require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/0d21bcaaf9225eaf120e4006b08f507d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0d21bcaaf9225eaf120e4006b08f507d'] = async function fn_0d21bcaaf9225eaf120e4006b08f507d(listToModify) {
  await (async function(array) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.reverse(array)
  })(listToModify);

}

})
define('./functions/0ea1d65b7a2db5c48adc82f4f78b00c1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0ea1d65b7a2db5c48adc82f4f78b00c1'] = async function fn_0ea1d65b7a2db5c48adc82f4f78b00c1(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/15ca0e8cc5e67ed6b62edeb5642db8ca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ca0e8cc5e67ed6b62edeb5642db8ca'] = async function fn_15ca0e8cc5e67ed6b62edeb5642db8ca(listToCompact) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.compact(array)
})(listToCompact))
}

})
define('./functions/15ceddbd38db9429a0f97a454e8b367a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ceddbd38db9429a0f97a454e8b367a'] = async function fn_15ceddbd38db9429a0f97a454e8b367a(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.take(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/16424e16271fba19226ae38e9f473baa/code.js', () => { 

BackendlessUI.Functions.Custom['fn_16424e16271fba19226ae38e9f473baa'] = async function fn_16424e16271fba19226ae38e9f473baa(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.head(array)
})(listToQuery))
}

})
define('./functions/1a53e926aaf153363e427601c3443e71/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1a53e926aaf153363e427601c3443e71'] = async function fn_1a53e926aaf153363e427601c3443e71(HUB, Tractor, Appdata, PageData, Arrow, Block) {
  await (async function(HUB, Tractor, AppData, PageData, Image, Arrow, Block) {
  	// ===== GPS - Telematics Setup Hub v5.0.1 =====
  	// Mobile-first, two-tier item cards:
  	//   1) Name, value/unit and information at the top
  	//   2) Full-width toggle or custom slider at the bottom
  	//
  	// No native input/change controls are used.
  	// Called with: HUB, Tractor, AppData, PageData, Image, Arrow, Block

  	if (!HUB?.el || !Tractor?.CAN || !AppData?.User || !PageData) return;

  	const CAN = Tractor.CAN;

  	if (!CAN.EventsBoolean || typeof CAN.EventsBoolean !== "object") {
  	  CAN.EventsBoolean = {};
  	}

  	const EB = CAN.EventsBoolean;

  	const themeOrange = "#CC6633";
  	const themeOrangeSoft = "rgba(204,102,51,0.18)";
  	const themeOrangeMedium = "rgba(204,102,51,0.34)";
  	const maxZIndex = "2147483647";

  	const FLESPI_THRESHOLD_SYNC_URL =
  	  "https://fif-daily-report-exporter.raymondewoodley.workers.dev/sync-thresholds";

  	const popupId = "telematics-popup";
  	const styleId = "telematics-setup-hub-style";

  	let changesMade = false;
  	let isSaving = false;
  	let lastKnownHubRect = null;

  	const parameterControls = new Map();
  	const eventControls = new Map();
  	const managedCleanups = [];

  	// =======================================================
  	// Previous Instance Cleanup
  	// =======================================================

  	try {
  	  if (typeof window.__telematicsSetupHubCleanup === "function") {
  	    window.__telematicsSetupHubCleanup();
  	  }
  	} catch (_) {}

  	document.getElementById(popupId)?.remove();
  	document.getElementById(styleId)?.remove();

  	function addManagedListener(target, eventName, handler, options) {
  	  if (!target || typeof target.addEventListener !== "function") return;

  	  target.addEventListener(eventName, handler, options);

  	  managedCleanups.push(() => {
  	    try {
  	      target.removeEventListener(eventName, handler, options);
  	    } catch (_) {}
  	  });
  	}

  	function runManagedCleanups() {
  	  while (managedCleanups.length) {
  	    const cleanup = managedCleanups.pop();

  	    try {
  	      cleanup();
  	    } catch (_) {}
  	  }
  	}

  	function safeString(value) {
  	  return value === undefined || value === null ? "" : String(value);
  	}

  	function cleanText(value) {
  	  return typeof value === "string" ? value.trim() : "";
  	}

  	function clonePlain(value) {
  	  try {
  	    return JSON.parse(JSON.stringify(value));
  	  } catch (_) {
  	    return value;
  	  }
  	}

  	function clamp(value, min, max) {
  	  return Math.min(max, Math.max(min, value));
  	}

  	function readFiniteNumber(value) {
  	  if (typeof value === "number" && Number.isFinite(value)) return value;

  	  if (typeof value === "string" && value.trim() !== "") {
  	    const parsed = Number(value);
  	    return Number.isFinite(parsed) ? parsed : null;
  	  }

  	  return null;
  	}

  	function firstFiniteNumber(source, keys) {
  	  if (!source || typeof source !== "object") return null;

  	  for (const key of keys) {
  	    const value = readFiniteNumber(source[key]);
  	    if (value !== null) return value;
  	  }

  	  return null;
  	}

  	function getDecimalPlaces(number) {
  	  const text = safeString(number).toLowerCase();

  	  if (text.includes("e-")) {
  	    const [base, exponentText] = text.split("e-");
  	    const exponent = Number(exponentText) || 0;
  	    const baseDecimals = (base.split(".")[1] || "").length;
  	    return exponent + baseDecimals;
  	  }

  	  return (text.split(".")[1] || "").length;
  	}

  	function roundToStep(value, min, step) {
  	  if (!Number.isFinite(step) || step <= 0) return value;

  	  const decimalPlaces = Math.min(
  	    8,
  	    Math.max(getDecimalPlaces(step), getDecimalPlaces(min))
  	  );

  	  const snapped = min + Math.round((value - min) / step) * step;
  	  return Number(snapped.toFixed(decimalPlaces));
  	}

  	function niceCeiling(value) {
  	  const absolute = Math.abs(Number(value));

  	  if (!Number.isFinite(absolute) || absolute === 0) return 1;

  	  const power = 10 ** Math.floor(Math.log10(absolute));
  	  const scaled = absolute / power;

  	  let niceScaled;

  	  if (scaled <= 1) niceScaled = 1;
  	  else if (scaled <= 2) niceScaled = 2;
  	  else if (scaled <= 5) niceScaled = 5;
  	  else niceScaled = 10;

  	  return niceScaled * power;
  	}

  	// =======================================================
  	// Styles
  	// =======================================================

  	const style = document.createElement("style");
  	style.id = styleId;

  	style.textContent = `
  	  #${popupId} {
  	    position: fixed;
  	    bottom: 0;
  	    background: rgba(24,24,24,0.975);
  	    color: #fff;
  	    z-index: 9999;
  	    overflow-y: auto;
  	    overscroll-behavior: contain;
  	    border-top: 2px solid ${themeOrange};
  	    font-family: "Segoe UI", Arial, sans-serif;
  	    box-shadow: 0 -6px 22px rgba(0,0,0,0.58);
  	    box-sizing: border-box;
  	    scrollbar-width: thin;
  	    scrollbar-color: ${themeOrange} #1b1b1b;
  	  }

  	  #${popupId} * {
  	    box-sizing: border-box;
  	  }

  	  #${popupId} button {
  	    font: inherit;
  	  }

  	  .telematics-header {
  	    position: sticky;
  	    top: 0;
  	    z-index: 10000;
  	    display: flex;
  	    align-items: center;
  	    justify-content: space-between;
  	    gap: 12px;
  	    min-height: 48px;
  	    padding: 9px 12px;
  	    background: rgba(29,29,29,0.99);
  	    border-bottom: 1px solid rgba(255,255,255,0.15);
  	    backdrop-filter: blur(8px);
  	  }

  	  .telematics-title {
  	    min-width: 0;
  	    font-size: 17px;
  	    font-weight: 700;
  	    line-height: 1.2;
  	  }

  	  .telematics-close-btn,
  	  .telematics-save-btn,
  	  .telematics-section-head,
  	  .telematics-info-btn,
  	  .telematics-value-btn,
  	  .telematics-toggle-btn {
  	    border: 0;
  	    outline: 0;
  	    cursor: pointer;
  	    user-select: none;
  	    -webkit-user-select: none;
  	    -webkit-user-drag: none;
  	  }

  	  .telematics-close-btn {
  	    flex: 0 0 auto;
  	    min-height: 32px;
  	    padding: 5px 11px;
  	    border-radius: 5px;
  	    background: ${themeOrange};
  	    color: #111;
  	    font-weight: 600;
  	  }

  	  .telematics-close-btn:hover,
  	  .telematics-close-btn:focus-visible,
  	  .telematics-save-btn:hover,
  	  .telematics-save-btn:focus-visible {
  	    filter: brightness(1.12);
  	    box-shadow: 0 0 0 2px rgba(204,102,51,0.28);
  	  }

  	  .telematics-content {
  	    padding: 12px 12px 72px;
  	  }

  	  .telematics-section {
  	    margin-bottom: 12px;
  	    border: 1px solid rgba(255,255,255,0.18);
  	    border-radius: 8px;
  	    overflow: hidden;
  	    background: #202020;
  	  }

  	  .telematics-section-head {
  	    width: 100%;
  	    display: grid;
  	    grid-template-columns: minmax(0, 1fr) auto auto;
  	    align-items: center;
  	    gap: 8px;
  	    padding: 10px 12px;
  	    background: #343434;
  	    color: #fff;
  	    text-align: left;
  	    font-size: 15px;
  	    font-weight: 700;
  	    transition: background 0.18s ease;
  	  }

  	  .telematics-section-head.open {
  	    background: ${themeOrangeMedium};
  	  }

  	  .telematics-section-head:hover,
  	  .telematics-section-head:focus-visible {
  	    background: rgba(204,102,51,0.28);
  	  }

  	  .telematics-section-count {
  	    min-width: 25px;
  	    padding: 2px 7px;
  	    border-radius: 999px;
  	    background: rgba(0,0,0,0.3);
  	    color: rgba(255,255,255,0.78);
  	    text-align: center;
  	    font-size: 11px;
  	    font-weight: 700;
  	  }

  	  .telematics-section-chevron {
  	    width: 18px;
  	    color: rgba(255,255,255,0.8);
  	    text-align: center;
  	    font-size: 15px;
  	    transform: rotate(0deg);
  	    transition: transform 0.18s ease;
  	  }

  	  .telematics-section-head.open .telematics-section-chevron {
  	    transform: rotate(180deg);
  	  }

  	  .telematics-section-body {
  	    display: none;
  	    padding: 10px;
  	    background: #202020;
  	  }

  	  .telematics-section-body.open {
  	    display: grid;
  	    gap: 9px;
  	  }

  	  .telematics-item-card {
  	    display: flex;
  	    flex-direction: column;
  	    gap: 10px;
  	    padding: 11px;
  	    background: #2b2b2b;
  	    border: 1px solid rgba(255,255,255,0.07);
  	    border-radius: 8px;
  	    box-shadow: 0 2px 6px rgba(0,0,0,0.16);
  	  }

  	  .telematics-item-card.changed {
  	    border-color: rgba(204,102,51,0.62);
  	    box-shadow: 0 0 0 1px rgba(204,102,51,0.13);
  	  }

  	  .telematics-item-top {
  	    display: grid;
  	    grid-template-columns: minmax(0, 1fr) auto;
  	    align-items: start;
  	    gap: 10px;
  	  }

  	  .telematics-item-heading {
  	    min-width: 0;
  	  }

  	  .telematics-item-name {
  	    display: block;
  	    color: #fff;
  	    font-size: 14px;
  	    font-weight: 600;
  	    line-height: 1.28;
  	    white-space: normal;
  	    overflow-wrap: anywhere;
  	    word-break: normal;
  	  }

  	  .telematics-item-unit {
  	    display: block;
  	    margin-top: 3px;
  	    color: rgba(255,255,255,0.56);
  	    font-size: 11px;
  	    line-height: 1.2;
  	  }

  	  .telematics-item-actions {
  	    display: flex;
  	    align-items: center;
  	    justify-content: flex-end;
  	    gap: 7px;
  	    flex: 0 0 auto;
  	  }

  	  .telematics-info-btn {
  	    width: 24px;
  	    height: 24px;
  	    min-width: 24px;
  	    border-radius: 50%;
  	    border: 1px solid rgba(255,255,255,0.45);
  	    background: transparent;
  	    color: #fff;
  	    display: inline-flex;
  	    align-items: center;
  	    justify-content: center;
  	    padding: 0;
  	    font-size: 12px;
  	    font-weight: 800;
  	    line-height: 1;
  	  }

  	  .telematics-info-btn:hover,
  	  .telematics-info-btn:focus-visible,
  	  .telematics-info-btn.active {
  	    border-color: ${themeOrange};
  	    background: ${themeOrangeSoft};
  	    box-shadow: 0 0 9px rgba(204,102,51,0.5);
  	  }

  	  .telematics-description {
  	    display: none;
  	    margin-top: -1px;
  	    padding: 8px 9px;
  	    border-left: 3px solid ${themeOrange};
  	    border-radius: 4px;
  	    background: rgba(0,0,0,0.22);
  	    color: rgba(255,255,255,0.82);
  	    font-size: 12px;
  	    line-height: 1.42;
  	    white-space: normal;
  	    overflow-wrap: anywhere;
  	  }

  	  .telematics-description.open {
  	    display: block;
  	  }

  	  .telematics-control-bottom {
  	    width: 100%;
  	  }

  	  .telematics-value-btn {
  	    min-width: 66px;
  	    max-width: 100px;
  	    min-height: 27px;
  	    padding: 3px 9px;
  	    border: 1px solid rgba(255,255,255,0.28);
  	    border-radius: 999px;
  	    background: #121212;
  	    color: #fff;
  	    font-size: 12px;
  	    font-weight: 700;
  	    text-align: center;
  	  }

  	  .telematics-value-btn:hover,
  	  .telematics-value-btn:focus-visible {
  	    border-color: ${themeOrange};
  	    box-shadow: 0 0 8px rgba(204,102,51,0.48);
  	  }

  	  .telematics-toggle-btn {
  	    width: 100%;
  	    min-height: 40px;
  	    display: flex;
  	    align-items: center;
  	    justify-content: space-between;
  	    gap: 12px;
  	    padding: 7px 10px 7px 13px;
  	    border: 1px solid rgba(255,255,255,0.25);
  	    border-radius: 7px;
  	    background: #151515;
  	    color: rgba(255,255,255,0.72);
  	    transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
  	  }

  	  .telematics-toggle-btn:hover,
  	  .telematics-toggle-btn:focus-visible {
  	    border-color: ${themeOrange};
  	    box-shadow: 0 0 8px rgba(204,102,51,0.42);
  	  }

  	  .telematics-toggle-caption {
  	    font-size: 12px;
  	    font-weight: 600;
  	  }

  	  .telematics-toggle-switch {
  	    position: relative;
  	    width: 58px;
  	    height: 26px;
  	    flex: 0 0 auto;
  	    border-radius: 999px;
  	    background: #050505;
  	    border: 1px solid rgba(255,255,255,0.25);
  	    transition: background 0.18s ease, border-color 0.18s ease;
  	  }

  	  .telematics-toggle-knob {
  	    position: absolute;
  	    top: 3px;
  	    left: 3px;
  	    width: 18px;
  	    height: 18px;
  	    border-radius: 50%;
  	    background: rgba(255,255,255,0.78);
  	    transition: transform 0.18s ease, background 0.18s ease;
  	  }

  	  .telematics-toggle-state {
  	    position: absolute;
  	    top: 50%;
  	    right: 7px;
  	    transform: translateY(-50%);
  	    color: rgba(255,255,255,0.66);
  	    font-size: 9px;
  	    font-weight: 800;
  	    line-height: 1;
  	  }

  	  .telematics-toggle-btn.on {
  	    border-color: ${themeOrange};
  	    background: ${themeOrangeSoft};
  	    color: #fff;
  	  }

  	  .telematics-toggle-btn.on .telematics-toggle-switch {
  	    border-color: ${themeOrange};
  	    background: ${themeOrangeMedium};
  	  }

  	  .telematics-toggle-btn.on .telematics-toggle-knob {
  	    transform: translateX(32px);
  	    background: #fff;
  	  }

  	  .telematics-toggle-btn.on .telematics-toggle-state {
  	    left: 7px;
  	    right: auto;
  	    color: #fff;
  	  }

  	  .telematics-slider-shell {
  	    width: 100%;
  	  }

  	  .telematics-slider {
  	    position: relative;
  	    width: 100%;
  	    height: 34px;
  	    display: flex;
  	    align-items: center;
  	    cursor: pointer;
  	    touch-action: none;
  	    outline: none;
  	  }

  	  .telematics-slider-track {
  	    position: absolute;
  	    left: 1px;
  	    right: 1px;
  	    top: 50%;
  	    height: 8px;
  	    transform: translateY(-50%);
  	    border-radius: 999px;
  	    background: #101010;
  	    border: 1px solid rgba(255,255,255,0.22);
  	    overflow: hidden;
  	  }

  	  .telematics-slider-fill {
  	    width: 0%;
  	    height: 100%;
  	    background: ${themeOrange};
  	    border-radius: 999px;
  	    pointer-events: none;
  	  }

  	  .telematics-slider-thumb {
  	      position: absolute;
  	    top: 50%;
  	    left: 0%;
  	    width: 24px;
  	    height: 24px;
  	    transform: translate(-50%, -50%);
  	    border-radius: 50%;
  	    border: 2px solid ${themeOrange};
  	    background: #f5f5f5;
  	    box-shadow: 0 2px 8px rgba(0,0,0,0.72), 0 0 0 3px rgba(204,102,51,0.14);
  	    pointer-events: none;
  	  }

  	  .telematics-slider:hover .telematics-slider-thumb,
  	  .telematics-slider:focus-visible .telematics-slider-thumb,
  	  .telematics-slider.dragging .telematics-slider-thumb {
  	    box-shadow: 0 2px 8px rgba(0,0,0,0.72), 0 0 0 5px rgba(204,102,51,0.24);
  	  }

  	  .telematics-slider.dragging .telematics-slider-thumb {
  	    transform: translate(-50%, -50%) scale(1.08);
  	  }

  	  .telematics-slider-limits {
  	    display: flex;
  	    align-items: center;
  	    justify-content: space-between;
  	    gap: 12px;
  	    margin-top: -2px;
  	    color: rgba(255,255,255,0.5);
  	    font-size: 10px;
  	    line-height: 1;
  	  }

  	  .telematics-save-bar {
  	    position: sticky;
  	    bottom: 0;
  	    z-index: 10001;
  	    display: none;
  	    padding: 9px 12px;
  	    background: rgba(24,24,24,0.99);
  	    border-top: 1px solid ${themeOrange};
  	    backdrop-filter: blur(8px);
  	  }

  	  .telematics-save-bar.visible {
  	    display: block;
  	  }

  	  .telematics-save-btn {
  	    width: 100%;
  	    min-height: 40px;
  	    padding: 8px 14px;
  	    border-radius: 7px;
  	    background: ${themeOrange};
  	    color: #111;
  	    font-weight: 700;
  	  }

  	  .telematics-save-btn:disabled {
  	    opacity: 0.66;
  	    cursor: wait;
  	  }

  	  .telematics-empty {
  	    padding: 11px;
  	    background: #2b2b2b;
  	    border-radius: 7px;
  	    color: rgba(255,255,255,0.65);
  	    font-size: 13px;
  	  }

  	  @media (max-width: 380px) {
  	    .telematics-header {
  	      padding-left: 10px;
  	      padding-right: 10px;
  	    }

  	    .telematics-content {
  	      padding-left: 8px;
  	      padding-right: 8px;
  	    }

  	    .telematics-section-body {
  	      padding: 8px;
  	    }

  	    .telematics-item-card {
  	      padding: 10px;
  	    }
  	  }
  	`;

  	document.head.appendChild(style);

  	// =======================================================
  	// Defensive Event Firewall
  	// =======================================================
  	// The current UI does not use native form fields. The shield remains so a
  	// later native field added inside this popup cannot leak page-level events.

  	function isTelematicsPopupEventTarget(target) {
  	  try {
  	    return !!(
  	      target &&
  	      typeof target.closest === "function" &&
  	      target.closest(`#${popupId}`)
  	    );
  	  } catch (_) {
  	    return false;
  	  }
  	}

  	function stopNativeFormEventsInsidePopup(event) {
  	  if (!isTelematicsPopupEventTarget(event?.target)) return;

  	  try {
  	    event.stopImmediatePropagation();
  	    event.stopPropagation();
  	  } catch (_) {}
  	}

  	addManagedListener(window, "input", stopNativeFormEventsInsidePopup, true);
  	addManagedListener(window, "change", stopNativeFormEventsInsidePopup, true);
  	addManagedListener(window, "focusout", stopNativeFormEventsInsidePopup, true);

  	// =======================================================
  	// Exclusions
  	// =======================================================

  	const staticExclusions = [
  	  "Engine",
  	  "Events",
  	  "EventsBoolean",
  	  "FuelLoss",
  	  "StepL",
  	  "GradePctMax",
  	  "PoorHdop",
  	  "SpeedGL",
  	  "Units",
  	  "Stream",
  	  "Descriptions",
  	  "descriptions",
  	  "PropertyDescriptions",
  	  "propertyDescriptions",
  	  "ParameterDescriptions",
  	  "parameterDescriptions",
  	  "ParameterRanges",
  	  "parameterRanges",
  	  "Ranges",
  	  "ranges",
  	  "Help",
  	  "help",
  	  "Tooltips",
  	  "tooltips",
  	  "Metadata",
  	  "metadata",
  	  "Exclusions"
  	];

  	const dynamicExclusions = Array.isArray(CAN.Exclusions) ? CAN.Exclusions : [];
  	const excludedKeys = Array.from(new Set([...staticExclusions, ...dynamicExclusions]));

  	// =======================================================
  	// HUB Position and Visibility
  	// =======================================================

  	const hubEl = HUB.el;

  	try {
  	  const rect = hubEl.getBoundingClientRect();

  	  if (rect.width > 0 && rect.height >= 0) {
  	    lastKnownHubRect = {
  	      left: rect.left,
  	      right: rect.right,
  	      top: rect.top,
  	      bottom: rect.bottom,
  	      width: rect.width,
  	      height: rect.height
  	    };
  	  }
  	} catch (_) {}

  	try {
  	  if (typeof HUB.setVisible === "function") HUB.setVisible(false);
  	  else if ("visible" in HUB) HUB.visible = false;
  	} catch (_) {}

  	// =======================================================
  	// Popup Container
  	// =======================================================

  	const popup = document.createElement("div");
  	popup.id = popupId;
  	popup.dataset.telematicsPopup = "true";

  	function getUsableHubRect() {
  	  try {
  	    const rect = hubEl.getBoundingClientRect();

  	    if (rect.width > 0 && rect.bottom >= 0) {
  	      lastKnownHubRect = {
  	        left: rect.left,
  	        right: rect.right,
  	        top: rect.top,
  	        bottom: rect.bottom,
  	        width: rect.width,
  	        height: rect.height
  	      };
  	    }
  	  } catch (_) {}

  	  return lastKnownHubRect;
  	}

  	function positionPopup() {
  	  const viewportWidth =
  	    window.innerWidth || document.documentElement.clientWidth || 0;

  	  const viewportHeight =
  	    window.innerHeight || document.documentElement.clientHeight || 0;

  	  const rect = getUsableHubRect();

  	  if (!rect) {
  	    popup.style.left = "0px";
  	    popup.style.top = "0px";
  	    popup.style.width = `${Math.max(280, viewportWidth)}px`;
  	    popup.style.maxHeight = `${Math.max(180, viewportHeight)}px`;
  	    return;
  	  }

  	  const width = clamp(rect.width, 280, Math.max(280, viewportWidth));
  	  const left = clamp(rect.left, 0, Math.max(0, viewportWidth - width));
  	  const top = clamp(rect.bottom, 0, Math.max(0, viewportHeight - 180));
  	  const availableHeight = Math.max(180, viewportHeight - top);

  	  popup.style.left = `${left}px`;
  	  popup.style.top = `${top}px`;
  	  popup.style.width = `${width}px`;
  	  popup.style.maxHeight = `${availableHeight}px`;
  	}

  	// =======================================================
  	// Metadata Helpers
  	// =======================================================

  	function readDescriptionFromValue(value) {
  	  if (typeof value === "string") {
  	    return cleanText(value);
  	  }

  	  if (!value || typeof value !== "object") {
  	    return "";
  	  }

  	  const possibleKeys = [
  	    "description",
  	    "Description",
  	    "desc",
  	    "Desc",
  	    "help",
  	    "Help",
  	    "helpText",
  	    "HelpText",
  	    "tooltip",
  	    "Tooltip",
  	    "info",
  	    "Info"
  	  ];

  	  for (const key of possibleKeys) {
  	    const description = cleanText(value[key]);
  	    if (description) return description;
  	  }

  	  return "";
  	}

  	function readDisplayLabelFromValue(value, fallback) {
  	  if (!value || typeof value !== "object") return fallback;

  	  const possibleKeys = [
  	    "label",
  	    "Label",
  	    "displayName",
  	    "DisplayName",
  	    "title",
  	    "Title",
  	    "name",
  	    "Name"
  	  ];

  	  for (const key of possibleKeys) {
  	    const label = cleanText(value[key]);
  	    if (label) return label;
  	  }

  	  return fallback;
  	}

  	function readUnitFromValue(value) {
  	  if (!value || typeof value !== "object") return "";

  	  const possibleKeys = [
  	    "unit",
  	    "Unit",
  	    "units",
  	    "Units",
  	    "suffix",
  	    "Suffix"
  	  ];

  	  for (const key of possibleKeys) {
  	    const unit = cleanText(value[key]);
  	    if (unit) return unit;
  	  }

  	  return "";
  	}

  	function readRangeFromValue(value) {
  	  if (!value || typeof value !== "object") {
  	    return {
  	      min: null,
  	      max: null,
  	      step: null
  	    };
  	  }

  	  return {
  	    min: firstFiniteNumber(value, [
  	      "min",
  	      "Min",
  	      "minimum",
  	      "Minimum",
  	      "minValue",
  	      "MinValue"
  	    ]),
  	    max: firstFiniteNumber(value, [
  	      "max",
  	      "Max",
  	      "maximum",
  	      "Maximum",
  	      "maxValue",
  	      "MaxValue"
  	    ]),
  	    step: firstFiniteNumber(value, [
  	      "step",
  	      "Step",
  	      "increment",
  	      "Increment",
  	      "resolution",
  	      "Resolution"
  	    ])
  	  };
  	}

  	function buildEventMetadataMap(events) {
  	  const result = new Map();

  	  if (!Array.isArray(events)) return result;

  	  events.forEach(event => {
  	    if (!event || typeof event !== "object") return;

  	    const name = cleanText(
  	      event.name ||
  	      event.Name ||
  	      event.Event ||
  	      event.event
  	    );

  	    if (!name) return;

  	    result.set(name, {
  	      description: readDescriptionFromValue(event),
  	      label: readDisplayLabelFromValue(event, name)
  	    });
  	  });

  	  return result;
  	}

  	function buildParameterMetadataMap() {
  	  const result = new Map();

  	  const possibleMaps = [
  	    CAN.ParameterDescriptions,
  	    CAN.parameterDescriptions,
  	    CAN.PropertyDescriptions,
  	    CAN.propertyDescriptions,
  	    CAN.Descriptions,
  	    CAN.descriptions,
  	    CAN.ParameterRanges,
  	    CAN.parameterRanges,
  	    CAN.Ranges,
  	    CAN.ranges,
  	    CAN.Help,
  	    CAN.help,
  	    CAN.Tooltips,
  	    CAN.tooltips,
  	    CAN.Metadata,
  	    CAN.metadata
  	  ];

  	  possibleMaps.forEach(map => {
  	    if (!map || typeof map !== "object" || Array.isArray(map)) return;

  	    Object.keys(map).forEach(key => {
  	      if (!key) return;

  	      const raw = map[key];

  	      const previous = result.get(key) || {
  	        description: "",
  	        label: key,
  	        unit: "",
  	        min: null,
  	        max: null,
  	        step: null
  	      };

  	      const range = readRangeFromValue(raw);

  	      result.set(key, {
  	        description: previous.description || readDescriptionFromValue(raw),
  	        label:
  	          previous.label !== key
  	            ? previous.label
  	            : readDisplayLabelFromValue(raw, key),
  	        unit: previous.unit || readUnitFromValue(raw),
  	        min: previous.min !== null ? previous.min : range.min,
  	        max: previous.max !== null ? previous.max : range.max,
  	        step: previous.step !== null ? previous.step : range.step
  	      });
  	    });
  	  });

  	  return result;
  	}

  	const eventMetadataByName = buildEventMetadataMap(CAN.Events);
  	const parameterMetadataByKey = buildParameterMetadataMap();

  	function getParameterMetadata(key) {
  	  return parameterMetadataByKey.get(key) || {
  	    description: "",
  	    label: key,
  	    unit: "",
  	    min: null,
  	    max: null,
  	    step: null
  	  };
  	}

  	function getParameterUnit(key, metadata) {
  	  if (metadata?.unit) return metadata.unit;
  	  if (!CAN.Units || typeof CAN.Units !== "object") return "";

  	  const unitMap = {
  	    RPM: "rpm",
  	    RPMGH: "rpm",
  	    RPMGL: "rpm",
  	    RetarderRpmHigh: "rpm",
  	    RetarderRpmLow: "rpm",
  	    Speed: "speed",
  	    SpeedGL: "speed",
  	    Tank: "fuel_l",
  	    FuelLossStepL: "fuel_l",
  	    LowFuel: "fuel_pct"
  	  };

  	  const unitKey = unitMap[key];

  	  if (unitKey && typeof CAN.Units[unitKey] === "string") {
  	    return CAN.Units[unitKey];
  	  }

  	  return "";
  	}

  	// =======================================================
  	// Layout Builders
  	// =======================================================

  	const header = document.createElement("div");
  	header.className = "telematics-header";

  	const title = document.createElement("span");
  	title.className = "telematics-title";
  	title.textContent = "Telematics Setup Hub";

  	const closeBtn = document.createElement("button");
  	closeBtn.type = "button";
  	closeBtn.className = "telematics-close-btn";
  	closeBtn.textContent = "✕ Close";

  	header.appendChild(title);
  	header.appendChild(closeBtn);
  	popup.appendChild(header);

  	const container = document.createElement("div");
  	container.className = "telematics-content";
  	popup.appendChild(container);

  	function makeAccordionSection(titleText, count, initiallyOpen) {
  	  const section = document.createElement("section");
  	  section.className = "telematics-section";

  	  const head = document.createElement("button");
  	  head.type = "button";
  	  head.className = "telematics-section-head";
  	  head.setAttribute("aria-expanded", initiallyOpen ? "true" : "false");

  	  const titleEl = document.createElement("span");
  	  titleEl.textContent = titleText;

  	  const countEl = document.createElement("span");
  	  countEl.className = "telematics-section-count";
  	  countEl.textContent = String(count);

  	  const chevron = document.createElement("span");
  	  chevron.className = "telematics-section-chevron";
  	  chevron.textContent = "⌄";
  	  chevron.setAttribute("aria-hidden", "true");

  	  head.append(titleEl, countEl, chevron);

  	  const body = document.createElement("div");
  	  body.className = "telematics-section-body";

  	  if (initiallyOpen) {
  	    head.classList.add("open");
  	    body.classList.add("open");
  	  }

  	  head.addEventListener("click", event => {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    const nextOpen = !body.classList.contains("open");

  	    body.classList.toggle("open", nextOpen);
  	    head.classList.toggle("open", nextOpen);
  	    head.setAttribute("aria-expanded", nextOpen ? "true" : "false");
  	  });

  	  section.append(head, body);

  	  return {
  	    section,
  	    head,
  	    body
  	  };
  	}

  	function makeEmptyMessage(message) {
  	  const empty = document.createElement("div");
  	  empty.className = "telematics-empty";
  	    empty.textContent = message;
  	  return empty;
  	}

  	function makeInfoButton(description, descriptionPanel) {
  	  const text = cleanText(description);
  	  if (!text) return null;

  	  const button = document.createElement("button");
  	  button.type = "button";
  	  button.className = "telematics-info-btn";
  	  button.textContent = "i";
  	  button.setAttribute("aria-label", "Show information");
  	  button.setAttribute("aria-expanded", "false");

  	  button.addEventListener("click", event => {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    const nextOpen = !descriptionPanel.classList.contains("open");

  	    descriptionPanel.classList.toggle("open", nextOpen);
  	    button.classList.toggle("active", nextOpen);
  	    button.setAttribute("aria-expanded", nextOpen ? "true" : "false");

  	    button.setAttribute(
  	      "aria-label",
  	      nextOpen ? "Hide information" : "Show information"
  	    );
  	  });

  	  return button;
  	}

  	function makeItemCard({ label, unit, description, valueButton }) {
  	  const card = document.createElement("article");
  	  card.className = "telematics-item-card";

  	  const top = document.createElement("div");
  	  top.className = "telematics-item-top";

  	  const heading = document.createElement("div");
  	  heading.className = "telematics-item-heading";

  	  const name = document.createElement("span");
  	  name.className = "telematics-item-name";
  	  name.textContent = label;
  	  heading.appendChild(name);

  	  const unitText = cleanText(unit);

  	  if (unitText) {
  	    const unitEl = document.createElement("span");
  	    unitEl.className = "telematics-item-unit";
  	    unitEl.textContent = unitText;
  	    heading.appendChild(unitEl);
  	  }

  	  const actions = document.createElement("div");
  	  actions.className = "telematics-item-actions";

  	  if (valueButton) {
  	    actions.appendChild(valueButton);
  	  }

  	  const descriptionPanel = document.createElement("div");
  	  descriptionPanel.className = "telematics-description";
  	  descriptionPanel.textContent = cleanText(description);

  	  const infoButton = makeInfoButton(description, descriptionPanel);

  	  if (infoButton) {
  	    actions.appendChild(infoButton);
  	  }

  	  top.append(heading, actions);
  	  card.appendChild(top);

  	  if (cleanText(description)) {
  	    card.appendChild(descriptionPanel);
  	  }

  	  const controlBottom = document.createElement("div");
  	  controlBottom.className = "telematics-control-bottom";
  	  card.appendChild(controlBottom);

  	  return {
  	    card,
  	    controlBottom
  	  };
  	}

  	// =======================================================
  	// Change State
  	// =======================================================

  	const saveBar = document.createElement("div");
  	saveBar.className = "telematics-save-bar";

  	const saveBtn = document.createElement("button");
  	saveBtn.type = "button";
  	saveBtn.className = "telematics-save-btn";
  	saveBtn.textContent = "Save Changes";

  	saveBar.appendChild(saveBtn);

  	function markChanged(card) {
  	  if (card?.classList) {
  	    card.classList.add("changed");
  	  }

  	  if (!changesMade) {
  	    changesMade = true;
  	    saveBar.classList.add("visible");
  	  }
  	}

  	// =======================================================
  	// Event Toggles
  	// =======================================================

  	function paintToggleState(button, switchState, value) {
  	  button.classList.toggle("on", !!value);
  	  button.setAttribute("aria-pressed", value ? "true" : "false");
  	  switchState.textContent = value ? "ON" : "OFF";
  	}

  	function makeEventToggleCard(key) {
  	  const metadata = eventMetadataByName.get(key) || {
  	    description: "",
  	    label: key
  	  };

  	  const item = makeItemCard({
  	    label: metadata.label || key,
  	    unit: "",
  	    description: metadata.description || ""
  	  });

  	  const toggle = document.createElement("button");
  	  toggle.type = "button";
  	  toggle.className = "telematics-toggle-btn";

  	  const caption = document.createElement("span");
  	  caption.className = "telematics-toggle-caption";
  	  caption.textContent = "Event alert";

  	  const switchEl = document.createElement("span");
  	  switchEl.className = "telematics-toggle-switch";
  	  switchEl.setAttribute("aria-hidden", "true");

  	  const knob = document.createElement("span");
  	  knob.className = "telematics-toggle-knob";

  	  const switchState = document.createElement("span");
  	  switchState.className = "telematics-toggle-state";

  	  switchEl.append(knob, switchState);
  	  toggle.append(caption, switchEl);

  	  let currentValue = !!EB[key];
  	  paintToggleState(toggle, switchState, currentValue);

  	  toggle.addEventListener("click", event => {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    currentValue = !currentValue;
  	    EB[key] = currentValue;

  	    paintToggleState(toggle, switchState, currentValue);
  	    markChanged(item.card);
  	  });

  	  eventControls.set(key, {
  	    key,
  	    card: item.card,

  	    getValue() {
  	      return currentValue;
  	    },

  	    setValue(value) {
  	      currentValue = !!value;
  	      EB[key] = currentValue;
  	      paintToggleState(toggle, switchState, currentValue);
  	    }
  	  });

  	  item.controlBottom.appendChild(toggle);
  	  return item.card;
  	}

  	const eventKeys = Object.keys(EB)
  	  .filter(key => !excludedKeys.includes(key))
  	  .sort((a, b) =>
  	    a.localeCompare(b, undefined, {
  	      sensitivity: "base"
  	    })
  	  );

  	if (eventKeys.length) {
  	  const {
  	    section: eventSection,
  	    body: eventBody
  	  } = makeAccordionSection(
  	    "Event Toggles",
  	    eventKeys.length,
  	    true
  	  );

  	  eventKeys.forEach(key => {
  	    eventBody.appendChild(makeEventToggleCard(key));
  	  });

  	  container.appendChild(eventSection);
  	}

  	// =======================================================
  	// Numeric Parameter Sliders
  	// =======================================================

  	function isNumericLike(value) {
  	  return readFiniteNumber(value) !== null;
  	}

  	function getCANStep(key, metadata, currentValue) {
  	  if (Number.isFinite(metadata?.step) && metadata.step > 0) {
  	    return metadata.step;
  	  }

  	  const raw = safeString(CAN?.[key]);

  	  if (raw.includes(".")) {
  	    const decimals = raw.split(".")[1]?.length || 0;

  	    if (decimals >= 3) return 0.001;
  	    if (decimals === 2) return 0.01;
  	    if (decimals === 1) return 0.1;
  	  }

  	  if (Math.abs(currentValue) > 0 && Math.abs(currentValue) < 1) {
  	    return 0.01;
  	  }

  	  return 1;
  	}

  	function formatCANNumber(value, step) {
  	  const numberValue = Number(value);

  	  if (!Number.isFinite(numberValue)) return "";

  	  const decimals = Math.min(
  	    6,
  	    Math.max(0, getDecimalPlaces(step))
  	  );

  	  if (decimals === 0) {
  	    return String(Math.round(numberValue));
  	  }

  	  return numberValue
  	    .toFixed(decimals)
  	    .replace(/(\.\d*?[1-9])0+$/, "$1")
  	    .replace(/\.0+$/, "");
  	}

  	function inferSliderBounds(
  	  key,
  	  label,
  	  unit,
  	  currentValue,
  	  metadata,
  	  step
  	) {
  	  let min = Number.isFinite(metadata?.min)
  	    ? metadata.min
  	    : null;

  	  let max = Number.isFinite(metadata?.max)
  	    ? metadata.max
  	    : null;

  	  const searchText = `${key} ${label} ${unit}`.toLowerCase();
  	  const absoluteCurrent = Math.abs(currentValue);

  	  if (min === null || max === null) {
  	    let inferredMin;
  	    let inferredMax;

  	    if (/\brpm\b|revolution/.test(searchText)) {
  	      inferredMin = 0;
  	      inferredMax = Math.max(
  	        5000,
  	        niceCeiling(currentValue * 1.25)
  	      );
  	    } else if (/speed|km\/h|kph|mph/.test(searchText)) {
  	      inferredMin = 0;
  	      inferredMax = Math.max(
  	        250,
  	        niceCeiling(currentValue * 1.5)
  	      );
  	    } else if (/temp|temperature|°c|celsius/.test(searchText)) {
  	      inferredMin = -40;
  	      inferredMax = Math.max(
  	        150,
  	        niceCeiling(currentValue * 1.5)
  	      );
  	    } else if (/volt|voltage/.test(searchText)) {
  	      inferredMin = 0;
  	      inferredMax = Math.max(
  	        32,
  	        niceCeiling(currentValue * 1.5)
  	      );
  	    } else if (/percent|percentage|\bpct\b|%/.test(searchText)) {
  	      inferredMin = 0;
  	      inferredMax = 100;
  	    } else if (
  	      /accel|brak|corner|coast/.test(searchText) &&
  	      absoluteCurrent <= 2
  	    ) {
  	      inferredMin = -1;
  	      inferredMax = 1;
  	    } else if (
  	      /grade/.test(searchText) &&
  	      absoluteCurrent <= 2
  	    ) {
  	      inferredMin = -1;
  	      inferredMax = 1;
  	    } else if (
  	      /tank|litre|liter|fuel_l|volume/.test(searchText)
  	    ) {
  	      inferredMin = 0;
  	      inferredMax = Math.max(
  	        500,
  	        niceCeiling(currentValue * 2)
  	      );
  	    } else if (/idle/.test(searchText)) {
  	      inferredMin = 0;
  	      inferredMax = Math.max(
  	        600,
  	        niceCeiling(currentValue * 2)
  	      );
  	    } else if (step < 1 && absoluteCurrent <= 2) {
  	      inferredMin = -1;
  	      inferredMax = 1;
  	    } else if (currentValue >= 0) {
  	      inferredMin = 0;
  	      inferredMax = Math.max(
  	        step * 20,
  	        niceCeiling(Math.max(10, currentValue * 2))
  	      );
  	    } else {
  	      const extent = Math.max(
  	        step * 20,
  	        niceCeiling(Math.max(10, absoluteCurrent * 2))
  	      );

  	      inferredMin = -extent;
  	      inferredMax = extent;
  	    }

  	    if (min === null) min = inferredMin;
  	    if (max === null) max = inferredMax;
  	  }

  	  if (!Number.isFinite(min)) min = 0;

  	  if (!Number.isFinite(max)) {
  	    max = min + Math.max(step * 20, 1);
  	  }

  	  if (min === max) {
  	    max = min + Math.max(step * 20, 1);
  	  }

  	  if (min > max) {
  	    [min, max] = [max, min];
  	  }

  	  if (currentValue < min) {
  	    min =
  	      currentValue < 0
  	        ? -niceCeiling(Math.abs(currentValue) * 1.25)
  	        : currentValue;
  	  }

  	  if (currentValue > max) {
  	    max = niceCeiling(currentValue * 1.25);
  	  }

  	  return {
  	    min,
  	    max
  	  };
  	}

  	function makeNumericParameterCard(key) {
  	  const metadata = getParameterMetadata(key);
  	  const displayLabel = metadata.label || key;
  	  const displayUnit = getParameterUnit(key, metadata);

  	  let currentValue = readFiniteNumber(CAN[key]);

  	  if (currentValue === null) {
  	    currentValue = 0;
  	  }

  	  const step = getCANStep(key, metadata, currentValue);

  	  let { min, max } = inferSliderBounds(
  	    key,
  	    displayLabel,
  	    displayUnit,
  	    currentValue,
  	    metadata,
  	    step
  	  );

  	  const valueButton = document.createElement("button");
  	  valueButton.type = "button";
  	  valueButton.className = "telematics-value-btn";
  	  valueButton.title = "Click to enter an exact value";

  	  const item = makeItemCard({
  	    label: displayLabel,
  	    unit: displayUnit,
  	    description: metadata.description || "",
  	    valueButton
  	  });

  	  const sliderShell = document.createElement("div");
  	  sliderShell.className = "telematics-slider-shell";

  	  const slider = document.createElement("div");
  	  slider.className = "telematics-slider";
  	  slider.tabIndex = 0;
  	  slider.setAttribute("role", "slider");
  	  slider.setAttribute("aria-label", displayLabel);

  	  const track = document.createElement("div");
  	  track.className = "telematics-slider-track";

  	  const fill = document.createElement("div");
  	  fill.className = "telematics-slider-fill";

  	  const thumb = document.createElement("div");
  	  thumb.className = "telematics-slider-thumb";

  	  track.appendChild(fill);
  	  slider.append(track, thumb);

  	  const limits = document.createElement("div");
  	  limits.className = "telematics-slider-limits";

  	  const minLabel = document.createElement("span");
  	  const maxLabel = document.createElement("span");

  	  limits.append(minLabel, maxLabel);
  	  sliderShell.append(slider, limits);
  	  item.controlBottom.appendChild(sliderShell);

  	  function ensureBoundsContain(value) {
  	    if (value >= min && value <= max) return;

  	    if (value < min) {
  	      if (value < 0) {
  	        min = -niceCeiling(Math.abs(value) * 1.25);
  	      } else {
  	        min = value;
  	      }
  	    }

  	    if (value > max) {
  	      max = niceCeiling(value * 1.25);
  	    }

  	    if (min === max) {
  	      max = min + Math.max(step * 20, 1);
  	    }
  	  }

  	  function paintValue() {
  	    const range = max - min;

  	    const ratio =
  	      range > 0
  	        ? clamp((currentValue - min) / range, 0, 1)
  	        : 0;

  	    const percentage = ratio * 100;
  	    const formatted = formatCANNumber(currentValue, step);

  	    valueButton.textContent = formatted;
  	    fill.style.width = `${percentage}%`;
  	    thumb.style.left = `${percentage}%`;

  	    minLabel.textContent = formatCANNumber(min, step);
  	    maxLabel.textContent = formatCANNumber(max, step);

  	    slider.setAttribute("aria-valuemin", safeString(min));
  	    slider.setAttribute("aria-valuemax", safeString(max));
  	    slider.setAttribute("aria-valuenow", safeString(currentValue));

  	    slider.setAttribute(
  	      "aria-valuetext",
  	      displayUnit
  	        ? `${formatted} ${displayUnit}`
  	        : formatted
  	    );
  	  }

  	  function setValue(
  	    nextValue,
  	    shouldMarkChanged,
  	    expandRange
  	  ) {
  	    const numeric = Number(nextValue);

  	    if (!Number.isFinite(numeric)) return;

  	    if (expandRange) {
  	      ensureBoundsContain(numeric);
  	    }

  	    const bounded = clamp(numeric, min, max);
  	    const snapped = roundToStep(bounded, min, step);

  	    currentValue = clamp(snapped, min, max);
  	    CAN[key] = currentValue;

  	    paintValue();

  	    if (shouldMarkChanged) {
  	      markChanged(item.card);
  	    }
  	  }

  	  function valueFromClientX(clientX) {
  	    const rect = slider.getBoundingClientRect();

  	    if (!rect.width) return currentValue;

  	    const ratio = clamp(
  	      (clientX - rect.left) / rect.width,
  	      0,
  	      1
  	    );

  	    return min + ratio * (max - min);
  	  }

  	  let activePointerId = null;

  	  slider.addEventListener("pointerdown", event => {
  	    if (
  	      event.button !== undefined &&
  	      event.button !== 0
  	    ) {
  	      return;
  	    }

  	    event.preventDefault();
  	    event.stopPropagation();

  	    activePointerId = event.pointerId;
  	    slider.classList.add("dragging");

  	    try {
  	      slider.setPointerCapture(event.pointerId);
  	    } catch (_) {}

  	    setValue(
  	      valueFromClientX(event.clientX),
  	      true,
  	      false
  	    );
  	  });

  	  slider.addEventListener("pointermove", event => {
  	    if (
  	      activePointerId === null ||
  	      event.pointerId !== activePointerId
  	    ) {
  	      return;
  	    }

  	    event.preventDefault();
  	    event.stopPropagation();

  	    setValue(
  	      valueFromClientX(event.clientX),
  	      true,
  	      false
  	    );
  	  });

  	  function finishPointer(event) {
  	    if (
  	      activePointerId === null ||
  	      event.pointerId !== activePointerId
  	    ) {
  	      return;
  	    }

  	    event.preventDefault();
  	    event.stopPropagation();

  	    try {
  	      slider.releasePointerCapture(event.pointerId);
  	    } catch (_) {}

  	    activePointerId = null;
  	    slider.classList.remove("dragging");
  	  }

  	  slider.addEventListener("pointerup", finishPointer);
  	  slider.addEventListener("pointercancel", finishPointer);

  	  slider.addEventListener("lostpointercapture", () => {
  	    activePointerId = null;
  	    slider.classList.remove("dragging");
  	  });

  	  slider.addEventListener("keydown", event => {
  	    let nextValue = currentValue;
  	    let handled = true;

  	    switch (event.key) {
  	      case "ArrowLeft":
  	      case "ArrowDown":
  	        nextValue -= step;
  	        break;

  	      case "ArrowRight":
  	      case "ArrowUp":
  	        nextValue += step;
  	        break;

  	      case "PageDown":
  	        nextValue -= step * 10;
  	        break;

  	      case "PageUp":
  	        nextValue += step * 10;
  	        break;

  	      case "Home":
  	        nextValue = min;
  	        break;

  	      case "End":
  	        nextValue = max;
  	        break;

  	      default:
  	        handled = false;
  	    }

  	    if (!handled) return;

  	    event.preventDefault();
  	        event.stopPropagation();
  	    setValue(nextValue, true, false);
  	  });

  	  valueButton.addEventListener("click", event => {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    const currentText = formatCANNumber(
  	      currentValue,
  	      step
  	    );

  	    const response = window.prompt(
  	      `Enter value for ${displayLabel}`,
  	      currentText
  	    );

  	    if (response === null) return;

  	    const next = Number(String(response).trim());

  	    if (!Number.isFinite(next)) {
  	      showToast("Invalid number.");
  	      return;
  	    }

  	    setValue(next, true, true);
  	  });

  	  paintValue();

  	  parameterControls.set(key, {
  	    key,
  	    card: item.card,

  	    getValue() {
  	      return currentValue;
  	    },

  	    setValue(value) {
  	      setValue(value, false, true);
  	    }
  	  });

  	  return item.card;
  	}

  	const numKeys = Object.keys(CAN)
  	  .filter(key => !excludedKeys.includes(key))
  	  .filter(key => isNumericLike(CAN[key]))
  	  .sort((a, b) =>
  	    a.localeCompare(b, undefined, {
  	      sensitivity: "base"
  	    })
  	  );

  	if (numKeys.length) {
  	  const {
  	    section: parameterSection,
  	    body: parameterBody
  	  } = makeAccordionSection(
  	    "Adjustable Parameters",
  	    numKeys.length,
  	    !eventKeys.length
  	  );

  	  numKeys.forEach(key => {
  	    parameterBody.appendChild(
  	      makeNumericParameterCard(key)
  	    );
  	  });

  	  container.appendChild(parameterSection);
  	}

  	if (!eventKeys.length && !numKeys.length) {
  	  container.appendChild(
  	    makeEmptyMessage(
  	      "No adjustable telematics settings found."
  	    )
  	  );
  	}

  	container.appendChild(saveBar);

  	// =======================================================
  	// Save Helpers
  	// =======================================================

  	function getTractorObjectIdAny(tractor) {
  	  return safeString(
  	    tractor?.objectId ||
  	    tractor?.ObjectId ||
  	    tractor?.id ||
  	    tractor?.ID ||
  	    ""
  	  ).trim();
  	}


  	function tractorMatches(a, b) {
  	  if (!a || !b) return false;

  	  const aObjectId = getTractorObjectIdAny(a);
  	  const bObjectId = getTractorObjectIdAny(b);

  	  if (
  	    aObjectId &&
  	    bObjectId &&
  	    aObjectId === bObjectId
  	  ) {
  	    return true;
  	  }

  	  const fields = [
  	    "FID",
  	    "fid",
  	    "Tracker",
  	    "tracker",
  	    "Registration",
  	    "registration",
  	    "Reg",
  	    "reg",
  	    "VIN",
  	    "vin",
  	    "Name",
  	    "name"
  	  ];

  	  return fields.some(field => {
  	    const av =
  	      safeString(a?.[field]).trim();

  	    const bv =
  	      safeString(b?.[field]).trim();

  	    return (
  	      av &&
  	      bv &&
  	      av === bv
  	    );
  	  });
  	}


  	function commitAllTelematicsControls() {
  	  parameterControls.forEach(control => {
  	    const value =
  	      Number(control.getValue());

  	    if (Number.isFinite(value)) {
  	      CAN[control.key] = value;
  	    }
  	  });

  	  eventControls.forEach(control => {
  	    EB[control.key] =
  	      !!control.getValue();
  	  });
  	}


  	function clearChangedCardHighlights() {
  	  parameterControls.forEach(control => {
  	    control.card?.classList?.remove(
  	      "changed"
  	    );
  	  });

  	  eventControls.forEach(control => {
  	    control.card?.classList?.remove(
  	      "changed"
  	    );
  	  });
  	}


  	function updateTractorInAppDataCompanies(
  	  updatedTractor
  	) {
  	  if (
  	    !Array.isArray(
  	      AppData?.User?.Companies
  	    )
  	  ) {
  	    return false;
  	  }

  	  let updated = false;

  	  for (
  	    const company of
  	    AppData.User.Companies
  	  ) {
  	    if (
  	      !Array.isArray(
  	        company.Tractors
  	      )
  	    ) {
  	      continue;
  	    }

  	    const index =
  	      company.Tractors.findIndex(
  	        existing =>
  	          tractorMatches(
  	            existing,
  	            updatedTractor
  	          )
  	      );

  	    if (index !== -1) {
  	      company.Tractors[index] =
  	        clonePlain(updatedTractor);

  	      updated = true;
  	    }
  	  }

  	  return updated;
  	}


  	function findObjectIdFromAppData(
  	  updatedTractor
  	) {
  	  let objectId =
  	    getTractorObjectIdAny(
  	      updatedTractor
  	    ) ||
  	    getTractorObjectIdAny(
  	      Tractor
  	    ) ||
  	    getTractorObjectIdAny(
  	      AppData?.SelectedTractor
  	    );

  	  if (objectId) {
  	    return objectId;
  	  }

  	  if (
  	    !Array.isArray(
  	      AppData?.User?.Companies
  	    )
  	  ) {
  	    return "";
  	  }

  	  for (
  	    const company of
  	    AppData.User.Companies
  	  ) {
  	    if (
  	      !Array.isArray(
  	        company.Tractors
  	      )
  	    ) {
  	      continue;
  	    }

  	    const found =
  	      company.Tractors.find(
  	        existing =>
  	          tractorMatches(
  	            existing,
  	            updatedTractor
  	          )
  	      );

  	    if (!found) {
  	      continue;
  	    }

  	    objectId =
  	      getTractorObjectIdAny(
  	        found
  	      );

  	    if (objectId) {
  	      return objectId;
  	    }
  	  }

  	  return "";
  	}


  	// =======================================================
  	// Flespi Threshold Synchronisation
  	// =======================================================

  	async function getBackendlessUserTokenSafe() {
  	  try {
  	    const token =
  	      await Backendless
  	        ?.UserService
  	        ?.getCurrentUserToken?.();

  	    if (
  	      typeof token === "string" &&
  	      token.trim()
  	    ) {
  	      return token.trim();
  	    }
  	  } catch (error) {
  	    console.warn(
  	      "[Telematics Setup Hub] Could not read Backendless user token.",
  	      error
  	    );
  	  }

  	  return "";
  	}


  	async function syncFlespiThresholdsBestEffort(
  	  objectId
  	) {
  	  try {
  	    const cleanObjectId =
  	      safeString(objectId).trim();

  	    if (!cleanObjectId) {
  	      console.warn(
  	        "[Telematics Setup Hub] Flespi sync skipped: missing Tractor objectId."
  	      );

  	      return {
  	        success: false,
  	        skipped: true,
  	        reason: "missing_object_id"
  	      };
  	    }

  	    const userToken =
  	      await getBackendlessUserTokenSafe();

  	    if (!userToken) {
  	      console.warn(
  	        "[Telematics Setup Hub] Flespi sync skipped: Backendless session token unavailable."
  	      );

  	      return {
  	        success: false,
  	        skipped: true,
  	        reason:
  	          "missing_backendless_user_token"
  	      };
  	    }

  	    const response =
  	      await fetch(
  	        FLESPI_THRESHOLD_SYNC_URL,
  	        {
  	          method: "POST",

  	          headers: {
  	            "Content-Type":
  	              "application/json",

  	            "user-token":
  	              userToken
  	          },

  	          body: JSON.stringify({
  	            objectId:
  	              cleanObjectId
  	          }),

  	          /*
  	           * The sync is deliberately secondary.
  	           * keepalive gives the small request a better
  	           * chance to complete if the user immediately
  	           * moves away from the page.
  	           */
  	          keepalive: true
  	        }
  	      );

  	    let result = null;

  	    try {
  	      result =
  	        await response.json();
  	    } catch (_) {
  	      result = null;
  	    }

  	    if (
  	      !response.ok ||
  	      !result?.success
  	    ) {
  	      console.warn(
  	        "[Telematics Setup Hub] Flespi threshold sync rejected.",
  	        {
  	          status:
  	            response.status,

  	          objectId:
  	            cleanObjectId,

  	          result
  	        }
  	      );

  	      return {
  	        success: false,
  	        status:
  	          response.status,
  	        result
  	      };
  	    }

  	    console.log(
  	      "[Telematics Setup Hub] Flespi thresholds synced.",
  	      {
  	        objectId:
  	          cleanObjectId,

  	        tracker:
  	          result.tracker,

  	        speed_limit:
  	          result.speed_limit,

  	        rpm_limit:
  	          result.rpm_limit,

  	        flespi_device_name:
  	          result.flespi_device_name ||
  	          null
  	      }
  	    );

  	    return {
  	      success: true,
  	      ...result
  	    };

  	  } catch (error) {
  	    /*
  	     * IMPORTANT:
  	     * A Flespi failure must NEVER convert an otherwise
  	     * successful Backendless save into a failed save.
  	     */
  	    console.warn(
  	      "[Telematics Setup Hub] Flespi threshold sync failed silently.",
  	      error
  	    );

  	    return {
  	      success: false,
  	      error
  	    };
  	  }
  	}


  	// =======================================================
  	// Spinner Completion
  	// =======================================================

  	function finishSpinnerNow(message) {
  	  try {
  	    if (message) {
  	      AppData.SpinnerMsg =
  	        message;
  	    }

  	    AppData.SpinnerDone =
  	      true;
  	  } catch (_) {}
  	}


  	// =======================================================
  	// Spinner
  	// =======================================================

  	function spinnerOverlay(args) {
  	  const {
  	    App,
  	    waitKey = "SpinnerDone",
  	    msgKey = "SpinnerMsg",
  	    Image: SpinnerImage
  	  } = args || {};

  	  if (
  	    !App ||
  	    document.getElementById(
  	      "fleetSpinner"
  	    )
  	  ) {
  	    return;
  	  }

  	  const overlay =
  	    document.createElement("div");

  	  overlay.id =
  	    "fleetSpinner";

  	  Object.assign(
  	    overlay.style,
  	    {
  	      position: "fixed",
  	      inset: "0",
  	      zIndex: maxZIndex,
  	      background:
  	        "rgba(5,5,5,1)",
  	      display: "flex",
  	      flexDirection: "column",
  	      alignItems: "center",
  	      justifyContent: "center",
  	      color: "#fff",
  	      fontFamily:
  	        "Inter, sans-serif",
  	      transition:
  	        "opacity 0.45s ease"
  	    }
  	  );

  	  const logo =
  	    document.createElement("img");

  	  if (SpinnerImage) {
  	    logo.src =
  	      SpinnerImage;
  	  }

  	  logo.style.cssText = `
  	    width:200px;
  	    height:auto;
  	    margin-bottom:30px;
  	    opacity:0;
  	    transform:scale(0.8);
  	    filter:drop-shadow(0 0 12px rgba(204,102,51,0.8));
  	    animation:telematicsLogoFade 2.5s ease forwards;
  	  `;

  	  const spinner =
  	    document.createElement("div");

  	  spinner.style.cssText = `
  	    width:70px;
  	    height:70px;
  	    border:6px solid rgba(255,255,255,0.15);
  	    border-top:6px solid #CC6633;
  	    border-radius:50%;
  	    animation:telematicsSpin 1s linear infinite;
  	    box-shadow:0 0 20px rgba(204,102,51,0.4);
  	  `;

  	  const msg =
  	    document.createElement("div");

  	  msg.textContent =
  	    App?.[msgKey] ||
  	    "Saving telematics…";

  	  msg.style.cssText = `
  	    margin-top:28px;
  	    font-size:1.3em;
  	    font-weight:700;
  	    text-align:center;
  	    letter-spacing:0.5px;
  	    opacity:0;
  	    animation:telematicsFadeIn 1.5s ease forwards,
  	              telematicsTextPulse 4s ease-in-out infinite 1.5s;
  	  `;

  	  const spinnerStyle =
  	    document.createElement(
  	      "style"
  	    );

  	  spinnerStyle.textContent = `
  	    @keyframes telematicsSpin {
  	      0% {
  	        transform: rotate(0);
  	      }

  	      100% {
  	        transform: rotate(360deg);
  	      }
  	    }

  	    @keyframes telematicsFadeIn {
  	      from {
  	        opacity: 0;
  	        transform: translateY(8px);
  	      }

  	      to {
  	        opacity: 1;
  	        transform: translateY(0);
  	      }
  	    }

  	    @keyframes telematicsLogoFade {
  	      0% {
  	        opacity: 0;
  	        transform: scale(0.8);
  	      }

  	      60% {
  	        opacity: 0.9;
  	        transform: scale(1.1);
  	      }

  	      100% {
  	        opacity: 1;
  	        transform: scale(1);
  	      }
  	    }

  	    @keyframes telematicsTextPulse {
  	      0%,
  	      100% {
  	        opacity: 0.4;
  	        transform: scale(1);
  	        text-shadow: 0 0 0 rgba(204,102,51,0);
  	      }

  	      50% {
  	        opacity: 1;
  	        transform: scale(1.3);
  	        text-shadow: 0 0 25px rgba(204,102,51,0.9);
  	        color: #fff8f0;
  	      }
  	    }
  	  `;

  	  overlay.append(
  	    logo,
  	    spinner,
  	    msg
  	  );

  	  document.body.append(
  	    spinnerStyle,
  	    overlay
  	  );

  	  let last =
  	    msg.textContent;

  	  const poller =
  	    setInterval(() => {
  	      if (
  	        App[msgKey] &&
  	        App[msgKey] !== last
  	      ) {
  	        msg.textContent =
  	          App[msgKey];

  	        last =
  	          msg.textContent;
  	      }

  	      if (App[waitKey]) {
  	        clearInterval(
  	          poller
  	        );

  	        overlay.style.opacity =
  	          "0";

  	        setTimeout(() => {
  	          try {
  	            overlay.remove();
  	          } catch (_) {}

  	          try {
  	            spinnerStyle.remove();
  	          } catch (_) {}
  	        }, 400);

  	        delete App[waitKey];
  	        delete App[msgKey];
  	      }
  	    }, 250);
  	}


  	// =======================================================
  	// Save Logic
  	// =======================================================

  	async function saveTelematics() {
  	  if (isSaving) {
  	    return;
  	  }

  	  isSaving = true;

  	  saveBtn.disabled = true;
  	  saveBtn.textContent =
  	    "Saving…";

  	  /*
  	   * Copy every currently displayed control back into
  	   * the CAN object before persistence.
  	   */
  	  commitAllTelematicsControls();

  	  try {
  	    AppData.SpinnerDone =
  	      false;

  	    AppData.SpinnerMsg =
  	      "Saving telematics…";
  	  } catch (_) {}

  	  spinnerOverlay({
  	    App: AppData,
  	    Image
  	  });

  	  try {

  	    // ---------------------------------------------------
  	    // Build the Tractor payload
  	    // ---------------------------------------------------

  	    const updatedTractor =
  	      clonePlain(Tractor) ||
  	      {};

  	    updatedTractor.CAN =
  	      clonePlain(CAN) ||
  	      CAN;

  	    const objectId =
  	      findObjectIdFromAppData(
  	        updatedTractor
  	      );

  	    if (!objectId) {
  	      throw new Error(
  	        "No tractor objectId found. Cannot save CAN parameters to Backendless."
  	      );
  	    }

  	    updatedTractor.objectId =
  	      getTractorObjectIdAny(
  	        updatedTractor
  	      ) ||
  	      objectId;


  	    // ---------------------------------------------------
  	    // Backendless is the PRIMARY save
  	    // ---------------------------------------------------

  	    const table =
  	      Backendless.Data.of(
  	        "Tractors"
  	      );

  	    let backendTractor =
  	      await table.findById(
  	        objectId
  	      );

  	    if (!backendTractor) {
  	      throw new Error(
  	        `Tractor record was not found in Backendless: ${objectId}`
  	      );
  	    }

  	    backendTractor.CAN =
  	      clonePlain(
  	        updatedTractor.CAN
  	      );

  	    try {
  	      backendTractor =
  	        await table.save(
  	          backendTractor,
  	          true
  	        );
  	    } catch (_) {
  	      backendTractor =
  	        await table.save(
  	          backendTractor
  	        );
  	    }


  	    // ---------------------------------------------------
  	    // Canonical post-save Tractor
  	    // ---------------------------------------------------

  	    const savedTractor = {
  	      ...updatedTractor,
  	      ...backendTractor,

  	      CAN: clonePlain(
  	        backendTractor.CAN ||
  	        updatedTractor.CAN
  	      )
  	    };


  	    // ---------------------------------------------------
  	    // Update Fleet In Form state immediately
  	    // ---------------------------------------------------

  	    AppData.SelectedTractor =
  	      savedTractor;

  	    try {
  	      Tractor.CAN =
  	        clonePlain(
  	          savedTractor.CAN
  	        );

  	      Tractor.objectId =
  	        getTractorObjectIdAny(
  	          savedTractor
  	        ) ||
  	        objectId;
  	    } catch (_) {}

  	    updateTractorInAppDataCompanies(
  	      savedTractor
  	    );


  	    // ---------------------------------------------------
  	    // Flespi is SECONDARY and SILENT
  	    //
  	    // Do not await this.
  	    // Backendless has already saved successfully.
  	    // ---------------------------------------------------

  	    void syncFlespiThresholdsBestEffort(
  	      objectId
  	    );


  	    // ---------------------------------------------------
  	    // Existing app refresh
  	    // ---------------------------------------------------

  	    try {
  	      BackendlessUI
  	        ?.App
  	        ?.refresh
  	        ?.();
  	    } catch (_) {}


  	    // ---------------------------------------------------
  	    // Complete UI state
  	    // ---------------------------------------------------

  	    saveBtn.textContent =
  	      "Saved!";

  	    saveBar.classList.remove(
  	      "visible"
  	    );

  	    changesMade =
  	      false;

  	    clearChangedCardHighlights();

  	    try {
  	      PageData.FIF =
  	        true;
  	    } catch (_) {}

  	    finishSpinnerNow(
  	      "Telematics saved."
  	    );

  	    /*
  	     * Preserve your existing success language.
  	     * The Flespi sync remains completely silent.
  	     */
  	    showToast(
  	      "Telematics Updated — Flash Triggered"
  	    );

  	    setTimeout(() => {
  	      if (!isSaving) {
  	        saveBtn.textContent =
  	          "Save Changes";
  	      }
  	    }, 800);

  	  } catch (error) {

  	    /*
  	     * This catch is now only for the REAL Fleet In Form
  	     * / Backendless save path.
  	     *
  	     * Flespi cannot land here.
  	     */

  	    console.error(
  	      "[Telematics Setup Hub] Save failed.",
  	      error
  	    );

  	    finishSpinnerNow(
  	      "Save failed"
  	    );

  	    saveBtn.textContent =
  	      "Save Changes";

  	    showToast(
  	      "Save failed: " +
  	      (
  	        error?.message ||
  	        error?.faultString ||
  	        "Please retry."
  	      )
  	    );

  	  } finally {

  	    isSaving =
  	      false;

  	    saveBtn.disabled =
  	      false;
  	  }
  	}


  	saveBtn.addEventListener(
  	  "click",
  	  event => {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    saveTelematics();
  	  }
  	);

  	// =======================================================
  	// Toast
  	// =======================================================

  	function showToast(message) {
  	  const existing =
  	    document.getElementById("telematics-toast");

  	  existing?.remove();

  	  const toast = document.createElement("div");

  	  toast.id = "telematics-toast";
  	  toast.textContent = message;

  	  Object.assign(toast.style, {
  	    position: "fixed",
  	    bottom: "20px",
  	    left: "50%",
  	    transform: "translateX(-50%)",
  	    background: themeOrange,
  	    color: "#111",
  	    padding: "10px 18px",
  	    borderRadius: "7px",
  	    fontWeight: "700",
  	    zIndex: "10002",
  	    boxShadow: "0 3px 12px rgba(0,0,0,0.58)",
  	    opacity: "0",
  	    transition: "opacity 0.3s ease",
  	    maxWidth: "calc(100vw - 32px)",
  	    textAlign: "center"
  	  });

  	  document.body.appendChild(toast);

  	  setTimeout(() => {
  	    toast.style.opacity = "1";
  	  }, 10);

  	  setTimeout(() => {
  	    toast.style.opacity = "0";

  	    setTimeout(() => {
  	      try {
  	        toast.remove();
  	      } catch (_) {}
  	    }, 400);
  	  }, 2500);
  	}

  	// =======================================================
  	// Close Behaviour
  	// =======================================================

  	function restoreHubControls() {
  	  try {
  	    if (typeof HUB.setVisible === "function") {
  	      HUB.setVisible(true);
  	    } else if ("visible" in HUB) {
  	      HUB.visible = true;
  	    }
  	  } catch (_) {}

  	  try {
  	    if (Arrow) {
  	      if (typeof Arrow.setIcon === "function") {
  	        Arrow.setIcon("arrow_drop_up");
  	      } else if ("icon" in Arrow) {
  	        Arrow.icon = "arrow_drop_up";
  	      }
  	    }
  	  } catch (_) {}

  	  try {
  	    if (Block) {
  	      if ("display" in Block) {
  	        Block.display = true;
  	      } else if (
  	        typeof Block.setVisible === "function"
  	      ) {
  	        Block.setVisible(true);
  	      } else if ("visible" in Block) {
  	        Block.visible = true;
  	      }
  	    }
  	  } catch (_) {}
  	}

  	function removePopupElements() {
  	  try {
  	    popup.remove();
  	  } catch (_) {}

  	  try {
  	    style.remove();
  	  } catch (_) {}
  	}

  	function closePopup() {
  	  restoreHubControls();
  	  runManagedCleanups();
  	  removePopupElements();

  	  if (
  	    window.__telematicsSetupHubCleanup ===
  	    cleanupCurrentPopup
  	  ) {
  	    delete window.__telematicsSetupHubCleanup;
  	  }
  	}

  	function cleanupCurrentPopup() {
  	  runManagedCleanups();
  	  removePopupElements();
  	}

  	window.__telematicsSetupHubCleanup =
  	  cleanupCurrentPopup;

  	closeBtn.addEventListener("click", event => {
  	  event.preventDefault();
  	  event.stopPropagation();

  	  closePopup();
  	});

  	// =======================================================
  	// Mount Popup + Event Listeners
  	// =======================================================

  	document.body.appendChild(popup);

  	function resizeHandler() {
  	  positionPopup();
  	}

  	function escHandler(event) {
  	  if (event.key === "Escape") {
  	    closePopup();
  	  }
  	}

  	addManagedListener(
  	  window,
  	  "resize",
  	  resizeHandler
  	);

  	addManagedListener(
  	  window,
  	  "orientationchange",
  	  resizeHandler
  	);

  	addManagedListener(
  	  window,
  	  "keydown",
  	  escHandler
  	);

  	positionPopup();
  })(HUB, Tractor, Appdata, PageData, 'data:image/png;base64,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', Arrow, Block);

}

})
define('./functions/1c281acb3a51cd63d152afb639d9a49f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1c281acb3a51cd63d152afb639d9a49f'] = async function fn_1c281acb3a51cd63d152afb639d9a49f(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.dropRight(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/26d5effe010a024af594e7ea0151369e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_26d5effe010a024af594e7ea0151369e'] = async function fn_26d5effe010a024af594e7ea0151369e(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/27a3d5b5fe9f5c3e7f0c16ee16cd7b55/code.js', () => { 

BackendlessUI.Functions.Custom['fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55'] = async function fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55(propertyNamePathsList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObjectDeep(props, values)
})(propertyNamePathsList, propertyValuesList))
}

})
define('./functions/2a1538e41c7c2966c613c5082d9cc4a6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2a1538e41c7c2966c613c5082d9cc4a6'] = async function fn_2a1538e41c7c2966c613c5082d9cc4a6(listOfGroupedElements, combinerFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzipWith(array, iteratee)
})(listOfGroupedElements, combinerFunction))
}

})
define('./functions/2a3bf3cde9c8d10f742f3579cbb2a766/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2a3bf3cde9c8d10f742f3579cbb2a766'] = async function fn_2a3bf3cde9c8d10f742f3579cbb2a766(App) {
  await (async function(App, SVG) {
  	return (async function FleetInFormDashboardVehicleManagerV21_12_80() {
  	  "use strict";

  	{
  	    window.__FIF_DASHBOARD_BUILD__ = "21.12.94-vehicle-tank-can-data-sync";
  	    // Employee lifecycle V3: SA ID reuses existing Employees, Company membership controls login availability, and unlinking all Companies retains the full Users record.
  	    // Vehicle Data V21.12.94: Essential Tank Size synchronizes Data tank mirrors and CAN.Tank; preserves live CAN settings and verifies all values after REST save.
  	    // Vehicle Data V21.12.92: fixes Tank Size suffix-only control layout while retaining synchronized fuel tank capacity mirrors.
  	    // Fuel analysis V21.12.80: stable stationary pre/post plateaus; Telemetry Fuel Rise remains primary; authenticated Driver Mobile slip/odometer photos are displayed and printed as evidence.
  	    window.__FIF_VEHICLE_DATA_STATE__ = "ESSENTIAL_AND_IDENTITY_PHASE_2";
  	  }

  	  function fifExactOriginalTractorManager(args) {

  	    args = args || {};

  	    var AppSafe = args.App || null;
  	    var TractorsSafe = Array.isArray(args.Tractors) ? args.Tractors: [];
  	    var TyresSafe = Array.isArray(args.Tyres) ? args.Tyres: [];
  	    var HubSafe = args.Hub || null;
  	    var BackendlessSafe = args.Backendless || null;
  	    var SvgSafe =
  	    args.SVG ||
  	    args.svg ||
  	    args.Svg ||
  	    (typeof SVG !== "undefined" ? SVG: "") ||
  	    (typeof window !== "undefined" && window.SVG ? window.SVG: "");
  	    var WindowSafe = (typeof window !== "undefined" ? window: null);
  	    var DocumentSafe = (typeof document !== "undefined" ? document: null);
  	    var InlineMode = !!args.InlineMode;
  	    var InitialVehicle = args.Vehicle || (TractorsSafe.length ? TractorsSafe[0]: null);
  	    var AllowTyreOperations = args.AllowTyreOperations !== false;
  	    var AllowAxleConfiguration = args.AllowAxleConfiguration !== false;
  	    var App = AppSafe;
  	    var Tractors = TractorsSafe;
  	    var TyresArg = TyresSafe;
  	    var Hub = HubSafe;
  	    var BackendlessApi = BackendlessSafe;

  	    var TABLE_TRACTORS = "Tractors";
  	    var TABLE_TYRES = "Tyres";

  	    var TPOSITIONS_PRIMARY = "TPositions";
  	    var TPOSITIONS_SECONDARY = "TyrePositions";
  	    var TYRES_RELATION = "Tyres";

  	    var SCHEMA_VERSION = "T3.0";
  	    var VEHICLE_TYPE = "Tractor";

  	    var TYRE_STATUS = {
  	      OK: "All In Order",
  	      RETREAD: "In For Retread",
  	      SCRAPPED: "Scrapped",
  	      STOLEN: "Stolen"
  	    };

  	    var AXLE_TYPES = {
  	      Tractor: ["Steer", "Tag", "Drive", "Spare"],
  	      Trailer: ["Trailer", "Spare"]
  	    };

  	    var hubEl = Hub && Hub.el ? Hub.el: Hub;

  	    if (!hubEl || !DocumentSafe) {

  	      return false;
  	    }

  	    function escapeHtml(value) {
  	      return String(value == null ? "": value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/\"/g, "&quot;")
  	      .replace(/'/g, "&#39;");
  	    }

  	    function clean(value) {
  	      return String(value == null ? "": value).trim();
  	    }

  	    function reportLogoHtml() {
  	      var svg = SvgSafe;
  	      var cleaned;

  	      if (svg && typeof svg === "object") {
  	        svg = svg.value || svg.Value || svg.src || svg.url || "";
  	      }

  	      svg = clean(svg);

  	      if (
  	        svg.length >= 2 &&
  	        (
  	          (svg.charAt(0) === "\"" && svg.charAt(svg.length - 1) === "\"") ||
  	          (svg.charAt(0) === "'" && svg.charAt(svg.length - 1) === "'")
  	        )
  	      ) {
  	        svg = svg.substring(1, svg.length - 1);
  	      }

  	      if (!svg) {
  	        return "";
  	      }

  	      if (/^data:image\//i.test(svg)) {
  	        return "<img src=\"" + escapeHtml(svg) + "\" alt=\"Report Logo\" style=\"height:48px;width:auto;max-width:190px;object-fit:contain;display:block;\">";
  	      }

  	      if (/^<svg[\s>]/i.test(svg)) {
  	        cleaned = svg
  	        .replace(/<script[\s\S]*?<\/script>/gi, "")
  	        .replace(/<svg(?![^>]*preserveAspectRatio)/i, "<svg preserveAspectRatio=\"xMidYMid meet\"")
  	        .replace(/<svg([^>]*?)>/i, "<svg$1 style=\"height:48px;width:auto;max-width:190px;display:block;\">");

  	        return cleaned;
  	      }

  	      return "";
  	    }



  	    function arr(value) {
  	      return Array.isArray(value) ? value: [];
  	    }

  	    function clone(value) {
  	      return JSON.parse(JSON.stringify(value || {}));
  	    }

  	    function clamp(value, min, max, fallback) {
  	      var number = Number(value);

  	      if (!Number.isFinite(number)) {
  	        number = fallback;
  	      }

  	      return Math.max(min, Math.min(max, number));
  	    }

  	    function numberOrNull(value) {
  	      if (value === null || value === undefined || value === "") {
  	        return null;
  	      }

  	      var number = Number(value);

  	      return Number.isFinite(number) ? number: null;
  	    }

  	    function promptTypeFromMessage(message) {
  	      var text = clean(message).toLowerCase();
  	      if (/failed|error|invalid|not allowed|could not|cannot|expired|stolen|scrap/.test(text)) return "danger";
  	      if (/saved|completed|success|allocated|removed/.test(text)) return "success";
  	      if (/confirm|approve|warning|cancel|clear|mismatch|remove/.test(text)) return "warning";
  	      return "info";
  	    }

  	    function promptTitleFromMessage(message, fallback) {
  	      var text = clean(message);
  	      if (/mismatch/i.test(text)) return "Tyre Type Mismatch";
  	      if (/remove/i.test(text)) return "Remove Tyre";
  	      if (/allocation/i.test(text)) return "Tyre Allocation";
  	      if (/rotation/i.test(text)) return "Tyre Rotation";
  	      if (/axle/i.test(text)) return "Axle Configuration";
  	      return fallback || "Fleet In Form";
  	    }

  	    function alertSafe(message, options) {
  	      options = options || {};
  	      if (typeof fifAlert === "function") {
  	        fifAlert(message, {
  	          title: options.title || promptTitleFromMessage(message, "Fleet In Form"),
  	          type: options.type || promptTypeFromMessage(message),
  	          confirmText: options.confirmText || "Close",
  	          details: options.details || []
  	        });
  	        return;
  	      }

  	    }

  	    function confirmSafe(message, options) {
  	      options = options || {};
  	      if (typeof fifConfirm === "function") {
  	        return fifConfirm(message, {
  	          title: options.title || promptTitleFromMessage(message, "Please Confirm"),
  	          type: options.type || "warning",
  	          confirmText: options.confirmText || "Continue",
  	          cancelText: options.cancelText || "Cancel",
  	          details: options.details || []
  	        });
  	      }

  	      return Promise.resolve(false);
  	    }

  	    function parseJson(raw, fallback) {
  	      if (raw === null || raw === undefined || raw === "") {
  	        return clone(fallback);
  	      }

  	      if (typeof raw === "object") {
  	        return clone(raw);
  	      }

  	      try {
  	        return JSON.parse(raw);
  	      } catch (error) {

  	        return clone(fallback);
  	      }
  	    }

  	    function prettyName(value) {
  	      return String(value || "")
  	      .replace(/_/g, " ")
  	      .replace(/([a-z])([A-Z])/g, "$1 $2")
  	      .trim()
  	      .replace(/\b\w/g, function (char) {
  	        return char.toUpperCase();
  	      });
  	    }

  	    function isWrapped(value) {
  	      return !!(
  	        value &&
  	        typeof value === "object" &&
  	        !Array.isArray(value) &&
  	        Object.prototype.hasOwnProperty.call(value, "value")
  	      );
  	    }

  	    function unwrap(value) {
  	      return isWrapped(value) ? value.value: value;
  	    }

  	    function getFirst(source, names) {
  	      if (!source || typeof source !== "object") {
  	        return "";
  	      }

  	      for (var i = 0; i < names.length; i++) {
  	        if (
  	          Object.prototype.hasOwnProperty.call(source, names[i]) &&
  	          source[names[i]] !== null &&
  	          source[names[i]] !== undefined
  	        ) {
  	          return source[names[i]];
  	        }
  	      }

  	      return "";
  	    }

  	    function ensureObjectPath(root, path) {
  	      var ref = root;

  	      path.forEach(function (key) {
  	        if (!ref[key] || typeof ref[key] !== "object" || Array.isArray(ref[key])) {
  	          ref[key] = {};
  	        }

  	        ref = ref[key];
  	      });

  	      return ref;
  	    }

  	    function ensureArrayPath(root,
  	      path) {
  	      var parent = ensureObjectPath(root,
  	        path.slice(0, -1));
  	      var key = path[path.length - 1];

  	      if (!Array.isArray(parent[key])) {
  	        parent[key] = [];
  	      }

  	      return parent[key];
  	    }

  	    function tokenizePath(path) {
  	      var tokens = [];

  	      String(path || "").split(".").forEach(function (part) {
  	        var re = /([^\[\]]+)|\[(\d+)\]/g;
  	        var match;

  	        while ((match = re.exec(part)) !== null) {
  	          if (match[1] !== null && match[1] !== undefined) {
  	            tokens.push(match[1]);
  	          } else if (match[2] !== null && match[2] !== undefined) {
  	            tokens.push(Number(match[2]));
  	          }
  	        }
  	      });

  	      return tokens;
  	    }

  	    function setByTokens(root,
  	      tokens,
  	      value) {
  	      var ref = root;

  	      if (!root || !tokens.length) {
  	        return;
  	      }

  	      for (var i = 0; i < tokens.length - 1; i++) {
  	        var key = tokens[i];
  	        var next = tokens[i + 1];

  	        if (typeof key === "number") {
  	          if (!Array.isArray(ref)) {
  	            return;
  	          }

  	          if (!ref[key]) {
  	            ref[key] = typeof next === "number" ? []: {};
  	          }

  	          ref = ref[key];
  	        } else {
  	          if (typeof next === "number") {
  	            if (!Array.isArray(ref[key])) {
  	              ref[key] = [];
  	            }
  	          } else if (!ref[key] || typeof ref[key] !== "object") {
  	            ref[key] = {};
  	          }

  	          ref = ref[key];
  	        }
  	      }

  	      ref[tokens[tokens.length - 1]] = value;
  	    }

  	    function readInputValue(element) {
  	      if (!element) {
  	        return null;
  	      }

  	      if (element.type === "checkbox") {
  	        return !!element.checked;
  	      }

  	      if (element.type === "number") {
  	        if (element.value === "") {
  	          return "";
  	        }

  	        var number = Number(element.value);

  	        return Number.isFinite(number) ? number: element.value;
  	      }

  	      return element.value;
  	    }

  	    function getUiValue(id) {
  	      var element = DocumentSafe.getElementById(id);

  	      if (!element) {
  	        return "";
  	      }

  	      return clean(element.value);
  	    }



  	    function vehicleObjectId(vehicle) {
  	      return clean(getFirst(vehicle, ["objectId", "ObjectId", "OBJECTID", "objectID"]));
  	    }

  	    function vehicleId(vehicle) {
  	      return clean(firstValue([
  	        fifVehicleIdentityValue(vehicle, "FID", ""),
  	        getFirst(vehicle, ["ID", "Id", "id"]),
  	        vehicleObjectId(vehicle)
  	      ], ""));
  	    }

  	    function vehicleMake(vehicle) {
  	      return clean(fifVehicleIdentityValue(vehicle, "Make", ""));
  	    }

  	    function vehicleModel(vehicle) {
  	      return clean(fifVehicleIdentityValue(vehicle, "Model", ""));
  	    }

  	    function vehicleReg(vehicle) {
  	      return clean(fifVehicleIdentityValue(vehicle, "Registration", ""));
  	    }

  	    function vehicleTitle(vehicle) {
  	      var title = clean(vehicleMake(vehicle) + " " + vehicleModel(vehicle));

  	      if (!title) {
  	        title = vehicleId(vehicle) || vehicleObjectId(vehicle) || "Vehicle";
  	      }

  	      if (vehicleReg(vehicle)) {
  	        title += " (" + vehicleReg(vehicle) + ")";
  	      }

  	      return title;
  	    }

  	    function vehicleOdometerBaseline(vehicle) {
  	      return numberOr(fifVehicleCurrentReading(vehicle), 0);
  	    }

  	    function cardColor(vehicle) {
  	      return fifVehicleColorValue(vehicle);
  	    }

  	    function tyreObjectId(tyre) {
  	      return clean(getFirst(tyre, ["objectId", "ObjectId", "objectID", "id"]));
  	    }

  	    function tyreNumber(tyre) {
  	      return clean(getFirst(tyre, [
  	        "ID",
  	        "FID",
  	        "Tyre_Number",
  	        "TyreNumber",
  	        "Serial_Number",
  	        "SerialNumber"
  	      ]));
  	    }

  	    function tyreSerial(tyre) {
  	      return clean(getFirst(tyre, ["Serial_Number", "SerialNumber", "Serial"]));
  	    }

  	    function tyreMake(tyre) {
  	      return clean(getFirst(tyre, ["Make", "Tyre_Brand", "Brand"]));
  	    }

  	    function tyreModel(tyre) {
  	      return clean(getFirst(tyre, ["Model", "Pattern"]));
  	    }

  	    function tyreSize(tyre) {
  	      return clean(getFirst(tyre, ["Size"]));
  	    }

  	    function tyreType(tyre) {
  	      return clean(getFirst(tyre, ["Type"]));
  	    }

  	    function tyreStatus(tyre) {
  	      return clean(getFirst(tyre, ["Status"])) || TYRE_STATUS.OK;
  	    }

  	    function tyreName(tyre) {
  	      if (!tyre) {
  	        return "";
  	      }

  	      return [
  	        tyreNumber(tyre),
  	        tyreSerial(tyre),
  	        tyreMake(tyre),
  	        tyreModel(tyre),
  	        tyreSize(tyre)
  	      ].filter(Boolean).join(" - ") || tyreObjectId(tyre);
  	    }

  	    function tyreLife(tyre) {
  	      var direct;
  	      var currentMileage;
  	      var expectedMileage;

  	      if (!tyre) {
  	        return null;
  	      }

  	      direct = numberOrNull(tyre.Current_Life);

  	      if (direct !== null) {
  	        return clamp(direct, 0, 100, 0);
  	      }

  	      currentMileage = numberOrNull(tyre.Current_Mileage);
  	      expectedMileage = numberOrNull(tyre.Expected_Mileage);

  	      if (currentMileage !== null && expectedMileage !== null && expectedMileage > 0) {
  	        return clamp(100 - ((currentMileage / expectedMileage) * 100), 0, 100, 0);
  	      }

  	      return null;
  	    }

  	    function tyreColor(tyre) {
  	      var life = tyreLife(tyre);

  	      if (life === null) return "#6b7280";
  	      if (life <= 0) return "#111827";
  	      if (life < 20) return "#ff2b1a";
  	      if (life < 40) return "#ff8a00";
  	      if (life < 60) return "#ffd633";
  	      if (life < 80) return "#a6ff33";

  	      return "#39ff14";
  	    }

  	    function requiredTyreTypeForSlot(slot) {
  	      if (!slot) return "Drive";
  	      if (slot.AxleType === "Tag") return "Drive";
  	      if (slot.AxleType === "Spare") return "Spare";
  	      if (slot.AxleType === "Trailer") return "Trailer";
  	      if (slot.AxleType === "Steer") return "Steer";

  	      return "Drive";
  	    }



  	    function tyreMismatchInfo(tyre, slot) {
  	      var actual = tyreType(tyre) || "No Type";
  	      var required = requiredTyreTypeForSlot(slot);

  	      return {
  	        HasMismatch: !!(actual && required && actual !== required && actual !== "No Type"),
  	        ActualType: actual,
  	        RequiredType: required,
  	        Message: "Tyre type mismatch. Required: " + required + ". Actual: " + actual + "."
  	      };
  	    }

  	    function mismatchKey(tyreId, positionKey) {
  	      return clean(tyreId) + "::" + clean(positionKey);
  	    }

  	    function mismatchAlreadyApproved(tyreId, positionKey) {
  	      return !!state.mismatchApprovals[mismatchKey(tyreId, positionKey)];
  	    }

  	    function approveMismatch(tyre, slot, reason) {
  	      var info = tyreMismatchInfo(tyre, slot);
  	      var key = mismatchKey(tyreObjectId(tyre), slot.PositionKey);

  	      state.mismatchApprovals[key] = {
  	        Accepted: true,
  	        Date: new Date().toISOString(),
  	        Required_Type: info.RequiredType,
  	        Actual_Type: info.ActualType,
  	        Position: slot.PositionKey,
  	        Reason: reason || "User accepted tyre type mismatch."
  	      };

  	      return state.mismatchApprovals[key];
  	    }

  	    function getMismatchApproval(tyreId, positionKey) {
  	      return state.mismatchApprovals[mismatchKey(tyreId, positionKey)] || null;
  	    }

  	    async function confirmMismatchIfNeeded(tyre, slot) {
  	      var info = tyreMismatchInfo(tyre, slot);
  	      var approved;

  	      if (!info.HasMismatch) {
  	        return true;
  	      }

  	      if (mismatchAlreadyApproved(tyreObjectId(tyre), slot.PositionKey)) {
  	        return true;
  	      }

  	      approved = await confirmSafe(
  	        "The selected tyre type does not match the required axle position. The fitment is allowed only after explicit approval, and that approval will be written to the tyre history.",
  	        {
  	          title: "Tyre Type Mismatch",
  	          type: "warning",
  	          confirmText: "Approve Fitment",
  	          cancelText: "Cancel",
  	          details: [{
  	            label: "Position", value: slot.PositionKey
  	          },
  	            {
  	              label: "Required", value: info.RequiredType
  	            },
  	            {
  	              label: "Actual", value: info.ActualType
  	            },
  	            {
  	              label: "Tyre", value: tyreName(tyre)
  	            }]
  	        }
  	      );

  	      if (!approved) {
  	        return false;
  	      }

  	      approveMismatch(tyre, slot, "Mismatch approved during tyre operation.");
  	      return true;
  	    }

  	    function mismatchSummaryForHistory(tyre, slot) {
  	      var info = tyreMismatchInfo(tyre, slot);

  	      if (!info.HasMismatch) {
  	        return "";
  	      }

  	      return "Mismatch accepted. Required Type: " + info.RequiredType + ". Actual Type: " + info.ActualType + ".";
  	    }

  	    function isTyreAvailable(tyre) {
  	      return !!tyreObjectId(tyre) &&
  	      !clean(tyre.Vehicle_ObjectId) &&
  	      tyreStatus(tyre) === TYRE_STATUS.OK;
  	    }

  	    function addTyreToMap(map, tyre) {
  	      var id = tyreObjectId(tyre);

  	      if (id) {
  	        map[id] = tyre;
  	      }
  	    }

  	    function collectTyres() {
  	      var map = {};

  	      TyresArg.forEach(function (tyre) {
  	        addTyreToMap(map, tyre);
  	      });

  	      arr(TyresSafe).forEach(function (tyre) {
  	        addTyreToMap(map, tyre);
  	      });

  	      try {
  	        arr(App && App.User && App.User.Companies).forEach(function (company) {
  	          arr(company.Tyres).forEach(function (tyre) {
  	            addTyreToMap(map, tyre);
  	          });

  	          arr(company.Tractors).forEach(function (vehicle) {
  	            arr(vehicle.Tyres).forEach(function (tyre) {
  	              addTyreToMap(map, tyre);
  	            });
  	          });

  	          arr(company.Trailers).forEach(function (vehicle) {
  	            arr(vehicle.Tyres).forEach(function (tyre) {
  	              addTyreToMap(map, tyre);
  	            });
  	          });
  	        });
  	      } catch (error) {

  	      }

  	      Tractors.forEach(function (vehicle) {
  	        arr(vehicle.Tyres).forEach(function (tyre) {
  	          addTyreToMap(map, tyre);
  	        });
  	      });

  	      return Object.keys(map).map(function (id) {
  	        return map[id];
  	      });
  	    }

  	    function findTyre(id) {
  	      var cleanId = clean(id);

  	      if (!cleanId) {
  	        return null;
  	      }

  	      for (var i = 0; i < state.tyreArray.length; i++) {
  	        if (tyreObjectId(state.tyreArray[i]) === cleanId) {
  	          return state.tyreArray[i];
  	        }
  	      }

  	      return null;
  	    }

  	    function upsertTyre(tyre) {
  	      var id = tyreObjectId(tyre);
  	      var i;

  	      if (!id) {
  	        return;
  	      }

  	      for (i = 0; i < state.tyreArray.length; i++) {
  	        if (tyreObjectId(state.tyreArray[i]) === id) {
  	          state.tyreArray[i] = tyre;
  	          return;
  	        }
  	      }

  	      state.tyreArray.push(tyre);
  	    }

  	    function loadTyres() {
  	      var store;
  	      var query = null;

  	      if (state.tyresLoaded) {
  	        return Promise.resolve(state.tyreArray);
  	      }

  	      if (state.tyresLoading) {
  	        return state.tyresLoading;
  	      }

  	      if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	        return Promise.resolve(state.tyreArray);
  	      }

  	      store = BackendlessApi.Data.of(TABLE_TYRES);

  	      try {
  	        if (BackendlessApi.DataQueryBuilder && BackendlessApi.DataQueryBuilder.create) {
  	          query = BackendlessApi.DataQueryBuilder.create();

  	          if (typeof query.setPageSize === "function") {
  	            query.setPageSize(100);
  	          }
  	        } else {
  	          query = {
  	            pageSize: 100
  	          };
  	        }
  	      } catch (error) {
  	        query = {
  	          pageSize: 100
  	        };
  	      }

  	      state.tyresLoading = store.find(query)
  	      .then(function (rows) {
  	        rows = Array.isArray(rows)
  	        ? rows: rows && Array.isArray(rows.data)
  	        ? rows.data: [];

  	        rows.forEach(function (tyre) {
  	          upsertTyre(tyre);
  	        });

  	        state.tyresLoaded = true;
  	        state.tyresLoading = null;

  	        return state.tyreArray;
  	      })
  	      .catch(function (error) {

  	        state.tyresLoading = null;

  	        return state.tyreArray;
  	      });

  	      return state.tyresLoading;
  	    }

  	    function allowedAxleTypes(vehicleType) {
  	      return AXLE_TYPES[vehicleType] || AXLE_TYPES.Tractor;
  	    }

  	    function defaultAxleType(vehicleType) {
  	      return vehicleType === "Trailer" ? "Trailer": "Drive";
  	    }

  	    function normaliseAxle(axle, fallbackAxleNo, vehicleType) {
  	      var cleanVehicleType = vehicleType || VEHICLE_TYPE;
  	      var allowed = allowedAxleTypes(cleanVehicleType);
  	      var axleNo = Math.max(1, Number((axle && (axle.Axle || axle.AxleNo)) || fallbackAxleNo || 1));
  	      var type = axle && allowed.indexOf(axle.Type) !== -1 ? axle.Type: defaultAxleType(cleanVehicleType);
  	      var tyresPerSide = Number(axle && (
  	        axle.TyresPerSide ||
  	        axle.TyreCountPerSide ||
  	        axle.Tyres ||
  	        axle.LeftCount ||
  	        axle.Left
  	      ));
  	      var wearRate = Number(axle && (axle.WearRate || axle.TagWearRate));

  	      if (!Number.isFinite(tyresPerSide)) {
  	        tyresPerSide = 1;
  	      }

  	      tyresPerSide = Math.round(clamp(tyresPerSide, 1, 2, 1));

  	      if (type === "Steer" || type === "Spare") {
  	        tyresPerSide = 1;
  	      }

  	      if (!Number.isFinite(wearRate)) {
  	        wearRate = 1;
  	      }

  	      wearRate = clamp(wearRate, 0, 1, 1);

  	      if (type !== "Tag") {
  	        wearRate = 1;
  	      }

  	      return {
  	        Axle: axleNo,
  	        Type: type,
  	        TyresPerSide: tyresPerSide,
  	        WearRate: wearRate,
  	        Enabled: axle && axle.Enabled === false ? false: true
  	      };
  	    }

  	    function applyAxleRules(tPositions, showAlerts) {
  	      var vehicleType;
  	      var allowed;
  	      var steerCount = 0;
  	      var unsupportedChanged = false;
  	      var steerLimitChanged = false;
  	      var lockedChanged = false;

  	      if (!tPositions || typeof tPositions !== "object") {
  	        return tPositions;
  	      }

  	      vehicleType = tPositions.VehicleType || VEHICLE_TYPE;
  	      allowed = allowedAxleTypes(vehicleType);

  	      tPositions.Axles = arr(tPositions.Axles).map(function (axle, index) {
  	        var cleanAxle = normaliseAxle(axle, index + 1, vehicleType);

  	        if (allowed.indexOf(cleanAxle.Type) === -1) {
  	          cleanAxle.Type = defaultAxleType(vehicleType);
  	          unsupportedChanged = true;
  	        }

  	        if (vehicleType === "Tractor" && cleanAxle.Type === "Trailer") {
  	          cleanAxle.Type = "Drive";
  	          unsupportedChanged = true;
  	        }

  	        if (
  	          vehicleType === "Trailer" &&
  	          ["Steer", "Drive", "Tag"].indexOf(cleanAxle.Type) !== -1
  	        ) {
  	          cleanAxle.Type = "Trailer";
  	          unsupportedChanged = true;
  	        }

  	        if (cleanAxle.Type === "Steer") {
  	          steerCount += 1;

  	          if (steerCount > 2) {
  	            cleanAxle.Type = "Tag";
  	            cleanAxle.WearRate = 1;
  	            steerLimitChanged = true;
  	          }
  	        }

  	        if (
  	          (cleanAxle.Type === "Steer" || cleanAxle.Type === "Spare") &&
  	          cleanAxle.TyresPerSide !== 1
  	        ) {
  	          cleanAxle.TyresPerSide = 1;
  	          lockedChanged = true;
  	        }

  	        if (cleanAxle.Type === "Tag") {
  	          cleanAxle.WearRate = clamp(cleanAxle.WearRate, 0, 1, 1);
  	        } else {
  	          cleanAxle.WearRate = 1;
  	        }

  	        return cleanAxle;
  	      });

  	      if (showAlerts && unsupportedChanged) {
  	        alertSafe("Invalid axle type removed. Tractors cannot use Trailer axles.");
  	      }

  	      if (showAlerts && steerLimitChanged) {
  	        alertSafe("A tractor cannot have more than 2 Steer axles. Extra Steer axles were changed to Tag.");
  	      }

  	      if (showAlerts && lockedChanged) {
  	        alertSafe("Steer and Spare axles are locked to 1 tyre.");
  	      }

  	      return tPositions;
  	    }

  	    function emptyTPositions() {
  	      return {
  	        SchemaVersion: SCHEMA_VERSION,
  	        VehicleType: VEHICLE_TYPE,
  	        Axles: [],
  	        Positions: {},
  	        Summary: {
  	          TotalAxles: 0,
  	          TotalPositions: 0,
  	          AssignedTyres: 0,
  	          EmptyPositions: 0
  	        },
  	        UpdatedAt: "",
  	        UpdatedBy: ""
  	      };
  	    }

  	    function tPositionsFieldName(vehicle) {
  	      if (!vehicle || typeof vehicle !== "object") {
  	        return TPOSITIONS_PRIMARY;
  	      }

  	      if (Object.prototype.hasOwnProperty.call(vehicle, TPOSITIONS_PRIMARY)) {
  	        return TPOSITIONS_PRIMARY;
  	      }

  	      if (Object.prototype.hasOwnProperty.call(vehicle, TPOSITIONS_SECONDARY)) {
  	        return TPOSITIONS_SECONDARY;
  	      }

  	      if (
  	        vehicle.Data &&
  	        Object.prototype.hasOwnProperty.call(vehicle.Data, TPOSITIONS_PRIMARY)
  	      ) {
  	        return TPOSITIONS_PRIMARY;
  	      }

  	      if (
  	        vehicle.Data &&
  	        Object.prototype.hasOwnProperty.call(vehicle.Data, TPOSITIONS_SECONDARY)
  	      ) {
  	        return TPOSITIONS_SECONDARY;
  	      }

  	      return TPOSITIONS_PRIMARY;
  	    }

  	    function readTPositionsRaw(vehicle) {
  	      if (!vehicle) {
  	        return null;
  	      }

  	      if (vehicle[TPOSITIONS_PRIMARY] !== null && vehicle[TPOSITIONS_PRIMARY] !== undefined) {
  	        return vehicle[TPOSITIONS_PRIMARY];
  	      }

  	      if (vehicle[TPOSITIONS_SECONDARY] !== null && vehicle[TPOSITIONS_SECONDARY] !== undefined) {
  	        return vehicle[TPOSITIONS_SECONDARY];
  	      }

  	      if (
  	        vehicle.Data &&
  	        vehicle.Data[TPOSITIONS_PRIMARY] !== null &&
  	        vehicle.Data[TPOSITIONS_PRIMARY] !== undefined
  	      ) {
  	        return unwrap(vehicle.Data[TPOSITIONS_PRIMARY]);
  	      }

  	      if (
  	        vehicle.Data &&
  	        vehicle.Data[TPOSITIONS_SECONDARY] !== null &&
  	        vehicle.Data[TPOSITIONS_SECONDARY] !== undefined
  	      ) {
  	        return unwrap(vehicle.Data[TPOSITIONS_SECONDARY]);
  	      }

  	      return null;
  	    }

  	    function positionKey(axleNo, sideCode, tyreIndex) {
  	      return "A" + Number(axleNo || 0) + String(sideCode || "").toUpperCase() + Number(tyreIndex || 1);
  	    }

  	    function spareKey(index) {
  	      return "SP" + Number(index || 1);
  	    }

  	    function createSlot(key, axle, side, sideCode, tyreIndex, existing) {
  	      var old = existing && typeof existing === "object" ? existing: {};
  	      var tyreId = old.TyreObjectId || old.tyreObjectId || "";

  	      return {
  	        PositionKey: key,
  	        Axle: axle.Axle,
  	        AxleType: axle.Type,
  	        Side: side,
  	        SideCode: sideCode,
  	        TyreIndex: tyreIndex,
  	        TyresPerSide: axle.TyresPerSide,
  	        WearRate: axle.Type === "Tag" ? axle.WearRate: 1,

  	        TyreObjectId: tyreId,
  	        TyreNumber: old.TyreNumber || old.Tyre_Number || "",
  	        SerialNumber: old.SerialNumber || old.Serial_Number || "",

  	        Status: tyreId ? "Fitted": "Empty",
  	        UpdatedAt: old.UpdatedAt || "",
  	        Notes: old.Notes || ""
  	      };
  	    }

  	    function summaryForTPositions(tPositions) {
  	      var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	      var keys = Object.keys(positions);
  	      var assigned = keys.filter(function (key) {
  	        return !!(positions[key] && positions[key].TyreObjectId);
  	      }).length;

  	      return {
  	        TotalAxles: arr(tPositions && tPositions.Axles).filter(function (axle) {
  	          return axle && axle.Enabled !== false;
  	        }).length,
  	        TotalPositions: keys.length,
  	        AssignedTyres: assigned,
  	        EmptyPositions: keys.length - assigned
  	      };
  	    }

  	    function rebuildSlots(tPositions) {
  	      var oldPositions;
  	      var newPositions = {};
  	      var spareCounter = 1;

  	      if (!tPositions || typeof tPositions !== "object") {
  	        return tPositions;
  	      }

  	      applyAxleRules(tPositions, false);

  	      oldPositions =
  	      tPositions.Positions && typeof tPositions.Positions === "object"
  	      ? tPositions.Positions: {};

  	      tPositions.Axles = arr(tPositions.Axles)
  	      .filter(function (axle) {
  	        return axle && axle.Enabled !== false;
  	      })
  	      .map(function (axle, index) {
  	        return normaliseAxle(axle, index + 1, tPositions.VehicleType || VEHICLE_TYPE);
  	      })
  	      .sort(function (a, b) {
  	        return Number(a.Axle) - Number(b.Axle);
  	      });

  	      applyAxleRules(tPositions, false);

  	      tPositions.Axles.forEach(function (axle) {
  	        var i;
  	        var key;

  	        if (axle.Type === "Spare") {
  	          key = spareKey(spareCounter);
  	          spareCounter += 1;

  	          newPositions[key] = createSlot(key, axle, "Spare", "SP", 1, oldPositions[key]);
  	          return;
  	        }

  	        for (i = 1; i <= axle.TyresPerSide; i++) {
  	          key = positionKey(axle.Axle, "L", i);
  	          newPositions[key] = createSlot(key, axle, "Left", "L", i, oldPositions[key]);
  	        }

  	        for (i = 1; i <= axle.TyresPerSide; i++) {
  	          key = positionKey(axle.Axle, "R", i);
  	          newPositions[key] = createSlot(key, axle, "Right", "R", i, oldPositions[key]);
  	        }
  	      });

  	      tPositions.Positions = newPositions;
  	      tPositions.Summary = summaryForTPositions(tPositions);

  	      return tPositions;
  	    }

  	    function normaliseTPositions(raw) {
  	      var base = emptyTPositions();
  	      var parsed = parseJson(raw,
  	        base);
  	      var tPositions = {
  	        SchemaVersion: parsed.SchemaVersion || SCHEMA_VERSION,
  	        VehicleType: VEHICLE_TYPE,
  	        Axles: [],
  	        Positions:
  	        parsed.Positions && typeof parsed.Positions === "object"
  	        ? clone(parsed.Positions): {},
  	        Summary:
  	        parsed.Summary && typeof parsed.Summary === "object"
  	        ? clone(parsed.Summary): clone(base.Summary),
  	        UpdatedAt: parsed.UpdatedAt || "",
  	        UpdatedBy: parsed.UpdatedBy || ""
  	      };

  	      if (Array.isArray(parsed.Axles)) {
  	        tPositions.Axles = parsed.Axles.map(function (axle, index) {
  	          return normaliseAxle(axle, index + 1, tPositions.VehicleType);
  	        });
  	      }

  	      applyAxleRules(tPositions, false);
  	      rebuildSlots(tPositions);

  	      return tPositions;
  	    }

  	    function sortedPositionKeys(tPositions) {
  	      var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	      return Object.keys(positions).sort(function (a, b) {
  	        var pa = positions[a] || {};
  	        var pb = positions[b] || {};
  	        var aSpare = String(a).indexOf("SP") === 0;
  	        var bSpare = String(b).indexOf("SP") === 0;
  	        var sideOrder = {
  	          L: 1, R: 2, SP: 3
  	        };
  	        var sideA;
  	        var sideB;

  	        if (aSpare && !bSpare) return 1;
  	        if (!aSpare && bSpare) return -1;

  	        if (Number(pa.Axle || 999) !== Number(pb.Axle || 999)) {
  	          return Number(pa.Axle || 999) - Number(pb.Axle || 999);
  	        }

  	        sideA = sideOrder[pa.SideCode] || 99;
  	        sideB = sideOrder[pb.SideCode] || 99;

  	        if (sideA !== sideB) {
  	          return sideA - sideB;
  	        }

  	        return Number(pa.TyreIndex || 0) - Number(pb.TyreIndex || 0);
  	      });
  	    }

  	    function assignedTyreIds(tPositions) {
  	      var ids = [];
  	      var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	      Object.keys(positions).forEach(function (key) {
  	        var id = clean(positions[key] && positions[key].TyreObjectId);

  	        if (id && ids.indexOf(id) === -1) {
  	          ids.push(id);
  	        }
  	      });

  	      return ids;
  	    }

  	    function assignedTyreObjects(tPositions) {
  	      return assignedTyreIds(tPositions)
  	      .map(function (id) {
  	        return findTyre(id);
  	      })
  	      .filter(Boolean);
  	    }

  	    function cleanTPositionsForSave(tPositions) {
  	      var cleaned = clone(tPositions);

  	      cleaned.SchemaVersion = SCHEMA_VERSION;
  	      cleaned.VehicleType = VEHICLE_TYPE;
  	      cleaned.UpdatedAt = new Date().toISOString();

  	      applyAxleRules(cleaned,
  	        false);
  	      rebuildSlots(cleaned);

  	      cleaned.Summary = summaryForTPositions(cleaned);

  	      return cleaned;
  	    }

  	    function writeTPositionsToVehicle(vehicle,
  	      tPositions) {
  	      var cleaned = cleanTPositionsForSave(tPositions);
  	      var field = tPositionsFieldName(vehicle);
  	      var other = field === TPOSITIONS_PRIMARY ? TPOSITIONS_SECONDARY: TPOSITIONS_PRIMARY;

  	      vehicle[field] = cleaned;

  	      if (Object.prototype.hasOwnProperty.call(vehicle, other)) {
  	        vehicle[other] = cleaned;
  	      }

  	      vehicle[TYRES_RELATION] = assignedTyreObjects(cleaned);

  	      return vehicle;
  	    }

  	    function getSlot(tPositions, key) {
  	      var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	      var cleanKey = clean(key);
  	      var keys;
  	      var i;

  	      if (!cleanKey) {
  	        return null;
  	      }

  	      if (positions[cleanKey]) {
  	        return positions[cleanKey];
  	      }

  	      keys = Object.keys(positions);

  	      for (i = 0; i < keys.length; i++) {
  	        if (positions[keys[i]] && positions[keys[i]].PositionKey === cleanKey) {
  	          return positions[keys[i]];
  	        }
  	      }

  	      return null;
  	    }

  	    function clearSlot(slot) {
  	      if (!slot) {
  	        return;
  	      }

  	      slot.TyreObjectId = "";
  	      slot.TyreNumber = "";
  	      slot.SerialNumber = "";
  	      slot.Status = "Empty";
  	      slot.UpdatedAt = new Date().toISOString();
  	    }

  	    function fitSlot(slot, tyre) {
  	      if (!slot || !tyre) {
  	        return;
  	      }

  	      slot.TyreObjectId = tyreObjectId(tyre);
  	      slot.TyreNumber = tyreNumber(tyre);
  	      slot.SerialNumber = tyreSerial(tyre);
  	      slot.Status = "Fitted";
  	      slot.UpdatedAt = new Date().toISOString();
  	    }

  	    function copySlotTyre(fromSlot, toSlot) {
  	      if (!fromSlot || !toSlot) {
  	        return;
  	      }

  	      toSlot.TyreObjectId = fromSlot.TyreObjectId || "";
  	      toSlot.TyreNumber = fromSlot.TyreNumber || "";
  	      toSlot.SerialNumber = fromSlot.SerialNumber || "";
  	      toSlot.Status = toSlot.TyreObjectId ? "Fitted": "Empty";
  	      toSlot.UpdatedAt = new Date().toISOString();
  	    }

  	    function slotsForAxle(tPositions, axleNo, sideCode) {
  	      var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	      return Object.keys(positions)
  	      .map(function (key) {
  	        var slot = clone(positions[key]);
  	        slot.PositionKey = slot.PositionKey || key;
  	        return slot;
  	      })
  	      .filter(function (slot) {
  	        return Number(slot.Axle || 0) === Number(axleNo) &&
  	        String(slot.SideCode || "").toUpperCase() === String(sideCode).toUpperCase();
  	      })
  	      .sort(function (a, b) {
  	        return Number(a.TyreIndex || 0) - Number(b.TyreIndex || 0);
  	      });
  	    }

  	    function spareSlots(tPositions) {
  	      var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	      return Object.keys(positions)
  	      .map(function (key) {
  	        var slot = clone(positions[key]);
  	        slot.PositionKey = slot.PositionKey || key;
  	        return slot;
  	      })
  	      .filter(function (slot) {
  	        return String(slot.SideCode || "").toUpperCase() === "SP" ||
  	        String(slot.PositionKey || "").indexOf("SP") === 0;
  	      });
  	    }

  	    function blankHistoryStage(active) {
  	      return {
  	        CPK: 0,
  	        Cost: 0,
  	        Ended: "",
  	        Notes: "",
  	        Active: !!active,
  	        Events: [],
  	        Status: active ? "Active": "Not Started",
  	        Started: active ? new Date().toISOString(): "",
  	        End_Mileage: 0,
  	        Mileage_Done: 0,
  	        Start_Mileage: 0,
  	        Mileage_Expected: 0
  	      };
  	    }

  	    function defaultHistory(tyre) {
  	      var stage = clean(tyre && tyre.Current_Stage) || "New";

  	      return {
  	        New: blankHistoryStage(stage === "New"),
  	        Cap1: blankHistoryStage(stage === "Cap1"),
  	        Cap2: blankHistoryStage(stage === "Cap2"),
  	        Cap3: blankHistoryStage(stage === "Cap3"),
  	        Totals: {
  	          Cost_Total: numberOrNull(tyre && tyre.Total_Cost) || 0,
  	          Average_CPK: numberOrNull(tyre && tyre.Total_CPK) || 0,
  	          Mileage_Total: numberOrNull(tyre && tyre.Total_Mileage) || 0,
  	          Total_Life_Stages_Used: 1
  	        },
  	        Current: {
  	          Stage: stage
  	        }
  	      };
  	    }

  	    function normaliseHistory(tyre) {
  	      var fallback = defaultHistory(tyre);
  	      var history = parseJson(tyre && tyre.History, fallback);

  	      ["New",
  	        "Cap1",
  	        "Cap2",
  	        "Cap3"].forEach(function (stage) {
  	          if (!history[stage] || typeof history[stage] !== "object") {
  	            history[stage] = clone(fallback[stage]);
  	          }

  	          if (!Array.isArray(history[stage].Events)) {
  	            history[stage].Events = [];
  	          }
  	        });

  	      if (!history.Totals || typeof history.Totals !== "object") {
  	        history.Totals = clone(fallback.Totals);
  	      }

  	      if (!history.Current || typeof history.Current !== "object") {
  	        history.Current = {
  	          Stage: clean(tyre && tyre.Current_Stage) || "New"
  	        };
  	      }

  	      return history;
  	    }

  	    function appendHistoryEvent(tyre, event) {
  	      var updated = clone(tyre);
  	      var history = normaliseHistory(updated);
  	      var stage = clean(updated.Current_Stage) || clean(history.Current.Stage) || "New";

  	      if (!history[stage] || typeof history[stage] !== "object") {
  	        history[stage] = blankHistoryStage(true);
  	      }

  	      if (!Array.isArray(history[stage].Events)) {
  	        history[stage].Events = [];
  	      }

  	      history[stage].Events.push(event);

  	      history.Current.Stage = stage;
  	      history.Current.Last_Event_Type = event.Type || "";
  	      history.Current.Last_Event_Date = event.Date || "";
  	      history.Current.Vehicle_ObjectId = updated.Vehicle_ObjectId || "";
  	      history.Current.Vehicle_ID = updated.Vehicle_ID || "";
  	      history.Current.Position = updated.Current_Position || "";
  	      history.Current.Axle_Type = updated.Current_Axle_Type || "";
  	      history.Current.Wear_Rate = updated.Current_Wear_Rate || "";

  	      history.Totals.Cost_Total = numberOrNull(updated.Total_Cost) || history.Totals.Cost_Total || 0;
  	      history.Totals.Average_CPK = numberOrNull(updated.Total_CPK) || history.Totals.Average_CPK || 0;
  	      history.Totals.Mileage_Total = numberOrNull(updated.Total_Mileage) || history.Totals.Mileage_Total || 0;

  	      updated.History = history;

  	      return updated;
  	    }

  	    function createTyreEvent(type, options) {
  	      options = options || {};

  	      return {
  	        Date: new Date().toISOString(),
  	        Type: type,
  	        Vehicle_ObjectId: vehicleObjectId(state.activeTractor),
  	        Vehicle_ID: vehicleId(state.activeTractor),
  	        FromPosition: options.FromPosition || "",
  	        ToPosition: options.ToPosition || "",
  	        Odometer: options.Odometer || "",
  	        Destination: options.Destination || "",
  	        WearRate: options.WearRate === null || options.WearRate === undefined ? "": options.WearRate,
  	        CapturedBy: "Tractor Manager",
  	        Notes: options.Notes || "",

  	        Mismatch_Accepted: !!options.Mismatch_Accepted,
  	        Required_Type: options.Required_Type || "",
  	        Actual_Type: options.Actual_Type || "",
  	        Mismatch_Approved_Date: options.Mismatch_Approved_Date || "",
  	        Mismatch_Reason: options.Mismatch_Reason || ""
  	      };
  	    }

  	    var TYRE_EXPRESSION_FIELDS = [
  	      "Warehouse",
  	      "Current_CPK",
  	      "Total_CPK",
  	      "Current_Life",
  	      "Total_Mileage",
  	      "Mileage_Warning",
  	      "Total_Cost",
  	      "Expected_CPK",
  	      "Remaining_Mileage"
  	    ];

  	    var TYRE_READ_ONLY_FIELDS = [
  	      "created",
  	      "updated",
  	      "ownerId",
  	      "___class"
  	    ];

  	    function cleanTyreForSave(tyre) {
  	      var payload = clone(tyre);

  	      TYRE_EXPRESSION_FIELDS.concat(TYRE_READ_ONLY_FIELDS).forEach(function (field) {
  	        if (Object.prototype.hasOwnProperty.call(payload, field)) {
  	          delete payload[field];
  	        }
  	      });

  	      return payload;
  	    }

  	    function makeTyreFitted(tyre,
  	      slot,
  	      odometer,
  	      notes,
  	      eventType,
  	      fromPosition) {
  	      var updated = clone(tyre);
  	      var event;

  	      updated.Vehicle_ObjectId = vehicleObjectId(state.activeTractor) || null;
  	      updated.Vehicle_ID = vehicleId(state.activeTractor) || null;
  	      updated.Vehicle_Type = VEHICLE_TYPE;

  	      updated.Current_Position = slot.PositionKey;
  	      updated.Current_Axle_Type = slot.AxleType;
  	      updated.Current_Wear_Rate = slot.WearRate === null || slot.WearRate === undefined ? 1: slot.WearRate;

  	      updated.Status = TYRE_STATUS.OK;

  	      if (eventType === "Installed" || !updated.Fitted_Date) {
  	        updated.Fitted_Date = new Date().toISOString();
  	      }

  	      if (odometer !== "") {
  	        updated.Fitted_Odometer = odometer;
  	        updated.Last_Vehicle_Odometer = odometer;
  	      }

  	      var mismatchApproval = getMismatchApproval(tyreObjectId(updated), slot.PositionKey);
  	      var finalNotes = notes || "";

  	      if (mismatchApproval) {
  	        finalNotes = clean(finalNotes + " " + mismatchSummaryForHistory(updated, slot));
  	      }

  	      event = createTyreEvent(eventType || "Installed", {
  	        FromPosition: fromPosition || "",
  	        ToPosition: slot.PositionKey,
  	        Odometer: odometer,
  	        WearRate: slot.WearRate,
  	        Notes: finalNotes,

  	        Mismatch_Accepted: !!mismatchApproval,
  	        Required_Type: mismatchApproval ? mismatchApproval.Required_Type: "",
  	        Actual_Type: mismatchApproval ? mismatchApproval.Actual_Type: "",
  	        Mismatch_Approved_Date: mismatchApproval ? mismatchApproval.Date: "",
  	        Mismatch_Reason: mismatchApproval ? mismatchApproval.Reason: ""
  	      });

  	      updated = appendHistoryEvent(updated, event);

  	      return updated;
  	    }

  	    function makeTyreRemoved(tyre, slot, destination, odometer, notes) {
  	      var updated = clone(tyre);
  	      var status = TYRE_STATUS.OK;
  	      var destinationLabel = destination || "Warehouse";

  	      if (destination === "Retread") {
  	        status = TYRE_STATUS.RETREAD;
  	        destinationLabel = "In For Retread";
  	      }

  	      if (destination === "Scrap") {
  	        status = TYRE_STATUS.SCRAPPED;
  	        destinationLabel = "Scrapped";
  	      }

  	      if (destination === "Stolen") {
  	        status = TYRE_STATUS.STOLEN;
  	        destinationLabel = "Stolen";
  	      }

  	      updated.Vehicle_ObjectId = null;
  	      updated.Vehicle_ID = null;
  	      updated.Vehicle_Type = null;

  	      updated.Current_Position = null;
  	      updated.Current_Axle_Type = null;
  	      updated.Current_Wear_Rate = null;

  	      updated.Fitted_Date = null;
  	      updated.Fitted_Odometer = null;

  	      updated.Status = status;

  	      if (odometer !== "") {
  	        updated.Last_Vehicle_Odometer = odometer;
  	      }

  	      updated = appendHistoryEvent(updated, createTyreEvent("Removed", {
  	        FromPosition: slot.PositionKey,
  	        ToPosition: "",
  	        Odometer: odometer,
  	        Destination: destinationLabel,
  	        WearRate: slot.WearRate,
  	        Notes: notes
  	      }));

  	      return updated;
  	    }

  	    function makeTyreMoved(tyre, fromSlot, toSlot, odometer, notes, eventType) {
  	      var updated = clone(tyre);

  	      updated.Vehicle_ObjectId = vehicleObjectId(state.activeTractor) || null;
  	      updated.Vehicle_ID = vehicleId(state.activeTractor) || null;
  	      updated.Vehicle_Type = VEHICLE_TYPE;

  	      updated.Current_Position = toSlot.PositionKey;
  	      updated.Current_Axle_Type = toSlot.AxleType;
  	      updated.Current_Wear_Rate = toSlot.WearRate === null || toSlot.WearRate === undefined ? 1: toSlot.WearRate;

  	      updated.Status = TYRE_STATUS.OK;

  	      if (odometer !== "") {
  	        updated.Last_Vehicle_Odometer = odometer;
  	      }

  	      var mismatchApproval = getMismatchApproval(tyreObjectId(updated), toSlot.PositionKey);
  	      var finalNotes = notes || "";

  	      if (mismatchApproval) {
  	        finalNotes = clean(finalNotes + " " + mismatchSummaryForHistory(updated, toSlot));
  	      }

  	      updated = appendHistoryEvent(updated, createTyreEvent(eventType || "Rotation", {
  	        FromPosition: fromSlot.PositionKey,
  	        ToPosition: toSlot.PositionKey,
  	        Odometer: odometer,
  	        WearRate: toSlot.WearRate,
  	        Notes: finalNotes,

  	        Mismatch_Accepted: !!mismatchApproval,
  	        Required_Type: mismatchApproval ? mismatchApproval.Required_Type: "",
  	        Actual_Type: mismatchApproval ? mismatchApproval.Actual_Type: "",
  	        Mismatch_Approved_Date: mismatchApproval ? mismatchApproval.Date: "",
  	        Mismatch_Reason: mismatchApproval ? mismatchApproval.Reason: ""
  	      }));

  	      return updated;
  	    }

  	    function saveTyresSequentially(tyres) {
  	      var saved = [];
  	      var store;

  	      tyres = arr(tyres).filter(function (tyre) {
  	        return tyre && tyreObjectId(tyre);
  	      });

  	      if (!tyres.length) {
  	        return Promise.resolve([]);
  	      }

  	      if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	        return Promise.reject(new Error("Backendless is unavailable. Cannot save tyre records."));
  	      }

  	      store = BackendlessApi.Data.of(TABLE_TYRES);

  	      return tyres.reduce(function (chain, tyre) {
  	        return chain.then(function () {
  	          var payload = cleanTyreForSave(tyre);

  	          return store.save(payload).then(function (row) {
  	            row = row && typeof row === "object" ? row: tyre;

  	            saved.push(row);
  	            upsertTyre(row);

  	            return row;
  	          });
  	        });
  	      }, Promise.resolve()).then(function () {
  	        return saved;
  	      });
  	    }

  	    function removeTyreRelationForSave(vehicle) {
  	      var payload = clone(vehicle);

  	      delete payload[TYRES_RELATION];

  	      return payload;
  	    }

  	    function syncTyreRelation(vehicle, tPositions) {
  	      var store;
  	      var refs;

  	      if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	        return Promise.resolve({
  	          skipped: true,
  	          reason: "Backendless unavailable"
  	        });
  	      }

  	      store = BackendlessApi.Data.of(TABLE_TRACTORS);

  	      if (!store || typeof store.setRelation !== "function") {
  	        return Promise.resolve({
  	          skipped: true,
  	          reason: "setRelation unavailable"
  	        });
  	      }

  	      refs = assignedTyreIds(tPositions).map(function (id) {
  	        return {
  	          objectId: id
  	        };
  	      });

  	      return store.setRelation(vehicle, TYRES_RELATION, refs).catch(function (firstError) {
  	        var objectId = vehicleObjectId(vehicle);

  	        if (!objectId) {
  	          throw firstError;
  	        }

  	        return store.setRelation(objectId, TYRES_RELATION, refs);
  	      });
  	    }

  	    function syncTractorIntoAppData(updated) {
  	      var updatedObjectId = vehicleObjectId(updated);
  	      var updatedId = vehicleId(updated);
  	      var i;

  	      for (i = 0; i < state.tractorArray.length; i++) {
  	        if (
  	          vehicleObjectId(state.tractorArray[i]) === updatedObjectId ||
  	          (updatedId && vehicleId(state.tractorArray[i]) === updatedId)
  	        ) {
  	          state.tractorArray[i] = updated;
  	          break;
  	        }
  	      }

  	      try {
  	        arr(App && App.User && App.User.Companies).forEach(function (company) {
  	          var tractors = arr(company.Tractors);

  	          for (var j = 0; j < tractors.length; j++) {
  	            if (
  	              vehicleObjectId(tractors[j]) === updatedObjectId ||
  	              (updatedId && vehicleId(tractors[j]) === updatedId)
  	            ) {
  	              company.Tractors[j] = updated;
  	              break;
  	            }
  	          }
  	        });
  	      } catch (error) {

  	      }
  	    }

  	    function saveVehicleWithTPositions(vehicle,
  	      tPositions) {
  	      var payload;

  	      if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	        return Promise.reject(new Error("Backendless is unavailable. Cannot save tractor."));
  	      }

  	      payload = removeTyreRelationForSave(vehicle);

  	      return BackendlessApi.Data.of(TABLE_TRACTORS).save(payload).then(function (saved) {
  	        saved = saved && typeof saved === "object" ? saved: payload;

  	        return syncTyreRelation(saved, tPositions).then(function () {
  	          saved[TYRES_RELATION] = assignedTyreObjects(tPositions);

  	          Object.assign(vehicle, saved);

  	          if (
  	            state.activeTractor &&
  	            (
  	              vehicleObjectId(state.activeTractor) === vehicleObjectId(saved) ||
  	              vehicleId(state.activeTractor) === vehicleId(saved)
  	            )
  	          ) {
  	            Object.assign(state.activeTractor, saved);
  	          }

  	          syncTractorIntoAppData(saved);

  	          return saved;
  	        });
  	      });
  	    }

  	    function saveVehicleOnly(vehicle) {
  	      var payload;

  	      if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	        return Promise.reject(new Error("Backendless is unavailable. Cannot save tractor."));
  	      }

  	      payload = removeTyreRelationForSave(vehicle);

  	      return BackendlessApi.Data.of(TABLE_TRACTORS).save(payload).then(function (saved) {
  	        saved = saved && typeof saved === "object" ? saved: payload;

  	        Object.assign(vehicle, saved);

  	        if (
  	          state.activeTractor &&
  	          (
  	            vehicleObjectId(state.activeTractor) === vehicleObjectId(saved) ||
  	            vehicleId(state.activeTractor) === vehicleId(saved)
  	          )
  	        ) {
  	          Object.assign(state.activeTractor, saved);
  	        }

  	        syncTractorIntoAppData(saved);

  	        return saved;
  	      });
  	    }

  	    function appendTyreMovementRecord(vehicle,
  	      record) {
  	      if (!vehicle.Data) {
  	        vehicle.Data = {};
  	      }

  	      ensureArrayPath(vehicle, ["Data", "Tyres", "TyreRecords"]).push(record);
  	    }

  	    function tyreMovementRecord(type, fromPosition, toPosition, tyre, odometer, notes) {
  	      return {
  	        date: new Date().toISOString(),
  	        type: type,
  	        fromPosition: fromPosition || "",
  	        toPosition: toPosition || "",
  	        tyre: tyreName(tyre),
  	        tyreObjectId: tyreObjectId(tyre),
  	        odometer: odometer || "",
  	        notes: notes || ""
  	      };
  	    }

  	    function scanVehicleForTyre(vehicle, tyreId, currentVehicleObjectId) {
  	      var tPositions;
  	      var positions;
  	      var keys;
  	      var vehicleObjId;
  	      var slot;
  	      var i;

  	      tyreId = clean(tyreId);

  	      if (!vehicle || !tyreId) {
  	        return null;
  	      }

  	      vehicleObjId = vehicleObjectId(vehicle);

  	      if (
  	        currentVehicleObjectId &&
  	        vehicleObjId &&
  	        String(vehicleObjId) === String(currentVehicleObjectId)
  	      ) {
  	        return null;
  	      }

  	      tPositions = normaliseTPositions(readTPositionsRaw(vehicle));
  	      positions = tPositions.Positions || {};
  	      keys = Object.keys(positions);

  	      for (i = 0; i < keys.length; i++) {
  	        slot = positions[keys[i]];

  	        if (slot && String(slot.TyreObjectId || "") === tyreId) {
  	          return {
  	            vehicle: vehicle,
  	            vehicleObjectId: vehicleObjId,
  	            vehicleLabel: vehicleTitle(vehicle),
  	            positionKey: slot.PositionKey || keys[i]
  	          };
  	        }
  	      }

  	      return null;
  	    }

  	    function findTyreFleetAssignment(tyreId) {
  	      var currentVehicleObjectId = vehicleObjectId(state.activeTractor);
  	      var found = null;

  	      try {
  	        arr(App && App.User && App.User.Companies).some(function (company) {
  	          var stop = false;

  	          arr(company.Tractors).some(function (tractor) {
  	            found = scanVehicleForTyre(tractor, tyreId, currentVehicleObjectId);
  	            stop = !!found;
  	            return stop;
  	          });

  	          if (stop) {
  	            return true;
  	          }

  	          arr(company.Trailers).some(function (trailer) {
  	            found = scanVehicleForTyre(trailer, tyreId, currentVehicleObjectId);
  	            stop = !!found;
  	            return stop;
  	          });

  	          return stop;
  	        });
  	      } catch (error) {

  	      }

  	      return found;
  	    }



  	    function allAvailableWarehouseTyres() {
  	      return state.tyreArray.filter(function (tyre) {
  	        var id = tyreObjectId(tyre);

  	        if (!id) {
  	          return false;
  	        }

  	        if (!isTyreAvailable(tyre)) {
  	          return false;
  	        }

  	        if (findTyreFleetAssignment(id)) {
  	          return false;
  	        }

  	        if (
  	          (state.actionMode === "Allocate" || state.actionMode === "RotateSwap") &&
  	          warehouseTyreAlreadyInDraft(id)
  	        ) {
  	          return false;
  	        }

  	        return true;
  	      });
  	    }





  	    function clearPendingTyreAction() {
  	      state.pendingTyreAction = null;
  	      state.dragSource = null;
  	      state.tapSource = null;
  	      state.actionMessage = "";
  	      state.actionError = false;
  	    }

  	    function closeFloatingPopup(id) {
  	      var popup;

  	      if (!DocumentSafe || !id) {
  	        return;
  	      }

  	      popup = DocumentSafe.getElementById(id);

  	      if (popup && popup.parentNode) {
  	        popup.parentNode.removeChild(popup);
  	      }
  	    }



  	    function lockTyreMovementState(message) {
  	      var allocateMount;

  	      clearPendingTyreAction();
  	      resetRotationPlan();

  	      state.actionMode = "";
  	      state.allocatePopupOpen = false;
  	      state.allocateSelectedTyreId = "";
  	      state.allocateSearch = "";
  	      state.allocateTypeFilter = "";
  	      state.rotationPopupOpen = false;
  	      state.pendingTyreAction = null;
  	      state.dragSource = null;
  	      state.tapSource = null;
  	      state.selectedPosition = "";
  	      state.mismatchApprovals = {};

  	      closeAllTyrePopups();

  	      allocateMount = DocumentSafe.getElementById("allocateTyreInlineMount");

  	      if (allocateMount) {
  	        allocateMount.innerHTML = "";
  	      }

  	      state.actionMessage = message || "";
  	      state.actionError = false;

  	      if (typeof state.__rerenderTyreEditor === "function") {
  	        state.__rerenderTyreEditor();
  	        return;
  	      }

  	      requestTyreTabRerender();
  	    }

  	    function closeAllTyrePopups() {
  	      closeFloatingPopup("allocateTyrePopup");
  	      closeFloatingPopup("allocationPlanPopup");
  	      closeFloatingPopup("rotationSavePopup");
  	      closeFloatingPopup("removeTyrePopup");
  	    }

  	    function requestTyreTabRerender() {
  	      try {
  	        if (typeof renderVisualTyreOperations === "function") {
  	          renderVisualTyreOperations();
  	          return true;
  	        }
  	      } catch (error) {

  	      }

  	      try {
  	        if (typeof renderTab === "function") {
  	          renderTab("Tyres");
  	          return true;
  	        }
  	      } catch (error2) {

  	      }

  	      try {
  	        if (
  	          state &&
  	          state.allocatePopupOpen &&
  	          typeof renderAllocatePopup === "function"
  	        ) {
  	          renderAllocatePopup();
  	          return true;
  	        }
  	      } catch (error3) {

  	      }

  	      return false;
  	    }

  	    function enterRotateSwapAfterAllocate(message) {
  	      state.allocatePopupOpen = false;
  	      state.allocateSelectedTyreId = "";
  	      state.pendingTyreAction = null;
  	      state.dragSource = null;
  	      state.tapSource = null;

  	      closeFloatingPopup("allocateTyrePopup");

  	      state.actionMode = "RotateSwap";
  	      state.rotationPopupOpen = false;
  	      closeFloatingPopup("rotationSavePopup");

  	      beginRotationPlan();

  	      state.actionMessage = message || "Allocate finished. Rotate / Swap unlocked. Drag fitted tyres directly on the vehicle layout.";
  	      state.actionError = false;

  	      requestTyreTabRerender();
  	    }









  	    function createPendingAction(sourceType,
  	      tyreId,
  	      sourcePosition,
  	      targetPosition) {
  	      var tPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	      var sourceSlot = sourcePosition ? getSlot(tPositions,
  	        sourcePosition): null;
  	      var targetSlot = targetPosition ? getSlot(tPositions,
  	        targetPosition): null;
  	      var tyre = findTyre(tyreId);
  	      var targetTyre = null;
  	      var actionType = "";
  	      var preview = "";
  	      var existingAssignment;

  	      tyreId = clean(tyreId);
  	      sourcePosition = clean(sourcePosition);
  	      targetPosition = clean(targetPosition);

  	      if (!state.activeTractor) {
  	        throw new Error("No tractor selected.");
  	      }

  	      if (!tyreId) {
  	        throw new Error("No tyre selected.");
  	      }

  	      if (!targetPosition || !targetSlot) {
  	        throw new Error("Drop the tyre onto a valid position.");
  	      }

  	      if (!tyre) {
  	        throw new Error("The selected tyre record could not be found.");
  	      }

  	      if (sourceType === "fitted") {
  	        if (!sourcePosition || !sourceSlot) {
  	          throw new Error("The fitted tyre source position could not be found.");
  	        }

  	        if (sourcePosition === targetPosition) {
  	          throw new Error("Source and target positions are the same.");
  	        }

  	        if (!sourceSlot.TyreObjectId || clean(sourceSlot.TyreObjectId) !== tyreId) {
  	          throw new Error("The source position no longer contains this tyre.");
  	        }

  	        if (targetSlot.TyreObjectId) {
  	          targetTyre = findTyre(targetSlot.TyreObjectId);

  	          if (!targetTyre) {
  	            throw new Error("The target position has a tyre ID, but the tyre record could not be found.");
  	          }

  	          actionType = "Swap";
  	          preview = "Swap " + sourcePosition + " with " + targetPosition + ".";
  	        } else {
  	          actionType = "Move";
  	          preview = "Move tyre from " + sourcePosition + " to " + targetPosition + ".";
  	        }

  	        return {
  	          Type: actionType,
  	          SourceType: "fitted",
  	          TyreObjectId: tyreId,
  	          SourcePosition: sourcePosition,
  	          TargetPosition: targetPosition,
  	          Preview: preview,
  	          TyreLabel: tyreName(tyre),
  	          TargetTyreLabel: targetTyre ? tyreName(targetTyre): ""
  	        };
  	      }

  	      if (sourceType === "warehouse") {
  	        if (!isTyreAvailable(tyre)) {
  	          throw new Error("This tyre is not available in warehouse.");
  	        }

  	        existingAssignment = findTyreFleetAssignment(tyreId);

  	        if (existingAssignment) {
  	          throw new Error("This tyre is already allocated to " + existingAssignment.vehicleLabel + " at " + existingAssignment.positionKey + ".");
  	        }

  	        if (targetSlot.TyreObjectId) {
  	          targetTyre = findTyre(targetSlot.TyreObjectId);

  	          if (!targetTyre) {
  	            throw new Error("The target position has a tyre ID, but the tyre record could not be found.");
  	          }

  	          return {
  	            Type: "WarehouseSwap",
  	            SourceType: "warehouse",
  	            TyreObjectId: tyreId,
  	            SourcePosition: "",
  	            TargetPosition: targetPosition,
  	            Preview: "Fit warehouse tyre to " + targetPosition + " and move fitted tyre back to warehouse.",
  	            TyreLabel: tyreName(tyre),
  	            TargetTyreLabel: tyreName(targetTyre)
  	          };
  	        }

  	        return {
  	          Type: "Allocate",
  	          SourceType: "warehouse",
  	          TyreObjectId: tyreId,
  	          SourcePosition: "",
  	          TargetPosition: targetPosition,
  	          Preview: "Allocate warehouse tyre to " + targetPosition + ".",
  	          TyreLabel: tyreName(tyre),
  	          TargetTyreLabel: ""
  	        };
  	      }

  	      throw new Error("Invalid tyre source.");
  	    }

  	    async function setPendingActionFromSourceAndTarget(sourceType, tyreId, sourcePosition, targetPosition) {
  	      var tPositions;
  	      var sourceSlot;
  	      var targetSlot;
  	      var sourceTyre;
  	      var targetTyre;
  	      var pending;

  	      try {
  	        tPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	        sourceSlot = sourcePosition ? getSlot(tPositions, sourcePosition): null;
  	        targetSlot = targetPosition ? getSlot(tPositions, targetPosition): null;
  	        sourceTyre = findTyre(tyreId);
  	        targetTyre = targetSlot && targetSlot.TyreObjectId ? findTyre(targetSlot.TyreObjectId): null;

  	        pending = createPendingAction(
  	          sourceType,
  	          tyreId,
  	          sourcePosition,
  	          targetPosition
  	        );

  	        if (sourceTyre && targetSlot && !(await confirmMismatchIfNeeded(sourceTyre, targetSlot))) {
  	          throw new Error("Tyre mismatch was not approved.");
  	        }

  	        if (
  	          sourceType === "fitted" &&
  	          targetTyre &&
  	          sourceSlot &&
  	          !(await confirmMismatchIfNeeded(targetTyre, sourceSlot))
  	        ) {
  	          throw new Error("Target tyre mismatch was not approved.");
  	        }

  	        state.pendingTyreAction = pending;
  	        state.selectedPosition = clean(targetPosition);
  	        state.actionMessage = pending.Preview;
  	        state.actionError = false;

  	        return pending;
  	      } catch (error) {
  	        state.pendingTyreAction = null;
  	        state.actionMessage = error && error.message ? error.message: "Tyre action could not be prepared.";
  	        state.actionError = true;

  	        return null;
  	      }
  	    }

  	    function setDragSource(sourceType, tyreId, sourcePosition) {
  	      state.dragSource = {
  	        SourceType: sourceType,
  	        TyreObjectId: clean(tyreId),
  	        SourcePosition: clean(sourcePosition)
  	      };
  	    }

  	    function setTapSource(sourceType, tyreId, sourcePosition) {
  	      state.tapSource = {
  	        SourceType: sourceType,
  	        TyreObjectId: clean(tyreId),
  	        SourcePosition: clean(sourcePosition)
  	      };

  	      state.actionMessage = "Now tap the target tyre position.";
  	      state.actionError = false;
  	    }

  	    function clearTapSource() {
  	      state.tapSource = null;
  	    }

  	    function sourceAllowedForCurrentMode(source) {
  	      if (!source) {
  	        return false;
  	      }

  	      if (state.actionMode === "Allocate") {
  	        return source.SourceType === "warehouse" || source.SourceType === "fitted";
  	      }

  	      if (state.actionMode === "RotateSwap") {
  	        return source.SourceType === "fitted";
  	      }

  	      return false;
  	    }

  	    async function handleSlotTarget(positionKey) {
  	      var source = state.tapSource || state.dragSource;
  	      var tPositions = state.actionMode === "RotateSwap"
  	      ? getRotationDraftTPositions(): normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	      var slot = getSlot(tPositions, positionKey);

  	      state.selectedPosition = clean(positionKey);

  	      if (!slot) {
  	        state.actionMessage = "Target position could not be found.";
  	        state.actionError = true;
  	        return null;
  	      }

  	      if (!source) {
  	        if (state.actionMode === "RotateSwap") {
  	          if (!slot.TyreObjectId) {
  	            state.actionMessage = "Tap or drag a fitted tyre first, then choose a target position.";
  	            state.actionError = false;
  	            return null;
  	          }

  	          setTapSource("fitted", slot.TyreObjectId, slot.PositionKey);
  	          state.actionMessage = "Selected " + slot.PositionKey + ". Now tap the target position to move or swap.";
  	          state.actionError = false;
  	          return null;
  	        }

  	        if (state.actionMode === "Allocate") {
  	          if (slot.TyreObjectId) {
  	            setTapSource("fitted", slot.TyreObjectId, slot.PositionKey);
  	            state.actionMessage = "Selected " + slot.PositionKey + ". Now tap another position to move or swap, or select a warehouse tyre.";
  	            state.actionError = false;
  	            return null;
  	          }

  	          state.actionMessage = "Tap or drag a warehouse tyre first, or tap a fitted tyre to move or swap it.";
  	          state.actionError = false;
  	          return null;
  	        }

  	        state.actionMessage = "Select Rotate / Swap or Allocate first.";
  	        state.actionError = false;
  	        return null;
  	      }

  	      if (!sourceAllowedForCurrentMode(source)) {
  	        state.actionMessage = "This tyre action is locked. Select the correct mode first.";
  	        state.actionError = true;
  	        return null;
  	      }

  	      if (state.actionMode === "Allocate") {
  	        await applyDraftTyreMove(source, positionKey);

  	        state.pendingTyreAction = null;
  	        state.dragSource = null;
  	        state.tapSource = null;
  	        state.allocatePopupOpen = true;
  	        state.selectedPosition = positionKey;

  	        renderVisualTyreOperations();
  	        renderAllocatePopup();
  	        return;
  	      }

  	      await setPendingActionFromSourceAndTarget(
  	        source.SourceType,
  	        source.TyreObjectId,
  	        source.SourcePosition,
  	        positionKey
  	      );

  	      state.dragSource = null;
  	      renderVisualTyreOperations();
  	    }

  	    function allocateWarehouseTyreToPosition(tyreId, targetPosition, odometer, notes) {
  	      var updatedVehicle;
  	      var tPositions;
  	      var targetSlot;
  	      var tyre;
  	      var updatedTyre;
  	      var existingAssignment;

  	      tyreId = clean(tyreId);
  	      targetPosition = clean(targetPosition);
  	      odometer = clean(odometer);
  	      notes = clean(notes);

  	      if (!state.activeTractor) {
  	        return Promise.reject(new Error("No tractor selected."));
  	      }

  	      updatedVehicle = clone(state.activeTractor);
  	      tPositions = normaliseTPositions(readTPositionsRaw(updatedVehicle));
  	      targetSlot = getSlot(tPositions, targetPosition);
  	      tyre = findTyre(tyreId);

  	      if (!targetSlot) {
  	        return Promise.reject(new Error("Target position could not be found."));
  	      }

  	      if (targetSlot.TyreObjectId) {
  	        return Promise.reject(new Error("Target position already has a tyre fitted."));
  	      }

  	      if (!tyre) {
  	        return Promise.reject(new Error("Selected tyre could not be found."));
  	      }

  	      if (!isTyreAvailable(tyre)) {
  	        return Promise.reject(new Error("Selected tyre is not available for allocation."));
  	      }

  	      if (tyreMismatchInfo(tyre, targetSlot).HasMismatch && !mismatchAlreadyApproved(tyreObjectId(tyre), targetSlot.PositionKey)) {
  	        return Promise.reject(new Error("Tyre mismatch approval is required before this fitment can be saved."));
  	      }

  	      existingAssignment = findTyreFleetAssignment(tyreId);

  	      if (existingAssignment) {
  	        return Promise.reject(new Error("This tyre is already allocated to " + existingAssignment.vehicleLabel + " at " + existingAssignment.positionKey + "."));
  	      }

  	      fitSlot(targetSlot, tyre);
  	      writeTPositionsToVehicle(updatedVehicle, tPositions);

  	      updatedTyre = makeTyreFitted(tyre, targetSlot, odometer, notes, "Installed", "");

  	      appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	        "Installed",
  	        "",
  	        targetSlot.PositionKey,
  	        updatedTyre,
  	        odometer,
  	        notes
  	      ));

  	      return saveTyresSequentially([updatedTyre])
  	      .then(function () {
  	        return saveVehicleWithTPositions(updatedVehicle, tPositions);
  	      })
  	      .then(function () {
  	        state.selectedPosition = targetSlot.PositionKey;
  	        return "Tyre allocated to " + targetSlot.PositionKey + ".";
  	      });
  	    }

  	    function swapWarehouseTyreWithFittedPosition(warehouseTyreId, targetPosition, odometer, notes) {
  	      var updatedVehicle;
  	      var tPositions;
  	      var targetSlot;
  	      var warehouseTyre;
  	      var fittedTyre;
  	      var updatedWarehouseTyre;
  	      var updatedFittedTyre;
  	      var tyresToSave = [];

  	      warehouseTyreId = clean(warehouseTyreId);
  	      targetPosition = clean(targetPosition);
  	      odometer = clean(odometer);
  	      notes = clean(notes);

  	      if (!state.activeTractor) {
  	        return Promise.reject(new Error("No tractor selected."));
  	      }

  	      updatedVehicle = clone(state.activeTractor);
  	      tPositions = normaliseTPositions(readTPositionsRaw(updatedVehicle));
  	      targetSlot = getSlot(tPositions, targetPosition);
  	      warehouseTyre = findTyre(warehouseTyreId);

  	      if (!targetSlot) {
  	        return Promise.reject(new Error("Target position could not be found."));
  	      }

  	      if (!targetSlot.TyreObjectId) {
  	        return allocateWarehouseTyreToPosition(
  	          warehouseTyreId,
  	          targetPosition,
  	          odometer,
  	          notes
  	        );
  	      }

  	      fittedTyre = findTyre(targetSlot.TyreObjectId);

  	      if (!warehouseTyre) {
  	        return Promise.reject(new Error("Warehouse tyre could not be found."));
  	      }

  	      if (!fittedTyre) {
  	        return Promise.reject(new Error("Fitted tyre record could not be found."));
  	      }

  	      if (!isTyreAvailable(warehouseTyre)) {
  	        return Promise.reject(new Error("Selected warehouse tyre is not available."));
  	      }

  	      if (tyreMismatchInfo(warehouseTyre, targetSlot).HasMismatch && !mismatchAlreadyApproved(tyreObjectId(warehouseTyre), targetSlot.PositionKey)) {
  	        return Promise.reject(new Error("Warehouse tyre mismatch approval is required before this fitment can be saved."));
  	      }

  	      updatedFittedTyre = makeTyreRemoved(
  	        fittedTyre,
  	        targetSlot,
  	        "Warehouse",
  	        odometer,
  	        clean(notes + " Swapped out to warehouse.")
  	      );

  	      fitSlot(targetSlot, warehouseTyre);
  	      writeTPositionsToVehicle(updatedVehicle, tPositions);

  	      updatedWarehouseTyre = makeTyreFitted(
  	        warehouseTyre,
  	        targetSlot,
  	        odometer,
  	        clean(notes + " Fitted from warehouse by allocation swap."),
  	        "Installed",
  	        "Warehouse"
  	      );

  	      tyresToSave.push(updatedWarehouseTyre);
  	      tyresToSave.push(updatedFittedTyre);

  	      appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	        "Warehouse Swap",
  	        "Warehouse",
  	        targetSlot.PositionKey,
  	        updatedWarehouseTyre,
  	        odometer,
  	        notes
  	      ));

  	      appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	        "Removed To Warehouse",
  	        targetSlot.PositionKey,
  	        "Warehouse",
  	        updatedFittedTyre,
  	        odometer,
  	        notes
  	      ));

  	      return saveTyresSequentially(tyresToSave)
  	      .then(function () {
  	        return saveVehicleWithTPositions(updatedVehicle, tPositions);
  	      })
  	      .then(function () {
  	        state.selectedPosition = targetSlot.PositionKey;
  	        return "Warehouse tyre fitted to " + targetSlot.PositionKey + ". Fitted tyre moved to warehouse.";
  	      });
  	    }

  	    function moveOrSwapFittedTyre(sourcePosition, targetPosition, odometer, notes) {
  	      var updatedVehicle;
  	      var tPositions;
  	      var sourceSlot;
  	      var targetSlot;
  	      var sourceTyre;
  	      var targetTyre;
  	      var sourceSnapshot;
  	      var targetSnapshot;
  	      var updatedSourceTyre;
  	      var updatedTargetTyre;
  	      var tyresToSave = [];
  	      var movementType;

  	      sourcePosition = clean(sourcePosition);
  	      targetPosition = clean(targetPosition);
  	      odometer = clean(odometer);
  	      notes = clean(notes);

  	      if (!state.activeTractor) {
  	        return Promise.reject(new Error("No tractor selected."));
  	      }

  	      if (!sourcePosition || !targetPosition) {
  	        return Promise.reject(new Error("Source and target positions are required."));
  	      }

  	      if (sourcePosition === targetPosition) {
  	        return Promise.reject(new Error("Source and target positions cannot be the same."));
  	      }

  	      updatedVehicle = clone(state.activeTractor);
  	      tPositions = normaliseTPositions(readTPositionsRaw(updatedVehicle));

  	      sourceSlot = getSlot(tPositions, sourcePosition);
  	      targetSlot = getSlot(tPositions, targetPosition);

  	      if (!sourceSlot || !sourceSlot.TyreObjectId) {
  	        return Promise.reject(new Error("Source position does not have a tyre fitted."));
  	      }

  	      if (!targetSlot) {
  	        return Promise.reject(new Error("Target position could not be found."));
  	      }

  	      sourceTyre = findTyre(sourceSlot.TyreObjectId);
  	      targetTyre = targetSlot.TyreObjectId ? findTyre(targetSlot.TyreObjectId): null;

  	      if (!sourceTyre) {
  	        return Promise.reject(new Error("Source tyre record could not be found."));
  	      }

  	      if (tyreMismatchInfo(sourceTyre, targetSlot).HasMismatch && !mismatchAlreadyApproved(tyreObjectId(sourceTyre), targetSlot.PositionKey)) {
  	        return Promise.reject(new Error("Source tyre mismatch approval is required before this movement can be saved."));
  	      }

  	      if (targetTyre && tyreMismatchInfo(targetTyre, sourceSlot).HasMismatch && !mismatchAlreadyApproved(tyreObjectId(targetTyre), sourceSlot.PositionKey)) {
  	        return Promise.reject(new Error("Target tyre mismatch approval is required before this movement can be saved."));
  	      }

  	      movementType = targetTyre ? "Swap": "Rotation";

  	      sourceSnapshot = {
  	        TyreObjectId: sourceSlot.TyreObjectId || "",
  	        TyreNumber: sourceSlot.TyreNumber || "",
  	        SerialNumber: sourceSlot.SerialNumber || ""
  	      };

  	      targetSnapshot = {
  	        TyreObjectId: targetSlot.TyreObjectId || "",
  	        TyreNumber: targetSlot.TyreNumber || "",
  	        SerialNumber: targetSlot.SerialNumber || ""
  	      };

  	      copySlotTyre(targetSnapshot, sourceSlot);
  	      copySlotTyre(sourceSnapshot, targetSlot);

  	      updatedSourceTyre = makeTyreMoved(
  	        sourceTyre,
  	        {
  	          PositionKey: sourcePosition, AxleType: sourceSlot.AxleType, WearRate: sourceSlot.WearRate
  	        },
  	        targetSlot,
  	        odometer,
  	        notes,
  	        movementType
  	      );

  	      tyresToSave.push(updatedSourceTyre);

  	      appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	        movementType,
  	        sourcePosition,
  	        targetPosition,
  	        updatedSourceTyre,
  	        odometer,
  	        notes
  	      ));

  	      if (targetTyre) {
  	        updatedTargetTyre = makeTyreMoved(
  	          targetTyre,
  	          {
  	            PositionKey: targetPosition, AxleType: targetSlot.AxleType, WearRate: targetSlot.WearRate
  	          },
  	          sourceSlot,
  	          odometer,
  	          notes,
  	          movementType
  	        );

  	        tyresToSave.push(updatedTargetTyre);

  	        appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	          movementType,
  	          targetPosition,
  	          sourcePosition,
  	          updatedTargetTyre,
  	          odometer,
  	          notes
  	        ));
  	      }

  	      writeTPositionsToVehicle(updatedVehicle, tPositions);

  	      return saveTyresSequentially(tyresToSave)
  	      .then(function () {
  	        return saveVehicleWithTPositions(updatedVehicle, tPositions);
  	      })
  	      .then(function () {
  	        state.selectedPosition = targetPosition;
  	        return targetTyre ? "Tyres swapped.": "Tyre moved to " + targetPosition + ".";
  	      });
  	    }

  	    function removeTyreFromPosition(positionKey, destination, odometer, notes) {
  	      var updatedVehicle;
  	      var tPositions;
  	      var slot;
  	      var tyre;
  	      var updatedTyre;
  	      var fromPosition;

  	      positionKey = clean(positionKey);
  	      destination = clean(destination) || "Warehouse";
  	      odometer = clean(odometer);
  	      notes = clean(notes);

  	      if (!state.activeTractor) {
  	        return Promise.reject(new Error("No tractor selected."));
  	      }

  	      if (!positionKey) {
  	        return Promise.reject(new Error("Select a fitted tyre first."));
  	      }

  	      updatedVehicle = clone(state.activeTractor);
  	      tPositions = normaliseTPositions(readTPositionsRaw(updatedVehicle));
  	      slot = getSlot(tPositions, positionKey);

  	      if (!slot || !slot.TyreObjectId) {
  	        return Promise.reject(new Error("Selected position does not have a tyre fitted."));
  	      }

  	      tyre = findTyre(slot.TyreObjectId);

  	      if (!tyre) {
  	        return Promise.reject(new Error("The fitted tyre record could not be found."));
  	      }

  	      fromPosition = slot.PositionKey;
  	      updatedTyre = makeTyreRemoved(tyre, slot, destination, odometer, notes);

  	      clearSlot(slot);
  	      writeTPositionsToVehicle(updatedVehicle, tPositions);

  	      appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	        "Removed",
  	        fromPosition,
  	        destination,
  	        updatedTyre,
  	        odometer,
  	        notes
  	      ));

  	      return saveTyresSequentially([updatedTyre])
  	      .then(function () {
  	        return saveVehicleWithTPositions(updatedVehicle, tPositions);
  	      })
  	      .then(function () {
  	        state.selectedPosition = fromPosition;
  	        return "Tyre removed.";
  	      });
  	    }

  	    function executePendingTyreAction() {
  	      var pending = state.pendingTyreAction;
  	      var odometer = getUiValue("tyreActionOdometer");
  	      var notes = getUiValue("tyreActionNotes");

  	      if (!pending) {
  	        return Promise.reject(new Error("No pending tyre action to save."));
  	      }

  	      if (pending.Type === "Allocate") {
  	        return allocateWarehouseTyreToPosition(
  	          pending.TyreObjectId,
  	          pending.TargetPosition,
  	          odometer,
  	          notes
  	        );
  	      }

  	      if (pending.Type === "WarehouseSwap") {
  	        return swapWarehouseTyreWithFittedPosition(
  	          pending.TyreObjectId,
  	          pending.TargetPosition,
  	          odometer,
  	          notes
  	        );
  	      }

  	      if (pending.Type === "Move" || pending.Type === "Swap") {
  	        return moveOrSwapFittedTyre(
  	          pending.SourcePosition,
  	          pending.TargetPosition,
  	          odometer,
  	          notes
  	        );
  	      }

  	      return Promise.reject(new Error("Unknown tyre action type."));
  	    }

  	    function executeRemoveFromUi() {
  	      var positionKey = clean(state.selectedPosition);
  	      var destination = getUiValue("tyreActionDestination");
  	      var odometer = getUiValue("tyreActionOdometer");
  	      var notes = getUiValue("tyreActionNotes");

  	      return removeTyreFromPosition(positionKey, destination, odometer, notes);
  	    }

  	    function pendingActionLabel() {
  	      var pending = state.pendingTyreAction;

  	      if (!pending) {
  	        return "";
  	      }

  	      if (pending.Type === "Allocate") {
  	        return "Allocate: " + pending.TyreLabel + " → " + pending.TargetPosition;
  	      }

  	      if (pending.Type === "WarehouseSwap") {
  	        return "Swap From Warehouse: " + pending.TyreLabel + " → " + pending.TargetPosition + " | " + pending.TargetTyreLabel + " → Warehouse";
  	      }

  	      if (pending.Type === "Move") {
  	        return "Move: " + pending.TyreLabel + " from " + pending.SourcePosition + " → " + pending.TargetPosition;
  	      }

  	      if (pending.Type === "Swap") {
  	        return "Swap: " + pending.SourcePosition + " ↔ " + pending.TargetPosition;
  	      }

  	      return pending.Preview || "";
  	    }

  	    function validatePendingStillPossible() {
  	      var pending = state.pendingTyreAction;

  	      if (!pending) {
  	        return {
  	          ok: false,
  	          message: "No pending tyre action."
  	        };
  	      }

  	      try {
  	        createPendingAction(
  	          pending.SourceType,
  	          pending.TyreObjectId,
  	          pending.SourcePosition,
  	          pending.TargetPosition
  	        );

  	        return {
  	          ok: true,
  	          message: ""
  	        };
  	      } catch (error) {
  	        return {
  	          ok: false,
  	          message: error && error.message ? error.message: "Pending action is no longer valid."
  	        };
  	      }
  	    }

  	    function findSlotByTyreId(tPositions, tyreId) {
  	      var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	      var keys = Object.keys(positions);
  	      var cleanTyreId = clean(tyreId);
  	      var i;

  	      if (!cleanTyreId) {
  	        return null;
  	      }

  	      for (i = 0; i < keys.length; i++) {
  	        if (clean(positions[keys[i]] && positions[keys[i]].TyreObjectId) === cleanTyreId) {
  	          return positions[keys[i]];
  	        }
  	      }

  	      return null;
  	    }

  	    function resetRotationPlan() {
  	      state.rotationDraftTPositions = null;
  	      state.rotationPlanStartedVehicleId = "";
  	      state.rotationMessage = "";
  	    }

  	    function beginRotationPlan() {
  	      state.rotationDraftTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	      state.rotationPlanStartedVehicleId = vehicleObjectId(state.activeTractor);
  	      state.pendingTyreAction = null;
  	      state.dragSource = null;
  	      state.tapSource = null;
  	      state.rotationMessage = "Rotation planning started. Drag all required tyres, then save once.";

  	      return state.rotationDraftTPositions;
  	    }

  	    function getRotationDraftTPositions() {
  	      var activeVehicleId = vehicleObjectId(state.activeTractor);

  	      if (
  	        state.rotationDraftTPositions &&
  	        state.rotationPlanStartedVehicleId === activeVehicleId
  	      ) {
  	        return state.rotationDraftTPositions;
  	      }

  	      return beginRotationPlan();
  	    }

  	    function getVisualTPositionsForTyreTab(currentVehicle) {
  	      if (state.actionMode === "RotateSwap" || state.actionMode === "Allocate") {
  	        return getRotationDraftTPositions();
  	      }

  	      return normaliseTPositions(readTPositionsRaw(currentVehicle));
  	    }

  	    function getRotationArrows() {
  	      var originalTPositions;
  	      var draftTPositions;
  	      var finalPositions;
  	      var keys;
  	      var arrows = [];

  	      if (!state.activeTractor || state.actionMode !== "RotateSwap") {
  	        return [];
  	      }

  	      originalTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	      draftTPositions = getRotationDraftTPositions();
  	      finalPositions = draftTPositions && draftTPositions.Positions ? draftTPositions.Positions: {};
  	      keys = Object.keys(finalPositions);

  	      keys.forEach(function (key) {
  	        var finalSlot = finalPositions[key];
  	        var tyreId = clean(finalSlot && finalSlot.TyreObjectId);
  	        var originalSlot;
  	        var fromPosition;
  	        var toPosition;
  	        var tyre;

  	        if (!tyreId) {
  	          return;
  	        }

  	        originalSlot = findSlotByTyreId(originalTPositions, tyreId);

  	        if (!originalSlot) {
  	          return;
  	        }

  	        fromPosition = clean(originalSlot.PositionKey);
  	        toPosition = clean(finalSlot.PositionKey || key);

  	        if (!fromPosition || !toPosition || fromPosition === toPosition) {
  	          return;
  	        }

  	        tyre = findTyre(tyreId);

  	        arrows.push({
  	          TyreObjectId: tyreId,
  	          TyreLabel: tyre ? tyreName(tyre): tyreId,
  	          FromPosition: fromPosition,
  	          ToPosition: toPosition
  	        });
  	      });

  	      return arrows;
  	    }

  	    async function moveTyreInRotationDraft(sourcePosition,
  	      targetPosition) {
  	      var draft = getRotationDraftTPositions();
  	      var sourceSlot = getSlot(draft,
  	        sourcePosition);
  	      var targetSlot = getSlot(draft,
  	        targetPosition);
  	      var sourceTyre;
  	      var targetTyre;
  	      var sourceSnapshot;
  	      var targetSnapshot;

  	      sourcePosition = clean(sourcePosition);
  	      targetPosition = clean(targetPosition);

  	      if (!sourcePosition || !targetPosition) {
  	        state.actionMessage = "Source and target positions are required.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (sourcePosition === targetPosition) {
  	        state.actionMessage = "Source and target positions are the same.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (!sourceSlot || !sourceSlot.TyreObjectId) {
  	        state.actionMessage = "Source position does not have a fitted tyre.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (!targetSlot) {
  	        state.actionMessage = "Target position could not be found.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      sourceTyre = findTyre(sourceSlot.TyreObjectId);
  	      targetTyre = targetSlot.TyreObjectId ? findTyre(targetSlot.TyreObjectId): null;

  	      if (!sourceTyre) {
  	        state.actionMessage = "Source tyre record could not be found.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (!(await confirmMismatchIfNeeded(sourceTyre, targetSlot))) {
  	        state.actionMessage = "Source tyre mismatch was not approved.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (targetTyre && !(await confirmMismatchIfNeeded(targetTyre, sourceSlot))) {
  	        state.actionMessage = "Target tyre mismatch was not approved.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      sourceSnapshot = {
  	        TyreObjectId: sourceSlot.TyreObjectId || "",
  	        TyreNumber: sourceSlot.TyreNumber || "",
  	        SerialNumber: sourceSlot.SerialNumber || ""
  	      };

  	      targetSnapshot = {
  	        TyreObjectId: targetSlot.TyreObjectId || "",
  	        TyreNumber: targetSlot.TyreNumber || "",
  	        SerialNumber: targetSlot.SerialNumber || ""
  	      };

  	      copySlotTyre(targetSnapshot, sourceSlot);
  	      copySlotTyre(sourceSnapshot, targetSlot);

  	      draft.Summary = summaryForTPositions(draft);

  	      state.selectedPosition = targetPosition;
  	      state.actionMessage = targetTyre
  	      ? "Planned swap: " + sourcePosition + " ↔ " + targetPosition + ".": "Planned rotation: " + sourcePosition + " → " + targetPosition + ".";
  	      state.actionError = false;

  	      return true;
  	    }

  	    function draftAssignedTyreIds() {
  	      var draft = getRotationDraftTPositions();

  	      return assignedTyreIds(draft);
  	    }

  	    function warehouseTyreAlreadyInDraft(tyreId) {
  	      return draftAssignedTyreIds().indexOf(clean(tyreId)) !== -1;
  	    }

  	    async function planWarehouseTyreIntoDraft(tyreId, targetPosition) {
  	      var draft = getRotationDraftTPositions();
  	      var targetSlot = getSlot(draft, targetPosition);
  	      var tyre = findTyre(tyreId);

  	      tyreId = clean(tyreId);
  	      targetPosition = clean(targetPosition);

  	      if (!tyreId || !tyre) {
  	        state.actionMessage = "Warehouse tyre could not be found.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (!targetSlot) {
  	        state.actionMessage = "Target position could not be found.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (!isTyreAvailable(tyre)) {
  	        state.actionMessage = "Selected warehouse tyre is not available.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (warehouseTyreAlreadyInDraft(tyreId)) {
  	        state.actionMessage = "This warehouse tyre is already in the current plan.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (!(await confirmMismatchIfNeeded(tyre, targetSlot))) {
  	        state.actionMessage = "Tyre mismatch was not approved.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      fitSlot(targetSlot, tyre);

  	      draft.Summary = summaryForTPositions(draft);

  	      state.selectedPosition = targetPosition;
  	      state.actionMessage = "Planned allocation: " + tyreName(tyre) + " → " + targetPosition + ".";
  	      state.actionError = false;

  	      return true;
  	    }

  	    async function applyDraftTyreMove(source, targetPosition) {
  	      if (!source) {
  	        state.actionMessage = "No tyre source found.";
  	        state.actionError = true;
  	        return false;
  	      }

  	      if (source.SourceType === "warehouse") {
  	        return await planWarehouseTyreIntoDraft(
  	          source.TyreObjectId,
  	          targetPosition
  	        );
  	      }

  	      if (source.SourceType === "fitted") {
  	        return await moveTyreInRotationDraft(
  	          source.SourcePosition,
  	          targetPosition
  	        );
  	      }

  	      state.actionMessage = "Invalid tyre source.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    function getAllocationPlanRows() {
  	      var originalTPositions;
  	      var draftTPositions;
  	      var originalPositions;
  	      var finalPositions;
  	      var rows = [];
  	      var seenOriginalTyres = {};
  	      var finalKeys;
  	      var originalKeys;

  	      if (!state.activeTractor) {
  	        return [];
  	      }

  	      originalTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	      draftTPositions = getRotationDraftTPositions();

  	      originalPositions = originalTPositions && originalTPositions.Positions ? originalTPositions.Positions: {};
  	      finalPositions = draftTPositions && draftTPositions.Positions ? draftTPositions.Positions: {};

  	      finalKeys = Object.keys(finalPositions);
  	      originalKeys = Object.keys(originalPositions);

  	      finalKeys.forEach(function (key) {
  	        var finalSlot = finalPositions[key];
  	        var tyreId = clean(finalSlot && finalSlot.TyreObjectId);
  	        var originalSlot;
  	        var tyre;

  	        if (!tyreId) {
  	          return;
  	        }

  	        tyre = findTyre(tyreId);
  	        originalSlot = findSlotByTyreId(originalTPositions, tyreId);

  	        if (originalSlot) {
  	          seenOriginalTyres[tyreId] = true;

  	          if (clean(originalSlot.PositionKey) !== clean(finalSlot.PositionKey || key)) {
  	            rows.push({
  	              Type: "Move",
  	              TyreObjectId: tyreId,
  	              TyreLabel: tyre ? tyreName(tyre): tyreId,
  	              FromPosition: clean(originalSlot.PositionKey),
  	              ToPosition: clean(finalSlot.PositionKey || key),
  	              FromLabel: clean(originalSlot.PositionKey),
  	              ToLabel: clean(finalSlot.PositionKey || key)
  	            });
  	          }

  	          return;
  	        }

  	        rows.push({
  	          Type: "Allocate",
  	          TyreObjectId: tyreId,
  	          TyreLabel: tyre ? tyreName(tyre): tyreId,
  	          FromPosition: "",
  	          ToPosition: clean(finalSlot.PositionKey || key),
  	          FromLabel: "Warehouse",
  	          ToLabel: clean(finalSlot.PositionKey || key)
  	        });
  	      });

  	      originalKeys.forEach(function (key) {
  	        var originalSlot = originalPositions[key];
  	        var tyreId = clean(originalSlot && originalSlot.TyreObjectId);
  	        var finalSlot;
  	        var tyre;

  	        if (!tyreId || seenOriginalTyres[tyreId]) {
  	          return;
  	        }

  	        finalSlot = findSlotByTyreId(draftTPositions, tyreId);

  	        if (finalSlot) {
  	          return;
  	        }

  	        tyre = findTyre(tyreId);

  	        rows.push({
  	          Type: "RemoveToWarehouse",
  	          TyreObjectId: tyreId,
  	          TyreLabel: tyre ? tyreName(tyre): tyreId,
  	          FromPosition: clean(originalSlot.PositionKey || key),
  	          ToPosition: "",
  	          FromLabel: clean(originalSlot.PositionKey || key),
  	          ToLabel: "Warehouse"
  	        });
  	      });

  	      return rows;
  	    }



  	    function allocationPlanInlineStatusHtml() {
  	      var rows = getAllocationPlanRows();

  	      if (!rows.length) {
  	        return ""
  	        + "<div style=\"border:1px solid #333;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	        + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Allocation Plan</div>"
  	        + "  <div style=\"padding:11px 12px;color:#777;font-size:12px;line-height:1.45;\">"
  	        + "Drag warehouse tyres onto positions, or move fitted tyres around the vehicle. Press Complete Allocation when the plan is ready."
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      return ""
  	      + "<div style=\"border:1px solid #2a8f3a;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	      + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Allocation Plan</div>"
  	      + "  <div style=\"padding:11px 12px;color:#ddd;font-size:12px;line-height:1.45;\">"
  	      + "    <b style=\"color:#fff;\">" + escapeHtml(rows.length) + "</b> unsaved tyre change" + (rows.length === 1 ? "": "s") + " planned. Press <b style=\"color:#a7d8aa;\">Complete Allocation</b> to review and save."
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function allocationPlanPopupRowsHtml(rows) {
  	      if (!rows.length) {
  	        return "<div style=\"color:#777;border:1px dashed #444;border-radius:8px;padding:12px;\">No planned tyre changes.</div>";
  	      }

  	      return rows.map(function (row, index) {
  	        return ""
  	        + "<div style=\"display:grid;grid-template-columns:34px 1fr;gap:10px;align-items:start;border-bottom:1px solid #252525;padding:9px 0;\">"
  	        + "  <div style=\"color:#aaa;font-weight:900;font-size:16px;text-align:center;\">" + escapeHtml(index + 1) + "</div>"
  	        + "  <div>"
  	        + "    <div style=\"color:#fff;font-weight:900;font-size:13px;line-height:1.3;\">" + escapeHtml(row.TyreLabel) + "</div>"
  	        + "    <div style=\"color:#aaa;font-size:12px;line-height:1.4;margin-top:2px;\">" + escapeHtml(row.Type) + ": " + escapeHtml(row.FromLabel) + " → " + escapeHtml(row.ToLabel) + "</div>"
  	        + "  </div>"
  	        + "</div>";
  	      }).join("");
  	    }

  	    function floatingPopupShellHtml(id, title, innerHtml, width) {
  	      var card = ""
  	      + "<section data-popup-card=\"" + escapeHtml(id) + "\" role=\"dialog\" aria-modal=\"true\" aria-label=\"" + escapeHtml(title) + "\" style=\""
  	      + "position:relative;"
  	      + "width:" + escapeHtml(width || "720px") + ";"
  	      + "max-width:calc(100vw - 40px);"
  	      + "max-height:calc(100vh - 90px);"
  	      + "background:linear-gradient(145deg,#151916,#080b09);"
  	      + "border:1px solid rgba(204,102,51,.48);"
  	      + "border-radius:15px;"
  	      + "box-shadow:0 28px 80px rgba(0,0,0,.86),0 0 32px rgba(204,102,51,.13);"
  	      + "overflow:hidden;"
  	      + "font-family:system-ui,sans-serif;"
  	      + "color:#fff;"
  	      + "\">"
  	      + "  <header style=\"display:flex;align-items:center;justify-content:space-between;gap:12px;padding:13px 15px;border-bottom:1px solid #333;background:rgba(204,102,51,.07);\">"
  	      + "    <div><div style=\"color:#CC6633;font-size:15px;font-weight:900;\">" + escapeHtml(title) + "</div><div style=\"color:#8f9691;font-size:11px;margin-top:3px;\">Review the operation before committing it.</div></div>"
  	      + "    <button type=\"button\" data-popup-close=\"" + escapeHtml(id) + "\" style=\"background:#555;color:#fff;border:none;border-radius:7px;padding:6px 10px;cursor:pointer;font-weight:900;\">✕</button>"
  	      + "  </header>"
  	      + "  <div style=\"padding:15px;overflow:auto;max-height:calc(100vh - 180px);\">"
  	      + innerHtml
  	      + "  </div>"
  	      + "</section>";

  	      return ""
  	      + "<div id=\"" + escapeHtml(id) + "\" style=\""
  	      + "position:fixed;"
  	      + "inset:50px 0 0;"
  	      + "z-index:2147483646;"
  	      + "display:flex;"
  	      + "align-items:center;"
  	      + "justify-content:center;"
  	      + "padding:18px;"
  	      + "background:rgba(0,0,0,.84);"
  	      + "backdrop-filter:blur(7px) saturate(.78);"
  	      + "\">"
  	      + card
  	      + "</div>";
  	    }

  	    function allocationReportRowsHtml(rows) {
  	      if (!rows.length) {
  	        return "<tr><td colspan=\"6\">No planned tyre changes.</td></tr>";
  	      }

  	      return rows.map(function (row) {
  	        var tyre = findTyre(row.TyreObjectId);
  	        var toSlot = null;
  	        var requiredType = "—";
  	        var actualType = tyre ? tyreType(tyre) || "—": "—";
  	        var mismatch = "No";

  	        try {
  	          if (row.ToPosition) {
  	            toSlot = getSlot(getRotationDraftTPositions(), row.ToPosition);
  	          }

  	          if (toSlot) {
  	            requiredType = requiredTyreTypeForSlot(toSlot);

  	            if (actualType !== "—" && requiredType && actualType !== requiredType) {
  	              mismatch = "Accepted / To be recorded";
  	            }
  	          }
  	        } catch (error) {

  	        }

  	        return ""
  	        + "<tr>"
  	        + "  <td>" + escapeHtml(row.Type || "Change") + "</td>"
  	        + "  <td>" + escapeHtml(row.FromLabel || row.FromPosition || "Warehouse") + "</td>"
  	        + "  <td>" + escapeHtml(row.ToLabel || row.ToPosition || "Warehouse") + "</td>"
  	        + "  <td>" + escapeHtml(row.TyreLabel || (tyre ? tyreName(tyre): "Tyre")) + "</td>"
  	        + "  <td>" + escapeHtml(actualType) + " / " + escapeHtml(requiredType) + "</td>"
  	        + "  <td>" + escapeHtml(mismatch) + "</td>"
  	        + "</tr>";
  	      }).join("");
  	    }

  	    function allocationReportHtml(rows,
  	      odometer,
  	      notes) {
  	      var currentVehicle = state.activeTractor || {};
  	      var generatedAt = new Date().toLocaleString();
  	      var logoHtml = reportLogoHtml();

  	      return ""
  	      + "<div style=\"font-family:Arial,sans-serif;color:#111;padding:20px 22px;\">"
  	      + "  <div style=\"display:flex;justify-content:space-between;align-items:flex-start;gap:18px;border-bottom:2px solid #CC6633;padding-bottom:10px;margin-bottom:14px;\">"
  	      + "    <div>"
  	      + "      <h2 style=\"margin:0 0 5px;font-size:22px;color:#111;\">Tyre Allocation Report</h2>"
  	      + "      <div style=\"font-size:12px;color:#555;\">Generated: " + escapeHtml(generatedAt) + "</div>"
  	      + "      <div style=\"font-size:12px;color:#777;margin-top:2px;\">Allocation Plan Report</div>"
  	      + "    </div>"
  	      + "    <div style=\"min-width:160px;text-align:right;display:flex;justify-content:flex-end;align-items:flex-start;\">"
  	      + (logoHtml || "<div style=\"font-size:12px;color:#555;\">Tractor Manager</div>")
  	      + "    </div>"
  	      + "  </div>"

  	      + "  <table style=\"width:100%;border-collapse:collapse;margin-bottom:14px;font-size:12px;\">"
  	      + "    <tbody>"
  	      + "      <tr><th style=\"width:170px;text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Vehicle</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(vehicleTitle(currentVehicle)) + "</td></tr>"
  	      + "      <tr><th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Vehicle ID</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(vehicleId(currentVehicle) || "—") + "</td></tr>"
  	      + "      <tr><th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Registration</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(vehicleReg(currentVehicle) || "—") + "</td></tr>"
  	      + "      <tr><th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Odometer</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(odometer || "—") + " km</td></tr>"
  	      + "      <tr><th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Notes</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(notes || "") + "</td></tr>"
  	      + "    </tbody>"
  	      + "  </table>"

  	      + "  <h3 style=\"margin:12px 0 7px;font-size:15px;\">Planned Tyre Changes</h3>"
  	      + "  <table style=\"width:100%;border-collapse:collapse;font-size:12px;\">"
  	      + "    <thead>"
  	      + "      <tr>"
  	      + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Action</th>"
  	      + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">From</th>"
  	      + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">To</th>"
  	      + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Tyre</th>"
  	      + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Actual / Required Type</th>"
  	      + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Mismatch</th>"
  	      + "      </tr>"
  	      + "    </thead>"
  	      + "    <tbody>"
  	      + allocationReportRowsHtml(rows)
  	      + "    </tbody>"
  	      + "  </table>"

  	      + "  <div style=\"display:flex;justify-content:space-between;margin-top:28px;font-size:12px;color:#444;\">"
  	      + "    <div>Captured By: ______________________________</div>"
  	      + "    <div>Checked By: ______________________________</div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function printHtmlInHiddenFrame(title,
  	      html) {
  	      var frame;
  	      var doc;

  	      if (!DocumentSafe || !DocumentSafe.body) {
  	        alertSafe("Printing is unavailable in this browser.");
  	        return;
  	      }

  	      frame = DocumentSafe.createElement("iframe");

  	      frame.style.position = "fixed";
  	      frame.style.right = "0";
  	      frame.style.bottom = "0";
  	      frame.style.width = "0";
  	      frame.style.height = "0";
  	      frame.style.border = "0";
  	      frame.style.opacity = "0";
  	      frame.style.pointerEvents = "none";

  	      DocumentSafe.body.appendChild(frame);

  	      doc = frame.contentWindow.document;
  	      doc.open();
  	      doc.write("<!doctype html>");
  	      doc.write("<html><head><meta charset=\"utf-8\"><title>" + escapeHtml(title) + "</title>");
  	      doc.write("<style>");
  	      doc.write("@page{size:A4 landscape;margin:10mm;}");
  	      doc.write("html,body{margin:0;padding:0;background:#fff;color:#000;font-family:Arial,sans-serif;}");
  	      doc.write("*{box-sizing:border-box;}");
  	      doc.write("table{width:100%;border-collapse:collapse;page-break-inside:auto;}");
  	      doc.write("tr{page-break-inside:avoid;page-break-after:auto;}");
  	      doc.write("th,td{vertical-align:top;}");
  	      doc.write("h2,h3{page-break-after:avoid;}");
  	      doc.write("</style>");
  	      doc.write("</head><body>");
  	      doc.write(html);
  	      doc.write("</body></html>");
  	      doc.close();

  	      setTimeout(function () {
  	        try {
  	          frame.contentWindow.focus();
  	          frame.contentWindow.print();

  	          setTimeout(function () {
  	            if (frame && frame.parentNode) {
  	              frame.parentNode.removeChild(frame);
  	            }
  	          },
  	            1000);
  	        } catch (error) {

  	          alertSafe("Could not print the allocation report.");
  	        }
  	      }, 250);
  	    }

  	    function printAllocationPlanReportFromPopup() {
  	      var rows = getAllocationPlanRows();
  	      var popup = DocumentSafe.getElementById("allocationPlanPopup");
  	      var odometerInput = popup ? popup.querySelector("#tyreActionOdometer"): null;
  	      var notesInput = popup ? popup.querySelector("#tyreActionNotes"): null;
  	      var odometer = odometerInput ? clean(odometerInput.value): "";
  	      var notes = notesInput ? notesInput.value: "";

  	      if (!rows.length) {
  	        alertSafe("No allocation changes to print.");
  	        return;
  	      }

  	      printHtmlInHiddenFrame(
  	        "Tyre Allocation Report",
  	        allocationReportHtml(rows, odometer, notes)
  	      );
  	    }







  	    function renderAllocationPlanPopup() {
  	      var rows = getAllocationPlanRows();
  	      var html;
  	      var popup;

  	      closeFloatingPopup("allocationPlanPopup");

  	      if (!rows.length) {
  	        alertSafe("Drag a warehouse tyre onto a vehicle position before completing the allocation.", {
  	          title: "No Allocation Changes",
  	          type: "warning",
  	          confirmText: "Close"
  	        });
  	        return;
  	      }

  	      html = ""
  	      + "<div style=\"display:flex;flex-direction:column;gap:12px;\">"

  	      + "  <div style=\"border:1px solid #2a8f3a;background:#101010;border-radius:8px;overflow:hidden;\">"
  	      + "    <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Planned Tyre Changes</div>"
  	      + "    <div style=\"padding:10px 12px;max-height:240px;overflow:auto;\">"
  	      + allocationPlanPopupRowsHtml(rows)
  	      + "    </div>"
  	      + "  </div>"

  	      + "  <div style=\"border:1px solid #333;background:#101010;border-radius:8px;padding:12px;\">"
  	      + "    <div style=\"margin-bottom:10px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	      + "      <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	      + "    </div>"
  	      + "    <div style=\"margin-bottom:12px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	      + "      <textarea id=\"tyreActionNotes\" placeholder=\"Notes for all planned tyre changes\" style=\"width:100%;box-sizing:border-box;min-height:72px;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	      + "    </div>"
  	      + "    <div id=\"allocationPlanError\" style=\"min-height:16px;color:#ff7d73;font-size:12px;margin-bottom:8px;\"></div>"
  	      + "    <div style=\"display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;align-items:center;\">"
  	      + "      <button id=\"allocationPlanPrintBtn\" type=\"button\" style=\"background:#374151;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;margin-right:auto;display:inline-flex;align-items:center;gap:6px;\">🖨 Print Report</button>"
  	      + "      <button id=\"allocationPlanSaveBtn\" type=\"button\" style=\"display:none;background:#2a8f3a;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Save All Changes</button>"
  	      + "      <button id=\"allocationPlanCancelBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Cancel</button>"
  	      + "    </div>"
  	      + "  </div>"

  	      + "</div>";

  	      if (!DocumentSafe || !DocumentSafe.body) {
  	        return;
  	      }

  	      DocumentSafe.body.insertAdjacentHTML(
  	        "beforeend",
  	        floatingPopupShellHtml("allocationPlanPopup", "Complete Allocation", html, "720px")
  	      );

  	      popup = DocumentSafe.getElementById("allocationPlanPopup");

  	      if (!popup) {
  	        return;
  	      }

  	      wireAllocationPlanPopupEvents(popup);
  	    }

  	    function wireAllocationPlanPopupEvents(popup) {
  	      var saveBtn = popup.querySelector("#allocationPlanSaveBtn");
  	      var printBtn = popup.querySelector("#allocationPlanPrintBtn");
  	      var cancelBtn = popup.querySelector("#allocationPlanCancelBtn");
  	      var odometerInput = popup.querySelector("#tyreActionOdometer");
  	      var errorEl = popup.querySelector("#allocationPlanError");
  	      var closeButtons = popup.querySelectorAll("[data-popup-close=\"allocationPlanPopup\"]");

  	      function refreshSaveButton() {
  	        var value = odometerInput ? numberOrNull(odometerInput.value): null;

  	        if (!saveBtn) {
  	          return;
  	        }

  	        saveBtn.style.display = value !== null ? "inline-flex": "none";
  	      }

  	      refreshSaveButton();

  	      if (odometerInput) {
  	        odometerInput.oninput = refreshSaveButton;
  	        odometerInput.onchange = refreshSaveButton;
  	      }

  	      if (printBtn) {
  	        printBtn.onclick = function () {
  	          if (typeof printAllocationPlanReportFromPopup === "function") {
  	            printAllocationPlanReportFromPopup();
  	            return;
  	          }

  	          alertSafe("Allocation report print function is not installed yet.");
  	        };
  	      }

  	      if (saveBtn) {
  	        saveBtn.onclick = function () {
  	          if (errorEl) {
  	            errorEl.textContent = "";
  	          }

  	          saveAllocationPlanFromUi(saveBtn)
  	          .then(function () {
  	            closeFloatingPopup("allocationPlanPopup");
  	            lockTyreMovementState(state.actionMessage || "Allocation complete. Tyre movement locked.");
  	          })
  	          .catch(function (error) {
  	            state.actionMessage = error && error.message ? error.message: "Could not save allocation plan.";
  	            state.actionError = true;

  	            if (saveBtn) {
  	              saveBtn.disabled = false;
  	              saveBtn.textContent = "Save All Changes";
  	              refreshSaveButton();
  	            }

  	            if (errorEl) {
  	              errorEl.textContent = state.actionMessage;
  	            }

  	            requestTyreTabRerender();
  	          });
  	        };
  	      }

  	      if (cancelBtn) {
  	        cancelBtn.onclick = async function (event) {
  	          if (event && event.preventDefault) {
  	            event.preventDefault();
  	          }

  	          if (event && event.stopPropagation) {
  	            event.stopPropagation();
  	          }

  	          if (!(await confirmSafe(
  	            "All unsaved allocation changes will be discarded and the tyre layout will return to its last saved state.",
  	            {
  	              title: "Cancel Allocation Plan", type: "warning", confirmText: "Discard Plan", cancelText: "Keep Editing"
  	            }
  	          ))) {
  	            return;
  	          }

  	          lockTyreMovementState("Allocation cancelled. Tyre layout reset.");
  	        };
  	      }

  	      Array.prototype.forEach.call(closeButtons, function (button) {
  	        button.onclick = async function (event) {
  	          if (event && event.preventDefault) {
  	            event.preventDefault();
  	          }

  	          if (event && event.stopPropagation) {
  	            event.stopPropagation();
  	          }

  	          if (!(await confirmSafe(
  	            "All unsaved allocation changes will be discarded and the tyre layout will return to its last saved state.",
  	            {
  	              title: "Cancel Allocation Plan", type: "warning", confirmText: "Discard Plan", cancelText: "Keep Editing"
  	            }
  	          ))) {
  	            return;
  	          }

  	          lockTyreMovementState("Allocation cancelled. Tyre layout reset.");
  	        };
  	      });
  	    }

  	    function saveRotationPlanFromUi() {
  	      var odometer = getUiValue("tyreActionOdometer");
  	      var notes = getUiValue("tyreActionNotes");
  	      var arrows = getRotationArrows();
  	      var updatedVehicle;
  	      var originalTPositions;
  	      var finalTPositions;
  	      var tyresToSave = [];

  	      if (!arrows.length) {
  	        return Promise.reject(new Error("No tyre rotation changes to save."));
  	      }

  	      updatedVehicle = clone(state.activeTractor);
  	      originalTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	      finalTPositions = clone(getRotationDraftTPositions());

  	      arrows.forEach(function (arrow) {
  	        var tyre = findTyre(arrow.TyreObjectId);
  	        var originalSlot = getSlot(originalTPositions, arrow.FromPosition);
  	        var finalSlot = getSlot(finalTPositions, arrow.ToPosition);
  	        var updatedTyre;

  	        if (!tyre || !originalSlot || !finalSlot) {
  	          throw new Error("Rotation plan contains a tyre or position that could not be found.");
  	        }

  	        if (tyreMismatchInfo(tyre, finalSlot).HasMismatch && !mismatchAlreadyApproved(tyreObjectId(tyre), finalSlot.PositionKey)) {
  	          throw new Error("Tyre mismatch approval is required for " + arrow.FromPosition + " to " + arrow.ToPosition + ".");
  	        }

  	        updatedTyre = makeTyreMoved(
  	          tyre,
  	          originalSlot,
  	          finalSlot,
  	          odometer,
  	          notes,
  	          "Rotation"
  	        );

  	        tyresToSave.push(updatedTyre);

  	        appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	          "Rotation",
  	          arrow.FromPosition,
  	          arrow.ToPosition,
  	          updatedTyre,
  	          odometer,
  	          notes
  	        ));
  	      });

  	      writeTPositionsToVehicle(updatedVehicle,
  	        finalTPositions);

  	      return saveTyresSequentially(tyresToSave)
  	      .then(function () {
  	        return saveVehicleWithTPositions(updatedVehicle, finalTPositions);
  	      })
  	      .then(function () {
  	        state.selectedPosition = arrows[arrows.length - 1].ToPosition;
  	        resetRotationPlan();

  	        return "Rotation plan saved for " + arrows.length + " tyre movement" + (arrows.length === 1 ? ".": "s.");
  	      });
  	    }

  	    function saveAllocationPlanFromUi(button) {
  	      var popup = button && typeof button.closest === "function"
  	      ? button.closest("#allocationPlanPopup"): DocumentSafe.getElementById("allocationPlanPopup");
  	      var odometerInput = popup ? popup.querySelector("#tyreActionOdometer"): null;
  	      var notesInput = popup ? popup.querySelector("#tyreActionNotes"): null;
  	      var odometer = odometerInput ? clean(odometerInput.value): "";
  	      var notes = notesInput ? notesInput.value: "";
  	      var rows = getAllocationPlanRows();
  	      var updatedVehicle;
  	      var originalTPositions;
  	      var finalTPositions;
  	      var tyresToSave = [];
  	      var savedTyreIds = {};

  	      if (!rows.length) {
  	        return Promise.reject(new Error("No tyre changes to save."));
  	      }

  	      if (odometer === "") {
  	        return Promise.reject(new Error("Enter the vehicle odometer before saving tyre changes."));
  	      }

  	      updatedVehicle = clone(state.activeTractor);
  	      originalTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	      finalTPositions = clone(getRotationDraftTPositions());

  	      rows.forEach(function (row) {
  	        var tyre = findTyre(row.TyreObjectId);
  	        var fromSlot = row.FromPosition ? getSlot(originalTPositions, row.FromPosition): null;
  	        var toSlot = row.ToPosition ? getSlot(finalTPositions, row.ToPosition): null;
  	        var updatedTyre;

  	        if (!tyre || savedTyreIds[row.TyreObjectId]) {
  	          return;
  	        }

  	        if (row.Type === "Allocate") {
  	          if (!toSlot) {
  	            throw new Error("Target slot could not be found for " + row.TyreLabel + ".");
  	          }

  	          updatedTyre = makeTyreFitted(
  	            tyre,
  	            toSlot,
  	            odometer,
  	            notes,
  	            "Installed",
  	            "Warehouse"
  	          );

  	          appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	            "Installed",
  	            "Warehouse",
  	            toSlot.PositionKey,
  	            updatedTyre,
  	            odometer,
  	            notes
  	          ));
  	        }

  	        if (row.Type === "Move") {
  	          if (!fromSlot || !toSlot) {
  	            throw new Error("Move slot could not be found for " + row.TyreLabel + ".");
  	          }

  	          updatedTyre = makeTyreMoved(
  	            tyre,
  	            fromSlot,
  	            toSlot,
  	            odometer,
  	            notes,
  	            "Rotation"
  	          );

  	          appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	            "Rotation",
  	            fromSlot.PositionKey,
  	            toSlot.PositionKey,
  	            updatedTyre,
  	            odometer,
  	            notes
  	          ));
  	        }

  	        if (row.Type === "RemoveToWarehouse") {
  	          if (!fromSlot) {
  	            throw new Error("Remove slot could not be found for " + row.TyreLabel + ".");
  	          }

  	          updatedTyre = makeTyreRemoved(
  	            tyre,
  	            fromSlot,
  	            "Warehouse",
  	            odometer,
  	            notes
  	          );

  	          appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	            "Removed To Warehouse",
  	            fromSlot.PositionKey,
  	            "Warehouse",
  	            updatedTyre,
  	            odometer,
  	            notes
  	          ));
  	        }

  	        if (updatedTyre) {
  	          tyresToSave.push(updatedTyre);
  	          savedTyreIds[row.TyreObjectId] = true;
  	        }
  	      });

  	      writeTPositionsToVehicle(updatedVehicle,
  	        finalTPositions);

  	      if (button) {
  	        button.disabled = true;
  	        button.textContent = "Saving...";
  	      }

  	      return saveTyresSequentially(tyresToSave)
  	      .then(function () {
  	        return saveVehicleWithTPositions(updatedVehicle, finalTPositions);
  	      })
  	      .then(function () {
  	        state.selectedPosition = rows[rows.length - 1].ToPosition || rows[rows.length - 1].FromPosition || state.selectedPosition;

  	        lockTyreMovementState(
  	          "Saved " + rows.length + " tyre change" + (rows.length === 1 ? ".": "s.") + " Tyre movement locked."
  	        );

  	        if (typeof renderList === "function") {
  	          renderList(search && search.value ? search.value: "");
  	        }

  	        return state.actionMessage;
  	      });
  	    }

  	    function removeExistingPanels() {
  	      var oldList = hubEl.querySelector("#tractorListPanel");
  	      var oldEditor = hubEl.querySelector("#tractorEditorPanel");

  	      if (oldList) {
  	        oldList.remove();
  	      }

  	      if (oldEditor) {
  	        oldEditor.remove();
  	      }
  	    }

  	    removeExistingPanels();

  	    var state = {
  	      tractorArray: Tractors,
  	      tyreArray: collectTyres(),
  	      tyresLoaded: true,
  	      tyresLoading: null,

  	      editMode: false,
  	      activeTab: "Vehicle",
  	      activeTractor: null,

  	      tyrePositionsDraft: null,
  	      tyrePositionsDraftTractorId: "",

  	      selectedPosition: "",
  	      actionMode: "",
  	      actionMessage: "",
  	      actionError: false,

  	      pendingTyreAction: null,
  	      dragSource: null,
  	      tapSource: null,

  	      rotationDraftTPositions: null,
  	      rotationPlanStartedVehicleId: "",
  	      rotationMessage: "",

  	      allocatePopupOpen: false,
  	      allocateSearch: "",
  	      allocateTypeFilter: "",
  	      allocateSelectedTyreId: "",

  	      mismatchApprovals: {},
  	      rotationPopupOpen: false
  	    };

  	    var listPanel = DocumentSafe.createElement("div");
  	    listPanel.id = "tractorListPanel";

  	    Object.assign(listPanel.style, {
  	      position: "absolute",
  	      top: "50px",
  	      right: "0",
  	      width: "240px",
  	      bottom: "0",
  	      background: "rgba(20,20,20,0.96)",
  	      color: "#fff",
  	      zIndex: 900,
  	      overflowY: "auto",
  	      borderLeft: "2px solid #CC6633",
  	      boxShadow: "-2px 0 10px rgba(0,0,0,0.4)",
  	      fontFamily: "system-ui, sans-serif",
  	      transform: "translateX(100%)",
  	      opacity: "0",
  	      transition: "transform 0.35s ease, opacity 0.35s ease"
  	    });

  	    if (InlineMode) {
  	      listPanel.style.display = "none";
  	      listPanel.style.width = "0";
  	      listPanel.style.pointerEvents = "none";
  	    }

  	    hubEl.appendChild(listPanel);

  	    setTimeout(function () {
  	      listPanel.style.transform = "translateX(0)";
  	      listPanel.style.opacity = "1";
  	    }, 0);

  	    var listTopBar = DocumentSafe.createElement("div");

  	    Object.assign(listTopBar.style, {
  	      display: "flex",
  	      justifyContent: "space-between",
  	      alignItems: "center",
  	      padding: "8px 10px",
  	      borderBottom: "1px solid rgba(204,102,51,0.4)",
  	      background: "rgba(30,30,30,0.9)",
  	      position: "sticky",
  	      top: "0",
  	      zIndex: 10
  	    });

  	    var listTitle = DocumentSafe.createElement("div");
  	    listTitle.textContent = "Tractors";

  	    Object.assign(listTitle.style, {
  	      fontWeight: "600",
  	      color: "#CC6633",
  	      fontSize: "13px"
  	    });

  	    var listCloseBtn = DocumentSafe.createElement("div");
  	    listCloseBtn.textContent = "✕";

  	    Object.assign(listCloseBtn.style, {
  	      cursor: "pointer",
  	      fontSize: "14px",
  	      padding: "2px 6px",
  	      borderRadius: "4px"
  	    });

  	    listCloseBtn.onclick = function () {
  	      var editor = hubEl.querySelector("#tractorEditorPanel");

  	      listPanel.style.transform = "translateX(100%)";
  	      listPanel.style.opacity = "0";

  	      if (editor) {
  	        editor.remove();
  	      }

  	      setTimeout(function () {
  	        if (listPanel && listPanel.parentNode) {
  	          listPanel.remove();
  	        }
  	      },
  	        400);
  	    };

  	    listTopBar.appendChild(listTitle);
  	    listTopBar.appendChild(listCloseBtn);
  	    listPanel.appendChild(listTopBar);

  	    var search = DocumentSafe.createElement("input");
  	    search.type = "text";
  	    search.placeholder = "🔍 Search tractor...";

  	    Object.assign(search.style,
  	      {
  	        width: "calc(100% - 16px)",
  	        padding: "6px 8px",
  	        margin: "6px 8px",
  	        border: "none",
  	        borderRadius: "6px",
  	        background: "#222",
  	        color: "#fff",
  	        outline: "none",
  	        fontSize: "13px",
  	        boxSizing: "border-box"
  	      });

  	    listPanel.appendChild(search);

  	    var listBody = DocumentSafe.createElement("div");
  	    listPanel.appendChild(listBody);

  	    function renderList(filter) {
  	      var query = clean(filter).toLowerCase();

  	      listBody.innerHTML = "";

  	      state.tractorArray
  	      .filter(function (tractor) {
  	        var id = clean(vehicleId(tractor) || vehicleObjectId(tractor)).toLowerCase();
  	        var make = clean(vehicleMake(tractor)).toLowerCase();
  	        var model = clean(vehicleModel(tractor)).toLowerCase();
  	        var reg = clean(vehicleReg(tractor)).toLowerCase();

  	        return (
  	          id.indexOf(query) !== -1 ||
  	          make.indexOf(query) !== -1 ||
  	          model.indexOf(query) !== -1 ||
  	          reg.indexOf(query) !== -1
  	        );
  	      })
  	      .forEach(function (tractor) {
  	        var card = DocumentSafe.createElement("div");
  	        var color = cardColor(tractor);
  	        var id = vehicleId(tractor) || vehicleObjectId(tractor);
  	        var make = vehicleMake(tractor);
  	        var model = vehicleModel(tractor);
  	        var reg = vehicleReg(tractor);

  	        Object.assign(card.style, {
  	          background: "#1b1b1b",
  	          padding: "8px",
  	          margin: "6px 8px",
  	          borderRadius: "8px",
  	          cursor: "pointer",
  	          boxShadow: "0 0 4px rgba(0,0,0,0.3)",
  	          fontSize: "12px"
  	        });

  	        card.innerHTML = ""
  	        + "<div style=\"display:flex;align-items:center;font-size:14px;font-weight:600;margin-bottom:4px;\">"
  	        + "  <div style=\"width:12px;height:12px;border-radius:50%;background:" + escapeHtml(color) + ";margin-right:6px;\"></div>"
  	        + "  " + escapeHtml(id)
  	        + "</div>"
  	        + "<div style=\"color:#aaa;font-size:12px;\">" + escapeHtml(clean(make + " " + model)) + "</div>"
  	        + (reg ? "<div style=\"color:#777;font-size:11px;margin-top:2px;\">" + escapeHtml(reg) + "</div>": "");

  	        card.onclick = function () {
  	          openEditor(tractor);
  	        };

  	        listBody.appendChild(card);
  	      });
  	    }

  	    search.addEventListener("input",
  	      function (event) {
  	        renderList(event.target.value);
  	      });

  	    renderList("");

  	    function getOptionsForWrappedNode(node) {
  	      if (node && Array.isArray(node.options)) {
  	        return node.options;
  	      }

  	      return [];
  	    }

  	    function renderField(selector, path, node, editMode) {
  	      var value = node && Object.prototype.hasOwnProperty.call(node, "value")
  	      ? node.value: node;

  	      var editable = !!(node && node.editable);
  	      var disabled = !editMode || !editable ? "disabled": "";
  	      var dim = !editable ? "opacity:0.6;": "";
  	      var label = prettyName(String(path || "").split(".").pop());
  	      var bind = path + ".value";
  	      var options;
  	      var html;

  	      if (selector === "boolean") {
  	        return ""
  	        + "<label style=\"display:flex;align-items:center;margin:6px 0;" + dim + "\">"
  	        + "  <span style=\"margin-right:6px\">" + escapeHtml(label) + "</span>"
  	        + "  <input type=\"checkbox\" data-bind=\"" + escapeHtml(bind) + "\" " + (value ? "checked": "") + " " + disabled + ">"
  	        + "</label>";
  	      }

  	      if (selector === "textarea") {
  	        return ""
  	        + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	        + "<textarea data-bind=\"" + escapeHtml(bind) + "\" " + disabled + " style=\"width:100%;min-height:80px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">"
  	        + escapeHtml(value || "")
  	        + "</textarea>";
  	      }

  	      if (selector === "number" || selector === "currency") {
  	        return ""
  	        + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	        + "<input type=\"number\" step=\"" + (selector === "currency" ? "0.01": "any") + "\" data-bind=\"" + escapeHtml(bind) + "\" value=\"" + escapeHtml(value == null ? "": value) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";
  	      }

  	      if (selector === "date" || selector === "time" || selector === "datetime") {
  	        return ""
  	        + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	        + "<input type=\"" + (selector === "datetime" ? "datetime-local": selector) + "\" data-bind=\"" + escapeHtml(bind) + "\" value=\"" + escapeHtml(value == null ? "": value) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";
  	      }

  	      if (selector === "select") {
  	        options = getOptionsForWrappedNode(node);
  	        html = ""
  	        + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	        + "<select data-bind=\"" + escapeHtml(bind) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";

  	        options.forEach(function (option) {
  	          html += "<option value=\"" + escapeHtml(option) + "\" " + (value === option ? "selected": "") + ">" + escapeHtml(option) + "</option>";
  	        });

  	        html += "</select>";

  	        return html;
  	      }

  	      if (selector === "image") {
  	        return ""
  	        + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	        + "<div style=\"margin:8px 0;\">"
  	        + (
  	          value
  	          ? "<img src=\"" + escapeHtml(value) + "\" style=\"max-width:100%;max-height:200px;border-radius:8px;background:#000;padding:6px;\">": "<div style=\"height:160px;border:1px dashed #666;border-radius:8px;background:#111;display:flex;align-items:center;justify-content:center;color:#666;\">No Image</div>"
  	        )
  	        + "</div>"
  	        + "<button " + disabled + " data-bind=\"" + escapeHtml(bind) + "\" data-media-action=\"choose\" style=\"width:100%;padding:6px;background:#444;color:#fff;border:none;border-radius:6px;" + dim + "\">"
  	        + (value ? "Replace Image": "Add Image")
  	        + "</button>";
  	      }

  	      if (selector === "email" || selector === "phone" || selector === "password") {
  	        return ""
  	        + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	        + "<input type=\"" + (selector === "phone" ? "tel": selector) + "\" data-bind=\"" + escapeHtml(bind) + "\" value=\"" + escapeHtml(value == null ? "": value) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";
  	      }

  	      return ""
  	      + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	      + "<input type=\"text\" data-bind=\"" + escapeHtml(bind) + "\" value=\"" + escapeHtml(value == null ? "": value) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";
  	    }

  	    function buildForm(obj, basePath) {
  	      var html = "";

  	      if (!obj || typeof obj !== "object") {
  	        return "<div style=\"color:#777;\">No Data</div>";
  	      }

  	      Object.keys(obj).forEach(function (key) {
  	        var raw = obj[key];
  	        var fullPath = basePath ? basePath + "." + key: key;
  	        var selector;

  	        if (isWrapped(raw)) {
  	          selector = raw.selector || "text";
  	          html += renderField(selector, fullPath, raw, state.editMode);
  	          return;
  	        }

  	        if (Array.isArray(raw)) {
  	          html += ""
  	          + "<div style=\"margin-top:12px;font-weight:600;color:#CC6633;\">" + escapeHtml(prettyName(key)) + "</div>"
  	          + "<div style=\"margin-left:10px;border-left:2px solid #333;padding-left:10px;\">";

  	          if (!raw.length) {
  	            html += "<div style=\"color:#777;\">(empty)</div>";
  	          } else {
  	            raw.forEach(function (item, index) {
  	              html += ""
  	              + "<div style=\"margin-top:8px;\">"
  	              + "  <div style=\"color:#999;font-size:11px;\">[" + index + "]</div>"
  	              + buildForm(item, fullPath + "[" + index + "]")
  	              + "</div>";
  	            });
  	          }

  	          html += "</div>";
  	          return;
  	        }

  	        if (raw && typeof raw === "object") {
  	          html += ""
  	          + "<div style=\"margin-top:12px;font-weight:600;color:#CC6633;\">" + escapeHtml(prettyName(key)) + "</div>"
  	          + "<div style=\"margin-left:10px;border-left:2px solid #333;padding-left:10px;\">"
  	          + buildForm(raw, fullPath)
  	          + "</div>";
  	          return;
  	        }

  	        html += renderField("text", fullPath, {
  	          value: raw,
  	          editable: true,
  	          selector: "text"
  	        }, state.editMode);
  	      });

  	      return html;
  	    }

  	    function applyBoundInputsToVehicle(vehicle,
  	      panel) {
  	      var inputs = panel.querySelectorAll("[data-bind]");
  	      var i;
  	      var input;
  	      var bind;
  	      var tokens;
  	      var value;

  	      if (!vehicle.Data) {
  	        vehicle.Data = {};
  	      }

  	      for (i = 0; i < inputs.length; i++) {
  	        input = inputs[i];

  	        if (input.disabled) {
  	          continue;
  	        }

  	        bind = input.getAttribute("data-bind");

  	        if (!bind) {
  	          continue;
  	        }

  	        value = readInputValue(input);

  	        tokens = tokenizePath(bind);
  	        setByTokens(vehicle.Data, tokens, value);
  	      }
  	    }

  	    function openEditor(tractor) {
  	      var existingEditor;
  	      var editorPanel;
  	      var header;
  	      var titleWrap;
  	      var headTitle;
  	      var fidRow;
  	      var fidLabel;
  	      var fidInput;
  	      var editBtn;
  	      var tabBar;
  	      var body;
  	      var controlBar;
  	      var cancelBtn;
  	      var saveBtn;

  	      state.activeTractor = tractor;
  	      state.editMode = false;
  	      state.activeTab = "Vehicle";

  	      state.tyrePositionsDraft = null;
  	      state.tyrePositionsDraftTractorId = "";

  	      state.selectedPosition = "";
  	      state.actionMode = "";
  	      state.actionMessage = "";
  	      state.actionError = false;

  	      state.pendingTyreAction = null;
  	      state.dragSource = null;
  	      state.tapSource = null;

  	      state.rotationDraftTPositions = null;
  	      state.rotationPlanStartedVehicleId = "";
  	      state.rotationMessage = "";

  	      state.allocatePopupOpen = false;
  	      state.allocateSearch = "";
  	      state.allocateTypeFilter = "";
  	      state.allocateSelectedTyreId = "";

  	      state.mismatchApprovals = {};
  	      state.rotationPopupOpen = false;

  	      existingEditor = hubEl.querySelector("#tractorEditorPanel");

  	      if (existingEditor) {
  	        existingEditor.remove();
  	      }

  	      loadTyres().then(function () {
  	        if (
  	          state.activeTractor &&
  	          vehicleObjectId(state.activeTractor) === vehicleObjectId(tractor) &&
  	          state.activeTab === "Tyres"
  	        ) {
  	          renderTab("Tyres");
  	        }
  	      });

  	      editorPanel = DocumentSafe.createElement("div");
  	      editorPanel.id = "tractorEditorPanel";

  	      Object.assign(editorPanel.style,
  	        {
  	          position: "absolute",
  	          top: "50px",
  	          left: "0",
  	          right: "240px",
  	          bottom: "0",
  	          background: "rgba(20,20,20,0.96)",
  	          color: "#fff",
  	          zIndex: 901,
  	          borderRight: "2px solid #CC6633",
  	          boxShadow: "2px 0 10px rgba(0,0,0,0.4)",
  	          fontFamily: "system-ui, sans-serif",
  	          transform: "translateX(-100%)",
  	          opacity: "0",
  	          transition: "transform 0.35s ease, opacity 0.35s ease",
  	          display: "flex",
  	          flexDirection: "column",
  	          overflow: "hidden"
  	        });

  	      if (InlineMode) {
  	        Object.assign(editorPanel.style, {
  	          position: "relative",
  	          top: "0",
  	          left: "0",
  	          right: "auto",
  	          bottom: "auto",
  	          width: "100%",
  	          minHeight: "680px",
  	          height: "auto",
  	          zIndex: "1",
  	          borderRight: "0",
  	          boxShadow: "none",
  	          transform: "none",
  	          opacity: "1",
  	          transition: "none",
  	          background: "transparent"
  	        });
  	      }

  	      hubEl.appendChild(editorPanel);

  	      setTimeout(function () {
  	        editorPanel.style.transform = "translateX(0)";
  	        editorPanel.style.opacity = "1";
  	      },
  	        0);

  	      header = DocumentSafe.createElement("div");

  	      Object.assign(header.style,
  	        {
  	          display: "flex",
  	          justifyContent: "space-between",
  	          alignItems: "flex-start",
  	          padding: "10px 12px",
  	          borderBottom: "1px solid #333",
  	          background: "#1a1a1a",
  	          flex: "0 0 auto",
  	          gap: "10px"
  	        });

  	      titleWrap = DocumentSafe.createElement("div");

  	      Object.assign(titleWrap.style,
  	        {
  	          display: "flex",
  	          flexDirection: "column",
  	          minWidth: "0"
  	        });

  	      headTitle = DocumentSafe.createElement("div");
  	      headTitle.textContent = vehicleTitle(tractor);

  	      Object.assign(headTitle.style,
  	        {
  	          fontSize: "16px",
  	          fontWeight: "600",
  	          color: "#CC6633",
  	          lineHeight: "1.2",
  	          whiteSpace: "nowrap",
  	          overflow: "hidden",
  	          textOverflow: "ellipsis",
  	          maxWidth: "520px"
  	        });

  	      fidRow = DocumentSafe.createElement("div");

  	      Object.assign(fidRow.style,
  	        {
  	          display: "flex",
  	          alignItems: "center",
  	          gap: "8px",
  	          marginTop: "8px"
  	        });

  	      fidLabel = DocumentSafe.createElement("div");
  	      fidLabel.textContent = "FID";

  	      Object.assign(fidLabel.style,
  	        {
  	          fontSize: "12px",
  	          color: "#aaa",
  	          minWidth: "34px"
  	        });

  	      fidInput = DocumentSafe.createElement("input");
  	      fidInput.type = "text";
  	      fidInput.value = fifVehicleIdentityValue(tractor, "FID", "") || "";
  	      fidInput.dataset.bind = "Vehicle.Identity.FID.value";
  	      fidInput.disabled = true;

  	      Object.assign(fidInput.style,
  	        {
  	          width: "200px",
  	          padding: "6px 8px",
  	          border: "1px solid #555",
  	          borderRadius: "6px",
  	          background: "#111",
  	          color: "#fff",
  	          outline: "none",
  	          fontSize: "13px"
  	        });

  	      fidRow.appendChild(fidLabel);
  	      fidRow.appendChild(fidInput);

  	      titleWrap.appendChild(headTitle);
  	      titleWrap.appendChild(fidRow);

  	      editBtn = DocumentSafe.createElement("button");
  	      editBtn.id = "tractorEditBtn";
  	      editBtn.textContent = "Edit";

  	      Object.assign(editBtn.style,
  	        {
  	          background: "#CC6633",
  	          color: "#fff",
  	          border: "none",
  	          padding: "6px 12px",
  	          borderRadius: "6px",
  	          cursor: "pointer",
  	          fontSize: "13px",
  	          flex: "0 0 auto"
  	        });

  	      header.appendChild(titleWrap);
  	      header.appendChild(editBtn);
  	      editorPanel.appendChild(header);

  	      if (InlineMode) {
  	        header.style.display = "none";
  	      }

  	      tabBar = DocumentSafe.createElement("div");

  	      Object.assign(tabBar.style,
  	        {
  	          display: "flex",
  	          borderBottom: "1px solid #333",
  	          background: "#1a1a1a",
  	          flex: "0 0 auto",
  	          padding: "0 5px",
  	          overflowX: "auto"
  	        });

  	      editorPanel.appendChild(tabBar);

  	      if (InlineMode) {
  	        tabBar.style.display = "none";
  	      }

  	      body = DocumentSafe.createElement("div");

  	      Object.assign(body.style,
  	        {
  	          flex: "1 1 auto",
  	          overflowY: "auto",
  	          padding: "12px 15px 20px",
  	          position: "relative"
  	        });

  	      if (InlineMode) {
  	        Object.assign(body.style, {
  	          padding: "0",
  	          overflowY: "visible",
  	          minHeight: "640px"
  	        });
  	      }

  	      editorPanel.appendChild(body);

  	      controlBar = DocumentSafe.createElement("div");

  	      Object.assign(controlBar.style,
  	        {
  	          display: "none",
  	          justifyContent: "flex-end",
  	          gap: "10px",
  	          padding: "10px 15px",
  	          borderTop: "1px solid #333",
  	          background: "#1a1a1a",
  	          flex: "0 0 auto"
  	        });

  	      cancelBtn = DocumentSafe.createElement("button");
  	      cancelBtn.textContent = "Cancel";

  	      Object.assign(cancelBtn.style,
  	        {
  	          background: "#555",
  	          color: "#fff",
  	          border: "none",
  	          padding: "6px 14px",
  	          borderRadius: "6px",
  	          cursor: "pointer",
  	          fontSize: "14px"
  	        });

  	      saveBtn = DocumentSafe.createElement("button");
  	      saveBtn.textContent = "Save";

  	      Object.assign(saveBtn.style,
  	        {
  	          background: "#2a8f3a",
  	          color: "#fff",
  	          border: "none",
  	          padding: "6px 14px",
  	          borderRadius: "6px",
  	          cursor: "pointer",
  	          fontSize: "14px"
  	        });

  	      controlBar.appendChild(cancelBtn);
  	      controlBar.appendChild(saveBtn);
  	      editorPanel.appendChild(controlBar);

  	      var TAB_DEFS = [{
  	        label: "Vehicle",
  	        key: "Vehicle"
  	      },
  	        {
  	          label: "Tyres",
  	          key: "__TYRES__"
  	        },
  	        {
  	          label: "Compliance",
  	          key: "Compliance"
  	        },
  	        {
  	          label: "Ownership",
  	          key: "Ownership"
  	        },
  	        {
  	          label: "Service",
  	          key: "Service"
  	        },
  	        {
  	          label: "Financials",
  	          key: "Financials"
  	        },
  	        {
  	          label: "Operational Targets",
  	          key: "OperationalTargets"
  	        },
  	        {
  	          label: "Financial Targets",
  	          key: "FinancialTargets"
  	        },
  	        {
  	          label: "Media",
  	          key: "Media"
  	        }];

  	      function renderTabButtons() {
  	        tabBar.innerHTML = "";

  	        TAB_DEFS.forEach(function (def) {
  	          var tab = DocumentSafe.createElement("div");
  	          var active = state.activeTab === def.label;

  	          tab.textContent = def.label;
  	          tab.dataset.tabName = def.label;

  	          Object.assign(tab.style, {
  	            padding: "10px 20px",
  	            cursor: "pointer",
  	            fontSize: "13px",
  	            color: active ? "#fff": "#ccc",
  	            background: active ? "#242424": "#1a1a1a",
  	            borderBottom: active ? "2px solid #CC6633": "2px solid transparent",
  	            whiteSpace: "nowrap"
  	          });

  	          tab.onclick = function () {
  	            setActiveTab(def.label);
  	          };

  	          tabBar.appendChild(tab);
  	        });
  	      }

  	      function getDraftTPositions() {
  	        if (
  	          state.tyrePositionsDraft &&
  	          state.tyrePositionsDraftTractorId === vehicleObjectId(tractor)
  	        ) {
  	          return state.tyrePositionsDraft;
  	        }

  	        state.tyrePositionsDraft = normaliseTPositions(readTPositionsRaw(tractor));
  	        state.tyrePositionsDraftTractorId = vehicleObjectId(tractor);

  	        return state.tyrePositionsDraft;
  	      }

  	      function resetDraftTPositions() {
  	        state.tyrePositionsDraft = null;
  	        state.tyrePositionsDraftTractorId = "";
  	      }

  	      function setPreset4x2(draft) {
  	        draft.Axles = [{
  	          Axle: 1,
  	          Type: "Steer",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	          {
  	            Axle: 2,
  	            Type: "Drive",
  	            TyresPerSide: 1,
  	            WearRate: 1,
  	            Enabled: true
  	          }];

  	        applyAxleRules(draft, false);
  	        rebuildSlots(draft);
  	      }

  	      function setPreset6x2Tag(draft) {
  	        draft.Axles = [{
  	          Axle: 1,
  	          Type: "Steer",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	          {
  	            Axle: 2,
  	            Type: "Tag",
  	            TyresPerSide: 1,
  	            WearRate: 0.35,
  	            Enabled: true
  	          },
  	          {
  	            Axle: 3,
  	            Type: "Drive",
  	            TyresPerSide: 1,
  	            WearRate: 1,
  	            Enabled: true
  	          }];

  	        applyAxleRules(draft, false);
  	        rebuildSlots(draft);
  	      }

  	      function setPreset6x4(draft) {
  	        draft.Axles = [{
  	          Axle: 1,
  	          Type: "Steer",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	          {
  	            Axle: 2,
  	            Type: "Drive",
  	            TyresPerSide: 1,
  	            WearRate: 1,
  	            Enabled: true
  	          },
  	          {
  	            Axle: 3,
  	            Type: "Drive",
  	            TyresPerSide: 1,
  	            WearRate: 1,
  	            Enabled: true
  	          }];

  	        applyAxleRules(draft, false);
  	        rebuildSlots(draft);
  	      }

  	      function setPreset8x4(draft) {
  	        draft.Axles = [{
  	          Axle: 1,
  	          Type: "Steer",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	          {
  	            Axle: 2,
  	            Type: "Steer",
  	            TyresPerSide: 1,
  	            WearRate: 1,
  	            Enabled: true
  	          },
  	          {
  	            Axle: 3,
  	            Type: "Drive",
  	            TyresPerSide: 1,
  	            WearRate: 1,
  	            Enabled: true
  	          },
  	          {
  	            Axle: 4,
  	            Type: "Drive",
  	            TyresPerSide: 1,
  	            WearRate: 1,
  	            Enabled: true
  	          }];

  	        applyAxleRules(draft, false);
  	        rebuildSlots(draft);
  	      }

  	      function tyreTreadHtml(color, selected, dropReady) {
  	        return ""
  	        + "<div style=\""
  	        + "width:100%;"
  	        + "height:34px;"
  	        + "border-radius:4px;"
  	        + "background:" + escapeHtml(color) + ";"
  	        + "border:" + (selected ? "2px solid #ffffff": dropReady ? "2px solid #CC6633": "1px solid rgba(0,0,0,0.85)") + ";"
  	        + "box-shadow:inset 0 0 0 1px rgba(255,255,255,0.18),0 1px 2px rgba(0,0,0,0.45);"
  	        + "background-image:"
  	        + "repeating-linear-gradient(135deg,rgba(0,0,0,0.72) 0px,rgba(0,0,0,0.72) 3px,transparent 3px,transparent 7px),"
  	        + "repeating-linear-gradient(45deg,rgba(0,0,0,0.55) 0px,rgba(0,0,0,0.55) 2px,transparent 2px,transparent 6px);"
  	        + "\"></div>";
  	      }

  	      function tyreSlotHtml(slot) {
  	        var tyreId = clean(slot && slot.TyreObjectId);
  	        var tyre = tyreId ? findTyre(tyreId): null;
  	        var selectedPosition = state.selectedPosition === slot.PositionKey;
  	        var selectedTapSource =
  	        state.tapSource &&
  	        state.tapSource.SourceType === "fitted" &&
  	        state.tapSource.SourcePosition === slot.PositionKey;

  	        var selectedDragSource =
  	        state.dragSource &&
  	        state.dragSource.SourceType === "fitted" &&
  	        state.dragSource.SourcePosition === slot.PositionKey;

  	        var selected = selectedPosition || selectedTapSource || selectedDragSource;
  	        var dropReady = (state.actionMode === "RotateSwap" || state.actionMode === "Allocate") && (state.tapSource || state.dragSource);
  	        var canDragFitted = (state.actionMode === "RotateSwap" || state.actionMode === "Allocate") && !!tyreId;
  	        var color = tyre ? tyreColor(tyre): tyreId ? "#6b7280": "#263044";
  	        var label = tyre ? tyreName(tyre): tyreId ? tyreId: "Empty";
  	        var life = tyre ? tyreLife(tyre): null;
  	        var lifeLabel = life === null ? "No data": life.toFixed(1) + "%";
  	        var selectedStyle = selected
  	        ? "background:rgba(204,102,51,0.22);outline:3px solid #CC6633;box-shadow:0 0 0 2px rgba(255,255,255,0.18),0 0 18px rgba(204,102,51,0.7);": "background:transparent;outline:1px solid transparent;box-shadow:none;";

  	        return ""
  	        + "<div class=\"trac-tyre-slot\" "
  	        + "draggable=\"" + (canDragFitted ? "true": "false") + "\" "
  	        + "data-source-type=\"fitted\" "
  	        + "data-position-key=\"" + escapeHtml(slot.PositionKey) + "\" "
  	        + "data-source-position=\"" + escapeHtml(slot.PositionKey) + "\" "
  	        + "data-tyre-object-id=\"" + escapeHtml(tyreId) + "\" "
  	        + "title=\"" + escapeHtml(slot.PositionKey + " • " + label + " • " + lifeLabel) + "\" "
  	        + "style=\"cursor:" + (canDragFitted ? "grab": "pointer") + ";padding:5px;border-radius:8px;transition:background .12s,outline .12s,box-shadow .12s,transform .12s;" + selectedStyle + "\">"
  	        + tyreTreadHtml(color, selected, !!dropReady)
  	        + "<div style=\"margin-top:4px;color:" + (selected ? "#fff": "#9ca3af") + ";font-size:10px;font-weight:" + (selected ? "900": "600") + ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;\">"
  	        + escapeHtml(slot.PositionKey)
  	        + "</div>"
  	        + "</div>";
  	      }

  	      function renderSmallTyreDisplay(slot) {
  	        var tyreId = clean(slot && slot.TyreObjectId);
  	        var tyre = tyreId ? findTyre(tyreId): null;
  	        var label = tyre ? tyreName(tyre): tyreId ? tyreId: "No tyre assigned";

  	        return ""
  	        + "<div style=\"width:100%;padding:7px 8px;border:1px solid #333;border-radius:6px;background:#111;color:#bbb;font-size:12px;min-height:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\">"
  	        + escapeHtml(label)
  	        + "</div>";
  	      }

  	      function renderWearLegend() {
  	        var items = [{
  	          label: "80-100%",
  	          color: "#39ff14"
  	        },
  	          {
  	            label: "60-79%",
  	            color: "#a6ff33"
  	          },
  	          {
  	            label: "40-59%",
  	            color: "#ffd633"
  	          },
  	          {
  	            label: "20-39%",
  	            color: "#ff8a00"
  	          },
  	          {
  	            label: "1-19%",
  	            color: "#ff2b1a"
  	          },
  	          {
  	            label: "0%",
  	            color: "#111827"
  	          },
  	          {
  	            label: "No data",
  	            color: "#6b7280"
  	          }];

  	        return ""
  	        + "<div style=\"display:flex;flex-wrap:wrap;gap:8px;margin-bottom:10px;\">"
  	        + items.map(function (item) {
  	          return ""
  	          + "<div style=\"display:flex;align-items:center;gap:5px;color:#aaa;font-size:11px;\">"
  	          + "  <div style=\"width:22px;height:12px;border-radius:3px;background:" + escapeHtml(item.color) + ";border:1px solid rgba(0,0,0,0.8);\"></div>"
  	          + "  " + escapeHtml(item.label)
  	          + "</div>";
  	        }).join("")
  	        + "</div>";
  	      }

  	      function axleVisualHtml(tPositions, axle) {
  	        var leftSlots = slotsForAxle(tPositions, axle.Axle, "L");
  	        var rightSlots = slotsForAxle(tPositions, axle.Axle, "R");

  	        return ""
  	        + "<div style=\""
  	        + "width:190px;min-height:370px;background:#253044;"
  	        + "border-left:6px solid #6b7280;border-right:6px solid #6b7280;"
  	        + "position:relative;box-shadow:0 0 0 1px rgba(255,255,255,0.04);"
  	        + "display:flex;flex-direction:column;justify-content:space-between;"
  	        + "padding:10px 8px;"
  	        + "\">"
  	        + "  <div style=\"position:absolute;top:8px;left:8px;right:8px;display:flex;gap:5px;flex-direction:column;\">"
  	        + (
  	          leftSlots.length
  	          ? leftSlots.map(tyreSlotHtml).join(""): "<div style=\"height:38px;color:#64748b;font-size:11px;text-align:center;\">No left tyres</div>"
  	        )
  	        + "  </div>"
  	        + "  <div style=\"position:absolute;top:50%;left:0;right:0;transform:translateY(-50%);text-align:center;color:#cbd5e1;font-size:12px;font-weight:800;opacity:0.75;\">"
  	        + "    A" + escapeHtml(axle.Axle) + "<br>"
  	        + "    <span style=\"font-size:10px;font-weight:600;\">" + escapeHtml(axle.Type) + "</span>"
  	        + (
  	          axle.Type === "Tag"
  	          ? "<br><span style=\"font-size:10px;color:#facc15;\">Wear " + escapeHtml(axle.WearRate) + "</span>": ""
  	        )
  	        + "  </div>"
  	        + "  <div style=\"position:absolute;bottom:8px;left:8px;right:8px;display:flex;gap:5px;flex-direction:column;\">"
  	        + (
  	          rightSlots.length
  	          ? rightSlots.map(tyreSlotHtml).join(""): "<div style=\"height:38px;color:#64748b;font-size:11px;text-align:center;\">No right tyres</div>"
  	        )
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      function selectedTyreDetailHtml(tPositions) {
  	        var slot = getSlot(tPositions, state.selectedPosition);
  	        var tyreId = slot ? clean(slot.TyreObjectId): "";
  	        var tyre = tyreId ? findTyre(tyreId): null;
  	        var life = tyre ? tyreLife(tyre): null;

  	        if (!slot) {
  	          return "";
  	        }

  	        return ""
  	        + "<div style=\"border:1px solid #333;border-radius:8px;background:#101010;overflow:hidden;margin-bottom:10px;\">"
  	        + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Selected Position</div>"
  	        + "  <div style=\"padding:12px;\">"
  	        + "    <div style=\"margin-bottom:10px;\">" + tyreTreadHtml(tyre ? tyreColor(tyre): tyreId ? "#6b7280": "#263044", true, false) + "</div>"
  	        + "    <div style=\"display:grid;grid-template-columns:130px 1fr;gap:6px 10px;font-size:12px;\">"
  	        + "      <div style=\"color:#888;\">Position</div><div style=\"color:#fff;font-weight:700;\">" + escapeHtml(slot.PositionKey) + "</div>"
  	        + "      <div style=\"color:#888;\">Axle Type</div><div style=\"color:#fff;\">" + escapeHtml(slot.AxleType || "") + "</div>"
  	        + "      <div style=\"color:#888;\">Wear Rate</div><div style=\"color:#fff;\">" + escapeHtml(slot.WearRate == null ? "": slot.WearRate) + "</div>"
  	        + "      <div style=\"color:#888;\">Tyre</div><div style=\"color:#fff;\">" + escapeHtml(tyre ? tyreName(tyre): tyreId ? tyreId: "Empty") + "</div>"
  	        + "      <div style=\"color:#888;\">Type Required</div><div style=\"color:#fff;\">" + escapeHtml(requiredTyreTypeForSlot(slot)) + "</div>"
  	        + "      <div style=\"color:#888;\">Tyre Status</div><div style=\"color:#fff;\">" + escapeHtml(tyre ? tyreStatus(tyre): "") + "</div>"
  	        + "      <div style=\"color:#888;\">Current Life</div><div style=\"color:#fff;\">" + escapeHtml(life == null ? "": life.toFixed(1) + "%") + "</div>"
  	        + "      <div style=\"color:#888;\">Current Mileage</div><div style=\"color:#fff;\">" + escapeHtml(tyre && tyre.Current_Mileage != null ? tyre.Current_Mileage: "") + "</div>"
  	        + "      <div style=\"color:#888;\">Expected Mileage</div><div style=\"color:#fff;\">" + escapeHtml(tyre && tyre.Expected_Mileage != null ? tyre.Expected_Mileage: "") + "</div>"
  	        + "    </div>"
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      function actionInputsHtml(notePlaceholder) {
  	        return ""
  	        + "<div style=\"padding:8px 0;border-top:1px solid #252525;\">"
  	        + "  <label style=\"display:block;color:#9c9c9c;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	        + "  <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:7px;border:1px solid #343434;border-radius:6px;background:#151515;color:#fff;\">"
  	        + "</div>"
  	        + "<div style=\"padding:8px 0;\">"
  	        + "  <label style=\"display:block;color:#9c9c9c;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	        + "  <textarea id=\"tyreActionNotes\" placeholder=\"" + escapeHtml(notePlaceholder || "Notes") + "\" style=\"width:100%;box-sizing:border-box;min-height:52px;padding:7px;border:1px solid #343434;border-radius:6px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	        + "</div>";
  	      }

  	      function pendingPreviewHtml() {
  	        var pending = state.pendingTyreAction;
  	        var validation = pending ? validatePendingStillPossible(): null;

  	        if (!pending) {
  	          return "";
  	        }

  	        return ""
  	        + "<div style=\"border:1px solid " + (validation && validation.ok ? "#2a8f3a": "#7f1d1d") + ";background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	        + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Pending Allocation</div>"
  	        + "  <div style=\"padding:11px 12px;\">"
  	        + "    <div style=\"color:#fff;font-size:13px;font-weight:800;margin-bottom:6px;\">" + escapeHtml(pendingActionLabel()) + "</div>"
  	        + "    <div style=\"color:" + (validation && validation.ok ? "#9ca3af": "#ff4d4f") + ";font-size:12px;margin-bottom:8px;\">"
  	        + escapeHtml(validation && validation.ok ? pending.Preview: validation.message)
  	        + "    </div>"
  	        + actionInputsHtml("Allocation notes")
  	        + "    <div style=\"display:flex;gap:8px;padding:10px 0 0;\">"
  	        + "      <button id=\"tyreConfirmPendingBtn\" type=\"button\" " + (validation && validation.ok ? "": "disabled") + " style=\"background:#2a8f3a;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:800;opacity:" + (validation && validation.ok ? "1": "0.5") + ";\">Confirm Allocation</button>"
  	        + "      <button id=\"tyreClearPendingBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:800;\">Clear</button>"
  	        + "    </div>"
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      function selectedRemovableTyreSlot() {
  	        var currentVehicle;
  	        var tPositions;
  	        var slot;

  	        if (state.actionMode === "Allocate" || state.actionMode === "RotateSwap") {
  	          return null;
  	        }

  	        if (!state.selectedPosition) {
  	          return null;
  	        }

  	        currentVehicle = state.activeTractor || tractor;
  	        tPositions = normaliseTPositions(readTPositionsRaw(currentVehicle));
  	        slot = getSlot(tPositions, state.selectedPosition);

  	        if (!slot || !slot.TyreObjectId) {
  	          return null;
  	        }

  	        return slot;
  	      }

  	      function tyreModeButtonHtml(mode, label) {
  	        var active = state.actionMode === mode;

  	        return ""
  	        + "<button type=\"button\" class=\"trac-tyre-mode-btn\" data-mode=\"" + escapeHtml(mode) + "\" style=\""
  	        + "background:" + (active ? "#CC6633": "#333") + ";"
  	        + "color:#fff;border:none;padding:7px 10px;border-radius:7px;cursor:pointer;font-size:12px;font-weight:800;"
  	        + "\">" + escapeHtml(label) + "</button>";
  	      }

  	      function tyreActionTopBarHtml() {
  	        var removeSlot = selectedRemovableTyreSlot();

  	        return ""
  	        + "<div style=\""
  	        + "position:sticky;"
  	        + "top:0;"
  	        + "z-index:30;"
  	        + "display:flex;"
  	        + "align-items:center;"
  	        + "justify-content:space-between;"
  	        + "gap:12px;"
  	        + "border:1px solid #333;"
  	        + "background:#101010;"
  	        + "border-radius:8px;"
  	        + "padding:10px 12px;"
  	        + "margin-bottom:12px;"
  	        + "box-shadow:0 8px 18px rgba(0,0,0,0.45);"
  	        + "\">"
  	        + "  <div style=\"display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;margin-left:auto;\">"
  	        + (
  	          removeSlot
  	          ? "    <button type=\"button\" id=\"tyreOpenRemovePopupBtn\" style=\"background:#8a2d2d;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-size:13px;font-weight:900;\">Remove Tyre</button>": ""
  	        )
  	        + (
  	          state.actionMode === "Allocate"
  	          ? ""
  	          + "    <button type=\"button\" id=\"tyreCompleteAllocationBtn\" style=\"background:#2a8f3a;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-size:13px;font-weight:900;\">Complete Allocation</button>"
  	          + "    <button type=\"button\" id=\"tyreCancelAllocationBtn\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-size:13px;font-weight:900;\">Cancel Allocation</button>": ""
  	          + tyreModeButtonHtml("RotateSwap", "Rotate / Swap")
  	          + tyreModeButtonHtml("Allocate", "Allocate")
  	        )
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      function compactRotationArrowsHtml() {
  	        var arrows;

  	        if (state.actionMode !== "RotateSwap") {
  	          return "";
  	        }

  	        arrows = getRotationArrows();

  	        if (!arrows.length) {
  	          return "";
  	        }

  	        return ""
  	        + "<div style=\"border:1px solid #2a8f3a;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	        + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Rotation Summary</div>"
  	        + "  <div style=\"padding:10px 12px;\">"
  	        + arrows.map(function (arrow) {
  	          return ""
  	          + "<div style=\"display:grid;grid-template-columns:64px 22px 64px minmax(0,1fr);gap:6px;align-items:center;padding:5px 0;border-bottom:1px solid #252525;font-size:12px;\">"
  	          + "  <div style=\"color:#fff;font-weight:900;text-align:center;background:#1f2937;border:1px solid #374151;border-radius:6px;padding:4px;\">" + escapeHtml(arrow.FromPosition) + "</div>"
  	          + "  <div style=\"color:#CC6633;font-size:16px;text-align:center;font-weight:900;\">→</div>"
  	          + "  <div style=\"color:#fff;font-weight:900;text-align:center;background:#1f2937;border:1px solid #374151;border-radius:6px;padding:4px;\">" + escapeHtml(arrow.ToPosition) + "</div>"
  	          + "  <div style=\"color:#aaa;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\" title=\"" + escapeHtml(arrow.TyreLabel) + "\">" + escapeHtml(arrow.TyreLabel) + "</div>"
  	          + "</div>";
  	        }).join("")
  	        + "    <div style=\"display:flex;gap:8px;padding-top:10px;\">"
  	        + "      <button id=\"tyreOpenRotationSavePopupBtn\" type=\"button\" style=\"background:#2a8f3a;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:900;\">Save Rotation</button>"
  	        + "      <button id=\"tyreClearRotationPlanBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:900;\">Clear Plan</button>"
  	        + "    </div>"
  	        + "  </div>"
  	        + "</div>";
  	      }







  	      function closeFloatingPopup(id) {
  	        var el = DocumentSafe.getElementById(id);

  	        if (el && el.parentNode) {
  	          el.parentNode.removeChild(el);
  	        }
  	      }

  	      function floatingPopupShellHtml(id, title, innerHtml, width) {
  	        var isModal = id === "rotationSavePopup" || id === "allocationPlanPopup";
  	        var defaultLeft = id === "allocateTyrePopup" ? "420px": "50%";
  	        var defaultTop = id === "allocateTyrePopup" ? "92px": "92px";
  	        var defaultTransform = id === "allocateTyrePopup" ? "none": "translateX(-50%)";
  	        var card = ""
  	        + "<div " + (isModal ? "data-popup-card=\"" + escapeHtml(id) + "\"": "id=\"" + escapeHtml(id) + "\"") + " style=\""
  	        + "position:" + (isModal ? "relative": "fixed") + ";"
  	        + (isModal ? "": "top:" + defaultTop + ";left:" + defaultLeft + ";transform:" + defaultTransform + ";")
  	        + "width:" + escapeHtml(width || "760px") + ";"
  	        + "max-width:calc(100vw - 40px);"
  	        + "max-height:calc(100vh - 110px);"
  	        + "background:linear-gradient(145deg,#151916,#080b09);"
  	        + "border:1px solid rgba(204,102,51,.48);"
  	        + "border-radius:14px;"
  	        + "box-shadow:0 28px 80px rgba(0,0,0,.82),0 0 30px rgba(204,102,51,.12);"
  	        + "overflow:hidden;"
  	        + "font-family:system-ui,sans-serif;"
  	        + "color:#fff;"
  	        + "\">"
  	        + "  <div data-popup-drag-handle=\"" + escapeHtml(id) + "\" style=\"display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;border-bottom:1px solid #333;background:rgba(204,102,51,.07);user-select:none;\">"
  	        + "    <div style=\"color:#CC6633;font-size:15px;font-weight:900;\">" + escapeHtml(title) + "</div>"
  	        + "    <button type=\"button\" data-popup-close=\"" + escapeHtml(id) + "\" style=\"background:#555;color:#fff;border:none;border-radius:7px;padding:6px 10px;cursor:pointer;font-weight:900;\">✕</button>"
  	        + "  </div>"
  	        + "  <div style=\"padding:12px;overflow:auto;max-height:calc(100vh - 175px);\">"
  	        + innerHtml
  	        + "  </div>"
  	        + "</div>";

  	        if (!isModal) {
  	          return card;
  	        }

  	        return "<div id=\"" + escapeHtml(id) + "\" style=\"position:fixed;inset:50px 0 0;z-index:2147483646;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.82);backdrop-filter:blur(6px) saturate(.82);\">" + card + "</div>";
  	      }

  	      function wirePopupCloseButtons(container) {
  	        var buttons = container.querySelectorAll("[data-popup-close]");

  	        Array.prototype.forEach.call(buttons, function (button) {
  	          button.onclick = function () {
  	            var id = button.getAttribute("data-popup-close");

  	            if (id === "allocateTyrePopup") {
  	              state.allocatePopupOpen = false;
  	            }

  	            if (id === "rotationSavePopup") {
  	              state.rotationPopupOpen = false;
  	            }

  	            closeFloatingPopup(id);
  	          };
  	        });

  	        container.onclick = function (event) {
  	          if (event.target === container) {
  	            if (container.id === "allocateTyrePopup") {
  	              state.allocatePopupOpen = false;
  	            }

  	            if (container.id === "rotationSavePopup") {
  	              state.rotationPopupOpen = false;
  	            }

  	            closeFloatingPopup(container.id);
  	          }
  	        };
  	      }



  	      function tyreSearchBlob(tyre) {
  	        return [
  	          tyreObjectId(tyre),
  	          tyreNumber(tyre),
  	          tyreSerial(tyre),
  	          tyreMake(tyre),
  	          tyreModel(tyre),
  	          tyreSize(tyre),
  	          tyreType(tyre),
  	          tyreStatus(tyre),
  	          tyre.Current_Stage,
  	          tyre.Current_Mileage,
  	          tyre.Expected_Mileage,
  	          tyre.Current_Life
  	        ].join(" ").toLowerCase();
  	      }

  	      function filteredAllocateTyres() {
  	        var searchText = clean(state.allocateSearch).toLowerCase();
  	        var typeFilter = clean(state.allocateTypeFilter);

  	        return allAvailableWarehouseTyres().filter(function (tyre) {
  	          var id = tyreObjectId(tyre);

  	          if (!id || warehouseTyreAlreadyInDraft(id)) {
  	            return false;
  	          }

  	          if (typeFilter && tyreType(tyre) !== typeFilter) {
  	            return false;
  	          }

  	          if (searchText && tyreSearchBlob(tyre).indexOf(searchText) === -1) {
  	            return false;
  	          }

  	          return true;
  	        });
  	      }

  	      function allocateTyreCardHtml(tyre) {
  	        var id = tyreObjectId(tyre);
  	        var life = tyreLife(tyre);
  	        var lifeLabel = life === null ? "No data": life.toFixed(1) + "%";
  	        var selected = state.allocateSelectedTyreId === id;

  	        return ""
  	        + "<div class=\"allocate-tyre-popup-card\" draggable=\"true\" "
  	        + "data-source-type=\"warehouse\" "
  	        + "data-tyre-object-id=\"" + escapeHtml(id) + "\" "
  	        + "data-source-position=\"\" "
  	        + "style=\""
  	        + "border:1px solid " + (selected ? "#fff": "#333") + ";"
  	        + "background:" + (selected ? "#263044": "#151515") + ";"
  	        + "border-radius:8px;"
  	        + "padding:9px;"
  	        + "margin-bottom:8px;"
  	        + "cursor:grab;"
  	        + "box-shadow:0 1px 3px rgba(0,0,0,0.35);"
  	        + "\">"
  	        + "  <div style=\"display:flex;gap:9px;align-items:center;\">"
  	        + "    <div style=\"width:38px;flex:0 0 38px;\">" + tyreTreadHtml(tyreColor(tyre),
  	          false,
  	          false) + "</div>"
  	        + "    <div style=\"min-width:0;flex:1;\">"
  	        + "      <div style=\"color:#fff;font-size:13px;font-weight:900;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\">" + escapeHtml(tyreName(tyre)) + "</div>"
  	        + "      <div style=\"color:#999;font-size:11px;margin-top:3px;\">"
  	        + "        Type: " + escapeHtml(tyreType(tyre) || "No Type")
  	        + " • Stage: " + escapeHtml(tyre.Current_Stage || "")
  	        + " • Life: " + escapeHtml(lifeLabel)
  	        + "      </div>"
  	        + "      <div style=\"color:#777;font-size:11px;margin-top:2px;\">"
  	        + "        Status: " + escapeHtml(tyreStatus(tyre))
  	        + " • Size: " + escapeHtml(tyreSize(tyre) || "")
  	        + "      </div>"
  	        + "    </div>"
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      function allocateTypeOptionsHtml() {
  	        var types = ["", "Steer", "Drive", "Trailer", "Spare"];

  	        return types.map(function (type) {
  	          return "<option value=\"" + escapeHtml(type) + "\" " + (state.allocateTypeFilter === type ? "selected": "") + ">"
  	          + escapeHtml(type || "All Types")
  	          + "</option>";
  	        }).join("");
  	      }



  	      function closeFloatingPopup(id) {
  	        var popup;

  	        if (!DocumentSafe || !id) {
  	          return;
  	        }

  	        popup = DocumentSafe.getElementById(id);

  	        if (popup && popup.parentNode) {
  	          popup.parentNode.removeChild(popup);
  	        }
  	      }

  	      function renderAllocatePopup() {
  	        var mount = DocumentSafe.getElementById("allocateTyreInlineMount");
  	        var popup;
  	        var tyres;
  	        var html;

  	        closeFloatingPopup("allocateTyrePopup");

  	        if (!mount) {
  	          return;
  	        }

  	        if (!state.allocatePopupOpen || state.actionMode !== "Allocate") {
  	          mount.innerHTML = "";
  	          return;
  	        }

  	        tyres = filteredAllocateTyres();

  	        html = ""
  	        + "<div id=\"allocateTyrePopup\" style=\""
  	        + "border:1px solid #333;"
  	        + "background:#101010;"
  	        + "border-radius:8px;"
  	        + "box-shadow:0 10px 28px rgba(0,0,0,0.42);"
  	        + "overflow:hidden;"
  	        + "display:flex;"
  	        + "flex-direction:column;"
  	        + "max-height:calc(100vh - 430px);"
  	        + "min-height:260px;"
  	        + "\">"

  	        + "  <div style=\"display:flex;align-items:center;justify-content:space-between;gap:10px;padding:9px 10px;border-bottom:1px solid #333;background:#181818;flex:0 0 auto;\">"
  	        + "    <div style=\"color:#CC6633;font-size:13px;font-weight:900;\">Allocate Tyre</div>"
  	        + "    <button type=\"button\" data-popup-close=\"allocateTyrePopup\" style=\"background:#555;color:#fff;border:none;border-radius:6px;padding:4px 8px;cursor:pointer;font-weight:900;line-height:1;\">✕</button>"
  	        + "  </div>"

  	        + "  <div style=\"padding:10px;display:flex;flex-direction:column;gap:9px;min-height:0;flex:1 1 auto;\">"

  	        + "    <div style=\"display:grid;grid-template-columns:1fr 118px;gap:8px;flex:0 0 auto;\">"
  	        + "      <div>"
  	        + "        <label style=\"display:block;color:#aaa;font-size:11px;margin-bottom:4px;\">Search</label>"
  	        + "        <input id=\"allocateTyreSearchInput\" type=\"text\" value=\"" + escapeHtml(state.allocateSearch || "") + "\" placeholder=\"ID, serial, make, model, size\" style=\"width:100%;box-sizing:border-box;padding:7px;border:1px solid #343434;border-radius:6px;background:#151515;color:#fff;font-size:12px;\">"
  	        + "      </div>"
  	        + "      <div>"
  	        + "        <label style=\"display:block;color:#aaa;font-size:11px;margin-bottom:4px;\">Type</label>"
  	        + "        <select id=\"allocateTyreTypeFilter\" style=\"width:100%;box-sizing:border-box;padding:7px;border:1px solid #343434;border-radius:6px;background:#151515;color:#fff;font-size:12px;\">"
  	        + allocateTypeOptionsHtml()
  	        + "        </select>"
  	        + "      </div>"
  	        + "    </div>"

  	        + "    <div style=\"flex:0 0 auto;\">"
  	        + allocationPlanInlineStatusHtml()
  	        + "    </div>"

  	        + "    <div style=\"display:flex;justify-content:space-between;align-items:center;flex:0 0 auto;\">"
  	        + "      <div style=\"color:#fff;font-size:13px;font-weight:900;\">Available Tyres</div>"
  	        + "      <div style=\"color:#777;font-size:12px;\">" + escapeHtml(tyres.length) + " found</div>"
  	        + "    </div>"

  	        + "    <div id=\"allocateTyrePopupList\" style=\"flex:1 1 auto;min-height:170px;overflow:auto;padding-right:5px;\">"
  	        + (
  	          tyres.length
  	          ? tyres.map(allocateTyreCardHtml).join(""): "<div style=\"color:#777;border:1px dashed #444;border-radius:8px;padding:12px;\">No available tyres match this search.</div>"
  	        )
  	        + "    </div>"

  	        + "  </div>"
  	        + "</div>";

  	        mount.innerHTML = html;

  	        popup = DocumentSafe.getElementById("allocateTyrePopup");

  	        if (!popup) {
  	          return;
  	        }

  	        wireAllocatePopupEvents(popup);
  	      }

  	      function wireAllocatePopupEvents(popup) {
  	        var searchInput = popup.querySelector("#allocateTyreSearchInput");
  	        var typeFilter = popup.querySelector("#allocateTyreTypeFilter");
  	        var cards = popup.querySelectorAll(".allocate-tyre-popup-card");
  	        var saveAllocatePlanBtn = popup.querySelector("#allocateSavePlanBtn");
  	        var clearAllocatePlanBtn = popup.querySelector("#allocateClearPlanBtn");
  	        var doneRotateBtn = popup.querySelector("#allocateDoneRotateBtn");
  	        var closeButtons = popup.querySelectorAll("[data-popup-close=\"allocateTyrePopup\"]");
  	        if (saveAllocatePlanBtn) {
  	          saveAllocatePlanBtn.onclick = function () {
  	            saveAllocationPlanFromUi(saveAllocatePlanBtn)
  	            .catch(function (error) {
  	              state.actionMessage = error && error.message ? error.message: "Could not save tyre changes.";
  	              state.actionError = true;
  	              renderAllocatePopup();
  	              renderVisualTyreOperations();
  	            });
  	          };
  	        }

  	        if (clearAllocatePlanBtn) {
  	          clearAllocatePlanBtn.onclick = function () {
  	            beginRotationPlan();

  	            state.pendingTyreAction = null;
  	            state.dragSource = null;
  	            state.tapSource = null;
  	            state.allocateSelectedTyreId = "";
  	            state.actionMessage = "Allocation plan cleared.";
  	            state.actionError = false;

  	            renderVisualTyreOperations();
  	            renderAllocatePopup();
  	          };
  	        }

  	        if (doneRotateBtn) {
  	          doneRotateBtn.onclick = function () {
  	            enterRotateSwapAfterAllocate("Allocate finished. Rotate / Swap unlocked. Drag fitted tyres directly on the vehicle layout.");
  	          };
  	        }

  	        Array.prototype.forEach.call(closeButtons, function (button) {
  	          button.onclick = function (event) {
  	            if (event && event.preventDefault) {
  	              event.preventDefault();
  	            }

  	            if (event && event.stopPropagation) {
  	              event.stopPropagation();
  	            }

  	            lockTyreMovementState("Allocation cancelled. Tyre layout reset.");
  	          };
  	        });

  	        if (searchInput) {
  	          searchInput.oninput = function () {
  	            state.allocateSearch = searchInput.value || "";
  	            renderAllocatePopup();
  	          };
  	        }

  	        if (typeFilter) {
  	          typeFilter.onchange = function () {
  	            state.allocateTypeFilter = typeFilter.value || "";
  	            renderAllocatePopup();
  	          };
  	        }

  	        Array.prototype.forEach.call(cards, function (card) {
  	          card.addEventListener("dragstart", function (event) {
  	            var tyreId = card.getAttribute("data-tyre-object-id") || "";
  	            var source = {
  	              SourceType: "warehouse",
  	              TyreObjectId: tyreId,
  	              SourcePosition: ""
  	            };

  	            state.actionMode = "Allocate";
  	            setDragSource("warehouse", tyreId, "");

  	            if (event.dataTransfer) {
  	              event.dataTransfer.effectAllowed = "move";
  	              event.dataTransfer.setData("text/plain", JSON.stringify(source));
  	            }

  	            card.style.opacity = "0.55";
  	          });

  	          card.addEventListener("dragend",
  	            function () {
  	              card.style.opacity = "1";
  	              state.dragSource = null;
  	            });

  	          card.onclick = function () {
  	            var tyreId = card.getAttribute("data-tyre-object-id") || "";

  	            state.actionMode = "Allocate";
  	            state.allocatePopupOpen = true;
  	            state.allocateSelectedTyreId = tyreId;

  	            setTapSource("warehouse",
  	              tyreId,
  	              "");

  	            state.actionMessage = "Tyre selected. Click the target position on the vehicle layout. Type mismatches will warn before continuing.";
  	            state.actionError = false;

  	            renderVisualTyreOperations();
  	            renderAllocatePopup();
  	          };
  	        });
  	      }

  	      function getRotationBaselineOdometer(arrows) {
  	        var best = vehicleOdometerBaseline(state.activeTractor || tractor);

  	        arr(arrows).forEach(function (arrow) {
  	          var tyre = findTyre(arrow.TyreObjectId);
  	          var a = numberOrNull(tyre && tyre.Last_Vehicle_Odometer);
  	          var b = numberOrNull(tyre && tyre.Fitted_Odometer);

  	          if (a !== null && a > best) {
  	            best = a;
  	          }

  	          if (b !== null && b > best) {
  	            best = b;
  	          }
  	        });

  	        return best;
  	      }

  	      function validateRotationMileage(value,
  	        baseline) {
  	        var mileage = numberOrNull(value);
  	        var maxJump = 25000;
  	        var minAllowed = baseline || 0;

  	        if (mileage === null) {
  	          return {
  	            ok: false,
  	            mileage: null,
  	            message: "Enter the vehicle odometer before saving the rotation."
  	          };
  	        }

  	        if (mileage <= 0) {
  	          return {
  	            ok: false,
  	            mileage: mileage,
  	            message: "Vehicle odometer must be greater than zero."
  	          };
  	        }

  	        if (minAllowed > 0 && mileage < minAllowed) {
  	          return {
  	            ok: false,
  	            mileage: mileage,
  	            message: "Odometer is lower than the last known reading of " + minAllowed + " km."
  	          };
  	        }

  	        if (minAllowed >= 1000 && mileage > minAllowed + maxJump) {
  	          return {
  	            ok: false,
  	            mileage: mileage,
  	            message: "Odometer jump is too high. Last known: " + minAllowed + " km. Entered: " + mileage + " km."
  	          };
  	        }

  	        return {
  	          ok: true,
  	          mileage: mileage,
  	          message: ""
  	        };
  	      }

  	      function rotationReportHtml(arrows, odometer, notes) {
  	        var currentVehicle = state.activeTractor || tractor;
  	        var finalTPositions = state.rotationDraftTPositions || normaliseTPositions(readTPositionsRaw(currentVehicle));
  	        var generatedAt = new Date().toLocaleString();
  	        var logoHtml = reportLogoHtml();

  	        return ""
  	        + "<div style=\"font-family:Arial,sans-serif;color:#111;padding:20px 22px;\">"
  	        + "  <div style=\"display:flex;justify-content:space-between;align-items:flex-start;gap:18px;border-bottom:2px solid #CC6633;padding-bottom:10px;margin-bottom:14px;\">"
  	        + "    <div>"
  	        + "      <h2 style=\"margin:0 0 5px;font-size:22px;color:#111;\">Tyre Rotation Report</h2>"
  	        + "      <div style=\"font-size:12px;color:#555;\">Generated: " + escapeHtml(generatedAt) + "</div>"
  	        + "      <div style=\"font-size:12px;color:#777;margin-top:2px;\">Rotation / Swap Report</div>"
  	        + "    </div>"
  	        + "    <div style=\"min-width:160px;text-align:right;display:flex;justify-content:flex-end;align-items:flex-start;\">"
  	        + (logoHtml || "<div style=\"font-size:12px;color:#b44;\">No SVG logo received</div>")
  	        + "    </div>"
  	        + "  </div>"

  	        + "  <table style=\"width:100%;border-collapse:collapse;margin-bottom:16px;font-size:13px;\">"
  	        + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;width:170px;background:#f3f3f3;\">Vehicle</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(vehicleTitle(currentVehicle)) + "</td></tr>"
  	        + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;background:#f3f3f3;\">Vehicle ID</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(vehicleId(currentVehicle)) + "</td></tr>"
  	        + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;background:#f3f3f3;\">Registration</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(vehicleReg(currentVehicle)) + "</td></tr>"
  	        + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;background:#f3f3f3;\">Odometer</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(odometer || "") + " km</td></tr>"
  	        + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;background:#f3f3f3;\">Notes</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(notes || "") + "</td></tr>"
  	        + "  </table>"

  	        + "  <h3 style=\"margin:12px 0 8px;font-size:16px;\">Planned Tyre Movements</h3>"
  	        + "  <table style=\"width:100%;border-collapse:collapse;font-size:12px;\">"
  	        + "    <thead>"
  	        + "      <tr>"
  	        + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">From</th>"
  	        + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">To</th>"
  	        + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">Tyre</th>"
  	        + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">Actual Type</th>"
  	        + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">Required Type</th>"
  	        + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">Mismatch</th>"
  	        + "      </tr>"
  	        + "    </thead>"
  	        + "    <tbody>"
  	        + arrows.map(function (arrow) {
  	          var tyre = findTyre(arrow.TyreObjectId);
  	          var finalSlot = getSlot(finalTPositions, arrow.ToPosition);
  	          var mismatch = tyre && finalSlot ? tyreMismatchInfo(tyre, finalSlot): null;

  	          return ""
  	          + "<tr>"
  	          + "  <td style=\"padding:6px;border:1px solid #ccc;font-weight:bold;\">" + escapeHtml(arrow.FromPosition) + "</td>"
  	          + "  <td style=\"padding:6px;border:1px solid #ccc;font-weight:bold;\">" + escapeHtml(arrow.ToPosition) + "</td>"
  	          + "  <td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(arrow.TyreLabel) + "</td>"
  	          + "  <td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(mismatch ? mismatch.ActualType: "") + "</td>"
  	          + "  <td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(mismatch ? mismatch.RequiredType: "") + "</td>"
  	          + "  <td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(mismatch && mismatch.HasMismatch ? "Accepted / To be recorded": "No") + "</td>"
  	          + "</tr>";
  	        }).join("")
  	        + "    </tbody>"
  	        + "  </table>"

  	        + "  <div style=\"margin-top:28px;display:grid;grid-template-columns:1fr 1fr;gap:28px;font-size:12px;color:#555;\">"
  	        + "    <div>Captured By: ________________________________</div>"
  	        + "    <div>Checked By: ________________________________</div>"
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      function printRotationReportFromPopup() {
  	        var arrows = getRotationArrows();
  	        var odometerInput = DocumentSafe.getElementById("tyreActionOdometer");
  	        var notesInput = DocumentSafe.getElementById("tyreActionNotes");
  	        var odometer = odometerInput ? odometerInput.value: "";
  	        var notes = notesInput ? notesInput.value: "";
  	        var frame;
  	        var doc;
  	        var html;

  	        if (!arrows.length) {
  	          alertSafe("No rotation movements to print.");
  	          return;
  	        }

  	        if (!DocumentSafe || !DocumentSafe.body) {
  	          alertSafe("Printing is unavailable in this browser.");
  	          return;
  	        }

  	        html = rotationReportHtml(arrows, odometer, notes);

  	        frame = DocumentSafe.createElement("iframe");

  	        frame.style.position = "fixed";
  	        frame.style.right = "0";
  	        frame.style.bottom = "0";
  	        frame.style.width = "0";
  	        frame.style.height = "0";
  	        frame.style.border = "0";
  	        frame.style.opacity = "0";
  	        frame.style.pointerEvents = "none";

  	        DocumentSafe.body.appendChild(frame);

  	        doc = frame.contentWindow.document;
  	        doc.open();
  	        doc.write("")
  	        doc.write("<!doctype html>");
  	        doc.write("<html>");
  	        doc.write("<head>");
  	        doc.write("  <meta charset=\"utf-8\">");
  	        doc.write("  <title>Tyre Rotation Report</title>");
  	        doc.write("  <style>");
  	        doc.write("    @page{size:A4 landscape;margin:10mm;}");
  	        doc.write("    html,body{margin:0;padding:0;background:#fff;color:#000;font-family:Arial,sans-serif;}");
  	        doc.write("    *{box-sizing:border-box;}");
  	        doc.write("    table{width:100%;border-collapse:collapse;page-break-inside:auto;}");
  	        doc.write("    th,td{page-break-inside:avoid;}");
  	        doc.write("    tr{page-break-inside:avoid;page-break-after:auto;}");
  	        doc.write("    h2{page-break-after:avoid;}");
  	        doc.write("    @media print{body{margin:0;}button{display:none!important;}}");
  	        doc.write("  </style>");
  	        doc.write("</head>");
  	        doc.write("<body>");
  	        doc.write(html);
  	        doc.write("</body>");
  	        doc.write("</html>");
  	        doc.close();

  	        setTimeout(function () {
  	          try {
  	            frame.contentWindow.focus();
  	            frame.contentWindow.print();

  	            setTimeout(function () {
  	              if (frame && frame.parentNode) {
  	                frame.parentNode.removeChild(frame);
  	              }
  	            },
  	              1000);
  	          } catch (error) {

  	            alertSafe("Could not print the rotation report.");
  	          }
  	        }, 250);
  	      }

  	      function renderRotationSavePopup() {
  	        var arrows = getRotationArrows();
  	        var baseline = getRotationBaselineOdometer(arrows);
  	        var html;
  	        var popup;

  	        closeFloatingPopup("rotationSavePopup");

  	        if (!state.rotationPopupOpen) {
  	          return;
  	        }

  	        if (!arrows.length) {
  	          state.rotationPopupOpen = false;
  	          state.actionMessage = "No rotation changes to save.";
  	          state.actionError = true;
  	          renderVisualTyreOperations();
  	          return;
  	        }

  	        html = ""
  	        + "<div style=\"color:#aaa;font-size:12px;line-height:1.45;margin-bottom:10px;\">"
  	        + "Review the full rotation breakdown, enter one believable vehicle odometer reading, then save. The same odometer and notes will be written to every tyre movement."
  	        + "</div>"
  	        + "<div style=\"border:1px solid #333;border-radius:8px;overflow:hidden;margin-bottom:12px;\">"
  	        + "  <div style=\"padding:9px 12px;background:#181818;border-bottom:1px solid #333;color:#fff;font-weight:900;\">Planned tyre movements</div>"
  	        + "  <div style=\"padding:10px 12px;\">"
  	        + arrows.map(function (arrow) {
  	          return ""
  	          + "<div style=\"display:grid;grid-template-columns:70px 24px 70px minmax(0,1fr);gap:7px;align-items:center;padding:6px 0;border-bottom:1px solid #252525;font-size:12px;\">"
  	          + "  <div style=\"color:#fff;font-weight:900;text-align:center;background:#1f2937;border:1px solid #374151;border-radius:6px;padding:5px;\">" + escapeHtml(arrow.FromPosition) + "</div>"
  	          + "  <div style=\"color:#CC6633;font-size:18px;text-align:center;font-weight:900;\">→</div>"
  	          + "  <div style=\"color:#fff;font-weight:900;text-align:center;background:#1f2937;border:1px solid #374151;border-radius:6px;padding:5px;\">" + escapeHtml(arrow.ToPosition) + "</div>"
  	          + "  <div style=\"color:#aaa;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\" title=\"" + escapeHtml(arrow.TyreLabel) + "\">" + escapeHtml(arrow.TyreLabel) + "</div>"
  	          + "</div>";
  	        }).join("")
  	        + "  </div>"
  	        + "</div>"
  	        + "<div style=\"color:#999;font-size:12px;margin-bottom:8px;\">Last known tyre odometer baseline: " + escapeHtml(baseline || "No reliable baseline") + "</div>"
  	        + "<div style=\"margin-bottom:10px;\">"
  	        + "  <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	        + "  <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	        + "  <div id=\"rotationMileageError\" style=\"color:#ff4d4f;font-size:12px;margin-top:5px;min-height:16px;\"></div>"
  	        + "</div>"
  	        + "<div style=\"margin-bottom:12px;\">"
  	        + "  <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	        + "  <textarea id=\"tyreActionNotes\" placeholder=\"Rotation notes\" style=\"width:100%;box-sizing:border-box;min-height:70px;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	        + "</div>"
  	        + "<div style=\"display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;align-items:center;\">"
  	        + "  <button id=\"tyrePrintRotationReportBtn\" type=\"button\" style=\"background:#374151;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;margin-right:auto;display:inline-flex;align-items:center;gap:6px;\">🖨 Print Report</button>"
  	        + "  <button id=\"tyrePopupSaveRotationBtn\" type=\"button\" style=\"display:none;background:#2a8f3a;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Save Rotation Plan</button>"
  	        + "  <button data-popup-close=\"rotationSavePopup\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Cancel</button>"
  	        + "</div>";

  	        DocumentSafe.body.insertAdjacentHTML(
  	          "beforeend",
  	          floatingPopupShellHtml("rotationSavePopup", "Save Rotation Plan", html, "820px")
  	        );

  	        popup = DocumentSafe.getElementById("rotationSavePopup");

  	        if (!popup) {
  	          return;
  	        }

  	        wireRotationSavePopupEvents(popup, baseline);
  	      }

  	      function wireRotationSavePopupEvents(popup, baseline) {
  	        var saveBtn = popup.querySelector("#tyrePopupSaveRotationBtn");
  	        var printBtn = popup.querySelector("#tyrePrintRotationReportBtn");
  	        var odometerInput = popup.querySelector("#tyreActionOdometer");
  	        var errorEl = popup.querySelector("#rotationMileageError");

  	        wirePopupCloseButtons(popup);

  	        function refreshRotationSaveButton() {
  	          var validation = odometerInput ? validateRotationMileage(odometerInput.value, baseline): {
  	            ok: false,
  	            message: ""
  	          };

  	          if (errorEl) {
  	            errorEl.textContent = validation.ok || !odometerInput || !odometerInput.value ? "": validation.message;
  	          }

  	          if (saveBtn) {
  	            saveBtn.style.display = validation.ok ? "inline-flex": "none";
  	          }
  	        }

  	        refreshRotationSaveButton();

  	        if (odometerInput) {
  	          odometerInput.oninput = refreshRotationSaveButton;
  	          odometerInput.onchange = refreshRotationSaveButton;
  	        }

  	        if (printBtn) {
  	          printBtn.onclick = function () {
  	            printRotationReportFromPopup();
  	          };
  	        }

  	        if (saveBtn) {
  	          saveBtn.onclick = function () {
  	            var validation = validateRotationMileage(odometerInput ? odometerInput.value: "", baseline);

  	            if (!validation.ok) {
  	              if (errorEl) {
  	                errorEl.textContent = validation.message;
  	              }

  	              return;
  	            }

  	            saveBtn.disabled = true;
  	            saveBtn.textContent = "Saving...";

  	            saveRotationPlanFromUi()
  	            .then(function (message) {
  	              state.rotationPopupOpen = false;
  	              closeFloatingPopup("rotationSavePopup");

  	              state.actionMode = "";
  	              state.pendingTyreAction = null;
  	              state.dragSource = null;
  	              state.tapSource = null;

  	              state.actionMessage = message || "Rotation plan saved.";
  	              state.actionError = false;

  	              renderVisualTyreOperations();
  	              renderList(search.value || "");
  	            })
  	            .catch(function (error) {
  	              saveBtn.disabled = false;
  	              saveBtn.textContent = "Save Rotation Plan";
  	              refreshRotationSaveButton();

  	              if (errorEl) {
  	                errorEl.textContent = error && error.message ? error.message: "Rotation plan failed.";
  	              }
  	            });
  	          };
  	        }
  	      }


  	      function renderAxleConfigurator() {
  	        var draft = getDraftTPositions();
  	        var summary;
  	        var allowed;

  	        applyAxleRules(draft,
  	          false);
  	        rebuildSlots(draft);

  	        summary = summaryForTPositions(draft);
  	        allowed = allowedAxleTypes(VEHICLE_TYPE);

  	        body.innerHTML = ""
  	        + "<div style=\"display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px;\">"
  	        + "  <button data-action=\"add-axle\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#CC6633;color:#fff;cursor:pointer;\">Add Axle</button>"
  	        + "  <button data-action=\"add-spare\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#555;color:#fff;cursor:pointer;\">Add Spare</button>"
  	        + "  <button data-action=\"preset-4x2\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#333;color:#fff;cursor:pointer;\">4x2</button>"
  	        + "  <button data-action=\"preset-6x2-tag\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#333;color:#fff;cursor:pointer;\">6x2 Tag</button>"
  	        + "  <button data-action=\"preset-6x4\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#333;color:#fff;cursor:pointer;\">6x4</button>"
  	        + "  <button data-action=\"preset-8x4\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#333;color:#fff;cursor:pointer;\">8x4</button>"
  	        + "  <button data-action=\"clear-config\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#7f1d1d;color:#fff;cursor:pointer;\">Clear</button>"
  	        + "</div>"
  	        + "<div id=\"tyreAxleRows\"></div>"
  	        + "<div id=\"tyrePositionGrid\" style=\"display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:10px;margin-top:10px;\"></div>";

  	        renderAxleRows(draft,
  	          allowed);
  	        renderGeneratedPositionGrid(draft);
  	        wireAxleConfiguratorActions(draft);
  	      }

  	      function renderAxleRows(draft,
  	        allowed) {
  	        var axleRows = DocumentSafe.getElementById("tyreAxleRows");

  	        if (!axleRows) {
  	          return;
  	        }

  	        axleRows.innerHTML = "";

  	        if (!draft.Axles.length) {
  	          axleRows.innerHTML = "";
  	          return;
  	        }

  	        draft.Axles
  	        .sort(function (a, b) {
  	          return Number(a.Axle) - Number(b.Axle);
  	        })
  	        .forEach(function (axle, index) {
  	          var row = DocumentSafe.createElement("div");
  	          var tyreCountLocked = axle.Type === "Steer" || axle.Type === "Spare";
  	          var tyreCountDisabled = tyreCountLocked ? "disabled": "";
  	          var wearDisabled = axle.Type !== "Tag" ? "disabled": "";
  	          var typeOptions = "";

  	          allowed.forEach(function (type) {
  	            typeOptions += ""
  	            + "<option value=\"" + escapeHtml(type) + "\" " + (axle.Type === type ? "selected": "") + ">"
  	            + escapeHtml(type)
  	            + "</option>";
  	          });

  	          row.dataset.axleIndex = String(index);

  	          Object.assign(row.style, {
  	            display: "grid",
  	            gridTemplateColumns: "80px 150px 120px 120px 90px",
  	            gap: "8px",
  	            alignItems: "end",
  	            background: "#181818",
  	            border: "1px solid #333",
  	            borderRadius: "8px",
  	            padding: "10px",
  	            marginBottom: "8px"
  	          });

  	          row.innerHTML = ""
  	          + "<label style=\"font-size:12px;color:#aaa;\">Axle"
  	          + "  <input type=\"number\" min=\"1\" value=\"" + escapeHtml(axle.Axle) + "\" data-axle-field=\"Axle\" data-fif-number-native=\"true\" style=\"width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;\">"
  	          + "</label>"
  	          + "<label style=\"font-size:12px;color:#aaa;\">Type"
  	          + "  <select data-axle-field=\"Type\" style=\"width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;\">"
  	          + typeOptions
  	          + "  </select>"
  	          + "</label>"
  	          + "<label style=\"font-size:12px;color:#aaa;\">Tyres Per Side"
  	          + "  <input type=\"number\" min=\"1\" max=\"2\" step=\"1\" value=\"" + escapeHtml(axle.TyresPerSide) + "\" data-axle-field=\"TyresPerSide\" data-fif-number-native=\"true\" " + tyreCountDisabled + " style=\"width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + (tyreCountLocked ? "opacity:0.6;": "") + "\">"
  	          + "</label>"
  	          + "<label style=\"font-size:12px;color:#aaa;\">Wear Rate"
  	          + "  <input type=\"number\" min=\"0\" max=\"1\" step=\"0.01\" value=\"" + escapeHtml(axle.WearRate) + "\" data-axle-field=\"WearRate\" data-fif-number-native=\"true\" " + wearDisabled + " style=\"width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + (axle.Type !== "Tag" ? "opacity:0.6;": "") + "\">"
  	          + "</label>"
  	          + "<button data-action=\"remove-axle\" style=\"padding:7px 10px;border:none;border-radius:6px;background:#7f1d1d;color:#fff;cursor:pointer;\">Remove</button>";

  	          axleRows.appendChild(row);
  	        });
  	      }

  	      function renderGeneratedPositionGrid(draft) {
  	        var positionGrid = DocumentSafe.getElementById("tyrePositionGrid");
  	        var keys;

  	        if (!positionGrid) {
  	          return;
  	        }

  	        positionGrid.innerHTML = "";
  	        keys = sortedPositionKeys(draft);

  	        if (!keys.length) {
  	          positionGrid.innerHTML = "";
  	          return;
  	        }

  	        keys.forEach(function (key) {
  	          var slot = draft.Positions[key];
  	          var card = DocumentSafe.createElement("div");

  	          Object.assign(card.style, {
  	            background: "#181818",
  	            border: "1px solid #333",
  	            borderRadius: "8px",
  	            padding: "10px"
  	          });

  	          card.innerHTML = ""
  	          + "<div style=\"display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;\">"
  	          + "  <div style=\"font-weight:700;color:#fff;\">" + escapeHtml(slot.PositionKey) + "</div>"
  	          + "  <div style=\"font-size:11px;color:#aaa;\">" + escapeHtml(slot.AxleType) + " / " + escapeHtml(slot.Side) + "</div>"
  	          + "</div>"
  	          + (slot.AxleType === "Tag"
  	            ? "<div style=\"font-size:11px;color:#777;margin-bottom:6px;\">Wear " + escapeHtml(slot.WearRate) + "</div>"
  	            : "")
  	          + renderSmallTyreDisplay(slot);

  	          positionGrid.appendChild(card);
  	        });
  	      }

  	      function wireAxleConfiguratorActions(draft) {
  	        var buttons = body.querySelectorAll("[data-action]");
  	        var inputs = body.querySelectorAll("[data-axle-field]");

  	        Array.prototype.forEach.call(buttons, function (button) {
  	          button.onclick = async function () {
  	            var action = button.getAttribute("data-action");
  	            var maxAxle;
  	            var row;
  	            var index;

  	            if (action === "add-axle") {
  	              maxAxle = draft.Axles.reduce(function (max, axle) {
  	                return Math.max(max, Number(axle.Axle || 0));
  	              }, 0);

  	              draft.Axles.push({
  	                Axle: maxAxle + 1,
  	                Type: "Drive",
  	                TyresPerSide: 1,
  	                WearRate: 1,
  	                Enabled: true
  	              });

  	              applyAxleRules(draft, true);
  	              rebuildSlots(draft);
  	              renderAxleConfigurator();
  	              return;
  	            }

  	            if (action === "add-spare") {
  	              maxAxle = draft.Axles.reduce(function (max, axle) {
  	                return Math.max(max, Number(axle.Axle || 0));
  	              }, 0);

  	              draft.Axles.push({
  	                Axle: maxAxle + 1,
  	                Type: "Spare",
  	                TyresPerSide: 1,
  	                WearRate: 1,
  	                Enabled: true
  	              });

  	              applyAxleRules(draft, true);
  	              rebuildSlots(draft);
  	              renderAxleConfigurator();
  	              return;
  	            }

  	            if (action === "preset-4x2") {
  	              setPreset4x2(draft);
  	              renderAxleConfigurator();
  	              return;
  	            }

  	            if (action === "preset-6x2-tag") {
  	              setPreset6x2Tag(draft);
  	              renderAxleConfigurator();
  	              return;
  	            }

  	            if (action === "preset-6x4") {
  	              setPreset6x4(draft);
  	              renderAxleConfigurator();
  	              return;
  	            }

  	            if (action === "preset-8x4") {
  	              setPreset8x4(draft);
  	              renderAxleConfigurator();
  	              return;
  	            }

  	            if (action === "clear-config") {
  	              if (!(await confirmSafe(
  	                "This will remove every unsaved axle and generated tyre position from the current configuration.",
  	                {
  	                  title: "Clear Axle Configuration", type: "danger", confirmText: "Clear Configuration", cancelText: "Cancel"
  	                }
  	              ))) {
  	                return;
  	              }

  	              draft.Axles = [];
  	              draft.Positions = {};
  	              draft.Summary = summaryForTPositions(draft);
  	              renderAxleConfigurator();
  	              return;
  	            }

  	            if (action === "remove-axle") {
  	              row = button.closest("[data-axle-index]");
  	              index = Number(row && row.dataset ? row.dataset.axleIndex: null);

  	              if (!Number.isFinite(index)) {
  	                return;
  	              }

  	              draft.Axles.splice(index, 1);
  	              applyAxleRules(draft, true);
  	              rebuildSlots(draft);
  	              renderAxleConfigurator();
  	            }
  	          };
  	        });

  	        Array.prototype.forEach.call(inputs,
  	          function (input) {
  	            input.onchange = function () {
  	              var row = input.closest("[data-axle-index]");
  	              var index = Number(row && row.dataset ? row.dataset.axleIndex: null);
  	              var field = input.getAttribute("data-axle-field");
  	              var newType;

  	              if (!Number.isFinite(index) || !draft.Axles[index]) {
  	                return;
  	              }

  	              if (field === "Type") {
  	                newType = input.value;

  	                if (allowedAxleTypes(VEHICLE_TYPE).indexOf(newType) === -1) {
  	                  alertSafe("This axle type is not allowed on this vehicle.");
  	                  renderAxleConfigurator();
  	                  return;
  	                }

  	                draft.Axles[index].Type = newType;

  	                if (newType === "Steer" || newType === "Spare") {
  	                  draft.Axles[index].TyresPerSide = 1;
  	                  draft.Axles[index].WearRate = 1;
  	                }

  	                if (newType === "Tag") {
  	                  draft.Axles[index].WearRate = clamp(draft.Axles[index].WearRate, 0, 1, 1);
  	                }

  	                if (newType === "Drive") {
  	                  draft.Axles[index].WearRate = 1;
  	                }
  	              }

  	              if (field === "Axle") {
  	                draft.Axles[index].Axle = Math.max(1, Number(input.value || 1));
  	              }

  	              if (field === "TyresPerSide") {
  	                draft.Axles[index].TyresPerSide = Math.round(clamp(input.value, 1, 2, 1));
  	              }

  	              if (field === "WearRate") {
  	                draft.Axles[index].WearRate = clamp(input.value, 0, 1, 1);
  	              }

  	              applyAxleRules(draft, true);
  	              rebuildSlots(draft);
  	              renderAxleConfigurator();
  	            };
  	          });
  	      }



  	      function renderRemoveTyrePopup() {
  	        var slot = selectedRemovableTyreSlot();
  	        var tyre;
  	        var html;
  	        var popup;

  	        closeFloatingPopup("removeTyrePopup");

  	        if (!slot) {
  	          alertSafe("Select a fitted tyre first.", {
  	            title: "No Tyre Selected", type: "warning"
  	          });
  	          return;
  	        }

  	        tyre = findTyre(slot.TyreObjectId);

  	        if (!tyre) {
  	          alertSafe("The selected tyre record could not be found.", {
  	            title: "Tyre Not Found", type: "danger"
  	          });
  	          return;
  	        }

  	        html = ""
  	        + "<div id=\"removeTyrePopup\" style=\"position:fixed;inset:50px 0 0;z-index:2147483646;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.82);backdrop-filter:blur(6px) saturate(.82);font-family:system-ui,sans-serif;color:#fff;\">"
  	        + "  <section data-remove-tyre-card style=\"width:min(560px,calc(100vw - 40px));max-height:calc(100vh - 90px);overflow:hidden;background:linear-gradient(145deg,#151916,#080b09);border:1px solid rgba(204,102,51,.48);border-radius:15px;box-shadow:0 28px 80px rgba(0,0,0,.82),0 0 30px rgba(204,102,51,.12);\">"
  	        + "    <div style=\"display:flex;align-items:center;justify-content:space-between;gap:12px;padding:13px 15px;border-bottom:1px solid #333;background:rgba(204,102,51,.07);\">"
  	        + "      <div><div style=\"color:#CC6633;font-size:15px;font-weight:900;\">Remove Tyre</div><div style=\"color:#8f9691;font-size:11px;margin-top:3px;\">Update the tyre destination, vehicle assignment and movement history.</div></div>"
  	        + "      <button type=\"button\" id=\"removeTyrePopupCloseBtn\" style=\"background:#555;color:#fff;border:none;border-radius:7px;padding:6px 10px;cursor:pointer;font-weight:900;\">✕</button>"
  	        + "    </div>"
  	        + "    <div style=\"padding:15px;overflow:auto;max-height:calc(100vh - 180px);\">"
  	        + "      <div style=\"border:1px solid #333;background:#111512;border-radius:10px;padding:12px;margin-bottom:12px;\">"
  	        + "        <div style=\"color:#fff;font-size:14px;font-weight:900;margin-bottom:6px;\">" + escapeHtml(tyreName(tyre)) + "</div>"
  	        + "        <div style=\"display:grid;grid-template-columns:1fr 1fr;gap:8px;color:#a9b0ab;font-size:11px;\"><div><b>Position:</b> " + escapeHtml(slot.PositionKey) + "</div><div><b>Axle Type:</b> " + escapeHtml(slot.AxleType || "") + "</div></div>"
  	        + "      </div>"
  	        + "      <div style=\"margin-bottom:10px;\"><label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Send Tyre To</label><select id=\"removeTyreDestination\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\"><option value=\"Warehouse\">Warehouse</option><option value=\"Retread\">Retread</option><option value=\"Scrap\">Scrap</option><option value=\"Stolen\">Stolen</option></select></div>"
  	        + "      <div style=\"margin-bottom:10px;\"><label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label><input id=\"removeTyreOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\"></div>"
  	        + "      <div style=\"margin-bottom:13px;\"><label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Notes</label><textarea id=\"removeTyreNotes\" placeholder=\"Removal notes\" style=\"width:100%;box-sizing:border-box;min-height:80px;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;resize:vertical;\"></textarea></div>"
  	        + "      <div id=\"removeTyreError\" style=\"min-height:16px;color:#ff7d73;font-size:12px;margin-bottom:8px;\"></div>"
  	        + "      <div style=\"display:flex;justify-content:flex-end;gap:8px;\"><button id=\"removeTyreCancelBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Cancel</button><button id=\"tyreRemoveSelectedBtn\" type=\"button\" style=\"background:#8a2d2d;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Remove Tyre</button></div>"
  	        + "    </div>"
  	        + "  </section>"
  	        + "</div>";

  	        DocumentSafe.body.insertAdjacentHTML("beforeend", html);
  	        popup = DocumentSafe.getElementById("removeTyrePopup");
  	        if (!popup) return;
  	        wireRemoveTyrePopupEvents(popup, slot, tyre);
  	      }

  	      function wireRemoveTyrePopupEvents(popup, slot, tyre) {
  	        var closeBtn = popup.querySelector("#removeTyrePopupCloseBtn");
  	        var cancelBtn = popup.querySelector("#removeTyreCancelBtn");
  	        var removeBtn = popup.querySelector("#tyreRemoveSelectedBtn");
  	        var destinationEl = popup.querySelector("#removeTyreDestination");
  	        var odometerEl = popup.querySelector("#removeTyreOdometer");
  	        var notesEl = popup.querySelector("#removeTyreNotes");
  	        var errorEl = popup.querySelector("#removeTyreError");

  	        function closeRemovePopup() {
  	          closeFloatingPopup("removeTyrePopup");
  	        }
  	        if (closeBtn) closeBtn.onclick = closeRemovePopup;
  	        if (cancelBtn) cancelBtn.onclick = closeRemovePopup;
  	        popup.onclick = function (event) {
  	          if (event.target === popup) closeRemovePopup();
  	        };

  	        if (removeBtn) {
  	          removeBtn.onclick = async function () {
  	            var destination = clean(destinationEl && destinationEl.value) || "Warehouse";
  	            var odometer = clean(odometerEl && odometerEl.value);
  	            var notes = clean(notesEl && notesEl.value);
  	            var approved = await confirmSafe(
  	              "This tyre will be removed from the selected position and sent to the chosen destination. The vehicle layout, tyre holder, status and movement histories will be updated.",
  	              {
  	                title: "Confirm Tyre Removal",
  	                type: destination === "Scrap" || destination === "Stolen" ? "danger": "warning",
  	                confirmText: "Remove Tyre",
  	                cancelText: "Cancel",
  	                details: [{
  	                  label: "Tyre", value: tyreName(tyre)
  	                },
  	                  {
  	                    label: "Position", value: slot.PositionKey
  	                  },
  	                  {
  	                    label: "Destination", value: destination
  	                  },
  	                  {
  	                    label: "Odometer", value: odometer ? odometer + " km": "Not entered"
  	                  }]
  	              }
  	            );
  	            if (!approved) return;

  	            removeBtn.disabled = true;
  	            removeBtn.textContent = "Removing...";
  	            if (errorEl) errorEl.textContent = "";

  	            removeTyreFromPosition(slot.PositionKey, destination, odometer, notes)
  	            .then(function (message) {
  	              state.pendingTyreAction = null;
  	              state.dragSource = null;
  	              state.tapSource = null;
  	              state.actionMessage = message || "Tyre removed.";
  	              state.actionError = false;
  	              closeRemovePopup();
  	              if (typeof resetDraftTPositions === "function") resetDraftTPositions(); else resetRotationPlan();
  	              renderVisualTyreOperations();
  	              if (typeof renderList === "function") {
  	                try {
  	                  renderList(typeof search !== "undefined" && search && search.value ? search.value: "");
  	                }
  	                catch (error) {
  	                  renderList("");
  	                }
  	              }
  	            })
  	            .catch(function (error) {
  	              var message = error && error.message ? error.message: "Tyre removal failed.";
  	              state.actionMessage = message;
  	              state.actionError = true;
  	              removeBtn.disabled = false;
  	              removeBtn.textContent = "Remove Tyre";
  	              if (errorEl) errorEl.textContent = message;
  	            });
  	          };
  	        }
  	      }

  	      function renderVisualTyreOperations() {
  	        if (state.actionMode !== "Allocate") {
  	          state.allocatePopupOpen = false;
  	          state.allocateSelectedTyreId = "";
  	          state.allocateSearch = "";
  	          state.allocateTypeFilter = "";
  	        }

  	        if (state.actionMode !== "RotateSwap") {
  	          state.rotationPopupOpen = false;
  	        }

  	        var currentVehicle = state.activeTractor || tractor;
  	        var tPositions = getVisualTPositionsForTyreTab(currentVehicle);
  	        var keys = sortedPositionKeys(tPositions);
  	        var normalAxles = arr(tPositions.Axles).filter(function (axle) {
  	          return axle && axle.Type !== "Spare";
  	        });
  	        var spares = spareSlots(tPositions);
  	        var spareHtml = "";
  	        var sideHtml = "";

  	        if (!state.selectedPosition && keys.length) {
  	          state.selectedPosition = tPositions.Positions[keys[0]].PositionKey || keys[0];
  	        }

  	        spares.forEach(function (slot) {
  	          spareHtml += ""
  	          + "<div style=\"border:1px solid #3b3b3b;background:#1f2937;border-radius:9px;padding:9px;min-width:180px;\">"
  	          + "  <div style=\"color:#CC6633;font-size:12px;font-weight:800;margin-bottom:7px;\">" + escapeHtml(slot.PositionKey) + "</div>"
  	          + tyreSlotHtml(slot)
  	          + "</div>";
  	        });

  	        sideHtml = ""
  	        + (state.actionMode === "Allocate" ? "" : selectedTyreDetailHtml(tPositions))
  	        + (state.actionMode === "Allocate" ? "<div id=\"allocateTyreInlineMount\" style=\"margin-top:10px;\"></div>": "")
  	        + compactRotationArrowsHtml()
  	        + (state.actionMode === "RotateSwap" ? pendingPreviewHtml(): "")
  	        + ""
  	        + "<div id=\"tyreActionStatus\" style=\"min-height:17px;margin-top:10px;color:" + (state.actionError ? "#ff4d4f": "#aaa") + ";font-size:12px;\">"
  	        + escapeHtml(state.actionMessage || "")
  	        + "</div>";

  	        body.innerHTML = ""
  	        + tyreActionTopBarHtml()
  	        + renderWearLegend()
  	        + "<div style=\"display:grid;grid-template-columns:minmax(0,1fr) 430px;gap:12px;align-items:start;\">"
  	        + "  <div style=\"overflow-x:auto;border:1px solid #252525;border-radius:8px;background:#0b0f18;padding:12px;\">"
  	        + "    <div id=\"vehicleTyreLayoutDropZone\" style=\"display:flex;gap:14px;align-items:stretch;min-height:390px;\">"
  	        + (
  	          normalAxles.length
  	          ? normalAxles.map(function (axle) {
  	            return axleVisualHtml(tPositions, axle);
  	          }).join(""): "<div style=\"color:#777;border:1px dashed #444;border-radius:8px;padding:12px;\">No axles.</div>"
  	        )
  	        + "    </div>"
  	        + (
  	          spareHtml
  	          ? "<div style=\"display:flex;gap:10px;flex-wrap:wrap;margin-top:12px;padding-top:12px;border-top:1px solid #252525;\">" + spareHtml + "</div>": ""
  	        )
  	        + "  </div>"
  	        + "  <div>"
  	        + sideHtml
  	        + "  </div>"
  	        + "</div>";

  	        if (AllowTyreOperations) {
  	          wireVisualTyreEvents();
  	        } else {
  	          Array.prototype.forEach.call(body.querySelectorAll("button, input, select, textarea"), function (control) {
  	            control.disabled = true;
  	            control.style.opacity = "0.55";
  	            control.style.cursor = "not-allowed";
  	          });
  	          Array.prototype.forEach.call(body.querySelectorAll("[draggable=\"true\"]"), function (node) {
  	            node.setAttribute("draggable", "false");
  	            node.style.cursor = "default";
  	          });
  	        }

  	        if (state.allocatePopupOpen && AllowTyreOperations) {
  	          renderAllocatePopup();
  	        }

  	        if (state.rotationPopupOpen && AllowTyreOperations) {
  	          renderRotationSavePopup();
  	        }
  	      }

  	      function wireVisualTyreEvents() {
  	        var slotEls = body.querySelectorAll(".trac-tyre-slot");
  	        var tyreCards = body.querySelectorAll(".trac-tyre-card");
  	        var modeButtons = body.querySelectorAll(".trac-tyre-mode-btn");
  	        var openRemovePopupBtn = DocumentSafe.getElementById("tyreOpenRemovePopupBtn");
  	        var modeClearBtn = null;
  	        var completeAllocationBtn = DocumentSafe.getElementById("tyreCompleteAllocationBtn");
  	        var cancelAllocationBtn = DocumentSafe.getElementById("tyreCancelAllocationBtn");
  	        var confirmPendingBtn = DocumentSafe.getElementById("tyreConfirmPendingBtn");
  	        var clearPendingBtn = DocumentSafe.getElementById("tyreClearPendingBtn");
  	        var openRotationSavePopupBtn = DocumentSafe.getElementById("tyreOpenRotationSavePopupBtn");
  	        var clearRotationPlanBtn = DocumentSafe.getElementById("tyreClearRotationPlanBtn");
  	        var removeSelectedBtn = DocumentSafe.getElementById("tyreRemoveSelectedBtn");

  	        Array.prototype.forEach.call(modeButtons, function (button) {
  	          button.onclick = function () {
  	            state.actionMode = button.getAttribute("data-mode") || "";
  	            state.pendingTyreAction = null;
  	            state.dragSource = null;
  	            state.tapSource = null;

  	            if (state.actionMode === "RotateSwap") {
  	              state.allocatePopupOpen = false;
  	              state.allocateSelectedTyreId = "";
  	              closeFloatingPopup("allocateTyrePopup");

  	              state.rotationPopupOpen = false;
  	              closeFloatingPopup("rotationSavePopup");

  	              beginRotationPlan();
  	              state.actionMessage = "Rotate / Swap";
  	            } else if (state.actionMode === "Allocate") {
  	              beginRotationPlan();

  	              state.rotationPopupOpen = false;
  	              closeFloatingPopup("rotationSavePopup");
  	              closeFloatingPopup("allocationPlanPopup");

  	              state.allocatePopupOpen = true;
  	              state.allocateSelectedTyreId = "";
  	              state.pendingTyreAction = null;
  	              state.dragSource = null;
  	              state.tapSource = null;
  	              state.actionMessage = "Allocate";
  	            }

  	            state.actionError = false;
  	            renderVisualTyreOperations();

  	            if (state.actionMode === "Allocate") {
  	              renderAllocatePopup();
  	            }
  	          };
  	        });

  	        if (completeAllocationBtn) {
  	          completeAllocationBtn.onclick = function () {
  	            renderAllocationPlanPopup();
  	          };
  	        }

  	        if (cancelAllocationBtn) {
  	          cancelAllocationBtn.onclick = async function (event) {
  	            if (event && event.preventDefault) {
  	              event.preventDefault();
  	            }

  	            if (event && event.stopPropagation) {
  	              event.stopPropagation();
  	            }

  	            if (!(await confirmSafe(
  	              "All unsaved allocation changes will be discarded and the tyre layout will return to its last saved state.",
  	              {
  	                title: "Cancel Allocation Plan", type: "warning", confirmText: "Discard Plan", cancelText: "Keep Editing"
  	              }
  	            ))) {
  	              return;
  	            }

  	            lockTyreMovementState("Allocation cancelled. Tyre layout reset.");
  	          };
  	        }

  	        if (openRemovePopupBtn) {
  	          openRemovePopupBtn.onclick = function () {
  	            renderRemoveTyrePopup();
  	          };
  	        }

  	        if (modeClearBtn) {
  	          modeClearBtn.onclick = function () {
  	            lockTyreMovementState("Tyre movement locked.");
  	          };
  	        }

  	        Array.prototype.forEach.call(tyreCards, function (card) {
  	          card.addEventListener("dragstart", function (event) {
  	            var sourceType = card.getAttribute("data-source-type") || "";
  	            var tyreId = card.getAttribute("data-tyre-object-id") || "";
  	            var sourcePosition = card.getAttribute("data-source-position") || "";
  	            var source = {
  	              SourceType: sourceType,
  	              TyreObjectId: tyreId,
  	              SourcePosition: sourcePosition
  	            };

  	            if (!sourceAllowedForCurrentMode(source)) {
  	              event.preventDefault();
  	              state.actionMessage = "Select the correct tyre action first.";
  	              state.actionError = true;
  	              renderVisualTyreOperations();
  	              return;
  	            }

  	            setDragSource(sourceType, tyreId, sourcePosition);

  	            if (event.dataTransfer) {
  	              event.dataTransfer.effectAllowed = "move";
  	              event.dataTransfer.setData("text/plain", JSON.stringify(source));
  	            }

  	            card.style.opacity = "0.55";
  	          });

  	          card.addEventListener("dragend",
  	            function () {
  	              card.style.opacity = "1";
  	              state.dragSource = null;
  	            });

  	          card.onclick = function () {
  	            var sourceType = card.getAttribute("data-source-type") || "";
  	            var tyreId = card.getAttribute("data-tyre-object-id") || "";
  	            var sourcePosition = card.getAttribute("data-source-position") || "";
  	            var source = {
  	              SourceType: sourceType,
  	              TyreObjectId: tyreId,
  	              SourcePosition: sourcePosition
  	            };

  	            if (!sourceAllowedForCurrentMode(source)) {
  	              state.actionMessage = "Select the correct tyre action first.";
  	              state.actionError = true;
  	              renderVisualTyreOperations();
  	              return;
  	            }

  	            setTapSource(sourceType, tyreId, sourcePosition);
  	            renderVisualTyreOperations();
  	          };
  	        });

  	        Array.prototype.forEach.call(slotEls,
  	          function (slotEl) {
  	            slotEl.addEventListener("dragstart", function (event) {
  	              var positionKey = slotEl.getAttribute("data-position-key") || "";
  	              var tyreId = slotEl.getAttribute("data-tyre-object-id") || "";

  	              if (
  	                (state.actionMode !== "RotateSwap" && state.actionMode !== "Allocate") ||
  	                !tyreId
  	              ) {
  	                event.preventDefault();
  	                return;
  	              }

  	              state.selectedPosition = positionKey;
  	              setDragSource("fitted", tyreId, positionKey);

  	              if (event.dataTransfer) {
  	                event.dataTransfer.effectAllowed = "move";
  	                event.dataTransfer.setData("text/plain", JSON.stringify({
  	                  SourceType: "fitted",
  	                  TyreObjectId: tyreId,
  	                  SourcePosition: positionKey
  	                }));
  	              }

  	              slotEl.style.opacity = "0.72";
  	              slotEl.style.outline = "3px solid #CC6633";
  	              slotEl.style.boxShadow = "0 0 18px rgba(204,102,51,0.75)";
  	            });

  	            slotEl.addEventListener("dragend",
  	              function () {
  	                slotEl.style.opacity = "1";
  	                state.dragSource = null;
  	              });

  	            slotEl.addEventListener("dragover",
  	              function (event) {
  	                if (state.actionMode !== "RotateSwap" && state.actionMode !== "Allocate") {
  	                  return;
  	                }

  	                event.preventDefault();

  	                if (event.dataTransfer) {
  	                  event.dataTransfer.dropEffect = "move";
  	                }

  	                slotEl.style.background = "rgba(204,102,51,0.22)";
  	              });

  	            slotEl.addEventListener("dragleave",
  	              function () {
  	                var positionKey = slotEl.getAttribute("data-position-key") || "";

  	                if (state.selectedPosition === positionKey) {
  	                  slotEl.style.background = "rgba(204,102,51,0.22)";
  	                  slotEl.style.outline = "3px solid #CC6633";
  	                  slotEl.style.boxShadow = "0 0 18px rgba(204,102,51,0.7)";
  	                } else {
  	                  slotEl.style.background = "transparent";
  	                  slotEl.style.outline = "1px solid transparent";
  	                  slotEl.style.boxShadow = "none";
  	                }
  	              });

  	            slotEl.addEventListener("drop",
  	              async function (event) {
  	                var positionKey = slotEl.getAttribute("data-position-key") || "";
  	                var source = state.dragSource;
  	                var raw;

  	                event.preventDefault();

  	                if (state.actionMode !== "RotateSwap" && state.actionMode !== "Allocate") {
  	                  state.actionMessage = "Tyre movement is locked. Select Rotate / Swap or Allocate first.";
  	                  state.actionError = true;
  	                  renderVisualTyreOperations();
  	                  return;
  	                }

  	                if (!source && event.dataTransfer) {
  	                  raw = event.dataTransfer.getData("text/plain");

  	                  try {
  	                    source = JSON.parse(raw);
  	                  } catch (error) {
  	                    source = null;
  	                  }
  	                }

  	                if (!source) {
  	                  state.actionMessage = "No tyre source found.";
  	                  state.actionError = true;
  	                  renderVisualTyreOperations();
  	                  return;
  	                }

  	                if (!sourceAllowedForCurrentMode(source)) {
  	                  state.actionMessage = "This source is not allowed in the current mode.";
  	                  state.actionError = true;
  	                  renderVisualTyreOperations();
  	                  return;
  	                }

  	                if (state.actionMode === "RotateSwap") {
  	                  if (source.SourceType !== "fitted") {
  	                    state.actionMessage = "Only fitted tyres can be used in Rotate / Swap mode.";
  	                    state.actionError = true;
  	                    renderVisualTyreOperations();
  	                    return;
  	                  }

  	                  await moveTyreInRotationDraft(source.SourcePosition, positionKey);

  	                  state.dragSource = null;
  	                  renderVisualTyreOperations();
  	                  return;
  	                }

  	                if (state.actionMode === "Allocate") {
  	                  await applyDraftTyreMove(source, positionKey);

  	                  state.pendingTyreAction = null;
  	                  state.dragSource = null;
  	                  state.tapSource = null;
  	                  state.allocatePopupOpen = true;

  	                  renderVisualTyreOperations();
  	                  renderAllocatePopup();
  	                  return;
  	                }

  	                state.dragSource = null;
  	                renderVisualTyreOperations();
  	              });

  	            slotEl.onclick = async function () {
  	              var positionKey = slotEl.getAttribute("data-position-key") || "";
  	              var hadTapSource = !!state.tapSource;
  	              var slot;
  	              var tPositions;

  	              if (state.actionMode === "RotateSwap" && hadTapSource) {
  	                await moveTyreInRotationDraft(
  	                  state.tapSource.SourcePosition,
  	                  positionKey
  	                );

  	                clearTapSource();
  	                renderVisualTyreOperations();
  	                return;
  	              }

  	              if (state.actionMode === "Allocate") {
  	                if (hadTapSource) {
  	                  await applyDraftTyreMove(state.tapSource, positionKey);

  	                  clearTapSource();

  	                  state.pendingTyreAction = null;
  	                  state.allocatePopupOpen = true;

  	                  renderVisualTyreOperations();
  	                  renderAllocatePopup();
  	                  return;
  	                }

  	                tPositions = getRotationDraftTPositions();
  	                slot = getSlot(tPositions, positionKey);

  	                state.selectedPosition = positionKey;

  	                if (slot && slot.TyreObjectId) {
  	                  setTapSource("fitted", slot.TyreObjectId, slot.PositionKey);
  	                  state.selectedPosition = slot.PositionKey;
  	                  state.actionMessage = "Selected " + slot.PositionKey + ". Tap another position to move or swap it.";
  	                  state.actionError = false;
  	                } else {
  	                  state.actionMessage = "Select a warehouse tyre from the Allocate popup, or tap a fitted tyre first.";
  	                  state.actionError = false;
  	                }

  	                renderVisualTyreOperations();
  	                renderAllocatePopup();
  	                return;
  	              }

  	              await handleSlotTarget(positionKey);

  	              if (hadTapSource) {
  	                clearTapSource();
  	              }

  	              renderVisualTyreOperations();
  	            };
  	          });

  	        if (confirmPendingBtn) {
  	          confirmPendingBtn.onclick = async function () {
  	            if (state.actionMode === "Allocate") {
  	              renderAllocatePopup();
  	              state.actionMessage = "Confirm allocation inside the Allocate Tyre popup.";
  	              state.actionError = false;
  	              renderVisualTyreOperations();
  	              return;
  	            }

  	            var validation = validatePendingStillPossible();

  	            if (!validation.ok) {
  	              state.actionMessage = validation.message;
  	              state.actionError = true;
  	              renderVisualTyreOperations();
  	              return;
  	            }

  	            if (!(await confirmSafe(
  	              "Review the tyre movement before saving it to the vehicle and tyre histories.",
  	              {
  	                title: "Confirm Tyre Action", type: "warning", confirmText: "Save Action", cancelText: "Cancel", details: [{
  	                  label: "Planned Action", value: pendingActionLabel()
  	                }]
  	              }
  	            ))) {
  	              return;
  	            }

  	            confirmPendingBtn.disabled = true;
  	            confirmPendingBtn.textContent = "Saving...";

  	            executePendingTyreAction()
  	            .then(function (message) {
  	              state.pendingTyreAction = null;
  	              state.dragSource = null;
  	              state.tapSource = null;

  	              state.actionMessage = message || "Tyre action saved.";
  	              state.actionError = false;
  	              resetDraftTPositions();

  	              renderVisualTyreOperations();
  	              renderList(search.value || "");
  	            })
  	            .catch(function (error) {
  	              state.actionMessage = error && error.message ? error.message: "Tyre action failed.";
  	              state.actionError = true;
  	              renderVisualTyreOperations();
  	            });
  	          };
  	        }

  	        if (clearPendingBtn) {
  	          clearPendingBtn.onclick = function () {
  	            state.pendingTyreAction = null;
  	            state.dragSource = null;
  	            state.tapSource = null;
  	            state.actionMessage = "Pending tyre action cleared.";
  	            state.actionError = false;
  	            renderVisualTyreOperations();
  	          };
  	        }

  	        if (openRotationSavePopupBtn) {
  	          openRotationSavePopupBtn.onclick = function () {
  	            var arrows = getRotationArrows();

  	            if (!arrows.length) {
  	              state.actionMessage = "No rotation changes to save.";
  	              state.actionError = true;
  	              renderVisualTyreOperations();
  	              return;
  	            }

  	            state.rotationPopupOpen = true;
  	            renderRotationSavePopup();
  	          };
  	        }

  	        if (clearRotationPlanBtn) {
  	          clearRotationPlanBtn.onclick = function () {
  	            beginRotationPlan();

  	            state.rotationPopupOpen = false;
  	            closeFloatingPopup("rotationSavePopup");

  	            state.actionMessage = "Rotation plan cleared. Start dragging again.";
  	            state.actionError = false;
  	            renderVisualTyreOperations();
  	          };
  	        }

  	        if (removeSelectedBtn) {
  	          removeSelectedBtn.onclick = async function () {
  	            if (!(await confirmSafe(
  	              "The selected tyre will be removed from its fitted position using the destination and odometer entered in the removal panel.",
  	              {
  	                title: "Remove Tyre", type: "danger", confirmText: "Remove Tyre", cancelText: "Cancel"
  	              }
  	            ))) {
  	              return;
  	            }

  	            removeSelectedBtn.disabled = true;
  	            removeSelectedBtn.textContent = "Removing...";

  	            executeRemoveFromUi()
  	            .then(function (message) {
  	              state.pendingTyreAction = null;
  	              state.dragSource = null;
  	              state.tapSource = null;
  	              state.actionMessage = message || "Tyre removed.";
  	              state.actionError = false;
  	              resetDraftTPositions();

  	              renderVisualTyreOperations();
  	              renderList(search.value || "");
  	            })
  	            .catch(function (error) {
  	              state.actionMessage = error && error.message ? error.message: "Tyre removal failed.";
  	              state.actionError = true;
  	              renderVisualTyreOperations();
  	            });
  	          };
  	        }
  	      } // =========================================================
  	      function renderGenericTab(tabLabel) {
  	        var currentVehicle = state.activeTractor || tractor;
  	        var def = TAB_DEFS.filter(function (tabDef) {
  	          return tabDef.label === tabLabel;
  	        })[0];

  	        var key = def ? def.key: tabLabel.replace(/\s+/g, "");
  	        var root = currentVehicle.Data || {};
  	        var data = root[key];
  	        var keys;
  	        var objectKeys;
  	        var scalarKeys;
  	        var sections = [];
  	        var subTabBar;
  	        var subContent;

  	        body.innerHTML = "";

  	        if (!data || typeof data !== "object") {
  	          body.innerHTML = "<div style=\"color:#777;\">No Data</div>";
  	          return;
  	        }

  	        keys = Object.keys(data);

  	        objectKeys = keys.filter(function (k) {
  	          var value = data[k];

  	          return value &&
  	          typeof value === "object" &&
  	          !Array.isArray(value) &&
  	          !isWrapped(value);
  	        });

  	        scalarKeys = keys.filter(function (k) {
  	          return objectKeys.indexOf(k) === -1;
  	        });

  	        if (scalarKeys.length && !objectKeys.length) {
  	          body.innerHTML = buildForm(data, key);
  	          return;
  	        }

  	        if (scalarKeys.length) {
  	          var overview = {};

  	          scalarKeys.forEach(function (k) {
  	            overview[k] = data[k];
  	          });

  	          sections.push({
  	            key: "_overview",
  	            label: "Overview",
  	            value: overview,
  	            basePath: key
  	          });
  	        }

  	        objectKeys.forEach(function (k) {
  	          sections.push({
  	            key: k,
  	            label: prettyName(k),
  	            value: data[k],
  	            basePath: key + "." + k
  	          });
  	        });

  	        subTabBar = DocumentSafe.createElement("div");

  	        Object.assign(subTabBar.style, {
  	          display: "flex",
  	          flexWrap: "wrap",
  	          gap: "4px 6px",
  	          background: "#181818",
  	          padding: "8px 10px",
  	          borderBottom: "1px solid #333",
  	          position: "sticky",
  	          top: "0",
  	          zIndex: 5
  	        });

  	        subContent = DocumentSafe.createElement("div");
  	        subContent.style.marginTop = "8px";

  	        body.appendChild(subTabBar);
  	        body.appendChild(subContent);

  	        function setSubTab(subKey) {
  	          var section = sections.filter(function (s) {
  	            return s.key === subKey;
  	          })[0];

  	          if (!section) {
  	            return;
  	          }

  	          subContent.innerHTML = buildForm(section.value, section.basePath);

  	          Array.prototype.forEach.call(subTabBar.children, function (btn) {
  	            var selected = btn.dataset.subKey === subKey;

  	            Object.assign(btn.style, {
  	              background: selected ? "#262626": "transparent",
  	              color: selected ? "#fff": "#ccc",
  	              border: selected ? "1px solid #CC6633": "1px solid #333"
  	            });
  	          });
  	        }

  	        sections.forEach(function (section) {
  	          var btn = DocumentSafe.createElement("div");

  	          btn.textContent = section.label;
  	          btn.dataset.subKey = section.key;

  	          Object.assign(btn.style, {
  	            padding: "6px 12px",
  	            cursor: "pointer",
  	            borderRadius: "6px",
  	            fontSize: "12px",
  	            border: "1px solid #333"
  	          });

  	          btn.onclick = function () {
  	            setSubTab(section.key);
  	          };

  	          subTabBar.appendChild(btn);
  	        });

  	        if (sections.length) {
  	          setSubTab(sections[0].key);
  	        }
  	      }

  	      function renderTab(tabLabel) {
  	        if (tabLabel === "Tyres") {
  	          if (state.editMode) {
  	            renderAxleConfigurator();
  	          } else {
  	            renderVisualTyreOperations();

  	            loadTyres().then(function () {
  	              if (
  	                state.activeTractor &&
  	                vehicleObjectId(state.activeTractor) === vehicleObjectId(tractor) &&
  	                state.activeTab === "Tyres" &&
  	                !state.editMode
  	              ) {
  	                renderVisualTyreOperations();
  	              }
  	            });
  	          }

  	          return;
  	        }

  	        renderGenericTab(tabLabel);
  	      }

  	      state.__rerenderTyreEditor = function () {
  	        if (
  	          !state.activeTractor ||
  	          vehicleObjectId(state.activeTractor) !== vehicleObjectId(tractor)
  	        ) {
  	          return false;
  	        }

  	        if (state.activeTab === "Tyres" && !state.editMode) {
  	          renderVisualTyreOperations();
  	        } else {
  	          renderTab(state.activeTab || "Tyres");
  	        }

  	        if (typeof renderList === "function") {
  	          try {
  	            renderList(typeof search !== "undefined" && search && search.value ? search.value: "");
  	          } catch (error) {
  	            renderList("");
  	          }
  	        }

  	        return true;
  	      };

  	      function setActiveTab(label) {
  	        state.activeTab = label;

  	        if (label !== "Tyres") {
  	          clearPendingTyreAction();

  	          state.actionMode = "";
  	          state.allocatePopupOpen = false;
  	          state.rotationPopupOpen = false;
  	          state.allocateSelectedTyreId = "";

  	          closeFloatingPopup("allocateTyrePopup");
  	          closeFloatingPopup("rotationSavePopup");
  	        }

  	        renderTabButtons();
  	        renderTab(label);
  	      }

  	      function enableEdit() {
  	        state.editMode = true;

  	        clearPendingTyreAction();

  	        state.actionMode = "";
  	        state.allocatePopupOpen = false;
  	        state.rotationPopupOpen = false;
  	        state.allocateSelectedTyreId = "";

  	        closeFloatingPopup("allocateTyrePopup");
  	        closeFloatingPopup("rotationSavePopup");

  	        editBtn.style.display = "none";
  	        controlBar.style.display = "flex";
  	        fidInput.disabled = false;

  	        if (state.activeTab === "Tyres") {
  	          resetDraftTPositions();
  	        }

  	        renderTab(state.activeTab);
  	      }

  	      function disableEdit() {
  	        state.editMode = false;

  	        clearPendingTyreAction();

  	        state.actionMode = "";
  	        state.allocatePopupOpen = false;
  	        state.rotationPopupOpen = false;
  	        state.allocateSelectedTyreId = "";

  	        closeFloatingPopup("allocateTyrePopup");
  	        closeFloatingPopup("rotationSavePopup");

  	        editBtn.style.display = "block";
  	        controlBar.style.display = "none";
  	        fidInput.disabled = true;

  	        resetDraftTPositions();
  	        renderTab(state.activeTab);
  	      }

  	      editBtn.onclick = function () {
  	        if (!AllowAxleConfiguration) {
  	          return;
  	        }
  	        enableEdit();
  	      };

  	      cancelBtn.onclick = function () {
  	        disableEdit();
  	      };

  	      state.__inlineEnableEdit = function () {
  	        if (!AllowAxleConfiguration) {
  	          return false;
  	        }
  	        enableEdit();
  	        return true;
  	      };

  	      state.__inlineDisableEdit = function () {
  	        disableEdit();
  	        return true;
  	      };

  	      state.__inlineSetTyres = function () {
  	        setActiveTab("Tyres");
  	        return true;
  	      };

  	      saveBtn.onclick = function () {
  	        var updated = clone(state.activeTractor);
  	        var draft;
  	        var savePromise;

  	        saveBtn.disabled = true;
  	        saveBtn.textContent = "Saving...";

  	        if (state.activeTab === "Tyres") {
  	          draft = getDraftTPositions();

  	          writeTPositionsToVehicle(updated, draft);
  	          savePromise = saveVehicleWithTPositions(updated, draft);
  	        } else {
  	          applyBoundInputsToVehicle(updated, editorPanel);
  	          savePromise = saveVehicleOnly(updated);
  	        }

  	        savePromise
  	        .then(function (saved) {
  	          if (saved && typeof saved === "object") {
  	            state.activeTractor = saved;
  	          }

  	          saveBtn.textContent = "Saved";

  	          renderList(search.value || "");
  	          disableEdit();
  	        })
  	        .catch(function (error) {
  	          alertSafe(error && error.message ? error.message: "Save failed.");
  	        })
  	        .then(function () {
  	          saveBtn.disabled = false;
  	          saveBtn.textContent = "Save";
  	        });
  	      };

  	      renderTabButtons();
  	      setActiveTab(InlineMode ? "Tyres": "Vehicle");
  	    }

  	    if (InlineMode && InitialVehicle) {
  	      openEditor(InitialVehicle);
  	    }

  	    if (InlineMode) {
  	      return {
  	        configureAxles: function () {
  	          return state.__inlineEnableEdit ? state.__inlineEnableEdit(): false;
  	        },
  	        cancelAxleConfiguration: function () {
  	          return state.__inlineDisableEdit ? state.__inlineDisableEdit(): false;
  	        },
  	        showTyres: function () {
  	          return state.__inlineSetTyres ? state.__inlineSetTyres(): false;
  	        },
  	        destroy: function () {
  	          closeFloatingPopup("allocateTyrePopup");
  	          closeFloatingPopup("rotationSavePopup");
  	          removeExistingPanels();
  	          return true;
  	        }
  	      };
  	    }

  	    return true;
  	  }

  	  function fifCompanyTyreWarehouseManager(rawArgs, directApp, directTractors, directHub, directBackendless, directSvg) {

  	    rawArgs = rawArgs && typeof rawArgs === "object" ? rawArgs: {};

  	    var WindowSafe = typeof window !== "undefined" ? window: null;
  	    var DocumentSafe = typeof document !== "undefined" ? document: null;
  	    var InlineMode = !!rawArgs.InlineMode;
  	    var HostSafe = rawArgs.Hub || directHub || null;
  	    var InitialCompany = rawArgs.Company || null;
  	    var HideCompanySelector = rawArgs.HideCompanySelector !== false;
  	    var HideClose = rawArgs.HideClose !== false;
  	    var AllowEditing = rawArgs.AllowEditing !== false;
  	    var ManagerTitle = String(rawArgs.Title || "Tyre Warehouse");
  	    var OnFinancialEvent = typeof rawArgs.OnFinancialEvent === "function" ? rawArgs.OnFinancialEvent: null;

  	    function emitFinancialEvent(event) {
  	      if (!OnFinancialEvent) return Promise.resolve(null);
  	      try {
  	        return Promise.resolve(OnFinancialEvent(event || {}));
  	      }
  	      catch (error) {
  	        return Promise.reject(error);
  	      }
  	    }

  	    var AppSafe = rawArgs.App || directApp || (typeof App !== "undefined" ? App: null);
  	    var VehiclesSafe = Array.isArray(rawArgs.Tractors)
  	      ? rawArgs.Tractors
  	      : Array.isArray(directTractors)
  	        ? directTractors
  	        : [];
  	    var BackendlessSafe = rawArgs.Backendless || directBackendless || (typeof Backendless !== "undefined" ? Backendless: null);
  	    var SvgSafe = rawArgs.SVG || rawArgs.svg || directSvg || (typeof SVG !== "undefined" ? SVG: "");

  	    var TABLE_TYRES = "Tyres";
  	    var ROOT_ID = "companyTyreManagerRoot";
  	    var MODAL_PORTAL_ID = "companyTyreManagerModalPortal";
  	    var CSS_SCOPE = ":is(#" + ROOT_ID + ",#" + MODAL_PORTAL_ID + ")";
  	    var modalPortalEl = null;

  	    var DEFAULT_FLEET_PREFIX = "FLE TY";
  	    var DEFAULT_FLEET_PADDING = 5;

  	    var TYRE_STATUS = {
  	      OK: "All In Order",
  	      RETREAD: "In For Retread",
  	      SCRAPPED: "Scrapped",
  	      STOLEN: "Stolen"
  	    };

  	    var STAGES = ["New",
  	      "Cap1",
  	      "Cap2",
  	      "Cap3"];
  	    var TYPES = ["Steer",
  	      "Drive",
  	      "Trailer",
  	      "Spare"];

  	    if (!DocumentSafe || !DocumentSafe.body) {

  	      return false;
  	    }

  	    function resolveHostElement(value) {
  	      if (!value || !DocumentSafe) return null;
  	      if (value instanceof HTMLElement) return value;
  	      if (value.el instanceof HTMLElement) return value.el;
  	      if (value.element instanceof HTMLElement) return value.element;
  	      if (value.elRef instanceof HTMLElement) return value.elRef;
  	      if (value.ref instanceof HTMLElement) return value.ref;
  	      if (typeof value.getEl === "function") {
  	        try {
  	          var resolved = value.getEl();
  	          if (resolved instanceof HTMLElement) return resolved;
  	        } catch (_) {}
  	      }
  	      return null;
  	    }

  	    function createOwnRootDiv() {
  	      var root = resolveHostElement(HostSafe) || DocumentSafe.getElementById(ROOT_ID);

  	      if (!root) {
  	        root = DocumentSafe.createElement("div");
  	        root.id = ROOT_ID;
  	        DocumentSafe.body.appendChild(root);
  	      }

  	      root.id = ROOT_ID;
  	      root.removeAttribute("style");
  	      root.className = InlineMode ? "ctm-inline-root": "";

  	      if (InlineMode) {
  	        root.style.position = "relative";
  	        root.style.inset = "auto";
  	        root.style.width = "100%";
  	        root.style.height = "100%";
  	        root.style.minHeight = "0";
  	        root.style.zIndex = "1";
  	        root.style.overflow = "hidden";
  	        root.style.boxSizing = "border-box";
  	        root.style.background = "transparent";
  	        root.style.padding = "0";
  	        root.style.margin = "0";
  	        root.style.display = "flex";
  	        root.style.justifyContent = "stretch";
  	        root.style.alignItems = "stretch";
  	        return root;
  	      }

  	      root.style.position = "fixed";
  	      root.style.top = "50px";
  	      root.style.right = "200px";
  	      root.style.bottom = "0";
  	      root.style.left = "0";
  	      root.style.zIndex = "99999";
  	      root.style.overflow = "hidden";
  	      root.style.boxSizing = "border-box";
  	      root.style.background = "#0f0f0f";
  	      root.style.padding = "0";
  	      root.style.margin = "0";
  	      root.style.display = "flex";
  	      root.style.justifyContent = "stretch";
  	      root.style.alignItems = "stretch";

  	      return root;
  	    }

  	    function removeModalPortal() {
  	      var existing = DocumentSafe.getElementById(MODAL_PORTAL_ID);
  	      if (existing) {
  	        existing.onclick = null;
  	        existing.innerHTML = "";
  	        if (existing.parentNode) existing.parentNode.removeChild(existing);
  	      }
  	      modalPortalEl = null;
  	    }

  	    function mountModalPortal(markup) {
  	      removeModalPortal();
  	      if (!markup) return null;

  	      modalPortalEl = DocumentSafe.createElement("div");
  	      modalPortalEl.id = MODAL_PORTAL_ID;
  	      modalPortalEl.setAttribute("data-ctm-modal-portal", "true");
  	      Object.assign(modalPortalEl.style, {
  	        position: "fixed",
  	        inset: "0",
  	        zIndex: "2147483646",
  	        pointerEvents: "none",
  	        width: "100vw",
  	        height: "100dvh",
  	        overflow: "visible"
  	      });
  	      modalPortalEl.innerHTML = markup;
  	      DocumentSafe.body.appendChild(modalPortalEl);
  	      return modalPortalEl;
  	    }

  	    var hubEl = createOwnRootDiv();

  	    function escapeHtml(value) {
  	      return String(value == null ? "": value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/\"/g, "&quot;")
  	      .replace(/'/g, "&#39;");
  	    }

  	    function clean(value) {
  	      return String(value == null ? "": value).trim();
  	    }

  	    function reportLogoHtml() {
  	      var svg = clean(SvgSafe);
  	      var cleaned;

  	      if (!svg) {
  	        return "";
  	      }

  	      if (svg.indexOf("data:image") === 0) {
  	        return "<img class=\"ctm-report-logo\" src=\"" + escapeHtml(svg) + "\" alt=\"Report Logo\">";
  	      }

  	      if (svg.indexOf("<svg") === 0) {
  	        cleaned = svg
  	        .replace(/<script[\s\S]*?<\/script>/gi, "")
  	        .replace(/<svg(?![^>]*preserveAspectRatio)/i, "<svg preserveAspectRatio=\"xMidYMid meet\"")
  	        .replace(/<svg([^>]*?)>/i, "<svg$1 class=\"ctm-report-logo-svg\">");

  	        return "<div class=\"ctm-report-logo-inline\">" + cleaned + "</div>";
  	      }

  	      return "";
  	    }

  	    function arr(value) {
  	      return Array.isArray(value) ? value: [];
  	    }

  	    function clone(value) {
  	      return JSON.parse(JSON.stringify(value || {}));
  	    }

  	    function numberOrNull(value) {
  	      if (value === null || value === undefined || value === "") {
  	        return null;
  	      }

  	      var number = Number(value);

  	      return isFinite(number) ? number: null;
  	    }

  	    function nowIso() {
  	      return new Date().toISOString();
  	    }

  	    function alertSafe(message, options) {
  	      if (typeof rawArgs.Alert === "function") {
  	        try {
  	          Promise.resolve(rawArgs.Alert(message, Object.assign({
  	            title: ManagerTitle,
  	            type: "warning",
  	            confirmText: "Close"
  	          }, options || {}))).catch(function (error) {

  	          });
  	          return;
  	        } catch (error) {

  	        }
  	      }

  	      if (WindowSafe && typeof WindowSafe.alert === "function") {
  	        WindowSafe.alert(message);
  	        return;
  	      }

  	    }

  	    function confirmSafe(message) {
  	      if (WindowSafe && typeof WindowSafe.confirm === "function") {
  	        return WindowSafe.confirm(message);
  	      }

  	      return true;
  	    }

  	    function confirmSafeAsync(message, options) {
  	      if (typeof rawArgs.Confirm === "function") {
  	        try {
  	          return Promise.resolve(rawArgs.Confirm(message, Object.assign({
  	            title: ManagerTitle,
  	            type: "warning",
  	            confirmText: "Discard Changes",
  	            cancelText: "Keep Editing"
  	          }, options || {})));
  	        } catch (error) {

  	        }
  	      }
  	      return Promise.resolve(confirmSafe(message));
  	    }

  	    async function confirmPrompt(message, options) {
  	      if (typeof rawArgs.Confirm === "function") {
  	        try {
  	          return !!(await rawArgs.Confirm(message, Object.assign({
  	            title: ManagerTitle,
  	            type: "warning",
  	            confirmText: "Confirm",
  	            cancelText: "Cancel"
  	          }, options || {})));
  	        } catch (error) {

  	        }
  	      }

  	      return confirmSafe(message);
  	    }

  	    function requireEditing() {
  	      if (AllowEditing) return true;
  	      alertSafe("You may view the tyre warehouse, but tyre changes require the Tyres permission.", {
  	        title: "Tyre Warehouse — View Only",
  	        type: "info"
  	      });
  	      return false;
  	    }

  	    function getFirst(source, names) {
  	      var i;

  	      if (!source || typeof source !== "object") {
  	        return "";
  	      }

  	      for (i = 0; i < names.length; i++) {
  	        if (
  	          Object.prototype.hasOwnProperty.call(source, names[i]) &&
  	          source[names[i]] !== null &&
  	          source[names[i]] !== undefined
  	        ) {
  	          return source[names[i]];
  	        }
  	      }

  	      return "";
  	    }

  	    function readValue(id) {
  	      var el = DocumentSafe.getElementById(id);

  	      if (!el) {
  	        return "";
  	      }

  	      return clean(el.value);
  	    }

  	    function parseJson(raw, fallback) {
  	      if (raw === null || raw === undefined || raw === "") {
  	        return clone(fallback);
  	      }

  	      if (typeof raw === "object") {
  	        return clone(raw);
  	      }

  	      try {
  	        return JSON.parse(raw);
  	      } catch (error) {

  	        return clone(fallback);
  	      }
  	    }

  	    function escapeRegex(value) {
  	      return String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  	    }

  	    function zeroPad(number, width) {
  	      var text = String(Math.max(0, Number(number) || 0));

  	      while (text.length < width) {
  	        text = "0" + text;
  	      }

  	      return text;
  	    }

  	    function normaliseFleetPrefix(prefix) {
  	      return clean(prefix || DEFAULT_FLEET_PREFIX).replace(/\s+/g, " ");
  	    }

  	    function formatFleetNumber(prefix, number) {
  	      return normaliseFleetPrefix(prefix) + " " + zeroPad(number, DEFAULT_FLEET_PADDING);
  	    }

  	    function companyObjectId(company) {
  	      return clean(getFirst(company, ["objectId", "ObjectId", "objectID", "id", "CompanyId"]));
  	    }

  	    function companyName(company) {
  	      var direct = clean(getFirst(company, [
  	        "Name",
  	        "Company_Name",
  	        "CompanyName",
  	        "Trading_Name",
  	        "TradingName",
  	        "Name_Company"
  	      ]));
  	      var profile = company && company.Data && company.Data.Profile ? company.Data.Profile: {};
  	      var profileName = getFirst(profile, ["Company_Name", "Trading_As"]);

  	      if (profileName && typeof profileName === "object" && !Array.isArray(profileName) && Object.prototype.hasOwnProperty.call(profileName, "value")) {
  	        profileName = profileName.value;
  	      }

  	      return direct || clean(profileName) || clean(company && company.CompanyId) || companyObjectId(company) || "Company";
  	    }

  	    function companyClassName(company) {
  	      return clean(getFirst(company, ["___class", "__class", "className"])) || "Companies";
  	    }

  	    function collectCompanies() {
  	      var companies = [];
  	      var seen = {};

  	      try {
  	        var sourceCompanies = InitialCompany ? [InitialCompany]: arr(AppSafe && AppSafe.User && AppSafe.User.Companies);

  	        sourceCompanies.forEach(function (company) {
  	          var id = companyObjectId(company);

  	          if (!id) {
  	            return;
  	          }

  	          if (!seen[id]) {
  	            seen[id] = true;

  	            companies.push({
  	              id: id,
  	              name: companyName(company),
  	              className: companyClassName(company),
  	              row: company
  	            });
  	          }
  	        });
  	      } catch (error) {

  	      }

  	      return companies;
  	    }

  	    var companies = collectCompanies();

  	    function defaultCompanyId() {
  	      return companies.length ? companies[0].id: "";
  	    }

  	    function selectedCompany() {
  	      var i;

  	      for (i = 0; i < companies.length; i++) {
  	        if (companies[i].id === state.companyId) {
  	          return companies[i];
  	        }
  	      }

  	      return null;
  	    }

  	    function canAccessCompanyId(companyId) {
  	      var i;

  	      for (i = 0; i < companies.length; i++) {
  	        if (companies[i].id === companyId) {
  	          return true;
  	        }
  	      }

  	      return false;
  	    }

  	    function tyreObjectId(tyre) {
  	      return clean(getFirst(tyre, ["objectId", "ObjectId", "objectID", "id"]));
  	    }

  	    function tyreNumber(tyre) {
  	      return clean(getFirst(tyre, [
  	        "ID",
  	        "FID",
  	        "Tyre_Number",
  	        "TyreNumber",
  	        "Serial_Number",
  	        "SerialNumber"
  	      ]));
  	    }

  	    function tyreSerial(tyre) {
  	      return clean(getFirst(tyre, ["Serial_Number", "SerialNumber", "Serial"]));
  	    }

  	    function tyreMake(tyre) {
  	      return clean(getFirst(tyre, ["Make", "Tyre_Brand", "Brand"]));
  	    }

  	    function tyreModel(tyre) {
  	      return clean(getFirst(tyre, ["Model", "Pattern"]));
  	    }

  	    function tyreSize(tyre) {
  	      return clean(getFirst(tyre, ["Size"]));
  	    }

  	    function tyreType(tyre) {
  	      return clean(getFirst(tyre, ["Type"]));
  	    }

  	    function tyreStatus(tyre) {
  	      return clean(getFirst(tyre, ["Status"])) || TYRE_STATUS.OK;
  	    }

  	    function tyreStage(tyre) {
  	      return clean(getFirst(tyre, ["Current_Stage"])) || "New";
  	    }

  	    function tyreName(tyre) {
  	      return [
  	        tyreNumber(tyre),
  	        tyreSerial(tyre),
  	        tyreMake(tyre),
  	        tyreModel(tyre),
  	        tyreSize(tyre)
  	      ].filter(Boolean).join(" - ") || tyreObjectId(tyre) || "Tyre";
  	    }

  	    function tyreIsFitted(tyre) {
  	      return !!clean(tyre && tyre.Vehicle_ObjectId);
  	    }

  	    function tyreIsWarehouse(tyre) {
  	      return !tyreIsFitted(tyre) && tyreStatus(tyre) === TYRE_STATUS.OK;
  	    }

  	    function tyreLinkedVehicle(tyre) {
  	      var linkedId = clean(getFirst(tyre, ["Vehicle_ObjectId", "VehicleObjectId"]));
  	      var linkedCode = clean(getFirst(tyre, ["Vehicle_ID", "VehicleId"]));
  	      var i;
  	      var vehicle;
  	      var vehicleId;
  	      var vehicleCode;

  	      for (i = 0; i < VehiclesSafe.length; i++) {
  	        vehicle = VehiclesSafe[i];
  	        vehicleId = clean(getFirst(vehicle, ["objectId", "ObjectId", "objectID", "id"]));
  	        vehicleCode = clean(getFirst(vehicle, ["ID", "FID", "Registration"]));

  	        if ((linkedId && vehicleId === linkedId) || (linkedCode && vehicleCode === linkedCode)) {
  	          return vehicle;
  	        }
  	      }

  	      return null;
  	    }

  	    function tyreUsesHoursCounter(tyre) {
  	      var vehicle = tyreLinkedVehicle(tyre);
  	      var direct = clean(getFirst(vehicle, ["CounterType"]));
  	      var readingUnit = vehicle && vehicle.Data && vehicle.Data.Vehicle
  	        ? vehicle.Data.Vehicle.ReadingUnit
  	        : "";
  	      var descriptor = readingUnit && typeof readingUnit === "object" && Object.prototype.hasOwnProperty.call(readingUnit, "value")
  	        ? readingUnit.value
  	        : readingUnit;
  	      var value = clean(direct || descriptor).toLowerCase();

  	      return value === "hours";
  	    }

  	    function tyreCounterUnit(tyre) {
  	      return tyreUsesHoursCounter(tyre) ? "h" : "km";
  	    }

  	    function formatTyreCounter(value, tyre) {
  	      var n = numberOrNull(value);

  	      if (n === null) {
  	        return "—";
  	      }

  	      return Math.round(n).toLocaleString() + " " + tyreCounterUnit(tyre);
  	    }

  	    function tyreCounterName(tyre) {
  	      return tyreUsesHoursCounter(tyre) ? "Hours" : "Mileage";
  	    }

  	    function tyreCounterHistoryHeading(tyre) {
  	      return tyreUsesHoursCounter(tyre) ? "Hobbs Meter" : "Odometer";
  	    }

  	    function tyreHistoryActivityLabel(value, tyre) {
  	      var label = historyDisplayValue(value);
  	      return tyreUsesHoursCounter(tyre) ? label.replace(/Mileage/gi, "Hours").replace(/Odometer/gi, "Hobbs Meter") : label;
  	    }

  	    function tyreRemainingMileageVisual(tyre) {
  	      return tyreUsesHoursCounter(tyre) ? "—" : formatMileage(tyreRemainingMileage(tyre));
  	    }

  	    function tyreRemainingHoursVisual(tyre) {
  	      return tyreUsesHoursCounter(tyre) ? formatHours(tyreRemainingMileage(tyre)) : "—";
  	    }

  	    function formatTyreHistoryCounter(value, tyre) {
  	      var n = numberOrNull(value);
  	      return n === null ? historyDisplayValue(value) : formatTyreCounter(n, tyre);
  	    }

  	    function tyreHistoryFieldLabel(key, tyre) {
  	      var label = clean(key).replace(/_/g, " ");
  	      if (!tyreUsesHoursCounter(tyre)) return label;

  	      return label
  	      .replace(/Fitted Odometer/gi, "Fitted Hobbs Meter")
  	      .replace(/Odometer/gi, "Hobbs Meter")
  	      .replace(/Expected Remaining Mileage/gi, "Expected Remaining Hours")
  	      .replace(/Remaining Mileage/gi, "Remaining Hours")
  	      .replace(/Expected Mileage/gi, "Expected Hours")
  	      .replace(/Current Mileage/gi, "Current Hours")
  	      .replace(/Start Mileage/gi, "Start Hours")
  	      .replace(/End Mileage/gi, "End Hours")
  	      .replace(/Mileage Done/gi, "Hours Done")
  	      .replace(/Mileage Expected/gi, "Hours Expected")
  	      .replace(/Total Mileage/gi, "Total Hours")
  	      .replace(/Mileage Warning/gi, "Hours Warning")
  	      .replace(/Mileage/gi, "Hours");
  	    }

  	    function tyreRemainingMileage(tyre) {
  	      var direct = numberOrNull(getFirst(tyre, [
  	        "Remaining_Mileage",
  	        "RemainingMileage",
  	        "Remaining_KM",
  	        "RemainingKm"
  	      ]));
  	      var expected;
  	      var current;

  	      if (direct !== null) {
  	        return direct;
  	      }

  	      expected = numberOrNull(getFirst(tyre, [
  	        "Expected_Mileage",
  	        "ExpectedMileage"
  	      ]));

  	      current = numberOrNull(getFirst(tyre, [
  	        "Current_Mileage",
  	        "CurrentMileage"
  	      ]));

  	      if (expected !== null && current !== null) {
  	        return Math.max(0, expected - current);
  	      }

  	      return null;
  	    }

  	    function formatMileage(value) {
  	      var n = numberOrNull(value);

  	      if (n === null) {
  	        return "—";
  	      }

  	      return Math.round(n).toLocaleString() + " km";
  	    }

  	    function sortText(value) {
  	      return clean(value).toLowerCase();
  	    }

  	    function sortValueForTyre(tyre, key) {
  	      if (key === "tyre") {
  	        return sortText(tyreNumber(tyre) || tyreObjectId(tyre));
  	      }

  	      if (key === "remainingMileage") {
  	        return tyreUsesHoursCounter(tyre) ? null : tyreRemainingMileage(tyre);
  	      }

  	      if (key === "remainingHours") {
  	        return tyreUsesHoursCounter(tyre) ? tyreRemainingMileage(tyre) : null;
  	      }

  	      if (key === "type") {
  	        return sortText(tyreType(tyre));
  	      }

  	      if (key === "stage") {
  	        return sortText(tyreStage(tyre));
  	      }

  	      if (key === "status") {
  	        return sortText(tyreStatus(tyre));
  	      }

  	      if (key === "warning") {
  	        return sortText(mileageWarningText(tyre));
  	      }

  	      if (key === "location") {
  	        return sortText(locationText(tyre) + " " + locationSubText(tyre));
  	      }
  	      return sortText(tyreName(tyre));
  	    }

  	    function compareSortValues(a, b, key, dir) {
  	      var av = sortValueForTyre(a, key);
  	      var bv = sortValueForTyre(b, key);
  	      var direction = dir === "desc" ? -1: 1;
  	      var aMissing = av === null || av === undefined || av === "";
  	      var bMissing = bv === null || bv === undefined || bv === "";

  	      if (aMissing && bMissing) {
  	        return tyreName(a).localeCompare(tyreName(b));
  	      }

  	      if (aMissing) {
  	        return 1;
  	      }

  	      if (bMissing) {
  	        return -1;
  	      }

  	      if (typeof av === "number" || typeof bv === "number") {
  	        av = Number(av) || 0;
  	        bv = Number(bv) || 0;

  	        if (av < bv) return -1 * direction;
  	        if (av > bv) return 1 * direction;

  	        return tyreName(a).localeCompare(tyreName(b));
  	      }

  	      return String(av).localeCompare(String(bv)) * direction || tyreName(a).localeCompare(tyreName(b));
  	    }

  	    function sortHeaderHtml(key, label) {
  	      var active = state.sortKey === key;
  	      var arrow = active ? (state.sortDir === "asc" ? " ▲": " ▼"): "";

  	      return ""
  	      + "<button type=\"button\" class=\"ctm-sort-head\" data-sort-key=\"" + escapeHtml(key) + "\">"
  	      + escapeHtml(label + arrow)
  	      + "</button>";
  	    }

  	    function tyreSearchBlob(tyre) {
  	      return [
  	        tyreObjectId(tyre),
  	        tyreNumber(tyre),
  	        tyreSerial(tyre),
  	        tyreMake(tyre),
  	        tyreModel(tyre),
  	        tyreSize(tyre),
  	        tyreType(tyre),
  	        tyreStage(tyre),
  	        tyreStatus(tyre),
  	        clean(tyre && tyre.Vehicle_ID),
  	        clean(tyre && tyre.Current_Position),
  	        clean(tyre && tyre.Company_ID),
  	        clean(tyre && tyre.__CompanyName)
  	      ].join(" ").toLowerCase();
  	    }

  	    function clampTyreValue(value, min, max, fallback) {
  	      var number = Number(value);

  	      if (!isFinite(number)) {
  	        number = fallback;
  	      }

  	      return Math.max(min, Math.min(max, number));
  	    }

  	    function tyreLife(tyre) {
  	      var direct;
  	      var currentMileage;
  	      var expectedMileage;

  	      if (!tyre) {
  	        return null;
  	      }

  	      if (tyreStatus(tyre) === TYRE_STATUS.SCRAPPED) {
  	        return 0;
  	      }

  	      direct = numberOrNull(tyre.Current_Life);

  	      if (direct !== null) {
  	        return clampTyreValue(direct, 0, 100, 0);
  	      }

  	      currentMileage = numberOrNull(tyre.Current_Mileage);
  	      expectedMileage = numberOrNull(tyre.Expected_Mileage);

  	      if (currentMileage !== null && expectedMileage !== null && expectedMileage > 0) {
  	        return clampTyreValue(100 - ((currentMileage / expectedMileage) * 100), 0, 100, 0);
  	      }

  	      if (tyreStatus(tyre) === TYRE_STATUS.OK && tyreStage(tyre) === "New") {
  	        return 100;
  	      }

  	      return null;
  	    }

  	    function tyreVisualColor(tyre) {
  	      var life = tyreLife(tyre);

  	      if (tyreStatus(tyre) === TYRE_STATUS.SCRAPPED) return "#7b3935";
  	      if (tyreStatus(tyre) === TYRE_STATUS.RETREAD) return "#8a5a33";
  	      if (tyreStatus(tyre) === TYRE_STATUS.STOLEN) return "#4e455f";

  	      if (life === null) return "#6b7280";
  	      if (life <= 0) return "#111827";
  	      if (life < 20) return "#ff2b1a";
  	      if (life < 40) return "#ff8a00";
  	      if (life < 60) return "#ffd633";
  	      if (life < 80) return "#a6ff33";

  	      return "#39ff14";
  	    }

  	    function tyreLifeText(tyre) {
  	      var life = tyreLife(tyre);

  	      if (life === null) {
  	        return "Life not set";
  	      }

  	      return Math.round(life) + "% life";
  	    }

  	    function tyreGraphicHtml(tyre, variant) {
  	      var isLarge = variant === "large";
  	      var color = tyreVisualColor(tyre);
  	      var number = tyreNumber(tyre) || "Tyre";
  	      var title = [
  	        number,
  	        tyreMake(tyre),
  	        tyreModel(tyre),
  	        tyreSize(tyre),
  	        tyreStage(tyre),
  	        tyreStatus(tyre),
  	        tyreLifeText(tyre)
  	      ].filter(Boolean).join(" - ");

  	      return ""
  	      + "<div class=\"ctm-tyre-visual-wrap" + (isLarge ? " ctm-tyre-visual-large": "") + "\" title=\"" + escapeHtml(title) + "\">"
  	      + "  <div class=\"ctm-tyre-graphic\" style=\"--ctm-tyre-color:" + escapeHtml(color) + ";\"></div>"
  	      + "  <div class=\"ctm-tyre-visual-text\">"
  	      + "    <div>" + escapeHtml(number) + "</div>"
  	      + "    <div>" + escapeHtml(tyreLifeText(tyre)) + "</div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function parseFleetSequence(value, prefix) {
  	      var cleanPrefix = normaliseFleetPrefix(prefix);
  	      var text = clean(value).replace(/\s+/g, " ");
  	      var re;
  	      var match;

  	      if (!text) {
  	        return null;
  	      }

  	      re = new RegExp("^" + escapeRegex(cleanPrefix) + "\\s+(\\d+)$", "i");
  	      match = text.match(re);

  	      if (!match) {
  	        return null;
  	      }

  	      return Number(match[1]);
  	    }

  	    function tyreFleetNumberValues(tyre) {
  	      return [
  	        clean(tyre && tyre.ID),
  	        clean(tyre && tyre.FID),
  	        clean(tyre && tyre.Tyre_Number),
  	        clean(tyre && tyre.TyreNumber)
  	      ].filter(Boolean);
  	    }

  	    function parseFleetIdentity(value) {
  	      var text = clean(value).replace(/\s+/g, " ");
  	      var match;
  	      var prefix;
  	      if (!text) return null;
  	      match = text.match(/^(.*?)(\d+)$/);
  	      if (!match) return null;
  	      prefix = normaliseFleetPrefix(match[1]);
  	      if (!prefix) return null;
  	      return {
  	        prefix: prefix,
  	        number: Number(match[2]),
  	        padding: match[2].length,
  	        value: text
  	      };
  	    }

  	    function tyreRecordTimestamp(tyre) {
  	      var values = [
  	        tyre && tyre.created,
  	        tyre && tyre.Created,
  	        tyre && tyre.updated,
  	        tyre && tyre.Updated,
  	        tyre && tyre.Creation_Date,
  	        tyre && tyre.CreatedAt,
  	        tyre && tyre.createdAt
  	      ];
  	      var best = 0;
  	      values.forEach(function (value) {
  	        var numeric = Number(value);
  	        var parsed;
  	        if (Number.isFinite(numeric) && numeric > best) best = numeric;
  	        parsed = Date.parse(value);
  	        if (Number.isFinite(parsed) && parsed > best) best = parsed;
  	      });
  	      return best;
  	    }

  	    function occupiedFleetNumberMap(prefix) {
  	      var map = {};
  	      companyScopedTyres().forEach(function (tyre) {
  	        tyreFleetNumberValues(tyre).forEach(function (value) {
  	          var number = parseFleetSequence(value, prefix);
  	          if (number !== null) map[number] = true;
  	        });
  	      });
  	      return map;
  	    }

  	    function nextAvailableFleetSequence(prefix, count, startHint) {
  	      var occupied = occupiedFleetNumberMap(prefix);
  	      var candidate = Math.max(1, Number(startHint) || 1);
  	      var needed = Math.max(1, Math.min(500, Number(count) || 1));
  	      var guard = 0;
  	      var offset;
  	      var free;

  	      while (guard < 100000) {
  	        free = true;
  	        for (offset = 0; offset < needed; offset += 1) {
  	          if (occupied[candidate + offset]) {
  	            free = false;
  	            candidate = candidate + offset + 1;
  	            break;
  	          }
  	        }
  	        if (free) return candidate;
  	        guard += 1;
  	      }
  	      return Math.max(1, Number(startHint) || 1);
  	    }

  	    function latestFleetSeed() {
  	      var scoped = companyScopedTyres();
  	      var latest = null;

  	      scoped.forEach(function (tyre, index) {
  	        var identity = null;
  	        tyreFleetNumberValues(tyre).some(function (value) {
  	          identity = parseFleetIdentity(value);
  	          return !!identity;
  	        });
  	        if (!identity) return;

  	        var timestamp = tyreRecordTimestamp(tyre);
  	        var candidate = {
  	          prefix: identity.prefix,
  	          number: identity.number,
  	          value: formatFleetNumber(identity.prefix, identity.number),
  	          timestamp: timestamp,
  	          index: index
  	        };

  	        if (
  	          !latest ||
  	          (candidate.timestamp && !latest.timestamp) ||
  	          candidate.timestamp > latest.timestamp ||
  	          (candidate.timestamp === latest.timestamp && candidate.index > latest.index)
  	        ) {
  	          latest = candidate;
  	        }
  	      });

  	      if (!latest) {
  	        return {
  	          prefix: DEFAULT_FLEET_PREFIX,
  	          lastNumber: "",
  	          nextNumber: nextAvailableFleetSequence(DEFAULT_FLEET_PREFIX, 1, 1)
  	        };
  	      }

  	      return {
  	        prefix: latest.prefix,
  	        lastNumber: latest.value,
  	        nextNumber: nextAvailableFleetSequence(
  	          latest.prefix,
  	          1,
  	          Math.max(latest.number + 1, highestFleetSequence(latest.prefix) + 1)
  	        )
  	      };
  	    }

  	    function bulkAvailability(prefix, start, count) {
  	      var ids = bulkPreviewIds(prefix, start, count);
  	      var existing = {};
  	      var duplicates = [];
  	      companyScopedTyres().forEach(function (tyre) {
  	        tyreFleetNumberValues(tyre).forEach(function (value) {
  	          existing[clean(value).toLowerCase()] = true;
  	        });
  	      });
  	      ids.forEach(function (id) {
  	        if (existing[clean(id).toLowerCase()]) duplicates.push(id);
  	      });
  	      return {
  	        ids: ids,
  	        duplicates: duplicates,
  	        available: duplicates.length === 0,
  	        nextAvailableStart: nextAvailableFleetSequence(prefix, count, start)
  	      };
  	    }

  	    function openNewTyresModal() {
  	      var seed = latestFleetSeed();
  	      var count = Math.max(1, Math.min(500, Number(state.bulkCount) || 1));
  	      state.bulkSeed = seed;
  	      state.bulkPrefix = seed.prefix;
  	      state.bulkStart = nextAvailableFleetSequence(seed.prefix, count, seed.nextNumber);
  	      state.bulkCount = count;
  	      state.modal = { type: "new" };
  	      render();
  	    }

  	    function nextStage(stage) {
  	      var index = STAGES.indexOf(clean(stage) || "New");

  	      if (index === -1) {
  	        return "Cap1";
  	      }

  	      if (index >= STAGES.length - 1) {
  	        return "";
  	      }

  	      return STAGES[index + 1];
  	    }

  	    function clearVehicleFields(tyre) {
  	      tyre.Vehicle_ObjectId = null;
  	      tyre.Vehicle_ID = null;
  	      tyre.Vehicle_Type = null;
  	      tyre.Current_Position = null;
  	      tyre.Current_Axle_Type = null;
  	      tyre.Current_Wear_Rate = null;
  	      tyre.Fitted_Date = null;
  	      tyre.Fitted_Odometer = null;
  	      return tyre;
  	    }

  	    function blankHistoryStage(active) {
  	      return {
  	        CPK: 0,
  	        Cost: 0,
  	        Ended: "",
  	        Notes: "",
  	        Active: !!active,
  	        Events: [],
  	        Status: active ? "Active": "Not Started",
  	        Started: active ? nowIso(): "",
  	        End_Mileage: 0,
  	        Mileage_Done: 0,
  	        Start_Mileage: 0,
  	        Mileage_Expected: 0
  	      };
  	    }

  	    function defaultHistory(tyre) {
  	      var stage = tyreStage(tyre);

  	      return {
  	        New: blankHistoryStage(stage === "New"),
  	        Cap1: blankHistoryStage(stage === "Cap1"),
  	        Cap2: blankHistoryStage(stage === "Cap2"),
  	        Cap3: blankHistoryStage(stage === "Cap3"),
  	        Totals: {
  	          Cost_Total: numberOrNull(tyre && tyre.Total_Cost) || 0,
  	          Average_CPK: numberOrNull(tyre && tyre.Total_CPK) || 0,
  	          Mileage_Total: numberOrNull(tyre && tyre.Total_Mileage) || 0,
  	          Total_Life_Stages_Used: 1
  	        },
  	        Current: {
  	          Stage: stage
  	        }
  	      };
  	    }

  	    function normaliseHistory(tyre) {
  	      var fallback = defaultHistory(tyre);
  	      var history = parseJson(tyre && tyre.History, fallback);

  	      STAGES.forEach(function (stage) {
  	        if (!history[stage] || typeof history[stage] !== "object") {
  	          history[stage] = clone(fallback[stage]);
  	        }

  	        if (!Array.isArray(history[stage].Events)) {
  	          history[stage].Events = [];
  	        }
  	      });

  	      if (!history.Totals || typeof history.Totals !== "object") {
  	        history.Totals = clone(fallback.Totals);
  	      }

  	      if (!history.Current || typeof history.Current !== "object") {
  	        history.Current = {
  	          Stage: tyreStage(tyre)
  	        };
  	      }

  	      return history;
  	    }

  	    function tyreWarningThresholdKm(tyre) {
  	      var history = normaliseHistory(tyre);
  	      var threshold = numberOrNull(history && history.Current && history.Current.Warning_Threshold_KM);

  	      return threshold !== null && threshold > 0 ? threshold : null;
  	    }

  	    function tyreWarningThresholdHours(tyre) {
  	      var history = normaliseHistory(tyre);
  	      var threshold = numberOrNull(history && history.Current && history.Current.Warning_Threshold_Hours);

  	      return threshold !== null && threshold > 0 ? threshold : null;
  	    }

  	    function tyreWarningThreshold(tyre) {
  	      return tyreUsesHoursCounter(tyre)
  	        ? tyreWarningThresholdHours(tyre)
  	        : tyreWarningThresholdKm(tyre);
  	    }

  	    function tyreWarningState(tyre) {
  	      var threshold = tyreWarningThreshold(tyre);
  	      var expectedMileage = numberOrNull(getFirst(tyre, ["Expected_Mileage", "ExpectedMileage"]));
  	      var remaining = tyreRemainingMileage(tyre);

  	      if (threshold === null || expectedMileage === null || expectedMileage <= 0 || remaining === null) {
  	        return {
  	          active: false,
  	          level: "",
  	          severity: "",
  	          threshold: threshold,
  	          remaining: remaining,
  	          unit: tyreCounterUnit(tyre)
  	        };
  	      }

  	      if (remaining <= 0) {
  	        return {
  	          active: true,
  	          level: "Critical",
  	          severity: "critical",
  	          threshold: threshold,
  	          remaining: remaining,
  	          unit: tyreCounterUnit(tyre)
  	        };
  	      }

  	      if (remaining <= threshold) {
  	        return {
  	          active: true,
  	          level: "High",
  	          severity: "high",
  	          threshold: threshold,
  	          remaining: remaining,
  	          unit: tyreCounterUnit(tyre)
  	        };
  	      }

  	      return {
  	        active: false,
  	        level: "",
  	        severity: "",
  	        threshold: threshold,
  	        remaining: remaining
  	      };
  	    }

  	    function applyCostToCurrentStage(tyre, cost) {
  	      var updated = clone(tyre);
  	      var history = normaliseHistory(updated);
  	      var stage = tyreStage(updated);
  	      var safeCost = numberOrNull(cost) || 0;

  	      if (!history[stage] || typeof history[stage] !== "object") {
  	        history[stage] = blankHistoryStage(true);
  	      }

  	      history[stage].Cost = safeCost;
  	      history.Totals.Cost_Total = (numberOrNull(history.Totals.Cost_Total) || 0) + safeCost;

  	      updated.History = history;

  	      return updated;
  	    }

  	    function tyreEvent(type, options) {
  	      options = options || {};

  	      return {
  	        Date: nowIso(),
  	        Type: type,
  	        Vehicle_ObjectId: options.Vehicle_ObjectId || "",
  	        Vehicle_ID: options.Vehicle_ID || "",
  	        FromPosition: options.FromPosition || "",
  	        ToPosition: options.ToPosition || "",
  	        Odometer: options.Odometer || "",
  	        Destination: options.Destination || "",
  	        WearRate: options.WearRate === null || options.WearRate === undefined ? "": options.WearRate,
  	        CapturedBy: "Company Tyre Manager",
  	        Notes: options.Notes || "",
  	        Cost: options.Cost || "",
  	        Retread_From_Stage: options.Retread_From_Stage || "",
  	        Retread_To_Stage: options.Retread_To_Stage || "",
  	        Retread_Cost: options.Retread_Cost || "",
  	        Scrap_Reason: options.Scrap_Reason || "",
  	        Bulk_Create_Count: options.Bulk_Create_Count || "",
  	        Bulk_Create_Batch: options.Bulk_Create_Batch || "",
  	        Warning_Threshold_KM: options.Warning_Threshold_KM === null || options.Warning_Threshold_KM === undefined ? "": options.Warning_Threshold_KM,
  	        Warning_Threshold_Hours: options.Warning_Threshold_Hours === null || options.Warning_Threshold_Hours === undefined ? "": options.Warning_Threshold_Hours,
  	        Expected_Remaining_Mileage: options.Expected_Remaining_Mileage === null || options.Expected_Remaining_Mileage === undefined ? "": options.Expected_Remaining_Mileage,
  	        Expected_Mileage: options.Expected_Mileage === null || options.Expected_Mileage === undefined ? "": options.Expected_Mileage
  	      };
  	    }

  	    function appendHistoryEvent(tyre, event) {
  	      var updated = clone(tyre);
  	      var history = normaliseHistory(updated);
  	      var stage = tyreStage(updated);

  	      if (!history[stage] || typeof history[stage] !== "object") {
  	        history[stage] = blankHistoryStage(true);
  	      }

  	      if (!Array.isArray(history[stage].Events)) {
  	        history[stage].Events = [];
  	      }

  	      history[stage].Events.push(event);

  	      history.Current.Stage = stage;
  	      history.Current.Last_Event_Type = event.Type || "";
  	      history.Current.Last_Event_Date = event.Date || "";
  	      history.Current.Vehicle_ObjectId = updated.Vehicle_ObjectId || "";
  	      history.Current.Vehicle_ID = updated.Vehicle_ID || "";
  	      history.Current.Position = updated.Current_Position || "";
  	      history.Current.Axle_Type = updated.Current_Axle_Type || "";
  	      history.Current.Wear_Rate = updated.Current_Wear_Rate || "";

  	      updated.History = history;

  	      return updated;
  	    }

  	    function currentStageName(tyre) {
  	      return tyreStage(tyre) || "New";
  	    }



  	    function formatHistoryDate(value) {
  	      var raw = clean(value);
  	      var date;

  	      if (!raw) {
  	        return "—";
  	      }

  	      date = new Date(raw);

  	      if (isNaN(date.getTime())) {
  	        return raw;
  	      }

  	      return date.toLocaleString();
  	    }

  	    function historyDisplayValue(value) {
  	      if (value === null || value === undefined || value === "") {
  	        return "—";
  	      }

  	      if (typeof value === "object") {
  	        try {
  	          return JSON.stringify(value);
  	        } catch (error) {
  	          return String(value);
  	        }
  	      }

  	      return clean(value);
  	    }

  	    function collectTyreHistoryRows(tyre) {
  	      var history = normaliseHistory(tyre);
  	      var rows = [];

  	      STAGES.forEach(function (stage) {
  	        var stageData = history[stage] || {};
  	        var events = Array.isArray(stageData.Events) ? stageData.Events: [];

  	        events.forEach(function (event, index) {
  	          event = event || {};

  	          rows.push({
  	            Key: "h" + rows.length,
  	            Stage: stage,
  	            StageIndex: index,
  	            Date: clean(event.Date),
  	            Type: clean(event.Type) || "Event",
  	            Odometer: historyDisplayValue(event.Odometer),
  	            FromPosition: historyDisplayValue(event.FromPosition),
  	            ToPosition: historyDisplayValue(event.ToPosition),
  	            Destination: historyDisplayValue(event.Destination),
  	            Cost: historyDisplayValue(event.Cost),
  	            Notes: historyDisplayValue(event.Notes),
  	            Event: event
  	          });
  	        });
  	      });

  	      rows.sort(function (a, b) {
  	        var ad = Date.parse(a.Date);
  	        var bd = Date.parse(b.Date);

  	        if (!isNaN(ad) && !isNaN(bd)) {
  	          return bd - ad;
  	        }

  	        if (!isNaN(ad)) {
  	          return -1;
  	        }

  	        if (!isNaN(bd)) {
  	          return 1;
  	        }

  	        return a.Stage.localeCompare(b.Stage) || a.StageIndex - b.StageIndex;
  	      });

  	      rows.forEach(function (row, index) {
  	        row.Key = "h" + index;
  	      });

  	      return rows;
  	    }

  	    function historyEventDetailHtml(row, tyre) {
  	      var event = row && row.Event ? row.Event: {};
  	      var keys = Object.keys(event).filter(function (key) {
  	        return event[key] !== null && event[key] !== undefined && event[key] !== "";
  	      }).sort();

  	      if (!keys.length) {
  	        return "<div class=\"ctm-muted\">No extra event detail is stored for this history row.</div>";
  	      }

  	      return ""
  	      + "<div class=\"ctm-history-detail-grid\">"
  	      + keys.map(function (key) {
  	        var value = event[key];
  	        var display = key === "Type"
  	          ? tyreHistoryActivityLabel(value, tyre)
  	          : /odometer|mileage/i.test(key)
  	            ? formatTyreHistoryCounter(value, tyre)
  	            : historyDisplayValue(value);
  	        return ""
  	        + "<div>"
  	        + "  <div class=\"ctm-history-detail-label\">" + escapeHtml(tyreHistoryFieldLabel(key, tyre)) + "</div>"
  	        + "  <div class=\"ctm-history-detail-value\">" + escapeHtml(display) + "</div>"
  	        + "</div>";
  	      }).join("")
  	      + "</div>";
  	    }

  	    function tyreHistoryTableHtml(tyre) {
  	      var rows = collectTyreHistoryRows(tyre);
  	      var counterHeading = tyreCounterHistoryHeading(tyre);

  	      return ""
  	      + "<section class=\"ctm-detail-section ctm-history-section\">"
  	      + "  <header class=\"ctm-detail-section-head\">"
  	      + "    <div><strong>Tyre History</strong><span>Permanent lifecycle, movement and cost events.</span></div>"
  	      + "    <b>" + escapeHtml(rows.length) + " event" + (rows.length === 1 ? "" : "s") + "</b>"
  	      + "  </header>"
  	      + (rows.length ? ""
  	        + "  <div class=\"ctm-history-help\">Select a row to open every stored field for that event.</div>"
  	        + "  <div class=\"ctm-history-scroll\">"
  	        + "    <table class=\"ctm-history-table\">"
  	        + "      <thead>"
  	        + "        <tr>"
  	        + "          <th>Date</th>"
  	        + "          <th>Activity</th>"
  	        + "          <th>" + escapeHtml(counterHeading) + "</th>"
  	        + "          <th>Movement / Destination</th>"
  	        + "          <th>Cost</th>"
  	        + "          <th>Notes</th>"
  	        + "        </tr>"
  	        + "      </thead>"
  	        + "      <tbody>"
  	        + rows.map(function (row) {
  	          var movement = [
  	            row.FromPosition !== "—" ? row.FromPosition : "",
  	            row.ToPosition !== "—" ? row.ToPosition : ""
  	          ].filter(Boolean).join(" → ");
  	          if (row.Destination !== "—") {
  	            movement += (movement ? " · " : "") + row.Destination;
  	          }
  	          return ""
  	          + "        <tr class=\"ctm-history-row\" data-history-key=\"" + escapeHtml(row.Key) + "\">"
  	          + "          <td><strong>" + escapeHtml(formatHistoryDate(row.Date)) + "</strong></td>"
  	          + "          <td><strong>" + escapeHtml(tyreHistoryActivityLabel(row.Type, tyre)) + "</strong><small>" + escapeHtml(row.Stage) + "</small></td>"
  	          + "          <td>" + escapeHtml(formatTyreHistoryCounter(row.Odometer, tyre)) + "</td>"
  	          + "          <td>" + escapeHtml(movement || "—") + "</td>"
  	          + "          <td>" + escapeHtml(row.Cost) + "</td>"
  	          + "          <td>" + escapeHtml(row.Notes) + "</td>"
  	          + "        </tr>"
  	          + "        <tr id=\"ctmHistoryDetail_" + escapeHtml(row.Key) + "\" class=\"ctm-history-detail-row\" style=\"display:none;\">"
  	          + "          <td colspan=\"6\">" + historyEventDetailHtml(row, tyre) + "</td>"
  	          + "        </tr>";
  	        }).join("")
  	        + "      </tbody>"
  	        + "    </table>"
  	        + "  </div>"
  	        : "<div class=\"ctm-empty\">No tyre history events are stored yet.</div>")
  	      + "</section>";
  	    }

  	    function printReportValue(value) {
  	      return historyDisplayValue(value);
  	    }

  	    function printTyreDetailRowsHtml(tyre) {
  	      var history = normaliseHistory(tyre);
  	      var counterName = tyreCounterName(tyre);
  	      var counterHeading = tyreCounterHistoryHeading(tyre);
  	      var rows = [
  	        ["Company", clean(tyre.__CompanyName) || "Unassigned"],
  	        ["Fleet Number", tyreNumber(tyre)],
  	        ["Serial Number", tyreSerial(tyre)],
  	        ["Make", tyreMake(tyre)],
  	        ["Model / Pattern", tyreModel(tyre)],
  	        ["Size", tyreSize(tyre)],
  	        ["Type", tyreType(tyre)],
  	        ["Status", tyreStatus(tyre)],
  	        ["Stage", tyreStage(tyre)],
  	        ["Life", tyreLifeText(tyre)],
  	        ["Current " + counterName, formatTyreCounter(tyre.Current_Mileage, tyre)],
  	        ["Expected " + counterName, formatTyreCounter(tyre.Expected_Mileage, tyre)],
  	        ["Remaining " + counterName, formatTyreCounter(tyreRemainingMileage(tyre), tyre)],
  	        [counterName + " Warning", mileageWarningText(tyre) || "—"],
  	        ["Warning Threshold (km)", formatMileage(tyreWarningThresholdKm(tyre))],
  	        ["Warning Threshold (hours)", formatHours(tyreWarningThresholdHours(tyre))],
  	        ["Location", locationText(tyre)],
  	        ["Position", locationSubText(tyre) || "—"],
  	        ["Vehicle ObjectId", clean(tyre.Vehicle_ObjectId) || "—"],
  	        ["Vehicle Type", clean(tyre.Vehicle_Type) || "—"],
  	        ["Axle Type", clean(tyre.Current_Axle_Type) || "—"],
  	        ["Wear Rate", clean(tyre.Current_Wear_Rate) || "—"],
  	        ["Fitted Date", clean(tyre.Fitted_Date) || "—"],
  	        ["Fitted " + counterHeading, formatTyreHistoryCounter(tyre.Fitted_Odometer, tyre)],
  	        ["Total " + counterName, formatTyreCounter(tyre.Total_Mileage, tyre)],
  	        ["Total Cost", printReportValue(tyre.Total_Cost)],
  	        ["Current CPK", printReportValue(tyre.Current_CPK)],
  	        ["Total CPK", printReportValue(tyre.Total_CPK)],
  	        ["Expected CPK", printReportValue(tyre.Expected_CPK)],
  	        ["ObjectId", tyreObjectId(tyre)],
  	        ["Company ObjectId", clean(tyre.__CompanyObjectId) || clean(tyre.Company_ID) || "—"],
  	        ["History Current Stage", history && history.Current ? printReportValue(history.Current.Stage): "—"],
  	        ["History Last Event", history && history.Current ? printReportValue(history.Current.Last_Event_Type): "—"],
  	        ["History Last Event Date", history && history.Current ? printReportValue(history.Current.Last_Event_Date): "—"]
  	      ];
  	      var html = "";
  	      var i;
  	      var left;
  	      var right;

  	      for (i = 0; i < rows.length; i += 2) {
  	        left = rows[i];
  	        right = rows[i + 1];

  	        html += ""
  	        + "<tr>"
  	        + "  <th>" + escapeHtml(left[0]) + "</th>"
  	        + "  <td>" + escapeHtml(printReportValue(left[1])) + "</td>"
  	        + (right ? "  <th>" + escapeHtml(right[0]) + "</th>"
  	          + "  <td>" + escapeHtml(printReportValue(right[1])) + "</td>": "<th></th><td></td>")
  	        + "</tr>";
  	      }

  	      return html;
  	    }

  	    function printTyreHistoryRowsHtml(tyre) {
  	      var rows = collectTyreHistoryRows(tyre);

  	      if (!rows.length) {
  	        return "<tr><td colspan=\"11\">No tyre history events are stored yet.</td></tr>";
  	      }

  	      return rows.map(function (row) {
  	        return ""
  	        + "<tr>"
  	        + "  <td>" + escapeHtml(formatHistoryDate(row.Date)) + "</td>"
  	        + "  <td>" + escapeHtml(row.Stage) + "</td>"
  	        + "  <td>" + escapeHtml(tyreHistoryActivityLabel(row.Type, tyre)) + "</td>"
  	        + "  <td>" + escapeHtml(formatTyreHistoryCounter(row.Odometer, tyre)) + "</td>"
  	        + "  <td>" + escapeHtml(row.FromPosition) + "</td>"
  	        + "  <td>" + escapeHtml(row.ToPosition) + "</td>"
  	        + "  <td>" + escapeHtml(row.Destination) + "</td>"
  	        + "  <td>" + escapeHtml(row.Cost) + "</td>"
  	        + "  <td>" + escapeHtml(row.Notes) + "</td>"
  	        + "  <td>" + escapeHtml(historyDisplayValue(row.Event && row.Event.WearRate)) + "</td>"
  	        + "  <td>" + escapeHtml(historyDisplayValue(row.Event && row.Event.CapturedBy)) + "</td>"
  	        + "</tr>";
  	      }).join("");
  	    }

  	    function printTyreReportHtml(tyre) {
  	      var title = "Tyre Report - " + (tyreNumber(tyre) || tyreObjectId(tyre) || "Tyre");
  	      var counterName = tyreCounterName(tyre);
  	      var counterHeading = tyreCounterHistoryHeading(tyre);

  	      return ""
  	      + "<!doctype html>"
  	      + "<html>"
  	      + "<head>"
  	      + "  <meta charset=\"utf-8\">"
  	      + "  <title>" + escapeHtml(title) + "</title>"
  	      + "  <style>"
  	      + "    *{box-sizing:border-box;}"
  	      + "    body{font-family:Arial,sans-serif;color:#111;margin:24px;font-size:12px;}"
  	      + "    .ctm-report-head{display:flex;justify-content:space-between;align-items:flex-start;gap:14px;border-bottom:2px solid #cc6b33;padding-bottom:8px;margin-bottom:12px;}"
  	      + "    .ctm-report-logo-box{min-width:110px;text-align:right;}"
  	      + "    .ctm-report-logo{height:42px;width:auto;max-width:180px;object-fit:contain;}"
  	      + "    .ctm-report-logo-svg{height:42px;width:auto;max-width:180px;display:block;}"
  	      + "    .ctm-report-logo-inline{display:inline-flex;align-items:center;justify-content:flex-end;}"
  	      + "    h1{font-size:22px;margin:0 0 4px;color:#111;}"
  	      + "    h2{font-size:15px;margin:22px 0 8px;border-bottom:2px solid #222;padding-bottom:5px;}"
  	      + "    .sub{color:#555;margin-bottom:16px;}"
  	      + "    .summary{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:8px;margin:12px 0 18px;}"
  	      + "    .box{border:1px solid #bbb;padding:8px;border-radius:4px;}"
  	      + "    .box b{display:block;font-size:10px;text-transform:uppercase;color:#555;margin-bottom:3px;}"
  	      + "    table{width:100%;border-collapse:collapse;margin-bottom:12px;}"
  	      + "    th,td{border:1px solid #bbb;padding:5px 6px;vertical-align:top;text-align:left;}"
  	      + "    th{background:#eee;font-weight:700;}"
  	      + "    .details th{width:18%;}"
  	      + "    .details td{width:32%;}"
  	      + "    pre{white-space:pre-wrap;word-break:break-word;margin:0;font-family:Consolas,monospace;font-size:10px;}"
  	      + "    .print-meta{font-size:10px;color:#666;margin-top:18px;}"
  	      + "    @media print{body{margin:10mm;}button{display:none!important;}h2{page-break-after:avoid;}tr{page-break-inside:avoid;}}"
  	      + "  </style>"
  	      + "</head>"
  	      + "<body>"
  	      + "  <button onclick=\"window.print()\" style=\"float:right;padding:8px 12px;\">Print</button>"
  	      + "  <div class=\"ctm-report-head\">"
  	      + "    <div>"
  	      + "      <h1>" + escapeHtml(title) + "</h1>"
  	      + "      <div class=\"sub\">" + escapeHtml([tyreMake(tyre), tyreModel(tyre), tyreSize(tyre)].filter(Boolean).join(" - ") || "No make/model/size") + "</div>"
  	      + "    </div>"
  	      + "    <div class=\"ctm-report-logo-box\">" + reportLogoHtml() + "</div>"
  	      + "  </div>"
  	      + "  <div class=\"summary\">"
  	      + "    <div class=\"box\"><b>Status</b>" + escapeHtml(tyreStatus(tyre)) + "</div>"
  	      + "    <div class=\"box\"><b>Stage</b>" + escapeHtml(tyreStage(tyre)) + "</div>"
  	      + "    <div class=\"box\"><b>Remaining " + escapeHtml(counterName) + "</b>" + escapeHtml(formatTyreCounter(tyreRemainingMileage(tyre), tyre)) + "</div>"
  	      + "    <div class=\"box\"><b>Location</b>" + escapeHtml(locationText(tyre)) + "</div>"
  	      + "    <div class=\"box\"><b>Position</b>" + escapeHtml(locationSubText(tyre) || "—") + "</div>"
  	      + "    <div class=\"box\"><b>Life</b>" + escapeHtml(tyreLifeText(tyre)) + "</div>"
  	      + "  </div>"
  	      + "  <h2>Tyre Details</h2>"
  	      + "  <table class=\"details\"><tbody>"
  	      + printTyreDetailRowsHtml(tyre)
  	      + "  </tbody></table>"
  	      + "  <h2>Full Tyre History</h2>"
  	      + "  <table>"
  	      + "    <thead>"
  	      + "      <tr>"
  	      + "        <th>Date</th>"
  	      + "        <th>Stage</th>"
  	      + "        <th>Event</th>"
  	      + "        <th>" + escapeHtml(counterHeading) + "</th>"
  	      + "        <th>From</th>"
  	      + "        <th>To</th>"
  	      + "        <th>Destination</th>"
  	      + "        <th>Cost</th>"
  	      + "        <th>Notes</th>"
  	      + "        <th>Wear Rate</th>"
  	      + "        <th>Captured By</th>"
  	      + "      </tr>"
  	      + "    </thead>"
  	      + "    <tbody>"
  	      + printTyreHistoryRowsHtml(tyre)
  	      + "    </tbody>"
  	      + "  </table>"
  	      + "  <div class=\"print-meta\">Printed from Company Tyre Manager on " + escapeHtml(new Date().toLocaleString()) + "</div>"
  	      + "</body>"
  	      + "</html>";
  	    }

  	    function printSelectedTyreReport() {
  	      var tyre = findTyreById(state.modal && state.modal.tyreId);
  	      var printWindow;
  	      var html;

  	      if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	        alertSafe("You do not have access to this tyre.");
  	        return;
  	      }

  	      if (!WindowSafe || typeof WindowSafe.open !== "function") {
  	        alertSafe("Printing is unavailable in this browser.");
  	        return;
  	      }

  	      html = printTyreReportHtml(tyre);
  	      printWindow = WindowSafe.open("", "_blank");

  	      if (!printWindow) {
  	        alertSafe("The print window was blocked. Allow popups for this app and try again.");
  	        return;
  	      }

  	      printWindow.document.open();
  	      printWindow.document.write(html);
  	      printWindow.document.close();

  	      try {
  	        printWindow.focus();
  	        setTimeout(function () {
  	          printWindow.print();
  	        }, 250);
  	      } catch (error) {

  	      }
  	    }



  	    function warehouseWarningStats() {
  	      var stats = {
  	        total: 0,
  	        configured: 0,
  	        unconfigured: 0,
  	        warningTotal: 0,
  	        critical: 0,
  	        high: 0
  	      };

  	      companyScopedTyres().forEach(function (tyre) {
  	        var stateForTyre = tyreWarningState(tyre);

  	        stats.total += 1;

  	        if (stateForTyre.threshold === null) {
  	          stats.unconfigured += 1;
  	          return;
  	        }

  	        stats.configured += 1;

  	        if (!stateForTyre.active) {
  	          return;
  	        }

  	        stats.warningTotal += 1;

  	        if (stateForTyre.level === "Critical") {
  	          stats.critical += 1;
  	        } else if (stateForTyre.level === "High") {
  	          stats.high += 1;
  	        }
  	      });

  	      return stats;
  	    }

  	    function warehouseOrderRows() {
  	      var map = {};
  	      var rows = [];

  	      companyScopedTyres().forEach(function (tyre) {
  	        var warningState = tyreWarningState(tyre);
  	        var make;
  	        var model;
  	        var type;
  	        var size;
  	        var key;

  	        if (!warningState.active) {
  	          return;
  	        }

  	        make = tyreMake(tyre) || "Unknown Make";
  	        model = tyreModel(tyre) || "Unknown Model";
  	        type = tyreType(tyre) || "Unknown Type";
  	        size = tyreSize(tyre) || "Unknown Size";

  	        key = [
  	          make.toLowerCase(),
  	          model.toLowerCase(),
  	          type.toLowerCase(),
  	          size.toLowerCase()
  	        ].join("|");

  	        if (!map[key]) {
  	          map[key] = {
  	            Make: make,
  	            Model: model,
  	            Type: type,
  	            Size: size,
  	            QtyHigh: 0,
  	            QtyCritical: 0,
  	            Tyres: []
  	          };
  	        }

  	        if (warningState.level === "Critical") {
  	          map[key].QtyCritical += 1;
  	        } else {
  	          map[key].QtyHigh += 1;
  	        }

  	        map[key].Tyres.push(tyreNumber(tyre) || tyreObjectId(tyre));
  	      });

  	      rows = Object.keys(map).map(function (key) {
  	        map[key].TotalQty = map[key].QtyHigh + map[key].QtyCritical;
  	        return map[key];
  	      });

  	      rows.sort(function (a, b) {
  	        return b.QtyCritical - a.QtyCritical ||
  	        b.TotalQty - a.TotalQty ||
  	        a.Type.localeCompare(b.Type) ||
  	        a.Make.localeCompare(b.Make) ||
  	        a.Model.localeCompare(b.Model) ||
  	        a.Size.localeCompare(b.Size);
  	      });

  	      return rows;
  	    }

  	    function warehouseOrderRowsHtml() {
  	      var rows = warehouseOrderRows();

  	      if (!rows.length) {
  	        return "<tr><td colspan=\"7\">No tyres have reached their configured warning threshold.</td></tr>";
  	      }

  	      return rows.map(function (row) {
  	        return ""
  	        + "<tr>"
  	        + "  <td>" + escapeHtml(row.Make) + "</td>"
  	        + "  <td>" + escapeHtml(row.Model) + "</td>"
  	        + "  <td>" + escapeHtml(row.Type) + "</td>"
  	        + "  <td>" + escapeHtml(row.Size) + "</td>"
  	        + "  <td>" + escapeHtml(row.QtyHigh) + "</td>"
  	        + "  <td>" + escapeHtml(row.QtyCritical) + "</td>"
  	        + "  <td>" + escapeHtml(row.TotalQty) + "</td>"
  	        + "</tr>";
  	      }).join("");
  	    }

  	    function warehouseWarningTyreRowsHtml() {
  	      var tyres = companyScopedTyres().filter(function (tyre) {
  	        return tyreWarningState(tyre).active;
  	      }).sort(function (a, b) {
  	        var aState = tyreWarningState(a);
  	        var bState = tyreWarningState(b);

  	        if (aState.level !== bState.level) {
  	          return aState.level === "Critical" ? -1: 1;
  	        }

  	        return compareSortValues(a, b, "remainingMileage", "asc");
  	      });

  	      if (!tyres.length) {
  	        return "<tr><td colspan=\"9\">No tyres have reached their configured warning threshold.</td></tr>";
  	      }

  	      return tyres.map(function (tyre) {
  	        var warningState = tyreWarningState(tyre);

  	        return ""
  	        + "<tr>"
  	        + "  <td>" + escapeHtml(tyreNumber(tyre) || tyreObjectId(tyre)) + "</td>"
  	        + "  <td>" + escapeHtml(warningState.level) + "</td>"
  	        + "  <td>" + escapeHtml(formatTyreCounter(warningState.threshold, tyre)) + "</td>"
  	        + "  <td>" + escapeHtml(formatTyreCounter(warningState.remaining, tyre)) + "</td>"
  	        + "  <td>" + escapeHtml(tyreMake(tyre) || "—") + "</td>"
  	        + "  <td>" + escapeHtml(tyreModel(tyre) || "—") + "</td>"
  	        + "  <td>" + escapeHtml(tyreType(tyre) || "—") + "</td>"
  	        + "  <td>" + escapeHtml(tyreSize(tyre) || "—") + "</td>"
  	        + "  <td>" + escapeHtml(locationText(tyre) + (locationSubText(tyre) ? " / " + locationSubText(tyre): "")) + "</td>"
  	        + "</tr>";
  	      }).join("");
  	    }

  	    function warehouseWarningReportHtml() {
  	      var company = selectedCompany();
  	      var stats = warehouseWarningStats();
  	      var title = "Warehouse Tyre Warning Report";

  	      return ""
  	      + "<!doctype html>"
  	      + "<html>"
  	      + "<head>"
  	      + "  <meta charset=\"utf-8\">"
  	      + "  <title>" + escapeHtml(title) + "</title>"
  	      + "  <style>"
  	      + "    *{box-sizing:border-box;}"
  	      + "    body{font-family:Arial,sans-serif;color:#111;margin:22px;font-size:12px;}"
  	      + "    .ctm-report-head{display:flex;justify-content:space-between;align-items:flex-start;gap:14px;border-bottom:2px solid #cc6b33;padding-bottom:8px;margin-bottom:12px;}"
  	      + "    .ctm-report-logo-box{min-width:110px;text-align:right;}"
  	      + "    .ctm-report-logo{height:42px;width:auto;max-width:180px;object-fit:contain;}"
  	      + "    .ctm-report-logo-svg{height:42px;width:auto;max-width:180px;display:block;}"
  	      + "    .ctm-report-logo-inline{display:inline-flex;align-items:center;justify-content:flex-end;}"
  	      + "    h1{font-size:22px;margin:0 0 4px;color:#111;}"
  	      + "    h2{font-size:15px;margin:18px 0 8px;border-bottom:2px solid #222;padding-bottom:5px;}"
  	      + "    .sub{color:#555;margin-bottom:14px;}"
  	      + "    .summary{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin:12px 0 16px;}"
  	      + "    .box{border:1px solid #bbb;padding:8px;border-radius:4px;}"
  	      + "    .box b{display:block;font-size:10px;text-transform:uppercase;color:#555;margin-bottom:3px;}"
  	      + "    table{width:100%;border-collapse:collapse;margin-bottom:12px;}"
  	      + "    th,td{border:1px solid #bbb;padding:5px 6px;vertical-align:top;text-align:left;}"
  	      + "    th{background:#eee;font-weight:700;}"
  	      + "    .print-meta{font-size:10px;color:#666;margin-top:16px;}"
  	      + "    @media print{body{margin:10mm;}button{display:none!important;}h2{page-break-after:avoid;}tr{page-break-inside:avoid;}}"
  	      + "  </style>"
  	      + "</head>"
  	      + "<body>"
  	      + "  <button onclick=\"window.print()\" style=\"float:right;padding:8px 12px;\">Print</button>"
  	      + "  <div class=\"ctm-report-head\">"
  	      + "    <div>"
  	      + "      <h1>" + escapeHtml(title) + "</h1>"
  	      + "      <div class=\"sub\">Company: " + escapeHtml(company ? company.name: "Selected Company") + "</div>"
  	      + "    </div>"
  	      + "    <div class=\"ctm-report-logo-box\">" + reportLogoHtml() + "</div>"
  	      + "  </div>"
  	      + "  <div class=\"summary\">"
  	      + "    <div class=\"box\"><b>Total Tyres</b>" + escapeHtml(stats.total) + "</div>"
  	      + "    <div class=\"box\"><b>Thresholds Set</b>" + escapeHtml(stats.configured) + "</div>"
  	      + "    <div class=\"box\"><b>No Threshold</b>" + escapeHtml(stats.unconfigured) + "</div>"
  	      + "    <div class=\"box\"><b>Total Warnings</b>" + escapeHtml(stats.warningTotal) + "</div>"
  	      + "    <div class=\"box\"><b>Critical</b>" + escapeHtml(stats.critical) + "</div>"
  	      + "    <div class=\"box\"><b>High</b>" + escapeHtml(stats.high) + "</div>"
  	      + "    <div class=\"box\"><b>Rule</b>Remaining ≤ Threshold</div>"
  	      + "    <div class=\"box\"><b>Report Date</b>" + escapeHtml(new Date().toLocaleString()) + "</div>"
  	      + "  </div>"
  	      + "  <h2>Replacement Summary: High and Critical Tyres</h2>"
  	      + "  <table>"
  	      + "    <thead>"
  	      + "      <tr>"
  	      + "        <th>Make</th>"
  	      + "        <th>Model / Pattern</th>"
  	      + "        <th>Type</th>"
  	      + "        <th>Size</th>"
  	      + "        <th>High Qty</th>"
  	      + "        <th>Critical Qty</th>"
  	      + "        <th>Total Qty</th>"
  	      + "      </tr>"
  	      + "    </thead>"
  	      + "    <tbody>"
  	      + warehouseOrderRowsHtml()
  	      + "    </tbody>"
  	      + "  </table>"
  	      + "  <h2>Tyres At Their Configured Warning Threshold</h2>"
  	      + "  <table>"
  	      + "    <thead>"
  	      + "      <tr>"
  	      + "        <th>Tyre</th>"
  	      + "        <th>Severity</th>"
  	      + "        <th>Threshold</th>"
  	      + "        <th>Remaining</th>"
  	      + "        <th>Make</th>"
  	      + "        <th>Model / Pattern</th>"
  	      + "        <th>Type</th>"
  	      + "        <th>Size</th>"
  	      + "        <th>Location</th>"
  	      + "      </tr>"
  	      + "    </thead>"
  	      + "    <tbody>"
  	      + warehouseWarningTyreRowsHtml()
  	      + "    </tbody>"
  	      + "  </table>"
  	      + "  <div class=\"print-meta\">Printed from Company Tyre Manager on " + escapeHtml(new Date().toLocaleString()) + "</div>"
  	      + "</body>"
  	      + "</html>";
  	    }

  	    function printWarehouseWarningReport() {
  	      var printWindow;
  	      var html;

  	      if (!companies.length || !selectedCompany()) {
  	        alertSafe("Select a company before printing the warehouse report.");
  	        return;
  	      }

  	      if (!WindowSafe || typeof WindowSafe.open !== "function") {
  	        alertSafe("Printing is unavailable in this browser.");
  	        return;
  	      }

  	      html = warehouseWarningReportHtml();
  	      printWindow = WindowSafe.open("", "_blank");

  	      if (!printWindow) {
  	        alertSafe("The print window was blocked. Allow popups for this app and try again.");
  	        return;
  	      }

  	      printWindow.document.open();
  	      printWindow.document.write(html);
  	      printWindow.document.close();

  	      try {
  	        printWindow.focus();
  	        setTimeout(function () {
  	          printWindow.print();
  	        }, 250);
  	      } catch (error) {

  	      }
  	    }

  	    function transactionPanelHtml() {
  	      if (!AllowEditing) return "";
  	      return ""
  	      + "<section class=\"ctm-detail-section ctm-transaction-shell\">"
  	      + "  <header class=\"ctm-detail-section-head\">"
  	      + "    <div><strong>Tyre Work & Cost</strong><span>Repairs, inspections, valves, patches, plugs and other tyre costs.</span></div>"
  	      + buttonHtml("ctmNewTransactionBtn", "+ Record Work / Cost", "ctm-btn-orange")
  	      + "  </header>"
  	      + "  <div id=\"ctmTransactionPanel\" class=\"ctm-transaction-panel\" style=\"display:none;\">"
  	      + "    <div class=\"ctm-grid2\">"
  	      + selectHtml("ctmTransactionType", "Work performed", ["", "Vulcanised", "Patched", "Plugged", "Valve Replaced", "Bead Repair", "Inspection", "Other"], "")
  	      + fieldHtml("ctmTransactionCost", "Transaction cost", "", "Required", "number")
  	      + "    </div>"
  	      + "    <div class=\"ctm-transaction-actions\">"
  	      + buttonHtml("ctmSaveTransactionBtn", "Save Tyre Transaction", "ctm-btn-main", "style=\"display:none;\"")
  	      + "    </div>"
  	      + "  </div>"
  	      + "</section>";
  	    }

  	    function updateTransactionSaveVisibility() {
  	      var typeEl = DocumentSafe.getElementById("ctmTransactionType");
  	      var costEl = DocumentSafe.getElementById("ctmTransactionCost");
  	      var saveBtn = DocumentSafe.getElementById("ctmSaveTransactionBtn");
  	      var type = typeEl ? clean(typeEl.value): "";
  	      var cost = costEl ? numberOrNull(costEl.value): null;

  	      if (!saveBtn) {
  	        return;
  	      }

  	      saveBtn.style.display = type && cost !== null && cost > 0 ? "inline-flex": "none";
  	    }

  	    function saveTransactionFromModal() {
  	      if (!requireEditing()) return;
  	      var tyre = findTyreById(state.modal && state.modal.tyreId);
  	      var updated;
  	      var transactionType = readValue("ctmTransactionType");
  	      var transactionCost = readValue("ctmTransactionCost");
  	      var notes = readValue("ctmEditNotes");
  	      var company;

  	      if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	        alertSafe("You do not have access to this tyre.");
  	        return;
  	      }

  	      company = {
  	        id: clean(tyre.__CompanyObjectId),
  	        name: clean(tyre.__CompanyName)
  	      };

  	      try {
  	        updated = applyTyreTransaction(tyre, transactionType, transactionCost, notes);
  	      } catch (error) {
  	        alertSafe(error && error.message ? error.message: "Could not save tyre transaction.");
  	        return;
  	      }

  	      state.busy = true;
  	      setMessage("Saving transaction...", false);
  	      render();

  	      saveTyre(updated, company)
  	      .then(function (savedTyre) {
  	        return emitFinancialEvent({
  	          Kind: "TyreTransaction", Company: company, Tyre: savedTyre, OriginalTyre: tyre,
  	          TransactionType: transactionType, Cost: numberOrNull(transactionCost) || 0, Notes: notes || "",
  	          SourceKey: "Tyres:" + clean(savedTyre && savedTyre.objectId) + ":" + clean(transactionType) + ":" + nowIso()
  	        }).then(function () {
  	          return savedTyre;
  	        });
  	      })
  	      .then(function () {
  	        state.busy = false;
  	        setMessage("Tyre work record saved.", false);
  	        render();
  	      })
  	      .catch(failSave);
  	    }





  	    function applyExpectedMileageFromRemaining(tyre, remainingCounter, warningThresholdKm, warningThresholdHours, notes) {
  	      var updated = clone(tyre);
  	      var history = normaliseHistory(updated);
  	      var stage = currentStageName(updated);
  	      var currentMileage = numberOrNull(updated.Current_Mileage);
  	      var remaining = numberOrNull(remainingCounter);
  	      var thresholdKm = numberOrNull(warningThresholdKm);
  	      var thresholdHours = numberOrNull(warningThresholdHours);
  	      var expectedMileage;
  	      var unit = tyreCounterUnit(updated);

  	      if (currentMileage === null || currentMileage < 0) {
  	        throw new Error("Set the current tyre reading before calculating its expected life.");
  	      }

  	      if (remaining === null || remaining < 0) {
  	        throw new Error("Expected remaining tyre life must be a valid number.");
  	      }

  	      /*
  	       * Warning thresholds are optional lifecycle controls.
  	       * Blank, zero or negative values disable that warning dimension and
  	       * must never prevent the tyre life update from being saved.
  	       */
  	      thresholdKm =
  	        thresholdKm !== null && thresholdKm > 0
  	          ? thresholdKm
  	          : null;

  	      thresholdHours =
  	        thresholdHours !== null && thresholdHours > 0
  	          ? thresholdHours
  	          : null;

  	      expectedMileage = currentMileage + remaining;

  	      updated.Remaining_Mileage = remaining;
  	      updated.Expected_Mileage = expectedMileage;

  	      if (!history[stage] || typeof history[stage] !== "object") {
  	        history[stage] = blankHistoryStage(true);
  	      }

  	      history[stage].Mileage_Expected = expectedMileage;

  	      if (!Array.isArray(history[stage].Events)) {
  	        history[stage].Events = [];
  	      }

  	      history[stage].Events.push(tyreEvent("Life & Warning Set", {
  	        Notes: notes || ("Expected remaining tyre life set to " + remaining + " " + unit + "."),
  	        Odometer: currentMileage,
  	        Destination: "Expected Reading: " + expectedMileage + " " + unit,
  	        Warning_Threshold_KM: thresholdKm,
  	        Warning_Threshold_Hours: thresholdHours,
  	        Expected_Remaining_Mileage: remaining,
  	        Expected_Mileage: expectedMileage
  	      }));

  	      history.Current.Stage = stage;
  	      history.Current.Warning_Threshold_KM = thresholdKm;
  	      history.Current.Warning_Threshold_Hours = thresholdHours;
  	      history.Current.Last_Event_Type = "Life & Warning Set";
  	      history.Current.Last_Event_Date = nowIso();

  	      updated.History = history;

  	      return updated;
  	    }

  	    function applyTyreTransaction(tyre, transactionType, cost, notes) {
  	      var updated = clone(tyre);
  	      var history = normaliseHistory(updated);
  	      var stage = currentStageName(updated);
  	      var safeCost = numberOrNull(cost);

  	      transactionType = clean(transactionType);

  	      if (!transactionType) {
  	        throw new Error("Select a transaction type.");
  	      }

  	      if (safeCost === null || safeCost < 0) {
  	        throw new Error("Transaction cost is required.");
  	      }

  	      if (!history[stage] || typeof history[stage] !== "object") {
  	        history[stage] = blankHistoryStage(true);
  	      }

  	      history[stage].Cost = (numberOrNull(history[stage].Cost) || 0) + safeCost;
  	      history.Totals.Cost_Total = (numberOrNull(history.Totals.Cost_Total) || 0) + safeCost;

  	      if (!Array.isArray(history[stage].Events)) {
  	        history[stage].Events = [];
  	      }

  	      history[stage].Events.push(tyreEvent("Tyre Transaction", {
  	        Notes: notes || transactionType,
  	        Cost: safeCost,
  	        Destination: transactionType
  	      }));

  	      history.Current.Stage = stage;
  	      history.Current.Last_Event_Type = "Tyre Transaction";
  	      history.Current.Last_Event_Date = nowIso();

  	      updated.History = history;

  	      return updated;
  	    }

  	    function advanceRetreadStage(tyre, fromStage, toStage, event, cost) {
  	      var updated = clone(tyre);
  	      var history = normaliseHistory(updated);
  	      var safeCost = numberOrNull(cost) || 0;

  	      if (!history[fromStage] || typeof history[fromStage] !== "object") {
  	        history[fromStage] = blankHistoryStage(false);
  	      }

  	      history[fromStage].Active = false;
  	      history[fromStage].Status = "Completed";
  	      history[fromStage].Ended = nowIso();

  	      if (!history[toStage] || typeof history[toStage] !== "object") {
  	        history[toStage] = blankHistoryStage(true);
  	      }

  	      history[toStage].Active = true;
  	      history[toStage].Status = "Active";
  	      history[toStage].Cost = safeCost;

  	      if (!history[toStage].Started) {
  	        history[toStage].Started = nowIso();
  	      }

  	      if (!Array.isArray(history[toStage].Events)) {
  	        history[toStage].Events = [];
  	      }

  	      history[toStage].Events.push(event);
  	      history.Totals.Cost_Total = (numberOrNull(history.Totals.Cost_Total) || 0) + safeCost;

  	      history.Current.Stage = toStage;
  	      history.Current.Last_Event_Type = event.Type || "";
  	      history.Current.Last_Event_Date = event.Date || "";

  	      updated.Current_Stage = toStage;
  	      updated.History = history;

  	      return updated;
  	    }

  	    var TYRE_EXPRESSION_FIELDS = [
  	      "Warehouse",
  	      "Current_CPK",
  	      "Total_CPK",
  	      "Current_Life",
  	      "Total_Mileage",
  	      "Mileage_Warning",
  	      "Total_Cost",
  	      "Expected_CPK",
  	      "Remaining_Mileage"
  	    ];

  	    var TYRE_READ_ONLY_FIELDS = [
  	      "created",
  	      "updated",
  	      "ownerId",
  	      "___class",
  	      "__CompanyObjectId",
  	      "__CompanyName"
  	    ];

  	    function cleanTyreForSave(tyre) {
  	      var payload = clone(tyre);

  	      TYRE_EXPRESSION_FIELDS.concat(TYRE_READ_ONLY_FIELDS).forEach(function (field) {
  	        if (Object.prototype.hasOwnProperty.call(payload, field)) {
  	          delete payload[field];
  	        }
  	      });

  	      return payload;
  	    }

  	    function stampCompanyMeta(tyre,
  	      company) {
  	      var updated = clone(tyre);

  	      if (company && company.id) {
  	        updated.Company_ID = company.id;
  	        updated.__CompanyObjectId = company.id;
  	        updated.__CompanyName = company.name;
  	      }

  	      return updated;
  	    }

  	    function tyreStoredCompanyId(tyre) {
  	      var value;

  	      if (!tyre || typeof tyre !== "object") {
  	        return "";
  	      }

  	      value = getFirst(tyre, [
  	        "Company_ID",
  	        "CompanyObjectId",
  	        "Company_ObjectId",
  	        "CompanyId",
  	        "CompanyID"
  	      ]);

  	      if (value && typeof value === "object") {
  	        value = companyObjectId(value);
  	      }

  	      if (!value && tyre.Company && typeof tyre.Company === "object") {
  	        value = companyObjectId(tyre.Company);
  	      }

  	      return clean(value);
  	    }

  	    function companyItemById(id) {
  	      var wanted = clean(id);
  	      var i;

  	      if (!wanted) {
  	        return null;
  	      }

  	      for (i = 0; i < companies.length; i++) {
  	        if (companies[i] && clean(companies[i].id) === wanted) {
  	          return companies[i];
  	        }
  	      }

  	      return null;
  	    }

  	    function tyreWhereValue(value) {
  	      return String(value == null ? "": value).replace(/'/g, "''");
  	    }

  	    function addTyreToMap(map, tyre, company) {
  	      var id = tyreObjectId(tyre);
  	      var copy;

  	      if (!tyre || !company || !company.id) {
  	        return;
  	      }

  	      copy = stampCompanyMeta(tyre, company);

  	      if (id) {
  	        map[id] = copy;
  	        return;
  	      }

  	      map["unsaved-" + Object.keys(map).length] = copy;
  	    }

  	    function collectTyres() {
  	      var map = {};

  	      try {
  	        companies.forEach(function (companyItem) {
  	          var company = companyItem.row;

  	          arr(company && company.Tyres).forEach(function (tyre) {
  	            addTyreToMap(map, tyre, companyItem);
  	          });

  	          arr(company && company.Tractors).forEach(function (vehicle) {
  	            arr(vehicle && vehicle.Tyres).forEach(function (tyre) {
  	              addTyreToMap(map, tyre, companyItem);
  	            });
  	          });

  	          arr(company && company.Trailers).forEach(function (vehicle) {
  	            arr(vehicle && vehicle.Tyres).forEach(function (tyre) {
  	              addTyreToMap(map, tyre, companyItem);
  	            });
  	          });
  	        });
  	      } catch (error) {

  	      }

  	      return Object.keys(map).map(function (key) {
  	        return map[key];
  	      });
  	    }

  	    var state = {
  	      tyres: [],
  	      companyId: clean(rawArgs.CompanyObjectId || (InitialCompany ? companyObjectId(InitialCompany): "")) || defaultCompanyId(),
  	      search: "",
  	      statusFilter: "All",
  	      stageFilter: "All",
  	      typeFilter: "All",
  	      locationFilter: "All",
  	      sortKey: "remainingMileage",
  	      sortDir: "asc",
  	      modal: null,
  	      busy: false,
  	      message: "",
  	      messageError: false,
  	      bulkPrefix: "",
  	      bulkStart: null,
  	      bulkCount: 1,
  	      bulkSeed: null
  	    };

  	    state.tyres = collectTyres();

  	    function companyScopedTyres() {
  	      if (!state.companyId || !canAccessCompanyId(state.companyId)) {
  	        return [];
  	      }

  	      return state.tyres.filter(function (tyre) {
  	        return clean(tyre.__CompanyObjectId) === state.companyId;
  	      });
  	    }

  	    function highestFleetSequence(prefix) {
  	      var highest = 0;

  	      companyScopedTyres().forEach(function (tyre) {
  	        [
  	          clean(tyre.ID),
  	          clean(tyre.FID),
  	          clean(tyre.Tyre_Number),
  	          clean(tyre.TyreNumber)
  	        ].forEach(function (value) {
  	            var number = parseFleetSequence(value, prefix);

  	            if (number !== null && number > highest) {
  	              highest = number;
  	            }
  	          });
  	      });

  	      return highest;
  	    }

  	    function nextFleetSequence(prefix) {
  	      return highestFleetSequence(prefix) + 1;
  	    }

  	    function bulkPreviewIds(prefix, start, count) {
  	      var ids = [];
  	      var i;

  	      start = Math.max(1, Number(start) || 1);
  	      count = Math.max(1, Math.min(500,
  	        Number(count) || 1));

  	      for (i = 0; i < count; i++) {
  	        ids.push(formatFleetNumber(prefix, start + i));
  	      }

  	      return ids;
  	    }

  	    function upsertTyre(tyre, company) {
  	      var id = tyreObjectId(tyre);
  	      var i;
  	      var copy = stampCompanyMeta(tyre, company || selectedCompany());

  	      if (!id) {
  	        state.tyres.push(copy);
  	        return;
  	      }

  	      for (i = 0; i < state.tyres.length; i++) {
  	        if (tyreObjectId(state.tyres[i]) === id) {
  	          state.tyres[i] = copy;
  	          return;
  	        }
  	      }

  	      state.tyres.push(copy);
  	    }

  	    function resolveCompanyItem(company) {
  	      var id = clean(company && company.id);
  	      var i;

  	      if (company && company.row) return company;
  	      if (!id) return selectedCompany();

  	      for (i = 0; i < companies.length; i++) {
  	        if (companies[i] && companies[i].id === id) return companies[i];
  	      }

  	      return company || selectedCompany();
  	    }

  	    function syncSavedTyreToAppData(savedTyre, company) {
  	      var companyItem = resolveCompanyItem(company);
  	      var id = tyreObjectId(savedTyre);
  	      var companyRow;

  	      if (!companyItem || !companyItem.row || !id) return;
  	      companyRow = companyItem.row;

  	      function syncList(owner) {
  	        var list;
  	        var replaced = false;
  	        var i;
  	        if (!owner || typeof owner !== "object") return;
  	        list = arr(owner.Tyres).slice();
  	        for (i = 0; i < list.length; i++) {
  	          if (tyreObjectId(list[i]) === id) {
  	            list[i] = savedTyre;
  	            replaced = true;
  	            break;
  	          }
  	        }
  	        if (!replaced && owner === companyRow) list.push(savedTyre);
  	        owner.Tyres = list;
  	      }

  	      syncList(companyRow);
  	      arr(companyRow.Tractors).forEach(syncList);
  	      arr(companyRow.Trailers).forEach(syncList);
  	    }

  	    function attachTyreToCompany(savedTyre, company) {
  	      company = resolveCompanyItem(company);

  	      if (company && company.id && savedTyre && typeof savedTyre === "object") {
  	        savedTyre.Company_ID = company.id;
  	        savedTyre.__CompanyObjectId = company.id;
  	        savedTyre.__CompanyName = company.name;
  	      }

  	      return Promise.resolve(savedTyre);
  	    }

  	    function saveTyre(tyre, company) {
  	      var payload;
  	      var owningCompany = company || selectedCompany();

  	      if (!BackendlessSafe || !BackendlessSafe.Data || !BackendlessSafe.Data.of) {
  	        return Promise.reject(new Error("Backendless is unavailable. Cannot save tyre."));
  	      }

  	      tyre = stampCompanyMeta(tyre, owningCompany);
  	      tyre = stampCompanyMeta(tyre, owningCompany);
  	      payload = cleanTyreForSave(tyre);

  	      return BackendlessSafe.Data.of(TABLE_TYRES).save(payload)
  	      .then(function (saved) {
  	        saved = saved && typeof saved === "object" ? saved: payload;
  	        upsertTyre(saved, owningCompany);
  	        syncSavedTyreToAppData(saved, owningCompany);

  	        return attachTyreToCompany(saved, owningCompany)
  	        .then(function () {
  	          return saved;
  	        });
  	      });
  	    }

  	    function saveTyresSequentially(tyres, progressPrefix) {
  	      var saved = [];
  	      var total = tyres.length;
  	      var company = selectedCompany();

  	      return tyres.reduce(function (chain, tyre, index) {
  	        return chain.then(function () {
  	          state.busy = true;
  	          state.message = (progressPrefix || "Saving tyres") + " " + (index + 1) + " of " + total + "...";
  	          state.messageError = false;
  	          render();

  	          return saveTyre(tyre, company).then(function (savedTyre) {
  	            saved.push(savedTyre);
  	            return savedTyre;
  	          });
  	        });
  	      }, Promise.resolve()).then(function () {
  	        return saved;
  	      });
  	    }

  	    function loadTyresFromDatabase() {
  	      var store;
  	      var companyIds = companies.map(function (company) {
  	        return clean(company && company.id);
  	      }).filter(function (id, index, all) {
  	        return !!id && canAccessCompanyId(id) && all.indexOf(id) === index;
  	      });
  	      var pageSize = 100;
  	      var offset = 0;
  	      var maximumRows = 10000;
  	      var loaded = [];
  	      var seenObjectIds = {};
  	      var whereClause;

  	      if (!companyIds.length || !BackendlessSafe || !BackendlessSafe.Data || !BackendlessSafe.Data.of) {
  	        return Promise.resolve([]);
  	      }

  	      whereClause = companyIds.map(function (id) {
  	        return "Company_ID = '" + tyreWhereValue(id) + "'";
  	      }).join(" OR ");

  	      try {
  	        store = BackendlessSafe.Data.of(TABLE_TYRES);
  	      } catch (error) {
  	        return Promise.reject(error);
  	      }

  	      function fetchPage() {
  	        var query;
  	        var supportsOffset = false;

  	        try {
  	          if (BackendlessSafe.DataQueryBuilder && BackendlessSafe.DataQueryBuilder.create) {
  	            query = BackendlessSafe.DataQueryBuilder.create();
  	            if (typeof query.setWhereClause === "function") query.setWhereClause(whereClause);
  	            if (typeof query.setPageSize === "function") query.setPageSize(pageSize);
  	            if (typeof query.setOffset === "function") {
  	              query.setOffset(offset);
  	              supportsOffset = true;
  	            }
  	          } else {
  	            query = {
  	              whereClause: whereClause,
  	              pageSize: pageSize,
  	              offset: offset
  	            };
  	            supportsOffset = true;
  	          }
  	        } catch (error) {
  	          query = {
  	            whereClause: whereClause,
  	            pageSize: pageSize,
  	            offset: offset
  	          };
  	          supportsOffset = true;
  	        }

  	        return Promise.resolve(store.find(query)).then(function (rows) {
  	          rows = Array.isArray(rows)
  	          ? rows
  	          : rows && Array.isArray(rows.data)
  	          ? rows.data
  	          : [];

  	          var added = 0;

  	          rows.forEach(function (row, index) {
  	            var id = tyreObjectId(row);
  	            var key = id || ("offset-" + offset + "-row-" + index);

  	            if (id && seenObjectIds[key]) {
  	              return;
  	            }

  	            if (id) {
  	              seenObjectIds[key] = true;
  	            }

  	            loaded.push(row);
  	            added += 1;
  	          });

  	          if (rows.length === pageSize && added > 0 && loaded.length < maximumRows && supportsOffset) {
  	            offset += pageSize;
  	            return fetchPage();
  	          }

  	          return loaded;
  	        });
  	      }

  	      return fetchPage();
  	    }

  	    function loadTyres() {
  	      var fresh = collectTyres();
  	      var map = {};

  	      fresh.forEach(function (tyre) {
  	        var id = tyreObjectId(tyre);

  	        if (id) {
  	          map[id] = tyre;
  	        }
  	      });

  	      state.tyres.forEach(function (tyre) {
  	        var id = tyreObjectId(tyre);
  	        var companyId = clean(tyre.__CompanyObjectId) || tyreStoredCompanyId(tyre);

  	        if (id && companyId && canAccessCompanyId(companyId) && !map[id]) {
  	          map[id] = stampCompanyMeta(tyre, companyItemById(companyId));
  	        }
  	      });

  	      state.busy = true;
  	      state.message = "Loading company tyres...";
  	      state.messageError = false;
  	      render();

  	      return loadTyresFromDatabase()
  	      .then(function (databaseTyres) {
  	        databaseTyres.forEach(function (tyre) {
  	          var id = tyreObjectId(tyre);
  	          var companyId = tyreStoredCompanyId(tyre);
  	          var company = companyItemById(companyId);

  	          if (!company && id && map[id]) {
  	            company = companyItemById(clean(map[id].__CompanyObjectId) || tyreStoredCompanyId(map[id]));
  	          }

  	          if (!company || !canAccessCompanyId(company.id)) {
  	            return;
  	          }

  	          addTyreToMap(map, tyre, company);
  	          syncSavedTyreToAppData(stampCompanyMeta(tyre, company), company);
  	        });

  	        state.tyres = Object.keys(map).map(function (key) {
  	          return map[key];
  	        });

  	        state.busy = false;
  	        state.message = "Company tyres refreshed.";
  	        state.messageError = false;
  	        render();

  	        return state.tyres;
  	      })
  	      .catch(function (error) {

  	        state.tyres = Object.keys(map).map(function (key) {
  	          return map[key];
  	        });
  	        state.busy = false;
  	        state.message = "Loaded available company tyres. Database refresh was unavailable.";
  	        state.messageError = true;
  	        render();

  	        return state.tyres;
  	      });
  	    }

  	    function filteredTyres() {
  	      var q = clean(state.search).toLowerCase();

  	      return companyScopedTyres().filter(function (tyre) {
  	        if (q && tyreSearchBlob(tyre).indexOf(q) === -1) {
  	          return false;
  	        }

  	        if (state.statusFilter !== "All" && tyreStatus(tyre) !== state.statusFilter) {
  	          return false;
  	        }

  	        if (state.stageFilter !== "All" && tyreStage(tyre) !== state.stageFilter) {
  	          return false;
  	        }

  	        if (state.typeFilter !== "All" && tyreType(tyre) !== state.typeFilter) {
  	          return false;
  	        }

  	        if (state.locationFilter === "Warehouse" && !tyreIsWarehouse(tyre)) {
  	          return false;
  	        }

  	        if (state.locationFilter === "Fitted" && !tyreIsFitted(tyre)) {
  	          return false;
  	        }

  	        return true;
  	      }).sort(function (a, b) {
  	        return compareSortValues(a, b, state.sortKey || "remainingMileage", state.sortDir || "asc");
  	      });
  	    }

  	    function counts() {
  	      var tyres = companyScopedTyres();

  	      return {
  	        total: tyres.length,
  	        warehouse: tyres.filter(tyreIsWarehouse).length,
  	        fitted: tyres.filter(tyreIsFitted).length,
  	        retread: tyres.filter(function (tyre) {
  	          return tyreStatus(tyre) === TYRE_STATUS.RETREAD;
  	        }).length,
  	        scrapped: tyres.filter(function (tyre) {
  	          return tyreStatus(tyre) === TYRE_STATUS.SCRAPPED;
  	        }).length,
  	        newStage: tyres.filter(function (tyre) {
  	          return tyreStage(tyre) === "New";
  	        }).length,
  	        cap1: tyres.filter(function (tyre) {
  	          return tyreStage(tyre) === "Cap1";
  	        }).length,
  	        cap2: tyres.filter(function (tyre) {
  	          return tyreStage(tyre) === "Cap2";
  	        }).length,
  	        cap3: tyres.filter(function (tyre) {
  	          return tyreStage(tyre) === "Cap3";
  	        }).length
  	      };
  	    }

  	    function cssHtml() {
  	      return ""
  	      + "<style>"
  	      + CSS_SCOPE + " *{box-sizing:border-box;}"
  	      + CSS_SCOPE + "{font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#e8e8e8;}"
  	      + CSS_SCOPE + " .ctm-panel{position:relative;width:100%!important;max-width:none!important;height:100%!important;min-height:0!important;margin:0!important;background:#111;border:1px solid #2f2f2f;border-radius:0;box-shadow:0 18px 60px rgba(0,0,0,.72);overflow:hidden!important;display:flex!important;flex-direction:column!important;flex:1 1 auto!important;}"
  	      + CSS_SCOPE + " .ctm-main-head-actions{position:absolute;top:7px;right:9px;display:flex;align-items:center;gap:7px;z-index:50;}"
  	      + CSS_SCOPE + " .ctm-close-main{width:28px;height:28px;border-radius:5px;background:#1d1d1d;border:1px solid #3a3a3a;color:#ddd;font-size:17px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;}"
  	      + CSS_SCOPE + " .ctm-close-main:hover{background:#2a2a2a;color:#fff;}"
  	      + CSS_SCOPE + " .ctm-head{display:flex;justify-content:space-between;gap:14px;align-items:flex-start;margin-bottom:5px;padding-right:145px;}"
  	      + CSS_SCOPE + " .ctm-title{color:#cc6633;font-size:17px;font-weight:850;letter-spacing:.01em;}"
  	      + CSS_SCOPE + " .ctm-message{font-size:11px;font-weight:750;text-align:right;min-width:230px;}"
  	      + CSS_SCOPE + " .ctm-company-row{display:grid;grid-template-columns:260px max-content;gap:8px;align-items:end;margin:8px 0 10px;justify-content:start;}"
  	      + CSS_SCOPE + " .ctm-stats{display:flex;gap:6px;flex-wrap:wrap;margin:7px 0 10px;}"
  	      + CSS_SCOPE + " .ctm-stat{border:1px solid #333;background:#151515;border-radius:5px;padding:5px 9px;display:flex;gap:7px;align-items:center;min-height:27px;}"
  	      + CSS_SCOPE + " .ctm-stat span:first-child{color:#858585;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.05em;}"
  	      + CSS_SCOPE + " .ctm-stat span:last-child{color:#f2f2f2;font-size:13px;font-weight:850;}"
  	      + CSS_SCOPE + " .ctm-tools{display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr auto;gap:7px;align-items:end;margin:8px 0 9px;}"
  	      + CSS_SCOPE + " label{display:block;color:#bdbdbd;font-size:10px;font-weight:650;margin-bottom:2px;}"
  	      + CSS_SCOPE + " input," + CSS_SCOPE + " select," + CSS_SCOPE + " textarea{width:100%;background:#0f0f0f;border:1px solid #3c3c3c;border-radius:5px;color:#eee;padding:5px 8px;font-size:12px;outline:none;min-height:30px;}"
  	      + CSS_SCOPE + " input:focus," + CSS_SCOPE + " select:focus," + CSS_SCOPE + " textarea:focus{border-color:#cc6633;box-shadow:0 0 0 2px rgba(204,102,51,.11);}"
  	      + CSS_SCOPE + " textarea{min-height:46px;resize:vertical;}" + CSS_SCOPE + " button{border:none;border-radius:5px;color:#fff;padding:7px 10px;font-size:12px;font-weight:750;cursor:pointer;}"
  	      + CSS_SCOPE + " button:hover{filter:brightness(1.08);}"
  	      + CSS_SCOPE + " button:disabled{opacity:.48;cursor:not-allowed;}"
  	      + CSS_SCOPE + " .ctm-btn-main{background:#b86635;}"
  	      + CSS_SCOPE + " .ctm-btn-muted{background:#555;}"
  	      + CSS_SCOPE + " .ctm-btn-dark{background:#2a2a2a;}"
  	      + CSS_SCOPE + " .ctm-btn-green{background:#3d7d40;}"
  	      + CSS_SCOPE + " .ctm-btn-orange{background:#9a5d2e;}"
  	      + CSS_SCOPE + " .ctm-btn-red{background:#8a3b37;}"
  	      + CSS_SCOPE + " .ctm-list{display:flex;flex-direction:column;gap:3px;}"
  	      + CSS_SCOPE + " .ctm-list-head{display:grid;grid-template-columns:2.4fr 1.1fr .65fr .65fr .9fr 1fr;gap:8px;color:#b86635;font-size:10px;font-weight:800;text-transform:uppercase;padding:0 9px 3px;}"
  	      + CSS_SCOPE + " .ctm-row{display:grid;grid-template-columns:2.4fr 1.1fr .65fr .65fr .9fr 1fr;gap:8px;align-items:center;background:rgba(18,18,18,.86);border:1px solid #282828;border-radius:5px;padding:5px 9px;cursor:pointer;transition:background .12s,border-color .12s;min-height:36px;}"
  	      + CSS_SCOPE + " .ctm-row:hover{background:#191919;border-color:#4a4a4a;}"
  	      + CSS_SCOPE + " .ctm-sort-head{width:auto;background:transparent!important;border:0!important;color:#b86635!important;padding:0!important;margin:0!important;font-size:10px!important;font-weight:850!important;text-transform:uppercase!important;text-align:left!important;box-shadow:none!important;}"
  	      + CSS_SCOPE + " .ctm-sort-head:hover{color:#e08b53!important;text-decoration:underline;filter:none!important;}" + CSS_SCOPE + " .ctm-fleet{font-weight:800;color:#f4f4f4;font-size:12px;line-height:1.12;}"
  	      + CSS_SCOPE + " .ctm-desc{color:#888;font-size:10px;margin-top:1px;line-height:1.18;}"
  	      + CSS_SCOPE + " .ctm-small{color:#b7b7b7;font-size:11px;line-height:1.15;}"
  	      + CSS_SCOPE + " .ctm-muted{color:#777;font-size:10px;line-height:1.15;}"
  	      + CSS_SCOPE + " .ctm-badge{display:inline-flex;align-items:center;border-radius:5px;padding:2px 7px;font-size:10px;font-weight:800;white-space:nowrap;}"
  	      + CSS_SCOPE + " .ctm-empty{border:1px dashed #333;background:#121212;border-radius:5px;padding:24px;text-align:center;color:#777;}"
  	      + CSS_SCOPE + " .ctm-modal{position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.90);display:flex;align-items:center;justify-content:center;padding:24px;pointer-events:auto;backdrop-filter:blur(8px) saturate(.72);}"
  	      + CSS_SCOPE + " .ctm-card{width:min(820px,calc(100vw - 42px));max-width:100%;max-height:calc(100dvh - 42px);display:flex;flex-direction:column;background:linear-gradient(145deg,#171b18,#090c0a 74%);border:1px solid rgba(204,102,51,.52);border-radius:15px;box-shadow:0 30px 90px rgba(0,0,0,.88),0 0 34px rgba(204,102,51,.12);overflow:hidden;}"
  	      + CSS_SCOPE + " .ctm-card-head{position:sticky;top:0;z-index:4;display:flex;justify-content:space-between;align-items:center;gap:12px;padding:13px 15px;border-bottom:1px solid rgba(204,102,51,.22);background:linear-gradient(145deg,#1c211d,#111512);}"
  	      + CSS_SCOPE + " .ctm-card-title{color:#f3f5f3;font-weight:900;font-size:17px;}"
  	      + CSS_SCOPE + " .ctm-card-head-actions{display:flex;align-items:center;gap:7px;}"
  	      + CSS_SCOPE + " .ctm-print-head-btn{background:#2a2a2a!important;border:1px solid #444!important;padding:6px 9px!important;font-size:12px!important;height:28px!important;display:inline-flex!important;align-items:center!important;gap:5px!important;}"
  	      + CSS_SCOPE + " .ctm-card-body{flex:1 1 auto;min-height:0;padding:13px 14px 15px;overflow:auto;max-height:none;scrollbar-width:thin;scrollbar-color:rgba(204,102,51,.52) transparent;}"
  	      + CSS_SCOPE + " .ctm-grid2{display:grid;grid-template-columns:1fr 1fr;gap:6px 10px;}"
  	      + CSS_SCOPE + " .ctm-note{color:#999;font-size:11px;line-height:1.3;margin-bottom:7px;}"
  	      + CSS_SCOPE + " .ctm-preview{border:1px solid #303030;background:#111;border-radius:5px;padding:7px 9px;margin:7px 0;color:#d0d0d0;font-size:12px;line-height:1.35;max-height:88px;overflow:auto;}"
  	      + CSS_SCOPE + " .ctm-popup-actions{display:grid;grid-template-columns:repeat(4,minmax(120px,1fr));gap:7px;margin:7px 0 9px;}"
  	      + CSS_SCOPE + " .ctm-popup-actions button{padding:7px 10px;font-size:12px;}"
  	      + CSS_SCOPE + " .ctm-bottom-actions{display:flex;gap:7px;justify-content:flex-end;margin-top:8px;flex-wrap:wrap;}"
  	      + CSS_SCOPE + " .ctm-detail-top{display:flex;justify-content:space-between;gap:12px;align-items:flex-start;margin-bottom:7px;}"
  	      + CSS_SCOPE + " .ctm-detail-name{font-size:18px;font-weight:850;color:#f4f4f4;line-height:1.05;}"
  	      + CSS_SCOPE + " .ctm-detail-sub{font-size:12px;color:#888;margin-top:2px;line-height:1.2;}"
  	      + CSS_SCOPE + " .ctm-section-title{color:#cc6633;font-size:13px;font-weight:850;margin:8px 0 5px;}"
  	      + CSS_SCOPE + " .ctm-transaction-shell{margin:8px 0;}"
  	      + CSS_SCOPE + " .ctm-transaction-panel{border:1px solid #303030;background:#111;border-radius:5px;padding:8px;margin-top:7px;}"
  	      + CSS_SCOPE + " .ctm-history-wrap{margin-top:8px;border-top:1px solid #292929;padding-top:7px;}"
  	      + CSS_SCOPE + " .ctm-history-scroll{max-height:220px;overflow:auto;border:1px solid #303030;border-radius:5px;background:#0f0f0f;}"+ CSS_SCOPE + " .ctm-history-table{width:100%;border-collapse:collapse;font-size:11px;min-width:980px;}"
  	      + CSS_SCOPE + " .ctm-history-table th{position:sticky;top:0;background:#191919;color:#b86635;text-align:left;font-size:10px;text-transform:uppercase;padding:7px;border-bottom:1px solid #333;z-index:1;}"
  	      + CSS_SCOPE + " .ctm-history-table td{padding:7px;border-bottom:1px solid #242424;color:#cfcfcf;vertical-align:top;}"
  	      + CSS_SCOPE + " .ctm-history-row{cursor:pointer;}"
  	      + CSS_SCOPE + " .ctm-history-row:hover td{background:#181818;}"
  	      + CSS_SCOPE + " .ctm-history-selected td{background:#202020!important;color:#fff;}"
  	      + CSS_SCOPE + " .ctm-history-detail-row td{background:#111!important;border-bottom:1px solid #333;}"
  	      + CSS_SCOPE + " .ctm-history-detail-grid{display:grid;grid-template-columns:repeat(3,minmax(160px,1fr));gap:8px;}"
  	      + CSS_SCOPE + " .ctm-history-detail-label{color:#888;font-size:9px;font-weight:800;text-transform:uppercase;margin-bottom:2px;}"
  	      + CSS_SCOPE + " .ctm-history-detail-value{color:#eee;font-size:11px;word-break:break-word;}"
  	      + "@media(max-width:1000px){#" + ROOT_ID + "{padding:64px 8px 8px 8px!important;}#" + ROOT_ID + " .ctm-panel{width:100%;}#" + ROOT_ID + " .ctm-tools{grid-template-columns:1fr 1fr;}#" + ROOT_ID + " .ctm-company-row{grid-template-columns:1fr;}#" + ROOT_ID + " .ctm-list-head{display:none;}#" + ROOT_ID + " .ctm-row{grid-template-columns:1fr;}#" + ROOT_ID + " .ctm-grid2{grid-template-columns:1fr;}#" + ROOT_ID + " .ctm-popup-actions{grid-template-columns:1fr;}#" + ROOT_ID + " .ctm-history-detail-grid{grid-template-columns:1fr;}}"
  	      + CSS_SCOPE + " .ctm-panel{width:100%!important;max-width:none!important;margin:0!important;height:100%!important;min-height:0!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;background:#111!important;border-radius:0!important;flex:1 1 auto!important;}"
  	      + CSS_SCOPE + " .ctm-wrap{width:100%!important;max-width:none!important;min-width:1100px!important;height:100%!important;min-height:0!important;display:flex!important;flex-direction:column!important;padding:6px 8px 0!important;overflow:hidden!important;}"
  	      + CSS_SCOPE + " #ctmListMount{width:100%!important;max-width:none!important;flex:1 1 auto!important;min-height:0!important;overflow:auto!important;padding-bottom:8px!important;}"
  	      + CSS_SCOPE + " .ctm-list-head,#" + ROOT_ID + " .ctm-row{grid-template-columns:96px 2.1fr .82fr .82fr .65fr .65fr .9fr 1.1fr 1fr!important;}"
  	      + CSS_SCOPE + " .ctm-tyre-visual-wrap{display:flex;flex-direction:column;align-items:flex-start;gap:2px;min-width:76px;}"
  	      + CSS_SCOPE + " .ctm-tyre-visual-large{flex-direction:row;align-items:center;gap:13px;min-width:300px;}"
  	      + CSS_SCOPE + " .ctm-tyre-graphic{position:relative;width:76px;height:25px;border:2px solid #050505;border-radius:4px;background-color:var(--ctm-tyre-color,#6b7280);background-image:linear-gradient(45deg,rgba(0,0,0,.82) 25%,transparent 25%,transparent 50%,rgba(0,0,0,.82) 50%,rgba(0,0,0,.82) 75%,transparent 75%,transparent),linear-gradient(-45deg,rgba(0,0,0,.72) 25%,transparent 25%,transparent 50%,rgba(0,0,0,.72) 50%,rgba(0,0,0,.72) 75%,transparent 75%,transparent);background-size:10px 10px;box-shadow:inset 0 0 0 1px rgba(255,255,255,.16),inset 0 -7px 11px rgba(0,0,0,.38),0 1px 4px rgba(0,0,0,.75);overflow:hidden;}"
  	      + CSS_SCOPE + " .ctm-tyre-graphic:before{content:'';position:absolute;left:3px;right:3px;top:3px;height:3px;border-radius:3px;background:rgba(255,255,255,.18);}"
  	      + CSS_SCOPE + " .ctm-tyre-visual-large .ctm-tyre-graphic{width:180px;height:46px;border-radius:6px;background-size:13px 13px;}"
  	      + CSS_SCOPE + " .ctm-tyre-visual-text{font-size:9px;line-height:1.15;color:#8f8f8f;font-weight:750;white-space:nowrap;}"
  	      + CSS_SCOPE + " .ctm-tyre-visual-large .ctm-tyre-visual-text{font-size:12px;line-height:1.35;color:#bdbdbd;}"
  	      + CSS_SCOPE + " .ctm-list{width:100%!important;}"
  	+ CSS_SCOPE + " .ctm-col-remaining-mileage," + CSS_SCOPE + " .ctm-col-remaining-hours{display:block!important;visibility:visible!important;min-width:0!important;}"
  	      + CSS_SCOPE + " .ctm-list-head,#" + ROOT_ID + " .ctm-row{width:100%!important;grid-template-columns:96px minmax(230px,2.1fr) minmax(120px,.82fr) minmax(115px,.82fr) minmax(80px,.65fr) minmax(80px,.65fr) minmax(130px,.9fr) minmax(150px,1.1fr) minmax(160px,1fr)!important;}"
  	      + CSS_SCOPE + " .ctm-list-head{position:sticky!important;top:0!important;z-index:5!important;background:rgba(17,17,17,.98)!important;padding-top:4px!important;border-bottom:1px solid #292929!important;}"
  	      + CSS_SCOPE + " #ctmListMount::-webkit-scrollbar{width:10px;height:10px;}"
  	      + CSS_SCOPE + " #ctmListMount::-webkit-scrollbar-thumb{background:#333;border-radius:8px;}"
  	      + CSS_SCOPE + " #ctmListMount::-webkit-scrollbar-track{background:#111;}"
  	      + CSS_SCOPE + ".ctm-inline-root{padding:0!important;background:transparent!important;}"
  	      + "#" + MODAL_PORTAL_ID + "{overflow:visible!important;pointer-events:none!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-modal{pointer-events:auto!important;}"
  	      + CSS_SCOPE + ".ctm-inline-root .ctm-panel{border-radius:12px!important;border-color:rgba(204,102,51,.28)!important;background:linear-gradient(145deg,#111412,#090b0a)!important;}"
  	      + CSS_SCOPE + ".ctm-inline-root .ctm-wrap{min-width:1240px!important;padding:8px 9px 0!important;}"
  	      + CSS_SCOPE + ".ctm-inline-root .ctm-head{margin-bottom:2px!important;}"
  	      + CSS_SCOPE + ".ctm-inline-root .ctm-company-row{margin:5px 0 7px!important;}"
  	      + CSS_SCOPE + " .ctm-company-row-inline{grid-template-columns:minmax(220px,1fr) auto!important;align-items:end!important;}"
  	      + CSS_SCOPE + " .ctm-company-display{min-height:30px;display:flex;align-items:center;padding:5px 9px;border:1px solid #393d3a;border-radius:6px;background:#0b0e0c;color:#fff;font-size:12px;font-weight:850;}"
  	      + CSS_SCOPE + " .ctm-company-actions{display:flex;gap:7px;justify-content:flex-start;align-items:end;}"
  	      + CSS_SCOPE + " .ctm-view-only-note{padding:8px 10px;border:1px solid rgba(245,166,35,.26);border-radius:6px;background:rgba(245,166,35,.07);color:#e5bc7a;}"
  	      + CSS_SCOPE + " .ctm-modal{z-index:2147483647!important;background:rgba(0,0,0,.90)!important;backdrop-filter:blur(8px) saturate(.72);}"
  	      + "@media(max-width:1000px){#" + ROOT_ID + ".ctm-inline-root{padding:0!important;}#" + ROOT_ID + ".ctm-inline-root .ctm-wrap{min-width:980px!important;}}"

  	      + "#" + MODAL_PORTAL_ID + " .ctm-card{width:min(900px,calc(100vw - 40px));}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-card-body{padding:0!important;background:linear-gradient(145deg,#101411,#080b09);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form{display:grid;gap:11px;padding:14px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-intro{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:14px;align-items:center;padding:11px 12px;border:1px solid rgba(204,102,51,.24);border-radius:11px;background:linear-gradient(145deg,rgba(204,102,51,.085),rgba(255,255,255,.018));}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-intro strong{display:block;color:#f2f4f2;font-size:12px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-intro span{display:block;margin-top:3px;color:#89928c;font-size:9px;line-height:1.4;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-intro b{color:#d37b4b;font-size:11px;white-space:nowrap;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-section{border:1px solid rgba(255,255,255,.075);border-radius:12px;background:rgba(255,255,255,.018);overflow:hidden;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-section>header{padding:9px 11px;border-bottom:1px solid rgba(255,255,255,.06);background:#141915;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-section>header strong{display:block;color:#f0f3f1;font-size:11px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-section>header span{display:block;margin-top:2px;color:#747d77;font-size:8px;line-height:1.35;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px 12px;padding:11px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-grid.spec{grid-template-columns:repeat(4,minmax(0,1fr));}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-grid.purchase{grid-template-columns:repeat(3,minmax(0,1fr));}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form label{display:block;margin:0 0 5px;color:#909993;font-size:9px;font-weight:850;line-height:1.2;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form input," + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form textarea," + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form select{width:100%;min-width:0;min-height:42px;padding:9px 10px;border:1px solid rgba(255,255,255,.105);border-radius:9px;background:#090c0a;color:#edf1ee;font:700 11px/1.3 Inter,system-ui;outline:none;box-shadow:inset 0 1px 0 rgba(255,255,255,.018);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form input::placeholder," + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form textarea::placeholder{color:#5e6761;opacity:1;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form input:focus," + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form textarea:focus{border-color:#cc6633;box-shadow:0 0 0 2px rgba(204,102,51,.11);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-form textarea{min-height:76px;resize:vertical;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-new-tyres-notes{padding:0 11px 11px;}"
  	      + "#" + MODAL_PORTAL_ID + " .fif-native-select{position:absolute!important;width:1px!important;height:1px!important;margin:0!important;padding:0!important;opacity:0!important;pointer-events:none!important;overflow:hidden!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .fif-styled-select-button{height:42px!important;border-radius:9px!important;padding:0 11px!important;font-size:11px!important;background:linear-gradient(145deg,#111612,#080b09)!important;}"
  	      + "#" + MODAL_PORTAL_ID + " input[type=number][data-fif-number-enhanced]{-moz-appearance:textfield;}"
  	      + "#" + MODAL_PORTAL_ID + " input[type=number][data-fif-number-enhanced]::-webkit-inner-spin-button," + "#" + MODAL_PORTAL_ID + " input[type=number][data-fif-number-enhanced]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}"
  	      + "#" + MODAL_PORTAL_ID + " .fifvm-number-shell{position:relative;display:flex;width:100%;min-width:0;align-items:stretch;}"
  	      + "#" + MODAL_PORTAL_ID + " .fifvm-number-shell>input{flex:1 1 auto;min-width:0;padding-right:43px!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .fifvm-number-steppers{position:absolute;top:4px;right:4px;bottom:4px;width:29px;display:grid;grid-template-rows:1fr 1fr;border:1px solid rgba(204,102,51,.26);border-radius:7px;overflow:hidden;background:#121713;}"
  	      + "#" + MODAL_PORTAL_ID + " .fifvm-number-steppers button{display:grid!important;place-items:center!important;min-height:0!important;width:100%!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .fifvm-number-steppers button+button{border-top:1px solid rgba(204,102,51,.18)!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .fifvm-number-steppers button:hover{background:rgba(204,102,51,.13)!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .fifvm-number-steppers svg{width:12px;height:12px;display:block;fill:none;stroke:#d18458;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-numbering-preview{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:12px;align-items:center;padding:10px 11px;border:1px solid rgba(255,255,255,.075);border-radius:10px;background:#0a0e0b;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-numbering-preview strong{display:block;color:#f1f4f2;font-size:10px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-numbering-preview p{margin:3px 0 0;color:#858e88;font-size:9px;line-height:1.4;word-break:break-word;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-number-status{min-width:150px;padding:8px 10px;border:1px solid rgba(85,201,139,.23);border-radius:9px;background:rgba(85,201,139,.06);color:#77d8a4;text-align:center;font-size:9px;font-weight:900;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-number-status.bad{border-color:rgba(239,83,80,.27);background:rgba(239,83,80,.07);color:#ef8b87;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-number-status.warn{border-color:rgba(227,160,74,.27);background:rgba(227,160,74,.07);color:#e8ad5f;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-next-number-row{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:0 11px 11px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-next-number-row span{color:#79827c;font-size:8.5px;}"
  	      + "#" + MODAL_PORTAL_ID + " #ctmUseNextAvailable{min-height:34px;padding:0 11px;border:1px solid rgba(204,102,51,.35);border-radius:8px;background:#171c18;color:#db8a5b;font-size:9px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-bottom-actions{position:sticky;bottom:0;z-index:3;margin:0!important;padding:11px 14px;border-top:1px solid rgba(255,255,255,.07);background:rgba(12,16,13,.97);backdrop-filter:blur(8px);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-bottom-actions button{min-height:39px;padding:0 14px;border-radius:9px;font-size:10px;}"
  	      + "#" + MODAL_PORTAL_ID + " #ctmConfirmBulkCreate{background:linear-gradient(145deg,#bb6034,#77341a)!important;border:1px solid rgba(224,118,62,.62)!important;box-shadow:0 8px 20px rgba(97,38,13,.28);}"
  	      + "#" + MODAL_PORTAL_ID + " #ctmConfirmBulkCreate:disabled{background:#2a302b!important;border-color:rgba(255,255,255,.08)!important;box-shadow:none;}"
  	      + "@media(max-width:760px){#" + MODAL_PORTAL_ID + " .ctm-new-tyres-grid,#" + MODAL_PORTAL_ID + " .ctm-new-tyres-grid.spec,#" + MODAL_PORTAL_ID + " .ctm-new-tyres-grid.purchase{grid-template-columns:1fr 1fr;}#" + MODAL_PORTAL_ID + " .ctm-new-tyres-intro,#" + MODAL_PORTAL_ID + " .ctm-numbering-preview{grid-template-columns:1fr;}}"
  	      + "@media(max-width:500px){#" + MODAL_PORTAL_ID + " .ctm-new-tyres-grid,#" + MODAL_PORTAL_ID + " .ctm-new-tyres-grid.spec,#" + MODAL_PORTAL_ID + " .ctm-new-tyres-grid.purchase{grid-template-columns:1fr;}#" + MODAL_PORTAL_ID + " .ctm-modal{padding:10px;}#" + MODAL_PORTAL_ID + " .ctm-card{width:calc(100vw - 20px);max-height:calc(100dvh - 20px);}}"

  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card{width:min(1180px,calc(100vw - 38px));max-height:calc(100dvh - 34px);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card .ctm-card-head{padding:12px 16px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card .ctm-card-title{font-size:18px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card .ctm-card-body{padding:0!important;overflow:auto;background:linear-gradient(145deg,#111612,#080b09);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-content{display:grid;gap:10px;padding:12px 14px 0;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-hero{display:grid;grid-template-columns:minmax(390px,1.25fr) minmax(480px,1fr);gap:12px;align-items:stretch;padding:12px;border:1px solid rgba(204,102,51,.25);border-radius:12px;background:radial-gradient(circle at 0 0,rgba(204,102,51,.13),transparent 40%),linear-gradient(145deg,#202620,#121713);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-identity{display:flex;align-items:center;gap:15px;min-width:0;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card .ctm-tyre-visual-large{min-width:230px;gap:9px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card .ctm-tyre-visual-large .ctm-tyre-graphic{width:210px;height:56px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card .ctm-tyre-visual-large .ctm-tyre-visual-text{display:none;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-copy{min-width:0;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-copy>span{display:block;color:#d47b49;font-size:8px;font-weight:950;letter-spacing:.11em;text-transform:uppercase;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-copy h2{margin:4px 0 0;color:#fff;font-size:22px;line-height:1.05;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-copy p{margin:5px 0 0;color:#929b95;font-size:11px;line-height:1.4;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-badges{display:flex;gap:6px;flex-wrap:wrap;margin-top:9px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-stage-badge{background:rgba(255,255,255,.06)!important;border:1px solid rgba(255,255,255,.09)!important;color:#c5ccc7!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-metrics{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-metrics article{min-width:0;padding:9px 10px;border:1px solid rgba(255,255,255,.07);border-radius:9px;background:#121713;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-metrics span{display:block;color:#7f8983;font-size:8px;font-weight:900;text-transform:uppercase;letter-spacing:.06em;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-metrics strong{display:block;margin-top:5px;color:#f0f4f1;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-notice{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:9px 11px;border:1px solid rgba(228,162,79,.22);border-radius:9px;background:rgba(228,162,79,.055);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-notice strong{color:#efb66a;font-size:10px;white-space:nowrap;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-notice span{color:#969f99;font-size:9px;text-align:right;line-height:1.35;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-section{border:1px solid rgba(255,255,255,.075);border-radius:11px;background:rgba(255,255,255,.018);overflow:hidden;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-section-head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:9px 11px;border-bottom:1px solid rgba(255,255,255,.06);background:#161c17;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-section-head strong{display:block;color:#f0f4f1;font-size:12px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-section-head span{display:block;margin-top:2px;color:#7f8983;font-size:8.5px;line-height:1.35;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-section-head>b{color:#d18458;font-size:9px;white-space:nowrap;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-section-head>button{min-height:34px;padding:0 11px;border:1px solid rgba(204,102,51,.35);border-radius:8px;background:rgba(204,102,51,.11);color:#e6a07a;font-size:9px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-form-grid{display:grid;gap:10px 12px;padding:11px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-form-grid-spec{grid-template-columns:repeat(3,minmax(0,1fr));}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-form-grid-life{grid-template-columns:repeat(3,minmax(0,1fr));}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card label{display:block;margin:0 0 5px;color:#939c96;font-size:9px;font-weight:850;line-height:1.2;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card input,#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card textarea,#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card select{min-height:42px;padding:9px 10px;border:1px solid rgba(255,255,255,.1);border-radius:9px;background:#090c0a;color:#edf2ee;font:700 11px/1.3 Inter,system-ui;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card textarea{min-height:84px;resize:vertical;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card input::placeholder,#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card textarea::placeholder{color:#5f6862;opacity:1;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-notes{padding:11px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-transaction-shell{margin:0;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-transaction-panel{margin:0;padding:11px;border:0;border-radius:0;background:#101511;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-transaction-actions{display:flex;justify-content:flex-end;margin-top:9px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-transaction-actions button{min-height:36px;padding:0 12px;border-radius:8px;font-size:9px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-facts{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1px;background:rgba(255,255,255,.055);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-facts>div{min-width:0;padding:9px 10px;background:#111612;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-facts span{display:block;color:#7f8983;font-size:8px;font-weight:900;text-transform:uppercase;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-facts strong{display:block;margin-top:5px;color:#e8ede9;font-size:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-readonly-field{min-width:0;padding:9px 10px;background:#111612;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-readonly-field span{display:block;color:#7f8983;font-size:8px;font-weight:900;text-transform:uppercase;letter-spacing:.04em;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-readonly-field strong{display:block;margin-top:5px;color:#e8ede9;font-size:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-readonly-field small{display:block;margin-top:3px;color:#69736d;font-size:8px;line-height:1.3;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-record-facts{grid-template-columns:repeat(3,minmax(0,1fr));}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-action-strip{display:flex;align-items:center;justify-content:flex-end;gap:7px;flex-wrap:wrap;padding:8px 10px;border:1px solid rgba(255,255,255,.07);border-radius:10px;background:#151a16;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-detail-action-strip button{min-height:34px;padding:0 11px;border-radius:8px;font-size:9px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-action-editor{border-color:rgba(204,102,51,.34);box-shadow:0 0 0 1px rgba(204,102,51,.05);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-expected-mileage-preview{border:1px solid rgba(204,102,51,.28);background:linear-gradient(145deg,rgba(204,102,51,.10),#111612);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-expected-mileage-preview strong{color:#f3b080;font-size:14px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-expected-mileage-preview small{color:#9ca59f;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-footer button[aria-hidden=true]{display:none!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-section{margin:0;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-help{padding:8px 11px;color:#828c85;font-size:9px;border-bottom:1px solid rgba(255,255,255,.05);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-scroll{max-height:310px;border:0;border-radius:0;background:#0d110e;overflow:auto;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-table{min-width:760px;font-size:10px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-table th{top:0;padding:8px 9px;background:#171d18;color:#d18458;font-size:8px;border-bottom:1px solid rgba(204,102,51,.18);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-table td{padding:8px 9px;color:#cbd2cd;border-bottom:1px solid rgba(255,255,255,.05);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-table td strong{display:block;color:#edf2ee;font-size:10px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-table td small{display:block;margin-top:2px;color:#78827c;font-size:8px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-row:hover td{background:#171d18;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-selected td{background:rgba(204,102,51,.08)!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-detail-row td{padding:11px!important;background:#111612!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-history-detail-grid{grid-template-columns:repeat(4,minmax(130px,1fr));gap:7px;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-footer{margin:0 -14px!important;padding:11px 14px!important;}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-footer #ctmSaveEditTyre{background:linear-gradient(145deg,#bc6134,#7b351b)!important;border:1px solid rgba(224,118,62,.55)!important;box-shadow:0 8px 20px rgba(91,36,14,.25);}"
  	      + "#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-footer #ctmCancelModal{background:#242a25!important;border:1px solid rgba(255,255,255,.09)!important;}"
  	      + "@media(max-width:980px){#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-hero{grid-template-columns:1fr;}#" + MODAL_PORTAL_ID + " .ctm-detail-form-grid-spec{grid-template-columns:repeat(2,minmax(0,1fr));}#" + MODAL_PORTAL_ID + " .ctm-detail-form-grid-life{grid-template-columns:1fr 1fr;}#" + MODAL_PORTAL_ID + " .ctm-detail-facts{grid-template-columns:repeat(2,minmax(0,1fr));}}"
  	      + "@media(max-width:650px){#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-content{padding:9px 9px 0;}#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-identity{align-items:flex-start;flex-direction:column;}#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card .ctm-tyre-visual-large{min-width:0;width:100%;}#" + MODAL_PORTAL_ID + " .ctm-tyre-detail-card .ctm-tyre-visual-large .ctm-tyre-graphic{width:100%;max-width:260px;}#" + MODAL_PORTAL_ID + " .ctm-tyre-hero-metrics,#" + MODAL_PORTAL_ID + " .ctm-detail-form-grid-spec,#" + MODAL_PORTAL_ID + " .ctm-detail-form-grid-life,#" + MODAL_PORTAL_ID + " .ctm-detail-facts{grid-template-columns:1fr;}#" + MODAL_PORTAL_ID + " .ctm-detail-notice{align-items:flex-start;flex-direction:column;}#" + MODAL_PORTAL_ID + " .ctm-detail-notice span{text-align:left;}#" + MODAL_PORTAL_ID + " .ctm-history-detail-grid{grid-template-columns:1fr 1fr;}}"

  	      + "</style>";
  	    }

  	    function buttonHtml(id,
  	      label,
  	      className,
  	      extraAttrs) {
  	      return "<button id=\"" + escapeHtml(id) + "\" type=\"button\" class=\"" + escapeHtml(className || "ctm-btn-main") + "\" " + (extraAttrs || "") + ">" + escapeHtml(label) + "</button>";
  	    }

  	    function statPillHtml(label,
  	      value) {
  	      return "<div class=\"ctm-stat\"><span>" + escapeHtml(label) + "</span><span>" + escapeHtml(value) + "</span></div>";
  	    }

  	    function optionHtml(value,
  	      current,
  	      label) {
  	      return "<option value=\"" + escapeHtml(value) + "\"" + (value === current ? " selected": "") + ">" + escapeHtml(label || value) + "</option>";
  	    }

  	    function fieldHtml(id,
  	      label,
  	      value,
  	      placeholder,
  	      type) {
  	      return ""
  	      + "<div>"
  	      + "  <label>" + escapeHtml(label) + "</label>"
  	      + "  <input id=\"" + escapeHtml(id) + "\" type=\"" + escapeHtml(type || "text") + "\" value=\"" + escapeHtml(value || "") + "\" placeholder=\"" + escapeHtml(placeholder || "") + "\">"
  	      + "</div>";
  	    }

  	    function textareaHtml(id,
  	      label,
  	      placeholder,
  	      value) {
  	      return ""
  	      + "<div>"
  	      + "  <label>" + escapeHtml(label) + "</label>"
  	      + "  <textarea id=\"" + escapeHtml(id) + "\" placeholder=\"" + escapeHtml(placeholder || "") + "\">" + escapeHtml(value || "") + "</textarea>"
  	      + "</div>";
  	    }

  	    function selectHtml(id,
  	      label,
  	      values,
  	      current) {
  	      return ""
  	      + "<div>"
  	      + "  <label>" + escapeHtml(label) + "</label>"
  	      + "  <select id=\"" + escapeHtml(id) + "\">"
  	      + values.map(function (value) {
  	        return optionHtml(value, current, value);
  	      }).join("")
  	      + "  </select>"
  	      + "</div>";
  	    }

  	    function companySelectHtml() {
  	      var company = selectedCompany();
  	      var actions = ""
  	      + (AllowEditing ? buttonHtml("ctmNewTyresBtn", "New Tyres", "ctm-btn-main"): "")
  	      + buttonHtml("ctmRefreshBtn",
  	        "Refresh",
  	        "ctm-btn-muted");

  	      if (HideCompanySelector) {
  	        return ""
  	        + "<div class=\"ctm-company-row ctm-company-row-inline\">"
  	        + "  <div>"
  	        + "    <label>Operating Company</label>"
  	        + "    <div class=\"ctm-company-display\">" + escapeHtml(company ? company.name: "No company selected") + "</div>"
  	        + "  </div>"
  	        + "  <div class=\"ctm-company-actions\">" + actions + "</div>"
  	        + "</div>";
  	      }

  	      return ""
  	      + "<div class=\"ctm-company-row\">"
  	      + "  <div>"
  	      + "    <label>Company Tyres</label>"
  	      + "    <select id=\"ctmCompanyFilter\">"
  	      + (companies.length
  	        ? companies.map(function (companyItem) {
  	          return optionHtml(companyItem.id, state.companyId, companyItem.name);
  	        }).join(""): "<option value=\"\">No accessible companies</option>")
  	      + "    </select>"
  	      + "  </div>"
  	      + "  <div class=\"ctm-company-actions\">" + actions + "</div>"
  	      + "</div>";
  	    }

  	    function filtersHtml() {
  	      return ""
  	      + "<div class=\"ctm-tools\">"
  	      + "  <div>"
  	      + "    <label>Search</label>"
  	      + "    <input id=\"ctmSearch\" value=\"" + escapeHtml(state.search) + "\" placeholder=\"ID, serial, make, size, vehicle, stage...\">"
  	      + "  </div>"
  	      + "  <div>"
  	      + "    <label>Location</label>"
  	      + "    <select id=\"ctmLocationFilter\">"
  	      + optionHtml("All",
  	        state.locationFilter,
  	        "All")
  	      + optionHtml("Warehouse",
  	        state.locationFilter,
  	        "Warehouse")
  	      + optionHtml("Fitted",
  	        state.locationFilter,
  	        "Fitted")
  	      + "    </select>"
  	      + "  </div>"
  	      + "  <div>"
  	      + "    <label>Status</label>"
  	      + "    <select id=\"ctmStatusFilter\">"
  	      + optionHtml("All",
  	        state.statusFilter,
  	        "All")
  	      + optionHtml(TYRE_STATUS.OK,
  	        state.statusFilter,
  	        TYRE_STATUS.OK)
  	      + optionHtml(TYRE_STATUS.RETREAD,
  	        state.statusFilter,
  	        TYRE_STATUS.RETREAD)
  	      + optionHtml(TYRE_STATUS.SCRAPPED,
  	        state.statusFilter,
  	        TYRE_STATUS.SCRAPPED)
  	      + optionHtml(TYRE_STATUS.STOLEN,
  	        state.statusFilter,
  	        TYRE_STATUS.STOLEN)
  	      + "    </select>"
  	      + "  </div>"
  	      + "  <div>"
  	      + "    <label>Stage</label>"
  	      + "    <select id=\"ctmStageFilter\">"
  	      + optionHtml("All",
  	        state.stageFilter,
  	        "All")
  	      + STAGES.map(function (stage) {
  	        return optionHtml(stage, state.stageFilter, stage);
  	      }).join("")
  	      + "    </select>"
  	      + "  </div>"
  	      + "  <div>"
  	      + "    <label>Type</label>"
  	      + "    <select id=\"ctmTypeFilter\">"
  	      + optionHtml("All",
  	        state.typeFilter,
  	        "All")
  	      + TYPES.map(function (type) {
  	        return optionHtml(type, state.typeFilter, type);
  	      }).join("")
  	      + "    </select>"
  	      + "  </div>"
  	      + "  <div></div>"
  	      + "</div>";
  	    }

  	    function statusBadgeHtml(tyre) {
  	      var status = tyreStatus(tyre);
  	      var bg = "#444";

  	      if (status === TYRE_STATUS.OK) bg = "#3d6f40";
  	      if (status === TYRE_STATUS.RETREAD) bg = "#8a5a33";
  	      if (status === TYRE_STATUS.SCRAPPED) bg = "#7b3935";
  	      if (status === TYRE_STATUS.STOLEN) bg = "#4e455f";

  	      return "<span class=\"ctm-badge\" style=\"background:" + bg + ";\">" + escapeHtml(status) + "</span>";
  	    }

  	    function mileageWarningText(tyre) {
  	      return tyreWarningState(tyre).level;
  	    }

  	    function mileageWarningHtml(tyre) {
  	      var warningState = tyreWarningState(tyre);
  	      var bg;
  	      var color = "#ffffff";

  	      if (!warningState.active) {
  	        return "<span class=\"ctm-muted\">—</span>";
  	      }

  	      bg = warningState.level === "Critical" ? "#ef3b24": "#f28c28";

  	      return "<span class=\"ctm-badge\" style=\"background:" + bg + ";color:" + color + ";\" title=\"Threshold: " + escapeHtml(formatTyreCounter(warningState.threshold, tyre)) + " · Remaining: " + escapeHtml(formatTyreCounter(warningState.remaining, tyre)) + "\">" + escapeHtml(warningState.level) + "</span>";
  	    }

  	    function locationText(tyre) {
  	      if (tyreIsFitted(tyre)) {
  	        return clean(tyre.Vehicle_ID) || "Fitted";
  	      }

  	      if (tyreStatus(tyre) === TYRE_STATUS.OK) {
  	        return "Warehouse";
  	      }

  	      return "Not fitted";
  	    }

  	    function locationSubText(tyre) {
  	      if (tyreIsFitted(tyre)) {
  	        return clean(tyre.Current_Position);
  	      }

  	      return "";
  	    }

  	    function locationHtml(tyre) {
  	      if (tyreIsFitted(tyre)) {
  	        return ""
  	        + "<div class=\"ctm-small\" style=\"font-weight:750;color:#eee;\">" + escapeHtml(locationText(tyre)) + "</div>"
  	        + "<div class=\"ctm-muted\">" + escapeHtml(locationSubText(tyre)) + "</div>";
  	      }

  	      if (tyreStatus(tyre) === TYRE_STATUS.OK) {
  	        return "<span class=\"ctm-small\" style=\"color:#a7d8aa;font-weight:750;\">Warehouse</span>";
  	      }

  	      return "<span class=\"ctm-muted\">Not fitted</span>";
  	    }

  	    function listHtml() {
  	      var tyres = filteredTyres();
  	      var tyreWarehouseGrid = "96px minmax(230px,2.1fr) minmax(120px,.82fr) minmax(120px,.82fr) minmax(80px,.65fr) minmax(80px,.65fr) minmax(130px,.9fr) minmax(150px,1.1fr) minmax(160px,1fr)";

  	      if (!companies.length) {
  	        return "<div class=\"ctm-empty\">No accessible companies were found.</div>";
  	      }

  	      if (!tyres.length) {
  	        return "<div class=\"ctm-empty\">No tyres match the current filters.</div>";
  	      }

  	      return ""
  	      + "<div class=\"ctm-list-head\" style=\"grid-template-columns:" + tyreWarehouseGrid + " !important;\">"
  	      + "  <div></div>"
  	      + "  <div>" + sortHeaderHtml("tyre", "Tyre") + "</div>"
  	      + "  <div class=\"ctm-col-remaining-mileage\" data-tyre-counter-column=\"mileage\">" + sortHeaderHtml("remainingMileage", "Remaining Mileage") + "</div>"
  	      + "  <div class=\"ctm-col-remaining-hours\" data-tyre-counter-column=\"hours\">" + sortHeaderHtml("remainingHours", "Remaining Hours") + "</div>"
  	      + "  <div>" + sortHeaderHtml("type", "Type") + "</div>"
  	      + "  <div>" + sortHeaderHtml("stage", "Stage") + "</div>"
  	      + "  <div>" + sortHeaderHtml("status", "Status") + "</div>"
  	      + "  <div>" + sortHeaderHtml("warning", "Warning") + "</div>"
  	      + "  <div>" + sortHeaderHtml("location", "Location") + "</div>"
  	      + "</div>"
  	      + "<div class=\"ctm-list\">"
  	      + tyres.map(function (tyre) {
  	        var id = tyreObjectId(tyre);

  	        return ""
  	        + "<div class=\"ctm-row\" data-row-id=\"" + escapeHtml(id) + "\" title=\"Click to open tyre details\" style=\"grid-template-columns:" + tyreWarehouseGrid + " !important;\">"
  	        + "  <div>" + tyreGraphicHtml(tyre, "row") + "</div>"
  	        + "  <div>"
  	        + "    <div class=\"ctm-fleet\">" + escapeHtml(tyreNumber(tyre) || id || "Unsaved tyre") + "</div>"
  	        + "    <div class=\"ctm-desc\">" + escapeHtml([tyreMake(tyre), tyreModel(tyre), tyreSize(tyre)].filter(Boolean).join(" - ") || "No make/model/size") + "</div>"
  	        + "  </div>"
  	        + "  <div class=\"ctm-small ctm-col-remaining-mileage\" data-tyre-counter-column=\"mileage\" style=\"font-weight:850;color:#eee;\">" + escapeHtml(tyreRemainingMileageVisual(tyre)) + "</div>"
  	        + "  <div class=\"ctm-small ctm-col-remaining-hours\" data-tyre-counter-column=\"hours\" style=\"font-weight:850;color:#eee;\">" + escapeHtml(tyreRemainingHoursVisual(tyre)) + "</div>"
  	        + "  <div class=\"ctm-small\">" + escapeHtml(tyreType(tyre) || "—") + "</div>"
  	        + "  <div class=\"ctm-small\" style=\"font-weight:750;color:#eee;\">" + escapeHtml(tyreStage(tyre)) + "</div>"
  	        + "  <div>" + statusBadgeHtml(tyre) + "</div>"
  	        + "  <div>" + mileageWarningHtml(tyre) + "</div>"
  	        + "  <div>" + locationHtml(tyre) + "</div>"
  	        + "</div>";
  	      }).join("")
  	      + "</div>";
  	    }

  	    function updateListOnly() {
  	      var mount = DocumentSafe.getElementById("ctmListMount");

  	      if (mount) {
  	        mount.innerHTML = listHtml();
  	      }
  	    }

  	    function tyreDetailMode() {
  	      return clean(state.modal && state.modal.mode);
  	    }

  	    function tyreDetailFactHtml(label, value, help) {
  	      return ""
  	      + "<div class=\"ctm-tyre-readonly-field\">"
  	      + "  <span>" + escapeHtml(label) + "</span>"
  	      + "  <strong>" + escapeHtml(clean(value) || "Not recorded") + "</strong>"
  	      + (help ? "  <small>" + escapeHtml(help) + "</small>" : "")
  	      + "</div>";
  	    }

  	    function tyreModalSnapshot() {
  	      if (!modalPortalEl || !modalPortalEl.querySelectorAll) return "";
  	      var values = [];
  	      var controls = modalPortalEl.querySelectorAll("input,select,textarea");
  	      var i;
  	      for (i = 0; i < controls.length; i++) {
  	        var control = controls[i];
  	        var type = clean(control.type).toLowerCase();
  	        if (control.disabled || ["button", "submit", "reset", "hidden", "file"].indexOf(type) !== -1) continue;
  	        values.push(
  	          clean(control.id || control.name || ("control-" + i)) +
  	          "=" +
  	          ((type === "checkbox" || type === "radio")
  	            ? (control.checked ? "1" : "0")
  	            : String(control.value == null ? "" : control.value))
  	        );
  	      }
  	      return values.join("\u001e");
  	    }

  	    function tyreModalSaveButtons() {
  	      if (!modalPortalEl) return [];
  	      return [
  	        DocumentSafe.getElementById("ctmSaveEditTyre"),
  	        DocumentSafe.getElementById("ctmSaveTyreInspection"),
  	        DocumentSafe.getElementById("ctmSaveTyreNote")
  	      ].filter(Boolean);
  	    }

  	    function setTyreModalDirty(dirty) {
  	      if (!state.modal) return;
  	      state.modal.dirty = !!dirty;
  	      tyreModalSaveButtons().forEach(function (button) {
  	        button.style.display = dirty ? "" : "none";
  	        button.setAttribute("aria-hidden", dirty ? "false" : "true");
  	      });
  	    }

  	    function refreshTyreModalDirty() {
  	      if (!state.modal || !state.modal.baseline) return false;
  	      var dirty = tyreModalSnapshot() !== state.modal.baseline;
  	      setTyreModalDirty(dirty);
  	      return dirty;
  	    }

  	    function installTyreModalDirtyGuard() {
  	      if (!state.modal || !modalPortalEl) return;
  	      state.modal.baseline = tyreModalSnapshot();
  	      state.modal.dirty = false;
  	      setTyreModalDirty(false);
  	      updateTyreExpectedMileagePreview();

  	      var mark = function () {
  	        refreshTyreModalDirty();
  	        updateTyreExpectedMileagePreview();
  	      };
  	      modalPortalEl.addEventListener("input", mark, true);
  	      modalPortalEl.addEventListener("change", mark, true);
  	    }

  	    function updateTyreExpectedMileagePreview() {
  	      var input = DocumentSafe.getElementById("ctmRemainingKm");
  	      var preview = DocumentSafe.getElementById("ctmExpectedMileagePreview");
  	      var equation = DocumentSafe.getElementById("ctmExpectedMileageEquation");
  	      var tyre;
  	      var current;
  	      var expectedRemaining;
  	      var expectedTotal;
  	      var counterName;

  	      if (!input || !preview) return;

  	      tyre = findTyreById(state.modal && state.modal.tyreId);
  	      current = numberOrNull(tyre && tyre.Current_Mileage);
  	      expectedRemaining = numberOrNull(input.value);
  	      counterName = tyreCounterName(tyre);

  	      if (current === null || expectedRemaining === null || expectedRemaining < 0) {
  	        preview.textContent = "Enter expected remaining " + counterName.toLowerCase();
  	        if (equation) equation.textContent = "Current " + counterName + " + Expected Remaining " + counterName;
  	        return;
  	      }

  	      expectedTotal = current + expectedRemaining;
  	      preview.textContent = formatTyreCounter(expectedTotal, tyre);

  	      if (equation) {
  	        equation.textContent =
  	          formatTyreCounter(current, tyre) +
  	          " + " +
  	          formatTyreCounter(expectedRemaining, tyre) +
  	          " = " +
  	          formatTyreCounter(expectedTotal, tyre);
  	      }
  	    }

  	    async function requestClosePopup() {
  	      if (state.modal && state.modal.dirty) {
  	        var approved = await confirmSafeAsync(
  	          "There are unsaved tyre changes. Closing this window will discard them.",
  	          {
  	            title: "Discard Unsaved Tyre Changes?",
  	            confirmText: "Discard Changes",
  	            cancelText: "Keep Editing"
  	          }
  	        );
  	        if (!approved) return false;
  	      }
  	      closePopup();
  	      return true;
  	    }

  	    async function changeTyreDetailMode(mode) {
  	      if (!state.modal || state.modal.type !== "tyre") return;
  	      if (state.modal.dirty) {
  	        var approved = await confirmSafeAsync(
  	          "The current tyre action has unsaved changes. Switching actions will discard them.",
  	          {
  	            title: "Discard Current Tyre Changes?",
  	            confirmText: "Discard Changes",
  	            cancelText: "Keep Editing"
  	          }
  	        );
  	        if (!approved) return;
  	      }
  	      state.modal.mode = clean(mode);
  	      state.modal.dirty = false;
  	      state.modal.baseline = "";
  	      render();
  	    }

  	function modalShellHtml(title, innerHtml) {
  	      var showPrint = state.modal && state.modal.type === "tyre";
  	      var cardClass = showPrint ? "ctm-card ctm-tyre-detail-card" : "ctm-card";

  	      return ""
  	      + "<div class=\"ctm-modal\" id=\"ctmModal\">"
  	      + "  <div class=\"" + cardClass + "\" id=\"ctmModalCard\">"
  	      + "    <div class=\"ctm-card-head\">"
  	      + "      <div class=\"ctm-card-title\">" + escapeHtml(title) + "</div>"
  	      + "      <div class=\"ctm-card-head-actions\">"
  	      + (showPrint ? "        <button id=\"ctmPrintTyreReport\" type=\"button\" class=\"ctm-print-head-btn\"><span aria-hidden=\"true\">▣</span> Print Report</button>" : "")
  	      + "        <button id=\"ctmModalClose\" type=\"button\" class=\"ctm-btn-dark\" aria-label=\"Close\">✕</button>"
  	      + "      </div>"
  	      + "    </div>"
  	      + "    <div class=\"ctm-card-body\">"
  	      + innerHtml
  	      + "    </div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function tyreDetailActionsHtml(tyre) {
  	      var status = tyreStatus(tyre);
  	      var stage = tyreStage(tyre);
  	      var next = nextStage(stage);
  	      var fitted = tyreIsFitted(tyre);
  	      var actions = [];

  	      if (!AllowEditing) {
  	        return "<div class=\"ctm-detail-notice ctm-view-only-note\"><strong>View only</strong><span>The Tyres permission is required to change this tyre.</span></div>";
  	      }

  	      actions.push(buttonHtml("ctmEditTyreRecord", "Correct Record", "ctm-btn-dark"));
  	      actions.push(buttonHtml("ctmRecordTyreInspection", "Set " + tyreCounterName(tyre) + " & Warning", "ctm-btn-orange"));
  	      actions.push(buttonHtml("ctmAddTyreNote", "Add Note", "ctm-btn-dark"));

  	      if (!fitted) {
  	        if (
  	          status !== TYRE_STATUS.RETREAD &&
  	          status !== TYRE_STATUS.SCRAPPED &&
  	          status !== TYRE_STATUS.STOLEN &&
  	          next
  	        ) actions.push(buttonHtml("ctmDetailSendRetread", "Send For Retread", "ctm-btn-orange"));

  	        if (status === TYRE_STATUS.RETREAD && next) {
  	          actions.push(buttonHtml("ctmDetailCompleteRetread", "Complete Retread → " + next, "ctm-btn-green"));
  	        }

  	        if (status !== TYRE_STATUS.SCRAPPED && status !== TYRE_STATUS.STOLEN) {
  	          actions.push(buttonHtml("ctmDetailScrap", "Scrap Tyre", "ctm-btn-red"));
  	        }
  	      }

  	      return ""
  	      + (fitted
  	        ? "<div class=\"ctm-detail-notice\"><strong>Tyre currently fitted</strong><span>Status, stage, location, position and counter reading are controlled by vehicle and tyre workflows.</span></div>"
  	        : "")
  	      + "<div class=\"ctm-popup-actions ctm-detail-action-strip\">" + actions.join("") + "</div>";
  	    }

  	    function tyreDetailModalHtml() {
  	      var tyre = findTyreById(state.modal && state.modal.tyreId);
  	      var status;
  	      var stage;
  	      var remaining;
  	      var warningThresholdKm;
  	      var warningThresholdHours;
  	      var counterUnit;
  	      var counterName;
  	      var location;
  	      var position;
  	      var mode = tyreDetailMode();
  	      var content = "";
  	      var footer = "";

  	      if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	        return modalShellHtml("Tyre Details", "<div style=\"color:#d98f8f;\">You do not have access to this tyre.</div>");
  	      }

  	      status = tyreStatus(tyre);
  	      stage = tyreStage(tyre);
  	      remaining = tyreRemainingMileage(tyre);
  	      warningThresholdKm = tyreWarningThresholdKm(tyre);
  	      warningThresholdHours = tyreWarningThresholdHours(tyre);
  	      counterUnit = tyreCounterUnit(tyre);
  	      counterName = counterUnit === "h" ? "Hours" : "Mileage";
  	      location = tyreIsFitted(tyre)
  	        ? clean(tyre.Vehicle_ID) || "Fitted vehicle"
  	        : status === TYRE_STATUS.OK ? "Warehouse" : "Not fitted";
  	      position = tyreIsFitted(tyre) ? clean(tyre.Current_Position) : "";

  	      if (mode === "correction") {
  	        content += ""
  	        + "<section class=\"ctm-detail-section ctm-tyre-action-editor\">"
  	        + "  <header class=\"ctm-detail-section-head\"><div><strong>Correct Tyre Record</strong><span>Only specification errors may be corrected. Fleet number, status, stage, counter reading and allocation remain locked.</span></div></header>"
  	        + "  <div class=\"ctm-detail-form-grid ctm-detail-form-grid-spec\">"
  	        + tyreDetailFactHtml("Company Fleet Number", tyreNumber(tyre), "Permanent identity")
  	        + fieldHtml("ctmEditSerial", "Serial Number", tyreSerial(tyre), "Can be added or corrected")
  	        + fieldHtml("ctmEditMake", "Make", tyreMake(tyre), "Bridgestone")
  	        + fieldHtml("ctmEditModel", "Model / Pattern", tyreModel(tyre), "Dueler A/T 697")
  	        + fieldHtml("ctmEditSize", "Size", tyreSize(tyre), "225/75R17")
  	        + selectHtml("ctmEditType", "Type", TYPES, tyreType(tyre) || "Drive")
  	        + "  </div>"
  	        + "  <div class=\"ctm-detail-notes\">" + textareaHtml("ctmCorrectionReason", "Correction reason", "Explain exactly what was incorrect and why it is being corrected.", "") + "</div>"
  	        + "</section>";
  	        footer += buttonHtml("ctmCancelTyreAction", "Cancel Correction", "ctm-btn-muted");
  	        footer += buttonHtml("ctmSaveEditTyre", "Save Correction", "ctm-btn-main", "style=\"display:none;\"");
  	      } else if (mode === "inspection") {
  	        content += ""
  	        + "<section class=\"ctm-detail-section ctm-tyre-action-editor\">"
  	        + "  <header class=\"ctm-detail-section-head\"><div><strong>Set Tyre Life & Warning</strong><span>Warning thresholds and the inspection note are optional. Leave either warning threshold blank when no warning is required.</span></div></header>"
  	        + "  <div class=\"ctm-detail-form-grid ctm-detail-form-grid-life\">"
  	        + tyreDetailFactHtml("Current Stage " + counterName, formatTyreCounter(tyre.Current_Mileage, tyre), "Updated through the vehicle's operational counter")
  	        + fieldHtml("ctmRemainingKm", "Expected Remaining " + counterName, remaining === null ? "" : String(Math.round(remaining)), counterUnit === "h" ? "Operating hours expected to remain" : "Kilometers expected to remain", "number")
  	        + fieldHtml("ctmWarningThresholdKm", "Warning Threshold (km) — Optional", warningThresholdKm === null ? "" : String(Math.round(warningThresholdKm)), "Leave blank for no kilometre warning", "number")
  	        + fieldHtml("ctmWarningThresholdHours", "Warning Threshold (hours) — Optional", warningThresholdHours === null ? "" : String(Math.round(warningThresholdHours)), "Leave blank for no hour warning", "number")
  	        + "<div class=\"ctm-tyre-readonly-field ctm-expected-mileage-preview\">"
  	        + "  <span>Expected " + counterName + "</span>"
  	        + "  <strong id=\"ctmExpectedMileagePreview\">" + escapeHtml(formatTyreCounter(tyre.Expected_Mileage, tyre)) + "</strong>"
  	        + "  <small id=\"ctmExpectedMileageEquation\">Current reading + expected remaining reading</small>"
  	        + "</div>"
  	        + "  </div>"
  	        + "  <div class=\"ctm-detail-notes\">" + textareaHtml("ctmInspectionNotes", "Inspection note — Optional", "Optional: tread condition, damage, pressure, wear pattern or reason for the estimate.", "") + "</div>"
  	        + "</section>";
  	        footer += buttonHtml("ctmCancelTyreAction", "Cancel", "ctm-btn-muted");
  	        footer += buttonHtml("ctmSaveTyreInspection", "Save Tyre Life & Warning", "ctm-btn-main", "style=\"display:none;\"");
  	      } else if (mode === "note") {
  	        content += ""
  	        + "<section class=\"ctm-detail-section ctm-tyre-action-editor\">"
  	        + "  <header class=\"ctm-detail-section-head\"><div><strong>Add Permanent Tyre Note</strong><span>Existing history cannot be edited or deleted.</span></div></header>"
  	        + "  <div class=\"ctm-detail-notes\">" + textareaHtml("ctmPermanentTyreNote", "New note", "Add the new permanent note.", "") + "</div>"
  	        + "</section>";
  	        footer += buttonHtml("ctmCancelTyreAction", "Cancel Note", "ctm-btn-muted");
  	        footer += buttonHtml("ctmSaveTyreNote", "Add Permanent Note", "ctm-btn-main", "style=\"display:none;\"");
  	      }

  	      return modalShellHtml("Tyre Details", ""
  	        + "<div class=\"ctm-tyre-detail-content\">"
  	        + "  <section class=\"ctm-tyre-detail-hero\">"
  	        + "    <div class=\"ctm-tyre-hero-identity\">"
  	        + tyreGraphicHtml(tyre, "large")
  	        + "      <div class=\"ctm-tyre-hero-copy\">"
  	        + "        <span>Company tyre</span>"
  	        + "        <h2>" + escapeHtml(tyreNumber(tyre) || tyreObjectId(tyre)) + "</h2>"
  	        + "        <p>" + escapeHtml([tyreMake(tyre), tyreModel(tyre), tyreSize(tyre), tyreType(tyre)].filter(Boolean).join(" · ") || "No tyre specification") + "</p>"
  	        + "        <div class=\"ctm-tyre-hero-badges\">" + statusBadgeHtml(tyre)
  	        + "          <span class=\"ctm-badge ctm-stage-badge\">" + escapeHtml(stage) + "</span>"
  	        + "        </div>"
  	        + "      </div>"
  	        + "    </div>"
  	        + "    <div class=\"ctm-tyre-hero-metrics\">"
  	        + "      <article><span>Current life</span><strong>" + escapeHtml(tyreLifeText(tyre)) + "</strong></article>"
  	        + "      <article><span>Stage " + escapeHtml(counterName) + "</span><strong>" + escapeHtml(formatTyreCounter(tyre.Current_Mileage, tyre)) + "</strong></article>"
  	        + "      <article><span>Remaining " + escapeHtml(counterName) + "</span><strong>" + escapeHtml(remaining === null ? "Not set" : formatTyreCounter(remaining, tyre)) + "</strong></article>"
  	        + "      <article><span>Current location</span><strong>" + escapeHtml(location + (position ? " · " + position : "")) + "</strong></article>"
  	        + "    </div>"
  	        + "  </section>"
  	        + tyreDetailActionsHtml(tyre)
  	        + content
  	        + "  <section class=\"ctm-detail-section\">"
  	        + "    <header class=\"ctm-detail-section-head\"><div><strong>Tyre Record</strong><span>Identity and specification are read only until Correct Record is selected.</span></div></header>"
  	        + "    <div class=\"ctm-detail-facts ctm-tyre-record-facts\">"
  	        + tyreDetailFactHtml("Company Fleet Number", tyreNumber(tyre), "Permanent")
  	        + tyreDetailFactHtml("Serial Number", tyreSerial(tyre), "")
  	        + tyreDetailFactHtml("Make", tyreMake(tyre), "")
  	        + tyreDetailFactHtml("Model / Pattern", tyreModel(tyre), "")
  	        + tyreDetailFactHtml("Size", tyreSize(tyre), "")
  	        + tyreDetailFactHtml("Type", tyreType(tyre), "")
  	        + "    </div>"
  	        + "  </section>"
  	        + transactionPanelHtml()
  	        + "  <section class=\"ctm-detail-section ctm-current-record-section\">"
  	        + "    <header class=\"ctm-detail-section-head\"><div><strong>Controlled Lifecycle</strong><span>These values change only through allocation, counter updates, inspection, retread and scrap workflows.</span></div></header>"
  	        + "    <div class=\"ctm-detail-facts\">"
  	        + tyreDetailFactHtml("Company", clean(tyre.__CompanyName) || "Unassigned", "")
  	        + tyreDetailFactHtml("Location", location, "")
  	        + tyreDetailFactHtml("Position", position || "Not allocated", "")
  	        + tyreDetailFactHtml("Status", status, "")
  	        + tyreDetailFactHtml("Lifecycle Stage", stage, "")
  	        + tyreDetailFactHtml("Current " + counterName, formatTyreCounter(tyre.Current_Mileage, tyre), "System controlled")
  	        + tyreDetailFactHtml("Expected Remaining " + counterName, remaining === null ? "Not set" : formatTyreCounter(remaining, tyre), "The estimated operational life still available")
  	        + tyreDetailFactHtml("Warning Threshold (km)", warningThresholdKm === null ? "Not set" : formatMileage(warningThresholdKm), "Used on kilometer vehicles")
  	        + tyreDetailFactHtml("Warning Threshold (hours)", warningThresholdHours === null ? "Not set" : formatHours(warningThresholdHours), "Used on hour vehicles")
  	        + tyreDetailFactHtml("Expected " + counterName, formatTyreCounter(tyre.Expected_Mileage, tyre), "Current reading + expected remaining reading")
  	        + tyreDetailFactHtml("Object ID", tyreObjectId(tyre), "Database identity")
  	        + "    </div>"
  	        + "  </section>"
  	        + tyreHistoryTableHtml(tyre)
  	        + "  <div class=\"ctm-bottom-actions ctm-tyre-detail-footer\">"
  	        + footer
  	        + buttonHtml("ctmCancelModal", "Close", "ctm-btn-muted")
  	        + "  </div>"
  	        + "</div>"
  	      );
  	    }

  	    function newTyresModalHtml() {
  	      var seed = state.bulkSeed || latestFleetSeed();
  	      var prefix = state.bulkPrefix || seed.prefix || DEFAULT_FLEET_PREFIX;
  	      var count = Math.max(1, Math.min(500, Number(state.bulkCount) || 1));
  	      var start = Math.max(1, Number(state.bulkStart) || nextAvailableFleetSequence(prefix, count, seed.nextNumber || 1));
  	      var availability = bulkAvailability(prefix, start, count);
  	      var ids = availability.ids;
  	      var previewText = ids.length <= 8
  	        ? ids.join(", ")
  	        : ids.slice(0, 4).join(", ") + " … " + ids.slice(-2).join(", ");
  	      var continuationText = seed.lastNumber
  	        ? "Continuing after " + seed.lastNumber
  	        : "No existing company tyre number was found. Starting a new sequence.";

  	      return modalShellHtml("New Tyres", ""
  	        + "<div class=\"ctm-new-tyres-form\">"
  	        + "  <div class=\"ctm-new-tyres-intro\">"
  	        + "    <div><strong>Company tyre numbering</strong><span>" + escapeHtml(continuationText) + " The proposed range may be changed, but every number must be free.</span></div>"
  	        + "    <b id=\"ctmBulkSeedLabel\">" + escapeHtml(formatFleetNumber(prefix, start)) + "</b>"
  	        + "  </div>"

  	        + "  <section class=\"ctm-new-tyres-section\">"
  	        + "    <header><strong>Fleet numbering</strong><span>Prefix comes from the latest company tyre. The start number is the next free contiguous number for the requested quantity.</span></header>"
  	        + "    <div class=\"ctm-new-tyres-grid\">"
  	        + fieldHtml("ctmBulkPrefix", "Fleet Prefix", prefix, "FLE TY")
  	        + fieldHtml("ctmBulkStart", "Start Number", String(start), "Next available", "number")
  	        + fieldHtml("ctmBulkCount", "Quantity", String(count), "1", "number")
  	        + "    </div>"
  	        + "    <div class=\"ctm-next-number-row\"><span id=\"ctmBulkSuggestion\">Next available range begins at " + escapeHtml(formatFleetNumber(prefix, availability.nextAvailableStart)) + ".</span>"
  	        + buttonHtml("ctmUseNextAvailable", "Use Next Available", "ctm-btn-dark")
  	        + "    </div>"
  	        + "  </section>"

  	        + "  <section class=\"ctm-new-tyres-section\">"
  	        + "    <header><strong>Tyre specification</strong><span>Core identification used throughout fitting, lifecycle and reporting.</span></header>"
  	        + "    <div class=\"ctm-new-tyres-grid spec\">"
  	        + selectHtml("ctmBulkType", "Type", TYPES, "Drive")
  	        + fieldHtml("ctmBulkMake", "Make", "", "Dunlop")
  	        + fieldHtml("ctmBulkModel", "Model / Pattern", "", "SP 700")
  	        + fieldHtml("ctmBulkSize", "Size", "", "225 80 R20")
  	        + fieldHtml("ctmBulkWarningThresholdKm", "Warning Threshold (km)", "", "Required", "number")
  	        + fieldHtml("ctmBulkWarningThresholdHours", "Warning Threshold (hours)", "", "Required", "number")
  	        + "    </div>"
  	        + "  </section>"

  	        + "  <section class=\"ctm-new-tyres-section\">"
  	        + "    <header><strong>Purchase and serial detail</strong><span>Cost is stored on the tyre work record. Serial numbers may still be completed later.</span></header>"
  	        + "    <div class=\"ctm-new-tyres-grid purchase\">"
  	        + fieldHtml("ctmBulkCost", "Cost Per Tyre", "", "Required", "number")
  	        + fieldHtml("ctmBulkPurchaseRef", "Purchase Ref / Invoice", "", "Optional")
  	        + fieldHtml("ctmBulkSerialPrefix", "Optional Serial Prefix", "", "Leave blank")
  	        + "    </div>"
  	        + "    <div class=\"ctm-new-tyres-notes\">"
  	        + textareaHtml("ctmBulkNotes", "Notes", "Serial numbers can be added later.", "Serial numbers can be added later.")
  	        + "    </div>"
  	        + "  </section>"

  	        + "  <div class=\"ctm-numbering-preview\">"
  	        + "    <div><strong>Fleet number preview</strong><p id=\"ctmBulkPreview\">" + escapeHtml(previewText) + "</p></div>"
  	        + "    <div id=\"ctmBulkAvailability\" class=\"ctm-number-status" + (availability.available ? "" : " bad") + "\">"
  	        + (availability.available ? "Range Available" : availability.duplicates.length + " Number" + (availability.duplicates.length === 1 ? "" : "s") + " Already Used")
  	        + "    </div>"
  	        + "  </div>"
  	        + "</div>"

  	        + "<div class=\"ctm-bottom-actions\">"
  	        + buttonHtml("ctmCancelModal", "Cancel", "ctm-btn-muted")
  	        + buttonHtml("ctmConfirmBulkCreate", "Create Tyres", "ctm-btn-green", availability.available ? "" : "disabled")
  	        + "</div>"
  	      );
  	    }

  	    function modalHtml() {
  	      if (!state.modal) {
  	        return "";
  	      }

  	      if (state.modal.type === "new") {
  	        return newTyresModalHtml();
  	      }

  	      if (state.modal.type === "tyre") {
  	        return tyreDetailModalHtml();
  	      }

  	      return "";
  	    }

  	    function render() {
  	      var c = counts();

  	      hubEl = createOwnRootDiv();

  	      var modalMarkup = modalHtml();

  	      hubEl.innerHTML = cssHtml()
  	      + "<div class=\"ctm-panel\" id=\"ctmPanel\">"
  	      + "  <div class=\"ctm-main-head-actions\">"
  	      + "    <button id=\"ctmPrintWarehouseReport\" type=\"button\" class=\"ctm-print-head-btn\">🖨 Print</button>"
  	      + (HideClose ? "": "    <button id=\"ctmCloseX\" type=\"button\" class=\"ctm-close-main\">×</button>")
  	      + "  </div>"
  	      + "  <div class=\"ctm-wrap\">"
  	      + "    <div class=\"ctm-head\">"
  	      + "      <div>"
  	      + "        <div class=\"ctm-title\">" + escapeHtml(ManagerTitle) + "</div>"
  	      + "      </div>"
  	      + "      <div class=\"ctm-message\" style=\"color:" + (state.messageError ? "#d98f8f": "#a7d8aa") + ";\">"
  	      + escapeHtml(state.busy ? "Working...": state.message)
  	      + "      </div>"
  	      + "    </div>"
  	      + companySelectHtml()
  	      + "    <div class=\"ctm-stats\">"
  	      + statPillHtml("Total", c.total)
  	      + statPillHtml("Warehouse", c.warehouse)
  	      + statPillHtml("Fitted", c.fitted)
  	      + statPillHtml("Retread", c.retread)
  	      + statPillHtml("Scrapped", c.scrapped)
  	      + statPillHtml("New", c.newStage)
  	      + statPillHtml("Cap1", c.cap1)
  	      + statPillHtml("Cap2", c.cap2)
  	      + statPillHtml("Cap3", c.cap3)
  	      + "    </div>"
  	      + filtersHtml()
  	      + "    <div id=\"ctmListMount\">"
  	      + listHtml()
  	      + "    </div>"
  	      + "  </div>"
  	      + "</div>";

  	      mountModalPortal(modalMarkup);
  	      wireEvents();
  	      installTyreModalDirtyGuard();

  	      if (!AllowEditing && state.modal && state.modal.type === "tyre") {
  	        var modalBody = DocumentSafe.querySelector("#" + MODAL_PORTAL_ID + " .ctm-card-body");
  	        if (modalBody) {
  	          Array.prototype.forEach.call(modalBody.querySelectorAll("input,select,textarea"), function (field) {
  	            field.disabled = true;
  	          });
  	        }
  	      }

  	      if (typeof rawArgs.OnRendered === "function") {
  	        try {
  	          rawArgs.OnRendered(hubEl);
  	          if (modalPortalEl) rawArgs.OnRendered(modalPortalEl);
  	        } catch (error) {

  	        }
  	      }
  	    }

  	    function setMessage(message, isError) {
  	      state.message = message || "";
  	      state.messageError = !!isError;
  	    }

  	    function beginSave() {
  	      state.busy = true;
  	      setMessage("Saving...", false);
  	      render();
  	    }

  	    function finishSave(message) {
  	      state.busy = false;
  	      state.modal = null;
  	      setMessage(message, false);
  	      render();
  	    }

  	    function failSave(error) {
  	      state.busy = false;
  	      setMessage(error && error.message ? error.message: "Save failed.", true);
  	      render();
  	    }

  	    async function createNewTyresFromModal() {
  	      if (!requireEditing()) return;
  	      var prefix = normaliseFleetPrefix(readValue("ctmBulkPrefix") || DEFAULT_FLEET_PREFIX);
  	      var start = Math.max(1, Number(readValue("ctmBulkStart")) || nextFleetSequence(prefix));
  	      var count = Math.max(1, Math.min(500, Number(readValue("ctmBulkCount")) || 1));
  	      var cost = numberOrNull(readValue("ctmBulkCost"));
  	      var warningThresholdKm = numberOrNull(readValue("ctmBulkWarningThresholdKm"));
  	      var warningThresholdHours = numberOrNull(readValue("ctmBulkWarningThresholdHours"));
  	      var make = readValue("ctmBulkMake");
  	      var model = readValue("ctmBulkModel");
  	      var size = readValue("ctmBulkSize");
  	      var type = readValue("ctmBulkType") || "Drive";
  	      var serialPrefix = readValue("ctmBulkSerialPrefix");
  	      var purchaseRef = readValue("ctmBulkPurchaseRef");
  	      var notes = readValue("ctmBulkNotes");
  	      var batchId = "NEW-TYRES-" + nowIso();
  	      var availability = bulkAvailability(prefix, start, count);
  	      var ids = availability.ids;
  	      var duplicateIds = availability.duplicates;
  	      var tyres = [];
  	      var company = selectedCompany();

  	      if (!company || !company.id) {
  	        alertSafe("Select a company before creating tyres.");
  	        return;
  	      }

  	      if (cost === null || cost <= 0) {
  	        alertSafe("Cost Per Tyre is required.");
  	        return;
  	      }

  	      if (warningThresholdKm === null || warningThresholdKm <= 0) {
  	        alertSafe("Warning Threshold (km) is required and must be greater than zero.");
  	        return;
  	      }

  	      if (warningThresholdHours === null || warningThresholdHours <= 0) {
  	        alertSafe("Warning Threshold (hours) is required and must be greater than zero.");
  	        return;
  	      }

  	      ids.forEach(function (id) {
  	        companyScopedTyres().forEach(function (existing) {
  	          if (
  	            clean(existing.ID) === id ||
  	            clean(existing.FID) === id ||
  	            clean(existing.Tyre_Number) === id ||
  	            clean(existing.TyreNumber) === id
  	          ) {
  	            duplicateIds.push(id);
  	          }
  	        });
  	      });

  	      if (duplicateIds.length) {
  	        alertSafe("These fleet numbers already exist in this company:\n\n" + duplicateIds.join(", "));
  	        return;
  	      }

  	      if (!make || !model || !size) {
  	        alertSafe("Enter Make, Model / Pattern, and Size.");
  	        return;
  	      }

  	      if (!(await confirmPrompt("Create the new tyre records for this company?", {
  	        title: "Create New Tyres",
  	        type: "warning",
  	        confirmText: "Create Tyres",
  	        details: [{
  	          label: "Company", value: company.name
  	        },
  	          {
  	            label: "Quantity", value: String(count)
  	          },
  	          {
  	            label: "From", value: ids[0]
  	          },
  	          {
  	            label: "To", value: ids[ids.length - 1]
  	          },
  	          {
  	            label: "Cost Each", value: String(cost)
  	          },
  	          {
  	            label: "Kilometer Warning", value: formatMileage(warningThresholdKm)
  	          },
  	          {
  	            label: "Hour Warning", value: formatHours(warningThresholdHours)
  	          }]
  	      }))) {
  	        return;
  	      }

  	      ids.forEach(function (id, index) {
  	        var tyre = {};
  	        var serial = "";

  	        if (serialPrefix) {
  	          serial = serialPrefix + zeroPad(index + 1, DEFAULT_FLEET_PADDING);
  	        }

  	        tyre.ID = id;
  	        tyre.FID = id;
  	        tyre.Tyre_Number = id;
  	        tyre.Company_ID = company.id;
  	        tyre.Serial_Number = serial;
  	        tyre.Make = make;
  	        tyre.Model = model;
  	        tyre.Size = size;
  	        tyre.Type = type;
  	        tyre.Status = TYRE_STATUS.OK;
  	        tyre.Current_Stage = "New";

  	        clearVehicleFields(tyre);

  	        tyre.History = defaultHistory(tyre);
  	        tyre.History.Current.Warning_Threshold_KM = warningThresholdKm;
  	        tyre.History.Current.Warning_Threshold_Hours = warningThresholdHours;
  	        tyre = applyCostToCurrentStage(tyre, cost);
  	        tyre = appendHistoryEvent(tyre, tyreEvent("Created", {
  	          Notes: notes || "New tyre created. Serial number may be added later.",
  	          Destination: purchaseRef || "",
  	          Cost: cost,
  	          Bulk_Create_Count: count,
  	          Bulk_Create_Batch: batchId,
  	          Warning_Threshold_KM: warningThresholdKm,
  	          Warning_Threshold_Hours: warningThresholdHours
  	        }));

  	        tyre = stampCompanyMeta(tyre, company);

  	        tyres.push(tyre);
  	      });

  	      state.bulkPrefix = prefix;
  	      state.bulkStart = nextAvailableFleetSequence(prefix, count, start + count);
  	      state.bulkCount = count;
  	      state.bulkSeed = {
  	        prefix: prefix,
  	        lastNumber: ids[ids.length - 1],
  	        nextNumber: state.bulkStart
  	      };

  	      saveTyresSequentially(tyres,
  	        "Creating tyres")
  	      .then(function (savedTyres) {
  	        return Promise.all(savedTyres.map(function (savedTyre) {
  	          return emitFinancialEvent({
  	            Kind: "TyrePurchase", Company: company, Tyre: savedTyre, Cost: cost, Quantity: 1,
  	            ReferenceNumber: purchaseRef || "", Notes: notes || "New tyre purchase", BatchId: batchId,
  	            SourceKey: "Tyres:" + clean(savedTyre && savedTyre.objectId) + ":Purchase"
  	          });
  	        }));
  	      })
  	      .then(function () {
  	        finishSave("Created " + count + " tyre(s) and posted their purchases: " + ids[0] + " to " + ids[ids.length - 1] + ".");
  	      })
  	      .catch(failSave);
  	    }

  	    function saveEditedTyreFromModal() {
  	      if (!requireEditing()) return;
  	      var tyre = findTyreById(state.modal && state.modal.tyreId);
  	      var updated;
  	      var reason = readValue("ctmCorrectionReason");
  	      var company;
  	      var changes = [];

  	      if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	        alertSafe("You do not have access to this tyre.");
  	        return;
  	      }
  	      if (!reason) {
  	        alertSafe("A correction reason is required.");
  	        return;
  	      }

  	      updated = clone(tyre);
  	      [
  	        ["Serial_Number", "Serial Number", tyreSerial(tyre), readValue("ctmEditSerial")],
  	        ["Make", "Make", tyreMake(tyre), readValue("ctmEditMake")],
  	        ["Model", "Model / Pattern", tyreModel(tyre), readValue("ctmEditModel")],
  	        ["Size", "Size", tyreSize(tyre), readValue("ctmEditSize")],
  	        ["Type", "Type", tyreType(tyre), readValue("ctmEditType") || tyreType(tyre) || "Drive"]
  	      ].forEach(function (item) {
  	        if (clean(item[2]) === clean(item[3])) return;
  	        updated[item[0]] = item[3];
  	        changes.push(item[1] + ": " + (clean(item[2]) || "blank") + " → " + (clean(item[3]) || "blank"));
  	      });

  	      if (!changes.length) {
  	        alertSafe("No tyre specification has changed.");
  	        return;
  	      }

  	      updated = appendHistoryEvent(updated, tyreEvent("Record Corrected", {
  	        Notes: reason,
  	        Description: changes.join(" · ")
  	      }));

  	      company = { id: clean(tyre.__CompanyObjectId), name: clean(tyre.__CompanyName) };
  	      beginSave();
  	      saveTyre(updated, company)
  	      .then(function () { finishSave("Tyre record corrected."); })
  	      .catch(failSave);
  	    }

  	    function saveTyreInspectionFromModal() {
  	      if (!requireEditing()) return;
  	      var tyre = findTyreById(state.modal && state.modal.tyreId);
  	      var remaining = readValue("ctmRemainingKm");
  	      var warningThresholdKm = readValue("ctmWarningThresholdKm");
  	      var warningThresholdHours = readValue("ctmWarningThresholdHours");
  	      var notes = readValue("ctmInspectionNotes");
  	      var updated;
  	      var company;

  	      if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	        alertSafe("You do not have access to this tyre.");
  	        return;
  	      }
  	      if (remaining === "") {
  	        alertSafe("Expected Remaining Reading is required.");
  	        return;
  	      }
  	      try {
  	        updated = applyExpectedMileageFromRemaining(tyre, remaining, warningThresholdKm, warningThresholdHours, notes);
  	      } catch (error) {
  	        alertSafe(error && error.message ? error.message : "The tyre inspection could not be recorded.");
  	        return;
  	      }

  	      company = { id: clean(tyre.__CompanyObjectId), name: clean(tyre.__CompanyName) };
  	      beginSave();
  	      saveTyre(updated, company)
  	      .then(function () { finishSave("Tyre life updated. Optional warning thresholds saved when supplied."); })
  	      .catch(failSave);
  	    }

  	    function saveTyreNoteFromModal() {
  	      if (!requireEditing()) return;
  	      var tyre = findTyreById(state.modal && state.modal.tyreId);
  	      var note = readValue("ctmPermanentTyreNote");
  	      var updated;
  	      var company;

  	      if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	        alertSafe("You do not have access to this tyre.");
  	        return;
  	      }
  	      if (!note) {
  	        alertSafe("Enter the permanent tyre note.");
  	        return;
  	      }

  	      updated = appendHistoryEvent(clone(tyre), tyreEvent("Note Added", { Notes: note }));
  	      company = { id: clean(tyre.__CompanyObjectId), name: clean(tyre.__CompanyName) };
  	      beginSave();
  	      saveTyre(updated, company)
  	      .then(function () { finishSave("Tyre note added."); })
  	      .catch(failSave);
  	    }

  	    function sendTyreForRetreadById(tyreId) {
  	      if (!requireEditing()) return;
  	      var tyre = findTyreById(tyreId);
  	      var updated;
  	      var company;

  	      if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	        alertSafe("You do not have access to this tyre.");
  	        return;
  	      }

  	      if (tyreIsFitted(tyre)) {
  	        alertSafe("This tyre is still fitted to a vehicle. Remove it from the vehicle first.");
  	        return;
  	      }

  	      if (tyreStatus(tyre) === TYRE_STATUS.SCRAPPED || tyreStatus(tyre) === TYRE_STATUS.STOLEN) {
  	        alertSafe("This tyre cannot be sent for retread because it is " + tyreStatus(tyre) + ".");
  	        return;
  	      }

  	      if (!nextStage(tyreStage(tyre))) {
  	        alertSafe("This tyre is already at Cap3 and cannot advance further.");
  	        return;
  	      }

  	      company = {
  	        id: clean(tyre.__CompanyObjectId),
  	        name: clean(tyre.__CompanyName)
  	      };

  	      updated = clone(tyre);
  	      clearVehicleFields(updated);
  	      updated.Status = TYRE_STATUS.RETREAD;

  	      updated = appendHistoryEvent(updated, tyreEvent("Sent For Retread", {
  	        Destination: "Retread",
  	        Notes: "Tyre sent for retread.",
  	        Retread_From_Stage: tyreStage(updated),
  	        Retread_To_Stage: nextStage(tyreStage(updated))
  	      }));

  	      beginSave();

  	      saveTyre(updated, company)
  	      .then(function () {
  	        finishSave("Tyre sent for retread.");
  	      })
  	      .catch(failSave);
  	    }

  	    function completeTyreRetreadById(tyreId) {
  	      if (!requireEditing()) return;
  	      var tyre = findTyreById(tyreId);
  	      var updated;
  	      var fromStage;
  	      var toStage;
  	      var cost = numberOrNull(readValue("ctmActionCost"));
  	      var company;

  	      if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	        alertSafe("You do not have access to this tyre.");
  	        return;
  	      }

  	      if (cost === null || cost <= 0) {
  	        alertSafe("Action Cost is required before completing a retread.");
  	        return;
  	      }

  	      if (tyreIsFitted(tyre)) {
  	        alertSafe("This tyre is still fitted to a vehicle. Remove it from the vehicle first.");
  	        return;
  	      }

  	      fromStage = tyreStage(tyre);
  	      toStage = nextStage(fromStage);

  	      if (!toStage) {
  	        alertSafe("This tyre is already at Cap3 and cannot advance further.");
  	        return;
  	      }

  	      company = {
  	        id: clean(tyre.__CompanyObjectId),
  	        name: clean(tyre.__CompanyName)
  	      };

  	      updated = clone(tyre);
  	      clearVehicleFields(updated);
  	      updated.Status = TYRE_STATUS.OK;
  	      updated.Current_Stage = toStage;

  	      updated = advanceRetreadStage(updated, fromStage, toStage, tyreEvent("Retread Completed", {
  	        Notes: "Retread completed.",
  	        Cost: cost,
  	        Retread_From_Stage: fromStage,
  	        Retread_To_Stage: toStage,
  	        Retread_Cost: cost
  	      }), cost);

  	      beginSave();

  	      saveTyre(updated, company)
  	      .then(function (savedTyre) {
  	        return emitFinancialEvent({
  	          Kind: "TyreRetread", Company: company, Tyre: savedTyre, OriginalTyre: tyre, Cost: cost,
  	          TransactionType: "Retread", Notes: "Retread completed from " + fromStage + " to " + toStage,
  	          SourceKey: "Tyres:" + clean(savedTyre && savedTyre.objectId) + ":Retread:" + clean(toStage)
  	        });
  	      })
  	      .then(function () {
  	        finishSave("Retread completed, recorded, and advanced to " + toStage + ".");
  	      })
  	      .catch(failSave);
  	    }

  	    async function scrapTyreById(tyreId) {
  	      if (!requireEditing()) return;
  	      var tyre = findTyreById(tyreId);
  	      var updated;
  	      var company;

  	      if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	        alertSafe("You do not have access to this tyre.");
  	        return;
  	      }

  	      if (tyreIsFitted(tyre)) {
  	        alertSafe("This tyre is still fitted to a vehicle. Remove it from the vehicle first.");
  	        return;
  	      }

  	      if (!(await confirmPrompt("This tyre will be marked as scrapped and removed from available warehouse stock.", {
  	        title: "Scrap Tyre",
  	        type: "danger",
  	        confirmText: "Scrap Tyre",
  	        details: [{
  	          label: "Tyre", value: tyreName(tyre)
  	        }]
  	      }))) {
  	        return;
  	      }

  	      company = {
  	        id: clean(tyre.__CompanyObjectId),
  	        name: clean(tyre.__CompanyName)
  	      };

  	      updated = clone(tyre);
  	      clearVehicleFields(updated);
  	      updated.Status = TYRE_STATUS.SCRAPPED;

  	      updated = appendHistoryEvent(updated, tyreEvent("Scrapped", {
  	        Destination: "Scrapped",
  	        Notes: "Tyre scrapped.",
  	        Scrap_Reason: "Scrapped from company tyre manager."
  	      }));

  	      beginSave();

  	      saveTyre(updated, company)
  	      .then(function () {
  	        finishSave("Tyre scrapped.");
  	      })
  	      .catch(failSave);
  	    }

  	    function closeManager() {
  	      if (hubEl && hubEl.parentNode) {
  	        hubEl.parentNode.removeChild(hubEl);
  	      }
  	    }

  	    function closePopup() {
  	      state.modal = null;
  	      render();
  	    }

  	    function findTyreById(id) {
  	      var cleanId = clean(id);
  	      var i;

  	      for (i = 0; i < state.tyres.length; i++) {
  	        if (tyreObjectId(state.tyres[i]) === cleanId) {
  	          return state.tyres[i];
  	        }
  	      }

  	      return null;
  	    }

  	    function closestWithAttribute(node, attributeName) {
  	      while (node && node !== hubEl && node.nodeType === 1) {
  	        if (node.getAttribute && node.getAttribute(attributeName) !== null) {
  	          return node;
  	        }

  	        node = node.parentNode;
  	      }

  	      return null;
  	    }

  	    function updateNewTyresPreviewFromInputs() {
  	      var previewEl = DocumentSafe.getElementById("ctmBulkPreview");
  	      var statusEl = DocumentSafe.getElementById("ctmBulkAvailability");
  	      var suggestionEl = DocumentSafe.getElementById("ctmBulkSuggestion");
  	      var seedEl = DocumentSafe.getElementById("ctmBulkSeedLabel");
  	      var createButton = DocumentSafe.getElementById("ctmConfirmBulkCreate");
  	      var prefix = normaliseFleetPrefix(readValue("ctmBulkPrefix") || DEFAULT_FLEET_PREFIX);
  	      var start = Math.max(1, Number(readValue("ctmBulkStart")) || 1);
  	      var count = Math.max(1, Math.min(500, Number(readValue("ctmBulkCount")) || 1));
  	      var availability = bulkAvailability(prefix, start, count);
  	      var ids = availability.ids;
  	      var previewText = ids.length <= 8
  	        ? ids.join(", ")
  	        : ids.slice(0, 4).join(", ") + " … " + ids.slice(-2).join(", ");

  	      state.bulkPrefix = prefix;
  	      state.bulkStart = start;
  	      state.bulkCount = count;

  	      if (previewEl) previewEl.textContent = previewText;
  	      if (seedEl) seedEl.textContent = formatFleetNumber(prefix, start);
  	      if (suggestionEl) {
  	        suggestionEl.textContent = availability.available
  	          ? "This full range is available."
  	          : "Next free contiguous range begins at " + formatFleetNumber(prefix, availability.nextAvailableStart) + ".";
  	      }
  	      if (statusEl) {
  	        statusEl.className = "ctm-number-status" + (availability.available ? "" : " bad");
  	        statusEl.textContent = availability.available
  	          ? "Range Available"
  	          : availability.duplicates.length + " Number" + (availability.duplicates.length === 1 ? "" : "s") + " Already Used";
  	      }
  	      if (createButton) createButton.disabled = !availability.available;
  	    }

  	    function wireEvents() {
  	      var companyFilter = DocumentSafe.getElementById("ctmCompanyFilter");
  	      var search = DocumentSafe.getElementById("ctmSearch");
  	      var locationFilter = DocumentSafe.getElementById("ctmLocationFilter");
  	      var statusFilter = DocumentSafe.getElementById("ctmStatusFilter");
  	      var stageFilter = DocumentSafe.getElementById("ctmStageFilter");
  	      var typeFilter = DocumentSafe.getElementById("ctmTypeFilter");
  	      var bulkPrefixInput = DocumentSafe.getElementById("ctmBulkPrefix");
  	      var bulkStartInput = DocumentSafe.getElementById("ctmBulkStart");
  	      var bulkCountInput = DocumentSafe.getElementById("ctmBulkCount");
  	      var transactionTypeInput = DocumentSafe.getElementById("ctmTransactionType");
  	      var transactionCostInput = DocumentSafe.getElementById("ctmTransactionCost");

  	      if (companyFilter) {
  	        companyFilter.onchange = function () {
  	          state.companyId = companyFilter.value || "";
  	          render();
  	        };
  	      }

  	      if (search) {
  	        search.oninput = function () {
  	          state.search = search.value || "";
  	          updateListOnly();
  	        };
  	      }

  	      if (locationFilter) {
  	        locationFilter.onchange = function () {
  	          state.locationFilter = locationFilter.value || "All";
  	          updateListOnly();
  	        };
  	      }

  	      if (statusFilter) {
  	        statusFilter.onchange = function () {
  	          state.statusFilter = statusFilter.value || "All";
  	          updateListOnly();
  	        };
  	      }

  	      if (stageFilter) {
  	        stageFilter.onchange = function () {
  	          state.stageFilter = stageFilter.value || "All";
  	          updateListOnly();
  	        };
  	      }

  	      if (typeFilter) {
  	        typeFilter.onchange = function () {
  	          state.typeFilter = typeFilter.value || "All";
  	          updateListOnly();
  	        };
  	      }

  	      if (bulkPrefixInput) {
  	        bulkPrefixInput.oninput = function () {
  	          var prefix = normaliseFleetPrefix(bulkPrefixInput.value || DEFAULT_FLEET_PREFIX);
  	          var startEl = DocumentSafe.getElementById("ctmBulkStart");
  	          var count = Math.max(1, Math.min(500, Number(readValue("ctmBulkCount")) || 1));
  	          if (startEl) {
  	            startEl.value = String(nextAvailableFleetSequence(prefix, count, highestFleetSequence(prefix) + 1));
  	          }
  	          updateNewTyresPreviewFromInputs();
  	        };
  	      }

  	      if (bulkStartInput) {
  	        bulkStartInput.oninput = updateNewTyresPreviewFromInputs;
  	      }

  	      if (bulkCountInput) {
  	        bulkCountInput.oninput = updateNewTyresPreviewFromInputs;
  	      }

  	      if (transactionTypeInput) {
  	        transactionTypeInput.onchange = updateTransactionSaveVisibility;
  	        transactionTypeInput.oninput = updateTransactionSaveVisibility;
  	      }

  	      if (transactionCostInput) {
  	        transactionCostInput.oninput = updateTransactionSaveVisibility;
  	        transactionCostInput.onchange = updateTransactionSaveVisibility;
  	      }

  	      var clickHandler = function (event) {
  	        var target = event.target;
  	        var rowEl;
  	        var historyEl;
  	        var detailEl;
  	        var historyRows;
  	        var detailRows;
  	        var panel;
  	        var i;
  	        var id;

  	        if (target === hubEl && !state.modal) {
  	          closeManager();
  	          return;
  	        }

  	        if (target && target.getAttribute && target.getAttribute("data-sort-key")) {
  	          if (state.sortKey === target.getAttribute("data-sort-key")) {
  	            state.sortDir = state.sortDir === "asc" ? "desc": "asc";
  	          } else {
  	            state.sortKey = target.getAttribute("data-sort-key");
  	            state.sortDir = (state.sortKey === "remainingMileage" || state.sortKey === "remainingHours") ? "asc": "asc";
  	          }

  	          updateListOnly();
  	          return;
  	        }

  	        if (target && target.id === "ctmModal") {
  	          requestClosePopup();
  	          return;
  	        }

  	        if (target && target.id === "ctmCloseX") {
  	          closeManager();
  	          return;
  	        }

  	        if (target && target.id === "ctmNewTyresBtn") {
  	          openNewTyresModal();
  	          return;
  	        }

  	        if (target && target.id === "ctmUseNextAvailable") {
  	          var prefix = normaliseFleetPrefix(readValue("ctmBulkPrefix") || DEFAULT_FLEET_PREFIX);
  	          var count = Math.max(1, Math.min(500, Number(readValue("ctmBulkCount")) || 1));
  	          var currentStart = Math.max(1, Number(readValue("ctmBulkStart")) || 1);
  	          var startEl = DocumentSafe.getElementById("ctmBulkStart");
  	          if (startEl) {
  	            startEl.value = String(nextAvailableFleetSequence(prefix, count, currentStart));
  	          }
  	          updateNewTyresPreviewFromInputs();
  	          return;
  	        }

  	        if (target && target.id === "ctmRefreshBtn") {
  	          loadTyres();
  	          return;
  	        }

  	        if (target && target.id === "ctmPrintWarehouseReport") {
  	          printWarehouseWarningReport();
  	          return;
  	        }

  	        if (target && (target.id === "ctmModalClose" || target.id === "ctmCancelModal")) {
  	          requestClosePopup();
  	          return;
  	        }

  	        if (target && target.id === "ctmConfirmBulkCreate") {
  	          createNewTyresFromModal();
  	          return;
  	        }

  	        if (target && target.id === "ctmNewTransactionBtn") {
  	          panel = DocumentSafe.getElementById("ctmTransactionPanel");

  	          if (panel) {
  	            panel.style.display = "block";
  	          }

  	          target.style.display = "none";
  	          updateTransactionSaveVisibility();
  	          return;
  	        }

  	        if (target && target.id === "ctmSaveTransactionBtn") {
  	          saveTransactionFromModal();
  	          return;
  	        }

  	        historyEl = closestWithAttribute(target, "data-history-key");

  	        if (historyEl && state.modal && state.modal.type === "tyre") {
  	          id = historyEl.getAttribute("data-history-key");

  	          historyRows = DocumentSafe.querySelectorAll("#" + MODAL_PORTAL_ID + " .ctm-history-row");
  	          detailRows = DocumentSafe.querySelectorAll("#" + MODAL_PORTAL_ID + " .ctm-history-detail-row");

  	          for (i = 0; i < historyRows.length; i++) {
  	            historyRows[i].className = historyRows[i].className.replace(/\s?ctm-history-selected/g, "");
  	          }

  	          for (i = 0; i < detailRows.length; i++) {
  	            detailRows[i].style.display = "none";
  	          }

  	          historyEl.className += " ctm-history-selected";

  	          detailEl = DocumentSafe.getElementById("ctmHistoryDetail_" + id);

  	          if (detailEl) {
  	            detailEl.style.display = "";
  	          }

  	          return;
  	        }

  	        if (target && target.id === "ctmPrintTyreReport") {
  	          printSelectedTyreReport();
  	          return;
  	        }

  	        if (target && target.id === "ctmEditTyreRecord") {
  	          changeTyreDetailMode("correction");
  	          return;
  	        }
  	        if (target && target.id === "ctmRecordTyreInspection") {
  	          changeTyreDetailMode("inspection");
  	          return;
  	        }
  	        if (target && target.id === "ctmAddTyreNote") {
  	          changeTyreDetailMode("note");
  	          return;
  	        }
  	        if (target && target.id === "ctmCancelTyreAction") {
  	          changeTyreDetailMode("");
  	          return;
  	        }
  	        if (target && target.id === "ctmSaveEditTyre") {
  	          saveEditedTyreFromModal();
  	          return;
  	        }
  	        if (target && target.id === "ctmSaveTyreInspection") {
  	          saveTyreInspectionFromModal();
  	          return;
  	        }
  	        if (target && target.id === "ctmSaveTyreNote") {
  	          saveTyreNoteFromModal();
  	          return;
  	        }

  	        if (target && target.id === "ctmDetailSendRetread") {
  	          sendTyreForRetreadById(state.modal && state.modal.tyreId);
  	          return;
  	        }

  	        if (target && target.id === "ctmDetailCompleteRetread") {
  	          completeTyreRetreadById(state.modal && state.modal.tyreId);
  	          return;
  	        }

  	        if (target && target.id === "ctmDetailScrap") {
  	          scrapTyreById(state.modal && state.modal.tyreId);
  	          return;
  	        }

  	        rowEl = closestWithAttribute(target, "data-row-id");

  	        if (rowEl) {
  	          id = rowEl.getAttribute("data-row-id");

  	          if (id) {
  	            state.modal = {
  	              type: "tyre",
  	              tyreId: id,
  	              mode: "",
  	              dirty: false,
  	              baseline: ""
  	            };
  	            render();
  	          }
  	        }
  	      };

  	      hubEl.onclick = clickHandler;
  	      modalPortalEl = DocumentSafe.getElementById(MODAL_PORTAL_ID);
  	      if (modalPortalEl) modalPortalEl.onclick = clickHandler;
  	    }

  	    render();
  	    loadTyres();

  	    return {
  	      root: hubEl,
  	      refresh: loadTyres,
  	      getState: function () {
  	        return state;
  	      },
  	      hasUnsavedChanges: function () {
  	        return !!(state.modal && state.modal.dirty);
  	      },
  	      destroy: function () {
  	        try {
  	          if (hubEl) {
  	            hubEl.onclick = null;
  	            hubEl.oninput = null;
  	            hubEl.onchange = null;
  	            hubEl.innerHTML = "";
  	          }
  	          removeModalPortal();
  	        } catch (_) {}
  	      }
  	    };
  	  }

  	  const ROOT_ID = "fif-dashboard-layout-v3-root";
  	  const STYLE_ID = "fif-dashboard-layout-v3-style";
  	  const VEHICLE_STYLE_ID = "fif-dashboard-vehicle-manager-v3-style";
  	  const SERVICE_STYLE_ID = "fif-dashboard-service-portal-v1-style";
  	  const VERSION = "21.12.81";
  	  const TOP_OFFSET_PX = 50;

  	  function readArg(name, lowerName, index) {
  	    try {
  	      if (typeof ___arguments !== "undefined" && ___arguments) {
  	        if (___arguments[name] !== undefined) return ___arguments[name];
  	        if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	        if (___arguments[index] !== undefined) return ___arguments[index];
  	      }
  	    } catch (_) {}

  	    return undefined;
  	  }

  	  const APP_INPUT =
  	  (typeof App !== "undefined" ? App: undefined) ||
  	  readArg("App", "app", 0) ||
  	  null;

  	  const SVG_INPUT =
  	  (typeof SVG !== "undefined" ? SVG: undefined) ||
  	  readArg("SVG", "svg", 1) ||
  	  "";

  	  const BACKENDLESS_INPUT =
  	    (typeof Backendless !== "undefined" && Backendless ? Backendless : undefined) ||
  	    readArg("Backendless", "backendless", 2) ||
  	    (
  	      typeof globalThis !== "undefined" &&
  	      globalThis.Backendless
  	        ? globalThis.Backendless
  	        : undefined
  	    ) ||
  	    (
  	      typeof window !== "undefined" &&
  	      window.Backendless
  	        ? window.Backendless
  	        : undefined
  	    ) ||
  	    null;

  	  let fifTractorDebugSession = null;
  	  let fifTractorDebugCounter = 0;

  	  function fifDebugSensitiveKey(key) {
  	    return /token|authorization|password|secret|api[-_]?key|cookie/i.test(
  	      String(key || "")
  	    );
  	  }

  	  function fifDebugClone(value) {
  	    const seen = typeof WeakSet === "function" ? new WeakSet() : null;

  	    try {
  	      const json = JSON.stringify(value, function (key, current) {
  	        if (fifDebugSensitiveKey(key)) {
  	          return current ? "[MASKED]" : current;
  	        }

  	        if (typeof current === "bigint") {
  	          return String(current);
  	        }

  	        if (typeof current === "function") {
  	          return "[Function " + (current.name || "anonymous") + "]";
  	        }

  	        if (current && typeof current === "object" && seen) {
  	          if (seen.has(current)) return "[Circular]";
  	          seen.add(current);
  	        }

  	        return current;
  	      });

  	      return json === undefined ? undefined : JSON.parse(json);
  	    } catch (error) {
  	      return {
  	        debugCloneFailed: true,
  	        message: error && error.message ? error.message : String(error),
  	        valueType: typeof value
  	      };
  	    }
  	  }

  	  function fifDebugError(error) {
  	    if (!error) return null;

  	    return {
  	      name: error.name || "Error",
  	      message: error.message || String(error),
  	      stack: error.stack || "",
  	      code: error.code,
  	      status: error.status,
  	      faultCode: error.faultCode,
  	      faultString: error.faultString,
  	      raw: fifDebugClone(error)
  	    };
  	  }

  	  function fifDebugHeaders(headers) {
  	    const result = {};
  	    if (!headers) return result;

  	    Object.keys(headers).forEach(function (key) {
  	      result[key] = fifDebugSensitiveKey(key)
  	        ? (headers[key] ? "[PRESENT - MASKED]" : headers[key])
  	        : headers[key];
  	    });

  	    return result;
  	  }

  	  function fifDebugDescriptors(value) {
  	    const result = {};
  	    if (!value || typeof value !== "object") return result;

  	    Object.keys(value).forEach(function (key) {
  	      const descriptor = Object.getOwnPropertyDescriptor(value, key);
  	      const current = value[key];

  	      result[key] = {
  	        enumerable: !!(descriptor && descriptor.enumerable),
  	        writable:
  	          descriptor && Object.prototype.hasOwnProperty.call(descriptor, "writable")
  	            ? !!descriptor.writable
  	            : undefined,
  	        configurable: !!(descriptor && descriptor.configurable),
  	        type:
  	          Array.isArray(current)
  	            ? "array"
  	            : current === null
  	              ? "null"
  	              : typeof current,
  	        preview:
  	          current && typeof current === "object"
  	            ? (
  	                Array.isArray(current)
  	                  ? "[Array length " + String(current.length) + "]"
  	                  : "[Object keys " + String(Object.keys(current).length) + "]"
  	              )
  	            : current
  	      };
  	    });

  	    return result;
  	  }

  	  function fifDebugEssential(record) {
  	    const source = record && typeof record === "object" ? record : {};

  	    return {
  	      top: {
  	        objectId: source.objectId,
  	        ID: source.ID,
  	        FID: source.FID,
  	        Registration: source.Registration,
  	        color: source.color,
  	        LicenseExpiry: source.LicenseExpiry,
  	        Range: source.Range,
  	        CounterType: source.CounterType,
  	        SARSCompliance: source.SARSCompliance,
  	        SARSRate: source.SARSRate,
  	        CANTank: getDeep(source, ["CAN", "Tank"], undefined),
  	        updated: source.updated
  	      },
  	      nested: {
  	        FID: descriptorValue(getDeep(source, ["Data", "Vehicle", "Identity", "FID"], undefined)),
  	        Registration: descriptorValue(getDeep(source, ["Data", "Vehicle", "Identity", "Registration"], undefined)),
  	        color: descriptorValue(getDeep(source, ["Data", "Vehicle", "Appearance", "Color"], undefined)),
  	        LicenseExpiry: getDeep(source, ["Data", "Compliance", "Setup", "Requirements", "VehicleLicence", "ExpiryDate"], undefined),
  	        Range: descriptorValue(getDeep(source, ["Data", "Vehicle", "Usage", "Range"], undefined)),
  	        CounterType: descriptorValue(getDeep(source, ["Data", "Vehicle", "Usage", "CounterType"], undefined)),
  	        TankCapacity: descriptorValue(getDeep(source, ["Data", "FuelAndEnergy", "TankCapacityL"], undefined)),
  	        VehicleTankCapacity: descriptorValue(getDeep(source, ["Data", "Vehicle", "Tank_Capacity"], undefined)),
  	        AgriculturalTankCapacity: descriptorValue(getDeep(source, ["Data", "Agricultural", "FieldPerformance", "FuelTankCapacityL"], undefined)),
  	        SARSCompliance: descriptorValue(getDeep(source, ["Data", "FuelAndEnergy", "SARSCompliance"], undefined)),
  	        SARSRate: descriptorValue(getDeep(source, ["Data", "FuelAndEnergy", "SARSRate"], undefined))
  	      }
  	    };
  	  }

  	  function fifStartTractorDebug(context) {
  	    fifTractorDebugCounter += 1;

  	    fifTractorDebugSession = {
  	      id: "TRACTOR-SAVE-" + String(fifTractorDebugCounter) + "-" + String(Date.now()),
  	      build:
  	        typeof window !== "undefined"
  	          ? window.__FIF_DASHBOARD_BUILD__
  	          : "",
  	      startedAt: new Date().toISOString(),
  	      page:
  	        typeof window !== "undefined" && window.location
  	          ? {
  	              href: window.location.href,
  	              origin: window.location.origin,
  	              pathname: window.location.pathname
  	            }
  	          : null,
  	      context: fifDebugClone(context || {}),
  	      stages: []
  	    };

  	    if (typeof window !== "undefined") {
  	      window.__FIF_LAST_TRACTOR_SAVE_DEBUG__ = fifTractorDebugSession;
  	    }

  	    return fifTractorDebugSession;
  	  }

  	  function fifEnsureTractorDebug(context) {
  	    return fifTractorDebugSession || fifStartTractorDebug(context || {});
  	  }

  	  function fifTractorLog(label, data, level) {
  	    const session = fifEnsureTractorDebug();
  	    const entry = {
  	      number: session.stages.length + 1,
  	      at: new Date().toISOString(),
  	      label: String(label || "Unnamed stage"),
  	      data: fifDebugClone(data)
  	    };

  	    session.stages.push(entry);

  	    if (typeof window !== "undefined") {
  	      window.__FIF_LAST_TRACTOR_SAVE_DEBUG__ = session;
  	    }

  	    const method =
  	      level === "error"
  	        ? "error"
  	        : level === "warn"
  	          ? "warn"
  	          : "log";

  	    return entry;
  	  }

  	  function fifTractorTable(label, rows) {
  	    fifTractorLog(label, rows);

  	    try {

  	    } catch (_) {}
  	  }

  	  function fifFinishTractorDebug(status, data) {
  	    const session = fifEnsureTractorDebug();
  	    session.status = String(status || "complete");
  	    session.completedAt = new Date().toISOString();
  	    session.result = fifDebugClone(data);

  	    if (typeof window !== "undefined") {
  	      window.__FIF_LAST_TRACTOR_SAVE_DEBUG__ = session;
  	    }

  	    fifTractorLog(
  	      "SESSION " + session.status.toUpperCase(),
  	      data,
  	      session.status === "failed" ? "error" : "log"
  	    );

  	    return session;
  	  }

  	  if (typeof window !== "undefined") {
  	    window.FIF_DUMP_LAST_TRACTOR_SAVE_DEBUG = function () {
  	      const snapshot = fifDebugClone(window.__FIF_LAST_TRACTOR_SAVE_DEBUG__);

  	      return snapshot;
  	    };

  	    window.FIF_COPY_LAST_TRACTOR_SAVE_DEBUG = async function () {
  	      const json = JSON.stringify(
  	        fifDebugClone(window.__FIF_LAST_TRACTOR_SAVE_DEBUG__),
  	        null,
  	        2
  	      );

  	      if (
  	        typeof navigator !== "undefined" &&
  	        navigator.clipboard &&
  	        typeof navigator.clipboard.writeText === "function"
  	      ) {
  	        await navigator.clipboard.writeText(json);

  	        return true;
  	      }

  	      return false;
  	    };
  	  }

  	  function fifEssentialInvalidControlDetails(form) {
  	    if (!form || typeof form.querySelectorAll !== "function") return [];

  	    return Array.from(
  	      form.querySelectorAll(
  	        "input,select,textarea,button"
  	      )
  	    )
  	      .filter(function (control) {
  	        return (
  	          control &&
  	          control.willValidate &&
  	          !control.validity.valid
  	        );
  	      })
  	      .map(function (control) {
  	        return {
  	          tag: control.tagName,
  	          type: control.type,
  	          name: control.name,
  	          value: control.value,
  	          required: control.required,
  	          min: control.min,
  	          max: control.max,
  	          step: control.step,
  	          validationMessage:
  	            control.validationMessage,
  	          validity: {
  	            valueMissing:
  	              control.validity.valueMissing,
  	            typeMismatch:
  	              control.validity.typeMismatch,
  	            patternMismatch:
  	              control.validity.patternMismatch,
  	            tooLong:
  	              control.validity.tooLong,
  	            tooShort:
  	              control.validity.tooShort,
  	            rangeUnderflow:
  	              control.validity.rangeUnderflow,
  	            rangeOverflow:
  	              control.validity.rangeOverflow,
  	            stepMismatch:
  	              control.validity.stepMismatch,
  	            badInput:
  	              control.validity.badInput,
  	            customError:
  	              control.validity.customError,
  	            valid:
  	              control.validity.valid
  	          }
  	        };
  	      });
  	  }

  	  function fifEssentialSavePathSnapshot(source) {
  	    const root =
  	      document.getElementById(ROOT_ID);

  	    const form =
  	      root &&
  	      root.querySelector(
  	        "[data-essential-form]"
  	      );

  	    const button =
  	      root &&
  	      root.querySelector(
  	        "[data-essential-save]"
  	      );

  	    const company =
  	      typeof selectedCompany === "function"
  	        ? selectedCompany()
  	        : null;

  	    const vehicle =
  	      company &&
  	      typeof selectedVehicle === "function"
  	        ? selectedVehicle(company)
  	        : null;

  	    return {
  	      source: source || "manual",
  	      at: new Date().toISOString(),
  	      build:
  	        typeof window !== "undefined"
  	          ? window.__FIF_DASHBOARD_BUILD__
  	          : "",
  	      rootFound: !!root,
  	      formFound: !!form,
  	      buttonFound: !!button,
  	      buttonDisabled:
  	        !!(button && button.disabled),
  	      formNoValidate:
  	        !!(form && form.noValidate),
  	      formCheckValidity:
  	        form &&
  	        typeof form.checkValidity === "function"
  	          ? form.checkValidity()
  	          : null,
  	      invalidControls:
  	        fifEssentialInvalidControlDetails(
  	          form
  	        ),
  	      activeTab:
  	        typeof state !== "undefined"
  	          ? state.activeTab
  	          : undefined,
  	      vehicleActiveTab:
  	        typeof state !== "undefined"
  	          ? state.vehicleActiveTab
  	          : undefined,
  	      selectedVehicleKey:
  	        typeof state !== "undefined"
  	          ? state.selectedVehicleKey
  	          : undefined,
  	      selectedAssetType:
  	        typeof state !== "undefined"
  	          ? state.selectedAssetType
  	          : undefined,
  	      vehicleDataEditMode:
  	        typeof state !== "undefined"
  	          ? state.vehicleDataEditMode
  	          : undefined,
  	      vehicleBusy:
  	        typeof state !== "undefined"
  	          ? state.vehicleBusy
  	          : undefined,
  	      hasDraft:
  	        typeof state !== "undefined"
  	          ? !!state.vehicleDataDraft
  	          : false,
  	      draft:
  	        typeof state !== "undefined"
  	          ? fifDebugClone(
  	              state.vehicleDataDraft
  	            )
  	          : null,
  	      companyFound: !!company,
  	      vehicleFound: !!vehicle,
  	      vehicleObjectId:
  	        vehicle &&
  	        typeof objectIdOf === "function"
  	          ? objectIdOf(vehicle)
  	          : "",
  	      vehicleClass:
  	        vehicle && vehicle.___class,
  	      vehicleIsTrailer:
  	        vehicle &&
  	        typeof assetIsTrailer === "function"
  	          ? assetIsTrailer(vehicle)
  	          : null,
  	      canEditVehiclePhysical:
  	        typeof CAN_EDIT_VEHICLE_PHYSICAL !==
  	        "undefined"
  	          ? CAN_EDIT_VEHICLE_PHYSICAL
  	          : undefined
  	    };
  	  }

  	  function fifConsoleEssentialPath(
  	    label,
  	    source
  	  ) {
  	    const snapshot =
  	      fifEssentialSavePathSnapshot(source);

  	    if (snapshot.invalidControls.length) {
  	      try {

  	      } catch (_) {}
  	    }

  	    if (typeof window !== "undefined") {
  	      window.__FIF_LAST_ESSENTIAL_PATH_TRACE__ =
  	        snapshot;
  	    }

  	    return snapshot;
  	  }

  	  function fifRawEssentialClickTrace(event) {
  	    const target =
  	      event &&
  	      event.target &&
  	      event.target.closest
  	        ? event.target.closest(
  	            "[data-essential-save]"
  	          )
  	        : null;

  	    if (!target) return;

  	    fifConsoleEssentialPath(
  	      "CAPTURE CLICK",
  	      "document capture click"
  	    );
  	  }

  	  function fifRawEssentialSubmitTrace(event) {
  	    const form =
  	      event &&
  	      event.target &&
  	      event.target.matches &&
  	      event.target.matches(
  	        "[data-essential-form]"
  	      )
  	        ? event.target
  	        : null;

  	    if (!form) return;

  	    fifConsoleEssentialPath(
  	      "CAPTURE SUBMIT",
  	      "document capture submit"
  	    );
  	  }

  	  if (typeof window !== "undefined") {
  	    window.FIF_TRACE_ESSENTIAL_SAVE_PATH =
  	      function () {
  	        return fifConsoleEssentialPath(
  	          "MANUAL TRACE",
  	          "manual command"
  	        );
  	      };
  	  }

  	  function fifInstallTraceBuildBadge() {
  	    if (typeof document === "undefined") return;
  	    document.getElementById("fif-essential-trace-build-badge")?.remove();
  	  }

  	  const FIF_OPERATION_OVERLAY_ID = "fif-dashboard-operation-overlay";
  	  const FIF_OPERATION_STYLE_ID = "fif-dashboard-operation-style";
  	  let fifOperationDepth = 0;
  	  let fifOperationShownAt = 0;
  	  let fifOperationHideTimer = null;
  	  let fifOperationErrorLocked = false;
  	  let fifOperationPrime = null;
  	  let fifOperationPrimeTimer = null;

  	  function fifDatabaseUserText(value) {
  	    return String(value === null || value === undefined ? "" : value)
  	      .replace(/\bBackendless\b/gi, "Database")
  	      .replace(/\bthe Database\b/g, "the database")
  	      .replace(/\bDatabase database\b/gi, "database");
  	  }

  	  function fifOperationLogoHtml() {
  	    let source = SVG_INPUT;
  	    if (source && typeof source === "object") source = source.value || source.Value || source.src || source.url || "";
  	    source = clean(source);
  	    if (!source) return `<div class="fif-operation-logo-fallback">FIF</div>`;
  	    if ((source.charAt(0) === '"' && source.charAt(source.length - 1) === '"') || (source.charAt(0) === "'" && source.charAt(source.length - 1) === "'")) source = source.substring(1, source.length - 1);
  	    if (/^data:image\//i.test(source) || /^https?:\/\//i.test(source)) return `<img src="${escapeAttr(source)}" alt="Fleet In Form">`;
  	    if (/^<svg[\s>]/i.test(source)) return source.replace(/<script[\s\S]*?<\/script>/gi, "").replace(/<svg([^>]*?)>/i, '<svg$1 preserveAspectRatio="xMidYMid meet">');
  	    return `<div class="fif-operation-logo-fallback">FIF</div>`;
  	  }

  	  function ensureFifOperationStyles() {
  	    if (document.getElementById(FIF_OPERATION_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = FIF_OPERATION_STYLE_ID;
  	    style.textContent = `
  	      #${FIF_OPERATION_OVERLAY_ID},#${FIF_OPERATION_OVERLAY_ID} *{box-sizing:border-box}
  	      #${FIF_OPERATION_OVERLAY_ID}{position:fixed;inset:50px 0 0;z-index:2147483647;display:grid;place-items:center;padding:24px;background:radial-gradient(circle at 50% 44%,rgba(113,47,17,.18),transparent 34%),rgba(0,0,0,.91);backdrop-filter:blur(8px);opacity:0;visibility:hidden;pointer-events:none;transition:opacity .3s ease,visibility .3s ease}
  	      #${FIF_OPERATION_OVERLAY_ID}.is-visible{opacity:1;visibility:visible;pointer-events:auto}
  	      #${FIF_OPERATION_OVERLAY_ID}.is-leaving{opacity:0;pointer-events:none}
  	      #${FIF_OPERATION_OVERLAY_ID} .fif-operation-card{width:min(420px,calc(100vw - 48px));display:flex;flex-direction:column;align-items:center;gap:17px;padding:29px 25px;border:1px solid rgba(198,92,40,.34);border-radius:25px;color:#fff;background:radial-gradient(circle at 50% 0%,rgba(225,109,48,.10),transparent 44%),linear-gradient(145deg,rgba(25,29,26,.98),rgba(8,11,10,.99));box-shadow:0 30px 80px rgba(0,0,0,.62),inset 0 1px 0 rgba(255,255,255,.04);transform:translateY(8px) scale(.985);transition:transform .3s ease}
  	      #${FIF_OPERATION_OVERLAY_ID}.is-visible .fif-operation-card{transform:none}
  	      #${FIF_OPERATION_OVERLAY_ID} .fif-operation-logo{width:150px;min-height:64px;display:grid;place-items:center;animation:fifOperationThrob 1.45s ease-in-out infinite;filter:drop-shadow(0 0 16px rgba(219,102,43,.24))}
  	      #${FIF_OPERATION_OVERLAY_ID} .fif-operation-logo img,#${FIF_OPERATION_OVERLAY_ID} .fif-operation-logo svg{width:150px;max-height:72px;display:block;object-fit:contain}
  	      #${FIF_OPERATION_OVERLAY_ID} .fif-operation-logo-fallback{width:76px;height:52px;display:grid;place-items:center;border:1px solid rgba(224,111,55,.54);border-radius:16px;color:#ffb083;background:rgba(100,42,18,.24);font-size:20px;font-weight:950}
  	      #${FIF_OPERATION_OVERLAY_ID} .fif-operation-status{min-height:22px;color:#f0d7c8;font:800 14px/1.45 Inter,system-ui,sans-serif;text-align:center;text-shadow:0 2px 8px rgba(0,0,0,.7);transition:opacity .16s ease}
  	      #${FIF_OPERATION_OVERLAY_ID} .fif-operation-note{margin-top:-8px;color:rgba(203,213,225,.68);font:650 10px/1.45 Inter,system-ui,sans-serif;text-align:center}
  	      #${FIF_OPERATION_OVERLAY_ID} .fif-operation-ok{display:none;min-width:118px;height:42px;padding:0 22px;border:1px solid rgba(232,115,57,.56);border-radius:13px;color:#fff;background:linear-gradient(145deg,#9c4822,#5e2914);font-size:12px;font-weight:900;text-transform:uppercase;cursor:pointer}
  	      #${FIF_OPERATION_OVERLAY_ID}.is-error .fif-operation-card{border-color:rgba(214,65,43,.72);background:radial-gradient(circle at 50% 0%,rgba(185,46,30,.15),transparent 46%),linear-gradient(145deg,rgba(31,18,17,.98),rgba(8,10,10,.99))}
  	      #${FIF_OPERATION_OVERLAY_ID}.is-error .fif-operation-logo{animation-play-state:paused;filter:drop-shadow(0 0 17px rgba(211,64,38,.3))}
  	      #${FIF_OPERATION_OVERLAY_ID}.is-error .fif-operation-ok{display:inline-flex;align-items:center;justify-content:center}
  	      #${FIF_OPERATION_OVERLAY_ID}.is-success .fif-operation-logo{animation:fifOperationComplete .62s ease-in-out 1}
  	      @keyframes fifOperationThrob{0%,100%{transform:scale(.97);opacity:.78}50%{transform:scale(1.045);opacity:1}}
  	      @keyframes fifOperationComplete{0%{transform:scale(.98);opacity:.82}52%{transform:scale(1.075);opacity:1}100%{transform:scale(1);opacity:1}}
  	      @media(prefers-reduced-motion:reduce){#${FIF_OPERATION_OVERLAY_ID},#${FIF_OPERATION_OVERLAY_ID} .fif-operation-card,#${FIF_OPERATION_OVERLAY_ID} .fif-operation-logo{transition-duration:.01ms!important;animation-duration:.01ms!important;animation-iteration-count:1!important}}
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function fifEnsureOperationOverlay(status) {
  	    ensureFifOperationStyles();
  	    let overlay = document.getElementById(FIF_OPERATION_OVERLAY_ID);
  	    if (!overlay) {
  	      overlay = document.createElement("div");
  	      overlay.id = FIF_OPERATION_OVERLAY_ID;
  	      overlay.setAttribute("role", "status");
  	      overlay.setAttribute("aria-live", "polite");
  	      overlay.innerHTML = `<div class="fif-operation-card"><div class="fif-operation-logo">${fifOperationLogoHtml()}</div><div class="fif-operation-status"></div><div class="fif-operation-note"></div><button type="button" class="fif-operation-ok">OK</button></div>`;
  	      document.body.appendChild(overlay);
  	      overlay.querySelector(".fif-operation-ok")?.addEventListener("click", function () {
  	        fifOperationErrorLocked = false;
  	        fifOperationDepth = 0;
  	        fifFadeOperationOverlay();
  	      });
  	    }
  	    // Once a database error is on screen it is authoritative until the user
  	    // acknowledges it. Background reads must never replace the error with
  	    // messages such as "Loading Companies…".
  	    if (fifOperationErrorLocked && overlay.classList.contains("is-error")) {
  	      return overlay;
  	    }

  	    const statusNode = overlay.querySelector(".fif-operation-status");
  	    const noteNode = overlay.querySelector(".fif-operation-note");
  	    if (statusNode) statusNode.textContent = clean(status) || "Saving to database…";
  	    if (noteNode && !fifOperationErrorLocked) {
  	      noteNode.textContent =
  	        "No AppData is changed until the database confirms the write.";
  	    }
  	    overlay.classList.remove("is-leaving", "is-error", "is-success");
  	    requestAnimationFrame(function () { overlay.classList.add("is-visible"); });
  	    return overlay;
  	  }

  	  function fifCancelPrimedOperation() {
  	    if (!fifOperationPrime) return;
  	    const prime = fifOperationPrime;
  	    fifOperationPrime = null;
  	    if (fifOperationPrimeTimer) {
  	      clearTimeout(fifOperationPrimeTimer);
  	      fifOperationPrimeTimer = null;
  	    }
  	    if (prime.claimed) return;
  	    fifOperationDepth = Math.max(0, fifOperationDepth - 1);
  	    if (prime.token && prime.token.owner && fifOperationDepth === 0 && !fifOperationErrorLocked) {
  	      fifFadeOperationOverlay();
  	    }
  	  }

  	  function fifPrimeOperationFromClick(status) {
  	    if (fifOperationErrorLocked || fifOperationDepth > 0) return;
  	    fifCancelPrimedOperation();
  	    const token = fifBeginSaveOperation(status || "Preparing operation…");
  	    fifOperationPrime = { token: token, claimed: false };
  	    fifOperationPrimeTimer = setTimeout(function () {
  	      fifOperationPrimeTimer = null;
  	      if (fifOperationPrime && !fifOperationPrime.claimed) fifCancelPrimedOperation();
  	    }, 1100);
  	  }

  	  function fifBeginSaveOperation(status) {
  	    if (fifOperationHideTimer) { clearTimeout(fifOperationHideTimer); fifOperationHideTimer = null; }

  	    if (fifOperationPrime && !fifOperationPrime.claimed) {
  	      const prime = fifOperationPrime;
  	      prime.claimed = true;
  	      fifOperationPrime = null;
  	      if (fifOperationPrimeTimer) {
  	        clearTimeout(fifOperationPrimeTimer);
  	        fifOperationPrimeTimer = null;
  	      }
  	      fifOperationErrorLocked = false;
  	      fifUpdateSaveOperation(status || "Saving…");
  	      return prime.token;
  	    }

  	    const owner = fifOperationDepth === 0;
  	    fifOperationDepth += 1;
  	    if (owner) fifOperationShownAt = Date.now();
  	    fifOperationErrorLocked = false;
  	    fifEnsureOperationOverlay(status);
  	    return { owner: owner };
  	  }

  	  function fifUpdateSaveOperation(status) {
  	    const overlay = fifEnsureOperationOverlay(status);
  	    const node = overlay.querySelector(".fif-operation-status");
  	    if (!node) return;
  	    node.style.opacity = ".34";
  	    setTimeout(function () { if (node.isConnected && !fifOperationErrorLocked) { node.textContent = clean(status) || "Saving…"; node.style.opacity = "1"; } }, 80);
  	  }

  	  function fifFadeOperationOverlay() {
  	    const overlay = document.getElementById(FIF_OPERATION_OVERLAY_ID);
  	    if (!overlay) return;
  	    overlay.classList.add("is-leaving");
  	    overlay.classList.remove("is-visible");
  	    setTimeout(function () { if (!fifOperationErrorLocked && fifOperationDepth === 0) overlay.remove(); }, 380);
  	  }

  	  function fifCompleteSaveOperation(token, message) {
  	    if (fifOperationPrimeTimer) { clearTimeout(fifOperationPrimeTimer); fifOperationPrimeTimer = null; }
  	    fifOperationPrime = null;
  	    fifOperationDepth = Math.max(0, fifOperationDepth - 1);
  	    if (!token || fifOperationDepth > 0) return;
  	    const overlay = fifEnsureOperationOverlay(message || "Database update completed.");
  	    overlay.classList.add("is-success");
  	    overlay.setAttribute("aria-busy", "false");
  	    const note = overlay.querySelector(".fif-operation-note");
  	    if (note) note.textContent = "The update has been completed successfully.";
  	    const visibleFor = Date.now() - fifOperationShownAt;
  	    fifOperationHideTimer = setTimeout(function () { fifOperationHideTimer = null; fifFadeOperationOverlay(); }, Math.max(780, 620 - visibleFor));
  	  }

  	  function fifFailSaveOperation(token, error) {
  	    if (fifOperationPrimeTimer) { clearTimeout(fifOperationPrimeTimer); fifOperationPrimeTimer = null; }
  	    fifOperationPrime = null;
  	    fifOperationDepth = 0;
  	    fifOperationErrorLocked = true;
  	    const message = fifDatabaseUserText(clean(error && (error.message || error.faultString)) || clean(error) || "The save operation could not be completed.");
  	    const overlay = fifEnsureOperationOverlay(message);
  	    overlay.classList.add("is-error", "is-visible");
  	    overlay.setAttribute("role", "alertdialog");
  	    overlay.setAttribute("aria-modal", "true");
  	    overlay.setAttribute("aria-busy", "false");
  	    const note = overlay.querySelector(".fif-operation-note");
  	    if (note) note.textContent = "Nothing further will happen until this message is acknowledged.";
  	    setTimeout(function () { try { overlay.querySelector(".fif-operation-ok")?.focus(); } catch (_) {} }, 40);
  	  }

  	  let fifProxiedOperationPending = 0;
  	  let fifProxiedOperationToken = null;
  	  let fifProxiedOperationTimer = null;
  	  let fifProxiedOperationLastWasRead = false;
  	  let fifProxiedOperationLastTable = "";
  	  let fifSuppressProxiedOperationOverlay = 0;

  	  function fifOperationTableLabel(tableName) {
  	    const value = clean(tableName).replace(/[_-]+/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2");
  	    return value || "database records";
  	  }

  	  function fifOperationMethodStatus(tableName, method) {
  	    const label = fifOperationTableLabel(tableName);
  	    if (["find", "findById", "findFirst", "loadRelations", "getRelation"].indexOf(method) !== -1) {
  	      return "Loading " + label + "…";
  	    }
  	    if (method === "save") return "Saving " + label + "…";
  	    if (method === "remove" || method === "delete") return "Deleting " + label + "…";
  	    return "Updating " + label + " relations…";
  	  }

  	  function fifExtractTractorTopLevelMirrors(payload) {
  	    if (!payload || typeof payload !== "object") return null;

  	    const data =
  	      payload.Data &&
  	      typeof payload.Data === "object"
  	        ? payload.Data
  	        : null;

  	    const vehicle =
  	      data &&
  	      data.Vehicle &&
  	      typeof data.Vehicle === "object"
  	        ? data.Vehicle
  	        : null;

  	    const identity =
  	      vehicle &&
  	      vehicle.Identity &&
  	      typeof vehicle.Identity === "object"
  	        ? vehicle.Identity
  	        : null;

  	    const appearance =
  	      vehicle &&
  	      vehicle.Appearance &&
  	      typeof vehicle.Appearance === "object"
  	        ? vehicle.Appearance
  	        : null;

  	    const usage =
  	      vehicle &&
  	      vehicle.Usage &&
  	      typeof vehicle.Usage === "object"
  	        ? vehicle.Usage
  	        : null;

  	    const fuelAndEnergy =
  	      data &&
  	      data.FuelAndEnergy &&
  	      typeof data.FuelAndEnergy === "object"
  	        ? data.FuelAndEnergy
  	        : null;

  	    const nestedLicenceExpiry =
  	      data
  	        ? getDeep(
  	            data,
  	            [
  	              "Compliance",
  	              "Setup",
  	              "Requirements",
  	              "VehicleLicence",
  	              "ExpiryDate"
  	            ],
  	            undefined
  	          )
  	        : undefined;

  	    function supplied(nestedValue, topValue) {
  	      const value = descriptorValue(nestedValue);

  	      if (
  	        value !== undefined &&
  	        value !== null &&
  	        value !== ""
  	      ) {
  	        return value;
  	      }

  	      return topValue;
  	    }

  	    const fleetId =
  	      clean(
  	        supplied(
  	          identity ? identity.FID : undefined,
  	          payload.FID || payload.ID
  	        )
  	      );

  	    const registration =
  	      clean(
  	        supplied(
  	          identity ? identity.Registration : undefined,
  	          payload.Registration
  	        )
  	      );

  	    const color =
  	      safeColor(
  	        supplied(
  	          appearance ? appearance.Color : undefined,
  	          payload.color
  	        ),
  	        ""
  	      );

  	    const range =
  	      Number(
  	        supplied(
  	          usage ? usage.Range : undefined,
  	          payload.Range
  	        )
  	      );

  	    const counterType =
  	      clean(
  	        supplied(
  	          usage ? usage.CounterType : undefined,
  	          payload.CounterType
  	        )
  	      );

  	    const sarsComplianceCandidate =
  	      supplied(
  	        fuelAndEnergy
  	          ? fuelAndEnergy.SARSCompliance
  	          : undefined,
  	        payload.SARSCompliance
  	      );

  	    const sarsRate =
  	      Number(
  	        supplied(
  	          fuelAndEnergy ? fuelAndEnergy.SARSRate : undefined,
  	          payload.SARSRate
  	        )
  	      );

  	    const licenceExpiryValue =
  	      nestedLicenceExpiry !== undefined &&
  	      nestedLicenceExpiry !== null &&
  	      nestedLicenceExpiry !== ""
  	        ? nestedLicenceExpiry
  	        : payload.LicenseExpiry;

  	    const licenceExpiryDate =
  	      fifEssentialDateValue(licenceExpiryValue);

  	    const licenceExpiryTimestamp =
  	      fifEssentialDateTimestamp(licenceExpiryDate);

  	    const patch = {};

  	    if (fleetId) {
  	      patch.ID = fleetId;
  	      patch.FID = fleetId;
  	    }

  	    if (registration) {
  	      patch.Registration = registration;
  	    }

  	    if (/^#[0-9a-f]{6}$/i.test(color)) {
  	      patch.color = color.toLowerCase();
  	    }

  	    if (licenceExpiryTimestamp !== null) {
  	      patch.LicenseExpiry = licenceExpiryTimestamp;
  	    }

  	    if (Number.isFinite(range)) {
  	      patch.Range = range;
  	    }

  	    if (
  	      counterType === "Kilometers" ||
  	      counterType === "Hours"
  	    ) {
  	      patch.CounterType = counterType;
  	    }

  	    if (
  	      sarsComplianceCandidate === true ||
  	      sarsComplianceCandidate === false
  	    ) {
  	      patch.SARSCompliance =
  	        sarsComplianceCandidate === true;
  	    } else {
  	      const normalisedCompliance =
  	        lower(sarsComplianceCandidate);

  	      if (
  	        normalisedCompliance === "true" ||
  	        normalisedCompliance === "yes" ||
  	        normalisedCompliance === "compliant"
  	      ) {
  	        patch.SARSCompliance = true;
  	      } else if (
  	        normalisedCompliance === "false" ||
  	        normalisedCompliance === "no" ||
  	        normalisedCompliance === "not compliant"
  	      ) {
  	        patch.SARSCompliance = false;
  	      }
  	    }

  	    if (Number.isFinite(sarsRate)) {
  	      patch.SARSRate = sarsRate;
  	    }

  	    return Object.keys(patch).length ? patch : null;
  	  }

  	  function fifTractorTopLevelMirrorValueMatches(
  	    field,
  	    actual,
  	    expected
  	  ) {
  	    if (field === "Range" || field === "SARSRate") {
  	      return (
  	        Number.isFinite(Number(actual)) &&
  	        Number(actual) === Number(expected)
  	      );
  	    }

  	    if (field === "SARSCompliance") {
  	      return actual === expected;
  	    }

  	    if (field === "LicenseExpiry") {
  	      return (
  	        fifEssentialDateValue(actual) ===
  	        fifEssentialDateValue(expected)
  	      );
  	    }

  	    if (field === "color") {
  	      return lower(actual) === lower(expected);
  	    }

  	    return clean(actual) === clean(expected);
  	  }

  	  function fifTractorTopLevelMirrorsMatch(
  	    record,
  	    expectedMirrors
  	  ) {
  	    if (
  	      !record ||
  	      typeof record !== "object" ||
  	      !expectedMirrors ||
  	      typeof expectedMirrors !== "object"
  	    ) {
  	      return false;
  	    }

  	    return Object.keys(expectedMirrors).every(function (field) {
  	      return fifTractorTopLevelMirrorValueMatches(
  	        field,
  	        record[field],
  	        expectedMirrors[field]
  	      );
  	    });
  	  }

  	  function fifDescribeTractorMirrorMismatch(
  	    record,
  	    expectedMirrors
  	  ) {
  	    return Object.keys(expectedMirrors || {})
  	      .filter(function (field) {
  	        return !fifTractorTopLevelMirrorValueMatches(
  	          field,
  	          record && record[field],
  	          expectedMirrors[field]
  	        );
  	      })
  	      .map(function (field) {
  	        return (
  	          field +
  	          " expected " +
  	          JSON.stringify(expectedMirrors[field]) +
  	          " but returned " +
  	          JSON.stringify(record && record[field])
  	        );
  	      })
  	      .join("; ");
  	  }

  	  function fifOperationBackendlessProxy(api) {
  	    let sourceData = null;
  	    try {
  	      sourceData = api && api.Data;
  	    } catch (_) {
  	      sourceData = null;
  	    }

  	    if (!api || !sourceData || typeof sourceData.of !== "function") return api;
  	    if (api.__fifUniversalOperationProxy) return api;

  	    const proxiedApi = Object.create(api);
  	    const proxiedData = Object.create(sourceData);

  	    Object.defineProperty(proxiedApi, "__fifUniversalOperationProxy", {
  	      configurable: false,
  	      enumerable: false,
  	      writable: false,
  	      value: true
  	    });

  	    Object.defineProperty(proxiedData, "of", {
  	      configurable: true,
  	      enumerable: true,
  	      writable: false,
  	      value: function (tableName) {
  	        const store = sourceData.of(tableName);
  	        if (!store || store.__fifOperationProxy) return store;

  	        const proxy = Object.create(store);
  	        Object.defineProperty(proxy, "__fifOperationProxy", {
  	          configurable: false,
  	          enumerable: false,
  	          writable: false,
  	          value: true
  	        });

  	        [
  	          "find",
  	          "findById",
  	          "findFirst",
  	          "loadRelations",
  	          "getRelation",
  	          "save",
  	          "addRelation",
  	          "setRelation",
  	          "deleteRelation",
  	          "remove",
  	          "delete"
  	        ].forEach(function (method) {
  	          let sourceMethod = null;
  	          try {
  	            sourceMethod = store[method];
  	          } catch (_) {
  	            sourceMethod = null;
  	          }
  	          if (typeof sourceMethod !== "function") return;

  	          Object.defineProperty(proxy, method, {
  	            configurable: true,
  	            enumerable: false,
  	            writable: false,
  	            value: function () {
  	              const args = Array.prototype.slice.call(arguments);
  	              const isRead = ["find", "findById", "findFirst", "loadRelations", "getRelation"].indexOf(method) !== -1;
  	              const status = fifOperationMethodStatus(tableName, method);
  	              if (
  	                method === "save" &&
  	                clean(tableName) === "Tractors" &&
  	                args[0] &&
  	                typeof args[0] === "object"
  	              ) {
  	                const tractorMirrorPatch =
  	                  fifExtractTractorTopLevelMirrors(args[0]);

  	                if (tractorMirrorPatch) {
  	                  args[0] = Object.assign(
  	                    {},
  	                    args[0],
  	                    tractorMirrorPatch
  	                  );
  	                }
  	              }

  	              // Explicit workflows (notably Employee creation) own their
  	              // operation overlay. Also, once an error is locked on screen,
  	              // background database activity must not take ownership of it.
  	              if (fifSuppressProxiedOperationOverlay > 0 || fifOperationErrorLocked) {
  	                let directRequest;
  	                try {
  	                  directRequest = sourceMethod.apply(store, args);
  	                } catch (error) {
  	                  throw error;
  	                }
  	                return Promise.resolve(directRequest);
  	              }

  	              if (fifProxiedOperationTimer) {
  	                clearTimeout(fifProxiedOperationTimer);
  	                fifProxiedOperationTimer = null;
  	              }
  	              if (!fifProxiedOperationToken) {
  	                fifProxiedOperationToken = fifBeginSaveOperation(status);
  	              }

  	              fifProxiedOperationPending += 1;
  	              fifProxiedOperationLastWasRead = isRead;
  	              fifProxiedOperationLastTable = fifOperationTableLabel(tableName);
  	              fifUpdateSaveOperation(status);

  	              let request;
  	              try {
  	                request = sourceMethod.apply(store, args);
  	              } catch (error) {
  	                fifProxiedOperationPending = Math.max(0, fifProxiedOperationPending - 1);
  	                const token = fifProxiedOperationToken;
  	                fifProxiedOperationToken = null;
  	                if (token && token.owner) fifFailSaveOperation(token, error);
  	                throw error;
  	              }

  	              return Promise.resolve(request).then(function (result) {
  	                fifProxiedOperationPending = Math.max(0, fifProxiedOperationPending - 1);

  	                if (fifProxiedOperationPending === 0 && fifProxiedOperationToken) {
  	                  fifProxiedOperationTimer = setTimeout(function () {
  	                    fifProxiedOperationTimer = null;

  	                    if (fifProxiedOperationPending !== 0 || !fifProxiedOperationToken) {
  	                      return;
  	                    }

  	                    const token = fifProxiedOperationToken;
  	                    fifProxiedOperationToken = null;

  	                    fifCompleteSaveOperation(
  	                      token,
  	                      fifProxiedOperationLastWasRead
  	                        ? fifProxiedOperationLastTable + " loaded."
  	                        : fifProxiedOperationLastTable + " updated."
  	                    );
  	                  }, 220);
  	                }

  	                return result;
  	              }, function (error) {
  	                fifProxiedOperationPending = Math.max(0, fifProxiedOperationPending - 1);
  	                const token = fifProxiedOperationToken;
  	                fifProxiedOperationToken = null;
  	                if (token && token.owner) fifFailSaveOperation(token, error);
  	                throw error;
  	              });
  	            }
  	          });
  	        });

  	        return proxy;
  	      }
  	    });

  	    Object.defineProperty(proxiedApi, "Data", {
  	      configurable: true,
  	      enumerable: true,
  	      writable: false,
  	      value: proxiedData
  	    });

  	    return proxiedApi;
  	  }

  	  const FIF_IMMEDIATE_OPERATION_RULES = [
  	    ["[data-essential-save]", "Preparing Essential Data database save…"],
  	    ["[data-identity-save]", "Preparing Vehicle Identity database save…"],
  	    ["[data-app-save]", "Saving company applications…"],
  	    ["[data-employee-save]", "Saving employee record…"],
  	    ["[data-employee-remove-company]", "Updating company membership…"],
  	    ["[data-road-fuel-save]", "Saving on-road fuel record…"],
  	    ["[data-events-save-applications]", "Saving event products and rates…"],
  	    ["[data-vm-save-service-record]", "Saving completed service record…"],
  	    ["[data-sp-save-job]", "Saving workshop job…"],
  	    ["[data-sp-save-reschedule]", "Saving rescheduled workshop date…"],
  	    ["[data-sp-save-phase]", "Saving workshop phase change…"],
  	    ["[data-sp-save-provider]", "Saving service provider…"],
  	    ["[data-cmp-save]", "Saving compliance record…"],
  	    ["[data-vm-save-tyres]", "Saving tyre changes…"],
  	    ['[data-vm-tab="tyres"]', "Loading tyre workspace…"]
  	  ];

  	  function fifImmediateOperationStatus(target) {
  	    const button = target && target.closest ? target.closest("button,input[type=submit]") : null;
  	    if (!button || button.disabled || button.getAttribute("aria-disabled") === "true") return "";
  	    const surface = button.closest("#" + ROOT_ID + ",[data-fif-main-surface='exact-original-tractor-manager'],#fif-original-tyre-inline-host");
  	    if (!surface) return "";

  	    for (let index = 0; index < FIF_IMMEDIATE_OPERATION_RULES.length; index += 1) {
  	      if (button.matches(FIF_IMMEDIATE_OPERATION_RULES[index][0])) return FIF_IMMEDIATE_OPERATION_RULES[index][1];
  	    }

  	    const label = clean(button.textContent || button.value).replace(/\s+/g, " ");
  	    if (/^(save|post|submit|reconcile|activate|complete)\b/i.test(label)) {
  	      return label.length <= 56 ? label.replace(/[.!]+$/, "") + "…" : "Saving changes…";
  	    }
  	    return "";
  	  }

  	  function onFifImmediateOperationClick(event) {
  	    if (event.defaultPrevented || fifOperationErrorLocked) return;
  	    const status = fifImmediateOperationStatus(event.target);
  	    if (status) fifPrimeOperationFromClick(status);
  	  }

  	  const FIF_PROMPT_ROOT_ID = "fif-universal-prompt-root";
  	  const FIF_PROMPT_STYLE_ID = "fif-universal-prompt-style";
  	  let activePromptResolve = null;
  	  let activePromptKeyHandler = null;

  	  function promptEscapeHtml(value) {
  	    return String(value == null ? "": value)
  	    .replace(/&/g, "&amp;")
  	    .replace(/</g, "&lt;")
  	    .replace(/>/g, "&gt;")
  	    .replace(/\"/g, "&quot;")
  	    .replace(/'/g, "&#039;");
  	  }

  	  function ensureFifPromptStyles() {
  	    if (document.getElementById(FIF_PROMPT_STYLE_ID)) return;

  	    const style = document.createElement("style");
  	    style.id = FIF_PROMPT_STYLE_ID;
  	    style.textContent = `
  	    #${FIF_PROMPT_ROOT_ID}, #${FIF_PROMPT_ROOT_ID} * { box-sizing:border-box; }
  	    #${FIF_PROMPT_ROOT_ID} {
  	    position:fixed;
  	    inset:50px 0 0 0;
  	    z-index:2147483647;
  	    display:grid;
  	    place-items:center;
  	    padding:22px;
  	    background:rgba(0,0,0,.76);
  	    backdrop-filter:blur(7px) saturate(.86);
  	    font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  	    animation:fifPromptFade .14s ease-out;
  	    }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-card {
  	    --prompt-accent:#cc6633;
  	    width:min(590px,96vw);
  	    max-height:min(720px,calc(100vh - 92px));
  	    overflow:auto;
  	    color:#f6f7f6;
  	    border:1px solid color-mix(in srgb,var(--prompt-accent) 58%,rgba(255,255,255,.08));
  	    border-radius:19px;
  	    background:
  	    radial-gradient(circle at 10% 0%,color-mix(in srgb,var(--prompt-accent) 18%,transparent),transparent 34%),
  	    linear-gradient(145deg,rgba(23,27,24,.995),rgba(7,10,8,.995));
  	    box-shadow:0 34px 90px rgba(0,0,0,.82),0 0 36px color-mix(in srgb,var(--prompt-accent) 13%,transparent),inset 0 1px 0 rgba(255,255,255,.055);
  	    transform-origin:center;
  	    animation:fifPromptRise .18s cubic-bezier(.2,.75,.25,1);
  	    }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-card.type-danger { --prompt-accent:#ef5350; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-card.type-success { --prompt-accent:#49c785; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-card.type-info { --prompt-accent:#4d92ff; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-topline { height:3px;background:linear-gradient(90deg,var(--prompt-accent),transparent 78%); }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-head { display:grid;grid-template-columns:54px minmax(0,1fr);gap:14px;align-items:center;padding:19px 20px 15px;border-bottom:1px solid rgba(255,255,255,.07); }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-icon { width:54px;height:54px;display:grid;place-items:center;border-radius:15px;border:1px solid color-mix(in srgb,var(--prompt-accent) 44%,transparent);background:color-mix(in srgb,var(--prompt-accent) 10%,rgba(0,0,0,.35));box-shadow:inset 0 1px 0 rgba(255,255,255,.055),0 0 18px color-mix(in srgb,var(--prompt-accent) 12%,transparent); }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-icon svg { width:28px;height:28px;fill:none;stroke:var(--prompt-accent);stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-kicker { color:var(--prompt-accent);font-size:9px;font-weight:950;text-transform:uppercase;letter-spacing:.16em; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-title { margin:4px 0 0;color:#fff;font-size:19px;line-height:1.15;font-weight:900; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-body { padding:17px 20px 8px; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-message { color:#cdd2cf;font-size:13px;line-height:1.62;white-space:normal; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-details { display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin-top:15px; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-detail { min-width:0;padding:10px 11px;border:1px solid rgba(255,255,255,.07);border-radius:10px;background:rgba(255,255,255,.025); }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-detail span { display:block;color:#777f7a;font-size:9px;font-weight:900;text-transform:uppercase;letter-spacing:.06em; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-detail strong { display:block;margin-top:4px;color:#f4f6f5;font-size:12px;overflow-wrap:anywhere; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-actions { display:flex;align-items:center;justify-content:flex-end;gap:9px;padding:15px 20px 19px; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-actions button { min-width:108px;border-radius:10px;padding:10px 14px;font:inherit;font-size:12px;font-weight:900;cursor:pointer;transition:transform .12s,border-color .12s,box-shadow .12s,background .12s; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-actions button:hover { transform:translateY(-1px); }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-cancel { border:1px solid rgba(255,255,255,.11);background:#171b18;color:#c6ccc8; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-confirm { border:1px solid color-mix(in srgb,var(--prompt-accent) 68%,transparent);background:linear-gradient(145deg,color-mix(in srgb,var(--prompt-accent) 30%,#151815),color-mix(in srgb,var(--prompt-accent) 12%,#0a0d0b));color:#fff;box-shadow:0 0 18px color-mix(in srgb,var(--prompt-accent) 13%,transparent); }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-confirm:focus-visible, #${FIF_PROMPT_ROOT_ID} .fif-prompt-cancel:focus-visible { outline:2px solid var(--prompt-accent);outline-offset:2px; }
  	    @keyframes fifPromptFade { from { opacity:0; } to { opacity:1; } }
  	    @keyframes fifPromptRise { from { opacity:0;transform:translateY(10px) scale(.985); } to { opacity:1;transform:none; } }
  	    @media (max-width:620px) {
  	    #${FIF_PROMPT_ROOT_ID} { padding:12px; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-head { grid-template-columns:44px minmax(0,1fr);padding:15px; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-icon { width:44px;height:44px;border-radius:12px; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-details { grid-template-columns:1fr; }
  	    #${FIF_PROMPT_ROOT_ID} .fif-prompt-actions { padding:12px 15px 16px; }
  	    }
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function promptIconSvg(type) {
  	    if (type === "success") return '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"></circle><path d="m8 12 2.6 2.7L16.5 9"></path></svg>';
  	    if (type === "info") return '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"></circle><path d="M12 10.7v6M12 7.2v.2"></path></svg>';
  	    if (type === "danger") return '<svg viewBox="0 0 24 24"><path d="M7.2 3.5h9.6l3.7 3.7v9.6l-3.7 3.7H7.2l-3.7-3.7V7.2z"></path><path d="M12 7.8v5.7M12 16.7v.2"></path></svg>';
  	    return '<svg viewBox="0 0 24 24"><path d="M12 3 2.7 20h18.6L12 3Z"></path><path d="M12 9v5M12 17.3v.2"></path></svg>';
  	  }

  	  function closeFifPrompt(result) {
  	    const root = document.getElementById(FIF_PROMPT_ROOT_ID);
  	    if (root && root.parentNode) root.parentNode.removeChild(root);
  	    if (activePromptKeyHandler) {
  	      document.removeEventListener("keydown", activePromptKeyHandler, true);
  	      activePromptKeyHandler = null;
  	    }
  	    const resolve = activePromptResolve;
  	    activePromptResolve = null;
  	    if (resolve) resolve(!!result);
  	  }

  	  function fifPrompt(options) {
  	    if (fifOperationPrime && !fifOperationPrime.claimed) fifCancelPrimedOperation();
  	    options = options || {};
  	    const type = ["warning",
  	      "danger",
  	      "success",
  	      "info"].indexOf(options.type) !== -1 ? options.type: "warning";
  	    const title = fifDatabaseUserText(options.title || (type === "danger" ? "Action Required": type === "success" ? "Completed": type === "info" ? "Information": "Please Confirm"));
  	    const message = fifDatabaseUserText(options.message == null ? "": options.message);
  	    const details = (Array.isArray(options.details) ? options.details: []).map(function (item) {
  	      return {
  	        label: fifDatabaseUserText(item && item.label),
  	        value: fifDatabaseUserText(item && item.value)
  	      };
  	    });
  	    const showCancel = options.showCancel !== false;
  	    const confirmText = options.confirmText || "Continue";
  	    const cancelText = options.cancelText || "Cancel";
  	    const kicker = options.kicker || "Fleet In Form";

  	    if (!document || !document.body) {
  	      if (showCancel && typeof window !== "undefined" && typeof window.confirm === "function") return Promise.resolve(window.confirm(message));
  	      if (typeof window !== "undefined" && typeof window.alert === "function") window.alert(message);
  	      return Promise.resolve(true);
  	    }

  	    ensureFifPromptStyles();
  	    if (activePromptResolve) closeFifPrompt(false);

  	    return new Promise(function (resolve) {
  	      activePromptResolve = resolve;
  	      const root = document.createElement("div");
  	      root.id = FIF_PROMPT_ROOT_ID;
  	      root.setAttribute("role", "presentation");
  	      root.innerHTML = `
  	      <section class="fif-prompt-card type-${promptEscapeHtml(type)}" role="dialog" aria-modal="true" aria-labelledby="fifPromptTitle">
  	      <div class="fif-prompt-topline"></div>
  	      <header class="fif-prompt-head">
  	      <div class="fif-prompt-icon">${promptIconSvg(type)}</div>
  	      <div><div class="fif-prompt-kicker">${promptEscapeHtml(kicker)}</div><h2 class="fif-prompt-title" id="fifPromptTitle">${promptEscapeHtml(title)}</h2></div>
  	      </header>
  	      <div class="fif-prompt-body">
  	      <div class="fif-prompt-message">${promptEscapeHtml(message).replace(/\n/g, "<br>")}</div>
  	      ${details.length ? `<div class="fif-prompt-details">${details.map(function (item) {
  	        return `<div class="fif-prompt-detail"><span>${promptEscapeHtml(item && item.label)}</span><strong>${promptEscapeHtml(item && item.value)}</strong></div>`;
  	      }).join("")}</div>`: ""}
  	      </div>
  	      <footer class="fif-prompt-actions">
  	      ${showCancel ? `<button type="button" class="fif-prompt-cancel" data-fif-prompt-cancel>${promptEscapeHtml(cancelText)}</button>`: ""}
  	      <button type="button" class="fif-prompt-confirm" data-fif-prompt-confirm>${promptEscapeHtml(confirmText)}</button>
  	      </footer>
  	      </section>`;
  	      document.body.appendChild(root);

  	      root.querySelector("[data-fif-prompt-confirm]").addEventListener("click", function () {
  	        closeFifPrompt(true);
  	      });
  	      root.querySelector("[data-fif-prompt-cancel]")?.addEventListener("click", function () {
  	        closeFifPrompt(false);
  	      });
  	      activePromptKeyHandler = function (event) {
  	        if (event.key === "Escape") {
  	          event.preventDefault();
  	          closeFifPrompt(false);
  	        }
  	        if (event.key === "Enter" && !event.shiftKey) {
  	          event.preventDefault();
  	          closeFifPrompt(true);
  	        }
  	      };
  	      document.addEventListener("keydown", activePromptKeyHandler, true);
  	      setTimeout(function () {
  	        root.querySelector("[data-fif-prompt-confirm]")?.focus();
  	      }, 0);
  	    });
  	  }

  	  function fifAlert(message,
  	    options) {
  	    options = Object.assign({},
  	      options || {},
  	      {
  	        message: message,
  	        showCancel: false,
  	        confirmText: (options && options.confirmText) || "Close"
  	      });
  	    return fifPrompt(options);
  	  }

  	  function fifConfirm(message,
  	    options) {
  	    options = Object.assign({},
  	      options || {},
  	      {
  	        message: message,
  	        showCancel: true
  	      });
  	    return fifPrompt(options);
  	  }

  	  const FIF_DIRTY_SAVE_SELECTOR = [
  	    "[data-app-save]",
  	    "[data-employee-save]",
  	    "[data-road-fuel-save]",
  	    "[data-vm-save-service-record]",
  	    "[data-sp-save-job]",
  	    "[data-sp-save-reschedule]",
  	    "[data-sp-save-phase]",
  	    "[data-sp-save-provider]",
  	    "[data-cmp-settings-save]",
  	    "[data-cmp-save]",
  	    "[data-vm-save-tyres]"
  	  ].join(",");

  	  let fifActiveDirtyScope = null;

  	  function fifDirtyControlValue(control) {
  	    if (!control) return "";
  	    const type = lower(control.type || "");
  	    if (type === "checkbox" || type === "radio") return control.checked ? "1" : "0";
  	    if (control.tagName === "SELECT" && control.multiple) {
  	      return Array.prototype.map.call(control.selectedOptions || [], function (option) {
  	        return option.value;
  	      }).join("\u001f");
  	    }
  	    return String(control.value == null ? "" : control.value);
  	  }

  	  function fifDirtySnapshot(scope) {
  	    if (!scope || !scope.querySelectorAll) return "";
  	    const values = [];
  	    scope.querySelectorAll("input,select,textarea,[contenteditable=true]").forEach(function (control, index) {
  	      const type = lower(control.type || "");
  	      if (
  	        control.disabled ||
  	        ["button", "submit", "reset", "hidden", "file"].indexOf(type) !== -1 ||
  	        control.hasAttribute("data-fif-dirty-ignore")
  	      ) {
  	        return;
  	      }

  	      const identity = clean(
  	        control.name ||
  	        control.id ||
  	        control.getAttribute("data-vm-bind") ||
  	        "control-" + index
  	      );

  	      values.push(identity + "=" + fifDirtyControlValue(control));
  	    });
  	    return values.join("\u001e");
  	  }

  	  function fifConditionalSaveButtons(scope) {
  	    if (!scope || !scope.querySelectorAll) return [];
  	    return Array.prototype.filter.call(
  	      scope.querySelectorAll(FIF_DIRTY_SAVE_SELECTOR),
  	      function (button) {
  	        const label = clean(button.textContent);
  	        return /^save\b/i.test(label) || /^update\b/i.test(label) || button.hasAttribute("data-fif-require-change");
  	      }
  	    );
  	  }

  	  function fifSetSaveButtonVisible(button, visible) {
  	    if (!button) return;
  	    if (!Object.prototype.hasOwnProperty.call(button.dataset, "fifDirtyDisplay")) {
  	      button.dataset.fifDirtyDisplay = button.style.display || "";
  	    }
  	    button.style.display = visible ? button.dataset.fifDirtyDisplay : "none";
  	    button.setAttribute("aria-hidden", visible ? "false" : "true");
  	  }

  	  function fifSetDirtyScope(scope, dirty) {
  	    if (!scope) return;
  	    if (!scope.__fifDirtyState) {
  	      scope.__fifDirtyState = { baseline: fifDirtySnapshot(scope), dirty: false };
  	    }
  	    scope.__fifDirtyState.dirty = !!dirty;
  	    scope.dataset.fifDirty = dirty ? "true" : "false";
  	    fifConditionalSaveButtons(scope).forEach(function (button) {
  	      fifSetSaveButtonVisible(button, !!dirty);
  	    });
  	  }

  	  function fifDirtyScopeIsDirty(scope) {
  	    return !!(scope && scope.__fifDirtyState && scope.__fifDirtyState.dirty);
  	  }

  	  function fifRefreshDirtyScope(scope) {
  	    if (!scope || !scope.__fifDirtyState) return false;
  	    const dirty = fifDirtySnapshot(scope) !== scope.__fifDirtyState.baseline;
  	    fifSetDirtyScope(scope, dirty);
  	    return dirty;
  	  }

  	  function fifInstallDirtyScope(scope) {
  	    if (!scope || scope.__fifDirtyInstalled) return scope;
  	    scope.__fifDirtyInstalled = true;
  	    scope.__fifDirtyState = { baseline: fifDirtySnapshot(scope), dirty: false };
  	    fifActiveDirtyScope = scope;
  	    fifSetDirtyScope(scope, false);

  	    const update = function () {
  	      fifRefreshDirtyScope(scope);
  	    };
  	    scope.addEventListener("input", update, true);
  	    scope.addEventListener("change", update, true);
  	    return scope;
  	  }

  	  async function fifRequestCloseServicePortalModal() {
  	    const overlay = document.getElementById(SERVICE_MODAL_ID);
  	    if (!overlay) return true;

  	    if (fifDirtyScopeIsDirty(overlay)) {
  	      const approved = await fifConfirm(
  	        "There are unsaved changes in this window. Closing it will discard those changes.",
  	        {
  	          title: "Discard Unsaved Changes?",
  	          type: "warning",
  	          confirmText: "Discard Changes",
  	          cancelText: "Keep Editing"
  	        }
  	      );
  	      if (!approved) return false;
  	    }

  	    closeServicePortalModal();
  	    return true;
  	  }

  	  function fifVehicleWorkspaceHasUnsavedChanges(company, vehicle) {
  	    if (state.applicationDirty || state.vehicleDataDirty) return true;
  	    if (vehicle) {
  	      try {
  	        if (tyrePlanRows(company, vehicle).length || tyrePlanHasAxleChanges(vehicle)) return true;
  	      } catch (_) {}
  	    }
  	    return false;
  	  }

  	  function fifHasAnyUnsavedChanges() {
  	    if (fifActiveDirtyScope && fifDirtyScopeIsDirty(fifActiveDirtyScope)) return true;
  	    if (state.applicationDirty || state.vehicleDataDirty) return true;

  	    try {
  	      const company = selectedCompany();
  	      const vehicle = selectedVehicle(company);
  	      if (vehicle && (tyrePlanRows(company, vehicle).length || tyrePlanHasAxleChanges(vehicle))) return true;
  	    } catch (_) {}

  	    try {
  	      if (
  	        companyTyreWarehouseInstance &&
  	        typeof companyTyreWarehouseInstance.hasUnsavedChanges === "function" &&
  	        companyTyreWarehouseInstance.hasUnsavedChanges()
  	      ) {
  	        return true;
  	      }
  	    } catch (_) {}

  	    return false;
  	  }

  	  async function fifConfirmWorkspaceDiscard(message) {
  	    return fifConfirm(
  	      message || "There are unsaved changes. Leaving now will discard them.",
  	      {
  	        title: "Discard Unsaved Changes?",
  	        type: "warning",
  	        confirmText: "Discard Changes",
  	        cancelText: "Keep Editing"
  	      }
  	    );
  	  }

  	  function fifSyncPageSaveVisibility(root) {
  	    if (!root || !root.querySelectorAll) return;

  	    root.querySelectorAll("[data-app-save]").forEach(function (button) {
  	      fifSetSaveButtonVisible(button, !!(state.applicationDirty || state.applicationSaving));
  	    });
  	    root.querySelectorAll("[data-vm-save-tyres]").forEach(function (button) {
  	      let changed = false;
  	      try {
  	        const company = selectedCompany();
  	        const vehicle = selectedVehicle(company);
  	        changed = !!(vehicle && (tyrePlanRows(company, vehicle).length || tyrePlanHasAxleChanges(vehicle)));
  	      } catch (_) {}
  	      fifSetSaveButtonVisible(button, !!(changed || state.vehicleBusy));
  	    });
  	  }

  	  function fifBindPageDirtyTracking(root) {
  	    if (!root || root.__fifPageDirtyInstalled) {
  	      fifSyncPageSaveVisibility(root);
  	      return;
  	    }
  	    root.__fifPageDirtyInstalled = true;

  	    const mark = function (event) {
  	      const target = event.target;
  	      if (!target || !target.matches) return;

  	      requestAnimationFrame(function () {
  	        fifSyncPageSaveVisibility(root);
  	      });
  	    };

  	    root.addEventListener("input", mark, true);
  	    root.addEventListener("change", mark, true);
  	    fifSyncPageSaveVisibility(root);
  	  }

  	  function onFifBeforeUnload(event) {
  	    if (!fifHasAnyUnsavedChanges()) return;
  	    event.preventDefault();
  	    event.returnValue = "";
  	  }

  	  function resolveAppData(input) {
  	    try {
  	      if (input && input.data && typeof input.data === "object") return input.data;
  	      if (input && input.User && typeof input === "object") return input;
  	    } catch (_) {}

  	    try {
  	      if (
  	        typeof BackendlessUI !== "undefined" &&
  	        BackendlessUI &&
  	        BackendlessUI.App &&
  	        BackendlessUI.App.data
  	      ) {
  	        return BackendlessUI.App.data;
  	      }
  	    } catch (_) {}

  	    try {
  	      if (typeof window !== "undefined" && window.AppData) {
  	        return window.AppData.data || window.AppData;
  	      }
  	    } catch (_) {}

  	    return null;
  	  }

  	  let APP_DATA = resolveAppData(APP_INPUT);

  	  if (!APP_DATA || !APP_DATA.User) {
  	    await fifAlert("The dashboard could not find App Data.User. The dashboard cannot safely continue without the authenticated user and company data.", {
  	      title: "Dashboard Data Unavailable",
  	      type: "danger",
  	      confirmText: "Close"
  	    });
  	    return {
  	      ok: false,
  	      reason: "App Data.User was not found."
  	    };
  	  }

  	  const existingDashboard = typeof window !== "undefined" ? window.FIFDashboard : null;
  	  const existingDashboardRoot = typeof document !== "undefined" ? document.getElementById(ROOT_ID) : null;
  	  if (existingDashboardRoot && existingDashboard && existingDashboard.version === VERSION && typeof existingDashboard.updateAppData === "function") {
  	    existingDashboard.updateAppData(APP_DATA, { source: "live-reentry" });
  	    return { ok: true, version: VERSION, rootId: ROOT_ID, reused: true, destroy: existingDashboard.destroy };
  	  }

  	  const state = {
  	    activeTab: "vehicles",
  	    viewMode: "current",
  	    selectedCompanyKey: "",
  	    selectedHistoryKey: "",
  	    search: "",
  	    trailerType: "all",
  	    vehicleSortKey: "vehicle",
  	    vehicleSortDir: "asc",

  	    selectedVehicleKey: "",
  	    selectedAssetType: "tractor",
  	    vehicleActiveTab: "",
  	    vehicleMessage: "",
  	    vehicleMessageError: false,
  	    vehicleBusy: false,

  	    vehicleDataEditMode: false,
  	    vehicleDataDraft: null,
  	    vehicleDataOriginal: null,
  	    vehicleDataEssentialDirty: false,
  	    vehicleIdentityEditMode: false,
  	    vehicleIdentityDraft: null,
  	    vehicleIdentityOriginal: null,
  	    vehicleIdentityDirty: false,
  	    vehicleDataDirty: false,
  	    vehicleDataEssentialOpen: false,
  	    vehicleDataIdentityOpen: false,

  	    tyreDraft: null,
  	    tyreMode: "",
  	    tyreSourcePosition: "",
  	    tyreSelectedWarehouseId: "",
  	    tyreChangedIds: {},
  	    tyreObjectDrafts: {},
  	    tyreVehicleDraft: null,
  	    axleConfigMode: false,
  	    tyreOriginalDraft: null,
  	    tyreDragSource: null,
  	    tyreTapSource: null,
  	    tyreDragOverPosition: "",
  	    tyreRemovalMeta: {},
  	    tyreRemoveRequest: null,
  	    tyreOperationOdometer: "",
  	    tyreOperationNotes: "",
  	    tyreMismatchApprovals: {},
  	    tyreDetailsRequest: null,

  	    applicationDraft: null,
  	    applicationCompanyKey: "",
  	    applicationDirty: false,
  	    applicationSaving: false,
  	    applicationStatus: "Ready",

  	    employeeSearch: "",
  	    employeeStatusFilter: "all",
  	    employeeDepartmentFilter: "all",
  	    employeeSortKey: "name",
  	    employeeSortDir: "asc",
  	    employeeEditorTab: "account",

  	    servicePortalView: "control",
  	    vehicleServiceView: "position",
  	    serviceSearch: "",
  	    serviceProviderCategory: "all",
  	    serviceProviderStatus: "active",
  	    serviceJobStatus: "open",
  	    serviceSaving: false,
  	    serviceStatus: "Ready",
  	    serviceModalOpen: false,
  	    serviceProviderEmailTimer: null,
  	    serviceProviderEmailPending: {},
  	    serviceProviderEmailFailureUntil: {},
  	    serviceProviderEmailDeferredUntil: {},
  	    serviceProviderEmailInteractionActive: false,

  	    complianceSearch: "",
  	    complianceStatusFilter: "all",
  	    complianceTypeFilter: "all",
  	    complianceSortKey: "expiry",
  	    complianceSortDir: "asc",
  	    actionableAlertCache: {},
  	    locationEventCache: {},

  	    priorBodyOverflow: document.body.style.overflow || "",
  	    destroyed: false
  	  };

  	  window.addEventListener("beforeunload", onFifBeforeUnload);

  	  const ICONS = {
  	    vehicles: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <path d="M3 13.5V9.8c0-.8.35-1.55.96-2.07l2.1-1.8A3 3 0 0 1 8 5.2h6.9c1.1 0 2.13.6 2.66 1.56l1.03 1.85H20a1 1 0 0 1 1 1v3.89"/>
  	    <path d="M5 13.5h14v3H5z"/>
  	    <circle cx="7.2" cy="17.2" r="1.8"/>
  	    <circle cx="17.2" cy="17.2" r="1.8"/>
  	    <path d="M6 9h10.8"/>
  	    </svg>`,
  	    trailers: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <path d="M3 7.5h14.5v7H3z"/>
  	    <path d="M17.5 12.5h2.1l1.4 1.6v1.4h-3.5"/>
  	    <circle cx="6.2" cy="17" r="1.8"/>
  	    <circle cx="15.2" cy="17" r="1.8"/>
  	    <path d="M5.5 10h9.5"/>
  	    </svg>`,
  	    employees: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <circle cx="9" cy="8" r="3"/>
  	    <path d="M3.8 18.5c.4-3.2 2.1-5 5.2-5s4.8 1.8 5.2 5"/>
  	    <circle cx="17" cy="9" r="2.2"/>
  	    <path d="M14.8 14.2c2.9-.6 5.1.8 5.5 3.8"/>
  	    </svg>`,
  	    tyres: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <circle cx="12" cy="12" r="8"/>
  	    <circle cx="12" cy="12" r="3.2"/>
  	    <path d="M12 4v4.8M12 15.2V20M4 12h4.8M15.2 12H20M6.35 6.35l3.4 3.4M14.25 14.25l3.4 3.4M17.65 6.35l-3.4 3.4M9.75 14.25l-3.4 3.4"/>
  	    </svg>`,
  	    applications: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <rect x="4" y="4" width="6" height="6" rx="1.2"/>
  	    <rect x="14" y="4" width="6" height="6" rx="1.2"/>
  	    <rect x="4" y="14" width="6" height="6" rx="1.2"/>
  	    <rect x="14" y="14" width="6" height="6" rx="1.2"/>
  	    </svg>`,
  	    service: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <path d="M14.8 6.2a4.2 4.2 0 0 0-5.6 5.6L4 17l3 3 5.2-5.2a4.2 4.2 0 0 0 5.6-5.6l-2.5 2.5-2.8-.7-.7-2.8 3-3Z"/>
  	    <path d="m5.8 16.2 2 2"/>
  	    </svg>`,
  	    search: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <circle cx="10.5" cy="10.5" r="6"/>
  	    <path d="m15 15 5 5"/>
  	    </svg>`,
  	    warning: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <path d="M12 3 2.7 20h18.6L12 3Z"/>
  	    <path d="M12 9v5M12 17.3v.2"/>
  	    </svg>`,
  	    close: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <path d="m6 6 12 12M18 6 6 18"/>
  	    </svg>`,
  	    fuelTank: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <path d="M5 4.5h9.5v15H5z"/>
  	    <path d="M7.5 7.5H12"/>
  	    <path d="M14.5 8h2.2l1.8 2.1v6.6c0 .9.6 1.6 1.4 1.6s1.4-.7 1.4-1.6v-5.2l-2.2-2.2"/>
  	    <path d="M8 15.8c0-1.2 1.7-3.1 1.7-3.1s1.7 1.9 1.7 3.1a1.7 1.7 0 1 1-3.4 0Z"/>
  	    </svg>`,
  	    chevron: `
  	    <svg viewBox="0 0 24 24" aria-hidden="true">
  	    <path d="m9 6 6 6-6 6"/>
  	    </svg>`
  	  };

  	  const GLOBAL_VEHICLE_ICON_CFG = {
  	    W: 176,
  	    H: 176,
  	    CX: 88,
  	    CY: 88,
  	    OUTER_R: 44,
  	    DOT_R: 18,
  	    PTR_LEN: 40,
  	    PTR_HALF: 24,
  	    HEADING_OFFSET: 0,
  	    MOVING_SPEED_KMH: 2,
  	    COLORS: {
  	      truckFallback: "#2f32d7",
  	      status: {
  	        moving: "#18a058",
  	        stopped: "#7a7a7a",
  	        warn: "#ee4b2b"
  	      },
  	      stroke: "#101010",
  	      innerRim: "rgba(255,255,255,0.35)",
  	      outline: "#ffffff"
  	    },
  	    OUTLINE_W: 6
  	  };

  	  function globalVehicleTelemetryValue(vehicle, path) {
  	    const location = vehicle && vehicle.Location ? vehicle.Location: {};

  	    if (Object.prototype.hasOwnProperty.call(location, path)) {
  	      return location[path];
  	    }

  	    return String(path || "").split(".").reduce(function (result, key) {
  	      return result && result[key] !== undefined ? result[key]: undefined;
  	    }, location);
  	  }

  	  function globalVehicleIconNumber(value) {
  	    return typeof value === "number" ? value: Number(value);
  	  }

  	  function globalVehicleIconBool(value) {
  	    return value === true || value === 1 || (
  	      typeof value === "string" &&
  	      ["true", "1", "yes", "y", "on"].indexOf(value.toLowerCase()) !== -1
  	    );
  	  }

  	  function globalVehicleIsMoving(vehicle) {
  	    const speed = globalVehicleIconNumber(globalVehicleTelemetryValue(vehicle, "position.speed"));

  	    if (Number.isFinite(speed)) {
  	      return speed > GLOBAL_VEHICLE_ICON_CFG.MOVING_SPEED_KMH;
  	    }

  	    const canSpeed = globalVehicleIconNumber(
  	      vehicle && vehicle.CAN && vehicle.CAN.Speed !== undefined
  	      ? vehicle.CAN.Speed: vehicle && vehicle["can.vehicle.speed"]
  	    );

  	    if (Number.isFinite(canSpeed)) {
  	      return canSpeed > GLOBAL_VEHICLE_ICON_CFG.MOVING_SPEED_KMH;
  	    }

  	    return globalVehicleIconBool(globalVehicleTelemetryValue(vehicle, "movement.status"));
  	  }

  	  function globalVehicleHasWarning(vehicle) {
  	    const limits = vehicle && vehicle.CAN ? vehicle.CAN: {};
  	    const speed = globalVehicleIconNumber(globalVehicleTelemetryValue(vehicle, "position.speed"));
  	    const rpm = globalVehicleIconNumber(globalVehicleTelemetryValue(vehicle, "can.engine.rpm"));
  	    const temp = globalVehicleIconNumber(globalVehicleTelemetryValue(vehicle, "can.engine.temperature"));
  	    const limitSpeed = globalVehicleIconNumber(limits.Speed);
  	    const limitRpm = globalVehicleIconNumber(limits.RPM);
  	    const limitTemp = globalVehicleIconNumber(limits.Temp);

  	    if (Number.isFinite(speed) && Number.isFinite(limitSpeed) && speed > limitSpeed) return true;
  	    if (Number.isFinite(rpm) && Number.isFinite(limitRpm) && rpm > limitRpm) return true;
  	    if (Number.isFinite(temp) && Number.isFinite(limitTemp) && temp > limitTemp) return true;

  	    return false;
  	  }

  	  function globalVehicleIconSvg(vehicle) {
  	    const cfg = GLOBAL_VEHICLE_ICON_CFG;
  	    const heading = globalVehicleIconNumber(globalVehicleTelemetryValue(vehicle, "position.direction"));
  	    const angle = (Number.isFinite(heading) ? heading: 0) + cfg.HEADING_OFFSET;
  	    const warning = globalVehicleHasWarning(vehicle);
  	    const moving = globalVehicleIsMoving(vehicle);
  	    const truckColor = safeColor(fifVehicleColorValue(vehicle), cfg.COLORS.truckFallback);
  	    const statusColor = warning
  	    ? cfg.COLORS.status.warn: moving
  	    ? cfg.COLORS.status.moving: cfg.COLORS.status.stopped;
  	    const tipY = cfg.CY - cfg.OUTER_R - cfg.PTR_LEN;
  	    const baseY = cfg.CY - cfg.OUTER_R + 2;

  	    return `
  	    <svg xmlns="http://www.w3.org/2000/svg" width="${cfg.W}" height="${cfg.H}" viewBox="0 0 ${cfg.W} ${cfg.H}">
  	    <circle cx="${cfg.CX}" cy="${cfg.CY}" r="${cfg.OUTER_R}" fill="none" stroke="${cfg.COLORS.outline}" stroke-width="${cfg.OUTLINE_W}"/>

  	    <g transform="rotate(${angle}, ${cfg.CX}, ${cfg.CY})">
  	    <path d="M ${cfg.CX},${tipY} L ${cfg.CX - cfg.PTR_HALF},${baseY} L ${cfg.CX + cfg.PTR_HALF},${baseY} Z"
  	    fill="none"
  	    stroke="${cfg.COLORS.outline}"
  	    stroke-width="${cfg.OUTLINE_W}"/>
  	    </g>

  	    <circle cx="${cfg.CX}" cy="${cfg.CY}" r="${cfg.OUTER_R}"
  	    fill="${truckColor}"
  	    stroke="${cfg.COLORS.stroke}"
  	    stroke-width="2"/>

  	    <circle cx="${cfg.CX}" cy="${cfg.CY}" r="${cfg.DOT_R}"
  	    fill="${statusColor}"
  	    stroke="${cfg.COLORS.outline}"
  	    stroke-width="2"/>

  	    <circle cx="${cfg.CX}" cy="${cfg.CY}" r="${cfg.DOT_R - 3}"
  	    fill="none"
  	    stroke="${cfg.COLORS.innerRim}"
  	    stroke-width="2"/>

  	    <g transform="rotate(${angle}, ${cfg.CX}, ${cfg.CY})">
  	    <path d="M ${cfg.CX},${tipY} L ${cfg.CX - cfg.PTR_HALF},${baseY} L ${cfg.CX + cfg.PTR_HALF},${baseY} Z"
  	    fill="${truckColor}"
  	    stroke="${cfg.COLORS.stroke}"
  	    stroke-width="2"/>
  	    </g>
  	    </svg>`;
  	  }

  	  function globalVehicleIconUrl(vehicle) {
  	    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(globalVehicleIconSvg(vehicle || {}))}`;
  	  }

  	  function globalVehicleIconMarkup(vehicle, className) {
  	    return `<img class="${escapeAttr(className || "fif-global-vehicle-icon")}" src="${escapeAttr(globalVehicleIconUrl(vehicle))}" alt="" aria-hidden="true">`;
  	  }

  	  function text(value) {
  	    return value === undefined || value === null ? "": String(value);
  	  }

  	  function clean(value) {
  	    return text(value).trim();
  	  }

  	  function lower(value) {
  	    return clean(value).toLowerCase();
  	  }

  	  function isProtectedTrackerKey(value) {
  	    return lower(value).replace(/[\s_-]+/g, "").indexOf("tracker") !== -1;
  	  }



  	  function restoreProtectedTrackerFields(target, source) {
  	    if (!target || !source || typeof target !== "object" || typeof source !== "object") return target;

  	    Object.keys(source).forEach(function (key) {
  	      if (isProtectedTrackerKey(key)) {
  	        target[key] = cloneData(source[key]);
  	        return;
  	      }

  	      if (
  	        source[key] && target[key] &&
  	        typeof source[key] === "object" && typeof target[key] === "object" &&
  	        !Array.isArray(source[key]) && !Array.isArray(target[key])
  	      ) {
  	        restoreProtectedTrackerFields(target[key], source[key]);
  	      }
  	    });

  	    Object.keys(target).forEach(function (key) {
  	      if (isProtectedTrackerKey(key) && !Object.prototype.hasOwnProperty.call(source, key)) {
  	        delete target[key];
  	      }
  	    });

  	    return target;
  	  }

  	  function arr(value) {
  	    return Array.isArray(value) ? value: [];
  	  }

  	  function isObject(value) {
  	    return !!value && typeof value === "object" && !Array.isArray(value);
  	  }

  	  function descriptorValue(value) {
  	    if (
  	      isObject(value) &&
  	      Object.prototype.hasOwnProperty.call(value, "value")
  	    ) {
  	      return value.value;
  	    }

  	    return value;
  	  }

  	  let fifDatabaseRawApi = null;
  	  let fifDatabaseProxiedApi = null;
  	  let fifDatabaseRequestSequence = 0;

  	  function fifIsWritableBackendlessApi(candidate, tableName) {
  	    if (
  	      !candidate ||
  	      !candidate.Data ||
  	      typeof candidate.Data.of !== "function"
  	    ) {
  	      return false;
  	    }

  	    try {
  	      const store = candidate.Data.of(tableName || "Tractors");
  	      return !!(
  	        store &&
  	        typeof store.save === "function" &&
  	        typeof store.findById === "function"
  	      );
  	    } catch (_) {
  	      return false;
  	    }
  	  }

  	  function fifDatabaseApiCandidates() {
  	    const candidates = [];

  	    function add(candidate) {
  	      if (
  	        candidate &&
  	        candidates.indexOf(candidate) === -1
  	      ) {
  	        candidates.push(candidate);
  	      }
  	    }

  	    add(BACKENDLESS_INPUT);

  	    try {
  	      if (typeof Backendless !== "undefined") add(Backendless);
  	    } catch (_) {}

  	    try {
  	      if (typeof globalThis !== "undefined") add(globalThis.Backendless);
  	    } catch (_) {}

  	    try {
  	      if (typeof window !== "undefined") {
  	        add(window.Backendless);
  	        add(window.backendless);
  	        add(window.BackendlessUI && window.BackendlessUI.Backendless);
  	        add(
  	          window.BackendlessUI &&
  	          window.BackendlessUI.App &&
  	          window.BackendlessUI.App.Backendless
  	        );
  	      }
  	    } catch (_) {}

  	    try {
  	      add(readArg("Backendless", "backendless", 2));
  	    } catch (_) {}

  	    try {
  	      add(APP_INPUT && APP_INPUT.Backendless);
  	      add(APP_INPUT && APP_INPUT.backendless);
  	    } catch (_) {}

  	    return candidates;
  	  }

  	  function fifResolveRawWritableBackendlessApi(tableName) {
  	    const candidates = fifDatabaseApiCandidates();

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const candidate = candidates[index];
  	      if (fifIsWritableBackendlessApi(candidate, tableName)) {
  	        return candidate;
  	      }
  	    }

  	    return null;
  	  }

  	  function fifResolveDatabaseApi() {
  	    const candidate = fifResolveRawWritableBackendlessApi("Tractors");
  	    if (!candidate) return null;

  	    if (
  	      candidate === fifDatabaseRawApi &&
  	      fifDatabaseProxiedApi
  	    ) {
  	      return fifDatabaseProxiedApi;
  	    }

  	    fifDatabaseRawApi = candidate;
  	    fifDatabaseProxiedApi = fifOperationBackendlessProxy(candidate);
  	    return fifDatabaseProxiedApi;
  	  }

  	  async function fifWaitForRawWritableBackendlessApi(timeoutMs, tableName) {
  	    const timeout = Math.max(0, Number(timeoutMs) || 0);
  	    const started = Date.now();
  	    let api = fifResolveRawWritableBackendlessApi(tableName);

  	    while (!api && Date.now() - started < timeout) {
  	      await new Promise(function (resolve) {
  	        setTimeout(resolve, 60);
  	      });
  	      api = fifResolveRawWritableBackendlessApi(tableName);
  	    }

  	    return api;
  	  }

  	  async function fifWaitForDatabaseApi(timeoutMs) {
  	    const timeout = Math.max(0, Number(timeoutMs) || 0);
  	    const started = Date.now();
  	    let api = fifResolveDatabaseApi();

  	    while (!api && Date.now() - started < timeout) {
  	      await new Promise(function (resolve) {
  	        setTimeout(resolve, 60);
  	      });
  	      api = fifResolveDatabaseApi();
  	    }

  	    return api;
  	  }

  	  function fifDatabaseOperationNote(value) {
  	    const overlay = document.getElementById(FIF_OPERATION_OVERLAY_ID);
  	    const note = overlay && overlay.querySelector(".fif-operation-note");
  	    if (note) {
  	      note.textContent =
  	        clean(value) ||
  	        "No AppData is changed until the database confirms the write.";
  	    }
  	  }

  	  function fifDatabaseRequestStatus(tableName, phase, requestNumber) {
  	    const label = fifOperationTableLabel(tableName);

  	    if (phase === "connect") {
  	      return "Connecting to the database for " + label + "…";
  	    }

  	    if (phase === "save") {
  	      return (
  	        "Sending " +
  	        label +
  	        " save request #" +
  	        String(requestNumber) +
  	        " to the database…"
  	      );
  	    }

  	    if (phase === "verify") {
  	      return (
  	        "Database save request #" +
  	        String(requestNumber) +
  	        " returned. Verifying " +
  	        label +
  	        "…"
  	      );
  	    }

  	    return "Completing database operation…";
  	  }

  	  async function fifRequireWritableDatabaseStore(tableName, timeoutMs) {
  	    fifUpdateSaveOperation(
  	      fifDatabaseRequestStatus(tableName, "connect", 0)
  	    );

  	    fifDatabaseOperationNote(
  	      "Resolving the real writable Backendless SDK. AppData-only adapters are rejected."
  	    );

  	    const api = await fifWaitForRawWritableBackendlessApi(
  	      timeoutMs || 2500,
  	      tableName
  	    );

  	    if (!api) {
  	      throw new Error(
  	        "No real writable Backendless SDK was found. " +
  	        "Connect the Backendless SDK as the third Custom Code input named Backendless. " +
  	        "No database request was sent and AppData was not changed."
  	      );
  	    }

  	    const store = api.Data.of(tableName);

  	    if (
  	      !store ||
  	      typeof store.save !== "function" ||
  	      typeof store.findById !== "function"
  	    ) {
  	      throw new Error(
  	        "The Backendless " +
  	        tableName +
  	        " store does not expose save and findById. No AppData change was made."
  	      );
  	    }

  	    return { api: api, store: store };
  	  }

  	  function fifBuildSingleBackendlessSavePayload(
  	    tableName,
  	    currentRow,
  	    submittedPayload
  	  ) {
  	    const payload = {};
  	    const current =
  	      currentRow && typeof currentRow === "object"
  	        ? currentRow
  	        : {};
  	    const submitted =
  	      submittedPayload && typeof submittedPayload === "object"
  	        ? submittedPayload
  	        : {};

  	    const serverManagedFields = {
  	      created: true,
  	      updated: true,
  	      ownerId: true,
  	      ___class: true,
  	      __meta: true
  	    };

  	    const writableJsonFields = {
  	      Data: true,
  	      TPositions: true,
  	      TyrePositions: true,
  	      CAN: true
  	    };

  	    Object.keys(current).forEach(function (key) {
  	      if (serverManagedFields[key]) return;

  	      const value = current[key];

  	      if (Array.isArray(value)) return;

  	      if (value && typeof value === "object") {
  	        if (writableJsonFields[key]) {
  	          payload[key] = cloneData(value);
  	        }
  	        return;
  	      }

  	      if (typeof value !== "function" && value !== undefined) {
  	        payload[key] = value;
  	      }
  	    });

  	    Object.keys(submitted).forEach(function (key) {
  	      if (serverManagedFields[key]) return;

  	      const value = submitted[key];

  	      if (Array.isArray(value)) return;

  	      if (value && typeof value === "object") {
  	        if (writableJsonFields[key]) {
  	          payload[key] = cloneData(value);
  	        }
  	        return;
  	      }

  	      if (typeof value !== "function" && value !== undefined) {
  	        payload[key] = value;
  	      }
  	    });

  	    const objectId =
  	      clean(
  	        submitted.objectId ||
  	        current.objectId
  	      );

  	    if (objectId) {
  	      payload.objectId = objectId;
  	    }

  	    if (clean(tableName) === "Tractors") {
  	      const mirrors =
  	        fifExtractTractorTopLevelMirrors(payload);

  	      if (mirrors) {
  	        Object.assign(payload, mirrors);
  	      }
  	    }

  	    return payload;
  	  }

  	  function fifResolveActualBackendlessSdk() {
  	    const candidates = [];

  	    function add(name, candidate) {
  	      if (
  	        candidate &&
  	        !candidates.some(function (entry) {
  	          return entry.candidate === candidate;
  	        })
  	      ) {
  	        candidates.push({
  	          name: name,
  	          candidate: candidate
  	        });
  	      }
  	    }

  	    add("BACKENDLESS_INPUT", BACKENDLESS_INPUT);

  	    try {
  	      if (typeof Backendless !== "undefined") {
  	        add("lexical Backendless", Backendless);
  	      }
  	    } catch (_) {}

  	    try {
  	      if (typeof globalThis !== "undefined") {
  	        add("globalThis.Backendless", globalThis.Backendless);
  	      }
  	    } catch (_) {}

  	    try {
  	      if (typeof window !== "undefined") {
  	        add("window.Backendless", window.Backendless);
  	      }
  	    } catch (_) {}

  	    const capabilityRows = candidates.map(function (entry) {
  	      const candidate = entry.candidate;

  	      return {
  	        name: entry.name,
  	        type: typeof candidate,
  	        hasData: !!(candidate && candidate.Data),
  	        hasDataOf: !!(
  	          candidate &&
  	          candidate.Data &&
  	          typeof candidate.Data.of === "function"
  	        ),
  	        hasUserService: !!(candidate && candidate.UserService),
  	        hasTokenMethod: !!(
  	          candidate &&
  	          candidate.UserService &&
  	          typeof candidate.UserService.getCurrentUserToken === "function"
  	        )
  	      };
  	    });

  	    fifTractorTable("BACKENDLESS SDK CANDIDATES", capabilityRows);

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const candidate = candidates[index].candidate;

  	      if (
  	        candidate &&
  	        candidate.Data &&
  	        typeof candidate.Data.of === "function" &&
  	        candidate.UserService &&
  	        typeof candidate.UserService.getCurrentUserToken === "function"
  	      ) {
  	        fifTractorLog("BACKENDLESS SDK SELECTED", {
  	          name: candidates[index].name,
  	          capabilities: capabilityRows[index]
  	        });

  	        return candidate;
  	      }
  	    }

  	    fifTractorLog(
  	      "NO SUITABLE BACKENDLESS SDK FOUND",
  	      capabilityRows,
  	      "warn"
  	    );

  	    return null;
  	  }

  	  function fifBackendlessSameOriginApiBase() {
  	    if (
  	      typeof window === "undefined" ||
  	      !window.location ||
  	      !window.location.origin
  	    ) {
  	      throw new Error(
  	        "The Dashboard cannot determine the Backendless application origin."
  	      );
  	    }

  	    const origin =
  	      clean(window.location.origin).replace(/\/+$/, "");

  	    if (!/^https?:\/\//i.test(origin)) {
  	      throw new Error(
  	        "The Dashboard is not running from an HTTP application origin."
  	      );
  	    }

  	    return origin + "/api";
  	  }

  	  async function fifBackendlessRestHeaders() {
  	    const headers = {
  	      "Accept": "application/json",
  	      "Content-Type": "application/json",
  	      "Cache-Control": "no-cache",
  	      "Pragma": "no-cache"
  	    };

  	    const sdk = fifResolveActualBackendlessSdk();

  	    fifTractorLog("REST HEADER BUILD START", {
  	      sdkFound: !!sdk,
  	      initialHeaders: fifDebugHeaders(headers)
  	    });

  	    if (
  	      sdk &&
  	      sdk.UserService &&
  	      typeof sdk.UserService.getCurrentUserToken === "function"
  	    ) {
  	      try {
  	        const token = await sdk.UserService.getCurrentUserToken();

  	        if (clean(token)) {
  	          headers["user-token"] = clean(token);
  	        }

  	        fifTractorLog("CURRENT USER TOKEN RESULT", {
  	          tokenPresent: !!clean(token),
  	          tokenLength: clean(token).length,
  	          tokenValue: "[MASKED]"
  	        });
  	      } catch (error) {
  	        fifTractorLog(
  	          "CURRENT USER TOKEN ERROR",
  	          fifDebugError(error),
  	          "warn"
  	        );
  	      }
  	    }

  	    fifTractorLog("FINAL REST HEADERS", fifDebugHeaders(headers));
  	    return headers;
  	  }

  	  async function fifReadBackendlessRestResponse(
  	    response,
  	    operationName
  	  ) {
  	    const responseHeaders = {};

  	    try {
  	      response.headers.forEach(function (value, key) {
  	        responseHeaders[key] = value;
  	      });
  	    } catch (_) {}

  	    fifTractorLog(
  	      operationName + " RESPONSE METADATA",
  	      {
  	        ok: response.ok,
  	        status: response.status,
  	        statusText: response.statusText,
  	        type: response.type,
  	        redirected: response.redirected,
  	        url: response.url,
  	        headers: responseHeaders
  	      },
  	      response.ok ? "log" : "error"
  	    );

  	    let raw = "";

  	    try {
  	      raw = await response.text();
  	    } catch (error) {
  	      fifTractorLog(
  	        operationName + " RESPONSE TEXT READ ERROR",
  	        fifDebugError(error),
  	        "error"
  	      );
  	      throw error;
  	    }

  	    fifTractorLog(
  	      operationName + " RAW RESPONSE BODY",
  	      {
  	        length: raw.length,
  	        raw: raw
  	      },
  	      response.ok ? "log" : "error"
  	    );

  	    let parsed = null;
  	    let parseError = null;

  	    if (clean(raw)) {
  	      try {
  	        parsed = JSON.parse(raw);
  	      } catch (error) {
  	        parseError = error;
  	      }
  	    }

  	    fifTractorLog(
  	      operationName + " PARSED RESPONSE BODY",
  	      {
  	        parsed: parsed,
  	        parseError: parseError ? fifDebugError(parseError) : null
  	      },
  	      parseError ? "warn" : "log"
  	    );

  	    if (!response.ok) {
  	      const serverMessage =
  	        clean(
  	          parsed &&
  	          (
  	            parsed.message ||
  	            parsed.faultString ||
  	            parsed.error
  	          )
  	        ) ||
  	        clean(raw) ||
  	        (
  	          "HTTP " +
  	          String(response.status) +
  	          " " +
  	          clean(response.statusText)
  	        );

  	      const failure = new Error(
  	        operationName + " failed: " + serverMessage
  	      );

  	      fifTractorLog(
  	        operationName + " FAILURE",
  	        fifDebugError(failure),
  	        "error"
  	      );

  	      throw failure;
  	    }

  	    return parsed || {};
  	  }

  	  async function fifPutTractorDirectlyToBackendlessRest(
  	    savePayload
  	  ) {
  	    fifEnsureTractorDebug({
  	      action: "Direct Tractor REST PUT"
  	    });

  	    fifTractorLog("DIRECT PUT ENTRY", {
  	      payload: savePayload,
  	      essential: fifDebugEssential(savePayload),
  	      keys:
  	        savePayload && typeof savePayload === "object"
  	          ? Object.keys(savePayload)
  	          : [],
  	      descriptors: fifDebugDescriptors(savePayload)
  	    });

  	    const objectId = clean(savePayload && savePayload.objectId);

  	    if (!objectId) {
  	      const error = new Error(
  	        "The direct Tractor REST payload has no objectId."
  	      );
  	      fifTractorLog("DIRECT PUT BLOCKED", fifDebugError(error), "error");
  	      throw error;
  	    }

  	    const mirrors = fifExtractTractorTopLevelMirrors(savePayload);

  	    fifTractorLog("MIRRORS EXTRACTED BEFORE PUT", {
  	      mirrors: mirrors,
  	      before: fifDebugEssential(savePayload)
  	    });

  	    if (mirrors) {
  	      Object.assign(savePayload, mirrors);
  	    }

  	    fifTractorLog("PAYLOAD AFTER MIRROR ASSIGNMENT", {
  	      payload: savePayload,
  	      essential: fifDebugEssential(savePayload),
  	      descriptors: fifDebugDescriptors(savePayload)
  	    });

  	    const requiredFields = [
  	      "objectId",
  	      "Data",
  	      "ID",
  	      "FID",
  	      "Registration",
  	      "color",
  	      "LicenseExpiry",
  	      "Range",
  	      "CounterType",
  	      "SARSCompliance",
  	      "SARSRate"
  	    ];

  	    const missingFields = requiredFields.filter(function (field) {
  	      return !Object.prototype.hasOwnProperty.call(savePayload, field);
  	    });

  	    fifTractorLog(
  	      "REQUIRED FIELD CHECK",
  	      {
  	        requiredFields: requiredFields,
  	        actualFields: Object.keys(savePayload),
  	        missingFields: missingFields
  	      },
  	      missingFields.length ? "error" : "log"
  	    );

  	    if (missingFields.length) {
  	      const error = new Error(
  	        "The Tractor REST payload is incomplete. Missing: " +
  	        missingFields.join(", ") +
  	        ". No database request was sent."
  	      );
  	      fifTractorLog("DIRECT PUT BLOCKED", fifDebugError(error), "error");
  	      throw error;
  	    }

  	    const requestBody = JSON.stringify(savePayload);
  	    const parsedBody = JSON.parse(requestBody);

  	    if (typeof window !== "undefined") {
  	      window.__FIF_LAST_TRACTOR_SAVE_PAYLOAD__ = fifDebugClone(parsedBody);
  	      window.__FIF_LAST_TRACTOR_SAVE_PAYLOAD_JSON__ = requestBody;
  	    }

  	    fifTractorLog("EXACT SERIALISED PUT BODY", {
  	      jsonLength: requestBody.length,
  	      json: requestBody,
  	      parsedBody: parsedBody,
  	      essential: fifDebugEssential(parsedBody),
  	      keys: Object.keys(parsedBody),
  	      descriptors: fifDebugDescriptors(parsedBody)
  	    });

  	    const serialisedMirrors = fifExtractTractorTopLevelMirrors(parsedBody);

  	    const serialisedRows = Object.keys(serialisedMirrors || {}).map(function (field) {
  	      return {
  	        field: field,
  	        expected: serialisedMirrors[field],
  	        actual: parsedBody[field],
  	        matches: fifTractorTopLevelMirrorValueMatches(
  	          field,
  	          parsedBody[field],
  	          serialisedMirrors[field]
  	        )
  	      };
  	    });

  	    fifTractorTable("SERIALISED BODY MIRROR CHECK", serialisedRows);

  	    if (
  	      !serialisedMirrors ||
  	      !fifTractorTopLevelMirrorsMatch(parsedBody, serialisedMirrors)
  	    ) {
  	      const error = new Error(
  	        "The serialised Tractor REST body lost one or more top-level properties. No database request was sent."
  	      );
  	      fifTractorLog("SERIALISATION VERIFICATION FAILED", fifDebugError(error), "error");
  	      throw error;
  	    }

  	    const apiBase = fifBackendlessSameOriginApiBase();
  	    const endpoint =
  	      apiBase +
  	      "/data/Tractors/" +
  	      encodeURIComponent(objectId);
  	    const headers = await fifBackendlessRestHeaders();

  	    fifTractorLog("PUT REQUEST CONFIGURATION", {
  	      windowOrigin:
  	        typeof window !== "undefined" && window.location
  	          ? window.location.origin
  	          : null,
  	      apiBase: apiBase,
  	      endpoint: endpoint,
  	      objectId: objectId,
  	      encodedObjectId: encodeURIComponent(objectId),
  	      method: "PUT",
  	      credentials: "include",
  	      cache: "no-store",
  	      headers: fifDebugHeaders(headers),
  	      bodyLength: requestBody.length,
  	      bodyKeys: Object.keys(parsedBody)
  	    });

  	    fifUpdateSaveOperation(
  	      "Sending one direct Tractors REST PUT payload…"
  	    );

  	    fifDatabaseOperationNote(
  	      "The exact JSON body contains Tractor.Data and every Essential top-level property. No SDK save adapter is involved."
  	    );

  	    let response;

  	    try {
  	      fifTractorLog("FETCH PUT START", {
  	        endpoint: endpoint,
  	        at: new Date().toISOString()
  	      });

  	      response = await fetch(endpoint, {
  	        method: "PUT",
  	        headers: headers,
  	        credentials: "include",
  	        cache: "no-store",
  	        body: requestBody
  	      });

  	      fifTractorLog(
  	        "FETCH PUT PROMISE RESOLVED",
  	        {
  	          endpoint: endpoint,
  	          ok: response.ok,
  	          status: response.status,
  	          statusText: response.statusText,
  	          responseUrl: response.url
  	        },
  	        response.ok ? "log" : "error"
  	      );
  	    } catch (error) {
  	      fifTractorLog(
  	        "FETCH PUT NETWORK OR CORS ERROR",
  	        {
  	          endpoint: endpoint,
  	          error: fifDebugError(error)
  	        },
  	        "error"
  	      );
  	      throw error;
  	    }

  	    const saved = await fifReadBackendlessRestResponse(
  	      response,
  	      "Direct Tractors REST PUT"
  	    );

  	    fifTractorLog("PUT RESPONSE OBJECT", {
  	      saved: saved,
  	      essential: fifDebugEssential(saved),
  	      keys:
  	        saved && typeof saved === "object"
  	          ? Object.keys(saved)
  	          : []
  	    });

  	    return {
  	      endpoint: endpoint,
  	      headers: headers,
  	      requestBody: requestBody,
  	      payload: parsedBody,
  	      saved: saved
  	    };
  	  }

  	  async function fifReadTractorDirectlyFromBackendlessRest(
  	    endpoint,
  	    headers
  	  ) {
  	    fifTractorLog("DIRECT GET START", {
  	      endpoint: endpoint,
  	      method: "GET",
  	      credentials: "include",
  	      cache: "no-store",
  	      headers: fifDebugHeaders(headers)
  	    });

  	    fifUpdateSaveOperation(
  	      "Reading the physical Tractors row directly from the REST API…"
  	    );

  	    let response;

  	    try {
  	      response = await fetch(endpoint, {
  	        method: "GET",
  	        headers: headers,
  	        credentials: "include",
  	        cache: "no-store"
  	      });

  	      fifTractorLog(
  	        "FETCH GET PROMISE RESOLVED",
  	        {
  	          endpoint: endpoint,
  	          ok: response.ok,
  	          status: response.status,
  	          statusText: response.statusText,
  	          responseUrl: response.url
  	        },
  	        response.ok ? "log" : "error"
  	      );
  	    } catch (error) {
  	      fifTractorLog(
  	        "FETCH GET NETWORK OR CORS ERROR",
  	        {
  	          endpoint: endpoint,
  	          error: fifDebugError(error)
  	        },
  	        "error"
  	      );
  	      throw error;
  	    }

  	    const readBack = await fifReadBackendlessRestResponse(
  	      response,
  	      "Direct Tractors REST verification"
  	    );

  	    if (typeof window !== "undefined") {
  	      window.__FIF_LAST_TRACTOR_REST_READBACK__ = fifDebugClone(readBack);
  	    }

  	    fifTractorLog("PHYSICAL TRACTOR ROW FROM GET", {
  	      readBack: readBack,
  	      essential: fifDebugEssential(readBack),
  	      keys:
  	        readBack && typeof readBack === "object"
  	          ? Object.keys(readBack)
  	          : [],
  	      descriptors: fifDebugDescriptors(readBack)
  	    });

  	    return readBack;
  	  }

  	  async function fifSaveTractorByExactRestPayload(
  	    submittedPayload,
  	    options
  	  ) {
  	    options = options || {};

  	    fifEnsureTractorDebug({
  	      action: "Exact Tractor REST save"
  	    });

  	    fifTractorLog("EXACT SAVE COORDINATOR ENTRY", {
  	      submittedPayload: submittedPayload,
  	      essential: fifDebugEssential(submittedPayload),
  	      keys:
  	        submittedPayload && typeof submittedPayload === "object"
  	          ? Object.keys(submittedPayload)
  	          : [],
  	      descriptors: fifDebugDescriptors(submittedPayload)
  	    });

  	    const savePayload = cloneData(submittedPayload);
  	    const mirrors = fifExtractTractorTopLevelMirrors(savePayload);

  	    fifTractorLog("EXACT SAVE CLONE AND MIRRORS", {
  	      clone: savePayload,
  	      mirrors: mirrors,
  	      cloneEssential: fifDebugEssential(savePayload)
  	    });

  	    if (mirrors) {
  	      Object.assign(savePayload, mirrors);
  	    }

  	    fifTractorLog("EXACT PAYLOAD HANDED TO PUT", {
  	      payload: savePayload,
  	      essential: fifDebugEssential(savePayload),
  	      descriptors: fifDebugDescriptors(savePayload)
  	    });

  	    const request = await fifPutTractorDirectlyToBackendlessRest(
  	      savePayload
  	    );

  	    fifTractorLog("PUT COMPLETED BEFORE GET", {
  	      requestPayload: request.payload,
  	      putResponse: request.saved,
  	      requestEssential: fifDebugEssential(request.payload),
  	      putResponseEssential: fifDebugEssential(request.saved)
  	    });

  	    const readBack = await fifReadTractorDirectlyFromBackendlessRest(
  	      request.endpoint,
  	      request.headers
  	    );

  	    const expectedMirrors = fifExtractTractorTopLevelMirrors(
  	      request.payload
  	    );

  	    const comparisonRows = Object.keys(expectedMirrors || {}).map(function (field) {
  	      const expected = expectedMirrors[field];
  	      const actual = readBack && readBack[field];

  	      return {
  	        field: field,
  	        expected: expected,
  	        actual: actual,
  	        expectedType: expected === null ? "null" : typeof expected,
  	        actualType: actual === null ? "null" : typeof actual,
  	        matches: fifTractorTopLevelMirrorValueMatches(
  	          field,
  	          actual,
  	          expected
  	        )
  	      };
  	    });

  	    fifTractorTable(
  	      "TOP-LEVEL FIELD-BY-FIELD PUT BODY VS GET ROW",
  	      comparisonRows
  	    );

  	    fifTractorLog("PUT RESPONSE AND GET READ-BACK COMPARISON", {
  	      sentPayload: request.payload,
  	      sentEssential: fifDebugEssential(request.payload),
  	      putResponse: request.saved,
  	      putResponseEssential: fifDebugEssential(request.saved),
  	      getReadBack: readBack,
  	      getReadBackEssential: fifDebugEssential(readBack),
  	      expectedMirrors: expectedMirrors,
  	      mismatchDescription: fifDescribeTractorMirrorMismatch(
  	        readBack,
  	        expectedMirrors || {}
  	      )
  	    });

  	    if (
  	      expectedMirrors &&
  	      !fifTractorTopLevelMirrorsMatch(
  	        readBack,
  	        expectedMirrors
  	      )
  	    ) {
  	      const error = new Error(
  	        "The direct REST PUT body contained every Essential top-level property, but the physical Tractors row did not match: " +
  	        fifDescribeTractorMirrorMismatch(
  	          readBack,
  	          expectedMirrors
  	        ) +
  	        ". This points to Backendless table schema or server-side update logic, not AppData."
  	      );

  	      fifTractorLog(
  	        "TOP-LEVEL PHYSICAL READ-BACK VERIFICATION FAILED",
  	        {
  	          error: fifDebugError(error),
  	          comparisonRows: comparisonRows
  	        },
  	        "error"
  	      );

  	      throw error;
  	    }

  	    if (
  	      typeof options.verify === "function" &&
  	      !options.verify(readBack)
  	    ) {
  	      const error = new Error(
  	        options.verifyMessage ||
  	        "The direct REST update returned, but the physical Tractor row did not contain the expected values."
  	      );

  	      fifTractorLog(
  	        "CUSTOM ESSENTIAL VERIFICATION FAILED",
  	        {
  	          error: fifDebugError(error),
  	          sent: fifDebugEssential(request.payload),
  	          readBack: fifDebugEssential(readBack)
  	        },
  	        "error"
  	      );

  	      throw error;
  	    }

  	    fifTractorLog("REST PUT AND GET VERIFICATION PASSED", {
  	      payload: request.payload,
  	      putResponse: request.saved,
  	      readBack: readBack,
  	      comparisonRows: comparisonRows
  	    });

  	    return {
  	      requestNumber: ++fifDatabaseRequestSequence,
  	      saveResult: request.saved,
  	      value: readBack,
  	      payload: request.payload,
  	      endpoint: request.endpoint
  	    };
  	  }

  	  async function fifSaveDatabaseRowAndReadBack(
  	    tableName,
  	    payload,
  	    options
  	  ) {
  	    options = options || {};

  	    fifTractorLog("CENTRAL SAVE GATEWAY ENTRY", {
  	      tableName: tableName,
  	      payload: payload,
  	      essential:
  	        clean(tableName) === "Tractors"
  	          ? fifDebugEssential(payload)
  	          : null,
  	      keys:
  	        payload && typeof payload === "object"
  	          ? Object.keys(payload)
  	          : [],
  	      descriptors: fifDebugDescriptors(payload),
  	      hasVerifyFunction: typeof options.verify === "function",
  	      verifyMessage: options.verifyMessage || ""
  	    });

  	    if (!payload || typeof payload !== "object") {
  	      throw new Error("The database save payload is missing.");
  	    }

  	    const objectId = clean(payload.objectId);

  	    if (!objectId) {
  	      throw new Error(
  	        "The " +
  	        tableName +
  	        " database payload has no objectId."
  	      );
  	    }

  	    if (clean(tableName) === "Tractors") {
  	      return await fifSaveTractorByExactRestPayload(
  	        payload,
  	        options
  	      );
  	    }

  	    const resolved =
  	      await fifRequireWritableDatabaseStore(
  	        tableName,
  	        options.timeoutMs || 2500
  	      );

  	    const store = resolved.store;

  	    fifUpdateSaveOperation(
  	      "Loading the current " +
  	      fifOperationTableLabel(tableName) +
  	      " row before the single database save…"
  	    );

  	    const currentRow =
  	      await store.findById(objectId);

  	    if (!currentRow || typeof currentRow !== "object") {
  	      throw new Error(
  	        "The existing " +
  	        tableName +
  	        " database row could not be loaded. No save was attempted."
  	      );
  	    }

  	    const savePayload =
  	      fifBuildSingleBackendlessSavePayload(
  	        tableName,
  	        currentRow,
  	        payload
  	      );

  	    if (clean(tableName) === "Tractors") {
  	      const finalMirrors =
  	        fifExtractTractorTopLevelMirrors(savePayload);

  	      if (finalMirrors) {
  	        Object.assign(savePayload, finalMirrors);
  	      }
  	    }

  	    const requestNumber =
  	      ++fifDatabaseRequestSequence;

  	    fifUpdateSaveOperation(
  	      "Sending one " +
  	      fifOperationTableLabel(tableName) +
  	      " database save payload #" +
  	      String(requestNumber) +
  	      "…"
  	    );

  	    fifDatabaseOperationNote(
  	      clean(tableName) === "Tractors"
  	        ? "The same payload contains Tractor.Data plus ID, FID, Registration, color, LicenseExpiry, Range, CounterType, SARSCompliance and SARSRate. No second save will be attempted."
  	        : "The complete writable record is being sent in one database save payload."
  	    );

  	    const saveResult =
  	      await store.save(savePayload);

  	    fifUpdateSaveOperation(
  	      "The single database save returned. Reading the row back for verification…"
  	    );

  	    const readBack =
  	      await store.findById(objectId);

  	    if (!readBack || typeof readBack !== "object") {
  	      throw new Error(
  	        "The database save returned, but " +
  	        tableName +
  	        "." +
  	        objectId +
  	        " could not be read back. AppData was not changed."
  	      );
  	    }

  	    if (
  	      clean(tableName) === "Tractors"
  	    ) {
  	      const expectedMirrors =
  	        fifExtractTractorTopLevelMirrors(savePayload);

  	      if (
  	        expectedMirrors &&
  	        !fifTractorTopLevelMirrorsMatch(
  	          readBack,
  	          expectedMirrors
  	        )
  	      ) {
  	        throw new Error(
  	          "The single Tractor save payload contained all Essential top-level mirrors, but Backendless read-back did not match: " +
  	          fifDescribeTractorMirrorMismatch(
  	            readBack,
  	            expectedMirrors
  	          ) +
  	          ". No second save was attempted and AppData was not changed."
  	        );
  	      }
  	    }

  	    if (
  	      typeof options.verify === "function" &&
  	      !options.verify(readBack)
  	    ) {
  	      throw new Error(
  	        options.verifyMessage ||
  	        "The database row was read back, but it does not contain the expected saved values. AppData was not changed."
  	      );
  	    }

  	    return {
  	      requestNumber: requestNumber,
  	      saveResult: saveResult,
  	      value: readBack,
  	      payload: savePayload,
  	      store: store
  	    };
  	  }

  	  const BACKENDLESS_API = {};
  	  Object.defineProperty(BACKENDLESS_API, "Data", {
  	    configurable: false,
  	    enumerable: true,
  	    get: function () {
  	      const api = fifResolveDatabaseApi();
  	      return api && api.Data ? api.Data : null;
  	    }
  	  });
  	  Object.defineProperty(BACKENDLESS_API, "DataQueryBuilder", {
  	    configurable: false,
  	    enumerable: true,
  	    get: function () {
  	      const api = fifResolveDatabaseApi();
  	      return api && api.DataQueryBuilder ? api.DataQueryBuilder : null;
  	    }
  	  });

  	  function permissionTokens(value) {
  	    const raw = Array.isArray(value) ? value: String(value || "").split(/[;,|]/g);
  	    return raw.map(function (item) {
  	      return clean(item).toLowerCase();
  	    }).filter(Boolean);
  	  }



  	  const FIF_APP_PERMISSION_OPTIONS = ["Office", "Road", "Bowser"];
  	  const FIF_OFFICE_PERMISSION_OPTIONS = ["LiveTrack", "Bowser", "Dash", "Locations"];
  	  const FIF_DASH_PERMISSION_OPTIONS = [
  	    "Applications",
  	    "Users",
  	    "Vehicles",
  	    "Trailers",
  	    "Fuel",
  	    "Tyres",
  	    "Finances",
  	    "Compliance",
  	    "Overview",
  	    "VehicleData",
  	    "Alerts",
  	    "Maintenance",
  	    "Rig",
  	    "Service"
  	  ];
  	  const FIF_PERMISSION_ALIASES = {
  	    Applications: ["application", "applications"],
  	    Users: ["user", "users", "employee", "employees"],
  	    Vehicles: ["vehicle", "vehicles", "vehichle", "vehichles"],
  	    Trailers: ["trailer", "trailers", "implement", "implements"],
  	    Fuel: ["fuel", "fuels", "fuel report", "fuel capture", "on road fuel", "on-road fuel"],
  	    Tyres: ["tyre", "tyres", "tire", "tires"],
  	    Finances: ["finance", "finances", "financial", "financials", "financial ledger", "financialledger"],
  	    Overview: ["overview", "snapshot", "dashboard overview", "dashboardoverview", "vehicle overview", "vehicleoverview"],
  	    Rig: ["rig", "rigs", "rig builder", "rigbuilder"],
  	    Maintenance: ["maintenance"],
  	    Service: ["service", "services"],
  	    Compliance: ["compliance", "compliances", "regulatory compliance"],
  	    VehicleData: ["vehicledata", "vehicle data", "physical vehicle data", "vehicle setup"],
  	    Alerts: ["alert", "alerts", "vehicle alerts", "operational alerts", "notifications"]
  	  };

  	  function permissionRawValues(value) {
  	    const raw = Array.isArray(value) ? value : String(value || "").split(/[;,|]/g);
  	    return uniqueStrings(raw.map(clean).filter(Boolean));
  	  }

  	  function permissionNormalKey(value) {
  	    return lower(value).replace(/[^a-z0-9]+/g, "");
  	  }

  	  function permissionOptionAliases(option) {
  	    return uniqueStrings([option].concat(FIF_PERMISSION_ALIASES[option] || []));
  	  }

  	  function permissionMatchesOption(value, option) {
  	    const key = permissionNormalKey(value);
  	    return permissionOptionAliases(option).some(function (candidate) {
  	      return key === permissionNormalKey(candidate);
  	    });
  	  }

  	  function managedPermissionValues(value, options) {
  	    const raw = permissionRawValues(value);
  	    return options.filter(function (option) {
  	      return raw.some(function (item) {
  	        return permissionMatchesOption(item, option);
  	      });
  	    });
  	  }

  	  function unmanagedPermissionValues(value, options) {
  	    return permissionRawValues(value).filter(function (item) {
  	      return !options.some(function (option) {
  	        return permissionMatchesOption(item, option);
  	      });
  	    });
  	  }

  	  function permissionStorageValue(previousValue, values) {
  	    const cleaned = uniqueStrings(values);
  	    return Array.isArray(previousValue) ? cleaned : cleaned.join(",");
  	  }

  	  let CURRENT_USER = APP_DATA.User || {};
  	  let USER_APP_TOKENS = [];
  	  let USER_OFFICE_TOKENS = [];
  	  let USER_SETTINGS_TOKENS = [];
  	  let USER_HAS_OFFICE_APP = false;
  	  let USER_HAS_DASH_OFFICE = false;
  	  let USER_HAS_SETTINGS_OFFICE = false;
  	  let USER_HAS_VEHICLE_SETTINGS = false;

  	  let CAN_ACCESS_DASHBOARD = false;
  	  let CAN_ACCESS_APPLICATIONS = false;
  	  let CAN_ACCESS_USERS = false;
  	  let CAN_ACCESS_VEHICLES = false;
  	  let CAN_ACCESS_TRAILERS = false;
  	  let CAN_ACCESS_FUEL = false;
  	  let CAN_ACCESS_TYRES = false;

  	  let CAN_ACCESS_MAINTENANCE = false;
  	  let CAN_ACCESS_SERVICE = false;
  	  let CAN_ACCESS_COMPLIANCE = false;

  	  let CAN_ACCESS_VEHICLE_DATA = false;
  	  let CAN_ACCESS_ALERTS = false;
  	  let CAN_ACCESS_LOCATION_EVENTS = false;

  	  let CAN_EDIT_VEHICLE_PHYSICAL = false;
  	  let CAN_MANAGE_SERVICE = false;
  	  let CAN_MANAGE_MAINTENANCE = false;
  	  let CAN_MANAGE_WORKSHOP = false;

  	  let CAN_EDIT_COMPLIANCE = false;
  	  let CAN_CAPTURE_ON_ROAD_FUEL = false;

  	  let CAN_VIEW_EMPLOYEES = false;
  	  let CAN_MANAGE_EMPLOYEES = false;
  	  let CAN_MANAGE_EMPLOYEE_ACCESS = false;
  	  let CAN_CREATE_USERS = false;
  	  let CAN_RESET_EMPLOYEE_PASSWORDS = false;
  	  let CAN_VIEW_EMPLOYEE_PAYROLL = false;

  	  function currentUserHasApp(option) {
  	    return managedPermissionValues(CURRENT_USER.APP, FIF_APP_PERMISSION_OPTIONS).indexOf(option) !== -1;
  	  }

  	  function currentUserHasOffice(option) {
  	    return currentUserHasApp("Office") && managedPermissionValues(CURRENT_USER.Office, FIF_OFFICE_PERMISSION_OPTIONS).indexOf(option) !== -1;
  	  }

  	  function currentUserHasSetting(option) {
  	    return currentUserHasOffice("Dash") && managedPermissionValues(CURRENT_USER.Settings, FIF_DASH_PERMISSION_OPTIONS).indexOf(option) !== -1;
  	  }

  	  function currentUserGrantableApps() {
  	    return managedPermissionValues(CURRENT_USER.APP, FIF_APP_PERMISSION_OPTIONS);
  	  }

  	  function currentUserGrantableOffice() {
  	    if (!currentUserHasApp("Office")) return [];
  	    return managedPermissionValues(CURRENT_USER.Office, FIF_OFFICE_PERMISSION_OPTIONS);
  	  }

  	  function currentUserGrantableSettings() {
  	    if (!currentUserHasOffice("Dash")) return [];
  	    return managedPermissionValues(CURRENT_USER.Settings, FIF_DASH_PERMISSION_OPTIONS);
  	  }

  	  const FIF_USER_ADMIN_SERVICE = "FIFUserAdmin";
  	  const FIF_USER_ADMIN_PASSWORD_METHOD = "changePassword";

  	  function employeeIsCurrentUser(employee) {
  	    if (!employee || !CURRENT_USER) return false;
  	    return employeeSameIdentity(employee, CURRENT_USER);
  	  }

  	  function employeeSelfAccessLocked(employee) {
  	    return !!employee && employeeIsCurrentUser(employee);
  	  }

  	  function employeeIsDirector(employee) {
  	    return permissionNormalKey(employee && employee.Role) === "director";
  	  }

  	  function currentUserIsDirector() {
  	    return employeeIsDirector(CURRENT_USER);
  	  }

  	  function userCanResetEmployeePassword(employee) {
  	    return !!employee && !employeeIsDirector(employee) && CAN_RESET_EMPLOYEE_PASSWORDS && !employeeIsCurrentUser(employee);
  	  }

  	  function userCanEditAssetPhysical(asset) {
  	    return assetIsTrailer(asset) ? CAN_ACCESS_TRAILERS : CAN_ACCESS_VEHICLES;
  	  }
  	function userCanAccessAssetFunction(asset, setting) {
  	    if (!userCanAccessAsset(asset)) return false;
  	    if (setting === "Vehicles") return !assetIsTrailer(asset) && CAN_ACCESS_VEHICLES;
  	    if (setting === "Trailers") return assetIsTrailer(asset) && CAN_ACCESS_TRAILERS;
  	    if (setting === "Fuel") return !assetIsTrailer(asset) && CAN_ACCESS_FUEL;
  	    if (setting === "Tyres") return CAN_ACCESS_TYRES;
  	    if (setting === "Maintenance") return CAN_ACCESS_MAINTENANCE;
  	    if (setting === "Service") return CAN_ACCESS_SERVICE;
  	    if (setting === "Compliance") return CAN_ACCESS_COMPLIANCE;
  	    if (setting === "VehicleData") return !assetIsTrailer(asset) && CAN_ACCESS_VEHICLE_DATA;
  	    if (setting === "Alerts") return CAN_ACCESS_ALERTS;
  	    if (setting === "Events") return !assetIsTrailer(asset) && CAN_ACCESS_LOCATION_EVENTS;
  	    return false;
  	  }

  	  function fifPermissionError(message) {
  	    const error = new Error(message || "This function is not assigned in your permission tree.");
  	    error.code = "FIF_PERMISSION_DENIED";
  	    return error;
  	  }

  	  function fifRequirePermission(condition, message) {
  	    if (!condition) throw fifPermissionError(message);
  	    return true;
  	  }
  	function currentPermissionSnapshot() {
  	    return {
  	      APP: currentUserGrantableApps(),
  	      Office: currentUserGrantableOffice(),
  	      Settings: currentUserGrantableSettings(),
  	      Home: managedPermissionValues(CURRENT_USER && CURRENT_USER.Home, FIF_OFFICE_PERMISSION_OPTIONS)[0] || "",
  	      access: {
  	        dashboard: CAN_ACCESS_DASHBOARD,
  	        applications: CAN_ACCESS_APPLICATIONS,
  	        users: CAN_ACCESS_USERS,
  	        vehicles: CAN_ACCESS_VEHICLES,
  	        trailers: CAN_ACCESS_TRAILERS,
  	        fuel: CAN_ACCESS_FUEL,
  	        tyres: CAN_ACCESS_TYRES,
  	        maintenance: CAN_ACCESS_MAINTENANCE,
  	        service: CAN_ACCESS_SERVICE,
  	        compliance: CAN_ACCESS_COMPLIANCE,
  	        vehicleData: CAN_ACCESS_VEHICLE_DATA,
  	        alerts: CAN_ACCESS_ALERTS,
  	        locationEvents: CAN_ACCESS_LOCATION_EVENTS
  	      }
  	    };
  	  }

  	  function notifyPermissionConsumers() {
  	    state.actionableAlertCache = {};
  	    if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  	    try {
  	      window.dispatchEvent(new CustomEvent("fif:permissions-changed", {
  	        detail: {
  	          user: APP_DATA.User,
  	          permissions: currentPermissionSnapshot()
  	        }
  	      }));
  	    } catch (error) {

  	    }
  	  }
  	function refreshCurrentUserPermissions(refreshDerived) {
  	    CURRENT_USER = APP_DATA.User || CURRENT_USER || {};
  	    USER_APP_TOKENS = permissionTokens(CURRENT_USER.APP);
  	    USER_OFFICE_TOKENS = permissionTokens(CURRENT_USER.Office);
  	    USER_SETTINGS_TOKENS = permissionTokens(CURRENT_USER.Settings);
  	    USER_HAS_OFFICE_APP = currentUserHasApp("Office");
  	    USER_HAS_DASH_OFFICE = USER_HAS_OFFICE_APP && currentUserHasOffice("Dash");
  	    USER_HAS_SETTINGS_OFFICE = USER_HAS_DASH_OFFICE;
  	    USER_HAS_VEHICLE_SETTINGS = USER_HAS_DASH_OFFICE && currentUserHasSetting("Vehicles");

  	    CAN_ACCESS_DASHBOARD = USER_HAS_DASH_OFFICE;
  	    CAN_ACCESS_APPLICATIONS = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Applications");
  	    CAN_ACCESS_USERS = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Users");
  	    CAN_ACCESS_VEHICLES = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Vehicles");
  	    CAN_ACCESS_TRAILERS = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Trailers");
  	    CAN_ACCESS_FUEL = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Fuel");
  	    CAN_ACCESS_TYRES = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Tyres");
  	    CAN_ACCESS_MAINTENANCE = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Maintenance");
  	    CAN_ACCESS_SERVICE = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Service");
  	    CAN_ACCESS_COMPLIANCE = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Compliance");
  	    CAN_ACCESS_VEHICLE_DATA = CAN_ACCESS_DASHBOARD && currentUserHasSetting("VehicleData");
  	    CAN_ACCESS_ALERTS = CAN_ACCESS_DASHBOARD && currentUserHasSetting("Alerts");
  	    CAN_ACCESS_LOCATION_EVENTS = CAN_ACCESS_DASHBOARD && CAN_ACCESS_VEHICLES && currentUserHasOffice("Locations");

  	    CAN_EDIT_VEHICLE_PHYSICAL = CAN_ACCESS_VEHICLES || CAN_ACCESS_TRAILERS;
  	    CAN_MANAGE_SERVICE = CAN_ACCESS_SERVICE;
  	    CAN_MANAGE_MAINTENANCE = CAN_ACCESS_MAINTENANCE;
  	    CAN_MANAGE_WORKSHOP = CAN_MANAGE_SERVICE || CAN_MANAGE_MAINTENANCE;
  	    CAN_EDIT_COMPLIANCE = CAN_ACCESS_COMPLIANCE && (CAN_ACCESS_VEHICLES || CAN_ACCESS_TRAILERS);
  	    CAN_CAPTURE_ON_ROAD_FUEL = CAN_ACCESS_FUEL && CAN_ACCESS_VEHICLES;

  	    CAN_VIEW_EMPLOYEES = CAN_ACCESS_USERS;
  	    CAN_MANAGE_EMPLOYEES = CAN_ACCESS_USERS;
  	    CAN_MANAGE_EMPLOYEE_ACCESS = CAN_ACCESS_USERS;
  	    CAN_CREATE_USERS = CAN_ACCESS_USERS && currentUserIsDirector();
  	    CAN_RESET_EMPLOYEE_PASSWORDS = CAN_ACCESS_USERS && currentUserIsDirector();
  	    CAN_VIEW_EMPLOYEE_PAYROLL = CAN_ACCESS_USERS;

  	    if (refreshDerived && typeof refreshServicePortalPermissions === "function") refreshServicePortalPermissions();
  	  }

  	  refreshCurrentUserPermissions(false);

  	  function userCanAccessMainTab(tab) {
  	    if (!CAN_ACCESS_DASHBOARD) return false;
  	    if (tab === "vehicles") return CAN_ACCESS_VEHICLES;
  	    if (tab === "trailers") return CAN_ACCESS_TRAILERS;
  	    if (tab === "employees") return CAN_ACCESS_USERS;
  	    if (tab === "tyres") return CAN_ACCESS_TYRES;
  	    if (tab === "applications") return CAN_ACCESS_APPLICATIONS;
  	    return false;
  	  }

  	  function availableMainTabs() {
  	    return ["vehicles", "trailers", "employees", "tyres", "applications"].filter(userCanAccessMainTab);
  	  }

  	  function userCanAccessAsset(asset) {
  	    return assetIsTrailer(asset) ? CAN_ACCESS_TRAILERS : CAN_ACCESS_VEHICLES;
  	  }
  	function userCanAccessVehicleTab(tab, vehicle) {
  	    const trailer = assetIsTrailer(vehicle);
  	    const baseAccess = trailer ? CAN_ACCESS_TRAILERS : CAN_ACCESS_VEHICLES;
  	    if (!baseAccess) return false;
  	    if (tab === "physical") return !trailer && CAN_ACCESS_VEHICLES && CAN_ACCESS_VEHICLE_DATA;
  	    if (tab === "service") return CAN_ACCESS_SERVICE;
  	    if (tab === "maintenance") return CAN_ACCESS_MAINTENANCE;
  	    if (tab === "tyres") return CAN_ACCESS_TYRES;
  	    if (tab === "compliance") return CAN_ACCESS_COMPLIANCE;
  	    return false;
  	  }

  	function defaultVehicleManagerTab(vehicle) {
  	    if (!vehicle || !userCanAccessAsset(vehicle)) return "";
  	    const candidates = assetIsTrailer(vehicle)
  	      ? ["service", "maintenance", "tyres", "compliance"]
  	      : ["physical", "service", "maintenance", "tyres", "compliance"];
  	    return candidates.find(function (tab) { return userCanAccessVehicleTab(tab, vehicle); }) || "";
  	  }

  	function normalisePermissionNavigation(company) {
  	    if (!CAN_ACCESS_DASHBOARD) {
  	      state.selectedVehicleKey = "";
  	      state.activeTab = "";
  	      state.vehicleActiveTab = "";
  	      return;
  	    }

  	    if (state.selectedVehicleKey) {
  	      const asset = selectedVehicle(company);
  	      if (!asset || !userCanAccessAsset(asset)) {
  	        state.selectedVehicleKey = "";
  	        state.vehicleActiveTab = "";
  	      } else {
  	        const fallbackTab = defaultVehicleManagerTab(asset);
  	        if (!fallbackTab) {
  	          state.selectedVehicleKey = "";
  	          state.selectedAssetType = "";
  	          state.vehicleActiveTab = "";
  	        } else if (!userCanAccessVehicleTab(state.vehicleActiveTab || fallbackTab, asset)) {
  	          state.vehicleActiveTab = fallbackTab;
  	        }
  	      }
  	    }

  	    if ((!CAN_ACCESS_ALERTS && state.vehicleSortKey === "alerts") || (!CAN_ACCESS_LOCATION_EVENTS && state.vehicleSortKey === "events")) {
  	      state.vehicleSortKey = "vehicle";
  	      state.vehicleSortDir = "asc";
  	    }

  	    if (!state.selectedVehicleKey && !userCanAccessMainTab(state.activeTab)) {
  	      state.activeTab = availableMainTabs()[0] || "";
  	    }
  	  }

  	  function renderPermissionBoundary(title, message) {
  	    return `<section class="fifdash-permission-boundary">
  	      <div>
  	        <span>Fleet In Form Access</span>
  	        <h2>${escapeHtml(title)}</h2>
  	        <p>${escapeHtml(message)}</p>
  	      </div>
  	    </section>`;
  	  }

  	  function getDeep(object,
  	    path,
  	    fallback) {
  	    let current = object;

  	    for (let index = 0; index < path.length; index += 1) {
  	      if (current === undefined || current === null) return fallback;
  	      current = current[path[index]];
  	    }

  	    return current === undefined || current === null ? fallback: current;
  	  }

  	  function firstValue(values, fallback) {
  	    for (let index = 0; index < values.length; index += 1) {
  	      const value = descriptorValue(values[index]);
  	      if (value !== undefined && value !== null && clean(value) !== "") return value;
  	    }

  	    return fallback;
  	  }

  	  function numberValue(value) {
  	    const unwrapped = descriptorValue(value);
  	    const parsed = Number(unwrapped);
  	    return Number.isFinite(parsed) ? parsed: null;
  	  }

  	  function numberOr(value, fallback) {
  	    const parsed = numberValue(value);
  	    return parsed === null ? fallback: parsed;
  	  }

  	  function uniqueStrings(values) {
  	    const result = [];
  	    const seen = Object.create(null);

  	    arr(values).forEach(function (value) {
  	      const item = clean(value);
  	      const key = item.toLowerCase();
  	      if (!item || seen[key]) return;
  	      seen[key] = true;
  	      result.push(item);
  	    });

  	    return result;
  	  }

  	  function escapeHtml(value) {
  	    return text(value)
  	    .replace(/&/g,
  	      "&amp;")
  	    .replace(/</g,
  	      "&lt;")
  	    .replace(/>/g,
  	      "&gt;")
  	    .replace(/\"/g,
  	      "&quot;")
  	    .replace(/'/g,
  	      "&#039;");
  	  }

  	  function escapeAttr(value) {
  	    return escapeHtml(value).replace(/`/g,
  	      "&#096;");
  	  }

  	  function formatNumber(value,
  	    decimals) {
  	    const numeric = numberValue(value);
  	    if (numeric === null) return "—";

  	    return numeric.toLocaleString(undefined, {
  	      minimumFractionDigits: decimals || 0,
  	      maximumFractionDigits: decimals || 0
  	    });
  	  }

  	  function formatDistance(value) {
  	    const numeric = numberValue(value);
  	    return numeric === null ? "—": `${formatNumber(numeric, numeric < 100 ? 1: 0)} km`;
  	  }

  	  function formatHours(value) {
  	    const numeric = numberValue(value);
  	    return numeric === null ? "—": `${formatNumber(numeric, numeric < 100 ? 1: 0)} h`;
  	  }

  	  function formatLitres(value) {
  	    const numeric = numberValue(value);
  	    return numeric === null ? "—": `${formatNumber(numeric, numeric < 100 ? 1: 0)} L`;
  	  }

  	  function formatCurrency(value) {
  	    const numeric = numberValue(value);
  	    return numeric === null ? "—": `R ${formatNumber(numeric, 2)}`;
  	  }

  	  function formatCount(value) {
  	    const numeric = numberValue(value);
  	    return numeric === null ? "0": formatNumber(numeric, 0);
  	  }

  	  function safeColor(value, fallback) {
  	    const candidate = clean(value);
  	    return /^#[0-9a-f]{3,8}$/i.test(candidate) ? candidate: fallback || "#cc6633";
  	  }

  	  function companyKey(company, index) {
  	    return clean(firstValue([
  	      company && company.objectId,
  	      company && company.CompanyId,
  	      company && company.ID,
  	      company && company.Name
  	    ], `company-${index}`));
  	  }

  	  function companyName(company) {
  	    const profile = getDeep(company, ["Data", "Profile"], {});

  	    return clean(firstValue([
  	      profile && profile.Company_Name,
  	      profile && profile.Trading_As,
  	      company && company.Name,
  	      company && company.CompanyName,
  	      company && company.CompanyId,
  	      company && company.ID
  	    ], "Company"));
  	  }

  	  const OPERATING_COMPANY_PREFERENCE_VERSION = 1;
  	  const OPERATING_COMPANY_COLLATOR = (function () {
  	    try {
  	      return new Intl.Collator(undefined, {
  	        numeric: true,
  	        sensitivity: "base",
  	        ignorePunctuation: false
  	      });
  	    } catch (_) {
  	      return null;
  	    }
  	  })();

  	  function compareOperatingCompanyText(left, right) {
  	    const leftText = clean(left);
  	    const rightText = clean(right);

  	    if (OPERATING_COMPANY_COLLATOR) {
  	      return OPERATING_COMPANY_COLLATOR.compare(leftText, rightText);
  	    }

  	    try {
  	      return leftText.localeCompare(rightText, undefined, {
  	        numeric: true,
  	        sensitivity: "base"
  	      });
  	    } catch (_) {
  	      const leftLower = leftText.toLowerCase();
  	      const rightLower = rightText.toLowerCase();
  	      if (leftLower < rightLower) return -1;
  	      if (leftLower > rightLower) return 1;
  	      return 0;
  	    }
  	  }

  	  function compareOperatingCompanies(left, right) {
  	    const byName = compareOperatingCompanyText(companyName(left), companyName(right));
  	    if (byName) return byName;
  	    return compareOperatingCompanyText(companyKey(left, 0), companyKey(right, 0));
  	  }

  	  function operatingCompanyPreferenceUserKey() {
  	    return clean(firstValue([
  	      CURRENT_USER && CURRENT_USER.objectId,
  	      CURRENT_USER && CURRENT_USER.UserId,
  	      CURRENT_USER && CURRENT_USER.userId,
  	      CURRENT_USER && CURRENT_USER.ID,
  	      CURRENT_USER && CURRENT_USER.Employee_ID,
  	      CURRENT_USER && CURRENT_USER.Email,
  	      CURRENT_USER && CURRENT_USER.email
  	    ], "anonymous")).toLowerCase();
  	  }

  	  function operatingCompanyPreferenceStorageKey() {
  	    return [
  	      "FIF",
  	      "OperatingCompany",
  	      OPERATING_COMPANY_PREFERENCE_VERSION,
  	      encodeURIComponent(operatingCompanyPreferenceUserKey())
  	    ].join(":");
  	  }

  	  function operatingCompanyPreferenceStorageAvailable() {
  	    try {
  	      if (!window.localStorage) return false;
  	      const testKey = "__fif_operating_company_test__";
  	      window.localStorage.setItem(testKey, "1");
  	      window.localStorage.removeItem(testKey);
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  }

  	  function readOperatingCompanyPreference() {
  	    if (!operatingCompanyPreferenceStorageAvailable()) return null;

  	    try {
  	      const raw = window.localStorage.getItem(operatingCompanyPreferenceStorageKey());
  	      if (!raw) return null;

  	      try {
  	        const parsed = JSON.parse(raw);
  	        if (parsed && typeof parsed === "object") {
  	          return {
  	            companyKey: clean(parsed.companyKey),
  	            companyName: clean(parsed.companyName)
  	          };
  	        }
  	      } catch (_) {
  	        return {
  	          companyKey: clean(raw),
  	          companyName: ""
  	        };
  	      }
  	    } catch (_) {}

  	    return null;
  	  }

  	  function saveOperatingCompanyPreference(selectedKey) {
  	    if (!operatingCompanyPreferenceStorageAvailable()) return false;

  	    const cleanKey = clean(selectedKey);
  	    let selected = null;

  	    for (let index = 0; index < COMPANY_LIST.length; index += 1) {
  	      if (companyKey(COMPANY_LIST[index], index) === cleanKey) {
  	        selected = COMPANY_LIST[index];
  	        break;
  	      }
  	    }

  	    if (!selected) return false;

  	    try {
  	      window.localStorage.setItem(
  	        operatingCompanyPreferenceStorageKey(),
  	        JSON.stringify({
  	          version: OPERATING_COMPANY_PREFERENCE_VERSION,
  	          companyKey: cleanKey,
  	          companyName: companyName(selected),
  	          updatedAt: new Date().toISOString()
  	        })
  	      );
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  }

  	  function resolveInitialOperatingCompanyKey() {
  	    const preference = readOperatingCompanyPreference();
  	    let resolvedKey = "";

  	    if (preference && preference.companyKey) {
  	      for (let index = 0; index < COMPANY_LIST.length; index += 1) {
  	        if (companyKey(COMPANY_LIST[index], index) === preference.companyKey) {
  	          resolvedKey = preference.companyKey;
  	          break;
  	        }
  	      }
  	    }

  	    if (!resolvedKey && preference && preference.companyName) {
  	      for (let index = 0; index < COMPANY_LIST.length; index += 1) {
  	        if (compareOperatingCompanyText(companyName(COMPANY_LIST[index]), preference.companyName) === 0) {
  	          resolvedKey = companyKey(COMPANY_LIST[index], index);
  	          break;
  	        }
  	      }
  	    }

  	    if (!resolvedKey) {
  	      resolvedKey = companyKey(COMPANY_LIST[0], 0);
  	    }

  	    saveOperatingCompanyPreference(resolvedKey);
  	    return resolvedKey;
  	  }

  	  function companies() {
  	    const userCompanies = arr(getDeep(APP_DATA, ["User", "Companies"], []));
  	    const rootCompanies = arr(getDeep(APP_DATA, ["Companies"], []));
  	    const combined = [];
  	    const seen = Object.create(null);

  	    userCompanies.concat(rootCompanies).forEach(function (company, index) {
  	      const key = companyKey(company, index);
  	      if (!key || seen[key]) return;
  	      seen[key] = true;
  	      combined.push(company);
  	    });

  	    return combined.sort(compareOperatingCompanies);
  	  }

  	  const COMPANY_LIST = companies();

  	  if (!COMPANY_LIST.length) {
  	    await fifAlert("No companies were found in App Data.User.Companies. At least one company is required before the dashboard can open.", {
  	      title: "No Companies Available",
  	      type: "warning",
  	      confirmText: "Close"
  	    });
  	    return {
  	      ok: false,
  	      reason: "No companies were found."
  	    };
  	  }

  	  function selectedCompany() {
  	    for (let index = 0; index < COMPANY_LIST.length; index += 1) {
  	      if (companyKey(COMPANY_LIST[index], index) === state.selectedCompanyKey) {
  	        return COMPANY_LIST[index];
  	      }
  	    }

  	    return COMPANY_LIST[0];
  	  }

  	  function tractors(company) {
  	    return arr(company && company.Tractors);
  	  }

  	  function towedAssets(company) {
  	    return arr(company && company.Trailers);
  	  }

  	  function tyres(company) {
  	    return arr(company && company.Tyres);
  	  }

  	  function persistedApplications(company) {
  	    const top = descriptorValue(getDeep(company, ["Manifest", "Applications"], []));
  	    const nested = descriptorValue(getDeep(company, ["Data", "Manifest", "Applications"], []));

  	    if (Array.isArray(top)) return uniqueStrings(top);
  	    if (Array.isArray(nested)) return uniqueStrings(nested);

  	    if (typeof top === "string") return uniqueStrings(top.split(","));
  	    if (typeof nested === "string") return uniqueStrings(nested.split(","));

  	    return [];
  	  }

  	  function applications(company) {
  	    if (
  	      state.applicationCompanyKey === state.selectedCompanyKey &&
  	      Array.isArray(state.applicationDraft)
  	    ) {
  	      return state.applicationDraft.slice();
  	    }

  	    return persistedApplications(company);
  	  }

  	  function applicationStatusLabel() {
  	    if (state.applicationSaving) return "Saving...";
  	    if (state.applicationDirty) return "Unsaved changes";
  	    return state.applicationStatus || "Ready";
  	  }

  	  function beginApplicationDraft(company) {
  	    if (
  	      state.applicationCompanyKey !== state.selectedCompanyKey ||
  	      !Array.isArray(state.applicationDraft)
  	    ) {
  	      state.applicationDraft = persistedApplications(company).slice();
  	      state.applicationCompanyKey = state.selectedCompanyKey;
  	    }

  	    state.applicationDirty = true;
  	    state.applicationStatus = "Unsaved changes";
  	    return state.applicationDraft;
  	  }

  	  function discardApplicationDraft(status) {
  	    state.applicationDraft = null;
  	    state.applicationCompanyKey = "";
  	    state.applicationDirty = false;
  	    state.applicationSaving = false;
  	    state.applicationStatus = status || "Ready";
  	  }

  	  function applicationDraftResult(ok, message) {
  	    return {
  	      ok: !!ok,
  	      message: message || ""
  	    };
  	  }

  	  function addApplicationDraft(company, name) {
  	    if (!CAN_ACCESS_APPLICATIONS) return applicationDraftResult(false, "Application functionality is not assigned in your Dashboard Settings.");
  	    const cleanName = clean(name);
  	    const current = applications(company);
  	    if (!cleanName) return applicationDraftResult(false, "Please enter an application name.");

  	    const exists = current.some(function (item) {
  	      return lower(item) === lower(cleanName);
  	    });
  	    if (exists) return applicationDraftResult(false, "That application already exists.");

  	    const list = beginApplicationDraft(company);
  	    list.push(cleanName);
  	    state.applicationDraft = list;
  	    return applicationDraftResult(true, "");
  	  }

  	  function renameApplicationDraft(company, index, name) {
  	    if (!CAN_ACCESS_APPLICATIONS) return applicationDraftResult(false, "Application functionality is not assigned in your Dashboard Settings.");
  	    const cleanName = clean(name);
  	    const current = applications(company);

  	    if (!cleanName) return applicationDraftResult(false, "Please enter an application name.");
  	    if (index < 0 || index >= current.length) return applicationDraftResult(false, "That application could not be found.");

  	    const exists = current.some(function (item, itemIndex) {
  	      return itemIndex !== index && lower(item) === lower(cleanName);
  	    });
  	    if (exists) return applicationDraftResult(false, "That application already exists.");

  	    const list = beginApplicationDraft(company);
  	    list[index] = cleanName;
  	    state.applicationDraft = list;
  	    return applicationDraftResult(true, "");
  	  }

  	  function removeApplicationDraft(company, index) {
  	    if (!CAN_ACCESS_APPLICATIONS) return false;
  	    const list = beginApplicationDraft(company);
  	    if (index < 0 || index >= list.length) return false;
  	    list.splice(index, 1);
  	    state.applicationDraft = list;
  	    return true;
  	  }

  	  function applicationSetListNode(container, apps) {
  	    if (!container || typeof container !== "object") return;
  	    const existing = container.Applications;

  	    if (
  	      existing &&
  	      typeof existing === "object" &&
  	      !Array.isArray(existing) &&
  	      Object.prototype.hasOwnProperty.call(existing, "value")
  	    ) {
  	      existing.value = apps.slice();
  	      existing.editable = true;
  	      existing.selector = "list";
  	      return;
  	    }

  	    container.Applications = apps.slice();
  	  }

  	  function applyApplicationsToCompany(company, apps) {
  	    fifCompanyAliases(company).forEach(function (alias) {
  	      if (!alias || typeof alias !== "object") return;
  	      if (!alias.Manifest || typeof alias.Manifest !== "object" || Array.isArray(alias.Manifest)) alias.Manifest = {};
  	      if (!alias.Data || typeof alias.Data !== "object" || Array.isArray(alias.Data)) alias.Data = {};
  	      if (!alias.Data.Manifest || typeof alias.Data.Manifest !== "object" || Array.isArray(alias.Data.Manifest)) alias.Data.Manifest = {};
  	      applicationSetListNode(alias.Manifest, apps);
  	      applicationSetListNode(alias.Data.Manifest, apps);
  	    });
  	  }

  	  function applicationIsDescriptor(value) {
  	    return !!(
  	      value &&
  	      typeof value === "object" &&
  	      !Array.isArray(value) &&
  	      Object.prototype.hasOwnProperty.call(value, "value") &&
  	      Object.prototype.hasOwnProperty.call(value, "selector")
  	    );
  	  }

  	  function sanitizeApplicationCompanyForBackendless(value) {
  	    if (value === null || value === undefined) return value;
  	    if (["string", "number", "boolean"].indexOf(typeof value) !== -1) return value;
  	    if (applicationIsDescriptor(value)) return sanitizeApplicationCompanyForBackendless(value.value);
  	    if (Array.isArray(value)) return value.map(sanitizeApplicationCompanyForBackendless);

  	    if (typeof value === "object") {
  	      const result = {};
  	      Object.keys(value).forEach(function (key) {
  	        if (key === "CompanyId") return;
  	        result[key] = sanitizeApplicationCompanyForBackendless(value[key]);
  	      });
  	      return result;
  	    }

  	    return value;
  	  }

  	  async function saveApplicationDraft(company) {
  	    refreshCurrentUserPermissions(false);
  	    if (!CAN_ACCESS_APPLICATIONS) {
  	      await fifAlert("Application functionality is not assigned in your Dashboard Settings.", {
  	        title: "Application Access Required", type: "warning", confirmText: "Close"
  	      });
  	      return;
  	    }
  	    if (state.applicationSaving) return;
  	    if (!state.applicationDirty || !Array.isArray(state.applicationDraft)) {
  	      await fifAlert("There are no application changes to save.", {
  	        title: "Nothing to Save",
  	        type: "info",
  	        confirmText: "Close"
  	      });
  	      return;
  	    }

  	    if (!company || !company.objectId) {
  	      await fifAlert("The selected company does not contain an objectId, so its applications cannot be saved to the Companies table.", {
  	        title: "Company Record Unavailable",
  	        type: "danger",
  	        confirmText: "Close"
  	      });
  	      return;
  	    }

  	    if (!BACKENDLESS_API || !BACKENDLESS_API.Data || typeof BACKENDLESS_API.Data.of !== "function") {
  	      await fifAlert("The database is unavailable. The application changes remain unsaved.", {
  	        title: "Save Unavailable",
  	        type: "danger",
  	        confirmText: "Close"
  	      });
  	      return;
  	    }

  	    const apps = state.applicationDraft.slice();
  	    const payload = sanitizeApplicationCompanyForBackendless(company);
  	    if (!payload.Manifest || typeof payload.Manifest !== "object") payload.Manifest = {};
  	    if (!payload.Data || typeof payload.Data !== "object") payload.Data = {};
  	    if (!payload.Data.Manifest || typeof payload.Data.Manifest !== "object") payload.Data.Manifest = {};
  	    payload.Manifest.Applications = apps.slice();
  	    payload.Data.Manifest.Applications = apps.slice();

  	    state.applicationSaving = true;
  	    state.applicationStatus = "Saving...";
  	    render();
  	    const operation = fifBeginSaveOperation("Saving company applications…");

  	    try {
  	      const saved = await BACKENDLESS_API.Data.of("Companies").save(payload);
  	      fifReconcileCompanyAppData(company, payload, saved || payload);
  	      applyApplicationsToCompany(company, apps);
  	      if (saved && saved.updated !== undefined) company.updated = saved.updated;
  	      discardApplicationDraft("Saved");
  	      fifCompleteSaveOperation(operation, "Company applications saved.");
  	      render();
  	      await fifAlert("The application list for " + companyName(company) + " was saved successfully.", {
  	        title: "Applications Saved",
  	        type: "success",
  	        confirmText: "Done",
  	        details: [{
  	          label: "Applications", value: String(apps.length)
  	        }]
  	      });
  	    } catch (error) {
  	      state.applicationSaving = false;
  	      state.applicationStatus = "Save failed";
  	      fifFailSaveOperation(operation, error);
  	      render();
  	      await fifAlert(error && (error.message || error.faultString) ? (error.message || error.faultString): "The application list could not be saved.", {
  	        title: "Application Save Failed",
  	        type: "danger",
  	        confirmText: "Close"
  	      });
  	    }
  	  }

  	  const APPLICATION_TEXT_PROMPT_ID = "fif-application-text-prompt";

  	  function closeApplicationTextPrompt() {
  	    document.getElementById(APPLICATION_TEXT_PROMPT_ID)?.remove();
  	  }

  	  function openApplicationTextPrompt(options) {
  	    options = options || {};
  	    closeApplicationTextPrompt();

  	    const overlay = document.createElement("div");
  	    overlay.id = APPLICATION_TEXT_PROMPT_ID;
  	    overlay.innerHTML = `
  	    <div class="fif-app-text-card" role="dialog" aria-modal="true" aria-labelledby="fif-app-text-title">
  	    <div class="fif-app-text-accent"></div>
  	    <header>
  	    <div class="fif-app-text-icon">${ICONS.applications}</div>
  	    <div>
  	    <span>Fleet In Form</span>
  	    <h2 id="fif-app-text-title">${escapeHtml(options.title || "Application")}</h2>
  	    <p>${escapeHtml(options.subtitle || "Enter an application name.")}</p>
  	    </div>
  	    </header>
  	    <main>
  	    <label>
  	    <span>Application name</span>
  	    <input type="text" data-app-text-input maxlength="120" value="${escapeAttr(options.value || "")}" placeholder="${escapeAttr(options.placeholder || "e.g. Spraying")}">
  	    </label>
  	    <div class="fif-app-text-error" data-app-text-error></div>
  	    </main>
  	    <footer>
  	    <button type="button" class="secondary" data-app-text-cancel>Cancel</button>
  	    <button type="button" class="primary" data-app-text-confirm>${escapeHtml(options.confirmText || "Apply")}</button>
  	    </footer>
  	    </div>`;

  	    document.body.appendChild(overlay);
  	    const input = overlay.querySelector("[data-app-text-input]");
  	    const errorNode = overlay.querySelector("[data-app-text-error]");

  	    function cancel() {
  	      closeApplicationTextPrompt();
  	    }
  	    function confirm() {
  	      const value = clean(input && input.value);
  	      let result = applicationDraftResult(true, "");
  	      if (typeof options.onConfirm === "function") result = options.onConfirm(value) || result;
  	      if (result && result.ok === false) {
  	        if (errorNode) errorNode.textContent = result.message || "Please check the value.";
  	        input?.focus();
  	        return;
  	      }
  	      closeApplicationTextPrompt();
  	      render();
  	    }

  	    overlay.querySelector("[data-app-text-cancel]")?.addEventListener("click", cancel);
  	    overlay.querySelector("[data-app-text-confirm]")?.addEventListener("click", confirm);
  	    overlay.addEventListener("click", function (event) {
  	      if (event.target === overlay) cancel();
  	    });
  	    input?.addEventListener("keydown",
  	      function (event) {
  	        if (event.key === "Escape") {
  	          event.preventDefault(); cancel();
  	        }
  	        if (event.key === "Enter") {
  	          event.preventDefault(); confirm();
  	        }
  	      });

  	    setTimeout(function () {
  	      input?.focus(); input?.select();
  	    },
  	      0);
  	  }

  	  function trailerKind(asset) {
  	    return clean(firstValue([
  	      asset && asset.Type,
  	      getDeep(asset, ["Data", "Schema", "TypeMirror"], ""),
  	      getDeep(asset, ["Data", "Type"], "")
  	    ], "Trailer"));
  	  }

  	  function assetIdentity(asset,
  	    index,
  	    fallback) {
  	    const canonicalVehicleId = clean(firstValue([
  	      fifVehicleIdentityValue(asset, "FID", ""),
  	      fifVehicleIdentityValue(asset, "Registration", "")
  	    ], ""));
  	    return clean(firstValue([
  	      canonicalVehicleId,
  	      asset && asset.ID,
  	      asset && asset.TyreNumber,
  	      asset && asset.Tyre_Number,
  	      asset && asset.SerialNumber,
  	      asset && asset.Serial_Number,
  	      asset && asset.Name,
  	      asset && asset.objectId
  	    ], `${fallback || "Asset"} ${index + 1}`));
  	  }

  	  function assetSubtitle(asset,
  	    tab) {
  	    if (tab === "vehicles") {
  	      const vehicleType = clean(fifVehicleClassificationValue(asset, "VehicleType", ""));
  	      const make = clean(fifVehicleIdentityValue(asset, "Make", ""));
  	      const model = clean(fifVehicleIdentityValue(asset, "Model", ""));
  	      const year = clean(fifVehicleIdentityValue(asset, "Year", ""));
  	      return [vehicleType, make, model, year].filter(Boolean).join(" · ") || "Vehicle";
  	    }

  	    if (tab === "trailers") {
  	      const application = clean(firstValue([
  	        asset && asset.Application,
  	        getDeep(asset, ["Data", "Application"], ""),
  	        getDeep(asset, ["Data", "Implement", "Application"], "")
  	      ], ""));
  	      const kind = trailerKind(asset);
  	      return [kind,
  	        application].filter(Boolean).join(" · ") || "Towed asset";
  	    }

  	    const brand = clean(firstValue([
  	      asset && asset.Brand,
  	      asset && asset.Make,
  	      asset && asset.Manufacturer,
  	      getDeep(asset, ["Data", "Brand"], "")
  	    ], ""));
  	    const model = clean(firstValue([
  	      asset && asset.Model,
  	      asset && asset.Pattern,
  	      getDeep(asset, ["Data", "Model"], "")
  	    ], ""));
  	    const size = clean(firstValue([
  	      asset && asset.Size,
  	      asset && asset.TyreSize,
  	      asset && asset.Tyre_Size,
  	      getDeep(asset, ["Data", "Size"], "")
  	    ], ""));

  	    return [brand,
  	      model,
  	      size].filter(Boolean).join(" · ") || "Tyre";
  	  }

  	  const VEHICLE_STATUS_OPTIONS = [
  	    "Active",
  	    "Decommissioned",
  	    "Broken Down",
  	    "In For Service",
  	    "In For Repairs",
  	    "Inactive"
  	  ];

  	  function vehicleCanonicalStatus(value, fallback) {
  	    const original = clean(descriptorValue(value));
  	    const key = lower(original).replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  	    if (!key) return fallback || "Inactive";
  	    if (["active", "operational", "available", "all in order"].indexOf(key) !== -1) return "Active";
  	    if (["decommissioned", "retired", "scrapped", "scrap"].indexOf(key) !== -1) return "Decommissioned";
  	    if (["broken down", "breakdown", "immobilised", "immobilized", "out of service", "fault"].indexOf(key) !== -1) return "Broken Down";
  	    if (["in for service", "service", "servicing", "scheduled service", "at service provider"].indexOf(key) !== -1) return "In For Service";
  	    if (["in for repairs", "in repair", "repairs", "repair", "workshop repair", "at workshop"].indexOf(key) !== -1) return "In For Repairs";
  	    if (["inactive", "standby", "parked", "off duty", "unavailable"].indexOf(key) !== -1) return "Inactive";
  	    return VEHICLE_STATUS_OPTIONS.indexOf(original) !== -1 ? original : (fallback || "Inactive");
  	  }



  	  function assetStatus(asset, tab) {
  	    if (tab === "vehicles" || tab === "trailers") {
  	      return vehicleCanonicalStatus(firstValue([
  	        getDeep(asset, ["Data", "Vehicle", "Identity", "Status"], ""),
  	        getDeep(asset, ["Data", "Vehicle", "Status"], ""),
  	        asset && asset.Status
  	      ], "Inactive"), "Inactive");
  	    }

  	    return clean(descriptorValue(firstValue([
  	      asset && asset.Status,
  	      getDeep(asset, ["Data", "Trailer", "Status"], ""),
  	      getDeep(asset, ["Data", "Status"], ""),
  	      getDeep(asset, ["Data", "General", "Status"], "")
  	    ], tab === "tyres" ? "In service" : "Active")));
  	  }

  	  const FIF_ACTION_STYLE_ID = "fif-actionable-alerts-v211-style";

  	  function tractorMileage(vehicle) {
  	    return fifVehicleCurrentReading(vehicle);
  	  }

  	  function currentOdometer(asset) {
  	    return tractorMileage(asset);
  	  }

  	  function vehicleUsesHoursCounter(vehicle) {
  	    return serviceSetupCounterType(vehicle) === "Hours";
  	  }

  	  function vehicleOperationalCounter(vehicle) {
  	    return tractorMileage(vehicle);
  	  }

  	  function vehiclePeriodCounter(view) {
  	    return numberValue(view && view.Distance);
  	  }

  	  function vehicleOdometerCounter(vehicle) {
  	    return vehicleUsesHoursCounter(vehicle) ? null : vehicleOperationalCounter(vehicle);
  	  }

  	  function vehicleHobbsCounter(vehicle) {
  	    return vehicleUsesHoursCounter(vehicle) ? vehicleOperationalCounter(vehicle) : null;
  	  }

  	  function vehiclePeriodDistance(vehicle, view) {
  	    return vehicleUsesHoursCounter(vehicle) ? null : vehiclePeriodCounter(view);
  	  }

  	  function vehiclePeriodHours(vehicle, view) {
  	    if (!vehicleUsesHoursCounter(vehicle)) return null;

  	    // Hour-based assets store their current-period usage in Tractorview.Hours.
  	    // Older records may have used Distance as the operational-period counter,
  	    // so keep that only as a fallback when Hours is genuinely absent.
  	    const hours = numberValue(view && view.Hours);
  	    return hours !== null ? hours : vehiclePeriodCounter(view);
  	  }

  	  const FIF_DEFAULT_SARS_REBATE_RATE = 0;

  	  function fifVehicleSarsRebateRate(vehicle) {
  	    const value = numberValue(fifVehicleFuelAndEnergyValue(vehicle, "SARSRate", null));
  	    return value === null || value < 0 ? FIF_DEFAULT_SARS_REBATE_RATE : value;
  	  }

  	  function fifAlertSeverityRank(value) {
  	    return ({ critical: 0, high: 1, warning: 2, info: 3 })[lower(value)] ?? 4;
  	  }

  	  function fifAlertSeverityLabel(value) {
  	    const key = lower(value);
  	    return key === "critical" ? "Critical": key === "high" ? "High": key === "warning" ? "Warning": "Information";
  	  }

  	  function fifAlertDate(value) {
  	    if (value === null || value === undefined || value === "") return null;
  	    const resolved = descriptorValue(value);
  	    if (resolved instanceof Date) {
  	      return Number.isNaN(resolved.getTime()) ? null : new Date(resolved.getTime());
  	    }

  	    let date = null;
  	    if (typeof resolved === "number" && Number.isFinite(resolved)) {
  	      let timestamp = resolved;
  	      const magnitude = Math.abs(timestamp);
  	      if (magnitude >= 1000000000 && magnitude < 100000000000) timestamp *= 1000;
  	      else if (magnitude >= 100000000000000000) timestamp /= 1000000;
  	      else if (magnitude >= 100000000000000) timestamp /= 1000;
  	      date = new Date(timestamp);
  	    } else {
  	      const raw = clean(resolved);
  	      if (!raw) return null;
  	      if (/^-?\d{10,19}$/.test(raw)) {
  	        let timestamp = Number(raw);
  	        if (!Number.isFinite(timestamp)) return null;
  	        const digits = raw.replace(/^-/, "").length;
  	        if (digits <= 11) timestamp *= 1000;
  	        else if (digits >= 17) timestamp /= 1000000;
  	        else if (digits >= 14) timestamp /= 1000;
  	        date = new Date(timestamp);
  	      } else {
  	        date = new Date(raw);
  	      }
  	    }
  	    return !date || Number.isNaN(date.getTime()) ? null : date;
  	  }

  	  function fifDaysUntil(value) {
  	    const date = fifAlertDate(value);
  	    if (!date) return null;
  	    const today = new Date();
  	    const start = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
  	    const target = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  	    return Math.ceil((target - start) / 86400000);
  	  }

  	  function fifAlertDateLabel(value) {
  	    const date = fifAlertDate(value);
  	    if (!date) return "—";
  	    return date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  	  }



  	  function fifLegacyNotificationAlerts(asset) {
  	    const result = [];
  	    const issues = arr(getDeep(asset, ["Notifications", "issues"], []));
  	    const warnings = arr(getDeep(asset, ["Notifications", "warnings"], []));
  	    issues.forEach(function (item, index) {
  	      const message = clean(typeof item === "string" ? item: firstValue([item && item.Message, item && item.Title, item && item.message], "Operational issue"));
  	      result.push({
  	        key: "LegacyIssue:" + index + ":" + message,
  	        category: "Vehicle",
  	        code: "LEGACY_ISSUE",
  	        severity: "high",
  	        title: clean(item && item.Title) || "Operational issue",
  	        message: message,
  	        action: "vehicle-overview",
  	        actionLabel: "Open Vehicle"
  	      });
  	    });
  	    warnings.forEach(function (item, index) {
  	      const message = clean(typeof item === "string" ? item: firstValue([item && item.Message, item && item.Title, item && item.message], "Operational warning"));
  	      result.push({
  	        key: "LegacyWarning:" + index + ":" + message,
  	        category: "Vehicle",
  	        code: "LEGACY_WARNING",
  	        severity: "warning",
  	        title: clean(item && item.Title) || "Operational warning",
  	        message: message,
  	        action: "vehicle-overview",
  	        actionLabel: "Open Vehicle"
  	      });
  	    });
  	    return result;
  	  }

  	  function fifVehicleTyresForAlerts(company, vehicle) {
  	    const result = [];
  	    const seen = Object.create(null);
  	    const vehicleId = objectIdOf(vehicle);
  	    const vehicleCode = clean(firstValue([vehicle && vehicle.ID, fifVehicleIdentityValue(vehicle, "FID", "")], ""));
  	    arr(vehicle && vehicle.Tyres).concat(tyres(company).filter(function (tyre) {
  	      const linkedObjectId = clean(firstValue([tyre && tyre.Vehicle_ObjectId, tyre && tyre.VehicleObjectId], ""));
  	      const linkedId = clean(firstValue([tyre && tyre.Vehicle_ID, tyre && tyre.VehicleId], ""));
  	      return (vehicleId && linkedObjectId === vehicleId) || (vehicleCode && linkedId === vehicleCode);
  	    })).forEach(function (tyre) {
  	      const id = clean(firstValue([tyre && tyre.objectId, tyre && tyre.ID, tyre && tyre.FID, tyre && tyre.Serial_Number], ""));
  	      if (!id || seen[id]) return;
  	      seen[id] = true;
  	      result.push(tyre);
  	    });
  	    return result;
  	  }

  	  function fifTyreAlertLabel(tyre) {
  	    return clean(firstValue([
  	      tyre && tyre.ID,
  	      tyre && tyre.FID,
  	      tyre && tyre.Tyre_Number,
  	      tyre && tyre.Serial_Number,
  	      tyre && tyre.SerialNumber
  	    ], "Tyre"));
  	  }

  	  function fifTyrePositionForAlert(tyre) {
  	    const history = fifTyreHistoryObject(tyre);
  	    return clean(firstValue([
  	      tyre && tyre.Current_Position,
  	      tyre && tyre.Position,
  	      getDeep(history, ["Current", "Position"], "")
  	    ], ""));
  	  }

  	  function fifTyreWarningThresholdKm(tyre) {
  	    const history = fifTyreHistoryObject(tyre);
  	    const threshold = numberValue(getDeep(history, ["Current", "Warning_Threshold_KM"], null));
  	    return threshold !== null && threshold > 0 ? threshold: null;
  	  }

  	  function fifTyreWarningThresholdHours(tyre) {
  	    const history = fifTyreHistoryObject(tyre);
  	    const threshold = numberValue(getDeep(history, ["Current", "Warning_Threshold_Hours"], null));
  	    return threshold !== null && threshold > 0 ? threshold: null;
  	  }

  	  function fifTyreWarningThresholdForVehicle(tyre, vehicle) {
  	    return serviceSetupCounterType(vehicle) === "Hours"
  	      ? fifTyreWarningThresholdHours(tyre)
  	      : fifTyreWarningThresholdKm(tyre);
  	  }

  	  function fifTyreRemainingMileageForAlert(tyre) {
  	    const expected = numberValue(firstValue([
  	      tyre && tyre.Expected_Mileage,
  	      tyre && tyre.ExpectedMileage
  	    ], null));
  	    if (expected === null || expected <= 0) return null;

  	    const direct = numberValue(firstValue([
  	      tyre && tyre.Remaining_Mileage,
  	      tyre && tyre.RemainingMileage,
  	      tyre && tyre.Remaining_KM,
  	      tyre && tyre.RemainingKm
  	    ], null));
  	    if (direct !== null) return direct;

  	    const current = numberValue(firstValue([
  	      tyre && tyre.Current_Mileage,
  	      tyre && tyre.CurrentMileage
  	    ], null));

  	    if (current === null) return null;
  	    return expected - current;
  	  }

  	  function fifFuelConsumptionAlert(company, vehicle, add) {
  	    const current = vehicle && vehicle.ViewC;
  	    if (!current) return;
  	    const distance = numberValue(current.Distance);
  	    const litres = numberValue(current.Litres);
  	    if (litres !== null && litres > 0 && (distance === null || distance <= 0)) {
  	      add({
  	        key: "Fuel:" + objectIdOf(vehicle) + ":NoDistance",
  	        category: "Fuel",
  	        code: "FUEL_WITHOUT_DISTANCE",
  	        severity: "high",
  	        title: "Fuel recorded without distance",
  	        message: formatLitres(litres) + " is recorded for the current period, but no usable distance is available. Consumption cannot be trusted until the period data is corrected.",
  	        actual: formatLitres(litres),
  	        threshold: "Distance required",
  	        action: "fuel-capture",
  	        actionLabel: "Open Fuel Capture"
  	      });
  	      return;
  	    }
  	    if (distance === null || litres === null || distance < 300 || litres <= 0) return;
  	    const history = arr(vehicle && vehicle.ViewH).map(function (view) {
  	      return { distance: numberValue(view && view.Distance), litres: numberValue(view && view.Litres) };
  	    }).filter(function (row) {
  	      return row.distance !== null && row.litres !== null && row.distance >= 300 && row.litres > 0;
  	    }).slice(-6);
  	    if (history.length < 2) return;
  	    const baselineDistance = history.reduce(function (sum, row) { return sum + row.distance; }, 0);
  	    const baselineLitres = history.reduce(function (sum, row) { return sum + row.litres; }, 0);
  	    if (baselineDistance <= 0 || baselineLitres <= 0) return;
  	    const currentRate = litres / distance * 100;
  	    const baselineRate = baselineLitres / baselineDistance * 100;
  	    const variance = baselineRate > 0 ? (currentRate - baselineRate) / baselineRate * 100: 0;
  	    if (variance < 15) return;
  	    const severity = variance >= 40 ? "critical": variance >= 25 ? "high": "warning";
  	    add({
  	      key: "Fuel:" + objectIdOf(vehicle) + ":ConsumptionSpike",
  	      category: "Fuel",
  	      code: "FUEL_CONSUMPTION_SPIKE",
  	      severity: severity,
  	      title: "Fuel consumption spike",
  	      message: "Current consumption is " + formatNumber(currentRate, 1) + " L/100 km, " + formatNumber(variance, 1) + "% above the vehicle's weighted historical baseline of " + formatNumber(baselineRate, 1) + " L/100 km.",
  	      actual: formatNumber(currentRate, 1) + " L/100 km",
  	      threshold: formatNumber(baselineRate, 1) + " L/100 km baseline",
  	      action: "fuel-capture",
  	      actionLabel: "Review Fuel Capture"
  	    });
  	  }
  	function buildVehicleAlerts(company, vehicle) {
  	    const alerts = [];
  	    const byKey = Object.create(null);
  	    const vehicleObjectId = objectIdOf(vehicle);
  	    const isTrailerAsset = assetIsTrailer(vehicle);
  	    const mileage = tractorMileage(vehicle);
  	    const today = new Date();
  	    const add = function (input) {
  	      if (!input || !input.key) return;
  	      const alert = Object.assign({
  	        category: "Vehicle",
  	        code: "GENERAL",
  	        severity: "warning",
  	        title: "Attention required",
  	        message: "",
  	        action: "vehicle-overview",
  	        actionLabel: "Open Vehicle",
  	        sourceId: "",
  	        position: "",
  	        actual: "",
  	        threshold: ""
  	      }, input);
  	      const existing = byKey[alert.key];
  	      if (existing) {
  	        if (fifAlertSeverityRank(alert.severity) < fifAlertSeverityRank(existing.severity)) Object.assign(existing, alert);
  	        return;
  	      }
  	      byKey[alert.key] = alert;
  	      alerts.push(alert);
  	    };

  	    if (mileage === null) {
  	      const usesHours = serviceSetupCounterType(vehicle) === "Hours";
  	      add({
  	        key: "Vehicle:" + vehicleObjectId + ":" + (usesHours ? "HobbsMissing" : "MileageMissing"),
  	        category: "Data Quality",
  	        code: usesHours ? "TRACTOR_HOBBS_MISSING" : "TRACTOR_MILEAGE_MISSING",
  	        severity: "critical",
  	        title: isTrailerAsset
  	          ? usesHours ? "Implement hour reading is missing" : "Implement mileage is missing"
  	          : usesHours ? "Hobbs meter reading is missing" : "Tractor mileage is missing",
  	        message: (usesHours ? "Hour-based" : "Mileage-based") + " service and tyre alerts are unavailable. Capture the asset operational reading before relying on warnings.",
  	        actual: usesHours ? "No Hobbs meter value" : "No Mileage value",
  	        threshold: usesHours ? "Current hour reading required" : "Current mileage required",
  	        action: isTrailerAsset ? "vehicle-overview" : "vehicle-data",
  	        actionLabel: isTrailerAsset ? "Open Implement" : "Open Vehicle Data"
  	      });
  	    }

  	    const serviceRoot = getDeep(vehicle, ["Data", "Service"], null);
  	    const serviceHealth = serviceHealthForVehicle(company, vehicle);
  	    const serviceUnit = serviceHealth.unit || (serviceSetupCounterType(vehicle) === "Hours" ? "h" : "km");
  	    const serviceOpenJob = arr(serviceHealth.openOrders)[0] || null;
  	    const serviceResolveAction = serviceOpenJob ? "workshop-job" : "schedule-service";
  	    const serviceResolveLabel = serviceOpenJob
  	      ? "Open Service Job"
  	      : CAN_MANAGE_SERVICE_JOBS
  	        ? "Schedule Service"
  	        : "Open Service";
  	    const serviceActualReading = serviceHealth.odometer === null
  	      ? "No fuel-captured reading"
  	      : formatNumber(serviceHealth.odometer, 0) + " " + serviceUnit;
  	    const serviceCalculationEvidence = serviceHealth.readingAwaitingFuelUpdate && serviceHealth.lastCounter !== null
  	      ? serviceActualReading + " fuel · " + formatNumber(serviceHealth.lastCounter, 0) + " " + serviceUnit + " service baseline"
  	      : serviceActualReading;

  	    if (serviceHealth.serviceStatus === "out of service") {
  	      add({
  	        key: "Service:" + vehicleObjectId + ":OutOfService",
  	        category: "Service",
  	        code: "VEHICLE_OUT_OF_SERVICE",
  	        severity: "critical",
  	        title: isTrailerAsset ? "Implement is out of service" : "Vehicle is out of service",
  	        message: (isTrailerAsset ? "The implement" : "The vehicle") + " is marked out of service.",
  	        actual: "Out of service",
  	        threshold: "Operational service status",
  	        sourceId: serviceOpenJob ? serviceOpenJob.WorkOrderId : "",
  	        action: serviceResolveAction,
  	        actionLabel: serviceResolveLabel
  	      });
  	    }

  	    if (serviceHealth.dataConflict) {
  	      add({
  	        key: "Service:" + vehicleObjectId + ":SetupConflict",
  	        category: "Service",
  	        code: "SERVICE_SETUP_CONFLICT",
  	        severity: "critical",
  	        title: "Service setup needs correction",
  	        message: "The next service position is not later than the last service position. Review the saved interval and last-service values.",
  	        actual: serviceHealth.lastCounter === null ? "Last service not recorded" : formatNumber(serviceHealth.lastCounter, 0) + " " + serviceUnit,
  	        threshold: serviceHealth.nextCounter === null ? "Next service not configured" : formatNumber(serviceHealth.nextCounter, 0) + " " + serviceUnit,
  	        action: "service-setup",
  	        actionLabel: "Open Service Setup"
  	      });
  	    }

  	    if (!serviceHealth.dataConflict && serviceHealth.nextCounter === null && !serviceHealth.nextDate) {
  	      add({
  	        key: "Service:" + vehicleObjectId + ":SetupRequired",
  	        category: "Service",
  	        code: "SERVICE_SETUP_REQUIRED",
  	        severity: serviceRoot ? "warning" : "high",
  	        title: "Service setup required",
  	        message: "Configure a service interval and capture the starting service position before relying on service alerts.",
  	        actual: serviceRoot ? "No next service position" : "No Service data",
  	        threshold: "Counter interval or time interval",
  	        action: "service-setup",
  	        actionLabel: "Open Service Setup"
  	      });
  	    }

  	    if (!serviceHealth.dataConflict && serviceHealth.nextCounter !== null && serviceHealth.calculationReading !== null) {
  	      const remainingCounter = serviceHealth.remainingCounter;
  	      if (remainingCounter !== null && remainingCounter <= 0) {
  	        add({
  	          key: "Service:" + vehicleObjectId + ":OverdueCounter",
  	          category: "Service",
  	          code: serviceUnit === "h" ? "SERVICE_OVERDUE_HOURS" : "SERVICE_OVERDUE_KM",
  	          severity: "critical",
  	          title: "Service overdue by " + (serviceUnit === "h" ? "hours" : "mileage"),
  	          message: "The service position is " + formatNumber(Math.abs(remainingCounter), 0) + " " + serviceUnit + " overdue.",
  	          actual: serviceCalculationEvidence,
  	          threshold: formatNumber(serviceHealth.nextCounter, 0) + " " + serviceUnit,
  	          sourceId: serviceOpenJob ? serviceOpenJob.WorkOrderId : "",
  	          action: serviceResolveAction,
  	          actionLabel: serviceResolveLabel
  	        });
  	      } else if (
  	        remainingCounter !== null &&
  	        serviceHealth.warningCounter > 0 &&
  	        remainingCounter <= serviceHealth.warningCounter
  	      ) {
  	        add({
  	          key: "Service:" + vehicleObjectId + ":DueSoonCounter",
  	          category: "Service",
  	          code: serviceUnit === "h" ? "SERVICE_DUE_SOON_HOURS" : "SERVICE_DUE_SOON_KM",
  	          severity: remainingCounter <= Math.min(serviceUnit === "h" ? 10 : 1000, serviceHealth.warningCounter) ? "high" : "warning",
  	          title: "Service due soon by " + (serviceUnit === "h" ? "hours" : "mileage"),
  	          message: formatNumber(remainingCounter, 0) + " " + serviceUnit + " remains before the next service.",
  	          actual: serviceCalculationEvidence,
  	          threshold: formatNumber(serviceHealth.nextCounter, 0) + " " + serviceUnit,
  	          sourceId: serviceOpenJob ? serviceOpenJob.WorkOrderId : "",
  	          action: serviceResolveAction,
  	          actionLabel: serviceResolveLabel
  	        });
  	      }
  	    }

  	    if (!serviceHealth.dataConflict && serviceHealth.nextDate) {
  	      const days = serviceHealth.remainingDays;
  	      if (days !== null && days < 0) {
  	        add({
  	          key: "Service:" + vehicleObjectId + ":OverdueDate",
  	          category: "Service",
  	          code: "SERVICE_OVERDUE_DATE",
  	          severity: "critical",
  	          title: "Service overdue by date",
  	          message: "The service date passed " + Math.abs(days) + " day" + (Math.abs(days) === 1 ? "" : "s") + " ago.",
  	          actual: fifAlertDateLabel(today),
  	          threshold: fifAlertDateLabel(serviceHealth.nextDate),
  	          sourceId: serviceOpenJob ? serviceOpenJob.WorkOrderId : "",
  	          action: serviceResolveAction,
  	          actionLabel: serviceResolveLabel
  	        });
  	      } else if (
  	        days !== null &&
  	        serviceHealth.warningDays > 0 &&
  	        days <= serviceHealth.warningDays
  	      ) {
  	        add({
  	          key: "Service:" + vehicleObjectId + ":DueSoonDate",
  	          category: "Service",
  	          code: "SERVICE_DUE_SOON_DATE",
  	          severity: days <= 7 ? "high" : "warning",
  	          title: "Service date approaching",
  	          message: "The next service date is in " + days + " day" + (days === 1 ? "" : "s") + ".",
  	          actual: fifAlertDateLabel(today),
  	          threshold: fifAlertDateLabel(serviceHealth.nextDate),
  	          sourceId: serviceOpenJob ? serviceOpenJob.WorkOrderId : "",
  	          action: serviceResolveAction,
  	          actionLabel: serviceResolveLabel
  	        });
  	      }
  	    }

  	    preventiveMaintenancePlans(vehicle).forEach(function (plan) {
  	      const position = preventivePlanStatus(vehicle, plan);
  	      const planName = clean(plan.Name) || "Preventive maintenance";
  	      if (!plan.Active || position.openJob) return;

  	      if (position.status === "Unconfigured") {
  	        add({
  	          key: "Maintenance:Plan:" + plan.PlanId + ":Unconfigured",
  	          category: "Maintenance",
  	          code: "PREVENTIVE_PLAN_INCOMPLETE",
  	          severity: "warning",
  	          title: planName + " needs setup",
  	          message: "Complete the plan interval and starting reading or date before it can calculate a due position.",
  	          actual: plan.TriggerMode,
  	          threshold: "Usable interval and baseline",
  	          sourceId: plan.PlanId,
  	          action: "preventive-plan-edit",
  	          actionLabel: "Edit Plan"
  	        });
  	        return;
  	      }

  	      const counterDueText = position.remainingKM === null
  	        ? ""
  	        : position.remainingKM < 0
  	          ? formatNumber(Math.abs(position.remainingKM), 0) + " km overdue"
  	          : position.remainingKM === 0
  	            ? "Due now by kilometers"
  	            : formatNumber(position.remainingKM, 0) + " km remaining";
  	      const timeDueText = position.remainingDays === null
  	        ? ""
  	        : position.remainingDays < 0
  	          ? Math.abs(position.remainingDays) + " day" + (Math.abs(position.remainingDays) === 1 ? "" : "s") + " overdue"
  	          : position.remainingDays === 0
  	            ? "Due today"
  	            : position.remainingDays + " day" + (position.remainingDays === 1 ? "" : "s") + " remaining";
  	      const evidence = [counterDueText, timeDueText].filter(Boolean).join(" · ") || "Due position unavailable";
  	      const threshold = [
  	        position.nextKM === null ? "" : formatNumber(position.nextKM, 0) + " km",
  	        position.nextDate ? serviceFormatDate(position.nextDate) : ""
  	      ].filter(Boolean).join(" · ") || "Plan interval";

  	      if (position.due) {
  	        const trulyOverdue = (position.remainingKM !== null && position.remainingKM < 0) || (position.remainingDays !== null && position.remainingDays < 0);
  	        add({
  	          key: "Maintenance:Plan:" + plan.PlanId + ":Due",
  	          category: "Maintenance",
  	          code: trulyOverdue ? "PREVENTIVE_MAINTENANCE_OVERDUE" : "PREVENTIVE_MAINTENANCE_DUE",
  	          severity: trulyOverdue || plan.Priority === "Critical" ? "critical" : "high",
  	          title: planName + (trulyOverdue ? " is overdue" : " is due now"),
  	          message: evidence + ". Schedule the preventive job before the vehicle continues beyond the plan position.",
  	          actual: evidence,
  	          threshold: threshold,
  	          sourceId: plan.PlanId,
  	          action: "preventive-job-schedule",
  	          actionLabel: CAN_MANAGE_MAINTENANCE ? "Schedule Maintenance" : "Open Maintenance"
  	        });
  	      } else if (position.dueSoon) {
  	        const closeByCounter = position.remainingKM !== null && plan.WarningKM > 0 && position.remainingKM <= Math.min(500, plan.WarningKM);
  	        const closeByTime = position.remainingDays !== null && position.remainingDays <= 7;
  	        add({
  	          key: "Maintenance:Plan:" + plan.PlanId + ":DueSoon",
  	          category: "Maintenance",
  	          code: "PREVENTIVE_MAINTENANCE_DUE_SOON",
  	          severity: closeByCounter || closeByTime || plan.Priority === "Critical" ? "high" : "warning",
  	          title: planName + " is due soon",
  	          message: evidence + ".",
  	          actual: evidence,
  	          threshold: threshold,
  	          sourceId: plan.PlanId,
  	          action: "preventive-job-schedule",
  	          actionLabel: CAN_MANAGE_MAINTENANCE ? "Schedule Maintenance" : "Open Maintenance"
  	        });
  	      }
  	    });

  	    fifVehicleTyresForAlerts(company, vehicle).forEach(function (tyre) {
  	      const tyreId = clean(firstValue([
  	        tyre && tyre.objectId,
  	        fifTyreAlertLabel(tyre)
  	      ], ""));
  	      const label = fifTyreAlertLabel(tyre);
  	      const position = fifTyrePositionForAlert(tyre);
  	      const hoursVehicle = serviceSetupCounterType(vehicle) === "Hours";
  	      const unit = hoursVehicle ? "h" : "km";
  	      const counterName = hoursVehicle ? "operating hours" : "mileage";
  	      const threshold = fifTyreWarningThresholdForVehicle(tyre, vehicle);
  	      const remaining = fifTyreRemainingMileageForAlert(tyre);

  	      if (threshold === null || remaining === null || remaining > threshold) return;

  	      const critical = remaining <= 0;
  	      add({
  	        key: "Tyre:" + tyreId + ":" + (hoursVehicle ? "HourThreshold" : "MileageThreshold"),
  	        category: "Tyres",
  	        code: critical
  	          ? hoursVehicle ? "TYRE_HOURS_CRITICAL" : "TYRE_MILEAGE_CRITICAL"
  	          : hoursVehicle ? "TYRE_HOURS_WARNING" : "TYRE_MILEAGE_WARNING",
  	        severity: critical ? "critical": "high",
  	        title: critical
  	          ? label + " has no remaining tyre " + counterName
  	          : label + " reached its tyre warning threshold",
  	        message: label + (position ? " at " + position : "") +
  	          (critical
  	            ? " has reached zero remaining " + counterName + "."
  	            : " has " + formatNumber(remaining, 0) + " " + unit + " remaining, at or below its configured " + formatNumber(threshold, 0) + " " + unit + " warning threshold."),
  	        actual: formatNumber(Math.max(0, remaining), 0) + " " + unit + " remaining",
  	        threshold: formatNumber(threshold, 0) + " " + unit + " warning threshold",
  	        sourceId: tyreId,
  	        position: position,
  	        action: "tyre-swap",
  	        actionLabel: CAN_MANAGE_WORKSHOP ? "Inspect / Swap Tyre" : "Open Tyres"
  	      });
  	    });

  	    const complianceRoot = getDeep(vehicle, ["Data", "Compliance"], null);
  	    const complianceSetup = v21ComplianceSetupRoot(vehicle);
  	    const complianceConfigured = descriptorValue(complianceSetup.Configured) === true;
  	    const vehicleComplianceRecords = complianceRecords(vehicle).map(normalizeServiceWorkOrder);

  	    if (complianceRoot && !complianceConfigured) {
  	      add({
  	        key: "Compliance:" + vehicleObjectId + ":SetupRequired",
  	        category: "Compliance",
  	        code: "COMPLIANCE_SETUP_REQUIRED",
  	        severity: "warning",
  	        title: "Compliance setup required",
  	        message: "Select the compliance requirements that apply to this vehicle.",
  	        actual: "Not configured",
  	        threshold: "Vehicle requirements selected",
  	        action: "compliance-setup",
  	        actionLabel: "Open Compliance Setup"
  	      });
  	    }

  	    if (complianceConfigured || vehicleComplianceRecords.length) {
  	      v21ComplianceDashboardItems(vehicle)
  	        .filter(function (item) {
  	          return complianceConfigured || !!item.record;
  	        })
  	        .forEach(function (item) {
  	          if (item.tone !== "bad" && item.tone !== "warn") return;

  	          let severity = item.tone === "bad" ? "critical" : "warning";
  	          if (item.state === "Due soon") {
  	            severity = item.days !== null && item.days <= 7
  	              ? "critical"
  	              : item.days !== null && item.days <= 14
  	                ? "high"
  	                : "warning";
  	          } else if (item.state === "Missing evidence") {
  	            severity = "high";
  	          }

  	          add({
  	            key: "Compliance:" + vehicleObjectId + ":" + item.key + ":" + item.state,
  	            category: "Compliance",
  	            code: item.state === "Overdue"
  	              ? "COMPLIANCE_EXPIRED"
  	              : item.state === "Due soon"
  	                ? "COMPLIANCE_EXPIRING"
  	                : item.state === "Missing evidence"
  	                  ? "COMPLIANCE_EVIDENCE_MISSING"
  	                  : "COMPLIANCE_ACTION_REQUIRED",
  	            severity: severity,
  	            title: item.label + " · " + item.state.toLowerCase(),
  	            message: item.message,
  	            actual: item.state,
  	            threshold: item.expiryDate
  	              ? serviceFormatDate(item.expiryDate)
  	              : "Current evidence required",
  	            sourceId: item.record ? item.record.WorkOrderId : "SETUP:" + item.key,
  	            recordType: item.recordType,
  	            action: "compliance-renew",
  	            actionLabel: CAN_EDIT_COMPLIANCE
  	              ? item.record
  	                ? "Renew / Replace"
  	                : "Add Compliance Record"
  	              : "Open Compliance"
  	          });
  	        });
  	    }

  	    maintenanceRowsForVehicle(vehicle).map(normalizeServiceWorkOrder).filter(function (record) {
  	      return [MAINTENANCE_CATEGORY_SERVICE, MAINTENANCE_CATEGORY_MAINTENANCE].indexOf(record.Category) !== -1 && SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(record.Status)) !== -1;
  	    }).forEach(function (record) {
  	      const phase = serviceCanonicalStatus(record.Status);
  	      const phaseAge = workshopPhaseAgeDays(record);
  	      const scheduledDays = record.ScheduledDate ? fifDaysUntil(record.ScheduledDate) : null;
  	      const expectedDays = record.DelayExpectedDate ? fifDaysUntil(record.DelayExpectedDate) : null;
  	      const titlePrefix = record.Category === MAINTENANCE_CATEGORY_SERVICE ? "Service" : "Maintenance";
  	      if (
  	        record.Category === MAINTENANCE_CATEGORY_MAINTENANCE &&
  	        (record.OperationalBlock === true || record.SafeToOperate === false)
  	      ) {
  	        add({
  	          key: "Workshop:" + record.WorkOrderId + ":Unsafe",
  	          category: "Maintenance",
  	          code: "MAINTENANCE_OPERATIONAL_BLOCK",
  	          severity: "critical",
  	          title: "Vehicle is not safe to operate",
  	          message: record.WorkOrderId + " is open and blocks normal vehicle operation.",
  	          actual: servicePhaseLabel(phase),
  	          threshold: "Safe to operate",
  	          sourceId: record.WorkOrderId,
  	          action: "workshop-job",
  	          actionLabel: "Open Maintenance Job"
  	        });
  	      } else if (
  	        record.Category === MAINTENANCE_CATEGORY_MAINTENANCE &&
  	        lower(record.Priority) === "critical"
  	      ) {
  	        add({
  	          key: "Workshop:" + record.WorkOrderId + ":CriticalPriority",
  	          category: "Maintenance",
  	          code: "CRITICAL_MAINTENANCE_JOB_OPEN",
  	          severity: "high",
  	          title: "Critical maintenance job is open",
  	          message: record.WorkOrderId + " requires priority workshop attention.",
  	          actual: servicePhaseLabel(phase),
  	          threshold: "Critical priority",
  	          sourceId: record.WorkOrderId,
  	          action: "workshop-job",
  	          actionLabel: "Open Maintenance Job"
  	        });
  	      }
  	      if (phase === "Scheduled" && scheduledDays !== null && scheduledDays < 0) {
  	        add({key:"Workshop:"+record.WorkOrderId+":BookingOverdue",category:titlePrefix,code:"WORKSHOP_BOOKING_OVERDUE",severity:"high",title:titlePrefix+" booking is not confirmed",message:record.WorkOrderId+" passed its proposed date "+Math.abs(scheduledDays)+" day"+(Math.abs(scheduledDays)===1?"":"s")+" ago and is still Scheduled.",actual:servicePhaseLabel(phase),threshold:serviceFormatDate(record.ScheduledDate),sourceId:record.WorkOrderId,action:"workshop-job",actionLabel:"Confirm or Reschedule"});
  	      }
  	      if (phase === "Booked" && scheduledDays !== null && scheduledDays < -1) {
  	        add({key:"Workshop:"+record.WorkOrderId+":StartOverdue",category:titlePrefix,code:"WORKSHOP_START_OVERDUE",severity:"high",title:titlePrefix+" work has not started",message:record.WorkOrderId+" is Booked but its confirmed date has passed.",actual:servicePhaseLabel(phase),threshold:serviceFormatDate(record.ScheduledDate),sourceId:record.WorkOrderId,action:"workshop-job",actionLabel:"Start Work"});
  	      }
  	      if (phase === "In Progress" && phaseAge >= 3) {
  	        add({key:"Workshop:"+record.WorkOrderId+":Stalled",category:titlePrefix,code:"WORKSHOP_STALLED",severity:phaseAge>=7?"high":"warning",title:titlePrefix+" job may be stalled",message:record.WorkOrderId+" has remained In Progress for "+phaseAge+" days without a phase change.",actual:phaseAge+" days",threshold:"Review after 3 days",sourceId:record.WorkOrderId,action:"workshop-job",actionLabel:"Update Job"});
  	      }
  	      if (phase === "Waiting Parts" && expectedDays !== null && expectedDays < 0) {
  	        add({key:"Workshop:"+record.WorkOrderId+":PartsLate",category:titlePrefix,code:"WORKSHOP_PARTS_OVERDUE",severity:"high",title:"Parts review date has passed",message:record.WorkOrderId+" is delayed and its expected-parts or review date passed "+Math.abs(expectedDays)+" day"+(Math.abs(expectedDays)===1?"":"s")+" ago.",actual:servicePhaseLabel(phase),threshold:serviceFormatDate(record.DelayExpectedDate),sourceId:record.WorkOrderId,action:"workshop-job",actionLabel:"Update Delay"});
  	      }
  	      if (phase === "Ready" && phaseAge >= 1) {
  	        add({key:"Workshop:"+record.WorkOrderId+":Ready",category:titlePrefix,code:"WORKSHOP_READY_UNCLOSED",severity:phaseAge>=3?"high":"warning",title:"Ready job is not completed",message:record.WorkOrderId+" has been Ready for "+phaseAge+" day"+(phaseAge===1?"":"s")+" and still needs acceptance or completion.",actual:servicePhaseLabel(phase),threshold:"Complete after acceptance",sourceId:record.WorkOrderId,action:"workshop-job",actionLabel:"Complete Job"});
  	      }
  	    });
  	    if (!isTrailerAsset) fifFuelConsumptionAlert(company, vehicle, add);

  	    fifLegacyNotificationAlerts(vehicle).forEach(add);
  	    alerts.sort(function (a, b) {
  	      return fifAlertSeverityRank(a.severity) - fifAlertSeverityRank(b.severity) || naturalCompare(a.category, b.category) || naturalCompare(a.title, b.title);
  	    });
  	    return alerts;
  	  }

  	function userCanAccessVehicleAlert(alert, vehicle) {
  	    if (!CAN_ACCESS_ALERTS || !userCanAccessAsset(vehicle)) return false;
  	    const category = lower(alert && alert.category);
  	    const action = lower(alert && alert.action);
  	    const code = lower(alert && alert.code);
  	    const combined = [category, action, code, lower(alert && alert.title), lower(alert && alert.message)].join(" ");
  	    if (/financial|ledger|transaction|rig-builder|rig builder|active rig/.test(combined)) return false;
  	    if (category === "service" || action === "schedule-service") return CAN_ACCESS_SERVICE;
  	    if (category === "maintenance") return CAN_ACCESS_MAINTENANCE;
  	    if (category === "tyres" || action === "tyre-swap") return CAN_ACCESS_TYRES;
  	    if (category === "fuel" || action === "fuel-capture") return !assetIsTrailer(vehicle) && CAN_ACCESS_VEHICLES && CAN_ACCESS_FUEL;
  	    if (category === "compliance" || action === "compliance-renew") return CAN_ACCESS_COMPLIANCE;
  	    if (action === "workshop-job") return category === "service" ? CAN_ACCESS_SERVICE : CAN_ACCESS_MAINTENANCE;
  	    return true;
  	  }

  	function vehicleAlertsForDisplay(company, vehicle, refresh) {
  	    if (!CAN_ACCESS_ALERTS || !company || !vehicle) return [];
  	    const vehicleIndex = tractors(company).indexOf(vehicle);
  	    const key = clean(company && company.objectId) + "::" + vehicleStableKey(vehicle, vehicleIndex < 0 ? 0 : vehicleIndex);
  	    if (!refresh && state.actionableAlertCache && state.actionableAlertCache[key]) return state.actionableAlertCache[key];
  	    const alerts = buildVehicleAlerts(company, vehicle).filter(function (alert) { return userCanAccessVehicleAlert(alert, vehicle); });
  	    if (!state.actionableAlertCache) state.actionableAlertCache = {};
  	    state.actionableAlertCache[key] = alerts;
  	    return alerts;
  	  }

  	  function notificationCount(asset) {
  	    if (!CAN_ACCESS_ALERTS) return 0;
  	    let company = null;
  	    try { company = selectedCompany(); } catch (_) {}
  	    const assetObjectId = objectIdOf(asset);
  	    if (company && tractors(company).some(function (vehicle) { return vehicle === asset || (assetObjectId && objectIdOf(vehicle) === assetObjectId); })) {
  	      return vehicleAlertsForDisplay(company, asset, false).length;
  	    }
  	    const direct = numberValue(getDeep(asset, ["Notifications", "count"], null));
  	    if (direct !== null) return direct;
  	    return arr(getDeep(asset, ["Notifications", "issues"], [])).length + arr(getDeep(asset, ["Notifications", "warnings"], [])).length;
  	  }

  	  function injectActionableAlertStyles() {
  	    if (document.getElementById(FIF_ACTION_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = FIF_ACTION_STYLE_ID;
  	    style.textContent = `
  	    #${ROOT_ID} .fifdash-metric.is-action { appearance:none;width:100%;text-align:left;border-top:0;border-bottom:0;border-left:0;background:transparent;color:inherit;cursor:pointer;position:relative;transition:background .15s,border-color .15s,box-shadow .15s; }
  	    #${ROOT_ID} .fifdash-metric.is-action:hover { background:rgba(204,102,51,.075);box-shadow:inset 0 0 0 1px rgba(204,102,51,.16); }
  	    #${ROOT_ID} .fifdash-metric.is-action:focus-visible { outline:2px solid rgba(224,120,59,.72);outline-offset:-2px; }
  	    #${ROOT_ID} .fifdash-metric.is-action::after { content:"›";position:absolute;right:8px;top:50%;transform:translateY(-50%);color:#59615c;font-size:16px; }
  	    #${SERVICE_MODAL_ID} .fif-alert-summary { display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px;margin-bottom:12px; }
  	    #${SERVICE_MODAL_ID} .fif-alert-summary article { border:1px solid rgba(255,255,255,.075);border-radius:10px;background:#0d110e;padding:10px; }
  	    #${SERVICE_MODAL_ID} .fif-alert-summary span,#${SERVICE_MODAL_ID} .fif-alert-summary small { display:block;color:#737b76;font-size:8px;text-transform:uppercase;font-weight:900; }
  	    #${SERVICE_MODAL_ID} .fif-alert-summary strong { display:block;margin:4px 0 2px;color:#fff;font-size:18px; }
  	    #${SERVICE_MODAL_ID} .fif-alert-list { display:flex;flex-direction:column;gap:8px; }
  	    #${SERVICE_MODAL_ID} .fif-alert-card { --alert:#ffb04a;display:grid;grid-template-columns:4px minmax(0,1fr) auto;gap:12px;border:1px solid rgba(255,255,255,.075);border-radius:12px;background:linear-gradient(145deg,#111512,#090c0a);overflow:hidden; }
  	    #${SERVICE_MODAL_ID} .fif-alert-card.severity-critical { --alert:#ff5c4d; }
  	    #${SERVICE_MODAL_ID} .fif-alert-card.severity-high { --alert:#ff874d; }
  	    #${SERVICE_MODAL_ID} .fif-alert-card.severity-info { --alert:#4d92ff; }
  	    #${SERVICE_MODAL_ID} .fif-alert-bar { background:var(--alert);box-shadow:0 0 16px color-mix(in srgb,var(--alert) 55%,transparent); }
  	    #${SERVICE_MODAL_ID} .fif-alert-copy { min-width:0;padding:12px 0; }
  	    #${SERVICE_MODAL_ID} .fif-alert-top { display:flex;align-items:center;gap:7px;flex-wrap:wrap; }
  	    #${SERVICE_MODAL_ID} .fif-alert-badge { padding:4px 6px;border:1px solid color-mix(in srgb,var(--alert) 45%,transparent);border-radius:999px;background:color-mix(in srgb,var(--alert) 10%,transparent);color:var(--alert);font-size:8px;font-weight:950;text-transform:uppercase; }
  	    #${SERVICE_MODAL_ID} .fif-alert-category { color:#777f7a;font-size:8px;font-weight:900;text-transform:uppercase; }
  	    #${SERVICE_MODAL_ID} .fif-alert-copy h3 { margin:6px 0 4px;color:#f7f8f7;font-size:13px; }
  	    #${SERVICE_MODAL_ID} .fif-alert-copy p { margin:0;color:#969e99;font-size:10px;line-height:1.5; }
  	    #${SERVICE_MODAL_ID} .fif-alert-evidence { display:flex;gap:7px;flex-wrap:wrap;margin-top:8px; }
  	    #${SERVICE_MODAL_ID} .fif-alert-evidence span { padding:5px 7px;border-radius:7px;background:rgba(255,255,255,.035);color:#aeb5b0;font-size:8px; }
  	    #${SERVICE_MODAL_ID} .fif-alert-action { align-self:center;margin-right:12px;min-width:118px;border:1px solid color-mix(in srgb,var(--alert) 42%,transparent);border-radius:9px;background:color-mix(in srgb,var(--alert) 10%,#111512);color:#fff;padding:9px 10px;font-size:9px;font-weight:900;cursor:pointer; }
  	    #${SERVICE_MODAL_ID} .fif-alert-action:hover { background:color-mix(in srgb,var(--alert) 18%,#111512); }
  	    #${SERVICE_MODAL_ID} .fif-alert-empty { padding:28px;border:1px dashed rgba(73,199,133,.32);border-radius:12px;text-align:center;color:#8e9691; }
  	    #${SERVICE_MODAL_ID} .fif-alert-empty strong { display:block;color:#76dca4;font-size:15px;margin-bottom:5px; }
  	    #${SERVICE_MODAL_ID} .fif-fuel-live-total { display:flex;justify-content:space-between;align-items:center;margin:12px 0 0;padding:12px;border:1px solid rgba(204,102,51,.28);border-radius:10px;background:rgba(204,102,51,.07); }
  	    #${SERVICE_MODAL_ID} .fif-fuel-live-total span { color:#8f9792;font-size:9px;font-weight:900;text-transform:uppercase; }
  	    #${SERVICE_MODAL_ID} .fif-fuel-live-total strong { color:#fff;font-size:18px; }
  	    @media(max-width:760px){#${SERVICE_MODAL_ID} .fif-alert-summary{grid-template-columns:repeat(2,1fr)}#${SERVICE_MODAL_ID} .fif-alert-card{grid-template-columns:4px minmax(0,1fr)}#${SERVICE_MODAL_ID} .fif-alert-action{grid-column:2;margin:0 12px 12px 0;justify-self:start}}
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function closeActionableAlertModal() {
  	    closeServicePortalModal();
  	  }



  	  function openVehicleAlertPanel(company, vehicle) {
  	    if (!CAN_ACCESS_ALERTS || !userCanAccessAsset(vehicle)) {
  	      fifAlert("Alerts functionality is not assigned in your Dashboard Settings.", {
  	        title: "Alerts Access Required",
  	        type: "warning",
  	        confirmText: "Close"
  	      });
  	      return null;
  	    }
  	    injectServicePortalStyles();
  	    injectActionableAlertStyles();
  	    const alerts = vehicleAlertsForDisplay(company, vehicle, true);
  	    const counts = { critical: 0, high: 0, warning: 0, info: 0 };
  	    alerts.forEach(function (alert) { if (Object.prototype.hasOwnProperty.call(counts, alert.severity)) counts[alert.severity] += 1; });
  	    const body = `<section class="fif-alert-summary">
  	      <article><span>Critical</span><strong>${counts.critical}</strong><small>Immediate action</small></article>
  	      <article><span>High</span><strong>${counts.high}</strong><small>Overdue / abnormal</small></article>
  	      <article><span>Warnings</span><strong>${counts.warning}</strong><small>Approaching threshold</small></article>
  	      <article><span>Information</span><strong>${counts.info}</strong><small>Planning notices</small></article>
  	      </section>
  	      <section class="fif-alert-list">${alerts.length ? alerts.map(function (alert) {
  	        return `<article class="fif-alert-card severity-${escapeAttr(alert.severity)}">
  	          <i class="fif-alert-bar"></i>
  	          <div class="fif-alert-copy"><div class="fif-alert-top"><span class="fif-alert-badge">${escapeHtml(fifAlertSeverityLabel(alert.severity))}</span><span class="fif-alert-category">${escapeHtml(alert.category)}</span></div><h3>${escapeHtml(alert.title)}</h3><p>${escapeHtml(alert.message)}</p>${alert.actual || alert.threshold ? `<div class="fif-alert-evidence">${alert.actual ? `<span><b>Actual:</b> ${escapeHtml(alert.actual)}</span>`: ""}${alert.threshold ? `<span><b>Threshold:</b> ${escapeHtml(alert.threshold)}</span>`: ""}${alert.position ? `<span><b>Position:</b> ${escapeHtml(alert.position)}</span>`: ""}</div>`: ""}</div>
  	          <button type="button" class="fif-alert-action" data-alert-action="${escapeAttr(alert.key)}">${escapeHtml(alert.actionLabel || "Resolve Alert")}</button>
  	        </article>`;
  	      }).join(""): `<div class="fif-alert-empty"><strong>No active alerts</strong><span>This vehicle currently has no derived service, maintenance, fuel, tyre or compliance alerts.</span></div>`}</section>`;
  	    const footer = `<button type="button" data-sp-modal-close>Close</button>`;
  	    const overlay = serviceModalShell("Vehicle Alerts", vehicleTitleValue(vehicle) + " · Resolve conditions directly from this panel. Alerts clear automatically when their source data is corrected.", body, footer, true);
  	    overlay.querySelectorAll("[data-alert-action]").forEach(function (button) {
  	      button.addEventListener("click", async function () {
  	        const key = button.getAttribute("data-alert-action");
  	        const alert = alerts.find(function (item) { return item.key === key; });
  	        if (!alert) return;
  	        await executeVehicleAlertAction(company, vehicle, alert);
  	      });
  	    });
  	  }

  	  async function executeVehicleAlertAction(company, vehicle, alert) {
  	    closeActionableAlertModal();
  	    if (alert.action === "service-setup") {
  	      openVehicleServiceSetupModal(company, vehicle, "setup");
  	      return;
  	    }
  	    if (alert.action === "preventive-plan-edit") {
  	      if (CAN_MANAGE_MAINTENANCE && alert.sourceId) {
  	        openPreventivePlanModal(company, vehicle, alert.sourceId);
  	        return;
  	      }
  	      state.selectedVehicleKey = vehicleStableKey(vehicle, tractors(company).indexOf(vehicle));
  	      state.vehicleActiveTab = "maintenance";
  	      state.maintenanceView = "preventive";
  	      render();
  	      return;
  	    }
  	    if (alert.action === "preventive-job-schedule") {
  	      if (CAN_MANAGE_MAINTENANCE && alert.sourceId) {
  	        openPreventiveJobModal(company, vehicle, alert.sourceId);
  	        return;
  	      }
  	      state.selectedVehicleKey = vehicleStableKey(vehicle, tractors(company).indexOf(vehicle));
  	      state.vehicleActiveTab = "maintenance";
  	      state.maintenanceView = "preventive";
  	      render();
  	      return;
  	    }
  	    if (alert.action === "schedule-service") {
  	      if (!CAN_MANAGE_SERVICE_JOBS) {
  	        state.selectedVehicleKey = vehicleStableKey(vehicle, tractors(company).indexOf(vehicle));
  	        state.vehicleActiveTab = "service";
  	        state.vehicleServiceView = "position";
  	        render();
  	        return;
  	      }
  	      openServiceJobModal(company, "", {
  	        VehicleObjectId: objectIdOf(vehicle),
  	        VehicleId: vehicleTitleValue(vehicle),
  	        Registration: vehicleRegistrationValue(vehicle),
  	        Category: MAINTENANCE_CATEGORY_SERVICE,
  	        Type: "Scheduled Service",
  	        Title: alert.title,
  	        Priority: alert.severity === "critical" ? "Critical": alert.severity === "high" ? "High": "Normal",
  	        Status: "Booked",
  	        ReportedDate: new Date().toISOString().slice(0, 10),
  	        ScheduledDate: new Date().toISOString().slice(0, 10),
  	        Odometer: tractorMileage(vehicle),
  	        Complaint: alert.message,
  	        IsScheduled: true
  	      });
  	      return;
  	    }
  	    if (alert.action === "open-job") {
  	      openServiceJobModal(company, alert.sourceId, {});
  	      return;
  	    }
  	    if (alert.action === "workshop-job") {
  	      if (alert.sourceId) {
  	        openServiceJobModal(company, alert.sourceId, {});
  	        return;
  	      }
  	      state.selectedVehicleKey = vehicleStableKey(vehicle, tractors(company).indexOf(vehicle));
  	      state.vehicleActiveTab = lower(alert.category) === "service" ? "service" : "maintenance";
  	      if (state.vehicleActiveTab === "maintenance") {
  	        state.maintenanceView = "open";
  	        state.maintenanceOpenExpanded = true;
  	      } else {
  	        state.vehicleServiceView = "jobs";
  	      }
  	      render();
  	      return;
  	    }
  	    if (alert.action === "tyre-swap") {
  	      state.selectedVehicleKey = vehicleStableKey(vehicle, tractors(company).indexOf(vehicle));
  	      state.vehicleActiveTab = "tyres";
  	      clearVehicleEditorState();
  	      state.tyreMode = CAN_MANAGE_WORKSHOP ? "rotate": "";
  	      setVehicleMessage(CAN_MANAGE_WORKSHOP ? "Rotate / Swap mode opened from the alert panel. Select the fitted tyre and its replacement position or warehouse tyre.": "Tyre workspace opened from the alert panel.", false);
  	      render();
  	      return;
  	    }
  	    if (alert.action === "compliance-setup") {
  	      if (CAN_EDIT_COMPLIANCE) {
  	        v21OpenComplianceRequirementsModal(company, vehicle);
  	      } else {
  	        state.selectedVehicleKey = vehicleStableKey(vehicle, tractors(company).indexOf(vehicle));
  	        state.vehicleActiveTab = "compliance";
  	        render();
  	      }
  	      return;
  	    }
  	    if (alert.action === "compliance-renew") {
  	      if (CAN_EDIT_COMPLIANCE) {
  	        if (clean(alert.sourceId).indexOf("SETUP:") === 0 || !alert.sourceId) {
  	          v21OpenComplianceModal(company, vehicle, "", "", alert.recordType || "");
  	        } else {
  	          v21OpenComplianceModal(company, vehicle, "", alert.sourceId, alert.recordType || "");
  	        }
  	      } else {
  	        state.selectedVehicleKey = vehicleStableKey(vehicle, tractors(company).indexOf(vehicle));
  	        state.vehicleActiveTab = "compliance";
  	        render();
  	      }
  	      return;
  	    }
  	    if (alert.action === "fuel-capture") {
  	      if (CAN_CAPTURE_ON_ROAD_FUEL && userCanAccessAssetFunction(vehicle, "Fuel")) openOnRoadFuelCapture(company, vehicle);
  	      return;
  	    }
  	    if (alert.action === "vehicle-data") {
  	      state.selectedVehicleKey = vehicleStableKey(vehicle, tractors(company).indexOf(vehicle));
  	      state.vehicleActiveTab = "physical";
  	      clearVehicleEditorState();
  	      render();
  	      return;
  	    }
  	    state.selectedVehicleKey = vehicleStableKey(vehicle, tractors(company).indexOf(vehicle));
  	    state.vehicleActiveTab = defaultVehicleManagerTab(vehicle);
  	    clearVehicleEditorState();
  	    render();
  	  }

  	  function fifLocalDateTimeValue(date) {
  	    const value = date instanceof Date ? date: new Date(date || Date.now());
  	    const pad = function (number) { return String(number).padStart(2, "0"); };
  	    return value.getFullYear() + "-" + pad(value.getMonth() + 1) + "-" + pad(value.getDate()) + "T" + pad(value.getHours()) + ":" + pad(value.getMinutes());
  	  }

  	  function fifUpsertObjectById(list, row) {
  	    if (!Array.isArray(list) || !row) return row || null;
  	    const identity = fifRecordIdentity(row);
  	    const index = list.findIndex(function (item) {
  	      return fifRecordMatches(item, identity, null);
  	    });
  	    if (index >= 0) {
  	      fifMergeAppDataMutable(list[index], row);
  	      return list[index];
  	    }
  	    list.push(row);
  	    return row;
  	  }

  	  function fifArrayFromLocationSource(value) {
  	    const visited = typeof WeakSet !== "undefined" ? new WeakSet() : null;

  	    function expand(source) {
  	      if (source === null || source === undefined || source === "") return [];

  	      const raw = descriptorValue(source);
  	      if (raw !== source) return expand(raw);

  	      if (Array.isArray(raw)) return raw;

  	      if (typeof raw === "string") {
  	        try {
  	          const parsed = JSON.parse(raw);
  	          if (parsed !== raw) return expand(parsed);
  	        } catch (_) {}
  	        return [];
  	      }

  	      if (!raw || typeof raw !== "object") return [];

  	      if (visited) {
  	        if (visited.has(raw)) return [];
  	        visited.add(raw);
  	      }

  	      const relationArrays = [
  	        raw.data,
  	        raw.Data,
  	        raw.items,
  	        raw.Items,
  	        raw.rows,
  	        raw.Rows,
  	        raw.results,
  	        raw.Results,
  	        raw.relations,
  	        raw.Relations,
  	        raw.collection,
  	        raw.Collection
  	      ];

  	      for (let index = 0; index < relationArrays.length; index += 1) {
  	        const candidate = relationArrays[index];
  	        if (Array.isArray(candidate)) return candidate;
  	      }

  	      return [raw];
  	    }

  	    return expand(value);
  	  }

  	  function fifLocationIdentityTokens(location) {
  	    if (!location || typeof location !== "object") return [];
  	    return uniqueStrings([
  	      location.objectId,
  	      location.ObjectId,
  	      location.LocationId,
  	      location.locationId,
  	      location.ID,
  	      location.Id,
  	      location.id,
  	      location.FID,
  	      location.Name,
  	      location.LocationName,
  	      location.Label,
  	      location.REF,
  	      location.Ref
  	    ].map(function (value) {
  	      return permissionNormalKey(clean(value));
  	    }).filter(Boolean));
  	  }

  	  function fifLocationChildren(location) {
  	    if (!location || typeof location !== "object") return [];

  	    const rows = [];
  	    [
  	      location.Children,
  	      location.children,
  	      location.ChildLocations,
  	      location.childLocations,
  	      location.Locations,
  	      location.locations,
  	      location.Fields,
  	      location.fields,
  	      location.Segments,
  	      location.segments,
  	      location.Rings,
  	      location.rings,
  	      getDeep(location, ["Data", "Children"], null),
  	      getDeep(location, ["Data", "ChildLocations"], null),
  	      getDeep(location, ["Data", "Locations"], null),
  	      getDeep(location, ["LocationData", "Children"], null),
  	      getDeep(location, ["LocationData", "Locations"], null)
  	    ].forEach(function (source) {
  	      fifArrayFromLocationSource(source).forEach(function (child) {
  	        if (child && typeof child === "object") rows.push(child);
  	      });
  	    });

  	    return rows;
  	  }

  	  function fifCompanyLocations(company) {
  	    const rows = [];
  	    const objectSeen = typeof WeakSet !== "undefined" ? new WeakSet() : null;
  	    const primitiveSeen = Object.create(null);

  	    function visit(location, pathKey) {
  	      if (!location || typeof location !== "object") return;

  	      if (objectSeen) {
  	        if (objectSeen.has(location)) return;
  	        objectSeen.add(location);
  	      } else {
  	        const primitiveKey = clean(firstValue([
  	          location.objectId,
  	          location.ObjectId,
  	          location.LocationId,
  	          location.ID,
  	          location.FID,
  	          pathKey
  	        ], pathKey || ""));
  	        if (primitiveKey && primitiveSeen[primitiveKey]) return;
  	        if (primitiveKey) primitiveSeen[primitiveKey] = true;
  	      }

  	      rows.push(location);

  	      fifLocationChildren(location).forEach(function (child, index) {
  	        visit(child, (pathKey || "location") + "/" + index);
  	      });
  	    }

  	    [
  	      company && company.Locations,
  	      company && company.locations,
  	      company && company.Location,
  	      company && company.location,
  	      getDeep(company, ["Manifest", "Locations"], null),
  	      getDeep(company, ["Data", "Locations"], null),
  	      getDeep(company, ["Data", "Manifest", "Locations"], null)
  	    ].forEach(function (source, sourceIndex) {
  	      fifArrayFromLocationSource(source).forEach(function (location, index) {
  	        visit(location, "source-" + sourceIndex + "-" + index);
  	      });
  	    });

  	    return rows;
  	  }

  	  const FIF_VEHICLE_EVENTS_STYLE_ID = "fif-vehicle-location-events-style";

  	  function fifLocationJobs(location) {
  	    const rows = [];
  	    const seen = Object.create(null);

  	    [
  	      location && location.Jobs,
  	      location && location.Job,
  	      location && location.jobs,
  	      location && location.job,
  	      location && location.JobEntries,
  	      location && location.jobEntries,
  	      location && location.LocationJobs,
  	      location && location.locationJobs,
  	      getDeep(location, ["Data", "Jobs"], null),
  	      getDeep(location, ["Data", "JobEntries"], null),
  	      getDeep(location, ["Data", "LocationJobs"], null),
  	      getDeep(location, ["Data", "Location", "Jobs"], null),
  	      getDeep(location, ["LocationData", "Jobs"], null),
  	      getDeep(location, ["LocationData", "JobEntries"], null),
  	      getDeep(location, ["Manifest", "Jobs"], null)
  	    ].forEach(function (source, sourceIndex) {
  	      fifArrayFromLocationSource(source).forEach(function (job, index) {
  	        if (!job || typeof job !== "object") return;
  	        const key = clean(firstValue([
  	          job.objectId,
  	          job.ObjectId,
  	          job.JobId,
  	          job.DraftId,
  	          job.ID,
  	          job.FID,
  	          "job-" + sourceIndex + "-" + index + "-" + clean(job.DateISO)
  	        ], "job-" + sourceIndex + "-" + index));
  	        if (seen[key]) return;
  	        seen[key] = true;
  	        rows.push(job);
  	      });
  	    });

  	    return rows;
  	  }

  	  function fifLocationEventCompanyKey(company) {
  	    return clean(firstValue([
  	      objectIdOf(company),
  	      company && company.CompanyId,
  	      company && company.CompanyID,
  	      company && company.ID,
  	      company && company.FID,
  	      company && company.Name,
  	      company && company.CompanyName
  	    ], "company"));
  	  }

  	  function fifLocationEventLocationIds(company) {
  	    return uniqueStrings(
  	      fifCompanyLocations(company).map(function (location) {
  	        return clean(firstValue([
  	          location && location.objectId,
  	          location && location.ObjectId,
  	          location && location.LocationId,
  	          location && location.ID,
  	          location && location.FID
  	        ], ""));
  	      }).filter(Boolean)
  	    );
  	  }

  	  function fifLocationEventDatabaseRows(company) {
  	    const key = fifLocationEventCompanyKey(company);
  	    const store = state.locationEventDatabaseRows || {};
  	    return Array.isArray(store[key]) ? store[key].slice() : [];
  	  }



  	  async function fifHydrateCompanyLocationEvents(company, force) {
  	    if (!company) return [];

  	    refreshCurrentUserPermissions(false);
  	    if (!CAN_ACCESS_LOCATION_EVENTS) return [];

  	    const companyKeyValue = fifLocationEventCompanyKey(company);

  	    if (!state.locationEventDatabaseRows) state.locationEventDatabaseRows = {};
  	    if (!state.locationEventDatabaseLoaded) state.locationEventDatabaseLoaded = {};
  	    if (!state.locationEventDatabaseLoading) state.locationEventDatabaseLoading = {};
  	    if (!state.locationEventDatabaseError) state.locationEventDatabaseError = {};

  	    if (!force && state.locationEventDatabaseLoaded[companyKeyValue]) {
  	      return fifLocationEventDatabaseRows(company);
  	    }

  	    if (!force && state.locationEventDatabaseLoading[companyKeyValue]) {
  	      return state.locationEventDatabaseLoading[companyKeyValue];
  	    }

  	    const locationIds = fifLocationEventLocationIds(company);

  	    if (!locationIds.length) {
  	      state.locationEventDatabaseRows[companyKeyValue] = [];
  	      state.locationEventDatabaseLoaded[companyKeyValue] = true;
  	      state.locationEventDatabaseError[companyKeyValue] = "";
  	      state.locationEventCache = {};
  	      return [];
  	    }

  	    const loadingPromise = (async function () {
  	      const databaseApi = await fifWaitForRawWritableBackendlessApi(1800, "JobEntries");

  	      if (
  	        !databaseApi ||
  	        !databaseApi.Data ||
  	        typeof databaseApi.Data.of !== "function" ||
  	        !databaseApi.DataQueryBuilder ||
  	        typeof databaseApi.DataQueryBuilder.create !== "function"
  	      ) {
  	        throw new Error("The database JobEntries reader is unavailable.");
  	      }

  	      const store = databaseApi.Data.of("JobEntries");
  	      if (!store || typeof store.find !== "function") {
  	        throw new Error("The JobEntries table reader is unavailable.");
  	      }

  	      const collected = [];
  	      const seen = Object.create(null);

  	      for (let locationIndex = 0; locationIndex < locationIds.length; locationIndex += 1) {
  	        const locationIdValue = locationIds[locationIndex];
  	        const safeLocationId = clean(locationIdValue).replace(/'/g, "\\'");
  	        let offset = 0;
  	        let pageGuard = 0;

  	        while (pageGuard < 200) {
  	          pageGuard += 1;

  	          const query = databaseApi.DataQueryBuilder.create();
  	          query.setWhereClause(`LocationId = '${safeLocationId}'`);
  	          query.setPageSize(100);
  	          if (typeof query.setOffset === "function") query.setOffset(offset);
  	          query.setSortBy(["DateISO DESC"]);

  	          const result = await store.find(query);
  	          const page = Array.isArray(result)
  	            ? result
  	            : result && Array.isArray(result.data)
  	              ? result.data
  	              : [];

  	          page.forEach(function (job, index) {
  	            if (!job || typeof job !== "object") return;

  	            const key = clean(firstValue([
  	              job.objectId,
  	              job.ObjectId,
  	              job.JobId,
  	              job.DraftId,
  	              job.ID,
  	              job.FID,
  	              clean(job.LocationId) + "|" + clean(job.VehicleId) + "|" + clean(job.TractorObjectId) + "|" + clean(job.DateISO) + "|" + (offset + index)
  	            ], "job-" + locationIndex + "-" + offset + "-" + index));

  	            if (seen[key]) return;
  	            seen[key] = true;
  	            collected.push(job);
  	          });

  	          if (page.length < 100 || typeof query.setOffset !== "function") break;
  	          offset += page.length;
  	        }
  	      }

  	      state.locationEventDatabaseRows[companyKeyValue] = collected;
  	      state.locationEventDatabaseLoaded[companyKeyValue] = true;
  	      state.locationEventDatabaseError[companyKeyValue] = "";
  	      state.locationEventCache = {};

  	      return collected.slice();
  	    })();

  	    state.locationEventDatabaseLoading[companyKeyValue] = loadingPromise;

  	    try {
  	      return await loadingPromise;
  	    } catch (error) {
  	      state.locationEventDatabaseRows[companyKeyValue] = [];
  	      state.locationEventDatabaseLoaded[companyKeyValue] = false;
  	      state.locationEventDatabaseError[companyKeyValue] = clean(
  	        error && (error.message || error.faultString) ? (error.message || error.faultString) : error
  	      );
  	      state.locationEventCache = {};
  	      throw error;
  	    } finally {
  	      delete state.locationEventDatabaseLoading[companyKeyValue];
  	    }
  	  }

  	  function fifPreloadedCompanyJobEntries(company) {
  	    const rows = [];
  	    const seen = Object.create(null);

  	    [
  	      fifLocationEventDatabaseRows(company),
  	      company && company.JobEntries,
  	      company && company.jobEntries,
  	      company && company.Jobs,
  	      company && company.jobs,
  	      company && company.LocationJobs,
  	      company && company.locationJobs,
  	      getDeep(company, ["Data", "JobEntries"], null),
  	      getDeep(company, ["Data", "Jobs"], null),
  	      getDeep(company, ["Data", "LocationJobs"], null),
  	      getDeep(APP_DATA, ["JobEntries"], null),
  	      getDeep(APP_DATA, ["Jobs"], null),
  	      getDeep(APP_DATA, ["LocationJobs"], null),
  	      getDeep(APP_DATA, ["Data", "JobEntries"], null),
  	      getDeep(APP_DATA, ["Data", "Jobs"], null),
  	      getDeep(APP_DATA, ["User", "JobEntries"], null),
  	      getDeep(APP_DATA, ["User", "Jobs"], null)
  	    ].forEach(function (source, sourceIndex) {
  	      fifArrayFromLocationSource(source).forEach(function (job, index) {
  	        if (!job || typeof job !== "object") return;
  	        const key = clean(firstValue([
  	          job.objectId,
  	          job.ObjectId,
  	          job.JobId,
  	          job.DraftId,
  	          job.ID,
  	          job.FID,
  	          "preloaded-job-" + sourceIndex + "-" + index + "-" + clean(job.DateISO)
  	        ], "preloaded-job-" + sourceIndex + "-" + index));
  	        if (seen[key]) return;
  	        seen[key] = true;
  	        rows.push(job);
  	      });
  	    });

  	    return rows;
  	  }

  	  function fifLocationForPreloadedJob(locations, job) {
  	    const rows = Array.isArray(locations) ? locations : [];
  	    if (!job || typeof job !== "object" || !rows.length) return null;

  	    const jobLocationTokens = uniqueStrings([
  	      job.LocationId,
  	      job.LocationObjectId,
  	      job.locationId,
  	      job.locationObjectId,
  	      job.LocationLabel,
  	      job.LocationName,
  	      getDeep(job, ["Location", "objectId"], ""),
  	      getDeep(job, ["Location", "LocationId"], ""),
  	      getDeep(job, ["Location", "ID"], ""),
  	      getDeep(job, ["Location", "FID"], ""),
  	      getDeep(job, ["Location", "Name"], ""),
  	      getDeep(job, ["Location", "Label"], "")
  	    ].map(function (value) {
  	      return permissionNormalKey(clean(value));
  	    }).filter(Boolean));

  	    if (!jobLocationTokens.length) return null;

  	    for (let index = 0; index < rows.length; index += 1) {
  	      const locationTokens = fifLocationIdentityTokens(rows[index]);
  	      if (jobLocationTokens.some(function (token) {
  	        return locationTokens.indexOf(token) !== -1;
  	      })) {
  	        return rows[index];
  	      }
  	    }

  	    return null;
  	  }

  	  function fifLocationEventVehicleTokens(vehicle) {
  	    return uniqueStrings([
  	      objectIdOf(vehicle),
  	      vehicle && vehicle.objectId,
  	      vehicle && vehicle.ObjectId,
  	      vehicle && vehicle.ID,
  	      vehicle && vehicle.Id,
  	      vehicle && vehicle.id,
  	      vehicle && vehicle.FID,
  	      fifVehicleIdentityValue(vehicle, "FID", ""),
  	      vehicleRegistrationValue(vehicle),
  	      vehicleTitleValue(vehicle),
  	      vehicle && vehicle.Tracker,
  	      vehicle && vehicle.TrackerId,
  	      vehicle && vehicle.TrackerID,
  	      vehicle && vehicle.DeviceId,
  	      vehicle && vehicle.DeviceID
  	    ].map(function (value) {
  	      return permissionNormalKey(clean(value));
  	    }).filter(Boolean));
  	  }

  	  function fifLocationEventJobTokens(job) {
  	    return uniqueStrings([
  	      job && job.VehicleId,
  	      job && job.vehicleId,
  	      job && job.VehicleObjectId,
  	      job && job.vehicleObjectId,
  	      job && job.TractorId,
  	      job && job.tractorId,
  	      job && job.TractorObjectId,
  	      job && job.tractorObjectId,
  	      job && job.AssetId,
  	      job && job.AssetObjectId,
  	      job && job.VehicleLabel,
  	      job && job.TractorLabel,
  	      job && job.Registration,
  	      job && job.TrackerDeviceId,
  	      job && job.deviceId,
  	      getDeep(job, ["Vehicle", "objectId"], ""),
  	      getDeep(job, ["Tractor", "objectId"], ""),
  	      getDeep(job, ["Vehicle", "ID"], ""),
  	      getDeep(job, ["Tractor", "ID"], ""),
  	      getDeep(job, ["Vehicle", "FID"], ""),
  	      getDeep(job, ["Tractor", "FID"], ""),
  	      getDeep(job, ["Vehicle", "Registration"], ""),
  	      getDeep(job, ["Tractor", "Registration"], "")
  	    ].map(function (value) {
  	      return permissionNormalKey(clean(value));
  	    }).filter(Boolean));
  	  }

  	  function fifLocationJobMatchesVehicle(job, vehicle) {
  	    const vehicleTokens = fifLocationEventVehicleTokens(vehicle);
  	    if (!vehicleTokens.length) return false;

  	    const explicitIds = uniqueStrings([
  	      job && job.VehicleId,
  	      job && job.vehicleId,
  	      job && job.VehicleObjectId,
  	      job && job.vehicleObjectId,
  	      job && job.TractorId,
  	      job && job.tractorId,
  	      job && job.TractorObjectId,
  	      job && job.tractorObjectId,
  	      job && job.AssetId,
  	      job && job.AssetObjectId,
  	      getDeep(job, ["Vehicle", "objectId"], ""),
  	      getDeep(job, ["Tractor", "objectId"], "")
  	    ].map(function (value) {
  	      return permissionNormalKey(clean(value));
  	    }).filter(Boolean));

  	    if (explicitIds.length) {
  	      return explicitIds.some(function (token) {
  	        return vehicleTokens.indexOf(token) !== -1;
  	      });
  	    }

  	    const jobTokens = fifLocationEventJobTokens(job);
  	    return jobTokens.some(function (token) {
  	      return vehicleTokens.indexOf(token) !== -1;
  	    });
  	  }

  	  function fifEventDateObject(value) {
  	    if (value instanceof Date && !Number.isNaN(value.getTime())) return new Date(value.getTime());

  	    if (typeof value === "number" && Number.isFinite(value)) {
  	      let stamp = value;
  	      if (stamp > 1000000000 && stamp < 100000000000) stamp *= 1000;
  	      const numericDate = new Date(stamp);
  	      return Number.isNaN(numericDate.getTime()) ? null : numericDate;
  	    }

  	    const raw = clean(value);
  	    if (!raw) return null;

  	    if (/^\d{10,13}$/.test(raw)) {
  	      let stamp = Number(raw);
  	      if (raw.length === 10) stamp *= 1000;
  	      const numericDate = new Date(stamp);
  	      return Number.isNaN(numericDate.getTime()) ? null : numericDate;
  	    }

  	    let match = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/);
  	    if (match) {
  	      const year = Number(match[1]);
  	      const month = Number(match[2]) - 1;
  	      const day = Number(match[3]);
  	      const date = new Date(year, month, day);
  	      return Number.isNaN(date.getTime()) ? null : date;
  	    }

  	    match = raw.match(/^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})(?:$|[T\s])/);
  	    if (match) {
  	      const date = new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
  	      return Number.isNaN(date.getTime()) ? null : date;
  	    }

  	    const parsed = new Date(raw);
  	    return Number.isNaN(parsed.getTime()) ? null : parsed;
  	  }

  	  function fifEventDateKey(value) {
  	    const raw = clean(value);
  	    const exact = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/);
  	    if (exact) return exact[1] + "-" + exact[2] + "-" + exact[3];

  	    const date = fifEventDateObject(value);
  	    if (!date) return "";
  	    return date.getFullYear() + "-" + fifDatePad(date.getMonth() + 1) + "-" + fifDatePad(date.getDate());
  	  }

  	  function fifEventClockValue(value) {
  	    if (value === null || value === undefined || value === "") {
  	      return { label: "", minutes: null, timestamp: null };
  	    }

  	    if (typeof value === "number" && Number.isFinite(value)) {
  	      if (value > 1000000000) {
  	        let stamp = value;
  	        if (stamp < 100000000000) stamp *= 1000;
  	        const date = new Date(stamp);
  	        if (!Number.isNaN(date.getTime())) {
  	          const minutes = date.getHours() * 60 + date.getMinutes();
  	          return {
  	            label: fifDatePad(date.getHours()) + ":" + fifDatePad(date.getMinutes()),
  	            minutes: minutes,
  	            timestamp: date.getTime()
  	          };
  	        }
  	      }
  	      if (value >= 0 && value < 24) {
  	        const minutes = Math.round(value * 60);
  	        return {
  	          label: fifDatePad(Math.floor(minutes / 60) % 24) + ":" + fifDatePad(minutes % 60),
  	          minutes: minutes,
  	          timestamp: null
  	        };
  	      }
  	      if (value >= 0 && value < 1440) {
  	        const minutes = Math.round(value);
  	        return {
  	          label: fifDatePad(Math.floor(minutes / 60) % 24) + ":" + fifDatePad(minutes % 60),
  	          minutes: minutes,
  	          timestamp: null
  	        };
  	      }
  	    }

  	    const raw = clean(value);
  	    if (!raw) return { label: "", minutes: null, timestamp: null };

  	    let match = raw.match(/(?:^|[T\s])(\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?\s*(AM|PM)?(?:$|[Z+\-\s])/i);
  	    if (!match) match = raw.match(/^(\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?\s*(AM|PM)?$/i);
  	    if (match) {
  	      let hours = Number(match[1]);
  	      const minutesPart = Number(match[2]);
  	      const meridiem = clean(match[3]).toUpperCase();
  	      if (meridiem === "PM" && hours < 12) hours += 12;
  	      if (meridiem === "AM" && hours === 12) hours = 0;
  	      if (hours >= 0 && hours < 24 && minutesPart >= 0 && minutesPart < 60) {
  	        const minutes = hours * 60 + minutesPart;
  	        return {
  	          label: fifDatePad(hours) + ":" + fifDatePad(minutesPart),
  	          minutes: minutes,
  	          timestamp: null
  	        };
  	      }
  	    }

  	    const date = fifEventDateObject(raw);
  	    if (date) {
  	      const minutes = date.getHours() * 60 + date.getMinutes();
  	      return {
  	        label: fifDatePad(date.getHours()) + ":" + fifDatePad(date.getMinutes()),
  	        minutes: minutes,
  	        timestamp: date.getTime()
  	      };
  	    }

  	    return { label: raw, minutes: null, timestamp: null };
  	  }

  	  function fifEventNumberValue(value) {
  	    const raw = descriptorValue(value);
  	    if (raw === null || raw === undefined || clean(raw) === "") return null;
  	    const parsed = Number(raw);
  	    return Number.isFinite(parsed) ? parsed : null;
  	  }

  	  function fifEventExplicitDurationMinutes(job) {
  	    const directMinutes = fifEventNumberValue(firstValue([
  	      job && job.DurationMinutes,
  	      job && job.ElapsedMinutes,
  	      job && job.TimeMinutes
  	    ], null));
  	    if (directMinutes !== null && directMinutes >= 0) return directMinutes;

  	    const directHours = fifEventNumberValue(firstValue([
  	      job && job.DurationHours,
  	      job && job.ElapsedHours,
  	      job && job.TimeHours
  	    ], null));
  	    if (directHours !== null && directHours >= 0) return directHours * 60;

  	    const raw = firstValue([
  	      job && job.Duration,
  	      job && job.Elapsed,
  	      job && job.TimeTaken,
  	      job && job.Time
  	    ], null);
  	    if (raw === null || raw === undefined || raw === "") return null;

  	    if (typeof raw === "number" && Number.isFinite(raw)) {
  	      if (raw >= 0 && raw <= 24) return raw * 60;
  	      if (raw > 24 && raw <= 1440) return raw;
  	      return null;
  	    }

  	    const text = clean(raw);
  	    if (!text) return null;
  	    let match = text.match(/^(\d{1,3}):(\d{2})$/);
  	    if (match) return Number(match[1]) * 60 + Number(match[2]);

  	    match = text.match(/(?:(\d+(?:\.\d+)?)\s*h(?:ours?)?)?\s*(?:(\d+(?:\.\d+)?)\s*m(?:in(?:utes?)?)?)?/i);
  	    if (match && (match[1] || match[2])) {
  	      return numberOr(match[1], 0) * 60 + numberOr(match[2], 0);
  	    }

  	    const numeric = Number(text.replace(",", "."));
  	    if (Number.isFinite(numeric) && numeric >= 0) {
  	      return numeric <= 24 ? numeric * 60 : numeric <= 1440 ? numeric : null;
  	    }
  	    return null;
  	  }

  	  function fifEventDurationMinutes(job, timeIn, timeOut) {
  	    if (
  	      timeIn && timeOut &&
  	      timeIn.minutes !== null && timeOut.minutes !== null
  	    ) {
  	      let difference = timeOut.minutes - timeIn.minutes;
  	      if (difference < 0) difference += 1440;
  	      return difference;
  	    }
  	    return fifEventExplicitDurationMinutes(job);
  	  }

  	  function fifEventDurationLabel(minutes) {
  	    if (minutes === null || minutes === undefined || !Number.isFinite(Number(minutes))) return "—";
  	    const total = Math.max(0, Math.round(Number(minutes)));
  	    const hours = Math.floor(total / 60);
  	    const mins = total % 60;
  	    if (!hours) return mins + "m";
  	    return hours + "h " + fifDatePad(mins) + "m";
  	  }

  	  function fifLocationEventDateValue(job) {
  	    return fifEventDateKey(firstValue([
  	      job && job.DateISO,
  	      job && job.Date,
  	      job && job.JobDate,
  	      job && job.TimeIn,
  	      job && job.TimeOut,
  	      job && job.created,
  	      job && job.updated
  	    ], ""));
  	  }

  	  function fifLocationEventTimestamp(job) {
  	    const dateKey = fifLocationEventDateValue(job);
  	    const clock = fifEventClockValue(firstValue([
  	      job && job.TimeIn,
  	      job && job.StartTime,
  	      job && job.Time
  	    ], ""));
  	    if (dateKey) {
  	      const parts = dateKey.split("-").map(Number);
  	      if (parts.length === 3) {
  	        const minutes = clock.minutes === null ? 0 : clock.minutes;
  	        const date = new Date(parts[0], parts[1] - 1, parts[2], Math.floor(minutes / 60), minutes % 60, 0, 0);
  	        if (!Number.isNaN(date.getTime())) return date.getTime();
  	      }
  	    }
  	    if (clock.timestamp !== null) return clock.timestamp;

  	    const fallback = fifEventDateObject(firstValue([job && job.created, job && job.updated], null));
  	    return fallback ? fallback.getTime() : 0;
  	  }

  	  function fifLocationEventPeriodKey(job) {
  	    const raw = fifLocationEventDateValue(job);
  	    const match = raw.match(/^(\d{4})-(\d{2})/);
  	    return match ? match[1] + "-" + match[2] : "";
  	  }

  	  function fifLocationEventApplications(job) {
  	    return fifArrayFromLocationSource(firstValue([
  	      job && job.Applications,
  	      job && job.Application,
  	      getDeep(job, ["Data", "Applications"], null)
  	    ], []));
  	  }

  	  function fifLocationEventApplicationType(application) {
  	    if (!application || typeof application !== "object") return "";
  	    return clean(firstValue([
  	      application.Type,
  	      application.ApplicationType,
  	      application.Action,
  	      application.Event
  	    ], ""));
  	  }

  	  function fifLocationEventApplicationProduct(application) {
  	    if (!application || typeof application !== "object") return clean(application);
  	    return clean(firstValue([
  	      application.Product,
  	      application.Crop,
  	      application.Material,
  	      application.Description
  	    ], ""));
  	  }

  	  function fifLocationEventApplicationRate(application) {
  	    if (!application || typeof application !== "object") return "";
  	    return clean(firstValue([
  	      application.RateText,
  	      application.Rate,
  	      application.QuantityText,
  	      application.Quantity
  	    ], ""));
  	  }



  	  function fifLocationEventName(job, applications) {
  	    const direct = clean(firstValue([
  	      job && job.EventLabel,
  	      job && job.Event,
  	      job && job.Activity,
  	      job && job.JobType,
  	      job && job.Type
  	    ], ""));
  	    const types = uniqueStrings((applications || []).map(fifLocationEventApplicationType).filter(Boolean));
  	    const base = direct || types.join(" · ") || clean(job && job.Status) || "Location Visit";
  	    const implement = clean(firstValue([
  	      job && job.TrailerLabel,
  	      job && job.ImplementLabel,
  	      job && job.AttachmentLabel
  	    ], ""));
  	    return implement && permissionNormalKey(base).indexOf(permissionNormalKey(implement)) === -1
  	      ? base + " · " + implement
  	      : base;
  	  }

  	  function fifLocationEventActivity(job) {
  	    const applications = fifLocationEventApplications(job);
  	    const eventName = fifLocationEventName(job, applications);
  	    const productText = applications.map(function (application) {
  	      return [
  	        fifLocationEventApplicationProduct(application),
  	        fifLocationEventApplicationRate(application)
  	      ].filter(Boolean).join(" · ");
  	    }).filter(Boolean);

  	    if (productText.length) return eventName + " · " + productText.join(" | ");

  	    const fuel = fifEventNumberValue(firstValue([
  	      job && job.Fuel,
  	      job && job.FuelVolumeOut,
  	      job && job.FuelVolumeIn,
  	      job && job.FuelConsumedOut,
  	      job && job.FuelConsumedIn
  	    ], null));
  	    if (fuel !== null && fuel > 0) return eventName + " · Fuel " + formatLitres(fuel);

  	    return eventName;
  	  }

  	  function fifLocationEventLocationLabel(location, job) {
  	    return clean(firstValue([
  	      job && job.LocationLabel,
  	      job && job.LocationName,
  	      location && location.Name,
  	      location && location.LocationName,
  	      location && location.Label,
  	      location && location.REF,
  	      location && location.FID,
  	      location && location.ID
  	    ], "Location"));
  	  }

  	  function fifLocationEventTimeLabel(job) {
  	    const start = fifEventClockValue(firstValue([job && job.TimeIn, job && job.StartTime], ""));
  	    const end = fifEventClockValue(firstValue([job && job.TimeOut, job && job.EndTime], ""));
  	    if (start.label && end.label) return start.label + " – " + end.label;
  	    return start.label || end.label || "";
  	  }

  	  function fifLocationEventMileageLabel(job) {
  	    const start = fifEventNumberValue(firstValue([job && job.CanMileageIn, job && job.VehMileageIn, job && job.MileageIn], null));
  	    const end = fifEventNumberValue(firstValue([job && job.CanMileageOut, job && job.VehMileageOut, job && job.MileageOut], null));
  	    if (start !== null && end !== null) return formatDistance(start) + " → " + formatDistance(end);
  	    if (end !== null) return formatDistance(end);
  	    if (start !== null) return formatDistance(start);
  	    return "—";
  	  }

  	  function fifLocationEventFuelValue(job) {
  	    return fifEventNumberValue(firstValue([
  	      job && job.Fuel,
  	      job && job.FuelVolumeOut,
  	      job && job.FuelVolumeIn,
  	      job && job.FuelConsumedOut,
  	      job && job.FuelConsumedIn
  	    ], null));
  	  }

  	  function fifLocationEventDriverLabel(job) {
  	    const combined = clean(firstValue([
  	      job && job.DriverNames,
  	      job && job.DriverName,
  	      job && job.Driver,
  	      job && job.DriverLabel
  	    ], ""));

  	    if (combined) return combined;

  	    return uniqueStrings([
  	      job && job.Driver1Name,
  	      job && job.Driver2Name,
  	      getDeep(job, ["Driver1", "Name"], ""),
  	      getDeep(job, ["Driver1", "name"], ""),
  	      getDeep(job, ["Driver2", "Name"], ""),
  	      getDeep(job, ["Driver2", "name"], "")
  	    ].map(clean).filter(Boolean)).join(" / ");
  	  }

  	  function fifNormaliseLocationEvent(location, job, vehicle) {
  	    const locationLabel = fifLocationEventLocationLabel(location, job);
  	    const applications = fifLocationEventApplications(job);
  	    const dateKey = fifLocationEventDateValue(job);
  	    const timeIn = fifEventClockValue(firstValue([job && job.TimeIn, job && job.StartTime], ""));
  	    const timeOut = fifEventClockValue(firstValue([job && job.TimeOut, job && job.EndTime], ""));
  	    const durationMinutes = fifEventDurationMinutes(job, timeIn, timeOut);
  	    const objectId = clean(firstValue([job && job.objectId, job && job.JobId, job && job.DraftId], ""));
  	    const eventName = fifLocationEventName(job, applications);
  	    const productLines = applications.map(fifLocationEventApplicationProduct);
  	    const rateLines = applications.map(fifLocationEventApplicationRate);
  	    const fuelValue = fifLocationEventFuelValue(job);

  	    return {
  	      key: objectId || [
  	        dateKey,
  	        locationLabel,
  	        clean(job && job.VehicleId),
  	        clean(job && job.DraftId)
  	      ].join("|"),
  	      objectId: objectId,
  	      jobObjectId: clean(job && job.objectId),
  	      jobTable: clean(job && job.___class) === "JobEntries" ? "JobEntries" : "JobEntries",
  	      rawJob: job,
  	      rawLocation: location,
  	      dateValue: dateKey,
  	      dateKey: dateKey,
  	      timestamp: fifLocationEventTimestamp(job),
  	      periodKey: fifLocationEventPeriodKey(job),
  	      dateLabel: dateKey || "—",
  	      timeLabel: fifLocationEventTimeLabel(job),
  	      timeInLabel: timeIn.label || "—",
  	      timeOutLabel: timeOut.label || "—",
  	      durationMinutes: durationMinutes,
  	      durationLabel: fifEventDurationLabel(durationMinutes),
  	      locationLabel: locationLabel,
  	      fieldLabel: locationLabel,
  	      locationType: fifLocationType(location) || "Location",
  	      activity: fifLocationEventActivity(job),
  	      eventLabel: eventName,
  	      applications: applications,
  	      productLines: productLines,
  	      rateLines: rateLines,
  	      area: fifEventNumberValue(firstValue([job && job.Area, job && job.AreaHa, job && job.Hectares], null)),
  	      mileage: fifLocationEventMileageLabel(job),
  	      contractor: clean(firstValue([job && job.ContractorLabel, job && job.ContractorName], "")),
  	      driver: fifLocationEventDriverLabel(job),
  	      tractorLabel: clean(firstValue([
  	        job && job.Registration,
  	        vehicle && vehicleRegistrationValue(vehicle),
  	        job && job.VehicleLabel,
  	        job && job.TractorLabel,
  	        vehicle && vehicleTitleValue(vehicle)
  	      ], "—")),
  	      fuelValue: fuelValue,
  	      fuelLabel: fuelValue === null ? "—" : formatNumber(fuelValue, 2),
  	      status: clean(firstValue([job && job.Status, "Recorded"], "Recorded"))
  	    };
  	  }


  	  function fifVehicleStoredEventJobs(vehicle) {
  	    const rows = [];
  	    const seen = Object.create(null);

  	    [vehicle && vehicle.ViewC].concat(arr(vehicle && vehicle.ViewH)).filter(Boolean).forEach(function (view) {
  	      [
  	        view && view.Events,
  	        view && view.EventHistory,
  	        view && view.JobEntries,
  	        getDeep(view, ["Data", "Events"], null),
  	        getDeep(view, ["Data", "EventHistory"], null)
  	      ].forEach(function (source) {
  	        fifArrayFromLocationSource(source).forEach(function (job, index) {
  	          if (!job || typeof job !== "object") return;

  	          const key = clean(firstValue([
  	            job.objectId,
  	            job.ObjectId,
  	            job.JobId,
  	            job.DraftId,
  	            job.ID,
  	            job.FID,
  	            "stored-event-" + clean(view && view.objectId) + "-" + index
  	          ], "stored-event-" + index));

  	          if (seen[key]) return;
  	          seen[key] = true;
  	          rows.push(job);
  	        });
  	      });
  	    });

  	    return rows;
  	  }

  	  function fifCurrentVehicleViewForEventJob(vehicle, job) {
  	    if (!vehicle || !job) return null;

  	    const targetPeriod = fifLocationEventPeriodKey(job);
  	    const candidates = [vehicle && vehicle.ViewC]
  	      .concat(arr(vehicle && vehicle.ViewH))
  	      .filter(Boolean);

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const view = candidates[index];
  	      const key = typeof fifFuelReportViewMonthKey === "function"
  	        ? fifFuelReportViewMonthKey(view)
  	        : clean(firstValue([view && view.MYearKey, view && view.MonthKey], ""));

  	      if (targetPeriod && key === targetPeriod) return view;
  	    }

  	    return vehicle && vehicle.ViewC ? vehicle.ViewC : null;
  	  }

  	  async function fifQuietAddEventRelationsToView(rawApi, view, jobs) {
  	    if (
  	      !rawApi ||
  	      !rawApi.Data ||
  	      typeof rawApi.Data.of !== "function" ||
  	      !view ||
  	      !objectIdOf(view)
  	    ) {
  	      return false;
  	    }

  	    const children = [];
  	    const seen = Object.create(null);

  	    (Array.isArray(jobs) ? jobs : []).forEach(function (job) {
  	      const id = clean(firstValue([
  	        job && job.objectId,
  	        job && job.ObjectId,
  	        job && job.JobId
  	      ], ""));

  	      if (!id || seen[id]) return;
  	      seen[id] = true;
  	      children.push({ objectId: id });
  	    });

  	    if (!children.length) return true;

  	    const store = rawApi.Data.of("Tractorview");
  	    if (!store || typeof store.addRelation !== "function") return false;

  	    let linked = false;

  	    try {
  	      await store.addRelation(
  	        { objectId: objectIdOf(view) },
  	        "Events:JobEntries:n",
  	        children
  	      );
  	      linked = true;
  	    } catch (qualifiedError) {
  	      if (v21RelationAlreadyLinked(qualifiedError)) {
  	        linked = true;
  	      } else {
  	        try {
  	          await store.addRelation(
  	            { objectId: objectIdOf(view) },
  	            "Events",
  	            children
  	          );
  	          linked = true;
  	        } catch (shortError) {
  	          linked = v21RelationAlreadyLinked(shortError);
  	        }
  	      }
  	    }

  	    if (!linked) return false;

  	    if (!Array.isArray(view.Events)) view.Events = [];

  	    children.forEach(function (child) {
  	      const source = jobs.find(function (job) {
  	        return clean(firstValue([
  	          job && job.objectId,
  	          job && job.ObjectId,
  	          job && job.JobId
  	        ], "")) === child.objectId;
  	      });

  	      if (!source) return;

  	      const exists = view.Events.some(function (item) {
  	        return clean(firstValue([
  	          item && item.objectId,
  	          item && item.ObjectId,
  	          item && item.JobId
  	        ], "")) === child.objectId;
  	      });

  	      if (!exists) view.Events.push(source);
  	    });

  	    return true;
  	  }


  	  function fifStoredEventViewKey(view) {
  	    return clean(firstValue([
  	      view && view.objectId,
  	      view && view.ObjectId,
  	      view && view.ID,
  	      view && view.FID
  	    ], ""));
  	  }

  	  function fifRelevantStoredEventViews(vehicle) {
  	    if (!vehicle) return [];

  	    if (state.viewMode === "historical") {
  	      const historical = periodView(vehicle);
  	      return historical ? [historical] : [];
  	    }

  	    return vehicle.ViewC ? [vehicle.ViewC] : [];
  	  }

  	  function fifStoredEventRelationRows(value) {
  	    if (Array.isArray(value)) return value;
  	    if (value && Array.isArray(value.data)) return value.data;
  	    if (value && Array.isArray(value.items)) return value.items;
  	    if (value && Array.isArray(value.results)) return value.results;
  	    return [];
  	  }

  	  async function fifLoadStoredEventsForView(rawApi, view, force) {
  	    if (!rawApi || !view || !fifStoredEventViewKey(view)) return [];

  	    if (!state.locationEventViewRelationLoaded) state.locationEventViewRelationLoaded = {};
  	    if (!state.locationEventViewRelationLoading) state.locationEventViewRelationLoading = {};

  	    const viewKeyValue = fifStoredEventViewKey(view);

  	    if (!force && state.locationEventViewRelationLoaded[viewKeyValue]) {
  	      return Array.isArray(view.Events) ? view.Events.slice() : [];
  	    }

  	    if (!force && state.locationEventViewRelationLoading[viewKeyValue]) {
  	      return state.locationEventViewRelationLoading[viewKeyValue];
  	    }

  	    const loadingPromise = (async function () {
  	      const store = rawApi.Data && typeof rawApi.Data.of === "function"
  	        ? rawApi.Data.of("Tractorview")
  	        : null;

  	      if (!store || typeof store.loadRelations !== "function") return [];

  	      const collected = [];
  	      const seen = Object.create(null);
  	      let offset = 0;
  	      let pageGuard = 0;

  	      while (pageGuard < 200) {
  	        pageGuard += 1;

  	        let page = [];

  	        if (
  	          rawApi.LoadRelationsQueryBuilder &&
  	          typeof rawApi.LoadRelationsQueryBuilder.create === "function"
  	        ) {
  	          const qb = rawApi.LoadRelationsQueryBuilder.create();

  	          if (typeof qb.setRelationName === "function") qb.setRelationName("Events");
  	          if (typeof qb.setPageSize === "function") qb.setPageSize(100);
  	          if (typeof qb.setOffset === "function") qb.setOffset(offset);

  	          const result = await store.loadRelations(
  	            String(fifStoredEventViewKey(view)),
  	            qb
  	          );

  	          page = fifStoredEventRelationRows(result);
  	        } else {
  	          let builder = null;

  	          if (
  	            rawApi.DataQueryBuilder &&
  	            typeof rawApi.DataQueryBuilder.create === "function"
  	          ) {
  	            builder = rawApi.DataQueryBuilder.create();
  	            if (typeof builder.setPageSize === "function") builder.setPageSize(100);
  	            if (typeof builder.setOffset === "function") builder.setOffset(offset);
  	          }

  	          const result = builder
  	            ? await store.loadRelations(
  	                { objectId: fifStoredEventViewKey(view) },
  	                "Events",
  	                builder
  	              )
  	            : await store.loadRelations(
  	                { objectId: fifStoredEventViewKey(view) },
  	                "Events"
  	              );

  	          page = fifStoredEventRelationRows(result);
  	        }

  	        page.forEach(function (job, index) {
  	          if (!job || typeof job !== "object") return;

  	          const key = clean(firstValue([
  	            job.objectId,
  	            job.ObjectId,
  	            job.JobId,
  	            job.DraftId,
  	            job.ID,
  	            job.FID,
  	            "view-event-" + offset + "-" + index
  	          ], "view-event-" + offset + "-" + index));

  	          if (seen[key]) return;
  	          seen[key] = true;
  	          collected.push(job);
  	        });

  	        if (page.length < 100) break;
  	        offset += page.length;
  	      }

  	      view.Events = collected;
  	      state.locationEventViewRelationLoaded[viewKeyValue] = true;
  	      state.locationEventCache = {};

  	      return collected.slice();
  	    })();

  	    state.locationEventViewRelationLoading[viewKeyValue] = loadingPromise;

  	    try {
  	      return await loadingPromise;
  	    } finally {
  	      delete state.locationEventViewRelationLoading[viewKeyValue];
  	    }
  	  }

  	  async function fifHydrateStoredEventHistory(company, force) {
  	    if (!company || !CAN_ACCESS_LOCATION_EVENTS) return [];

  	    const rawApi = await fifWaitForRawWritableBackendlessApi(1800, "Tractorview");
  	    if (!rawApi) return [];

  	    const tasks = [];

  	    tractors(company).forEach(function (vehicle) {
  	      fifRelevantStoredEventViews(vehicle).forEach(function (view) {
  	        tasks.push(
  	          fifLoadStoredEventsForView(rawApi, view, !!force)
  	            .catch(function () { return []; })
  	        );
  	      });
  	    });

  	    if (!tasks.length) return [];

  	    const result = await Promise.all(tasks);
  	    state.locationEventCache = {};
  	    return result;
  	  }

  	  function fifPersistHydratedEventsIntoHistory(company) {
  	    if (!company || state.destroyed) return;

  	    setTimeout(function () {
  	      (async function () {
  	        const rawApi = await fifWaitForRawWritableBackendlessApi(1800, "Tractorview");
  	        if (!rawApi) return;

  	        const hydrated = fifLocationEventDatabaseRows(company);
  	        if (!hydrated.length) return;

  	        const allVehicles = tractors(company);

  	        for (let vehicleIndex = 0; vehicleIndex < allVehicles.length; vehicleIndex += 1) {
  	          const vehicle = allVehicles[vehicleIndex];
  	          const byView = new Map();

  	          hydrated.forEach(function (job) {
  	            if (!fifLocationJobMatchesVehicle(job, vehicle)) return;

  	            const view = fifCurrentVehicleViewForEventJob(vehicle, job);
  	            if (!view || !objectIdOf(view)) return;

  	            const viewId = objectIdOf(view);
  	            if (!byView.has(viewId)) byView.set(viewId, { view: view, jobs: [] });
  	            byView.get(viewId).jobs.push(job);
  	          });

  	          const groups = Array.from(byView.values());

  	          for (let groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
  	            const group = groups[groupIndex];
  	            await fifQuietAddEventRelationsToView(rawApi, group.view, group.jobs);
  	          }
  	        }
  	      })().catch(function () {
  	      });
  	    }, 0);
  	  }

  	  function fifVehicleLocationEvents(company, vehicle) {
  	    const rows = [];
  	    const seen = Object.create(null);
  	    if (!company || !vehicle) return rows;

  	    const cacheKey = [
  	      objectIdOf(company) || clean(company.CompanyId) || clean(company.CompanyID) || "company",
  	      objectIdOf(vehicle) || clean(vehicle.ID) || clean(fifVehicleIdentityValue(vehicle, "FID", "")) || vehicleTitleValue(vehicle)
  	    ].join("|");

  	    if (state.locationEventCache && state.locationEventCache[cacheKey]) {
  	      return state.locationEventCache[cacheKey].slice();
  	    }

  	    const locations = fifCompanyLocations(company);

  	    function pushJob(location, job, index, sourceName) {
  	      if (!location || !job || typeof job !== "object") return;
  	      if (!fifLocationJobMatchesVehicle(job, vehicle)) return;

  	      const event = fifNormaliseLocationEvent(location, job, vehicle);
  	      const key = event.objectId || [
  	        event.periodKey,
  	        event.locationLabel,
  	        event.activity,
  	        event.timestamp,
  	        clean(job && job.DraftId),
  	        sourceName || "preloaded",
  	        index
  	      ].join("|");

  	      if (seen[key]) return;
  	      seen[key] = true;
  	      rows.push(event);
  	    }

  	    fifVehicleStoredEventJobs(vehicle).forEach(function (job, index) {
  	      const location = fifLocationForPreloadedJob(locations, job);
  	      if (!location) return;
  	      pushJob(location, job, index, "tractorview-history");
  	    });

  	    locations.forEach(function (location, locationIndex) {
  	      fifLocationJobs(location).forEach(function (job, jobIndex) {
  	        pushJob(location, job, locationIndex + ":" + jobIndex, "location-relation");
  	      });
  	    });

  	    fifPreloadedCompanyJobEntries(company).forEach(function (job, index) {
  	      const location = fifLocationForPreloadedJob(locations, job);
  	      if (!location) return;
  	      pushJob(location, job, index, "preloaded-jobentries");
  	    });

  	    rows.sort(function (left, right) {
  	      if (left.timestamp !== right.timestamp) return right.timestamp - left.timestamp;
  	      return naturalCompare(right.locationLabel, left.locationLabel);
  	    });

  	    if (!state.locationEventCache) state.locationEventCache = {};
  	    state.locationEventCache[cacheKey] = rows;
  	    return rows.slice();
  	  }

  	  function fifSelectedVehicleEventPeriodKey(vehicle) {
  	    const view = periodView(vehicle);

  	    const viewMonthKey = typeof fifFuelReportViewMonthKey === "function"
  	      ? fifFuelReportViewMonthKey(view)
  	      : "";

  	    if (/^\d{4}-\d{2}$/.test(viewMonthKey)) return viewMonthKey;

  	    const direct = clean(firstValue([
  	      view && view.MYearKey,
  	      view && view.MonthKey
  	    ], ""));
  	    if (/^\d{4}-\d{2}$/.test(direct)) return direct;

  	    if (state.viewMode === "historical" && /^\d{4}-\d{2}$/.test(clean(state.selectedHistoryKey))) {
  	      return clean(state.selectedHistoryKey);
  	    }

  	    const dateKey = fifEventDateKey(firstValue([
  	      view && view.DateStart,
  	      view && view.StartDate,
  	      view && view.created
  	    ], ""));
  	    return /^\d{4}-\d{2}/.test(dateKey) ? dateKey.slice(0, 7) : "";
  	  }

  	  function fifVehicleDashboardEvents(company, vehicle) {
  	    const rows = fifVehicleLocationEvents(company, vehicle);
  	    const key = fifSelectedVehicleEventPeriodKey(vehicle);
  	    if (!key) return rows;
  	    return rows.filter(function (event) {
  	      return event.periodKey === key;
  	    });
  	  }

  	  function fifVehicleEventMetricValue(company, vehicle) {
  	    return formatCount(fifVehicleDashboardEvents(company, vehicle).length);
  	  }

  	  function fifVehicleEventSortValue(company, vehicle) {
  	    return fifVehicleDashboardEvents(company, vehicle).length;
  	  }



  	  function openVehicleLocationEvents(company, vehicle, requestedPeriod) {
  	    refreshCurrentUserPermissions(false);

  	    try {
  	      const legacyEventReport = document.getElementById(SERVICE_MODAL_ID);
  	      if (legacyEventReport) legacyEventReport.remove();
  	      state.serviceModalOpen = false;
  	    } catch (_) {}

  	    if (!CAN_ACCESS_LOCATION_EVENTS || !vehicle || assetIsTrailer(vehicle) || !userCanAccessAsset(vehicle)) {
  	      fifAlert("Location Events requires access to the Locations Office module and this vehicle.", {
  	        title: "Events Access Required",
  	        type: "warning",
  	        confirmText: "Close"
  	      });
  	      return null;
  	    }

  	    const safeString = function (value) {
  	      return value === undefined || value === null ? "" : String(value);
  	    };

  	    const eventCompany = company || selectedCompany();
  	    const appData = APP_DATA && APP_DATA.data && typeof APP_DATA.data === "object"
  	      ? APP_DATA.data
  	      : APP_DATA;
  	    const location = null;
  	    const locationId = clean(firstValue([
  	      objectIdOf(vehicle),
  	      vehicle && vehicle.objectId,
  	      vehicle && vehicle.ID,
  	      fifVehicleIdentityValue(vehicle, "FID", "")
  	    ], ""));
  	    const locationLabel = vehicleTitleValue(vehicle);
  	    const vehicleLabelForEvents = vehicleTitleValue(vehicle);

  	    const EVENTS_MOUNT_ID = "trackit-vehicle-events-manager";
  	    const EVENTS_STYLE_ID = "trackit-vehicle-events-manager-style";
  	    const TABLE_JOB_ENTRIES = "JobEntries";
  	    const TABLE_LOCATIONS = "Locations";
  	    const LOCATION_JOBS_RELATION_FIELD = "Jobs";

  	    const existing = document.getElementById(EVENTS_MOUNT_ID);
  	    if (existing) existing.remove();
  	    document.getElementById(EVENTS_STYLE_ID)?.remove();

  	    function hasBackendlessData() {
  	      return !!(
  	        typeof Backendless !== "undefined" &&
  	        Backendless &&
  	        Backendless.Data &&
  	        typeof Backendless.Data.of === "function"
  	      );
  	    }

  	    function getCompanyName(value) {
  	      return companyName(value);
  	    }



  	    function resolveReportBrandAsset(value) {
  	      let candidate = value;
  	      if (candidate && typeof candidate === "object") {
  	        candidate =
  	          candidate.value ??
  	          candidate.Value ??
  	          candidate.src ??
  	          candidate.Src ??
  	          candidate.url ??
  	          candidate.URL ??
  	          candidate.data ??
  	          candidate.Data ??
  	          "";
  	      }

  	      const raw = safeString(candidate).trim();
  	      if (!raw) return "";
  	      if (/^data:image\/(?:svg\+xml|png|jpe?g|webp|gif)(?:;|,)/i.test(raw)) return raw;
  	      if (/^<svg(?:\s|>)/i.test(raw)) {
  	        return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(raw);
  	      }
  	      if (/^(?:https?:|blob:)/i.test(raw)) return raw;
  	      return "";
  	    }

  	    const REPORT_SVG_INPUT = SVG_INPUT;

  	    const eventLocations = fifCompanyLocations(eventCompany);
  	    const eventLocationById = Object.create(null);

  	    eventLocations.forEach(function (candidate) {
  	      const ids = uniqueStrings([
  	        candidate && candidate.objectId,
  	        candidate && candidate.ObjectId,
  	        candidate && candidate.LocationId,
  	        candidate && candidate.ID,
  	        candidate && candidate.FID
  	      ].map(function (value) { return clean(value); }).filter(Boolean));

  	      ids.forEach(function (id) {
  	        eventLocationById[permissionNormalKey(id)] = candidate;
  	      });
  	    });

  	    function eventLocationForJob(job) {
  	      const direct = firstValue([
  	        job && job.Location,
  	        job && job.location,
  	        job && job.Field,
  	        job && job.field
  	      ], null);

  	      if (direct && typeof direct === "object") return direct;

  	      const ids = uniqueStrings([
  	        job && job.LocationId,
  	        job && job.LocationObjectId,
  	        job && job.FieldId,
  	        job && job.FieldObjectId,
  	        getDeep(job, ["Location", "objectId"], ""),
  	        getDeep(job, ["Field", "objectId"], "")
  	      ].map(function (value) { return clean(value); }).filter(Boolean));

  	      for (let index = 0; index < ids.length; index += 1) {
  	        const found = eventLocationById[permissionNormalKey(ids[index])];
  	        if (found) return found;
  	      }

  	      return null;
  	    }

  	    function eventFieldLabel(job) {
  	      const linked = eventLocationForJob(job);
  	      return clean(firstValue([
  	        job && job.FieldLabel,
  	        job && job.FieldName,
  	        getDeep(job, ["Field", "Name"], ""),
  	        getDeep(job, ["Field", "Label"], ""),
  	        linked && linked.FieldName,
  	        linked && linked.Name,
  	        linked && linked.Label,
  	        linked && linked.Title,
  	        linked && linked.REF,
  	        linked && linked.FID,
  	        linked && linked.ID
  	      ], ""));
  	    }

  	    function eventLocationDisplayLabel(job) {
  	      const linked = eventLocationForJob(job);
  	      const parent = linked && firstValue([
  	        linked.ParentLocation,
  	        linked.Parent,
  	        linked.LocationParent,
  	        linked.Site,
  	        linked.Farm,
  	        linked.Property,
  	        linked.Group
  	      ], null);

  	      return clean(firstValue([
  	        job && job.LocationLabel,
  	        job && job.LocationName,
  	        job && job.SiteName,
  	        job && job.FarmName,
  	        job && job.PropertyName,
  	        job && job.ParentLocationName,
  	        getDeep(job, ["Location", "Name"], ""),
  	        getDeep(job, ["Location", "Label"], ""),
  	        parent && parent.Name,
  	        parent && parent.LocationName,
  	        parent && parent.Label,
  	        parent && parent.Title,
  	        linked && linked.ParentName,
  	        linked && linked.SiteName,
  	        linked && linked.FarmName,
  	        linked && linked.PropertyName,
  	        linked && linked.LocationName,
  	        linked && linked.Name,
  	        linked && linked.Label,
  	        job && job.LocationId
  	      ], "Location"));
  	    }

  	    function eventLocationLabel(job) {
  	      return eventFieldLabel(job) || eventLocationDisplayLabel(job) || "Location";
  	    }



  	              function injectEventsStyles() {
  	                if (document.getElementById(EVENTS_STYLE_ID)) return;

  	                const style = document.createElement("style");
  	                style.id = EVENTS_STYLE_ID;
  	                style.textContent = `
  	                #${EVENTS_MOUNT_ID} {
  	                position: fixed;
  	                inset: 0;
  	                z-index: 2147483647;
  	                overflow: hidden;
  	                background: rgba(0,0,0,0.85);
  	                padding: 10px;
  	                box-sizing: border-box;
  	                font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-root {
  	                padding: 12px;
  	                box-sizing: border-box;
  	                color: #f0f0f0;
  	                max-width: 1700px;
  	                margin: 0 auto;
  	                height: calc(100vh - 20px);
  	                display: flex;
  	                flex-direction: column;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-card {
  	                border: 1px solid #333;
  	                border-radius: 14px;
  	                background: rgba(16,16,16,0.94);
  	                padding: 12px;
  	                box-sizing: border-box;
  	                display: flex;
  	                flex-direction: column;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                height: 100%;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-row {
  	                display: flex;
  	                gap: 8px;
  	                align-items: center;
  	                flex-wrap: wrap;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-actions {
  	                display: flex;
  	                align-items: center;
  	                justify-content: space-between;
  	                gap: 10px;
  	                flex-wrap: wrap;
  	                margin-top: 0;
  	                padding-top: 8px;
  	                flex: 0 0 auto;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-title {
  	                font-size: 1.05rem;
  	                font-weight: 900;
  	                color: #fff;
  	                margin: 0;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-sub {
  	                font-size: 0.78rem;
  	                color: #b0b0b0;
  	                margin-top: 2px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-badge {
  	                font-size: 0.72rem;
  	                padding: 4px 10px;
  	                border-radius: 999px;
  	                background: #2a2f38;
  	                color: #d2d7de;
  	                white-space: nowrap;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-divider {
  	                height: 1px;
  	                background: #2a2a2a;
  	                margin: 12px 0;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-search-wrap {
  	                margin: 10px 0 12px 0;
  	                flex: 0 0 auto;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-search {
  	                width: 100%;
  	                box-sizing: border-box;
  	                border: 1px solid #4a4a4a;
  	                background: #0f0f0f;
  	                color: #fff;
  	                border-radius: 10px;
  	                padding: 10px 12px;
  	                font-size: 0.90rem;
  	                outline: none;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-search:focus {
  	                border-color: #CC6633;
  	                box-shadow: 0 0 0 1px #CC6633 inset;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn {
  	                border-radius: 999px;
  	                border: 1px solid #555;
  	                background: #333;
  	                color: #e0e0e0;
  	                font-size: 0.85rem;
  	                padding: 8px 12px;
  	                cursor: pointer;
  	                user-select: none;
  	                white-space: nowrap;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn:hover {
  	                background: #3c3c3c;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-primary {
  	                background: #CC6633;
  	                border-color: #CC6633;
  	                color: #fff;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-primary:hover {
  	                background: #e0733a;
  	                border-color: #e0733a;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-danger {
  	                background: #7f1d1d;
  	                border-color: #a11f1f;
  	                color: #fff;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-danger:hover {
  	                background: #991b1b;
  	                border-color: #b91c1c;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-disabled {
  	                opacity: 0.55;
  	                cursor: not-allowed;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-events-box {
  	                border: 1px solid #333;
  	                border-radius: 12px;
  	                background: #101010;
  	                padding: 0;
  	                box-sizing: border-box;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                display: flex;
  	                flex-direction: column;
  	                overflow: hidden;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-tablewrap {
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                overflow: auto;
  	                border-radius: 12px;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table {
  	                width: 100%;
  	                border-collapse: collapse;
  	                min-width: 1650px;
  	                background: #141414;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table th,
  	                #${EVENTS_MOUNT_ID} table.jel-table td {
  	                padding: 10px 10px;
  	                border-bottom: 1px solid #242424;
  	                text-align: left;
  	                vertical-align: top;
  	                font-size: 0.9rem;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table th {
  	                position: sticky;
  	                top: 0;
  	                background: #1c1c1c;
  	                z-index: 2;
  	                font-weight: 800;
  	                color: #f2f2f2;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-muted {
  	                color: #a0a4aa;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-empty {
  	                color: #a0a4aa;
  	                font-size: 0.95rem;
  	                padding: 10px 12px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-cell {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 4px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-big {
  	                font-size: 0.95rem;
  	                font-weight: 900;
  	                color: #ffffff;
  	                line-height: 1.15;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-small {
  	                font-size: 0.80rem;
  	                color: #c1c6ce;
  	                line-height: 1.15;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-smallline {
  	                display: block;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-dash {
  	                color: #80858f;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-num {
  	                font-variant-numeric: tabular-nums;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-actions-cell {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 6px;
  	                min-width: 96px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-action-modal {
  	                position: fixed;
  	                inset: 0;
  	                z-index: 2147483647;
  	                display: grid;
  	                place-items: center;
  	                padding: 18px;
  	                box-sizing: border-box;
  	                background: rgba(0,0,0,0.82);
  	                backdrop-filter: blur(7px);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-action-panel {
  	                width: min(760px, calc(100vw - 36px));
  	                max-height: calc(100vh - 36px);
  	                display: flex;
  	                flex-direction: column;
  	                overflow: hidden;
  	                border: 1px solid rgba(204,102,51,0.62);
  	                border-radius: 20px;
  	                color: #f8fafc;
  	                background: linear-gradient(145deg, rgba(25,25,25,0.995), rgba(8,10,12,0.995));
  	                box-shadow: 0 28px 80px rgba(0,0,0,0.68), inset 0 1px 0 rgba(255,255,255,0.04);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-action-head {
  	                display: flex;
  	                align-items: flex-start;
  	                justify-content: space-between;
  	                gap: 16px;
  	                padding: 18px 18px 15px;
  	                border-bottom: 1px solid rgba(255,255,255,0.09);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-action-title {
  	                color: #fff;
  	                font-size: 1.12rem;
  	                font-weight: 900;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-action-sub {
  	                margin-top: 4px;
  	                color: #aeb5bf;
  	                font-size: 0.78rem;
  	                line-height: 1.4;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-action-body {
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                overflow: auto;
  	                padding: 16px 18px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-editor-list {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 10px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-editor-row {
  	                padding: 12px;
  	                border: 1px solid rgba(255,255,255,0.10);
  	                border-radius: 14px;
  	                background: rgba(255,255,255,0.035);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-editor-row-head {
  	                display: flex;
  	                align-items: center;
  	                justify-content: space-between;
  	                gap: 10px;
  	                margin-bottom: 10px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-editor-context {
  	                color: #d7dce3;
  	                font-size: 0.78rem;
  	                font-weight: 800;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-editor-grid {
  	                display: grid;
  	                grid-template-columns: minmax(0,1fr) minmax(0,1fr);
  	                gap: 10px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-field-label {
  	                display: block;
  	                margin-bottom: 5px;
  	                color: #b7bdc7;
  	                font-size: 0.72rem;
  	                font-weight: 850;
  	                text-transform: uppercase;
  	                letter-spacing: 0.04em;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-field-input {
  	                width: 100%;
  	                height: 42px;
  	                padding: 0 11px;
  	                box-sizing: border-box;
  	                border: 1px solid #4a4a4a;
  	                border-radius: 10px;
  	                outline: none;
  	                color: #fff;
  	                background: #0f0f0f;
  	                font: inherit;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-field-input:focus {
  	                border-color: #CC6633;
  	                box-shadow: 0 0 0 2px rgba(204,102,51,0.16);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-editor-tools {
  	                display: flex;
  	                justify-content: flex-start;
  	                margin-top: 12px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-action-error {
  	                display: none;
  	                margin-top: 12px;
  	                padding: 10px 12px;
  	                border: 1px solid rgba(205,70,55,0.55);
  	                border-radius: 10px;
  	                color: #ffd6ce;
  	                background: rgba(112,28,21,0.28);
  	                font-size: 0.80rem;
  	                line-height: 1.4;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-action-error.visible {
  	                display: block;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-action-foot {
  	                display: flex;
  	                justify-content: flex-end;
  	                gap: 9px;
  	                padding: 14px 18px 18px;
  	                border-top: 1px solid rgba(255,255,255,0.08);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-delete-name {
  	                padding: 12px 13px;
  	                border: 1px solid rgba(204,102,51,0.34);
  	                border-radius: 12px;
  	                color: #fff;
  	                background: rgba(204,102,51,0.10);
  	                font-weight: 900;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-delete-copy {
  	                margin-top: 13px;
  	                color: #c8cbd1;
  	                font-size: 0.86rem;
  	                line-height: 1.5;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-delete-copy strong {
  	                color: #fff;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-delete-input {
  	                width: 100%;
  	                height: 48px;
  	                margin-top: 12px;
  	                padding: 0 13px;
  	                box-sizing: border-box;
  	                border: 1px solid #9f3428;
  	                border-radius: 12px;
  	                outline: none;
  	                color: #fff;
  	                background: #0d0d0d;
  	                font-size: 1rem;
  	                font-weight: 900;
  	                letter-spacing: 0.08em;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-delete-input:focus {
  	                border-color: #e65b44;
  	                box-shadow: 0 0 0 3px rgba(198,58,40,0.16);
  	                }

  	                #${EVENTS_MOUNT_ID} {
  	                padding: 34px 24px 24px;
  	                background: rgba(2,5,3,0.82);
  	                backdrop-filter: blur(10px);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-root {
  	                width: min(1920px, 100%);
  	                max-width: none;
  	                height: calc(100vh - 58px);
  	                padding: 0;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-card {
  	                padding: 0;
  	                border: 1px solid rgba(204,102,51,0.58);
  	                border-radius: 16px;
  	                background: linear-gradient(145deg,#151b17,#080c09 62%);
  	                box-shadow: 0 28px 90px rgba(0,0,0,0.72), inset 0 1px 0 rgba(255,255,255,0.035);
  	                overflow: hidden;
  	                isolation: isolate;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-head {
  	                display: flex;
  	                align-items: flex-start;
  	                justify-content: space-between;
  	                gap: 18px;
  	                padding: 18px 20px 16px;
  	                border-bottom: 1px solid rgba(255,255,255,0.075);
  	                background: linear-gradient(90deg,rgba(31,39,33,0.96),rgba(10,14,11,0.92));
  	                border-radius: 15px 15px 0 0;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-kicker {
  	                display: block;
  	                margin-bottom: 5px;
  	                color: #d27a4c;
  	                font-size: 0.68rem;
  	                font-weight: 950;
  	                letter-spacing: 0.09em;
  	                text-transform: uppercase;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-title {
  	                font-size: 1.48rem;
  	                line-height: 1.1;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-head-actions {
  	                display: flex;
  	                gap: 9px;
  	                align-items: center;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-main {
  	                display: flex;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                flex-direction: column;
  	                padding: 14px;
  	                overflow: hidden;
  	                border-radius: 0 0 15px 15px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-actions {
  	                margin: 0 0 10px;
  	                padding: 11px 12px;
  	                border: 1px solid rgba(255,255,255,0.075);
  	                border-radius: 11px;
  	                background: rgba(255,255,255,0.026);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-actions-meta {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 3px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn {
  	                box-sizing: border-box;
  	                min-height: 38px;
  	                padding: 0 14px;
  	                border: 1px solid rgba(204,102,51,0.48);
  	                border-radius: 9px;
  	                background: linear-gradient(145deg,#1b211c,#101411);
  	                color: #ecf0ed;
  	                font-size: 0.76rem;
  	                font-weight: 850;
  	                box-shadow: none;
  	                transition: border-color .16s ease, background .16s ease, transform .16s ease;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn:hover:not(:disabled) {
  	                border-color: #d87945;
  	                background: #242c25;
  	                transform: translateY(-1px);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-primary {
  	                border-color: #b85a2f;
  	                background: linear-gradient(145deg,#b85a2f,#8e4122);
  	                color: #fff;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-primary:hover:not(:disabled) {
  	                border-color: #e1814d;
  	                background: linear-gradient(145deg,#ca6838,#a64b27);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-route {
  	                width: 100%;
  	                padding-left: 8px;
  	                padding-right: 8px;
  	                border-color: rgba(74,137,255,0.58);
  	                background: linear-gradient(145deg,#17335b,#102038);
  	                color: #dceaff;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-route:hover:not(:disabled) {
  	                border-color: #6198ff;
  	                background: linear-gradient(145deg,#214579,#142d50);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn:disabled {
  	                opacity: 0.42;
  	                cursor: not-allowed;
  	                transform: none;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-badge {
  	                padding: 6px 10px;
  	                border: 1px solid rgba(255,255,255,0.075);
  	                border-radius: 8px;
  	                background: #111713;
  	                color: #99a49d;
  	                font-weight: 800;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-search-wrap {
  	                margin: 0 0 10px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-search {
  	                min-height: 44px;
  	                border-color: rgba(255,255,255,0.09);
  	                border-radius: 9px;
  	                background: #090e0b;
  	                color: #f2f5f3;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-divider { display: none; }

  	                #${EVENTS_MOUNT_ID} .jel-events-box {
  	                border-color: rgba(255,255,255,0.08);
  	                border-radius: 10px;
  	                background: #090e0b;
  	                isolation: isolate;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-tablewrap {
  	                border-radius: inherit;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table {
  	                min-width: 1580px;
  	                table-layout: fixed;
  	                background: #0b100d;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table th,
  	                #${EVENTS_MOUNT_ID} table.jel-table td {
  	                padding: 12px 9px;
  	                border-bottom-color: rgba(255,255,255,0.065);
  	                overflow-wrap: anywhere;
  	                word-break: normal;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table th {
  	                background: #171d18;
  	                color: #aeb8b1;
  	                font-size: 0.70rem;
  	                letter-spacing: 0.055em;
  	                text-transform: uppercase;
  	                overflow: hidden;
  	                text-overflow: ellipsis;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table td {
  	                font-size: 0.78rem;
  	                line-height: 1.35;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table .jel-compact {
  	                white-space: nowrap;
  	                overflow: hidden;
  	                text-overflow: ellipsis;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table tbody tr:hover {
  	                background: rgba(204,102,51,0.045);
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-actions-cell {
  	                display: block;
  	                min-width: 0;
  	                gap: 7px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-actions-cell .jel-btn { width:100%; }

  	                #${EVENTS_MOUNT_ID} .jel-track-window {
  	                position: fixed;
  	                z-index: 2147483647;
  	                width: min(1180px,calc(100vw - 36px));
  	                height: min(720px,calc(100vh - 58px));
  	                left: 50%;
  	                top: 50%;
  	                transform: translate(-50%,-50%);
  	                display: flex;
  	                flex-direction: column;
  	                overflow: hidden;
  	                resize: none;
  	                border: 1px solid rgba(204,102,51,0.72);
  	                border-radius: 16px;
  	                color: #eff4f0;
  	                background: #090e0b;
  	                box-shadow: 0 30px 100px rgba(0,0,0,0.82);
  	                isolation: isolate;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-track-head {
  	                display: flex;
  	                align-items: flex-start;
  	                justify-content: space-between;
  	                gap: 14px;
  	                padding: 13px 15px;
  	                border-bottom: 1px solid rgba(255,255,255,0.08);
  	                background: linear-gradient(90deg,#1a211c,#0c110e);
  	                cursor: move;
  	                user-select: none;
  	                border-radius: 15px 15px 0 0;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-track-head strong { display:block; color:#fff; font-size:1.05rem; }
  	                #${EVENTS_MOUNT_ID} .jel-track-head small { display:block; margin-top:4px; color:#929d96; font-size:.72rem; }
  	                #${EVENTS_MOUNT_ID} .jel-track-head .jel-row { flex-wrap:nowrap; }

  	                #${EVENTS_MOUNT_ID} .jel-track-body {
  	                display: grid;
  	                grid-template-columns: minmax(0,1fr) 330px;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                overflow: hidden;
  	                border-radius: 0 0 15px 15px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-track-map-wrap { position:relative; min-height:320px; background:#101612; }
  	                #${EVENTS_MOUNT_ID} .jel-track-map { position:absolute; inset:0; }
  	                #${EVENTS_MOUNT_ID} .jel-track-state {
  	                position:absolute; inset:14px auto auto 14px; z-index:3; max-width:calc(100% - 28px);
  	                padding:9px 11px; border:1px solid rgba(204,102,51,.4); border-radius:9px;
  	                background:rgba(9,14,11,.91); color:#d6ddd8; font-size:.72rem; line-height:1.4;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-track-side {
  	                min-height:0; overflow:auto; padding:12px;
  	                border-left:1px solid rgba(255,255,255,.08); background:#0b100d;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-track-card {
  	                margin-bottom:9px; padding:11px; border:1px solid rgba(255,255,255,.075);
  	                border-radius:10px; background:#121813;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-track-card span {
  	                display:block; color:#d27a4c; font-size:.65rem; font-weight:900;
  	                letter-spacing:.065em; text-transform:uppercase;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-track-card strong { display:block; margin-top:5px; color:#f4f7f5; font-size:.88rem; }
  	                #${EVENTS_MOUNT_ID} .jel-track-card small { display:block; margin-top:4px; color:#87928b; font-size:.69rem; line-height:1.45; }

  	                #${EVENTS_MOUNT_ID} .jel-track-grid {
  	                display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:8px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-track-legend {
  	                position:absolute; left:12px; bottom:12px; z-index:3; display:flex; gap:9px; flex-wrap:wrap;
  	                padding:7px 9px; border-radius:8px; background:rgba(5,8,6,.88); color:#d7ddd9; font-size:.66rem;
  	                }
  	                #${EVENTS_MOUNT_ID} .jel-track-legend i { width:9px; height:9px; display:inline-block; margin-right:4px; border-radius:50%; }

  	                @media (max-width: 900px) {
  	                #${EVENTS_MOUNT_ID} { padding: 12px; }
  	                #${EVENTS_MOUNT_ID} .jel-root { height: calc(100vh - 24px); }
  	                #${EVENTS_MOUNT_ID} .jel-track-body { grid-template-columns:1fr; grid-template-rows:minmax(320px,1fr) auto; }
  	                #${EVENTS_MOUNT_ID} .jel-track-side { border-left:0; border-top:1px solid rgba(255,255,255,.08); max-height:230px; }
  	                }

  	                @media (max-width: 640px) {
  	                #${EVENTS_MOUNT_ID} .jel-editor-grid {
  	                grid-template-columns: 1fr;
  	                }
  	                }
  	                `;

  	                document.head.appendChild(style);
  	              }

  	              function pick(obj, keys) {
  	                if (!obj || typeof obj !== "object") return "";

  	                for (let i = 0; i < keys.length; i++) {
  	                  const value = obj[keys[i]];

  	                  if (value === undefined || value === null) continue;

  	                  const text = safeString(value).trim();

  	                  if (text) return text;
  	                }

  	                return "";
  	              }

  	              function numberPick(obj, keys) {
  	                if (!obj || typeof obj !== "object") return null;

  	                for (let i = 0; i < keys.length; i++) {
  	                  const value = obj[keys[i]];

  	                  if (value === undefined || value === null || value === "") continue;

  	                  const number = Number(value);

  	                  if (Number.isFinite(number)) return number;
  	                }

  	                return null;
  	              }

  	              function pad2(value) {
  	                const number = Number(value);

  	                if (!Number.isFinite(number)) return "00";

  	                return number < 10 ? `0${number}`: String(number);
  	              }

  	              function unwrapEventValue(value) {
  	                let current = value;
  	                let guard = 0;

  	                while (
  	                  current &&
  	                  typeof current === "object" &&
  	                  !(current instanceof Date) &&
  	                  Object.prototype.hasOwnProperty.call(current, "value") &&
  	                  guard < 5
  	                ) {
  	                  current = current.value;
  	                  guard += 1;
  	                }

  	                return current;
  	              }

  	              function readEventPath(object, path) {
  	                if (!object || typeof object !== "object") return undefined;
  	                if (Object.prototype.hasOwnProperty.call(object, path)) return object[path];

  	                const parts = String(path).split(".");
  	                let current = object;

  	                for (let index = 0; index < parts.length; index += 1) {
  	                  if (!current || typeof current !== "object") return undefined;
  	                  if (!Object.prototype.hasOwnProperty.call(current, parts[index])) return undefined;
  	                  current = current[parts[index]];
  	                }

  	                return current;
  	              }

  	              function firstEventValue(object, paths) {
  	                for (let index = 0; index < paths.length; index += 1) {
  	                  const raw = unwrapEventValue(readEventPath(object, paths[index]));

  	                  if (raw === undefined || raw === null) continue;
  	                  if (typeof raw === "string" && !raw.trim()) continue;

  	                  return raw;
  	                }

  	                return "";
  	              }

  	              function asDate(value) {
  	                const raw = unwrapEventValue(value);

  	                if (raw === undefined || raw === null || raw === "") return null;
  	                if (raw instanceof Date && !isNaN(raw.getTime())) return new Date(raw.getTime());

  	                if (typeof raw === "number" && Number.isFinite(raw)) {
  	                  let stamp = raw;
  	                  if (stamp > 1000000000 && stamp < 100000000000) stamp *= 1000;
  	                  const numericDate = new Date(stamp);
  	                  return isNaN(numericDate.getTime()) ? null: numericDate;
  	                }

  	                const text = safeString(raw).trim();
  	                if (!text) return null;

  	                if (/^\d{10,13}$/.test(text)) {
  	                  let stamp = Number(text);
  	                  if (text.length === 10) stamp *= 1000;
  	                  const numericDate = new Date(stamp);
  	                  return isNaN(numericDate.getTime()) ? null: numericDate;
  	                }

  	                const date = new Date(text);
  	                return isNaN(date.getTime()) ? null: date;
  	              }

  	              function parseClockValue(value) {
  	                const raw = unwrapEventValue(value);

  	                if (raw === undefined || raw === null || raw === "") {
  	                  return { label: "", minutes: null, timestamp: null };
  	                }

  	                if (raw instanceof Date && !isNaN(raw.getTime())) {
  	                  return {
  	                    label: `${pad2(raw.getHours())}:${pad2(raw.getMinutes())}`,
  	                    minutes: raw.getHours() * 60 + raw.getMinutes(),
  	                    timestamp: raw.getTime()
  	                  };
  	                }

  	                if (typeof raw === "number" && Number.isFinite(raw)) {
  	                  if (raw > 1000000000) {
  	                    const date = asDate(raw);
  	                    if (date) {
  	                      return {
  	                        label: `${pad2(date.getHours())}:${pad2(date.getMinutes())}`,
  	                        minutes: date.getHours() * 60 + date.getMinutes(),
  	                        timestamp: date.getTime()
  	                      };
  	                    }
  	                  }

  	                  if (raw >= 0 && raw < 24) {
  	                    const minutes = Math.round(raw * 60);
  	                    return {
  	                      label: `${pad2(Math.floor(minutes / 60) % 24)}:${pad2(minutes % 60)}`,
  	                      minutes,
  	                      timestamp: null
  	                    };
  	                  }

  	                  if (raw >= 0 && raw < 1440) {
  	                    const minutes = Math.round(raw);
  	                    return {
  	                      label: `${pad2(Math.floor(minutes / 60) % 24)}:${pad2(minutes % 60)}`,
  	                      minutes,
  	                      timestamp: null
  	                    };
  	                  }
  	                }

  	                const text = safeString(raw).trim();
  	                if (!text) return { label: "", minutes: null, timestamp: null };

  	                if (/^\d{10,13}$/.test(text)) {
  	                  const date = asDate(text);
  	                  if (date) {
  	                    return {
  	                      label: `${pad2(date.getHours())}:${pad2(date.getMinutes())}`,
  	                      minutes: date.getHours() * 60 + date.getMinutes(),
  	                      timestamp: date.getTime()
  	                    };
  	                  }
  	                }

  	                let match = text.match(/(?:^|[T\s])(\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?\s*(AM|PM)?(?:$|[Z+\-\s])/i);
  	                if (!match) match = text.match(/^(\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?\s*(AM|PM)?$/i);
  	                if (!match) match = text.match(/^(\d{1,2})\s*h(?:ours?)?\s*(\d{1,2})?\s*m?/i);

  	                if (match) {
  	                  let hours = Number(match[1]);
  	                  const minutesPart = Number(match[2] || 0);
  	                  const meridiem = safeString(match[3]).trim().toUpperCase();

  	                  if (meridiem === "PM" && hours < 12) hours += 12;
  	                  if (meridiem === "AM" && hours === 12) hours = 0;

  	                  if (hours >= 0 && hours < 24 && minutesPart >= 0 && minutesPart < 60) {
  	                    return {
  	                      label: `${pad2(hours)}:${pad2(minutesPart)}`,
  	                      minutes: hours * 60 + minutesPart,
  	                      timestamp: null
  	                    };
  	                  }
  	                }

  	                const date = asDate(text);
  	                if (date) {
  	                  return {
  	                    label: `${pad2(date.getHours())}:${pad2(date.getMinutes())}`,
  	                    minutes: date.getHours() * 60 + date.getMinutes(),
  	                    timestamp: date.getTime()
  	                  };
  	                }

  	                return { label: "", minutes: null, timestamp: null };
  	              }

  	              function formatDate(value) {
  	                const date = asDate(value);

  	                if (!date) return "";

  	                return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
  	              }

  	              function formatTime(value) {
  	                return parseClockValue(value).label;
  	              }

  	              function formatDuration(seconds) {
  	                const value = Number(seconds);

  	                if (!Number.isFinite(value) || value < 0) return "";

  	                const totalSeconds = Math.round(value);
  	                const hours = Math.floor(totalSeconds / 3600);
  	                const minutes = Math.floor((totalSeconds % 3600) / 60);

  	                if (hours > 0) return `${hours}h ${pad2(minutes)}m`;

  	                return `${minutes}m`;
  	              }

  	              function getBestTimeIn(job) {
  	                return firstEventValue(job, [
  	                  "TimeIn",
  	                  "timeIn",
  	                  "Time_In",
  	                  "time_in",
  	                  "StartTime",
  	                  "startTime",
  	                  "StartTimestamp",
  	                  "startTimestamp",
  	                  "StartedAt",
  	                  "startedAt",
  	                  "EnterTime",
  	                  "enterTime",
  	                  "EntryTime",
  	                  "entryTime",
  	                  "EntryTimestamp",
  	                  "entryTimestamp",
  	                  "EnteredAt",
  	                  "enteredAt",
  	                  "ArrivalTime",
  	                  "arrivalTime",
  	                  "ArrivedAt",
  	                  "arrivedAt",
  	                  "GeofenceEnterTime",
  	                  "geofenceEnterTime",
  	                  "GeofenceEntryTime",
  	                  "geofenceEntryTime",
  	                  "Data.TimeIn",
  	                  "Data.StartTime",
  	                  "Event.TimeIn",
  	                  "Event.StartTime",
  	                  "Times.TimeIn",
  	                  "Timing.TimeIn"
  	                ]);
  	              }

  	              function getBestTimeOut(job) {
  	                return firstEventValue(job, [
  	                  "TimeOut",
  	                  "timeOut",
  	                  "Time_Out",
  	                  "time_out",
  	                  "EndTime",
  	                  "endTime",
  	                  "EndTimestamp",
  	                  "endTimestamp",
  	                  "EndedAt",
  	                  "endedAt",
  	                  "ExitTime",
  	                  "exitTime",
  	                  "ExitTimestamp",
  	                  "exitTimestamp",
  	                  "ExitedAt",
  	                  "exitedAt",
  	                  "DepartureTime",
  	                  "departureTime",
  	                  "DepartedAt",
  	                  "departedAt",
  	                  "GeofenceExitTime",
  	                  "geofenceExitTime",
  	                  "GeofenceDepartureTime",
  	                  "geofenceDepartureTime",
  	                  "Data.TimeOut",
  	                  "Data.EndTime",
  	                  "Event.TimeOut",
  	                  "Event.EndTime",
  	                  "Times.TimeOut",
  	                  "Timing.TimeOut"
  	                ]);
  	              }

  	              function getBestDate(job) {
  	                const direct = firstEventValue(job, [
  	                  "DateISO",
  	                  "dateISO",
  	                  "Date",
  	                  "date",
  	                  "JobDate",
  	                  "jobDate",
  	                  "EventDate",
  	                  "eventDate"
  	                ]);

  	                return direct ? formatDate(direct) || safeString(direct).trim():
  	                  formatDate(getBestTimeIn(job)) ||
  	                  formatDate(getBestTimeOut(job)) ||
  	                  "";
  	              }

  	              function explicitDurationSeconds(job) {
  	                const seconds = numberPick(job, [
  	                  "DurationSeconds",
  	                  "durationSeconds",
  	                  "DurationSec",
  	                  "durationSec",
  	                  "ElapsedSeconds",
  	                  "elapsedSeconds",
  	                  "TimeSeconds",
  	                  "timeSeconds"
  	                ]);
  	                if (seconds !== null && seconds >= 0) return seconds;

  	                const milliseconds = numberPick(job, [
  	                  "DurationMilliseconds",
  	                  "durationMilliseconds",
  	                  "DurationMS",
  	                  "durationMS",
  	                  "ElapsedMilliseconds",
  	                  "elapsedMilliseconds"
  	                ]);
  	                if (milliseconds !== null && milliseconds >= 0) return milliseconds / 1000;

  	                const minutes = numberPick(job, [
  	                  "DurationMinutes",
  	                  "durationMinutes",
  	                  "ElapsedMinutes",
  	                  "elapsedMinutes",
  	                  "TimeMinutes",
  	                  "timeMinutes"
  	                ]);
  	                if (minutes !== null && minutes >= 0) return minutes * 60;

  	                const hours = numberPick(job, [
  	                  "DurationHours",
  	                  "durationHours",
  	                  "ElapsedHours",
  	                  "elapsedHours",
  	                  "TimeHours",
  	                  "timeHours"
  	                ]);
  	                if (hours !== null && hours >= 0) return hours * 3600;

  	                const raw = firstEventValue(job, [
  	                  "Duration",
  	                  "duration",
  	                  "Elapsed",
  	                  "elapsed",
  	                  "TimeTaken",
  	                  "timeTaken"
  	                ]);

  	                if (raw === "") return null;

  	                if (typeof raw === "number" && Number.isFinite(raw)) {
  	                  if (raw >= 0 && raw <= 24) return raw * 3600;
  	                  if (raw > 24 && raw <= 1440) return raw * 60;
  	                  return null;
  	                }

  	                const text = safeString(raw).trim();
  	                if (!text) return null;

  	                let match = text.match(/^(\d{1,3}):(\d{2})(?::(\d{2}))?$/);
  	                if (match) {
  	                  const hoursPart = Number(match[1]);
  	                  const minutesPart = Number(match[2]);
  	                  const secondsPart = Number(match[3] || 0);
  	                  return hoursPart * 3600 + minutesPart * 60 + secondsPart;
  	                }

  	                match = text.match(/(?:(\d+(?:\.\d+)?)\s*h(?:ours?)?)?\s*(?:(\d+(?:\.\d+)?)\s*m(?:in(?:utes?)?)?)?\s*(?:(\d+(?:\.\d+)?)\s*s(?:ec(?:onds?)?)?)?/i);
  	                if (match && (match[1] || match[2] || match[3])) {
  	                  return Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0);
  	                }

  	                const numeric = Number(text.replace(",", "."));
  	                if (Number.isFinite(numeric) && numeric >= 0) {
  	                  if (numeric <= 24) return numeric * 3600;
  	                  if (numeric <= 1440) return numeric * 60;
  	                }

  	                return null;
  	              }

  	              function getBestDuration(job) {
  	                const timeIn = parseClockValue(getBestTimeIn(job));
  	                const timeOut = parseClockValue(getBestTimeOut(job));

  	                if (timeIn.timestamp !== null && timeOut.timestamp !== null) {
  	                  const difference = timeOut.timestamp - timeIn.timestamp;
  	                  if (difference >= 0) return Math.round(difference / 1000);
  	                }

  	                if (timeIn.minutes !== null && timeOut.minutes !== null) {
  	                  let differenceMinutes = timeOut.minutes - timeIn.minutes;
  	                  if (differenceMinutes < 0) differenceMinutes += 1440;
  	                  return differenceMinutes * 60;
  	                }

  	                return explicitDurationSeconds(job);
  	              }

  	              function getBestArea(job) {
  	                const fromJob = numberPick(job, [
  	                  "Area",
  	                  "area",
  	                  "FieldArea",
  	                  "fieldArea",
  	                  "LocationArea",
  	                  "locationArea"
  	                ]);

  	                if (fromJob !== null) return fromJob;

  	                const linkedLocation = eventLocationForJob(job);

  	                return numberPick(linkedLocation, [
  	                  "Area",
  	                  "area",
  	                  "FieldArea",
  	                  "fieldArea",
  	                  "Size",
  	                  "size",
  	                  "Hectares",
  	                  "hectares",
  	                  "Data.Area",
  	                  "Data.FieldArea",
  	                  "Data.Hectares",
  	                  "LocationData.Area",
  	                  "LocationData.Hectares"
  	                ]);
  	              }

  	              function normalizeApplications(job) {
  	                let source = firstEventValue(job, [
  	                  "Applications",
  	                  "applications",
  	                  "Application",
  	                  "application",
  	                  "Data.Applications",
  	                  "data.applications"
  	                ]);

  	                if (typeof source === "string") {
  	                  const text = source.trim();
  	                  if (text.startsWith("[") || text.startsWith("{")) {
  	                    try {
  	                      source = JSON.parse(text);
  	                    } catch (_) {
  	                      source = [];
  	                    }
  	                  }
  	                }

  	                const apps = Array.isArray(source) ? source: source && typeof source === "object" ? [source]: [];

  	                return apps.map(app => {
  	                  return {
  	                    Type: pick(app, ["Type", "type", "ApplicationType", "applicationType", "Action", "action", "Event", "event"]),
  	                    Product: pick(app, ["Product", "product", "Crop", "crop", "Material", "material", "Description", "description"]),
  	                    RateText: pick(app, ["RateText", "rateText", "Rate", "rate", "QuantityText", "quantityText", "Quantity", "quantity"]),
  	                    Registration: pick(app, ["Registration", "registration", "VehicleRegistration", "vehicleRegistration"]),
  	                    Trailer: pick(app, ["Trailer", "trailer", "TrailerRegistration", "trailerRegistration", "Implement", "implement"])
  	                  };
  	                }).filter(app => {
  	                  return app.Type || app.Product || app.RateText || app.Registration || app.Trailer;
  	                });
  	              }

  	              function buildEventText(job) {
  	                const apps = normalizeApplications(job);

  	                if (!apps.length) {
  	                  return pick(job, ["Event", "event", "Type", "type", "Name", "name"]) || "Event";
  	                }

  	                return apps.map(app => {
  	                  const type = app.Type || "Event";
  	                  const reg = app.Registration || app.Trailer || "";

  	                  return reg ? `${type} - ${reg}`: type;
  	                }).join(" | ");
  	              }

  	              function buildProductText(job) {
  	                return normalizeApplications(job).map(app => {
  	                  if (app.Product && app.RateText) return `${app.Product} @ ${app.RateText}`;
  	                  return app.Product || app.RateText || "";
  	                }).filter(Boolean).join(" | ");
  	              }

  	              function calculateFuelUsed(job) {
  	                if (!job || typeof job !== "object") return null;

  	                const consumedIn = numberPick(job, ["FuelConsumedIn", "fuelConsumedIn"]);
  	                const consumedOut = numberPick(job, ["FuelConsumedOut", "fuelConsumedOut"]);

  	                if (consumedIn !== null && consumedOut !== null) {
  	                  const delta = consumedOut - consumedIn;
  	                  if (Number.isFinite(delta) && delta > 0) return delta;
  	                }

  	                const volumeIn = numberPick(job, ["FuelVolumeIn", "fuelVolumeIn"]);
  	                const volumeOut = numberPick(job, ["FuelVolumeOut", "fuelVolumeOut"]);

  	                if (volumeIn !== null && volumeOut !== null) {
  	                  const delta = volumeIn - volumeOut;
  	                  if (Number.isFinite(delta) && delta > 0) return delta;
  	                }

  	                const levelIn = numberPick(job, ["FuelLevelIn", "fuelLevelIn"]);
  	                const levelOut = numberPick(job, ["FuelLevelOut", "fuelLevelOut"]);

  	                if (levelIn !== null && levelOut !== null) {
  	                  const delta = levelIn - levelOut;
  	                  if (Number.isFinite(delta) && delta > 0) return delta;
  	                }

  	                const savedFuel = numberPick(job, ["Fuel", "fuel", "FuelUsed", "fuelUsed"]);

  	                if (savedFuel !== null && savedFuel > 0) return savedFuel;

  	                return null;
  	              }

  	              function getFuelText(job) {
  	                const fuel = calculateFuelUsed(job);

  	                if (fuel === null) return "";

  	                return Number(fuel).toFixed(2);
  	              }

  	              function buildMultilineEvent(job) {
  	                const apps = normalizeApplications(job);
  	                let headline = "";
  	                const extras = [];

  	                apps.forEach(app => {
  	                  const type = safeString(app.Type).trim();
  	                  const reg = safeString(app.Registration).trim();
  	                  const trailer = safeString(app.Trailer).trim();

  	                  let label = "";

  	                  if (reg) label = type ? `${type} - ${reg}`: reg;
  	                  else if (trailer) label = type ? `${type} - ${trailer}`: trailer;
  	                  else label = type;

  	                  if (!label) return;

  	                  if (!headline) headline = label;
  	                  else extras.push(label);
  	                });

  	                if (!headline) {
  	                  headline = pick(job, ["Event", "event", "Type", "type", "Name", "name"]) || "";
  	                }

  	                return {
  	                  headline,
  	                  extras
  	                };
  	              }

  	              function buildMultilineProducts(job) {
  	                return normalizeApplications(job).map(app => {
  	                  const product = safeString(app.Product).trim();
  	                  if (!product) return "";

  	                  const labelBase = safeString(app.Registration || app.Trailer).trim();
  	                  return labelBase ? `${labelBase}: ${product}`: product;
  	                }).filter(Boolean);
  	              }

  	              function buildMultilineRates(job) {
  	                return normalizeApplications(job).map(app => {
  	                  const rate = safeString(app.RateText).trim();
  	                  if (!rate) return "";

  	                  const labelBase = safeString(app.Registration || app.Trailer).trim();
  	                  return labelBase ? `${labelBase}: ${rate}`: rate;
  	                }).filter(Boolean);
  	              }

  	              function smallLines(lines) {
  	                const clean = Array.isArray(lines)
  	                ? lines.map(line => safeString(line).trim()).filter(Boolean): [];

  	                if (!clean.length) return `<div class="jel-big jel-dash">-</div>`;

  	                return `
  	                <div class="jel-small">
  	                ${clean.map(line => `<span class="jel-smallline">${escapeHtml(line)}</span>`).join("")}
  	                </div>
  	                `;
  	              }

  	              function bigSmall(bigText, smallLineArray) {
  	                const big = safeString(bigText).trim();
  	                const small = Array.isArray(smallLineArray) ? smallLineArray: [];

  	                return `
  	                <div class="jel-cell">
  	                <div class="jel-big ${big ? "": "jel-dash"}">${escapeHtml(big || "-")}</div>
  	                ${small.length ? smallLines(small): ""}
  	                </div>
  	                `;
  	              }

  	              function getContractorText(job) {
  	                return pick(job,
  	                  [
  	                    "ContractorLabel",
  	                    "contractorLabel",
  	                    "ContractorName",
  	                    "contractorName",
  	                    "ContractorId",
  	                    "contractorId"
  	                  ]);
  	              }

  	              function getDriverText(job) {
  	                const direct = pick(job, [
  	                  "DriverLabel", "driverLabel", "DriverName", "driverName",
  	                  "EmployeeLabel", "employeeLabel", "EmployeeName", "employeeName",
  	                  "OperatorLabel", "operatorLabel", "OperatorName", "operatorName",
  	                  "AssignedDriverName", "assignedDriverName", "CapturedByName", "capturedByName",
  	                  "Driver1Name", "driver1Name", "Driver2Name", "driver2Name",
  	                  "DriverSnapshotName", "driverSnapshotName", "DriverNames", "driverNames"
  	                ]);

  	                if (direct) return direct;

  	                const candidates = [
  	                  job?.Driver, job?.driver,
  	                  job?.Employee, job?.employee,
  	                  job?.Operator, job?.operator,
  	                  job?.AssignedDriver, job?.assignedDriver,
  	                  job?.Data?.Driver, job?.Data?.Employee, job?.Data?.Operator
  	                ];

  	                for (let index = 0; index < candidates.length; index += 1) {
  	                  const candidate = candidates[index];
  	                  if (candidate === undefined || candidate === null) continue;

  	                  if (typeof candidate === "string" || typeof candidate === "number") {
  	                    const text = safeString(candidate).trim();
  	                    if (text) return text;
  	                    continue;
  	                  }

  	                  if (typeof candidate !== "object") continue;

  	                  const label = pick(candidate, [
  	                    "FullName", "fullName", "DisplayName", "displayName",
  	                    "Name", "name", "Label", "label", "EmployeeName", "DriverName"
  	                  ]);
  	                  if (label) return label;

  	                  const firstName = pick(candidate, ["FirstName", "firstName", "Firstname", "firstname"]);
  	                  const lastName = pick(candidate, ["LastName", "lastName", "Surname", "surname"]);
  	                  const combined = [firstName, lastName].filter(Boolean).join(" ").trim();
  	                  if (combined) return combined;
  	                }

  	                return pick(job, [
  	                  "DriverId", "driverId", "EmployeeId", "employeeId",
  	                  "OperatorId", "operatorId", "AssignedDriverId", "assignedDriverId"
  	                ]);
  	              }

  	              function getVehicleText(job) {
  	                return pick(job,
  	                  [
  	                    "VehicleLabel",
  	                    "vehicleLabel",
  	                    "VehicleRegistration",
  	                    "vehicleRegistration",
  	                    "VehicleName",
  	                    "vehicleName",
  	                    "VehicleId",
  	                    "vehicleId",
  	                    "TractorLabel",
  	                    "tractorLabel",
  	                    "TractorRegistration",
  	                    "tractorRegistration",
  	                    "TractorName",
  	                    "tractorName",
  	                    "TractorId",
  	                    "tractorId"
  	                  ]) || vehicleLabelForEvents;
  	              }

  	              function eventBoundaryTimestamp(job, boundary) {
  	                const raw = boundary === "out" ? getBestTimeOut(job) : getBestTimeIn(job);
  	                if (raw === undefined || raw === null || raw === "") return null;

  	                const rawText = safeString(raw).trim();
  	                const hasFullDate = raw instanceof Date ||
  	                  typeof raw === "number" ||
  	                  /^\d{10,13}$/.test(rawText) ||
  	                  /^\d{4}-\d{2}-\d{2}[T\s]/.test(rawText);

  	                if (hasFullDate) {
  	                  const fullDate = asDate(raw);
  	                  if (fullDate) return fullDate.getTime();
  	                }

  	                const clock = parseClockValue(raw);
  	                if (clock.minutes === null) return null;

  	                const baseText = safeString(getBestDate(job)).trim();
  	                const dateParts = baseText.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  	                const base = dateParts
  	                  ? new Date(Number(dateParts[1]), Number(dateParts[2]) - 1, Number(dateParts[3]), 0, 0, 0, 0)
  	                  : asDate(baseText);
  	                if (!base || Number.isNaN(base.getTime())) return null;

  	                const combined = new Date(
  	                  base.getFullYear(),
  	                  base.getMonth(),
  	                  base.getDate(),
  	                  Math.floor(clock.minutes / 60),
  	                  clock.minutes % 60,
  	                  0,
  	                  0
  	                );

  	                return Number.isNaN(combined.getTime()) ? null : combined.getTime();
  	              }

  	              const EVENT_TRACKING_PADDING_MS = 5 * 60 * 1000;
  	              const EVENT_TRACKING_CACHE_VERSION = "event-tracking-v3-interactive-map";

  	              function eventTrackingRange(job) {
  	                const recordedFrom = eventBoundaryTimestamp(job, "in");
  	                let recordedTo = eventBoundaryTimestamp(job, "out");

  	                if (recordedFrom === null || recordedTo === null) return null;
  	                if (recordedTo <= recordedFrom && recordedTo + 86400000 > recordedFrom) recordedTo += 86400000;
  	                if (recordedTo <= recordedFrom) return null;

  	                return {
  	                  recordedFrom,
  	                  recordedTo,
  	                  from: recordedFrom - EVENT_TRACKING_PADDING_MS,
  	                  to: recordedTo + EVENT_TRACKING_PADDING_MS,
  	                  paddingMs: EVENT_TRACKING_PADDING_MS
  	                };
  	              }

  	              function eventTrackingParseJson(value, fallback) {
  	                if (value === undefined || value === null || value === "") return fallback;
  	                if (typeof value === "object") {
  	                  try { return JSON.parse(JSON.stringify(value)); }
  	                  catch (_) { return value; }
  	                }

  	                const raw = safeString(value).trim();
  	                if (!raw) return fallback;

  	                try { return JSON.parse(raw); }
  	                catch (_) { return fallback; }
  	              }

  	              function eventTrackingCache(job) {
  	                const direct = firstEventValue(job, [
  	                  "Tracking",
  	                  "tracking",
  	                  "EventTracking",
  	                  "eventTracking",
  	                  "Data.EventTracking",
  	                  "Data.Tracking",
  	                  "data.eventTracking",
  	                  "data.tracking"
  	                ]);

  	                const parsed = eventTrackingParseJson(direct, null);
  	                if (!parsed || typeof parsed !== "object") return null;
  	                if (safeString(parsed.version || parsed.Version || "") !== EVENT_TRACKING_CACHE_VERSION) return null;

  	                return parsed;
  	              }

  	              function eventTrackingNormaliseColor(value, fallback) {
  	                const textValue = safeString(value || "").trim();

  	                if (
  	                  /^#[0-9a-f]{3,8}$/i.test(textValue) ||
  	                  /^rgba?\(/i.test(textValue) ||
  	                  /^hsla?\(/i.test(textValue) ||
  	                  /^[a-z]+$/i.test(textValue)
  	                ) {
  	                  return textValue;
  	                }

  	                return fallback === undefined ? "" : fallback;
  	              }

  	              function eventTrackingLocationColor(job) {
  	                const location = eventLocationForJob(job);
  	                const fallback = "#ff8a3c";

  	                if (!location || typeof location !== "object") return fallback;

  	                const paths = [
  	                  "Color",
  	                  "color",
  	                  "Colour",
  	                  "colour",
  	                  "LocationColor",
  	                  "locationColor",
  	                  "LocationColour",
  	                  "locationColour",
  	                  "PolygonColor",
  	                  "polygonColor",
  	                  "FillColor",
  	                  "fillColor",
  	                  "StrokeColor",
  	                  "strokeColor",
  	                  "HexColor",
  	                  "hexColor",
  	                  "HexColour",
  	                  "hexColour",
  	                  "Style.Color",
  	                  "Style.color",
  	                  "Style.Colour",
  	                  "Style.colour",
  	                  "Style.FillColor",
  	                  "Style.fillColor",
  	                  "Style.StrokeColor",
  	                  "Style.strokeColor",
  	                  "LocationData.Color",
  	                  "LocationData.color",
  	                  "LocationData.Colour",
  	                  "LocationData.colour",
  	                  "LocationData.LocationColor",
  	                  "LocationData.locationColor",
  	                  "LocationData.FillColor",
  	                  "LocationData.fillColor",
  	                  "LocationData.StrokeColor",
  	                  "LocationData.strokeColor",
  	                  "LocationData.Style.Color",
  	                  "LocationData.Style.color",
  	                  "LocationData.Style.FillColor",
  	                  "LocationData.Style.fillColor",
  	                  "LocationData.Style.StrokeColor",
  	                  "LocationData.Style.strokeColor",
  	                  "LocationData.Shape.Color",
  	                  "LocationData.Shape.color",
  	                  "LocationData.Shape.Colour",
  	                  "LocationData.Shape.colour",
  	                  "LocationData.Shape.FillColor",
  	                  "LocationData.Shape.fillColor",
  	                  "LocationData.Shape.StrokeColor",
  	                  "LocationData.Shape.strokeColor",
  	                  "Shape.Color",
  	                  "Shape.color",
  	                  "Shape.Colour",
  	                  "Shape.colour",
  	                  "Shape.FillColor",
  	                  "Shape.fillColor",
  	                  "Shape.StrokeColor",
  	                  "Shape.strokeColor"
  	                ];

  	                for (let index = 0; index < paths.length; index += 1) {
  	                  const color = eventTrackingNormaliseColor(
  	                    readEventPath(location, paths[index]),
  	                    ""
  	                  );

  	                  if (color) return color;
  	                }

  	                return fallback;
  	              }

  	              function eventTrackingPointEvents(raw) {
  	                const output = [];

  	                function add(value) {
  	                  if (value === undefined || value === null) return;

  	                  if (Array.isArray(value)) {
  	                    value.forEach(add);
  	                    return;
  	                  }

  	                  if (typeof value === "object") {
  	                    const label = safeString(firstValue([
  	                      value.name,
  	                      value.Name,
  	                      value.type,
  	                      value.Type,
  	                      value.event,
  	                      value.Event,
  	                      value.label,
  	                      value.Label
  	                    ], "")).trim();

  	                    if (label && !output.includes(label)) output.push(label);
  	                    return;
  	                  }

  	                  const label = safeString(value).trim();
  	                  if (label && !output.includes(label)) output.push(label);
  	                }

  	                if (raw && typeof raw === "object") {
  	                  add(raw.events);
  	                  add(raw.Events);
  	                  add(raw.event);
  	                  add(raw.Event);
  	                  add(raw.alarms);
  	                  add(raw.Alarms);
  	                  add(raw.alarm);
  	                  add(raw.Alarm);
  	                }

  	                return output.slice(0, 24);
  	              }

  	              function eventTrackingVehicleLimit(vehicle, names) {
  	                for (let index = 0; index < names.length; index += 1) {
  	                  const value = Number(trackingValue(vehicle, names[index]));
  	                  if (Number.isFinite(value) && value > 0) return value;
  	                }

  	                return null;
  	              }

  	              function eventTrackingPointRouteColor(point, vehicle) {
  	                const explicit = eventTrackingNormaliseColor(point && point.color, "");
  	                if (
  	                  explicit &&
  	                  /^(#ff0000|red|#00ff00|green|#ffff00|yellow)$/i.test(explicit)
  	                ) {
  	                  return explicit;
  	                }

  	                const events = Array.isArray(point && point.events)
  	                  ? point.events.map(value => safeString(value))
  	                  : [];

  	                const redEvents = [
  	                  "Speeding",
  	                  "Engine Over-Rev",
  	                  "Engine Over-Temperature",
  	                  "Throttle Overuse"
  	                ];
  	                const greenEvents = ["Green Band Driving"];

  	                if (events.some(name => redEvents.includes(name))) return "#FF0000";
  	                if (events.some(name => greenEvents.includes(name))) return "#00FF00";

  	                const speedLimit = eventTrackingVehicleLimit(vehicle, [
  	                  "CAN.Speed",
  	                  "CAN.SpeedLimit",
  	                  "CAN.MaxSpeed",
  	                  "SpeedLimit"
  	                ]);
  	                const rpmLimit = eventTrackingVehicleLimit(vehicle, [
  	                  "CAN.RPM",
  	                  "CAN.RPMLimit",
  	                  "CAN.MaxRPM"
  	                ]);
  	                const tempLimit = eventTrackingVehicleLimit(vehicle, [
  	                  "CAN.Temp",
  	                  "CAN.Temperature",
  	                  "CAN.MaxTemp"
  	                ]);
  	                const throttleLimit = eventTrackingVehicleLimit(vehicle, [
  	                  "CAN.ThrottlePct",
  	                  "CAN.Throttle",
  	                  "CAN.MaxThrottle"
  	                ]);

  	                if (
  	                  (Number.isFinite(point && point.speed) && speedLimit !== null && point.speed > speedLimit) ||
  	                  (Number.isFinite(point && point.rpm) && rpmLimit !== null && point.rpm > rpmLimit) ||
  	                  (Number.isFinite(point && point.temperature) && tempLimit !== null && point.temperature > tempLimit) ||
  	                  (Number.isFinite(point && point.throttle) && throttleLimit !== null && point.throttle > throttleLimit)
  	                ) {
  	                  return "#FF0000";
  	                }

  	                return "#FFFF00";
  	              }

  	              function eventTrackingDarkenRouteColor(color, factor) {
  	                const value = eventTrackingNormaliseColor(color, "#FFFF00");
  	                const clean = String(value).replace("#", "");

  	                if (!/^[0-9a-f]{6}$/i.test(clean)) return "#5a5a00";

  	                const safeFactor = Math.max(0, Math.min(1, Number(factor) || 0.55));
  	                const red = Math.round(parseInt(clean.slice(0, 2), 16) * safeFactor);
  	                const green = Math.round(parseInt(clean.slice(2, 4), 16) * safeFactor);
  	                const blue = Math.round(parseInt(clean.slice(4, 6), 16) * safeFactor);

  	                return "#" + [red, green, blue]
  	                  .map(value => value.toString(16).padStart(2, "0"))
  	                  .join("");
  	              }

  	              function eventTrackingMixRouteColors(firstColor, secondColor, ratio) {
  	                function rgb(value) {
  	                  const clean = String(eventTrackingNormaliseColor(value, "#FFFF00")).replace("#", "");
  	                  if (!/^[0-9a-f]{6}$/i.test(clean)) return [255, 255, 0];
  	                  return [
  	                    parseInt(clean.slice(0, 2), 16),
  	                    parseInt(clean.slice(2, 4), 16),
  	                    parseInt(clean.slice(4, 6), 16)
  	                  ];
  	                }

  	                const first = rgb(firstColor);
  	                const second = rgb(secondColor);
  	                const mix = Math.max(0, Math.min(1, Number(ratio) || 0.5));

  	                return "#" + first.map((value, index) => {
  	                  return Math.round(value + (second[index] - value) * mix)
  	                    .toString(16)
  	                    .padStart(2, "0");
  	                }).join("");
  	              }

  	              function eventTrackingRouteChevronIcon(color) {
  	                return {
  	                  path: "M -10 -7 L -4 -7 L 6 0 L -4 7 L -10 7 L 0 0 Z",
  	                  fillColor: eventTrackingDarkenRouteColor(color, 0.55),
  	                  fillOpacity: 0.20,
  	                  strokeColor: eventTrackingDarkenRouteColor(color, 0.34),
  	                  strokeOpacity: 0.25,
  	                  strokeWeight: 1,
  	                  scale: 0.72,
  	                  rotation: 270
  	                };
  	              }

  	              function eventTrackingDirectionText(value) {
  	                const direction = Number(value);
  	                if (!Number.isFinite(direction)) return "—";

  	                const labels = [
  	                  "N", "NNE", "NE", "ENE",
  	                  "E", "ESE", "SE", "SSE",
  	                  "S", "SSW", "SW", "WSW",
  	                  "W", "WNW", "NW", "NNW"
  	                ];
  	                const normalized = ((direction % 360) + 360) % 360;
  	                return `${labels[Math.round(normalized / 22.5) % 16]} · ${Math.round(normalized)}°`;
  	              }

  	              function eventTrackingMetricText(value, suffix, decimals) {
  	                const numeric = Number(value);
  	                if (!Number.isFinite(numeric)) return "—";
  	                return numeric.toFixed(Number.isFinite(Number(decimals)) ? Number(decimals) : 0) + safeString(suffix || "");
  	              }

  	              function eventTrackingCompactPoint(point) {
  	                if (!point) return null;

  	                return {
  	                  timestamp: Number(point.timestamp),
  	                  lat: Number(point.lat),
  	                  lng: Number(point.lng),
  	                  speed: Number.isFinite(Number(point.speed)) ? Number(point.speed) : null,
  	                  rpm: Number.isFinite(Number(point.rpm)) ? Number(point.rpm) : null,
  	                  temperature: Number.isFinite(Number(point.temperature)) ? Number(point.temperature) : null,
  	                  throttle: Number.isFinite(Number(point.throttle)) ? Number(point.throttle) : null,
  	                  direction: Number.isFinite(Number(point.direction)) ? Number(point.direction) : null,
  	                  altitude: Number.isFinite(Number(point.altitude)) ? Number(point.altitude) : null,
  	                  odometer: Number.isFinite(Number(point.odometer)) ? Number(point.odometer) : null,
  	                  fuelLevel: Number.isFinite(Number(point.fuelLevel)) ? Number(point.fuelLevel) : null,
  	                  color: eventTrackingNormaliseColor(point.color, ""),
  	                  events: Array.isArray(point.events)
  	                    ? point.events.map(value => safeString(value)).filter(Boolean).slice(0, 24)
  	                    : [],
  	                  boundary: !!point.boundary,
  	                  boundaryType: safeString(point.boundaryType || "")
  	                };
  	              }

  	              function eventTrackingRestorePoints(value) {
  	                return (Array.isArray(value) ? value : []).map(function (point) {
  	                  const timestamp = Number(point && point.timestamp);
  	                  const lat = Number(point && point.lat);
  	                  const lng = Number(point && point.lng);

  	                  if (!Number.isFinite(timestamp) || !Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  	                  return {
  	                    timestamp,
  	                    lat,
  	                    lng,
  	                    speed: Number.isFinite(Number(point.speed)) ? Number(point.speed) : null,
  	                    rpm: Number.isFinite(Number(point.rpm)) ? Number(point.rpm) : null,
  	                    temperature: Number.isFinite(Number(point.temperature)) ? Number(point.temperature) : null,
  	                    throttle: Number.isFinite(Number(point.throttle)) ? Number(point.throttle) : null,
  	                    direction: Number.isFinite(Number(point.direction)) ? Number(point.direction) : null,
  	                    altitude: Number.isFinite(Number(point.altitude)) ? Number(point.altitude) : null,
  	                    odometer: Number.isFinite(Number(point.odometer)) ? Number(point.odometer) : null,
  	                    fuelLevel: Number.isFinite(Number(point.fuelLevel)) ? Number(point.fuelLevel) : null,
  	                    color: eventTrackingNormaliseColor(point.color, ""),
  	                    events: Array.isArray(point.events)
  	                      ? point.events.map(value => safeString(value)).filter(Boolean)
  	                      : [],
  	                    boundary: !!point.boundary,
  	                    boundaryType: safeString(point.boundaryType || ""),
  	                    raw: null
  	                  };
  	                }).filter(Boolean).sort((a, b) => a.timestamp - b.timestamp);
  	              }

  	              function eventTrackingClockWithSeconds(timestamp) {
  	                const date = new Date(Number(timestamp));
  	                if (Number.isNaN(date.getTime())) return "";
  	                return `${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;
  	              }

  	              function eventTrackingCoordinateFromValue(value, preferLngLat) {
  	                if (!value) return null;

  	                if (Array.isArray(value) && value.length >= 2) {
  	                  const first = Number(value[0]);
  	                  const second = Number(value[1]);
  	                  if (!Number.isFinite(first) || !Number.isFinite(second)) return null;

  	                  let lat;
  	                  let lng;

  	                  if (preferLngLat || Math.abs(first) > 90) {
  	                    lng = first;
  	                    lat = second;
  	                  } else if (Math.abs(second) > 90) {
  	                    lat = first;
  	                    lng = second;
  	                  } else {
  	                    lat = first;
  	                    lng = second;
  	                  }

  	                  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  	                  return { lat, lng };
  	                }

  	                if (typeof value === "object") {
  	                  const lat = Number(firstValue([
  	                    value.lat,
  	                    value.Lat,
  	                    value.latitude,
  	                    value.Latitude,
  	                    value.y,
  	                    value.Y
  	                  ], NaN));
  	                  const lng = Number(firstValue([
  	                    value.lng,
  	                    value.lon,
  	                    value.Lng,
  	                    value.Lon,
  	                    value.longitude,
  	                    value.Longitude,
  	                    value.x,
  	                    value.X
  	                  ], NaN));

  	                  if (Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180) {
  	                    return { lat, lng };
  	                  }
  	                }

  	                return null;
  	              }

  	              function eventTrackingBoundaryRing(value, preferLngLat, depth) {
  	                depth = Number(depth || 0);
  	                if (depth > 7 || value === undefined || value === null) return [];

  	                if (typeof value === "string") {
  	                  const parsed = eventTrackingParseJson(value, null);
  	                  return parsed ? eventTrackingBoundaryRing(parsed, preferLngLat, depth + 1) : [];
  	                }

  	                if (Array.isArray(value)) {
  	                  if (!value.length) return [];

  	                  const direct = value.map(item => eventTrackingCoordinateFromValue(item, preferLngLat)).filter(Boolean);
  	                  if (direct.length >= 3) return direct;

  	                  for (let index = 0; index < value.length; index += 1) {
  	                    const nested = eventTrackingBoundaryRing(value[index], preferLngLat, depth + 1);
  	                    if (nested.length >= 3) return nested;
  	                  }

  	                  return [];
  	                }

  	                if (typeof value !== "object") return [];

  	                const type = safeString(value.type || value.Type || "").toLowerCase();
  	                if (type === "feature") return eventTrackingBoundaryRing(value.geometry || value.Geometry, true, depth + 1);
  	                if (type === "polygon") return eventTrackingBoundaryRing(value.coordinates || value.Coordinates, true, depth + 1);
  	                if (type === "multipolygon") return eventTrackingBoundaryRing(value.coordinates || value.Coordinates, true, depth + 1);

  	                const keys = [
  	                  "coordinates", "Coordinates",
  	                  "points", "Points",
  	                  "path", "Path",
  	                  "paths", "Paths",
  	                  "vertices", "Vertices",
  	                  "polygon", "Polygon",
  	                  "boundary", "Boundary",
  	                  "geometry", "Geometry",
  	                  "geojson", "GeoJSON"
  	                ];

  	                for (let index = 0; index < keys.length; index += 1) {
  	                  if (value[keys[index]] === undefined) continue;
  	                  const nested = eventTrackingBoundaryRing(
  	                    value[keys[index]],
  	                    /coordinates|geojson|geometry/i.test(keys[index]) ? true : preferLngLat,
  	                    depth + 1
  	                  );
  	                  if (nested.length >= 3) return nested;
  	                }

  	                return [];
  	              }

  	              function eventTrackingBoundaryGeometry(job) {
  	                const linked = eventLocationForJob(job);
  	                if (!linked) return null;

  	                const polygonPaths = [
  	                  "Boundary", "boundary",
  	                  "Polygon", "polygon",
  	                  "GeoJSON", "geojson",
  	                  "Geometry", "geometry",
  	                  "Coordinates", "coordinates",
  	                  "Points", "points",
  	                  "Path", "path",
  	                  "Geofence", "geofence",
  	                  "Fence", "fence",
  	                  "Data.Boundary", "Data.Polygon", "Data.GeoJSON", "Data.Geometry", "Data.Coordinates", "Data.Points", "Data.Path", "Data.Geofence",
  	                  "Data.Location.Boundary", "Data.Location.Polygon", "Data.Location.GeoJSON", "Data.Location.Geometry", "Data.Location.Coordinates",
  	                  "LocationData.Boundary", "LocationData.Polygon", "LocationData.GeoJSON", "LocationData.Geometry", "LocationData.Coordinates", "LocationData.Points", "LocationData.Path", "LocationData.Geofence"
  	                ];

  	                for (let index = 0; index < polygonPaths.length; index += 1) {
  	                  const candidate = readEventPath(linked, polygonPaths[index]);
  	                  const ring = eventTrackingBoundaryRing(
  	                    unwrapEventValue(candidate),
  	                    /geojson|geometry|coordinates/i.test(polygonPaths[index]),
  	                    0
  	                  );

  	                  if (ring.length >= 3) {
  	                    const first = ring[0];
  	                    const last = ring[ring.length - 1];
  	                    const closed = first && last && Math.abs(first.lat - last.lat) < 1e-9 && Math.abs(first.lng - last.lng) < 1e-9
  	                      ? ring.slice()
  	                      : ring.concat([{ lat: first.lat, lng: first.lng }]);

  	                    return {
  	                      type: "polygon",
  	                      points: closed,
  	                      source: polygonPaths[index],
  	                      locationLabel: eventLocationDisplayLabel(job),
  	                      fieldLabel: eventFieldLabel(job)
  	                    };
  	                  }
  	                }

  	                const centerLat = Number(firstValue([
  	                  linked.Latitude,
  	                  linked.latitude,
  	                  linked.lat,
  	                  readEventPath(linked, "Center.latitude"),
  	                  readEventPath(linked, "Center.lat"),
  	                  readEventPath(linked, "Data.Latitude"),
  	                  readEventPath(linked, "Data.Center.latitude"),
  	                  readEventPath(linked, "LocationData.Latitude"),
  	                  readEventPath(linked, "LocationData.Center.latitude")
  	                ], NaN));

  	                const centerLng = Number(firstValue([
  	                  linked.Longitude,
  	                  linked.longitude,
  	                  linked.lng,
  	                  linked.lon,
  	                  readEventPath(linked, "Center.longitude"),
  	                  readEventPath(linked, "Center.lng"),
  	                  readEventPath(linked, "Data.Longitude"),
  	                  readEventPath(linked, "Data.Center.longitude"),
  	                  readEventPath(linked, "LocationData.Longitude"),
  	                  readEventPath(linked, "LocationData.Center.longitude")
  	                ], NaN));

  	                const radius = Number(firstValue([
  	                  linked.Radius,
  	                  linked.radius,
  	                  linked.GeofenceRadius,
  	                  linked.geofenceRadius,
  	                  linked.BoundaryRadius,
  	                  readEventPath(linked, "Data.Radius"),
  	                  readEventPath(linked, "Data.GeofenceRadius"),
  	                  readEventPath(linked, "LocationData.Radius"),
  	                  readEventPath(linked, "LocationData.GeofenceRadius")
  	                ], NaN));

  	                if (
  	                  Number.isFinite(centerLat) &&
  	                  Number.isFinite(centerLng) &&
  	                  Number.isFinite(radius) &&
  	                  radius > 0
  	                ) {
  	                  return {
  	                    type: "circle",
  	                    center: { lat: centerLat, lng: centerLng },
  	                    radiusMeters: radius,
  	                    source: "center-radius",
  	                    locationLabel: eventLocationDisplayLabel(job),
  	                    fieldLabel: eventFieldLabel(job)
  	                  };
  	                }

  	                return null;
  	              }

  	              function eventTrackingPointInsidePolygon(point, ring) {
  	                if (!point || !Array.isArray(ring) || ring.length < 3) return false;

  	                let inside = false;
  	                const x = Number(point.lng);
  	                const y = Number(point.lat);

  	                for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
  	                  const xi = Number(ring[i].lng);
  	                  const yi = Number(ring[i].lat);
  	                  const xj = Number(ring[j].lng);
  	                  const yj = Number(ring[j].lat);

  	                  const intersects =
  	                    ((yi > y) !== (yj > y)) &&
  	                    (x < ((xj - xi) * (y - yi)) / ((yj - yi) || Number.EPSILON) + xi);

  	                  if (intersects) inside = !inside;
  	                }

  	                return inside;
  	              }

  	              function eventTrackingPointInsideBoundary(point, boundary) {
  	                if (!point || !boundary) return false;

  	                if (boundary.type === "polygon") {
  	                  return eventTrackingPointInsidePolygon(point, boundary.points);
  	                }

  	                if (boundary.type === "circle" && boundary.center) {
  	                  return trackingDistanceMeters(point, boundary.center) <= Number(boundary.radiusMeters || 0);
  	                }

  	                return false;
  	              }

  	              function eventTrackingInterpolatedPoint(a, b, ratio, boundaryType) {
  	                ratio = Math.max(0, Math.min(1, Number(ratio) || 0));

  	                return {
  	                  timestamp: Math.round(a.timestamp + (b.timestamp - a.timestamp) * ratio),
  	                  lat: a.lat + (b.lat - a.lat) * ratio,
  	                  lng: a.lng + (b.lng - a.lng) * ratio,
  	                  speed: Number.isFinite(Number(b.speed)) ? Number(b.speed) : Number.isFinite(Number(a.speed)) ? Number(a.speed) : null,
  	                  rpm: Number.isFinite(Number(b.rpm)) ? Number(b.rpm) : Number.isFinite(Number(a.rpm)) ? Number(a.rpm) : null,
  	                  temperature: Number.isFinite(Number(b.temperature)) ? Number(b.temperature) : Number.isFinite(Number(a.temperature)) ? Number(a.temperature) : null,
  	                  throttle: Number.isFinite(Number(b.throttle)) ? Number(b.throttle) : Number.isFinite(Number(a.throttle)) ? Number(a.throttle) : null,
  	                  direction: Number.isFinite(Number(b.direction)) ? Number(b.direction) : Number.isFinite(Number(a.direction)) ? Number(a.direction) : null,
  	                  altitude: Number.isFinite(Number(b.altitude)) ? Number(b.altitude) : Number.isFinite(Number(a.altitude)) ? Number(a.altitude) : null,
  	                  odometer: Number.isFinite(Number(a.odometer)) && Number.isFinite(Number(b.odometer))
  	                    ? a.odometer + (b.odometer - a.odometer) * ratio
  	                    : Number.isFinite(Number(b.odometer)) ? Number(b.odometer) : Number.isFinite(Number(a.odometer)) ? Number(a.odometer) : null,
  	                  fuelLevel: Number.isFinite(Number(a.fuelLevel)) && Number.isFinite(Number(b.fuelLevel))
  	                    ? a.fuelLevel + (b.fuelLevel - a.fuelLevel) * ratio
  	                    : Number.isFinite(Number(b.fuelLevel)) ? Number(b.fuelLevel) : Number.isFinite(Number(a.fuelLevel)) ? Number(a.fuelLevel) : null,
  	                  events: [],
  	                  color: eventTrackingNormaliseColor(
  	                    Number(ratio) >= 0.5 ? b.color : a.color,
  	                    "#FFFF00"
  	                  ),
  	                  raw: null,
  	                  boundary: true,
  	                  boundaryType: safeString(boundaryType || "")
  	                };
  	              }

  	              function eventTrackingSegmentCrossing(a, b, boundary, transition) {
  	                if (!a || !b || !boundary) return null;

  	                const startInside = eventTrackingPointInsideBoundary(a, boundary);
  	                const endInside = eventTrackingPointInsideBoundary(b, boundary);
  	                if (startInside === endInside) return null;

  	                let low = 0;
  	                let high = 1;
  	                const expectedLowInside = startInside;

  	                for (let iteration = 0; iteration < 28; iteration += 1) {
  	                  const middle = (low + high) / 2;
  	                  const probe = eventTrackingInterpolatedPoint(a, b, middle, transition);
  	                  const probeInside = eventTrackingPointInsideBoundary(probe, boundary);

  	                  if (probeInside === expectedLowInside) low = middle;
  	                  else high = middle;
  	                }

  	                return eventTrackingInterpolatedPoint(a, b, (low + high) / 2, transition);
  	              }

  	              function eventTrackingFindBoundaryCrossings(points, boundary, range) {
  	                const entries = [];
  	                const exits = [];

  	                for (let index = 1; index < points.length; index += 1) {
  	                  const previous = points[index - 1];
  	                  const current = points[index];
  	                  const wasInside = eventTrackingPointInsideBoundary(previous, boundary);
  	                  const isInside = eventTrackingPointInsideBoundary(current, boundary);

  	                  if (wasInside === isInside) continue;

  	                  if (!wasInside && isInside) {
  	                    const crossing = eventTrackingSegmentCrossing(previous, current, boundary, "entry");
  	                    if (crossing) entries.push({ crossing, before: previous, after: current, index });
  	                  } else if (wasInside && !isInside) {
  	                    const crossing = eventTrackingSegmentCrossing(previous, current, boundary, "exit");
  	                    if (crossing) exits.push({ crossing, before: previous, after: current, index });
  	                  }
  	                }

  	                const recordedFrom = Number(range && range.recordedFrom);
  	                const recordedTo = Number(range && range.recordedTo);

  	                entries.sort((left, right) =>
  	                  Math.abs(left.crossing.timestamp - recordedFrom) - Math.abs(right.crossing.timestamp - recordedFrom)
  	                );

  	                let entry = entries[0] || null;
  	                let possibleExits = exits.filter(candidate => !entry || candidate.crossing.timestamp > entry.crossing.timestamp);

  	                possibleExits.sort((left, right) =>
  	                  Math.abs(left.crossing.timestamp - recordedTo) - Math.abs(right.crossing.timestamp - recordedTo)
  	                );

  	                let exit = possibleExits[0] || null;

  	                if (!entry || !exit || exit.crossing.timestamp <= entry.crossing.timestamp) {
  	                  return {
  	                    ok: false,
  	                    entry: entry,
  	                    exit: exit,
  	                    entries,
  	                    exits,
  	                    reason: !entry
  	                      ? "No outside-to-inside boundary crossing was found in the padded tracking window."
  	                      : !exit
  	                        ? "No inside-to-outside boundary crossing was found after the entry crossing."
  	                        : "The detected boundary crossings are not in a valid order."
  	                  };
  	                }

  	                return { ok: true, entry, exit, entries, exits, reason: "" };
  	              }

  	              function eventTrackingRouteBetween(points, entryPoint, exitPoint) {
  	                const route = [entryPoint];

  	                points.forEach(function (point) {
  	                  if (point.timestamp > entryPoint.timestamp && point.timestamp < exitPoint.timestamp) {
  	                    route.push(point);
  	                  }
  	                });

  	                route.push(exitPoint);

  	                return route.sort((a, b) => a.timestamp - b.timestamp);
  	              }

  	              function reconcileEventTracking(job, points, searchRange) {
  	                const boundary = eventTrackingBoundaryGeometry(job);
  	                if (!boundary) {
  	                  return {
  	                    ok: false,
  	                    reason: "This Location has no readable polygon/geofence boundary in the loaded Location record.",
  	                    boundary: null,
  	                    searchRange,
  	                    routePoints: [],
  	                    analysis: null,
  	                    entry: null,
  	                    exit: null
  	                  };
  	                }

  	                const crossings = eventTrackingFindBoundaryCrossings(points, boundary, searchRange);
  	                if (!crossings.ok) {
  	                  return {
  	                    ok: false,
  	                    reason: crossings.reason,
  	                    boundary,
  	                    searchRange,
  	                    routePoints: [],
  	                    analysis: null,
  	                    entry: crossings.entry,
  	                    exit: crossings.exit
  	                  };
  	                }

  	                const entryPoint = crossings.entry.crossing;
  	                const exitPoint = crossings.exit.crossing;
  	                const correctedRange = {
  	                  from: entryPoint.timestamp,
  	                  to: exitPoint.timestamp,
  	                  recordedFrom: searchRange.recordedFrom,
  	                  recordedTo: searchRange.recordedTo,
  	                  paddingMs: searchRange.paddingMs
  	                };
  	                const routePoints = eventTrackingRouteBetween(points, entryPoint, exitPoint);
  	                const analysis = analyseEventTracking(routePoints, correctedRange);

  	                return {
  	                  ok: true,
  	                  reason: "",
  	                  boundary,
  	                  searchRange,
  	                  correctedRange,
  	                  routePoints,
  	                  analysis,
  	                  entry: crossings.entry,
  	                  exit: crossings.exit,
  	                  crossings
  	                };
  	              }

  	              function eventTrackingEvidenceFromReconciliation(job, loaded, searchPoints, result) {
  	                const corrected = result && result.correctedRange;
  	                const analysis = result && result.analysis;
  	                const entryPoint = result && result.entry && result.entry.crossing;
  	                const exitPoint = result && result.exit && result.exit.crossing;

  	                return {
  	                  version: EVENT_TRACKING_CACHE_VERSION,
  	                  reconciled: !!(result && result.ok),
  	                  reconciledAt: new Date().toISOString(),
  	                  source: safeString(loaded && loaded.source || ""),
  	                  location: {
  	                    id: safeString(firstValue([
  	                      job && job.LocationId,
  	                      job && job.LocationObjectId,
  	                      getDeep(job, ["Location", "objectId"], "")
  	                    ], "")),
  	                    locationLabel: eventLocationDisplayLabel(job),
  	                    fieldLabel: eventFieldLabel(job)
  	                  },
  	                  recorded: {
  	                    from: result && result.searchRange ? result.searchRange.recordedFrom : null,
  	                    to: result && result.searchRange ? result.searchRange.recordedTo : null
  	                  },
  	                  searchWindow: {
  	                    from: result && result.searchRange ? result.searchRange.from : null,
  	                    to: result && result.searchRange ? result.searchRange.to : null,
  	                    paddingMs: EVENT_TRACKING_PADDING_MS
  	                  },
  	                  corrected: corrected && analysis ? {
  	                    from: corrected.from,
  	                    to: corrected.to,
  	                    durationSeconds: analysis.durationSeconds,
  	                    distanceMeters: analysis.distance,
  	                    movingSeconds: analysis.movingSeconds,
  	                    stoppedSeconds: analysis.stoppedSeconds,
  	                    averageSpeed: analysis.averageSpeed,
  	                    maximumSpeed: analysis.maxSpeed,
  	                    pointCount: result.routePoints.length
  	                  } : null,
  	                  boundary: result && result.boundary ? {
  	                    type: result.boundary.type,
  	                    source: result.boundary.source,
  	                    entry: entryPoint ? eventTrackingCompactPoint(entryPoint) : null,
  	                    exit: exitPoint ? eventTrackingCompactPoint(exitPoint) : null
  	                  } : null,
  	                  points: searchPoints.map(eventTrackingCompactPoint).filter(Boolean),
  	                  routePoints: (result && result.routePoints || []).map(eventTrackingCompactPoint).filter(Boolean),
  	                  reason: safeString(result && result.reason || "")
  	                };
  	              }

  	              function eventTrackingApplyKnownField(payload, job, names, value, fallbackName) {
  	                for (let index = 0; index < names.length; index += 1) {
  	                  if (Object.prototype.hasOwnProperty.call(job || {}, names[index])) {
  	                    payload[names[index]] = value;
  	                    return names[index];
  	                  }
  	                }

  	                if (fallbackName) {
  	                  payload[fallbackName] = value;
  	                  return fallbackName;
  	                }

  	                return "";
  	              }

  	              function eventTrackingCloneObject(value) {
  	                const parsed = eventTrackingParseJson(value, {});
  	                return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  	              }

  	              async function saveEventTrackingReconciliation(job, evidence, result) {
  	                if (!hasBackendlessData()) {
  	                  throw new Error("The Database connection is unavailable, so the reconciled Job cannot be saved.");
  	                }

  	                const objectId = jobEntryObjectId(job);
  	                if (!objectId) {
  	                  throw new Error("This Job Entry has no objectId and cannot be reconciled.");
  	                }

  	                const store = Backendless.Data.of(TABLE_JOB_ENTRIES);
  	                if (!store || typeof store.save !== "function") {
  	                  throw new Error("The JobEntries save function is unavailable.");
  	                }

  	                const corrected = result && result.correctedRange;
  	                const analysis = result && result.analysis;
  	                const basePayload = { objectId };

  	                if (corrected && analysis) {
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["TimeIn", "timeIn", "Time_In", "StartTime", "startTime", "EnterTime", "EntryTime"],
  	                    eventTrackingClockWithSeconds(corrected.from),
  	                    "TimeIn"
  	                  );
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["TimeOut", "timeOut", "Time_Out", "EndTime", "endTime", "ExitTime", "DepartureTime"],
  	                    eventTrackingClockWithSeconds(corrected.to),
  	                    "TimeOut"
  	                  );

  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["DurationSeconds", "durationSeconds", "DurationSec", "durationSec"],
  	                    Math.round(analysis.durationSeconds),
  	                    ""
  	                  );
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["DurationMinutes", "durationMinutes"],
  	                    analysis.durationSeconds / 60,
  	                    ""
  	                  );
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["Distance", "distance", "DistanceKm", "distanceKm", "TrackedDistance", "trackedDistance"],
  	                    analysis.distance / 1000,
  	                    ""
  	                  );
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["MovingSeconds", "movingSeconds"],
  	                    Math.round(analysis.movingSeconds),
  	                    ""
  	                  );
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["StoppedSeconds", "stoppedSeconds"],
  	                    Math.round(analysis.stoppedSeconds),
  	                    ""
  	                  );
  	                }

  	                const attempts = [];
  	                const existingData = eventTrackingCloneObject(job && job.Data);
  	                existingData.EventTracking = evidence;

  	                attempts.push(Object.assign({}, basePayload, { Data: existingData }));
  	                attempts.push(Object.assign({}, basePayload, { Tracking: evidence }));

  	                let lastError = null;
  	                let saved = null;
  	                let cacheField = "";

  	                for (let index = 0; index < attempts.length; index += 1) {
  	                  try {
  	                    saved = await store.save(attempts[index]);
  	                    cacheField = index === 0 ? "Data.EventTracking" : "Tracking";
  	                    break;
  	                  } catch (error) {
  	                    lastError = error;
  	                  }
  	                }

  	                if (!saved) {
  	                  try {
  	                    saved = await store.save(basePayload);
  	                    cacheField = "";
  	                  } catch (baseError) {
  	                    throw lastError || baseError;
  	                  }
  	                }

  	                if (saved && typeof saved === "object") Object.assign(job, saved);
  	                Object.assign(job, basePayload);

  	                job.Data = eventTrackingCloneObject(job.Data);
  	                job.Data.EventTracking = evidence;
  	                job.Tracking = evidence;

  	                state.locationEventCache = {};

  	                return {
  	                  saved: saved && typeof saved === "object" ? saved : basePayload,
  	                  cacheField,
  	                  cacheSaved: !!cacheField
  	                };
  	              }

  	              function eventTrackingContextFromCache(job, searchRange) {
  	                const cache = eventTrackingCache(job);
  	                if (!cache || cache.reconciled !== true || !cache.corrected) return null;

  	                const currentFrom = searchRange && Number(searchRange.recordedFrom);
  	                const currentTo = searchRange && Number(searchRange.recordedTo);
  	                const cachedCorrectedFrom = Number(cache.corrected.from);
  	                const cachedCorrectedTo = Number(cache.corrected.to);

  	                if (
  	                  !Number.isFinite(cachedCorrectedFrom) ||
  	                  !Number.isFinite(cachedCorrectedTo) ||
  	                  cachedCorrectedTo <= cachedCorrectedFrom
  	                ) {
  	                  return null;
  	                }

  	                const currentMatchesCorrected =
  	                  Number.isFinite(currentFrom) &&
  	                  Number.isFinite(currentTo) &&
  	                  Math.abs(currentFrom - cachedCorrectedFrom) <= 2000 &&
  	                  Math.abs(currentTo - cachedCorrectedTo) <= 2000;

  	                const currentMatchesRecorded =
  	                  Number.isFinite(currentFrom) &&
  	                  Number.isFinite(currentTo) &&
  	                  Number.isFinite(Number(cache.recorded && cache.recorded.from)) &&
  	                  Number.isFinite(Number(cache.recorded && cache.recorded.to)) &&
  	                  Math.abs(currentFrom - Number(cache.recorded.from)) <= 2000 &&
  	                  Math.abs(currentTo - Number(cache.recorded.to)) <= 2000;

  	                if (!currentMatchesCorrected && !currentMatchesRecorded) return null;

  	                const routePoints = eventTrackingRestorePoints(cache.routePoints);
  	                const searchPoints = eventTrackingRestorePoints(cache.points);
  	                if (routePoints.length < 2) return null;

  	                const correctedRange = {
  	                  from: cachedCorrectedFrom,
  	                  to: cachedCorrectedTo,
  	                  recordedFrom: Number(cache.recorded && cache.recorded.from),
  	                  recordedTo: Number(cache.recorded && cache.recorded.to),
  	                  paddingMs: Number(cache.searchWindow && cache.searchWindow.paddingMs) || EVENT_TRACKING_PADDING_MS
  	                };

  	                const analysis = {
  	                  distance: Number(cache.corrected.distanceMeters) || 0,
  	                  durationSeconds: Number(cache.corrected.durationSeconds) || Math.max(0, (cachedCorrectedTo - cachedCorrectedFrom) / 1000),
  	                  movingSeconds: Number(cache.corrected.movingSeconds) || 0,
  	                  stoppedSeconds: Number(cache.corrected.stoppedSeconds) || 0,
  	                  maxSpeed: Number.isFinite(Number(cache.corrected.maximumSpeed)) ? Number(cache.corrected.maximumSpeed) : null,
  	                  averageSpeed: Number.isFinite(Number(cache.corrected.averageSpeed)) ? Number(cache.corrected.averageSpeed) : null,
  	                  first: routePoints[0] || null,
  	                  last: routePoints[routePoints.length - 1] || null
  	                };

  	                return {
  	                  cache,
  	                  points: routePoints,
  	                  searchPoints,
  	                  analysis,
  	                  correctedRange,
  	                  boundary: eventTrackingBoundaryGeometry(job),
  	                  source: "Saved JobEntries tracking JSON"
  	                };
  	              }

  	              function trackingValue(raw, keys) {
  	                if (!raw || typeof raw !== "object") return null;

  	                for (let index = 0; index < keys.length; index += 1) {
  	                  const key = keys[index];
  	                  let value;

  	                  if (Object.prototype.hasOwnProperty.call(raw, key)) {
  	                    value = raw[key];
  	                  } else {
  	                    value = key.split(".").reduce((current, part) => {
  	                      return current && current[part] !== undefined ? current[part] : undefined;
  	                    }, raw);
  	                  }

  	                  if (value && typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "value")) {
  	                    value = value.value;
  	                  }

  	                  if (value !== undefined && value !== null && value !== "") return value;
  	                }

  	                return null;
  	              }

  	              function trackingNumber(raw, keys) {
  	                const numeric = Number(trackingValue(raw, keys));
  	                return Number.isFinite(numeric) ? numeric : null;
  	              }

  	              function trackingTimestamp(value) {
  	                if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.getTime();
  	                if (typeof value === "number" && Number.isFinite(value)) return value < 1e12 ? value * 1000 : value;

  	                const raw = safeString(value).trim();
  	                if (!raw) return null;

  	                const numeric = Number(raw);
  	                if (Number.isFinite(numeric)) return numeric < 1e12 ? numeric * 1000 : numeric;

  	                const parsed = Date.parse(raw);
  	                return Number.isFinite(parsed) ? parsed : null;
  	              }

  	              function trackerIdOf(vehicle) {
  	                return safeString(trackingValue(vehicle, [
  	                  "Tracker", "TrackerId", "TrackerID", "trackerId",
  	                  "Data.Tracking.TrackerId", "Data.Telematics.DeviceId", "DeviceId", "deviceId"
  	                ]) || "").trim();
  	              }

  	              function objectIdOfEventAsset(value) {
  	                return safeString(trackingValue(value, ["objectId", "ObjectId", "objectID", "id", "ID"]) || "").trim();
  	              }

  	              function normaliseMatchToken(value) {
  	                return safeString(value || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
  	              }

  	              function eventVehicleCandidates() {
  	                const output = [];
  	                const add = value => {
  	                  if (!value || typeof value !== "object") return;
  	                  if (!output.includes(value)) output.push(value);
  	                };
  	                const addArray = value => (Array.isArray(value) ? value : value ? [value] : []).forEach(add);

  	                addArray(eventCompany?.Tractors);
  	                addArray(eventCompany?.Vehicles);
  	                addArray(eventCompany?.Fleet);
  	                addArray(appData?.Tractors);
  	                addArray(appData?.Vehicles);
  	                add(appData?.SelectedTractor);

  	                const companies = []
  	                  .concat(Array.isArray(appData?.Companies) ? appData.Companies : [])
  	                  .concat(Array.isArray(appData?.User?.Companies) ? appData.User.Companies : []);

  	                companies.forEach(company => {
  	                  addArray(company?.Tractors);
  	                  addArray(company?.Vehicles);
  	                });

  	                return output;
  	              }

  	              function vehicleMatchTokens(vehicle) {
  	                return [
  	                  objectIdOfEventAsset(vehicle),
  	                  trackingValue(vehicle, ["VehicleId", "vehicleId", "TractorId", "tractorId"]),
  	                  trackingValue(vehicle, ["Registration", "registration", "VehicleRegistration", "vehicleRegistration"]),
  	                  trackingValue(vehicle, ["Label", "label", "Name", "name", "VehicleName", "vehicleName"]),
  	                  trackerIdOf(vehicle)
  	                ].map(normaliseMatchToken).filter(Boolean);
  	              }

  	              function resolveEventVehicle(job) {
  	                const jobTokens = [
  	                  trackingValue(job, ["VehicleObjectId", "vehicleObjectId", "VehicleId", "vehicleId"]),
  	                  trackingValue(job, ["TractorObjectId", "tractorObjectId", "TractorId", "tractorId"]),
  	                  trackingValue(job, ["VehicleRegistration", "vehicleRegistration", "Registration", "registration"]),
  	                  trackingValue(job, ["VehicleLabel", "vehicleLabel", "VehicleName", "vehicleName"]),
  	                  getVehicleText(job)
  	                ].map(normaliseMatchToken).filter(Boolean);

  	                let best = null;
  	                let bestScore = 0;

  	                eventVehicleCandidates().forEach(vehicle => {
  	                  const candidates = vehicleMatchTokens(vehicle);
  	                  let score = 0;

  	                  jobTokens.forEach(jobToken => {
  	                    candidates.forEach(vehicleToken => {
  	                      if (jobToken === vehicleToken) score = Math.max(score, 100);
  	                      else if (jobToken.length >= 5 && (jobToken.includes(vehicleToken) || vehicleToken.includes(jobToken))) {
  	                        score = Math.max(score, 45);
  	                      }
  	                    });
  	                  });

  	                  if (score > bestScore) {
  	                    bestScore = score;
  	                    best = vehicle;
  	                  }
  	                });

  	                return best;
  	              }

  	              function trackingExtractRows(payload, depth = 0) {
  	                if (depth > 6 || payload === undefined || payload === null) return [];
  	                if (Array.isArray(payload)) return payload;

  	                if (typeof payload === "string") {
  	                  try { return trackingExtractRows(JSON.parse(payload), depth + 1); }
  	                  catch (_) { return []; }
  	                }

  	                if (typeof payload !== "object") return [];

  	                const keys = ["result", "messages", "Tracking", "tracking", "rows", "items", "data", "body"];
  	                for (let index = 0; index < keys.length; index += 1) {
  	                  if (payload[keys[index]] === undefined) continue;
  	                  const rows = trackingExtractRows(payload[keys[index]], depth + 1);
  	                  if (rows.length || Array.isArray(payload[keys[index]])) return rows;
  	                }

  	                return [];
  	              }

  	              function trackingMessageTimestamp(row) {
  	                return trackingTimestamp(trackingValue(row, ["timestamp", "server.timestamp", "created", "time", "ts"]));
  	              }

  	              function loadedEventTrackingRows(vehicle, from, to) {
  	                const sources = [
  	                  vehicle?.Tracking,
  	                  vehicle?.TrackingHistory,
  	                  vehicle?.TelemetryHistory,
  	                  appData?.Tracking?.[trackerIdOf(vehicle)]
  	                ];

  	                for (let index = 0; index < sources.length; index += 1) {
  	                  const rows = trackingExtractRows(sources[index]).filter(row => {
  	                    const timestamp = trackingMessageTimestamp(row);
  	                    return timestamp !== null && timestamp >= from && timestamp <= to;
  	                  });
  	                  if (rows.length) return rows;
  	                }

  	                return [];
  	              }

  	              const EVENT_TRACKING_FUNCTION = "fn_2cdb14e20aec99596e5725c4e3064843";
  	              const EVENT_TRACKING_FIELDS = [
  	                "timestamp", "server.timestamp", "position.latitude", "position.longitude",
  	                "position.speed", "position.direction", "position.valid", "can.vehicle.speed",
  	                "can.vehicle.mileage", "can.fuel.level", "engine.ignition.status", "movement.status",
  	                "battery.voltage", "gsm.signal.level", "ident"
  	              ];

  	              async function loadEventTracking(vehicle, range) {
  	                const trackerId = trackerIdOf(vehicle);
  	                if (!trackerId) throw new Error("The event vehicle has no tracker device ID.");

  	                const payload = {
  	                  trackerId,
  	                  vehicleObjectId: objectIdOfEventAsset(vehicle),
  	                  registration: safeString(trackingValue(vehicle, ["Registration", "VehicleRegistration", "Label", "Name"]) || ""),
  	                  from: Math.floor(range.from / 1000),
  	                  to: Math.ceil(range.to / 1000),
  	                  fromIso: new Date(range.from).toISOString(),
  	                  toIso: new Date(range.to).toISOString(),
  	                  fields: EVENT_TRACKING_FIELDS.slice()
  	                };

  	                const loaded = loadedEventTrackingRows(vehicle, range.from, range.to);
  	                if (loaded.length) return { rows: loaded, source: "Loaded vehicle tracking", payload };

  	                const runtimes = [];
  	                try { if (typeof BackendlessUI !== "undefined" && BackendlessUI) runtimes.push(BackendlessUI); } catch (_) {}
  	                try { if (window.BackendlessUI && !runtimes.includes(window.BackendlessUI)) runtimes.push(window.BackendlessUI); } catch (_) {}

  	                for (let index = 0; index < runtimes.length; index += 1) {
  	                  const custom = runtimes[index]?.Functions?.Custom;
  	                  const loader = custom?.[EVENT_TRACKING_FUNCTION];
  	                  if (typeof loader !== "function") continue;

  	                  const hadSelected = Object.prototype.hasOwnProperty.call(appData || {}, "SelectedTractor");
  	                  const previous = appData?.SelectedTractor;
  	                  let returned;

  	                  try {
  	                    if (appData) appData.SelectedTractor = vehicle;
  	                    returned = await loader.call(custom, appData, trackerId, new Date(range.to), new Date(range.from));
  	                  } finally {
  	                    if (appData) {
  	                      if (hadSelected) appData.SelectedTractor = previous;
  	                      else delete appData.SelectedTractor;
  	                    }
  	                  }

  	                  const afterLoad = loadedEventTrackingRows(vehicle, range.from, range.to);
  	                  const returnedRows = trackingExtractRows(returned).filter(row => {
  	                    const timestamp = trackingMessageTimestamp(row);
  	                    return timestamp !== null && timestamp >= range.from && timestamp <= range.to;
  	                  });

  	                  return { rows: afterLoad.length ? afterLoad : returnedRows, source: "TrackIT history loader", payload };
  	                }

  	                const providers = [
  	                  [window.FIFTrackingProvider, "loadWindow"],
  	                  [window.FIFTrackingProvider, "loadHistory"],
  	                  [appData?.TrackingProvider, "loadWindow"]
  	                ];

  	                for (let index = 0; index < providers.length; index += 1) {
  	                  const owner = providers[index][0];
  	                  const fn = owner?.[providers[index][1]];
  	                  if (typeof fn !== "function") continue;
  	                  const returned = await fn.call(owner, payload);
  	                  return { rows: trackingExtractRows(returned), source: "Installed tracking provider", payload };
  	                }

  	                if (typeof Backendless !== "undefined" && Backendless?.APIServices?.invoke) {
  	                  const returned = await Backendless.APIServices.invoke("FIFTrackingService", "getTrackingWindow", payload);
  	                  return { rows: trackingExtractRows(returned), source: "Secure tracking service", payload };
  	                }

  	                throw new Error("Tracking history is not connected. Install the TrackIT history function or FIFTrackingService.getTrackingWindow.");
  	              }

  	              function normaliseTrackingPoints(rows, range, vehicle) {
  	                const seen = new Set();

  	                return (Array.isArray(rows) ? rows : []).map(raw => {
  	                  const timestamp = trackingMessageTimestamp(raw);
  	                  const lat = trackingNumber(raw, ["position.latitude", "latitude", "lat"]);
  	                  const lng = trackingNumber(raw, ["position.longitude", "longitude", "lng", "lon"]);

  	                  if (timestamp === null || timestamp < range.from || timestamp > range.to) return null;
  	                  if (lat === null || lng === null || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;

  	                  const key = `${timestamp}|${lat.toFixed(7)}|${lng.toFixed(7)}`;
  	                  if (seen.has(key)) return null;
  	                  seen.add(key);

  	                  const point = {
  	                    timestamp,
  	                    lat,
  	                    lng,
  	                    speed: trackingNumber(raw, ["position.speed", "can.vehicle.speed"]),
  	                    rpm: trackingNumber(raw, ["can.engine.rpm", "engine.rpm", "rpm"]),
  	                    temperature: trackingNumber(raw, ["can.engine.temperature", "engine.temperature", "engine.coolant.temperature", "temperature"]),
  	                    throttle: trackingNumber(raw, ["can.throttle.pedal.level", "throttle", "throttle.position"]),
  	                    direction: trackingNumber(raw, ["position.direction", "position.heading", "heading", "direction"]),
  	                    altitude: trackingNumber(raw, ["position.altitude", "altitude"]),
  	                    odometer: trackingNumber(raw, ["can.vehicle.mileage", "vehicle.mileage", "odometer"]),
  	                    fuelLevel: trackingNumber(raw, ["can.fuel.level", "fuel.level"]),
  	                    events: eventTrackingPointEvents(raw),
  	                    color: eventTrackingNormaliseColor(
  	                      firstValue([
  	                        raw && raw.color,
  	                        raw && raw.Color,
  	                        raw && raw.routeColor,
  	                        raw && raw.RouteColor
  	                      ], ""),
  	                      ""
  	                    ),
  	                    raw
  	                  };

  	                  point.color = eventTrackingPointRouteColor(point, vehicle);
  	                  return point;
  	                }).filter(Boolean).sort((a, b) => a.timestamp - b.timestamp);
  	              }

  	              function trackingDistanceMeters(a, b) {
  	                const radians = value => value * Math.PI / 180;
  	                const lat1 = radians(a.lat);
  	                const lat2 = radians(b.lat);
  	                const deltaLat = lat2 - lat1;
  	                const deltaLng = radians(b.lng - a.lng);
  	                const value = Math.sin(deltaLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) ** 2;
  	                return 6371000 * 2 * Math.atan2(Math.sqrt(value), Math.sqrt(1 - value));
  	              }

  	              function analyseEventTracking(points, range) {
  	                let distance = 0;
  	                let maxSpeed = null;
  	                let speedTotal = 0;
  	                let speedCount = 0;
  	                let movingSeconds = 0;

  	                for (let index = 0; index < points.length; index += 1) {
  	                  const point = points[index];
  	                  if (Number.isFinite(point.speed)) {
  	                    maxSpeed = maxSpeed === null ? point.speed : Math.max(maxSpeed, point.speed);
  	                    speedTotal += point.speed;
  	                    speedCount += 1;
  	                  }

  	                  if (index > 0) {
  	                    const previous = points[index - 1];
  	                    const segment = trackingDistanceMeters(previous, point);
  	                    const seconds = Math.max(0, (point.timestamp - previous.timestamp) / 1000);
  	                    if (segment < 5000) distance += segment;
  	                    if ((Number.isFinite(point.speed) && point.speed > 3) || segment > 15) movingSeconds += Math.min(seconds, 300);
  	                  }
  	                }

  	                const durationSeconds = Math.max(0, (range.to - range.from) / 1000);
  	                return {
  	                  distance,
  	                  durationSeconds,
  	                  movingSeconds: Math.min(durationSeconds, movingSeconds),
  	                  stoppedSeconds: Math.max(0, durationSeconds - movingSeconds),
  	                  maxSpeed,
  	                  averageSpeed: speedCount ? speedTotal / speedCount : null,
  	                  first: points[0] || null,
  	                  last: points[points.length - 1] || null
  	                };
  	              }

  	              function formatTrackingDuration(seconds) {
  	                const value = Math.max(0, Math.round(Number(seconds) || 0));
  	                const hours = Math.floor(value / 3600);
  	                const minutes = Math.floor((value % 3600) / 60);
  	                const secs = value % 60;
  	                return hours ? `${hours}h ${pad2(minutes)}m` : minutes ? `${minutes}m ${pad2(secs)}s` : `${secs}s`;
  	              }

  	              function trackingVehicleLabel(vehicle, job) {
  	                return safeString(trackingValue(vehicle, [
  	                  "Registration", "VehicleRegistration", "Label", "Name", "VehicleName"
  	                ]) || getVehicleText(job) || "Vehicle").trim();
  	              }

  	              function eventGoogleMapsApiKey() {
  	                const scripts = Array.from(document.querySelectorAll('script[src*="maps.googleapis.com/maps/api/js"]'));

  	                for (let index = 0; index < scripts.length; index += 1) {
  	                  try {
  	                    const key = new URL(scripts[index].src, window.location.href).searchParams.get("key");
  	                    if (key) return key;
  	                  } catch (_) {}
  	                }

  	                return safeString(
  	                  appData?.GoogleMapsApiKey ||
  	                  appData?.Configuration?.GoogleMapsApiKey ||
  	                  appData?.Configuration?.Maps?.ApiKey ||
  	                  ""
  	                ).trim();
  	              }

  	              function eventTrackingStaticMapUrl(context) {
  	                const key = eventGoogleMapsApiKey();
  	                const points = (context?.points || []).filter(point =>
  	                  point &&
  	                  Number.isFinite(Number(point.lat)) &&
  	                  Number.isFinite(Number(point.lng))
  	                );

  	                if (!key || !points.length) return "";

  	                function staticHex(value, fallback) {
  	                  const textValue = safeString(value || "").trim();
  	                  const fallbackValue = safeString(fallback || "#ff8a3c").trim();

  	                  if (/^#[0-9a-f]{6}$/i.test(textValue)) {
  	                    return "0x" + textValue.slice(1).toLowerCase();
  	                  }

  	                  if (/^#[0-9a-f]{3}$/i.test(textValue)) {
  	                    const short = textValue.slice(1);
  	                    return "0x" + short.split("").map(char => char + char).join("").toLowerCase();
  	                  }

  	                  const basic = {
  	                    red: "0xff0000",
  	                    green: "0x00ff00",
  	                    yellow: "0xffff00",
  	                    orange: "0xff8a3c",
  	                    blue: "0x4a89ff",
  	                    purple: "0x7c3aed",
  	                    white: "0xffffff",
  	                    black: "0x000000"
  	                  };

  	                  const named = basic[textValue.toLowerCase()];
  	                  if (named) return named;

  	                  return staticHex(fallbackValue === textValue ? "#ff8a3c" : fallbackValue, "#ff8a3c");
  	                }

  	                function decimatePath(pathPoints, maxPoints) {
  	                  const input = Array.isArray(pathPoints) ? pathPoints : [];
  	                  if (input.length <= maxPoints) return input.slice();

  	                  const step = Math.max(1, Math.ceil(input.length / maxPoints));
  	                  const selected = input.filter((point, index) => index % step === 0);

  	                  if (selected[0] !== input[0]) selected.unshift(input[0]);
  	                  if (selected[selected.length - 1] !== input[input.length - 1]) {
  	                    selected.push(input[input.length - 1]);
  	                  }

  	                  return selected;
  	                }

  	                const boundary = context?.boundary || eventTrackingBoundaryGeometry(context?.job);
  	                const locationColor = eventTrackingLocationColor(context?.job);
  	                const boundaryPoints = [];

  	                if (
  	                  boundary &&
  	                  boundary.type === "polygon" &&
  	                  Array.isArray(boundary.points)
  	                ) {
  	                  boundary.points.forEach(point => {
  	                    const lat = Number(point && point.lat);
  	                    const lng = Number(point && point.lng);

  	                    if (
  	                      Number.isFinite(lat) &&
  	                      Number.isFinite(lng) &&
  	                      Math.abs(lat) <= 90 &&
  	                      Math.abs(lng) <= 180
  	                    ) {
  	                      boundaryPoints.push({ lat, lng });
  	                    }
  	                  });
  	                } else if (
  	                  boundary &&
  	                  boundary.type === "circle" &&
  	                  boundary.center &&
  	                  Number.isFinite(Number(boundary.center.lat)) &&
  	                  Number.isFinite(Number(boundary.center.lng)) &&
  	                  Number.isFinite(Number(boundary.radiusMeters)) &&
  	                  Number(boundary.radiusMeters) > 0
  	                ) {
  	                  const centerLat = Number(boundary.center.lat);
  	                  const centerLng = Number(boundary.center.lng);
  	                  const radius = Number(boundary.radiusMeters);
  	                  const earth = 6371000;

  	                  for (let index = 0; index <= 36; index += 1) {
  	                    const angle = (index / 36) * Math.PI * 2;
  	                    const north = Math.cos(angle) * radius;
  	                    const east = Math.sin(angle) * radius;
  	                    const lat = centerLat + (north / earth) * (180 / Math.PI);
  	                    const lng =
  	                      centerLng +
  	                      (east / (earth * Math.cos(centerLat * Math.PI / 180))) *
  	                        (180 / Math.PI);

  	                    boundaryPoints.push({ lat, lng });
  	                  }
  	                }

  	                // Match the live map: calculate the viewport from BOTH the corrected
  	                // route and the complete Location boundary.
  	                const viewportPoints = points.concat(boundaryPoints);

  	                let minLat = Number(viewportPoints[0].lat);
  	                let maxLat = minLat;
  	                let minLng = Number(viewportPoints[0].lng);
  	                let maxLng = minLng;

  	                viewportPoints.forEach(point => {
  	                  const lat = Number(point.lat);
  	                  const lng = Number(point.lng);

  	                  minLat = Math.min(minLat, lat);
  	                  maxLat = Math.max(maxLat, lat);
  	                  minLng = Math.min(minLng, lng);
  	                  maxLng = Math.max(maxLng, lng);
  	                });

  	                // Give the printable map breathing room, then calculate an explicit
  	                // centre/zoom for the WIDE report image. Relying on Static Maps
  	                // auto-fit/visible caused some long Location polygons to be clipped
  	                // even though the live Google Map was correctly fitBounds().
  	                const latSpan = Math.max(maxLat - minLat, 0.0005);
  	                const lngSpan = Math.max(maxLng - minLng, 0.0005);
  	                const latPad = Math.max(latSpan * 0.20, 0.00065);
  	                const lngPad = Math.max(lngSpan * 0.20, 0.00065);

  	                const south = Math.max(-85, minLat - latPad);
  	                const north = Math.min(85, maxLat + latPad);
  	                const west = Math.max(-180, minLng - lngPad);
  	                const east = Math.min(180, maxLng + lngPad);

  	                const staticWidth = 640;
  	                const staticHeight = 220;

  	                function mercatorY(latitude) {
  	                  const lat = Math.max(-85, Math.min(85, Number(latitude) || 0));
  	                  const sin = Math.sin(lat * Math.PI / 180);
  	                  return 0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI);
  	                }

  	                function inverseMercatorY(y) {
  	                  return Math.atan(
  	                    Math.sinh(Math.PI * (1 - 2 * y))
  	                  ) * 180 / Math.PI;
  	                }

  	                const westX = (west + 180) / 360;
  	                const eastX = (east + 180) / 360;
  	                const northY = mercatorY(north);
  	                const southY = mercatorY(south);
  	                const longitudeFraction = Math.max(Math.abs(eastX - westX), 1e-9);
  	                const latitudeFraction = Math.max(Math.abs(southY - northY), 1e-9);

  	                // Reserve physical pixel padding inside the returned Static Map.
  	                const usableWidth = Math.max(120, staticWidth - 90);
  	                const usableHeight = Math.max(90, staticHeight - 70);
  	                const zoomX = Math.log2(usableWidth / (256 * longitudeFraction));
  	                const zoomY = Math.log2(usableHeight / (256 * latitudeFraction));
  	                const staticZoom = Math.max(
  	                  0,
  	                  Math.min(20, Math.floor(Math.min(zoomX, zoomY)))
  	                );

  	                const centerY = (northY + southY) / 2;
  	                const centerLat = inverseMercatorY(centerY);
  	                const centerLng = (west + east) / 2;

  	                const params = new URLSearchParams({
  	                  size: staticWidth + "x" + staticHeight,
  	                  scale: "2",
  	                  maptype: "hybrid",
  	                  format: "png",
  	                  center: centerLat.toFixed(6) + "," + centerLng.toFixed(6),
  	                  zoom: String(staticZoom),
  	                  key
  	                });

  	                // Draw the Location polygon / circle first.
  	                if (boundaryPoints.length >= 3) {
  	                  const selectedBoundary = decimatePath(boundaryPoints, 90);
  	                  const boundaryPath = selectedBoundary
  	                    .map(point =>
  	                      `${Number(point.lat).toFixed(6)},${Number(point.lng).toFixed(6)}`
  	                    )
  	                    .join("|");

  	                  params.append(
  	                    "path",
  	                    `color:${staticHex(locationColor, "#ff8a3c")}e6|weight:3|fillcolor:${staticHex(locationColor, "#ff8a3c")}2b|${boundaryPath}`
  	                  );
  	                }

  	                // TrackIT-style Red > Green > Yellow route segmentation.
  	                const routeSegments = [];
  	                let currentSegment = [];
  	                let currentColor = eventTrackingPointRouteColor(points[0], context?.vehicle);

  	                points.forEach((point, index) => {
  	                  const color = eventTrackingPointRouteColor(point, context?.vehicle);
  	                  const previous = points[index - 1];

  	                  if (previous && trackingDistanceMeters(previous, point) < 3) return;

  	                  if (color !== currentColor) {
  	                    if (currentSegment.length >= 2) {
  	                      routeSegments.push({
  	                        color: currentColor,
  	                        points: currentSegment
  	                      });
  	                    }

  	                    if (currentSegment.length) {
  	                      currentSegment = [currentSegment[currentSegment.length - 1], point];
  	                    } else {
  	                      currentSegment = [point];
  	                    }

  	                    currentColor = color;
  	                  } else {
  	                    currentSegment.push(point);
  	                  }
  	                });

  	                if (currentSegment.length >= 2) {
  	                  routeSegments.push({
  	                    color: currentColor,
  	                    points: currentSegment
  	                  });
  	                }

  	                routeSegments.forEach(segment => {
  	                  const selected = decimatePath(segment.points, 70);
  	                  const routePath = selected
  	                    .map(point =>
  	                      `${Number(point.lat).toFixed(6)},${Number(point.lng).toFixed(6)}`
  	                    )
  	                    .join("|");

  	                  params.append(
  	                    "path",
  	                    `color:${staticHex(segment.color, "#ffff00")}ff|weight:7|${routePath}`
  	                  );
  	                });

  	                // Centre/zoom above is deliberately explicit. Do not ask the Static
  	                // Maps service to auto-fit the paths again, because that was the
  	                // source of the report-only cropping mismatch.

  	                const first = points[0];
  	                const last = points[points.length - 1];

  	                params.append(
  	                  "markers",
  	                  `color:green|label:I|${Number(first.lat).toFixed(6)},${Number(first.lng).toFixed(6)}`
  	                );

  	                params.append(
  	                  "markers",
  	                  `color:orange|label:O|${Number(last.lat).toFixed(6)},${Number(last.lng).toFixed(6)}`
  	                );

  	                return `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`;
  	              }

  	              function printEventTrackingReport(trackWindow) {
  	                const context = trackWindow?.__eventTrackingContext;
  	                if (!context) return;

  	                const printWindow = window.open("", "_blank", "width=1320,height=920");
  	                if (!printWindow) {
  	                  window.alert("The Event Tracking report window was blocked by the browser.");
  	                  return;
  	                }

  	                const job = context.job;
  	                const range = context.range;
  	                const analysis = context.analysis;
  	                const mapUrl = eventTrackingStaticMapUrl(context);
  	                const reportBrandAsset = resolveReportBrandAsset(REPORT_SVG_INPUT);
  	                const eventInfo = buildMultilineEvent(job);
  	                const vehicleLabel = trackingVehicleLabel(context.vehicle, job);
  	                const generatedAt = new Date().toLocaleString();
  	                const inLabel = new Date(range.from).toLocaleString();
  	                const outLabel = new Date(range.to).toLocaleString();
  	                const recordedInLabel = context.searchRange && Number.isFinite(Number(context.searchRange.recordedFrom))
  	                  ? new Date(Number(context.searchRange.recordedFrom)).toLocaleString()
  	                  : "Not recorded";
  	                const recordedOutLabel = context.searchRange && Number.isFinite(Number(context.searchRange.recordedTo))
  	                  ? new Date(Number(context.searchRange.recordedTo)).toLocaleString()
  	                  : "Not recorded";
  	                const status = context.error
  	                  ? context.error
  	                  : `${context.points.length} GPS point${context.points.length === 1 ? "" : "s"} · ${context.source || "Tracking history"}`;
  	                const startPoint = analysis?.first;
  	                const endPoint = analysis?.last;

  	                const html = `<!doctype html>
  	                <html><head><meta charset="utf-8"><title>Event Tracking Evidence</title>
  	                <style>
  	                @page{size:A4 landscape;margin:7mm}*{box-sizing:border-box}html,body{width:100%;margin:0;padding:0}body{color:#1d2821;font-family:Arial,sans-serif;font-size:9px;overflow:visible}
  	                header{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding-bottom:7px;border-bottom:3px solid #b85a2f}.brand-head{display:flex;align-items:flex-start;gap:12px;min-width:0}.brand{display:block;width:96px;max-height:46px;object-fit:contain;object-position:left top;flex:0 0 auto}.brand-copy{min-width:0}h1{margin:2px 0 0;font-size:19px}h2{margin:0 0 5px;color:#a44f2a;font-size:9px;letter-spacing:.08em;text-transform:uppercase}.meta{text-align:right;color:#607067;font-size:8px}
  	                .grid{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;margin:7px 0}.card{padding:6px;border:1px solid #d7ddd9;border-radius:6px;background:#f4f7f5}.card span{display:block;color:#6c7870;font-size:7px;font-weight:bold;text-transform:uppercase}.card strong{display:block;margin-top:3px;font-size:10px}
  	                .map{border:1px solid #b7c0ba;border-radius:7px;overflow:hidden;background:#111;display:grid;place-items:center;break-inside:avoid;page-break-inside:avoid}.map img{display:block;width:100%;height:auto;object-fit:contain;background:#111}.map p{min-height:220px;display:grid;place-items:center;max-width:none;width:100%;margin:0;padding:24px;text-align:center;color:#68736c}
  	                table{width:100%;margin-top:6px;border-collapse:collapse;break-inside:avoid;page-break-inside:avoid}th,td{padding:4px 5px;border:1px solid #d4dad6;text-align:left;line-height:1.25}th{width:16%;background:#edf1ee;color:#536159;text-transform:uppercase;font-size:7px}footer{display:flex;justify-content:space-between;margin-top:5px;color:#738078;font-size:7px;break-inside:avoid;page-break-inside:avoid}
  	                @media print{body{zoom:.98}header,.grid,.map,table,footer{break-inside:avoid;page-break-inside:avoid}}
  	                </style></head><body>
  	                <header><div class="brand-head">${reportBrandAsset ? `<img class="brand" src="${escapeHtml(reportBrandAsset)}" alt="Fleet In Form">` : ""}<div class="brand-copy"><h2>Fleet In Form · Event Tracking Evidence</h2><h1>${escapeHtml(vehicleLabel)} · ${escapeHtml(eventInfo.headline || "Location Event")}</h1><div>${escapeHtml(eventLocationDisplayLabel(job) || "Location")} · ${escapeHtml(eventFieldLabel(job) || "Field not recorded")}</div></div></div><div class="meta">Generated ${escapeHtml(generatedAt)}<br>${escapeHtml(status)}</div></header>
  	                <section class="grid">
  	                <div class="card"><span>Actual Time In</span><strong>${escapeHtml(inLabel)}</strong></div>
  	                <div class="card"><span>Actual Time Out</span><strong>${escapeHtml(outLabel)}</strong></div>
  	                <div class="card"><span>Event Duration</span><strong>${escapeHtml(formatTrackingDuration((range.to-range.from)/1000))}</strong></div>
  	                <div class="card"><span>Tracked Distance</span><strong>${analysis ? escapeHtml((analysis.distance/1000).toFixed(2)+" km") : "—"}</strong></div>
  	                </section>
  	                <div class="map">${mapUrl ? `<img src="${escapeHtml(mapUrl)}" alt="Hybrid map snapshot of event route">` : `<p>A printable Hybrid map snapshot is unavailable because no Google Static Maps key or GPS path was available. The tracking facts below remain part of this evidence report.</p>`}</div>
  	                <table><tbody>
  	                <tr><th>Vehicle</th><td>${escapeHtml(vehicleLabel)}</td><th>Tracker</th><td>${escapeHtml(trackerIdOf(context.vehicle) || "Not recorded")}</td></tr>
  	                <tr><th>Location</th><td>${escapeHtml(eventLocationDisplayLabel(job) || "Location")}</td><th>Field</th><td>${escapeHtml(eventFieldLabel(job) || "Not recorded")}</td></tr><tr><th>Event</th><td>${escapeHtml(eventInfo.headline || "Not recorded")}</td><th>Boundary Source</th><td>${escapeHtml(context.boundary && context.boundary.source || "Not recorded")}</td></tr>
  	                <tr><th>Recorded Window</th><td>${escapeHtml(recordedInLabel)} → ${escapeHtml(recordedOutLabel)}</td><th>Driver</th><td>${escapeHtml(getDriverText(job) || "Not recorded")}</td></tr><tr><th>Contractor</th><td>${escapeHtml(getContractorText(job) || "Not recorded")}</td><th>Tracker Source</th><td>${escapeHtml(context.source || "Not recorded")}</td></tr>
  	                <tr><th>Moving / Stopped</th><td>${analysis ? escapeHtml(formatTrackingDuration(analysis.movingSeconds)+" / "+formatTrackingDuration(analysis.stoppedSeconds)) : "—"}</td><th>Average / Max Speed</th><td>${analysis && analysis.averageSpeed !== null ? escapeHtml(analysis.averageSpeed.toFixed(1)+" / "+analysis.maxSpeed.toFixed(1)+" km/h") : "—"}</td></tr>
  	                <tr><th>First GPS Fix</th><td>${startPoint ? escapeHtml(new Date(startPoint.timestamp).toLocaleString()+` · ${startPoint.lat.toFixed(6)}, ${startPoint.lng.toFixed(6)}`) : "—"}</td><th>Last GPS Fix</th><td>${endPoint ? escapeHtml(new Date(endPoint.timestamp).toLocaleString()+` · ${endPoint.lat.toFixed(6)}, ${endPoint.lng.toFixed(6)}`) : "—"}</td></tr>
  	                </tbody></table>
  	                <footer><span>Route is reconciled from actual Location boundary entry → exit. Tracker history is searched with 5 minutes of padding on each side.</span><span>Fleet In Form</span></footer>
  	                <script>
  	                window.onload=function(){
  	                  window.focus();
  	                  var image=document.querySelector(".map img");
  	                  var printed=false;
  	                  function go(){
  	                    if(printed)return;
  	                    printed=true;
  	                    setTimeout(function(){window.print();},180);
  	                  }
  	                  if(!image||image.complete){go();return;}
  	                  image.addEventListener("load",go,{once:true});
  	                  image.addEventListener("error",go,{once:true});
  	                  setTimeout(go,2200);
  	                };
  	                <\/script>
  	                </body></html>`;

  	                printWindow.document.open();
  	                printWindow.document.write(html);
  	                printWindow.document.close();
  	              }

  	              function makeTrackingWindowDraggable(trackWindow) {
  	                const handle = trackWindow.querySelector("[data-jel-track-drag]");
  	                if (!handle) return;

  	                handle.addEventListener("mousedown", event => {
  	                  if (event.button !== 0 || event.target.closest("button")) return;
  	                  const rect = trackWindow.getBoundingClientRect();
  	                  const offsetX = event.clientX - rect.left;
  	                  const offsetY = event.clientY - rect.top;

  	                  trackWindow.style.transform = "none";
  	                  trackWindow.style.left = `${rect.left}px`;
  	                  trackWindow.style.top = `${rect.top}px`;

  	                  const move = moveEvent => {
  	                    const maxLeft = Math.max(0, window.innerWidth - trackWindow.offsetWidth);
  	                    const maxTop = Math.max(0, window.innerHeight - trackWindow.offsetHeight);
  	                    trackWindow.style.left = `${Math.min(maxLeft,Math.max(0,moveEvent.clientX-offsetX))}px`;
  	                    trackWindow.style.top = `${Math.min(maxTop,Math.max(0,moveEvent.clientY-offsetY))}px`;
  	                  };

  	                  const stop = () => {
  	                    document.removeEventListener("mousemove", move);
  	                    document.removeEventListener("mouseup", stop);
  	                  };

  	                  document.addEventListener("mousemove", move);
  	                  document.addEventListener("mouseup", stop);
  	                  event.preventDefault();
  	                });
  	              }

  	              function renderEventTrackingMap(trackWindow, points, range) {
  	                const mapNode = trackWindow.querySelector("[data-jel-track-map]");
  	                const state = trackWindow.querySelector("[data-jel-track-state]");
  	                const maps = window.google?.maps;

  	                if (!maps || typeof maps.Map !== "function") {
  	                  if (state) state.textContent = "Google Maps is unavailable in this window.";
  	                  return null;
  	                }

  	                const context = trackWindow?.__eventTrackingContext || {};
  	                const vehicle = context.vehicle || resolveEventVehicle(context.job);
  	                const eventLocation = eventLocationForJob(context.job);
  	                const eventBoundary = context.boundary || eventTrackingBoundaryGeometry(context.job);
  	                const locationColor = eventTrackingLocationColor(context.job);
  	                const fallbackLat = Number(trackingValue(eventLocation, ["Latitude", "latitude", "lat", "Center.latitude"]));
  	                const fallbackLng = Number(trackingValue(eventLocation, ["Longitude", "longitude", "lng", "lon", "Center.longitude"]));
  	                const center = points.length
  	                  ? { lat: points[Math.floor(points.length / 2)].lat, lng: points[Math.floor(points.length / 2)].lng }
  	                  : {
  	                    lat: Number.isFinite(fallbackLat) ? fallbackLat : -30.5595,
  	                    lng: Number.isFinite(fallbackLng) ? fallbackLng : 22.9375
  	                  };

  	                const map = new maps.Map(mapNode, {
  	                  center,
  	                  zoom: points.length ? 15 : 6,
  	                  mapTypeId: maps.MapTypeId?.HYBRID || "hybrid",
  	                  mapTypeControl: true,
  	                  mapTypeControlOptions: {
  	                    mapTypeIds: [
  	                      maps.MapTypeId?.ROADMAP || "roadmap",
  	                      maps.MapTypeId?.SATELLITE || "satellite",
  	                      maps.MapTypeId?.HYBRID || "hybrid"
  	                    ]
  	                  },
  	                  fullscreenControl: true,
  	                  streetViewControl: false,
  	                  clickableIcons: true
  	                });

  	                // Keep Google InfoWindow plumbing, but use our own close control
  	                // inside the Fleet In Form card so Google's floating X does not sit
  	                // above the popup.
  	                const pointPopupStyleId = "fif-event-point-popup-google-shell-css";

  	                if (!document.getElementById(pointPopupStyleId)) {
  	                  const pointPopupStyle = document.createElement("style");
  	                  pointPopupStyle.id = pointPopupStyleId;
  	                  pointPopupStyle.textContent = `
  	                    .jel-track-window [data-jel-track-map] .gm-style-iw-c {
  	                      padding: 0 !important;
  	                      background: transparent !important;
  	                      box-shadow: none !important;
  	                      border-radius: 10px !important;
  	                      overflow: visible !important;
  	                    }

  	                    .jel-track-window [data-jel-track-map] .gm-style-iw-d {
  	                      overflow: visible !important;
  	                      padding: 0 !important;
  	                      max-height: none !important;
  	                    }

  	                    .jel-track-window [data-jel-track-map] .gm-style-iw-d > div {
  	                      overflow: visible !important;
  	                    }

  	                    .jel-track-window [data-jel-track-map] .gm-ui-hover-effect {
  	                      display: none !important;
  	                    }

  	                    .jel-track-window [data-jel-track-map] .gm-style-iw-tc {
  	                      filter: drop-shadow(0 2px 2px rgba(0,0,0,.42));
  	                    }

  	                    .jel-track-window [data-jel-track-map] [data-jel-point-popup-close]:hover {
  	                      background: #24170f !important;
  	                      border-color: #cc6633 !important;
  	                      color: #ffffff !important;
  	                    }

  	                    .jel-track-window [data-jel-track-map] [data-jel-point-popup-close]:focus-visible {
  	                      outline: 2px solid rgba(204,102,51,.72);
  	                      outline-offset: 2px;
  	                    }
  	                  `;
  	                  document.head.appendChild(pointPopupStyle);
  	                }

  	                const infoWindow = new maps.InfoWindow({});
  	                let selectedPointMarker = null;

  	                function pointInfoHtml(point) {
  	                  const speedLimit = eventTrackingVehicleLimit(vehicle, ["CAN.Speed", "CAN.SpeedLimit", "CAN.MaxSpeed", "SpeedLimit"]);
  	                  const rpmLimit = eventTrackingVehicleLimit(vehicle, ["CAN.RPM", "CAN.RPMLimit", "CAN.MaxRPM"]);
  	                  const tempLimit = eventTrackingVehicleLimit(vehicle, ["CAN.Temp", "CAN.Temperature", "CAN.MaxTemp"]);

  	                  const speedOver = Number.isFinite(point.speed) && speedLimit !== null && point.speed > speedLimit;
  	                  const rpmOver = Number.isFinite(point.rpm) && rpmLimit !== null && point.rpm > rpmLimit;
  	                  const tempOver = Number.isFinite(point.temperature) && tempLimit !== null && point.temperature > tempLimit;
  	                  const eventList = Array.isArray(point.events) && point.events.length
  	                    ? `<div style="margin-top:8px;padding-top:7px;border-top:1px solid rgba(255,255,255,.12);"><b>Events:</b><div style="margin-top:3px;color:#d7dde2;">${point.events.map(value => escapeHtml(value)).join(" · ")}</div></div>`
  	                    : "";

  	                  return `
  	                  <div style="position:relative;min-width:245px;max-width:310px;padding:10px 42px 10px 10px;border-radius:10px;background:#0b0f14;color:#fff;font:12px/1.42 system-ui,Arial,sans-serif;">
  	                    <button
  	                      type="button"
  	                      data-jel-point-popup-close
  	                      aria-label="Close tracking point"
  	                      title="Close"
  	                      style="
  	                        position:absolute;
  	                        top:8px;
  	                        right:8px;
  	                        width:26px;
  	                        height:26px;
  	                        padding:0;
  	                        display:grid;
  	                        place-items:center;
  	                        border:1px solid rgba(204,102,51,.42);
  	                        border-radius:7px;
  	                        background:#141a1f;
  	                        color:#e8edf2;
  	                        font:900 17px/1 system-ui,Arial,sans-serif;
  	                        cursor:pointer;
  	                        box-shadow:none;
  	                      "
  	                    >×</button>
  	                    <div style="font-size:13px;font-weight:850;margin-bottom:7px;">Tracking Point</div>
  	                    <div style="color:#aab5bf;margin-bottom:8px;">${escapeHtml(new Date(point.timestamp).toLocaleString())}</div>

  	                    <div style="padding:6px 8px;border-radius:6px;background:${speedOver ? "#CC6633" : "rgba(255,255,255,.05)"};">
  	                      <b>Speed:</b> ${escapeHtml(eventTrackingMetricText(point.speed, " km/h", 1))}
  	                      ${speedLimit !== null ? `<span style="opacity:.6;"> · limit ${escapeHtml(eventTrackingMetricText(speedLimit, "", 0))}</span>` : ""}
  	                    </div>

  	                    <div style="margin-top:5px;padding:6px 8px;border-radius:6px;background:${rpmOver ? "#7B08CD" : "rgba(255,255,255,.05)"};">
  	                      <b>RPM:</b> ${escapeHtml(eventTrackingMetricText(point.rpm, " RPM", 0))}
  	                      ${rpmLimit !== null ? `<span style="opacity:.6;"> · limit ${escapeHtml(eventTrackingMetricText(rpmLimit, "", 0))}</span>` : ""}
  	                    </div>

  	                    <div style="margin-top:5px;padding:6px 8px;border-radius:6px;background:${tempOver ? "#ffc107" : "rgba(255,255,255,.05)"};color:${tempOver ? "#111" : "#fff"};">
  	                      <b>Engine Temp:</b> ${escapeHtml(eventTrackingMetricText(point.temperature, "°C", 1))}
  	                      ${tempLimit !== null ? `<span style="opacity:.6;"> · limit ${escapeHtml(eventTrackingMetricText(tempLimit, "", 0))}</span>` : ""}
  	                    </div>

  	                    <div style="margin-top:7px;">
  	                      <b>Direction:</b> ${escapeHtml(eventTrackingDirectionText(point.direction))}<br>
  	                      <b>Altitude:</b> ${escapeHtml(eventTrackingMetricText(point.altitude, " m", 1))}
  	                    </div>
  	                    ${eventList}
  	                  </div>`;
  	                }

  	                if (eventBoundary && eventBoundary.type === "polygon" && Array.isArray(eventBoundary.points)) {
  	                  const boundaryPath = eventBoundary.points.map(point => ({
  	                    lat: Number(point.lat),
  	                    lng: Number(point.lng)
  	                  }));

  	                  new maps.Polygon({
  	                    map,
  	                    paths: boundaryPath,
  	                    clickable: false,
  	                    zIndex: 10,
  	                    strokeColor: locationColor,
  	                    strokeOpacity: 0.95,
  	                    strokeWeight: 2,
  	                    fillColor: locationColor,
  	                    fillOpacity: 0.16,
  	                    geodesic: true
  	                  });
  	                } else if (eventBoundary && eventBoundary.type === "circle" && eventBoundary.center) {
  	                  new maps.Circle({
  	                    map,
  	                    center: eventBoundary.center,
  	                    radius: Number(eventBoundary.radiusMeters || 0),
  	                    clickable: false,
  	                    zIndex: 10,
  	                    strokeColor: locationColor,
  	                    strokeOpacity: 0.95,
  	                    strokeWeight: 2,
  	                    fillColor: locationColor,
  	                    fillOpacity: 0.16
  	                  });
  	                }

  	                if (points.length) {
  	                  const bounds = new maps.LatLngBounds();

  	                  points.forEach(point => {
  	                    bounds.extend({ lat: point.lat, lng: point.lng });
  	                    point.color = eventTrackingPointRouteColor(point, vehicle);
  	                  });

  	                  if (eventBoundary && eventBoundary.type === "polygon") {
  	                    eventBoundary.points.forEach(point => {
  	                      bounds.extend({
  	                        lat: Number(point.lat),
  	                        lng: Number(point.lng)
  	                      });
  	                    });
  	                  } else if (eventBoundary && eventBoundary.type === "circle" && eventBoundary.center) {
  	                    bounds.extend(eventBoundary.center);
  	                  }

  	                  // TrackIT-style Red > Green > Yellow colour segmentation.
  	                  const segments = [];
  	                  let currentSegment = [];
  	                  let currentColor = points[0].color || "#FFFF00";
  	                  let previousTail = null;

  	                  for (let index = 0; index < points.length; index += 1) {
  	                    const point = points[index];
  	                    const color = point.color || "#FFFF00";
  	                    const previous = points[index - 1];

  	                    if (previous && trackingDistanceMeters(previous, point) < 3) continue;

  	                    if (color !== currentColor) {
  	                      if (currentSegment.length >= 2) {
  	                        segments.push({
  	                          color: currentColor,
  	                          points: currentSegment
  	                        });
  	                      }

  	                      if (previousTail && point) {
  	                        segments.push({
  	                          color: eventTrackingMixRouteColors(currentColor, color, 0.5),
  	                          points: [previousTail, point]
  	                        });
  	                      }

  	                      currentColor = color;
  	                      currentSegment = [point];
  	                    } else {
  	                      currentSegment.push(point);
  	                    }

  	                    previousTail = point;
  	                  }

  	                  if (currentSegment.length >= 2) {
  	                    segments.push({
  	                      color: currentColor,
  	                      points: currentSegment
  	                    });
  	                  }

  	                  segments.forEach(segment => {
  	                    const routePath = segment.points.map(point => ({
  	                      lat: point.lat,
  	                      lng: point.lng
  	                    }));

  	                    new maps.Polyline({
  	                      map,
  	                      path: routePath,
  	                      strokeColor: segment.color,
  	                      strokeOpacity: 0.90,
  	                      strokeWeight: 10,
  	                      geodesic: true,
  	                      clickable: false,
  	                      zIndex: 50
  	                    });

  	                    // Same repeating direction-chevron pattern as FineTrack.
  	                    new maps.Polyline({
  	                      map,
  	                      path: routePath,
  	                      strokeOpacity: 0,
  	                      strokeWeight: 10,
  	                      geodesic: true,
  	                      clickable: false,
  	                      icons: [{
  	                        icon: eventTrackingRouteChevronIcon(segment.color),
  	                        offset: "0px",
  	                        repeat: "22px"
  	                      }],
  	                      zIndex: 51
  	                    });
  	                  });

  	                  // Every tracker point is now clickable. Small markers keep the
  	                  // route readable while exposing Speed / RPM / Temp / Direction.
  	                  points.forEach((point, index) => {
  	                    const isBoundaryPoint = !!point.boundary;
  	                    const marker = new maps.Marker({
  	                      map,
  	                      position: {
  	                        lat: point.lat,
  	                        lng: point.lng
  	                      },
  	                      title: `${new Date(point.timestamp).toLocaleTimeString()} · ${eventTrackingMetricText(point.speed, " km/h", 1)}`,
  	                      icon: {
  	                        path: maps.SymbolPath.CIRCLE,
  	                        scale: isBoundaryPoint ? 4.7 : 3.25,
  	                        fillColor: point.color || "#FFFF00",
  	                        fillOpacity: isBoundaryPoint ? 1 : 0.78,
  	                        strokeColor: "#ffffff",
  	                        strokeOpacity: isBoundaryPoint ? 1 : 0.62,
  	                        strokeWeight: isBoundaryPoint ? 1.7 : 1
  	                      },
  	                      zIndex: isBoundaryPoint ? 85 : 70,
  	                      optimized: true
  	                    });

  	                    marker.addListener("click", () => {
  	                      if (selectedPointMarker && selectedPointMarker !== marker) {
  	                        try {
  	                          const selectedPoint = selectedPointMarker.__eventTrackingPoint;
  	                          selectedPointMarker.setIcon({
  	                            path: maps.SymbolPath.CIRCLE,
  	                            scale: selectedPoint && selectedPoint.boundary ? 4.7 : 3.25,
  	                            fillColor: selectedPoint && selectedPoint.color ? selectedPoint.color : "#FFFF00",
  	                            fillOpacity: selectedPoint && selectedPoint.boundary ? 1 : 0.78,
  	                            strokeColor: "#ffffff",
  	                            strokeOpacity: selectedPoint && selectedPoint.boundary ? 1 : 0.62,
  	                            strokeWeight: selectedPoint && selectedPoint.boundary ? 1.7 : 1
  	                          });
  	                        } catch (_) {}
  	                      }

  	                      selectedPointMarker = marker;
  	                      marker.__eventTrackingPoint = point;

  	                      marker.setIcon({
  	                        path: maps.SymbolPath.CIRCLE,
  	                        scale: isBoundaryPoint ? 6.2 : 5.2,
  	                        fillColor: point.color || "#FFFF00",
  	                        fillOpacity: 1,
  	                        strokeColor: "#ffffff",
  	                        strokeOpacity: 1,
  	                        strokeWeight: 2
  	                      });

  	                      infoWindow.setContent(pointInfoHtml(point));
  	                      infoWindow.open({
  	                        map,
  	                        anchor: marker
  	                      });

  	                      maps.event.addListenerOnce(infoWindow, "domready", () => {
  	                        const popupClose = mapNode.querySelector(
  	                          "[data-jel-point-popup-close]"
  	                        );

  	                        if (popupClose) {
  	                          popupClose.onclick = event => {
  	                            event.preventDefault();
  	                            event.stopPropagation();
  	                            infoWindow.close();
  	                          };
  	                        }
  	                      });
  	                    });

  	                    marker.__eventTrackingPoint = point;
  	                  });

  	                  const first = points[0];
  	                  const last = points[points.length - 1];

  	                  new maps.Circle({
  	                    map,
  	                    center: { lat: first.lat, lng: first.lng },
  	                    radius: 8,
  	                    fillColor: "#58d68d",
  	                    fillOpacity: 1,
  	                    strokeColor: "#ffffff",
  	                    strokeWeight: 2,
  	                    clickable: false,
  	                    zIndex: 90
  	                  });

  	                  new maps.Circle({
  	                    map,
  	                    center: { lat: last.lat, lng: last.lng },
  	                    radius: 8,
  	                    fillColor: "#f39c4a",
  	                    fillOpacity: 1,
  	                    strokeColor: "#ffffff",
  	                    strokeWeight: 2,
  	                    clickable: false,
  	                    zIndex: 90
  	                  });

  	                  infoWindow.addListener("closeclick", () => {
  	                    if (!selectedPointMarker) return;

  	                    try {
  	                      const selectedPoint = selectedPointMarker.__eventTrackingPoint;
  	                      selectedPointMarker.setIcon({
  	                        path: maps.SymbolPath.CIRCLE,
  	                        scale: selectedPoint && selectedPoint.boundary ? 4.7 : 3.25,
  	                        fillColor: selectedPoint && selectedPoint.color ? selectedPoint.color : "#FFFF00",
  	                        fillOpacity: selectedPoint && selectedPoint.boundary ? 1 : 0.78,
  	                        strokeColor: "#ffffff",
  	                        strokeOpacity: selectedPoint && selectedPoint.boundary ? 1 : 0.62,
  	                        strokeWeight: selectedPoint && selectedPoint.boundary ? 1.7 : 1
  	                      });
  	                    } catch (_) {}

  	                    selectedPointMarker = null;
  	                  });

  	                  map.fitBounds(bounds, 48);

  	                  const boundaryLegend = trackWindow.querySelector("[data-jel-boundary-swatch]");
  	                  if (boundaryLegend) boundaryLegend.style.background = locationColor;

  	                  if (state) state.hidden = true;
  	                } else if (state) {
  	                  state.hidden = false;
  	                  state.textContent = `Hybrid map is active, but no GPS fixes were returned from ${new Date(range.from).toLocaleTimeString()} to ${new Date(range.to).toLocaleTimeString()}.`;
  	                }

  	                setTimeout(() => maps.event?.trigger?.(map, "resize"), 80);
  	                return map;
  	              }

  	              async function openEventTrackingWindow(job) {
  	                const searchRange = eventTrackingRange(job);
  	                const vehicle = resolveEventVehicle(job);

  	                if (!searchRange) {
  	                  window.alert("This event needs both a valid Time In and Time Out before its route can be opened.");
  	                  return;
  	                }

  	                if (!vehicle || !trackerIdOf(vehicle)) {
  	                  window.alert("The event vehicle could not be matched to a vehicle with an assigned tracker.");
  	                  return;
  	                }

  	                mount.querySelector("[data-jel-track-window]")?.remove();

  	                const eventInfo = buildMultilineEvent(job);
  	                const vehicleLabel = trackingVehicleLabel(vehicle, job);
  	                const trackWindow = document.createElement("section");
  	                trackWindow.className = "jel-track-window";
  	                trackWindow.setAttribute("data-jel-track-window", "");

  	                trackWindow.innerHTML = `
  	                <header class="jel-track-head" data-jel-track-drag>
  	                <div>
  	                  <span class="jel-kicker">Event Tracking Evidence</span>
  	                  <strong>${escapeHtml(vehicleLabel)} · ${escapeHtml(eventInfo.headline || "Location Event")}</strong>
  	                  <small>${escapeHtml(eventLocationDisplayLabel(job))} · ${escapeHtml(eventFieldLabel(job) || "Field not recorded")}</small>
  	                </div>
  	                <div class="jel-row">
  	                  <button class="jel-btn" type="button" data-jel-track-print disabled>Print Report</button>
  	                  <button class="jel-btn" type="button" data-jel-track-close>Close</button>
  	                </div>
  	                </header>
  	                <div class="jel-track-body">
  	                  <div class="jel-track-map-wrap">
  	                    <div class="jel-track-map" data-jel-track-map></div>
  	                    <div class="jel-track-state" data-jel-track-state>Checking saved tracking evidence…</div>
  	                    <div class="jel-track-legend">
  	                      <span><i style="background:#58d68d"></i>Actual In</span>
  	                      <span><i style="background:#FFFF00"></i>Normal</span>
  	                      <span><i style="background:#00FF00"></i>Green Band</span>
  	                      <span><i style="background:#FF0000"></i>Exception</span>
  	                      <span><i style="background:#f39c4a"></i>Actual Out</span>
  	                      <span><i data-jel-boundary-swatch style="background:#ff8a3c"></i>Location Boundary</span>
  	                    </div>
  	                  </div>
  	                  <aside class="jel-track-side" data-jel-track-summary>
  	                    <div class="jel-track-card">
  	                      <span>Tracking History</span>
  	                      <strong>Checking saved reconciliation…</strong>
  	                      <small>The live search extends 5 minutes before and after the recorded times, then recalculates the Job from the actual boundary crossings.</small>
  	                    </div>
  	                  </aside>
  	                </div>`;

  	                mount.appendChild(trackWindow);
  	                makeTrackingWindowDraggable(trackWindow);

  	                const closeButton = trackWindow.querySelector("[data-jel-track-close]");
  	                const printButton = trackWindow.querySelector("[data-jel-track-print]");
  	                const summary = trackWindow.querySelector("[data-jel-track-summary]");
  	                const stateNode = trackWindow.querySelector("[data-jel-track-state]");

  	                closeButton.addEventListener("click", () => trackWindow.remove());
  	                printButton.addEventListener("click", () => printEventTrackingReport(trackWindow));

  	                function renderReconciledContext(context, cacheNote) {
  	                  if (!trackWindow.isConnected) return;

  	                  const analysis = context.analysis;
  	                  const range = context.correctedRange;
  	                  const recordedFrom = Number(searchRange.recordedFrom);
  	                  const recordedTo = Number(searchRange.recordedTo);
  	                  const entryVarianceSeconds = Math.round((range.from - recordedFrom) / 1000);
  	                  const exitVarianceSeconds = Math.round((range.to - recordedTo) / 1000);

  	                  trackWindow.__eventTrackingContext = {
  	                    job,
  	                    vehicle,
  	                    range,
  	                    searchRange,
  	                    points: context.points,
  	                    searchPoints: context.searchPoints || context.points,
  	                    analysis,
  	                    boundary: context.boundary || eventTrackingBoundaryGeometry(job),
  	                    source: context.source || "",
  	                    payload: context.payload || null,
  	                    cache: context.cache || null,
  	                    error: ""
  	                  };

  	                  summary.innerHTML = `
  	                  <div class="jel-track-card">
  	                    <span>Location</span>
  	                    <strong>${escapeHtml(eventLocationDisplayLabel(job))}</strong>
  	                    <small>Field: ${escapeHtml(eventFieldLabel(job) || "Not recorded")}</small>
  	                  </div>
  	                  <div class="jel-track-card">
  	                    <span>Corrected Event Window</span>
  	                    <strong>${escapeHtml(formatTrackingDuration(analysis.durationSeconds))}</strong>
  	                    <small>${escapeHtml(new Date(range.from).toLocaleTimeString())} actual entry → ${escapeHtml(new Date(range.to).toLocaleTimeString())} actual exit</small>
  	                  </div>
  	                  <div class="jel-track-grid">
  	                    <div class="jel-track-card"><span>GPS Points</span><strong>${escapeHtml(String(context.points.length))}</strong><small>${escapeHtml(context.source || "Tracking history")}</small></div>
  	                    <div class="jel-track-card"><span>Distance</span><strong>${escapeHtml((analysis.distance / 1000).toFixed(2))} km</strong><small>Boundary-to-boundary GPS path</small></div>
  	                    <div class="jel-track-card"><span>Moving</span><strong>${escapeHtml(formatTrackingDuration(analysis.movingSeconds))}</strong><small>Within corrected event</small></div>
  	                    <div class="jel-track-card"><span>Stopped</span><strong>${escapeHtml(formatTrackingDuration(analysis.stoppedSeconds))}</strong><small>Within corrected event</small></div>
  	                  </div>
  	                  <div class="jel-track-card">
  	                    <span>Recorded vs Actual</span>
  	                    <strong>In ${entryVarianceSeconds >= 0 ? "+" : ""}${escapeHtml(String(entryVarianceSeconds))}s · Out ${exitVarianceSeconds >= 0 ? "+" : ""}${escapeHtml(String(exitVarianceSeconds))}s</strong>
  	                    <small>Recorded ${escapeHtml(new Date(recordedFrom).toLocaleTimeString())} → ${escapeHtml(new Date(recordedTo).toLocaleTimeString())}</small>
  	                  </div>
  	                  <div class="jel-track-card">
  	                    <span>Speed</span>
  	                    <strong>${analysis.averageSpeed === null ? "Not reported" : escapeHtml(analysis.averageSpeed.toFixed(1) + " km/h average")}</strong>
  	                    <small>${analysis.maxSpeed === null ? "Tracker did not report speed" : escapeHtml(analysis.maxSpeed.toFixed(1) + " km/h maximum")}</small>
  	                  </div>
  	                  <div class="jel-track-card">
  	                    <span>Boundary Evidence</span>
  	                    <strong>${analysis.first ? escapeHtml(new Date(analysis.first.timestamp).toLocaleString()) : "No entry crossing"}</strong>
  	                    <small>${analysis.last ? escapeHtml("Exit " + new Date(analysis.last.timestamp).toLocaleString()) : "No exit crossing"}${cacheNote ? " · " + escapeHtml(cacheNote) : ""}</small>
  	                  </div>`;

  	                  renderEventTrackingMap(trackWindow, context.points, range);
  	                  if (stateNode) stateNode.hidden = true;
  	                  printButton.disabled = false;
  	                }

  	                const cached = eventTrackingContextFromCache(job, searchRange);
  	                if (cached) {
  	                  renderReconciledContext(cached, "Hot loaded from JobEntries");
  	                  return;
  	                }

  	                try {
  	                  if (stateNode) {
  	                    stateNode.hidden = false;
  	                    stateNode.textContent =
  	                      `Loading tracker history from ${new Date(searchRange.from).toLocaleTimeString()} to ${new Date(searchRange.to).toLocaleTimeString()} (5 minute padding on each side)…`;
  	                  }

  	                  const loaded = await loadEventTracking(vehicle, searchRange);
  	                  if (!trackWindow.isConnected) return;

  	                  const searchPoints = normaliseTrackingPoints(loaded.rows, searchRange, vehicle);
  	                  const reconciliation = reconcileEventTracking(job, searchPoints, searchRange);

  	                  if (!reconciliation.ok) {
  	                    const rawAnalysis = analyseEventTracking(searchPoints, searchRange);
  	                    trackWindow.__eventTrackingContext = {
  	                      job,
  	                      vehicle,
  	                      range: searchRange,
  	                      searchRange,
  	                      points: searchPoints,
  	                      searchPoints,
  	                      analysis: rawAnalysis,
  	                      boundary: reconciliation.boundary,
  	                      source: loaded.source,
  	                      payload: loaded.payload,
  	                      error: reconciliation.reason
  	                    };

  	                    summary.innerHTML = `
  	                    <div class="jel-track-card"><span>Location</span><strong>${escapeHtml(eventLocationDisplayLabel(job))}</strong><small>Field: ${escapeHtml(eventFieldLabel(job) || "Not recorded")}</small></div>
  	                    <div class="jel-track-card"><span>Boundary Reconciliation</span><strong>Review required</strong><small>${escapeHtml(reconciliation.reason)}</small></div>
  	                    <div class="jel-track-card"><span>Padded Search Window</span><strong>${escapeHtml(formatTrackingDuration((searchRange.to - searchRange.from) / 1000))}</strong><small>${escapeHtml(new Date(searchRange.from).toLocaleTimeString())} → ${escapeHtml(new Date(searchRange.to).toLocaleTimeString())} · ${escapeHtml(String(searchPoints.length))} GPS points</small></div>`;

  	                    renderEventTrackingMap(trackWindow, searchPoints, searchRange);
  	                    printButton.disabled = false;
  	                    return;
  	                  }

  	                  const evidence = eventTrackingEvidenceFromReconciliation(
  	                    job,
  	                    loaded,
  	                    searchPoints,
  	                    reconciliation
  	                  );

  	                  let persistence = { cacheSaved: false, cacheField: "" };
  	                  try {
  	                    persistence = await saveEventTrackingReconciliation(job, evidence, reconciliation);
  	                  } catch (saveError) {
  	                    console.error("Event tracking reconciliation save failed:", saveError);
  	                  }

  	                  if (!trackWindow.isConnected) return;

  	                  renderEvents();

  	                  renderReconciledContext({
  	                    points: reconciliation.routePoints,
  	                    searchPoints,
  	                    analysis: reconciliation.analysis,
  	                    correctedRange: reconciliation.correctedRange,
  	                    boundary: reconciliation.boundary,
  	                    source: persistence.cacheSaved
  	                      ? `${loaded.source} · saved to ${persistence.cacheField}`
  	                      : `${loaded.source} · Job corrected; tracking JSON cache not persisted`,
  	                    payload: loaded.payload,
  	                    cache: evidence
  	                  }, persistence.cacheSaved ? "Saved for hot load" : "Tracking cache save needs a JSON field");

  	                } catch (error) {
  	                  if (!trackWindow.isConnected) return;

  	                  const message = safeString(error?.message || error?.faultString || "Event tracking history could not be loaded.");
  	                  const analysis = analyseEventTracking([], searchRange);

  	                  trackWindow.__eventTrackingContext = {
  	                    job,
  	                    vehicle,
  	                    range: searchRange,
  	                    searchRange,
  	                    points: [],
  	                    searchPoints: [],
  	                    analysis,
  	                    boundary: eventTrackingBoundaryGeometry(job),
  	                    source: "",
  	                    error: message
  	                  };

  	                  if (stateNode) {
  	                    stateNode.hidden = false;
  	                    stateNode.textContent = "Hybrid Google Maps is ready; the route will appear when tracker history is connected.";
  	                  }

  	                  summary.innerHTML = `
  	                    <div class="jel-track-card"><span>Tracking Unavailable</span><strong>History request did not complete</strong><small>${escapeHtml(message)}</small></div>
  	                    <div class="jel-track-card"><span>Requested Search Window</span><strong>${escapeHtml(new Date(searchRange.from).toLocaleString())}</strong><small>to ${escapeHtml(new Date(searchRange.to).toLocaleString())} · includes ±5 minute padding</small></div>`;

  	                  renderEventTrackingMap(trackWindow, [], searchRange);
  	                  printButton.disabled = false;
  	                }
  	              }

  	              function sortEvents(events) {
  	                return events.slice().sort((a, b) => {
  	                  const aDate = asDate(getBestTimeIn(a) || getBestTimeOut(a) || getBestDate(a));
  	                  const bDate = asDate(getBestTimeIn(b) || getBestTimeOut(b) || getBestDate(b));

  	                  const aTime = aDate ? aDate.getTime(): 0;
  	                  const bTime = bDate ? bDate.getTime(): 0;

  	                  return bTime - aTime;
  	                });
  	              }

  	              async function loadEvents() {
  	                const periodKey = clean(
  	                  requestedPeriod === undefined
  	                    ? fifSelectedVehicleEventPeriodKey(vehicle)
  	                    : requestedPeriod
  	                );

  	                const matchesVehicleAndPeriod = function (job) {
  	                  if (!fifLocationJobMatchesVehicle(job, vehicle)) return false;
  	                  if (!periodKey) return true;
  	                  return fifLocationEventPeriodKey(job) === periodKey;
  	                };

  	                try {
  	                  const databaseRows = await fifHydrateCompanyLocationEvents(eventCompany, true);
  	                  const jobs = (Array.isArray(databaseRows) ? databaseRows : []).filter(matchesVehicleAndPeriod);

  	                  return {
  	                    ok: true,
  	                    jobs,
  	                    source: periodKey
  	                      ? "JobEntries.Vehicle · " + periodKey
  	                      : "JobEntries.Vehicle"
  	                  };
  	                } catch (error) {
  	                  const fallbackRows = fifPreloadedCompanyJobEntries(eventCompany).filter(matchesVehicleAndPeriod);

  	                  if (fallbackRows.length) {
  	                    return {
  	                      ok: true,
  	                      jobs: fallbackRows,
  	                      source: periodKey
  	                        ? "Preloaded JobEntries.Vehicle · " + periodKey
  	                        : "Preloaded JobEntries.Vehicle"
  	                    };
  	                  }

  	                  return {
  	                    ok: false,
  	                    jobs: [],
  	                    reason: safeString(error?.message || error?.faultString || "Vehicle JobEntries query failed")
  	                  };
  	                }
  	              }

  	              function eventMatchesSearch(job, query) {
  	                if (!query) return true;

  	                const blob = [
  	                  getBestDate(job),
  	                  eventLocationDisplayLabel(job),
  	                  eventFieldLabel(job),
  	                  buildEventText(job),
  	                  buildProductText(job),
  	                  getContractorText(job),
  	                  getDriverText(job),
  	                  getVehicleText(job),
  	                  formatTime(getBestTimeIn(job)),
  	                  formatTime(getBestTimeOut(job)),
  	                  formatDuration(getBestDuration(job)),
  	                  safeString(getBestArea(job) || "")
  	                ].join(" ").toLowerCase();

  	                return blob.includes(query);
  	              }

  	              function renderRows(jobs, query) {
  	                const visible = sortEvents(jobs).filter(job => eventMatchesSearch(job, query));

  	                if (!visible.length) {
  	                  return `
  	                  <div class="jel-empty">
  	                  ${query ? "No matching jobs found.": "No jobs found for this vehicle."}
  	                  </div>
  	                  `;
  	                }

  	                return `
  	                <div class="jel-tablewrap">
  	                <table class="jel-table">
  	                <colgroup>
  	                <col style="width:6.5%"><col style="width:7.5%"><col style="width:7.5%"><col style="width:4%"><col style="width:7%">
  	                <col style="width:7%"><col style="width:5.5%"><col style="width:7%"><col style="width:7%">
  	                <col style="width:7%"><col style="width:4%"><col style="width:5.5%"><col style="width:5.5%">
  	                <col style="width:5%"><col style="width:6%"><col style="width:10%">
  	                </colgroup>
  	                <thead>
  	                <tr>
  	                <th>Date</th>
  	                <th>Location</th>
  	                <th>Field</th>
  	                <th>Area</th>
  	                <th>Event</th>
  	                <th>Product</th>
  	                <th>Rate</th>
  	                <th>Contractor</th>
  	                <th>Driver</th>
  	                <th>Tractor</th>
  	                <th>Fuel</th>
  	                <th>Time In</th>
  	                <th>Time Out</th>
  	                <th>Duration</th>
  	                <th>Tracking</th>
  	                <th>Actions</th>
  	                </tr>
  	                </thead>

  	                <tbody>
  	                ${visible.map((job, index) => {
  	                  const eventInfo = buildMultilineEvent(job);
  	                  const products = buildMultilineProducts(job);
  	                  const rates = buildMultilineRates(job);
  	                  const area = getBestArea(job);
  	                  const duration = getBestDuration(job);
  	                  const range = eventTrackingRange(job);
  	                  const eventVehicle = resolveEventVehicle(job);
  	                  const routeAvailable = !!range && !!eventVehicle && !!trackerIdOf(eventVehicle);
  	                  const routeReason = !range
  	                    ? "Time In and Time Out are required"
  	                    : !eventVehicle
  	                      ? "Event vehicle could not be matched"
  	                      : !trackerIdOf(eventVehicle)
  	                        ? "Vehicle has no tracker assigned"
  	                        : eventTrackingCache(job)
  	                          ? "Open saved boundary-reconciled tracking evidence"
  	                          : "Load tracker history, find actual boundary crossings and save the reconciled Job";

  	                  return `
  	                  <tr>
  	                  <td class="jel-compact">
  	                  <div class="${getBestDate(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getBestDate(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td class="jel-compact">
  	                  <div class="${eventLocationDisplayLabel(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(eventLocationDisplayLabel(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td class="jel-compact">
  	                  <div class="${eventFieldLabel(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(eventFieldLabel(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <div class="${area === null ? "jel-muted jel-num": "jel-num"}">
  	                  ${area === null ? "-": escapeHtml(Number(area).toFixed(2))}
  	                  </div>
  	                  </td>

  	                  <td>${bigSmall(eventInfo.headline, eventInfo.extras)}</td>

  	                  <td>${smallLines(products)}</td>

  	                  <td>${smallLines(rates)}</td>

  	                  <td>
  	                  <div class="${getContractorText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getContractorText(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td class="jel-compact">
  	                  <div class="${getDriverText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getDriverText(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td class="jel-compact">
  	                  <div class="${getVehicleText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getVehicleText(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td class="jel-compact">
  	                  <div class="${getFuelText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getFuelText(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td class="jel-compact">
  	                  <div class="${formatTime(getBestTimeIn(job)) ? "jel-num": "jel-muted jel-num"}">
  	                  ${escapeHtml(formatTime(getBestTimeIn(job)) || "-")}
  	                  </div>
  	                  </td>

  	                  <td class="jel-compact">
  	                  <div class="${formatTime(getBestTimeOut(job)) ? "jel-num": "jel-muted jel-num"}">
  	                  ${escapeHtml(formatTime(getBestTimeOut(job)) || "-")}
  	                  </div>
  	                  </td>

  	                  <td class="jel-compact">
  	                  <div class="${duration === null ? "jel-muted jel-num": "jel-num"}">
  	                  ${escapeHtml(duration === null ? "-": formatDuration(duration))}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <button class="jel-btn jel-btn-route" type="button" data-tem-route-index="${index}" title="${escapeHtml(routeReason)}" ${routeAvailable ? "" : "disabled"}>
  	                  ${routeAvailable ? "View Route" : "Unavailable"}
  	                  </button>
  	                  </td>

  	                  <td>
  	                  <div class="jel-actions-cell">
  	                  <button class="jel-btn" type="button" data-tem-edit-index="${index}">Edit Products / Rates</button>
  	                  </div>
  	                  </td>
  	                  </tr>
  	                  `;
  	                }).join("")}
  	                </tbody>
  	                </table>
  	                </div>
  	                `;
  	              }

  	              function jobEntryObjectId(job) {
  	                return safeString(
  	                  job?.objectId ||
  	                  job?.ObjectId ||
  	                  job?.objectID ||
  	                  job?.id ||
  	                  job?.ID ||
  	                  ""
  	                ).trim();
  	              }

  	              function cloneEventApplication(value) {
  	                if (!value || typeof value !== "object" || Array.isArray(value)) return {};

  	                try {
  	                  return JSON.parse(JSON.stringify(value));
  	                } catch (_) {
  	                  return Object.assign({}, value);
  	                }
  	              }

  	              function rawApplicationsForEdit(job) {
  	                let source = firstEventValue(job, [
  	                  "Applications",
  	                  "applications",
  	                  "Application",
  	                  "application",
  	                  "Data.Applications",
  	                  "data.applications"
  	                ]);

  	                if (typeof source === "string") {
  	                  const raw = source.trim();

  	                  if (raw.startsWith("[") || raw.startsWith("{")) {
  	                    try {
  	                      source = JSON.parse(raw);
  	                    } catch (_) {
  	                      source = [];
  	                    }
  	                  }
  	                }

  	                if (Array.isArray(source)) {
  	                  return source.map(item => {
  	                    if (item && typeof item === "object") return cloneEventApplication(item);
  	                    const text = safeString(item).trim();
  	                    return text ? { Product: text, RateText: "" }: {};
  	                  });
  	                }

  	                if (source && typeof source === "object") {
  	                  return [cloneEventApplication(source)];
  	                }

  	                return [];
  	              }

  	              const EVENT_PRODUCT_KEYS = [
  	                "Product", "product", "Crop", "crop", "Material", "material", "Description", "description"
  	              ];

  	              const EVENT_RATE_KEYS = [
  	                "RateText", "rateText", "Rate", "rate", "QuantityText", "quantityText", "Quantity", "quantity"
  	              ];

  	              function applicationProductValue(application) {
  	                return pick(application, EVENT_PRODUCT_KEYS);
  	              }

  	              function applicationRateValue(application) {
  	                return pick(application, EVENT_RATE_KEYS);
  	              }

  	              function applicationContextLabel(application, index) {
  	                const type = pick(application, ["Type", "type", "ApplicationType", "applicationType", "Action", "action", "Event", "event"]);
  	                const asset = pick(application, [
  	                  "Registration", "registration", "VehicleRegistration", "vehicleRegistration",
  	                  "Trailer", "trailer", "TrailerRegistration", "trailerRegistration", "Implement", "implement"
  	                ]);

  	                if (type && asset) return `${type} - ${asset}`;
  	                if (asset) return asset;
  	                if (type) return type;

  	                return `Additional Product / Rate ${index + 1}`;
  	              }

  	              function applicationHasNonProductRateData(application) {
  	                if (!application || typeof application !== "object") return false;

  	                const excluded = new Set(EVENT_PRODUCT_KEYS.concat(EVENT_RATE_KEYS));

  	                return Object.keys(application).some(key => {
  	                  if (excluded.has(key)) return false;

  	                  const value = application[key];

  	                  if (value === undefined || value === null) return false;
  	                  if (typeof value === "string") return !!value.trim();
  	                  if (Array.isArray(value)) return value.length > 0;
  	                  if (typeof value === "object") return Object.keys(value).length > 0;

  	                  return true;
  	                });
  	              }

  	              function writeApplicationProductRate(application, product, rate) {
  	                const output = cloneEventApplication(application);
  	                const cleanProduct = safeString(product).trim();
  	                const cleanRate = safeString(rate).trim();

  	                EVENT_PRODUCT_KEYS.forEach(key => {
  	                  if (Object.prototype.hasOwnProperty.call(output, key)) {
  	                    output[key] = cleanProduct;
  	                  }
  	                });

  	                EVENT_RATE_KEYS.forEach(key => {
  	                  if (Object.prototype.hasOwnProperty.call(output, key)) {
  	                    output[key] = cleanRate;
  	                  }
  	                });

  	                output.Product = cleanProduct;
  	                output.RateText = cleanRate;

  	                return output;
  	              }

  	              function closeEventsActionModal() {
  	                const modal = mount?.querySelector("[data-jel-action-modal]");

  	                if (modal) modal.remove();
  	              }

  	              function createEventsActionModal() {
  	                closeEventsActionModal();

  	                const modal = document.createElement("div");
  	                modal.className = "jel-action-modal";
  	                modal.setAttribute("data-jel-action-modal", "");

  	                modal.addEventListener("mousedown", event => {
  	                  if (event.target === modal) closeEventsActionModal();
  	                });

  	                mount.appendChild(modal);
  	                return modal;
  	              }

  	              function saveJobProductsAndRates(job, applications) {
  	                if (!hasBackendlessData()) {
  	                  return Promise.reject(new Error("The Database connection is unavailable."));
  	                }

  	                const objectId = jobEntryObjectId(job);

  	                if (!objectId) {
  	                  return Promise.reject(new Error("This Job Entry has no objectId and cannot be edited."));
  	                }

  	                const store = Backendless.Data.of(TABLE_JOB_ENTRIES);

  	                if (!store || typeof store.save !== "function") {
  	                  return Promise.reject(new Error("The JobEntries save function is unavailable."));
  	                }

  	                return store.save({
  	                  objectId,
  	                  Applications: applications
  	                });
  	              }

  	              function openJobProductsEditor(job) {
  	                const objectId = jobEntryObjectId(job);

  	                if (!objectId) {
  	                  window.alert("This Job Entry has no objectId and cannot be edited.");
  	                  return;
  	                }

  	                const originalApplications = rawApplicationsForEdit(job);
  	                const editorRows = originalApplications.map((application, index) => ({
  	                  raw: cloneEventApplication(application),
  	                  product: applicationProductValue(application),
  	                  rate: applicationRateValue(application),
  	                  removed: false,
  	                  added: false,
  	                  key: `existing-${index}-${Date.now()}`
  	                }));

  	                if (!editorRows.length) {
  	                  editorRows.push({
  	                    raw: {},
  	                    product: "",
  	                    rate: "",
  	                    removed: false,
  	                    added: true,
  	                    key: `added-${Date.now()}-0`
  	                  });
  	                }

  	                const modal = createEventsActionModal();
  	                let saving = false;

  	                function visibleRows() {
  	                  return editorRows.filter(row => !row.removed);
  	                }

  	                function renderEditor() {
  	                  const rows = visibleRows();
  	                  const eventInfo = buildMultilineEvent(job);
  	                  const jobLabel = [
  	                    getBestDate(job),
  	                    eventInfo.headline,
  	                    getVehicleText(job)
  	                  ].filter(Boolean).join(" · ") || objectId;

  	                  modal.innerHTML = `
  	                  <div class="jel-action-panel" role="dialog" aria-modal="true" aria-label="Edit Job Products and Rates">
  	                  <div class="jel-action-head">
  	                  <div>
  	                  <div class="jel-action-title">Edit Products and Rates</div>
  	                  <div class="jel-action-sub">${escapeHtml(jobLabel)}<br>Only Product and Rate values can be changed here.</div>
  	                  </div>
  	                  <button class="jel-btn" type="button" data-jel-modal-close ${saving ? "disabled": ""}>✖ Close</button>
  	                  </div>

  	                  <div class="jel-action-body">
  	                  <div class="jel-editor-list">
  	                  ${rows.length ? rows.map((row, visibleIndex) => {
  	                    const actualIndex = editorRows.indexOf(row);
  	                    return `
  	                    <div class="jel-editor-row">
  	                    <div class="jel-editor-row-head">
  	                    <div class="jel-editor-context">${escapeHtml(applicationContextLabel(row.raw, visibleIndex))}</div>
  	                    <button class="jel-btn jel-btn-danger" type="button" data-jel-remove-line="${actualIndex}" ${saving ? "disabled": ""}>Remove</button>
  	                    </div>
  	                    <div class="jel-editor-grid">
  	                    <label>
  	                    <span class="jel-field-label">Product</span>
  	                    <input class="jel-field-input" type="text" value="${escapeHtml(row.product)}" data-jel-product="${actualIndex}" placeholder="Product" ${saving ? "disabled": ""}>
  	                    </label>
  	                    <label>
  	                    <span class="jel-field-label">Rate</span>
  	                    <input class="jel-field-input" type="text" value="${escapeHtml(row.rate)}" data-jel-rate="${actualIndex}" placeholder="Rate" ${saving ? "disabled": ""}>
  	                    </label>
  	                    </div>
  	                    </div>
  	                    `;
  	                  }).join(""): '<div class="jel-empty">No Product / Rate lines. Add a new line below.</div>'}
  	                  </div>

  	                  <div class="jel-editor-tools">
  	                  <button class="jel-btn jel-btn-primary" type="button" data-jel-add-line ${saving ? "disabled": ""}>+ Add Product / Rate</button>
  	                  </div>

  	                  <div class="jel-action-error" data-jel-editor-error></div>
  	                  </div>

  	                  <div class="jel-action-foot">
  	                  <button class="jel-btn" type="button" data-jel-modal-close ${saving ? "disabled": ""}>Cancel</button>
  	                  <button class="jel-btn jel-btn-primary" type="button" data-jel-save-products ${saving ? "disabled": ""}>${saving ? "Saving...": "Save Products and Rates"}</button>
  	                  </div>
  	                  </div>
  	                  `;

  	                  modal.querySelectorAll("[data-jel-modal-close]").forEach(button => {
  	                    button.addEventListener("click", closeEventsActionModal);
  	                  });

  	                  modal.querySelectorAll("[data-jel-product]").forEach(input => {
  	                    input.addEventListener("input", () => {
  	                      const index = Number(input.getAttribute("data-jel-product"));
  	                      if (editorRows[index]) editorRows[index].product = input.value;
  	                    });
  	                  });

  	                  modal.querySelectorAll("[data-jel-rate]").forEach(input => {
  	                    input.addEventListener("input", () => {
  	                      const index = Number(input.getAttribute("data-jel-rate"));
  	                      if (editorRows[index]) editorRows[index].rate = input.value;
  	                    });
  	                  });

  	                  modal.querySelectorAll("[data-jel-remove-line]").forEach(button => {
  	                    button.addEventListener("click", () => {
  	                      const index = Number(button.getAttribute("data-jel-remove-line"));
  	                      if (!editorRows[index]) return;
  	                      editorRows[index].removed = true;
  	                      renderEditor();
  	                    });
  	                  });

  	                  modal.querySelector("[data-jel-add-line]")?.addEventListener("click", () => {
  	                    editorRows.push({
  	                      raw: {},
  	                      product: "",
  	                      rate: "",
  	                      removed: false,
  	                      added: true,
  	                      key: `added-${Date.now()}-${editorRows.length}`
  	                    });
  	                    renderEditor();
  	                    setTimeout(() => {
  	                      const inputs = modal.querySelectorAll("[data-jel-product]");
  	                      inputs[inputs.length - 1]?.focus?.();
  	                    }, 20);
  	                  });

  	                  modal.querySelector("[data-jel-save-products]")?.addEventListener("click", async () => {
  	                    if (saving) return;

  	                    const incomplete = visibleRows().find(row => {
  	                      const product = safeString(row.product).trim();
  	                      const rate = safeString(row.rate).trim();
  	                      return (product && !rate) || (!product && rate);
  	                    });

  	                    const errorEl = modal.querySelector("[data-jel-editor-error]");

  	                    if (incomplete) {
  	                      if (errorEl) {
  	                        errorEl.textContent = "Every Product line must also have a Rate, and every Rate must also have a Product.";
  	                        errorEl.classList.add("visible");
  	                      }
  	                      return;
  	                    }

  	                    const updatedApplications = [];

  	                    editorRows.forEach(row => {
  	                      const product = safeString(row.product).trim();
  	                      const rate = safeString(row.rate).trim();
  	                      const keepStructure = applicationHasNonProductRateData(row.raw);

  	                      if (row.removed || (!product && !rate)) {
  	                        if (keepStructure) {
  	                          updatedApplications.push(writeApplicationProductRate(row.raw, "", ""));
  	                        }
  	                        return;
  	                      }

  	                      updatedApplications.push(writeApplicationProductRate(row.raw, product, rate));
  	                    });

  	                    saving = true;
  	                    renderEditor();

  	                    try {
  	                      const saved = await saveJobProductsAndRates(job, updatedApplications);

  	                      job.Applications = updatedApplications;

  	                      if (saved && typeof saved === "object") {
  	                        Object.assign(job, saved);
  	                        job.Applications = updatedApplications;
  	                      }

  	                      closeEventsActionModal();
  	                      renderEvents();
  	                      statusEl.textContent = "Products and Rates saved";
  	                    } catch (error) {
  	                      saving = false;
  	                      renderEditor();
  	                      const currentError = modal.querySelector("[data-jel-editor-error]");
  	                      if (currentError) {
  	                        currentError.textContent = safeString(error?.message || error?.faultString || "The Products and Rates could not be saved.");
  	                        currentError.classList.add("visible");
  	                      }
  	                    }
  	                  });
  	                }

  	                renderEditor();
  	              }





  	              function openEventsPrintWindow() {
  	                try {
  	                  const query = safeString(searchInput?.value || "").trim().toLowerCase();
  	                  const visibleJobs = sortEvents(loadedJobs).filter(job => eventMatchesSearch(job, query));

  	                  if (!visibleJobs.length) {
  	                    window.alert(query
  	                      ? "There are no matching Job Events to print."
  	                      : "There are no Job Events to print.");
  	                    return;
  	                  }

  	                  const printWindow = window.open("", "_blank", "width=1500,height=950");

  	                  if (!printWindow) {
  	                    window.alert("The Job Events print window was blocked by the browser.");
  	                    return;
  	                  }

  	                  const reportCompany = eventCompany;

  	                  const companyLabel = safeString(
  	                    reportCompany ? getCompanyName(reportCompany) : ""
  	                  ).trim();

  	                  const locationTypeLabel = "Multiple Locations";
  	                  const locationReference = clean(firstValue([
  	                    vehicleRegistrationValue(vehicle),
  	                    fifVehicleIdentityValue(vehicle, "FID", ""),
  	                    vehicle && vehicle.ID,
  	                    objectIdOf(vehicle)
  	                  ], ""));

  	                  const generatedAt = new Date().toLocaleString();
  	                  const dates = visibleJobs
  	                    .map(job => getBestDate(job))
  	                    .filter(Boolean)
  	                    .sort();

  	                  const firstDate = dates.length ? dates[0] : "";
  	                  const lastDate = dates.length ? dates[dates.length - 1] : "";
  	                  const periodLabel = firstDate && lastDate
  	                    ? (firstDate === lastDate ? firstDate : `${firstDate} to ${lastDate}`)
  	                    : "Not recorded";

  	                  let totalFuel = 0;
  	                  let fuelRecordCount = 0;
  	                  let totalDurationSeconds = 0;
  	                  let durationRecordCount = 0;
  	                  let productLineCount = 0;
  	                  let rateLineCount = 0;

  	                  visibleJobs.forEach(job => {
  	                    const fuel = calculateFuelUsed(job);
  	                    const duration = getBestDuration(job);

  	                    if (fuel !== null && Number.isFinite(Number(fuel))) {
  	                      totalFuel += Number(fuel);
  	                      fuelRecordCount += 1;
  	                    }

  	                    if (duration !== null && Number.isFinite(Number(duration))) {
  	                      totalDurationSeconds += Number(duration);
  	                      durationRecordCount += 1;
  	                    }

  	                    productLineCount += buildMultilineProducts(job).length;
  	                    rateLineCount += buildMultilineRates(job).length;
  	                  });

  	                  function printDash(value) {
  	                    const textValue = safeString(value).trim();
  	                    return escapeHtml(textValue || "—");
  	                  }

  	                  function printStack(lines) {
  	                    const cleanLines = Array.isArray(lines)
  	                      ? lines.map(line => safeString(line).trim()).filter(Boolean)
  	                      : [];

  	                    if (!cleanLines.length) return '<span class="muted">—</span>';

  	                    return '<div class="stack">' + cleanLines.map(line => {
  	                      return '<span>' + escapeHtml(line) + '</span>';
  	                    }).join("") + '</div>';
  	                  }

  	                  const rowsHtml = visibleJobs.map(job => {
  	                    const eventInfo = buildMultilineEvent(job);
  	                    const eventLines = [eventInfo.headline].concat(eventInfo.extras || []).filter(Boolean);
  	                    const products = buildMultilineProducts(job);
  	                    const rates = buildMultilineRates(job);
  	                    const locationName = eventLocationDisplayLabel(job);
  	                    const fieldName = eventFieldLabel(job);
  	                    const area = getBestArea(job);
  	                    const fuel = calculateFuelUsed(job);
  	                    const duration = getBestDuration(job);
  	                    const timeIn = formatTime(getBestTimeIn(job));
  	                    const timeOut = formatTime(getBestTimeOut(job));

  	                    return ''
  	                      + '<tr>'
  	                      + '<td class="nowrap">' + printDash(getBestDate(job)) + '</td>'
  	                      + '<td>' + printDash(locationName) + '</td>'
  	                      + '<td>' + printDash(fieldName) + '</td>'
  	                      + '<td class="num">' + (area === null ? '<span class="muted">—</span>' : escapeHtml(Number(area).toFixed(2))) + '</td>'
  	                      + '<td>' + printStack(eventLines) + '</td>'
  	                      + '<td>' + printStack(products) + '</td>'
  	                      + '<td>' + printStack(rates) + '</td>'
  	                      + '<td>' + printDash(getContractorText(job)) + '</td>'
  	                      + '<td>' + printDash(getDriverText(job)) + '</td>'
  	                      + '<td>' + printDash(getVehicleText(job)) + '</td>'
  	                      + '<td class="num">' + (fuel === null ? '<span class="muted">—</span>' : escapeHtml(Number(fuel).toFixed(2))) + '</td>'
  	                      + '<td class="num nowrap">' + printDash(timeIn) + '</td>'
  	                      + '<td class="num nowrap">' + printDash(timeOut) + '</td>'
  	                      + '<td class="num nowrap">' + (duration === null ? '<span class="muted">—</span>' : escapeHtml(formatDuration(duration))) + '</td>'
  	                      + '</tr>';
  	                  }).join("");

  	                  const reportTitle = "Vehicle Job Events Report";
  	                  const reportBrandAsset = resolveReportBrandAsset(REPORT_SVG_INPUT);
  	                  const reportBrandHtml = reportBrandAsset
  	                    ? '<img class="brand-logo" src="' + escapeHtml(reportBrandAsset) + '" alt="Fleet In Form">'
  	                    : '<div class="brand-mark">FIF</div>';
  	                  const filterLabel = query
  	                    ? `Filtered by: “${safeString(searchInput?.value || "").trim()}”`
  	                    : "Filter: None";

  	                  const html = ''
  	                    + '<!doctype html>'
  	                    + '<html>'
  	                    + '<head>'
  	                    + '<meta charset="utf-8">'
  	                    + '<meta name="viewport" content="width=device-width,initial-scale=1">'
  	                    + '<title>' + escapeHtml(reportTitle) + '</title>'
  	                    + '<style>'
  	                    + '*{box-sizing:border-box;}'
  	                    + 'html,body{margin:0;padding:0;background:#fff;color:#111827;font-family:Arial,Helvetica,sans-serif;}'
  	                    + 'body{padding:24px 28px 30px;font-size:11px;}'
  	                    + '.report-head{display:flex;justify-content:space-between;align-items:flex-start;gap:24px;border-bottom:3px solid #cc6633;padding-bottom:13px;margin-bottom:16px;}'
  	                    + '.brand{display:flex;align-items:center;gap:11px;}'
  	                    + '.brand-mark{width:58px;height:42px;border-radius:8px;background:#111827;color:#fff;display:grid;place-items:center;font-size:17px;font-weight:900;border:3px solid #cc6633;flex:0 0 auto;}'
  	                    + '.brand-logo{display:block;width:auto;height:48px;max-width:180px;object-fit:contain;object-position:left center;flex:0 0 auto;}'
  	                    + '.title{font-size:25px;line-height:1.05;margin:0;color:#111827;}'
  	                    + '.subtitle{font-size:12px;color:#4b5563;margin-top:5px;}'
  	                    + '.head-meta{text-align:right;font-size:11px;line-height:1.55;color:#374151;min-width:270px;}'
  	                    + '.head-meta strong{color:#111827;}'
  	                    + '.summary-grid{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:9px;margin:0 0 16px;}'
  	                    + '.summary-card{border:1px solid #d1d5db;border-radius:8px;background:#f9fafb;padding:10px 11px;min-height:64px;break-inside:avoid;}'
  	                    + '.summary-label{font-size:9px;color:#6b7280;text-transform:uppercase;letter-spacing:.06em;font-weight:700;}'
  	                    + '.summary-value{font-size:15px;color:#111827;font-weight:800;margin-top:6px;line-height:1.15;word-break:break-word;}'
  	                    + '.report-section-title{font-size:13px;font-weight:800;margin:0 0 8px;color:#111827;}'
  	                    + '.table-shell{border:1px solid #cbd5e1;border-radius:7px;overflow:hidden;}'
  	                    + 'table{width:100%;border-collapse:collapse;table-layout:fixed;}'
  	                    + 'thead{display:table-header-group;}'
  	                    + 'thead th{background:#111827;color:#fff;font-size:8px;text-transform:uppercase;letter-spacing:.045em;padding:8px 6px;border-right:1px solid #334155;text-align:left;vertical-align:bottom;}'
  	                    + 'thead th:last-child{border-right:0;}'
  	                    + 'tbody td{font-size:8.2px;color:#111827;padding:7px 6px;border-top:1px solid #d1d5db;border-right:1px solid #e5e7eb;vertical-align:top;overflow-wrap:anywhere;line-height:1.3;}'
  	                    + 'tbody td:last-child{border-right:0;}'
  	                    + 'tbody tr:nth-child(even){background:#f8fafc;}'
  	                    + '.stack{display:flex;flex-direction:column;gap:2px;}'
  	                    + '.stack span:first-child{font-weight:700;}'
  	                    + '.muted{color:#94a3b8;font-weight:400!important;}'
  	                    + '.num{text-align:right;font-variant-numeric:tabular-nums;}'
  	                    + '.nowrap{white-space:nowrap;}'
  	                    + '.footer{margin-top:12px;padding-top:9px;border-top:1px solid #d1d5db;color:#64748b;font-size:9px;display:flex;justify-content:space-between;gap:16px;}'
  	                    + '.print-action{position:fixed;top:14px;right:14px;border:0;border-radius:8px;background:#cc6633;color:#fff;font-weight:800;padding:9px 14px;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.18);}'
  	                    + '@page{size:A3 landscape;margin:8mm;}'
  	                    + '@media print{body{padding:0}.print-action{display:none!important}.summary-card,tr,td,th{break-inside:avoid;page-break-inside:avoid}.table-shell{overflow:visible;border-radius:0}.footer{position:static}}'
  	                    + '</style>'
  	                    + '</head>'
  	                    + '<body>'
  	                    + '<button class="print-action" type="button" onclick="window.print()">Print / PDF</button>'
  	                    + '<header class="report-head">'
  	                    + '<div class="brand">'
  	                    + reportBrandHtml
  	                    + '<div><h1 class="title">' + escapeHtml(reportTitle) + '</h1>'
  	                    + '<div class="subtitle">Permanent operational Job Events for ' + printDash(vehicleLabelForEvents) + '</div></div>'
  	                    + '</div>'
  	                    + '<div class="head-meta">'
  	                    + '<div><strong>Company:</strong> ' + printDash(companyLabel) + '</div>'
  	                    + '<div><strong>Vehicle:</strong> ' + printDash(vehicleLabelForEvents) + '</div>'
  	                    + '<div><strong>Registration / Reference:</strong> ' + printDash(locationReference) + '</div>'
  	                    + '<div><strong>Scope:</strong> ' + printDash(locationTypeLabel) + '</div>'
  	                    + '<div><strong>Generated:</strong> ' + escapeHtml(generatedAt) + '</div>'
  	                    + '<div><strong>' + escapeHtml(filterLabel) + '</strong></div>'
  	                    + '</div>'
  	                    + '</header>'
  	                    + '<section class="summary-grid">'
  	                    + '<div class="summary-card"><div class="summary-label">Vehicle</div><div class="summary-value">' + printDash(vehicleLabelForEvents) + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Job Events</div><div class="summary-value">' + escapeHtml(String(visibleJobs.length)) + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Period</div><div class="summary-value" style="font-size:12px">' + escapeHtml(periodLabel) + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Fuel Recorded</div><div class="summary-value">' + (fuelRecordCount ? escapeHtml(totalFuel.toFixed(2) + ' L') : '—') + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Total Duration</div><div class="summary-value">' + (durationRecordCount ? escapeHtml(formatDuration(totalDurationSeconds)) : '—') + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Product / Rate Lines</div><div class="summary-value">' + escapeHtml(productLineCount + ' / ' + rateLineCount) + '</div></div>'
  	                    + '</section>'
  	                    + '<div class="report-section-title">Job Event Register</div>'
  	                    + '<div class="table-shell">'
  	                    + '<table>'
  	                    + '<colgroup>'
  	                    + '<col style="width:6%"><col style="width:8%"><col style="width:8%"><col style="width:4%"><col style="width:12%">'
  	                    + '<col style="width:9%"><col style="width:8%"><col style="width:7%"><col style="width:7%">'
  	                    + '<col style="width:7%"><col style="width:4%"><col style="width:6%"><col style="width:6%"><col style="width:5%">'
  	                    + '</colgroup>'
  	                    + '<thead><tr>'
  	                    + '<th>Date</th><th>Location</th><th>Field</th><th>Area</th><th>Event</th><th>Product</th><th>Rate</th>'
  	                    + '<th>Contractor</th><th>Driver</th><th>Tractor</th><th>Fuel</th><th>Time In</th><th>Time Out</th><th>Duration</th>'
  	                    + '</tr></thead>'
  	                    + '<tbody>' + rowsHtml + '</tbody>'
  	                    + '</table>'
  	                    + '</div>'
  	                    + '<footer class="footer">'
  	                    + '<span>This report reflects the Job Events currently visible in the Vehicle Events table.</span>'
  	                    + '<span>Generated by Fleet In Form</span>'
  	                    + '</footer>'
  	                    + '<script>window.onload=function(){window.focus();setTimeout(function(){window.print();},250);};<\/script>'
  	                    + '</body>'
  	                    + '</html>';

  	                  printWindow.document.open();
  	                  printWindow.document.write(html);
  	                  printWindow.document.close();
  	                } catch (error) {

  	                  window.alert("The Job Events report could not be prepared: " + safeString(
  	                    error?.message || error?.faultString || error
  	                  ));
  	                }
  	              }

  	              injectEventsStyles();

  	              const mount = document.createElement("div");
  	              mount.id = EVENTS_MOUNT_ID;

  	              mount.innerHTML = `
  	              <div class="jel-root">
  	              <div class="jel-card">
  	              <header class="jel-head">
  	              <div>
  	              <span class="jel-kicker">Fleet In Form Vehicle Events</span>
  	              <div class="jel-title">Event Operations</div>
  	              <div class="jel-sub">${escapeHtml(vehicleLabelForEvents || "(No Vehicle)")} · Time In to Time Out tracking evidence</div>
  	              </div>
  	              <div class="jel-head-actions">
  	              <button class="jel-btn" type="button" data-tem-print>Print Report</button>
  	              <button class="jel-btn" type="button" data-tem-close>Close</button>
  	              </div>
  	              </header>

  	              <main class="jel-main">
  	              <div class="jel-actions">
  	              <div class="jel-actions-meta">
  	              <div class="jel-badge" data-tem-status>Loading events...</div>
  	              <div class="jel-sub" data-tem-source></div>
  	              </div>
  	              <button class="jel-btn jel-btn-primary" type="button" data-tem-refresh>Refresh Events</button>
  	              </div>

  	              <div class="jel-search-wrap">
  	              <input
  	              class="jel-search"
  	              type="text"
  	              placeholder="Search jobs, drivers, products, tractors, contractors, dates..."
  	              data-tem-search
  	              />
  	              </div>

  	              <div class="jel-divider"></div>

  	              <div class="jel-events-box" data-tem-body>
  	              <div class="jel-empty">Loading events...</div>
  	              </div>
  	              </main>
  	              </div>
  	              </div>
  	              `;

  	              document.body.appendChild(mount);

  	              const statusEl = mount.querySelector("[data-tem-status]");
  	              const bodyEl = mount.querySelector("[data-tem-body]");
  	              const searchInput = mount.querySelector("[data-tem-search]");
  	              const closeButton = mount.querySelector("[data-tem-close]");
  	              const refreshButton = mount.querySelector("[data-tem-refresh]");

  	              const printButton = mount.querySelector("[data-tem-print]");
  	              const sourceEl = mount.querySelector("[data-tem-source]");

  	              let loadedJobs = [];

  	              function currentVisibleJobs() {
  	                const query = safeString(searchInput?.value || "").trim().toLowerCase();
  	                return sortEvents(loadedJobs).filter(job => eventMatchesSearch(job, query));
  	              }

  	              function renderEvents() {
  	                const query = safeString(searchInput?.value || "").trim().toLowerCase();

  	                bodyEl.innerHTML = renderRows(loadedJobs, query);

  	                statusEl.textContent = loadedJobs.length
  	                ? `Loaded ${loadedJobs.length} event(s)`: "No events found";
  	              }

  	              function refreshEvents() {
  	                const periodKey = clean(
  	                  requestedPeriod === undefined
  	                    ? fifSelectedVehicleEventPeriodKey(vehicle)
  	                    : requestedPeriod
  	                );

  	                const cachedJobRows = fifVehicleStoredEventJobs(vehicle)
  	                  .concat(fifPreloadedCompanyJobEntries(eventCompany));

  	                const cachedSeen = Object.create(null);
  	                const cachedJobs = cachedJobRows.filter(function (job, index) {
  	                  if (!job || typeof job !== "object") return false;
  	                  if (!fifLocationJobMatchesVehicle(job, vehicle)) return false;
  	                  if (periodKey && fifLocationEventPeriodKey(job) !== periodKey) return false;

  	                  const key = clean(firstValue([
  	                    job.objectId,
  	                    job.ObjectId,
  	                    job.JobId,
  	                    job.DraftId,
  	                    "cached-" + index
  	                  ], "cached-" + index));

  	                  if (cachedSeen[key]) return false;
  	                  cachedSeen[key] = true;
  	                  return true;
  	                });

  	                loadedJobs = cachedJobs.slice();

  	                if (loadedJobs.length) {
  	                  renderEvents();
  	                  statusEl.textContent = `Loaded ${loadedJobs.length} event(s) · refreshing…`;
  	                } else {
  	                  statusEl.textContent = "Loading events...";
  	                  bodyEl.innerHTML = `<div class="jel-empty">Loading events...</div>`;
  	                }

  	                if (sourceEl) {
  	                  sourceEl.textContent = loadedJobs.length ? "Refreshing latest JobEntries…" : "";
  	                }

  	                refreshButton.disabled = true;

  	                loadEvents().then(result => {
  	                  loadedJobs = Array.isArray(result.jobs) ? result.jobs: [];

  	                  renderEvents();

  	                  if (sourceEl) {
  	                    sourceEl.textContent = result.source ? `Source: ${result.source}`: "";
  	                  }

  	                }).catch(error => {
  	                  if (!loadedJobs.length) {
  	                    statusEl.textContent = "Failed to load events";
  	                    bodyEl.innerHTML = `
  	                    <div class="jel-empty">
  	                    ${escapeHtml(error?.message || "Could not load events.")}
  	                    </div>
  	                    `;
  	                  } else {
  	                    statusEl.textContent = `Loaded ${loadedJobs.length} cached event(s)`;
  	                    if (sourceEl) sourceEl.textContent = "Latest refresh unavailable";
  	                  }
  	                }).finally(() => {
  	                  refreshButton.disabled = false;
  	                });
  	              }

  	              closeButton.addEventListener("click",
  	                () => {
  	                  mount.remove();
  	                });

  	              refreshButton.addEventListener("click",
  	                () => {
  	                  refreshEvents();
  	                });

  	              printButton.addEventListener("click",
  	                () => {
  	                  openEventsPrintWindow();
  	                });

  	              searchInput.addEventListener("input",
  	                () => {
  	                  renderEvents();
  	                });

  	              bodyEl.addEventListener("click", event => {
  	                const editButton = event.target.closest("[data-tem-edit-index]");
  	                const routeButton = event.target.closest("[data-tem-route-index]");
  	                const button = editButton || routeButton;

  	                if (!button || !bodyEl.contains(button)) return;

  	                const index = Number(
  	                  button.getAttribute(editButton ? "data-tem-edit-index": "data-tem-route-index")
  	                );
  	                const visibleJobs = currentVisibleJobs();
  	                const job = visibleJobs[index] || null;

  	                if (!job) {
  	                  window.alert("This Job Entry is no longer available. Refresh the list and try again.");
  	                  return;
  	                }

  	                if (editButton) {
  	                  openJobProductsEditor(job);
  	                  return;
  	                }

  	                openEventTrackingWindow(job);
  	              });

  	              mount.addEventListener("mousedown",
  	                event => {
  	                  if (event.target === mount) {
  	                    mount.remove();
  	                  }
  	                });

  	              refreshEvents();
  	            }

  	  function fifFuelLogicEnabled(value) {
  	    const raw = descriptorValue(value);
  	    if (raw === true || raw === 1) return true;
  	    if (raw === false || raw === 0 || raw === null || raw === undefined || raw === "") return false;
  	    if (Array.isArray(raw)) {
  	      return raw.some(function (item) {
  	        return /fuel/i.test(clean(descriptorValue(item))) || fifFuelLogicEnabled(item);
  	      });
  	    }
  	    if (typeof raw === "object") {
  	      const explicit = firstValue([
  	        raw.Enabled,
  	        raw.Active,
  	        raw.IsEnabled,
  	        raw.HasFuel,
  	        raw.AllowFuel,
  	        raw.FuelEnabled,
  	        raw.value
  	      ], null);
  	      if (explicit !== null && explicit !== undefined && explicit !== raw) return fifFuelLogicEnabled(explicit);
  	      return Object.keys(raw).length > 0;
  	    }
  	    return /^(true|yes|active|enabled|fuel|on|1)$/i.test(clean(raw));
  	  }

  	  function fifLocationType(location) {
  	    return clean(firstValue([
  	      location && location.Type,
  	      location && location.LocationType,
  	      location && location.Category,
  	      getDeep(location, ["LocationData", "Type"], ""),
  	      getDeep(location, ["Data", "Type"], ""),
  	      getDeep(location, ["Data", "Location", "Type"], "")
  	    ], ""));
  	  }

  	  function fifLocationHasFuelLogic(location) {
  	    const locationType = fifLocationType(location);
  	    if (/^(fuel|fuel location|fuel depot|fuel station|refuelling|refueling)$/i.test(locationType)) return true;
  	    if (/(^|\s|[-_/])fuel($|\s|[-_/])/i.test(locationType)) return true;
  	    return [
  	      location && location.FuelLogic,
  	      location && location.Fuel_Logic,
  	      location && location.HasFuel,
  	      location && location.FuelEnabled,
  	      location && location.Logic,
  	      getDeep(location, ["Logic", "Fuel"], null),
  	      getDeep(location, ["LocationData", "FuelLogic"], null),
  	      getDeep(location, ["LocationData", "Fuel_Logic"], null),
  	      getDeep(location, ["LocationData", "Logic", "Fuel"], null),
  	      getDeep(location, ["Data", "Logic"], null),
  	      getDeep(location, ["Data", "FuelLogic"], null),
  	      getDeep(location, ["Data", "Fuel_Logic"], null),
  	      getDeep(location, ["Data", "Logic", "Fuel"], null)
  	    ].some(fifFuelLogicEnabled);
  	  }

  	  function fifLocationName(location) {
  	    return clean(firstValue([
  	      location && location.Name,
  	      location && location.LocationName,
  	      location && location.Title,
  	      location && location.Label,
  	      location && location.REF,
  	      location && location.FID,
  	      location && location.ID,
  	      getDeep(location, ["Data", "Name"], ""),
  	      getDeep(location, ["Data", "Location", "Name"], "")
  	    ], "Location"));
  	  }

  	  function fifLocationKey(location, index) {
  	    return clean(firstValue([
  	      location && location.objectId,
  	      location && location.LocationId,
  	      location && location.ID,
  	      location && location.FID,
  	      fifLocationName(location),
  	      "fuel-location-" + index
  	    ], "fuel-location-" + index));
  	  }

  	  function fifCompanyFuelLocations(company) {
  	    const seen = Object.create(null);
  	    return fifCompanyLocations(company).filter(fifLocationHasFuelLogic).map(function (location, index) {
  	      const value = fifLocationKey(location, index);
  	      const label = fifLocationName(location);
  	      return {
  	        value: value,
  	        label: label,
  	        type: fifLocationType(location) || "Fuel",
  	        objectId: clean(location && location.objectId),
  	        location: location
  	      };
  	    }).filter(function (item) {
  	      const key = lower(item.value || item.label);
  	      if (!key || seen[key]) return false;
  	      seen[key] = true;
  	      return true;
  	    }).sort(function (a, b) {
  	      return naturalCompare(a.label, b.label);
  	    });
  	  }

  	  function fifResolveFuelCalculation(litresValue, unitValue, totalValue, preferredSource) {
  	    let litres = numberValue(litresValue);
  	    let unit = numberValue(unitValue);
  	    let total = numberValue(totalValue);
  	    const positive = function (value) { return value !== null && value > 0; };
  	    if ([litres, unit, total].filter(positive).length < 2) {
  	      throw new Error("Enter any two of Litres, Cost per litre and Total cost. The third value will be calculated automatically.");
  	    }
  	    if (!positive(litres) && positive(unit) && positive(total)) litres = total / unit;
  	    if (!positive(unit) && positive(litres) && positive(total)) unit = total / litres;
  	    if (!positive(total) && positive(litres) && positive(unit)) total = litres * unit;
  	    if (preferredSource === "total") {
  	      if (positive(litres) && positive(total)) unit = total / litres;
  	      else if (positive(unit) && positive(total)) litres = total / unit;
  	    } else if (preferredSource === "litres") {
  	      if (positive(litres) && positive(unit)) total = litres * unit;
  	      else if (positive(litres) && positive(total)) unit = total / litres;
  	    } else if (preferredSource === "unit") {
  	      if (positive(litres) && positive(unit)) total = litres * unit;
  	      else if (positive(unit) && positive(total)) litres = total / unit;
  	    } else if (positive(litres) && positive(unit)) total = litres * unit;
  	    if (!positive(litres) || !positive(unit) || !positive(total)) throw new Error("The fuel calculation produced an invalid value. Check litres, unit price and total cost.");
  	    return {
  	      Litres: Math.round(litres * 1000) / 1000,
  	      CostPerLitre: Math.round(unit * 100) / 100,
  	      Cost: Math.round(total * 100) / 100
  	    };
  	  }

  	  function fifTyreByAnyId(company, vehicle, id) {
  	    const wanted = clean(id);
  	    if (!wanted) return null;
  	    const rows = arr(vehicle && vehicle.Tyres).concat(tyres(company));
  	    for (let index = 0; index < rows.length; index += 1) {
  	      const tyre = rows[index];
  	      if (clean(firstValue([tyre && tyre.objectId, tyre && tyre.ID, tyre && tyre.FID, tyre && tyre.Serial_Number], "")) === wanted) return tyre;
  	    }
  	    return null;
  	  }

  	  function fifFittedTyresForMileage(company, vehicle) {
  	    const rows = [];
  	    const seen = Object.create(null);
  	    const positions = currentTPositions(vehicle).Positions || {};
  	    Object.keys(positions).forEach(function (positionKey) {
  	      const slot = positions[positionKey] || {};
  	      const tyreId = clean(slot.TyreObjectId);
  	      if (!tyreId || seen[tyreId]) return;
  	      const tyre = fifTyreByAnyId(company, vehicle, tyreId);
  	      if (!tyre || !clean(tyre.objectId)) return;
  	      seen[tyreId] = true;
  	      const axleType = lower(slot.AxleType);
  	      const isTag = axleType === "tag";
  	      const isSpare = axleType === "spare" || String(positionKey).indexOf("SP") === 0;
  	      const rawRate = isTag ? numberValue(slot.WearRate): isSpare ? 0: 1;
  	      const wearRate = isSpare ? 0: isTag ? Math.max(0, Math.min(1, rawRate === null ? 1: rawRate)): 1;
  	      rows.push({ tyre: tyre, positionKey: positionKey, slot: slot, wearRate: wearRate });
  	    });
  	    const vehicleObjectId = objectIdOf(vehicle);
  	    const vehicleCode = clean(firstValue([vehicle && vehicle.ID, fifVehicleIdentityValue(vehicle, "FID", "")], ""));
  	    arr(vehicle && vehicle.Tyres).forEach(function (tyre) {
  	      const id = clean(tyre && tyre.objectId);
  	      if (!id || seen[id]) return;
  	      const linkedObjectId = clean(firstValue([tyre && tyre.Vehicle_ObjectId, tyre && tyre.VehicleObjectId], ""));
  	      const linkedVehicleId = clean(firstValue([tyre && tyre.Vehicle_ID, tyre && tyre.VehicleId], ""));
  	      const currentPosition = clean(tyre && tyre.Current_Position);
  	      const isAttached = !!currentPosition || (vehicleObjectId && linkedObjectId === vehicleObjectId) || (vehicleCode && linkedVehicleId === vehicleCode);
  	      if (!isAttached) return;
  	      seen[id] = true;
  	      const rawRate = numberValue(tyre && tyre.Current_Wear_Rate);
  	      rows.push({
  	        tyre: tyre,
  	        positionKey: currentPosition,
  	        slot: null,
  	        wearRate: Math.max(0, Math.min(1, rawRate === null ? 1: rawRate))
  	      });
  	    });
  	    return rows;
  	  }

  	  function fifMergeMileageTyre(company, vehicle, saved, original) {
  	    if (!saved && !original) return null;
  	    const row = fifReconcileCompanyCollection(
  	      company,
  	      "Tyres",
  	      original || null,
  	      original || null,
  	      saved || original,
  	      { pushMissing: true, createMissing: true }
  	    );
  	    if (!Array.isArray(vehicle.Tyres)) vehicle.Tyres = [];
  	    return fifUpsertObjectById(vehicle.Tyres, row);
  	  }

  	  function fifVehicleFuelRange(vehicle) {
  	    return fifVehicleRangeValue(vehicle);
  	  }

  	  function fifVehicleFuelTankCapacity(vehicle) {
  	    return fifVehicleTankCapacityValue(vehicle);
  	  }

  	  function fifOnRoadFuelLimits(vehicle) {
  	    const currentMileage = tractorMileage(vehicle);
  	    const range = fifVehicleFuelRange(vehicle);
  	    const tankCapacity = fifVehicleFuelTankCapacity(vehicle);
  	    return {
  	      currentMileage: currentMileage,
  	      range: range,
  	      maximumMileage: currentMileage === null ? null: currentMileage + range,
  	      tankCapacity: tankCapacity
  	    };
  	  }

  	  function fifNormalizeTyreHistoryStageKey(value) {
  	    return clean(value).toLowerCase().replace(/[^a-z0-9]/g, "");
  	  }

  	  function fifTyreHistoryObject(tyre) {
  	    const raw = tyre && tyre.History;
  	    if (!raw) return {};
  	    if (typeof raw === "object" && !Array.isArray(raw)) return cloneData(raw) || {};
  	    try {
  	      const parsed = JSON.parse(raw);
  	      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed: {};
  	    } catch (_) {
  	      return {};
  	    }
  	  }

  	  function fifResolveTyreHistoryStageKey(history, currentStage) {
  	    if (!history || typeof history !== "object" || Array.isArray(history)) return "";
  	    const direct = clean(currentStage);
  	    if (direct && history[direct] && typeof history[direct] === "object") return direct;
  	    const wanted = fifNormalizeTyreHistoryStageKey(direct);
  	    if (!wanted) return "";
  	    const keys = Object.keys(history);
  	    for (let index = 0; index < keys.length; index += 1) {
  	      const key = keys[index];
  	      if (fifNormalizeTyreHistoryStageKey(key) === wanted && history[key] && typeof history[key] === "object") return key;
  	    }
  	    return "";
  	  }

  	  function fifCalculateLiveTyreCurrentLife(tyre, source) {
  	    const expected = numberValue(firstValue([
  	      source && source.Expected_Mileage,
  	      tyre && tyre.Expected_Mileage
  	    ], null));
  	    const current = Math.max(0, numberOr(firstValue([
  	      source && source.Current_Mileage,
  	      tyre && tyre.Current_Mileage
  	    ], 0), 0));
  	    if (expected === null || expected <= 0) return numberOr(tyre && tyre.Current_Life, 0);
  	    const remaining = numberOr(firstValue([
  	      source && source.Remaining_Mileage,
  	      expected - current
  	    ], expected - current), expected - current);
  	    return Math.round(Math.max(0, Math.min(100, remaining / expected * 100)) * 100) / 100;
  	  }

  	  function fifEnsureMileageHistoryStage(history, tyre, currentMileage) {
  	    const safeHistory = history && typeof history === "object" && !Array.isArray(history) ? history: {};
  	    const requestedStage = clean(firstValue([
  	      tyre && tyre.Current_Stage,
  	      getDeep(safeHistory, ["Current", "Stage"], "")
  	    ], "New")) || "New";
  	    let stageKey = fifResolveTyreHistoryStageKey(safeHistory, requestedStage);
  	    let repaired = false;

  	    if (!stageKey) {
  	      stageKey = requestedStage;
  	      safeHistory[stageKey] = {
  	        CPK: 0,
  	        Cost: 0,
  	        Ended: "",
  	        Notes: "Mileage stage restored automatically during fuel capture.",
  	        Active: true,
  	        Events: [],
  	        Status: "Active",
  	        Started: clean(firstValue([
  	          tyre && tyre.Fitted_Date,
  	          tyre && tyre.Date_Fitted,
  	          tyre && tyre.created
  	        ], "")) || new Date().toISOString(),
  	        End_Mileage: Math.max(0, numberOr(currentMileage, 0)),
  	        Mileage_Done: 0,
  	        Start_Mileage: Math.max(0, numberOr(currentMileage, 0)),
  	        Mileage_Expected: Math.max(0, numberOr(tyre && tyre.Expected_Mileage, 0))
  	      };
  	      repaired = true;
  	    }

  	    if (!safeHistory.Current || typeof safeHistory.Current !== "object" || Array.isArray(safeHistory.Current)) {
  	      safeHistory.Current = {};
  	    }
  	    safeHistory.Current.Stage = stageKey;

  	    return {
  	      history: safeHistory,
  	      stageKey: stageKey,
  	      repaired: repaired
  	    };
  	  }

  	  function fifBuildMileageTyrePatch(item, targetMileage, previousMileage, mileageDelta) {
  	    const tyre = item && item.tyre;
  	    if (!tyre || !clean(tyre.objectId)) return null;

  	    const lastVehicleMileage = numberValue(tyre.Last_Vehicle_Odometer);
  	    if (lastVehicleMileage !== null && lastVehicleMileage > targetMileage) {
  	      throw new Error("Tyre Last_Vehicle_Odometer is higher than the entered Data.Vehicle.Usage.CurrentReading. Mileage was not reduced.");
  	    }

  	    let vehicleDistance = Math.max(0, numberOr(mileageDelta, 0));
  	    if (lastVehicleMileage !== null && lastVehicleMileage > 0) vehicleDistance = Math.max(0, targetMileage - lastVehicleMileage);
  	    else if (previousMileage === null) vehicleDistance = 0;

  	    const wearRate = Math.max(0, Math.min(1, numberOr(item.wearRate, 1)));
  	    const increment = Math.round(vehicleDistance * wearRate * 1000) / 1000;
  	    const oldCurrentMileage = Math.max(0, numberOr(tyre.Current_Mileage, 0));
  	    const oldTotalMileage = Math.max(0, numberOr(firstValue([tyre.Total_Mileage, oldCurrentMileage], oldCurrentMileage), oldCurrentMileage));
  	    const newCurrentMileage = Math.round((oldCurrentMileage + increment) * 1000) / 1000;
  	    const newTotalMileage = Math.round((oldTotalMileage + increment) * 1000) / 1000;
  	    const history = fifTyreHistoryObject(tyre);
  	    let stageKey = "";
  	    let historyRepaired = false;

  	    if (increment > 0) {
  	      const stageResolution = fifEnsureMileageHistoryStage(history, tyre, oldCurrentMileage);
  	      stageKey = stageResolution.stageKey;
  	      historyRepaired = stageResolution.repaired;

  	      const stage = stageResolution.history[stageKey] && typeof stageResolution.history[stageKey] === "object"
  	        ? cloneData(stageResolution.history[stageKey])
  	        : {};
  	      stage.Mileage_Done = Math.round((Math.max(0, numberOr(stage.Mileage_Done, 0)) + increment) * 1000) / 1000;
  	      stage.End_Mileage = newCurrentMileage;
  	      stageResolution.history[stageKey] = stage;

  	      if (!stageResolution.history.Totals || typeof stageResolution.history.Totals !== "object" || Array.isArray(stageResolution.history.Totals)) {
  	        stageResolution.history.Totals = {};
  	      }
  	      stageResolution.history.Totals.Mileage_Total = Math.round((Math.max(0, numberOr(stageResolution.history.Totals.Mileage_Total, 0)) + increment) * 1000) / 1000;
  	    }

  	    const payload = {
  	      objectId: tyre.objectId,
  	      Current_Mileage: newCurrentMileage,
  	      Last_Vehicle_Odometer: targetMileage,
  	      Current_Wear_Rate: wearRate
  	    };
  	    if (increment > 0) payload.History = history;

  	    const localPatch = Object.assign({}, payload, {
  	      Total_Mileage: newTotalMileage
  	    });
  	    const expectedMileage = numberValue(tyre.Expected_Mileage);
  	    if (expectedMileage !== null && expectedMileage >= 0) {
  	      localPatch.Remaining_Mileage = Math.max(0, Math.round((expectedMileage - newCurrentMileage) * 1000) / 1000);
  	    }
  	    localPatch.Current_Life = fifCalculateLiveTyreCurrentLife(Object.assign({}, tyre, localPatch), localPatch);

  	    return {
  	      tyre: tyre,
  	      payload: payload,
  	      localPatch: localPatch,
  	      wearRate: wearRate,
  	      vehicleDistance: vehicleDistance,
  	      increment: increment,
  	      oldCurrentMileage: oldCurrentMileage,
  	      newCurrentMileage: newCurrentMileage,
  	      newTotalMileage: newTotalMileage,
  	      stageKey: stageKey,
  	      historyRepaired: historyRepaired
  	    };
  	  }

  	  async function v21ExecuteUpdateBundle(updates) {
  	    updates = arr(updates).filter(function (update) {
  	      return update && update.table && update.payload && update.payload.objectId;
  	    });

  	    if (!updates.length) {
  	      return {
  	        atomic: true,
  	        count: 0,
  	        successes: [],
  	        failures: [],
  	        transactionError: null
  	      };
  	    }

  	    let transactionError = null;
  	    const context = v21CreateUnitOfWork();
  	    if (context && context.unit && typeof context.unit.update === "function") {
  	      try {
  	        updates.forEach(function (update) {
  	          context.unit.update(update.table, update.payload);
  	        });
  	        const result = await context.unit.execute();
  	        if (!v21UowResultSuccess(result)) throw v21UowResultError(result);
  	        return {
  	          atomic: true,
  	          count: updates.length,
  	          successes: updates.map(function (update) {
  	            return { update: update, saved: update.payload };
  	          }),
  	          failures: [],
  	          transactionError: null
  	        };
  	      } catch (error) {
  	        transactionError = error;

  	      }
  	    }

  	    const databaseApi = await fifWaitForDatabaseApi(1800);
  	    if (!databaseApi || !databaseApi.Data || typeof databaseApi.Data.of !== "function") {
  	      throw transactionError || new Error("The database is unavailable while updating mileage.");
  	    }

  	    const successes = [];
  	    const failures = [];
  	    let requiredFailure = null;

  	    for (let index = 0; index < updates.length; index += 1) {
  	      const update = updates[index];
  	      if (requiredFailure) {
  	        failures.push({
  	          update: update,
  	          error: new Error("Skipped because Data.Vehicle.Usage.CurrentReading could not be saved.")
  	        });
  	        continue;
  	      }
  	      try {
  	        const saved = await databaseApi.Data.of(update.table).save(update.payload);
  	        successes.push({ update: update, saved: saved || update.payload });
  	      } catch (error) {
  	        failures.push({ update: update, error: error });
  	        if (update.required) requiredFailure = error;
  	      }
  	    }

  	    return {
  	      atomic: false,
  	      count: successes.length,
  	      successes: successes,
  	      failures: failures,
  	      transactionError: transactionError
  	    };
  	  }

  	  async function fifApplyMileageBundle(company, vehicle, enteredMileage) {
  	    const target = numberValue(enteredMileage);
  	    const previous = tractorMileage(vehicle);
  	    const limits = fifOnRoadFuelLimits(vehicle);
  	    if (target === null || target < 0) throw new Error("Enter a valid vehicle mileage.");
  	    if (previous !== null && target < previous) {
  	      throw new Error("Fuel capture mileage cannot be lower than the current Data.Vehicle.Usage.CurrentReading of " + formatNumber(previous, 0) + " km.");
  	    }
  	    if (limits.maximumMileage !== null && target > limits.maximumMileage) {
  	      throw new Error("Fuel capture mileage cannot be higher than " + formatNumber(limits.maximumMileage, 0) + " km. The maximum permitted increase is the Data.Vehicle.Usage.Range of " + formatNumber(limits.range, 0) + " km.");
  	    }

  	    const delta = previous === null ? 0: target - previous;
  	    const result = {
  	      previousMileage: previous,
  	      mileage: target,
  	      delta: delta,
  	      vehicleSaveRequired: previous !== target,
  	      vehicleUpdated: false,
  	      tyresProcessed: 0,
  	      tyresUpdated: 0,
  	      tyresAdvanced: 0,
  	      tyreUpdates: [],
  	      tyreErrors: [],
  	      historyRepairs: 0,
  	      atomic: true,
  	      transactionRetried: false
  	    };

  	    const updates = [];
  	    const vehicleObjectId = objectIdOf(vehicle);
  	    if (!vehicleObjectId) throw new Error("The vehicle does not have an objectId. Data.Vehicle.Usage.CurrentReading could not be updated.");

  	    if (previous !== target) {
  	      const vehicleData = fifCanonicalVehicleData(vehicle);
  	      const counterType = fifVehicleCounterTypeValue(vehicle);
  	      fifSetCanonicalDescriptor(vehicleData.Vehicle.Usage, "CurrentReading", target, {
  	        editable: false,
  	        selector: "number",
  	        unitType: counterType === "Hours" ? "Time" : "Distance"
  	      });
  	      updates.push({
  	        table: assetTableName(vehicle),
  	        payload: {
  	          objectId: vehicleObjectId,
  	          Data: vehicleData
  	        },
  	        kind: "vehicle",
  	        required: true
  	      });
  	    }

  	    const fitted = fifFittedTyresForMileage(company, vehicle);
  	    fitted.forEach(function (item) {
  	      result.tyresProcessed += 1;
  	      try {
  	        const update = fifBuildMileageTyrePatch(item, target, previous, delta);
  	        if (!update) return;
  	        updates.push({
  	          table: "Tyres",
  	          payload: update.payload,
  	          kind: "tyre",
  	          item: item,
  	          update: update,
  	          required: false
  	        });
  	      } catch (error) {
  	        result.tyreErrors.push({
  	          tyre: fifTyreAlertLabel(item && item.tyre),
  	          position: clean(item && item.positionKey),
  	          message: clean(error && (error.message || error.faultString)) || "Tyre mileage preparation failed.",
  	          phase: "prepare"
  	        });
  	      }
  	    });

  	    const bundle = await v21ExecuteUpdateBundle(updates);
  	    result.atomic = bundle.atomic;
  	    result.transactionRetried = !!bundle.transactionError;

  	    arr(bundle.successes).forEach(function (success) {
  	      const entry = success.update;
  	      if (!entry) return;

  	      if (entry.kind === "vehicle") {
  	        vehicle = fifReconcileVehicleAppData(
  	          company,
  	          vehicle,
  	          entry.payload,
  	          success.saved || entry.payload,
  	          assetTableName(vehicle)
  	        );
  	        result.vehicleUpdated = true;
  	        return;
  	      }

  	      const update = entry.update;
  	      const merged = Object.assign({}, update.tyre, success.saved || {}, update.localPatch || update.payload);
  	      merged.Current_Life = fifCalculateLiveTyreCurrentLife(merged, update.localPatch || update.payload);
  	      fifMergeMileageTyre(company, vehicle, merged, update.tyre);
  	      result.tyresUpdated += 1;
  	      if (update.increment > 0) result.tyresAdvanced += 1;
  	      if (update.historyRepaired) result.historyRepairs += 1;
  	      result.tyreUpdates.push({
  	        tyre: fifTyreAlertLabel(update.tyre),
  	        position: entry.item.positionKey || clean(update.tyre.Current_Position),
  	        wearRate: update.wearRate,
  	        vehicleDistance: update.vehicleDistance,
  	        increment: update.increment,
  	        mileage: update.newCurrentMileage,
  	        stageKey: update.stageKey,
  	        historyRepaired: update.historyRepaired
  	      });
  	    });

  	    let vehicleFailure = null;
  	    arr(bundle.failures).forEach(function (failure) {
  	      const entry = failure.update;
  	      const message = clean(failure.error && (failure.error.message || failure.error.faultString)) || "Database update failed.";
  	      if (entry && entry.kind === "vehicle") {
  	        vehicleFailure = failure.error || new Error(message);
  	        return;
  	      }
  	      result.tyreErrors.push({
  	        tyre: entry && entry.update ? fifTyreAlertLabel(entry.update.tyre): "Tyre",
  	        position: clean(entry && entry.item && entry.item.positionKey),
  	        message: message,
  	        phase: "save"
  	      });
  	    });

  	    if (result.vehicleSaveRequired && !result.vehicleUpdated) {
  	      const detail = clean(vehicleFailure && (vehicleFailure.message || vehicleFailure.faultString));
  	      throw new Error("Data.Vehicle.Usage.CurrentReading could not be saved." + (detail ? " " + detail: ""));
  	    }

  	    return result;
  	  }

  	  function fifValidateOnRoadFuelCapture(vehicle, input) {
  	    if (assetIsTrailer(vehicle)) throw new Error("Fuel capture is not available for trailers or implements.");
  	    const limits = fifOnRoadFuelLimits(vehicle);
  	    const mileage = numberValue(input.Mileage);
  	    if (mileage === null || mileage < 0) throw new Error("Enter the vehicle mileage at the time of refuelling.");
  	    if (limits.currentMileage !== null && mileage < limits.currentMileage) throw new Error("Fuel capture mileage cannot be lower than the current Data.Vehicle.Usage.CurrentReading of " + formatNumber(limits.currentMileage, 0) + " km.");
  	    if (limits.maximumMileage !== null && mileage > limits.maximumMileage) throw new Error("Fuel capture mileage cannot be higher than " + formatNumber(limits.maximumMileage, 0) + " km. The Data.Vehicle.Usage.Range permits a maximum increase of " + formatNumber(limits.range, 0) + " km.");
  	    const calculation = fifResolveFuelCalculation(input.Litres, input.CostPerLitre, input.Cost, input.CalculationSource);
  	    if (calculation.Litres <= 0) throw new Error("Litres must be greater than 0.");
  	    if (limits.tankCapacity > 0 && calculation.Litres > limits.tankCapacity) throw new Error("Litres cannot exceed the vehicle tank capacity of " + formatNumber(limits.tankCapacity, 2) + " L.");
  	    const supplier = clean(input.ContractorName);
  	    if (!supplier) throw new Error("Select a company fuel location or enter the Other fuel station / supplier name.");
  	    return {
  	      limits: limits,
  	      mileage: mileage,
  	      calculation: calculation,
  	      supplier: supplier,
  	      distance: limits.currentMileage === null ? 0: Math.max(0, mileage - limits.currentMileage)
  	    };
  	  }
  	async function saveOnRoadFuelCapture(company, vehicle, input) {
  	    fifRequirePermission(CAN_CAPTURE_ON_ROAD_FUEL && userCanAccessAssetFunction(vehicle, "Fuel"), "Fuel capture is not assigned in your Dashboard Settings.");
  	    if (!BACKENDLESS_API || !BACKENDLESS_API.Data || !BACKENDLESS_API.Data.of) throw new Error("The database is unavailable. The on-road fuel record was not saved.");
  	    if (!vehicle || !objectIdOf(vehicle)) throw new Error("The selected vehicle does not contain an objectId.");
  	    const validated = fifValidateOnRoadFuelCapture(vehicle, input);
  	    const previousMileage = validated.limits.currentMileage;
  	    const mileage = validated.mileage;
  	    const calculation = validated.calculation;
  	    const fuelDate = fifAlertDate(input.FuelDate) || new Date();
  	    const view = matchingVehiclePeriod(vehicle, fuelDate) || vehicle.ViewC || null;
  	    const sarsRate = fifVehicleSarsRebateRate(vehicle);
  	    const sarsCompliant = !!input.SARSCompliance;
  	    const rebate = sarsCompliant ? Math.round(calculation.Litres * sarsRate * 100) / 100: 0;
  	    const companyObjectId = clean(company && company.objectId);
  	    const vehicleObjectId = objectIdOf(vehicle);
  	    const payload = {
  	      FuelDate: fuelDate.toISOString(),
  	      CaptureType: "on-road",
  	      EntryType: "On Road Fuel",
  	      Mileage: mileage,
  	      MileageLast: previousMileage,
  	      Distance: validated.distance,
  	      Litres: calculation.Litres,
  	      CostPerLitre: calculation.CostPerLitre,
  	      Cost: calculation.Cost,
  	      ContractorName: validated.supplier,
  	      ReferenceNo: clean(input.ReferenceNo),
  	      Application: clean(firstValue([input.Application, fifVehicleClassificationValue(vehicle, "Application", ""), getDeep(fifCanonicalVehicleData(vehicle), ["Application"], ""), vehicle && vehicle.Application], "On Road Fuel")),
  	      Description: clean((input.ReferenceNo ? "Receipt " + input.ReferenceNo + ". ": "") + (input.Description || "On-road fuel purchase") + (sarsCompliant ? " SARS rebate calculated at " + formatCurrency(sarsRate) + " per litre.": "")),
  	      SARSCompliance: sarsCompliant,
  	      SARSRebateRate: sarsRate,
  	      PotentialSARSRebate: rebate,
  	      CompanyObjectId: companyObjectId,
  	      TractorObjectId: vehicleObjectId,
  	      VehicleObjectId: vehicleObjectId,
  	      RollbackMileageDifferential: validated.distance,
  	      RollbackVehicleMileageBefore: previousMileage
  	    };
  	    if (companyObjectId) payload.Company = { objectId: companyObjectId };
  	    if (vehicleObjectId) payload.Tractor = { objectId: vehicleObjectId };
  	    const saved = await BACKENDLESS_API.Data.of("FuelOut").save(payload);
  	    const finalRow = fifReconcileCompanyCollection(
  	      company,
  	      "FuelOut",
  	      null,
  	      payload,
  	      saved || payload,
  	      { pushMissing: true, createMissing: true }
  	    );
  	    if (!finalRow.objectId) throw new Error("FuelOut saved without an objectId. Mileage and relation updates were not attempted.");
  	    if (!Array.isArray(vehicle.FuelOut)) vehicle.FuelOut = [];
  	    if (!Array.isArray(company.FuelOut)) company.FuelOut = [];
  	    fifUpsertObjectById(vehicle.FuelOut, finalRow);
  	    fifUpsertObjectById(company.FuelOut, finalRow);

  	    let mileageUpdate = null;
  	    let mileageError = null;
  	    try {
  	      mileageUpdate = await fifApplyMileageBundle(company, vehicle, mileage);
  	    } catch (error) {
  	      mileageError = error;

  	    }

  	    let periodRelationLinked = false;
  	    let periodSaveError = null;
  	    if (view && view.objectId) periodRelationLinked = await v21AddRelation("Tractorview", view.objectId, "Fuel", finalRow.objectId, false);
  	    if (view) {
  	      if (!Array.isArray(view.Fuel)) view.Fuel = [];
  	      fifUpsertObjectById(view.Fuel, finalRow);
  	      if (previousMileage !== null) {
  	        const meterStart = numberValue(view.MeterStart);
  	        if (meterStart === null || meterStart <= 0) view.MeterStart = previousMileage;
  	      }
  	      view.MeterEnd = mileage;
  	      view.Distance = numberOr(view.Distance, 0) + validated.distance;
  	      view.Litres = numberOr(view.Litres, 0) + calculation.Litres;
  	      view.Cost = Math.round((numberOr(view.Cost, 0) + calculation.Cost) * 100) / 100;
  	      view.PotentialSARSRebate = Math.round((numberOr(view.PotentialSARSRebate, 0) + rebate) * 100) / 100;
  	      if (view.objectId) {
  	        try {
  	          await BACKENDLESS_API.Data.of("Tractorview").save({
  	            objectId: view.objectId,
  	            MeterStart: view.MeterStart,
  	            MeterEnd: view.MeterEnd,
  	            Distance: view.Distance,
  	            Litres: view.Litres,
  	            Cost: view.Cost,
  	            PotentialSARSRebate: view.PotentialSARSRebate
  	          });
  	        } catch (error) {
  	          periodSaveError = error;

  	        }
  	      }
  	    }
  	    return {
  	      fuel: finalRow,
  	      mileageUpdate: mileageUpdate,
  	      mileageError: mileageError,
  	      view: view,
  	      periodRelationLinked: periodRelationLinked,
  	      periodSaveError: periodSaveError,
  	      sarsRate: sarsRate,
  	      rebate: rebate,
  	      limits: validated.limits,
  	      distance: validated.distance
  	    };
  	  }

  	  function injectOnRoadFuelCaptureStyles() {
  	    const styleId = "fif-on-road-fuel-capture-v21-style";
  	    if (document.getElementById(styleId)) return;
  	    const style = document.createElement("style");
  	    style.id = styleId;
  	    style.textContent = `
  	    #${SERVICE_MODAL_ID} .fifsp-modal.fif-road-fuel-modal{
  	      width:calc(100vw - 28px);
  	      height:calc(100vh - 78px);
  	      max-width:none;
  	      max-height:none;
  	      overflow:hidden;
  	      border-radius:18px;
  	      border:1px solid rgba(255,255,255,.075);
  	      background:linear-gradient(180deg,rgba(5,10,18,.985),rgba(10,16,24,.975));
  	      box-shadow:0 22px 60px rgba(0,0,0,.48);
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>header{
  	      padding:16px 16px 12px;
  	      border-bottom:1px solid rgba(255,255,255,.065);
  	      background:radial-gradient(circle at 14% 0%,rgba(204,102,51,.10),transparent 34%),linear-gradient(145deg,#111821,#080d13);
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>header span{font-size:9px;letter-spacing:.12em;color:#d98455}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>header h2{font-size:18px;margin-top:3px}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>header p{font-size:10.5px;color:#a0aab5}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>header button{
  	      width:32px;height:32px;flex:0 0 32px;border-radius:999px;border-color:rgba(204,102,51,.46);
  	      background:linear-gradient(145deg,rgba(29,24,22,.98),rgba(8,11,14,.98));color:#f4d7c5;
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>main{
  	      padding:18px;
  	      background:radial-gradient(circle at 18% 0%,rgba(204,102,51,.055),transparent 36%);
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>footer{
  	      padding:13px 18px;
  	      background:#090e14;
  	      border-top:1px solid rgba(255,255,255,.07);
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>footer button{
  	      height:46px;min-height:46px;border-radius:10px;padding:0 18px;font-size:13px;font-weight:850;
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>footer button.primary{
  	      flex:1 1 auto;
  	      background:linear-gradient(145deg,#9c4822,#5e2914);
  	      box-shadow:0 10px 24px rgba(204,102,51,.20);
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>footer button:not(.primary){width:140px}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-form{display:flex;flex-direction:column;gap:12px;min-height:100%}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-intro{
  	      padding:14px 16px;border:1px solid rgba(204,102,51,.28);border-radius:16px;
  	      background:linear-gradient(145deg,rgba(204,102,51,.12),rgba(255,255,255,.025));
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-intro strong{display:block;color:#fff;font-size:18px;font-weight:900}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-intro span{display:block;margin-top:4px;color:#94a3b8;font-size:11px;line-height:1.45}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-card{
  	      padding:18px;border:1px solid rgba(255,255,255,.075);border-top-color:rgba(204,102,51,.34);
  	      border-radius:18px;background:linear-gradient(145deg,rgba(255,255,255,.045),rgba(255,255,255,.018));
  	      box-shadow:0 16px 34px rgba(0,0,0,.18);
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field{display:block;min-width:0}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field.wide{grid-column:1/-1}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field>span{
  	      display:block;margin:0 0 7px 2px;color:#cbd5e1;font-size:12px;font-weight:800;letter-spacing:.01em
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field input,
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field textarea,
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field select{
  	      width:100%;height:46px;box-sizing:border-box;border:1px solid rgba(255,255,255,.12);border-radius:12px;
  	      background:linear-gradient(180deg,#121923,#0c121a);color:#f8fafc;padding:0 13px;font-size:14px;font-weight:650;
  	      box-shadow:inset 0 1px 0 rgba(255,255,255,.035),0 8px 18px rgba(0,0,0,.12);outline:none;
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field textarea{height:86px;padding:12px 13px;resize:vertical}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field input::placeholder,
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field textarea::placeholder{color:#64748b}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field input:focus,
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field textarea:focus{
  	      border-color:rgba(204,102,51,.82);box-shadow:0 0 0 3px rgba(204,102,51,.13),inset 0 1px 0 rgba(255,255,255,.04)
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field input:disabled{opacity:.68;color:#aeb8c4}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field .fif-styled-select-button{
  	      height:46px;border-radius:12px;padding:0 13px;font-size:14px;font-weight:700;
  	      background:linear-gradient(180deg,#121923,#0c121a);border-color:rgba(255,255,255,.12)
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-help{display:block;margin-top:5px;color:#94a3b8;font-size:10px;line-height:1.4}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-error{display:none;margin-top:5px;color:#ff8c8c;font-size:10px;font-weight:750}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-error.visible{display:block}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-check{
  	      grid-column:1/-1;display:flex;align-items:center;gap:11px;min-height:58px;padding:11px 13px;
  	      border:1px solid rgba(255,255,255,.08);border-radius:12px;background:rgba(255,255,255,.025);cursor:pointer
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-check input{width:18px;height:18px;accent-color:#cc6633}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-check strong{display:block;color:#f2f5f3;font-size:12px}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-check small{display:block;margin-top:3px;color:#7f8a84;font-size:10px}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-preview{
  	      grid-column:1/-1;padding:12px 14px;border-radius:12px;background:rgba(255,255,255,.04)
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-preview>strong{display:block;margin-bottom:8px;color:#f8fafc;font-size:12px}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-preview-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-preview-grid article{
  	      min-width:0;padding:10px;border:1px solid rgba(255,255,255,.05);border-radius:10px;background:rgba(255,255,255,.035)
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-preview-grid span{display:block;color:#94a3b8;font-size:10px}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-preview-grid b{
  	      display:block;margin-top:4px;color:#f8fafc;font-size:16px;font-weight:850;white-space:nowrap;overflow:hidden;text-overflow:ellipsis
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-safeguards{
  	      display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:9px;margin-top:12px
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-safeguards article{
  	      padding:10px 12px;border:1px solid rgba(255,255,255,.06);border-radius:11px;background:rgba(5,10,16,.48)
  	    }
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-safeguards span{display:block;color:#77838d;font-size:9px;text-transform:uppercase;font-weight:850}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-safeguards strong{display:block;margin-top:4px;color:#dce4ea;font-size:11px;line-height:1.4}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-location-note{
  	      grid-column:1/-1;padding:9px 11px;border:1px solid rgba(204,102,51,.20);border-radius:10px;
  	      color:#b6c0c8;background:rgba(204,102,51,.055);font-size:10px;line-height:1.45
  	    }
  	    @media(max-width:820px){
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-grid{grid-template-columns:1fr}
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-field.wide,
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-check,
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-preview,
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-location-note{grid-column:1}
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-preview-grid,
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-safeguards{grid-template-columns:repeat(2,minmax(0,1fr))}
  	    }
  	    @media(max-width:560px){
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-preview-grid,
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-safeguards{grid-template-columns:1fr}
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-modal>footer{flex-direction:column}
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-modal>footer button,
  	      #${SERVICE_MODAL_ID} .fif-road-fuel-modal>footer button:not(.primary){width:100%;flex:none}
  	    }

  	    #${SERVICE_MODAL_ID} .fifsp-modal.fif-road-fuel-modal{width:min(900px,calc(100vw - 28px));height:auto;max-height:calc(100vh - 72px);border-radius:15px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>header{padding:11px 13px 9px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>header h2{font-size:16px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>header p{font-size:9px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>main{padding:11px;overflow:auto;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>footer{padding:9px 11px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-modal>footer button{height:40px;min-height:40px;font-size:11px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-card{padding:11px;border-radius:13px;box-shadow:0 10px 24px rgba(0,0,0,.15);}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-grid{grid-template-columns:repeat(3,minmax(0,1fr));gap:9px 10px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field.wide{grid-column:span 2;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field>span{margin-bottom:4px;font-size:10px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field input,#${SERVICE_MODAL_ID} .fif-road-fuel-field textarea,#${SERVICE_MODAL_ID} .fif-road-fuel-field select,#${SERVICE_MODAL_ID} .fif-road-fuel-field .fif-styled-select-button{height:40px;border-radius:9px;padding:0 10px;font-size:12px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-field textarea{height:48px;padding:8px 10px;resize:none;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-help,#${SERVICE_MODAL_ID} .fif-road-fuel-error{margin-top:3px;font-size:8px;line-height:1.25;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-location-note{grid-column:3;padding:7px 9px;font-size:8px;display:flex;align-items:center;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-check{grid-column:span 2;min-height:44px;padding:7px 10px;border-radius:9px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-check strong{font-size:10px;}#${SERVICE_MODAL_ID} .fif-road-fuel-check small{font-size:8px;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-notes{grid-column:span 2;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-compact-summary{grid-column:1/-1;display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:6px;padding:7px;border:1px solid rgba(204,102,51,.22);border-radius:10px;background:rgba(204,102,51,.055);}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-compact-summary span{min-width:0;padding:5px 7px;border-radius:7px;background:rgba(255,255,255,.035);}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-compact-summary small{display:block;color:#7f8a84;font-size:7px;font-weight:900;text-transform:uppercase;}
  	    #${SERVICE_MODAL_ID} .fif-road-fuel-compact-summary b{display:block;margin-top:2px;color:#fff;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  	    @media(max-width:820px){#${SERVICE_MODAL_ID} .fif-road-fuel-grid{grid-template-columns:repeat(2,minmax(0,1fr));}#${SERVICE_MODAL_ID} .fif-road-fuel-location-note{grid-column:1/-1;}#${SERVICE_MODAL_ID} .fif-road-fuel-field.wide,#${SERVICE_MODAL_ID} .fif-road-fuel-check,#${SERVICE_MODAL_ID} .fif-road-fuel-notes{grid-column:1/-1;}}
  	    @media(max-width:560px){#${SERVICE_MODAL_ID} .fif-road-fuel-grid{grid-template-columns:1fr;}#${SERVICE_MODAL_ID} .fif-road-fuel-field.wide,#${SERVICE_MODAL_ID} .fif-road-fuel-check,#${SERVICE_MODAL_ID} .fif-road-fuel-notes{grid-column:1;}#${SERVICE_MODAL_ID} .fif-road-fuel-compact-summary{grid-template-columns:repeat(2,minmax(0,1fr));}}
  	    `;
  	    document.head.appendChild(style);
  	  }
  	function openOnRoadFuelCapture(company, vehicle) {
  	    if (!CAN_CAPTURE_ON_ROAD_FUEL || !userCanAccessAssetFunction(vehicle, "Vehicles")) {
  	      fifAlert("Vehicle fuel capture is not assigned.", {
  	        title: "Fuel Capture Access Required",
  	        type: "warning",
  	        confirmText: "Close"
  	      });
  	      return null;
  	    }
  	    if (assetIsTrailer(vehicle)) {
  	      fifAlert("Fuel capture is available only for powered vehicles. Trailers and implements do not use powered-vehicle fuel capture.", { title: "Fuel Capture Not Available", type: "warning", confirmText: "Close" });
  	      return null;
  	    }
  	    injectServicePortalStyles();
  	    injectActionableAlertStyles();
  	    injectOnRoadFuelCaptureStyles();

  	    let limits = fifOnRoadFuelLimits(vehicle);
  	    let currentMileage = limits.currentMileage;
  	    const application = clean(firstValue([
  	      fifVehicleClassificationValue(vehicle, "Application", ""),
  	      getDeep(fifCanonicalVehicleData(vehicle), ["Application"], ""),
  	      vehicle && vehicle.Application
  	    ], "On Road Fuel"));
  	    const sarsRate = fifVehicleSarsRebateRate(vehicle);
  	    const fuelLocations = fifCompanyFuelLocations(company);
  	    const locationOptionsHtml = [
  	      '<option value="__other__" selected>Other</option>'
  	    ].concat(fuelLocations.map(function (item) {
  	      return '<option value="' + escapeAttr(item.value) + '">' + escapeHtml(item.label) + '</option>';
  	    })).join("");

  	    const mileageHelpText = function () {
  	      return currentMileage === null
  	        ? "Data.Vehicle.Usage.CurrentReading is not set. This entry will establish the baseline; no historic tyre distance will be invented."
  	        : "Allowed range: " + formatNumber(currentMileage, 0) + " to " + formatNumber(limits.maximumMileage, 0) + " km.";
  	    };
  	    const litresHelpText = function () {
  	      return limits.tankCapacity > 0
  	        ? "Vehicle tank capacity: " + formatNumber(limits.tankCapacity, 2) + " L."
  	        : "Vehicle tank size is not configured in Essential Data; only the positive-litres blocker can be applied.";
  	    };

  	    const body = `<form data-road-fuel-form class="fif-road-fuel-form" novalidate>
  	      <section class="fif-road-fuel-card">
  	        <div class="fif-road-fuel-grid">
  	          <label class="fif-road-fuel-field wide">
  	            <span>Fuel location / supplier</span>
  	            <select name="FuelLocationId" required>${locationOptionsHtml}</select>
  	          </label>

  	          <div class="fif-road-fuel-location-note" data-road-fuel-location-note>
  	            ${fuelLocations.length
  	              ? escapeHtml(formatCount(fuelLocations.length) + " company fuel location" + (fuelLocations.length === 1 ? " is": "s are") + " available. Other remains pinned first for outside purchases.")
  	              : "No company location with Type Fuel was found. Other remains available for an outside purchase."}
  	          </div>

  	          <label data-road-fuel-other-wrap class="fif-road-fuel-field wide">
  	            <span>Other fuel station / supplier</span>
  	            <input name="ContractorName" type="text" placeholder="Type fuel station or supplier" required>
  	          </label>

  	          <label class="fif-road-fuel-field">
  	            <span>Date and time</span>
  	            <input name="FuelDate" type="datetime-local" value="${escapeAttr(fifLocalDateTimeValue(new Date()))}" required>
  	          </label>

  	          <label class="fif-road-fuel-field">
  	            <span>Vehicle mileage</span>
  	            <input name="Mileage" type="number" value="" inputmode="decimal" step="1" placeholder="${escapeAttr(currentMileage === null ? "Enter vehicle mileage": "Enter mileage; current is " + formatNumber(currentMileage, 0) + " km")}" required>
  	            <small class="fif-road-fuel-help" data-road-fuel-mileage-help>${escapeHtml(mileageHelpText())}</small>
  	            <small class="fif-road-fuel-error" data-road-fuel-mileage-error></small>
  	          </label>

  	          <label class="fif-road-fuel-field">
  	            <span>Litres</span>
  	            <input name="Litres" type="number" value="" inputmode="decimal" min="0.001" step="0.001" placeholder="Enter any two values">
  	            <small class="fif-road-fuel-help" data-road-fuel-litres-help>${escapeHtml(litresHelpText())}</small>
  	            <small class="fif-road-fuel-error" data-road-fuel-litres-error></small>
  	          </label>

  	          <label class="fif-road-fuel-field">
  	            <span>Cost per litre</span>
  	            <input name="CostPerLitre" type="number" value="" inputmode="decimal" min="0.01" step="0.01" data-fif-step-value="0.10" data-fif-decimals="2" placeholder="Enter any two values">
  	          </label>

  	          <label class="fif-road-fuel-field">
  	            <span>Total cost</span>
  	            <input name="Cost" type="number" value="" inputmode="decimal" min="0.01" step="0.01" data-fif-step-value="1.00" data-fif-decimals="2" placeholder="Enter any two values">
  	          </label>

  	          <label class="fif-road-fuel-field">
  	            <span>Receipt / invoice reference</span>
  	            <input name="ReferenceNo" type="text" value="" placeholder="Receipt or invoice number">
  	          </label>

  	          <label class="fif-road-fuel-field">
  	            <span>Vehicle application</span>
  	            <input name="ApplicationDisplay" type="text" value="${escapeAttr(application)}" disabled>
  	          </label>

  	          <label class="fif-road-fuel-check">
  	            <input name="SARSCompliance" type="checkbox">
  	            <span>
  	              <strong>SARS-compliant receipt available</strong>
  	              <small>Potential rebate = litres × the vehicle SARS Rebate Rate of ${escapeHtml(formatCurrency(sarsRate))} per litre.</small>
  	            </span>
  	          </label>

  	          <label class="fif-road-fuel-field wide fif-road-fuel-notes">
  	            <span>Notes</span>
  	            <textarea name="Description" placeholder="Optional notes">On-road fuel purchase</textarea>
  	          </label>

  	          <div class="fif-road-fuel-compact-summary">
  	            <span><small>Distance</small><b data-road-fuel-mileage-delta>Enter mileage</b></span>
  	            <span><small>Price / L</small><b data-road-fuel-unit>R 0.00</b></span>
  	            <span><small>Total</small><b data-road-fuel-total>R 0.00</b></span>
  	            <span><small>SARS</small><b data-road-fuel-sars>No</b></span>
  	            <span><small>Rebate</small><b data-road-fuel-rebate>R 0.00</b></span>
  	          </div>
  	          <div class="fif-road-fuel-limit-data" hidden>
  	            <span data-road-fuel-mileage-limit>${escapeHtml(mileageHelpText())}</span>
  	            <span data-road-fuel-litres-limit>${escapeHtml(litresHelpText())}</span>
  	          </div>
  	        </div>
  	      </section>
  	    </form>`;

  	    const footer = `<button type="button" data-sp-modal-close>Cancel</button>
  	      <button type="button" class="primary" data-road-fuel-save ${CAN_CAPTURE_ON_ROAD_FUEL ? "": "disabled"}>
  	        ${CAN_CAPTURE_ON_ROAD_FUEL ? "Save and New": "Capture Not Authorised"}
  	      </button>`;

  	    const overlay = serviceModalShell(
  	      "On-Road Fuel Capture",
  	      vehicleTitleValue(vehicle) + " · Mileage is intentionally blank and must be entered for every fuel capture.",
  	      body,
  	      footer,
  	      true
  	    );
  	    overlay.querySelector(".fifsp-modal")?.classList.add("fif-road-fuel-modal");

  	    const form = overlay.querySelector("[data-road-fuel-form]");
  	    const totalNode = overlay.querySelector("[data-road-fuel-total]");
  	    const unitNode = overlay.querySelector("[data-road-fuel-unit]");
  	    const rebateNode = overlay.querySelector("[data-road-fuel-rebate]");
  	    const sarsNode = overlay.querySelector("[data-road-fuel-sars]");
  	    const deltaNode = overlay.querySelector("[data-road-fuel-mileage-delta]");
  	    const mileageLimitNode = overlay.querySelector("[data-road-fuel-mileage-limit]");
  	    const litresLimitNode = overlay.querySelector("[data-road-fuel-litres-limit]");
  	    const mileageHelpNode = overlay.querySelector("[data-road-fuel-mileage-help]");
  	    const litresHelpNode = overlay.querySelector("[data-road-fuel-litres-help]");
  	    const mileageErrorNode = overlay.querySelector("[data-road-fuel-mileage-error]");
  	    const litresErrorNode = overlay.querySelector("[data-road-fuel-litres-error]");
  	    const otherWrap = overlay.querySelector("[data-road-fuel-other-wrap]");
  	    let calculationSource = "unit";

  	    const locationByKey = Object.create(null);
  	    fuelLocations.forEach(function (item) {
  	      locationByKey[item.value] = item;
  	    });

  	    const syncLocation = function () {
  	      const select = form && form.elements.FuelLocationId;
  	      const other = !select || select.value === "__other__";
  	      if (otherWrap) otherWrap.hidden = !other;
  	      const contractor = form && form.elements.ContractorName;
  	      if (contractor) {
  	        contractor.required = other;
  	        if (!other) contractor.value = locationByKey[select.value] ? locationByKey[select.value].label: "";
  	        else if (contractor.value && fuelLocations.some(function (item) {
  	          return item.label === contractor.value;
  	        })) contractor.value = "";
  	      }
  	    };

  	    const refreshLimits = function () {
  	      limits = fifOnRoadFuelLimits(vehicle);
  	      currentMileage = limits.currentMileage;
  	      const mileageInput = form && form.elements.Mileage;
  	      const litresInput = form && form.elements.Litres;
  	      if (mileageInput) {
  	        mileageInput.min = currentMileage === null ? "0": String(currentMileage);
  	        if (limits.maximumMileage === null) mileageInput.removeAttribute("max");
  	        else mileageInput.max = String(limits.maximumMileage);
  	        mileageInput.placeholder = currentMileage === null
  	          ? "Enter vehicle mileage"
  	          : "Enter mileage; current is " + formatNumber(currentMileage, 0) + " km";
  	      }
  	      if (litresInput) {
  	        if (limits.tankCapacity > 0) litresInput.max = String(limits.tankCapacity);
  	        else litresInput.removeAttribute("max");
  	      }
  	      const mileageHelp = mileageHelpText();
  	      const litresHelp = litresHelpText();
  	      if (mileageHelpNode) mileageHelpNode.textContent = mileageHelp;
  	      if (litresHelpNode) litresHelpNode.textContent = litresHelp;
  	      if (mileageLimitNode) mileageLimitNode.textContent = mileageHelp;
  	      if (litresLimitNode) litresLimitNode.textContent = litresHelp;
  	    };

  	    const renderConstraints = function () {
  	      const mileageInput = form && form.elements.Mileage;
  	      const litresInput = form && form.elements.Litres;
  	      const mileage = numberValue(mileageInput && mileageInput.value);
  	      const litres = numberValue(litresInput && litresInput.value);

  	      let mileageError = "";
  	      if (mileage !== null && currentMileage !== null && mileage < currentMileage) {
  	        mileageError = "Reading cannot be lower than " + formatNumber(currentMileage, 0) + " km.";
  	      } else if (mileage !== null && limits.maximumMileage !== null && mileage > limits.maximumMileage) {
  	        mileageError = "Reading cannot be higher than " + formatNumber(limits.maximumMileage, 0) + " km.";
  	      }
  	      if (mileageInput) mileageInput.setCustomValidity(mileageError);
  	      if (mileageErrorNode) {
  	        mileageErrorNode.textContent = mileageError;
  	        mileageErrorNode.classList.toggle("visible", !!mileageError);
  	      }

  	      let litresError = "";
  	      if (litres !== null && litres <= 0) {
  	        litresError = "Litres must be greater than 0.";
  	      } else if (litres !== null && limits.tankCapacity > 0 && litres > limits.tankCapacity) {
  	        litresError = "Litres cannot exceed tank capacity of " + formatNumber(limits.tankCapacity, 2) + " L.";
  	      }
  	      if (litresInput) litresInput.setCustomValidity(litresError);
  	      if (litresErrorNode) {
  	        litresErrorNode.textContent = litresError;
  	        litresErrorNode.classList.toggle("visible", !!litresError);
  	      }
  	    };

  	    const renderCalculation = function (source, preserveActiveField) {
  	      if (source) calculationSource = source;
  	      const activeSource = source || calculationSource;
  	      const preserve = preserveActiveField === true;
  	      const litresInput = form && form.elements.Litres;
  	      const unitInput = form && form.elements.CostPerLitre;
  	      const totalInput = form && form.elements.Cost;
  	      const litres = numberValue(litresInput && litresInput.value);
  	      const unit = numberValue(unitInput && unitInput.value);
  	      const total = numberValue(totalInput && totalInput.value);

  	      try {
  	        const calculated = fifResolveFuelCalculation(litres, unit, total, calculationSource);

  	        if (!(preserve && activeSource === "litres")) {
  	          litresInput.value = calculated.Litres.toFixed(3);
  	        }
  	        if (!(preserve && activeSource === "unit")) {
  	          unitInput.value = calculated.CostPerLitre.toFixed(2);
  	        }
  	        if (!(preserve && activeSource === "total")) {
  	          totalInput.value = calculated.Cost.toFixed(2);
  	        }
  	      } catch (_) {}

  	      renderConstraints();

  	      const finalLitres = numberValue(litresInput && litresInput.value) || 0;
  	      const finalUnit = numberValue(unitInput && unitInput.value) || 0;
  	      const finalTotal = numberValue(totalInput && totalInput.value) || 0;
  	      const compliant = !!(form && form.elements.SARSCompliance && form.elements.SARSCompliance.checked);
  	      const rebate = compliant ? Math.round(finalLitres * sarsRate * 100) / 100: 0;

  	      if (unitNode) unitNode.textContent = formatCurrency(finalUnit);
  	      if (totalNode) totalNode.textContent = formatCurrency(finalTotal);
  	      if (rebateNode) rebateNode.textContent = formatCurrency(rebate);
  	      if (sarsNode) sarsNode.textContent = compliant ? "Yes": "No";

  	      const enteredMileage = numberValue(form && form.elements.Mileage && form.elements.Mileage.value);
  	      if (deltaNode) {
  	        if (enteredMileage === null) deltaNode.textContent = "Enter mileage";
  	        else if (currentMileage === null) deltaNode.textContent = "Baseline set at " + formatNumber(enteredMileage, 0) + " km";
  	        else deltaNode.textContent = formatNumber(enteredMileage - currentMileage, 0) + " km";
  	      }
  	    };

  	    const resetForNextCapture = function () {
  	      const selected = form && form.elements.FuelLocationId;
  	      if (form) {
  	        form.elements.FuelDate.value = fifLocalDateTimeValue(new Date());
  	        form.elements.Mileage.value = "";
  	        form.elements.Litres.value = "";
  	        form.elements.CostPerLitre.value = "";
  	        form.elements.Cost.value = "";
  	        form.elements.ReferenceNo.value = "";
  	        form.elements.SARSCompliance.checked = false;
  	        form.elements.Description.value = "On-road fuel purchase";
  	        if (selected) {
  	          selected.value = "__other__";
  	          syncStyledSelect(selected);
  	        }
  	        form.elements.ContractorName.value = "";
  	      }
  	      calculationSource = "unit";
  	      refreshLimits();
  	      syncLocation();
  	      renderCalculation();
  	      setTimeout(function () {
  	        try {
  	          const mileageInput = form && form.elements.Mileage;
  	          if (mileageInput) mileageInput.focus();
  	        } catch (_) {}
  	      }, 0);
  	    };

  	    form?.elements.FuelLocationId?.addEventListener("change", syncLocation);
  	    form?.elements.Litres?.addEventListener("input", function () {
  	      renderCalculation("litres", true);
  	    });
  	    form?.elements.Litres?.addEventListener("blur", function () {
  	      renderCalculation("litres", false);
  	    });
  	    form?.elements.CostPerLitre?.addEventListener("input", function () {
  	      renderCalculation("unit", true);
  	    });
  	    form?.elements.CostPerLitre?.addEventListener("blur", function () {
  	      renderCalculation("unit", false);
  	    });
  	    form?.elements.Cost?.addEventListener("input", function () {
  	      renderCalculation("total", true);
  	    });
  	    form?.elements.Cost?.addEventListener("blur", function () {
  	      renderCalculation("total", false);
  	    });
  	    form?.elements.Mileage?.addEventListener("input", function () {
  	      renderCalculation(null, true);
  	    });
  	    form?.elements.SARSCompliance?.addEventListener("change", function () {
  	      renderCalculation(null, true);
  	    });

  	    refreshLimits();
  	    syncLocation();
  	    renderCalculation();

  	    overlay.querySelector("[data-road-fuel-save]")?.addEventListener("click", async function (event) {
  	      const button = event.currentTarget;
  	      renderCalculation(calculationSource, false);
  	      if (!CAN_CAPTURE_ON_ROAD_FUEL || !form) return;

  	      if (!form.checkValidity()) {
  	        form.reportValidity();
  	        return;
  	      }

  	      const data = new FormData(form);
  	      const selectedLocationKey = clean(data.get("FuelLocationId"));
  	      const selectedLocation = selectedLocationKey === "__other__" ? null: locationByKey[selectedLocationKey];
  	      const supplierName = selectedLocation
  	        ? selectedLocation.label
  	        : clean(data.get("ContractorName"));

  	      button.disabled = true;
  	      button.textContent = "Saving…";
  	      const operation = fifBeginSaveOperation("Saving on-road fuel record…");

  	      try {
  	        const result = await saveOnRoadFuelCapture(company, vehicle, {
  	          FuelDate: data.get("FuelDate"),
  	          Mileage: data.get("Mileage"),
  	          Litres: data.get("Litres"),
  	          CostPerLitre: data.get("CostPerLitre"),
  	          Cost: data.get("Cost"),
  	          CalculationSource: calculationSource,
  	          ContractorName: supplierName,
  	          ReferenceNo: data.get("ReferenceNo"),
  	          Application: application,
  	          SARSCompliance: data.has("SARSCompliance"),
  	          Description: data.get("Description")
  	        });

  	        state.serviceProviderEmailInteractionActive = true;
  	        renderDynamicMainOnly();

  	        let providerNotification = {
  	          status: "Not checked",
  	          message: "Service Provider notification review did not run."
  	        };

  	        try {
  	          providerNotification = await fifFuelTransactionProviderNotificationReview(
  	            company,
  	            vehicle,
  	            result
  	          );
  	        } finally {
  	          state.serviceProviderEmailInteractionActive = false;
  	        }

  	        fifScheduleAutomaticServiceProviderNotifications(company);

  	        const tyreFailures = result.mileageUpdate ? result.mileageUpdate.tyreErrors.length: 0;
  	        const partial =
  	          !!result.mileageError ||
  	          !!result.periodSaveError ||
  	          tyreFailures > 0;
  	        fifCompleteSaveOperation(
  	          operation,
  	          partial
  	            ? "Fuel record saved. Automatic follow-up is still required for one or more related updates."
  	            : "Fuel record, mileage and related records saved."
  	        );
  	        const mileageResult = result.mileageUpdate;
  	        const mileageMessage = result.mileageError
  	          ? " Data.Vehicle.Usage.CurrentReading and tyre mileage could not be fully updated: " + clean(result.mileageError && (result.mileageError.message || result.mileageError.faultString))
  	          : mileageResult && mileageResult.delta > 0
  	            ? " Data.Vehicle.Usage.CurrentReading increased by " + formatNumber(mileageResult.delta, 0) + " km; " + mileageResult.tyresAdvanced + " fitted tyre(s) advanced using their position wear rates."
  	            : mileageResult && mileageResult.previousMileage === null
  	              ? " Data.Vehicle.Usage.CurrentReading baseline was established; historic tyre distance was not invented."
  	              : " Data.Vehicle.Usage.CurrentReading was unchanged.";

  	        await fifAlert(
  	          "The on-road fuel record was saved." +
  	          mileageMessage +
  	          (tyreFailures ? " " + tyreFailures + " tyre mileage update(s) failed and require attention.": "") +
  	          (result.periodSaveError ? " The monthly Tractorview summary could not be saved.": "") +
  	          (mileageResult && mileageResult.historyRepairs
  	            ? " " + mileageResult.historyRepairs + " tyre history stage(s) were restored automatically."
  	            : "") +
  	          " The form is ready for a new capture.",
  	          {
  	            title: partial ? "Fuel Capture Partially Saved": "Fuel Capture Saved",
  	            type: partial ? "warning": "success",
  	            confirmText: "Continue",
  	            details: [
  	              { label: "Vehicle", value: vehicleTitleValue(vehicle) },
  	              { label: "Fuel source", value: result.fuel.ContractorName },
  	              { label: "Previous mileage", value: result.fuel.MileageLast === null || result.fuel.MileageLast === undefined ? "Not set": formatNumber(result.fuel.MileageLast, 0) + " km" },
  	              { label: "Captured mileage", value: formatNumber(result.fuel.Mileage, 0) + " km" },
  	              { label: "Distance added", value: formatNumber(result.distance, 0) + " km" },
  	              { label: "Tyres advanced", value: mileageResult ? String(mileageResult.tyresAdvanced): "0" },
  	              { label: "Litres", value: formatLitres(result.fuel.Litres) },
  	              { label: "Price per litre", value: formatCurrency(result.fuel.CostPerLitre) },
  	              { label: "Cost", value: formatCurrency(result.fuel.Cost) },
  	              { label: "SARS compliant", value: result.fuel.SARSCompliance ? "Yes": "No" },
  	              { label: "Potential rebate", value: formatCurrency(result.rebate) },
  	              { label: "Provider notification", value: providerNotification.status },
  	              { label: "Notification result", value: providerNotification.message }
  	            ]
  	          }
  	        );

  	        resetForNextCapture();
  	      } catch (error) {
  	        fifFailSaveOperation(operation, error);
  	        await fifAlert(
  	          error && error.message ? error.message: "The on-road fuel record could not be saved.",
  	          {
  	            title: "Fuel Capture Failed",
  	            type: "danger",
  	            confirmText: "Continue Editing"
  	          }
  	        );
  	      } finally {
  	        if (button && button.isConnected) {
  	          button.disabled = !CAN_CAPTURE_ON_ROAD_FUEL;
  	          button.textContent = CAN_CAPTURE_ON_ROAD_FUEL ? "Save and New": "Capture Not Authorised";
  	        }
  	      }
  	    });
  	  }

  	  const FIF_FUEL_REPORT_STYLE_ID = "fif-vehicle-fuel-report-v2170-style";

  	  function fifFuelReportDate(value) {
  	    const date = fifAlertDate(value);
  	    if (!date || Number.isNaN(date.getTime())) return "—";
  	    return date.toLocaleString(undefined, {
  	      year: "numeric",
  	      month: "short",
  	      day: "2-digit",
  	      hour: "2-digit",
  	      minute: "2-digit"
  	    });
  	  }

  	  function fifFuelReportMonthKey(value) {
  	    const date = fifAlertDate(value);
  	    if (!date || Number.isNaN(date.getTime())) return "";
  	    return date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0");
  	  }

  	  function fifFuelReportViewMonthKey(view) {
  	    const direct = clean(firstValue([
  	      view && view.MYearKey,
  	      view && view.MonthKey
  	    ], ""));
  	    if (/^\d{4}-\d{2}$/.test(direct)) return direct;

  	    const dateKey = fifFuelReportMonthKey(firstValue([
  	      view && view.DateStart,
  	      view && view.StartDate,
  	      view && view.created
  	    ], ""));
  	    if (dateKey) return dateKey;

  	    const label = clean(firstValue([
  	      view && view.MYear,
  	      view && view.Month,
  	      view && view.Period
  	    ], ""));
  	    return fifFuelReportMonthKey(label);
  	  }

  	  function fifFuelReportViewOptions(vehicle) {
  	    const rows = [];
  	    const seen = Object.create(null);

  	    function push(view, current, index) {
  	      if (!view) return;
  	      const objectKey = clean(view.objectId);
  	      const monthKey = fifFuelReportViewMonthKey(view);
  	      const baseKey = objectKey || monthKey || viewKey(view) || String(index);
  	      const key = (current ? "current:" : "history:") + baseKey;
  	      if (seen[key]) return;
  	      seen[key] = true;
  	      rows.push({
  	        key: key,
  	        view: view,
  	        current: current,
  	        monthKey: monthKey,
  	        label: viewLabel(view) + (current ? " · Current" : "")
  	      });
  	    }

  	    push(vehicle && vehicle.ViewC, true, 0);
  	    arr(vehicle && vehicle.ViewH).forEach(function (view, index) {
  	      push(view, false, index + 1);
  	    });

  	    return rows.sort(function (a, b) {
  	      if (a.current !== b.current) return a.current ? -1 : 1;
  	      return clean(b.monthKey || b.key).localeCompare(clean(a.monthKey || a.key));
  	    });
  	  }

  	  function fifFuelReportInitialOption(vehicle, requestedKey) {
  	    const options = fifFuelReportViewOptions(vehicle);
  	    if (!options.length) return null;

  	    const explicit = clean(requestedKey);
  	    if (explicit) {
  	      const match = options.find(function (option) { return option.key === explicit; });
  	      if (match) return match;
  	    }

  	    const selected = periodView(vehicle);
  	    if (selected) {
  	      const selectedId = clean(selected.objectId);
  	      const selectedMonth = fifFuelReportViewMonthKey(selected);
  	      const match = options.find(function (option) {
  	        return option.view === selected ||
  	          (selectedId && clean(option.view && option.view.objectId) === selectedId) ||
  	          (selectedMonth && option.monthKey === selectedMonth);
  	      });
  	      if (match) return match;
  	    }

  	    return options[0];
  	  }

  	  function fifFuelReportRecordKey(record) {
  	    return clean(firstValue([
  	      record && record.objectId,
  	      record && record.ID,
  	      record && record.FID
  	    ], "")) || [
  	      fifFuelReportMonthKey(record && record.FuelDate),
  	      numberOr(record && record.Mileage, 0),
  	      numberOr(record && record.Litres, 0),
  	      numberOr(record && record.Cost, 0),
  	      clean(record && record.ContractorName),
  	      clean(record && record.ReferenceNo)
  	    ].join("|");
  	  }

  	  function fifFuelReportRecordMatchesVehicle(record, vehicle) {
  	    if (!record || !vehicle) return false;
  	    const vehicleId = objectIdOf(vehicle);
  	    const recordIds = [
  	      record.TractorObjectId,
  	      record.VehicleObjectId,
  	      record.AssetObjectId,
  	      getDeep(record, ["Tractor", "objectId"], ""),
  	      getDeep(record, ["Vehicle", "objectId"], "")
  	    ].map(clean).filter(Boolean);
  	    if (recordIds.length) return recordIds.indexOf(vehicleId) !== -1;

  	    const vehicleLabel = vehicleTitleValue(vehicle);
  	    const registration = vehicleRegistrationValue(vehicle);
  	    const recordLabels = [
  	      record.TractorId,
  	      record.VehicleId,
  	      record.AssetId,
  	      record.Registration
  	    ].map(clean).filter(Boolean);
  	    if (recordLabels.length) {
  	      return recordLabels.indexOf(vehicleLabel) !== -1 ||
  	        (registration && recordLabels.indexOf(registration) !== -1);
  	    }
  	    return false;
  	  }

  	  function fifFuelReportNormalizeRecord(record) {
  	    const litres = numberValue(firstValue([
  	      record && record.Litres,
  	      record && record.Quantity
  	    ], null));
  	    let unit = numberValue(firstValue([
  	      record && record.CostPerLitre,
  	      record && record.UnitCost
  	    ], null));
  	    let cost = numberValue(firstValue([
  	      record && record.Cost,
  	      record && record.GrossAmount,
  	      record && record.NetAmount
  	    ], null));

  	    if (cost === null && litres !== null && unit !== null) cost = Math.round(litres * unit * 100) / 100;
  	    if (unit === null && litres !== null && litres > 0 && cost !== null) unit = Math.round(cost / litres * 100) / 100;

  	    const mileage = numberValue(firstValue([
  	      record && record.Mileage,
  	      record && record.Odometer
  	    ], null));
  	    const flespiMileage = numberValue(firstValue([
  	      record && record.FlespiMileage,
  	      record && record.FlespiCANVehicleMileage,
  	      record && record.CANVehicleMileage,
  	      getDeep(record, ["Data", "Audit", "FlespiMileage"], null)
  	    ], null));
  	    const readingUnit = clean(firstValue([
  	      record && record.ReadingUnit,
  	      getDeep(record, ["Data", "ReadingUnit"], null),
  	      "km"
  	    ], "km"));
  	    const mileageLast = numberValue(record && record.MileageLast);
  	    let distance = numberValue(firstValue([
  	      record && record.Distance,
  	      getDeep(record, ["Data", "Distance"], null)
  	    ], null));
  	    if (distance === null && mileage !== null && mileageLast !== null) distance = Math.max(0, mileage - mileageLast);

  	    const date = firstValue([
  	      record && record.FuelDate,
  	      record && record.TransactionDate,
  	      record && record.created
  	    ], "");

  	    return {
  	      raw: record,
  	      key: fifFuelReportRecordKey(record),
  	      objectId: clean(record && record.objectId),
  	      date: date,
  	      monthKey: fifFuelReportMonthKey(date),
  	      mileage: mileage,
  	      flespiMileage: flespiMileage,
  	      readingUnit: readingUnit,
  	      mileageLast: mileageLast,
  	      distance: Math.max(0, numberOr(distance, 0)),
  	      litres: Math.max(0, numberOr(litres, 0)),
  	      unitPrice: Math.max(0, numberOr(unit, 0)),
  	      cost: Math.max(0, numberOr(cost, 0)),
  	      supplier: clean(firstValue([record && record.ContractorName, record && record.SupplierName], "Not recorded")),
  	      application: clean(firstValue([record && record.Application, record && record.Subcategory], "Fuel")),
  	      reference: clean(firstValue([record && record.ReferenceNo, record && record.ReferenceNumber], "")),
  	      description: clean(record && record.Description),
  	      captureType: clean(firstValue([record && record.CaptureType, record && record.EntryType], "Fuel")),
  	      slipPhotoURL: clean(record && record.SlipPhotoURL),
  	      slipPhotoKey: clean(record && record.SlipPhotoKey),
  	      slipPhotoName: clean(record && record.SlipPhotoName),
  	      odometerPhotoURL: clean(record && record.OdometerPhotoURL),
  	      odometerPhotoKey: clean(record && record.OdometerPhotoKey),
  	      odometerPhotoName: clean(record && record.OdometerPhotoName),
  	      sarsCompliance: record && record.SARSCompliance === true,
  	      sarsRate: Math.max(0, numberOr(record && record.SARSRebateRate, 0)),
  	      rebate: Math.max(0, numberOr(record && record.PotentialSARSRebate, 0))
  	    };
  	  }

  	  function fifFuelReportRowsForPeriod(company, vehicle, view) {
  	    const result = [];
  	    const seen = Object.create(null);
  	    const directKeys = Object.create(null);
  	    const periodMonth = fifFuelReportViewMonthKey(view);

  	    function push(record, direct) {
  	      if (!record || typeof record !== "object") return;
  	      const normalized = fifFuelReportNormalizeRecord(record);
  	      if (!normalized.key || seen[normalized.key]) return;
  	      if (!direct && !fifFuelReportRecordMatchesVehicle(record, vehicle)) return;
  	      if (!direct && periodMonth && normalized.monthKey !== periodMonth) return;
  	      if (!direct && !periodMonth) return;
  	      seen[normalized.key] = true;
  	      result.push(normalized);
  	    }

  	    arr(view && view.Fuel).forEach(function (record) {
  	      const key = fifFuelReportRecordKey(record);
  	      if (key) directKeys[key] = true;
  	      push(record, true);
  	    });

  	    arr(vehicle && vehicle.FuelOut).forEach(function (record) {
  	      push(record, !!directKeys[fifFuelReportRecordKey(record)]);
  	    });

  	    arr(company && company.FuelOut).forEach(function (record) {
  	      push(record, !!directKeys[fifFuelReportRecordKey(record)]);
  	    });

  	    return result.sort(function (a, b) {
  	      const ad = fifAlertDate(a.date);
  	      const bd = fifAlertDate(b.date);
  	      return (bd ? bd.getTime() : 0) - (ad ? ad.getTime() : 0);
  	    });
  	  }

  	function fifFuelReportSummary(company, vehicle, view, rows) {
  	    rows = arr(rows);
  	    const rowsDistance = rows.reduce(function (sum, row) { return sum + numberOr(row.distance, 0); }, 0);
  	    const rowsLitres = rows.reduce(function (sum, row) { return sum + numberOr(row.litres, 0); }, 0);
  	    const rowsCost = rows.reduce(function (sum, row) { return sum + numberOr(row.cost, 0); }, 0);
  	    const rowsRebate = rows.reduce(function (sum, row) { return sum + numberOr(row.rebate, 0); }, 0);
  	    const rowsSarsLitres = rows.filter(function (row) { return row.sarsCompliance; }).reduce(function (sum, row) {
  	      return sum + numberOr(row.litres, 0);
  	    }, 0);
  	    const rowsSarsCost = rows.filter(function (row) { return row.sarsCompliance; }).reduce(function (sum, row) {
  	      return sum + numberOr(row.cost, 0);
  	    }, 0);

  	    const viewDistance = numberValue(view && view.Distance);
  	    const viewLitres = numberValue(view && view.Litres);
  	    const viewCost = numberValue(view && view.Cost);
  	    const viewRebate = numberValue(view && view.PotentialSARSRebate);
  	    const distance = viewDistance !== null ? Math.max(0, viewDistance) : rowsDistance;
  	    const litres = viewLitres !== null ? Math.max(0, viewLitres) : rowsLitres;
  	    const cost = viewCost !== null ? Math.max(0, viewCost) : rowsCost;
  	    const rebate = viewRebate !== null ? Math.max(0, viewRebate) : rowsRebate;
  	    const count = rows.length;
  	    const averagePrice = litres > 0 ? cost / litres : null;
  	    const consumption = distance > 0 ? litres / distance * 100 : null;
  	    const kilometersPerLitre = litres > 0 ? distance / litres : null;
  	    const costPerKm = distance > 0 ? cost / distance : null;
  	    const meterStart = numberValue(firstValue([
  	      view && view.MeterStart,
  	      rows.length ? rows[rows.length - 1].mileageLast : null,
  	      rows.length ? rows[rows.length - 1].mileage : null
  	    ], null));
  	    const meterEnd = numberValue(firstValue([
  	      view && view.MeterEnd,
  	      rows.length ? rows[0].mileage : null
  	    ], null));

  	    return {
  	      distance: distance,
  	      litres: litres,
  	      cost: cost,
  	      rebate: rebate,
  	      recordCount: count,
  	      averagePrice: averagePrice,
  	      consumption: consumption,
  	      kilometersPerLitre: kilometersPerLitre,
  	      costPerKm: costPerKm,
  	      meterStart: meterStart,
  	      meterEnd: meterEnd,
  	      sarsLitres: rowsSarsLitres,
  	      sarsCost: rowsSarsCost,
  	      nonSarsLitres: Math.max(0, rowsLitres - rowsSarsLitres),
  	      nonSarsCost: Math.max(0, rowsCost - rowsSarsCost),
  	      loadedRows: rows.length,
  	      viewDistance: viewDistance,
  	      viewLitres: viewLitres,
  	      viewCost: viewCost,
  	      rowsDistance: rowsDistance,
  	      rowsLitres: rowsLitres,
  	      rowsCost: rowsCost
  	    };
  	  }

  	function fifFuelReportQualityFlags(summary, rows) {
  	    const flags = [];
  	    if (!summary.loadedRows && summary.recordCount > 0) flags.push({ type: "warning", title: "Fuel detail not loaded", message: "The period summary exists, but its individual FuelOut relation rows are not present in App Data." });
  	    if (summary.litres > 0 && summary.distance <= 0) flags.push({ type: "danger", title: "Consumption unavailable", message: "Fuel exists without a positive period distance, so L/100 km cannot be calculated safely." });
  	    if (summary.viewLitres !== null && rows.length && Math.abs(summary.viewLitres - summary.rowsLitres) > 0.01) flags.push({ type: "warning", title: "Litres do not reconcile", message: "Tractorview reports " + formatLitres(summary.viewLitres) + " while loaded FuelOut rows total " + formatLitres(summary.rowsLitres) + "." });
  	    if (summary.viewCost !== null && rows.length && Math.abs(summary.viewCost - summary.rowsCost) > 0.01) flags.push({ type: "warning", title: "Cost does not reconcile", message: "Tractorview reports " + formatCurrency(summary.viewCost) + " while loaded FuelOut rows total " + formatCurrency(summary.rowsCost) + "." });
  	    const missingMileage = rows.filter(function (row) { return row.mileage === null; }).length;
  	    if (missingMileage) flags.push({ type: "warning", title: "Mileage missing", message: missingMileage + " fuel record" + (missingMileage === 1 ? "" : "s") + " do not contain a mileage reading." });
  	    if (!flags.length) flags.push({ type: "good", title: "Period data reconciled", message: "Loaded fuel totals and mileage evidence contain no immediate report warnings." });
  	    return flags;
  	  }

  	  function fifFuelReportComparison(current, previous, field, lowerIsBetter) {
  	    const currentValue = numberValue(current && current[field]);
  	    const previousValue = numberValue(previous && previous[field]);
  	    if (currentValue === null || previousValue === null || previousValue === 0) {
  	      return `<span class="neutral">No prior comparison</span>`;
  	    }
  	    const change = (currentValue - previousValue) / Math.abs(previousValue) * 100;
  	    const favourable = lowerIsBetter ? change <= 0 : change >= 0;
  	    const direction = change > 0 ? "▲" : change < 0 ? "▼" : "•";
  	    return `<span class="${Math.abs(change) < .01 ? "neutral" : favourable ? "good" : "bad"}">${direction} ${escapeHtml(formatNumber(Math.abs(change), 1))}%</span>`;
  	  }

  	  function fifFuelReportPeriodData(company, vehicle, option) {
  	    if (!option) return null;
  	    const rows = fifFuelReportRowsForPeriod(company, vehicle, option.view);
  	    return {
  	      option: option,
  	      rows: rows,
  	      summary: fifFuelReportSummary(company, vehicle, option.view, rows)
  	    };
  	  }

  	  function fifFuelReportPreviousData(company, vehicle, option) {
  	    const options = fifFuelReportViewOptions(vehicle)
  	      .filter(function (item) { return item.monthKey; })
  	      .sort(function (a, b) { return b.monthKey.localeCompare(a.monthKey); });
  	    const index = options.findIndex(function (item) { return item.key === option.key; });
  	    if (index < 0 || index >= options.length - 1) return null;
  	    return fifFuelReportPeriodData(company, vehicle, options[index + 1]);
  	  }

  	  const FIF_FUEL_TRACKING_STYLE_ID = "fif-fuel-tracking-evidence-v1-style";
  	  const FIF_FUEL_TRACKING_WINDOW_ID = "fif-fuel-tracking-evidence-window";
  	  const FIF_FUEL_TRACKING_WINDOW_MINUTES = 60;
  	  const FIF_FUEL_TRACKING_SERVICE = "FIFTrackingService";
  	  const FIF_FUEL_TRACKING_METHOD = "getTrackingWindow";
  	  const FIF_FUEL_TRACKING_CODELESS_FUNCTION = "fn_2cdb14e20aec99596e5725c4e3064843";
  	  const FIF_FUEL_TRACKING_FIELDS = [
  	    "timestamp",
  	    "server.timestamp",
  	    "position.latitude",
  	    "position.longitude",
  	    "position.valid",
  	    "position.speed",
  	    "position.direction",
  	    "position.altitude",
  	    "position.satellites",
  	    "engine.ignition.status",
  	    "movement.status",
  	    "can.vehicle.speed",
  	    "can.engine.rpm",
  	    "can.engine.temperature",
  	    "can.fuel.level",
  	    "can.fuel.volume",
  	    "can.fuel.consumed",
  	    "can.tracker.counted.fuel.consumed",
  	    "can.vehicle.mileage",
  	    "can.tracker.counted.mileage",
  	    "vehicle.mileage",
  	    "gps.odometer",
  	    "gps.mileage",
  	    "idle.status",
  	    "idle.total",
  	    "events",
  	    "device.id",
  	    "device.name",
  	    "ident"
  	  ];

  	  const FIF_FUEL_FILE_API_BASE = "https://files-api.fiffiles.com";
  	  const FIF_FUEL_DRIVER_PHOTO_CONFIG = Object.freeze({
  	    slip: {
  	      kind: "slip",
  	      label: "Fuel slip",
  	      urlField: "SlipPhotoURL",
  	      keyField: "SlipPhotoKey",
  	      nameField: "SlipPhotoName",
  	      rowUrlField: "slipPhotoURL",
  	      rowKeyField: "slipPhotoKey",
  	      rowNameField: "slipPhotoName"
  	    },
  	    odometer: {
  	      kind: "odometer",
  	      label: "Odometer / vehicle meter",
  	      urlField: "OdometerPhotoURL",
  	      keyField: "OdometerPhotoKey",
  	      nameField: "OdometerPhotoName",
  	      rowUrlField: "odometerPhotoURL",
  	      rowKeyField: "odometerPhotoKey",
  	      rowNameField: "odometerPhotoName"
  	    }
  	  });

  	  function fifTrackingDriverPhotoConfigs() {
  	    return [
  	      FIF_FUEL_DRIVER_PHOTO_CONFIG.slip,
  	      FIF_FUEL_DRIVER_PHOTO_CONFIG.odometer
  	    ];
  	  }

  	  function fifTrackingDriverPhotoSavedValue(row, config, valueKind) {
  	    const raw = row && row.raw && typeof row.raw === "object" ? row.raw : {};
  	    if (!config) return "";
  	    if (valueKind === "url") {
  	      return clean(firstValue([
  	        row && row[config.rowUrlField],
  	        raw && raw[config.urlField]
  	      ], ""));
  	    }
  	    if (valueKind === "key") {
  	      return clean(firstValue([
  	        row && row[config.rowKeyField],
  	        raw && raw[config.keyField]
  	      ], ""));
  	    }
  	    return clean(firstValue([
  	      row && row[config.rowNameField],
  	      raw && raw[config.nameField]
  	    ], ""));
  	  }

  	  async function fifTrackingHydrateFuelOutPhotoFields(row) {
  	    if (!row || typeof row !== "object") return row;
  	    const raw = row.raw && typeof row.raw === "object" ? row.raw : {};
  	    const objectId = clean(firstValue([
  	      row.objectId,
  	      raw.objectId
  	    ], ""));
  	    if (!objectId) return row;

  	    const sdk = fifResolveActualBackendlessSdk();
  	    if (!sdk || !sdk.Data || typeof sdk.Data.of !== "function") return row;

  	    try {
  	      const store = sdk.Data.of("FuelOut");
  	      if (!store || typeof store.findById !== "function") return row;
  	      const fresh = await store.findById(objectId);
  	      if (!fresh || typeof fresh !== "object") return row;

  	      row.raw = Object.assign({}, raw, fresh);
  	      fifTrackingDriverPhotoConfigs().forEach(function (config) {
  	        row[config.rowUrlField] = clean(firstValue([
  	          fresh[config.urlField],
  	          row[config.rowUrlField]
  	        ], ""));
  	        row[config.rowKeyField] = clean(firstValue([
  	          fresh[config.keyField],
  	          row[config.rowKeyField]
  	        ], ""));
  	        row[config.rowNameField] = clean(firstValue([
  	          fresh[config.nameField],
  	          row[config.rowNameField]
  	        ], ""));
  	      });
  	    } catch (error) {
  	      console.warn("FuelOut photo evidence refresh failed; using loaded App Data.", error);
  	    }

  	    return row;
  	  }

  	  async function fifTrackingFuelPhotoUserToken() {
  	    let token = "";
  	    const sdk = fifResolveActualBackendlessSdk();

  	    if (
  	      sdk &&
  	      sdk.UserService &&
  	      typeof sdk.UserService.getCurrentUserToken === "function"
  	    ) {
  	      try {
  	        token = sdk.UserService.getCurrentUserToken();
  	        if (token && typeof token.then === "function") token = await token;
  	      } catch (_) {
  	        token = "";
  	      }
  	    }

  	    if (!token) {
  	      token = firstValue([
  	        getDeep(APP_DATA, ["User", "user-token"], ""),
  	        getDeep(APP_DATA, ["User", "userToken"], ""),
  	        ""
  	      ], "");
  	    }

  	    token = clean(token);
  	    if (!token) {
  	      throw new Error("The logged-in Backendless session is unavailable for Driver photo evidence.");
  	    }
  	    return token;
  	  }

  	  function fifTrackingSafeFuelPhotoUrl(value, kind) {
  	    const rawUrl = clean(value);
  	    if (!rawUrl) return "";

  	    let parsed;
  	    try {
  	      parsed = new URL(rawUrl);
  	    } catch (_) {
  	      throw new Error("The saved Driver photo URL is invalid.");
  	    }

  	    if (
  	      parsed.origin !== FIF_FUEL_FILE_API_BASE ||
  	      !/^\/fuel-out\/[A-Za-z0-9_-]{1,64}\/photo\/(slip|odometer)\/[0-9a-f-]{36}\.(jpg|jpeg|png|webp)$/i.test(parsed.pathname)
  	    ) {
  	      throw new Error("The saved Driver photo URL is not trusted.");
  	    }

  	    const pathKind = (parsed.pathname.match(/\/photo\/(slip|odometer)\//i) || [])[1] || "";
  	    if (kind && clean(pathKind).toLowerCase() !== clean(kind).toLowerCase()) {
  	      throw new Error("The saved Driver photo does not match its evidence type.");
  	    }

  	    return parsed.href;
  	  }

  	  function fifTrackingBlobToDataUrl(blob) {
  	    return new Promise(function (resolve, reject) {
  	      if (!blob) {
  	        reject(new Error("The Driver photo response was empty."));
  	        return;
  	      }
  	      const reader = new FileReader();
  	      reader.onload = function () {
  	        const value = String(reader.result || "");
  	        if (!/^data:image\//i.test(value)) {
  	          reject(new Error("The Driver photo could not be prepared for the report."));
  	          return;
  	        }
  	        resolve(value);
  	      };
  	      reader.onerror = function () {
  	        reject(new Error("The Driver photo could not be prepared for the report."));
  	      };
  	      reader.readAsDataURL(blob);
  	    });
  	  }

  	  async function fifTrackingFetchDriverPhoto(row, config, token, signal) {
  	    const savedUrl = fifTrackingDriverPhotoSavedValue(row, config, "url");
  	    const savedName = fifTrackingDriverPhotoSavedValue(row, config, "name");
  	    const savedKey = fifTrackingDriverPhotoSavedValue(row, config, "key");

  	    if (!savedUrl) {
  	      return {
  	        kind: config.kind,
  	        label: config.label,
  	        name: savedName,
  	        key: savedKey,
  	        saved: false,
  	        loaded: false,
  	        objectUrl: "",
  	        dataUrl: "",
  	        bytes: 0,
  	        error: ""
  	      };
  	    }

  	    try {
  	      const trustedUrl = fifTrackingSafeFuelPhotoUrl(savedUrl, config.kind);
  	      const response = await fetch(trustedUrl, {
  	        method: "GET",
  	        headers: {
  	          "X-Backendless-User-Token": token
  	        },
  	        signal: signal || undefined,
  	        cache: "no-store"
  	      });

  	      if (!response.ok) {
  	        let message = "";
  	        try {
  	          const responseText = await response.text();
  	          const payload = responseText ? JSON.parse(responseText) : null;
  	          message = clean(payload && payload.error);
  	        } catch (_) {}
  	        throw new Error(message || "The Driver photo service returned " + response.status + ".");
  	      }

  	      const blob = await response.blob();
  	      if (!blob || !blob.size || !/^image\//i.test(clean(blob.type))) {
  	        throw new Error("The Driver photo response was not a valid image.");
  	      }

  	      const objectUrl = URL.createObjectURL(blob);
  	      let dataUrl = "";
  	      try {
  	        dataUrl = await fifTrackingBlobToDataUrl(blob);
  	      } catch (dataError) {
  	        try { URL.revokeObjectURL(objectUrl); } catch (_) {}
  	        throw dataError;
  	      }

  	      return {
  	        kind: config.kind,
  	        label: config.label,
  	        name: savedName || config.label,
  	        key: savedKey,
  	        saved: true,
  	        loaded: true,
  	        objectUrl: objectUrl,
  	        dataUrl: dataUrl,
  	        bytes: blob.size,
  	        error: ""
  	      };
  	    } catch (error) {
  	      if (error && error.name === "AbortError") throw error;
  	      return {
  	        kind: config.kind,
  	        label: config.label,
  	        name: savedName || config.label,
  	        key: savedKey,
  	        saved: true,
  	        loaded: false,
  	        objectUrl: "",
  	        dataUrl: "",
  	        bytes: 0,
  	        error: clean(error && error.message) || "The Driver photo could not be loaded."
  	      };
  	    }
  	  }

  	  async function fifTrackingLoadDriverPhotoEvidence(row, signal) {
  	    await fifTrackingHydrateFuelOutPhotoFields(row);

  	    const configs = fifTrackingDriverPhotoConfigs();
  	    const savedConfigs = configs.filter(function (config) {
  	      return !!fifTrackingDriverPhotoSavedValue(row, config, "url");
  	    });

  	    if (!savedConfigs.length) {
  	      return {
  	        items: configs.map(function (config) {
  	          return {
  	            kind: config.kind,
  	            label: config.label,
  	            name: "",
  	            key: "",
  	            saved: false,
  	            loaded: false,
  	            objectUrl: "",
  	            dataUrl: "",
  	            bytes: 0,
  	            error: ""
  	          };
  	        }),
  	        savedCount: 0,
  	        loadedCount: 0
  	      };
  	    }

  	    let token = "";
  	    try {
  	      token = await fifTrackingFuelPhotoUserToken();
  	    } catch (tokenError) {
  	      const tokenMessage = clean(tokenError && tokenError.message) || "The Driver photo session could not be verified.";
  	      return {
  	        items: configs.map(function (config) {
  	          const saved = !!fifTrackingDriverPhotoSavedValue(row, config, "url");
  	          return {
  	            kind: config.kind,
  	            label: config.label,
  	            name: fifTrackingDriverPhotoSavedValue(row, config, "name") || config.label,
  	            key: fifTrackingDriverPhotoSavedValue(row, config, "key"),
  	            saved: saved,
  	            loaded: false,
  	            objectUrl: "",
  	            dataUrl: "",
  	            bytes: 0,
  	            error: saved ? tokenMessage : ""
  	          };
  	        }),
  	        savedCount: savedConfigs.length,
  	        loadedCount: 0
  	      };
  	    }

  	    const items = await Promise.all(configs.map(function (config) {
  	      return fifTrackingFetchDriverPhoto(row, config, token, signal);
  	    }));

  	    return {
  	      items: items,
  	      savedCount: items.filter(function (item) { return item.saved; }).length,
  	      loadedCount: items.filter(function (item) { return item.loaded; }).length
  	    };
  	  }

  	  function fifTrackingRevokeDriverPhotoEvidence(evidence) {
  	    arr(evidence && evidence.items).forEach(function (item) {
  	      if (!item || !item.objectUrl) return;
  	      try { URL.revokeObjectURL(item.objectUrl); } catch (_) {}
  	      item.objectUrl = "";
  	    });
  	  }

  	  function fifTrackingDriverPhotosHtml(evidence) {
  	    const items = arr(evidence && evidence.items);
  	    if (!items.length) {
  	      return `<section class="fiftrk-snapshots fiftrk-driver-evidence"><header><span>Driver photographic evidence</span><strong>Fuel slip · odometer / vehicle meter</strong></header><div class="fiftrk-photo-empty">No optional Driver photos were supplied with this FuelOut.</div></section>`;
  	    }

  	    return `<section class="fiftrk-snapshots fiftrk-driver-evidence"><header><span>Driver photographic evidence</span><strong>Authenticated FuelOut uploads · click a photo to enlarge</strong></header>
  	      <div class="fiftrk-photo-grid">${items.map(function (item) {
  	        const stateClass = item.loaded ? "loaded" : item.saved ? "error" : "missing";
  	        const detail = item.loaded
  	          ? (item.name || "Photo attached")
  	          : item.saved
  	            ? (item.error || "Photo saved but could not be loaded")
  	            : "Not supplied · optional";
  	        return `<button type="button" class="fiftrk-photo-card ${escapeAttr(stateClass)}" data-fif-driver-photo-open="${escapeAttr(item.kind)}" ${item.loaded ? "" : "disabled"}>
  	          <span>${escapeHtml(item.label)}</span>
  	          <div class="fiftrk-photo-frame">${item.loaded
  	            ? `<img src="${escapeAttr(item.objectUrl)}" alt="${escapeAttr(item.label + " photo")}">`
  	            : `<div>${item.saved ? "Photo unavailable" : "No photo"}</div>`}</div>
  	          <small>${escapeHtml(detail)}</small>
  	        </button>`;
  	      }).join("")}</div>
  	    </section>`;
  	  }

  	  function fifTrackingDriverPhotosLoadingHtml() {
  	    return `<section class="fiftrk-snapshots fiftrk-driver-evidence"><header><span>Driver photographic evidence</span><strong>Fuel slip · odometer / vehicle meter</strong></header><div class="fiftrk-photo-empty">Checking optional Driver photos…</div></section>`;
  	  }

  	  function fifTrackingOpenDriverPhotoViewer(windowNode, evidence, kind) {
  	    if (!windowNode) return;
  	    const item = arr(evidence && evidence.items).find(function (photo) {
  	      return photo && photo.kind === kind && photo.loaded && photo.objectUrl;
  	    });
  	    if (!item) return;

  	    windowNode.querySelector("[data-fif-driver-photo-viewer]")?.remove();
  	    const viewer = document.createElement("div");
  	    viewer.className = "fiftrk-photo-viewer";
  	    viewer.setAttribute("data-fif-driver-photo-viewer", "");
  	    viewer.innerHTML = `<div class="fiftrk-photo-viewer-card" role="dialog" aria-modal="true" aria-label="${escapeAttr(item.label + " photo")}">
  	      <header><div><span>Driver evidence</span><strong>${escapeHtml(item.label)}</strong><small>${escapeHtml(item.name || "FuelOut photograph")}</small></div><button type="button" data-fif-driver-photo-close aria-label="Close photograph">×</button></header>
  	      <div class="fiftrk-photo-viewer-image"><img src="${escapeAttr(item.objectUrl)}" alt="${escapeAttr(item.label + " photo")}"></div>
  	    </div>`;
  	    windowNode.appendChild(viewer);

  	    const close = function () { viewer.remove(); };
  	    viewer.querySelector("[data-fif-driver-photo-close]")?.addEventListener("click", close);
  	    viewer.addEventListener("click", function (event) {
  	      if (event.target === viewer) close();
  	    });
  	  }

  	  function fifTrackingBindDriverPhotoButtons(windowNode, evidence) {
  	    if (!windowNode) return;
  	    windowNode.querySelectorAll("[data-fif-driver-photo-open]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        fifTrackingOpenDriverPhotoViewer(
  	          windowNode,
  	          evidence,
  	          clean(button.getAttribute("data-fif-driver-photo-open"))
  	        );
  	      });
  	    });
  	  }

  	  function fifTrackingReportDriverPhotoPage(evidence) {
  	    const photos = arr(evidence && evidence.items).filter(function (item) {
  	      return !!(item && item.loaded && /^data:image\//i.test(clean(item.dataUrl)));
  	    });
  	    if (!photos.length) return "";

  	    return `<section class="page-break driver-photo-page">
  	      <div class="section-title"><h2>Driver photographic evidence</h2><span>Optional images captured in Driver Mobile and retrieved through the authenticated File API</span></div>
  	      <div class="driver-photo-grid ${photos.length === 1 ? "single" : ""}">${photos.map(function (item) {
  	        return `<article class="driver-photo-card"><header><span>${escapeHtml(item.label)}</span><strong>${escapeHtml(item.name || "FuelOut photograph")}</strong></header><div><img data-driver-photo-report src="${escapeAttr(item.dataUrl)}" alt="${escapeAttr(item.label + " photo")}"></div></article>`;
  	      }).join("")}</div>
  	      <div class="driver-photo-note">These photographs are supporting Driver-captured evidence attached to this FuelOut record. They are not altered by the Dashboard.</div>
  	    </section>`;
  	  }

  	  function fifTrackingDriverPhotoStatus(evidence, kind) {
  	    const item = arr(evidence && evidence.items).find(function (photo) {
  	      return photo && photo.kind === kind;
  	    });
  	    if (!item || !item.saved) return "Not supplied";
  	    return item.loaded ? "Attached" : "Saved · unavailable";
  	  }

  	  function fifTrackingTimestampMs(value) {
  	    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.getTime();
  	    if (typeof value === "number" && Number.isFinite(value)) return value < 1e12 ? value * 1000 : value;
  	    const raw = clean(value);
  	    if (!raw) return null;
  	    const numeric = Number(raw);
  	    if (Number.isFinite(numeric)) return numeric < 1e12 ? numeric * 1000 : numeric;
  	    const parsed = Date.parse(raw);
  	    return Number.isFinite(parsed) ? parsed : null;
  	  }

  	  function fifTrackingValueHasClock(value) {
  	    if (value instanceof Date) return !Number.isNaN(value.getTime());
  	    if (typeof value === "number" && Number.isFinite(value)) return true;
  	    const raw = clean(value);
  	    if (!raw) return false;
  	    if (Number.isFinite(Number(raw))) return true;
  	    return /T\d{1,2}:\d{2}|\s\d{1,2}:\d{2}/i.test(raw);
  	  }

  	  // FuelOut timestamps can arrive from Driver Mobile with the South African
  	  // wall-clock value incorrectly tagged as UTC (for example 19:35 SA saved as
  	  // 19:35Z).  Backendless `created` is a genuine UTC instant, so use it as a
  	  // sanity check instead of blindly subtracting two hours from every record.
  	  function fifTrackingCorrectFuelCaptureTimestamp(value, createdValue) {
  	    const timestamp = fifTrackingTimestampMs(value);
  	    if (timestamp === null) return null;

  	    const createdTimestamp = fifTrackingTimestampMs(createdValue);
  	    if (createdTimestamp === null) return timestamp;

  	    const SOUTH_AFRICA_OFFSET_MS = 2 * 60 * 60 * 1000;
  	    const CLOCK_ERROR_TOLERANCE_MS = 20 * 60 * 1000;
  	    const aheadOfCreated = timestamp - createdTimestamp;

  	    // A freshly captured transaction cannot genuinely occur roughly two hours
  	    // after its own database creation time.  When it does, the FuelOut local
  	    // clock has been serialized with a false UTC suffix.
  	    if (
  	      aheadOfCreated >= SOUTH_AFRICA_OFFSET_MS - CLOCK_ERROR_TOLERANCE_MS &&
  	      aheadOfCreated <= SOUTH_AFRICA_OFFSET_MS + CLOCK_ERROR_TOLERANCE_MS
  	    ) {
  	      return timestamp - SOUTH_AFRICA_OFFSET_MS;
  	    }

  	    return timestamp;
  	  }

  	  function fifTrackingRecordAnchor(row) {
  	    const raw = row && row.raw ? row.raw : {};
  	    const candidates = [
  	      { value: raw.FuelDate, source: "Fuel date", fuelCapture: true },
  	      { value: raw.TransactionDate, source: "Transaction date", fuelCapture: true },
  	      { value: raw.CapturedAt, source: "Capture time", fuelCapture: true },
  	      { value: raw.created, source: "Record created", fuelCapture: false },
  	      { value: row && row.date, source: "Fuel record", fuelCapture: true }
  	    ];
  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const candidate = candidates[index];
  	      if (!fifTrackingValueHasClock(candidate.value)) continue;
  	      const timestamp = candidate.fuelCapture
  	        ? fifTrackingCorrectFuelCaptureTimestamp(candidate.value, raw.created)
  	        : fifTrackingTimestampMs(candidate.value);
  	      if (timestamp !== null) return { timestamp: timestamp, source: candidate.source, raw: candidate.value };
  	    }
  	    return null;
  	  }

  	  function fifTrackingValue(raw, keys) {
  	    if (!raw || typeof raw !== "object") return null;
  	    for (let index = 0; index < keys.length; index += 1) {
  	      const key = keys[index];
  	      if (Object.prototype.hasOwnProperty.call(raw, key)) {
  	        const value = descriptorValue(raw[key]);
  	        if (value !== null && value !== undefined && value !== "") return value;
  	      }
  	      const nestedValue = String(key).split(".").reduce(function (value, part) {
  	        return value && value[part] !== undefined ? value[part] : undefined;
  	      }, raw);
  	      const resolvedNestedValue = descriptorValue(nestedValue);
  	      if (resolvedNestedValue !== null && resolvedNestedValue !== undefined && resolvedNestedValue !== "") return resolvedNestedValue;
  	    }
  	    return null;
  	  }

  	  function fifTrackingNumber(raw, keys) {
  	    const value = fifTrackingValue(raw, keys);
  	    if (value === null || value === undefined || value === "") return null;
  	    const numeric = Number(value);
  	    return Number.isFinite(numeric) ? numeric : null;
  	  }

  	  function fifTrackingBoolean(raw, keys) {
  	    const value = fifTrackingValue(raw, keys);
  	    if (value === true || value === 1) return true;
  	    if (value === false || value === 0) return false;
  	    const normalized = lower(value);
  	    if (["true", "yes", "on", "1", "running"].indexOf(normalized) !== -1) return true;
  	    if (["false", "no", "off", "0", "stopped"].indexOf(normalized) !== -1) return false;
  	    return null;
  	  }

  	  function fifTrackingVehicleId(vehicle) {
  	    return clean(descriptorValue(firstValue([
  	      vehicle && vehicle.Tracker,
  	      vehicle && vehicle.TrackerId,
  	      vehicle && vehicle.TrackerID,
  	      getDeep(vehicle, ["Data", "Tracking", "TrackerId"], ""),
  	      getDeep(vehicle, ["Data", "Telematics", "DeviceId"], "")
  	    ], "")));
  	  }

  	  function fifTrackingExtractRows(payload, depth) {
  	    depth = depth || 0;
  	    if (depth > 6 || payload === null || payload === undefined) return [];
  	    if (Array.isArray(payload)) return payload;
  	    if (typeof payload === "string") {
  	      try { return fifTrackingExtractRows(JSON.parse(payload), depth + 1); } catch (_) { return []; }
  	    }
  	    if (typeof payload !== "object") return [];
  	    const keys = ["result", "messages", "Tracking", "tracking", "rows", "items", "data", "body"];
  	    for (let index = 0; index < keys.length; index += 1) {
  	      if (payload[keys[index]] !== undefined) {
  	        const rows = fifTrackingExtractRows(payload[keys[index]], depth + 1);
  	        if (rows.length || Array.isArray(payload[keys[index]])) return rows;
  	      }
  	    }
  	    return [];
  	  }

  	  function fifTrackingMessageTime(raw) {
  	    return fifTrackingTimestampMs(fifTrackingValue(raw, ["timestamp", "server.timestamp", "created", "time", "ts"]));
  	  }

  	  function fifTrackingMatchingVehicles(vehicle) {
  	    const trackerId = fifTrackingVehicleId(vehicle);
  	    const result = [];
  	    const add = function (candidate) {
  	      if (!candidate || typeof candidate !== "object") return;
  	      const candidateTracker = fifTrackingVehicleId(candidate);
  	      if (candidate !== vehicle && trackerId && candidateTracker !== trackerId) return;
  	      if (result.indexOf(candidate) === -1) result.push(candidate);
  	    };
  	    add(vehicle);
  	    add(APP_DATA && APP_DATA.SelectedTractor);
  	    const companySources = []
  	      .concat(arr(getDeep(APP_DATA, ["User", "Companies"], [])))
  	      .concat(arr(APP_DATA && APP_DATA.Companies))
  	      .concat(arr(APP_DATA && APP_DATA.Company));
  	    companySources.forEach(function (company) {
  	      arr(company && company.Tractors).forEach(add);
  	    });
  	    return result;
  	  }

  	  function fifTrackingLoadedRows(vehicle, fromMs, toMs) {
  	    const candidates = [];
  	    fifTrackingMatchingVehicles(vehicle).forEach(function (candidate) {
  	      candidates.push(candidate && candidate.Tracking);
  	      candidates.push(candidate && candidate.TrackingHistory);
  	      candidates.push(candidate && candidate.TelemetryHistory);
  	    });
  	    candidates.push(getDeep(APP_DATA, ["Tracking", fifTrackingVehicleId(vehicle)], null));
  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const rows = fifTrackingExtractRows(candidates[index]);
  	      if (!rows.length) continue;
  	      const filtered = rows.filter(function (raw) {
  	        const timestamp = fifTrackingMessageTime(raw);
  	        return timestamp !== null && timestamp >= fromMs && timestamp <= toMs;
  	      });
  	      if (filtered.length) return filtered;
  	    }
  	    return [];
  	  }

  	  function fifTrackingCodelessLoader() {
  	    const functionId = fifTrackingServiceConfig("CodelessFunctionId", FIF_FUEL_TRACKING_CODELESS_FUNCTION);
  	    const runtimes = [];
  	    try { if (typeof BackendlessUI !== "undefined" && BackendlessUI) runtimes.push(BackendlessUI); } catch (_) {}
  	    try { if (typeof window !== "undefined" && window.BackendlessUI && runtimes.indexOf(window.BackendlessUI) === -1) runtimes.push(window.BackendlessUI); } catch (_) {}
  	    for (let index = 0; index < runtimes.length; index += 1) {
  	      const custom = getDeep(runtimes[index], ["Functions", "Custom"], null);
  	      if (custom && typeof custom[functionId] === "function") {
  	        return { owner: custom, fn: custom[functionId], functionId: functionId };
  	      }
  	    }
  	    return null;
  	  }

  	  async function fifTrackingInvokeCodelessLoader(vehicle, payload) {
  	    const loader = fifTrackingCodelessLoader();
  	    if (!loader) return { available: false, rows: [] };
  	    const hadSelected = Object.prototype.hasOwnProperty.call(APP_DATA, "SelectedTractor");
  	    const previousSelected = APP_DATA.SelectedTractor;
  	    let returned;
  	    try {
  	      APP_DATA.SelectedTractor = vehicle;
  	      returned = await loader.fn.call(
  	        loader.owner,
  	        APP_DATA,
  	        payload.trackerId,
  	        new Date(payload.to * 1000),
  	        new Date(payload.from * 1000)
  	      );
  	      const loadedRows = fifTrackingLoadedRows(vehicle, payload.from * 1000, payload.to * 1000);
  	      if (loadedRows.length) return { available: true, rows: loadedRows };
  	      const returnedRows = fifTrackingExtractRows(returned).filter(function (raw) {
  	        const timestamp = fifTrackingMessageTime(raw);
  	        return timestamp !== null && timestamp >= payload.from * 1000 && timestamp <= payload.to * 1000;
  	      });
  	      return { available: true, rows: returnedRows };
  	    } finally {
  	      if (hadSelected) APP_DATA.SelectedTractor = previousSelected;
  	      else delete APP_DATA.SelectedTractor;
  	    }
  	  }

  	  function fifTrackingProviderFunctions() {
  	    const rows = [];
  	    const seen = [];
  	    const add = function (owner, name) {
  	      if (!owner || typeof owner[name] !== "function") return;
  	      const fn = owner[name];
  	      if (seen.indexOf(fn) !== -1) return;
  	      seen.push(fn);
  	      rows.push({ owner: owner, fn: fn, label: name });
  	    };
  	    try {
  	      add(window.FIFTrackingProvider, "loadWindow");
  	      add(window.FIFTrackingProvider, "loadHistory");
  	    } catch (_) {}
  	    add(APP_INPUT, "loadTrackingWindow");
  	    add(APP_INPUT && APP_INPUT.TrackingProvider, "loadWindow");
  	    add(APP_DATA && APP_DATA.TrackingProvider, "loadWindow");
  	    return rows;
  	  }

  	  function fifTrackingServiceConfig(key, fallback) {
  	    return clean(firstValue([
  	      getDeep(APP_DATA, ["Tracking", key], ""),
  	      getDeep(APP_DATA, ["Configuration", "Tracking", key], ""),
  	      getDeep(APP_INPUT, ["Tracking", key], ""),
  	      fallback
  	    ], fallback));
  	  }

  	  async function fifTrackingInvokeSecureService(payload) {
  	    const api = fifResolveDatabaseApi();
  	    if (!api) throw new Error("The database SDK is not available for tracking history.");
  	    const service = fifTrackingServiceConfig("Service", FIF_FUEL_TRACKING_SERVICE);
  	    const method = fifTrackingServiceConfig("Method", FIF_FUEL_TRACKING_METHOD);
  	    if (api.APIServices && typeof api.APIServices.invoke === "function") {
  	      try {
  	        return await api.APIServices.invoke(service, method, payload);
  	      } catch (objectError) {
  	        try {
  	          return await api.APIServices.invoke(service, method, payload.trackerId, payload.from, payload.to, payload.fields);
  	        } catch (_) {
  	          throw objectError;
  	        }
  	      }
  	    }
  	    if (api.CustomServices && typeof api.CustomServices.invoke === "function") {
  	      return api.CustomServices.invoke(service, method, payload);
  	    }
  	    throw new Error("The installed database SDK does not expose API Services.");
  	  }

  	  function fifTrackingDirectToken() {
  	    return clean(descriptorValue(firstValue([
  	      getDeep(APP_DATA, ["Tracking", "FlespiToken"], ""),
  	      getDeep(APP_DATA, ["Configuration", "Tracking", "FlespiToken"], ""),
  	      getDeep(APP_INPUT, ["Tracking", "FlespiToken"], ""),
  	      ""
  	    ], "")));
  	  }

  	  async function fifTrackingLoadDirectFlespi(payload, signal) {
  	    const token = fifTrackingDirectToken();
  	    if (!token) throw new Error("No direct read-only tracking token is configured.");
  	    const query = {
  	      from: payload.from,
  	      to: payload.to,
  	      fields: payload.fields.join(","),
  	      count: 10000,
  	      reverse: false
  	    };
  	    const url = "https://flespi.io/gw/devices/" + encodeURIComponent(payload.trackerId) +
  	      "/messages?data=" + encodeURIComponent(JSON.stringify(query));
  	    const response = await fetch(url, {
  	      method: "GET",
  	      signal: signal,
  	      headers: {
  	        Authorization: /^FlespiToken\s/i.test(token) ? token : "FlespiToken " + token,
  	        Accept: "application/json"
  	      }
  	    });
  	    const textBody = await response.text();
  	    let parsed = null;
  	    try { parsed = textBody ? JSON.parse(textBody) : null; } catch (_) {}
  	    if (!response.ok) {
  	      const message = clean(firstValue([
  	        parsed && parsed.errors && parsed.errors[0] && parsed.errors[0].reason,
  	        parsed && parsed.error,
  	        response.statusText,
  	        "Tracking history request failed."
  	      ], "Tracking history request failed."));
  	      throw new Error(message);
  	    }
  	    return parsed;
  	  }

  	  function fifTrackingCanEvidenceScore(rows) {
  	    let score = 0;
  	    let mileage = false;
  	    let fuel = false;
  	    let consumption = false;
  	    let engine = false;
  	    arr(rows).forEach(function (raw) {
  	      if (!raw || typeof raw !== "object") return;
  	      if (fifTrackingNumber(raw, ["can.vehicle.mileage"]) !== null) mileage = true;
  	      if (fifTrackingNumber(raw, ["can.fuel.volume", "can.fuel.level", "can.fuel.tank.volume", "can.fuel.tank.level"]) !== null) fuel = true;
  	      if (fifTrackingNumber(raw, ["can.tracker.counted.fuel.consumed", "can.fuel.consumed", "can.engine.total.fuel.used"]) !== null) consumption = true;
  	      if (
  	        fifTrackingNumber(raw, ["can.vehicle.speed", "can.engine.rpm", "can.engine.temperature"]) !== null ||
  	        fifTrackingBoolean(raw, ["can.engine.ignition.status", "engine.ignition.status", "movement.status"]) !== null
  	      ) engine = true;
  	    });
  	    if (mileage) score += 8;
  	    if (fuel) score += 8;
  	    if (consumption) score += 4;
  	    if (engine) score += 2;
  	    return score;
  	  }

  	  function fifTrackingBestRowsCandidate(current, rows, source, payload) {
  	    rows = fifTrackingExtractRows(rows);
  	    if (!rows.length) return current;
  	    const candidate = {
  	      rows: rows,
  	      source: source,
  	      payload: payload,
  	      canScore: fifTrackingCanEvidenceScore(rows)
  	    };
  	    if (!current) return candidate;
  	    if (candidate.canScore > current.canScore) return candidate;
  	    if (candidate.canScore === current.canScore && candidate.rows.length > current.rows.length) return candidate;
  	    return current;
  	  }

  	  async function fifTrackingLoadWindow(vehicle, anchorMs, signal) {
  	    const trackerId = fifTrackingVehicleId(vehicle);
  	    if (!trackerId) throw new Error("This vehicle has no Tracker device ID.");
  	    const radiusMs = FIF_FUEL_TRACKING_WINDOW_MINUTES * 60000;
  	    const fromMs = anchorMs - radiusMs;
  	    const toMs = anchorMs + radiusMs;
  	    const payload = {
  	      trackerId: trackerId,
  	      vehicleObjectId: objectIdOf(vehicle),
  	      vehicleId: vehicleTitleValue(vehicle),
  	      registration: vehicleRegistrationValue(vehicle),
  	      from: Math.floor(fromMs / 1000),
  	      to: Math.ceil(toMs / 1000),
  	      fromIso: new Date(fromMs).toISOString(),
  	      toIso: new Date(toMs).toISOString(),
  	      fields: FIF_FUEL_TRACKING_FIELDS.slice()
  	    };

  	    let best = null;
  	    const errors = [];

  	    // Do not stop at the first GPS-only history source. Fuel evidence requires
  	    // the richest CAN dataset available inside the same bounded time window.
  	    const loaded = fifTrackingLoadedRows(vehicle, fromMs, toMs);
  	    best = fifTrackingBestRowsCandidate(best, loaded, "Loaded vehicle tracking", payload);

  	    try {
  	      const codeless = await fifTrackingInvokeCodelessLoader(vehicle, payload);
  	      if (codeless.available) {
  	        best = fifTrackingBestRowsCandidate(best, codeless.rows, "Existing TrackIT history loader", payload);
  	      }
  	    } catch (error) {
  	      errors.push("TrackIT loader: " + clean(error && (error.message || error.faultString)));
  	    }

  	    const providers = fifTrackingProviderFunctions();
  	    for (let index = 0; index < providers.length; index += 1) {
  	      try {
  	        const result = await providers[index].fn.call(providers[index].owner, payload);
  	        best = fifTrackingBestRowsCandidate(best, result, "Installed tracking provider", payload);
  	      } catch (error) {
  	        errors.push(clean(error && (error.message || error.faultString)));
  	      }
  	    }

  	    try {
  	      const result = await fifTrackingInvokeSecureService(payload);
  	      best = fifTrackingBestRowsCandidate(best, result, "Secure tracking service", payload);
  	    } catch (error) {
  	      errors.push(clean(error && (error.message || error.faultString)));
  	    }

  	    // A configured direct Flespi source is authoritative for this evidence view.
  	    // Prefer it whenever it returns CAN-rich messages, rather than silently
  	    // settling for an earlier GPS-only history source.
  	    if (fifTrackingDirectToken()) {
  	      try {
  	        const result = await fifTrackingLoadDirectFlespi(payload, signal);
  	        const directRows = fifTrackingExtractRows(result);
  	        const direct = fifTrackingBestRowsCandidate(null, directRows, "Configured direct tracking source", payload);
  	        if (direct && (!best || direct.canScore >= best.canScore)) best = direct;
  	      } catch (error) {
  	        errors.push(clean(error && (error.message || error.faultString)));
  	      }
  	    }

  	    if (best && best.rows.length) return best;

  	    throw new Error(
  	      "Tracking history could not be loaded through TrackIT or the optional Dashboard providers. Install " +
  	      FIF_FUEL_TRACKING_SERVICE + "." + FIF_FUEL_TRACKING_METHOD +
  	      " or window.FIFTrackingProvider.loadWindow()." +
  	      (errors.filter(Boolean).length ? " Last response: " + errors.filter(Boolean).slice(-1)[0] : "")
  	    );
  	  }

  	  function fifTrackingConsoleLog(loaded, vehicle, row, anchorMs) {
  	    const tracking = fifDebugClone(arr(loaded && loaded.rows));
  	    const payload = loaded && loaded.payload ? loaded.payload : {};
  	    const snapshot = {
  	      build: typeof window !== "undefined" ? window.__FIF_DASHBOARD_BUILD__ : VERSION,
  	      receivedAt: new Date().toISOString(),
  	      source: clean(loaded && loaded.source) || "Unknown tracking source",
  	      vehicle: vehicleTitleValue(vehicle),
  	      transaction: fifTrackingFormatTime(anchorMs),
  	      request: {
  	        from: payload.from,
  	        to: payload.to,
  	        fromIso: payload.fromIso,
  	        toIso: payload.toIso,
  	        fields: fifDebugClone(payload.fields || [])
  	      },
  	      fuelRecord: fifDebugClone({
  	        date: row && row.date,
  	        litres: row && row.litres,
  	        capturedMileage: row && row.mileage,
  	        trackerMileage: row && row.flespiMileage,
  	        supplier: row && row.supplier,
  	        reference: row && row.reference
  	      }),
  	      messageCount: tracking.length,
  	      tracking: tracking
  	    };

  	    if (typeof window !== "undefined") window.__FIF_LAST_TRACKING_DEBUG__ = snapshot;

  	    // Always expose the exact returned Flespi/tracking messages in DevTools.
  	    // This is intentionally verbose for fuel-evidence diagnostics.
  	    try {
  	      if (typeof console !== "undefined") {
  	        const fuelCanMessages = tracking.filter(function (message) {
  	          if (!message || typeof message !== "object") return false;
  	          return (
  	            message["can.fuel.level"] !== undefined ||
  	            message["can.fuel.volume"] !== undefined ||
  	            message["can.fuel.consumed"] !== undefined ||
  	            message["can.tracker.counted.fuel.consumed"] !== undefined ||
  	            message["can.vehicle.mileage"] !== undefined ||
  	            message["can.engine.rpm"] !== undefined ||
  	            message["can.vehicle.speed"] !== undefined
  	          );
  	        });

  	        console.groupCollapsed(
  	          "[Fleet In Form] Fuel telemetry · " + snapshot.vehicle +
  	          " · " + snapshot.messageCount + " messages · " + snapshot.source
  	        );
  	        console.log("Fuel tracking request", snapshot.request);
  	        console.log("FuelOut record", snapshot.fuelRecord);
  	        console.log("Raw returned tracking/Flespi messages", tracking);
  	        console.log("Fuel/CAN messages", fuelCanMessages);
  	        if (typeof console.table === "function") {
  	          console.table(fuelCanMessages.map(function (message) {
  	            const rawTimestamp = message.timestamp !== undefined ? message.timestamp : message["server.timestamp"];
  	            const numericTimestamp = Number(rawTimestamp);
  	            return {
  	              time: Number.isFinite(numericTimestamp)
  	                ? new Date(numericTimestamp > 100000000000 ? numericTimestamp : numericTimestamp * 1000).toISOString()
  	                : rawTimestamp,
  	              fuelLevel: message["can.fuel.level"],
  	              fuelVolume: message["can.fuel.volume"],
  	              fuelConsumed: message["can.fuel.consumed"],
  	              trackerFuelConsumed: message["can.tracker.counted.fuel.consumed"],
  	              canMileage: message["can.vehicle.mileage"],
  	              rpm: message["can.engine.rpm"],
  	              canSpeed: message["can.vehicle.speed"],
  	              gpsSpeed: message["position.speed"],
  	              ignition: message["engine.ignition.status"],
  	              idle: message["idle.status"]
  	            };
  	          }));
  	        }
  	        console.log("Full debug snapshot", snapshot);
  	        console.groupEnd();
  	      }
  	    } catch (_) {}

  	    return snapshot;
  	  }

  	  if (typeof window !== "undefined") {
  	    window.FIF_LAST_TRACKING_JSON = function () {
  	      return JSON.stringify(fifDebugClone(window.__FIF_LAST_TRACKING_DEBUG__), null, 2);
  	    };
  	    window.FIF_DUMP_LAST_TRACKING_DEBUG = function () {
  	      const snapshot = fifDebugClone(window.__FIF_LAST_TRACKING_DEBUG__);

  	      if (snapshot && snapshot.tracking)

  	      return snapshot;
  	    };
  	    window.FIF_COPY_LAST_TRACKING_DEBUG = async function () {
  	      const json = window.FIF_LAST_TRACKING_JSON();
  	      try {
  	        if (typeof navigator !== "undefined" && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
  	          await navigator.clipboard.writeText(json);

  	          return true;
  	        }
  	      } catch (error) {

  	      }

  	      return json;
  	    };
  	    window.FIF_DOWNLOAD_LAST_TRACKING_DEBUG = function () {
  	      const snapshot = fifDebugClone(window.__FIF_LAST_TRACKING_DEBUG__);
  	      if (!snapshot) {

  	        return false;
  	      }
  	      const json = JSON.stringify(snapshot, null, 2);
  	      const blob = new Blob([json], { type: "application/json;charset=utf-8" });
  	      const url = URL.createObjectURL(blob);
  	      const link = document.createElement("a");
  	      const stamp = clean(snapshot.receivedAt || new Date().toISOString()).replace(/[^0-9A-Za-z-]+/g, "-");
  	      link.href = url;
  	      link.download = "FIF-Tracking-" + (clean(snapshot.vehicle) || "Vehicle") + "-" + stamp + ".json";
  	      link.style.display = "none";
  	      document.body.appendChild(link);
  	      link.click();
  	      link.remove();
  	      setTimeout(function () { URL.revokeObjectURL(url); }, 1500);

  	      return true;
  	    };
  	  }

  	  function fifTrackingNormalizePoints(rows, fromMs, toMs) {
  	    const seen = Object.create(null);
  	    return arr(rows).map(function (raw) {
  	      const timestamp = fifTrackingMessageTime(raw);
  	      const lat = fifTrackingNumber(raw, ["position.latitude", "latitude", "lat"]);
  	      const lng = fifTrackingNumber(raw, ["position.longitude", "longitude", "lng", "lon"]);
  	      if (timestamp === null || timestamp < fromMs || timestamp > toMs) return null;
  	      if (lat === null || lng === null || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  	      const key = timestamp + "|" + lat.toFixed(7) + "|" + lng.toFixed(7);
  	      if (seen[key]) return null;
  	      seen[key] = true;
  	      return {
  	        timestamp: timestamp,
  	        lat: lat,
  	        lng: lng,
  	        speed: fifTrackingNumber(raw, ["position.speed", "can.vehicle.speed"]),
  	        heading: fifTrackingNumber(raw, ["position.direction", "course", "heading"]),
  	        valid: fifTrackingBoolean(raw, ["position.valid"]),
  	        raw: raw
  	      };
  	    }).filter(Boolean).sort(function (a, b) { return a.timestamp - b.timestamp; });
  	  }

  	  function fifTrackingRadians(value) { return value * Math.PI / 180; }

  	  function fifTrackingDistanceM(left, right) {
  	    if (!left || !right) return 0;
  	    const earth = 6371000;
  	    const dLat = fifTrackingRadians(right.lat - left.lat);
  	    const dLng = fifTrackingRadians(right.lng - left.lng);
  	    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  	      Math.cos(fifTrackingRadians(left.lat)) * Math.cos(fifTrackingRadians(right.lat)) *
  	      Math.sin(dLng / 2) * Math.sin(dLng / 2);
  	    return earth * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  	  }

  	  function fifTrackingNearest(points, anchorMs) {
  	    let nearest = null;
  	    let difference = Infinity;
  	    arr(points).forEach(function (point) {
  	      const current = Math.abs(point.timestamp - anchorMs);
  	      if (current < difference) { difference = current; nearest = point; }
  	    });
  	    return nearest;
  	  }

  	  function fifTrackingSnapshotBefore(points, anchorMs) {
  	    let result = null;
  	    arr(points).forEach(function (point) { if (point.timestamp <= anchorMs) result = point; });
  	    return result;
  	  }

  	  function fifTrackingSnapshotAfter(points, anchorMs) {
  	    return arr(points).find(function (point) { return point.timestamp >= anchorMs; }) || null;
  	  }

  	  function fifTrackingOdometer(raw) {
  	    // Fuel evidence must use the vehicle ECU/CAN odometer first.
  	    // Generic calculated tracker mileage is only a fallback when CAN is absent.
  	    return fifTrackingNumber(raw, [
  	      "can.vehicle.mileage",
  	      "can.tracker.counted.mileage",
  	      "vehicle.mileage",
  	      "gps.odometer",
  	      "gps.mileage"
  	    ]);
  	  }

  	  function fifTrackingFuel(raw, vehicle) {
  	    const level = fifTrackingNumber(raw, ["can.fuel.level", "can.fuel.tank.level", "fuel.level"]);
  	    const volume = fifTrackingNumber(raw, ["can.fuel.volume", "can.fuel.tank.volume", "fuel.volume"]);
  	    if (volume !== null) return { value: volume, unit: "L", source: "CAN volume", rawValue: volume, rawUnit: "L" };
  	    if (level !== null) {
  	      const tank = fifVehicleFuelTankCapacity(vehicle);
  	      if (tank > 0) return { value: level / 100 * tank, unit: "L", source: "CAN level", rawValue: level, rawUnit: "%" };
  	      return { value: level, unit: "%", source: "CAN level", rawValue: level, rawUnit: "%" };
  	    }
  	    return null;
  	  }

  	  function fifTrackingFuelConsumed(raw) {
  	    return fifTrackingNumber(raw, [
  	      "can.tracker.counted.fuel.consumed",
  	      "can.fuel.consumed",
  	      "can.engine.total.fuel.used",
  	      "fuel.consumed"
  	    ]);
  	  }

  	  function fifTrackingMedian(values) {
  	    const rows = arr(values).filter(function (value) { return Number.isFinite(value); }).sort(function (a, b) { return a - b; });
  	    if (!rows.length) return null;
  	    const middle = Math.floor(rows.length / 2);
  	    return rows.length % 2 ? rows[middle] : (rows[middle - 1] + rows[middle]) / 2;
  	  }

  	  function fifTrackingIsMoving(point) {
  	    if (!point) return null;
  	    if (point.speed !== null && point.speed !== undefined) return point.speed > 2;
  	    return fifTrackingBoolean(point.raw, ["movement.status", "moving.status"]);
  	  }

  	  function fifTrackingFuelSamples(points, vehicle) {
  	    return arr(points).map(function (point) {
  	      const fuel = fifTrackingFuel(point.raw, vehicle);
  	      return fuel ? { point: point, fuel: fuel, value: fuel.value } : null;
  	    }).filter(Boolean);
  	  }

  	  function fifTrackingRepresentativeSample(samples, targetValue) {
  	    if (!samples.length || !Number.isFinite(targetValue)) return null;
  	    return samples.slice().sort(function (left, right) {
  	      const valueDifference = Math.abs(left.value - targetValue) - Math.abs(right.value - targetValue);
  	      return valueDifference || right.point.timestamp - left.point.timestamp;
  	    })[0];
  	  }

  	  function fifTrackingFuelStableTolerance(tankCapacity, unit) {
  	    if (unit === "L") return tankCapacity > 0 ? Math.max(.8, tankCapacity * .015) : .75;
  	    if (unit === "%") return 1.5;
  	    return .75;
  	  }

  	  function fifTrackingStableFuelPlateaus(points, vehicle) {
  	    const tankCapacity = fifVehicleFuelTankCapacity(vehicle);
  	    const samples = fifTrackingFuelSamples(points, vehicle)
  	      .filter(function (sample) {
  	        // A moving tank is allowed to remain visible as evidence, but it must not
  	        // establish a baseline. Unknown movement is retained and then has to pass
  	        // the stability tests below.
  	        return fifTrackingIsMoving(sample.point) !== true;
  	      })
  	      .sort(function (left, right) {
  	        return left.point.timestamp - right.point.timestamp;
  	      });

  	    if (!samples.length) return [];

  	    const maxGapMs = 600000;
  	    const plateaus = [];
  	    let bucket = [];

  	    const commit = function () {
  	      if (!bucket.length) return;

  	      const unit = bucket[0].fuel.unit;
  	      const tolerance = fifTrackingFuelStableTolerance(tankCapacity, unit);
  	      const firstMedian = fifTrackingMedian(bucket.map(function (sample) { return sample.value; }));
  	      let inliers = bucket.filter(function (sample) {
  	        return firstMedian !== null && Math.abs(sample.value - firstMedian) <= tolerance;
  	      });

  	      if (inliers.length < 2) {
  	        bucket = [];
  	        return;
  	      }

  	      const median = fifTrackingMedian(inliers.map(function (sample) { return sample.value; }));
  	      inliers = inliers.filter(function (sample) {
  	        return median !== null && Math.abs(sample.value - median) <= tolerance;
  	      });

  	      if (inliers.length < 2 || median === null) {
  	        bucket = [];
  	        return;
  	      }

  	      const startMs = inliers[0].point.timestamp;
  	      const endMs = inliers[inliers.length - 1].point.timestamp;
  	      const durationMs = Math.max(0, endMs - startMs);
  	      const values = inliers.map(function (sample) { return sample.value; });
  	      const spread = Math.max.apply(Math, values) - Math.min.apply(Math, values);
  	      const stable = inliers.length >= 3 && (durationMs >= 10000 || inliers.length >= 4);

  	      if (stable) {
  	        const representative = fifTrackingRepresentativeSample(inliers, median);
  	        plateaus.push({
  	          unit: unit,
  	          value: median,
  	          samples: inliers,
  	          sampleCount: inliers.length,
  	          startMs: startMs,
  	          endMs: endMs,
  	          durationMs: durationMs,
  	          spread: spread,
  	          tolerance: tolerance,
  	          representative: representative,
  	          qualityScore:
  	            inliers.length * 4 +
  	            Math.min(durationMs, 180000) / 30000 -
  	            (tolerance > 0 ? spread / tolerance : 0)
  	        });
  	      }

  	      bucket = [];
  	    };

  	    samples.forEach(function (sample) {
  	      if (!bucket.length) {
  	        bucket = [sample];
  	        return;
  	      }

  	      const previous = bucket[bucket.length - 1];
  	      const unit = bucket[0].fuel.unit;
  	      const tolerance = fifTrackingFuelStableTolerance(tankCapacity, unit);
  	      const median = fifTrackingMedian(bucket.map(function (candidate) { return candidate.value; }));
  	      const gap = sample.point.timestamp - previous.point.timestamp;
  	      const compatibleUnit = sample.fuel.unit === unit;
  	      const compatibleValue = median !== null && Math.abs(sample.value - median) <= tolerance * 1.5;

  	      if (gap <= maxGapMs && compatibleUnit && compatibleValue) {
  	        bucket.push(sample);
  	      } else {
  	        commit();
  	        bucket = [sample];
  	      }
  	    });

  	    commit();

  	    // Merge adjacent stable plateaus that are really the same settled fuel level
  	    // separated only by sparse packets. Do not bridge long movement periods.
  	    const merged = [];
  	    plateaus.forEach(function (plateau) {
  	      const previous = merged.length ? merged[merged.length - 1] : null;
  	      if (
  	        previous &&
  	        previous.unit === plateau.unit &&
  	        plateau.startMs - previous.endMs <= 600000 &&
  	        Math.abs(plateau.value - previous.value) <= Math.max(previous.tolerance, plateau.tolerance)
  	      ) {
  	        const combinedSamples = previous.samples.concat(plateau.samples).sort(function (left, right) {
  	          return left.point.timestamp - right.point.timestamp;
  	        });
  	        const combinedMedian = fifTrackingMedian(combinedSamples.map(function (sample) { return sample.value; }));
  	        const representative = fifTrackingRepresentativeSample(combinedSamples, combinedMedian);
  	        const values = combinedSamples.map(function (sample) { return sample.value; });
  	        previous.samples = combinedSamples;
  	        previous.sampleCount = combinedSamples.length;
  	        previous.value = combinedMedian;
  	        previous.endMs = combinedSamples[combinedSamples.length - 1].point.timestamp;
  	        previous.durationMs = previous.endMs - previous.startMs;
  	        previous.spread = Math.max.apply(Math, values) - Math.min.apply(Math, values);
  	        previous.representative = representative;
  	        previous.qualityScore =
  	          combinedSamples.length * 4 +
  	          Math.min(previous.durationMs, 180000) / 30000 -
  	          (previous.tolerance > 0 ? previous.spread / previous.tolerance : 0);
  	        return;
  	      }
  	      merged.push(plateau);
  	    });

  	    return merged;
  	  }

  	  function fifTrackingSelectRefuelPlateauPair(plateaus, anchorMs, tankCapacity) {
  	    const rows = arr(plateaus);
  	    if (rows.length < 2) return null;

  	    const maximumPairGapMs = 75 * 60 * 1000;
  	    const maximumEventDistanceMs = 60 * 60 * 1000;
  	    const minimumRise = tankCapacity > 0 ? Math.max(2, tankCapacity * .03) : 2;
  	    const candidates = [];

  	    for (let preIndex = 0; preIndex < rows.length - 1; preIndex += 1) {
  	      for (let postIndex = preIndex + 1; postIndex < rows.length; postIndex += 1) {
  	        const pre = rows[preIndex];
  	        const post = rows[postIndex];
  	        if (!pre || !post || pre.unit !== post.unit) continue;

  	        const gapMs = post.startMs - pre.endMs;
  	        if (gapMs < 0 || gapMs > maximumPairGapMs) continue;

  	        const rise = post.value - pre.value;
  	        if (!Number.isFinite(rise) || rise < minimumRise) continue;

  	        // The first settled high reading is a better event locator than the
  	        // manually saved FuelOut timestamp. The timestamp only bounds the search.
  	        const eventMs = post.startMs;
  	        const eventDistanceMs = Math.abs(eventMs - anchorMs);
  	        if (eventDistanceMs > maximumEventDistanceMs) continue;

  	        const plateauStrength = pre.qualityScore + post.qualityScore;
  	        const closeTier = eventDistanceMs <= 5 * 60 * 1000 ? 0 : eventDistanceMs <= 10 * 60 * 1000 ? 1 : 2;
  	        const score =
  	          plateauStrength * 100 +
  	          Math.min(rise, tankCapacity > 0 ? tankCapacity : 100) * 2 -
  	          eventDistanceMs / 1000 * .20 -
  	          gapMs / 1000 * .03;

  	        candidates.push({
  	          pre: pre,
  	          post: post,
  	          rise: rise,
  	          eventMs: eventMs,
  	          eventDistanceMs: eventDistanceMs,
  	          gapMs: gapMs,
  	          closeTier: closeTier,
  	          score: score,
  	          minimumRise: minimumRise
  	        });
  	      }
  	    }

  	    if (!candidates.length) return null;

  	    candidates.sort(function (left, right) {
  	      if (left.closeTier !== right.closeTier) return left.closeTier - right.closeTier;
  	      if (Math.abs(left.score - right.score) > .001) return right.score - left.score;
  	      if (left.eventDistanceMs !== right.eventDistanceMs) return left.eventDistanceMs - right.eventDistanceMs;
  	      return right.rise - left.rise;
  	    });

  	    return candidates[0];
  	  }

  	  function fifTrackingFuelConsumedDelta(fromPoint, toPoint, tankCapacity) {
  	    if (!fromPoint || !toPoint || toPoint.timestamp < fromPoint.timestamp) return null;
  	    const before = fifTrackingFuelConsumed(fromPoint.raw);
  	    const after = fifTrackingFuelConsumed(toPoint.raw);
  	    if (before === null || after === null || after < before) return null;
  	    const difference = after - before;
  	    if (difference > Math.max(20, tankCapacity || 0)) return null;
  	    return difference;
  	  }

  	  function fifTrackingRefuelEvidence(points, anchorMs, vehicle, capturedLitres) {
  	    const tankCapacity = fifVehicleFuelTankCapacity(vehicle);
  	    const nearest = fifTrackingNearest(points, anchorMs);
  	    const result = {
  	      detected: false,
  	      quality: "none",
  	      reason: "Fuel telemetry unavailable",
  	      tankCapacity: tankCapacity > 0 ? tankCapacity : null,
  	      capturedLitres: numberValue(capturedLitres),
  	      stationPoint: nearest,
  	      arrivalPoint: null,
  	      prePoint: null,
  	      postPoint: null,
  	      preFuel: null,
  	      postFuel: null,
  	      arrivalFuelLitres: null,
  	      ullageLitres: null,
  	      rawFuelIncrease: null,
  	      consumedLitres: null,
  	      arrivalConsumptionLitres: null,
  	      varianceLitres: null,
  	      variancePercent: null,
  	      ullageVarianceLitres: null,
  	      stopDurationMs: null,
  	      stopTransitionFound: false,
  	      preSampleCount: 0,
  	      postSampleCount: 0,
  	      preStable: false,
  	      postStable: false,
  	      plateauCount: 0,
  	      eventMs: null,
  	      eventDistanceMs: null,
  	      prePlateauDurationMs: null,
  	      postPlateauDurationMs: null,
  	      preSpreadLitres: null,
  	      postSpreadLitres: null
  	    };

  	    if (!points.length || !nearest) {
  	      result.reason = "No GPS points around the transaction";
  	      return result;
  	    }

  	    // GPS still establishes station dwell. Fuel level does NOT use the FuelOut
  	    // timestamp as a hard before/after divider.
  	    let anchorIndex = points.indexOf(nearest);
  	    if (anchorIndex < 0) anchorIndex = 0;
  	    let arrivalIndex = anchorIndex;
  	    for (let index = anchorIndex; index > 0; index -= 1) {
  	      const current = points[index];
  	      const previous = points[index - 1];
  	      const gap = current.timestamp - previous.timestamp;
  	      const atStation = fifTrackingDistanceM(previous, nearest) <= 100;
  	      const moving = fifTrackingIsMoving(previous);
  	      if (gap > 180000 || !atStation || moving === true) break;
  	      arrivalIndex = index - 1;
  	    }
  	    result.arrivalPoint = points[arrivalIndex] || nearest;
  	    const priorPoint = arrivalIndex > 0 ? points[arrivalIndex - 1] : null;
  	    result.stopTransitionFound = !!priorPoint && fifTrackingIsMoving(priorPoint) === true;

  	    let departureIndex = anchorIndex;
  	    for (let index = anchorIndex; index < points.length - 1; index += 1) {
  	      const current = points[index];
  	      const next = points[index + 1];
  	      const gap = next.timestamp - current.timestamp;
  	      const atStation = fifTrackingDistanceM(next, nearest) <= 100;
  	      if (gap > 180000 || !atStation || fifTrackingIsMoving(next) === true) break;
  	      departureIndex = index + 1;
  	    }
  	    result.stopDurationMs = Math.max(0, points[departureIndex].timestamp - result.arrivalPoint.timestamp);

  	    const plateaus = fifTrackingStableFuelPlateaus(points, vehicle);
  	    result.plateauCount = plateaus.length;
  	    const pair = fifTrackingSelectRefuelPlateauPair(plateaus, anchorMs, tankCapacity);

  	    if (!pair) {
  	      result.quality = plateaus.length ? "warning" : "none";
  	      result.reason = plateaus.length
  	        ? "Stable fuel readings were found, but no credible positive refuel transition was detected near the FuelOut capture"
  	        : "No stable stationary fuel plateaus were available for refuel analysis";
  	      return result;
  	    }

  	    const pre = pair.pre;
  	    const post = pair.post;
  	    const preSample = pre.representative;
  	    const postSample = post.representative;

  	    result.preStable = true;
  	    result.postStable = true;
  	    result.preSampleCount = pre.sampleCount;
  	    result.postSampleCount = post.sampleCount;
  	    result.prePlateauDurationMs = pre.durationMs;
  	    result.postPlateauDurationMs = post.durationMs;
  	    result.preSpreadLitres = pre.unit === "L" ? pre.spread : null;
  	    result.postSpreadLitres = post.unit === "L" ? post.spread : null;
  	    result.eventMs = pair.eventMs;
  	    result.eventDistanceMs = pair.eventDistanceMs;

  	    result.prePoint = preSample && preSample.point;
  	    result.postPoint = postSample && postSample.point;
  	    result.preFuel = preSample ? Object.assign({}, preSample.fuel, { value: pre.value }) : null;
  	    result.postFuel = postSample ? Object.assign({}, postSample.fuel, { value: post.value }) : null;

  	    if (!result.preFuel || !result.postFuel || result.preFuel.unit !== result.postFuel.unit) {
  	      result.reason = "Stable fuel plateaus use incompatible units";
  	      result.quality = "warning";
  	      return result;
  	    }

  	    result.rawFuelIncrease = result.postFuel.value - result.preFuel.value;

  	    if (result.preFuel.unit !== "L") {
  	      result.reason = "Tank capacity is required to convert CAN fuel level into litres";
  	      result.quality = "warning";
  	      return result;
  	    }

  	    // Telemetry Fuel Rise is the primary tracker-derived fill measurement.
  	    // It is deliberately NOT adjusted by fuel-consumption telemetry. The figure
  	    // remains a direct observation of the change between two trustworthy settled
  	    // tank levels: stable post-fill minus stable pre-fill.
  	    //
  	    // Measured consumption between the plateaus is retained only as supporting
  	    // diagnostic evidence and for the separate arrival-ullage calculation below.
  	    result.consumedLitres = fifTrackingFuelConsumedDelta(result.prePoint, result.postPoint, tankCapacity);

  	    // Ullage is based on the last trustworthy settled baseline. Where the cumulative
  	    // consumption counter is available, carry that baseline forward to the GPS
  	    // arrival stop before calculating ullage.
  	    result.arrivalFuelLitres = result.preFuel.value;
  	    if (
  	      result.arrivalPoint &&
  	      result.prePoint &&
  	      result.arrivalPoint.timestamp >= result.prePoint.timestamp &&
  	      (!result.postPoint || result.arrivalPoint.timestamp <= result.postPoint.timestamp)
  	    ) {
  	      result.arrivalConsumptionLitres = fifTrackingFuelConsumedDelta(result.prePoint, result.arrivalPoint, tankCapacity);
  	      if (result.arrivalConsumptionLitres !== null) {
  	        result.arrivalFuelLitres = Math.max(0, result.preFuel.value - result.arrivalConsumptionLitres);
  	      }
  	    }

  	    if (tankCapacity > 0) {
  	      result.arrivalFuelLitres = Math.min(tankCapacity, Math.max(0, result.arrivalFuelLitres));
  	      result.ullageLitres = Math.max(0, tankCapacity - result.arrivalFuelLitres);
  	    }

  	    if (result.capturedLitres !== null) {
  	      result.varianceLitres = result.rawFuelIncrease - result.capturedLitres;
  	      result.variancePercent = result.capturedLitres > 0 ? result.varianceLitres / result.capturedLitres * 100 : null;
  	      if (result.ullageLitres !== null) result.ullageVarianceLitres = result.ullageLitres - result.capturedLitres;
  	    }

  	    result.detected = result.rawFuelIncrease > 0 && result.rawFuelIncrease >= pair.minimumRise;

  	    const strongTiming = result.eventDistanceMs !== null && result.eventDistanceMs <= 10 * 60 * 1000;
  	    const strongSamples = result.preSampleCount >= 3 && result.postSampleCount >= 3;
  	    const strongSpread =
  	      (result.preSpreadLitres === null || result.preSpreadLitres <= pre.tolerance * 2) &&
  	      (result.postSpreadLitres === null || result.postSpreadLitres <= post.tolerance * 2);

  	    result.quality = result.detected && strongTiming && strongSamples && strongSpread ? "good" : "warning";
  	    result.reason = result.detected
  	      ? "Stable pre-fill and post-fill fuel plateaus detected; moving fuel readings excluded from the baseline"
  	      : "No positive stable fuel increase was detected";

  	    return result;
  	  }

  	  function fifTrackingFormatTime(timestamp, seconds) {
  	    if (!Number.isFinite(timestamp)) return "—";
  	    return new Date(timestamp).toLocaleString("en-ZA", {
  	      year: "numeric", month: "short", day: "2-digit",
  	      hour: "2-digit", minute: "2-digit", second: seconds === false ? undefined : "2-digit"
  	    });
  	  }

  	  function fifTrackingFormatDuration(milliseconds) {
  	    if (!Number.isFinite(milliseconds) || milliseconds < 0) return "—";
  	    const total = Math.round(milliseconds / 1000);
  	    const minutes = Math.floor(total / 60);
  	    const seconds = total % 60;
  	    return minutes + "m " + String(seconds).padStart(2, "0") + "s";
  	  }

  	  function fifTrackingNearestMileage(rows, anchorMs) {
  	    let best = null;
  	    let bestGap = Infinity;
  	    arr(rows).forEach(function (raw) {
  	      const timestamp = fifTrackingMessageTime(raw);
  	      const mileage = fifTrackingOdometer(raw);
  	      if (timestamp === null || mileage === null || !Number.isFinite(mileage) || mileage <= 0) return;
  	      const gap = Number.isFinite(anchorMs) ? Math.abs(timestamp - anchorMs) : 0;
  	      if (!best || gap < bestGap) {
  	        bestGap = gap;
  	        best = { value: mileage, timestamp: timestamp, gapMs: gap, raw: raw };
  	      }
  	    });
  	    return best;
  	  }

  	  function fifTrackingMileageAudit(row, trackingRows, anchorMs) {
  	    const raw = row && row.raw || {};
  	    const capturedMileage = numberValue(firstValue([
  	      row && row.mileage,
  	      raw && raw.Mileage,
  	      raw && raw.Odometer
  	    ], null));
  	    const savedTrackerMileage = numberValue(firstValue([
  	      row && row.flespiMileage,
  	      raw && raw.FlespiMileage,
  	      raw && raw.FlespiCANVehicleMileage,
  	      raw && raw.CANVehicleMileage,
  	      getDeep(raw, ["Data", "Audit", "FlespiMileage"], null)
  	    ], null));
  	    const liveMileage = fifTrackingNearestMileage(trackingRows, anchorMs);
  	    const trackerMileage = liveMileage && liveMileage.value > 0
  	      ? liveMileage.value
  	      : (savedTrackerMileage !== null && savedTrackerMileage > 0 ? savedTrackerMileage : null);
  	    const trackerSource = liveMileage && liveMileage.value > 0
  	      ? "Live Flespi CAN at " + fifTrackingFormatTime(liveMileage.timestamp)
  	      : (trackerMileage !== null ? "Saved Flespi can.vehicle.mileage" : "No valid CAN mileage available");
  	    const capturedUnit = clean(firstValue([
  	      row && row.readingUnit,
  	      raw && raw.ReadingUnit,
  	      "km"
  	    ], "km"));
  	    const capturedIsDistance = !capturedUnit || /km|kilomet/i.test(capturedUnit);
  	    const comparable = capturedMileage !== null && trackerMileage !== null && capturedIsDistance;
  	    const variance = comparable ? trackerMileage - capturedMileage : null;
  	    const toleranceKm = 1;
  	    const matched = comparable && Math.abs(variance) <= toleranceKm;

  	    let result = "Unavailable";
  	    let note = "Captured or tracker mileage was not available";
  	    let tone = "warning";
  	    if (capturedMileage === null && trackerMileage !== null) {
  	      result = "Captured missing";
  	      note = "Tracker mileage is available for review";
  	    } else if (capturedMileage !== null && trackerMileage === null) {
  	      result = "Tracker missing";
  	      note = "No valid Flespi CAN mileage was found";
  	    } else if (capturedMileage !== null && trackerMileage !== null && !capturedIsDistance) {
  	      result = "Not comparable";
  	      note = "Captured meter uses " + (capturedUnit || "a non-distance unit");
  	    } else if (matched) {
  	      result = "Matched";
  	      note = "Within " + formatNumber(toleranceKm, 2) + " km tolerance";
  	      tone = "good";
  	    } else if (comparable) {
  	      result = "Review";
  	      note = formatNumber(Math.abs(variance), 2) + " km difference";
  	    }

  	    return {
  	      capturedMileage: capturedMileage,
  	      capturedUnit: capturedUnit || "km",
  	      trackerMileage: trackerMileage,
  	      trackerSource: trackerSource,
  	      trackerTimestamp: liveMileage ? liveMileage.timestamp : null,
  	      variance: variance,
  	      comparable: comparable,
  	      matched: matched,
  	      result: result,
  	      note: note,
  	      tone: tone
  	    };
  	  }

  	  function fifTrackingFormatMileage(value, unit, signed) {
  	    if (!Number.isFinite(value)) return "—";
  	    return (signed && value > 0 ? "+" : "") + formatNumber(value, 2) + " " + clean(unit || "km");
  	  }

  	  function fifTrackingMileageAuditHtml(row, trackingRows, anchorMs) {
  	    const audit = fifTrackingMileageAudit(row, trackingRows, anchorMs);
  	    return `<section class="fiftrk-snapshots fiftrk-mileage-audit"><header><span>Mileage audit</span><strong>Driver-captured reading · live tracker reading</strong></header>
  	      <div class="fiftrk-metrics">
  	        ${fifTrackingMetric("Captured mileage", fifTrackingFormatMileage(audit.capturedMileage, audit.capturedUnit), "Driver-entered FuelOut reading")}
  	        ${fifTrackingMetric("Tracker mileage", fifTrackingFormatMileage(audit.trackerMileage, "km"), audit.trackerSource)}
  	        ${fifTrackingMetric("Mileage variance", fifTrackingFormatMileage(audit.variance, "km", true), audit.comparable ? "Tracker minus captured" : "Comparison unavailable", audit.matched ? "good" : audit.comparable ? "warning" : "")}
  	        ${fifTrackingMetric("Mileage check", audit.result, audit.note, audit.tone)}
  	      </div>
  	    </section>`;
  	  }

  	  function fifTrackingAnalyze(points, anchorMs, vehicle, row) {
  	    const before = fifTrackingSnapshotBefore(points, anchorMs);
  	    const after = fifTrackingSnapshotAfter(points, anchorMs);
  	    const nearest = fifTrackingNearest(points, anchorMs);
  	    let distanceM = 0;
  	    let movingMs = 0;
  	    let stoppedMs = 0;
  	    let idleMs = 0;
  	    let largestGapMs = 0;
  	    const speeds = [];

  	    for (let index = 0; index < points.length; index += 1) {
  	      const point = points[index];
  	      if (point.speed !== null && point.speed >= 0) speeds.push(point.speed);
  	      if (!index) continue;
  	      const previous = points[index - 1];
  	      const gap = Math.max(0, point.timestamp - previous.timestamp);
  	      largestGapMs = Math.max(largestGapMs, gap);
  	      if (gap <= 180000) {
  	        const segmentDistance = fifTrackingDistanceM(previous, point);
  	        if (segmentDistance < 10000) distanceM += segmentDistance;
  	        const speed = point.speed !== null ? point.speed : previous.speed;
  	        if (speed !== null && speed > 1) movingMs += gap;
  	        else {
  	          stoppedMs += gap;
  	          const ignition = fifTrackingBoolean(point.raw, ["engine.ignition.status"]);
  	          if (ignition === true) idleMs += gap;
  	        }
  	      }
  	    }

  	    const nearestGapMs = nearest ? Math.abs(nearest.timestamp - anchorMs) : Infinity;
  	    const hasBothSides = !!before && !!after;
  	    const quality = !points.length ? "none" :
  	      hasBothSides && nearestGapMs <= 60000 && largestGapMs <= 180000 ? "good" :
  	      hasBothSides && nearestGapMs <= 180000 ? "warning" : "poor";
  	    const beforeFuel = before ? fifTrackingFuel(before.raw, vehicle) : null;
  	    const afterFuel = after ? fifTrackingFuel(after.raw, vehicle) : null;
  	    const fuelChange = beforeFuel && afterFuel && beforeFuel.unit === afterFuel.unit
  	      ? afterFuel.value - beforeFuel.value : null;
  	    const beforeOdo = before ? fifTrackingOdometer(before.raw) : null;
  	    const afterOdo = after ? fifTrackingOdometer(after.raw) : null;
  	    const refuel = fifTrackingRefuelEvidence(points, anchorMs, vehicle, row && row.litres);

  	    return {
  	      before: before,
  	      after: after,
  	      nearest: nearest,
  	      pointCount: points.length,
  	      distanceM: distanceM,
  	      movingMs: movingMs,
  	      stoppedMs: stoppedMs,
  	      idleMs: idleMs,
  	      maxSpeed: speeds.length ? Math.max.apply(null, speeds) : null,
  	      averageSpeed: speeds.length ? speeds.reduce(function (sum, value) { return sum + value; }, 0) / speeds.length : null,
  	      largestGapMs: largestGapMs,
  	      nearestGapMs: nearestGapMs,
  	      hasBothSides: hasBothSides,
  	      quality: quality,
  	      beforeFuel: beforeFuel,
  	      afterFuel: afterFuel,
  	      fuelChange: fuelChange,
  	      beforeOdo: beforeOdo,
  	      afterOdo: afterOdo,
  	      odometerChange: beforeOdo !== null && afterOdo !== null ? afterOdo - beforeOdo : null,
  	      refuel: refuel
  	    };
  	  }

  	  function fifTrackingMetric(label, value, note, tone) {
  	    return `<article class="fiftrk-metric ${escapeAttr(tone || "")}"><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong>${note ? `<small>${escapeHtml(note)}</small>` : ""}</article>`;
  	  }

  	  function fifTrackingSnapshotValue(point, kind, vehicle) {
  	    if (!point) return "—";
  	    if (kind === "time") return fifTrackingFormatTime(point.timestamp);
  	    if (kind === "speed") return point.speed === null ? "—" : formatNumber(point.speed, 1) + " km/h";
  	    if (kind === "ignition") {
  	      const value = fifTrackingBoolean(point.raw, ["engine.ignition.status"]);
  	      return value === null ? "—" : value ? "On" : "Off";
  	    }
  	    if (kind === "odometer") {
  	      const value = fifTrackingOdometer(point.raw);
  	      return value === null ? "—" : formatNumber(value, 1) + " km";
  	    }
  	    if (kind === "fuel") {
  	      const value = fifTrackingFuel(point.raw, vehicle);
  	      return value ? formatNumber(value.value, 1) + " " + value.unit : "—";
  	    }
  	    return "—";
  	  }

  	  function fifTrackingRefuelHtml(evidence) {
  	    if (!evidence) return "";
  	    const litres = function (value, decimals) {
  	      return Number.isFinite(value) ? formatNumber(value, decimals === undefined ? 2 : decimals) + " L" : "—";
  	    };
  	    const captured = evidence.capturedLitres;
  	    const tolerance = captured !== null ? Math.max(2, captured * .1) : 2;
  	    const varianceGood = evidence.varianceLitres !== null && Math.abs(evidence.varianceLitres) <= tolerance;
  	    const ullageNote = evidence.ullageVarianceLitres === null ? "Tank capacity or arrival fuel unavailable" :
  	      evidence.ullageVarianceLitres >= 0
  	        ? litres(evidence.ullageVarianceLitres) + " spare after captured fill"
  	        : litres(Math.abs(evidence.ullageVarianceLitres)) + " more than measured ullage";
  	    const arrivalNote = evidence.arrivalConsumptionLitres === null
  	      ? "Stable pre-fill baseline used at arrival"
  	      : "Baseline less " + litres(evidence.arrivalConsumptionLitres) + " measured consumption to arrival";
  	    const varianceNote = evidence.variancePercent === null
  	      ? evidence.reason
  	      : (evidence.variancePercent >= 0 ? "+" : "") + formatNumber(evidence.variancePercent, 1) + "% versus captured";
  	    const eventNote = Number.isFinite(evidence.eventDistanceMs)
  	      ? fifTrackingFormatDuration(evidence.eventDistanceMs) + " from FuelOut capture"
  	      : evidence.reason;

  	    return `<section class="fiftrk-snapshots fiftrk-refuel-evidence"><header><span>Telemetry fuel reconciliation</span><strong>Stable stationary fuel plateaus determine the measured fuel rise · FuelOut time only bounds the search</strong></header>
  	      <div class="fiftrk-metrics">
  	        ${fifTrackingMetric("Stable pre-fill baseline", evidence.preFuel ? litres(evidence.preFuel.value) : "—", evidence.prePoint ? fifTrackingFormatTime(evidence.prePoint.timestamp) + " · " + evidence.preSampleCount + " stable samples" : evidence.reason)}
  	        ${fifTrackingMetric("Estimated arrival fuel", litres(evidence.arrivalFuelLitres), arrivalNote)}
  	        ${fifTrackingMetric("Arrival ullage", litres(evidence.ullageLitres), ullageNote, evidence.ullageVarianceLitres !== null && evidence.ullageVarianceLitres >= -tolerance ? "good" : "")}
  	        ${fifTrackingMetric("Stable post-fill level", evidence.postFuel ? litres(evidence.postFuel.value) : "—", evidence.postPoint ? fifTrackingFormatTime(evidence.postPoint.timestamp) + " · " + evidence.postSampleCount + " stable samples" : evidence.reason)}
  	        ${fifTrackingMetric("Telemetry fuel rise", litres(evidence.rawFuelIncrease), "Stable post-fill minus stable pre-fill · primary tracker figure", evidence.detected ? "good" : "")}
  	        ${fifTrackingMetric("Captured fill", litres(captured), "FuelOut transaction")}
  	        ${fifTrackingMetric("Telemetry variance", evidence.varianceLitres === null ? "—" : (evidence.varianceLitres >= 0 ? "+" : "") + litres(evidence.varianceLitres), varianceNote, varianceGood ? "good" : "")}
  	        ${fifTrackingMetric("Station dwell", fifTrackingFormatDuration(evidence.stopDurationMs), evidence.stopTransitionFound ? "Moving-to-stopped transition found" : "Stop transition not fully visible")}
  	        ${fifTrackingMetric("Fuel event timing", evidence.eventMs ? fifTrackingFormatTime(evidence.eventMs) : "—", eventNote)}
  	        ${fifTrackingMetric("Evidence quality", evidence.quality === "good" ? "Strong" : evidence.quality === "warning" ? "Review" : "Unavailable", evidence.reason, evidence.quality === "good" ? "good" : "")}
  	      </div>
  	    </section>`;
  	  }

  	  function fifTrackingConsoleRefuelEvidence(evidence) {
  	    if (!evidence) return null;
  	    const point = function (value) {
  	      return value ? {
  	        timestamp: value.timestamp,
  	        time: new Date(value.timestamp).toISOString(),
  	        latitude: value.lat,
  	        longitude: value.lng,
  	        speed: value.speed
  	      } : null;
  	    };
  	    const summary = {
  	      detected: evidence.detected,
  	      quality: evidence.quality,
  	      reason: evidence.reason,
  	      stopTransitionFound: evidence.stopTransitionFound,
  	      stationDwellSeconds: Number.isFinite(evidence.stopDurationMs) ? Math.round(evidence.stopDurationMs / 1000) : null,
  	      tankCapacityLitres: evidence.tankCapacity,
  	      plateauCount: evidence.plateauCount,
  	      fuelEventTime: Number.isFinite(evidence.eventMs) ? new Date(evidence.eventMs).toISOString() : null,
  	      fuelEventDistanceFromCaptureSeconds: Number.isFinite(evidence.eventDistanceMs) ? Math.round(evidence.eventDistanceMs / 1000) : null,
  	      stablePreFillFuelLitres: evidence.preFuel && evidence.preFuel.unit === "L" ? evidence.preFuel.value : null,
  	      estimatedArrivalFuelLitres: evidence.arrivalFuelLitres,
  	      arrivalConsumptionCorrectionLitres: evidence.arrivalConsumptionLitres,
  	      arrivalUllageLitres: evidence.ullageLitres,
  	      stablePostFillFuelLitres: evidence.postFuel && evidence.postFuel.unit === "L" ? evidence.postFuel.value : null,
  	      telemetryFuelRiseLitres: evidence.rawFuelIncrease,
  	      measuredConsumptionBetweenPlateausLitres: evidence.consumedLitres,
  	      capturedFillLitres: evidence.capturedLitres,
  	      varianceLitres: evidence.varianceLitres,
  	      variancePercent: evidence.variancePercent,
  	      ullageMinusCapturedLitres: evidence.ullageVarianceLitres,
  	      preFillPoint: point(evidence.prePoint),
  	      arrivalPoint: point(evidence.arrivalPoint),
  	      postFillPoint: point(evidence.postPoint),
  	      preStableSampleCount: evidence.preSampleCount,
  	      postStableSampleCount: evidence.postSampleCount,
  	      prePlateauDurationSeconds: Number.isFinite(evidence.prePlateauDurationMs) ? Math.round(evidence.prePlateauDurationMs / 1000) : null,
  	      postPlateauDurationSeconds: Number.isFinite(evidence.postPlateauDurationMs) ? Math.round(evidence.postPlateauDurationMs / 1000) : null,
  	      preSpreadLitres: evidence.preSpreadLitres,
  	      postSpreadLitres: evidence.postSpreadLitres,
  	      preStable: evidence.preStable,
  	      postStable: evidence.postStable
  	    };
  	    if (typeof window !== "undefined" && window.__FIF_LAST_TRACKING_DEBUG__) {
  	      window.__FIF_LAST_TRACKING_DEBUG__.refuelEvidence = fifDebugClone(summary);
  	    }

  	    try {
  	      if (typeof console !== "undefined") {
  	        console.groupCollapsed("[Fleet In Form] Refuel plateau analysis · " + (summary.quality || "unknown"));
  	        console.log("Refuel evidence summary", summary);
  	        console.log("Stable pre-fill", {
  	          point: summary.preFillPoint,
  	          litres: summary.stablePreFillFuelLitres,
  	          samples: summary.preStableSampleCount,
  	          durationSeconds: summary.prePlateauDurationSeconds,
  	          spreadLitres: summary.preSpreadLitres
  	        });
  	        console.log("Stable post-fill", {
  	          point: summary.postFillPoint,
  	          litres: summary.stablePostFillFuelLitres,
  	          samples: summary.postStableSampleCount,
  	          durationSeconds: summary.postPlateauDurationSeconds,
  	          spreadLitres: summary.postSpreadLitres
  	        });
  	        console.groupEnd();
  	      }
  	    } catch (_) {}

  	    return summary;
  	  }

  	  function fifTrackingSummaryHtml(analysis, points, anchorMs, vehicle, source, row, trackingRows) {
  	    const mileageAuditHtml = fifTrackingMileageAuditHtml(row, trackingRows, anchorMs);
  	    if (!points.length) {
  	      return `${mileageAuditHtml}<div class="fiftrk-empty"><strong>No GPS points in this 120-minute window</strong><span>The tracker returned no position messages from ${escapeHtml(fifTrackingFormatTime(anchorMs - FIF_FUEL_TRACKING_WINDOW_MINUTES * 60000))} to ${escapeHtml(fifTrackingFormatTime(anchorMs + FIF_FUEL_TRACKING_WINDOW_MINUTES * 60000))}.</span></div>`;
  	    }
  	    const nearest = analysis.nearest;
  	    const ignition = nearest ? fifTrackingBoolean(nearest.raw, ["engine.ignition.status"]) : null;
  	    const rpm = nearest ? fifTrackingNumber(nearest.raw, ["can.engine.rpm"]) : null;
  	    const temperature = nearest ? fifTrackingNumber(nearest.raw, ["can.engine.temperature"]) : null;
  	    const satellites = nearest ? fifTrackingNumber(nearest.raw, ["position.satellites"]) : null;
  	    const altitude = nearest ? fifTrackingNumber(nearest.raw, ["position.altitude"]) : null;
  	    const serverTimestamp = nearest ? fifTrackingTimestampMs(fifTrackingValue(nearest.raw, ["server.timestamp"])) : null;
  	    const transmissionDelay = nearest && serverTimestamp !== null ? Math.abs(serverTimestamp - nearest.timestamp) : null;
  	    const eventNames = nearest && Array.isArray(nearest.raw.events) ? nearest.raw.events.map(clean).filter(Boolean) : [];
  	    const positionText = nearest ? nearest.lat.toFixed(6) + ", " + nearest.lng.toFixed(6) : "—";
  	    const headingText = nearest && nearest.heading !== null ? Math.round(nearest.heading) + "° heading" : "Heading unavailable";
  	    const qualityText = analysis.quality === "good" ? "Strong evidence" : analysis.quality === "warning" ? "Review gaps" : "Weak evidence";
  	    const nearestNote = Number.isFinite(analysis.nearestGapMs)
  	      ? "Nearest fix " + fifTrackingFormatDuration(analysis.nearestGapMs) + " from capture" : "No nearby fix";
  	    const fuelUnit = analysis.beforeFuel && analysis.afterFuel && analysis.beforeFuel.unit === analysis.afterFuel.unit
  	      ? analysis.beforeFuel.unit : "";
  	    const fuelChangeText = analysis.fuelChange === null ? "—" :
  	      (analysis.fuelChange >= 0 ? "+" : "") + formatNumber(analysis.fuelChange, 1) + " " + fuelUnit;
  	    const odometerChangeText = analysis.odometerChange === null ? "—" : formatNumber(analysis.odometerChange, 2) + " km";

  	    return `${mileageAuditHtml}${fifTrackingRefuelHtml(analysis.refuel)}
  	      <div class="fiftrk-quality ${escapeAttr(analysis.quality)}"><i></i><div><strong>${escapeHtml(qualityText)}</strong><span>${escapeHtml(nearestNote)} · Largest packet gap ${escapeHtml(fifTrackingFormatDuration(analysis.largestGapMs))}</span></div></div>
  	      <div class="fiftrk-metrics">
  	        ${fifTrackingMetric("GPS points", String(analysis.pointCount), source)}
  	        ${fifTrackingMetric("Route distance", formatNumber(analysis.distanceM / 1000, 2) + " km", "GPS path inside window")}
  	        ${fifTrackingMetric("Moving", fifTrackingFormatDuration(analysis.movingMs), "Stopped " + fifTrackingFormatDuration(analysis.stoppedMs))}
  	        ${fifTrackingMetric("Idle", fifTrackingFormatDuration(analysis.idleMs), "Ignition on while stopped")}
  	        ${fifTrackingMetric("Speed at capture", nearest && nearest.speed !== null ? formatNumber(nearest.speed, 1) + " km/h" : "—", analysis.maxSpeed === null ? "No speed data" : "Max " + formatNumber(analysis.maxSpeed, 1) + " km/h")}
  	        ${fifTrackingMetric("Fuel change", fuelChangeText, analysis.beforeFuel && analysis.afterFuel ? "Before to after" : "Fuel telemetry unavailable", analysis.fuelChange !== null && analysis.fuelChange > 0 ? "good" : "")}
  	        ${fifTrackingMetric("Odometer change", odometerChangeText, analysis.beforeOdo === null ? "Odometer telemetry unavailable" : "Tracker/CAN reading")}
  	        ${fifTrackingMetric("Ignition", ignition === null ? "—" : ignition ? "On" : "Off", rpm === null ? "RPM unavailable" : formatNumber(rpm, 0) + " rpm")}
  	        ${fifTrackingMetric("Engine temperature", temperature === null ? "—" : formatNumber(temperature, 1) + " °C", "At nearest fix")}
  	        ${fifTrackingMetric("GNSS", satellites === null ? "—" : formatNumber(satellites, 0) + " satellites", altitude === null ? "Altitude unavailable" : formatNumber(altitude, 0) + " m altitude")}
  	        ${fifTrackingMetric("Capture position", positionText, headingText)}
  	        ${fifTrackingMetric("Transmission delay", transmissionDelay === null ? "—" : fifTrackingFormatDuration(transmissionDelay), "Device time to server time")}
  	        ${fifTrackingMetric("Events at fix", eventNames.length ? eventNames.slice(0, 3).join(", ") : "None", eventNames.length > 3 ? String(eventNames.length) + " events total" : "Tracker-generated events")}
  	      </div>
  	      <section class="fiftrk-snapshots"><header><span>Evidence snapshots</span><strong>Before · nearest capture fix · after</strong></header>
  	        <div class="fiftrk-snapshot-table">
  	          <div><b>Reading</b><b>Before</b><b>Capture fix</b><b>After</b></div>
  	          ${["time", "speed", "ignition", "odometer", "fuel"].map(function (kind) {
  	            const label = ({ time: "Time", speed: "Speed", ignition: "Ignition", odometer: "Odometer", fuel: "Fuel" })[kind];
  	            return `<div><span>${escapeHtml(label)}</span><span>${escapeHtml(fifTrackingSnapshotValue(analysis.before, kind, vehicle))}</span><span>${escapeHtml(fifTrackingSnapshotValue(analysis.nearest, kind, vehicle))}</span><span>${escapeHtml(fifTrackingSnapshotValue(analysis.after, kind, vehicle))}</span></div>`;
  	          }).join("")}
  	        </div>
  	      </section>`;
  	  }

  	  function fifTrackingGoogleMapsKey() {
  	    const configuredKey = clean(descriptorValue(firstValue([
  	      getDeep(APP_DATA, ["GoogleMapsApiKey"], ""),
  	      getDeep(APP_DATA, ["Settings", "GoogleMapsApiKey"], ""),
  	      getDeep(APP_DATA, ["Configuration", "GoogleMapsApiKey"], ""),
  	      getDeep(APP_DATA, ["Tracking", "GoogleMapsApiKey"], ""),
  	      getDeep(APP_INPUT, ["GoogleMapsApiKey"], ""),
  	      typeof window !== "undefined" ? window.GOOGLE_MAPS_API_KEY : "",
  	      ""
  	    ], "")));
  	    if (configuredKey) return configuredKey;
  	    if (typeof document === "undefined") return "";
  	    const mapsScript = Array.prototype.find.call(document.scripts || [], function (script) {
  	      return /maps\.googleapis\.com\/maps\/api\/js/i.test(script.src || "");
  	    });
  	    if (!mapsScript || !mapsScript.src) return "";
  	    try {
  	      return clean(new URL(mapsScript.src, window.location.href).searchParams.get("key"));
  	    } catch (_) {
  	      const match = mapsScript.src.match(/[?&]key=([^&]+)/i);
  	      return match ? clean(decodeURIComponent(match[1])) : "";
  	    }
  	  }

  	  function fifTrackingEnsureGoogleMaps() {
  	    if (typeof google !== "undefined" && google.maps && typeof google.maps.Map === "function") return Promise.resolve(google.maps);
  	    if (window.__fifGoogleMapsPromise) return window.__fifGoogleMapsPromise;
  	    window.__fifGoogleMapsPromise = new Promise(function (resolve, reject) {
  	      const finish = function () {
  	        if (typeof google !== "undefined" && google.maps && typeof google.maps.Map === "function") resolve(google.maps);
  	        else reject(new Error("Google Maps loaded without the Maps JavaScript API."));
  	      };
  	      const existing = Array.prototype.find.call(document.scripts, function (script) {
  	        return /maps\.googleapis\.com\/maps\/api\/js/i.test(script.src || "");
  	      });
  	      if (existing) {
  	        existing.addEventListener("load", finish, { once: true });
  	        existing.addEventListener("error", function () { reject(new Error("Google Maps could not load.")); }, { once: true });
  	        setTimeout(finish, 4000);
  	        return;
  	      }
  	      const key = fifTrackingGoogleMapsKey();
  	      if (!key) {
  	        reject(new Error("Google Maps is not loaded and GoogleMapsApiKey is not configured in App Data."));
  	        return;
  	      }
  	      const script = document.createElement("script");
  	      script.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(key) + "&v=weekly";
  	      script.async = true;
  	      script.defer = true;
  	      script.addEventListener("load", finish, { once: true });
  	      script.addEventListener("error", function () { reject(new Error("Google Maps could not load.")); }, { once: true });
  	      document.head.appendChild(script);
  	    });
  	    return window.__fifGoogleMapsPromise;
  	  }

  	  function fifTrackingPathSegments(points) {
  	    const segments = [];
  	    let current = [];
  	    arr(points).forEach(function (point, index) {
  	      if (index) {
  	        const previous = points[index - 1];
  	        const gap = point.timestamp - previous.timestamp;
  	        const jump = fifTrackingDistanceM(previous, point);
  	        if (gap > 180000 || jump > 10000) {
  	          if (current.length > 1) segments.push(current);
  	          current = [];
  	        }
  	      }
  	      current.push(point);
  	    });
  	    if (current.length > 1) segments.push(current);
  	    return segments;
  	  }

  	  function fifTrackingMapStyles() {
  	    return [
  	      { elementType: "geometry", stylers: [{ color: "#111713" }] },
  	      { elementType: "labels.text.stroke", stylers: [{ color: "#111713" }] },
  	      { elementType: "labels.text.fill", stylers: [{ color: "#8f9a93" }] },
  	      { featureType: "road", elementType: "geometry", stylers: [{ color: "#29302b" }] },
  	      { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#171c18" }] },
  	      { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3a403a" }] },
  	      { featureType: "water", elementType: "geometry", stylers: [{ color: "#071b25" }] },
  	      { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] }
  	    ];
  	  }

  	  function fifTrackingMarkerIcon(color, scale) {
  	    return {
  	      path: google.maps.SymbolPath.CIRCLE,
  	      fillColor: color,
  	      fillOpacity: 1,
  	      strokeColor: "#ffffff",
  	      strokeWeight: 2,
  	      scale: scale || 7
  	    };
  	  }

  	  function fifTrackingFallbackPoint(vehicle, row, anchorMs) {
  	    const rawRecord = row && row.raw && typeof row.raw === "object" ? row.raw : null;
  	    const candidates = [
  	      rawRecord && rawRecord.Location,
  	      rawRecord,
  	      vehicle && vehicle.Location,
  	      vehicle && vehicle.CurrentLocation,
  	      getDeep(vehicle, ["Data", "Tracking", "Location"], null),
  	      getDeep(vehicle, ["Data", "Telematics", "Location"], null)
  	    ];
  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const source = candidates[index];
  	      if (!source || typeof source !== "object") continue;
  	      const lat = fifTrackingNumber(source, [
  	        "position.latitude", "latitude", "Latitude", "lat", "GPSLatitude",
  	        "FuelLatitude", "TransactionLatitude"
  	      ]);
  	      const lng = fifTrackingNumber(source, [
  	        "position.longitude", "longitude", "Longitude", "lng", "lon",
  	        "GPSLongitude", "FuelLongitude", "TransactionLongitude"
  	      ]);
  	      if (lat === null || lng === null || Math.abs(lat) > 90 || Math.abs(lng) > 180) continue;
  	      return {
  	        timestamp: fifTrackingMessageTime(source) || anchorMs,
  	        lat: lat,
  	        lng: lng,
  	        speed: fifTrackingNumber(source, ["position.speed", "can.vehicle.speed", "speed", "Speed"]),
  	        heading: fifTrackingNumber(source, ["position.direction", "course", "heading"]),
  	        valid: fifTrackingBoolean(source, ["position.valid"]),
  	        raw: source,
  	        fallback: true,
  	        fallbackLabel: index < 2 ? "Fuel transaction position" : "Latest known vehicle position"
  	      };
  	    }
  	    return null;
  	  }

  	  function fifTrackingRenderMap(windowNode, points, anchorMs, analysis, row, vehicle) {
  	    const mapNode = windowNode.querySelector("[data-fif-tracking-map]");
  	    if (!mapNode) return null;
  	    points = arr(points);
  	    const fallbackPoint = fifTrackingFallbackPoint(vehicle, row, anchorMs);
  	    const center = points.length
  	      ? ((analysis && analysis.nearest) || points[0])
  	      : (fallbackPoint || { lat: -30.5595, lng: 22.9375 });
  	    const runtime = windowNode.__fifTrackingRuntime || {};
  	    try { runtime.resizeObserver?.disconnect(); } catch (_) {}
  	    arr(runtime.overlays).forEach(function (overlay) {
  	      try { overlay.setMap?.(null); } catch (_) {}
  	      try { overlay.close?.(); } catch (_) {}
  	    });
  	    const map = new google.maps.Map(mapNode, {
  	      center: { lat: center.lat, lng: center.lng },
  	      zoom: points.length || fallbackPoint ? 16 : 5,
  	      mapTypeId: google.maps.MapTypeId && google.maps.MapTypeId.HYBRID
  	        ? google.maps.MapTypeId.HYBRID
  	        : "hybrid",
  	      styles: fifTrackingMapStyles(),
  	      mapTypeControl: true,
  	      mapTypeControlOptions: {
  	        style: google.maps.MapTypeControlStyle && google.maps.MapTypeControlStyle.DROPDOWN_MENU
  	          ? google.maps.MapTypeControlStyle.DROPDOWN_MENU
  	          : undefined,
  	        position: google.maps.ControlPosition && google.maps.ControlPosition.TOP_RIGHT
  	          ? google.maps.ControlPosition.TOP_RIGHT
  	          : undefined,
  	        mapTypeIds: ["hybrid", "satellite", "roadmap"]
  	      },
  	      tilt: 0,
  	      streetViewControl: false,
  	      fullscreenControl: false,
  	      gestureHandling: "greedy"
  	    });
  	    runtime.map = map;
  	    runtime.overlays = [];
  	    windowNode.__fifTrackingRuntime = runtime;

  	    const addPolyline = function (segment, color) {
  	      const polyline = new google.maps.Polyline({
  	        map: map,
  	        path: segment.map(function (point) { return { lat: point.lat, lng: point.lng }; }),
  	        strokeColor: color,
  	        strokeOpacity: .94,
  	        strokeWeight: 7,
  	        geodesic: true,
  	        zIndex: 20
  	      });
  	      runtime.overlays.push(polyline);
  	    };
  	    const beforePoints = points.filter(function (point) { return point.timestamp <= anchorMs; });
  	    const afterPoints = points.filter(function (point) { return point.timestamp >= anchorMs; });
  	    fifTrackingPathSegments(beforePoints).forEach(function (segment) { addPolyline(segment, "#cc6633"); });
  	    fifTrackingPathSegments(afterPoints).forEach(function (segment) { addPolyline(segment, "#3d8bfd"); });

  	    const info = new google.maps.InfoWindow();
  	    runtime.overlays.push(info);
  	    const addMarker = function (point, title, color, scale) {
  	      if (!point) return null;
  	      const marker = new google.maps.Marker({
  	        map: map,
  	        position: { lat: point.lat, lng: point.lng },
  	        title: title,
  	        icon: fifTrackingMarkerIcon(color, scale),
  	        zIndex: scale > 8 ? 100 : 70
  	      });
  	      marker.addListener("click", function () {
  	        info.setContent(`<div style="font:12px system-ui;color:#111;min-width:180px"><b>${escapeHtml(title)}</b><br>${escapeHtml(fifTrackingFormatTime(point.timestamp))}<br>${point.speed === null ? "Speed unavailable" : escapeHtml(formatNumber(point.speed, 1) + " km/h")}</div>`);
  	        info.open(map, marker);
  	      });
  	      runtime.overlays.push(marker);
  	      return marker;
  	    };
  	    if (!points.length) {
  	      if (fallbackPoint) {
  	        addMarker(fallbackPoint, fallbackPoint.fallbackLabel, "#ffd166", 9);
  	      }
  	      if (typeof ResizeObserver !== "undefined") {
  	        runtime.resizeObserver = new ResizeObserver(function () {
  	          try { google.maps.event.trigger(map, "resize"); } catch (_) {}
  	        });
  	        runtime.resizeObserver.observe(windowNode);
  	      }
  	      return map;
  	    }
  	    addMarker(points[0], "Window start", "#49c785", 6);
  	    addMarker(analysis && analysis.refuel && analysis.refuel.prePoint, "Pre-stop fuel reading", "#ff8c42", 9);
  	    addMarker(analysis && analysis.nearest, "Nearest fix to fuel transaction", "#ffd166", 10);
  	    addMarker(analysis && analysis.refuel && analysis.refuel.postPoint, "Stable post-fill fuel reading", "#72dda0", 9);
  	    addMarker(points[points.length - 1], "Window end", "#3d8bfd", 6);

  	    const bounds = new google.maps.LatLngBounds();
  	    points.forEach(function (point) { bounds.extend({ lat: point.lat, lng: point.lng }); });
  	    if (!bounds.isEmpty()) map.fitBounds(bounds, { top: 60, right: 60, bottom: 60, left: 60 });
  	    google.maps.event.addListenerOnce(map, "idle", function () {
  	      if (map.getZoom() > 18) map.setZoom(18);
  	    });

  	    if (typeof ResizeObserver !== "undefined") {
  	      runtime.resizeObserver = new ResizeObserver(function () {
  	        try { google.maps.event.trigger(map, "resize"); } catch (_) {}
  	      });
  	      runtime.resizeObserver.observe(windowNode);
  	    }
  	    return map;
  	  }

  	  function fifTrackingSampleMapPoints(points, maximum) {
  	    points = arr(points);
  	    maximum = Math.max(2, Number(maximum) || 2);
  	    if (points.length <= maximum) return points.slice();
  	    const sampled = [];
  	    const last = points.length - 1;
  	    for (let index = 0; index < maximum; index += 1) {
  	      sampled.push(points[Math.round(index * last / (maximum - 1))]);
  	    }
  	    return sampled.filter(function (point, index) {
  	      return !index || point !== sampled[index - 1];
  	    });
  	  }

  	  function fifTrackingEncodePolyline(points) {
  	    let previousLat = 0;
  	    let previousLng = 0;
  	    let encoded = "";
  	    const encodeValue = function (value) {
  	      value = value < 0 ? ~(value << 1) : value << 1;
  	      let result = "";
  	      while (value >= 0x20) {
  	        result += String.fromCharCode((0x20 | (value & 0x1f)) + 63);
  	        value >>= 5;
  	      }
  	      return result + String.fromCharCode(value + 63);
  	    };
  	    arr(points).forEach(function (point) {
  	      const latitude = Math.round(Number(point.lat) * 100000);
  	      const longitude = Math.round(Number(point.lng) * 100000);
  	      encoded += encodeValue(latitude - previousLat);
  	      encoded += encodeValue(longitude - previousLng);
  	      previousLat = latitude;
  	      previousLng = longitude;
  	    });
  	    return encoded;
  	  }

  	  function fifTrackingStaticMapUrl(windowNode, context) {
  	    const key = fifTrackingGoogleMapsKey();
  	    if (!key || !context) return "";
  	    const points = arr(context.points);
  	    const anchorMs = context.anchor && context.anchor.timestamp;
  	    const analysis = context.analysis;
  	    const runtime = windowNode && windowNode.__fifTrackingRuntime || {};
  	    const parameters = new URLSearchParams();
  	    parameters.set("size", "640x420");
  	    parameters.set("scale", "2");
  	    parameters.set("format", "png");
  	    parameters.set("maptype", "hybrid");
  	    parameters.set("language", "en");
  	    parameters.set("region", "za");

  	    try {
  	      const currentCenter = runtime.map && runtime.map.getCenter && runtime.map.getCenter();
  	      const currentZoom = runtime.map && runtime.map.getZoom && runtime.map.getZoom();
  	      if (currentCenter && Number.isFinite(currentCenter.lat()) && Number.isFinite(currentCenter.lng())) {
  	        parameters.set("center", currentCenter.lat().toFixed(6) + "," + currentCenter.lng().toFixed(6));
  	      }
  	      if (Number.isFinite(currentZoom)) parameters.set("zoom", String(Math.round(currentZoom)));
  	    } catch (_) {}

  	    const appendPaths = function (routePoints, color) {
  	      fifTrackingPathSegments(routePoints).slice(0, 8).forEach(function (segment) {
  	        const sampled = fifTrackingSampleMapPoints(segment, 90);
  	        if (sampled.length > 1) {
  	          parameters.append("path", "color:" + color + "|weight:5|enc:" + fifTrackingEncodePolyline(sampled));
  	        }
  	      });
  	    };
  	    appendPaths(points.filter(function (point) { return point.timestamp <= anchorMs; }), "0xcc6633ff");
  	    appendPaths(points.filter(function (point) { return point.timestamp >= anchorMs; }), "0x3d8bfdff");

  	    const markerKeys = Object.create(null);
  	    const addMarker = function (point, color, label) {
  	      if (!point || !Number.isFinite(point.lat) || !Number.isFinite(point.lng)) return;
  	      const markerKey = point.lat.toFixed(6) + "|" + point.lng.toFixed(6) + "|" + label;
  	      if (markerKeys[markerKey]) return;
  	      markerKeys[markerKey] = true;
  	      parameters.append("markers", "size:mid|color:" + color + "|label:" + label + "|" + point.lat.toFixed(6) + "," + point.lng.toFixed(6));
  	    };
  	    if (points.length) {
  	      addMarker(points[0], "0x49c785", "S");
  	      addMarker(analysis && analysis.refuel && analysis.refuel.prePoint, "0xff8c42", "P");
  	      addMarker(analysis && analysis.nearest, "0xffd166", "F");
  	      addMarker(analysis && analysis.refuel && analysis.refuel.postPoint, "0x72dda0", "O");
  	      addMarker(points[points.length - 1], "0x3d8bfd", "E");
  	    } else {
  	      addMarker(fifTrackingFallbackPoint(context.vehicle, context.row, anchorMs), "0xffd166", "F");
  	    }
  	    parameters.set("key", key);
  	    return "https://maps.googleapis.com/maps/api/staticmap?" + parameters.toString();
  	  }

  	  function fifTrackingReportLitres(value, signed) {
  	    if (!Number.isFinite(value)) return "—";
  	    return (signed && value > 0 ? "+" : "") + formatNumber(value, 2) + " L";
  	  }

  	  function fifTrackingReportMetric(label, value, note, tone) {
  	    return `<article class="report-metric ${escapeAttr(tone || "")}"><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong><small>${escapeHtml(note || "")}</small></article>`;
  	  }

  	  function fifTrackingPrintReport(windowNode) {
  	    const runtime = windowNode && windowNode.__fifTrackingRuntime || {};
  	    const context = runtime.printContext;
  	    if (!context || !context.anchor) {
  	      fifAlert("The tracking evidence is still loading. Please wait for the Print Report button to become active.", {
  	        title: "Report Not Ready", type: "warning", confirmText: "Close"
  	      });
  	      return false;
  	    }

  	    const reportWindow = window.open("", "_blank", "width=1280,height=920");
  	    if (!reportWindow) {
  	      fifAlert("The printable report could not be opened. Allow pop-ups for this Fleet In Form page and try again.", {
  	        title: "Print Window Blocked", type: "warning", confirmText: "Close"
  	      });
  	      return false;
  	    }

  	    const company = context.company;
  	    const vehicle = context.vehicle;
  	    const row = context.row || {};
  	    const mileageAudit = fifTrackingMileageAudit(row, context.loaded && context.loaded.rows, context.anchor && context.anchor.timestamp);
  	    const analysis = context.analysis;
  	    const evidence = analysis && analysis.refuel;
  	    const points = arr(context.points);
  	    const driverPhotos = context.photos || { items: [], savedCount: 0, loadedCount: 0 };
  	    const snapshotUrl = fifTrackingStaticMapUrl(windowNode, context);
  	    const quality = evidence && evidence.quality === "good" ? "Strong" :
  	      evidence && evidence.quality === "warning" ? "Review" : "Unavailable";
  	    const tolerance = evidence && Number.isFinite(evidence.capturedLitres)
  	      ? Math.max(2, evidence.capturedLitres * .1) : 2;
  	    const varianceTone = evidence && Number.isFinite(evidence.varianceLitres) && Math.abs(evidence.varianceLitres) <= tolerance ? "good" : "review";
  	    const source = clean(context.loaded && context.loaded.source) || (context.error ? "Tracking history unavailable" : "Loaded tracking evidence");
  	    const reportTitle = vehicleTitleValue(vehicle) + " Fuel Tracking & Ullage Evidence";
  	    const logo = typeof serviceReportLogo === "function" ? serviceReportLogo() : "";
  	    const before = analysis && analysis.before;
  	    const nearest = analysis && analysis.nearest;
  	    const after = analysis && analysis.after;
  	    const slipPhotoStatus = fifTrackingDriverPhotoStatus(driverPhotos, "slip");
  	    const odometerPhotoStatus = fifTrackingDriverPhotoStatus(driverPhotos, "odometer");
  	    const photoPageHtml = fifTrackingReportDriverPhotoPage(driverPhotos);

  	    const metricHtml = [
  	      fifTrackingReportMetric("Captured mileage", fifTrackingFormatMileage(mileageAudit.capturedMileage, mileageAudit.capturedUnit), "Driver-entered FuelOut reading"),
  	      fifTrackingReportMetric("Tracker mileage", fifTrackingFormatMileage(mileageAudit.trackerMileage, "km"), mileageAudit.trackerSource),
  	      fifTrackingReportMetric("Mileage variance", fifTrackingFormatMileage(mileageAudit.variance, "km", true), mileageAudit.comparable ? "Tracker minus captured" : "Comparison unavailable", mileageAudit.matched ? "good" : mileageAudit.comparable ? "review" : ""),
  	      fifTrackingReportMetric("Mileage check", mileageAudit.result, mileageAudit.note, mileageAudit.tone === "good" ? "good" : "review"),
  	      fifTrackingReportMetric("Tank capacity", fifTrackingReportLitres(evidence && evidence.tankCapacity), "Configured vehicle tank"),
  	      fifTrackingReportMetric("Stable pre-fill baseline", fifTrackingReportLitres(evidence && evidence.preFuel && evidence.preFuel.value), evidence && evidence.prePoint ? fifTrackingFormatTime(evidence.prePoint.timestamp) + " · " + String(evidence.preSampleCount || 0) + " stable samples" : "No stable baseline"),
  	      fifTrackingReportMetric("Estimated arrival fuel", fifTrackingReportLitres(evidence && evidence.arrivalFuelLitres), evidence && Number.isFinite(evidence.arrivalConsumptionLitres) ? "Pre-fill baseline less measured consumption to arrival" : "Stable baseline used at arrival"),
  	      fifTrackingReportMetric("Arrival ullage", fifTrackingReportLitres(evidence && evidence.ullageLitres), "Capacity less estimated arrival fuel", evidence && Number.isFinite(evidence.ullageLitres) ? "good" : "review"),
  	      fifTrackingReportMetric("Stable post-fill level", fifTrackingReportLitres(evidence && evidence.postFuel && evidence.postFuel.value), evidence && evidence.postStable ? String(evidence.postSampleCount || 0) + " stable samples" : "No stable post-fill plateau"),
  	      fifTrackingReportMetric("Telemetry fuel rise", fifTrackingReportLitres(evidence && evidence.rawFuelIncrease), "Stable post-fill minus stable pre-fill · primary tracker figure", evidence && evidence.detected ? "good" : "review"),
  	      fifTrackingReportMetric("Captured fill", fifTrackingReportLitres(evidence && evidence.capturedLitres), "FuelOut transaction"),
  	      fifTrackingReportMetric("Telemetry variance", fifTrackingReportLitres(evidence && evidence.varianceLitres, true), evidence && Number.isFinite(evidence.variancePercent) ? (evidence.variancePercent > 0 ? "+" : "") + formatNumber(evidence.variancePercent, 1) + "% versus captured" : "Comparison unavailable", varianceTone),
  	      fifTrackingReportMetric("Fuel event timing", evidence && Number.isFinite(evidence.eventMs) ? fifTrackingFormatTime(evidence.eventMs) : "—", evidence && Number.isFinite(evidence.eventDistanceMs) ? fifTrackingFormatDuration(evidence.eventDistanceMs) + " from FuelOut capture" : "No stable event located"),
  	      fifTrackingReportMetric("Station dwell", fifTrackingFormatDuration(evidence && evidence.stopDurationMs), evidence && evidence.stopTransitionFound ? "Arrival stop transition found" : "Stop transition incomplete"),
  	      fifTrackingReportMetric("Evidence quality", quality, evidence && evidence.reason || "No tracking evidence", quality === "Strong" ? "good" : "review"),
  	      fifTrackingReportMetric("GPS points", String(points.length), source),
  	      fifTrackingReportMetric("Route distance", analysis ? formatNumber(analysis.distanceM / 1000, 2) + " km" : "—", "120-minute evidence window"),
  	      fifTrackingReportMetric("Largest packet gap", analysis ? fifTrackingFormatDuration(analysis.largestGapMs) : "—", "Tracker continuity")
  	    ].join("");

  	    const mapHtml = snapshotUrl
  	      ? `<img id="fif-tracking-print-map" src="${escapeAttr(snapshotUrl)}" alt="Hybrid Google Maps tracking evidence snapshot">`
  	      : `<div class="map-unavailable" data-map-unavailable><strong>Hybrid map snapshot unavailable</strong><span>The live map will be copied into this report when it is available.</span></div>`;

  	    const snapshotRows = [
  	      ["Time", fifTrackingSnapshotValue(before, "time", vehicle), fifTrackingSnapshotValue(nearest, "time", vehicle), fifTrackingSnapshotValue(after, "time", vehicle)],
  	      ["Speed", fifTrackingSnapshotValue(before, "speed", vehicle), fifTrackingSnapshotValue(nearest, "speed", vehicle), fifTrackingSnapshotValue(after, "speed", vehicle)],
  	      ["Ignition", fifTrackingSnapshotValue(before, "ignition", vehicle), fifTrackingSnapshotValue(nearest, "ignition", vehicle), fifTrackingSnapshotValue(after, "ignition", vehicle)],
  	      ["Odometer", fifTrackingSnapshotValue(before, "odometer", vehicle), fifTrackingSnapshotValue(nearest, "odometer", vehicle), fifTrackingSnapshotValue(after, "odometer", vehicle)],
  	      ["Fuel", fifTrackingSnapshotValue(before, "fuel", vehicle), fifTrackingSnapshotValue(nearest, "fuel", vehicle), fifTrackingSnapshotValue(after, "fuel", vehicle)]
  	    ];

  	    reportWindow.document.open();
  	    reportWindow.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${escapeHtml(reportTitle)}</title><style>
  	      @page{size:A4 landscape;margin:10mm}*{box-sizing:border-box}body{margin:0;color:#182019;background:#fff;font:11px/1.45 Arial,sans-serif}.print-toolbar{position:sticky;top:0;z-index:10;display:flex;justify-content:flex-end;gap:8px;padding:9px;background:#101612;border-bottom:3px solid #cc6633}.print-toolbar button{min-height:34px;padding:0 16px;border:1px solid #89918b;border-radius:6px;background:#fff;color:#172019;font-weight:800;cursor:pointer}.print-toolbar .primary{border-color:#a54f28;background:#cc6633;color:#fff}.report{padding:10mm}.report-head{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;padding-bottom:8px;border-bottom:3px solid #cc6633}.eyebrow{color:#a94f27;font-size:9px;font-weight:900;letter-spacing:.12em;text-transform:uppercase}h1{margin:3px 0 0;font-size:24px;line-height:1.1}.subhead{margin-top:5px;color:#667069}.logo{max-width:120px;max-height:48px}.transaction{margin-top:10px;border:1px solid #b8bdb9;border-radius:7px;overflow:hidden}.transaction table,.snapshots table{width:100%;border-collapse:collapse}.transaction th,.transaction td,.snapshots th,.snapshots td{padding:7px 8px;border:1px solid #c7cbc8;text-align:left;vertical-align:top}.transaction th,.snapshots th{background:#eef0ee;color:#4f5952;font-size:9px;text-transform:uppercase}.section-title{display:flex;justify-content:space-between;align-items:end;gap:10px;margin:13px 0 7px}.section-title h2{margin:0;font-size:15px}.section-title span{color:#717a73;font-size:9px}.metrics{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}.report-metric{min-height:67px;padding:8px;border:1px solid #c7cbc8;border-top:3px solid #858e87;border-radius:6px;background:#fafbfa}.report-metric.good{border-top-color:#2f9d61}.report-metric.review{border-top-color:#d08a29}.report-metric span,.report-metric strong,.report-metric small{display:block}.report-metric span{color:#6b746d;font-size:8px;font-weight:900;text-transform:uppercase}.report-metric strong{margin-top:3px;font-size:15px}.report-metric small{margin-top:3px;color:#727b74;font-size:8px}.map-card{border:1px solid #b9bfba;border-radius:7px;overflow:hidden;background:#111}.map-card img{display:block;width:100%;height:auto;max-height:142mm;object-fit:contain;background:#111}.map-unavailable{display:grid;place-items:center;min-height:90mm;padding:20px;background:#151a16;color:#fff;text-align:center}.map-unavailable span{display:block;margin-top:5px;color:#b4bcb6}.live-map-clone{position:relative;width:100%;height:132mm;overflow:hidden;background:#111}.live-map-clone[hidden]{display:none}.live-map-clone>.fiftrk-map{position:relative!important;inset:auto!important;width:100%!important;height:100%!important}.legend{display:flex;gap:16px;flex-wrap:wrap;padding:7px 9px;background:#f0f2f0;border-top:1px solid #b9bfba}.legend span{display:flex;align-items:center;gap:5px;font-size:9px;font-weight:800}.legend i{width:19px;height:4px;border-radius:4px;background:#cc6633}.legend .after i{background:#3d8bfd}.legend .marker i{width:9px;height:9px;border-radius:50%;background:#ffd166}.driver-photo-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px}.driver-photo-grid.single{grid-template-columns:1fr}.driver-photo-card{overflow:hidden;border:1px solid #bcc2bd;border-radius:7px;background:#f7f8f7;break-inside:avoid;page-break-inside:avoid}.driver-photo-card header{padding:8px 10px;border-bottom:1px solid #c8cdc9;background:#eef0ee}.driver-photo-card header span,.driver-photo-card header strong{display:block}.driver-photo-card header span{color:#a94f27;font-size:8px;font-weight:900;text-transform:uppercase;letter-spacing:.08em}.driver-photo-card header strong{margin-top:2px;color:#2d352f;font-size:10px}.driver-photo-card>div{height:145mm;display:grid;place-items:center;padding:5mm;background:#111}.driver-photo-card img{display:block;max-width:100%;max-height:100%;object-fit:contain}.driver-photo-note{margin-top:8px;padding:8px 10px;border:1px solid #c7cbc8;border-radius:6px;background:#f7f8f7;color:#5d675f;font-size:8px}.evidence-grid{display:grid;grid-template-columns:1.25fr .75fr;gap:10px}.note{padding:10px;border:1px solid #c7cbc8;border-radius:7px;background:#f7f8f7}.note h3{margin:0 0 5px;font-size:12px}.note p{margin:0 0 7px;color:#535d55}.note ul{margin:5px 0 0;padding-left:17px}.signoff{display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-top:16px}.signoff div{padding-top:22px;border-bottom:1px solid #444}.footer{margin-top:12px;padding-top:7px;border-top:1px solid #bcc1bd;color:#69726b;font-size:8px}.page-break{break-before:page;page-break-before:always}@media print{.print-toolbar{display:none}.report{padding:0}.map-card,.transaction,.report-metric,.note,.driver-photo-card,tr{break-inside:avoid;page-break-inside:avoid}.section-title{break-after:avoid;page-break-after:avoid}}
  	    </style></head><body><div class="print-toolbar"><button type="button" data-report-close>Close</button><button type="button" class="primary" data-report-print>Print / Save PDF</button></div><main class="report">
  	      <header class="report-head"><div><div class="eyebrow">Fleet In Form · Fuel Tracking Evidence</div><h1>${escapeHtml(reportTitle)}</h1><div class="subhead">${escapeHtml(fifTrackingFormatTime(context.fromMs))} — ${escapeHtml(fifTrackingFormatTime(context.toMs))} · 60 minutes before and after capture</div></div><div>${logo}</div></header>
  	      <section class="transaction"><table><tbody><tr><th>Company</th><td>${escapeHtml(companyName(company))}</td><th>Vehicle</th><td>${escapeHtml(vehicleTitleValue(vehicle))}</td><th>Registration</th><td>${escapeHtml(vehicleRegistrationValue(vehicle) || "—")}</td></tr><tr><th>Transaction</th><td>${escapeHtml(fifTrackingFormatTime(context.anchor.timestamp))}</td><th>Supplier</th><td>${escapeHtml(row.supplier || "Not recorded")}</td><th>Reference</th><td>${escapeHtml(row.reference || "—")}</td></tr><tr><th>Captured fuel</th><td>${escapeHtml(formatLitres(row.litres))}</td><th>Total</th><td>${escapeHtml(formatCurrency(row.cost))}</td><th>Application</th><td>${escapeHtml(row.application || "Fuel")}</td></tr><tr><th>Captured mileage</th><td>${escapeHtml(fifTrackingFormatMileage(mileageAudit.capturedMileage, mileageAudit.capturedUnit))}</td><th>Tracker mileage</th><td>${escapeHtml(fifTrackingFormatMileage(mileageAudit.trackerMileage, "km"))}</td><th>Mileage check</th><td>${escapeHtml(mileageAudit.result + (mileageAudit.note ? " · " + mileageAudit.note : ""))}</td></tr><tr><th>Fuel slip photo</th><td>${escapeHtml(slipPhotoStatus)}</td><th>Odometer photo</th><td>${escapeHtml(odometerPhotoStatus)}</td><th>Driver photos</th><td>${escapeHtml(String(driverPhotos.loadedCount || 0))} loaded / ${escapeHtml(String(driverPhotos.savedCount || 0))} saved</td></tr></tbody></table></section>
  	      <div class="section-title"><h2>Ullage and telemetry fuel reconciliation</h2><span>Calculated from the same bounded tracking evidence displayed on screen</span></div><section class="metrics">${metricHtml}</section>
  	      <div class="section-title"><h2>Hybrid Google Maps snapshot</h2><span>Current map centre and zoom captured when Print Report was selected</span></div><section class="map-card">${mapHtml}<div class="live-map-clone" data-live-map-clone hidden></div><div class="legend"><span><i></i>60 min before</span><span class="after"><i></i>60 min after</span><span class="marker"><i></i>Fuel transaction / evidence markers</span><span>S start · P stable pre-fill · F fuel fix · O stable post-fill · E end</span></div></section>
  	      ${photoPageHtml}
  	      <section class="page-break"><div class="section-title"><h2>Telemetry evidence snapshots</h2><span>Before · nearest fuel capture fix · after</span></div><div class="evidence-grid"><div class="snapshots"><table><thead><tr><th>Reading</th><th>Before</th><th>Capture fix</th><th>After</th></tr></thead><tbody>${snapshotRows.map(function (values) { return `<tr>${values.map(function (value, index) { return index ? `<td>${escapeHtml(value)}</td>` : `<th>${escapeHtml(value)}</th>`; }).join("")}</tr>`; }).join("")}</tbody></table></div><aside class="note"><h3>Evidence basis</h3><p>${escapeHtml(evidence && evidence.reason || context.error || "Tracking evidence was not available.")}</p><ul><li>Tracking source: ${escapeHtml(source)}</li><li>Nearest fix from capture: ${analysis && Number.isFinite(analysis.nearestGapMs) ? escapeHtml(fifTrackingFormatDuration(analysis.nearestGapMs)) : "—"}</li><li>Stable pre-fill samples: ${escapeHtml(String(evidence && evidence.preSampleCount || 0))}</li><li>Stable post-fill samples: ${escapeHtml(String(evidence && evidence.postSampleCount || 0))}</li><li>Stable plateaus found: ${escapeHtml(String(evidence && evidence.plateauCount || 0))}</li><li>Moving fuel readings excluded from baseline: Yes</li><li>Fuel slip photo: ${escapeHtml(slipPhotoStatus)}</li><li>Odometer photo: ${escapeHtml(odometerPhotoStatus)}</li></ul></aside></div>
  	      <div class="section-title"><h2>Method and review</h2></div><section class="note"><p><strong>Mileage audit</strong> compares the driver-entered FuelOut mileage with the silent Flespi <strong>can.vehicle.mileage</strong> captured when the fuel process opened. The displayed variance is tracker mileage minus captured mileage. <strong>Fuel-event analysis</strong> uses the FuelOut timestamp only to bound the search window. Stable stationary fuel plateaus determine the actual pre-fill and post-fill levels; fuel readings while the vehicle is moving are excluded from the baseline. <strong>Telemetry fuel rise</strong> is the stable post-fill level minus the stable pre-fill baseline and is the primary tracker-derived figure compared with the captured FuelOut litres. It is not adjusted by fuel-consumption telemetry. <strong>Arrival ullage</strong> is tank capacity minus the estimated arrival fuel; when possible the stable pre-fill baseline is carried forward to the GPS arrival stop using measured fuel consumption.</p><p><strong>Driver photographs</strong> are optional supporting FuelOut evidence. When supplied, the Dashboard retrieves them through the authenticated Fleet In Form File API and reproduces the stored images in this report without editing their contents.</p><p>This is operational evidence, not a calibrated tank measurement. Sensor resolution, CAN filtering, packet gaps, vehicle slope and movement can affect the result. Variances should be reviewed against slips, invoices and vehicle/tank records before action is taken.</p></section><section class="signoff"><div>Reviewed by / date</div><div>Authorised by / date</div></section>
  	      <footer class="footer">Generated ${escapeHtml(new Date().toLocaleString("en-ZA"))} · Fleet In Form Fuel Tracking Evidence · ${escapeHtml(VERSION)}</footer>
  	    </section></main></body></html>`);

  	    reportWindow.document.close();
  	    reportWindow.document.querySelector("[data-report-close]")?.addEventListener("click", function () { reportWindow.close(); });
  	    reportWindow.document.querySelector("[data-report-print]")?.addEventListener("click", function () { reportWindow.focus(); reportWindow.print(); });

  	    const mapImage = reportWindow.document.getElementById("fif-tracking-print-map");
  	    const driverPhotoImages = Array.prototype.slice.call(
  	      reportWindow.document.querySelectorAll("[data-driver-photo-report]")
  	    );

  	    const installLiveMapClone = function () {
  	      const sourceMap = windowNode && windowNode.querySelector("[data-fif-tracking-map]");
  	      const targetMap = reportWindow.document.querySelector("[data-live-map-clone]");
  	      if (!sourceMap || !sourceMap.childNodes.length || !targetMap) return false;
  	      try {
  	        const clone = reportWindow.document.importNode(sourceMap, true);
  	        clone.removeAttribute("data-fif-tracking-map");
  	        clone.removeAttribute("id");
  	        targetMap.innerHTML = "";
  	        targetMap.appendChild(clone);
  	        targetMap.hidden = false;
  	        if (mapImage) mapImage.hidden = true;
  	        const unavailable = reportWindow.document.querySelector("[data-map-unavailable]");
  	        if (unavailable) unavailable.hidden = true;
  	        return true;
  	      } catch (_) {
  	        return false;
  	      }
  	    };

  	    let printQueued = false;
  	    let mapReadyForPrint = false;

  	    const driverPhotosReadyForPrint = function () {
  	      return driverPhotoImages.every(function (image) {
  	        return !!image.complete;
  	      });
  	    };

  	    const queuePrint = function (force) {
  	      if (printQueued || reportWindow.closed) return;
  	      if (!force && (!mapReadyForPrint || !driverPhotosReadyForPrint())) return;
  	      printQueued = true;
  	      reportWindow.setTimeout(function () {
  	        if (reportWindow.closed) return;
  	        reportWindow.focus();
  	        reportWindow.print();
  	      }, 220);
  	    };

  	    driverPhotoImages.forEach(function (image) {
  	      if (image.complete) return;
  	      image.addEventListener("load", function () { queuePrint(false); }, { once: true });
  	      image.addEventListener("error", function () { queuePrint(false); }, { once: true });
  	    });

  	    if (mapImage && !mapImage.complete) {
  	      mapImage.addEventListener("load", function () {
  	        mapReadyForPrint = true;
  	        queuePrint(false);
  	      }, { once: true });
  	      mapImage.addEventListener("error", function () {
  	        installLiveMapClone();
  	        mapReadyForPrint = true;
  	        reportWindow.setTimeout(function () { queuePrint(false); }, 700);
  	      }, { once: true });
  	    } else if (mapImage && !mapImage.naturalWidth) {
  	      installLiveMapClone();
  	      mapReadyForPrint = true;
  	      reportWindow.setTimeout(function () { queuePrint(false); }, 700);
  	    } else if (!mapImage) {
  	      installLiveMapClone();
  	      mapReadyForPrint = true;
  	      reportWindow.setTimeout(function () { queuePrint(false); }, 700);
  	    } else {
  	      mapReadyForPrint = true;
  	      reportWindow.setTimeout(function () { queuePrint(false); }, 350);
  	    }

  	    reportWindow.setTimeout(function () { queuePrint(true); }, 3200);
  	    return true;
  	  }

  	  function injectFuelTrackingStyles() {
  	    if (document.getElementById(FIF_FUEL_TRACKING_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = FIF_FUEL_TRACKING_STYLE_ID;
  	    style.textContent = `
  	      #${FIF_FUEL_TRACKING_WINDOW_ID}{position:fixed;left:50%;top:${TOP_OFFSET_PX + 22}px;z-index:2147482000;width:min(1180px,calc(100vw - 30px));height:min(760px,calc(100vh - ${TOP_OFFSET_PX + 42}px));min-width:620px;min-height:430px;display:grid;grid-template-rows:auto minmax(0,1fr);overflow:hidden;resize:both;transform:translateX(-50%);border:1px solid rgba(204,102,51,.68);border-radius:16px;background:#090d0b;color:#edf2ef;box-shadow:0 30px 90px rgba(0,0,0,.72),0 0 0 1px rgba(0,0,0,.75);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} *{box-sizing:border-box}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID}>header{display:flex;align-items:center;justify-content:space-between;gap:15px;min-height:66px;padding:11px 14px 11px 17px;border-bottom:1px solid rgba(255,255,255,.08);background:linear-gradient(145deg,#1a211c,#0d120f);cursor:move;touch-action:none;user-select:none}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID}>header span,#${FIF_FUEL_TRACKING_WINDOW_ID}>header strong,#${FIF_FUEL_TRACKING_WINDOW_ID}>header small{display:block}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID}>header span{color:#d47d4d;font-size:9px;font-weight:950;text-transform:uppercase;letter-spacing:.1em}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID}>header strong{margin-top:3px;color:#fff;font-size:16px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID}>header small{margin-top:3px;color:#8e9992;font-size:9px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-window-actions{display:flex;align-items:center;gap:8px;flex:0 0 auto}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-print{min-height:39px;padding:0 14px;border:1px solid rgba(204,102,51,.7);border-radius:10px;background:#9f4d29;color:#fff;font-size:9px;font-weight:950;cursor:pointer;white-space:nowrap}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-print:hover{background:#bd5c31;border-color:#e58b5f}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-print:disabled{opacity:.42;cursor:wait;filter:saturate(.4)}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-close{width:39px;height:39px;flex:0 0 39px;border:1px solid rgba(255,255,255,.1);border-radius:10px;background:#151b17;color:#d9dfdb;font-size:20px;cursor:pointer}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-body{display:grid;grid-template-columns:minmax(0,1.65fr) minmax(330px,.85fr);min-height:0}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-map-shell{position:relative;min-width:0;min-height:0;background:#101611}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-map{position:absolute;inset:0}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-map-state{position:absolute;inset:0;z-index:5;display:grid;place-items:center;padding:30px;background:radial-gradient(circle at 50% 30%,rgba(204,102,51,.11),transparent 40%),#0b100c;color:#a4ada7;text-align:center;font-size:11px;line-height:1.5}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-map-state[hidden]{display:none}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-map-notice{position:absolute;left:12px;top:12px;z-index:7;max-width:min(520px,calc(100% - 24px));padding:9px 11px;border:1px solid rgba(227,160,74,.42);border-radius:9px;background:rgba(15,18,14,.92);color:#e8b66f;box-shadow:0 8px 24px rgba(0,0,0,.35);backdrop-filter:blur(8px);font-size:9px;font-weight:800;line-height:1.45}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-map-notice[hidden]{display:none}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-legend{position:absolute;left:12px;bottom:12px;z-index:6;display:flex;gap:8px;flex-wrap:wrap;padding:8px 10px;border:1px solid rgba(255,255,255,.1);border-radius:9px;background:rgba(7,11,8,.88);backdrop-filter:blur(8px);font-size:9px;font-weight:850}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-legend span{display:flex;align-items:center;gap:5px;color:#d7ddd9}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-legend i{width:18px;height:4px;border-radius:9px;background:#cc6633}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-legend span:nth-child(2) i{background:#3d8bfd}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-legend span:nth-child(3) i{width:9px;height:9px;border-radius:50%;background:#ffd166}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-side{min-width:0;overflow:auto;padding:11px;border-left:1px solid rgba(255,255,255,.075);background:#0a0f0b;scrollbar-width:thin;scrollbar-color:rgba(204,102,51,.5) transparent}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-transaction{padding:11px;border:1px solid rgba(204,102,51,.28);border-radius:11px;background:rgba(204,102,51,.065)}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-transaction span,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-transaction strong,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-transaction small{display:block}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-transaction span{color:#cc7a4e;font-size:8px;font-weight:950;text-transform:uppercase;letter-spacing:.08em}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-transaction strong{margin-top:5px;color:#fff;font-size:13px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-transaction small{margin-top:5px;color:#9ca69f;font-size:9px;line-height:1.45}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-driver-photo-host{margin-top:9px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-summary{display:grid;gap:9px;margin-top:9px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-quality{display:flex;align-items:flex-start;gap:9px;padding:10px;border:1px solid rgba(255,255,255,.08);border-radius:10px;background:#111712}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-quality i{width:9px;height:9px;flex:0 0 9px;margin-top:3px;border-radius:50%;background:#ef5350}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-quality.good i{background:#49c785}#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-quality.warning i{background:#e3a04a}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-quality strong,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-quality span{display:block}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-quality strong{color:#eef3ef;font-size:10px}#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-quality span{margin-top:4px;color:#858f88;font-size:8px;line-height:1.4}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metrics{display:grid;grid-template-columns:1fr 1fr;gap:7px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metric{min-width:0;padding:9px;border:1px solid rgba(255,255,255,.07);border-radius:9px;background:#101511}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metric span,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metric strong,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metric small{display:block}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metric span{color:#7e8881;font-size:7px;font-weight:950;text-transform:uppercase;letter-spacing:.06em}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metric strong{margin-top:4px;color:#f1f4f2;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metric.good strong{color:#72dda0}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metric.warning strong{color:#e3a04a}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-metric small{margin-top:4px;color:#737d76;font-size:7.5px;line-height:1.35}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshots{overflow:hidden;border:1px solid rgba(255,255,255,.075);border-radius:10px;background:#0e130f}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-refuel-evidence{border-color:rgba(204,102,51,.34);background:rgba(204,102,51,.035)}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-mileage-audit{border-color:rgba(61,139,253,.34);background:rgba(61,139,253,.035)}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-driver-evidence{border-color:rgba(73,199,133,.28);background:rgba(73,199,133,.025)}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-refuel-evidence .fiftrk-metrics,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-mileage-audit .fiftrk-metrics{padding:8px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-grid{display:grid;grid-template-columns:1fr 1fr;gap:7px;padding:8px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-card{min-width:0;padding:0;overflow:hidden;border:1px solid rgba(255,255,255,.08);border-radius:9px;background:#101511;color:#eef3ef;text-align:left;cursor:pointer}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-card:disabled{cursor:default;opacity:.78}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-card>span{display:block;padding:7px 8px 6px;color:#9ca69f;font-size:7.5px;font-weight:950;text-transform:uppercase;letter-spacing:.06em}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-card.loaded>span{color:#72dda0}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-card.error>span{color:#e3a04a}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-frame{height:126px;display:grid;place-items:center;overflow:hidden;border-top:1px solid rgba(255,255,255,.055);border-bottom:1px solid rgba(255,255,255,.055);background:#070a08;color:#6f7972;font-size:8px;font-weight:850;text-align:center}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-frame img{display:block;width:100%;height:100%;object-fit:contain;background:#050705}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-card>small{display:block;min-height:34px;padding:6px 8px;color:#7f8982;font-size:7px;line-height:1.35;overflow:hidden}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-empty{padding:13px 10px;color:#858f88;font-size:8px;line-height:1.45}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer{position:absolute;inset:0;z-index:30;display:grid;place-items:center;padding:22px;background:rgba(0,0,0,.82);backdrop-filter:blur(5px)}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-card{width:min(900px,96%);height:min(660px,94%);display:grid;grid-template-rows:auto minmax(0,1fr);overflow:hidden;border:1px solid rgba(204,102,51,.55);border-radius:14px;background:#090d0b;box-shadow:0 24px 80px rgba(0,0,0,.65)}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-card>header{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 12px;border-bottom:1px solid rgba(255,255,255,.08);background:#151a16}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-card>header span,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-card>header strong,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-card>header small{display:block}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-card>header span{color:#cc7a4e;font-size:7.5px;font-weight:950;text-transform:uppercase}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-card>header strong{margin-top:2px;color:#fff;font-size:13px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-card>header small{margin-top:2px;color:#89938c;font-size:8px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-card>header button{width:38px;height:38px;border:1px solid rgba(255,255,255,.1);border-radius:9px;background:#111712;color:#fff;font-size:20px;cursor:pointer}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-image{min-height:0;display:grid;place-items:center;padding:10px;background:#030503}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-viewer-image img{display:block;max-width:100%;max-height:100%;object-fit:contain}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshots>header{padding:9px 10px;border-bottom:1px solid rgba(255,255,255,.065);background:#151a16}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshots>header span,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshots>header strong{display:block}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshots>header span{color:#d17a4c;font-size:7.5px;font-weight:950;text-transform:uppercase}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshots>header strong{margin-top:3px;color:#e9edea;font-size:9px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshot-table{overflow:auto;font-size:7.5px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshot-table>div{display:grid;grid-template-columns:72px repeat(3,minmax(92px,1fr));min-width:360px}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshot-table span,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshot-table b{padding:7px;border-right:1px solid rgba(255,255,255,.045);border-bottom:1px solid rgba(255,255,255,.045);color:#aeb6b0;font-weight:750}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshot-table b{color:#e8ece9;background:#141915;font-size:7px;text-transform:uppercase}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-snapshot-table span:first-child{color:#7f8982;font-weight:900}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-empty{padding:24px 12px;border:1px dashed rgba(227,160,74,.28);border-radius:10px;text-align:center}
  	      #${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-empty strong,#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-empty span{display:block}#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-empty strong{color:#e6ad60;font-size:12px}#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-empty span{margin-top:6px;color:#818b84;font-size:9px;line-height:1.5}
  	      @media(max-width:820px){#${FIF_FUEL_TRACKING_WINDOW_ID}{left:8px!important;top:${TOP_OFFSET_PX + 8}px!important;width:calc(100vw - 16px)!important;height:calc(100vh - ${TOP_OFFSET_PX + 16}px)!important;min-width:0;min-height:0;resize:none;transform:none!important}#${FIF_FUEL_TRACKING_WINDOW_ID}>header strong{font-size:13px}#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-print{padding:0 10px}#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-body{grid-template-columns:1fr;grid-template-rows:minmax(280px,52%) minmax(0,48%)}#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-side{border-left:0;border-top:1px solid rgba(255,255,255,.075)}#${FIF_FUEL_TRACKING_WINDOW_ID} .fiftrk-photo-frame{height:150px}}
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function closeFuelTrackingWindow() {
  	    const node = document.getElementById(FIF_FUEL_TRACKING_WINDOW_ID);
  	    if (!node) return;
  	    const runtime = node.__fifTrackingRuntime || {};
  	    runtime.closed = true;
  	    try { runtime.abortController?.abort(); } catch (_) {}
  	    try { runtime.resizeObserver?.disconnect(); } catch (_) {}
  	    arr(runtime.overlays).forEach(function (overlay) {
  	      try { overlay.setMap?.(null); } catch (_) {}
  	      try { overlay.close?.(); } catch (_) {}
  	    });
  	    try {
  	      fifTrackingRevokeDriverPhotoEvidence(
  	        runtime.printContext && runtime.printContext.photos
  	      );
  	    } catch (_) {}
  	    node.remove();
  	  }

  	  function fifTrackingBindDrag(node) {
  	    const handle = node.querySelector("[data-fif-tracking-drag]");
  	    if (!handle) return;
  	    let drag = null;
  	    handle.addEventListener("pointerdown", function (event) {
  	      if (event.target.closest("button,input,select,a")) return;
  	      const rect = node.getBoundingClientRect();
  	      node.style.left = rect.left + "px";
  	      node.style.top = rect.top + "px";
  	      node.style.transform = "none";
  	      drag = { x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, id: event.pointerId };
  	      try { handle.setPointerCapture(event.pointerId); } catch (_) {}
  	      event.preventDefault();
  	    });
  	    handle.addEventListener("pointermove", function (event) {
  	      if (!drag || event.pointerId !== drag.id) return;
  	      const maxLeft = Math.max(0, window.innerWidth - node.offsetWidth);
  	      const maxTop = Math.max(TOP_OFFSET_PX, window.innerHeight - 70);
  	      node.style.left = Math.max(0, Math.min(maxLeft, drag.left + event.clientX - drag.x)) + "px";
  	      node.style.top = Math.max(TOP_OFFSET_PX, Math.min(maxTop, drag.top + event.clientY - drag.y)) + "px";
  	    });
  	    const stop = function (event) {
  	      if (!drag || event.pointerId !== drag.id) return;
  	      try { handle.releasePointerCapture(event.pointerId); } catch (_) {}
  	      drag = null;
  	    };
  	    handle.addEventListener("pointerup", stop);
  	    handle.addEventListener("pointercancel", stop);
  	  }

  	  async function openFuelTrackingWindow(company, vehicle, row) {
  	    const anchor = fifTrackingRecordAnchor(row);
  	    if (!anchor) {
  	      await fifAlert("This FuelOut record has no usable transaction timestamp, so a tracking evidence window cannot be calculated.", {
  	        title: "Tracking Time Unavailable", type: "warning", confirmText: "Close"
  	      });
  	      return null;
  	    }

  	    closeFuelTrackingWindow();
  	    injectFuelTrackingStyles();

  	    const fromMs = anchor.timestamp - FIF_FUEL_TRACKING_WINDOW_MINUTES * 60000;
  	    const toMs = anchor.timestamp + FIF_FUEL_TRACKING_WINDOW_MINUTES * 60000;
  	    const node = document.createElement("section");
  	    node.id = FIF_FUEL_TRACKING_WINDOW_ID;
  	    node.setAttribute("role", "dialog");
  	    node.setAttribute("aria-modal", "false");
  	    node.innerHTML = `<header data-fif-tracking-drag><div><span>Fuel Tracking Evidence</span><strong>${escapeHtml(vehicleTitleValue(vehicle))} · ${escapeHtml(formatLitres(row.litres))}</strong><small>${escapeHtml(fifTrackingFormatTime(fromMs))} — ${escapeHtml(fifTrackingFormatTime(toMs))}</small></div><div class="fiftrk-window-actions"><button type="button" class="fiftrk-print" data-fif-tracking-print disabled aria-busy="true">Print Report</button><button type="button" class="fiftrk-close" data-fif-tracking-close aria-label="Close tracking evidence">×</button></div></header>
  	      <div class="fiftrk-body">
  	        <section class="fiftrk-map-shell"><div class="fiftrk-map" data-fif-tracking-map></div><div class="fiftrk-map-state" data-fif-tracking-map-state>Opening Google Maps…</div><div class="fiftrk-map-notice" data-fif-tracking-map-notice hidden></div><div class="fiftrk-legend"><span><i></i>60 min before</span><span><i></i>60 min after</span><span><i></i>Nearest capture fix</span></div></section>
  	        <aside class="fiftrk-side"><div class="fiftrk-transaction"><span>Fuel transaction</span><strong>${escapeHtml(fifTrackingFormatTime(anchor.timestamp))}</strong><small>${escapeHtml(anchor.source)} · ${escapeHtml(row.supplier)} · ${escapeHtml(formatCurrency(row.cost))}</small></div><div class="fiftrk-driver-photo-host" data-fif-driver-photos>${fifTrackingDriverPhotosLoadingHtml()}</div><div class="fiftrk-summary" data-fif-tracking-summary><div class="fiftrk-empty"><strong>Loading tracking evidence</strong><span>Only the bounded transaction window is being requested.</span></div></div></aside>
  	      </div>`;

  	    document.body.appendChild(node);
  	    fifTrackingBindDrag(node);
  	    node.querySelector("[data-fif-tracking-close]")?.addEventListener("click", closeFuelTrackingWindow);

  	    const abortController = typeof AbortController !== "undefined" ? new AbortController() : null;
  	    let driverPhotoEvidence = null;
  	    let photosReady = false;
  	    let trackingReady = false;

  	    node.__fifTrackingRuntime = {
  	      abortController: abortController,
  	      overlays: [],
  	      closed: false,
  	      printContext: {
  	        company: company,
  	        vehicle: vehicle,
  	        row: row,
  	        anchor: anchor,
  	        fromMs: fromMs,
  	        toMs: toMs,
  	        loaded: null,
  	        points: [],
  	        analysis: null,
  	        error: "",
  	        photos: null
  	      }
  	    };

  	    const printButton = node.querySelector("[data-fif-tracking-print]");
  	    printButton?.addEventListener("click", function () { fifTrackingPrintReport(node); });

  	    const enablePrintReport = function () {
  	      if (!printButton || !node.isConnected || !trackingReady || !photosReady) return;
  	      printButton.disabled = false;
  	      printButton.setAttribute("aria-busy", "false");
  	    };

  	    const summaryNode = node.querySelector("[data-fif-tracking-summary]");
  	    const photoHost = node.querySelector("[data-fif-driver-photos]");
  	    const mapState = node.querySelector("[data-fif-tracking-map-state]");
  	    const mapNotice = node.querySelector("[data-fif-tracking-map-notice]");

  	    const photoPromise = fifTrackingLoadDriverPhotoEvidence(
  	      row,
  	      abortController && abortController.signal
  	    ).then(function (evidence) {
  	      if (!node.isConnected || node.__fifTrackingRuntime.closed) {
  	        fifTrackingRevokeDriverPhotoEvidence(evidence);
  	        return evidence;
  	      }

  	      driverPhotoEvidence = evidence;
  	      node.__fifTrackingRuntime.printContext.photos = evidence;

  	      if (photoHost) {
  	        photoHost.innerHTML = fifTrackingDriverPhotosHtml(evidence);
  	        fifTrackingBindDriverPhotoButtons(node, evidence);
  	      }

  	      return evidence;
  	    }).catch(function (photoError) {
  	      if (photoError && photoError.name === "AbortError") return null;

  	      const message = clean(photoError && photoError.message) || "Driver photo evidence could not be loaded.";
  	      driverPhotoEvidence = {
  	        items: fifTrackingDriverPhotoConfigs().map(function (config) {
  	          return {
  	            kind: config.kind,
  	            label: config.label,
  	            name: "",
  	            key: "",
  	            saved: !!fifTrackingDriverPhotoSavedValue(row, config, "url"),
  	            loaded: false,
  	            objectUrl: "",
  	            dataUrl: "",
  	            bytes: 0,
  	            error: message
  	          };
  	        }),
  	        savedCount: 0,
  	        loadedCount: 0
  	      };

  	      if (node.isConnected && !node.__fifTrackingRuntime.closed) {
  	        node.__fifTrackingRuntime.printContext.photos = driverPhotoEvidence;
  	        if (photoHost) photoHost.innerHTML = fifTrackingDriverPhotosHtml(driverPhotoEvidence);
  	      }

  	      return driverPhotoEvidence;
  	    }).finally(function () {
  	      photosReady = true;
  	      enablePrintReport();
  	    });

  	    let mapErrorMessage = "";
  	    const showMapNotice = function (message) {
  	      if (!mapNotice) return;
  	      mapNotice.textContent = clean(message);
  	      mapNotice.hidden = !clean(message);
  	    };

  	    const mapReadyPromise = fifTrackingEnsureGoogleMaps().then(function () {
  	      if (!node.isConnected || node.__fifTrackingRuntime.closed) return false;
  	      fifTrackingRenderMap(node, [], anchor.timestamp, null, row, vehicle);
  	      mapState.hidden = true;
  	      return true;
  	    }).catch(function (mapError) {
  	      mapErrorMessage = clean(mapError && mapError.message) || "Google Maps could not be opened.";
  	      if (node.isConnected && !node.__fifTrackingRuntime.closed) {
  	        mapState.hidden = false;
  	        mapState.textContent = mapErrorMessage;
  	      }
  	      return false;
  	    });

  	    try {
  	      const loaded = await fifTrackingLoadWindow(
  	        vehicle,
  	        anchor.timestamp,
  	        abortController && abortController.signal
  	      );
  	      if (!node.isConnected || node.__fifTrackingRuntime.closed) return null;

  	      fifTrackingConsoleLog(loaded, vehicle, row, anchor.timestamp);
  	      const points = fifTrackingNormalizePoints(loaded.rows, fromMs, toMs);
  	      const analysis = fifTrackingAnalyze(points, anchor.timestamp, vehicle, row);
  	      fifTrackingConsoleRefuelEvidence(analysis.refuel);

  	      node.__fifTrackingRuntime.printContext = {
  	        company: company,
  	        vehicle: vehicle,
  	        row: row,
  	        anchor: anchor,
  	        fromMs: fromMs,
  	        toMs: toMs,
  	        loaded: loaded,
  	        points: points,
  	        analysis: analysis,
  	        error: "",
  	        photos: driverPhotoEvidence
  	      };

  	      summaryNode.innerHTML = fifTrackingSummaryHtml(
  	        analysis,
  	        points,
  	        anchor.timestamp,
  	        vehicle,
  	        loaded.source,
  	        row,
  	        loaded.rows
  	      );

  	      const mapReady = await mapReadyPromise;
  	      if (!node.isConnected || node.__fifTrackingRuntime.closed) return null;

  	      trackingReady = true;

  	      if (!points.length) {
  	        if (mapReady) {
  	          showMapNotice("Google Maps is active. No historical GPS positions were returned inside this 120-minute transaction window.");
  	        }
  	        enablePrintReport();
  	        return node;
  	      }

  	      if (mapReady) {
  	        fifTrackingRenderMap(node, points, anchor.timestamp, analysis, row, vehicle);
  	        showMapNotice("");
  	      }

  	      enablePrintReport();
  	    } catch (error) {
  	      if (!node.isConnected || node.__fifTrackingRuntime.closed) return null;

  	      const message = clean(error && (error.message || error.faultString)) || "Tracking history could not be loaded.";
  	      node.__fifTrackingRuntime.printContext = {
  	        company: company,
  	        vehicle: vehicle,
  	        row: row,
  	        anchor: anchor,
  	        fromMs: fromMs,
  	        toMs: toMs,
  	        loaded: null,
  	        points: [],
  	        analysis: null,
  	        error: message,
  	        photos: driverPhotoEvidence
  	      };

  	      const mapReady = await mapReadyPromise;
  	      if (!node.isConnected || node.__fifTrackingRuntime.closed) return null;

  	      if (mapReady) {
  	        showMapNotice("Google Maps is active. The historical route is unavailable until the tracker-history connection succeeds.");
  	      } else {
  	        mapState.hidden = false;
  	        mapState.textContent = mapErrorMessage || "Google Maps could not be opened.";
  	      }

  	      summaryNode.innerHTML = `${fifTrackingMileageAuditHtml(row, [], anchor.timestamp)}<div class="fiftrk-empty"><strong>Tracking history unavailable</strong><span>${escapeHtml(message)}</span></div>`;
  	      trackingReady = true;
  	      enablePrintReport();
  	    }

  	    /*
  	     * Keep the photo loader alive in parallel with tracking. The print button is
  	     * released only after both tracking and photo evidence have settled.
  	     */
  	    void photoPromise;

  	    return node;
  	  }

  	function fifFuelReportRecordRows(company, vehicle, rows) {
  	    if (!rows.length) return `<div class="fif-fuel-report-empty"><strong>No detailed FuelOut rows loaded</strong><span>The period totals remain available from Tractorview, but record-level evidence is not present in App Data.</span></div>`;
  	    return `<div class="fif-fuel-report-table-wrap"><table class="fif-fuel-report-table">
  	      <thead><tr><th>Fuel record</th><th>Fuel</th><th>Total</th><th>Supplier & use</th><th>SARS</th><th>Tracking</th></tr></thead>
  	      <tbody>${rows.map(function (row) {
  	        const trackingAnchor = fifTrackingRecordAnchor(row);
  	        const trackingAvailable = !!trackingAnchor && !!fifTrackingVehicleId(vehicle);
  	        const trackingReason = !trackingAnchor ? "No transaction time" : !fifTrackingVehicleId(vehicle) ? "No tracker assigned" : "Open ±20 minute tracking evidence";
  	        return `<tr>
  	          <td class="record-cell"><strong>${escapeHtml(fifFuelReportDate(row.date))}</strong><small>${row.mileage === null ? "Mileage not recorded" : escapeHtml(formatNumber(row.mileage, 0) + " km")} · ${escapeHtml(formatDistance(row.distance))}</small>${row.reference ? `<small>Ref: ${escapeHtml(row.reference)}</small>` : ""}</td>
  	          <td><strong>${escapeHtml(formatLitres(row.litres))}</strong><small>${escapeHtml(formatCurrency(row.unitPrice))} / L</small></td>
  	          <td class="amount-cell"><strong>${escapeHtml(formatCurrency(row.cost))}</strong></td>
  	          <td><strong>${escapeHtml(row.supplier)}</strong><small>${escapeHtml(row.application)}</small></td>
  	          <td><span class="fif-fuel-report-pill ${row.sarsCompliance ? "good" : "neutral"}">${row.sarsCompliance ? "Yes · " + escapeHtml(formatCurrency(row.rebate)) : "No"}</span></td>
  	          <td><button type="button" class="fif-fuel-tracking-button" data-fuel-tracking="${escapeAttr(row.key)}" title="${escapeAttr(trackingReason)}" ${trackingAvailable ? "" : "disabled"}>${trackingAvailable ? "View Route" : "Unavailable"}</button></td>
  	        </tr>`;
  	      }).join("")}</tbody>
  	    </table></div>`;
  	  }

  	  function fifFuelReportTrendHtml(company, vehicle, selectedKey) {
  	    const options = fifFuelReportViewOptions(vehicle)
  	      .filter(function (option) { return option.monthKey; })
  	      .sort(function (a, b) { return b.monthKey.localeCompare(a.monthKey); })
  	      .slice(0, 12);

  	    if (!options.length) {
  	      return `<div class="fif-fuel-report-empty compact"><span>No historical period trend is available.</span></div>`;
  	    }

  	    return `<div class="fif-fuel-report-trend">${options.map(function (option) {
  	      const data = fifFuelReportPeriodData(company, vehicle, option);
  	      const summary = data.summary;
  	      const active = option.key === selectedKey;
  	      return `<article class="${active ? "active" : ""}">
  	        <div><strong>${escapeHtml(viewLabel(option.view))}</strong><span>${escapeHtml(formatDistance(summary.distance))}</span></div>
  	        <div><small>L / 100 km</small><b>${summary.consumption === null ? "—" : escapeHtml(formatNumber(summary.consumption, 2))}</b></div>
  	        <div><small>Fuel</small><b>${escapeHtml(formatLitres(summary.litres))}</b></div>
  	        <div><small>Cost</small><b>${escapeHtml(formatCurrency(summary.cost))}</b></div>
  	        <div><small>Cost / km</small><b>${summary.costPerKm === null ? "—" : escapeHtml(formatCurrency(summary.costPerKm))}</b></div>
  	      </article>`;
  	    }).join("")}</div>`;
  	  }
  	function fifFuelReportBody(company, vehicle, selectedOption) {
  	    const currentData = fifFuelReportPeriodData(company, vehicle, selectedOption);
  	    const previousData = fifFuelReportPreviousData(company, vehicle, selectedOption);
  	    const summary = currentData.summary;
  	    const previous = previousData && previousData.summary;
  	    const flags = fifFuelReportQualityFlags(summary, currentData.rows);
  	    const options = fifFuelReportViewOptions(vehicle);
  	    const trendPeriods = options.filter(function (option) { return option.monthKey; });
  	    const hasUsefulTrend = trendPeriods.length > 1;

  	    return `<div class="fif-fuel-report-root">
  	      <section class="fif-fuel-report-toolbar">
  	        <div>
  	          <span>Reporting period</span>
  	          <select data-fuel-report-period>${options.map(function (option) {
  	            return `<option value="${escapeAttr(option.key)}" ${option.key === selectedOption.key ? "selected" : ""}>${escapeHtml(option.label)}</option>`;
  	          }).join("")}</select>
  	        </div>
  	        <p><strong>${escapeHtml(String(summary.loadedRows))}</strong> detailed FuelOut record${summary.loadedRows === 1 ? "" : "s"} loaded · All figures use current App Data.</p>
  	      </section>

  	      <section class="fif-fuel-report-primary">
  	        <article>
  	          <span>Fuel cost</span>
  	          <strong>${escapeHtml(formatCurrency(summary.cost))}</strong>
  	          <small>${fifFuelReportComparison(summary, previous, "cost", true)}</small>
  	        </article>
  	        <article>
  	          <span>Consumption</span>
  	          <strong>${summary.consumption === null ? "—" : escapeHtml(formatNumber(summary.consumption, 2) + " L/100 km")}</strong>
  	          <small>${fifFuelReportComparison(summary, previous, "consumption", true)}</small>
  	        </article>
  	        <article>
  	          <span>Fuel used</span>
  	          <strong>${escapeHtml(formatLitres(summary.litres))}</strong>
  	          <small>${escapeHtml(String(summary.recordCount))} fuel record${summary.recordCount === 1 ? "" : "s"}</small>
  	        </article>
  	        <article>
  	          <span>Distance</span>
  	          <strong>${escapeHtml(formatDistance(summary.distance))}</strong>
  	          <small>${summary.meterStart === null || summary.meterEnd === null ? "Meter range unavailable" : escapeHtml(formatNumber(summary.meterStart, 0) + " → " + formatNumber(summary.meterEnd, 0) + " km")}</small>
  	        </article>
  	      </section>

  	      <section class="fif-fuel-report-secondary">
  	        <article>
  	          <span>Cost per km</span>
  	          <strong>${summary.costPerKm === null ? "—" : escapeHtml(formatCurrency(summary.costPerKm))}</strong>
  	          <small>${summary.costPerKm === null ? "Distance required" : escapeHtml(formatCurrency(summary.costPerKm * 100) + " per 100 km")}</small>
  	        </article>
  	        <article>
  	          <span>Average price</span>
  	          <strong>${summary.averagePrice === null ? "—" : escapeHtml(formatCurrency(summary.averagePrice) + " / L")}</strong>
  	          <small>${fifFuelReportComparison(summary, previous, "averagePrice", true)}</small>
  	        </article>
  	        <article>
  	          <span>Efficiency</span>
  	          <strong>${summary.kilometersPerLitre === null ? "—" : escapeHtml(formatNumber(summary.kilometersPerLitre, 2) + " km/L")}</strong>
  	          <small>${summary.recordCount ? escapeHtml(formatNumber(summary.litres / summary.recordCount, 2) + " L average fill") : "No fuel-record average"}</small>
  	        </article>
  	        <article>
  	          <span>Potential SARS rebate</span>
  	          <strong>${escapeHtml(formatCurrency(summary.rebate))}</strong>
  	          <small>${escapeHtml(formatLitres(summary.sarsLitres))} compliant fuel</small>
  	        </article>
  	      </section>

  	      <section class="fif-fuel-report-focus-grid">
  	        <article class="fif-fuel-report-panel sars">
  	          <header>
  	            <div>
  	              <span>SARS fuel position</span>
  	              <strong>Potential rebate evidence</strong>
  	            </div>
  	          </header>
  	          <div class="fif-fuel-report-sars-grid">
  	            <div><span>Compliant litres</span><strong>${escapeHtml(formatLitres(summary.sarsLitres))}</strong></div>
  	            <div><span>Compliant cost</span><strong>${escapeHtml(formatCurrency(summary.sarsCost))}</strong></div>
  	            <div><span>Non-compliant litres</span><strong>${escapeHtml(formatLitres(summary.nonSarsLitres))}</strong></div>
  	          </div>
  	          <p>Potential rebate is informational and depends on each FuelOut record being marked SARS compliant.</p>
  	        </article>

  	        <article class="fif-fuel-report-panel integrity">
  	          <header>
  	            <div>
  	              <span>Data integrity</span>
  	              <strong>Evidence and reconciliation checks</strong>
  	            </div>
  	          </header>
  	          <div class="fif-fuel-report-flags">${flags.map(function (flag) {
  	            return `<article class="${escapeAttr(flag.type)}"><i></i><div><strong>${escapeHtml(flag.title)}</strong><span>${escapeHtml(flag.message)}</span></div></article>`;
  	          }).join("")}</div>
  	        </article>
  	      </section>

  	      ${hasUsefulTrend ? `<section class="fif-fuel-report-panel trend">
  	        <header>
  	          <div>
  	            <span>Period trend</span>
  	            <strong>Loaded reporting history</strong>
  	          </div>
  	        </header>
  	        ${fifFuelReportTrendHtml(company, vehicle, selectedOption.key)}
  	      </section>` : ""}

  	      <section class="fif-fuel-report-panel detailed">
  	        <header>
  	          <div>
  	            <span>Detailed fuel records</span>
  	            <strong>FuelOut, mileage, supplier and SARS evidence</strong>
  	          </div>
  	          <b>${escapeHtml(String(currentData.rows.length))} loaded</b>
  	        </header>
  	        ${fifFuelReportRecordRows(company, vehicle, currentData.rows)}
  	      </section>
  	    </div>`;
  	  }

  	function fifFuelReportPrint(company, vehicle, selectedOption) {
  	    fifRequirePermission(CAN_ACCESS_FUEL && userCanAccessAssetFunction(vehicle, "Fuel"), "Fuel reporting is not assigned in your Dashboard Settings.");
  	    const data = fifFuelReportPeriodData(company, vehicle, selectedOption);
  	    const summary = data.summary;
  	    const body = `<h2>Period summary</h2><table><tbody>
  	      <tr><th>Vehicle</th><td>${escapeHtml(vehicleTitleValue(vehicle))}</td><th>Period</th><td>${escapeHtml(viewLabel(selectedOption.view))}</td></tr>
  	      <tr><th>Distance</th><td>${escapeHtml(formatDistance(summary.distance))}</td><th>Fuel</th><td>${escapeHtml(formatLitres(summary.litres))}</td></tr>
  	      <tr><th>Fuel cost</th><td>${escapeHtml(formatCurrency(summary.cost))}</td><th>Average price / L</th><td>${summary.averagePrice === null ? "—" : escapeHtml(formatCurrency(summary.averagePrice))}</td></tr>
  	      <tr><th>Consumption</th><td>${summary.consumption === null ? "—" : escapeHtml(formatNumber(summary.consumption, 2) + " L/100 km")}</td><th>Cost / km</th><td>${summary.costPerKm === null ? "—" : escapeHtml(formatCurrency(summary.costPerKm))}</td></tr>
  	      <tr><th>Potential SARS rebate</th><td>${escapeHtml(formatCurrency(summary.rebate))}</td><th>Fuel records</th><td>${escapeHtml(String(summary.recordCount))}</td></tr>
  	      </tbody></table><h2>Detailed fuel records</h2>
  	      <table><thead><tr><th>Date</th><th>Mileage</th><th>Distance</th><th>Litres</th><th>Price / L</th><th>Total</th><th>Supplier</th><th>SARS</th></tr></thead>
  	      <tbody>${data.rows.map(function (row) { return `<tr><td>${escapeHtml(fifFuelReportDate(row.date))}</td><td>${row.mileage === null ? "—" : escapeHtml(formatNumber(row.mileage, 0) + " km")}</td><td>${escapeHtml(formatDistance(row.distance))}</td><td>${escapeHtml(formatLitres(row.litres))}</td><td>${escapeHtml(formatCurrency(row.unitPrice))}</td><td>${escapeHtml(formatCurrency(row.cost))}</td><td>${escapeHtml(row.supplier)}</td><td>${row.sarsCompliance ? "Yes · " + escapeHtml(formatCurrency(row.rebate)) : "No"}</td></tr>`; }).join("") || `<tr><td colspan="8">No detailed FuelOut rows are loaded for this period.</td></tr>`}</tbody></table>`;
  	    openServicePrintWindow(vehicleTitleValue(vehicle) + " Fuel Report", body);
  	  }

  	  function injectVehicleFuelReportStyles() {
  	    if (document.getElementById(FIF_FUEL_REPORT_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = FIF_FUEL_REPORT_STYLE_ID;
  	    style.textContent = `
  	      #${SERVICE_MODAL_ID} .fifsp-modal.fif-fuel-report-modal{
  	        width:min(1380px,calc(100vw - 28px));
  	        height:calc(100vh - ${TOP_OFFSET_PX + 28}px);
  	        max-height:none;
  	        background:linear-gradient(145deg,#171d19,#090d0b);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-modal>header{
  	        padding:16px 20px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-modal>header h2{
  	        font-size:24px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-modal>header p{
  	        margin-top:5px;
  	        font-size:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-modal>main{
  	        padding:14px;
  	        background:
  	          radial-gradient(circle at 10% 0%,rgba(204,102,51,.075),transparent 32%),
  	          #090d0b;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-modal>footer{
  	        justify-content:space-between;
  	        padding:12px 16px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-modal>footer>div{
  	        display:flex;
  	        gap:9px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-modal>footer button{
  	        min-height:42px;
  	        padding:0 17px;
  	        font-size:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-root{
  	        display:grid;
  	        gap:12px;
  	        min-width:0;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-toolbar{
  	        display:flex;
  	        justify-content:space-between;
  	        align-items:flex-end;
  	        gap:16px;
  	        padding:12px 14px;
  	        border:1px solid rgba(255,255,255,.085);
  	        border-radius:12px;
  	        background:rgba(255,255,255,.028);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-toolbar>div{
  	        width:min(360px,100%);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-toolbar span{
  	        display:block;
  	        margin:0 0 7px;
  	        color:#929c96;
  	        font-size:10px;
  	        font-weight:900;
  	        text-transform:uppercase;
  	        letter-spacing:.08em;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-toolbar select{
  	        width:100%;
  	        min-height:44px;
  	        font-size:12px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-toolbar .fif-styled-select-button{
  	        min-height:44px;
  	        border-radius:9px;
  	        font-size:12px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-toolbar p{
  	        margin:0;
  	        color:#8d9791;
  	        font-size:11px;
  	        text-align:right;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-toolbar p strong{
  	        color:#f1f4f2;
  	        font-size:13px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-primary{
  	        display:grid;
  	        grid-template-columns:repeat(4,minmax(0,1fr));
  	        gap:10px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-primary article{
  	        min-width:0;
  	        padding:17px 16px;
  	        border:1px solid rgba(255,255,255,.085);
  	        border-top:3px solid rgba(204,102,51,.72);
  	        border-radius:12px;
  	        background:linear-gradient(145deg,#171d18,#0b100d);
  	        box-shadow:0 10px 26px rgba(0,0,0,.15);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-primary span,
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-secondary span{
  	        display:block;
  	        color:#8c9690;
  	        font-size:10px;
  	        font-weight:900;
  	        text-transform:uppercase;
  	        letter-spacing:.075em;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-primary strong{
  	        display:block;
  	        margin-top:8px;
  	        color:#f7f9f7;
  	        font-size:25px;
  	        line-height:1.05;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-primary small{
  	        display:block;
  	        min-height:16px;
  	        margin-top:9px;
  	        color:#89928c;
  	        font-size:10px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-primary small span{
  	        display:inline;
  	        font-size:10px;
  	        text-transform:none;
  	        letter-spacing:0;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-primary .good{color:#78dda4}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-primary .bad{color:#ff8f89}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-primary .neutral{color:#929b95}

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-secondary{
  	        display:grid;
  	        grid-template-columns:repeat(4,minmax(0,1fr));
  	        gap:10px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-secondary article{
  	        min-width:0;
  	        padding:13px 15px;
  	        border:1px solid rgba(255,255,255,.075);
  	        border-radius:11px;
  	        background:#111612;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-secondary strong{
  	        display:block;
  	        margin-top:6px;
  	        color:#eef2ef;
  	        font-size:17px;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-secondary small{
  	        display:block;
  	        min-height:14px;
  	        margin-top:6px;
  	        color:#7f8882;
  	        font-size:10px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-secondary small span{
  	        display:inline;
  	        font-size:10px;
  	        text-transform:none;
  	        letter-spacing:0;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-secondary .good{color:#78dda4}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-secondary .bad{color:#ff8f89}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-secondary .neutral{color:#929b95}

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-focus-grid{
  	        display:grid;
  	        grid-template-columns:minmax(340px,.72fr) minmax(0,1.28fr);
  	        gap:12px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-panel{
  	        min-width:0;
  	        border:1px solid rgba(255,255,255,.08);
  	        border-radius:12px;
  	        background:linear-gradient(145deg,#141a15,#0a0f0b);
  	        overflow:hidden;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-panel>header{
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        gap:12px;
  	        padding:12px 14px;
  	        border-bottom:1px solid rgba(255,255,255,.065);
  	        background:#171c18;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-panel>header span{
  	        display:block;
  	        color:#d27a4c;
  	        font-size:10px;
  	        font-weight:950;
  	        text-transform:uppercase;
  	        letter-spacing:.09em;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-panel>header strong{
  	        display:block;
  	        margin-top:4px;
  	        color:#f1f4f2;
  	        font-size:14px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-panel>header>b{
  	        color:#9ba49e;
  	        font-size:10px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-sars-grid{
  	        display:grid;
  	        grid-template-columns:repeat(3,minmax(0,1fr));
  	        gap:1px;
  	        background:rgba(255,255,255,.055);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-sars-grid>div{
  	        padding:15px 13px;
  	        background:#0e130f;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-sars-grid span{
  	        display:block;
  	        color:#87918b;
  	        font-size:9px;
  	        font-weight:900;
  	        text-transform:uppercase;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-sars-grid strong{
  	        display:block;
  	        margin-top:7px;
  	        color:#f2f5f3;
  	        font-size:17px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-panel.sars>p{
  	        margin:0;
  	        padding:11px 13px;
  	        color:#858f89;
  	        font-size:10px;
  	        line-height:1.45;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-flags{
  	        display:grid;
  	        grid-template-columns:repeat(auto-fit,minmax(260px,1fr));
  	        gap:9px;
  	        padding:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-flags article{
  	        display:flex;
  	        gap:10px;
  	        min-height:66px;
  	        padding:11px;
  	        border:1px solid rgba(255,255,255,.07);
  	        border-radius:10px;
  	        background:#0c110d;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-flags i{
  	        width:8px;
  	        height:8px;
  	        flex:0 0 8px;
  	        margin-top:4px;
  	        border-radius:99px;
  	        background:#7d8580;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-flags article.good i{background:#49c785}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-flags article.warning i{background:#e3a04a}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-flags article.danger i{background:#ef5350}

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-flags strong{
  	        display:block;
  	        color:#eef2ef;
  	        font-size:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-flags span{
  	        display:block;
  	        margin-top:5px;
  	        color:#8b958f;
  	        font-size:10px;
  	        line-height:1.45;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-trend{
  	        display:grid;
  	        grid-template-columns:repeat(auto-fit,minmax(260px,1fr));
  	        gap:8px;
  	        padding:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-trend article{
  	        display:grid;
  	        grid-template-columns:minmax(115px,1.25fr) repeat(4,minmax(70px,.7fr));
  	        gap:8px;
  	        padding:11px;
  	        border:1px solid rgba(255,255,255,.07);
  	        border-radius:9px;
  	        background:#0b100c;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-trend article.active{
  	        border-color:rgba(204,102,51,.55);
  	        background:rgba(204,102,51,.075);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-trend strong,
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-trend b{
  	        display:block;
  	        color:#eef1ee;
  	        font-size:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-trend span,
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-trend small{
  	        display:block;
  	        margin-top:4px;
  	        color:#7f8982;
  	        font-size:9px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table-wrap{
  	        max-height:420px;
  	        overflow:auto;
  	        scrollbar-width:thin;
  	        scrollbar-color:rgba(204,102,51,.5) transparent;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table{
  	        width:100%;
  	        border-collapse:collapse;
  	        table-layout:fixed;
  	        font-size:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table th{
  	        position:sticky;
  	        top:0;
  	        z-index:2;
  	        padding:11px 12px;
  	        background:#181d19;
  	        color:#9da69f;
  	        text-align:left;
  	        text-transform:uppercase;
  	        letter-spacing:.055em;
  	        border-bottom:1px solid rgba(204,102,51,.34);
  	        font-size:9px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table th:nth-child(1){width:24%}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table th:nth-child(2){width:13%}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table th:nth-child(3){width:13%}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table th:nth-child(4){width:28%}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table th:nth-child(5){width:11%}
  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table th:nth-child(6){width:11%}

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table td{
  	        padding:12px;
  	        color:#b5bdb8;
  	        border-bottom:1px solid rgba(255,255,255,.055);
  	        vertical-align:middle;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table tr:hover td{
  	        background:rgba(204,102,51,.04);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table td strong{
  	        display:block;
  	        color:#f0f3f1;
  	        font-size:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table td.amount-cell strong{
  	        font-size:13px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-table td small{
  	        display:block;
  	        margin-top:5px;
  	        color:#858e88;
  	        font-size:9px;
  	        line-height:1.35;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-tracking-button{
  	        appearance:none;
  	        -webkit-appearance:none;
  	        display:inline-flex;
  	        align-items:center;
  	        justify-content:center;
  	        min-width:84px;
  	        min-height:32px;
  	        margin:0;
  	        padding:0 11px;
  	        border:1px solid rgba(204,102,51,.48);
  	        border-radius:8px;
  	        outline:0;
  	        background:rgba(204,102,51,.08);
  	        color:#e7b99f;
  	        font:950 8px/1 Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  	        text-align:center;
  	        text-decoration:none;
  	        white-space:nowrap;
  	        cursor:pointer;
  	        box-shadow:none;
  	        transition:border-color .16s ease,background .16s ease,color .16s ease,transform .16s ease;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-tracking-button:hover:not(:disabled),
  	      #${SERVICE_MODAL_ID} .fif-fuel-tracking-button:focus-visible{
  	        border-color:#cc6633;
  	        background:rgba(204,102,51,.16);
  	        color:#fff;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-tracking-button:active:not(:disabled){
  	        transform:translateY(1px);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-tracking-button:disabled{
  	        opacity:.32;
  	        cursor:not-allowed;
  	        transform:none;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-pill{
  	        display:inline-flex;
  	        align-items:center;
  	        justify-content:center;
  	        min-height:27px;
  	        padding:4px 8px;
  	        border:1px solid rgba(255,255,255,.09);
  	        border-radius:99px;
  	        background:rgba(255,255,255,.035);
  	        font-size:9px;
  	        font-weight:900;
  	        white-space:nowrap;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-pill.good{
  	        color:#77dba2;
  	        border-color:rgba(73,199,133,.25);
  	        background:rgba(73,199,133,.07);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-pill.warn{
  	        color:#e6ad60;
  	        border-color:rgba(227,160,74,.25);
  	        background:rgba(227,160,74,.07);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-pill.bad{
  	        color:#ef8b87;
  	        border-color:rgba(239,83,80,.25);
  	        background:rgba(239,83,80,.07);
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-pill.neutral{
  	        color:#9ba39e;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-empty{
  	        padding:34px;
  	        text-align:center;
  	        color:#87918b;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-empty strong{
  	        display:block;
  	        color:#e4e8e5;
  	        font-size:15px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-empty span{
  	        display:block;
  	        margin-top:7px;
  	        font-size:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fif-fuel-report-empty.compact{
  	        padding:18px;
  	      }

  	      @media(max-width:1100px){
  	        #${SERVICE_MODAL_ID} .fif-fuel-report-primary,
  	        #${SERVICE_MODAL_ID} .fif-fuel-report-secondary{
  	          grid-template-columns:repeat(2,minmax(0,1fr));
  	        }

  	        #${SERVICE_MODAL_ID} .fif-fuel-report-focus-grid{
  	          grid-template-columns:1fr;
  	        }
  	      }

  	      @media(max-width:720px){
  	        #${SERVICE_MODAL_ID} .fif-fuel-report-toolbar{
  	          align-items:stretch;
  	          flex-direction:column;
  	        }

  	        #${SERVICE_MODAL_ID} .fif-fuel-report-toolbar p{
  	          text-align:left;
  	        }

  	        #${SERVICE_MODAL_ID} .fif-fuel-report-primary,
  	        #${SERVICE_MODAL_ID} .fif-fuel-report-secondary,
  	        #${SERVICE_MODAL_ID} .fif-fuel-report-sars-grid{
  	          grid-template-columns:1fr;
  	        }

  	        #${SERVICE_MODAL_ID} .fif-fuel-report-primary strong{
  	          font-size:22px;
  	        }

  	        #${SERVICE_MODAL_ID} .fif-fuel-report-trend article{
  	          grid-template-columns:1fr 1fr;
  	        }

  	        #${SERVICE_MODAL_ID} .fif-fuel-report-modal>footer{
  	          flex-direction:column;
  	        }

  	        #${SERVICE_MODAL_ID} .fif-fuel-report-modal>footer>div{
  	          width:100%;
  	        }

  	        #${SERVICE_MODAL_ID} .fif-fuel-report-modal>footer button{
  	          flex:1;
  	        }
  	      }
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function openVehicleFuelReport(company, vehicle, requestedKey) {
  	    if (!CAN_ACCESS_FUEL || !CAN_ACCESS_VEHICLES || !userCanAccessAssetFunction(vehicle, "Fuel")) {
  	      fifAlert("Fuel reporting is not assigned in your Dashboard Settings.", {
  	        title: "Fuel Access Required",
  	        type: "warning",
  	        confirmText: "Close"
  	      });
  	      return null;
  	    }
  	    if (!vehicle || assetIsTrailer(vehicle)) return null;
  	    injectVehicleFuelReportStyles();

  	    const selectedOption = fifFuelReportInitialOption(vehicle, requestedKey);
  	    if (!selectedOption) {
  	      fifAlert("No current or historical Tractorview period is loaded for this vehicle.", {
  	        title: "Fuel Report Unavailable",
  	        type: "warning",
  	        confirmText: "Close"
  	      });
  	      return null;
  	    }

  	    const overlay = serviceModalShell(
  	      "Fuel Cost & Consumption",
  	      vehicleTitleValue(vehicle) + " · " + viewLabel(selectedOption.view),
  	      fifFuelReportBody(company, vehicle, selectedOption),
  	      `<div><button type="button" data-fuel-report-print>Print Report</button></div><div><button type="button" data-fuel-report-close>Close</button>${CAN_CAPTURE_ON_ROAD_FUEL ? `<button type="button" class="primary" data-fuel-report-capture>Capture On-Road Fuel</button>` : ""}</div>`,
  	      true
  	    );

  	    overlay.querySelector(".fifsp-modal")?.classList.add("fif-fuel-report-modal");

  	    overlay.querySelector("[data-fuel-report-period]")?.addEventListener("change", function (event) {
  	      closeFuelTrackingWindow();
  	      openVehicleFuelReport(company, vehicle, event.target.value);
  	    });
  	    overlay.querySelector("[data-fuel-report-close]")?.addEventListener("click", function () {
  	      closeFuelTrackingWindow();
  	      closeServicePortalModal();
  	    });
  	    overlay.querySelector("[data-fuel-report-capture]")?.addEventListener("click", function () {
  	      closeServicePortalModal();
  	      openOnRoadFuelCapture(company, vehicle);
  	    });
  	    overlay.querySelector("[data-fuel-report-print]")?.addEventListener("click", function () {
  	      fifFuelReportPrint(company, vehicle, selectedOption);
  	    });
  	    const trackingRows = fifFuelReportRowsForPeriod(company, vehicle, selectedOption.view);
  	    overlay.querySelectorAll("[data-fuel-tracking]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const key = button.getAttribute("data-fuel-tracking") || "";
  	        const row = trackingRows.find(function (item) { return item.key === key; });
  	        if (row) openFuelTrackingWindow(company, vehicle, row);
  	      });
  	    });

  	    return overlay;
  	  }

  	  function bindFleetMetricActions(scope, company) {
  	    scope.querySelectorAll("[data-fleet-metric-action]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const key = button.getAttribute("data-vehicle-key") || "";
  	        const assetType = button.getAttribute("data-asset-type") || "tractor";
  	        const vehicle = fifVehicleFromStableKey(company, key, assetType);
  	        if (!vehicle) return;
  	        const action = button.getAttribute("data-fleet-metric-action");
  	        if (!userCanAccessAsset(vehicle)) return;
  	        if ((action === "fuel-report" || action === "fuel") && !CAN_ACCESS_FUEL) return;
  	        if (action === "fuel-capture" && !CAN_CAPTURE_ON_ROAD_FUEL) return;
  	        if (action === "tyres" && !CAN_ACCESS_TYRES) return;
  	        if (action === "service" && !CAN_ACCESS_SERVICE) return;
  	        if (action === "maintenance" && !CAN_ACCESS_MAINTENANCE) return;
  	        if (action === "alerts" && !CAN_ACCESS_ALERTS) return;
  	        if (action === "events" && !CAN_ACCESS_LOCATION_EVENTS) return;
  	        state.selectedAssetType = assetType;

  	        if ((action === "fuel-report" || action === "fuel") && assetType !== "trailer") {
  	          openVehicleFuelReport(company, vehicle);
  	        } else if (action === "fuel-capture" && assetType !== "trailer") {
  	          openOnRoadFuelCapture(company, vehicle);
  	        } else if (action === "alerts") {
  	          openVehicleAlertPanel(company, vehicle);
  	        } else if (action === "events" && assetType !== "trailer") {
  	          openVehicleLocationEvents(company, vehicle);
  	        } else if (action === "tyres" || action === "service" || action === "maintenance") {
  	          state.selectedVehicleKey = vehicleStableKey(vehicle, (assetType === "trailer" ? towedAssets(company) : tractors(company)).indexOf(vehicle));
  	          state.vehicleActiveTab = action;
  	          clearVehicleEditorState();
  	          render();
  	        }
  	      });
  	    });
  	  }

  	  function onFifVehicleEventsMetricCapture(event) {
  	    if (state.destroyed) return;

  	    const target = event && event.target && event.target.closest
  	      ? event.target.closest('[data-fleet-metric-action="events"]')
  	      : null;

  	    if (!target) return;

  	    const dashboardRoot = document.getElementById(ROOT_ID);
  	    if (!dashboardRoot || !dashboardRoot.contains(target)) return;

  	    try { event.preventDefault(); } catch (_) {}
  	    try { event.stopPropagation(); } catch (_) {}
  	    try { event.stopImmediatePropagation(); } catch (_) {}

  	    const company = selectedCompany();
  	    const key = target.getAttribute("data-vehicle-key") || "";
  	    const assetType = target.getAttribute("data-asset-type") || "tractor";
  	    const vehicle = fifVehicleFromStableKey(company, key, assetType);

  	    if (!vehicle || assetType === "trailer") return;
  	    if (!CAN_ACCESS_LOCATION_EVENTS || !userCanAccessAsset(vehicle)) return;

  	    state.selectedAssetType = "tractor";

  	    try {
  	      const legacy = document.getElementById(SERVICE_MODAL_ID);
  	      if (legacy) legacy.remove();
  	      state.serviceModalOpen = false;
  	    } catch (_) {}

  	    openVehicleLocationEvents(company, vehicle);
  	  }

  	  function installFifVehicleEventsMetricTakeover() {
  	    if (typeof document === "undefined") return;

  	    try {
  	      const previous = window.__FIF_VEHICLE_EVENTS_CAPTURE_HANDLER__;
  	      if (typeof previous === "function") {
  	        document.removeEventListener("click", previous, true);
  	      }
  	    } catch (_) {}

  	    document.addEventListener("click", onFifVehicleEventsMetricCapture, true);

  	    try {
  	      window.__FIF_VEHICLE_EVENTS_CAPTURE_HANDLER__ = onFifVehicleEventsMetricCapture;
  	      document.documentElement.setAttribute(
  	        "data-fif-vehicle-events-build",
  	        "21.12.66-slim-interactive-fuel-service-notification"
  	      );
  	    } catch (_) {}
  	  }

  	  function removeFifVehicleEventsMetricTakeover() {
  	    try {
  	      document.removeEventListener("click", onFifVehicleEventsMetricCapture, true);
  	    } catch (_) {}

  	    try {
  	      if (window.__FIF_VEHICLE_EVENTS_CAPTURE_HANDLER__ === onFifVehicleEventsMetricCapture) {
  	        delete window.__FIF_VEHICLE_EVENTS_CAPTURE_HANDLER__;
  	      }
  	      if (
  	        document.documentElement.getAttribute("data-fif-vehicle-events-build") ===
  	        "21.12.66-slim-interactive-fuel-service-notification"
  	      ) {
  	        document.documentElement.removeAttribute("data-fif-vehicle-events-build");
  	      }
  	    } catch (_) {}
  	  }

  	  function viewKey(view) {
  	    return clean(firstValue([
  	      view && view.MYearKey,
  	      view && view.MonthKey,
  	      view && view.MYear,
  	      view && view.DateStart
  	    ], ""));
  	  }

  	  function viewLabel(view) {
  	    const explicit = clean(firstValue([
  	      view && view.MYear,
  	      view && view.Month,
  	      view && view.Period
  	    ], ""));

  	    if (explicit) return explicit;

  	    const key = clean(firstValue([
  	      view && view.MYearKey,
  	      view && view.MonthKey
  	    ], ""));

  	    if (/^\d{4}-\d{2}$/.test(key)) {
  	      const date = new Date(`${key}-01T00:00:00`);
  	      if (!Number.isNaN(date.getTime())) {
  	        return date.toLocaleDateString(undefined, {
  	          month: "long", year: "numeric"
  	        });
  	      }
  	    }

  	    return key || "Historical period";
  	  }

  	  function historicalViews(asset) {
  	    return arr(asset && asset.ViewH);
  	  }

  	  function periodView(asset) {
  	    if (state.viewMode === "current") return asset && asset.ViewC ? asset.ViewC: null;

  	    const views = historicalViews(asset);
  	    if (!views.length) return null;

  	    for (let index = 0; index < views.length; index += 1) {
  	      if (viewKey(views[index]) === state.selectedHistoryKey) return views[index];
  	    }

  	    return null;
  	  }

  	  function allAssetsForHistory(company) {
  	    return tractors(company).concat(towedAssets(company));
  	  }

  	  function historyPeriods(company) {
  	    const byKey = Object.create(null);

  	    allAssetsForHistory(company).forEach(function (asset) {
  	      historicalViews(asset).forEach(function (view) {
  	        const key = viewKey(view);
  	        if (!key || byKey[key]) return;
  	        byKey[key] = {
  	          key: key,
  	          label: viewLabel(view),
  	          raw: view
  	        };
  	      });
  	    });

  	    return Object.keys(byKey)
  	    .map(function (key) {
  	      return byKey[key];
  	    })
  	    .sort(function (a,
  	      b) {
  	      return b.key.localeCompare(a.key);
  	    });
  	  }

  	  function currentPeriodLabel(company) {
  	    const assets = allAssetsForHistory(company);

  	    for (let index = 0; index < assets.length; index += 1) {
  	      if (assets[index] && assets[index].ViewC) return viewLabel(assets[index].ViewC);
  	    }

  	    return "Current period";
  	  }

  	  function tabAssets(company, tab) {
  	    if (tab === "vehicles") return tractors(company);
  	    if (tab === "trailers") return towedAssets(company);
  	    if (tab === "tyres") return tyres(company);
  	    return [];
  	  }

  	  function filterAssets(assets, tab) {
  	    const search = lower(state.search);

  	    return arr(assets).filter(function (asset, index) {
  	      if (
  	        tab === "trailers" &&
  	        state.trailerType !== "all" &&
  	        lower(trailerKind(asset)) !== state.trailerType
  	      ) {
  	        return false;
  	      }

  	      if (!search) return true;

  	      const haystack = [
  	        assetIdentity(asset, index, "Asset"),
  	        assetSubtitle(asset, tab),
  	        trailerKind(asset),
  	        vehicleRegistrationValue(asset),
  	        applicationOf(asset),
  	        asset && asset.objectId
  	      ].map(clean).join(" ").toLowerCase();

  	      return haystack.indexOf(search) !== -1;
  	    });
  	  }

  	  function statusClass(status) {
  	    const value = lower(status);
  	    if (/issue|warning|attention|expired|overdue|fault|scrap|stolen|broken down|in for repairs|decommissioned|out of service/.test(value)) return "danger";
  	    if (/inactive|standby|warehouse|unassigned|empty|in for service/.test(value)) return "muted";
  	    return "good";
  	  }

  	  function tyreLocation(asset) {
  	    const warehouse = descriptorValue(firstValue([
  	      asset && asset.Warehouse,
  	      getDeep(asset, ["Data", "Warehouse"], null)
  	    ], null));

  	    const fitted = descriptorValue(firstValue([
  	      asset && asset.Is_Fitted,
  	      asset && asset.IsFitted,
  	      getDeep(asset, ["Data", "Is_Fitted"], null)
  	    ], null));

  	    const vehicle = clean(firstValue([
  	      asset && asset.Vehicle_ID,
  	      asset && asset.CurrentVehicle,
  	      asset && asset.Vehicle,
  	      asset && asset.FittedTo,
  	      getDeep(asset, ["History", "Current", "Vehicle_ID"], ""),
  	      getDeep(asset, ["Data", "CurrentVehicle"], "")
  	    ], ""));

  	    const position = clean(firstValue([
  	      asset && asset.Current_Position,
  	      asset && asset.Position,
  	      getDeep(asset, ["History", "Current", "Position"], ""),
  	      getDeep(asset, ["Data", "CurrentPosition"], "")
  	    ], ""));

  	    if (fitted === true || lower(fitted) === "true") {
  	      return [vehicle,
  	        position].filter(Boolean).join(" · ") || "Fitted";
  	    }

  	    if (warehouse === true || lower(warehouse) === "true") return "Warehouse";
  	    if (vehicle || position) return [vehicle,
  	      position].filter(Boolean).join(" · ");

  	    return "Unassigned";
  	  }

  	  function tyreIsFitted(asset) {
  	    const fitted = descriptorValue(firstValue([
  	      asset && asset.Is_Fitted,
  	      asset && asset.IsFitted,
  	      getDeep(asset, ["Data", "Is_Fitted"], null)
  	    ], null));

  	    if (fitted === true || lower(fitted) === "true") return true;
  	    if (fitted === false || lower(fitted) === "false") return false;

  	    const location = lower(tyreLocation(asset));
  	    const status = lower(assetStatus(asset, "tyres"));
  	    return !!location && location !== "warehouse" && location !== "unassigned" && !/warehouse|unassigned|stock/.test(status);
  	  }

  	  function applicationOf(asset) {
  	    return clean(firstValue([
  	      fifVehicleClassificationValue(asset, "Application", ""),
  	      getDeep(fifCanonicalVehicleData(asset), ["Application"], ""),
  	      getDeep(asset, ["Data", "Implement", "Application"], ""),
  	      getDeep(asset, ["Data", "Trailer", "Application"], ""),
  	      asset && asset.Application
  	    ], ""));
  	  }

  	  function aggregate(company) {
  	    if (state.activeTab === "applications") {
  	      const apps = applications(company);
  	      const assets = tractors(company).concat(towedAssets(company));
  	      const linked = assets.filter(function (asset) {
  	        return applicationOf(asset);
  	      }).length;
  	      const unassigned = assets.length - linked;

  	      return [{
  	        label: "Applications",
  	        value: formatCount(apps.length),
  	        note: "Available to this company",
  	        tone: "orange"
  	      },
  	        {
  	          label: "Linked assets",
  	          value: formatCount(linked),
  	          note: "Application assigned",
  	          tone: "good"
  	        },
  	        {
  	          label: "Unassigned",
  	          value: formatCount(unassigned),
  	          note: "No application selected",
  	          tone: unassigned ? "warning": "muted"
  	        },
  	        {
  	          label: "Total assets",
  	          value: formatCount(assets.length),
  	          note: "Vehicles and towed assets",
  	          tone: "muted"
  	        }];
  	    }

  	    const rawAssets = tabAssets(company, state.activeTab);
  	    const visibleAssets = filterAssets(rawAssets, state.activeTab);

  	    if (state.activeTab === "tyres") {
  	      const fitted = rawAssets.filter(tyreIsFitted).length;
  	      const warehouse = rawAssets.length - fitted;
  	      const issues = rawAssets.reduce(function (total, asset) {
  	        return total + notificationCount(asset);
  	      }, 0);

  	      const tyreSummaryItems = [{
  	        label: "Tyres",
  	        value: formatCount(rawAssets.length),
  	        note: "Company tyre inventory",
  	        tone: "orange"
  	      },
  	        {
  	          label: "Fitted",
  	          value: formatCount(fitted),
  	          note: "Currently assigned",
  	          tone: "good"
  	        },
  	        {
  	          label: "Warehouse",
  	          value: formatCount(warehouse),
  	          note: "Stock or unassigned",
  	          tone: "muted"
  	        }];
  	      if (CAN_ACCESS_ALERTS) tyreSummaryItems.push({
  	        label: "Alerts",
  	        value: formatCount(issues),
  	        note: "Tyre notifications",
  	        tone: issues ? "warning": "good"
  	      });
  	      return tyreSummaryItems;
  	    }

  	    if (state.activeTab === "trailers") {
  	      let serviceDue = 0;
  	      let openMaintenance = 0;
  	      let fittedTyres = 0;
  	      let alerts = 0;
  	      rawAssets.forEach(function (asset) {
  	        const health = serviceHealthForVehicle(company, asset);
  	        if (health.severity === "critical" || health.severity === "warning") serviceDue += 1;
  	        openMaintenance += vehicleMaintenanceOrders(asset).filter(function (record) {
  	          return SERVICE_JOB_OPEN_STATUSES.indexOf(record.Status) !== -1;
  	        }).length;
  	        fittedTyres += tyrePositionSummary(currentTPositions(asset)).AssignedTyres;
  	        alerts += vehicleAlertsForDisplay(company, asset, false).length;
  	      });
  	      const trailerSummaryItems = [{
  	        label: "Implements", value: formatCount(rawAssets.length), note: `${visibleAssets.length} currently visible`, tone: "orange"
  	      }, {
  	        label: "Service due", value: formatCount(serviceDue), note: "Due soon or overdue", tone: serviceDue ? "warning" : "good"
  	      }, {
  	        label: "Open maintenance", value: formatCount(openMaintenance), note: "Active workshop records", tone: openMaintenance ? "warning" : "muted"
  	      }, {
  	        label: "Fitted tyres", value: formatCount(fittedTyres), note: "Across implement positions", tone: "muted"
  	      }];
  	      if (CAN_ACCESS_ALERTS) trailerSummaryItems.push({
  	        label: "Alerts", value: formatCount(alerts), note: "Open operational alerts", tone: alerts ? "warning" : "good"
  	      });
  	      return trailerSummaryItems;
  	    }

  	    let distance = 0;
  	    let hours = 0;
  	    let litres = 0;
  	    let cost = 0;
  	    let alerts = 0;
  	    let availableDistance = false;
  	    let availableHours = false;
  	    let availableLitres = false;
  	    let availableCost = false;

  	    rawAssets.forEach(function (asset) {
  	      const view = periodView(asset);
  	      alerts += notificationCount(asset);

  	      const distanceValue = vehiclePeriodDistance(asset, view);
  	      const hoursValue = vehiclePeriodHours(asset, view);
  	      const litresValue = numberValue(view && view.Litres);
  	      const costValue = numberValue(view && view.Cost);

  	      if (distanceValue !== null) {
  	        availableDistance = true;
  	        distance += distanceValue;
  	      }
  	      if (hoursValue !== null) {
  	        availableHours = true;
  	        hours += hoursValue;
  	      }
  	      if (litresValue !== null) {
  	        availableLitres = true;
  	        litres += litresValue;
  	      }
  	      if (costValue !== null) {
  	        availableCost = true;
  	        cost += costValue;
  	      }
  	    });

  	    const periodNote = state.viewMode === "current" ? "Current period": "Selected history";
  	    const vehicleSummaryItems = [{
  	      label: state.activeTab === "vehicles" ? "Vehicles": "Towed assets", value: formatCount(rawAssets.length), note: `${visibleAssets.length} currently visible`, tone: "orange"
  	    },
  	      {
  	        label: "Distance", value: availableDistance ? formatDistance(distance): "—", note: periodNote, tone: "good"
  	      },
  	      {
  	        label: "Hours", value: availableHours ? formatHours(hours): "—", note: periodNote, tone: "good"
  	      },
  	      {
  	        label: "Fuel", value: availableLitres ? formatLitres(litres): "—", note: "Recorded litres", tone: "muted"
  	      },
  	      {
  	        label: "Cost", value: availableCost ? formatCurrency(cost): "—", note: "Recorded operating cost", tone: "muted"
  	      }];
  	    if (CAN_ACCESS_ALERTS) vehicleSummaryItems.push({
  	      label: "Alerts", value: formatCount(alerts), note: "Open notifications", tone: alerts ? "warning": "good"
  	    });
  	    return vehicleSummaryItems;
  	  }

  	  function brandMarkup() {
  	    const icon = clean(SVG_INPUT);

  	    if (!icon) {
  	      return `<div class="fifdash-brand-fallback">FIF</div>`;
  	    }

  	    if (icon.indexOf("<svg") !== -1) {
  	      return `<div class="fifdash-brand-svg">${icon}</div>`;
  	    }

  	    return `<img class="fifdash-brand-image" src="${escapeAttr(icon)}" alt="Fleet In Form">`;
  	  }

  	  const EMPLOYEE_STYLE_ID = "fif-dashboard-employees-v2160-style";

  	  function employeeMerge(target, source) {
  	    target = isObject(target) ? target : {};
  	    if (!isObject(source)) return target;
  	    Object.keys(source).forEach(function (key) {
  	      const value = source[key];
  	      if (Array.isArray(value)) target[key] = cloneData(value);
  	      else if (isObject(value)) target[key] = employeeMerge(isObject(target[key]) ? target[key] : {}, value);
  	      else target[key] = value;
  	    });
  	    return target;
  	  }

  	  function employeeDefaultDetails() {
  	    return {
  	      account_type: "Employee", operational_roles: [],
  	      gender: "", address: { city: "", street: "", suburb: "", province: "", postal_code: "" },
  	      passport: { issue_date: "", expiry_date: "", passport_number: "", country_of_issue: "" },
  	      id_number: "", last_name: "", first_name: "", tax_number: "", employee_id: "", nationality: "",
  	      next_of_kin: { email: "", address: { city: "", street: "", suburb: "", province: "", postal_code: "" }, last_name: "", first_name: "", phone_number: "", relationship: "" },
  	      date_of_birth: "", marital_status: "", contact_details: { email: "", phone_number: "" },
  	      drivers_license: {
  	        enabled: false,
  	        pdp: { pdp_number: "", expiry_date: "", categories: [] },
  	        prdp: { prdp_number: "", expiry_date: "", categories: [] },
  	        permits: [], issue_date: "", expiry_date: "", endorsements: [], training: [],
  	        license_code: "", license_codes: [], license_number: "",
  	        available_license_codes: ["A1", "A", "B", "C1", "C", "EB", "EC1", "EC"]
  	      },
  	      emergency_contacts: [],
  	      employment_details: {
  	        status: "Active", job_title: "", department: "", start_date: "",
  	        bank_details: { bank_name: "", branch_code: "", account_number: "" },
  	        pay_frequency: "Monthly", employment_type: "Permanent", work_hours_per_week: "", employment_start_date: ""
  	      },
  	      audit: []
  	    };
  	  }

  	  function employeeDefaultWages() {
  	    return { wage_rates: { employee_id: "", deductions: {}, other_earnings: {}, pay_components: { base_salary: { amount: 0, pay_frequency: "Monthly" } } } };
  	  }

  	  function employeeNormaliseUserStatus(value) {
  	    return String(value == null ? "" : value).trim().toUpperCase() === "DISABLED" ? "DISABLED" : "ENABLED";
  	  }

  	  function employeeGenerateLocalKey() {
  	    try {
  	      const cryptoApi = typeof globalThis !== "undefined" && globalThis.crypto ? globalThis.crypto : null;
  	      if (cryptoApi && typeof cryptoApi.randomUUID === "function") return "FIF-" + cryptoApi.randomUUID();
  	      if (cryptoApi && typeof cryptoApi.getRandomValues === "function") {
  	        const words = new Uint32Array(4);
  	        cryptoApi.getRandomValues(words);
  	        return "FIF-" + Array.prototype.map.call(words, function (value) {
  	          return Number(value).toString(16).padStart(8, "0");
  	        }).join("");
  	      }
  	    } catch (_) {}
  	    return "FIF-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  	  }

  	  function employeeWithTimeout(request, timeoutMs, label) {
  	    const duration = Math.max(1000, Number(timeoutMs) || 12000);
  	    return new Promise(function (resolve, reject) {
  	      let settled = false;
  	      const timer = setTimeout(function () {
  	        if (settled) return;
  	        settled = true;
  	        reject(new Error((label || "Database request") + " timed out after " + Math.round(duration / 1000) + " seconds."));
  	      }, duration);
  	      Promise.resolve(request).then(function (value) {
  	        if (settled) return;
  	        settled = true;
  	        clearTimeout(timer);
  	        resolve(value);
  	      }, function (error) {
  	        if (settled) return;
  	        settled = true;
  	        clearTimeout(timer);
  	        reject(error);
  	      });
  	    });
  	  }

  	  function employeeCanonical(source) {
  	    const base = {
  	      APP: "", Office: "", Settings: "", Home: "", Local_Key: "", userStatus: "ENABLED",
  	      Role: "Employee", name: "", email: "", Data_Leave: null,
  	      Data_Details: { employee_details: employeeDefaultDetails() }, Data_Wages: employeeDefaultWages()
  	    };
  	    const result = employeeMerge(base, cloneData(source || {}));
  	    result.Role = permissionNormalKey(result.Role) === "director" ? "Director" : "Employee";
  	    result.Data_Details = result.Data_Details || {};
  	    result.Data_Details.employee_details = employeeMerge(employeeDefaultDetails(), result.Data_Details.employee_details || {});
  	    result.Data_Wages = employeeMerge(employeeDefaultWages(), result.Data_Wages || {});
  	    const details = result.Data_Details.employee_details;
  	    details.account_type = result.Role;
  	    details.operational_roles = uniqueStrings(arr(details.operational_roles));
  	    details.contact_details = details.contact_details || {};
  	    details.employment_details = employeeMerge(employeeDefaultDetails().employment_details, details.employment_details || {});
  	    details.drivers_license = employeeMerge(employeeDefaultDetails().drivers_license, details.drivers_license || {});
  	    const first = clean(details.first_name), last = clean(details.last_name);
  	    result.name = [first, last].filter(Boolean).join(" ") || clean(result.name) || clean(result.email) || result.Role;
  	    result.email = lower(result.email || details.contact_details.email);
  	    details.contact_details.email = result.email;
  	    result.userStatus = employeeNormaliseUserStatus(result.userStatus);
  	    result.APP = permissionRawValues(result.APP).join(",");
  	    result.Office = permissionRawValues(result.Office).join(",");
  	    result.Settings = permissionRawValues(result.Settings).join(",");
  	    const home = managedPermissionValues(result.Home, FIF_OFFICE_PERMISSION_OPTIONS)[0] || "";
  	    const office = managedPermissionValues(result.Office, FIF_OFFICE_PERMISSION_OPTIONS);
  	    result.Home = home && office.indexOf(home) !== -1 ? home : "";
  	    result.Local_Key = clean(result.Local_Key);
  	    delete result.loginEnabled;
  	    delete result.mustChangePassword;
  	    return result;
  	  }

  	  function companyEmployees(company) {
  	    const seen = Object.create(null);
  	    return arr(company && company.Employees).filter(function (employee) {
  	      const id = objectIdOf(employee);
  	      if (!employee || !id || seen[id]) return false;
  	      seen[id] = true;
  	      return true;
  	    }).sort(function (a, b) { return naturalCompare(employeeName(a), employeeName(b)); });
  	  }

  	  function allLoadedEmployees() {
  	    const rows = [], seen = Object.create(null);
  	    const add = function (employee) {
  	      if (!employee || typeof employee !== "object") return;
  	      const key = objectIdOf(employee) || lower(firstValue([
  	        employee.email,
  	        getDeep(employee, ["Data_Details", "employee_details", "contact_details", "email"], "")
  	      ], ""));
  	      if (!key || seen[key]) return;
  	      seen[key] = true;
  	      rows.push(employee);
  	    };

  	    add(APP_DATA.User);
  	    arr(APP_DATA.Users).forEach(add);
  	    arr(APP_DATA.Employees).forEach(add);
  	    COMPANY_LIST.forEach(function (company) {
  	      companyEmployees(company).forEach(add);
  	    });
  	    return rows;
  	  }

  	  function employeeDetails(employee) { return getDeep(employee, ["Data_Details", "employee_details"], {}) || {}; }
  	  function employeeEmployment(employee) { return getDeep(employee, ["Data_Details", "employee_details", "employment_details"], {}) || {}; }
  	  function employeeDriver(employee) { return getDeep(employee, ["Data_Details", "employee_details", "drivers_license"], {}) || {}; }
  	  function employeeDriverSummary(employee) {
  	    const details = employeeDriver(employee);
  	    const prdp = firstValue([details.prdp, details.pdp], {}) || {};
  	    return {
  	      codes: employeeLicenceCodesFromRecord(details),
  	      issueDate: employeeDateInput(firstValue([details.issue_date, details.licence_issue_date, details.license_issue_date], null)),
  	      expiryDate: employeeDateInput(firstValue([details.expiry_date, details.licence_expiry_date, details.license_expiry_date], null)),
  	      licenceNumber: clean(firstValue([details.licence_number, details.license_number], "")),
  	      prdpNumber: clean(firstValue([prdp.prdp_number, prdp.pdp_number, prdp.number], "")),
  	      prdpExpiry: employeeDateInput(firstValue([prdp.expiry_date, prdp.expiryDate], null)),
  	      prdpCategories: employeeNormalisePrDPCategories(firstValue([prdp.categories, prdp.category, details.prdp_categories], [])),
  	      permits: arr(details.permits).map(employeePermitCanonical),
  	      endorsements: arr(details.endorsements).map(employeeEndorsementCanonical),
  	      training: arr(details.training).map(employeeEndorsementCanonical)
  	    };
  	  }
  	  function employeeName(employee) {
  	    const details = employeeDetails(employee);
  	    return clean(firstValue([employee && employee.name, [details.first_name, details.last_name].filter(Boolean).join(" "), employee && employee.email], "Unnamed employee"));
  	  }
  	  function employeeStatus(employee) {
  	    return clean(firstValue([employeeEmployment(employee).status, employee && employee.userStatus], "Active"));
  	  }
  	  function employeeIsDriver(employee) {
  	    const licence = employeeDriver(employee);
  	    return licence.enabled === true || arr(firstValue([licence.license_codes, licence.licence_codes, licence.license_code, licence.licence_code], [])).length > 0;
  	  }
  	  function employeeDateInput(value) {
  	    if (!value) return "";
  	    const date = value instanceof Date ? value : new Date(value);
  	    return Number.isNaN(date.getTime()) ? clean(value).slice(0, 10) : date.toISOString().slice(0, 10);
  	  }
  	  function employeeLicenceDays(employee) {
  	    const expiry = employeeDateInput(employeeDriver(employee).expiry_date);
  	    if (!expiry) return null;
  	    const then = new Date(expiry + "T00:00:00"); const now = new Date(); now.setHours(0,0,0,0);
  	    return Math.ceil((then.getTime() - now.getTime()) / 86400000);
  	  }
  	  function employeeCompanyIds(employee) {
  	    const id = objectIdOf(employee), result = [], seen = Object.create(null);
  	    COMPANY_LIST.forEach(function (company, index) {
  	      const cid = companyKey(company, index);
  	      const related = companyEmployees(company).some(function (row) { return objectIdOf(row) === id; });
  	      if (related && !seen[cid]) { seen[cid] = true; result.push(cid); }
  	    });
  	    arr(employee && employee.Companies).forEach(function (company, index) {
  	      const cid = companyKey(company, index);
  	      if (cid && !seen[cid]) { seen[cid] = true; result.push(cid); }
  	    });
  	    return result;
  	  }
  	  function employeeSearchIndex(employee) {
  	    const d=employeeDetails(employee), e=employeeEmployment(employee), l=employeeDriver(employee);
  	    return [employeeName(employee), employee.email, d.employee_id, d.id_number, d.contact_details && d.contact_details.phone_number, e.department, e.job_title, e.status, employee.userStatus, employeeLicenceCodesFromRecord(l).join(" "), l.license_code, l.license_number].map(clean).join(" ").toLowerCase();
  	  }

  	  function employeeFiltered(company) {
  	    const term=lower(state.employeeSearch), status=lower(state.employeeStatusFilter), department=lower(state.employeeDepartmentFilter);
  	    const rows=companyEmployees(company).filter(function (employee) {
  	      if (term && employeeSearchIndex(employee).indexOf(term) === -1) return false;
  	      const rawStatus=lower(employeeStatus(employee));
  	      if (status !== "all") {
  	        if (status === "active" && /inactive|terminated|suspended|disabled|on leave/.test(rawStatus)) return false;
  	        else if (status === "unavailable" && !/inactive|terminated|suspended|disabled|on leave/.test(rawStatus)) return false;
  	        else if (status !== "active" && status !== "unavailable" && rawStatus !== status) return false;
  	      }
  	      if (department !== "all" && lower(employeeEmployment(employee).department) !== department) return false;
  	      return true;
  	    });
  	    const dir=state.employeeSortDir === "desc" ? -1 : 1;
  	    rows.sort(function (a,b) {
  	      let av="",bv="";
  	      if (state.employeeSortKey === "department") { av=employeeEmployment(a).department; bv=employeeEmployment(b).department; }
  	      else if (state.employeeSortKey === "status") { av=employeeStatus(a); bv=employeeStatus(b); }
  	      else if (state.employeeSortKey === "licence") { av=employeeDriverSummary(a).codes.join("/"); bv=employeeDriverSummary(b).codes.join("/"); }
  	      else { av=employeeName(a); bv=employeeName(b); }
  	      return naturalCompare(av,bv)*dir;
  	    });
  	    return rows;
  	  }

  	  function employeeEnsureStyles() {
  	    if (document.getElementById(EMPLOYEE_STYLE_ID)) return;
  	    const style=document.createElement("style"); style.id=EMPLOYEE_STYLE_ID;
  	    style.textContent=`
  	    #${ROOT_ID} .fifemp-root{display:flex;flex-direction:column;gap:10px;min-height:0;padding:10px 12px 18px;color:#eef2ef}
  	    #${ROOT_ID} .fifemp-head{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:13px 15px;border:1px solid rgba(204,102,51,.28);border-radius:13px;background:linear-gradient(135deg,rgba(204,102,51,.09),rgba(255,255,255,.018) 45%,rgba(0,0,0,.12))}
  	    #${ROOT_ID} .fifemp-head span{display:block;color:#d77a43;font-size:8px;font-weight:950;letter-spacing:.14em;text-transform:uppercase}#${ROOT_ID} .fifemp-head h2{margin:3px 0 0;color:#fff;font-size:19px}#${ROOT_ID} .fifemp-head p{margin:4px 0 0;color:#87908a;font-size:10px}
  	    #${ROOT_ID} .fifemp-actions{display:flex;gap:7px;align-items:center}#${ROOT_ID} .fifemp-btn{height:36px;padding:0 12px;border:1px solid rgba(255,255,255,.1);border-radius:9px;background:#171c18;color:#e7ebe8;font:850 9px Inter,system-ui;cursor:pointer}#${ROOT_ID} .fifemp-btn.primary{border-color:#b96035;background:linear-gradient(145deg,#c76b3b,#87401f);color:#fff;box-shadow:0 8px 20px rgba(164,75,37,.18)}
  	    #${ROOT_ID} .fifemp-kpis{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px}#${ROOT_ID} .fifemp-kpi{position:relative;padding:11px 12px;border:1px solid rgba(255,255,255,.075);border-radius:11px;background:linear-gradient(145deg,#151a16,#0d100e);overflow:hidden}#${ROOT_ID} .fifemp-kpi:before{content:"";position:absolute;inset:0 auto 0 0;width:2px;background:#cc6633}#${ROOT_ID} .fifemp-kpi.good:before{background:#55c98b}#${ROOT_ID} .fifemp-kpi.warn:before{background:#e3a04a}#${ROOT_ID} .fifemp-kpi.bad:before{background:#ef5350}#${ROOT_ID} .fifemp-kpi span{display:block;color:#727c75;font-size:7px;font-weight:950;letter-spacing:.08em;text-transform:uppercase}#${ROOT_ID} .fifemp-kpi strong{display:block;margin-top:4px;color:#fff;font-size:18px}#${ROOT_ID} .fifemp-kpi small{display:block;margin-top:3px;color:#778079;font-size:8px}
  	    #${ROOT_ID} .fifemp-toolbar{display:grid;grid-template-columns:minmax(280px,1fr) 175px 190px auto;gap:8px;align-items:end;padding:9px;border:1px solid rgba(255,255,255,.07);border-radius:11px;background:#101411}#${ROOT_ID} .fifemp-toolbar label>span{display:block;margin:0 0 4px;color:#747d77;font-size:7px;font-weight:950;text-transform:uppercase;letter-spacing:.08em}#${ROOT_ID} .fifemp-toolbar input,#${ROOT_ID} .fifemp-toolbar select{width:100%;height:36px;border:1px solid rgba(255,255,255,.09);border-radius:9px;background:#080b09;color:#edf1ee;padding:0 10px;font:inherit;font-size:10px;outline:none}#${ROOT_ID} .fifemp-result{height:36px;display:grid;place-items:center;padding:0 10px;border:1px solid rgba(255,255,255,.08);border-radius:9px;color:#89928c;font-size:9px;white-space:nowrap}
  	    #${ROOT_ID} .fifemp-list-shell{min-height:0;border:1px solid rgba(255,255,255,.07);border-radius:12px;background:#090c0a;overflow:hidden}#${ROOT_ID} .fifemp-columns,#${ROOT_ID} .fifemp-row{display:grid;grid-template-columns:minmax(180px,1.25fr) 130px minmax(150px,1fr) 110px 120px 110px 78px;align-items:stretch}#${ROOT_ID} .fifemp-columns{position:sticky;top:0;z-index:4;background:#151a16;border-bottom:1px solid rgba(204,102,51,.25)}#${ROOT_ID} .fifemp-sort{border:0;border-right:1px solid rgba(255,255,255,.055);background:transparent;color:#7f8882;padding:9px 10px;text-align:left;font:950 7px Inter,system-ui;text-transform:uppercase;letter-spacing:.08em;cursor:pointer}#${ROOT_ID} .fifemp-sort.active{color:#fff;background:rgba(204,102,51,.07)}
  	    #${ROOT_ID} .fifemp-list{max-height:calc(100vh - 405px);min-height:190px;overflow:auto}#${ROOT_ID} .fifemp-row{border-bottom:1px solid rgba(255,255,255,.05);background:rgba(255,255,255,.008)}#${ROOT_ID} .fifemp-row:hover{background:rgba(204,102,51,.055)}#${ROOT_ID} .fifemp-cell{min-width:0;padding:9px 10px;border-right:1px solid rgba(255,255,255,.04);display:flex;flex-direction:column;justify-content:center;gap:2px;color:#cfd6d1;font-size:9px}#${ROOT_ID} .fifemp-cell strong{color:#f4f7f5;font-size:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#${ROOT_ID} .fifemp-cell small{color:#6e7771;font-size:7.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#${ROOT_ID} .fifemp-badge{display:inline-flex;width:max-content;padding:4px 6px;border:1px solid rgba(255,255,255,.09);border-radius:999px;background:#151a16;color:#aeb6b1;font-size:7px;font-weight:900;text-transform:uppercase}#${ROOT_ID} .fifemp-badge.good{border-color:rgba(85,201,139,.25);color:#79daa6;background:rgba(85,201,139,.08)}#${ROOT_ID} .fifemp-badge.bad{border-color:rgba(239,83,80,.24);color:#ef8581;background:rgba(239,83,80,.07)}#${ROOT_ID} .fifemp-open{align-self:center;justify-self:center;width:32px;height:32px;border:1px solid rgba(204,102,51,.3);border-radius:9px;background:rgba(204,102,51,.08);color:#f0a06f;cursor:pointer;font-size:15px}
  	    #${ROOT_ID} .fifemp-empty{padding:34px;text-align:center;color:#737d76;font-size:10px}
  	    #${SERVICE_MODAL_ID} .fifemp-permission-tree{display:grid;gap:9px;margin:12px 0;padding:11px;border:1px solid rgba(204,102,51,.25);border-radius:12px;background:linear-gradient(145deg,rgba(204,102,51,.055),rgba(255,255,255,.012))}
  	    #${SERVICE_MODAL_ID} .fifemp-permission-tree>header span{display:block;color:#d47a46;font-size:7px;font-weight:950;letter-spacing:.11em;text-transform:uppercase}
  	    #${SERVICE_MODAL_ID} .fifemp-permission-tree>header h3{margin:3px 0 0!important;color:#fff;font-size:13px}
  	    #${SERVICE_MODAL_ID} .fifemp-permission-tree>header p{margin:4px 0 0;color:#879089;font-size:8px;line-height:1.45}
  	    #${SERVICE_MODAL_ID} .fifemp-permission-level{padding:10px;border:1px solid rgba(255,255,255,.07);border-radius:10px;background:#111612}
  	    #${SERVICE_MODAL_ID} .fifemp-permission-level-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}
  	    #${SERVICE_MODAL_ID} .fifemp-permission-level-head strong{color:#edf2ee;font-size:10px}
  	    #${SERVICE_MODAL_ID} .fifemp-permission-level-head span{color:#768079;font-size:8px;text-align:right}
  	    #${SERVICE_MODAL_ID} .fifemp-protected-access{display:grid;gap:3px;margin-top:8px;padding:8px 9px;border:1px solid rgba(228,162,79,.22);border-radius:8px;background:rgba(228,162,79,.055)}
  	    #${SERVICE_MODAL_ID} .fifemp-protected-access strong{color:#efb66a;font-size:8px}
  	    #${SERVICE_MODAL_ID} .fifemp-protected-access span{color:#d5dcd7;font-size:9px}
  	    #${SERVICE_MODAL_ID} .fifemp-protected-access small{color:#7d8780;font-size:7.5px}
  	    #${SERVICE_MODAL_ID} .fifemp-home-setting{display:block;margin-top:8px;padding:10px;border:1px solid rgba(70,146,205,.25);border-radius:9px;background:rgba(70,146,205,.055)}#${SERVICE_MODAL_ID} .fifemp-home-field{display:grid;gap:5px;margin:0}#${SERVICE_MODAL_ID} .fifemp-home-field>span{color:#77b9e8;font-size:7px;font-weight:950;letter-spacing:.08em;text-transform:uppercase}#${SERVICE_MODAL_ID} .fifemp-home-field>small{color:#7b867f;font-size:7.5px;line-height:1.45}#${SERVICE_MODAL_ID} .fifemp-home-field select,#${SERVICE_MODAL_ID} .fifemp-home-field .fif-styled-select{width:100%;min-width:0}
  	    #${SERVICE_MODAL_ID} .fifemp-permission-empty{margin-top:8px;padding:10px;border:1px dashed rgba(255,255,255,.09);border-radius:8px;color:#747e77;font-size:8px}
  	    #${SERVICE_MODAL_ID} .fifemp-tabs{display:flex;gap:6px;padding:0 0 10px;overflow:auto}#${SERVICE_MODAL_ID} .fifemp-tabs button{flex:0 0 auto;height:34px;padding:0 11px;border:1px solid rgba(255,255,255,.09);border-radius:9px;background:#151a16;color:#8f9892;font:850 8px Inter,system-ui;cursor:pointer}#${SERVICE_MODAL_ID} .fifemp-tabs button.active{border-color:#b96035;background:rgba(204,102,51,.14);color:#fff;box-shadow:inset 0 -2px #cc6633}#${SERVICE_MODAL_ID} .fifemp-panel{display:none}#${SERVICE_MODAL_ID} .fifemp-panel.active{display:block}#${SERVICE_MODAL_ID} .fifemp-check-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:7px;margin-top:8px}#${SERVICE_MODAL_ID} .fifemp-check{display:flex;align-items:center;gap:8px;min-height:38px;padding:7px 9px;border:1px solid rgba(255,255,255,.075);border-radius:9px;background:#0d110e;color:#dce2de;font-size:9px}#${SERVICE_MODAL_ID} .fifemp-check input{accent-color:#cc6633}#${SERVICE_MODAL_ID} .fifemp-membership{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px;margin-top:8px}#${SERVICE_MODAL_ID} .fifemp-membership small{display:block;color:#6f7972;font-size:7px}#${SERVICE_MODAL_ID} .fifemp-help{padding:9px 10px;border:1px solid rgba(204,102,51,.2);border-radius:9px;background:rgba(204,102,51,.055);color:#b8c0bb;font-size:8px;line-height:1.5}#${SERVICE_MODAL_ID} .fifemp-danger{color:#ff928e!important;border-color:rgba(239,83,80,.28)!important}

  	    #${SERVICE_MODAL_ID} .fifemp-driver-section{margin-top:12px;padding:11px;border:1px solid rgba(255,255,255,.07);border-radius:11px;background:rgba(255,255,255,.012)}
  	    #${SERVICE_MODAL_ID} .fifemp-section-title{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;margin-bottom:9px}#${SERVICE_MODAL_ID} .fifemp-section-title h3{margin:0!important}#${SERVICE_MODAL_ID} .fifemp-section-title p{margin:3px 0 0;color:#77817a;font-size:8px;line-height:1.45}
  	    #${SERVICE_MODAL_ID} .fifemp-code-editor{display:grid;gap:8px;margin:8px 0 12px}#${SERVICE_MODAL_ID} .fifemp-code-editor>p{margin:0;color:#707a73;font-size:8px;line-height:1.45}
  	    #${SERVICE_MODAL_ID} .fifemp-code-chips{display:flex;flex-wrap:wrap;gap:7px}#${SERVICE_MODAL_ID} .fifemp-code-chip{display:grid;grid-template-columns:auto minmax(0,1fr) auto;align-items:center;gap:7px;min-width:205px;padding:8px 9px;border:1px solid rgba(204,102,51,.27);border-radius:9px;background:linear-gradient(145deg,rgba(204,102,51,.09),rgba(0,0,0,.14))}#${SERVICE_MODAL_ID} .fifemp-code-chip strong{display:grid;place-items:center;width:34px;height:27px;border-radius:7px;background:#cc6633;color:#fff;font-size:10px}#${SERVICE_MODAL_ID} .fifemp-code-chip small{color:#aab2ad;font-size:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#${SERVICE_MODAL_ID} .fifemp-code-chip button{width:25px;height:25px;border:1px solid rgba(239,83,80,.25);border-radius:7px;background:rgba(239,83,80,.07);color:#ef8b87;cursor:pointer}
  	    #${SERVICE_MODAL_ID} .fifemp-code-empty{padding:12px;border:1px dashed rgba(255,255,255,.09);border-radius:9px;color:#747e77;font-size:9px}
  	    #${SERVICE_MODAL_ID} .fifemp-code-add{display:grid;grid-template-columns:minmax(260px,1fr) auto;gap:7px;align-items:end}#${SERVICE_MODAL_ID} .fifemp-code-add label>span{display:block;margin-bottom:4px;color:#7e8781;font-size:8px;font-weight:850}#${SERVICE_MODAL_ID} .fifemp-code-add select{width:100%;height:40px;border:1px solid rgba(204,102,51,.35);border-radius:9px;background:#090c0a;color:#eef2ef;padding:0 10px}#${SERVICE_MODAL_ID} .fifemp-code-add button,#${SERVICE_MODAL_ID} .fifemp-record-editor>header button{height:40px;padding:0 12px;border:1px solid #a9532d;border-radius:9px;background:linear-gradient(145deg,#bb6034,#7f391d);color:#fff;font:850 8px Inter,system-ui;cursor:pointer}#${SERVICE_MODAL_ID} .fifemp-code-add button:disabled{opacity:.45;cursor:not-allowed}
  	    #${SERVICE_MODAL_ID} .fifemp-record-editor{margin-top:12px;padding:11px;border:1px solid rgba(255,255,255,.07);border-radius:11px;background:rgba(255,255,255,.012)}#${SERVICE_MODAL_ID} .fifemp-record-editor>header{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;margin-bottom:9px}#${SERVICE_MODAL_ID} .fifemp-record-editor>header h3{margin:0!important}#${SERVICE_MODAL_ID} .fifemp-record-editor>header p{margin:3px 0 0;color:#77817a;font-size:8px;line-height:1.45}
  	    #${SERVICE_MODAL_ID} .fifemp-record-card{margin-top:8px;border:1px solid rgba(255,255,255,.075);border-radius:10px;background:#0a0e0b;overflow:hidden}#${SERVICE_MODAL_ID} .fifemp-record-card>header{display:flex;align-items:center;justify-content:space-between;gap:9px;padding:8px 10px;border-bottom:1px solid rgba(255,255,255,.06);background:#121713}#${SERVICE_MODAL_ID} .fifemp-record-card>header>div:first-child{display:grid;gap:2px}#${SERVICE_MODAL_ID} .fifemp-record-card>header span{color:#727c75;font-size:7px;font-weight:900;text-transform:uppercase;letter-spacing:.07em}#${SERVICE_MODAL_ID} .fifemp-record-card>header strong{color:#f2f5f3;font-size:10px}#${SERVICE_MODAL_ID} .fifemp-record-card>header>div:last-child{display:flex;align-items:center;gap:6px}#${SERVICE_MODAL_ID} .fifemp-record-card>header b{padding:4px 7px;border-radius:999px;background:rgba(255,255,255,.06);color:#a2aaa5;font-size:7px}#${SERVICE_MODAL_ID} .fifemp-record-card>header b.good{background:rgba(85,201,139,.08);color:#76d7a3}#${SERVICE_MODAL_ID} .fifemp-record-card>header b.warn{background:rgba(227,160,74,.08);color:#e8ad5f}#${SERVICE_MODAL_ID} .fifemp-record-card>header b.bad{background:rgba(239,83,80,.08);color:#ef8783}#${SERVICE_MODAL_ID} .fifemp-record-card>header button{width:27px;height:27px;border:1px solid rgba(239,83,80,.25);border-radius:7px;background:rgba(239,83,80,.07);color:#ef8b87;cursor:pointer}
  	    #${SERVICE_MODAL_ID} .fifemp-record-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;padding:10px}#${SERVICE_MODAL_ID} .fifemp-record-grid label{min-width:0}#${SERVICE_MODAL_ID} .fifemp-record-grid label.wide{grid-column:1/-1}#${SERVICE_MODAL_ID} .fifemp-record-grid label>span{display:block;margin-bottom:4px;color:#78827b;font-size:7.5px;font-weight:850}#${SERVICE_MODAL_ID} .fifemp-record-grid input,#${SERVICE_MODAL_ID} .fifemp-record-grid select,#${SERVICE_MODAL_ID} .fifemp-record-grid textarea{width:100%;box-sizing:border-box;border:1px solid rgba(255,255,255,.085);border-radius:8px;background:#070a08;color:#edf1ee;padding:8px 9px;font:9px Inter,system-ui;outline:none}#${SERVICE_MODAL_ID} .fifemp-record-grid input,#${SERVICE_MODAL_ID} .fifemp-record-grid select{height:38px}#${SERVICE_MODAL_ID} .fifemp-record-grid textarea{resize:vertical}
  	    #${SERVICE_MODAL_ID} .fifemp-record-empty{padding:14px;border:1px dashed rgba(255,255,255,.085);border-radius:9px;text-align:center;color:#717b74;font-size:9px}
  	    @media(max-width:1050px){#${ROOT_ID} .fifemp-kpis{grid-template-columns:repeat(3,minmax(0,1fr))}#${ROOT_ID} .fifemp-toolbar{grid-template-columns:1fr 1fr}#${ROOT_ID} .fifemp-list-shell{overflow-x:auto}#${ROOT_ID} .fifemp-columns,#${ROOT_ID} .fifemp-row{min-width:930px}}
  	    @media(max-width:720px){#${SERVICE_MODAL_ID} .fifemp-code-add{grid-template-columns:1fr}#${SERVICE_MODAL_ID} .fifemp-record-grid{grid-template-columns:1fr}#${SERVICE_MODAL_ID} .fifemp-record-grid label.wide{grid-column:auto}#${ROOT_ID} .fifemp-kpis{grid-template-columns:repeat(2,minmax(0,1fr))}#${ROOT_ID} .fifemp-toolbar{grid-template-columns:1fr}#${SERVICE_MODAL_ID} .fifemp-check-grid,#${SERVICE_MODAL_ID} .fifemp-membership{grid-template-columns:1fr}}
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function employeeSortButton(key,label) {
  	    const active=state.employeeSortKey===key;
  	    return `<button type="button" class="fifemp-sort ${active?"active":""}" data-employee-sort="${escapeAttr(key)}">${escapeHtml(label)} ${active?(state.employeeSortDir==="asc"?"↑":"↓"):""}</button>`;
  	  }

  	  function renderEmployees(company) {
  	    employeeEnsureStyles();
  	    const all=companyEmployees(company), rows=employeeFiltered(company);
  	    const active=all.filter(function(e){return !/inactive|terminated|suspended|disabled|on leave/.test(lower(employeeStatus(e)));}).length;
  	    const drivers=all.filter(employeeIsDriver).length;
  	    const expiring=all.filter(function(e){const d=employeeLicenceDays(e); return d!==null && d<=60;}).length;
  	    const disabled=all.filter(function(e){return employeeNormaliseUserStatus(e && e.userStatus)==="DISABLED";}).length;
  	    const departments=uniqueStrings(all.map(function(e){return employeeEmployment(e).department;})).sort(naturalCompare);
  	    const rowsHtml=rows.length?rows.map(function(employee){
  	      const details=employeeDetails(employee), employment=employeeEmployment(employee), driver=employeeDriverSummary(employee), days=employeeLicenceDays(employee);
  	      const status=employeeStatus(employee), available=!/inactive|terminated|suspended|disabled|on leave/.test(lower(status));
  	      return `<div class="fifemp-row"><div class="fifemp-cell"><strong>${escapeHtml(employeeName(employee))}</strong><small>${escapeHtml(employee.email||"No email")}</small></div><div class="fifemp-cell"><strong>${escapeHtml(details.employee_id||"—")}</strong><small>${escapeHtml(details.id_number||"No ID number")}</small></div><div class="fifemp-cell"><strong>${escapeHtml(employment.department||"Unassigned")}</strong><small>${escapeHtml(employment.job_title||"No job title")}</small></div><div class="fifemp-cell"><span class="fifemp-badge ${available?"good":"bad"}">${escapeHtml(status)}</span><small>Login status: ${employeeNormaliseUserStatus(employee.userStatus)}</small></div><div class="fifemp-cell"><strong>${escapeHtml(driver.codes.join("/")||"Not a driver")}</strong><small>${escapeHtml(driver.licenceNumber||"No licence number")}</small></div><div class="fifemp-cell"><strong>${days===null?"—":days<0?Math.abs(days)+" days expired":days+" days"}</strong><small>${escapeHtml(driver.expiryDate?employeeDateInput(driver.expiryDate):"No expiry")}</small></div><div class="fifemp-cell"><button type="button" class="fifemp-open" data-employee-open="${escapeAttr(objectIdOf(employee))}" aria-label="Open ${escapeAttr(employeeName(employee))}">›</button></div></div>`;
  	    }).join(""):`<div class="fifemp-empty">No employees match the current company filters.</div>`;
  	    return `<section class="fifemp-root"><header class="fifemp-head"><div><span>Company employee register</span><h2>${escapeHtml(companyName(company))} Employees</h2><p>Only employees related to this company are listed. One user may be related to several companies.</p></div><div class="fifemp-actions"><button type="button" class="fifemp-btn" data-employee-print>Print Register</button>${CAN_CREATE_USERS?`<button type="button" class="fifemp-btn primary" data-employee-new>+ New Employee</button>`:""}</div></header><section class="fifemp-kpis"><article class="fifemp-kpi"><span>Employees</span><strong>${formatCount(all.length)}</strong><small>Selected company relation</small></article><article class="fifemp-kpi good"><span>Operationally active</span><strong>${formatCount(active)}</strong><small>Available status</small></article><article class="fifemp-kpi"><span>Drivers</span><strong>${formatCount(drivers)}</strong><small>Licence data present</small></article><article class="fifemp-kpi ${expiring?"warn":"good"}"><span>Licence attention</span><strong>${formatCount(expiring)}</strong><small>Expired or within 60 days</small></article><article class="fifemp-kpi ${disabled?"bad":"good"}"><span>Login disabled</span><strong>${formatCount(disabled)}</strong><small>Database access unavailable</small></article></section><section class="fifemp-toolbar"><label><span>Search employees</span><input type="search" data-employee-search value="${escapeAttr(state.employeeSearch)}" placeholder="Name, employee ID, department, job title, licence..."></label><label><span>Status</span><select data-employee-status><option value="all">All statuses</option><option value="active" ${state.employeeStatusFilter==="active"?"selected":""}>Operationally active</option><option value="unavailable" ${state.employeeStatusFilter==="unavailable"?"selected":""}>Unavailable</option></select></label><label><span>Department</span><select data-employee-department><option value="all">All departments</option>${departments.map(function(d){return `<option value="${escapeAttr(lower(d))}" ${lower(state.employeeDepartmentFilter)===lower(d)?"selected":""}>${escapeHtml(d)}</option>`;}).join("")}</select></label><div class="fifemp-result">${formatCount(rows.length)} shown · ${formatCount(all.length)} total</div></section><section class="fifemp-list-shell"><div class="fifemp-columns">${employeeSortButton("name","Employee")}${employeeSortButton("id","Employee ID")}${employeeSortButton("department","Department / job title")}${employeeSortButton("status","Status")}${employeeSortButton("licence","Licence")}${employeeSortButton("expiry","Expiry")}<span></span></div><div class="fifemp-list">${rowsHtml}</div></section></section>`;
  	  }



  	  const EMPLOYEE_LICENCE_CODES = ["A1", "A", "B", "C1", "C", "EB", "EC1", "EC"];
  	  const EMPLOYEE_PERMIT_TYPES = [
  	    "Dangerous Goods Permit",
  	    "Cross-Border Driver Permit",
  	    "Medical Fitness Certificate",
  	    "Defensive Driving Certificate",
  	    "Equipment Operator Permit",
  	    "First Aid Certificate",
  	    "Other"
  	  ];
  	  const EMPLOYEE_ENDORSEMENT_TYPES = [
  	    "Dangerous Goods Training",
  	    "Corrective Lenses",
  	    "Automatic Transmission",
  	    "Vehicle Restriction",
  	    "Medical Restriction",
  	    "Defensive Driving",
  	    "Other"
  	  ];

  	  function employeeLicenceCodeLabel(code) {
  	    const labels = {
  	      A1: "A1 — Motorcycle up to 125 cc",
  	      A: "A — Motorcycle over 125 cc",
  	      B: "B — Rigid vehicle up to 3,500 kg GVM",
  	      C1: "C1 — Rigid vehicle 3,500–16,000 kg GVM",
  	      C: "C — Rigid vehicle over 16,000 kg GVM",
  	      EB: "EB — Light articulated combination",
  	      EC1: "EC1 — Articulated combination up to 16,000 kg GCM",
  	      EC: "EC — Articulated combination over 16,000 kg GCM"
  	    };
  	    return labels[clean(code).toUpperCase()] || clean(code).toUpperCase();
  	  }

  	  function employeeLicenceCodeValue(value) {
  	    if (typeof value === "string" || typeof value === "number") return clean(value).toUpperCase();
  	    if (!value || typeof value !== "object") return "";
  	    return clean(firstValue([
  	      value.code,
  	      value.Code,
  	      value.license_code,
  	      value.licence_code,
  	      value.value,
  	      value.name
  	    ], "")).toUpperCase();
  	  }

  	  function employeeNormaliseLicenceCodes(values) {
  	    let codes = uniqueStrings(arr(values).map(employeeLicenceCodeValue).filter(function (code) {
  	      return EMPLOYEE_LICENCE_CODES.indexOf(code) !== -1;
  	    }));

  	    if (codes.indexOf("A") !== -1) codes = codes.filter(function (code) { return code !== "A1"; });

  	    if (codes.indexOf("EC") !== -1) {
  	      codes = codes.filter(function (code) {
  	        return ["A1", "A", "EC"].indexOf(code) !== -1;
  	      });
  	    } else {
  	      if (codes.indexOf("EC1") !== -1) {
  	        codes = codes.filter(function (code) {
  	          return ["B", "C1", "EB"].indexOf(code) === -1;
  	        });
  	      }
  	      if (codes.indexOf("C") !== -1) {
  	        codes = codes.filter(function (code) {
  	          return ["B", "C1"].indexOf(code) === -1;
  	        });
  	      } else if (codes.indexOf("C1") !== -1) {
  	        codes = codes.filter(function (code) { return code !== "B"; });
  	      }
  	      if (codes.indexOf("EB") !== -1) {
  	        codes = codes.filter(function (code) { return code !== "B"; });
  	      }
  	    }

  	    return EMPLOYEE_LICENCE_CODES.filter(function (code) {
  	      return codes.indexOf(code) !== -1;
  	    });
  	  }

  	  function employeePrimaryLicenceCode(codes, preferred) {
  	    const normalised = employeeNormaliseLicenceCodes(codes);
  	    const requested = clean(preferred).toUpperCase();
  	    if (normalised.indexOf(requested) !== -1) return requested;
  	    const priority = ["EC", "C", "EC1", "C1", "EB", "B", "A", "A1"];
  	    return priority.find(function (code) { return normalised.indexOf(code) !== -1; }) || "";
  	  }

  	  function employeeLicenceCodesFromRecord(licence) {
  	    return employeeNormaliseLicenceCodes(firstValue([
  	      licence && licence.license_codes,
  	      licence && licence.licence_codes,
  	      licence && licence.license_code,
  	      licence && licence.licence_code
  	    ], []));
  	  }

  	  function employeePrDPCategoryCode(value) {
  	    const token = clean(value).toUpperCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ");
  	    if (token === "G" || token === "GOODS" || token === "GOOD") return "G";
  	    if (token === "P" || token === "PASSENGER" || token === "PASSENGERS") return "P";
  	    if (token === "D" || token === "DANGEROUS" || token === "DANGEROUS GOODS") return "D";
  	    return "";
  	  }

  	  function employeeNormalisePrDPCategories(values) {
  	    return uniqueStrings(arr(values).map(employeePrDPCategoryCode).filter(Boolean));
  	  }

  	  function employeeLicenceCodeEditorMarkup(codes, readOnly) {
  	    const selected = employeeNormaliseLicenceCodes(codes);
  	    const available = EMPLOYEE_LICENCE_CODES.filter(function (code) {
  	      return selected.indexOf(code) === -1;
  	    });
  	    const hidden = selected.map(function (code) {
  	      return `<input type="hidden" name="LicenceCodes" value="${escapeAttr(code)}">`;
  	    }).join("");
  	    const chips = selected.length ? selected.map(function (code) {
  	      return `<span class="fifemp-code-chip"><strong>${escapeHtml(code)}</strong><small>${escapeHtml(employeeLicenceCodeLabel(code).replace(code + " — ", ""))}</small>${readOnly ? "" : `<button type="button" data-employee-remove-licence="${escapeAttr(code)}" aria-label="Remove ${escapeAttr(code)}">×</button>`}</span>`;
  	    }).join("") : `<div class="fifemp-code-empty">No licence authorisation recorded.</div>`;
  	    const picker = readOnly ? "" : `<div class="fifemp-code-add"><label><span>Add licence authorisation</span><select data-employee-licence-picker><option value="">Choose a code</option>${available.map(function (code) {
  	      return `<option value="${escapeAttr(code)}">${escapeHtml(employeeLicenceCodeLabel(code))}</option>`;
  	    }).join("")}</select></label><button type="button" data-employee-add-licence ${available.length ? "" : "disabled"}>Add Code</button></div>`;
  	    return `<div class="fifemp-code-editor" data-employee-code-editor>${hidden}<div class="fifemp-code-chips">${chips}</div>${picker}<p>Most employees have one road code. Additional non-redundant authorisations, such as motorcycle plus heavy vehicle or C plus EB, remain available on the same licence record.</p></div>`;
  	  }

  	  function employeeRecordText(value) {
  	    if (value === null || value === undefined) return "";
  	    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return clean(value);
  	    return "";
  	  }

  	  function employeePermitCanonical(item, index) {
  	    if (typeof item === "string") {
  	      return {
  	        _sourceIndex: index,
  	        permit_type: clean(item) || "Other",
  	        permit_number: "",
  	        issue_date: "",
  	        expiry_date: "",
  	        issuing_authority: "",
  	        notes: ""
  	      };
  	    }
  	    item = item && typeof item === "object" ? item : {};
  	    return {
  	      _sourceIndex: index,
  	      permit_type: employeeRecordText(firstValue([
  	        item.permit_type, item.PermitType, item.type, item.Type,
  	        item.certificate_type, item.name, item.title
  	      ], "Other")) || "Other",
  	      permit_number: employeeRecordText(firstValue([
  	        item.permit_number, item.PermitNumber, item.number, item.Number,
  	        item.certificate_number, item.reference, item.Reference
  	      ], "")),
  	      issue_date: employeeDateInput(firstValue([
  	        item.issue_date, item.issued_date, item.IssueDate, item.start_date
  	      ], "")),
  	      expiry_date: employeeDateInput(firstValue([
  	        item.expiry_date, item.expiryDate, item.ExpiryDate,
  	        item.valid_until, item.ValidUntil
  	      ], "")),
  	      issuing_authority: employeeRecordText(firstValue([
  	        item.issuing_authority, item.authority, item.issuer,
  	        item.provider, item.training_provider
  	      ], "")),
  	      notes: employeeRecordText(firstValue([
  	        item.notes, item.Notes, item.description, item.Description
  	      ], ""))
  	    };
  	  }

  	  function employeeEndorsementCanonical(item, index) {
  	    if (typeof item === "string") {
  	      return {
  	        _sourceIndex: index,
  	        endorsement_type: clean(item) || "Other",
  	        code: "",
  	        issue_date: "",
  	        expiry_date: "",
  	        issuing_authority: "",
  	        notes: ""
  	      };
  	    }
  	    item = item && typeof item === "object" ? item : {};
  	    return {
  	      _sourceIndex: index,
  	      endorsement_type: employeeRecordText(firstValue([
  	        item.endorsement_type, item.EndorsementType, item.training_type,
  	        item.type, item.Type, item.name, item.title
  	      ], "Other")) || "Other",
  	      code: employeeRecordText(firstValue([
  	        item.code, item.Code, item.reference, item.Reference, item.number
  	      ], "")),
  	      issue_date: employeeDateInput(firstValue([
  	        item.issue_date, item.issued_date, item.IssueDate, item.start_date
  	      ], "")),
  	      expiry_date: employeeDateInput(firstValue([
  	        item.expiry_date, item.expiryDate, item.ExpiryDate,
  	        item.valid_until, item.ValidUntil
  	      ], "")),
  	      issuing_authority: employeeRecordText(firstValue([
  	        item.issuing_authority, item.authority, item.issuer,
  	        item.provider, item.training_provider
  	      ], "")),
  	      notes: employeeRecordText(firstValue([
  	        item.notes, item.Notes, item.description, item.Description
  	      ], ""))
  	    };
  	  }

  	  function employeeRecordStatus(expiryDate) {
  	    const expiry = employeeDateInput(expiryDate);
  	    if (!expiry) return { label: "No expiry", tone: "neutral" };
  	    const then = new Date(expiry + "T00:00:00");
  	    const now = new Date();
  	    now.setHours(0, 0, 0, 0);
  	    const days = Math.ceil((then.getTime() - now.getTime()) / 86400000);
  	    if (days < 0) return { label: Math.abs(days) + " days expired", tone: "bad" };
  	    if (days <= 60) return { label: days + " days remaining", tone: "warn" };
  	    return { label: "Valid", tone: "good" };
  	  }

  	  function employeeSelectOptions(values, selected) {
  	    const current = clean(selected);
  	    const items = values.slice();
  	    if (current && items.indexOf(current) === -1) items.unshift(current);
  	    return items.map(function (value) {
  	      return `<option value="${escapeAttr(value)}" ${current === value ? "selected" : ""}>${escapeHtml(value)}</option>`;
  	    }).join("");
  	  }

  	  function employeePermitRowMarkup(record, readOnly, key) {
  	    const status = employeeRecordStatus(record.expiry_date);
  	    return `<article class="fifemp-record-card" data-employee-permit-row data-source-index="${escapeAttr(record._sourceIndex)}" data-record-key="${escapeAttr(key)}">
  	      <header><div><span>Permit / certificate</span><strong data-record-title>${escapeHtml(record.permit_type || "Other")}</strong></div><div><b class="${status.tone}" data-record-status>${escapeHtml(status.label)}</b>${readOnly ? "" : `<button type="button" data-employee-remove-record="permit" aria-label="Remove permit">×</button>`}</div></header>
  	      <div class="fifemp-record-grid">
  	        <label><span>Type</span><select data-permit-field="permit_type" ${readOnly ? "disabled" : ""}>${employeeSelectOptions(EMPLOYEE_PERMIT_TYPES, record.permit_type)}</select></label>
  	        <label><span>Permit / certificate number</span><input type="text" data-permit-field="permit_number" value="${escapeAttr(record.permit_number)}" ${readOnly ? "disabled" : ""}></label>
  	        <label><span>Issue date</span><input type="date" data-permit-field="issue_date" value="${escapeAttr(record.issue_date)}" ${readOnly ? "disabled" : ""}></label>
  	        <label><span>Expiry date</span><input type="date" data-permit-field="expiry_date" value="${escapeAttr(record.expiry_date)}" ${readOnly ? "disabled" : ""}></label>
  	        <label><span>Issuing authority / provider</span><input type="text" data-permit-field="issuing_authority" value="${escapeAttr(record.issuing_authority)}" ${readOnly ? "disabled" : ""}></label>
  	        <label class="wide"><span>Notes</span><textarea rows="2" data-permit-field="notes" ${readOnly ? "disabled" : ""}>${escapeHtml(record.notes)}</textarea></label>
  	      </div>
  	    </article>`;
  	  }

  	  function employeeEndorsementRowMarkup(record, readOnly, key) {
  	    const status = employeeRecordStatus(record.expiry_date);
  	    return `<article class="fifemp-record-card" data-employee-endorsement-row data-source-index="${escapeAttr(record._sourceIndex)}" data-record-key="${escapeAttr(key)}">
  	      <header><div><span>Endorsement / restriction</span><strong data-record-title>${escapeHtml(record.endorsement_type || "Other")}</strong></div><div><b class="${status.tone}" data-record-status>${escapeHtml(status.label)}</b>${readOnly ? "" : `<button type="button" data-employee-remove-record="endorsement" aria-label="Remove endorsement">×</button>`}</div></header>
  	      <div class="fifemp-record-grid">
  	        <label><span>Type</span><select data-endorsement-field="endorsement_type" ${readOnly ? "disabled" : ""}>${employeeSelectOptions(EMPLOYEE_ENDORSEMENT_TYPES, record.endorsement_type)}</select></label>
  	        <label><span>Code / reference</span><input type="text" data-endorsement-field="code" value="${escapeAttr(record.code)}" ${readOnly ? "disabled" : ""}></label>
  	        <label><span>Issue date</span><input type="date" data-endorsement-field="issue_date" value="${escapeAttr(record.issue_date)}" ${readOnly ? "disabled" : ""}></label>
  	        <label><span>Expiry date</span><input type="date" data-endorsement-field="expiry_date" value="${escapeAttr(record.expiry_date)}" ${readOnly ? "disabled" : ""}></label>
  	        <label><span>Authority / provider</span><input type="text" data-endorsement-field="issuing_authority" value="${escapeAttr(record.issuing_authority)}" ${readOnly ? "disabled" : ""}></label>
  	        <label class="wide"><span>Description / restriction</span><textarea rows="2" data-endorsement-field="notes" ${readOnly ? "disabled" : ""}>${escapeHtml(record.notes)}</textarea></label>
  	      </div>
  	    </article>`;
  	  }

  	  function employeePermitEditorMarkup(items, readOnly) {
  	    const rows = arr(items).map(employeePermitCanonical);
  	    return `<section class="fifemp-record-editor"><header><div><h3>Permits and certificates</h3><p>Structured records remain readable and can be checked for expiry in the employee and compliance workspaces.</p></div>${readOnly ? "" : `<button type="button" data-employee-add-record="permit">+ Add Permit</button>`}</header><div data-employee-permit-list>${rows.length ? rows.map(function (record, index) {
  	      return employeePermitRowMarkup(record, readOnly, "permit-" + index);
  	    }).join("") : `<div class="fifemp-record-empty">No permits or certificates recorded.</div>`}</div></section>`;
  	  }

  	  function employeeEndorsementEditorMarkup(items, readOnly) {
  	    const rows = arr(items).map(employeeEndorsementCanonical);
  	    return `<section class="fifemp-record-editor"><header><div><h3>Endorsements, restrictions and training</h3><p>Use dated records for restrictions and specialist training such as dangerous-goods certification.</p></div>${readOnly ? "" : `<button type="button" data-employee-add-record="endorsement">+ Add Record</button>`}</header><div data-employee-endorsement-list>${rows.length ? rows.map(function (record, index) {
  	      return employeeEndorsementRowMarkup(record, readOnly, "endorsement-" + index);
  	    }).join("") : `<div class="fifemp-record-empty">No endorsements, restrictions or training records.</div>`}</div></section>`;
  	  }

  	  function employeeCollectStructuredRows(form, rowSelector, fieldAttribute, existingItems, canonicalFn) {
  	    const sources = arr(existingItems);
  	    return Array.from(form.querySelectorAll(rowSelector)).map(function (row) {
  	      const sourceIndex = Number(row.getAttribute("data-source-index"));
  	      const source = Number.isInteger(sourceIndex) && sourceIndex >= 0 && sources[sourceIndex] && typeof sources[sourceIndex] === "object"
  	        ? cloneData(sources[sourceIndex])
  	        : {};
  	      row.querySelectorAll("[" + fieldAttribute + "]").forEach(function (node) {
  	        const key = node.getAttribute(fieldAttribute);
  	        source[key] = clean(node.value);
  	      });
  	      const normalised = canonicalFn(source, sourceIndex);
  	      delete normalised._sourceIndex;
  	      return Object.assign(source, normalised);
  	    }).filter(function (record) {
  	      return clean(record.permit_type || record.endorsement_type || record.type || record.notes);
  	    });
  	  }

  	  function employeeCollectPermits(form, existingItems) {
  	    return employeeCollectStructuredRows(
  	      form,
  	      "[data-employee-permit-row]",
  	      "data-permit-field",
  	      existingItems,
  	      employeePermitCanonical
  	    );
  	  }

  	  function employeeCollectEndorsements(form, existingItems) {
  	    return employeeCollectStructuredRows(
  	      form,
  	      "[data-employee-endorsement-row]",
  	      "data-endorsement-field",
  	      existingItems,
  	      employeeEndorsementCanonical
  	    );
  	  }

  	  function employeeRefreshRecordCard(row) {
  	    if (!row) return;
  	    const isPermit = row.hasAttribute("data-employee-permit-row");
  	    const typeNode = row.querySelector(isPermit ? '[data-permit-field="permit_type"]' : '[data-endorsement-field="endorsement_type"]');
  	    const expiryNode = row.querySelector(isPermit ? '[data-permit-field="expiry_date"]' : '[data-endorsement-field="expiry_date"]');
  	    const title = row.querySelector("[data-record-title]");
  	    const statusNode = row.querySelector("[data-record-status]");
  	    if (title && typeNode) title.textContent = clean(typeNode.value) || "Other";
  	    if (statusNode) {
  	      const status = employeeRecordStatus(expiryNode && expiryNode.value);
  	      statusNode.textContent = status.label;
  	      statusNode.className = status.tone;
  	    }
  	  }
  	  const EMPLOYEE_MANAGED_APPS = FIF_APP_PERMISSION_OPTIONS.slice();
  	  const EMPLOYEE_MANAGED_OFFICE = FIF_OFFICE_PERMISSION_OPTIONS.slice();
  	  const EMPLOYEE_MANAGED_SETTINGS = FIF_DASH_PERMISSION_OPTIONS.slice();

  	  function employeeAppSet(employee) {
  	    return managedPermissionValues(employee && employee.APP, EMPLOYEE_MANAGED_APPS);
  	  }

  	  function employeeOfficeSet(employee) {
  	    return managedPermissionValues(employee && employee.Office, EMPLOYEE_MANAGED_OFFICE);
  	  }

  	  function employeeSettingsSet(employee) {
  	    return managedPermissionValues(employee && employee.Settings, EMPLOYEE_MANAGED_SETTINGS);
  	  }

  	  function employeeManagedAppSet(employee) {
  	    return employeeAppSet(employee);
  	  }

  	  function employeeUnmanagedAppSet(employee) {
  	    return unmanagedPermissionValues(employee && employee.APP, EMPLOYEE_MANAGED_APPS);
  	  }

  	  function employeeUnmanagedOfficeSet(employee) {
  	    return unmanagedPermissionValues(employee && employee.Office, EMPLOYEE_MANAGED_OFFICE);
  	  }

  	  function employeeUnmanagedSettingsSet(employee) {
  	    return unmanagedPermissionValues(employee && employee.Settings, EMPLOYEE_MANAGED_SETTINGS).filter(function (value) {
  	      const key = permissionNormalKey(value);
  	      return key !== "finances" && key !== "financial" && key !== "financialledger" && key !== "rig" && key !== "rigbuilder" && key !== "overview" && key !== "snapshot" && key !== "dashboardoverview" && key !== "vehicleoverview";
  	    });
  	  }

  	  function employeeProtectedManagedValues(employee, propertyName, options, grantable) {
  	    const current = managedPermissionValues(employee && employee[propertyName], options);
  	    return current.filter(function (option) {
  	      return grantable.indexOf(option) === -1;
  	    });
  	  }

  	  function employeePermissionCheckboxes(name, options, selected, readOnly, grantable) {
  	    if (!options.length) {
  	      return `<div class="fifemp-permission-empty">No permissions are defined at this level.</div>`;
  	    }

  	    const allowed = Array.isArray(grantable) ? grantable : options;
  	    return `<div class="fifemp-check-grid">${options.map(function (option) {
  	      const canGrant = allowed.indexOf(option) !== -1;
  	      const disabled = readOnly || !canGrant;
  	      return `<label class="fifemp-check ${canGrant ? "" : "is-unavailable"}" ${canGrant ? "" : `title="The signed-in user does not possess ${escapeAttr(option)} and cannot grant it."`}>
  	        <input type="checkbox" name="${escapeAttr(name)}" value="${escapeAttr(option)}" ${selected.indexOf(option) !== -1 ? "checked" : ""} ${disabled ? "disabled" : ""}>
  	        <span>${escapeHtml(option)}${canGrant ? "" : `<small>Not assigned to you</small>`}</span>
  	      </label>`;
  	    }).join("")}</div>`;
  	  }

  	  function employeeProtectedPermissionMarkup(label, values) {
  	    if (!values.length) return "";
  	    return `<div class="fifemp-protected-access">
  	      <strong>${escapeHtml(label)}</strong>
  	      <span>${escapeHtml(values.join(", "))}</span>
  	      <small>Retained because the signed-in user cannot grant or remove these permissions.</small>
  	    </div>`;
  	  }

  	  function employeeHomeValue(employee) {
  	    return managedPermissionValues(employee && employee.Home, EMPLOYEE_MANAGED_OFFICE)[0] || "";
  	  }

  	  function employeeHomeSettingMarkup(employee, office, readOnly) {
  	    const assigned = managedPermissionValues(office, EMPLOYEE_MANAGED_OFFICE);
  	    const existingHome = employeeHomeValue(employee);
  	    const home = assigned.indexOf(existingHome) !== -1 ? existingHome : "";
  	    const visible = assigned.length > 0;
  	    const options = [{ value: "", label: "Select home screen" }].concat(assigned);
  	    return `<div class="fifemp-home-setting" data-employee-home-setting style="${visible ? "" : "display:none;"}">
  	      <label class="fifemp-home-field">
  	        <span>Home Screen</span>
  	        <select name="Home" data-employee-home-select ${readOnly ? "data-employee-home-readonly disabled" : ""}>
  	          ${options.map(function (option) {
  	            const value = typeof option === "string" ? option : option.value;
  	            const label = typeof option === "string" ? option : option.label;
  	            return `<option value="${escapeAttr(value)}" ${value === home ? "selected" : ""}>${escapeHtml(label)}</option>`;
  	          }).join("")}
  	        </select>
  	        <small>Choose which assigned Office section opens first for this user.</small>
  	      </label>
  	    </div>`;
  	  }

  	  function employeeSetHomeValue(overlay, value) {
  	    if (!overlay) return "";
  	    const form = overlay.querySelector("[data-employee-form]");
  	    const select = form && form.elements.namedItem("Home");
  	    const office = employeeCheckedPermissionValues(form, "OfficeAccess");
  	    const normalized = managedPermissionValues(value, EMPLOYEE_MANAGED_OFFICE)[0] || "";
  	    const next = office.indexOf(normalized) !== -1 ? normalized : "";
  	    if (select) {
  	      select.value = next;
  	      if (typeof syncStyledSelect === "function") syncStyledSelect(select);
  	      select.dispatchEvent(new Event("input", { bubbles: true }));
  	      select.dispatchEvent(new Event("change", { bubbles: true }));
  	    }
  	    return next;
  	  }

  	  function employeePromptOfficeHome(overlay, required) {
  	    const form = overlay && overlay.querySelector("[data-employee-form]");
  	    const office = employeeCheckedPermissionValues(form, "OfficeAccess");
  	    if (!form || !office.length) {
  	      employeeSetHomeValue(overlay, "");
  	      return Promise.resolve("");
  	    }

  	    const current = managedPermissionValues(employeeFormValue(form, "Home"), EMPLOYEE_MANAGED_OFFICE)[0] || "";
  	    ensureFifPromptStyles();
  	    if (activePromptResolve) closeFifPrompt(false);
  	    const previous = document.getElementById(FIF_PROMPT_ROOT_ID);
  	    if (previous && previous.parentNode) previous.parentNode.removeChild(previous);

  	    return new Promise(function (resolve) {
  	      const root = document.createElement("div");
  	      root.id = FIF_PROMPT_ROOT_ID;
  	      root.setAttribute("role", "presentation");
  	      root.innerHTML = `
  	      <section class="fif-prompt-card type-info" role="dialog" aria-modal="true" aria-labelledby="fifPromptTitle">
  	        <div class="fif-prompt-topline"></div>
  	        <header class="fif-prompt-head">
  	          <div class="fif-prompt-icon">${promptIconSvg("info")}</div>
  	          <div><div class="fif-prompt-kicker">Fleet In Form Employees</div><h2 class="fif-prompt-title" id="fifPromptTitle">Set Office Home Screen</h2></div>
  	        </header>
  	        <div class="fif-prompt-body">
  	          <div class="fif-prompt-message">Choose the Office section this user must enter first after opening Office.</div>
  	          <div class="fif-prompt-details" style="grid-template-columns:1fr;margin-top:13px;">
  	            ${office.map(function (option) {
  	              return `<label class="fif-prompt-detail" style="display:flex;align-items:center;gap:10px;cursor:pointer;">
  	                <input type="radio" name="EmployeeHomeChoice" value="${escapeAttr(option)}" ${option === current ? "checked" : ""} style="accent-color:#cc6633;">
  	                <span style="margin:0;color:#f4f6f5;font-size:11px;letter-spacing:0;text-transform:none;">${escapeHtml(option)}</span>
  	              </label>`;
  	            }).join("")}
  	          </div>
  	        </div>
  	        <footer class="fif-prompt-actions">
  	          ${required ? "" : `<button type="button" class="fif-prompt-cancel" data-employee-home-cancel>Cancel</button>`}
  	          <button type="button" class="fif-prompt-confirm" data-employee-home-confirm ${current && office.indexOf(current) !== -1 ? "" : "disabled"}>Set Home</button>
  	        </footer>
  	      </section>`;
  	      document.body.appendChild(root);

  	      let settled = false;
  	      const finish = function (value) {
  	        if (settled) return;
  	        settled = true;
  	        document.removeEventListener("keydown", keyHandler, true);
  	        if (root.parentNode) root.parentNode.removeChild(root);
  	        const selected = employeeSetHomeValue(overlay, value);
  	        resolve(selected);
  	      };
  	      const confirm = root.querySelector("[data-employee-home-confirm]");
  	      const selectedValue = function () {
  	        const selected = root.querySelector('input[name="EmployeeHomeChoice"]:checked');
  	        return selected ? clean(selected.value) : "";
  	      };
  	      root.querySelectorAll('input[name="EmployeeHomeChoice"]').forEach(function (radio) {
  	        radio.addEventListener("change", function () {
  	          if (confirm) confirm.disabled = !selectedValue();
  	        });
  	      });
  	      confirm?.addEventListener("click", function () {
  	        const selected = selectedValue();
  	        if (selected) finish(selected);
  	      });
  	      root.querySelector("[data-employee-home-cancel]")?.addEventListener("click", function () {
  	        finish(current && office.indexOf(current) !== -1 ? current : "");
  	      });
  	      const keyHandler = function (event) {
  	        if (event.key === "Escape" && !required) {
  	          event.preventDefault();
  	          finish(current && office.indexOf(current) !== -1 ? current : "");
  	        } else if (event.key === "Enter") {
  	          const selected = selectedValue();
  	          if (selected) {
  	            event.preventDefault();
  	            finish(selected);
  	          }
  	        }
  	      };
  	      document.addEventListener("keydown", keyHandler, true);
  	      setTimeout(function () {
  	        const selected = root.querySelector('input[name="EmployeeHomeChoice"]:checked');
  	        (selected || root.querySelector('input[name="EmployeeHomeChoice"]'))?.focus();
  	      }, 0);
  	    });
  	  }

  	  async function employeeEnsureHomeBeforeSave(overlay) {
  	    const form = overlay && overlay.querySelector("[data-employee-form]");
  	    if (!form) return false;
  	    const apps = employeeCheckedPermissionValues(form, "Apps");
  	    const office = employeeCheckedPermissionValues(form, "OfficeAccess");

  	    if (apps.indexOf("Office") === -1) {
  	      employeeSetHomeValue(overlay, "");
  	      return true;
  	    }

  	    if (!office.length) {
  	      await fifAlert("Select at least one Office module before creating or saving a user who has Office application access.", {
  	        title: "Office Module Required",
  	        type: "warning",
  	        confirmText: "Close"
  	      });
  	      return false;
  	    }

  	    const home = managedPermissionValues(employeeFormValue(form, "Home"), EMPLOYEE_MANAGED_OFFICE)[0] || "";
  	    if (home && office.indexOf(home) !== -1) return true;

  	    return !!(await employeePromptOfficeHome(overlay, true));
  	  }

  	  function employeePermissionTreeMarkup(employee, accessReadOnly) {
  	    const apps = employeeAppSet(employee);
  	    const office = employeeOfficeSet(employee);
  	    const settings = employeeSettingsSet(employee);
  	    const grantableApps = currentUserGrantableApps();
  	    const grantableOffice = currentUserGrantableOffice();
  	    const grantableSettings = currentUserGrantableSettings();

  	    const protectedApps = employeeProtectedManagedValues(employee, "APP", EMPLOYEE_MANAGED_APPS, grantableApps);
  	    const protectedOffice = employeeProtectedManagedValues(employee, "Office", EMPLOYEE_MANAGED_OFFICE, grantableOffice);
  	    const protectedSettings = employeeProtectedManagedValues(employee, "Settings", EMPLOYEE_MANAGED_SETTINGS, grantableSettings);

  	    const officeVisible = apps.indexOf("Office") !== -1;
  	    const settingsVisible = officeVisible && office.indexOf("Dash") !== -1;

  	    return `<section class="fifemp-permission-tree" data-employee-permission-tree>
  	      <header>
  	        <div>
  	          <span>Permission hierarchy</span>
  	          <h3>Applications and functionality</h3>
  	          <p>APP grants the application. Office grants Office modules. Settings grants Dashboard functionality.</p>
  	        </div>
  	      </header>

  	      <div class="fifemp-permission-level">
  	        <div class="fifemp-permission-level-head">
  	          <strong>1. Application access — APP</strong>
  	          <span>The user can enter only the selected applications.</span>
  	        </div>
  	        ${employeePermissionCheckboxes("Apps", EMPLOYEE_MANAGED_APPS, apps, accessReadOnly, grantableApps)}
  	        ${employeeProtectedPermissionMarkup("Protected application access", protectedApps)}
  	      </div>

  	      <div class="fifemp-permission-level" data-employee-office-access style="${officeVisible ? "" : "display:none;"}">
  	        <div class="fifemp-permission-level-head">
  	          <strong>2. Office modules — Office</strong>
  	          <span>Shown only when Office is granted in APP.</span>
  	        </div>
  	        ${employeePermissionCheckboxes("OfficeAccess", EMPLOYEE_MANAGED_OFFICE, office, accessReadOnly, grantableOffice)}
  	        ${employeeHomeSettingMarkup(employee, office, accessReadOnly)}
  	        ${employeeProtectedPermissionMarkup("Protected Office modules", protectedOffice)}
  	      </div>

  	      <div class="fifemp-permission-level" data-employee-settings-access style="${settingsVisible ? "" : "display:none;"}">
  	        <div class="fifemp-permission-level-head">
  	          <strong>3. Dashboard functions — Settings</strong>
  	          <span>Shown only when Office and Dash are both granted.</span>
  	        </div>
  	        ${employeePermissionCheckboxes("SettingsAccess", EMPLOYEE_MANAGED_SETTINGS, settings, accessReadOnly, grantableSettings)}
  	        ${employeeProtectedPermissionMarkup("Protected Dashboard functions", protectedSettings)}
  	      </div>

  	      <div class="fifemp-help">
  	        Every defined permission is shown. Permissions not held by the signed-in user are visibly disabled and cannot be granted. Existing permissions outside that grant ceiling remain protected individually; removing Office or Dash revokes the entire dependent branch after confirmation.
  	      </div>
  	    </section>`;
  	  }

  	  function employeeClearPermissionInputs(overlay, name) {
  	    overlay.querySelectorAll(`input[name="${name}"]`).forEach(function (input) {
  	      input.checked = false;
  	      input.dispatchEvent(new Event("input", { bubbles: true }));
  	    });
  	  }

  	  function employeeCheckedPermissionValues(form, name) {
  	    if (!form) return [];
  	    return uniqueStrings(Array.prototype.slice.call(form.querySelectorAll('input[name="' + name + '"]:checked')).map(function (input) {
  	      return clean(input.value);
  	    }).filter(Boolean));
  	  }

  	  function employeeRefreshPermissionTree(overlay) {
  	    if (!overlay) return;
  	    const form = overlay.querySelector("[data-employee-form]");
  	    if (!form) return;

  	    const apps = employeeCheckedPermissionValues(form, "Apps");
  	    const office = employeeCheckedPermissionValues(form, "OfficeAccess");
  	    const officeSection = overlay.querySelector("[data-employee-office-access]");
  	    const settingsSection = overlay.querySelector("[data-employee-settings-access]");
  	    const homeSection = overlay.querySelector("[data-employee-home-setting]");
  	    const homeSelect = form.elements.namedItem("Home");
  	    const hasOffice = apps.indexOf("Office") !== -1;
  	    const hasDash = hasOffice && office.indexOf("Dash") !== -1;
  	    const hasOfficeModule = hasOffice && office.length > 0;
  	    const previousHome = managedPermissionValues(homeSelect && homeSelect.value, EMPLOYEE_MANAGED_OFFICE)[0] || "";
  	    const home = hasOfficeModule && office.indexOf(previousHome) !== -1 ? previousHome : "";

  	    if (officeSection) officeSection.style.display = hasOffice ? "" : "none";
  	    if (settingsSection) settingsSection.style.display = hasDash ? "" : "none";
  	    if (homeSection) homeSection.style.display = hasOfficeModule ? "" : "none";

  	    if (homeSelect) {
  	      const signature = office.join("|");
  	      if (homeSelect.dataset.employeeHomeOptions !== signature) {
  	        homeSelect.innerHTML = `<option value="">Select home screen</option>${office.map(function (option) {
  	          return `<option value="${escapeAttr(option)}">${escapeHtml(option)}</option>`;
  	        }).join("")}`;
  	        homeSelect.dataset.employeeHomeOptions = signature;
  	      }
  	      homeSelect.disabled = homeSelect.hasAttribute("data-employee-home-readonly") || !hasOfficeModule;
  	      homeSelect.value = home;
  	      if (typeof syncStyledSelect === "function") syncStyledSelect(homeSelect);
  	    }

  	    if (!hasOfficeModule || office.indexOf(previousHome) === -1) employeeSetHomeValue(overlay, "");
  	  }

  	  function employeeBuildPermissionTree(form, existing) {
  	    if (employeeSelfAccessLocked(existing)) {
  	      return {
  	        APP: existing && existing.APP,
  	        Office: existing && existing.Office,
  	        Settings: existing && existing.Settings,
  	        Home: existing && existing.Home
  	      };
  	    }

  	    const grantableApps = currentUserGrantableApps();
  	    const grantableOffice = currentUserGrantableOffice();
  	    const grantableSettings = currentUserGrantableSettings();

  	    const selectedApps = managedPermissionValues(employeeFormArray(form, "Apps"), EMPLOYEE_MANAGED_APPS);
  	    const selectedOffice = managedPermissionValues(employeeFormArray(form, "OfficeAccess"), EMPLOYEE_MANAGED_OFFICE);
  	    const selectedSettings = managedPermissionValues(employeeFormArray(form, "SettingsAccess"), EMPLOYEE_MANAGED_SETTINGS);
  	    let home = managedPermissionValues(employeeFormValue(form, "Home"), EMPLOYEE_MANAGED_OFFICE)[0] || "";

  	    selectedApps.forEach(function (option) {
  	      if (grantableApps.indexOf(option) === -1) throw fifPermissionError("You cannot grant the " + option + " application.");
  	    });
  	    selectedOffice.forEach(function (option) {
  	      if (grantableOffice.indexOf(option) === -1) throw fifPermissionError("You cannot grant the " + option + " Office module.");
  	    });
  	    selectedSettings.forEach(function (option) {
  	      if (grantableSettings.indexOf(option) === -1) throw fifPermissionError("You cannot grant the " + option + " Dashboard function.");
  	    });

  	    const protectedApps = employeeProtectedManagedValues(existing, "APP", EMPLOYEE_MANAGED_APPS, grantableApps);
  	    const protectedOffice = employeeProtectedManagedValues(existing, "Office", EMPLOYEE_MANAGED_OFFICE, grantableOffice);
  	    const protectedSettings = employeeProtectedManagedValues(existing, "Settings", EMPLOYEE_MANAGED_SETTINGS, grantableSettings);

  	    let apps = uniqueStrings(employeeUnmanagedAppSet(existing).concat(protectedApps, selectedApps));
  	    let office = uniqueStrings(employeeUnmanagedOfficeSet(existing).concat(protectedOffice, selectedOffice));
  	    let settings = uniqueStrings(employeeUnmanagedSettingsSet(existing).concat(protectedSettings, selectedSettings));

  	    const hasOffice = managedPermissionValues(apps, EMPLOYEE_MANAGED_APPS).indexOf("Office") !== -1;
  	    if (!hasOffice) {
  	      office = [];
  	      settings = [];
  	      home = "";
  	    } else {
  	      const managedOffice = managedPermissionValues(office, EMPLOYEE_MANAGED_OFFICE);
  	      const hasDash = managedOffice.indexOf("Dash") !== -1;
  	      if (!hasDash) settings = [];
  	      if (!managedOffice.length) home = "";
  	      else if (home && managedOffice.indexOf(home) === -1) throw fifPermissionError("Home must be one of the user's assigned Office modules.");
  	    }

  	    const tree = {
  	      APP: permissionStorageValue(existing && existing.APP, apps),
  	      Office: permissionStorageValue(existing && existing.Office, office),
  	      Settings: permissionStorageValue(existing && existing.Settings, settings),
  	      Home: home
  	    };

  	    const existingId = objectIdOf(existing);
  	    const currentId = objectIdOf(APP_DATA.User);
  	    if (existingId && currentId && existingId === currentId) {
  	      [
  	        ["APP", EMPLOYEE_MANAGED_APPS],
  	        ["Office", EMPLOYEE_MANAGED_OFFICE],
  	        ["Settings", EMPLOYEE_MANAGED_SETTINGS]
  	      ].forEach(function (entry) {
  	        const before = managedPermissionValues(existing && existing[entry[0]], entry[1]);
  	        const after = managedPermissionValues(tree[entry[0]], entry[1]);
  	        const added = after.filter(function (option) { return before.indexOf(option) === -1; });
  	        if (added.length) throw fifPermissionError("You cannot add " + added.join(", ") + " to your own permissions.");
  	      });
  	    }

  	    return tree;
  	  }

  	  function employeeGenderValue(value) {
  	    const token = lower(value);
  	    if (token === "male" || token === "m") return "Male";
  	    if (token === "female" || token === "f") return "Female";
  	    return "";
  	  }

  	  function employeeModalShell(title, subtitle, body, footer) {
  	    closeServicePortalModal();
  	    state.serviceModalOpen = true;
  	    const overlay = document.createElement("div");
  	    overlay.id = SERVICE_MODAL_ID;
  	    overlay.innerHTML = `<div class="fifsp-modal wide" role="dialog" aria-modal="true"><header><div><span>Fleet In Form Employees</span><h2>${escapeHtml(title)}</h2><p>${escapeHtml(subtitle || "")}</p></div><button type="button" data-sp-modal-close aria-label="Close">×</button></header><main>${body}</main><footer>${footer || ""}</footer></div>`;
  	    overlay.addEventListener("click", async function (event) {
  	      if (event.target === overlay || event.target.closest("[data-sp-modal-close]")) {
  	        event.preventDefault();
  	        await fifRequestCloseServicePortalModal();
  	      }
  	    });
  	    (document.getElementById(ROOT_ID) || document.body).appendChild(overlay);
  	    requestAnimationFrame(function () {
  	      enhanceAllStyledSelects(overlay);
  	      enhanceAllStyledDateInputs(overlay);
  	      enhanceDashboardNumberInputs(overlay);
  	      fifInstallDirtyScope(overlay);
  	    });
  	    return overlay;
  	  }

  	  function employeeMembershipMarkup(employee, company, readOnly) {
  	    const existing = employeeCompanyIds(employee);
  	    const currentId = companyKey(company, COMPANY_LIST.indexOf(company));
  	    const creating = !employeeDatabaseObjectId(employee);
  	    return `<div class="fifemp-membership">${COMPANY_LIST.map(function (item, index) {
  	      const id = companyKey(item, index);
  	      const current = id === currentId;
  	      // A brand-new Employee must start with a Company, so the current Company is
  	      // preselected and locked only during creation. Existing Employees may be
  	      // unlinked from the current Company or from every Company.
  	      const checked = creating ? (current || existing.indexOf(id) !== -1) : existing.indexOf(id) !== -1;
  	      const disabled = readOnly || (creating && current);
  	      const note = creating && current
  	        ? "Current company · required for new login"
  	        : readOnly
  	          ? "Company membership locked"
  	          : current
  	            ? "Current company · may be unlinked"
  	            : "Additional company membership";
  	      return `<label class="fifemp-check"><input type="checkbox" name="CompanyIds" value="${escapeAttr(id)}" ${checked ? "checked" : ""} ${disabled ? "disabled" : ""}><span><strong>${escapeHtml(companyName(item))}</strong><small>${escapeHtml(note)}</small></span>${checked && disabled ? `<input type="hidden" name="CompanyIds" value="${escapeAttr(id)}">` : ""}</label>`;
  	    }).join("")}</div>`;
  	  }

  	  function employeeOpenEditor(company, employee) {
  	    if (!CAN_VIEW_EMPLOYEES) return;
  	    const employeeSource = employee && employeeIsCurrentUser(employee)
  	      ? employeeMerge(cloneData(employee), cloneData(APP_DATA.User || {}))
  	      : employee;
  	    const existing = employeeSource ? employeeCanonical(employeeSource) : employeeCanonical({});
  	    const create = !employee;
  	    const details = employeeDetails(existing);
  	    const employment = employeeEmployment(existing);
  	    const licence = employeeDriver(existing);
  	    const prdp = firstValue([licence.prdp, licence.pdp], {}) || {};

  	    if (create && !CAN_CREATE_USERS) {
  	      fifAlert("Only a Director who is assigned the Users function may create login users.", {
  	        title: "Director Required",
  	        type: "warning",
  	        confirmText: "Close"
  	      });
  	      return;
  	    }

  	    const baseReadOnly = !CAN_MANAGE_EMPLOYEES;
  	    const accessReadOnly = !CAN_MANAGE_EMPLOYEE_ACCESS;
  	    const targetIsDirector = !create && employeeIsDirector(existing);
  	    const directorSelf = targetIsDirector && employeeIsCurrentUser(existing);
  	    const directorLockedForViewer = targetIsDirector && !directorSelf;
  	    const selfAccessLocked = !create && employeeSelfAccessLocked(existing);

  	    const accountReadOnly = baseReadOnly || targetIsDirector;
  	    const personalReadOnly = baseReadOnly || directorLockedForViewer;
  	    const employmentReadOnly = baseReadOnly || targetIsDirector;
  	    const driverReadOnly = baseReadOnly || directorLockedForViewer;
  	    const permissionReadOnly = accessReadOnly || selfAccessLocked || targetIsDirector;
  	    const payrollReadOnly = !CAN_VIEW_EMPLOYEE_PAYROLL || targetIsDirector;
  	    const canResetPassword = !create && !targetIsDirector && userCanResetEmployeePassword(existing);
  	    state.employeeEditorTab = "account";

  	    const codes = employeeLicenceCodesFromRecord(licence);
  	    const categories = employeeNormalisePrDPCategories(firstValue([prdp.categories, prdp.category], []));
  	    const apps = employeeManagedAppSet(existing);
  	    const office = employeeOfficeSet(existing);
  	    const panel = function (key, title, content) {
  	      return `<section class="fifemp-panel ${key === "account" ? "active" : ""}" data-employee-panel="${escapeAttr(key)}"><h3>${escapeHtml(title)}</h3>${content}</section>`;
  	    };

  	    const categoryOptions = [
  	      { value: "G", label: "G — Goods" },
  	      { value: "P", label: "P — Passengers" },
  	      { value: "D", label: "D — Dangerous goods" }
  	    ];

  	    const driverPanel = `<div class="checks">${serviceField(
  	      "DriverEnabled",
  	      "Eligible for driver setup",
  	      licence.enabled === true || codes.length > 0,
  	      "checkbox",
  	      {
  	        help: "Operational qualification checks still use the exact licence, PrDP, expiry and mass records.",
  	        disabled: driverReadOnly
  	      }
  	    )}</div>
  	    <section class="fifemp-driver-section">
  	      <div class="fifemp-section-title"><div><h3>Driving licence authorisations</h3><p>Add one code at a time. Redundant lower codes are removed automatically while legitimate combined categories remain.</p></div></div>
  	      ${employeeLicenceCodeEditorMarkup(codes, driverReadOnly)}
  	      <div class="grid">
  	        ${serviceField("LicenceNumber", "Licence card number", licence.license_number || licence.licence_number, "text", { disabled: driverReadOnly })}
  	        ${serviceField("LicenceIssueDate", "Licence issue date", employeeDateInput(licence.issue_date), "date", { disabled: driverReadOnly })}
  	        ${serviceField("LicenceExpiryDate", "Licence card expiry date", employeeDateInput(licence.expiry_date), "date", { disabled: driverReadOnly })}
  	      </div>
  	    </section>
  	    <section class="fifemp-driver-section">
  	      <div class="fifemp-section-title"><div><h3>Professional Driving Permit</h3><p>The PrDP is additional to the ordinary driving licence and remains a separate operational qualification.</p></div></div>
  	      <div class="grid">
  	        ${serviceField("PrDPNumber", "PrDP number", prdp.prdp_number || prdp.pdp_number, "text", { disabled: driverReadOnly })}
  	        ${serviceField("PrDPExpiry", "PrDP expiry", employeeDateInput(prdp.expiry_date), "date", { disabled: driverReadOnly })}
  	      </div>
  	      <div class="fifemp-check-grid">${categoryOptions.map(function (category) {
  	        return `<label class="fifemp-check"><input type="checkbox" name="PrDPCategories" value="${escapeAttr(category.value)}" ${categories.indexOf(category.value) !== -1 ? "checked" : ""} ${driverReadOnly ? "disabled" : ""}><span>${escapeHtml(category.label)}</span></label>`;
  	      }).join("")}</div>
  	    </section>
  	    ${employeePermitEditorMarkup(licence.permits, driverReadOnly)}
  	    ${employeeEndorsementEditorMarkup(licence.endorsements, driverReadOnly)}`;

  	    const employeeDetailTabs = create ? "" : `<button type="button" data-employee-editor-tab="personal">Personal</button>
  	      <button type="button" data-employee-editor-tab="employment">Employment</button>
  	      <button type="button" data-employee-editor-tab="driver">Driver & Permits</button>
  	      ${CAN_VIEW_EMPLOYEE_PAYROLL ? `<button type="button" data-employee-editor-tab="payroll">Payroll</button>` : ""}`;

  	    const body = `<form data-employee-form class="fifsp-form">
  	      <nav class="fifemp-tabs">
  	        <button type="button" class="active" data-employee-editor-tab="account">Account & Companies</button>
  	        ${employeeDetailTabs}
  	      </nav>
  	      ${panel("account", "Identity, access and company membership", `<div class="grid">
  	        ${serviceField("FirstName", "First name", details.first_name, "text", { required: true, disabled: accountReadOnly })}
  	        ${serviceField("LastName", "Last name", details.last_name, "text", { required: true, disabled: accountReadOnly })}
  	        ${serviceField("Email", "Email", existing.email, "email", { required: true, disabled: accountReadOnly || accessReadOnly })}
  	        ${create ? serviceField("Password", "Password", "", "password", { required: true, disabled: accessReadOnly, placeholder: "Minimum 8 characters" }) : canResetPassword ? serviceField("Password", "New password", "", "password", { disabled: false, placeholder: "Leave blank to keep the current password" }) : ""}
  	        ${create ? serviceField("ConfirmPassword", "Confirm password", "", "password", { required: true, disabled: accessReadOnly, placeholder: "Repeat the password" }) : canResetPassword ? serviceField("ConfirmPassword", "Confirm new password", "", "password", { disabled: false, placeholder: "Repeat the new password" }) : ""}
  	        ${create ? "" : serviceField("EmployeeId", "Employee ID", details.employee_id, "text", { disabled: accountReadOnly })}
  	        ${serviceField("IdNumber", "South African ID / identity number", details.id_number, "text", { required: true, disabled: accountReadOnly })}
  	        ${create ? "" : serviceField("Phone", "Phone number", getDeep(details, ["contact_details", "phone_number"], ""), "tel", { disabled: accountReadOnly })}
  	        ${create ? "" : serviceField("UserStatus", "Login status", employeeNormaliseUserStatus(existing.userStatus), "select", { values: ["ENABLED", "DISABLED"], disabled: permissionReadOnly })}
  	      </div>
  	      ${canResetPassword ? `<div class="fifemp-help">Password reset: the current password is never loaded or displayed. Enter the new password twice; leaving both fields blank keeps the existing password.</div>` : ""}
  	      ${targetIsDirector ? `<div class="fifemp-help">Director protection: Account & Companies, Employment, Payroll, login status and permissions are locked. A Director may edit only their own Personal and Driver & Permits information.</div>` : selfAccessLocked ? `<div class="fifemp-help">Your login status, permissions and company memberships are locked while you edit your own account.</div>` : ""}
  	      <div class="fifemp-help">This workspace lists only ${escapeHtml(companyName(company))} employees. Company membership below may include several companies without exposing an unrelated database-wide user table.</div>
  	      ${create ? `<section class="fifemp-permission-tree" data-employee-permission-tree>
  	        <header><div><span>Essential access</span><h3>Application and Home access</h3><p>Select at least one application. When Office is selected, choose at least one Office module and select which assigned module must open as Home.</p></div></header>
  	        <div class="fifemp-permission-level">
  	          <div class="fifemp-permission-level-head"><strong>1. Application access — APP</strong><span>The employee can enter only the selected applications.</span></div>
  	          ${employeePermissionCheckboxes("Apps", EMPLOYEE_MANAGED_APPS, apps, permissionReadOnly, currentUserGrantableApps())}
  	        </div>
  	        <div class="fifemp-permission-level" data-employee-office-access style="${apps.indexOf("Office") !== -1 ? "" : "display:none;"}">
  	          <div class="fifemp-permission-level-head"><strong>2. Office modules — Office</strong><span>Required when Office is granted. Home must be one of these selected modules.</span></div>
  	          ${employeePermissionCheckboxes("OfficeAccess", EMPLOYEE_MANAGED_OFFICE, office, permissionReadOnly, currentUserGrantableOffice())}
  	          ${employeeHomeSettingMarkup(existing, office, permissionReadOnly)}
  	        </div>
  	      </section>` : employeePermissionTreeMarkup(existing, permissionReadOnly)}
  	      <h3>Related companies</h3>
  	      ${employeeMembershipMarkup(existing, company, permissionReadOnly)}`)}
  	      ${create ? "" : panel("personal", "Personal and contact information", `<div class="grid">
  	        ${serviceField("DateOfBirth", "Date of birth", employeeDateInput(details.date_of_birth), "date", { disabled: personalReadOnly })}
  	        ${serviceField("Gender", "Gender", employeeGenderValue(details.gender), "select", { values: [{ value: "", label: "Select gender" }, "Male", "Female"], disabled: personalReadOnly })}
  	        ${serviceField("Nationality", "Nationality", details.nationality, "text", { disabled: personalReadOnly })}
  	        ${serviceField("MaritalStatus", "Marital status", details.marital_status, "text", { disabled: personalReadOnly })}
  	        ${serviceField("Street", "Street", getDeep(details, ["address", "street"], ""), "text", { disabled: personalReadOnly })}
  	        ${serviceField("Suburb", "Suburb", getDeep(details, ["address", "suburb"], ""), "text", { disabled: personalReadOnly })}
  	        ${serviceField("City", "City / town", getDeep(details, ["address", "city"], ""), "text", { disabled: personalReadOnly })}
  	        ${serviceField("Province", "Province", getDeep(details, ["address", "province"], ""), "text", { disabled: personalReadOnly })}
  	        ${serviceField("PostalCode", "Postal code", getDeep(details, ["address", "postal_code"], ""), "text", { disabled: personalReadOnly })}
  	        ${serviceField("NextKinName", "Next of kin", [getDeep(details, ["next_of_kin", "first_name"], ""), getDeep(details, ["next_of_kin", "last_name"], "")].filter(Boolean).join(" "), "text", { disabled: personalReadOnly })}
  	        ${serviceField("NextKinPhone", "Next-of-kin phone", getDeep(details, ["next_of_kin", "phone_number"], ""), "tel", { disabled: personalReadOnly })}
  	        ${serviceField("NextKinRelationship", "Relationship", getDeep(details, ["next_of_kin", "relationship"], ""), "text", { disabled: personalReadOnly })}
  	      </div>`)}
  	      ${create ? "" : panel("employment", "Employment and operational availability", `<div class="grid">
  	        ${serviceField("Department", "Department", employment.department, "text", { disabled: employmentReadOnly })}
  	        ${serviceField("JobTitle", "Job title", employment.job_title, "text", { disabled: employmentReadOnly })}
  	        ${serviceField("EmploymentStatus", "Employment status", employment.status || "Active", "select", { values: ["Active", "On Leave", "Suspended", "Inactive", "Terminated"], disabled: employmentReadOnly })}
  	        ${serviceField("EmploymentType", "Employment type", employment.employment_type || "Permanent", "select", { values: ["Permanent", "Temporary", "Contract", "Seasonal", "Casual"], disabled: employmentReadOnly })}
  	        ${serviceField("EmploymentStartDate", "Employment start date", employeeDateInput(employment.employment_start_date || employment.start_date), "date", { disabled: employmentReadOnly })}
  	        ${serviceField("HoursPerWeek", "Hours per week", employment.work_hours_per_week, "number", { min: 0, disabled: employmentReadOnly })}
  	      </div>`)}
  	      ${create ? "" : panel("driver", "Driving licence, PrDP, permits and endorsements", driverPanel)}
  	      ${!create && CAN_VIEW_EMPLOYEE_PAYROLL ? panel("payroll", "Payroll and banking — restricted", `<div class="grid">
  	        ${serviceField("BaseSalary", "Base salary / wage", getDeep(existing, ["Data_Wages", "wage_rates", "pay_components", "base_salary", "amount"], 0), "number", { min: 0, disabled: payrollReadOnly })}
  	        ${serviceField("PayFrequency", "Pay frequency", getDeep(existing, ["Data_Wages", "wage_rates", "pay_components", "base_salary", "pay_frequency"], employment.pay_frequency || "Monthly"), "select", { values: ["Weekly", "Fortnightly", "Monthly"], disabled: payrollReadOnly })}
  	        ${serviceField("BankName", "Bank name", getDeep(employment, ["bank_details", "bank_name"], ""), "text", { disabled: payrollReadOnly })}
  	        ${serviceField("BranchCode", "Branch code", getDeep(employment, ["bank_details", "branch_code"], ""), "text", { disabled: payrollReadOnly })}
  	        ${serviceField("AccountNumber", "Account number", getDeep(employment, ["bank_details", "account_number"], ""), "text", { disabled: payrollReadOnly })}
  	      </div>`) : ""}
  	      <input type="hidden" name="ObjectId" value="${escapeAttr(objectIdOf(employee) || "")}">
  	    </form>`;

  	    const canSaveEmployee = create
  	      ? CAN_CREATE_USERS
  	      : CAN_MANAGE_EMPLOYEES && (!targetIsDirector || directorSelf);
  	    const footer = `${employee && CAN_MANAGE_EMPLOYEES && !selfAccessLocked && !targetIsDirector ? `<button type="button" class="fifemp-danger" data-employee-remove-company>Remove from Fleet In Form</button>` : ""}<span style="flex:1"></span><button type="button" data-sp-modal-close>Cancel</button>${canSaveEmployee ? `<button type="button" class="primary" data-employee-save>${create ? "Create Employee" : "Save Employee"}</button>` : ""}`;
  	    const overlay = employeeModalShell(
  	      create ? "New Employee" : employeeName(existing),
  	      create ? "Create the login account and company membership now. Personal, employment, driver and payroll details can be completed after creation." : "Edit the employee record and company memberships without browsing unrelated users.",
  	      body,
  	      footer
  	    );

  	    const form = overlay.querySelector("[data-employee-form]");
  	    employeeRefreshPermissionTree(overlay);

  	    function refreshLicenceEditor(nextCodes) {
  	      const host = overlay.querySelector("[data-employee-code-editor]");
  	      if (!host) return;
  	      const replacement = document.createElement("div");
  	      replacement.innerHTML = employeeLicenceCodeEditorMarkup(nextCodes, driverReadOnly);
  	      const next = replacement.firstElementChild;
  	      host.replaceWith(next);
  	      enhanceAllStyledSelects(next);
  	    }

  	    overlay.addEventListener("click", function (event) {
  	      const addCode = event.target.closest("[data-employee-add-licence]");
  	      if (addCode) {
  	        if (driverReadOnly) return;
  	        const picker = overlay.querySelector("[data-employee-licence-picker]");
  	        const selected = employeeFormArray(form, "LicenceCodes");
  	        if (picker && clean(picker.value)) selected.push(clean(picker.value));
  	        refreshLicenceEditor(employeeNormaliseLicenceCodes(selected));
  	        return;
  	      }

  	      const removeCode = event.target.closest("[data-employee-remove-licence]");
  	      if (removeCode) {
  	        if (driverReadOnly) return;
  	        const remove = removeCode.getAttribute("data-employee-remove-licence");
  	        refreshLicenceEditor(employeeFormArray(form, "LicenceCodes").filter(function (code) {
  	          return code !== remove;
  	        }));
  	        return;
  	      }

  	      const addRecord = event.target.closest("[data-employee-add-record]");
  	      if (addRecord) {
  	        if (driverReadOnly) return;
  	        const type = addRecord.getAttribute("data-employee-add-record");
  	        const list = overlay.querySelector(type === "permit" ? "[data-employee-permit-list]" : "[data-employee-endorsement-list]");
  	        if (!list) return;
  	        list.querySelector(".fifemp-record-empty")?.remove();
  	        const key = type + "-new-" + Date.now();
  	        const wrapper = document.createElement("div");
  	        wrapper.innerHTML = type === "permit"
  	          ? employeePermitRowMarkup(employeePermitCanonical({}, -1), false, key)
  	          : employeeEndorsementRowMarkup(employeeEndorsementCanonical({}, -1), false, key);
  	        const row = wrapper.firstElementChild;
  	        list.appendChild(row);
  	        enhanceAllStyledSelects(row);
  	        return;
  	      }

  	      const removeRecord = event.target.closest("[data-employee-remove-record]");
  	      if (removeRecord) {
  	        if (driverReadOnly) return;
  	        const row = removeRecord.closest("[data-employee-permit-row],[data-employee-endorsement-row]");
  	        const list = row && row.parentElement;
  	        row?.remove();
  	        if (list && !list.children.length) {
  	          list.innerHTML = `<div class="fifemp-record-empty">No records captured.</div>`;
  	        }
  	      }
  	    });

  	    overlay.addEventListener("change", async function (event) {
  	      const permissionInput = event.target.closest('input[name="Apps"],input[name="OfficeAccess"],input[name="SettingsAccess"]');

  	      if (permissionInput) {
  	        if (permissionInput.name === "Apps" && permissionInput.value === "Office" && !permissionInput.checked) {
  	          const childSelected = employeeFormArray(form, "OfficeAccess").length || employeeFormArray(form, "SettingsAccess").length || employeeOfficeSet(existing).length || employeeSettingsSet(existing).length;
  	          if (childSelected) {
  	            const approved = await fifConfirm(
  	              "Removing Office application access will clear the complete Office and Dashboard permission branches, including existing protected selections.",
  	              {
  	                title: "Remove Office Access?",
  	                type: "warning",
  	                confirmText: "Remove and Clear",
  	                cancelText: "Keep Office"
  	              }
  	            );
  	            if (!approved) {
  	              permissionInput.checked = true;
  	              employeeRefreshPermissionTree(overlay);
  	              return;
  	            }
  	            employeeClearPermissionInputs(overlay, "OfficeAccess");
  	            employeeClearPermissionInputs(overlay, "SettingsAccess");
  	            employeeSetHomeValue(overlay, "");
  	          }
  	        }

  	        if (permissionInput.name === "OfficeAccess" && permissionInput.value === "Dash" && !permissionInput.checked) {
  	          const settingsSelected = employeeFormArray(form, "SettingsAccess").length || employeeSettingsSet(existing).length;
  	          if (settingsSelected) {
  	            const approved = await fifConfirm(
  	              "Removing Dash will clear the complete Dashboard Settings branch, including existing protected selections.",
  	              {
  	                title: "Remove Dashboard Access?",
  	                type: "warning",
  	                confirmText: "Remove and Clear",
  	                cancelText: "Keep Dash"
  	              }
  	            );
  	            if (!approved) {
  	              permissionInput.checked = true;
  	              employeeRefreshPermissionTree(overlay);
  	              return;
  	            }
  	            employeeClearPermissionInputs(overlay, "SettingsAccess");
  	          }
  	        }

  	        employeeRefreshPermissionTree(overlay);
  	        if (!create && permissionInput.name === "OfficeAccess" && !permissionReadOnly) {
  	          const office = employeeCheckedPermissionValues(form, "OfficeAccess");
  	          const home = managedPermissionValues(employeeFormValue(form, "Home"), EMPLOYEE_MANAGED_OFFICE)[0] || "";
  	          if (office.length && office.indexOf(home) === -1) await employeePromptOfficeHome(overlay, false);
  	        }
  	        return;
  	      }

  	      const row = event.target.closest("[data-employee-permit-row],[data-employee-endorsement-row]");
  	      if (row) employeeRefreshRecordCard(row);
  	    });

  	    overlay.querySelectorAll("[data-employee-editor-tab]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const key = button.getAttribute("data-employee-editor-tab") || "account";
  	        state.employeeEditorTab = key;
  	        overlay.querySelectorAll("[data-employee-editor-tab]").forEach(function (item) {
  	          item.classList.toggle("active", item === button);
  	        });
  	        overlay.querySelectorAll("[data-employee-panel]").forEach(function (item) {
  	          item.classList.toggle("active", item.getAttribute("data-employee-panel") === key);
  	        });
  	      });
  	    });

  	    overlay.querySelector("[data-employee-save]")?.addEventListener("click", async function () {
  	      if (await employeeEnsureHomeBeforeSave(overlay)) employeeSaveFlow(company, employee, overlay);
  	    });
  	    form?.addEventListener("submit", async function (event) {
  	      event.preventDefault();
  	      if (await employeeEnsureHomeBeforeSave(overlay)) employeeSaveFlow(company, employee, overlay);
  	    });
  	    overlay.querySelector("[data-employee-remove-company]")?.addEventListener("click", function () {
  	      employeeRemoveFromCompany(company, employee);
  	    });
  	  }

  	  function employeeFormArray(form,name){return new FormData(form).getAll(name).map(clean).filter(Boolean);}
  	  function employeeFormValue(form,name){const node=form.elements.namedItem(name);return node?clean(node.value):"";}
  	  function employeeFormChecked(form,name){const node=form.elements.namedItem(name);return !!(node&&node.checked);}

  	  function employeeBuildEssentialCreatePayload(form) {
  	    const firstName = employeeFormValue(form, "FirstName");
  	    const lastName = employeeFormValue(form, "LastName");
  	    const email = lower(employeeFormValue(form, "Email"));
  	    const southAfricanId = clean(employeeFormValue(form, "IdNumber")).replace(/\D/g, "");
  	    const selectedApps = managedPermissionValues(employeeFormArray(form, "Apps"), EMPLOYEE_MANAGED_APPS);
  	    const selectedOffice = managedPermissionValues(employeeFormArray(form, "OfficeAccess"), EMPLOYEE_MANAGED_OFFICE);
  	    const hasOffice = selectedApps.indexOf("Office") !== -1;
  	    const home = hasOffice ? (managedPermissionValues(employeeFormValue(form, "Home"), EMPLOYEE_MANAGED_OFFICE)[0] || "") : "";
  	    const payload = {
  	      objectId: southAfricanId,
  	      ownerId: southAfricanId,
  	      ID: southAfricanId,
  	      name: [firstName, lastName].filter(Boolean).join(" ").trim(),
  	      email: email,
  	      Role: "Employee",
  	      userStatus: "ENABLED",
  	      APP: selectedApps.join(","),
  	      Office: hasOffice ? selectedOffice.join(",") : "",
  	      Settings: "",
  	      Local_Key: employeeGenerateLocalKey(),
  	      Data_Details: {
  	        employee_details: {
  	          first_name: firstName,
  	          last_name: lastName,
  	          id_number: southAfricanId,
  	          account_type: "Employee",
  	          operational_roles: [],
  	          contact_details: { email: email, phone_number: "" }
  	        }
  	      }
  	    };
  	    if (hasOffice) payload.Home = home;
  	    return {
  	      payload: payload,
  	      password: employeeFormValue(form, "Password"),
  	      passwordConfirm: employeeFormValue(form, "ConfirmPassword"),
  	      passwordResetAllowed: false,
  	      companyIds: employeeFormArray(form, "CompanyIds")
  	    };
  	  }

  	  function employeeBuildPayload(form, existing) {
  	    const create = !employeeDatabaseObjectId(existing);
  	    if (create) return employeeBuildEssentialCreatePayload(form);
  	    const payload = employeeCanonical(existing || {});
  	    const details = payload.Data_Details.employee_details;
  	    const employment = details.employment_details;
  	    const licence = details.drivers_license;
  	    const existingPermits = cloneData(licence.permits || []);
  	    const existingEndorsements = cloneData(licence.endorsements || []);
  	    const selfAccessLocked = !create && employeeSelfAccessLocked(existing);
  	    const targetIsDirector = !create && employeeIsDirector(existing);
  	    const directorSelf = targetIsDirector && employeeIsCurrentUser(existing);

  	    details.first_name = employeeFormValue(form, "FirstName");
  	    details.last_name = employeeFormValue(form, "LastName");
  	    details.employee_id = employeeFormValue(form, "EmployeeId");
  	    details.id_number = employeeFormValue(form, "IdNumber");
  	    details.contact_details = details.contact_details || {};
  	    details.contact_details.phone_number = employeeFormValue(form, "Phone");
  	    details.date_of_birth = employeeFormValue(form, "DateOfBirth");
  	    details.gender = employeeFormValue(form, "Gender");
  	    details.nationality = employeeFormValue(form, "Nationality");
  	    details.marital_status = employeeFormValue(form, "MaritalStatus");

  	    details.address = details.address || {};
  	    details.address.street = employeeFormValue(form, "Street");
  	    details.address.suburb = employeeFormValue(form, "Suburb");
  	    details.address.city = employeeFormValue(form, "City");
  	    details.address.province = employeeFormValue(form, "Province");
  	    details.address.postal_code = employeeFormValue(form, "PostalCode");

  	    const kinName = employeeFormValue(form, "NextKinName").split(/\s+/);
  	    details.next_of_kin = details.next_of_kin || {};
  	    details.next_of_kin.first_name = kinName.shift() || "";
  	    details.next_of_kin.last_name = kinName.join(" ");
  	    details.next_of_kin.phone_number = employeeFormValue(form, "NextKinPhone");
  	    details.next_of_kin.relationship = employeeFormValue(form, "NextKinRelationship");

  	    employment.department = employeeFormValue(form, "Department");
  	    employment.job_title = employeeFormValue(form, "JobTitle");
  	    employment.status = employeeFormValue(form, "EmploymentStatus") || "Active";
  	    employment.employment_type = employeeFormValue(form, "EmploymentType") || "Permanent";
  	    employment.employment_start_date = employeeFormValue(form, "EmploymentStartDate");
  	    employment.start_date = employment.employment_start_date;
  	    employment.work_hours_per_week = employeeFormValue(form, "HoursPerWeek");

  	    licence.enabled = employeeFormChecked(form, "DriverEnabled");
  	    licence.license_codes = employeeNormaliseLicenceCodes(employeeFormArray(form, "LicenceCodes"));
  	    licence.licence_codes = cloneData(licence.license_codes);
  	    licence.license_code = employeePrimaryLicenceCode(licence.license_codes, licence.license_code);
  	    licence.licence_code = licence.license_code;
  	    licence.license_number = employeeFormValue(form, "LicenceNumber");
  	    licence.licence_number = licence.license_number;
  	    licence.issue_date = employeeFormValue(form, "LicenceIssueDate");
  	    licence.expiry_date = employeeFormValue(form, "LicenceExpiryDate");
  	    licence.permits = employeeCollectPermits(form, existingPermits);
  	    licence.endorsements = employeeCollectEndorsements(form, existingEndorsements);

  	    const categories = employeeNormalisePrDPCategories(employeeFormArray(form, "PrDPCategories"));
  	    const prdp = {
  	      prdp_number: employeeFormValue(form, "PrDPNumber"),
  	      pdp_number: employeeFormValue(form, "PrDPNumber"),
  	      expiry_date: employeeFormValue(form, "PrDPExpiry"),
  	      categories: categories,
  	      category: categories
  	    };
  	    licence.prdp = cloneData(prdp);
  	    licence.pdp = cloneData(prdp);

  	    payload.Role = targetIsDirector ? "Director" : "Employee";

  	    if (targetIsDirector) {
  	      const protectedDetails = employeeDetails(existing);
  	      details.first_name = protectedDetails.first_name;
  	      details.last_name = protectedDetails.last_name;
  	      details.employee_id = protectedDetails.employee_id;
  	      details.id_number = protectedDetails.id_number;
  	      details.contact_details = details.contact_details || {};
  	      details.contact_details.email = getDeep(protectedDetails, ["contact_details", "email"], existing.email || "");
  	      details.contact_details.phone_number = getDeep(protectedDetails, ["contact_details", "phone_number"], "");
  	      details.employment_details = cloneData(employeeEmployment(existing));
  	      payload.email = lower(existing.email || details.contact_details.email);
  	      payload.userStatus = employeeNormaliseUserStatus(existing.userStatus);
  	      payload.APP = existing.APP;
  	      payload.Office = existing.Office;
  	      payload.Settings = existing.Settings;
  	      payload.Home = existing.Home;
  	      payload.Data_Wages = cloneData(existing.Data_Wages || employeeDefaultWages());
  	    } else if (CAN_MANAGE_EMPLOYEE_ACCESS) {
  	      payload.email = lower(employeeFormValue(form, "Email"));
  	      details.contact_details.email = payload.email;

  	      if (selfAccessLocked) {
  	        payload.userStatus = employeeNormaliseUserStatus(existing.userStatus);
  	        payload.APP = existing.APP;
  	        payload.Office = existing.Office;
  	        payload.Settings = existing.Settings;
  	        payload.Home = existing.Home;
  	      } else {
  	        payload.userStatus = employeeNormaliseUserStatus(employeeFormValue(form, "UserStatus"));
  	        const permissionTree = employeeBuildPermissionTree(form, existing || payload);
  	        payload.APP = permissionTree.APP;
  	        payload.Office = permissionTree.Office;
  	        payload.Settings = permissionTree.Settings;
  	        payload.Home = permissionTree.Home;
  	      }
  	      delete payload.loginEnabled;
  	      delete payload.mustChangePassword;
  	    }

  	    if (CAN_VIEW_EMPLOYEE_PAYROLL && !targetIsDirector) {
  	      payload.Data_Wages = employeeMerge(employeeDefaultWages(), payload.Data_Wages || {});
  	      payload.Data_Wages.wage_rates.employee_id = details.employee_id;
  	      payload.Data_Wages.wage_rates.pay_components.base_salary.amount = numberOr(employeeFormValue(form, "BaseSalary"), 0);
  	      payload.Data_Wages.wage_rates.pay_components.base_salary.pay_frequency = employeeFormValue(form, "PayFrequency") || "Monthly";
  	      employment.pay_frequency = payload.Data_Wages.wage_rates.pay_components.base_salary.pay_frequency;
  	      employment.bank_details = employment.bank_details || {};
  	      employment.bank_details.bank_name = employeeFormValue(form, "BankName");
  	      employment.bank_details.branch_code = employeeFormValue(form, "BranchCode");
  	      employment.bank_details.account_number = employeeFormValue(form, "AccountNumber");
  	    }

  	    payload.name = [details.first_name, details.last_name].filter(Boolean).join(" ").trim();

  	    const southAfricanId = clean(details.id_number).replace(/\D/g, "");
  	    details.id_number = southAfricanId;
  	    if (southAfricanId) {
  	      const existingObjectId = employeeDatabaseObjectId(existing);
  	      if (existingObjectId && existingObjectId !== southAfricanId) {
  	        throw new Error("The South African ID cannot be changed because it is the employee's permanent Users objectId.");
  	      }
  	      payload.objectId = southAfricanId;
  	      payload.ownerId = southAfricanId;
  	      payload.ID = southAfricanId;
  	    }

  	    details.audit = arr(details.audit);
  	    details.audit.push({
  	      At: new Date().toISOString(),
  	      By: userDisplayName(),
  	      Action: existing && employeeDatabaseObjectId(existing) ? "Employee updated" : "Employee created"
  	    });

  	    return {
  	      payload: payload,
  	      password: employeeFormValue(form, "Password"),
  	      passwordConfirm: employeeFormValue(form, "ConfirmPassword"),
  	      passwordResetAllowed: !create && !targetIsDirector && userCanResetEmployeePassword(existing),
  	      companyIds: targetIsDirector
  	        ? uniqueStrings(employeeCompanyIds(existing).concat([state.selectedCompanyKey]).filter(Boolean))
  	        : employeeFormArray(form, "CompanyIds")
  	    };
  	  }

  	  function employeeValidate(data, create, currentCompanyId) {
  	    const payload = data.payload;
  	    const details = employeeDetails(payload);
  	    const employment = employeeEmployment(payload);
  	    const licence = employeeDriver(payload);
  	    const errors = [];

  	    if (!clean(details.first_name)) errors.push("First name is required.");
  	    if (!clean(details.last_name)) errors.push("Last name is required.");
  	    if (!clean(payload.name)) errors.push("A user name could not be generated from first and last name.");
  	    if (!payload.email) errors.push("Email is required.");
  	    const southAfricanId = clean(firstValue([details.id_number, payload.ID, payload.objectId], "")).replace(/\D/g, "");
  	    if (!southAfricanId) errors.push("South African ID is required and is used as ID, objectId and ownerId.");
  	    else if (!/^\d{13}$/.test(southAfricanId)) errors.push("South African ID must contain exactly 13 digits.");

  	    const password = String(data.password || "");
  	    const passwordConfirm = String(data.passwordConfirm || "");
  	    if (create || password || passwordConfirm) {
  	      if (password.length < 8) errors.push("A password of at least 8 characters is required.");
  	      if (password !== passwordConfirm) errors.push("Password and Confirm password must match exactly.");
  	    }
  	    if (!create && password && !data.passwordResetAllowed) errors.push("User Management permission is required to change another user's password.");

  	    if (create && !data.companyIds.length) errors.push("A new employee must belong to at least one company before the login can be enabled.");
  	    if (create && data.companyIds.indexOf(currentCompanyId) === -1) errors.push("A new employee must be related to the current company during creation.");

  	    const appPermissions = managedPermissionValues(payload.APP, EMPLOYEE_MANAGED_APPS);
  	    const officePermissions = managedPermissionValues(payload.Office, EMPLOYEE_MANAGED_OFFICE);
  	    const home = managedPermissionValues(payload.Home, EMPLOYEE_MANAGED_OFFICE)[0] || "";
  	    if (!appPermissions.length) errors.push("Select at least one application for the employee login.");
  	    if (appPermissions.indexOf("Office") !== -1) {
  	      if (!officePermissions.length) errors.push("Select at least one Office module when Office application access is assigned.");
  	      else if (!home || officePermissions.indexOf(home) === -1) errors.push("Choose one assigned Office module as the employee's Home screen.");
  	    }
  	    if (create && permissionNormalKey(payload.Role) !== "employee") errors.push("Employee creation must use Role Employee.");
  	    if (create && employeeNormaliseUserStatus(payload.userStatus) !== "ENABLED") errors.push("A new employee login must be enabled.");
  	    if (create && !clean(payload.Local_Key)) errors.push("A unique Local_Key could not be generated for the employee login.");

  	    // Creation deliberately stops here. Rich HR, payroll, employment and driver data is completed after the login exists.
  	    if (create) return uniqueStrings(errors);

  	    if (home && officePermissions.indexOf(home) === -1) errors.push("Home must be one of the user's assigned Office modules.");
  	    if (appPermissions.indexOf("Office") === -1 || !officePermissions.length) payload.Home = "";

  	    const codes = employeeLicenceCodesFromRecord(licence);
  	    if (licence.enabled && (!codes.length || !licence.license_number || !licence.expiry_date)) {
  	      errors.push("Driver-enabled employees require at least one licence authorisation, a licence number and an expiry date.");
  	    }

  	    const prdp = firstValue([licence.prdp, licence.pdp], {}) || {};
  	    if ((prdp.prdp_number || prdp.pdp_number) && !prdp.expiry_date) {
  	      errors.push("A PrDP expiry date is required when a PrDP number is recorded.");
  	    }

  	    arr(licence.permits).forEach(function (item, index) {
  	      const permit = employeePermitCanonical(item, index);
  	      if (!permit.permit_type) errors.push("Each permit record requires a type.");
  	      if (/dangerous|cross-border/i.test(permit.permit_type) && !permit.expiry_date) {
  	        errors.push(permit.permit_type + " requires an expiry or review date.");
  	      }
  	    });

  	    arr(licence.endorsements).forEach(function (item, index) {
  	      const record = employeeEndorsementCanonical(item, index);
  	      if (!record.endorsement_type) errors.push("Each endorsement or training record requires a type.");
  	      if (/dangerous goods training/i.test(record.endorsement_type) && !record.expiry_date) {
  	        errors.push("Dangerous Goods Training requires an expiry or renewal date.");
  	      }
  	    });

  	    return uniqueStrings(errors);
  	  }

  	  function employeeEscapeWhere(value){return String(value||"").replace(/'/g,"\\'");}

  	  function employeeDatabaseObjectId(value) {
  	    return clean(firstValue([
  	      value && value.objectId,
  	      value && value.ObjectId,
  	      value && value.objectID
  	    ], ""));
  	  }

  	  async function employeeFindDatabaseCollision(whereClause) {
  	    const api=await fifWaitForDatabaseApi(900); if(!api||!api.Data||!api.DataQueryBuilder||!api.DataQueryBuilder.create)return null;
  	    const builder=api.DataQueryBuilder.create(); builder.setWhereClause(whereClause); builder.setPageSize(1);
  	    const rows=await employeeWithTimeout(api.Data.of("Users").find(builder), 12000, "Checking Users uniqueness"); return arr(rows)[0]||null;
  	  }
  	  async function employeeFindExistingByIdentity(southAfricanId) {
  	    const identity = clean(southAfricanId).replace(/\D/g, "");
  	    if (!/^\d{13}$/.test(identity)) return null;

  	    // Prefer already-loaded data because it may already contain rich Employee data.
  	    const loaded = allLoadedEmployees().find(function (row) {
  	      const details = employeeDetails(row);
  	      const rowIdentity = clean(firstValue([
  	        details.id_number,
  	        row && row.ID,
  	        employeeDatabaseObjectId(row)
  	      ], "")).replace(/\D/g, "");
  	      return rowIdentity === identity;
  	    });
  	    if (loaded) return cloneData(loaded);

  	    try {
  	      return await employeeFindDatabaseCollision(
  	        "objectId = '" + employeeEscapeWhere(identity) + "'"
  	      );
  	    } catch (_) {
  	      return null;
  	    }
  	  }

  	  async function employeeAssertUnique(payload, existingId) {
  	    // The SA ID is the only unique Employee identity. During NEW Employee flow an
  	    // existing matching ID is not an error: employeeSaveFlow reuses that Users
  	    // record and creates only the missing Company relation. This function therefore
  	    // protects only edits that somehow attempt to collide with another identity.
  	    const details = employeeDetails(payload);
  	    const strictExistingId = clean(existingId);
  	    const southAfricanId = clean(firstValue([
  	      details.id_number,
  	      payload.ID,
  	      payload.objectId
  	    ], "")).replace(/\D/g, "");
  	    const errors = [];

  	    if (!southAfricanId || !strictExistingId) return errors;
  	    const row = await employeeFindExistingByIdentity(southAfricanId);
  	    if (row && employeeDatabaseObjectId(row) !== strictExistingId) {
  	      errors.push("South African ID already belongs to another user.");
  	    }
  	    return errors;
  	  }


  	  async function employeeSaveUserRecord(payload,password,create) {
  	    refreshCurrentUserPermissions(false);
  	    fifRequirePermission(CAN_ACCESS_USERS && CAN_MANAGE_EMPLOYEES, "User Management is not assigned.");
  	    if (create) fifRequirePermission(CAN_CREATE_USERS, "Only a Director who is assigned the Users function may create login users.");

  	    const api=await fifWaitForDatabaseApi(1500);
  	    if(!api||!api.Data||!api.Data.of)throw new Error("The database is unavailable. The employee record was not saved.");

  	    const cleanPayload=cloneData(payload);
  	    delete cleanPayload.password;
  	    delete cleanPayload.Companies;

  	    const southAfricanId=clean(cleanPayload.objectId || cleanPayload.ownerId || employeeDetails(cleanPayload).id_number).replace(/\D/g, "");
  	    if(!/^\d{13}$/.test(southAfricanId)) {
  	      throw new Error("A valid 13-digit South African ID is required before the Users record can be saved.");
  	    }

  	    cleanPayload.objectId=southAfricanId;
  	    cleanPayload.ownerId=southAfricanId;
  	    cleanPayload.ID=southAfricanId;
  	    cleanPayload.userStatus=create ? "ENABLED" : employeeNormaliseUserStatus(cleanPayload.userStatus);
  	    const cleanApps = managedPermissionValues(cleanPayload.APP, FIF_APP_PERMISSION_OPTIONS);
  	    const cleanOffice = managedPermissionValues(cleanPayload.Office, FIF_OFFICE_PERMISSION_OPTIONS);
  	    const cleanSettings = managedPermissionValues(cleanPayload.Settings, FIF_DASH_PERMISSION_OPTIONS);
  	    const cleanHome = managedPermissionValues(cleanPayload.Home, FIF_OFFICE_PERMISSION_OPTIONS)[0] || "";
  	    if (!cleanApps.length) throw new Error("At least one application is required for a successful employee login.");
  	    cleanPayload.APP = cleanApps.join(",");
  	    cleanPayload.Office = cleanApps.indexOf("Office") !== -1 ? cleanOffice.join(",") : "";
  	    cleanPayload.Settings = cleanApps.indexOf("Office") !== -1 && cleanOffice.indexOf("Dash") !== -1 ? cleanSettings.join(",") : "";
  	    if (cleanApps.indexOf("Office") !== -1) {
  	      if (!cleanOffice.length) throw new Error("Select at least one Office module when Office application access is assigned.");
  	      if (!cleanHome || cleanOffice.indexOf(cleanHome) === -1) throw new Error("Choose one assigned Office module as the user's Home screen.");
  	      cleanPayload.Home = cleanHome;
  	    } else if (create) {
  	      // Backendless Home has value validation enabled. Do not send an empty string through registration.
  	      delete cleanPayload.Home;
  	    } else {
  	      // NULL clears a previous Home without violating the Multiple Choice validator.
  	      cleanPayload.Home = null;
  	    }
  	    cleanPayload.Local_Key = clean(cleanPayload.Local_Key) || employeeGenerateLocalKey();
  	    delete cleanPayload.username;
  	    delete cleanPayload.login;
  	    delete cleanPayload.identity;
  	    delete cleanPayload.loginEnabled;
  	    delete cleanPayload.mustChangePassword;
  	    cleanPayload.Role = create ? "Employee" : (permissionNormalKey(cleanPayload.Role) === "director" ? "Director" : "Employee");
  	    if (cleanPayload.Data_Details && cleanPayload.Data_Details.employee_details) {
  	      cleanPayload.Data_Details.employee_details.account_type = cleanPayload.Role;
  	      cleanPayload.Data_Details.employee_details.operational_roles = uniqueStrings(arr(cleanPayload.Data_Details.employee_details.operational_roles));
  	    }

  	    if (create) {
  	      if (!api.UserService || typeof api.User !== "function" || typeof api.UserService.register !== "function") {
  	        throw new Error("Login-user registration is unavailable in the current database session.");
  	      }
  	      const accountPassword = String(password || "");
  	      if (accountPassword.length < 8) throw new Error("A password of at least 8 characters is required.");

  	      const user = new api.User();
  	      Object.keys(cleanPayload).forEach(function (key) {
  	        if (typeof user.setProperty === "function") user.setProperty(key, cleanPayload[key]);
  	        else user[key] = cleanPayload[key];
  	      });
  	      if (typeof user.setProperty === "function") user.setProperty("password", accountPassword);
  	      user.password = accountPassword;

  	      let registered;
  	      try {
  	        registered = await api.UserService.register(user);
  	      } catch (error) {
  	        console.error("[FIF Employees] User registration rejected", error);
  	        const registrationMessage = clean(error && (error.message || error.faultString || error.details || error.statusText || error.code));
  	        throw new Error(registrationMessage || "The database rejected the employee login registration.");
  	      }
  	      const saved = employeeCanonical(Object.assign({}, cleanPayload, registered || {}));
  	      const returnedObjectId = employeeDatabaseObjectId(saved);
  	      const returnedOwnerId = clean(saved && saved.ownerId);
  	      const returnedId = clean(saved && saved.ID);

  	      if (returnedObjectId !== southAfricanId) {
  	        throw new Error("The Users record was not created with the South African ID as objectId. Expected " + southAfricanId + " but received " + (returnedObjectId || "no objectId") + ".");
  	      }
  	      if (returnedOwnerId !== southAfricanId) {
  	        throw new Error("The Users record was not created with the South African ID as ownerId. Expected " + southAfricanId + " but received " + (returnedOwnerId || "no ownerId") + ".");
  	      }
  	      if (returnedId !== southAfricanId) {
  	        throw new Error("The Users record was not created with the South African ID as ID. Expected " + southAfricanId + " but received " + (returnedId || "no ID") + ".");
  	      }
  	      return saved;
  	    }

  	    const updated = employeeCanonical(Object.assign({}, cleanPayload, await api.Data.of("Users").save(cleanPayload)));
  	    if (employeeDatabaseObjectId(updated) !== southAfricanId || clean(updated.ownerId) !== southAfricanId || clean(updated.ID) !== southAfricanId) {
  	      throw new Error("The Users record must retain objectId, ownerId and ID equal to the employee's South African ID.");
  	    }
  	    return updated;
  	  }

  	  async function employeeChangePassword(employee, newPassword) {
  	    refreshCurrentUserPermissions(false);
  	    fifRequirePermission(CAN_RESET_EMPLOYEE_PASSWORDS, "Only a Director who is assigned the Users function may change another user's password.");
  	    fifRequirePermission(employee && !employeeIsCurrentUser(employee), "You cannot change your own password from User Management.");

  	    const targetId = employeeDatabaseObjectId(employee);
  	    const secret = String(newPassword || "");
  	    if (!targetId) throw new Error("The target user has no Database objectId.");
  	    if (secret.length < 8) throw new Error("A password of at least 8 characters is required.");

  	    const api = await fifWaitForDatabaseApi(1500);
  	    if (!api) throw new Error("The Database is unavailable while changing the password.");

  	    try {
  	      let result;
  	      if (api.APIServices && typeof api.APIServices.invoke === "function") {
  	        try {
  	          result = await api.APIServices.invoke(FIF_USER_ADMIN_SERVICE, FIF_USER_ADMIN_PASSWORD_METHOD, targetId, secret);
  	        } catch (positionalError) {
  	          result = await api.APIServices.invoke(FIF_USER_ADMIN_SERVICE, FIF_USER_ADMIN_PASSWORD_METHOD, {
  	            userId: targetId,
  	            newPassword: secret
  	          });
  	        }
  	      } else if (api.CustomServices && typeof api.CustomServices.invoke === "function") {
  	        result = await api.CustomServices.invoke(FIF_USER_ADMIN_SERVICE, FIF_USER_ADMIN_PASSWORD_METHOD, {
  	          userId: targetId,
  	          newPassword: secret
  	        });
  	      } else {
  	        throw new Error("The secure " + FIF_USER_ADMIN_SERVICE + "." + FIF_USER_ADMIN_PASSWORD_METHOD + " server service is unavailable.");
  	      }

  	      if (result === false || (result && result.ok === false)) {
  	        throw new Error(clean(result && (result.message || result.error)) || "The password service rejected the change.");
  	      }
  	      return true;
  	    } catch (error) {
  	      const message = clean(error && (error.message || error.faultString || error.details));
  	      throw new Error("The password was not changed. " + (message || "The secure password service failed."));
  	    }
  	  }

  	  function employeeRelationRows(company,userId,shouldInclude,saved) {
  	    const rows=companyEmployees(company).filter(function(row){return objectIdOf(row)!==userId;}); if(shouldInclude)rows.push(saved); return rows;
  	  }
  	  function employeeApplyCompanyRows(company, rows) {
  	    fifCompanyAliases(company).forEach(function (alias) {
  	      const existing = arr(alias.Employees);
  	      const next = arr(rows).map(function (row) {
  	        const id = objectIdOf(row);
  	        const match = existing.find(function (item) {
  	          return id && objectIdOf(item) === id;
  	        });
  	        if (match) {
  	          fifMergeAppDataMutable(match, row);
  	          return match;
  	        }
  	        return row;
  	      });
  	      alias.Employees = next;
  	    });
  	  }

  	  function employeeSameIdentity(left, right) {
  	    const leftId = employeeDatabaseObjectId(left);
  	    const rightId = employeeDatabaseObjectId(right);
  	    if (leftId && rightId) return leftId === rightId;
  	    const leftEmail = lower(firstValue([left && left.email, getDeep(left, ["Data_Details", "employee_details", "contact_details", "email"], "")], ""));
  	    const rightEmail = lower(firstValue([right && right.email, getDeep(right, ["Data_Details", "employee_details", "contact_details", "email"], "")], ""));
  	    return !!leftEmail && leftEmail === rightEmail;
  	  }

  	  function employeeReconcileSavedUserAppData(saved) {
  	    if (!objectIdOf(saved) && !clean(saved && saved.email)) return saved;

  	    const reconcileList = function (owner, key, upsert) {
  	      if (!owner || !Array.isArray(owner[key])) return;
  	      let found = false;
  	      owner[key] = owner[key].map(function (item) {
  	        if (!employeeSameIdentity(item, saved)) return item;
  	        found = true;
  	        fifMergeAppDataMutable(item, saved);
  	        return item;
  	      });
  	      if (upsert && !found) owner[key].push(saved);
  	    };

  	    reconcileList(APP_DATA, "Users", true);
  	    reconcileList(APP_DATA, "Employees", true);
  	    COMPANY_LIST.forEach(function (company) {
  	      fifCompanyAliases(company).forEach(function (alias) {
  	        reconcileList(alias, "Employees", false);
  	        reconcileList(alias, "Users", false);
  	      });
  	    });
  	    arr(APP_DATA.User && APP_DATA.User.Companies).forEach(function (company) {
  	      fifCompanyAliases(company).forEach(function (alias) {
  	        reconcileList(alias, "Employees", false);
  	        reconcileList(alias, "Users", false);
  	      });
  	    });

  	    if (employeeSameIdentity(APP_DATA.User, saved)) {
  	      fifMergeAppDataMutable(APP_DATA.User, saved);
  	      CURRENT_USER = APP_DATA.User;
  	    }
  	    return saved;
  	  }
  	  async function employeeWriteMembership(parentTable, parentId, relation, childId, shouldExist) {
  	    if (!parentId || !childId) throw new Error("A Database objectId is missing while synchronising " + parentTable + "." + relation + ".");

  	    const api = await fifWaitForDatabaseApi(1200);
  	    if (!api || !api.Data || !api.Data.of) throw new Error("The Database is unavailable while synchronising " + parentTable + "." + relation + ".");
  	    const store = api.Data.of(parentTable);
  	    const parent = { objectId: parentId };
  	    const child = [{ objectId: childId }];
  	    const qualified = v21QualifiedRelationName(parentTable, relation);

  	    if (shouldExist) {
  	      if (typeof store.addRelation !== "function") throw new Error("The Database relation API cannot add " + parentTable + "." + relation + ".");
  	      try {
  	        await employeeWithTimeout(store.addRelation(parent, relation, child), 12000, "Adding " + parentTable + "." + relation + " relation");
  	        return true;
  	      } catch (error) {
  	        if (v21RelationAlreadyLinked(error)) return true;
  	        if (!v21RelationColumnMissing(error) || !qualified) {
  	          throw new Error("The " + parentTable + "." + relation + " relationship could not be added. " + v21RelationMessage(error));
  	        }
  	      }
  	      try {
  	        await employeeWithTimeout(store.addRelation(parent, qualified, child), 12000, "Adding " + parentTable + "." + relation + " relation");
  	        return true;
  	      } catch (error) {
  	        if (v21RelationAlreadyLinked(error)) return true;
  	        throw new Error("The " + parentTable + "." + relation + " relationship could not be added or created. " + v21RelationMessage(error));
  	      }
  	    }

  	    if (typeof store.deleteRelation !== "function") throw new Error("The Database relation API cannot remove " + parentTable + "." + relation + ".");
  	    const names = uniqueStrings([relation, qualified].filter(Boolean));
  	    let lastError = null;
  	    for (let i = 0; i < names.length; i += 1) {
  	      try {
  	        await employeeWithTimeout(store.deleteRelation(parent, names[i], child), 12000, "Removing " + parentTable + "." + relation + " relation");
  	        return true;
  	      } catch (error) {
  	        lastError = error;
  	        if (v21RelationAlreadyLinked(error) || /not.+related|relation.+not.+found|does not exist/i.test(v21RelationMessage(error))) return true;
  	        if (v21RelationColumnMissing(error)) return true;
  	      }
  	    }
  	    throw new Error("The " + parentTable + "." + relation + " relationship could not be removed. " + v21RelationMessage(lastError));
  	  }

  	  async function employeeLoadRelationIds(parentTable, parentId, relation) {
  	    const api = await fifWaitForDatabaseApi(1200);
  	    if (!api || !api.Data || !api.Data.of) return null;
  	    const store = api.Data.of(parentTable);
  	    if (typeof store.loadRelations !== "function") return null;
  	    let builder = null;
  	    if (api.DataQueryBuilder && api.DataQueryBuilder.create) {
  	      builder = api.DataQueryBuilder.create();
  	      if (typeof builder.setPageSize === "function") builder.setPageSize(100);
  	    }
  	    try {
  	      const parent = { objectId: parentId };
  	      const request = builder
  	        ? store.loadRelations(parent, relation, builder)
  	        : store.loadRelations(parent, relation);
  	      const rows = await employeeWithTimeout(request, 12000, "Loading " + parentTable + "." + relation + " relations");
  	      const list = Array.isArray(rows) ? rows : arr(rows && rows.data);
  	      return list.map(employeeDatabaseObjectId).filter(Boolean);
  	    } catch (error) {

  	      return null;
  	    }
  	  }

  	  async function employeeVerifyUserCompanyMemberships(userId, expectedCompanies, removedCompanyIds) {
  	    const expectedIds = expectedCompanies.map(employeeDatabaseObjectId).filter(Boolean);
  	    const removedIds = uniqueStrings(arr(removedCompanyIds).filter(Boolean));
  	    const userCompanyIds = await employeeLoadRelationIds("Users", userId, "Companies");
  	    if (userCompanyIds) {
  	      const missingUserLinks = expectedCompanies.filter(function (company) {
  	        return userCompanyIds.indexOf(employeeDatabaseObjectId(company)) === -1;
  	      });
  	      const extraUserLinks = userCompanyIds.filter(function (companyId) {
  	        return expectedIds.indexOf(companyId) === -1;
  	      });
  	      if (missingUserLinks.length) {
  	        throw new Error("Users.Companies verification failed for: " + missingUserLinks.map(companyName).join(", ") + ".");
  	      }
  	      if (extraUserLinks.length) {
  	        throw new Error("Users.Companies still contains Company links that should have been removed.");
  	      }
  	    }

  	    for (let i = 0; i < expectedCompanies.length; i += 1) {
  	      const company = expectedCompanies[i];
  	      const companyId = employeeDatabaseObjectId(company);
  	      const employeeIds = await employeeLoadRelationIds("Companies", companyId, "Employees");
  	      if (employeeIds && employeeIds.indexOf(userId) === -1) {
  	        throw new Error("Companies.Employees verification failed for " + companyName(company) + ".");
  	      }
  	    }

  	    for (let i = 0; i < removedIds.length; i += 1) {
  	      const companyId = removedIds[i];
  	      const employeeIds = await employeeLoadRelationIds("Companies", companyId, "Employees");
  	      if (employeeIds && employeeIds.indexOf(userId) !== -1) {
  	        throw new Error("Companies.Employees still contains the Employee after the Company link was removed.");
  	      }
  	    }
  	  }

  	  function employeeCompanyLoginGuard(employee) {
  	    const details = employeeDetails(employee);
  	    if (!details.access_control || typeof details.access_control !== "object" || Array.isArray(details.access_control)) {
  	      details.access_control = {};
  	    }
  	    return details.access_control;
  	  }

  	  async function employeeApplyCompanyLoginState(saved, hasCompanies) {
  	    const id = employeeDatabaseObjectId(saved);
  	    if (!id) throw new Error("The Employee login state cannot be updated because the Users record has no objectId.");

  	    const api = await fifWaitForDatabaseApi(1500);
  	    if (!api || !api.Data || !api.Data.of) throw new Error("The database is unavailable while updating Employee login access.");

  	    saved.Data_Details = saved.Data_Details && typeof saved.Data_Details === "object" ? saved.Data_Details : { employee_details: employeeDefaultDetails() };
  	    saved.Data_Details.employee_details = employeeMerge(employeeDefaultDetails(), saved.Data_Details.employee_details || {});
  	    const guard = employeeCompanyLoginGuard(saved);
  	    const currentStatus = employeeNormaliseUserStatus(saved.userStatus);
  	    let nextStatus = currentStatus;
  	    let mustSave = false;

  	    if (!hasCompanies) {
  	      // Company membership is a hard login prerequisite. If the Employee was
  	      // enabled, remember that this disable was automatic so a later re-link may
  	      // restore the previous status. A manually-disabled Employee stays manually
  	      // disabled after re-linking.
  	      if (currentStatus !== "DISABLED") {
  	        guard.company_membership_login_disabled = true;
  	        guard.status_before_company_unlink = currentStatus;
  	        guard.company_membership_login_disabled_at = new Date().toISOString();
  	        mustSave = true;
  	      }
  	      nextStatus = "DISABLED";
  	      if (currentStatus !== nextStatus) mustSave = true;
  	    } else if (guard.company_membership_login_disabled === true) {
  	      nextStatus = employeeNormaliseUserStatus(guard.status_before_company_unlink || "ENABLED");
  	      if (nextStatus === "DISABLED") nextStatus = "ENABLED";
  	      guard.company_membership_login_disabled = false;
  	      guard.company_membership_login_restored_at = new Date().toISOString();
  	      delete guard.status_before_company_unlink;
  	      mustSave = true;
  	    }

  	    saved.userStatus = nextStatus;
  	    if (!mustSave) return saved;

  	    const patch = {
  	      objectId: id,
  	      userStatus: nextStatus,
  	      Data_Details: cloneData(saved.Data_Details)
  	    };
  	    const updated = await employeeWithTimeout(
  	      api.Data.of("Users").save(patch),
  	      12000,
  	      hasCompanies ? "Restoring Employee login after Company link" : "Disabling Employee login without Company membership"
  	    );
  	    Object.assign(saved, updated || patch);
  	    saved.userStatus = nextStatus;
  	    saved.Data_Details = patch.Data_Details;
  	    return saved;
  	  }

  	  async function employeeSyncMemberships(saved, targetCompanyIds, creating) {
  	    const id = employeeDatabaseObjectId(saved);
  	    if (!id) throw new Error("The saved employee has no real Database objectId.");

  	    const desiredKeys = uniqueStrings(targetCompanyIds);
  	    const desiredCompanies = [];
  	    desiredKeys.forEach(function (key) {
  	      const company = COMPANY_LIST.find(function (item, index) {
  	        return companyKey(item, index) === key || employeeDatabaseObjectId(item) === key;
  	      });
  	      if (!company) throw new Error("A selected company could not be resolved: " + key + ".");
  	      if (!employeeDatabaseObjectId(company)) throw new Error(companyName(company) + " has no Database objectId, so its employee relationship cannot be written.");
  	      if (desiredCompanies.indexOf(company) === -1) desiredCompanies.push(company);
  	    });

  	    if (creating && !desiredCompanies.length) {
  	      throw new Error("A new employee must belong to at least one company before the login can be enabled.");
  	    }

  	    const desiredObjectIds = desiredCompanies.map(employeeDatabaseObjectId);
  	    let currentObjectIds = creating ? [] : await employeeLoadRelationIds("Users", id, "Companies");
  	    if (!Array.isArray(currentObjectIds)) {
  	      currentObjectIds = [];
  	      COMPANY_LIST.forEach(function (company) {
  	        if (companyEmployees(company).some(function (row) { return employeeSameIdentity(row, saved); })) {
  	          const companyId = employeeDatabaseObjectId(company);
  	          if (companyId) currentObjectIds.push(companyId);
  	        }
  	      });
  	      arr(saved && saved.Companies).forEach(function (company) {
  	        const companyId = employeeDatabaseObjectId(company);
  	        if (companyId) currentObjectIds.push(companyId);
  	      });
  	      currentObjectIds = uniqueStrings(currentObjectIds);
  	    }

  	    const changed = [];
  	    const removedObjectIds = [];

  	    // Security first: when the final desired Company set is empty, disable the
  	    // login BEFORE removing the last Company relation. A failed relation write can
  	    // therefore never leave an enabled Company-less account.
  	    if (!desiredCompanies.length) {
  	      await employeeApplyCompanyLoginState(saved, false);
  	    }

  	    // ADD only memberships the user actually selected and does not already have.
  	    for (let i = 0; i < desiredCompanies.length; i += 1) {
  	      const company = desiredCompanies[i];
  	      const companyId = employeeDatabaseObjectId(company);
  	      if (currentObjectIds.indexOf(companyId) === -1) {
  	        await employeeWriteMembership("Companies", companyId, "Employees", id, true);
  	        await employeeWriteMembership("Users", id, "Companies", companyId, true);
  	        changed.push({ companyId: companyKey(company, COMPANY_LIST.indexOf(company)), objectId: companyId, added: true });
  	      }
  	      employeeApplyCompanyRows(company, employeeRelationRows(company, id, true, saved));
  	    }

  	    // REMOVE only memberships that really exist and were explicitly deselected.
  	    for (let i = 0; i < currentObjectIds.length; i += 1) {
  	      const companyId = currentObjectIds[i];
  	      if (desiredObjectIds.indexOf(companyId) !== -1) continue;
  	      const company = COMPANY_LIST.find(function (item) { return employeeDatabaseObjectId(item) === companyId; }) || null;
  	      await employeeWriteMembership("Companies", companyId, "Employees", id, false);
  	      await employeeWriteMembership("Users", id, "Companies", companyId, false);
  	      if (company) employeeApplyCompanyRows(company, employeeRelationRows(company, id, false, saved));
  	      removedObjectIds.push(companyId);
  	      changed.push({ companyId: company ? companyKey(company, COMPANY_LIST.indexOf(company)) : companyId, objectId: companyId, added: false });
  	    }

  	    saved.Companies = desiredCompanies;
  	    await employeeVerifyUserCompanyMemberships(id, desiredCompanies, removedObjectIds);

  	    // Re-enable only after a real Company relation exists and verification passed,
  	    // and only when the account was automatically disabled by the no-Company rule.
  	    if (desiredCompanies.length) {
  	      await employeeApplyCompanyLoginState(saved, true);
  	    }

  	    employeeReconcileSavedUserAppData(saved);
  	    if (employeeSameIdentity(APP_DATA.User, saved)) {
  	      refreshCurrentUserPermissions(true);
  	      normalisePermissionNavigation(selectedCompany());
  	      notifyPermissionConsumers();
  	    }
  	    return changed;
  	  }


  	  async function employeeSaveFlow(company, existing, overlay) {
  	    refreshCurrentUserPermissions(false);
  	    if (existing && employeeIsDirector(existing) && !employeeIsCurrentUser(existing)) {
  	      await fifAlert("Director records are protected. Only that Director may update their own Personal and Driver & Permits information.", {
  	        title: "Director Record Locked", type: "warning", confirmText: "Close"
  	      });
  	      return;
  	    }
  	    if (!CAN_ACCESS_USERS || !CAN_MANAGE_EMPLOYEES || (!existing && !CAN_CREATE_USERS)) {
  	      await fifAlert(!existing ? "Only a Director who is assigned the Users function may create or re-link login users." : "User Management is not assigned.", {
  	        title: "User Management Required", type: "warning", confirmText: "Close"
  	      });
  	      return;
  	    }

  	    const form = overlay.querySelector("[data-employee-form]");
  	    if (!form) {
  	      await fifAlert("Employee form is unavailable.", { title: "Employee Save Failed", type: "danger", confirmText: "Close" });
  	      return;
  	    }

  	    const data = employeeBuildPayload(form, existing);
  	    const currentId = companyKey(company, COMPANY_LIST.indexOf(company));
  	    const identity = clean(firstValue([
  	      data.payload && data.payload.ID,
  	      data.payload && data.payload.objectId,
  	      employeeDetails(data.payload).id_number
  	    ], "")).replace(/\D/g, "");

  	    // NEW Employee is identity-first. If that permanent SA ID already exists, the
  	    // existing Users record is recovered and linked; no registration, password
  	    // reset, access overwrite, HR overwrite or payroll overwrite occurs.
  	    if (!existing && /^\d{13}$/.test(identity)) {
  	      fifSuppressProxiedOperationOverlay += 1;
  	      let recovered = null;
  	      try {
  	        recovered = await employeeFindExistingByIdentity(identity);
  	      } finally {
  	        fifSuppressProxiedOperationOverlay = Math.max(0, fifSuppressProxiedOperationOverlay - 1);
  	      }

  	      if (recovered) {
  	        if (employeeIsDirector(recovered)) {
  	          await fifAlert("That South African ID already belongs to a Director account and cannot be re-created as an Employee.", {
  	            title: "Director Identity Found", type: "warning", confirmText: "Close"
  	          });
  	          return;
  	        }
  	        if (!data.companyIds.length) {
  	          await fifAlert("Select at least one Company before re-linking the existing Employee.", {
  	            title: "Company Required", type: "warning", confirmText: "Close"
  	          });
  	          return;
  	        }

  	        const recoveredName = employeeName(recovered) || identity;
  	        const confirmed = await fifConfirm(
  	          "This South African ID already belongs to an existing Employee. Fleet In Form will keep the existing login, password, permissions, HR, payroll, leave and historical data and create only the new Company link.",
  	          {
  	            title: "Existing Employee Found",
  	            type: "info",
  	            confirmText: "Link Existing Employee",
  	            cancelText: "Cancel",
  	            details: [
  	              { label: "Employee", value: recoveredName },
  	              { label: "South African ID", value: identity },
  	              { label: "Existing data", value: "Retained unchanged" }
  	            ]
  	          }
  	        );
  	        if (!confirmed) return;

  	        const operation = fifBeginSaveOperation("Re-linking existing employee…");
  	        fifSuppressProxiedOperationOverlay += 1;
  	        try {
  	          const currentRelations = await employeeLoadRelationIds("Users", employeeDatabaseObjectId(recovered), "Companies");
  	          const targetCompanyIds = uniqueStrings((Array.isArray(currentRelations) ? currentRelations : []).concat(data.companyIds));
  	          const saved = employeeCanonical(recovered);
  	          fifUpdateSaveOperation("Creating Company link and restoring login access…");
  	          await employeeSyncMemberships(saved, targetCompanyIds, false);
  	          state.employeeSearch = "";
  	          state.actionableAlertCache = {};
  	          closeServicePortalModal();
  	          fifCompleteSaveOperation(operation, "Existing Employee linked to Company.");
  	          render();
  	          await fifAlert(
  	            employeeName(saved) + " was found by South African ID and linked without replacing any existing Employee data." +
  	              (employeeNormaliseUserStatus(saved.userStatus) === "ENABLED" ? " Their login is enabled." : " Their login remains disabled by its existing account status."),
  	            { title: "Existing Employee Linked", type: "success", confirmText: "Close" }
  	          );
  	        } catch (error) {
  	          fifFailSaveOperation(operation, error);
  	          await fifAlert(error && error.message ? error.message : "The existing Employee could not be linked.", {
  	            title: "Employee Link Failed", type: "danger", confirmText: "Close"
  	          });
  	        } finally {
  	          fifSuppressProxiedOperationOverlay = Math.max(0, fifSuppressProxiedOperationOverlay - 1);
  	        }
  	        return;
  	      }
  	    }

  	    const operation = fifBeginSaveOperation(existing ? "Saving employee changes…" : "Creating employee and login…");
  	    fifSuppressProxiedOperationOverlay += 1;
  	    let saved = null;
  	    let passwordChanged = false;
  	    try {
  	      const errors = employeeValidate(data, !existing, currentId);
  	      if (errors.length) throw new Error(errors[0]);

  	      const unique = await employeeAssertUnique(data.payload, existing ? employeeDatabaseObjectId(existing) : "");
  	      if (unique.length) throw new Error(unique[0]);

  	      fifUpdateSaveOperation(existing ? "Updating employee record…" : "Registering employee login…");
  	      saved = await employeeSaveUserRecord(data.payload, existing ? "" : data.password, !existing);

  	      if (existing && data.password) {
  	        fifUpdateSaveOperation("Changing employee password…");
  	        await employeeChangePassword(saved, data.password);
  	        passwordChanged = true;
  	      }

  	      fifUpdateSaveOperation("Synchronising company employee relations…");
  	      await employeeSyncMemberships(saved, uniqueStrings(data.companyIds), !existing);
  	      state.employeeSearch = "";
  	      state.actionableAlertCache = {};
  	      closeServicePortalModal();

  	      const hasCompanies = employeeCompanyIds(saved).length > 0;
  	      const completion = existing
  	        ? "Employee and company memberships updated." + (passwordChanged ? " Password changed." : "")
  	        : "Employee created and related to the selected companies.";
  	      fifCompleteSaveOperation(operation, completion);
  	      render();
  	      await fifAlert(
  	        employeeName(saved) + (existing ? " was updated." : " was created.") +
  	          (passwordChanged ? " Their password was changed." : "") +
  	          (hasCompanies
  	            ? " The Employee has Company access."
  	            : " The Employee has no Company links, so their login is disabled while all existing data remains stored."),
  	        { title: existing ? "Employee Updated" : "Employee Created", type: "success", confirmText: "Close" }
  	      );
  	    } catch (error) {
  	      fifFailSaveOperation(operation, error);
  	      if (saved) {
  	        closeServicePortalModal();
  	        render();
  	        await fifAlert(
  	          "The employee record was saved, but the password change or one or more company relationships could not be completed. Reopen the employee and retry the unfinished action.\n\n" +
  	            (error && error.message ? error.message : error),
  	          { title: "Employee Partially Saved", type: "warning", confirmText: "Close" }
  	        );
  	      } else {
  	        await fifAlert(error && error.message ? error.message : "The employee could not be saved.", {
  	          title: "Employee Save Failed", type: "danger", confirmText: "Close"
  	        });
  	      }
  	    } finally {
  	      fifSuppressProxiedOperationOverlay = Math.max(0, fifSuppressProxiedOperationOverlay - 1);
  	    }
  	  }


  	  async function employeeRemoveFromCompany(company, employee) {
  	    refreshCurrentUserPermissions(false);
  	    if (!employee || !CAN_ACCESS_USERS || !CAN_MANAGE_EMPLOYEES) return;
  	    if (employeeIsDirector(employee)) {
  	      await fifAlert("A Director cannot be removed or transferred from this employee workspace.", {
  	        title: "Director Record Locked", type: "warning", confirmText: "Close"
  	      });
  	      return;
  	    }
  	    if (employeeSelfAccessLocked(employee)) {
  	      await fifAlert("You cannot remove your own company memberships from User Management.", {
  	        title: "Self Access Locked", type: "warning", confirmText: "Close"
  	      });
  	      return;
  	    }

  	    const relatedNames = COMPANY_LIST.filter(function (item) {
  	      return companyEmployees(item).some(function (row) {
  	        return objectIdOf(row) === objectIdOf(employee);
  	      });
  	    }).map(companyName);

  	    const confirmed = await fifConfirm(
  	      "Remove " + employeeName(employee) + " from every Company? The complete Users record and all Employee history will be retained, but the login will be automatically disabled because an Employee without a Company may not log in.",
  	      {
  	        title: "Remove from Fleet In Form",
  	        type: "warning",
  	        confirmText: "Unlink from All Companies",
  	        cancelText: "Cancel",
  	        details: [
  	          {
  	            label: "Employee",
  	            value: employeeName(employee)
  	          },
  	          {
  	            label: "Company memberships",
  	            value: relatedNames.length ? relatedNames.join(", ") : "No loaded memberships"
  	          },
  	          {
  	            label: "Users record",
  	            value: "Retained — not deleted"
  	          },
  	          {
  	            label: "Login after unlink",
  	            value: "Automatically disabled until re-linked to a Company"
  	          }
  	        ]
  	      }
  	    );
  	    if (!confirmed) return;

  	    const operation = fifBeginSaveOperation("Removing employee from all company registers…");
  	    fifSuppressProxiedOperationOverlay += 1;
  	    try {
  	      await employeeSyncMemberships(employee, [], false);
  	      closeServicePortalModal();
  	      state.employeeSearch = "";
  	      state.actionableAlertCache = {};
  	      fifCompleteSaveOperation(operation, "Employee unlinked from every Company. Login disabled; Users record retained.");
  	      render();
  	      await fifAlert(
  	        employeeName(employee) + " was removed from every Company. Their Users record and all historical data were retained, and their login was disabled until they are linked to a Company again.",
  	        {
  	          title: "Employee Unlinked",
  	          type: "success",
  	          confirmText: "Close"
  	        }
  	      );
  	    } catch (error) {
  	      fifFailSaveOperation(operation, error);
  	      await fifAlert(
  	        error && error.message ? error.message : "The employee could not be unlinked from every company.",
  	        {
  	          title: "Company Unlink Failed",
  	          type: "danger",
  	          confirmText: "Close"
  	        }
  	      );
  	    } finally {
  	      fifSuppressProxiedOperationOverlay = Math.max(0, fifSuppressProxiedOperationOverlay - 1);
  	    }
  	  }

  	  function employeePrint(company) {
  	    const rows=employeeFiltered(company);const win=window.open("","_blank","noopener,noreferrer");if(!win)return;win.document.write(`<html><head><title>${escapeHtml(companyName(company))} Employees</title><style>body{font-family:Arial;padding:24px;color:#111}h1{margin:0 0 4px}p{color:#555}table{width:100%;border-collapse:collapse;margin-top:18px;font-size:12px}th,td{border:1px solid #bbb;padding:7px;text-align:left}th{background:#eee}</style></head><body><h1>${escapeHtml(companyName(company))} Employees</h1><p>Generated ${escapeHtml(new Date().toLocaleString())}</p><table><thead><tr><th>Employee</th><th>ID</th><th>Department</th><th>Position</th><th>Status</th><th>Licence</th></tr></thead><tbody>${rows.map(function(e){const d=employeeDetails(e),em=employeeEmployment(e),dr=employeeDriverSummary(e);return `<tr><td>${escapeHtml(employeeName(e))}</td><td>${escapeHtml(d.employee_id||d.id_number||"")}</td><td>${escapeHtml(em.department||"")}</td><td>${escapeHtml(em.job_title||"")}</td><td>${escapeHtml(employeeStatus(e))}</td><td>${escapeHtml(dr.codes.join("/")||"")}</td></tr>`;}).join("")}</tbody></table></body></html>`);win.document.close();win.focus();setTimeout(function(){win.print();},180);
  	  }

  	  function bindEmployeeManagerEvents(root, company) {
  	    if(!CAN_ACCESS_USERS||state.activeTab!=="employees"||state.selectedVehicleKey)return;
  	    root.querySelector("[data-employee-new]")?.addEventListener("click",function(){employeeOpenEditor(company,null);});
  	    root.querySelectorAll("[data-employee-open]").forEach(function(button){button.addEventListener("click",function(){const id=button.getAttribute("data-employee-open");const employee=companyEmployees(company).find(function(row){return objectIdOf(row)===id;});if(employee)employeeOpenEditor(company,employee);});});
  	    root.querySelector("[data-employee-print]")?.addEventListener("click",function(){employeePrint(company);});
  	    root.querySelector("[data-employee-search]")?.addEventListener("input",function(event){const caret=event.target.selectionStart;state.employeeSearch=event.target.value;renderDynamicMainOnly();const replacement=document.getElementById(ROOT_ID)?.querySelector("[data-employee-search]");if(replacement){replacement.focus();try{replacement.setSelectionRange(caret,caret);}catch(_){}}});
  	    root.querySelector("[data-employee-status]")?.addEventListener("change",function(event){state.employeeStatusFilter=event.target.value||"all";renderDynamicMainOnly();});
  	    root.querySelector("[data-employee-department]")?.addEventListener("change",function(event){state.employeeDepartmentFilter=event.target.value||"all";renderDynamicMainOnly();});
  	    root.querySelectorAll("[data-employee-sort]").forEach(function(button){button.addEventListener("click",function(){const key=button.getAttribute("data-employee-sort")||"name";if(state.employeeSortKey===key)state.employeeSortDir=state.employeeSortDir==="asc"?"desc":"asc";else{state.employeeSortKey=key;state.employeeSortDir="asc";}renderDynamicMainOnly();});});
  	  }

  	  function renderSidebar(company) {
  	    const vehicleCount = tractors(company).length;
  	    const trailerCount = towedAssets(company).length;
  	    const employeeCount = companyEmployees(company).length;
  	    const tyreCount = tyres(company).length;
  	    const applicationCount = applications(company).length;

  	    const tabs = [
  	      ["vehicles", "Vehicles", vehicleCount],
  	      ["trailers", "Trailers / Implements", trailerCount],
  	      ["employees", "Employees", employeeCount],
  	      ["tyres", "Tyres", tyreCount],
  	      ["applications", "Applications", applicationCount]
  	    ].filter(function (item) {
  	      return userCanAccessMainTab(item[0]);
  	    });

  	    return `
  	    <aside class="fifdash-sidebar">
  	      <div class="fifdash-brand-row">
  	        <div class="fifdash-brand-mark">${brandMarkup()}</div>
  	        <div class="fifdash-brand-copy">
  	          <strong>Fleet In Form</strong>
  	          <span>Operations dashboard</span>
  	        </div>
  	      </div>

  	      <div class="fifdash-company-block">
  	        <label for="fifdash-company-select">Operating company</label>
  	        <div class="fifdash-select-shell">
  	          <select id="fifdash-company-select" data-company-select>
  	            ${COMPANY_LIST.map(function (item, index) {
  	              const key = companyKey(item, index);
  	              return `<option value="${escapeAttr(key)}" ${key === state.selectedCompanyKey ? "selected": ""}>${escapeHtml(companyName(item))}</option>`;
  	            }).join("")}
  	          </select>
  	          <span class="fifdash-select-arrow">⌄</span>
  	        </div>
  	      </div>

  	      <nav class="fifdash-nav" aria-label="Dashboard sections">
  	        ${tabs.map(function (item) {
  	          const active = state.activeTab === item[0];
  	          return `
  	          <button class="fifdash-nav-item ${active ? "active": ""}" type="button" data-tab="${item[0]}">
  	            <span class="fifdash-nav-icon">${ICONS[item[0]]}</span>
  	            <span class="fifdash-nav-label">${escapeHtml(item[1])}</span>
  	            <span class="fifdash-nav-count">${formatCount(item[2])}</span>
  	          </button>`;
  	        }).join("")}
  	      </nav>
  	    </aside>`;
  	  }

  	  function renderHeader(company) {
  	    const periods = historyPeriods(company);
  	    const showVehiclePeriodControls = CAN_ACCESS_VEHICLES && state.activeTab === "vehicles" && !state.selectedVehicleKey;
  	    const periodOptions = state.viewMode === "historical"
  	    ? periods.map(function (period) {
  	      return `<option value="${escapeAttr(period.key)}" ${period.key === state.selectedHistoryKey ? "selected": ""}>${escapeHtml(period.label)}</option>`;
  	    }).join(""): `<option value="current">${escapeHtml(currentPeriodLabel(company))}</option>`;

  	    const contextualHeaderAction = state.selectedVehicleKey
  	    ? `<button class="fifdash-back-to-fleet" type="button" data-vm-back aria-label="Back to ${state.selectedAssetType === "trailer" ? "Implements" : "Fleet"}">${ICONS.chevron}<span>Back to ${state.selectedAssetType === "trailer" ? "Implements" : "Fleet"}</span></button>`: showVehiclePeriodControls
  	    ? `<div class="fifdash-vehicle-period-controls">
  	    <div class="fifdash-view-toggle" role="group" aria-label="Current or historical vehicle data">
  	    <button type="button" data-view-mode="current" class="${state.viewMode === "current" ? "active": ""}">Current</button>
  	    <button type="button" data-view-mode="historical" class="${state.viewMode === "historical" ? "active": ""}">Historical</button>
  	    </div>
  	    <div class="fifdash-period-shell">
  	    <span>Period</span>
  	    <select data-period-select ${state.viewMode === "current" ? "disabled": ""}>
  	    ${periodOptions || `<option value="">No history available</option>`}
  	    </select>
  	    </div>
  	    </div>`: "";

  	    return `
  	    <header class="fifdash-command-header">
  	    <div class="fifdash-title-block">
  	    <div class="fifdash-eyebrow">${escapeHtml(companyName(company))}</div>
  	    <h1>${!CAN_ACCESS_DASHBOARD
  	      ? "Dashboard Access"
  	      : !state.activeTab
  	        ? "No Functions Assigned"
  	        : state.selectedVehicleKey
  	          ? (state.selectedAssetType === "trailer" ? "Implement Manager" : "Vehicle Manager")
  	          : state.activeTab === "vehicles"
  	            ? "Vehicle Operations"
  	            : state.activeTab === "trailers"
  	              ? "Trailers & Implements"
  	              : state.activeTab === "employees"
  	                ? "Employees"
  	                : state.activeTab === "tyres"
  	                  ? "Tyre Warehouse"
  	                  : "Operational Applications"}</h1>
  	    <p>${!CAN_ACCESS_DASHBOARD
  	      ? "Office and Dash access are required before this workspace can be used."
  	      : !state.activeTab
  	        ? "No Dashboard functions have been assigned in the Settings property."
  	        : state.selectedVehicleKey
  	          ? (state.selectedAssetType === "trailer"
  	              ? "Service, maintenance, tyre and compliance control for the selected implement."
  	              : "Complete vehicle interaction, records and tyre operations in one workspace.")
  	          : state.activeTab === "employees"
  	            ? "Maintain the selected company employee relation, operational qualifications and multi-company memberships."
  	            : state.activeTab === "applications"
  	              ? "Company-defined operational applications and their linked assets."
  	              : state.activeTab === "tyres"
  	                ? "Company tyre stock, fitted assets, lifecycle, warnings, work records and reports."
  	                : "A clean operational overview built directly from the selected company data."}</p>
  	    </div>

  	    <div class="fifdash-header-actions">
  	    ${contextualHeaderAction}
  	    </div>
  	    </header>`;
  	  }

  	  function renderSummary(company) {
  	    return `
  	    <section class="fifdash-summary-grid">
  	    ${aggregate(company).map(function (item) {
  	      return `
  	      <article class="fifdash-summary-card tone-${item.tone}">
  	      <div class="fifdash-summary-label">${escapeHtml(item.label)}</div>
  	      <div class="fifdash-summary-value">${escapeHtml(item.value)}</div>
  	      <div class="fifdash-summary-note">${escapeHtml(item.note)}</div>
  	      </article>`;
  	    }).join("")}
  	    </section>`;
  	  }

  	  function renderToolbar(company) {
  	    const kinds = uniqueStrings(towedAssets(company).map(trailerKind));

  	    return `
  	    <section class="fifdash-toolbar">
  	    <div class="fifdash-search-shell">
  	    <span>${ICONS.search}</span>
  	    <input type="search" data-search-input value="${escapeAttr(state.search)}" placeholder="Search ${state.activeTab === "vehicles" ? "vehicles": state.activeTab === "trailers" ? "trailers and implements": state.activeTab === "tyres" ? "tyres": "applications"}...">
  	    </div>

  	    ${state.activeTab === "trailers" ? `
  	    <div class="fifdash-filter-shell">
  	    <span>Asset type</span>
  	    <select data-trailer-type>
  	    <option value="all">All types</option>
  	    ${kinds.map(function (kind) {
  	      const value = lower(kind);
  	      return `<option value="${escapeAttr(value)}" ${value === state.trailerType ? "selected": ""}>${escapeHtml(kind)}</option>`;
  	    }).join("")}
  	    </select>
  	    </div>`: ""}

  	    <div class="fifdash-toolbar-spacer"></div>
  	    ${state.activeTab === "applications" && (state.applicationDirty || state.applicationSaving)
  	      ? `<div class="fifdash-readonly-chip ${state.applicationDirty ? "has-warning": ""}"><span></span>${escapeHtml(applicationStatusLabel())}</div>`
  	      : ""}
  	    </section>`;
  	  }



  	  function cloneData(value) {
  	    try {
  	      return JSON.parse(JSON.stringify(value));
  	    }
  	    catch (_) {
  	      return value && typeof value === "object" ? Object.assign({}, value): value;
  	    }
  	  }

  	  function vehicleStableKey(vehicle, index) {
  	    return clean(firstValue([
  	      vehicle && vehicle.objectId,
  	      vehicle && vehicle.ObjectId,
  	      fifVehicleIdentityValue(vehicle, "FID", ""),
  	      fifVehicleIdentityValue(vehicle, "Registration", ""),
  	      vehicle && vehicle.ID
  	    ], "vehicle-" + Number(index || 0)));
  	  }





  	  function setVehicleMessage(message, isError) {
  	    state.vehicleMessage = clean(fifDatabaseUserText(message));
  	    state.vehicleMessageError = !!isError;
  	  }

  	  function clearVehicleEditorState() {
  	    state.vehicleDataEditMode = false;
  	    state.vehicleDataDraft = null;
  	    state.vehicleDataOriginal = null;
  	    state.vehicleDataEssentialDirty = false;
  	    state.vehicleIdentityEditMode = false;
  	    state.vehicleIdentityDraft = null;
  	    state.vehicleIdentityOriginal = null;
  	    state.vehicleIdentityDirty = false;
  	    state.vehicleDataDirty = false;
  	    state.vehicleDataEssentialOpen = false;
  	    state.vehicleDataIdentityOpen = false;
  	    state.tyreDraft = null;
  	    state.tyreMode = "";
  	    state.tyreSourcePosition = "";
  	    state.tyreSelectedWarehouseId = "";
  	    state.tyreChangedIds = {};
  	    state.tyreObjectDrafts = {};
  	    state.tyreVehicleDraft = null;
  	    state.axleConfigMode = false;
  	    state.tyreOriginalDraft = null;
  	    state.tyreDragSource = null;
  	    state.tyreTapSource = null;
  	    state.tyreDragOverPosition = "";
  	    state.tyreRemovalMeta = {};
  	    state.tyreRemoveRequest = null;
  	    state.tyreOperationOdometer = "";
  	    state.tyreOperationNotes = "";
  	    state.tyreMismatchApprovals = {};
  	    state.tyreDetailsRequest = null;
  	  }

  	  function objectIdOf(value) {
  	    return clean(firstValue([
  	      value && value.objectId,
  	      value && value.ObjectId,
  	      value && value.objectID,
  	      value && value.ID,
  	      value && value.id
  	    ], ""));
  	  }









  	  function userDisplayName() {
  	    return clean(firstValue([
  	      CURRENT_USER.name,
  	      CURRENT_USER.Name,
  	      CURRENT_USER.email,
  	      CURRENT_USER.ID,
  	      "Fleet In Form User"
  	    ], "Fleet In Form User"));
  	  }

  	  function ensureObject(root, path) {
  	    let ref = root;
  	    path.forEach(function (key) {
  	      if (!ref[key] || typeof ref[key] !== "object" || Array.isArray(ref[key])) ref[key] = {};
  	      ref = ref[key];
  	    });
  	    return ref;
  	  }

  	  function ensureArray(root,
  	    path) {
  	    const parent = ensureObject(root,
  	      path.slice(0, -1));
  	    const key = path[path.length - 1];
  	    if (!Array.isArray(parent[key])) parent[key] = [];
  	    return parent[key];
  	  }



  	  function setByPath(root, path, value) {
  	    if (!root || !path.length) return;
  	    let ref = root;
  	    for (let index = 0; index < path.length - 1; index += 1) {
  	      const key = path[index];
  	      if (!ref[key] || typeof ref[key] !== "object") ref[key] = {};
  	      ref = ref[key];
  	    }
  	    ref[path[path.length - 1]] = value;
  	  }





  	  function displayVehicleValue(value) {
  	    value = descriptorValue(value);
  	    if (value === null || value === undefined || value === "") return "Not set";
  	    if (typeof value === "boolean") return value ? "Yes": "No";
  	    if (Array.isArray(value)) return value.length ? value.join(", "): "Not set";
  	    if (typeof value === "object") return "Structured data";
  	    return String(value);
  	  }

  	  function prettyFieldName(value) {
  	    return clean(value).replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, function (letter) {
  	      return letter.toUpperCase();
  	    });
  	  }







  	  function infoTile(label, value, note, tone) {
  	    return `<article class="fifvm-info-tile ${tone ? "tone-" + escapeAttr(tone): ""}"><span>${escapeHtml(label)}</span><strong>${escapeHtml(displayVehicleValue(value))}</strong>${note ? `<small>${escapeHtml(note)}</small>`: ""}</article>`;
  	  }

  	  function managerPanel(title, subtitle, body, actions) {
  	    return `<section class="fifvm-panel"><header><div><h3>${escapeHtml(title)}</h3>${subtitle ? `<p>${escapeHtml(subtitle)}</p>`: ""}</div>${actions || ""}</header><div class="fifvm-panel-body">${body || `<div class="fifvm-empty">No information available.</div>`}</div></section>`;
  	  }

















  	  function tyrePositionSummary(tPositions) {
  	    const positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    const keys = Object.keys(positions);
  	    const assigned = keys.filter(function (key) {
  	      return clean(positions[key] && positions[key].TyreObjectId);
  	    }).length;
  	    return {
  	      TotalAxles: arr(tPositions && tPositions.Axles).filter(function (axle) {
  	        return !axle || axle.Enabled !== false;
  	      }).length,
  	      TotalPositions: keys.length,
  	      AssignedTyres: assigned,
  	      EmptyPositions: keys.length - assigned
  	    };
  	  }

  	  function tyrePositionKey(axleNo, side, index) {
  	    return "A" + Number(axleNo || 0) + clean(side).toUpperCase() + Number(index || 1);
  	  }

  	  function newTyreSlot(key, axle, side, sideCode, tyreIndex, old) {
  	    old = old && typeof old === "object" ? old: {};
  	    const tyreId = clean(old.TyreObjectId);
  	    return {
  	      PositionKey: key,
  	      Axle: Number(axle.Axle || 0),
  	      AxleType: clean(axle.Type) || "Drive",
  	      Side: side,
  	      SideCode: sideCode,
  	      TyreIndex: tyreIndex,
  	      TyresPerSide: Number(axle.TyresPerSide || 1),
  	      WearRate: Number(axle.WearRate === undefined ? 1: axle.WearRate),
  	      TyreObjectId: tyreId,
  	      TyreNumber: old.TyreNumber || "",
  	      SerialNumber: old.SerialNumber || "",
  	      Status: tyreId ? "Fitted": "Empty",
  	      UpdatedAt: old.UpdatedAt || "",
  	      Notes: old.Notes || ""
  	    };
  	  }



  	  function legacyAxlePreset(draft, preset) {
  	    const presets = {
  	      "4x2": [{
  	        Axle: 1,
  	        Type: "Steer",
  	        TyresPerSide: 1,
  	        WearRate: 1,
  	        Enabled: true
  	      },
  	        {
  	          Axle: 2,
  	          Type: "Drive",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        }],
  	      "6x2-tag": [{
  	        Axle: 1,
  	        Type: "Steer",
  	        TyresPerSide: 1,
  	        WearRate: 1,
  	        Enabled: true
  	      },
  	        {
  	          Axle: 2,
  	          Type: "Tag",
  	          TyresPerSide: 1,
  	          WearRate: 0.35,
  	          Enabled: true
  	        },
  	        {
  	          Axle: 3,
  	          Type: "Drive",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        }],
  	      "6x4": [{
  	        Axle: 1,
  	        Type: "Steer",
  	        TyresPerSide: 1,
  	        WearRate: 1,
  	        Enabled: true
  	      },
  	        {
  	          Axle: 2,
  	          Type: "Drive",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	        {
  	          Axle: 3,
  	          Type: "Drive",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        }],
  	      "8x4": [{
  	        Axle: 1,
  	        Type: "Steer",
  	        TyresPerSide: 1,
  	        WearRate: 1,
  	        Enabled: true
  	      },
  	        {
  	          Axle: 2,
  	          Type: "Steer",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	        {
  	          Axle: 3,
  	          Type: "Drive",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	        {
  	          Axle: 4,
  	          Type: "Drive",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        }]
  	    };

  	    draft.Axles = cloneData(presets[preset] || []);
  	    return rebuildTyrePositionsFromAxles(draft);
  	  }

  	  function legacySmallTyreDisplay(company, slot) {
  	    const tyreId = clean(slot && slot.TyreObjectId);
  	    const tyre = tyreId ? workingTyre(company, tyreId): null;
  	    const label = tyre ? tyreDisplayName(tyre): tyreId ? tyreId: "No tyre assigned";

  	    return `<div style="width:100%;padding:7px 8px;border:1px solid #333;border-radius:6px;background:#111;color:#bbb;font-size:12px;min-height:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${escapeHtml(label)}</div>`;
  	  }

  	  function legacyGeneratedPositionGrid(company, draft) {
  	    const keys = sortedTyrePositionKeys(draft);
  	    if (!keys.length) {
  	      return `<div style="color:#777;border:1px dashed #444;border-radius:8px;padding:12px;">No tyre positions generated yet.</div>`;
  	    }

  	    return keys.map(function (key) {
  	      const slot = draft.Positions[key] || {};
  	      return `<div style="background:#181818;border:1px solid #333;border-radius:8px;padding:10px;">
  	      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
  	      <div style="font-weight:700;color:#fff;">${escapeHtml(slot.PositionKey || key)}</div>
  	      <div style="font-size:11px;color:#aaa;">${escapeHtml(slot.AxleType || "")} / ${escapeHtml(slot.Side || "")}</div>
  	      </div>
  	      <div style="font-size:11px;color:#777;margin-bottom:6px;">${slot.AxleType === "Tag" ? "Wear allocation: " + escapeHtml(slot.WearRate): "Position generated from axle layout."}</div>
  	      ${legacySmallTyreDisplay(company, slot)}
  	      </div>`;
  	    }).join("");
  	  }





  	  function sortedTyrePositionKeys(tPositions) {
  	    const positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    return Object.keys(positions).sort(function (a, b) {
  	      const pa = positions[a] || {};
  	      const pb = positions[b] || {};
  	      const aa = Number(pa.Axle || 999);
  	      const ab = Number(pb.Axle || 999);
  	      if (aa !== ab) return aa - ab;
  	      const sideOrder = {
  	        L: 1,
  	        R: 2,
  	        SP: 3
  	      };
  	      const sa = sideOrder[clean(pa.SideCode)] || 9;
  	      const sb = sideOrder[clean(pb.SideCode)] || 9;
  	      if (sa !== sb) return sa - sb;
  	      return Number(pa.TyreIndex || 0) - Number(pb.TyreIndex || 0);
  	    });
  	  }

  	  function tyreObjectId(tyre) {
  	    return clean(firstValue([tyre && tyre.objectId, tyre && tyre.ObjectId, tyre && tyre.id], ""));
  	  }

  	  function tyreNumber(tyre) {
  	    return clean(firstValue([
  	      tyre && tyre.ID,
  	      tyre && tyre.FID,
  	      tyre && tyre.Tyre_Number,
  	      tyre && tyre.TyreNumber,
  	      tyre && tyre.Serial_Number,
  	      tyre && tyre.SerialNumber
  	    ], tyreObjectId(tyre)));
  	  }

  	  function tyreDisplayName(tyre) {
  	    return [
  	      tyreNumber(tyre),
  	      clean(firstValue([tyre && tyre.Make, tyre && tyre.Brand, tyre && tyre.Tyre_Brand], "")),
  	      clean(firstValue([tyre && tyre.Model, tyre && tyre.Pattern], "")),
  	      clean(tyre && tyre.Size)
  	    ].filter(Boolean).join(" · ") || "Tyre";
  	  }

  	  function findCompanyTyre(company,
  	    id) {
  	    const wanted = clean(id);
  	    const list = tyres(company);
  	    for (let index = 0; index < list.length; index += 1) {
  	      if (tyreObjectId(list[index]) === wanted) return list[index];
  	    }
  	    return null;
  	  }

  	  function workingTyre(company, id) {
  	    const wanted = clean(id);
  	    if (!wanted) return null;
  	    if (!state.tyreObjectDrafts[wanted]) {
  	      const live = findCompanyTyre(company, wanted);
  	      if (!live) return null;
  	      state.tyreObjectDrafts[wanted] = cloneData(live);
  	    }
  	    return state.tyreObjectDrafts[wanted];
  	  }

  	  function mergeSavedTyreIntoCompany(company, tyre) {
  	    if (!tyre || !tyreObjectId(tyre)) return null;
  	    const existing = findCompanyTyre(company, tyreObjectId(tyre));
  	    return fifReconcileCompanyCollection(
  	      company,
  	      "Tyres",
  	      existing,
  	      tyre,
  	      tyre,
  	      { pushMissing: true, createMissing: true }
  	    );
  	  }

  	  function fittedTyreIdsAcrossCompany(company) {
  	    const ids = {};
  	    tractors(company).concat(towedAssets(company)).forEach(function (asset) {
  	      const positions = currentTPositions(asset).Positions;
  	      Object.keys(positions).forEach(function (key) {
  	        const id = clean(positions[key] && positions[key].TyreObjectId);
  	        if (id) ids[id] = true;
  	      });
  	    });
  	    return ids;
  	  }

  	  function warehouseTyres(company, selectedAsset) {
  	    const fitted = fittedTyreIdsAcrossCompany(company);
  	    const selectedPositions = state.tyreDraft ? state.tyreDraft.Positions: currentTPositions(selectedAsset).Positions;
  	    Object.keys(selectedPositions || {}).forEach(function (key) {
  	      const id = clean(selectedPositions[key] && selectedPositions[key].TyreObjectId);
  	      if (id) fitted[id] = true;
  	    });

  	    return tyres(company).filter(function (tyre) {
  	      const id = tyreObjectId(tyre);
  	      const status = lower(firstValue([tyre && tyre.Status, tyre && tyre.Current_Status], "all in order"));
  	      const holderType = lower(tyre && tyre.Current_Holder_Type);
  	      const vehicleObjectId = clean(tyre && tyre.Vehicle_ObjectId);
  	      const holderObjectId = clean(tyre && tyre.Current_Holder_ObjectId);
  	      const blocked = ["scrapped",
  	        "stolen",
  	        "sold",
  	        "lost",
  	        "in for retread",
  	        "retread"].indexOf(status) !== -1 || ["retread supplier",
  	        "scrap yard",
  	        "stolen",
  	        "sold",
  	        "lost"].indexOf(holderType) !== -1;
  	      const stillHeldByVehicle = !!vehicleObjectId || (holderType === "vehicle" && !!holderObjectId);
  	      return id && !fitted[id] && !blocked && !stillHeldByVehicle;
  	    });
  	  }

  	  function tyreBySlot(company,
  	    slot) {
  	    return slot && slot.TyreObjectId ? workingTyre(company,
  	      slot.TyreObjectId): null;
  	  }

  	  function writeVehicleTPositions(vehicle,
  	    tPositions) {
  	    const cleaned = cloneData(tPositions);
  	    cleaned.SchemaVersion = cleaned.SchemaVersion || "T3.0";
  	    cleaned.VehicleType = assetIsTrailer(vehicle) ? "Trailer" : (cleaned.VehicleType || "Tractor");
  	    cleaned.UpdatedAt = new Date().toISOString();
  	    cleaned.UpdatedBy = userDisplayName();
  	    cleaned.Summary = tyrePositionSummary(cleaned);
  	    vehicle.TPositions = cleaned;
  	    if (Object.prototype.hasOwnProperty.call(vehicle, "TyrePositions")) vehicle.TyrePositions = cleaned;
  	    vehicle.Tyres = Object.keys(cleaned.Positions).map(function (key) {
  	      return workingTyre(selectedCompany(), cleaned.Positions[key].TyreObjectId);
  	    }).filter(Boolean);
  	  }





  	  function vehiclePermissionNotice(required, description) {
  	    if (required) return "";
  	    return `<div class="fifvm-access-note"><strong>Read-only access</strong><span>${escapeHtml(description)}</span></div>`;
  	  }



  	  const VEHICLE_MANAGER_TABS = [{
  	    key: "overview",
  	    label: "Overview"
  	  },
  	    {
  	      key: "physical",
  	      label: "Vehicle Data"
  	    },
  	    {
  	      key: "service",
  	      label: "Service"
  	    },
  	    {
  	      key: "maintenance",
  	      label: "Maintenance"
  	    },
  	    {
  	      key: "tyres",
  	      label: "Tyres"
  	    },
  	    {
  	      key: "compliance",
  	      label: "Compliance"
  	    }];



  	  function renderVehicleMessage() {
  	    if (!state.vehicleMessage) return "";
  	    return `<div class="fifvm-message ${state.vehicleMessageError ? "error": "success"}">${escapeHtml(state.vehicleMessage)}</div>`;
  	  }







  	  function renderVehicleService(company, vehicle) {
  	    return renderVehicleServiceWorkspace(company, vehicle);
  	  }



  	  function tyreSlotHtml(company, key, slot) {
  	    const tyre = tyreBySlot(company, slot);
  	    const selected = state.tyreSourcePosition === key;
  	    const empty = !tyre;
  	    const axleType = clean(slot && slot.AxleType) || "Tyre";
  	    return `<button type="button" class="fifvm-tyre-slot ${empty ? "empty": "fitted"} ${selected ? "selected": ""}" data-vm-tyre-slot="${escapeAttr(key)}" ${!CAN_MANAGE_WORKSHOP ? "disabled": ""}>
  	    <span class="fifvm-tyre-wheel"><i></i></span>
  	    <strong>${escapeHtml(key)}</strong>
  	    <small>${escapeHtml(tyre ? tyreNumber(tyre): "Empty")}</small>
  	    <em>${escapeHtml(axleType)}</em>
  	    </button>`;
  	  }



  	  function legacyTyreLife(tyre) {
  	    const direct = numberValue(firstValue([
  	      tyre && tyre.Current_Life,
  	      tyre && tyre.Life_Percentage,
  	      tyre && tyre.LifePercentage
  	    ], null));
  	    if (direct !== null) return Math.max(0, Math.min(100, direct));

  	    const current = numberValue(firstValue([tyre && tyre.Current_Mileage, tyre && tyre.CurrentMileage], null));
  	    const expected = numberValue(firstValue([tyre && tyre.Expected_Mileage, tyre && tyre.ExpectedMileage], null));
  	    if (current !== null && expected !== null && expected > 0) {
  	      return Math.max(0, Math.min(100, 100 - ((current / expected) * 100)));
  	    }
  	    return null;
  	  }

  	  function legacyTyreWearColor(tyre) {
  	    const life = legacyTyreLife(tyre);
  	    if (life === null) return "#6b7280";
  	    if (life <= 0) return "#111827";
  	    if (life < 20) return "#ff2b1a";
  	    if (life < 40) return "#ff8a00";
  	    if (life < 60) return "#ffd633";
  	    if (life < 80) return "#a6ff33";
  	    return "#39ff14";
  	  }

  	  function legacyTyreTreadHtml(color, selected, dropReady) {
  	    return `<div style="width:100%;height:34px;border-radius:4px;background:${escapeAttr(color)};border:${selected ? "2px solid #ffffff": dropReady ? "2px solid #CC6633": "1px solid rgba(0,0,0,0.85)"};box-shadow:inset 0 0 0 1px rgba(255,255,255,0.18),0 1px 2px rgba(0,0,0,0.45);background-image:repeating-linear-gradient(135deg,rgba(0,0,0,0.72) 0px,rgba(0,0,0,0.72) 3px,transparent 3px,transparent 7px),repeating-linear-gradient(45deg,rgba(0,0,0,0.55) 0px,rgba(0,0,0,0.55) 2px,transparent 2px,transparent 6px);"></div>`;
  	  }

  	  function legacyTyreSlotHtml(company, slot) {
  	    const key = clean(slot && slot.PositionKey);
  	    const tyre = tyreBySlot(company, slot);
  	    const fitted = !!clean(slot && slot.TyreObjectId);
  	    const tapSelected = !!(state.tyreTapSource && state.tyreTapSource.SourceType === "fitted" && state.tyreTapSource.SourcePosition === key);
  	    const selected = tapSelected || state.tyreSourcePosition === key;
  	    const dragOver = state.tyreDragOverPosition === key;
  	    const dropReady = !!state.tyreMode && (state.tyreMode === "allocate" || state.tyreMode === "rotate");
  	    const canDrag = CAN_MANAGE_WORKSHOP && fitted && (state.tyreMode === "allocate" || state.tyreMode === "rotate");
  	    const color = tyre ? legacyTyreWearColor(tyre): fitted ? "#6b7280": "#263044";
  	    const label = tyre ? tyreDisplayName(tyre): fitted ? slot.TyreObjectId: "Empty";
  	    const life = tyre ? legacyTyreLife(tyre): null;
  	    const title = key + " • " + label + " • " + (life === null ? "No data": life.toFixed(1) + "%") + (canDrag ? " • Drag to move / swap": "");
  	    const selectedStyle = selected
  	    ? "background:rgba(204,102,51,0.22);outline:3px solid #CC6633;box-shadow:0 0 0 2px rgba(255,255,255,0.18),0 0 18px rgba(204,102,51,0.7);": dragOver
  	    ? "background:rgba(204,102,51,0.18);outline:3px solid rgba(204,102,51,0.88);box-shadow:0 0 20px rgba(204,102,51,0.58);transform:scale(1.025);": "background:transparent;outline:1px solid transparent;box-shadow:none;";

  	    return `<button type="button" data-vm-tyre-slot="${escapeAttr(key)}" data-vm-position-key="${escapeAttr(key)}" data-vm-fitted-tyre="${escapeAttr(fitted ? slot.TyreObjectId: "")}" draggable="${canDrag ? "true": "false"}" title="${escapeAttr(title)}" style="display:block;width:100%;border:0;cursor:${canDrag ? "grab": CAN_MANAGE_WORKSHOP ? "pointer": "default"};padding:5px;border-radius:8px;transition:background .12s,outline .12s,box-shadow .12s,transform .12s,opacity .12s;${selectedStyle}">
  	    ${legacyTyreTreadHtml(color, selected, dropReady)}
  	    <div style="margin-top:4px;color:${selected ? "#fff": "#9ca3af"};font-size:10px;font-weight:${selected ? "900": "600"};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;">${escapeHtml(key)}</div>
  	    </button>`;
  	  }

  	  function legacyWearLegend() {
  	    const items = [
  	      ["80-100%",
  	        "#39ff14"],
  	      ["60-79%",
  	        "#a6ff33"],
  	      ["40-59%",
  	        "#ffd633"],
  	      ["20-39%",
  	        "#ff8a00"],
  	      ["1-19%",
  	        "#ff2b1a"],
  	      ["0%",
  	        "#111827"],
  	      ["No data",
  	        "#6b7280"]
  	    ];
  	    return `<div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:10px;">${items.map(function (item) {
  	      return `<div style="display:flex;align-items:center;gap:5px;color:#aaa;font-size:11px;"><div style="width:22px;height:12px;border-radius:3px;background:${item[1]};border:1px solid rgba(0,0,0,0.8);"></div>${item[0]}</div>`;
  	    }).join("")}</div>`;
  	  }

  	  function legacySlotsForAxle(tPositions, axleNo, sideCode) {
  	    const positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    return Object.keys(positions).map(function (key) {
  	      const slot = Object.assign({}, positions[key]);
  	      slot.PositionKey = slot.PositionKey || key;
  	      return slot;
  	    }).filter(function (slot) {
  	      return Number(slot.Axle || 0) === Number(axleNo) && clean(slot.SideCode).toUpperCase() === clean(sideCode).toUpperCase();
  	    }).sort(function (a, b) {
  	      return Number(a.TyreIndex || 0) - Number(b.TyreIndex || 0);
  	    });
  	  }

  	  function legacyAxleVisualHtml(company, tPositions, axle) {
  	    const leftSlots = legacySlotsForAxle(tPositions, axle.Axle, "L");
  	    const rightSlots = legacySlotsForAxle(tPositions, axle.Axle, "R");
  	    return `<div style="width:190px;min-height:370px;background:#253044;border-left:6px solid #6b7280;border-right:6px solid #6b7280;position:relative;box-shadow:0 0 0 1px rgba(255,255,255,0.04);display:flex;flex-direction:column;justify-content:space-between;padding:10px 8px;">
  	    <div style="position:absolute;top:8px;left:8px;right:8px;display:flex;gap:5px;flex-direction:column;">${leftSlots.length ? leftSlots.map(function (slot) {
  	      return legacyTyreSlotHtml(company, slot);
  	    }).join(""): `<div style="height:38px;color:#64748b;font-size:11px;text-align:center;">No left tyres</div>`}</div>
  	    <div style="position:absolute;top:50%;left:0;right:0;transform:translateY(-50%);text-align:center;color:#cbd5e1;font-size:12px;font-weight:800;opacity:0.75;">A${escapeHtml(axle.Axle)}<br><span style="font-size:10px;font-weight:600;">${escapeHtml(axle.Type)}</span>${axle.Type === "Tag" ? `<br><span style="font-size:10px;color:#facc15;">Wear ${escapeHtml(axle.WearRate)}</span>`: ""}</div>
  	    <div style="position:absolute;bottom:8px;left:8px;right:8px;display:flex;gap:5px;flex-direction:column;">${rightSlots.length ? rightSlots.map(function (slot) {
  	      return legacyTyreSlotHtml(company, slot);
  	    }).join(""): `<div style="height:38px;color:#64748b;font-size:11px;text-align:center;">No right tyres</div>`}</div>
  	    </div>`;
  	  }

  	  function legacySpareSlots(tPositions) {
  	    const positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    return Object.keys(positions).map(function (key) {
  	      const slot = Object.assign({}, positions[key]);
  	      slot.PositionKey = slot.PositionKey || key;
  	      return slot;
  	    }).filter(function (slot) {
  	      return clean(slot.SideCode).toUpperCase() === "SP" || clean(slot.PositionKey).indexOf("SP") === 0;
  	    });
  	  }

  	  function legacySelectedTyreDetail(company, tPositions) {
  	    const key = state.tyreSourcePosition;
  	    const slot = key && tPositions.Positions ? tPositions.Positions[key]: null;
  	    const tyre = slot ? tyreBySlot(company, slot): null;
  	    const life = tyre ? legacyTyreLife(tyre): null;

  	    if (!slot) {
  	      return `<div style="border:1px solid #333;border-radius:8px;background:#101010;padding:12px;color:#777;font-size:13px;">Tap a tyre position, or choose an operation first.</div>`;
  	    }

  	    return `<div style="border:1px solid #333;border-radius:8px;background:#101010;overflow:hidden;margin-bottom:10px;">
  	    <div style="padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;">Selected Position</div>
  	    <div style="padding:12px;">
  	    <div style="margin-bottom:10px;">${legacyTyreTreadHtml(tyre ? legacyTyreWearColor(tyre): clean(slot.TyreObjectId) ? "#6b7280": "#263044", true, false)}</div>
  	    <div style="display:grid;grid-template-columns:130px 1fr;gap:6px 10px;font-size:12px;">
  	    <div style="color:#888;">Position</div><div style="color:#fff;font-weight:700;">${escapeHtml(slot.PositionKey || key)}</div>
  	    <div style="color:#888;">Axle Type</div><div style="color:#fff;">${escapeHtml(slot.AxleType || "")}</div>
  	    <div style="color:#888;">Wear Rate</div><div style="color:#fff;">${escapeHtml(slot.WearRate == null ? "": slot.WearRate)}</div>
  	    <div style="color:#888;">Tyre</div><div style="color:#fff;">${escapeHtml(tyre ? tyreDisplayName(tyre): clean(slot.TyreObjectId) ? slot.TyreObjectId: "Empty")}</div>
  	    <div style="color:#888;">Current Life</div><div style="color:#fff;">${escapeHtml(life == null ? "": life.toFixed(1) + "%")}</div>
  	    </div>
  	    ${tyre ? `<div style="display:flex;gap:7px;margin-top:12px;"><button type="button" class="fifvm-btn ghost" data-vm-open-tyre-details="${escapeAttr(tyreObjectId(tyre))}" data-vm-tyre-position="${escapeAttr(slot.PositionKey || key)}">Full Tyre Data</button><button type="button" class="fifvm-btn ghost" data-vm-print-tyre="${escapeAttr(tyreObjectId(tyre))}" data-vm-tyre-position="${escapeAttr(slot.PositionKey || key)}">Print Tyre</button></div>`: ""}
  	    </div>
  	    </div>`;
  	  }

  	  function legacyTyreLayout(company, tPositions) {
  	    const normalAxles = arr(tPositions.Axles).filter(function (axle) {
  	      return axle && axle.Type !== "Spare";
  	    });
  	    const spares = legacySpareSlots(tPositions);
  	    return `<div style="overflow-x:auto;border:1px solid #252525;border-radius:8px;background:#0b0f18;padding:12px;">
  	    ${legacyWearLegend()}
  	    <div style="display:flex;gap:14px;align-items:stretch;min-height:390px;">${normalAxles.length ? normalAxles.map(function (axle) {
  	      return legacyAxleVisualHtml(company, tPositions, axle);
  	    }).join(""): `<div style="color:#777;border:1px dashed #444;border-radius:8px;padding:12px;">No axle configuration found. Use Configure Axles to create the layout.</div>`}</div>
  	    ${spares.length ? `<div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:12px;padding-top:12px;border-top:1px solid #252525;">${spares.map(function (slot) {
  	      return `<div style="border:1px solid #3b3b3b;background:#1f2937;border-radius:9px;padding:9px;min-width:180px;"><div style="color:#CC6633;font-size:12px;font-weight:800;margin-bottom:7px;">${escapeHtml(slot.PositionKey)}</div>${legacyTyreSlotHtml(company, slot)}</div>`;
  	    }).join("")}</div>`: ""}
  	    </div>`;
  	  }

  	  function warehouseTyreCard(tyre) {
  	    const id = tyreObjectId(tyre);
  	    const displayTyre = workingTyre(selectedCompany(), id) || tyre;
  	    const selected = state.tyreSelectedWarehouseId === id || !!(state.tyreTapSource && state.tyreTapSource.SourceType === "warehouse" && state.tyreTapSource.TyreObjectId === id);
  	    tyre = displayTyre;
  	    const draggable = CAN_MANAGE_WORKSHOP && state.tyreMode === "allocate";
  	    return `<button type="button" class="fifvm-warehouse-tyre ${selected ? "selected": ""}" data-vm-warehouse-tyre="${escapeAttr(id)}" draggable="${draggable ? "true": "false"}" title="${escapeAttr(draggable ? "Drag onto any vehicle tyre position": "Enable Allocate mode to fit this tyre")}"><span class="fifvm-warehouse-wheel"></span><div><strong>${escapeHtml(tyreNumber(tyre))}</strong><small>${escapeHtml(tyreDisplayName(tyre))}</small><em>${escapeHtml(clean(firstValue([tyre && tyre.Type, tyre && tyre.Tyre_Type], "No type")))}</em></div><span class="fifvm-drag-grip">⋮⋮</span></button>`;
  	  }

  	  function tyrePlanHasAxleChanges(vehicle) {
  	    const original = state.tyreOriginalDraft || currentTPositions(vehicle);
  	    const finalDraft = state.tyreDraft || currentTPositions(vehicle);
  	    const originalShape = {
  	      Axles: original.Axles || [],
  	      Positions: Object.keys(original.Positions || {}).sort()
  	    };
  	    const finalShape = {
  	      Axles: finalDraft.Axles || [],
  	      Positions: Object.keys(finalDraft.Positions || {}).sort()
  	    };
  	    return JSON.stringify(originalShape) !== JSON.stringify(finalShape);
  	  }

  	  function findSlotByTyreId(tPositions, tyreId) {
  	    const wanted = clean(tyreId);
  	    const positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    const keys = Object.keys(positions);
  	    for (let index = 0; index < keys.length; index += 1) {
  	      const slot = positions[keys[index]];
  	      if (clean(slot && slot.TyreObjectId) === wanted) {
  	        const result = cloneData(slot);
  	        result.PositionKey = result.PositionKey || keys[index];
  	        return result;
  	      }
  	    }
  	    return null;
  	  }

  	  function tyrePlanRows(company, vehicle) {
  	    const original = state.tyreOriginalDraft || currentTPositions(vehicle);
  	    const finalDraft = state.tyreDraft || currentTPositions(vehicle);
  	    const ids = {};
  	    Object.keys(original.Positions || {}).forEach(function (key) {
  	      const id = clean(original.Positions[key] && original.Positions[key].TyreObjectId);
  	      if (id) ids[id] = true;
  	    });
  	    Object.keys(finalDraft.Positions || {}).forEach(function (key) {
  	      const id = clean(finalDraft.Positions[key] && finalDraft.Positions[key].TyreObjectId);
  	      if (id) ids[id] = true;
  	    });

  	    return Object.keys(ids).map(function (id) {
  	      const before = findSlotByTyreId(original, id);
  	      const after = findSlotByTyreId(finalDraft, id);
  	      if (before && after && clean(before.PositionKey) === clean(after.PositionKey)) return null;
  	      const tyre = workingTyre(company, id) || findCompanyTyre(company, id);
  	      if (!before && after) {
  	        return {
  	          Type: "Installed",
  	          TyreObjectId: id,
  	          Tyre: tyre,
  	          From: "Warehouse",
  	          To: after.PositionKey,
  	          Before: null,
  	          After: after
  	        };
  	      }
  	      if (before && !after) {
  	        const meta = state.tyreRemovalMeta[id] || {};
  	        return {
  	          Type: "Removed",
  	          TyreObjectId: id,
  	          Tyre: tyre,
  	          From: before.PositionKey,
  	          To: meta.destination || "Warehouse",
  	          Before: before,
  	          After: null,
  	          Meta: meta
  	        };
  	      }
  	      if (before && after) {
  	        return {
  	          Type: "Rotation",
  	          TyreObjectId: id,
  	          Tyre: tyre,
  	          From: before.PositionKey,
  	          To: after.PositionKey,
  	          Before: before,
  	          After: after
  	        };
  	      }
  	      return null;
  	    }).filter(Boolean).sort(function (a, b) {
  	      return clean(a.From).localeCompare(clean(b.From));
  	    });
  	  }

  	  function parseStructuredValue(raw,
  	    fallback) {
  	    if (raw === null || raw === undefined || raw === "") return cloneData(fallback);
  	    if (typeof raw === "object") return cloneData(raw);
  	    try {
  	      return JSON.parse(raw);
  	    } catch (_) {
  	      return cloneData(fallback);
  	    }
  	  }

  	  function tyreMake(tyre) {
  	    return clean(firstValue([tyre && tyre.Make, tyre && tyre.Brand, tyre && tyre.Tyre_Brand, tyre && tyre.Manufacturer], ""));
  	  }
  	  function tyreModel(tyre) {
  	    return clean(firstValue([tyre && tyre.Model, tyre && tyre.Pattern], ""));
  	  }
  	  function tyreSize(tyre) {
  	    return clean(firstValue([tyre && tyre.Size, tyre && tyre.Tyre_Size, tyre && tyre.TyreSize], ""));
  	  }
  	  function tyreTypeValue(tyre) {
  	    return clean(firstValue([tyre && tyre.Type, tyre && tyre.Tyre_Type], ""));
  	  }
  	  function tyreStage(tyre) {
  	    return clean(firstValue([tyre && tyre.Current_Stage, tyre && tyre.Stage, tyre && tyre.State], "New"));
  	  }
  	  function tyreStatus(tyre) {
  	    return clean(firstValue([tyre && tyre.Status, tyre && tyre.Current_Status], "All In Order"));
  	  }

  	  function tyreLifeCycle(tyre) {
  	    return parseStructuredValue(tyre && tyre.LifeCycle, {});
  	  }

  	  function tyreHistory(tyre) {
  	    return parseStructuredValue(tyre && tyre.History, {});
  	  }

  	  function tyreExpectedMileage(tyre) {
  	    const direct = numberValue(firstValue([tyre && tyre.Expected_Mileage, tyre && tyre.Mileage_Expected, tyre && tyre.ExpectedMileage], null));
  	    if (direct !== null) return direct;
  	    const current = tyreLifeCycle(tyre).Current || {};
  	    return numberValue(firstValue([current.ExpectedMileage, current.MileageExpected, current.Mileage_Expected], null));
  	  }

  	  function tyreCurrentMileage(tyre) {
  	    const direct = numberValue(firstValue([tyre && tyre.Current_Mileage, tyre && tyre.Mileage_Current, tyre && tyre.CurrentMileage], null));
  	    if (direct !== null) return direct;
  	    const current = tyreLifeCycle(tyre).Current || {};
  	    return numberValue(firstValue([current.CurrentMileage, current.MileageCurrent, current.Mileage_Current], null));
  	  }

  	  function tyreFullLife(tyre) {
  	    const direct = numberValue(firstValue([tyre && tyre.Current_Life, tyre && tyre.Life_Percentage, tyre && tyre.LifePercentage, tyre && tyre.Life_Remaining], null));
  	    if (direct !== null) return Math.max(0, Math.min(100, direct));
  	    const current = tyreCurrentMileage(tyre);
  	    const expected = tyreExpectedMileage(tyre);
  	    if (current !== null && expected !== null && expected > 0) return Math.max(0, Math.min(100, 100 - ((current / expected) * 100)));
  	    return null;
  	  }

  	  function formatTyreDate(value) {
  	    if (value === null || value === undefined || value === "") return "";
  	    const date = new Date(value);
  	    if (Number.isNaN(date.getTime())) return clean(value);
  	    return date.toLocaleString();
  	  }

  	  function tyreScalarEntries(tyre) {
  	    if (!tyre || typeof tyre !== "object") return [];
  	    const excluded = {
  	      History: true,
  	      LifeCycle: true,
  	      Tyres: true,
  	      ___class: true,
  	      objectId: true,
  	      ownerId: true,
  	      created: true,
  	      updated: true
  	    };
  	    const priority = [
  	      "ID",
  	      "FID",
  	      "Tyre_Number",
  	      "TyreNumber",
  	      "Serial_Number",
  	      "SerialNumber",
  	      "Make",
  	      "Brand",
  	      "Tyre_Brand",
  	      "Model",
  	      "Pattern",
  	      "Size",
  	      "Type",
  	      "Tyre_Type",
  	      "Current_Stage",
  	      "Status",
  	      "Current_Life",
  	      "Expected_Mileage",
  	      "Current_Mileage",
  	      "Total_Mileage",
  	      "Total_Cost",
  	      "Total_CPK",
  	      "Purchase_Price",
  	      "Current_Position",
  	      "Current_Axle_Type",
  	      "Current_Wear_Rate",
  	      "Vehicle_ID",
  	      "Vehicle_ObjectId",
  	      "Current_Holder_Type",
  	      "Current_Holder_ObjectId",
  	      "Fitted_Date",
  	      "Fitted_Odometer",
  	      "Last_Vehicle_Odometer",
  	      "Last_Inspection_Date",
  	      "Last_Tread_Depth"
  	    ];
  	    const keys = Object.keys(tyre).filter(function (key) {
  	      if (excluded[key] || key.indexOf("___") === 0) return false;
  	      const value = tyre[key];
  	      return value === null || value === undefined || ["string",
  	        "number",
  	        "boolean"].indexOf(typeof value) !== -1;
  	    });
  	    keys.sort(function (a, b) {
  	      const ai = priority.indexOf(a);
  	      const bi = priority.indexOf(b);
  	      if (ai !== -1 || bi !== -1) return (ai === -1 ? 9999: ai) - (bi === -1 ? 9999: bi);
  	      return prettyFieldName(a).localeCompare(prettyFieldName(b));
  	    });
  	    return keys.map(function (key) {
  	      return {
  	        key: key,
  	        label: prettyFieldName(key),
  	        value: tyre[key]
  	      };
  	    });
  	  }

  	  function tyreHistoryEvents(tyre) {
  	    const history = tyreHistory(tyre);
  	    const lifeCycle = tyreLifeCycle(tyre);
  	    const events = [];
  	    ["New", "Cap1", "Cap2", "Cap3"].forEach(function (stageName) {
  	      const stage = history && history[stageName] ? history[stageName]: null;
  	      arr(stage && stage.Events).forEach(function (event) {
  	        const copy = cloneData(event);
  	        copy.__stage = stageName;
  	        events.push(copy);
  	      });
  	      const lifeStage = lifeCycle && lifeCycle[stageName] ? lifeCycle[stageName]: null;
  	      arr(lifeStage && lifeStage.Events).forEach(function (event) {
  	        const exists = events.some(function (existing) {
  	          return String(existing.Date || "") === String(event.Date || "") && String(existing.Type || "") === String(event.Type || "") && String(existing.FromPosition || "") === String(event.FromPosition || "") && String(existing.ToPosition || "") === String(event.ToPosition || "");
  	        });
  	        if (!exists) {
  	          const copy = cloneData(event);
  	          copy.__stage = stageName;
  	          events.push(copy);
  	        }
  	      });
  	    });
  	    arr(lifeCycle && lifeCycle.Events).forEach(function (event) {
  	      const exists = events.some(function (existing) {
  	        return String(existing.Date || "") === String(event.Date || "") && String(existing.Type || "") === String(event.Type || "") && String(existing.FromPosition || "") === String(event.FromPosition || "") && String(existing.ToPosition || "") === String(event.ToPosition || "");
  	      });
  	      if (!exists) events.push(cloneData(event));
  	    });
  	    return events.sort(function (a, b) {
  	      return (new Date(b.Date || 0).getTime() || 0) - (new Date(a.Date || 0).getTime() || 0);
  	    });
  	  }

  	  function tyreDataLinesHtml(tyre) {
  	    const entries = tyreScalarEntries(tyre);
  	    if (!entries.length) return `<div class="fifvm-empty">No tyre data fields are available.</div>`;
  	    return `<div class="fifvm-tyre-data-lines">${entries.map(function (entry) {
  	      let value = entry.value;
  	      if (value === null || value === undefined || value === "") value = "Not set";
  	      else if (typeof value === "boolean") value = value ? "Yes": "No";
  	      return `<div class="fifvm-detail-line"><span>${escapeHtml(entry.label)}</span><strong>${escapeHtml(value)}</strong></div>`;
  	    }).join("")}</div>`;
  	  }

  	  function tyreStageCardsHtml(tyre) {
  	    const history = tyreHistory(tyre);
  	    const lifeCycle = tyreLifeCycle(tyre);
  	    return `<div class="fifvm-stage-grid">${["New", "Cap1", "Cap2", "Cap3"].map(function (stageName) {
  	      const stage = Object.assign({}, lifeCycle[stageName] || {}, history[stageName] || {});
  	      const active = !!stage.Active || lower(tyreStage(tyre)) === lower(stageName);
  	      return `<article class="fifvm-stage-card ${active ? "active": ""}"><header><strong>${escapeHtml(stageName)}</strong><span>${active ? "Current / Active": escapeHtml(stage.Status || "Inactive")}</span></header>
  	      <div><span>Started</span><strong>${escapeHtml(formatTyreDate(stage.Started) || "—")}</strong></div>
  	      <div><span>Ended</span><strong>${escapeHtml(formatTyreDate(stage.Ended) || "—")}</strong></div>
  	      <div><span>Mileage Done</span><strong>${escapeHtml(firstValue([stage.Mileage_Done, stage.MileageDone], "—"))}</strong></div>
  	      <div><span>Expected</span><strong>${escapeHtml(firstValue([stage.Mileage_Expected, stage.MileageExpected], "—"))}</strong></div>
  	      <div><span>Cost</span><strong>${escapeHtml(firstValue([stage.Cost], "—"))}</strong></div>
  	      <div><span>CPK</span><strong>${escapeHtml(firstValue([stage.CPK], "—"))}</strong></div>
  	      ${clean(stage.Notes) ? `<p>${escapeHtml(stage.Notes)}</p>`: ""}
  	      </article>`;
  	    }).join("")}</div>`;
  	  }

  	  function tyreHistoryHtml(tyre) {
  	    const events = tyreHistoryEvents(tyre);
  	    if (!events.length) return `<div class="fifvm-empty">No tyre history events were found.</div>`;
  	    return `<div class="fifvm-history-list">${events.map(function (event) {
  	      return `<article class="fifvm-history-event"><div class="fifvm-history-dot"></div><div><header><strong>${escapeHtml(event.Type || "Event")}</strong><span>${escapeHtml(event.__stage || "")}</span><time>${escapeHtml(formatTyreDate(event.Date) || "No date")}</time></header><div class="fifvm-history-meta">
  	      ${clean(event.FromPosition) ? `<span><b>From</b>${escapeHtml(event.FromPosition)}</span>`: ""}
  	      ${clean(event.ToPosition || event.Destination) ? `<span><b>To</b>${escapeHtml(event.ToPosition || event.Destination)}</span>`: ""}
  	      ${clean(event.Odometer) ? `<span><b>Odometer</b>${escapeHtml(event.Odometer)}</span>`: ""}
  	      ${clean(event.WearRate) ? `<span><b>Wear</b>${escapeHtml(event.WearRate)}</span>`: ""}
  	      ${clean(event.CapturedBy) ? `<span><b>Captured By</b>${escapeHtml(event.CapturedBy)}</span>`: ""}
  	      </div>${clean(event.Notes) ? `<p>${escapeHtml(event.Notes)}</p>`: ""}</div></article>`;
  	    }).join("")}</div>`;
  	  }

  	  function tyreDetailsRecord(company) {
  	    const request = state.tyreDetailsRequest;
  	    if (!request) return null;
  	    const tyre = workingTyre(company, request.TyreObjectId) || findCompanyTyre(company, request.TyreObjectId);
  	    if (!tyre) return null;
  	    const slot = request.PositionKey && request.PositionKey !== "Warehouse" && state.tyreDraft && state.tyreDraft.Positions ? state.tyreDraft.Positions[request.PositionKey]: null;
  	    return {
  	      tyre: tyre,
  	      slot: slot,
  	      position: request.PositionKey || clean(tyre.Current_Position) || "Warehouse"
  	    };
  	  }

  	  function renderTyreDetailsModal(company) {
  	    const record = tyreDetailsRecord(company);
  	    if (!record) return "";
  	    const tyre = record.tyre;
  	    const life = tyreFullLife(tyre);
  	    const expected = tyreExpectedMileage(tyre);
  	    const current = tyreCurrentMileage(tyre);
  	    const summary = `<section class="fifvm-tyre-modal-summary">
  	    ${infoTile("Position", record.position || "Warehouse", "Current / planned holder", "")}
  	    ${infoTile("Life Remaining", life === null ? "No data": life.toFixed(1) + "%", "Calculated tyre life", life !== null && life < 20 ? "bad": life !== null && life < 40 ? "warn": "good")}
  	    ${infoTile("Current Mileage", current === null ? "Not set": formatNumber(current, 0) + " km", "Tyre mileage", "")}
  	    ${infoTile("Expected Mileage", expected === null ? "Not set": formatNumber(expected, 0) + " km", "Life-stage target", "")}
  	    </section>`;

  	    return `<div class="fifvm-modal-backdrop" data-vm-tyre-details-backdrop>
  	    <section class="fifvm-modal fifvm-modal-wide" role="dialog" aria-modal="true" aria-label="Tyre data and history">
  	    <header><div><strong>Tyre Data & History</strong><small>${escapeHtml(tyreDisplayName(tyre))}</small></div><button type="button" data-vm-tyre-details-close>×</button></header>
  	    <div class="fifvm-modal-scroll">${summary}<div class="fifvm-tyre-data-grid">
  	    <div>${managerPanel("Complete Tyre Record", "Every scalar tyre field currently held in App Data / Database.", tyreDataLinesHtml(tyre))}</div>
  	    <div>${managerPanel("Lifecycle Stages", "New and recapped tyre stages.", tyreStageCardsHtml(tyre))}${managerPanel("Tyre Event History", "Most recent events appear first.", tyreHistoryHtml(tyre))}</div>
  	    </div></div>
  	    <footer><button type="button" class="ghost" data-vm-tyre-details-close>Close</button><button type="button" class="print" data-vm-print-tyre="${escapeAttr(tyreObjectId(tyre))}">Print Tyre Report</button></footer>
  	    </section>
  	    </div>`;
  	  }

  	  function printableLogoHtml() {
  	    let svg = SVG_INPUT;
  	    if (svg && typeof svg === "object") svg = svg.value || svg.Value || svg.src || svg.url || "";
  	    svg = clean(svg);
  	    if (!svg) return "";
  	    if ((svg.charAt(0) === '"' && svg.charAt(svg.length - 1) === '"') || (svg.charAt(0) === "'" && svg.charAt(svg.length - 1) === "'")) svg = svg.substring(1, svg.length - 1);
  	    if (/^data:image\//i.test(svg) || /^https?:\/\//i.test(svg)) return `<img src="${escapeAttr(svg)}" alt="Fleet In Form" style="height:48px;width:auto;max-width:200px;object-fit:contain;display:block;">`;
  	    if (/^<svg[\s>]/i.test(svg)) return svg.replace(/<script[\s\S]*?<\/script>/gi, "").replace(/<svg([^>]*?)>/i, '<svg$1 style="height:48px;width:auto;max-width:200px;display:block;">');
  	    return "";
  	  }

  	  function printHtmlInHiddenFrame(title, html, landscape) {
  	    if (!document || !document.body) {
  	      fifAlert("Printing is unavailable in this browser.", {
  	        title: "Printing Unavailable", type: "danger"
  	      });
  	      return;
  	    }
  	    const frame = document.createElement("iframe");
  	    frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none;";
  	    document.body.appendChild(frame);
  	    try {
  	      const doc = frame.contentWindow.document;
  	      doc.open();
  	      doc.write(`<!doctype html><html><head><meta charset="utf-8"><title>${escapeHtml(title)}</title><style>
  	        @page{size:A4 ${landscape === false ? "portrait": "landscape"};margin:10mm;}
  	        html,body{margin:0;padding:0;background:#fff;color:#111;font-family:Arial,sans-serif;}*{box-sizing:border-box;}
  	        table{width:100%;border-collapse:collapse;page-break-inside:auto;}th,td{padding:7px;border:1px solid #d7d7d7;text-align:left;font-size:10px;vertical-align:top;}th{background:#efefef;}tr{page-break-inside:avoid;}
  	        h1,h2,h3{page-break-after:avoid;} .report-head{display:flex;justify-content:space-between;gap:20px;align-items:flex-start;border-bottom:3px solid #cc6633;padding-bottom:10px;margin-bottom:14px;}
  	        .report-head h1{margin:0 0 5px;font-size:21px}.muted{color:#666;font-size:10px;line-height:1.5}.report-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px}.box{border:1px solid #ddd;padding:9px;margin-bottom:10px}.box h3{margin:0 0 7px;font-size:12px;color:#9a4a25}.kv{display:grid;grid-template-columns:155px 1fr;border-bottom:1px solid #eee;padding:4px 0;font-size:10px}.kv span{color:#666}.stage-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:7px}.stage{border:1px solid #ddd;padding:7px}.stage.active{border-color:#cc6633;background:#fff7f2}.stage h4{margin:0 0 6px}.event{border-bottom:1px solid #ddd;padding:7px 0;font-size:10px}.event strong{display:block;margin-bottom:3px}@media print{button{display:none!important;}}
  	        </style></head><body>${html}</body></html>`);
  	      doc.close();
  	      setTimeout(function () {
  	        try {
  	          frame.contentWindow.focus();
  	          frame.contentWindow.print();
  	          setTimeout(function () {
  	            if (frame.parentNode) frame.parentNode.removeChild(frame);
  	          },
  	            1200);
  	        } catch (error) {
  	          if (frame.parentNode) frame.parentNode.removeChild(frame);
  	          fifAlert(error && error.message ? error.message: "The tyre report could not be printed.", {
  	            title: "Print Failed", type: "danger"
  	          });
  	        }
  	      },
  	        260);
  	    } catch (error) {
  	      if (frame.parentNode) frame.parentNode.removeChild(frame);
  	      fifAlert(error && error.message ? error.message: "The print document could not be created.", {
  	        title: "Print Failed", type: "danger"
  	      });
  	    }
  	  }

  	  function reportHeaderHtml(title, subtitle, vehicle) {
  	    return `<div class="report-head"><div><h1>${escapeHtml(title)}</h1><div class="muted">${escapeHtml(subtitle || "")}</div><div class="muted">Vehicle: ${escapeHtml(vehicleTitleValue(vehicle))}<br>Generated: ${escapeHtml(new Date().toLocaleString())}<br>Prepared by: ${escapeHtml(userDisplayName())}</div></div><div>${printableLogoHtml() || "Fleet In Form"}</div></div>`;
  	  }

  	  function printTyrePlanReport(company, vehicle) {
  	    const rows = tyrePlanRows(company, vehicle);
  	    const axleChanged = tyrePlanHasAxleChanges(vehicle);
  	    if (!rows.length && !axleChanged) {
  	      fifAlert("There are no unsaved tyre movements or axle-layout changes to print.", {
  	        title: "Nothing to Print", type: "info"
  	      });
  	      return;
  	    }
  	    const bodyRows = rows.map(function (row, index) {
  	      return `<tr><td>${index + 1}</td><td>${escapeHtml(row.Type)}</td><td>${escapeHtml(row.From)}</td><td>${escapeHtml(row.To)}</td><td>${escapeHtml(row.Tyre ? tyreDisplayName(row.Tyre): row.TyreObjectId)}</td></tr>`;
  	    }).join("");
  	    const html = `<div style="padding:18px 20px;">${reportHeaderHtml("Tyre Movement Plan", "Allocation, rotation, swap and removal plan before saving.", vehicle)}
  	    <div class="report-grid"><div class="box"><strong>Odometer:</strong> ${escapeHtml(state.tyreOperationOdometer || currentOdometer(vehicle) || "—")}</div><div class="box"><strong>Movement Count:</strong> ${rows.length}</div></div>
  	    <table><thead><tr><th>#</th><th>Type</th><th>From</th><th>To</th><th>Tyre</th></tr></thead><tbody>${bodyRows || '<tr><td colspan="5">No tyre movements.</td></tr>'}</tbody></table>
  	    ${axleChanged ? '<div class="box" style="margin-top:10px;"><strong>Axle Layout:</strong> The axle / tyre-position configuration has unsaved changes.</div>': ""}
  	    <div class="box" style="margin-top:10px;"><strong>Notes:</strong><br>${escapeHtml(state.tyreOperationNotes || "—")}</div></div>`;
  	    printHtmlInHiddenFrame("Tyre Movement Plan", html, true);
  	  }

  	  function printVehicleTyreRegister(company, vehicle) {
  	    const positions = (state.tyreDraft || currentTPositions(vehicle)).Positions || {};
  	    const keys = sortedTyrePositionKeys(state.tyreDraft || currentTPositions(vehicle));
  	    const rows = keys.map(function (key) {
  	      const slot = positions[key] || {};
  	      const tyre = tyreBySlot(company, slot);
  	      const life = tyre ? tyreFullLife(tyre): null;
  	      return `<tr><td>${escapeHtml(key)}</td><td>${escapeHtml(slot.AxleType || "")}</td><td>${escapeHtml(tyre ? tyreNumber(tyre): "Empty")}</td><td>${escapeHtml(tyre ? tyreSerial(tyre): slot.SerialNumber || "")}</td><td>${escapeHtml(tyre ? tyreMake(tyre): "")}</td><td>${escapeHtml(tyre ? tyreModel(tyre): "")}</td><td>${escapeHtml(tyre ? tyreSize(tyre): "")}</td><td>${escapeHtml(tyre ? tyreTypeValue(tyre): "")}</td><td>${escapeHtml(tyre ? tyreStage(tyre): "")}</td><td>${escapeHtml(tyre ? tyreStatus(tyre): slot.Status || "")}</td><td>${life === null ? "": life.toFixed(1) + "%"}</td></tr>`;
  	    }).join("");
  	    const html = `<div style="padding:18px 20px;">${reportHeaderHtml("Vehicle Tyre Register", "Current and planned tyre positions for this vehicle.", vehicle)}<table><thead><tr><th>Position</th><th>Axle Type</th><th>Tyre ID</th><th>Serial</th><th>Make</th><th>Model</th><th>Size</th><th>Type</th><th>Stage</th><th>Status</th><th>Life</th></tr></thead><tbody>${rows || '<tr><td colspan="11">No tyre positions configured.</td></tr>'}</tbody></table></div>`;
  	    printHtmlInHiddenFrame("Vehicle Tyre Register", html, true);
  	  }

  	  function printIndividualTyreReport(company, tyre, vehicle, position) {
  	    if (!tyre) {
  	      fifAlert("The tyre record could not be found.", {
  	        title: "Tyre Not Found", type: "danger"
  	      });
  	      return;
  	    }
  	    const entries = tyreScalarEntries(tyre);
  	    const history = tyreHistoryEvents(tyre);
  	    const stages = tyreHistory(tyre);
  	    const lifeCycle = tyreLifeCycle(tyre);
  	    const dataHtml = entries.map(function (entry) {
  	      let value = entry.value;
  	      if (value === null || value === undefined || value === "") value = "—";
  	      else if (typeof value === "boolean") value = value ? "Yes": "No";
  	      return `<div class="kv"><span>${escapeHtml(entry.label)}</span><strong>${escapeHtml(value)}</strong></div>`;
  	    }).join("");
  	    const stageHtml = ["New", "Cap1", "Cap2", "Cap3"].map(function (name) {
  	      const stage = Object.assign({}, lifeCycle[name] || {}, stages[name] || {});
  	      const active = !!stage.Active || lower(tyreStage(tyre)) === lower(name);
  	      return `<div class="stage ${active ? "active": ""}"><h4>${escapeHtml(name)}${active ? " — Active": ""}</h4><div class="kv"><span>Started</span><strong>${escapeHtml(formatTyreDate(stage.Started) || "—")}</strong></div><div class="kv"><span>Ended</span><strong>${escapeHtml(formatTyreDate(stage.Ended) || "—")}</strong></div><div class="kv"><span>Mileage Done</span><strong>${escapeHtml(firstValue([stage.Mileage_Done, stage.MileageDone], "—"))}</strong></div><div class="kv"><span>Expected</span><strong>${escapeHtml(firstValue([stage.Mileage_Expected, stage.MileageExpected], "—"))}</strong></div><div class="kv"><span>Cost</span><strong>${escapeHtml(firstValue([stage.Cost], "—"))}</strong></div><div class="kv"><span>CPK</span><strong>${escapeHtml(firstValue([stage.CPK], "—"))}</strong></div></div>`;
  	    }).join("");
  	    const eventHtml = history.map(function (event) {
  	      return `<div class="event"><strong>${escapeHtml(event.Type || "Event")}${event.__stage ? " — " + escapeHtml(event.__stage): ""}</strong><div>${escapeHtml(formatTyreDate(event.Date) || "No date")}</div><div>${escapeHtml([event.FromPosition ? "From " + event.FromPosition: "", (event.ToPosition || event.Destination) ? "To " + (event.ToPosition || event.Destination): "", event.Odometer ? "Odometer " + event.Odometer: ""].filter(Boolean).join(" · "))}</div>${clean(event.Notes) ? `<div>${escapeHtml(event.Notes)}</div>`: ""}</div>`;
  	    }).join("");
  	    const html = `<div style="padding:18px 20px;">${reportHeaderHtml("Individual Tyre Report",
  	      tyreDisplayName(tyre) + " · Position " + (position || clean(tyre.Current_Position) || "Warehouse"),
  	      vehicle)}<div class="report-grid"><div class="box"><h3>Complete Tyre Data</h3>${dataHtml || "No tyre fields."}</div><div><div class="box"><h3>Lifecycle Stages</h3><div class="stage-grid">${stageHtml}</div></div><div class="box"><h3>Event History</h3>${eventHtml || "No history events."}</div></div></div></div>`;
  	    printHtmlInHiddenFrame("Individual Tyre Report",
  	      html,
  	      false);
  	  }

  	  function renderTyrePlanRows(company,
  	    vehicle) {
  	    const rows = tyrePlanRows(company,
  	      vehicle);
  	    if (!rows.length && !tyrePlanHasAxleChanges(vehicle)) {
  	      return `<div class="fifvm-empty">No unsaved tyre movements.</div>`;
  	    }
  	    return `<div class="fifvm-plan-list">${rows.map(function (row) {
  	      return `<div class="fifvm-plan-row"><span class="kind kind-${lower(row.Type)}">${escapeHtml(row.Type)}</span><div><strong>${escapeHtml(row.Tyre ? tyreNumber(row.Tyre): row.TyreObjectId)}</strong><small>${escapeHtml(row.From)} → ${escapeHtml(row.To)}</small></div></div>`;
  	    }).join("")}${tyrePlanHasAxleChanges(vehicle) ? `<div class="fifvm-plan-row"><span class="kind kind-config">Layout</span><div><strong>Axle configuration changed</strong><small>Save to commit the new position layout.</small></div></div>`: ""}</div>`;
  	  }

  	  function renderTyreRemoveModal(company) {
  	    const request = state.tyreRemoveRequest;
  	    if (!request) return "";
  	    const tyre = workingTyre(company, request.TyreObjectId) || findCompanyTyre(company, request.TyreObjectId);
  	    return `<div class="fifvm-modal-backdrop" data-vm-remove-backdrop>
  	    <section class="fifvm-modal" role="dialog" aria-modal="true" aria-label="Remove tyre">
  	    <header><div><strong>Remove Tyre</strong><small>${escapeHtml(tyre ? tyreDisplayName(tyre): request.TyreObjectId)} from ${escapeHtml(request.PositionKey)}</small></div><button type="button" data-vm-remove-cancel>×</button></header>
  	    <div class="fifvm-modal-body">
  	    <label>Destination<select data-vm-remove-destination><option value="Warehouse">Warehouse</option><option value="Retread">Retread</option><option value="Scrap">Scrap</option><option value="Stolen">Stolen</option></select></label>
  	    <label>Odometer<input type="number" min="0" step="0.1" data-vm-remove-odometer value="${escapeAttr(state.tyreOperationOdometer || currentOdometer(selectedVehicle(selectedCompany())) || "")}"></label>
  	    <label class="wide">Notes<textarea data-vm-remove-notes placeholder="Reason, condition or supporting detail"></textarea></label>
  	    </div>
  	    <footer><button type="button" class="ghost" data-vm-remove-cancel>Cancel</button><button type="button" class="danger" data-vm-remove-confirm>Remove Tyre</button></footer>
  	    </section>
  	    </div>`;
  	  }

  	  function renderTyreActionBar(company, vehicle) {
  	    if (!CAN_MANAGE_WORKSHOP && !CAN_EDIT_VEHICLE_PHYSICAL) return "";
  	    const rows = tyrePlanRows(company, vehicle);
  	    const changed = rows.length || tyrePlanHasAxleChanges(vehicle);
  	    const instruction = state.axleConfigMode
  	    ? "Axle configuration active": state.tyreMode === "allocate"
  	    ? "Drag a warehouse tyre onto a position. Fitted tyres can also be dragged to move or swap.": state.tyreMode === "rotate"
  	    ? "Drag any fitted tyre onto another position to move or swap it.": state.tyreMode === "remove"
  	    ? "Select a fitted tyre and choose its destination.": "Choose an operation";
  	    return `<div class="fifvm-tyre-actions">${CAN_MANAGE_WORKSHOP ? `<button type="button" data-vm-tyre-mode="allocate" class="${state.tyreMode === "allocate" ? "active": ""}">Allocate</button><button type="button" data-vm-tyre-mode="rotate" class="${state.tyreMode === "rotate" ? "active": ""}">Rotate / Swap</button><button type="button" data-vm-tyre-mode="remove" class="${state.tyreMode === "remove" ? "active": ""}">Remove</button>`: ""}${CAN_EDIT_VEHICLE_PHYSICAL ? `<button type="button" data-vm-axle-config class="${state.axleConfigMode ? "active": ""}">Configure Axles</button>`: ""}<button type="button" class="ghost" data-vm-tyre-cancel>Clear Plan</button><button type="button" class="print" data-vm-print-plan>Print Plan</button><button type="button" class="print" data-vm-print-register>Print Tyre Register</button><span>${escapeHtml(instruction)}</span><span class="fifvm-plan-count ${changed ? "has-plan": ""}">${rows.length} movement${rows.length === 1 ? "": "s"}</span><button type="button" class="save" data-vm-save-tyres ${state.vehicleBusy || !changed ? "disabled": ""}>${state.vehicleBusy ? "Saving…": "Save Tyre Changes"}</button></div>
  	    <div class="fifvm-tyre-capture"><label>Vehicle Odometer<input type="number" min="0" step="0.1" data-vm-tyre-odometer value="${escapeAttr(state.tyreOperationOdometer || currentOdometer(vehicle) || "")}"></label><label>Movement Notes<input type="text" data-vm-tyre-notes value="${escapeAttr(state.tyreOperationNotes)}" placeholder="Applied to all planned tyre movements"></label></div>`;
  	  }





  	  function formObject(form) {
  	    const data = {};
  	    new FormData(form).forEach(function (value, key) {
  	      data[key] = value;
  	    });
  	    return data;
  	  }



  	  function markTyreChanged(tyre) {
  	    const id = tyreObjectId(tyre);
  	    if (id) state.tyreChangedIds[id] = true;
  	  }

  	  function tyreSerial(tyre) {
  	    return clean(firstValue([tyre && tyre.Serial_Number, tyre && tyre.SerialNumber, tyre && tyre.Serial], ""));
  	  }

  	  function appendTyreRecord(vehicle, type, tyre, fromPosition, toPosition, odometer, notes, destination) {
  	    const records = ensureArray(vehicle, ["Data", "Tyres", "TyreRecords"]);
  	    records.push({
  	      date: new Date().toISOString(),
  	      type: type,
  	      tyre: tyreDisplayName(tyre),
  	      notes: notes || "Captured in integrated vehicle manager",
  	      odometer: odometer === "" ? currentOdometer(vehicle): odometer,
  	      fromPosition: fromPosition || "",
  	      toPosition: toPosition || "",
  	      destination: destination || "",
  	      tyreObjectId: tyreObjectId(tyre),
  	      capturedBy: userDisplayName()
  	    });
  	  }

  	  function clearTyreSlot(slot) {
  	    if (!slot) return;
  	    slot.TyreObjectId = "";
  	    slot.TyreNumber = "";
  	    slot.SerialNumber = "";
  	    slot.Status = "Empty";
  	    slot.UpdatedAt = new Date().toISOString();
  	  }

  	  function fitTyreSlot(slot, tyre) {
  	    if (!slot || !tyre) return;
  	    slot.TyreObjectId = tyreObjectId(tyre);
  	    slot.TyreNumber = tyreNumber(tyre);
  	    slot.SerialNumber = tyreSerial(tyre);
  	    slot.Status = "Fitted";
  	    slot.UpdatedAt = new Date().toISOString();
  	  }

  	  function copyTyreSlot(from, to) {
  	    if (!from || !to) return;
  	    to.TyreObjectId = from.TyreObjectId || "";
  	    to.TyreNumber = from.TyreNumber || "";
  	    to.SerialNumber = from.SerialNumber || "";
  	    to.Status = to.TyreObjectId ? "Fitted": "Empty";
  	    to.UpdatedAt = new Date().toISOString();
  	  }

  	  function requiredTyreTypeForSlot(slot) {
  	    const axleType = clean(slot && slot.AxleType);
  	    if (axleType === "Steer") return "Steer";
  	    if (axleType === "Spare") return "Spare";
  	    if (axleType === "Trailer") return "Trailer";
  	    return "Drive";
  	  }

  	  function actualTyreType(tyre) {
  	    return clean(firstValue([tyre && tyre.Type, tyre && tyre.Tyre_Type], ""));
  	  }

  	  async function approveTyreMismatch(tyre, slot) {
  	    const actual = actualTyreType(tyre);
  	    const required = requiredTyreTypeForSlot(slot);
  	    if (!actual || lower(actual) === lower(required)) return true;
  	    const key = tyreObjectId(tyre) + "::" + clean(slot && slot.PositionKey);
  	    if (state.tyreMismatchApprovals[key]) return true;

  	    const approved = await fifConfirm(
  	      "This tyre does not match the preferred tyre type for the selected position. The fitment is allowed only after explicit approval.",
  	      {
  	        title: "Tyre Type Mismatch",
  	        type: "warning",
  	        confirmText: "Approve Fitment",
  	        cancelText: "Cancel",
  	        details: [{
  	          label: "Position", value: clean(slot && slot.PositionKey) || "Unknown"
  	        },
  	          {
  	            label: "Required", value: required
  	          },
  	          {
  	            label: "Actual", value: actual
  	          },
  	          {
  	            label: "Tyre", value: tyreDisplayName(tyre)
  	          }]
  	      }
  	    );

  	    if (!approved) return false;
  	    state.tyreMismatchApprovals[key] = {
  	      Date: new Date().toISOString(),
  	      Required_Type: required,
  	      Actual_Type: actual,
  	      Reason: "Approved in integrated vehicle manager"
  	    };
  	    return true;
  	  }

  	  function resetTyreInteractionSources() {
  	    state.tyreDragSource = null;
  	    state.tyreTapSource = null;
  	    state.tyreDragOverPosition = "";
  	    state.tyreSourcePosition = "";
  	    state.tyreSelectedWarehouseId = "";
  	  }

  	  function tyreSourceAllowed(source) {
  	    if (!source) return false;
  	    if (state.tyreMode === "rotate") return source.SourceType === "fitted";
  	    if (state.tyreMode === "allocate") return source.SourceType === "fitted" || source.SourceType === "warehouse";
  	    return false;
  	  }

  	  function setTyreTapSource(source) {
  	    state.tyreTapSource = source;
  	    state.tyreDragSource = null;
  	    state.tyreSourcePosition = source && source.SourceType === "fitted" ? source.SourcePosition: "";
  	    state.tyreSelectedWarehouseId = source && source.SourceType === "warehouse" ? source.TyreObjectId: "";
  	  }

  	  async function applyTyreDrop(company, vehicle, source, targetPosition) {
  	    if (!CAN_MANAGE_WORKSHOP) return false;
  	    if (!state.tyreDraft) state.tyreDraft = currentTPositions(vehicle);
  	    if (!source || !tyreSourceAllowed(source)) {
  	      setVehicleMessage("This tyre source is not allowed in the current mode.", true);
  	      return false;
  	    }
  	    const target = state.tyreDraft.Positions && state.tyreDraft.Positions[targetPosition];
  	    if (!target) {
  	      setVehicleMessage("The target tyre position could not be found.", true);
  	      return false;
  	    }

  	    if (source.SourceType === "warehouse") {
  	      const incoming = workingTyre(company, source.TyreObjectId);
  	      if (!incoming) {
  	        setVehicleMessage("The selected warehouse tyre could not be found.", true);
  	        return false;
  	      }
  	      const already = findSlotByTyreId(state.tyreDraft, source.TyreObjectId);
  	      if (already) {
  	        setVehicleMessage("That warehouse tyre is already in this plan at " + already.PositionKey + ".", true);
  	        return false;
  	      }
  	      if (!(await approveTyreMismatch(incoming, target))) {
  	        setVehicleMessage("Tyre type mismatch was not approved.", true);
  	        return false;
  	      }
  	      const outgoingId = clean(target.TyreObjectId);
  	      if (outgoingId) {
  	        state.tyreRemovalMeta[outgoingId] = {
  	          destination: "Warehouse",
  	          notes: "Replaced by warehouse tyre " + tyreNumber(incoming)
  	        };
  	      }
  	      fitTyreSlot(target, incoming);
  	      delete state.tyreRemovalMeta[source.TyreObjectId];
  	      state.tyreDraft.Summary = tyrePositionSummary(state.tyreDraft);
  	      setVehicleMessage(outgoingId ? "Warehouse tyre fitted to " + targetPosition + "; the previous tyre will return to warehouse.": "Warehouse tyre planned for " + targetPosition + ".", false);
  	      resetTyreInteractionSources();
  	      return true;
  	    }

  	    const sourcePosition = clean(source.SourcePosition);
  	    if (!sourcePosition || sourcePosition === targetPosition) {
  	      setVehicleMessage(sourcePosition === targetPosition ? "Source and target positions are the same.": "The source position is missing.", true);
  	      return false;
  	    }
  	    const sourceSlot = state.tyreDraft.Positions && state.tyreDraft.Positions[sourcePosition];
  	    if (!sourceSlot || !clean(sourceSlot.TyreObjectId)) {
  	      setVehicleMessage("The source position no longer contains a tyre.", true);
  	      return false;
  	    }
  	    const sourceTyre = tyreBySlot(company, sourceSlot);
  	    const targetTyre = tyreBySlot(company, target);
  	    if (!sourceTyre) {
  	      setVehicleMessage("The source tyre record could not be found.", true);
  	      return false;
  	    }
  	    if (!(await approveTyreMismatch(sourceTyre, target))) {
  	      setVehicleMessage("Source tyre type mismatch was not approved.", true);
  	      return false;
  	    }
  	    if (targetTyre && !(await approveTyreMismatch(targetTyre, sourceSlot))) {
  	      setVehicleMessage("Target tyre type mismatch was not approved.", true);
  	      return false;
  	    }

  	    const sourceSnapshot = cloneData(sourceSlot);
  	    const targetSnapshot = cloneData(target);
  	    copyTyreSlot(targetSnapshot, sourceSlot);
  	    copyTyreSlot(sourceSnapshot, target);
  	    delete state.tyreRemovalMeta[sourceSnapshot.TyreObjectId];
  	    if (targetSnapshot.TyreObjectId) delete state.tyreRemovalMeta[targetSnapshot.TyreObjectId];
  	    state.tyreDraft.Summary = tyrePositionSummary(state.tyreDraft);
  	    setVehicleMessage(targetSnapshot.TyreObjectId ? "Tyre swap planned: " + sourcePosition + " ↔ " + targetPosition + ".": "Tyre rotation planned: " + sourcePosition + " → " + targetPosition + ".", false);
  	    resetTyreInteractionSources();
  	    return true;
  	  }

  	  function openTyreRemoval(company, vehicle, positionKey) {
  	    const slot = state.tyreDraft && state.tyreDraft.Positions ? state.tyreDraft.Positions[positionKey]: null;
  	    if (!slot || !clean(slot.TyreObjectId)) {
  	      setVehicleMessage("The selected position is empty.", true);
  	      return;
  	    }
  	    state.tyreSourcePosition = positionKey;
  	    state.tyreRemoveRequest = {
  	      PositionKey: positionKey,
  	      TyreObjectId: slot.TyreObjectId
  	    };
  	  }

  	  function confirmTyreRemoval(company, vehicle, destination, odometer, notes) {
  	    const request = state.tyreRemoveRequest;
  	    if (!request || !state.tyreDraft) return false;
  	    const slot = state.tyreDraft.Positions && state.tyreDraft.Positions[request.PositionKey];
  	    if (!slot || clean(slot.TyreObjectId) !== clean(request.TyreObjectId)) {
  	      setVehicleMessage("The tyre position changed before removal could be completed.", true);
  	      state.tyreRemoveRequest = null;
  	      return false;
  	    }
  	    state.tyreRemovalMeta[request.TyreObjectId] = {
  	      destination: destination || "Warehouse",
  	      odometer: clean(odometer),
  	      notes: clean(notes)
  	    };
  	    clearTyreSlot(slot);
  	    state.tyreDraft.Summary = tyrePositionSummary(state.tyreDraft);
  	    state.tyreOperationOdometer = clean(odometer) || state.tyreOperationOdometer;
  	    state.tyreRemoveRequest = null;
  	    resetTyreInteractionSources();
  	    setVehicleMessage("Tyre removal planned to " + (destination || "Warehouse") + ". Save tyre changes to commit.", false);
  	    return true;
  	  }

  	  function parseTyreHistory(raw, tyre) {
  	    let history = raw;
  	    if (typeof raw === "string") {
  	      try {
  	        history = JSON.parse(raw);
  	      } catch (_) {
  	        history = null;
  	      }
  	    }
  	    const stage = clean(tyre && tyre.Current_Stage) || "New";
  	    if (!history || typeof history !== "object" || Array.isArray(history)) history = {};
  	    if (!history[stage] || typeof history[stage] !== "object") history[stage] = {
  	      Active: true,
  	      Status: "Active",
  	      Events: []
  	    };
  	    if (!Array.isArray(history[stage].Events)) history[stage].Events = [];
  	    if (!history.Current || typeof history.Current !== "object") history.Current = {
  	      Stage: stage
  	    };
  	    if (!history.Totals || typeof history.Totals !== "object") history.Totals = {};
  	    return history;
  	  }

  	  function appendTyreHistoryEvent(tyre, event) {
  	    const updated = cloneData(tyre);
  	    const history = parseTyreHistory(updated.History, updated);
  	    const stage = clean(updated.Current_Stage) || clean(history.Current.Stage) || "New";
  	    if (!history[stage] || typeof history[stage] !== "object") history[stage] = {
  	      Active: true,
  	      Status: "Active",
  	      Events: []
  	    };
  	    if (!Array.isArray(history[stage].Events)) history[stage].Events = [];
  	    history[stage].Events.push(event);
  	    history.Current.Stage = stage;
  	    history.Current.Last_Event_Type = event.Type || "";
  	    history.Current.Last_Event_Date = event.Date || "";
  	    history.Current.Vehicle_ObjectId = updated.Vehicle_ObjectId || "";
  	    history.Current.Vehicle_ID = updated.Vehicle_ID || "";
  	    history.Current.Position = updated.Current_Position || "";
  	    history.Current.Axle_Type = updated.Current_Axle_Type || "";
  	    history.Current.Wear_Rate = updated.Current_Wear_Rate === undefined || updated.Current_Wear_Rate === null ? "": updated.Current_Wear_Rate;
  	    updated.History = history;
  	    return updated;
  	  }

  	  function tyreMovementEvent(type, vehicle, row, odometer, notes, destination) {
  	    const approval = row.After ? state.tyreMismatchApprovals[row.TyreObjectId + "::" + clean(row.After.PositionKey)]: null;
  	    return {
  	      Date: new Date().toISOString(),
  	      Type: type,
  	      Vehicle_ObjectId: objectIdOf(vehicle),
  	      Vehicle_ID: clean(firstValue([vehicle && vehicle.ID, fifVehicleIdentityValue(vehicle, "FID", ""), vehicleRegistrationValue(vehicle)], vehicleTitleValue(vehicle))),
  	      FromPosition: row.From || "",
  	      ToPosition: row.After ? row.After.PositionKey: "",
  	      Odometer: odometer || "",
  	      Destination: destination || "",
  	      WearRate: row.After && row.After.WearRate !== undefined ? row.After.WearRate: "",
  	      CapturedBy: userDisplayName(),
  	      Notes: notes || "",
  	      Mismatch_Accepted: !!approval,
  	      Required_Type: approval ? approval.Required_Type: "",
  	      Actual_Type: approval ? approval.Actual_Type: "",
  	      Mismatch_Approved_Date: approval ? approval.Date: "",
  	      Mismatch_Reason: approval ? approval.Reason: ""
  	    };
  	  }

  	  function statusForTyreDestination(destination) {
  	    if (destination === "Retread") return "In For Retread";
  	    if (destination === "Scrap") return "Scrapped";
  	    if (destination === "Stolen") return "Stolen";
  	    return "All In Order";
  	  }

  	  function holderTypeForDestination(destination) {
  	    if (destination === "Retread") return "Retread Supplier";
  	    if (destination === "Scrap") return "Scrap Yard";
  	    if (destination === "Stolen") return "Stolen";
  	    return "Warehouse";
  	  }

  	  function buildUpdatedTyreForPlanRow(row, vehicle, odometer, globalNotes) {
  	    let tyre = cloneData(row.Tyre || workingTyre(selectedCompany(), row.TyreObjectId));
  	    if (!tyre || !tyreObjectId(tyre)) throw new Error("Tyre record could not be found for " + row.TyreObjectId + ".");
  	    const rowNotes = clean((row.Meta && row.Meta.notes ? row.Meta.notes + " ": "") + (globalNotes || ""));
  	    if (row.Type === "Removed") {
  	      const destination = clean(row.To) || "Warehouse";
  	      tyre.Vehicle_ObjectId = null;
  	      tyre.Vehicle_ID = null;
  	      tyre.Vehicle_Type = null;
  	      tyre.Current_Position = destination;
  	      tyre.Current_Axle_Type = null;
  	      tyre.Current_Wear_Rate = null;
  	      tyre.Current_Holder_ObjectId = null;
  	      tyre.Current_Holder_Type = holderTypeForDestination(destination);
  	      tyre.Fitted_Date = null;
  	      tyre.Fitted_Odometer = null;
  	      tyre.Status = statusForTyreDestination(destination);
  	      tyre.Last_Vehicle_Odometer = clean((row.Meta && row.Meta.odometer) || odometer) || tyre.Last_Vehicle_Odometer || null;
  	      tyre = appendTyreHistoryEvent(tyre, tyreMovementEvent("Removed", vehicle, row, clean((row.Meta && row.Meta.odometer) || odometer), rowNotes, destination));
  	      return tyre;
  	    }

  	    const slot = row.After;
  	    tyre.Vehicle_ObjectId = objectIdOf(vehicle) || null;
  	    tyre.Vehicle_ID = clean(firstValue([vehicle && vehicle.ID, fifVehicleIdentityValue(vehicle, "FID", ""), vehicleRegistrationValue(vehicle)], vehicleTitleValue(vehicle))) || null;
  	    tyre.Vehicle_Type = assetIsTrailer(vehicle) ? "Trailer" : "Tractor";
  	    tyre.Current_Position = slot.PositionKey;
  	    tyre.Current_Axle_Type = slot.AxleType;
  	    tyre.Current_Wear_Rate = slot.WearRate === undefined || slot.WearRate === null ? 1: slot.WearRate;
  	    tyre.Current_Holder_ObjectId = objectIdOf(vehicle) || null;
  	    tyre.Current_Holder_Type = "Vehicle";
  	    tyre.Status = "All In Order";
  	    tyre.Last_Vehicle_Odometer = clean(odometer) || tyre.Last_Vehicle_Odometer || null;
  	    if (row.Type === "Installed") {
  	      tyre.Fitted_Date = new Date().toISOString();
  	      tyre.Fitted_Odometer = clean(odometer) || tyre.Fitted_Odometer || null;
  	    }
  	    tyre = appendTyreHistoryEvent(tyre, tyreMovementEvent(row.Type === "Installed" ? "Installed": "Rotation", vehicle, row, odometer, rowNotes, ""));
  	    return tyre;
  	  }

  	  const TYRE_GENERATED_SAVE_FIELDS = ["Warehouse",
  	    "Current_CPK",
  	    "Total_CPK",
  	    "Current_Life",
  	    "Total_Mileage",
  	    "Mileage_Warning",
  	    "Total_Cost",
  	    "Expected_CPK",
  	    "Remaining_Mileage"];
  	  const TYRE_READ_ONLY_SAVE_FIELDS = ["created",
  	    "updated",
  	    "ownerId",
  	    "___class"];

  	  function cleanTyrePayloadForSave(tyre) {
  	    const payload = cloneData(tyre);
  	    TYRE_GENERATED_SAVE_FIELDS.concat(TYRE_READ_ONLY_SAVE_FIELDS).forEach(function (field) {
  	      delete payload[field];
  	    });
  	    return payload;
  	  }

  	  function saveTyreObjectsSequentially(company, tyreObjects) {
  	    const list = tyreObjects.filter(function (tyre) {
  	      return tyre && tyreObjectId(tyre);
  	    });
  	    if (!BACKENDLESS_API || !BACKENDLESS_API.Data || !BACKENDLESS_API.Data.of) {
  	      return Promise.reject(
  	        new Error(
  	          "The real database SDK is unavailable. Tyre records were not saved and AppData was not changed."
  	        )
  	      );
  	    }
  	    const store = BACKENDLESS_API.Data.of("Tyres");
  	    const saved = [];
  	    return list.reduce(function (chain, tyre) {
  	      return chain.then(function () {
  	        return store.save(cleanTyrePayloadForSave(tyre)).then(function (result) {
  	          const value = result && typeof result === "object" ? Object.assign({}, tyre, result): tyre;
  	          mergeSavedTyreIntoCompany(company, value);
  	          saved.push(value);
  	        });
  	      });
  	    }, Promise.resolve()).then(function () {
  	      return {
  	        values: saved, localOnly: false
  	      };
  	    });
  	  }

  	  function saveVehicleWithTyreRelation(company, vehicle, tPositions) {
  	    fifRequirePermission(
  	      userCanAccessAssetFunction(vehicle, "Tyres") && (CAN_MANAGE_WORKSHOP || userCanEditAssetPhysical(vehicle)),
  	      "Tyre functionality is not assigned."
  	    );
  	    restoreProtectedTrackerFields(vehicle, selectedVehicle(company));
  	    const table = clean(firstValue([vehicle && vehicle.___class, "Tractors"], "Tractors"));
  	    const relationTyres = Object.keys(tPositions.Positions || {}).map(function (key) {
  	      return workingTyre(company, tPositions.Positions[key].TyreObjectId) || findCompanyTyre(company, tPositions.Positions[key].TyreObjectId);
  	    }).filter(Boolean);
  	    vehicle.Tyres = relationTyres;

  	    if (!BACKENDLESS_API || !BACKENDLESS_API.Data || !BACKENDLESS_API.Data.of) {
  	      return Promise.reject(
  	        new Error(
  	          "The real database SDK is unavailable. The vehicle and tyre relations were not saved and AppData was not changed."
  	        )
  	      );
  	    }

  	    const store = BACKENDLESS_API.Data.of(table);
  	    const payload = cloneData(vehicle);
  	    delete payload.Tyres;
  	    return store.save(payload).then(function (saved) {
  	      const value = saved && typeof saved === "object" ? saved: payload;
  	      if (!store.setRelation) return value;
  	      const refs = relationTyres.map(function (tyre) {
  	        return {
  	          objectId: tyreObjectId(tyre)
  	        };
  	      }).filter(function (ref) {
  	        return ref.objectId;
  	      });
  	      return store.setRelation(value, "Tyres", refs).catch(function () {
  	        return objectIdOf(value) ? store.setRelation(objectIdOf(value), "Tyres", refs): null;
  	      }).then(function () {
  	        return value;
  	      });
  	    }).then(function (saved) {
  	      saved.Tyres = relationTyres;
  	      replaceSelectedVehicle(company, saved);
  	      return {
  	        value: saved,
  	        localOnly: false
  	      };
  	    });
  	  }

  	  function saveTyrePlan(company) {
  	    const liveVehicle = selectedVehicle(company);
  	    if (!liveVehicle || !CAN_ACCESS_TYRES || !userCanAccessAsset(liveVehicle) || (!CAN_MANAGE_WORKSHOP && !userCanEditAssetPhysical(liveVehicle))) return;
  	    if (!state.tyreDraft) return;
  	    const rows = tyrePlanRows(company, liveVehicle);
  	    const axleChanged = tyrePlanHasAxleChanges(liveVehicle);
  	    if (!rows.length && !axleChanged) {
  	      setVehicleMessage("There are no tyre changes to save.", true);
  	      render();
  	      return;
  	    }
  	    const odometer = clean(state.tyreOperationOdometer);
  	    if (rows.length && !odometer) {
  	      setVehicleMessage("Enter the vehicle odometer before saving tyre movements.", true);
  	      render();
  	      return;
  	    }
  	    const notes = clean(state.tyreOperationNotes);
  	    const updatedVehicle = cloneData(state.tyreVehicleDraft || liveVehicle);
  	    const updatedTyres = [];

  	    try {
  	      rows.forEach(function (row) {
  	        const updatedTyre = buildUpdatedTyreForPlanRow(row, liveVehicle, odometer, notes);
  	        state.tyreObjectDrafts[row.TyreObjectId] = updatedTyre;
  	        markTyreChanged(updatedTyre);
  	        updatedTyres.push(updatedTyre);
  	        appendTyreRecord(updatedVehicle, row.Type, updatedTyre, row.From, row.After ? row.After.PositionKey: "", clean((row.Meta && row.Meta.odometer) || odometer), clean((row.Meta && row.Meta.notes ? row.Meta.notes + " ": "") + notes), row.Type === "Removed" ? row.To: "");
  	      });
  	      writeVehicleTPositions(updatedVehicle, state.tyreDraft);
  	      restoreProtectedTrackerFields(updatedVehicle, liveVehicle);
  	    } catch (error) {
  	      setVehicleMessage(error && error.message ? error.message: "The tyre plan could not be prepared.", true);
  	      render();
  	      return;
  	    }

  	    state.vehicleBusy = true;
  	    setVehicleMessage("Saving tyre records, vehicle positions and tyre relations…", false);
  	    render();
  	    const operation = fifBeginSaveOperation("Saving tyre records and vehicle relations…");

  	    saveTyreObjectsSequentially(company, updatedTyres).then(function (tyreResult) {
  	      return saveVehicleWithTyreRelation(company, updatedVehicle, state.tyreDraft).then(function (vehicleResult) {
  	        return {
  	          localOnly: tyreResult.localOnly || vehicleResult.localOnly
  	        };
  	      });
  	    }).then(function (result) {
  	      state.tyreDraft = null;
  	      state.tyreOriginalDraft = null;
  	      state.tyreMode = "";
  	      state.tyreChangedIds = {};
  	      state.tyreObjectDrafts = {};
  	      state.tyreVehicleDraft = null;
  	      state.axleConfigMode = false;
  	      state.tyreRemovalMeta = {};
  	      state.tyreRemoveRequest = null;
  	      state.tyreMismatchApprovals = {};
  	      state.tyreOperationNotes = "";
  	      resetTyreInteractionSources();
  	      state.vehicleBusy = false;
  	      fifCompleteSaveOperation(operation, "Tyre movements and relations saved to the database.");
  	      setVehicleMessage("Tyre movements, history and vehicle relations saved to the database.", false);
  	      render();
  	    }).catch(function (error) {
  	      state.vehicleBusy = false;
  	      fifFailSaveOperation(operation, error);
  	      setVehicleMessage(error && error.message ? error.message: "Tyre changes could not be saved.", true);
  	      render();
  	    });
  	  }

  	  const EXACT_TRACTOR_HOST_ID = "fif-exact-original-tractor-manager-host";
  	  let exactTractorLaunchTimer = null;
  	  let exactTractorLaunching = false;

  	  function exactTractorHost() {
  	    return document.getElementById(EXACT_TRACTOR_HOST_ID);
  	  }

  	  function closeExactOriginalTyreManager() {
  	    if (exactTractorLaunchTimer) {
  	      window.clearInterval(exactTractorLaunchTimer);
  	      exactTractorLaunchTimer = null;
  	    }

  	    exactTractorLaunching = false;

  	    try {
  	      document.getElementById("tractorEditorPanel")?.remove();
  	    } catch (_) {}
  	    try {
  	      document.getElementById("tractorListPanel")?.remove();
  	    } catch (_) {}
  	    try {
  	      exactTractorHost()?.remove();
  	    } catch (_) {}
  	  }







  	  let exactInlineTyreInstance = null;
  	  let exactInlineTyreHost = null;

  	  function destroyExactInlineTyreManager() {
  	    if (exactInlineTyreInstance && typeof exactInlineTyreInstance.destroy === "function") {
  	      try {
  	        exactInlineTyreInstance.destroy();
  	      } catch (error) {

  	      }
  	    }
  	    exactInlineTyreInstance = null;
  	    exactInlineTyreHost = null;
  	  }



  	  function bindExactOriginalTyreWrapperEvents(root) {
  	    root.querySelector("[data-vm-original-configure-axles]")?.addEventListener("click",
  	      function () {
  	        if (!CAN_EDIT_VEHICLE_PHYSICAL || !exactInlineTyreInstance || typeof exactInlineTyreInstance.configureAxles !== "function") return;
  	        exactInlineTyreInstance.configureAxles();
  	      });
  	  }

  	  function closeVehicleColourPopover(root, restoreOriginal) {
  	    const popup = root && root.querySelector(".fifvm-colour-popover");
  	    if (!popup) return;
  	    const inputId = popup.getAttribute("data-colour-input-id") || "";
  	    const input = inputId ? root.querySelector('[data-vm-colour-value][data-colour-input-id="' + inputId + '"]') : null;
  	    if (restoreOriginal && input) {
  	      input.value = popup.getAttribute("data-original-colour") || input.value;
  	      const control = input.closest(".fifvm-colour-control");
  	      const output = control && control.querySelector("[data-vm-colour-output]");
  	      const colour = safeColor(input.value, "#cc6633");
  	      if (control) control.style.setProperty("--selected-colour", colour);
  	      if (output) output.textContent = colour.toUpperCase();
  	    }
  	    popup.remove();
  	  }

  	  function positionVehicleColourPopover(popup, trigger) {
  	    if (!popup || !trigger) return;
  	    const triggerRect = trigger.getBoundingClientRect();
  	    const popupRect = popup.getBoundingClientRect();
  	    const rootRect = popup.parentElement && popup.parentElement.getBoundingClientRect ? popup.parentElement.getBoundingClientRect() : { left: 0, top: 0, right: window.innerWidth, bottom: window.innerHeight };
  	    const minimumLeft = Math.max(10, rootRect.left + 10);
  	    const maximumRight = Math.min(window.innerWidth || document.documentElement.clientWidth || 1200, rootRect.right) - 10;
  	    const minimumTop = Math.max(10, rootRect.top + 10);
  	    const maximumBottom = Math.min(window.innerHeight || document.documentElement.clientHeight || 800, rootRect.bottom) - 10;
  	    let left = triggerRect.left;
  	    let top = triggerRect.bottom + 8;
  	    if (left + popupRect.width > maximumRight) left = maximumRight - popupRect.width;
  	    if (left < minimumLeft) left = minimumLeft;
  	    if (top + popupRect.height > maximumBottom) top = triggerRect.top - popupRect.height - 8;
  	    if (top < minimumTop) top = minimumTop;
  	    popup.style.left = Math.round(left) + "px";
  	    popup.style.top = Math.round(top) + "px";
  	  }

  	  function openVehicleColourPopover(root, control, input) {
  	    closeVehicleColourPopover(root, false);
  	    const trigger = control.querySelector("[data-vm-colour-trigger]");
  	    if (!trigger || trigger.disabled) return;
  	    const original = safeColor(input.value, "#cc6633");
  	    const originalRgb = fifHexToRgb(original);
  	    const hsv = fifRgbToHsv(originalRgb.r, originalRgb.g, originalRgb.b);
  	    const inputId = "colour-" + Math.random().toString(36).slice(2, 10);
  	    input.setAttribute("data-colour-input-id", inputId);

  	    const popup = document.createElement("section");
  	    popup.className = "fifvm-colour-popover";
  	    popup.setAttribute("role", "dialog");
  	    popup.setAttribute("aria-label", "Fleet In Form colour picker");
  	    popup.setAttribute("data-colour-input-id", inputId);
  	    popup.setAttribute("data-original-colour", original);
  	    popup.innerHTML = `
  	      <header><div><span>Asset colour</span><strong>Fleet In Form Picker</strong></div><button type="button" data-colour-close aria-label="Close colour picker"></button></header>
  	      <div class="fifvm-colour-sv" data-colour-sv style="--picker-hue:${hsv.h}"><i data-colour-sv-marker></i></div>
  	      <div class="fifvm-colour-hue-row"><span data-colour-preview style="--preview-colour:${escapeAttr(original)}"></span><input type="range" min="0" max="360" step="1" value="${Math.round(hsv.h)}" data-colour-hue aria-label="Hue"><output data-colour-live>${escapeHtml(original.toUpperCase())}</output></div>
  	      <div class="fifvm-colour-presets" aria-label="Common fleet colours">${["#0044ff", "#cc6633", "#1f8f4d", "#d3a22b", "#c43d32", "#6e56cf", "#2f3431", "#f4f4f4"].map(function (colour) { return `<button type="button" data-colour-preset="${colour}" style="--preset-colour:${colour}" aria-label="Use ${colour}"></button>`; }).join("")}</div>
  	      <div class="fifvm-colour-values"><label class="hex"><span>HEX</span><input type="text" maxlength="7" spellcheck="false" value="${escapeAttr(original.toUpperCase())}" data-colour-hex></label><label><span>R</span><input type="number" min="0" max="255" step="1" value="${originalRgb.r}" data-colour-r></label><label><span>G</span><input type="number" min="0" max="255" step="1" value="${originalRgb.g}" data-colour-g></label><label><span>B</span><input type="number" min="0" max="255" step="1" value="${originalRgb.b}" data-colour-b></label></div>
  	      <footer><button type="button" class="fifvm-btn ghost" data-colour-cancel>Cancel</button><button type="button" class="fifvm-btn primary" data-colour-done>Use Colour</button></footer>`;
  	    root.appendChild(popup);

  	    const sv = popup.querySelector("[data-colour-sv]");
  	    const marker = popup.querySelector("[data-colour-sv-marker]");
  	    const hue = popup.querySelector("[data-colour-hue]");
  	    const live = popup.querySelector("[data-colour-live]");
  	    const preview = popup.querySelector("[data-colour-preview]");
  	    const hexInput = popup.querySelector("[data-colour-hex]");
  	    const rInput = popup.querySelector("[data-colour-r]");
  	    const gInput = popup.querySelector("[data-colour-g]");
  	    const bInput = popup.querySelector("[data-colour-b]");
  	    const stateValue = { h: hsv.h, s: hsv.s, v: hsv.v };

  	    function updateMarker() {
  	      marker.style.left = (stateValue.s * 100) + "%";
  	      marker.style.top = ((1 - stateValue.v) * 100) + "%";
  	      sv.style.setProperty("--picker-hue", stateValue.h);
  	      hue.value = String(Math.round(stateValue.h));
  	    }

  	    function commitRgb(rgb, updateHsv) {
  	      const hex = fifRgbToHex(rgb.r, rgb.g, rgb.b);
  	      if (updateHsv !== false) {
  	        const nextHsv = fifRgbToHsv(rgb.r, rgb.g, rgb.b);
  	        stateValue.h = nextHsv.h;
  	        stateValue.s = nextHsv.s;
  	        stateValue.v = nextHsv.v;
  	      }
  	      input.value = hex;
  	      control.style.setProperty("--selected-colour", hex);
  	      const output = control.querySelector("[data-vm-colour-output]");
  	      if (output) output.textContent = hex.toUpperCase();
  	      live.textContent = hex.toUpperCase();
  	      preview.style.setProperty("--preview-colour", hex);
  	      hexInput.value = hex.toUpperCase();
  	      rInput.value = String(rgb.r);
  	      gInput.value = String(rgb.g);
  	      bInput.value = String(rgb.b);
  	      updateMarker();
  	      input.dispatchEvent(new Event("input", { bubbles: true }));
  	    }

  	    function commitHsv() {
  	      commitRgb(fifHsvToRgb(stateValue.h, stateValue.s, stateValue.v), false);
  	    }

  	    function setSvFromPointer(event) {
  	      const rect = sv.getBoundingClientRect();
  	      stateValue.s = fifClampNumber((event.clientX - rect.left) / rect.width, 0, 1);
  	      stateValue.v = 1 - fifClampNumber((event.clientY - rect.top) / rect.height, 0, 1);
  	      commitHsv();
  	    }

  	    sv.addEventListener("pointerdown", function (event) {
  	      event.preventDefault();
  	      setSvFromPointer(event);
  	      const move = function (moveEvent) { setSvFromPointer(moveEvent); };
  	      const finish = function () {
  	        window.removeEventListener("pointermove", move, true);
  	        window.removeEventListener("pointerup", finish, true);
  	        window.removeEventListener("pointercancel", finish, true);
  	      };
  	      window.addEventListener("pointermove", move, true);
  	      window.addEventListener("pointerup", finish, true);
  	      window.addEventListener("pointercancel", finish, true);
  	    });

  	    hue.addEventListener("input", function () {
  	      stateValue.h = fifClampNumber(hue.value, 0, 360);
  	      commitHsv();
  	    });

  	    hexInput.addEventListener("input", function () {
  	      const raw = String(hexInput.value || "").trim();
  	      if (!/^#[0-9a-f]{6}$/i.test(raw)) return;
  	      const rgb = fifHexToRgb(raw);
  	      commitRgb(rgb, true);
  	    });

  	    function commitRgbInputs() {
  	      commitRgb({
  	        r: Math.round(fifClampNumber(rInput.value, 0, 255)),
  	        g: Math.round(fifClampNumber(gInput.value, 0, 255)),
  	        b: Math.round(fifClampNumber(bInput.value, 0, 255))
  	      }, true);
  	    }
  	    [rInput, gInput, bInput].forEach(function (rgbInput) {
  	      rgbInput.addEventListener("input", commitRgbInputs);
  	      rgbInput.addEventListener("change", commitRgbInputs);
  	    });

  	    popup.querySelectorAll("[data-colour-preset]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const rgb = fifHexToRgb(button.getAttribute("data-colour-preset") || original);
  	        commitRgb(rgb, true);
  	      });
  	    });
  	    popup.querySelector("[data-colour-close]").addEventListener("click", function () { closeVehicleColourPopover(root, false); });
  	    popup.querySelector("[data-colour-cancel]").addEventListener("click", function () { closeVehicleColourPopover(root, true); });
  	    popup.querySelector("[data-colour-done]").addEventListener("click", function () { closeVehicleColourPopover(root, false); });

  	    const outside = function (event) {
  	      if (!popup.isConnected) {
  	        document.removeEventListener("pointerdown", outside, true);
  	        return;
  	      }
  	      if (popup.contains(event.target) || control.contains(event.target)) return;
  	      closeVehicleColourPopover(root, false);
  	      document.removeEventListener("pointerdown", outside, true);
  	    };
  	    setTimeout(function () { document.addEventListener("pointerdown", outside, true); }, 0);
  	    popup.addEventListener("keydown", function (event) {
  	      if (event.key === "Escape") {
  	        closeVehicleColourPopover(root, true);
  	        trigger.focus();
  	      }
  	    });

  	    updateMarker();
  	    enhanceDashboardNumberInputs(popup);
  	    requestAnimationFrame(function () {
  	      positionVehicleColourPopover(popup, trigger);
  	      hexInput.focus();
  	      hexInput.select();
  	    });
  	  }

  	  function bindVehicleColourPickers(root) {
  	    root.querySelectorAll("[data-vm-colour-control]").forEach(function (control) {
  	      const input = control.querySelector("[data-vm-colour-value]");
  	      const trigger = control.querySelector("[data-vm-colour-trigger]");
  	      const output = control.querySelector("[data-vm-colour-output]");
  	      if (!input || !trigger) return;
  	      const sync = function () {
  	        const value = safeColor(input.value, "#cc6633");
  	        input.value = value;
  	        control.style.setProperty("--selected-colour", value);
  	        if (output) output.textContent = value.toUpperCase();
  	      };
  	      trigger.addEventListener("click", function () { openVehicleColourPopover(root, control, input); });
  	      input.addEventListener("input", sync);
  	      input.addEventListener("change", sync);
  	      sync();
  	    });
  	  }

  	  function decimalPlaces(value) {
  	    const text = String(value == null ? "" : value);
  	    if (/e-/i.test(text)) return Number(text.split(/e-/i)[1]) || 0;
  	    const point = text.indexOf(".");
  	    return point === -1 ? 0 : text.length - point - 1;
  	  }

  	  function fifDashboardNumberStepConfig(input) {
  	    const customStep = clean(input && input.getAttribute && input.getAttribute("data-fif-step-value"));
  	    const nativeStep = clean(input && input.getAttribute && input.getAttribute("step"));
  	    const stepText = customStep || nativeStep;
  	    const parsedStep = stepText && stepText !== "any" ? Number(stepText) : 1;
  	    const decimalsText = clean(input && input.getAttribute && input.getAttribute("data-fif-decimals"));
  	    const parsedDecimals = decimalsText === "" ? null : Number(decimalsText);

  	    return {
  	      step: Number.isFinite(parsedStep) && parsedStep > 0 ? parsedStep : 1,
  	      decimals: Number.isFinite(parsedDecimals)
  	        ? Math.max(0, Math.min(8, Math.floor(parsedDecimals)))
  	        : null
  	    };
  	  }

  	  function enhanceDashboardNumberInputs(scope) {
  	    if (!scope || !scope.querySelectorAll) return;
  	    scope.querySelectorAll('input[type="number"]:not([data-fif-number-enhanced]):not([data-fif-number-native])').forEach(function (input) {
  	      if (input.hasAttribute("data-axle-field") || input.closest(".fifvm-original-tyre-section") || input.closest('[data-fif-main-surface="exact-original-tractor-manager"]')) return;
  	      input.setAttribute("data-fif-number-enhanced", "true");
  	      const shell = document.createElement("span");
  	      shell.className = "fifvm-number-shell";
  	      input.parentNode.insertBefore(shell, input);
  	      shell.appendChild(input);
  	      const controls = document.createElement("span");
  	      controls.className = "fifvm-number-steppers";
  	      controls.innerHTML = '<button type="button" data-fif-number-step="up" aria-label="Increase value"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 10l4-4 4 4"></path></svg></button><button type="button" data-fif-number-step="down" aria-label="Decrease value"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4"></path></svg></button>';
  	      shell.appendChild(controls);

  	      function adjust(direction) {
  	        if (input.disabled || input.readOnly) return;
  	        const stepConfig = fifDashboardNumberStepConfig(input);
  	        const step = stepConfig.step;
  	        const minimum = input.getAttribute("min") !== null && input.getAttribute("min") !== "" ? Number(input.getAttribute("min")) : null;
  	        const maximum = input.getAttribute("max") !== null && input.getAttribute("max") !== "" ? Number(input.getAttribute("max")) : null;
  	        let current = input.value === "" ? 0 : Number(input.value);
  	        if (!Number.isFinite(current)) current = 0;
  	        let next = current + direction * step;
  	        if (minimum !== null && Number.isFinite(minimum)) next = Math.max(minimum, next);
  	        if (maximum !== null && Number.isFinite(maximum)) next = Math.min(maximum, next);
  	        const precision = stepConfig.decimals !== null
  	          ? stepConfig.decimals
  	          : Math.min(8, Math.max(decimalPlaces(step), decimalPlaces(current)));
  	        input.value = precision
  	          ? (stepConfig.decimals !== null
  	              ? next.toFixed(precision)
  	              : next.toFixed(precision).replace(/0+$/, "").replace(/\.$/, ""))
  	          : String(Math.round(next));
  	        input.dispatchEvent(new Event("input", { bubbles: true }));
  	        input.dispatchEvent(new Event("change", { bubbles: true }));
  	        input.focus();
  	      }

  	      controls.querySelector('[data-fif-number-step="up"]').addEventListener("click", function () { adjust(1); });
  	      controls.querySelector('[data-fif-number-step="down"]').addEventListener("click", function () { adjust(-1); });
  	    });
  	  }

  	  function fifDirectChild(parent, selector) {
  	    if (!parent || !parent.children) return null;
  	    for (let index = 0; index < parent.children.length; index += 1) {
  	      const child = parent.children[index];
  	      if (child && child.matches && child.matches(selector)) return child;
  	    }
  	    return null;
  	  }

  	  function fifMoveToHeader(node, header) {
  	    if (node && header && node.parentNode !== header) header.appendChild(node);
  	    return node;
  	  }

  	  function fifMoveChildren(source, target) {
  	    if (!source || !target) return;
  	    while (source.firstChild) target.appendChild(source.firstChild);
  	  }



  	  function fifSplitServiceWorkspace(scroller, header) {
  	    const root = scroller.querySelector(".fifvsvc-root");
  	    if (!root) return;
  	    const head = fifDirectChild(root, ".fifvsvc-head");
  	    const tabs = fifDirectChild(root, ".fifvsvc-tabs");
  	    const body = fifDirectChild(root, ".fifvsvc-body");
  	    fifMoveToHeader(head, header);
  	    fifMoveToHeader(tabs, header);
  	    if (body) {
  	      const kpis = fifDirectChild(body, ".fifvsvc-kpis");
  	      const filterbar = body.querySelector(":scope > .fifsp-job-view > .fifsp-filterbar, :scope > .fifsp-provider-view > .fifsp-filterbar, :scope > .fifsp-filterbar");
  	      if (kpis) fifMoveToHeader(kpis, header);
  	      if (filterbar) fifMoveToHeader(filterbar, header);
  	      fifMoveChildren(body, scroller);
  	    }
  	    root.remove();
  	  }

  	  function fifSplitMaintenanceWorkspace(scroller, header) {
  	    const root = scroller.querySelector(".fifmnt-root");
  	    if (!root) return;
  	    [".fifmnt-head", ".fifmnt-kpis", ".fifmnt-toolbar"].forEach(function (selector) {
  	      fifMoveToHeader(fifDirectChild(root, selector), header);
  	    });
  	    fifMoveChildren(root, scroller);
  	    root.remove();
  	  }

  	  function fifSplitComplianceWorkspace(scroller,header) {
  	    const root=scroller.querySelector(".fifcmp-root"); if(!root)return;
  	    fifMoveToHeader(fifDirectChild(root,".fifcmp-head"),header);
  	    fifMoveToHeader(fifDirectChild(root,".fifcmp-summary"),header);
  	    fifMoveChildren(root,scroller); root.remove();
  	  }

  	  function fifSplitTyreWorkspace(scroller, header) {
  	    const original = scroller.querySelector(".fifvm-original-tyre-section");
  	    if (original) {
  	      const heading = fifDirectChild(original, ".fifvm-original-tyre-heading");
  	      if (heading) fifMoveToHeader(heading, header);
  	      original.classList.add("fifvm-original-tyre-body");
  	      return;
  	    }
  	    const actionBar = fifDirectChild(scroller, ".fifvm-tyre-actions");
  	    const captureBar = fifDirectChild(scroller, ".fifvm-tyre-capture");
  	    if (actionBar) fifMoveToHeader(actionBar, header);
  	    if (captureBar) fifMoveToHeader(captureBar, header);
  	  }

  	  function fifDirectChildHeading(group) {
  	    const children = Array.from(group && group.children ? group.children : []);
  	    return children.find(function (child) {
  	      return child && (child.tagName === "HEADER" || child.tagName === "H2" || child.tagName === "H3" || child.tagName === "H4");
  	    }) || null;
  	  }

  	  function fifAccordionToggleMarkup() {
  	    return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 10 5 5 5-5"></path></svg>`;
  	  }

  	  function enhanceCollapsibleGroups(scope) {
  	    const host = scope || document.getElementById(ROOT_ID);
  	    if (!host || !host.querySelectorAll) return;
  	    const selectors = [
  	      ".fifsp-form > section"
  	    ];
  	    const groups = [];
  	    selectors.forEach(function (selector) {
  	      host.querySelectorAll(selector).forEach(function (group) {
  	        if (groups.indexOf(group) === -1) groups.push(group);
  	      });
  	    });

  	    groups.forEach(function (group, index) {
  	      if (!group || group.getAttribute("data-fif-collapsible-ready") === "true") return;
  	      let summary = fifDirectChildHeading(group);
  	      if (!summary) return;

  	      if (summary.tagName !== "HEADER") {
  	        const wrapper = document.createElement("div");
  	        wrapper.className = "fif-collapse-summary";
  	        group.insertBefore(wrapper, summary);
  	        wrapper.appendChild(summary);
  	        summary = wrapper;
  	      } else {
  	        summary.classList.add("fif-collapse-summary");
  	      }

  	      const content = document.createElement("div");
  	      content.className = "fif-collapse-content";
  	      while (summary.nextSibling) content.appendChild(summary.nextSibling);
  	      group.appendChild(content);

  	      const titleNode = summary.querySelector("h2,h3,h4,strong") || summary;
  	      const title = clean(titleNode && titleNode.textContent) || ("Group " + (index + 1));
  	      const toggle = document.createElement("button");
  	      toggle.type = "button";
  	      toggle.className = "fif-collapse-toggle";
  	      toggle.setAttribute("aria-label", "Open " + title);
  	      toggle.setAttribute("aria-expanded", "false");
  	      toggle.innerHTML = fifAccordionToggleMarkup();
  	      summary.appendChild(toggle);

  	      summary.setAttribute("role", "button");
  	      summary.setAttribute("tabindex", "0");
  	      summary.setAttribute("aria-expanded", "false");
  	      group.classList.add("fif-collapse-group", "is-collapsed");
  	      group.setAttribute("data-fif-collapsible-ready", "true");
  	      content.hidden = true;

  	      function setOpen(open) {
  	        const expanded = !!open;
  	        content.hidden = !expanded;
  	        group.classList.toggle("is-open", expanded);
  	        group.classList.toggle("is-collapsed", !expanded);
  	        summary.setAttribute("aria-expanded", String(expanded));
  	        toggle.setAttribute("aria-expanded", String(expanded));
  	        toggle.setAttribute("aria-label", (expanded ? "Close " : "Open ") + title);
  	      }

  	      function activate(event) {
  	        const interactive = event.target && event.target.closest ? event.target.closest("a,input,select,textarea,label,button") : null;
  	        if (interactive && interactive !== toggle) return;
  	        if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") return;
  	        if (event.type === "keydown") event.preventDefault();
  	        setOpen(content.hidden);
  	      }

  	      summary.addEventListener("click", activate);
  	      summary.addEventListener("keydown", activate);
  	    });
  	  }

  	  function composeVehicleTabWorkspace(root) {
  	    const body = root && root.querySelector(".fifvm-body[data-vm-workspace-body]");
  	    if (!body || fifDirectChild(body, ".fifvm-tab-fixed")) return;
  	    const tab = clean(body.getAttribute("data-vm-workspace-body") || state.vehicleActiveTab || "physical");
  	    const fixed = document.createElement("div");
  	    fixed.className = "fifvm-tab-fixed fifvm-tab-fixed-" + tab;
  	    fixed.setAttribute("data-vm-tab-fixed", tab);
  	    const scroller = document.createElement("div");
  	    scroller.className = "fifvm-tab-scroll fifvm-tab-scroll-" + tab;
  	    scroller.setAttribute("data-vm-tab-scroll", tab);

  	    while (body.firstChild) scroller.appendChild(body.firstChild);
  	    body.appendChild(fixed);
  	    body.appendChild(scroller);

  	    const message = fifDirectChild(scroller, ".fifvm-message");
  	    if (message) fifMoveToHeader(message, fixed);

  	    if (tab === "physical") {
  	    } else if (tab === "service") fifSplitServiceWorkspace(scroller, fixed);
  	    else if (tab === "maintenance") fifSplitMaintenanceWorkspace(scroller, fixed);
  	    else if (tab === "compliance") fifSplitComplianceWorkspace(scroller, fixed);
  	    else if (tab === "tyres") fifSplitTyreWorkspace(scroller, fixed);

  	    if (!fixed.children.length) fixed.hidden = true;
  	  }

  	  function arrangeMountedOriginalTyreHeader(root) {
  	    const host = root && root.querySelector("#fif-original-tyre-inline-host");
  	    if (!host) return;
  	    const divs = Array.from(host.querySelectorAll("div"));
  	    const action = divs.find(function (node) {
  	      const text = clean(node.textContent);
  	      return text.indexOf("Tyre Actions") === 0 && text.length < 500;
  	    });
  	    if (action) {
  	      action.setAttribute("data-fif-fixed-tyre-actions", "true");
  	      action.style.position = "sticky";
  	      action.style.top = "0";
  	      action.style.zIndex = "35";
  	      action.style.borderRadius = "0";
  	      action.style.marginBottom = "0";
  	    }
  	    const legend = divs.find(function (node) {
  	      const text = clean(node.textContent);
  	      return text.length < 220 && text.indexOf("80-100%") !== -1 && text.indexOf("60-79%") !== -1 && text.indexOf("No data") !== -1 && node.children.length >= 5;
  	    });
  	    if (legend) {
  	      legend.setAttribute("data-fif-fixed-tyre-legend", "true");
  	      legend.style.position = "sticky";
  	      legend.style.top = action ? Math.max(60, action.getBoundingClientRect().height || 60) + "px" : "0";
  	      legend.style.zIndex = "34";
  	      legend.style.margin = "0";
  	      legend.style.padding = "7px 12px";
  	      legend.style.background = "#171c18";
  	      legend.style.borderBottom = "1px solid rgba(204,102,51,.22)";
  	    }
  	  }

  	  function bindVehicleWorkspaceScroll(root) {
  	    const workspace = root && root.querySelector(".fifdash-workspace");
  	    const manager = root && root.querySelector(".fifvm-manager");
  	    if (workspace) workspace.classList.remove("is-vehicle-workspace-scrolled");
  	    if (manager) manager.classList.remove("is-workspace-scrolled");
  	  }

  	  function bindVehicleManagerEvents(root,
  	    company) {
  	    const vehicle = selectedVehicle(company);
  	    if (!vehicle) return;

  	    bindVehicleColourPickers(root);

  	    root.querySelector("[data-vm-back]")?.addEventListener("click", async function () {
  	      if (
  	        fifVehicleWorkspaceHasUnsavedChanges(company, vehicle) &&
  	        !(await fifConfirmWorkspaceDiscard("There are unsaved vehicle changes. Returning to the fleet will discard them."))
  	      ) return;
  	      state.selectedVehicleKey = "";
  	      state.vehicleActiveTab = "";
  	      state.vehicleServiceView = "position";
  	      clearVehicleEditorState();
  	      setVehicleMessage("", false);
  	      render();
  	    });

  	    const vehiclePrintablesWrap = root.querySelector(".fifvm-printables-wrap");
  	    const vehiclePrintablesToggle = root.querySelector("[data-vm-printables-toggle]");
  	    const vehicleQrButton = root.querySelector("[data-vm-print-vehicle-qr]");

  	    vehiclePrintablesToggle?.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      fifToggleVehiclePrintablesMenu(vehiclePrintablesToggle);
  	    });

  	    vehicleQrButton?.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      fifCloseVehiclePrintablesMenu(vehiclePrintablesWrap);
  	      fifOpenVehicleQrPrint(vehicle);
  	    });

  	    vehiclePrintablesWrap?.addEventListener("mouseleave", function () {
  	      fifCloseVehiclePrintablesMenu(vehiclePrintablesWrap);
  	    });

  	    vehiclePrintablesWrap?.addEventListener("focusout", function () {
  	      window.setTimeout(function () {
  	        if (!vehiclePrintablesWrap.contains(document.activeElement)) {
  	          fifCloseVehiclePrintablesMenu(vehiclePrintablesWrap);
  	        }
  	      }, 0);
  	    });

  	    root.querySelectorAll("[data-vm-tab]").forEach(function (button) {
  	      button.addEventListener("click", async function () {
  	        const requestedVehicleTab = button.getAttribute("data-vm-tab") || defaultVehicleManagerTab(vehicle);
  	        if (!userCanAccessVehicleTab(requestedVehicleTab, vehicle)) {
  	          await fifAlert("This function is not assigned in your Dashboard Settings.", {
  	            title: "Function Not Available",
  	            type: "warning",
  	            confirmText: "Close"
  	          });
  	          return;
  	        }
  	        if (
  	          requestedVehicleTab !== state.vehicleActiveTab &&
  	          fifVehicleWorkspaceHasUnsavedChanges(company, vehicle) &&
  	          !(await fifConfirmWorkspaceDiscard("There are unsaved changes in this vehicle workspace. Changing tabs will discard them."))
  	        ) return;

  	            closeExactOriginalTyreManager();
  	        state.vehicleActiveTab = requestedVehicleTab;
  	        if (requestedVehicleTab !== "physical") {
  	          state.vehicleDataEditMode = false;
  	          state.vehicleDataDraft = null;
  	          state.vehicleDataOriginal = null;
  	          state.vehicleDataEssentialDirty = false;
  	          state.vehicleIdentityEditMode = false;
  	          state.vehicleIdentityDraft = null;
  	          state.vehicleIdentityOriginal = null;
  	          state.vehicleIdentityDirty = false;
  	          state.vehicleDataDirty = false;
  	        }
  	        if (requestedVehicleTab === "service" && !state.vehicleServiceView) state.vehicleServiceView = "position";
  	                state.tyreSourcePosition = "";
  	        if (state.vehicleActiveTab !== "tyres") {
  	          state.tyreDraft = null;
  	          state.tyreObjectDrafts = {};
  	          state.tyreVehicleDraft = null;
  	          state.tyreChangedIds = {};
  	          state.axleConfigMode = false;
  	          state.tyreOriginalDraft = null;
  	          state.tyreRemovalMeta = {};
  	          state.tyreRemoveRequest = null;
  	          state.tyreMismatchApprovals = {};
  	          state.tyreOperationNotes = "";
  	          resetTyreInteractionSources();
  	        }
  	        render();
  	      });
  	    });

  	    root.querySelector("[data-vm-service-form]")?.addEventListener("submit",
  	      function (event) {
  	        event.preventDefault();
  	        appendWorkshopRecord(company, "service", event.currentTarget);
  	      });

  	    root.querySelector("[data-vm-maintenance-form]")?.addEventListener("submit",
  	      function (event) {
  	        event.preventDefault();
  	        appendWorkshopRecord(company, "maintenance", event.currentTarget);
  	      });

  	    root.querySelector("[data-vm-compliance-form]")?.addEventListener("submit",
  	      function (event) {
  	        event.preventDefault();
  	        appendWorkshopRecord(company, "compliance", event.currentTarget);
  	      });

  	    root.querySelectorAll("[data-vm-tyre-mode]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const nextMode = button.getAttribute("data-vm-tyre-mode") || "";
  	        state.tyreMode = state.tyreMode === nextMode ? "": nextMode;
  	        resetTyreInteractionSources();
  	        state.tyreRemoveRequest = null;
  	        if (!state.tyreVehicleDraft) state.tyreVehicleDraft = cloneData(vehicle);
  	        if (!state.tyreDraft) state.tyreDraft = currentTPositions(state.tyreVehicleDraft);
  	        if (!state.tyreOriginalDraft) state.tyreOriginalDraft = currentTPositions(vehicle);
  	        setVehicleMessage(state.tyreMode ? prettyFieldName(state.tyreMode) + " mode enabled.": "Tyre movement mode closed.", false);
  	        render();
  	      });
  	    });

  	    root.querySelector("[data-vm-tyre-cancel]")?.addEventListener("click", async function () {
  	      if (tyrePlanRows(company, vehicle).length || tyrePlanHasAxleChanges(vehicle)) {
  	        const approved = await fifConfirm("All unsaved tyre movements, removals, mismatch approvals and axle-layout changes will be discarded.", {
  	          title: "Clear Tyre Plan?",
  	          type: "warning",
  	          confirmText: "Clear Plan",
  	          cancelText: "Keep Working"
  	        });
  	        if (!approved) return;
  	      }
  	      state.tyreVehicleDraft = cloneData(vehicle);
  	      state.tyreDraft = currentTPositions(state.tyreVehicleDraft);
  	      state.tyreOriginalDraft = currentTPositions(vehicle);
  	      state.tyreMode = "";
  	      state.tyreChangedIds = {};
  	      state.tyreObjectDrafts = {};
  	      state.axleConfigMode = false;
  	      state.tyreRemovalMeta = {};
  	      state.tyreRemoveRequest = null;
  	      state.tyreMismatchApprovals = {};
  	      state.tyreOperationNotes = "";
  	      resetTyreInteractionSources();
  	      setVehicleMessage("Tyre plan cleared.", false);
  	      render();
  	    });

  	    root.querySelector("[data-vm-tyre-odometer]")?.addEventListener("input",
  	      function (event) {
  	        state.tyreOperationOdometer = event.currentTarget.value;
  	      });
  	    root.querySelector("[data-vm-tyre-notes]")?.addEventListener("input",
  	      function (event) {
  	        state.tyreOperationNotes = event.currentTarget.value;
  	      });

  	    root.querySelectorAll("[data-vm-warehouse-tyre]").forEach(function (button) {
  	      const id = button.getAttribute("data-vm-warehouse-tyre") || "";
  	      button.addEventListener("click", function () {
  	        if (state.tyreMode !== "allocate") {
  	          state.tyreDetailsRequest = {
  	            PositionKey: "Warehouse",
  	            TyreObjectId: id
  	          };
  	          setVehicleMessage("Showing complete warehouse tyre data.", false);
  	          render();
  	          return;
  	        }
  	        setTyreTapSource({
  	          SourceType: "warehouse", TyreObjectId: id, SourcePosition: ""
  	        });
  	        setVehicleMessage("Warehouse tyre selected. Tap a vehicle position or drag it onto the layout.", false);
  	        render();
  	      });
  	      button.addEventListener("dragstart",
  	        function (event) {
  	          if (state.tyreMode !== "allocate") {
  	            event.preventDefault(); return;
  	          }
  	          const source = {
  	            SourceType: "warehouse",
  	            TyreObjectId: id,
  	            SourcePosition: ""
  	          };
  	          state.tyreDragSource = source;
  	          state.tyreTapSource = null;
  	          button.classList.add("dragging");
  	          if (event.dataTransfer) {
  	            event.dataTransfer.effectAllowed = "move";
  	            event.dataTransfer.setData("text/plain", JSON.stringify(source));
  	          }
  	        });
  	      button.addEventListener("dragend",
  	        function () {
  	          button.classList.remove("dragging");
  	          state.tyreDragSource = null;
  	          state.tyreDragOverPosition = "";
  	        });
  	    });

  	    root.querySelectorAll("[data-vm-tyre-slot]").forEach(function (button) {
  	      const positionKey = button.getAttribute("data-vm-tyre-slot") || "";
  	      const fittedTyreId = button.getAttribute("data-vm-fitted-tyre") || "";

  	      button.addEventListener("dragstart",
  	        function (event) {
  	          if (!fittedTyreId || (state.tyreMode !== "rotate" && state.tyreMode !== "allocate")) {
  	            event.preventDefault(); return;
  	          }
  	          const source = {
  	            SourceType: "fitted",
  	            TyreObjectId: fittedTyreId,
  	            SourcePosition: positionKey
  	          };
  	          state.tyreDragSource = source;
  	          state.tyreTapSource = null;
  	          button.style.opacity = "0.45";
  	          if (event.dataTransfer) {
  	            event.dataTransfer.effectAllowed = "move";
  	            event.dataTransfer.setData("text/plain", JSON.stringify(source));
  	          }
  	        });

  	      button.addEventListener("dragend",
  	        function () {
  	          button.style.opacity = "1";
  	          state.tyreDragSource = null;
  	          state.tyreDragOverPosition = "";
  	        });

  	      button.addEventListener("dragover",
  	        function (event) {
  	          if (state.tyreMode !== "rotate" && state.tyreMode !== "allocate") return;
  	          const source = state.tyreDragSource;
  	          if (source && !tyreSourceAllowed(source)) return;
  	          event.preventDefault();
  	          state.tyreDragOverPosition = positionKey;
  	          if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
  	          button.classList.add("drag-over");
  	        });

  	      button.addEventListener("dragleave",
  	        function () {
  	          button.classList.remove("drag-over");
  	          if (state.tyreDragOverPosition === positionKey) state.tyreDragOverPosition = "";
  	        });

  	      button.addEventListener("drop",
  	        async function (event) {
  	          event.preventDefault();
  	          button.classList.remove("drag-over");
  	          let source = state.tyreDragSource;
  	          if (!source && event.dataTransfer) {
  	            try {
  	              source = JSON.parse(event.dataTransfer.getData("text/plain"));
  	            } catch (_) {
  	              source = null;
  	            }
  	          }
  	          state.tyreDragOverPosition = "";
  	          await applyTyreDrop(company, vehicle, source, positionKey);
  	          render();
  	        });

  	      button.addEventListener("click",
  	        async function () {
  	          if (state.tyreMode === "remove") {
  	            openTyreRemoval(company, vehicle, positionKey);
  	            render();
  	            return;
  	          }
  	          if (state.tyreMode === "rotate" || state.tyreMode === "allocate") {
  	            if (state.tyreTapSource) {
  	              await applyTyreDrop(company, vehicle, state.tyreTapSource, positionKey);
  	              render();
  	              return;
  	            }
  	            if (fittedTyreId) {
  	              if (state.tyreMode === "rotate" || state.tyreMode === "allocate") {
  	                setTyreTapSource({
  	                  SourceType: "fitted", TyreObjectId: fittedTyreId, SourcePosition: positionKey
  	                });
  	                setVehicleMessage("Source selected at " + positionKey + ". Tap a target position or drag the tyre.", false);
  	                render();
  	              }
  	              return;
  	            }
  	            setVehicleMessage(state.tyreMode === "allocate" ? "Select or drag a warehouse tyre first.": "Select a fitted tyre first.", true);
  	            render();
  	            return;
  	          }
  	          state.tyreSourcePosition = positionKey;
  	          if (fittedTyreId) {
  	            state.tyreDetailsRequest = {
  	              PositionKey: positionKey,
  	              TyreObjectId: fittedTyreId
  	            };
  	            setVehicleMessage("Showing complete tyre data for " + positionKey + ".", false);
  	          } else {
  	            setVehicleMessage("Position " + positionKey + " is empty.", false);
  	          }
  	          render();
  	        });
  	    });

  	    root.querySelectorAll("[data-vm-remove-cancel]").forEach(function (button) {
  	      button.addEventListener("click",
  	        function () {
  	          state.tyreRemoveRequest = null; render();
  	        });
  	    });
  	    root.querySelector("[data-vm-remove-backdrop]")?.addEventListener("click", function (event) {
  	      if (event.target === event.currentTarget) {
  	        state.tyreRemoveRequest = null; render();
  	      }
  	    });
  	    root.querySelector("[data-vm-remove-confirm]")?.addEventListener("click",
  	      function () {
  	        const destination = root.querySelector("[data-vm-remove-destination]")?.value || "Warehouse";
  	        const odometer = root.querySelector("[data-vm-remove-odometer]")?.value || "";
  	        const notes = root.querySelector("[data-vm-remove-notes]")?.value || "";
  	        confirmTyreRemoval(company, vehicle, destination, odometer, notes);
  	        render();
  	      });

  	    root.querySelector("[data-vm-axle-config]")?.addEventListener("click",
  	      function () {
  	        if (!CAN_EDIT_VEHICLE_PHYSICAL) return;
  	        if (!state.tyreVehicleDraft) state.tyreVehicleDraft = cloneData(vehicle);
  	        if (!state.tyreDraft) state.tyreDraft = currentTPositions(state.tyreVehicleDraft);
  	        state.axleConfigMode = !state.axleConfigMode;
  	        state.tyreMode = "";
  	        state.tyreSourcePosition = "";
  	        setVehicleMessage(state.axleConfigMode ? "Axle configuration enabled.": "Axle configuration closed.", false);
  	        render();
  	      });

  	    root.querySelectorAll("[data-vm-legacy-axle-action]").forEach(function (button) {
  	      button.addEventListener("click", async function () {
  	        if (!CAN_EDIT_VEHICLE_PHYSICAL || !state.tyreDraft) return;

  	        const action = button.getAttribute("data-vm-legacy-axle-action") || "";
  	        const before = cloneData(state.tyreDraft);
  	        let result = {
  	          ok: true,
  	          orphaned: []
  	        };
  	        let message = "Axle configuration updated.";

  	        if (action === "add-axle") {
  	          const maxAxle = arr(state.tyreDraft.Axles).reduce(function (max, axle) {
  	            return Math.max(max, Number(axle.Axle || 0));
  	          }, 0);
  	          state.tyreDraft.Axles.push({
  	            Axle: maxAxle + 1, Type: state.selectedAssetType === "trailer" ? "Trailer" : "Drive", TyresPerSide: 1, WearRate: 1, Enabled: true
  	          });
  	          result = rebuildTyrePositionsFromAxles(state.tyreDraft);
  	          message = "Axle added to the draft layout.";
  	        } else if (action === "add-spare") {
  	          const hasSpare = arr(state.tyreDraft.Axles).some(function (axle) {
  	            return clean(axle.Type) === "Spare";
  	          });
  	          if (hasSpare) {
  	            setVehicleMessage("Only one spare position is allowed.", true);
  	            render();
  	            return;
  	          }
  	          const maxAxle = arr(state.tyreDraft.Axles).reduce(function (max, axle) {
  	            return Math.max(max, Number(axle.Axle || 0));
  	          }, 0);
  	          state.tyreDraft.Axles.push({
  	            Axle: maxAxle + 1, Type: "Spare", TyresPerSide: 1, WearRate: 1, Enabled: true
  	          });
  	          result = rebuildTyrePositionsFromAxles(state.tyreDraft);
  	          message = "Spare position added.";
  	        } else if (action.indexOf("preset-") === 0) {
  	          result = legacyAxlePreset(state.tyreDraft, action.replace("preset-", ""));
  	          message = action.replace("preset-", "").toUpperCase() + " preset applied.";
  	        } else if (action === "clear-config") {
  	          const approved = await fifConfirm("This will remove every axle and generated tyre position from the unsaved layout. Fitted tyres prevent the action from completing.", {
  	            title: "Clear Axle Configuration?",
  	            type: "danger",
  	            confirmText: "Clear Configuration",
  	            cancelText: "Cancel"
  	          });
  	          if (!approved) return;
  	          const fitted = Object.keys(state.tyreDraft.Positions || {}).filter(function (key) {
  	            return clean(state.tyreDraft.Positions[key] && state.tyreDraft.Positions[key].TyreObjectId);
  	          });
  	          if (fitted.length) {
  	            setVehicleMessage("The configuration cannot be cleared while tyres are fitted: " + fitted.join(", "), true);
  	            return;
  	          }
  	          state.tyreDraft.Axles = [];
  	          state.tyreDraft.Positions = {};
  	          state.tyreDraft.Summary = tyrePositionSummary(state.tyreDraft);
  	          message = "Tyre axle configuration cleared.";
  	        } else if (action === "remove-axle") {
  	          const row = button.closest("[data-vm-legacy-axle-index]");
  	          const index = Number(row && row.getAttribute("data-vm-legacy-axle-index"));
  	          if (!Number.isFinite(index)) return;
  	          state.tyreDraft.Axles.splice(index, 1);
  	          result = rebuildTyrePositionsFromAxles(state.tyreDraft);
  	          message = "Axle removed from the draft layout.";
  	        }

  	        if (!result.ok) {
  	          state.tyreDraft = before;
  	          setVehicleMessage("That change would orphan fitted tyres: " + result.orphaned.join(", "), true);
  	        } else {
  	          setVehicleMessage(message, false);
  	        }
  	        render();
  	      });
  	    });

  	    root.querySelectorAll("[data-vm-legacy-axle-field]").forEach(function (input) {
  	      input.addEventListener("change",
  	        function () {
  	          if (!CAN_EDIT_VEHICLE_PHYSICAL || !state.tyreDraft) return;

  	          const row = input.closest("[data-vm-legacy-axle-index]");
  	          const index = Number(row && row.getAttribute("data-vm-legacy-axle-index"));
  	          const field = input.getAttribute("data-vm-legacy-axle-field") || "";
  	          const axle = arr(state.tyreDraft.Axles)[index];
  	          if (!Number.isFinite(index) || !axle) return;

  	          const before = cloneData(state.tyreDraft);

  	          if (field === "Type") {
  	            const newType = input.value;
  	            const steerCountWithoutCurrent = arr(state.tyreDraft.Axles).filter(function (item, itemIndex) {
  	              return itemIndex !== index && clean(item.Type) === "Steer";
  	            }).length;
  	            const spareCountWithoutCurrent = arr(state.tyreDraft.Axles).filter(function (item, itemIndex) {
  	              return itemIndex !== index && clean(item.Type) === "Spare";
  	            }).length;

  	            if (newType === "Steer" && steerCountWithoutCurrent >= 2) {
  	              setVehicleMessage("A tractor cannot have more than two Steer axles.", true);
  	              render();
  	              return;
  	            }
  	            if (newType === "Spare" && spareCountWithoutCurrent >= 1) {
  	              setVehicleMessage("Only one spare position is allowed.", true);
  	              render();
  	              return;
  	            }

  	            axle.Type = newType;
  	            if (newType === "Steer" || newType === "Spare") axle.TyresPerSide = 1;
  	            if (newType !== "Tag") axle.WearRate = 1;
  	          } else if (field === "Axle") {
  	            axle.Axle = Math.max(1, Number(input.value || 1));
  	          } else if (field === "TyresPerSide") {
  	            axle.TyresPerSide = Math.max(1, Math.min(2, Math.round(Number(input.value || 1))));
  	          } else if (field === "WearRate") {
  	            axle.WearRate = Math.max(0, Math.min(1, Number(input.value || 1)));
  	          }

  	          const result = rebuildTyrePositionsFromAxles(state.tyreDraft);
  	          if (!result.ok) {
  	            state.tyreDraft = before;
  	            setVehicleMessage("That change would orphan fitted tyres: " + result.orphaned.join(", "), true);
  	          } else {
  	            setVehicleMessage("Axle configuration updated in the draft layout.", false);
  	          }
  	          render();
  	        });
  	    });

  	    root.querySelectorAll("[data-vm-open-tyre-details]").forEach(function (button) {
  	      button.addEventListener("click",
  	        function () {
  	          state.tyreDetailsRequest = {
  	            TyreObjectId: button.getAttribute("data-vm-open-tyre-details") || "",
  	            PositionKey: button.getAttribute("data-vm-tyre-position") || ""
  	          };
  	          render();
  	        });
  	    });

  	    root.querySelectorAll("[data-vm-tyre-details-close]").forEach(function (button) {
  	      button.addEventListener("click",
  	        function () {
  	          state.tyreDetailsRequest = null; render();
  	        });
  	    });
  	    root.querySelector("[data-vm-tyre-details-backdrop]")?.addEventListener("click", function (event) {
  	      if (event.target === event.currentTarget) {
  	        state.tyreDetailsRequest = null; render();
  	      }
  	    });

  	    root.querySelectorAll("[data-vm-print-tyre]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const id = button.getAttribute("data-vm-print-tyre") || "";
  	        const position = button.getAttribute("data-vm-tyre-position") || (state.tyreDetailsRequest && state.tyreDetailsRequest.PositionKey) || "";
  	        const tyre = workingTyre(company, id) || findCompanyTyre(company, id);
  	        printIndividualTyreReport(company, tyre, vehicle, position);
  	      });
  	    });

  	    root.querySelector("[data-vm-print-plan]")?.addEventListener("click",
  	      function () {
  	        printTyrePlanReport(company, vehicle);
  	      });
  	    root.querySelector("[data-vm-print-register]")?.addEventListener("click",
  	      function () {
  	        printVehicleTyreRegister(company, vehicle);
  	      });

  	    root.querySelector("[data-vm-save-tyres]")?.addEventListener("click",
  	      function () {
  	        saveTyrePlan(company);
  	      });

  	    bindVehicleServiceWorkspaceEvents(root,
  	      company,
  	      vehicle);
  	    bindV21VehicleEvents(root,
  	      company,
  	      vehicle);
  	    bindExactOriginalTyreWrapperEvents(root);
  	  }

  	  const SERVICE_PROVIDER_CATEGORIES = [
  	    "General Service", "Mechanical", "Diagnostics", "Electrical", "Tyres",
  	    "Towing", "Bodywork", "Hydraulics", "Air Conditioning", "Auto Glass",
  	    "OEM Dealer", "Roadside Assistance", "Fuel Systems", "Transmission"
  	  ];
  	  const SERVICE_JOB_TYPES = [
  	    "Scheduled Service", "Preventive Service", "Inspection", "Breakdown",
  	    "Mechanical Repair", "Diagnostics", "Electrical Repair", "Tyre Work",
  	    "Bodywork", "Towing", "Warranty Work", "Other"
  	  ];
  	  const SERVICE_JOB_STATUSES = ["Scheduled", "Booked", "In Progress", "Waiting Parts", "Ready", "Completed", "Cancelled"];
  	  const SERVICE_JOB_OPEN_STATUSES = ["Scheduled", "Booked", "In Progress", "Waiting Parts", "Ready"];
  	  let CAN_MANAGE_SERVICE_PROVIDERS = false;
  	  let CAN_MANAGE_SERVICE_JOBS = false;

  	  function refreshServicePortalPermissions() {
  	    CAN_MANAGE_SERVICE_PROVIDERS = CAN_ACCESS_SERVICE;
  	    CAN_MANAGE_SERVICE_JOBS = CAN_ACCESS_SERVICE || CAN_ACCESS_MAINTENANCE;
  	  }

  	  refreshServicePortalPermissions();
  	  const SERVICE_MODAL_ID = "fif-service-portal-modal";

  	  const SERVICE_JOB_PHASE_RULES = {
  	    "Scheduled": {
  	      description: "Work has been raised and proposed, but the provider has not yet confirmed the booking.",
  	      next: ["Booked", "In Progress", "Completed", "Cancelled"],
  	      primary: "Booked",
  	      primaryLabel: "Confirm Booking"
  	    },
  	    "Booked": {
  	      description: "The provider has confirmed the work, date and responsibility for the job.",
  	      next: ["In Progress", "Completed", "Scheduled", "Cancelled"],
  	      primary: "In Progress",
  	      primaryLabel: "Start Work"
  	    },
  	    "In Progress": {
  	      description: "The asset is with the provider or workshop and work is actively underway.",
  	      next: ["Waiting Parts", "Ready", "Completed", "Cancelled"],
  	      primary: "",
  	      primaryLabel: "Update Phase"
  	    },
  	    "Waiting Parts": {
  	      description: "Work is delayed. The reason and next review or expected-parts date must remain visible.",
  	      next: ["In Progress", "Ready", "Completed", "Cancelled"],
  	      primary: "",
  	      primaryLabel: "Update Delay"
  	    },
  	    "Ready": {
  	      description: "Work is finished and the asset is awaiting inspection, acceptance or collection.",
  	      next: ["Completed", "In Progress", "Waiting Parts", "Cancelled"],
  	      primary: "Completed",
  	      primaryLabel: "Complete Job"
  	    },
  	    "Completed": {
  	      description: "The asset has been accepted or returned and the operational job card is closed.",
  	      next: [],
  	      primary: "",
  	      primaryLabel: ""
  	    },
  	    "Cancelled": {
  	      description: "The job was cancelled or abandoned with an auditable reason.",
  	      next: [],
  	      primary: "",
  	      primaryLabel: ""
  	    }
  	  };

  	  function serviceCanonicalStatus(value) {
  	    const key = lower(value).replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  	    if (!key || key === "new" || key === "scheduled" || key === "planned") return "Scheduled";
  	    if (key === "booked" || key === "confirmed" || key === "booking confirmed") return "Booked";
  	    if (key === "in progress" || key === "at provider" || key === "workshop" || key === "started") return "In Progress";
  	    if (key === "waiting parts" || key === "waiting for parts" || key === "delayed" || key === "on hold") return "Waiting Parts";
  	    if (key === "ready" || key === "ready for collection" || key === "awaiting collection") return "Ready";
  	    if (key === "completed" || key === "complete" || key === "closed") return "Completed";
  	    if (key === "cancelled" || key === "canceled" || key === "abandoned") return "Cancelled";
  	    return clean(value) || "Scheduled";
  	  }

  	  function servicePhaseLabel(status) {
  	    const phase = serviceCanonicalStatus(status);
  	    if (phase === "Waiting Parts") return "Delayed / Waiting Parts";
  	    return phase;
  	  }

  	  function servicePhaseDescription(status) {
  	    const phase = serviceCanonicalStatus(status);
  	    return SERVICE_JOB_PHASE_RULES[phase] ? SERVICE_JOB_PHASE_RULES[phase].description : "";
  	  }

  	  function serviceAllowedTransitions(status) {
  	    const phase = serviceCanonicalStatus(status);
  	    return cloneData(SERVICE_JOB_PHASE_RULES[phase] ? SERVICE_JOB_PHASE_RULES[phase].next : []);
  	  }



  	  function serviceWorkflowHistory(order) {
  	    const direct = arr(order && order.WorkflowHistory);
  	    const data = arr(getDeep(order, ["Data", "WorkflowHistory"], []));
  	    const source = direct.length ? direct : data;
  	    return source.map(function (entry) {
  	      return {
  	        From: serviceCanonicalStatus(entry && entry.From),
  	        To: serviceCanonicalStatus(entry && entry.To),
  	        At: clean(entry && (entry.At || entry.Date || entry.UpdatedAt)),
  	        By: clean(entry && (entry.By || entry.User || entry.UpdatedBy)),
  	        Note: clean(entry && (entry.Note || entry.Reason || entry.Notes)),
  	        Mode: clean(entry && (entry.Mode || entry.Action || "Controlled transition")),
  	        Evidence: cloneData(entry && entry.Evidence || {})
  	      };
  	    }).filter(function (entry) {
  	      return entry.To && entry.At;
  	    });
  	  }



  	  function serviceTransitionAudit(order, target, note, mode, evidence) {
  	    const history = serviceWorkflowHistory(order);
  	    const from = serviceCanonicalStatus(order && order.Status);
  	    const to = serviceCanonicalStatus(target);
  	    const at = new Date().toISOString();
  	    const by = userDisplayName();
  	    history.push({
  	      From: from,
  	      To: to,
  	      At: at,
  	      By: by,
  	      Note: clean(note),
  	      Mode: clean(mode || "Controlled transition"),
  	      Evidence: cloneData(evidence || {})
  	    });
  	    return {
  	      WorkflowHistory: history,
  	      CurrentPhaseEnteredAt: at,
  	      CurrentPhaseEnteredBy: by,
  	      At: at,
  	      By: by
  	    };
  	  }

  	  function serviceTransitionValue(values, key) {
  	    if (!values) return "";
  	    if (values instanceof FormData) return values.get(key);
  	    return values[key];
  	  }

  	  function serviceApplyPhaseTransition(company, vehicle, order, target, values, options) {
  	    options = options || {};
  	    const current = serviceCanonicalStatus(order && order.Status);
  	    const next = serviceCanonicalStatus(target);
  	    const allowed = serviceAllowedTransitions(current);
  	    const retrospectiveCompletion = options.mode === "Completed service capture" && next === "Completed";
  	    if (allowed.indexOf(next) === -1 && !retrospectiveCompletion) {
  	      throw new Error(servicePhaseLabel(current) + " cannot move directly to " + servicePhaseLabel(next) + ". Use one of the permitted workshop phase actions.");
  	    }

  	    const transitionNote = clean(serviceTransitionValue(values, "TransitionNote") || serviceTransitionValue(values, "notes") || serviceTransitionValue(values, "Reason"));
  	    if (!transitionNote) throw new Error("Record a transition note. Every workshop phase change must explain what happened.");

  	    const providers = serviceProviders(company);
  	    const providerId = clean(serviceTransitionValue(values, "ProviderId") || order.ProviderId);
  	    const provider = providerId ? serviceProviderById(company, providerId) : null;
  	    const scheduledDate = maintenanceDateInput(serviceTransitionValue(values, "ScheduledDate") || order.ScheduledDate);
  	    const startedDate = maintenanceDateTimeInput(serviceTransitionValue(values, "StartedDate") || order.StartedDate || new Date());
  	    const completedDate = maintenanceDateInput(serviceTransitionValue(values, "CompletedDate") || order.CompletedDate || new Date());
  	    const odometer = numberOr(serviceTransitionValue(values, "Odometer"), numberOr(order.Odometer, null));
  	    const bookingReference = clean(serviceTransitionValue(values, "BookingReference") || order.BookingReference);
  	    const delayReason = clean(serviceTransitionValue(values, "DelayReason") || order.DelayReason);
  	    const delayExpectedDate = maintenanceDateInput(serviceTransitionValue(values, "DelayExpectedDate") || order.DelayExpectedDate);
  	    const workPerformed = clean(serviceTransitionValue(values, "WorkPerformed") || order.WorkPerformed);
  	    const actualCostRaw = serviceTransitionValue(values, "ActualCost");
  	    const actualCost = actualCostRaw === "" || actualCostRaw === null || actualCostRaw === undefined
  	      ? numberOr(order.ActualCost, null)
  	      : numberOr(actualCostRaw, null);

  	    if (next === "Booked") {
  	      if (!provider) throw new Error("Select the provider that confirmed the booking.");
  	      if (!scheduledDate) throw new Error("A confirmed booking requires a scheduled date.");
  	      if (!bookingReference) throw new Error("Enter the provider confirmation or booking reference.");
  	    }
  	    if (next === "In Progress") {
  	      if (!provider) throw new Error("Assign the provider or workshop before starting work.");
  	      if (!startedDate) throw new Error("Record when the asset arrived or work started.");
  	      if (odometer === null) throw new Error("Record the asset odometer when work starts.");
  	    }
  	    if (next === "Waiting Parts") {
  	      if (!delayReason) throw new Error("Record why the work is delayed.");
  	      if (!delayExpectedDate) throw new Error("Set the next review or expected-parts date.");
  	    }
  	    if (next === "Ready") {
  	      if (!workPerformed) throw new Error("Record the work performed before marking the asset Ready.");
  	    }
  	    if (next === "Completed") {
  	      if (!workPerformed) throw new Error("Record the work performed before completing the job.");
  	      if (odometer === null) throw new Error("Record the final odometer before completing the job.");
  	      if (!completedDate) throw new Error("Record the completion date.");
  	    }

  	    const evidence = {
  	      ProviderId: providerId,
  	      ProviderName: provider ? serviceProviderLabel(provider) : clean(order.ProviderName),
  	      ScheduledDate: scheduledDate,
  	      BookingReference: bookingReference,
  	      StartedDate: startedDate,
  	      Odometer: odometer,
  	      DelayReason: delayReason,
  	      DelayExpectedDate: delayExpectedDate,
  	      CompletedDate: completedDate,
  	      ActualCost: actualCost
  	    };
  	    const audit = serviceTransitionAudit(order, next, transitionNote, options.mode || "Controlled transition", evidence);
  	    const noteAudit = serviceAppendAuditNote(order, transitionNote, "Phase: " + servicePhaseLabel(current) + " → " + servicePhaseLabel(next));
  	    const updated = normalizeServiceWorkOrder(Object.assign({}, order, {
  	      Status: next,
  	      WorkflowHistory: audit.WorkflowHistory,
  	      CurrentPhaseEnteredAt: audit.CurrentPhaseEnteredAt,
  	      CurrentPhaseEnteredBy: audit.CurrentPhaseEnteredBy,
  	      Notes: noteAudit.Notes,
  	      NoteLog: noteAudit.NoteLog,
  	      UpdatedAt: audit.At,
  	      UpdatedBy: audit.By
  	    }));

  	    if (next === "Scheduled") {
  	      updated.ScheduledDate = scheduledDate || updated.ScheduledDate;
  	      updated.BookingReleasedAt = audit.At;
  	      updated.BookingReleasedBy = audit.By;
  	    }

  	    if (next === "Booked") {
  	      updated.ProviderId = provider.ProviderId;
  	      updated.ProviderName = serviceProviderLabel(provider);
  	      updated.ScheduledDate = scheduledDate;
  	      updated.BookingReference = bookingReference;
  	      updated.BookingConfirmedAt = audit.At;
  	      updated.BookingConfirmedBy = audit.By;
  	      updated.IsScheduled = true;
  	    }

  	    if (next === "In Progress") {
  	      updated.ProviderId = provider.ProviderId;
  	      updated.ProviderName = serviceProviderLabel(provider);
  	      updated.StartedDate = startedDate;
  	      updated.Odometer = odometer;
  	      updated.VehicleReceivedAt = audit.At;
  	      updated.VehicleReceivedBy = audit.By;
  	      updated.DowntimeStart = updated.DowntimeStart || startedDate;
  	      if (current === "Waiting Parts") {
  	        updated.DelayResolvedAt = audit.At;
  	        updated.DelayResolvedBy = audit.By;
  	      }
  	    }

  	    if (next === "Waiting Parts") {
  	      updated.DelayReason = delayReason;
  	      updated.DelayExpectedDate = delayExpectedDate;
  	      updated.DelayStartedAt = audit.At;
  	      updated.DelayStartedBy = audit.By;
  	    }

  	    if (next === "Ready") {
  	      updated.WorkPerformed = workPerformed;
  	      updated.ReadyAt = audit.At;
  	      updated.ReadyBy = audit.By;
  	      if (current === "Waiting Parts") {
  	        updated.DelayResolvedAt = audit.At;
  	        updated.DelayResolvedBy = audit.By;
  	      }
  	    }

  	    if (next === "Completed") {
  	      updated.WorkPerformed = workPerformed;
  	      updated.CompletedDate = completedDate;
  	      updated.Odometer = odometer;
  	      updated.ActualCost = actualCost;
  	      updated.DowntimeEnd = updated.DowntimeEnd || maintenanceDateTimeInput(new Date());
  	      updated.ClosedAt = audit.At;
  	      updated.ClosedBy = audit.By;
  	      updated.ClosureReason = options.mode === "Completed service capture"
  	        ? "Completed service captured and operational job closed"
  	        : "Workshop lifecycle completed";
  	      updated.CollectedAt = audit.At;
  	      updated.CollectedBy = audit.By;

  	      if (updated.Category === MAINTENANCE_CATEGORY_SERVICE) {
  	        const intervalKm = serviceConfiguredIntervalKm(vehicle);
  	        const calculatedNextKm = serviceNextIntervalMileage(odometer, intervalKm);
  	        if (calculatedNextKm !== null) updated.NextServiceKm = calculatedNextKm;
  	      }

  	      if (current === "Waiting Parts") {
  	        updated.DelayResolvedAt = audit.At;
  	        updated.DelayResolvedBy = audit.By;
  	      }
  	    }

  	    if (next === "Cancelled") {
  	      updated.ClosedAt = audit.At;
  	      updated.ClosedBy = audit.By;
  	      updated.ClosureReason = transitionNote;
  	      updated.CancelledAt = audit.At;
  	      updated.CancelledBy = audit.By;
  	      updated.DowntimeEnd = updated.DowntimeEnd || (updated.DowntimeStart ? maintenanceDateTimeInput(new Date()) : "");
  	    }

  	    return normalizeServiceWorkOrder(updated);
  	  }





  	  function serviceJobIsClosed(order) {
  	    return ["Completed", "Cancelled"].indexOf(serviceCanonicalStatus(order && order.Status)) !== -1;
  	  }

  	  function serviceJobIsOpen(order) {
  	    return !serviceJobIsClosed(order) && SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(order && order.Status)) !== -1;
  	  }

  	  function serviceJobRequiresReschedule(order) {
  	    const phase = serviceCanonicalStatus(order && order.Status);
  	    return !!(order && order.IsScheduled === true && clean(order.ScheduledDate) && ["Scheduled", "Booked"].indexOf(phase) !== -1);
  	  }

  	  function serviceAuditNoteLog(order) {
  	    const direct = arr(order && order.NoteLog);
  	    const data = arr(getDeep(order, ["Data", "NoteLog"], []));
  	    const source = direct.length ? direct : data;
  	    const normalized = source.map(function (entry) {
  	      if (typeof entry === "string") {
  	        return { At: "", By: "", Type: "Legacy note", Text: clean(entry) };
  	      }
  	      return {
  	        At: clean(entry && (entry.At || entry.Date || entry.CreatedAt)),
  	        By: clean(entry && (entry.By || entry.User || entry.CreatedBy)),
  	        Type: clean(entry && (entry.Type || entry.Action || "Note")),
  	        Text: clean(entry && (entry.Text || entry.Note || entry.Notes))
  	      };
  	    }).filter(function (entry) { return entry.Text; });

  	    if (!normalized.length) {
  	      const legacyText = clean(firstValue([
  	        getDeep(order, ["Data", "Notes"], ""),
  	        order && order.Notes
  	      ], ""));
  	      if (legacyText) {
  	        normalized.push({
  	          At: clean(firstValue([
  	            getDeep(order, ["Data", "CreatedAt"], ""),
  	            order && order.CreatedAt,
  	            order && order.created
  	          ], "")),
  	          By: clean(firstValue([
  	            getDeep(order, ["Data", "CreatedBy"], ""),
  	            order && order.CreatedBy
  	          ], "")),
  	          Type: "Legacy note",
  	          Text: legacyText
  	        });
  	      }
  	    }

  	    return normalized;
  	  }

  	  function serviceScheduleAudit(order) {
  	    return arr(order && order.ScheduleHistory).concat(arr(getDeep(order, ["Data", "ScheduleHistory"], []))).map(function (entry) {
  	      return {
  	        At: clean(entry && (entry.At || entry.Date || entry.UpdatedAt)),
  	        By: clean(entry && (entry.By || entry.User || entry.UpdatedBy)),
  	        PreviousDate: maintenanceDateInput(entry && (entry.PreviousDate || entry.FromDate)),
  	        NewDate: maintenanceDateInput(entry && (entry.NewDate || entry.ToDate)),
  	        Reason: clean(entry && (entry.Reason || entry.Notes))
  	      };
  	    }).filter(function (entry) { return entry.NewDate || entry.Reason; });
  	  }

  	  function serviceAppendAuditNote(order, note, type) {
  	    const addition = clean(note);
  	    const legacyText = clean(firstValue([
  	      getDeep(order, ["Data", "Notes"], ""),
  	      order && order.Notes
  	    ], ""));
  	    const log = serviceAuditNoteLog(order);

  	    if (!addition) {
  	      return {
  	        Notes: legacyText,
  	        NoteLog: log
  	      };
  	    }

  	    const at = new Date().toISOString();
  	    const by = userDisplayName();
  	    const noteType = clean(type || "Job note");

  	    log.push({
  	      At: at,
  	      By: by,
  	      Type: noteType,
  	      Text: addition
  	    });

  	    return {
  	      Notes: legacyText,
  	      NoteLog: log
  	    };
  	  }

  	  function serviceNoteEntryKey(entry) {
  	    entry = entry || {};
  	    return [
  	      clean(entry.At),
  	      clean(entry.By),
  	      clean(entry.Type),
  	      clean(entry.Text)
  	    ].join("\u241f");
  	  }

  	  function serviceAuditLogIsPrefix(previousOrder, incomingOrder) {
  	    const previousLog = serviceAuditNoteLog(previousOrder);
  	    const incomingLog = serviceAuditNoteLog(incomingOrder);

  	    if (incomingLog.length < previousLog.length) return false;

  	    for (let index = 0; index < previousLog.length; index += 1) {
  	      if (serviceNoteEntryKey(previousLog[index]) !== serviceNoteEntryKey(incomingLog[index])) {
  	        return false;
  	      }
  	    }

  	    return true;
  	  }

  	  function maintenanceNotesSummary(order, limit) {
  	    const maximum = Math.max(80, Math.min(240, numberOr(limit, 240)));
  	    const log = serviceAuditNoteLog(order);
  	    const latest = log.length ? log[log.length - 1] : null;

  	    let summary = latest
  	      ? (clean(latest.Type || "Note") + ": " + clean(latest.Text))
  	      : clean(firstValue([
  	          order && order.WorkPerformed,
  	          order && order.Complaint,
  	          getDeep(order, ["Data", "Notes"], ""),
  	          order && order.Notes
  	        ], ""));

  	    summary = summary.replace(/\s+/g, " ").trim();

  	    if (summary.length <= maximum) return summary;
  	    return summary.slice(0, Math.max(0, maximum - 1)).trimEnd() + "…";
  	  }

  	  function serviceNoteHistoryHtml(order) {
  	    const textValue = clean(order && order.Notes);
  	    const log = serviceAuditNoteLog(order);
  	    if (!textValue && !log.length) {
  	      return `<div class="fifsp-note-history empty">No notes have been recorded. New notes are permanently appended to the audit trail.</div>`;
  	    }
  	    const rows = log.length ? log.map(function (entry) {
  	      return `<article><div><strong>${escapeHtml(entry.Type || "Note")}</strong><span>${escapeHtml(entry.By || "Unknown user")}</span></div><time>${escapeHtml(entry.At ? serviceFormatDate(entry.At) : "Legacy")}</time><p>${escapeHtml(entry.Text)}</p></article>`;
  	    }).join("") : `<pre>${escapeHtml(textValue)}</pre>`;
  	    return `<div class="fifsp-note-history"><div class="fifsp-note-history-title">Permanent note history</div>${rows}</div>`;
  	  }

  	  function serviceScheduleHistoryHtml(order) {
  	    const history = serviceScheduleAudit(order);
  	    if (!history.length) return "";
  	    return `<div class="fifsp-schedule-history"><strong>Reschedule history</strong>${history.slice().reverse().map(function (entry) {
  	      return `<div><span>${escapeHtml(serviceFormatDate(entry.PreviousDate))} → ${escapeHtml(serviceFormatDate(entry.NewDate))}</span><small>${escapeHtml(entry.Reason || "No reason recorded")} · ${escapeHtml(entry.By || "Unknown user")}</small></div>`;
  	    }).join("")}</div>`;
  	  }

  	  function serviceSetDescriptor(root, path, value, selector, unitType) {
  	    const parent = ensureObject(root, path.slice(0, -1));
  	    const key = path[path.length - 1];
  	    const existing = parent[key];
  	    if (existing && typeof existing === "object" && !Array.isArray(existing) && Object.prototype.hasOwnProperty.call(existing, "value")) {
  	      existing.value = value;
  	      if (selector && !existing.selector) existing.selector = selector;
  	      if (unitType && !existing.unitType) existing.unitType = unitType;
  	      if (existing.editable === undefined) existing.editable = true;
  	      return;
  	    }
  	    parent[key] = {
  	      value: value,
  	      editable: true,
  	      selector: selector || (typeof value === "boolean" ? "boolean" : typeof value === "number" ? "number" : "text")
  	    };
  	    if (unitType) parent[key].unitType = unitType;
  	  }

  	  function serviceDatePlusDays(value, days) {
  	    const date = new Date(value);
  	    const count = Math.round(numberOr(days, 0));
  	    if (!count || Number.isNaN(date.getTime())) return "";
  	    date.setUTCDate(date.getUTCDate() + count);
  	    return date.toISOString().slice(0, 10);
  	  }

  	  function serviceConfiguredIntervalKm(vehicle) {
  	    const service = getDeep(vehicle, ["Data", "Service"], {}) || {};
  	    const schedule = getDeep(service, ["Schedule"], {}) || {};
  	    return numberValue(descriptorValue(firstValue([
  	      schedule.ServiceIntervalKM,
  	      schedule.Service_Interval_KM,
  	      service.Service_Interval
  	    ], 0))) || 0;
  	  }

  	  function serviceConfiguredIntervalHours(vehicle) {
  	    const service = getDeep(vehicle, ["Data", "Service"], {}) || {};
  	    const schedule = getDeep(service, ["Schedule"], {}) || {};
  	    return numberValue(descriptorValue(firstValue([
  	      schedule.ServiceIntervalHours,
  	      schedule.Service_Interval_Hours
  	    ], 0))) || 0;
  	  }

  	  function serviceNextIntervalMileage(lastServiceReading, intervalValue) {
  	    const lastReading = numberValue(lastServiceReading);
  	    const interval = numberValue(intervalValue);

  	    if (!Number.isFinite(lastReading) || lastReading < 0 || !Number.isFinite(interval) || interval <= 0) {
  	      return null;
  	    }

  	    return lastReading + interval;
  	  }

  	  function serviceConfiguredIntervalDays(vehicle) {
  	    const service = getDeep(vehicle, ["Data", "Service"], {}) || {};
  	    const schedule = getDeep(service, ["Schedule"], {}) || {};
  	    const explicit = numberValue(descriptorValue(firstValue([
  	      schedule.ServiceIntervalDays,
  	      schedule.Service_Interval_Days
  	    ], 0))) || 0;
  	    if (explicit > 0) return explicit;

  	    const current = getDeep(service, ["Current"], {}) || {};
  	    const history = getDeep(service, ["History"], {}) || {};
  	    const lastDate = clean(descriptorValue(firstValue([
  	      current.LastServiceDate,
  	      history.Last_Service_Date
  	    ], "")));
  	    const nextDate = clean(descriptorValue(firstValue([
  	      current.NextServiceDate,
  	      history.Next_Service_Date_Estimate,
  	      history.Next_Service_Date
  	    ], "")));
  	    const last = new Date(lastDate);
  	    const next = new Date(nextDate);
  	    if (!Number.isNaN(last.getTime()) && !Number.isNaN(next.getTime())) {
  	      const days = Math.round((next.getTime() - last.getTime()) / 86400000);
  	      if (days > 0 && days <= 3660) return days;
  	    }
  	    return 0;
  	  }

  	  function serviceVehicleOpenJobs(company, vehicle) {
  	    return vehicleServiceOrders(company, vehicle).filter(function (order) {
  	      return order.Category === MAINTENANCE_CATEGORY_SERVICE && serviceJobIsOpen(order);
  	    });
  	  }

  	  function serviceArrayFromManifest(company,
  	    key) {
  	    const top = descriptorValue(getDeep(company, ["Manifest", key], []));
  	    const nested = descriptorValue(getDeep(company, ["Data", "Manifest", key], []));
  	    if (Array.isArray(top)) return cloneData(top);
  	    if (Array.isArray(nested)) return cloneData(nested);
  	    return [];
  	  }

  	  function serviceId(prefix) {
  	    return prefix + "-" + Date.now().toString(36).toUpperCase() + "-" + Math.floor(Math.random() * 1679616).toString(36).toUpperCase().padStart(4, "0");
  	  }

  	  function normalizeServiceProvider(provider) {
  	    provider = provider && typeof provider === "object" ? cloneData(provider): {};
  	    const providerName = clean(provider.Name || provider.Company || provider.CompanyName || "Service Provider");
  	    const stableLegacyId = "SP-" + (lower(providerName).replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "provider").toUpperCase();
  	    return {
  	      ProviderId: clean(provider.ProviderId || provider.Id || provider.objectId || stableLegacyId),
  	      Name: providerName,
  	      TradingName: clean(provider.TradingName || provider.Trading_As || ""),
  	      Status: clean(provider.Status || "Active"),
  	      Preferred: provider.Preferred === true,
  	      IsInHouse: provider.IsInHouse === true,
  	      Emergency24Hour: provider.Emergency24Hour === true,
  	      Rating: Math.max(0, Math.min(5, Number(provider.Rating) || 0)),
  	      Categories: uniqueStrings(provider.Categories || provider.Capabilities || []),
  	      VehicleMakes: uniqueStrings(provider.VehicleMakes || []),
  	      Contact: {
  	        Name: clean(getDeep(provider, ["Contact", "Name"], provider.ContactName || "")),
  	        Role: clean(getDeep(provider, ["Contact", "Role"], provider.ContactRole || "")),
  	        Phone: clean(getDeep(provider, ["Contact", "Phone"], provider.Phone || "")),
  	        AlternatePhone: clean(getDeep(provider, ["Contact", "AlternatePhone"], provider.AfterHoursPhone || "")),
  	        Email: clean(getDeep(provider, ["Contact", "Email"], provider.Email || "")),
  	        Website: clean(getDeep(provider, ["Contact", "Website"], provider.Website || ""))
  	      },
  	      Address: {
  	        Line1: clean(getDeep(provider, ["Address", "Line1"], provider.Address || "")),
  	        Line2: clean(getDeep(provider, ["Address", "Line2"], "")),
  	        City: clean(getDeep(provider, ["Address", "City"], "")),
  	        Province: clean(getDeep(provider, ["Address", "Province"], "")),
  	        PostalCode: clean(getDeep(provider, ["Address", "PostalCode"], "")),
  	        Country: clean(getDeep(provider, ["Address", "Country"], "South Africa"))
  	      },
  	      SLA: {
  	        ResponseHours: numberOr(getDeep(provider, ["SLA", "ResponseHours"], null), null),
  	        MaxDowntimeHours: numberOr(getDeep(provider, ["SLA", "MaxDowntimeHours"], null), null),
  	        LoanVehicleAvailable: getDeep(provider, ["SLA", "LoanVehicleAvailable"], false) === true,
  	        PriorityProvider: getDeep(provider, ["SLA", "PriorityProvider"], false) === true
  	      },
  	      Commercial: {
  	        AccountNumber: clean(getDeep(provider, ["Commercial", "AccountNumber"], "")),
  	        PaymentTerms: clean(getDeep(provider, ["Commercial", "PaymentTerms"], "")),
  	        VatNumber: clean(getDeep(provider, ["Commercial", "VatNumber"], "")),
  	        LabourRate: numberOr(getDeep(provider, ["Commercial", "LabourRate"], null), null),
  	        CallOutFee: numberOr(getDeep(provider, ["Commercial", "CallOutFee"], null), null),
  	        Currency: clean(getDeep(provider, ["Commercial", "Currency"], "ZAR")) || "ZAR"
  	      },
  	      Coverage: {
  	        RadiusKm: numberOr(getDeep(provider, ["Coverage", "RadiusKm"], null), null),
  	        Provinces: uniqueStrings(getDeep(provider, ["Coverage", "Provinces"], []))
  	      },
  	      Certifications: uniqueStrings(provider.Certifications || []),
  	      Notes: clean(provider.Notes || ""),
  	      CreatedAt: provider.CreatedAt || new Date().toISOString(),
  	      UpdatedAt: provider.UpdatedAt || new Date().toISOString(),
  	      CreatedBy: clean(provider.CreatedBy || userDisplayName())
  	    };
  	  }



  	  function serviceProviders(company) {
  	    return serviceArrayFromManifest(company, "ServiceProviders").map(normalizeServiceProvider);
  	  }



  	  function serviceSetManifestArray(container, key, list) {
  	    if (!container || typeof container !== "object") return;
  	    const existing = container[key];
  	    if (existing && typeof existing === "object" && !Array.isArray(existing) && Object.prototype.hasOwnProperty.call(existing, "value")) {
  	      existing.value = cloneData(list);
  	      existing.editable = true;
  	      existing.selector = "list";
  	    } else {
  	      container[key] = cloneData(list);
  	    }
  	  }

  	  function applyServicePortalToCompany(company, providers, workOrders) {
  	    if (!company || typeof company !== "object") return;
  	    if (!company.Manifest || typeof company.Manifest !== "object" || Array.isArray(company.Manifest)) company.Manifest = {};
  	    if (!company.Data || typeof company.Data !== "object" || Array.isArray(company.Data)) company.Data = {};
  	    if (!company.Data.Manifest || typeof company.Data.Manifest !== "object" || Array.isArray(company.Data.Manifest)) company.Data.Manifest = {};
  	    serviceSetManifestArray(company.Manifest, "ServiceProviders", providers);
  	    serviceSetManifestArray(company.Manifest, "ServiceWorkOrders", workOrders);
  	    serviceSetManifestArray(company.Data.Manifest, "ServiceProviders", providers);
  	    serviceSetManifestArray(company.Data.Manifest, "ServiceWorkOrders", workOrders);
  	  }



  	  function serviceProviderById(company, id) {
  	    return serviceProviders(company).find(function (provider) {
  	      return provider.ProviderId === id;
  	    }) || null;
  	  }





  	  function serviceProviderLabel(provider) {
  	    return clean(provider && (provider.TradingName || provider.Name)) || "Service Provider";
  	  }

  	  function serviceFormatDate(value) {
  	    const raw = clean(value);
  	    if (!raw) return "—";
  	    const date = new Date(raw);
  	    if (Number.isNaN(date.getTime())) return raw;
  	    return date.toLocaleDateString(undefined, {
  	      year: "numeric", month: "short", day: "numeric"
  	    });
  	  }

  	  function serviceOpenOrders(company) {
  	    const byKey = {};
  	    serviceWorkOrders(company).concat(tractors(company).concat(towedAssets(company)).reduce(function (rows, vehicle) {
  	      return rows.concat(maintenanceRowsForVehicle(vehicle));
  	    }, [])).forEach(function (row) {
  	      const order = normalizeServiceWorkOrder(row);
  	      const key = order.WorkOrderId || order.objectId;
  	      if (!key) return;
  	      const previous = byKey[key];
  	      if (!previous || order.objectId || new Date(order.UpdatedAt || 0).getTime() >= new Date(previous.UpdatedAt || 0).getTime()) byKey[key] = order;
  	    });
  	    return Object.keys(byKey).map(function (key) { return byKey[key]; }).filter(serviceJobIsOpen);
  	  }



  	  function serviceHealth(company) {
  	    const rank = {
  	      critical: 0,
  	      warning: 1,
  	      scheduled: 2,
  	      good: 3
  	    };
  	    return tractors(company).map(function (vehicle) {
  	      return serviceHealthForVehicle(company, vehicle);
  	    }).sort(function (a, b) {
  	      return rank[a.severity] - rank[b.severity] || (a.remainingKm === null ? 999999999: a.remainingKm) - (b.remainingKm === null ? 999999999: b.remainingKm);
  	    });
  	  }



  	  function serviceStatusClass(status) {
  	    const key = lower(serviceCanonicalStatus(status)).replace(/\s+/g, "-");
  	    return ["scheduled", "booked", "in-progress", "waiting-parts", "ready", "completed", "cancelled"].indexOf(key) !== -1 ? key : "scheduled";
  	  }

























  	  function renderVehicleServiceKpis(company, vehicle) {
  	    const summary = vehicleServiceWorkspaceSummary(company, vehicle);
  	    return `<section class="fifvsvc-kpis">
  	    <article class="tone-${summary.health.severity}"><button type="button" data-vm-service-info="position" aria-label="Open service position"><span>Service condition</span><strong>${escapeHtml(summary.health.label)}</strong></button></article>
  	    <article><button type="button" data-vm-service-info="setup" aria-label="Open service setup"><span>Next service</span><strong>${escapeHtml(summary.nextText)}</strong></button></article>
  	    <article><button type="button" data-vm-service-info="jobs" aria-label="Open service jobs"><span>Open jobs</span><strong>${escapeHtml(summary.openJobs.length)}</strong></button></article>
  	    <article><button type="button" data-vm-service-info="providers" aria-label="Open service providers"><span>Providers</span><strong>${escapeHtml(summary.providers.length)}</strong></button></article>
  	    </section>`;
  	  }

















  	  function serviceApplyRetrospectiveCompletion(company, vehicle, existing, values) {
  	    values = values || {};

  	    const at = new Date().toISOString();
  	    const by = userDisplayName();
  	    const previousPhase = existing
  	      ? serviceCanonicalStatus(existing.Status)
  	      : "Historical Capture";
  	    const serviceDate = maintenanceDateInput(values.date) || at.slice(0, 10);
  	    const odometer = numberOr(values.odometer, null);
  	    const workPerformed = clean(values.notes) || clean(existing && existing.WorkPerformed) || "Completed service captured";
  	    const actualCost = values.cost === "" || values.cost === null || values.cost === undefined
  	      ? numberOr(existing && existing.ActualCost, null)
  	      : numberOr(values.cost, null);
  	    const intervalKm = serviceConfiguredIntervalKm(vehicle);
  	    const calculatedNextKm = serviceNextIntervalMileage(odometer, intervalKm);

  	    if (odometer === null) {
  	      throw new Error("A completed service requires an odometer reading.");
  	    }
  	    if (!workPerformed) {
  	      throw new Error("Record the work completed before saving the completed service.");
  	    }

  	    const noteAudit = serviceAppendAuditNote(
  	      existing || {},
  	      workPerformed,
  	      existing ? "Retrospective completed service" : "Completed service"
  	    );

  	    const workflowHistory = serviceWorkflowHistory(existing || {});
  	    workflowHistory.push({
  	      From: previousPhase,
  	      To: "Completed",
  	      At: at,
  	      By: by,
  	      Note: workPerformed,
  	      Mode: "Completed service capture",
  	      Evidence: {
  	        BypassLifecycle: true,
  	        PreviousPhase: previousPhase,
  	        CompletedDate: serviceDate,
  	        Odometer: odometer,
  	        ActualCost: actualCost,
  	        ServiceIntervalKM: intervalKm,
  	        NextServiceKM: calculatedNextKm,
  	        ProviderName: clean(values.provider) || clean(existing && existing.ProviderName)
  	      }
  	    });

  	    return normalizeServiceWorkOrder(Object.assign({}, existing || {}, {
  	      objectId: existing && existing.objectId,
  	      WorkOrderId: existing ? existing.WorkOrderId : serviceId("SVC"),
  	      VehicleObjectId: objectIdOf(vehicle),
  	      VehicleId: vehicleTitleValue(vehicle),
  	      Registration: vehicleRegistrationValue(vehicle),
  	      Category: MAINTENANCE_CATEGORY_SERVICE,
  	      Type: clean(values.type) || clean(existing && existing.Type) || "Scheduled Service",
  	      Title: clean(values.type) || clean(existing && existing.Title) || "Scheduled Service",
  	      Status: "Completed",
  	      Priority: clean(existing && existing.Priority) || "Normal",
  	      ReportedDate: clean(existing && existing.ReportedDate) || serviceDate,
  	      ScheduledDate: clean(existing && existing.ScheduledDate),
  	      StartedDate: clean(existing && existing.StartedDate),
  	      CompletedDate: serviceDate,
  	      Odometer: odometer,
  	      ProviderId: clean(existing && existing.ProviderId),
  	      ProviderName: clean(values.provider) || clean(existing && existing.ProviderName),
  	      Technician: clean(existing && existing.Technician),
  	      Complaint: clean(existing && existing.Complaint) || workPerformed,
  	      Diagnosis: clean(existing && existing.Diagnosis),
  	      WorkPerformed: workPerformed,
  	      Parts: cloneData(existing && existing.Parts || []),
  	      EstimatedCost: numberOr(existing && existing.EstimatedCost, null),
  	      LabourCost: numberOr(existing && existing.LabourCost, null),
  	      PartsCost: numberOr(existing && existing.PartsCost, null),
  	      ExternalCost: numberOr(existing && existing.ExternalCost, null),
  	      OtherCost: numberOr(existing && existing.OtherCost, null),
  	      ActualCost: actualCost,
  	      PurchaseOrder: clean(existing && existing.PurchaseOrder),
  	      InvoiceNumber: clean(existing && existing.InvoiceNumber),
  	      DowntimeStart: clean(existing && existing.DowntimeStart),
  	      DowntimeEnd: clean(existing && existing.DowntimeEnd) || at.slice(0, 16),
  	      IsScheduled: existing ? existing.IsScheduled === true : false,
  	      NextServiceKm: calculatedNextKm !== null
  	        ? calculatedNextKm
  	        : numberOr(existing && existing.NextServiceKm, null),
  	      NextServiceDate: clean(existing && existing.NextServiceDate),
  	      Notes: noteAudit.Notes,
  	      NoteLog: noteAudit.NoteLog,
  	      ScheduleHistory: existing ? serviceScheduleAudit(existing) : [],
  	      RescheduleCount: numberOr(existing && existing.RescheduleCount, 0),
  	      LastRescheduledAt: clean(existing && existing.LastRescheduledAt),
  	      LastRescheduledBy: clean(existing && existing.LastRescheduledBy),
  	      WorkflowHistory: workflowHistory,
  	      CurrentPhaseEnteredAt: at,
  	      CurrentPhaseEnteredBy: by,
  	      ClosedAt: at,
  	      ClosedBy: by,
  	      ClosureReason: existing
  	        ? "Retrospective completed-service capture bypassed the remaining workshop phases"
  	        : "Retrospective completed-service record captured",
  	      CollectedAt: at,
  	      CollectedBy: by,
  	      CompletionCaptureMode: "Retrospective",
  	      LifecycleBypassed: true,
  	      LifecycleBypassFrom: previousPhase,
  	      CreatedAt: clean(existing && existing.CreatedAt) || at,
  	      CreatedBy: clean(existing && existing.CreatedBy) || by,
  	      UpdatedAt: at,
  	      UpdatedBy: by
  	    }));
  	  }

  	  async function saveCompletedServiceCapture(company, vehicle, form) {
  	    const values = formObject(form);
  	    const linkedId = clean(values.linkedJob);
  	    const existing = linkedId ? serviceWorkOrderById(company, linkedId) : null;

  	    if (linkedId && (!existing || existing.Category !== MAINTENANCE_CATEGORY_SERVICE || !serviceJobIsOpen(existing))) {
  	      throw new Error("The selected Service job card is no longer open. Reopen the completed-service form and choose another open Service job.");
  	    }

  	    const record = serviceApplyRetrospectiveCompletion(company, vehicle, existing, values);

  	    return saveMaintenanceRecord(company, vehicle, record, {
  	      message: existing
  	        ? record.WorkOrderId + " was completed directly from " + servicePhaseLabel(record.LifecycleBypassFrom) + ", closed and used to reset the vehicle's next-service position."
  	        : record.WorkOrderId + " was captured as completed and used to reset the vehicle's next-service position.",
  	      title: existing ? "Service Job Completed" : "Service Record Saved"
  	    });
  	  }

  	  function openCompletedServiceModal(company, vehicle) {
  	    if (!CAN_MANAGE_WORKSHOP || !vehicle) return;
  	    const openJobs = serviceVehicleOpenJobs(company, vehicle);
  	    const linkedDefault = openJobs.length === 1 ? openJobs[0].WorkOrderId : "";
  	    const linkedOptions = [{
  	      value: "",
  	      label: "Standalone completed service record"
  	    }].concat(openJobs.map(function (job) {
  	      return {
  	        value: job.WorkOrderId,
  	        label: job.WorkOrderId + " · " + (job.Type || "Scheduled Service") + (job.ScheduledDate ? " · " + serviceFormatDate(job.ScheduledDate) : "")
  	      };
  	    }));

  	    const body = `<form data-vm-service-modal-form class="fifsp-form fifvsvc-completed-form">
  	      <section data-fif-collapsible-ready="true"><h3>Completed Service</h3><div class="grid">
  	        ${serviceField("linkedJob", "Open Service job to close — optional", linkedDefault, "select", { values: linkedOptions, wide: true })}
  	        ${serviceField("date", "Service date", new Date().toISOString().slice(0, 10), "date", { required: true })}
  	        ${serviceField("odometer", "Odometer", "", "number", { min: 0, placeholder: "km", required: true })}
  	        ${serviceField("type", "Service type", "Scheduled Service", "text", { required: true })}
  	        ${serviceField("provider", "Provider", "", "text", {})}
  	        ${serviceField("cost", "Total cost", "", "number", { min: 0, step: 0.01 })}
  	        ${serviceField("notes", "Work completed / note to append", "", "textarea", { wide: true, required: true })}
  	      </div>${openJobs.length ? `<div class="fifsp-protection-note">This is retrospective capture. Selecting any open Service job closes it directly from its current phase. Booked, In Progress, Delayed and Ready are not required first.</div>` : ""}</section>
  	    </form>`;

  	    const footer = `<button type="button" data-sp-modal-close>Cancel</button><button type="button" class="primary" data-vm-save-service-record>Save Completed Service</button>`;
  	    const overlay = serviceModalShell(
  	      "Capture Completed Service",
  	      vehicleTitleValue(vehicle) + " · Record work that is already complete. This bypasses the normal workshop phases and optionally closes an open Service job.",
  	      body,
  	      footer,
  	      false
  	    );
  	    const form = overlay.querySelector("[data-vm-service-modal-form]");

  	    const submit = async function () {
  	      if (!form || !form.reportValidity()) return;
  	      try {
  	        closeServicePortalModal();
  	        await saveCompletedServiceCapture(company, vehicle, form);
  	      } catch (error) {
  	        await fifAlert(error && error.message ? error.message : "The completed service could not be saved.", {
  	          title: "Service Save Failed", type: "danger", confirmText: "Close"
  	        });
  	      }
  	    };

  	    overlay.querySelector("[data-vm-save-service-record]")?.addEventListener("click", submit);
  	    form?.addEventListener("submit", function (event) {
  	      event.preventDefault();
  	      submit();
  	    });
  	  }

  	  function maintenanceVehicleOpenJobs(company, vehicle) {
  	    return vehicleServiceOrders(company, vehicle).filter(function (job) {
  	      return job.Category === MAINTENANCE_CATEGORY_MAINTENANCE && serviceJobIsOpen(job);
  	    });
  	  }

  	  function maintenanceApplyRetrospectiveCompletion(company, vehicle, existing, values) {
  	    values = values || {};
  	    const at = new Date().toISOString();
  	    const by = userDisplayName();
  	    const previousPhase = existing ? serviceCanonicalStatus(existing.Status) : "Historical Capture";
  	    const completedDate = maintenanceDateInput(values.date) || at.slice(0, 10);
  	    const odometer = numberOr(values.odometer, null);
  	    const workPerformed = clean(values.notes) || clean(existing && existing.WorkPerformed) || "Completed maintenance captured";
  	    const actualCost = values.cost === "" || values.cost === null || values.cost === undefined
  	      ? numberOr(existing && existing.ActualCost, null)
  	      : numberOr(values.cost, null);

  	    if (odometer === null) throw new Error("A completed maintenance record requires an odometer reading.");
  	    if (!workPerformed) throw new Error("Record the maintenance work completed before saving.");

  	    const noteAudit = serviceAppendAuditNote(
  	      existing || {},
  	      workPerformed,
  	      existing ? "Retrospective completed maintenance" : "Completed maintenance"
  	    );
  	    const workflowHistory = serviceWorkflowHistory(existing || {});
  	    workflowHistory.push({
  	      From: previousPhase,
  	      To: "Completed",
  	      At: at,
  	      By: by,
  	      Note: workPerformed,
  	      Mode: "Completed maintenance capture",
  	      Evidence: {
  	        BypassLifecycle: true,
  	        PreviousPhase: previousPhase,
  	        CompletedDate: completedDate,
  	        Odometer: odometer,
  	        ActualCost: actualCost,
  	        ProviderName: clean(values.provider) || clean(existing && existing.ProviderName)
  	      }
  	    });

  	    return normalizeServiceWorkOrder(Object.assign({}, existing || {}, {
  	      objectId: existing && existing.objectId,
  	      WorkOrderId: existing ? existing.WorkOrderId : serviceId("MNT"),
  	      VehicleObjectId: objectIdOf(vehicle),
  	      VehicleId: vehicleTitleValue(vehicle),
  	      Registration: vehicleRegistrationValue(vehicle),
  	      Category: MAINTENANCE_CATEGORY_MAINTENANCE,
  	      Type: clean(values.type) || clean(existing && existing.Type) || "General Maintenance",
  	      Title: clean(values.type) || clean(existing && existing.Title) || "General Maintenance",
  	      Status: "Completed",
  	      Priority: clean(existing && existing.Priority) || "Normal",
  	      ReportedDate: clean(existing && existing.ReportedDate) || completedDate,
  	      ScheduledDate: clean(existing && existing.ScheduledDate),
  	      StartedDate: clean(existing && existing.StartedDate),
  	      CompletedDate: completedDate,
  	      Odometer: odometer,
  	      ProviderId: clean(existing && existing.ProviderId),
  	      ProviderName: clean(values.provider) || clean(existing && existing.ProviderName),
  	      Technician: clean(existing && existing.Technician),
  	      Complaint: clean(existing && existing.Complaint) || workPerformed,
  	      Diagnosis: clean(existing && existing.Diagnosis),
  	      WorkPerformed: workPerformed,
  	      Parts: cloneData(existing && existing.Parts || []),
  	      EstimatedCost: numberOr(existing && existing.EstimatedCost, null),
  	      LabourCost: numberOr(existing && existing.LabourCost, null),
  	      PartsCost: numberOr(existing && existing.PartsCost, null),
  	      ExternalCost: numberOr(existing && existing.ExternalCost, null),
  	      OtherCost: numberOr(existing && existing.OtherCost, null),
  	      ActualCost: actualCost,
  	      PurchaseOrder: clean(existing && existing.PurchaseOrder),
  	      InvoiceNumber: clean(existing && existing.InvoiceNumber),
  	      DowntimeStart: clean(existing && existing.DowntimeStart),
  	      DowntimeEnd: clean(existing && existing.DowntimeEnd) || at.slice(0, 16),
  	      IsScheduled: existing ? existing.IsScheduled === true : false,
  	      Notes: noteAudit.Notes,
  	      NoteLog: noteAudit.NoteLog,
  	      ScheduleHistory: existing ? serviceScheduleAudit(existing) : [],
  	      RescheduleCount: numberOr(existing && existing.RescheduleCount, 0),
  	      LastRescheduledAt: clean(existing && existing.LastRescheduledAt),
  	      LastRescheduledBy: clean(existing && existing.LastRescheduledBy),
  	      WorkflowHistory: workflowHistory,
  	      CurrentPhaseEnteredAt: at,
  	      CurrentPhaseEnteredBy: by,
  	      ClosedAt: at,
  	      ClosedBy: by,
  	      ClosureReason: existing
  	        ? "Retrospective completed-maintenance capture bypassed the remaining workshop phases"
  	        : "Retrospective completed-maintenance record captured",
  	      CollectedAt: at,
  	      CollectedBy: by,
  	      CompletionCaptureMode: "Retrospective",
  	      LifecycleBypassed: true,
  	      LifecycleBypassFrom: previousPhase,
  	      CreatedAt: clean(existing && existing.CreatedAt) || at,
  	      CreatedBy: clean(existing && existing.CreatedBy) || by,
  	      UpdatedAt: at,
  	      UpdatedBy: by
  	    }));
  	  }

  	  async function saveCompletedMaintenanceCapture(company, vehicle, form) {
  	    const values = formObject(form);
  	    const linkedId = clean(values.linkedJob);
  	    const existing = linkedId ? serviceWorkOrderById(company, linkedId) : null;

  	    if (linkedId && (!existing || existing.Category !== MAINTENANCE_CATEGORY_MAINTENANCE || !serviceJobIsOpen(existing))) {
  	      throw new Error("The selected Maintenance job card is no longer open. Reopen the form and choose another open Maintenance job.");
  	    }

  	    const record = maintenanceApplyRetrospectiveCompletion(company, vehicle, existing, values);
  	    return saveMaintenanceRecord(company, vehicle, record, {
  	      message: existing
  	        ? record.WorkOrderId + " was completed directly from " + servicePhaseLabel(record.LifecycleBypassFrom) + "."
  	        : record.WorkOrderId + " was captured as completed maintenance.",
  	      title: existing ? "Maintenance Job Completed" : "Maintenance Record Saved"
  	    });
  	  }

  	  function openCompletedMaintenanceModal(company, vehicle) {
  	    if (!CAN_MANAGE_WORKSHOP || !vehicle) return;
  	    const openJobs = maintenanceVehicleOpenJobs(company, vehicle);
  	    const linkedDefault = openJobs.length === 1 ? openJobs[0].WorkOrderId : "";
  	    const linkedOptions = [{
  	      value: "",
  	      label: "Standalone completed maintenance record"
  	    }].concat(openJobs.map(function (job) {
  	      return {
  	        value: job.WorkOrderId,
  	        label: job.WorkOrderId + " · " + (job.Type || "Maintenance") + (job.ScheduledDate ? " · " + serviceFormatDate(job.ScheduledDate) : "")
  	      };
  	    }));

  	    const body = `<form data-mnt-completed-form class="fifsp-form fifvsvc-completed-form">
  	      <section data-fif-collapsible-ready="true"><h3>Completed Maintenance</h3><div class="grid">
  	        ${serviceField("linkedJob", "Open Maintenance job to close — optional", linkedDefault, "select", { values: linkedOptions, wide: true })}
  	        ${serviceField("date", "Completion date", new Date().toISOString().slice(0, 10), "date", { required: true })}
  	        ${serviceField("odometer", "Odometer", currentOdometer(vehicle) === null ? "" : currentOdometer(vehicle), "number", { min: 0, placeholder: "km", required: true })}
  	        ${serviceField("type", "Maintenance type", "General Maintenance", "text", { required: true })}
  	        ${serviceField("provider", "Provider", "", "text", {})}
  	        ${serviceField("cost", "Total cost", "", "number", { min: 0, step: 0.01 })}
  	        ${serviceField("notes", "Work completed", "", "textarea", { wide: true, required: true })}
  	      </div></section>
  	    </form>`;

  	    const footer = `<button type="button" data-sp-modal-close>Cancel</button><button type="button" class="primary" data-mnt-save-completed>Save Completed Maintenance</button>`;
  	    const overlay = serviceModalShell(
  	      "Capture Completed Maintenance",
  	      vehicleTitleValue(vehicle),
  	      body,
  	      footer,
  	      false
  	    );
  	    const form = overlay.querySelector("[data-mnt-completed-form]");
  	    const submit = async function () {
  	      if (!form || !form.reportValidity()) return;
  	      try {
  	        closeServicePortalModal();
  	        await saveCompletedMaintenanceCapture(company, vehicle, form);
  	      } catch (error) {
  	        await fifAlert(error && error.message ? error.message : "The completed maintenance could not be saved.", {
  	          title: "Maintenance Save Failed", type: "danger", confirmText: "Close"
  	        });
  	      }
  	    };
  	    overlay.querySelector("[data-mnt-save-completed]")?.addEventListener("click", submit);
  	    form?.addEventListener("submit", function (event) {
  	      event.preventDefault();
  	      submit();
  	    });
  	  }

  	  function vehicleServiceSetupProviderListHtml(company) {
  	    const providers = serviceProviders(company).slice().sort(function (a, b) {
  	      return naturalCompare(serviceProviderLabel(a), serviceProviderLabel(b));
  	    });
  	    return `<section class="fifvsvc-provider-modal"><div class="fifvsvc-provider-list">${providers.length ? providers.map(function (provider) {
  	      return `<article><div><strong>${escapeHtml(serviceProviderLabel(provider))}</strong><span>${escapeHtml(provider.Status || "Active")} · ${escapeHtml((provider.Categories || []).join(", ") || "General service")}</span><small>${escapeHtml(provider.Contact && (provider.Contact.Phone || provider.Contact.Email) || "No contact details")}</small></div><div class="fifvsvc-provider-actions"><button type="button" data-sp-edit-provider="${escapeAttr(provider.ProviderId)}">Open</button>${CAN_MANAGE_SERVICE_PROVIDERS ? `<button type="button" class="danger" data-sp-delete-provider="${escapeAttr(provider.ProviderId)}">Remove</button>` : ""}</div></article>`;
  	    }).join("") : `<div class="fifvm-empty">No service providers are configured.</div>`}</div></section>`;
  	  }

  	  function serviceSetupCounterType(vehicle) {
  	    return fifVehicleCounterTypeValue(vehicle);
  	  }



  	  function serviceSetupDescriptorNumber(value) {
  	    const number = numberValue(descriptorValue(value));
  	    return number === null || !Number.isFinite(number) ? "" : number;
  	  }

  	  function serviceSetupSnapshot(vehicle) {
  	    const data = fifCanonicalVehicleData(vehicle);
  	    const schedule = getDeep(data, ["Service", "Schedule"], {}) || {};
  	    const notifications = getDeep(data, ["Service", "Notifications"], {}) || {};
  	    const setup = getDeep(data, ["Service", "Setup"], {}) || {};
  	    const current = getDeep(data, ["Service", "Current"], {}) || {};
  	    const history = getDeep(data, ["Service", "History"], {}) || {};
  	    const hours = serviceSetupCounterType(vehicle) === "Hours";
  	    const initialDate = clean(descriptorValue(firstValue([
  	      setup.InitialLastServiceDate,
  	      current.LastServiceDate,
  	      history.Last_Service_Date
  	    ], "")));
  	    const initialReading = serviceSetupDescriptorNumber(firstValue(hours ? [
  	      setup.InitialLastServiceReading,
  	      current.LastServiceHours,
  	      history.Last_Service_Hours
  	    ] : [
  	      setup.InitialLastServiceReading,
  	      current.LastServiceMileage,
  	      history.Last_Service_KM
  	    ], ""));
  	    const explicitlyCaptured = descriptorValue(setup.InitialLastServiceCaptured) === true;
  	    const existingCaptured = !!initialDate && initialReading !== "";
  	    return {
  	      CounterType: hours ? "Hours" : "Kilometers",
  	      CounterUnit: hours ? "h" : "km",
  	      ServiceIntervalCounter: serviceSetupDescriptorNumber(hours ? schedule.ServiceIntervalHours : schedule.ServiceIntervalKM),
  	      ServiceIntervalDays: serviceSetupDescriptorNumber(schedule.ServiceIntervalDays),
  	      NotifyServiceProvider: descriptorValue(notifications.NotifyServiceProvider) === true,
  	      NotifyCompany: descriptorValue(notifications.NotifyCompany) === true,
  	      NotificationProviderId: clean(descriptorValue(firstValue([
  	        notifications.ServiceProviderId,
  	        notifications.ProviderId
  	      ], ""))),
  	      NotificationProviderName: clean(descriptorValue(firstValue([
  	        notifications.ServiceProviderName,
  	        notifications.ProviderName
  	      ], ""))),
  	      NotificationCounter: serviceSetupDescriptorNumber(hours ? schedule.ServiceWarningHours : schedule.ServiceWarningKM),
  	      NotificationDays: serviceSetupDescriptorNumber(schedule.ServiceWarningDays),
  	      LastServiceDate: initialDate,
  	      LastServiceReading: initialReading,
  	      InitialLastServiceCaptured: explicitlyCaptured || existingCaptured
  	    };
  	  }

  	  function serviceSetupWriteDescriptor(root, path, value, selector, unitType, editable) {
  	    serviceSetDescriptor(root, path, value, selector, unitType);
  	    const descriptor = getDeep(root, path, null);
  	    if (descriptor && typeof descriptor === "object" && !Array.isArray(descriptor)) {
  	      descriptor.editable = editable !== false;
  	      if (selector) descriptor.selector = selector;
  	      if (unitType) descriptor.unitType = unitType;
  	    }
  	  }

  	  function vehicleServiceSetupFormHtml(company, vehicle, draft) {
  	    const setup = Object.assign({}, serviceSetupSnapshot(vehicle), draft || {});
  	    const readOnly = !CAN_MANAGE_SERVICE;
  	    const lastLocked = setup.InitialLastServiceCaptured || readOnly;
  	    const providerOptions = [{ value: "", label: "Select notification provider" }].concat(
  	      serviceProviders(company)
  	        .filter(function (provider) { return lower(provider.Status) === "active"; })
  	        .sort(function (a, b) { return naturalCompare(serviceProviderLabel(a), serviceProviderLabel(b)); })
  	        .map(function (provider) {
  	          return {
  	            value: provider.ProviderId,
  	            label: serviceProviderLabel(provider) + (provider.Contact.Email ? " · " + provider.Contact.Email : " · No email")
  	          };
  	        })
  	    );
  	    return `<form data-vm-service-setup-form class="fifsp-form fifvsvc-service-setup-form">
  	      <section><h3>Service Interval</h3><div class="grid">
  	        ${serviceField("ServiceIntervalCounter", "Service Interval (" + setup.CounterUnit + ")", setup.ServiceIntervalCounter, "number", { min: 0, disabled: readOnly })}
  	        ${serviceField("ServiceIntervalDays", "Service Interval (Days)", setup.ServiceIntervalDays, "number", { min: 0, disabled: readOnly })}
  	      </div></section>
  	      <section><h3>Notifications</h3><div class="grid">
  	        ${serviceField("NotificationCounter", "Service Notification Period (" + setup.CounterUnit + ")", setup.NotificationCounter, "number", { min: 0, disabled: readOnly })}
  	        ${serviceField("NotificationDays", "Service Notification Period (Days)", setup.NotificationDays, "number", { min: 0, disabled: readOnly })}
  	        ${serviceField("NotificationProviderId", "Notification Service Provider", setup.NotificationProviderId, "select", { values: providerOptions, disabled: readOnly, wide: true })}
  	      </div><div class="checks">
  	        ${serviceField("NotifyServiceProvider", "Notify Service Provider", setup.NotifyServiceProvider, "checkbox", { disabled: readOnly })}
  	        ${serviceField("NotifyCompany", "Notify Company", setup.NotifyCompany, "checkbox", { disabled: readOnly })}
  	      </div></section>
  	      <section><h3>Last Service</h3><div class="grid">
  	        ${serviceField("LastServiceDate", "Last Service Date", setup.LastServiceDate, "date", { disabled: lastLocked })}
  	        ${serviceField("LastServiceReading", "Last Service Reading (" + setup.CounterUnit + ")", setup.LastServiceReading, "number", { min: 0, disabled: lastLocked })}
  	      </div></section>
  	    </form>`;
  	  }

  	  async function saveVehicleServiceSetup(company, vehicle, form) {
  	    if (!CAN_MANAGE_SERVICE || !vehicle || !form) return false;
  	    const snapshot = serviceSetupSnapshot(vehicle);
  	    const data = new FormData(form);
  	    const intervalCounter = data.get("ServiceIntervalCounter") === "" ? 0 : Number(data.get("ServiceIntervalCounter"));
  	    const intervalDays = data.get("ServiceIntervalDays") === "" ? 0 : Number(data.get("ServiceIntervalDays"));
  	    const notificationCounter = data.get("NotificationCounter") === "" ? 0 : Number(data.get("NotificationCounter"));
  	    const notificationDays = data.get("NotificationDays") === "" ? 0 : Number(data.get("NotificationDays"));
  	    const notifyServiceProvider = data.has("NotifyServiceProvider");
  	    const notifyCompany = data.has("NotifyCompany");
  	    let notificationProviderId = clean(data.get("NotificationProviderId"));
  	    const activeServiceProviders = serviceProviders(company).filter(function (provider) {
  	      return lower(provider.Status) === "active";
  	    });
  	    let notificationProvider = notificationProviderId
  	      ? serviceProviderById(company, notificationProviderId)
  	      : null;

  	    if (notifyServiceProvider && !notificationProvider) {
  	      const preferred = activeServiceProviders.filter(function (provider) {
  	        return provider.Preferred === true;
  	      });

  	      if (preferred.length === 1) {
  	        notificationProvider = preferred[0];
  	      } else if (activeServiceProviders.length === 1) {
  	        notificationProvider = activeServiceProviders[0];
  	      }

  	      if (notificationProvider) notificationProviderId = notificationProvider.ProviderId;
  	    }

  	    const lastDate = clean(data.get("LastServiceDate"));
  	    const lastReadingRaw = data.get("LastServiceReading");
  	    const lastReading = lastReadingRaw === null || lastReadingRaw === "" ? null : Number(lastReadingRaw);
  	    const errors = [];

  	    [
  	      [intervalCounter, "Service interval"],
  	      [intervalDays, "Service interval time"],
  	      [notificationCounter, "Service notification period"],
  	      [notificationDays, "Service notification time"]
  	    ].forEach(function (entry) {
  	      if (!Number.isFinite(entry[0]) || entry[0] < 0) errors.push(entry[1] + " must be zero or greater.");
  	    });

  	    if (!snapshot.InitialLastServiceCaptured && (lastDate || lastReading !== null)) {
  	      if (!lastDate) errors.push("Last Service Date is required when capturing the initial last service.");
  	      if (lastReading === null || !Number.isFinite(lastReading) || lastReading < 0) errors.push("Last Service Reading must be zero or greater.");
  	    }

  	    if (notifyServiceProvider) {
  	      if (!notificationProvider) {
  	        errors.push("Choose the Service Provider that must receive automatic notifications.");
  	      } else if (!clean(notificationProvider.Contact && notificationProvider.Contact.Email)) {
  	        errors.push(serviceProviderLabel(notificationProvider) + " does not have an email address.");
  	      }
  	    }

  	    if (notifyCompany) {
  	      const notificationCompany = fifResolveVehicleNotificationCompany(company, vehicle);
  	      const companyEmails = fifServiceNotificationCompanyEmails(notificationCompany);
  	      if (!companyEmails.length) {
  	        errors.push("Notify Company is enabled, but no company email was found in AppData.User.Companies. Add Manifest.Profile.PrimaryEmail or Manifest.Contacts.Primary.Email to the company record.");
  	      }
  	    }

  	    if (errors.length) {
  	      await fifAlert(errors.join("\n"), { title: "Service Setup Incomplete", type: "warning", confirmText: "Correct Setup" });
  	      return false;
  	    }

  	    const updated = cloneData(vehicle);
  	    const vehicleData = fifCanonicalVehicleData(vehicle);
  	    if (!vehicleData.Service || typeof vehicleData.Service !== "object" || Array.isArray(vehicleData.Service)) vehicleData.Service = {};
  	    const hours = snapshot.CounterType === "Hours";

  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Schedule", hours ? "ServiceIntervalHours" : "ServiceIntervalKM"], intervalCounter, "number", hours ? "Time" : "Distance", true);
  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Schedule", "ServiceIntervalDays"], intervalDays, "number", "Time", true);
  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Schedule", hours ? "ServiceWarningHours" : "ServiceWarningKM"], notificationCounter, "number", hours ? "Time" : "Distance", true);
  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Schedule", "ServiceWarningDays"], notificationDays, "number", "Time", true);
  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Notifications", "NotifyServiceProvider"], notifyServiceProvider, "boolean", "", true);
  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Notifications", "NotifyCompany"], notifyCompany, "boolean", "", true);
  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Notifications", "ServiceProviderId"], notificationProvider ? notificationProvider.ProviderId : notificationProviderId, "text", "", true);
  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Notifications", "ServiceProviderName"], notificationProvider ? serviceProviderLabel(notificationProvider) : "", "text", "", true);

  	    if (!snapshot.InitialLastServiceCaptured && lastDate && lastReading !== null) {
  	      const capturedAt = new Date().toISOString();
  	      const capturedBy = userDisplayName();
  	      const capturedEmail = clean(firstValue([CURRENT_USER.email, CURRENT_USER.Email], ""));
  	      const capturedObjectId = clean(firstValue([CURRENT_USER.objectId, CURRENT_USER.ObjectId, CURRENT_USER.ID], ""));
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceCaptured"], true, "boolean", "", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceDate"], lastDate, "date", "", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceReading"], lastReading, "number", hours ? "Time" : "Distance", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceUnit"], snapshot.CounterUnit, "text", "", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceCapturedAt"], capturedAt, "text", "", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceCapturedBy"], capturedBy, "text", "", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceCapturedByEmail"], capturedEmail, "text", "", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceCapturedByObjectId"], capturedObjectId, "text", "", false);

  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Current", "LastServiceDate"], lastDate, "date", "", true);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "History", "Last_Service_Date"], lastDate, "date", "", true);
  	      if (hours) {
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "Current", "LastServiceHours"], lastReading, "number", "Time", true);
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "History", "Last_Service_Hours"], lastReading, "number", "Time", true);
  	        if (intervalCounter > 0) {
  	          const nextHours = serviceNextIntervalMileage(lastReading, intervalCounter);
  	          serviceSetupWriteDescriptor(vehicleData, ["Service", "Current", "NextServiceHours"], nextHours, "number", "Time", true);
  	          serviceSetupWriteDescriptor(vehicleData, ["Service", "History", "Next_Service_Hours"], nextHours, "number", "Time", true);
  	        }
  	      } else {
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "Current", "LastServiceMileage"], lastReading, "number", "Distance", true);
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "History", "Last_Service_KM"], lastReading, "number", "Distance", true);
  	        if (intervalCounter > 0) {
  	          const nextKm = serviceNextIntervalMileage(lastReading, intervalCounter);
  	          serviceSetupWriteDescriptor(vehicleData, ["Service", "Current", "NextServiceMileage"], nextKm, "number", "Distance", true);
  	          serviceSetupWriteDescriptor(vehicleData, ["Service", "History", "Next_Service_KM"], nextKm, "number", "Distance", true);
  	        }
  	      }
  	      if (intervalDays > 0) {
  	        const nextDate = serviceDatePlusDays(lastDate, intervalDays);
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "Current", "NextServiceDate"], nextDate, "date", "", true);
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "History", "Next_Service_Date_Estimate"], nextDate, "date", "", true);
  	      }
  	    } else if (!descriptorValue(getDeep(vehicleData, ["Service", "Setup", "InitialLastServiceCaptured"], false)) && snapshot.InitialLastServiceCaptured) {
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceCaptured"], true, "boolean", "", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceDate"], snapshot.LastServiceDate, "date", "", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceReading"], snapshot.LastServiceReading, "number", hours ? "Time" : "Distance", false);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "InitialLastServiceUnit"], snapshot.CounterUnit, "text", "", false);
  	    }

  	    const currentService = getDeep(vehicleData, ["Service", "Current"], {}) || {};
  	    const serviceHistory = getDeep(vehicleData, ["Service", "History"], {}) || {};
  	    const serviceSetupData = getDeep(vehicleData, ["Service", "Setup"], {}) || {};
  	    const effectiveLastDate = clean(descriptorValue(firstValue([
  	      currentService.LastServiceDate,
  	      serviceHistory.Last_Service_Date,
  	      serviceSetupData.InitialLastServiceDate
  	    ], "")));
  	    const effectiveLastReading = numberValue(descriptorValue(firstValue(hours ? [
  	      currentService.LastServiceHours,
  	      serviceHistory.Last_Service_Hours,
  	      serviceSetupData.InitialLastServiceReading
  	    ] : [
  	      currentService.LastServiceMileage,
  	      serviceHistory.Last_Service_KM,
  	      serviceSetupData.InitialLastServiceReading
  	    ], null)));

  	    if (effectiveLastReading !== null) {
  	      const recalculatedNextCounter = intervalCounter > 0
  	        ? serviceNextIntervalMileage(effectiveLastReading, intervalCounter)
  	        : 0;
  	      if (hours) {
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "Current", "NextServiceHours"], recalculatedNextCounter, "number", "Time", true);
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "History", "Next_Service_Hours"], recalculatedNextCounter, "number", "Time", true);
  	      } else {
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "Current", "NextServiceMileage"], recalculatedNextCounter, "number", "Distance", true);
  	        serviceSetupWriteDescriptor(vehicleData, ["Service", "History", "Next_Service_KM"], recalculatedNextCounter, "number", "Distance", true);
  	      }
  	    }

  	    if (effectiveLastDate) {
  	      const recalculatedNextDate = intervalDays > 0 ? serviceDatePlusDays(effectiveLastDate, intervalDays) : "";
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "Current", "NextServiceDate"], recalculatedNextDate, "date", "", true);
  	      serviceSetupWriteDescriptor(vehicleData, ["Service", "History", "Next_Service_Date_Estimate"], recalculatedNextDate, "date", "", true);
  	    }

  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "UpdatedAt"], new Date().toISOString(), "text", "", false);
  	    serviceSetupWriteDescriptor(vehicleData, ["Service", "Setup", "UpdatedBy"], userDisplayName(), "text", "", false);
  	    updated.Data = vehicleData;

  	    const payload = { objectId: objectIdOf(vehicle), Data: cloneData(updated.Data) };
  	    if (!payload.objectId) {
  	      await fifAlert("The selected Tractor has no objectId and cannot be updated.", { title: "Save Blocked", type: "danger" });
  	      return false;
  	    }

  	    const operation = fifBeginSaveOperation("Saving service setup…");
  	    state.serviceSaving = true;
  	    try {
  	      const databaseApi = await fifWaitForDatabaseApi(1800);
  	      if (!databaseApi || !databaseApi.Data || typeof databaseApi.Data.of !== "function") throw new Error("The database connection is not ready.");
  	      const saved = await databaseApi.Data.of("Tractors").save(payload);
  	      fifReconcileVehicleAppData(company, vehicle, updated, saved || payload, "Tractors");
  	      state.serviceSaving = false;
  	      state.actionableAlertCache = {};
  	      closeServicePortalModal();
  	      fifCompleteSaveOperation(operation, "Service setup saved.");
  	      render();
  	      return true;
  	    } catch (error) {
  	      state.serviceSaving = false;
  	      fifFailSaveOperation(operation, error);
  	      await fifAlert(error && error.message ? error.message : "Service setup could not be saved.", { title: "Service Setup Save Failed", type: "danger", confirmText: "Close" });
  	      return false;
  	    }
  	  }

  	  function openVehicleServiceSetupModal(company, vehicle, initialTab) {
  	    let activeTab = initialTab === "providers" ? "providers" : "setup";
  	    let setupDraft = null;
  	    const providerCount = serviceProviders(company).length;
  	    const body = `<section class="fifvsvc-service-setup-modal"><nav class="fifvsvc-service-setup-tabs"><button type="button" data-vm-service-setup-tab="setup">Service Setup</button><button type="button" data-vm-service-setup-tab="providers">Providers <b>${providerCount}</b></button></nav><div class="fifvsvc-service-setup-panel" data-vm-service-setup-panel></div></section>`;
  	    const footer = `<button type="button" data-sp-modal-close>Close</button>${CAN_MANAGE_SERVICE ? `<button type="button" class="primary" data-vm-service-setup-only data-vm-save-service-setup>Save Service Setup</button>` : ""}<button type="button" data-vm-service-provider-only data-sp-print-directory hidden>Print Directory</button>${CAN_MANAGE_SERVICE_PROVIDERS ? `<button type="button" class="primary" data-vm-service-provider-only data-sp-add-provider hidden>+ Service Provider</button>` : ""}`;
  	    const overlay = serviceModalShell("Service Setup", "", body, footer, true);
  	    const panel = overlay.querySelector("[data-vm-service-setup-panel]");

  	    function bindProviderRowActions() {
  	      panel?.querySelectorAll("[data-sp-edit-provider]").forEach(function (button) {
  	        button.addEventListener("click", function () {
  	          openServiceProviderModal(company, button.getAttribute("data-sp-edit-provider"));
  	        });
  	      });
  	      panel?.querySelectorAll("[data-sp-delete-provider]").forEach(function (button) {
  	        button.addEventListener("click", function () {
  	          const providerId = button.getAttribute("data-sp-delete-provider");
  	          closeServicePortalModal();
  	          deleteServiceProvider(company, providerId);
  	        });
  	      });
  	    }

  	    function captureSetupDraft() {
  	      const form = panel?.querySelector("[data-vm-service-setup-form]");
  	      if (!form) return;
  	      const values = new FormData(form);
  	      const base = serviceSetupSnapshot(vehicle);
  	      setupDraft = {
  	        ServiceIntervalCounter: values.get("ServiceIntervalCounter") === null ? base.ServiceIntervalCounter : values.get("ServiceIntervalCounter"),
  	        ServiceIntervalDays: values.get("ServiceIntervalDays") === null ? base.ServiceIntervalDays : values.get("ServiceIntervalDays"),
  	        NotifyServiceProvider: values.has("NotifyServiceProvider"),
  	        NotifyCompany: values.has("NotifyCompany"),
  	        NotificationProviderId: values.get("NotificationProviderId") === null ? base.NotificationProviderId : values.get("NotificationProviderId"),
  	        NotificationCounter: values.get("NotificationCounter") === null ? base.NotificationCounter : values.get("NotificationCounter"),
  	        NotificationDays: values.get("NotificationDays") === null ? base.NotificationDays : values.get("NotificationDays"),
  	        LastServiceDate: values.get("LastServiceDate") === null ? base.LastServiceDate : values.get("LastServiceDate"),
  	        LastServiceReading: values.get("LastServiceReading") === null ? base.LastServiceReading : values.get("LastServiceReading")
  	      };
  	    }

  	    function renderSetupTab() {
  	      overlay.querySelectorAll("[data-vm-service-setup-tab]").forEach(function (button) {
  	        button.classList.toggle("active", button.getAttribute("data-vm-service-setup-tab") === activeTab);
  	      });
  	      overlay.querySelectorAll("[data-vm-service-provider-only]").forEach(function (button) {
  	        button.hidden = activeTab !== "providers";
  	      });
  	      overlay.querySelectorAll("[data-vm-service-setup-only]").forEach(function (button) {
  	        button.hidden = activeTab !== "setup";
  	      });
  	      if (!panel) return;
  	      panel.innerHTML = activeTab === "providers" ? vehicleServiceSetupProviderListHtml(company) : vehicleServiceSetupFormHtml(company, vehicle, setupDraft);
  	      if (activeTab === "providers") bindProviderRowActions();
  	      requestAnimationFrame(function () {
  	        enhanceAllStyledSelects(panel);
  	        enhanceAllStyledDateInputs(panel);
  	        enhanceDashboardNumberInputs(panel);
  	      });
  	    }

  	    overlay.querySelector("[data-vm-save-service-setup]")?.addEventListener("click", function () {
  	      const form = panel?.querySelector("[data-vm-service-setup-form]");
  	      if (!form || !form.reportValidity()) return;
  	      saveVehicleServiceSetup(company, vehicle, form);
  	    });
  	    overlay.querySelector("[data-sp-print-directory]")?.addEventListener("click", function () {
  	      printServiceProviderDirectory(company);
  	    });
  	    overlay.querySelector("[data-sp-add-provider]")?.addEventListener("click", function () {
  	      openServiceProviderModal(company, "");
  	    });

  	    overlay.querySelectorAll("[data-vm-service-setup-tab]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        if (activeTab === "setup") captureSetupDraft();
  	        activeTab = button.getAttribute("data-vm-service-setup-tab") === "providers" ? "providers" : "setup";
  	        renderSetupTab();
  	      });
  	    });
  	    renderSetupTab();
  	  }



  	  function closeServicePortalModal() {
  	    closeStyledSelectPortal();
  	    closeStyledDatePortal();
  	    const overlay = document.getElementById(SERVICE_MODAL_ID);
  	    if (fifActiveDirtyScope === overlay) fifActiveDirtyScope = null;
  	    overlay?.remove();
  	    state.serviceModalOpen = false;
  	  }

  	  function serviceModalShell(title, subtitle, body, footer, wide) {
  	    closeServicePortalModal();
  	    state.serviceModalOpen = true;
  	    const overlay = document.createElement("div");
  	    overlay.id = SERVICE_MODAL_ID;
  	    overlay.innerHTML = `<div class="fifsp-modal ${wide ? "wide": ""}" role="dialog" aria-modal="true"><header><div><span>Fleet In Form Vehicle Service</span><h2>${escapeHtml(title)}</h2><p>${escapeHtml(subtitle || "")}</p></div><button type="button" data-sp-modal-close aria-label="Close">×</button></header><main>${body}</main><footer>${footer || ""}</footer></div>`;
  	    overlay.addEventListener("click", async function (event) {
  	      if (event.target === overlay || event.target.closest("[data-sp-modal-close]")) {
  	        event.preventDefault();
  	        await fifRequestCloseServicePortalModal();
  	      }
  	    });
  	    (document.getElementById(ROOT_ID) || document.body).appendChild(overlay);
  	    requestAnimationFrame(function () {
  	      enhanceAllStyledSelects(overlay);
  	      enhanceAllStyledDateInputs(overlay);
  	      enhanceDashboardNumberInputs(overlay);
  	      enhanceCollapsibleGroups(overlay);
  	      fifInstallDirtyScope(overlay);
  	    });
  	    return overlay;
  	  }

  	  function serviceField(name,
  	    label,
  	    value,
  	    type,
  	    options) {
  	    options = options || {};
  	    const disabled = options.disabled ? "disabled": "";
  	    const required = options.required ? "required": "";
  	    const wide = options.wide ? " wide": "";
  	    if (type === "textarea") return `<label class="fifsp-field${wide}"><span>${escapeHtml(label)}</span><textarea name="${escapeAttr(name)}" ${disabled} ${required} placeholder="${escapeAttr(options.placeholder || "")}">${escapeHtml(value || "")}</textarea></label>`;
  	    if (type === "select") return `<label class="fifsp-field${wide}"><span>${escapeHtml(label)}</span><select name="${escapeAttr(name)}" ${disabled} ${required}>${(options.values || []).map(function (item) {
  	      const optionValue = typeof item === "string" ? item: item.value; const optionLabel = typeof item === "string" ? item: item.label; return `<option value="${escapeAttr(optionValue)}" ${String(optionValue) === String(value || "") ? "selected": ""}>${escapeHtml(optionLabel)}</option>`;
  	    }).join("")}</select>${options.disabled ? `<input type="hidden" name="${escapeAttr(name)}" value="${escapeAttr(value || "")}">`: ""}</label>`;
  	    if (type === "checkbox") return `<label class="fifsp-check${wide}"><input type="checkbox" name="${escapeAttr(name)}" ${value ? "checked": ""} ${disabled}><span><b>${escapeHtml(label)}</b><small>${escapeHtml(options.help || "")}</small></span></label>`;
  	    return `<label class="fifsp-field${wide}"><span>${escapeHtml(label)}</span><input type="${escapeAttr(type || "text")}" name="${escapeAttr(name)}" value="${escapeAttr(value === null || value === undefined ? "": value)}" ${disabled} ${required} min="${escapeAttr(options.min === undefined ? "": options.min)}" max="${escapeAttr(options.max === undefined ? "": options.max)}" step="${escapeAttr(options.step || "any")}" placeholder="${escapeAttr(options.placeholder || "")}"></label>`;
  	  }

  	  function openServiceProviderModal(company, providerId) {
  	    const existing = providerId ? serviceProviderById(company, providerId): null;
  	    const provider = normalizeServiceProvider(existing || {
  	      Name: "", Status: "Active", ProviderId: serviceId("SP")
  	    });
  	    if (!existing) provider.Name = "";
  	    const readOnly = !CAN_MANAGE_SERVICE_PROVIDERS;
  	    const body = `<form data-sp-provider-form class="fifsp-form">
  	    <section><h3>Provider Identity</h3><div class="grid">${serviceField("Name", "Legal / company name", provider.Name, "text", {
  	      required: true, disabled: readOnly
  	    })}${serviceField("TradingName", "Trading name", provider.TradingName, "text", {
  	      disabled: readOnly
  	    })}${serviceField("Status", "Provider status", provider.Status, "select", {
  	      values: ["Active", "Inactive", "Suspended"], disabled: readOnly
  	    })}${serviceField("Rating", "Internal rating (0–5)", provider.Rating, "number", {
  	      min: 0, max: 5, step: .1, disabled: readOnly
  	    })}</div><div class="checks">${serviceField("Preferred", "Preferred provider", provider.Preferred, "checkbox", {
  	      help: "Shown in the priority network.", disabled: readOnly
  	    })}${serviceField("IsInHouse", "In-house workshop", provider.IsInHouse, "checkbox", {
  	      help: "Owned or directly operated by the company.", disabled: readOnly
  	    })}${serviceField("Emergency24Hour", "24-hour emergency support", provider.Emergency24Hour, "checkbox", {
  	      help: "Available outside normal working hours.", disabled: readOnly
  	    })}</div></section>
  	    <section><h3>Contact and Location</h3><div class="grid">${serviceField("ContactName", "Primary contact", provider.Contact.Name, "text", {
  	      disabled: readOnly
  	    })}${serviceField("ContactRole", "Contact role", provider.Contact.Role, "text", {
  	      disabled: readOnly
  	    })}${serviceField("Phone", "Phone", provider.Contact.Phone, "tel", {
  	      disabled: readOnly
  	    })}${serviceField("AlternatePhone", "After-hours phone", provider.Contact.AlternatePhone, "tel", {
  	      disabled: readOnly
  	    })}${serviceField("Email", "Email", provider.Contact.Email, "email", {
  	      disabled: readOnly
  	    })}${serviceField("Website", "Website", provider.Contact.Website, "url", {
  	      disabled: readOnly
  	    })}${serviceField("AddressLine1", "Address", provider.Address.Line1, "text", {
  	      disabled: readOnly
  	    })}${serviceField("City", "City / town", provider.Address.City, "text", {
  	      disabled: readOnly
  	    })}${serviceField("Province", "Province", provider.Address.Province, "text", {
  	      disabled: readOnly
  	    })}${serviceField("PostalCode", "Postal code", provider.Address.PostalCode, "text", {
  	      disabled: readOnly
  	    })}</div></section>
  	    <section><h3>Capabilities</h3><div class="fifsp-capability-checks">${SERVICE_PROVIDER_CATEGORIES.map(function (category) {
  	      return `<label><input type="checkbox" name="Categories" value="${escapeAttr(category)}" ${provider.Categories.indexOf(category) !== -1 ? "checked": ""} ${readOnly ? "disabled": ""}><span>${escapeHtml(category)}</span></label>`;
  	    }).join("")}</div>${serviceField("VehicleMakes", "Vehicle makes supported", provider.VehicleMakes.join(", "), "text", {
  	      wide: true, disabled: readOnly, placeholder: "IVECO, MAN, Volvo, Ford"
  	    })}${serviceField("Certifications", "Certifications / approvals", provider.Certifications.join(", "), "text", {
  	      wide: true, disabled: readOnly, placeholder: "OEM approved, RMI, ISO 9001"
  	    })}</section>
  	    <section><h3>SLA and Commercial Control</h3><div class="grid">${serviceField("ResponseHours", "Response time (hours)", provider.SLA.ResponseHours, "number", {
  	      min: 0, disabled: readOnly
  	    })}${serviceField("MaxDowntimeHours", "Maximum downtime (hours)", provider.SLA.MaxDowntimeHours, "number", {
  	      min: 0, disabled: readOnly
  	    })}${serviceField("LabourRate", "Labour rate", provider.Commercial.LabourRate, "number", {
  	      min: 0, disabled: readOnly
  	    })}${serviceField("CallOutFee", "Call-out fee", provider.Commercial.CallOutFee, "number", {
  	      min: 0, disabled: readOnly
  	    })}${serviceField("AccountNumber", "Account number", provider.Commercial.AccountNumber, "text", {
  	      disabled: readOnly
  	    })}${serviceField("PaymentTerms", "Payment terms", provider.Commercial.PaymentTerms, "text", {
  	      disabled: readOnly
  	    })}${serviceField("VatNumber", "VAT number", provider.Commercial.VatNumber, "text", {
  	      disabled: readOnly
  	    })}${serviceField("RadiusKm", "Service radius (km)", provider.Coverage.RadiusKm, "number", {
  	      min: 0, disabled: readOnly
  	    })}</div><div class="checks">${serviceField("LoanVehicleAvailable", "Loan vehicle available", provider.SLA.LoanVehicleAvailable, "checkbox", {
  	      help: "Provider can supply a temporary replacement.", disabled: readOnly
  	    })}${serviceField("PriorityProvider", "Priority SLA", provider.SLA.PriorityProvider, "checkbox", {
  	      help: "Contracted priority response.", disabled: readOnly
  	    })}</div>${serviceField("Notes", "Operational notes", provider.Notes, "textarea", {
  	      wide: true, disabled: readOnly, placeholder: "Escalation path, booking rules, exclusions or account notes"
  	    })}</section>
  	    <input type="hidden" name="ProviderId" value="${escapeAttr(provider.ProviderId)}">
  	    </form>`;
  	    const footer = readOnly ? `<button type="button" data-sp-modal-close>Close</button>`: `<button type="button" data-sp-modal-close>Cancel</button><button type="button" class="primary" data-sp-save-provider>${existing ? "Save Provider": "Create Provider"}</button>`;
  	    const overlay = serviceModalShell(existing ? "Service Provider Profile": "New Service Provider", existing ? "Detailed contact, capability, SLA and commercial profile.": "Build a complete provider record in the company manifest.", body, footer, true);
  	    overlay.querySelector("[data-sp-save-provider]")?.addEventListener("click", async function () {
  	      const form = overlay.querySelector("[data-sp-provider-form]");
  	      if (!form || !form.reportValidity()) return;
  	      const data = new FormData(form);
  	      const providers = serviceProviders(company);
  	      const updated = normalizeServiceProvider({
  	        ProviderId: data.get("ProviderId"), Name: data.get("Name"), TradingName: data.get("TradingName"), Status: data.get("Status"), Rating: data.get("Rating"),
  	        Preferred: data.has("Preferred"), IsInHouse: data.has("IsInHouse"), Emergency24Hour: data.has("Emergency24Hour"), Categories: data.getAll("Categories"),
  	        VehicleMakes: String(data.get("VehicleMakes") || "").split(","), Certifications: String(data.get("Certifications") || "").split(","),
  	        Contact: {
  	          Name: data.get("ContactName"), Role: data.get("ContactRole"), Phone: data.get("Phone"), AlternatePhone: data.get("AlternatePhone"), Email: data.get("Email"), Website: data.get("Website")
  	        },
  	        Address: {
  	          Line1: data.get("AddressLine1"), City: data.get("City"), Province: data.get("Province"), PostalCode: data.get("PostalCode"), Country: "South Africa"
  	        },
  	        SLA: {
  	          ResponseHours: data.get("ResponseHours"), MaxDowntimeHours: data.get("MaxDowntimeHours"), LoanVehicleAvailable: data.has("LoanVehicleAvailable"), PriorityProvider: data.has("PriorityProvider")
  	        },
  	        Commercial: {
  	          LabourRate: data.get("LabourRate"), CallOutFee: data.get("CallOutFee"), AccountNumber: data.get("AccountNumber"), PaymentTerms: data.get("PaymentTerms"), VatNumber: data.get("VatNumber"), Currency: "ZAR"
  	        },
  	        Coverage: {
  	          RadiusKm: data.get("RadiusKm"), Provinces: []
  	        }, Notes: data.get("Notes"), CreatedAt: provider.CreatedAt, CreatedBy: provider.CreatedBy, UpdatedAt: new Date().toISOString()
  	      });
  	      const index = providers.findIndex(function (item) {
  	        return item.ProviderId === updated.ProviderId;
  	      });
  	      if (providers.some(function (item, itemIndex) {
  	        return itemIndex !== index && lower(serviceProviderLabel(item)) === lower(serviceProviderLabel(updated));
  	      })) {
  	        await fifAlert("A service provider with this name already exists.", {
  	          title: "Duplicate Provider", type: "warning", confirmText: "Continue Editing"
  	        }); return;
  	      }
  	      if (index >= 0) providers[index] = updated; else providers.push(updated);
  	      const jobs = serviceWorkOrders(company).map(function (job) {
  	        if (job.ProviderId === updated.ProviderId) job.ProviderName = serviceProviderLabel(updated); return job;
  	      });
  	      closeServicePortalModal();
  	      await saveServicePortalData(company,
  	        providers,
  	        jobs,
  	        serviceProviderLabel(updated) + " was saved to the company service network.");
  	    });
  	  }





  	  async function deleteServiceProvider(company, providerId) {
  	    const provider = serviceProviderById(company, providerId);
  	    if (!provider) return;
  	    const jobs = serviceWorkOrders(company);
  	    const linked = jobs.filter(function (job) {
  	      return job.ProviderId === providerId && SERVICE_JOB_OPEN_STATUSES.indexOf(job.Status) !== -1;
  	    });
  	    if (linked.length) {
  	      await fifAlert("This provider has active job cards and cannot be removed until those jobs are reassigned or closed.", {
  	        title: "Provider In Use", type: "warning", confirmText: "Close", details: [{
  	          label: "Active jobs", value: String(linked.length)
  	        }]
  	      }); return;
  	    }
  	    const approved = await fifConfirm("Remove this service provider from the company manifest? Historical job cards will keep the provider name.", {
  	      title: "Remove Service Provider", type: "danger", confirmText: "Remove Provider", cancelText: "Cancel", details: [{
  	        label: "Provider", value: serviceProviderLabel(provider)
  	      }]
  	    });
  	    if (!approved) return;
  	    await saveServicePortalData(company, serviceProviders(company).filter(function (item) {
  	      return item.ProviderId !== providerId;
  	    }), jobs, serviceProviderLabel(provider) + " was removed from the service network.");
  	  }

  	  function serviceReportLogo() {
  	    const icon = clean(SVG_INPUT);
  	    if (!icon) return "";
  	    if (icon.indexOf("<svg") !== -1) return icon;
  	    return `<img src="${escapeAttr(icon)}" alt="Fleet In Form" style="height:44px;max-width:180px;object-fit:contain">`;
  	  }

  	  function openServicePrintWindow(title, body) {
  	    const win = window.open("", "_blank");
  	    if (!win) {
  	      fifAlert("The print window was blocked. Allow popups and try again.", {
  	        title: "Print Window Blocked", type: "warning", confirmText: "Close"
  	      }); return;
  	    }
  	    win.document.open();
  	    win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${escapeHtml(title)}</title><style>*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#151515;margin:22px;font-size:12px}.head{display:flex;justify-content:space-between;gap:20px;border-bottom:3px solid #cc6633;padding-bottom:10px;margin-bottom:16px}h1{font-size:23px;margin:0}h2{font-size:15px;margin:20px 0 8px}table{width:100%;border-collapse:collapse}th,td{border:1px solid #bbb;padding:7px;text-align:left;vertical-align:top}th{background:#eee}.card{border:1px solid #bbb;border-radius:5px;padding:10px;margin-bottom:10px}.meta{color:#666;font-size:10px;margin-top:18px}@media print{button{display:none!important}body{margin:10mm}tr,.card{page-break-inside:avoid}}</style></head><body><button onclick="window.print()" style="float:right;padding:8px 13px">Print</button><div class="head"><div><h1>${escapeHtml(title)}</h1><p>${escapeHtml(companyName(selectedCompany()))}</p></div><div>${serviceReportLogo()}</div></div>${body}<div class="meta">Generated by Fleet In Form Vehicle Service · ${escapeHtml(new Date().toLocaleString())}</div></body></html>`);
  	    win.document.close(); win.focus(); setTimeout(function () {
  	      win.print();
  	    }, 250);
  	  }

  	  function printServiceProviderDirectory(company) {
  	    const providers = serviceProviders(company);
  	    const rows = providers.map(function (provider) {
  	      return `<tr><td><strong>${escapeHtml(serviceProviderLabel(provider))}</strong><br>${escapeHtml(provider.IsInHouse ? "In-house": "External")}</td><td>${escapeHtml(provider.Categories.join(", ") || "General Service")}</td><td>${escapeHtml(provider.Contact.Name || "—")}<br>${escapeHtml(provider.Contact.Phone || "—")}<br>${escapeHtml(provider.Contact.Email || "—")}</td><td>${escapeHtml([provider.Address.City, provider.Address.Province].filter(Boolean).join(", ") || "—")}</td><td>${provider.Emergency24Hour ? "Yes": "No"}</td><td>${provider.SLA.ResponseHours === null ? "—": provider.SLA.ResponseHours + " h"}</td><td>${provider.Rating ? provider.Rating.toFixed(1): "—"}</td><td>${escapeHtml(provider.Status)}</td></tr>`;
  	    }).join("");
  	    openServicePrintWindow("Service Provider Directory", `<table><thead><tr><th>Provider</th><th>Capabilities</th><th>Contact</th><th>Location</th><th>24h</th><th>Response SLA</th><th>Rating</th><th>Status</th></tr></thead><tbody>${rows || `<tr><td colspan="8">No service providers configured.</td></tr>`}</tbody></table>`);
  	  }





  	  function bindApplicationManagerEvents(scope, company) {
  	    if (!scope || state.activeTab !== "applications") return;

  	    scope.querySelector("[data-app-add]")?.addEventListener("click", function () {
  	      openApplicationTextPrompt({
  	        title: "Add Application",
  	        subtitle: "Create a new application label for " + companyName(company) + ".",
  	        confirmText: "Add Application",
  	        onConfirm: function (value) {
  	          return addApplicationDraft(company, value);
  	        }
  	      });
  	    });

  	    scope.querySelector("[data-app-save]")?.addEventListener("click", function () {
  	      saveApplicationDraft(company);
  	    });

  	    scope.querySelector("[data-app-undo]")?.addEventListener("click", async function () {
  	      const approved = await fifConfirm("Discard all unsaved application changes and restore the last saved list?", {
  	        title: "Undo Application Changes",
  	        type: "warning",
  	        confirmText: "Undo Changes",
  	        cancelText: "Keep Editing"
  	      });
  	      if (!approved) return;
  	      discardApplicationDraft("Reverted");
  	      render();
  	    });

  	    scope.querySelectorAll("[data-app-rename]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const index = Number(button.getAttribute("data-app-rename"));
  	        const list = applications(company);
  	        openApplicationTextPrompt({
  	          title: "Rename Application",
  	          subtitle: "Change the application label. Save the list when you are finished.",
  	          value: list[index] || "",
  	          confirmText: "Apply Name",
  	          onConfirm: function (value) {
  	            return renameApplicationDraft(company, index, value);
  	          }
  	        });
  	      });
  	    });

  	    scope.querySelectorAll("[data-app-remove]").forEach(function (button) {
  	      button.addEventListener("click", async function () {
  	        const index = Number(button.getAttribute("data-app-remove"));
  	        const list = applications(company);
  	        const name = list[index] || "Application";
  	        const approved = await fifConfirm("Remove this application from the company manifest?", {
  	          title: "Remove Application",
  	          type: "danger",
  	          confirmText: "Remove",
  	          cancelText: "Cancel",
  	          details: [{
  	            label: "Application", value: name
  	          }]
  	        });
  	        if (!approved) return;
  	        removeApplicationDraft(company, index);
  	        render();
  	      });
  	    });
  	  }

  	  function renderApplications(company) {
  	    const allApps = applications(company);
  	    const search = lower(state.search);
  	    const visible = allApps
  	    .map(function (name,
  	      index) {
  	      return {
  	        name: name, index: index
  	      };
  	    })
  	    .filter(function (entry) {
  	      return !search || lower(entry.name).indexOf(search) !== -1;
  	    });

  	    return `
  	    <section class="fifdash-app-manager">
  	    <header class="fifdash-app-manager-head">
  	    <div class="fifdash-app-manager-heading">
  	    <span class="fifdash-app-manager-icon">${ICONS.applications}</span>
  	    <div>
  	    <span class="eyebrow">Company manifest</span>
  	    <h2>Applications</h2>
  	    <p>Add, rename or remove the application labels available to ${escapeHtml(companyName(company))}.</p>
  	    </div>
  	    </div>

  	    <div class="fifdash-app-manager-actions">
  	    <span class="fifdash-app-status ${state.applicationDirty ? "dirty": state.applicationStatus === "Saved" ? "saved": ""}"><i></i>${escapeHtml(applicationStatusLabel())}</span>
  	    <button type="button" class="fifdash-app-button primary" data-app-add ${state.applicationSaving ? "disabled": ""}>+ Add Application</button>
  	    <button type="button" class="fifdash-app-button" data-app-save ${!state.applicationDirty || state.applicationSaving ? "disabled": ""}>Save</button>
  	    <button type="button" class="fifdash-app-button" data-app-undo ${!state.applicationDirty || state.applicationSaving ? "disabled": ""}>Undo</button>
  	    </div>
  	    </header>

  	    <div class="fifdash-app-manager-meta">
  	    <span><strong>${allApps.length}</strong> application${allApps.length === 1 ? "": "s"}</span>
  	    <span>Stored at Manifest.Applications</span>
  	    </div>

  	    <div class="fifdash-app-list">
  	    ${visible.length ? visible.map(function (entry) {
  	      return `
  	      <article class="fifdash-app-row">
  	      <span class="fifdash-app-row-number">${String(entry.index + 1).padStart(2,
  	        "0")}</span>
  	      <span class="fifdash-app-row-icon">${ICONS.applications}</span>
  	      <div class="fifdash-app-row-copy">
  	      <strong>${escapeHtml(entry.name)}</strong>
  	      <small>Operational application</small>
  	      </div>
  	      <div class="fifdash-app-row-actions">
  	      <button type="button" data-app-rename="${entry.index}" ${state.applicationSaving ? "disabled": ""}>Rename</button>
  	      <button type="button" class="danger" data-app-remove="${entry.index}" ${state.applicationSaving ? "disabled": ""}>Remove</button>
  	      </div>
  	      </article>`;
  	    }).join(""): `
  	    <div class="fifdash-app-manager-empty">
  	    <span>${ICONS.applications}</span>
  	    <strong>${search ? "No matching applications": "No applications yet"}</strong>
  	    <p>${search ? "Clear the search or use a different term.": "Use Add Application to create the first application for this company."}</p>
  	    </div>`}
  	    </div>
  	    </section>`;
  	  }

  	  function renderEmpty(title, message) {
  	    return `
  	    <section class="fifdash-empty">
  	    <div class="fifdash-empty-icon">${ICONS.warning}</div>
  	    <h3>${escapeHtml(title)}</h3>
  	    <p>${escapeHtml(message)}</p>
  	    </section>`;
  	  }

  	  function naturalCompare(a, b) {
  	    return String(a == null ? "": a).localeCompare(String(b == null ? "": b), undefined, {
  	      numeric: true,
  	      sensitivity: "base"
  	    });
  	  }

  	  function vehicleSortValue(vehicle, index, key) {
  	    const view = periodView(vehicle);
  	    if (key === "vehicle" || key === "manage") return assetIdentity(vehicle, index, "Vehicle");
  	    if (key === "odometer") return vehicleOdometerCounter(vehicle);
  	    if (key === "hobbs") return vehicleHobbsCounter(vehicle);
  	    if (key === "distance") return vehiclePeriodDistance(vehicle, view);
  	    if (key === "hours") return vehiclePeriodHours(vehicle, view);
  	    if (key === "fuel") return numberValue(view && view.Litres);
  	    if (key === "events") return CAN_ACCESS_LOCATION_EVENTS ? fifVehicleEventSortValue(selectedCompany(), vehicle) : null;
  	    if (key === "cost") return numberValue(view && view.Cost);
  	    if (key === "alerts") return numberValue(notificationCount(vehicle));
  	    return assetIdentity(vehicle, index, "Vehicle");
  	  }

  	  function sortedVehicleAssets(company) {
  	    const source = filterAssets(tabAssets(company, "vehicles"), "vehicles").map(function (vehicle, index) {
  	      return {
  	        vehicle: vehicle, originalIndex: index
  	      };
  	    });
  	    const key = state.vehicleSortKey || "vehicle";
  	    const direction = state.vehicleSortDir === "desc" ? -1: 1;

  	    source.sort(function (a, b) {
  	      const av = vehicleSortValue(a.vehicle, a.originalIndex, key);
  	      const bv = vehicleSortValue(b.vehicle, b.originalIndex, key);
  	      const aMissing = av === null || av === undefined || av === "";
  	      const bMissing = bv === null || bv === undefined || bv === "";
  	      if (aMissing && bMissing) return naturalCompare(assetIdentity(a.vehicle, a.originalIndex, "Vehicle"), assetIdentity(b.vehicle, b.originalIndex, "Vehicle"));
  	      if (aMissing) return 1;
  	      if (bMissing) return -1;
  	      if (typeof av === "number" && typeof bv === "number") {
  	        if (av < bv) return -1 * direction;
  	        if (av > bv) return 1 * direction;
  	      } else {
  	        const result = naturalCompare(av, bv);
  	        if (result) return result * direction;
  	      }
  	      return naturalCompare(assetIdentity(a.vehicle, a.originalIndex, "Vehicle"), assetIdentity(b.vehicle, b.originalIndex, "Vehicle"));
  	    });
  	    return source;
  	  }

  	  function vehicleSortButton(key,
  	    label) {
  	    const active = state.vehicleSortKey === key;
  	    const direction = active ? state.vehicleSortDir: "";
  	    return `<button type="button" data-vehicle-sort="${escapeAttr(key)}" class="${active ? "active": ""}" aria-label="Sort by ${escapeAttr(label)} ${active ? direction: ""}"><span>${escapeHtml(label)}</span><i class="${direction}"></i></button>`;
  	  }



  	  function renderVehicleFleetView(company, requestedTab) {
  	    const tab = requestedTab === "trailers" ? "trailers" : "vehicles";
  	    if (!userCanAccessMainTab(tab)) {
  	      return renderPermissionBoundary("Function Not Assigned", "This asset area is not present in the signed-in user's Settings property.");
  	    }
  	    let sorted;

  	    if (tab === "vehicles") {
  	      sorted = sortedVehicleAssets(company);
  	    } else {
  	      const fullList = tabAssets(company, "trailers");
  	      sorted = filterAssets(fullList, "trailers").map(function (asset, filteredIndex) {
  	        const originalIndex = fullList.indexOf(asset);
  	        return {
  	          vehicle: asset,
  	          originalIndex: originalIndex >= 0 ? originalIndex : filteredIndex
  	        };
  	      }).sort(function (a, b) {
  	        return naturalCompare(
  	          assetIdentity(a.vehicle, a.originalIndex, "Towed Asset"),
  	          assetIdentity(b.vehicle, b.originalIndex, "Towed Asset")
  	        );
  	      });
  	    }

  	    const emptyTitle = tab === "trailers" ? "No trailers or implements found" : "No vehicles found";
  	    const emptyDefault = tab === "trailers"
  	      ? "The selected company does not currently contain trailer or implement records."
  	      : "The selected company does not currently contain vehicle records.";

  	    const body = sorted.length
  	      ? `<section class="fifdash-asset-list">${sorted.map(function (entry) {
  	          return renderAssetCard(entry.vehicle, entry.originalIndex, tab);
  	        }).join("")}</section>`
  	      : renderEmpty(
  	          emptyTitle,
  	          state.search
  	            ? "Nothing matches the current search or filter."
  	            : emptyDefault
  	        );

  	    return `<section class="fifdash-vehicle-dashboard fifdash-main-area-dashboard is-${escapeAttr(tab)}">
  	      <div class="fifdash-vehicle-fixed-area fifdash-main-area-fixed">
  	        ${renderSummary(company)}
  	        ${renderToolbar(company)}
  	        ${renderVehicleColumnHeader()}
  	      </div>
  	      <div class="fifdash-vehicle-list-scroll fifdash-main-area-scroll" data-main-area-scroll="${escapeAttr(tab)}">${body}</div>
  	    </section>`;
  	  }

  	  function renderContent(company) {
  	    if (!userCanAccessMainTab(state.activeTab)) {
  	      return renderPermissionBoundary("Function Not Assigned", "This Dashboard function is not present in the signed-in user's Settings property.");
  	    }
  	    if (state.activeTab === "applications") return renderApplications(company);
  	    if (state.activeTab === "tyres") {
  	      return `
  	      <section class="fifdash-tyre-warehouse-host" aria-label="Company tyre warehouse">
  	      <div id="companyTyreManagerRoot"></div>
  	      </section>`;
  	    }

  	    const assets = filterAssets(tabAssets(company, state.activeTab), state.activeTab);

  	    if (!assets.length) {
  	      return renderEmpty(
  	        `No ${state.activeTab === "vehicles" ? "vehicles": state.activeTab === "trailers" ? "trailers or implements": "tyres"} found`,
  	        state.search ? "Nothing matches the current search or filter.": "The selected company does not currently contain records for this section."
  	      );
  	    }

  	    return `
  	    <section class="fifdash-asset-list">
  	    ${assets.map(function (asset, index) {
  	      return renderAssetCard(asset, index, state.activeTab);
  	    }).join("")}
  	    </section>`;
  	  }

  	  let activeStyledSelectPortal = null;
  	  let styledSelectObserver = null;
  	  const FIF_DATE_PICKER_STYLE_ID = "fif-styled-date-picker-v2163-style";
  	  let activeStyledDatePortal = null;

  	  function fifDatePad(value) {
  	    return String(value).padStart(2, "0");
  	  }

  	  function fifDateOnlyValue(value) {
  	    const match = clean(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  	    return match ? match[1] + "-" + match[2] + "-" + match[3] : "";
  	  }

  	  function fifDateTimePart(value) {
  	    const match = clean(value).match(/T(\d{2}):(\d{2})/);
  	    return match ? match[1] + ":" + match[2] : "";
  	  }

  	  function fifDateParts(value) {
  	    const date = fifDateOnlyValue(value);
  	    if (!date) return null;
  	    const parts = date.split("-").map(Number);
  	    if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) return null;
  	    return {
  	      year: parts[0],
  	      month: parts[1] - 1,
  	      day: parts[2],
  	      key: date
  	    };
  	  }

  	  function fifDateDisplayValue(value, type) {
  	    const parts = fifDateParts(value);
  	    if (!parts) return "";
  	    const dateText = fifDatePad(parts.day) + "/" + fifDatePad(parts.month + 1) + "/" + parts.year;
  	    if (type === "datetime-local") {
  	      const time = fifDateTimePart(value);
  	      return dateText + (time ? " " + time : "");
  	    }
  	    return dateText;
  	  }

  	  function fifDateSourceValue(dateKey, timeValue, type) {
  	    if (!dateKey) return "";
  	    if (type === "datetime-local") return dateKey + "T" + (clean(timeValue) || "00:00");
  	    return dateKey;
  	  }

  	  function fifDateRangeYears(input) {
  	    const minParts = fifDateParts(input && input.min);
  	    const maxParts = fifDateParts(input && input.max);
  	    return {
  	      minYear: minParts ? minParts.year : null,
  	      maxYear: maxParts ? maxParts.year : null
  	    };
  	  }

  	  function fifDateYearAllowed(input, year) {
  	    const range = fifDateRangeYears(input);
  	    if (range.minYear !== null && year < range.minYear) return false;
  	    if (range.maxYear !== null && year > range.maxYear) return false;
  	    return true;
  	  }

  	  function fifDateMonthAllowed(input, year, month) {
  	    const minDate = fifDateOnlyValue(input && input.min);
  	    const maxDate = fifDateOnlyValue(input && input.max);
  	    const monthStart = year + "-" + fifDatePad(month + 1) + "-01";
  	    const monthEndDate = new Date(year, month + 1, 0);
  	    const monthEnd = year + "-" + fifDatePad(month + 1) + "-" + fifDatePad(monthEndDate.getDate());
  	    if (minDate && monthEnd < minDate) return false;
  	    if (maxDate && monthStart > maxDate) return false;
  	    return true;
  	  }

  	  function fifDateDecadeStart(year) {
  	    return Math.floor(Number(year) / 10) * 10;
  	  }

  	  function fifDateCenturyStart(year) {
  	    return Math.floor(Number(year) / 100) * 100;
  	  }

  	  function fifDateDecadeAllowed(input, startYear) {
  	    const range = fifDateRangeYears(input);
  	    const endYear = startYear + 9;
  	    if (range.minYear !== null && endYear < range.minYear) return false;
  	    if (range.maxYear !== null && startYear > range.maxYear) return false;
  	    return true;
  	  }

  	  function fifDateNavigationStep(view) {
  	    if (view === "months") return 1;
  	    if (view === "years") return 10;
  	    if (view === "decades") return 100;
  	    return 1;
  	  }

  	  function fifDateViewLabel(portal, monthNames) {
  	    if (portal.view === "months") return String(portal.year);
  	    if (portal.view === "years") {
  	      const start = fifDateDecadeStart(portal.year);
  	      return start + "–" + (start + 9);
  	    }
  	    if (portal.view === "decades") {
  	      const start = fifDateCenturyStart(portal.year);
  	      return start + "–" + (start + 99);
  	    }
  	    return monthNames[portal.month] + " " + portal.year;
  	  }

  	  function fifDateHigherView(view) {
  	    if (view === "days") return "months";
  	    if (view === "months") return "years";
  	    if (view === "years") return "decades";
  	    return "decades";
  	  }

  	  function ensureStyledDatePickerStyles() {
  	    document.getElementById("fif-styled-date-picker-v2162-style")?.remove();
  	    if (document.getElementById(FIF_DATE_PICKER_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = FIF_DATE_PICKER_STYLE_ID;
  	    style.textContent = `
  	      .fif-native-date-source{
  	        position:absolute!important;
  	        width:1px!important;
  	        height:1px!important;
  	        min-width:1px!important;
  	        min-height:1px!important;
  	        padding:0!important;
  	        margin:0!important;
  	        border:0!important;
  	        opacity:0!important;
  	        pointer-events:none!important;
  	        overflow:hidden!important;
  	      }
  	      .fif-styled-date{position:relative;width:100%;min-width:0}
  	      .fif-styled-date-button{
  	        width:100%;min-width:0;min-height:42px;display:grid;
  	        grid-template-columns:minmax(0,1fr) auto;align-items:center;gap:10px;
  	        padding:0 11px;border:1px solid rgba(255,255,255,.11);
  	        border-radius:9px;background:#0b0e0c;color:#eef1ef;
  	        text-align:left;font:700 12px/1.2 Inter,system-ui,sans-serif;
  	        cursor:pointer;outline:none;transition:border-color .14s,box-shadow .14s,background .14s
  	      }
  	      .fif-styled-date-button:hover,.fif-styled-date.is-open .fif-styled-date-button,.fif-styled-date-button:focus-visible{
  	        border-color:#cc6633;background:#0e120f;box-shadow:0 0 0 2px rgba(204,102,51,.11)
  	      }
  	      .fif-styled-date.is-empty .fif-styled-date-label{color:#69716c;font-weight:550}
  	      .fif-styled-date.is-disabled{opacity:.48}.fif-styled-date-button:disabled{cursor:default}
  	      .fif-styled-date-icon{
  	        width:25px;height:25px;display:grid;place-items:center;border-radius:7px;
  	        border:1px solid rgba(204,102,51,.26);background:rgba(204,102,51,.08);color:#df804d
  	      }
  	      .fif-styled-date-icon svg{width:14px;height:14px;fill:none;stroke:currentColor;stroke-width:1.8}
  	      .fif-styled-date-error{display:none;margin-top:4px;color:#ef8682;font:750 8px/1.2 Inter,system-ui}
  	      .fif-styled-date.is-invalid .fif-styled-date-button{border-color:#ef5350;box-shadow:0 0 0 2px rgba(239,83,80,.12)}
  	      .fif-styled-date.is-invalid .fif-styled-date-error{display:block}
  	      .fif-styled-date-menu{
  	        position:fixed;z-index:2147483647;width:326px;overflow:hidden;
  	        border:1px solid rgba(204,102,51,.46);border-radius:13px;
  	        background:linear-gradient(155deg,#171b18,#090c0a 72%);
  	        color:#edf1ee;box-shadow:0 24px 65px rgba(0,0,0,.7),0 0 0 1px rgba(255,255,255,.025);
  	        font-family:Inter,system-ui,sans-serif
  	      }
  	      .fif-date-head{display:grid;grid-template-columns:36px minmax(0,1fr) 36px;align-items:center;gap:7px;padding:10px;border-bottom:1px solid rgba(255,255,255,.07)}
  	      .fif-date-level{
  	        min-width:0;height:34px;padding:0 9px;border:1px solid transparent;
  	        border-radius:8px;background:transparent;color:#f0f3f1;
  	        text-align:center;font:900 12px/1 Inter,system-ui;cursor:pointer
  	      }
  	      .fif-date-level:hover,.fif-date-level:focus-visible{
  	        border-color:rgba(204,102,51,.38);background:rgba(204,102,51,.07);outline:none
  	      }
  	      .fif-date-level span{display:block}
  	      .fif-date-level small{display:block;margin-top:3px;color:#707a73;font-size:6.5px;font-weight:750;text-transform:uppercase;letter-spacing:.08em}
  	      .fif-date-nav{height:32px;border:1px solid rgba(255,255,255,.09);border-radius:8px;background:#111612;color:#d7ddd9;cursor:pointer;font-size:18px}
  	      .fif-date-nav:hover,.fif-date-nav:focus-visible{border-color:#cc6633;color:#fff;outline:none}
  	      .fif-date-week{display:grid;grid-template-columns:repeat(7,1fr);gap:3px;padding:8px 10px 3px}
  	      .fif-date-week span{text-align:center;color:#707a73;font-size:7px;font-weight:900;text-transform:uppercase}
  	      .fif-date-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:3px;padding:4px 10px 10px}
  	      .fif-date-day{height:34px;border:1px solid transparent;border-radius:8px;background:transparent;color:#cdd3cf;cursor:pointer;font-size:9px}
  	      .fif-date-day:hover,.fif-date-day:focus-visible{border-color:rgba(204,102,51,.48);background:rgba(204,102,51,.09);outline:none}
  	      .fif-date-day.outside{color:#4e5751}.fif-date-day.today{border-color:rgba(65,110,255,.42)}
  	      .fif-date-day.selected{border-color:#cc6633;background:linear-gradient(145deg,#b95b31,#753319);color:#fff;font-weight:900}
  	      .fif-date-day:disabled{opacity:.22;cursor:not-allowed;background:transparent}
  	      .fif-date-choice-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:7px;padding:11px;min-height:202px;align-content:start}
  	      .fif-date-choice{
  	        min-height:48px;padding:7px;border:1px solid rgba(255,255,255,.075);
  	        border-radius:9px;background:#101511;color:#cdd4cf;cursor:pointer;
  	        font:850 9px/1.25 Inter,system-ui
  	      }
  	      .fif-date-choice:hover,.fif-date-choice:focus-visible{border-color:rgba(204,102,51,.5);background:rgba(204,102,51,.09);color:#fff;outline:none}
  	      .fif-date-choice.selected{border-color:#cc6633;background:linear-gradient(145deg,#a84f2b,#642a16);color:#fff}
  	      .fif-date-choice.current{box-shadow:inset 0 0 0 1px rgba(65,110,255,.42)}
  	      .fif-date-choice.outside{color:#606963}
  	      .fif-date-choice:disabled{opacity:.23;cursor:not-allowed;background:#0c100d}
  	      .fif-date-choice strong,.fif-date-choice small{display:block}
  	      .fif-date-choice strong{font-size:10px}.fif-date-choice small{margin-top:3px;color:inherit;opacity:.7;font-size:7px;font-weight:650}
  	      .fif-date-view-help{padding:0 11px 9px;color:#6e7871;font-size:7.5px;line-height:1.4;text-align:center}
  	      .fif-date-time-row{display:grid;grid-template-columns:auto minmax(0,1fr);align-items:center;gap:10px;padding:9px 11px;border-top:1px solid rgba(255,255,255,.06);background:rgba(255,255,255,.015)}
  	      .fif-date-time-row span{color:#8b958e;font-size:9px;font-weight:850}
  	      .fif-date-time-row input{height:36px;border:1px solid rgba(255,255,255,.1);border-radius:8px;background:#080b09;color:#fff;padding:0 9px;outline:none;color-scheme:dark}
  	      .fif-date-time-row input:focus{border-color:#cc6633;box-shadow:0 0 0 2px rgba(204,102,51,.1)}
  	      .fif-date-actions{display:grid;grid-template-columns:auto auto minmax(0,1fr);gap:7px;padding:10px;border-top:1px solid rgba(255,255,255,.07);background:#101411}
  	      .fif-date-actions button{height:35px;padding:0 11px;border:1px solid rgba(255,255,255,.09);border-radius:8px;background:#171d18;color:#cfd5d1;font:850 8px Inter,system-ui;cursor:pointer}
  	      .fif-date-actions button:hover{border-color:rgba(204,102,51,.4);color:#fff}
  	      .fif-date-actions .apply{justify-self:end;min-width:86px;border-color:#a74e27;background:linear-gradient(145deg,#bd6034,#79351b);color:#fff}
  	      .fif-date-actions .clear:disabled{display:none}
  	      @media(max-width:480px){.fif-styled-date-menu{width:calc(100vw - 20px)}}
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function closeStyledDatePortal() {
  	    if (!activeStyledDatePortal) return;
  	    try {
  	      document.removeEventListener("pointerdown", activeStyledDatePortal.outsideHandler, true);
  	      document.removeEventListener("keydown", activeStyledDatePortal.keyHandler, true);
  	      window.removeEventListener("resize", activeStyledDatePortal.repositionHandler, true);
  	      window.removeEventListener("scroll", activeStyledDatePortal.repositionHandler, true);
  	    } catch (_) {}
  	    try {
  	      activeStyledDatePortal.shell.classList.remove("is-open");
  	      activeStyledDatePortal.menu.remove();
  	    } catch (_) {}
  	    activeStyledDatePortal = null;
  	  }

  	  function positionStyledDateMenu(button, menu) {
  	    if (!button || !menu) return;
  	    const rect = button.getBoundingClientRect();
  	    const padding = 8;
  	    const width = Math.min(326, window.innerWidth - padding * 2);
  	    menu.style.width = width + "px";
  	    menu.style.left = Math.max(padding, Math.min(window.innerWidth - width - padding, rect.left)) + "px";
  	    const expectedHeight = Math.min(menu.scrollHeight || 430, 470);
  	    const below = window.innerHeight - rect.bottom - padding;
  	    const above = rect.top - TOP_OFFSET_PX - padding;
  	    const openAbove = below < Math.min(expectedHeight, 280) && above > below;
  	    menu.style.top = (openAbove
  	      ? Math.max(TOP_OFFSET_PX + padding, rect.top - Math.min(expectedHeight, above) - 6)
  	      : rect.bottom + 6) + "px";
  	  }

  	  function syncStyledDateInput(input) {
  	    if (!input) return;
  	    const shell = input.__fifStyledDateShell;
  	    if (!shell || !shell.isConnected) return;
  	    const button = shell.querySelector(".fif-styled-date-button");
  	    const label = shell.querySelector(".fif-styled-date-label");
  	    const display = fifDateDisplayValue(input.value, input.type);
  	    if (label) label.textContent = display || (input.type === "datetime-local" ? "Select date and time" : "Select date");
  	    if (button) button.disabled = !!input.disabled;
  	    shell.classList.toggle("is-disabled", !!input.disabled);
  	    shell.classList.toggle("is-empty", !display);
  	    if (input.value) shell.classList.remove("is-invalid");
  	  }

  	  function renderStyledDateMenu(portal) {
  	    if (!portal || !portal.menu) return;
  	    const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  	    const monthShort = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  	    const weekdays = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
  	    const today = new Date();
  	    const todayKey = today.getFullYear() + "-" + fifDatePad(today.getMonth() + 1) + "-" + fifDatePad(today.getDate());
  	    const selectedParts = fifDateParts(portal.selectedDate);
  	    const minDate = fifDateOnlyValue(portal.input.min);
  	    const maxDate = fifDateOnlyValue(portal.input.max);
  	    const viewLabel = fifDateViewLabel(portal, monthNames);
  	    const levelHelp = portal.view === "days"
  	      ? "Choose day · click heading for months"
  	      : portal.view === "months"
  	        ? "Choose month · click heading for years"
  	        : portal.view === "years"
  	          ? "Choose year · click heading for decades"
  	          : "Choose decade within this century";

  	    let content = "";

  	    if (portal.view === "months") {
  	      content = `<div class="fif-date-choice-grid">${monthNames.map(function (name, month) {
  	        const allowed = fifDateMonthAllowed(portal.input, portal.year, month);
  	        const selected = selectedParts && selectedParts.year === portal.year && selectedParts.month === month;
  	        const current = today.getFullYear() === portal.year && today.getMonth() === month;
  	        return `<button type="button" class="fif-date-choice${selected ? " selected" : ""}${current ? " current" : ""}" data-fif-date-month="${month}" ${allowed ? "" : "disabled"}><strong>${monthShort[month]}</strong><small>${escapeHtml(name)}</small></button>`;
  	      }).join("")}</div>`;
  	    } else if (portal.view === "years") {
  	      const decadeStart = fifDateDecadeStart(portal.year);
  	      const years = [];
  	      for (let offset = -1; offset <= 10; offset += 1) {
  	        const year = decadeStart + offset;
  	        const allowed = fifDateYearAllowed(portal.input, year);
  	        const selected = selectedParts && selectedParts.year === year;
  	        const current = today.getFullYear() === year;
  	        const outside = year < decadeStart || year > decadeStart + 9;
  	        years.push(`<button type="button" class="fif-date-choice${selected ? " selected" : ""}${current ? " current" : ""}${outside ? " outside" : ""}" data-fif-date-year="${year}" ${allowed ? "" : "disabled"}><strong>${year}</strong><small>${outside ? "Adjacent decade" : "Year"}</small></button>`);
  	      }
  	      content = `<div class="fif-date-choice-grid">${years.join("")}</div>`;
  	    } else if (portal.view === "decades") {
  	      const centuryStart = fifDateCenturyStart(portal.year);
  	      const selectedDecade = selectedParts ? fifDateDecadeStart(selectedParts.year) : null;
  	      const currentDecade = fifDateDecadeStart(today.getFullYear());
  	      const decades = [];
  	      for (let offset = -10; offset <= 100; offset += 10) {
  	        const start = centuryStart + offset;
  	        const allowed = fifDateDecadeAllowed(portal.input, start);
  	        const outside = start < centuryStart || start > centuryStart + 99;
  	        decades.push(`<button type="button" class="fif-date-choice${selectedDecade === start ? " selected" : ""}${currentDecade === start ? " current" : ""}${outside ? " outside" : ""}" data-fif-date-decade="${start}" ${allowed ? "" : "disabled"}><strong>${start}s</strong><small>${start}–${start + 9}</small></button>`);
  	      }
  	      content = `<div class="fif-date-choice-grid">${decades.join("")}</div>`;
  	    } else {
  	      const firstDay = new Date(portal.year, portal.month, 1);
  	      const startOffset = (firstDay.getDay() + 6) % 7;
  	      const startDate = new Date(portal.year, portal.month, 1 - startOffset);
  	      const days = [];

  	      for (let index = 0; index < 42; index += 1) {
  	        const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + index);
  	        const key = date.getFullYear() + "-" + fifDatePad(date.getMonth() + 1) + "-" + fifDatePad(date.getDate());
  	        const outside = date.getMonth() !== portal.month;
  	        const disabled = (minDate && key < minDate) || (maxDate && key > maxDate);
  	        days.push(`<button type="button" class="fif-date-day${outside ? " outside" : ""}${key === todayKey ? " today" : ""}${key === portal.selectedDate ? " selected" : ""}" data-fif-date-day="${key}" ${disabled ? "disabled" : ""}>${date.getDate()}</button>`);
  	      }

  	      content = `<div class="fif-date-week">${weekdays.map(function (day) { return `<span>${day}</span>`; }).join("")}</div><div class="fif-date-grid">${days.join("")}</div>`;
  	    }

  	    portal.menu.innerHTML = `
  	      <div class="fif-date-head">
  	        <button type="button" class="fif-date-nav" data-fif-date-nav="-1" aria-label="Previous ${portal.view === "days" ? "month" : portal.view === "months" ? "year" : portal.view === "years" ? "decade" : "century"}">‹</button>
  	        <button type="button" class="fif-date-level" data-fif-date-level aria-label="${portal.view === "decades" ? "Century view" : "Open higher-level date selection"}"><span>${escapeHtml(viewLabel)}</span><small>${escapeHtml(levelHelp)}</small></button>
  	        <button type="button" class="fif-date-nav" data-fif-date-nav="1" aria-label="Next ${portal.view === "days" ? "month" : portal.view === "months" ? "year" : portal.view === "years" ? "decade" : "century"}">›</button>
  	      </div>
  	      ${content}
  	      <div class="fif-date-view-help">${escapeHtml(levelHelp)}</div>
  	      ${portal.input.type === "datetime-local" && portal.view === "days" ? `<label class="fif-date-time-row"><span>Time</span><input type="time" data-fif-date-time value="${escapeAttr(portal.selectedTime || "00:00")}"></label>` : ""}
  	      <div class="fif-date-actions">
  	        <button type="button" data-fif-date-today>Today</button>
  	        <button type="button" class="clear" data-fif-date-clear ${portal.input.required ? "disabled" : ""}>Clear</button>
  	        ${portal.view === "days" ? `<button type="button" class="apply" data-fif-date-apply>Apply</button>` : `<button type="button" class="apply" data-fif-date-return>Back to Days</button>`}
  	      </div>`;

  	    portal.menu.querySelectorAll("[data-fif-date-nav]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const direction = Number(button.getAttribute("data-fif-date-nav")) || 0;
  	        if (portal.view === "days") {
  	          const next = new Date(portal.year, portal.month + direction, 1);
  	          portal.year = next.getFullYear();
  	          portal.month = next.getMonth();
  	        } else {
  	          portal.year += direction * fifDateNavigationStep(portal.view);
  	        }
  	        renderStyledDateMenu(portal);
  	        positionStyledDateMenu(portal.button, portal.menu);
  	      });
  	    });

  	    portal.menu.querySelector("[data-fif-date-level]")?.addEventListener("click", function () {
  	      portal.view = fifDateHigherView(portal.view);
  	      renderStyledDateMenu(portal);
  	      positionStyledDateMenu(portal.button, portal.menu);
  	    });

  	    portal.menu.querySelectorAll("[data-fif-date-decade]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        portal.year = Number(button.getAttribute("data-fif-date-decade")) || portal.year;
  	        portal.view = "years";
  	        renderStyledDateMenu(portal);
  	        positionStyledDateMenu(portal.button, portal.menu);
  	      });
  	    });

  	    portal.menu.querySelectorAll("[data-fif-date-year]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        portal.year = Number(button.getAttribute("data-fif-date-year")) || portal.year;
  	        portal.view = "months";
  	        renderStyledDateMenu(portal);
  	        positionStyledDateMenu(portal.button, portal.menu);
  	      });
  	    });

  	    portal.menu.querySelectorAll("[data-fif-date-month]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        portal.month = Number(button.getAttribute("data-fif-date-month"));
  	        portal.view = "days";
  	        renderStyledDateMenu(portal);
  	        positionStyledDateMenu(portal.button, portal.menu);
  	      });
  	    });

  	    portal.menu.querySelectorAll("[data-fif-date-day]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        portal.selectedDate = button.getAttribute("data-fif-date-day") || "";
  	        const selected = fifDateParts(portal.selectedDate);
  	        if (selected) {
  	          portal.year = selected.year;
  	          portal.month = selected.month;
  	        }
  	        renderStyledDateMenu(portal);
  	        positionStyledDateMenu(portal.button, portal.menu);
  	      });
  	    });

  	    portal.menu.querySelector("[data-fif-date-time]")?.addEventListener("input", function (event) {
  	      portal.selectedTime = clean(event.target.value);
  	    });

  	    portal.menu.querySelector("[data-fif-date-today]")?.addEventListener("click", function () {
  	      const now = new Date();
  	      portal.selectedDate = now.getFullYear() + "-" + fifDatePad(now.getMonth() + 1) + "-" + fifDatePad(now.getDate());
  	      portal.year = now.getFullYear();
  	      portal.month = now.getMonth();
  	      portal.view = "days";
  	      if (portal.input.type === "datetime-local") portal.selectedTime = fifDatePad(now.getHours()) + ":" + fifDatePad(now.getMinutes());
  	      renderStyledDateMenu(portal);
  	      positionStyledDateMenu(portal.button, portal.menu);
  	    });

  	    portal.menu.querySelector("[data-fif-date-return]")?.addEventListener("click", function () {
  	      portal.view = "days";
  	      renderStyledDateMenu(portal);
  	      positionStyledDateMenu(portal.button, portal.menu);
  	    });

  	    portal.menu.querySelector("[data-fif-date-clear]")?.addEventListener("click", function () {
  	      portal.input.value = "";
  	      portal.input.dispatchEvent(new Event("input", { bubbles: true }));
  	      portal.input.dispatchEvent(new Event("change", { bubbles: true }));
  	      syncStyledDateInput(portal.input);
  	      closeStyledDatePortal();
  	      portal.button.focus();
  	    });

  	    portal.menu.querySelector("[data-fif-date-apply]")?.addEventListener("click", function () {
  	      if (!portal.selectedDate) {
  	        portal.shell.classList.add("is-invalid");
  	        return;
  	      }
  	      portal.input.value = fifDateSourceValue(portal.selectedDate, portal.selectedTime, portal.input.type);
  	      portal.input.dispatchEvent(new Event("input", { bubbles: true }));
  	      portal.input.dispatchEvent(new Event("change", { bubbles: true }));
  	      syncStyledDateInput(portal.input);
  	      closeStyledDatePortal();
  	      portal.button.focus();
  	    });
  	  }

  	  function openStyledDateInput(input, shell) {
  	    if (!input || !shell || input.disabled) return;
  	    closeStyledSelectPortal();
  	    closeStyledDatePortal();

  	    const button = shell.querySelector(".fif-styled-date-button");
  	    if (!button) return;
  	    const initial = fifDateParts(input.value);
  	    const now = new Date();
  	    const portal = {
  	      input: input,
  	      shell: shell,
  	      button: button,
  	      menu: document.createElement("div"),
  	      selectedDate: initial ? initial.key : "",
  	      selectedTime: fifDateTimePart(input.value) || (input.type === "datetime-local" ? fifDatePad(now.getHours()) + ":" + fifDatePad(now.getMinutes()) : ""),
  	      year: initial ? initial.year : now.getFullYear(),
  	      month: initial ? initial.month : now.getMonth(),
  	      view: "days"
  	    };
  	    portal.menu.className = "fif-styled-date-menu";
  	    portal.menu.setAttribute("role", "dialog");
  	    portal.menu.setAttribute("aria-label", input.type === "datetime-local" ? "Choose date and time" : "Choose date");
  	    document.body.appendChild(portal.menu);
  	    shell.classList.add("is-open");

  	    portal.outsideHandler = function (event) {
  	      if (portal.menu.contains(event.target) || shell.contains(event.target)) return;
  	      closeStyledDatePortal();
  	    };
  	    portal.keyHandler = function (event) {
  	      if (event.key !== "Escape") return;
  	      event.preventDefault();
  	      closeStyledDatePortal();
  	      button.focus();
  	    };
  	    portal.repositionHandler = function () {
  	      if (!button.isConnected || !portal.menu.isConnected) {
  	        closeStyledDatePortal();
  	        return;
  	      }
  	      positionStyledDateMenu(button, portal.menu);
  	    };

  	    activeStyledDatePortal = portal;
  	    renderStyledDateMenu(portal);
  	    positionStyledDateMenu(button, portal.menu);
  	    setTimeout(function () {
  	      document.addEventListener("pointerdown", portal.outsideHandler, true);
  	      document.addEventListener("keydown", portal.keyHandler, true);
  	      window.addEventListener("resize", portal.repositionHandler, true);
  	      window.addEventListener("scroll", portal.repositionHandler, true);
  	      portal.menu.querySelector(".fif-date-day.selected:not(:disabled),.fif-date-day.today:not(:disabled),.fif-date-day:not(:disabled)")?.focus({ preventScroll: true });
  	    }, 0);
  	  }

  	  function enhanceStyledDateInput(input) {
  	    if (!input || (input.type !== "date" && input.type !== "datetime-local")) return;
  	    if (input.dataset.fifStyledDate === "1") {
  	      syncStyledDateInput(input);
  	      return;
  	    }
  	    ensureStyledDatePickerStyles();
  	    input.dataset.fifStyledDate = "1";
  	    input.classList.add("fif-native-date-source");
  	    input.tabIndex = -1;
  	    input.setAttribute("aria-hidden", "true");

  	    const shell = document.createElement("div");
  	    shell.className = "fif-styled-date";
  	    shell.innerHTML = `<button type="button" class="fif-styled-date-button" aria-haspopup="dialog"><span class="fif-styled-date-label"></span><span class="fif-styled-date-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 3v3M18 3v3M4 8h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z"/><path d="M8 12h3M13 12h3M8 16h3M13 16h3"/></svg></span></button><small class="fif-styled-date-error">A date is required.</small>`;
  	    input.insertAdjacentElement("afterend", shell);
  	    input.__fifStyledDateShell = shell;
  	    const button = shell.querySelector(".fif-styled-date-button");

  	    button.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      if (activeStyledDatePortal && activeStyledDatePortal.input === input) {
  	        closeStyledDatePortal();
  	        return;
  	      }
  	      openStyledDateInput(input, shell);
  	    });
  	    input.addEventListener("input", function () { syncStyledDateInput(input); });
  	    input.addEventListener("change", function () { syncStyledDateInput(input); });
  	    input.addEventListener("invalid", function (event) {
  	      event.preventDefault();
  	      shell.classList.add("is-invalid");
  	      button.focus();
  	    });
  	    syncStyledDateInput(input);
  	  }

  	  function enhanceAllStyledDateInputs(scope) {
  	    const host = scope && scope.querySelectorAll ? scope : document.getElementById(ROOT_ID);
  	    if (!host) return;
  	    host.querySelectorAll('input[type="date"],input[type="datetime-local"]').forEach(enhanceStyledDateInput);
  	  }

  	  function fifStyledSelectEventPath(event) {
  	    try {
  	      const path = typeof event.composedPath === "function" ? event.composedPath() : [];
  	      if (Array.isArray(path) && path.length) return path;
  	    } catch (_) {}
  	    const path = [];
  	    let node = event && event.target;
  	    while (node) {
  	      path.push(node);
  	      node = node.parentNode || node.host || null;
  	    }
  	    path.push(window);
  	    return path;
  	  }

  	  function fifStyledSelectPathMatch(event, selector) {
  	    const path = fifStyledSelectEventPath(event);
  	    for (let index = 0; index < path.length; index += 1) {
  	      const node = path[index];
  	      if (node && node.nodeType === 1 && typeof node.matches === "function" && node.matches(selector)) return node;
  	    }
  	    const target = event && event.target;
  	    return target && target.closest ? target.closest(selector) : null;
  	  }

  	  function fifStyledSelectSource(shell) {
  	    if (!shell) return null;
  	    if (shell.__fifSelectSource && shell.__fifSelectSource.isConnected) return shell.__fifSelectSource;
  	    const previous = shell.previousElementSibling;
  	    if (previous && previous.tagName === "SELECT") {
  	      shell.__fifSelectSource = previous;
  	      return previous;
  	    }
  	    return null;
  	  }

  	  function closeStyledSelectPortal() {
  	    const portal = activeStyledSelectPortal;
  	    if (!portal) return;

  	    activeStyledSelectPortal = null;
  	    try {
  	      document.removeEventListener("keydown", portal.keyHandler, true);
  	      window.removeEventListener("resize", portal.repositionHandler, true);
  	      window.removeEventListener("scroll", portal.repositionHandler, true);
  	    } catch (_) {}
  	    try {
  	      if (portal.shell) portal.shell.classList.remove("is-open");
  	      if (portal.button) portal.button.setAttribute("aria-expanded", "false");
  	      if (portal.menu) portal.menu.remove();
  	    } catch (_) {}
  	  }

  	  function selectedOptionText(select) {
  	    if (!select) return "Select";
  	    const option = select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
  	    return option ? String(option.textContent || option.label || option.value || "Select").trim() : "Select";
  	  }

  	  function syncStyledSelect(select) {
  	    if (!select) return;
  	    const shell = select.__fifStyledShell;
  	    if (!shell || !shell.isConnected) return;
  	    const button = shell.querySelector(".fif-styled-select-button");
  	    if (!button) return;
  	    const label = button.querySelector(".fif-styled-select-label");
  	    if (label) label.textContent = selectedOptionText(select);
  	    button.disabled = !!select.disabled;
  	    shell.classList.toggle("is-disabled", !!select.disabled);
  	    shell.classList.toggle("is-empty", !String(select.value || "").trim());
  	  }

  	  function positionStyledSelectMenu(button, menu) {
  	    if (!button || !menu) return;
  	    const rect = button.getBoundingClientRect();
  	    const viewportPadding = 8;
  	    const menuWidth = Math.max(170, Math.round(rect.width));
  	    menu.style.width = menuWidth + "px";
  	    menu.style.left = Math.max(viewportPadding, Math.min(window.innerWidth - menuWidth - viewportPadding, rect.left)) + "px";

  	    const measuredHeight = Math.min(menu.scrollHeight || 260, 320);
  	    const below = window.innerHeight - rect.bottom - viewportPadding;
  	    const above = rect.top - TOP_OFFSET_PX - viewportPadding;
  	    const openAbove = below < Math.min(measuredHeight, 180) && above > below;
  	    menu.classList.toggle("opens-up", openAbove);
  	    menu.style.maxHeight = Math.max(110, Math.min(320, openAbove ? above : below)) + "px";
  	    menu.style.top = (openAbove
  	      ? Math.max(TOP_OFFSET_PX + viewportPadding, rect.top - Math.min(measuredHeight, above) - 6)
  	      : rect.bottom + 6) + "px";
  	  }

  	  function fifStyledSelectEnabledOptions(portal) {
  	    if (!portal || !portal.menu) return [];
  	    return Array.from(portal.menu.querySelectorAll("[data-fif-select-index]")).filter(function (item) {
  	      return !item.disabled;
  	    });
  	  }

  	  function fifStyledSelectFocusCurrent(portal) {
  	    if (!portal) return;
  	    const options = fifStyledSelectEnabledOptions(portal);
  	    if (!options.length) return;
  	    const selected = options.find(function (item) {
  	      return item.classList.contains("is-selected");
  	    }) || options[0];
  	    try { selected.focus({ preventScroll: true }); } catch (_) { try { selected.focus(); } catch (__) {} }
  	  }

  	  function fifCommitStyledSelectOption(optionButton) {
  	    const portal = activeStyledSelectPortal;
  	    if (!portal || !optionButton || !portal.menu || !portal.menu.contains(optionButton)) return false;
  	    const index = Number(optionButton.getAttribute("data-fif-select-index"));
  	    const select = portal.select;
  	    const button = portal.button;
  	    if (!Number.isFinite(index) || !select || !select.options[index] || select.options[index].disabled) return false;

  	    select.selectedIndex = index;
  	    syncStyledSelect(select);
  	    closeStyledSelectPortal();

  	    select.dispatchEvent(new Event("input", { bubbles: true }));
  	    select.dispatchEvent(new Event("change", { bubbles: true }));
  	    requestAnimationFrame(function () {
  	      if (button && button.isConnected) {
  	        try { button.focus({ preventScroll: true }); } catch (_) { try { button.focus(); } catch (__) {} }
  	      }
  	    });
  	    return true;
  	  }

  	  function openStyledSelect(select, shell, keyboardOpen) {
  	    if (!select || !shell || select.disabled) return;
  	    closeStyledDatePortal();
  	    closeStyledSelectPortal();

  	    const button = shell.querySelector(".fif-styled-select-button");
  	    if (!button) return;

  	    const menu = document.createElement("div");
  	    menu.className = "fif-styled-select-menu";
  	    menu.setAttribute("role", "listbox");
  	    menu.setAttribute("data-fif-select-portal", "true");
  	    menu.setAttribute("aria-label", clean(select.getAttribute("aria-label") || select.name || "Choose an option"));
  	    menu.innerHTML = Array.from(select.options || []).map(function (option, index) {
  	      const selected = index === select.selectedIndex;
  	      return `<button type="button" role="option" class="fif-styled-select-option${selected ? " is-selected" : ""}" data-fif-select-index="${index}" aria-selected="${selected ? "true" : "false"}" ${option.disabled ? "disabled" : ""}><span>${escapeHtml(option.textContent || option.label || option.value || "")}</span>${selected ? '<i aria-hidden="true">✓</i>' : ""}</button>`;
  	    }).join("");

  	    document.body.appendChild(menu);
  	    shell.classList.add("is-open");
  	    button.setAttribute("aria-expanded", "true");
  	    positionStyledSelectMenu(button, menu);

  	    const keyHandler = function (event) {
  	      if (!activeStyledSelectPortal || activeStyledSelectPortal.menu !== menu) return;
  	      if (event.key === "Escape") {
  	        event.preventDefault();
  	        event.stopPropagation();
  	        closeStyledSelectPortal();
  	        if (button.isConnected) button.focus();
  	        return;
  	      }

  	      const options = fifStyledSelectEnabledOptions(activeStyledSelectPortal);
  	      if (!options.length) return;
  	      if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Home" || event.key === "End") {
  	        event.preventDefault();
  	        event.stopPropagation();
  	        let next = options[0];
  	        const current = options.indexOf(document.activeElement);
  	        if (event.key === "End") next = options[options.length - 1];
  	        else if (event.key === "Home") next = options[0];
  	        else if (event.key === "ArrowDown") next = options[(current + 1 + options.length) % options.length];
  	        else next = options[(current - 1 + options.length) % options.length];
  	        next.focus({ preventScroll: true });
  	        return;
  	      }

  	      if ((event.key === "Enter" || event.key === " ") && document.activeElement && document.activeElement.matches("[data-fif-select-index]")) {
  	        event.preventDefault();
  	        event.stopPropagation();
  	        fifCommitStyledSelectOption(document.activeElement);
  	        return;
  	      }

  	      if (event.key === "Tab") {
  	        setTimeout(function () {
  	          if (activeStyledSelectPortal && activeStyledSelectPortal.menu === menu) closeStyledSelectPortal();
  	        }, 0);
  	      }
  	    };

  	    const repositionHandler = function () {
  	      if (!button.isConnected || !menu.isConnected) {
  	        closeStyledSelectPortal();
  	        return;
  	      }
  	      positionStyledSelectMenu(button, menu);
  	    };

  	    activeStyledSelectPortal = {
  	      select: select,
  	      shell: shell,
  	      button: button,
  	      menu: menu,
  	      keyHandler: keyHandler,
  	      repositionHandler: repositionHandler
  	    };

  	    document.addEventListener("keydown", keyHandler, true);
  	    window.addEventListener("resize", repositionHandler, true);
  	    window.addEventListener("scroll", repositionHandler, true);

  	    if (keyboardOpen) requestAnimationFrame(function () {
  	      if (activeStyledSelectPortal && activeStyledSelectPortal.menu === menu) fifStyledSelectFocusCurrent(activeStyledSelectPortal);
  	    });
  	  }

  	  let styledSelectCaptureInstalled = false;
  	  let styledSelectSuppressClickUntil = 0;

  	  function fifToggleStyledSelectFromButton(button, keyboardOpen) {
  	    if (!button || button.disabled) return;
  	    const shell = button.closest(".fif-styled-select");
  	    const select = fifStyledSelectSource(shell);
  	    if (!shell || !select || select.disabled) return;

  	    if (activeStyledSelectPortal && activeStyledSelectPortal.shell === shell) {
  	      closeStyledSelectPortal();
  	      return;
  	    }

  	    openStyledSelect(select, shell, !!keyboardOpen);
  	    try { button.focus({ preventScroll: true }); } catch (_) { try { button.focus(); } catch (__) {} }
  	  }

  	  function onStyledSelectPointerDownCapture(event) {
  	    if (state.destroyed || event.button > 0) return;

  	    const optionButton = fifStyledSelectPathMatch(event, "[data-fif-select-index]");
  	    if (optionButton && activeStyledSelectPortal && activeStyledSelectPortal.menu.contains(optionButton)) {
  	      event.preventDefault();
  	      event.stopImmediatePropagation();
  	      styledSelectSuppressClickUntil = Date.now() + 650;
  	      fifCommitStyledSelectOption(optionButton);
  	      return;
  	    }

  	    const button = fifStyledSelectPathMatch(event, ".fif-styled-select-button");
  	    if (button) {
  	      event.preventDefault();
  	      event.stopImmediatePropagation();
  	      styledSelectSuppressClickUntil = Date.now() + 650;
  	      fifToggleStyledSelectFromButton(button, false);
  	      return;
  	    }

  	    const portal = activeStyledSelectPortal;
  	    if (!portal) return;
  	    const path = fifStyledSelectEventPath(event);
  	    if (
  	      path.indexOf(portal.menu) !== -1 ||
  	      path.indexOf(portal.shell) !== -1 ||
  	      portal.menu.contains(event.target) ||
  	      portal.shell.contains(event.target)
  	    ) return;
  	    closeStyledSelectPortal();
  	  }

  	  function onStyledSelectClickCapture(event) {
  	    const optionButton = fifStyledSelectPathMatch(event, "[data-fif-select-index]");
  	    const button = fifStyledSelectPathMatch(event, ".fif-styled-select-button");
  	    if (!optionButton && !button) return;

  	    event.preventDefault();
  	    event.stopImmediatePropagation();

  	    if (Date.now() <= styledSelectSuppressClickUntil) return;
  	    if (optionButton) {
  	      fifCommitStyledSelectOption(optionButton);
  	      return;
  	    }
  	    fifToggleStyledSelectFromButton(button, true);
  	  }

  	  function installStyledSelectCaptureController() {
  	    if (styledSelectCaptureInstalled) return;
  	    styledSelectCaptureInstalled = true;
  	    window.addEventListener("pointerdown", onStyledSelectPointerDownCapture, true);
  	    window.addEventListener("click", onStyledSelectClickCapture, true);
  	  }

  	  function removeStyledSelectCaptureController() {
  	    if (!styledSelectCaptureInstalled) return;
  	    styledSelectCaptureInstalled = false;
  	    window.removeEventListener("pointerdown", onStyledSelectPointerDownCapture, true);
  	    window.removeEventListener("click", onStyledSelectClickCapture, true);
  	  }

  	  function enhanceStyledSelect(select) {
  	    if (select && (select.multiple || select.hasAttribute("data-fif-native-select"))) return;
  	    if (!select || select.dataset.fifStyledSelect === "1") {
  	      if (select) syncStyledSelect(select);
  	      return;
  	    }

  	    select.dataset.fifStyledSelect = "1";
  	    select.classList.add("fif-native-select");

  	    const shell = document.createElement("div");
  	    shell.className = "fif-styled-select";
  	    shell.innerHTML = `<button type="button" class="fif-styled-select-button" aria-haspopup="listbox" aria-expanded="false"><span class="fif-styled-select-label"></span><span class="fif-styled-select-chevron" aria-hidden="true"></span></button>`;
  	    select.insertAdjacentElement("afterend", shell);
  	    select.__fifStyledShell = shell;
  	    shell.__fifSelectSource = select;

  	    const button = shell.querySelector(".fif-styled-select-button");
  	    button.addEventListener("keydown", function (event) {
  	      if (event.key !== "Enter" && event.key !== " " && event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
  	      event.preventDefault();
  	      event.stopImmediatePropagation();
  	      fifToggleStyledSelectFromButton(button, true);
  	    });

  	    select.addEventListener("change", function () {
  	      syncStyledSelect(select);
  	    });
  	    syncStyledSelect(select);
  	  }

  	  function enhanceAllStyledSelects(scope) {
  	    const host = scope && scope.querySelectorAll ? scope : document.getElementById(ROOT_ID);
  	    if (!host) return;
  	    host.querySelectorAll("select").forEach(enhanceStyledSelect);
  	  }

  	  function installStyledSelectObserver(root) {
  	    if (styledSelectObserver) styledSelectObserver.disconnect();
  	    styledSelectObserver = new MutationObserver(function (mutations) {
  	      let requiresScan = false;
  	      mutations.forEach(function (mutation) {
  	        if (mutation.type === "childList" && mutation.addedNodes.length) requiresScan = true;
  	        if (mutation.type === "attributes" && mutation.target) {
  	          if (mutation.target.tagName === "SELECT") syncStyledSelect(mutation.target);
  	          if (mutation.target.tagName === "INPUT" && (mutation.target.type === "date" || mutation.target.type === "datetime-local")) {
  	            syncStyledDateInput(mutation.target);
  	          }
  	        }
  	      });
  	      if (requiresScan) requestAnimationFrame(function () {
  	        enhanceAllStyledSelects(root);
  	        enhanceAllStyledDateInputs(root);
  	      });
  	    });
  	    styledSelectObserver.observe(root, {
  	      childList: true,
  	      subtree: true,
  	      attributes: true,
  	      attributeFilter: ["disabled", "min", "max", "value"]
  	    });
  	    enhanceAllStyledSelects(root);
  	    enhanceAllStyledDateInputs(root);
  	  }

  	  let companyTyreWarehouseInstance = null;

  	  function destroyCompanyTyreWarehouse() {
  	    if (!companyTyreWarehouseInstance) return;
  	    try {
  	      if (typeof companyTyreWarehouseInstance.destroy === "function") companyTyreWarehouseInstance.destroy();
  	    } catch (error) {

  	    }
  	    companyTyreWarehouseInstance = null;
  	  }

  	  function mountCompanyTyreWarehouse(root, company) {
  	    destroyCompanyTyreWarehouse();
  	    const host = root && root.querySelector ? root.querySelector("#companyTyreManagerRoot"): null;
  	    if (!host || !company) return;

  	    companyTyreWarehouseInstance = fifCompanyTyreWarehouseManager({
  	      App: APP_DATA,
  	      Tractors: tractors(company),
  	      Company: company,
  	      CompanyObjectId: clean(company.objectId || company.CompanyId),
  	      Hub: host,
  	      Backendless: BACKENDLESS_API,
  	      SVG: SVG_INPUT,
  	      InlineMode: true,
  	      HideCompanySelector: true,
  	      HideClose: true,
  	      AllowEditing: CAN_MANAGE_WORKSHOP,
  	      Title: "Tyre Warehouse",
  	      Alert: fifAlert,
  	      Confirm: fifConfirm,
  	      OnRendered: function (scope) {
  	        requestAnimationFrame(function () {
  	          enhanceAllStyledSelects(scope);
  	          enhanceAllStyledDateInputs(scope);
  	          enhanceDashboardNumberInputs(scope);
  	        });
  	      }
  	    });

  	    requestAnimationFrame(function () {
  	      enhanceAllStyledSelects(host);
  	    });
  	  }

  	  function render() {
  	    closeStyledSelectPortal();
  	    state.actionableAlertCache = {};
  	    state.locationEventCache = {};
  	    injectActionableAlertStyles();
  	    injectAdaptiveExperienceStyles();
  	    destroyCompanyTyreWarehouse();
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root || state.destroyed) return;

  	    const company = selectedCompany();
  	    normalisePermissionNavigation(company);
  	    const periods = historyPeriods(company);

  	    if (state.viewMode === "historical") {
  	      const selectedStillExists = periods.some(function (item) {
  	        return item.key === state.selectedHistoryKey;
  	      });

  	      if (!selectedStillExists) {
  	        state.selectedHistoryKey = periods.length ? periods[0].key: "";
  	      }
  	    }

  	    root.innerHTML = `
  	    <div class="fifdash-shell">
  	    ${renderSidebar(company)}

  	    <section class="fifdash-workspace">
  	    ${renderHeader(company)}

  	    <main class="fifdash-main main-area-${escapeAttr(state.activeTab)} ${state.selectedVehicleKey ? "has-vehicle-manager": ""} ${!state.selectedVehicleKey && (state.activeTab === "vehicles" || state.activeTab === "trailers") ? "fleet-list-mode": ""}">
  	    ${!CAN_ACCESS_DASHBOARD
  	      ? renderPermissionBoundary("Office Dashboard Not Granted", "The signed-in user requires Office in APP and Dash in the Office property.")
  	      : !state.activeTab
  	        ? renderPermissionBoundary("No Dashboard Functions Assigned", "Add at least one function to the user's Settings property.")
  	        : state.selectedVehicleKey
  	          ? renderIntegratedVehicleManager(company)
  	          : state.activeTab === "vehicles"
  	            ? renderVehicleFleetView(company, "vehicles")
  	            : state.activeTab === "trailers"
  	              ? renderVehicleFleetView(company, "trailers")
  	              : state.activeTab === "employees"
  	                ? renderEmployees(company)
  	                : state.activeTab === "tyres"
  	                  ? renderContent(company)
  	                  : `${renderSummary(company)}${renderToolbar(company)}${renderContent(company)}`}
  	    </main>
  	    </section>
  	    </div>`;

  	    composeVehicleTabWorkspace(root);
  	    enhanceCollapsibleGroups(root);
  	    bindEvents(root);
  	    bindEmployeeManagerEvents(root, company);
  	    bindAdaptiveExperienceEvents(root, company);
  	    enhanceAllStyledSelects(root);
  	    enhanceAllStyledDateInputs(root);
  	    enhanceDashboardNumberInputs(root);
  	    bindVehicleWorkspaceScroll(root);

  	    if (state.selectedVehicleKey && state.vehicleActiveTab === "tyres") {
  	      mountExactOriginalTyreManagerInline(root, company);
  	      arrangeMountedOriginalTyreHeader(root);
  	      requestAnimationFrame(function () { arrangeMountedOriginalTyreHeader(root); });
  	    } else {
  	      destroyExactInlineTyreManager();
  	    }

  	    if (!state.selectedVehicleKey && state.activeTab === "tyres" && CAN_ACCESS_TYRES) {
  	      mountCompanyTyreWarehouse(root, company);
  	    } else {
  	      destroyCompanyTyreWarehouse();
  	    }

  	    if (state.viewMode === "current") {
  	      fifScheduleAutomaticServiceProviderNotifications(company);
  	    }
  	  }

  	  function bindEvents(root) {
  	    root.querySelector("[data-company-select]")?.addEventListener("change", async function (event) {
  	      if (
  	        fifHasAnyUnsavedChanges() &&
  	        !(await fifConfirmWorkspaceDiscard("There are unsaved changes. Switching companies will discard them."))
  	      ) {
  	        event.target.value = state.selectedCompanyKey;
  	        syncStyledSelect(event.target);
  	        return;
  	      }
  	      discardApplicationDraft("Ready");
  	      clearVehicleEditorState();
  	      state.selectedCompanyKey = event.target.value;
  	      saveOperatingCompanyPreference(state.selectedCompanyKey);
  	      state.selectedVehicleKey = "";
  	      state.selectedAssetType = "tractor";
  	      clearVehicleEditorState();
  	      state.selectedHistoryKey = "";
  	      state.search = "";
  	      state.trailerType = "all";
  	      state.employeeSearch = "";
  	      state.employeeStatusFilter = "all";
  	      state.employeeDepartmentFilter = "all";

  	      render();

  	      if (CAN_ACCESS_LOCATION_EVENTS) {
  	        fifSchedulePassiveLocationEventHydration(selectedCompany(), false);
  	      }
  	    });

  	    root.querySelectorAll("[data-tab]").forEach(function (button) {
  	      button.addEventListener("click", async function () {
  	        const nextTab = button.getAttribute("data-tab") || "vehicles";
  	        if (!userCanAccessMainTab(nextTab)) {
  	          await fifAlert("This section is not assigned in your Dashboard Settings.", {
  	            title: "Function Not Available",
  	            type: "warning",
  	            confirmText: "Close"
  	          });
  	          return;
  	        }
  	        if (
  	          nextTab !== state.activeTab &&
  	          fifHasAnyUnsavedChanges() &&
  	          !(await fifConfirmWorkspaceDiscard("There are unsaved changes. Leaving this area will discard them."))
  	        ) return;
  	        if (nextTab !== "applications") discardApplicationDraft("Ready");
  	        clearVehicleEditorState();
  	        state.activeTab = nextTab;
  	        state.selectedVehicleKey = "";
  	        state.selectedAssetType = "tractor";
  	        clearVehicleEditorState();
  	        state.search = "";
  	        state.trailerType = "all";
  	        state.employeeSearch = "";
  	        state.employeeStatusFilter = "all";
  	        state.employeeDepartmentFilter = "all";
  	        render();
  	      });
  	    });

  	    root.querySelectorAll("[data-view-mode]").forEach(function (button) {
  	      button.addEventListener("click",
  	        function () {
  	          state.viewMode = button.getAttribute("data-view-mode") || "current";
  	          state.selectedHistoryKey = "";
  	          render();
  	          fifSchedulePassiveLocationEventHydration(selectedCompany(), false);
  	        });
  	    });

  	    root.querySelector("[data-period-select]")?.addEventListener("change", function (event) {
  	      state.selectedHistoryKey = event.target.value;
  	      render();
  	      fifSchedulePassiveLocationEventHydration(selectedCompany(), false);
  	    });

  	    root.querySelector("[data-search-input]")?.addEventListener("input", function (event) {
  	      state.search = event.target.value;
  	      renderDynamicMainOnly();
  	    });

  	    root.querySelector("[data-trailer-type]")?.addEventListener("change", function (event) {
  	      state.trailerType = event.target.value || "all";
  	      renderDynamicMainOnly();
  	    });

  	    root.querySelectorAll("[data-vehicle-sort]").forEach(function (button) {
  	      button.addEventListener("click",
  	        function () {
  	          const key = button.getAttribute("data-vehicle-sort") || "vehicle";
  	          if (state.vehicleSortKey === key) state.vehicleSortDir = state.vehicleSortDir === "asc" ? "desc": "asc";
  	          else {
  	            state.vehicleSortKey = key; state.vehicleSortDir = "asc";
  	          }
  	          renderDynamicMainOnly();
  	        });
  	    });

  	    root.querySelectorAll("[data-open-vehicle]").forEach(function (button) {
  	      button.addEventListener("click",
  	        function () {
  	          const assetType = button.getAttribute("data-asset-type") || (state.activeTab === "trailers" ? "trailer" : "tractor");
  	          if ((assetType === "trailer" && !CAN_ACCESS_TRAILERS) || (assetType !== "trailer" && !CAN_ACCESS_VEHICLES)) return;
  	          state.selectedVehicleKey = button.getAttribute("data-open-vehicle") || "";
  	          state.selectedAssetType = assetType;
  	          const openedAsset = fifVehicleFromStableKey(selectedCompany(), state.selectedVehicleKey, assetType);
  	          const openingTab = defaultVehicleManagerTab(openedAsset);
  	          if (!openedAsset || !openingTab) {
  	            state.selectedVehicleKey = "";
  	            state.selectedAssetType = "";
  	            return;
  	          }
  	          state.vehicleActiveTab = openingTab;
  	          clearVehicleEditorState();
  	          setVehicleMessage("", false);
  	          render();
  	        });
  	    });
  	    if (!state.selectedVehicleKey && (state.activeTab === "vehicles" || state.activeTab === "trailers")) bindFleetMetricActions(root, selectedCompany());

  	    if (state.selectedVehicleKey) bindVehicleManagerEvents(root, selectedCompany());
  	    if (!state.selectedVehicleKey && state.activeTab === "applications") bindApplicationManagerEvents(root, selectedCompany());
  	    enhanceDashboardNumberInputs(root);

  	  }


  	  function fifRefreshVehicleEventFigures(company) {
  	    if (!company || state.destroyed || state.selectedVehicleKey || state.activeTab !== "vehicles") return;

  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return;

  	    root.querySelectorAll('[data-fleet-metric-action="events"]').forEach(function (button) {
  	      const key = button.getAttribute("data-vehicle-key") || "";
  	      const assetType = button.getAttribute("data-asset-type") || "tractor";
  	      if (assetType === "trailer") return;

  	      const vehicle = fifVehicleFromStableKey(company, key, assetType);
  	      if (!vehicle) return;

  	      const value = button.querySelector("strong");
  	      if (value) value.textContent = fifVehicleEventMetricValue(company, vehicle);
  	    });
  	  }

  	  function fifSchedulePassiveLocationEventHydration(company, force) {
  	    if (!CAN_ACCESS_LOCATION_EVENTS || !company || state.destroyed) return;

  	    const requestedCompanyKey = companyKey(
  	      company,
  	      COMPANY_LIST.indexOf(company)
  	    );

  	    setTimeout(function () {
  	      if (state.destroyed) return;

  	      (async function () {
  	        try {
  	          await fifHydrateStoredEventHistory(company, !!force);
  	        } catch (_) {
  	        }

  	        if (state.destroyed) return;

  	        let activeCompany = selectedCompany();
  	        let activeCompanyKey = companyKey(
  	          activeCompany,
  	          COMPANY_LIST.indexOf(activeCompany)
  	        );

  	        if (activeCompanyKey === requestedCompanyKey) {
  	          state.locationEventCache = {};

  	          if (
  	            state.activeTab === "vehicles" &&
  	            !state.selectedVehicleKey &&
  	            state.vehicleSortKey === "events"
  	          ) {
  	            renderDynamicMainOnly();
  	          } else {
  	            fifRefreshVehicleEventFigures(activeCompany);
  	          }
  	        }

  	        try {
  	          await fifHydrateCompanyLocationEvents(company, !!force);
  	        } catch (_) {
  	          return;
  	        }

  	        if (state.destroyed) return;

  	        fifPersistHydratedEventsIntoHistory(company);

  	        activeCompany = selectedCompany();
  	        activeCompanyKey = companyKey(
  	          activeCompany,
  	          COMPANY_LIST.indexOf(activeCompany)
  	        );

  	        if (activeCompanyKey !== requestedCompanyKey) return;

  	        state.locationEventCache = {};

  	        if (
  	          state.activeTab === "vehicles" &&
  	          !state.selectedVehicleKey &&
  	          state.vehicleSortKey === "events"
  	        ) {
  	          renderDynamicMainOnly();
  	          return;
  	        }

  	        fifRefreshVehicleEventFigures(activeCompany);
  	      })().catch(function () {
  	      });
  	    }, 0);
  	  }

  	  function renderDynamicMainOnly() {
  	    closeStyledSelectPortal();
  	    closeStyledDatePortal();
  	    state.actionableAlertCache = {};

  	    if (state.selectedVehicleKey) {
  	      render();
  	      return;
  	    }

  	    const root = document.getElementById(ROOT_ID);
  	    if (!root || state.destroyed) return;

  	    const company = selectedCompany();
  	    normalisePermissionNavigation(company);
  	    const main = root.querySelector(".fifdash-main");
  	    if (!main) {
  	      render();
  	      return;
  	    }

  	    if (!CAN_ACCESS_DASHBOARD || !state.activeTab) {
  	      render();
  	      return;
  	    }

  	    main.innerHTML = state.activeTab === "vehicles"
  	      ? renderVehicleFleetView(company, "vehicles")
  	      : state.activeTab === "trailers"
  	        ? renderVehicleFleetView(company, "trailers")
  	        : state.activeTab === "employees"
  	          ? renderEmployees(company)
  	          : state.activeTab === "tyres"
  	            ? renderContent(company)
  	            : `${renderSummary(company)}${renderToolbar(company)}${renderContent(company)}`;

  	    const searchInput = main.querySelector("[data-search-input]");
  	    if (searchInput) {
  	      searchInput.addEventListener("input", function (event) {
  	        const caret = event.target.selectionStart;
  	        state.search = event.target.value;
  	        renderDynamicMainOnly();
  	        const replacement = document.getElementById(ROOT_ID)?.querySelector("[data-search-input]");
  	        if (replacement) {
  	          replacement.focus();
  	          try {
  	            replacement.setSelectionRange(caret, caret);
  	          } catch (_) {}
  	        }
  	      });
  	    }

  	    main.querySelector("[data-trailer-type]")?.addEventListener("change", function (event) {
  	      state.trailerType = event.target.value || "all";
  	      renderDynamicMainOnly();
  	    });

  	    main.querySelectorAll("[data-vehicle-sort]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const key = button.getAttribute("data-vehicle-sort") || "vehicle";
  	        if (state.vehicleSortKey === key) {
  	          state.vehicleSortDir = state.vehicleSortDir === "asc" ? "desc" : "asc";
  	        } else {
  	          state.vehicleSortKey = key;
  	          state.vehicleSortDir = "asc";
  	        }
  	        renderDynamicMainOnly();
  	      });
  	    });

  	    main.querySelectorAll("[data-open-vehicle]").forEach(function (button) {
  	      button.addEventListener("click", function () {
  	        const assetType = button.getAttribute("data-asset-type") || (state.activeTab === "trailers" ? "trailer" : "tractor");
  	        if ((assetType === "trailer" && !CAN_ACCESS_TRAILERS) || (assetType !== "trailer" && !CAN_ACCESS_VEHICLES)) return;
  	        state.selectedVehicleKey = button.getAttribute("data-open-vehicle") || "";
  	        state.selectedAssetType = assetType;
  	        const openedAsset = fifVehicleFromStableKey(company, state.selectedVehicleKey, assetType);
  	        const openingTab = defaultVehicleManagerTab(openedAsset);
  	        if (!openedAsset || !openingTab) {
  	          state.selectedVehicleKey = "";
  	          state.selectedAssetType = "";
  	          return;
  	        }
  	        state.vehicleActiveTab = openingTab;
  	        state.vehicleServiceView = "position";
  	        clearVehicleEditorState();
  	        setVehicleMessage("", false);
  	        render();
  	      });
  	    });

  	    if (state.activeTab === "vehicles" || state.activeTab === "trailers") bindFleetMetricActions(main, company);
  	    if (state.activeTab === "applications" && CAN_ACCESS_APPLICATIONS) bindApplicationManagerEvents(main, company);
  	    if (state.activeTab === "employees" && CAN_ACCESS_USERS) bindEmployeeManagerEvents(main, company);
  	    if (state.activeTab === "tyres" && CAN_ACCESS_TYRES) mountCompanyTyreWarehouse(root, company);

  	    enhanceAllStyledSelects(main);
  	    enhanceAllStyledDateInputs(main);
  	    enhanceDashboardNumberInputs(main);
  	    fifBindPageDirtyTracking(document.getElementById(ROOT_ID));
  	  }

  	  function injectVehicleManagerStyles() {
  	    document.getElementById(VEHICLE_STYLE_ID)?.remove();
  	    const style = document.createElement("style");
  	    style.id = VEHICLE_STYLE_ID;
  	    style.textContent = `
  	    #${ROOT_ID} .fifdash-main.has-vehicle-manager { padding: 0; overflow: hidden; }
  	    #${ROOT_ID} .fifvm-manager { height: 100%; min-height: 0; display: flex; flex-direction: column; background: #090b0a; color: var(--fif-text); }
  	    #${ROOT_ID} .fifvm-hero { --vehicle-color:#cc6633; position: relative; display: grid; grid-template-columns: auto minmax(250px,1fr) minmax(420px,auto); align-items: center; gap: 16px; padding: 18px 22px; border-bottom: 1px solid var(--fif-line); background: radial-gradient(circle at 12% 0%, color-mix(in srgb, var(--vehicle-color) 18%, transparent), transparent 30%), linear-gradient(145deg,#171a18,#0b0e0c); overflow: hidden; }
  	    #${ROOT_ID} .fifvm-hero-accent { position:absolute; inset:0 auto 0 0; width:4px; background:var(--vehicle-color); box-shadow:0 0 18px color-mix(in srgb,var(--vehicle-color) 70%,transparent); }
  	    #${ROOT_ID} .fifvm-hero-icon { width:58px; height:58px; border-radius:16px; display:grid; place-items:center; border:1px solid color-mix(in srgb,var(--vehicle-color) 55%,transparent); background:color-mix(in srgb,var(--vehicle-color) 9%,#0c110e); }
  	    #${ROOT_ID} .fifvm-hero-icon svg { width:29px; height:29px; fill:none; stroke:var(--vehicle-color); stroke-width:1.7; }
  	    #${ROOT_ID} .fifvm-hero-icon.is-global-vehicle { padding:0; border-color:transparent; background:transparent; }
  	    #${ROOT_ID} .fifvm-hero-icon.is-global-vehicle .fif-global-vehicle-icon { width:58px; height:58px; display:block; object-fit:contain; }
  	    #${ROOT_ID} .fifvm-hero-copy { min-width:0; }
  	    #${ROOT_ID} .fifvm-hero-actions { position:relative; z-index:8; justify-self:end; display:flex; align-items:center; }
  	    #${ROOT_ID} .fifvm-printables-wrap { position:relative; display:inline-flex; }
  	    #${ROOT_ID} .fifvm-printables-button { min-width:98px; height:36px; display:inline-flex; align-items:center; justify-content:center; padding:0 13px; border:1px solid rgba(232,115,57,.58); border-radius:10px; outline:none; cursor:pointer; color:#fff; background:linear-gradient(145deg,#b5572b,#733018); box-shadow:inset 0 1px 0 rgba(255,255,255,.08),0 7px 16px rgba(0,0,0,.24); font:850 11px/1 Inter,system-ui,sans-serif; }
  	    #${ROOT_ID} .fifvm-printables-button:hover,#${ROOT_ID} .fifvm-printables-button:focus-visible,#${ROOT_ID} .fifvm-printables-button[aria-expanded="true"] { border-color:rgba(255,145,78,.88); background:linear-gradient(145deg,#c46331,#7d351b); box-shadow:0 0 0 2px rgba(204,102,51,.13),0 9px 20px rgba(0,0,0,.30); }
  	    #${ROOT_ID} .fifvm-printables-popover { position:absolute; z-index:2147483647; top:calc(100% + 6px); right:0; width:190px; display:none; padding:5px; border:1px solid rgba(232,115,57,.48); border-radius:12px; background:linear-gradient(145deg,rgba(28,29,27,.995),rgba(9,12,10,.995)); box-shadow:0 18px 38px rgba(0,0,0,.52),inset 0 1px 0 rgba(255,255,255,.045); }
  	    #${ROOT_ID} .fifvm-printables-wrap.is-open .fifvm-printables-popover,#${ROOT_ID} .fifvm-printables-wrap:hover .fifvm-printables-popover,#${ROOT_ID} .fifvm-printables-wrap:focus-within .fifvm-printables-popover { display:block; }
  	    #${ROOT_ID} .fifvm-printables-popover>button { width:100%; min-height:48px; display:grid; grid-template-columns:34px minmax(0,1fr); align-items:center; gap:9px; padding:7px 9px; border:0; border-radius:9px; outline:none; cursor:pointer; text-align:left; color:#fff; background:transparent; }
  	    #${ROOT_ID} .fifvm-printables-popover>button:hover,#${ROOT_ID} .fifvm-printables-popover>button:focus-visible { background:rgba(204,102,51,.15); }
  	    #${ROOT_ID} .fifvm-printables-option-icon { width:32px; height:32px; display:grid; place-items:center; border:1px solid rgba(232,115,57,.36); border-radius:8px; color:#ff9b62; background:rgba(204,102,51,.09); font-size:17px; }
  	    #${ROOT_ID} .fifvm-printables-popover strong,#${ROOT_ID} .fifvm-printables-popover small { display:block; }
  	    #${ROOT_ID} .fifvm-printables-popover strong { font-size:12px; font-weight:900; }
  	    #${ROOT_ID} .fifvm-printables-popover small { margin-top:3px; color:#9da69f; font-size:9px; font-weight:700; }
  	    #${ROOT_ID} .fifvm-hero-title-row { display:flex; align-items:center; gap:10px; min-width:0; }
  	    #${ROOT_ID} .fifvm-hero-title-row h2 { margin:0; color:#fff; font-size:24px; line-height:1.1; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  	    #${ROOT_ID} .fifvm-hero-copy>p { margin:6px 0 10px; color:var(--fif-muted); font-size:12px; }
  	    #${ROOT_ID} .fifvm-status { display:inline-flex; align-items:center; padding:5px 9px; border-radius:999px; font-size:10px; font-weight:950; letter-spacing:.04em; text-transform:uppercase; }
  	    #${ROOT_ID} .fifvm-status.tone-good { background:rgba(73,199,133,.13); color:#69dda0; border:1px solid rgba(73,199,133,.35); }
  	    #${ROOT_ID} .fifvm-status.tone-warn { background:rgba(245,166,35,.12); color:#f5b657; border:1px solid rgba(245,166,35,.34); }
  	    #${ROOT_ID} .fifvm-status.tone-bad { background:rgba(239,83,80,.12); color:#ff7773; border:1px solid rgba(239,83,80,.35); }
  	    #${ROOT_ID} .fifvm-status.tone-neutral { background:rgba(255,255,255,.06); color:#c8ceca; border:1px solid rgba(255,255,255,.12); }
  	    #${ROOT_ID} .fifvm-permissions { display:flex; flex-wrap:wrap; gap:7px; }
  	    #${ROOT_ID} .fifvm-permission { display:inline-flex; align-items:center; gap:6px; padding:4px 8px; border-radius:999px; font-size:10px; font-weight:800; }
  	    #${ROOT_ID} .fifvm-permission i { width:6px; height:6px; border-radius:50%; }
  	    #${ROOT_ID} .fifvm-permission.allowed { color:#9ce3b9; background:rgba(73,199,133,.08); border:1px solid rgba(73,199,133,.22); }
  	    #${ROOT_ID} .fifvm-permission.allowed i { background:#49c785; box-shadow:0 0 8px rgba(73,199,133,.7); }
  	    #${ROOT_ID} .fifvm-permission.readonly { color:#9ca39f; background:rgba(255,255,255,.035); border:1px solid rgba(255,255,255,.08); }
  	    #${ROOT_ID} .fifvm-permission.readonly i { background:#6d746f; }
  	    #${ROOT_ID} .fifvm-hero-stats { display:grid; grid-template-columns:repeat(3,minmax(118px,1fr)); gap:9px; }
  	    #${ROOT_ID} .fifvm-info-tile { min-width:0; padding:11px 12px; border:1px solid var(--fif-line); border-radius:12px; background:rgba(255,255,255,.025); }
  	    #${ROOT_ID} .fifvm-info-tile>span { display:block; color:var(--fif-muted); font-size:10px; text-transform:uppercase; letter-spacing:.05em; }
  	    #${ROOT_ID} .fifvm-info-tile>strong { display:block; margin-top:5px; color:#fff; font-size:16px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  	    #${ROOT_ID} .fifvm-info-tile>small { display:block; margin-top:3px; color:#777f7a; font-size:10px; }
  	    #${ROOT_ID} .fifvm-info-tile.tone-good { border-color:rgba(73,199,133,.25); }
  	    #${ROOT_ID} .fifvm-info-tile.tone-bad { border-color:rgba(239,83,80,.34); }
  	    #${ROOT_ID} .fifvm-info-tile.tone-warn { border-color:rgba(245,166,35,.3); }
  	    #${ROOT_ID} .fifvm-tabs { flex:0 0 auto; display:flex; gap:5px; padding:9px 18px; background:#101311; border-bottom:1px solid var(--fif-line); overflow-x:auto; }
  	    #${ROOT_ID} .fifvm-tabs button { min-width:118px; display:flex; justify-content:center; align-items:center; gap:7px; border:1px solid transparent; border-radius:10px; background:transparent; color:#929a95; padding:9px 12px; cursor:pointer; font-weight:850; }
  	    #${ROOT_ID} .fifvm-tabs button small { font-size:8px; color:#6f7672; text-transform:uppercase; }
  	    #${ROOT_ID} .fifvm-tabs button:hover { color:#fff; background:rgba(255,255,255,.035); }
  	    #${ROOT_ID} .fifvm-tabs button.active { color:#fff; border-color:rgba(204,102,51,.38); background:linear-gradient(145deg,rgba(204,102,51,.15),rgba(204,102,51,.05)); box-shadow:inset 0 -2px 0 var(--fif-orange); }
  	    #${ROOT_ID} .fifvm-message { flex:0 0 auto; margin:9px 18px 0; border-radius:9px; padding:9px 12px; font-size:12px; font-weight:750; }
  	    #${ROOT_ID} .fifvm-message.success { color:#9ce3b9; border:1px solid rgba(73,199,133,.25); background:rgba(73,199,133,.07); }
  	    #${ROOT_ID} .fifvm-message.error { color:#ff8a87; border:1px solid rgba(239,83,80,.28); background:rgba(239,83,80,.08); }
  	    #${ROOT_ID} .fifvm-body { flex:1 1 auto; min-height:0; overflow:auto; padding:16px 18px 28px; }
  	    #${ROOT_ID} .fifvm-tabs { position:relative; z-index:45; box-shadow:0 7px 18px rgba(0,0,0,.22); }
  	    #${ROOT_ID} .fifvm-body.is-service-workspace { overflow:hidden; padding:0; }
  	    #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-root { height:100%; min-height:0; display:flex; flex-direction:column; }
  	    #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-head { position:relative; z-index:35; flex:0 0 auto; border-radius:0; }
  	    #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-tabs { position:relative; z-index:34; flex:0 0 auto; box-shadow:0 7px 16px rgba(0,0,0,.2); }
  	    #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-body { flex:1 1 auto; min-height:0; overflow:auto; padding:9px 12px 24px; scrollbar-width:thin; scrollbar-color:rgba(204,102,51,.5) transparent; }
  	    #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-body::-webkit-scrollbar { width:7px; }
  	    #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-body::-webkit-scrollbar-thumb { background:rgba(204,102,51,.48); border-radius:99px; }
  	    #${ROOT_ID} .fifsp-view-tabs { position:sticky; top:0; z-index:30; background:#0d100e; }
  	    #${ROOT_ID} .fifvm-overview-grid, #${ROOT_ID} .fifvm-two-column { display:grid; grid-template-columns:minmax(0,1.15fr) minmax(360px,.85fr); gap:14px; align-items:start; }
  	    #${ROOT_ID} .fifvm-panel { margin-bottom:14px; border:1px solid var(--fif-line); border-radius:14px; background:linear-gradient(145deg,rgba(19,23,20,.98),rgba(11,14,12,.98)); overflow:hidden; box-shadow:0 12px 28px rgba(0,0,0,.16); }
  	    #${ROOT_ID} .fifvm-panel>header { display:flex; align-items:center; justify-content:space-between; gap:12px; min-height:55px; padding:11px 14px; border-bottom:1px solid var(--fif-line); background:rgba(255,255,255,.018); }
  	    #${ROOT_ID} .fifvm-panel>header h3 { margin:0; color:#f7f8f7; font-size:13px; }
  	    #${ROOT_ID} .fifvm-panel>header p { margin:3px 0 0; color:#737b76; font-size:10px; }
  	    #${ROOT_ID} .fifvm-panel-body { min-height:0; }
  	    #${ROOT_ID} .fifvm-detail-line { min-height:39px; display:grid; grid-template-columns:minmax(145px,38%) minmax(0,1fr); align-items:center; gap:12px; padding:8px 14px; border-bottom:1px solid rgba(255,255,255,.045); }
  	    #${ROOT_ID} .fifvm-detail-line:last-child { border-bottom:0; }
  	    #${ROOT_ID} .fifvm-detail-line>span { color:#858d88; font-size:11px; }
  	    #${ROOT_ID} .fifvm-detail-line>strong { color:#eef1ef; font-size:12px; text-align:right; overflow-wrap:anywhere; }
  	    #${ROOT_ID} .fifvm-detail-line em { color:#787f7b; font-size:9px; font-style:normal; font-weight:700; }
  	    #${ROOT_ID} .fifvm-kpi-grid, #${ROOT_ID} .fifvm-tyre-summary { display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:10px; margin-bottom:14px; }
  	    #${ROOT_ID} .fifvm-issue { display:flex; gap:10px; padding:11px 13px; border-bottom:1px solid var(--fif-line); }
  	    #${ROOT_ID} .fifvm-issue>span svg { width:18px; fill:none; stroke:#ef5350; stroke-width:1.7; }
  	    #${ROOT_ID} .fifvm-issue strong { color:#f4f4f4; font-size:12px; }
  	    #${ROOT_ID} .fifvm-issue p { margin:3px 0 0; color:#8c938f; font-size:10px; }
  	    #${ROOT_ID} .fifvm-empty { padding:18px; color:#777f7a; font-size:12px; text-align:center; }
  	    #${ROOT_ID} .fifvm-empty.positive { color:#7fcf9e; }
  	    #${ROOT_ID} .fifvm-access-note { display:flex; align-items:center; gap:10px; margin-bottom:12px; padding:10px 12px; border:1px solid rgba(245,166,35,.22); border-radius:10px; background:rgba(245,166,35,.06); }
  	    #${ROOT_ID} .fifvm-access-note strong { color:#e4b66c; font-size:11px; }
  	    #${ROOT_ID} .fifvm-access-note span { color:#898f8b; font-size:10px; }
  	    #${ROOT_ID} .fifvm-panel-actions { display:flex; gap:7px; }
  	    #${ROOT_ID} .fifvm-btn {
  	    appearance:none !important;
  	    display:inline-flex;
  	    align-items:center;
  	    justify-content:center;
  	    gap:6px;
  	    min-height:34px;
  	    padding:0 12px;
  	    border:1px solid rgba(255,255,255,.12) !important;
  	    border-radius:9px;
  	    background:linear-gradient(145deg,#1b201c,#101411) !important;
  	    color:#cbd2cd !important;
  	    box-shadow:
  	    inset 0 1px 0 rgba(255,255,255,.035),
  	    0 4px 12px rgba(0,0,0,.18) !important;
  	    font-size:11px;
  	    font-weight:900;
  	    line-height:1;
  	    white-space:nowrap;
  	    cursor:pointer;
  	    transition:
  	    border-color .15s ease,
  	    background .15s ease,
  	    color .15s ease,
  	    transform .15s ease;
  	    }

  	    #${ROOT_ID} .fifvm-btn:hover {
  	    border-color:rgba(204,102,51,.52) !important;
  	    background:linear-gradient(145deg,#24251f,#151813) !important;
  	    color:#fff !important;
  	    }

  	    #${ROOT_ID} .fifvm-btn:active {
  	    transform:translateY(1px);
  	    }

  	    #${ROOT_ID} .fifvm-btn:focus-visible {
  	    outline:2px solid rgba(224,120,59,.72);
  	    outline-offset:2px;
  	    }

  	    #${ROOT_ID} .fifvm-btn.primary {
  	    border-color:rgba(224,113,55,.7) !important;
  	    background:linear-gradient(145deg,#d8743e,#9c431f) !important;
  	    color:#fff !important;
  	    box-shadow:
  	    inset 0 1px 0 rgba(255,255,255,.12),
  	    0 7px 16px rgba(204,102,51,.18) !important;
  	    }

  	    #${ROOT_ID} .fifvm-btn.primary:hover {
  	    border-color:rgba(255,155,96,.78) !important;
  	    background:linear-gradient(145deg,#e47d45,#ad4d24) !important;
  	    }

  	    #${ROOT_ID} .fifvm-btn.ghost {
  	    border-color:rgba(255,255,255,.1) !important;
  	    background:#151a16 !important;
  	    color:#bfc6c1 !important;
  	    box-shadow:none !important;
  	    }

  	    #${ROOT_ID} .fifvm-btn.ghost:hover {
  	    border-color:rgba(204,102,51,.4) !important;
  	    background:#1b201c !important;
  	    color:#fff !important;
  	    }

  	    #${ROOT_ID} .fifvm-btn:disabled {
  	    opacity:.42 !important;
  	    cursor:not-allowed;
  	    transform:none;
  	    }
  	    #${ROOT_ID} .fifvm-form-grid { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:0; }
  	    #${ROOT_ID} .fifvm-form-grid.compact { grid-template-columns:repeat(5,minmax(0,1fr)); border-bottom:1px solid var(--fif-line); }
  	    #${ROOT_ID} .fifvm-form-field { display:block; min-width:0; padding:11px 13px; border-right:1px solid rgba(255,255,255,.045); border-bottom:1px solid rgba(255,255,255,.045); }
  	    #${ROOT_ID} .fifvm-form-field>span { display:flex; align-items:center; gap:6px; min-height:18px; margin-bottom:6px; color:#8d9590; font-size:10px; font-weight:800; }
  	    #${ROOT_ID} .fifvm-form-field>span small { color:#646b67; font-size:8px; text-transform:uppercase; }
  	    #${ROOT_ID} .fifvm-field-lock { margin-left:auto; color:#666d69; font-size:8px; font-weight:700; }
  	    #${ROOT_ID} .fifvm-form-field input, #${ROOT_ID} .fifvm-form-field select, #${ROOT_ID} .fifvm-form-field textarea, #${ROOT_ID} .fifvm-capture input, #${ROOT_ID} .fifvm-capture textarea { width:100%; border:1px solid rgba(255,255,255,.09); border-radius:9px; background:#0c0f0d; color:#e9ecea; padding:8px 9px; outline:none; font-size:11px; }
  	    #${ROOT_ID} .fifvm-form-field input:focus, #${ROOT_ID} .fifvm-form-field select:focus, #${ROOT_ID} .fifvm-form-field textarea:focus, #${ROOT_ID} .fifvm-capture input:focus, #${ROOT_ID} .fifvm-capture textarea:focus { border-color:rgba(204,102,51,.72); box-shadow:0 0 0 2px rgba(204,102,51,.11); }
  	    #${ROOT_ID} .fifvm-form-field input:disabled, #${ROOT_ID} .fifvm-form-field select:disabled, #${ROOT_ID} .fifvm-form-field textarea:disabled { color:#adb3af; background:transparent; border-color:transparent; padding-left:0; opacity:1; }
  	    #${ROOT_ID} .fifvm-form-field textarea { min-height:72px; resize:vertical; }
  	    #${ROOT_ID} .fifvm-switch { display:flex; align-items:center; gap:8px; }
  	    #${ROOT_ID} .fifvm-switch input { position:absolute; opacity:0; pointer-events:none; }
  	    #${ROOT_ID} .fifvm-switch>span { width:34px; height:18px; border-radius:99px; background:#303632; position:relative; }
  	    #${ROOT_ID} .fifvm-switch>span:after { content:""; position:absolute; width:14px; height:14px; border-radius:50%; background:#aab0ac; left:2px; top:2px; transition:.15s; }
  	    #${ROOT_ID} .fifvm-switch input:checked+span { background:rgba(73,199,133,.35); }
  	    #${ROOT_ID} .fifvm-switch input:checked+span:after { left:18px; background:#65d998; }
  	    #${ROOT_ID} .fifvm-switch em { font-style:normal; color:#929a95; font-size:10px; }
  	    #${ROOT_ID} .fifvm-image-preview { height:80px; border-radius:9px; overflow:hidden; background:#050605; }
  	    #${ROOT_ID} .fifvm-image-preview img { width:100%; height:100%; object-fit:contain; }
  	    #${ROOT_ID} .fifvm-image-empty { height:36px; display:grid; place-items:center; border:1px dashed rgba(255,255,255,.1); border-radius:9px; color:#666d69; font-size:10px; }
  	    #${ROOT_ID} .fifvm-record-list { max-height:520px; overflow:auto; }
  	    #${ROOT_ID} .fifvm-record-card { display:grid; grid-template-columns:95px minmax(0,1fr); gap:12px; padding:11px 13px; border-bottom:1px solid var(--fif-line); }
  	    #${ROOT_ID} .fifvm-record-date { color:#cc7a51; font-size:10px; font-weight:850; }
  	    #${ROOT_ID} .fifvm-record-card h4 { margin:0; color:#f0f2f0; font-size:12px; }
  	    #${ROOT_ID} .fifvm-record-card p { margin:4px 0 0; color:#858d88; font-size:10px; }
  	    #${ROOT_ID} .fifvm-record-card small { display:block; margin-top:5px; color:#6e7671; font-size:9px; }
  	    #${ROOT_ID} .fifvm-capture { border:1px solid var(--fif-line); border-radius:14px; background:linear-gradient(145deg,#131713,#0c0f0d); padding:14px; }
  	    #${ROOT_ID} .fifvm-capture-head h3 { margin:0; color:#fff; font-size:14px; }
  	    #${ROOT_ID} .fifvm-capture-head p { margin:4px 0 14px; color:#777f7a; font-size:10px; }
  	    #${ROOT_ID} .fifvm-capture-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; margin-bottom:12px; }
  	    #${ROOT_ID} .fifvm-capture-grid label>span { display:block; margin:0 0 5px; color:#8b938e; font-size:10px; }
  	    #${ROOT_ID} .fifvm-capture-grid .wide { grid-column:1/-1; }
  	    #${ROOT_ID} .fifvm-capture textarea { min-height:86px; resize:vertical; }
  	    #${ROOT_ID} .fifvm-tyre-actions { display:flex; align-items:center; flex-wrap:wrap; gap:7px; margin-bottom:12px; padding:9px; border:1px solid var(--fif-line); border-radius:12px; background:#111512; }
  	    #${ROOT_ID} .fifvm-tyre-actions button { border:1px solid var(--fif-line); border-radius:8px; background:#1a1f1b; color:#aeb5b0; padding:8px 10px; cursor:pointer; font-size:10px; font-weight:850; }
  	    #${ROOT_ID} .fifvm-tyre-actions button.active { color:#fff; border-color:rgba(204,102,51,.52); background:rgba(204,102,51,.16); }
  	    #${ROOT_ID} .fifvm-tyre-actions button.save { margin-left:auto; color:#fff; border-color:rgba(73,199,133,.4); background:rgba(73,199,133,.18); }
  	    #${ROOT_ID} .fifvm-tyre-actions>span { color:#777f7a; font-size:10px; }
  	    #${ROOT_ID} .fifvm-tyre-workspace { display:grid; grid-template-columns:minmax(520px,1.25fr) minmax(330px,.75fr); gap:14px; align-items:start; }
  	    #${ROOT_ID} .fifvm-axle-layout { padding:13px; }
  	    #${ROOT_ID} .fifvm-axle-row { display:grid; grid-template-columns:minmax(0,1fr) 74px minmax(0,1fr); align-items:center; gap:12px; min-height:126px; padding:14px 0; border-bottom:1px dashed rgba(255,255,255,.075); position:relative; }
  	    #${ROOT_ID} .fifvm-axle-row:last-child { border-bottom:0; }
  	    #${ROOT_ID} .fifvm-axle-row>header { position:absolute; left:50%; top:9px; transform:translateX(-50%); text-align:center; }
  	    #${ROOT_ID} .fifvm-axle-row>header span { display:block; color:#c8ceca; font-size:10px; font-weight:900; }
  	    #${ROOT_ID} .fifvm-axle-row>header small { color:#6f7772; font-size:8px; text-transform:uppercase; }
  	    #${ROOT_ID} .fifvm-axle-side { display:flex; justify-content:flex-end; gap:7px; }
  	    #${ROOT_ID} .fifvm-axle-side.right { justify-content:flex-start; }
  	    #${ROOT_ID} .fifvm-axle-side.spare { grid-column:1/-1; justify-content:center; }
  	    #${ROOT_ID} .fifvm-axle-beam { height:10px; border-radius:10px; background:linear-gradient(#4b514d,#202421); box-shadow:inset 0 1px 0 rgba(255,255,255,.12),0 3px 8px rgba(0,0,0,.35); }
  	    #${ROOT_ID} .fifvm-tyre-slot { width:92px; min-height:84px; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:3px; border:1px solid rgba(255,255,255,.09); border-radius:11px; background:#111512; color:#dce0dd; cursor:pointer; }
  	    #${ROOT_ID} .fifvm-tyre-slot:hover:not(:disabled) { border-color:rgba(204,102,51,.45); transform:translateY(-1px); }
  	    #${ROOT_ID} .fifvm-tyre-slot.selected { border-color:#cc6633; box-shadow:0 0 0 2px rgba(204,102,51,.14),0 0 16px rgba(204,102,51,.14); }
  	    #${ROOT_ID} .fifvm-tyre-slot.empty { border-style:dashed; color:#747c77; }
  	    #${ROOT_ID} .fifvm-tyre-slot:disabled { cursor:default; }
  	    #${ROOT_ID} .fifvm-tyre-slot strong { font-size:10px; }
  	    #${ROOT_ID} .fifvm-tyre-slot small { max-width:78px; color:#969e99; font-size:8px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  	    #${ROOT_ID} .fifvm-tyre-slot em { color:#626a65; font-size:7px; font-style:normal; text-transform:uppercase; }
  	    #${ROOT_ID} .fifvm-tyre-wheel, #${ROOT_ID} .fifvm-warehouse-wheel { width:25px; height:31px; border:3px solid #555d58; border-radius:7px; background:repeating-linear-gradient(0deg,#171a18 0,#171a18 3px,#2b302d 4px,#2b302d 5px); position:relative; }
  	    #${ROOT_ID} .fifvm-warehouse-list { max-height:400px; overflow:auto; padding:9px; }
  	    #${ROOT_ID} .fifvm-warehouse-tyre { width:100%; display:flex; align-items:center; gap:10px; padding:10px; margin-bottom:7px; border:1px solid var(--fif-line); border-radius:10px; background:#101411; color:#fff; text-align:left; cursor:pointer; }
  	    #${ROOT_ID} .fifvm-warehouse-tyre.selected { border-color:#cc6633; background:rgba(204,102,51,.09); }
  	    #${ROOT_ID} .fifvm-warehouse-tyre>div { min-width:0; }
  	    #${ROOT_ID} .fifvm-warehouse-tyre strong, #${ROOT_ID} .fifvm-warehouse-tyre small, #${ROOT_ID} .fifvm-warehouse-tyre em { display:block; }
  	    #${ROOT_ID} .fifvm-warehouse-tyre strong { font-size:11px; }
  	    #${ROOT_ID} .fifvm-warehouse-tyre small { margin-top:2px; color:#838b86; font-size:9px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  	    #${ROOT_ID} .fifvm-warehouse-tyre em { margin-top:3px; color:#b66a45; font-size:8px; font-style:normal; text-transform:uppercase; }
  	    #${ROOT_ID} .fifvm-warehouse-tyre[draggable="true"] { cursor:grab; }
  	    #${ROOT_ID} .fifvm-warehouse-tyre.dragging { opacity:.46; transform:scale(.985); }
  	    #${ROOT_ID} .fifvm-drag-grip { margin-left:auto; color:#606862; font-size:14px; letter-spacing:-3px; }
  	    #${ROOT_ID} [data-vm-tyre-slot][draggable="true"]:active { cursor:grabbing !important; }
  	    #${ROOT_ID} [data-vm-tyre-slot].drag-over { background:rgba(204,102,51,.22) !important; outline:3px solid #cc6633 !important; box-shadow:0 0 20px rgba(204,102,51,.55) !important; transform:scale(1.025); }
  	    #${ROOT_ID} .fifvm-plan-count { margin-left:auto; padding:5px 8px; border:1px solid var(--fif-line); border-radius:999px; color:#737b76; font-size:9px; font-weight:900; }
  	    #${ROOT_ID} .fifvm-plan-count.has-plan { color:#ffd8c4; border-color:rgba(204,102,51,.48); background:rgba(204,102,51,.13); }
  	    #${ROOT_ID} .fifvm-tyre-actions button.save { margin-left:0; }
  	    #${ROOT_ID} .fifvm-tyre-actions button.print, #${ROOT_ID} .fifvm-modal footer button.print { border-color:rgba(77,146,255,.36);background:rgba(77,146,255,.11);color:#b8d0ff; }
  	    #${ROOT_ID} .fifvm-modal-wide { width:min(1180px,97vw);max-height:calc(100vh - 82px);display:flex;flex-direction:column; }
  	    #${ROOT_ID} .fifvm-modal-scroll { flex:1 1 auto;min-height:0;overflow:auto;padding:15px; }
  	    #${ROOT_ID} .fifvm-tyre-modal-summary { display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:9px;margin-bottom:12px; }
  	    #${ROOT_ID} .fifvm-tyre-data-grid { display:grid;grid-template-columns:minmax(330px,.82fr) minmax(470px,1.18fr);gap:12px;align-items:start; }
  	    #${ROOT_ID} .fifvm-tyre-data-lines { max-height:620px;overflow:auto; }
  	    #${ROOT_ID} .fifvm-stage-grid { display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;padding:10px; }
  	    #${ROOT_ID} .fifvm-stage-card { border:1px solid var(--fif-line);border-radius:10px;background:#0e120f;overflow:hidden; }
  	    #${ROOT_ID} .fifvm-stage-card.active { border-color:rgba(204,102,51,.55);box-shadow:0 0 18px rgba(204,102,51,.08); }
  	    #${ROOT_ID} .fifvm-stage-card>header { display:flex;justify-content:space-between;gap:8px;padding:8px 9px;border-bottom:1px solid var(--fif-line);background:rgba(255,255,255,.025); }
  	    #${ROOT_ID} .fifvm-stage-card>header strong { color:#fff;font-size:11px; }
  	    #${ROOT_ID} .fifvm-stage-card>header span { color:#b66a45;font-size:8px;font-weight:900;text-transform:uppercase; }
  	    #${ROOT_ID} .fifvm-stage-card>div { display:grid;grid-template-columns:1fr 1fr;gap:6px;padding:6px 9px;border-bottom:1px solid rgba(255,255,255,.04); }
  	    #${ROOT_ID} .fifvm-stage-card>div span { color:#727a75;font-size:9px; }
  	    #${ROOT_ID} .fifvm-stage-card>div strong { color:#e7ebe8;font-size:9px;text-align:right; }
  	    #${ROOT_ID} .fifvm-stage-card>p { margin:0;padding:8px 9px;color:#909893;font-size:9px;line-height:1.45; }
  	    #${ROOT_ID} .fifvm-history-list { max-height:460px;overflow:auto;padding:10px; }
  	    #${ROOT_ID} .fifvm-history-event { position:relative;display:grid;grid-template-columns:12px minmax(0,1fr);gap:8px;padding:0 0 12px; }
  	    #${ROOT_ID} .fifvm-history-event:not(:last-child):before { content:"";position:absolute;left:5px;top:12px;bottom:0;width:1px;background:rgba(204,102,51,.28); }
  	    #${ROOT_ID} .fifvm-history-dot { width:10px;height:10px;margin-top:4px;border-radius:50%;background:#cc6633;box-shadow:0 0 8px rgba(204,102,51,.55);z-index:1; }
  	    #${ROOT_ID} .fifvm-history-event>div:last-child { border:1px solid var(--fif-line);border-radius:10px;background:#0e120f;padding:9px; }
  	    #${ROOT_ID} .fifvm-history-event header { display:flex;align-items:center;gap:7px;flex-wrap:wrap; }
  	    #${ROOT_ID} .fifvm-history-event header strong { color:#f1f3f2;font-size:11px; }
  	    #${ROOT_ID} .fifvm-history-event header span { color:#c77a51;font-size:8px;font-weight:900;text-transform:uppercase; }
  	    #${ROOT_ID} .fifvm-history-event header time { margin-left:auto;color:#6f7772;font-size:8px; }
  	    #${ROOT_ID} .fifvm-history-meta { display:flex;gap:6px;flex-wrap:wrap;margin-top:7px; }
  	    #${ROOT_ID} .fifvm-history-meta span { padding:4px 6px;border-radius:6px;background:rgba(255,255,255,.035);color:#aab0ac;font-size:8px; }
  	    #${ROOT_ID} .fifvm-history-meta b { color:#6f7772;margin-right:4px; }
  	    #${ROOT_ID} .fifvm-history-event p { margin:7px 0 0;color:#858d88;font-size:9px;line-height:1.45; }
  	    #${ROOT_ID} .fifvm-tyre-actions button:disabled { opacity:.42; cursor:default; }
  	    #${ROOT_ID} .fifvm-tyre-capture { display:grid; grid-template-columns:220px minmax(260px,1fr); gap:9px; margin:-4px 0 12px; padding:9px; border:1px solid var(--fif-line); border-radius:11px; background:#0f1310; }
  	    #${ROOT_ID} .fifvm-tyre-capture label { color:#7c847f; font-size:9px; font-weight:850; text-transform:uppercase; letter-spacing:.06em; }
  	    #${ROOT_ID} .fifvm-tyre-capture input { width:100%; margin-top:5px; box-sizing:border-box; border:1px solid var(--fif-line); border-radius:8px; background:#151a16; color:#fff; padding:8px 9px; outline:none; }
  	    #${ROOT_ID} .fifvm-tyre-capture input:focus { border-color:rgba(204,102,51,.62); box-shadow:0 0 0 2px rgba(204,102,51,.12); }
  	    #${ROOT_ID} .fifvm-plan-list { display:flex; flex-direction:column; gap:6px; }
  	    #${ROOT_ID} .fifvm-plan-row { display:flex; align-items:center; gap:8px; padding:8px; border:1px solid var(--fif-line); border-radius:9px; background:#0f1310; }
  	    #${ROOT_ID} .fifvm-plan-row .kind { min-width:62px; padding:4px 6px; border-radius:6px; text-align:center; font-size:8px; font-weight:950; text-transform:uppercase; background:rgba(204,102,51,.14); color:#f1b18f; }
  	    #${ROOT_ID} .fifvm-plan-row .kind-removed { background:rgba(230,76,64,.13); color:#ffaaa2; }
  	    #${ROOT_ID} .fifvm-plan-row .kind-rotation { background:rgba(77,146,255,.13); color:#a8c8ff; }
  	    #${ROOT_ID} .fifvm-plan-row .kind-config { background:rgba(73,199,133,.13); color:#9ce0ba; }
  	    #${ROOT_ID} .fifvm-plan-row strong, #${ROOT_ID} .fifvm-plan-row small { display:block; }
  	    #${ROOT_ID} .fifvm-plan-row strong { color:#dce1de; font-size:10px; }
  	    #${ROOT_ID} .fifvm-plan-row small { margin-top:2px; color:#757d78; font-size:9px; }
  	    #${ROOT_ID} .fifvm-modal-backdrop { position:fixed; inset:50px 0 0; z-index:2147483646; display:flex; align-items:center; justify-content:center; padding:18px; background:rgba(0,0,0,.72); backdrop-filter:blur(4px); }
  	    #${ROOT_ID} .fifvm-modal { width:min(580px,96vw); border:1px solid rgba(204,102,51,.48); border-radius:16px; overflow:hidden; background:linear-gradient(145deg,#151916,#080b09); box-shadow:0 28px 70px rgba(0,0,0,.72),0 0 30px rgba(204,102,51,.1); }
  	    #${ROOT_ID} .fifvm-modal header { display:flex; justify-content:space-between; gap:12px; padding:14px 16px; border-bottom:1px solid var(--fif-line); background:rgba(204,102,51,.07); }
  	    #${ROOT_ID} .fifvm-modal header strong, #${ROOT_ID} .fifvm-modal header small { display:block; }
  	    #${ROOT_ID} .fifvm-modal header strong { color:#fff; font-size:14px; }
  	    #${ROOT_ID} .fifvm-modal header small { margin-top:3px; color:#8d958f; font-size:9px; }
  	    #${ROOT_ID} .fifvm-modal header button { border:0; background:transparent; color:#9ca39f; font-size:22px; cursor:pointer; }
  	    #${ROOT_ID} .fifvm-modal-body { display:grid; grid-template-columns:1fr 1fr; gap:10px; padding:16px; }
  	    #${ROOT_ID} .fifvm-modal-body label { color:#8d958f; font-size:9px; font-weight:900; text-transform:uppercase; }
  	    #${ROOT_ID} .fifvm-modal-body label.wide { grid-column:1/-1; }
  	    #${ROOT_ID} .fifvm-modal-body input, #${ROOT_ID} .fifvm-modal-body select, #${ROOT_ID} .fifvm-modal-body textarea { width:100%; box-sizing:border-box; margin-top:5px; padding:9px; border:1px solid var(--fif-line); border-radius:8px; background:#111512; color:#fff; }
  	    #${ROOT_ID} .fifvm-modal-body textarea { min-height:84px; resize:vertical; }
  	    #${ROOT_ID} .fifvm-modal footer { display:flex; justify-content:flex-end; gap:8px; padding:12px 16px; border-top:1px solid var(--fif-line); }
  	    #${ROOT_ID} .fifvm-modal footer button { border:1px solid var(--fif-line); border-radius:8px; padding:9px 12px; color:#fff; background:#1a1f1b; cursor:pointer; font-weight:900; }
  	    #${ROOT_ID} .fifvm-modal footer button.danger { border-color:rgba(230,76,64,.48); background:rgba(230,76,64,.18); }
  	    #${ROOT_ID} .fifvm-axle-config-list { padding:8px; }
  	    #${ROOT_ID} .fifvm-axle-config-row { display:grid; grid-template-columns:90px minmax(120px,1fr) minmax(110px,.7fr) minmax(110px,.7fr) 34px; gap:9px; align-items:end; padding:9px; border-bottom:1px solid var(--fif-line); }
  	    #${ROOT_ID} .fifvm-axle-config-row>strong { align-self:center; color:#e7eae8; font-size:11px; }
  	    #${ROOT_ID} .fifvm-axle-config-row label>span { display:block; margin-bottom:4px; color:#747c77; font-size:9px; }
  	    #${ROOT_ID} .fifvm-axle-config-row select, #${ROOT_ID} .fifvm-axle-config-row input { width:100%; height:34px; border:1px solid var(--fif-line); border-radius:8px; background:#0d100e; color:#e9ecea; padding:0 8px; }
  	    #${ROOT_ID} .fifvm-axle-config-row>button { width:34px; height:34px; border:1px solid rgba(239,83,80,.25); border-radius:8px; background:rgba(239,83,80,.08); color:#ef7774; cursor:pointer; font-size:18px; }
  	    #${ROOT_ID} .fifvm-axle-config-footer { display:flex; align-items:center; gap:10px; padding:10px 12px 13px; }
  	    #${ROOT_ID} .fifvm-axle-config-footer span { color:#707873; font-size:9px; }

  	    #${ROOT_ID} .fifvm-original-tyre-section {
  	      border-color:rgba(204,102,51,.34)!important;
  	      background:linear-gradient(145deg,#151a16,#090d0a)!important;
  	      box-shadow:0 16px 34px rgba(0,0,0,.22);
  	    }
  	    #${ROOT_ID} .fifvm-original-tyre-heading {
  	      min-height:50px!important;
  	      padding:8px 11px!important;
  	      background:linear-gradient(145deg,#1a1f1b,#101411)!important;
  	    }
  	    #${ROOT_ID} .fifvm-original-tyre-configure {
  	      appearance:none!important;
  	      min-height:34px!important;
  	      display:inline-flex!important;
  	      align-items:center!important;
  	      justify-content:center!important;
  	      padding:0 12px!important;
  	      border:1px solid rgba(224,118,62,.68)!important;
  	      border-radius:9px!important;
  	      background:linear-gradient(145deg,#bb6034,#78351b)!important;
  	      color:#fff!important;
  	      box-shadow:inset 0 1px 0 rgba(255,255,255,.10),0 7px 17px rgba(87,34,11,.28)!important;
  	      font:900 9px/1 Inter,system-ui!important;
  	      letter-spacing:.015em!important;
  	      cursor:pointer!important;
  	      opacity:1!important;
  	    }
  	    #${ROOT_ID} .fifvm-original-tyre-configure:hover {
  	      filter:brightness(1.09)!important;
  	      transform:translateY(-1px);
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host #tractorEditorPanel {
  	      min-height:620px!important;
  	      border:0!important;
  	      background:linear-gradient(145deg,#101511,#070a08)!important;
  	      color:#edf1ee!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host #tractorEditorPanel > div:nth-child(3) {
  	      min-height:600px!important;
  	      padding:10px 11px 18px!important;
  	      background:linear-gradient(145deg,#101511,#080b09)!important;
  	      scrollbar-width:thin;
  	      scrollbar-color:rgba(204,102,51,.48) transparent;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host [data-action] {
  	      appearance:none!important;
  	      min-height:34px!important;
  	      padding:0 11px!important;
  	      border:1px solid rgba(255,255,255,.10)!important;
  	      border-radius:8px!important;
  	      background:linear-gradient(145deg,#1c221d,#111612)!important;
  	      color:#dbe0dc!important;
  	      box-shadow:inset 0 1px 0 rgba(255,255,255,.035)!important;
  	      font-weight:850!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host [data-action="add-axle"] {
  	      border-color:rgba(204,102,51,.55)!important;
  	      background:linear-gradient(145deg,#b85c32,#743219)!important;
  	      color:#fff!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host [data-action="clear-config"],
  	    #${ROOT_ID} #fif-original-tyre-inline-host [data-action="remove-axle"] {
  	      border-color:rgba(239,83,80,.34)!important;
  	      background:rgba(116,33,31,.34)!important;
  	      color:#ff9894!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host [data-axle-index] {
  	      grid-template-columns:80px minmax(145px,1fr) minmax(130px,.8fr) minmax(130px,.8fr) 92px!important;
  	      gap:9px!important;
  	      align-items:end!important;
  	      margin-bottom:8px!important;
  	      padding:10px!important;
  	      border:1px solid rgba(255,255,255,.075)!important;
  	      border-left:3px solid rgba(204,102,51,.54)!important;
  	      border-radius:10px!important;
  	      background:linear-gradient(145deg,#171c18,#0c100d)!important;
  	      box-shadow:0 7px 16px rgba(0,0,0,.16)!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host [data-axle-index] label {
  	      color:#89918c!important;
  	      font-size:9px!important;
  	      font-weight:850!important;
  	      text-transform:uppercase!important;
  	      letter-spacing:.045em!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host [data-axle-field] {
  	      position:relative!important;
  	      z-index:2!important;
  	      display:block!important;
  	      width:100%!important;
  	      min-width:0!important;
  	      height:36px!important;
  	      min-height:36px!important;
  	      box-sizing:border-box!important;
  	      margin-top:5px!important;
  	      padding:0 9px!important;
  	      border:1px solid rgba(255,255,255,.10)!important;
  	      border-radius:8px!important;
  	      background:#090d0a!important;
  	      color:#eef1ef!important;
  	      -webkit-text-fill-color:#eef1ef!important;
  	      line-height:34px!important;
  	      outline:none!important;
  	      opacity:1!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host input[type=number][data-fif-number-native] {
  	      -moz-appearance:textfield!important;
  	      appearance:textfield!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host input[type=number][data-fif-number-native]::-webkit-inner-spin-button,
  	    #${ROOT_ID} #fif-original-tyre-inline-host input[type=number][data-fif-number-native]::-webkit-outer-spin-button {
  	      -webkit-appearance:none!important;
  	      margin:0!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host [data-axle-field]:focus {
  	      border-color:rgba(204,102,51,.68)!important;
  	      box-shadow:0 0 0 2px rgba(204,102,51,.11)!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host [data-axle-field]:disabled {
  	      opacity:.55!important;
  	      background:#0d110e!important;
  	      color:#aeb6b0!important;
  	      -webkit-text-fill-color:#aeb6b0!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host #tyreAxleRows > div:not([data-axle-index]),
  	    #${ROOT_ID} #fif-original-tyre-inline-host #tyrePositionGrid > div {
  	      border-color:rgba(255,255,255,.075)!important;
  	      border-radius:10px!important;
  	      background:linear-gradient(145deg,#151a16,#0b0f0c)!important;
  	      color:#dce1dd!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host #tyrePositionGrid {
  	      grid-template-columns:repeat(auto-fill,minmax(210px,1fr))!important;
  	      gap:8px!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host .trac-tyre-mode-btn {
  	      min-height:34px!important;
  	      padding:0 12px!important;
  	      border:1px solid rgba(255,255,255,.10)!important;
  	      border-radius:8px!important;
  	      box-shadow:inset 0 1px 0 rgba(255,255,255,.035)!important;
  	    }
  	    #${ROOT_ID} #fif-original-tyre-inline-host .trac-tyre-slot {
  	      border-radius:9px!important;
  	    }
  	    @media(max-width:980px) {
  	      #${ROOT_ID} #fif-original-tyre-inline-host [data-axle-index] {
  	        grid-template-columns:repeat(2,minmax(0,1fr))!important;
  	      }
  	      #${ROOT_ID} #fif-original-tyre-inline-host [data-axle-index] [data-action="remove-axle"] {
  	        grid-column:1/-1;
  	      }
  	    }
  	    @media (max-width:1320px) {
  	    #${ROOT_ID} .fifvm-hero { grid-template-columns:auto minmax(220px,1fr); }
  	    #${ROOT_ID} .fifvm-hero-stats { grid-column:1/-1; }
  	    #${ROOT_ID} .fifvm-form-grid { grid-template-columns:repeat(2,minmax(0,1fr)); }
  	    #${ROOT_ID} .fifvm-form-grid.compact { grid-template-columns:repeat(3,minmax(0,1fr)); }
  	    #${ROOT_ID} .fifvm-axle-config-row { grid-template-columns:70px repeat(3,minmax(100px,1fr)) 34px; }
  	    }
  	    @media (max-width:980px) {
  	    #${ROOT_ID} .fifvm-overview-grid, #${ROOT_ID} .fifvm-two-column, #${ROOT_ID} .fifvm-tyre-workspace, #${ROOT_ID} .fifvm-tyre-data-grid { grid-template-columns:1fr; }
  	    #${ROOT_ID} .fifvm-kpi-grid, #${ROOT_ID} .fifvm-tyre-summary, #${ROOT_ID} .fifvm-tyre-modal-summary { grid-template-columns:repeat(2,minmax(0,1fr)); }
  	    #${ROOT_ID} .fifvm-hero { grid-template-columns:auto minmax(0,1fr); }
  	    }
  	    @media (max-width:680px) {
  	    #${ROOT_ID} .fifvm-hero { padding:13px; grid-template-columns:auto minmax(0,1fr); }
  	    #${ROOT_ID} .fifvm-hero-icon { width:48px; height:48px; }
  	    #${ROOT_ID} .fifvm-hero-stats, #${ROOT_ID} .fifvm-form-grid, #${ROOT_ID} .fifvm-form-grid.compact { grid-template-columns:1fr; }
  	    #${ROOT_ID} .fifvm-tabs button { min-width:100px; }
  	    #${ROOT_ID} .fifvm-axle-row { grid-template-columns:1fr; padding-top:45px; }
  	    #${ROOT_ID} .fifvm-axle-side, #${ROOT_ID} .fifvm-axle-side.right { justify-content:center; }
  	    #${ROOT_ID} .fifvm-axle-beam { width:70%; justify-self:center; }
  	    #${ROOT_ID} .fifvm-axle-config-row { grid-template-columns:1fr 1fr; }
  	    #${ROOT_ID} .fifvm-axle-config-row>strong { grid-column:1/-1; }
  	    #${ROOT_ID} .fifvm-stage-grid, #${ROOT_ID} .fifvm-tyre-modal-summary { grid-template-columns:1fr; }
  	    }
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function injectStyles() {
  	    document.getElementById(STYLE_ID)?.remove();

  	    const style = document.createElement("style");
  	    style.id = STYLE_ID;
  	    style.textContent = `
  	    #${ROOT_ID},
  	    #${ROOT_ID} * {
  	    box-sizing: border-box;
  	    }

  	    #${ROOT_ID} {
  	    --fif-orange: #cc6633;
  	    --fif-orange-bright: #ff8a3c;
  	    --fif-bg: #070908;
  	    --fif-panel: #101312;
  	    --fif-panel-2: #151817;
  	    --fif-panel-3: #1b1e1d;
  	    --fif-line: rgba(255, 255, 255, 0.075);
  	    --fif-line-orange: rgba(204, 102, 51, 0.42);
  	    --fif-text: #f4f5f4;
  	    --fif-muted: #8e9691;
  	    --fif-good: #49c785;
  	    --fif-danger: #ff5c4d;
  	    --fif-warning: #ffb04a;

  	    position: fixed;
  	    inset: ${TOP_OFFSET_PX}px 0 0 0;
  	    z-index: 2147482000;
  	    overflow: hidden;
  	    color: var(--fif-text);
  	    background:
  	    radial-gradient(circle at 78% -10%, rgba(204, 102, 51, 0.16), transparent 32%),
  	    linear-gradient(145deg, #0d100f 0%, #060807 55%, #030404 100%);
  	    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  	    -webkit-font-smoothing: antialiased;
  	    isolation: isolate;
  	    }

  	    #${ROOT_ID} button,
  	    #${ROOT_ID} input,
  	    #${ROOT_ID} select {
  	    font: inherit;
  	    }

  	    #${ROOT_ID} button {
  	    color: inherit;
  	    }

  	    #${ROOT_ID} svg {
  	    width: 100%;
  	    height: 100%;
  	    fill: none;
  	    stroke: currentColor;
  	    stroke-width: 1.8;
  	    stroke-linecap: round;
  	    stroke-linejoin: round;
  	    }

  	    #${ROOT_ID} .fifdash-shell {
  	    width: 100%;
  	    height: 100%;
  	    display: grid;
  	    grid-template-columns: 260px minmax(0, 1fr);
  	    }

  	    #${ROOT_ID} .fifdash-sidebar {
  	    min-width: 0;
  	    display: flex;
  	    flex-direction: column;
  	    background:
  	    radial-gradient(circle at 12% 0%, rgba(255, 133, 49, 0.12), transparent 27%),
  	    linear-gradient(180deg, rgba(20, 23, 22, 0.99), rgba(8, 10, 9, 0.995));
  	    border-right: 1px solid rgba(204, 102, 51, 0.30);
  	    box-shadow: 12px 0 38px rgba(0, 0, 0, 0.33);
  	    position: relative;
  	    z-index: 2;
  	    }

  	    #${ROOT_ID} .fifdash-sidebar::after {
  	    content: "";
  	    position: absolute;
  	    inset: 0 0 auto 0;
  	    height: 1px;
  	    background: linear-gradient(90deg, transparent, rgba(255, 138, 60, 0.72), transparent);
  	    }

  	    #${ROOT_ID} .fifdash-brand-row {
  	    min-height: 88px;
  	    display: flex;
  	    align-items: center;
  	    gap: 12px;
  	    padding: 18px 18px 16px;
  	    border-bottom: 1px solid var(--fif-line);
  	    }

  	    #${ROOT_ID} .fifdash-brand-mark {
  	    width: 45px;
  	    height: 45px;
  	    flex: 0 0 45px;
  	    display: grid;
  	    place-items: center;
  	    border: 1px solid rgba(255, 138, 60, 0.48);
  	    border-radius: 13px;
  	    background: linear-gradient(145deg, rgba(204, 102, 51, 0.26), rgba(10, 12, 11, 0.88));
  	    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.30), inset 0 1px 0 rgba(255, 255, 255, 0.05);
  	    overflow: hidden;
  	    }

  	    #${ROOT_ID} .fifdash-brand-image,
  	    #${ROOT_ID} .fifdash-brand-svg,
  	    #${ROOT_ID} .fifdash-brand-svg svg {
  	    display: block;
  	    width: 100%;
  	    height: 100%;
  	    object-fit: contain;
  	    }

  	    #${ROOT_ID} .fifdash-brand-fallback {
  	    font-weight: 950;
  	    letter-spacing: -0.04em;
  	    color: var(--fif-orange-bright);
  	    }

  	    #${ROOT_ID} .fifdash-brand-copy {
  	    min-width: 0;
  	    display: flex;
  	    flex-direction: column;
  	    gap: 2px;
  	    }

  	    #${ROOT_ID} .fifdash-brand-copy strong {
  	    font-size: 14px;
  	    letter-spacing: 0.02em;
  	    }

  	    #${ROOT_ID} .fifdash-brand-copy span {
  	    color: var(--fif-muted);
  	    font-size: 11px;
  	    }

  	    #${ROOT_ID} .fifdash-company-block {
  	    padding: 16px 14px 12px;
  	    }

  	    #${ROOT_ID} .fifdash-company-block label,
  	    #${ROOT_ID} .fifdash-filter-shell > span,
  	    #${ROOT_ID} .fifdash-period-shell > span {
  	    display: block;
  	    margin: 0 0 7px;
  	    color: #b9bfbb;
  	    font-size: 10px;
  	    font-weight: 850;
  	    letter-spacing: 0.09em;
  	    text-transform: uppercase;
  	    }

  	    #${ROOT_ID} .fifdash-select-shell,
  	    #${ROOT_ID} .fifdash-filter-shell,
  	    #${ROOT_ID} .fifdash-period-shell {
  	    position: relative;
  	    }

  	    #${ROOT_ID} .fifdash-select-shell select,
  	    #${ROOT_ID} .fifdash-filter-shell select,
  	    #${ROOT_ID} .fifdash-period-shell select {
  	    width: 100%;
  	    min-height: 42px;
  	    appearance: none;
  	    color: var(--fif-text);
  	    background: linear-gradient(145deg, rgba(26, 29, 28, 0.94), rgba(8, 10, 9, 0.97));
  	    border: 1px solid rgba(204, 102, 51, 0.50);
  	    border-radius: 12px;
  	    outline: none;
  	    padding: 0 36px 0 12px;
  	    font-size: 12px;
  	    font-weight: 800;
  	    cursor: pointer;
  	    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.20), inset 0 1px 0 rgba(255, 255, 255, 0.035);
  	    }

  	    #${ROOT_ID} .fifdash-select-shell select:focus,
  	    #${ROOT_ID} .fifdash-filter-shell select:focus,
  	    #${ROOT_ID} .fifdash-period-shell select:focus {
  	    border-color: var(--fif-orange-bright);
  	    box-shadow: 0 0 0 3px rgba(255, 138, 60, 0.10);
  	    }

  	    #${ROOT_ID} .fifdash-select-arrow {
  	    position: absolute;
  	    right: 13px;
  	    top: 50%;
  	    transform: translateY(-58%);
  	    color: var(--fif-orange-bright);
  	    pointer-events: none;
  	    }

  	    #${ROOT_ID} .fifdash-nav {
  	    padding: 8px 10px;
  	    display: grid;
  	    gap: 5px;
  	    }

  	    #${ROOT_ID} .fifdash-nav-item {
  	    width: 100%;
  	    min-height: 48px;
  	    display: grid;
  	    grid-template-columns: 30px minmax(0, 1fr) auto;
  	    align-items: center;
  	    gap: 9px;
  	    padding: 0 10px;
  	    border: 1px solid transparent;
  	    border-radius: 12px;
  	    background: transparent;
  	    cursor: pointer;
  	    text-align: left;
  	    transition: 160ms ease;
  	    }

  	    #${ROOT_ID} .fifdash-nav-item:hover {
  	    background: rgba(255, 255, 255, 0.035);
  	    border-color: rgba(255, 255, 255, 0.055);
  	    }

  	    #${ROOT_ID} .fifdash-nav-item.active {
  	    background:
  	    radial-gradient(circle at 0% 50%, rgba(255, 138, 60, 0.19), transparent 42%),
  	    linear-gradient(90deg, rgba(204, 102, 51, 0.14), rgba(255, 255, 255, 0.025));
  	    border-color: rgba(204, 102, 51, 0.36);
  	    box-shadow: inset 3px 0 0 var(--fif-orange-bright), 0 9px 20px rgba(0, 0, 0, 0.16);
  	    }

  	    #${ROOT_ID} .fifdash-nav-icon {
  	    width: 22px;
  	    height: 22px;
  	    color: #a7ada9;
  	    }

  	    #${ROOT_ID} .fifdash-nav-item.active .fifdash-nav-icon {
  	    color: var(--fif-orange-bright);
  	    }

  	    #${ROOT_ID} .fifdash-nav-label {
  	    min-width: 0;
  	    overflow: hidden;
  	    text-overflow: ellipsis;
  	    white-space: nowrap;
  	    font-size: 12px;
  	    font-weight: 790;
  	    }

  	    #${ROOT_ID} .fifdash-nav-count {
  	    min-width: 24px;
  	    height: 22px;
  	    display: grid;
  	    place-items: center;
  	    padding: 0 7px;
  	    color: #b8bfbb;
  	    background: rgba(255, 255, 255, 0.055);
  	    border-radius: 999px;
  	    font-size: 10px;
  	    font-weight: 900;
  	    }

  	    #${ROOT_ID} .fifdash-nav-item.active .fifdash-nav-count {
  	    color: #fff;
  	    background: rgba(204, 102, 51, 0.30);
  	    }

  	    #${ROOT_ID} .fifdash-readonly-chip span {
  	    width: 8px;
  	    height: 8px;
  	    flex: 0 0 8px;
  	    border-radius: 50%;
  	    background: var(--fif-good);
  	    box-shadow: 0 0 0 4px rgba(73, 199, 133, 0.10), 0 0 12px rgba(73, 199, 133, 0.38);
  	    }

  	    #${ROOT_ID} .fifdash-workspace {
  	    min-width: 0;
  	    min-height: 0;
  	    display: flex;
  	    flex-direction: column;
  	    }

  	    #${ROOT_ID} .fifdash-command-header {
  	    min-height: 108px;
  	    flex: 0 0 auto;
  	    display: flex;
  	    align-items: center;
  	    justify-content: space-between;
  	    gap: 24px;
  	    padding: 18px 24px;
  	    border-bottom: 1px solid var(--fif-line-orange);
  	    background:
  	    linear-gradient(90deg, rgba(255, 255, 255, 0.022), transparent 45%),
  	    rgba(7, 9, 8, 0.86);
  	    backdrop-filter: blur(14px);
  	    }

  	    #${ROOT_ID} .fifdash-title-block {
  	    min-width: 0;
  	    }

  	    #${ROOT_ID} .fifdash-eyebrow {
  	    margin-bottom: 3px;
  	    color: var(--fif-orange-bright);
  	    font-size: 10px;
  	    font-weight: 900;
  	    letter-spacing: 0.12em;
  	    text-transform: uppercase;
  	    }

  	    #${ROOT_ID} .fifdash-title-block h1 {
  	    margin: 0;
  	    font-size: clamp(21px, 2vw, 30px);
  	    line-height: 1.08;
  	    letter-spacing: -0.035em;
  	    }

  	    #${ROOT_ID} .fifdash-title-block p {
  	    max-width: 620px;
  	    margin: 6px 0 0;
  	    color: var(--fif-muted);
  	    font-size: 11px;
  	    line-height: 1.5;
  	    }

  	    #${ROOT_ID} .fifdash-header-actions {
  	    flex: 0 0 auto;
  	    display: flex;
  	    align-items: center;
  	    gap: 10px;
  	    }

  	    #${ROOT_ID} .fifdash-vehicle-period-controls {
  	    display: flex;
  	    align-items: center;
  	    gap: 10px;
  	    }

  	    #${ROOT_ID} .fifdash-back-to-fleet {
  	    min-height: 39px;
  	    display: inline-flex;
  	    align-items: center;
  	    justify-content: center;
  	    gap: 8px;
  	    padding: 0 14px;
  	    border: 1px solid rgba(204, 102, 51, 0.50);
  	    border-radius: 11px;
  	    background: linear-gradient(145deg, rgba(31, 25, 20, 0.96), rgba(10, 13, 11, 0.98));
  	    color: #f5f6f5;
  	    font-size: 11px;
  	    font-weight: 900;
  	    white-space: nowrap;
  	    cursor: pointer;
  	    box-shadow: inset 0 1px 0 rgba(255,255,255,0.045), 0 8px 20px rgba(0,0,0,0.22);
  	    transition: 150ms ease;
  	    }

  	    #${ROOT_ID} .fifdash-back-to-fleet svg {
  	    width: 16px;
  	    height: 16px;
  	    transform: rotate(180deg);
  	    fill: none;
  	    stroke: currentColor;
  	    stroke-width: 1.8;
  	    }

  	    #${ROOT_ID} .fifdash-back-to-fleet:hover {
  	    color: #fff;
  	    border-color: rgba(255, 132, 68, 0.84);
  	    background: linear-gradient(145deg, rgba(92, 43, 20, 0.82), rgba(18, 17, 14, 0.98));
  	    transform: translateY(-1px);
  	    }

  	    #${ROOT_ID} .fifdash-view-toggle {
  	    display: flex;
  	    padding: 3px;
  	    border: 1px solid rgba(255, 255, 255, 0.08);
  	    border-radius: 12px;
  	    background: rgba(0, 0, 0, 0.28);
  	    }

  	    #${ROOT_ID} .fifdash-view-toggle button {
  	    min-width: 80px;
  	    height: 35px;
  	    border: 0;
  	    border-radius: 9px;
  	    background: transparent;
  	    color: #929a95;
  	    font-size: 11px;
  	    font-weight: 850;
  	    cursor: pointer;
  	    }

  	    #${ROOT_ID} .fifdash-view-toggle button.active {
  	    color: #fff;
  	    background: linear-gradient(145deg, rgba(204, 102, 51, 0.82), rgba(105, 45, 18, 0.84));
  	    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.27), inset 0 1px 0 rgba(255, 255, 255, 0.09);
  	    }

  	    #${ROOT_ID} .fifdash-period-shell {
  	    width: 172px;
  	    }

  	    #${ROOT_ID} .fifdash-period-shell > span {
  	    margin-bottom: 4px;
  	    }

  	    #${ROOT_ID} .fifdash-period-shell select {
  	    min-height: 35px;
  	    border-color: rgba(255, 255, 255, 0.10);
  	    border-radius: 9px;
  	    padding-left: 10px;
  	    font-size: 11px;
  	    }

  	    #${ROOT_ID} .fifdash-period-shell.is-muted {
  	    opacity: 0.42;
  	    }

  	    #${ROOT_ID} .fifdash-period-shell select:disabled {
  	    cursor: default;
  	    opacity: 0.72;
  	    }

  	    #${ROOT_ID} .fifdash-close {
  	    width: 39px;
  	    height: 39px;
  	    display: grid;
  	    place-items: center;
  	    border: 1px solid rgba(255, 255, 255, 0.09);
  	    border-radius: 11px;
  	    background: rgba(255, 255, 255, 0.035);
  	    color: #b6bcb8;
  	    cursor: pointer;
  	    transition: 150ms ease;
  	    }

  	    #${ROOT_ID} .fifdash-close svg {
  	    width: 18px;
  	    height: 18px;
  	    }

  	    #${ROOT_ID} .fifdash-close:hover {
  	    color: #fff;
  	    border-color: rgba(255, 92, 77, 0.46);
  	    background: rgba(255, 92, 77, 0.10);
  	    }

  	    #${ROOT_ID} .fifdash-main {
  	    min-height: 0;
  	    flex: 1 1 auto;
  	    overflow: auto;
  	    padding: 18px 22px 28px;
  	    scrollbar-width: thin;
  	    scrollbar-color: rgba(204, 102, 51, 0.45) transparent;
  	    }

  	    #${ROOT_ID} .fifdash-main::-webkit-scrollbar {
  	    width: 7px;
  	    height: 7px;
  	    }

  	    #${ROOT_ID} .fifdash-main::-webkit-scrollbar-thumb {
  	    background: rgba(204, 102, 51, 0.44);
  	    border-radius: 999px;
  	    }

  	    #${ROOT_ID} .fifdash-summary-grid {
  	    display: grid;
  	    grid-template-columns: repeat(auto-fit, minmax(145px, 1fr));
  	    gap: 11px;
  	    }

  	    #${ROOT_ID} .fifdash-summary-card {
  	    min-height: 105px;
  	    padding: 15px 16px;
  	    border: 1px solid var(--fif-line);
  	    border-radius: 15px;
  	    background:
  	    radial-gradient(circle at 100% 0%, rgba(255, 255, 255, 0.045), transparent 40%),
  	    linear-gradient(145deg, rgba(25, 28, 27, 0.92), rgba(10, 12, 11, 0.94));
  	    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.035);
  	    position: relative;
  	    overflow: hidden;
  	    }

  	    #${ROOT_ID} .fifdash-summary-card::before {
  	    content: "";
  	    position: absolute;
  	    left: 0;
  	    top: 14px;
  	    bottom: 14px;
  	    width: 2px;
  	    border-radius: 999px;
  	    background: #6f7672;
  	    }

  	    #${ROOT_ID} .fifdash-summary-card.tone-orange::before { background: var(--fif-orange-bright); }
  	    #${ROOT_ID} .fifdash-summary-card.tone-good::before { background: var(--fif-good); }
  	    #${ROOT_ID} .fifdash-summary-card.tone-warning::before { background: var(--fif-warning); }

  	    #${ROOT_ID} .fifdash-summary-label {
  	    color: #9ea5a1;
  	    font-size: 9px;
  	    font-weight: 850;
  	    letter-spacing: 0.10em;
  	    text-transform: uppercase;
  	    }

  	    #${ROOT_ID} .fifdash-summary-value {
  	    margin-top: 9px;
  	    font-size: clamp(18px, 1.7vw, 27px);
  	    font-weight: 920;
  	    line-height: 1;
  	    letter-spacing: -0.035em;
  	    }

  	    #${ROOT_ID} .fifdash-summary-note {
  	    margin-top: 8px;
  	    color: var(--fif-muted);
  	    font-size: 9px;
  	    }

  	    #${ROOT_ID} .fifdash-toolbar {
  	    min-height: 64px;
  	    display: flex;
  	    align-items: flex-end;
  	    gap: 10px;
  	    margin-top: 15px;
  	    padding: 10px;
  	    border: 1px solid var(--fif-line);
  	    border-radius: 14px;
  	    background: rgba(12, 15, 14, 0.76);
  	    }

  	    #${ROOT_ID} .fifdash-search-shell {
  	    width: min(430px, 42vw);
  	    height: 41px;
  	    display: flex;
  	    align-items: center;
  	    gap: 9px;
  	    padding: 0 12px;
  	    border: 1px solid rgba(255, 255, 255, 0.09);
  	    border-radius: 11px;
  	    background: rgba(0, 0, 0, 0.24);
  	    }

  	    #${ROOT_ID} .fifdash-search-shell:focus-within {
  	    border-color: rgba(255, 138, 60, 0.72);
  	    box-shadow: 0 0 0 3px rgba(255, 138, 60, 0.08);
  	    }

  	    #${ROOT_ID} .fifdash-search-shell span {
  	    width: 17px;
  	    height: 17px;
  	    color: #7e8781;
  	    }

  	    #${ROOT_ID} .fifdash-search-shell input {
  	    min-width: 0;
  	    flex: 1 1 auto;
  	    border: 0;
  	    outline: 0;
  	    color: #fff;
  	    background: transparent;
  	    font-size: 11px;
  	    font-weight: 700;
  	    }

  	    #${ROOT_ID} .fifdash-search-shell input::placeholder {
  	    color: #69716c;
  	    }

  	    #${ROOT_ID} .fifdash-filter-shell {
  	    width: 170px;
  	    }

  	    #${ROOT_ID} .fifdash-filter-shell > span {
  	    margin: 0 0 4px 2px;
  	    }

  	    #${ROOT_ID} .fifdash-filter-shell select {
  	    min-height: 41px;
  	    border-color: rgba(255, 255, 255, 0.09);
  	    }

  	    #${ROOT_ID} .fifdash-toolbar-spacer {
  	    flex: 1 1 auto;
  	    }

  	    #${ROOT_ID} .fifdash-readonly-chip {
  	    height: 34px;
  	    display: flex;
  	    align-items: center;
  	    gap: 8px;
  	    padding: 0 12px;
  	    color: #9ea5a1;
  	    border: 1px solid rgba(255, 255, 255, 0.07);
  	    border-radius: 999px;
  	    background: rgba(255, 255, 255, 0.025);
  	    font-size: 9px;
  	    font-weight: 850;
  	    letter-spacing: 0.06em;
  	    text-transform: uppercase;
  	    }

  	    #${ROOT_ID} .fifdash-readonly-chip span {
  	    width: 6px;
  	    height: 6px;
  	    flex-basis: 6px;
  	    }

  	    #${ROOT_ID} .fifdash-asset-list {
  	    display: grid;
  	    gap: 9px;
  	    margin-top: 12px;
  	    }

  	    #${ROOT_ID} .fifdash-asset-card {
  	    min-height: 91px;
  	    display: grid;
  	    grid-template-columns: 4px minmax(250px, 1.2fr) minmax(500px, 2fr);
  	    align-items: stretch;
  	    border: 1px solid var(--fif-line);
  	    border-radius: 14px;
  	    background:
  	    linear-gradient(90deg, color-mix(in srgb, var(--asset-color) 7%, transparent), transparent 24%),
  	    linear-gradient(145deg, rgba(24, 27, 26, 0.94), rgba(10, 12, 11, 0.96));
  	    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.19), inset 0 1px 0 rgba(255, 255, 255, 0.025);
  	    overflow: hidden;
  	    transition: 150ms ease;
  	    }

  	    #${ROOT_ID} .fifdash-asset-card:hover {
  	    transform: translateY(-1px);
  	    border-color: rgba(204, 102, 51, 0.36);
  	    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.27), inset 0 1px 0 rgba(255, 255, 255, 0.035);
  	    }

  	    #${ROOT_ID} .fifdash-asset-accent {
  	    background: var(--asset-color);
  	    box-shadow: 0 0 18px color-mix(in srgb, var(--asset-color) 48%, transparent);
  	    }

  	    #${ROOT_ID} .fifdash-asset-leading {
  	    min-width: 0;
  	    display: flex;
  	    align-items: center;
  	    gap: 13px;
  	    padding: 13px 16px;
  	    }

  	    #${ROOT_ID} button.fifdash-asset-leading {
  	    width: 100%;
  	    border: 0;
  	    outline: 0;
  	    background: transparent;
  	    color: inherit;
  	    font: inherit;
  	    text-align: left;
  	    cursor: pointer;
  	    }

  	    #${ROOT_ID} button.fifdash-asset-leading:focus-visible {
  	    box-shadow: inset 0 0 0 2px rgba(204, 102, 51, 0.62);
  	    }

  	    #${ROOT_ID} .fifdash-asset-card.is-manager-disabled:hover {
  	    transform: none;
  	    border-color: var(--fif-line);
  	    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.19), inset 0 1px 0 rgba(255, 255, 255, 0.025);
  	    }

  	    #${ROOT_ID} button.fifdash-asset-leading:disabled {
  	    cursor: not-allowed;
  	    opacity: .72;
  	    filter: saturate(.72);
  	    }

  	    #${ROOT_ID} .fifdash-asset-card.is-manager-disabled .fifdash-asset-accent {
  	    opacity: .48;
  	    box-shadow: none;
  	    }

  	    #${ROOT_ID} .fifdash-fuel-split {
  	    display: grid;
  	    grid-template-columns: minmax(0, 1fr) 34px;
  	    flex-direction: initial;
  	    gap: 0;
  	    padding: 0;
  	    }

  	    #${ROOT_ID} .fifdash-fuel-report-action,
  	    #${ROOT_ID} .fifdash-fuel-capture-action {
  	    border: 0;
  	    outline: 0;
  	    background: transparent;
  	    color: inherit;
  	    cursor: pointer;
  	    }

  	    #${ROOT_ID} .fifdash-fuel-report-action {
  	    min-width: 0;
  	    height: 100%;
  	    display: flex;
  	    flex-direction: column;
  	    justify-content: center;
  	    align-items: flex-start;
  	    gap: 3px;
  	    padding: 0 9px;
  	    text-align: left;
  	    }

  	    #${ROOT_ID} .fifdash-fuel-capture-action {
  	    width: 34px;
  	    height: 100%;
  	    display: grid;
  	    place-items: center;
  	    color: #7d8781;
  	    border-left: 1px solid var(--fif-line);
  	    }

  	    #${ROOT_ID} .fifdash-fuel-capture-action svg {
  	    width: 16px;
  	    height: 16px;
  	    fill: none;
  	    stroke: currentColor;
  	    stroke-width: 1.7;
  	    stroke-linecap: round;
  	    stroke-linejoin: round;
  	    }

  	    #${ROOT_ID} .fifdash-fuel-report-action:hover,
  	    #${ROOT_ID} .fifdash-fuel-report-action:focus-visible,
  	    #${ROOT_ID} .fifdash-fuel-capture-action:hover,
  	    #${ROOT_ID} .fifdash-fuel-capture-action:focus-visible {
  	    color: var(--fif-orange-bright);
  	    background: rgba(204, 102, 51, 0.07);
  	    }

  	    #${ROOT_ID} .fifdash-fuel-report-action:focus-visible,
  	    #${ROOT_ID} .fifdash-fuel-capture-action:focus-visible {
  	    box-shadow: inset 0 0 0 1px rgba(204, 102, 51, 0.55);
  	    }

  	    #${ROOT_ID} .fifdash-asset-icon {
  	    width: 42px;
  	    height: 42px;
  	    flex: 0 0 42px;
  	    display: grid;
  	    place-items: center;
  	    padding: 10px;
  	    color: var(--asset-color);
  	    border: 1px solid color-mix(in srgb, var(--asset-color) 42%, transparent);
  	    border-radius: 12px;
  	    background: color-mix(in srgb, var(--asset-color) 10%, rgba(0, 0, 0, 0.48));
  	    }

  	    #${ROOT_ID} .fifdash-asset-icon.is-global-vehicle {
  	    padding: 0;
  	    border-color: transparent;
  	    background: transparent;
  	    }

  	    #${ROOT_ID} .fifdash-asset-icon.is-global-vehicle .fif-global-vehicle-icon {
  	    width: 42px;
  	    height: 42px;
  	    display: block;
  	    object-fit: contain;
  	    }

  	    #${ROOT_ID} .fifdash-asset-copy {
  	    min-width: 0;
  	    }

  	    #${ROOT_ID} .fifdash-asset-topline {
  	    display: flex;
  	    align-items: center;
  	    gap: 8px;
  	    }

  	    #${ROOT_ID} .fifdash-asset-topline h3 {
  	    min-width: 0;
  	    margin: 0;
  	    overflow: hidden;
  	    text-overflow: ellipsis;
  	    white-space: nowrap;
  	    font-size: 13px;
  	    font-weight: 900;
  	    letter-spacing: -0.01em;
  	    }

  	    #${ROOT_ID} .fifdash-status {
  	    max-width: 120px;
  	    flex: 0 0 auto;
  	    overflow: hidden;
  	    text-overflow: ellipsis;
  	    white-space: nowrap;
  	    padding: 4px 7px;
  	    border-radius: 999px;
  	    font-size: 8px;
  	    font-weight: 900;
  	    letter-spacing: 0.05em;
  	    text-transform: uppercase;
  	    }

  	    #${ROOT_ID} .fifdash-status.good {
  	    color: #8ee8b6;
  	    background: rgba(73, 199, 133, 0.10);
  	    border: 1px solid rgba(73, 199, 133, 0.23);
  	    }

  	    #${ROOT_ID} .fifdash-status.danger {
  	    color: #ff9b91;
  	    background: rgba(255, 92, 77, 0.10);
  	    border: 1px solid rgba(255, 92, 77, 0.23);
  	    }

  	    #${ROOT_ID} .fifdash-status.muted {
  	    color: #b3bbb6;
  	    background: rgba(255, 255, 255, 0.045);
  	    border: 1px solid rgba(255, 255, 255, 0.07);
  	    }

  	    #${ROOT_ID} .fifdash-asset-copy p {
  	    margin: 5px 0 0;
  	    color: #9ba29e;
  	    overflow: hidden;
  	    text-overflow: ellipsis;
  	    white-space: nowrap;
  	    font-size: 10px;
  	    }

  	    #${ROOT_ID} .fifdash-asset-meta {
  	    display: flex;
  	    gap: 9px;
  	    margin-top: 5px;
  	    color: #68706b;
  	    font-size: 8px;
  	    font-weight: 750;
  	    text-transform: uppercase;
  	    letter-spacing: 0.05em;
  	    }

  	    #${ROOT_ID} .fifdash-asset-meta .missing {
  	    color: var(--fif-warning);
  	    }

  	    #${ROOT_ID} .fifdash-asset-metrics {
  	    min-width: 0;
  	    display: grid;
  	    grid-template-columns: repeat(5, minmax(90px, 1fr));
  	    align-items: center;
  	    border-left: 1px solid var(--fif-line);
  	    }

  	    #${ROOT_ID} .fifdash-metric {
  	    min-width: 0;
  	    min-height: 54px;
  	    display: flex;
  	    flex-direction: column;
  	    justify-content: center;
  	    gap: 5px;
  	    padding: 0 13px;
  	    border-right: 1px solid var(--fif-line);
  	    }

  	    #${ROOT_ID} .fifdash-metric span {
  	    color: #747c77;
  	    font-size: 8px;
  	    font-weight: 850;
  	    letter-spacing: 0.09em;
  	    text-transform: uppercase;
  	    }

  	    #${ROOT_ID} .fifdash-metric strong {
  	    min-width: 0;
  	    overflow: hidden;
  	    text-overflow: ellipsis;
  	    white-space: nowrap;
  	    font-size: 11px;
  	    font-weight: 880;
  	    }

  	    #${ROOT_ID} .fifdash-metric.has-alert strong {
  	    color: var(--fif-danger);
  	    }

  	    #${ROOT_ID} .fifdash-card-action {
  	    width: 100%;
  	    height: 100%;
  	    display: grid;
  	    place-items: center;
  	    border: 0;
  	    background: transparent;
  	    color: #717974;
  	    cursor: pointer;
  	    }

  	    #${ROOT_ID} .fifdash-card-action svg {
  	    width: 17px;
  	    height: 17px;
  	    }

  	    #${ROOT_ID} .fifdash-card-action:hover {
  	    color: var(--fif-orange-bright);
  	    background: rgba(204, 102, 51, 0.07);
  	    }

  	    #${ROOT_ID} .fifdash-app-grid {
  	    display: grid;
  	    grid-template-columns: repeat(4, minmax(210px, 1fr));
  	    gap: 12px;
  	    margin-top: 12px;
  	    }

  	    #${ROOT_ID} .fifdash-app-card {
  	    min-height: 235px;
  	    padding: 18px;
  	    border: 1px solid var(--fif-line);
  	    border-radius: 17px;
  	    background:
  	    radial-gradient(circle at 100% 0%, rgba(255, 138, 60, 0.11), transparent 38%),
  	    linear-gradient(145deg, rgba(25, 28, 27, 0.95), rgba(9, 11, 10, 0.98));
  	    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.035);
  	    position: relative;
  	    overflow: hidden;
  	    }

  	    #${ROOT_ID} .fifdash-app-number {
  	    position: absolute;
  	    right: 14px;
  	    top: 10px;
  	    color: rgba(255, 255, 255, 0.055);
  	    font-size: 48px;
  	    font-weight: 950;
  	    line-height: 1;
  	    }

  	    #${ROOT_ID} .fifdash-app-icon {
  	    width: 42px;
  	    height: 42px;
  	    padding: 10px;
  	    color: var(--fif-orange-bright);
  	    border: 1px solid rgba(255, 138, 60, 0.31);
  	    border-radius: 12px;
  	    background: rgba(204, 102, 51, 0.10);
  	    }

  	    #${ROOT_ID} .fifdash-app-card h3 {
  	    margin: 17px 0 0;
  	    font-size: 17px;
  	    letter-spacing: -0.025em;
  	    }

  	    #${ROOT_ID} .fifdash-app-card > p {
  	    margin: 7px 0 0;
  	    color: var(--fif-muted);
  	    font-size: 10px;
  	    }

  	    #${ROOT_ID} .fifdash-app-linked {
  	    min-height: 58px;
  	    display: flex;
  	    flex-wrap: wrap;
  	    align-content: flex-start;
  	    gap: 5px;
  	    margin-top: 14px;
  	    }

  	    #${ROOT_ID} .fifdash-app-linked span {
  	    max-width: 100%;
  	    overflow: hidden;
  	    text-overflow: ellipsis;
  	    white-space: nowrap;
  	    padding: 5px 8px;
  	    color: #c9cecb;
  	    border: 1px solid rgba(255, 255, 255, 0.07);
  	    border-radius: 999px;
  	    background: rgba(255, 255, 255, 0.035);
  	    font-size: 8px;
  	    font-weight: 760;
  	    }

  	    #${ROOT_ID} .fifdash-app-linked span.muted {
  	    color: #747c77;
  	    }

  	    #${ROOT_ID} .fifdash-app-card button {
  	    width: 100%;
  	    height: 36px;
  	    display: flex;
  	    align-items: center;
  	    justify-content: space-between;
  	    margin-top: 8px;
  	    padding: 0 11px;
  	    color: #d5d8d6;
  	    border: 1px solid rgba(204, 102, 51, 0.23);
  	    border-radius: 10px;
  	    background: rgba(204, 102, 51, 0.07);
  	    font-size: 9px;
  	    font-weight: 850;
  	    cursor: pointer;
  	    }

  	    #${ROOT_ID} .fifdash-app-card button svg {
  	    width: 14px;
  	    height: 14px;
  	    }

  	    #${ROOT_ID} .fifdash-app-manager {
  	    margin-top: 8px;
  	    overflow: hidden;
  	    border: 1px solid var(--fif-line-orange);
  	    border-radius: 13px;
  	    background:
  	    radial-gradient(circle at 8% 0%, rgba(255, 133, 49, 0.10), transparent 30%),
  	    linear-gradient(145deg, rgba(19, 22, 20, 0.97), rgba(7, 9, 8, 0.99));
  	    box-shadow: 0 16px 34px rgba(0,0,0,.24), inset 0 1px 0 rgba(255,255,255,.035);
  	    }

  	    #${ROOT_ID} .fifdash-app-manager-head {
  	    min-height: 72px;
  	    display: flex;
  	    align-items: center;
  	    justify-content: space-between;
  	    gap: 14px;
  	    padding: 10px 12px;
  	    border-bottom: 1px solid var(--fif-line);
  	    }

  	    #${ROOT_ID} .fifdash-app-manager-heading {
  	    min-width: 0;
  	    display: flex;
  	    align-items: center;
  	    gap: 11px;
  	    }

  	    #${ROOT_ID} .fifdash-app-manager-icon {
  	    width: 38px;
  	    height: 38px;
  	    flex: 0 0 38px;
  	    display: grid;
  	    place-items: center;
  	    padding: 9px;
  	    color: var(--fif-orange-bright);
  	    border: 1px solid rgba(255,138,60,.34);
  	    border-radius: 10px;
  	    background: rgba(204,102,51,.09);
  	    }

  	    #${ROOT_ID} .fifdash-app-manager-heading .eyebrow {
  	    display: block;
  	    color: var(--fif-orange-bright);
  	    font-size: 7px;
  	    font-weight: 950;
  	    letter-spacing: .16em;
  	    text-transform: uppercase;
  	    }

  	    #${ROOT_ID} .fifdash-app-manager-heading h2 {
  	    margin: 2px 0 0;
  	    color: #fff;
  	    font-size: 17px;
  	    line-height: 1.1;
  	    }

  	    #${ROOT_ID} .fifdash-app-manager-heading p {
  	    margin: 4px 0 0;
  	    color: var(--fif-muted);
  	    font-size: 9px;
  	    }

  	    #${ROOT_ID} .fifdash-app-manager-actions {
  	    display: flex;
  	    align-items: center;
  	    justify-content: flex-end;
  	    gap: 6px;
  	    flex-wrap: wrap;
  	    }

  	    #${ROOT_ID} .fifdash-app-status {
  	    height: 29px;
  	    display: inline-flex;
  	    align-items: center;
  	    gap: 6px;
  	    padding: 0 9px;
  	    color: #9da49f;
  	    border: 1px solid var(--fif-line);
  	    border-radius: 999px;
  	    background: rgba(255,255,255,.025);
  	    font-size: 8px;
  	    font-weight: 850;
  	    }

  	    #${ROOT_ID} .fifdash-app-status i {
  	    width: 6px;
  	    height: 6px;
  	    border-radius: 50%;
  	    background: #707873;
  	    }

  	    #${ROOT_ID} .fifdash-app-status.dirty { color: #ffc47f; border-color: rgba(255,176,74,.28); background: rgba(255,176,74,.07); }
  	    #${ROOT_ID} .fifdash-app-status.dirty i { background: var(--fif-warning); box-shadow: 0 0 8px rgba(255,176,74,.65); }
  	    #${ROOT_ID} .fifdash-app-status.saved { color: #9ce3b9; border-color: rgba(73,199,133,.26); background: rgba(73,199,133,.07); }
  	    #${ROOT_ID} .fifdash-app-status.saved i { background: var(--fif-good); box-shadow: 0 0 8px rgba(73,199,133,.65); }

  	    #${ROOT_ID} .fifdash-app-button,
  	    #${ROOT_ID} .fifdash-app-row-actions button {
  	    height: 30px;
  	    padding: 0 10px;
  	    border: 1px solid var(--fif-line);
  	    border-radius: 8px;
  	    background: #171b18;
  	    color: #dce0dd;
  	    cursor: pointer;
  	    font-size: 8px;
  	    font-weight: 900;
  	    }

  	    #${ROOT_ID} .fifdash-app-button.primary {
  	    border-color: rgba(255,138,60,.48);
  	    background: linear-gradient(145deg, rgba(204,102,51,.82), rgba(116,48,18,.88));
  	    color: #fff;
  	    }

  	    #${ROOT_ID} .fifdash-app-button:hover:not(:disabled),
  	    #${ROOT_ID} .fifdash-app-row-actions button:hover:not(:disabled) {
  	    border-color: rgba(255,138,60,.46);
  	    color: #fff;
  	    }

  	    #${ROOT_ID} .fifdash-app-button:disabled,
  	    #${ROOT_ID} .fifdash-app-row-actions button:disabled { opacity: .38; cursor: not-allowed; }

  	    #${ROOT_ID} .fifdash-app-manager-meta {
  	    min-height: 34px;
  	    display: flex;
  	    align-items: center;
  	    gap: 18px;
  	    padding: 0 12px;
  	    color: #777f7a;
  	    border-bottom: 1px solid var(--fif-line);
  	    font-size: 8px;
  	    }

  	    #${ROOT_ID} .fifdash-app-manager-meta strong { color: #e7eae8; }

  	    #${ROOT_ID} .fifdash-app-list {
  	    display: flex;
  	    flex-direction: column;
  	    gap: 5px;
  	    padding: 8px;
  	    }

  	    #${ROOT_ID} .fifdash-app-row {
  	    min-height: 50px;
  	    display: grid;
  	    grid-template-columns: 34px 32px minmax(0,1fr) auto;
  	    align-items: center;
  	    gap: 9px;
  	    padding: 6px 8px;
  	    border: 1px solid rgba(255,255,255,.065);
  	    border-radius: 10px;
  	    background: linear-gradient(145deg, rgba(23,27,24,.82), rgba(10,13,11,.92));
  	    }

  	    #${ROOT_ID} .fifdash-app-row-number {
  	    color: rgba(255,255,255,.22);
  	    font-size: 12px;
  	    font-weight: 950;
  	    text-align: center;
  	    }

  	    #${ROOT_ID} .fifdash-app-row-icon {
  	    width: 30px;
  	    height: 30px;
  	    display: grid;
  	    place-items: center;
  	    padding: 7px;
  	    color: var(--fif-orange-bright);
  	    border: 1px solid rgba(255,138,60,.23);
  	    border-radius: 8px;
  	    background: rgba(204,102,51,.06);
  	    }

  	    #${ROOT_ID} .fifdash-app-row-copy { min-width: 0; }
  	    #${ROOT_ID} .fifdash-app-row-copy strong,
  	    #${ROOT_ID} .fifdash-app-row-copy small { display: block; }
  	    #${ROOT_ID} .fifdash-app-row-copy strong { color: #f3f5f3; font-size: 11px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  	    #${ROOT_ID} .fifdash-app-row-copy small { margin-top: 2px; color: #737b76; font-size: 8px; }
  	    #${ROOT_ID} .fifdash-app-row-actions { display: flex; align-items: center; gap: 5px; }
  	    #${ROOT_ID} .fifdash-app-row-actions button.danger { color: #ff9992; border-color: rgba(239,83,80,.22); background: rgba(239,83,80,.06); }

  	    #${ROOT_ID} .fifdash-app-manager-empty {
  	    min-height: 190px;
  	    display: grid;
  	    place-items: center;
  	    align-content: center;
  	    gap: 7px;
  	    color: #767e79;
  	    text-align: center;
  	    }
  	    #${ROOT_ID} .fifdash-app-manager-empty > span { width: 34px; height: 34px; padding: 7px; color: var(--fif-orange-bright); }
  	    #${ROOT_ID} .fifdash-app-manager-empty strong { color: #d9ddda; font-size: 12px; }
  	    #${ROOT_ID} .fifdash-app-manager-empty p { margin: 0; font-size: 9px; }

  	    #${ROOT_ID} .fifdash-readonly-chip.has-warning { color:#ffc47f; border-color:rgba(255,176,74,.28); background:rgba(255,176,74,.07); }
  	    #${ROOT_ID} .fifdash-readonly-chip.has-warning span { background:var(--fif-warning); box-shadow:0 0 8px rgba(255,176,74,.65); }

  	    #${APPLICATION_TEXT_PROMPT_ID}, #${APPLICATION_TEXT_PROMPT_ID} * { box-sizing: border-box; }
  	    #${APPLICATION_TEXT_PROMPT_ID} {
  	    position: fixed;
  	    inset: 50px 0 0;
  	    z-index: 2147483647;
  	    display: grid;
  	    place-items: center;
  	    padding: 18px;
  	    background: rgba(0,0,0,.76);
  	    backdrop-filter: blur(7px);
  	    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  	    }
  	    #${APPLICATION_TEXT_PROMPT_ID} .fif-app-text-card {
  	    width: min(520px, 96vw);
  	    overflow: hidden;
  	    border: 1px solid rgba(255,138,60,.48);
  	    border-radius: 16px;
  	    background: radial-gradient(circle at 10% 0%, rgba(255,133,49,.14), transparent 34%), linear-gradient(145deg,#171b18,#080b09);
  	    box-shadow: 0 30px 80px rgba(0,0,0,.82), 0 0 28px rgba(204,102,51,.12);
  	    }
  	    #${APPLICATION_TEXT_PROMPT_ID} .fif-app-text-accent { height: 3px; background: linear-gradient(90deg,#ff8a3c,transparent 78%); }
  	    #${APPLICATION_TEXT_PROMPT_ID} header { display: grid; grid-template-columns: 44px minmax(0,1fr); gap: 11px; align-items: center; padding: 14px 15px 12px; border-bottom: 1px solid rgba(255,255,255,.07); }
  	    #${APPLICATION_TEXT_PROMPT_ID} .fif-app-text-icon { width: 44px; height: 44px; padding: 10px; color: #ff8a3c; border: 1px solid rgba(255,138,60,.34); border-radius: 12px; background: rgba(204,102,51,.08); }
  	    #${APPLICATION_TEXT_PROMPT_ID} header span { color: #ff8a3c; font-size: 7px; font-weight: 950; letter-spacing: .15em; text-transform: uppercase; }
  	    #${APPLICATION_TEXT_PROMPT_ID} header h2 { margin: 3px 0 0; color: #fff; font-size: 17px; }
  	    #${APPLICATION_TEXT_PROMPT_ID} header p { margin: 4px 0 0; color: #89918c; font-size: 9px; }
  	    #${APPLICATION_TEXT_PROMPT_ID} main { padding: 14px 15px; }
  	    #${APPLICATION_TEXT_PROMPT_ID} label span { display: block; margin-bottom: 5px; color: #8f9792; font-size: 8px; font-weight: 900; text-transform: uppercase; }
  	    #${APPLICATION_TEXT_PROMPT_ID} input { width: 100%; height: 38px; padding: 0 10px; border: 1px solid rgba(255,138,60,.36); border-radius: 9px; outline: none; background: #101411; color: #fff; font-size: 11px; font-weight: 800; }
  	    #${APPLICATION_TEXT_PROMPT_ID} input:focus { border-color: #ff8a3c; box-shadow: 0 0 0 2px rgba(255,138,60,.11); }
  	    #${APPLICATION_TEXT_PROMPT_ID} .fif-app-text-error { min-height: 18px; padding-top: 5px; color: #ff8c84; font-size: 8px; }
  	    #${APPLICATION_TEXT_PROMPT_ID} footer { display: flex; justify-content: flex-end; gap: 7px; padding: 10px 15px 13px; border-top: 1px solid rgba(255,255,255,.07); }
  	    #${APPLICATION_TEXT_PROMPT_ID} footer button { height: 32px; padding: 0 12px; border: 1px solid rgba(255,255,255,.10); border-radius: 8px; color: #e5e8e6; background: #191e1a; cursor: pointer; font-size: 9px; font-weight: 900; }
  	    #${APPLICATION_TEXT_PROMPT_ID} footer button.primary { border-color: rgba(255,138,60,.50); background: linear-gradient(145deg,rgba(204,102,51,.88),rgba(104,43,17,.92)); color: #fff; }

  	    @media (max-width: 760px) {
  	    #${ROOT_ID} .fifdash-app-manager-head { align-items: flex-start; flex-direction: column; }
  	    #${ROOT_ID} .fifdash-app-manager-actions { width: 100%; justify-content: flex-start; }
  	    #${ROOT_ID} .fifdash-app-row { grid-template-columns: 28px 28px minmax(0,1fr); }
  	    #${ROOT_ID} .fifdash-app-row-actions { grid-column: 1 / -1; justify-content: flex-end; }
  	    }

  	    #${ROOT_ID} .fifdash-empty {
  	    min-height: 280px;
  	    display: grid;
  	    place-items: center;
  	    align-content: center;
  	    gap: 8px;
  	    margin-top: 12px;
  	    border: 1px dashed rgba(255, 255, 255, 0.12);
  	    border-radius: 16px;
  	    background: rgba(255, 255, 255, 0.018);
  	    text-align: center;
  	    }

  	    #${ROOT_ID} .fifdash-empty-icon {
  	    width: 34px;
  	    height: 34px;
  	    padding: 7px;
  	    color: var(--fif-warning);
  	    border: 1px solid rgba(255, 176, 74, 0.23);
  	    border-radius: 11px;
  	    background: rgba(255, 176, 74, 0.08);
  	    }

  	    #${ROOT_ID} .fifdash-empty h3 {
  	    margin: 7px 0 0;
  	    font-size: 15px;
  	    }

  	    #${ROOT_ID} .fifdash-empty p {
  	    max-width: 470px;
  	    margin: 0;
  	    color: var(--fif-muted);
  	    font-size: 10px;
  	    }

  	    #${ROOT_ID} .fif-native-select {
  	    position:absolute !important;
  	    width:1px !important;
  	    height:1px !important;
  	    margin:0 !important;
  	    padding:0 !important;
  	    opacity:0 !important;
  	    pointer-events:none !important;
  	    overflow:hidden !important;
  	    }

  	    #${ROOT_ID} .fifdash-select-arrow { display:none !important; }

  	    .fif-styled-select {
  	    position:relative;
  	    width:100%;
  	    min-width:0;
  	    }

  	    .fif-styled-select-button {
  	    width:100%;
  	    height:31px;
  	    display:flex;
  	    align-items:center;
  	    justify-content:space-between;
  	    gap:9px;
  	    padding:0 11px 0 12px;
  	    border:1px solid rgba(255,122,36,.42);
  	    border-radius:14px;
  	    outline:none;
  	    color:#f3f5f3;
  	    background:
  	    radial-gradient(circle at 12% 0%,rgba(255,133,49,.14),transparent 40%),
  	    linear-gradient(145deg,rgba(21,23,21,.97),rgba(5,8,7,.99));
  	    box-shadow:0 5px 13px rgba(0,0,0,.24),inset 0 1px 0 rgba(255,255,255,.045),inset 0 -10px 20px rgba(0,0,0,.18);
  	    cursor:pointer;
  	    font:inherit;
  	    font-size:10.5px;
  	    font-weight:850;
  	    text-align:left;
  	    transition:border-color .14s,box-shadow .14s,background .14s;
  	    }

  	    .fif-styled-select-button:hover,
  	    .fif-styled-select.is-open .fif-styled-select-button,
  	    .fif-styled-select-button:focus-visible {
  	    border-color:rgba(255,138,61,.84);
  	    box-shadow:0 0 0 2px rgba(255,122,36,.10),0 6px 15px rgba(0,0,0,.30),0 0 16px rgba(255,105,25,.11);
  	    }

  	    .fif-styled-select-label {
  	    min-width:0;
  	    overflow:hidden;
  	    text-overflow:ellipsis;
  	    white-space:nowrap;
  	    }

  	    .fif-styled-select-chevron {
  	    width:7px;
  	    height:7px;
  	    flex:0 0 7px;
  	    margin:-3px 2px 0 0;
  	    border-right:2px solid #ff8a3c;
  	    border-bottom:2px solid #ff8a3c;
  	    transform:rotate(45deg);
  	    transition:transform .14s,margin .14s;
  	    }

  	    .fif-styled-select.is-open .fif-styled-select-chevron {
  	    margin:3px 2px 0 0;
  	    transform:rotate(225deg);
  	    }

  	    .fif-styled-select.is-disabled { opacity:.46; }
  	    .fif-styled-select-button:disabled { cursor:default; }

  	    .fif-styled-select-menu {
  	    position:fixed;
  	    z-index:2147483647;
  	    display:grid;
  	    gap:2px;
  	    padding:5px;
  	    overflow:auto;
  	    overscroll-behavior:contain;
  	    border:1px solid rgba(255,122,36,.56);
  	    border-radius:15px;
  	    background:
  	    radial-gradient(circle at 16% 0%,rgba(255,133,49,.16),transparent 34%),
  	    repeating-radial-gradient(ellipse at 34% 118%,transparent 0,transparent 9px,rgba(255,116,34,.16) 10px,transparent 12px),
  	    linear-gradient(145deg,rgba(16,17,16,.995),rgba(3,7,7,.998));
  	    box-shadow:0 22px 48px rgba(0,0,0,.68),0 0 22px rgba(255,105,25,.10),inset 0 1px 0 rgba(255,255,255,.055),inset 0 -18px 38px rgba(0,0,0,.24);
  	    animation:fifSelectMenuIn .12s ease-out;
  	    }

  	    .fif-styled-select-option {
  	    width:100%;
  	    min-height:30px;
  	    display:flex;
  	    align-items:center;
  	    justify-content:space-between;
  	    gap:8px;
  	    padding:5px 10px;
  	    border:1px solid transparent;
  	    border-radius:10px;
  	    color:#d6dad7;
  	    background:transparent;
  	    cursor:pointer;
  	    font:inherit;
  	    font-size:10.5px;
  	    font-weight:820;
  	    text-align:left;
  	    }

  	    .fif-styled-select-option:hover,
  	    .fif-styled-select-option:focus-visible {
  	    color:#fff;
  	    outline:none;
  	    border-color:rgba(255,138,61,.22);
  	    background:rgba(255,122,36,.12);
  	    }

  	    .fif-styled-select-option.is-selected {
  	    color:#fff;
  	    border-color:rgba(255,138,61,.30);
  	    background:linear-gradient(145deg,rgba(255,122,36,.24),rgba(95,42,17,.24));
  	    box-shadow:inset 0 0 15px rgba(255,105,25,.08);
  	    }

  	    .fif-styled-select-option i {
  	    color:#ff963f;
  	    font-size:11px;
  	    font-style:normal;
  	    }

  	    .fif-styled-select-option:disabled {
  	    opacity:.35;
  	    cursor:default;
  	    }

  	    @keyframes fifSelectMenuIn {
  	    from { opacity:0; transform:translateY(-4px) scale(.99); }
  	    to { opacity:1; transform:none; }
  	    }

  	    #${ROOT_ID} .fifdash-brand-row { min-height:68px; gap:9px; padding:10px 12px; }
  	    #${ROOT_ID} .fifdash-brand-mark { width:38px; height:38px; flex-basis:38px; border-radius:11px; }
  	    #${ROOT_ID} .fifdash-company-block { padding:10px 9px 7px; }
  	    #${ROOT_ID} .fifdash-company-block label,
  	    #${ROOT_ID} .fifdash-filter-shell > span,
  	    #${ROOT_ID} .fifdash-period-shell > span { margin-bottom:4px; font-size:8px; }
  	    #${ROOT_ID} .fifdash-nav { padding:5px 7px; gap:3px; }
  	    #${ROOT_ID} .fifdash-nav-item { min-height:39px; grid-template-columns:25px minmax(0,1fr) auto; gap:7px; padding:0 8px; border-radius:10px; }
  	    #${ROOT_ID} .fifdash-nav-icon { width:18px; height:18px; }
  	    #${ROOT_ID} .fifdash-nav-label { font-size:10.5px; }
  	    #${ROOT_ID} .fifdash-nav-count { min-width:21px; height:19px; padding:0 6px; font-size:8px; }
  	    #${ROOT_ID} .fifdash-command-header { min-height:80px; gap:15px; padding:11px 17px; }
  	    #${ROOT_ID} .fifdash-title-block h1 { font-size:clamp(19px,1.7vw,26px); }
  	    #${ROOT_ID} .fifdash-title-block p { margin-top:4px; font-size:9.5px; line-height:1.35; }
  	    #${ROOT_ID} .fifdash-header-actions { gap:7px; }
  	    #${ROOT_ID} .fifdash-vehicle-period-controls { gap:7px; }
  	    #${ROOT_ID} .fifdash-back-to-fleet { min-height:33px; padding:0 11px; border-radius:9px; font-size:9.5px; }
  	    #${ROOT_ID} .fifdash-view-toggle button { min-width:64px; height:30px; font-size:9.5px; }
  	    #${ROOT_ID} .fifdash-period-shell { width:145px; }
  	    #${ROOT_ID} .fifdash-close { width:33px; height:33px; border-radius:9px; }
  	    #${ROOT_ID} .fifdash-main { padding:11px 14px 18px; }
  	    #${ROOT_ID} .fifdash-main.fleet-list-mode { padding:0; }
  	    #${ROOT_ID} .fifdash-main:has(.fifdash-tyre-warehouse-host) { padding:8px 10px 10px; overflow:hidden; }
  	    #${ROOT_ID} .fifdash-tyre-warehouse-host { width:100%; height:100%; min-height:0; overflow:hidden; }
  	    #${ROOT_ID} .fifdash-tyre-warehouse-host > #companyTyreManagerRoot { width:100%; height:100%; min-height:0; }
  	    #${ROOT_ID} .fifdash-summary-grid { gap:7px; }
  	    #${ROOT_ID} .fifdash-summary-card { min-height:77px; padding:10px 12px; border-radius:12px; }
  	    #${ROOT_ID} .fifdash-summary-card::before { top:10px; bottom:10px; }
  	    #${ROOT_ID} .fifdash-summary-value { margin-top:5px; font-size:clamp(16px,1.35vw,22px); }
  	    #${ROOT_ID} .fifdash-summary-note { margin-top:5px; font-size:8px; }
  	    #${ROOT_ID} .fifdash-toolbar { min-height:48px; gap:7px; margin-top:9px; padding:6px; border-radius:11px; }
  	    #${ROOT_ID} .fifdash-search-shell { height:32px; gap:7px; padding:0 9px; border-radius:9px; }
  	    #${ROOT_ID} .fifdash-filter-shell { width:150px; }
  	    #${ROOT_ID} .fifdash-readonly-chip { height:29px; padding:0 9px; font-size:8px; }
  	    #${ROOT_ID} .fifdash-asset-list { gap:6px; margin-top:8px; }
  	    #${ROOT_ID} .fifdash-asset-card { min-height:66px; border-radius:11px; grid-template-columns:3px minmax(235px,1.2fr) minmax(470px,2fr); }
  	    #${ROOT_ID} .fifdash-asset-leading { gap:10px; padding:8px 11px; }
  	    #${ROOT_ID} .fifdash-asset-icon { width:34px; height:34px; flex-basis:34px; padding:8px; border-radius:10px; }
  	    #${ROOT_ID} .fifdash-asset-copy p { margin-top:3px; font-size:9px; }
  	    #${ROOT_ID} .fifdash-asset-meta { gap:7px; margin-top:3px; font-size:7px; }
  	    #${ROOT_ID} .fifdash-metric { min-height:42px; gap:3px; padding:0 9px; }
  	    #${ROOT_ID} .fifdash-metric span { font-size:7px; }
  	    #${ROOT_ID} .fifdash-metric strong { font-size:10px; }
  	    #${ROOT_ID} .fifdash-card-action svg { width:14px; height:14px; }
  	    #${ROOT_ID} .fifdash-app-grid { gap:8px; margin-top:8px; }
  	    #${ROOT_ID} .fifdash-app-card { min-height:190px; padding:13px; border-radius:13px; }

  	    #${ROOT_ID} .fifvm-hero { padding:10px 14px; gap:10px; }
  	    #${ROOT_ID} .fifvm-hero-icon { width:48px; height:48px; border-radius:13px; }
  	    #${ROOT_ID} .fifvm-hero-title-row h2 { font-size:20px; }
  	    #${ROOT_ID} .fifvm-hero-copy>p { margin:4px 0 7px; }
  	    #${ROOT_ID} .fifvm-info-tile { padding:8px 9px; border-radius:10px; }
  	    #${ROOT_ID} .fifvm-tabs { gap:3px; padding:6px 12px; }
  	    #${ROOT_ID} .fifvm-tabs button { min-width:96px; padding:7px 9px; border-radius:8px; }
  	    #${ROOT_ID} .fifvm-body { padding:10px 12px 17px; }
  	    #${ROOT_ID} .fifvm-overview-grid,
  	    #${ROOT_ID} .fifvm-two-column { gap:9px; }
  	    #${ROOT_ID} .fifvm-panel { margin-bottom:9px; border-radius:11px; }
  	    #${ROOT_ID} .fifvm-panel>header { min-height:43px; gap:8px; padding:8px 10px; }
  	    #${ROOT_ID} .fifvm-detail-line { min-height:32px; gap:8px; padding:6px 10px; }
  	    #${ROOT_ID} .fifvm-kpi-grid,
  	    #${ROOT_ID} .fifvm-tyre-summary { gap:7px; margin-bottom:9px; }
  	    #${ROOT_ID} .fifvm-form-field { padding:8px 9px; }
  	    #${ROOT_ID} .fifvm-form-field>span { min-height:15px; margin-bottom:4px; }
  	    #${ROOT_ID} .fifvm-form-field input,
  	    #${ROOT_ID} .fifvm-form-field textarea,
  	    #${ROOT_ID} .fifvm-capture input,
  	    #${ROOT_ID} .fifvm-capture textarea { padding:6px 8px; border-radius:8px; }
  	    #${ROOT_ID} .fifvm-capture { padding:10px; border-radius:11px; }
  	    #${ROOT_ID} .fifvm-capture-grid { gap:7px; margin-bottom:8px; }
  	    #${ROOT_ID} .fifvm-record-card { gap:9px; padding:8px 10px; }
  	    #${ROOT_ID} .fifvm-access-note { gap:8px; margin-bottom:8px; padding:7px 9px; }
  	    #${ROOT_ID} .fifvm-btn { min-height:30px; padding:0 10px; border-radius:8px; }

  	    #${ROOT_ID} .fifdash-main.fleet-list-mode { padding:0; overflow:hidden; display:flex; flex-direction:column; }
  	    #${ROOT_ID} .fifdash-vehicle-dashboard { height:100%; min-height:0; display:flex; flex-direction:column; padding:11px 14px 0; }
  	    #${ROOT_ID} .fifdash-vehicle-fixed-area { flex:0 0 auto; min-width:0; background:#090b0a; position:relative; z-index:4; }
  	    #${ROOT_ID} .fifdash-vehicle-list-scroll { flex:1 1 auto; min-height:0; overflow:auto; padding:0 0 18px; scrollbar-width:thin; scrollbar-color:rgba(204,102,51,.48) transparent; }
  	    #${ROOT_ID} .fifdash-vehicle-list-scroll::-webkit-scrollbar { width:7px; }
  	    #${ROOT_ID} .fifdash-vehicle-list-scroll::-webkit-scrollbar-thumb { background:rgba(204,102,51,.46); border-radius:99px; }
  	    #${ROOT_ID} .fifdash-vehicle-list-scroll .fifdash-asset-list { margin-top:6px; }
  	    #${ROOT_ID} .fifdash-asset-column-head { min-height:31px; display:grid; grid-template-columns:3px minmax(235px,1.2fr) minmax(470px,2fr); align-items:stretch; margin-top:7px; border:1px solid rgba(255,255,255,.075); border-radius:9px; background:linear-gradient(145deg,rgba(21,24,22,.98),rgba(8,10,9,.98)); overflow:hidden; }
  	    #${ROOT_ID} .fifdash-asset-column-head>.accent { background:linear-gradient(180deg,#f08342,#7d3215); }
  	    #${ROOT_ID} .fifdash-asset-column-head .vehicle-head { padding-left:11px; border-right:1px solid rgba(255,255,255,.06); }
  	    #${ROOT_ID} .fifdash-asset-column-head .metric-heads { display:grid; grid-template-columns:repeat(5,minmax(0,1fr)); }
  	    #${ROOT_ID} .fifdash-asset-column-head .metric-heads>button { border-right:1px solid rgba(255,255,255,.06); }
  	    #${ROOT_ID} .fifdash-asset-column-head button { width:100%; height:100%; min-height:29px; display:flex; align-items:center; justify-content:flex-start; gap:5px; border:0; background:transparent; color:#7f8882; padding:0 9px; font-size:7.5px; font-weight:950; letter-spacing:.08em; text-transform:uppercase; cursor:pointer; }
  	    #${ROOT_ID} .fifdash-asset-column-head button:hover,#${ROOT_ID} .fifdash-asset-column-head button.active { color:#fff; background:rgba(204,102,51,.08); }
  	    #${ROOT_ID} .fifdash-asset-column-head button i { width:0; height:0; opacity:.34; border-left:3px solid transparent; border-right:3px solid transparent; border-bottom:4px solid currentColor; }
  	    #${ROOT_ID} .fifdash-asset-column-head button i.asc { opacity:1; border-bottom:4px solid #f08342; }
  	    #${ROOT_ID} .fifdash-asset-column-head button i.desc { opacity:1; border-bottom:0; border-top:4px solid #f08342; }

  	    #${ROOT_ID} .fifvsvc-root { min-height:0; display:flex; flex-direction:column; gap:0; }
  	    #${ROOT_ID} .fifvsvc-head { display:flex; align-items:center; justify-content:space-between; gap:14px; padding:10px 12px; border:1px solid rgba(204,102,51,.23); border-radius:11px 11px 0 0; background:radial-gradient(circle at 0 0,rgba(204,102,51,.12),transparent 35%),linear-gradient(145deg,#151816,#0a0d0b); }
  	    #${ROOT_ID} .fifvsvc-head>div>span { color:#d6743d; font-size:7.5px; font-weight:950; letter-spacing:.11em; text-transform:uppercase; }
  	    #${ROOT_ID} .fifvsvc-head h3 { margin:2px 0 0; color:#fff; font-size:16px; }
  	    #${ROOT_ID} .fifvsvc-head p { margin:3px 0 0; color:#747d77; font-size:9px; }
  	    #${ROOT_ID} .fifvsvc-head-actions { display:flex; align-items:center; justify-content:flex-end; gap:7px; flex-wrap:wrap; }
  	    #${ROOT_ID} .fifvsvc-head-actions .fifsp-save-state { margin-right:2px; }
  	    #${ROOT_ID} .fifvsvc-position-view { width:min(1180px,100%); max-width:1180px; margin:0; }
  	    #${ROOT_ID} .fifvsvc-position-view .fifvm-panel { margin:0; }
  	    #${ROOT_ID} .fifvsvc-history-view { display:grid; gap:9px; }
  	    #${ROOT_ID} .fifvsvc-history-intro { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:10px 12px; border:1px solid rgba(255,255,255,.08); border-radius:10px; background:#171c18; }
  	    #${ROOT_ID} .fifvsvc-history-intro strong,#${ROOT_ID} .fifvsvc-history-intro span { display:block; }
  	    #${ROOT_ID} .fifvsvc-history-intro strong { color:#fff; font-size:12px; }
  	    #${ROOT_ID} .fifvsvc-history-intro span { margin-top:3px; color:#8e9891; font-size:9px; }
  	    #${ROOT_ID} .fifvsvc-history-actions{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
  	    #${ROOT_ID} .fifvsvc-history-table{overflow:hidden;border:1px solid rgba(255,255,255,.08);border-radius:12px;background:#151a16}
  	    #${ROOT_ID} .fifvsvc-history-head,#${ROOT_ID} .fifvsvc-history-table>article{display:grid;grid-template-columns:120px minmax(180px,1.2fr) minmax(150px,1fr) 120px 110px 150px 42px;align-items:center;gap:10px;padding:9px 11px}
  	    #${ROOT_ID} .fifvsvc-history-head{background:#202620;color:#b9c2bc;font-size:9px;font-weight:900;text-transform:uppercase;letter-spacing:.06em}
  	    #${ROOT_ID} .fifvsvc-history-table>article{border-top:1px solid rgba(255,255,255,.06);min-height:58px}
  	    #${ROOT_ID} .fifvsvc-history-table>article strong,#${ROOT_ID} .fifvsvc-history-table>article small{display:block;min-width:0;overflow:hidden;text-overflow:ellipsis}
  	    #${ROOT_ID} .fifvsvc-history-table>article strong{color:#fff;font-size:11px}
  	    #${ROOT_ID} .fifvsvc-history-table>article small{margin-top:3px;color:#8f9992;font-size:9px;white-space:nowrap}
  	    #${ROOT_ID} .fifvsvc-history-open{width:32px;height:32px;border:1px solid rgba(204,102,51,.35);border-radius:9px;background:rgba(204,102,51,.1);color:#f4c0a0;font-size:21px;cursor:pointer}
  	    @media(max-width:1150px){#${ROOT_ID} .fifvsvc-history-table{overflow:auto}#${ROOT_ID} .fifvsvc-history-head,#${ROOT_ID} .fifvsvc-history-table>article{min-width:980px}}
  	    #${ROOT_ID} .fifvsvc-provider-modal { min-height:160px; }
  	    #${ROOT_ID} .fifvsvc-provider-list { display:grid; gap:8px; }
  	    #${ROOT_ID} .fifvsvc-provider-list article { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:11px 12px; border:1px solid rgba(255,255,255,.08); border-radius:10px; background:#171c18; }
  	    #${ROOT_ID} .fifvsvc-provider-list strong,#${ROOT_ID} .fifvsvc-provider-list span,#${ROOT_ID} .fifvsvc-provider-list small { display:block; }
  	    #${ROOT_ID} .fifvsvc-provider-list strong { color:#fff; font-size:12px; }
  	    #${ROOT_ID} .fifvsvc-provider-list span { margin-top:3px; color:#a3aca6; font-size:9px; }
  	    #${ROOT_ID} .fifvsvc-provider-list small { margin-top:2px; color:#717a74; font-size:8px; }
  	    #${ROOT_ID} .fifvsvc-provider-list button { min-width:72px; min-height:32px; border:1px solid rgba(204,102,51,.34); border-radius:8px; background:#202620; color:#fff; font-weight:900; cursor:pointer; }
  	    #${ROOT_ID} .fifvsvc-provider-actions { display:flex; align-items:center; gap:6px; }
  	    #${ROOT_ID} .fifvsvc-provider-list button.danger { border-color:rgba(239,83,80,.4); background:rgba(239,83,80,.12); color:#ffaaa8; }
  	    #${ROOT_ID} .fifvsvc-tabs { display:flex; gap:3px; padding:5px 8px; border:1px solid rgba(255,255,255,.07); border-top:0; background:#0d100e; }
  	    #${ROOT_ID} .fifvsvc-tabs button { min-height:31px; display:flex; align-items:center; gap:7px; border:1px solid transparent; border-radius:7px; background:transparent; color:#89918c; padding:0 11px; font-size:9px; font-weight:900; cursor:pointer; }
  	    #${ROOT_ID} .fifvsvc-tabs button b { min-width:18px; height:17px; display:grid; place-items:center; border-radius:99px; background:rgba(255,255,255,.07); font-size:8px; }
  	    #${ROOT_ID} .fifvsvc-tabs button.active { color:#fff; border-color:rgba(204,102,51,.42); background:linear-gradient(145deg,rgba(204,102,51,.18),rgba(255,255,255,.025)); }
  	    #${ROOT_ID} .fifvsvc-body { min-height:0; padding-top:9px; }
  	    #${ROOT_ID} .fifvsvc-kpis { display:grid; grid-template-columns:repeat(4,minmax(150px,1fr)); gap:7px; margin-bottom:9px; }
  	    #${ROOT_ID} .fifvsvc-kpis article { min-height:70px; padding:9px 11px; border:1px solid rgba(255,255,255,.07); border-radius:10px; background:linear-gradient(145deg,#151816,#0b0e0c); box-shadow:inset 2px 0 0 #666e69; }
  	    #${ROOT_ID} .fifvsvc-kpis article.tone-critical { box-shadow:inset 2px 0 0 #ef5350; }
  	    #${ROOT_ID} .fifvsvc-kpis article.tone-warning { box-shadow:inset 2px 0 0 #f1a43c; }
  	    #${ROOT_ID} .fifvsvc-kpis article.tone-scheduled { box-shadow:inset 2px 0 0 #4f8ee8; }
  	    #${ROOT_ID} .fifvsvc-kpis article.tone-good { box-shadow:inset 2px 0 0 #49c785; }
  	    #${ROOT_ID} .fifvsvc-kpis span { display:block; color:#79817c; font-size:7px; font-weight:900; letter-spacing:.08em; text-transform:uppercase; }
  	    #${ROOT_ID} .fifvsvc-kpis strong { display:block; margin-top:6px; color:#fff; font-size:14px; }
  	    #${ROOT_ID} .fifvsvc-kpis small { display:block; margin-top:4px; color:#78807b; font-size:8px; }
  	    #${ROOT_ID} .fifvsvc-overview-grid { display:grid; grid-template-columns:minmax(0,1.25fr) minmax(340px,.75fr); gap:9px; }
  	    #${ROOT_ID} .fifvsvc-job-preview { display:flex; align-items:center; justify-content:space-between; gap:10px; padding:8px 10px; border-bottom:1px solid rgba(255,255,255,.055); }
  	    #${ROOT_ID} .fifvsvc-job-preview:last-child { border-bottom:0; }
  	    #${ROOT_ID} .fifvsvc-job-preview>div { min-width:0; display:grid; grid-template-columns:auto minmax(0,1fr); align-items:center; gap:4px 8px; }
  	    #${ROOT_ID} .fifvsvc-job-preview>div>span { grid-row:1/span 2; min-width:72px; padding:4px 6px; border-radius:99px; background:rgba(204,102,51,.12); color:#e38a58; font-size:7px; font-weight:900; text-align:center; }
  	    #${ROOT_ID} .fifvsvc-job-preview strong { color:#e9ecea; font-size:9px; }
  	    #${ROOT_ID} .fifvsvc-job-preview small { color:#727a75; font-size:8px; }
  	    #${ROOT_ID} .fifvsvc-job-preview button { border:1px solid rgba(255,255,255,.09); border-radius:7px; background:#171a18; color:#aeb5b1; padding:6px 9px; font-size:8px; font-weight:900; cursor:pointer; }
  	    #${ROOT_ID} .fifvsvc-inline-actions { display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:8px; padding:9px 11px; border:1px solid rgba(255,255,255,.07); border-radius:10px; background:#0f1210; }
  	    #${ROOT_ID} .fifvsvc-inline-actions>div:first-child { display:flex; flex-direction:column; gap:2px; }
  	    #${ROOT_ID} .fifvsvc-inline-actions strong { color:#fff; font-size:11px; }
  	    #${ROOT_ID} .fifvsvc-inline-actions span { color:#747d77; font-size:8px; }
  	    #${ROOT_ID} .fifvsvc-inline-actions>div:last-child,#${ROOT_ID} .fifvsvc-job-tools { display:flex; align-items:flex-end; gap:7px; }
  	    #${ROOT_ID} .fifvsvc-job-view .fifsp-kanban { min-height:360px; }
  	    #${ROOT_ID} .fifvsvc-job-tools label { min-width:155px; }

  	    @media (max-width: 1280px) {
  	    #${ROOT_ID} .fifdash-shell {
  	    grid-template-columns: 226px minmax(0, 1fr);
  	    }

  	    #${ROOT_ID} .fifdash-summary-grid {
  	    grid-template-columns: repeat(3, minmax(150px, 1fr));
  	    }

  	    #${ROOT_ID} .fifdash-asset-card {
  	    grid-template-columns: 4px minmax(230px, 1fr) minmax(430px, 1.7fr);
  	    }

  	    #${ROOT_ID} .fifdash-app-grid {
  	    grid-template-columns: repeat(3, minmax(210px, 1fr));
  	    }
  	    }

  	    @media (max-width: 1280px) {
  	    #${ROOT_ID} .fifdash-asset-column-head { grid-template-columns:3px minmax(230px,1fr) minmax(430px,1.7fr); }
  	    #${ROOT_ID} .fifvsvc-overview-grid { grid-template-columns:1fr; }
  	    #${ROOT_ID} .fifvsvc-kpis { grid-template-columns:repeat(2,minmax(150px,1fr)); }
  	    #${ROOT_ID} .fifvsvc-head { align-items:flex-start; }
  	    #${ROOT_ID} .fifvsvc-head-actions { width:100%; justify-content:flex-start; }
  	    #${ROOT_ID} .fifvsvc-history-intro { align-items:flex-start; flex-direction:column; }
  	    }

  	    @media (max-width: 980px) {
  	    #${ROOT_ID} .fifdash-shell {
  	    grid-template-columns: 78px minmax(0, 1fr);
  	    }

  	    #${ROOT_ID} .fifdash-brand-row {
  	    justify-content: center;
  	    padding-inline: 10px;
  	    }

  	    #${ROOT_ID} .fifdash-brand-copy,
  	    #${ROOT_ID} .fifdash-company-block,
  	    #${ROOT_ID} .fifdash-nav-label,
  	    #${ROOT_ID} .fifdash-nav-count {
  	    display: none;
  	    }

  	    #${ROOT_ID} .fifdash-nav-item {
  	    grid-template-columns: 1fr;
  	    justify-items: center;
  	    padding: 0;
  	    }

  	    #${ROOT_ID} .fifdash-command-header {
  	    align-items: flex-start;
  	    padding-inline: 18px;
  	    }

  	    #${ROOT_ID} .fifdash-title-block p {
  	    display: none;
  	    }

  	    #${ROOT_ID} .fifdash-period-shell {
  	    display: none;
  	    }

  	    #${ROOT_ID} .fifdash-summary-grid {
  	    grid-template-columns: repeat(2, minmax(150px, 1fr));
  	    }

  	    #${ROOT_ID} .fifdash-asset-card {
  	    grid-template-columns: 4px minmax(230px, 1fr);
  	    }

  	    #${ROOT_ID} .fifdash-asset-column-head {
  	    grid-template-columns: 4px minmax(230px, 1fr);
  	    }
  	    #${ROOT_ID} .fifdash-asset-column-head .metric-heads { display:none; }

  	    #${ROOT_ID} .fifdash-asset-metrics {
  	    grid-column: 2 / 3;
  	    grid-row: 2;
  	    border-left: 0;
  	    border-top: 1px solid var(--fif-line);
  	    }

  	    #${ROOT_ID} .fifdash-card-action {
  	    grid-column: 3;
  	    grid-row: 1 / span 2;
  	    }

  	    #${ROOT_ID} .fifdash-app-grid {
  	    grid-template-columns: repeat(2, minmax(210px, 1fr));
  	    }
  	    }
  	    `;

  	    style.textContent += `
  	      #${ROOT_ID} .fifdash-asset-metrics .fifdash-metric.fifdash-fuel-split{
  	        display:grid;
  	        grid-template-columns:minmax(0,1fr) 38px;
  	        grid-template-rows:minmax(54px,1fr);
  	        align-items:stretch;
  	        gap:0;
  	        padding:0;
  	      }

  	      #${ROOT_ID} .fifdash-asset-metrics .fifdash-fuel-report-action{
  	        grid-column:1;
  	        grid-row:1;
  	        min-width:0;
  	        width:100%;
  	        height:100%;
  	        padding:0 12px;
  	      }

  	      #${ROOT_ID} .fifdash-asset-metrics .fifdash-fuel-capture-action{
  	        grid-column:2;
  	        grid-row:1;
  	        width:38px;
  	        min-width:38px;
  	        height:100%;
  	        align-self:stretch;
  	        border-left:1px solid var(--fif-line);
  	      }

  	      #${ROOT_ID} .fifdash-asset-metrics .fifdash-fuel-capture-action svg{
  	        width:18px;
  	        height:18px;
  	      }

  	      @media(max-width:760px){
  	        #${ROOT_ID} .fifdash-asset-metrics .fifdash-metric.fifdash-fuel-split{
  	          grid-template-columns:minmax(0,1fr) 36px;
  	        }

  	        #${ROOT_ID} .fifdash-asset-metrics .fifdash-fuel-capture-action{
  	          width:36px;
  	          min-width:36px;
  	        }
  	      }
  	    `;

  	    style.textContent += `
  	      #${ROOT_ID} .fifdash-permission-boundary{
  	        min-height:100%;
  	        display:grid;
  	        place-items:center;
  	        padding:28px;
  	        background:
  	          radial-gradient(circle at 50% 0%,rgba(204,102,51,.08),transparent 36%),
  	          #111512;
  	      }
  	      #${ROOT_ID} .fifdash-permission-boundary>div{
  	        width:min(620px,100%);
  	        padding:24px;
  	        border:1px solid rgba(204,102,51,.28);
  	        border-radius:16px;
  	        background:linear-gradient(145deg,#1b201c,#0d110e);
  	        box-shadow:0 20px 54px rgba(0,0,0,.32);
  	        text-align:center;
  	      }
  	      #${ROOT_ID} .fifdash-permission-boundary span{
  	        display:block;
  	        color:#d47a46;
  	        font-size:8px;
  	        font-weight:950;
  	        letter-spacing:.13em;
  	        text-transform:uppercase;
  	      }
  	      #${ROOT_ID} .fifdash-permission-boundary h2{
  	        margin:7px 0 0;
  	        color:#fff;
  	        font-size:22px;
  	      }
  	      #${ROOT_ID} .fifdash-permission-boundary p{
  	        margin:8px auto 0;
  	        max-width:520px;
  	        color:#929b95;
  	        font-size:11px;
  	        line-height:1.55;
  	      }
  	`;

  	    document.head.appendChild(style);
  	  }

  	  function injectServicePortalStyles() {
  	    document.getElementById(SERVICE_STYLE_ID)?.remove();
  	    document.getElementById(MAINTENANCE_STYLE_ID)?.remove();
  	    const style = document.createElement("style");
  	    style.id = SERVICE_STYLE_ID;
  	    style.textContent = `
  	    #${ROOT_ID} .fifsp-root{height:100%;min-height:0;display:flex;flex-direction:column;background:#090b0a;color:#eef1ef;}
  	    #${ROOT_ID} .fifsp-topbar{position:relative;flex:0 0 auto;padding:14px 17px 0;border-bottom:1px solid rgba(204,102,51,.24);background:radial-gradient(circle at 12% 0%,rgba(204,102,51,.13),transparent 33%),linear-gradient(145deg,#141714,#090b0a);}
  	    #${ROOT_ID} .fifsp-title{display:flex;align-items:center;gap:12px;min-width:0;}
  	    #${ROOT_ID} .fifsp-title-icon{width:43px;height:43px;border:1px solid rgba(204,102,51,.4);border-radius:12px;display:grid;place-items:center;background:rgba(204,102,51,.09);color:#ff8a45;}
  	    #${ROOT_ID} .fifsp-title-icon svg{width:23px;height:23px;fill:none;stroke:currentColor;stroke-width:1.7;}
  	    #${ROOT_ID} .fifsp-title>div>span{display:block;color:#cf7040;font-size:8px;font-weight:950;letter-spacing:.12em;text-transform:uppercase;}
  	    #${ROOT_ID} .fifsp-title h2{margin:2px 0 0;font-size:22px;color:#fff;}
  	    #${ROOT_ID} .fifsp-title p{margin:3px 0 0;color:#777f7a;font-size:10px;}
  	    #${ROOT_ID} .fifsp-actions{position:absolute;right:18px;top:15px;display:flex;gap:7px;align-items:center;}
  	    #${ROOT_ID} .fifsp-actions button,#${ROOT_ID} .fifsp-provider-card footer button,#${ROOT_ID} .fifsp-health-row>button,#${ROOT_ID} .fifsp-modal footer button{border:1px solid rgba(255,255,255,.1);border-radius:8px;background:#171b18;color:#b5bcb7;padding:8px 10px;font-size:9px;font-weight:900;cursor:pointer;}
  	    #${ROOT_ID} .fifsp-actions button.primary,#${ROOT_ID} .fifsp-modal footer button.primary{border-color:rgba(204,102,51,.58);background:linear-gradient(145deg,#b5562a,#763117);color:#fff;}
  	    #${ROOT_ID} .fifsp-actions button:hover,#${ROOT_ID} .fifsp-provider-card footer button:hover,#${ROOT_ID} .fifsp-health-row>button:hover{color:#fff;border-color:rgba(204,102,51,.45);}
  	    #${ROOT_ID} .fifsp-save-state{display:inline-flex;align-items:center;gap:6px;color:#777f7a;font-size:9px;font-weight:850;padding:7px 9px;border:1px solid rgba(255,255,255,.07);border-radius:99px;}
  	    #${ROOT_ID} .fifsp-save-state i{width:6px;height:6px;border-radius:50%;background:#747b76;}
  	    #${ROOT_ID} .fifsp-save-state.saved{color:#8ed9ad}#${ROOT_ID} .fifsp-save-state.saved i{background:#49c785}#${ROOT_ID} .fifsp-save-state.failed{color:#ff8984}#${ROOT_ID} .fifsp-save-state.failed i{background:#ef5350}
  	    #${ROOT_ID} .fifsp-view-tabs{display:flex;gap:4px;margin-top:13px;}
  	    #${ROOT_ID} .fifsp-view-tabs button{position:relative;display:flex;align-items:center;gap:8px;border:0;border-bottom:2px solid transparent;background:transparent;color:#777f7a;padding:9px 13px;cursor:pointer;font-size:10px;font-weight:900;}
  	    #${ROOT_ID} .fifsp-view-tabs button.active{color:#fff;border-color:#cc6633;background:linear-gradient(180deg,transparent,rgba(204,102,51,.08));}
  	    #${ROOT_ID} .fifsp-view-tabs b{min-width:19px;height:18px;display:grid;place-items:center;border-radius:99px;background:rgba(255,255,255,.06);font-size:8px;}
  	    #${ROOT_ID} .fifsp-body{flex:1 1 auto;min-height:0;overflow:auto;padding:13px 15px 24px;}
  	    #${ROOT_ID} .fifsp-kpis{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px;margin-bottom:11px;}
  	    #${ROOT_ID} .fifsp-kpis article{padding:11px 12px;border:1px solid rgba(255,255,255,.075);border-radius:12px;background:linear-gradient(145deg,#151916,#0d100e);position:relative;overflow:hidden;}
  	    #${ROOT_ID} .fifsp-kpis article:before{content:"";position:absolute;left:0;top:0;bottom:0;width:3px;background:#68706a;}
  	    #${ROOT_ID} .fifsp-kpis .tone-orange:before{background:#cc6633}#${ROOT_ID} .fifsp-kpis .tone-bad:before{background:#ef5350}#${ROOT_ID} .fifsp-kpis .tone-warn:before{background:#f5a623}#${ROOT_ID} .fifsp-kpis .tone-good:before{background:#49c785}
  	    #${ROOT_ID} .fifsp-kpis span{display:block;color:#777f7a;font-size:8px;text-transform:uppercase;letter-spacing:.07em;font-weight:900;}
  	    #${ROOT_ID} .fifsp-kpis strong{display:block;margin-top:4px;color:#fff;font-size:20px;}
  	    #${ROOT_ID} .fifsp-kpis small{display:block;margin-top:3px;color:#666e69;font-size:8px;}
  	    #${ROOT_ID} .fifsp-control-grid{display:grid;grid-template-columns:minmax(680px,1.35fr) minmax(310px,.65fr);gap:11px;align-items:start;}
  	    #${ROOT_ID} .fifsp-panel{border:1px solid rgba(255,255,255,.075);border-radius:13px;background:linear-gradient(145deg,#131713,#0c0f0d);overflow:hidden;}
  	    #${ROOT_ID} .fifsp-panel>header{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 12px;border-bottom:1px solid rgba(255,255,255,.065);}
  	    #${ROOT_ID} .fifsp-panel h3{margin:0;color:#f6f7f6;font-size:12px}#${ROOT_ID} .fifsp-panel header p{margin:3px 0 0;color:#69716c;font-size:8px}#${ROOT_ID} .fifsp-panel header>span{color:#8b938e;font-size:9px;}
  	    #${ROOT_ID} .fifsp-health-head,#${ROOT_ID} .fifsp-health-row{display:grid;grid-template-columns:minmax(210px,1.35fr) minmax(120px,.85fr) 100px minmax(145px,1fr) minmax(115px,.8fr) 76px;gap:9px;align-items:center;}
  	    #${ROOT_ID} .fifsp-health-head{padding:7px 11px;color:#646c67;font-size:7px;font-weight:900;letter-spacing:.07em;text-transform:uppercase;background:#0b0e0c;}
  	    #${ROOT_ID} .fifsp-health-row{position:relative;padding:8px 11px;border-top:1px solid rgba(255,255,255,.045);font-size:9px;}
  	    #${ROOT_ID} .fifsp-health-row:before{content:"";position:absolute;left:0;top:0;bottom:0;width:3px;background:#49c785}#${ROOT_ID} .fifsp-health-row.severity-critical:before{background:#ef5350}#${ROOT_ID} .fifsp-health-row.severity-warning:before{background:#f5a623}#${ROOT_ID} .fifsp-health-row.severity-scheduled:before{background:#4d92ff}
  	    #${ROOT_ID} .fifsp-health-row .vehicle{display:flex;align-items:center;gap:8px;min-width:0}#${ROOT_ID} .fifsp-mini-vehicle{width:32px;height:32px;flex:0 0 32px}#${ROOT_ID} .fifsp-mini-vehicle img{width:100%;height:100%;object-fit:contain}#${ROOT_ID} .fifsp-health-row strong{display:block;color:#e8ebe9;font-size:9px}#${ROOT_ID} .fifsp-health-row small{display:block;margin-top:2px;color:#6d756f;font-size:7px}#${ROOT_ID} .fifsp-health-row .muted{color:#646c67}
  	    #${ROOT_ID} .fifsp-health-badge{display:inline-flex;padding:4px 6px;border:1px solid rgba(255,255,255,.08);border-radius:99px;color:#cdd2cf;font-size:7px;font-weight:900;}
  	    #${ROOT_ID} .fifsp-side-stack{display:grid;gap:11px}#${ROOT_ID} .fifsp-queue button,#${ROOT_ID} .fifsp-preferred-list button{width:100%;display:grid;grid-template-columns:auto minmax(0,1fr) auto;align-items:center;gap:8px;border:0;border-top:1px solid rgba(255,255,255,.045);background:transparent;color:#fff;padding:9px 11px;text-align:left;cursor:pointer}#${ROOT_ID} .fifsp-queue button:hover,#${ROOT_ID} .fifsp-preferred-list button:hover{background:rgba(204,102,51,.06)}
  	    #${ROOT_ID} .fifsp-queue .status{width:8px;height:8px;border-radius:50%;background:#7d857f}#${ROOT_ID} .fifsp-queue .status.new{background:#4d92ff}#${ROOT_ID} .fifsp-queue .status.booked{background:#8b6bd9}#${ROOT_ID} .fifsp-queue .status.in-progress{background:#cc6633}#${ROOT_ID} .fifsp-queue .status.waiting-parts{background:#f5a623}#${ROOT_ID} .fifsp-queue .status.ready{background:#49c785}#${ROOT_ID} .fifsp-queue strong,#${ROOT_ID} .fifsp-preferred-list strong{display:block;font-size:9px}#${ROOT_ID} .fifsp-queue small,#${ROOT_ID} .fifsp-preferred-list small{display:block;margin-top:2px;color:#6d756f;font-size:7px}#${ROOT_ID} .fifsp-queue time{color:#8b938e;font-size:7px}#${ROOT_ID} .fifsp-preferred-list>button>span{width:28px;height:28px;border-radius:9px;background:rgba(204,102,51,.13);display:grid;place-items:center;color:#ff9560;font-size:8px;font-weight:950}#${ROOT_ID} .fifsp-preferred-list b{color:#f5b46c;font-size:9px}
  	    #${ROOT_ID} .fifsp-filterbar{display:flex;align-items:end;gap:8px;margin-bottom:10px;padding:9px;border:1px solid rgba(255,255,255,.07);border-radius:12px;background:#101411}#${ROOT_ID} .fifsp-filterbar label{min-width:170px}#${ROOT_ID} .fifsp-filterbar label>span{display:block;margin-bottom:4px;color:#717974;font-size:7px;text-transform:uppercase;font-weight:900}#${ROOT_ID} .fifsp-filterbar .fifsp-provider-search{min-width:300px;flex:1;display:flex;align-items:center;gap:8px;padding:0 10px;border:1px solid rgba(255,255,255,.08);border-radius:9px;background:#0b0e0c}#${ROOT_ID} .fifsp-filterbar .fifsp-provider-search svg{width:15px;fill:none;stroke:#747c77;stroke-width:1.7}#${ROOT_ID} .fifsp-filterbar input,#${ROOT_ID} .fifsp-filterbar select{width:100%;height:36px;border:1px solid rgba(255,255,255,.08);border-radius:9px;background:#0b0e0c;color:#e7eae8;padding:0 9px;font-size:9px;outline:none}#${ROOT_ID} .fifsp-filterbar .fifsp-provider-search input{border:0;background:transparent;padding:0}#${ROOT_ID} .fifsp-filterbar .fifsp-provider-result{margin-left:auto;color:#747c77;font-size:9px;padding:9px}#${ROOT_ID} .fifsp-filterbar.jobbar{align-items:center;justify-content:space-between}#${ROOT_ID} .fifsp-filterbar.jobbar>div strong{display:block;color:#fff;font-size:12px}#${ROOT_ID} .fifsp-filterbar.jobbar>div span{display:block;margin-top:2px;color:#6d756f;font-size:8px}
  	    #${ROOT_ID} .fifsp-provider-grid{display:grid;grid-template-columns:repeat(3,minmax(260px,1fr));gap:10px}#${ROOT_ID} .fifsp-provider-card{position:relative;border:1px solid rgba(255,255,255,.075);border-radius:13px;background:linear-gradient(145deg,#151916,#0c0f0d);overflow:hidden}#${ROOT_ID} .fifsp-provider-card.preferred{border-color:rgba(204,102,51,.4);box-shadow:0 0 22px rgba(204,102,51,.05)}#${ROOT_ID} .fifsp-provider-card.inactive{opacity:.65}#${ROOT_ID} .fifsp-provider-accent{height:2px;background:#4d5550}#${ROOT_ID} .fifsp-provider-card.preferred .fifsp-provider-accent{background:linear-gradient(90deg,#cc6633,#ff995e)}
  	    #${ROOT_ID} .fifsp-provider-card>header{display:grid;grid-template-columns:auto minmax(0,1fr) auto;gap:9px;align-items:start;padding:11px}#${ROOT_ID} .fifsp-provider-card .fifsp-provider-avatar{width:37px;height:37px;border-radius:11px;display:grid;place-items:center;background:rgba(204,102,51,.1);border:1px solid rgba(204,102,51,.25);color:#ff8b4e;font-size:10px;font-weight:950}#${ROOT_ID} .fifsp-provider-card .fifsp-provider-eyebrow{color:#b9653c;font-size:6px;text-transform:uppercase;font-weight:950;letter-spacing:.09em}#${ROOT_ID} .fifsp-provider-card h3{margin:2px 0 0;color:#fff;font-size:12px}#${ROOT_ID} .fifsp-provider-card header p{margin:2px 0 0;color:#69716c;font-size:8px}#${ROOT_ID} .fifsp-provider-card .fifsp-provider-flags{display:flex;flex-direction:column;gap:4px;align-items:end}#${ROOT_ID} .fifsp-provider-card .fifsp-provider-flags b{padding:3px 5px;border-radius:99px;background:rgba(204,102,51,.13);color:#ff9a62;font-size:6px;text-transform:uppercase}#${ROOT_ID} .fifsp-provider-card .fifsp-provider-flags b.fifsp-provider-emergency{background:rgba(73,199,133,.12);color:#70dba2}
  	    #${ROOT_ID} .fifsp-provider-metrics{display:grid;grid-template-columns:repeat(3,1fr);border-top:1px solid rgba(255,255,255,.05);border-bottom:1px solid rgba(255,255,255,.05)}#${ROOT_ID} .fifsp-provider-metrics span{padding:8px 9px;border-right:1px solid rgba(255,255,255,.045)}#${ROOT_ID} .fifsp-provider-metrics span:last-child{border:0}#${ROOT_ID} .fifsp-provider-metrics small{display:block;color:#636b66;font-size:6px;text-transform:uppercase}#${ROOT_ID} .fifsp-provider-metrics strong{display:block;margin-top:3px;color:#e5e8e6;font-size:8px}#${ROOT_ID} .fifsp-capabilities{display:flex;flex-wrap:wrap;gap:4px;padding:9px 10px}#${ROOT_ID} .fifsp-capabilities span{padding:4px 6px;border:1px solid rgba(255,255,255,.07);border-radius:99px;color:#8e9691;font-size:6px}#${ROOT_ID} .fifsp-provider-contact{display:grid;grid-template-columns:1fr 1fr;gap:5px;padding:0 10px 9px}#${ROOT_ID} .fifsp-provider-contact a{min-width:0;color:#aeb5b0;font-size:7px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-decoration:none}#${ROOT_ID} .fifsp-provider-card footer{display:flex;gap:5px;padding:8px 10px;border-top:1px solid rgba(255,255,255,.05)}#${ROOT_ID} .fifsp-provider-card footer button{flex:1;padding:7px 6px}#${ROOT_ID} .fifsp-provider-card footer button.danger{flex:0 0 auto;color:#ff8883;border-color:rgba(239,83,80,.2)}
  	    #${ROOT_ID} .fifsp-kanban{display:grid;grid-template-columns:repeat(5,minmax(220px,1fr));gap:9px;overflow-x:auto;padding-bottom:8px}#${ROOT_ID} .fifsp-kanban-column{min-width:220px;border:1px solid rgba(255,255,255,.07);border-radius:12px;background:#0d100e;overflow:hidden}#${ROOT_ID} .fifsp-kanban-column>header{display:grid;grid-template-columns:auto 1fr auto;gap:7px;align-items:center;padding:9px 10px;border-bottom:1px solid rgba(255,255,255,.06)}#${ROOT_ID} .fifsp-kanban-column>header>div{min-width:0;display:grid;gap:2px}#${ROOT_ID} .fifsp-kanban-column>header>div small{display:block;color:#626b65;font-size:6.5px;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#${ROOT_ID} .fifsp-kanban-column>header span{width:8px;height:8px;border-radius:50%;background:#7c837e}#${ROOT_ID} .fifsp-kanban-column.status-new>header span{background:#4d92ff}#${ROOT_ID} .fifsp-kanban-column.status-scheduled>header span{background:#4d92ff}#${ROOT_ID} .fifsp-kanban-column.status-booked>header span{background:#8b6bd9}#${ROOT_ID} .fifsp-kanban-column.status-in-progress>header span{background:#cc6633}#${ROOT_ID} .fifsp-kanban-column.status-waiting-parts>header span{background:#f5a623}#${ROOT_ID} .fifsp-kanban-column.status-ready>header span{background:#49c785}#${ROOT_ID} .fifsp-kanban-column.status-completed>header span{background:#5f6963}#${ROOT_ID} .fifsp-kanban-column>header strong{font-size:9px}#${ROOT_ID} .fifsp-kanban-column>header b{min-width:18px;height:18px;display:grid;place-items:center;border-radius:99px;background:rgba(255,255,255,.06);font-size:7px}#${ROOT_ID} .fifsp-kanban-column>div{padding:7px;max-height:calc(100vh - 330px);overflow:auto}#${ROOT_ID} .fifsp-job-card{margin-bottom:7px;padding:9px;border:1px solid rgba(255,255,255,.07);border-radius:10px;background:linear-gradient(145deg,#151916,#101310)}#${ROOT_ID} .fifsp-job-card.priority-critical{border-color:rgba(239,83,80,.34)}#${ROOT_ID} .fifsp-job-card.priority-high{border-color:rgba(245,166,35,.25)}#${ROOT_ID} .fifsp-job-card .top{display:flex;justify-content:space-between;color:#68706a;font-size:6px}#${ROOT_ID} .fifsp-job-card .top b{color:#c27a50;text-transform:uppercase}#${ROOT_ID} .fifsp-job-card h4{margin:6px 0 0;color:#fff;font-size:10px}#${ROOT_ID} .fifsp-job-card p{margin:2px 0 7px;color:#cc7043;font-size:8px;font-weight:850}#${ROOT_ID} .fifsp-job-card dl{margin:0}#${ROOT_ID} .fifsp-job-card dl div{display:flex;justify-content:space-between;gap:8px;padding:3px 0;border-top:1px solid rgba(255,255,255,.035);font-size:7px}#${ROOT_ID} .fifsp-job-card dt{color:#606863}#${ROOT_ID} .fifsp-job-card dd{margin:0;color:#aeb5b0;text-align:right}#${ROOT_ID} .fifsp-job-card>small{display:block;margin-top:7px;color:#717974;font-size:7px;line-height:1.4}#${ROOT_ID} .fifsp-job-card footer{margin-top:8px;display:grid;grid-template-columns:repeat(auto-fit,minmax(72px,1fr));gap:5px}#${ROOT_ID} .fifsp-job-card footer button{width:100%;border:1px solid rgba(204,102,51,.22);border-radius:7px;background:rgba(204,102,51,.07);color:#d48b67;padding:6px;font-size:7px;font-weight:900;cursor:pointer}#${ROOT_ID} .fifsp-job-card footer button.primary{background:linear-gradient(145deg,#a44b25,#6f2d16);border-color:rgba(204,102,51,.58);color:#fff}
  	    #${ROOT_ID} .fifsp-empty{padding:20px;text-align:center;color:#6c746f;font-size:9px}#${ROOT_ID} .fifsp-empty.compact{padding:13px}#${ROOT_ID} .fifsp-empty.fifsp-provider-empty{grid-column:1/-1;border:1px dashed rgba(255,255,255,.08);border-radius:12px}#${ROOT_ID} .fifsp-empty.fifsp-provider-empty span svg{width:28px;fill:none;stroke:#6e7671}#${ROOT_ID} .fifsp-empty.fifsp-provider-empty strong{display:block;margin-top:8px;color:#c5cac7;font-size:11px}#${ROOT_ID} .fifsp-empty.fifsp-provider-empty p{margin:4px 0 0}
  	    #${SERVICE_MODAL_ID}{position:fixed;inset:${TOP_OFFSET_PX}px 0 0;z-index:2147483600;display:flex;align-items:center;justify-content:center;padding:14px;background:rgba(0,0,0,.86);backdrop-filter:blur(8px)}
  	    #${SERVICE_MODAL_ID} .fifsp-modal{width:min(840px,calc(100vw - 34px));max-height:calc(100vh - ${TOP_OFFSET_PX + 18}px);display:flex;flex-direction:column;border:1px solid rgba(204,102,51,.44);border-radius:16px;background:linear-gradient(145deg,#171a18,#090b0a);box-shadow:0 28px 90px rgba(0,0,0,.76);overflow:hidden;font-size:12px}#${SERVICE_MODAL_ID} .fifsp-modal.wide{width:min(1280px,calc(100vw - 34px))}#${SERVICE_MODAL_ID} .fifsp-modal>header{flex:0 0 auto;display:flex;justify-content:space-between;align-items:flex-start;gap:18px;padding:17px 21px 15px;border-bottom:1px solid rgba(255,255,255,.08)}#${SERVICE_MODAL_ID} .fifsp-modal>header span{color:#d17a4d;font-size:10px;text-transform:uppercase;font-weight:950;letter-spacing:.1em}#${SERVICE_MODAL_ID} .fifsp-modal>header h2{margin:4px 0 0;color:#fff;font-size:23px;line-height:1.12}#${SERVICE_MODAL_ID} .fifsp-modal>header p{margin:5px 0 0;color:#8d9690;font-size:11.5px;line-height:1.4}#${SERVICE_MODAL_ID} .fifsp-modal>header button{width:38px;height:38px;flex:0 0 38px;border:1px solid rgba(255,255,255,.1);border-radius:10px;background:#1a1e1b;color:#bec5c0;font-size:21px;cursor:pointer}#${SERVICE_MODAL_ID} .fifsp-modal>main{flex:1 1 auto;min-height:0;overflow:auto;padding:16px 17px 18px;scrollbar-width:thin;scrollbar-color:rgba(204,102,51,.5) rgba(255,255,255,.035)}#${SERVICE_MODAL_ID} .fifsp-modal>footer{flex:0 0 auto;display:flex;justify-content:flex-end;gap:9px;padding:13px 17px;border-top:1px solid rgba(255,255,255,.08);background:#0d100e}#${SERVICE_MODAL_ID} .fifsp-modal>footer button{min-height:39px;padding:10px 15px;font-size:11px}
  	    #${SERVICE_MODAL_ID} .fifsp-phase-current,#${SERVICE_MODAL_ID} .fifsp-phase-summary{display:grid;gap:3px;margin:10px 0 12px;padding:11px 12px;border:1px solid rgba(204,102,51,.22);border-radius:10px;background:linear-gradient(145deg,rgba(204,102,51,.075),rgba(255,255,255,.018))}#${SERVICE_MODAL_ID} .fifsp-phase-current span,#${SERVICE_MODAL_ID} .fifsp-phase-summary span{color:#8b958e;font-size:9.5px;line-height:1.4}#${SERVICE_MODAL_ID} .fifsp-phase-current strong,#${SERVICE_MODAL_ID} .fifsp-phase-summary strong{color:#fff;font-size:13px}#${SERVICE_MODAL_ID} [data-phase-field].is-hidden{display:none!important}#${SERVICE_MODAL_ID} .fifsp-workflow-history{display:grid;gap:7px;margin-top:12px}#${SERVICE_MODAL_ID} .fifsp-workflow-history.empty{padding:10px;border:1px dashed rgba(255,255,255,.09);border-radius:9px;color:#858e88}#${SERVICE_MODAL_ID} .fifsp-workflow-title{color:#c7754b;font-size:9px;font-weight:950;letter-spacing:.08em;text-transform:uppercase}#${SERVICE_MODAL_ID} .fifsp-workflow-history article{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:4px 10px;padding:9px 10px;border:1px solid rgba(255,255,255,.065);border-radius:9px;background:#0a0d0b}#${SERVICE_MODAL_ID} .fifsp-workflow-history article div{display:flex;gap:7px;align-items:center}#${SERVICE_MODAL_ID} .fifsp-workflow-history article strong{color:#eef2ef;font-size:10px}#${SERVICE_MODAL_ID} .fifsp-workflow-history article span,#${SERVICE_MODAL_ID} .fifsp-workflow-history article time{color:#747e77;font-size:8.5px}#${SERVICE_MODAL_ID} .fifsp-workflow-history article p{grid-column:1/-1;margin:2px 0 0;color:#b7beb9;font-size:10px;line-height:1.4}#${SERVICE_MODAL_ID} .fifsp-protection-note{margin-top:12px;padding:10px 12px;border:1px solid rgba(204,102,51,.24);border-radius:9px;background:rgba(204,102,51,.07);color:#d7b39f;font-size:10.5px;line-height:1.45}#${SERVICE_MODAL_ID} .fifsp-note-history{display:grid;gap:8px;margin-bottom:12px}#${SERVICE_MODAL_ID} .fifsp-note-history.empty{padding:11px;border:1px dashed rgba(255,255,255,.09);border-radius:9px;color:#7d8680;font-size:10.5px}#${SERVICE_MODAL_ID} .fifsp-note-history-title{color:#c7754b;font-size:9px;font-weight:950;letter-spacing:.08em;text-transform:uppercase}#${SERVICE_MODAL_ID} .fifsp-note-history article{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:4px 10px;padding:10px;border:1px solid rgba(255,255,255,.07);border-radius:9px;background:#0b0e0c}#${SERVICE_MODAL_ID} .fifsp-note-history article div{display:flex;gap:7px;align-items:center}#${SERVICE_MODAL_ID} .fifsp-note-history article strong{color:#eef1ef;font-size:10.5px}#${SERVICE_MODAL_ID} .fifsp-note-history article span,#${SERVICE_MODAL_ID} .fifsp-note-history article time{color:#78817b;font-size:9px}#${SERVICE_MODAL_ID} .fifsp-note-history article p{grid-column:1/-1;margin:3px 0 0;color:#bcc3be;font-size:10.5px;line-height:1.45;white-space:pre-wrap}#${SERVICE_MODAL_ID} .fifsp-note-history pre{margin:0;padding:11px;border:1px solid rgba(255,255,255,.07);border-radius:9px;background:#0b0e0c;color:#bcc3be;font:10.5px/1.5 Inter,system-ui,sans-serif;white-space:pre-wrap}#${SERVICE_MODAL_ID} .fifsp-schedule-history{display:grid;gap:6px;margin-top:12px;padding:10px;border:1px solid rgba(255,255,255,.07);border-radius:9px;background:#0b0e0c}#${SERVICE_MODAL_ID} .fifsp-schedule-history>strong{color:#c7754b;font-size:9px;text-transform:uppercase;letter-spacing:.07em}#${SERVICE_MODAL_ID} .fifsp-schedule-history>div{display:flex;justify-content:space-between;gap:10px;padding-top:6px;border-top:1px solid rgba(255,255,255,.05)}#${SERVICE_MODAL_ID} .fifsp-schedule-history span{color:#e3e7e4;font-size:10px}#${SERVICE_MODAL_ID} .fifsp-schedule-history small{color:#7d8680;font-size:9px;text-align:right}#${SERVICE_MODAL_ID} .fifsp-form{display:grid;gap:14px}#${SERVICE_MODAL_ID} .fifsp-form section{border:1px solid rgba(255,255,255,.085);border-radius:13px;background:rgba(255,255,255,.022);padding:15px}#${SERVICE_MODAL_ID} .fifsp-form section h3{margin:0 0 12px;color:#f2f4f2;font-size:14px;line-height:1.2}#${SERVICE_MODAL_ID} .fifsp-form .grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px 14px}#${SERVICE_MODAL_ID} .fifsp-field{display:block;min-width:0}#${SERVICE_MODAL_ID} .fifsp-field.wide{grid-column:1/-1}#${SERVICE_MODAL_ID} .fifsp-field>span{display:block;margin-bottom:6px;color:#9aa39d;font-size:10.5px;font-weight:850;line-height:1.25}#${SERVICE_MODAL_ID} .fifsp-field input,#${SERVICE_MODAL_ID} .fifsp-field select,#${SERVICE_MODAL_ID} .fifsp-field textarea{width:100%;min-width:0;min-height:42px;border:1px solid rgba(255,255,255,.11);border-radius:9px;background:#0b0e0c;color:#eef1ef;padding:10px 11px;font-size:12px;line-height:1.35;outline:none}#${SERVICE_MODAL_ID} .fifsp-field input::placeholder,#${SERVICE_MODAL_ID} .fifsp-field textarea::placeholder{color:#626a65;opacity:1}#${SERVICE_MODAL_ID} .fifsp-field textarea{min-height:105px;resize:vertical}#${SERVICE_MODAL_ID} .fifsp-field input:focus,#${SERVICE_MODAL_ID} .fifsp-field textarea:focus{border-color:#cc6633;box-shadow:0 0 0 2px rgba(204,102,51,.12)}#${SERVICE_MODAL_ID} .fifsp-field .fif-styled-select-button{height:42px;border-radius:9px;padding:0 11px;font-size:12px}#${SERVICE_MODAL_ID} .checks{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:9px;margin-top:12px}#${SERVICE_MODAL_ID} .fifsp-check{display:flex;align-items:center;gap:10px;min-height:54px;padding:10px 11px;border:1px solid rgba(255,255,255,.08);border-radius:10px;background:#0c0f0d}#${SERVICE_MODAL_ID} .fifsp-check input,#${SERVICE_MODAL_ID} .fifsp-capability-checks input{width:16px;height:16px;flex:0 0 16px;accent-color:#cc6633}#${SERVICE_MODAL_ID} .fifsp-check b{display:block;color:#dce0dd;font-size:11px;line-height:1.25}#${SERVICE_MODAL_ID} .fifsp-check small{display:block;margin-top:3px;color:#78817b;font-size:9.5px;line-height:1.3}#${SERVICE_MODAL_ID} .fifsp-capability-checks{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin-bottom:12px}#${SERVICE_MODAL_ID} .fifsp-capability-checks label{display:flex;align-items:center;gap:9px;min-height:42px;padding:9px 10px;border:1px solid rgba(255,255,255,.075);border-radius:9px;color:#b2b9b4;font-size:10.5px;line-height:1.2;background:#0c0f0d}
  	    @media(max-width:1100px){#${ROOT_ID} .fifsp-provider-grid{grid-template-columns:repeat(2,minmax(260px,1fr))}#${ROOT_ID} .fifsp-control-grid{grid-template-columns:1fr}#${ROOT_ID} .fifsp-kpis{grid-template-columns:repeat(3,1fr)}#${SERVICE_MODAL_ID} .fifsp-form .grid,#${SERVICE_MODAL_ID} .fifsp-capability-checks,#${SERVICE_MODAL_ID} .checks{grid-template-columns:repeat(2,minmax(0,1fr))}}
  	    @media(max-width:760px){#${ROOT_ID} .fifsp-actions{position:static;margin-top:10px;flex-wrap:wrap}#${ROOT_ID} .fifsp-kpis{grid-template-columns:repeat(2,1fr)}#${ROOT_ID} .fifsp-provider-grid{grid-template-columns:1fr}#${ROOT_ID} .fifsp-health-head{display:none}#${ROOT_ID} .fifsp-health-row{grid-template-columns:1fr 1fr}#${ROOT_ID} .fifsp-health-row .vehicle{grid-column:1/-1}#${ROOT_ID} .fifsp-filterbar{align-items:stretch;flex-direction:column}#${ROOT_ID} .fifsp-filterbar label,#${ROOT_ID} .fifsp-filterbar .fifsp-provider-search{min-width:0;width:100%}#${SERVICE_MODAL_ID} .fifsp-modal>header{padding:14px 15px 12px}#${SERVICE_MODAL_ID} .fifsp-modal>header h2{font-size:20px}#${SERVICE_MODAL_ID} .fifsp-modal>main{padding:12px}#${SERVICE_MODAL_ID} .fifsp-form .grid,#${SERVICE_MODAL_ID} .fifsp-capability-checks,#${SERVICE_MODAL_ID} .checks{grid-template-columns:1fr}}

  	    #${ROOT_ID} .fifsp-provider-view{display:flex;flex-direction:column;min-width:0;min-height:0;}
  	    #${ROOT_ID} .fifsp-provider-view>.fifsp-filterbar{display:grid!important;grid-template-columns:minmax(260px,1fr) minmax(150px,180px) minmax(180px,220px) auto;align-items:end!important;gap:8px!important;height:auto!important;min-height:54px!important;margin:0 0 10px!important;padding:8px!important;overflow:visible!important;}
  	    #${ROOT_ID} .fifsp-provider-view .fifsp-provider-search{display:flex!important;align-items:center!important;gap:8px!important;min-width:0!important;width:100%!important;height:36px!important;min-height:36px!important;max-height:36px!important;margin:0!important;padding:0 10px!important;border:1px solid rgba(255,255,255,.08)!important;border-radius:9px!important;background:#0b0e0c!important;overflow:hidden!important;}
  	    #${ROOT_ID} .fifsp-provider-view .fifsp-provider-search svg{display:block!important;width:15px!important;height:15px!important;min-width:15px!important;max-width:15px!important;min-height:15px!important;max-height:15px!important;flex:0 0 15px!important;fill:none!important;stroke:#747c77!important;stroke-width:1.7!important;}
  	    #${ROOT_ID} .fifsp-provider-view .fifsp-provider-search input{display:block!important;flex:1 1 auto!important;min-width:0!important;width:100%!important;height:34px!important;margin:0!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;color:#e7eae8!important;font-size:9px!important;outline:none!important;box-shadow:none!important;}
  	    #${ROOT_ID} .fifsp-provider-view .fifsp-filterbar>label:not(.fifsp-provider-search){display:block!important;min-width:0!important;width:100%!important;margin:0!important;}
  	    #${ROOT_ID} .fifsp-provider-view .fifsp-filterbar>label>span{display:block!important;margin:0 0 4px!important;}
  	    #${ROOT_ID} .fifsp-provider-view .fifsp-filterbar .fif-styled-select{width:100%!important;min-width:0!important;}
  	    #${ROOT_ID} .fifsp-provider-view .fifsp-provider-result{align-self:center!important;justify-self:end!important;white-space:nowrap!important;margin:0!important;padding:0 5px!important;color:#747c77!important;font-size:9px!important;}
  	    #${ROOT_ID} .fifsp-provider-grid{min-width:0;align-content:start;}
  	    #${ROOT_ID} .fifsp-provider-card .fifsp-provider-avatar{width:37px;height:37px;border-radius:11px;display:grid;place-items:center;background:rgba(204,102,51,.1);border:1px solid rgba(204,102,51,.25);color:#ff8b4e;font-size:10px;font-weight:950;}
  	    #${ROOT_ID} .fifsp-provider-card .fifsp-provider-eyebrow{color:#b9653c;font-size:6px;text-transform:uppercase;font-weight:950;letter-spacing:.09em;}
  	    #${ROOT_ID} .fifsp-provider-card .fifsp-provider-flags{display:flex;flex-direction:column;gap:4px;align-items:flex-end;}
  	    #${ROOT_ID} .fifsp-provider-card .fifsp-provider-flags b{padding:3px 5px;border-radius:99px;background:rgba(204,102,51,.13);color:#ff9a62;font-size:6px;text-transform:uppercase;}
  	    #${ROOT_ID} .fifsp-provider-card .fifsp-provider-flags b.fifsp-provider-emergency{background:rgba(73,199,133,.12);color:#70dba2;}
  	    #${ROOT_ID} .fifsp-empty.fifsp-provider-empty{grid-column:1/-1;border:1px dashed rgba(255,255,255,.08);border-radius:12px;}
  	    #${ROOT_ID} .fifsp-empty.fifsp-provider-empty span svg{width:28px!important;height:28px!important;fill:none;stroke:#6e7671;}

  	    @media(max-width:900px){
  	    #${ROOT_ID} .fifsp-provider-view>.fifsp-filterbar{grid-template-columns:minmax(220px,1fr) minmax(145px,170px) minmax(165px,190px);}
  	    #${ROOT_ID} .fifsp-provider-view .fifsp-provider-result{grid-column:1/-1;justify-self:end;}
  	    }
  	    @media(max-width:680px){
  	    #${ROOT_ID} .fifsp-provider-view>.fifsp-filterbar{grid-template-columns:1fr;align-items:stretch!important;}
  	    #${ROOT_ID} .fifsp-provider-view .fifsp-provider-result{grid-column:auto;justify-self:start;}
  	    }
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function destroyExisting() {
  	    closeExactOriginalTyreManager();
  	    const existing = document.getElementById(ROOT_ID);

  	    if (existing && typeof existing.__destroyDashboard === "function") {
  	      try {
  	        existing.__destroyDashboard();
  	        return;
  	      } catch (_) {}
  	    }

  	    existing?.remove();
  	    document.getElementById(STYLE_ID)?.remove();
  	    document.getElementById(VEHICLE_STYLE_ID)?.remove();
  	    document.getElementById(SERVICE_STYLE_ID)?.remove();
  	    document.getElementById("fif-on-road-fuel-capture-v21-style")?.remove();
  	    document.getElementById(FIF_DATE_PICKER_STYLE_ID)?.remove();
  	    document.getElementById("fif-styled-date-picker-v2162-style")?.remove();
  	    closeServicePortalModal();
  	    closeFifPrompt(false);
  	  }

  	  function announceMainSurface() {
  	    try {
  	      window.dispatchEvent(new CustomEvent("fif:main-surface-opening", {
  	        detail: {
  	          id: ROOT_ID, version: VERSION
  	        }
  	      }));
  	    } catch (_) {}
  	  }

  	  const MAINTENANCE_TABLE = "Maintenance";
  	  const MAINTENANCE_RELATION = "Maintenance";
  	  const MAINTENANCE_CATEGORY_SERVICE = "Service";
  	  const MAINTENANCE_CATEGORY_MAINTENANCE = "Maintenance";
  	  const MAINTENANCE_STYLE_ID = "fif-dashboard-relational-maintenance-v1-style";
  	  const MAINTENANCE_SCHEMA_COLUMNS = [
  	    "WorkOrderId",
  	    "CompanyObjectId",
  	    "CompanyId",
  	    "VehicleObjectId",
  	    "VehicleId",
  	    "Registration",
  	    "Category",
  	    "Type",
  	    "Title",
  	    "Status",
  	    "Priority",
  	    "Source",
  	    "MYearKey",
  	    "ReportedDate",
  	    "ScheduledDate",
  	    "StartedDate",
  	    "CompletedDate",
  	    "Odometer",
  	    "ProviderId",
  	    "ProviderName",
  	    "Technician",
  	    "Complaint",
  	    "Diagnosis",
  	    "WorkPerformed",
  	    "Parts",
  	    "Checklist",
  	    "EstimatedCost",
  	    "LabourCost",
  	    "PartsCost",
  	    "ExternalCost",
  	    "OtherCost",
  	    "ActualCost",
  	    "PurchaseOrder",
  	    "InvoiceNumber",
  	    "DowntimeStart",
  	    "DowntimeEnd",
  	    "DowntimeHours",
  	    "IsScheduled",
  	    "IsWarranty",
  	    "WarrantyReference",
  	    "RepeatRepair",
  	    "ParentWorkOrderId",
  	    "NextServiceKm",
  	    "NextServiceDate",
  	    "Documents",
  	    "Notes",
  	    "Audit",
  	    "Data"
  	  ];

  	  state.maintenanceCache = state.maintenanceCache || {};
  	  state.maintenanceLoaded = state.maintenanceLoaded || {};
  	  state.maintenanceLoading = state.maintenanceLoading || {};
  	  state.maintenanceLoadError = state.maintenanceLoadError || {};
  	  state.maintenanceSearch = state.maintenanceSearch || "";
  	  state.maintenanceStatusFilter = state.maintenanceStatusFilter || "open";
  	  state.maintenanceTypeFilter = state.maintenanceTypeFilter || "all";
  	  state.maintenanceSortKey = state.maintenanceSortKey || "reported";
  	  state.maintenanceSortDir = state.maintenanceSortDir || "desc";

  	  function injectMaintenanceRelationStyles() {
  	    if (document.getElementById(MAINTENANCE_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = MAINTENANCE_STYLE_ID;
  	    style.textContent = `
  	    #${ROOT_ID} .fifmnt-root{display:flex;flex-direction:column;min-height:0;gap:10px;color:#eef2ef}
  	    #${ROOT_ID} .fifmnt-head{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:13px 15px;border:1px solid rgba(204,102,51,.28);border-radius:13px;background:linear-gradient(135deg,rgba(204,102,51,.09),rgba(255,255,255,.015) 44%,rgba(0,0,0,.12))}
  	    #${ROOT_ID} .fifmnt-head .eyebrow{display:block;color:#d77a43;font-size:9px;font-weight:950;letter-spacing:.14em;text-transform:uppercase;margin-bottom:4px}
  	    #${ROOT_ID} .fifmnt-head h3{margin:0;color:#fff;font-size:18px;line-height:1.15}
  	    #${ROOT_ID} .fifmnt-head p{margin:4px 0 0;color:#87908a;font-size:11px;line-height:1.45}
  	    #${ROOT_ID} .fifmnt-actions{display:flex;align-items:center;justify-content:flex-end;gap:7px;flex-wrap:wrap}
  	    #${ROOT_ID} .fifmnt-schema-state{display:inline-flex;align-items:center;gap:7px;border:1px solid rgba(255,255,255,.08);border-radius:999px;padding:7px 10px;color:#aeb6b1;background:#0c100d;font-size:10px;font-weight:850}
  	    #${ROOT_ID} .fifmnt-schema-state i{width:7px;height:7px;border-radius:50%;background:#55c98b;box-shadow:0 0 10px rgba(85,201,139,.45)}
  	    #${ROOT_ID} .fifmnt-schema-state.loading i{background:#e4a24f;box-shadow:0 0 10px rgba(228,162,79,.45)}
  	    #${ROOT_ID} .fifmnt-schema-state.failed i{background:#ef5350;box-shadow:0 0 10px rgba(239,83,80,.45)}
  	    #${ROOT_ID} .fifmnt-kpis{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px}
  	    #${ROOT_ID} .fifmnt-kpi{position:relative;overflow:hidden;min-width:0;padding:12px 13px;border:1px solid rgba(255,255,255,.075);border-radius:12px;background:linear-gradient(145deg,#121613,#0a0d0b);box-shadow:inset 0 1px 0 rgba(255,255,255,.025)}
  	    #${ROOT_ID} .fifmnt-kpi:before{content:"";position:absolute;inset:0 auto 0 0;width:2px;background:#cc6633}
  	    #${ROOT_ID} .fifmnt-kpi.good:before{background:#55c98b}.fifmnt-kpi.warn:before{background:#e4a24f}.fifmnt-kpi.bad:before{background:#ef5350}.fifmnt-kpi.info:before{background:#5b8fff}
  	    #${ROOT_ID} .fifmnt-kpi span{display:block;color:#737d76;font-size:8px;font-weight:950;letter-spacing:.1em;text-transform:uppercase}
  	    #${ROOT_ID} .fifmnt-kpi strong{display:block;margin-top:5px;color:#fff;font-size:19px;line-height:1}
  	    #${ROOT_ID} .fifmnt-kpi small{display:block;margin-top:5px;color:#7f8882;font-size:9px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	    #${ROOT_ID} .fifmnt-toolbar{display:grid;grid-template-columns:minmax(260px,1fr) 165px 180px auto;gap:8px;align-items:end;padding:10px;border:1px solid rgba(255,255,255,.07);border-radius:12px;background:#0c100d}
  	    #${ROOT_ID} .fifmnt-search{position:relative;display:block}
  	    #${ROOT_ID} .fifmnt-search svg{position:absolute;left:11px;top:50%;transform:translateY(-50%);width:15px;height:15px;fill:none;stroke:#69726d;stroke-width:1.8;pointer-events:none}
  	    #${ROOT_ID} .fifmnt-search input{width:100%;height:37px;padding:0 12px 0 36px;border:1px solid rgba(255,255,255,.09);border-radius:9px;background:#070a08;color:#edf1ee;font:inherit;font-size:11px;outline:none}
  	    #${ROOT_ID} .fifmnt-search input:focus{border-color:#cc6633;box-shadow:0 0 0 2px rgba(204,102,51,.12)}
  	    #${ROOT_ID} .fifmnt-toolbar label>span{display:block;margin:0 0 4px;color:#727b75;font-size:8px;font-weight:950;letter-spacing:.08em;text-transform:uppercase}
  	    #${ROOT_ID} .fifmnt-toolbar select{width:100%;height:37px;border:1px solid rgba(255,255,255,.09);border-radius:9px;background:#070a08;color:#edf1ee;padding:0 10px;font:inherit;font-size:11px}
  	    #${ROOT_ID} .fifmnt-result-count{height:37px;display:flex;align-items:center;justify-content:center;padding:0 11px;border:1px solid rgba(255,255,255,.08);border-radius:9px;background:#111512;color:#8d9790;font-size:10px;font-weight:850;white-space:nowrap}
  	    #${ROOT_ID} .fifmnt-list-shell{min-height:0;border:1px solid rgba(255,255,255,.07);border-radius:12px;overflow:hidden;background:#090c0a}
  	    #${ROOT_ID} .fifmnt-columns,#${ROOT_ID} .fifmnt-row{display:grid;grid-template-columns:130px 118px minmax(190px,1.5fr) minmax(150px,1fr) 105px 125px 110px 112px;align-items:stretch}
  	    #${ROOT_ID} .fifmnt-columns{position:sticky;top:0;z-index:4;background:#111512;border-bottom:1px solid rgba(204,102,51,.25)}
  	    #${ROOT_ID} .fifmnt-sort{min-width:0;display:flex;align-items:center;justify-content:space-between;gap:7px;border:0;border-right:1px solid rgba(255,255,255,.06);background:transparent;color:#848e87;padding:9px 10px;font:inherit;font-size:8px;font-weight:950;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;text-align:left}
  	    #${ROOT_ID} .fifmnt-sort:hover,#${ROOT_ID} .fifmnt-sort.active{color:#f4f7f5;background:rgba(204,102,51,.07)}
  	    #${ROOT_ID} .fifmnt-sort b{font-size:9px;color:#cc6633}
  	    #${ROOT_ID} .fifmnt-list{max-height:calc(100vh - 510px);min-height:170px;overflow:auto}
  	    #${ROOT_ID} .fifmnt-row{border-bottom:1px solid rgba(255,255,255,.055);background:linear-gradient(90deg,rgba(255,255,255,.012),transparent);transition:background .12s,border-color .12s}
  	    #${ROOT_ID} .fifmnt-row:hover{background:linear-gradient(90deg,rgba(204,102,51,.075),rgba(255,255,255,.012));border-color:rgba(204,102,51,.2)}
  	    #${ROOT_ID} .fifmnt-cell{min-width:0;padding:10px;border-right:1px solid rgba(255,255,255,.045);display:flex;flex-direction:column;justify-content:center;gap:3px;color:#dce2de;font-size:10px}
  	    #${ROOT_ID} .fifmnt-cell strong{color:#f4f7f5;font-size:10.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	    #${ROOT_ID} .fifmnt-cell small{color:#6f7872;font-size:8.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	    #${ROOT_ID} .fifmnt-status{display:inline-flex;align-items:center;width:max-content;max-width:100%;padding:4px 7px;border:1px solid rgba(255,255,255,.09);border-radius:999px;background:#151a16;color:#b9c1bc;font-size:8px;font-weight:950;text-transform:uppercase;letter-spacing:.04em}
  	    #${ROOT_ID} .fifmnt-status.completed{border-color:rgba(85,201,139,.28);background:rgba(85,201,139,.09);color:#7fe2ad}
  	    #${ROOT_ID} .fifmnt-status.cancelled{border-color:rgba(239,83,80,.25);background:rgba(239,83,80,.08);color:#f27b78}
  	    #${ROOT_ID} .fifmnt-status.progress{border-color:rgba(91,143,255,.28);background:rgba(91,143,255,.09);color:#8fb3ff}
  	    #${ROOT_ID} .fifmnt-priority{font-weight:900}.fifmnt-priority.critical{color:#ff6c68}.fifmnt-priority.high{color:#f1ad58}
  	    #${ROOT_ID} .fifmnt-row-actions{display:flex;align-items:center;justify-content:center;gap:5px;padding:6px}#${ROOT_ID} .fifmnt-open{align-self:center;justify-self:center;width:32px;height:32px;display:grid;place-items:center;border:1px solid rgba(204,102,51,.32);border-radius:9px;background:rgba(204,102,51,.09);color:#f0a06f;cursor:pointer;font-size:15px}#${ROOT_ID} .fifmnt-phase{height:32px;padding:0 8px;border:1px solid rgba(204,102,51,.34);border-radius:9px;background:linear-gradient(145deg,rgba(164,75,37,.78),rgba(92,38,18,.88));color:#fff;font:800 8px Inter,system-ui,sans-serif;cursor:pointer}
  	    #${ROOT_ID} .fifmnt-open:hover{background:rgba(204,102,51,.18);border-color:#cc6633;color:#fff}
  	    #${ROOT_ID} .fifmnt-empty{padding:32px;text-align:center;color:#737c76;font-size:11px}
  	    #${ROOT_ID} .fifmnt-schema-error{padding:12px 13px;border:1px solid rgba(239,83,80,.28);border-radius:11px;background:rgba(239,83,80,.055);color:#d8b1af;font-size:10px;line-height:1.5}
  	    #${ROOT_ID} .fifmnt-schema-error strong{display:block;color:#ff8c88;margin-bottom:3px}
  	    @media(max-width:1250px){#${ROOT_ID} .fifmnt-kpis{grid-template-columns:repeat(3,minmax(0,1fr))}#${ROOT_ID} .fifmnt-columns,#${ROOT_ID} .fifmnt-row{grid-template-columns:120px 110px minmax(180px,1.4fr) minmax(140px,1fr) 100px 115px 100px 104px}}
  	    @media(max-width:900px){#${ROOT_ID} .fifmnt-kpis{grid-template-columns:repeat(2,minmax(0,1fr))}#${ROOT_ID} .fifmnt-toolbar{grid-template-columns:1fr 1fr}#${ROOT_ID} .fifmnt-list-shell{overflow-x:auto}#${ROOT_ID} .fifmnt-columns,#${ROOT_ID} .fifmnt-row{min-width:970px}}
  	    `;
  	    document.head.appendChild(style);
  	  }



  	  function maintenanceDateInput(value) {
  	    if (value === null || value === undefined || value === "") return "";
  	    const date = value instanceof Date ? value: new Date(value);
  	    if (Number.isNaN(date.getTime())) return clean(value).slice(0, 10);
  	    return date.toISOString().slice(0, 10);
  	  }

  	  function maintenanceDateTimeInput(value) {
  	    if (value === null || value === undefined || value === "") return "";
  	    const date = value instanceof Date ? value: new Date(value);
  	    if (Number.isNaN(date.getTime())) return clean(value).slice(0, 16);
  	    const offset = date.getTimezoneOffset() * 60000;
  	    return new Date(date.getTime() - offset).toISOString().slice(0, 16);
  	  }

  	  function maintenanceDateForSave(value) {
  	    const raw = clean(value);
  	    if (!raw) return null;
  	    const date = new Date(raw.length === 10 ? raw + "T12:00:00": raw);
  	    return Number.isNaN(date.getTime()) ? null: date;
  	  }

  	  function maintenanceYearKey(value) {
  	    const date = value instanceof Date ? value: new Date(value || Date.now());
  	    if (Number.isNaN(date.getTime())) return "";
  	    return date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0");
  	  }









  	  function maintenanceCacheKey(vehicle) {
  	    return objectIdOf(vehicle) || vehicleTitleValue(vehicle);
  	  }

  	  function maintenanceRelationRows(vehicle) {
  	    const raw = arr(vehicle && vehicle.Maintenance);
  	    const seen = {};
  	    return raw.map(normalizeServiceWorkOrder).filter(function (row) {
  	      const key = row.objectId || row.WorkOrderId;
  	      if (!key || seen[key]) return false;
  	      seen[key] = true;
  	      return true;
  	    });
  	  }

  	  function maintenanceRowsForVehicle(vehicle) {
  	    if (!vehicle) return [];
  	    const key = maintenanceCacheKey(vehicle);
  	    if (Array.isArray(state.maintenanceCache[key])) return state.maintenanceCache[key].map(normalizeServiceWorkOrder);
  	    const rows = maintenanceRelationRows(vehicle);
  	    state.maintenanceCache[key] = rows;
  	    return rows;
  	  }

  	  function replaceMaintenanceRowsForVehicle(vehicle, rows) {
  	    if (!vehicle) return;
  	    const normalized = arr(rows).map(normalizeServiceWorkOrder);
  	    const key = maintenanceCacheKey(vehicle);
  	    state.maintenanceCache[key] = normalized;
  	    vehicle.Maintenance = normalized.map(function (row) {
  	      const copy = cloneData(row);
  	      if (row.objectId) copy.objectId = row.objectId;
  	      return copy;
  	    });
  	  }

  	  function upsertMaintenanceLocal(vehicle,
  	    row) {
  	    const normalized = normalizeServiceWorkOrder(row);
  	    const rows = maintenanceRowsForVehicle(vehicle).slice();
  	    const index = rows.findIndex(function (item) {
  	      return (normalized.objectId && item.objectId === normalized.objectId) || item.WorkOrderId === normalized.WorkOrderId;
  	    });
  	    if (index >= 0) rows[index] = normalized; else rows.push(normalized);
  	    replaceMaintenanceRowsForVehicle(vehicle, rows);
  	    return normalized;
  	  }

  	  function ensureMaintenanceRecordsLoaded(company, vehicle, force) {
  	    if (!vehicle) return [];
  	    const key = maintenanceCacheKey(vehicle);

  	    if (force || !state.maintenanceLoaded[key] || !Array.isArray(state.maintenanceCache[key])) {
  	      const rows = maintenanceRelationRows(vehicle);
  	      replaceMaintenanceRowsForVehicle(vehicle, rows);
  	    }

  	    state.maintenanceLoaded[key] = true;
  	    state.maintenanceLoading[key] = false;
  	    state.maintenanceLoadError[key] = "";
  	    return maintenanceRowsForVehicle(vehicle);
  	  }







  	  function serviceWorkOrderById(company, id) {
  	    const target = clean(id);
  	    if (!target) return null;
  	    const assets = tractors(company).concat(towedAssets(company));
  	    for (let index = 0; index < assets.length; index += 1) {
  	      const found = maintenanceRowsForVehicle(assets[index]).map(normalizeServiceWorkOrder).find(function (order) {
  	        return order.WorkOrderId === target || order.objectId === target;
  	      });
  	      if (found) return found;
  	    }
  	    return serviceWorkOrders(company).find(function (order) {
  	      return order.WorkOrderId === target || order.objectId === target;
  	    }) || null;
  	  }

  	  function vehicleServiceOrders(company, vehicle) {
  	    const vehicleObjectId = objectIdOf(vehicle);
  	    const vehicleLabel = vehicleTitleValue(vehicle);
  	    const manifestRows = serviceWorkOrders(company).filter(function (job) {
  	      return clean(job.VehicleObjectId) === vehicleObjectId || clean(job.VehicleId) === vehicleLabel;
  	    });
  	    const relationalRows = maintenanceRowsForVehicle(vehicle).filter(function (record) {
  	      return [MAINTENANCE_CATEGORY_SERVICE, MAINTENANCE_CATEGORY_MAINTENANCE].indexOf(record.Category) !== -1;
  	    });
  	    const byKey = {};
  	    manifestRows.concat(relationalRows).forEach(function (row) {
  	      const normalized = normalizeServiceWorkOrder(row);
  	      const key = normalized.WorkOrderId || normalized.objectId;
  	      if (!key) return;
  	      const previous = byKey[key];
  	      if (!previous || normalized.objectId || new Date(normalized.UpdatedAt || 0).getTime() >= new Date(previous.UpdatedAt || 0).getTime()) {
  	        byKey[key] = normalized;
  	      }
  	    });
  	    return Object.keys(byKey).map(function (key) { return byKey[key]; });
  	  }



  	  function matchingVehiclePeriod(vehicle, dateValue) {
  	    const key = maintenanceYearKey(dateValue);
  	    const views = [vehicle && vehicle.ViewC].concat(arr(vehicle && vehicle.ViewH)).filter(Boolean);
  	    return views.find(function (view) {
  	      return clean(descriptorValue(view && view.MYearKey)) === key;
  	    }) || null;
  	  }





  	  async function saveMaintenanceRecord(company, vehicle, order, options) {
  	    options = options || {};
  	    if (!company || !vehicle || !vehicle.objectId) throw new Error("The selected vehicle does not contain an objectId.");
  	    refreshCurrentUserPermissions(false);
  	    const incomingCategory = clean(order && order.Category);
  	    if (incomingCategory === V21_CATEGORY_COMPLIANCE) {
  	      fifRequirePermission(userCanAccessAsset(vehicle) && CAN_EDIT_COMPLIANCE, "Compliance editing is not assigned.");
  	    } else if (incomingCategory === MAINTENANCE_CATEGORY_SERVICE) {
  	      fifRequirePermission(userCanAccessAssetFunction(vehicle, "Service") && CAN_MANAGE_SERVICE, "Service functionality is not assigned.");
  	    } else {
  	      fifRequirePermission(userCanAccessAssetFunction(vehicle, "Maintenance") && CAN_MANAGE_MAINTENANCE, "Maintenance functionality is not assigned.");
  	    }
  	    if (!BACKENDLESS_API || !BACKENDLESS_API.Data || !BACKENDLESS_API.Data.of) throw new Error("The database is unavailable. The maintenance record was not saved.");
  	    const payload = maintenanceRowPayload(company, vehicle, order);
  	    state.serviceSaving = true;
  	    state.serviceStatus = "Saving...";
  	    render();
  	    try {
  	      const savedRaw = await BACKENDLESS_API.Data.of(MAINTENANCE_TABLE).save(payload);
  	      const saved = normalizeServiceWorkOrder(Object.assign({}, payload, savedRaw || {}));
  	      await addMaintenanceRelations(vehicle, savedRaw || payload, saved.CompletedDate || saved.ReportedDate);
  	      upsertMaintenanceLocal(vehicle, saved);
  	      state.maintenanceLoaded[maintenanceCacheKey(vehicle)] = true;
  	      await updateVehicleServicePositionFromRecord(company, vehicle, saved);
  	      state.serviceSaving = false;
  	      state.serviceStatus = "Saved";
  	      render();
  	      if (options.message) await fifAlert(options.message, {
  	        title: options.title || "Maintenance Record Saved", type: "success", confirmText: "Done"
  	      });
  	      return saved;
  	    } catch (error) {
  	      state.serviceSaving = false;
  	      state.serviceStatus = "Save failed";
  	      render();
  	      const message = error && (error.message || error.faultString) ? (error.message || error.faultString): "The maintenance record could not be saved.";
  	      if (/column|property|schema|unknown/i.test(message)) {
  	        throw new Error(message + " The Maintenance table schema must contain the fields listed in the supplied Maintenance Table setup file.");
  	      }
  	      throw error;
  	    }
  	  }

  	  async function saveServicePortalData(company, providers, workOrders, message) {
  	    refreshCurrentUserPermissions(false);
  	    if (!CAN_ACCESS_SERVICE || !CAN_MANAGE_SERVICE_PROVIDERS) {
  	      await fifAlert("Service functionality is not assigned for provider changes.", {
  	        title: "Service Access Required", type: "warning", confirmText: "Close"
  	      });
  	      return false;
  	    }
  	    if (state.serviceSaving) return false;
  	    if (!company || !company.objectId) {
  	      await fifAlert("The selected company does not contain an objectId, so service-provider data cannot be saved.", {
  	        title: "Company Record Unavailable", type: "danger", confirmText: "Close"
  	      });
  	      return false;
  	    }
  	    if (!BACKENDLESS_API || !BACKENDLESS_API.Data || typeof BACKENDLESS_API.Data.of !== "function") {
  	      await fifAlert("The database is unavailable. The service-provider changes were not saved.", {
  	        title: "Save Unavailable", type: "danger", confirmText: "Close"
  	      });
  	      return false;
  	    }
  	    const payload = sanitizeApplicationCompanyForBackendless(company);
  	    if (!payload.Manifest || typeof payload.Manifest !== "object") payload.Manifest = {};
  	    if (!payload.Data || typeof payload.Data !== "object") payload.Data = {};
  	    if (!payload.Data.Manifest || typeof payload.Data.Manifest !== "object") payload.Data.Manifest = {};
  	    payload.Manifest.ServiceProviders = cloneData(providers);
  	    payload.Data.Manifest.ServiceProviders = cloneData(providers);
  	    if (Object.prototype.hasOwnProperty.call(payload.Manifest, "ServiceWorkOrders")) delete payload.Manifest.ServiceWorkOrders;
  	    if (Object.prototype.hasOwnProperty.call(payload.Data.Manifest, "ServiceWorkOrders")) delete payload.Data.Manifest.ServiceWorkOrders;
  	    state.serviceSaving = true;
  	    state.serviceStatus = "Saving...";
  	    render();
  	    const operation = fifBeginSaveOperation("Saving service provider and workshop data…");
  	    try {
  	      const saved = await BACKENDLESS_API.Data.of("Companies").save(payload);
  	      applyServicePortalToCompany(company, providers, []);
  	      if (company.Manifest) delete company.Manifest.ServiceWorkOrders;
  	      if (company.Data && company.Data.Manifest) delete company.Data.Manifest.ServiceWorkOrders;
  	      if (saved && saved.updated !== undefined) company.updated = saved.updated;
  	      state.serviceSaving = false;
  	      state.serviceStatus = "Saved";
  	      fifCompleteSaveOperation(operation, "Vehicle service data saved.");
  	      render();
  	      if (message) await fifAlert(message, {
  	        title: "Service Provider Saved", type: "success", confirmText: "Done"
  	      });
  	      return true;
  	    } catch (error) {
  	      state.serviceSaving = false;
  	      state.serviceStatus = "Save failed";
  	      fifFailSaveOperation(operation, error);
  	      render();
  	      await fifAlert(error && (error.message || error.faultString) ? (error.message || error.faultString): "The service-provider data could not be saved.", {
  	        title: "Service Provider Save Failed", type: "danger", confirmText: "Close"
  	      });
  	      return false;
  	    }
  	  }











  	  function appendWorkshopRecord(company,
  	    kind,
  	    form) {
  	    if (!CAN_MANAGE_WORKSHOP || state.vehicleBusy || state.serviceSaving) return;
  	    const vehicle = selectedVehicle(company);
  	    if (!vehicle) return;
  	    const values = formObject(form);
  	    const category = kind === "service" ? MAINTENANCE_CATEGORY_SERVICE: MAINTENANCE_CATEGORY_MAINTENANCE;
  	    const record = normalizeServiceWorkOrder({
  	      WorkOrderId: serviceId(kind === "service" ? "SVC": "MNT"),
  	      VehicleObjectId: objectIdOf(vehicle), VehicleId: vehicleTitleValue(vehicle), Registration: vehicleRegistrationValue(vehicle),
  	      Category: category, Type: values.type || prettyFieldName(kind), Title: values.type || prettyFieldName(kind),
  	      Status: "Completed", Priority: "Normal", ReportedDate: values.date || new Date().toISOString().slice(0, 10), CompletedDate: values.date || new Date().toISOString().slice(0, 10),
  	      Odometer: values.odometer === "" ? null: Number(values.odometer), ProviderName: values.provider || "", ActualCost: values.cost === "" ? null: Number(values.cost),
  	      Complaint: values.notes || "", WorkPerformed: values.notes || "", Notes: values.notes || "", IsScheduled: kind === "service"
  	    });
  	    setVehicleMessage("Saving " + kind + " record to the Maintenance table...", false);
  	    render();
  	    saveMaintenanceRecord(company, vehicle, record).then(function () {
  	      setVehicleMessage(prettyFieldName(kind) + " record saved and linked to " + vehicleTitleValue(vehicle) + ".", false);
  	      render();
  	    }).catch(async function (error) {
  	      setVehicleMessage(error && error.message ? error.message: "The record could not be saved.", true);
  	      render();
  	      await fifAlert(error && error.message ? error.message: "The record could not be saved.", {
  	        title: "Workshop Record Save Failed", type: "danger", confirmText: "Close"
  	      });
  	    });
  	  }

  	  function maintenanceFormPartLines(value) {
  	    if (Array.isArray(value)) return value.map(function (item) {
  	      return clean(item && (item.Description || item.Part || item.Name) || item);
  	    }).filter(Boolean).join("\n");
  	    return clean(value);
  	  }

  	  function openServiceRescheduleModal(company, workOrderId) {
  	    const order = serviceWorkOrderById(company, workOrderId);
  	    if (!order || !serviceJobIsOpen(order)) {
  	      fifAlert("Only an open scheduled job card can be rescheduled.", {
  	        title: "Reschedule Unavailable", type: "warning", confirmText: "Close"
  	      });
  	      return;
  	    }
  	    const vehicle = serviceVehicleById(company, order.VehicleObjectId);
  	    const body = `<form data-sp-reschedule-form class="fifsp-form">
  	      <section data-fif-collapsible-ready="true"><h3>Reschedule Work</h3><div class="grid">
  	        ${serviceField("PreviousDate", "Current scheduled date", order.ScheduledDate, "date", { disabled: true })}
  	        ${serviceField("NewDate", "New scheduled date", "", "date", { required: true })}
  	        ${serviceField("Reason", "Reason for rescheduling", "", "textarea", { wide: true, required: true })}
  	        ${serviceField("AddNote", "Additional note", "", "textarea", { wide: true })}
  	      </div>${serviceScheduleHistoryHtml(order)}</section>
  	    </form>`;
  	    const footer = `<button type="button" data-sp-modal-close>Cancel</button><button type="button" class="primary" data-sp-save-reschedule>Save Reschedule</button>`;
  	    const overlay = serviceModalShell(
  	      "Reschedule Job Card",
  	      order.WorkOrderId + " · The original scheduled date remains in the permanent audit history.",
  	      body,
  	      footer,
  	      false
  	    );

  	    overlay.querySelector("[data-sp-save-reschedule]")?.addEventListener("click", async function () {
  	      const form = overlay.querySelector("[data-sp-reschedule-form]");
  	      if (!form || !form.reportValidity()) return;
  	      const data = new FormData(form);
  	      const newDate = maintenanceDateInput(data.get("NewDate"));
  	      const reason = clean(data.get("Reason"));
  	      if (!newDate || newDate === clean(order.ScheduledDate)) {
  	        await fifAlert("Choose a new scheduled date that differs from the current date.", {
  	          title: "New Date Required", type: "warning", confirmText: "Continue Editing"
  	        });
  	        return;
  	      }
  	      const at = new Date().toISOString();
  	      const by = userDisplayName();
  	      const scheduleHistory = serviceScheduleAudit(order);
  	      scheduleHistory.push({
  	        At: at,
  	        By: by,
  	        PreviousDate: clean(order.ScheduledDate),
  	        NewDate: newDate,
  	        Reason: reason
  	      });
  	      const notes = serviceAppendAuditNote(order, clean(data.get("AddNote")) || reason, "Rescheduled");
  	      const updated = normalizeServiceWorkOrder(Object.assign({}, order, {
  	        ScheduledDate: newDate,
  	        Status: "Booked",
  	        ScheduleHistory: scheduleHistory,
  	        RescheduleCount: numberOr(order.RescheduleCount, 0) + 1,
  	        LastRescheduledAt: at,
  	        LastRescheduledBy: by,
  	        Notes: notes.Notes,
  	        NoteLog: notes.NoteLog,
  	        UpdatedAt: at,
  	        UpdatedBy: by
  	      }));
  	      try {
  	        closeServicePortalModal();
  	        await saveMaintenanceRecord(company, vehicle, updated, {
  	          message: updated.WorkOrderId + " was rescheduled to " + serviceFormatDate(newDate) + ". The previous date and reason were retained.",
  	          title: "Job Rescheduled"
  	        });
  	      } catch (error) {
  	        await fifAlert(error && error.message ? error.message : "The job card could not be rescheduled.", {
  	          title: "Reschedule Failed", type: "danger", confirmText: "Close"
  	        });
  	      }
  	    });
  	  }

  	  function openServiceJobModal(company, workOrderId, defaults) {
  	    defaults = defaults || {};
  	    const existing = workOrderId ? serviceWorkOrderById(company, workOrderId) : null;
  	    const order = normalizeServiceWorkOrder(existing || defaults);
  	    if (defaults.Category) order.Category = defaults.Category;
  	    if (defaults.Type) order.Type = defaults.Type;

  	    const providers = serviceProviders(company).filter(function (provider) {
  	      return lower(provider.Status) === "active";
  	    });
  	    const vehicles = tractors(company).concat(towedAssets(company));
  	    const permissionReadOnly = !CAN_MANAGE_SERVICE_JOBS;
  	    const closedRecord = !!existing && serviceJobIsClosed(order);
  	    const fieldReadOnly = permissionReadOnly || closedRecord;
  	    const scheduleProtected = !!existing && serviceJobRequiresReschedule(order);
  	    order.Status = serviceCanonicalStatus(order.Status || "Scheduled");

  	    const body = `<form data-sp-job-form class="fifsp-form">
  	    <section><h3>Job Identity and Workflow</h3><div class="grid">${serviceField("VehicleObjectId", "Vehicle", order.VehicleObjectId, "select", {
  	      required: true, disabled: fieldReadOnly || !!existing || defaults.LockVehicle === true, values: [{
  	        value: "", label: "Select vehicle"
  	      }].concat(vehicles.map(function (vehicle) {
  	        return { value: objectIdOf(vehicle), label: vehicleTitleValue(vehicle) + " · " + vehicleSecondaryTitle(vehicle) };
  	      }))
  	    })}${serviceField("Category", "Record category", order.Category, "select", {
  	      values: [MAINTENANCE_CATEGORY_SERVICE, MAINTENANCE_CATEGORY_MAINTENANCE], disabled: fieldReadOnly
  	    })}${serviceField("Type", "Job type", order.Type, "select", {
  	      values: SERVICE_JOB_TYPES, disabled: fieldReadOnly
  	    })}${serviceField("Title", "Job title", order.Title, "text", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("Priority", "Priority", order.Priority, "select", {
  	      values: ["Low", "Normal", "High", "Critical"], disabled: fieldReadOnly
  	    })}${serviceField("Status", "Current workshop phase", servicePhaseLabel(order.Status), "text", {
  	      disabled: true
  	    })}${serviceField("ReportedDate", "Reported date", order.ReportedDate, "date", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("ScheduledDate", scheduleProtected ? "Scheduled date — use Reschedule" : "Scheduled date", order.ScheduledDate, "date", {
  	      disabled: fieldReadOnly || scheduleProtected
  	    })}${serviceField("StartedDate", "Work started", order.StartedDate, "datetime-local", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("CompletedDate", "Completed date", order.CompletedDate, "date", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("Odometer", "Vehicle odometer", order.Odometer, "number", {
  	      min: 0, disabled: fieldReadOnly
  	    })}${serviceField("ProviderId", "Service provider", order.ProviderId, "select", {
  	      disabled: fieldReadOnly, values: [{
  	        value: "", label: "Not assigned"
  	      }].concat(providers.map(function (provider) {
  	        return { value: provider.ProviderId, label: serviceProviderLabel(provider) };
  	      }))
  	    })}</div>${scheduleProtected ? `<div class="fifsp-protection-note">This scheduled date is protected. Use <strong>Reschedule</strong> to move the work and retain the original date and reason.</div>` : ""}<div class="fifsp-phase-summary"><strong>${escapeHtml(servicePhaseLabel(order.Status))}</strong><span>${escapeHtml(servicePhaseDescription(order.Status))}</span></div></section>

  	    <section><h3>Technical Job Card</h3><div class="grid">${serviceField("Technician", "Technician / contact", order.Technician, "text", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("Complaint", "Reported concern / requirement", order.Complaint, "textarea", {
  	      wide: true, disabled: fieldReadOnly, required: true
  	    })}${serviceField("Diagnosis", "Diagnosis and root cause", order.Diagnosis, "textarea", {
  	      wide: true, disabled: fieldReadOnly
  	    })}${serviceField("WorkPerformed", "Work performed", order.WorkPerformed, "textarea", {
  	      wide: true, disabled: fieldReadOnly
  	    })}${serviceField("PartsText", "Parts and materials — one per line", maintenanceFormPartLines(order.Parts), "textarea", {
  	      wide: true, disabled: fieldReadOnly
  	    })}</div></section>

  	    <section><h3>Commercial Control</h3><div class="grid">${serviceField("EstimatedCost", "Estimated total", order.EstimatedCost, "number", {
  	      min: 0, disabled: fieldReadOnly
  	    })}${serviceField("LabourCost", "Labour cost", order.LabourCost, "number", {
  	      min: 0, disabled: fieldReadOnly
  	    })}${serviceField("PartsCost", "Parts cost", order.PartsCost, "number", {
  	      min: 0, disabled: fieldReadOnly
  	    })}${serviceField("ExternalCost", "External / subcontract", order.ExternalCost, "number", {
  	      min: 0, disabled: fieldReadOnly
  	    })}${serviceField("OtherCost", "Other cost", order.OtherCost, "number", {
  	      min: 0, disabled: fieldReadOnly
  	    })}${serviceField("ActualCost", "Actual total", order.ActualCost, "number", {
  	      min: 0, disabled: fieldReadOnly
  	    })}${serviceField("PurchaseOrder", "Purchase order", order.PurchaseOrder, "text", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("InvoiceNumber", "Invoice number", order.InvoiceNumber, "text", {
  	      disabled: fieldReadOnly
  	    })}</div></section>

  	    <section><h3>Downtime, Warranty and Follow-up</h3><div class="grid">${serviceField("DowntimeStart", "Downtime started", order.DowntimeStart, "datetime-local", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("DowntimeEnd", "Downtime ended", order.DowntimeEnd, "datetime-local", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("IsScheduled", "Scheduled / planned work", order.IsScheduled, "checkbox", {
  	      wide: true, disabled: fieldReadOnly || scheduleProtected
  	    })}${serviceField("IsWarranty", "Warranty claim", order.IsWarranty, "checkbox", {
  	      wide: true, disabled: fieldReadOnly
  	    })}${serviceField("WarrantyReference", "Warranty reference", order.WarrantyReference, "text", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("RepeatRepair", "Repeat repair", order.RepeatRepair, "checkbox", {
  	      wide: true, disabled: fieldReadOnly
  	    })}${serviceField("ParentWorkOrderId", "Related prior work order", order.ParentWorkOrderId, "text", {
  	      disabled: fieldReadOnly
  	    })}${serviceField("NextServiceKm", "Next service odometer — calculated on completion", order.NextServiceKm, "number", {
  	      min: 0, disabled: true
  	    })}${serviceField("NextServiceDate", "Next service date", order.NextServiceDate, "date", {
  	      disabled: fieldReadOnly
  	    })}</div></section>

  	    <section><h3>Append-only Notes</h3>${workshopTimelineHtml(order)}${permissionReadOnly ? "" : `<div class="grid">${serviceField("AddNote", closedRecord ? "Add post-closure note" : existing ? "Add note" : "Initial note", "", "textarea", {
  	      wide: true, disabled: false
  	    })}</div>`}</section>
  	    <input type="hidden" name="WorkOrderId" value="${escapeAttr(order.WorkOrderId)}"><input type="hidden" name="ObjectId" value="${escapeAttr(order.objectId)}">
  	    </form>`;

  	    let footer = `<button type="button" data-sp-modal-close>${permissionReadOnly ? "Close" : "Cancel"}</button>`;
  	    if (existing) footer += `<button type="button" data-sp-print-job>Print Job Card</button>`;
  	    if (!permissionReadOnly && scheduleProtected) footer += `<button type="button" data-sp-reschedule-job="${escapeAttr(order.WorkOrderId)}">Reschedule</button>`;
  	    if (!permissionReadOnly && existing && serviceCanonicalStatus(order.Status) === "In Progress") footer += `<button type="button" class="danger" data-sp-cancel-job>Cancel Job</button>`;
  	    if (!permissionReadOnly && existing && serviceJobIsOpen(order)) footer += `<button type="button" class="primary" data-sp-phase-job-card>Update Phase</button>`;
  	    if (!permissionReadOnly) footer += `<button type="button" class="${existing && serviceJobIsOpen(order) ? "" : "primary"}" data-sp-save-job>${closedRecord ? "Add Note" : existing ? "Save Details" : "Create Scheduled Job"}</button>`;

  	    const overlay = serviceModalShell(
  	      existing ? "Workshop Job Card" : "New Workshop Job",
  	      existing ? order.WorkOrderId + " · " + order.VehicleId : "Create a relational service or maintenance record linked to the vehicle.",
  	      body,
  	      footer,
  	      true
  	    );

  	    overlay.querySelector("[data-sp-print-job]")?.addEventListener("click", function () {
  	      printServiceJobCard(company, order);
  	    });
  	    overlay.querySelector("[data-sp-reschedule-job]")?.addEventListener("click", function () {
  	      const id = order.WorkOrderId;
  	      closeServicePortalModal();
  	      openServiceRescheduleModal(company, id);
  	    });

  	    const submitJob = async function (forceClose) {
  	      const form = overlay.querySelector("[data-sp-job-form]");
  	      if (!form || !form.reportValidity()) return;
  	      const data = new FormData(form);
  	      const vehicle = serviceVehicleById(company, clean(data.get("VehicleObjectId")) || order.VehicleObjectId);
  	      if (!vehicle) {
  	        await fifAlert("Select a valid vehicle for this job card.", {
  	          title: "Vehicle Required", type: "warning", confirmText: "Continue Editing"
  	        });
  	        return;
  	      }

  	      const addedNote = clean(data.get("AddNote"));
  	      if (closedRecord) {
  	        if (!addedNote) {
  	          await fifAlert("Closed job cards are protected. Enter a new note to append, or close the window without saving.", {
  	            title: "New Note Required", type: "warning", confirmText: "Continue Editing"
  	          });
  	          return;
  	        }
  	        const notes = serviceAppendAuditNote(order, addedNote, "Post-closure note");
  	        const noteOnly = normalizeServiceWorkOrder(Object.assign({}, order, {
  	          Notes: notes.Notes,
  	          NoteLog: notes.NoteLog,
  	          UpdatedAt: new Date().toISOString(),
  	          UpdatedBy: userDisplayName()
  	        }));
  	        try {
  	          closeServicePortalModal();
  	          await saveMaintenanceRecord(company, vehicle, noteOnly, {
  	            message: "The new note was appended to " + noteOnly.WorkOrderId + ". Existing notes and closure details were not changed.",
  	            title: "Note Added"
  	          });
  	        } catch (error) {
  	          await fifAlert(error && error.message ? error.message : "The note could not be added.", {
  	            title: "Note Save Failed", type: "danger", confirmText: "Close"
  	          });
  	        }
  	        return;
  	      }

  	      const provider = serviceProviderById(company, data.get("ProviderId"));
  	      const status = existing ? serviceCanonicalStatus(order.Status) : "Scheduled";
  	      const category = clean(data.get("Category")) || maintenanceCategoryFromType(data.get("Type"), "");
  	      const workPerformed = clean(data.get("WorkPerformed"));
  	      const odometer = numberOr(data.get("Odometer"), null);

  	      if (forceClose && !workPerformed) {
  	        await fifAlert("Record the work performed before closing the job card.", {
  	          title: "Work Performed Required", type: "warning", confirmText: "Continue Editing"
  	        });
  	        return;
  	      }
  	      if (forceClose && odometer === null) {
  	        await fifAlert("Record the vehicle odometer before closing the job card.", {
  	          title: "Odometer Required", type: "warning", confirmText: "Continue Editing"
  	        });
  	        return;
  	      }

  	      const at = new Date().toISOString();
  	      const notes = serviceAppendAuditNote(order, addedNote, forceClose ? "Job closed" : existing ? "Job note" : "Initial note");
  	      const updated = normalizeServiceWorkOrder({
  	        objectId: data.get("ObjectId") || order.objectId,
  	        WorkOrderId: data.get("WorkOrderId"),
  	        VehicleObjectId: objectIdOf(vehicle),
  	        VehicleId: vehicleTitleValue(vehicle),
  	        Registration: vehicleRegistrationValue(vehicle),
  	        Category: category,
  	        Type: data.get("Type"),
  	        Title: data.get("Title"),
  	        Priority: data.get("Priority"),
  	        Status: status,
  	        ReportedDate: data.get("ReportedDate"),
  	        ScheduledDate: scheduleProtected ? order.ScheduledDate : data.get("ScheduledDate"),
  	        StartedDate: data.get("StartedDate"),
  	        CompletedDate: forceClose ? (clean(data.get("CompletedDate")) || at.slice(0, 10)) : clean(data.get("CompletedDate")),
  	        Odometer: odometer,
  	        ProviderId: provider ? provider.ProviderId : "",
  	        ProviderName: provider ? serviceProviderLabel(provider) : "",
  	        Technician: data.get("Technician"),
  	        Complaint: data.get("Complaint"),
  	        Diagnosis: data.get("Diagnosis"),
  	        WorkPerformed: workPerformed,
  	        Parts: String(data.get("PartsText") || "").split(/\n+/).map(clean).filter(Boolean).map(function (line) {
  	          return { Description: line };
  	        }),
  	        EstimatedCost: data.get("EstimatedCost"),
  	        LabourCost: data.get("LabourCost"),
  	        PartsCost: data.get("PartsCost"),
  	        ExternalCost: data.get("ExternalCost"),
  	        OtherCost: data.get("OtherCost"),
  	        ActualCost: data.get("ActualCost"),
  	        PurchaseOrder: data.get("PurchaseOrder"),
  	        InvoiceNumber: data.get("InvoiceNumber"),
  	        DowntimeStart: data.get("DowntimeStart"),
  	        DowntimeEnd: forceClose ? (clean(data.get("DowntimeEnd")) || at.slice(0, 16)) : data.get("DowntimeEnd"),
  	        IsScheduled: scheduleProtected ? true : data.has("IsScheduled"),
  	        IsWarranty: data.has("IsWarranty"),
  	        WarrantyReference: data.get("WarrantyReference"),
  	        RepeatRepair: data.has("RepeatRepair"),
  	        ParentWorkOrderId: data.get("ParentWorkOrderId"),
  	        NextServiceKm: data.get("NextServiceKm"),
  	        NextServiceDate: data.get("NextServiceDate"),
  	        Notes: notes.Notes,
  	        NoteLog: notes.NoteLog,
  	        ScheduleHistory: serviceScheduleAudit(order),
  	        RescheduleCount: order.RescheduleCount,
  	        LastRescheduledAt: order.LastRescheduledAt,
  	        LastRescheduledBy: order.LastRescheduledBy,
  	        ClosedAt: forceClose ? at : order.ClosedAt,
  	        ClosedBy: forceClose ? userDisplayName() : order.ClosedBy,
  	        ClosureReason: order.ClosureReason,
  	        WorkflowHistory: serviceWorkflowHistory(order),
  	        CurrentPhaseEnteredAt: order.CurrentPhaseEnteredAt,
  	        CurrentPhaseEnteredBy: order.CurrentPhaseEnteredBy,
  	        BookingReference: order.BookingReference,
  	        BookingConfirmedAt: order.BookingConfirmedAt,
  	        BookingConfirmedBy: order.BookingConfirmedBy,
  	        BookingReleasedAt: order.BookingReleasedAt,
  	        BookingReleasedBy: order.BookingReleasedBy,
  	        VehicleReceivedAt: order.VehicleReceivedAt,
  	        VehicleReceivedBy: order.VehicleReceivedBy,
  	        DelayReason: order.DelayReason,
  	        DelayExpectedDate: order.DelayExpectedDate,
  	        DelayStartedAt: order.DelayStartedAt,
  	        DelayStartedBy: order.DelayStartedBy,
  	        DelayResolvedAt: order.DelayResolvedAt,
  	        DelayResolvedBy: order.DelayResolvedBy,
  	        ReadyAt: order.ReadyAt,
  	        ReadyBy: order.ReadyBy,
  	        CollectedAt: order.CollectedAt,
  	        CollectedBy: order.CollectedBy,
  	        CancelledAt: order.CancelledAt,
  	        CancelledBy: order.CancelledBy,
  	        CreatedAt: order.CreatedAt,
  	        CreatedBy: order.CreatedBy,
  	        UpdatedAt: at,
  	        UpdatedBy: userDisplayName()
  	      });

  	      if (!existing) {
  	        const createdAudit = serviceTransitionAudit({ Status: "" }, "Scheduled", addedNote || "Job card created", "Created", {
  	          ScheduledDate: updated.ScheduledDate,
  	          ProviderId: updated.ProviderId
  	        });
  	        updated.WorkflowHistory = createdAudit.WorkflowHistory;
  	        updated.CurrentPhaseEnteredAt = createdAudit.CurrentPhaseEnteredAt;
  	        updated.CurrentPhaseEnteredBy = createdAudit.CurrentPhaseEnteredBy;
  	      }

  	      try {
  	        closeServicePortalModal();
  	        await saveMaintenanceRecord(company, vehicle, updated, {
  	          message: updated.WorkOrderId + (forceClose ? " was completed and closed." : " was saved and linked to " + vehicleTitleValue(vehicle) + "."),
  	          title: forceClose ? "Job Card Closed" : "Workshop Job Saved"
  	        });
  	      } catch (error) {
  	        await fifAlert(error && error.message ? error.message : "The workshop record could not be saved.", {
  	          title: "Workshop Save Failed", type: "danger", confirmText: "Close"
  	        });
  	      }
  	    };

  	    overlay.querySelector("[data-sp-save-job]")?.addEventListener("click", function () {
  	      submitJob(false);
  	    });
  	    overlay.querySelector("[data-sp-cancel-job]")?.addEventListener("click", function () {
  	      const id = order.WorkOrderId;
  	      closeServicePortalModal();
  	      openServicePhaseModal(company, id, "Cancelled");
  	    });
  	    overlay.querySelector("[data-sp-phase-job-card]")?.addEventListener("click", function () {
  	      const id = order.WorkOrderId;
  	      closeServicePortalModal();
  	      openServicePhaseModal(company, id, "");
  	    });
  	  }



  	  function printServiceJobCard(company, job) {
  	    const record = normalizeServiceWorkOrder(job);
  	    const cost = record.ActualCost !== null ? record.ActualCost: record.EstimatedCost;
  	    const parts = maintenanceFormPartLines(record.Parts) || "—";
  	    openServicePrintWindow("Workshop Job Card " + record.WorkOrderId, `<div class="card"><table><tbody>
  	      <tr><th>Vehicle</th><td>${escapeHtml(record.VehicleId)}</td><th>Category</th><td>${escapeHtml(record.Category)}</td></tr>
  	      <tr><th>Status</th><td>${escapeHtml(record.Status)}</td><th>Priority</th><td>${escapeHtml(record.Priority)}</td></tr>
  	      <tr><th>Job type</th><td>${escapeHtml(record.Type)}</td><th>Odometer</th><td>${record.Odometer === null ? "—": escapeHtml(formatNumber(record.Odometer, 0) + " km")}</td></tr>
  	      <tr><th>Provider</th><td>${escapeHtml(record.ProviderName || "Not assigned")}</td><th>Technician</th><td>${escapeHtml(record.Technician || "—")}</td></tr>
  	      <tr><th>Reported</th><td>${escapeHtml(serviceFormatDate(record.ReportedDate))}</td><th>Scheduled</th><td>${escapeHtml(serviceFormatDate(record.ScheduledDate))}</td></tr>
  	      <tr><th>Completed</th><td>${escapeHtml(serviceFormatDate(record.CompletedDate))}</td><th>Recorded cost</th><td>${cost === null ? "—": escapeHtml(formatCurrency(cost))}</td></tr>
  	      <tr><th>Purchase order</th><td>${escapeHtml(record.PurchaseOrder || "—")}</td><th>Invoice</th><td>${escapeHtml(record.InvoiceNumber || "—")}</td></tr>
  	      </tbody></table></div>
  	      <h2>Reported Requirement</h2><div class="card">${escapeHtml(record.Complaint || "—")}</div>
  	      <h2>Diagnosis</h2><div class="card">${escapeHtml(record.Diagnosis || "—")}</div>
  	      <h2>Work Performed</h2><div class="card">${escapeHtml(record.WorkPerformed || "—")}</div>
  	      <h2>Parts / Materials</h2><div class="card" style="white-space:pre-wrap">${escapeHtml(parts)}</div>
  	      <h2>Commercial Breakdown</h2><table><tbody><tr><th>Labour</th><td>${record.LabourCost === null ? "—": escapeHtml(formatCurrency(record.LabourCost))}</td><th>Parts</th><td>${record.PartsCost === null ? "—": escapeHtml(formatCurrency(record.PartsCost))}</td></tr><tr><th>External</th><td>${record.ExternalCost === null ? "—": escapeHtml(formatCurrency(record.ExternalCost))}</td><th>Other</th><td>${record.OtherCost === null ? "—": escapeHtml(formatCurrency(record.OtherCost))}</td></tr></tbody></table>
  	      <h2>Notes</h2><div class="card">${escapeHtml(record.Notes || "—")}</div>
  	      <h2>Authorisation</h2><table><tbody><tr><th>Technician / Provider</th><td style="height:42px"></td><th>Company approval</th><td></td></tr></tbody></table>`);
  	  }



  	  const V21_CATEGORY_COMPLIANCE = "Compliance";

  	  const V21_COMPLIANCE_STYLE_ID = "fif-dashboard-compliance-v2190-style";
  	  const V21_WORKSHOP_SMART_STYLE_ID = "fif-dashboard-workshop-smart-v21110-style";

  	  const V21_COMPLIANCE_TYPES = ["Vehicle Licence", "Certificate of Fitness", "Roadworthy", "Load Test", "Calibration", "Insurance", "Operating Permit", "Cross-border Permit", "Fire Extinguisher", "Dangerous Goods", "Tracking Certificate", "Other Compliance"];

  	  const V21_COMPLIANCE_SETUP_DEFINITIONS = [
  	    {
  	      key: "VehicleLicence",
  	      label: "Vehicle licence",
  	      caption: "Annual vehicle licensing and registration evidence.",
  	      group: "Road & registration",
  	      recordTypes: ["Vehicle Licence"],
  	      aliases: ["licence expiry", "license expiry", "vehicle licence", "registration and licensing"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "RegistrationAndLicensing", "LicenceExpiry"],
  	        ["Data", "Compliance", "License_Expiry_Date"]
  	      ],
  	      relevant: function (context) { return context.road; },
  	      recommended: function (context) { return context.road; }
  	    },
  	    {
  	      key: "Roadworthiness",
  	      label: "Roadworthiness / COF",
  	      caption: "One requirement covers Roadworthy and Certificate of Fitness evidence.",
  	      group: "Road & registration",
  	      recordTypes: ["Certificate of Fitness", "Roadworthy"],
  	      aliases: ["roadworthy", "roadworthiness", "cof expiry", "certificate of fitness"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Roadworthiness", "COFExpiry"],
  	        ["Data", "Compliance", "COF_Expiry"]
  	      ],
  	      relevant: function (context) { return context.road || context.commercial || context.heavy; },
  	      recommended: function (context) { return context.commercial || context.heavy; }
  	    },
  	    {
  	      key: "Insurance",
  	      label: "Insurance",
  	      caption: "Vehicle insurance policy and renewal date.",
  	      group: "Road & registration",
  	      recordTypes: ["Insurance"],
  	      aliases: ["insurance expiry", "insurance"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Insurance", "ExpiryDate"],
  	        ["Data", "Compliance", "InsuranceExpiry"]
  	      ],
  	      relevant: function (context) { return context.road; }
  	    },
  	    {
  	      key: "OperatingPermit",
  	      label: "Operating permit",
  	      caption: "Commercial operating permit where one is required.",
  	      group: "Commercial permits",
  	      recordTypes: ["Operating Permit"],
  	      aliases: ["operating permit expiry", "operating permit required", "operating permit"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Permits", "OperatingPermitExpiry"]
  	      ],
  	      relevant: function (context) { return context.commercial || context.heavy; }
  	    },
  	    {
  	      key: "CrossBorderPermit",
  	      label: "Cross-border permit",
  	      caption: "Cross-border authority for vehicles operating outside South Africa.",
  	      group: "Commercial permits",
  	      recordTypes: ["Cross-border Permit"],
  	      aliases: ["cross border expiry", "cross border required", "cross-border permit"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Permits", "CrossBorderExpiry"]
  	      ],
  	      relevant: function (context) {
  	        return context.commercial || arr(context.domains).some(function (domain) {
  	          return lower(domain).indexOf("cross") !== -1;
  	        });
  	      }
  	    },
  	    {
  	      key: "DangerousGoods",
  	      label: "Dangerous goods",
  	      caption: "Vehicle dangerous-goods permit or supporting certificate.",
  	      group: "Commercial permits",
  	      recordTypes: ["Dangerous Goods"],
  	      aliases: ["dangerous goods expiry", "dangerous goods required", "dangerous goods"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Permits", "DangerousGoodsExpiry"]
  	      ],
  	      relevant: function (context) { return context.commercial || context.heavy; }
  	    },
  	    {
  	      key: "LoadTest",
  	      label: "Load test",
  	      caption: "Load-test certificate for lifting, load-bearing or regulated equipment.",
  	      group: "Safety & testing",
  	      recordTypes: ["Load Test"],
  	      aliases: ["load test expiry", "load test required", "load test certificate"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Testing", "LoadTestExpiry"],
  	        ["Data", "Compliance", "Load_Test_Expiry"]
  	      ],
  	      relevant: function (context) { return context.commercial || context.heavy || context.agricultural; }
  	    },
  	    {
  	      key: "Calibration",
  	      label: "Calibration",
  	      caption: "Calibration certificate for metering or measurement equipment.",
  	      group: "Safety & testing",
  	      recordTypes: ["Calibration"],
  	      aliases: ["calibration expiry", "calibration required", "calibration certificate"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Testing", "CalibrationExpiry"],
  	        ["Data", "Compliance", "Calibration_Expiry"]
  	      ],
  	      relevant: function (context) { return context.commercial || context.agricultural; }
  	    },
  	    {
  	      key: "FireExtinguisher",
  	      label: "Fire extinguisher",
  	      caption: "Inspection or service expiry for the fitted extinguisher.",
  	      group: "Safety & testing",
  	      recordTypes: ["Fire Extinguisher"],
  	      aliases: ["fire extinguisher expiry", "fire extinguisher required", "fire extinguisher"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "SafetyEquipment", "FireExtinguisherExpiry"],
  	        ["Data", "Compliance", "Fire_Extinguisher_Expiry"]
  	      ],
  	      relevant: function (context) { return context.commercial || context.heavy || context.agricultural; }
  	    },
  	    {
  	      key: "TrackingCertificate",
  	      label: "Tracking certificate",
  	      caption: "Current tracking installation or verification certificate.",
  	      group: "Safety & testing",
  	      recordTypes: ["Tracking Certificate"],
  	      aliases: ["tracking certificate expiry", "tracking certificate"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Tracking", "CertificateExpiry"]
  	      ],
  	      relevant: function (context) { return context.road || context.commercial; }
  	    },
  	    {
  	      key: "ROPSInspection",
  	      label: "ROPS inspection",
  	      caption: "Inspection of the rollover protection structure.",
  	      group: "Agricultural safety",
  	      recordTypes: ["Other Compliance"],
  	      aliases: ["ropsinspection expiry", "rops inspection expiry", "rops inspection required"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Agricultural", "ROPSInspectionExpiry"]
  	      ],
  	      relevant: function (context) { return context.agricultural; }
  	    },
  	    {
  	      key: "PTOGuardInspection",
  	      label: "PTO guard inspection",
  	      caption: "Inspection of PTO guards and related agricultural safety equipment.",
  	      group: "Agricultural safety",
  	      recordTypes: ["Other Compliance"],
  	      aliases: ["ptoguard inspection expiry", "pto guard inspection expiry", "pto guard inspection required"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Agricultural", "PTOGuardInspectionExpiry"]
  	      ],
  	      relevant: function (context) { return context.agricultural; }
  	    }
  	  ];
  	  const V21_COMPLIANCE_STATUSES = ["Draft", "Scheduled", "Submitted", "Issued", "Active", "Due Soon", "Expired", "Failed", "Rejected", "Renewed", "Cancelled"];

  	  function injectV21ComplianceStyles() {
  	    if (document.getElementById(V21_COMPLIANCE_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = V21_COMPLIANCE_STYLE_ID;
  	    style.textContent = `
  	      #${ROOT_ID} .fifcmp-root{
  	        display:grid;
  	        gap:10px;
  	        min-width:0;
  	        color:#edf2ee;
  	      }

  	      #${ROOT_ID} .fifcmp-head{
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        gap:14px;
  	        padding:12px 15px;
  	        border:1px solid rgba(204,102,51,.25);
  	        border-radius:11px;
  	        background:
  	          radial-gradient(circle at 0 0,rgba(204,102,51,.12),transparent 38%),
  	          linear-gradient(145deg,#222922,#151a16);
  	      }

  	      #${ROOT_ID} .fifcmp-head .eyebrow,
  	      #${ROOT_ID} .fifcmp-section>header span,
  	      #${ROOT_ID} .fifcmp-records>summary span{
  	        display:block;
  	        color:#db7c48;
  	        font-size:9px;
  	        font-weight:950;
  	        letter-spacing:.11em;
  	        text-transform:uppercase;
  	      }

  	      #${ROOT_ID} .fifcmp-head h3{
  	        margin:4px 0 0;
  	        color:#fff;
  	        font-size:20px;
  	      }

  	      #${ROOT_ID} .fifcmp-head p{
  	        margin:4px 0 0;
  	        color:#929c96;
  	        font-size:11px;
  	      }

  	      #${ROOT_ID} .fifcmp-head-actions{
  	        display:flex;
  	        align-items:center;
  	        justify-content:flex-end;
  	        gap:7px;
  	        flex-wrap:wrap;
  	      }

  	      #${ROOT_ID} .fifcmp-summary{
  	        display:grid;
  	        grid-template-columns:minmax(250px,1.3fr) repeat(3,minmax(150px,.7fr));
  	        gap:7px;
  	        padding:8px 10px;
  	        background:#181e19;
  	      }

  	      #${ROOT_ID} .fifcmp-summary article{
  	        min-width:0;
  	        padding:11px 12px;
  	        border:1px solid rgba(255,255,255,.075);
  	        border-radius:10px;
  	        background:linear-gradient(145deg,#232a23,#191e1a);
  	      }

  	      #${ROOT_ID} .fifcmp-summary .overall{
  	        border-left:4px solid #7c8680;
  	      }

  	      #${ROOT_ID} .fifcmp-summary .overall.good{border-left-color:#55c98b}
  	      #${ROOT_ID} .fifcmp-summary .overall.warn{border-left-color:#e4a24f}
  	      #${ROOT_ID} .fifcmp-summary .overall.bad{border-left-color:#ef6761}

  	      #${ROOT_ID} .fifcmp-summary span{
  	        display:block;
  	        color:#87918b;
  	        font-size:9px;
  	        font-weight:950;
  	        letter-spacing:.07em;
  	        text-transform:uppercase;
  	      }

  	      #${ROOT_ID} .fifcmp-summary strong{
  	        display:block;
  	        margin-top:6px;
  	        color:#f7f9f7;
  	        font-size:19px;
  	      }

  	      #${ROOT_ID} .fifcmp-summary .overall strong{
  	        font-size:22px;
  	      }

  	      #${ROOT_ID} .fifcmp-summary small{
  	        display:block;
  	        margin-top:5px;
  	        color:#8c9690;
  	        font-size:10px;
  	        line-height:1.35;
  	      }

  	      #${ROOT_ID} .fifcmp-section,
  	      #${ROOT_ID} .fifcmp-records{
  	        min-width:0;
  	        border:1px solid rgba(255,255,255,.075);
  	        border-radius:11px;
  	        background:linear-gradient(145deg,#1d241e,#131814);
  	        overflow:hidden;
  	      }

  	      #${ROOT_ID} .fifcmp-section>header{
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        gap:12px;
  	        padding:10px 12px;
  	        border-bottom:1px solid rgba(255,255,255,.065);
  	        background:#202620;
  	      }

  	      #${ROOT_ID} .fifcmp-section>header h4,
  	      #${ROOT_ID} .fifcmp-records>summary strong{
  	        display:block;
  	        margin-top:3px;
  	        color:#f2f5f3;
  	        font-size:15px;
  	      }

  	      #${ROOT_ID} .fifcmp-section>header p,
  	      #${ROOT_ID} .fifcmp-records>summary small{
  	        display:block;
  	        margin:3px 0 0;
  	        color:#89938d;
  	        font-size:10px;
  	      }

  	      #${ROOT_ID} .fifcmp-section>header b,
  	      #${ROOT_ID} .fifcmp-records>summary>b{
  	        display:grid;
  	        place-items:center;
  	        min-width:28px;
  	        height:28px;
  	        padding:0 8px;
  	        border:1px solid rgba(204,102,51,.24);
  	        border-radius:99px;
  	        color:#d58b61;
  	        background:rgba(204,102,51,.07);
  	        font-size:10px;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-grid{
  	        display:grid;
  	        grid-template-columns:repeat(auto-fit,minmax(285px,1fr));
  	        gap:8px;
  	        padding:10px;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-card{
  	        display:grid;
  	        gap:9px;
  	        min-width:0;
  	        padding:11px;
  	        border:1px solid rgba(255,255,255,.075);
  	        border-left:4px solid #7d8781;
  	        border-radius:10px;
  	        background:linear-gradient(145deg,#1b211c,#111612);
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-card.good{border-left-color:#55c98b}
  	      #${ROOT_ID} .fifcmp-dashboard-card.warn{border-left-color:#e4a24f}
  	      #${ROOT_ID} .fifcmp-dashboard-card.bad{border-left-color:#ef6761}

  	      #${ROOT_ID} .fifcmp-dashboard-top{
  	        display:flex;
  	        align-items:flex-start;
  	        justify-content:space-between;
  	        gap:10px;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-top span{
  	        display:block;
  	        color:#858f89;
  	        font-size:8px;
  	        font-weight:900;
  	        letter-spacing:.07em;
  	        text-transform:uppercase;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-top h5{
  	        margin:0;
  	        color:#f3f6f4;
  	        font-size:14px;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-card>p{
  	        min-height:28px;
  	        margin:0;
  	        color:#98a19b;
  	        font-size:10px;
  	        line-height:1.4;
  	      }

  	      #${ROOT_ID} .fifcmp-badge{
  	        display:inline-flex;
  	        align-items:center;
  	        justify-content:center;
  	        min-height:25px;
  	        padding:0 8px;
  	        border:1px solid rgba(255,255,255,.09);
  	        border-radius:99px;
  	        background:#151a16;
  	        color:#afb8b2;
  	        font-size:8px;
  	        font-weight:950;
  	        text-transform:uppercase;
  	        white-space:nowrap;
  	      }

  	      #${ROOT_ID} .fifcmp-badge.good{
  	        color:#7fe2ad;
  	        border-color:rgba(85,201,139,.28);
  	        background:rgba(85,201,139,.08);
  	      }

  	      #${ROOT_ID} .fifcmp-badge.warn{
  	        color:#f0b767;
  	        border-color:rgba(228,162,79,.28);
  	        background:rgba(228,162,79,.08);
  	      }

  	      #${ROOT_ID} .fifcmp-badge.bad{
  	        color:#f28a85;
  	        border-color:rgba(239,83,80,.28);
  	        background:rgba(239,83,80,.08);
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-evidence{
  	        display:grid;
  	        grid-template-columns:repeat(2,minmax(0,1fr));
  	        gap:6px;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-evidence>div{
  	        min-width:0;
  	        padding:7px 8px;
  	        border:1px solid rgba(255,255,255,.055);
  	        border-radius:8px;
  	        background:#111612;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-evidence span{
  	        display:block;
  	        color:#7e8881;
  	        font-size:8px;
  	        font-weight:900;
  	        text-transform:uppercase;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-evidence strong{
  	        display:block;
  	        margin-top:4px;
  	        color:#e5ebe6;
  	        font-size:10px;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-actions{
  	        display:flex;
  	        justify-content:flex-end;
  	      }

  	      #${ROOT_ID} .fifcmp-dashboard-actions button,
  	      #${ROOT_ID} .fifcmp-record-actions button{
  	        min-height:31px;
  	        padding:0 10px;
  	        border:1px solid rgba(204,102,51,.3);
  	        border-radius:8px;
  	        background:rgba(204,102,51,.08);
  	        color:#e1a07a;
  	        font:inherit;
  	        font-size:10px;
  	        font-weight:850;
  	        cursor:pointer;
  	      }

  	      #${ROOT_ID} .fifcmp-setup-empty{
  	        display:grid;
  	        justify-items:center;
  	        gap:7px;
  	        padding:34px 18px;
  	        text-align:center;
  	      }

  	      #${ROOT_ID} .fifcmp-setup-empty strong{
  	        color:#eef2ef;
  	        font-size:15px;
  	      }

  	      #${ROOT_ID} .fifcmp-setup-empty span{
  	        color:#87918b;
  	        font-size:11px;
  	      }

  	      #${ROOT_ID} .fifcmp-records>summary{
  	        display:grid;
  	        grid-template-columns:minmax(0,1fr) auto auto;
  	        align-items:center;
  	        gap:12px;
  	        min-height:61px;
  	        padding:10px 12px;
  	        list-style:none;
  	        cursor:pointer;
  	        background:#202620;
  	      }

  	      #${ROOT_ID} .fifcmp-records>summary::-webkit-details-marker{
  	        display:none;
  	      }

  	      #${ROOT_ID} .fifcmp-records>summary:after{
  	        content:"";
  	        width:9px;
  	        height:9px;
  	        border-right:2px solid #d18458;
  	        border-bottom:2px solid #d18458;
  	        transform:rotate(45deg);
  	      }

  	      #${ROOT_ID} .fifcmp-records[open]>summary:after{
  	        transform:rotate(225deg);
  	      }

  	      #${ROOT_ID} .fifcmp-record-body{
  	        border-top:1px solid rgba(255,255,255,.055);
  	      }

  	      #${ROOT_ID} .fifcmp-record-toolbar{
  	        display:grid;
  	        grid-template-columns:minmax(240px,1fr) auto auto;
  	        align-items:center;
  	        gap:8px;
  	        padding:9px;
  	        border-bottom:1px solid rgba(255,255,255,.055);
  	      }

  	      #${ROOT_ID} .fifcmp-search{
  	        position:relative;
  	      }

  	      #${ROOT_ID} .fifcmp-search svg{
  	        position:absolute;
  	        left:10px;
  	        top:50%;
  	        width:15px;
  	        height:15px;
  	        transform:translateY(-50%);
  	        fill:none;
  	        stroke:#7d8781;
  	        stroke-width:1.8;
  	      }

  	      #${ROOT_ID} .fifcmp-search input{
  	        width:100%;
  	        height:38px;
  	        padding:0 11px 0 34px;
  	        border:1px solid rgba(255,255,255,.09);
  	        border-radius:8px;
  	        background:#0b0f0c;
  	        color:#edf2ee;
  	        font:inherit;
  	        font-size:11px;
  	        outline:none;
  	      }

  	      #${ROOT_ID} .fifcmp-scopes{
  	        display:flex;
  	        gap:5px;
  	        flex-wrap:wrap;
  	      }

  	      #${ROOT_ID} .fifcmp-scopes button{
  	        min-height:33px;
  	        padding:0 9px;
  	        border:1px solid rgba(255,255,255,.08);
  	        border-radius:8px;
  	        background:#171d18;
  	        color:#949d97;
  	        font:inherit;
  	        font-size:10px;
  	        font-weight:850;
  	        cursor:pointer;
  	      }

  	      #${ROOT_ID} .fifcmp-scopes button.active{
  	        border-color:rgba(204,102,51,.5);
  	        color:#fff;
  	        background:rgba(204,102,51,.12);
  	        box-shadow:inset 0 -2px 0 #cc6633;
  	      }

  	      #${ROOT_ID} .fifcmp-count{
  	        color:#8c9690;
  	        font-size:10px;
  	        white-space:nowrap;
  	      }

  	      #${ROOT_ID} .fifcmp-record-grid{
  	        display:grid;
  	        grid-template-columns:repeat(auto-fit,minmax(320px,1fr));
  	        gap:8px;
  	        padding:10px;
  	      }

  	      #${ROOT_ID} .fifcmp-record-card{
  	        display:grid;
  	        gap:9px;
  	        min-width:0;
  	        padding:11px;
  	        border:1px solid rgba(255,255,255,.075);
  	        border-radius:10px;
  	        background:linear-gradient(145deg,#1b211c,#111612);
  	      }

  	      #${ROOT_ID} .fifcmp-record-top{
  	        display:flex;
  	        align-items:flex-start;
  	        justify-content:space-between;
  	        gap:10px;
  	      }

  	      #${ROOT_ID} .fifcmp-record-top h5{
  	        margin:0;
  	        color:#f2f5f3;
  	        font-size:13px;
  	      }

  	      #${ROOT_ID} .fifcmp-record-top small{
  	        display:block;
  	        margin-top:3px;
  	        color:#7f8982;
  	        font-size:9px;
  	      }

  	      #${ROOT_ID} .fifcmp-record-detail{
  	        display:grid;
  	        grid-template-columns:repeat(2,minmax(0,1fr));
  	        gap:6px;
  	      }

  	      #${ROOT_ID} .fifcmp-record-detail>div{
  	        min-width:0;
  	        padding:7px 8px;
  	        border:1px solid rgba(255,255,255,.055);
  	        border-radius:8px;
  	        background:#111612;
  	      }

  	      #${ROOT_ID} .fifcmp-record-detail span{
  	        display:block;
  	        color:#7f8982;
  	        font-size:8px;
  	        font-weight:900;
  	        text-transform:uppercase;
  	      }

  	      #${ROOT_ID} .fifcmp-record-detail strong{
  	        display:block;
  	        margin-top:4px;
  	        color:#e7ece8;
  	        font-size:10px;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }

  	      #${ROOT_ID} .fifcmp-record-actions{
  	        display:flex;
  	        justify-content:flex-end;
  	        gap:7px;
  	      }

  	      #${ROOT_ID} .fifcmp-empty{
  	        padding:30px 16px;
  	        color:#87918b;
  	        text-align:center;
  	        font-size:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifsp-modal.fifcmp-modal{
  	        width:min(960px,calc(100vw - 28px));
  	        max-height:calc(100vh - ${TOP_OFFSET_PX + 28}px);
  	        background:linear-gradient(145deg,#1b211c,#0c100d);
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-shell{
  	        width:min(1080px,calc(100vw - 28px));
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-modal{
  	        display:grid;
  	        gap:10px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-intro{
  	        display:flex;
  	        align-items:flex-end;
  	        justify-content:space-between;
  	        gap:14px;
  	        padding:11px 12px;
  	        border:1px solid rgba(255,255,255,.075);
  	        border-radius:10px;
  	        background:#161c17;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-intro>div>span{
  	        display:block;
  	        color:#d77d49;
  	        font-size:9px;
  	        font-weight:950;
  	        letter-spacing:.1em;
  	        text-transform:uppercase;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-intro>div>strong{
  	        display:block;
  	        margin-top:4px;
  	        color:#f2f5f3;
  	        font-size:15px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-intro p{
  	        margin:4px 0 0;
  	        color:#8d9791;
  	        font-size:10px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-intro>label{
  	        min-width:190px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-intro>label>span,
  	      #${SERVICE_MODAL_ID} .fifcmp-setup-expiry>span{
  	        display:block;
  	        margin-bottom:5px;
  	        color:#929c96;
  	        font-size:9px;
  	        font-weight:900;
  	        text-transform:uppercase;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-intro select,
  	      #${SERVICE_MODAL_ID} .fifcmp-setup-expiry input{
  	        width:100%;
  	        min-height:40px;
  	        border:1px solid rgba(255,255,255,.09);
  	        border-radius:8px;
  	        background:#0b0f0c;
  	        color:#edf2ee;
  	        padding:0 10px;
  	        font:inherit;
  	        font-size:11px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-groups{
  	        display:grid;
  	        gap:9px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-group,
  	      #${SERVICE_MODAL_ID} .fifcmp-setup-optional{
  	        border:1px solid rgba(255,255,255,.075);
  	        border-radius:10px;
  	        background:#151a16;
  	        overflow:hidden;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-group>header,
  	      #${SERVICE_MODAL_ID} .fifcmp-setup-optional>summary{
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        gap:12px;
  	        min-height:50px;
  	        padding:9px 11px;
  	        background:#1d231e;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-group h3,
  	      #${SERVICE_MODAL_ID} .fifcmp-setup-optional strong{
  	        margin:0;
  	        color:#f0f4f1;
  	        font-size:13px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-group p,
  	      #${SERVICE_MODAL_ID} .fifcmp-setup-optional span{
  	        margin:3px 0 0;
  	        color:#87918b;
  	        font-size:9px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-group>header>b,
  	      #${SERVICE_MODAL_ID} .fifcmp-setup-optional>summary>b{
  	        color:#d48a60;
  	        font-size:9px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-optional>summary{
  	        list-style:none;
  	        cursor:pointer;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-optional>summary::-webkit-details-marker{
  	        display:none;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-grid{
  	        display:grid;
  	        grid-template-columns:repeat(2,minmax(0,1fr));
  	        gap:7px;
  	        padding:8px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-card{
  	        display:grid;
  	        grid-template-columns:minmax(0,1fr) minmax(170px,.52fr);
  	        align-items:center;
  	        gap:10px;
  	        min-width:0;
  	        padding:10px;
  	        border:1px solid rgba(255,255,255,.065);
  	        border-radius:9px;
  	        background:#111612;
  	        opacity:.72;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-card.enabled{
  	        opacity:1;
  	        border-color:rgba(204,102,51,.28);
  	        background:rgba(204,102,51,.045);
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-choice{
  	        display:grid;
  	        grid-template-columns:22px minmax(0,1fr);
  	        gap:9px;
  	        align-items:start;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-choice input{
  	        width:18px;
  	        height:18px;
  	        margin:2px 0 0;
  	        accent-color:#cc6633;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-choice label{
  	        cursor:pointer;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-choice strong{
  	        display:block;
  	        color:#edf2ee;
  	        font-size:12px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-choice span{
  	        display:block;
  	        margin-top:4px;
  	        color:#8b958f;
  	        font-size:9px;
  	        line-height:1.4;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-choice small{
  	        display:block;
  	        margin-top:5px;
  	        color:#ca8c66;
  	        font-size:8px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-setup-expiry em{
  	        color:#6f7973;
  	        font-style:normal;
  	        text-transform:none;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-stepper{
  	        display:grid;
  	        grid-template-columns:repeat(3,minmax(0,1fr));
  	        gap:6px;
  	        margin-bottom:9px;
  	        padding:6px;
  	        border:1px solid rgba(255,255,255,.07);
  	        border-radius:9px;
  	        background:#111612;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-stepper button{
  	        display:flex;
  	        align-items:center;
  	        gap:8px;
  	        min-height:38px;
  	        padding:0 9px;
  	        border:1px solid transparent;
  	        border-radius:8px;
  	        background:transparent;
  	        color:#87918b;
  	        font:inherit;
  	        font-size:10px;
  	        font-weight:850;
  	        cursor:pointer;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-stepper button em{
  	        display:grid;
  	        place-items:center;
  	        width:21px;
  	        height:21px;
  	        border:1px solid rgba(255,255,255,.1);
  	        border-radius:99px;
  	        font-style:normal;
  	        font-size:9px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-stepper button.active{
  	        border-color:rgba(204,102,51,.4);
  	        background:rgba(204,102,51,.1);
  	        color:#fff;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-step-panel{
  	        display:none;
  	        padding:12px;
  	        border:1px solid rgba(255,255,255,.075);
  	        border-radius:10px;
  	        background:#161c17;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-step-panel.active{
  	        display:block;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-step-panel>header{
  	        margin-bottom:10px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-step-panel>header h3{
  	        margin:0;
  	        color:#f2f5f3;
  	        font-size:15px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-step-panel>header p{
  	        margin:4px 0 0;
  	        color:#8b958f;
  	        font-size:10px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-form .grid{
  	        display:grid;
  	        grid-template-columns:repeat(2,minmax(0,1fr));
  	        gap:8px;
  	      }

  	      #${SERVICE_MODAL_ID} .fifcmp-form .wide{
  	        grid-column:1/-1;
  	      }

  	      @media(max-width:1050px){
  	        #${ROOT_ID} .fifcmp-summary{
  	          grid-template-columns:repeat(2,minmax(0,1fr));
  	        }

  	        #${ROOT_ID} .fifcmp-record-toolbar{
  	          grid-template-columns:1fr;
  	        }

  	        #${SERVICE_MODAL_ID} .fifcmp-setup-grid{
  	          grid-template-columns:1fr;
  	        }
  	      }

  	      @media(max-width:700px){
  	        #${ROOT_ID} .fifcmp-head,
  	        #${SERVICE_MODAL_ID} .fifcmp-setup-intro{
  	          align-items:flex-start;
  	          flex-direction:column;
  	        }

  	        #${ROOT_ID} .fifcmp-summary,
  	        #${ROOT_ID} .fifcmp-dashboard-grid,
  	        #${ROOT_ID} .fifcmp-record-grid,
  	        #${ROOT_ID} .fifcmp-dashboard-evidence,
  	        #${ROOT_ID} .fifcmp-record-detail,
  	        #${SERVICE_MODAL_ID} .fifcmp-form .grid{
  	          grid-template-columns:1fr;
  	        }

  	        #${ROOT_ID} .fifcmp-records>summary{
  	          grid-template-columns:1fr auto;
  	        }

  	        #${ROOT_ID} .fifcmp-records>summary>b{
  	          display:none;
  	        }

  	        #${SERVICE_MODAL_ID} .fifcmp-setup-card{
  	          grid-template-columns:1fr;
  	        }

  	        #${SERVICE_MODAL_ID} .fifcmp-stepper{
  	          grid-template-columns:1fr;
  	        }
  	      }
  	    `;
  	    document.head.appendChild(style);
  	  }





  	  const V21_UOW_SCHEMA_CACHE = Object.create(null);

  	  function v21RawDatabaseApi() {
  	    const resolved = fifResolveDatabaseApi();
  	    return fifDatabaseRawApi || resolved || null;
  	  }

  	  function v21CreateUnitOfWork() {
  	    const api = v21RawDatabaseApi();
  	    const Constructor = api && api.UnitOfWork;
  	    if (typeof Constructor !== "function") return null;

  	    const unit = new Constructor();
  	    try {
  	      if (
  	        typeof unit.setIsolationLevel === "function" &&
  	        Constructor.IsolationLevelEnum &&
  	        Constructor.IsolationLevelEnum.REPEATABLE_READ
  	      ) {
  	        unit.setIsolationLevel(Constructor.IsolationLevelEnum.REPEATABLE_READ);
  	      }
  	    } catch (_) {}

  	    return { api: api, unit: unit };
  	  }



  	  function v21UowResultSuccess(result) {
  	    if (!result) return false;
  	    try {
  	      if (typeof result.isSuccess === "function") return result.isSuccess() === true;
  	    } catch (_) {}
  	    if (typeof result.success === "boolean") return result.success;
  	    return true;
  	  }

  	  function v21UowResultError(result) {
  	    if (!result) return new Error("The database transaction returned no result.");
  	    try {
  	      if (typeof result.getError === "function") {
  	        const error = result.getError();
  	        if (error) return error;
  	      }
  	    } catch (_) {}
  	    return result.error || new Error("The database transaction could not be completed.");
  	  }





  	  function maintenanceCategoryFromType(type, fallback) {
  	    if (clean(fallback)) return clean(fallback);
  	    if (V21_COMPLIANCE_TYPES.indexOf(clean(type)) !== -1) return V21_CATEGORY_COMPLIANCE;
  	    const serviceTypes = ["Scheduled Service",
  	      "Preventive Service",
  	      "Oil Service",
  	      "Major Service",
  	      "Minor Service",
  	      "Manufacturer Service",
  	      "Warranty Service",
  	      "Pre-delivery Inspection",
  	      "Post-repair Inspection"];
  	    return serviceTypes.indexOf(clean(type)) !== -1 ? MAINTENANCE_CATEGORY_SERVICE: MAINTENANCE_CATEGORY_MAINTENANCE;
  	  }

  	  function normalizeServiceWorkOrder(order) {
  	    order = order && typeof order === "object" ? cloneData(order): {};
  	    let data = order.Data && typeof order.Data === "object" ? cloneData(order.Data): {};
  	    if (typeof order.Data === "string") {
  	      try {
  	        data = JSON.parse(order.Data);
  	      } catch (_) {
  	        data = {};
  	      }
  	    }
  	    const type = clean(firstValue([order.Type, data.Type], "Scheduled Service"));
  	    const category = maintenanceCategoryFromType(type, firstValue([order.Category, data.Category], ""));
  	    const actualDirect = numberOr(firstValue([order.ActualCost, order.GrossAmount, data.ActualCost, data.GrossAmount], null), null);
  	    const componentTotal = [order.LabourCost,
  	      order.PartsCost,
  	      order.ExternalCost,
  	      order.OtherCost,
  	      data.LabourCost,
  	      data.PartsCost,
  	      data.ExternalCost,
  	      data.OtherCost].map(function (v) {
  	        return numberOr(v, 0);
  	      }).reduce(function (a, b) {
  	        return a+b;
  	      }, 0);
  	    const actual = actualDirect === null && componentTotal > 0 ? componentTotal: actualDirect;
  	    const vat = numberOr(firstValue([order.VATAmount, data.VATAmount], 0), 0);
  	    const net = numberOr(firstValue([order.NetAmount, data.NetAmount], actual === null ? null: Math.max(0, actual - vat)), null);
  	    const rawOperationalStatus = clean(firstValue([order.Status, data.Status], ""));
  	    return {
  	      objectId: clean(order.objectId || data.objectId || ""),
  	      WorkOrderId: clean(firstValue([order.WorkOrderId, order.RecordNumber, order.RecordId, order.Id, data.WorkOrderId], "")) || serviceId(category === V21_CATEGORY_COMPLIANCE ? "CMP": "WO"),
  	      RecordNumber: clean(firstValue([order.RecordNumber, order.WorkOrderId, data.RecordNumber], "")),
  	      CompanyObjectId: clean(firstValue([order.CompanyObjectId, data.CompanyObjectId], "")),
  	      CompanyId: clean(firstValue([order.CompanyId, data.CompanyId], "")),
  	      VehicleObjectId: clean(firstValue([order.VehicleObjectId, data.VehicleObjectId], "")),
  	      VehicleId: clean(firstValue([order.VehicleId, data.VehicleId], "")),
  	      Registration: clean(firstValue([order.Registration, data.Registration], "")),
  	      Category: category,
  	      Type: type,
  	      Title: clean(firstValue([order.Title, data.Title], type)),
  	      Priority: clean(firstValue([order.Priority, data.Priority], "Normal")),
  	      Status: category === V21_CATEGORY_COMPLIANCE ? clean(firstValue([order.Status, data.Status], "Active")) : serviceCanonicalStatus(firstValue([order.Status, data.Status], "Scheduled")),
  	      Source: clean(firstValue([order.Source, data.Source], "Vehicle Manager")),
  	      SourceTable: clean(firstValue([order.SourceTable, data.SourceTable], "")),
  	      SourceObjectId: clean(firstValue([order.SourceObjectId, data.SourceObjectId], "")),
  	      MYearKey: clean(firstValue([order.MYearKey, data.MYearKey], "")),
  	      ReportedDate: maintenanceDateInput(firstValue([order.ReportedDate, data.ReportedDate, order.Date, order.created], new Date())),
  	      ScheduledDate: maintenanceDateInput(firstValue([order.ScheduledDate, data.ScheduledDate], "")),
  	      StartedDate: maintenanceDateTimeInput(firstValue([order.StartedDate, data.StartedDate], "")),
  	      CompletedDate: maintenanceDateInput(firstValue([order.CompletedDate, data.CompletedDate], "")),
  	      IssueDate: maintenanceDateInput(firstValue([order.IssueDate, data.IssueDate], "")),
  	      EffectiveDate: maintenanceDateInput(firstValue([order.EffectiveDate, data.EffectiveDate], "")),
  	      ExpiryDate: maintenanceDateInput(firstValue([order.ExpiryDate, data.ExpiryDate], "")),
  	      RenewalDueDate: maintenanceDateInput(firstValue([order.RenewalDueDate, data.RenewalDueDate], "")),
  	      RenewedDate: maintenanceDateInput(firstValue([order.RenewedDate, data.RenewedDate], "")),
  	      PostingDate: maintenanceDateInput(firstValue([order.PostingDate, data.PostingDate], "")),
  	      Odometer: numberOr(firstValue([order.Odometer, data.Odometer], null), null),
  	      ProviderId: clean(firstValue([order.ProviderId, order.ServiceProviderId, data.ProviderId], "")),
  	      ProviderName: clean(firstValue([order.ProviderName, order.Provider, data.ProviderName], "")),
  	      Technician: clean(firstValue([order.Technician, data.Technician], "")),
  	      Issuer: clean(firstValue([order.Issuer, data.Issuer], "")),
  	      Authority: clean(firstValue([order.Authority, data.Authority], "")),
  	      ReferenceNumber: clean(firstValue([order.ReferenceNumber, order.Reference, data.ReferenceNumber], "")),
  	      CertificateNumber: clean(firstValue([order.CertificateNumber, data.CertificateNumber], "")),
  	      PolicyNumber: clean(firstValue([order.PolicyNumber, data.PolicyNumber], "")),
  	      PermitNumber: clean(firstValue([order.PermitNumber, data.PermitNumber], "")),
  	      Complaint: clean(firstValue([order.Complaint, data.Complaint], "")),
  	      Diagnosis: clean(firstValue([order.Diagnosis, data.Diagnosis], "")),
  	      WorkPerformed: clean(firstValue([order.WorkPerformed, data.WorkPerformed], "")),
  	      Parts: cloneData(firstValue([order.Parts, data.Parts], [])),
  	      Checklist: cloneData(firstValue([order.Checklist, data.Checklist], [])),
  	      EstimatedCost: numberOr(firstValue([order.EstimatedCost, data.EstimatedCost], null), null),
  	      LabourCost: numberOr(firstValue([order.LabourCost, data.LabourCost], null), null),
  	      PartsCost: numberOr(firstValue([order.PartsCost, data.PartsCost], null), null),
  	      ExternalCost: numberOr(firstValue([order.ExternalCost, data.ExternalCost], null), null),
  	      OtherCost: numberOr(firstValue([order.OtherCost, data.OtherCost], null), null),
  	      NetAmount: net,
  	      VATAmount: vat,
  	      VATRate: numberOr(firstValue([order.VATRate, data.VATRate], 15), 15),
  	      VATIncluded: firstValue([order.VATIncluded, data.VATIncluded], true) !== false,
  	      ActualCost: actual,
  	      Currency: clean(firstValue([order.Currency, data.Currency], "ZAR")) || "ZAR",
  	      PurchaseOrder: clean(firstValue([order.PurchaseOrder, data.PurchaseOrder], "")),
  	      InvoiceNumber: clean(firstValue([order.InvoiceNumber, data.InvoiceNumber], "")),
  	      DowntimeStart: maintenanceDateTimeInput(firstValue([order.DowntimeStart, data.DowntimeStart], "")),
  	      DowntimeEnd: maintenanceDateTimeInput(firstValue([order.DowntimeEnd, data.DowntimeEnd], "")),
  	      DowntimeHours: numberOr(firstValue([order.DowntimeHours, data.DowntimeHours], null), null),
  	      IsScheduled: firstValue([order.IsScheduled, data.IsScheduled], category === MAINTENANCE_CATEGORY_SERVICE) === true,
  	      IsWarranty: firstValue([order.IsWarranty, data.IsWarranty], false) === true,
  	      WarrantyReference: clean(firstValue([order.WarrantyReference, data.WarrantyReference], "")),
  	      RepeatRepair: firstValue([order.RepeatRepair, data.RepeatRepair], false) === true,
  	      Trigger: clean(firstValue([order.Trigger, data.Trigger], "")),
  	      SafeToOperate: firstValue([order.SafeToOperate, data.SafeToOperate], true) !== false,
  	      OperationalBlock: firstValue([order.OperationalBlock, data.OperationalBlock], false) === true,
  	      EstimatedAdditionalCost: numberOr(firstValue([order.EstimatedAdditionalCost, data.EstimatedAdditionalCost], null), null),
  	      ParentWorkOrderId: clean(firstValue([order.ParentWorkOrderId, order.PreviousRecordId, data.ParentWorkOrderId], "")),
  	      PreviousRecordId: clean(firstValue([order.PreviousRecordId, data.PreviousRecordId], "")),
  	      ComplianceStatus: clean(firstValue([order.ComplianceStatus, data.ComplianceStatus], "")),
  	      ComplianceResult: clean(firstValue([order.ComplianceResult, data.ComplianceResult], "")),
  	      ComplianceScope: clean(firstValue([order.ComplianceScope, data.ComplianceScope], "")),
  	      IsRenewal: firstValue([order.IsRenewal, data.IsRenewal], false) === true,
  	      NextServiceKm: numberOr(firstValue([order.NextServiceKm, data.NextServiceKm], null), null),
  	      NextServiceDate: maintenanceDateInput(firstValue([order.NextServiceDate, data.NextServiceDate], "")),
  	      PreventivePlanId: clean(firstValue([order.PreventivePlanId, data.PreventivePlanId], "")),
  	      PreventivePlanName: clean(firstValue([order.PreventivePlanName, data.PreventivePlanName], "")),
  	      PreventiveDueKM: numberOr(firstValue([order.PreventiveDueKM, data.PreventiveDueKM], null), null),
  	      PreventiveDueDate: maintenanceDateInput(firstValue([order.PreventiveDueDate, data.PreventiveDueDate], "")),
  	      GeneratedFromPreventivePlan: firstValue([order.GeneratedFromPreventivePlan, data.GeneratedFromPreventivePlan], false) === true,
  	      Documents: cloneData(firstValue([order.Documents, data.Documents], [])),
  	      Notes: clean(firstValue([data.Notes, order.Notes], "")),
  	      NoteLog: cloneData(firstValue([order.NoteLog, data.NoteLog], [])),
  	      ScheduleHistory: cloneData(firstValue([order.ScheduleHistory, data.ScheduleHistory], [])),
  	      RescheduleCount: numberOr(firstValue([order.RescheduleCount, data.RescheduleCount], 0), 0),
  	      LastRescheduledAt: clean(firstValue([order.LastRescheduledAt, data.LastRescheduledAt], "")),
  	      LastRescheduledBy: clean(firstValue([order.LastRescheduledBy, data.LastRescheduledBy], "")),
  	      ClosedAt: clean(firstValue([order.ClosedAt, data.ClosedAt], "")),
  	      ClosedBy: clean(firstValue([order.ClosedBy, data.ClosedBy], "")),
  	      ClosureReason: clean(firstValue([order.ClosureReason, data.ClosureReason], "")),
  	      WorkflowHistory: cloneData(firstValue([order.WorkflowHistory, data.WorkflowHistory], [])),
  	      CurrentPhaseEnteredAt: clean(firstValue([order.CurrentPhaseEnteredAt, data.CurrentPhaseEnteredAt], "")),
  	      CurrentPhaseEnteredBy: clean(firstValue([order.CurrentPhaseEnteredBy, data.CurrentPhaseEnteredBy], "")),
  	      BookingReference: clean(firstValue([order.BookingReference, data.BookingReference], "")),
  	      BookingConfirmedAt: clean(firstValue([order.BookingConfirmedAt, data.BookingConfirmedAt], "")),
  	      BookingConfirmedBy: clean(firstValue([order.BookingConfirmedBy, data.BookingConfirmedBy], "")),
  	      BookingReleasedAt: clean(firstValue([order.BookingReleasedAt, data.BookingReleasedAt], "")),
  	      BookingReleasedBy: clean(firstValue([order.BookingReleasedBy, data.BookingReleasedBy], "")),
  	      VehicleReceivedAt: clean(firstValue([order.VehicleReceivedAt, data.VehicleReceivedAt], "")),
  	      VehicleReceivedBy: clean(firstValue([order.VehicleReceivedBy, data.VehicleReceivedBy], "")),
  	      DelayReason: clean(firstValue([order.DelayReason, data.DelayReason], "")),
  	      DelayExpectedDate: maintenanceDateInput(firstValue([order.DelayExpectedDate, data.DelayExpectedDate], "")),
  	      DelayStartedAt: clean(firstValue([order.DelayStartedAt, data.DelayStartedAt], "")),
  	      DelayStartedBy: clean(firstValue([order.DelayStartedBy, data.DelayStartedBy], "")),
  	      DelayResolvedAt: clean(firstValue([order.DelayResolvedAt, data.DelayResolvedAt], "")),
  	      DelayResolvedBy: clean(firstValue([order.DelayResolvedBy, data.DelayResolvedBy], "")),
  	      ReadyAt: clean(firstValue([order.ReadyAt, data.ReadyAt], "")),
  	      ReadyBy: clean(firstValue([order.ReadyBy, data.ReadyBy], "")),
  	      CollectedAt: clean(firstValue([order.CollectedAt, data.CollectedAt], "")),
  	      CollectedBy: clean(firstValue([order.CollectedBy, data.CollectedBy], "")),
  	      CancelledAt: clean(firstValue([order.CancelledAt, data.CancelledAt], "")),
  	      CancelledBy: clean(firstValue([order.CancelledBy, data.CancelledBy], "")),
  	      CompletionCaptureMode: clean(firstValue([order.CompletionCaptureMode, data.CompletionCaptureMode], "")),
  	      LifecycleBypassed: firstValue([order.LifecycleBypassed, data.LifecycleBypassed], false) === true,
  	      LifecycleBypassFrom: clean(firstValue([order.LifecycleBypassFrom, data.LifecycleBypassFrom], "")),
  	      SARSCompliance: firstValue([order.SARSCompliance, data.SARSCompliance], false) === true,
  	      PotentialSARSRebate: numberOr(firstValue([order.PotentialSARSRebate, data.PotentialSARSRebate], null), null),
  	      Audit: cloneData(firstValue([order.Audit, data.Audit], {})),
  	      CreatedAt: firstValue([data.CreatedAt, order.CreatedAt, order.created], new Date().toISOString()),
  	      UpdatedAt: firstValue([data.UpdatedAt, order.UpdatedAt, order.updated], new Date().toISOString()),
  	      CreatedBy: clean(firstValue([data.CreatedBy, order.CreatedBy], userDisplayName())),
  	      UpdatedBy: clean(firstValue([data.UpdatedBy, order.UpdatedBy], userDisplayName())),
  	      created: order.created,
  	      updated: order.updated
  	    };
  	  }

  	  function maintenanceRowPayload(company, vehicle, order) {
  	    order = normalizeServiceWorkOrder(order);
  	    const reported = order.ReportedDate || new Date().toISOString().slice(0, 10);
  	    const periodDate = order.PostingDate || order.CompletedDate || order.EffectiveDate || order.ScheduledDate || reported;
  	    const start = maintenanceDateForSave(order.DowntimeStart),
  	    end = maintenanceDateForSave(order.DowntimeEnd);
  	    const downtime = start && end ? Math.max(0, (end.getTime()-start.getTime())/3600000): order.DowntimeHours;
  	    const fullNotes = clean(order.Notes);
  	    const noteLog = serviceAuditNoteLog(order);
  	    const notesSummary = maintenanceNotesSummary(order, 240);
  	    const payload = {
  	      WorkOrderId: order.WorkOrderId,
  	      RecordNumber: order.RecordNumber || order.WorkOrderId,
  	      CompanyObjectId: clean(company && company.objectId),
  	      CompanyId: clean(firstValue([company && company.CompanyId, companyName(company)], "")),
  	      VehicleObjectId: objectIdOf(vehicle),
  	      AssetType: assetIsTrailer(vehicle) ? "Trailer" : "Tractor",
  	      VehicleId: vehicleTitleValue(vehicle),
  	      Registration: vehicleRegistrationValue(vehicle),
  	      Category: order.Category,
  	      Type: order.Type,
  	      Title: order.Title,
  	      Status: order.Status,
  	      Priority: order.Priority,
  	      Source: order.Source,
  	      SourceTable: order.SourceTable,
  	      SourceObjectId: order.SourceObjectId,
  	      MYearKey: maintenanceYearKey(periodDate),
  	      ReportedDate: maintenanceDateForSave(reported),
  	      ScheduledDate: maintenanceDateForSave(order.ScheduledDate),
  	      StartedDate: maintenanceDateForSave(order.StartedDate),
  	      CompletedDate: maintenanceDateForSave(order.CompletedDate),
  	      IssueDate: maintenanceDateForSave(order.IssueDate),
  	      EffectiveDate: maintenanceDateForSave(order.EffectiveDate),
  	      ExpiryDate: maintenanceDateForSave(order.ExpiryDate),
  	      RenewalDueDate: maintenanceDateForSave(order.RenewalDueDate),
  	      RenewedDate: maintenanceDateForSave(order.RenewedDate),
  	      PostingDate: maintenanceDateForSave(order.PostingDate || periodDate),
  	      Odometer: order.Odometer,
  	      ProviderId: order.ProviderId,
  	      ProviderName: order.ProviderName,
  	      Technician: order.Technician,
  	      Issuer: order.Issuer,
  	      Authority: order.Authority,
  	      ReferenceNumber: order.ReferenceNumber,
  	      CertificateNumber: order.CertificateNumber,
  	      PolicyNumber: order.PolicyNumber,
  	      PermitNumber: order.PermitNumber,
  	      Complaint: order.Complaint,
  	      Diagnosis: order.Diagnosis,
  	      WorkPerformed: order.WorkPerformed,
  	      Parts: cloneData(order.Parts || []),
  	      Checklist: cloneData(order.Checklist || []),
  	      EstimatedCost: order.EstimatedCost,
  	      LabourCost: order.LabourCost,
  	      PartsCost: order.PartsCost,
  	      ExternalCost: order.ExternalCost,
  	      OtherCost: order.OtherCost,
  	      NetAmount: order.NetAmount,
  	      VATAmount: order.VATAmount,
  	      VATRate: order.VATRate,
  	      VATIncluded: order.VATIncluded,
  	      ActualCost: order.ActualCost,
  	      Currency: order.Currency,
  	      PurchaseOrder: order.PurchaseOrder,
  	      InvoiceNumber: order.InvoiceNumber,
  	      DowntimeStart: start,
  	      DowntimeEnd: end,
  	      DowntimeHours: downtime,
  	      IsScheduled: order.IsScheduled,
  	      IsWarranty: order.IsWarranty,
  	      WarrantyReference: order.WarrantyReference,
  	      RepeatRepair: order.RepeatRepair,
  	      ParentWorkOrderId: order.ParentWorkOrderId,
  	      PreviousRecordId: order.PreviousRecordId,
  	      ComplianceStatus: order.ComplianceStatus,
  	      ComplianceResult: order.ComplianceResult,
  	      ComplianceScope: order.ComplianceScope,
  	      IsRenewal: order.IsRenewal,
  	      NextServiceKm: order.NextServiceKm,
  	      NextServiceDate: maintenanceDateForSave(order.NextServiceDate),
  	      SARSCompliance: order.SARSCompliance,
  	      PotentialSARSRebate: order.PotentialSARSRebate,
  	      Documents: cloneData(order.Documents || []),
  	      Notes: notesSummary,
  	      Audit: Object.assign({}, order.Audit || {}, {
  	        CreatedAt: order.CreatedAt, CreatedBy: order.CreatedBy, UpdatedAt: new Date().toISOString(), UpdatedBy: userDisplayName()
  	      }),
  	      Data: {
  	        SchemaVersion: VERSION,
  	        NotesStorage: "Data.NoteLog",
  	        NotesSummaryLimit: 240,
  	        Category: order.Category,
  	        Type: order.Type,
  	        Notes: fullNotes,
  	        NoteLog: cloneData(noteLog),
  	        ScheduleHistory: cloneData(order.ScheduleHistory || []),
  	        RescheduleCount: numberOr(order.RescheduleCount, 0),
  	        LastRescheduledAt: order.LastRescheduledAt,
  	        LastRescheduledBy: order.LastRescheduledBy,
  	        ClosedAt: order.ClosedAt,
  	        ClosedBy: order.ClosedBy,
  	        ClosureReason: order.ClosureReason,
  	        WorkflowHistory: cloneData(order.WorkflowHistory || []),
  	        CurrentPhaseEnteredAt: order.CurrentPhaseEnteredAt,
  	        CurrentPhaseEnteredBy: order.CurrentPhaseEnteredBy,
  	        BookingReference: order.BookingReference,
  	        BookingConfirmedAt: order.BookingConfirmedAt,
  	        BookingConfirmedBy: order.BookingConfirmedBy,
  	        BookingReleasedAt: order.BookingReleasedAt,
  	        BookingReleasedBy: order.BookingReleasedBy,
  	        VehicleReceivedAt: order.VehicleReceivedAt,
  	        VehicleReceivedBy: order.VehicleReceivedBy,
  	        DelayReason: order.DelayReason,
  	        DelayExpectedDate: order.DelayExpectedDate,
  	        DelayStartedAt: order.DelayStartedAt,
  	        DelayStartedBy: order.DelayStartedBy,
  	        DelayResolvedAt: order.DelayResolvedAt,
  	        DelayResolvedBy: order.DelayResolvedBy,
  	        ReadyAt: order.ReadyAt,
  	        ReadyBy: order.ReadyBy,
  	        CollectedAt: order.CollectedAt,
  	        CollectedBy: order.CollectedBy,
  	        CancelledAt: order.CancelledAt,
  	        CancelledBy: order.CancelledBy,
  	        CompletionCaptureMode: order.CompletionCaptureMode,
  	        LifecycleBypassed: order.LifecycleBypassed === true,
  	        LifecycleBypassFrom: order.LifecycleBypassFrom,
  	        Trigger: order.Trigger,
  	        PreventivePlanId: order.PreventivePlanId,
  	        PreventivePlanName: order.PreventivePlanName,
  	        PreventiveDueKM: order.PreventiveDueKM,
  	        PreventiveDueDate: order.PreventiveDueDate,
  	        GeneratedFromPreventivePlan: order.GeneratedFromPreventivePlan === true,
  	        SafeToOperate: order.SafeToOperate !== false,
  	        OperationalBlock: order.OperationalBlock === true,
  	        EstimatedAdditionalCost: order.EstimatedAdditionalCost,
  	        CreatedAt: order.CreatedAt,
  	        CreatedBy: order.CreatedBy,
  	        UpdatedAt: new Date().toISOString(),
  	        UpdatedBy: userDisplayName()
  	      }
  	    };
  	    if (order.objectId) payload.objectId = order.objectId;
  	    return payload;
  	  }

  	  function serviceRecords(vehicle) {
  	    return maintenanceRowsForVehicle(vehicle).filter(function(r) {
  	      return r.Category === MAINTENANCE_CATEGORY_SERVICE && lower(r.Status) === "completed";
  	    }).map(function(r) {
  	      return {
  	        Date: r.CompletedDate || r.ReportedDate, Type: r.Type, Provider: r.ProviderName, Odometer: r.Odometer, Cost: r.ActualCost, Notes: r.Notes || r.WorkPerformed || r.Complaint, WorkOrderId: r.WorkOrderId, objectId: r.objectId
  	      };
  	    });
  	  }
  	  function maintenanceRecords(vehicle) {
  	    return maintenanceRowsForVehicle(vehicle).filter(function(r) {
  	      return r.Category === MAINTENANCE_CATEGORY_MAINTENANCE;
  	    });
  	  }
  	  function complianceRecords(vehicle) {
  	    return maintenanceRowsForVehicle(vehicle).filter(function(r) {
  	      return r.Category === V21_CATEGORY_COMPLIANCE;
  	    });
  	  }
  	  function vehicleMaintenanceOrders(vehicle) {
  	    return maintenanceRecords(vehicle);
  	  }







  	  const WORKSHOP_VEHICLE_STATUS_PHASES = ["In Progress", "Waiting Parts", "Ready"];






















  	async function saveMaintenanceRecord(company, vehicle, order, options) {
  	    options = options || {};
  	    if (!company || !vehicle || !vehicle.objectId) throw new Error("The selected vehicle does not contain an objectId.");
  	    refreshCurrentUserPermissions(false);
  	    const incomingCategory = clean(order && order.Category);
  	    if (incomingCategory === V21_CATEGORY_COMPLIANCE) {
  	      fifRequirePermission(userCanAccessAsset(vehicle) && CAN_EDIT_COMPLIANCE, "Compliance editing is not assigned.");
  	    } else if (incomingCategory === MAINTENANCE_CATEGORY_SERVICE) {
  	      fifRequirePermission(userCanAccessAssetFunction(vehicle, "Service") && CAN_MANAGE_SERVICE, "Service functionality is not assigned.");
  	    } else {
  	      fifRequirePermission(userCanAccessAssetFunction(vehicle, "Maintenance") && CAN_MANAGE_MAINTENANCE, "Maintenance functionality is not assigned.");
  	    }
  	    const databaseApi = await fifWaitForDatabaseApi(1800);
  	    if (!databaseApi || !databaseApi.Data || typeof databaseApi.Data.of !== "function") {
  	      throw new Error("The database connection is not ready. The workshop record was not changed.");
  	    }
  	    const previous = order && (order.objectId || order.WorkOrderId) ? serviceWorkOrderById(company, order.objectId || order.WorkOrderId): null;
  	    const normalizedIncoming = normalizeServiceWorkOrder(order);

  	    if (previous && [MAINTENANCE_CATEGORY_SERVICE, MAINTENANCE_CATEGORY_MAINTENANCE].indexOf(previous.Category) !== -1) {
  	      if (!serviceAuditLogIsPrefix(previous, normalizedIncoming)) {
  	        throw new Error("Workshop notes are append-only. Existing audit entries may not be changed, reordered or removed; add a new note instead.");
  	      }

  	      if (serviceJobRequiresReschedule(previous) && clean(previous.ScheduledDate) !== clean(normalizedIncoming.ScheduledDate)) {
  	        const history = serviceScheduleAudit(normalizedIncoming);
  	        const audited = history.some(function (entry) {
  	          return clean(entry.PreviousDate) === clean(previous.ScheduledDate) && clean(entry.NewDate) === clean(normalizedIncoming.ScheduledDate) && clean(entry.Reason);
  	        });
  	        if (!audited) throw new Error("A scheduled service or maintenance job cannot be moved by editing its date. Use Reschedule and record the reason.");
  	      }

  	      const previousPhase = serviceCanonicalStatus(previous.Status);
  	      const incomingPhase = serviceCanonicalStatus(normalizedIncoming.Status);
  	      if (previousPhase !== incomingPhase) {
  	        const history = serviceWorkflowHistory(normalizedIncoming);
  	        const latest = history.length ? history[history.length - 1] : null;
  	        const retrospectiveCompletion = incomingPhase === "Completed"
  	          && normalizedIncoming.CompletionCaptureMode === "Retrospective"
  	          && normalizedIncoming.LifecycleBypassed === true
  	          && latest
  	          && latest.Mode === "Completed service capture"
  	          && latest.Evidence
  	          && latest.Evidence.BypassLifecycle === true;
  	        if (serviceAllowedTransitions(previousPhase).indexOf(incomingPhase) === -1 && !retrospectiveCompletion) {
  	          throw new Error(servicePhaseLabel(previousPhase) + " cannot move directly to " + servicePhaseLabel(incomingPhase) + ".");
  	        }
  	        if (!latest || latest.From !== previousPhase || latest.To !== incomingPhase || !latest.At || !latest.By || !latest.Note) {
  	          throw new Error("The workshop phase change is missing its permanent audit entry. Use Update Phase rather than editing Status.");
  	        }
  	      }

  	      if (incomingPhase === "Completed" && previousPhase !== "Completed" && (!clean(normalizedIncoming.ClosedAt) || !clean(normalizedIncoming.WorkPerformed) || normalizedIncoming.Odometer === null)) {
  	        throw new Error("Completion requires work performed, final odometer and closure audit details.");
  	      }
  	      if (incomingPhase === "Cancelled" && previousPhase !== "Cancelled" && (!clean(normalizedIncoming.ClosedAt) || !clean(normalizedIncoming.ClosureReason))) {
  	        throw new Error("Cancellation requires a permanent reason and closure audit.");
  	      }
  	    }

  	    const payload = maintenanceRowPayload(company, vehicle, normalizedIncoming);
  	    let saved = null;
  	    let relationStageComplete = false;
  	    let servicePositionUpdated = true;
  	    state.serviceSaving = true;
  	    state.serviceStatus = "Saving...";
  	    render();
  	    const operation = options.operation || fifBeginSaveOperation(order.Category === V21_CATEGORY_COMPLIANCE ? "Saving compliance record…" : order.Category === MAINTENANCE_CATEGORY_SERVICE ? "Saving service record…" : "Saving maintenance record…");

  	    try {
  	      const savedRaw = await databaseApi.Data.of(MAINTENANCE_TABLE).save(payload);
  	      fifUpdateSaveOperation("Linking the saved record to its company, asset and period…");
  	      const savedCandidate = normalizeServiceWorkOrder(Object.assign({}, payload, savedRaw || {}));
  	      saved = fifReconcileCompanyCollection(
  	        company,
  	        MAINTENANCE_TABLE,
  	        previous || null,
  	        payload,
  	        savedCandidate,
  	        { pushMissing: true, createMissing: true }
  	      );

  	      upsertMaintenanceLocal(vehicle, saved);
  	      state.maintenanceLoaded[maintenanceCacheKey(vehicle)] = true;

  	      render();

  	      await addMaintenanceRelations(vehicle, savedRaw || saved, saved.PostingDate || saved.CompletedDate || saved.EffectiveDate || saved.ReportedDate);
  	      await v21AddMaintenanceOwnershipRelations(company, vehicle, savedRaw || saved, saved.PostingDate || saved.CompletedDate || saved.EffectiveDate || saved.ReportedDate);
  	      await v21LinkMaintenanceLineage(company, saved);
  	      relationStageComplete = true;

  	      servicePositionUpdated = await updateVehicleServicePositionFromRecord(company, vehicle, saved);

  	      state.serviceSaving = false;
  	      state.serviceStatus = !servicePositionUpdated ? "Saved · Service position update incomplete" : "Saved";
  	      fifCompleteSaveOperation(operation, "Workshop record saved.");
  	      render();

  	      if (options.message) {
  	        let completionMessage = options.message;
  	        let completionType = "success";
  	        if (!servicePositionUpdated && saved.Category === MAINTENANCE_CATEGORY_SERVICE && lower(saved.Status) === "completed") {
  	          completionMessage += " The completed service record was saved, but the vehicle's current service position was not changed because that separate vehicle save failed.";
  	          completionType = "warning";
  	        }
  	        await fifAlert(completionMessage, {
  	          title: options.title || "Maintenance Record Saved",
  	          type: completionType,
  	          confirmText: "Done"
  	        });
  	      }
  	      return saved;
  	    } catch (error) {
  	      state.serviceSaving = false;
  	      fifFailSaveOperation(operation, error);
  	      const rawMessage = error && (error.message || error.faultString) ? (error.message || error.faultString): "The maintenance record could not be saved.";
  	      if (saved && saved.objectId && !relationStageComplete) {
  	        state.serviceStatus = "Record saved · Relations incomplete";
  	        upsertMaintenanceLocal(vehicle, saved);
  	        render();
  	        throw new Error(saved.WorkOrderId + " was saved in Maintenance, but one or more required ownership relations failed. The saved object remains in App Data and can be reopened and retried without creating a duplicate. " + rawMessage);
  	      }
  	      state.serviceStatus = "Save failed";
  	      render();

  	      if (/data too long|value too long|exceeds.{0,30}(length|size)|too many characters/i.test(rawMessage)) {
  	        throw new Error("A database summary field exceeded its safe length. Permanent workshop notes are stored in the structured audit log and the ordinary Notes field is now limited to a short summary. Retry this phase change.");
  	      }

  	      if (/unknown column|column.{0,30}(not found|does not exist|unknown)|unknown property|relation.{0,20}column|schema.{0,30}(missing|relation)/i.test(rawMessage)) {
  	        throw new Error(rawMessage + " Automatic relation-column creation was attempted. Check database permissions only if the qualified relation retry was rejected.");
  	      }

  	      throw error;
  	    }
  	  }

  	  function v21ComplianceStatus(record, vehicle) {
  	    const fixed = clean(record.Status || record.ComplianceStatus);
  	    if (["Failed", "Rejected", "Cancelled", "Renewed"].indexOf(fixed) !== -1) return fixed;
  	    const activeVehicle = vehicle || selectedVehicle(selectedCompany());
  	    const warningDays = Math.max(1, numberOr(descriptorValue(v21ComplianceSetupRoot(activeVehicle).WarningDays), 60));
  	    const expiry = record.ExpiryDate ? new Date(record.ExpiryDate + "T23:59:59") : null;
  	    if (expiry && !Number.isNaN(expiry.getTime())) {
  	      const days = (expiry.getTime() - Date.now()) / 86400000;
  	      if (days < 0) return "Expired";
  	      if (days <= warningDays) return "Due Soon";
  	    }
  	    return fixed || "Active";
  	  }

  	  function v21FilteredCompliance(vehicle) {
  	    const q=lower(state.complianceSearch), scope=clean(state.complianceStatusFilter || "all");
  	    const rows=complianceRecords(vehicle).map(function(record){ const normalized=normalizeServiceWorkOrder(record); normalized.DisplayStatus=v21ComplianceStatus(normalized); return normalized; }).filter(function(record){
  	      const status=record.DisplayStatus;
  	      if (scope === "attention" && !v21ComplianceIsAttentionStatus(status)) return false;
  	      if (scope === "current" && !v21ComplianceIsCurrentStatus(status)) return false;
  	      if (scope === "history" && !v21ComplianceIsHistoryStatus(status)) return false;
  	      if (["all","attention","current","history"].indexOf(scope) === -1 && status !== scope) return false;
  	      if (q && lower([record.WorkOrderId,record.Type,v21ComplianceReferenceValue(record),record.ProviderName,record.Issuer,record.Authority,record.Notes].join(" ")).indexOf(q) === -1) return false;
  	      return true;
  	    });
  	    const priority={Failed:0,Rejected:1,Expired:2,"Due Soon":3,Submitted:4,Active:5,Issued:6,Renewed:7,Cancelled:8};
  	    rows.sort(function(a,b){ const sd=numberOr(priority[v21ComplianceStatus(a)],99)-numberOr(priority[v21ComplianceStatus(b)],99); if(sd)return sd; const ed=v21ComplianceExpiryTime(a)-v21ComplianceExpiryTime(b); return ed || naturalCompare(a.Type,b.Type); });
  	    return rows;
  	  }



  	  function v21ComplianceStatusTone(status) {
  	    status = clean(status);
  	    if (["Failed", "Rejected", "Expired"].indexOf(status) !== -1) return "bad";
  	    if (status === "Due Soon" || status === "Submitted") return "warn";
  	    if (["Active", "Issued"].indexOf(status) !== -1) return "good";
  	    return "neutral";
  	  }
  	  function v21ComplianceIsAttentionStatus(status) { return ["Due Soon", "Expired", "Failed", "Rejected"].indexOf(clean(status)) !== -1; }
  	  function v21ComplianceIsCurrentStatus(status) { return ["Active", "Issued", "Submitted"].indexOf(clean(status)) !== -1; }
  	  function v21ComplianceIsHistoryStatus(status) { return ["Renewed", "Cancelled"].indexOf(clean(status)) !== -1; }
  	  function v21ComplianceExpiryTime(record) { const date = fifAlertDate(record && record.ExpiryDate); return date && !Number.isNaN(date.getTime()) ? date.getTime() : Number.MAX_SAFE_INTEGER; }
  	  function v21ComplianceReferenceValue(record) { return clean(firstValue([record && record.ReferenceNumber, record && record.CertificateNumber, record && record.PolicyNumber, record && record.PermitNumber], "")); }
  	  function v21ComplianceReferenceProperty(type) {
  	    type = clean(type);
  	    if (["Vehicle Licence", "Operating Permit", "Cross-border Permit", "Dangerous Goods"].indexOf(type) !== -1) return "PermitNumber";
  	    if (type === "Insurance") return "PolicyNumber";
  	    if (["Certificate of Fitness", "Roadworthy", "Load Test", "Calibration", "Fire Extinguisher", "Tracking Certificate"].indexOf(type) !== -1) return "CertificateNumber";
  	    return "ReferenceNumber";
  	  }
  	  function v21ComplianceRequirementEntries(vehicle, source) {
  	    const data = getDeep(source || vehicle, ["Data", "Compliance"], {}) || {};
  	    const entries = [];
  	    const seen = Object.create(null);

  	    function walk(node, path, group) {
  	      if (node === null || node === undefined || Array.isArray(node)) return;
  	      if (isObject(node) && (node.hidden === true || node.visible === false || node.applicable === false)) return;

  	      const wrapped = isObject(node) && Object.prototype.hasOwnProperty.call(node, "value");
  	      if (typeof node !== "object" || wrapped) {
  	        const value = wrapped ? node.value : node;
  	        const key = path[path.length - 1] || "Requirement";
  	        const normalised = lower(
  	          prettyFieldName(key).replace(/[^a-z0-9]+/g, " ")
  	        ).trim();
  	        const identity = normalised + "|" + clean(value);
  	        if (seen[identity]) return;
  	        seen[identity] = true;
  	        entries.push({
  	          key: key,
  	          label: prettyFieldName(key),
  	          group: group || "General",
  	          path: path,
  	          value: value,
  	          node: node,
  	          selector: clean(
  	            wrapped && node.selector
  	              ? node.selector
  	              : typeof value === "boolean"
  	                ? "boolean"
  	                : typeof value === "number"
  	                  ? "number"
  	                  : "text"
  	          ).toLowerCase()
  	        });
  	        return;
  	      }

  	      Object.keys(node).forEach(function (key) {
  	        if (["ComplianceRecords", "Records", "Setup"].indexOf(key) !== -1) return;
  	        walk(
  	          node[key],
  	          path.concat([key]),
  	          path.length === 2 ? prettyFieldName(key) : group
  	        );
  	      });
  	    }

  	    walk(data, ["Data", "Compliance"], "General");
  	    return entries;
  	  }

  	  function v21ComplianceNormalise(value) {
  	    return clean(value).toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  	  }

  	  function v21ComplianceReadPath(vehicle, path) {
  	    return descriptorValue(getDeep(vehicle, path, null));
  	  }

  	  function v21ComplianceWritePath(draft, path, value) {
  	    const current = getDeep(draft, path, undefined);
  	    if (
  	      isObject(current) &&
  	      Object.prototype.hasOwnProperty.call(current, "value")
  	    ) {
  	      current.value = value;
  	      return;
  	    }
  	    setByPath(draft, path, value);
  	  }

  	  function v21ComplianceSetupRoot(vehicle) {
  	    return getDeep(vehicle, ["Data", "Compliance", "Setup"], {}) || {};
  	  }

  	  function v21ComplianceSetupRequirement(vehicle, key) {
  	    return getDeep(
  	      vehicle,
  	      ["Data", "Compliance", "Setup", "Requirements", key],
  	      {}
  	    ) || {};
  	  }

  	  function v21ComplianceDefinitionMatchesEntry(definition, entry) {
  	    if (!definition || !entry) return false;
  	    const text = v21ComplianceNormalise(
  	      [entry.group, entry.label, entry.key, arr(entry.path).join(" ")].join(" ")
  	    );
  	    return arr(definition.aliases).some(function (alias) {
  	      return text.indexOf(v21ComplianceNormalise(alias)) !== -1;
  	    });
  	  }

  	  function v21ComplianceMatchingLegacyEntries(vehicle, definition) {
  	    return v21ComplianceRequirementEntries(vehicle, vehicle).filter(function (entry) {
  	      return v21ComplianceDefinitionMatchesEntry(definition, entry);
  	    });
  	  }

  	  function v21ComplianceLegacyExpiry(vehicle, definition) {
  	    let value = "";
  	    arr(definition.expiryPaths).some(function (path) {
  	      const candidate = clean(v21ComplianceReadPath(vehicle, path));
  	      if (!candidate) return false;
  	      value = candidate;
  	      return true;
  	    });
  	    if (value) return value;

  	    const entry = v21ComplianceMatchingLegacyEntries(vehicle, definition).find(function (candidate) {
  	      return candidate.selector === "date" || /expiry|renewal|date/i.test(candidate.key);
  	    });
  	    return entry ? clean(entry.value) : "";
  	  }

  	  function v21ComplianceLegacyRequired(vehicle, definition) {
  	    const entries = v21ComplianceMatchingLegacyEntries(vehicle, definition);
  	    if (entries.some(function (entry) {
  	      return typeof entry.value === "boolean" && entry.value === true;
  	    })) return true;
  	    return entries.some(function (entry) {
  	      return clean(entry.value) !== "" && entry.value !== false;
  	    });
  	  }

  	  function v21ComplianceRecordMatchesDefinition(record, definition) {
  	    const type = v21ComplianceNormalise(record && record.Type);
  	    if (!type) return false;

  	    if (definition.key === "ROPSInspection") {
  	      return /rops|rollover protection/.test(
  	        v21ComplianceNormalise(
  	          [record.Type, record.Title, record.Description, record.Notes].join(" ")
  	        )
  	      );
  	    }
  	    if (definition.key === "PTOGuardInspection") {
  	      return /pto.*guard|guard.*pto/.test(
  	        v21ComplianceNormalise(
  	          [record.Type, record.Title, record.Description, record.Notes].join(" ")
  	        )
  	      );
  	    }

  	    return arr(definition.recordTypes).some(function (recordType) {
  	      return type === v21ComplianceNormalise(recordType);
  	    });
  	  }

  	  function v21ComplianceLatestRecord(vehicle, definition) {
  	    const rows = complianceRecords(vehicle)
  	      .map(normalizeServiceWorkOrder)
  	      .filter(function (record) {
  	        return v21ComplianceRecordMatchesDefinition(record, definition);
  	      })
  	      .sort(function (left, right) {
  	        const leftCurrent = ["Renewed", "Cancelled"].indexOf(
  	          v21ComplianceStatus(left)
  	        ) === -1 ? 1 : 0;
  	        const rightCurrent = ["Renewed", "Cancelled"].indexOf(
  	          v21ComplianceStatus(right)
  	        ) === -1 ? 1 : 0;
  	        if (leftCurrent !== rightCurrent) return rightCurrent - leftCurrent;

  	        const leftDate = new Date(
  	          left.IssueDate ||
  	          left.EffectiveDate ||
  	          left.ReportedDate ||
  	          left.updated ||
  	          left.created ||
  	          0
  	        ).getTime();
  	        const rightDate = new Date(
  	          right.IssueDate ||
  	          right.EffectiveDate ||
  	          right.ReportedDate ||
  	          right.updated ||
  	          right.created ||
  	          0
  	        ).getTime();
  	        return rightDate - leftDate;
  	      });

  	    return rows[0] || null;
  	  }

  	  function v21ComplianceDefinitionRequired(vehicle, definition) {
  	    const setup = v21ComplianceSetupRequirement(vehicle, definition.key);
  	    const configured = v21ComplianceSetupRoot(vehicle).Configured === true;
  	    if (configured && typeof setup.Required === "boolean") return setup.Required;
  	    if (configured) return false;

  	    if (v21ComplianceLegacyRequired(vehicle, definition)) return true;
  	    if (v21ComplianceLatestRecord(vehicle, definition)) return true;

  	    const context = adaptiveProfileContext(vehicle);
  	    return typeof definition.recommended === "function"
  	      ? definition.recommended(context) === true
  	      : false;
  	  }

  	  function v21ComplianceDefinitionExpiry(vehicle, definition, record) {
  	    if (record && clean(record.ExpiryDate)) return clean(record.ExpiryDate);

  	    const setup = v21ComplianceSetupRequirement(vehicle, definition.key);
  	    if (clean(setup.ExpiryDate)) return clean(setup.ExpiryDate);

  	    return v21ComplianceLegacyExpiry(vehicle, definition);
  	  }

  	  function v21ComplianceDefinitionRecordType(vehicle, definition) {
  	    if (definition.key === "Roadworthiness") {
  	      const context = adaptiveProfileContext(vehicle);
  	      return context.commercial || context.heavy
  	        ? "Certificate of Fitness"
  	        : "Roadworthy";
  	    }
  	    if (definition.key === "ROPSInspection") return "Other Compliance";
  	    if (definition.key === "PTOGuardInspection") return "Other Compliance";
  	    return arr(definition.recordTypes)[0] || "Other Compliance";
  	  }

  	  function v21ComplianceDashboardItemFromDefinition(vehicle, definition) {
  	    const required = v21ComplianceDefinitionRequired(vehicle, definition);
  	    const record = v21ComplianceLatestRecord(vehicle, definition);
  	    const expiryDate = v21ComplianceDefinitionExpiry(vehicle, definition, record);
  	    const warningDays = Math.max(
  	      1,
  	      numberOr(v21ComplianceSetupRoot(vehicle).WarningDays, 60)
  	    );
  	    const fixedStatus = record ? v21ComplianceStatus(record) : "";
  	    const days = expiryDate ? fifDaysUntil(expiryDate) : null;

  	    let stateLabel = "Not required";
  	    let tone = "neutral";
  	    let rank = 8;
  	    let message = "This requirement is not enabled in Compliance Setup.";

  	    if (record && ["Failed", "Rejected"].indexOf(fixedStatus) !== -1) {
  	      stateLabel = "Action required";
  	      tone = "bad";
  	      rank = 0;
  	      message = fixedStatus + " evidence requires corrective action.";
  	    } else if (days !== null && days < 0) {
  	      stateLabel = "Overdue";
  	      tone = "bad";
  	      rank = 1;
  	      message = "Expired " + Math.abs(days) + " day" + (Math.abs(days) === 1 ? "" : "s") + " ago.";
  	    } else if (required && !record && !expiryDate) {
  	      stateLabel = "Missing evidence";
  	      tone = "bad";
  	      rank = 2;
  	      message = "This requirement applies, but no current record or expiry date is available.";
  	    } else if (days !== null && days <= warningDays) {
  	      stateLabel = "Due soon";
  	      tone = "warn";
  	      rank = 3;
  	      message = "Expires in " + days + " day" + (days === 1 ? "" : "s") + ".";
  	    } else if (
  	      record &&
  	      ["Active", "Issued", "Submitted"].indexOf(fixedStatus) !== -1
  	    ) {
  	      stateLabel = fixedStatus === "Submitted" ? "Submitted" : "Current";
  	      tone = fixedStatus === "Submitted" ? "warn" : "good";
  	      rank = fixedStatus === "Submitted" ? 4 : 5;
  	      message = expiryDate
  	        ? "Current until " + serviceFormatDate(expiryDate) + "."
  	        : "Current record with no expiry date.";
  	    } else if (expiryDate) {
  	      stateLabel = "Current";
  	      tone = "good";
  	      rank = 5;
  	      message = "Current until " + serviceFormatDate(expiryDate) + ".";
  	    } else if (required) {
  	      stateLabel = "Setup required";
  	      tone = "warn";
  	      rank = 6;
  	      message = "Complete the current evidence for this required item.";
  	    }

  	    return {
  	      key: definition.key,
  	      label: definition.label,
  	      caption: definition.caption,
  	      group: definition.group,
  	      required: required,
  	      record: record,
  	      recordType: v21ComplianceDefinitionRecordType(vehicle, definition),
  	      expiryDate: expiryDate,
  	      days: days,
  	      warningDays: warningDays,
  	      state: stateLabel,
  	      tone: tone,
  	      rank: rank,
  	      message: message,
  	      source: record ? "Compliance record" : expiryDate ? "Setup / legacy date" : "Compliance Setup",
  	      configured: required || !!record || !!expiryDate,
  	      definition: definition
  	    };
  	  }

  	  function v21ComplianceDashboardItems(vehicle) {
  	    const items = V21_COMPLIANCE_SETUP_DEFINITIONS
  	      .map(function (definition) {
  	        return v21ComplianceDashboardItemFromDefinition(vehicle, definition);
  	      })
  	      .filter(function (item) {
  	        return item.configured;
  	      });

  	    const matchedIds = Object.create(null);
  	    items.forEach(function (item) {
  	      if (item.record && item.record.WorkOrderId) {
  	        matchedIds[item.record.WorkOrderId] = true;
  	      }
  	    });

  	    const unmatchedByType = {};
  	    complianceRecords(vehicle)
  	      .map(normalizeServiceWorkOrder)
  	      .forEach(function (record) {
  	        if (matchedIds[record.WorkOrderId]) return;

  	        const matched = V21_COMPLIANCE_SETUP_DEFINITIONS.some(function (definition) {
  	          return v21ComplianceRecordMatchesDefinition(record, definition);
  	        });
  	        if (matched) return;

  	        const type = clean(record.Type) || "Other Compliance";
  	        const key = v21ComplianceNormalise(type) || record.WorkOrderId;
  	        const current = unmatchedByType[key];
  	        if (!current) {
  	          unmatchedByType[key] = record;
  	          return;
  	        }
  	        const currentTime = new Date(
  	          current.IssueDate || current.EffectiveDate || current.ReportedDate || 0
  	        ).getTime();
  	        const recordTime = new Date(
  	          record.IssueDate || record.EffectiveDate || record.ReportedDate || 0
  	        ).getTime();
  	        if (recordTime > currentTime) unmatchedByType[key] = record;
  	      });

  	    Object.keys(unmatchedByType).forEach(function (key) {
  	      const record = unmatchedByType[key];
  	      const expiryDate = clean(record.ExpiryDate);
  	      const days = expiryDate ? fifDaysUntil(expiryDate) : null;
  	      const fixedStatus = v21ComplianceStatus(record);
  	      let stateLabel = "Current";
  	      let tone = "good";
  	      let rank = 5;
  	      let message = expiryDate
  	        ? "Current until " + serviceFormatDate(expiryDate) + "."
  	        : "Current compliance record.";

  	      if (["Failed", "Rejected"].indexOf(fixedStatus) !== -1) {
  	        stateLabel = "Action required";
  	        tone = "bad";
  	        rank = 0;
  	        message = fixedStatus + " evidence requires corrective action.";
  	      } else if (days !== null && days < 0) {
  	        stateLabel = "Overdue";
  	        tone = "bad";
  	        rank = 1;
  	        message = "Expired " + Math.abs(days) + " day" + (Math.abs(days) === 1 ? "" : "s") + " ago.";
  	      } else if (days !== null && days <= Math.max(1, numberOr(descriptorValue(v21ComplianceSetupRoot(vehicle).WarningDays), 60))) {
  	        stateLabel = "Due soon";
  	        tone = "warn";
  	        rank = 3;
  	        message = "Expires in " + days + " day" + (days === 1 ? "" : "s") + ".";
  	      }

  	      items.push({
  	        key: "Record-" + key,
  	        label: clean(record.Type) || "Other Compliance",
  	        caption: "Additional compliance record.",
  	        group: "Other records",
  	        required: true,
  	        record: record,
  	        recordType: clean(record.Type) || "Other Compliance",
  	        expiryDate: expiryDate,
  	        days: days,
  	        warningDays: Math.max(1, numberOr(descriptorValue(v21ComplianceSetupRoot(vehicle).WarningDays), 60)),
  	        state: stateLabel,
  	        tone: tone,
  	        rank: rank,
  	        message: message,
  	        source: "Compliance record",
  	        configured: true,
  	        definition: null
  	      });
  	    });

  	    return items.sort(function (left, right) {
  	      if (left.rank !== right.rank) return left.rank - right.rank;
  	      const leftExpiry = left.expiryDate
  	        ? new Date(left.expiryDate + "T23:59:59").getTime()
  	        : Number.MAX_SAFE_INTEGER;
  	      const rightExpiry = right.expiryDate
  	        ? new Date(right.expiryDate + "T23:59:59").getTime()
  	        : Number.MAX_SAFE_INTEGER;
  	      if (leftExpiry !== rightExpiry) return leftExpiry - rightExpiry;
  	      return naturalCompare(left.label, right.label);
  	    });
  	  }

  	  function v21ComplianceRecordTypeOptions(vehicle, selected) {
  	    const values = v21ComplianceDashboardItems(vehicle)
  	      .filter(function (item) { return item.required; })
  	      .map(function (item) { return item.recordType; });

  	    if (selected) values.push(selected);
  	    values.push("Other Compliance");

  	    const unique = uniqueStrings(values).filter(Boolean);
  	    return unique.length ? unique : V21_COMPLIANCE_TYPES.slice();
  	  }

  	  function v21ComplianceSetupGroups(vehicle) {
  	    const context = adaptiveProfileContext(vehicle);
  	    const groups = {};
  	    const optional = [];

  	    V21_COMPLIANCE_SETUP_DEFINITIONS.forEach(function (definition) {
  	      const item = v21ComplianceDashboardItemFromDefinition(vehicle, definition);
  	      const relevant = typeof definition.relevant === "function"
  	        ? definition.relevant(context)
  	        : true;

  	      if (!relevant && !item.configured) {
  	        optional.push(item);
  	        return;
  	      }

  	      if (!groups[definition.group]) groups[definition.group] = [];
  	      groups[definition.group].push(item);
  	    });

  	    return {
  	      groups: groups,
  	      optional: optional
  	    };
  	  }

  	  function v21ComplianceSetupCard(item, optional) {
  	    const requiredId = "cmp-setup-required-" + item.key;
  	    const expiryId = "cmp-setup-expiry-" + item.key;
  	    return `<article class="fifcmp-setup-card ${item.required ? "enabled" : ""}" data-cmp-setup-card="${escapeAttr(item.key)}">
  	      <div class="fifcmp-setup-choice">
  	        <input type="checkbox" id="${escapeAttr(requiredId)}" data-cmp-setup-required="${escapeAttr(item.key)}" ${item.required ? "checked" : ""}>
  	        <label for="${escapeAttr(requiredId)}"><strong>${escapeHtml(item.label)}</strong></label>
  	      </div>
  	      <label class="fifcmp-setup-expiry" for="${escapeAttr(expiryId)}">
  	        <span>Expiry</span>
  	        <input type="date" id="${escapeAttr(expiryId)}" data-cmp-setup-expiry="${escapeAttr(item.key)}" value="${escapeAttr(item.expiryDate || "")}">
  	      </label>
  	    </article>`;
  	  }





  	function v21ComplianceRecordCard(record,canEdit) {
  	    const status=v21ComplianceStatus(record), tone=v21ComplianceStatusTone(status), css=tone === "bad" ? "critical" : tone === "warn" ? "attention" : "";
  	    const reference=v21ComplianceReferenceValue(record) || "No reference", authority=clean(firstValue([record.Authority,record.Issuer,record.ProviderName],"")) || "Not specified";
  	    const canRenew=canEdit && ["Due Soon","Expired","Failed","Rejected"].indexOf(status)!==-1;
  	    return `<article class="fifcmp-record-card ${css}"><div class="fifcmp-record-top"><div><h5>${escapeHtml(record.Type || "Compliance record")}</h5><small>${escapeHtml(record.WorkOrderId)}</small></div><span class="fifcmp-badge ${tone}">${escapeHtml(status)}</span></div><div class="fifcmp-record-detail"><div><span>Issued</span><strong>${escapeHtml(serviceFormatDate(record.IssueDate || record.EffectiveDate || record.ReportedDate))}</strong></div><div><span>Expiry</span><strong>${record.ExpiryDate ? escapeHtml(serviceFormatDate(record.ExpiryDate)) : "No expiry"}</strong></div><div><span>Authority</span><strong>${escapeHtml(authority)}</strong></div><div><span>Reference</span><strong>${escapeHtml(reference)}</strong></div><div><span>Cost</span><strong>${record.ActualCost === null ? "—" : escapeHtml(formatCurrency(record.ActualCost))}</strong></div></div><div class="fifcmp-record-actions">${canRenew ? `<button type="button" data-cmp-renew-row="${escapeAttr(record.WorkOrderId)}">Renew</button>` : ""}<button type="button" data-cmp-open="${escapeAttr(record.WorkOrderId)}">Open Record</button></div></article>`;
  	  }


  	  function v21OpenComplianceRequirementsModal(company, vehicle) {
  	    if (!CAN_EDIT_COMPLIANCE) return;

  	    const draft = cloneData(vehicle);
  	    const setup = v21ComplianceSetupGroups(vehicle);
  	    const groupNames = Object.keys(setup.groups);
  	    const warningDays = Math.max(1, numberOr(v21ComplianceSetupRoot(vehicle).WarningDays, 60));

  	    const body = `<div class="fifcmp-setup-modal">
  	      <section class="fifcmp-setup-intro">
  	        <label>
  	          <span>Expiry warning</span>
  	          <select data-cmp-setup-warning>
  	            ${[30, 45, 60, 90].map(function (days) {
  	              return `<option value="${days}" ${warningDays === days ? "selected" : ""}>${days} days</option>`;
  	            }).join("")}
  	          </select>
  	        </label>
  	      </section>

  	      <div class="fifcmp-setup-groups">
  	        ${groupNames.map(function (groupName) {
  	          const items = setup.groups[groupName];
  	          return `<section class="fifcmp-setup-group">
  	            <header><h3>${escapeHtml(groupName)}</h3><b>${items.filter(function (item) { return item.required; }).length}</b></header>
  	            <div class="fifcmp-setup-grid">${items.map(function (item) {
  	              return v21ComplianceSetupCard(item, false);
  	            }).join("")}</div>
  	          </section>`;
  	        }).join("")}

  	        ${setup.optional.length ? `<details class="fifcmp-setup-optional">
  	          <summary><strong>Additional Requirements</strong><b>${setup.optional.length}</b></summary>
  	          <div class="fifcmp-setup-grid">${setup.optional.map(function (item) {
  	            return v21ComplianceSetupCard(item, true);
  	          }).join("")}</div>
  	        </details>` : ""}
  	      </div>
  	    </div>`;

  	    const overlay = serviceModalShell(
  	      "Compliance Setup",
  	      vehicleTitleValue(vehicle),
  	      body,
  	      `<button type="button" data-cmp-settings-cancel>Cancel</button>
  	       <button type="button" class="primary" data-cmp-settings-save>Save Setup</button>`,
  	      true
  	    );
  	    overlay.querySelector(".fifsp-modal")?.classList.add("fifcmp-modal", "fifcmp-setup-shell");

  	    overlay.querySelectorAll("[data-cmp-setup-required]").forEach(function (input) {
  	      input.addEventListener("change", function () {
  	        const card = input.closest("[data-cmp-setup-card]");
  	        if (card) card.classList.toggle("enabled", input.checked);
  	      });
  	    });

  	    overlay.querySelector("[data-cmp-settings-cancel]")?.addEventListener("click", closeServicePortalModal);

  	    overlay.querySelector("[data-cmp-settings-save]")?.addEventListener("click", function () {
  	      const warning = Math.max(1, numberOr(overlay.querySelector("[data-cmp-setup-warning]")?.value, 60));

  	      v21ComplianceWritePath(draft, ["Data", "Compliance", "Setup", "Configured"], true);
  	      v21ComplianceWritePath(draft, ["Data", "Compliance", "Setup", "WarningDays"], warning);

  	      V21_COMPLIANCE_SETUP_DEFINITIONS.forEach(function (definition) {
  	        const required = !!overlay.querySelector('[data-cmp-setup-required="' + definition.key + '"]')?.checked;
  	        const expiryDate = clean(overlay.querySelector('[data-cmp-setup-expiry="' + definition.key + '"]')?.value);

  	        v21ComplianceWritePath(draft, ["Data", "Compliance", "Setup", "Requirements", definition.key, "Required"], required);
  	        v21ComplianceWritePath(draft, ["Data", "Compliance", "Setup", "Requirements", definition.key, "ExpiryDate"], expiryDate);
  	      });

  	      const operation = fifBeginSaveOperation("Saving compliance setup…");
  	      saveVehicleToBackendless(company, draft).then(function (result) {
  	        closeServicePortalModal();
  	        fifCompleteSaveOperation(operation, "Compliance setup saved to the database.");
  	        setVehicleMessage("Compliance setup saved to the database.", false);
  	        render();
  	      }).catch(function (error) {
  	        fifFailSaveOperation(operation, error);
  	        setVehicleMessage(error && error.message ? error.message : "Compliance setup could not be saved.", true);
  	        render();
  	      });
  	    });
  	  }

  	  function v21ComplianceDashboardCard(item) {
  	    const actionLabel = item.record
  	      ? ["Overdue", "Due soon", "Action required"].indexOf(item.state) !== -1
  	        ? "Renew / Replace"
  	        : "Open Record"
  	      : "Add Record";

  	    const actionAttribute = item.record
  	      ? `data-cmp-open="${escapeAttr(item.record.WorkOrderId)}"`
  	      : `data-cmp-add-for="${escapeAttr(item.key)}"`;

  	    return `<article class="fifcmp-dashboard-card ${escapeAttr(item.tone)}">
  	      <div class="fifcmp-dashboard-top">
  	        <h5>${escapeHtml(item.label)}</h5>
  	        <b class="fifcmp-badge ${escapeAttr(item.tone)}">${escapeHtml(item.state)}</b>
  	      </div>
  	      <div class="fifcmp-dashboard-evidence">
  	        <div><span>Expiry</span><strong>${item.expiryDate ? escapeHtml(serviceFormatDate(item.expiryDate)) : "Not recorded"}</strong></div>
  	      </div>
  	      <div class="fifcmp-dashboard-actions"><button type="button" ${actionAttribute}>${escapeHtml(actionLabel)}</button></div>
  	    </article>`;
  	  }

  	function renderVehicleCompliance(company, vehicle) {
  	    injectV21ComplianceStyles();

  	    if (["all", "attention", "current", "history"].indexOf(state.complianceStatusFilter) === -1) {
  	      state.complianceStatusFilter = "all";
  	    }

  	    const dashboard = v21ComplianceDashboardItems(vehicle);
  	    const allRecords = complianceRecords(vehicle).map(normalizeServiceWorkOrder);
  	    const rows = v21FilteredCompliance(vehicle);
  	    const overdue = dashboard.filter(function (item) {
  	      return item.state === "Overdue" || item.state === "Action required";
  	    });
  	    const dueSoon = dashboard.filter(function (item) { return item.state === "Due soon"; });
  	    const current = dashboard.filter(function (item) { return item.tone === "good"; });

  	    let overallLabel = "Setup Required";
  	    let overallTone = "warn";
  	    if (overdue.length) {
  	      overallLabel = "Action Required";
  	      overallTone = "bad";
  	    } else if (dueSoon.length) {
  	      overallLabel = "Due Soon";
  	      overallTone = "warn";
  	    } else if (dashboard.length && current.length === dashboard.length) {
  	      overallLabel = "In Order";
  	      overallTone = "good";
  	    } else if (dashboard.length) {
  	      overallLabel = "Incomplete";
  	      overallTone = "warn";
  	    }

  	    return `${vehiclePermissionNotice(CAN_EDIT_COMPLIANCE, "Compliance editing requires the Compliance permission and asset access.")}
  	    <section class="fifcmp-root">
  	      <header class="fifcmp-head">
  	        <h3>${escapeHtml(vehicleTitleValue(vehicle))} Compliance</h3>
  	        <div class="fifcmp-head-actions">
  	          <button type="button" class="fifvm-btn" data-cmp-print>Print Register</button>
  	          ${CAN_EDIT_COMPLIANCE ? `<button type="button" class="fifvm-btn" data-cmp-settings>Compliance Setup</button>` : ""}
  	          ${CAN_EDIT_COMPLIANCE ? `<button type="button" class="fifvm-btn primary" data-cmp-new>+ Add Record</button>` : ""}
  	        </div>
  	      </header>

  	      <section class="fifcmp-summary">
  	        <article class="overall ${overallTone}"><span>Position</span><strong>${escapeHtml(overallLabel)}</strong></article>
  	        <article><span>Overdue / Failed</span><strong>${overdue.length}</strong></article>
  	        <article><span>Due Soon</span><strong>${dueSoon.length}</strong></article>
  	        <article><span>Current</span><strong>${current.length} / ${dashboard.length}</strong></article>
  	      </section>

  	      <section class="fifcmp-section fifcmp-dashboard-section">
  	        <header><h4>Requirements</h4><b>${dashboard.length}</b></header>
  	        ${dashboard.length
  	          ? `<div class="fifcmp-dashboard-grid">${dashboard.map(v21ComplianceDashboardCard).join("")}</div>`
  	          : `<div class="fifcmp-setup-empty"><strong>No requirements selected</strong>${CAN_EDIT_COMPLIANCE ? `<button type="button" class="fifvm-btn primary" data-cmp-settings>Compliance Setup</button>` : ""}</div>`
  	        }
  	      </section>

  	      <details class="fifcmp-records">
  	        <summary><strong>Compliance Records</strong><b>${allRecords.length}</b></summary>
  	        <div class="fifcmp-record-body">
  	          <div class="fifcmp-record-toolbar">
  	            <label class="fifcmp-search">
  	              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m16.4 16.4 4 4"></path></svg>
  	              <input type="search" data-cmp-search value="${escapeAttr(state.complianceSearch)}" placeholder="Search records">
  	            </label>
  	            <div class="fifcmp-scopes">
  	              ${[["all", "All"], ["attention", "Attention"], ["current", "Current"], ["history", "History"]].map(function (scope) {
  	                return `<button type="button" data-cmp-scope="${scope[0]}" class="${state.complianceStatusFilter === scope[0] ? "active" : ""}">${scope[1]}</button>`;
  	              }).join("")}
  	            </div>
  	            <div class="fifcmp-count">${rows.length} / ${allRecords.length}</div>
  	          </div>
  	          ${rows.length
  	            ? `<div class="fifcmp-record-grid">${rows.map(function (record) { return v21ComplianceRecordCard(record, CAN_EDIT_COMPLIANCE); }).join("")}</div>`
  	            : `<div class="fifcmp-empty">No records</div>`
  	          }
  	        </div>
  	      </details>
  	    </section>`;
  	  }
  	function v21OpenComplianceModal(company,vehicle,id,renewalOf,presetType) {
  	    const existing=id?serviceWorkOrderById(company,id):null, parent=renewalOf?serviceWorkOrderById(company,renewalOf):null, source=existing || parent || {};
  	    const base=normalizeServiceWorkOrder(existing || {WorkOrderId:serviceId("CMP"),Category:V21_CATEGORY_COMPLIANCE,Type:parent?parent.Type:(clean(presetType)||"Vehicle Licence"),Status:"Active",Priority:"Normal",ReportedDate:new Date().toISOString().slice(0,10),IssueDate:new Date().toISOString().slice(0,10),EffectiveDate:new Date().toISOString().slice(0,10),Odometer:currentOdometer(vehicle),Currency:"ZAR",ParentWorkOrderId:parent?parent.WorkOrderId:"",PreviousRecordId:parent?parent.WorkOrderId:"",IsRenewal:!!parent,Authority:parent?parent.Authority:"",Issuer:parent?parent.Issuer:"",ProviderId:parent?parent.ProviderId:"",ProviderName:parent?parent.ProviderName:""});
  	    const readOnly=!CAN_EDIT_COMPLIANCE, providers=serviceProviders(company).filter(function(p){return lower(p.Status)==="active";}), statuses=["Active","Issued","Submitted","Failed","Rejected","Cancelled"], reference=v21ComplianceReferenceValue(source), history=existing?serviceNoteHistoryHtml(base):"";
  	    const body=`<form data-cmp-form class="fifsp-form fifcmp-form"><nav class="fifcmp-stepper" aria-label="Compliance record steps"><button type="button" class="active" data-cmp-step="identity"><em>1</em><span>Record</span></button><button type="button" data-cmp-step="validity"><em>2</em><span>Validity</span></button><button type="button" data-cmp-step="cost"><em>3</em><span>Cost & Notes</span></button></nav><div class="fifcmp-panels">
  	      <section class="fifcmp-step-panel active" data-cmp-step-panel="identity"><header><h3>Record</h3></header><div class="grid">${serviceField("Type","Compliance type",base.Type,"select",{values:v21ComplianceRecordTypeOptions(vehicle,base.Type),disabled:readOnly,required:true})}${serviceField("Status","Status",base.Status,"select",{values:statuses,disabled:readOnly,required:true})}${serviceField("Authority","Authority",base.Authority || base.Issuer,"text",{disabled:readOnly})}${providers.length?serviceField("ProviderId","Provider",base.ProviderId,"select",{disabled:readOnly,values:[{value:"",label:"Not assigned"}].concat(providers.map(function(p){return {value:p.ProviderId,label:serviceProviderLabel(p)};}))}):""}${serviceField("PrimaryReference","Reference",reference,"text",{disabled:readOnly,wide:true})}</div></section>
  	      <section class="fifcmp-step-panel" data-cmp-step-panel="validity"><header><h3>Validity</h3></header><div class="grid">${serviceField("IssueDate","Issue date",base.IssueDate,"date",{disabled:readOnly})}${serviceField("ExpiryDate","Expiry date",base.ExpiryDate,"date",{disabled:readOnly})}${serviceField("RenewalDueDate","Renew by",base.RenewalDueDate,"date",{disabled:readOnly})}${serviceField("Odometer","Odometer",base.Odometer,"number",{min:0,disabled:readOnly})}${base.ParentWorkOrderId?`<div class="fifsp-inline-note wide"><strong>Renewal of</strong><span>${escapeHtml(base.ParentWorkOrderId)}</span></div>`:""}</div></section>
  	      <section class="fifcmp-step-panel" data-cmp-step-panel="cost"><header><h3>Cost & Notes</h3></header><div class="grid">${serviceField("ActualCost","Gross cost",base.ActualCost,"number",{min:0,disabled:readOnly})}${serviceField("VATAmount","VAT",base.VATAmount,"number",{min:0,disabled:readOnly})}${serviceField("InvoiceNumber","Invoice",base.InvoiceNumber,"text",{disabled:readOnly})}${serviceField("PurchaseOrder","Purchase order",base.PurchaseOrder,"text",{disabled:readOnly})}${serviceField("AddNote",existing?"Add note":"Note","","textarea",{wide:true,disabled:readOnly})}</div>${history?`<div class="fifcmp-note-history">${history}</div>`:""}</section></div><input type="hidden" name="WorkOrderId" value="${escapeAttr(base.WorkOrderId)}"><input type="hidden" name="ObjectId" value="${escapeAttr(base.objectId)}"></form>`;
  	    const footer=`<button type="button" data-sp-modal-close>${readOnly?"Close":"Cancel"}</button>${existing?`<button type="button" data-cmp-print-record>Print Record</button><button type="button" data-cmp-renew>Renew Record</button>`:""}<button type="button" data-cmp-back hidden>Back</button><button type="button" class="primary" data-cmp-next ${readOnly?"hidden":""}>Continue</button>${readOnly?"":`<button type="button" class="primary" data-cmp-save hidden>${existing?"Save Record":"Create Record"}</button>`}`;
  	    const overlay=serviceModalShell(existing?"Compliance Record":"New Compliance Record",existing?base.WorkOrderId:vehicleTitleValue(vehicle),body,footer,true); overlay.querySelector(".fifsp-modal")?.classList.add("fifcmp-modal");
  	    const steps=["identity","validity","cost"]; let index=0; const back=overlay.querySelector("[data-cmp-back]"), next=overlay.querySelector("[data-cmp-next]"), save=overlay.querySelector("[data-cmp-save]");
  	    function show(i){index=Math.max(0,Math.min(steps.length-1,i)); overlay.querySelectorAll("[data-cmp-step]").forEach(function(b){b.classList.toggle("active",b.getAttribute("data-cmp-step")===steps[index]);}); overlay.querySelectorAll("[data-cmp-step-panel]").forEach(function(p){p.classList.toggle("active",p.getAttribute("data-cmp-step-panel")===steps[index]);}); if(back)back.hidden=index===0; if(next)next.hidden=readOnly || index===steps.length-1; if(save)save.hidden=readOnly || index!==steps.length-1;}
  	    overlay.querySelectorAll("[data-cmp-step]").forEach(function(b){b.addEventListener("click",function(){show(steps.indexOf(b.getAttribute("data-cmp-step")));});}); back?.addEventListener("click",function(){show(index-1);}); next?.addEventListener("click",function(){const panel=overlay.querySelector('[data-cmp-step-panel="'+steps[index]+'"]'), invalid=panel&&panel.querySelector(":invalid"); if(invalid){invalid.reportValidity();return;} show(index+1);});
  	    overlay.querySelector("[data-cmp-print-record]")?.addEventListener("click",function(){printComplianceRecord(company,vehicle,base);}); overlay.querySelector("[data-cmp-renew]")?.addEventListener("click",function(){closeServicePortalModal();v21OpenComplianceModal(company,vehicle,"",base.WorkOrderId);});
  	    save?.addEventListener("click",async function(){const form=overlay.querySelector("[data-cmp-form]");if(!form||!form.reportValidity())return;const d=new FormData(form),provider=serviceProviderById(company,d.get("ProviderId")),gross=numberOr(d.get("ActualCost"),null),vat=numberOr(d.get("VATAmount"),0),net=gross===null?null:Math.max(0,gross-vat),type=clean(d.get("Type")),ref=clean(d.get("PrimaryReference")),refProp=v21ComplianceReferenceProperty(type),notes=serviceAppendAuditNote(base,clean(d.get("AddNote")),existing?"Compliance note":"Initial compliance note"),refs={ReferenceNumber:base.ReferenceNumber,CertificateNumber:base.CertificateNumber,PolicyNumber:base.PolicyNumber,PermitNumber:base.PermitNumber};refs[refProp]=ref;if(!refs.ReferenceNumber)refs.ReferenceNumber=ref;
  	      const record=normalizeServiceWorkOrder({objectId:d.get("ObjectId")||base.objectId,WorkOrderId:d.get("WorkOrderId"),Category:V21_CATEGORY_COMPLIANCE,Type:type,Title:type,Status:d.get("Status"),Priority:"Normal",ReportedDate:base.ReportedDate||new Date().toISOString().slice(0,10),IssueDate:d.get("IssueDate"),EffectiveDate:d.get("IssueDate"),ExpiryDate:d.get("ExpiryDate"),RenewalDueDate:d.get("RenewalDueDate")||d.get("ExpiryDate"),PostingDate:d.get("IssueDate")||new Date().toISOString().slice(0,10),Odometer:d.get("Odometer"),ProviderId:provider?provider.ProviderId:"",ProviderName:provider?serviceProviderLabel(provider):"",Issuer:d.get("Authority"),Authority:d.get("Authority"),ReferenceNumber:refs.ReferenceNumber,CertificateNumber:refs.CertificateNumber,PolicyNumber:refs.PolicyNumber,PermitNumber:refs.PermitNumber,ParentWorkOrderId:base.ParentWorkOrderId,PreviousRecordId:base.ParentWorkOrderId,IsRenewal:!!base.ParentWorkOrderId,NetAmount:net,VATAmount:vat,ActualCost:gross,Currency:base.Currency||"ZAR",PurchaseOrder:d.get("PurchaseOrder"),InvoiceNumber:d.get("InvoiceNumber"),ComplianceScope:base.ComplianceScope,ComplianceResult:d.get("Status"),Notes:notes.Notes,NoteLog:notes.NoteLog,CreatedAt:base.CreatedAt,CreatedBy:base.CreatedBy,UpdatedAt:new Date().toISOString(),UpdatedBy:userDisplayName()});
  	      try{closeServicePortalModal();await saveMaintenanceRecord(company,vehicle,record,{message:record.WorkOrderId+" was saved to the compliance register.",title:"Compliance Saved"});}catch(error){await fifAlert(error&&error.message?error.message:"Compliance could not be saved.",{title:"Compliance Save Failed",type:"danger"});}}); show(0);
  	  }

  	  function printComplianceRecord(company, vehicle, record) {
  	    const row = normalizeServiceWorkOrder(record);
  	    openServicePrintWindow("Compliance Record " + row.WorkOrderId, `<div class="card"><table><tbody><tr><th>Vehicle</th><td>${escapeHtml(vehicleTitleValue(vehicle))}</td><th>Registration</th><td>${escapeHtml(vehicleRegistrationValue(vehicle) || "—")}</td></tr><tr><th>Record</th><td>${escapeHtml(row.Type || row.Title || "Compliance")}</td><th>Status</th><td>${escapeHtml(v21ComplianceStatus(row))}</td></tr><tr><th>Issued</th><td>${escapeHtml(serviceFormatDate(row.IssueDate || row.EffectiveDate || row.ReportedDate))}</td><th>Expiry</th><td>${escapeHtml(serviceFormatDate(row.ExpiryDate))}</td></tr><tr><th>Authority</th><td>${escapeHtml(row.Authority || row.Issuer || row.ProviderName || "—")}</td><th>Reference</th><td>${escapeHtml(row.ReferenceNumber || row.CertificateNumber || row.PolicyNumber || row.PermitNumber || "—")}</td></tr><tr><th>Cost</th><td>${row.ActualCost === null ? "—" : escapeHtml(formatCurrency(row.ActualCost))}</td><th>Invoice / PO</th><td>${escapeHtml(row.InvoiceNumber || row.PurchaseOrder || "—")}</td></tr></tbody></table></div><h2>Scope / Result</h2><div class="card">${escapeHtml(row.ComplianceScope || row.ComplianceResult || row.WorkPerformed || "—")}</div><h2>Notes</h2><div class="card">${escapeHtml(row.Notes || row.Complaint || "—")}</div>`);
  	  }

  	  function v21PrintCompliance(company, vehicle) {
  	    const rows = v21FilteredCompliance(vehicle); openServicePrintWindow("Vehicle Compliance Register", `<div class="card"><table><tbody><tr><th>Vehicle</th><td>${escapeHtml(vehicleTitleValue(vehicle))}</td><th>Company</th><td>${escapeHtml(companyName(company))}</td></tr></tbody></table></div><table><thead><tr><th>Record</th><th>Status</th><th>Issued</th><th>Expiry</th><th>Authority</th><th>Reference</th><th>Cost</th></tr></thead><tbody>${rows.map(function(r) {
  	      return `<tr><td>${escapeHtml(r.Type)}</td><td>${escapeHtml(v21ComplianceStatus(r))}</td><td>${escapeHtml(serviceFormatDate(r.IssueDate || r.ReportedDate))}</td><td>${escapeHtml(serviceFormatDate(r.ExpiryDate))}</td><td>${escapeHtml(r.Authority || r.Issuer || r.ProviderName || "—")}</td><td>${escapeHtml(r.ReferenceNumber || r.CertificateNumber || r.PolicyNumber || r.PermitNumber || "—")}</td><td>${r.ActualCost === null?"—": escapeHtml(formatCurrency(r.ActualCost))}</td></tr>`;
  	    }).join("") || `<tr><td colspan="7">No compliance records.</td></tr>`}</tbody></table>`);
  	  }

  	function bindV21VehicleEvents(root, company, vehicle) {
  	    if (!root || !vehicle) return;
  	    root.querySelector("[data-cmp-new]")?.addEventListener("click", function () { v21OpenComplianceModal(company, vehicle, "", ""); });
  	    root.querySelector("[data-cmp-print]")?.addEventListener("click", function () { v21PrintCompliance(company, vehicle); });
  	    root.querySelectorAll("[data-cmp-settings]").forEach(function (button) { button.addEventListener("click", function () { v21OpenComplianceRequirementsModal(company, vehicle); }); });
  	    root.querySelector("[data-cmp-search]")?.addEventListener("input", function (event) {
  	      const caret = event.target.selectionStart; state.complianceSearch = event.target.value; render();
  	      requestAnimationFrame(function () { const input = document.getElementById(ROOT_ID)?.querySelector("[data-cmp-search]"); if (!input) return; input.focus(); try { input.setSelectionRange(caret, caret); } catch (_) {} });
  	    });
  	    root.querySelectorAll("[data-cmp-scope]").forEach(function (button) { button.addEventListener("click", function () { state.complianceStatusFilter = button.getAttribute("data-cmp-scope") || "all"; render(); }); });
  	    root.querySelectorAll("[data-cmp-open]").forEach(function (button) { button.addEventListener("click", function () {
  	      const recordId = button.getAttribute("data-cmp-open"); const record = serviceWorkOrderById(company, recordId); const status = record ? v21ComplianceStatus(record) : "";
  	      if (CAN_EDIT_COMPLIANCE && ["Due Soon", "Expired", "Failed", "Rejected"].indexOf(status) !== -1) { v21OpenComplianceModal(company, vehicle, "", recordId, record.Type); return; }
  	      v21OpenComplianceModal(company, vehicle, recordId, "", "");
  	    }); });
  	    root.querySelectorAll("[data-cmp-add-for]").forEach(function (button) { button.addEventListener("click", function () {
  	      const key = button.getAttribute("data-cmp-add-for"); const item = v21ComplianceDashboardItems(vehicle).find(function (candidate) { return candidate.key === key; });
  	      v21OpenComplianceModal(company, vehicle, "", "", item ? item.recordType : "");
  	    }); });
  	    root.querySelectorAll("[data-cmp-renew-row]").forEach(function (button) { button.addEventListener("click", function () { v21OpenComplianceModal(company, vehicle, "", button.getAttribute("data-cmp-renew-row")); }); });
  	  }

  	  function onAnotherMainSurface(event) {
  	    const id = event && event.detail ? event.detail.id: "";
  	    if (id && id !== ROOT_ID) destroy();
  	  }

  	  function onTopBarPointerDown(event) {
  	    if (state.destroyed) return;

  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return;

  	    let insideRoot = false;
  	    try {
  	      const path = typeof event.composedPath === "function" ? event.composedPath(): [];
  	      insideRoot = path.indexOf(root) !== -1;
  	    } catch (_) {
  	      insideRoot = root.contains(event.target);
  	    }

  	    if (insideRoot) return;

  	    const y = Number(event.clientY);
  	    if (Number.isFinite(y) && y >= 0 && y < TOP_OFFSET_PX) {
  	      destroy();
  	    }
  	  }

  	  function onEscape(event) {
  	    if (event.key !== "Escape") return;
  	    if (document.getElementById(FIF_FUEL_TRACKING_WINDOW_ID)) {
  	      closeFuelTrackingWindow(); return;
  	    }
  	    if (document.getElementById(SERVICE_MODAL_ID)) {
  	      closeServicePortalModal(); return;
  	    }
  	    if (document.getElementById(APPLICATION_TEXT_PROMPT_ID)) {
  	      closeApplicationTextPrompt(); return;
  	    }
  	    if (document.getElementById(FIF_PROMPT_ROOT_ID)) return;
  	    if (state.tyreDetailsRequest) {
  	      state.tyreDetailsRequest = null;
  	      render();
  	      return;
  	    }
  	    if (state.tyreRemoveRequest) {
  	      state.tyreRemoveRequest = null;
  	      render();
  	      return;
  	    }
  	    destroy();
  	  }

  	  function destroy() {
  	    closeFuelTrackingWindow();
  	    closeStyledSelectPortal();
  	    closeStyledDatePortal();
  	    if (styledSelectObserver) {
  	      styledSelectObserver.disconnect(); styledSelectObserver = null;
  	    }
  	    removeStyledSelectCaptureController();
  	    destroyExactInlineTyreManager();
  	    destroyCompanyTyreWarehouse();
  	    if (state.destroyed) return;
  	    closeExactOriginalTyreManager();
  	    state.destroyed = true;

  	    if (state.serviceProviderEmailTimer) {
  	      clearTimeout(state.serviceProviderEmailTimer);
  	      state.serviceProviderEmailTimer = null;
  	    }
  	    state.serviceProviderEmailInteractionActive = false;

  	    document.removeEventListener("pointerdown", onTopBarPointerDown, true);
  	    document.removeEventListener("click", onFifImmediateOperationClick, true);
  	    document.removeEventListener("click", fifRawEssentialClickTrace, true);
  	    document.removeEventListener("submit", fifRawEssentialSubmitTrace, true);
  	    document.removeEventListener("keydown", onEscape, true);
  	    removeFifVehicleEventsMetricTakeover();
  	    document.getElementById("fif-essential-trace-build-badge")?.remove();
  	    fifCancelPrimedOperation();
  	    window.removeEventListener("fif:main-surface-opening", onAnotherMainSurface);
  	    window.removeEventListener("beforeunload", onFifBeforeUnload);

  	    const root = document.getElementById(ROOT_ID);
  	    if (root) root.remove();
  	    document.getElementById(STYLE_ID)?.remove();
  	    document.getElementById(VEHICLE_STYLE_ID)?.remove();
  	    document.getElementById(SERVICE_STYLE_ID)?.remove();
  	    document.getElementById(MAINTENANCE_STYLE_ID)?.remove();
  	    document.getElementById(V21_COMPLIANCE_STYLE_ID)?.remove();
  	    document.getElementById(V21_WORKSHOP_SMART_STYLE_ID)?.remove();
  	    document.getElementById(FIF_FUEL_REPORT_STYLE_ID)?.remove();
  	    document.getElementById(FIF_FUEL_TRACKING_STYLE_ID)?.remove();
  	    document.getElementById(FIF_ACTION_STYLE_ID)?.remove();
  	    document.getElementById(EMPLOYEE_STYLE_ID)?.remove();
  	    document.getElementById(FIF_DATE_PICKER_STYLE_ID)?.remove();
  	    closeServicePortalModal();
  	    closeFifPrompt(false);
  	    closeApplicationTextPrompt();
  	    document.getElementById(FIF_PROMPT_STYLE_ID)?.remove();

  	    document.body.style.overflow = state.priorBodyOverflow;

  	    try {
  	      if (window.FIFDashboard && window.FIFDashboard.version === VERSION) {
  	        delete window.FIFDashboard;
  	      }
  	    } catch (_) {}
  	  }

  	  destroyExisting();
  	  announceMainSurface();
  	  injectStyles();
  	  injectVehicleManagerStyles();
  	  injectServicePortalStyles();
  	  injectMaintenanceRelationStyles();

  	  const root = document.createElement("div");
  	  root.id = ROOT_ID;
  	  root.setAttribute("data-fif-main-surface", "dashboard");
  	  root.__destroyDashboard = destroy;
  	  document.body.appendChild(root);
  	  document.body.style.overflow = "hidden";
  	  installStyledSelectCaptureController();
  	  installStyledSelectObserver(root);

  	  state.selectedCompanyKey = resolveInitialOperatingCompanyKey();

  	  window.addEventListener("fif:main-surface-opening", onAnotherMainSurface);
  	  document.addEventListener("pointerdown", onTopBarPointerDown, true);
  	  document.addEventListener("click", onFifImmediateOperationClick, true);
  	  document.addEventListener("click", fifRawEssentialClickTrace, true);
  	  document.addEventListener("submit", fifRawEssentialSubmitTrace, true);
  	  document.addEventListener("keydown", onEscape, true);
  	  installFifVehicleEventsMetricTakeover();
  	  fifInstallTraceBuildBadge();

  	  function assetIsTrailer(asset) {
  	    if (!asset) return state.selectedAssetType === "trailer";
  	    const cls = lower(asset.___class);
  	    if (cls === "trailers" || cls === "trailer") return true;
  	    const company = selectedCompany();
  	    const id = objectIdOf(asset);
  	    return towedAssets(company).some(function (item) {
  	      return item === asset || (id && objectIdOf(item) === id);
  	    });
  	  }

  	  function assetTableName(asset) {
  	    return assetIsTrailer(asset) ? "Trailers" : "Tractors";
  	  }



  	  function selectedVehicle(company) {
  	    if (!state.selectedVehicleKey) return null;
  	    const list = state.selectedAssetType === "trailer" ? towedAssets(company) : tractors(company);
  	    for (let index = 0; index < list.length; index += 1) {
  	      if (vehicleStableKey(list[index], index) === state.selectedVehicleKey) return list[index];
  	    }
  	    return null;
  	  }

  	  function fifIsMergeObject(value) {
  	    return !!value && typeof value === "object" && !Array.isArray(value) && !(value instanceof Date);
  	  }

  	  function fifMergeAppDataMutable(target, source) {
  	    if (!fifIsMergeObject(target) || !source || typeof source !== "object") return target;
  	    Object.keys(source).forEach(function (key) {
  	      const value = source[key];
  	      if (value === undefined) return;
  	      if (Array.isArray(value)) {
  	        target[key] = value.map(function (item) { return cloneData(item); });
  	        return;
  	      }
  	      if (fifIsMergeObject(value)) {
  	        if (!fifIsMergeObject(target[key])) target[key] = {};
  	        fifMergeAppDataMutable(target[key], value);
  	        return;
  	      }
  	      target[key] = value;
  	    });
  	    return target;
  	  }

  	  function fifLocalMergePatch(saved, baseline) {
  	    const patch = cloneData(saved && typeof saved === "object" ? saved : {});
  	    const relationKeys = [
  	      "Tractors", "Trailers", "Tyres", "Employees", "Maintenance",
  	      "FuelOut", "Fuel", "ViewC", "ViewH", "Companies"
  	    ];
  	    relationKeys.forEach(function (key) {
  	      if (
  	        Array.isArray(patch[key]) &&
  	        patch[key].length === 0 &&
  	        baseline &&
  	        Array.isArray(baseline[key]) &&
  	        baseline[key].length
  	      ) {
  	        delete patch[key];
  	      }
  	    });
  	    return patch;
  	  }

  	  function fifBuildLocalSavedSnapshot(existing, submitted, saved) {
  	    const snapshot = {};
  	    if (existing && typeof existing === "object") fifMergeAppDataMutable(snapshot, cloneData(existing));
  	    if (submitted && typeof submitted === "object") fifMergeAppDataMutable(snapshot, cloneData(submitted));
  	    if (saved && typeof saved === "object") fifMergeAppDataMutable(snapshot, fifLocalMergePatch(saved, snapshot));
  	    return snapshot;
  	  }

  	  function fifRecordIdentity(record) {
  	    record = record && typeof record === "object" ? record : {};
  	    return {
  	      objectId: clean(firstValue([record.objectId, record.ObjectId], "")),
  	      alternates: uniqueStrings([
  	        record.ID,
  	        record.FID,
  	        record.Local_Key,
  	        record.Registration,
  	        record.WorkOrderId,
  	        record.Tyre_Number,
  	        record.TyreNumber,
  	        record.email
  	      ].map(clean).filter(Boolean))
  	    };
  	  }

  	  function fifRecordMatches(candidate, identity, directReference) {
  	    if (!candidate || typeof candidate !== "object") return false;
  	    if (directReference && candidate === directReference) return true;
  	    const candidateId = clean(firstValue([candidate.objectId, candidate.ObjectId], ""));
  	    if (identity.objectId) return candidateId === identity.objectId;
  	    if (!identity.alternates.length) return false;
  	    const candidateValues = [
  	      candidate.ID,
  	      candidate.FID,
  	      candidate.Local_Key,
  	      candidate.Registration,
  	      candidate.WorkOrderId,
  	      candidate.Tyre_Number,
  	      candidate.TyreNumber,
  	      candidate.email
  	    ].map(clean).filter(Boolean);
  	    return candidateValues.some(function (value) {
  	      return identity.alternates.indexOf(value) !== -1;
  	    });
  	  }

  	  function fifSameCompanyRecord(left, right) {
  	    if (!left || !right || typeof left !== "object" || typeof right !== "object") return false;
  	    if (left === right) return true;
  	    const leftId = clean(firstValue([left.objectId, left.ObjectId], ""));
  	    const rightId = clean(firstValue([right.objectId, right.ObjectId], ""));
  	    if (leftId || rightId) return !!leftId && leftId === rightId;
  	    const leftKey = lower(firstValue([left.CompanyId, left.CompanyID, left.ID, left.Name, left.name], ""));
  	    const rightKey = lower(firstValue([right.CompanyId, right.CompanyID, right.ID, right.Name, right.name], ""));
  	    return !!leftKey && leftKey === rightKey;
  	  }

  	  function fifCompanyAliases(company) {
  	    const candidates = [company]
  	      .concat(arr(COMPANY_LIST))
  	      .concat(arr(getDeep(APP_DATA, ["User", "Companies"], [])))
  	      .concat(arr(getDeep(APP_DATA, ["Companies"], [])));
  	    const result = [];
  	    candidates.forEach(function (candidate) {
  	      if (!candidate || typeof candidate !== "object" || !fifSameCompanyRecord(candidate, company)) return;
  	      if (result.indexOf(candidate) === -1) result.push(candidate);
  	    });
  	    return result.length ? result : [company];
  	  }

  	  function fifReconcileObjectGraphById(root, objectId, snapshot) {
  	    const wanted = clean(objectId);
  	    if (!wanted || !root || typeof root !== "object") return 0;
  	    const visited = typeof WeakSet === "function" ? new WeakSet() : null;
  	    let changed = 0;
  	    let visitedCount = 0;

  	    function walk(node, depth) {
  	      if (!node || typeof node !== "object" || depth > 16 || visitedCount > 50000) return;
  	      if (visited) {
  	        if (visited.has(node)) return;
  	        visited.add(node);
  	      }
  	      visitedCount += 1;

  	      if (clean(firstValue([node.objectId, node.ObjectId], "")) === wanted) {
  	        try {
  	          fifMergeAppDataMutable(node, snapshot);
  	          changed += 1;
  	        } catch (_) {}
  	      }

  	      let keys = [];
  	      try { keys = Object.keys(node); } catch (_) { return; }
  	      keys.forEach(function (key) {
  	        let child;
  	        try { child = node[key]; } catch (_) { return; }
  	        if (child && typeof child === "object") walk(child, depth + 1);
  	      });
  	    }

  	    walk(root, 0);
  	    return changed;
  	  }



  	  function fifSynchroniseVehicleAppData(record) {
  	    if (!record || typeof record !== "object") return record;

  	    delete record.Status;
  	    if (record.Data && typeof record.Data === "object") {
  	      fifStripOperationalVehicleStatus(record.Data);
  	    }
  	    return record;
  	  }

  	  function fifReconcileCompanyCollection(company, collectionName, existing, submitted, saved, options) {
  	    options = options || {};
  	    let snapshot = fifBuildLocalSavedSnapshot(existing, submitted, saved);
  	    if (collectionName === "Tractors" || collectionName === "Trailers") {
  	      snapshot = fifSynchroniseVehicleAppData(snapshot);
  	    }
  	    const identity = fifRecordIdentity(snapshot);
  	    let canonical = existing && typeof existing === "object" ? existing : null;

  	    if (canonical) fifMergeAppDataMutable(canonical, snapshot);

  	    fifCompanyAliases(company).forEach(function (alias) {
  	      if (!Array.isArray(alias[collectionName])) {
  	        if (options.createMissing === false) return;
  	        alias[collectionName] = [];
  	      }
  	      const list = alias[collectionName];
  	      let match = null;
  	      for (let index = 0; index < list.length; index += 1) {
  	        if (fifRecordMatches(list[index], identity, existing)) {
  	          match = list[index];
  	          break;
  	        }
  	      }
  	      if (match) {
  	        fifMergeAppDataMutable(match, snapshot);
  	        if (!canonical || alias === company) canonical = match;
  	      } else if (options.pushMissing !== false) {
  	        const inserted = canonical || cloneData(snapshot);
  	        list.push(inserted);
  	        if (!canonical || alias === company) canonical = inserted;
  	      }
  	    });

  	    if (!canonical) canonical = snapshot;
  	    if (identity.objectId) {
  	      fifReconcileObjectGraphById(APP_DATA, identity.objectId, snapshot);
  	      fifReconcileObjectGraphById(COMPANY_LIST, identity.objectId, snapshot);
  	    }
  	    if (collectionName === "Tractors" || collectionName === "Trailers") {
  	      fifSynchroniseVehicleAppData(canonical);
  	    }
  	    return canonical;
  	  }

  	  function fifReconcileCompanyAppData(company, submitted, saved) {
  	    const snapshot = fifBuildLocalSavedSnapshot(company, submitted, saved);
  	    let canonical = company;
  	    fifCompanyAliases(company).forEach(function (alias) {
  	      fifMergeAppDataMutable(alias, snapshot);
  	      if (alias === company) canonical = alias;
  	    });
  	    const id = objectIdOf(snapshot);
  	    if (id) fifReconcileObjectGraphById(APP_DATA, id, snapshot);
  	    return canonical;
  	  }

  	  function fifReconcileVehicleAppData(company, existing, submitted, saved, tableHint) {
  	    const debugTractorReconcile =
  	      fifTractorDebugSession &&
  	      (
  	        clean(tableHint) === "Tractors" ||
  	        (
  	          !clean(tableHint) &&
  	          !assetIsTrailer(existing || submitted || saved)
  	        )
  	      );

  	    if (debugTractorReconcile) {
  	      fifTractorLog("APPDATA RECONCILIATION ENTRY", {
  	        tableHint: tableHint,
  	        existing: existing,
  	        submitted: submitted,
  	        saved: saved,
  	        existingEssential: fifDebugEssential(existing),
  	        submittedEssential: fifDebugEssential(submitted),
  	        savedEssential: fifDebugEssential(saved),
  	        companyTractorsBefore: tractors(company).map(function (item) {
  	          return {
  	            objectId: objectIdOf(item),
  	            essential: fifDebugEssential(item)
  	          };
  	        })
  	      });
  	    }
  	    const existingId = objectIdOf(existing);
  	    const submittedId = objectIdOf(submitted);
  	    const savedId = objectIdOf(saved);
  	    const tractorMatch = tractors(company).some(function (item) {
  	      return item === existing || (existingId && objectIdOf(item) === existingId) || (submittedId && objectIdOf(item) === submittedId) || (savedId && objectIdOf(item) === savedId);
  	    });
  	    const trailerMatch = towedAssets(company).some(function (item) {
  	      return item === existing || (existingId && objectIdOf(item) === existingId) || (submittedId && objectIdOf(item) === submittedId) || (savedId && objectIdOf(item) === savedId);
  	    });
  	    const table = clean(tableHint) || (trailerMatch ? "Trailers" : tractorMatch ? "Tractors" : assetIsTrailer(existing || submitted || saved) ? "Trailers" : "Tractors");
  	    const selectedBefore = selectedVehicle(company);
  	    const selectedBeforeId = objectIdOf(selectedBefore);
  	    const canonical = fifReconcileCompanyCollection(
  	      company,
  	      table === "Trailers" ? "Trailers" : "Tractors",
  	      existing,
  	      submitted,
  	      saved,
  	      { pushMissing: true, createMissing: true }
  	    );

  	    const canonicalId = objectIdOf(canonical);
  	    const wasSelected = !!selectedBefore && (
  	      selectedBefore === existing ||
  	      selectedBefore === canonical ||
  	      (selectedBeforeId && canonicalId && selectedBeforeId === canonicalId)
  	    );
  	    if (wasSelected || (!selectedBefore && state.selectedVehicleKey && vehicleStableKey(canonical, 0) === state.selectedVehicleKey)) {
  	      state.selectedAssetType = table === "Trailers" ? "trailer" : "tractor";
  	      state.selectedVehicleKey = vehicleStableKey(canonical, 0);
  	    }

  	    state.actionableAlertCache = {};

  	    if (debugTractorReconcile) {
  	      fifTractorLog("APPDATA RECONCILIATION COMPLETE", {
  	        canonical: canonical,
  	        canonicalEssential: fifDebugEssential(canonical),
  	        selectedVehicle: selectedVehicle(company),
  	        selectedEssential: fifDebugEssential(selectedVehicle(company)),
  	        companyTractorsAfter: tractors(company).map(function (item) {
  	          return {
  	            objectId: objectIdOf(item),
  	            essential: fifDebugEssential(item)
  	          };
  	        })
  	      });
  	    }

  	    return canonical;
  	  }

  	  function replaceSelectedVehicle(company, vehicle) {
  	    const recordId = objectIdOf(vehicle);
  	    let existing = null;
  	    let table = "";

  	    [tractors(company), towedAssets(company)].some(function (list, listIndex) {
  	      for (let index = 0; index < list.length; index += 1) {
  	        if (
  	          list[index] === vehicle ||
  	          (recordId && objectIdOf(list[index]) === recordId) ||
  	          vehicleStableKey(list[index], index) === state.selectedVehicleKey
  	        ) {
  	          existing = list[index];
  	          table = listIndex === 1 ? "Trailers" : "Tractors";
  	          return true;
  	        }
  	      }
  	      return false;
  	    });

  	    if (!table) table = assetIsTrailer(vehicle) ? "Trailers" : "Tractors";
  	    return fifReconcileVehicleAppData(company, existing, vehicle, vehicle, table);
  	  }



  	  function vehicleRegistrationValue(vehicle) {
  	    return clean(fifVehicleIdentityValue(vehicle, "Registration", ""));
  	  }

  	  function vehicleTitleValue(vehicle) {
  	    if (assetIsTrailer(vehicle)) {
  	      return clean(firstValue([
  	        vehicle && vehicle.ID,
  	        vehicle && vehicle.FID,
  	        getDeep(vehicle, ["Data", "Vehicle", "Identity", "ID", "value"], ""),
  	        vehicleRegistrationValue(vehicle),
  	        getDeep(vehicle, ["Data", "Implement", "Classification", "ImplementType", "value"], "")
  	      ], "Implement"));
  	    }
  	    return clean(firstValue([
  	      fifVehicleIdentityValue(vehicle, "FID", ""),
  	      vehicleRegistrationValue(vehicle),
  	      clean(fifVehicleIdentityValue(vehicle, "Make", "") + " " + fifVehicleIdentityValue(vehicle, "Model", "")),
  	      vehicle && vehicle.ID
  	    ], "Vehicle"));
  	  }

  	  function vehicleSecondaryTitle(vehicle) {
  	    if (assetIsTrailer(vehicle)) {
  	      return [
  	        clean(getDeep(vehicle, ["Data", "Implement", "Classification", "ImplementType", "value"], "")),
  	        clean(getDeep(vehicle, ["Data", "Implement", "Classification", "MajorCategory", "value"], "")),
  	        vehicleRegistrationValue(vehicle)
  	      ].filter(Boolean).join(" · ") || "Trailer / implement profile";
  	    }
  	    return [
  	      clean(fifVehicleClassificationValue(vehicle, "VehicleType", "")),
  	      clean(fifVehicleIdentityValue(vehicle, "Make", "")),
  	      clean(fifVehicleIdentityValue(vehicle, "Model", "")),
  	      clean(fifVehicleIdentityValue(vehicle, "Year", ""))
  	    ].filter(Boolean).join(" · ") || "Vehicle profile";
  	  }

  	  function currentTPositions(vehicle) {
  	    const raw = firstValue([
  	      vehicle && vehicle.TPositions,
  	      vehicle && vehicle.TyrePositions,
  	      getDeep(vehicle, ["Data", "TPositions"], null),
  	      getDeep(vehicle, ["Data", "TyrePositions"], null)
  	    ], null);
  	    let parsed = raw;
  	    if (typeof raw === "string") {
  	      try { parsed = JSON.parse(raw); } catch (_) { parsed = null; }
  	    }
  	    const trailer = assetIsTrailer(vehicle);
  	    if (!parsed || typeof parsed !== "object") {
  	      parsed = { SchemaVersion: "T3.0", VehicleType: trailer ? "Trailer" : "Tractor", Axles: [], Positions: {}, Summary: {} };
  	    }
  	    const result = cloneData(parsed);
  	    result.VehicleType = trailer ? "Trailer" : (result.VehicleType || "Tractor");
  	    if (!Array.isArray(result.Axles)) result.Axles = [];
  	    if (!result.Positions || typeof result.Positions !== "object") result.Positions = {};
  	    result.Summary = tyrePositionSummary(result);
  	    return result;
  	  }

  	  function rebuildTyrePositionsFromAxles(tPositions) {
  	    const oldPositions = cloneData(tPositions.Positions || {});
  	    const nextPositions = {};
  	    let spareIndex = 1;
  	    const trailer = lower(tPositions.VehicleType) === "trailer" || state.selectedAssetType === "trailer";
  	    tPositions.VehicleType = trailer ? "Trailer" : "Tractor";
  	    tPositions.Axles = arr(tPositions.Axles).filter(function (axle) {
  	      return axle && axle.Enabled !== false;
  	    }).map(function (axle, index) {
  	      const allowed = trailer ? ["Trailer", "Spare"] : ["Steer", "Tag", "Drive", "Spare"];
  	      const fallback = trailer ? "Trailer" : "Drive";
  	      const type = allowed.indexOf(clean(axle.Type)) !== -1 ? clean(axle.Type) : fallback;
  	      let count = Math.max(1, Math.min(2, Number(axle.TyresPerSide || 1)));
  	      if (type === "Steer" || type === "Spare") count = 1;
  	      return {
  	        Axle: index + 1,
  	        Type: type,
  	        Enabled: true,
  	        TyresPerSide: count,
  	        WearRate: type === "Tag" ? Math.max(0, Math.min(1, Number(axle.WearRate === undefined ? 1 : axle.WearRate))) : 1
  	      };
  	    });
  	    tPositions.Axles.forEach(function (axle) {
  	      if (axle.Type === "Spare") {
  	        const key = "SP" + spareIndex++;
  	        nextPositions[key] = newTyreSlot(key, axle, "Spare", "SP", 1, oldPositions[key]);
  	        return;
  	      }
  	      for (let index = 1; index <= axle.TyresPerSide; index += 1) {
  	        const left = tyrePositionKey(axle.Axle, "L", index);
  	        const right = tyrePositionKey(axle.Axle, "R", index);
  	        nextPositions[left] = newTyreSlot(left, axle, "Left", "L", index, oldPositions[left]);
  	        nextPositions[right] = newTyreSlot(right, axle, "Right", "R", index, oldPositions[right]);
  	      }
  	    });
  	    const orphaned = Object.keys(oldPositions).filter(function (key) {
  	      return !nextPositions[key] && clean(oldPositions[key] && oldPositions[key].TyreObjectId);
  	    });
  	    if (orphaned.length) return { ok: false, orphaned: orphaned };
  	    tPositions.Positions = nextPositions;
  	    tPositions.Summary = tyrePositionSummary(tPositions);
  	    return { ok: true, orphaned: [] };
  	  }

  	  function legacyAxleRows(draft) {
  	    const trailer = lower(draft && draft.VehicleType) === "trailer" || state.selectedAssetType === "trailer";
  	    const allowed = trailer ? ["Trailer", "Spare"] : ["Steer", "Tag", "Drive", "Spare"];
  	    const rows = arr(draft.Axles).slice().sort(function (a, b) { return Number(a.Axle || 0) - Number(b.Axle || 0); });
  	    if (!rows.length) return `<div style="color:#777;border:1px dashed #444;border-radius:8px;padding:12px;">No axle configuration yet. Click Add Axle.</div>`;
  	    return rows.map(function (axle, index) {
  	      const tyreCountLocked = axle.Type === "Steer" || axle.Type === "Spare";
  	      const typeOptions = allowed.map(function (type) {
  	        return `<option value="${escapeAttr(type)}" ${axle.Type === type ? "selected" : ""}>${escapeHtml(type)}</option>`;
  	      }).join("");
  	      return `<div data-vm-legacy-axle-index="${index}" style="display:grid;grid-template-columns:70px 135px 110px 100px 82px;gap:7px;align-items:end;background:#181818;border:1px solid #333;border-radius:8px;padding:9px;margin-bottom:7px;">
  	        <label style="font-size:11px;color:#aaa;">Axle<input type="number" min="1" value="${escapeAttr(axle.Axle)}" data-vm-legacy-axle-field="Axle" style="width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;"></label>
  	        <label style="font-size:11px;color:#aaa;">Type<select data-vm-legacy-axle-field="Type" style="width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;">${typeOptions}</select></label>
  	        <label style="font-size:11px;color:#aaa;">Tyres / side<input type="number" min="1" max="2" step="1" value="${escapeAttr(axle.TyresPerSide)}" data-vm-legacy-axle-field="TyresPerSide" ${tyreCountLocked ? "disabled" : ""} style="width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;${tyreCountLocked ? "opacity:.6;" : ""}"></label>
  	        <label style="font-size:11px;color:#aaa;">Wear<input type="number" min="0" max="1" step="0.01" value="${escapeAttr(axle.WearRate === undefined ? 1 : axle.WearRate)}" data-vm-legacy-axle-field="WearRate" ${axle.Type !== "Tag" ? "disabled" : ""} style="width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;${axle.Type !== "Tag" ? "opacity:.6;" : ""}"></label>
  	        <button type="button" data-vm-legacy-axle-action="remove-axle" style="padding:7px 8px;border:none;border-radius:6px;background:#7f1d1d;color:#fff;cursor:pointer;">Remove</button>
  	      </div>`;
  	    }).join("");
  	  }

  	  function renderAxleConfigurator(tPositions) {
  	    if (!CAN_EDIT_VEHICLE_PHYSICAL || !state.axleConfigMode) return "";
  	    const company = selectedCompany();
  	    const trailer = lower(tPositions && tPositions.VehicleType) === "trailer" || state.selectedAssetType === "trailer";
  	    const summary = tyrePositionSummary(tPositions);
  	    return `<section style="border:1px solid rgba(204,102,51,.28);border-radius:12px;background:#101010;padding:12px;margin-bottom:12px;">
  	      <div style="display:flex;justify-content:space-between;gap:12px;margin-bottom:10px;"><div><div style="font-size:15px;font-weight:800;color:#CC6633;">${trailer ? "Implement" : "Vehicle"} Axle Configurator</div><div style="font-size:11px;color:#888;margin-top:3px;">${trailer ? "Trailer axles use Trailer positions; one optional spare is supported." : "TPositions defines the tractor axle layout."}</div></div><div style="font-size:10px;color:#bbb;text-align:right;">${summary.TotalAxles} axles · ${summary.TotalPositions} positions · ${summary.AssignedTyres} fitted</div></div>
  	      <div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:10px;"><button type="button" data-vm-legacy-axle-action="add-axle" class="fifvm-btn primary">Add Axle</button><button type="button" data-vm-legacy-axle-action="add-spare" class="fifvm-btn">Add Spare</button>${trailer ? "" : `<button type="button" data-vm-legacy-axle-action="preset-4x2" class="fifvm-btn">4x2</button><button type="button" data-vm-legacy-axle-action="preset-6x2-tag" class="fifvm-btn">6x2 Tag</button><button type="button" data-vm-legacy-axle-action="preset-6x4" class="fifvm-btn">6x4</button>`}<button type="button" data-vm-legacy-axle-action="clear-config" class="fifvm-btn">Clear</button></div>
  	      ${legacyAxleRows(tPositions)}
  	      <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:8px;margin-top:10px;">${legacyGeneratedPositionGrid(company, tPositions)}</div>
  	    </section>`;
  	  }

  	  function renderImplementTyres(company, vehicle) {
  	    const tPositions = state.tyreDraft || currentTPositions(vehicle);
  	    const stock = warehouseTyres(company, vehicle);
  	    return `${vehiclePermissionNotice(CAN_MANAGE_WORKSHOP || CAN_EDIT_VEHICLE_PHYSICAL, "Tyre operations require the Tyres permission. Axle configuration requires Vehicle Data access.")}
  	      ${renderTyreActionBar(company, vehicle)}
  	      ${renderAxleConfigurator(tPositions)}
  	      <div class="fifvm-tyre-workspace">
  	        <section>${legacyTyreLayout(company, tPositions)}${managerPanel("Pending Tyre Plan", "Movements are not written until Save Tyre Changes is pressed.", renderTyrePlanRows(company, vehicle))}</section>
  	        <aside>${legacySelectedTyreDetail(company, tPositions)}${managerPanel("Tyre Warehouse", stock.length + " available tyre" + (stock.length === 1 ? "" : "s"), `<div class="fifvm-warehouse-list">${stock.length ? stock.map(warehouseTyreCard).join("") : `<div class="fifvm-empty">No compatible warehouse tyres are available.</div>`}</div>`)}</aside>
  	      </div>${renderTyreRemoveModal(company)}${renderTyreDetailsModal(company)}`;
  	  }

  	  function renderVehicleTyres(company, vehicle) {
  	    if (assetIsTrailer(vehicle)) return renderImplementTyres(company, vehicle);
  	    const canOpenOriginal = CAN_MANAGE_WORKSHOP || CAN_EDIT_VEHICLE_PHYSICAL;
  	    const configureButton = CAN_EDIT_VEHICLE_PHYSICAL ? `<button type="button" class="fifvm-original-tyre-configure" data-vm-original-configure-axles>Axle Configurator</button>` : "";
  	    return `${vehiclePermissionNotice(canOpenOriginal, "Tyre operations require the Tyres permission. Axle layout requires Vehicle Data access.")}<section class="fifvm-original-tyre-section" style="border:1px solid rgba(255,122,36,.30);background:rgba(7,10,10,.72);border-radius:14px;overflow:hidden;min-height:700px;"><div class="fifvm-original-tyre-heading" style="min-height:54px;padding:10px 13px;display:flex;align-items:center;justify-content:space-between;gap:12px;border-bottom:1px solid rgba(255,122,36,.24);background:linear-gradient(145deg,rgba(24,24,22,.96),rgba(8,10,10,.96));"><strong style="display:block;color:#ff8a3c;font-size:14px;">Vehicle Tyres</strong>${configureButton}</div><div id="fif-original-tyre-inline-host" class="fifvm-original-tyre-host" style="position:relative;width:100%;min-height:640px;overflow:visible;"></div></section>`;
  	  }

  	  function mountExactOriginalTyreManagerInline(root, company) {
  	    const vehicle = selectedVehicle(company);
  	    const host = root && root.querySelector("#fif-original-tyre-inline-host");
  	    if (!vehicle || assetIsTrailer(vehicle) || !host || state.vehicleActiveTab !== "tyres") {
  	      destroyExactInlineTyreManager();
  	      return;
  	    }
  	    destroyExactInlineTyreManager();
  	    exactInlineTyreHost = host;
  	    const backendlessApi =
  	      fifResolveRawWritableBackendlessApi("Tractors");
  	    const tyreMap = {};
  	    arr(company && company.Tyres).concat(arr(vehicle && vehicle.Tyres)).forEach(function (tyre) {
  	      const id = clean(firstValue([tyre && tyre.objectId, tyre && tyre.ObjectId, tyre && tyre.objectID, tyre && tyre.ID, tyre && tyre.FID], ""));
  	      if (id) tyreMap[id] = tyre;
  	    });
  	    try {
  	      exactInlineTyreInstance = fifExactOriginalTractorManager({ App: APP_INPUT, Tractors: [vehicle], Vehicle: vehicle, Tyres: Object.keys(tyreMap).map(function (id) { return tyreMap[id]; }), Hub: host, Backendless: fifOperationBackendlessProxy(backendlessApi), SVG: SVG_INPUT, InlineMode: true, AllowTyreOperations: CAN_MANAGE_WORKSHOP, AllowAxleConfiguration: CAN_EDIT_VEHICLE_PHYSICAL });
  	    } catch (error) {
  	      exactInlineTyreInstance = null;
  	      host.innerHTML = `<div class="fifvm-empty"><strong>Tyre manager could not open</strong><span>${escapeHtml(error && error.message ? error.message : "Unknown error")}</span></div>`;
  	    }
  	  }

  	  var fifVehicleQrLibrary = (function () {
  	var QRMode = {
  	    MODE_NUMBER :       1 << 0,
  	    MODE_ALPHA_NUM :    1 << 1,
  	    MODE_8BIT_BYTE :    1 << 2,
  	    MODE_KANJI :        1 << 3
  	};

  	var QRErrorCorrectLevel = {
  		L : 1,
  		M : 0,
  		Q : 3,
  		H : 2
  	};

  	var QRMaskPattern = {
  		PATTERN000 : 0,
  		PATTERN001 : 1,
  		PATTERN010 : 2,
  		PATTERN011 : 3,
  		PATTERN100 : 4,
  		PATTERN101 : 5,
  		PATTERN110 : 6,
  		PATTERN111 : 7
  	};

  	var QRMath = {

  		glog : function(n) {

  			if (n < 1) {
  				throw new Error("glog(" + n + ")");
  			}

  			return QRMath.LOG_TABLE[n];
  		},

  		gexp : function(n) {

  			while (n < 0) {
  				n += 255;
  			}

  			while (n >= 256) {
  				n -= 255;
  			}

  			return QRMath.EXP_TABLE[n];
  		},

  		EXP_TABLE : new Array(256),

  		LOG_TABLE : new Array(256)

  	};

  	for (var i = 0; i < 8; i++) {
  		QRMath.EXP_TABLE[i] = 1 << i;
  	}
  	for (var i = 8; i < 256; i++) {
  		QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
  			^ QRMath.EXP_TABLE[i - 5]
  			^ QRMath.EXP_TABLE[i - 6]
  			^ QRMath.EXP_TABLE[i - 8];
  	}
  	for (var i = 0; i < 255; i++) {
  		QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
  	}

  	function QRPolynomial(num, shift) {
  		if (num.length === undefined) {
  			throw new Error(num.length + "/" + shift);
  		}

  		var offset = 0;

  		while (offset < num.length && num[offset] === 0) {
  			offset++;
  		}

  		this.num = new Array(num.length - offset + shift);
  		for (var i = 0; i < num.length - offset; i++) {
  			this.num[i] = num[i + offset];
  		}
  	}

  	QRPolynomial.prototype = {

  		get : function(index) {
  			return this.num[index];
  		},

  		getLength : function() {
  			return this.num.length;
  		},

  		multiply : function(e) {

  			var num = new Array(this.getLength() + e.getLength() - 1);

  			for (var i = 0; i < this.getLength(); i++) {
  				for (var j = 0; j < e.getLength(); j++) {
  					num[i + j] ^= QRMath.gexp(QRMath.glog(this.get(i) ) + QRMath.glog(e.get(j) ) );
  				}
  			}

  			return new QRPolynomial(num, 0);
  		},

  		mod : function(e) {

  			if (this.getLength() - e.getLength() < 0) {
  				return this;
  			}

  			var ratio = QRMath.glog(this.get(0) ) - QRMath.glog(e.get(0) );

  			var num = new Array(this.getLength() );

  			for (var i = 0; i < this.getLength(); i++) {
  				num[i] = this.get(i);
  			}

  			for (var x = 0; x < e.getLength(); x++) {
  				num[x] ^= QRMath.gexp(QRMath.glog(e.get(x) ) + ratio);
  			}

  			return new QRPolynomial(num, 0).mod(e);
  		}
  	};

  	function QRBitBuffer() {
  		this.buffer = [];
  		this.length = 0;
  	}

  	QRBitBuffer.prototype = {

  		get : function(index) {
  			var bufIndex = Math.floor(index / 8);
  			return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
  		},

  		put : function(num, length) {
  			for (var i = 0; i < length; i++) {
  				this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
  			}
  		},

  		getLengthInBits : function() {
  			return this.length;
  		},

  		putBit : function(bit) {

  			var bufIndex = Math.floor(this.length / 8);
  			if (this.buffer.length <= bufIndex) {
  				this.buffer.push(0);
  			}

  			if (bit) {
  				this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
  			}

  			this.length++;
  		}
  	};

  	function QR8bitByte(data) {
  		this.mode = QRMode.MODE_8BIT_BYTE;
  		this.data = data;
  	}

  	QR8bitByte.prototype = {

  		getLength : function() {
  			return this.data.length;
  		},

  		write : function(buffer) {
  			for (var i = 0; i < this.data.length; i++) {
  				buffer.put(this.data.charCodeAt(i), 8);
  			}
  		}
  	};

  	function QRRSBlock(totalCount, dataCount) {
  		this.totalCount = totalCount;
  		this.dataCount  = dataCount;
  	}

  	QRRSBlock.RS_BLOCK_TABLE = [

  		[1, 26, 19],
  		[1, 26, 16],
  		[1, 26, 13],
  		[1, 26, 9],

  		[1, 44, 34],
  		[1, 44, 28],
  		[1, 44, 22],
  		[1, 44, 16],

  		[1, 70, 55],
  		[1, 70, 44],
  		[2, 35, 17],
  		[2, 35, 13],

  		[1, 100, 80],
  		[2, 50, 32],
  		[2, 50, 24],
  		[4, 25, 9],

  		[1, 134, 108],
  		[2, 67, 43],
  		[2, 33, 15, 2, 34, 16],
  		[2, 33, 11, 2, 34, 12],

  		[2, 86, 68],
  		[4, 43, 27],
  		[4, 43, 19],
  		[4, 43, 15],

  		[2, 98, 78],
  		[4, 49, 31],
  		[2, 32, 14, 4, 33, 15],
  		[4, 39, 13, 1, 40, 14],

  		[2, 121, 97],
  		[2, 60, 38, 2, 61, 39],
  		[4, 40, 18, 2, 41, 19],
  		[4, 40, 14, 2, 41, 15],

  		[2, 146, 116],
  		[3, 58, 36, 2, 59, 37],
  		[4, 36, 16, 4, 37, 17],
  		[4, 36, 12, 4, 37, 13],

  		[2, 86, 68, 2, 87, 69],
  		[4, 69, 43, 1, 70, 44],
  		[6, 43, 19, 2, 44, 20],
  		[6, 43, 15, 2, 44, 16],

  		[4, 101, 81],
  		[1, 80, 50, 4, 81, 51],
  		[4, 50, 22, 4, 51, 23],
  		[3, 36, 12, 8, 37, 13],

  		[2, 116, 92, 2, 117, 93],
  		[6, 58, 36, 2, 59, 37],
  		[4, 46, 20, 6, 47, 21],
  		[7, 42, 14, 4, 43, 15],

  		[4, 133, 107],
  		[8, 59, 37, 1, 60, 38],
  		[8, 44, 20, 4, 45, 21],
  		[12, 33, 11, 4, 34, 12],

  		[3, 145, 115, 1, 146, 116],
  		[4, 64, 40, 5, 65, 41],
  		[11, 36, 16, 5, 37, 17],
  		[11, 36, 12, 5, 37, 13],

  		[5, 109, 87, 1, 110, 88],
  		[5, 65, 41, 5, 66, 42],
  		[5, 54, 24, 7, 55, 25],
  		[11, 36, 12],

  		[5, 122, 98, 1, 123, 99],
  		[7, 73, 45, 3, 74, 46],
  		[15, 43, 19, 2, 44, 20],
  		[3, 45, 15, 13, 46, 16],

  		[1, 135, 107, 5, 136, 108],
  		[10, 74, 46, 1, 75, 47],
  		[1, 50, 22, 15, 51, 23],
  		[2, 42, 14, 17, 43, 15],

  		[5, 150, 120, 1, 151, 121],
  		[9, 69, 43, 4, 70, 44],
  		[17, 50, 22, 1, 51, 23],
  		[2, 42, 14, 19, 43, 15],

  		[3, 141, 113, 4, 142, 114],
  		[3, 70, 44, 11, 71, 45],
  		[17, 47, 21, 4, 48, 22],
  		[9, 39, 13, 16, 40, 14],

  		[3, 135, 107, 5, 136, 108],
  		[3, 67, 41, 13, 68, 42],
  		[15, 54, 24, 5, 55, 25],
  		[15, 43, 15, 10, 44, 16],

  		[4, 144, 116, 4, 145, 117],
  		[17, 68, 42],
  		[17, 50, 22, 6, 51, 23],
  		[19, 46, 16, 6, 47, 17],

  		[2, 139, 111, 7, 140, 112],
  		[17, 74, 46],
  		[7, 54, 24, 16, 55, 25],
  		[34, 37, 13],

  		[4, 151, 121, 5, 152, 122],
  		[4, 75, 47, 14, 76, 48],
  		[11, 54, 24, 14, 55, 25],
  		[16, 45, 15, 14, 46, 16],

  		[6, 147, 117, 4, 148, 118],
  		[6, 73, 45, 14, 74, 46],
  		[11, 54, 24, 16, 55, 25],
  		[30, 46, 16, 2, 47, 17],

  		[8, 132, 106, 4, 133, 107],
  		[8, 75, 47, 13, 76, 48],
  		[7, 54, 24, 22, 55, 25],
  		[22, 45, 15, 13, 46, 16],

  		[10, 142, 114, 2, 143, 115],
  		[19, 74, 46, 4, 75, 47],
  		[28, 50, 22, 6, 51, 23],
  		[33, 46, 16, 4, 47, 17],

  		[8, 152, 122, 4, 153, 123],
  		[22, 73, 45, 3, 74, 46],
  		[8, 53, 23, 26, 54, 24],
  		[12, 45, 15, 28, 46, 16],

  		[3, 147, 117, 10, 148, 118],
  		[3, 73, 45, 23, 74, 46],
  		[4, 54, 24, 31, 55, 25],
  		[11, 45, 15, 31, 46, 16],

  		[7, 146, 116, 7, 147, 117],
  		[21, 73, 45, 7, 74, 46],
  		[1, 53, 23, 37, 54, 24],
  		[19, 45, 15, 26, 46, 16],

  		[5, 145, 115, 10, 146, 116],
  		[19, 75, 47, 10, 76, 48],
  		[15, 54, 24, 25, 55, 25],
  		[23, 45, 15, 25, 46, 16],

  		[13, 145, 115, 3, 146, 116],
  		[2, 74, 46, 29, 75, 47],
  		[42, 54, 24, 1, 55, 25],
  		[23, 45, 15, 28, 46, 16],

  		[17, 145, 115],
  		[10, 74, 46, 23, 75, 47],
  		[10, 54, 24, 35, 55, 25],
  		[19, 45, 15, 35, 46, 16],

  		[17, 145, 115, 1, 146, 116],
  		[14, 74, 46, 21, 75, 47],
  		[29, 54, 24, 19, 55, 25],
  		[11, 45, 15, 46, 46, 16],

  		[13, 145, 115, 6, 146, 116],
  		[14, 74, 46, 23, 75, 47],
  		[44, 54, 24, 7, 55, 25],
  		[59, 46, 16, 1, 47, 17],

  		[12, 151, 121, 7, 152, 122],
  		[12, 75, 47, 26, 76, 48],
  		[39, 54, 24, 14, 55, 25],
  		[22, 45, 15, 41, 46, 16],

  		[6, 151, 121, 14, 152, 122],
  		[6, 75, 47, 34, 76, 48],
  		[46, 54, 24, 10, 55, 25],
  		[2, 45, 15, 64, 46, 16],

  		[17, 152, 122, 4, 153, 123],
  		[29, 74, 46, 14, 75, 47],
  		[49, 54, 24, 10, 55, 25],
  		[24, 45, 15, 46, 46, 16],

  		[4, 152, 122, 18, 153, 123],
  		[13, 74, 46, 32, 75, 47],
  		[48, 54, 24, 14, 55, 25],
  		[42, 45, 15, 32, 46, 16],

  		[20, 147, 117, 4, 148, 118],
  		[40, 75, 47, 7, 76, 48],
  		[43, 54, 24, 22, 55, 25],
  		[10, 45, 15, 67, 46, 16],

  		[19, 148, 118, 6, 149, 119],
  		[18, 75, 47, 31, 76, 48],
  		[34, 54, 24, 34, 55, 25],
  		[20, 45, 15, 61, 46, 16]
  	];

  	QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {

  		var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);

  		if (rsBlock === undefined) {
  			throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
  		}

  		var length = rsBlock.length / 3;

  		var list = [];

  		for (var i = 0; i < length; i++) {

  			var count = rsBlock[i * 3 + 0];
  			var totalCount = rsBlock[i * 3 + 1];
  			var dataCount  = rsBlock[i * 3 + 2];

  			for (var j = 0; j < count; j++) {
  				list.push(new QRRSBlock(totalCount, dataCount) );
  			}
  		}

  		return list;
  	};

  	QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

  		switch(errorCorrectLevel) {
  		case QRErrorCorrectLevel.L :
  			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
  		case QRErrorCorrectLevel.M :
  			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
  		case QRErrorCorrectLevel.Q :
  			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
  		case QRErrorCorrectLevel.H :
  			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
  		default :
  			return undefined;
  		}
  	};

  	var QRUtil = {

  	    PATTERN_POSITION_TABLE : [
  	        [],
  	        [6, 18],
  	        [6, 22],
  	        [6, 26],
  	        [6, 30],
  	        [6, 34],
  	        [6, 22, 38],
  	        [6, 24, 42],
  	        [6, 26, 46],
  	        [6, 28, 50],
  	        [6, 30, 54],
  	        [6, 32, 58],
  	        [6, 34, 62],
  	        [6, 26, 46, 66],
  	        [6, 26, 48, 70],
  	        [6, 26, 50, 74],
  	        [6, 30, 54, 78],
  	        [6, 30, 56, 82],
  	        [6, 30, 58, 86],
  	        [6, 34, 62, 90],
  	        [6, 28, 50, 72, 94],
  	        [6, 26, 50, 74, 98],
  	        [6, 30, 54, 78, 102],
  	        [6, 28, 54, 80, 106],
  	        [6, 32, 58, 84, 110],
  	        [6, 30, 58, 86, 114],
  	        [6, 34, 62, 90, 118],
  	        [6, 26, 50, 74, 98, 122],
  	        [6, 30, 54, 78, 102, 126],
  	        [6, 26, 52, 78, 104, 130],
  	        [6, 30, 56, 82, 108, 134],
  	        [6, 34, 60, 86, 112, 138],
  	        [6, 30, 58, 86, 114, 142],
  	        [6, 34, 62, 90, 118, 146],
  	        [6, 30, 54, 78, 102, 126, 150],
  	        [6, 24, 50, 76, 102, 128, 154],
  	        [6, 28, 54, 80, 106, 132, 158],
  	        [6, 32, 58, 84, 110, 136, 162],
  	        [6, 26, 54, 82, 110, 138, 166],
  	        [6, 30, 58, 86, 114, 142, 170]
  	    ],

  	    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
  	    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
  	    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)    | (1 << 4) | (1 << 1),

  	    getBCHTypeInfo : function(data) {
  	        var d = data << 10;
  	        while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
  	            d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) );
  	        }
  	        return ( (data << 10) | d) ^ QRUtil.G15_MASK;
  	    },

  	    getBCHTypeNumber : function(data) {
  	        var d = data << 12;
  	        while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
  	            d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) );
  	        }
  	        return (data << 12) | d;
  	    },

  	    getBCHDigit : function(data) {

  	        var digit = 0;

  	        while (data !== 0) {
  	            digit++;
  	            data >>>= 1;
  	        }

  	        return digit;
  	    },

  	    getPatternPosition : function(typeNumber) {
  	        return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
  	    },

  	    getMask : function(maskPattern, i, j) {

  	        switch (maskPattern) {

  	        case QRMaskPattern.PATTERN000 : return (i + j) % 2 === 0;
  	        case QRMaskPattern.PATTERN001 : return i % 2 === 0;
  	        case QRMaskPattern.PATTERN010 : return j % 3 === 0;
  	        case QRMaskPattern.PATTERN011 : return (i + j) % 3 === 0;
  	        case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 === 0;
  	        case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 === 0;
  	        case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 === 0;
  	        case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 === 0;

  	        default :
  	            throw new Error("bad maskPattern:" + maskPattern);
  	        }
  	    },

  	    getErrorCorrectPolynomial : function(errorCorrectLength) {

  	        var a = new QRPolynomial([1], 0);

  	        for (var i = 0; i < errorCorrectLength; i++) {
  	            a = a.multiply(new QRPolynomial([1, QRMath.gexp(i)], 0) );
  	        }

  	        return a;
  	    },

  	    getLengthInBits : function(mode, type) {

  	        if (1 <= type && type < 10) {

  	            switch(mode) {
  	            case QRMode.MODE_NUMBER     : return 10;
  	            case QRMode.MODE_ALPHA_NUM  : return 9;
  	            case QRMode.MODE_8BIT_BYTE  : return 8;
  	            case QRMode.MODE_KANJI      : return 8;
  	            default :
  	                throw new Error("mode:" + mode);
  	            }

  	        } else if (type < 27) {

  	            switch(mode) {
  	            case QRMode.MODE_NUMBER     : return 12;
  	            case QRMode.MODE_ALPHA_NUM  : return 11;
  	            case QRMode.MODE_8BIT_BYTE  : return 16;
  	            case QRMode.MODE_KANJI      : return 10;
  	            default :
  	                throw new Error("mode:" + mode);
  	            }

  	        } else if (type < 41) {

  	            switch(mode) {
  	            case QRMode.MODE_NUMBER     : return 14;
  	            case QRMode.MODE_ALPHA_NUM  : return 13;
  	            case QRMode.MODE_8BIT_BYTE  : return 16;
  	            case QRMode.MODE_KANJI      : return 12;
  	            default :
  	                throw new Error("mode:" + mode);
  	            }

  	        } else {
  	            throw new Error("type:" + type);
  	        }
  	    },

  	    getLostPoint : function(qrCode) {

  	        var moduleCount = qrCode.getModuleCount();
  	        var lostPoint = 0;
  	        var row = 0;
  	        var col = 0;

  	        for (row = 0; row < moduleCount; row++) {

  	            for (col = 0; col < moduleCount; col++) {

  	                var sameCount = 0;
  	                var dark = qrCode.isDark(row, col);

  	                for (var r = -1; r <= 1; r++) {

  	                    if (row + r < 0 || moduleCount <= row + r) {
  	                        continue;
  	                    }

  	                    for (var c = -1; c <= 1; c++) {

  	                        if (col + c < 0 || moduleCount <= col + c) {
  	                            continue;
  	                        }

  	                        if (r === 0 && c === 0) {
  	                            continue;
  	                        }

  	                        if (dark === qrCode.isDark(row + r, col + c) ) {
  	                            sameCount++;
  	                        }
  	                    }
  	                }

  	                if (sameCount > 5) {
  	                    lostPoint += (3 + sameCount - 5);
  	                }
  	            }
  	        }

  	        for (row = 0; row < moduleCount - 1; row++) {
  	            for (col = 0; col < moduleCount - 1; col++) {
  	                var count = 0;
  	                if (qrCode.isDark(row,     col    ) ) count++;
  	                if (qrCode.isDark(row + 1, col    ) ) count++;
  	                if (qrCode.isDark(row,     col + 1) ) count++;
  	                if (qrCode.isDark(row + 1, col + 1) ) count++;
  	                if (count === 0 || count === 4) {
  	                    lostPoint += 3;
  	                }
  	            }
  	        }

  	        for (row = 0; row < moduleCount; row++) {
  	            for (col = 0; col < moduleCount - 6; col++) {
  	                if (qrCode.isDark(row, col) &&
  	                        !qrCode.isDark(row, col + 1) &&
  	                         qrCode.isDark(row, col + 2) &&
  	                         qrCode.isDark(row, col + 3) &&
  	                         qrCode.isDark(row, col + 4) &&
  	                        !qrCode.isDark(row, col + 5) &&
  	                         qrCode.isDark(row, col + 6) ) {
  	                    lostPoint += 40;
  	                }
  	            }
  	        }

  	        for (col = 0; col < moduleCount; col++) {
  	            for (row = 0; row < moduleCount - 6; row++) {
  	                if (qrCode.isDark(row, col) &&
  	                        !qrCode.isDark(row + 1, col) &&
  	                         qrCode.isDark(row + 2, col) &&
  	                         qrCode.isDark(row + 3, col) &&
  	                         qrCode.isDark(row + 4, col) &&
  	                        !qrCode.isDark(row + 5, col) &&
  	                         qrCode.isDark(row + 6, col) ) {
  	                    lostPoint += 40;
  	                }
  	            }
  	        }

  	        var darkCount = 0;

  	        for (col = 0; col < moduleCount; col++) {
  	            for (row = 0; row < moduleCount; row++) {
  	                if (qrCode.isDark(row, col) ) {
  	                    darkCount++;
  	                }
  	            }
  	        }

  	        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
  	        lostPoint += ratio * 10;

  	        return lostPoint;
  	    }

  	};

  	function QRCode(typeNumber, errorCorrectLevel) {
  		this.typeNumber = typeNumber;
  		this.errorCorrectLevel = errorCorrectLevel;
  		this.modules = null;
  		this.moduleCount = 0;
  		this.dataCache = null;
  		this.dataList = [];
  	}

  	QRCode.prototype = {

  		addData : function(data) {
  			var newData = new QR8bitByte(data);
  			this.dataList.push(newData);
  			this.dataCache = null;
  		},

  		isDark : function(row, col) {
  			if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
  				throw new Error(row + "," + col);
  			}
  			return this.modules[row][col];
  		},

  		getModuleCount : function() {
  			return this.moduleCount;
  		},

  		make : function() {
  			if (this.typeNumber < 1 ){
  				var typeNumber = 1;
  				for (typeNumber = 1; typeNumber < 40; typeNumber++) {
  					var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

  					var buffer = new QRBitBuffer();
  					var totalDataCount = 0;
  					for (var i = 0; i < rsBlocks.length; i++) {
  						totalDataCount += rsBlocks[i].dataCount;
  					}

  					for (var x = 0; x < this.dataList.length; x++) {
  						var data = this.dataList[x];
  						buffer.put(data.mode, 4);
  						buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber) );
  						data.write(buffer);
  					}
  					if (buffer.getLengthInBits() <= totalDataCount * 8)
  						break;
  				}
  				this.typeNumber = typeNumber;
  			}
  			this.makeImpl(false, this.getBestMaskPattern() );
  		},

  		makeImpl : function(test, maskPattern) {

  			this.moduleCount = this.typeNumber * 4 + 17;
  			this.modules = new Array(this.moduleCount);

  			for (var row = 0; row < this.moduleCount; row++) {

  				this.modules[row] = new Array(this.moduleCount);

  				for (var col = 0; col < this.moduleCount; col++) {
  					this.modules[row][col] = null;//(col + row) % 3;
  				}
  			}

  			this.setupPositionProbePattern(0, 0);
  			this.setupPositionProbePattern(this.moduleCount - 7, 0);
  			this.setupPositionProbePattern(0, this.moduleCount - 7);
  			this.setupPositionAdjustPattern();
  			this.setupTimingPattern();
  			this.setupTypeInfo(test, maskPattern);

  			if (this.typeNumber >= 7) {
  				this.setupTypeNumber(test);
  			}

  			if (this.dataCache === null) {
  				this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
  			}

  			this.mapData(this.dataCache, maskPattern);
  		},

  		setupPositionProbePattern : function(row, col)  {

  			for (var r = -1; r <= 7; r++) {

  				if (row + r <= -1 || this.moduleCount <= row + r) continue;

  				for (var c = -1; c <= 7; c++) {

  					if (col + c <= -1 || this.moduleCount <= col + c) continue;

  					if ( (0 <= r && r <= 6 && (c === 0 || c === 6) ) ||
  	                     (0 <= c && c <= 6 && (r === 0 || r === 6) ) ||
  	                     (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
  						this.modules[row + r][col + c] = true;
  					} else {
  						this.modules[row + r][col + c] = false;
  					}
  				}
  			}
  		},

  		getBestMaskPattern : function() {

  			var minLostPoint = 0;
  			var pattern = 0;

  			for (var i = 0; i < 8; i++) {

  				this.makeImpl(true, i);

  				var lostPoint = QRUtil.getLostPoint(this);

  				if (i === 0 || minLostPoint >  lostPoint) {
  					minLostPoint = lostPoint;
  					pattern = i;
  				}
  			}

  			return pattern;
  		},

  		createMovieClip : function(target_mc, instance_name, depth) {

  			var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
  			var cs = 1;

  			this.make();

  			for (var row = 0; row < this.modules.length; row++) {

  				var y = row * cs;

  				for (var col = 0; col < this.modules[row].length; col++) {

  					var x = col * cs;
  					var dark = this.modules[row][col];

  					if (dark) {
  						qr_mc.beginFill(0, 100);
  						qr_mc.moveTo(x, y);
  						qr_mc.lineTo(x + cs, y);
  						qr_mc.lineTo(x + cs, y + cs);
  						qr_mc.lineTo(x, y + cs);
  						qr_mc.endFill();
  					}
  				}
  			}

  			return qr_mc;
  		},

  		setupTimingPattern : function() {

  			for (var r = 8; r < this.moduleCount - 8; r++) {
  				if (this.modules[r][6] !== null) {
  					continue;
  				}
  				this.modules[r][6] = (r % 2 === 0);
  			}

  			for (var c = 8; c < this.moduleCount - 8; c++) {
  				if (this.modules[6][c] !== null) {
  					continue;
  				}
  				this.modules[6][c] = (c % 2 === 0);
  			}
  		},

  		setupPositionAdjustPattern : function() {

  			var pos = QRUtil.getPatternPosition(this.typeNumber);

  			for (var i = 0; i < pos.length; i++) {

  				for (var j = 0; j < pos.length; j++) {

  					var row = pos[i];
  					var col = pos[j];

  					if (this.modules[row][col] !== null) {
  						continue;
  					}

  					for (var r = -2; r <= 2; r++) {

  						for (var c = -2; c <= 2; c++) {

  							if (Math.abs(r) === 2 ||
  	                            Math.abs(c) === 2 ||
  	                            (r === 0 && c === 0) ) {
  								this.modules[row + r][col + c] = true;
  							} else {
  								this.modules[row + r][col + c] = false;
  							}
  						}
  					}
  				}
  			}
  		},

  		setupTypeNumber : function(test) {

  			var bits = QRUtil.getBCHTypeNumber(this.typeNumber);
  	        var mod;

  			for (var i = 0; i < 18; i++) {
  				mod = (!test && ( (bits >> i) & 1) === 1);
  				this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
  			}

  			for (var x = 0; x < 18; x++) {
  				mod = (!test && ( (bits >> x) & 1) === 1);
  				this.modules[x % 3 + this.moduleCount - 8 - 3][Math.floor(x / 3)] = mod;
  			}
  		},

  		setupTypeInfo : function(test, maskPattern) {

  			var data = (this.errorCorrectLevel << 3) | maskPattern;
  			var bits = QRUtil.getBCHTypeInfo(data);
  	        var mod;

  			for (var v = 0; v < 15; v++) {

  				mod = (!test && ( (bits >> v) & 1) === 1);

  				if (v < 6) {
  					this.modules[v][8] = mod;
  				} else if (v < 8) {
  					this.modules[v + 1][8] = mod;
  				} else {
  					this.modules[this.moduleCount - 15 + v][8] = mod;
  				}
  			}

  			for (var h = 0; h < 15; h++) {

  				mod = (!test && ( (bits >> h) & 1) === 1);

  				if (h < 8) {
  					this.modules[8][this.moduleCount - h - 1] = mod;
  				} else if (h < 9) {
  					this.modules[8][15 - h - 1 + 1] = mod;
  				} else {
  					this.modules[8][15 - h - 1] = mod;
  				}
  			}

  			this.modules[this.moduleCount - 8][8] = (!test);

  		},

  		mapData : function(data, maskPattern) {

  			var inc = -1;
  			var row = this.moduleCount - 1;
  			var bitIndex = 7;
  			var byteIndex = 0;

  			for (var col = this.moduleCount - 1; col > 0; col -= 2) {

  				if (col === 6) col--;

  				while (true) {

  					for (var c = 0; c < 2; c++) {

  						if (this.modules[row][col - c] === null) {

  							var dark = false;

  							if (byteIndex < data.length) {
  								dark = ( ( (data[byteIndex] >>> bitIndex) & 1) === 1);
  							}

  							var mask = QRUtil.getMask(maskPattern, row, col - c);

  							if (mask) {
  								dark = !dark;
  							}

  							this.modules[row][col - c] = dark;
  							bitIndex--;

  							if (bitIndex === -1) {
  								byteIndex++;
  								bitIndex = 7;
  							}
  						}
  					}

  					row += inc;

  					if (row < 0 || this.moduleCount <= row) {
  						row -= inc;
  						inc = -inc;
  						break;
  					}
  				}
  			}

  		}

  	};

  	QRCode.PAD0 = 0xEC;
  	QRCode.PAD1 = 0x11;

  	QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {

  		var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);

  		var buffer = new QRBitBuffer();

  		for (var i = 0; i < dataList.length; i++) {
  			var data = dataList[i];
  			buffer.put(data.mode, 4);
  			buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber) );
  			data.write(buffer);
  		}

  		var totalDataCount = 0;
  		for (var x = 0; x < rsBlocks.length; x++) {
  			totalDataCount += rsBlocks[x].dataCount;
  		}

  		if (buffer.getLengthInBits() > totalDataCount * 8) {
  			throw new Error("code length overflow. (" +
  	            buffer.getLengthInBits() +
  	            ">" +
  	            totalDataCount * 8 +
  	            ")");
  		}

  		if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
  			buffer.put(0, 4);
  		}

  		while (buffer.getLengthInBits() % 8 !== 0) {
  			buffer.putBit(false);
  		}

  		while (true) {

  			if (buffer.getLengthInBits() >= totalDataCount * 8) {
  				break;
  			}
  			buffer.put(QRCode.PAD0, 8);

  			if (buffer.getLengthInBits() >= totalDataCount * 8) {
  				break;
  			}
  			buffer.put(QRCode.PAD1, 8);
  		}

  		return QRCode.createBytes(buffer, rsBlocks);
  	};

  	QRCode.createBytes = function(buffer, rsBlocks) {

  		var offset = 0;

  		var maxDcCount = 0;
  		var maxEcCount = 0;

  		var dcdata = new Array(rsBlocks.length);
  		var ecdata = new Array(rsBlocks.length);

  		for (var r = 0; r < rsBlocks.length; r++) {

  			var dcCount = rsBlocks[r].dataCount;
  			var ecCount = rsBlocks[r].totalCount - dcCount;

  			maxDcCount = Math.max(maxDcCount, dcCount);
  			maxEcCount = Math.max(maxEcCount, ecCount);

  			dcdata[r] = new Array(dcCount);

  			for (var i = 0; i < dcdata[r].length; i++) {
  				dcdata[r][i] = 0xff & buffer.buffer[i + offset];
  			}
  			offset += dcCount;

  			var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
  			var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1);

  			var modPoly = rawPoly.mod(rsPoly);
  			ecdata[r] = new Array(rsPoly.getLength() - 1);
  			for (var x = 0; x < ecdata[r].length; x++) {
  	            var modIndex = x + modPoly.getLength() - ecdata[r].length;
  				ecdata[r][x] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
  			}

  		}

  		var totalCodeCount = 0;
  		for (var y = 0; y < rsBlocks.length; y++) {
  			totalCodeCount += rsBlocks[y].totalCount;
  		}

  		var data = new Array(totalCodeCount);
  		var index = 0;

  		for (var z = 0; z < maxDcCount; z++) {
  			for (var s = 0; s < rsBlocks.length; s++) {
  				if (z < dcdata[s].length) {
  					data[index++] = dcdata[s][z];
  				}
  			}
  		}

  		for (var xx = 0; xx < maxEcCount; xx++) {
  			for (var t = 0; t < rsBlocks.length; t++) {
  				if (xx < ecdata[t].length) {
  					data[index++] = ecdata[t][xx];
  				}
  			}
  		}

  		return data;

  	};

  	    return {
  	      QRCode: QRCode,
  	      QRErrorCorrectLevel: QRErrorCorrectLevel
  	    };
  	  })();

  	  function fifBuildVehicleQrSvg(value) {
  	    const payload = clean(value);
  	    if (!payload) return "";

  	    const qr = new fifVehicleQrLibrary.QRCode(
  	      -1,
  	      fifVehicleQrLibrary.QRErrorCorrectLevel.M
  	    );

  	    qr.addData(payload);
  	    qr.make();

  	    const moduleCount = qr.getModuleCount();
  	    const quietZone = 4;
  	    const imageSize = moduleCount + quietZone * 2;
  	    const path = [];

  	    for (let row = 0; row < moduleCount; row++) {
  	      for (let column = 0; column < moduleCount; column++) {
  	        if (!qr.isDark(row, column)) continue;
  	        path.push(
  	          "M" + (column + quietZone) + " " + (row + quietZone) +
  	          "h1v1h-1z"
  	        );
  	      }
  	    }

  	    return (
  	      '<svg xmlns="http://www.w3.org/2000/svg" ' +
  	      'viewBox="0 0 ' + imageSize + ' ' + imageSize + '" ' +
  	      'role="img" aria-label="Vehicle QR Code" ' +
  	      'shape-rendering="crispEdges">' +
  	        '<rect width="100%" height="100%" fill="#ffffff"/>' +
  	        '<path d="' + path.join("") + '" fill="#000000"/>' +
  	      '</svg>'
  	    );
  	  }

  	  function fifVehiclePrintableObjectId(vehicle) {
  	    return clean(vehicle && vehicle.objectId);
  	  }

  	  function fifOpenVehicleQrPrint(vehicle) {
  	    const objectId = fifVehiclePrintableObjectId(vehicle);

  	    if (!objectId) {
  	      fifAlert("This Vehicle does not have an objectId, so its QR Code cannot be created.", {
  	        title: "Vehicle QR Unavailable",
  	        type: "warning",
  	        confirmText: "Close"
  	      });
  	      return null;
  	    }

  	    const printWindow = window.open("", "_blank", "width=900,height=900");
  	    if (!printWindow) {
  	      fifAlert("The Vehicle QR Code print window was blocked by the browser.", {
  	        title: "Print Window Blocked",
  	        type: "warning",
  	        confirmText: "Close"
  	      });
  	      return null;
  	    }

  	    const registration = clean(vehicleRegistrationValue(vehicle)) || "No Registration";
  	    const qrSvg = fifBuildVehicleQrSvg(objectId);
  	    const logoHtml = fifOperationLogoHtml();
  	    const html = `<!doctype html>
  	<html>
  	<head>
  	  <meta charset="utf-8">
  	  <title>Vehicle QR Code - ${escapeHtml(registration)}</title>
  	  <style>
  	    *{box-sizing:border-box;}
  	    html,body{margin:0;padding:0;background:#fff;color:#111827;font-family:Arial,sans-serif;}
  	    body{min-height:100vh;display:grid;place-items:center;padding:4vh 5vw;}
  	    .sheet{width:min(90vw,189mm);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4mm;}
  	    .logo{width:100%;height:34mm;display:flex;align-items:center;justify-content:center;overflow:hidden;}
  	    .logo img,.logo svg{display:block;width:100%;height:100%;max-width:none;max-height:none;object-fit:contain;}
  	    .logo .fif-operation-logo-fallback{width:100%;height:100%;display:grid;place-items:center;border:1px solid #cc6633;color:#9a431e;font-size:30pt;font-weight:950;}
  	    .qr{width:100%;aspect-ratio:1 / 1;display:block;break-inside:avoid;}
  	    .qr svg{display:block;width:100%;height:100%;}
  	    .registration{width:100%;font-size:36pt;font-weight:950;line-height:1.02;text-align:center;letter-spacing:-.025em;overflow-wrap:anywhere;word-break:break-word;}
  	    .print-control{position:fixed;right:18px;bottom:18px;height:42px;padding:0 20px;border:1px solid #9a431e;border-radius:10px;background:#a84f25;color:#fff;cursor:pointer;font-size:13px;font-weight:800;}
  	    @page{size:A4 portrait;margin:6mm 10.5mm;}
  	    @media print{
  	      html,body{width:189mm;height:285mm;min-height:285mm;}
  	      body{padding:0;}
  	      .sheet{width:189mm;height:285mm;gap:4mm;}
  	      .logo{width:189mm;height:34mm;}
  	      .qr{width:189mm;height:189mm;aspect-ratio:auto;}
  	      .registration{width:189mm;font-size:36pt;}
  	      .print-control{display:none!important;}
  	    }
  	  </style>
  	</head>
  	<body>
  	  <main class="sheet">
  	    <div class="logo">${logoHtml}</div>
  	    <div class="qr">${qrSvg}</div>
  	    <div class="registration">${escapeHtml(registration)}</div>
  	  </main>
  	  <button class="print-control" type="button" onclick="window.print()">Print QR</button>
  	</body>
  	</html>`;

  	    printWindow.document.open();
  	    printWindow.document.write(html);
  	    printWindow.document.close();

  	    let printRequested = false;
  	    const openPrintPanel = function () {
  	      if (printRequested || !printWindow || printWindow.closed) return;
  	      try {
  	        printWindow.focus();
  	        printWindow.print();
  	        printRequested = true;
  	      } catch (error) {

  	      }
  	    };

  	    try {
  	      if (printWindow.document.readyState === "complete") {
  	        window.setTimeout(openPrintPanel, 120);
  	      } else {
  	        printWindow.addEventListener("load", function () {
  	          window.setTimeout(openPrintPanel, 120);
  	        }, { once: true });
  	        window.setTimeout(openPrintPanel, 700);
  	      }
  	    } catch (_) {
  	      window.setTimeout(openPrintPanel, 180);
  	    }

  	    return printWindow;
  	  }

  	  function fifCloseVehiclePrintablesMenu(wrap) {
  	    if (!wrap) return;
  	    wrap.classList.remove("is-open");
  	    const toggle = wrap.querySelector("[data-vm-printables-toggle]");
  	    if (toggle) toggle.setAttribute("aria-expanded", "false");
  	  }

  	  function fifToggleVehiclePrintablesMenu(button) {
  	    const wrap = button && button.closest(".fifvm-printables-wrap");
  	    if (!wrap) return;
  	    const open = !wrap.classList.contains("is-open");
  	    wrap.classList.toggle("is-open", open);
  	    button.setAttribute("aria-expanded", open ? "true" : "false");
  	  }

  	  function renderVehicleManagerHero(company, vehicle) {
  	    const trailer = assetIsTrailer(vehicle);
  	    const color = trailer ? safeColor(vehicle && vehicle.color, "#cc6633") : fifVehicleColorValue(vehicle);
  	    const printables = trailer ? "" : `<div class="fifvm-hero-actions">
  	      <div class="fifvm-printables-wrap">
  	        <button type="button" class="fifvm-printables-button" data-vm-printables-toggle aria-haspopup="menu" aria-expanded="false" title="Open Vehicle printables">Printables</button>
  	        <div class="fifvm-printables-popover" role="menu" aria-label="Vehicle printables">
  	          <button type="button" role="menuitem" data-vm-print-vehicle-qr>
  	            <span class="fifvm-printables-option-icon" aria-hidden="true">▦</span>
  	            <span><strong>QR Code</strong><small>Vehicle objectId</small></span>
  	          </button>
  	        </div>
  	      </div>
  	    </div>`;
  	    return `<section class="fifvm-hero fifvm-hero-compact" style="--vehicle-color:${escapeAttr(color)}">
  	      <div class="fifvm-hero-accent"></div>
  	      <div class="fifvm-hero-icon ${trailer ? "" : "is-global-vehicle"}">${trailer ? ICONS.trailers : globalVehicleIconMarkup(vehicle, "fif-global-vehicle-icon")}</div>
  	      <div class="fifvm-hero-copy">
  	        <div class="fifvm-hero-title-row"><h2>${escapeHtml(vehicleTitleValue(vehicle))}</h2></div>
  	        <p>${escapeHtml(vehicleSecondaryTitle(vehicle))}</p>
  	      </div>
  	      ${printables}
  	    </section>`;
  	  }

  	  function renderIntegratedVehicleManager(company) {
  	    const vehicle = selectedVehicle(company);
  	    if (!vehicle) {
  	      state.selectedVehicleKey = "";
  	      return renderEmpty(state.selectedAssetType === "trailer" ? "Implement not found" : "Vehicle not found", "The selected asset is no longer available in this company.");
  	    }
  	    const activeWorkspace = clean(state.vehicleActiveTab || defaultVehicleManagerTab(vehicle) || "physical");
  	    const workspaceClass = "is-" + activeWorkspace + "-workspace";
  	    return `<section class="fifvm-manager" data-vm-active-workspace="${escapeAttr(activeWorkspace)}"><div class="fifvm-fixed-stack">${renderVehicleManagerHero(company, vehicle)}${renderVehicleManagerTabs()}</div><div class="fifvm-body ${workspaceClass}" data-vm-workspace-body="${escapeAttr(activeWorkspace)}">${renderVehicleMessage()}${renderVehicleManagerBody(company, vehicle)}</div></section>`;
  	  }

  	  function serviceHealthForVehicle(company, vehicle) {
  	    const counterType = serviceSetupCounterType(vehicle);
  	    const hours = counterType === "Hours";
  	    const unit = hours ? "h" : "km";
  	    const readingValue = numberValue(tractorMileage(vehicle));
  	    const reading = readingValue !== null && Number.isFinite(readingValue) ? readingValue : null;
  	    const service = getDeep(vehicle, ["Data", "Service"], {}) || {};
  	    const current = getDeep(service, ["Current"], {}) || {};
  	    const history = getDeep(service, ["History"], {}) || {};
  	    const schedule = getDeep(service, ["Schedule"], {}) || {};

  	    const storedNextCounter = numberValue(descriptorValue(firstValue(hours ? [
  	      current.NextServiceHours,
  	      current.Next_Service_Hours,
  	      history.Next_Service_Hours
  	    ] : [
  	      current.NextServiceMileage,
  	      current.Next_Service_KM,
  	      current.NextServiceKM,
  	      history.Next_Service_KM
  	    ], null)));
  	    const lastCounter = numberValue(descriptorValue(firstValue(hours ? [
  	      current.LastServiceHours,
  	      current.Last_Service_Hours,
  	      history.Last_Service_Hours
  	    ] : [
  	      current.LastServiceMileage,
  	      current.Last_Service_KM,
  	      current.LastServiceKM,
  	      history.Last_Service_KM
  	    ], null)));
  	    const storedNextDate = clean(descriptorValue(firstValue([
  	      current.NextServiceDate,
  	      current.Next_Service_Date_Estimate,
  	      current.Next_Service_Date,
  	      history.Next_Service_Date_Estimate,
  	      history.Next_Service_Date
  	    ], "")));
  	    const lastDate = clean(descriptorValue(firstValue([
  	      current.LastServiceDate,
  	      current.Last_Service_Date,
  	      history.Last_Service_Date
  	    ], "")));

  	    const intervalCounter = hours ? serviceConfiguredIntervalHours(vehicle) : serviceConfiguredIntervalKm(vehicle);
  	    const intervalDays = serviceConfiguredIntervalDays(vehicle);
  	    const calculatedNextCounter = lastCounter !== null && intervalCounter > 0
  	      ? serviceNextIntervalMileage(lastCounter, intervalCounter)
  	      : null;
  	    const calculatedNextDate = lastDate && intervalDays > 0
  	      ? serviceDatePlusDays(lastDate, intervalDays)
  	      : "";
  	    const nextCounter = calculatedNextCounter !== null
  	      ? calculatedNextCounter
  	      : storedNextCounter !== null && storedNextCounter > 0
  	        ? storedNextCounter
  	        : null;
  	    const nextDate = calculatedNextDate || storedNextDate;

  	    const warningRaw = numberOr(descriptorValue(firstValue(hours ? [
  	      schedule.ServiceWarningHours
  	    ] : [
  	      schedule.ServiceWarningKM,
  	      getDeep(service, ["Service_Warning_Duration_in_KM"], 0)
  	    ], 0)), 0);
  	    const warningCounter = warningRaw > 0 ? warningRaw : 0;
  	    const warningDays = numberOr(descriptorValue(schedule.ServiceWarningDays), 0);
  	    const serviceStatus = lower(descriptorValue(firstValue([
  	      current.ServiceStatus,
  	      service.Service_Status
  	    ], "")));
  	    const openOrders = vehicleServiceOrders(company, vehicle).filter(function (order) {
  	      return order.Category === MAINTENANCE_CATEGORY_SERVICE && SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(order.Status)) !== -1;
  	    });

  	    const calculationReading = reading === null
  	      ? lastCounter
  	      : lastCounter === null
  	        ? reading
  	        : Math.max(reading, lastCounter);
  	    const remainingCounter = nextCounter === null || calculationReading === null ? null : nextCounter - calculationReading;
  	    const days = nextDate ? fifDaysUntil(nextDate) : null;
  	    const readingAwaitingFuelUpdate = reading !== null && lastCounter !== null && lastCounter > reading;
  	    const counterPositionConflict = nextCounter !== null && lastCounter !== null && nextCounter <= lastCounter;
  	    const lastDateValue = lastDate ? new Date(lastDate) : null;
  	    const nextDateValue = nextDate ? new Date(nextDate) : null;
  	    const datePositionConflict = !!(
  	      lastDateValue && nextDateValue &&
  	      !Number.isNaN(lastDateValue.getTime()) &&
  	      !Number.isNaN(nextDateValue.getTime()) &&
  	      nextDateValue.getTime() <= lastDateValue.getTime()
  	    );
  	    const dataConflict = counterPositionConflict || datePositionConflict;

  	    let severity = "good";
  	    let label = "Healthy";
  	    if (serviceStatus === "out of service") {
  	      severity = "critical";
  	      label = "Out of service";
  	    } else if (dataConflict) {
  	      severity = "critical";
  	      label = "Service setup conflict";
  	    } else if (nextCounter === null && !nextDate) {
  	      severity = "warning";
  	      label = "Not configured";
  	    } else if ((remainingCounter !== null && remainingCounter <= 0) || (days !== null && days < 0)) {
  	      severity = "critical";
  	      label = "Service overdue";
  	    } else if ((remainingCounter !== null && warningCounter > 0 && remainingCounter <= warningCounter) || (days !== null && warningDays > 0 && days <= warningDays)) {
  	      severity = "warning";
  	      label = "Service due soon";
  	    } else if (openOrders.length) {
  	      severity = "scheduled";
  	      label = "Job in progress";
  	    }

  	    return {
  	      vehicle: vehicle,
  	      odometer: reading,
  	      counterType: counterType,
  	      unit: unit,
  	      intervalCounter: intervalCounter,
  	      intervalDays: intervalDays,
  	      nextCounter: nextCounter,
  	      lastCounter: lastCounter,
  	      remainingCounter: remainingCounter,
  	      nextKm: nextCounter,
  	      lastKm: lastCounter,
  	      remainingKm: remainingCounter,
  	      nextDate: nextDate,
  	      lastDate: lastDate,
  	      remainingDays: days,
  	      warningCounter: warningCounter,
  	      warningDays: warningDays,
  	      serviceStatus: serviceStatus,
  	      severity: severity,
  	      label: label,
  	      openOrders: openOrders,
  	      calculationReading: calculationReading,
  	      readingAwaitingFuelUpdate: readingAwaitingFuelUpdate,
  	      readingConflict: false,
  	      dataConflict: dataConflict
  	    };
  	  }

  	function renderVehicleColumnHeader() {
  	    if (state.activeTab === "trailers") {
  	      const trailerHeaders = ["Usage", "Service", "Maintenance", "Tyres"];
  	      if (CAN_ACCESS_ALERTS) trailerHeaders.push("Alerts");
  	      return `<div class="fifdash-asset-column-head" role="row"><span class="accent" aria-hidden="true"></span><div class="vehicle-head"><span>Implement</span></div><div class="metric-heads" style="grid-template-columns:repeat(${trailerHeaders.length},minmax(0,1fr));">${trailerHeaders.map(function (label) { return `<span>${escapeHtml(label)}</span>`; }).join("")}</div></div>`;
  	    }
  	    const metricHeaders = [
  	      vehicleSortButton("odometer", "Odometer"),
  	      vehicleSortButton("hobbs", "Hobbs Meter"),
  	      vehicleSortButton("distance", "Distance"),
  	      vehicleSortButton("hours", "Hours"),
  	      vehicleSortButton("fuel", "Fuel")
  	    ];
  	    if (CAN_ACCESS_LOCATION_EVENTS) metricHeaders.push(vehicleSortButton("events", "Events"));
  	    if (CAN_ACCESS_ALERTS) metricHeaders.push(vehicleSortButton("alerts", "Alerts"));
  	    return `<div class="fifdash-asset-column-head" role="row"><span class="accent" aria-hidden="true"></span><div class="vehicle-head">${vehicleSortButton("vehicle", "Vehicle")}</div><div class="metric-heads" style="grid-template-columns:repeat(${metricHeaders.length},minmax(0,1fr));">${metricHeaders.join("")}</div></div>`;
  	  }

  	function renderAssetCard(asset, index, tab) {
  	    const view = tab === "tyres" ? null : periodView(asset);
  	    const identity = assetIdentity(asset, index, tab === "vehicles" ? "Vehicle" : tab === "trailers" ? "Towed Asset" : "Tyre");
  	    const subtitle = assetSubtitle(asset, tab);
  	    const trailer = tab === "trailers";
  	    const opensVehicleManager = tab === "vehicles" || trailer;
  	    const canOpenVehicleManager = opensVehicleManager && adaptiveAvailablePrimaryTabs(selectedCompany(), asset).length > 0;
  	    const assetType = trailer ? "trailer" : "tractor";
  	    const stableKey = vehicleStableKey(asset, index);
  	    const alerts = trailer ? vehicleAlertsForDisplay(selectedCompany(), asset, false).length : notificationCount(asset);
  	    const eventMetric = !trailer && CAN_ACCESS_LOCATION_EVENTS ? fifVehicleEventMetricValue(selectedCompany(), asset) : "";
  	    const color = tab === "vehicles" ? fifVehicleColorValue(asset) : safeColor(asset && asset.color, "#cc6633");
  	    let metrics;

  	    if (tab === "tyres") {
  	      metrics = [
  	        ["Location", tyreLocation(asset)],
  	        ["Stage", clean(firstValue([asset && asset.Current_Stage, getDeep(asset, ["History", "Current", "Stage"], "")], "—"))],
  	        ["Mileage", formatDistance(firstValue([asset && asset.Current_Mileage, asset && asset.CurrentMileage, asset && asset.Total_Mileage, getDeep(asset, ["Data", "Mileage"], null)], null))],
  	        ["Cost", formatCurrency(firstValue([asset && asset.Total_Cost, asset && asset.Current_Cost, getDeep(asset, ["History", "Totals", "Cost_Total"], null)], null))]
  	      ];
  	      if (CAN_ACCESS_ALERTS) metrics.push(["Alerts", formatCount(alerts)]);
  	    } else if (trailer) {
  	      const health = serviceHealthForVehicle(selectedCompany(), asset);
  	      const maintenanceOpen = vehicleMaintenanceOrders(asset).filter(function (record) {
  	        return SERVICE_JOB_OPEN_STATUSES.indexOf(record.Status) !== -1;
  	      }).length;
  	      const tyreSummary = tyrePositionSummary(currentTPositions(asset));
  	      metrics = [
  	        ["Usage", tractorMileage(asset) === null ? "—" : formatDistance(tractorMileage(asset))],
  	        ["Service", health.label],
  	        ["Maintenance", formatCount(maintenanceOpen)],
  	        ["Tyres", tyreSummary.AssignedTyres + " / " + tyreSummary.TotalPositions]
  	      ];
  	      if (CAN_ACCESS_ALERTS) metrics.push(["Alerts", formatCount(alerts)]);
  	    } else {
  	      metrics = [
  	        ["Odometer", formatDistance(vehicleOdometerCounter(asset))],
  	        ["Hobbs Meter", formatHours(vehicleHobbsCounter(asset))],
  	        ["Distance", formatDistance(vehiclePeriodDistance(asset, view))],
  	        ["Hours", formatHours(vehiclePeriodHours(asset, view))],
  	        ["Fuel", view ? formatLitres(view.Litres) : "—"]
  	      ];
  	      if (CAN_ACCESS_LOCATION_EVENTS) metrics.push(["Events", eventMetric]);
  	      if (CAN_ACCESS_ALERTS) metrics.push(["Alerts", formatCount(alerts)]);
  	    }

  	    const leadingTag = opensVehicleManager ? "button" : "div";
  	    const leadingAttributes = opensVehicleManager
  	      ? (canOpenVehicleManager
  	          ? `type="button" data-open-vehicle="${escapeAttr(stableKey)}" data-asset-type="${assetType}" aria-label="Open ${escapeAttr(identity)} Vehicle Manager" title="Open complete ${trailer ? "implement" : "vehicle"} manager"`
  	          : `type="button" disabled aria-disabled="true" aria-label="${escapeAttr(identity)} has no assigned manager functions" title="No Vehicle Manager functions are assigned"`)
  	      : "";

  	    const metricHtml = metrics.map(function (metric) {
  	      const label = metric[0];
  	      const value = metric[1];
  	      const isAlert = label === "Alerts" && numberOr(value, 0) > 0;

  	      if (tab === "vehicles" && label === "Fuel" && CAN_ACCESS_FUEL && CAN_ACCESS_VEHICLES) {
  	        if (CAN_CAPTURE_ON_ROAD_FUEL) {
  	          return `<div class="fifdash-metric fifdash-fuel-split">
  	            <button type="button" class="fifdash-fuel-report-action" data-fleet-metric-action="fuel-report" data-vehicle-key="${escapeAttr(stableKey)}" data-asset-type="tractor" title="Open fuel cost and consumption report for this period">
  	              <span>${escapeHtml(label)}</span>
  	              <strong>${escapeHtml(value)}</strong>
  	            </button>
  	            <button type="button" class="fifdash-fuel-capture-action" data-fleet-metric-action="fuel-capture" data-vehicle-key="${escapeAttr(stableKey)}" data-asset-type="tractor" aria-label="Capture on-road fuel" title="Capture on-road fuel">${ICONS.fuelTank}</button>
  	          </div>`;
  	        }
  	        return `<button type="button" class="fifdash-metric is-action" data-fleet-metric-action="fuel-report" data-vehicle-key="${escapeAttr(stableKey)}" data-asset-type="tractor" title="Open fuel cost and consumption report for this period"><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong></button>`;
  	      }

  	      const metricAction = tab === "vehicles"
  	        ? (label === "Events" && CAN_ACCESS_LOCATION_EVENTS
  	            ? "events"
  	            : label === "Alerts" && CAN_ACCESS_ALERTS
  	              ? "alerts"
  	              : "")
  	        : trailer
  	          ? (label === "Tyres" && CAN_ACCESS_TYRES
  	              ? "tyres"
  	              : label === "Service" && CAN_ACCESS_SERVICE
  	                ? "service"
  	                : label === "Maintenance" && CAN_ACCESS_MAINTENANCE
  	                  ? "maintenance"
  	                  : label === "Alerts" && CAN_ACCESS_ALERTS
  	                    ? "alerts"
  	                    : "")
  	          : "";
  	      const tag = metricAction ? "button" : "div";
  	      const actionTitle = metricAction === "alerts"
  	        ? "Open actionable alerts"
  	          : metricAction === "events"
  	            ? "Open location and job event history"
  	            : metricAction
  	              ? "Open " + metricAction
  	              : "";

  	      return `<${tag} ${metricAction ? `type="button" data-fleet-metric-action="${metricAction}" data-vehicle-key="${escapeAttr(stableKey)}" data-asset-type="${assetType}" title="${escapeAttr(actionTitle)}"` : ""} class="fifdash-metric ${isAlert ? "has-alert" : ""} ${metricAction ? "is-action" : ""}"><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong></${tag}>`;
  	    }).join("");

  	    return `<article class="fifdash-asset-card ${opensVehicleManager && !canOpenVehicleManager ? "is-manager-disabled" : ""}" style="--asset-color:${escapeAttr(color)}" data-asset-key="${escapeAttr(stableKey)}">
  	      <div class="fifdash-asset-accent"></div>
  	      <${leadingTag} ${leadingAttributes} class="fifdash-asset-leading ${canOpenVehicleManager ? "fifdash-asset-open" : ""}">
  	        <div class="fifdash-asset-icon ${tab === "vehicles" ? "is-global-vehicle" : ""}">${tab === "vehicles" ? globalVehicleIconMarkup(asset, "fif-global-vehicle-icon") : ICONS[tab]}</div>
  	        <div class="fifdash-asset-copy">
  	          <div class="fifdash-asset-topline"><h3>${escapeHtml(identity)}</h3></div>
  	          <p>${escapeHtml(subtitle)}</p>
  	        </div>
  	      </${leadingTag}>
  	      <div class="fifdash-asset-metrics" style="grid-template-columns:repeat(${metrics.length},minmax(76px,1fr));">${metricHtml}</div>
  	    </article>`;
  	  }

  	  function fifVehicleFromStableKey(company, key, assetType) {
  	    const list = assetType === "trailer" || state.activeTab === "trailers" ? towedAssets(company) : tractors(company);
  	    for (let index = 0; index < list.length; index += 1) if (vehicleStableKey(list[index], index) === key) return list[index];
  	    return null;
  	  }

  	  function fifStripOperationalVehicleStatus(data) {
  	    if (!data || typeof data !== "object") return data;
  	    const vehicleData = data.Vehicle;
  	    if (vehicleData && typeof vehicleData === "object") {
  	      delete vehicleData.Status;
  	      delete vehicleData.WorkshopStatus;
  	      if (vehicleData.Identity && typeof vehicleData.Identity === "object") delete vehicleData.Identity.Status;
  	    }
  	    return data;
  	  }

  	  function fifVehicleDataSavePayload(vehicle) {
  	    const source = vehicle && typeof vehicle === "object" ? vehicle : {};
  	    const payload = {};
  	    const serverFields = {
  	      created: true,
  	      updated: true,
  	      ownerId: true,
  	      ___class: true,
  	      __meta: true
  	    };
  	    const writableJsonFields = {
  	      Data: true,
  	      TPositions: true,
  	      TyrePositions: true
  	    };

  	    Object.keys(source).forEach(function (key) {
  	      if (serverFields[key] || key === "Status") return;
  	      const value = source[key];

  	      if (Array.isArray(value)) return;

  	      if (value && typeof value === "object") {
  	        if (writableJsonFields[key]) {
  	          const clonedValue = cloneData(value);
  	          payload[key] = key === "Data" ? fifStripOperationalVehicleStatus(clonedValue) : clonedValue;
  	        }
  	        return;
  	      }

  	      if (typeof value !== "function" && value !== undefined) {
  	        payload[key] = value;
  	      }
  	    });

  	    const mirrors =
  	      fifExtractTractorTopLevelMirrors(payload);

  	    if (mirrors) {
  	      Object.assign(payload, mirrors);
  	    }

  	    const id = objectIdOf(source);
  	    if (id) payload.objectId = id;
  	    return payload;
  	  }

  	  async function saveVehicleToBackendless(company, vehicle) {
  	    state.vehicleBusy = true;

  	    const prepared = fifSynchroniseVehicleAppData(cloneData(vehicle));
  	    const table = assetTableName(prepared);
  	    const collection =
  	      table === "Trailers"
  	        ? towedAssets(company)
  	        : tractors(company);
  	    const preparedId = objectIdOf(prepared);
  	    const existing =
  	      collection.find(function (item, index) {
  	        return (
  	          item === vehicle ||
  	          (preparedId && objectIdOf(item) === preparedId) ||
  	          vehicleStableKey(item, index) === state.selectedVehicleKey
  	        );
  	      }) ||
  	      selectedVehicle(company) ||
  	      null;
  	    const payload = fifVehicleDataSavePayload(prepared);

  	    if (!payload.objectId) {
  	      state.vehicleBusy = false;
  	      throw new Error(
  	        "The selected vehicle does not contain an objectId and cannot be updated."
  	      );
  	    }

  	    try {
  	      const databaseResult =
  	        await fifSaveDatabaseRowAndReadBack(table, payload);

  	      const result = fifReconcileVehicleAppData(
  	        company,
  	        existing,
  	        databaseResult.value,
  	        databaseResult.value,
  	        table
  	      );

  	      state.vehicleBusy = false;

  	      return {
  	        value: result,
  	        localOnly: false,
  	        databaseRequest: databaseResult.requestNumber
  	      };
  	    } catch (error) {
  	      state.vehicleBusy = false;
  	      throw error;
  	    }
  	  }



  	  async function v21AddMaintenanceOwnershipRelations(company, vehicle, saved, dateValue) {
  	    if (!saved || !saved.objectId) return;
  	    await v21AddRelation("Companies", clean(company && company.objectId), MAINTENANCE_RELATION, saved.objectId, true);
  	    await v21SetMaintenanceBackRelation(saved, "Company", clean(company && company.objectId), true);
  	    if (assetIsTrailer(vehicle)) await v21SetMaintenanceBackRelation(saved, "Trailer", objectIdOf(vehicle), true);
  	    else await v21SetMaintenanceBackRelation(saved, "Tractor", objectIdOf(vehicle), true);
  	    const view = matchingVehiclePeriod(vehicle, dateValue);
  	    if (!assetIsTrailer(vehicle) && view && view.objectId) await v21SetMaintenanceBackRelation(saved, "TractorPeriod", view.objectId, false);
  	  }

  	  async function updateVehicleServicePositionFromRecord(company, vehicle, record) {
  	    if (!vehicle || record.Category !== MAINTENANCE_CATEGORY_SERVICE || lower(record.Status) !== "completed") return true;

  	    const updated = cloneData(vehicle);
  	    const odometer = numberOr(record.Odometer, null);
  	    const completedDate = maintenanceDateInput(record.CompletedDate || record.ReportedDate || new Date()) || new Date().toISOString().slice(0, 10);
  	    const hours = serviceSetupCounterType(updated) === "Hours";
  	    const intervalCounter = hours ? serviceConfiguredIntervalHours(updated) : serviceConfiguredIntervalKm(updated);
  	    const intervalDays = serviceConfiguredIntervalDays(updated);
  	    const calculatedNextCounter = serviceNextIntervalMileage(odometer, intervalCounter);
  	    const nextCounter = calculatedNextCounter !== null
  	      ? calculatedNextCounter
  	      : numberOr(record.NextServiceKm, null);
  	    const nextDate = clean(record.NextServiceDate) || (intervalDays > 0 ? serviceDatePlusDays(completedDate, intervalDays) : "");
  	    const providerName = clean(record.ProviderName || "");

  	    serviceSetDescriptor(updated, ["Data", "Service", "History", "Last_Service_Date"], completedDate, "date");
  	    if (hours) {
  	      if (odometer !== null) serviceSetDescriptor(updated, ["Data", "Service", "History", "Last_Service_Hours"], odometer, "number", "Time");
  	      if (nextCounter !== null) serviceSetDescriptor(updated, ["Data", "Service", "History", "Next_Service_Hours"], nextCounter, "number", "Time");
  	    } else {
  	      if (odometer !== null) serviceSetDescriptor(updated, ["Data", "Service", "History", "Last_Service_KM"], odometer, "number", "Distance");
  	      if (nextCounter !== null) serviceSetDescriptor(updated, ["Data", "Service", "History", "Next_Service_KM"], nextCounter, "number", "Distance");
  	    }
  	    if (nextDate) serviceSetDescriptor(updated, ["Data", "Service", "History", "Next_Service_Date_Estimate"], nextDate, "date");
  	    if (providerName) serviceSetDescriptor(updated, ["Data", "Service", "History", "Service_Centre_Last_Used"], providerName, "text");

  	    serviceSetDescriptor(updated, ["Data", "Service", "Current", "LastServiceDate"], completedDate, "date");
  	    if (hours) {
  	      if (odometer !== null) serviceSetDescriptor(updated, ["Data", "Service", "Current", "LastServiceHours"], odometer, "number", "Time");
  	      if (nextCounter !== null) serviceSetDescriptor(updated, ["Data", "Service", "Current", "NextServiceHours"], nextCounter, "number", "Time");
  	    } else {
  	      if (odometer !== null) serviceSetDescriptor(updated, ["Data", "Service", "Current", "LastServiceMileage"], odometer, "number", "Distance");
  	      if (nextCounter !== null) serviceSetDescriptor(updated, ["Data", "Service", "Current", "NextServiceMileage"], nextCounter, "number", "Distance");
  	    }
  	    if (nextDate) serviceSetDescriptor(updated, ["Data", "Service", "Current", "NextServiceDate"], nextDate, "date");
  	    if (providerName) serviceSetDescriptor(updated, ["Data", "Service", "Current", "ServiceCentreLastUsed"], providerName, "text");
  	    serviceSetDescriptor(updated, ["Data", "Service", "Current", "ServiceWarningActive"], false, "boolean");
  	    serviceSetDescriptor(updated, ["Data", "Service", "Current", "WarningResetAt"], new Date().toISOString(), "text");

  	    serviceSetDescriptor(updated, ["Data", "Service", "Service_Status"], "All In Order", "select");
  	    serviceSetDescriptor(updated, ["Data", "Service", "Current", "ServiceStatus"], "All In Order", "select");

  	    try {
  	      const databaseApi = await fifWaitForDatabaseApi(1800);
  	      if (!databaseApi || !databaseApi.Data || typeof databaseApi.Data.of !== "function") throw new Error("The database connection is not ready.");
  	      const savedAsset = await databaseApi.Data.of(assetTableName(updated)).save({
  	        objectId: updated.objectId,
  	        Data: cloneData(updated.Data)
  	      });
  	      replaceSelectedVehicle(company, Object.assign(updated, savedAsset && typeof savedAsset === "object" ? savedAsset : {}));
  	      state.actionableAlertCache = {};
  	      return true;
  	    } catch (error) {

  	      return false;
  	    }
  	  }

  	  function serviceVehicleById(company, id) {
  	    return tractors(company).concat(towedAssets(company)).find(function (vehicle) {
  	      return objectIdOf(vehicle) === id || vehicleTitleValue(vehicle) === id;
  	    }) || null;
  	  }

  	  function serviceWorkOrders(company) {
  	    const rows = [];
  	    const seen = {};
  	    tractors(company).concat(towedAssets(company)).forEach(function (asset) {
  	      maintenanceRowsForVehicle(asset).forEach(function (record) {
  	        const key = record.objectId || record.WorkOrderId;
  	        if (!key || seen[key]) return;
  	        seen[key] = true;
  	        rows.push(normalizeServiceWorkOrder(record));
  	      });
  	    });
  	    return rows;
  	  }


  	async function executeVehicleAlertAction(company, vehicle, alert) {
  	    closeActionableAlertModal();
  	    if (!userCanAccessVehicleAlert(alert, vehicle)) {
  	      await fifAlert("This alert belongs to functionality that is not assigned in your Dashboard Settings.", {
  	        title: "Function Not Available", type: "warning", confirmText: "Close"
  	      });
  	      return;
  	    }
  	    const trailer = assetIsTrailer(vehicle);
  	    const list = trailer ? towedAssets(company) : tractors(company);
  	    const selectTab = function (tab) {
  	      state.selectedAssetType = trailer ? "trailer" : "tractor";
  	      state.selectedVehicleKey = vehicleStableKey(vehicle, list.indexOf(vehicle));
  	      state.vehicleActiveTab = tab;
  	      clearVehicleEditorState();
  	      render();
  	    };

  	    if (alert.action === "service-setup") {
  	      state.selectedAssetType = trailer ? "trailer" : "tractor";
  	      openVehicleServiceSetupModal(company, vehicle, "setup");
  	      return;
  	    }
  	    if (alert.action === "preventive-plan-edit") {
  	      state.selectedAssetType = trailer ? "trailer" : "tractor";
  	      if (CAN_MANAGE_MAINTENANCE && alert.sourceId) {
  	        openPreventivePlanModal(company, vehicle, alert.sourceId);
  	      } else {
  	        selectTab("maintenance");
  	        state.maintenanceView = "preventive";
  	        render();
  	      }
  	      return;
  	    }
  	    if (alert.action === "preventive-job-schedule") {
  	      state.selectedAssetType = trailer ? "trailer" : "tractor";
  	      if (CAN_MANAGE_MAINTENANCE && alert.sourceId) {
  	        openPreventiveJobModal(company, vehicle, alert.sourceId);
  	      } else {
  	        selectTab("maintenance");
  	        state.maintenanceView = "preventive";
  	        render();
  	      }
  	      return;
  	    }
  	    if (alert.action === "compliance-setup") {
  	      state.selectedAssetType = trailer ? "trailer" : "tractor";
  	      if (CAN_EDIT_COMPLIANCE) {
  	        v21OpenComplianceRequirementsModal(company, vehicle);
  	      } else {
  	        selectTab("compliance");
  	      }
  	      return;
  	    }
  	    if (alert.action === "schedule-service") {
  	      state.selectedAssetType = trailer ? "trailer" : "tractor";
  	      if (!CAN_MANAGE_SERVICE_JOBS) {
  	        selectTab("service");
  	        return;
  	      }
  	      openWorkshopIntakeModal(company, vehicle, MAINTENANCE_CATEGORY_SERVICE, {
  	        Priority: alert.severity === "critical" ? "Critical" : alert.severity === "high" ? "High" : "Normal",
  	        Complaint: alert.message
  	      });
  	      return;
  	    }
  	    if (alert.action === "open-job") {
  	      state.selectedAssetType = trailer ? "trailer" : "tractor";
  	      openServiceJobModal(company, alert.sourceId, {});
  	      return;
  	    }
  	    if (alert.action === "tyre-swap") {
  	      selectTab("tyres");
  	      state.tyreMode = CAN_MANAGE_WORKSHOP ? "rotate" : "";
  	      setVehicleMessage(CAN_MANAGE_WORKSHOP ? "Rotate / Swap mode opened from the alert panel." : "Tyre workspace opened from the alert panel.", false);
  	      render();
  	      return;
  	    }
  	    if (alert.action === "compliance-renew") {
  	      state.selectedAssetType = trailer ? "trailer" : "tractor";
  	      if (CAN_EDIT_COMPLIANCE) {
  	        const sourceId = clean(alert.sourceId);
  	        const setupOnly = sourceId.indexOf("SETUP:") === 0;
  	        v21OpenComplianceModal(
  	          company,
  	          vehicle,
  	          "",
  	          setupOnly ? "" : sourceId,
  	          clean(alert.recordType)
  	        );
  	      } else {
  	        selectTab("compliance");
  	      }
  	      return;
  	    }
  	    if (alert.action === "fuel-capture") {
  	      if (!trailer) openOnRoadFuelCapture(company, vehicle);
  	      else selectTab("overview");
  	      return;
  	    }
  	    if (alert.action === "workshop-job") {
  	      state.selectedAssetType = trailer ? "trailer" : "tractor";
  	      const order = serviceWorkOrderById(company, alert.sourceId);
  	      if (!order) {
  	        selectTab("maintenance");
  	        return;
  	      }
  	      const phase = serviceCanonicalStatus(order.Status);
  	      const primary = servicePrimaryTransition(order);
  	      if (CAN_MANAGE_SERVICE_JOBS && alert.code === "WORKSHOP_BOOKING_OVERDUE") {
  	        openWorkshopActionMenu(company, order.WorkOrderId);
  	      } else if (CAN_MANAGE_SERVICE_JOBS && primary.target) {
  	        openServicePhaseModal(company, order.WorkOrderId, primary.target);
  	      } else {
  	        openServiceJobModal(company, order.WorkOrderId, { LockVehicle: true });
  	      }
  	      return;
  	    }
  	    if (alert.action === "vehicle-data") {
  	      selectTab(trailer ? "overview" : "physical");
  	      return;
  	    }
  	    selectTab("overview");
  	  }





  	  const ADAPTIVE_STYLE_ID = "fif-dashboard-experience-style";

  	  function adaptiveProfileContext(vehicle) {
  	    const data = fifCanonicalVehicleData(vehicle);
  	    const profile = clean(firstValue([
  	      descriptorValue(getDeep(data, ["Profile", "TemplateProfile"], "")),
  	      descriptorValue(getDeep(data, ["Profile", "VehicleClass"], "")),
  	      descriptorValue(getDeep(data, ["Vehicle", "Classification", "VehicleClass"], "")),
  	      vehicle && vehicle.Type
  	    ], "Unconfigured")) || "Unconfigured";
  	    const profileKey = lower(profile);
  	    const vehicleType = lower(descriptorValue(getDeep(data, ["Vehicle", "Classification", "VehicleType"], "")));
  	    const domains = arr(descriptorValue(getDeep(data, ["Profile", "OperatingDomain"], []))).map(lower);
  	    const commercial = descriptorValue(getDeep(data, ["Commercial", "Enabled"], false)) === true || /commercial|goods|truck tractor|bus/.test(profileKey) || domains.indexOf("commercial") !== -1 || ["commercial", "ldv"].indexOf(vehicleType) !== -1;
  	    const agricultural = descriptorValue(getDeep(data, ["Agricultural", "Enabled"], false)) === true || /agricultural|farm/.test(profileKey) || domains.indexOf("agricultural") !== -1 || vehicleType === "agricultural";
  	    const road = descriptorValue(getDeep(data, ["Vehicle", "Usage", "PublicRoad"], false)) === true || domains.indexOf("public road") !== -1 || ["personal", "ldv", "commercial"].indexOf(vehicleType) !== -1;
  	    const fuelType = lower(firstValue([
  	      descriptorValue(getDeep(data, ["FuelAndEnergy", "FuelGrade"], "")),
  	      descriptorValue(getDeep(data, ["FuelAndEnergy", "PrimaryEnergyType"], "")),
  	      descriptorValue(getDeep(data, ["Powertrain", "Engine", "EngineType"], ""))
  	    ], ""));
  	    return {
  	      profile: profile,
  	      declaredProfile: profile === "Unconfigured" ? "" : profile,
  	      configured: profile !== "Unconfigured",
  	      inferred: false,
  	      rule: {},
  	      commercial: commercial,
  	      agricultural: agricultural,
  	      road: road,
  	      heavy: /medium|heavy|truck tractor/.test(profileKey),
  	      private: /private|passenger|utility|suv/.test(profileKey) || vehicleType === "personal",
  	      electric: /electric/.test(fuelType),
  	      service: !!data.Service,
  	      maintenance: !!data.Maintenance || !!(vehicle && vehicle.Maintenance),
  	      tyres: !!(vehicle && vehicle.TPositions) || !!data.TPositions || !!data.Tyres || !!(vehicle && vehicle.Tyres),
  	      compliance: !!data.Compliance,
  	      telematics: !!data.Telematics || !!(vehicle && vehicle.Location),
  	      fuel: !assetIsTrailer(vehicle) && !/electric/.test(fuelType),
  	      sars: !assetIsTrailer(vehicle) && fifVehicleSarsComplianceValue(vehicle)
  	    };
  	  }

  	  function adaptiveAvailablePrimaryTabs(company, vehicle) {
  	    const tabs = [];
  	    const trailer = assetIsTrailer(vehicle);
  	    if (!trailer && CAN_ACCESS_VEHICLE_DATA) tabs.push({ key: "physical", label: "Vehicle Data" });
  	    if (CAN_ACCESS_SERVICE) tabs.push({ key: "service", label: "Service" });
  	    if (CAN_ACCESS_MAINTENANCE) tabs.push({ key: "maintenance", label: "Maintenance" });
  	    if (CAN_ACCESS_TYRES) tabs.push({ key: "tyres", label: "Tyres" });
  	    if (CAN_ACCESS_COMPLIANCE) tabs.push({ key: "compliance", label: "Compliance" });
  	    return tabs;
  	  }

  	  function renderVehicleManagerTabs() {
  	    const vehicle = selectedVehicle(selectedCompany());
  	    if (!vehicle) return "";
  	    const tabs = adaptiveAvailablePrimaryTabs(selectedCompany(), vehicle);
  	    return `<nav class="fifvm-tabs">${tabs.map(function (tab) {
  	      const active = state.vehicleActiveTab === tab.key;
  	      const locked = (["service", "maintenance"].indexOf(tab.key) !== -1 && !CAN_MANAGE_WORKSHOP) ||
  	        (tab.key === "tyres" && !CAN_MANAGE_WORKSHOP && !CAN_EDIT_VEHICLE_PHYSICAL);
  	      return `<button type="button" data-vm-tab="${escapeAttr(tab.key)}" class="${active ? "active" : ""}"><span>${escapeHtml(tab.label)}</span>${locked ? `<small>View only</small>` : ""}</button>`;
  	    }).join("")}</nav>`;
  	  }

  	  const FIF_ESSENTIAL_FUEL_GRADES = [
  	    "Diesel 10 ppm",
  	    "Diesel 50 ppm",
  	    "Petrol 93",
  	    "Petrol 95",
  	    "LPG",
  	    "CNG",
  	    "Other"
  	  ];

  	  const FIF_VEHICLE_TYPES = [
  	    "LDV",
  	    "Commercial",
  	    "Agricultural",
  	    "Plant",
  	    "Personal"
  	  ];

  	  function fifVehicleDataObject(vehicle) {
  	    const raw = vehicle && vehicle.Data;
  	    if (raw && typeof raw === "object" && !Array.isArray(raw)) return cloneData(raw);
  	    if (typeof raw === "string" && clean(raw)) {
  	      try {
  	        const parsed = JSON.parse(raw);
  	        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  	      } catch (_) {}
  	    }
  	    return {};
  	  }

  	  // Clone the entire CAN configuration, including its event rules. Never replace
  	  // an existing CAN object with a tank-only object when editing Essential Data.
  	  function fifVehicleCANObject(vehicle) {
  	    const raw = vehicle && vehicle.CAN;
  	    if (raw && typeof raw === "object" && !Array.isArray(raw)) return cloneData(raw);
  	    if (typeof raw === "string" && clean(raw)) {
  	      try {
  	        const parsed = JSON.parse(raw);
  	        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  	      } catch (_) {}
  	    }
  	    return {};
  	  }

  	  function fifCanonicalVehicleData(vehicle) {
  	    const data = fifVehicleDataObject(vehicle);
  	    if (!data.Vehicle || typeof data.Vehicle !== "object" || Array.isArray(data.Vehicle)) data.Vehicle = {};
  	    if (!data.Vehicle.Identity || typeof data.Vehicle.Identity !== "object" || Array.isArray(data.Vehicle.Identity)) data.Vehicle.Identity = {};
  	    if (!data.Vehicle.Classification || typeof data.Vehicle.Classification !== "object" || Array.isArray(data.Vehicle.Classification)) data.Vehicle.Classification = {};
  	    if (!data.Vehicle.Appearance || typeof data.Vehicle.Appearance !== "object" || Array.isArray(data.Vehicle.Appearance)) data.Vehicle.Appearance = {};
  	    if (!data.Vehicle.Usage || typeof data.Vehicle.Usage !== "object" || Array.isArray(data.Vehicle.Usage)) data.Vehicle.Usage = {};
  	    if (!data.FuelAndEnergy || typeof data.FuelAndEnergy !== "object" || Array.isArray(data.FuelAndEnergy)) data.FuelAndEnergy = {};
  	    if (!data.Compliance || typeof data.Compliance !== "object" || Array.isArray(data.Compliance)) data.Compliance = {};
  	    if (!data.Compliance.Setup || typeof data.Compliance.Setup !== "object" || Array.isArray(data.Compliance.Setup)) data.Compliance.Setup = {};
  	    if (!data.Compliance.Setup.Requirements || typeof data.Compliance.Setup.Requirements !== "object" || Array.isArray(data.Compliance.Setup.Requirements)) data.Compliance.Setup.Requirements = {};
  	    if (!data.Compliance.Setup.Requirements.VehicleLicence || typeof data.Compliance.Setup.Requirements.VehicleLicence !== "object" || Array.isArray(data.Compliance.Setup.Requirements.VehicleLicence)) {
  	      data.Compliance.Setup.Requirements.VehicleLicence = { Required: false, ExpiryDate: "" };
  	    }

  	    function seedDescriptor(parent, key, legacy, definition) {
  	      const existing = parent[key];
  	      const existingValue = descriptorValue(existing);
  	      if (existingValue !== undefined && existingValue !== null && clean(existingValue) !== "") return;
  	      if (legacy === undefined || legacy === null || clean(legacy) === "") return;
  	      parent[key] = Object.assign({ value: legacy, editable: true, selector: "text" }, definition || {});
  	    }

  	    seedDescriptor(data.Vehicle.Identity, "FID", vehicle && vehicle.FID, { selector: "text" });
  	    seedDescriptor(data.Vehicle.Identity, "Registration", vehicle && vehicle.Registration, { selector: "text" });
  	    seedDescriptor(data.Vehicle.Appearance, "Color", vehicle && vehicle.color, { selector: "color" });
  	    seedDescriptor(data.Vehicle.Usage, "CounterType", vehicle && vehicle.CounterType, {
  	      selector: "select",
  	      options: ["Kilometers", "Hours"]
  	    });
  	    const migratedCounterType = lower(descriptorValue(data.Vehicle.Usage.CounterType)) === "hours" ? "Hours" : "Kilometers";
  	    const migratedCounterUnitType = migratedCounterType === "Hours" ? "Time" : "Distance";
  	    seedDescriptor(data.Vehicle.Usage, "CurrentReading", vehicle && vehicle.Mileage, {
  	      selector: "number",
  	      editable: false,
  	      unitType: migratedCounterUnitType
  	    });
  	    seedDescriptor(data.Vehicle.Usage, "Range", vehicle && vehicle.Range, {
  	      selector: "number",
  	      unitType: migratedCounterUnitType
  	    });
  	    seedDescriptor(data.FuelAndEnergy, "SARSCompliance", vehicle && vehicle.SARSCompliance, { selector: "boolean" });
  	    seedDescriptor(data.FuelAndEnergy, "SARSRate", vehicle && vehicle.SARSRate, { selector: "number" });

  	    const agriculturalFieldPerformance = getDeep(data, ["Agricultural", "FieldPerformance"], null);
  	    const tankCandidates = [
  	      descriptorValue(data.FuelAndEnergy.TankCapacityL),
  	      descriptorValue(data.Vehicle.Tank_Capacity),
  	      descriptorValue(getDeep(data, ["Agricultural", "FieldPerformance", "FuelTankCapacityL"], null)),
  	      descriptorValue(getDeep(vehicle, ["CAN", "Tank"], null))
  	    ];
  	    let migratedTankCapacity = null;
  	    for (let tankIndex = 0; tankIndex < tankCandidates.length; tankIndex += 1) {
  	      const tankValue = numberValue(tankCandidates[tankIndex]);
  	      if (tankValue !== null && tankValue > 0) {
  	        migratedTankCapacity = tankValue;
  	        break;
  	      }
  	    }
  	    if (migratedTankCapacity !== null) {
  	      seedDescriptor(data.FuelAndEnergy, "TankCapacityL", migratedTankCapacity, {
  	        selector: "number",
  	        editable: true,
  	        unitType: "Volume"
  	      });
  	      seedDescriptor(data.Vehicle, "Tank_Capacity", migratedTankCapacity, {
  	        selector: "number",
  	        editable: true,
  	        unitType: "Volume"
  	      });
  	      if (agriculturalFieldPerformance && typeof agriculturalFieldPerformance === "object" && !Array.isArray(agriculturalFieldPerformance)) {
  	        seedDescriptor(agriculturalFieldPerformance, "FuelTankCapacityL", migratedTankCapacity, {
  	          selector: "number",
  	          editable: true,
  	          unitType: "Volume"
  	        });
  	      }
  	    }

  	    const licence = data.Compliance.Setup.Requirements.VehicleLicence;
  	    if (!clean(licence.ExpiryDate) && vehicle && vehicle.LicenseExpiry) {
  	      licence.ExpiryDate = fifEssentialDateValue(vehicle.LicenseExpiry);
  	      licence.Required = true;
  	    }

  	    return data;
  	  }

  	  function fifVehicleDataDescriptor(vehicle, path, fallback) {
  	    return descriptorValue(getDeep(fifCanonicalVehicleData(vehicle), path, fallback));
  	  }

  	  function fifVehicleIdentityValue(vehicle, key, fallback) {
  	    return fifVehicleDataDescriptor(vehicle, ["Vehicle", "Identity", key], fallback);
  	  }

  	  function fifVehicleClassificationValue(vehicle, key, fallback) {
  	    return fifVehicleDataDescriptor(vehicle, ["Vehicle", "Classification", key], fallback);
  	  }

  	  function fifVehicleUsageValue(vehicle, key, fallback) {
  	    return fifVehicleDataDescriptor(vehicle, ["Vehicle", "Usage", key], fallback);
  	  }

  	  function fifVehicleFuelAndEnergyValue(vehicle, key, fallback) {
  	    return fifVehicleDataDescriptor(vehicle, ["FuelAndEnergy", key], fallback);
  	  }

  	  function fifVehicleColorValue(vehicle) {
  	    return safeColor(fifVehicleDataDescriptor(vehicle, ["Vehicle", "Appearance", "Color"], "#cc6633"), "#cc6633");
  	  }

  	  function fifVehicleCurrentReading(vehicle) {
  	    return numberValue(fifVehicleUsageValue(vehicle, "CurrentReading", null));
  	  }

  	  function fifVehicleCounterTypeValue(vehicle) {
  	    const value = clean(fifVehicleUsageValue(vehicle, "CounterType", "Kilometers"));
  	    return lower(value) === "hours" ? "Hours" : "Kilometers";
  	  }

  	  function fifVehicleRangeValue(vehicle) {
  	    const value = numberValue(fifVehicleUsageValue(vehicle, "Range", null));
  	    return value === null || value < 0 ? 0 : value;
  	  }

  	  function fifVehicleSarsComplianceValue(vehicle) {
  	    const value = fifVehicleFuelAndEnergyValue(vehicle, "SARSCompliance", false);
  	    return value === true || lower(value) === "true" || lower(value) === "yes";
  	  }

  	  function fifVehicleTankCapacityValue(vehicle) {
  	    const data = fifCanonicalVehicleData(vehicle);
  	    const candidates = [
  	      descriptorValue(getDeep(data, ["FuelAndEnergy", "TankCapacityL"], null)),
  	      descriptorValue(getDeep(data, ["Vehicle", "Tank_Capacity"], null)),
  	      descriptorValue(getDeep(data, ["Agricultural", "FieldPerformance", "FuelTankCapacityL"], null)),
  	      descriptorValue(getDeep(vehicle, ["CAN", "Tank"], null))
  	    ];
  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const value = numberValue(candidates[index]);
  	      if (value !== null && value > 0) return value;
  	    }
  	    return 0;
  	  }



  	  function fifEssentialDateValue(value) {
  	    if (value === null || value === undefined || value === "") return "";
  	    let date;
  	    if (value instanceof Date) date = value;
  	    else if (typeof value === "number" || /^\d{11,}$/.test(String(value))) date = new Date(Number(value));
  	    else date = new Date(value);
  	    if (Number.isNaN(date.getTime())) return "";
  	    return date.getFullYear() + "-" + fifDatePad(date.getMonth() + 1) + "-" + fifDatePad(date.getDate());
  	  }

  	  function fifEssentialDateTimestamp(value) {
  	    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(clean(value));
  	    if (!match) return null;
  	    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12, 0, 0, 0);
  	    return Number.isNaN(date.getTime()) ? null : date.getTime();
  	  }

  	  function fifEssentialFuelGrade(vehicle) {
  	    return clean(fifVehicleFuelAndEnergyValue(vehicle, "FuelGrade", ""));
  	  }

  	  function fifEssentialSnapshot(vehicle) {
  	    const data = fifCanonicalVehicleData(vehicle);
  	    const counter = fifVehicleCounterTypeValue(vehicle);
  	    const licenceExpiry = clean(getDeep(data, ["Compliance", "Setup", "Requirements", "VehicleLicence", "ExpiryDate"], ""));
  	    const sarsComplianceRaw = fifVehicleFuelAndEnergyValue(vehicle, "SARSCompliance", null);
  	    return {
  	      FID: clean(fifVehicleIdentityValue(vehicle, "FID", "")),
  	      Registration: clean(fifVehicleIdentityValue(vehicle, "Registration", "")),
  	      color: fifVehicleColorValue(vehicle),
  	      FuelGrade: fifEssentialFuelGrade(vehicle),
  	      TankCapacity: fifVehicleTankCapacityValue(vehicle) || "",
  	      LicenseExpiry: fifEssentialDateValue(licenceExpiry),
  	      Range: fifVehicleRangeValue(vehicle) || "",
  	      CounterType: counter,
  	      SARSCompliance: sarsComplianceRaw === null || sarsComplianceRaw === undefined || sarsComplianceRaw === ""
  	        ? null
  	        : fifVehicleSarsComplianceValue(vehicle),
  	      SARSRate: numberValue(fifVehicleFuelAndEnergyValue(vehicle, "SARSRate", null)) === null
  	        ? ""
  	        : Number(fifVehicleFuelAndEnergyValue(vehicle, "SARSRate", 0))
  	    };
  	  }

  	  function fifEssentialDraftEquals(left, right) {
  	    return JSON.stringify(left || {}) === JSON.stringify(right || {});
  	  }

  	  function fifRefreshVehicleDataDirty() {
  	    state.vehicleDataDirty = !!(state.vehicleDataEssentialDirty || state.vehicleIdentityDirty);
  	    return state.vehicleDataDirty;
  	  }

  	  function fifVehicleDataHasActiveEditor() {
  	    return !!(state.vehicleDataEditMode || state.vehicleIdentityEditMode);
  	  }

  	  function fifIdentitySnapshot(vehicle) {
  	    const data = fifCanonicalVehicleData(vehicle);
  	    const year = numberValue(descriptorValue(getDeep(data, ["Vehicle", "Identity", "Year"], "")));
  	    return {
  	      Manufacturer: clean(descriptorValue(getDeep(data, ["Vehicle", "Identity", "Make"], ""))),
  	      Model: clean(descriptorValue(getDeep(data, ["Vehicle", "Identity", "Model"], ""))),
  	      ModelYear: year === null ? "" : Math.trunc(year),
  	      VIN: clean(descriptorValue(getDeep(data, ["Vehicle", "Identity", "VIN"], ""))),
  	      EngineNumber: clean(descriptorValue(getDeep(data, ["Vehicle", "Identity", "EngineNumber"], ""))),
  	      VehicleType: clean(descriptorValue(getDeep(data, ["Vehicle", "Classification", "VehicleType"], "")))
  	    };
  	  }

  	  function fifIdentityField(label, body) {
  	    return `<label class="fif-essential-field"><span>${escapeHtml(label)}</span>${body}</label>`;
  	  }

  	  function fifSetCanonicalDescriptor(parent, key, value, definition) {
  	    const existing = parent[key];
  	    if (existing && typeof existing === "object" && !Array.isArray(existing) && Object.prototype.hasOwnProperty.call(existing, "value")) {
  	      existing.value = value;
  	      if (definition && Array.isArray(definition.options)) existing.options = definition.options.slice();
  	      if (definition && definition.selector) existing.selector = definition.selector;
  	      if (definition && typeof definition.editable === "boolean") existing.editable = definition.editable;
  	      if (definition && definition.unitType) existing.unitType = definition.unitType;
  	      return existing;
  	    }
  	    parent[key] = Object.assign({ value: value, editable: true, selector: "text" }, definition || {});
  	    return parent[key];
  	  }

  	  function fifEssentialViewValue(value, fallback) {
  	    if (value === null || value === undefined || value === "") return fallback || "Not set";
  	    return String(value);
  	  }

  	  function fifEssentialField(label, body, note, wide) {
  	    return `<label class="fif-essential-field${wide ? " is-wide" : ""}"><span>${escapeHtml(label)}</span>${body}</label>`;
  	  }

  	  function fifEssentialColourControl(value, editMode) {
  	    const colour = safeColor(value, "#cc6633");
  	    if (!editMode) {
  	      return `<div class="fif-essential-read-colour" style="--selected-colour:${escapeAttr(colour)}"><i></i><strong>${escapeHtml(colour.toUpperCase())}</strong></div>`;
  	    }
  	    return `<div class="fifvm-colour-control is-editable" data-vm-colour-control style="--selected-colour:${escapeAttr(colour)}">
  	      <input type="hidden" name="color" value="${escapeAttr(colour)}" data-vm-colour-value data-essential-field="color">
  	      <button type="button" class="fifvm-colour-trigger" data-vm-colour-trigger>
  	        <span class="fifvm-colour-swatch"><i></i></span>
  	        <span class="fifvm-colour-copy"><output data-vm-colour-output>${escapeHtml(colour.toUpperCase())}</output></span><b></b>
  	      </button>
  	    </div>`;
  	  }

  	  function renderEssentialDataFields(vehicle, draft, editMode) {
  	    const fuelOptions = [""].concat(FIF_ESSENTIAL_FUEL_GRADES).map(function (option) {
  	      return `<option value="${escapeAttr(option)}" ${clean(draft.FuelGrade) === option ? "selected" : ""}>${escapeHtml(option || "Select fuel grade")}</option>`;
  	    }).join("");
  	    const counterOptions = ["", "Kilometers", "Hours"].map(function (option) {
  	      return `<option value="${escapeAttr(option)}" ${clean(draft.CounterType) === option ? "selected" : ""}>${escapeHtml(option || "Select counter type")}</option>`;
  	    }).join("");
  	    const complianceOptions = [
  	      { value: "", label: "Select compliance" },
  	      { value: "true", label: "Compliant" },
  	      { value: "false", label: "Not compliant" }
  	    ].map(function (option) {
  	      const selected = draft.SARSCompliance === null ? option.value === "" : String(draft.SARSCompliance) === option.value;
  	      return `<option value="${escapeAttr(option.value)}" ${selected ? "selected" : ""}>${escapeHtml(option.label)}</option>`;
  	    }).join("");

  	    if (!editMode) {
  	      return `<div class="fif-essential-grid is-readonly">
  	        ${fifEssentialField("Fleet ID", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.FID))}</div>`, "Data.Vehicle.Identity.FID")}
  	        ${fifEssentialField("Registration", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.Registration))}</div>`, "Data.Vehicle.Identity.Registration")}
  	        ${fifEssentialField("Asset colour", fifEssentialColourControl(draft.color, false), "Data.Vehicle.Appearance.Color")}
  	        ${fifEssentialField("Fuel grade", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.FuelGrade))}</div>`, "Data.FuelAndEnergy.FuelGrade")}
  	        ${fifEssentialField("Tank size", `<div class="fif-essential-value">${draft.TankCapacity === "" ? "Not set" : escapeHtml(formatNumber(draft.TankCapacity, 0)) + " L"}</div>`, "Data.FuelAndEnergy.TankCapacityL")}
  	        ${fifEssentialField("Licence expiry", `<div class="fif-essential-value">${escapeHtml(draft.LicenseExpiry ? fifDateDisplayValue(draft.LicenseExpiry, "date") : "Not set")}</div>`, "Data.Compliance.Setup.Requirements.VehicleLicence.ExpiryDate")}
  	        ${fifEssentialField("Range safeguard", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.Range))}</div>`, "Data.Vehicle.Usage.Range")}
  	        ${fifEssentialField("Counter type", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.CounterType))}</div>`, "Data.Vehicle.Usage.CounterType")}
  	        ${fifEssentialField("SARS compliance", `<div class="fif-essential-value">${draft.SARSCompliance === true ? "Compliant" : draft.SARSCompliance === false ? "Not compliant" : "Not set"}</div>`, "Data.FuelAndEnergy.SARSCompliance")}
  	        ${fifEssentialField("SARS rebate rate", `<div class="fif-essential-value">${draft.SARSRate === "" ? "Not set" : "R " + escapeHtml(formatNumber(draft.SARSRate, 2)) + " / L"}</div>`, "Data.FuelAndEnergy.SARSRate")}
  	      </div>`;
  	    }

  	    return `<form class="fif-essential-form" data-essential-form novalidate><div class="fif-essential-grid">
  	      ${fifEssentialField("Fleet ID", `<input name="FID" type="text" required maxlength="100" value="${escapeAttr(draft.FID)}" data-essential-field="FID">`, "Unique operational fleet identifier")}
  	      ${fifEssentialField("Registration", `<input name="Registration" type="text" required maxlength="100" value="${escapeAttr(draft.Registration)}" data-essential-field="Registration">`, "Vehicle registration number")}
  	      ${fifEssentialField("Asset colour", fifEssentialColourControl(draft.color, true), "Styled Fleet In Form colour picker")}
  	      ${fifEssentialField("Fuel grade", `<select name="FuelGrade" required data-essential-field="FuelGrade">${fuelOptions}</select>`, "Stored only at Data.FuelAndEnergy.FuelGrade")}
  	      ${fifEssentialField("Tank size", `<div class="fif-essential-unit-input is-suffix-only"><input name="TankCapacity" type="number" min="1" step="1" required value="${escapeAttr(draft.TankCapacity)}" data-essential-field="TankCapacity"><b>L</b></div>`, "Main fuel tank capacity; synchronized across canonical tank-capacity mirrors")}
  	      ${fifEssentialField("Licence expiry", `<input name="LicenseExpiry" type="date" required value="${escapeAttr(draft.LicenseExpiry)}" data-essential-field="LicenseExpiry">`, "Saved to the canonical Vehicle Licence expiry date in Data JSON")}
  	      ${fifEssentialField("Range safeguard", `<input name="Range" type="number" min="1" step="1" required value="${escapeAttr(draft.Range)}" data-essential-field="Range">`, "Maximum permitted reading movement safeguard")}
  	      ${fifEssentialField("Counter type", `<select name="CounterType" required data-essential-field="CounterType">${counterOptions}</select>`, "Kilometers or Hours")}
  	      ${fifEssentialField("SARS compliance", `<select name="SARSCompliance" required data-essential-field="SARSCompliance">${complianceOptions}</select>`, "Explicit vehicle rebate eligibility")}
  	      ${fifEssentialField("SARS rebate rate", `<div class="fif-essential-unit-input"><span>R</span><input name="SARSRate" type="number" min="0" step="0.01" required value="${escapeAttr(draft.SARSRate)}" data-essential-field="SARSRate"><b>/ L</b></div>`, "A compliant vehicle requires a rate above zero")}
  	    </div><div class="fif-essential-actions"><button type="button" class="fifvm-btn ghost" data-essential-cancel>Cancel</button><button type="submit" class="fifvm-btn primary" data-essential-save ${state.vehicleBusy ? "disabled" : ""}>${state.vehicleBusy ? "Saving…" : "Save Essential Data"}</button></div></form>`;
  	  }

  	  function renderVehicleDataEssential(vehicle) {
  	    const editMode = !!state.vehicleDataEditMode;
  	    if (editMode && !state.vehicleDataDraft) {
  	      state.vehicleDataDraft = fifEssentialSnapshot(vehicle);
  	      state.vehicleDataOriginal = cloneData(state.vehicleDataDraft);
  	      state.vehicleDataEssentialDirty = false;
  	      fifRefreshVehicleDataDirty();
  	    }
  	    const draft = editMode ? state.vehicleDataDraft : fifEssentialSnapshot(vehicle);
  	    const open = state.vehicleDataEssentialOpen !== false;
  	    const actions = CAN_EDIT_VEHICLE_PHYSICAL && !editMode && !fifVehicleDataHasActiveEditor()
  	      ? `<button type="button" class="fifvm-btn primary" data-essential-edit>Edit Essential Data</button>`
  	      : "";
  	    return `<section class="fif-essential-section ${open ? "is-open" : ""}" data-essential-section>
  	      <header>
  	        <button type="button" class="fif-essential-toggle" data-essential-toggle aria-expanded="${open ? "true" : "false"}"><span><strong>Essential Data</strong></span><i></i></button>
  	        ${actions}
  	      </header>
  	      <div class="fif-essential-body" ${open ? "" : "hidden"}>${renderEssentialDataFields(vehicle, draft, editMode)}</div>
  	    </section>`;
  	  }

  	  function renderVehicleIdentityFields(vehicle, draft, editMode) {
  	    const vehicleTypeOptions = [""].concat(FIF_VEHICLE_TYPES).map(function (option) {
  	      return `<option value="${escapeAttr(option)}" ${clean(draft.VehicleType) === option ? "selected" : ""}>${escapeHtml(option || "Select vehicle type")}</option>`;
  	    }).join("");
  	    const currentYear = new Date().getFullYear();

  	    if (!editMode) {
  	      return `<div class="fif-essential-grid is-readonly">
  	        ${fifIdentityField("Manufacturer", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.Manufacturer))}</div>`, "Data.Vehicle.Identity.Make", true)}
  	        ${fifIdentityField("Model", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.Model))}</div>`, "Data.Vehicle.Identity.Model", true)}
  	        ${fifIdentityField("Model year", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.ModelYear))}</div>`, "Data.Vehicle.Identity.Year", true)}
  	        ${fifIdentityField("VIN", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.VIN))}</div>`, "Data.Vehicle.Identity.VIN", false)}
  	        ${fifIdentityField("Engine number", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.EngineNumber))}</div>`, "Data.Vehicle.Identity.EngineNumber", false)}
  	        ${fifIdentityField("Vehicle type", `<div class="fif-essential-value">${escapeHtml(fifEssentialViewValue(draft.VehicleType))}</div>`, "Data.Vehicle.Classification.VehicleType", true)}
  	      </div>`;
  	    }

  	    return `<form class="fif-essential-form" data-identity-form novalidate><div class="fif-essential-grid">
  	      ${fifIdentityField("Manufacturer", `<input name="Manufacturer" type="text" maxlength="120" value="${escapeAttr(draft.Manufacturer)}" data-identity-field="Manufacturer">`, "Vehicle manufacturer", true)}
  	      ${fifIdentityField("Model", `<input name="Model" type="text" maxlength="180" value="${escapeAttr(draft.Model)}" data-identity-field="Model">`, "Model and derivative", true)}
  	      ${fifIdentityField("Model year", `<input name="ModelYear" type="number" min="1900" max="${currentYear + 1}" step="1" value="${escapeAttr(draft.ModelYear)}" data-identity-field="ModelYear">`, "Four-digit model year", true)}
  	      ${fifIdentityField("VIN", `<input name="VIN" type="text" maxlength="50" autocomplete="off" value="${escapeAttr(draft.VIN)}" data-identity-field="VIN">`, "Uppercase; spaces are removed on save", false)}
  	      ${fifIdentityField("Engine number", `<input name="EngineNumber" type="text" maxlength="100" autocomplete="off" value="${escapeAttr(draft.EngineNumber)}" data-identity-field="EngineNumber">`, "Stored exactly once in the canonical identity record", false)}
  	      ${fifIdentityField("Vehicle type", `<select name="VehicleType" data-identity-field="VehicleType">${vehicleTypeOptions}</select>`, "LDV, Commercial, Agricultural, Plant or Personal", true)}
  	    </div><div class="fif-essential-actions"><button type="button" class="fifvm-btn ghost" data-identity-cancel>Cancel</button><button type="submit" class="fifvm-btn primary" data-identity-save ${state.vehicleBusy ? "disabled" : ""}>${state.vehicleBusy ? "Saving…" : "Save Vehicle Identity"}</button></div></form>`;
  	  }

  	  function renderVehicleDataIdentity(vehicle) {
  	    const editMode = !!state.vehicleIdentityEditMode;
  	    if (editMode && !state.vehicleIdentityDraft) {
  	      state.vehicleIdentityDraft = fifIdentitySnapshot(vehicle);
  	      state.vehicleIdentityOriginal = cloneData(state.vehicleIdentityDraft);
  	      state.vehicleIdentityDirty = false;
  	      fifRefreshVehicleDataDirty();
  	    }
  	    const draft = editMode ? state.vehicleIdentityDraft : fifIdentitySnapshot(vehicle);
  	    const open = state.vehicleDataIdentityOpen === true;
  	    const actions = CAN_EDIT_VEHICLE_PHYSICAL && !editMode && !fifVehicleDataHasActiveEditor()
  	      ? `<button type="button" class="fifvm-btn primary" data-identity-edit>Edit Vehicle Identity</button>`
  	      : "";
  	    return `<section class="fif-essential-section ${open ? "is-open" : ""}" data-identity-section>
  	      <header>
  	        <button type="button" class="fif-essential-toggle" data-identity-toggle aria-expanded="${open ? "true" : "false"}"><span><strong>Vehicle Identity</strong></span><i></i></button>
  	        ${actions}
  	      </header>
  	      <div class="fif-essential-body" ${open ? "" : "hidden"}>${renderVehicleIdentityFields(vehicle, draft, editMode)}</div>
  	    </section>`;
  	  }

  	  function fifUpdateIdentityDraftField(field, rawValue) {
  	    if (!state.vehicleIdentityDraft) return;
  	    let value = rawValue;
  	    if (field === "ModelYear") value = rawValue === "" ? "" : Number(rawValue);
  	    state.vehicleIdentityDraft[field] = value;
  	    state.vehicleIdentityDirty = !fifEssentialDraftEquals(state.vehicleIdentityDraft, state.vehicleIdentityOriginal);
  	    fifRefreshVehicleDataDirty();
  	  }

  	  async function saveVehicleIdentityData(company, vehicle) {
  	    if (!CAN_EDIT_VEHICLE_PHYSICAL || !state.vehicleIdentityDraft || !vehicle) return;
  	    const draft = cloneData(state.vehicleIdentityDraft);
  	    const errors = [];
  	    const manufacturer = clean(draft.Manufacturer);
  	    const model = clean(draft.Model);
  	    const modelYear = draft.ModelYear === "" || draft.ModelYear === null || draft.ModelYear === undefined ? "" : Number(draft.ModelYear);
  	    const currentYear = new Date().getFullYear();
  	    const vin = clean(draft.VIN).toUpperCase().replace(/\s+/g, "");
  	    const engineNumber = clean(draft.EngineNumber).replace(/\s+/g, " ");
  	    const vehicleType = clean(draft.VehicleType);

  	    if (modelYear !== "" && (!Number.isInteger(modelYear) || modelYear < 1900 || modelYear > currentYear + 1)) errors.push("Enter a valid four-digit model year or leave it blank.");
  	    if (vehicleType && FIF_VEHICLE_TYPES.indexOf(vehicleType) === -1) errors.push("Select a valid vehicle type or leave it blank.");
  	    if (errors.length) {
  	      await fifAlert(errors.join("\n"), { title: "Check Vehicle Identity", type: "warning", confirmText: "Correct Data" });
  	      return;
  	    }

  	    const updated = cloneData(vehicle);
  	    const data = fifCanonicalVehicleData(vehicle);
  	    if (!data.Vehicle || typeof data.Vehicle !== "object" || Array.isArray(data.Vehicle)) data.Vehicle = {};
  	    if (!data.Vehicle.Identity || typeof data.Vehicle.Identity !== "object" || Array.isArray(data.Vehicle.Identity)) data.Vehicle.Identity = {};
  	    if (!data.Vehicle.Classification || typeof data.Vehicle.Classification !== "object" || Array.isArray(data.Vehicle.Classification)) data.Vehicle.Classification = {};

  	    fifSetCanonicalDescriptor(data.Vehicle.Identity, "Make", manufacturer, { editable: true, selector: "text" });
  	    fifSetCanonicalDescriptor(data.Vehicle.Identity, "Model", model, { editable: true, selector: "text" });
  	    fifSetCanonicalDescriptor(data.Vehicle.Identity, "Year", modelYear, { editable: true, selector: "number" });
  	    fifSetCanonicalDescriptor(data.Vehicle.Identity, "VIN", vin, { editable: true, selector: "text" });
  	    fifSetCanonicalDescriptor(data.Vehicle.Identity, "EngineNumber", engineNumber, { editable: true, selector: "text" });
  	    fifSetCanonicalDescriptor(data.Vehicle.Classification, "VehicleType", vehicleType, {
  	      options: FIF_VEHICLE_TYPES.slice(),
  	      editable: true,
  	      selector: "select"
  	    });
  	    updated.Data = data;

  	    const payload = {
  	      objectId: objectIdOf(vehicle),
  	      Data: cloneData(updated.Data)
  	    };
  	    if (!payload.objectId) {
  	      await fifAlert("The selected Tractor has no objectId and cannot be updated.", { title: "Save Blocked", type: "danger" });
  	      return;
  	    }

  	    const operation = fifBeginSaveOperation("Preparing Vehicle Identity database save…");
  	    state.vehicleBusy = true;
  	    try {
  	      const databaseResult =
  	        await fifSaveDatabaseRowAndReadBack(
  	          "Tractors",
  	          payload,
  	          {
  	            verify: function (row) {
  	              const rowData =
  	                row && row.Data && typeof row.Data === "object"
  	                  ? row.Data
  	                  : {};

  	              return (
  	                clean(
  	                  descriptorValue(
  	                    getDeep(
  	                      rowData,
  	                      ["Vehicle", "Identity", "Make"],
  	                      ""
  	                    )
  	                  )
  	                ) === manufacturer &&
  	                clean(
  	                  descriptorValue(
  	                    getDeep(
  	                      rowData,
  	                      ["Vehicle", "Identity", "Model"],
  	                      ""
  	                    )
  	                  )
  	                ) === model &&
  	                clean(
  	                  descriptorValue(
  	                    getDeep(
  	                      rowData,
  	                      ["Vehicle", "Classification", "VehicleType"],
  	                      ""
  	                    )
  	                  )
  	                ) === vehicleType
  	              );
  	            },
  	            verifyMessage:
  	              "The Tractor save request returned, but the Vehicle Identity values were not persisted in the database. AppData was not changed."
  	          }
  	        );

  	      fifReconcileVehicleAppData(
  	        company,
  	        vehicle,
  	        databaseResult.value,
  	        databaseResult.value,
  	        "Tractors"
  	      );
  	      state.vehicleIdentityEditMode = false;
  	      state.vehicleIdentityDraft = null;
  	      state.vehicleIdentityOriginal = null;
  	      state.vehicleIdentityDirty = false;
  	      fifRefreshVehicleDataDirty();
  	      state.vehicleBusy = false;
  	      state.actionableAlertCache = {};
  	      setVehicleMessage("Vehicle identity saved.", false);
  	      fifCompleteSaveOperation(operation, "Vehicle identity saved.");
  	      render();
  	    } catch (error) {
  	      state.vehicleBusy = false;
  	      fifFailSaveOperation(operation, error);
  	      setVehicleMessage(error && error.message ? error.message : "Vehicle identity could not be saved.", true);
  	    }
  	  }

  	  function renderVehicleDataWorkspace(vehicle) {
  	    return `<section class="fif-vehicle-data-root">
  	      ${renderVehicleDataEssential(vehicle)}
  	      ${renderVehicleDataIdentity(vehicle)}
  	    </section>`;
  	  }

  	  function fifUpdateEssentialDraftField(field, rawValue) {
  	    if (!state.vehicleDataDraft) return;
  	    let value = rawValue;
  	    if (field === "Range" || field === "SARSRate" || field === "TankCapacity") value = rawValue === "" ? "" : Number(rawValue);
  	    if (field === "SARSCompliance") value = rawValue === "" ? null : rawValue === "true";
  	    if (field === "color") value = safeColor(rawValue, "#cc6633");
  	    state.vehicleDataDraft[field] = value;
  	    state.vehicleDataEssentialDirty = !fifEssentialDraftEquals(state.vehicleDataDraft, state.vehicleDataOriginal);
  	    fifRefreshVehicleDataDirty();
  	  }

  	  function fifBackendlessTractorEssentialMatches(
  	    record,
  	    expected
  	  ) {
  	    if (
  	      !record ||
  	      typeof record !== "object" ||
  	      !expected ||
  	      typeof expected !== "object"
  	    ) {
  	      return false;
  	    }

  	    const nestedData =
  	      record.Data &&
  	      typeof record.Data === "object"
  	        ? record.Data
  	        : {};

  	    const nestedMirrors =
  	      fifExtractTractorTopLevelMirrors({
  	        Data: nestedData
  	      }) || {};

  	    const expectedTopLevel = {
  	      ID: expected.ID,
  	      FID: expected.FID,
  	      Registration: expected.Registration,
  	      color: expected.color,
  	      LicenseExpiry: expected.LicenseExpiry,
  	      Range: expected.Range,
  	      CounterType: expected.CounterType,
  	      SARSCompliance: expected.SARSCompliance,
  	      SARSRate: expected.SARSRate
  	    };

  	    const expectedTankCapacity = numberValue(
  	      descriptorValue(
  	        getDeep(
  	          expected,
  	          ["Data", "FuelAndEnergy", "TankCapacityL"],
  	          null
  	        )
  	      )
  	    );
  	    const tankMirrorValues = [
  	      descriptorValue(getDeep(nestedData, ["FuelAndEnergy", "TankCapacityL"], null)),
  	      descriptorValue(getDeep(nestedData, ["Vehicle", "Tank_Capacity"], null))
  	    ];
  	    const expectedAgriculturalTank = getDeep(
  	      expected,
  	      ["Data", "Agricultural", "FieldPerformance", "FuelTankCapacityL"],
  	      undefined
  	    );
  	    if (expectedAgriculturalTank !== undefined) {
  	      tankMirrorValues.push(
  	        descriptorValue(
  	          getDeep(
  	            nestedData,
  	            ["Agricultural", "FieldPerformance", "FuelTankCapacityL"],
  	            null
  	          )
  	        )
  	      );
  	    }
  	    const tankMirrorsMatch =
  	      expectedTankCapacity !== null &&
  	      tankMirrorValues.every(function (value) {
  	        const numeric = numberValue(value);
  	        return numeric !== null && numeric === expectedTankCapacity;
  	      });
  	    // CAN.Tank is a numeric litre capacity used by CAN fuel event rules.
  	    // Include it in the actual Backendless GET verification, not just the UI.
  	    const expectedCANTank = numberValue(fifVehicleCANObject(expected).Tank);
  	    const savedCANTank = numberValue(fifVehicleCANObject(record).Tank);
  	    const canTankMatches =
  	      expectedTankCapacity !== null &&
  	      expectedCANTank === expectedTankCapacity &&
  	      savedCANTank === expectedTankCapacity;

  	    return (
  	      fifTractorTopLevelMirrorsMatch(
  	        record,
  	        expectedTopLevel
  	      ) &&
  	      fifTractorTopLevelMirrorsMatch(
  	        nestedMirrors,
  	        expectedTopLevel
  	      ) &&
  	      tankMirrorsMatch &&
  	      canTankMatches
  	    );
  	  }



  	  async function saveEssentialVehicleData(company, vehicle) {
  	    if (!CAN_EDIT_VEHICLE_PHYSICAL || !state.vehicleDataDraft || !vehicle) {
  	      fifStartTractorDebug({
  	        action: "Essential save blocked before start"
  	      });
  	      fifFinishTractorDebug("failed", {
  	        reason: "Missing permission, draft or selected vehicle.",
  	        canEdit: CAN_EDIT_VEHICLE_PHYSICAL,
  	        hasDraft: !!state.vehicleDataDraft,
  	        hasVehicle: !!vehicle
  	      });
  	      return;
  	    }

  	    fifStartTractorDebug({
  	      action: "Save Essential Data",
  	      objectId: objectIdOf(vehicle),
  	      registration: vehicleRegistrationValue(vehicle)
  	    });

  	    fifTractorLog("ESSENTIAL SAVE ENTRY", {
  	      selectedVehicle: vehicle,
  	      selectedVehicleEssential: fifDebugEssential(vehicle),
  	      selectedAppDataVehicle: selectedVehicle(company),
  	      selectedAppDataEssential: fifDebugEssential(selectedVehicle(company)),
  	      stateDraft: state.vehicleDataDraft,
  	      state: {
  	        selectedVehicleKey: state.selectedVehicleKey,
  	        selectedAssetType: state.selectedAssetType,
  	        vehicleBusy: state.vehicleBusy,
  	        vehicleDataEssentialDirty: state.vehicleDataEssentialDirty
  	      }
  	    });

  	    const draft = cloneData(state.vehicleDataDraft);

  	    fifTractorLog("CLONED ESSENTIAL FORM DRAFT", {
  	      draft: draft,
  	      descriptors: fifDebugDescriptors(draft)
  	    });
  	    const errors = [];
  	    if (!clean(draft.FID)) errors.push("Fleet ID is required.");
  	    if (!clean(draft.Registration)) errors.push("Registration is required.");
  	    if (!/^#[0-9a-f]{6}$/i.test(clean(draft.color))) errors.push("A valid asset colour is required.");
  	    if (FIF_ESSENTIAL_FUEL_GRADES.indexOf(clean(draft.FuelGrade)) === -1) errors.push("Select a valid fuel grade.");
  	    const tankCapacity = Number(draft.TankCapacity);
  	    if (!Number.isFinite(tankCapacity) || tankCapacity <= 0) errors.push("Tank size must be greater than zero litres.");
  	    const expiryTimestamp = fifEssentialDateTimestamp(draft.LicenseExpiry);
  	    if (expiryTimestamp === null) errors.push("Licence expiry is required.");
  	    const range = Number(draft.Range);
  	    if (!Number.isFinite(range) || range <= 0) errors.push("Range must be greater than zero.");
  	    if (["Kilometers", "Hours"].indexOf(clean(draft.CounterType)) === -1) errors.push("Select Kilometers or Hours as the counter type.");
  	    if (typeof draft.SARSCompliance !== "boolean") errors.push("Select the SARS compliance status.");
  	    const sarsRate = Number(draft.SARSRate);
  	    if (!Number.isFinite(sarsRate) || sarsRate < 0) errors.push("Enter a valid SARS rebate rate.");
  	    if (draft.SARSCompliance === true && !(sarsRate > 0)) errors.push("A SARS-compliant vehicle requires a rebate rate above zero.");
  	    fifTractorLog(
  	      "ESSENTIAL VALIDATION RESULT",
  	      {
  	        errors: errors,
  	        expiryTimestamp: expiryTimestamp,
  	        range: range,
  	        tankCapacity: tankCapacity,
  	        counterType: draft.CounterType,
  	        sarsCompliance: draft.SARSCompliance,
  	        sarsRate: sarsRate
  	      },
  	      errors.length ? "error" : "log"
  	    );

  	    if (errors.length) {
  	      fifFinishTractorDebug("failed", {
  	        stage: "validation",
  	        errors: errors
  	      });
  	      await fifAlert(errors.join("\n"), { title: "Essential Data Incomplete", type: "warning", confirmText: "Correct Data" });
  	      return;
  	    }

  	    const updated = cloneData(vehicle);
  	    const data = fifCanonicalVehicleData(vehicle);
  	    const counterType = clean(draft.CounterType);
  	    const counterUnitType = counterType === "Hours" ? "Time" : "Distance";

  	    fifSetCanonicalDescriptor(data.Vehicle.Identity, "FID", clean(draft.FID), { editable: true, selector: "text" });
  	    fifSetCanonicalDescriptor(data.Vehicle.Identity, "Registration", clean(draft.Registration), { editable: true, selector: "text" });
  	    fifSetCanonicalDescriptor(data.Vehicle.Appearance, "Color", safeColor(draft.color, "#cc6633"), { editable: true, selector: "color" });
  	    fifSetCanonicalDescriptor(data.Vehicle.Usage, "CounterType", counterType, {
  	      options: ["Kilometers", "Hours"],
  	      editable: true,
  	      selector: "select"
  	    });
  	    fifSetCanonicalDescriptor(data.Vehicle.Usage, "Range", range, {
  	      editable: true,
  	      selector: "number",
  	      unitType: counterUnitType
  	    });
  	    if (!Object.prototype.hasOwnProperty.call(data.Vehicle.Usage, "CurrentReading")) {
  	      fifSetCanonicalDescriptor(data.Vehicle.Usage, "CurrentReading", tractorMileage(vehicle) === null ? 0 : tractorMileage(vehicle), {
  	        editable: false,
  	        selector: "number",
  	        unitType: counterUnitType
  	      });
  	    } else if (data.Vehicle.Usage.CurrentReading && typeof data.Vehicle.Usage.CurrentReading === "object") {
  	      data.Vehicle.Usage.CurrentReading.unitType = counterUnitType;
  	      data.Vehicle.Usage.CurrentReading.editable = false;
  	      data.Vehicle.Usage.CurrentReading.selector = "number";
  	    }

  	    fifSetCanonicalDescriptor(data.FuelAndEnergy, "FuelGrade", clean(draft.FuelGrade), {
  	      options: [""].concat(FIF_ESSENTIAL_FUEL_GRADES),
  	      editable: true,
  	      selector: "select"
  	    });
  	    fifSetCanonicalDescriptor(data.FuelAndEnergy, "TankCapacityL", tankCapacity, {
  	      editable: true,
  	      selector: "number",
  	      unitType: "Volume"
  	    });
  	    fifSetCanonicalDescriptor(data.Vehicle, "Tank_Capacity", tankCapacity, {
  	      editable: true,
  	      selector: "number",
  	      unitType: "Volume"
  	    });
  	    const agriculturalFieldPerformance = getDeep(data, ["Agricultural", "FieldPerformance"], null);
  	    if (agriculturalFieldPerformance && typeof agriculturalFieldPerformance === "object" && !Array.isArray(agriculturalFieldPerformance)) {
  	      fifSetCanonicalDescriptor(agriculturalFieldPerformance, "FuelTankCapacityL", tankCapacity, {
  	        editable: true,
  	        selector: "number",
  	        unitType: "Volume"
  	      });
  	    }
  	    fifSetCanonicalDescriptor(data.FuelAndEnergy, "SARSCompliance", draft.SARSCompliance === true, {
  	      editable: true,
  	      selector: "boolean"
  	    });
  	    fifSetCanonicalDescriptor(data.FuelAndEnergy, "SARSRate", sarsRate, {
  	      editable: true,
  	      selector: "number"
  	    });

  	    data.Compliance.Setup.Requirements.VehicleLicence.Required = true;
  	    data.Compliance.Setup.Requirements.VehicleLicence.ExpiryDate = clean(draft.LicenseExpiry);

  	    fifTractorLog("CANONICAL DATA AFTER ESSENTIAL EDITS", {
  	      Data: data,
  	      essentialNested: fifDebugEssential({ Data: data }).nested,
  	      Identity: getDeep(data, ["Vehicle", "Identity"], null),
  	      Appearance: getDeep(data, ["Vehicle", "Appearance"], null),
  	      Usage: getDeep(data, ["Vehicle", "Usage"], null),
  	      FuelAndEnergy: getDeep(data, ["FuelAndEnergy"], null),
  	      VehicleLicence: getDeep(
  	        data,
  	        ["Compliance", "Setup", "Requirements", "VehicleLicence"],
  	        null
  	      )
  	    });

  	    const fleetId = clean(draft.FID);
  	    const registration = clean(draft.Registration);
  	    const assetColor =
  	      safeColor(draft.color, "#cc6633").toLowerCase();

  	    updated.Data = data;
  	    updated.CAN = fifVehicleCANObject(vehicle);
  	    updated.CAN.Tank = tankCapacity;
  	    updated.ID = fleetId;
  	    updated.FID = fleetId;
  	    updated.Registration = registration;
  	    updated.color = assetColor;
  	    updated.LicenseExpiry = expiryTimestamp;
  	    updated.Range = range;
  	    updated.CounterType = counterType;
  	    updated.SARSCompliance =
  	      draft.SARSCompliance === true;
  	    updated.SARSRate = sarsRate;

  	    const payload = {
  	      objectId: objectIdOf(vehicle),
  	      Data: cloneData(updated.Data),
  	      CAN: cloneData(updated.CAN),
  	      ID: fleetId,
  	      FID: fleetId,
  	      Registration: registration,
  	      color: assetColor,
  	      LicenseExpiry: expiryTimestamp,
  	      Range: Number(range),
  	      CounterType: String(counterType),
  	      SARSCompliance:
  	        draft.SARSCompliance === true,
  	      SARSRate: Number(sarsRate)
  	    };
  	    fifTractorLog("INITIAL ESSENTIAL PAYLOAD BEFORE LIVE CAN READ", {
  	      payload: payload,
  	      essential: fifDebugEssential(payload),
  	      keys: Object.keys(payload),
  	      descriptors: fifDebugDescriptors(payload),
  	      json: JSON.stringify(payload)
  	    });

  	    if (!payload.objectId) {
  	      const error = new Error(
  	        "The selected Tractor has no objectId and cannot be updated."
  	      );
  	      fifFinishTractorDebug("failed", {
  	        stage: "payload-objectId",
  	        error: fifDebugError(error),
  	        payload: payload
  	      });
  	      await fifAlert("The selected Tractor has no objectId and cannot be updated.", { title: "Save Blocked", type: "danger" });
  	      return;
  	    }

  	    const operation = fifBeginSaveOperation("Preparing one direct Tractor REST payload…");
  	    state.vehicleBusy = true;
  	    try {
  	      // Read the physical row first. An older AppData copy of CAN might omit
  	      // recently updated thresholds or event definitions; use the live CAN
  	      // configuration and change only its Tank field in the outgoing payload.
  	      const physicalEndpoint =
  	        fifBackendlessSameOriginApiBase() +
  	        "/data/Tractors/" +
  	        encodeURIComponent(payload.objectId);
  	      const physicalRow = await fifReadTractorDirectlyFromBackendlessRest(
  	        physicalEndpoint,
  	        await fifBackendlessRestHeaders()
  	      );
  	      if (
  	        !physicalRow ||
  	        typeof physicalRow !== "object" ||
  	        clean(physicalRow.objectId) !== clean(payload.objectId)
  	      ) {
  	        throw new Error("Could not verify the current Tractor CAN configuration before saving. No changes were sent.");
  	      }
  	      payload.CAN = fifVehicleCANObject(physicalRow);
  	      payload.CAN.Tank = tankCapacity;
  	      fifTractorLog("FINAL ESSENTIAL PAYLOAD WITH LIVE CAN TANK", {
  	        tankCapacity: tankCapacity,
  	        previousCANTank: fifVehicleCANObject(physicalRow).Tank,
  	        finalCANTank: payload.CAN.Tank,
  	        canPropertyCount: Object.keys(payload.CAN).length,
  	        essential: fifDebugEssential(payload)
  	      });

  	      const databaseResult =
  	        await fifSaveDatabaseRowAndReadBack(
  	          "Tractors",
  	          payload,
  	          {
  	            verify: function (row) {
  	              return fifBackendlessTractorEssentialMatches(
  	                row,
  	                payload
  	              );
  	            },
  	            verifyMessage:
  	              "Backendless did not persist matching CAN.Tank, Data.FuelAndEnergy.TankCapacityL and Data.Vehicle.Tank_Capacity values (and any configured agricultural mirror). AppData was not changed."
  	          }
  	        );

  	      fifTractorLog("DATABASE RESULT RETURNED TO ESSENTIAL SAVE", {
  	        databaseResult: databaseResult,
  	        returnedEssential: fifDebugEssential(databaseResult.value)
  	      });

  	      const verifiedDatabaseTractor =
  	        databaseResult.value;

  	      const reconciledTractor =
  	        fifReconcileVehicleAppData(
  	          company,
  	          vehicle,
  	          verifiedDatabaseTractor,
  	          verifiedDatabaseTractor,
  	          "Tractors"
  	        );

  	      fifTractorLog("ESSENTIAL SAVE AFTER APPDATA RECONCILIATION", {
  	        reconciledTractor: reconciledTractor,
  	        reconciledEssential: fifDebugEssential(reconciledTractor),
  	        selectedVehicle: selectedVehicle(company),
  	        selectedEssential: fifDebugEssential(selectedVehicle(company))
  	      });
  	      state.vehicleDataEditMode = false;
  	      state.vehicleDataDraft = null;
  	      state.vehicleDataOriginal = null;
  	      state.vehicleDataEssentialDirty = false;
  	      fifRefreshVehicleDataDirty();
  	      state.vehicleBusy = false;
  	      state.actionableAlertCache = {};
  	      setVehicleMessage("Essential Data, CAN.Tank and all fuel tank capacity mirrors saved and verified by direct REST read-back.", false);
  	      fifCompleteSaveOperation(operation, "Physical Tractors row verified after the direct REST PUT.");

  	      fifFinishTractorDebug("success", {
  	        payload: databaseResult.payload,
  	        physicalDatabaseRow: verifiedDatabaseTractor,
  	        physicalEssential: fifDebugEssential(verifiedDatabaseTractor),
  	        appDataRow: reconciledTractor,
  	        appDataEssential: fifDebugEssential(reconciledTractor)
  	      });

  	      render();
  	    } catch (error) {
  	      state.vehicleBusy = false;

  	      fifTractorLog(
  	        "ESSENTIAL SAVE CATCH BLOCK",
  	        {
  	          error: fifDebugError(error),
  	          currentDraft: state.vehicleDataDraft,
  	          selectedVehicle: selectedVehicle(company),
  	          selectedEssential: fifDebugEssential(selectedVehicle(company)),
  	          lastPayload:
  	            typeof window !== "undefined"
  	              ? window.__FIF_LAST_TRACTOR_SAVE_PAYLOAD__
  	              : null,
  	          lastReadBack:
  	            typeof window !== "undefined"
  	              ? window.__FIF_LAST_TRACTOR_REST_READBACK__
  	              : null
  	        },
  	        "error"
  	      );

  	      fifFinishTractorDebug("failed", {
  	        error: fifDebugError(error),
  	        lastPayload:
  	          typeof window !== "undefined"
  	            ? window.__FIF_LAST_TRACTOR_SAVE_PAYLOAD__
  	            : null,
  	        lastReadBack:
  	          typeof window !== "undefined"
  	            ? window.__FIF_LAST_TRACTOR_REST_READBACK__
  	            : null
  	      });

  	      fifFailSaveOperation(operation, error);
  	      setVehicleMessage(error && error.message ? error.message : "Essential vehicle data could not be saved.", true);
  	    }
  	  }

  	  function renderVehicleManagerBody(company, vehicle) {
  	    const tabs = adaptiveAvailablePrimaryTabs(company, vehicle);
  	    const allowed = tabs.map(function (tab) { return tab.key; });
  	    if (allowed.indexOf(state.vehicleActiveTab) === -1) state.vehicleActiveTab = allowed[0] || defaultVehicleManagerTab(vehicle);
  	    if (state.vehicleActiveTab === "physical" && !assetIsTrailer(vehicle)) return renderVehicleDataWorkspace(vehicle);
  	    if (state.vehicleActiveTab === "service") return renderVehicleService(company, vehicle);
  	    if (state.vehicleActiveTab === "maintenance") return renderVehicleMaintenance(company, vehicle);
  	    if (state.vehicleActiveTab === "tyres") return renderVehicleTyres(company, vehicle);
  	    if (state.vehicleActiveTab === "compliance") return renderVehicleCompliance(company, vehicle);
  	    return renderPermissionBoundary("No Assigned Vehicle Functions", "The signed-in user has no assigned functions for this asset.");
  	  }

  	  function fifClampNumber(value, minimum, maximum) {
  	    const number = Number(value);
  	    if (!Number.isFinite(number)) return minimum;
  	    return Math.min(maximum, Math.max(minimum, number));
  	  }

  	  function fifHexToRgb(hex) {
  	    const value = safeColor(hex, "#cc6633").slice(1);
  	    return {
  	      r: parseInt(value.slice(0, 2), 16),
  	      g: parseInt(value.slice(2, 4), 16),
  	      b: parseInt(value.slice(4, 6), 16)
  	    };
  	  }

  	  function fifRgbToHex(r, g, b) {
  	    return "#" + [r, g, b].map(function (value) {
  	      return Math.round(fifClampNumber(value, 0, 255)).toString(16).padStart(2, "0");
  	    }).join("");
  	  }

  	  function fifRgbToHsv(r, g, b) {
  	    r = fifClampNumber(r, 0, 255) / 255;
  	    g = fifClampNumber(g, 0, 255) / 255;
  	    b = fifClampNumber(b, 0, 255) / 255;
  	    const maximum = Math.max(r, g, b);
  	    const minimum = Math.min(r, g, b);
  	    const delta = maximum - minimum;
  	    let hue = 0;
  	    if (delta) {
  	      if (maximum === r) hue = 60 * (((g - b) / delta) % 6);
  	      else if (maximum === g) hue = 60 * (((b - r) / delta) + 2);
  	      else hue = 60 * (((r - g) / delta) + 4);
  	    }
  	    if (hue < 0) hue += 360;
  	    return {
  	      h: hue,
  	      s: maximum === 0 ? 0 : delta / maximum,
  	      v: maximum
  	    };
  	  }

  	  function fifHsvToRgb(h, s, v) {
  	    h = ((Number(h) % 360) + 360) % 360;
  	    s = fifClampNumber(s, 0, 1);
  	    v = fifClampNumber(v, 0, 1);
  	    const chroma = v * s;
  	    const x = chroma * (1 - Math.abs(((h / 60) % 2) - 1));
  	    const match = v - chroma;
  	    let r = 0;
  	    let g = 0;
  	    let b = 0;
  	    if (h < 60) { r = chroma; g = x; }
  	    else if (h < 120) { r = x; g = chroma; }
  	    else if (h < 180) { g = chroma; b = x; }
  	    else if (h < 240) { g = x; b = chroma; }
  	    else if (h < 300) { r = x; b = chroma; }
  	    else { r = chroma; b = x; }
  	    return {
  	      r: Math.round((r + match) * 255),
  	      g: Math.round((g + match) * 255),
  	      b: Math.round((b + match) * 255)
  	    };
  	  }

  	  function bindAdaptiveExperienceEvents(root, company) {
  	    const vehicle = selectedVehicle(company);
  	    if (!vehicle || state.vehicleActiveTab !== "physical" || assetIsTrailer(vehicle)) return;

  	    root.querySelector("[data-essential-toggle]")?.addEventListener("click", function () {
  	      state.vehicleDataEssentialOpen = state.vehicleDataEssentialOpen === false;
  	      render();
  	    });

  	    root.querySelector("[data-essential-edit]")?.addEventListener("click", function () {
  	      if (!CAN_EDIT_VEHICLE_PHYSICAL) return;
  	      state.vehicleDataEditMode = true;
  	      state.vehicleDataDraft = fifEssentialSnapshot(vehicle);
  	      state.vehicleDataOriginal = cloneData(state.vehicleDataDraft);
  	      state.vehicleDataEssentialDirty = false;
  	      fifRefreshVehicleDataDirty();
  	      state.vehicleDataEssentialOpen = true;
  	      setVehicleMessage("Editing Essential Data. All fields in this accordion are compulsory.", false);
  	      render();
  	    });

  	    root.querySelectorAll("[data-essential-field]").forEach(function (input) {
  	      const field = input.getAttribute("data-essential-field") || "";
  	      const update = function () { fifUpdateEssentialDraftField(field, input.value); };
  	      input.addEventListener("input", update);
  	      input.addEventListener("change", update);
  	    });

  	    root.querySelector("[data-essential-cancel]")?.addEventListener("click", async function () {
  	      if (state.vehicleDataEssentialDirty) {
  	        const approved = await fifConfirm("Discard the unsaved Essential Data changes?", {
  	          title: "Discard Essential Data Changes?",
  	          type: "warning",
  	          confirmText: "Discard Changes",
  	          cancelText: "Keep Editing"
  	        });
  	        if (!approved) return;
  	      }
  	      state.vehicleDataEditMode = false;
  	      state.vehicleDataDraft = null;
  	      state.vehicleDataOriginal = null;
  	      state.vehicleDataEssentialDirty = false;
  	      fifRefreshVehicleDataDirty();
  	      setVehicleMessage("Essential Data changes discarded.", false);
  	      render();
  	    });

  	    const essentialForm =
  	      root.querySelector(
  	        "[data-essential-form]"
  	      );

  	    const essentialSaveButton =
  	      root.querySelector(
  	        "[data-essential-save]"
  	      );

  	    essentialSaveButton?.addEventListener(
  	      "click",
  	      function (event) {

  	        fifConsoleEssentialPath(
  	          "DIRECT BUTTON CLICK",
  	          "bound save button"
  	        );
  	      }
  	    );

  	    essentialForm?.addEventListener(
  	      "invalid",
  	      function (event) {

  	      },
  	      true
  	    );

  	    essentialForm?.addEventListener(
  	      "submit",
  	      async function (event) {

  	        event.preventDefault();

  	        const formIsValid =
  	          event.currentTarget.reportValidity();

  	        if (!formIsValid) {
  	          fifConsoleEssentialPath(
  	            "SAVE STOPPED BY HTML VALIDATION",
  	            "bound form reportValidity"
  	          );
  	          return;
  	        }

  	        await saveEssentialVehicleData(
  	          company,
  	          vehicle
  	        );

  	      }
  	    );

  	    root.querySelector("[data-identity-toggle]")?.addEventListener("click", function () {
  	      state.vehicleDataIdentityOpen = state.vehicleDataIdentityOpen !== true;
  	      render();
  	    });

  	    root.querySelector("[data-identity-edit]")?.addEventListener("click", function () {
  	      if (!CAN_EDIT_VEHICLE_PHYSICAL || fifVehicleDataHasActiveEditor()) return;
  	      state.vehicleIdentityEditMode = true;
  	      state.vehicleIdentityDraft = fifIdentitySnapshot(vehicle);
  	      state.vehicleIdentityOriginal = cloneData(state.vehicleIdentityDraft);
  	      state.vehicleIdentityDirty = false;
  	      fifRefreshVehicleDataDirty();
  	      state.vehicleDataIdentityOpen = true;
  	      setVehicleMessage("Editing Vehicle Identity. Manufacturer, model, model year and vehicle type are compulsory.", false);
  	      render();
  	    });

  	    root.querySelectorAll("[data-identity-field]").forEach(function (input) {
  	      const field = input.getAttribute("data-identity-field") || "";
  	      const update = function () { fifUpdateIdentityDraftField(field, input.value); };
  	      input.addEventListener("input", update);
  	      input.addEventListener("change", update);
  	    });

  	    root.querySelector("[data-identity-cancel]")?.addEventListener("click", async function () {
  	      if (state.vehicleIdentityDirty) {
  	        const approved = await fifConfirm("Discard the unsaved Vehicle Identity changes?", {
  	          title: "Discard Vehicle Identity Changes?",
  	          type: "warning",
  	          confirmText: "Discard Changes",
  	          cancelText: "Keep Editing"
  	        });
  	        if (!approved) return;
  	      }
  	      state.vehicleIdentityEditMode = false;
  	      state.vehicleIdentityDraft = null;
  	      state.vehicleIdentityOriginal = null;
  	      state.vehicleIdentityDirty = false;
  	      fifRefreshVehicleDataDirty();
  	      setVehicleMessage("Vehicle Identity changes discarded.", false);
  	      render();
  	    });

  	    root.querySelector("[data-identity-form]")?.addEventListener("submit", async function (event) {
  	      event.preventDefault();
  	      if (!event.currentTarget.reportValidity()) return;
  	      await saveVehicleIdentityData(company, vehicle);
  	    });
  	  }

  	  function injectAdaptiveExperienceStyles() {
  	    document.getElementById(ADAPTIVE_STYLE_ID)?.remove();

  	    const style = document.createElement("style");
  	    style.id = ADAPTIVE_STYLE_ID;
  	    style.textContent = `
  	      #${ROOT_ID} .fif-vehicle-data-root{display:grid;gap:10px;padding:10px 12px 26px;min-width:0}
  	      #${ROOT_ID} .fif-essential-section{overflow:visible;border:1px solid rgba(255,255,255,.085);border-radius:12px;background:linear-gradient(145deg,#202720,#171c18);box-shadow:0 8px 18px rgba(0,0,0,.14)}
  	      #${ROOT_ID} .fif-essential-section>header{display:flex;align-items:center;gap:10px;min-height:58px;padding:7px 9px 7px 0;border-bottom:1px solid transparent}
  	      #${ROOT_ID} .fif-essential-section.is-open>header{border-bottom-color:rgba(204,102,51,.22)}
  	      #${ROOT_ID} .fif-essential-toggle{flex:1 1 auto;min-width:0;display:flex;align-items:center;justify-content:space-between;gap:14px;min-height:46px;padding:7px 12px;border:0;background:transparent;color:#fff;text-align:left;cursor:pointer}
  	      #${ROOT_ID} .fif-essential-toggle strong{display:block}
  	      #${ROOT_ID} .fif-essential-toggle strong{font-size:14px;font-weight:950}
  	      #${ROOT_ID} .fif-essential-toggle>i{position:relative;flex:0 0 34px;width:34px;height:34px;border:1px solid rgba(204,102,51,.35);border-radius:9px;background:rgba(204,102,51,.07)}
  	      #${ROOT_ID} .fif-essential-toggle>i:before,#${ROOT_ID} .fif-essential-toggle>i:after{content:"";position:absolute;top:16px;width:8px;height:2px;border-radius:2px;background:#d98455;transition:transform .18s ease}
  	      #${ROOT_ID} .fif-essential-toggle>i:before{left:9px;transform:rotate(45deg)}#${ROOT_ID} .fif-essential-toggle>i:after{right:9px;transform:rotate(-45deg)}
  	      #${ROOT_ID} .fif-essential-section.is-open .fif-essential-toggle>i:before{transform:rotate(-45deg)}#${ROOT_ID} .fif-essential-section.is-open .fif-essential-toggle>i:after{transform:rotate(45deg)}
  	      #${ROOT_ID} .fif-essential-body{padding:11px 12px 13px}
  	      #${ROOT_ID} .fif-essential-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:9px 10px;align-items:stretch}
  	      #${ROOT_ID} .fif-essential-field{display:flex;flex-direction:column;min-width:0;min-height:86px;padding:9px 10px;border:1px solid rgba(255,255,255,.055);border-radius:9px;background:rgba(10,14,11,.34)}
  	      #${ROOT_ID} .fif-essential-field>span{display:flex;align-items:center;gap:7px;min-height:18px;color:#d7ddd9;font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.045em}
  	      #${ROOT_ID} .fif-essential-field>input,#${ROOT_ID} .fif-essential-field>select,#${ROOT_ID} .fif-essential-field>.fif-styled-date,#${ROOT_ID} .fif-essential-field>.fifvm-colour-control,#${ROOT_ID} .fif-essential-field>.fif-essential-unit-input,#${ROOT_ID} .fif-essential-value,#${ROOT_ID} .fif-essential-read-colour{margin-top:auto}
  	      #${ROOT_ID} .fif-essential-field input,#${ROOT_ID} .fif-essential-field select{width:100%;min-width:0;min-height:39px;padding:7px 9px;border:1px solid rgba(255,255,255,.10);border-radius:8px;background:#111612;color:#fff;font-size:12px;box-sizing:border-box}
  	      #${ROOT_ID} .fif-essential-field input:focus,#${ROOT_ID} .fif-essential-field select:focus{outline:none;border-color:rgba(217,132,78,.75);box-shadow:0 0 0 3px rgba(204,102,51,.12)}
  	      #${ROOT_ID} .fif-essential-value{display:flex;align-items:center;min-height:39px;padding:7px 9px;border:1px solid rgba(255,255,255,.035);border-radius:8px;background:rgba(255,255,255,.018);color:#eef2ef;font-size:12px;font-weight:750;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
  	      #${ROOT_ID} .fif-essential-unit-input{display:grid;grid-template-columns:28px minmax(0,1fr) 36px;align-items:center;min-height:39px;border:1px solid rgba(255,255,255,.10);border-radius:8px;background:#111612;overflow:hidden}
  	      #${ROOT_ID} .fif-essential-unit-input.is-suffix-only{grid-template-columns:minmax(0,1fr) 36px}
  	      #${ROOT_ID} .fif-essential-unit-input>span,#${ROOT_ID} .fif-essential-unit-input>b{display:grid;place-items:center;height:100%;color:#c98459;background:rgba(204,102,51,.07);font-size:10px;font-weight:900}
  	      #${ROOT_ID} .fif-essential-unit-input>input{min-height:37px!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important}
  	      #${ROOT_ID} .fif-essential-read-colour{--selected-colour:#cc6633;display:grid;grid-template-columns:38px minmax(0,1fr);gap:9px;align-items:center;min-height:39px;padding:4px 8px;border:1px solid color-mix(in srgb,var(--selected-colour) 45%,rgba(255,255,255,.08));border-radius:8px;background:rgba(255,255,255,.018)}
  	      #${ROOT_ID} .fif-essential-read-colour>i{width:34px;height:27px;border:1px solid rgba(255,255,255,.18);border-radius:7px;background:var(--selected-colour);box-shadow:inset 0 0 0 3px rgba(0,0,0,.14)}
  	      #${ROOT_ID} .fif-essential-read-colour>strong{color:#fff;font-size:11px;letter-spacing:.05em}
  	      #${ROOT_ID} .fif-essential-actions{display:flex;justify-content:flex-end;gap:8px;padding-top:11px}
  	      @media(max-width:1050px){#${ROOT_ID} .fif-essential-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
  	      @media(max-width:680px){#${ROOT_ID} .fif-essential-grid{grid-template-columns:1fr}#${ROOT_ID} .fif-essential-section>header{align-items:flex-start;flex-wrap:wrap;padding-bottom:9px}#${ROOT_ID} .fif-essential-section>header>.fifvm-btn{margin-left:12px}}

  	      #${ROOT_ID} .fifvm-btn{min-height:36px;border-radius:9px!important;padding:7px 11px!important;font-size:10px!important;line-height:1.15!important}#${ROOT_ID} .fifvm-btn.primary{background:linear-gradient(145deg,#91401f,#5b2816)!important;border-color:rgba(219,116,64,.62)!important;color:#fff!important}#${ROOT_ID} .fifvm-panel>header{border-radius:14px 14px 0 0}#${ROOT_ID} .fifvm-form-field{min-width:0}#${ROOT_ID} .fif-styled-select-menu{z-index:2147483647}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace) .fifvm-panel{overflow:visible}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace) .fifvm-panel>header{position:sticky;top:0;z-index:58;border-radius:14px 14px 0 0;background:linear-gradient(180deg,rgba(19,23,20,.985),rgba(15,19,16,.965));box-shadow:0 8px 18px rgba(0,0,0,.28);backdrop-filter:blur(14px)}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace) .fifvm-panel-body{overflow:hidden;border-radius:0 0 14px 14px;background:linear-gradient(145deg,rgba(19,23,20,.98),rgba(11,14,12,.98))}
  	      #${ROOT_ID} .fifvm-capture-head,#${ROOT_ID} .fifsnap-toolbar{position:sticky;top:0;z-index:57;background:linear-gradient(180deg,rgba(14,18,15,.99),rgba(11,14,12,.965));box-shadow:0 8px 18px rgba(0,0,0,.26);backdrop-filter:blur(14px)}
  	      #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-head,#${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-tabs{position:sticky;top:0}
  	      #${ROOT_ID} .fifvm-colour-control{--selected-colour:#cc6633;display:grid;grid-template-columns:44px minmax(0,1fr);grid-template-rows:auto auto;gap:2px 10px;align-items:center;min-height:42px;padding:7px 9px;border:1px solid rgba(255,255,255,.09);border-radius:9px;background:#111512}
  	      #${ROOT_ID} .fifvm-colour-control.is-editable{border-color:color-mix(in srgb,var(--selected-colour) 52%,rgba(204,102,51,.35));box-shadow:inset 0 0 0 1px color-mix(in srgb,var(--selected-colour) 14%,transparent)}
  	      #${ROOT_ID} .fifvm-colour-swatch{position:relative;grid-row:1/3;width:42px;height:34px;overflow:hidden;border:1px solid rgba(255,255,255,.18);border-radius:8px;background:var(--selected-colour);box-shadow:inset 0 0 0 3px rgba(0,0,0,.16),0 5px 12px rgba(0,0,0,.24)}
  	      #${ROOT_ID} .fifvm-colour-swatch>input{position:absolute;inset:-8px;width:calc(100% + 16px);height:calc(100% + 16px);opacity:0;cursor:pointer}
  	      #${ROOT_ID} .fifvm-colour-swatch>span{position:absolute;inset:0;pointer-events:none;background:linear-gradient(135deg,rgba(255,255,255,.19),transparent 48%,rgba(0,0,0,.15))}
  	      #${ROOT_ID} .fifvm-colour-control output{color:#fff;font-size:11px;font-weight:900;letter-spacing:.05em}
  	      #${ROOT_ID} .fifvm-colour-control>small{color:#737c77;font-size:7px;line-height:1.25}
  	      #${ROOT_ID} .fifvm-colour-control.is-readonly .fifvm-colour-swatch>input{cursor:default}
  	      #${ROOT_ID} .fifvm-form-grid.compact{grid-template-columns:repeat(4,minmax(0,1fr))!important}
  	      #${ROOT_ID} .fifvm-form-field{display:flex!important;flex-direction:column;min-height:92px;box-sizing:border-box}
  	      #${ROOT_ID} .fifvm-form-field>span{flex:0 0 auto;min-height:20px!important;align-items:flex-start!important}
  	      #${ROOT_ID} .fifvm-form-field>input,#${ROOT_ID} .fifvm-form-field>select,#${ROOT_ID} .fifvm-form-field>textarea,#${ROOT_ID} .fifvm-form-field>.fifvm-number-shell,#${ROOT_ID} .fifvm-form-field>.fifvm-colour-control,#${ROOT_ID} .fifvm-form-field>.fifvm-switch{margin-top:auto;box-sizing:border-box}
  	      #${ROOT_ID} .fifvm-form-field input,#${ROOT_ID} .fifvm-form-field select{min-height:40px;box-sizing:border-box}
  	      #${ROOT_ID} .fifvm-form-field input:disabled,#${ROOT_ID} .fifvm-form-field select:disabled{min-height:40px;padding:8px 9px!important;border-color:rgba(255,255,255,.035)!important;background:rgba(255,255,255,.012)!important}
  	      #${ROOT_ID} .fifvm-colour-control{display:block;min-height:40px;padding:0;border:0;background:transparent;box-shadow:none!important}
  	      #${ROOT_ID} .fifvm-colour-trigger{width:100%;min-height:40px;display:grid;grid-template-columns:42px minmax(0,1fr) 18px;gap:10px;align-items:center;padding:5px 8px;border:1px solid color-mix(in srgb,var(--selected-colour) 52%,rgba(255,255,255,.11));border-radius:9px;background:linear-gradient(145deg,rgba(255,255,255,.045),rgba(255,255,255,.018));color:#fff;text-align:left;cursor:pointer;box-shadow:inset 0 0 0 1px color-mix(in srgb,var(--selected-colour) 12%,transparent)}
  	      #${ROOT_ID} .fifvm-colour-trigger:disabled{cursor:default;opacity:1}
  	      #${ROOT_ID} .fifvm-colour-trigger:focus-visible{outline:none;border-color:rgba(224,123,67,.8);box-shadow:0 0 0 3px rgba(204,102,51,.14)}
  	      #${ROOT_ID} .fifvm-colour-swatch{position:relative;width:40px;height:30px;overflow:hidden;border:1px solid rgba(255,255,255,.2);border-radius:8px;background:var(--selected-colour);box-shadow:inset 0 0 0 3px rgba(0,0,0,.15),0 4px 10px rgba(0,0,0,.24)}
  	      #${ROOT_ID} .fifvm-colour-swatch>i{position:absolute;inset:0;background:linear-gradient(135deg,rgba(255,255,255,.2),transparent 50%,rgba(0,0,0,.16))}
  	      #${ROOT_ID} .fifvm-colour-copy{min-width:0}
  	      #${ROOT_ID} .fifvm-colour-copy output,#${ROOT_ID} .fifvm-colour-copy small{display:block}
  	      #${ROOT_ID} .fifvm-colour-copy output{color:#fff;font-size:11px;font-weight:950;letter-spacing:.05em}
  	      #${ROOT_ID} .fifvm-colour-copy small{margin-top:2px;color:#78817c;font-size:7px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fifvm-colour-trigger>b{position:relative;width:16px;height:16px}
  	      #${ROOT_ID} .fifvm-colour-trigger>b:before,#${ROOT_ID} .fifvm-colour-trigger>b:after{content:"";position:absolute;top:7px;width:7px;height:2px;border-radius:2px;background:#c97849}
  	      #${ROOT_ID} .fifvm-colour-trigger>b:before{left:1px;transform:rotate(45deg)}
  	      #${ROOT_ID} .fifvm-colour-trigger>b:after{right:1px;transform:rotate(-45deg)}
  	      #${ROOT_ID} .fifvm-colour-popover{position:fixed;z-index:2147483646;width:min(340px,calc(100vw - 20px));padding:0;border:1px solid rgba(224,123,67,.5);border-radius:14px;background:linear-gradient(180deg,#151916,#0a0d0b);box-shadow:0 28px 75px rgba(0,0,0,.65),0 0 0 1px rgba(0,0,0,.55);overflow:hidden;color:#fff}
  	      #${ROOT_ID} .fifvm-colour-popover>header{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 12px;border-bottom:1px solid rgba(255,255,255,.07);background:linear-gradient(145deg,rgba(204,102,51,.12),rgba(255,255,255,.018))}
  	      #${ROOT_ID} .fifvm-colour-popover>header span,#${ROOT_ID} .fifvm-colour-popover>header strong{display:block}
  	      #${ROOT_ID} .fifvm-colour-popover>header span{color:#d17b4c;font-size:7px;font-weight:950;letter-spacing:.1em;text-transform:uppercase}
  	      #${ROOT_ID} .fifvm-colour-popover>header strong{margin-top:2px;font-size:11px}
  	      #${ROOT_ID} .fifvm-colour-popover>header button{position:relative;width:30px;height:30px;border:1px solid rgba(255,255,255,.09);border-radius:8px;background:#111512;cursor:pointer}
  	      #${ROOT_ID} .fifvm-colour-popover>header button:before,#${ROOT_ID} .fifvm-colour-popover>header button:after{content:"";position:absolute;left:8px;right:8px;top:14px;height:2px;border-radius:2px;background:#aab1ad}
  	      #${ROOT_ID} .fifvm-colour-popover>header button:before{transform:rotate(45deg)}
  	      #${ROOT_ID} .fifvm-colour-popover>header button:after{transform:rotate(-45deg)}
  	      #${ROOT_ID} .fifvm-colour-sv{--picker-hue:20;position:relative;height:190px;margin:12px;border:1px solid rgba(255,255,255,.13);border-radius:11px;background:linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,hsl(var(--picker-hue) 100% 50%));cursor:crosshair;touch-action:none;overflow:hidden}
  	      #${ROOT_ID} .fifvm-colour-sv>i{position:absolute;width:15px;height:15px;border:2px solid #fff;border-radius:50%;transform:translate(-50%,-50%);box-shadow:0 0 0 2px rgba(0,0,0,.6),0 3px 8px rgba(0,0,0,.45);pointer-events:none}
  	      #${ROOT_ID} .fifvm-colour-hue-row{display:grid;grid-template-columns:36px minmax(0,1fr) 72px;gap:9px;align-items:center;padding:0 12px}
  	      #${ROOT_ID} .fifvm-colour-hue-row>span{width:34px;height:34px;border:1px solid rgba(255,255,255,.16);border-radius:50%;background:var(--preview-colour);box-shadow:inset 0 0 0 3px rgba(0,0,0,.16)}
  	      #${ROOT_ID} .fifvm-colour-hue-row output{color:#fff;font-size:9px;font-weight:900;text-align:right}
  	      #${ROOT_ID} .fifvm-colour-hue-row input[type=range]{width:100%;height:14px;padding:0;border:0;border-radius:99px;background:linear-gradient(90deg,#f00,#ff0,#0f0,#0ff,#00f,#f0f,#f00);appearance:none;-webkit-appearance:none}
  	      #${ROOT_ID} .fifvm-colour-hue-row input[type=range]::-webkit-slider-thumb{width:18px;height:18px;border:3px solid #fff;border-radius:50%;background:transparent;box-shadow:0 0 0 2px rgba(0,0,0,.58);appearance:none;-webkit-appearance:none}
  	      #${ROOT_ID} .fifvm-colour-hue-row input[type=range]::-moz-range-thumb{width:12px;height:12px;border:3px solid #fff;border-radius:50%;background:transparent;box-shadow:0 0 0 2px rgba(0,0,0,.58)}
  	      #${ROOT_ID} .fifvm-colour-presets{display:grid;grid-template-columns:repeat(8,1fr);gap:6px;padding:10px 12px 0}
  	      #${ROOT_ID} .fifvm-colour-presets button{aspect-ratio:1;border:1px solid rgba(255,255,255,.15);border-radius:7px;background:var(--preset-colour);cursor:pointer;box-shadow:inset 0 0 0 2px rgba(0,0,0,.12)}
  	      #${ROOT_ID} .fifvm-colour-presets button:hover{transform:translateY(-1px);border-color:#fff}
  	      #${ROOT_ID} .fifvm-colour-values{display:grid;grid-template-columns:1.35fr repeat(3,.8fr);gap:7px;padding:10px 12px 12px}
  	      #${ROOT_ID} .fifvm-colour-values label{min-width:0}
  	      #${ROOT_ID} .fifvm-colour-values label>span{display:block;margin:0 0 4px 2px;color:#7f8883;font-size:7px;font-weight:900}
  	      #${ROOT_ID} .fifvm-colour-values input{width:100%;min-height:36px;box-sizing:border-box;border:1px solid rgba(255,255,255,.09);border-radius:8px;background:#0c100d;color:#fff;padding:0 8px;font-size:10px;text-align:center;outline:none}
  	      #${ROOT_ID} .fifvm-colour-values input:focus{border-color:rgba(224,123,67,.7);box-shadow:0 0 0 2px rgba(204,102,51,.11)}
  	      #${ROOT_ID} .fifvm-colour-popover>footer{display:flex;justify-content:flex-end;gap:7px;padding:10px 12px;border-top:1px solid rgba(255,255,255,.07);background:#0d100e}
  	      #${ROOT_ID} input[type=number][data-fif-number-enhanced]{-moz-appearance:textfield}
  	      #${ROOT_ID} input[type=number][data-fif-number-enhanced]::-webkit-inner-spin-button,#${ROOT_ID} input[type=number][data-fif-number-enhanced]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}
  	      #${ROOT_ID} .fifvm-number-shell{position:relative;display:flex;width:100%;min-width:0;align-items:stretch}
  	      #${ROOT_ID} .fifvm-number-shell>input{flex:1 1 auto;min-width:0;padding-right:36px!important;border-radius:9px!important}
  	      #${ROOT_ID} .fifvm-number-steppers{position:absolute;top:1px;right:1px;bottom:1px;width:30px;display:grid;grid-template-rows:1fr 1fr;border-left:1px solid rgba(255,255,255,.075);border-radius:0 8px 8px 0;overflow:hidden;background:rgba(255,255,255,.025)}
  	      #${ROOT_ID} .fifvm-number-steppers button{position:relative;min-height:0!important;width:100%;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;cursor:pointer}
  	      #${ROOT_ID} .fifvm-number-steppers button+button{border-top:1px solid rgba(255,255,255,.065)!important}
  	      #${ROOT_ID} .fifvm-number-steppers button:hover{background:rgba(204,102,51,.14)!important}
  	      #${ROOT_ID} .fifvm-number-steppers button:before{content:"";position:absolute;left:50%;top:50%;width:6px;height:6px;border-top:2px solid #c97849;border-left:2px solid #c97849;transform:translate(-50%,-30%) rotate(45deg)}
  	      #${ROOT_ID} .fifvm-number-steppers button[data-fif-number-step=down]:before{transform:translate(-50%,-70%) rotate(225deg)}
  	      #${ROOT_ID} .fifvm-number-shell>input:disabled+.fifvm-number-steppers{display:none}
  	      #${ROOT_ID} .fifvm-manager>.fifvm-hero,#${ROOT_ID} .fifvm-manager>.fifvm-tabs,#${ROOT_ID} .fifvm-manager>.fifvm-message{max-height:110px;opacity:1;transition:max-height .18s ease,opacity .12s ease,padding .18s ease,margin .18s ease,border-width .18s ease;overflow:hidden}
  	      #${ROOT_ID} .fifvm-manager.is-workspace-scrolled>.fifvm-hero,#${ROOT_ID} .fifvm-manager.is-workspace-scrolled>.fifvm-tabs,#${ROOT_ID} .fifvm-manager.is-workspace-scrolled>.fifvm-message{max-height:0!important;min-height:0!important;height:0!important;padding-top:0!important;padding-bottom:0!important;margin-top:0!important;margin-bottom:0!important;border-width:0!important;opacity:0;pointer-events:none}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace){padding-top:0!important}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace) .fifvm-panel{--fifvm-panel-head-height:64px;margin-top:10px}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace) .fifvm-panel>header{top:0!important;z-index:90!important;min-height:64px;box-sizing:border-box;background:#111512!important;backdrop-filter:none!important;box-shadow:0 9px 20px rgba(0,0,0,.44)!important}

  	      #${ROOT_ID} .fifdash-workspace.is-vehicle-workspace-scrolled>.fifdash-command-header{display:none!important}
  	      #${ROOT_ID} .fifvm-manager>.fifvm-hero,#${ROOT_ID} .fifvm-manager>.fifvm-tabs,#${ROOT_ID} .fifvm-manager>.fifvm-message{max-height:none!important;height:auto!important;opacity:1!important;overflow:visible!important;transition:none!important}
  	      #${ROOT_ID} .fifvm-manager.is-workspace-scrolled>.fifvm-hero,#${ROOT_ID} .fifvm-manager.is-workspace-scrolled>.fifvm-tabs,#${ROOT_ID} .fifvm-manager.is-workspace-scrolled>.fifvm-message{display:none!important}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace){overflow:auto!important;padding:0 18px 28px!important;scroll-padding-top:66px}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace)>.fifvm-panel{margin:0 0 14px!important;border-radius:0 0 14px 14px!important;overflow:visible!important;background:#0b0f0c!important}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace)>.fifvm-panel>header{position:sticky!important;top:0!important;z-index:30!important;min-height:64px!important;border-radius:0!important;background:#111512!important;box-shadow:0 8px 18px rgba(0,0,0,.46)!important;backdrop-filter:none!important;isolation:isolate}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace)>.fifvm-panel>header:after{content:"";position:absolute;left:0;right:0;bottom:-1px;height:1px;background:rgba(204,102,51,.24);pointer-events:none}
  	      #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-head,#${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-tabs{position:relative!important;top:auto!important;z-index:auto!important}
  	      #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-root{overflow:hidden!important}
  	      #${ROOT_ID} .fifvm-body.is-service-workspace .fifvsvc-body{position:relative;z-index:1}
  	      #${ROOT_ID} .fifvm-number-shell>input{padding-right:42px!important}
  	      #${ROOT_ID} .fifvm-number-steppers{top:4px!important;right:4px!important;bottom:4px!important;width:29px!important;border:1px solid rgba(204,102,51,.24)!important;border-radius:7px!important;background:#111512!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.025)!important}
  	      #${ROOT_ID} .fifvm-number-steppers button{display:grid!important;place-items:center!important}
  	      #${ROOT_ID} .fifvm-number-steppers button:before{display:none!important}
  	      #${ROOT_ID} .fifvm-number-steppers button svg{width:13px;height:13px;display:block;fill:none;stroke:#d18458;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;pointer-events:none}
  	      #${ROOT_ID} .fifvm-number-steppers button:hover svg{stroke:#fff}
  	      #${ROOT_ID} .fifvm-number-steppers button+button{border-top:1px solid rgba(204,102,51,.18)!important}

  	      #${ROOT_ID} .fifdash-workspace{height:100%;min-height:0;overflow:hidden!important}
  	      #${ROOT_ID} .fifdash-command-header{position:relative!important;z-index:120!important;flex:0 0 auto!important}
  	      #${ROOT_ID} .fifdash-main.has-vehicle-manager{display:flex!important;flex:1 1 auto!important;min-height:0!important;overflow:hidden!important;padding:0!important}
  	      #${ROOT_ID} .fifvm-manager{flex:1 1 auto!important;height:100%!important;min-height:0!important;overflow:hidden!important;display:flex!important;flex-direction:column!important}
  	      #${ROOT_ID} .fifvm-fixed-stack{position:relative!important;z-index:110!important;flex:0 0 auto!important;background:#0b0e0c!important;box-shadow:0 10px 22px rgba(0,0,0,.34)!important;isolation:isolate}
  	      #${ROOT_ID} .fifvm-fixed-stack>.fifvm-hero,#${ROOT_ID} .fifvm-fixed-stack>.fifvm-tabs{position:relative!important;display:flex;max-height:none!important;height:auto!important;min-height:0;opacity:1!important;overflow:visible!important;pointer-events:auto!important;transition:none!important}
  	      #${ROOT_ID} .fifvm-fixed-stack>.fifvm-hero{display:grid!important;z-index:6!important}
  	      #${ROOT_ID} .fifvm-fixed-stack>.fifvm-tabs{z-index:3!important}
  	      #${ROOT_ID} .fifvm-body{position:relative!important;z-index:1!important;flex:1 1 auto!important;min-height:0!important;overflow:auto!important;overscroll-behavior:contain;scrollbar-gutter:stable;background:#090b0a!important}
  	      #${ROOT_ID} .fifvm-body.is-service-workspace{overflow:hidden!important}
  	      #${ROOT_ID} .fifvm-body>.fifvm-message{margin:10px 18px 0!important;position:relative!important;z-index:auto!important;flex:none!important}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace){padding:0 18px 28px!important;scroll-padding-top:0!important}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace)>.fifvm-message+*{margin-top:10px!important}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace)>.fifvm-panel{margin:10px 0 14px!important;border-radius:14px!important;overflow:hidden!important}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace)>.fifvm-panel>header,#${ROOT_ID} .fifvm-capture-head,#${ROOT_ID} .fifsnap-toolbar{position:static!important;top:auto!important;z-index:auto!important;box-shadow:none!important;backdrop-filter:none!important}
  	      #${ROOT_ID} .fifvm-manager.is-workspace-scrolled>.fifvm-hero,#${ROOT_ID} .fifvm-manager.is-workspace-scrolled>.fifvm-tabs,#${ROOT_ID} .fifvm-manager.is-workspace-scrolled>.fifvm-message,#${ROOT_ID} .fifdash-workspace.is-vehicle-workspace-scrolled>.fifdash-command-header{display:revert!important;max-height:none!important;height:auto!important;opacity:1!important;pointer-events:auto!important}
  	      #${ROOT_ID}{--fif-bg:#111512;--fif-panel:#181d19;--fif-panel-2:#1d231e;--fif-panel-3:#242b25;--fif-line:rgba(255,255,255,.105);--fif-text:#f7f8f7;--fif-muted:#a7b0aa}
  	      #${ROOT_ID},#${ROOT_ID} button,#${ROOT_ID} input,#${ROOT_ID} select,#${ROOT_ID} textarea{font-size:13px}
  	      #${ROOT_ID} .fifdash-shell{grid-template-columns:244px minmax(0,1fr);background:#111512}
  	      #${ROOT_ID} .fifdash-sidebar{background:radial-gradient(circle at 12% 0%,rgba(255,133,49,.14),transparent 28%),linear-gradient(180deg,rgba(35,40,35,.99),rgba(17,21,18,.995));box-shadow:9px 0 26px rgba(0,0,0,.24)}
  	      #${ROOT_ID} .fifdash-brand-row{min-height:76px;padding:13px 15px 12px}
  	      #${ROOT_ID} .fifdash-brand-copy strong{font-size:15px}#${ROOT_ID} .fifdash-brand-copy span{font-size:12px}
  	      #${ROOT_ID} .fifdash-company-block{padding:11px 10px 8px}#${ROOT_ID} .fifdash-company-block label,#${ROOT_ID} .fifdash-filter-shell>span,#${ROOT_ID} .fifdash-period-shell>span{margin-bottom:5px;font-size:11px}
  	      #${ROOT_ID} .fifdash-select-shell select,#${ROOT_ID} .fifdash-filter-shell select,#${ROOT_ID} .fifdash-period-shell select{min-height:39px;border-radius:10px;background:linear-gradient(145deg,rgba(39,45,39,.96),rgba(20,24,21,.98));font-size:13px}
  	      #${ROOT_ID} .fifdash-nav{padding:5px 7px;gap:3px}#${ROOT_ID} .fifdash-nav-item{min-height:43px;padding:0 8px;border-radius:10px}#${ROOT_ID} .fifdash-nav-label{font-size:13px}#${ROOT_ID} .fifdash-nav-count{height:21px;font-size:11px}
  	      #${ROOT_ID} .fifdash-command-header{min-height:92px;padding:13px 20px;gap:18px;background:linear-gradient(90deg,rgba(255,255,255,.035),transparent 48%),rgba(20,25,21,.97);backdrop-filter:none}
  	      #${ROOT_ID} .fifdash-eyebrow{font-size:11px}#${ROOT_ID} .fifdash-title-block h1{font-size:clamp(23px,2vw,31px)}#${ROOT_ID} .fifdash-title-block p{margin-top:4px;font-size:12px}
  	      #${ROOT_ID} .fifdash-main,#${ROOT_ID} .fifdash-main.has-vehicle-manager{background:#111512}
  	      #${ROOT_ID} .fifvm-manager{background:#111512!important}
  	      #${ROOT_ID} .fifvm-fixed-stack{background:#171c18!important;box-shadow:0 7px 16px rgba(0,0,0,.24)!important}
  	      #${ROOT_ID} .fifvm-hero.fifvm-hero-compact{min-height:62px;padding:7px 13px!important;gap:10px!important;background:radial-gradient(circle at 8% 0%,color-mix(in srgb,var(--vehicle-color) 15%,transparent),transparent 34%),linear-gradient(145deg,#222820,#151a16)}
  	      #${ROOT_ID} .fifvm-hero.fifvm-hero-compact{grid-template-columns:auto minmax(0,1fr) auto!important;overflow:visible!important}
  	      #${ROOT_ID} .fifvm-hero.fifvm-hero-compact .fifvm-hero-actions{justify-self:end!important}
  	      #${ROOT_ID} .fifvm-hero.fifvm-hero-compact .fifvm-printables-button{height:34px!important;min-width:94px!important;padding:0 12px!important;font-size:11px!important}
  	      #${ROOT_ID} .fifvm-hero.fifvm-hero-compact .fifvm-hero-title-row h2{font-size:22px!important}#${ROOT_ID} .fifvm-hero.fifvm-hero-compact .fifvm-hero-copy>p{font-size:12px!important;color:#a5aea8!important}
  	      #${ROOT_ID} .fifvm-status{font-size:11px;padding:4px 8px}
  	      #${ROOT_ID} .fifvm-tabs{gap:3px;padding:5px 10px;background:#1a201b!important;box-shadow:0 5px 12px rgba(0,0,0,.18)}#${ROOT_ID} .fifvm-tabs button{min-width:102px;padding:6px 10px;font-size:13px;border-radius:8px}#${ROOT_ID} .fifvm-tabs button small{font-size:9px}
  	      #${ROOT_ID} .fifvm-body{background:#121713!important;color:#f7f8f7}#${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace){padding:0 12px 20px!important}
  	      #${ROOT_ID} .fifvm-body>.fifvm-message{margin:7px 12px 0!important;padding:7px 10px;font-size:13px}
  	      #${ROOT_ID} .fifvm-panel{margin-bottom:8px!important;border-radius:10px!important;background:linear-gradient(145deg,rgba(32,38,32,.99),rgba(22,27,23,.99))!important;box-shadow:0 8px 18px rgba(0,0,0,.12)}
  	      #${ROOT_ID} .fifvm-body:not(.is-overview-workspace):not(.is-service-workspace)>.fifvm-panel{margin:7px 0 9px!important;border-radius:10px!important}
  	      #${ROOT_ID} .fifvm-panel>header{min-height:45px;padding:8px 11px!important;background:rgba(255,255,255,.032)!important}#${ROOT_ID} .fifvm-panel>header h3{font-size:15px}#${ROOT_ID} .fifvm-panel>header p{font-size:11px;color:#9da69f}
  	      #${ROOT_ID} .fifvm-form-grid{background:#171c18!important}
  	      #${ROOT_ID} .fifvm-form-field{padding:7px 9px;border-color:rgba(255,255,255,.065);background:#171c18}#${ROOT_ID} .fifvm-form-field>span{min-height:16px;margin-bottom:4px;color:#b0b9b3;font-size:11px;font-weight:850}#${ROOT_ID} .fifvm-form-field>span small,#${ROOT_ID} .fifvm-field-lock{font-size:9px}
  	      #${ROOT_ID} .fifvm-form-field input,#${ROOT_ID} .fifvm-form-field select,#${ROOT_ID} .fifvm-form-field textarea,#${ROOT_ID} .fifvm-capture input,#${ROOT_ID} .fifvm-capture select,#${ROOT_ID} .fifvm-capture textarea{min-height:38px;padding:7px 9px;border-color:rgba(255,255,255,.12);background:#222922;color:#f6f8f6;font-size:13px}
  	      #${ROOT_ID} .fifvm-form-field input:disabled,#${ROOT_ID} .fifvm-form-field select:disabled,#${ROOT_ID} .fifvm-form-field textarea:disabled{color:#d0d6d2;background:rgba(255,255,255,.018)}
  	      #${ROOT_ID} .fifvm-number-steppers{background:#202720!important}
  	      #${ROOT_ID} .fifvm-colour-trigger{min-height:38px;padding:4px 7px;background:linear-gradient(145deg,rgba(255,255,255,.07),rgba(255,255,255,.025))}#${ROOT_ID} .fifvm-colour-copy output{font-size:12px}#${ROOT_ID} .fifvm-colour-copy small{font-size:9px;color:#9ca59f}
  	      #${ROOT_ID} .fifvm-btn{min-height:33px!important;padding:6px 10px!important;font-size:12px!important;background:linear-gradient(145deg,#272e28,#1a201b)!important}
  	      #${ROOT_ID} .fifvm-btn.ghost{background:#202720!important}#${ROOT_ID} .fifvm-btn.primary{background:linear-gradient(145deg,#d8743e,#98411f)!important}
  	      #${ROOT_ID} .fifvm-detail-line{min-height:31px;padding:5px 10px}#${ROOT_ID} .fifvm-detail-line>span{font-size:12px;color:#aeb7b1}#${ROOT_ID} .fifvm-detail-line>strong{font-size:13px}
  	      #${ROOT_ID} .fifvm-record-card{padding:7px 9px}#${ROOT_ID} .fifvm-record-card h4{font-size:13px}#${ROOT_ID} .fifvm-record-card p{font-size:11px}#${ROOT_ID} .fifvm-record-card small{font-size:10px}
  	      #${ROOT_ID} .fifvm-capture{padding:9px;border-radius:10px;background:linear-gradient(145deg,#202720,#171c18)}#${ROOT_ID} .fifvm-capture-head h3{font-size:15px}#${ROOT_ID} .fifvm-capture-head p{margin:3px 0 9px;font-size:11px;color:#9ea7a1}#${ROOT_ID} .fifvm-capture-grid{gap:7px;margin-bottom:8px}#${ROOT_ID} .fifvm-capture-grid label>span{font-size:11px}
  	      #${ROOT_ID} .fifvsvc-head{padding:8px 10px;background:radial-gradient(circle at 0 0,rgba(204,102,51,.14),transparent 38%),linear-gradient(145deg,#242a24,#171c18)}#${ROOT_ID} .fifvsvc-head h3{margin:0;font-size:18px}#${ROOT_ID} .fifvsvc-kpis article{min-height:52px}#${ROOT_ID} .fifwrk-position-next>strong{display:block}
  	      #${ROOT_ID} .fifvsvc-tabs{padding:4px 7px;background:#1b211c}#${ROOT_ID} .fifvsvc-tabs button{min-height:32px;padding:0 10px;font-size:11px}#${ROOT_ID} .fifvsvc-tabs button b{font-size:9px}
  	      #${ROOT_ID} .fifvsvc-body{padding:7px 9px 18px!important;background:#121713}#${ROOT_ID} .fifvsvc-kpis{gap:6px;margin-bottom:7px}#${ROOT_ID} .fifvsvc-kpis article{min-height:64px;padding:7px 9px;background:linear-gradient(145deg,#222822,#181d19)}#${ROOT_ID} .fifvsvc-kpis span{font-size:9px}#${ROOT_ID} .fifvsvc-kpis strong{font-size:16px}#${ROOT_ID} .fifvsvc-kpis small{font-size:10px}
  	      #${ROOT_ID} .fifsnap-root{background:#121713}#${ROOT_ID} .fifsnap-toolbar{padding:8px 10px;background:#1b211c}#${ROOT_ID} .fifsnap-toolbar h3{font-size:16px}#${ROOT_ID} .fifsnap-toolbar p{font-size:11px}#${ROOT_ID} .fifsnap-grid{gap:8px;padding:8px}#${ROOT_ID} .fifsnap-panel{background:linear-gradient(145deg,#222822,#181d19);box-shadow:0 7px 16px rgba(0,0,0,.12)}#${ROOT_ID} .fifsnap-panel>header{padding:7px 9px}#${ROOT_ID} .fifsnap-panel>header strong{font-size:13px}#${ROOT_ID} .fifsnap-panel-body{padding:8px}
  	      #${ROOT_ID} .fifdash-summary-card,#${ROOT_ID} .fifdash-app-card,#${ROOT_ID} .fifdash-asset-row,#${ROOT_ID} .fifdash-asset-column-head{background:linear-gradient(145deg,rgba(37,43,38,.98),rgba(22,27,23,.98))}
  	      #${ROOT_ID} .fifdash-summary-card{padding:11px}#${ROOT_ID} .fifdash-summary-card span,#${ROOT_ID} .fifdash-metric span{font-size:11px}#${ROOT_ID} .fifdash-summary-card strong,#${ROOT_ID} .fifdash-metric strong{font-size:13px}
  	      #${ROOT_ID} .fif-styled-select-trigger{background:#222922!important;font-size:13px!important}
  	      #${ROOT_ID} .fifvm-body{display:flex!important;flex-direction:column!important;overflow:hidden!important;padding:0!important;background:#121713!important}
  	      #${ROOT_ID} .fifvm-tab-fixed{position:relative;z-index:70;flex:0 0 auto;min-width:0;background:#171c18;border-bottom:1px solid rgba(204,102,51,.28);box-shadow:0 8px 18px rgba(0,0,0,.24);isolation:isolate}
  	      #${ROOT_ID} .fifvm-tab-fixed[hidden]{display:none!important}
  	      #${ROOT_ID} .fifvm-tab-scroll{position:relative;z-index:1;flex:1 1 auto;min-width:0;min-height:0;overflow:auto;overscroll-behavior:contain;scrollbar-gutter:stable;padding:10px 12px 24px;background:#121713}
  	      #${ROOT_ID} .fifvm-tab-scroll::-webkit-scrollbar{width:8px;height:8px}#${ROOT_ID} .fifvm-tab-scroll::-webkit-scrollbar-thumb{border-radius:99px;background:rgba(204,102,51,.44)}
  	      #${ROOT_ID} .fifvm-tab-fixed>.fifvm-message{margin:7px 12px!important}
  	      #${ROOT_ID} .fifvm-tab-fixed>.fifvm-tab-titlebar{min-height:51px!important;margin:0!important;border:0!important;border-top:1px solid rgba(255,255,255,.035)!important;border-radius:0!important;padding:8px 14px!important;background:#1b211c!important;box-shadow:none!important}
  	      #${ROOT_ID} .fifvm-tab-scroll>.fifvm-tab-scroll-content{border:0!important;border-radius:0!important;background:transparent!important;padding:0!important}
  	      #${ROOT_ID} .fifvm-tab-scroll>.fifvm-access-note{margin:0 0 8px}
  	      #${ROOT_ID} .fifvm-tab-fixed .fifvsvc-head,#${ROOT_ID} .fifvm-tab-fixed .fifvsvc-tabs,#${ROOT_ID} .fifvm-tab-fixed .fifvsvc-kpis,#${ROOT_ID} .fifvm-tab-fixed .fifmnt-head,#${ROOT_ID} .fifvm-tab-fixed .fifmnt-kpis,#${ROOT_ID} .fifvm-tab-fixed .fifmnt-toolbar,#${ROOT_ID} .fifvm-tab-fixed .fifv21-head,#${ROOT_ID} .fifvm-tab-fixed .fifv21-kpis,#${ROOT_ID} .fifvm-tab-fixed .fifv21-toolbar,#${ROOT_ID} .fifvm-tab-fixed .fifsnap-toolbar,#${ROOT_ID} .fifvm-tab-fixed .fifvm-original-tyre-heading{position:relative!important;top:auto!important;z-index:auto!important;margin:0!important;border-radius:0!important;box-shadow:none!important}
  	      #${ROOT_ID} .fifvm-tab-fixed .fifvsvc-head,#${ROOT_ID} .fifvm-tab-fixed .fifmnt-head,#${ROOT_ID} .fifvm-tab-fixed .fifv21-head{border-left:0!important;border-right:0!important;border-top:0!important}
  	      #${ROOT_ID} .fifvm-tab-fixed .fifvsvc-kpis,#${ROOT_ID} .fifvm-tab-fixed .fifmnt-kpis,#${ROOT_ID} .fifvm-tab-fixed .fifv21-kpis{padding:8px 10px!important;background:#171c18!important}
  	      #${ROOT_ID} .fifvm-tab-fixed .fifmnt-toolbar,#${ROOT_ID} .fifvm-tab-fixed .fifv21-toolbar{border-radius:0!important;border-left:0!important;border-right:0!important;padding:8px 10px!important;background:#151a16!important}
  	      #${ROOT_ID} .fifvm-tab-scroll-service{padding:0 10px 24px!important}#${ROOT_ID} .fifvm-tab-scroll-service>.fifvsvc-overview-grid,#${ROOT_ID} .fifvm-tab-scroll-service>.fifsp-provider-view,#${ROOT_ID} .fifvm-tab-scroll-service>.fifsp-job-view{padding-top:9px}
  	      #${ROOT_ID} .fifvm-tab-scroll-service{display:block!important;text-align:left!important}
  	      #${ROOT_ID} .fifvm-tab-scroll-service>.fifvsvc-position-view{display:block!important;width:min(1180px,100%)!important;max-width:1180px!important;margin:9px auto 0 0!important;align-self:flex-start!important;justify-self:start!important}
  	      #${ROOT_ID} .fifvm-tab-scroll-service>.fifvsvc-position-view>.fifvm-panel{display:block!important;width:100%!important;max-width:none!important;margin:0!important}
  	      #${ROOT_ID} .fifvm-tab-scroll-maintenance>.fifmnt-list-shell,#${ROOT_ID} .fifvm-tab-scroll-compliance>.fifv21-table-shell{margin-top:0}
  	      #${ROOT_ID} .fifvm-tab-scroll .fifmnt-list-shell,#${ROOT_ID} .fifvm-tab-scroll .fifv21-table-shell{overflow:visible!important}
  	      #${ROOT_ID} .fifvm-tab-scroll .fifmnt-columns,#${ROOT_ID} .fifvm-tab-scroll .fifv21-table thead{position:sticky!important;top:0!important;z-index:12!important;background:#1b211c!important;box-shadow:0 5px 12px rgba(0,0,0,.24)}
  	      #${ROOT_ID} .fifvm-tab-scroll .fifmnt-list{max-height:none!important;overflow:visible!important}
  	      #${ROOT_ID} .fifvm-tab-scroll .fifv21-table tbody{display:table-row-group!important;max-height:none!important;overflow:visible!important}
  	      #${ROOT_ID} .fifvm-tab-scroll .fifv21-table thead{display:table-header-group!important;width:auto!important}#${ROOT_ID} .fifvm-tab-scroll .fifv21-table tbody tr{display:table-row!important;width:auto!important}
  	      #${ROOT_ID} .fifvm-tab-fixed-tyres .fifvm-original-tyre-heading{min-height:52px!important;padding:8px 14px!important;background:#171c18!important;border-bottom:1px solid rgba(204,102,51,.22)!important}
  	      #${ROOT_ID} .fifvm-tab-scroll-tyres{padding:0 12px 24px!important}#${ROOT_ID} .fifvm-original-tyre-body{overflow:visible!important;border-top:0!important;border-radius:0 0 12px 12px!important}
  	      #${ROOT_ID} [data-fif-fixed-tyre-actions=true]{background:#171c18!important;border-left:0!important;border-right:0!important}
  	      #${ROOT_ID} .fifvm-tab-fixed-overview .fifsnap-toolbar{padding:8px 12px!important;border-bottom:0!important}
  	      #${ROOT_ID} .fifvm-tab-scroll-overview{padding:0!important}#${ROOT_ID} .fifvm-tab-scroll-overview>.fifsnap-picker{margin:8px}#${ROOT_ID} .fifvm-tab-scroll-overview>.fifsnap-grid{padding:8px!important}
  	      @media(max-width:1180px){#${ROOT_ID} .fifvm-form-grid.compact{grid-template-columns:repeat(2,minmax(0,1fr))!important}}
  	      @media(max-width:760px){#${ROOT_ID} .fifvm-form-grid.compact{grid-template-columns:1fr!important}#${ROOT_ID} .fifvm-colour-values{grid-template-columns:1fr 1fr}#${ROOT_ID} .fifvm-colour-values .hex{grid-column:1/-1}}

  	      #${ROOT_ID} .fifdash-workspace{
  	        display:grid!important;
  	        grid-template-rows:auto minmax(0,1fr)!important;
  	        height:100%!important;
  	        min-width:0!important;
  	        min-height:0!important;
  	        overflow:hidden!important;
  	        isolation:isolate!important;
  	        background:#111512!important;
  	      }
  	      #${ROOT_ID} .fifdash-command-header{
  	        grid-row:1!important;
  	        position:relative!important;
  	        inset:auto!important;
  	        z-index:500!important;
  	        width:100%!important;
  	        min-width:0!important;
  	        box-sizing:border-box!important;
  	        flex:none!important;
  	        background:
  	          linear-gradient(90deg,rgba(255,255,255,.035),transparent 48%),
  	          #151a16!important;
  	        border-bottom:1px solid rgba(204,102,51,.34)!important;
  	        box-shadow:0 10px 24px rgba(0,0,0,.36)!important;
  	        backdrop-filter:none!important;
  	        isolation:isolate!important;
  	        transform:translateZ(0);
  	      }
  	      #${ROOT_ID} .fifdash-main{
  	        grid-row:2!important;
  	        position:relative!important;
  	        z-index:1!important;
  	        width:100%!important;
  	        min-width:0!important;
  	        min-height:0!important;
  	        max-height:100%!important;
  	        overflow:auto!important;
  	        overscroll-behavior:contain!important;
  	        scrollbar-gutter:stable;
  	        background:#111512!important;
  	      }
  	      #${ROOT_ID} .fifdash-main.fleet-list-mode,
  	      #${ROOT_ID} .fifdash-main.has-vehicle-manager,
  	      #${ROOT_ID} .fifdash-main.main-area-tyres{
  	        overflow:hidden!important;
  	      }
  	      #${ROOT_ID} .fifdash-main-area-dashboard{
  	        height:100%!important;
  	        min-height:0!important;
  	        display:flex!important;
  	        flex-direction:column!important;
  	      }
  	      #${ROOT_ID} .fifdash-main-area-fixed{
  	        position:relative!important;
  	        z-index:40!important;
  	        flex:0 0 auto!important;
  	        min-width:0!important;
  	        background:#111512!important;
  	        box-shadow:0 8px 18px rgba(0,0,0,.22);
  	        isolation:isolate;
  	      }
  	      #${ROOT_ID} .fifdash-main-area-scroll{
  	        position:relative!important;
  	        z-index:1!important;
  	        flex:1 1 auto!important;
  	        min-width:0!important;
  	        min-height:0!important;
  	        overflow:auto!important;
  	        overscroll-behavior:contain!important;
  	        scrollbar-gutter:stable;
  	        background:#111512!important;
  	      }
  	      #${ROOT_ID} .fifdash-main-area-scroll::-webkit-scrollbar{
  	        width:7px;
  	        height:7px;
  	      }
  	      #${ROOT_ID} .fifdash-main-area-scroll::-webkit-scrollbar-thumb{
  	        border-radius:999px;
  	        background:rgba(204,102,51,.46);
  	      }
  	      #${ROOT_ID} .fifdash-main-area-dashboard.is-trailers .fifdash-asset-column-head .vehicle-head{
  	        display:flex;
  	        align-items:center;
  	        padding:0 11px;
  	        color:#8f9892;
  	        font-size:8px;
  	        font-weight:950;
  	        letter-spacing:.08em;
  	        text-transform:uppercase;
  	      }
  	      #${ROOT_ID} .fifdash-main-area-dashboard.is-trailers .fifdash-asset-column-head .metric-heads>span{
  	        min-width:0;
  	        display:flex;
  	        align-items:center;
  	        padding:0 9px;
  	        border-right:1px solid rgba(255,255,255,.06);
  	        color:#7f8882;
  	        font-size:7.5px;
  	        font-weight:950;
  	        letter-spacing:.08em;
  	        text-transform:uppercase;
  	      }
  	      #${ROOT_ID} .fifdash-main-area-dashboard.is-trailers .fifdash-asset-column-head .metric-heads>span:last-child{
  	        border-right:0;
  	      }

  	      #${ROOT_ID} .fif-collapse-group{position:relative;overflow:hidden}
  	      #${ROOT_ID} .fif-collapse-summary{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:12px!important;width:100%;box-sizing:border-box;cursor:pointer;user-select:none;outline:none}
  	      #${ROOT_ID} .fif-collapse-summary>div:first-child,#${ROOT_ID} .fif-collapse-summary>h2,#${ROOT_ID} .fif-collapse-summary>h3,#${ROOT_ID} .fif-collapse-summary>h4{min-width:0;flex:1 1 auto}
  	      #${ROOT_ID} .fif-collapse-summary:focus-visible{box-shadow:inset 0 0 0 2px rgba(224,123,67,.7)!important}
  	      #${ROOT_ID} .fif-collapse-toggle{flex:0 0 34px!important;width:34px!important;height:34px!important;min-height:34px!important;padding:0!important;margin-left:auto!important;display:grid!important;place-items:center!important;border:1px solid rgba(204,102,51,.34)!important;border-radius:9px!important;background:linear-gradient(145deg,rgba(204,102,51,.13),rgba(255,255,255,.025))!important;color:#d98759!important;cursor:pointer!important;box-shadow:none!important}
  	      #${ROOT_ID} .fif-collapse-toggle:hover{border-color:rgba(224,123,67,.75)!important;background:rgba(204,102,51,.2)!important;color:#fff!important}
  	      #${ROOT_ID} .fif-collapse-toggle svg{width:18px;height:18px;display:block;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round;transition:transform .16s ease;pointer-events:none}
  	      #${ROOT_ID} .fif-collapse-group.is-open>.fif-collapse-summary .fif-collapse-toggle svg{transform:rotate(180deg)}
  	      #${ROOT_ID} .fif-collapse-group.is-open>.fif-collapse-summary{border-bottom:1px solid rgba(204,102,51,.2)!important}
  	      #${ROOT_ID} .fif-collapse-content[hidden]{display:none!important}
  	      #${ROOT_ID} .fif-collapse-content{display:block;min-width:0}
  	      #${ROOT_ID} .fifsp-form>section.fif-collapse-group{padding:0!important}
  	      #${ROOT_ID} .fifsp-form>section.fif-collapse-group>.fif-collapse-summary{min-height:48px;padding:10px 12px!important;background:rgba(255,255,255,.03)!important}
  	      #${ROOT_ID} .fifsp-form>section.fif-collapse-group>.fif-collapse-summary h3{margin:0!important}
  	      #${ROOT_ID} .fifsp-form>section.fif-collapse-group>.fif-collapse-content{padding:10px 12px 12px}
  	      @media(max-width:680px){#${ROOT_ID} .fif-collapse-toggle{flex-basis:32px!important;width:32px!important;height:32px!important;min-height:32px!important}}
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  window.FIFDashboard = {
  	    version: VERSION,
  	    rootId: ROOT_ID,
  	    render: render,
  	    destroy: destroy,
  	    updateAppData: function (nextAppData) {
  	      if (!nextAppData || !nextAppData.User) return false;
  	      APP_DATA = nextAppData;
  	      refreshCurrentUserPermissions(false);
  	      state.actionableAlertCache = {};
  	      state.locationEventCache = {};
  	      state.locationEventDatabaseRows = {};
  	      state.locationEventDatabaseLoaded = {};
  	      state.locationEventDatabaseLoading = {};
  	      state.locationEventDatabaseError = {};
  	      state.locationEventViewRelationLoaded = {};
  	      state.locationEventViewRelationLoading = {};
  	      const workspaceOpen = !!state.selectedVehicleKey || state.serviceModalOpen || !!document.getElementById(SERVICE_MODAL_ID);
  	      if (!workspaceOpen && !state.destroyed) render();
  	      return true;
  	    },
  	    getState: function () {
  	      return {
  	        activeTab: state.activeTab,
  	        viewMode: state.viewMode,
  	        selectedCompanyKey: state.selectedCompanyKey,
  	        selectedHistoryKey: state.selectedHistoryKey,
  	        search: state.search,
  	        trailerType: state.trailerType,
  	        selectedVehicleKey: state.selectedVehicleKey,
  	        vehicleActiveTab: state.vehicleActiveTab,
  	        applicationDirty: state.applicationDirty,
  	        applicationStatus: applicationStatusLabel(),
  	        vehicleServiceView: state.vehicleServiceView,
  	        serviceProviderCount: CAN_ACCESS_SERVICE ? serviceProviders(selectedCompany()).length : 0,
  	        vehicleSortKey: state.vehicleSortKey,
  	        vehicleSortDir: state.vehicleSortDir,
  	        serviceOpenJobs: (CAN_ACCESS_SERVICE || CAN_ACCESS_MAINTENANCE) ? serviceOpenOrders(selectedCompany()).length : 0,
  	        maintenanceTable: MAINTENANCE_TABLE,
  	        maintenanceSchemaColumns: MAINTENANCE_SCHEMA_COLUMNS.slice(),
  	        maintenanceReadSource: "AppData.Tractors[].Maintenance + AppData.Trailers[].Maintenance",
  	        maintenanceLoadedVehicles: (CAN_ACCESS_SERVICE || CAN_ACCESS_MAINTENANCE) ? Object.keys(state.maintenanceLoaded || {}).filter(function (key) {
  	          return state.maintenanceLoaded[key];
  	        }).length : 0,
  	        tyreWarehouseMounted: !!companyTyreWarehouseInstance,
  	        canEditVehiclePhysical: CAN_EDIT_VEHICLE_PHYSICAL,
  	        canManageWorkshop: CAN_MANAGE_WORKSHOP,
  	        canManageServiceProviders: CAN_MANAGE_SERVICE_PROVIDERS,
  	        canCaptureOnRoadFuel: CAN_CAPTURE_ON_ROAD_FUEL,
  	        employeeCount: CAN_ACCESS_USERS ? companyEmployees(selectedCompany()).length : 0,
  	        canManageEmployees: CAN_MANAGE_EMPLOYEES,
  	        canManageEmployeeAccess: CAN_MANAGE_EMPLOYEE_ACCESS,
  	        canCreateUsers: CAN_CREATE_USERS,
  	        canResetEmployeePasswords: CAN_RESET_EMPLOYEE_PASSWORDS,
  	        canViewEmployeePayroll: CAN_VIEW_EMPLOYEE_PAYROLL,
  	        access: {
  	          dashboard: CAN_ACCESS_DASHBOARD,
  	          applications: CAN_ACCESS_APPLICATIONS,
  	          users: CAN_ACCESS_USERS,
  	          home: managedPermissionValues(CURRENT_USER && CURRENT_USER.Home, FIF_OFFICE_PERMISSION_OPTIONS)[0] || "",
  	          vehicles: CAN_ACCESS_VEHICLES,
  	          trailers: CAN_ACCESS_TRAILERS,
  	            vehicleData: CAN_ACCESS_VEHICLE_DATA,
  	          alerts: CAN_ACCESS_ALERTS,
  	          locationEvents: CAN_ACCESS_LOCATION_EVENTS,
  	          fuel: CAN_ACCESS_FUEL,
  	          tyres: CAN_ACCESS_TYRES,
  	          maintenance: CAN_ACCESS_MAINTENANCE,
  	          service: CAN_ACCESS_SERVICE,
  	          compliance: CAN_ACCESS_COMPLIANCE,
  	        },
  	        selectedVehicleAlertCount: CAN_ACCESS_ALERTS && selectedVehicle(selectedCompany()) && userCanAccessAsset(selectedVehicle(selectedCompany())) ? vehicleAlertsForDisplay(selectedCompany(), selectedVehicle(selectedCompany()), true).length: 0,
  	        selectedVehicleEventCount: CAN_ACCESS_LOCATION_EVENTS && selectedVehicle(selectedCompany()) ? fifVehicleLocationEvents(selectedCompany(), selectedVehicle(selectedCompany())).length : 0,
  	        relationSchemaMode: "automatic qualified relation creation on explicit save"
  	      };
  	    }
  	  };

  	  const V21_RELATION_SCHEMA = Object.freeze({
  	    "Companies.Maintenance": ["Maintenance", "n"],
  	    "Tractors.Maintenance": ["Maintenance", "n"],
  	    "Trailers.Maintenance": ["Maintenance", "n"],
  	    "Tractorview.Maintenance": ["Maintenance", "n"],
  	    "Tractorview.Fuel": ["FuelOut", "n"],
  	    "Tractorview.Events": ["JobEntries", "n"],
  	    "Companies.Employees": ["Users", "n"],
  	    "Users.Companies": ["Companies", "n"],
  	    "Tractors.Tyres": ["Tyres", "n"],
  	    "Trailers.Tyres": ["Tyres", "n"],
  	    "Maintenance.Company": ["Companies", "1"],
  	    "Maintenance.Tractor": ["Tractors", "1"],
  	    "Maintenance.Trailer": ["Trailers", "1"],
  	    "Maintenance.TractorPeriod": ["Tractorview", "1"],
  	    "Maintenance.ParentRecord": ["Maintenance", "1"],
  	    "Maintenance.RenewalRecord": ["Maintenance", "1"],
  	  });

  	  function v21RelationMessage(error) {
  	    return clean(error && (error.message || error.faultString || error.details || error.code));
  	  }

  	  function v21RelationAlreadyLinked(error) {
  	    return /already|duplicate|relation.+exist|already.+related/i.test(v21RelationMessage(error));
  	  }

  	  function v21RelationColumnMissing(error) {
  	    return /unknown\s+column|column.+(?:does not exist|not found|unknown)|unknown.+property|relation.+column.+(?:missing|not found)|unable to find.+column/i.test(v21RelationMessage(error));
  	  }

  	  function v21RelationDefinition(parentTable, relation) {
  	    const configured = V21_RELATION_SCHEMA[clean(parentTable) + "." + clean(relation)];
  	    return configured ? { childTable: configured[0], cardinality: configured[1] } : null;
  	  }

  	  function v21QualifiedRelationName(parentTable, relation) {
  	    const definition = v21RelationDefinition(parentTable, relation);
  	    return definition ? clean(relation) + ":" + definition.childTable + ":" + definition.cardinality : "";
  	  }

  	  async function v21WriteRelation(mode, parentTable, parentId, relation, children, required) {
  	    if (!parentId) return false;
  	    const childRows = arr(children).filter(function (child) { return child && objectIdOf(child); }).map(function (child) {
  	      return { objectId: objectIdOf(child) };
  	    });
  	    if (!BACKENDLESS_API || !BACKENDLESS_API.Data || !BACKENDLESS_API.Data.of) {
  	      if (required) throw new Error("The database is unavailable while linking " + parentTable + "." + relation + ".");
  	      return false;
  	    }

  	    const store = BACKENDLESS_API.Data.of(parentTable);
  	    const parent = { objectId: parentId };
  	    const useSet = mode === "set" && typeof store.setRelation === "function";
  	    const useAdd = typeof store.addRelation === "function";
  	    if (!useSet && !useAdd) {
  	      if (required) throw new Error("Database relation methods are unavailable for " + parentTable + "." + relation + ".");
  	      return false;
  	    }

  	    const perform = async function (relationName) {
  	      if (useSet) return store.setRelation(parent, relationName, childRows);
  	      if (!childRows.length) return 0;
  	      return store.addRelation(parent, relationName, childRows);
  	    };

  	    const qualified = childRows.length ? v21QualifiedRelationName(parentTable, relation) : "";
  	    const primaryName = qualified || relation;
  	    try {
  	      await perform(primaryName);
  	      if (qualified)
  	      return true;
  	    } catch (firstError) {
  	      if (v21RelationAlreadyLinked(firstError)) return true;
  	      if (qualified && !v21RelationColumnMissing(firstError)) {
  	        try {
  	          await perform(relation);
  	          return true;
  	        } catch (shortError) {
  	          if (v21RelationAlreadyLinked(shortError)) return true;
  	          firstError = shortError;
  	        }
  	      }
  	      if (v21RelationColumnMissing(firstError) && !childRows.length) return true;

  	      if (required) throw new Error("The " + parentTable + "." + relation + " relation could not be linked or created. " + v21RelationMessage(firstError));
  	      return false;
  	    }
  	  }

  	  async function v21AddRelation(table, parentId, relation, childId, required) {
  	    if (!parentId || !childId) return false;
  	    return v21WriteRelation("add", table, parentId, relation, [{ objectId: childId }], required);
  	  }

  	  async function v21SetMaintenanceBackRelation(saved, relation, targetId, required) {
  	    if (!saved || !saved.objectId || !targetId) return false;
  	    return v21WriteRelation("set", MAINTENANCE_TABLE, saved.objectId, relation, [{ objectId: targetId }], required);
  	  }

  	  async function addMaintenanceRelations(vehicle, saved, dateValue) {
  	    if (!vehicle || !objectIdOf(vehicle) || !saved || !objectIdOf(saved)) return;
  	    await v21AddRelation(assetTableName(vehicle), objectIdOf(vehicle), MAINTENANCE_RELATION, objectIdOf(saved), true);
  	    const view = matchingVehiclePeriod(vehicle, dateValue);
  	    if (!assetIsTrailer(vehicle) && view && objectIdOf(view)) {
  	      const linked = await v21AddRelation("Tractorview", objectIdOf(view), MAINTENANCE_RELATION, objectIdOf(saved), false);
  	      if (linked) {
  	        if (!Array.isArray(view.Maintenance)) view.Maintenance = [];
  	        if (!view.Maintenance.some(function (item) { return item && objectIdOf(item) === objectIdOf(saved); })) view.Maintenance.push(saved);
  	      }
  	    }
  	  }

  	  async function v21LinkMaintenanceLineage(company, saved) {
  	    if (!saved || !saved.objectId || !saved.ParentWorkOrderId) return;
  	    const parent = serviceWorkOrderById(company, saved.ParentWorkOrderId);
  	    if (!parent || !parent.objectId || parent.objectId === saved.objectId) return;
  	    await v21SetMaintenanceBackRelation(saved, "ParentRecord", parent.objectId, false);
  	    try {
  	      await v21WriteRelation("set", MAINTENANCE_TABLE, parent.objectId, "RenewalRecord", [{ objectId: saved.objectId }], false);
  	      if (saved.Category === V21_CATEGORY_COMPLIANCE && saved.IsRenewal) {
  	        const renewedDate = maintenanceDateForSave(saved.IssueDate || saved.EffectiveDate || new Date());
  	        await BACKENDLESS_API.Data.of(MAINTENANCE_TABLE).save({
  	          objectId: parent.objectId, Status: "Renewed", ComplianceStatus: "Renewed", RenewedDate: renewedDate
  	        });
  	        parent.Status = "Renewed";
  	        parent.ComplianceStatus = "Renewed";
  	        parent.RenewedDate = maintenanceDateInput(renewedDate);
  	        const vehicle = selectedVehicle(company);
  	        if (vehicle) upsertMaintenanceLocal(vehicle, parent);
  	      }
  	    } catch (error) {

  	    }
  	  }

  	  function workshopEnsureSmartState() {
  	    if (!state.maintenanceView) state.maintenanceView = "preventive";
  	    if (typeof state.maintenanceOpenExpanded !== "boolean") state.maintenanceOpenExpanded = false;
  	    if (!state.workshopDragJobId) state.workshopDragJobId = "";
  	    if (!state.workshopDragFrom) state.workshopDragFrom = "";
  	    if (!state.workshopBoardCategory) state.workshopBoardCategory = "";
  	  }

  	  function injectV21SmartWorkshopStyles() {
  	    if (document.getElementById(V21_WORKSHOP_SMART_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = V21_WORKSHOP_SMART_STYLE_ID;
  	    style.textContent = `
  	      #${ROOT_ID} .fifwrk-decision{
  	        width:min(980px,100%);
  	        margin:10px 0 0;
  	        border:1px solid rgba(255,255,255,.08);
  	        border-left:4px solid #cc6633;
  	        border-radius:12px;
  	        background:linear-gradient(145deg,#202720,#121713);
  	        overflow:hidden;
  	      }
  	      #${ROOT_ID} .fifwrk-decision>header{
  	        display:flex;align-items:flex-start;justify-content:space-between;gap:14px;
  	        padding:13px 14px;border-bottom:1px solid rgba(255,255,255,.07);background:#202620;
  	      }
  	      #${ROOT_ID} .fifwrk-decision .eyebrow,#${ROOT_ID} .fifwrk-panel-label{
  	        display:block;color:#da7a47;font-size:9px;font-weight:950;letter-spacing:.1em;text-transform:uppercase;
  	      }
  	      #${ROOT_ID} .fifwrk-decision h4{margin:0;color:#fff;font-size:20px}
  	      #${ROOT_ID} .fifwrk-decision p{margin:5px 0 0;color:#929c96;font-size:11px;line-height:1.45}
  	      #${ROOT_ID} .fifwrk-decision-actions{display:flex;gap:7px;align-items:center;flex-wrap:wrap;justify-content:flex-end}
  	      #${ROOT_ID} .fifwrk-position-grid{
  	        display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1px;background:rgba(255,255,255,.055)
  	      }
  	      #${ROOT_ID} .fifvsvc-kpis article>button{
  	        width:100%;height:100%;padding:0;border:0;background:transparent;color:inherit;text-align:left;font:inherit;cursor:pointer
  	      }
  	      #${ROOT_ID} .fifvsvc-kpis article:hover{border-color:rgba(204,102,51,.48);transform:translateY(-1px)}
  	      #${ROOT_ID} .fifvsvc-kpis article:focus-within{outline:2px solid rgba(204,102,51,.58);outline-offset:1px}
  	      #${ROOT_ID} .fifwrk-position-grid>div{padding:11px 12px;background:#151a16;min-width:0}
  	      #${ROOT_ID} .fifwrk-position-grid span{display:block;color:#7f8982;font-size:8px;font-weight:900;text-transform:uppercase}
  	      #${ROOT_ID} .fifwrk-position-grid strong{display:block;margin-top:5px;color:#edf2ee;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fifwrk-position-grid small{display:block;margin-top:4px;color:#87918b;font-size:9px}
  	      #${ROOT_ID} .fifwrk-position-next{padding:12px 14px;border-top:1px solid rgba(255,255,255,.055);display:flex;align-items:center;justify-content:space-between;gap:12px;background:#111612}
  	      #${ROOT_ID} .fifwrk-position-next strong{color:#f4f7f5;font-size:13px}
  	      #${ROOT_ID} .fifwrk-position-next span{display:block;margin-top:3px;color:#8a948e;font-size:10px}

  	      #${ROOT_ID} .fifwrk-tabs{display:flex;align-items:center;gap:6px;padding:7px 10px;background:#171d18;border-bottom:1px solid rgba(255,255,255,.06);overflow-x:auto}
  	      #${ROOT_ID} .fifwrk-tabs button{min-height:34px;padding:0 11px;border:1px solid transparent;border-radius:8px;background:transparent;color:#919b95;font:inherit;font-size:10px;font-weight:900;white-space:nowrap;cursor:pointer}
  	      #${ROOT_ID} .fifwrk-tabs button.active{border-color:rgba(204,102,51,.45);background:rgba(204,102,51,.11);color:#fff;box-shadow:inset 0 -2px 0 #cc6633}
  	      #${ROOT_ID} .fifwrk-tabs b{display:inline-grid;place-items:center;min-width:18px;height:18px;margin-left:5px;border-radius:99px;background:#29302a;color:#c9d0cb;font-size:8px}
  	      #${ROOT_ID} .fifmnt-collapse-arrow{display:inline-block;margin-left:6px;color:#d27a4c;font-size:13px;line-height:1}

  	      #${ROOT_ID} .fifwrk-board-wrap{display:grid;gap:8px;padding:10px 0 20px}
  	      #${ROOT_ID} .fifwrk-board-intro{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:0 2px}
  	      #${ROOT_ID} .fifwrk-board-intro strong{color:#eef2ef;font-size:14px}
  	      #${ROOT_ID} .fifwrk-board-intro span{display:block;margin-top:3px;color:#87918b;font-size:10px}
  	      #${ROOT_ID} .fifwrk-board{display:grid;grid-template-columns:repeat(5,minmax(230px,1fr));gap:7px;overflow-x:auto;padding-bottom:5px}
  	      #${ROOT_ID} .fifwrk-column{min-height:360px;border:1px solid rgba(255,255,255,.07);border-radius:10px;background:#111612;overflow:hidden}
  	      #${ROOT_ID} .fifwrk-column.is-drop-target{border-color:rgba(204,102,51,.75);box-shadow:0 0 0 2px rgba(204,102,51,.12) inset}
  	      #${ROOT_ID} .fifwrk-column>header{display:flex;align-items:center;gap:8px;padding:9px 10px;border-bottom:1px solid rgba(255,255,255,.06);background:#1d231e}
  	      #${ROOT_ID} .fifwrk-column>header i{width:8px;height:8px;border-radius:99px;background:#78827c}
  	      #${ROOT_ID} .fifwrk-column.phase-scheduled>header i{background:#6c8cff}
  	      #${ROOT_ID} .fifwrk-column.phase-booked>header i{background:#9c75e8}
  	      #${ROOT_ID} .fifwrk-column.phase-in-progress>header i{background:#df8b54}
  	      #${ROOT_ID} .fifwrk-column.phase-waiting-parts>header i{background:#e0ad43}
  	      #${ROOT_ID} .fifwrk-column.phase-ready>header i{background:#63c88c}
  	      #${ROOT_ID} .fifwrk-column>header div{min-width:0;flex:1}
  	      #${ROOT_ID} .fifwrk-column>header strong{display:block;color:#f0f4f1;font-size:11px}
  	      #${ROOT_ID} .fifwrk-column>header small{display:block;margin-top:2px;color:#7f8982;font-size:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fifwrk-column>header b{display:grid;place-items:center;min-width:21px;height:21px;border-radius:99px;background:#2a302b;color:#d4dad6;font-size:9px}
  	      #${ROOT_ID} .fifwrk-column-body{display:grid;align-content:start;gap:7px;padding:7px;min-height:305px}
  	      #${ROOT_ID} .fifwrk-column-empty{padding:35px 10px;color:#707a73;text-align:center;font-size:9px}

  	      #${ROOT_ID} .fifwrk-card{display:grid;gap:8px;padding:10px;border:1px solid rgba(255,255,255,.075);border-left:3px solid #cc6633;border-radius:9px;background:linear-gradient(145deg,#1b211c,#0f1410);cursor:grab}
  	      #${ROOT_ID} .fifwrk-card:active{cursor:grabbing}
  	      #${ROOT_ID} .fifwrk-card.is-dragging{opacity:.5}
  	      #${ROOT_ID} .fifwrk-card.priority-critical{border-left-color:#ef6761}
  	      #${ROOT_ID} .fifwrk-card.priority-high{border-left-color:#e4a24f}
  	      #${ROOT_ID} .fifwrk-card-top{display:flex;align-items:flex-start;justify-content:space-between;gap:8px}
  	      #${ROOT_ID} .fifwrk-card-top span{color:#77817a;font-size:8px;font-weight:850}
  	      #${ROOT_ID} .fifwrk-card-top b{color:#d68a60;font-size:8px;text-transform:uppercase}
  	      #${ROOT_ID} .fifwrk-card h5{margin:0;color:#f3f6f4;font-size:12px}
  	      #${ROOT_ID} .fifwrk-card-provider{margin:-4px 0 0;color:#c87a50;font-size:9px;font-weight:800}
  	      #${ROOT_ID} .fifwrk-card-facts{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:5px}
  	      #${ROOT_ID} .fifwrk-card-facts>div{padding:6px 7px;border:1px solid rgba(255,255,255,.05);border-radius:7px;background:#101511;min-width:0}
  	      #${ROOT_ID} .fifwrk-card-facts span{display:block;color:#707a73;font-size:7px;font-weight:900;text-transform:uppercase}
  	      #${ROOT_ID} .fifwrk-card-facts strong{display:block;margin-top:3px;color:#dfe5e0;font-size:9px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fifwrk-card-note{padding:7px 8px;border-radius:7px;background:rgba(255,255,255,.025);color:#8f9992;font-size:9px;line-height:1.4}
  	      #${ROOT_ID} .fifwrk-card-note strong{display:block;margin-bottom:2px;color:#b9c1bc;font-size:8px}
  	      #${ROOT_ID} .fifwrk-card footer{display:grid;grid-template-columns:auto auto minmax(90px,1fr);gap:5px}
  	      #${ROOT_ID} .fifwrk-card footer.has-cancel{grid-template-columns:auto auto auto minmax(90px,1fr)}
  	      #${ROOT_ID} .fifwrk-card footer button{min-height:30px;padding:0 8px;border:1px solid rgba(255,255,255,.09);border-radius:7px;background:#171c18;color:#aab3ad;font:inherit;font-size:8px;font-weight:900;cursor:pointer}
  	      #${ROOT_ID} .fifwrk-card footer button.primary{border-color:rgba(204,102,51,.45);background:#9d4928;color:#fff}
  	      #${ROOT_ID} .fifwrk-card footer button.danger,#${ROOT_ID} .fifwrk-decision-actions button.danger{border-color:rgba(239,83,80,.42);background:rgba(239,83,80,.14);color:#ffaaa6}
  	      #${SERVICE_MODAL_ID} .fifwrk-modal footer button.danger{border-color:rgba(239,83,80,.48);background:rgba(239,83,80,.16);color:#ffaaa6}

  	      #${ROOT_ID} .fifwrk-history-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(330px,1fr));gap:8px;padding:10px 0 20px}
  	      #${ROOT_ID} .fifwrk-history-card{display:grid;gap:8px;padding:11px;border:1px solid rgba(255,255,255,.075);border-radius:10px;background:linear-gradient(145deg,#1b211c,#111612)}
  	      #${ROOT_ID} .fifwrk-history-card>header{display:flex;align-items:flex-start;justify-content:space-between;gap:9px}
  	      #${ROOT_ID} .fifwrk-history-card h5{margin:0;color:#f2f5f3;font-size:13px}
  	      #${ROOT_ID} .fifwrk-history-card header span{color:#79837c;font-size:8px}
  	      #${ROOT_ID} .fifwrk-history-card p{margin:0;color:#929c96;font-size:10px;line-height:1.45}
  	      #${ROOT_ID} .fifwrk-history-meta{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:5px}
  	      #${ROOT_ID} .fifwrk-history-meta div{padding:7px;border:1px solid rgba(255,255,255,.05);border-radius:7px;background:#101511}
  	      #${ROOT_ID} .fifwrk-history-meta span{display:block;color:#707a73;font-size:7px;text-transform:uppercase;font-weight:900}
  	      #${ROOT_ID} .fifwrk-history-meta strong{display:block;margin-top:3px;color:#dfe5e0;font-size:9px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fifwrk-history-actions{display:flex;justify-content:flex-end;gap:6px}

  	      #${ROOT_ID} .fifwrk-analysis{display:grid;gap:9px;padding:10px 0 20px}
  	      #${ROOT_ID} .fifwrk-analysis-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:7px}
  	      #${ROOT_ID} .fifwrk-analysis-grid article{padding:11px;border:1px solid rgba(255,255,255,.07);border-radius:9px;background:#171d18}
  	      #${ROOT_ID} .fifwrk-analysis-grid span{display:block;color:#78827b;font-size:8px;font-weight:900;text-transform:uppercase}
  	      #${ROOT_ID} .fifwrk-analysis-grid strong{display:block;margin-top:5px;color:#f0f4f1;font-size:16px}
  	      #${ROOT_ID} .fifwrk-analysis-list{border:1px solid rgba(255,255,255,.07);border-radius:10px;background:#141914;overflow:hidden}
  	      #${ROOT_ID} .fifwrk-analysis-list>header{padding:10px 12px;background:#1e241f;color:#eef2ef;font-size:12px;font-weight:900}
  	      #${ROOT_ID} .fifwrk-analysis-list article{display:grid;grid-template-columns:minmax(0,1fr) auto auto;gap:10px;padding:9px 12px;border-top:1px solid rgba(255,255,255,.05);align-items:center}
  	      #${ROOT_ID} .fifwrk-analysis-list article strong{color:#dfe5e0;font-size:10px}
  	      #${ROOT_ID} .fifwrk-analysis-list article span{color:#89938d;font-size:9px}

  	      #${SERVICE_MODAL_ID} .fifsp-modal.fifwrk-modal{width:min(760px,calc(100vw - 28px));background:linear-gradient(145deg,#1c221d,#0c100d)}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-summary{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;margin-bottom:10px}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-summary>div{padding:8px 9px;border:1px solid rgba(255,255,255,.06);border-radius:8px;background:#111612}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-summary span{display:block;color:#77817a;font-size:7px;font-weight:900;text-transform:uppercase}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-summary strong{display:block;margin-top:4px;color:#e8ede9;font-size:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-help{padding:9px 10px;margin-bottom:10px;border:1px solid rgba(204,102,51,.22);border-radius:8px;background:rgba(204,102,51,.055);color:#b9a090;font-size:10px;line-height:1.45}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-grid .wide{grid-column:1/-1}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-grid label>span{font-size:9px}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-grid input,#${SERVICE_MODAL_ID} .fifwrk-action-grid select,#${SERVICE_MODAL_ID} .fifwrk-action-grid textarea{min-height:40px;font-size:11px}
  	      #${SERVICE_MODAL_ID} .fifwrk-action-grid textarea{min-height:84px}
  	      #${SERVICE_MODAL_ID} .fifwrk-menu-list{display:grid;gap:7px}
  	      #${SERVICE_MODAL_ID} .fifwrk-menu-list button{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:8px;align-items:center;min-height:49px;padding:9px 11px;border:1px solid rgba(255,255,255,.075);border-radius:9px;background:#151a16;color:#edf2ee;text-align:left;font:inherit;cursor:pointer}
  	      #${SERVICE_MODAL_ID} .fifwrk-menu-list button strong{display:block;font-size:11px}
  	      #${SERVICE_MODAL_ID} .fifwrk-menu-list button span{display:block;margin-top:3px;color:#838d87;font-size:9px}
  	      #${SERVICE_MODAL_ID} .fifwrk-menu-list button b{color:#d58a60;font-size:16px}

  	      #${SERVICE_MODAL_ID} .fifsp-modal>header p:empty{display:none}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-modal{display:grid;grid-template-rows:auto minmax(320px,1fr);min-height:390px}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-tabs{display:flex;align-items:center;gap:6px;padding:0 0 10px;border-bottom:1px solid rgba(255,255,255,.07)}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-tabs button{min-height:36px;padding:0 13px;border:1px solid rgba(255,255,255,.08);border-radius:8px;background:#151a16;color:#929c96;font:inherit;font-size:10px;font-weight:900;cursor:pointer}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-tabs button.active{border-color:rgba(204,102,51,.55);background:rgba(204,102,51,.12);color:#fff;box-shadow:inset 0 -2px 0 #cc6633}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-tabs b{display:inline-grid;place-items:center;min-width:18px;height:18px;margin-left:5px;border-radius:99px;background:#29302a;color:#d0d6d2;font-size:8px}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-panel{min-height:320px;padding-top:10px}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-form{max-width:820px}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-form .grid{grid-template-columns:repeat(2,minmax(0,1fr))}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-form .checks{grid-template-columns:repeat(2,minmax(0,1fr))}
  	      #${SERVICE_MODAL_ID} .fifvsvc-service-setup-form input:disabled{opacity:.62;cursor:not-allowed}
  	      #${SERVICE_MODAL_ID} [data-vm-service-provider-only][hidden],#${SERVICE_MODAL_ID} [data-vm-service-setup-only][hidden]{display:none!important}

  	      @media(max-width:1100px){
  	        #${ROOT_ID} .fifwrk-position-grid,#${ROOT_ID} .fifwrk-analysis-grid{grid-template-columns:repeat(2,minmax(0,1fr))}
  	      }
  	      @media(max-width:700px){
  	        #${ROOT_ID} .fifwrk-decision>header,#${ROOT_ID} .fifwrk-position-next{align-items:flex-start;flex-direction:column}
  	        #${ROOT_ID} .fifwrk-position-grid,#${ROOT_ID} .fifwrk-analysis-grid,#${ROOT_ID} .fifwrk-history-meta,#${SERVICE_MODAL_ID} .fifwrk-action-grid,#${SERVICE_MODAL_ID} .fifwrk-action-summary{grid-template-columns:1fr}
  	        #${ROOT_ID} .fifwrk-card footer{grid-template-columns:1fr}
  	      }
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function servicePrimaryTransition(order) {
  	    const phase = serviceCanonicalStatus(order && order.Status);
  	    const map = {
  	      "Scheduled": { target: "Booked", label: "Confirm Booking" },
  	      "Booked": { target: "In Progress", label: "Start Work" },
  	      "In Progress": { target: "Ready", label: "Mark Ready" },
  	      "Waiting Parts": { target: "In Progress", label: "Parts Received" },
  	      "Ready": { target: "Completed", label: "Complete Job" }
  	    };
  	    return map[phase] || { target: "", label: "" };
  	  }

  	  function vehicleServiceWorkspaceSummary(company, vehicle) {
  	    const records = serviceRecords(vehicle);
  	    const jobs = vehicleServiceOrders(company, vehicle).filter(function (job) {
  	      return job.Category === MAINTENANCE_CATEGORY_SERVICE;
  	    });
  	    const openJobs = jobs.filter(function (job) {
  	      return SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(job.Status)) !== -1;
  	    });
  	    const providers = serviceProviders(company).filter(function (provider) {
  	      return lower(provider.Status) === "active";
  	    });
  	    const health = Object.assign({}, serviceHealthForVehicle(company, vehicle));
  	    const nextParts = [];

  	    if (health.dataConflict) {
  	      nextParts.push("Check setup");
  	    } else {
  	      if (health.nextCounter !== null) {
  	        if (health.remainingCounter === null) {
  	          nextParts.push(formatNumber(health.nextCounter, 0) + " " + health.unit);
  	        } else if (health.remainingCounter <= 0) {
  	          nextParts.push(formatNumber(Math.abs(health.remainingCounter), 0) + " " + health.unit + " overdue");
  	        } else {
  	          nextParts.push(formatNumber(health.remainingCounter, 0) + " " + health.unit);
  	        }
  	      }
  	      if (health.nextDate) {
  	        if (health.remainingDays === null) {
  	          nextParts.push(serviceFormatDate(health.nextDate));
  	        } else if (health.remainingDays < 0) {
  	          nextParts.push(Math.abs(health.remainingDays) + " days overdue");
  	        } else if (health.remainingDays === 0) {
  	          nextParts.push("Due today");
  	        } else {
  	          nextParts.push(health.remainingDays + " days");
  	        }
  	      }
  	    }

  	    return {
  	      records: records,
  	      health: health,
  	      jobs: jobs,
  	      openJobs: openJobs,
  	      providers: providers,
  	      nextText: nextParts.length ? nextParts.join(" / ") : "Not configured"
  	    };
  	  }

  	  function workshopPhaseAgeDays(order) {
  	    const date = fifAlertDate(firstValue([
  	      order && order.CurrentPhaseEnteredAt,
  	      order && order.UpdatedAt,
  	      order && order.updated,
  	      order && order.created
  	    ], ""));
  	    return date ? Math.max(0, Math.floor((Date.now() - date.getTime()) / 86400000)) : 0;
  	  }

  	  function workshopLatestTimelineEntry(order) {
  	    const entries = [];
  	    serviceAuditNoteLog(order).forEach(function (entry) {
  	      entries.push({ At: entry.At, By: entry.By, Type: entry.Type || "Note", Text: entry.Text });
  	    });
  	    serviceWorkflowHistory(order).forEach(function (entry) {
  	      entries.push({ At: entry.At, By: entry.By, Type: servicePhaseLabel(entry.From) + " → " + servicePhaseLabel(entry.To), Text: entry.Note });
  	    });
  	    serviceScheduleAudit(order).forEach(function (entry) {
  	      entries.push({ At: entry.At, By: entry.By, Type: "Rescheduled", Text: (entry.PreviousDate ? serviceFormatDate(entry.PreviousDate) + " → " : "") + (entry.NewDate ? serviceFormatDate(entry.NewDate) : "") + (entry.Reason ? " · " + entry.Reason : "") });
  	    });
  	    entries.sort(function (left, right) {
  	      return new Date(right.At || 0).getTime() - new Date(left.At || 0).getTime();
  	    });
  	    return entries[0] || null;
  	  }

  	  function workshopTimelineHtml(order) {
  	    const entries = [];
  	    serviceAuditNoteLog(order).forEach(function (entry) {
  	      entries.push({ At: entry.At, By: entry.By, Type: entry.Type || "Note", Text: entry.Text });
  	    });
  	    serviceWorkflowHistory(order).forEach(function (entry) {
  	      entries.push({ At: entry.At, By: entry.By, Type: servicePhaseLabel(entry.From) + " → " + servicePhaseLabel(entry.To), Text: entry.Note });
  	    });
  	    serviceScheduleAudit(order).forEach(function (entry) {
  	      entries.push({ At: entry.At, By: entry.By, Type: "Rescheduled", Text: (entry.PreviousDate ? serviceFormatDate(entry.PreviousDate) + " → " : "") + (entry.NewDate ? serviceFormatDate(entry.NewDate) : "") + (entry.Reason ? " · " + entry.Reason : "") });
  	    });
  	    entries.sort(function (left, right) {
  	      return new Date(right.At || 0).getTime() - new Date(left.At || 0).getTime();
  	    });
  	    if (!entries.length) return `<div class="fifsp-empty compact">No workshop timeline entries yet.</div>`;
  	    return `<div class="fifsp-workflow-history"><div class="fifsp-workflow-title">Permanent workshop timeline</div>${entries.map(function (entry) {
  	      return `<article><div><strong>${escapeHtml(entry.Type || "Workshop update")}</strong><span>${escapeHtml(entry.By || "Unknown user")}</span></div><time>${escapeHtml(entry.At ? new Date(entry.At).toLocaleString() : "—")}</time><p>${escapeHtml(entry.Text || "No detail recorded")}</p></article>`;
  	    }).join("")}</div>`;
  	  }

  	  function workshopJobDateLabel(order) {
  	    const phase = serviceCanonicalStatus(order.Status);
  	    if (phase === "Waiting Parts") return order.DelayExpectedDate ? serviceFormatDate(order.DelayExpectedDate) : "Review not set";
  	    if (phase === "Ready") return order.ReadyAt ? new Date(order.ReadyAt).toLocaleDateString() : "Ready";
  	    return order.ScheduledDate ? serviceFormatDate(order.ScheduledDate) : "Unscheduled";
  	  }

  	  function workshopJobCard(order) {
  	    const phase = serviceCanonicalStatus(order.Status);
  	    const primary = servicePrimaryTransition(order);
  	    const canCancelInProgress = phase === "In Progress";
  	    const latest = workshopLatestTimelineEntry(order);
  	    const cost = order.ActualCost !== null ? order.ActualCost : order.EstimatedCost;
  	    return `<article class="fifwrk-card priority-${escapeAttr(lower(order.Priority || "normal"))}" draggable="true" data-workshop-job="${escapeAttr(order.WorkOrderId)}" data-workshop-phase="${escapeAttr(phase)}">
  	      <div class="fifwrk-card-top"><span>${escapeHtml(order.WorkOrderId)}</span><b>${escapeHtml(order.Priority || "Normal")}</b></div>
  	      <h5>${escapeHtml(order.Type || order.Title || "Workshop job")}</h5>
  	      <div class="fifwrk-card-provider">${escapeHtml(order.ProviderName || "Provider not assigned")}</div>
  	      <div class="fifwrk-card-facts">
  	        <div><span>${phase === "Waiting Parts" ? "Next review" : "Scheduled"}</span><strong>${escapeHtml(workshopJobDateLabel(order))}</strong></div>
  	        <div><span>Odometer</span><strong>${order.Odometer === null ? "Not recorded" : escapeHtml(formatNumber(order.Odometer, 0) + " km")}</strong></div>
  	        <div><span>Cost</span><strong>${cost === null ? "Not recorded" : escapeHtml(formatCurrency(cost))}</strong></div>
  	        <div><span>Phase age</span><strong>${workshopPhaseAgeDays(order)} day${workshopPhaseAgeDays(order) === 1 ? "" : "s"}</strong></div>
  	      </div>
  	      <div class="fifwrk-card-note">${latest ? `<strong>${escapeHtml(latest.Type)}</strong>${escapeHtml(latest.Text || "No detail")}` : escapeHtml(order.Complaint || order.Notes || "No job description")}</div>
  	      <footer class="${canCancelInProgress ? "has-cancel" : ""}">
  	        <button type="button" data-workshop-open="${escapeAttr(order.WorkOrderId)}">Open</button>
  	        <button type="button" data-workshop-more="${escapeAttr(order.WorkOrderId)}">More</button>
  	        ${canCancelInProgress ? `<button type="button" class="danger" data-workshop-action="${escapeAttr(order.WorkOrderId)}" data-workshop-target="Cancelled">Cancel Job</button>` : ""}
  	        ${primary.target ? `<button type="button" class="primary" data-workshop-action="${escapeAttr(order.WorkOrderId)}" data-workshop-target="${escapeAttr(primary.target)}">${escapeHtml(primary.label)}</button>` : `<button type="button" data-workshop-open="${escapeAttr(order.WorkOrderId)}">View Record</button>`}
  	      </footer>
  	    </article>`;
  	  }

  	  function workshopBoard(company, vehicle, category) {
  	    const phases = SERVICE_JOB_OPEN_STATUSES.slice();
  	    const isServiceBoard = category === MAINTENANCE_CATEGORY_SERVICE;
  	    const jobs = vehicleServiceOrders(company, vehicle).filter(function (job) {
  	      return job.Category === category && SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(job.Status)) !== -1;
  	    });
  	    const intro = isServiceBoard
  	      ? `<div class="fifwrk-board-intro"><div><strong>Service Jobs</strong></div></div>`
  	      : "";
  	    return `<section class="fifwrk-board-wrap">
  	      ${intro}
  	      <div class="fifwrk-board" data-workshop-board="${escapeAttr(category)}">${phases.map(function (phase) {
  	        const rows = jobs.filter(function (job) { return serviceCanonicalStatus(job.Status) === phase; }).sort(function (a,b) { return naturalCompare(a.ScheduledDate || "9999", b.ScheduledDate || "9999"); });
  	        return `<section class="fifwrk-column phase-${escapeAttr(serviceStatusClass(phase))}" data-workshop-drop-phase="${escapeAttr(phase)}"><header><i></i><div><strong>${escapeHtml(servicePhaseLabel(phase))}</strong>${isServiceBoard ? `<small>${escapeHtml(servicePhaseDescription(phase))}</small>` : ""}</div><b>${rows.length}</b></header><div class="fifwrk-column-body">${rows.length ? rows.map(workshopJobCard).join("") : `<div class="fifwrk-column-empty">No ${escapeHtml(lower(servicePhaseLabel(phase)))} work.</div>`}</div></section>`;
  	      }).join("")}</div>
  	    </section>`;
  	  }

  	  function workshopHistoryCards(records, emptyText) {
  	    return `<div class="fifwrk-history-grid">${records.length ? records.map(function (record) {
  	      const status = serviceCanonicalStatus(record.Status);
  	      const historyDate = record.CompletedDate || record.CancelledAt || record.ReportedDate;
  	      const summary = status === "Cancelled"
  	        ? (record.ClosureReason || record.Notes || "Job cancelled")
  	        : (record.WorkPerformed || record.Diagnosis || record.Complaint || record.Notes || "No work summary");
  	      return `<article class="fifwrk-history-card"><header><div><h5>${escapeHtml(record.Type || record.Title || "Workshop record")}</h5><span>${escapeHtml(record.WorkOrderId)} · ${escapeHtml(status)}</span></div><span>${escapeHtml(serviceFormatDate(historyDate))}</span></header><p>${escapeHtml(summary)}</p><div class="fifwrk-history-meta"><div><span>Provider</span><strong>${escapeHtml(record.ProviderName || "Not recorded")}</strong></div><div><span>Odometer</span><strong>${record.Odometer === null ? "—" : escapeHtml(formatNumber(record.Odometer,0)+" km")}</strong></div><div><span>Cost</span><strong>${record.ActualCost === null ? "—" : escapeHtml(formatCurrency(record.ActualCost))}</strong></div></div><div class="fifwrk-history-actions"><button type="button" class="fifvm-btn" data-workshop-print="${escapeAttr(record.WorkOrderId)}">Print</button><button type="button" class="fifvm-btn primary" data-workshop-open="${escapeAttr(record.WorkOrderId)}">Open Full Record</button></div></article>`;
  	    }).join("") : `<div class="fifvm-empty">${escapeHtml(emptyText)}</div>`}</div>`;
  	  }

  	  function renderSmartServicePosition(company, vehicle) {
  	    const summary = vehicleServiceWorkspaceSummary(company, vehicle);
  	    const health = summary.health;
  	    const hours = health.counterType === "Hours";
  	    const interval = hours ? serviceConfiguredIntervalHours(vehicle) : serviceConfiguredIntervalKm(vehicle);
  	    const next = health.nextCounter;
  	    const active = vehicleServiceOrders(company, vehicle).filter(function (job) {
  	      return job.Category === MAINTENANCE_CATEGORY_SERVICE && SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(job.Status)) !== -1;
  	    }).sort(function (a,b) { return workshopPhaseAgeDays(b)-workshopPhaseAgeDays(a); })[0] || null;
  	    const actionLabel = active ? servicePrimaryTransition(active).label || "Open Service Job" : "";
  	    const readingLabel = hours ? "Current hours" : "Current mileage";
  	    const currentReading = numberValue(tractorMileage(vehicle));
  	    const positionMessage = active
  	      ? servicePhaseLabel(active.Status) + " · " + active.Type
  	      : "No open service job";
  	    return `${vehiclePermissionNotice(CAN_MANAGE_WORKSHOP,"Service permission is required to capture service work and manage job cards.")}<section class="fifwrk-decision"><header><h4>${escapeHtml(health.label)}</h4>${active ? `<div class="fifwrk-decision-actions"><button type="button" class="fifvm-btn" data-workshop-open="${escapeAttr(active.WorkOrderId)}">Open Current Job</button>${serviceCanonicalStatus(active.Status) === "In Progress" ? `<button type="button" class="fifvm-btn danger" data-workshop-action="${escapeAttr(active.WorkOrderId)}" data-workshop-target="Cancelled">Cancel Job</button>` : ""}${servicePrimaryTransition(active).target ? `<button type="button" class="fifvm-btn primary" data-workshop-action="${escapeAttr(active.WorkOrderId)}" data-workshop-target="${escapeAttr(servicePrimaryTransition(active).target)}">${escapeHtml(actionLabel)}</button>` : ""}</div>` : ""}</header><div class="fifwrk-position-grid"><div><span>${escapeHtml(readingLabel)}</span><strong>${currentReading === null ? "Not recorded" : escapeHtml(formatNumber(currentReading,0)+" "+health.unit)}</strong></div><div><span>Last service</span><strong>${health.lastCounter === null ? "Not recorded" : escapeHtml(formatNumber(health.lastCounter,0)+" "+health.unit)}</strong></div><div><span>Service interval</span><strong>${!interval ? "Not configured" : escapeHtml(formatNumber(interval,0)+" "+health.unit)}</strong></div><div><span>Next service</span><strong>${next === null ? "Not configured" : escapeHtml(formatNumber(next,0)+" "+health.unit)}</strong></div><div><span>Last service date</span><strong>${health.lastDate ? escapeHtml(serviceFormatDate(health.lastDate)) : "Not recorded"}</strong></div><div><span>Next service date</span><strong>${health.nextDate ? escapeHtml(serviceFormatDate(health.nextDate)) : "Not configured"}</strong></div></div><div class="fifwrk-position-next"><strong>${escapeHtml(positionMessage)}</strong></div></section>`;
  	  }

  	  function renderVehicleServiceWorkspace(company, vehicle) {
  	    workshopEnsureSmartState();
  	    injectV21SmartWorkshopStyles();
  	    const allowed = ["position","jobs","history"];
  	    const active = allowed.indexOf(state.vehicleServiceView) !== -1 ? state.vehicleServiceView : "position";
  	    const serviceJobs = vehicleServiceOrders(company, vehicle).filter(function (job) { return job.Category === MAINTENANCE_CATEGORY_SERVICE; });
  	    const open = serviceJobs.filter(function (job) { return SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(job.Status)) !== -1; });
  	    const closed = serviceJobs.filter(function (job) { return ["Completed", "Cancelled"].indexOf(serviceCanonicalStatus(job.Status)) !== -1; }).sort(function(a,b){return naturalCompare(b.CompletedDate||b.CancelledAt||b.ReportedDate,a.CompletedDate||a.CancelledAt||a.ReportedDate);});
  	    const view = active === "jobs"
  	      ? workshopBoard(company,vehicle,MAINTENANCE_CATEGORY_SERVICE)
  	      : active === "history"
  	        ? workshopHistoryCards(closed,"No closed service records captured.")
  	        : renderSmartServicePosition(company,vehicle);
  	    const body = renderVehicleServiceKpis(company,vehicle) + view;
  	    return `<section class="fifvsvc-root"><header class="fifvsvc-head"><h3>${escapeHtml(vehicleTitleValue(vehicle))} Service</h3><div class="fifvsvc-head-actions"><button type="button" class="fifvm-btn" data-vm-service-setup>Service Setup</button>${CAN_MANAGE_WORKSHOP ? `<button type="button" class="fifvm-btn" data-vm-service-capture>Capture Completed Service</button>` : ""}${CAN_MANAGE_SERVICE_JOBS ? `<button type="button" class="fifvm-btn primary" data-workshop-new="${escapeAttr(MAINTENANCE_CATEGORY_SERVICE)}">+ Schedule Service</button>` : ""}</div></header><nav class="fifvsvc-tabs fifwrk-tabs"><button type="button" data-vm-service-view="position" class="${active === "position" ? "active" : ""}">Service Position</button><button type="button" data-vm-service-view="jobs" class="${active === "jobs" ? "active" : ""}">Open Jobs <b>${open.length}</b></button><button type="button" data-vm-service-view="history" class="${active === "history" ? "active" : ""}">History <b>${closed.length}</b></button></nav><div class="fifvsvc-body">${body}</div></section>`;
  	  }

  	  function injectPreventiveMaintenanceStyles() {
  	    const styleId = "fif-preventive-maintenance-styles";
  	    if (document.getElementById(styleId)) return;
  	    const style = document.createElement("style");
  	    style.id = styleId;
  	    style.textContent = `
  	      #${ROOT_ID} .fifpm-root{padding:12px;background:#111612}
  	      #${ROOT_ID} .fifpm-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:10px}
  	      #${ROOT_ID} .fifpm-head h4{margin:0;color:#fff;font-size:16px}
  	      #${ROOT_ID} .fifpm-summary{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px;margin-bottom:10px}
  	      #${ROOT_ID} .fifpm-summary article{padding:10px 11px;border:1px solid rgba(255,255,255,.075);border-radius:9px;background:linear-gradient(145deg,#1a211b,#121713)}
  	      #${ROOT_ID} .fifpm-summary span{display:block;color:#7f8982;font-size:8px;font-weight:900;text-transform:uppercase;letter-spacing:.07em}
  	      #${ROOT_ID} .fifpm-summary strong{display:block;margin-top:4px;color:#fff;font-size:17px}
  	      #${ROOT_ID} .fifpm-summary .due strong{color:#e18a59}
  	      #${ROOT_ID} .fifpm-summary .soon strong{color:#d7bd67}
  	      #${ROOT_ID} .fifpm-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:9px}
  	      #${ROOT_ID} .fifpm-card{position:relative;display:flex;flex-direction:column;min-height:230px;padding:12px;border:1px solid rgba(255,255,255,.08);border-radius:11px;background:linear-gradient(145deg,#1d241e,#121713);overflow:hidden}
  	      #${ROOT_ID} .fifpm-card:before{content:"";position:absolute;inset:0 auto 0 0;width:3px;background:#58615b}
  	      #${ROOT_ID} .fifpm-card.status-overdue:before{background:#c85d4b}
  	      #${ROOT_ID} .fifpm-card.status-due-soon:before{background:#d6a84b}
  	      #${ROOT_ID} .fifpm-card.status-on-track:before{background:#4f9b6d}
  	      #${ROOT_ID} .fifpm-card.status-scheduled:before{background:#6b73d8}
  	      #${ROOT_ID} .fifpm-card.status-paused:before{background:#737c76}
  	      #${ROOT_ID} .fifpm-card-top{display:flex;align-items:center;justify-content:space-between;gap:8px}
  	      #${ROOT_ID} .fifpm-card-top span{color:#88928c;font-size:8px;font-weight:900;text-transform:uppercase;letter-spacing:.06em}
  	      #${ROOT_ID} .fifpm-status{padding:4px 7px;border:1px solid rgba(255,255,255,.08);border-radius:99px;background:#222923;color:#dce2de;font-size:8px;font-weight:900;text-transform:uppercase}
  	      #${ROOT_ID} .fifpm-card h5{margin:9px 0 0;color:#fff;font-size:14px}
  	      #${ROOT_ID} .fifpm-scope{min-height:30px;margin:5px 0 0;color:#8d9790;font-size:10px;line-height:1.45}
  	      #${ROOT_ID} .fifpm-due-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px;margin-top:10px}
  	      #${ROOT_ID} .fifpm-due-grid div{padding:8px;border:1px solid rgba(255,255,255,.06);border-radius:7px;background:#111612}
  	      #${ROOT_ID} .fifpm-due-grid span{display:block;color:#737d76;font-size:7px;font-weight:900;text-transform:uppercase}
  	      #${ROOT_ID} .fifpm-due-grid strong{display:block;margin-top:4px;color:#e8ede9;font-size:11px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fifpm-progress{height:6px;margin-top:10px;border-radius:99px;background:#0d110e;overflow:hidden}
  	      #${ROOT_ID} .fifpm-progress i{display:block;height:100%;border-radius:inherit;background:linear-gradient(90deg,#6b7b70,#cc6633)}
  	      #${ROOT_ID} .fifpm-provider{margin-top:8px;color:#87918b;font-size:9px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fifpm-actions{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;margin-top:auto;padding-top:10px}
  	      #${ROOT_ID} .fifpm-actions button{min-height:32px;padding:0 7px;border:1px solid rgba(255,255,255,.09);border-radius:7px;background:#202721;color:#d8ded9;font:inherit;font-size:9px;font-weight:900;cursor:pointer}
  	      #${ROOT_ID} .fifpm-actions button.primary{border-color:#b75b30;background:linear-gradient(#c86e42,#a84e29);color:#fff}
  	      #${ROOT_ID} .fifpm-empty{display:grid;place-items:center;min-height:230px;border:1px dashed rgba(255,255,255,.12);border-radius:11px;background:#121713;color:#87918b;text-align:center}
  	      #${ROOT_ID} .fifpm-empty strong{display:block;color:#fff;font-size:14px}
  	      #${ROOT_ID} .fifpm-empty button{margin-top:10px}
  	      #${SERVICE_MODAL_ID} .fifpm-modal-form .fifpm-form-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
  	      #${SERVICE_MODAL_ID} .fifpm-modal-form .wide{grid-column:1/-1}
  	      #${SERVICE_MODAL_ID} .fifpm-modal-form [hidden]{display:none!important}
  	      #${SERVICE_MODAL_ID} .fifpm-delete-plan{margin-right:auto;border-color:rgba(239,83,80,.48);background:rgba(239,83,80,.14);color:#ffaaa5}
  	      #${SERVICE_MODAL_ID} .fifpm-delete-plan:hover{background:rgba(239,83,80,.24);color:#fff}
  	      #${SERVICE_MODAL_ID} .fifpm-schedule-summary{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:7px;margin-bottom:10px}
  	      #${SERVICE_MODAL_ID} .fifpm-schedule-summary div{padding:9px;border:1px solid rgba(255,255,255,.07);border-radius:8px;background:#121713}
  	      #${SERVICE_MODAL_ID} .fifpm-schedule-summary span{display:block;color:#77817a;font-size:7px;font-weight:900;text-transform:uppercase}
  	      #${SERVICE_MODAL_ID} .fifpm-schedule-summary strong{display:block;margin-top:4px;color:#eef2ef;font-size:10px}
  	      @media(max-width:1150px){#${ROOT_ID} .fifpm-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
  	      @media(max-width:760px){#${ROOT_ID} .fifpm-summary,#${ROOT_ID} .fifpm-grid,#${SERVICE_MODAL_ID} .fifpm-modal-form .fifpm-form-grid,#${SERVICE_MODAL_ID} .fifpm-schedule-summary{grid-template-columns:1fr}}
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function preventivePlanTriggerMode(value) {
  	    value = clean(value);
  	    return ["First Due", "Kilometers Only", "Time Only"].indexOf(value) !== -1 ? value : "First Due";
  	  }

  	  function normalizePreventivePlan(plan) {
  	    plan = plan && typeof plan === "object" ? cloneData(plan) : {};
  	    return {
  	      PlanId: clean(plan.PlanId) || serviceId("PM"),
  	      Name: clean(plan.Name),
  	      Scope: clean(plan.Scope),
  	      TriggerMode: preventivePlanTriggerMode(plan.TriggerMode),
  	      IntervalKM: Math.max(0, numberOr(plan.IntervalKM, 0)),
  	      IntervalDays: Math.max(0, numberOr(plan.IntervalDays, 0)),
  	      WarningKM: Math.max(0, numberOr(plan.WarningKM, 0)),
  	      WarningDays: Math.max(0, numberOr(plan.WarningDays, 0)),
  	      BaselineKM: numberOr(plan.BaselineKM, null),
  	      BaselineDate: maintenanceDateInput(plan.BaselineDate || ""),
  	      Priority: ["Low", "Normal", "High", "Critical"].indexOf(clean(plan.Priority)) !== -1 ? clean(plan.Priority) : "Normal",
  	      ProviderId: clean(plan.ProviderId),
  	      ProviderName: clean(plan.ProviderName),
  	      Active: plan.Active !== false,
  	      CreatedAt: clean(plan.CreatedAt) || new Date().toISOString(),
  	      CreatedBy: clean(plan.CreatedBy) || userDisplayName(),
  	      UpdatedAt: clean(plan.UpdatedAt) || new Date().toISOString(),
  	      UpdatedBy: clean(plan.UpdatedBy) || userDisplayName()
  	    };
  	  }

  	  function preventiveMaintenancePlans(vehicle) {
  	    return arr(getDeep(vehicle, ["Data", "Maintenance", "PreventivePlans"], []))
  	      .filter(function (plan) { return plan && typeof plan === "object" && !Array.isArray(plan); })
  	      .map(normalizePreventivePlan);
  	  }

  	  function preventivePlanRecords(vehicle, planId) {
  	    planId = clean(planId);
  	    if (!planId) return [];
  	    return vehicleMaintenanceOrders(vehicle).map(normalizeServiceWorkOrder).filter(function (record) {
  	      return clean(record.PreventivePlanId) === planId;
  	    });
  	  }

  	  function preventivePlanLatestCompleted(vehicle, plan) {
  	    return preventivePlanRecords(vehicle, plan.PlanId).filter(function (record) {
  	      return serviceCanonicalStatus(record.Status) === "Completed";
  	    }).sort(function (left, right) {
  	      const leftTime = new Date(left.CompletedDate || left.ReportedDate || 0).getTime();
  	      const rightTime = new Date(right.CompletedDate || right.ReportedDate || 0).getTime();
  	      return rightTime - leftTime;
  	    })[0] || null;
  	  }

  	  function preventivePlanOpenJob(vehicle, plan) {
  	    return preventivePlanRecords(vehicle, plan.PlanId).filter(function (record) {
  	      return SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(record.Status)) !== -1;
  	    }).sort(function (left, right) {
  	      return naturalCompare(left.ScheduledDate || "9999", right.ScheduledDate || "9999");
  	    })[0] || null;
  	  }

  	  function preventiveDateDiffDays(dateValue) {
  	    const date = fifAlertDate(dateValue);
  	    if (!date) return null;
  	    const today = new Date();
  	    today.setHours(0, 0, 0, 0);
  	    date.setHours(0, 0, 0, 0);
  	    return Math.ceil((date.getTime() - today.getTime()) / 86400000);
  	  }

  	  function preventivePlanStatus(vehicle, plan) {
  	    plan = normalizePreventivePlan(plan);
  	    const latestCompleted = preventivePlanLatestCompleted(vehicle, plan);
  	    const openJob = preventivePlanOpenJob(vehicle, plan);
  	    const currentKM = numberOr(tractorMileage(vehicle), null);
  	    const baselineKM = latestCompleted && latestCompleted.Odometer !== null ? latestCompleted.Odometer : plan.BaselineKM;
  	    const baselineDate = clean(latestCompleted && (latestCompleted.CompletedDate || latestCompleted.ReportedDate)) || plan.BaselineDate;
  	    const usesKM = plan.TriggerMode !== "Time Only" && plan.IntervalKM > 0;
  	    const usesTime = plan.TriggerMode !== "Kilometers Only" && plan.IntervalDays > 0;
  	    const nextKM = usesKM && baselineKM !== null ? baselineKM + plan.IntervalKM : null;
  	    const nextDate = usesTime && baselineDate ? serviceDatePlusDays(baselineDate, plan.IntervalDays) : "";
  	    const calculationKM = currentKM === null
  	      ? baselineKM
  	      : baselineKM === null
  	        ? currentKM
  	        : Math.max(currentKM, baselineKM);
  	    const remainingKM = nextKM !== null && calculationKM !== null ? nextKM - calculationKM : null;
  	    const remainingDays = nextDate ? preventiveDateDiffDays(nextDate) : null;
  	    const counterOverdue = usesKM && remainingKM !== null && remainingKM <= 0;
  	    const timeOverdue = usesTime && remainingDays !== null && remainingDays <= 0;
  	    const counterSoon = usesKM && remainingKM !== null && plan.WarningKM > 0 && remainingKM <= plan.WarningKM;
  	    const timeSoon = usesTime && remainingDays !== null && plan.WarningDays > 0 && remainingDays <= plan.WarningDays;
  	    const configured = usesKM || usesTime;
  	    const missingBaseline = (usesKM && baselineKM === null) || (usesTime && !baselineDate);
  	    let status = "On Track";
  	    let statusClass = "on-track";
  	    let rank = 4;

  	    if (!plan.Active) {
  	      status = "Paused";
  	      statusClass = "paused";
  	      rank = 6;
  	    } else if (openJob) {
  	      status = servicePhaseLabel(openJob.Status);
  	      statusClass = "scheduled";
  	      rank = 1;
  	    } else if (!configured || missingBaseline) {
  	      status = "Unconfigured";
  	      statusClass = "paused";
  	      rank = 5;
  	    } else if (counterOverdue || timeOverdue) {
  	      status = "Overdue";
  	      statusClass = "overdue";
  	      rank = 0;
  	    } else if (counterSoon || timeSoon) {
  	      status = "Due Soon";
  	      statusClass = "due-soon";
  	      rank = 2;
  	    }

  	    const counterProgress = usesKM && baselineKM !== null && calculationKM !== null && plan.IntervalKM > 0
  	      ? Math.max(0, Math.min(1, (calculationKM - baselineKM) / plan.IntervalKM)) : 0;
  	    const baselineDateObject = fifAlertDate(baselineDate);
  	    const today = new Date();
  	    today.setHours(0, 0, 0, 0);
  	    const timeElapsed = baselineDateObject ? Math.max(0, Math.floor((today.getTime() - baselineDateObject.getTime()) / 86400000)) : 0;
  	    const timeProgress = usesTime && plan.IntervalDays > 0 ? Math.max(0, Math.min(1, timeElapsed / plan.IntervalDays)) : 0;
  	    const progress = plan.TriggerMode === "First Due" ? Math.max(counterProgress, timeProgress) : usesKM ? counterProgress : timeProgress;

  	    return {
  	      plan: plan,
  	      latestCompleted: latestCompleted,
  	      openJob: openJob,
  	      currentKM: currentKM,
  	      calculationKM: calculationKM,
  	      baselineKM: baselineKM,
  	      baselineDate: baselineDate,
  	      nextKM: nextKM,
  	      nextDate: nextDate,
  	      remainingKM: remainingKM,
  	      remainingDays: remainingDays,
  	      status: status,
  	      statusClass: statusClass,
  	      rank: rank,
  	      progress: Math.round(progress * 100),
  	      due: !openJob && plan.Active && (counterOverdue || timeOverdue),
  	      dueSoon: !openJob && plan.Active && !counterOverdue && !timeOverdue && (counterSoon || timeSoon)
  	    };
  	  }

  	  function preventiveTriggerLabel(plan) {
  	    if (plan.TriggerMode === "Kilometers Only") return "Kilometers";
  	    if (plan.TriggerMode === "Time Only") return "Time";
  	    return "First Due";
  	  }

  	  function preventiveDueCounterLabel(status) {
  	    if (status.nextKM === null) return "Not used";
  	    if (status.remainingKM === null) return formatNumber(status.nextKM, 0) + " km";
  	    if (status.remainingKM <= 0) return formatNumber(Math.abs(status.remainingKM), 0) + " km overdue";
  	    return formatNumber(status.nextKM, 0) + " km";
  	  }

  	  function preventiveDueDateLabel(status) {
  	    if (!status.nextDate) return "Not used";
  	    if (status.remainingDays === null) return serviceFormatDate(status.nextDate);
  	    if (status.remainingDays < 0) return Math.abs(status.remainingDays) + " days overdue";
  	    if (status.remainingDays === 0) return "Today";
  	    return serviceFormatDate(status.nextDate);
  	  }

  	  function preventivePlanCardHtml(status) {
  	    const plan = status.plan;
  	    const provider = clean(plan.ProviderName) || "No preferred provider";
  	    const canManage = CAN_MANAGE_MAINTENANCE;
  	    return `<article class="fifpm-card status-${escapeAttr(status.statusClass)}">
  	      <div class="fifpm-card-top"><span>${escapeHtml(preventiveTriggerLabel(plan))}</span><b class="fifpm-status">${escapeHtml(status.status)}</b></div>
  	      <h5>${escapeHtml(plan.Name || "Unnamed Plan")}</h5>
  	      <p class="fifpm-scope">${escapeHtml(plan.Scope || "Preventive maintenance")}</p>
  	      <div class="fifpm-due-grid">
  	        <div><span>Next Kilometer</span><strong>${escapeHtml(preventiveDueCounterLabel(status))}</strong></div>
  	        <div><span>Next Date</span><strong>${escapeHtml(preventiveDueDateLabel(status))}</strong></div>
  	      </div>
  	      <div class="fifpm-progress"><i style="width:${Math.max(0, Math.min(100, status.progress))}%"></i></div>
  	      <div class="fifpm-provider">${escapeHtml(provider)}</div>
  	      <div class="fifpm-actions">
  	        ${status.openJob ? `<button type="button" class="primary" data-pm-open-job="${escapeAttr(status.openJob.WorkOrderId)}">Open Job</button>` : canManage && plan.Active ? `<button type="button" class="primary" data-pm-create-job="${escapeAttr(plan.PlanId)}">Schedule</button>` : `<button type="button" disabled>Schedule</button>`}
  	        ${canManage ? `<button type="button" data-pm-edit="${escapeAttr(plan.PlanId)}">Edit</button><button type="button" data-pm-toggle="${escapeAttr(plan.PlanId)}">${plan.Active ? "Pause" : "Activate"}</button>` : `<button type="button" disabled>Edit</button><button type="button" disabled>${plan.Active ? "Active" : "Paused"}</button>`}
  	      </div>
  	    </article>`;
  	  }

  	  function renderPreventiveMaintenancePortal(company, vehicle) {
  	    injectPreventiveMaintenanceStyles();
  	    const statuses = preventiveMaintenancePlans(vehicle).map(function (plan) {
  	      return preventivePlanStatus(vehicle, plan);
  	    }).sort(function (left, right) {
  	      return left.rank - right.rank || naturalCompare(left.nextDate || "9999", right.nextDate || "9999") || numberOr(left.nextKM, Number.MAX_SAFE_INTEGER) - numberOr(right.nextKM, Number.MAX_SAFE_INTEGER);
  	    });
  	    const active = statuses.filter(function (status) { return status.plan.Active; }).length;
  	    const due = statuses.filter(function (status) { return status.due; }).length;
  	    const soon = statuses.filter(function (status) { return status.dueSoon; }).length;
  	    const openJobs = statuses.filter(function (status) { return !!status.openJob; }).length;
  	    return `<section class="fifpm-root">
  	      <header class="fifpm-head"><h4>Preventive Maintenance</h4>${CAN_MANAGE_MAINTENANCE ? `<button type="button" class="fifvm-btn primary" data-pm-new>+ Add Plan</button>` : ""}</header>
  	      <section class="fifpm-summary"><article><span>Active Plans</span><strong>${active}</strong></article><article class="due"><span>Due Now</span><strong>${due}</strong></article><article class="soon"><span>Due Soon</span><strong>${soon}</strong></article><article><span>Open Jobs</span><strong>${openJobs}</strong></article></section>
  	      ${statuses.length ? `<div class="fifpm-grid">${statuses.map(preventivePlanCardHtml).join("")}</div>` : `<div class="fifpm-empty"><div><strong>No preventive plans</strong>${CAN_MANAGE_MAINTENANCE ? `<button type="button" class="fifvm-btn primary" data-pm-new>Create First Plan</button>` : ""}</div></div>`}
  	    </section>`;
  	  }

  	  async function savePreventiveMaintenancePlans(company, vehicle, plans, message, operationMessage) {
  	    const updated = cloneData(vehicle);
  	    if (!updated.Data || typeof updated.Data !== "object" || Array.isArray(updated.Data)) updated.Data = {};
  	    setByPath(updated, ["Data", "Maintenance", "PreventivePlans"], plans.map(normalizePreventivePlan));
  	    const operation = fifBeginSaveOperation(operationMessage || "Saving preventive maintenance plan…");
  	    try {
  	      await saveVehicleToBackendless(company, updated);
  	      fifCompleteSaveOperation(operation, message || "Preventive maintenance plan saved.");
  	      state.actionableAlertCache = {};
  	      render();
  	      return true;
  	    } catch (error) {
  	      fifFailSaveOperation(operation, error);
  	      await fifAlert(error && error.message ? error.message : "The preventive maintenance plan could not be saved.", { title: "Plan Save Failed", type: "danger" });
  	      return false;
  	    }
  	  }

  	  function preventivePlanById(vehicle, planId) {
  	    planId = clean(planId);
  	    return preventiveMaintenancePlans(vehicle).find(function (plan) { return plan.PlanId === planId; }) || null;
  	  }

  	  async function deletePreventivePlan(company, vehicle, planId) {
  	    if (!CAN_MANAGE_MAINTENANCE || !vehicle) return false;
  	    const plan = preventivePlanById(vehicle, planId);
  	    if (!plan) return false;

  	    const linkedRecords = preventivePlanRecords(vehicle, plan.PlanId);
  	    const openJobs = linkedRecords.filter(function (record) {
  	      return SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(record.Status)) !== -1;
  	    });

  	    if (openJobs.length) {
  	      await fifAlert("This preventive plan still has an open job card. Complete or close that job before deleting the plan.", {
  	        title: "Plan Has Open Work",
  	        type: "warning",
  	        confirmText: "Close",
  	        details: [{
  	          label: "Plan",
  	          value: plan.Name || plan.PlanId
  	        }, {
  	          label: "Open job",
  	          value: openJobs[0].WorkOrderId + " · " + servicePhaseLabel(openJobs[0].Status)
  	        }]
  	      });
  	      return false;
  	    }

  	    const completedCount = linkedRecords.filter(function (record) {
  	      return serviceCanonicalStatus(record.Status) === "Completed";
  	    }).length;
  	    const approved = await fifConfirm("Delete this preventive maintenance plan? Completed maintenance records will remain in history.", {
  	      title: "Delete Preventive Plan",
  	      type: "danger",
  	      confirmText: "Delete Plan",
  	      cancelText: "Cancel",
  	      details: [{
  	        label: "Plan",
  	        value: plan.Name || plan.PlanId
  	      }, {
  	        label: "Completed records retained",
  	        value: String(completedCount)
  	      }]
  	    });

  	    if (!approved) return false;

  	    const plans = preventiveMaintenancePlans(vehicle).filter(function (row) {
  	      return row.PlanId !== plan.PlanId;
  	    });
  	    closeServicePortalModal();
  	    return savePreventiveMaintenancePlans(
  	      company,
  	      vehicle,
  	      plans,
  	      "Preventive plan deleted.",
  	      "Deleting preventive maintenance plan…"
  	    );
  	  }

  	  function openPreventivePlanModal(company, vehicle, planId) {
  	    if (!CAN_MANAGE_MAINTENANCE || !vehicle) return;
  	    const existing = preventivePlanById(vehicle, planId);
  	    const currentKM = numberOr(tractorMileage(vehicle), 0);
  	    const plan = existing || normalizePreventivePlan({
  	      Name: "",
  	      Scope: "",
  	      TriggerMode: "First Due",
  	      IntervalKM: 10000,
  	      IntervalDays: 180,
  	      WarningKM: 1000,
  	      WarningDays: 14,
  	      BaselineKM: currentKM,
  	      BaselineDate: new Date().toISOString().slice(0, 10),
  	      Priority: "Normal",
  	      Active: true
  	    });
  	    const providers = [{ value: "", label: "No preferred provider" }].concat(serviceProviders(company).filter(function (provider) {
  	      return lower(provider.Status) === "active";
  	    }).map(function (provider) {
  	      return { value: provider.ProviderId, label: serviceProviderLabel(provider) };
  	    }));
  	    const body = `<form data-pm-plan-form class="fifsp-form fifpm-modal-form">
  	      <div class="fifpm-form-grid">
  	        ${serviceField("Name", "Plan Name", plan.Name, "text", { required: true, wide: true })}
  	        ${serviceField("TriggerMode", "Trigger", plan.TriggerMode, "select", { values: ["First Due", "Kilometers Only", "Time Only"], required: true })}
  	        ${serviceField("Priority", "Priority", plan.Priority, "select", { values: ["Low", "Normal", "High", "Critical"], required: true })}
  	        <div data-pm-km-fields>${serviceField("IntervalKM", "Interval (km)", plan.IntervalKM, "number", { min: 0 })}</div>
  	        <div data-pm-time-fields>${serviceField("IntervalDays", "Interval (Days)", plan.IntervalDays, "number", { min: 0 })}</div>
  	        <div data-pm-km-fields>${serviceField("WarningKM", "Notify Before (km)", plan.WarningKM, "number", { min: 0 })}</div>
  	        <div data-pm-time-fields>${serviceField("WarningDays", "Notify Before (Days)", plan.WarningDays, "number", { min: 0 })}</div>
  	        <div data-pm-km-fields>${serviceField("BaselineKM", "Start Reading (km)", plan.BaselineKM, "number", { min: 0 })}</div>
  	        <div data-pm-time-fields>${serviceField("BaselineDate", "Start Date", plan.BaselineDate, "date", {})}</div>
  	        ${serviceField("ProviderId", "Preferred Provider", plan.ProviderId, "select", { values: providers })}
  	        ${serviceField("Active", "Plan Active", plan.Active, "checkbox", {})}
  	        ${serviceField("Scope", "Work Scope", plan.Scope, "textarea", { wide: true })}
  	      </div>
  	    </form>`;
  	    const planFooter = `${existing ? `<button type="button" class="fifpm-delete-plan" data-pm-plan-delete>Delete Plan</button>` : ""}<button type="button" data-sp-modal-close>Cancel</button><button type="button" class="primary" data-pm-plan-save>Save Plan</button>`;
  	    const overlay = serviceModalShell(existing ? "Edit Preventive Plan" : "New Preventive Plan", vehicleTitleValue(vehicle), body, planFooter, false);
  	    overlay.querySelector(".fifsp-modal")?.classList.add("fifwrk-modal");
  	    const form = overlay.querySelector("[data-pm-plan-form]");
  	    const syncTrigger = function () {
  	      const mode = clean(form && form.elements.TriggerMode && form.elements.TriggerMode.value) || "First Due";
  	      overlay.querySelectorAll("[data-pm-km-fields]").forEach(function (node) { node.hidden = mode === "Time Only"; });
  	      overlay.querySelectorAll("[data-pm-time-fields]").forEach(function (node) { node.hidden = mode === "Kilometers Only"; });
  	    };
  	    form && form.elements.TriggerMode && form.elements.TriggerMode.addEventListener("change", syncTrigger);
  	    syncTrigger();
  	    overlay.querySelector("[data-pm-plan-delete]")?.addEventListener("click", function () {
  	      deletePreventivePlan(company, vehicle, plan.PlanId);
  	    });
  	    overlay.querySelector("[data-pm-plan-save]")?.addEventListener("click", async function () {
  	      if (!form || !form.reportValidity()) return;
  	      const values = new FormData(form);
  	      const triggerMode = preventivePlanTriggerMode(values.get("TriggerMode"));
  	      const intervalKM = numberOr(values.get("IntervalKM"), 0);
  	      const intervalDays = numberOr(values.get("IntervalDays"), 0);
  	      const warningKM = numberOr(values.get("WarningKM"), 0);
  	      const warningDays = numberOr(values.get("WarningDays"), 0);
  	      const baselineKM = values.get("BaselineKM") === "" ? null : numberOr(values.get("BaselineKM"), null);
  	      const baselineDate = maintenanceDateInput(values.get("BaselineDate") || "");
  	      const errors = [];
  	      if (!clean(values.get("Name"))) errors.push("Plan Name is required.");
  	      if (triggerMode !== "Time Only" && intervalKM <= 0) errors.push("A kilometer interval greater than zero is required.");
  	      if (triggerMode !== "Kilometers Only" && intervalDays <= 0) errors.push("A time interval greater than zero is required.");
  	      if (triggerMode !== "Time Only" && baselineKM === null) errors.push("Start Reading is required.");
  	      if (triggerMode !== "Kilometers Only" && !baselineDate) errors.push("Start Date is required.");
  	      if (warningKM < 0 || warningDays < 0) errors.push("Notification periods cannot be negative.");
  	      if (triggerMode !== "Time Only" && warningKM >= intervalKM && intervalKM > 0) errors.push("The kilometer notification period must be less than the interval.");
  	      if (triggerMode !== "Kilometers Only" && warningDays >= intervalDays && intervalDays > 0) errors.push("The time notification period must be less than the interval.");
  	      if (errors.length) {
  	        await fifAlert(errors.join("\n"), { title: "Plan Incomplete", type: "warning" });
  	        return;
  	      }
  	      const provider = serviceProviderById(company, values.get("ProviderId"));
  	      const savedPlan = normalizePreventivePlan(Object.assign({}, plan, {
  	        Name: clean(values.get("Name")),
  	        Scope: clean(values.get("Scope")),
  	        TriggerMode: triggerMode,
  	        IntervalKM: triggerMode === "Time Only" ? 0 : intervalKM,
  	        IntervalDays: triggerMode === "Kilometers Only" ? 0 : intervalDays,
  	        WarningKM: triggerMode === "Time Only" ? 0 : warningKM,
  	        WarningDays: triggerMode === "Kilometers Only" ? 0 : warningDays,
  	        BaselineKM: triggerMode === "Time Only" ? null : baselineKM,
  	        BaselineDate: triggerMode === "Kilometers Only" ? "" : baselineDate,
  	        Priority: clean(values.get("Priority")) || "Normal",
  	        ProviderId: provider ? provider.ProviderId : "",
  	        ProviderName: provider ? serviceProviderLabel(provider) : "",
  	        Active: values.has("Active"),
  	        UpdatedAt: new Date().toISOString(),
  	        UpdatedBy: userDisplayName()
  	      }));
  	      const plans = preventiveMaintenancePlans(vehicle);
  	      const index = plans.findIndex(function (row) { return row.PlanId === savedPlan.PlanId; });
  	      if (index === -1) plans.push(savedPlan); else plans[index] = savedPlan;
  	      closeServicePortalModal();
  	      await savePreventiveMaintenancePlans(company, vehicle, plans, "Preventive plan saved.");
  	    });
  	  }

  	  async function togglePreventivePlan(company, vehicle, planId) {
  	    if (!CAN_MANAGE_MAINTENANCE) return;
  	    const plans = preventiveMaintenancePlans(vehicle);
  	    const index = plans.findIndex(function (plan) { return plan.PlanId === clean(planId); });
  	    if (index === -1) return;
  	    plans[index].Active = !plans[index].Active;
  	    plans[index].UpdatedAt = new Date().toISOString();
  	    plans[index].UpdatedBy = userDisplayName();
  	    await savePreventiveMaintenancePlans(company, vehicle, plans, plans[index].Active ? "Preventive plan activated." : "Preventive plan paused.");
  	  }


  	  function fifProviderNotificationHistory(vehicle) {
  	    const raw = descriptorValue(
  	      getDeep(vehicle, ["Data", "Service", "Notifications", "ProviderEmailHistory"], [])
  	    );
  	    return Array.isArray(raw)
  	      ? raw.filter(function (entry) {
  	          return entry && typeof entry === "object" && !Array.isArray(entry);
  	        }).map(cloneData)
  	      : [];
  	  }

  	  function fifResolveProviderByIdOrName(company, value) {
  	    const target = clean(value);
  	    if (!target) return null;

  	    const byId = serviceProviderById(company, target);
  	    if (byId) return byId;

  	    const key = lower(target);
  	    return serviceProviders(company).find(function (provider) {
  	      return lower(serviceProviderLabel(provider)) === key ||
  	        lower(provider.Name) === key ||
  	        lower(provider.TradingName) === key;
  	    }) || null;
  	  }

  	  function fifProviderSnapshotFromVehicle(vehicle, requested) {
  	    const setup = serviceSetupSnapshot(vehicle);
  	    const requestedKey = lower(clean(firstValue([
  	      requested,
  	      setup.NotificationProviderId,
  	      setup.NotificationProviderName
  	    ], "")));
  	    const history = fifProviderNotificationHistory(vehicle);

  	    let providerId = clean(setup.NotificationProviderId);
  	    let providerName = clean(setup.NotificationProviderName);
  	    let providerEmail = "";

  	    for (let index = history.length - 1; index >= 0; index -= 1) {
  	      const entry = history[index] || {};
  	      const entryId = clean(entry.ProviderId);
  	      const entryName = clean(entry.ProviderName);
  	      const entryEmail = clean(entry.ProviderEmail);
  	      const matches =
  	        !requestedKey ||
  	        lower(entryId) === requestedKey ||
  	        lower(entryName) === requestedKey ||
  	        (providerId && entryId === providerId) ||
  	        (providerName && lower(entryName) === lower(providerName));

  	      if (!matches) continue;
  	      if (!providerId && entryId) providerId = entryId;
  	      if (!providerName && entryName) providerName = entryName;
  	      if (!providerEmail && entryEmail) providerEmail = entryEmail;
  	      if (providerEmail) break;
  	    }

  	    if (!providerEmail) return null;

  	    return normalizeServiceProvider({
  	      ProviderId: providerId || clean(requested) || "SP-HISTORY",
  	      Name: providerName || clean(requested) || "Service Provider",
  	      Status: "Active",
  	      Contact: { Email: providerEmail }
  	    });
  	  }

  	  function fifResolveAutomaticServiceProvider(company, vehicle, requested, health) {
  	    let provider = fifResolveProviderByIdOrName(company, requested);
  	    if (provider && lower(provider.Status) === "active") return provider;

  	    const setup = serviceSetupSnapshot(vehicle);
  	    provider = fifResolveProviderByIdOrName(company, setup.NotificationProviderId);
  	    if (provider && lower(provider.Status) === "active") return provider;

  	    const openOrders = health && Array.isArray(health.openOrders) ? health.openOrders : [];
  	    for (let i = 0; i < openOrders.length; i += 1) {
  	      provider = fifResolveProviderByIdOrName(
  	        company,
  	        openOrders[i].ProviderId || openOrders[i].ProviderName
  	      );
  	      if (provider && lower(provider.Status) === "active") return provider;
  	    }

  	    const lastUsed = clean(descriptorValue(firstValue([
  	      getDeep(vehicle, ["Data", "Service", "Current", "ServiceCentreLastUsed"], ""),
  	      getDeep(vehicle, ["Data", "Service", "History", "Service_Centre_Last_Used"], "")
  	    ], "")));
  	    provider = fifResolveProviderByIdOrName(company, lastUsed);
  	    if (provider && lower(provider.Status) === "active") return provider;

  	    const active = serviceProviders(company).filter(function (candidate) {
  	      return lower(candidate.Status) === "active";
  	    });
  	    const preferred = active.filter(function (candidate) {
  	      return candidate.Preferred === true;
  	    });

  	    if (preferred.length === 1) return preferred[0];
  	    if (active.length === 1) return active[0];

  	    return fifProviderSnapshotFromVehicle(vehicle, requested);
  	  }

  	  function fifNotificationCompanyIdentityValues(company) {
  	    if (!company || typeof company !== "object") return [];
  	    return [
  	      company.objectId,
  	      company.CompanyId,
  	      company.CompanyID,
  	      company.ID,
  	      company.Name,
  	      company.CompanyName,
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "CompanyId"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "Company_Name"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "TradingName"], "")),
  	      descriptorValue(getDeep(company, ["Data", "Profile", "Company_Name"], "")),
  	      descriptorValue(getDeep(company, ["Data", "Profile", "Trading_As"], ""))
  	    ].map(function (value) {
  	      return lower(clean(value));
  	    }).filter(Boolean);
  	  }

  	  function fifNotificationCompanyContainsVehicle(company, vehicle) {
  	    if (!company || !vehicle) return false;
  	    const vehicleObjectId = objectIdOf(vehicle);
  	    const vehicleKeys = uniqueStrings([
  	      vehicleObjectId,
  	      clean(vehicle && vehicle.ID),
  	      clean(vehicle && vehicle.FID),
  	      vehicleRegistrationValue(vehicle),
  	      vehicleTitleValue(vehicle)
  	    ].filter(Boolean)).map(lower);

  	    return tractors(company).some(function (candidate) {
  	      if (!candidate) return false;
  	      if (vehicleObjectId && objectIdOf(candidate) === vehicleObjectId) return true;
  	      const candidateKeys = uniqueStrings([
  	        objectIdOf(candidate),
  	        clean(candidate.ID),
  	        clean(candidate.FID),
  	        vehicleRegistrationValue(candidate),
  	        vehicleTitleValue(candidate)
  	      ].filter(Boolean)).map(lower);
  	      return candidateKeys.some(function (key) {
  	        return vehicleKeys.indexOf(key) !== -1;
  	      });
  	    });
  	  }

  	  function fifResolveVehicleNotificationCompany(company, vehicle) {
  	    const userCompanies = arr(getDeep(APP_DATA, ["User", "Companies"], []));
  	    const source = userCompanies.length ? userCompanies : companies();

  	    const containing = source.find(function (candidate) {
  	      return fifNotificationCompanyContainsVehicle(candidate, vehicle);
  	    });
  	    if (containing) return containing;

  	    const suppliedKeys = fifNotificationCompanyIdentityValues(company);
  	    if (suppliedKeys.length) {
  	      const matched = source.find(function (candidate) {
  	        const keys = fifNotificationCompanyIdentityValues(candidate);
  	        return keys.some(function (key) {
  	          return suppliedKeys.indexOf(key) !== -1;
  	        });
  	      });
  	      if (matched) return matched;
  	    }

  	    return company || (source.length === 1 ? source[0] : null);
  	  }

  	  function fifServiceNotificationCompanyEmails(company) {
  	    if (!company || typeof company !== "object") return [];

  	    return uniqueStrings([
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "PrimaryEmail"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Contacts", "Primary", "Email"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "Email"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Billing", "Account", "InvoiceEmail"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Billing", "Account", "StatementEmail"], "")),
  	      descriptorValue(getDeep(company, ["Data", "Profile", "PrimaryEmail"], "")),
  	      descriptorValue(getDeep(company, ["Data", "Contacts", "Primary", "Email"], "")),
  	      descriptorValue(company.PrimaryEmail),
  	      descriptorValue(company.CompanyEmail),
  	      descriptorValue(company.Email),
  	      descriptorValue(company.email)
  	    ].reduce(function (rows, value) {
  	      String(value == null ? "" : value)
  	        .split(/[;,\n]+/)
  	        .map(clean)
  	        .filter(function (email) {
  	          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  	        })
  	        .forEach(function (email) { rows.push(email); });
  	      return rows;
  	    }, []));
  	  }

  	  function fifNotificationVehicleIdentity(vehicle) {
  	    function value(key, fallbacks) {
  	      return clean(firstValue([
  	        fifVehicleIdentityValue(vehicle, key, "")
  	      ].concat(fallbacks || []), "")) || "Not captured";
  	    }

  	    return {
  	      make: value("Make", [vehicle && vehicle.Make]),
  	      model: value("Model", [vehicle && vehicle.Model]),
  	      year: value("Year", [vehicle && vehicle.Year]),
  	      vin: value("VIN", [vehicle && vehicle.VIN]),
  	      engineNumber: value("EngineNumber", [
  	        getDeep(vehicle, ["Data", "Vehicle", "EngineNumber"], ""),
  	        getDeep(vehicle, ["Data", "Vehicle", "Engine_Number"], ""),
  	        vehicle && vehicle.EngineNumber,
  	        vehicle && vehicle.Engine_Number
  	      ])
  	    };
  	  }

  	  function fifNotificationEntryMatchesCandidate(entry, candidate) {
  	    if (!entry || !candidate) return false;
  	    const key = clean(entry.Key);
  	    if (!key) return false;
  	    if (key === candidate.key) return true;
  	    return !!(
  	      candidate.matchPrefix &&
  	      candidate.matchSuffix &&
  	      key.indexOf(candidate.matchPrefix) === 0 &&
  	      key.slice(-candidate.matchSuffix.length) === candidate.matchSuffix
  	    );
  	  }

  	  function fifNotificationHistoryRecipientState(history, candidate) {
  	    let providerSent = false;
  	    let companySent = false;

  	    (Array.isArray(history) ? history : []).forEach(function (entry) {
  	      if (!fifNotificationEntryMatchesCandidate(entry, candidate)) return;

  	      if (
  	        entry.ProviderEmailSent === true ||
  	        clean(entry.ProviderEmail)
  	      ) providerSent = true;

  	      if (
  	        entry.CompanyEmailSent === true ||
  	        clean(entry.CompanyEmail) ||
  	        clean(entry.CompanyEmails)
  	      ) companySent = true;
  	    });

  	    return { providerSent: providerSent, companySent: companySent };
  	  }

  	  function fifServiceProviderNotificationCandidate(company, vehicle) {
  	    const setup = serviceSetupSnapshot(vehicle);
  	    if (!setup.NotifyServiceProvider && !setup.NotifyCompany) return null;

  	    const health = serviceHealthForVehicle(company, vehicle);
  	    if (health.dataConflict || (health.nextCounter === null && !health.nextDate)) return null;

  	    const overdue =
  	      (health.remainingCounter !== null && health.remainingCounter <= 0) ||
  	      (health.remainingDays !== null && health.remainingDays < 0);

  	    const dueSoon =
  	      (health.remainingCounter !== null &&
  	        health.warningCounter > 0 &&
  	        health.remainingCounter <= health.warningCounter) ||
  	      (health.remainingDays !== null &&
  	        health.warningDays > 0 &&
  	        health.remainingDays <= health.warningDays);

  	    if (!overdue && !dueSoon) return null;

  	    const provider = fifResolveAutomaticServiceProvider(company, vehicle, "", health);
  	    const stage = overdue ? "OVERDUE" : "DUE_SOON";
  	    const remaining = [];
  	    const due = [];

  	    if (health.remainingCounter !== null) {
  	      remaining.push(
  	        health.remainingCounter <= 0
  	          ? formatNumber(Math.abs(health.remainingCounter), 0) + " " + health.unit + " overdue"
  	          : formatNumber(health.remainingCounter, 0) + " " + health.unit + " remaining"
  	      );
  	    }
  	    if (health.remainingDays !== null) {
  	      remaining.push(
  	        health.remainingDays < 0
  	          ? Math.abs(health.remainingDays) + " day" + (Math.abs(health.remainingDays) === 1 ? "" : "s") + " overdue"
  	          : health.remainingDays === 0
  	            ? "due today"
  	            : health.remainingDays + " day" + (health.remainingDays === 1 ? "" : "s") + " remaining"
  	      );
  	    }
  	    if (health.nextCounter !== null) due.push(formatNumber(health.nextCounter, 0) + " " + health.unit);
  	    if (health.nextDate) due.push(serviceFormatDate(health.nextDate));

  	    const cycle = [
  	      health.nextCounter === null ? "" : String(Math.round(health.nextCounter * 100) / 100),
  	      clean(health.nextDate)
  	    ].join("|");
  	    const providerKey = clean(provider && provider.ProviderId) || clean(setup.NotificationProviderId) || "NO_PROVIDER";

  	    return {
  	      key: ["SERVICE", objectIdOf(vehicle), providerKey, stage, cycle].join("|"),
  	      matchPrefix: ["SERVICE", objectIdOf(vehicle), ""].join("|"),
  	      matchSuffix: ["", stage, cycle].join("|"),
  	      kind: "Service",
  	      stage: stage,
  	      provider: provider,
  	      title: overdue ? "Service Overdue" : "Service Due Soon",
  	      subject: "Fleet In Form - " + (overdue ? "Service Overdue" : "Service Due Soon") + " - " +
  	        (vehicleRegistrationValue(vehicle) || vehicleTitleValue(vehicle)),
  	      summary: remaining.join(" · ") || (overdue ? "The scheduled service is overdue." : "The scheduled service is approaching."),
  	      duePosition: due.join(" · ") || "Configured service interval",
  	      scope: "Scheduled vehicle service",
  	      reference: ""
  	    };
  	  }

  	  function fifMaintenanceProviderNotificationCandidates(company, vehicle) {
  	    const setup = serviceSetupSnapshot(vehicle);
  	    if (!setup.NotifyServiceProvider && !setup.NotifyCompany) return [];

  	    return preventiveMaintenancePlans(vehicle).map(function (plan) {
  	      if (!plan.Active) return null;

  	      const status = preventivePlanStatus(vehicle, plan);
  	      if (status.openJob || (!status.due && !status.dueSoon)) return null;

  	      const provider = fifResolveAutomaticServiceProvider(
  	        company,
  	        vehicle,
  	        plan.ProviderId || plan.ProviderName,
  	        null
  	      );

  	      const stage = status.due ? "OVERDUE" : "DUE_SOON";
  	      const remaining = [];
  	      const due = [];

  	      if (status.remainingKM !== null) {
  	        remaining.push(
  	          status.remainingKM <= 0
  	            ? formatNumber(Math.abs(status.remainingKM), 0) + " km overdue"
  	            : formatNumber(status.remainingKM, 0) + " km remaining"
  	        );
  	      }
  	      if (status.remainingDays !== null) {
  	        remaining.push(
  	          status.remainingDays <= 0
  	            ? Math.abs(status.remainingDays) + " day" + (Math.abs(status.remainingDays) === 1 ? "" : "s") + " overdue"
  	            : status.remainingDays + " day" + (status.remainingDays === 1 ? "" : "s") + " remaining"
  	        );
  	      }
  	      if (status.nextKM !== null) due.push(formatNumber(status.nextKM, 0) + " km");
  	      if (status.nextDate) due.push(serviceFormatDate(status.nextDate));

  	      const providerKey = clean(provider && provider.ProviderId) || clean(plan.ProviderId) || clean(setup.NotificationProviderId) || "NO_PROVIDER";
  	      const nextKM = status.nextKM === null ? "" : String(Math.round(status.nextKM * 100) / 100);
  	      const nextDate = clean(status.nextDate);

  	      return {
  	        key: [
  	          "MAINTENANCE",
  	          objectIdOf(vehicle),
  	          plan.PlanId,
  	          providerKey,
  	          stage,
  	          nextKM,
  	          nextDate
  	        ].join("|"),
  	        matchPrefix: ["MAINTENANCE", objectIdOf(vehicle), plan.PlanId, ""].join("|"),
  	        matchSuffix: ["", stage, nextKM, nextDate].join("|"),
  	        kind: "Maintenance",
  	        stage: stage,
  	        provider: provider,
  	        title: status.due ? "Preventive Maintenance Overdue" : "Preventive Maintenance Due Soon",
  	        subject: "Fleet In Form - " +
  	          (status.due ? "Maintenance Overdue" : "Maintenance Due Soon") + " - " +
  	          (vehicleRegistrationValue(vehicle) || vehicleTitleValue(vehicle)),
  	        summary: remaining.join(" · ") || status.status,
  	        duePosition: due.join(" · ") || "Preventive maintenance interval",
  	        scope: clean(plan.Scope) || clean(plan.Name) || "Preventive maintenance",
  	        reference: plan.PlanId
  	      };
  	    }).filter(Boolean);
  	  }

  	  function fifAutomaticProviderNotificationCandidates(company, vehicle) {
  	    if (!vehicle || assetIsTrailer(vehicle)) return [];
  	    const serviceCandidate = fifServiceProviderNotificationCandidate(company, vehicle);
  	    return (serviceCandidate ? [serviceCandidate] : [])
  	      .concat(fifMaintenanceProviderNotificationCandidates(company, vehicle));
  	  }

  	  function fifFuelTransactionNotificationConditions(company, vehicle) {
  	    const rows = [];

  	    try {
  	      const health = serviceHealthForVehicle(company, vehicle);

  	      if (!health.dataConflict && (health.nextCounter !== null || health.nextDate)) {
  	        const overdue =
  	          (health.remainingCounter !== null && health.remainingCounter <= 0) ||
  	          (health.remainingDays !== null && health.remainingDays < 0);

  	        const dueSoon =
  	          (health.remainingCounter !== null &&
  	            health.warningCounter > 0 &&
  	            health.remainingCounter <= health.warningCounter) ||
  	          (health.remainingDays !== null &&
  	            health.warningDays > 0 &&
  	            health.remainingDays <= health.warningDays);

  	        if (overdue || dueSoon) {
  	          rows.push({
  	            kind: "Service",
  	            stage: overdue ? "Overdue" : "Due Soon",
  	            label: overdue ? "Scheduled Service Overdue" : "Scheduled Service Due Soon"
  	          });
  	        }
  	      }
  	    } catch (_) {}

  	    try {
  	      preventiveMaintenancePlans(vehicle).forEach(function (plan) {
  	        if (!plan || !plan.Active) return;

  	        const status = preventivePlanStatus(vehicle, plan);
  	        if (status.openJob || (!status.due && !status.dueSoon)) return;

  	        rows.push({
  	          kind: "Maintenance",
  	          stage: status.due ? "Overdue" : "Due Soon",
  	          label:
  	            (clean(plan.Scope) || clean(plan.Name) || "Preventive Maintenance") +
  	            " · " +
  	            (status.due ? "Overdue" : "Due Soon")
  	        });
  	      });
  	    } catch (_) {}

  	    return rows;
  	  }

  	  function fifFuelTransactionProviderNotificationDetails(vehicle, result, conditions, candidates, companyEmails, setup) {
  	    const providers = uniqueStrings(
  	      (Array.isArray(candidates) ? candidates : []).map(function (candidate) {
  	        return candidate && candidate.provider ? serviceProviderLabel(candidate.provider) : "";
  	      }).filter(Boolean)
  	    );

  	    const providerEmails = uniqueStrings(
  	      (Array.isArray(candidates) ? candidates : []).map(function (candidate) {
  	        return clean(getDeep(candidate, ["provider", "Contact", "Email"], ""));
  	      }).filter(Boolean)
  	    );

  	    return [
  	      { label: "Vehicle", value: vehicleTitleValue(vehicle) },
  	      {
  	        label: "Fuel mileage",
  	        value:
  	          result && result.fuel && result.fuel.Mileage !== null && result.fuel.Mileage !== undefined
  	            ? formatNumber(result.fuel.Mileage, 0) + " km"
  	            : "Not recorded"
  	      },
  	      {
  	        label: "Notification condition",
  	        value: conditions.length
  	          ? conditions.map(function (item) { return item.label; }).join(" · ")
  	          : "No Service / Maintenance notification threshold reached"
  	      },
  	      {
  	        label: "Service Provider",
  	        value: setup && setup.NotifyServiceProvider
  	          ? (providers.length ? providers.join(", ") : "Not resolved")
  	          : "Not enabled"
  	      },
  	      {
  	        label: "Provider Email",
  	        value: setup && setup.NotifyServiceProvider
  	          ? (providerEmails.length ? providerEmails.join(", ") : "Not available")
  	          : "Not enabled"
  	      },
  	      {
  	        label: "Company Email",
  	        value: setup && setup.NotifyCompany
  	          ? (companyEmails.length ? companyEmails.join(", ") : "Not available")
  	          : "Not enabled"
  	      }
  	    ];
  	  }

  	  function fifProviderEmailBody(company, vehicle, candidate, fuel) {
  	    const providerName = candidate.provider ? serviceProviderLabel(candidate.provider) : "Not assigned";
  	    const companyLabel = companyName(company);
  	    const vehicleLabel = vehicleTitleValue(vehicle);
  	    const registration = vehicleRegistrationValue(vehicle) || "Not recorded";
  	    const identity = fifNotificationVehicleIdentity(vehicle);
  	    const fuelObjectId = clean(fuel && fuel.objectId);
  	    const fuelReading = fuel && fuel.Mileage !== null && fuel.Mileage !== undefined
  	      ? formatNumber(fuel.Mileage, 0) + " " + serviceSetupSnapshot(vehicle).CounterUnit
  	      : "";

  	    const textBody = [
  	      "Fleet In Form - " + candidate.title,
  	      "",
  	      "Service Provider: " + providerName,
  	      "Company: " + companyLabel,
  	      "Vehicle: " + vehicleLabel,
  	      "Registration: " + registration,
  	      "Make: " + identity.make,
  	      "Model: " + identity.model,
  	      "Year: " + identity.year,
  	      "VIN: " + identity.vin,
  	      "Engine Number: " + identity.engineNumber,
  	      "Type: " + candidate.kind,
  	      "Status: " + candidate.title,
  	      "Current Position: " + candidate.summary,
  	      "Due Position: " + candidate.duePosition,
  	      "Work Scope: " + candidate.scope,
  	      candidate.reference ? "Reference: " + candidate.reference : "",
  	      fuelObjectId ? "Fuel Transaction: " + fuelObjectId : "",
  	      fuelReading ? "Vehicle Reading: " + fuelReading : "",
  	      "",
  	      "This notification was generated automatically by Fleet In Form for the enabled Service notification recipients."
  	    ].filter(Boolean).join("\n");

  	    const htmlBody =
  	      '<div style="font-family:Arial,sans-serif;color:#202420;line-height:1.45">' +
  	      '<h2 style="margin:0 0 4px;color:#a34f29">Fleet In Form</h2>' +
  	      '<h3 style="margin:0 0 18px">' + escapeHtml(candidate.title) + '</h3>' +
  	      '<table style="border-collapse:collapse;width:100%;max-width:720px">' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Service Provider</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(providerName) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Company</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(companyLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Vehicle</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(vehicleLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Registration</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(registration) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Make</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.make) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Model</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.model) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Year</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.year) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">VIN</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.vin) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Engine Number</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.engineNumber) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Notification</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.kind + " · " + candidate.title) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Position</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.summary) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Due Position</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.duePosition) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Work Scope</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.scope) + '</td></tr>' +
  	      (candidate.reference
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Reference</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.reference) + '</td></tr>'
  	        : "") +
  	      (fuelObjectId
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Fuel Transaction</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(fuelObjectId) + '</td></tr>'
  	        : "") +
  	      (fuelReading
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Vehicle Reading</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(fuelReading) + '</td></tr>'
  	        : "") +
  	      '</table>' +
  	      '<p style="margin-top:18px;color:#657069;font-size:12px">Generated automatically for the enabled Service notification recipients.</p>' +
  	      '</div>';

  	    return { text: textBody, html: htmlBody };
  	  }

  	  async function fifSendAutomaticProviderEmail(rawApi, company, vehicle, candidate, fuel) {
  	    if (!rawApi || !rawApi.Messaging || typeof rawApi.Messaging.sendEmail !== "function") {
  	      throw new Error("Backendless email delivery is unavailable.");
  	    }

  	    const recipient = clean(getDeep(candidate, ["provider", "Contact", "Email"], ""));
  	    if (!recipient) throw new Error("The selected Service Provider has no email address.");

  	    const body = fifProviderEmailBody(company, vehicle, candidate, fuel);
  	    const bodyParts = typeof rawApi.Bodyparts === "function" ? new rawApi.Bodyparts() : {};
  	    bodyParts.textmessage = body.text;
  	    bodyParts.htmlmessage = body.html;

  	    await rawApi.Messaging.sendEmail(candidate.subject, bodyParts, [recipient], []);
  	  }

  	  async function fifSendCompanyServiceEmail(rawApi, company, vehicle, candidate, fuel, recipients) {
  	    if (!rawApi || !rawApi.Messaging || typeof rawApi.Messaging.sendEmail !== "function") {
  	      throw new Error("Backendless email delivery is unavailable.");
  	    }

  	    const emails = uniqueStrings(Array.isArray(recipients) ? recipients : []).filter(function (email) {
  	      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clean(email));
  	    });
  	    if (!emails.length) throw new Error("The vehicle company has no Service notification email in AppData.User.Companies.");

  	    const body = fifProviderEmailBody(company, vehicle, candidate, fuel);
  	    const bodyParts = typeof rawApi.Bodyparts === "function" ? new rawApi.Bodyparts() : {};
  	    bodyParts.textmessage = body.text;
  	    bodyParts.htmlmessage = body.html;

  	    await rawApi.Messaging.sendEmail(candidate.subject, bodyParts, emails, []);
  	  }

  	  async function fifPersistProviderNotificationHistory(rawApi, vehicle, history) {
  	    if (!rawApi || !rawApi.Data || typeof rawApi.Data.of !== "function") return false;
  	    if (!vehicle || !objectIdOf(vehicle)) return false;

  	    const data = fifCanonicalVehicleData(vehicle);
  	    const trimmed = (Array.isArray(history) ? history : []).slice(-100);

  	    serviceSetupWriteDescriptor(
  	      data,
  	      ["Service", "Notifications", "ProviderEmailHistory"],
  	      trimmed,
  	      "json",
  	      "",
  	      false
  	    );
  	    serviceSetupWriteDescriptor(
  	      data,
  	      ["Service", "Notifications", "LastProviderEmailAt"],
  	      trimmed.length ? clean(trimmed[trimmed.length - 1].SentAt) : "",
  	      "text",
  	      "",
  	      false
  	    );

  	    const saved = await rawApi.Data.of(assetTableName(vehicle)).save({
  	      objectId: objectIdOf(vehicle),
  	      Data: cloneData(data)
  	    });

  	    vehicle.Data = cloneData(saved && saved.Data ? saved.Data : data);
  	    state.actionableAlertCache = {};
  	    return true;
  	  }

  	  async function fifFuelTransactionProviderNotificationReview(company, vehicle, result) {
  	    const setup = serviceSetupSnapshot(vehicle);
  	    const conditions = fifFuelTransactionNotificationConditions(company, vehicle);

  	    if (!setup.NotifyServiceProvider && !setup.NotifyCompany) {
  	      return {
  	        status: "Disabled",
  	        message: "Service Provider and Company notifications are not enabled for this vehicle."
  	      };
  	    }

  	    if (!conditions.length) {
  	      return {
  	        status: "Not required",
  	        message: "The fuel transaction did not place Service or Preventive Maintenance inside a notification threshold."
  	      };
  	    }

  	    const resolvedCompany = fifResolveVehicleNotificationCompany(company, vehicle);
  	    const companyEmails = setup.NotifyCompany
  	      ? fifServiceNotificationCompanyEmails(resolvedCompany)
  	      : [];
  	    const candidates = fifAutomaticProviderNotificationCandidates(resolvedCompany || company, vehicle);
  	    const details = fifFuelTransactionProviderNotificationDetails(
  	      vehicle,
  	      result,
  	      conditions,
  	      candidates,
  	      companyEmails,
  	      setup
  	    );

  	    if (!candidates.length) {
  	      return {
  	        status: "Not required",
  	        message: "No Service or Preventive Maintenance notification candidate was produced."
  	      };
  	    }

  	    const history = fifProviderNotificationHistory(vehicle);
  	    const pendingCandidates = candidates.map(function (candidate) {
  	      const recipientState = fifNotificationHistoryRecipientState(history, candidate);
  	      const repeatOverdue = candidate.stage === "OVERDUE";
  	      const copy = Object.assign({}, candidate);

  	      copy._sendProvider = !!(
  	        setup.NotifyServiceProvider &&
  	        (repeatOverdue || !recipientState.providerSent)
  	      );
  	      copy._sendCompany = !!(
  	        setup.NotifyCompany &&
  	        (repeatOverdue || !recipientState.companySent)
  	      );
  	      copy._companyEmails = companyEmails.slice();

  	      return copy._sendProvider || copy._sendCompany ? copy : null;
  	    }).filter(Boolean);

  	    if (!pendingCandidates.length) {
  	      return {
  	        status: "Already notified",
  	        message: "The Due Soon notification was already sent to all enabled recipients for the current Service / Maintenance stage."
  	      };
  	    }

  	    const hasOverdue = pendingCandidates.some(function (candidate) {
  	      return candidate.stage === "OVERDUE";
  	    });

  	    let approved = true;
  	    if (!hasOverdue) {
  	      approved = await fifConfirm(
  	        "The fuel transaction has updated the vehicle mileage and a Service / Maintenance notification is now active. Send the notification to the enabled recipients now?",
  	        {
  	          title: "Send Service Notification?",
  	          type: "warning",
  	          confirmText: "Send Email",
  	          cancelText: "Not Now",
  	          details: details
  	        }
  	      );
  	    }

  	    if (!approved) {
  	      const deferUntil = Date.now() + 60 * 60 * 1000;
  	      pendingCandidates.forEach(function (candidate) {
  	        state.serviceProviderEmailDeferredUntil[candidate.key] = deferUntil;
  	      });

  	      return {
  	        status: "Deferred",
  	        message: "The Due Soon Service notification was not sent. Automatic retry is deferred for one hour."
  	      };
  	    }

  	    const rawApi = await fifWaitForRawWritableBackendlessApi(1800, "Tractors");
  	    if (!rawApi || !rawApi.Messaging || typeof rawApi.Messaging.sendEmail !== "function") {
  	      await fifAlert(
  	        "Fleet In Form could not access Backendless email delivery. The fuel record is saved, but the Service notification was not sent.",
  	        {
  	          title: "Service Notification Email Failed",
  	          type: "danger",
  	          confirmText: "Close",
  	          details: details
  	        }
  	      );
  	      return { status: "Email unavailable", message: "Backendless Messaging.sendEmail is unavailable." };
  	    }

  	    let successfulSends = 0;
  	    const failures = [];
  	    const fuel = result && result.fuel ? result.fuel : null;

  	    for (let index = 0; index < pendingCandidates.length; index += 1) {
  	      const candidate = pendingCandidates[index];
  	      let providerSent = false;
  	      let companySent = false;
  	      const providerEmail = clean(getDeep(candidate, ["provider", "Contact", "Email"], ""));

  	      if (candidate._sendProvider) {
  	        if (!candidate.provider || !providerEmail) {
  	          failures.push("Service Provider: no active provider email could be resolved.");
  	        } else {
  	          try {
  	            await fifSendAutomaticProviderEmail(rawApi, resolvedCompany || company, vehicle, candidate, fuel);
  	            providerSent = true;
  	            successfulSends += 1;
  	          } catch (error) {
  	            failures.push(
  	              "Service Provider: " +
  	              (clean(error && (error.message || error.faultString)) || "Email failed.")
  	            );
  	          }
  	        }
  	      }

  	      if (candidate._sendCompany) {
  	        if (!companyEmails.length) {
  	          failures.push(
  	            "Company: no Service notification email was found in AppData.User.Companies for " +
  	            companyName(resolvedCompany || company) + "."
  	          );
  	        } else {
  	          try {
  	            await fifSendCompanyServiceEmail(
  	              rawApi,
  	              resolvedCompany || company,
  	              vehicle,
  	              candidate,
  	              fuel,
  	              companyEmails
  	            );
  	            companySent = true;
  	            successfulSends += 1;
  	          } catch (error) {
  	            failures.push(
  	              "Company: " +
  	              (clean(error && (error.message || error.faultString)) || "Email failed.")
  	            );
  	          }
  	        }
  	      }

  	      if (providerSent || companySent) {
  	        const fuelObjectId = clean(fuel && fuel.objectId);
  	        history.push({
  	          Key: candidate.key,
  	          Kind: candidate.kind,
  	          Stage: candidate.stage,
  	          ProviderId: candidate.provider ? candidate.provider.ProviderId : "",
  	          ProviderName: candidate.provider ? serviceProviderLabel(candidate.provider) : "",
  	          ProviderEmail: providerSent ? providerEmail : "",
  	          ProviderEmailSent: providerSent,
  	          CompanyId: clean(firstValue([
  	            resolvedCompany && resolvedCompany.objectId,
  	            resolvedCompany && resolvedCompany.CompanyId,
  	            resolvedCompany && resolvedCompany.Name
  	          ], "")),
  	          CompanyName: companyName(resolvedCompany || company),
  	          CompanyEmail: companySent ? companyEmails.join(", ") : "",
  	          CompanyEmails: companySent ? companyEmails.join(", ") : "",
  	          CompanyEmailSent: companySent,
  	          Subject: candidate.subject,
  	          SentAt: new Date().toISOString(),
  	          Trigger: "Fuel Transaction",
  	          RepeatOverdue: candidate.stage === "OVERDUE",
  	          FuelOutObjectId: fuelObjectId,
  	          OccurrenceKey: candidate.key + "|FUELOUT|" + fuelObjectId
  	        });
  	      }

  	      if (providerSent || companySent) {
  	        delete state.serviceProviderEmailFailureUntil[candidate.key];
  	        delete state.serviceProviderEmailDeferredUntil[candidate.key];
  	      } else {
  	        state.serviceProviderEmailFailureUntil[candidate.key] = Date.now() + 60 * 60 * 1000;
  	      }
  	    }

  	    if (successfulSends > 0) {
  	      try {
  	        await fifPersistProviderNotificationHistory(rawApi, vehicle, history);
  	      } catch (_) {
  	        /* Internal audit persistence must never interrupt the fuel workflow. */
  	      }
  	    }

  	    if (failures.length) {
  	      await fifAlert(
  	        successfulSends
  	          ? "At least one configured Service notification recipient received the email, but another recipient could not be reached."
  	          : "The fuel transaction was saved, but the configured Service notification email could not be delivered.",
  	        {
  	          title: successfulSends ? "Service Notification Partially Sent" : "Service Notification Email Failed",
  	          type: "danger",
  	          confirmText: "Close",
  	          details: details.concat([{ label: "Email result", value: failures.join(" | ") }])
  	        }
  	      );
  	    }

  	    return {
  	      status: failures.length
  	        ? (successfulSends ? "Partially sent" : "Failed")
  	        : "Sent",
  	      message:
  	        "Service notification processing completed for " +
  	        successfulSends +
  	        " recipient delivery" +
  	        (successfulSends === 1 ? "." : "s.")
  	    };
  	  }

  	  async function fifProcessAutomaticProviderNotifications(company, vehicle, rawApi) {
  	    const setup = serviceSetupSnapshot(vehicle);
  	    if (!setup.NotifyServiceProvider && !setup.NotifyCompany) return 0;

  	    const resolvedCompany = fifResolveVehicleNotificationCompany(company, vehicle);
  	    const companyEmails = setup.NotifyCompany
  	      ? fifServiceNotificationCompanyEmails(resolvedCompany)
  	      : [];
  	    const candidates = fifAutomaticProviderNotificationCandidates(resolvedCompany || company, vehicle);
  	    if (!candidates.length) return 0;

  	    const history = fifProviderNotificationHistory(vehicle);
  	    let count = 0;
  	    let changed = false;

  	    for (let i = 0; i < candidates.length; i += 1) {
  	      const candidate = candidates[i];
  	      if (!candidate || !candidate.key) continue;
  	      if (state.serviceProviderEmailPending[candidate.key]) continue;

  	      const recipientState = fifNotificationHistoryRecipientState(history, candidate);

  	      /*
  	       * Background rendering/checking may send each current stage once, but it
  	       * never performs the repeated OVERDUE rule. Repeated overdue reminders are
  	       * tied only to a real new FuelOut transaction.
  	       */
  	      const sendProvider = !!(setup.NotifyServiceProvider && !recipientState.providerSent);
  	      const sendCompany = !!(setup.NotifyCompany && !recipientState.companySent);
  	      if (!sendProvider && !sendCompany) continue;

  	      const retryAfter = numberOr(state.serviceProviderEmailFailureUntil[candidate.key], 0);
  	      if (retryAfter > Date.now()) continue;

  	      const deferredUntil = numberOr(state.serviceProviderEmailDeferredUntil[candidate.key], 0);
  	      if (deferredUntil > Date.now()) continue;

  	      state.serviceProviderEmailPending[candidate.key] = true;
  	      let providerSent = false;
  	      let companySent = false;
  	      const providerEmail = clean(getDeep(candidate, ["provider", "Contact", "Email"], ""));

  	      let hadFailure = false;

  	      if (sendProvider) {
  	        if (!candidate.provider || !providerEmail) {
  	          hadFailure = true;
  	        } else {
  	          try {
  	            await fifSendAutomaticProviderEmail(rawApi, resolvedCompany || company, vehicle, candidate, null);
  	            providerSent = true;
  	            count += 1;
  	          } catch (_) {
  	            hadFailure = true;
  	          }
  	        }
  	      }

  	      if (sendCompany) {
  	        if (!companyEmails.length) {
  	          hadFailure = true;
  	        } else {
  	          try {
  	            await fifSendCompanyServiceEmail(
  	              rawApi,
  	              resolvedCompany || company,
  	              vehicle,
  	              candidate,
  	              null,
  	              companyEmails
  	            );
  	            companySent = true;
  	            count += 1;
  	          } catch (_) {
  	            hadFailure = true;
  	          }
  	        }
  	      }

  	      if (providerSent || companySent) {
  	        history.push({
  	          Key: candidate.key,
  	          Kind: candidate.kind,
  	          Stage: candidate.stage,
  	          ProviderId: candidate.provider ? candidate.provider.ProviderId : "",
  	          ProviderName: candidate.provider ? serviceProviderLabel(candidate.provider) : "",
  	          ProviderEmail: providerSent ? providerEmail : "",
  	          ProviderEmailSent: providerSent,
  	          CompanyId: clean(firstValue([
  	            resolvedCompany && resolvedCompany.objectId,
  	            resolvedCompany && resolvedCompany.CompanyId,
  	            resolvedCompany && resolvedCompany.Name
  	          ], "")),
  	          CompanyName: companyName(resolvedCompany || company),
  	          CompanyEmail: companySent ? companyEmails.join(", ") : "",
  	          CompanyEmails: companySent ? companyEmails.join(", ") : "",
  	          CompanyEmailSent: companySent,
  	          Subject: candidate.subject,
  	          SentAt: new Date().toISOString(),
  	          Trigger: "Dashboard Background"
  	        });
  	        changed = true;
  	      }

  	      if (hadFailure) {
  	        state.serviceProviderEmailFailureUntil[candidate.key] = Date.now() + 60 * 60 * 1000;
  	      } else {
  	        delete state.serviceProviderEmailFailureUntil[candidate.key];
  	      }

  	      delete state.serviceProviderEmailPending[candidate.key];
  	    }

  	    if (changed) {
  	      try {
  	        await fifPersistProviderNotificationHistory(rawApi, vehicle, history);
  	      } catch (_) {
  	        /* Background audit failures are intentionally silent. */
  	      }
  	    }

  	    return count;
  	  }

  	  function fifScheduleAutomaticServiceProviderNotifications(company) {
  	    if (
  	      !company ||
  	      state.destroyed ||
  	      state.viewMode !== "current" ||
  	      state.serviceProviderEmailInteractionActive
  	    ) return;

  	    if (state.serviceProviderEmailTimer) {
  	      clearTimeout(state.serviceProviderEmailTimer);
  	      state.serviceProviderEmailTimer = null;
  	    }

  	    state.serviceProviderEmailTimer = setTimeout(function () {
  	      state.serviceProviderEmailTimer = null;

  	      (async function () {
  	        if (
  	          state.destroyed ||
  	          state.viewMode !== "current" ||
  	          state.serviceProviderEmailInteractionActive
  	        ) return;

  	        const activeCompany = selectedCompany();
  	        if (!activeCompany || objectIdOf(activeCompany) !== objectIdOf(company)) return;

  	        const rawApi = await fifWaitForRawWritableBackendlessApi(1800, "Tractors");
  	        if (!rawApi || !rawApi.Messaging || typeof rawApi.Messaging.sendEmail !== "function") return;

  	        const vehicles = tractors(activeCompany);
  	        for (let i = 0; i < vehicles.length; i += 1) {
  	          if (state.destroyed || state.viewMode !== "current") return;
  	          await fifProcessAutomaticProviderNotifications(activeCompany, vehicles[i], rawApi);
  	        }
  	      })().catch(function () {});
  	    }, 500);
  	  }

  	  function preventiveScheduleDate(status) {
  	    const today = new Date().toISOString().slice(0, 10);
  	    if (!status.nextDate) return today;
  	    return status.nextDate < today ? today : status.nextDate;
  	  }

  	  function openPreventiveJobModal(company, vehicle, planId) {
  	    if (!CAN_MANAGE_MAINTENANCE || !vehicle) return;
  	    const plan = preventivePlanById(vehicle, planId);
  	    if (!plan) return;
  	    const status = preventivePlanStatus(vehicle, plan);
  	    if (status.openJob) {
  	      openServiceJobModal(company, status.openJob.WorkOrderId, { LockVehicle: true });
  	      return;
  	    }
  	    const providers = [{ value: "", label: "Not assigned" }].concat(serviceProviders(company).filter(function (provider) {
  	      return lower(provider.Status) === "active";
  	    }).map(function (provider) {
  	      return { value: provider.ProviderId, label: serviceProviderLabel(provider) };
  	    }));
  	    const body = `<form data-pm-job-form class="fifsp-form fifpm-modal-form">
  	      <div class="fifpm-schedule-summary"><div><span>Plan</span><strong>${escapeHtml(plan.Name)}</strong></div><div><span>Due Kilometer</span><strong>${escapeHtml(preventiveDueCounterLabel(status))}</strong></div><div><span>Due Date</span><strong>${escapeHtml(preventiveDueDateLabel(status))}</strong></div></div>
  	      <div class="fifpm-form-grid">
  	        ${serviceField("ScheduledDate", "Scheduled Date", preventiveScheduleDate(status), "date", { required: true })}
  	        ${serviceField("ProviderId", "Provider", plan.ProviderId, "select", { values: providers })}
  	        ${serviceField("Priority", "Priority", plan.Priority, "select", { values: ["Low", "Normal", "High", "Critical"], required: true })}
  	        ${serviceField("Odometer", "Current Odometer", currentOdometer(vehicle), "number", { min: 0 })}
  	        ${serviceField("Scope", "Work Scope", plan.Scope || plan.Name, "textarea", { required: true, wide: true })}
  	        ${serviceField("AddNote", "Job Note", "", "textarea", { wide: true })}
  	      </div>
  	    </form>`;
  	    const overlay = serviceModalShell("Schedule Preventive Job", vehicleTitleValue(vehicle), body, `<button type="button" data-sp-modal-close>Cancel</button><button type="button" class="primary" data-pm-job-save>Schedule Job</button>`, false);
  	    overlay.querySelector(".fifsp-modal")?.classList.add("fifwrk-modal");
  	    overlay.querySelector("[data-pm-job-save]")?.addEventListener("click", async function () {
  	      const form = overlay.querySelector("[data-pm-job-form]");
  	      if (!form || !form.reportValidity()) return;
  	      const values = new FormData(form);
  	      const provider = serviceProviderById(company, values.get("ProviderId"));
  	      const now = new Date().toISOString();
  	      const noteText = clean(values.get("AddNote")) || "Created from preventive maintenance plan " + plan.Name + ".";
  	      const note = serviceAppendAuditNote({}, noteText, "Preventive job created");
  	      const order = normalizeServiceWorkOrder({
  	        WorkOrderId: serviceId("WO"),
  	        VehicleObjectId: objectIdOf(vehicle),
  	        VehicleId: vehicleTitleValue(vehicle),
  	        Registration: vehicleRegistrationValue(vehicle),
  	        Category: MAINTENANCE_CATEGORY_MAINTENANCE,
  	        Type: "Preventive Maintenance",
  	        Title: plan.Name,
  	        Status: "Scheduled",
  	        Priority: clean(values.get("Priority")) || plan.Priority,
  	        ReportedDate: new Date().toISOString().slice(0, 10),
  	        ScheduledDate: clean(values.get("ScheduledDate")),
  	        Odometer: values.get("Odometer"),
  	        ProviderId: provider ? provider.ProviderId : "",
  	        ProviderName: provider ? serviceProviderLabel(provider) : "",
  	        Complaint: clean(values.get("Scope")) || plan.Scope || plan.Name,
  	        SafeToOperate: true,
  	        OperationalBlock: false,
  	        Trigger: "Preventive maintenance",
  	        IsScheduled: true,
  	        PreventivePlanId: plan.PlanId,
  	        PreventivePlanName: plan.Name,
  	        PreventiveDueKM: status.nextKM,
  	        PreventiveDueDate: status.nextDate,
  	        GeneratedFromPreventivePlan: true,
  	        Notes: note.Notes,
  	        NoteLog: note.NoteLog,
  	        CurrentPhaseEnteredAt: now,
  	        CurrentPhaseEnteredBy: userDisplayName(),
  	        CreatedAt: now,
  	        CreatedBy: userDisplayName(),
  	        UpdatedAt: now,
  	        UpdatedBy: userDisplayName()
  	      });
  	      const operation = fifBeginSaveOperation("Scheduling preventive maintenance…");
  	      let handed = false;
  	      try {
  	        closeServicePortalModal();
  	        handed = true;
  	        await saveMaintenanceRecord(company, vehicle, order, { operation: operation, message: order.WorkOrderId + " scheduled from " + plan.Name + ".", title: "Preventive Job Scheduled" });
  	        state.maintenanceView = "open";
  	        state.maintenanceOpenExpanded = true;
  	        render();
  	      } catch (error) {
  	        if (!handed) fifFailSaveOperation(operation, error);
  	        await fifAlert(error && error.message ? error.message : "The preventive job could not be scheduled.", { title: "Schedule Failed", type: "danger" });
  	      }
  	    });
  	  }

  	  function renderMaintenanceAnalysis(records) {
  	    const completed = records.filter(function (record) { return serviceCanonicalStatus(record.Status) === "Completed"; });
  	    const totalCost = completed.reduce(function(sum,row){return sum+numberOr(row.ActualCost,0);},0);
  	    const downtime = completed.reduce(function(sum,row){return sum+numberOr(row.DowntimeHours,0);},0);
  	    const types = {};
  	    completed.forEach(function(row){const key=clean(row.Type||"Other"); if(!types[key]) types[key]={count:0,cost:0}; types[key].count+=1; types[key].cost+=numberOr(row.ActualCost,0);});
  	    const repeated=Object.keys(types).map(function(key){return {type:key,count:types[key].count,cost:types[key].cost};}).sort(function(a,b){return b.count-a.count || b.cost-a.cost;});
  	    return `<section class="fifwrk-analysis"><div class="fifwrk-analysis-grid"><article><span>Completed work</span><strong>${completed.length}</strong></article><article><span>Recorded spend</span><strong>${escapeHtml(formatCurrency(totalCost))}</strong></article><article><span>Average repair</span><strong>${completed.length ? escapeHtml(formatCurrency(totalCost/completed.length)) : "R 0.00"}</strong></article><article><span>Downtime</span><strong>${escapeHtml(formatNumber(downtime,1)+" h")}</strong></article></div><section class="fifwrk-analysis-list"><header>Repeated maintenance patterns</header>${repeated.length ? repeated.map(function(item){return `<article><strong>${escapeHtml(item.type)}</strong><span>${item.count} job${item.count===1?"":"s"}</span><span>${escapeHtml(formatCurrency(item.cost))}</span></article>`;}).join("") : `<div class="fifvm-empty">No completed maintenance history is available for analysis.</div>`}</section></section>`;
  	  }

  	  function renderVehicleMaintenance(company, vehicle) {
  	    workshopEnsureSmartState();
  	    injectMaintenanceRelationStyles();
  	    injectV21SmartWorkshopStyles();
  	    injectPreventiveMaintenanceStyles();
  	    ensureMaintenanceRecordsLoaded(company,vehicle,false);
  	    const all=vehicleMaintenanceOrders(vehicle).map(normalizeServiceWorkOrder);
  	    const open=all.filter(function(row){return SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(row.Status))!==-1;});
  	    const completed=all.filter(function(row){return serviceCanonicalStatus(row.Status)==="Completed";}).sort(function(a,b){return naturalCompare(b.CompletedDate||b.ReportedDate,a.CompletedDate||a.ReportedDate);});
  	    const closed=all.filter(function(row){return ["Completed","Cancelled"].indexOf(serviceCanonicalStatus(row.Status))!==-1;}).sort(function(a,b){return naturalCompare(b.CompletedDate||b.CancelledAt||b.ReportedDate,a.CompletedDate||a.CancelledAt||a.ReportedDate);});
  	    const critical=open.filter(function(row){return lower(row.Priority)==="critical";});
  	    const inWorkflow=open.filter(function(row){return ["In Progress","Waiting Parts","Ready"].indexOf(serviceCanonicalStatus(row.Status))!==-1;});
  	    const spend=completed.reduce(function(sum,row){return sum+numberOr(row.ActualCost,0);},0);
  	    const openExpanded=state.maintenanceOpenExpanded === true;
  	    const view=state.maintenanceView === "preventive"
  	      ? renderPreventiveMaintenancePortal(company,vehicle)
  	      : state.maintenanceView === "completed"
  	        ? workshopHistoryCards(closed,"No closed maintenance records captured.")
  	        : state.maintenanceView === "analysis"
  	          ? renderMaintenanceAnalysis(all)
  	          : openExpanded
  	            ? workshopBoard(company,vehicle,MAINTENANCE_CATEGORY_MAINTENANCE)
  	            : "";
  	    return `${vehiclePermissionNotice(CAN_MANAGE_WORKSHOP,"Maintenance permission is required to create or update maintenance job cards.")}<section class="fifmnt-root"><header class="fifmnt-head"><h3>${escapeHtml(vehicleTitleValue(vehicle))} Maintenance</h3><div class="fifmnt-actions">${CAN_MANAGE_WORKSHOP ? `<button type="button" class="fifvm-btn" data-mnt-capture-completed>Capture Completed Maintenance</button>` : ""}${CAN_MANAGE_SERVICE_JOBS ? `<button type="button" class="fifvm-btn primary" data-workshop-new="${escapeAttr(MAINTENANCE_CATEGORY_MAINTENANCE)}">+ Report Maintenance</button>` : ""}</div></header><section class="fifmnt-kpis"><article class="fifmnt-kpi warn"><span>Open Jobs</span><strong>${open.length}</strong></article><article class="fifmnt-kpi bad"><span>Critical</span><strong>${critical.length}</strong></article><article class="fifmnt-kpi info"><span>In Workflow</span><strong>${inWorkflow.length}</strong></article><article class="fifmnt-kpi good"><span>Completed</span><strong>${completed.length}</strong></article><article class="fifmnt-kpi"><span>Recorded Spend</span><strong>${escapeHtml(formatCurrency(spend))}</strong></article></section><nav class="fifmnt-toolbar fifwrk-tabs"><button type="button" data-maintenance-view="preventive" class="${state.maintenanceView === "preventive" ? "active" : ""}">Preventive</button><button type="button" data-maintenance-view="open" class="${state.maintenanceView === "open" ? "active" : ""}" aria-expanded="${openExpanded ? "true" : "false"}">Open Job Cards <b>${open.length}</b><span class="fifmnt-collapse-arrow">${openExpanded ? "⌄" : "›"}</span></button><button type="button" data-maintenance-view="completed" class="${state.maintenanceView === "completed" ? "active" : ""}">History <b>${closed.length}</b></button><button type="button" data-maintenance-view="analysis" class="${state.maintenanceView === "analysis" ? "active" : ""}">Analysis</button></nav>${view}</section>`;
  	  }

  	  function workshopActionDefinition(target, order) {
  	    const phase=serviceCanonicalStatus(target);
  	    const defs={
  	      "Booked": {title:"Confirm Booking",help:"Record only the provider confirmation. The job then becomes Booked.",button:"Confirm Booking",saving:"Confirming workshop booking…"},
  	      "In Progress": {title:serviceCanonicalStatus(order.Status)==="Waiting Parts"?"Parts Received":"Start Work",help:serviceCanonicalStatus(order.Status)==="Waiting Parts"?"Record that the delay has ended and work has resumed.":"Record arrival, provider and opening odometer. The workshop workflow advances automatically.",button:serviceCanonicalStatus(order.Status)==="Waiting Parts"?"Resume Work":"Start Work",saving:"Starting workshop work…"},
  	      "Waiting Parts": {title:"Delay / Waiting for Parts",help:"Record the reason and the next review or expected-parts date.",button:"Record Delay",saving:"Recording workshop delay…"},
  	      "Ready": {title:"Mark Ready",help:"Record the work completed before the vehicle is accepted or collected.",button:"Mark Ready",saving:"Marking workshop job ready…"},
  	      "Completed": {title:"Complete Job",help:"One action closes the job, records the final cost and updates service position when applicable.",button:"Complete Job",saving:"Completing workshop job…"},
  	      "Scheduled": {title:"Return to Scheduled",help:"Release the booking while retaining the permanent workflow history.",button:"Return to Scheduled",saving:"Updating workshop schedule…"},
  	      "Cancelled": {title:"Cancel Job",help:"Cancellation is permanent and requires an audit reason.",button:"Cancel Job",saving:"Cancelling workshop job…"}
  	    };
  	    return defs[phase] || {title:"Update Workshop",help:"Record the evidence required for this change.",button:"Save Change",saving:"Updating workshop job…"};
  	  }

  	  function workshopActionFields(company, vehicle, order, target) {
  	    const phase=serviceCanonicalStatus(target);
  	    const providers=[{value:"",label:"Select provider"}].concat(serviceProviders(company).filter(function(p){return lower(p.Status)==="active";}).map(function(p){return {value:p.ProviderId,label:serviceProviderLabel(p)};}));
  	    const now=maintenanceDateTimeInput(new Date());
  	    const fields=[];
  	    if (phase === "Booked") {
  	      fields.push(serviceField("ProviderId","Confirmed provider",order.ProviderId,"select",{values:providers,required:true}));
  	      fields.push(serviceField("ScheduledDate","Confirmed date",order.ScheduledDate,"date",{required:true}));
  	      fields.push(serviceField("BookingReference","Booking reference",order.BookingReference,"text",{required:true,wide:true}));
  	    } else if (phase === "In Progress") {
  	      fields.push(serviceField("ProviderId","Provider / workshop",order.ProviderId,"select",{values:providers,required:true}));
  	      fields.push(serviceField("StartedDate",serviceCanonicalStatus(order.Status)==="Waiting Parts"?"Work resumed":"Asset received / work started",serviceCanonicalStatus(order.Status)==="Waiting Parts"?now:(order.StartedDate||now),"datetime-local",{required:true}));
  	      fields.push(serviceField("Odometer","Opening odometer",order.Odometer===null?currentOdometer(vehicle):order.Odometer,"number",{min:0,required:true}));
  	    } else if (phase === "Waiting Parts") {
  	      fields.push(serviceField("DelayReason","Delay reason",order.DelayReason,"textarea",{required:true,wide:true}));
  	      fields.push(serviceField("DelayExpectedDate","Next review / expected-parts date",order.DelayExpectedDate,"date",{required:true}));
  	      fields.push(serviceField("EstimatedAdditionalCost","Estimated additional cost",order.EstimatedAdditionalCost,"number",{min:0,step:0.01}));
  	    } else if (phase === "Ready") {
  	      fields.push(serviceField("WorkPerformed","Work performed",order.WorkPerformed,"textarea",{required:true,wide:true}));
  	    } else if (phase === "Completed") {
  	      fields.push(serviceField("CompletedDate","Completion date",order.CompletedDate||new Date().toISOString().slice(0,10),"date",{required:true}));
  	      fields.push(serviceField("Odometer","Final odometer",order.Odometer===null?currentOdometer(vehicle):order.Odometer,"number",{min:0,required:true}));
  	      fields.push(serviceField("WorkPerformed","Final work performed",order.WorkPerformed,"textarea",{required:true,wide:true}));
  	      fields.push(serviceField("ActualCost","Final gross cost",order.ActualCost,"number",{min:0,step:0.01}));
  	      fields.push(serviceField("InvoiceNumber","Invoice / reference",order.InvoiceNumber,"text",{}));
  	    } else if (phase === "Scheduled") {
  	      fields.push(serviceField("ScheduledDate","Proposed date",order.ScheduledDate,"date",{}));
  	    }
  	    fields.push(serviceField("TransitionNote",phase === "Cancelled" ? "Cancellation reason" : "Permanent note / evidence","","textarea",{required:true,wide:true}));
  	    return fields.join("");
  	  }

  	  function openServicePhaseModal(company, workOrderId, presetTarget) {
  	    const order=serviceWorkOrderById(company,workOrderId);
  	    if(!order || !serviceJobIsOpen(order)) { fifAlert("Only an open Service or Maintenance job can change workshop phase.",{title:"Action Unavailable",type:"warning"}); return; }
  	    const vehicle=serviceVehicleById(company,order.VehicleObjectId);
  	    if(!vehicle) { fifAlert("The linked asset is not available in loaded App Data.",{title:"Asset Unavailable",type:"danger"}); return; }
  	    const target=serviceCanonicalStatus(presetTarget || servicePrimaryTransition(order).target);
  	    if(serviceAllowedTransitions(order.Status).indexOf(target)===-1){fifAlert(servicePhaseLabel(order.Status)+" cannot move directly to "+servicePhaseLabel(target)+".",{title:"Invalid Workshop Move",type:"warning"});return;}
  	    const def=workshopActionDefinition(target,order);
  	    const body=`<form data-workshop-action-form class="fifsp-form"><div class="fifwrk-action-summary"><div><span>Job</span><strong>${escapeHtml(order.WorkOrderId)}</strong></div><div><span>Current phase</span><strong>${escapeHtml(servicePhaseLabel(order.Status))}</strong></div><div><span>Next phase</span><strong>${escapeHtml(servicePhaseLabel(target))}</strong></div></div><div class="fifwrk-action-help">${escapeHtml(def.help)}</div><div class="fifwrk-action-grid">${workshopActionFields(company,vehicle,order,target)}</div></form>`;
  	    const overlay=serviceModalShell(def.title,order.Type+" · "+vehicleTitleValue(vehicle),body,`<button type="button" data-sp-modal-close>Cancel</button><button type="button" class="primary" data-workshop-action-save>${escapeHtml(def.button)}</button>`,false);
  	    overlay.querySelector(".fifsp-modal")?.classList.add("fifwrk-modal");
  	    overlay.querySelector("[data-workshop-action-save]")?.addEventListener("click",async function(){
  	      const form=overlay.querySelector("[data-workshop-action-form]"); if(!form || !form.reportValidity()) return;
  	      const operation=fifBeginSaveOperation(def.saving); let handed=false;
  	      try{
  	        const values=new FormData(form);
  	        let updated=serviceApplyPhaseTransition(company,vehicle,order,target,values,{mode:"Smart workshop action"});
  	        if(values.has("InvoiceNumber")) updated.InvoiceNumber=clean(values.get("InvoiceNumber"));
  	        if(values.has("EstimatedAdditionalCost")) updated.EstimatedAdditionalCost=numberOr(values.get("EstimatedAdditionalCost"),null);
  	        closeServicePortalModal(); handed=true;
  	        await saveMaintenanceRecord(company,vehicle,updated,{operation:operation,message:updated.WorkOrderId+" moved to "+servicePhaseLabel(updated.Status)+".",title:def.title+" Saved"});
  	      }catch(error){if(!handed)fifFailSaveOperation(operation,error);await fifAlert(error&&error.message?error.message:"The workshop action could not be saved.",{title:def.title+" Failed",type:"danger"});}
  	    });
  	  }

  	  function openWorkshopActionMenu(company, workOrderId) {
  	    const order=serviceWorkOrderById(company,workOrderId); if(!order)return;
  	    const allowed=serviceAllowedTransitions(order.Status);
  	    const body=`<div class="fifwrk-menu-list">${allowed.map(function(target){const def=workshopActionDefinition(target,order);return `<button type="button" data-workshop-menu-target="${escapeAttr(target)}"><div><strong>${escapeHtml(def.title)}</strong><span>${escapeHtml(def.help)}</span></div><b>›</b></button>`;}).join("")}${serviceJobRequiresReschedule(order)?`<button type="button" data-workshop-menu-reschedule><div><strong>Reschedule</strong><span>Move the planned date and retain the original date and reason.</span></div><b>›</b></button>`:""}<button type="button" data-workshop-menu-note><div><strong>Add Permanent Note</strong><span>Add information without changing or removing earlier notes.</span></div><b>›</b></button></div>`;
  	    const overlay=serviceModalShell("Workshop Actions",order.WorkOrderId+" · "+servicePhaseLabel(order.Status),body,`<button type="button" data-sp-modal-close>Close</button>`,false); overlay.querySelector(".fifsp-modal")?.classList.add("fifwrk-modal");
  	    overlay.querySelectorAll("[data-workshop-menu-target]").forEach(function(button){button.addEventListener("click",function(){const target=button.getAttribute("data-workshop-menu-target");closeServicePortalModal();openServicePhaseModal(company,workOrderId,target);});});
  	    overlay.querySelector("[data-workshop-menu-reschedule]")?.addEventListener("click",function(){closeServicePortalModal();openServiceRescheduleModal(company,workOrderId);});
  	    overlay.querySelector("[data-workshop-menu-note]")?.addEventListener("click",function(){closeServicePortalModal();openWorkshopNoteModal(company,workOrderId);});
  	  }

  	  function openWorkshopNoteModal(company, workOrderId) {
  	    const order=serviceWorkOrderById(company,workOrderId); if(!order)return;
  	    const vehicle=serviceVehicleById(company,order.VehicleObjectId); if(!vehicle)return;
  	    const body=`<form data-workshop-note-form class="fifsp-form"><div class="fifwrk-action-help">Earlier notes cannot be edited or removed.</div><div class="fifwrk-action-grid">${serviceField("AddNote","New permanent note","","textarea",{required:true,wide:true})}</div>${workshopTimelineHtml(order)}</form>`;
  	    const overlay=serviceModalShell("Add Workshop Note",order.WorkOrderId,body,`<button type="button" data-sp-modal-close>Cancel</button><button type="button" class="primary" data-workshop-note-save>Add Note</button>`,false); overlay.querySelector(".fifsp-modal")?.classList.add("fifwrk-modal");
  	    overlay.querySelector("[data-workshop-note-save]")?.addEventListener("click",async function(){const form=overlay.querySelector("[data-workshop-note-form]");if(!form||!form.reportValidity())return;const operation=fifBeginSaveOperation("Adding permanent workshop note…");let handed=false;try{const note=serviceAppendAuditNote(order,new FormData(form).get("AddNote"),"Workshop note");const updated=normalizeServiceWorkOrder(Object.assign({},order,note,{UpdatedAt:new Date().toISOString(),UpdatedBy:userDisplayName()}));closeServicePortalModal();handed=true;await saveMaintenanceRecord(company,vehicle,updated,{operation:operation,message:"Workshop note added.",title:"Note Saved"});}catch(error){if(!handed)fifFailSaveOperation(operation,error);await fifAlert(error&&error.message?error.message:"The note could not be saved.",{title:"Note Save Failed",type:"danger"});}});
  	  }

  	  function workshopIntakeType(trigger) {
  	    return {
  	      "Breakdown":"Breakdown",
  	      "Driver-reported defect":"Mechanical Repair",
  	      "Inspection finding":"Inspection",
  	      "Preventive maintenance":"Preventive Service",
  	      "Accident damage":"Bodywork",
  	      "Tyre-related defect":"Tyre Work",
  	      "Other":"Other"
  	    }[clean(trigger)] || "Mechanical Repair";
  	  }

  	  function openWorkshopIntakeModal(company, vehicle, category, defaults) {
  	    defaults=defaults||{};
  	    const serviceJob=category===MAINTENANCE_CATEGORY_SERVICE;
  	    if(serviceJob){
  	      const existing=vehicleServiceOrders(company,vehicle).find(function(job){return job.Category===MAINTENANCE_CATEGORY_SERVICE && SERVICE_JOB_OPEN_STATUSES.indexOf(serviceCanonicalStatus(job.Status))!==-1;});
  	      if(existing){openWorkshopActionMenu(company,existing.WorkOrderId);return;}
  	    }
  	    const providers=[{value:"",label:"Not assigned yet"}].concat(serviceProviders(company).filter(function(p){return lower(p.Status)==="active";}).map(function(p){return {value:p.ProviderId,label:serviceProviderLabel(p)};}));
  	    const body=serviceJob ? `<form data-workshop-intake class="fifsp-form"><div class="fifwrk-action-help">Schedule the service. Provider confirmation is captured later with Confirm Booking.</div><div class="fifwrk-action-grid">${serviceField("ScheduledDate","Proposed service date",defaults.ScheduledDate||"","date",{required:true})}${serviceField("ProviderId","Preferred provider",clean(getDeep(vehicle,["Data","Service","History","Service_Centre_Last_Used"],"")),"select",{values:providers})}${serviceField("Priority","Priority",defaults.Priority||"Normal","select",{values:["Low","Normal","High","Critical"]})}${serviceField("Odometer","Current odometer",currentOdometer(vehicle),"number",{min:0})}${serviceField("Complaint","Service requirement",defaults.Complaint||(serviceHealthForVehicle(company,vehicle).nextKm?"Scheduled service at "+formatNumber(serviceHealthForVehicle(company,vehicle).nextKm,0)+" km":"Scheduled service"),"textarea",{required:true,wide:true})}${serviceField("AddNote","Initial note","","textarea",{wide:true})}</div></form>` : `<form data-workshop-intake class="fifsp-form"><div class="fifwrk-action-help">Report what happened. Provider, diagnosis, parts and final cost are captured only when they become relevant.</div><div class="fifwrk-action-grid">${serviceField("Trigger","What happened?","Driver-reported defect","select",{values:["Breakdown","Driver-reported defect","Inspection finding","Preventive maintenance","Accident damage","Tyre-related defect","Other"],required:true})}${serviceField("Priority","Severity","Normal","select",{values:["Low","Normal","High","Critical"],required:true})}${serviceField("SafeToOperate","Safe to operate?","Yes","select",{values:["Yes","No"],required:true})}${serviceField("Odometer","Current odometer",currentOdometer(vehicle),"number",{min:0})}${serviceField("Complaint","Short description","","textarea",{required:true,wide:true})}${serviceField("AddNote","Optional initial note","","textarea",{wide:true})}</div></form>`;
  	    const title=serviceJob?"Schedule Service":"Report Maintenance";
  	    const overlay=serviceModalShell(title,vehicleTitleValue(vehicle)+" · minimal intake",body,`<button type="button" data-sp-modal-close>Cancel</button><button type="button" class="primary" data-workshop-intake-save>${escapeHtml(title)}</button>`,false); overlay.querySelector(".fifsp-modal")?.classList.add("fifwrk-modal");
  	    overlay.querySelector("[data-workshop-intake-save]")?.addEventListener("click",async function(){const form=overlay.querySelector("[data-workshop-intake]");if(!form||!form.reportValidity())return;const values=new FormData(form);const operation=fifBeginSaveOperation(serviceJob?"Scheduling service…":"Creating maintenance job…");let handed=false;try{const provider=serviceProviderById(company,values.get("ProviderId"));const trigger=serviceJob?"Scheduled service":clean(values.get("Trigger"));const note=serviceAppendAuditNote({},clean(values.get("AddNote"))||clean(values.get("Complaint")),"Job created");const now=new Date().toISOString();let order=normalizeServiceWorkOrder({WorkOrderId:serviceId("WO"),VehicleObjectId:objectIdOf(vehicle),VehicleId:vehicleTitleValue(vehicle),Registration:vehicleRegistrationValue(vehicle),Category:category,Type:serviceJob?"Scheduled Service":workshopIntakeType(trigger),Title:serviceJob?"Scheduled Service":trigger,Status:"Scheduled",Priority:values.get("Priority")||"Normal",ReportedDate:new Date().toISOString().slice(0,10),ScheduledDate:values.get("ScheduledDate"),Odometer:values.get("Odometer"),ProviderId:provider?provider.ProviderId:"",ProviderName:provider?serviceProviderLabel(provider):"",Complaint:values.get("Complaint"),SafeToOperate:serviceJob?true:clean(values.get("SafeToOperate"))!=="No",OperationalBlock:!serviceJob&&clean(values.get("SafeToOperate"))==="No",Trigger:trigger,IsScheduled:serviceJob,Notes:note.Notes,NoteLog:note.NoteLog,CurrentPhaseEnteredAt:now,CurrentPhaseEnteredBy:userDisplayName(),CreatedAt:now,CreatedBy:userDisplayName(),UpdatedAt:now,UpdatedBy:userDisplayName()});closeServicePortalModal();handed=true;await saveMaintenanceRecord(company,vehicle,order,{operation:operation,message:order.WorkOrderId+" created.",title:title+" Saved"});}catch(error){if(!handed)fifFailSaveOperation(operation,error);await fifAlert(error&&error.message?error.message:"The workshop job could not be created.",{title:title+" Failed",type:"danger"});}});
  	  }









  	  function bindSmartWorkshopBoard(scope, company, vehicle) {
  	    scope.querySelectorAll("[data-workshop-open]").forEach(function(button){button.addEventListener("click",function(){openServiceJobModal(company,button.getAttribute("data-workshop-open"),{LockVehicle:true});});});
  	    scope.querySelectorAll("[data-workshop-print]").forEach(function(button){button.addEventListener("click",function(){const row=serviceWorkOrderById(company,button.getAttribute("data-workshop-print"));if(row)printServiceJobCard(company,row);});});
  	    scope.querySelectorAll("[data-workshop-action]").forEach(function(button){button.addEventListener("click",function(){openServicePhaseModal(company,button.getAttribute("data-workshop-action"),button.getAttribute("data-workshop-target"));});});
  	    scope.querySelectorAll("[data-workshop-more]").forEach(function(button){button.addEventListener("click",function(){openWorkshopActionMenu(company,button.getAttribute("data-workshop-more"));});});
  	    scope.querySelectorAll("[data-workshop-new]").forEach(function(button){button.addEventListener("click",function(){openWorkshopIntakeModal(company,vehicle,button.getAttribute("data-workshop-new"));});});
  	    scope.querySelectorAll("[data-workshop-job]").forEach(function(card){card.addEventListener("dragstart",function(event){state.workshopDragJobId=card.getAttribute("data-workshop-job")||"";state.workshopDragFrom=card.getAttribute("data-workshop-phase")||"";card.classList.add("is-dragging");if(event.dataTransfer){event.dataTransfer.effectAllowed="move";event.dataTransfer.setData("text/plain",state.workshopDragJobId);}});card.addEventListener("dragend",function(){state.workshopDragJobId="";state.workshopDragFrom="";card.classList.remove("is-dragging");scope.querySelectorAll(".is-drop-target").forEach(function(node){node.classList.remove("is-drop-target");});});});
  	    scope.querySelectorAll("[data-workshop-drop-phase]").forEach(function(column){column.addEventListener("dragover",function(event){if(!state.workshopDragJobId)return;event.preventDefault();column.classList.add("is-drop-target");if(event.dataTransfer)event.dataTransfer.dropEffect="move";});column.addEventListener("dragleave",function(event){if(!column.contains(event.relatedTarget))column.classList.remove("is-drop-target");});column.addEventListener("drop",function(event){event.preventDefault();column.classList.remove("is-drop-target");const id=state.workshopDragJobId || (event.dataTransfer&&event.dataTransfer.getData("text/plain"));const target=column.getAttribute("data-workshop-drop-phase");const order=serviceWorkOrderById(company,id);state.workshopDragJobId="";state.workshopDragFrom="";if(!order)return;if(serviceCanonicalStatus(order.Status)===serviceCanonicalStatus(target))return;if(serviceAllowedTransitions(order.Status).indexOf(serviceCanonicalStatus(target))===-1){fifAlert(servicePhaseLabel(order.Status)+" cannot move directly to "+servicePhaseLabel(target)+". Use the valid workshop actions on the card.",{title:"Invalid Workshop Move",type:"warning"});return;}openServicePhaseModal(company,id,target);});});
  	  }

  	  function bindVehicleServiceWorkspaceEvents(scope, company, vehicle) {
  	    if(!scope||!vehicle)return;workshopEnsureSmartState();if(state.vehicleActiveTab==="service"||state.vehicleActiveTab==="maintenance")ensureMaintenanceRecordsLoaded(company,vehicle,false);
  	    bindSmartWorkshopBoard(scope,company,vehicle);
  	    scope.querySelectorAll("[data-vm-service-view]").forEach(function(button){button.addEventListener("click",function(){state.vehicleServiceView=button.getAttribute("data-vm-service-view")||"position";render();});});
  	    scope.querySelectorAll("[data-vm-service-info]").forEach(function(button){button.addEventListener("click",function(){const target=button.getAttribute("data-vm-service-info")||"position";if(target==="providers"){openVehicleServiceSetupModal(company,vehicle,"providers");return;}if(target==="setup"){openVehicleServiceSetupModal(company,vehicle,"setup");return;}state.vehicleServiceView=target==="jobs"?"jobs":"position";render();});});
  	    scope.querySelectorAll("[data-maintenance-view]").forEach(function(button){button.addEventListener("click",function(){const next=button.getAttribute("data-maintenance-view")||"open";if(next==="open"){if(state.maintenanceView==="open")state.maintenanceOpenExpanded=!state.maintenanceOpenExpanded;else{state.maintenanceView="open";state.maintenanceOpenExpanded=true;}}else{state.maintenanceView=next;}render();});});
  	    scope.querySelectorAll("[data-workshop-position-schedule]").forEach(function(button){button.addEventListener("click",function(){openWorkshopIntakeModal(company,vehicle,MAINTENANCE_CATEGORY_SERVICE);});});
  	    scope.querySelectorAll("[data-vm-service-capture]").forEach(function(button){button.addEventListener("click",function(){openCompletedServiceModal(company,vehicle);});});
  	    scope.querySelectorAll("[data-vm-service-setup]").forEach(function(button){button.addEventListener("click",function(){openVehicleServiceSetupModal(company,vehicle,"setup");});});
  	    scope.querySelectorAll("[data-mnt-capture-completed]").forEach(function(button){button.addEventListener("click",function(){openCompletedMaintenanceModal(company,vehicle);});});
  	    scope.querySelectorAll("[data-pm-new]").forEach(function(button){button.addEventListener("click",function(){openPreventivePlanModal(company,vehicle,"");});});
  	    scope.querySelectorAll("[data-pm-edit]").forEach(function(button){button.addEventListener("click",function(){openPreventivePlanModal(company,vehicle,button.getAttribute("data-pm-edit"));});});
  	    scope.querySelectorAll("[data-pm-toggle]").forEach(function(button){button.addEventListener("click",function(){togglePreventivePlan(company,vehicle,button.getAttribute("data-pm-toggle"));});});
  	    scope.querySelectorAll("[data-pm-create-job]").forEach(function(button){button.addEventListener("click",function(){openPreventiveJobModal(company,vehicle,button.getAttribute("data-pm-create-job"));});});
  	    scope.querySelectorAll("[data-pm-open-job]").forEach(function(button){button.addEventListener("click",function(){openServiceJobModal(company,button.getAttribute("data-pm-open-job"),{LockVehicle:true});});});
  	  }

  	  window.FIFDashboard.permissions = {
  	    refresh: function () {
  	      refreshCurrentUserPermissions(true);
  	      normalisePermissionNavigation(selectedCompany());
  	      notifyPermissionConsumers();
  	      render();
  	      return currentPermissionSnapshot();
  	    },
  	    snapshot: currentPermissionSnapshot,
  	    canApp: function (name) { return currentUserHasApp(name); },
  	    canOffice: function (name) { return currentUserHasOffice(name); },
  	    canSetting: function (name) { return currentUserHasSetting(name); },
  	    canMainTab: userCanAccessMainTab,
  	    canVehicleTab: userCanAccessVehicleTab
  	  };

  	  window.FIFDashboard.alerts = {
  	    forVehicle: function (vehicle) {
  	      const company = selectedCompany();
  	      const target = vehicle || selectedVehicle(company);
  	      if (!CAN_ACCESS_ALERTS || !target || !userCanAccessAsset(target)) return [];
  	      return vehicleAlertsForDisplay(company, target, true);
  	    },
  	    openForVehicle: function (vehicle) {
  	      const company = selectedCompany();
  	      const target = vehicle || selectedVehicle(company);
  	      if (CAN_ACCESS_ALERTS && target && userCanAccessAsset(target)) return openVehicleAlertPanel(company, target);
  	      return null;
  	    }
  	  };

  	  window.FIFDashboard.fuel = {
  	    openReport: function (vehicle) {
  	      const company = selectedCompany();
  	      const target = vehicle || selectedVehicle(company);
  	      if (target && CAN_ACCESS_FUEL && userCanAccessAssetFunction(target, "Fuel")) return openVehicleFuelReport(company, target);
  	      return null;
  	    },
  	    openOnRoadCapture: function (vehicle) {
  	      const company = selectedCompany();
  	      const target = vehicle || selectedVehicle(company);
  	      if (target && CAN_CAPTURE_ON_ROAD_FUEL && userCanAccessAssetFunction(target, "Fuel")) return openOnRoadFuelCapture(company, target);
  	      return null;
  	    },
  	    openTracking: function (vehicle, fuelRecord) {
  	      const company = selectedCompany();
  	      const target = vehicle || selectedVehicle(company);
  	      if (!target || !fuelRecord || !CAN_ACCESS_FUEL || !userCanAccessAssetFunction(target, "Fuel")) return null;
  	      const row = fuelRecord.raw ? fuelRecord : fifFuelReportNormalizeRecord(fuelRecord);
  	      return openFuelTrackingWindow(company, target, row);
  	    },
  	    closeTracking: closeFuelTrackingWindow
  	  };

  	  window.FIFDashboard.employees = {
  	    forCompany: function (company) { return CAN_ACCESS_USERS ? companyEmployees(company || selectedCompany()).slice() : []; },
  	    open: function () {
  	      if (!CAN_ACCESS_USERS) return false;
  	      state.activeTab = "employees"; state.selectedVehicleKey = ""; render(); return true;
  	    },
  	    openEmployee: function (employee) {
  	      if (!CAN_ACCESS_USERS) return false;
  	      employeeOpenEditor(selectedCompany(), employee); return true;
  	    }
  	  };

  	  window.FIFDashboard.events = {
  	    forVehicle: function (vehicle) {
  	      const company = selectedCompany();
  	      const target = vehicle || selectedVehicle(company);
  	      if (!CAN_ACCESS_LOCATION_EVENTS || !target || assetIsTrailer(target) || !userCanAccessAsset(target)) return [];
  	      return fifVehicleLocationEvents(company, target);
  	    },
  	    openForVehicle: function (vehicle, periodKey) {
  	      const company = selectedCompany();
  	      const target = vehicle || selectedVehicle(company);
  	      if (!CAN_ACCESS_LOCATION_EVENTS || !target || assetIsTrailer(target) || !userCanAccessAsset(target)) return null;
  	      return openVehicleLocationEvents(company, target, periodKey);
  	    },
  	    reload: async function () {
  	      const company = selectedCompany();
  	      const rows = await fifHydrateCompanyLocationEvents(company, true);
  	      state.locationEventCache = {};
  	      if (!state.destroyed) render();
  	      return rows.slice();
  	    },
  	    debug: function (vehicle) {
  	      const company = selectedCompany();
  	      const target = vehicle || selectedVehicle(company) || tractors(company)[0] || null;
  	      const companyKeyValue = fifLocationEventCompanyKey(company);
  	      return {
  	        version: VERSION,
  	        company: companyName(company),
  	        companyKey: companyKeyValue,
  	        locationCount: fifCompanyLocations(company).length,
  	        locationIds: fifLocationEventLocationIds(company),
  	        databaseRowsLoaded: fifLocationEventDatabaseRows(company).length,
  	        databaseLoaded: !!(state.locationEventDatabaseLoaded && state.locationEventDatabaseLoaded[companyKeyValue]),
  	        databaseLoading: !!(state.locationEventDatabaseLoading && state.locationEventDatabaseLoading[companyKeyValue]),
  	        databaseError: clean(state.locationEventDatabaseError && state.locationEventDatabaseError[companyKeyValue]),
  	        vehicle: target ? vehicleTitleValue(target) : "",
  	        vehicleTokens: target ? fifLocationEventVehicleTokens(target) : [],
  	        matchedEvents: target ? fifVehicleLocationEvents(company, target).length : 0,
  	        currentPeriodMatchedEvents: target ? fifVehicleDashboardEvents(company, target).length : 0
  	      };
  	    }
  	  };

  	  notifyPermissionConsumers();

  	  render();

  	  if (CAN_ACCESS_LOCATION_EVENTS) {
  	    fifSchedulePassiveLocationEventHydration(selectedCompany(), false);
  	  }

  	  return {
  	    ok: true,
  	    version: VERSION,
  	    rootId: ROOT_ID,
  	    destroy: destroy
  	  };
  	})();

  })(App, 'data:image/png;base64,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');

}

})
define('./functions/2bab1b7406627074e9c73f97d5958322/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2bab1b7406627074e9c73f97d5958322'] = async function fn_2bab1b7406627074e9c73f97d5958322(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.initial(array)
})(listToQuery))
}

})
define('./functions/2cdb14e20aec99596e5725c4e3064843/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2cdb14e20aec99596e5725c4e3064843'] = async function fn_2cdb14e20aec99596e5725c4e3064843(AppData, Devices, To, From) {
var Beacon_Data, h, Tracking_Data, Tracking, item, Result, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097'](To)) && (await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097'](From))) {
    Result = (getObjectProperty((getObjectProperty((getObjectProperty((await (async function(devices, to, from) {
    	/**
    	 * GPS - Device Requests (DEV ONLY: hardcoded token)
    	 * Args expected from Codeless:
    	 *   - devices : Array<string>
    	 *   - from    : number|string|null  (optional, Unix seconds)
    	 *   - to      : number|string|null  (optional, Unix seconds)
    	 *
    	 * Returns:
    	 *   { ok:boolean, data:any, error:null|{code:number,message:string} }
    	 *
    	 * SECURITY: This hardcodes your Flespi token. Use only in dev.
    	 * Move to Backendless Third Party API Keys ASAP.
    	 */
    	
    	/* =======================
    	   CONFIG — paste token here
    	   ======================= */
    	const AUTH_TOKEN = "FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW"; // raw token, no "FlespiToken " prefix
    	
    	// ---------- helpers ----------
    	function toNumOrNull(v) {
    	  if (v === "" || v === null || typeof v === "undefined") return null;
    	  const n = Number(v);
    	  return Number.isFinite(n) ? n : null;
    	}
    	
    	function normalizeDevices(list) {
    	  const flat = [];
    	  const stack = Array.isArray(list) ? [...list] : [];
    	  while (stack.length) {
    	    const x = stack.shift();
    	    if (Array.isArray(x)) stack.push(...x);
    	    else if (x !== null && typeof x !== "undefined") {
    	      const s = String(x).trim();
    	      if (s) flat.push(s);
    	    }
    	  }
    	  return Array.from(new Set(flat)); // dedupe
    	}
    	
    	function buildUrl(path, dataObj) {
    	  const dataStr = encodeURIComponent(JSON.stringify(dataObj || {}));
    	  return `https://flespi.io/gw/${path}?data=${dataStr}`;
    	}
    	
    	async function getJson(url, headers) {
    	  const r = await fetch(url, { method: "GET", headers });
    	  if (!r.ok) {
    	    const t = await r.text().catch(() => "");
    	    return { ok: false, status: r.status, body: t };
    	  }
    	  const body = await r.json().catch(() => ({}));
    	  return { ok: true, status: r.status, body };
    	}
    	
    	// ---------- main (return the promise) ----------
    	return (async () => {
    	  try {
    	    // Build Authorization header from hardcoded token
    	    const authHeader = AUTH_TOKEN
    	      ? (AUTH_TOKEN.startsWith("FlespiToken ") ? AUTH_TOKEN : "FlespiToken " + AUTH_TOKEN)
    	      : "";
    	
    	    if (!authHeader) {
    	      return { ok: false, data: null, error: { code: 401, message: "Missing hardcoded Flespi token." } };
    	    }
    	
    	    const devs = normalizeDevices(devices);
    	    if (!devs.length) {
    	      return { ok: false, data: null, error: { code: 400, message: "devices must be a non-empty list" } };
    	    }
    	
    	    const fromNum = toNumOrNull(from);
    	    const toNum   = toNumOrNull(to);
    	
    	    const headers = {
    	      "Content-Type": "application/json",
    	      "Authorization": authHeader
    	    };
    	
    	    const useRange = Number.isFinite(fromNum) && Number.isFinite(toNum);
    	
    	    if (useRange) {
    	      // RANGE MODE: per-device concurrently
    	      const tasks = devs.map(async (dev) => {
    	        const url = buildUrl(`devices/${dev}/messages`, { from: fromNum, to: toNum });
    	        try {
    	          const { ok, status, body } = await getJson(url, headers);
    	          return ok
    	            ? { device: dev, result: body }
    	            : { device: dev, error: { code: status, message: typeof body === "string" ? body : JSON.stringify(body) } };
    	        } catch (e) {
    	          return { device: dev, error: { code: 500, message: e?.message || "fetch failed" } };
    	        }
    	      });
    	
    	      const results = await Promise.all(tasks);
    	      return { ok: true, data: { mode: "range", results }, error: null };
    	    }
    	
    	    // LATEST MODE: one call for all devices (count=1, reverse=true)
    	    const csv = devs.join(",");
    	    const url = buildUrl(`devices/${csv}/messages`, { count: 1, reverse: true });
    	    const { ok, status, body } = await getJson(url, headers);
    	    if (!ok) {
    	      return { ok: false, data: null, error: { code: status, message: typeof body === "string" ? body : JSON.stringify(body) } };
    	    }
    	    return { ok: true, data: { mode: "latest", results: body }, error: null };
    	
    	  } catch (e) {
    	    return { ok: false, data: null, error: { code: 500, message: e?.message || "Internal error" } };
    	  }
    	})();

    })(Devices, null, null)), 'data')), 'results')), 'result'));
    try {
      var j_list = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        var h_list = (getObjectProperty(j, 'Tractors'));
        for (var h_index in h_list) {
          h = h_list[h_index];
          try {
            h['Location'] = (await asyncListFind(Result, async (item) => {


             return ((getObjectProperty(item, 'device.id')) == (getObjectProperty(h, 'Tracker')));
            }));

          } catch (error) {

          }
          try {
            (getObjectProperty(h, 'Location'))['GPSWarnings'] = ({ [`Speed`]: (getObjectProperty((getObjectProperty(h, 'Location')), 'position.speed')) >= (getObjectProperty((getObjectProperty(h, 'CAN')), 'Speed')),[`RPM`]: (getObjectProperty((getObjectProperty(h, 'Location')), 'can.engine.rpm')) >= (getObjectProperty((getObjectProperty(h, 'CAN')), 'RPM')),[`Temp`]: (getObjectProperty((getObjectProperty(h, 'Location')), 'can.engine.temperature')) >= (getObjectProperty((getObjectProperty(h, 'CAN')), 'Temp')) });

          } catch (error) {

          }
        }
      }

    } catch (error) {

    }
  } else {
    Result = (getObjectProperty((getObjectProperty((await (async function(devices, to, from) {
    	/**
    	 * GPS - Device Requests (DEV ONLY: hardcoded token)
    	 * Args expected from Codeless:
    	 *   - devices : Array<string>
    	 *   - from    : number|string|null  (optional, Unix seconds)
    	 *   - to      : number|string|null  (optional, Unix seconds)
    	 *
    	 * Returns:
    	 *   { ok:boolean, data:any, error:null|{code:number,message:string} }
    	 *
    	 * SECURITY: This hardcodes your Flespi token. Use only in dev.
    	 * Move to Backendless Third Party API Keys ASAP.
    	 */
    	
    	/* =======================
    	   CONFIG — paste token here
    	   ======================= */
    	const AUTH_TOKEN = "FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW"; // raw token, no "FlespiToken " prefix
    	
    	// ---------- helpers ----------
    	function toNumOrNull(v) {
    	  if (v === "" || v === null || typeof v === "undefined") return null;
    	  const n = Number(v);
    	  return Number.isFinite(n) ? n : null;
    	}
    	
    	function normalizeDevices(list) {
    	  const flat = [];
    	  const stack = Array.isArray(list) ? [...list] : [];
    	  while (stack.length) {
    	    const x = stack.shift();
    	    if (Array.isArray(x)) stack.push(...x);
    	    else if (x !== null && typeof x !== "undefined") {
    	      const s = String(x).trim();
    	      if (s) flat.push(s);
    	    }
    	  }
    	  return Array.from(new Set(flat)); // dedupe
    	}
    	
    	function buildUrl(path, dataObj) {
    	  const dataStr = encodeURIComponent(JSON.stringify(dataObj || {}));
    	  return `https://flespi.io/gw/${path}?data=${dataStr}`;
    	}
    	
    	async function getJson(url, headers) {
    	  const r = await fetch(url, { method: "GET", headers });
    	  if (!r.ok) {
    	    const t = await r.text().catch(() => "");
    	    return { ok: false, status: r.status, body: t };
    	  }
    	  const body = await r.json().catch(() => ({}));
    	  return { ok: true, status: r.status, body };
    	}
    	
    	// ---------- main (return the promise) ----------
    	return (async () => {
    	  try {
    	    // Build Authorization header from hardcoded token
    	    const authHeader = AUTH_TOKEN
    	      ? (AUTH_TOKEN.startsWith("FlespiToken ") ? AUTH_TOKEN : "FlespiToken " + AUTH_TOKEN)
    	      : "";
    	
    	    if (!authHeader) {
    	      return { ok: false, data: null, error: { code: 401, message: "Missing hardcoded Flespi token." } };
    	    }
    	
    	    const devs = normalizeDevices(devices);
    	    if (!devs.length) {
    	      return { ok: false, data: null, error: { code: 400, message: "devices must be a non-empty list" } };
    	    }
    	
    	    const fromNum = toNumOrNull(from);
    	    const toNum   = toNumOrNull(to);
    	
    	    const headers = {
    	      "Content-Type": "application/json",
    	      "Authorization": authHeader
    	    };
    	
    	    const useRange = Number.isFinite(fromNum) && Number.isFinite(toNum);
    	
    	    // ============================================================
    	    // RANGE MODE: per-device concurrently + fallback to latest
    	    // ============================================================
    	    if (useRange) {
    	      const tasks = devs.map(async (dev) => {
    	        const urlRange = buildUrl(`devices/${dev}/messages`, { from: fromNum, to: toNum });
    	        try {
    	          const { ok, status, body } = await getJson(urlRange, headers);
    	
    	          // Check if we got tracking data in range
    	          const results = body?.result || body?.results || body?.messages || [];
    	          if (ok && Array.isArray(results) && results.length > 0) {
    	            return { device: dev, result: body };
    	          }
    	
    	          // --- Fallback: fetch last message ---
    	          const urlLatest = buildUrl(`devices/${dev}/messages`, { count: 1, reverse: true });
    	          const latest = await getJson(urlLatest, headers);
    	          if (latest.ok) {
    	            return { device: dev, result: latest.body, fallback: true };
    	          } else {
    	            return {
    	              device: dev,
    	              error: { code: latest.status, message: "No tracking data or fallback failed" }
    	            };
    	          }
    	
    	        } catch (e) {
    	          return { device: dev, error: { code: 500, message: e?.message || "fetch failed" } };
    	        }
    	      });
    	
    	      const results = await Promise.all(tasks);
    	      return { ok: true, data: { mode: "range+fallback", results }, error: null };
    	    }
    	
    	    // ============================================================
    	    // LATEST MODE: single call for all devices (count=1, reverse=true)
    	    // ============================================================
    	    const csv = devs.join(",");
    	    const url = buildUrl(`devices/${csv}/messages`, { count: 1, reverse: true });
    	    const { ok, status, body } = await getJson(url, headers);
    	    if (!ok) {
    	      return { ok: false, data: null, error: { code: status, message: typeof body === "string" ? body : JSON.stringify(body) } };
    	    }
    	
    	    return { ok: true, data: { mode: "latest", results: body }, error: null };
    	
    	  } catch (e) {
    	    return { ok: false, data: null, error: { code: 500, message: e?.message || "Internal error" } };
    	  }
    	})();

    })([Devices], ((To.valueOf()) / 1000), ((From.valueOf()) / 1000))), 'data')), 'results'));
    try {
      var j_list2 = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        var h_list2 = (getObjectProperty(j, 'Tractors'));
        for (var h_index2 in h_list2) {
          h = h_list2[h_index2];
          try {
            Tracking = (await asyncListFind(Result, async (item) => {


             return ((getObjectProperty(item, 'device')) == (getObjectProperty(h, 'Tracker')));
            }));

          } catch (error) {

          }
          try {
            Beacon_Data = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty(Tracking, 'result')), 'result')), async (item) => {


             return (Array.isArray((getObjectProperty(item, 'ble.beacons'))));
            })), async (item) => {


             return ((getObjectProperty(item, 'ble.beacons')).length != 0);
            }));

          } catch (error) {

          }
          try {
            Tracking_Data = (getObjectProperty((getObjectProperty(Tracking, 'result')), 'result'));

          } catch (error) {

          }
          try {
            if (Tracking_Data.length > 0) {
              try {
                h['Tracking'] = Tracking_Data;

              } catch (error) {

              }
              try {
                (getObjectProperty(AppData, 'SelectedTractor'))['Tracking'] = Tracking_Data;

              } catch (error) {

              }
              try {
                h['Beacons'] = Beacon_Data;

              } catch (error) {

              }
              try {
                (getObjectProperty(AppData, 'SelectedTractor'))['Beacons'] = Beacon_Data;

              } catch (error) {

              }
            } else {
              try {
                h['Tracking'] = Beacon_Data;

              } catch (error) {

              }
              try {
                (getObjectProperty(AppData, 'SelectedTractor'))['Tracking'] = Beacon_Data;

              } catch (error) {

              }
              try {
                h['Beacons'] = Beacon_Data;

              } catch (error) {

              }
              try {
                (getObjectProperty(AppData, 'SelectedTractor'))['Beacons'] = Beacon_Data;

              } catch (error) {

              }
            }

          } catch (error) {

          }
        }
      }

    } catch (error) {

    }
  }

}

})
define('./functions/302f8a0eaf0351f7bd6ef7c44ea2db0e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_302f8a0eaf0351f7bd6ef7c44ea2db0e'] = async function fn_302f8a0eaf0351f7bd6ef7c44ea2db0e(APP, User, PageData, AppData) {
var item, Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

/**
 * Describe this function...
 */
async function Office() {
  if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097'](((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((getObjectProperty(User, 'Local_Key'))))))) {
    localStorage.setItem((getObjectProperty(User, 'Local_Key')), JSON.stringify(({ [`Lets See this Work`]: (generateUUID().short()) })));
  } else {
    await BackendlessUI.Functions.Custom['fn_2cdb14e20aec99596e5725c4e3064843'](AppData, (await Promise.all((getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies')).map(async item => {; return (await Promise.all((getObjectProperty(item, 'Tractors')).map(async Tractor => {; return (getObjectProperty(Tractor, 'Tracker'));})));}))), null, null);
    await (async function(App, Tractors) {
    	/*
    	 * Fleet In Form
    	 * ASYNCHRONOUS Login Vehicle Report Loader
    	 *
    	 * IMPORTANT:
    	 * - NEVER blocks login.
    	 * - NEVER throws into the login procedure.
    	 * - ALL network / parsing / Backendless errors are contained.
    	 * - Reports are populated onto Tractor objects in the background.
    	 *
    	 * Tractor.Reports = {
    	 *   Today: "2026-08-29",
    	 *   Date: "2026-08-28",
    	 *   Month: "2026-08",
    	 *   Loading: true,
    	 *   Loaded: false,
    	 *   Current: null,
    	 *   Daily: null,
    	 *   Monthly: null,
    	 *   Availability: {
    	 *     Current: false,
    	 *     Daily: false,
    	 *     Monthly: false
    	 *   }
    	 * }
    	 */


    	/* =========================================================
    	   SAFE OUTER WRAPPER

    	   Even a synchronous programming/data error must NEVER
    	   prevent Login from continuing.
    	   ========================================================= */

    	try {

    	  /* =======================================================
    	     NORMALISE TRACTORS
    	     ======================================================= */

    	  const tractorList =
    	    (Array.isArray(Tractors) ? Tractors : [])
    	      .flat(Infinity)
    	      .filter(
    	        tractor =>
    	          tractor &&
    	          typeof tractor === "object"
    	      );


    	  /* =======================================================
    	     DETERMINE REPORT DATE SYNCHRONOUSLY

    	     This is deliberately done before launching the async
    	     worker so Tractor.Reports exists immediately.
    	     ======================================================= */

    	  let todayDate = null;
    	  let reportDate = null;
    	  let reportMonth = null;

    	  try {
    	    const now =
    	      new Date();

    	    const parts =
    	      new Intl.DateTimeFormat(
    	        "en-CA",
    	        {
    	          timeZone:
    	            "Africa/Johannesburg",

    	          year:
    	            "numeric",

    	          month:
    	            "2-digit",

    	          day:
    	            "2-digit"
    	        }
    	      )
    	        .formatToParts(now);

    	    const sast = {};

    	    for (const part of parts) {
    	      if (
    	        part.type === "year" ||
    	        part.type === "month" ||
    	        part.type === "day"
    	      ) {
    	        sast[part.type] =
    	          Number(part.value);
    	      }
    	    }

    	    const todayYear =
    	      sast.year;

    	    const todayMonth =
    	      String(
    	        sast.month
    	      )
    	        .padStart(
    	          2,
    	          "0"
    	        );

    	    const todayDay =
    	      String(
    	        sast.day
    	      )
    	        .padStart(
    	          2,
    	          "0"
    	        );

    	    todayDate =
    	      `${todayYear}-${todayMonth}-${todayDay}`;


    	    const yesterday =
    	      new Date(
    	        Date.UTC(
    	          sast.year,
    	          sast.month - 1,
    	          sast.day,
    	          12
    	        ) -
    	        86400000
    	      );

    	    const year =
    	      yesterday
    	        .getUTCFullYear();

    	    const month =
    	      String(
    	        yesterday
    	          .getUTCMonth() + 1
    	      )
    	        .padStart(
    	          2,
    	          "0"
    	        );

    	    const day =
    	      String(
    	        yesterday
    	          .getUTCDate()
    	      )
    	        .padStart(
    	          2,
    	          "0"
    	        );

    	    reportDate =
    	      `${year}-${month}-${day}`;

    	    reportMonth =
    	      `${year}-${month}`;

    	  } catch (dateError) {
    	    console.warn(
    	      "[FIF Reports] Could not determine report date.",
    	      dateError
    	    );
    	  }


    	  /* =======================================================
    	     GROUP TRACTORS BY TRACKER
    	     ======================================================= */

    	  const tractorsByTracker =
    	    new Map();

    	  for (const tractor of tractorList) {

    	    try {
    	      const tracker =
    	        String(
    	          tractor?.Tracker ||
    	          ""
    	        )
    	          .trim();

    	      if (!tracker) {
    	        continue;
    	      }

    	      if (
    	        !tractorsByTracker.has(
    	          tracker
    	        )
    	      ) {
    	        tractorsByTracker.set(
    	          tracker,
    	          []
    	        );
    	      }

    	      tractorsByTracker
    	        .get(tracker)
    	        .push(tractor);


    	      /*
    	       * Create the report container NOW.
    	       *
    	       * This happens before any network activity, meaning
    	       * Snapshot/Office can safely inspect Tractor.Reports
    	       * even while the download is still running.
    	       */
    	      tractor.Reports = {
    	        Today:
    	          todayDate,

    	        Date:
    	          reportDate,

    	        Month:
    	          reportMonth,

    	        Loading:
    	          true,

    	        Loaded:
    	          false,

    	        Current:
    	          null,

    	        Daily:
    	          null,

    	        Monthly:
    	          null,

    	        Availability: {
    	          Current:
    	            false,

    	          Daily:
    	            false,

    	          Monthly:
    	            false
    	        },

    	        Errors: []
    	      };

    	    } catch (tractorError) {
    	      console.warn(
    	        "[FIF Reports] Tractor initialisation skipped.",
    	        tractorError
    	      );
    	    }
    	  }


    	  /* =======================================================
    	     BACKGROUND TASK

    	     CRITICAL:
    	     There is deliberately NO await here.

    	     Login continues immediately.
    	     ======================================================= */

    	  void (async function loadVehicleReportsInBackground() {

    	    const errors = [];

    	    try {

    	      /* ===================================================
    	         USER TOKEN

    	         This may take time. That no longer matters because
    	         Login is already free to continue.
    	         =================================================== */

    	      let userToken = null;

    	      try {
    	        userToken =
    	          await Backendless
    	            .UserService
    	            .getCurrentUserToken();

    	      } catch (tokenError) {
    	        errors.push({
    	          stage:
    	            "user_token",

    	          error:
    	            tokenError?.message ||
    	            String(tokenError)
    	        });

    	        console.warn(
    	          "[FIF Reports] User token lookup failed.",
    	          tokenError
    	        );
    	      }


    	      if (!userToken) {

    	        for (
    	          const tractorCopies
    	          of tractorsByTracker.values()
    	        ) {
    	          for (
    	            const vehicle
    	            of tractorCopies
    	          ) {
    	            if (!vehicle.Reports) {
    	              continue;
    	            }

    	            vehicle.Reports.Loading =
    	              false;

    	            vehicle.Reports.Loaded =
    	              false;

    	            vehicle.Reports.Errors.push({
    	              error:
    	                "NO_USER_TOKEN"
    	            });
    	          }
    	        }

    	        console.warn(
    	          "[FIF Reports] Background loading stopped: no Backendless user token."
    	        );

    	        return;
    	      }


    	      /* ===================================================
    	         BUILD DOWNLOAD JOBS

    	         Only download URLs which actually exist in
    	         ViewC.Reports.
    	         =================================================== */

    	      const jobs = [];

    	      for (
    	        const [
    	          tracker,
    	          tractorCopies
    	        ]
    	        of tractorsByTracker
    	      ) {

    	        try {

    	          /* ===============================================
    	             CURRENT DAY

    	             Live report from SAST midnight to the latest
    	             calculated interval.

    	             This does NOT use ViewC.Reports because the
    	             current report is not persisted to R2.
    	             =============================================== */

    	          jobs.push({
    	            tracker:
    	              tracker,

    	            type:
    	              "Current",

    	            url:
    	              "https://fif-daily-report-exporter.raymondewoodley.workers.dev/current-reports/" +
    	              encodeURIComponent(
    	                tracker
    	              )
    	          });


    	          const tractor =
    	            tractorCopies[0];

    	          let viewC =
    	            tractor?.ViewC ??
    	            tractor?.viewC ??
    	            null;

    	          if (
    	            Array.isArray(viewC)
    	          ) {
    	            viewC =
    	              viewC[0] ||
    	              null;
    	          }


    	          if (
    	            !viewC ||
    	            typeof viewC !==
    	              "object"
    	          ) {

    	            for (
    	              const vehicle
    	              of tractorCopies
    	            ) {
    	              vehicle
    	                ?.Reports
    	                ?.Errors
    	                ?.push({
    	                  error:
    	                    "VIEWC_UNAVAILABLE"
    	                });
    	            }

    	            continue;
    	          }


    	          let reportIndex =
    	            viewC?.Reports ??
    	            viewC?.reports ??
    	            {};


    	          /*
    	           * Tolerate Backendless returning the JSON column
    	           * as a string.
    	           */
    	          if (
    	            typeof reportIndex ===
    	              "string"
    	          ) {
    	            try {
    	              reportIndex =
    	                JSON.parse(
    	                  reportIndex
    	                );

    	            } catch (jsonError) {

    	              for (
    	                const vehicle
    	                of tractorCopies
    	              ) {
    	                vehicle
    	                  ?.Reports
    	                  ?.Errors
    	                  ?.push({
    	                    error:
    	                      "INVALID_VIEWC_REPORTS_JSON"
    	                  });
    	              }

    	              continue;
    	            }
    	          }


    	          /* ===============================================
    	             DAILY
    	             =============================================== */

    	          const dailyPointer =
    	            reportIndex
    	              ?.daily
    	              ?.[reportDate] ??
    	            null;

    	          if (
    	            dailyPointer?.url
    	          ) {

    	            for (
    	              const vehicle
    	              of tractorCopies
    	            ) {
    	              if (
    	                vehicle?.Reports
    	              ) {
    	                vehicle
    	                  .Reports
    	                  .Availability
    	                  .Daily =
    	                  true;
    	              }
    	            }

    	            jobs.push({
    	              tracker:
    	                tracker,

    	              type:
    	                "Daily",

    	              url:
    	                dailyPointer.url
    	            });
    	          }


    	          /* ===============================================
    	             MONTHLY
    	             =============================================== */

    	          const monthlyPointer =
    	            reportIndex
    	              ?.monthly
    	              ?.[reportMonth] ??
    	            null;

    	          if (
    	            monthlyPointer?.url
    	          ) {

    	            for (
    	              const vehicle
    	              of tractorCopies
    	            ) {
    	              if (
    	                vehicle?.Reports
    	              ) {
    	                vehicle
    	                  .Reports
    	                  .Availability
    	                  .Monthly =
    	                  true;
    	              }
    	            }

    	            jobs.push({
    	              tracker:
    	                tracker,

    	              type:
    	                "Monthly",

    	              url:
    	                monthlyPointer.url
    	            });
    	          }

    	        } catch (jobError) {

    	          errors.push({
    	            tracker:
    	              tracker,

    	            stage:
    	              "build_jobs",

    	            error:
    	              jobError?.message ||
    	              String(jobError)
    	          });

    	          /*
    	           * Continue with every other vehicle.
    	           */
    	          continue;
    	        }
    	      }


    	      /* ===================================================
    	         PARALLEL DOWNLOAD WORKERS
    	         =================================================== */

    	      let nextJob =
    	        0;

    	      const concurrency =
    	        8;


    	      async function downloadWorker() {

    	        /*
    	         * This worker itself is protected so a completely
    	         * unexpected failure cannot reject Promise.all.
    	         */
    	        try {

    	          while (true) {

    	            const index =
    	              nextJob++;

    	            if (
    	              index >=
    	              jobs.length
    	            ) {
    	              return;
    	            }

    	            const job =
    	              jobs[index];


    	            try {

    	              /* ===========================================
    	                 FETCH WITH TIMEOUT

    	                 We do not want a dead connection hanging
    	                 around indefinitely.
    	                 =========================================== */

    	              const controller =
    	                new AbortController();

    	              const timeoutId =
    	                setTimeout(
    	                  function () {
    	                    try {
    	                      controller.abort();
    	                    } catch (_) {}
    	                  },
    	                  15000
    	                );


    	              let response;

    	              try {

    	                response =
    	                  await fetch(
    	                    job.url,
    	                    {
    	                      method:
    	                        "GET",

    	                      headers: {
    	                        "Accept":
    	                          "application/json",

    	                        "user-token":
    	                          userToken
    	                      },

    	                      signal:
    	                        controller.signal
    	                    }
    	                  );

    	              } finally {

    	                clearTimeout(
    	                  timeoutId
    	                );
    	              }


    	              /*
    	               * A Current report can legitimately be absent when
    	               * a vehicle has supplied no telemetry today.
    	               *
    	               * This is NOT an application/login error.
    	               */
    	              if (
    	                response.status === 404 &&
    	                job.type === "Current"
    	              ) {
    	                continue;
    	              }


    	              if (
    	                !response.ok
    	              ) {
    	                throw new Error(
    	                  `HTTP ${response.status}`
    	                );
    	              }


    	              let report;

    	              try {
    	                report =
    	                  await response.json();

    	              } catch (_) {
    	                throw new Error(
    	                  "INVALID_REPORT_JSON"
    	                );
    	              }


    	              /* ===========================================
    	                 STAMP EVERY COPY OF THIS TRACTOR
    	                 =========================================== */

    	              const vehicleCopies =
    	                tractorsByTracker
    	                  .get(
    	                    job.tracker
    	                  ) ||
    	                [];


    	              for (
    	                const vehicle
    	                of vehicleCopies
    	              ) {

    	                try {

    	                  if (
    	                    !vehicle ||
    	                    !vehicle.Reports
    	                  ) {
    	                    continue;
    	                  }


    	                  vehicle
    	                    .Reports[
    	                      job.type
    	                    ] =
    	                    report;


    	                  /*
    	                   * Daily and Monthly Availability are still set
    	                   * earlier from their ViewC pointers exactly as
    	                   * before.
    	                   *
    	                   * Current has no pointer, so successful download
    	                   * is what proves availability.
    	                   */
    	                  if (
    	                    job.type ===
    	                      "Current"
    	                  ) {
    	                    vehicle
    	                      .Reports
    	                      .Availability
    	                      .Current =
    	                      true;
    	                  }

    	                } catch (stampError) {

    	                  errors.push({
    	                    tracker:
    	                      job.tracker,

    	                    type:
    	                      job.type,

    	                    stage:
    	                      "stamp_report",

    	                    error:
    	                      stampError?.message ||
    	                      String(stampError)
    	                  });
    	                }
    	              }


    	            } catch (downloadError) {

    	              const errorRecord = {
    	                tracker:
    	                  job?.tracker ??
    	                  null,

    	                type:
    	                  job?.type ??
    	                  null,

    	                stage:
    	                  "download",

    	                error:
    	                  downloadError?.name ===
    	                  "AbortError"
    	                    ? "TIMEOUT"
    	                    : (
    	                        downloadError
    	                          ?.message ||
    	                        String(
    	                          downloadError
    	                        )
    	                      )
    	              };


    	              errors.push(
    	                errorRecord
    	              );


    	              /*
    	               * Record the failure against the relevant
    	               * Tractor, but NEVER throw it further.
    	               */
    	              const vehicleCopies =
    	                tractorsByTracker
    	                  .get(
    	                    job?.tracker
    	                  ) ||
    	                [];


    	              for (
    	                const vehicle
    	                of vehicleCopies
    	              ) {

    	                try {

    	                  vehicle
    	                    ?.Reports
    	                    ?.Errors
    	                    ?.push(
    	                      errorRecord
    	                    );

    	                } catch (_) {}
    	              }
    	            }
    	          }

    	        } catch (workerError) {

    	          /*
    	           * Absolute final protection for the worker.
    	           */
    	          errors.push({
    	            stage:
    	              "download_worker",

    	            error:
    	              workerError?.message ||
    	              String(workerError)
    	          });

    	          console.warn(
    	            "[FIF Reports] Background worker failed safely.",
    	            workerError
    	          );
    	        }
    	      }


    	      /*
    	       * Promise.allSettled instead of Promise.all.
    	       *
    	       * Even if one worker somehow rejects, the remaining
    	       * workers are allowed to complete.
    	       */
    	      const workerCount =
    	        Math.min(
    	          concurrency,
    	          Math.max(
    	            jobs.length,
    	            1
    	          )
    	        );


    	      await Promise.allSettled(
    	        Array.from(
    	          {
    	            length:
    	              workerCount
    	          },

    	          function () {
    	            return downloadWorker();
    	          }
    	        )
    	      );


    	      /* ===================================================
    	         MARK REPORT OBJECTS COMPLETE
    	         =================================================== */

    	      for (
    	        const tractorCopies
    	        of tractorsByTracker.values()
    	      ) {

    	        for (
    	          const vehicle
    	          of tractorCopies
    	        ) {

    	          try {

    	            if (
    	              !vehicle?.Reports
    	            ) {
    	              continue;
    	            }

    	            vehicle.Reports.Loading =
    	              false;

    	            vehicle.Reports.Loaded =
    	              true;

    	            vehicle.Reports.LoadedAt =
    	              new Date()
    	                .toISOString();

    	          } catch (_) {}
    	        }
    	      }


    	      console.log(
    	        "[FIF Reports] Background vehicle reports loaded",
    	        {
    	          todayDate:
    	            todayDate,

    	          reportDate:
    	            reportDate,

    	          reportMonth:
    	            reportMonth,

    	          vehicles:
    	            tractorsByTracker.size,

    	          downloads:
    	            jobs.length,

    	          errors:
    	            errors.length
    	        }
    	      );


    	      /* ===================================================
    	         OPTIONAL APPLICATION EVENT

    	         Snapshot/Office can listen for this later if we want
    	         the UI to redraw the instant reports arrive.
    	         =================================================== */

    	      try {

    	        window.dispatchEvent(
    	          new CustomEvent(
    	            "fif:vehicle-reports-loaded",
    	            {
    	              detail: {
    	                todayDate:
    	                  todayDate,

    	                reportDate:
    	                  reportDate,

    	                reportMonth:
    	                  reportMonth,

    	                vehicles:
    	                  tractorsByTracker.size,

    	                downloads:
    	                  jobs.length,

    	                errors:
    	                  errors.length
    	              }
    	            }
    	          )
    	        );

    	      } catch (_) {}


    	    } catch (backgroundError) {

    	      /*
    	       * FINAL BACKGROUND SAFETY NET.
    	       *
    	       * Nothing is allowed to escape this async task as an
    	       * unhandled Promise rejection.
    	       */

    	      console.warn(
    	        "[FIF Reports] Background loader failed safely.",
    	        backgroundError
    	      );


    	      try {

    	        for (
    	          const tractorCopies
    	          of tractorsByTracker.values()
    	        ) {

    	          for (
    	            const vehicle
    	            of tractorCopies
    	          ) {

    	            if (
    	              !vehicle?.Reports
    	            ) {
    	              continue;
    	            }

    	            vehicle.Reports.Loading =
    	              false;

    	            vehicle.Reports.Loaded =
    	              false;

    	            vehicle.Reports.Errors.push({
    	              error:
    	                backgroundError
    	                  ?.message ||
    	                String(
    	                  backgroundError
    	                )
    	            });
    	          }
    	        }

    	      } catch (_) {}
    	    }

    	  })()
    	    .catch(
    	      function (unexpectedError) {

    	        /*
    	         * Belt-and-braces protection.
    	         *
    	         * Because this is a detached Promise, explicitly
    	         * consume any impossible final rejection.
    	         */
    	        console.warn(
    	          "[FIF Reports] Detached loader rejection contained.",
    	          unexpectedError
    	        );
    	      }
    	    );


    	  /* =======================================================
    	     RETURN TO LOGIN IMMEDIATELY

    	     No report request has to finish before this return.
    	     ======================================================= */

    	  return {
    	    success:
    	      true,

    	    started:
    	      true,

    	    background:
    	      true,

    	    todayDate:
    	      todayDate,

    	    reportDate:
    	      reportDate,

    	    reportMonth:
    	      reportMonth,

    	    vehicles:
    	      tractorsByTracker.size
    	  };


    	} catch (fatalSetupError) {

    	  /*
    	   * ABSOLUTE OUTER SAFETY NET.
    	   *
    	   * Even malformed Tractor data or an unexpected JS issue
    	   * must never prevent login/navigation.
    	   */

    	  console.warn(
    	    "[FIF Reports] Loader setup failed safely. Login will continue.",
    	    fatalSetupError
    	  );


    	  return {
    	    success:
    	      false,

    	    started:
    	      false,

    	    background:
    	      false,

    	    error:
    	      fatalSetupError
    	        ?.message ||
    	      String(
    	        fatalSetupError
    	      )
    	  };
    	}
    })(APP, (await Promise.all((getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies')).map(async item => {; return (getObjectProperty(item, 'Tractors'));}))));
  }
  AppData['APP'] = APP;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Office', undefined);
}

/**
 * Describe this function...
 */
async function Mobile_Tracking() {
  AppData['APP'] = APP;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MobileTracking', undefined);
}

/**
 * Describe this function...
 */
async function Road() {
  AppData['APP'] = APP;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Road', undefined);
}

/**
 * Describe this function...
 */
async function Bowser() {
  AppData['APP'] = APP;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Bowser', undefined);
}

/**
 * Describe this function...
 */
async function Snapshot() {
  if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097'](((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((getObjectProperty(User, 'Local_Key'))))))) {
    localStorage.setItem((getObjectProperty(User, 'Local_Key')), JSON.stringify(({ [`Lets See this Work`]: (generateUUID().short()) })));
  } else {
    await BackendlessUI.Functions.Custom['fn_2cdb14e20aec99596e5725c4e3064843'](AppData, (await Promise.all((getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies')).map(async item => {; return (await Promise.all((getObjectProperty(item, 'Tractors')).map(async Tractor => {; return (getObjectProperty(Tractor, 'Tracker'));})));}))), null, null);
    await (async function(App, Tractors) {
    	/*
    	 * Fleet In Form
    	 * ASYNCHRONOUS Login Vehicle Report Loader
    	 *
    	 * IMPORTANT:
    	 * - NEVER blocks login.
    	 * - NEVER throws into the login procedure.
    	 * - ALL network / parsing / Backendless errors are contained.
    	 * - Reports are populated onto Tractor objects in the background.
    	 *
    	 * Tractor.Reports = {
    	 *   Today: "2026-08-29",
    	 *   Date: "2026-08-28",
    	 *   Month: "2026-08",
    	 *   Loading: true,
    	 *   Loaded: false,
    	 *   Current: null,
    	 *   Daily: null,
    	 *   Monthly: null,
    	 *   Availability: {
    	 *     Current: false,
    	 *     Daily: false,
    	 *     Monthly: false
    	 *   }
    	 * }
    	 */


    	/* =========================================================
    	   SAFE OUTER WRAPPER

    	   Even a synchronous programming/data error must NEVER
    	   prevent Login from continuing.
    	   ========================================================= */

    	try {

    	  /* =======================================================
    	     NORMALISE TRACTORS
    	     ======================================================= */

    	  const tractorList =
    	    (Array.isArray(Tractors) ? Tractors : [])
    	      .flat(Infinity)
    	      .filter(
    	        tractor =>
    	          tractor &&
    	          typeof tractor === "object"
    	      );


    	  /* =======================================================
    	     DETERMINE REPORT DATE SYNCHRONOUSLY

    	     This is deliberately done before launching the async
    	     worker so Tractor.Reports exists immediately.
    	     ======================================================= */

    	  let todayDate = null;
    	  let reportDate = null;
    	  let reportMonth = null;

    	  try {
    	    const now =
    	      new Date();

    	    const parts =
    	      new Intl.DateTimeFormat(
    	        "en-CA",
    	        {
    	          timeZone:
    	            "Africa/Johannesburg",

    	          year:
    	            "numeric",

    	          month:
    	            "2-digit",

    	          day:
    	            "2-digit"
    	        }
    	      )
    	        .formatToParts(now);

    	    const sast = {};

    	    for (const part of parts) {
    	      if (
    	        part.type === "year" ||
    	        part.type === "month" ||
    	        part.type === "day"
    	      ) {
    	        sast[part.type] =
    	          Number(part.value);
    	      }
    	    }

    	    const todayYear =
    	      sast.year;

    	    const todayMonth =
    	      String(
    	        sast.month
    	      )
    	        .padStart(
    	          2,
    	          "0"
    	        );

    	    const todayDay =
    	      String(
    	        sast.day
    	      )
    	        .padStart(
    	          2,
    	          "0"
    	        );

    	    todayDate =
    	      `${todayYear}-${todayMonth}-${todayDay}`;


    	    const yesterday =
    	      new Date(
    	        Date.UTC(
    	          sast.year,
    	          sast.month - 1,
    	          sast.day,
    	          12
    	        ) -
    	        86400000
    	      );

    	    const year =
    	      yesterday
    	        .getUTCFullYear();

    	    const month =
    	      String(
    	        yesterday
    	          .getUTCMonth() + 1
    	      )
    	        .padStart(
    	          2,
    	          "0"
    	        );

    	    const day =
    	      String(
    	        yesterday
    	          .getUTCDate()
    	      )
    	        .padStart(
    	          2,
    	          "0"
    	        );

    	    reportDate =
    	      `${year}-${month}-${day}`;

    	    reportMonth =
    	      `${year}-${month}`;

    	  } catch (dateError) {
    	    console.warn(
    	      "[FIF Reports] Could not determine report date.",
    	      dateError
    	    );
    	  }


    	  /* =======================================================
    	     GROUP TRACTORS BY TRACKER
    	     ======================================================= */

    	  const tractorsByTracker =
    	    new Map();

    	  for (const tractor of tractorList) {

    	    try {
    	      const tracker =
    	        String(
    	          tractor?.Tracker ||
    	          ""
    	        )
    	          .trim();

    	      if (!tracker) {
    	        continue;
    	      }

    	      if (
    	        !tractorsByTracker.has(
    	          tracker
    	        )
    	      ) {
    	        tractorsByTracker.set(
    	          tracker,
    	          []
    	        );
    	      }

    	      tractorsByTracker
    	        .get(tracker)
    	        .push(tractor);


    	      /*
    	       * Create the report container NOW.
    	       *
    	       * This happens before any network activity, meaning
    	       * Snapshot/Office can safely inspect Tractor.Reports
    	       * even while the download is still running.
    	       */
    	      tractor.Reports = {
    	        Today:
    	          todayDate,

    	        Date:
    	          reportDate,

    	        Month:
    	          reportMonth,

    	        Loading:
    	          true,

    	        Loaded:
    	          false,

    	        Current:
    	          null,

    	        Daily:
    	          null,

    	        Monthly:
    	          null,

    	        Availability: {
    	          Current:
    	            false,

    	          Daily:
    	            false,

    	          Monthly:
    	            false
    	        },

    	        Errors: []
    	      };

    	    } catch (tractorError) {
    	      console.warn(
    	        "[FIF Reports] Tractor initialisation skipped.",
    	        tractorError
    	      );
    	    }
    	  }


    	  /* =======================================================
    	     BACKGROUND TASK

    	     CRITICAL:
    	     There is deliberately NO await here.

    	     Login continues immediately.
    	     ======================================================= */

    	  void (async function loadVehicleReportsInBackground() {

    	    const errors = [];

    	    try {

    	      /* ===================================================
    	         USER TOKEN

    	         This may take time. That no longer matters because
    	         Login is already free to continue.
    	         =================================================== */

    	      let userToken = null;

    	      try {
    	        userToken =
    	          await Backendless
    	            .UserService
    	            .getCurrentUserToken();

    	      } catch (tokenError) {
    	        errors.push({
    	          stage:
    	            "user_token",

    	          error:
    	            tokenError?.message ||
    	            String(tokenError)
    	        });

    	        console.warn(
    	          "[FIF Reports] User token lookup failed.",
    	          tokenError
    	        );
    	      }


    	      if (!userToken) {

    	        for (
    	          const tractorCopies
    	          of tractorsByTracker.values()
    	        ) {
    	          for (
    	            const vehicle
    	            of tractorCopies
    	          ) {
    	            if (!vehicle.Reports) {
    	              continue;
    	            }

    	            vehicle.Reports.Loading =
    	              false;

    	            vehicle.Reports.Loaded =
    	              false;

    	            vehicle.Reports.Errors.push({
    	              error:
    	                "NO_USER_TOKEN"
    	            });
    	          }
    	        }

    	        console.warn(
    	          "[FIF Reports] Background loading stopped: no Backendless user token."
    	        );

    	        return;
    	      }


    	      /* ===================================================
    	         BUILD DOWNLOAD JOBS

    	         Only download URLs which actually exist in
    	         ViewC.Reports.
    	         =================================================== */

    	      const jobs = [];

    	      for (
    	        const [
    	          tracker,
    	          tractorCopies
    	        ]
    	        of tractorsByTracker
    	      ) {

    	        try {

    	          /* ===============================================
    	             CURRENT DAY

    	             Live report from SAST midnight to the latest
    	             calculated interval.

    	             This does NOT use ViewC.Reports because the
    	             current report is not persisted to R2.
    	             =============================================== */

    	          jobs.push({
    	            tracker:
    	              tracker,

    	            type:
    	              "Current",

    	            url:
    	              "https://fif-daily-report-exporter.raymondewoodley.workers.dev/current-reports/" +
    	              encodeURIComponent(
    	                tracker
    	              )
    	          });


    	          const tractor =
    	            tractorCopies[0];

    	          let viewC =
    	            tractor?.ViewC ??
    	            tractor?.viewC ??
    	            null;

    	          if (
    	            Array.isArray(viewC)
    	          ) {
    	            viewC =
    	              viewC[0] ||
    	              null;
    	          }


    	          if (
    	            !viewC ||
    	            typeof viewC !==
    	              "object"
    	          ) {

    	            for (
    	              const vehicle
    	              of tractorCopies
    	            ) {
    	              vehicle
    	                ?.Reports
    	                ?.Errors
    	                ?.push({
    	                  error:
    	                    "VIEWC_UNAVAILABLE"
    	                });
    	            }

    	            continue;
    	          }


    	          let reportIndex =
    	            viewC?.Reports ??
    	            viewC?.reports ??
    	            {};


    	          /*
    	           * Tolerate Backendless returning the JSON column
    	           * as a string.
    	           */
    	          if (
    	            typeof reportIndex ===
    	              "string"
    	          ) {
    	            try {
    	              reportIndex =
    	                JSON.parse(
    	                  reportIndex
    	                );

    	            } catch (jsonError) {

    	              for (
    	                const vehicle
    	                of tractorCopies
    	              ) {
    	                vehicle
    	                  ?.Reports
    	                  ?.Errors
    	                  ?.push({
    	                    error:
    	                      "INVALID_VIEWC_REPORTS_JSON"
    	                  });
    	              }

    	              continue;
    	            }
    	          }


    	          /* ===============================================
    	             DAILY
    	             =============================================== */

    	          const dailyPointer =
    	            reportIndex
    	              ?.daily
    	              ?.[reportDate] ??
    	            null;

    	          if (
    	            dailyPointer?.url
    	          ) {

    	            for (
    	              const vehicle
    	              of tractorCopies
    	            ) {
    	              if (
    	                vehicle?.Reports
    	              ) {
    	                vehicle
    	                  .Reports
    	                  .Availability
    	                  .Daily =
    	                  true;
    	              }
    	            }

    	            jobs.push({
    	              tracker:
    	                tracker,

    	              type:
    	                "Daily",

    	              url:
    	                dailyPointer.url
    	            });
    	          }


    	          /* ===============================================
    	             MONTHLY
    	             =============================================== */

    	          const monthlyPointer =
    	            reportIndex
    	              ?.monthly
    	              ?.[reportMonth] ??
    	            null;

    	          if (
    	            monthlyPointer?.url
    	          ) {

    	            for (
    	              const vehicle
    	              of tractorCopies
    	            ) {
    	              if (
    	                vehicle?.Reports
    	              ) {
    	                vehicle
    	                  .Reports
    	                  .Availability
    	                  .Monthly =
    	                  true;
    	              }
    	            }

    	            jobs.push({
    	              tracker:
    	                tracker,

    	              type:
    	                "Monthly",

    	              url:
    	                monthlyPointer.url
    	            });
    	          }

    	        } catch (jobError) {

    	          errors.push({
    	            tracker:
    	              tracker,

    	            stage:
    	              "build_jobs",

    	            error:
    	              jobError?.message ||
    	              String(jobError)
    	          });

    	          /*
    	           * Continue with every other vehicle.
    	           */
    	          continue;
    	        }
    	      }


    	      /* ===================================================
    	         PARALLEL DOWNLOAD WORKERS
    	         =================================================== */

    	      let nextJob =
    	        0;

    	      const concurrency =
    	        8;


    	      async function downloadWorker() {

    	        /*
    	         * This worker itself is protected so a completely
    	         * unexpected failure cannot reject Promise.all.
    	         */
    	        try {

    	          while (true) {

    	            const index =
    	              nextJob++;

    	            if (
    	              index >=
    	              jobs.length
    	            ) {
    	              return;
    	            }

    	            const job =
    	              jobs[index];


    	            try {

    	              /* ===========================================
    	                 FETCH WITH TIMEOUT

    	                 We do not want a dead connection hanging
    	                 around indefinitely.
    	                 =========================================== */

    	              const controller =
    	                new AbortController();

    	              const timeoutId =
    	                setTimeout(
    	                  function () {
    	                    try {
    	                      controller.abort();
    	                    } catch (_) {}
    	                  },
    	                  15000
    	                );


    	              let response;

    	              try {

    	                response =
    	                  await fetch(
    	                    job.url,
    	                    {
    	                      method:
    	                        "GET",

    	                      headers: {
    	                        "Accept":
    	                          "application/json",

    	                        "user-token":
    	                          userToken
    	                      },

    	                      signal:
    	                        controller.signal
    	                    }
    	                  );

    	              } finally {

    	                clearTimeout(
    	                  timeoutId
    	                );
    	              }


    	              /*
    	               * A Current report can legitimately be absent when
    	               * a vehicle has supplied no telemetry today.
    	               *
    	               * This is NOT an application/login error.
    	               */
    	              if (
    	                response.status === 404 &&
    	                job.type === "Current"
    	              ) {
    	                continue;
    	              }


    	              if (
    	                !response.ok
    	              ) {
    	                throw new Error(
    	                  `HTTP ${response.status}`
    	                );
    	              }


    	              let report;

    	              try {
    	                report =
    	                  await response.json();

    	              } catch (_) {
    	                throw new Error(
    	                  "INVALID_REPORT_JSON"
    	                );
    	              }


    	              /* ===========================================
    	                 STAMP EVERY COPY OF THIS TRACTOR
    	                 =========================================== */

    	              const vehicleCopies =
    	                tractorsByTracker
    	                  .get(
    	                    job.tracker
    	                  ) ||
    	                [];


    	              for (
    	                const vehicle
    	                of vehicleCopies
    	              ) {

    	                try {

    	                  if (
    	                    !vehicle ||
    	                    !vehicle.Reports
    	                  ) {
    	                    continue;
    	                  }


    	                  vehicle
    	                    .Reports[
    	                      job.type
    	                    ] =
    	                    report;


    	                  /*
    	                   * Daily and Monthly Availability are still set
    	                   * earlier from their ViewC pointers exactly as
    	                   * before.
    	                   *
    	                   * Current has no pointer, so successful download
    	                   * is what proves availability.
    	                   */
    	                  if (
    	                    job.type ===
    	                      "Current"
    	                  ) {
    	                    vehicle
    	                      .Reports
    	                      .Availability
    	                      .Current =
    	                      true;
    	                  }

    	                } catch (stampError) {

    	                  errors.push({
    	                    tracker:
    	                      job.tracker,

    	                    type:
    	                      job.type,

    	                    stage:
    	                      "stamp_report",

    	                    error:
    	                      stampError?.message ||
    	                      String(stampError)
    	                  });
    	                }
    	              }


    	            } catch (downloadError) {

    	              const errorRecord = {
    	                tracker:
    	                  job?.tracker ??
    	                  null,

    	                type:
    	                  job?.type ??
    	                  null,

    	                stage:
    	                  "download",

    	                error:
    	                  downloadError?.name ===
    	                  "AbortError"
    	                    ? "TIMEOUT"
    	                    : (
    	                        downloadError
    	                          ?.message ||
    	                        String(
    	                          downloadError
    	                        )
    	                      )
    	              };


    	              errors.push(
    	                errorRecord
    	              );


    	              /*
    	               * Record the failure against the relevant
    	               * Tractor, but NEVER throw it further.
    	               */
    	              const vehicleCopies =
    	                tractorsByTracker
    	                  .get(
    	                    job?.tracker
    	                  ) ||
    	                [];


    	              for (
    	                const vehicle
    	                of vehicleCopies
    	              ) {

    	                try {

    	                  vehicle
    	                    ?.Reports
    	                    ?.Errors
    	                    ?.push(
    	                      errorRecord
    	                    );

    	                } catch (_) {}
    	              }
    	            }
    	          }

    	        } catch (workerError) {

    	          /*
    	           * Absolute final protection for the worker.
    	           */
    	          errors.push({
    	            stage:
    	              "download_worker",

    	            error:
    	              workerError?.message ||
    	              String(workerError)
    	          });

    	          console.warn(
    	            "[FIF Reports] Background worker failed safely.",
    	            workerError
    	          );
    	        }
    	      }


    	      /*
    	       * Promise.allSettled instead of Promise.all.
    	       *
    	       * Even if one worker somehow rejects, the remaining
    	       * workers are allowed to complete.
    	       */
    	      const workerCount =
    	        Math.min(
    	          concurrency,
    	          Math.max(
    	            jobs.length,
    	            1
    	          )
    	        );


    	      await Promise.allSettled(
    	        Array.from(
    	          {
    	            length:
    	              workerCount
    	          },

    	          function () {
    	            return downloadWorker();
    	          }
    	        )
    	      );


    	      /* ===================================================
    	         MARK REPORT OBJECTS COMPLETE
    	         =================================================== */

    	      for (
    	        const tractorCopies
    	        of tractorsByTracker.values()
    	      ) {

    	        for (
    	          const vehicle
    	          of tractorCopies
    	        ) {

    	          try {

    	            if (
    	              !vehicle?.Reports
    	            ) {
    	              continue;
    	            }

    	            vehicle.Reports.Loading =
    	              false;

    	            vehicle.Reports.Loaded =
    	              true;

    	            vehicle.Reports.LoadedAt =
    	              new Date()
    	                .toISOString();

    	          } catch (_) {}
    	        }
    	      }


    	      console.log(
    	        "[FIF Reports] Background vehicle reports loaded",
    	        {
    	          todayDate:
    	            todayDate,

    	          reportDate:
    	            reportDate,

    	          reportMonth:
    	            reportMonth,

    	          vehicles:
    	            tractorsByTracker.size,

    	          downloads:
    	            jobs.length,

    	          errors:
    	            errors.length
    	        }
    	      );


    	      /* ===================================================
    	         OPTIONAL APPLICATION EVENT

    	         Snapshot/Office can listen for this later if we want
    	         the UI to redraw the instant reports arrive.
    	         =================================================== */

    	      try {

    	        window.dispatchEvent(
    	          new CustomEvent(
    	            "fif:vehicle-reports-loaded",
    	            {
    	              detail: {
    	                todayDate:
    	                  todayDate,

    	                reportDate:
    	                  reportDate,

    	                reportMonth:
    	                  reportMonth,

    	                vehicles:
    	                  tractorsByTracker.size,

    	                downloads:
    	                  jobs.length,

    	                errors:
    	                  errors.length
    	              }
    	            }
    	          )
    	        );

    	      } catch (_) {}


    	    } catch (backgroundError) {

    	      /*
    	       * FINAL BACKGROUND SAFETY NET.
    	       *
    	       * Nothing is allowed to escape this async task as an
    	       * unhandled Promise rejection.
    	       */

    	      console.warn(
    	        "[FIF Reports] Background loader failed safely.",
    	        backgroundError
    	      );


    	      try {

    	        for (
    	          const tractorCopies
    	          of tractorsByTracker.values()
    	        ) {

    	          for (
    	            const vehicle
    	            of tractorCopies
    	          ) {

    	            if (
    	              !vehicle?.Reports
    	            ) {
    	              continue;
    	            }

    	            vehicle.Reports.Loading =
    	              false;

    	            vehicle.Reports.Loaded =
    	              false;

    	            vehicle.Reports.Errors.push({
    	              error:
    	                backgroundError
    	                  ?.message ||
    	                String(
    	                  backgroundError
    	                )
    	            });
    	          }
    	        }

    	      } catch (_) {}
    	    }

    	  })()
    	    .catch(
    	      function (unexpectedError) {

    	        /*
    	         * Belt-and-braces protection.
    	         *
    	         * Because this is a detached Promise, explicitly
    	         * consume any impossible final rejection.
    	         */
    	        console.warn(
    	          "[FIF Reports] Detached loader rejection contained.",
    	          unexpectedError
    	        );
    	      }
    	    );


    	  /* =======================================================
    	     RETURN TO LOGIN IMMEDIATELY

    	     No report request has to finish before this return.
    	     ======================================================= */

    	  return {
    	    success:
    	      true,

    	    started:
    	      true,

    	    background:
    	      true,

    	    todayDate:
    	      todayDate,

    	    reportDate:
    	      reportDate,

    	    reportMonth:
    	      reportMonth,

    	    vehicles:
    	      tractorsByTracker.size
    	  };


    	} catch (fatalSetupError) {

    	  /*
    	   * ABSOLUTE OUTER SAFETY NET.
    	   *
    	   * Even malformed Tractor data or an unexpected JS issue
    	   * must never prevent login/navigation.
    	   */

    	  console.warn(
    	    "[FIF Reports] Loader setup failed safely. Login will continue.",
    	    fatalSetupError
    	  );


    	  return {
    	    success:
    	      false,

    	    started:
    	      false,

    	    background:
    	      false,

    	    error:
    	      fatalSetupError
    	        ?.message ||
    	      String(
    	        fatalSetupError
    	      )
    	  };
    	}
    })(APP, (await Promise.all((getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies')).map(async item => {; return (getObjectProperty(item, 'Tractors'));}))));
  }
  AppData['APP'] = APP;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Snapshot', undefined);
}


  if (APP == 'Office') {
    await Office();
  } else if (APP == 'Road') {
    await Road();
  } else if (APP == 'Bowser') {
    await Bowser();
  } else if (APP == 'Mobile Tracking') {
    await Mobile_Tracking();
  } else if (APP == 'Snapshot') {
    await Snapshot();
  }

}

})
define('./functions/33f4c01b8e8eda17aee5c5294b33b8fc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_33f4c01b8e8eda17aee5c5294b33b8fc'] = async function fn_33f4c01b8e8eda17aee5c5294b33b8fc(listsToProcess) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zip(...arrays)
})(listsToProcess))
}

})
define('./functions/37a70893d34d348151130eb779d90624/code.js', () => { 

BackendlessUI.Functions.Custom['fn_37a70893d34d348151130eb779d90624'] = async function fn_37a70893d34d348151130eb779d90624(listsToProcess, combinerFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipWith(...arrays, iteratee)
})(listsToProcess, combinerFunction))
}

})
define('./functions/38c2ffe50d0e5cca36f20903850cc95a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_38c2ffe50d0e5cca36f20903850cc95a'] = async function fn_38c2ffe50d0e5cca36f20903850cc95a(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.last(array)
})(listToQuery))
}

})
define('./functions/3a17163a8ed3566b1d770b133f9e456c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3a17163a8ed3566b1d770b133f9e456c'] = async function fn_3a17163a8ed3566b1d770b133f9e456c(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/3b22bf56ea095bef299e80632005db52/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3b22bf56ea095bef299e80632005db52'] = async function fn_3b22bf56ea095bef299e80632005db52(listToProcess, chunkLength) {
return (await (async function(array, size) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (size == null) {
	  size = 1
	}

	return _.chunk(array, size)
})(listToProcess, chunkLength))
}

})
define('./functions/3da675c9560df4688c120284991f799e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3da675c9560df4688c120284991f799e'] = async function fn_3da675c9560df4688c120284991f799e(listToInspect, valuesToExclude, comparatorFunction) {
return (await (async function(array, values, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceWith(array, values, comparator)
})(listToInspect, valuesToExclude, comparatorFunction))
}

})
define('./functions/4305c6b3c9678eaff3f213c4ef4213e4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4305c6b3c9678eaff3f213c4ef4213e4'] = async function fn_4305c6b3c9678eaff3f213c4ef4213e4(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.tail(array)
})(listToQuery))
}

})
define('./functions/45e840d979f666875cfc9d9849ef3d28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_45e840d979f666875cfc9d9849ef3d28'] = async function fn_45e840d979f666875cfc9d9849ef3d28(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/461d17e665f8b6391823125f6307ab14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_461d17e665f8b6391823125f6307ab14'] = async function fn_461d17e665f8b6391823125f6307ab14(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniq(array)
})(listToInspect))
}

})
define('./functions/486ef78363267883c1df0cc331fd1a59/code.js', () => { 

BackendlessUI.Functions.Custom['fn_486ef78363267883c1df0cc331fd1a59'] = async function fn_486ef78363267883c1df0cc331fd1a59(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.without(array, ...values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/4cf12a1449b890f2c42b8fe2a753bc14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4cf12a1449b890f2c42b8fe2a753bc14'] = async function fn_4cf12a1449b890f2c42b8fe2a753bc14(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/520e5b11f44ee8f88266875f0285766e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_520e5b11f44ee8f88266875f0285766e'] = async function fn_520e5b11f44ee8f88266875f0285766e(propertyNamesList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObject(props, values)
})(propertyNamesList, propertyValuesList))
}

})
define('./functions/52fdb524073bbad39dd107b4c7541e2d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_52fdb524073bbad39dd107b4c7541e2d'] = async function fn_52fdb524073bbad39dd107b4c7541e2d(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/56599adc54c74c9fdbc667193c854a77/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56599adc54c74c9fdbc667193c854a77'] = async function fn_56599adc54c74c9fdbc667193c854a77(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.drop(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/56884591a118bc7af84daa6bfc0ea942/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56884591a118bc7af84daa6bfc0ea942'] = async function fn_56884591a118bc7af84daa6bfc0ea942(listToModify, valuesToRemove, filterFunction) {
  await (async function(array, values, iteratee) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllBy(array, values, iteratee)
  })(listToModify, valuesToRemove, filterFunction);

}

})
define('./functions/58ac96052b6cbe4266b47f18e18aecef/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58ac96052b6cbe4266b47f18e18aecef'] = async function fn_58ac96052b6cbe4266b47f18e18aecef(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/58b599fc79a1984718ac68445dc7b9e6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58b599fc79a1984718ac68445dc7b9e6'] = async function fn_58b599fc79a1984718ac68445dc7b9e6(listToFill, valueToFillListWith, startPosition, endPosition) {
  await (async function(array, value, start, end) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	if (start == null) {
  	  start = 0
  	}
  	if (end == null) {
  	  end = array.length
  	}

  	_.fill(array, value, start, end)
  })(listToFill, valueToFillListWith, startPosition, endPosition);

}

})
define('./functions/58db38bddf2dcf8f42d5e5214a01acc1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58db38bddf2dcf8f42d5e5214a01acc1'] = async function fn_58db38bddf2dcf8f42d5e5214a01acc1(listOfGroupedElements) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzip(array)
})(listOfGroupedElements))
}

})
define('./functions/5aa80c3936bd19c8f14dd135542b64be/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5aa80c3936bd19c8f14dd135542b64be'] = async function fn_5aa80c3936bd19c8f14dd135542b64be(listsTonspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorBy(...arrays, iteratee)
})(listsTonspect, filterFunction))
}

})
define('./functions/5f5f461bf34ccd068f9312393141132a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5f5f461bf34ccd068f9312393141132a'] = async function fn_5f5f461bf34ccd068f9312393141132a(App, Map) {
  await (async function(App, Map, SVG) {
  	return new Promise(resolve => {
  	  (async function CarvedEdgeShapeUI() {
  	    "use strict";
  	
  	    const LOCATION_CODE_BUILD = "2026.10.19-dashboard-event-parity-v3.2-geofence-safe-delete";
  	    const FIF_SILENT_CONSOLE = Object.freeze({
  	      log() {}, info() {}, warn() {}, error() {}, debug() {},
  	      table() {}, group() {}, groupCollapsed() {}, groupEnd() {}, trace() {}
  	    });
  	
  	    // Flespi sync restoration (2026-10-30). The old UI saved Locations but
  	    // never called the Flespi CREATE or UPDATE APIs. The no-op console hid clues.
  	    function getFlespiApiInvoker() {
  	      if (typeof Backendless === "undefined" || !Backendless) {
  	        throw new Error("Backendless SDK is not available.");
  	      }
  	      const candidates = [
  	        Backendless.APIServices,
  	        Backendless.CustomService,
  	        Backendless.CustomServices
  	      ];
  	      const invoker = candidates.find(item => item && typeof item.invoke === "function");
  	      if (!invoker) {
  	        throw new Error("Backendless API service invocation is unavailable (APIServices/CustomService).");
  	      }
  	      return invoker;
  	    }
  	
  	    async function invokeFlespiSyncOperation(method, locationObjectId) {
  	      const objectId = String(locationObjectId || "").trim();
  	      if (!objectId) throw new Error("Location objectId is missing; Flespi sync cannot start.");
  	
  	      const api = getFlespiApiInvoker();
  	      let result = await api.invoke("FlespiSync", method, objectId);
  	      if (typeof result === "string") {
  	        try { result = JSON.parse(result); } catch (_) {}
  	      }
  	      if (!result || result.ok !== true ||
  	          String(result.objectId || "").trim() !== objectId) {
  	        const detail = result && typeof result === "object"
  	          ? (result.message || result.error || JSON.stringify(result))
  	          : String(result);
  	        throw new Error("FlespiSync." + method + " returned an unconfirmed result: " + detail);
  	      }
  	      return result;
  	    }
  	
  	    async function syncSavedLocationWithFlespi(operation, location) {
  	      const objectId = String(location?.objectId || "").trim();
  	      const method = operation === "create" ? "createGeofenceFromLocation" : "updateGeofenceFromLocation";
  	      try {
  	        const result = await invokeFlespiSyncOperation(method, objectId);
  	        if (!/^[1-9]\d*$/.test(String(result.flespiGeofenceId || ""))) {
  	          throw new Error("FlespiSync succeeded without returning a valid geofence ID.");
  	        }
  	        location.flespiGeofenceId = String(result.flespiGeofenceId);
  	        console.info("[FIF FlespiSync] SYNC OK", { operation, objectId, result });
  	        return result;
  	      } catch (error) {
  	        // Do NOT retry saving the entire Location: that row already exists.
  	        // Leave it pending for the repairPendingGeofences service operation.
  	        console.error("[FIF FlespiSync] SYNC FAILED", {
  	          operation, objectId, error
  	        });
  	        try {
  	          window.alert(
  	            "The Location was saved in Backendless, but its Flespi geofence did NOT sync.\n\n" +
  	            "Location ID: " + objectId + "\n" +
  	            "Error: " + (error?.message || String(error)) + "\n\n" +
  	            "The location remains in Backendless. Use FlespiSync repair to retry; do not create a duplicate."
  	          );
  	        } catch (_) {}
  	        return null;
  	      }
  	    }
  	
  	    // Temporary UI switch only. Load/Gate data models and save logic remain intact.
  	    // Location Events share Dashboard field resolution and boundary-corrected Time In/Out reconciliation.
  	    const SHOW_LOAD_AND_GATE_FUNCTIONALITY_OPTIONS = false;
  	
  	    const APP_DATA = App;
  	
  	    try {
  	      if (typeof window !== "undefined") {
  	        window.__FIF_LOCATION_EVENT_BUILD = LOCATION_CODE_BUILD;
  	      }
  	    } catch (_) {}
  	    const MAP_INPUT = Map;
  	    const REPORT_SVG_INPUT =
  	      typeof SVG !== "undefined"
  	        ? SVG
  	        : readBackendlessArg("SVG", "svg", 2);
  	
  	    const ENGINE_ID = "fif-carved-edge-shape-ui";
  	    const STYLE_ID = `${ENGINE_ID}-style`;
  	    const ADD_NEW_LOCATION_TYPE_VALUE = "__add_new_location_type__";
  	    const DEFAULT_NEW_LOCATION_TYPE_COLOR = "#ff9a3d";
  	
  	    const OLD_ENGINE_IDS = [
  	      ENGINE_ID,
  	      "carved-edge-shape-ui",
  	      "trackit-carved-edge-shape-ui",
  	      "trackit-location-carved-edge-ui",
  	      "fif-location-carved-edge-ui"
  	    ];
  	
  	    const CTX = typeof ___arguments !== "undefined"
  	    ? ___arguments.context: null;
  	
  	    let DATA_CHANNEL = null;
  	
  	    let COMPANY_OPTIONS = [{
  	      value: "dummy-company-i",
  	      label: "i",
  	      company: null
  	    }];
  	
  	    const FALLBACK_LOCATION_TYPE_OPTIONS = [{
  	      value: "__add_new_location_type__",
  	      label: "Add New Location Type",
  	      color: "#ff9a3d",
  	      raw: null
  	    },
  	      {
  	        value: "dummy-location-type",
  	        label: "Dummy Location Type",
  	        color: "#49d37d",
  	        raw: null
  	      }];
  	
  	    const HELP_TEXT = {
  	      eventsCapture: {
  	        title: "Events Capture",
  	        body: "Allows this location to capture operational events such as arrivals, departures, delays, exceptions, inspections, notes, and activity records."
  	      },
  	      fuelLogic: {
  	        title: "Fuel Logic",
  	        body: "Adds fuel-related behaviour to this location. Choose either Public Fuel Station or Depot. Only one fuel mode can be active."
  	      },
  	      publicFuelStation: {
  	        title: "Public Fuel Station",
  	        body: "Marks the location as a public fuel station where vehicles can refuel through an external or commercial fuel provider."
  	      },
  	      fuelDepot: {
  	        title: "Depot",
  	        body: "Marks the location as a company depot or internal controlled fuel point."
  	      },
  	      loadLogic: {
  	        title: "Load Logic",
  	        body: "Adds load handling behaviour to this location. Use this for loading points, offloading points, collection areas, dispatch areas, or stock movement."
  	      },
  	      gateLogic: {
  	        title: "Gate Logic",
  	        body: "Adds gate-related behaviour to this location. For now this captures a contact number for future gate communication or access-control functionality."
  	      }
  	    };
  	
  	    const createState = {
  	      isCreating: false,
  	      company: "",
  	      locationType: "",
  	      creationMode: "",
  	      name: "",
  	      openDropdown: "",
  	      isPlotting: false,
  	      isSaved: false,
  	
  	      plotMode: "free-ground",
  	
  	      // Resolved points are what we actually draw.
  	      // Raw points are what the user clicked / intended.
  	      plotPoints: [],
  	      plotRawPoints: [],
  	      plotResolvedPoints: [],
  	      plotSnapSegments: [],
  	      plotHeadingPoints: [],
  	      plotHoleRings: [],
  	      plotHoleLocations: [],
  	
  	      plotPivotCenter: null,
  	      plotPivotRadiusPoint: null,
  	      plotPivotRadiusMeters: 0,
  	      plotDraftPivotCenterMarker: null,
  	      plotDraftPivotRadiusMarker: null,
  	      plotDraftPivotRadiusLine: null,
  	
  	      plotWedgeCenter: null,
  	      plotWedgeRadiusPoint: null,
  	      plotWedgeEdgePoint: null,
  	      plotWedgeRadiusMeters: 0,
  	      plotDraftWedgeCenterMarker: null,
  	      plotDraftWedgeRadiusMarker: null,
  	      plotDraftWedgeEdgeMarker: null,
  	      plotDraftWedgeRadiusLine: null,
  	      plotDraftWedgeEdgeLine: null,
  	
  	      plotActiveRawIndex: -1,
  	      plotCrossingWarnAt: 0,
  	
  	      plotParentLocation: null,
  	      plotParentLocationId: "",
  	
  	      childShapeMode: "",
  	      childFixedCenter: null,
  	      childRadiusPoint: null,
  	      childEdgePoint: null,
  	
  	      isPickingEntrance: false,
  	      entrancePoint: null,
  	      entranceMarker: null,
  	
  	      isSavingLocation: false,
  	      saveAfterFunctionality: false,
  	
  	      mapLockedUntilPlot: false,
  	      mapLockMap: null,
  	      mapLockOriginalOptions: null,
  	      mapLockOverlay: null,
  	
  	      plotDraftMap: null,
  	      plotDraftMarkers: [],
  	      plotDraftMidMarkers: [],
  	      plotDraftHeadingMarkers: [],
  	      plotDraftPolyline: null,
  	      plotDraftRawPolyline: null,
  	      plotDraftPolygon: null,
  	
  	      modalMode: "",
  	      helpTopic: "",
  	      typeManagerName: "",
  	      typeManagerColor: DEFAULT_NEW_LOCATION_TYPE_COLOR,
  	      typeManagerOriginalName: "",
  	
  	      typeManagerSource: "",
  	      typeManagerReturnRowData: null,
  	      functionality: {
  	        eventsCapture: false,
  	        fuelLogic: false,
  	        publicFuelStation: false,
  	        fuelDepot: false,
  	        loadLogic: false,
  	        gateLogic: false,
  	        gatePhone: ""
  	      }
  	    };
  	
  	    const mapControlState = {
  	      isOpen: false,
  	      map: null,
  	      labelsOn: true,
  	      hideSecondaryLocations: false,
  	      hideAllLocations: false,
  	      listenersBound: false
  	    };
  	
  	    const dropdownCompanyVisibilityState = {
  	      collapsedCompanyIds: new Set()
  	    };
  	
  	    const measureState = {
  	      isActive: false,
  	      mode: "",
  	      map: null,
  	
  	      rawPoints: [],
  	      points: [],
  	
  	      markers: [],
  	      guideLines: [],
  	
  	      polyline: null,
  	      polygon: null,
  	      circle: null,
  	
  	      results: {
  	        distanceMeters: 0,
  	        perimeterMeters: 0,
  	        areaM2: 0,
  	        radiusMeters: 0,
  	        diameterMeters: 0,
  	        circumferenceMeters: 0,
  	        arcMeters: 0,
  	        pointCount: 0
  	      },
  	
  	      message: "Choose a measure tool."
  	    };
  	
  	    let attentionTimer = null;
  	    let searchPanelResizeRaf = 0;
  	    let searchPanelResizeTimeouts = [];
  	    let freeGroundChildPromptOpen = false;
  	
  	    function safeString(value) {
  	      return value === undefined || value === null ? "": String(value);
  	    }
  	
  	    function escapeHtml(value) {
  	      return safeString(value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/"/g, "&quot;")
  	      .replace(/'/g, "&#039;");
  	    }
  	
  	    function resolveReportBrandAsset(value) {
  	      let candidate = value;
  	
  	      if (candidate && typeof candidate === "object") {
  	        candidate =
  	          candidate.value ??
  	          candidate.Value ??
  	          candidate.src ??
  	          candidate.Src ??
  	          candidate.url ??
  	          candidate.URL ??
  	          candidate.data ??
  	          candidate.Data ??
  	          "";
  	      }
  	
  	      const raw = safeString(candidate).trim();
  	
  	      if (!raw) return "";
  	
  	      if (/^data:image\/(?:svg\+xml|png|jpe?g|webp|gif)(?:;|,)/i.test(raw)) {
  	        return raw;
  	      }
  	
  	      if (/^<svg(?:\s|>)/i.test(raw)) {
  	        return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(raw);
  	      }
  	
  	      if (/^(?:https?:|blob:)/i.test(raw)) {
  	        return raw;
  	      }
  	
  	      return "";
  	    }
  	
  	    function resolveComponent(input) {
  	      if (!input) return null;
  	
  	      if (typeof input === "string") {
  	        if (CTX && typeof CTX.getComponentByUid === "function") {
  	          return CTX.getComponentByUid(input);
  	        }
  	
  	        return null;
  	      }
  	
  	      if (input.uid && CTX && typeof CTX.getComponentByUid === "function") {
  	        return CTX.getComponentByUid(input.uid) || input;
  	      }
  	
  	      return input;
  	    }
  	
  	    function readBackendlessArg(name, lowerName, index) {
  	      try {
  	        if (typeof ___arguments !== "undefined" && ___arguments) {
  	          if (___arguments[name] !== undefined) return ___arguments[name];
  	          if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	          if (___arguments[index] !== undefined) return ___arguments[index];
  	        }
  	      } catch (_) {}
  	
  	      return undefined;
  	    }
  	
  	    function getAppBag() {
  	      try {
  	        if (CTX && CTX.appData) return CTX.appData;
  	      } catch (_) {}
  	
  	      try {
  	        if (APP_DATA && APP_DATA.data && typeof APP_DATA.data === "object") {
  	          return APP_DATA.data;
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (APP_DATA && typeof APP_DATA === "object") {
  	          return APP_DATA;
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	          return BackendlessUI.App.data;
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (typeof window !== "undefined" && window.AppData) {
  	          return window.AppData.data || window.AppData;
  	        }
  	      } catch (_) {}
  	
  	      return null;
  	    }
  	
  	    function getObjectProperty(object, propPath) {
  	      if (!object) return undefined;
  	
  	      if (typeof propPath !== "string" || object[propPath] !== undefined) {
  	        return object[propPath];
  	      }
  	
  	      const parts = propPath.split(".");
  	      let current = object;
  	
  	      for (let i = 0; i < parts.length; i++) {
  	        if (!current || current[parts[i]] === undefined) return undefined;
  	        current = current[parts[i]];
  	      }
  	
  	      return current;
  	    }
  	
  	    function getCompanyId(company, index) {
  	      return (
  	        company?.objectId ||
  	        company?.ObjectId ||
  	        company?.CompanyId ||
  	        company?.companyId ||
  	        company?.id ||
  	        company?.ID ||
  	        `company-${index}`
  	      );
  	    }
  	
  	    function getCompanyName(company) {
  	      return (
  	        company?.Name ||
  	        company?.name ||
  	        company?.CompanyName ||
  	        company?.companyName ||
  	        company?.Title ||
  	        company?.title ||
  	        "Company"
  	      );
  	    }
  	
  	    function getCompanyLocations(company) {
  	      const locations =
  	      company?.Locations ||
  	      company?.locations ||
  	      company?.Location ||
  	      company?.location ||
  	      [];
  	
  	      return Array.isArray(locations) ? locations: [];
  	    }
  	
  	    function getLocationValue(location) {
  	      return (
  	        location?.objectId ||
  	        location?.ObjectId ||
  	        location?.id ||
  	        location?.ID ||
  	        null
  	      );
  	    }
  	
  	    function getLocationName(location) {
  	      return (
  	        location?.Name ||
  	        location?.name ||
  	        location?.Label ||
  	        location?.label ||
  	        location?.Title ||
  	        location?.title ||
  	        location?.ID ||
  	        location?.id ||
  	        "Location"
  	      );
  	    }
  	
  	    function getLocationTypeName(location) {
  	      return (
  	        location?.LocationType ||
  	        location?.locationType ||
  	        location?.Type ||
  	        location?.type ||
  	        location?.FieldType ||
  	        location?.fieldType ||
  	        location?.Shape ||
  	        location?.shape ||
  	        ""
  	      );
  	    }
  	
  	    function getLocationTypeColor(location) {
  	      const value =
  	      location?.Color ||
  	      location?.color ||
  	      location?.Colour ||
  	      location?.colour ||
  	      "";
  	
  	      const color = safeString(value).trim();
  	
  	      if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)) return color;
  	      if (/^rgba?\([0-9.,%\s]+\)$/i.test(color)) return color;
  	      if (/^hsla?\([0-9.,%\s]+\)$/i.test(color)) return color;
  	
  	      return "#49d37d";
  	    }
  	
  	    function getLocationChildren(location) {
  	      const arrays = [
  	        location?.Children,
  	        location?.children,
  	        location?.ChildLocations,
  	        location?.childLocations,
  	        location?.Locations,
  	        location?.locations,
  	        location?.Fields,
  	        location?.fields,
  	        location?.Segments,
  	        location?.segments,
  	        location?.Rings,
  	        location?.rings
  	      ];
  	
  	      const result = [];
  	      const seen = new Set();
  	
  	      arrays.forEach(list => {
  	        if (!Array.isArray(list)) return;
  	
  	        list.forEach(child => {
  	          if (!child || typeof child !== "object") return;
  	
  	          const key = getLocationValue(child) || child;
  	
  	          if (seen.has(key)) return;
  	
  	          seen.add(key);
  	          result.push(child);
  	        });
  	      });
  	
  	      return result;
  	    }
  	
  	    function flattenLocations(locations, output = [], seen = new Set()) {
  	      if (!Array.isArray(locations)) return output;
  	
  	      locations.forEach(location => {
  	        if (!location || typeof location !== "object") return;
  	
  	        const key = getLocationValue(location) || getLocationName(location);
  	
  	        if (key && seen.has(key)) return;
  	
  	        if (key) seen.add(key);
  	
  	        output.push(location);
  	        flattenLocations(getLocationChildren(location), output, seen);
  	      });
  	
  	      return output;
  	    }
  	
  	    function getRegistryLocations(appData) {
  	      const store =
  	      appData?.LocationRegistryStore ||
  	      appData?.locationRegistryStore ||
  	      null;
  	
  	      const byId = store?.byId || store?.ById || {};
  	
  	      if (!byId || typeof byId !== "object") return [];
  	
  	      return Object.keys(byId)
  	      .map(key => byId[key])
  	      .filter(Boolean);
  	    }
  	
  	    function getCompaniesFromData(appData) {
  	      const listInput =
  	      typeof List !== "undefined"
  	      ? List: readBackendlessArg("List", "list", 1);
  	
  	      if (Array.isArray(listInput)) return listInput;
  	
  	      const userCompanies =
  	      appData?.User?.Companies ||
  	      appData?.User?.companies ||
  	      appData?.Companies ||
  	      appData?.companies ||
  	      [];
  	
  	      return Array.isArray(userCompanies) ? userCompanies: [];
  	    }
  	
  	    function createCompanyOptionsFromData(companies) {
  	      const options = companies.map((company, index) => {
  	        return {
  	          value: safeString(getCompanyId(company, index)),
  	          label: safeString(getCompanyName(company)),
  	          company
  	        };
  	      });
  	
  	      return options.length
  	      ? options: [{
  	        value: "dummy-company-i",
  	        label: "i",
  	        company: null
  	      }];
  	    }
  	
  	    function findCompanyOption(value) {
  	      return COMPANY_OPTIONS.find(option => option.value === value) || null;
  	    }
  	
  	    function refreshBackendlessApp() {
  	      try {
  	        if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.refresh) {
  	          BackendlessUI.App.refresh();
  	        }
  	      } catch (_) {}
  	    }
  	
  	    function normalizeLocationTypeColorValue(value) {
  	      const color = safeString(value).trim();
  	
  	      if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)) return color;
  	
  	      return DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	    }
  	
  	    function createLocationTypeValue(name) {
  	      const slug = safeString(name)
  	      .trim()
  	      .toLowerCase()
  	      .replace(/&/g, "and")
  	      .replace(/[^a-z0-9]+/g, "-")
  	      .replace(/^-+|-+$/g, "");
  	
  	      return slug || `location-type-${Date.now()}`;
  	    }
  	
  	    function getCompanyManifest(company) {
  	      if (!company || typeof company !== "object") return null;
  	
  	      if (!company.Manifest || typeof company.Manifest !== "object") {
  	        company.Manifest = {};
  	      }
  	
  	      return company.Manifest;
  	    }
  	
  	    function normalizeManifestLocationTypeRecord(record) {
  	      if (!record || typeof record !== "object") return null;
  	
  	      const name = safeString(
  	        record.TypeName ||
  	        record.typeName ||
  	        record.Name ||
  	        record.name ||
  	        record.Label ||
  	        record.label ||
  	        ""
  	      ).trim();
  	
  	      if (!name) return null;
  	
  	      const color = normalizeLocationTypeColorValue(
  	        record.Color ||
  	        record.color ||
  	        record.Colour ||
  	        record.colour ||
  	        DEFAULT_NEW_LOCATION_TYPE_COLOR
  	      );
  	
  	      const value = safeString(
  	        record.Value ||
  	        record.value ||
  	        createLocationTypeValue(name)
  	      ).trim();
  	
  	      return {
  	        ...record,
  	        Value: value || createLocationTypeValue(name),
  	        TypeName: name,
  	        Color: color,
  	        UpdatedAt: record.UpdatedAt || record.updatedAt || new Date().toISOString(),
  	        IsActive: record.IsActive !== false
  	      };
  	    }
  	
  	    function getManifestLocationTypes(company) {
  	      const manifest = getCompanyManifest(company);
  	
  	      if (!manifest) return [];
  	
  	      if (!Array.isArray(manifest.LocationTypes)) {
  	        manifest.LocationTypes = [];
  	      }
  	
  	      // One-time migration from old top-level Company.LocationTypes.
  	      const oldTopLevelTypes =
  	      Array.isArray(company.LocationTypes)
  	      ? company.LocationTypes: Array.isArray(company.locationTypes)
  	      ? company.locationTypes: [];
  	
  	      oldTopLevelTypes.forEach(record => {
  	        const normal = normalizeManifestLocationTypeRecord(record);
  	
  	        if (!normal) return;
  	
  	        const exists = manifest.LocationTypes.some(item => {
  	          return safeString(
  	            item.TypeName ||
  	            item.typeName ||
  	            item.Name ||
  	            item.name ||
  	            ""
  	          ).trim().toLowerCase() === normal.TypeName.toLowerCase();
  	        });
  	
  	        if (!exists) {
  	          manifest.LocationTypes.push(normal);
  	        }
  	      });
  	
  	      // One-time bootstrap from existing locations if Manifest.LocationTypes is empty.
  	      // After this, the Manifest is the source of truth.
  	      if (!manifest.LocationTypes.length) {
  	        const existingLocations = flattenLocations(getCompanyLocations(company));
  	        const byName = Object.create(null);
  	
  	        existingLocations.forEach(location => {
  	          const typeName = safeString(getLocationTypeName(location)).trim();
  	
  	          if (!typeName) return;
  	
  	          const key = typeName.toLowerCase();
  	
  	          if (byName[key]) return;
  	
  	          byName[key] = {
  	            Value: createLocationTypeValue(typeName),
  	            TypeName: typeName,
  	            Color: normalizeLocationTypeColorValue(getLocationTypeColor(location)),
  	            CreatedAt: new Date().toISOString(),
  	            UpdatedAt: new Date().toISOString(),
  	            IsActive: true,
  	            Source: "existing-location-bootstrap"
  	          };
  	        });
  	
  	        Object.keys(byName)
  	        .sort()
  	        .forEach(key => {
  	          manifest.LocationTypes.push(byName[key]);
  	        });
  	      }
  	
  	      manifest.LocationTypes = manifest.LocationTypes
  	      .map(normalizeManifestLocationTypeRecord)
  	      .filter(Boolean)
  	      .filter(record => record.IsActive !== false);
  	
  	      return manifest.LocationTypes;
  	    }
  	
  	    function persistCompanyManifest(company,
  	      source) {
  	      if (!company || typeof company !== "object") return;
  	
  	      const objectId =
  	      company.objectId ||
  	      company.ObjectId ||
  	      company.id ||
  	      company.ID ||
  	      null;
  	
  	      if (!objectId) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Location Types] Cannot persist company manifest without objectId.", {
  	          source: source || "manifest-location-types",
  	          company
  	        });
  	
  	        return;
  	      }
  	
  	      const manifest = getCompanyManifest(company);
  	
  	      if (!manifest) return;
  	
  	      try {
  	        if (
  	          typeof Backendless === "undefined" ||
  	          !Backendless ||
  	          !Backendless.Data ||
  	          typeof Backendless.Data.of !== "function"
  	        ) {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Location Types] Backendless not available. Manifest updated in memory only.", {
  	            source: source || "manifest-location-types",
  	            companyId: objectId,
  	            manifest
  	          });
  	
  	          return;
  	        }
  	
  	        Backendless.Data.of("Companies")
  	        .save({
  	          objectId,
  	          Manifest: safeCloneForSave(manifest)
  	        })
  	        .then(saved => {
  	          FIF_SILENT_CONSOLE.log("[TrackIT Location Types] Company Manifest persisted.", {
  	            source: source || "manifest-location-types",
  	            companyId: objectId,
  	            saved
  	          });
  	        })
  	        .catch(error => {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Location Types] Could not persist company Manifest.", {
  	            source: source || "manifest-location-types",
  	            companyId: objectId,
  	            error
  	          });
  	        });
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Location Types] Manifest persist failed.", {
  	          source: source || "manifest-location-types",
  	          companyId: objectId,
  	          error
  	        });
  	      }
  	    }
  	
  	    function getCompanyTypeStore(companyValue) {
  	      const option = findCompanyOption(companyValue);
  	      const company = option?.company || null;
  	
  	      if (company && typeof company === "object") {
  	        const manifestTypes = getManifestLocationTypes(company);
  	
  	        // Compatibility mirror only.
  	        // The canonical store is company.Manifest.LocationTypes.
  	        company.LocationTypes = manifestTypes;
  	
  	        return manifestTypes;
  	      }
  	
  	      const appData = getAppBag();
  	
  	      if (!appData) return [];
  	
  	      if (!appData.Manifest || typeof appData.Manifest !== "object") {
  	        appData.Manifest = {};
  	      }
  	
  	      if (
  	        !appData.Manifest.LocationTypesByCompany ||
  	        typeof appData.Manifest.LocationTypesByCompany !== "object"
  	      ) {
  	        appData.Manifest.LocationTypesByCompany = {};
  	      }
  	
  	      if (!Array.isArray(appData.Manifest.LocationTypesByCompany[companyValue])) {
  	        appData.Manifest.LocationTypesByCompany[companyValue] = [];
  	      }
  	
  	      return appData.Manifest.LocationTypesByCompany[companyValue];
  	    }
  	
  	    function getLocationTypeRecordName(record) {
  	      return (
  	        record?.TypeName ||
  	        record?.typeName ||
  	        record?.Name ||
  	        record?.name ||
  	        record?.Label ||
  	        record?.label ||
  	        ""
  	      );
  	    }
  	
  	    function getLocationTypeRecordColor(record) {
  	      return normalizeLocationTypeColorValue(
  	        record?.Color ||
  	        record?.color ||
  	        record?.Colour ||
  	        record?.colour ||
  	        ""
  	      );
  	    }
  	
  	    function getCompanyObjectByValue(companyValue) {
  	      const option = findCompanyOption(companyValue);
  	
  	      return option?.company || null;
  	    }
  	
  	    function getLocationCreationCompanyScope(appData) {
  	      const data = appData || getAppBag() || APP_DATA;
  	      const companies =
  	      DATA_CHANNEL?.companies ||
  	      data?.User?.Companies ||
  	      data?.User?.companies ||
  	      data?.Companies ||
  	      data?.companies ||
  	      [];
  	
  	      const companyList = Array.isArray(companies) ? companies: [];
  	      const selectedCompanyId = safeString(createState.company).trim();
  	      const realCompanyOptions = Array.isArray(COMPANY_OPTIONS)
  	      ? COMPANY_OPTIONS.filter(option => option && option.company): [];
  	
  	      const hasMultipleCompanies = Math.max(
  	        companyList.length,
  	        realCompanyOptions.length
  	      ) > 1;
  	
  	      const active = !!(
  	        createState.isCreating &&
  	        selectedCompanyId &&
  	        hasMultipleCompanies
  	      );
  	
  	      let company = active ? getCompanyObjectByValue(selectedCompanyId): null;
  	
  	      if (active && !company) {
  	        company = companyList.find((item, index) => {
  	          return safeString(getCompanyId(item, index)).trim() === selectedCompanyId;
  	        }) || null;
  	      }
  	
  	      return {
  	        active,
  	        companyId: selectedCompanyId,
  	        company,
  	        companyCount: Math.max(companyList.length, realCompanyOptions.length)
  	      };
  	    }
  	
  	    function getDropdownCollapsedCompanyLocationIds(appData) {
  	      const hiddenLocationIds = new Set();
  	      const data = appData || getAppBag() || APP_DATA;
  	      const creationScope = getLocationCreationCompanyScope(data);
  	
  	      // New Location creation owns map visibility while a Company is selected.
  	      // A previously collapsed Company must still expose its own boundaries for
  	      // parenting, snapping, containment, and same-Company collision checks.
  	      if (creationScope.active) return hiddenLocationIds;
  	
  	      const collapsedCompanyIds = dropdownCompanyVisibilityState.collapsedCompanyIds;
  	
  	      if (!collapsedCompanyIds || !collapsedCompanyIds.size) {
  	        return hiddenLocationIds;
  	      }
  	
  	      const companies =
  	      DATA_CHANNEL?.companies ||
  	      data?.User?.Companies ||
  	      data?.User?.companies ||
  	      data?.Companies ||
  	      data?.companies ||
  	      [];
  	
  	      if (!Array.isArray(companies)) return hiddenLocationIds;
  	
  	      companies.forEach((company, index) => {
  	        const companyId = safeString(getCompanyId(company, index)).trim();
  	
  	        if (!companyId || !collapsedCompanyIds.has(companyId)) return;
  	
  	        flattenLocations(getCompanyLocations(company)).forEach(location => {
  	          const locationId = rendererGetLocationId(location);
  	
  	          if (locationId) {
  	            hiddenLocationIds.add(locationId);
  	          }
  	        });
  	      });
  	
  	      return hiddenLocationIds;
  	    }
  	
  	    function refreshLocationCreationCompanyScope(reason) {
  	      const refresh = () => {
  	        try {
  	          const runtime =
  	          typeof window !== "undefined"
  	          ? window.TrackITLocationMapRenderer ||
  	          window.TrackITLocationRendererRuntime ||
  	          window.__TrackITLocationRendererRuntime ||
  	          null: null;
  	
  	          if (runtime && typeof runtime.refresh === "function") {
  	            runtime.refresh({
  	              reason: reason || "location-create-company-scope",
  	              doFitBounds: false
  	            });
  	
  	            return true;
  	          }
  	
  	          if (typeof renderSavedLocationsOnMap === "function") {
  	            return renderSavedLocationsOnMap(MAP_INPUT, {
  	              reason: reason || "location-create-company-scope",
  	              doFitBounds: false
  	            });
  	          }
  	        } catch (error) {
  	          FIF_SILENT_CONSOLE.warn(
  	            "[TrackIT Location Company Scope] Could not refresh location visibility.",
  	            error
  	          );
  	        }
  	
  	        return false;
  	      };
  	
  	      refresh();
  	
  	      setTimeout(() => {
  	        refresh();
  	      }, 80);
  	    }
  	
  	    function setLocationTypeNameAndColor(location, typeName, color) {
  	      if (!location || typeof location !== "object") return;
  	
  	      const typeFields = [
  	        "LocationType",
  	        "locationType",
  	        "Type",
  	        "type",
  	        "FieldType",
  	        "fieldType"
  	      ];
  	
  	      let hadTypeField = false;
  	
  	      typeFields.forEach(field => {
  	        if (location[field] !== undefined && location[field] !== null && safeString(location[field]).trim()) {
  	          location[field] = typeName;
  	          hadTypeField = true;
  	        }
  	      });
  	
  	      if (!hadTypeField) {
  	        location.LocationType = typeName;
  	      }
  	
  	      if (location.Color !== undefined) {
  	        location.Color = color;
  	      } else if (location.color !== undefined) {
  	        location.color = color;
  	      } else if (location.Colour !== undefined) {
  	        location.Colour = color;
  	      } else if (location.colour !== undefined) {
  	        location.colour = color;
  	      } else {
  	        location.Color = color;
  	      }
  	    }
  	
  	    function bulkUpdateCompanyLocationsByType(companyValue, originalTypeName, newTypeName, newColor) {
  	      const company = getCompanyObjectByValue(companyValue);
  	      const oldName = safeString(originalTypeName).trim();
  	      const nextName = safeString(newTypeName).trim();
  	      const nextColor = normalizeLocationTypeColorValue(newColor);
  	
  	      if (!company || !oldName || !nextName) {
  	        return {
  	          updatedCount: 0,
  	          updatedLocations: []
  	        };
  	      }
  	
  	      const oldKey = oldName.toLowerCase();
  	      const locations = flattenLocations(getCompanyLocations(company));
  	      const updatedLocations = [];
  	
  	      locations.forEach(location => {
  	        const currentType = safeString(getLocationTypeName(location)).trim();
  	
  	        if (!currentType) return;
  	        if (currentType.toLowerCase() !== oldKey) return;
  	
  	        setLocationTypeNameAndColor(location, nextName, nextColor);
  	        updatedLocations.push(location);
  	      });
  	
  	      return {
  	        updatedCount: updatedLocations.length,
  	        updatedLocations
  	      };
  	    }
  	
  	    function upsertCompanyLocationType(companyValue,
  	      typeName,
  	      color,
  	      originalTypeName) {
  	      const cleanName = safeString(typeName).trim();
  	      const cleanColor = normalizeLocationTypeColorValue(color);
  	      const cleanOriginalName = safeString(originalTypeName).trim();
  	
  	      if (!cleanName) return null;
  	
  	      const company = getCompanyObjectByValue(companyValue);
  	      const store = getCompanyTypeStore(companyValue);
  	
  	      const now = new Date().toISOString();
  	
  	      const originalIndex = cleanOriginalName
  	      ? store.findIndex(item => {
  	        return safeString(
  	          item.TypeName ||
  	          item.typeName ||
  	          item.Name ||
  	          item.name ||
  	          ""
  	        ).trim().toLowerCase() === cleanOriginalName.toLowerCase();
  	      }): -1;
  	
  	      const targetIndex = store.findIndex(item => {
  	        return safeString(
  	          item.TypeName ||
  	          item.typeName ||
  	          item.Name ||
  	          item.name ||
  	          ""
  	        ).trim().toLowerCase() === cleanName.toLowerCase();
  	      });
  	
  	      let record = null;
  	
  	      if (originalIndex >= 0 && targetIndex >= 0 && originalIndex !== targetIndex) {
  	        record = store[targetIndex];
  	
  	        record.TypeName = cleanName;
  	        record.Name = cleanName;
  	        record.Label = cleanName;
  	        record.Value = record.Value || record.value || createLocationTypeValue(cleanName);
  	        record.Color = cleanColor;
  	        record.UpdatedAt = now;
  	        record.IsActive = true;
  	
  	        store.splice(originalIndex, 1);
  	      } else if (originalIndex >= 0) {
  	        record = store[originalIndex];
  	
  	        record.TypeName = cleanName;
  	        record.Name = cleanName;
  	        record.Label = cleanName;
  	        record.Value = record.Value || record.value || createLocationTypeValue(cleanName);
  	        record.Color = cleanColor;
  	        record.UpdatedAt = now;
  	        record.IsActive = true;
  	      } else if (targetIndex >= 0) {
  	        record = store[targetIndex];
  	
  	        record.TypeName = cleanName;
  	        record.Name = cleanName;
  	        record.Label = cleanName;
  	        record.Value = record.Value || record.value || createLocationTypeValue(cleanName);
  	        record.Color = cleanColor;
  	        record.UpdatedAt = now;
  	        record.IsActive = true;
  	      } else {
  	        record = {
  	          Value: createLocationTypeValue(cleanName),
  	          TypeName: cleanName,
  	          Name: cleanName,
  	          Label: cleanName,
  	          Color: cleanColor,
  	          CreatedAt: now,
  	          UpdatedAt: now,
  	          IsActive: true,
  	          Source: "company-manifest"
  	        };
  	
  	        store.push(record);
  	      }
  	
  	      const bulkResult = cleanOriginalName
  	      ? bulkUpdateCompanyLocationsByType(companyValue, cleanOriginalName, cleanName, cleanColor): {
  	        updatedCount: 0,
  	        updatedLocations: []
  	      };
  	
  	      if (company) {
  	        const manifest = getCompanyManifest(company);
  	
  	        if (manifest) {
  	          manifest.LocationTypes = store;
  	        }
  	
  	        company.LocationTypes = store;
  	
  	        persistCompanyManifest(company, "upsert-company-location-type");
  	      }
  	
  	      refreshBackendlessApp();
  	
  	      return {
  	        value: record.Value || createLocationTypeValue(cleanName),
  	        label: cleanName,
  	        color: cleanColor,
  	        raw: record,
  	        originalName: cleanOriginalName,
  	        updatedCount: bulkResult.updatedCount,
  	        updatedLocations: bulkResult.updatedLocations
  	      };
  	    }
  	
  	    function deleteCompanyLocationTypeFromManifest(companyValue, typeRecord) {
  	      const company = getCompanyObjectByValue(companyValue);
  	
  	      if (!company || typeof company !== "object") {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Location Types] Cannot delete type because company was not found.", {
  	          companyValue,
  	          typeRecord
  	        });
  	
  	        return false;
  	      }
  	
  	      const manifest = getCompanyManifest(company);
  	
  	      if (!manifest) return false;
  	
  	      const store = getCompanyTypeStore(companyValue);
  	
  	      const targetName = safeString(
  	        typeRecord?.TypeName ||
  	        typeRecord?.typeName ||
  	        typeRecord?.Name ||
  	        typeRecord?.name ||
  	        typeRecord?.Label ||
  	        typeRecord?.label ||
  	        typeRecord?.label ||
  	        ""
  	      ).trim();
  	
  	      const targetValue = safeString(
  	        typeRecord?.Value ||
  	        typeRecord?.value ||
  	        ""
  	      ).trim();
  	
  	      const targetKey = targetName.toLowerCase();
  	      const targetValueKey = targetValue.toLowerCase();
  	
  	      if (!targetKey && !targetValueKey) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Location Types] Cannot delete type because it has no name/value.", {
  	          typeRecord
  	        });
  	
  	        return false;
  	      }
  	
  	      const nextStore = store.filter(item => {
  	        const itemName = safeString(
  	          item.TypeName ||
  	          item.typeName ||
  	          item.Name ||
  	          item.name ||
  	          item.Label ||
  	          item.label ||
  	          ""
  	        ).trim();
  	
  	        const itemValue = safeString(
  	          item.Value ||
  	          item.value ||
  	          ""
  	        ).trim();
  	
  	        const itemNameKey = itemName.toLowerCase();
  	        const itemValueKey = itemValue.toLowerCase();
  	
  	        if (targetValueKey && itemValueKey && itemValueKey === targetValueKey) {
  	          return false;
  	        }
  	
  	        if (targetKey && itemNameKey && itemNameKey === targetKey) {
  	          return false;
  	        }
  	
  	        return true;
  	      });
  	
  	      if (nextStore.length === store.length) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Location Types] Type was not found in Manifest.LocationTypes.", {
  	          companyValue,
  	          targetName,
  	          targetValue,
  	          store
  	        });
  	
  	        return false;
  	      }
  	
  	      manifest.LocationTypes = nextStore;
  	      company.LocationTypes = nextStore;
  	
  	      if (
  	        safeString(createState.locationType).trim().toLowerCase() === targetValueKey ||
  	        safeString(createState.locationType).trim().toLowerCase() === targetKey
  	      ) {
  	        createState.locationType = "";
  	      }
  	
  	      if (
  	        safeString(createState.typeManagerOriginalName).trim().toLowerCase() === targetKey
  	      ) {
  	        createState.typeManagerOriginalName = "";
  	        createState.typeManagerName = "";
  	        createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	      }
  	
  	      persistCompanyManifest(company, "delete-company-location-type");
  	
  	      refreshBackendlessApp();
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Location Types] Type deleted from company Manifest only.", {
  	        companyValue,
  	        deletedTypeName: targetName,
  	        deletedTypeValue: targetValue,
  	        remainingTypes: nextStore
  	      });
  	
  	      return true;
  	    }
  	
  	    function getLocationTypeDeleteConfirmBlackout() {
  	      let blackout = null;
  	
  	      try {
  	        blackout = document.body.__trackitLocationTypeDeleteBlackout || null;
  	      } catch (_) {
  	        blackout = null;
  	      }
  	
  	      if (blackout && document.body.contains(blackout)) {
  	        return blackout;
  	      }
  	
  	      blackout = document.createElement("div");
  	      blackout.className = "trackit-delete-confirm-blackout";
  	      blackout.setAttribute("aria-hidden", "true");
  	
  	      document.body.appendChild(blackout);
  	
  	      try {
  	        document.body.__trackitLocationTypeDeleteBlackout = blackout;
  	      } catch (_) {}
  	
  	      return blackout;
  	    }
  	
  	    function openLocationTypeDeleteConfirmBlackout() {
  	      const blackout = getLocationTypeDeleteConfirmBlackout();
  	
  	      blackout.classList.add("open");
  	
  	      try {
  	        document.documentElement.classList.add("trackit-delete-confirm-open");
  	        document.body.classList.add("trackit-delete-confirm-open");
  	      } catch (_) {}
  	
  	      return blackout;
  	    }
  	
  	    function closeLocationTypeDeleteConfirmBlackout() {
  	      const blackout = getLocationTypeDeleteConfirmBlackout();
  	
  	      blackout.classList.remove("open");
  	
  	      try {
  	        document.documentElement.classList.remove("trackit-delete-confirm-open");
  	        document.body.classList.remove("trackit-delete-confirm-open");
  	      } catch (_) {}
  	    }
  	
  	    function getLocationTypeDeleteConfirmPopup() {
  	      let popup = null;
  	
  	      try {
  	        popup = document.body.__trackitLocationTypeDeletePopup || null;
  	      } catch (_) {
  	        popup = null;
  	      }
  	
  	      if (popup && document.body.contains(popup)) {
  	        return popup;
  	      }
  	
  	      popup = document.createElement("div");
  	      popup.className = "trackit-delete-confirm-popup";
  	      popup.setAttribute("role", "dialog");
  	      popup.setAttribute("aria-modal", "false");
  	      popup.setAttribute("aria-label", "Delete Location Type Confirmation");
  	
  	      document.body.appendChild(popup);
  	
  	      try {
  	        document.body.__trackitLocationTypeDeletePopup = popup;
  	      } catch (_) {}
  	
  	      return popup;
  	    }
  	
  	    function closeLocationTypeDeleteConfirmPopup() {
  	      const popup = getLocationTypeDeleteConfirmPopup();
  	
  	      popup.classList.remove("open");
  	      popup.innerHTML = "";
  	      popup.__locationTypeDeleteContext = null;
  	
  	      closeLocationTypeDeleteConfirmBlackout();
  	    }
  	
  	    function openLocationTypeDeleteConfirmPopup(selectedType, root) {
  	      if (!selectedType) return;
  	
  	      const popup = getLocationTypeDeleteConfirmPopup();
  	
  	      const typeName = safeString(selectedType.label || selectedType.TypeName || selectedType.Name || "this type").trim();
  	
  	      popup.__locationTypeDeleteContext = {
  	        selectedType,
  	        root,
  	        typeName
  	      };
  	
  	      popup.innerHTML = `
  	      <div class="trackit-delete-popup-panel">
  	      <div class="trackit-delete-popup-head">
  	      <div class="trackit-delete-popup-icon">!</div>
  	
  	      <div class="trackit-delete-popup-title-block">
  	      <div class="trackit-delete-popup-title">Delete Location Type</div>
  	      <div class="trackit-delete-popup-subtitle">Manifest Only</div>
  	      </div>
  	
  	      <button class="trackit-delete-popup-close" type="button" data-location-type-delete-cancel aria-label="Cancel delete">
  	      ×
  	      </button>
  	      </div>
  	
  	      <div class="trackit-delete-popup-body">
  	      <div class="trackit-delete-popup-name">
  	      ${escapeHtml(typeName)}
  	      </div>
  	
  	      <div class="trackit-delete-popup-copy">
  	      This will remove this type from the company Manifest only. Existing saved locations will not be changed.
  	      </div>
  	
  	      <label class="trackit-delete-popup-label">
  	      Type <strong>DELETE</strong> to confirm
  	      </label>
  	
  	      <input
  	      class="trackit-delete-popup-input"
  	      type="text"
  	      autocomplete="off"
  	      spellcheck="false"
  	      data-location-type-delete-input
  	      placeholder="DELETE"
  	      >
  	
  	      <div class="trackit-delete-popup-error" data-location-type-delete-error>
  	      Exact confirmation required.
  	      </div>
  	      </div>
  	
  	      <div class="trackit-delete-popup-actions">
  	      <button
  	      class="trackit-delete-popup-btn danger"
  	      type="button"
  	      data-location-type-delete-confirm
  	      disabled
  	      >
  	      Delete
  	      </button>
  	
  	      <button
  	      class="trackit-delete-popup-btn"
  	      type="button"
  	      data-location-type-delete-cancel
  	      >
  	      Cancel
  	      </button>
  	      </div>
  	      </div>
  	      `;
  	
  	      openLocationTypeDeleteConfirmBlackout();
  	      popup.classList.add("open");
  	
  	      bindLocationTypeDeleteConfirmPopupEvents();
  	
  	      setTimeout(() => {
  	        const input = popup.querySelector("[data-location-type-delete-input]");
  	
  	        try {
  	          input?.focus?.();
  	          input?.select?.();
  	        } catch (_) {}
  	      }, 30);
  	    }
  	
  	    function bindLocationTypeDeleteConfirmPopupEvents() {
  	      const popup = getLocationTypeDeleteConfirmPopup();
  	
  	      const input = popup.querySelector("[data-location-type-delete-input]");
  	      const deleteButton = popup.querySelector("[data-location-type-delete-confirm]");
  	      const cancelButtons = popup.querySelectorAll("[data-location-type-delete-cancel]");
  	      const error = popup.querySelector("[data-location-type-delete-error]");
  	
  	      if (!input || !deleteButton) return;
  	
  	      function refreshState() {
  	        const value = safeString(input.value).trim();
  	        const isValid = value === "DELETE";
  	
  	        deleteButton.disabled = !isValid;
  	
  	        if (error) {
  	          error.classList.toggle("visible", !!value && !isValid);
  	        }
  	
  	        input.classList.toggle("is-valid", isValid);
  	        input.classList.toggle("is-invalid", !!value && !isValid);
  	      }
  	
  	      function cancel() {
  	        closeLocationTypeDeleteConfirmPopup();
  	      }
  	
  	      function confirm() {
  	        const context = popup.__locationTypeDeleteContext || null;
  	
  	        if (!context || !context.selectedType) {
  	          closeLocationTypeDeleteConfirmPopup();
  	          return;
  	        }
  	
  	        const selectedType = context.selectedType;
  	        const root = context.root;
  	
  	        const deleted = deleteCompanyLocationTypeFromManifest(
  	          createState.company,
  	          {
  	            ...selectedType.raw,
  	            TypeName: selectedType.label,
  	            Name: selectedType.label,
  	            Label: selectedType.label,
  	            Value: selectedType.value,
  	            Color: selectedType.color
  	          }
  	        );
  	
  	        closeLocationTypeDeleteConfirmPopup();
  	
  	        if (!deleted) return;
  	
  	        renderTop(root);
  	        renderModal(root);
  	      }
  	
  	      input.addEventListener("input", refreshState);
  	
  	      input.addEventListener("keydown", event => {
  	        if (event.key === "Enter") {
  	          event.preventDefault();
  	
  	          if (safeString(input.value).trim() === "DELETE") {
  	            confirm();
  	          }
  	
  	          return;
  	        }
  	
  	        if (event.key === "Escape") {
  	          event.preventDefault();
  	          cancel();
  	        }
  	      });
  	
  	      deleteButton.addEventListener("click",
  	        event => {
  	          event.preventDefault();
  	          confirm();
  	        });
  	
  	      cancelButtons.forEach(button => {
  	        button.addEventListener("click", event => {
  	          event.preventDefault();
  	          cancel();
  	        });
  	      });
  	
  	      refreshState();
  	    }
  	
  	    function buildLocationTypeOptionsForCompany(companyValue) {
  	      const store = getCompanyTypeStore(companyValue);
  	      const byType = Object.create(null);
  	
  	      function addTypeOption(record) {
  	        const normal = normalizeManifestLocationTypeRecord(record);
  	
  	        if (!normal) return;
  	
  	        const label = safeString(normal.TypeName).trim();
  	
  	        if (!label) return;
  	
  	        const key = label.toLowerCase();
  	
  	        if (byType[key]) return;
  	
  	        byType[key] = {
  	          value: normal.Value || createLocationTypeValue(label),
  	          label,
  	          color: normalizeLocationTypeColorValue(normal.Color),
  	          raw: normal
  	        };
  	      }
  	
  	      store.forEach(addTypeOption);
  	
  	      const manifestOptions = Object.keys(byType)
  	      .map(key => byType[key])
  	      .sort((a, b) => a.label.localeCompare(b.label, undefined, {
  	        numeric: true,
  	        sensitivity: "base"
  	      }));
  	
  	      return [{
  	        value: ADD_NEW_LOCATION_TYPE_VALUE,
  	        label: "Add New Location Type",
  	        color: DEFAULT_NEW_LOCATION_TYPE_COLOR,
  	        raw: null
  	      },
  	        ...manifestOptions
  	      ];
  	    }
  	
  	    function createDataChannel(appData) {
  	      const companies = getCompaniesFromData(appData);
  	      const registryLocations = getRegistryLocations(appData);
  	      const companyOptions = createCompanyOptionsFromData(companies);
  	
  	      const companySummaries = companies.map((company, index) => {
  	        const locations = flattenLocations(getCompanyLocations(company));
  	
  	        return {
  	          index,
  	          id: getCompanyId(company, index),
  	          name: getCompanyName(company),
  	          directLocationCount: getCompanyLocations(company).length,
  	          flattenedLocationCount: locations.length,
  	          locationTypes: Array.from(
  	            new Set(
  	              locations
  	              .map(location => safeString(getLocationTypeName(location)).trim())
  	              .filter(Boolean)
  	            )
  	          )
  	        };
  	      });
  	
  	      return {
  	        loadedAt: new Date().toISOString(),
  	        appData,
  	        user: appData?.User || null,
  	        companies,
  	        companyOptions,
  	        companySummaries,
  	        registryStore: appData?.LocationRegistryStore || null,
  	        registryLocations,
  	        selectedLocation: {
  	          marker: appData?.SelectedLocationMarker || null,
  	          objectId: appData?.SelectedLocationObjectId || null,
  	          location: appData?.SelectedLocation || null
  	        },
  	        dropdownBridge: {
  	          status: "placeholder",
  	          source: "TrackIT Location Dropdown",
  	          targetHostSelector: "[data-location-dropdown-host]",
  	          notes: [
  	            "Current placeholder only logs data and prepares the mount point.",
  	            "Next pass will mount the existing TrackIT dropdown tree into this host.",
  	            "The uploaded dropdown code already handles company groups, type groups, parent/child location rows, selection, AppData writing, and map focus."
  	          ]
  	        }
  	      };
  	    }
  	
  	    function printDataChannelOnLoad(dataChannel) {
  	      try {
  	        FIF_SILENT_CONSOLE.groupCollapsed("[Carved Edge Shape UI] Data Channel Loaded");
  	        FIF_SILENT_CONSOLE.log("Loaded At:",
  	          dataChannel.loadedAt);
  	        FIF_SILENT_CONSOLE.log("User:",
  	          dataChannel.user);
  	        FIF_SILENT_CONSOLE.log("Companies:",
  	          dataChannel.companies);
  	        FIF_SILENT_CONSOLE.table(dataChannel.companySummaries);
  	        FIF_SILENT_CONSOLE.log("Company Options:",
  	          dataChannel.companyOptions);
  	        FIF_SILENT_CONSOLE.log("Location Registry Store:",
  	          dataChannel.registryStore);
  	        FIF_SILENT_CONSOLE.log("Registry Locations:",
  	          dataChannel.registryLocations);
  	        FIF_SILENT_CONSOLE.log("Selected Location:",
  	          dataChannel.selectedLocation);
  	        FIF_SILENT_CONSOLE.log("Raw App Data:",
  	          dataChannel.appData);
  	        FIF_SILENT_CONSOLE.log("Dropdown Bridge Placeholder:",
  	          dataChannel.dropdownBridge);
  	        FIF_SILENT_CONSOLE.groupEnd();
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[Carved Edge Shape UI] Could not print data channel.",
  	          error);
  	      }
  	    }
  	
  	    function mountLocationDropdownBridgePlaceholder(root) {
  	      const host = root.querySelector("[data-location-dropdown-host]");
  	
  	      if (!host || !DATA_CHANNEL) return;
  	
  	      host.innerHTML = `
  	      <div class="ces-dropdown-placeholder">
  	      <span class="ces-dropdown-placeholder-icon">⌕</span>
  	      <span class="ces-dropdown-placeholder-text">Search Location</span>
  	      <span class="ces-dropdown-placeholder-caret">⌄</span>
  	      </div>
  	      `;
  	
  	      const bridge = {
  	        status: "placeholder-mounted",
  	        host,
  	        uiRoot: root,
  	        dataChannel: DATA_CHANNEL,
  	        mapInput: MAP_INPUT,
  	
  	        resizeTopShell() {
  	          scheduleSearchPanelHeight(root);
  	        },
  	
  	        resetTopShell() {
  	          resetSearchPanelHeight(root);
  	        },
  	
  	        mountTrackITDropdown() {
  	          (function () {
  	            // ============================================================
  	            // TrackIT Location Dropdown — Placeholder Card Router Rewrite
  	            //
  	            // Company -> Top-Level Type Groups -> Parent/Child Location Tree
  	            //
  	            // Main behaviour:
  	            //   - Search locations.
  	            //   - Keep company groups open by default.
  	            //   - Type groups start collapsed.
  	            //   - Parent locations with children start collapsed.
  	            //   - First click on collapsed parent opens children only.
  	            //   - Second click selects the parent.
  	            //   - Selection writes to AppData.
  	            //   - Selection focuses/zooms map when possible.
  	            //   - Selection opens a placeholder card/router.
  	            //
  	            // Backendless Custom Code Inputs:
  	            //   Component: Dropdown component
  	            //   List:      App Data -> User -> Companies
  	            //   App:       App Data
  	            //   Map:       Settings - Hub Location Map component
  	            //   Hub:       Optional container/hub component
  	            //
  	            // Future carved UI mount:
  	            //   Can also mount into:
  	            //   window.__CarvedEdgeShapeDropdownBridge.host
  	            // ============================================================
  	
  	            "use strict";
  	
  	            const MAP_COMPONENT_UID = "67483b334ccf3f07d1147d3805582d58";
  	            const MAP_SELECT_ZOOM = 20;
  	            const MAX_Z_INDEX = 2147483647;
  	            const MAP_CONTROL_GAP_PX = 10;
  	
  	            const GOOGLE_LOCATION_COUNTRY_CODE = "za";
  	            const GOOGLE_LOCATION_REGION = "za";
  	            const GOOGLE_LOCATION_LABEL = "South Africa";
  	
  	            // Simple point data model:
  	            //   Companies.PointLocations -> PointLocations
  	            // A point has no location parent/child relations and is not stored in Manifest.
  	            // The qualified relation name lets Backendless create the one-to-many
  	            // relation column automatically the first time a point is saved.
  	            const POINT_LOCATION_TABLE = "PointLocations";
  	            const POINT_COMPANY_TABLE = "Companies";
  	            const COMPANY_POINT_RELATION_FIELD = "PointLocations";
  	            const COMPANY_POINT_RELATION_DEFINITION =
  	            `${COMPANY_POINT_RELATION_FIELD}:${POINT_LOCATION_TABLE}:n`;
  	
  	            // Reuse the existing approved Directions WhatsApp template for point routes.
  	            const POINT_WHATSAPP_SERVICE_NAME = "WhatsApp";
  	            const POINT_WHATSAPP_METHOD_NAME = "Send_Directions_Template";
  	
  	            // Change this later if required:
  	            //   "placeholder" = show temporary action card
  	            //   "card-router" = dispatch card events and show card
  	            //   "select-only" = select/write/focus only
  	            //   "open-panel" = old behaviour, try LocationRegistry / LocationRegistryUI
  	            const SEARCH_ACTION_MODE = "placeholder";
  	
  	            const STYLE_ID = "trackit-compact-location-dropdown-css";
  	            const EVENT_LOCATION_CHANGE = "locationDropdownChange";
  	
  	            const ROUTER_EVENTS = {
  	              selected: "trackitLocationSelected",
  	              cardRequested: "trackitLocationCardRequested",
  	              dataCardRequested: "trackitLocationDataCardRequested",
  	              childrenRequested: "trackitLocationChildrenRequested",
  	              functionalityRequested: "trackitLocationFunctionalityRequested",
  	              editRequested: "trackitLocationEditRequested"
  	            };
  	
  	            const MAP_CONTROL_SELECTORS = [
  	              ".trackit-compact-map-control",
  	              "#fif-carved-edge-shape-ui .ces-bottom-shape",
  	              "#fif-carved-edge-shape-ui .ces-bottom-content"
  	            ];
  	
  	            // ============================================================
  	            // Backendless argument helpers
  	            // ============================================================
  	
  	            function readBackendlessArg(name, lowerName, index) {
  	              try {
  	                if (typeof ___arguments !== "undefined" && ___arguments) {
  	                  if (___arguments[name] !== undefined) return ___arguments[name];
  	                  if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	                  if (___arguments[index] !== undefined) return ___arguments[index];
  	                }
  	              } catch (_) {}
  	
  	              return undefined;
  	            }
  	
  	            const bridge =
  	            typeof window !== "undefined" && window.__CarvedEdgeShapeDropdownBridge
  	            ? window.__CarvedEdgeShapeDropdownBridge: null;
  	
  	            const ComponentInput =
  	            typeof Component !== "undefined"
  	            ? Component: readBackendlessArg("Component", "component", 0);
  	
  	            const ListInput =
  	            typeof List !== "undefined"
  	            ? List: readBackendlessArg("List", "list", 1);
  	
  	            const AppRoot =
  	            typeof App !== "undefined"
  	            ? App: readBackendlessArg("App", "app", 2);
  	
  	            const MapInputFromArgs = readBackendlessArg("Map", "map", 3);
  	
  	            const HubRoot =
  	            typeof Hub !== "undefined"
  	            ? Hub: readBackendlessArg("Hub", "hub", 4);
  	
  	            const MapRoot =
  	            MapInputFromArgs ||
  	            MAP_INPUT ||
  	            bridge?.mapInput ||
  	            bridge?.dataChannel?.mapInput ||
  	            (
  	              typeof Map !== "undefined" &&
  	              (typeof window === "undefined" || Map !== window.Map)
  	              ? Map: null
  	            );
  	
  	            function resolveElementFromComponent(value) {
  	              try {
  	                if (!value) return null;
  	
  	                if (typeof HTMLElement !== "undefined" && value instanceof HTMLElement) {
  	                  return value;
  	                }
  	
  	                if (value.element && typeof HTMLElement !== "undefined" && value.element instanceof HTMLElement) {
  	                  return value.element;
  	                }
  	
  	                if (value.el && typeof HTMLElement !== "undefined" && value.el instanceof HTMLElement) {
  	                  return value.el;
  	                }
  	
  	                if (value.node && typeof HTMLElement !== "undefined" && value.node instanceof HTMLElement) {
  	                  return value.node;
  	                }
  	
  	                if (value.domNode && typeof HTMLElement !== "undefined" && value.domNode instanceof HTMLElement) {
  	                  return value.domNode;
  	                }
  	
  	                if (typeof value.getElement === "function") {
  	                  const el = value.getElement();
  	                  if (el) return el;
  	                }
  	
  	                if (typeof value.getDomNode === "function") {
  	                  const el = value.getDomNode();
  	                  if (el) return el;
  	                }
  	              } catch (_) {}
  	
  	              return null;
  	            }
  	
  	            const root =
  	            bridge?.host ||
  	            resolveElementFromComponent(ComponentInput) ||
  	            ComponentInput?.element ||
  	            ComponentInput?.el ||
  	            ComponentInput?.node ||
  	            ComponentInput ||
  	            null;
  	
  	            if (!root) {
  	              FIF_SILENT_CONSOLE.error("[TrackIT Location Dropdown] Component root / host not found.");
  	              return;
  	            }
  	
  	            const hubElement =
  	            resolveElementFromComponent(HubRoot) ||
  	            root.closest?.(".bl-block") ||
  	            root.parentElement ||
  	            null;
  	
  	            const hubOriginalStyle = hubElement
  	            ? {
  	              height: hubElement.style.height || "",
  	              minHeight: hubElement.style.minHeight || "",
  	              maxHeight: hubElement.style.maxHeight || "",
  	              overflow: hubElement.style.overflow || "",
  	              transition: hubElement.style.transition || ""
  	            }: null;
  	
  	            if (typeof root.__locationDropdownCleanup === "function") {
  	              try {
  	                root.__locationDropdownCleanup();
  	              } catch (_) {}
  	            }
  	
  	            if (!root.__trackitCollapsedLocationTree) {
  	              root.__trackitCollapsedLocationTree = {};
  	            }
  	
  	            root.innerHTML = "";
  	            root.style.maxWidth = "100%";
  	            root.style.boxSizing = "border-box";
  	            root.style.overflow = "visible";
  	            root.style.position = root.style.position || "relative";
  	            root.style.zIndex = String(MAX_Z_INDEX);
  	
  	            // ============================================================
  	            // General helpers
  	            // ============================================================
  	
  	            function safeString(value) {
  	              return value === undefined || value === null ? "": String(value);
  	            }
  	
  	            function escapeHtml(value) {
  	              return safeString(value)
  	              .replace(/&/g, "&amp;")
  	              .replace(/</g, "&lt;")
  	              .replace(/>/g, "&gt;")
  	              .replace(/"/g, "&quot;")
  	              .replace(/'/g, "&#039;");
  	            }
  	
  	            function getBackendlessContext() {
  	              try {
  	                if (typeof ___arguments !== "undefined" && ___arguments?.context) {
  	                  return ___arguments.context;
  	                }
  	              } catch (_) {}
  	
  	              return null;
  	            }
  	
  	            function getAppBag() {
  	              const ctx = getBackendlessContext();
  	
  	              if (ctx?.appData) return ctx.appData;
  	
  	              if (bridge?.dataChannel?.appData) {
  	                return bridge.dataChannel.appData;
  	              }
  	
  	              if (AppRoot?.data && typeof AppRoot.data === "object") {
  	                return AppRoot.data;
  	              }
  	
  	              if (AppRoot && typeof AppRoot === "object" && !("data" in AppRoot)) {
  	                return AppRoot;
  	              }
  	
  	              if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	                return BackendlessUI.App.data;
  	              }
  	
  	              if (typeof window !== "undefined" && window.AppData) {
  	                return window.AppData.data || window.AppData;
  	              }
  	
  	              return null;
  	            }
  	
  	            function refreshApp() {
  	              try {
  	                BackendlessUI?.App?.refresh?.();
  	              } catch (_) {}
  	            }
  	
  	            function getObjectProperty(object, propPath) {
  	              if (!object) return undefined;
  	
  	              if (typeof propPath !== "string" || object[propPath] !== undefined) {
  	                return object[propPath];
  	              }
  	
  	              const parts = propPath.split(".");
  	              let current = object;
  	
  	              for (let i = 0; i < parts.length; i++) {
  	                if (!current || current[parts[i]] === undefined) return undefined;
  	                current = current[parts[i]];
  	              }
  	
  	              return current;
  	            }
  	
  	            function getCompaniesFromAnySource() {
  	              if (Array.isArray(ListInput)) return ListInput;
  	
  	              if (Array.isArray(bridge?.dataChannel?.companies)) {
  	                return bridge.dataChannel.companies;
  	              }
  	
  	              const appData = getAppBag();
  	
  	              const userCompanies =
  	              appData?.User?.Companies ||
  	              appData?.User?.companies ||
  	              appData?.Companies ||
  	              appData?.companies ||
  	              [];
  	
  	              return Array.isArray(userCompanies) ? userCompanies: [];
  	            }
  	
  	            const companies = getCompaniesFromAnySource();
  	
  	            // ============================================================
  	            // AppData selection helpers
  	            // ============================================================
  	
  	            function readSelectedLocationMarkerId() {
  	              const appData = getAppBag();
  	
  	              return (
  	                appData?.SelectedLocationMarker ||
  	                appData?.SelectedLocationObjectId ||
  	                appData?.SelectedLocation?.objectId ||
  	                appData?.SelectedLocation?.ObjectId ||
  	                appData?.SelectedLocation?.id ||
  	                null
  	              );
  	            }
  	
  	            function clearSelectedLocationFromAppData() {
  	              const appData = getAppBag();
  	
  	              if (!appData) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] AppData not found. Could not clear selected location.");
  	                return;
  	              }
  	
  	              try {
  	                delete appData.SelectedLocationMarker;
  	              } catch (_) {
  	                appData.SelectedLocationMarker = null;
  	              }
  	
  	              try {
  	                delete appData.SelectedLocationObjectId;
  	              } catch (_) {
  	                appData.SelectedLocationObjectId = null;
  	              }
  	
  	              try {
  	                delete appData.SelectedLocation;
  	              } catch (_) {
  	                appData.SelectedLocation = null;
  	              }
  	
  	              refreshApp();
  	            }
  	
  	            function writeSelectedLocationToAppData(location) {
  	              if (!location) return;
  	
  	              const appData = getAppBag();
  	
  	              if (!appData) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] AppData not found. Could not write selected location.");
  	                return;
  	              }
  	
  	              const objectId = getLocationValue(location);
  	
  	              if (!objectId) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Selected location has no objectId.", location);
  	                return;
  	              }
  	
  	              appData.SelectedLocationMarker = objectId;
  	              appData.SelectedLocationObjectId = objectId;
  	
  	              let plain = location;
  	
  	              try {
  	                plain = JSON.parse(JSON.stringify(location));
  	              } catch (_) {}
  	
  	              appData.SelectedLocation = plain;
  	              refreshApp();
  	            }
  	
  	            function findLocationByObjectId(inputValue) {
  	              if (!inputValue) return null;
  	
  	              const value = String(inputValue);
  	              const found = flatRows.find(row => row.value === value);
  	
  	              return found?.location || null;
  	            }
  	
  	            // ============================================================
  	            // Number / coordinate helpers
  	            // ============================================================
  	
  	            function num(value) {
  	              return typeof value === "number" ? value: Number(value);
  	            }
  	
  	            function firstFinite(values) {
  	              for (let i = 0; i < values.length; i++) {
  	                const value = num(values[i]);
  	
  	                if (Number.isFinite(value)) {
  	                  return value;
  	                }
  	              }
  	
  	              return NaN;
  	            }
  	
  	            function readLatLngFromKnownPaths(location) {
  	              const lat = firstFinite([
  	                getObjectProperty(location, "position.latitude"),
  	                getObjectProperty(location, "Position.latitude"),
  	                getObjectProperty(location, "center.latitude"),
  	                getObjectProperty(location, "Center.latitude"),
  	                getObjectProperty(location, "location.latitude"),
  	                getObjectProperty(location, "Location.latitude"),
  	                getObjectProperty(location, "Location.position.latitude"),
  	                getObjectProperty(location, "geo.latitude"),
  	                getObjectProperty(location, "Geo.latitude"),
  	                getObjectProperty(location, "latitude"),
  	                getObjectProperty(location, "Latitude"),
  	                getObjectProperty(location, "lat"),
  	                getObjectProperty(location, "Lat")
  	              ]);
  	
  	              const lng = firstFinite([
  	                getObjectProperty(location, "position.longitude"),
  	                getObjectProperty(location, "Position.longitude"),
  	                getObjectProperty(location, "center.longitude"),
  	                getObjectProperty(location, "Center.longitude"),
  	                getObjectProperty(location, "location.longitude"),
  	                getObjectProperty(location, "Location.longitude"),
  	                getObjectProperty(location, "Location.position.longitude"),
  	                getObjectProperty(location, "geo.longitude"),
  	                getObjectProperty(location, "Geo.longitude"),
  	                getObjectProperty(location, "longitude"),
  	                getObjectProperty(location, "Longitude"),
  	                getObjectProperty(location, "lng"),
  	                getObjectProperty(location, "Lng"),
  	                getObjectProperty(location, "lon"),
  	                getObjectProperty(location, "Lon")
  	              ]);
  	
  	              if (Number.isFinite(lat) && Number.isFinite(lng)) {
  	                return {
  	                  lat,
  	                  lng
  	                };
  	              }
  	
  	              return null;
  	            }
  	
  	            function collectLatLngPoints(value, points, depth) {
  	              if (!value || points.length >= 250 || depth > 8) return;
  	
  	              if (Array.isArray(value)) {
  	                if (
  	                  value.length >= 2 &&
  	                  typeof value[0] !== "object" &&
  	                  typeof value[1] !== "object"
  	                ) {
  	                  const a = num(value[0]);
  	                  const b = num(value[1]);
  	
  	                  if (Number.isFinite(a) && Number.isFinite(b)) {
  	                    if (Math.abs(a) <= 180 && Math.abs(b) <= 90) {
  	                      points.push({
  	                        lat: b, lng: a
  	                      });
  	                      return;
  	                    }
  	
  	                    if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
  	                      points.push({
  	                        lat: a, lng: b
  	                      });
  	                      return;
  	                    }
  	                  }
  	                }
  	
  	                value.forEach(child => collectLatLngPoints(child, points, depth + 1));
  	                return;
  	              }
  	
  	              if (typeof value === "object") {
  	                const direct = readLatLngFromKnownPaths(value);
  	
  	                if (direct) {
  	                  points.push(direct);
  	                }
  	
  	                const possibleGeometry =
  	                value.coordinates ||
  	                value.Coordinates ||
  	                value.points ||
  	                value.Points ||
  	                value.path ||
  	                value.Path ||
  	                value.polygon ||
  	                value.Polygon ||
  	                value.boundary ||
  	                value.Boundary ||
  	                value.geometry ||
  	                value.Geometry;
  	
  	                if (possibleGeometry && possibleGeometry !== value) {
  	                  collectLatLngPoints(possibleGeometry, points, depth + 1);
  	                }
  	              }
  	            }
  	
  	            function getLocationCenter(location) {
  	              const direct = readLatLngFromKnownPaths(location);
  	
  	              if (direct) return direct;
  	
  	              const points = [];
  	
  	              collectLatLngPoints(location?.coordinates, points, 0);
  	              collectLatLngPoints(location?.Coordinates, points, 0);
  	              collectLatLngPoints(location?.polygon, points, 0);
  	              collectLatLngPoints(location?.Polygon, points, 0);
  	              collectLatLngPoints(location?.boundary, points, 0);
  	              collectLatLngPoints(location?.Boundary, points, 0);
  	              collectLatLngPoints(location?.geometry, points, 0);
  	              collectLatLngPoints(location?.Geometry, points, 0);
  	              collectLatLngPoints(location?.Polygon?.coordinates, points, 0);
  	              collectLatLngPoints(location?.Polygon?.boundary?.points, points, 0);
  	
  	              if (!points.length) return null;
  	
  	              const total = points.reduce((sum, point) => {
  	                sum.lat += point.lat;
  	                sum.lng += point.lng;
  	                return sum;
  	              }, {
  	                lat: 0, lng: 0
  	              });
  	
  	              return {
  	                lat: total.lat / points.length,
  	                lng: total.lng / points.length
  	              };
  	            }
  	
  	            // ============================================================
  	            // Map helpers
  	            // ============================================================
  	
  	            function getFallbackMapComponentByUid() {
  	              try {
  	                const ctx = getBackendlessContext();
  	                return ctx?.getComponentByUid?.(MAP_COMPONENT_UID) || null;
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function resolveGMap(mapMaybe) {
  	              try {
  	                const candidate = mapMaybe || MapRoot || getFallbackMapComponentByUid();
  	
  	                return (
  	                  candidate?.map?.map ||
  	                  candidate?.map ||
  	                  candidate ||
  	                  null
  	                );
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function getPolygonLatLngsFromLocation(location) {
  	              const poly =
  	              location?.Polygon ||
  	              location?.polygon ||
  	              location?.Boundary ||
  	              location?.boundary ||
  	              null;
  	
  	              if (!poly) return null;
  	
  	              if (poly.boundary?.points && Array.isArray(poly.boundary.points)) {
  	                return poly.boundary.points
  	                .map(p => ({
  	                  lat: Number(p.y),
  	                  lng: Number(p.x)
  	                }))
  	                .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  	              }
  	
  	              if (poly.points && Array.isArray(poly.points)) {
  	                return poly.points
  	                .map(p => ({
  	                  lat: Number(p.y ?? p.lat ?? p.latitude),
  	                  lng: Number(p.x ?? p.lng ?? p.lon ?? p.longitude)
  	                }))
  	                .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  	              }
  	
  	              if (Array.isArray(poly.coordinates) && Array.isArray(poly.coordinates[0])) {
  	                return poly.coordinates[0]
  	                .map(coord => ({
  	                  lat: Number(coord[1]),
  	                  lng: Number(coord[0])
  	                }))
  	                .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  	              }
  	
  	              if (Array.isArray(poly.Coordinates) && Array.isArray(poly.Coordinates[0])) {
  	                return poly.Coordinates[0]
  	                .map(coord => ({
  	                  lat: Number(coord[1]),
  	                  lng: Number(coord[0])
  	                }))
  	                .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  	              }
  	
  	              return null;
  	            }
  	
  	            function fitMapToLatLngs(gMap, latLngs) {
  	              try {
  	                if (!gMap || !latLngs || !latLngs.length) return false;
  	
  	                if (
  	                  typeof google === "undefined" ||
  	                  !google.maps ||
  	                  !google.maps.LatLngBounds
  	                ) {
  	                  return false;
  	                }
  	
  	                const bounds = new google.maps.LatLngBounds();
  	
  	                latLngs.forEach(p => {
  	                  if (Number.isFinite(p.lat) && Number.isFinite(p.lng)) {
  	                    bounds.extend(p);
  	                  }
  	                });
  	
  	                if (bounds.isEmpty && bounds.isEmpty()) {
  	                  return false;
  	                }
  	
  	                if (typeof gMap.fitBounds === "function") {
  	                  gMap.fitBounds(bounds);
  	                }
  	
  	                if (typeof gMap.panToBounds === "function") {
  	                  gMap.panToBounds(bounds);
  	                }
  	
  	                if (google.maps.event?.addListenerOnce) {
  	                  google.maps.event.addListenerOnce(gMap, "bounds_changed", function () {
  	                    try {
  	                      const zoom = typeof gMap.getZoom === "function" ? gMap.getZoom(): null;
  	
  	                      if (Number.isFinite(zoom) && zoom > 18) {
  	                        gMap.setZoom(18);
  	                      }
  	                    } catch (_) {}
  	                  });
  	                }
  	
  	                return true;
  	              } catch (_) {
  	                return false;
  	              }
  	            }
  	
  	            function fitMapToGooglePolygon(gMap,
  	              polygon) {
  	              try {
  	                if (!gMap || !polygon) return false;
  	
  	                if (
  	                  typeof google === "undefined" ||
  	                  !google.maps ||
  	                  !google.maps.LatLngBounds
  	                ) {
  	                  return false;
  	                }
  	
  	                const bounds = new google.maps.LatLngBounds();
  	                const paths = polygon.getPaths ? polygon.getPaths(): null;
  	
  	                if (paths && typeof paths.getLength === "function") {
  	                  for (let pathIndex = 0; pathIndex < paths.getLength(); pathIndex++) {
  	                    const path = paths.getAt(pathIndex);
  	
  	                    if (!path || typeof path.getLength !== "function") continue;
  	
  	                    for (let i = 0; i < path.getLength(); i++) {
  	                      bounds.extend(path.getAt(i));
  	                    }
  	                  }
  	                } else {
  	                  const path = polygon.getPath ? polygon.getPath(): null;
  	
  	                  if (path && typeof path.getLength === "function") {
  	                    for (let i = 0; i < path.getLength(); i++) {
  	                      bounds.extend(path.getAt(i));
  	                    }
  	                  }
  	                }
  	
  	                if (bounds.isEmpty && bounds.isEmpty()) {
  	                  return false;
  	                }
  	
  	                if (typeof gMap.fitBounds === "function") {
  	                  gMap.fitBounds(bounds);
  	                  return true;
  	                }
  	              } catch (_) {}
  	
  	              return false;
  	            }
  	
  	            function centerMapOnLocation(location, mapMaybe) {
  	              if (!location) return false;
  	
  	              const gMap = resolveGMap(mapMaybe);
  	              if (!gMap) return false;
  	
  	              const polygonPoints = getPolygonLatLngsFromLocation(location);
  	
  	              if (polygonPoints && polygonPoints.length) {
  	                const fitted = fitMapToLatLngs(gMap, polygonPoints);
  	                if (fitted) return true;
  	              }
  	
  	              const center = getLocationCenter(location);
  	
  	              if (!center || !Number.isFinite(center.lat) || !Number.isFinite(center.lng)) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Location has no valid latitude/longitude.", location);
  	                return false;
  	              }
  	
  	              try {
  	                if (typeof gMap.setCenter === "function") {
  	                  gMap.setCenter({
  	                    lat: center.lat,
  	                    lng: center.lng
  	                  });
  	                } else {
  	                  gMap.center = {
  	                    lat: center.lat,
  	                    lng: center.lng
  	                  };
  	                }
  	
  	                if (typeof gMap.setZoom === "function") {
  	                  gMap.setZoom(MAP_SELECT_ZOOM);
  	                } else {
  	                  gMap.zoom = MAP_SELECT_ZOOM;
  	                }
  	
  	                return true;
  	              } catch (e) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not center map.", e);
  	                return false;
  	              }
  	            }
  	
  	            function focusMapForSelectedLocation(location) {
  	              return centerMapOnLocation(location, MapRoot);
  	            }
  	
  	            function getGoogleAutocompleteService() {
  	              try {
  	                if (
  	                  typeof google === "undefined" ||
  	                  !google.maps ||
  	                  !google.maps.places ||
  	                  !google.maps.places.AutocompleteService
  	                ) {
  	                  return null;
  	                }
  	
  	                if (!googleAutocompleteService) {
  	                  googleAutocompleteService = new google.maps.places.AutocompleteService();
  	                }
  	
  	                return googleAutocompleteService;
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function getGooglePlacesService() {
  	              try {
  	                if (
  	                  typeof google === "undefined" ||
  	                  !google.maps ||
  	                  !google.maps.places ||
  	                  !google.maps.places.PlacesService
  	                ) {
  	                  return null;
  	                }
  	
  	                if (!googlePlacesService) {
  	                  googlePlacesService = new google.maps.places.PlacesService(document.createElement("div"));
  	                }
  	
  	                return googlePlacesService;
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function getGoogleStatusOk() {
  	              try {
  	                return google.maps.places.PlacesServiceStatus.OK;
  	              } catch (_) {
  	                return "OK";
  	              }
  	            }
  	
  	            function focusMapOnGooglePlace(place) {
  	              try {
  	                const gMap = resolveGMap(MapRoot);
  	
  	                if (!gMap || !place || !place.geometry) return false;
  	
  	                if (place.geometry.viewport && typeof gMap.fitBounds === "function") {
  	                  gMap.fitBounds(place.geometry.viewport);
  	                  return true;
  	                }
  	
  	                const location = place.geometry.location;
  	
  	                if (!location) return false;
  	
  	                const lat = typeof location.lat === "function" ? location.lat(): location.lat;
  	                const lng = typeof location.lng === "function" ? location.lng(): location.lng;
  	
  	                if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return false;
  	
  	                if (typeof gMap.setCenter === "function") {
  	                  gMap.setCenter({
  	                    lat: Number(lat),
  	                    lng: Number(lng)
  	                  });
  	                }
  	
  	                if (typeof gMap.setZoom === "function") {
  	                  gMap.setZoom(17);
  	                }
  	
  	                return true;
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not focus Google place.", error);
  	                return false;
  	              }
  	            }
  	
  	            function parseCoordinateSearchValue(value) {
  	              let text = safeString(value).trim();
  	
  	              if (!text) return null;
  	
  	              text = text
  	              .replace(/[\[\]()]/g, " ")
  	              .replace(/\u00b0/g, " ")
  	              .replace(/\b(?:latitude|lat)\b\s*[:=]?/gi, " ")
  	              .replace(/\b(?:longitude|long|lng|lon)\b\s*[:=]?/gi, " ")
  	              .trim();
  	
  	              const parts = /[,;]/.test(text)
  	              ? text.split(/[,;]/)
  	              : text.split(/\s+/);
  	
  	              if (parts.length !== 2) return null;
  	
  	              const numberPattern = /^[+-]?(?:\d+(?:\.\d+)?|\.\d+)$/;
  	              const latText = safeString(parts[0]).trim();
  	              const lngText = safeString(parts[1]).trim();
  	
  	              if (!numberPattern.test(latText) || !numberPattern.test(lngText)) {
  	                return null;
  	              }
  	
  	              const lat = Number(latText);
  	              const lng = Number(lngText);
  	
  	              if (
  	                !Number.isFinite(lat) ||
  	                !Number.isFinite(lng) ||
  	                lat < -90 ||
  	                lat > 90 ||
  	                lng < -180 ||
  	                lng > 180
  	              ) {
  	                return null;
  	              }
  	
  	              return {
  	                lat,
  	                lng
  	              };
  	            }
  	
  	            function normalizePointColor(value) {
  	              const color = safeString(value).trim();
  	
  	              if (/^#([0-9a-f]{6})$/i.test(color)) return color;
  	
  	              return "#ff7a24";
  	            }
  	
  	            function getPointRecordId(point) {
  	              return safeString(
  	                point?.PointId ||
  	                point?.pointId ||
  	                point?.objectId ||
  	                point?.ObjectId ||
  	                point?.id ||
  	                point?.ID ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function getPointCoordinates(point) {
  	              const lat = Number(
  	                point?.Latitude ??
  	                point?.latitude ??
  	                point?.Lat ??
  	                point?.lat
  	              );
  	
  	              const lng = Number(
  	                point?.Longitude ??
  	                point?.longitude ??
  	                point?.Lng ??
  	                point?.lng ??
  	                point?.Lon ??
  	                point?.lon
  	              );
  	
  	              if (
  	                !Number.isFinite(lat) ||
  	                !Number.isFinite(lng) ||
  	                lat < -90 ||
  	                lat > 90 ||
  	                lng < -180 ||
  	                lng > 180
  	              ) {
  	                return null;
  	              }
  	
  	              return { lat, lng };
  	            }
  	
  	            function getPointType(point) {
  	              return safeString(
  	                point?.Type ||
  	                point?.type ||
  	                point?.PointType ||
  	                point?.pointType ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function getPointColor(point) {
  	              return normalizePointColor(
  	                point?.Color ||
  	                point?.color ||
  	                point?.Colour ||
  	                point?.colour ||
  	                "#ff7a24"
  	              );
  	            }
  	
  	            function getPointCompanyLabel(company) {
  	              return safeString(
  	                company?.Name ||
  	                company?.name ||
  	                company?.CompanyName ||
  	                company?.companyName ||
  	                "Company"
  	              ).trim() || "Company";
  	            }
  	
  	            function getPointCompanyId(company) {
  	              return safeString(
  	                company?.objectId ||
  	                company?.ObjectId ||
  	                company?.id ||
  	                company?.ID ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function findPointCompanyById(value) {
  	              const target = safeString(value).trim();
  	
  	              if (!target) return null;
  	
  	              return companies.find(company => {
  	                return getPointCompanyId(company) === target;
  	              }) || null;
  	            }
  	
  	            function rememberPointCompany(company) {
  	              const companyId = getPointCompanyId(company);
  	
  	              pointPreferredCompanyId = companyId;
  	
  	              try {
  	                const appData = getAppBag();
  	
  	                if (!appData) return;
  	
  	                if (company && companyId) {
  	                  appData.SelectedPointCompany = company;
  	                  appData.SelectedPointCompanyObjectId = companyId;
  	                } else {
  	                  delete appData.SelectedPointCompany;
  	                  delete appData.SelectedPointCompanyObjectId;
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function buildPointCompanyOptions(selectedCompanyId) {
  	              const selectedId = safeString(selectedCompanyId).trim();
  	
  	              return companies.map(company => {
  	                const companyId = getPointCompanyId(company);
  	
  	                if (!companyId) return "";
  	
  	                return `
  	                <option value="${escapeHtml(companyId)}" ${companyId === selectedId ? "selected": ""}>
  	                ${escapeHtml(getPointCompanyLabel(company))}
  	                </option>
  	                `;
  	              }).join("");
  	            }
  	
  	            function resolvePointCompany() {
  	              if (activePointContext?.company) {
  	                return activePointContext.company;
  	              }
  	
  	              if (selectedRowData?.companyEntry?.company) {
  	                return selectedRowData.companyEntry.company;
  	              }
  	
  	              const appData = getAppBag();
  	              const selectedPointCompanyObject =
  	              appData?.SelectedPointCompany ||
  	              appData?.selectedPointCompany ||
  	              null;
  	
  	              if (selectedPointCompanyObject && typeof selectedPointCompanyObject === "object") {
  	                const companyId = getPointCompanyId(selectedPointCompanyObject);
  	                const normalCompany = findPointCompanyById(companyId);
  	
  	                if (normalCompany) return normalCompany;
  	              }
  	
  	              const selectedCompanyObject =
  	              appData?.SelectedCompany ||
  	              appData?.selectedCompany ||
  	              null;
  	
  	              if (selectedCompanyObject && typeof selectedCompanyObject === "object") {
  	                const companyId = getPointCompanyId(selectedCompanyObject);
  	                const normalCompany = findPointCompanyById(companyId);
  	
  	                if (normalCompany) return normalCompany;
  	              }
  	
  	              const selectedCompanyId = safeString(
  	                pointPreferredCompanyId ||
  	                appData?.SelectedPointCompanyObjectId ||
  	                appData?.SelectedPointCompanyId ||
  	                appData?.SelectedCompanyObjectId ||
  	                appData?.SelectedCompanyId ||
  	                appData?.selectedCompanyId ||
  	                createState.company ||
  	                ""
  	              ).trim();
  	
  	              if (selectedCompanyId) {
  	                const found = findPointCompanyById(selectedCompanyId);
  	
  	                if (found) return found;
  	              }
  	
  	              return companies.length === 1 ? companies[0] : null;
  	            }
  	
  	            function getCompanyPointRelationStore(company) {
  	              if (!company || typeof company !== "object") return [];
  	
  	              const points =
  	              company.PointLocations ||
  	              company.pointLocations ||
  	              [];
  	
  	              return Array.isArray(points) ? points : [];
  	            }
  	
  	            function normalizePointLocationRecord(point) {
  	              if (!point || typeof point !== "object") return null;
  	
  	              const coordinates = getPointCoordinates(point);
  	
  	              if (!coordinates) return null;
  	
  	              return {
  	                ...point,
  	                Latitude: coordinates.lat,
  	                Longitude: coordinates.lng,
  	                Type: getPointType(point),
  	                Color: getPointColor(point),
  	                IsActive: point?.IsActive !== false
  	              };
  	            }
  	
  	            function getNormalChannelPointStore(company) {
  	              const output = [];
  	              const seen = new Set();
  	
  	              getCompanyPointRelationStore(company).forEach(point => {
  	                const normal = normalizePointLocationRecord(point);
  	
  	                if (!normal || normal.IsActive === false) return;
  	
  	                const key = getPointRecordId(normal) ||
  	                `${normal.Latitude.toFixed(7)}|${normal.Longitude.toFixed(7)}|${normal.Type}`;
  	
  	                if (seen.has(key)) return;
  	
  	                seen.add(key);
  	                output.push(normal);
  	              });
  	
  	              return output;
  	            }
  	
  	            function writeCompanyPointRelationStore(company, points) {
  	              if (!company || typeof company !== "object") return;
  	
  	              const clean = Array.isArray(points) ? points : [];
  	
  	              company.PointLocations = clean;
  	
  	              if (company.pointLocations !== undefined) {
  	                company.pointLocations = clean;
  	              }
  	            }
  	
  	            function upsertPointInNormalChannels(company, point) {
  	              const normal = normalizePointLocationRecord(point);
  	
  	              if (!company || !normal) return normal;
  	
  	              const pointId = getPointRecordId(normal);
  	              const next = getNormalChannelPointStore(company).slice();
  	              const index = pointId
  	              ? next.findIndex(item => getPointRecordId(item) === pointId)
  	              : -1;
  	
  	              if (index >= 0) {
  	                next[index] = normal;
  	              } else {
  	                next.push(normal);
  	              }
  	
  	              writeCompanyPointRelationStore(company, next);
  	
  	              try {
  	                const appData = getAppBag();
  	
  	                if (appData) {
  	                  appData.SelectedPointLocation = normal;
  	                }
  	              } catch (_) {}
  	
  	              return normal;
  	            }
  	
  	            function removePointFromNormalChannels(company, pointId) {
  	              if (!company || !pointId) return;
  	
  	              const next = getNormalChannelPointStore(company).filter(point => {
  	                return getPointRecordId(point) !== pointId;
  	              });
  	
  	              writeCompanyPointRelationStore(company, next);
  	
  	              try {
  	                const appData = getAppBag();
  	
  	                if (
  	                  appData?.SelectedPointLocation &&
  	                  getPointRecordId(appData.SelectedPointLocation) === pointId
  	                ) {
  	                  delete appData.SelectedPointLocation;
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function hasPointBackendlessData() {
  	              return !!(
  	                typeof Backendless !== "undefined" &&
  	                Backendless &&
  	                Backendless.Data &&
  	                typeof Backendless.Data.of === "function"
  	              );
  	            }
  	
  	            function extractPointRelationResult(result) {
  	              if (Array.isArray(result)) return result;
  	              if (Array.isArray(result?.data)) return result.data;
  	              return [];
  	            }
  	
  	            function isMissingPointRelationColumnError(error) {
  	              const message = safeString(
  	                error?.message ||
  	                error?.faultString ||
  	                error?.description ||
  	                error ||
  	                ""
  	              ).toLowerCase();
  	
  	              return (
  	                message.includes("unknown column") ||
  	                message.includes("column name") ||
  	                message.includes("relation column") ||
  	                message.includes("pointlocations") && message.includes("column")
  	              );
  	            }
  	
  	            async function loadPointLocationsFromCompanyRelation(company) {
  	              const companyId = getPointCompanyId(company);
  	
  	              if (!companyId || !hasPointBackendlessData()) return null;
  	
  	              const companyStore = Backendless.Data.of(POINT_COMPANY_TABLE);
  	
  	              if (!companyStore || typeof companyStore.loadRelations !== "function") {
  	                return null;
  	              }
  	
  	              let relationQuery = null;
  	
  	              try {
  	                if (
  	                  Backendless.LoadRelationsQueryBuilder &&
  	                  typeof Backendless.LoadRelationsQueryBuilder.create === "function"
  	                ) {
  	                  relationQuery = Backendless.LoadRelationsQueryBuilder.create();
  	                  relationQuery.setRelationName(COMPANY_POINT_RELATION_FIELD);
  	                  relationQuery.setPageSize?.(100);
  	                }
  	              } catch (_) {
  	                relationQuery = null;
  	              }
  	
  	              if (!relationQuery) return null;
  	
  	              try {
  	                const result = await companyStore.loadRelations(
  	                  companyId,
  	                  relationQuery
  	                );
  	
  	                const points = extractPointRelationResult(result)
  	                .map(normalizePointLocationRecord)
  	                .filter(Boolean)
  	                .filter(point => point.IsActive !== false);
  	
  	                writeCompanyPointRelationStore(company, points);
  	
  	                return points;
  	              } catch (error) {
  	                // Before the first point is saved the relation column may not exist yet.
  	                // Treat that as an empty relation; save will create it automatically.
  	                if (isMissingPointRelationColumnError(error)) {
  	                  writeCompanyPointRelationStore(company, []);
  	                  return [];
  	                }
  	
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Point Search] Could not load Company.PointLocations relation.", {
  	                  companyId,
  	                  relation: COMPANY_POINT_RELATION_FIELD,
  	                  error
  	                });
  	
  	                return null;
  	              }
  	            }
  	
  	            function getBackendlessPointObjectId(point) {
  	              return safeString(
  	                point?.objectId ||
  	                point?.ObjectId ||
  	                ""
  	              ).trim();
  	            }
  	
  	            async function addPointToCompanyRelation(companyId, pointObjectId) {
  	              const companyStore = Backendless.Data.of(POINT_COMPANY_TABLE);
  	
  	              if (!companyStore || typeof companyStore.addRelation !== "function") {
  	                throw new Error("Backendless addRelation is unavailable for Companies.PointLocations.");
  	              }
  	
  	              const parent = { objectId: companyId };
  	              const children = [{ objectId: pointObjectId }];
  	
  	              try {
  	                // Qualified form creates Companies.PointLocations automatically when absent.
  	                return await companyStore.addRelation(
  	                  parent,
  	                  COMPANY_POINT_RELATION_DEFINITION,
  	                  children
  	                );
  	              } catch (qualifiedError) {
  	                // Some SDK/runtime combinations prefer the short name once the column exists.
  	                try {
  	                  return await companyStore.addRelation(
  	                    parent,
  	                    COMPANY_POINT_RELATION_FIELD,
  	                    children
  	                  );
  	                } catch (shortNameError) {
  	                  const message = safeString(
  	                    shortNameError?.message ||
  	                    shortNameError?.faultString ||
  	                    qualifiedError?.message ||
  	                    qualifiedError?.faultString ||
  	                    "Unable to create the company point relation."
  	                  );
  	
  	                  throw new Error(
  	                    `Unable to create Company → PointLocations relation. ${message}`
  	                  );
  	                }
  	              }
  	            }
  	
  	            async function persistPointLocationRecord(point, company) {
  	              const coordinates = getPointCoordinates(point);
  	              const companyId = getPointCompanyId(company);
  	
  	              if (!coordinates) {
  	                throw new Error("The point has invalid coordinates.");
  	              }
  	
  	              if (!companyId) {
  	                throw new Error("The selected company has no Backendless objectId.");
  	              }
  	
  	              if (!hasPointBackendlessData()) {
  	                throw new Error("Backendless Data is not available.");
  	              }
  	
  	              const pointStore = Backendless.Data.of(POINT_LOCATION_TABLE);
  	              const currentObjectId = getBackendlessPointObjectId(point);
  	              const payload = {
  	                Latitude: coordinates.lat,
  	                Longitude: coordinates.lng,
  	                Type: getPointType(point),
  	                Color: getPointColor(point),
  	                IsActive: true
  	              };
  	
  	              if (currentObjectId) {
  	                payload.objectId = currentObjectId;
  	              }
  	
  	              const saved = await pointStore.save(payload);
  	              const savedObjectId = getBackendlessPointObjectId(saved);
  	
  	              if (!savedObjectId) {
  	                throw new Error("Backendless saved the point without returning an objectId.");
  	              }
  	
  	              // Only a newly-created point needs to be added to the Company's one relation.
  	              if (!currentObjectId) {
  	                try {
  	                  await addPointToCompanyRelation(companyId, savedObjectId);
  	                } catch (error) {
  	                  // Do not leave an orphan PointLocations row if relation creation fails.
  	                  try {
  	                    await pointStore.remove({ objectId: savedObjectId });
  	                  } catch (_) {}
  	
  	                  throw error;
  	                }
  	              }
  	
  	              const normal = normalizePointLocationRecord(saved);
  	
  	              if (!normal) {
  	                throw new Error("The saved point could not be normalised.");
  	              }
  	
  	              upsertPointInNormalChannels(company, normal);
  	
  	              return normal;
  	            }
  	
  	            async function deletePointLocationRecord(point, company) {
  	              const objectId = getBackendlessPointObjectId(point);
  	
  	              if (!objectId) {
  	                throw new Error("This point has no Backendless objectId.");
  	              }
  	
  	              if (!hasPointBackendlessData()) {
  	                throw new Error("Backendless Data is not available.");
  	              }
  	
  	              const pointStore = Backendless.Data.of(POINT_LOCATION_TABLE);
  	
  	              if (!pointStore || typeof pointStore.remove !== "function") {
  	                throw new Error("Backendless remove is unavailable for PointLocations.");
  	              }
  	
  	              await pointStore.remove({ objectId });
  	              removePointFromNormalChannels(company, objectId);
  	
  	              return objectId;
  	            }
  	
  	            function buildPointMarkerIcon(color) {
  	              if (
  	                typeof google === "undefined" ||
  	                !google?.maps?.SymbolPath ||
  	                google.maps.SymbolPath.CIRCLE === undefined
  	              ) {
  	                return undefined;
  	              }
  	
  	              return {
  	                path: google.maps.SymbolPath.CIRCLE,
  	                scale: 7,
  	                fillColor: normalizePointColor(color),
  	                fillOpacity: 1,
  	                strokeColor: "#ffffff",
  	                strokeOpacity: 0.96,
  	                strokeWeight: 2
  	              };
  	            }
  	
  	            function setPointMarkerColor(marker, color) {
  	              if (!marker) return;
  	
  	              const icon = buildPointMarkerIcon(color);
  	
  	              if (!icon) return;
  	
  	              try {
  	                marker.setIcon(icon);
  	              } catch (_) {}
  	            }
  	
  	            function buildPointMapLabelHtml(point) {
  	              const coordinates = getPointCoordinates(point);
  	              const type = getPointType(point) || "Point";
  	              const coordinateText = coordinates
  	              ? `${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}`
  	              : "";
  	
  	              return `
  	              <div class="trackit-map-location-label-name">${escapeHtml(type)}</div>
  	              ${coordinateText ? `<div class="trackit-map-location-label-area">${escapeHtml(coordinateText)}</div>` : ""}
  	              `;
  	            }
  	
  	            function shouldShowPointMapLabels(gMap) {
  	              try {
  	                const zoom = Number(
  	                  typeof gMap?.getZoom === "function"
  	                  ? gMap.getZoom()
  	                  : gMap?.zoom
  	                );
  	
  	                return Number.isFinite(zoom) && zoom >= 16;
  	              } catch (_) {
  	                return false;
  	              }
  	            }
  	
  	            function createPointMapLabelOverlay(gMap, point, zIndex) {
  	              const coordinates = getPointCoordinates(point);
  	
  	              if (
  	                !gMap ||
  	                !coordinates ||
  	                typeof google === "undefined" ||
  	                !google?.maps ||
  	                typeof google.maps.OverlayView !== "function"
  	              ) {
  	                return null;
  	              }
  	
  	              const overlay = new google.maps.OverlayView();
  	
  	              overlay.__trackitPoint = point;
  	              overlay.__trackitPosition = coordinates;
  	              overlay.__trackitHtml = buildPointMapLabelHtml(point);
  	              overlay.__trackitZIndex = zIndex || 2147483200;
  	              overlay.__trackitDiv = null;
  	              overlay.__trackitVisible = shouldShowPointMapLabels(gMap);
  	              overlay.__trackitZoomListener = null;
  	
  	              overlay.onAdd = function () {
  	                const div = document.createElement("div");
  	
  	                div.className = "trackit-map-location-label trackit-map-point-location-label";
  	                div.innerHTML = overlay.__trackitHtml;
  	                div.style.position = "absolute";
  	                div.style.transform = "translate(-50%, 14px)";
  	                div.style.pointerEvents = "none";
  	                div.style.background = "rgba(0,0,0,0.84)";
  	                div.style.color = "#fff";
  	                div.style.border = "1px solid rgba(255,255,255,0.16)";
  	                div.style.borderRadius = "8px";
  	                div.style.padding = "4px 7px 5px";
  	                div.style.fontFamily = "Inter, Arial, sans-serif";
  	                div.style.fontSize = "10px";
  	                div.style.fontWeight = "900";
  	                div.style.lineHeight = "1.14";
  	                div.style.letterSpacing = "0.01em";
  	                div.style.textAlign = "center";
  	                div.style.whiteSpace = "nowrap";
  	                div.style.boxShadow = "0 8px 18px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,154,61,0.12)";
  	                div.style.backdropFilter = "blur(5px)";
  	                div.style.webkitBackdropFilter = "blur(5px)";
  	                div.style.zIndex = String(overlay.__trackitZIndex);
  	                div.style.display = overlay.__trackitVisible ? "block" : "none";
  	
  	                overlay.__trackitDiv = div;
  	
  	                const panes = overlay.getPanes();
  	
  	                if (panes?.floatPane) {
  	                  panes.floatPane.appendChild(div);
  	                }
  	
  	                try {
  	                  if (typeof gMap.addListener === "function") {
  	                    overlay.__trackitZoomListener = gMap.addListener("zoom_changed", () => {
  	                      overlay.setTrackITPointLabelVisible(shouldShowPointMapLabels(gMap));
  	                    });
  	                  }
  	                } catch (_) {}
  	              };
  	
  	              overlay.draw = function () {
  	                const div = overlay.__trackitDiv;
  	                const projection = overlay.getProjection();
  	
  	                if (!div || !projection || !overlay.__trackitPosition) return;
  	
  	                const pixel = projection.fromLatLngToDivPixel(
  	                  new google.maps.LatLng(
  	                    overlay.__trackitPosition.lat,
  	                    overlay.__trackitPosition.lng
  	                  )
  	                );
  	
  	                if (!pixel) return;
  	
  	                div.style.left = `${pixel.x}px`;
  	                div.style.top = `${pixel.y}px`;
  	                div.style.zIndex = String(overlay.__trackitZIndex);
  	                div.style.display = overlay.__trackitVisible ? "block" : "none";
  	                div.innerHTML = overlay.__trackitHtml;
  	              };
  	
  	              overlay.onRemove = function () {
  	                try {
  	                  overlay.__trackitZoomListener?.remove?.();
  	                } catch (_) {}
  	
  	                overlay.__trackitZoomListener = null;
  	
  	                if (overlay.__trackitDiv?.parentNode) {
  	                  overlay.__trackitDiv.parentNode.removeChild(overlay.__trackitDiv);
  	                }
  	
  	                overlay.__trackitDiv = null;
  	              };
  	
  	              overlay.setTrackITPointLabelData = function (nextPoint, nextZIndex) {
  	                const nextCoordinates = getPointCoordinates(nextPoint);
  	
  	                if (!nextCoordinates) return;
  	
  	                overlay.__trackitPoint = nextPoint;
  	                overlay.__trackitPosition = nextCoordinates;
  	                overlay.__trackitHtml = buildPointMapLabelHtml(nextPoint);
  	                overlay.__trackitZIndex = nextZIndex || overlay.__trackitZIndex || 2147483200;
  	
  	                if (overlay.__trackitDiv) {
  	                  overlay.__trackitDiv.innerHTML = overlay.__trackitHtml;
  	                  overlay.__trackitDiv.style.zIndex = String(overlay.__trackitZIndex);
  	                }
  	
  	                try {
  	                  overlay.draw();
  	                } catch (_) {}
  	              };
  	
  	              overlay.setTrackITPointLabelVisible = function (visible) {
  	                overlay.__trackitVisible = !!visible;
  	
  	                if (overlay.__trackitDiv) {
  	                  overlay.__trackitDiv.style.display = overlay.__trackitVisible ? "block" : "none";
  	                }
  	              };
  	
  	              overlay.setMap(gMap);
  	
  	              return overlay;
  	            }
  	
  	            function updatePointMarkerLabel(marker, point) {
  	              if (!marker || !point) return;
  	
  	              const label = marker.__trackitPointLabel || null;
  	              const zIndex = marker.__trackitPointSaved ? 2147483250 : 2147483350;
  	
  	              if (label && typeof label.setTrackITPointLabelData === "function") {
  	                label.setTrackITPointLabelData(point, zIndex);
  	                return;
  	              }
  	
  	              const gMap = resolveGMap(MapRoot);
  	
  	              if (!gMap) return;
  	
  	              marker.__trackitPointLabel = createPointMapLabelOverlay(gMap, point, zIndex);
  	            }
  	
  	            function removePointMarkerLabel(marker) {
  	              const label = marker?.__trackitPointLabel || null;
  	
  	              try {
  	                label?.setMap?.(null);
  	              } catch (_) {}
  	
  	              if (marker) {
  	                marker.__trackitPointLabel = null;
  	              }
  	            }
  	
  	            const POINT_WHATSAPP_COUNTRIES = [{
  	              iso: "ZA",
  	              label: "South Africa",
  	              dial: "+27",
  	              example: "0821234567",
  	              nsnMin: 9,
  	              nsnMax: 9,
  	              mobilePattern: /^[6-8]\d{8}$/
  	            },
  	              {
  	                iso: "BW",
  	                label: "Botswana",
  	                dial: "+267",
  	                example: "71234567",
  	                nsnMin: 7,
  	                nsnMax: 8
  	              },
  	              {
  	                iso: "NA",
  	                label: "Namibia",
  	                dial: "+264",
  	                example: "811234567",
  	                nsnMin: 8,
  	                nsnMax: 9
  	              },
  	              {
  	                iso: "ZW",
  	                label: "Zimbabwe",
  	                dial: "+263",
  	                example: "771234567",
  	                nsnMin: 9,
  	                nsnMax: 9
  	              },
  	              {
  	                iso: "ZM",
  	                label: "Zambia",
  	                dial: "+260",
  	                example: "971234567",
  	                nsnMin: 9,
  	                nsnMax: 9
  	              },
  	              {
  	                iso: "MZ",
  	                label: "Mozambique",
  	                dial: "+258",
  	                example: "841234567",
  	                nsnMin: 9,
  	                nsnMax: 9
  	              },
  	              {
  	                iso: "LS",
  	                label: "Lesotho",
  	                dial: "+266",
  	                example: "50123456",
  	                nsnMin: 8,
  	                nsnMax: 8
  	              },
  	              {
  	                iso: "SZ",
  	                label: "Eswatini",
  	                dial: "+268",
  	                example: "76123456",
  	                nsnMin: 8,
  	                nsnMax: 8
  	              },
  	              {
  	                iso: "MW",
  	                label: "Malawi",
  	                dial: "+265",
  	                example: "991234567",
  	                nsnMin: 9,
  	                nsnMax: 9
  	              },
  	              {
  	                iso: "GB",
  	                label: "United Kingdom",
  	                dial: "+44",
  	                example: "7123456789",
  	                nsnMin: 9,
  	                nsnMax: 10
  	              },
  	              {
  	                iso: "US",
  	                label: "United States",
  	                dial: "+1",
  	                example: "3133950896",
  	                nsnMin: 10,
  	                nsnMax: 10
  	              },
  	              {
  	                iso: "INTL",
  	                label: "International",
  	                dial: "",
  	                example: "+27821234567",
  	                nsnMin: 8,
  	                nsnMax: 15,
  	                allowAnyIntl: true
  	              }];
  	
  	            function getPointWhatsappCountryByIso(iso) {
  	              return POINT_WHATSAPP_COUNTRIES.find(country => {
  	                return country.iso === iso;
  	              }) || POINT_WHATSAPP_COUNTRIES[0];
  	            }
  	
  	            function getPointWhatsappCountryOptionsHtml(selectedIso) {
  	              return POINT_WHATSAPP_COUNTRIES.map(country => {
  	                const selected = country.iso === selectedIso ? "selected": "";
  	                const label = country.dial
  	                ? `${country.iso} ${country.dial}`
  	                : `${country.iso} +`;
  	
  	                return `<option value="${country.iso}" ${selected}>${label}</option>`;
  	              }).join("");
  	            }
  	
  	            function normalisePointWhatsappNumber(raw, countryIso) {
  	              const country = getPointWhatsappCountryByIso(countryIso || "ZA");
  	              let text = safeString(raw).trim();
  	
  	              if (!text) {
  	                return {
  	                  ok: false,
  	                  value: "",
  	                  error: "Enter a WhatsApp number first."
  	                };
  	              }
  	
  	              text = text.replace(/^whatsapp:/i, "").trim();
  	              text = text.replace(/[^\d+]/g, "");
  	
  	              const plusCount = (text.match(/\+/g) || []).length;
  	
  	              if (plusCount > 1 || (text.includes("+") && !text.startsWith("+"))) {
  	                return {
  	                  ok: false,
  	                  value: "",
  	                  error: "Invalid WhatsApp number format."
  	                };
  	              }
  	
  	              const digits = text.replace(/\D/g, "");
  	
  	              if (country.allowAnyIntl) {
  	                if (!text.startsWith("+")) {
  	                  return {
  	                    ok: false,
  	                    value: "",
  	                    error: "Use full international format, for example +27821234567."
  	                  };
  	                }
  	
  	                if (digits.length < 8 || digits.length > 15) {
  	                  return {
  	                    ok: false,
  	                    value: "",
  	                    error: "WhatsApp number must be 8 to 15 digits in international format."
  	                  };
  	                }
  	
  	                return {
  	                  ok: true,
  	                  value: `+${digits}`,
  	                  country
  	                };
  	              }
  	
  	              const dialDigits = country.dial.replace(/\D/g, "");
  	              let nationalNumber = "";
  	
  	              if (text.startsWith("+")) {
  	                if (!digits.startsWith(dialDigits)) {
  	                  return {
  	                    ok: false,
  	                    value: "",
  	                    error: `Number does not match selected country ${country.iso} ${country.dial}.`
  	                  };
  	                }
  	
  	                nationalNumber = digits.slice(dialDigits.length);
  	              } else {
  	                if (digits.startsWith(dialDigits) && digits.length > dialDigits.length + 3) {
  	                  nationalNumber = digits.slice(dialDigits.length);
  	                } else {
  	                  nationalNumber = digits;
  	                }
  	
  	                if (nationalNumber.startsWith("0")) {
  	                  nationalNumber = nationalNumber.slice(1);
  	                }
  	              }
  	
  	              if (
  	                nationalNumber.length < country.nsnMin ||
  	                nationalNumber.length > country.nsnMax
  	              ) {
  	                return {
  	                  ok: false,
  	                  value: "",
  	                  error: `${country.iso} number must be ${country.nsnMin === country.nsnMax ? country.nsnMin : `${country.nsnMin}-${country.nsnMax}`} digits after ${country.dial}.`
  	                };
  	              }
  	
  	              if (country.mobilePattern && !country.mobilePattern.test(nationalNumber)) {
  	                return {
  	                  ok: false,
  	                  value: "",
  	                  error: `That does not look like a valid ${country.iso} mobile WhatsApp number.`
  	                };
  	              }
  	
  	              const e164 = `${country.dial}${nationalNumber}`;
  	              const e164Digits = e164.replace(/\D/g, "");
  	
  	              if (e164Digits.length < 8 || e164Digits.length > 15) {
  	                return {
  	                  ok: false,
  	                  value: "",
  	                  error: "WhatsApp number must be valid international E.164 format."
  	                };
  	              }
  	
  	              return {
  	                ok: true,
  	                value: e164,
  	                country
  	              };
  	            }
  	
  	            function getPointWhatsappButtonHtml(label) {
  	              return `
  	              <svg class="trackit-point-whatsapp-icon" viewBox="0 0 32 32" aria-hidden="true">
  	              <path fill="currentColor" d="M16.02 3.2C9.02 3.2 3.34 8.78 3.34 15.66c0 2.22.6 4.38 1.74 6.27L3.2 28.8l7.08-1.84a12.9 12.9 0 0 0 5.74 1.36c7 0 12.68-5.58 12.68-12.46S23.02 3.2 16.02 3.2Zm0 22.98c-1.84 0-3.64-.49-5.2-1.42l-.37-.22-4.2 1.09 1.12-4.02-.25-.41a10.06 10.06 0 0 1-1.56-5.34c0-5.69 4.7-10.32 10.46-10.32s10.46 4.63 10.46 10.32-4.7 10.32-10.46 10.32Zm5.74-7.72c-.31-.15-1.84-.9-2.13-1-.29-.1-.5-.15-.71.15-.21.31-.82 1-.99 1.2-.18.2-.36.23-.67.08-.31-.15-1.31-.48-2.5-1.53-.92-.81-1.54-1.81-1.72-2.12-.18-.3-.02-.47.13-.62.14-.14.31-.36.47-.54.16-.18.21-.31.31-.51.1-.2.05-.38-.03-.54-.08-.15-.71-1.69-.97-2.31-.25-.6-.51-.52-.71-.53h-.6c-.21 0-.55.08-.84.38-.29.3-1.1 1.06-1.1 2.59s1.13 3.01 1.29 3.22c.16.2 2.23 3.35 5.41 4.7.76.32 1.35.51 1.81.65.76.24 1.45.21 2 .13.61-.09 1.84-.74 2.1-1.45.26-.71.26-1.32.18-1.45-.08-.13-.29-.2-.6-.36Z"/>
  	              </svg>
  	              <span>${escapeHtml(label)}</span>
  	              `;
  	            }
  	
  	            function setPointWhatsappButtonState(button, label, sending) {
  	              if (!button) return;
  	
  	              button.disabled = !!sending;
  	              button.classList.toggle("sending", !!sending);
  	              button.innerHTML = getPointWhatsappButtonHtml(label);
  	            }
  	
  	            function setPointWhatsappStatus(message, state) {
  	              const status = pointEditorPanel.querySelector("[data-point-whatsapp-status]");
  	
  	              if (!status) return;
  	
  	              status.textContent = safeString(message);
  	              status.classList.toggle("success", state === "success");
  	              status.classList.toggle("error", state === "error");
  	            }
  	
  	            function updatePointWhatsappPhonePlaceholder() {
  	              const countrySelect = pointEditorPanel.querySelector("[data-point-whatsapp-country]");
  	              const phoneInput = pointEditorPanel.querySelector("[data-point-whatsapp-phone]");
  	
  	              if (!phoneInput) return;
  	
  	              const country = getPointWhatsappCountryByIso(countrySelect?.value || "ZA");
  	
  	              phoneInput.placeholder = country.allowAnyIntl
  	              ? "Full number e.g. +27821234567"
  	              : `${country.iso} WhatsApp e.g. ${country.example}`;
  	            }
  	
  	            function formatPointRouteCoordinate(coordinates) {
  	              if (!coordinates) return "";
  	
  	              return `${Number(coordinates.lat).toFixed(7)},${Number(coordinates.lng).toFixed(7)}`;
  	            }
  	
  	            function buildPointGoogleMapsRouteUrl(point) {
  	              const coordinates = getPointCoordinates(point);
  	
  	              if (!coordinates) return "";
  	
  	              const params = new URLSearchParams();
  	
  	              params.set("api", "1");
  	              params.set("destination", formatPointRouteCoordinate(coordinates));
  	              params.set("travelmode", "driving");
  	
  	              return `https://www.google.com/maps/dir/?${params.toString()}`;
  	            }
  	
  	            async function invokePointWhatsappService(payload) {
  	              const serviceArgs = {
  	                To: payload.To,
  	                FromLocation: payload.FromLocation,
  	                ToLocation: payload.ToLocation,
  	                Stops: payload.Stops,
  	                RouteLink: payload.RouteLink
  	              };
  	
  	              FIF_SILENT_CONSOLE.log("[TrackIT Point WhatsApp] Backendless service args:", serviceArgs);
  	
  	              if (
  	                typeof Backendless !== "undefined" &&
  	                Backendless.CustomServices &&
  	                typeof Backendless.CustomServices.invoke === "function"
  	              ) {
  	                return Backendless.CustomServices.invoke(
  	                  POINT_WHATSAPP_SERVICE_NAME,
  	                  POINT_WHATSAPP_METHOD_NAME,
  	                  serviceArgs
  	                );
  	              }
  	
  	              if (
  	                typeof BackendlessUI !== "undefined" &&
  	                BackendlessUI.Backendless &&
  	                BackendlessUI.Backendless.CustomServices &&
  	                typeof BackendlessUI.Backendless.CustomServices.invoke === "function"
  	              ) {
  	                return BackendlessUI.Backendless.CustomServices.invoke(
  	                  POINT_WHATSAPP_SERVICE_NAME,
  	                  POINT_WHATSAPP_METHOD_NAME,
  	                  serviceArgs
  	                );
  	              }
  	
  	              if (
  	                typeof window !== "undefined" &&
  	                window.Backendless &&
  	                window.Backendless.CustomServices &&
  	                typeof window.Backendless.CustomServices.invoke === "function"
  	              ) {
  	                return window.Backendless.CustomServices.invoke(
  	                  POINT_WHATSAPP_SERVICE_NAME,
  	                  POINT_WHATSAPP_METHOD_NAME,
  	                  serviceArgs
  	                );
  	              }
  	
  	              throw new Error("Backendless CustomServices.invoke is not available.");
  	            }
  	
  	            async function sendActivePointWhatsapp() {
  	              const context = activePointContext;
  	
  	              if (
  	                !context?.point ||
  	                pointWhatsappBusy
  	              ) {
  	                return;
  	              }
  	
  	              const phoneInput = pointEditorPanel.querySelector("[data-point-whatsapp-phone]");
  	              const countrySelect = pointEditorPanel.querySelector("[data-point-whatsapp-country]");
  	              const sendButton = pointEditorPanel.querySelector('[data-point-action="whatsapp"]');
  	
  	              const checkedNumber = normalisePointWhatsappNumber(
  	                phoneInput?.value,
  	                countrySelect?.value || "ZA"
  	              );
  	
  	              if (!checkedNumber.ok) {
  	                phoneInput?.classList?.add("invalid");
  	                phoneInput?.focus?.();
  	                setPointWhatsappStatus(checkedNumber.error, "error");
  	                return;
  	              }
  	
  	              const coordinates = getPointCoordinates(context.point);
  	              const routeLink = buildPointGoogleMapsRouteUrl(context.point);
  	
  	              if (!coordinates || !routeLink) {
  	                setPointWhatsappStatus("Could not build a route for this point.", "error");
  	                return;
  	              }
  	
  	              phoneInput.classList.remove("invalid");
  	              phoneInput.value = checkedNumber.value;
  	
  	              const pointType = getPointType(context.point) || "Point";
  	              const destination =
  	              `${pointType} (${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)})`;
  	
  	              const payload = {
  	                To: checkedNumber.value,
  	                FromLocation: "Current Location",
  	                ToLocation: destination,
  	                Stops: "No stops",
  	                RouteLink: routeLink
  	              };
  	
  	              pointWhatsappBusy = true;
  	
  	              try {
  	                setPointWhatsappButtonState(sendButton, "Sending...", true);
  	                setPointWhatsappStatus("Sending WhatsApp route…", "");
  	
  	                FIF_SILENT_CONSOLE.log("[TrackIT Point WhatsApp] Sending template payload:", payload);
  	
  	                const result = await invokePointWhatsappService(payload);
  	
  	                FIF_SILENT_CONSOLE.log("[TrackIT Point WhatsApp] Sent:", result);
  	                setPointWhatsappStatus("WhatsApp route sent.", "success");
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.error("[TrackIT Point WhatsApp] Send failed:", error);
  	
  	                const message = safeString(error?.message || error?.faultString || error);
  	
  	                if (message.includes("not available")) {
  	                  setPointWhatsappStatus(
  	                    "WhatsApp failed. Backendless service invoke is not available on this screen.",
  	                    "error"
  	                  );
  	                } else {
  	                  setPointWhatsappStatus(
  	                    "WhatsApp failed. Check the approved template, Backendless service and Twilio logs.",
  	                    "error"
  	                  );
  	                }
  	              } finally {
  	                pointWhatsappBusy = false;
  	
  	                if (
  	                  activePointContext === context &&
  	                  pointEditorPanel.classList.contains("open")
  	                ) {
  	                  setPointWhatsappButtonState(sendButton, "WhatsApp", false);
  	                }
  	              }
  	            }
  	
  	            function wirePointWhatsappControls() {
  	              const countrySelect = pointEditorPanel.querySelector("[data-point-whatsapp-country]");
  	              const phoneInput = pointEditorPanel.querySelector("[data-point-whatsapp-phone]");
  	
  	              if (!countrySelect || !phoneInput) return;
  	
  	              updatePointWhatsappPhonePlaceholder();
  	
  	              countrySelect.addEventListener("change", () => {
  	                updatePointWhatsappPhonePlaceholder();
  	                phoneInput.classList.remove("invalid");
  	                setPointWhatsappStatus("", "");
  	
  	                if (!safeString(phoneInput.value).trim()) return;
  	
  	                const checked = normalisePointWhatsappNumber(
  	                  phoneInput.value,
  	                  countrySelect.value
  	                );
  	
  	                phoneInput.classList.toggle("invalid", !checked.ok);
  	
  	                if (checked.ok) {
  	                  phoneInput.value = checked.value;
  	                  setPointWhatsappStatus("WhatsApp number normalised.", "success");
  	                } else {
  	                  setPointWhatsappStatus(checked.error, "error");
  	                }
  	              });
  	
  	              phoneInput.addEventListener("input", () => {
  	                phoneInput.classList.remove("invalid");
  	                setPointWhatsappStatus("", "");
  	              });
  	
  	              phoneInput.addEventListener("blur", () => {
  	                if (!safeString(phoneInput.value).trim()) return;
  	
  	                const checked = normalisePointWhatsappNumber(
  	                  phoneInput.value,
  	                  countrySelect.value
  	                );
  	
  	                phoneInput.classList.toggle("invalid", !checked.ok);
  	
  	                if (checked.ok) {
  	                  phoneInput.value = checked.value;
  	                } else {
  	                  setPointWhatsappStatus(checked.error, "error");
  	                }
  	              });
  	
  	              phoneInput.addEventListener("keydown", event => {
  	                if (event.key !== "Enter") return;
  	
  	                event.preventDefault();
  	                event.stopPropagation();
  	                sendActivePointWhatsapp();
  	              });
  	            }
  	
  	            function closePointEditor() {
  	              const context = activePointContext;
  	
  	              if (context?.saved && context?.marker && context?.originalPoint) {
  	                try {
  	                  context.marker.setTitle(
  	                    getPointType(context.originalPoint) || "Point Location"
  	                  );
  	                } catch (_) {}
  	
  	                setPointMarkerColor(context.marker, getPointColor(context.originalPoint));
  	                updatePointMarkerLabel(context.marker, context.originalPoint);
  	              }
  	
  	              pointEditorPanel.classList.remove("open");
  	              pointEditorPanel.innerHTML = "";
  	              activePointContext = null;
  	              notifyCarvedShellLayout();
  	            }
  	
  	            function renderPointEditor() {
  	              const context = activePointContext;
  	
  	              if (!context?.point || !context?.marker) {
  	                closePointEditor();
  	                return;
  	              }
  	
  	              const point = context.point;
  	              const coordinates = getPointCoordinates(point);
  	              const company = context.company || resolvePointCompany();
  	              const companyId = getPointCompanyId(company);
  	              const saved = context.saved === true;
  	
  	              if (!coordinates) {
  	                closePointEditor();
  	                return;
  	              }
  	
  	              context.company = company || null;
  	
  	              pointEditorPanel.innerHTML = `
  	              <div class="trackit-point-editor-head">
  	              <div>
  	              <div class="trackit-point-editor-title">${saved ? "Saved Point": "New Point"}</div>
  	              <div class="trackit-point-editor-coordinates">${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}</div>
  	              <div class="trackit-point-editor-company">${company ? `Company relation: ${escapeHtml(getPointCompanyLabel(company))}`: "Choose the company this point belongs to"}</div>
  	              </div>
  	              <button class="trackit-point-editor-close" type="button" data-point-action="close" title="Close">×</button>
  	              </div>
  	
  	              <div class="trackit-point-editor-body">
  	              <label class="trackit-point-editor-field company">
  	              <span class="trackit-point-editor-label">Company</span>
  	              <select class="trackit-point-editor-company-select" data-point-field="company" ${saved ? "disabled": ""}>
  	              <option value="">Select company</option>
  	              ${buildPointCompanyOptions(companyId)}
  	              </select>
  	              </label>
  	
  	              <label class="trackit-point-editor-field">
  	              <span class="trackit-point-editor-label">Colour</span>
  	              <input class="trackit-point-editor-color" type="color" data-point-field="color" value="${escapeHtml(getPointColor(point))}">
  	              </label>
  	
  	              <label class="trackit-point-editor-field">
  	              <span class="trackit-point-editor-label">Type</span>
  	              <input class="trackit-point-editor-type" type="text" data-point-field="type" value="${escapeHtml(getPointType(point))}" placeholder="Point type" autocomplete="off">
  	              </label>
  	              </div>
  	
  	              <div class="trackit-point-editor-actions">
  	              ${saved ? '<button class="trackit-point-editor-btn delete" type="button" data-point-action="delete">Delete</button>': ""}
  	              <button class="trackit-point-editor-btn" type="button" data-point-action="save" ${companyId ? "": "disabled"}>${saved ? "Update": "Save"}</button>
  	              </div>
  	
  	              <div class="trackit-point-whatsapp">
  	              <div class="trackit-point-whatsapp-title">Share point route on WhatsApp</div>
  	
  	              <div class="trackit-point-whatsapp-fields">
  	              <select class="trackit-point-whatsapp-country" data-point-whatsapp-country aria-label="Country code">
  	              ${getPointWhatsappCountryOptionsHtml("ZA")}
  	              </select>
  	
  	              <input
  	              class="trackit-point-whatsapp-phone"
  	              data-point-whatsapp-phone
  	              type="tel"
  	              placeholder="ZA WhatsApp e.g. 0821234567"
  	              autocomplete="tel"
  	              >
  	              </div>
  	
  	              <button
  	              class="trackit-point-whatsapp-btn"
  	              type="button"
  	              data-point-action="whatsapp"
  	              >
  	              ${getPointWhatsappButtonHtml("WhatsApp")}
  	              </button>
  	
  	              <div class="trackit-point-whatsapp-status" data-point-whatsapp-status></div>
  	              </div>
  	              `;
  	
  	              closeActionCard();
  	              closeDropdown();
  	              pointEditorPanel.classList.add("open");
  	              wirePointWhatsappControls();
  	              notifyCarvedShellLayout();
  	
  	              setTimeout(() => {
  	                try {
  	                  if (!companyId) {
  	                    pointEditorPanel.querySelector('[data-point-field="company"]')?.focus?.();
  	                  } else {
  	                    pointEditorPanel.querySelector('[data-point-field="type"]')?.focus?.();
  	                  }
  	                } catch (_) {}
  	              }, 0);
  	            }
  	
  	            function openPointEditor(point, marker, saved, company) {
  	              const isSaved = saved === true;
  	              const draftPoint = point && typeof point === "object"
  	              ? { ...point }
  	              : point;
  	
  	              activePointContext = {
  	                point: draftPoint,
  	                originalPoint: isSaved ? point : null,
  	                marker,
  	                saved: isSaved,
  	                company: company || resolvePointCompany() || null
  	              };
  	
  	              renderPointEditor();
  	            }
  	
  	            function clearCoordinateSearchMarker(options) {
  	              const opts = options || {};
  	
  	              if (coordinateSearchMarker) {
  	                removePointMarkerLabel(coordinateSearchMarker);
  	
  	                try {
  	                  if (typeof coordinateSearchMarker.setMap === "function") {
  	                    coordinateSearchMarker.setMap(null);
  	                  } else if ("map" in coordinateSearchMarker) {
  	                    coordinateSearchMarker.map = null;
  	                  }
  	                } catch (_) {}
  	              }
  	
  	              if (activePointContext?.marker === coordinateSearchMarker) {
  	                closePointEditor();
  	              }
  	
  	              coordinateSearchMarker = null;
  	
  	              if (!opts.keepAppData) {
  	                try {
  	                  const appData = getAppBag();
  	
  	                  if (appData && Object.prototype.hasOwnProperty.call(appData, "SelectedCoordinates")) {
  	                    delete appData.SelectedCoordinates;
  	                  }
  	                } catch (_) {}
  	              }
  	            }
  	
  	            function createPointMarker(gMap, point, options) {
  	              const opts = options || {};
  	              const coordinates = getPointCoordinates(point);
  	
  	              if (
  	                !gMap ||
  	                !coordinates ||
  	                typeof google === "undefined" ||
  	                !google?.maps?.Marker
  	              ) {
  	                return null;
  	              }
  	
  	              try {
  	                const marker = new google.maps.Marker({
  	                  map: gMap,
  	                  position: coordinates,
  	                  title: getPointType(point) || `${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}`,
  	                  zIndex: opts.saved ? 2147483300 : 2147483400,
  	                  icon: buildPointMarkerIcon(getPointColor(point))
  	                });
  	
  	                marker.__trackitPointRecord = point;
  	                marker.__trackitPointSaved = opts.saved === true;
  	                marker.__trackitPointCompany = opts.company || null;
  	                marker.__trackitPointLabel = createPointMapLabelOverlay(
  	                  gMap,
  	                  point,
  	                  opts.saved ? 2147483250 : 2147483350
  	                );
  	
  	                marker.addListener("mousedown", () => {
  	                  pointMarkerClickSuppressUntil = Date.now() + 350;
  	                });
  	
  	                marker.addListener("click", () => {
  	                  pointMarkerClickSuppressUntil = Date.now() + 350;
  	
  	                  openPointEditor(
  	                    marker.__trackitPointRecord,
  	                    marker,
  	                    marker.__trackitPointSaved,
  	                    marker.__trackitPointCompany
  	                  );
  	                });
  	
  	                return marker;
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Point Search] Could not place point marker.", error);
  	                return null;
  	              }
  	            }
  	
  	            function placeCoordinateSearchMarker(gMap, coordinates, options) {
  	              const opts = options || {};
  	
  	              clearCoordinateSearchMarker();
  	
  	              const point = {
  	                PointId: "",
  	                Latitude: Number(coordinates.lat),
  	                Longitude: Number(coordinates.lng),
  	                Type: safeString(opts.type).trim(),
  	                Color: normalizePointColor(opts.color || "#ff7a24"),
  	                IsActive: true
  	              };
  	
  	              coordinateSearchMarker = createPointMarker(gMap, point, {
  	                saved: false,
  	                company: resolvePointCompany()
  	              });
  	
  	              if (coordinateSearchMarker && opts.openEditor) {
  	                openPointEditor(
  	                  point,
  	                  coordinateSearchMarker,
  	                  false,
  	                  coordinateSearchMarker.__trackitPointCompany
  	                );
  	              }
  	
  	              return coordinateSearchMarker;
  	            }
  	
  	            function clearSavedPointMarkers() {
  	              pointSavedMarkers.forEach(marker => {
  	                removePointMarkerLabel(marker);
  	
  	                try {
  	                  marker.setMap(null);
  	                } catch (_) {}
  	              });
  	
  	              pointSavedMarkers = [];
  	            }
  	
  	            function drawSavedPointRecords(gMap, company, points) {
  	              (Array.isArray(points) ? points : []).forEach(point => {
  	                const marker = createPointMarker(gMap, point, {
  	                  saved: true,
  	                  company
  	                });
  	
  	                if (marker) pointSavedMarkers.push(marker);
  	              });
  	            }
  	
  	            async function renderSavedPointMarkers() {
  	              const requestId = ++pointLoadRequestId;
  	
  	              clearSavedPointMarkers();
  	
  	              const gMap = resolveGMap(MapRoot);
  	              const company = resolvePointCompany();
  	              const companyId = getPointCompanyId(company);
  	
  	              if (!pointSearchActive || !gMap || !company || !companyId) return;
  	
  	              // Render the relation already delivered through the normal Company channel first.
  	              drawSavedPointRecords(gMap, company, getNormalChannelPointStore(company));
  	
  	              const loaded = await loadPointLocationsFromCompanyRelation(company);
  	
  	              if (
  	                requestId !== pointLoadRequestId ||
  	                !pointSearchActive ||
  	                getPointCompanyId(resolvePointCompany()) !== companyId ||
  	                loaded === null
  	              ) {
  	                return;
  	              }
  	
  	              clearSavedPointMarkers();
  	              drawSavedPointRecords(gMap, company, loaded);
  	            }
  	
  	            function readOverlayClickable(overlay) {
  	              try {
  	                if (typeof overlay?.getClickable === "function") {
  	                  return overlay.getClickable();
  	                }
  	
  	                if (typeof overlay?.get === "function") {
  	                  const value = overlay.get("clickable");
  	                  return value === undefined ? true : value;
  	                }
  	              } catch (_) {}
  	
  	              return true;
  	            }
  	
  	            function writeOverlayClickable(overlay, clickable) {
  	              try {
  	                if (typeof overlay?.setClickable === "function") {
  	                  overlay.setClickable(!!clickable);
  	                  return;
  	                }
  	
  	                if (typeof overlay?.setOptions === "function") {
  	                  overlay.setOptions({ clickable: !!clickable });
  	                  return;
  	                }
  	
  	                if (typeof overlay?.set === "function") {
  	                  overlay.set("clickable", !!clickable);
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function collectRenderedLocationOverlays() {
  	              const runtimes = [];
  	              const seenRuntime = new Set();
  	              const overlays = [];
  	              const seenOverlay = new Set();
  	
  	              try {
  	                [
  	                  window.TrackITLocationMapRenderer,
  	                  window.TrackITLocationRendererRuntime,
  	                  window.__TrackITLocationRendererRuntime,
  	                  window.LocationRendererRuntime
  	                ].forEach(runtime => {
  	                  if (!runtime || seenRuntime.has(runtime)) return;
  	                  seenRuntime.add(runtime);
  	                  runtimes.push(runtime);
  	                });
  	              } catch (_) {}
  	
  	              runtimes.forEach(runtime => {
  	                [runtime.polygonsById, runtime.markersById].forEach(store => {
  	                  if (!store || typeof store !== "object") return;
  	
  	                  Object.keys(store).forEach(key => {
  	                    const overlay = store[key];
  	
  	                    if (!overlay || seenOverlay.has(overlay)) return;
  	
  	                    seenOverlay.add(overlay);
  	                    overlays.push(overlay);
  	                  });
  	                });
  	              });
  	
  	              return overlays;
  	            }
  	
  	            function setLocationOverlaysClickThrough(active) {
  	              if (active) {
  	                if (pointLocationClickState.length) return;
  	
  	                pointLocationClickState = collectRenderedLocationOverlays().map(overlay => {
  	                  const clickable = readOverlayClickable(overlay);
  	                  writeOverlayClickable(overlay, false);
  	
  	                  return { overlay, clickable };
  	                });
  	
  	                return;
  	              }
  	
  	              pointLocationClickState.forEach(state => {
  	                writeOverlayClickable(state.overlay, state.clickable !== false);
  	              });
  	
  	              pointLocationClickState = [];
  	            }
  	
  	            function removePointProjectionOverlay() {
  	              try {
  	                pointProjectionOverlay?.setMap?.(null);
  	              } catch (_) {}
  	
  	              pointProjectionOverlay = null;
  	              pointProjectionMap = null;
  	            }
  	
  	            function ensurePointProjectionOverlay(gMap) {
  	              if (
  	                !gMap ||
  	                typeof google === "undefined" ||
  	                !google?.maps ||
  	                typeof google.maps.OverlayView !== "function"
  	              ) {
  	                return null;
  	              }
  	
  	              if (pointProjectionOverlay && pointProjectionMap === gMap) {
  	                return pointProjectionOverlay;
  	              }
  	
  	              removePointProjectionOverlay();
  	
  	              const overlay = new google.maps.OverlayView();
  	              overlay.onAdd = function () {};
  	              overlay.draw = function () {};
  	              overlay.onRemove = function () {};
  	              overlay.setMap(gMap);
  	
  	              pointProjectionOverlay = overlay;
  	              pointProjectionMap = gMap;
  	
  	              return overlay;
  	            }
  	
  	            function removePointMapDomClickBridge() {
  	              if (pointMapDomElement && pointMapDomClickHandler) {
  	                try {
  	                  pointMapDomElement.removeEventListener("click", pointMapDomClickHandler, true);
  	                } catch (_) {}
  	              }
  	
  	              pointMapDomElement = null;
  	              pointMapDomClickHandler = null;
  	              removePointProjectionOverlay();
  	            }
  	
  	            function shouldIgnorePointMapDomTarget(target) {
  	              if (!target?.closest) return false;
  	
  	              return !!target.closest(
  	                ".trackit-location-dropdown, .trackit-compact-map-control, " +
  	                ".ces-top-content, .ces-bottom-shape, .ces-bottom-content, .ces-screen-blocker, .ces-modal-card, " +
  	                ".trackit-map-temp-point-label.is-clickable, .trackit-segment-point-share-panel, " +
  	                ".gm-control-active, .gm-style-mtc, .gm-svpc, .gm-fullscreen-control, " +
  	                "a, button, input, textarea, select, [role='button']"
  	              );
  	            }
  	
  	            function selectPointCoordinates(coordinates, source) {
  	              const gMap = resolveGMap(MapRoot);
  	              const lat = Number(coordinates?.lat);
  	              const lng = Number(coordinates?.lng);
  	
  	              if (!gMap || !Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  	
  	              const cleanCoordinates = { lat, lng };
  	
  	              searchInput.value = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
  	              setQueryState();
  	              updateCoordinateSearchButtonState(searchInput.value);
  	
  	              placeCoordinateSearchMarker(gMap, cleanCoordinates, {
  	                openEditor: true
  	              });
  	
  	              try {
  	                const appData = getAppBag();
  	                if (appData) appData.SelectedCoordinates = cleanCoordinates;
  	              } catch (_) {}
  	
  	              dispatchDropdownEvent(root, "trackitCoordinateSelected", {
  	                value: searchInput.value,
  	                coordinates: cleanCoordinates,
  	                lat,
  	                lng,
  	                source: source || "trackit-map-point-search",
  	                searchMode: "coordinates",
  	                pointSearch: true
  	              });
  	
  	              return true;
  	            }
  	
  	            function bindPointMapDomClickBridge(gMap) {
  	              removePointMapDomClickBridge();
  	
  	              const mapDiv = typeof gMap?.getDiv === "function" ? gMap.getDiv() : null;
  	              const projectionOverlay = ensurePointProjectionOverlay(gMap);
  	
  	              if (!mapDiv || !projectionOverlay) return false;
  	
  	              pointMapDomElement = mapDiv;
  	              pointMapDomClickHandler = event => {
  	                if (!pointSearchActive) return;
  	                if (Date.now() < pointMarkerClickSuppressUntil) return;
  	                if (event.button !== undefined && event.button !== 0) return;
  	                if (shouldIgnorePointMapDomTarget(event.target)) return;
  	
  	                const projection = pointProjectionOverlay?.getProjection?.();
  	
  	                if (!projection) return;
  	
  	                const rect = mapDiv.getBoundingClientRect();
  	                const pixel = new google.maps.Point(
  	                  event.clientX - rect.left,
  	                  event.clientY - rect.top
  	                );
  	                const latLng = projection.fromContainerPixelToLatLng(pixel);
  	
  	                if (!latLng) return;
  	
  	                const lat = typeof latLng.lat === "function" ? latLng.lat() : Number(latLng.lat);
  	                const lng = typeof latLng.lng === "function" ? latLng.lng() : Number(latLng.lng);
  	
  	                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
  	
  	                event.preventDefault();
  	                event.stopPropagation();
  	                event.stopImmediatePropagation?.();
  	
  	                selectPointCoordinates({ lat, lng }, "trackit-map-click-through-point-search");
  	              };
  	
  	              mapDiv.addEventListener("click", pointMapDomClickHandler, true);
  	
  	              return true;
  	            }
  	
  	            function removePointMapClickListener() {
  	              if (pointMapClickListener) {
  	                try {
  	                  google?.maps?.event?.removeListener?.(pointMapClickListener);
  	                } catch (_) {}
  	              }
  	
  	              pointMapClickListener = null;
  	              removePointMapDomClickBridge();
  	            }
  	
  	            function bindPointMapClickListener() {
  	              removePointMapClickListener();
  	
  	              const gMap = resolveGMap(MapRoot);
  	
  	              if (
  	                !pointSearchActive ||
  	                !gMap ||
  	                typeof google === "undefined" ||
  	                !google?.maps?.event?.addListener
  	              ) {
  	                return;
  	              }
  	
  	              // Capture map-container clicks first so polygons and other location overlays
  	              // cannot swallow a Point Search click. This is the preferred route.
  	              if (bindPointMapDomClickBridge(gMap)) {
  	                return;
  	              }
  	
  	              // Fallback for map implementations where the DOM projection bridge is unavailable.
  	              pointMapClickListener = google.maps.event.addListener(gMap, "click", event => {
  	                if (!pointSearchActive) return;
  	                if (Date.now() < pointMarkerClickSuppressUntil) return;
  	
  	                const latLng = event?.latLng;
  	                const lat = typeof latLng?.lat === "function" ? latLng.lat() : Number(latLng?.lat);
  	                const lng = typeof latLng?.lng === "function" ? latLng.lng() : Number(latLng?.lng);
  	
  	                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
  	
  	                selectPointCoordinates({ lat, lng }, "trackit-map-point-search");
  	              });
  	            }
  	
  	            function setPointSearchActive(active) {
  	              const next = active === true;
  	
  	              if (pointSearchActive === next) {
  	                applyLocationSearchModeVisualState();
  	                return;
  	              }
  	
  	              pointSearchActive = next;
  	
  	              if (pointSearchActive && isGoogleSearchMode()) {
  	                locationSearchMode = "trackit";
  	                writeStoredLocationSearchMode("trackit");
  	              }
  	
  	              const gMap = resolveGMap(MapRoot);
  	
  	              if (pointSearchActive) {
  	                try {
  	                  gMap?.setOptions?.({ draggableCursor: "crosshair" });
  	                } catch (_) {}
  	
  	                setLocationOverlaysClickThrough(true);
  	                bindPointMapClickListener();
  	                renderSavedPointMarkers();
  	              } else {
  	                pointLoadRequestId += 1;
  	                removePointMapClickListener();
  	                setLocationOverlaysClickThrough(false);
  	                clearSavedPointMarkers();
  	                closePointEditor();
  	
  	                try {
  	                  gMap?.setOptions?.({ draggableCursor: null });
  	                } catch (_) {}
  	              }
  	
  	              applyLocationSearchModeVisualState();
  	              updateCoordinateSearchButtonState(searchInput.value);
  	            }
  	
  	            async function saveActivePoint() {
  	              const context = activePointContext;
  	
  	              if (!context?.point || !context?.marker || pointSaveBusy) return;
  	
  	              const companySelect = pointEditorPanel.querySelector('[data-point-field="company"]');
  	              const selectedCompany = findPointCompanyById(companySelect?.value);
  	              const company = context.saved
  	              ? context.company || resolvePointCompany()
  	              : selectedCompany || context.company || resolvePointCompany();
  	
  	              if (!company) {
  	                companySelect?.focus?.();
  	                return;
  	              }
  	
  	              context.company = company;
  	              context.marker.__trackitPointCompany = company;
  	              rememberPointCompany(company);
  	
  	              const typeInput = pointEditorPanel.querySelector('[data-point-field="type"]');
  	              const colorInput = pointEditorPanel.querySelector('[data-point-field="color"]');
  	              const saveButton = pointEditorPanel.querySelector('[data-point-action="save"]');
  	              const type = safeString(typeInput?.value).trim();
  	              const color = normalizePointColor(colorInput?.value);
  	              const coordinates = getPointCoordinates(context.point);
  	
  	              if (!coordinates) return;
  	
  	              if (!type) {
  	                window.alert("Enter a point type before saving.");
  	                typeInput?.focus?.();
  	                return;
  	              }
  	
  	              context.point.Type = type;
  	              context.point.Color = color;
  	              pointSaveBusy = true;
  	
  	              if (saveButton) {
  	                saveButton.disabled = true;
  	                saveButton.textContent = context.saved ? "Updating…" : "Saving…";
  	              }
  	
  	              try {
  	                const record = await persistPointLocationRecord(context.point, company);
  	
  	                context.point = { ...record };
  	                context.originalPoint = record;
  	                context.company = company;
  	                context.saved = true;
  	                context.marker.__trackitPointRecord = record;
  	                context.marker.__trackitPointSaved = true;
  	                context.marker.__trackitPointCompany = company;
  	                context.marker.setTitle(type);
  	                setPointMarkerColor(context.marker, color);
  	                updatePointMarkerLabel(context.marker, record);
  	
  	                if (!pointSavedMarkers.includes(context.marker)) {
  	                  pointSavedMarkers.push(context.marker);
  	                }
  	
  	                if (coordinateSearchMarker === context.marker) {
  	                  coordinateSearchMarker = null;
  	                }
  	
  	                refreshApp();
  	
  	                dispatchDropdownEvent(root, "trackitPointSaved", {
  	                  point: record,
  	                  company,
  	                  source: "Companies.PointLocations-relation"
  	                });
  	
  	                renderPointEditor();
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Point Search] Point save failed.", error);
  	                window.alert(
  	                  `The point could not be saved. ${safeString(error?.message || error?.faultString || "Unknown error")}`
  	                );
  	              } finally {
  	                pointSaveBusy = false;
  	
  	                if (activePointContext === context && pointEditorPanel.classList.contains("open")) {
  	                  renderPointEditor();
  	                }
  	              }
  	            }
  	
  	            async function deleteActivePoint() {
  	              const context = activePointContext;
  	
  	              if (
  	                !context?.saved ||
  	                !context?.point ||
  	                !context?.marker ||
  	                pointDeleteBusy
  	              ) {
  	                return;
  	              }
  	
  	              const company = context.company || resolvePointCompany();
  	
  	              if (!company) return;
  	
  	              const deleteButton = pointEditorPanel.querySelector('[data-point-action="delete"]');
  	              pointDeleteBusy = true;
  	
  	              if (deleteButton) {
  	                deleteButton.disabled = true;
  	                deleteButton.textContent = "Deleting…";
  	              }
  	
  	              try {
  	                const pointId = await deletePointLocationRecord(context.point, company);
  	
  	                refreshApp();
  	                removePointMarkerLabel(context.marker);
  	
  	                try {
  	                  context.marker.setMap(null);
  	                } catch (_) {}
  	
  	                pointSavedMarkers = pointSavedMarkers.filter(marker => marker !== context.marker);
  	
  	                dispatchDropdownEvent(root, "trackitPointDeleted", {
  	                  point: context.point,
  	                  pointId,
  	                  company,
  	                  source: "Companies.PointLocations-relation"
  	                });
  	
  	                closePointEditor();
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Point Search] Point delete failed.", error);
  	                window.alert(
  	                  `The point could not be deleted. ${safeString(error?.message || error?.faultString || "Unknown error")}`
  	                );
  	              } finally {
  	                pointDeleteBusy = false;
  	
  	                if (activePointContext === context && pointEditorPanel.classList.contains("open")) {
  	                  renderPointEditor();
  	                }
  	              }
  	            }
  	
  	            function renderCoordinateSearchMessage(message) {
  	              menu.innerHTML = "";
  	
  	              const empty = document.createElement("div");
  	              empty.className = "trackit-empty trackit-coordinate-message";
  	              empty.textContent = message;
  	              menu.appendChild(empty);
  	
  	              openDropdown();
  	            }
  	
  	            function updateCoordinateSearchButtonState(value) {
  	              const coordinates = parseCoordinateSearchValue(value);
  	
  	              coordinateToggle.classList.toggle("is-valid", !!coordinates);
  	              coordinateToggle.classList.toggle("is-point-mode", pointSearchActive);
  	              coordinateToggle.setAttribute("aria-disabled", "false");
  	              coordinateToggle.setAttribute("aria-pressed", pointSearchActive ? "true": "false");
  	              coordinateToggle.title = pointSearchActive
  	              ? coordinates
  	              ? `Point Search ON · go to ${coordinates.lat}, ${coordinates.lng}`
  	              : "Point Search ON · click the map to place a point"
  	              : coordinates
  	              ? `Enable Point Search and go to ${coordinates.lat}, ${coordinates.lng}`
  	              : "Enable Point Search";
  	
  	              return coordinates;
  	            }
  	
  	            function runCoordinateSearch(value, options) {
  	              const opts = options || {};
  	              const coordinates = parseCoordinateSearchValue(value);
  	
  	              if (!coordinates) {
  	                if (!opts.silentInvalid) {
  	                  coordinateToggle.classList.add("is-invalid");
  	                  renderCoordinateSearchMessage(
  	                    "Enter coordinates as latitude, longitude. Example: -29.7461, 29.3883"
  	                  );
  	
  	                  setTimeout(() => {
  	                    coordinateToggle.classList.remove("is-invalid");
  	                  }, 700);
  	                }
  	
  	                return false;
  	              }
  	
  	              const gMap = resolveGMap(MapRoot);
  	
  	              if (!gMap) {
  	                if (!opts.silentInvalid) {
  	                  renderCoordinateSearchMessage("The map is not ready for coordinate search.");
  	                }
  	
  	                return false;
  	              }
  	
  	              try {
  	                if (typeof gMap.panTo === "function") {
  	                  gMap.panTo(coordinates);
  	                } else if (typeof gMap.setCenter === "function") {
  	                  gMap.setCenter(coordinates);
  	                } else {
  	                  gMap.center = coordinates;
  	                }
  	
  	                if (typeof gMap.setZoom === "function") {
  	                  gMap.setZoom(MAP_SELECT_ZOOM);
  	                } else {
  	                  gMap.zoom = MAP_SELECT_ZOOM;
  	                }
  	
  	                placeCoordinateSearchMarker(gMap, coordinates, {
  	                  openEditor: opts.openEditor === true || pointSearchActive
  	                });
  	
  	                searchInput.value = `${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}`;
  	                setQueryState();
  	                updateCoordinateSearchButtonState(searchInput.value);
  	                closeActionCard();
  	                closeDropdown();
  	
  	                const detail = {
  	                  value: searchInput.value,
  	                  coordinates: {
  	                    lat: coordinates.lat,
  	                    lng: coordinates.lng
  	                  },
  	                  lat: coordinates.lat,
  	                  lng: coordinates.lng,
  	                  source: "trackit-coordinate-search",
  	                  searchMode: "coordinates"
  	                };
  	
  	                try {
  	                  const appData = getAppBag();
  	
  	                  if (appData) {
  	                    appData.SelectedCoordinates = detail.coordinates;
  	                  }
  	                } catch (_) {}
  	
  	                dispatchDropdownEvent(root, "trackitCoordinateSelected", detail);
  	
  	                return true;
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Coordinate Search] Could not focus coordinates.", error);
  	
  	                if (!opts.silentInvalid) {
  	                  renderCoordinateSearchMessage("The map could not move to those coordinates.");
  	                }
  	
  	                return false;
  	              }
  	            }
  	
  	            function dispatchGooglePlaceSelected(prediction, place) {
  	              try {
  	                const detail = {
  	                  value: prediction?.place_id || "",
  	                  item: place || prediction || null,
  	                  location: place || prediction || null,
  	                  prediction,
  	                  place,
  	                  source: "google-location-search",
  	                  searchMode: "google",
  	                  countryCode: GOOGLE_LOCATION_COUNTRY_CODE,
  	                  region: GOOGLE_LOCATION_REGION,
  	                  countryLabel: GOOGLE_LOCATION_LABEL
  	                };
  	
  	                root.locationDropdownValue = detail.value;
  	                root.locationDropdownItem = detail.item;
  	                root.locationDropdownLocation = detail.location;
  	                root.googlePlacePrediction = prediction || null;
  	                root.googlePlace = place || null;
  	
  	                const appData = getAppBag();
  	
  	                if (appData) {
  	                  appData.SelectedGooglePlace = place || prediction || null;
  	                  appData.SelectedGooglePlaceId = prediction?.place_id || "";
  	                  appData.SelectedGooglePlaceCountryCode = GOOGLE_LOCATION_COUNTRY_CODE;
  	                  appData.SelectedGooglePlaceRegion = GOOGLE_LOCATION_REGION;
  	                  appData.SelectedGooglePlaceCountryLabel = GOOGLE_LOCATION_LABEL;
  	                }
  	
  	                dispatchDropdownEvent(root, EVENT_LOCATION_CHANGE, detail);
  	                dispatchDropdownEvent(root, "trackitGooglePlaceSelected", detail);
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not dispatch Google place selection.", error);
  	              }
  	            }
  	
  	            function renderGoogleEmpty(message) {
  	              menu.innerHTML = "";
  	
  	              const empty = document.createElement("div");
  	              empty.className = "trackit-empty";
  	              empty.textContent = message;
  	              menu.appendChild(empty);
  	
  	              requestAnimationFrame(() => {
  	                if (dropdown.classList.contains("open")) updateMenuHeightToBottom();
  	              });
  	            }
  	
  	            function renderGooglePlacePredictions(predictions) {
  	              menu.innerHTML = "";
  	              googlePredictions = Array.isArray(predictions) ? predictions: [];
  	              activeIndex = -1;
  	
  	              if (!googlePredictions.length) {
  	                renderGoogleEmpty(`No ${GOOGLE_LOCATION_LABEL} location found`);
  	                return;
  	              }
  	
  	              googlePredictions.forEach((prediction, index) => {
  	                const row = document.createElement("button");
  	                row.className = "trackit-google-place-item";
  	                row.type = "button";
  	                row.__googlePredictionIndex = index;
  	                row.__rowIndex = index;
  	
  	                const mainText =
  	                prediction.structured_formatting?.main_text ||
  	                prediction.description ||
  	                "Google Location";
  	
  	                const secondaryText =
  	                prediction.structured_formatting?.secondary_text ||
  	                prediction.description ||
  	                "";
  	
  	                row.innerHTML = `
  	                <span class="trackit-google-place-icon">
  	                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  	                <circle cx="12" cy="12" r="8.5" stroke-width="2"></circle>
  	                <path d="M3.8 12h16.4" stroke-width="2" stroke-linecap="round"></path>
  	                <path d="M12 3.5c2.25 2.35 3.35 5.18 3.35 8.5S14.25 18.15 12 20.5" stroke-width="2" stroke-linecap="round"></path>
  	                <path d="M12 3.5C9.75 5.85 8.65 8.68 8.65 12s1.1 6.15 3.35 8.5" stroke-width="2" stroke-linecap="round"></path>
  	                </svg>
  	                </span>
  	
  	                <span class="trackit-google-place-main">
  	                <span class="trackit-google-place-name">${escapeHtml(mainText)}</span>
  	                <span class="trackit-google-place-meta">${escapeHtml(secondaryText)}</span>
  	                </span>
  	                `;
  	
  	                menu.appendChild(row);
  	              });
  	
  	              requestAnimationFrame(() => {
  	                if (dropdown.classList.contains("open")) updateMenuHeightToBottom();
  	              });
  	            }
  	
  	            function renderGoogleMenu(query) {
  	              const q = safeString(query).trim();
  	
  	              menu.innerHTML = "";
  	              visibleRows = [];
  	              activeIndex = -1;
  	
  	              if (!q) {
  	                renderGoogleEmpty(`Start typing to search ${GOOGLE_LOCATION_LABEL}`);
  	                return;
  	              }
  	
  	              const autocompleteService = getGoogleAutocompleteService();
  	
  	              if (!autocompleteService) {
  	                renderGoogleEmpty("Google Places search is not loaded");
  	                return;
  	              }
  	
  	              const requestId = ++googlePredictionRequestId;
  	
  	              renderGoogleEmpty(`Searching ${GOOGLE_LOCATION_LABEL}...`);
  	
  	              autocompleteService.getPlacePredictions(
  	                {
  	                  input: q,
  	                  componentRestrictions: {
  	                    country: GOOGLE_LOCATION_COUNTRY_CODE
  	                  },
  	                  region: GOOGLE_LOCATION_REGION,
  	                  language: "en"
  	                },
  	                function (predictions, status) {
  	                  if (requestId !== googlePredictionRequestId) return;
  	
  	                  const ok = getGoogleStatusOk();
  	
  	                  if (status !== ok || !Array.isArray(predictions) || !predictions.length) {
  	                    renderGoogleEmpty(`No ${GOOGLE_LOCATION_LABEL} location found`);
  	                    return;
  	                  }
  	
  	                  renderGooglePlacePredictions(predictions);
  	                }
  	              );
  	            }
  	
  	            function selectGooglePrediction(index) {
  	              const prediction = googlePredictions[index];
  	
  	              if (!prediction) return;
  	
  	              clearCoordinateSearchMarker();
  	
  	              const label = prediction.description || prediction.structured_formatting?.main_text || "Google Location";
  	
  	              searchInput.value = label;
  	              selectedValue = null;
  	              selectedItem = null;
  	              selectedLabel = "";
  	              selectedRowData = null;
  	
  	              dropdown.classList.remove("has-value");
  	              dropdown.classList.remove("has-query");
  	              selectedIcon.removeAttribute("src");
  	
  	              closeActionCard();
  	              closeDropdown();
  	
  	              const placesService = getGooglePlacesService();
  	
  	              if (!placesService || !prediction.place_id) {
  	                dispatchGooglePlaceSelected(prediction, null);
  	                return;
  	              }
  	
  	              placesService.getDetails(
  	                {
  	                  placeId: prediction.place_id,
  	                  fields: ["place_id", "name", "formatted_address", "geometry"]
  	                },
  	                function (place, status) {
  	                  const ok = getGoogleStatusOk();
  	
  	                  if (status === ok && place) {
  	                    focusMapOnGooglePlace(place);
  	                    dispatchGooglePlaceSelected(prediction, place);
  	                    return;
  	                  }
  	
  	                  dispatchGooglePlaceSelected(prediction, null);
  	                }
  	              );
  	            }
  	
  	            function handleGoogleKeydown(event) {
  	              if (!isGoogleSearchMode()) return false;
  	
  	              if (event.key === "ArrowDown") {
  	                event.preventDefault();
  	
  	                if (!dropdown.classList.contains("open")) {
  	                  openDropdown();
  	                }
  	
  	                if (!googlePredictions.length) return true;
  	
  	                activeIndex = activeIndex < googlePredictions.length - 1 ? activeIndex + 1: 0;
  	                paintActiveRow();
  	                return true;
  	              }
  	
  	              if (event.key === "ArrowUp") {
  	                event.preventDefault();
  	
  	                if (!googlePredictions.length) return true;
  	
  	                activeIndex = activeIndex > 0 ? activeIndex - 1: googlePredictions.length - 1;
  	                paintActiveRow();
  	                return true;
  	              }
  	
  	              if (event.key === "Enter") {
  	                event.preventDefault();
  	
  	                if (googlePredictions.length) {
  	                  selectGooglePrediction(activeIndex >= 0 ? activeIndex: 0);
  	                }
  	
  	                return true;
  	              }
  	
  	              if (event.key === "Escape") {
  	                closeDropdown();
  	                return true;
  	              }
  	
  	              return false;
  	            }
  	
  	            // ============================================================
  	            // Old panel behaviour preserved behind SEARCH_ACTION_MODE
  	            // ============================================================
  	
  	            function getLocationIdAny(value) {
  	              try {
  	                if (!value) return null;
  	
  	                if (typeof value === "string") {
  	                  const s = value.trim();
  	                  return s ? s: null;
  	                }
  	
  	                return getLocationValue(value);
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function openLocationPanelAndFocusMap(location, mapMaybe) {
  	              const clickedId = getLocationIdAny(location);
  	
  	              if (!clickedId) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not resolve selected location ID.", location);
  	                return false;
  	              }
  	
  	              const gMap = resolveGMap(mapMaybe);
  	
  	              const RegistrySafe =
  	              typeof window !== "undefined" && window.LocationRegistry
  	              ? window.LocationRegistry: null;
  	
  	              const RegistryUISafe =
  	              typeof window !== "undefined" && window.LocationRegistryUI
  	              ? window.LocationRegistryUI: null;
  	
  	              let runtime = null;
  	
  	              try {
  	                if (RegistrySafe && typeof RegistrySafe.getRuntime === "function") {
  	                  runtime = RegistrySafe.getRuntime(clickedId);
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                if (gMap && runtime?.polygon) {
  	                  const fittedRuntimePolygon = fitMapToGooglePolygon(gMap, runtime.polygon);
  	
  	                  if (!fittedRuntimePolygon) {
  	                    centerMapOnLocation(location, mapMaybe);
  	                  }
  	                } else {
  	                  centerMapOnLocation(location, mapMaybe);
  	                }
  	              } catch (_) {
  	                centerMapOnLocation(location, mapMaybe);
  	              }
  	
  	              let opened = false;
  	
  	              try {
  	                if (RegistrySafe && typeof RegistrySafe.openLocation === "function") {
  	                  opened = !!RegistrySafe.openLocation(clickedId);
  	                }
  	              } catch (_) {}
  	
  	              if (!opened) {
  	                try {
  	                  if (RegistryUISafe && typeof RegistryUISafe.openEditPanel === "function") {
  	                    RegistryUISafe.openEditPanel({
  	                      loc: runtime?.location || location || null,
  	                      polygon: runtime?.polygon || null,
  	                      marker: runtime?.marker || null,
  	                      registryApi: RegistrySafe || null
  	                    });
  	
  	                    opened = true;
  	                  }
  	                } catch (e) {
  	                  FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] openEditPanel failed.", e);
  	                }
  	              }
  	
  	              if (!opened) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Location panel could not be opened. LocationRegistryUI may not be ready.");
  	              }
  	
  	              return opened;
  	            }
  	
  	            // ============================================================
  	            // Location type helpers + icon logic
  	            // ============================================================
  	
  	            const ICON_CFG = {
  	              W: 176,
  	              H: 176,
  	              CX: 88,
  	              CY: 78,
  	              COLORS: {
  	                fallback: "#2f32d7",
  	                locations: "#2f32d7",
  	                agricultural: "#18a058",
  	                commercial: "#d95f28",
  	                fuel: "#d8a21b",
  	                farm: "#1c7f42",
  	                field: "#27944f",
  	                pivot: "#1f8ccf",
  	                wedge: "#8a63d2",
  	                segment: "#5f8f3f",
  	                ring: "#3a78c2",
  	                gate: "#62d26f",
  	                load_point: "#4fd0e8",
  	                stroke: "#101010",
  	                innerRim: "rgba(255,255,255,0.35)",
  	                outline: "#ffffff"
  	              },
  	              OUTLINE_W: 6
  	            };
  	
  	            const STATIC_TYPE_GROUP_ORDER = [
  	              "farm",
  	              "field",
  	              "pivot",
  	              "wedge",
  	              "segment",
  	              "ring",
  	              "fuel",
  	              "gate",
  	              "load_point",
  	              "agricultural",
  	              "commercial",
  	              "locations"
  	            ];
  	
  	            const TYPE_GROUP_LABELS = {
  	              farm: "Farms",
  	              field: "Fields",
  	              pivot: "Pivots",
  	              wedge: "Wedges",
  	              segment: "Segments",
  	              ring: "Rings",
  	              fuel: "Fuel",
  	              gate: "Gates",
  	              load_point: "Load Points",
  	              agricultural: "Agricultural",
  	              commercial: "Commercial",
  	              locations: "Locations"
  	            };
  	
  	            function cleanColor(value) {
  	              if (typeof value !== "string") return "";
  	
  	              const color = value.trim();
  	
  	              if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)) return color;
  	              if (/^rgba?\([0-9.,%\s]+\)$/i.test(color)) return color;
  	              if (/^hsla?\([0-9.,%\s]+\)$/i.test(color)) return color;
  	
  	              return "";
  	            }
  	
  	            function getLocationCategory(location) {
  	              return (
  	                location?.LocationCategory ||
  	                location?.locationCategory ||
  	                location?.Category ||
  	                location?.category ||
  	                location?.Group ||
  	                location?.group ||
  	                ""
  	              );
  	            }
  	
  	            function getLocationType(location) {
  	              return (
  	                location?.LocationType ||
  	                location?.locationType ||
  	                location?.Type ||
  	                location?.type ||
  	                location?.FieldType ||
  	                location?.fieldType ||
  	                location?.Shape ||
  	                location?.shape ||
  	                ""
  	              );
  	            }
  	
  	            function getLocationShape(location) {
  	              return (
  	                location?.FieldShape ||
  	                location?.fieldShape ||
  	                location?.Shape ||
  	                location?.shape ||
  	                location?.GeometryType ||
  	                location?.geometryType ||
  	                ""
  	              );
  	            }
  	
  	            function typeKey(value) {
  	              return String(value || "").trim().toLowerCase();
  	            }
  	
  	            function titleCaseWords(value) {
  	              return String(value || "")
  	              .replace(/[_-]+/g, " ")
  	              .replace(/\s+/g, " ")
  	              .trim()
  	              .toLowerCase()
  	              .replace(/\b\w/g, c => c.toUpperCase());
  	            }
  	
  	            function slugifyGroup(value) {
  	              const slug = String(value || "")
  	              .toLowerCase()
  	              .replace(/&/g, "and")
  	              .replace(/\//g, " ")
  	              .replace(/[^a-z0-9]+/g, "_")
  	              .replace(/^_+|_+$/g, "");
  	
  	              return slug || "locations";
  	            }
  	
  	            function pluralizeLabel(label) {
  	              const clean = titleCaseWords(label);
  	
  	              if (!clean) return "Locations";
  	
  	              if (/s$/i.test(clean)) return clean;
  	              if (/y$/i.test(clean)) return clean.replace(/y$/i, "ies");
  	              if (/(ch|sh|x|z)$/i.test(clean)) return clean + "es";
  	
  	              return clean + "s";
  	            }
  	
  	            function getDynamicTypeSource(location) {
  	              return (
  	                getLocationType(location) ||
  	                getLocationCategory(location) ||
  	                getLocationShape(location) ||
  	                "Locations"
  	              );
  	            }
  	
  	            function getLocationTypeGroup(location) {
  	              const type = typeKey(getLocationType(location));
  	              const category = typeKey(getLocationCategory(location));
  	              const shape = typeKey(getLocationShape(location));
  	
  	              const creationType = typeKey(
  	                location?.CreationType ||
  	                location?.creationType ||
  	                location?.creation_type ||
  	                location?.CreationMode ||
  	                location?.creationMode ||
  	                location?.GeometryType ||
  	                location?.geometryType ||
  	                location?.LocationData?.CreationType ||
  	                location?.LocationData?.creationType ||
  	                location?.LocationData?.CreationMode ||
  	                location?.LocationData?.creationMode ||
  	                location?.LocationData?.GeometryType ||
  	                location?.LocationData?.geometryType ||
  	                ""
  	              );
  	
  	              const combined = `${type} ${category} ${shape} ${creationType}`;
  	
  	              if (combined.includes("farm")) {
  	                return {
  	                  id: "farm",
  	                  label: TYPE_GROUP_LABELS.farm
  	                };
  	              }
  	
  	              if (combined.includes("pivot")) {
  	                return {
  	                  id: "pivot",
  	                  label: TYPE_GROUP_LABELS.pivot
  	                };
  	              }
  	
  	              if (combined.includes("wedge")) {
  	                return {
  	                  id: "wedge",
  	                  label: TYPE_GROUP_LABELS.wedge
  	                };
  	              }
  	
  	              if (combined.includes("segment")) {
  	                return {
  	                  id: "segment",
  	                  label: TYPE_GROUP_LABELS.segment
  	                };
  	              }
  	
  	              if (combined.includes("ring")) {
  	                return {
  	                  id: "ring",
  	                  label: TYPE_GROUP_LABELS.ring
  	                };
  	              }
  	
  	              if (combined.includes("field")) {
  	                return {
  	                  id: "field",
  	                  label: TYPE_GROUP_LABELS.field
  	                };
  	              }
  	
  	              if (combined.includes("fuel")) {
  	                return {
  	                  id: "fuel",
  	                  label: TYPE_GROUP_LABELS.fuel
  	                };
  	              }
  	
  	              if (combined.includes("gate")) {
  	                return {
  	                  id: "gate",
  	                  label: TYPE_GROUP_LABELS.gate
  	                };
  	              }
  	
  	              if (
  	                combined.includes("load") ||
  	                combined.includes("offload") ||
  	                combined.includes("off-load")
  	              ) {
  	                return {
  	                  id: "load_point",
  	                  label: TYPE_GROUP_LABELS.load_point
  	                };
  	              }
  	
  	              if (combined.includes("agric")) {
  	                return {
  	                  id: "agricultural",
  	                  label: TYPE_GROUP_LABELS.agricultural
  	                };
  	              }
  	
  	              if (combined.includes("commercial")) {
  	                return {
  	                  id: "commercial",
  	                  label: TYPE_GROUP_LABELS.commercial
  	                };
  	              }
  	
  	              const source = getDynamicTypeSource(location);
  	              const dynamicLabel = pluralizeLabel(source);
  	              const dynamicId = slugifyGroup(dynamicLabel);
  	
  	              return {
  	                id: dynamicId,
  	                label: dynamicLabel
  	              };
  	            }
  	
  	            function colorForLocation(location) {
  	              const explicit = cleanColor(
  	                location?.color ||
  	                location?.Color ||
  	                location?.colour ||
  	                location?.Colour
  	              );
  	
  	              if (explicit) return explicit;
  	
  	              const group = getLocationTypeGroup(location);
  	
  	              return ICON_CFG.COLORS[group.id] || ICON_CFG.COLORS.fallback;
  	            }
  	
  	            function svgBadge(location) {
  	              const W = ICON_CFG.W;
  	              const H = ICON_CFG.H;
  	              const CX = ICON_CFG.CX;
  	              const CY = ICON_CFG.CY;
  	              const fill = colorForLocation(location || {});
  	
  	              return `
  	              <svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}">
  	              <path d="M ${CX},164 C ${CX},164 38,107 38,64 C 38,35 60,14 ${CX},14 C 116,14 138,35 138,64 C 138,107 ${CX},164 ${CX},164 Z"
  	              fill="none"
  	              stroke="${ICON_CFG.COLORS.outline}"
  	              stroke-width="${ICON_CFG.OUTLINE_W}"/>
  	
  	              <path d="M ${CX},164 C ${CX},164 38,107 38,64 C 38,35 60,14 ${CX},14 C 116,14 138,35 138,64 C 138,107 ${CX},164 ${CX},164 Z"
  	              fill="${fill}"
  	              stroke="${ICON_CFG.COLORS.stroke}"
  	              stroke-width="2"/>
  	
  	              <circle cx="${CX}" cy="${CY - 14}" r="30"
  	              fill="rgba(0,0,0,0.18)"
  	              stroke="${ICON_CFG.COLORS.outline}"
  	              stroke-width="2"/>
  	
  	              <circle cx="${CX}" cy="${CY - 14}" r="15"
  	              fill="${fill}"
  	              stroke="${ICON_CFG.COLORS.outline}"
  	              stroke-width="2"/>
  	
  	              <circle cx="${CX}" cy="${CY - 14}" r="11"
  	              fill="none"
  	              stroke="${ICON_CFG.COLORS.innerRim}"
  	              stroke-width="2"/>
  	              </svg>
  	              `;
  	            }
  	
  	            function iconUrl(location) {
  	              return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgBadge(location || {}))}`;
  	            }
  	
  	            // ============================================================
  	            // Company + location graph helpers
  	            // ============================================================
  	
  	            function getCompanyLabel(company) {
  	              return (
  	                company?.Name ||
  	                company?.name ||
  	                company?.CompanyName ||
  	                company?.companyName ||
  	                company?.Title ||
  	                company?.title ||
  	                "Company"
  	              );
  	            }
  	
  	            function getCompanyKey(company, index) {
  	              return `company:${company?.objectId || company?.ObjectId || getCompanyLabel(company) || index}`;
  	            }
  	
  	            function getCompanyLocations(company) {
  	              const locations =
  	              company?.Locations ||
  	              company?.locations ||
  	              company?.Location ||
  	              company?.location ||
  	              [];
  	
  	              return Array.isArray(locations) ? locations: [];
  	            }
  	
  	            function getLocationLabel(location) {
  	              return (
  	                location?.Name ||
  	                location?.name ||
  	                location?.Label ||
  	                location?.label ||
  	                location?.Title ||
  	                location?.title ||
  	                location?.ID ||
  	                location?.id ||
  	                "Location"
  	              );
  	            }
  	
  	            function getLocationValue(location) {
  	              return (
  	                location?.objectId ||
  	                location?.ObjectId ||
  	                location?.id ||
  	                location?.ID ||
  	                null
  	              );
  	            }
  	
  	            function getLocationParentId(location) {
  	              return (
  	                location?.ParentId ||
  	                location?.parentId ||
  	                location?.ParentID ||
  	                location?.parentID ||
  	                location?.ParentLocationId ||
  	                location?.parentLocationId ||
  	                location?.ParentLocationID ||
  	                location?.parentLocationID ||
  	                location?.Parent?.objectId ||
  	                location?.parent?.objectId ||
  	                location?.Parent?.id ||
  	                location?.parent?.id ||
  	                null
  	              );
  	            }
  	
  	            function getLocationMeta(location) {
  	              const category = getLocationCategory(location);
  	              const type = getLocationType(location);
  	              const fieldShape = getLocationShape(location);
  	
  	              if (category && type && fieldShape && type !== fieldShape) {
  	                return `${category} • ${type} • ${fieldShape}`;
  	              }
  	
  	              if (category && type) return `${category} • ${type}`;
  	              if (type && fieldShape && type !== fieldShape) return `${type} • ${fieldShape}`;
  	              if (type) return type;
  	              if (category) return category;
  	
  	              return (
  	                location?.Address ||
  	                location?.address ||
  	                location?.Description ||
  	                location?.description ||
  	                ""
  	              );
  	            }
  	
  	            function getLocationChildren(location) {
  	              const arrays = [
  	                location?.Children,
  	                location?.children,
  	                location?.ChildLocations,
  	                location?.childLocations,
  	                location?.Locations,
  	                location?.locations,
  	                location?.Fields,
  	                location?.fields,
  	                location?.Segments,
  	                location?.segments,
  	                location?.Rings,
  	                location?.rings
  	              ];
  	
  	              const result = [];
  	              const seen = new Set();
  	
  	              arrays.forEach(list => {
  	                if (!Array.isArray(list)) return;
  	
  	                list.forEach(child => {
  	                  if (!child || typeof child !== "object") return;
  	
  	                  const key = getLocationValue(child) || child;
  	
  	                  if (seen.has(key)) return;
  	
  	                  seen.add(key);
  	                  result.push(child);
  	                });
  	              });
  	
  	              return result;
  	            }
  	
  	            function directChildCount(location) {
  	              try {
  	                return getLocationChildren(location).length;
  	              } catch (_) {
  	                return 0;
  	              }
  	            }
  	
  	            function makeLocationKey(location, fallbackPath) {
  	              return `location:${getLocationValue(location) || fallbackPath || getLocationLabel(location)}`;
  	            }
  	
  	            function getSearchTextForNode(companyEntry, location, path) {
  	              return [
  	                companyEntry?.label,
  	                path,
  	                getLocationLabel(location),
  	                getLocationType(location),
  	                getLocationCategory(location),
  	                getLocationShape(location),
  	                location?.Address,
  	                location?.address,
  	                location?.Description,
  	                location?.description,
  	                location?.Notes,
  	                location?.notes,
  	                location?.Code,
  	                location?.code
  	              ]
  	              .filter(Boolean)
  	              .join(" ")
  	              .toLowerCase();
  	            }
  	
  	            function makeTypeGroupKey(companyEntry, groupId) {
  	              return `typegroup:${companyEntry.key}:${groupId}`;
  	            }
  	
  	            function sortNodesByLabel(nodes) {
  	              return nodes.sort((a,
  	                b) => a.label.localeCompare(b.label,
  	                undefined,
  	                {
  	                  numeric: true,
  	                  sensitivity: "base"
  	                }));
  	            }
  	
  	            function sortLocationsByLabel(locations) {
  	              return locations.sort((a,
  	                b) => getLocationLabel(a).localeCompare(getLocationLabel(b),
  	                undefined,
  	                {
  	                  numeric: true,
  	                  sensitivity: "base"
  	                }));
  	            }
  	
  	            let companyEntries = [];
  	            let flatRows = [];
  	            let activeShapeEditSession = null;
  	            let activeEntranceEditSession = null;
  	
  	            function isShapeEditActive() {
  	              return !!activeShapeEditSession;
  	            }
  	
  	            function flashActiveShapeEditLock(message) {
  	              const session = activeShapeEditSession;
  	
  	              if (!session) return;
  	
  	              const text = message || "Finish or cancel shape editing before selecting another location.";
  	
  	              try {
  	                if (typeof setShapeEditMessage === "function") {
  	                  setShapeEditMessage(session, text, true);
  	                  return;
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                if (session.messageNode) {
  	                  session.messageNode.textContent = text;
  	                  session.messageNode.classList.add("is-error");
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function cancelActiveShapeEditBecauseClosed(reason) {
  	              const session = activeShapeEditSession;
  	
  	              if (!session) return false;
  	
  	              const rowData = session.rowData || selectedRowData || null;
  	
  	              stopShapeEditSession({
  	                restoreOriginal: true
  	              });
  	
  	              try {
  	                actionCard.classList.remove("shape-editing");
  	                actionCard.classList.remove("editing");
  	              } catch (_) {}
  	
  	              try {
  	                if (rowData && typeof emitRouterEvent === "function") {
  	                  emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                    action: "autoCancelShapeEdit",
  	                    cardType: "location-shape-edit-card",
  	                    reason: reason || "card-closed",
  	                    placeholder: false
  	                  });
  	                }
  	              } catch (_) {}
  	
  	              return true;
  	            }
  	
  	            function buildCompanyLocationGraph(company) {
  	              const byId = Object.create(null);
  	              const orderedIds = [];
  	              const childrenByParentId = Object.create(null);
  	              const parentByChildId = Object.create(null);
  	
  	              function rememberLocation(location) {
  	                const id = getLocationValue(location);
  	
  	                if (!id) return "";
  	
  	                const idText = String(id);
  	
  	                if (!byId[idText]) {
  	                  byId[idText] = location;
  	                  orderedIds.push(idText);
  	                } else {
  	                  const existing = byId[idText];
  	
  	                  if (directChildCount(location) > directChildCount(existing)) {
  	                    byId[idText] = location;
  	                  }
  	                }
  	
  	                return idText;
  	              }
  	
  	              function addChildLink(parentId, childId) {
  	                if (!parentId || !childId) return;
  	
  	                const p = String(parentId);
  	                const c = String(childId);
  	
  	                if (!p || !c || p === c) return;
  	
  	                if (parentByChildId[c] && parentByChildId[c] !== p) {
  	                  return;
  	                }
  	
  	                parentByChildId[c] = p;
  	
  	                if (!childrenByParentId[p]) {
  	                  childrenByParentId[p] = Object.create(null);
  	                }
  	
  	                childrenByParentId[p][c] = true;
  	              }
  	
  	              function scanLocationTree(location, explicitParentId) {
  	                if (!location || typeof location !== "object") return;
  	
  	                const id = rememberLocation(location);
  	
  	                if (!id) return;
  	
  	                if (explicitParentId) {
  	                  addChildLink(explicitParentId, id);
  	                }
  	
  	                const storedParentId = getLocationParentId(location);
  	
  	                if (storedParentId) {
  	                  addChildLink(storedParentId, id);
  	                }
  	
  	                const children = getLocationChildren(location);
  	
  	                children.forEach(child => {
  	                  const childId = rememberLocation(child);
  	
  	                  if (childId) {
  	                    addChildLink(id, childId);
  	                  }
  	
  	                  scanLocationTree(child, id);
  	                });
  	              }
  	
  	              const companyLocations = getCompanyLocations(company);
  	
  	              companyLocations.forEach(location => {
  	                scanLocationTree(location, null);
  	              });
  	
  	              const rootIds = [];
  	
  	              orderedIds.forEach(id => {
  	                const parentId = parentByChildId[id];
  	
  	                if (!parentId || !byId[parentId]) {
  	                  rootIds.push(id);
  	                }
  	              });
  	
  	              return {
  	                byId,
  	                orderedIds,
  	                childrenByParentId,
  	                parentByChildId,
  	                rootIds
  	              };
  	            }
  	
  	            function buildLocationNodeFromGraph(companyEntry,
  	              graph,
  	              id,
  	              depth,
  	              parentPath,
  	              stack) {
  	              const idText = String(id || "");
  	
  	              if (!idText || !graph.byId[idText]) return null;
  	
  	              if (stack.has(idText)) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Circular location reference skipped.", graph.byId[idText]);
  	                return null;
  	              }
  	
  	              const location = graph.byId[idText];
  	              const value = getLocationValue(location);
  	
  	              if (!value) return null;
  	
  	              const label = getLocationLabel(location);
  	              const path = parentPath ? `${parentPath} > ${label}`: label;
  	              const key = makeLocationKey(location, path);
  	              const group = getLocationTypeGroup(location);
  	
  	              const nextStack = new Set(stack);
  	              nextStack.add(idText);
  	
  	              const childIds = Object.keys(graph.childrenByParentId[idText] || {});
  	
  	              const childLocations = childIds
  	              .map(childId => graph.byId[childId])
  	              .filter(Boolean);
  	
  	              sortLocationsByLabel(childLocations);
  	
  	              const childrenNodes = childLocations
  	              .map(childLoc => buildLocationNodeFromGraph(
  	                companyEntry,
  	                graph,
  	                getLocationValue(childLoc),
  	                depth + 1,
  	                path,
  	                nextStack
  	              ))
  	              .filter(Boolean);
  	
  	              const node = {
  	                key,
  	                companyEntry,
  	                location,
  	                value: String(value),
  	                label,
  	                meta: getLocationMeta(location),
  	                type: getLocationType(location),
  	                category: getLocationCategory(location),
  	                typeGroupId: group.id,
  	                typeGroupLabel: group.label,
  	                depth,
  	                path,
  	                childrenNodes,
  	                searchText: getSearchTextForNode(companyEntry, location, path)
  	              };
  	
  	              flatRows.push(node);
  	
  	              return node;
  	            }
  	
  	            function groupRootNodesByType(companyEntry, rootNodes) {
  	              const groupsById = Object.create(null);
  	
  	              rootNodes.forEach(node => {
  	                const groupId = node.typeGroupId || "locations";
  	                const groupLabel = node.typeGroupLabel || TYPE_GROUP_LABELS.locations;
  	
  	                if (!groupsById[groupId]) {
  	                  groupsById[groupId] = {
  	                    id: groupId,
  	                    key: makeTypeGroupKey(companyEntry, groupId),
  	                    label: groupLabel,
  	                    companyEntry,
  	                    nodes: []
  	                  };
  	                }
  	
  	                groupsById[groupId].nodes.push(node);
  	              });
  	
  	              const groups = Object.keys(groupsById).map(groupId => {
  	                const group = groupsById[groupId];
  	
  	                group.nodes = sortNodesByLabel(group.nodes);
  	
  	                return group;
  	              });
  	
  	              groups.sort((a, b) => {
  	                const ai = STATIC_TYPE_GROUP_ORDER.indexOf(a.id);
  	                const bi = STATIC_TYPE_GROUP_ORDER.indexOf(b.id);
  	
  	                const aKnown = ai >= 0;
  	                const bKnown = bi >= 0;
  	
  	                if (aKnown && bKnown) return ai - bi;
  	                if (aKnown) return -1;
  	                if (bKnown) return 1;
  	
  	                return a.label.localeCompare(b.label, undefined, {
  	                  numeric: true,
  	                  sensitivity: "base"
  	                });
  	              });
  	
  	              return groups;
  	            }
  	
  	            function buildTreeRows() {
  	              flatRows = [];
  	              companyEntries = [];
  	
  	              companies.forEach((company, index) => {
  	                const companyId = getCompanyId(company, index);
  	
  	                const entry = {
  	                  company,
  	                  index,
  	                  id: companyId,
  	                  value: companyId,
  	                  key: getCompanyKey(company, index),
  	                  label: getCompanyLabel(company),
  	                  locationNodes: [],
  	                  typeGroups: []
  	                };
  	
  	                const graph = buildCompanyLocationGraph(company);
  	
  	                const rootLocations = graph.rootIds
  	                .map(id => graph.byId[id])
  	                .filter(Boolean);
  	
  	                sortLocationsByLabel(rootLocations);
  	
  	                entry.locationNodes = rootLocations
  	                .map(location => buildLocationNodeFromGraph(
  	                  entry,
  	                  graph,
  	                  getLocationValue(location),
  	                  0,
  	                  "",
  	                  new Set()
  	                ))
  	                .filter(Boolean);
  	
  	                entry.typeGroups = groupRootNodesByType(entry, entry.locationNodes);
  	
  	                if (entry.typeGroups.length) {
  	                  companyEntries.push(entry);
  	                }
  	              });
  	            }
  	
  	            function markDefaultCollapsedStates() {
  	              const collapsed = root.__trackitCollapsedLocationTree || {};
  	              const liveCompanyIds = new Set();
  	
  	              companyEntries.forEach(companyEntry => {
  	                const companyId = safeString(companyEntry.id).trim();
  	
  	                if (companyId) {
  	                  liveCompanyIds.add(companyId);
  	                }
  	
  	                if (
  	                  companyId &&
  	                  dropdownCompanyVisibilityState.collapsedCompanyIds.has(companyId)
  	                ) {
  	                  collapsed[companyEntry.key] = true;
  	                } else if (collapsed[companyEntry.key] === true) {
  	                  if (companyId) {
  	                    dropdownCompanyVisibilityState.collapsedCompanyIds.add(companyId);
  	                  }
  	                } else if (collapsed[companyEntry.key] === undefined) {
  	                  collapsed[companyEntry.key] = false;
  	                }
  	
  	                companyEntry.typeGroups.forEach(typeGroup => {
  	                  if (collapsed[typeGroup.key] === undefined) {
  	                    collapsed[typeGroup.key] = true;
  	                  }
  	
  	                  markLocationChildrenCollapsed(typeGroup.nodes, collapsed);
  	                });
  	              });
  	
  	              Array.from(dropdownCompanyVisibilityState.collapsedCompanyIds)
  	              .forEach(companyId => {
  	                if (!liveCompanyIds.has(companyId)) {
  	                  dropdownCompanyVisibilityState.collapsedCompanyIds.delete(companyId);
  	                }
  	              });
  	
  	              root.__trackitCollapsedLocationTree = collapsed;
  	            }
  	
  	            function markLocationChildrenCollapsed(nodes, collapsed) {
  	              if (!Array.isArray(nodes)) return;
  	
  	              nodes.forEach(node => {
  	                if (!node) return;
  	
  	                if (Array.isArray(node.childrenNodes) && node.childrenNodes.length > 0) {
  	                  if (collapsed[node.key] === undefined) {
  	                    collapsed[node.key] = true;
  	                  }
  	
  	                  markLocationChildrenCollapsed(node.childrenNodes, collapsed);
  	                }
  	              });
  	            }
  	
  	            function companyMatchesQuery(companyEntry,
  	              q) {
  	              if (!q) return true;
  	
  	              return [
  	                companyEntry.label,
  	                companyEntry.company?.Name,
  	                companyEntry.company?.name,
  	                companyEntry.company?.CompanyName,
  	                companyEntry.company?.companyName
  	              ]
  	              .filter(Boolean)
  	              .join(" ")
  	              .toLowerCase()
  	              .includes(q);
  	            }
  	
  	            function nodeSelfMatchesQuery(node, q) {
  	              if (!q) return true;
  	              return node.searchText.includes(q);
  	            }
  	
  	            function nodeMatchesQuery(node, q) {
  	              if (!q) return true;
  	              if (nodeSelfMatchesQuery(node, q)) return true;
  	
  	              return node.childrenNodes.some(child => nodeMatchesQuery(child, q));
  	            }
  	
  	            function hasAnyNodes(nodes) {
  	              return Array.isArray(nodes) && nodes.length > 0;
  	            }
  	
  	            // ============================================================
  	            // CSS
  	            // ============================================================
  	
  	            const css = `
  	            .trackit-location-dropdown {
  	            position: relative;
  	            width: 100%;
  	            max-width: 100%;
  	            min-width: 0;
  	            box-sizing: border-box;
  	            font-family: Inter, Arial, sans-serif;
  	            color: #fff;
  	            z-index: ${MAX_Z_INDEX} !important;
  	            user-select: none;
  	            }
  	
  	            .ces-create-map-lock-overlay {
  	            position: absolute;
  	            inset: 0;
  	            z-index: 999999;
  	            pointer-events: auto;
  	            cursor: not-allowed;
  	            background:
  	            radial-gradient(circle at 70% 18%, rgba(255, 147, 52, 0.12), transparent 34%),
  	            rgba(0, 0, 0, 0.38);
  	            backdrop-filter: grayscale(0.95) brightness(0.55);
  	            }
  	
  	            html.ces-create-map-locked .gm-style,
  	            body.ces-create-map-locked .gm-style {
  	            filter: grayscale(0.95) brightness(0.52) contrast(0.9);
  	            }
  	
  	            .trackit-location-dropdown.google-mode .trackit-location-control {
  	            border-color: rgba(255,122,36,0.72);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.055),
  	            0 0 18px rgba(255,122,36,0.16);
  	            }
  	
  	            .trackit-location-dropdown.google-mode .trackit-menu {
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(255,122,36,0.18), rgba(255,122,36,0.00) 44%),
  	            linear-gradient(145deg, rgba(5,6,7,0.99), rgba(0,0,0,0.98));
  	            border-color: rgba(255,122,36,0.58);
  	            box-shadow:
  	            -14px 16px 32px rgba(0,0,0,0.46),
  	            0 0 20px rgba(255,122,36,0.12),
  	            inset 0 1px 0 rgba(255,255,255,0.035);
  	            }
  	
  	            .trackit-location-dropdown.google-mode .trackit-empty {
  	            width: 100%;
  	            min-height: 40px;
  	            display: flex;
  	            align-items: center;
  	            padding: 9px 11px;
  	            background:
  	            radial-gradient(circle at 0% 50%, rgba(255,122,36,0.10), rgba(255,122,36,0.00) 52%),
  	            linear-gradient(145deg, rgba(7,8,9,0.98), rgba(0,0,0,0.96));
  	            border-bottom: 1px solid rgba(255,122,36,0.16);
  	            color: rgba(255,184,125,0.84);
  	            font-size: 10px;
  	            font-weight: 900;
  	            letter-spacing: 0.02em;
  	            }
  	
  	            .trackit-google-place-item {
  	            width: 100%;
  	            min-height: 42px;
  	            display: grid;
  	            grid-template-columns: 20px 1fr;
  	            gap: 8px;
  	            align-items: center;
  	            padding: 8px 10px;
  	            border: 0;
  	            border-bottom: 1px solid rgba(255,122,36,0.13);
  	            background:
  	            radial-gradient(circle at 0% 50%, rgba(255,122,36,0.08), rgba(255,122,36,0.00) 50%),
  	            linear-gradient(145deg, rgba(8,9,10,0.98), rgba(0,0,0,0.96));
  	            color: rgba(255,216,191,0.88);
  	            text-align: left;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-google-place-item:hover,
  	            .trackit-google-place-item.active {
  	            background:
  	            radial-gradient(circle at 0% 50%, rgba(255,122,36,0.20), rgba(255,122,36,0.00) 54%),
  	            linear-gradient(145deg, rgba(14,10,7,0.99), rgba(0,0,0,0.98));
  	            border-bottom-color: rgba(255,122,36,0.32);
  	            box-shadow:
  	            inset 3px 0 0 rgba(255,122,36,0.78),
  	            inset 0 1px 0 rgba(255,255,255,0.035);
  	            }
  	
  	            .trackit-google-place-icon {
  	            width: 18px;
  	            height: 18px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,154,61,0.92);
  	            filter: drop-shadow(0 0 7px rgba(255,122,36,0.24));
  	            }
  	
  	            .trackit-google-place-icon svg {
  	            width: 14px;
  	            height: 14px;
  	            stroke: currentColor;
  	            }
  	
  	            .trackit-google-place-main {
  	            min-width: 0;
  	            display: block;
  	            }
  	
  	            .trackit-google-place-name {
  	            display: block;
  	            font-size: 10px;
  	            font-weight: 950;
  	            line-height: 1.18;
  	            color: #ffb16f;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }
  	
  	            .trackit-google-place-meta {
  	            display: block;
  	            margin-top: 3px;
  	            font-size: 8px;
  	            font-weight: 800;
  	            line-height: 1.14;
  	            color: rgba(255,216,191,0.56);
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }
  	
  	            .trackit-google-place-item:hover .trackit-google-place-name,
  	            .trackit-google-place-item.active .trackit-google-place-name {
  	            color: #ff9a3d;
  	            }
  	
  	            .trackit-google-place-item:hover .trackit-google-place-meta,
  	            .trackit-google-place-item.active .trackit-google-place-meta {
  	            color: rgba(255,226,207,0.76);
  	            }
  	
  	            .trackit-location-dropdown * {
  	            box-sizing: border-box;
  	            }
  	
  	            .trackit-location-control {
  	            width: 100%;
  	            max-width: 100%;
  	            min-width: 0;
  	            height: 28px;
  	            position: relative;
  	            background:
  	            radial-gradient(circle at 0% 50%, rgba(255,122,36,0.11), rgba(255,122,36,0.00) 46%),
  	            linear-gradient(145deg, rgba(10,13,14,0.96), rgba(0,0,0,0.82));
  	            border: 1px solid rgba(255,122,36,0.34);
  	            border-radius: 14px;
  	            color: #fff;
  	            padding: 0 96px 0 9px;
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.045),
  	            0 0 12px rgba(255,122,36,0.06);
  	            overflow: visible;
  	            }
  	
  	            .trackit-location-control:hover,
  	            .trackit-location-dropdown.open .trackit-location-control {
  	            border-color: rgba(255,122,36,0.72);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.055),
  	            0 0 18px rgba(255,122,36,0.16);
  	            }
  	
  	            .trackit-input-row {
  	            display: grid;
  	            grid-template-columns: 18px 1fr;
  	            align-items: center;
  	            gap: 5px;
  	            width: 100%;
  	            height: 100%;
  	            min-width: 0;
  	            }
  	
  	            .trackit-search-icon {
  	            color: rgba(255,193,148,0.68);
  	            font-size: 12px;
  	            line-height: 1;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            }
  	
  	            .trackit-selected-icon {
  	            width: 18px;
  	            height: 18px;
  	            display: none;
  	            }
  	
  	            .trackit-location-dropdown.has-value .trackit-input-row {
  	            grid-template-columns: 18px 1fr;
  	            }
  	
  	            .trackit-location-dropdown.has-value .trackit-search-icon {
  	            display: none;
  	            }
  	
  	            .trackit-location-dropdown.has-value .trackit-selected-icon {
  	            display: block;
  	            }
  	
  	            .trackit-search-input {
  	            width: 100%;
  	            min-width: 0;
  	            height: 26px;
  	            border: none;
  	            outline: none;
  	            background: transparent;
  	            color: rgba(248,250,252,0.82);
  	            font-size: 10px;
  	            font-weight: 750;
  	            padding: 0;
  	            }
  	
  	            .trackit-search-input::placeholder {
  	            color: rgba(226,232,240,0.44);
  	            font-weight: 750;
  	            }
  	
  	            .trackit-clear {
  	            position: absolute;
  	            right: 74px;
  	            top: 50%;
  	            transform: translateY(-50%);
  	            color: rgba(255,154,61,0.78);
  	            font-size: 18px;
  	            line-height: 1;
  	            cursor: pointer;
  	            display: none;
  	            user-select: none;
  	            z-index: 6;
  	            }
  	
  	            .trackit-clear:hover {
  	            color: #ff9a3d;
  	            }
  	
  	            .trackit-location-dropdown.has-value .trackit-clear,
  	            .trackit-location-dropdown.has-query .trackit-clear {
  	            display: block;
  	            }
  	
  	            .trackit-arrow-hit {
  	            position: absolute;
  	            right: 48px;
  	            top: 0;
  	            width: 24px;
  	            height: 100%;
  	            z-index: 7;
  	            cursor: pointer;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            user-select: none;
  	            }
  	
  	            .trackit-arrow-triangle {
  	            width: 0;
  	            height: 0;
  	            border-left: 3px solid transparent;
  	            border-right: 3px solid transparent;
  	            border-top: 4px solid rgba(255,122,36,0.72);
  	            transition: transform 120ms ease, border-top-color 120ms ease;
  	            }
  	
  	            .trackit-arrow-hit:hover .trackit-arrow-triangle {
  	            border-top-color: #ff9a3d;
  	            }
  	
  	            .trackit-location-dropdown.open .trackit-arrow-triangle {
  	            transform: rotate(180deg);
  	            }
  	
  	            .trackit-coordinate-toggle {
  	            position: absolute;
  	            right: 24px;
  	            top: 0;
  	            width: 24px;
  	            height: 100%;
  	            z-index: 9;
  	            display: flex !important;
  	            visibility: visible !important;
  	            opacity: 1 !important;
  	            align-items: center;
  	            justify-content: center;
  	            border: 0;
  	            outline: 0;
  	            padding: 0;
  	            margin: 0;
  	            background: transparent;
  	            color: rgba(255,216,191,0.62);
  	            font-family: Arial, sans-serif;
  	            font-size: 16px;
  	            font-weight: 700;
  	            line-height: 1;
  	            cursor: pointer;
  	            transition:
  	            color 130ms ease,
  	            filter 130ms ease,
  	            transform 130ms ease;
  	            }
  	
  	            .trackit-coordinate-toggle:hover,
  	            .trackit-coordinate-toggle.is-valid {
  	            color: #ff9a3d;
  	            filter: drop-shadow(0 0 7px rgba(255,122,36,0.46));
  	            }
  	
  	            .trackit-coordinate-toggle.is-valid {
  	            transform: scale(1.06);
  	            }
  	
  	            .trackit-coordinate-toggle.is-invalid {
  	            color: #ff4d38;
  	            filter: drop-shadow(0 0 8px rgba(255,77,56,0.52));
  	            }
  	
  	            .trackit-coordinate-message {
  	            color: rgba(255,190,142,0.92);
  	            }
  	
  	            .trackit-coordinate-toggle.is-point-mode,
  	            .trackit-location-dropdown.point-mode-active .trackit-coordinate-toggle {
  	            color: #ff9a3d;
  	            transform: scale(1.12);
  	            filter: drop-shadow(0 0 9px rgba(255,122,36,0.72));
  	            }
  	
  	            .trackit-point-editor {
  	            position: absolute;
  	            top: calc(100% + 5px);
  	            left: 0;
  	            right: 0;
  	            z-index: ${MAX_Z_INDEX} !important;
  	            display: none;
  	            overflow: hidden;
  	            padding: 8px;
  	            border-radius: 18px;
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(255,122,36,0.18), rgba(255,122,36,0.00) 42%),
  	            linear-gradient(145deg, rgba(18,24,26,0.985), rgba(0,0,0,0.97));
  	            border: 1px solid rgba(255,122,36,0.48);
  	            box-shadow:
  	            -14px 16px 32px rgba(0,0,0,0.44),
  	            0 0 22px rgba(255,122,36,0.16),
  	            inset 0 1px 0 rgba(255,255,255,0.065);
  	            }
  	
  	            .trackit-point-editor.open {
  	            display: block;
  	            }
  	
  	            .trackit-map-point-location-label .trackit-map-location-label-area {
  	            margin-top: 2px;
  	            color: rgba(255,255,255,0.66);
  	            font-size: 8px;
  	            font-weight: 800;
  	            }
  	
  	            .trackit-point-editor-head {
  	            display: flex;
  	            align-items: flex-start;
  	            justify-content: space-between;
  	            gap: 8px;
  	            padding: 2px 2px 8px;
  	            border-bottom: 1px solid rgba(120,49,15,0.36);
  	            }
  	
  	            .trackit-point-editor-title {
  	            color: #fff;
  	            font-size: 13px;
  	            font-weight: 800;
  	            line-height: 17px;
  	            }
  	
  	            .trackit-point-editor-coordinates,
  	            .trackit-point-editor-company {
  	            margin-top: 2px;
  	            color: rgba(255,255,255,0.62);
  	            font-size: 10px;
  	            line-height: 14px;
  	            }
  	
  	            .trackit-point-editor-close {
  	            width: 24px;
  	            height: 24px;
  	            border: 0;
  	            border-radius: 50%;
  	            background: rgba(255,255,255,0.06);
  	            color: rgba(255,255,255,0.78);
  	            font-size: 17px;
  	            line-height: 22px;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-point-editor-body {
  	            display: grid;
  	            grid-template-columns: 58px minmax(0, 1fr);
  	            gap: 8px;
  	            padding: 9px 2px 7px;
  	            }
  	
  	            .trackit-point-editor-field {
  	            min-width: 0;
  	            }
  	
  	            .trackit-point-editor-field.company {
  	            grid-column: 1 / -1;
  	            }
  	
  	            .trackit-point-editor-label {
  	            display: block;
  	            margin-bottom: 4px;
  	            color: rgba(255,216,191,0.72);
  	            font-size: 9px;
  	            font-weight: 800;
  	            letter-spacing: 0.08em;
  	            text-transform: uppercase;
  	            }
  	
  	            .trackit-point-editor-color,
  	            .trackit-point-editor-type,
  	            .trackit-point-editor-company-select {
  	            width: 100%;
  	            height: 34px;
  	            box-sizing: border-box;
  	            border: 1px solid rgba(255,122,36,0.34);
  	            border-radius: 10px;
  	            background: rgba(0,0,0,0.34);
  	            color: #fff;
  	            outline: none;
  	            }
  	
  	            .trackit-point-editor-color {
  	            padding: 3px;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-point-editor-type,
  	            .trackit-point-editor-company-select {
  	            padding: 0 9px;
  	            font-size: 12px;
  	            }
  	
  	            .trackit-point-editor-company-select {
  	            cursor: pointer;
  	            color-scheme: dark;
  	            }
  	
  	            .trackit-point-editor-company-select:disabled {
  	            cursor: default;
  	            opacity: 0.72;
  	            }
  	
  	            .trackit-point-editor-type:focus,
  	            .trackit-point-editor-color:focus,
  	            .trackit-point-editor-company-select:focus {
  	            border-color: rgba(255,154,61,0.86);
  	            box-shadow: 0 0 0 2px rgba(255,122,36,0.12);
  	            }
  	
  	            .trackit-point-editor-actions {
  	            display: flex;
  	            justify-content: flex-end;
  	            gap: 7px;
  	            padding: 2px;
  	            }
  	
  	            .trackit-point-editor-btn {
  	            min-width: 66px;
  	            height: 30px;
  	            padding: 0 10px;
  	            border: 1px solid rgba(255,122,36,0.38);
  	            border-radius: 10px;
  	            background: rgba(255,122,36,0.12);
  	            color: rgba(255,255,255,0.92);
  	            font-size: 11px;
  	            font-weight: 800;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-point-editor-btn:hover {
  	            background: rgba(255,122,36,0.22);
  	            }
  	
  	            .trackit-point-editor-btn:disabled {
  	            cursor: not-allowed;
  	            opacity: 0.42;
  	            background: rgba(255,255,255,0.04);
  	            }
  	
  	            .trackit-point-editor-btn.delete {
  	            border-color: rgba(255,77,56,0.48);
  	            background: rgba(255,77,56,0.12);
  	            color: #ff9b8e;
  	            }
  	
  	            .trackit-point-editor-btn.delete:hover {
  	            background: rgba(255,77,56,0.22);
  	            }
  	
  	            .trackit-point-whatsapp {
  	            margin: 9px 2px 2px;
  	            padding-top: 9px;
  	            border-top: 1px solid rgba(255,255,255,0.08);
  	            }
  	
  	            .trackit-point-whatsapp-title {
  	            margin-bottom: 6px;
  	            color: rgba(255,232,208,0.82);
  	            font-size: 9px;
  	            font-weight: 900;
  	            letter-spacing: 0.08em;
  	            text-transform: uppercase;
  	            }
  	
  	            .trackit-point-whatsapp-fields {
  	            display: grid;
  	            grid-template-columns: 82px minmax(0, 1fr);
  	            gap: 6px;
  	            }
  	
  	            .trackit-point-whatsapp-country,
  	            .trackit-point-whatsapp-phone {
  	            width: 100%;
  	            height: 32px;
  	            box-sizing: border-box;
  	            border: 1px solid rgba(37,211,102,0.32);
  	            border-radius: 10px;
  	            background: rgba(0,0,0,0.36);
  	            color: #fff;
  	            outline: none;
  	            font-size: 10px;
  	            }
  	
  	            .trackit-point-whatsapp-country {
  	            padding: 0 5px;
  	            color-scheme: dark;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-point-whatsapp-phone {
  	            min-width: 0;
  	            padding: 0 8px;
  	            }
  	
  	            .trackit-point-whatsapp-country:focus,
  	            .trackit-point-whatsapp-phone:focus {
  	            border-color: rgba(37,211,102,0.78);
  	            box-shadow: 0 0 0 2px rgba(37,211,102,0.10);
  	            }
  	
  	            .trackit-point-whatsapp-phone.invalid {
  	            border-color: rgba(255,77,56,0.78);
  	            box-shadow: 0 0 0 2px rgba(255,77,56,0.10);
  	            }
  	
  	            .trackit-point-whatsapp-btn {
  	            width: 100%;
  	            height: 32px;
  	            margin-top: 6px;
  	            border: 1px solid rgba(37,211,102,0.62);
  	            border-radius: 10px;
  	            background: linear-gradient(145deg, rgba(37,211,102,0.28), rgba(14,92,47,0.34));
  	            color: #dfffea;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            gap: 7px;
  	            padding: 0 10px;
  	            box-sizing: border-box;
  	            font-size: 11px;
  	            font-weight: 900;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-point-whatsapp-btn:hover {
  	            background: linear-gradient(145deg, rgba(37,211,102,0.40), rgba(14,92,47,0.46));
  	            }
  	
  	            .trackit-point-whatsapp-btn:disabled,
  	            .trackit-point-whatsapp-btn.sending {
  	            cursor: wait;
  	            opacity: 0.72;
  	            }
  	
  	            .trackit-point-whatsapp-icon {
  	            width: 16px;
  	            height: 16px;
  	            flex: 0 0 16px;
  	            }
  	
  	            .trackit-point-whatsapp-status {
  	            min-height: 13px;
  	            margin-top: 4px;
  	            color: rgba(255,255,255,0.56);
  	            font-size: 9px;
  	            line-height: 13px;
  	            }
  	
  	            .trackit-point-whatsapp-status.success {
  	            color: #8ff0b2;
  	            }
  	
  	            .trackit-point-whatsapp-status.error {
  	            color: #ff9b8e;
  	            }
  	
  	            .trackit-google-toggle {
  	            position: absolute;
  	            right: 0;
  	            top: 0;
  	            width: 24px;
  	            height: 100%;
  	            z-index: 8;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            border: 0;
  	            outline: 0;
  	            padding: 0;
  	            margin: 0;
  	            background: transparent;
  	            color: rgba(255,216,191,0.34);
  	            cursor: pointer;
  	            }
  	
  	            .trackit-google-toggle svg {
  	            width: 14px;
  	            height: 14px;
  	            display: block;
  	            stroke: currentColor;
  	            filter: drop-shadow(0 0 0 rgba(255,122,36,0));
  	            transition:
  	            color 130ms ease,
  	            filter 130ms ease,
  	            transform 130ms ease;
  	            }
  	
  	            .trackit-google-toggle:hover {
  	            color: rgba(255,154,61,0.76);
  	            }
  	
  	            .trackit-location-dropdown.google-mode .trackit-google-toggle {
  	            color: #ff9a3d;
  	            }
  	
  	            .trackit-location-dropdown.google-mode .trackit-google-toggle svg {
  	            filter: drop-shadow(0 0 8px rgba(255,122,36,0.48));
  	            transform: scale(1.04);
  	            }
  	
  	            .trackit-location-dropdown.google-mode .trackit-location-control {
  	            border-color: rgba(255,122,36,0.72);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.055),
  	            0 0 18px rgba(255,122,36,0.16);
  	            }
  	
  	            .trackit-menu {
  	            position: absolute;
  	            top: calc(100% + 5px);
  	            left: 0;
  	            right: 0;
  	            z-index: ${MAX_Z_INDEX} !important;
  	
  	            height: var(--trackit-menu-height, 320px);
  	            max-height: var(--trackit-menu-height, 320px);
  	
  	            overflow-y: auto;
  	            overflow-x: hidden;
  	
  	            padding-right: 0;
  	            padding-bottom: 10px;
  	
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(120,49,15,0.24), rgba(120,49,15,0.00) 44%),
  	            linear-gradient(145deg, rgba(13,17,18,0.99), rgba(0,0,0,0.97));
  	
  	            border: 1px solid rgba(120,49,15,0.72);
  	            border-radius: 16px;
  	            display: none;
  	
  	            box-shadow:
  	            -14px 16px 32px rgba(0,0,0,0.42),
  	            0 0 18px rgba(120,49,15,0.18),
  	            inset 0 1px 0 rgba(255,255,255,0.045);
  	
  	            scrollbar-width: none;
  	            scrollbar-gutter: auto;
  	            -ms-overflow-style: none;
  	            }
  	
  	
  	            .trackit-action-card-body::-webkit-scrollbar {
  	            width: 0;
  	            height: 0;
  	            display: none;
  	            }
  	
  	            .trackit-action-card-body {
  	            max-height: 300px;
  	            overflow-y: auto;
  	            padding: 7px 5px 5px 5px;
  	            scrollbar-width: none;
  	            scrollbar-gutter: auto;
  	            -ms-overflow-style: none;
  	            }
  	
  	            .trackit-company-header,
  	            .trackit-company-collapsed-note,
  	            .trackit-type-group-header,
  	            .trackit-type-group-collapsed-note,
  	            .trackit-location-item,
  	            .trackit-empty {
  	            width: 100%;
  	            max-width: 100%;
  	            margin-right: 0;
  	            }
  	
  	            .trackit-location-item {
  	            padding-right: 8px;
  	            }
  	
  	            .trackit-location-dropdown.open .trackit-menu {
  	            display: block;
  	            }
  	
  	            .trackit-company-header {
  	            position: sticky;
  	            top: 0;
  	            z-index: 3;
  	            display: flex;
  	            align-items: center;
  	            justify-content: space-between;
  	            gap: 8px;
  	            padding: 7px 9px;
  	            background:
  	            linear-gradient(90deg, rgba(120,49,15,0.88), rgba(47,18,6,0.96));
  	            color: #ffd8bf;
  	            font-size: 10px;
  	            font-weight: 950;
  	            letter-spacing: 0.07em;
  	            text-transform: uppercase;
  	            border-bottom: 1px solid rgba(0,0,0,0.35);
  	            cursor: pointer;
  	            user-select: none;
  	            }
  	
  	            .trackit-company-header:hover {
  	            background:
  	            linear-gradient(90deg, rgba(146,58,18,0.92), rgba(61,23,7,0.98));
  	            }
  	
  	            .trackit-company-title {
  	            min-width: 0;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            white-space: nowrap;
  	            }
  	
  	            .trackit-company-meta {
  	            display: flex;
  	            align-items: center;
  	            gap: 6px;
  	            flex: 0 0 auto;
  	            opacity: 0.9;
  	            }
  	
  	            .trackit-company-caret,
  	            .trackit-type-group-caret {
  	            width: 0;
  	            height: 0;
  	            border-left: 4px solid transparent;
  	            border-right: 4px solid transparent;
  	            border-top: 5px solid rgba(255,255,255,0.92);
  	            transition: transform 120ms ease, border-top-color 120ms ease;
  	            }
  	
  	            .trackit-company-header.collapsed .trackit-company-caret,
  	            .trackit-type-group-header.collapsed .trackit-type-group-caret {
  	            transform: rotate(-90deg);
  	            }
  	
  	            .trackit-company-collapsed-note {
  	            height: 28px;
  	            padding: 0;
  	            background: rgba(5, 12, 9, 0.94);
  	            border-bottom: 1px solid rgba(255,255,255,0.04);
  	            cursor: pointer;
  	            }
  	
  	            .trackit-company-collapsed-note:hover {
  	            background: rgba(10, 18, 13, 0.98);
  	            }
  	
  	            .trackit-type-group-header {
  	            display: flex;
  	            align-items: center;
  	            gap: 8px;
  	            min-height: 30px;
  	            padding: 6px 9px 6px 18px;
  	            background:
  	            linear-gradient(90deg, rgba(23, 28, 29, 0.98), rgba(5, 7, 8, 0.98));
  	            border-bottom: 1px solid rgba(255,255,255,0.055);
  	            border-left: 3px solid rgba(120,49,15,0.82);
  	            color: #fff;
  	            cursor: pointer;
  	            user-select: none;
  	            }
  	
  	            .trackit-type-group-header:hover {
  	            background:
  	            linear-gradient(90deg, rgba(35, 42, 44, 0.98), rgba(8, 11, 12, 0.98));
  	            border-left-color: #9a3f16;
  	            }
  	
  	            .trackit-type-group-title {
  	            min-width: 0;
  	            flex: 1;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            white-space: nowrap;
  	            font-size: 11px;
  	            font-weight: 900;
  	            letter-spacing: 0.04em;
  	            text-transform: uppercase;
  	            }
  	
  	            .trackit-type-group-meta {
  	            min-width: 19px;
  	            height: 18px;
  	            padding: 0 6px;
  	            border-radius: 999px;
  	            background: rgba(120,49,15,0.36);
  	            border: 1px solid rgba(120,49,15,0.72);
  	            color: rgba(255,255,255,0.88);
  	            font-size: 10px;
  	            font-weight: 850;
  	            line-height: 16px;
  	            text-align: center;
  	            }
  	
  	            .trackit-type-group-header:hover .trackit-type-group-caret {
  	            border-top-color: #ff9a3d;
  	            }
  	
  	            .trackit-type-group-collapsed-note {
  	            height: 1px;
  	            padding: 0;
  	            background: rgba(5, 12, 9, 0.88);
  	            border-bottom: 1px solid rgba(255,255,255,0.035);
  	            cursor: pointer;
  	            }
  	
  	            .trackit-location-item {
  	            display: flex;
  	            align-items: center;
  	            gap: 6px;
  	            padding: 6px 8px;
  	            cursor: pointer;
  	            border-bottom: 1px solid rgba(255,255,255,0.055);
  	            background: rgba(255,255,255,0.018);
  	            min-width: 0;
  	            }
  	
  	            .trackit-location-item:hover,
  	            .trackit-location-item.active {
  	            background: rgba(120,49,15,0.26);
  	            }
  	
  	            .trackit-location-item.selected {
  	            background: rgba(120,49,15,0.42);
  	            }
  	
  	            .trackit-location-caret-hit {
  	            width: 13px;
  	            height: 26px;
  	            flex: 0 0 13px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            cursor: pointer;
  	            user-select: none;
  	            }
  	
  	            .trackit-location-caret-hit.empty {
  	            cursor: default;
  	            }
  	
  	            .trackit-location-caret {
  	            width: 0;
  	            height: 0;
  	            border-left: 4px solid transparent;
  	            border-right: 4px solid transparent;
  	            border-top: 5px solid rgba(255,255,255,0.82);
  	            transition: transform 120ms ease, border-top-color 120ms ease;
  	            }
  	
  	            .trackit-location-caret-hit:hover .trackit-location-caret {
  	            border-top-color: #ff9a3d;
  	            }
  	
  	            .trackit-location-caret.collapsed {
  	            transform: rotate(-90deg);
  	            }
  	
  	            .trackit-item-icon {
  	            width: 26px;
  	            height: 26px;
  	            flex: 0 0 26px;
  	            }
  	
  	            .trackit-item-text-wrap {
  	            min-width: 0;
  	            flex: 1;
  	            }
  	
  	            .trackit-item-label {
  	            font-size: 12px;
  	            line-height: 15px;
  	            font-weight: 800;
  	            color: #fff;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }
  	
  	            .trackit-item-meta {
  	            margin-top: 0;
  	            font-size: 10px;
  	            line-height: 12px;
  	            color: rgba(255,255,255,0.58);
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }
  	
  	            .trackit-empty {
  	            padding: 10px 9px;
  	            color: rgba(255,255,255,0.65);
  	            font-size: 12px;
  	            }
  	
  	            .trackit-action-card {
  	            position: absolute;
  	            top: calc(100% + 5px);
  	            left: 0;
  	            right: 0;
  	            z-index: ${MAX_Z_INDEX} !important;
  	            display: none;
  	            overflow: hidden;
  	            border-radius: 18px;
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(255,122,36,0.18), rgba(255,122,36,0.00) 42%),
  	            linear-gradient(145deg, rgba(18,24,26,0.98), rgba(0,0,0,0.96));
  	            border: 1px solid rgba(255,122,36,0.44);
  	            box-shadow:
  	            -14px 16px 32px rgba(0,0,0,0.44),
  	            0 0 22px rgba(255,122,36,0.14),
  	            inset 0 1px 0 rgba(255,255,255,0.065);
  	            }
  	
  	            .trackit-action-card.open {
  	            display: block;
  	            }
  	
  	            .trackit-action-card {
  	            padding: 5px;
  	            }
  	
  	            .trackit-action-card-header {
  	            display: block;
  	            padding: 5px 5px 7px 5px;
  	            border-bottom: 1px solid rgba(120,49,15,0.36);
  	            }
  	
  	            .trackit-action-card-top-row {
  	            display: flex;
  	            justify-content: flex-end;
  	            align-items: center;
  	            gap: 5px;
  	            width: 100%;
  	            margin-bottom: 5px;
  	            }
  	
  	            .trackit-action-card-title-wrap {
  	            width: 100%;
  	            min-width: 0;
  	            padding: 0 2px;
  	            }
  	
  	            .trackit-action-card-icon {
  	            width: 32px;
  	            height: 32px;
  	            border-radius: 13px;
  	            object-fit: contain;
  	            background: rgba(0,0,0,0.44);
  	            border: 1px solid rgba(255,122,36,0.22);
  	            box-shadow: 0 0 12px rgba(255,122,36,0.10);
  	            }
  	
  	            .trackit-action-card-title-wrap {
  	            min-width: 0;
  	            }
  	
  	            .trackit-action-card-title {
  	            color: #ffd8bf;
  	            font-size: 12px;
  	            line-height: 1.1;
  	            font-weight: 950;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }
  	
  	            .trackit-action-card-subtitle {
  	            margin-top: 3px;
  	            color: rgba(226,232,240,0.46);
  	            font-size: 8px;
  	            font-weight: 900;
  	            text-transform: uppercase;
  	            letter-spacing: 0.10em;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }
  	
  	            .trackit-action-card-edit {
  	            width: 24px;
  	            height: 24px;
  	            border: 0;
  	            outline: 0;
  	            border-radius: 10px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,216,191,0.82);
  	            font-size: 12px;
  	            font-weight: 950;
  	            background: rgba(0,0,0,0.46);
  	            border: 1px solid rgba(120,49,15,0.42);
  	            cursor: pointer;
  	            }
  	
  	            .trackit-action-card-edit:hover {
  	            color: #ff9a3d;
  	            border-color: rgba(255,122,36,0.52);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.22);
  	            }
  	
  	            .trackit-action-card-close {
  	            width: 24px;
  	            height: 24px;
  	            border: 0;
  	            outline: 0;
  	            border-radius: 10px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,216,191,0.82);
  	            font-size: 13px;
  	            font-weight: 950;
  	            background: rgba(0,0,0,0.46);
  	            border: 1px solid rgba(255,122,36,0.24);
  	            cursor: pointer;
  	            }
  	
  	            .trackit-action-card-close:hover {
  	            color: #ff9a3d;
  	            border-color: rgba(255,122,36,0.52);
  	            }
  	
  	            .trackit-action-card.editing {
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(120,49,15,0.30), rgba(120,49,15,0.00) 44%),
  	            linear-gradient(145deg, rgba(14,18,19,0.99), rgba(0,0,0,0.98));
  	            }
  	
  	            .trackit-action-card-header.is-editing {
  	            border-bottom: 1px solid rgba(120,49,15,0.48);
  	            }
  	
  	            .trackit-action-card-delete,
  	            .trackit-action-card-undo,
  	            .trackit-action-card-save {
  	            width: 24px;
  	            height: 24px;
  	            border: 0;
  	            outline: 0;
  	            border-radius: 10px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,216,191,0.84);
  	            font-size: 12px;
  	            font-weight: 950;
  	            background: rgba(0,0,0,0.46);
  	            border: 1px solid rgba(120,49,15,0.42);
  	            cursor: pointer;
  	            }
  	
  	            .trackit-action-card-delete:hover {
  	            color: #ffb0a3;
  	            border-color: rgba(255,90,60,0.62);
  	            background: rgba(120,24,15,0.32);
  	            box-shadow: 0 0 10px rgba(120,24,15,0.22);
  	            }
  	
  	            .trackit-action-card-undo:hover,
  	            .trackit-action-card-save:hover {
  	            color: #ff9a3d;
  	            border-color: rgba(255,122,36,0.58);
  	            background: rgba(120,49,15,0.28);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.22);
  	            }
  	
  	            .trackit-action-card-save {
  	            background:
  	            linear-gradient(145deg, rgba(120,49,15,0.58), rgba(47,18,6,0.88));
  	            border-color: rgba(255,122,36,0.50);
  	            }
  	
  	            .trackit-action-card-edit-subtitle {
  	            margin-top: 3px;
  	            color: rgba(226,232,240,0.44);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.12em;
  	            }
  	
  	            .trackit-card-edit-tools {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 7px;
  	            margin-bottom: 10px;
  	            }
  	
  	            .trackit-card-tool-button {
  	            width: 100%;
  	            min-height: 31px;
  	            border: 1px solid rgba(120,49,15,0.46);
  	            border-radius: 13px;
  	            background:
  	            linear-gradient(145deg, rgba(18,22,23,0.92), rgba(0,0,0,0.94));
  	            color: rgba(255,216,191,0.88);
  	            font-size: 9px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.065em;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-card-tool-button:hover {
  	            border-color: rgba(255,122,36,0.62);
  	            background:
  	            linear-gradient(145deg, rgba(120,49,15,0.34), rgba(0,0,0,0.94));
  	            box-shadow: 0 0 12px rgba(120,49,15,0.20);
  	            }
  	
  	            .trackit-card-edit-form {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 8px;
  	            }
  	
  	            .trackit-card-edit-field {
  	            width: 100%;
  	            min-width: 0;
  	            }
  	
  	            .trackit-action-card.editing .trackit-card-edit-textarea {
  	            min-height: 58px;
  	            max-height: 86px;
  	            }
  	
  	            .trackit-action-card.editing .trackit-action-card-body {
  	            overflow-y: auto;
  	            padding-bottom: 10px;
  	            }
  	
  	            .trackit-action-card.functionality-editing {
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(120,49,15,0.30), rgba(120,49,15,0.00) 44%),
  	            linear-gradient(145deg, rgba(14,18,19,0.99), rgba(0,0,0,0.98));
  	            }
  	
  	            .trackit-action-card-header.is-functionality {
  	            border-bottom: 1px solid rgba(120,49,15,0.48);
  	            }
  	
  	            .trackit-card-functionality-form {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 8px;
  	            }
  	
  	            .trackit-card-functionality-row {
  	            min-height: 46px;
  	            display: grid;
  	            grid-template-columns: 1fr 28px;
  	            gap: 7px;
  	            align-items: center;
  	            padding: 8px;
  	            border: 1px solid rgba(120,49,15,0.36);
  	            border-radius: 15px;
  	            background:
  	            linear-gradient(145deg, rgba(0,0,0,0.50), rgba(10,12,13,0.84));
  	            }
  	
  	            .trackit-card-functionality-main {
  	            display: grid;
  	            grid-template-columns: 24px 1fr;
  	            gap: 8px;
  	            align-items: center;
  	            min-width: 0;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-card-functionality-main input {
  	            display: none;
  	            }
  	
  	            .trackit-card-functionality-box {
  	            width: 22px;
  	            height: 22px;
  	            border-radius: 9px;
  	            border: 1px solid rgba(120,49,15,0.62);
  	            background: rgba(0,0,0,0.72);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.04),
  	            0 0 8px rgba(120,49,15,0.08);
  	            }
  	
  	            .trackit-card-functionality-main input:checked + .trackit-card-functionality-box {
  	            background:
  	            radial-gradient(circle at 50% 50%, rgba(255,154,61,0.96), rgba(120,49,15,0.86));
  	            border-color: rgba(255,154,61,0.74);
  	            box-shadow:
  	            0 0 12px rgba(255,122,36,0.22),
  	            inset 0 1px 0 rgba(255,255,255,0.18);
  	            }
  	
  	            .trackit-card-functionality-text {
  	            min-width: 0;
  	            display: flex;
  	            flex-direction: column;
  	            gap: 2px;
  	            }
  	
  	            .trackit-card-functionality-title {
  	            color: rgba(255,226,205,0.92);
  	            font-size: 11px;
  	            font-weight: 950;
  	            line-height: 1.1;
  	            }
  	
  	            .trackit-card-functionality-subtitle {
  	            color: rgba(226,232,240,0.42);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.08em;
  	            line-height: 1.1;
  	            }
  	
  	            .trackit-card-functionality-help {
  	            width: 26px;
  	            height: 26px;
  	            border-radius: 11px;
  	            border: 1px solid rgba(120,49,15,0.54);
  	            background: rgba(0,0,0,0.52);
  	            color: rgba(255,216,191,0.86);
  	            font-size: 11px;
  	            font-weight: 950;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-card-functionality-help:hover {
  	            color: #ff9a3d;
  	            border-color: rgba(255,122,36,0.62);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.20);
  	            }
  	
  	            .trackit-card-functionality-fuel-options {
  	            display: none;
  	            grid-template-columns: 1fr;
  	            gap: 8px;
  	            padding-left: 10px;
  	            border-left: 1px solid rgba(120,49,15,0.28);
  	            }
  	
  	            .trackit-card-functionality-fuel-options.open {
  	            display: grid;
  	            }
  	
  	            .trackit-card-functionality-gate-phone {
  	            display: none;
  	            padding: 8px;
  	            border: 1px solid rgba(120,49,15,0.30);
  	            border-radius: 14px;
  	            background: rgba(0,0,0,0.26);
  	            }
  	
  	            .trackit-card-functionality-gate-phone.open {
  	            display: block;
  	            }
  	
  	            .trackit-card-functionality-help-box {
  	            padding: 9px;
  	            border-radius: 14px;
  	            border: 1px solid rgba(120,49,15,0.42);
  	            background: rgba(0,0,0,0.42);
  	            }
  	
  	            .trackit-card-functionality-help-title {
  	            color: #ffd8bf;
  	            font-size: 10px;
  	            font-weight: 950;
  	            margin-bottom: 4px;
  	            }
  	
  	            .trackit-card-functionality-help-body {
  	            color: rgba(248,250,252,0.66);
  	            font-size: 9px;
  	            font-weight: 750;
  	            line-height: 1.35;
  	            }
  	
  	            .trackit-card-edit-label {
  	            margin-bottom: 4px;
  	            color: rgba(255,193,148,0.64);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.10em;
  	            }
  	
  	            .trackit-card-edit-input,
  	            .trackit-card-edit-textarea {
  	            width: 100%;
  	            min-width: 0;
  	            border: 1px solid rgba(120,49,15,0.42);
  	            outline: 0;
  	            border-radius: 12px;
  	            background:
  	            linear-gradient(145deg, rgba(0,0,0,0.62), rgba(10,12,13,0.92));
  	            color: rgba(248,250,252,0.88);
  	            font-size: 10px;
  	            font-weight: 780;
  	            padding: 8px 9px;
  	            box-sizing: border-box;
  	            }
  	
  	            .trackit-card-edit-input:focus,
  	            .trackit-card-edit-textarea:focus {
  	            border-color: rgba(255,122,36,0.68);
  	            box-shadow:
  	            0 0 0 1px rgba(255,122,36,0.10),
  	            0 0 14px rgba(120,49,15,0.18);
  	            }
  	
  	            .trackit-card-edit-textarea {
  	            min-height: 76px;
  	            max-height: 130px;
  	            resize: vertical;
  	            line-height: 1.35;
  	            }
  	
  	            .trackit-card-color-wrap {
  	            display: grid;
  	            grid-template-columns: 1fr 32px;
  	            gap: 8px;
  	            align-items: center;
  	            }
  	
  	            .trackit-card-edit-color {
  	            width: 100%;
  	            height: 34px;
  	            padding: 3px;
  	            border: 1px solid rgba(120,49,15,0.42);
  	            border-radius: 12px;
  	            background: rgba(0,0,0,0.62);
  	            cursor: pointer;
  	            }
  	
  	            .trackit-card-color-preview {
  	            width: 32px;
  	            height: 32px;
  	            border-radius: 12px;
  	            border: 1px solid rgba(255,216,191,0.22);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.10),
  	            0 0 10px rgba(120,49,15,0.18);
  	            }
  	
  	            .trackit-card-info-row {
  	            display: grid;
  	            grid-template-columns: 70px 1fr;
  	            gap: 7px;
  	            min-height: 20px;
  	            align-items: center;
  	            color: rgba(248,250,252,0.78);
  	            font-size: 10px;
  	            line-height: 1.25;
  	            padding: 0 2px;
  	            }
  	
  	            .trackit-card-info-row + .trackit-card-info-row {
  	            margin-top: 4px;
  	            }
  	
  	            .trackit-card-info-key {
  	            color: rgba(255,193,148,0.58);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.08em;
  	            }
  	
  	            .trackit-card-info-value {
  	            min-width: 0;
  	            overflow: hidden;
  	            white-space: nowrap;
  	            text-overflow: ellipsis;
  	            font-weight: 760;
  	            }
  	
  	            .trackit-card-placeholder-note {
  	            margin-top: 10px;
  	            padding: 8px;
  	            border-radius: 13px;
  	            background: rgba(0,0,0,0.42);
  	            border: 1px solid rgba(255,122,36,0.16);
  	            color: rgba(248,250,252,0.64);
  	            font-size: 10px;
  	            line-height: 1.35;
  	            font-weight: 720;
  	            }
  	
  	            .trackit-card-actions {
  	            display: grid;
  	            grid-template-columns: 1fr 1fr;
  	            gap: 7px;
  	            padding: 0 10px 10px;
  	            }
  	
  	            .trackit-card-actions.three-actions {
  	            grid-template-columns: 1fr;
  	            }
  	
  	            .trackit-card-action-button {
  	            height: 32px;
  	            border: 0;
  	            outline: 0;
  	            border-radius: 14px;
  	            color: rgba(255,216,191,0.82);
  	            background: rgba(0,0,0,0.48);
  	            border: 1px solid rgba(255,122,36,0.22);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.055em;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-card-action-button:hover {
  	            color: #ffd8bf;
  	            border-color: rgba(255,122,36,0.58);
  	            box-shadow: 0 0 14px rgba(255,122,36,0.12);
  	            }
  	
  	            .trackit-card-action-button.primary {
  	            color: #ffd8bf;
  	            background:
  	            linear-gradient(145deg, rgba(255,127,39,0.46), rgba(91,36,11,0.62));
  	            border-color: rgba(255,127,39,0.68);
  	            box-shadow:
  	            0 8px 20px rgba(255,96,24,0.12),
  	            inset 0 1px 0 rgba(255,221,195,0.16);
  	            }
  	
  	            .trackit-card-children-block {
  	            margin-top: 8px;
  	            padding-top: 8px;
  	            border-top: 1px solid rgba(120,49,15,0.34);
  	            }
  	
  	            .trackit-card-events-block {
  	            margin-top: 8px;
  	            padding-top: 8px;
  	            border-top: 1px solid rgba(120,49,15,0.34);
  	            }
  	
  	            .trackit-card-events-actions {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 6px;
  	            }
  	
  	            .trackit-card-event-button {
  	            width: 100%;
  	            min-height: 30px;
  	            border: 1px solid rgba(120,49,15,0.42);
  	            border-radius: 13px;
  	            background: rgba(0,0,0,0.36);
  	            color: rgba(255,216,191,0.86);
  	            font-size: 9px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.06em;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-card-event-button:hover {
  	            border-color: rgba(255,122,36,0.58);
  	            background: rgba(120,49,15,0.24);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.16);
  	            }
  	
  	            .trackit-card-event-button.primary {
  	            background:
  	            linear-gradient(145deg, rgba(120,49,15,0.72), rgba(47,18,6,0.92));
  	            border-color: rgba(255,122,36,0.52);
  	            color: #ffd8bf;
  	            }
  	
  	            .trackit-card-segmentation-block {
  	            margin-top: 8px;
  	            padding-top: 8px;
  	            border-top: 1px solid rgba(120,49,15,0.34);
  	            }
  	
  	            .trackit-card-segmentation-row {
  	            display: grid;
  	            grid-template-columns: 54px 1fr;
  	            gap: 6px;
  	            align-items: center;
  	            }
  	
  	            .trackit-card-segment-count-input {
  	            width: 100%;
  	            height: 30px;
  	            min-height: 30px;
  	            border-radius: 12px;
  	            border: 1px solid rgba(255,122,36,0.42);
  	            background: rgba(0,0,0,0.38);
  	            color: #ffe9d5;
  	            font-size: 11px;
  	            font-weight: 950;
  	            text-align: center;
  	            outline: 0;
  	            box-sizing: border-box;
  	            }
  	
  	            .trackit-card-segment-count-input:focus {
  	            border-color: rgba(255,154,61,0.86);
  	            box-shadow: 0 0 0 2px rgba(255,154,61,0.14);
  	            }
  	
  	            .trackit-card-segmentation-note {
  	            margin-top: 6px;
  	            color: rgba(248,250,252,0.56);
  	            font-size: 8.5px;
  	            font-weight: 800;
  	            line-height: 1.25;
  	            }
  	
  	            .trackit-card-event-button.subtle {
  	            min-height: 26px;
  	            margin-top: 6px;
  	            opacity: 0.82;
  	            }
  	
  	            .trackit-card-child-row.is-temporary {
  	            border-style: dashed;
  	            border-color: rgba(255,180,94,0.58);
  	            background: rgba(120,49,15,0.18);
  	            }
  	
  	            .trackit-card-child-row.is-temporary .trackit-card-child-type {
  	            color: rgba(255,193,148,0.72);
  	            }
  	
  	            .trackit-map-temp-segment-label {
  	            min-width: 58px;
  	            padding: 5px 7px;
  	            border-radius: 8px;
  	            border: 1px solid rgba(255,255,255,0.16);
  	            background: rgba(5,5,5,0.88);
  	            color: #ffffff;
  	            font-size: 9px;
  	            font-weight: 1000;
  	            line-height: 1.08;
  	            text-align: center;
  	            white-space: nowrap;
  	            box-shadow:
  	            0 8px 18px rgba(0,0,0,0.34),
  	            inset 0 0 0 1px rgba(255,255,255,0.05);
  	            }
  	
  	            .trackit-map-temp-segment-label span {
  	            display: block;
  	            }
  	
  	            .trackit-map-temp-point-label {
  	            min-width: 94px;
  	            padding: 4px 6px;
  	            border-radius: 8px;
  	            border: 1px solid rgba(124,255,139,0.38);
  	            background: rgba(0,0,0,0.84);
  	            color: #eaffee;
  	            font-size: 8px;
  	            font-weight: 950;
  	            line-height: 1.12;
  	            text-align: center;
  	            white-space: nowrap;
  	            box-shadow:
  	            0 8px 18px rgba(0,0,0,0.32),
  	            inset 0 0 0 1px rgba(255,255,255,0.045);
  	            }
  	
  	            .trackit-map-temp-point-label > span {
  	            display: block;
  	            }
  	
  	            .trackit-map-temp-point-label > span:first-child {
  	            color: rgba(170,255,183,0.88);
  	            font-size: 7.5px;
  	            letter-spacing: 0.05em;
  	            text-transform: uppercase;
  	            }
  	
  	            .trackit-map-temp-point-label.is-clickable {
  	            pointer-events: auto !important;
  	            cursor: pointer;
  	            overflow: visible !important;
  	            border-color: rgba(37,211,102,0.58);
  	            transition:
  	            border-color 120ms ease,
  	            box-shadow 120ms ease,
  	            background 120ms ease;
  	            }
  	
  	            .trackit-map-temp-point-label.is-clickable:hover,
  	            .trackit-map-temp-point-label.is-clickable:focus,
  	            .trackit-map-temp-point-label.is-share-open {
  	            outline: 0;
  	            border-color: rgba(37,211,102,0.92);
  	            background: rgba(0,0,0,0.94);
  	            box-shadow:
  	            0 9px 20px rgba(0,0,0,0.42),
  	            0 0 14px rgba(37,211,102,0.24),
  	            inset 0 0 0 1px rgba(255,255,255,0.06);
  	            }
  	
  	            .trackit-map-temp-point-label.is-share-open {
  	            z-index: 2147483646 !important;
  	            }
  	
  	            .trackit-segment-point-share-panel {
  	            position: absolute;
  	            top: calc(100% + 7px);
  	            left: 50%;
  	            width: 286px;
  	            box-sizing: border-box;
  	            transform: translateX(-50%);
  	            padding: 8px;
  	            border: 1px solid rgba(37,211,102,0.52);
  	            border-radius: 14px;
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(37,211,102,0.16), transparent 46%),
  	            linear-gradient(145deg, rgba(18,24,26,0.995), rgba(0,0,0,0.985));
  	            color: #fff;
  	            text-align: left;
  	            white-space: normal;
  	            cursor: default;
  	            pointer-events: auto;
  	            box-shadow:
  	            0 16px 34px rgba(0,0,0,0.52),
  	            0 0 18px rgba(37,211,102,0.15),
  	            inset 0 1px 0 rgba(255,255,255,0.055);
  	            }
  	
  	            .trackit-segment-point-share-head {
  	            display: flex;
  	            align-items: flex-start;
  	            justify-content: space-between;
  	            gap: 8px;
  	            padding-bottom: 7px;
  	            margin-bottom: 7px;
  	            border-bottom: 1px solid rgba(37,211,102,0.22);
  	            }
  	
  	            .trackit-segment-point-share-title {
  	            color: #e5ffed;
  	            font-size: 10px;
  	            font-weight: 950;
  	            line-height: 13px;
  	            letter-spacing: 0.05em;
  	            text-transform: uppercase;
  	            }
  	
  	            .trackit-segment-point-share-meta {
  	            margin-top: 2px;
  	            color: rgba(255,255,255,0.60);
  	            font-size: 8px;
  	            font-weight: 750;
  	            line-height: 11px;
  	            }
  	
  	            .trackit-segment-point-share-close {
  	            width: 22px;
  	            height: 22px;
  	            flex: 0 0 22px;
  	            border: 1px solid rgba(255,255,255,0.10);
  	            border-radius: 50%;
  	            background: rgba(255,255,255,0.055);
  	            color: rgba(255,255,255,0.82);
  	            font-size: 16px;
  	            line-height: 18px;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-segment-point-share-close:hover {
  	            background: rgba(255,255,255,0.11);
  	            color: #fff;
  	            }
  	
  	            .trackit-segment-point-share-panel .trackit-point-whatsapp-fields {
  	            grid-template-columns: 78px minmax(0, 1fr);
  	            }
  	
  	            .trackit-segment-point-share-panel .trackit-point-whatsapp-country,
  	            .trackit-segment-point-share-panel .trackit-point-whatsapp-phone,
  	            .trackit-segment-point-share-panel .trackit-point-whatsapp-btn {
  	            height: 30px;
  	            font-size: 9px;
  	            }
  	
  	            .trackit-segment-point-share-panel .trackit-point-whatsapp-status {
  	            min-height: 12px;
  	            margin-top: 4px;
  	            font-size: 8px;
  	            line-height: 12px;
  	            }
  	
  	            .trackit-segment-point-name-editor {
  	            display: grid;
  	            gap: 6px;
  	            margin-bottom: 8px;
  	            padding-bottom: 8px;
  	            border-bottom: 1px solid rgba(37,211,102,0.18);
  	            }
  	
  	            .trackit-segment-point-name-field {
  	            display: grid;
  	            gap: 3px;
  	            }
  	
  	            .trackit-segment-point-name-field > span {
  	            color: rgba(229,255,237,0.72);
  	            font-size: 7.5px;
  	            font-weight: 900;
  	            letter-spacing: 0.05em;
  	            text-transform: uppercase;
  	            }
  	
  	            .trackit-segment-point-name-input,
  	            .trackit-segment-point-segment-select {
  	            width: 100%;
  	            height: 30px;
  	            box-sizing: border-box;
  	            border: 1px solid rgba(37,211,102,0.30);
  	            border-radius: 9px;
  	            background: rgba(0,0,0,0.42);
  	            color: #f4fff7;
  	            padding: 0 9px;
  	            font-size: 9px;
  	            font-weight: 800;
  	            outline: 0;
  	            }
  	
  	            .trackit-segment-point-name-input:focus,
  	            .trackit-segment-point-segment-select:focus {
  	            border-color: rgba(37,211,102,0.82);
  	            box-shadow: 0 0 0 2px rgba(37,211,102,0.12);
  	            }
  	
  	            .trackit-segment-point-name-save {
  	            width: 100%;
  	            height: 30px;
  	            border: 1px solid rgba(37,211,102,0.58);
  	            border-radius: 9px;
  	            background: rgba(24,111,56,0.54);
  	            color: #eaffef;
  	            font-size: 9px;
  	            font-weight: 950;
  	            cursor: pointer;
  	            }
  	
  	            .trackit-segment-point-name-save:hover {
  	            background: rgba(28,135,67,0.68);
  	            }
  	
  	            .trackit-segment-point-name-save:disabled {
  	            opacity: 0.58;
  	            cursor: wait;
  	            }
  	
  	            .trackit-card-segment-detail {
  	            margin-top: 8px;
  	            padding: 8px;
  	            border-radius: 14px;
  	            border: 1px solid rgba(255,122,36,0.36);
  	            background:
  	            radial-gradient(circle at top left, rgba(255,122,36,0.16), transparent 54%),
  	            rgba(0,0,0,0.32);
  	            box-shadow: inset 0 0 0 1px rgba(255,255,255,0.035);
  	            }
  	
  	            .trackit-card-segment-detail-title {
  	            color: #ffe1c5;
  	            font-size: 10px;
  	            font-weight: 1000;
  	            letter-spacing: 0.04em;
  	            text-transform: uppercase;
  	            margin-bottom: 6px;
  	            }
  	
  	            .trackit-card-segment-detail-grid {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 5px;
  	            }
  	
  	            .trackit-card-segment-detail-row {
  	            display: grid;
  	            grid-template-columns: 72px 1fr;
  	            gap: 7px;
  	            align-items: start;
  	            }
  	
  	            .trackit-card-segment-detail-key {
  	            color: rgba(255,193,148,0.64);
  	            font-size: 8px;
  	            font-weight: 950;
  	            letter-spacing: 0.05em;
  	            text-transform: uppercase;
  	            }
  	
  	            .trackit-card-segment-detail-value {
  	            color: rgba(255,246,238,0.94);
  	            font-size: 9px;
  	            font-weight: 850;
  	            line-height: 1.3;
  	            word-break: break-word;
  	            }
  	
  	            .trackit-card-segment-detail-value.mono {
  	            font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  	            font-size: 8.5px;
  	            font-weight: 850;
  	            color: rgba(255,246,238,0.88);
  	            }
  	
  	            .trackit-card-section-title {
  	            padding: 0 2px 6px 2px;
  	            color: rgba(255,193,148,0.62);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.10em;
  	            }
  	
  	            .trackit-card-child-list {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 5px;
  	            }
  	
  	            .trackit-card-child-row {
  	            width: 100%;
  	            min-height: 34px;
  	            display: grid;
  	            grid-template-columns: 1fr 22px;
  	            gap: 6px;
  	            align-items: center;
  	            padding: 6px 7px;
  	            border: 1px solid rgba(120,49,15,0.36);
  	            border-radius: 12px;
  	            background: rgba(0,0,0,0.34);
  	            color: #fff;
  	            cursor: pointer;
  	            text-align: left;
  	            }
  	
  	            .trackit-card-child-row:hover {
  	            border-color: rgba(255,122,36,0.56);
  	            background: rgba(120,49,15,0.22);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.16);
  	            }
  	
  	            .trackit-card-child-main {
  	            min-width: 0;
  	            }
  	
  	            .trackit-card-child-name {
  	            color: rgba(248,250,252,0.92);
  	            font-size: 10px;
  	            font-weight: 900;
  	            line-height: 1.1;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }
  	
  	            .trackit-card-child-type {
  	            margin-top: 2px;
  	            color: rgba(226,232,240,0.52);
  	            font-size: 8px;
  	            font-weight: 800;
  	            line-height: 1.1;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }
  	
  	            .trackit-card-child-count {
  	            width: 20px;
  	            height: 18px;
  	            border-radius: 999px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,216,191,0.84);
  	            background: rgba(120,49,15,0.34);
  	            border: 1px solid rgba(120,49,15,0.60);
  	            font-size: 9px;
  	            font-weight: 950;
  	            }
  	
  	            .trackit-card-empty-children {
  	            min-height: 34px;
  	            display: flex;
  	            align-items: center;
  	            padding: 7px;
  	            border: 1px dashed rgba(120,49,15,0.46);
  	            border-radius: 12px;
  	            background: rgba(0,0,0,0.24);
  	            color: rgba(248,250,252,0.58);
  	            font-size: 9px;
  	            font-weight: 800;
  	            line-height: 1.25;
  	            }
  	
  	            .trackit-card-type-picker {
  	            position: relative !important;
  	            width: 100% !important;
  	            z-index: 40 !important;
  	            }
  	
  	            .trackit-card-type-picker-button {
  	            width: 100% !important;
  	            height: 34px !important;
  	            min-height: 34px !important;
  	            display: grid !important;
  	            grid-template-columns: auto minmax(0, 1fr) auto !important;
  	            align-items: center !important;
  	            gap: 8px !important;
  	            padding: 0 12px !important;
  	            border-radius: 14px !important;
  	            border: 1px solid rgba(255, 122, 35, 0.55) !important;
  	            background: linear-gradient(180deg, rgba(18, 10, 6, 0.96), rgba(4, 3, 2, 0.96)) !important;
  	            color: rgba(255, 244, 230, 0.98) !important;
  	            box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 0 0 1px rgba(0,0,0,0.34) !important;
  	            cursor: pointer !important;
  	            box-sizing: border-box !important;
  	            }
  	
  	            .trackit-card-type-picker.open .trackit-card-type-picker-button {
  	            border-color: rgba(255, 154, 61, 0.95) !important;
  	            box-shadow: 0 0 0 2px rgba(255, 154, 61, 0.14), 0 10px 24px rgba(0,0,0,0.32) !important;
  	            }
  	
  	            .trackit-card-type-picker-dot {
  	            width: 9px !important;
  	            height: 9px !important;
  	            border-radius: 999px !important;
  	            box-shadow: 0 0 0 2px rgba(0,0,0,0.55), 0 0 10px rgba(255,154,61,0.24) !important;
  	            }
  	
  	            .trackit-card-type-picker-label {
  	            min-width: 0 !important;
  	            overflow: hidden !important;
  	            text-overflow: ellipsis !important;
  	            white-space: nowrap !important;
  	            text-align: left !important;
  	            font-size: 12px !important;
  	            font-weight: 900 !important;
  	            }
  	
  	            .trackit-card-type-picker-caret {
  	            color: rgba(255, 180, 100, 0.96) !important;
  	            font-size: 12px !important;
  	            font-weight: 900 !important;
  	            }
  	
  	            .trackit-card-type-picker-menu {
  	            display: none !important;
  	            position: absolute !important;
  	            left: 0 !important;
  	            right: 0 !important;
  	            top: calc(100% + 5px) !important;
  	            max-height: 180px !important;
  	            overflow-y: auto !important;
  	            padding: 6px !important;
  	            border-radius: 14px !important;
  	            border: 1px solid rgba(255, 122, 35, 0.58) !important;
  	            background: linear-gradient(180deg, rgba(20, 12, 7, 0.99), rgba(4, 3, 2, 0.99)) !important;
  	            box-shadow: 0 18px 44px rgba(0,0,0,0.70), inset 0 1px 0 rgba(255,255,255,0.05) !important;
  	            z-index: 999999 !important;
  	            }
  	
  	            .trackit-card-type-picker.open .trackit-card-type-picker-menu {
  	            display: grid !important;
  	            gap: 4px !important;
  	            }
  	
  	            .trackit-card-type-picker-option {
  	            width: 100% !important;
  	            min-height: 30px !important;
  	            display: grid !important;
  	            grid-template-columns: auto minmax(0, 1fr) !important;
  	            align-items: center !important;
  	            gap: 8px !important;
  	            padding: 0 10px !important;
  	            border: 0 !important;
  	            border-radius: 10px !important;
  	            background: transparent !important;
  	            color: rgba(255, 238, 220, 0.92) !important;
  	            font-size: 11px !important;
  	            font-weight: 850 !important;
  	            text-align: left !important;
  	            cursor: pointer !important;
  	            }
  	
  	            .trackit-card-type-picker-option:hover,
  	            .trackit-card-type-picker-option.is-selected {
  	            background: rgba(255, 122, 35, 0.18) !important;
  	            color: #ffffff !important;
  	            }
  	
  	            .trackit-card-type-picker-option.is-add {
  	            color: rgba(255, 185, 105, 0.98) !important;
  	            border-bottom: 1px solid rgba(255, 122, 35, 0.22) !important;
  	            margin-bottom: 4px !important;
  	            padding-bottom: 4px !important;
  	            }
  	
  	            .trackit-card-type-picker-add-icon {
  	            width: 15px !important;
  	            height: 15px !important;
  	            border-radius: 999px !important;
  	            display: grid !important;
  	            place-items: center !important;
  	            background: rgba(255, 122, 35, 0.22) !important;
  	            color: rgba(255, 210, 150, 1) !important;
  	            font-size: 12px !important;
  	            font-weight: 950 !important;
  	            }
  	
  	            .trackit-card-edit-select-wrap {
  	            position: relative !important;
  	            width: 100% !important;
  	            }
  	
  	            .trackit-card-edit-select-wrap::after {
  	            content: "⌄" !important;
  	            position: absolute !important;
  	            right: 12px !important;
  	            top: 50% !important;
  	            transform: translateY(-52%) !important;
  	            pointer-events: none !important;
  	            color: rgba(255, 190, 120, 0.92) !important;
  	            font-size: 14px !important;
  	            font-weight: 900 !important;
  	            line-height: 1 !important;
  	            }
  	
  	            .trackit-card-edit-select {
  	            width: 100% !important;
  	            height: 34px !important;
  	            min-height: 34px !important;
  	            padding: 0 34px 0 12px !important;
  	            border-radius: 14px !important;
  	            border: 1px solid rgba(255, 122, 35, 0.45) !important;
  	            background: rgba(0, 0, 0, 0.34) !important;
  	            color: rgba(255, 244, 230, 0.96) !important;
  	            font-size: 12px !important;
  	            font-weight: 800 !important;
  	            line-height: 34px !important;
  	            outline: none !important;
  	            box-sizing: border-box !important;
  	            appearance: none !important;
  	            -webkit-appearance: none !important;
  	            }
  	
  	            .trackit-card-edit-select:focus {
  	            border-color: rgba(255, 154, 61, 0.86) !important;
  	            box-shadow: 0 0 0 2px rgba(255, 154, 61, 0.16) !important;
  	            }
  	
  	            .trackit-card-edit-select option {
  	            background: #17110d !important;
  	            color: #fff2e5 !important;
  	            }
  	
  	            .trackit-action-card.entrance-editing {
  	            width: 184px;
  	            border-radius: 18px;
  	            border: 1px solid rgba(255,132,48,0.46);
  	            background:
  	            radial-gradient(circle at 18% 10%, rgba(255,132,48,0.16), transparent 34%),
  	            linear-gradient(145deg, rgba(16,18,18,0.96), rgba(4,5,5,0.96));
  	            box-shadow:
  	            0 0 0 1px rgba(255,255,255,0.035),
  	            0 18px 38px rgba(0,0,0,0.50),
  	            0 0 26px rgba(255,122,36,0.16);
  	            }
  	
  	            .trackit-action-card.entrance-editing .trackit-entrance-edit-inner {
  	            padding: 10px;
  	            display: grid;
  	            gap: 8px;
  	            }
  	
  	            .trackit-action-card.entrance-editing .trackit-entrance-edit-head {
  	            padding: 0 0 7px;
  	            border-bottom: 1px solid rgba(255,132,48,0.24);
  	            }
  	
  	            .trackit-action-card.entrance-editing .trackit-action-card-title {
  	            font-size: 12px;
  	            font-weight: 950;
  	            letter-spacing: 0.02em;
  	            color: #ffe7cf;
  	            line-height: 1.1;
  	            }
  	
  	            .trackit-action-card.entrance-editing .trackit-action-card-subtitle {
  	            margin-top: 3px;
  	            font-size: 7px;
  	            font-weight: 950;
  	            letter-spacing: 0.14em;
  	            text-transform: uppercase;
  	            color: rgba(255,154,61,0.78);
  	            line-height: 1;
  	            }
  	
  	            .trackit-entrance-edit-status {
  	            min-height: 42px;
  	            border-radius: 12px;
  	            border: 1px solid rgba(255,255,255,0.08);
  	            background: rgba(255,255,255,0.045);
  	            color: rgba(255,232,208,0.78);
  	            font-size: 8.5px;
  	            font-weight: 850;
  	            line-height: 1.32;
  	            padding: 7px;
  	            }
  	
  	            .trackit-entrance-edit-status.is-error {
  	            color: #ffd0d0;
  	            border-color: rgba(255,80,80,0.42);
  	            background: rgba(255,40,40,0.12);
  	            text-shadow: 0 0 12px rgba(255,60,60,0.35);
  	            }
  	
  	            .trackit-entrance-edit-actions {
  	            display: grid;
  	            grid-template-columns: repeat(2, minmax(0, 1fr));
  	            gap: 6px;
  	            }
  	
  	            .trackit-entrance-edit-btn {
  	            height: 30px;
  	            border-radius: 11px;
  	            border: 1px solid rgba(255,255,255,0.10);
  	            outline: 0;
  	            background:
  	            radial-gradient(circle at 100% 0%, rgba(255,132,48,0.11), transparent 44%),
  	            linear-gradient(145deg, rgba(255,255,255,0.060), rgba(255,255,255,0.020));
  	            color: rgba(255,255,255,0.80);
  	            font-size: 8px;
  	            font-weight: 950;
  	            letter-spacing: 0.03em;
  	            text-transform: uppercase;
  	            cursor: pointer;
  	            padding: 0 6px;
  	            appearance: none;
  	            -webkit-appearance: none;
  	            }
  	
  	            .trackit-entrance-edit-btn:hover {
  	            color: #fff;
  	            border-color: rgba(255,137,56,0.58);
  	            background: rgba(255,111,29,0.15);
  	            }
  	
  	            .trackit-entrance-edit-btn.primary {
  	            color: #fff;
  	            border-color: rgba(255,137,56,0.82);
  	            background:
  	            radial-gradient(circle at 50% 12%, rgba(255,177,92,0.24), transparent 46%),
  	            linear-gradient(145deg, rgba(255,112,30,0.44), rgba(86,30,8,0.68));
  	            box-shadow: 0 0 14px rgba(255,111,29,0.16);
  	            }
  	
  	            .trackit-entrance-edit-btn.danger {
  	            color: rgba(255,222,222,0.86);
  	            }
  	
  	            .trackit-entrance-edit-btn.saving,
  	            .trackit-entrance-edit-btn:disabled {
  	            opacity: 0.62;
  	            pointer-events: none;
  	            }
  	
  	            .trackit-action-card.shape-editing {
  	            width: 178px;
  	            border-radius: 18px;
  	            border: 1px solid rgba(255,132,48,0.46);
  	            background:
  	            radial-gradient(circle at 18% 10%, rgba(255,132,48,0.16), transparent 34%),
  	            linear-gradient(145deg, rgba(16,18,18,0.96), rgba(4,5,5,0.96));
  	            box-shadow:
  	            0 0 0 1px rgba(255,255,255,0.035),
  	            0 18px 38px rgba(0,0,0,0.50),
  	            0 0 26px rgba(255,122,36,0.16);
  	            }
  	
  	            .trackit-action-card.shape-editing .trackit-shape-edit-inner {
  	            padding: 10px;
  	            display: grid;
  	            gap: 8px;
  	            }
  	
  	            .trackit-action-card.shape-editing .trackit-shape-edit-head {
  	            padding: 0 0 7px;
  	            border-bottom: 1px solid rgba(255,132,48,0.24);
  	            }
  	
  	            .trackit-action-card.shape-editing .trackit-action-card-title {
  	            font-size: 12px;
  	            font-weight: 950;
  	            letter-spacing: 0.02em;
  	            color: #ffe7cf;
  	            line-height: 1.1;
  	            }
  	
  	            .trackit-action-card.shape-editing .trackit-action-card-subtitle {
  	            margin-top: 3px;
  	            font-size: 7px;
  	            font-weight: 950;
  	            letter-spacing: 0.14em;
  	            text-transform: uppercase;
  	            color: rgba(255,154,61,0.78);
  	            line-height: 1;
  	            }
  	
  	            .trackit-shape-edit-status {
  	            min-height: 38px;
  	            border-radius: 12px;
  	            border: 1px solid rgba(255,255,255,0.08);
  	            background: rgba(255,255,255,0.045);
  	            color: rgba(255,232,208,0.78);
  	            font-size: 8.5px;
  	            font-weight: 850;
  	            line-height: 1.32;
  	            padding: 7px;
  	            }
  	
  	            .trackit-shape-edit-status.is-error {
  	            color: #ffd0d0;
  	            border-color: rgba(255,80,80,0.42);
  	            background: rgba(255,40,40,0.12);
  	            text-shadow: 0 0 12px rgba(255,60,60,0.35);
  	            }
  	
  	            .trackit-shape-edit-actions-two {
  	            display: grid;
  	            grid-template-columns: repeat(2, minmax(0, 1fr));
  	            gap: 6px;
  	            }
  	
  	            .trackit-shape-edit-btn {
  	            height: 30px;
  	            border-radius: 11px;
  	            border: 1px solid rgba(255,255,255,0.10);
  	            outline: 0;
  	            background:
  	            radial-gradient(circle at 100% 0%, rgba(255,132,48,0.11), transparent 44%),
  	            linear-gradient(145deg, rgba(255,255,255,0.060), rgba(255,255,255,0.020));
  	            color: rgba(255,255,255,0.80);
  	            font-size: 8px;
  	            font-weight: 950;
  	            letter-spacing: 0.03em;
  	            text-transform: uppercase;
  	            cursor: pointer;
  	            padding: 0 6px;
  	            appearance: none;
  	            -webkit-appearance: none;
  	            }
  	
  	            .trackit-shape-edit-btn:hover {
  	            color: #fff;
  	            border-color: rgba(255,137,56,0.58);
  	            background: rgba(255,111,29,0.15);
  	            }
  	
  	            .trackit-shape-edit-btn.primary {
  	            color: #fff;
  	            border-color: rgba(255,137,56,0.82);
  	            background:
  	            radial-gradient(circle at 50% 12%, rgba(255,177,92,0.24), transparent 46%),
  	            linear-gradient(145deg, rgba(255,112,30,0.44), rgba(86,30,8,0.68));
  	            box-shadow: 0 0 14px rgba(255,111,29,0.16);
  	            }
  	
  	            .trackit-shape-edit-btn.danger {
  	            color: rgba(255,222,222,0.86);
  	            }
  	
  	            .trackit-shape-edit-btn.saving,
  	            .trackit-shape-edit-btn:disabled {
  	            opacity: 0.62;
  	            pointer-events: none;
  	            }
  	            .trackit-action-card.shape-editing .trackit-card-action.saving {
  	            opacity: 0.68;
  	            pointer-events: none;
  	            }
  	
  	            .trackit-delete-confirm-blackout {
  	            position: fixed;
  	            inset: 0;
  	            z-index: 2147483646;
  	            pointer-events: none;
  	            opacity: 0;
  	            background:
  	            radial-gradient(circle at 70% 18%, rgba(255,147,52,0.13), transparent 34%),
  	            radial-gradient(circle at 20% 78%, rgba(255,78,54,0.10), transparent 42%),
  	            rgba(0,0,0,0.46);
  	            backdrop-filter: grayscale(0.92) brightness(0.50) contrast(0.92) blur(1.5px);
  	            -webkit-backdrop-filter: grayscale(0.92) brightness(0.50) contrast(0.92) blur(1.5px);
  	            transition:
  	            opacity 150ms ease,
  	            backdrop-filter 150ms ease,
  	            -webkit-backdrop-filter 150ms ease;
  	            }
  	
  	            .trackit-delete-confirm-blackout.open {
  	            opacity: 1;
  	            pointer-events: auto;
  	            }
  	
  	            html.trackit-delete-confirm-open .gm-style,
  	            body.trackit-delete-confirm-open .gm-style {
  	            filter: grayscale(0.88) brightness(0.54) contrast(0.92);
  	            }
  	
  	            .trackit-delete-confirm-popup {
  	            position: fixed;
  	            left: 50%;
  	            top: 46%;
  	            transform: translate(-50%, -50%) scale(0.96);
  	            z-index: 2147483647;
  	            width: min(420px, calc(100vw - 34px));
  	            pointer-events: none;
  	            opacity: 0;
  	            transition:
  	            opacity 150ms ease,
  	            transform 150ms ease;
  	            }
  	
  	            .trackit-delete-confirm-popup.open {
  	            pointer-events: auto;
  	            opacity: 1;
  	            transform: translate(-50%, -50%) scale(1);
  	            }
  	
  	            .trackit-delete-popup-panel {
  	            border-radius: 24px;
  	            border: 1px solid rgba(255,78,54,0.58);
  	            background:
  	            radial-gradient(circle at 16% 8%, rgba(255,78,54,0.24), transparent 34%),
  	            radial-gradient(circle at 88% 120%, rgba(255,132,48,0.13), transparent 42%),
  	            linear-gradient(145deg, rgba(18,15,14,0.985), rgba(4,5,5,0.985));
  	            box-shadow:
  	            0 0 0 1px rgba(255,255,255,0.04),
  	            0 28px 70px rgba(0,0,0,0.62),
  	            0 0 38px rgba(255,70,40,0.18);
  	            overflow: hidden;
  	            backdrop-filter: blur(18px) saturate(1.15);
  	            -webkit-backdrop-filter: blur(18px) saturate(1.15);
  	            }
  	
  	            .trackit-delete-popup-head {
  	            display: grid;
  	            grid-template-columns: 38px minmax(0, 1fr) 30px;
  	            align-items: center;
  	            gap: 11px;
  	            padding: 16px 16px 13px;
  	            border-bottom: 1px solid rgba(255,78,54,0.28);
  	            }
  	
  	            .trackit-delete-popup-icon {
  	            width: 36px;
  	            height: 36px;
  	            border-radius: 15px;
  	            border: 1px solid rgba(255,78,54,0.78);
  	            background:
  	            radial-gradient(circle at 38% 24%, rgba(255,182,98,0.26), transparent 38%),
  	            linear-gradient(145deg, rgba(255,78,54,0.38), rgba(82,14,8,0.76));
  	            color: #ffd6cc;
  	            font-size: 20px;
  	            font-weight: 950;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            box-shadow:
  	            0 0 18px rgba(255,70,40,0.26),
  	            inset 0 1px 0 rgba(255,255,255,0.13);
  	            }
  	
  	            .trackit-delete-popup-title {
  	            font-size: 15px;
  	            font-weight: 950;
  	            letter-spacing: 0.03em;
  	            color: #ffe3d9;
  	            line-height: 1.05;
  	            }
  	
  	            .trackit-delete-popup-subtitle {
  	            margin-top: 5px;
  	            font-size: 8px;
  	            font-weight: 950;
  	            letter-spacing: 0.16em;
  	            text-transform: uppercase;
  	            color: rgba(255,120,90,0.88);
  	            line-height: 1;
  	            }
  	
  	            .trackit-delete-popup-close {
  	            width: 30px;
  	            height: 30px;
  	            border-radius: 12px;
  	            border: 1px solid rgba(255,255,255,0.09);
  	            background: rgba(255,255,255,0.045);
  	            color: rgba(255,235,226,0.76);
  	            font-size: 18px;
  	            font-weight: 800;
  	            line-height: 1;
  	            cursor: pointer;
  	            appearance: none;
  	            -webkit-appearance: none;
  	            }
  	
  	            .trackit-delete-popup-close:hover {
  	            color: #fff;
  	            border-color: rgba(255,78,54,0.58);
  	            background: rgba(255,78,54,0.16);
  	            }
  	
  	            .trackit-delete-popup-body {
  	            display: grid;
  	            gap: 10px;
  	            padding: 15px 16px 14px;
  	            }
  	
  	            .trackit-delete-popup-name {
  	            min-width: 0;
  	            border-radius: 14px;
  	            border: 1px solid rgba(255,255,255,0.08);
  	            background: rgba(255,255,255,0.045);
  	            color: #fff0e8;
  	            font-size: 13px;
  	            font-weight: 950;
  	            line-height: 1.25;
  	            padding: 9px 10px;
  	            word-break: break-word;
  	            }
  	
  	            .trackit-delete-popup-copy,
  	            .trackit-delete-popup-child-warning {
  	            color: rgba(255,232,220,0.72);
  	            font-size: 10px;
  	            font-weight: 800;
  	            line-height: 1.42;
  	            }
  	
  	            .trackit-delete-popup-child-warning {
  	            border-radius: 13px;
  	            border: 1px solid rgba(255,132,48,0.24);
  	            background: rgba(255,132,48,0.08);
  	            padding: 9px 10px;
  	            color: rgba(255,220,190,0.84);
  	            }
  	
  	            .trackit-delete-popup-child-warning strong {
  	            color: #ffb36c;
  	            }
  	
  	            .trackit-delete-popup-label {
  	            color: rgba(255,235,226,0.80);
  	            font-size: 9px;
  	            font-weight: 950;
  	            letter-spacing: 0.055em;
  	            text-transform: uppercase;
  	            }
  	
  	            .trackit-delete-popup-label strong {
  	            color: #ff9a72;
  	            }
  	
  	            .trackit-delete-popup-input {
  	            width: 100%;
  	            height: 40px;
  	            box-sizing: border-box;
  	            border-radius: 14px;
  	            border: 1px solid rgba(255,255,255,0.12);
  	            outline: 0;
  	            background:
  	            linear-gradient(145deg, rgba(255,255,255,0.065), rgba(255,255,255,0.022));
  	            color: #fff;
  	            font-size: 14px;
  	            font-weight: 950;
  	            letter-spacing: 0.11em;
  	            text-transform: uppercase;
  	            padding: 0 12px;
  	            appearance: none;
  	            -webkit-appearance: none;
  	            }
  	
  	            .trackit-delete-popup-input:focus {
  	            border-color: rgba(255,132,48,0.76);
  	            box-shadow:
  	            0 0 0 1px rgba(255,132,48,0.20),
  	            0 0 18px rgba(255,100,54,0.16);
  	            }
  	
  	            .trackit-delete-popup-input.is-valid {
  	            border-color: rgba(88,220,126,0.74);
  	            box-shadow:
  	            0 0 0 1px rgba(88,220,126,0.18),
  	            0 0 18px rgba(88,220,126,0.14);
  	            }
  	
  	            .trackit-delete-popup-input.is-invalid {
  	            border-color: rgba(255,78,54,0.66);
  	            }
  	
  	            .trackit-delete-popup-error {
  	            display: none;
  	            color: #ffd0c8;
  	            font-size: 8px;
  	            font-weight: 850;
  	            line-height: 1.2;
  	            }
  	
  	            .trackit-delete-popup-error.visible {
  	            display: block;
  	            }
  	
  	            .trackit-delete-popup-actions {
  	            display: grid;
  	            grid-template-columns: repeat(2, minmax(0, 1fr));
  	            gap: 9px;
  	            padding: 0 16px 16px;
  	            }
  	
  	            .trackit-delete-popup-btn {
  	            height: 36px;
  	            border-radius: 13px;
  	            border: 1px solid rgba(255,255,255,0.10);
  	            outline: 0;
  	            background:
  	            radial-gradient(circle at 100% 0%, rgba(255,132,48,0.10), transparent 44%),
  	            linear-gradient(145deg, rgba(255,255,255,0.060), rgba(255,255,255,0.020));
  	            color: rgba(255,255,255,0.82);
  	            font-size: 9px;
  	            font-weight: 950;
  	            letter-spacing: 0.06em;
  	            text-transform: uppercase;
  	            cursor: pointer;
  	            padding: 0 8px;
  	            appearance: none;
  	            -webkit-appearance: none;
  	            }
  	
  	            .trackit-delete-popup-btn:hover:not(:disabled) {
  	            color: #fff;
  	            border-color: rgba(255,137,56,0.60);
  	            background: rgba(255,111,29,0.15);
  	            }
  	
  	            .trackit-delete-popup-btn.danger {
  	            color: #ffe1d8;
  	            border-color: rgba(255,78,54,0.84);
  	            background:
  	            radial-gradient(circle at 50% 12%, rgba(255,177,92,0.18), transparent 46%),
  	            linear-gradient(145deg, rgba(255,78,54,0.48), rgba(88,12,8,0.76));
  	            box-shadow: 0 0 16px rgba(255,70,40,0.18);
  	            }
  	
  	            .trackit-delete-popup-btn.danger:hover:not(:disabled) {
  	            border-color: rgba(255,116,86,0.96);
  	            box-shadow:
  	            0 0 0 1px rgba(255,78,54,0.20),
  	            0 0 20px rgba(255,70,40,0.26);
  	            }
  	
  	            .trackit-delete-popup-btn:disabled,
  	            .trackit-delete-popup-btn.saving {
  	            opacity: 0.52;
  	            pointer-events: none;
  	            }
  	
  	            .trackit-delete-confirm-inner {
  	            padding: 11px;
  	            display: grid;
  	            gap: 10px;
  	            }
  	
  	            .trackit-delete-confirm-head {
  	            display: grid;
  	            grid-template-columns: 32px minmax(0, 1fr);
  	            align-items: center;
  	            gap: 9px;
  	            padding-bottom: 9px;
  	            border-bottom: 1px solid rgba(255,78,54,0.28);
  	            }
  	
  	            .trackit-delete-confirm-icon {
  	            width: 30px;
  	            height: 30px;
  	            border-radius: 13px;
  	            border: 1px solid rgba(255,78,54,0.72);
  	            background:
  	            radial-gradient(circle at 38% 24%, rgba(255,182,98,0.25), transparent 38%),
  	            linear-gradient(145deg, rgba(255,78,54,0.34), rgba(82,14,8,0.72));
  	            color: #ffd6cc;
  	            font-size: 17px;
  	            font-weight: 950;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            box-shadow:
  	            0 0 16px rgba(255,70,40,0.24),
  	            inset 0 1px 0 rgba(255,255,255,0.12);
  	            }
  	
  	            .trackit-action-card.delete-confirming .trackit-action-card-title {
  	            font-size: 12px;
  	            font-weight: 950;
  	            letter-spacing: 0.03em;
  	            color: #ffe3d9;
  	            line-height: 1.05;
  	            }
  	
  	            .trackit-action-card.delete-confirming .trackit-action-card-subtitle {
  	            margin-top: 4px;
  	            font-size: 7px;
  	            font-weight: 950;
  	            letter-spacing: 0.15em;
  	            text-transform: uppercase;
  	            color: rgba(255,120,90,0.86);
  	            line-height: 1;
  	            }
  	
  	            .trackit-action-card.open.editing {
  	            height: auto !important;
  	            overflow: visible !important;
  	            }
  	
  	            .trackit-action-card.open.editing .trackit-action-card-body {
  	            max-height: none !important;
  	            height: auto !important;
  	            overflow-y: visible !important;
  	            }
  	
  	            /* JS will add inline max-height only when the card truly hits the Map Control limit. */
  	            .trackit-action-card.open.editing[style*="max-height"] .trackit-action-card-body {
  	            scrollbar-width: none !important;
  	            -ms-overflow-style: none !important;
  	            }
  	
  	            .trackit-action-card.open.editing[style*="max-height"] .trackit-action-card-body::-webkit-scrollbar {
  	            width: 0 !important;
  	            height: 0 !important;
  	            display: none !important;
  	            }
  	
  	            .trackit-delete-confirm-body {
  	            display: grid;
  	            gap: 8px;
  	            }
  	
  	            .trackit-delete-confirm-name {
  	            min-width: 0;
  	            border-radius: 12px;
  	            border: 1px solid rgba(255,255,255,0.08);
  	            background: rgba(255,255,255,0.045);
  	            color: #fff0e8;
  	            font-size: 11px;
  	            font-weight: 950;
  	            line-height: 1.25;
  	            padding: 7px 8px;
  	            word-break: break-word;
  	            }
  	
  	            .trackit-delete-confirm-copy,
  	            .trackit-delete-confirm-child-warning {
  	            color: rgba(255,232,220,0.70);
  	            font-size: 8.5px;
  	            font-weight: 800;
  	            line-height: 1.34;
  	            }
  	
  	            .trackit-delete-confirm-child-warning {
  	            border-radius: 11px;
  	            border: 1px solid rgba(255,132,48,0.22);
  	            background: rgba(255,132,48,0.075);
  	            padding: 7px;
  	            color: rgba(255,220,190,0.82);
  	            }
  	
  	            .trackit-delete-confirm-child-warning strong {
  	            color: #ffb36c;
  	            }
  	
  	            .trackit-delete-confirm-label {
  	            color: rgba(255,235,226,0.78);
  	            font-size: 8px;
  	            font-weight: 900;
  	            letter-spacing: 0.04em;
  	            text-transform: uppercase;
  	            }
  	
  	            .trackit-delete-confirm-label strong {
  	            color: #ff9a72;
  	            }
  	
  	            .trackit-delete-confirm-input {
  	            width: 100%;
  	            height: 34px;
  	            box-sizing: border-box;
  	            border-radius: 12px;
  	            border: 1px solid rgba(255,255,255,0.11);
  	            outline: 0;
  	            background:
  	            linear-gradient(145deg, rgba(255,255,255,0.060), rgba(255,255,255,0.020));
  	            color: #fff;
  	            font-size: 12px;
  	            font-weight: 950;
  	            letter-spacing: 0.10em;
  	            text-transform: uppercase;
  	            padding: 0 10px;
  	            appearance: none;
  	            -webkit-appearance: none;
  	            }
  	
  	            .trackit-delete-confirm-input:focus {
  	            border-color: rgba(255,132,48,0.72);
  	            box-shadow:
  	            0 0 0 1px rgba(255,132,48,0.18),
  	            0 0 16px rgba(255,100,54,0.15);
  	            }
  	
  	            .trackit-delete-confirm-input.is-valid {
  	            border-color: rgba(88,220,126,0.72);
  	            box-shadow:
  	            0 0 0 1px rgba(88,220,126,0.18),
  	            0 0 16px rgba(88,220,126,0.14);
  	            }
  	
  	            .trackit-delete-confirm-input.is-invalid {
  	            border-color: rgba(255,78,54,0.64);
  	            }
  	
  	            .trackit-delete-confirm-error {
  	            display: none;
  	            color: #ffd0c8;
  	            font-size: 7.5px;
  	            font-weight: 850;
  	            line-height: 1.2;
  	            }
  	
  	            .trackit-delete-confirm-error.visible {
  	            display: block;
  	            }
  	
  	            .trackit-delete-confirm-actions {
  	            display: grid;
  	            grid-template-columns: repeat(2, minmax(0, 1fr));
  	            gap: 7px;
  	            }
  	
  	            .trackit-delete-confirm-btn {
  	            height: 31px;
  	            border-radius: 11px;
  	            border: 1px solid rgba(255,255,255,0.10);
  	            outline: 0;
  	            background:
  	            radial-gradient(circle at 100% 0%, rgba(255,132,48,0.10), transparent 44%),
  	            linear-gradient(145deg, rgba(255,255,255,0.060), rgba(255,255,255,0.020));
  	            color: rgba(255,255,255,0.80);
  	            font-size: 8px;
  	            font-weight: 950;
  	            letter-spacing: 0.05em;
  	            text-transform: uppercase;
  	            cursor: pointer;
  	            padding: 0 7px;
  	            appearance: none;
  	            -webkit-appearance: none;
  	            }
  	
  	            .trackit-delete-confirm-btn:hover:not(:disabled) {
  	            color: #fff;
  	            border-color: rgba(255,137,56,0.58);
  	            background: rgba(255,111,29,0.15);
  	            }
  	
  	            .trackit-delete-confirm-btn.danger {
  	            color: #ffe1d8;
  	            border-color: rgba(255,78,54,0.82);
  	            background:
  	            radial-gradient(circle at 50% 12%, rgba(255,177,92,0.18), transparent 46%),
  	            linear-gradient(145deg, rgba(255,78,54,0.46), rgba(88,12,8,0.74));
  	            box-shadow: 0 0 14px rgba(255,70,40,0.16);
  	            }
  	
  	            .trackit-delete-confirm-btn.danger:hover:not(:disabled) {
  	            border-color: rgba(255,116,86,0.95);
  	            box-shadow:
  	            0 0 0 1px rgba(255,78,54,0.20),
  	            0 0 18px rgba(255,70,40,0.25);
  	            }
  	
  	            .trackit-delete-confirm-btn:disabled,
  	            .trackit-delete-confirm-btn.saving {
  	            opacity: 0.52;
  	            pointer-events: none;
  	            }
  	            `;
  	
  	            let style = document.getElementById(STYLE_ID);
  	
  	            if (!style) {
  	              style = document.createElement("style");
  	              style.id = STYLE_ID;
  	              document.head.appendChild(style);
  	            }
  	
  	            style.textContent = css;
  	
  	            // ============================================================
  	            // Build dropdown
  	            // ============================================================
  	
  	            const dropdown = document.createElement("div");
  	            dropdown.className = "trackit-location-dropdown";
  	
  	            const control = document.createElement("div");
  	            control.className = "trackit-location-control";
  	
  	            const inputRow = document.createElement("div");
  	            inputRow.className = "trackit-input-row";
  	
  	            const searchIcon = document.createElement("span");
  	            searchIcon.className = "trackit-search-icon";
  	            searchIcon.textContent = "⌕";
  	
  	            const selectedIcon = document.createElement("img");
  	            selectedIcon.className = "trackit-selected-icon";
  	            selectedIcon.alt = "";
  	
  	            const searchInput = document.createElement("input");
  	            searchInput.className = "trackit-search-input";
  	            searchInput.type = "text";
  	            searchInput.placeholder = "Search Location";
  	            searchInput.autocomplete = "off";
  	            searchInput.spellcheck = false;
  	
  	            inputRow.appendChild(searchIcon);
  	            inputRow.appendChild(selectedIcon);
  	            inputRow.appendChild(searchInput);
  	
  	            const clear = document.createElement("span");
  	            clear.className = "trackit-clear";
  	            clear.innerHTML = "&times;";
  	
  	            const arrowHit = document.createElement("span");
  	            arrowHit.className = "trackit-arrow-hit";
  	
  	            const arrowTriangle = document.createElement("span");
  	            arrowTriangle.className = "trackit-arrow-triangle";
  	
  	            arrowHit.appendChild(arrowTriangle);
  	
  	            const googleToggle = document.createElement("button");
  	            googleToggle.className = "trackit-google-toggle";
  	            googleToggle.type = "button";
  	            googleToggle.title = "Toggle Google Location Search";
  	            googleToggle.setAttribute("aria-label", "Toggle Google Location Search");
  	            googleToggle.setAttribute("aria-pressed", "false");
  	            googleToggle.innerHTML = `
  	            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  	            <circle cx="12" cy="12" r="8.5" stroke-width="2"></circle>
  	            <path d="M3.8 12h16.4" stroke-width="2" stroke-linecap="round"></path>
  	            <path d="M12 3.5c2.25 2.35 3.35 5.18 3.35 8.5S14.25 18.15 12 20.5" stroke-width="2" stroke-linecap="round"></path>
  	            <path d="M12 3.5C9.75 5.85 8.65 8.68 8.65 12s1.1 6.15 3.35 8.5" stroke-width="2" stroke-linecap="round"></path>
  	            </svg>
  	            `;
  	
  	            const coordinateToggle = document.createElement("button");
  	            coordinateToggle.className = "trackit-coordinate-toggle";
  	            coordinateToggle.type = "button";
  	            coordinateToggle.title = "Coordinate Search: enter latitude, longitude";
  	            coordinateToggle.setAttribute("aria-label", "Toggle point search by coordinates or map click");
  	            coordinateToggle.setAttribute("aria-disabled", "false");
  	            coordinateToggle.setAttribute("aria-pressed", "false");
  	            coordinateToggle.innerHTML = "&#8857;";
  	
  	            control.appendChild(inputRow);
  	            control.appendChild(clear);
  	            control.appendChild(arrowHit);
  	            control.appendChild(coordinateToggle);
  	            control.appendChild(googleToggle);
  	
  	            const menu = document.createElement("div");
  	            menu.className = "trackit-menu";
  	
  	            const actionCard = document.createElement("div");
  	            actionCard.className = "trackit-action-card";
  	
  	            const pointEditorPanel = document.createElement("div");
  	            pointEditorPanel.className = "trackit-point-editor";
  	            pointEditorPanel.setAttribute("role", "dialog");
  	            pointEditorPanel.setAttribute("aria-label", "Point Location Editor");
  	
  	            dropdown.appendChild(control);
  	            dropdown.appendChild(menu);
  	            dropdown.appendChild(actionCard);
  	            dropdown.appendChild(pointEditorPanel);
  	            root.appendChild(dropdown);
  	
  	            let selectedValue = null;
  	            let selectedItem = null;
  	            let selectedLabel = "";
  	            let selectedRowData = null;
  	            let visibleRows = [];
  	            let activeIndex = -1;
  	            let suppressFocusOpenUntil = 0;
  	            let menuResizeRaf = 0;
  	            let mapControlWatchRetry = null;
  	            let watchedMapControl = null;
  	            let mapControlMutationObserver = null;
  	            let mapControlResizeObserver = null;
  	
  	            let locationSearchMode = "trackit";
  	            let googleAutocompleteService = null;
  	            let googlePlacesService = null;
  	            let googlePredictionRequestId = 0;
  	            let googlePredictions = [];
  	            let coordinateSearchMarker = null;
  	            let pointSearchActive = false;
  	            let pointMapClickListener = null;
  	            let pointMapDomElement = null;
  	            let pointMapDomClickHandler = null;
  	            let pointProjectionOverlay = null;
  	            let pointProjectionMap = null;
  	            let pointMarkerClickSuppressUntil = 0;
  	            let pointLocationClickState = [];
  	            let pointSavedMarkers = [];
  	            let pointLoadRequestId = 0;
  	            let pointSaveBusy = false;
  	            let pointDeleteBusy = false;
  	            let pointWhatsappBusy = false;
  	            let segmentPointWhatsappBusy = false;
  	            let activeSegmentPointLabelOverlay = null;
  	            let activePointContext = null;
  	            let pointPreferredCompanyId = "";
  	
  	            buildTreeRows();
  	            markDefaultCollapsedStates();
  	
  	            const existingSelectedObjectId = readSelectedLocationMarkerId();
  	
  	            function readStoredLocationSearchMode() {
  	              try {
  	                const appData = getAppBag();
  	                const value = safeString(appData?.TrackITLocationSearchMode).trim().toLowerCase();
  	
  	                return value === "google" ? "google": "trackit";
  	              } catch (_) {
  	                return "trackit";
  	              }
  	            }
  	
  	            function writeStoredLocationSearchMode(mode) {
  	              try {
  	                const appData = getAppBag();
  	
  	                if (appData) {
  	                  appData.TrackITLocationSearchMode = mode === "google" ? "google": "trackit";
  	                  refreshApp();
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function isGoogleSearchMode() {
  	              return locationSearchMode === "google";
  	            }
  	
  	            function applyLocationSearchModeVisualState() {
  	              const googleMode = isGoogleSearchMode();
  	
  	              dropdown.classList.toggle("google-mode", googleMode);
  	              dropdown.classList.toggle("point-mode-active", pointSearchActive);
  	              googleToggle.setAttribute("aria-pressed", googleMode ? "true": "false");
  	              googleToggle.title = googleMode
  	              ? "Google Location Search is ON": "Google Location Search is OFF";
  	
  	              coordinateToggle.classList.toggle("is-point-mode", pointSearchActive);
  	              coordinateToggle.setAttribute("aria-pressed", pointSearchActive ? "true": "false");
  	
  	              searchInput.placeholder = googleMode
  	              ? `Search Google Location · ${GOOGLE_LOCATION_LABEL}`
  	              : pointSearchActive
  	              ? "Point Search · type coordinates or click map"
  	              : "Search Location";
  	            }
  	
  	            function setLocationSearchMode(mode) {
  	              const nextMode = mode === "google" ? "google": "trackit";
  	
  	              if (locationSearchMode === nextMode) {
  	                applyLocationSearchModeVisualState();
  	                return;
  	              }
  	
  	              locationSearchMode = nextMode;
  	              googlePredictions = [];
  	              activeIndex = -1;
  	
  	              if (nextMode === "google" && pointSearchActive) {
  	                setPointSearchActive(false);
  	              }
  	
  	              closeActionCard();
  	              applyLocationSearchModeVisualState();
  	              writeStoredLocationSearchMode(locationSearchMode);
  	
  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	            }
  	
  	            function toggleLocationSearchMode() {
  	              setLocationSearchMode(isGoogleSearchMode() ? "trackit": "google");
  	            }
  	
  	            locationSearchMode = readStoredLocationSearchMode();
  	            applyLocationSearchModeVisualState();
  	            updateCoordinateSearchButtonState(searchInput.value);
  	
  	            // ============================================================
  	            // Dropdown behaviour
  	            // ============================================================
  	            function getMapControlTopLimit() {
  	              try {
  	                let top = Infinity;
  	
  	                MAP_CONTROL_SELECTORS.forEach(selector => {
  	                  document.querySelectorAll(selector).forEach(controlEl => {
  	                    const rect = controlEl.getBoundingClientRect();
  	
  	                    if (rect.width > 0 && rect.height > 0 && rect.top > 0) {
  	                      top = Math.min(top, rect.top);
  	                    }
  	                  });
  	                });
  	
  	                if (Number.isFinite(top)) {
  	                  return top - MAP_CONTROL_GAP_PX;
  	                }
  	              } catch (_) {}
  	
  	              return window.innerHeight - 8;
  	            }
  	
  	            function updateMenuHeightToBottom() {
  	              try {
  	                const rect = menu.getBoundingClientRect();
  	                const bottomLimit = getMapControlTopLimit();
  	                const availableHeight = Math.max(40, Math.floor(bottomLimit - rect.top));
  	
  	                let contentHeight = 0;
  	
  	                Array.from(menu.children).forEach(child => {
  	                  const childRect = child.getBoundingClientRect();
  	
  	                  if (childRect && childRect.height) {
  	                    contentHeight += childRect.height;
  	                  }
  	                });
  	
  	                contentHeight = Math.ceil(contentHeight + 8);
  	
  	                const safeHeight = Math.max(40,
  	                  Math.min(contentHeight, availableHeight));
  	
  	                menu.style.setProperty("--trackit-menu-height",
  	                  `${safeHeight}px`);
  	                menu.style.height = `${safeHeight}px`;
  	                menu.style.maxHeight = `${safeHeight}px`;
  	
  	                growHubToMenuHeight(safeHeight);
  	              } catch (e) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not calculate menu height.",
  	                  e);
  	              }
  	            }
  	
  	            function growHubToMenuHeight(menuHeight) {
  	              try {
  	                if (!hubElement) return;
  	                if (!dropdown.classList.contains("open")) return;
  	
  	                const hubRect = hubElement.getBoundingClientRect();
  	                const menuRect = menu.getBoundingClientRect();
  	
  	                const neededBottom = menuRect.top + menuHeight;
  	                const neededHeight = Math.ceil(neededBottom - hubRect.top + 2);
  	
  	                if (!Number.isFinite(neededHeight) || neededHeight <= 40) return;
  	
  	                hubElement.style.height = `${neededHeight}px`;
  	                hubElement.style.minHeight = `${neededHeight}px`;
  	                hubElement.style.maxHeight = "none";
  	                hubElement.style.overflow = "visible";
  	
  	                if (!hubElement.style.transition) {
  	                  hubElement.style.transition = "height 140ms ease, min-height 140ms ease";
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function resetHubHeight() {
  	              try {
  	                if (!hubElement || !hubOriginalStyle) return;
  	
  	                hubElement.style.height = hubOriginalStyle.height;
  	                hubElement.style.minHeight = hubOriginalStyle.minHeight;
  	                hubElement.style.maxHeight = hubOriginalStyle.maxHeight;
  	                hubElement.style.overflow = hubOriginalStyle.overflow;
  	                hubElement.style.transition = hubOriginalStyle.transition;
  	              } catch (_) {}
  	            }
  	
  	            function scheduleHubAndMenuResize() {
  	              try {
  	                if (!dropdown.classList.contains("open")) return;
  	
  	                requestAnimationFrame(function () {
  	                  updateMenuHeightToBottom();
  	                });
  	
  	                setTimeout(function () {
  	                  if (dropdown.classList.contains("open")) {
  	                    updateMenuHeightToBottom();
  	                  }
  	                },
  	                  180);
  	              } catch (_) {}
  	            }
  	
  	            function scheduleMenuHeightRefresh() {
  	              try {
  	                if (!dropdown.classList.contains("open")) return;
  	
  	                if (menuResizeRaf) {
  	                  cancelAnimationFrame(menuResizeRaf);
  	                }
  	
  	                menuResizeRaf = requestAnimationFrame(function () {
  	                  menuResizeRaf = 0;
  	                  updateMenuHeightToBottom();
  	                });
  	              } catch (_) {}
  	            }
  	
  	            function getActiveMapControlElement() {
  	              try {
  	                for (let i = 0; i < MAP_CONTROL_SELECTORS.length; i++) {
  	                  const controls = Array.from(document.querySelectorAll(MAP_CONTROL_SELECTORS[i]));
  	
  	                  const found = controls.find(controlEl => {
  	                    const rect = controlEl.getBoundingClientRect();
  	                    return rect.width > 0 && rect.height > 0;
  	                  });
  	
  	                  if (found) return found;
  	                }
  	
  	                return null;
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function mapControlLayoutHandler() {
  	              scheduleMenuHeightRefresh();
  	
  	              setTimeout(function () {
  	                scheduleMenuHeightRefresh();
  	              }, 180);
  	            }
  	
  	            function bindMapControlLayoutListener() {
  	              try {
  	                if (mapControlWatchRetry) {
  	                  clearTimeout(mapControlWatchRetry);
  	                  mapControlWatchRetry = null;
  	                }
  	
  	                const mapControl = getActiveMapControlElement();
  	
  	                if (!mapControl) {
  	                  mapControlWatchRetry = setTimeout(bindMapControlLayoutListener, 250);
  	                  return;
  	                }
  	
  	                if (watchedMapControl === mapControl) {
  	                  return;
  	                }
  	
  	                if (watchedMapControl) {
  	                  try {
  	                    watchedMapControl.removeEventListener("click", mapControlLayoutHandler, true);
  	                  } catch (_) {}
  	                }
  	
  	                if (mapControlMutationObserver) {
  	                  try {
  	                    mapControlMutationObserver.disconnect();
  	                  } catch (_) {}
  	                }
  	
  	                if (mapControlResizeObserver) {
  	                  try {
  	                    mapControlResizeObserver.disconnect();
  	                  } catch (_) {}
  	                }
  	
  	                watchedMapControl = mapControl;
  	
  	                watchedMapControl.addEventListener("click", mapControlLayoutHandler, true);
  	
  	                mapControlMutationObserver = new MutationObserver(mapControlLayoutHandler);
  	                mapControlMutationObserver.observe(watchedMapControl, {
  	                  attributes: true,
  	                  attributeFilter: ["class", "style"]
  	                });
  	
  	                if (typeof ResizeObserver !== "undefined") {
  	                  mapControlResizeObserver = new ResizeObserver(mapControlLayoutHandler);
  	                  mapControlResizeObserver.observe(watchedMapControl);
  	                }
  	
  	                scheduleMenuHeightRefresh();
  	              } catch (_) {}
  	            }
  	
  	            function notifyCarvedShellLayout() {
  	              try {
  	                const bridge = window.__CarvedEdgeShapeDropdownBridge;
  	
  	                if (bridge && typeof bridge.resizeTopShell === "function") {
  	                  bridge.resizeTopShell();
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function notifyCarvedShellReset() {
  	              try {
  	                const bridge = window.__CarvedEdgeShapeDropdownBridge;
  	
  	                if (bridge && typeof bridge.resetTopShell === "function") {
  	                  bridge.resetTopShell();
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function openDropdown() {
  	              if (isShapeEditActive()) {
  	                flashActiveShapeEditLock("Save or cancel the shape edit before searching/selecting another location.");
  	                return;
  	              }
  	
  	              actionCard.classList.remove("open");
  	              dropdown.classList.add("open");
  	              scheduleHubAndMenuResize();
  	              notifyCarvedShellLayout();
  	
  	              setTimeout(notifyCarvedShellLayout, 80);
  	              setTimeout(notifyCarvedShellLayout, 220);
  	            }
  	
  	            function closeDropdown() {
  	              dropdown.classList.remove("open");
  	              activeIndex = -1;
  	              paintActiveRow();
  	              resetHubHeight();
  	
  	              if (!actionCard.classList.contains("open")) {
  	                notifyCarvedShellReset();
  	              }
  	            }
  	
  	            function closeActionCard() {
  	              if (isShapeEditActive()) {
  	                cancelActiveShapeEditBecauseClosed("action-card-closed");
  	              }
  	
  	              if (isEntranceEditActive()) {
  	                cancelActiveEntranceEditBecauseClosed("action-card-closed");
  	              }
  	
  	              clearCardTemporarySegmentPolygons();
  	
  	              if (
  	                actionCard.classList.contains("editing") &&
  	                !actionCard.classList.contains("shape-editing") &&
  	                actionCard.__editRowData &&
  	                actionCard.__editSnapshot
  	              ) {
  	                restoreEditSnapshotAndRefresh(actionCard.__editRowData, "location-edit-close-revert");
  	              }
  	              actionCard.classList.remove("open");
  	              resetHubHeight();
  	
  	
  	              if (!dropdown.classList.contains("open")) {
  	                notifyCarvedShellReset();
  	              }
  	            }
  	
  	            function toggleDropdownFromArrow() {
  	              suppressFocusOpenUntil = Date.now() + 250;
  	
  	              if (dropdown.classList.contains("open")) {
  	                closeDropdown();
  	
  	                try {
  	                  searchInput.blur();
  	                } catch (_) {}
  	
  	                return;
  	              }
  	
  	              searchInput.focus();
  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	              openDropdown();
  	            }
  	
  	            function dispatchDropdownEvent(target, eventName, detail) {
  	              try {
  	                target.dispatchEvent(new CustomEvent(eventName, {
  	                  bubbles: true,
  	                  detail
  	                }));
  	              } catch (_) {}
  	
  	              try {
  	                window.dispatchEvent(new CustomEvent(eventName, {
  	                  detail
  	                }));
  	              } catch (_) {}
  	            }
  	
  	            function buildEventDetail(rowData, extra) {
  	              const location = rowData?.location || selectedItem || null;
  	              const value = rowData?.value || selectedValue || null;
  	
  	              return Object.assign({
  	                value,
  	                item: location,
  	                location,
  	                rowData: rowData || selectedRowData || null,
  	                company: rowData?.companyEntry?.company || null,
  	                companyLabel: rowData?.companyEntry?.label || "",
  	                path: rowData?.path || "",
  	                source: "trackit-location-dropdown",
  	                actionMode: SEARCH_ACTION_MODE,
  	                placeholder: SEARCH_ACTION_MODE === "placeholder"
  	              }, extra || {});
  	            }
  	
  	            function emitChange(rowData) {
  	              const location = rowData?.location || selectedItem || null;
  	              const value = rowData?.value || selectedValue || null;
  	
  	              root.locationDropdownValue = value;
  	              root.locationDropdownItem = location;
  	              root.locationDropdownLocation = location;
  	
  	              dispatchDropdownEvent(root, EVENT_LOCATION_CHANGE, {
  	                value,
  	                item: location,
  	                location
  	              });
  	            }
  	
  	            function emitRouterEvent(eventName, rowData, extra) {
  	              dispatchDropdownEvent(root, eventName, buildEventDetail(rowData, extra));
  	            }
  	
  	            function setQueryState() {
  	              const query = searchInput.value.trim();
  	
  	              if (query) {
  	                dropdown.classList.add("has-query");
  	              } else {
  	                dropdown.classList.remove("has-query");
  	              }
  	            }
  	
  	            function paintActiveRow() {
  	              menu.querySelectorAll(".trackit-location-item, .trackit-google-place-item").forEach(row => {
  	                row.classList.toggle("active", row.__rowIndex === activeIndex);
  	              });
  	
  	              const active = menu.querySelector(".trackit-location-item.active, .trackit-google-place-item.active");
  	
  	              if (active) {
  	                active.scrollIntoView({
  	                  block: "nearest"
  	                });
  	              }
  	            }
  	
  	            function paintSelectedRow(rowData, shouldRunSelectionPipeline) {
  	              if (!rowData) return;
  	
  	              if (isShapeEditActive()) {
  	                flashActiveShapeEditLock("Shape editing is active. Save or cancel before selecting another location.");
  	                return;
  	              }
  	
  	              const location = rowData.location;
  	              const value = rowData.value;
  	              const label = rowData.label;
  	
  	              clearCoordinateSearchMarker();
  	
  	              selectedValue = value;
  	              selectedItem = location;
  	              selectedLabel = label;
  	              selectedRowData = rowData;
  	
  	              searchInput.value = label;
  	              selectedIcon.src = iconUrl(location);
  	
  	              dropdown.classList.add("has-value");
  	              dropdown.classList.remove("has-query");
  	
  	              menu.querySelectorAll(".trackit-location-item").forEach(element => {
  	                element.classList.toggle("selected", element.__locationValue === value);
  	              });
  	
  	              if (shouldRunSelectionPipeline) {
  	                runLocationSelectionPipeline(rowData);
  	              }
  	            }
  	
  	            function clearSelected(shouldWrite) {
  	              clearCoordinateSearchMarker();
  	
  	              selectedValue = null;
  	              selectedItem = null;
  	              selectedLabel = "";
  	              selectedRowData = null;
  	
  	              searchInput.value = "";
  	              selectedIcon.removeAttribute("src");
  	
  	              dropdown.classList.remove("has-value");
  	              dropdown.classList.remove("has-query");
  	
  	              menu.querySelectorAll(".trackit-location-item").forEach(element => {
  	                element.classList.remove("selected");
  	              });
  	
  	              closeActionCard();
  	              renderMenu("");
  	
  	              if (shouldWrite) {
  	                clearSelectedLocationFromAppData();
  	
  	                root.locationDropdownValue = null;
  	                root.locationDropdownItem = null;
  	                root.locationDropdownLocation = null;
  	
  	                dispatchDropdownEvent(root, EVENT_LOCATION_CHANGE, {
  	                  value: null,
  	                  item: null,
  	                  location: null
  	                });
  	              }
  	            }
  	
  	            function toggleCompanyGroup(companyEntry) {
  	              if (!companyEntry) return;
  	
  	              const collapsed = root.__trackitCollapsedLocationTree;
  	              const companyKey = companyEntry.key;
  	              const companyId = safeString(companyEntry.id).trim();
  	              const isCollapsed = !collapsed[companyKey];
  	
  	              collapsed[companyKey] = isCollapsed;
  	
  	              if (companyId) {
  	                if (isCollapsed) {
  	                  dropdownCompanyVisibilityState.collapsedCompanyIds.add(companyId);
  	                } else {
  	                  dropdownCompanyVisibilityState.collapsedCompanyIds.delete(companyId);
  	                }
  	              }
  	
  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	              openDropdown();
  	              refreshDropdownLayoutAfterTreeChange();
  	              refreshLocationCreationCompanyScope("location-dropdown-company-visibility");
  	            }
  	
  	            function toggleTypeGroup(typeGroupKey) {
  	              const collapsed = root.__trackitCollapsedLocationTree;
  	              collapsed[typeGroupKey] = !collapsed[typeGroupKey];
  	
  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	              openDropdown();
  	              refreshDropdownLayoutAfterTreeChange();
  	            }
  	
  	            function toggleLocationNode(nodeKey) {
  	              const collapsed = root.__trackitCollapsedLocationTree;
  	              collapsed[nodeKey] = !collapsed[nodeKey];
  	
  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	              openDropdown();
  	              refreshDropdownLayoutAfterTreeChange();
  	            }
  	            // ============================================================
  	            // Placeholder card / router
  	            // ============================================================
  	
  	
  	            function normalizeCardNumber(value) {
  	              const number = typeof value === "string" ? Number(value): value;
  	
  	              return typeof number === "number" && !Number.isNaN(number) ? number: null;
  	            }
  	
  	            function getLocationData(location) {
  	              return (
  	                location?.LocationData ||
  	                location?.locationData ||
  	                location?.Data ||
  	                location?.data ||
  	                {}
  	              );
  	            }
  	
  	            function getCardType(location, rowData) {
  	              return (
  	                location?.Type ||
  	                location?.type ||
  	                location?.LocationType ||
  	                location?.locationType ||
  	                rowData?.type ||
  	                ""
  	              );
  	            }
  	
  	            function getCardContactName(location) {
  	              const data = getLocationData(location);
  	
  	              return (
  	                data?.ContactName ||
  	                data?.contactName ||
  	                data?.Contact ||
  	                data?.contact ||
  	                location?.ContactName ||
  	                location?.contactName ||
  	                ""
  	              );
  	            }
  	
  	            function getCardContactNumber(location) {
  	              const data = getLocationData(location);
  	
  	              return (
  	                data?.ContactNumber ||
  	                data?.contactNumber ||
  	                data?.PhoneNumber ||
  	                data?.phoneNumber ||
  	                data?.Phone ||
  	                data?.phone ||
  	                location?.ContactNumber ||
  	                location?.contactNumber ||
  	                location?.PhoneNumber ||
  	                location?.phoneNumber ||
  	                ""
  	              );
  	            }
  	
  	            function getCardStoredAreaHa(location) {
  	              const data = getLocationData(location);
  	              const area = data?.Area || data?.area || location?.Area || location?.area || null;
  	
  	              const hectares = normalizeCardNumber(
  	                area?.Hectares ||
  	                area?.hectares ||
  	                area?.Ha ||
  	                area?.ha ||
  	                area?.HA ||
  	                null
  	              );
  	
  	              if (hectares !== null) return hectares;
  	
  	              const m2 = normalizeCardNumber(
  	                area?.m2 ||
  	                area?.M2 ||
  	                area?.SquareMeters ||
  	                area?.squareMeters ||
  	                null
  	              );
  	
  	              if (m2 !== null) return m2 / 10000;
  	
  	              return null;
  	            }
  	
  	            function getCardPolygonRing(location) {
  	              try {
  	                const poly =
  	                location?.Polygon ||
  	                location?.polygon ||
  	                location?.Boundary ||
  	                location?.boundary ||
  	                null;
  	
  	                if (!poly) return null;
  	
  	                let ring = null;
  	
  	                if (Array.isArray(poly.coordinates) && Array.isArray(poly.coordinates[0])) {
  	                  ring = poly.coordinates[0];
  	                } else if (Array.isArray(poly.Coordinates) && Array.isArray(poly.Coordinates[0])) {
  	                  ring = poly.Coordinates[0];
  	                }
  	
  	                if (!Array.isArray(ring) || ring.length < 3) return null;
  	
  	                const out = ring
  	                .map(point => {
  	                  if (!Array.isArray(point) || point.length < 2) return null;
  	
  	                  const lng = normalizeCardNumber(point[0]);
  	                  const lat = normalizeCardNumber(point[1]);
  	
  	                  if (lat === null || lng === null) return null;
  	
  	                  return [lng,
  	                    lat];
  	                })
  	                .filter(Boolean);
  	
  	                return out.length >= 3 ? out: null;
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function getCardComputedAreaHa(location) {
  	              try {
  	                const ring = getCardPolygonRing(location);
  	
  	                if (!ring || ring.length < 3) return null;
  	
  	                const closed = ring.slice();
  	                const first = closed[0];
  	                const last = closed[closed.length - 1];
  	
  	                if (first[0] !== last[0] || first[1] !== last[1]) {
  	                  closed.push([first[0], first[1]]);
  	                }
  	
  	                const radius = 6378137;
  	                const toRad = value => value * Math.PI / 180;
  	
  	                let total = 0;
  	
  	                for (let i = 0; i < closed.length - 1; i++) {
  	                  const lng1 = closed[i][0];
  	                  const lat1 = closed[i][1];
  	                  const lng2 = closed[i + 1][0];
  	                  const lat2 = closed[i + 1][1];
  	
  	                  const phi1 = toRad(lat1);
  	                  const phi2 = toRad(lat2);
  	                  const lambda1 = toRad(lng1);
  	                  const lambda2 = toRad(lng2);
  	                  const deltaLambda = lambda2 - lambda1;
  	
  	                  const t = Math.tan(phi2 / 2 + Math.PI / 4);
  	                  const b = Math.tan(phi1 / 2 + Math.PI / 4);
  	
  	                  total += Math.atan2(
  	                    Math.sin(deltaLambda) * b * t,
  	                    1 + b * t * Math.cos(deltaLambda)
  	                  );
  	                }
  	
  	                const m2 = Math.abs(total * 2 * radius * radius);
  	
  	                return m2 / 10000;
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function getCardAreaHa(location) {
  	              const stored = getCardStoredAreaHa(location);
  	
  	              if (stored !== null) return stored;
  	
  	              const computed = getCardComputedAreaHa(location);
  	
  	              if (computed !== null) return computed;
  	
  	              return null;
  	            }
  	
  	            function formatCardAreaHa(value) {
  	              const number = normalizeCardNumber(value);
  	
  	              if (number === null) return "—";
  	
  	              return number.toFixed(2);
  	            }
  	
  	            function getCardRingPoint(point) {
  	              if (!point) return null;
  	
  	              let lat = null;
  	              let lng = null;
  	
  	              if (Array.isArray(point)) {
  	                lng = normalizeCardNumber(point[0]);
  	                lat = normalizeCardNumber(point[1]);
  	              } else if (typeof point === "object") {
  	                lat = normalizeCardNumber(
  	                  point.lat ??
  	                  point.latitude ??
  	                  point.Latitude ??
  	                  point.y ??
  	                  point.Y
  	                );
  	
  	                lng = normalizeCardNumber(
  	                  point.lng ??
  	                  point.lon ??
  	                  point.longitude ??
  	                  point.Longitude ??
  	                  point.x ??
  	                  point.X
  	                );
  	              }
  	
  	              if (lat === null || lng === null) return null;
  	
  	              return [lng,
  	                lat];
  	            }
  	
  	            function isCardCoordinateRing(value) {
  	              if (!Array.isArray(value) || value.length < 3) return false;
  	
  	              let validCount = 0;
  	
  	              value.forEach(point => {
  	                if (getCardRingPoint(point)) {
  	                  validCount++;
  	                }
  	              });
  	
  	              return validCount >= 3;
  	            }
  	
  	            function normalizeCardCoordinateRing(ring) {
  	              if (!isCardCoordinateRing(ring)) return null;
  	
  	              const out = ring
  	              .map(getCardRingPoint)
  	              .filter(Boolean);
  	
  	              return out.length >= 3 ? out: null;
  	            }
  	
  	            function getCardPolygonObject(location) {
  	              return (
  	                location?.Polygon ||
  	                location?.polygon ||
  	                location?.Boundary ||
  	                location?.boundary ||
  	                null
  	              );
  	            }
  	
  	            function getCardOuterRingForPerimeter(location) {
  	              const direct = getCardPolygonRing(location);
  	
  	              if (direct && direct.length >= 3) return direct;
  	
  	              const poly = getCardPolygonObject(location);
  	
  	              if (!poly) return null;
  	
  	              const coords =
  	              poly.coordinates ||
  	              poly.Coordinates ||
  	              null;
  	
  	              if (Array.isArray(coords)) {
  	                if (isCardCoordinateRing(coords)) {
  	                  return normalizeCardCoordinateRing(coords);
  	                }
  	
  	                if (Array.isArray(coords[0])) {
  	                  const first = normalizeCardCoordinateRing(coords[0]);
  	
  	                  if (first) return first;
  	                }
  	              }
  	
  	              return (
  	                normalizeCardCoordinateRing(poly.boundary?.points) ||
  	                normalizeCardCoordinateRing(poly.Boundary?.points) ||
  	                normalizeCardCoordinateRing(poly.points) ||
  	                normalizeCardCoordinateRing(poly.Points) ||
  	                null
  	              );
  	            }
  	
  	            function getCardExplicitHoleRings(location) {
  	              const data = getLocationData(location);
  	              const shape =
  	              data?.Shape ||
  	              data?.shape ||
  	              location?.LocationData?.Shape ||
  	              location?.LocationData?.shape ||
  	              location?.locationData?.Shape ||
  	              location?.locationData?.shape ||
  	              null;
  	
  	              const poly = getCardPolygonObject(location);
  	              const geometry =
  	              data?.Geometry ||
  	              data?.geometry ||
  	              location?.LocationData?.Geometry ||
  	              location?.LocationData?.geometry ||
  	              location?.locationData?.Geometry ||
  	              location?.locationData?.geometry ||
  	              null;
  	              const rings = [];
  	              const seen = Object.create(null);
  	
  	              function addRing(ring) {
  	                const normalized = normalizeCardCoordinateRing(ring);
  	
  	                if (!normalized || normalized.length < 3) return;
  	
  	                const key = normalized
  	                .map(point => {
  	                  return `${Number(point[0]).toFixed(7)},${Number(point[1]).toFixed(7)}`;
  	                })
  	                .join("|");
  	
  	                if (seen[key]) return;
  	
  	                seen[key] = true;
  	                rings.push(normalized);
  	              }
  	
  	              function addHoleList(value) {
  	                if (!value) return;
  	
  	                if (isCardCoordinateRing(value)) {
  	                  addRing(value);
  	                  return;
  	                }
  	
  	                if (Array.isArray(value)) {
  	                  value.forEach(item => addRing(item));
  	                }
  	              }
  	
  	              function addPolygonCoordinateHoles(value) {
  	                if (!Array.isArray(value)) return;
  	
  	                // GeoJSON Polygon coordinates:
  	                // [ outerRing, holeRing1, holeRing2, ... ]
  	                // Only indexes after 0 are actual holes.
  	                if (Array.isArray(value[0]) && value.length > 1) {
  	                  value.slice(1).forEach(ring => addRing(ring));
  	                }
  	              }
  	
  	              addPolygonCoordinateHoles(poly?.coordinates);
  	              addPolygonCoordinateHoles(poly?.Coordinates);
  	
  	              addHoleList(poly?.HoleRings);
  	              addHoleList(poly?.holeRings);
  	              addHoleList(poly?.Holes);
  	              addHoleList(poly?.holes);
  	              addHoleList(poly?.InnerRings);
  	              addHoleList(poly?.innerRings);
  	
  	              addHoleList(location?.HoleRings);
  	              addHoleList(location?.holeRings);
  	              addHoleList(location?.Holes);
  	              addHoleList(location?.holes);
  	
  	              addHoleList(data?.HoleRings);
  	              addHoleList(data?.holeRings);
  	              addHoleList(data?.Holes);
  	              addHoleList(data?.holes);
  	
  	              addHoleList(shape?.HoleRings);
  	              addHoleList(shape?.holeRings);
  	              addHoleList(shape?.Holes);
  	              addHoleList(shape?.holes);
  	              addHoleList(shape?.InnerRings);
  	              addHoleList(shape?.innerRings);
  	
  	              // The save channel stores resolved sibling/parent cut-outs here.
  	              // Backendless GIS fields can return only the exterior ring after reload,
  	              // so this JSON channel must also be authoritative for segmentation.
  	              addHoleList(geometry?.holeRings);
  	              addHoleList(geometry?.HoleRings);
  	              addHoleList(geometry?.holes);
  	              addHoleList(geometry?.Holes);
  	              addHoleList(geometry?.innerRings);
  	              addHoleList(geometry?.InnerRings);
  	
  	              const holeLocations =
  	              geometry?.holeLocations ||
  	              geometry?.HoleLocations ||
  	              [];
  	
  	              if (Array.isArray(holeLocations)) {
  	                holeLocations.forEach(hole => {
  	                  addRing(
  	                    hole?.points ||
  	                    hole?.Points ||
  	                    hole?.boundary ||
  	                    hole?.Boundary ||
  	                    hole?.ring ||
  	                    hole?.Ring
  	                  );
  	                });
  	              }
  	
  	              return rings;
  	            }
  	
  	            function getCardPointDistanceMeters(a, b) {
  	              if (!a || !b) return 0;
  	
  	              const lng1 = normalizeCardNumber(a[0]);
  	              const lat1 = normalizeCardNumber(a[1]);
  	              const lng2 = normalizeCardNumber(b[0]);
  	              const lat2 = normalizeCardNumber(b[1]);
  	
  	              if (lat1 === null || lng1 === null || lat2 === null || lng2 === null) {
  	                return 0;
  	              }
  	
  	              const radius = 6371008.8;
  	              const toRad = value => value * Math.PI / 180;
  	
  	              const phi1 = toRad(lat1);
  	              const phi2 = toRad(lat2);
  	              const deltaPhi = toRad(lat2 - lat1);
  	              const deltaLambda = toRad(lng2 - lng1);
  	
  	              const h =
  	              Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
  	              Math.cos(phi1) * Math.cos(phi2) *
  	              Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
  	
  	              return 2 * radius * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  	            }
  	
  	            function getCardRingPerimeterMeters(ring) {
  	              const normalized = normalizeCardCoordinateRing(ring);
  	
  	              if (!normalized || normalized.length < 3) return null;
  	
  	              const closed = normalized.slice();
  	              const first = closed[0];
  	              const last = closed[closed.length - 1];
  	
  	              if (first[0] !== last[0] || first[1] !== last[1]) {
  	                closed.push([first[0], first[1]]);
  	              }
  	
  	              let total = 0;
  	
  	              for (let i = 0; i < closed.length - 1; i++) {
  	                total += getCardPointDistanceMeters(closed[i], closed[i + 1]);
  	              }
  	
  	              return Number.isFinite(total) ? total: null;
  	            }
  	
  	            function getCardPerimeterMeters(location) {
  	              const ring = getCardOuterRingForPerimeter(location);
  	
  	              if (!ring || ring.length < 3) return null;
  	
  	              return getCardRingPerimeterMeters(ring);
  	            }
  	
  	            function getCardHolePerimeterMeters(location) {
  	              const holeRings = getCardExplicitHoleRings(location);
  	
  	              if (!holeRings.length) return null;
  	
  	              let total = 0;
  	
  	              holeRings.forEach(ring => {
  	                const perimeter = getCardRingPerimeterMeters(ring);
  	
  	                if (Number.isFinite(perimeter)) {
  	                  total += perimeter;
  	                }
  	              });
  	
  	              return Number.isFinite(total) ? total: null;
  	            }
  	
  	            function formatCardPerimeterMeters(value) {
  	              const meters = normalizeCardNumber(value);
  	
  	              if (meters === null) return "—";
  	
  	              if (meters >= 1000) {
  	                return `${(meters / 1000).toFixed(2)} km`;
  	              }
  	
  	              return `${meters.toFixed(0)} m`;
  	            }
  	
  	            function cardInfoRow(label, value) {
  	              return `
  	              <div class="trackit-card-info-row">
  	              <div class="trackit-card-info-key">${escapeHtml(label)}</div>
  	              <div class="trackit-card-info-value" title="${escapeHtml(value)}">${escapeHtml(value || "—")}</div>
  	              </div>
  	              `;
  	            }
  	
  	            function buildCardChildrenList(rowData) {
  	              const savedChildren = Array.isArray(rowData?.childrenNodes)
  	              ? rowData.childrenNodes: [];
  	
  	              const temporarySegments = getCardTemporarySegmentRows(rowData);
  	              const children = [
  	                ...savedChildren,
  	                ...temporarySegments
  	              ];
  	
  	              actionCard.__childRows = children;
  	
  	              if (!children.length) {
  	                return `
  	                <div class="trackit-card-children-block">
  	                <div class="trackit-card-section-title">Sub-Locations</div>
  	
  	                <div class="trackit-card-empty-children">
  	                Click Add Location to add Sub-Location
  	                </div>
  	                </div>
  	                `;
  	              }
  	
  	              return `
  	              <div class="trackit-card-children-block">
  	              <div class="trackit-card-section-title">Sub-Locations</div>
  	
  	              <div class="trackit-card-child-list">
  	              ${children.map((child, index) => {
  	                const isTemporarySegment = child.__trackitTemporarySegment === true;
  	                const childType = isTemporarySegment ? "Temporary Segment": getCardType(child.location, child);
  	                const childLabel = child.label || getLocationLabel(child.location);
  	                const childCount = isTemporarySegment
  	                ? "T": Array.isArray(child.childrenNodes)
  	                ? child.childrenNodes.length: 0;
  	
  	                return `
  	                <button class="trackit-card-child-row ${isTemporarySegment ? "is-temporary": ""}" type="button" data-card-child-index="${index}">
  	                <div class="trackit-card-child-main">
  	                <div class="trackit-card-child-name">${escapeHtml(childLabel)}</div>
  	                <div class="trackit-card-child-type">${escapeHtml(childType || "Location")}</div>
  	                </div>
  	
  	                <div class="trackit-card-child-count">${escapeHtml(childCount)}</div>
  	                </button>
  	                `;
  	              }).join("")}
  	              </div>
  	              </div>
  	              `;
  	            }
  	
  	            function getCardFunctionality(location) {
  	              const data = getLocationData(location);
  	
  	              return (
  	                data?.Functionality ||
  	                data?.functionality ||
  	                location?.Functionality ||
  	                location?.functionality ||
  	                {}
  	              );
  	            }
  	
  	            function isEventsCaptureEnabled(location) {
  	              const functionality = getCardFunctionality(location);
  	
  	              return (
  	                functionality?.EventsCapture === true ||
  	                functionality?.eventsCapture === true ||
  	                functionality?.Events === true ||
  	                functionality?.events === true
  	              );
  	            }
  	
  	            function buildCardEventsBlock(location) {
  	              if (!isEventsCaptureEnabled(location)) return "";
  	
  	              return `
  	              <div class="trackit-card-events-block">
  	              <div class="trackit-card-section-title">Events</div>
  	
  	              <div class="trackit-card-events-actions">
  	              <button class="trackit-card-event-button" type="button" data-card-action="viewEvents">
  	              View Events
  	              </button>
  	
  	              <button class="trackit-card-event-button primary" type="button" data-card-action="captureEvent">
  	              Capture Event
  	              </button>
  	              </div>
  	              </div>
  	              `;
  	            }
  	
  	            function buildCardSegmentationBlock(rowData) {
  	              if (!isCardSegmentableLocation(rowData)) return "";
  	
  	              const segments = getCardSegmentationSegments(rowData);
  	              const currentCount = segments.length;
  	              const suggestedCount = currentCount || 10;
  	              const isDirty = isCardSegmentationDirty(rowData);
  	              const isVisible = areCardSegmentsVisible(rowData);
  	
  	              return `
  	              <div class="trackit-card-segmentation-block">
  	              <div class="trackit-card-section-title">Segments</div>
  	
  	              <div class="trackit-card-segmentation-row">
  	              <input
  	              class="trackit-card-segment-count-input"
  	              type="number"
  	              min="1"
  	              max="180"
  	              step="1"
  	              value="${escapeHtml(suggestedCount)}"
  	              data-card-segment-count
  	              />
  	
  	              <button class="trackit-card-event-button primary" type="button" data-card-action="generateSegments">
  	              Segment
  	              </button>
  	              </div>
  	
  	              ${currentCount ? `
  	              <button class="trackit-card-event-button" type="button" data-card-action="toggleSegments">
  	              ${isVisible ? "Hide Segments": "View Segments"}
  	              </button>
  	
  	              ${isDirty ? `
  	              <button class="trackit-card-event-button primary" type="button" data-card-action="saveSegments">
  	              Save Segments
  	              </button>
  	              `: ""}
  	
  	              <button class="trackit-card-event-button subtle" type="button" data-card-action="clearSegments">
  	              Clear Temporary Segments
  	              </button>
  	              `: ""}
  	
  	              <div data-card-segment-detail-host>
  	              ${buildCardSegmentDetailBlock(rowData)}
  	              </div>
  	              </div>
  	              `;
  	            }
  	
  	            function cardSegmentCleanPoint(point) {
  	              if (!point) return null;
  	
  	              if (Array.isArray(point.coordinates) && point.coordinates.length >= 2) {
  	                const lng = Number(point.coordinates[0]);
  	                const lat = Number(point.coordinates[1]);
  	
  	                if (Number.isFinite(lat) && Number.isFinite(lng)) {
  	                  return {
  	                    lat,
  	                    lng
  	                  };
  	                }
  	              }
  	
  	              const lat = Number(point.lat ?? point.latitude ?? point.y);
  	              const lng = Number(point.lng ?? point.longitude ?? point.x);
  	
  	              if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  	
  	              return {
  	                lat,
  	                lng
  	              };
  	            }
  	
  	            function cardSegmentRoundPoint(point) {
  	              const clean = cardSegmentCleanPoint(point);
  	
  	              if (!clean) return null;
  	
  	              return {
  	                lat: Number(clean.lat.toFixed(8)),
  	                lng: Number(clean.lng.toFixed(8))
  	              };
  	            }
  	
  	            function cardSegmentBearingDegrees(fromPoint, toPoint) {
  	              const from = cardSegmentCleanPoint(fromPoint);
  	              const to = cardSegmentCleanPoint(toPoint);
  	
  	              if (!from || !to) return 0;
  	
  	              try {
  	                if (
  	                  typeof google !== "undefined" &&
  	                  google?.maps?.geometry?.spherical?.computeHeading
  	                ) {
  	                  return (
  	                    google.maps.geometry.spherical.computeHeading(
  	                      new google.maps.LatLng(from.lat, from.lng),
  	                      new google.maps.LatLng(to.lat, to.lng)
  	                    ) + 360
  	                  ) % 360;
  	                }
  	              } catch (_) {}
  	
  	              const toRad = value => value * Math.PI / 180;
  	              const toDeg = value => value * 180 / Math.PI;
  	
  	              const phi1 = toRad(from.lat);
  	              const phi2 = toRad(to.lat);
  	              const lambda1 = toRad(from.lng);
  	              const lambda2 = toRad(to.lng);
  	
  	              const y = Math.sin(lambda2 - lambda1) * Math.cos(phi2);
  	              const x =
  	              Math.cos(phi1) * Math.sin(phi2) -
  	              Math.sin(phi1) * Math.cos(phi2) * Math.cos(lambda2 - lambda1);
  	
  	              return (toDeg(Math.atan2(y, x)) + 360) % 360;
  	            }
  	
  	            function cardSegmentDistanceMeters(a, b) {
  	              const p1 = cardSegmentCleanPoint(a);
  	              const p2 = cardSegmentCleanPoint(b);
  	
  	              if (!p1 || !p2) return 0;
  	
  	              try {
  	                if (
  	                  typeof google !== "undefined" &&
  	                  google?.maps?.geometry?.spherical?.computeDistanceBetween
  	                ) {
  	                  return google.maps.geometry.spherical.computeDistanceBetween(
  	                    new google.maps.LatLng(p1.lat, p1.lng),
  	                    new google.maps.LatLng(p2.lat, p2.lng)
  	                  );
  	                }
  	              } catch (_) {}
  	
  	              const radius = 6371008.8;
  	              const toRad = value => value * Math.PI / 180;
  	
  	              const phi1 = toRad(p1.lat);
  	              const phi2 = toRad(p2.lat);
  	              const deltaPhi = toRad(p2.lat - p1.lat);
  	              const deltaLambda = toRad(p2.lng - p1.lng);
  	
  	              const h =
  	              Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
  	              Math.cos(phi1) * Math.cos(phi2) *
  	              Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
  	
  	              return 2 * radius * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  	            }
  	
  	            function cardSegmentDestinationPoint(centerPoint, distanceMeters, bearingDegrees) {
  	              const center = cardSegmentCleanPoint(centerPoint);
  	
  	              if (!center || !Number.isFinite(Number(distanceMeters))) return null;
  	
  	              try {
  	                if (
  	                  typeof google !== "undefined" &&
  	                  google?.maps?.geometry?.spherical?.computeOffset
  	                ) {
  	                  const latLng = google.maps.geometry.spherical.computeOffset(
  	                    new google.maps.LatLng(center.lat, center.lng),
  	                    Number(distanceMeters),
  	                    Number(bearingDegrees)
  	                  );
  	
  	                  return {
  	                    lat: latLng.lat(),
  	                    lng: latLng.lng()
  	                  };
  	                }
  	              } catch (_) {}
  	
  	              const radius = 6371008.8;
  	              const delta = Number(distanceMeters) / radius;
  	              const theta = Number(bearingDegrees) * Math.PI / 180;
  	
  	              const phi1 = center.lat * Math.PI / 180;
  	              const lambda1 = center.lng * Math.PI / 180;
  	
  	              const sinPhi2 =
  	              Math.sin(phi1) * Math.cos(delta) +
  	              Math.cos(phi1) * Math.sin(delta) * Math.cos(theta);
  	
  	              const phi2 = Math.asin(sinPhi2);
  	
  	              const y = Math.sin(theta) * Math.sin(delta) * Math.cos(phi1);
  	              const x = Math.cos(delta) - Math.sin(phi1) * Math.sin(phi2);
  	
  	              const lambda2 = lambda1 + Math.atan2(y, x);
  	
  	              return {
  	                lat: phi2 * 180 / Math.PI,
  	                lng: ((lambda2 * 180 / Math.PI + 540) % 360) - 180
  	              };
  	            }
  	
  	            function cardSegmentClockwiseDelta(startBearing, endBearing) {
  	              return (Number(endBearing) - Number(startBearing) + 360) % 360;
  	            }
  	
  	            function getCardGeneratedShapeKind(rowData) {
  	              const location = rowData?.location || null;
  	              const data = getLocationData(location);
  	              const shape = data?.Shape || data?.shape || {};
  	
  	              function hasType(value, typeName) {
  	                return safeString(value).trim().toLowerCase().includes(typeName);
  	              }
  	
  	              // CreationType must win over display Type / LocationType.
  	              // A location can have Type = "Pivot" as a user location type,
  	              // while CreationType = "Wedge" as the actual generated geometry.
  	              const explicitTypeCandidates = [
  	                location?.CreationType,
  	                location?.creationType,
  	                location?.creation_type,
  	                location?.CreationMode,
  	                location?.creationMode,
  	
  	                data?.CreationType,
  	                data?.creationType,
  	                data?.creation_type,
  	                data?.CreationMode,
  	                data?.creationMode,
  	
  	                data?.ShapeKind,
  	                data?.shapeKind,
  	                data?.GeneratedShapeKind,
  	                data?.generatedShapeKind
  	              ];
  	
  	              if (explicitTypeCandidates.some(value => hasType(value, "segment"))) return "wedge";
  	              if (explicitTypeCandidates.some(value => hasType(value, "wedge"))) return "wedge";
  	              if (explicitTypeCandidates.some(value => hasType(value, "ring"))) return "ring";
  	              if (explicitTypeCandidates.some(value => hasType(value, "pivot"))) return "pivot";
  	
  	              // Geometry fallback. If wedge geometry exists, it is a wedge,
  	              // even if the display type says Pivot.
  	              const hasWedgeGeometry = !!(
  	                cardSegmentCleanPoint(shape.WedgeCenter || shape.wedgeCenter || location?.WedgeCenter || location?.wedgeCenter) &&
  	                cardSegmentCleanPoint(shape.WedgeRadiusPoint || shape.wedgeRadiusPoint || location?.WedgeRadiusPoint || location?.wedgeRadiusPoint) &&
  	                cardSegmentCleanPoint(shape.WedgeEdgePoint || shape.wedgeEdgePoint || location?.WedgeEdgePoint || location?.wedgeEdgePoint)
  	              );
  	
  	              if (hasWedgeGeometry) return "wedge";
  	
  	              const hasPivotGeometry = !!(
  	                cardSegmentCleanPoint(shape.PivotCenter || shape.pivotCenter || location?.PivotCenter || location?.pivotCenter) &&
  	                cardSegmentCleanPoint(shape.PivotRadiusPoint || shape.pivotRadiusPoint || location?.PivotRadiusPoint || location?.pivotRadiusPoint)
  	              );
  	
  	              if (hasPivotGeometry) return "pivot";
  	
  	              // Last fallback only. This should not override real generated geometry.
  	              const displayTypeCandidates = [
  	                location?.Type,
  	                location?.type,
  	                location?.LocationType,
  	                location?.locationType,
  	                data?.Type,
  	                data?.type,
  	                data?.LocationType,
  	                data?.locationType,
  	                rowData?.type
  	              ];
  	
  	              const combinedDisplayType = safeString(
  	                displayTypeCandidates.filter(Boolean).join(" ")
  	              ).toLowerCase();
  	
  	              if (combinedDisplayType.includes("segment")) return "wedge";
  	              if (combinedDisplayType.includes("wedge")) return "wedge";
  	              if (combinedDisplayType.includes("ring")) return "ring";
  	              if (combinedDisplayType.includes("pivot")) return "pivot";
  	
  	              return "";
  	            }
  	
  	            function isCardSegmentableLocation(rowData) {
  	              const kind = getCardGeneratedShapeKind(rowData);
  	
  	              return kind === "pivot" || kind === "ring" || kind === "wedge";
  	            }
  	
  	            function getCardSegmentationSegments(rowData) {
  	              const location = rowData?.location || null;
  	              const data = getLocationData(location);
  	              const segmentation = data?.Segmentation || data?.segmentation || null;
  	              const segments = segmentation?.Segments || segmentation?.segments || [];
  	
  	              return Array.isArray(segments) ? segments: [];
  	            }
  	
  	            function getCardSegmentationRecord(rowData) {
  	              const location = rowData?.location || null;
  	              const data = getLocationData(location);
  	
  	              return data?.Segmentation || data?.segmentation || null;
  	            }
  	
  	            function isCardSegmentationDirty(rowData) {
  	              const segmentation = getCardSegmentationRecord(rowData);
  	              const segments = getCardSegmentationSegments(rowData);
  	
  	              if (!segmentation || !segments.length) return false;
  	
  	              if (segmentation.IsSaved === false) return true;
  	              if (segmentation.isSaved === false) return true;
  	
  	              if (!segmentation.SavedAt && !segmentation.savedAt) {
  	                return true;
  	              }
  	
  	              return false;
  	            }
  	
  	            function getCardSegmentationVisibilityKey(rowData) {
  	              const id =
  	              getCardLocationIdForRefresh(rowData?.location) ||
  	              safeString(rowData?.value).trim() ||
  	              "selected";
  	
  	              return `segments-visible:${id}`;
  	            }
  	
  	            function getCardSegmentationVisibilityStore() {
  	              if (typeof window === "undefined") return {};
  	
  	              if (!window.__TrackITSegmentationVisibilityByLocation) {
  	                window.__TrackITSegmentationVisibilityByLocation = {};
  	              }
  	
  	              return window.__TrackITSegmentationVisibilityByLocation;
  	            }
  	
  	            function areCardSegmentsVisible(rowData) {
  	              const store = getCardSegmentationVisibilityStore();
  	              const key = getCardSegmentationVisibilityKey(rowData);
  	
  	              if (store[key] === false) return false;
  	
  	              return true;
  	            }
  	
  	            function setCardSegmentsVisible(rowData, visible) {
  	              const store = getCardSegmentationVisibilityStore();
  	              const key = getCardSegmentationVisibilityKey(rowData);
  	
  	              store[key] = visible === true;
  	            }
  	
  	            function toggleCardSegmentsVisible(rowData) {
  	              const nextVisible = !areCardSegmentsVisible(rowData);
  	
  	              setCardSegmentsVisible(rowData, nextVisible);
  	
  	              if (nextVisible) {
  	                renderCardTemporarySegmentsOnMap(rowData);
  	              } else {
  	                clearCardTemporarySegmentPolygons();
  	              }
  	
  	              openLocationActionCard(rowData);
  	            }
  	
  	            function formatCardSegmentCoordinate(point) {
  	              const clean = cardSegmentCleanPoint(point);
  	
  	              if (!clean) return "—";
  	
  	              return `${Number(clean.lat).toFixed(4)}, ${Number(clean.lng).toFixed(4)}`;
  	            }
  	
  	            function formatCardSegmentMeters(value) {
  	              const number = Number(value);
  	
  	              if (!Number.isFinite(number)) return "—";
  	
  	              if (number >= 1000) {
  	                return `${(number / 1000).toFixed(3)} km`;
  	              }
  	
  	              return `${number.toFixed(2)} m`;
  	            }
  	
  	            function formatCardSegmentAreaHa(value) {
  	              const number = Number(value);
  	
  	              if (!Number.isFinite(number)) return "—";
  	
  	              return `${number.toFixed(4)} ha`;
  	            }
  	
  	            function formatCardSegmentAreaM2(value) {
  	              const number = Number(value);
  	
  	              if (!Number.isFinite(number)) return "—";
  	
  	              return `${number.toFixed(2)} m²`;
  	            }
  	
  	            function getSelectedCardTemporarySegment(rowData) {
  	              const segments = getCardSegmentationSegments(rowData);
  	              const selectedNumber = Number(actionCard.__selectedTemporarySegmentNumber || 0);
  	
  	              if (!selectedNumber) return null;
  	
  	              return segments.find(segment => {
  	                return Number(segment.SegmentNumber || segment.segmentNumber || 0) === selectedNumber;
  	              }) || null;
  	            }
  	
  	            function buildCardSegmentDetailBlock(rowData) {
  	              const segment = getSelectedCardTemporarySegment(rowData);
  	
  	              if (!segment) return "";
  	
  	              const segmentNumber = Number(segment.SegmentNumber || segment.segmentNumber || 0) || "";
  	              const name = safeString(segment.Name || segment.name || `Segment ${segmentNumber}`).trim();
  	
  	              const center = segment.Center || segment.center || segment.Coordinates?.Center || null;
  	              const startArc = segment.StartArc || segment.startArc || segment.Coordinates?.StartArc || null;
  	              const endArc = segment.EndArc || segment.endArc || segment.Coordinates?.EndArc || null;
  	
  	              const areaHa = Number(segment.AreaHa ?? segment.areaHa);
  	              const areaM2 = Number(segment.AreaM2 ?? segment.areaM2);
  	              const arcDistance = Number(segment.ArcDistanceMeters ?? segment.arcDistanceMeters);
  	
  	              return `
  	              <div class="trackit-card-segment-detail">
  	              <div class="trackit-card-segment-detail-title">
  	              ${escapeHtml(name || "Segment")}
  	              </div>
  	
  	              <div class="trackit-card-segment-detail-grid">
  	              <div class="trackit-card-segment-detail-row">
  	              <div class="trackit-card-segment-detail-key">Area</div>
  	              <div class="trackit-card-segment-detail-value">
  	              ${escapeHtml(formatCardSegmentAreaHa(areaHa))} / ${escapeHtml(formatCardSegmentAreaM2(areaM2))}
  	              </div>
  	              </div>
  	
  	              <div class="trackit-card-segment-detail-row">
  	              <div class="trackit-card-segment-detail-key">Arc</div>
  	              <div class="trackit-card-segment-detail-value">
  	              ${escapeHtml(formatCardSegmentMeters(arcDistance))}
  	              </div>
  	              </div>
  	
  	              <div class="trackit-card-segment-detail-row">
  	              <div class="trackit-card-segment-detail-key">Center</div>
  	              <div class="trackit-card-segment-detail-value mono">
  	              ${escapeHtml(formatCardSegmentCoordinate(center))}
  	              </div>
  	              </div>
  	
  	              <div class="trackit-card-segment-detail-row">
  	              <div class="trackit-card-segment-detail-key">Start Arc</div>
  	              <div class="trackit-card-segment-detail-value mono">
  	              ${escapeHtml(formatCardSegmentCoordinate(startArc))}
  	              </div>
  	              </div>
  	
  	              <div class="trackit-card-segment-detail-row">
  	              <div class="trackit-card-segment-detail-key">End Arc</div>
  	              <div class="trackit-card-segment-detail-value mono">
  	              ${escapeHtml(formatCardSegmentCoordinate(endArc))}
  	              </div>
  	              </div>
  	              </div>
  	              </div>
  	              `;
  	            }
  	
  	            function showCardTemporarySegmentDetails(rowData, childRow) {
  	              if (!childRow || !childRow.__trackitTemporarySegment) return;
  	
  	              const segment = childRow.__trackitSegmentData || null;
  	              const number = Number(segment?.SegmentNumber || segment?.segmentNumber || 0);
  	
  	              if (!number) return;
  	
  	              actionCard.__selectedTemporarySegmentNumber = number;
  	
  	              const host = actionCard.querySelector("[data-card-segment-detail-host]");
  	
  	              if (host) {
  	                host.innerHTML = buildCardSegmentDetailBlock(rowData);
  	              }
  	
  	              try {
  	                notifyCarvedShellLayout();
  	              } catch (_) {}
  	
  	              try {
  	                bridge?.resizeTopShell?.();
  	              } catch (_) {}
  	            }
  	
  	            function getCardTemporarySegmentRows(rowData) {
  	              const parentId = getCardLocationIdForRefresh(rowData?.location) || safeString(rowData?.value).trim();
  	              const segments = getCardSegmentationSegments(rowData);
  	
  	              return segments.map(segment => {
  	                const number = Number(segment.SegmentNumber || segment.segmentNumber || 0) || 0;
  	                const name = safeString(segment.Name || segment.name || `Segment ${number || ""}`).trim();
  	
  	                return {
  	                  __trackitTemporarySegment: true,
  	                  __trackitSegmentParentId: parentId,
  	                  __trackitSegmentKey: `${parentId}::segment::${number || name}`,
  	                  __trackitSegmentData: segment,
  	                  value: `${parentId}::temporary-segment::${number || name}`,
  	                  label: name || "Temporary Segment",
  	                  type: "Temporary Segment",
  	                  location: {
  	                    Name: name || "Temporary Segment",
  	                    Type: "Temporary Segment",
  	                    LocationType: "Temporary Segment",
  	                    ParentLocationId: parentId,
  	                    LocationData: {
  	                      TemporarySegment: true,
  	                      Segment: segment
  	                    }
  	                  },
  	                  childrenNodes: []
  	                };
  	              });
  	            }
  	
  	            function getCardSegmentationBase(rowData) {
  	              const location = rowData?.location || null;
  	              const data = getLocationData(location);
  	              const shape = data?.Shape || data?.shape || {};
  	              const area = data?.Area || data?.area || {};
  	              const kind = getCardGeneratedShapeKind(rowData);
  	
  	              const center = cardSegmentCleanPoint(
  	                kind === "wedge"
  	                ? shape.WedgeCenter || shape.wedgeCenter || shape.ChildFixedCenter || shape.childFixedCenter || area.Center || area.center: shape.PivotCenter || shape.pivotCenter || shape.ChildFixedCenter || shape.childFixedCenter || area.Center || area.center
  	              );
  	
  	              const radiusPoint = cardSegmentCleanPoint(
  	                kind === "wedge"
  	                ? shape.WedgeRadiusPoint || shape.wedgeRadiusPoint || shape.ChildRadiusPoint || shape.childRadiusPoint: shape.PivotRadiusPoint || shape.pivotRadiusPoint || shape.ChildRadiusPoint || shape.childRadiusPoint
  	              );
  	
  	              const edgePoint = cardSegmentCleanPoint(
  	                shape.WedgeEdgePoint ||
  	                shape.wedgeEdgePoint ||
  	                shape.ChildEdgePoint ||
  	                shape.childEdgePoint
  	              );
  	
  	              const entrancePoint = cardSegmentCleanPoint(
  	                getLocationEntrancePoint(location) ||
  	                shape.EntrancePoint ||
  	                shape.entrancePoint ||
  	                data.EntrancePoint ||
  	                data.entrancePoint ||
  	                radiusPoint
  	              );
  	
  	              const storedRadius = Number(
  	                kind === "wedge"
  	                ? shape.WedgeRadiusMeters || shape.wedgeRadiusMeters || shape.ChildRadiusMeters || shape.childRadiusMeters: shape.PivotRadiusMeters || shape.pivotRadiusMeters || shape.ChildRadiusMeters || shape.childRadiusMeters
  	              );
  	
  	              const radiusMeters = Number.isFinite(storedRadius) && storedRadius > 0
  	              ? storedRadius: cardSegmentDistanceMeters(center, radiusPoint);
  	
  	              return {
  	                kind,
  	                center,
  	                radiusPoint,
  	                edgePoint,
  	                entrancePoint,
  	                radiusMeters
  	              };
  	            }
  	
  	            // Temporary segmentation is area-first. Angles and arc lengths are
  	            // measurements of the result; they are never used as a proxy for area.
  	            // All clipping is performed against the saved, resolved parent boundary,
  	            // so an irregular Pivot/Wedge and its holes remain authoritative.
  	            function cardSegmentBuildLocalGeometry(location, centerPoint) {
  	              const center = cardSegmentCleanPoint(centerPoint);
  	              const outerLngLat = getCardOuterRingForPerimeter(location);
  	
  	              if (!center || !Array.isArray(outerLngLat) || outerLngLat.length < 3) {
  	                return null;
  	              }
  	
  	              const earthRadius = 6371008.8;
  	              const centerLatRad = Number(center.lat) * Math.PI / 180;
  	              const cosLat = Math.max(0.000001, Math.cos(centerLatRad));
  	
  	              function toLocal(point) {
  	                const clean = cardSegmentCleanPoint(
  	                  Array.isArray(point)
  	                  ? { lng: point[0], lat: point[1] }
  	                  : point
  	                );
  	
  	                if (!clean) return null;
  	
  	                return {
  	                  x: (Number(clean.lng) - Number(center.lng)) * Math.PI / 180 * earthRadius * cosLat,
  	                  y: (Number(clean.lat) - Number(center.lat)) * Math.PI / 180 * earthRadius
  	                };
  	              }
  	
  	              function toGeo(point) {
  	                if (!point || !Number.isFinite(point.x) || !Number.isFinite(point.y)) {
  	                  return null;
  	                }
  	
  	                return cardSegmentRoundPoint({
  	                  lat: Number(center.lat) + (point.y / earthRadius) * 180 / Math.PI,
  	                  lng: Number(center.lng) + (point.x / (earthRadius * cosLat)) * 180 / Math.PI
  	                });
  	              }
  	
  	              function cleanRing(ring) {
  	                const out = (Array.isArray(ring) ? ring : [])
  	                .map(toLocal)
  	                .filter(Boolean);
  	
  	                if (out.length > 1) {
  	                  const first = out[0];
  	                  const last = out[out.length - 1];
  	
  	                  if (Math.abs(first.x - last.x) < 0.000001 && Math.abs(first.y - last.y) < 0.000001) {
  	                    out.pop();
  	                  }
  	                }
  	
  	                return out.length >= 3 ? out : [];
  	              }
  	
  	              const outer = cleanRing(outerLngLat);
  	              const holes = getCardExplicitHoleRings(location)
  	              .map(cleanRing)
  	              .filter(ring => ring.length >= 3);
  	
  	              if (outer.length < 3) return null;
  	
  	              return {
  	                center,
  	                outer,
  	                holes,
  	                toGeo,
  	                toLocal
  	              };
  	            }
  	
  	            function cardSegmentSignedAreaM2(ring) {
  	              if (!Array.isArray(ring) || ring.length < 3) return 0;
  	
  	              let twiceArea = 0;
  	
  	              for (let index = 0; index < ring.length; index++) {
  	                const current = ring[index];
  	                const next = ring[(index + 1) % ring.length];
  	
  	                twiceArea += (Number(current.x) * Number(next.y)) -
  	                (Number(next.x) * Number(current.y));
  	              }
  	
  	              return twiceArea / 2;
  	            }
  	
  	            function cardSegmentClipRingToHalfPlane(ring, isInside, intersection) {
  	              const source = Array.isArray(ring) ? ring : [];
  	
  	              if (source.length < 3) return [];
  	
  	              const output = [];
  	
  	              for (let index = 0; index < source.length; index++) {
  	                const current = source[index];
  	                const previous = source[(index + source.length - 1) % source.length];
  	                const currentInside = isInside(current);
  	                const previousInside = isInside(previous);
  	
  	                if (currentInside) {
  	                  if (!previousInside) {
  	                    const hit = intersection(previous, current);
  	                    if (hit) output.push(hit);
  	                  }
  	
  	                  output.push(current);
  	                } else if (previousInside) {
  	                  const hit = intersection(previous, current);
  	                  if (hit) output.push(hit);
  	                }
  	              }
  	
  	              return output.length >= 3 ? output : [];
  	            }
  	
  	            function cardSegmentClipRingByRay(ring, bearingDegrees, keepClockwiseSide) {
  	              const angle = Number(bearingDegrees) * Math.PI / 180;
  	              const direction = {
  	                x: Math.sin(angle),
  	                y: Math.cos(angle)
  	              };
  	              const epsilon = 0.000001;
  	
  	              function side(point) {
  	                return (direction.x * Number(point.y)) - (direction.y * Number(point.x));
  	              }
  	
  	              function isInside(point) {
  	                const value = side(point);
  	                return keepClockwiseSide ? value <= epsilon : value >= -epsilon;
  	              }
  	
  	              function intersection(a, b) {
  	                const sideA = side(a);
  	                const sideB = side(b);
  	                const denominator = sideA - sideB;
  	
  	                if (Math.abs(denominator) < 1e-12) return null;
  	
  	                const t = Math.max(0, Math.min(1, sideA / denominator));
  	
  	                return {
  	                  x: Number(a.x) + ((Number(b.x) - Number(a.x)) * t),
  	                  y: Number(a.y) + ((Number(b.y) - Number(a.y)) * t)
  	                };
  	              }
  	
  	              return cardSegmentClipRingToHalfPlane(ring, isInside, intersection);
  	            }
  	
  	            // A clockwise angular window up to 180 degrees is the intersection of
  	            // two half-planes. Larger windows are split into non-overlapping parts.
  	            function cardSegmentClipRingToAngularPart(ring, startBearing, sweepDegrees) {
  	              const sweep = Math.max(0, Math.min(180, Number(sweepDegrees) || 0));
  	
  	              if (!Array.isArray(ring) || ring.length < 3 || sweep <= 0.000001) {
  	                return [];
  	              }
  	
  	              const afterStart = cardSegmentClipRingByRay(ring, startBearing, true);
  	
  	              if (afterStart.length < 3) return [];
  	
  	              return cardSegmentClipRingByRay(
  	                afterStart,
  	                Number(startBearing) + sweep,
  	                false
  	              );
  	            }
  	
  	            function cardSegmentBuildAngularPieces(localGeometry, startBearing, sweepDegrees) {
  	              const totalSweep = Math.max(0, Math.min(360, Number(sweepDegrees) || 0));
  	              const pieces = [];
  	              const maxPartSweep = 120;
  	
  	              if (!localGeometry || totalSweep <= 0.000001) return pieces;
  	
  	              for (let offset = 0; offset < totalSweep - 0.000001; offset += maxPartSweep) {
  	                const partSweep = Math.min(maxPartSweep, totalSweep - offset);
  	                const partStart = Number(startBearing) + offset;
  	                const outer = cardSegmentClipRingToAngularPart(
  	                  localGeometry.outer,
  	                  partStart,
  	                  partSweep
  	                );
  	
  	                if (outer.length < 3) continue;
  	
  	                const holes = localGeometry.holes
  	                .map(hole => cardSegmentClipRingToAngularPart(hole, partStart, partSweep))
  	                .filter(hole => hole.length >= 3);
  	
  	                const outerAreaM2 = Math.abs(cardSegmentSignedAreaM2(outer));
  	                const holeAreaM2 = holes.reduce((total, hole) => {
  	                  return total + Math.abs(cardSegmentSignedAreaM2(hole));
  	                }, 0);
  	
  	                pieces.push({
  	                  startBearing: partStart,
  	                  sweepDegrees: partSweep,
  	                  outer,
  	                  holes,
  	                  areaM2: Math.max(0, outerAreaM2 - holeAreaM2)
  	                });
  	              }
  	
  	              return pieces;
  	            }
  	
  	            function cardSegmentMeasureAngularAreaM2(localGeometry, startBearing, sweepDegrees) {
  	              return cardSegmentBuildAngularPieces(localGeometry, startBearing, sweepDegrees)
  	              .reduce((total, piece) => total + Number(piece.areaM2 || 0), 0);
  	            }
  	
  	            function cardSegmentFindSweepForArea(localGeometry, startBearing, maximumSweep, targetAreaM2) {
  	              const maxSweep = Math.max(0, Number(maximumSweep) || 0);
  	              const target = Math.max(0, Number(targetAreaM2) || 0);
  	
  	              if (maxSweep <= 0.000001 || target <= 0) return 0;
  	
  	              const maximumArea = cardSegmentMeasureAngularAreaM2(
  	                localGeometry,
  	                startBearing,
  	                maxSweep
  	              );
  	
  	              if (target >= maximumArea) return maxSweep;
  	
  	              let low = 0;
  	              let high = maxSweep;
  	              const areaToleranceM2 = Math.max(0.05, target * 0.00001);
  	
  	              for (let iteration = 0; iteration < 52; iteration++) {
  	                const middle = (low + high) / 2;
  	                const area = cardSegmentMeasureAngularAreaM2(
  	                  localGeometry,
  	                  startBearing,
  	                  middle
  	                );
  	
  	                if (Math.abs(area - target) <= areaToleranceM2 || high - low <= 0.000001) {
  	                  return middle;
  	                }
  	
  	                if (area < target) {
  	                  low = middle;
  	                } else {
  	                  high = middle;
  	                }
  	              }
  	
  	              return (low + high) / 2;
  	            }
  	
  	            function cardSegmentSerializePieces(pieces, localGeometry) {
  	              return (Array.isArray(pieces) ? pieces : []).map(piece => {
  	                return {
  	                  Boundary: piece.outer.map(localGeometry.toGeo).filter(Boolean),
  	                  Holes: piece.holes.map(hole => {
  	                    return hole.map(localGeometry.toGeo).filter(Boolean);
  	                  }).filter(hole => hole.length >= 3),
  	                  AreaM2: Number(Number(piece.areaM2 || 0).toFixed(2))
  	                };
  	              }).filter(piece => piece.Boundary.length >= 3);
  	            }
  	
  	
  	            // -----------------------------------------------------------------
  	            // Segmentation point model v4
  	            //
  	            // Divider points must come from the ACTUAL resolved boundary.
  	            // The nominal pivot radius is never used as the saved/share point.
  	            // A ray can cross the resolved polygon more than once (for example,
  	            // where a sibling occupies the ground between the parent centre and
  	            // the usable child area). Every real crossing is retained and labelled.
  	            // -----------------------------------------------------------------
  	
  	            function cardSegmentCreatePersistentId(prefix) {
  	              const cleanPrefix = safeString(prefix || "segment").replace(/[^a-z0-9_-]+/gi, "-");
  	
  	              try {
  	                if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
  	                  return `${cleanPrefix}-${crypto.randomUUID()}`;
  	                }
  	              } catch (_) {}
  	
  	              return `${cleanPrefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`;
  	            }
  	
  	            function cardSegmentLocalCross(a, b) {
  	              return (Number(a?.x) * Number(b?.y)) - (Number(a?.y) * Number(b?.x));
  	            }
  	
  	            function cardSegmentRayRingIntersectionsLocal(ring, bearingDegrees, boundaryRole, ringIndex) {
  	              const source = Array.isArray(ring) ? ring : [];
  	
  	              if (source.length < 2) return [];
  	
  	              const angle = Number(bearingDegrees) * Math.PI / 180;
  	              const direction = {
  	                x: Math.sin(angle),
  	                y: Math.cos(angle)
  	              };
  	              const epsilon = 1e-8;
  	              const hits = [];
  	
  	              function addHit(distanceMeters, point, edgeIndex) {
  	                const distance = Number(distanceMeters);
  	
  	                if (!Number.isFinite(distance) || distance < 0.03 || !point) return;
  	
  	                const duplicate = hits.some(existing => {
  	                  return Math.abs(Number(existing.distanceMeters) - distance) <= 0.05;
  	                });
  	
  	                if (duplicate) return;
  	
  	                hits.push({
  	                  point: {
  	                    x: Number(point.x),
  	                    y: Number(point.y)
  	                  },
  	                  distanceMeters: distance,
  	                  boundaryRole: boundaryRole || "boundary",
  	                  ringIndex: Number(ringIndex) || 0,
  	                  edgeIndex: Number(edgeIndex) || 0
  	                });
  	              }
  	
  	              for (let index = 0; index < source.length; index++) {
  	                const a = source[index];
  	                const b = source[(index + 1) % source.length];
  	                const edge = {
  	                  x: Number(b.x) - Number(a.x),
  	                  y: Number(b.y) - Number(a.y)
  	                };
  	                const denominator = cardSegmentLocalCross(direction, edge);
  	
  	                if (Math.abs(denominator) <= epsilon) {
  	                  // Parallel/collinear edges can still contribute an endpoint.
  	                  [a, b].forEach(endpoint => {
  	                    const side = cardSegmentLocalCross(direction, endpoint);
  	                    const distance = (Number(endpoint.x) * direction.x) + (Number(endpoint.y) * direction.y);
  	
  	                    if (Math.abs(side) <= 0.02 && distance >= 0.03) {
  	                      addHit(distance, endpoint, index);
  	                    }
  	                  });
  	
  	                  continue;
  	                }
  	
  	                // Ray: t * direction, t >= 0
  	                // Segment: a + u * edge, 0 <= u <= 1
  	                const distance = cardSegmentLocalCross(a, edge) / denominator;
  	                const segmentT = cardSegmentLocalCross(a, direction) / denominator;
  	
  	                if (
  	                  distance < -epsilon ||
  	                  segmentT < -epsilon ||
  	                  segmentT > 1 + epsilon
  	                ) {
  	                  continue;
  	                }
  	
  	                addHit(
  	                  Math.max(0, distance),
  	                  {
  	                    x: direction.x * Math.max(0, distance),
  	                    y: direction.y * Math.max(0, distance)
  	                  },
  	                  index
  	                );
  	              }
  	
  	              return hits.sort((a, b) => Number(a.distanceMeters) - Number(b.distanceMeters));
  	            }
  	
  	            function cardSegmentGetDividerBoundaryHits(localGeometry, bearingDegrees) {
  	              if (!localGeometry) return [];
  	
  	              const hits = [];
  	
  	              cardSegmentRayRingIntersectionsLocal(
  	                localGeometry.outer,
  	                bearingDegrees,
  	                "parent-boundary",
  	                0
  	              ).forEach(hit => hits.push(hit));
  	
  	              (Array.isArray(localGeometry.holes) ? localGeometry.holes : []).forEach((hole, index) => {
  	                cardSegmentRayRingIntersectionsLocal(
  	                  hole,
  	                  bearingDegrees,
  	                  "sibling-or-hole-boundary",
  	                  index
  	                ).forEach(hit => hits.push(hit));
  	              });
  	
  	              hits.sort((a, b) => Number(a.distanceMeters) - Number(b.distanceMeters));
  	
  	              const deduped = [];
  	
  	              hits.forEach(hit => {
  	                const duplicate = deduped.find(existing => {
  	                  return Math.abs(Number(existing.distanceMeters) - Number(hit.distanceMeters)) <= 0.05;
  	                });
  	
  	                if (!duplicate) {
  	                  deduped.push(hit);
  	                  return;
  	                }
  	
  	                // Prefer a parent-boundary classification when two stored rings
  	                // meet at the same real-world coordinate.
  	                if (
  	                  duplicate.boundaryRole !== "parent-boundary" &&
  	                  hit.boundaryRole === "parent-boundary"
  	                ) {
  	                  Object.assign(duplicate, hit);
  	                }
  	              });
  	
  	              return deduped;
  	            }
  	
  	
  	            // The exact first and final bearing of a cut ring can lie along a
  	            // clipping edge. A conventional ray/ring intersection can then report
  	            // only one endpoint, or classify the shared inner endpoint as the
  	            // parent boundary. Recover every real divider endpoint from the
  	            // generated segment polygons as well, then merge them by distance.
  	            function cardSegmentGetDividerBoundaryHitsFromSegments(
  	              segments,
  	              dividerNumber,
  	              bearingDegrees,
  	              isClosed,
  	              localGeometry
  	            ) {
  	              const sourceSegments = Array.isArray(segments) ? segments : [];
  	
  	              if (!sourceSegments.length || !localGeometry || typeof localGeometry.toLocal !== "function") {
  	                return [];
  	              }
  	
  	              const count = sourceSegments.length;
  	              const relatedNumbers = cardSegmentGetRelatedSegmentNumbers(
  	                dividerNumber,
  	                count,
  	                isClosed
  	              );
  	              const angle = Number(bearingDegrees) * Math.PI / 180;
  	              const direction = {
  	                x: Math.sin(angle),
  	                y: Math.cos(angle)
  	              };
  	              const rayToleranceMeters = 0.35;
  	              const hits = [];
  	
  	              function classifyPoint(point) {
  	                if (cardSegmentPointOnLocalRingBoundary(point, localGeometry.outer, 0.35)) {
  	                  return {
  	                    boundaryRole: "parent-boundary",
  	                    ringIndex: 0
  	                  };
  	                }
  	
  	                const holes = Array.isArray(localGeometry.holes) ? localGeometry.holes : [];
  	
  	                for (let index = 0; index < holes.length; index++) {
  	                  if (cardSegmentPointOnLocalRingBoundary(point, holes[index], 0.35)) {
  	                    return {
  	                      boundaryRole: "sibling-or-hole-boundary",
  	                      ringIndex: index
  	                    };
  	                  }
  	                }
  	
  	                return {
  	                  boundaryRole: "resolved-segment-boundary",
  	                  ringIndex: 0
  	                };
  	              }
  	
  	              function addCoordinate(coordinate, edgeIndex) {
  	                const localPoint = localGeometry.toLocal(coordinate);
  	
  	                if (!localPoint) return;
  	
  	                const distanceMeters = (Number(localPoint.x) * direction.x) +
  	                (Number(localPoint.y) * direction.y);
  	                const perpendicularMeters = Math.abs(
  	                  (direction.x * Number(localPoint.y)) -
  	                  (direction.y * Number(localPoint.x))
  	                );
  	
  	                if (!Number.isFinite(distanceMeters) || distanceMeters < 0.03) return;
  	                if (!Number.isFinite(perpendicularMeters) || perpendicularMeters > rayToleranceMeters) return;
  	
  	                const classification = classifyPoint(localPoint);
  	                const duplicate = hits.find(existing => {
  	                  return Math.abs(Number(existing.distanceMeters) - distanceMeters) <= 0.15;
  	                });
  	
  	                const record = {
  	                  point: {
  	                    x: Number(localPoint.x),
  	                    y: Number(localPoint.y)
  	                  },
  	                  distanceMeters,
  	                  boundaryRole: classification.boundaryRole,
  	                  ringIndex: classification.ringIndex,
  	                  edgeIndex: Number(edgeIndex) || 0,
  	                  source: "resolved-segment-polygon"
  	                };
  	
  	                if (!duplicate) {
  	                  hits.push(record);
  	                  return;
  	                }
  	
  	                // At a cut endpoint the same coordinate can belong to both the
  	                // outer and inner rings. Retain the more useful non-parent role
  	                // for the nearer point; the farthest point is selected as Pn below.
  	                if (
  	                  duplicate.boundaryRole === "resolved-segment-boundary" ||
  	                  (
  	                    duplicate.boundaryRole === "parent-boundary" &&
  	                    record.boundaryRole === "sibling-or-hole-boundary"
  	                  )
  	                ) {
  	                  Object.assign(duplicate, record);
  	                }
  	              }
  	
  	              sourceSegments.forEach(segment => {
  	                const segmentNumber = Number(segment?.SegmentNumber || segment?.segmentNumber || 0);
  	
  	                if (!relatedNumbers.includes(segmentNumber)) return;
  	
  	                const parts = Array.isArray(segment?.BoundaryParts)
  	                ? segment.BoundaryParts
  	                : Array.isArray(segment?.boundaryParts)
  	                ? segment.boundaryParts
  	                : [];
  	
  	                parts.forEach(part => {
  	                  const rings = [
  	                    part?.Boundary || part?.boundary || [],
  	                    ...(Array.isArray(part?.Holes || part?.holes)
  	                      ? (part.Holes || part.holes)
  	                      : [])
  	                  ];
  	
  	                  rings.forEach(ring => {
  	                    (Array.isArray(ring) ? ring : []).forEach((coordinate, edgeIndex) => {
  	                      addCoordinate(coordinate, edgeIndex);
  	                    });
  	                  });
  	                });
  	              });
  	
  	              return hits.sort((a, b) => {
  	                return Number(a.distanceMeters) - Number(b.distanceMeters);
  	              });
  	            }
  	
  	            function cardSegmentMergeDividerBoundaryHits(primaryHits, recoveredHits) {
  	              const merged = [];
  	
  	              function addHit(hit) {
  	                if (!hit || !Number.isFinite(Number(hit.distanceMeters))) return;
  	
  	                const duplicate = merged.find(existing => {
  	                  return Math.abs(Number(existing.distanceMeters) - Number(hit.distanceMeters)) <= 0.15;
  	                });
  	
  	                if (!duplicate) {
  	                  merged.push({ ...hit });
  	                  return;
  	                }
  	
  	                // Prefer the recovered segment-polygon classification at shared
  	                // cut endpoints because it correctly distinguishes Pn-IN from Pn.
  	                if (hit.source === "resolved-segment-polygon") {
  	                  Object.assign(duplicate, hit);
  	                }
  	              }
  	
  	              (Array.isArray(primaryHits) ? primaryHits : []).forEach(addHit);
  	              (Array.isArray(recoveredHits) ? recoveredHits : []).forEach(addHit);
  	
  	              return merged.sort((a, b) => {
  	                return Number(a.distanceMeters) - Number(b.distanceMeters);
  	              });
  	            }
  	
  	
  	
  	            // Open cut-rings have two special end boundaries. The inner point is
  	            // the angular/tangent point on the sibling or hole boundary, while the
  	            // outer point is the end of the physical cut boundary on the parent
  	            // shell. That outer point is not necessarily collinear with the centre,
  	            // so a ray-only intersection can never recover it.
  	            function cardSegmentRecoverOpenCutOuterBoundaryHit(
  	              segments,
  	              dividerNumber,
  	              isClosed,
  	              localGeometry,
  	              currentHits
  	            ) {
  	              const sourceSegments = Array.isArray(segments) ? segments : [];
  	              const hits = Array.isArray(currentHits) ? currentHits : [];
  	
  	              if (isClosed || !sourceSegments.length || !localGeometry) return null;
  	
  	              const count = sourceSegments.length;
  	              const isFirstDivider = Number(dividerNumber) === 1;
  	              const isFinalDivider = Number(dividerNumber) === count + 1;
  	
  	              if (!isFirstDivider && !isFinalDivider) return null;
  	
  	              const innerHit = hits.find(hit => {
  	                return safeString(hit?.boundaryRole).includes("sibling-or-hole");
  	              }) || hits[0] || null;
  	
  	              if (!innerHit?.point) return null;
  	
  	              const innerDistance = Number(innerHit.distanceMeters);
  	
  	              // Do nothing when the normal geometry already supplied a genuine,
  	              // farther parent endpoint for this cut boundary.
  	              const existingOuter = hits.find(hit => {
  	                return (
  	                  hit !== innerHit &&
  	                  hit?.boundaryRole === "parent-boundary" &&
  	                  Number(hit.distanceMeters) > innerDistance + 0.5
  	                );
  	              });
  	
  	              if (existingOuter) return null;
  	
  	              const targetSegment = isFirstDivider
  	              ? sourceSegments[0]
  	              : sourceSegments[count - 1];
  	
  	              if (!targetSegment) return null;
  	
  	              const adjacentBearing = Number(
  	                isFirstDivider
  	                ? targetSegment?.EndAngleDeg ?? targetSegment?.endAngleDeg
  	                : targetSegment?.StartAngleDeg ?? targetSegment?.startAngleDeg
  	              );
  	
  	              const segmentBoundaryRings = [];
  	              const parts = Array.isArray(targetSegment?.BoundaryParts)
  	              ? targetSegment.BoundaryParts
  	              : Array.isArray(targetSegment?.boundaryParts)
  	              ? targetSegment.boundaryParts
  	              : [];
  	
  	              parts.forEach(part => {
  	                const ring = (part?.Boundary || part?.boundary || [])
  	                .map(coordinate => localGeometry.toLocal(coordinate))
  	                .filter(Boolean);
  	
  	                if (ring.length >= 3) {
  	                  segmentBoundaryRings.push(ring);
  	                }
  	              });
  	
  	              if (!segmentBoundaryRings.length) return null;
  	
  	              function isOnTargetSegmentBoundary(point) {
  	                return segmentBoundaryRings.some(ring => {
  	                  return cardSegmentPointOnLocalRingBoundary(point, ring, 0.85);
  	                });
  	              }
  	
  	              function perpendicularDistanceToBearing(point, bearingDegrees) {
  	                if (!Number.isFinite(Number(bearingDegrees))) return Infinity;
  	
  	                const angle = Number(bearingDegrees) * Math.PI / 180;
  	                const direction = {
  	                  x: Math.sin(angle),
  	                  y: Math.cos(angle)
  	                };
  	
  	                return Math.abs(
  	                  (direction.x * Number(point.y)) -
  	                  (direction.y * Number(point.x))
  	                );
  	              }
  	
  	              function turnDegrees(ring, index) {
  	                const previous = ring[(index + ring.length - 1) % ring.length];
  	                const current = ring[index];
  	                const next = ring[(index + 1) % ring.length];
  	                const incoming = {
  	                  x: Number(current.x) - Number(previous.x),
  	                  y: Number(current.y) - Number(previous.y)
  	                };
  	                const outgoing = {
  	                  x: Number(next.x) - Number(current.x),
  	                  y: Number(next.y) - Number(current.y)
  	                };
  	                const inLength = Math.hypot(incoming.x, incoming.y);
  	                const outLength = Math.hypot(outgoing.x, outgoing.y);
  	
  	                if (inLength <= 0.001 || outLength <= 0.001) return 0;
  	
  	                const cosine = Math.max(-1, Math.min(1,
  	                  ((incoming.x * outgoing.x) + (incoming.y * outgoing.y)) /
  	                  (inLength * outLength)
  	                ));
  	
  	                return Math.acos(cosine) * 180 / Math.PI;
  	              }
  	
  	              const outerRing = Array.isArray(localGeometry.outer)
  	              ? localGeometry.outer
  	              : [];
  	              const candidates = [];
  	
  	              outerRing.forEach((point, index) => {
  	                if (!point || !isOnTargetSegmentBoundary(point)) return;
  	
  	                const radialDistance = Math.hypot(Number(point.x), Number(point.y));
  	                const distanceFromInner = Math.hypot(
  	                  Number(point.x) - Number(innerHit.point.x),
  	                  Number(point.y) - Number(innerHit.point.y)
  	                );
  	
  	                if (!Number.isFinite(radialDistance) || radialDistance <= innerDistance + 0.5) return;
  	                if (!Number.isFinite(distanceFromInner) || distanceFromInner <= 0.5) return;
  	
  	                // Exclude the ordinary neighbouring divider endpoint (P2/P10).
  	                // The wanted P1/P11 lies on the physical cut boundary instead.
  	                if (
  	                  Number.isFinite(adjacentBearing) &&
  	                  perpendicularDistanceToBearing(point, adjacentBearing) <= 0.85
  	                ) {
  	                  return;
  	                }
  	
  	                candidates.push({
  	                  point: {
  	                    x: Number(point.x),
  	                    y: Number(point.y)
  	                  },
  	                  radialDistance,
  	                  distanceFromInner,
  	                  turnDegrees: turnDegrees(outerRing, index),
  	                  edgeIndex: index
  	                });
  	              });
  	
  	              // Some older resolved records do not retain the physical cut
  	              // corner in localGeometry.outer. In that case, recover it directly
  	              // from the first/last generated segment boundary.
  	              if (!candidates.length) {
  	                segmentBoundaryRings.forEach(ring => {
  	                  ring.forEach((point, index) => {
  	                    const radialDistance = Math.hypot(Number(point.x), Number(point.y));
  	                    const distanceFromInner = Math.hypot(
  	                      Number(point.x) - Number(innerHit.point.x),
  	                      Number(point.y) - Number(innerHit.point.y)
  	                    );
  	
  	                    if (!Number.isFinite(radialDistance) || radialDistance <= innerDistance + 0.5) return;
  	                    if (!Number.isFinite(distanceFromInner) || distanceFromInner <= 0.5) return;
  	
  	                    if (
  	                      Number.isFinite(adjacentBearing) &&
  	                      perpendicularDistanceToBearing(point, adjacentBearing) <= 0.85
  	                    ) {
  	                      return;
  	                    }
  	
  	                    const duplicate = candidates.some(candidate => {
  	                      return Math.hypot(
  	                        Number(candidate.point.x) - Number(point.x),
  	                        Number(candidate.point.y) - Number(point.y)
  	                      ) <= 0.25;
  	                    });
  	
  	                    if (duplicate) return;
  	
  	                    candidates.push({
  	                      point: {
  	                        x: Number(point.x),
  	                        y: Number(point.y)
  	                      },
  	                      radialDistance,
  	                      distanceFromInner,
  	                      turnDegrees: turnDegrees(ring, index),
  	                      edgeIndex: index
  	                    });
  	                  });
  	                });
  	              }
  	
  	              if (!candidates.length) return null;
  	
  	              const maximumTurn = candidates.reduce((maximum, candidate) => {
  	                return Math.max(maximum, Number(candidate.turnDegrees) || 0);
  	              }, 0);
  	              const cornerThreshold = Math.max(8, maximumTurn * 0.55);
  	              const cornerCandidates = candidates.filter(candidate => {
  	                return Number(candidate.turnDegrees) >= cornerThreshold;
  	              });
  	              const pool = cornerCandidates.length ? cornerCandidates : candidates;
  	
  	              pool.sort((a, b) => {
  	                // The cut endpoint is normally the closest sharp parent corner to
  	                // the inner tangent point. Prefer the sharper corner on a close tie.
  	                const distanceDifference = Number(a.distanceFromInner) - Number(b.distanceFromInner);
  	
  	                if (Math.abs(distanceDifference) > 0.35) return distanceDifference;
  	
  	                return Number(b.turnDegrees) - Number(a.turnDegrees);
  	              });
  	
  	              const selected = pool[0];
  	
  	              if (!selected?.point) return null;
  	
  	              return {
  	                point: selected.point,
  	                distanceMeters: selected.radialDistance,
  	                boundaryRole: "parent-boundary",
  	                ringIndex: 0,
  	                edgeIndex: selected.edgeIndex,
  	                source: "open-cut-boundary-endpoint",
  	                isCutOuterEndpoint: true
  	              };
  	            }
  	
  	            function cardSegmentPointOnLocalRingBoundary(point, ring, toleranceMeters) {
  	              const source = Array.isArray(ring) ? ring : [];
  	              const tolerance = Math.max(0.001, Number(toleranceMeters) || 0.03);
  	
  	              if (!point || source.length < 2) return false;
  	
  	              for (let index = 0; index < source.length; index++) {
  	                const a = source[index];
  	                const b = source[(index + 1) % source.length];
  	                const abx = Number(b.x) - Number(a.x);
  	                const aby = Number(b.y) - Number(a.y);
  	                const apx = Number(point.x) - Number(a.x);
  	                const apy = Number(point.y) - Number(a.y);
  	                const length2 = (abx * abx) + (aby * aby);
  	                const t = length2 > 0
  	                ? Math.max(0, Math.min(1, ((apx * abx) + (apy * aby)) / length2))
  	                : 0;
  	                const nearestX = Number(a.x) + (abx * t);
  	                const nearestY = Number(a.y) + (aby * t);
  	                const distance = Math.hypot(
  	                  Number(point.x) - nearestX,
  	                  Number(point.y) - nearestY
  	                );
  	
  	                if (distance <= tolerance) return true;
  	              }
  	
  	              return false;
  	            }
  	
  	            function cardSegmentPointInLocalRing(point, ring, includeBoundary) {
  	              const source = Array.isArray(ring) ? ring : [];
  	
  	              if (!point || source.length < 3) return false;
  	
  	              if (includeBoundary !== false && cardSegmentPointOnLocalRingBoundary(point, source, 0.03)) {
  	                return true;
  	              }
  	
  	              const x = Number(point.x);
  	              const y = Number(point.y);
  	              let inside = false;
  	
  	              for (let i = 0, j = source.length - 1; i < source.length; j = i++) {
  	                const xi = Number(source[i].x);
  	                const yi = Number(source[i].y);
  	                const xj = Number(source[j].x);
  	                const yj = Number(source[j].y);
  	                const crosses = ((yi > y) !== (yj > y)) &&
  	                (x < ((xj - xi) * (y - yi) / ((yj - yi) || 1e-15)) + xi);
  	
  	                if (crosses) inside = !inside;
  	              }
  	
  	              return inside;
  	            }
  	
  	            function cardSegmentPointInLocalGeometry(point, localGeometry) {
  	              if (!point || !localGeometry) return false;
  	
  	              if (!cardSegmentPointInLocalRing(point, localGeometry.outer, true)) {
  	                return false;
  	              }
  	
  	              const holes = Array.isArray(localGeometry.holes) ? localGeometry.holes : [];
  	
  	              for (let index = 0; index < holes.length; index++) {
  	                if (cardSegmentPointInLocalRing(point, holes[index], false)) {
  	                  return false;
  	                }
  	              }
  	
  	              return true;
  	            }
  	
  	            function cardSegmentGetUsableRayIntervalsLocal(localGeometry, bearingDegrees) {
  	              if (!localGeometry) return [];
  	
  	              const angle = Number(bearingDegrees) * Math.PI / 180;
  	              const direction = {
  	                x: Math.sin(angle),
  	                y: Math.cos(angle)
  	              };
  	              const hits = cardSegmentGetDividerBoundaryHits(localGeometry, bearingDegrees);
  	              const distances = [0];
  	
  	              hits.forEach(hit => {
  	                const distance = Number(hit?.distanceMeters);
  	
  	                if (!Number.isFinite(distance) || distance <= 0.001) return;
  	
  	                if (!distances.some(value => Math.abs(Number(value) - distance) <= 0.03)) {
  	                  distances.push(distance);
  	                }
  	              });
  	
  	              distances.sort((a, b) => Number(a) - Number(b));
  	
  	              const intervals = [];
  	
  	              for (let index = 0; index < distances.length - 1; index++) {
  	                const startDistance = Number(distances[index]);
  	                const endDistance = Number(distances[index + 1]);
  	
  	                if (!Number.isFinite(startDistance) || !Number.isFinite(endDistance)) continue;
  	                if (endDistance - startDistance <= 0.03) continue;
  	
  	                const middleDistance = (startDistance + endDistance) / 2;
  	                const middlePoint = {
  	                  x: direction.x * middleDistance,
  	                  y: direction.y * middleDistance
  	                };
  	
  	                if (!cardSegmentPointInLocalGeometry(middlePoint, localGeometry)) {
  	                  continue;
  	                }
  	
  	                intervals.push({
  	                  startDistanceMeters: startDistance,
  	                  endDistanceMeters: endDistance,
  	                  startPoint: {
  	                    x: direction.x * startDistance,
  	                    y: direction.y * startDistance
  	                  },
  	                  endPoint: {
  	                    x: direction.x * endDistance,
  	                    y: direction.y * endDistance
  	                  }
  	                });
  	              }
  	
  	              return intervals;
  	            }
  	
  	            function cardSegmentBearingHasUsableGround(localGeometry, bearingDegrees) {
  	              return cardSegmentGetUsableRayIntervalsLocal(localGeometry, bearingDegrees)
  	              .some(interval => {
  	                return Number(interval.endDistanceMeters) - Number(interval.startDistanceMeters) > 0.05;
  	              });
  	            }
  	
  	            function cardSegmentFindUsableAngularWindows(localGeometry, preferredStartBearing) {
  	              if (!localGeometry) return [];
  	
  	              const startBearing = ((Number(preferredStartBearing) % 360) + 360) % 360;
  	              const sampleCount = 1440;
  	              const step = 360 / sampleCount;
  	              const states = [];
  	
  	              function bearingForOffset(offset) {
  	                return (startBearing + Number(offset) + 3600) % 360;
  	              }
  	
  	              function stateAtOffset(offset) {
  	                return cardSegmentBearingHasUsableGround(
  	                  localGeometry,
  	                  bearingForOffset(offset)
  	                );
  	              }
  	
  	              for (let index = 0; index < sampleCount; index++) {
  	                states.push(stateAtOffset(index * step));
  	              }
  	
  	              const trueCount = states.filter(Boolean).length;
  	
  	              if (!trueCount) return [];
  	
  	              if (trueCount === sampleCount) {
  	                return [{
  	                  startBearing,
  	                  endBearing: startBearing,
  	                  sweepDegrees: 360,
  	                  isClosed: true,
  	                  areaM2: cardSegmentMeasureAngularAreaM2(localGeometry, startBearing, 360)
  	                }];
  	              }
  	
  	              function refineFalseToTrue(lowOffset, highOffset) {
  	                let low = Number(lowOffset);
  	                let high = Number(highOffset);
  	
  	                for (let iteration = 0; iteration < 34; iteration++) {
  	                  const middle = (low + high) / 2;
  	
  	                  if (stateAtOffset(middle)) {
  	                    high = middle;
  	                  } else {
  	                    low = middle;
  	                  }
  	                }
  	
  	                return high;
  	              }
  	
  	              function refineTrueToFalse(lowOffset, highOffset) {
  	                let low = Number(lowOffset);
  	                let high = Number(highOffset);
  	
  	                for (let iteration = 0; iteration < 34; iteration++) {
  	                  const middle = (low + high) / 2;
  	
  	                  if (stateAtOffset(middle)) {
  	                    low = middle;
  	                  } else {
  	                    high = middle;
  	                  }
  	                }
  	
  	                return low;
  	              }
  	
  	              const startTransitions = [];
  	              const endTransitions = [];
  	
  	              for (let index = 0; index < sampleCount; index++) {
  	                const current = states[index];
  	                const next = states[(index + 1) % sampleCount];
  	
  	                if (!current && next) startTransitions.push(index);
  	                if (current && !next) endTransitions.push(index);
  	              }
  	
  	              const windows = [];
  	
  	              startTransitions.forEach(startIndex => {
  	                let endIndex = null;
  	
  	                for (let offset = 1; offset <= sampleCount; offset++) {
  	                  const candidate = (startIndex + offset) % sampleCount;
  	
  	                  if (endTransitions.includes(candidate)) {
  	                    endIndex = candidate;
  	                    break;
  	                  }
  	                }
  	
  	                if (endIndex === null) return;
  	
  	                const rawStartLow = startIndex * step;
  	                const rawStartHigh = rawStartLow + step;
  	                let rawEndLow = endIndex * step;
  	
  	                while (rawEndLow <= rawStartLow) rawEndLow += 360;
  	
  	                const rawEndHigh = rawEndLow + step;
  	                const startOffset = refineFalseToTrue(rawStartLow, rawStartHigh);
  	                const endOffset = refineTrueToFalse(rawEndLow, rawEndHigh);
  	                const sweepDegrees = Math.max(0, endOffset - startOffset);
  	
  	                if (sweepDegrees <= 0.001) return;
  	
  	                const windowStartBearing = bearingForOffset(startOffset);
  	                const areaM2 = cardSegmentMeasureAngularAreaM2(
  	                  localGeometry,
  	                  windowStartBearing,
  	                  sweepDegrees
  	                );
  	
  	                if (!Number.isFinite(areaM2) || areaM2 <= 0.5) return;
  	
  	                windows.push({
  	                  startBearing: windowStartBearing,
  	                  endBearing: bearingForOffset(endOffset),
  	                  sweepDegrees,
  	                  isClosed: false,
  	                  areaM2
  	                });
  	              });
  	
  	              return windows.sort((a, b) => {
  	                return cardSegmentClockwiseDelta(startBearing, a.startBearing) -
  	                cardSegmentClockwiseDelta(startBearing, b.startBearing);
  	              });
  	            }
  	
  	            function cardSegmentGetRelatedSegmentNumbers(dividerNumber, segmentCount, isClosed) {
  	              const divider = Number(dividerNumber) || 0;
  	              const count = Number(segmentCount) || 0;
  	              const related = [];
  	
  	              if (!divider || !count) return related;
  	
  	              if (isClosed) {
  	                related.push(divider === 1 ? count : divider - 1);
  	                related.push(divider);
  	              } else {
  	                if (divider > 1) related.push(divider - 1);
  	                if (divider <= count) related.push(divider);
  	              }
  	
  	              return Array.from(new Set(related.filter(number => number >= 1 && number <= count)));
  	            }
  	
  	            function cardSegmentAttachPointRegistry(segmentation, localGeometry, base) {
  	              if (!segmentation || !localGeometry) return segmentation;
  	
  	              const segments = Array.isArray(segmentation.Segments)
  	              ? segmentation.Segments
  	              : Array.isArray(segmentation.segments)
  	              ? segmentation.segments
  	              : [];
  	
  	              if (!segments.length) return segmentation;
  	
  	              const segmentationId = safeString(
  	                segmentation.SegmentationId ||
  	                segmentation.segmentationId ||
  	                ""
  	              ).trim() || cardSegmentCreatePersistentId("segmentation");
  	
  	              const existingPoints = Array.isArray(segmentation.Points)
  	              ? segmentation.Points
  	              : Array.isArray(segmentation.points)
  	              ? segmentation.points
  	              : [];
  	
  	              const existingById = Object.create(null);
  	              const existingByDefaultName = Object.create(null);
  	
  	              existingPoints.forEach(point => {
  	                const pointId = safeString(point?.PointId || point?.pointId).trim();
  	                const defaultName = safeString(point?.DefaultName || point?.defaultName).trim().toLowerCase();
  	
  	                if (pointId) existingById[pointId] = point;
  	                if (defaultName && !existingByDefaultName[defaultName]) {
  	                  existingByDefaultName[defaultName] = point;
  	                }
  	              });
  	
  	              function preservedName(pointId, defaultName) {
  	                const existing = existingById[pointId] || existingByDefaultName[safeString(defaultName).toLowerCase()] || null;
  	                const name = safeString(existing?.Name || existing?.name).trim();
  	                const oldDefaultName = safeString(
  	                  existing?.DefaultName ||
  	                  existing?.defaultName ||
  	                  ""
  	                ).trim();
  	
  	                // Preserve only a genuine user rename. When a point changes from
  	                // the old single-endpoint model (P1) to the corrected inner/outer
  	                // model (P1-IN + P1), its old generated name must not override the
  	                // new correct default name.
  	                if (
  	                  name &&
  	                  oldDefaultName &&
  	                  name.toLowerCase() !== oldDefaultName.toLowerCase()
  	                ) {
  	                  return name;
  	                }
  	
  	                return defaultName;
  	              }
  	
  	              segmentation.SegmentationId = segmentationId;
  	
  	              const count = segments.length;
  	              const availableSweep = Number(segmentation.AvailableSweepDeg ?? segmentation.availableSweepDeg);
  	              const explicitClosed =
  	              segmentation.IsAngularClosed ??
  	              segmentation.isAngularClosed;
  	              const shapeKind = safeString(
  	                segmentation.ShapeKind ||
  	                segmentation.shapeKind ||
  	                base?.kind
  	              ).toLowerCase();
  	              const isClosed = explicitClosed === true || (
  	                explicitClosed === undefined &&
  	                (shapeKind === "pivot" || shapeKind === "ring") &&
  	                (!Number.isFinite(availableSweep) || availableSweep >= 359.999)
  	              );
  	              const dividerCount = isClosed ? count : count + 1;
  	              const dividerRecords = [];
  	              const pointRecords = [];
  	
  	              const centerCoordinates = cardSegmentRoundPoint(base?.center || segments[0]?.Center || segments[0]?.center);
  	
  	              if (centerCoordinates) {
  	                const centerPointId = `${segmentationId}:center`;
  	                const centerDefaultName = "Center";
  	
  	                pointRecords.push({
  	                  PointId: centerPointId,
  	                  DefaultName: centerDefaultName,
  	                  Name: preservedName(centerPointId, centerDefaultName),
  	                  Coordinates: centerCoordinates,
  	                  PointRole: "center",
  	                  BoundaryRole: "centre",
  	                  IsPrimary: true,
  	                  Order: 0,
  	                  RelatedSegmentNumbers: segments.map((_, index) => index + 1)
  	                });
  	              }
  	
  	              for (let dividerIndex = 0; dividerIndex < dividerCount; dividerIndex++) {
  	                const dividerNumber = dividerIndex + 1;
  	                let bearing = null;
  	
  	                if (dividerIndex < count) {
  	                  bearing = Number(
  	                    segments[dividerIndex]?.StartAngleDeg ??
  	                    segments[dividerIndex]?.startAngleDeg
  	                  );
  	                } else {
  	                  bearing = Number(
  	                    segments[count - 1]?.EndAngleDeg ??
  	                    segments[count - 1]?.endAngleDeg
  	                  );
  	                }
  	
  	                if (!Number.isFinite(bearing)) continue;
  	
  	                const directHits = cardSegmentGetDividerBoundaryHits(localGeometry, bearing);
  	                const recoveredHits = cardSegmentGetDividerBoundaryHitsFromSegments(
  	                  segments,
  	                  dividerNumber,
  	                  bearing,
  	                  isClosed,
  	                  localGeometry
  	                );
  	                let hits = cardSegmentMergeDividerBoundaryHits(directHits, recoveredHits);
  	                const cutOuterHit = cardSegmentRecoverOpenCutOuterBoundaryHit(
  	                  segments,
  	                  dividerNumber,
  	                  isClosed,
  	                  localGeometry,
  	                  hits
  	                );
  	
  	                if (cutOuterHit) {
  	                  hits = cardSegmentMergeDividerBoundaryHits(hits, [cutOuterHit]);
  	                }
  	
  	                // Normal dividers use the farthest resolved boundary hit. The first
  	                // and final divider of an open cut-ring use the explicit physical
  	                // cut-boundary endpoint, which may not be collinear with the centre.
  	                const primaryParentHit = hits.find(hit => hit?.isCutOuterEndpoint === true) ||
  	                hits[hits.length - 1] || null;
  	                const nonPrimaryHits = hits.filter(hit => hit !== primaryParentHit);
  	                const relatedSegmentNumbers = cardSegmentGetRelatedSegmentNumbers(
  	                  dividerNumber,
  	                  count,
  	                  isClosed
  	                );
  	                const dividerPointIds = [];
  	                let innerOrdinal = 0;
  	
  	                hits.forEach((hit, hitIndex) => {
  	                  const coordinates = localGeometry.toGeo(hit.point);
  	
  	                  if (!coordinates) return;
  	
  	                  const isPrimary = hit === primaryParentHit;
  	                  let defaultName = `P${dividerNumber}`;
  	
  	                  if (!isPrimary) {
  	                    innerOrdinal++;
  	                    defaultName = nonPrimaryHits.length === 1
  	                    ? `P${dividerNumber}-IN`
  	                    : `P${dividerNumber}-IN${innerOrdinal}`;
  	                  }
  	
  	                  const pointId = `${segmentationId}:divider:${dividerNumber}:point:${hitIndex + 1}`;
  	                  const pointRecord = {
  	                    PointId: pointId,
  	                    DefaultName: defaultName,
  	                    Name: preservedName(pointId, defaultName),
  	                    Coordinates: cardSegmentRoundPoint(coordinates),
  	                    PointRole: "divider-boundary-intersection",
  	                    DividerNumber: dividerNumber,
  	                    BearingDeg: Number((
  	                      hit?.isCutOuterEndpoint === true && base?.center
  	                      ? cardSegmentBearingDegrees(base.center, coordinates)
  	                      : bearing
  	                    ).toFixed(6)),
  	                    DividerBearingDeg: Number(bearing.toFixed(6)),
  	                    BoundaryRole: hit.boundaryRole,
  	                    BoundaryRingIndex: Number(hit.ringIndex) || 0,
  	                    BoundaryEdgeIndex: Number(hit.edgeIndex) || 0,
  	                    DistanceFromCenterMeters: Number(Number(hit.distanceMeters).toFixed(3)),
  	                    Position: isPrimary ? "outer" : "inner",
  	                    IsPrimary: isPrimary,
  	                    Order: (dividerNumber * 100) + hitIndex,
  	                    RelatedSegmentNumbers: relatedSegmentNumbers.slice()
  	                  };
  	
  	                  pointRecords.push(pointRecord);
  	                  dividerPointIds.push(pointId);
  	                });
  	
  	                dividerRecords.push({
  	                  DividerId: `${segmentationId}:divider:${dividerNumber}`,
  	                  DividerNumber: dividerNumber,
  	                  BearingDeg: Number(bearing.toFixed(6)),
  	                  PointIds: dividerPointIds,
  	                  PrimaryPointId: primaryParentHit
  	                  ? dividerPointIds[hits.indexOf(primaryParentHit)] || null
  	                  : dividerPointIds[dividerPointIds.length - 1] || null,
  	                  RelatedSegmentNumbers: relatedSegmentNumbers
  	                });
  	              }
  	
  	              function findDivider(number) {
  	                return dividerRecords.find(divider => {
  	                  return Number(divider.DividerNumber) === Number(number);
  	                }) || null;
  	              }
  	
  	              function findPoint(pointId) {
  	                return pointRecords.find(point => point.PointId === pointId) || null;
  	              }
  	
  	              segments.forEach((segment, index) => {
  	                const startDividerNumber = index + 1;
  	                const endDividerNumber = isClosed && index === count - 1
  	                ? 1
  	                : index + 2;
  	                const startDivider = findDivider(startDividerNumber);
  	                const endDivider = findDivider(endDividerNumber);
  	                const startPrimary = findPoint(startDivider?.PrimaryPointId);
  	                const endPrimary = findPoint(endDivider?.PrimaryPointId);
  	                const startPointIds = Array.isArray(startDivider?.PointIds) ? startDivider.PointIds.slice() : [];
  	                const endPointIds = Array.isArray(endDivider?.PointIds) ? endDivider.PointIds.slice() : [];
  	                const boundaryPointIds = Array.from(new Set([...startPointIds, ...endPointIds]));
  	
  	                segment.StartDividerId = startDivider?.DividerId || null;
  	                segment.EndDividerId = endDivider?.DividerId || null;
  	                segment.StartDividerNumber = startDividerNumber;
  	                segment.EndDividerNumber = endDividerNumber;
  	                segment.StartPointIds = startPointIds;
  	                segment.EndPointIds = endPointIds;
  	                segment.BoundaryPointIds = boundaryPointIds;
  	
  	                // Legacy compatibility fields now point to the TRUE resolved
  	                // outer boundary intersections, not the theoretical radius.
  	                segment.StartArc = startPrimary?.Coordinates || null;
  	                segment.EndArc = endPrimary?.Coordinates || null;
  	
  	                if (!segment.Coordinates || typeof segment.Coordinates !== "object") {
  	                  segment.Coordinates = {};
  	                }
  	
  	                segment.Coordinates.Center = centerCoordinates;
  	                segment.Coordinates.StartArc = segment.StartArc;
  	                segment.Coordinates.EndArc = segment.EndArc;
  	                segment.Coordinates.StartBoundaryPoints = startPointIds.map(findPoint).filter(Boolean).map(point => point.Coordinates);
  	                segment.Coordinates.EndBoundaryPoints = endPointIds.map(findPoint).filter(Boolean).map(point => point.Coordinates);
  	              });
  	
  	              segmentation.PointModelVersion = 4;
  	              segmentation.PointModel = "resolved-boundary-intersections-v4-open-cut-endpoints";
  	              segmentation.Points = pointRecords;
  	              segmentation.Dividers = dividerRecords;
  	
  	              try {
  	                delete segmentation.points;
  	                delete segmentation.dividers;
  	              } catch (_) {}
  	
  	              return segmentation;
  	            }
  	
  	            function ensureCardSegmentationPointRegistry(rowData) {
  	              const segmentation = getCardSegmentationRecord(rowData);
  	              const segments = getCardSegmentationSegments(rowData);
  	
  	              if (!segmentation || !segments.length) return segmentation;
  	
  	              const points = Array.isArray(segmentation.Points)
  	              ? segmentation.Points
  	              : Array.isArray(segmentation.points)
  	              ? segmentation.points
  	              : [];
  	
  	              if (Number(segmentation.PointModelVersion) >= 4 && points.length) {
  	                return segmentation;
  	              }
  	
  	              const base = getCardSegmentationBase(rowData);
  	              const localGeometry = cardSegmentBuildLocalGeometry(rowData?.location, base?.center);
  	
  	              if (!base?.center || !localGeometry) return segmentation;
  	
  	              cardSegmentAttachPointRegistry(segmentation, localGeometry, base);
  	              segmentation.PointMigrationPending = true;
  	
  	              const data = ensureCardLocationData(rowData.location);
  	              data.Segmentation = segmentation;
  	
  	              return segmentation;
  	            }
  	
  	            function buildCardTemporarySegmentation(rowData, requestedCount) {
  	              const count = Math.floor(Number(requestedCount));
  	
  	              if (!Number.isFinite(count) || count < 1 || count > 180) {
  	                return {
  	                  ok: false,
  	                  reason: "Enter a segment count from 1 to 180."
  	                };
  	              }
  	
  	              const base = getCardSegmentationBase(rowData);
  	
  	              if (!base.kind || !base.center || !base.radiusPoint || !base.radiusMeters) {
  	                return {
  	                  ok: false,
  	                  reason: "This location does not have enough saved pivot/wedge geometry to segment."
  	                };
  	              }
  	
  	              let startBearing = cardSegmentBearingDegrees(base.center, base.entrancePoint || base.radiusPoint);
  	              let availableSweep = 360;
  	              let sourceEndBearing = startBearing;
  	              let isAngularClosed = true;
  	              let startMode = base.entrancePoint ? "entrance-point" : "radius-point";
  	
  	              if (base.kind === "wedge") {
  	                if (!base.edgePoint) {
  	                  return {
  	                    ok: false,
  	                    reason: "This wedge does not have a saved end radius point."
  	                  };
  	                }
  	
  	                const wedgeStart = cardSegmentBearingDegrees(base.center, base.radiusPoint);
  	                const wedgeEnd = cardSegmentBearingDegrees(base.center, base.edgePoint);
  	                const wedgeSweep = cardSegmentClockwiseDelta(wedgeStart, wedgeEnd);
  	
  	                if (!Number.isFinite(wedgeSweep) || wedgeSweep < 1) {
  	                  return {
  	                    ok: false,
  	                    reason: "This wedge arc is too small to segment. Move the end radius further around the pivot."
  	                  };
  	                }
  	
  	                // Wedge segmentation must use the full arc between the two radiuses.
  	                // Do not trim the wedge from the entrance point.
  	                startBearing = wedgeStart;
  	                availableSweep = wedgeSweep;
  	                sourceEndBearing = wedgeEnd;
  	                isAngularClosed = false;
  	                startMode = "wedge-radius-point";
  	              }
  	
  	              const localGeometry = cardSegmentBuildLocalGeometry(
  	                rowData.location,
  	                base.center
  	              );
  	
  	              if (!localGeometry) {
  	                return {
  	                  ok: false,
  	                  reason: "This location does not have a valid saved parent boundary to segment."
  	                };
  	              }
  	
  	              if (base.kind !== "wedge") {
  	                const windows = cardSegmentFindUsableAngularWindows(
  	                  localGeometry,
  	                  startBearing
  	                );
  	
  	                if (!windows.length) {
  	                  return {
  	                    ok: false,
  	                    reason: "No usable resolved ground was found around this centre."
  	                  };
  	                }
  	
  	                if (windows.length > 1) {
  	                  return {
  	                    ok: false,
  	                    reason: "This location contains more than one disconnected angular section. Split those sections into separate locations before segmenting."
  	                  };
  	                }
  	
  	                const window = windows[0];
  	
  	                if (window.isClosed || Number(window.sweepDegrees) >= 359.999) {
  	                  availableSweep = 360;
  	                  sourceEndBearing = startBearing;
  	                  isAngularClosed = true;
  	                } else {
  	                  startBearing = Number(window.startBearing);
  	                  availableSweep = Number(window.sweepDegrees);
  	                  sourceEndBearing = Number(window.endBearing);
  	                  isAngularClosed = false;
  	                  startMode = base.kind === "ring"
  	                  ? "resolved-cut-ring-boundary"
  	                  : "resolved-cut-shape-boundary";
  	                }
  	              }
  	
  	              const totalAreaM2 = cardSegmentMeasureAngularAreaM2(
  	                localGeometry,
  	                startBearing,
  	                availableSweep
  	              );
  	
  	              if (!Number.isFinite(totalAreaM2) || totalAreaM2 <= 0.01) {
  	                return {
  	                  ok: false,
  	                  reason: "The usable parent area is too small to segment."
  	                };
  	              }
  	
  	              const totalAreaHa = totalAreaM2 / 10000;
  	              const targetSegmentAreaM2 = totalAreaM2 / count;
  	              const targetSegmentAreaHa = targetSegmentAreaM2 / 10000;
  	
  	              const segments = [];
  	              let consumedSweep = 0;
  	
  	              for (let index = 0; index < count; index++) {
  	                const remainingSweep = Math.max(0, availableSweep - consumedSweep);
  	                const startAngle = (startBearing + consumedSweep) % 360;
  	                const segmentSweep = index === count - 1
  	                ? remainingSweep
  	                : cardSegmentFindSweepForArea(
  	                  localGeometry,
  	                  startAngle,
  	                  remainingSweep,
  	                  targetSegmentAreaM2
  	                );
  	                const endAngle = (startAngle + segmentSweep) % 360;
  	                const pieces = cardSegmentBuildAngularPieces(
  	                  localGeometry,
  	                  startAngle,
  	                  segmentSweep
  	                );
  	                const actualAreaM2 = pieces.reduce((total, piece) => {
  	                  return total + Number(piece.areaM2 || 0);
  	                }, 0);
  	                const actualAreaHa = actualAreaM2 / 10000;
  	                const arcDistanceMeters = Number(base.radiusMeters) * (segmentSweep * Math.PI / 180);
  	
  	                if (!Number.isFinite(actualAreaM2) || actualAreaM2 <= 0.5 || !pieces.length) {
  	                  return {
  	                    ok: false,
  	                    reason: `Segment ${index + 1} resolved to empty or disconnected non-usable ground. Regenerate after checking the saved cut boundaries.`
  	                  };
  	                }
  	
  	                const centerPoint = cardSegmentRoundPoint(base.center);
  	
  	                segments.push({
  	                  SegmentNumber: index + 1,
  	                  Name: `Segment ${index + 1}`,
  	
  	                  Center: centerPoint,
  	                  StartArc: null,
  	                  EndArc: null,
  	
  	                  Coordinates: {
  	                    Center: centerPoint,
  	                    StartArc: null,
  	                    EndArc: null
  	                  },
  	
  	                  BoundaryParts: cardSegmentSerializePieces(pieces, localGeometry),
  	
  	                  StartAngleDeg: Number(startAngle.toFixed(6)),
  	                  EndAngleDeg: Number(endAngle.toFixed(6)),
  	                  SweepDeg: Number(segmentSweep.toFixed(6)),
  	
  	                  RadiusMeters: Number(Number(base.radiusMeters).toFixed(3)),
  	                  ArcDistanceMeters: Number(Number(arcDistanceMeters).toFixed(3)),
  	
  	                  TargetAreaHa: Number(targetSegmentAreaHa.toFixed(6)),
  	                  TargetAreaM2: Number(targetSegmentAreaM2.toFixed(2)),
  	                  AreaHa: Number(actualAreaHa.toFixed(6)),
  	                  AreaM2: Number(actualAreaM2.toFixed(2)),
  	                  AreaDifferenceM2: Number((actualAreaM2 - targetSegmentAreaM2).toFixed(2))
  	                });
  	
  	                consumedSweep += segmentSweep;
  	              }
  	
  	              const generatedAreaM2 = segments.reduce((total, segment) => {
  	                return total + Number(segment?.AreaM2 || segment?.areaM2 || 0);
  	              }, 0);
  	              const generatedToleranceM2 = Math.max(1, totalAreaM2 * 0.001);
  	
  	              if (
  	                segments.length !== count ||
  	                Math.abs(generatedAreaM2 - totalAreaM2) > generatedToleranceM2
  	              ) {
  	                return {
  	                  ok: false,
  	                  reason: "The generated segments did not reconcile to the selected location's usable area. Nothing was saved."
  	                };
  	              }
  	
  	              const segmentation = {
  	                SegmentationId: cardSegmentCreatePersistentId("segmentation"),
  	                IsActive: true,
  	                IsTemporary: true,
  	                Source: "trackit-pasture-segmentation",
  	                EngineRevision: "resolved-cut-ring-v4-open-cut-endpoints",
  	                ShapeKind: base.kind,
  	                SegmentCount: count,
  	                Direction: "clockwise",
  	                StartMode: startMode,
  	                IsAngularClosed: isAngularClosed,
  	                StartAngleDeg: Number(startBearing.toFixed(6)),
  	                EndAngleDeg: Number(sourceEndBearing.toFixed(6)),
  	                AvailableSweepDeg: Number(availableSweep.toFixed(6)),
  	
  	                TotalAreaHa: Number.isFinite(Number(totalAreaHa))
  	                ? Number(Number(totalAreaHa).toFixed(6)): null,
  	                GeneratedAreaHa: Number((generatedAreaM2 / 10000).toFixed(6)),
  	                StoredLocationAreaHa: Number.isFinite(Number(getCardAreaHa(rowData.location)))
  	                ? Number(Number(getCardAreaHa(rowData.location)).toFixed(6))
  	                : null,
  	
  	                AreaMode: "equal-usable-area",
  	                TargetSegmentAreaHa: Number(targetSegmentAreaHa.toFixed(6)),
  	                TargetSegmentAreaM2: Number(targetSegmentAreaM2.toFixed(2)),
  	
  	                GeneratedAt: new Date().toISOString(),
  	                Segments: segments
  	              };
  	
  	              cardSegmentAttachPointRegistry(segmentation, localGeometry, base);
  	
  	              return {
  	                ok: true,
  	                segmentation
  	              };
  	            }
  	
  	            function getCardTemporarySegmentRuntime() {
  	              if (typeof window === "undefined") {
  	                return {
  	                  polygonsByKey: {},
  	                  labelsByKey: {},
  	                  pointLabelsByKey: {},
  	                  dividerLinesByKey: {}
  	                };
  	              }
  	
  	              if (!window.__TrackITTemporarySegmentationRuntime) {
  	                window.__TrackITTemporarySegmentationRuntime = {
  	                  polygonsByKey: {},
  	                  labelsByKey: {},
  	                  pointLabelsByKey: {},
  	                  dividerLinesByKey: {}
  	                };
  	              }
  	
  	              if (!window.__TrackITTemporarySegmentationRuntime.polygonsByKey) {
  	                window.__TrackITTemporarySegmentationRuntime.polygonsByKey = {};
  	              }
  	
  	              if (!window.__TrackITTemporarySegmentationRuntime.labelsByKey) {
  	                window.__TrackITTemporarySegmentationRuntime.labelsByKey = {};
  	              }
  	
  	              if (!window.__TrackITTemporarySegmentationRuntime.pointLabelsByKey) {
  	                window.__TrackITTemporarySegmentationRuntime.pointLabelsByKey = {};
  	              }
  	
  	              if (!window.__TrackITTemporarySegmentationRuntime.dividerLinesByKey) {
  	                window.__TrackITTemporarySegmentationRuntime.dividerLinesByKey = {};
  	              }
  	
  	              return window.__TrackITTemporarySegmentationRuntime;
  	            }
  	
  	            function clearCardTemporarySegmentPolygons() {
  	              const runtime = getCardTemporarySegmentRuntime();
  	
  	              Object.keys(runtime.polygonsByKey || {}).forEach(key => {
  	                try {
  	                  const stored = runtime.polygonsByKey[key];
  	                  const polygons = Array.isArray(stored) ? stored : [stored];
  	
  	                  polygons.forEach(polygon => {
  	                    if (polygon && typeof polygon.setMap === "function") {
  	                      polygon.setMap(null);
  	                    }
  	                  });
  	                } catch (_) {}
  	
  	                delete runtime.polygonsByKey[key];
  	              });
  	
  	              Object.keys(runtime.labelsByKey || {}).forEach(key => {
  	                try {
  	                  runtime.labelsByKey[key].setMap(null);
  	                } catch (_) {}
  	
  	                delete runtime.labelsByKey[key];
  	              });
  	
  	              Object.keys(runtime.pointLabelsByKey || {}).forEach(key => {
  	                try {
  	                  runtime.pointLabelsByKey[key].setMap(null);
  	                } catch (_) {}
  	
  	                delete runtime.pointLabelsByKey[key];
  	              });
  	
  	              Object.keys(runtime.dividerLinesByKey || {}).forEach(key => {
  	                try {
  	                  const stored = runtime.dividerLinesByKey[key];
  	                  const lines = Array.isArray(stored) ? stored : [stored];
  	
  	                  lines.forEach(line => {
  	                    if (line && typeof line.setMap === "function") {
  	                      line.setMap(null);
  	                    }
  	                  });
  	                } catch (_) {}
  	
  	                delete runtime.dividerLinesByKey[key];
  	              });
  	            }
  	
  	            function buildCardTemporarySegmentPath(segment) {
  	              const boundaryParts = Array.isArray(segment?.BoundaryParts)
  	              ? segment.BoundaryParts: Array.isArray(segment?.boundaryParts)
  	              ? segment.boundaryParts: [];
  	
  	              if (boundaryParts.length) {
  	                const firstBoundary = boundaryParts[0]?.Boundary || boundaryParts[0]?.boundary || [];
  	                const actualPath = firstBoundary
  	                .map(cardSegmentCleanPoint)
  	                .filter(Boolean);
  	
  	                if (actualPath.length >= 3) return actualPath;
  	              }
  	
  	              const center = cardSegmentCleanPoint(segment?.Center || segment?.center);
  	              const startArc = cardSegmentCleanPoint(segment?.StartArc || segment?.startArc);
  	              const endArc = cardSegmentCleanPoint(segment?.EndArc || segment?.endArc);
  	
  	              if (!center || !startArc || !endArc) return [];
  	
  	              const radiusMeters = cardSegmentDistanceMeters(center, startArc);
  	              const startBearing = cardSegmentBearingDegrees(center, startArc);
  	              const endBearing = cardSegmentBearingDegrees(center, endArc);
  	              const sweep = cardSegmentClockwiseDelta(startBearing, endBearing) || 360;
  	              const steps = Math.max(2, Math.min(36, Math.ceil(sweep / 3)));
  	              const path = [center,
  	                startArc];
  	
  	              for (let i = 1; i < steps; i++) {
  	                const bearing = startBearing + (sweep * i / steps);
  	                const point = cardSegmentDestinationPoint(center, radiusMeters, bearing);
  	
  	                if (point) path.push(point);
  	              }
  	
  	              path.push(endArc);
  	              path.push(center);
  	
  	              return path.filter(Boolean);
  	            }
  	
  	            function buildCardTemporarySegmentPolygonPaths(segment) {
  	              const boundaryParts = Array.isArray(segment?.BoundaryParts)
  	              ? segment.BoundaryParts: Array.isArray(segment?.boundaryParts)
  	              ? segment.boundaryParts: [];
  	
  	              const actualParts = boundaryParts.map(part => {
  	                const outer = (part?.Boundary || part?.boundary || [])
  	                .map(cardSegmentCleanPoint)
  	                .filter(Boolean);
  	                const holes = (part?.Holes || part?.holes || [])
  	                .map(hole => {
  	                  return (Array.isArray(hole) ? hole : [])
  	                  .map(cardSegmentCleanPoint)
  	                  .filter(Boolean);
  	                })
  	                .filter(hole => hole.length >= 3);
  	
  	                return outer.length >= 3 ? [outer, ...holes]: null;
  	              }).filter(Boolean);
  	
  	              if (actualParts.length) return actualParts;
  	
  	              const legacyPath = buildCardTemporarySegmentPath(segment);
  	
  	              return legacyPath.length >= 3 ? [[legacyPath]]: [];
  	            }
  	
  	            function cardSegmentPointInGeoRing(point, ring) {
  	              const cleanPoint = cardSegmentCleanPoint(point);
  	              const source = (Array.isArray(ring) ? ring : [])
  	              .map(cardSegmentCleanPoint)
  	              .filter(Boolean);
  	
  	              if (!cleanPoint || source.length < 3) return false;
  	
  	              const x = Number(cleanPoint.lng);
  	              const y = Number(cleanPoint.lat);
  	              let inside = false;
  	
  	              for (let i = 0, j = source.length - 1; i < source.length; j = i++) {
  	                const xi = Number(source[i].lng);
  	                const yi = Number(source[i].lat);
  	                const xj = Number(source[j].lng);
  	                const yj = Number(source[j].lat);
  	                const crosses = ((yi > y) !== (yj > y)) &&
  	                (x < ((xj - xi) * (y - yi) / ((yj - yi) || 1e-15)) + xi);
  	
  	                if (crosses) inside = !inside;
  	              }
  	
  	              return inside;
  	            }
  	
  	            function cardSegmentPointInGeoPart(point, part) {
  	              const outer = part?.Boundary || part?.boundary || [];
  	              const holes = part?.Holes || part?.holes || [];
  	
  	              if (!cardSegmentPointInGeoRing(point, outer)) return false;
  	
  	              return !(Array.isArray(holes) ? holes : []).some(hole => {
  	                return cardSegmentPointInGeoRing(point, hole);
  	              });
  	            }
  	
  	            function cardSegmentGeoPointToEdgeDistance(point, a, b, cosLat) {
  	              const px = Number(point.lng) * cosLat;
  	              const py = Number(point.lat);
  	              const ax = Number(a.lng) * cosLat;
  	              const ay = Number(a.lat);
  	              const bx = Number(b.lng) * cosLat;
  	              const by = Number(b.lat);
  	              const abx = bx - ax;
  	              const aby = by - ay;
  	              const apx = px - ax;
  	              const apy = py - ay;
  	              const length2 = (abx * abx) + (aby * aby);
  	              const t = length2 > 0
  	              ? Math.max(0, Math.min(1, ((apx * abx) + (apy * aby)) / length2))
  	              : 0;
  	              const nearestX = ax + (abx * t);
  	              const nearestY = ay + (aby * t);
  	
  	              return Math.hypot(px - nearestX, py - nearestY);
  	            }
  	
  	            function cardSegmentGeoPartClearance(point, part) {
  	              const clean = cardSegmentCleanPoint(point);
  	
  	              if (!clean) return -1;
  	
  	              const rings = [
  	                part?.Boundary || part?.boundary || [],
  	                ...(Array.isArray(part?.Holes || part?.holes) ? (part?.Holes || part?.holes) : [])
  	              ];
  	              const cosLat = Math.max(0.000001, Math.cos(Number(clean.lat) * Math.PI / 180));
  	              let minimum = Infinity;
  	
  	              rings.forEach(ring => {
  	                const source = (Array.isArray(ring) ? ring : [])
  	                .map(cardSegmentCleanPoint)
  	                .filter(Boolean);
  	
  	                for (let index = 0; index < source.length; index++) {
  	                  minimum = Math.min(
  	                    minimum,
  	                    cardSegmentGeoPointToEdgeDistance(
  	                      clean,
  	                      source[index],
  	                      source[(index + 1) % source.length],
  	                      cosLat
  	                    )
  	                  );
  	                }
  	              });
  	
  	              return Number.isFinite(minimum) ? minimum : -1;
  	            }
  	
  	            function cardSegmentFindGeoPartInteriorPoint(part) {
  	              const outer = (part?.Boundary || part?.boundary || [])
  	              .map(cardSegmentCleanPoint)
  	              .filter(Boolean);
  	
  	              if (outer.length < 3) return null;
  	
  	              let minLat = Infinity;
  	              let maxLat = -Infinity;
  	              let minLng = Infinity;
  	              let maxLng = -Infinity;
  	              let sumLat = 0;
  	              let sumLng = 0;
  	
  	              outer.forEach(point => {
  	                minLat = Math.min(minLat, Number(point.lat));
  	                maxLat = Math.max(maxLat, Number(point.lat));
  	                minLng = Math.min(minLng, Number(point.lng));
  	                maxLng = Math.max(maxLng, Number(point.lng));
  	                sumLat += Number(point.lat);
  	                sumLng += Number(point.lng);
  	              });
  	
  	              const candidates = [
  	                { lat: sumLat / outer.length, lng: sumLng / outer.length },
  	                { lat: (minLat + maxLat) / 2, lng: (minLng + maxLng) / 2 }
  	              ];
  	
  	              // Area-weighted polygon centroid.
  	              let twiceArea = 0;
  	              let centroidX = 0;
  	              let centroidY = 0;
  	
  	              for (let index = 0; index < outer.length; index++) {
  	                const current = outer[index];
  	                const next = outer[(index + 1) % outer.length];
  	                const cross = (Number(current.lng) * Number(next.lat)) -
  	                (Number(next.lng) * Number(current.lat));
  	
  	                twiceArea += cross;
  	                centroidX += (Number(current.lng) + Number(next.lng)) * cross;
  	                centroidY += (Number(current.lat) + Number(next.lat)) * cross;
  	              }
  	
  	              if (Math.abs(twiceArea) > 1e-18) {
  	                candidates.unshift({
  	                  lng: centroidX / (3 * twiceArea),
  	                  lat: centroidY / (3 * twiceArea)
  	                });
  	              }
  	
  	              let best = null;
  	              let bestClearance = -1;
  	
  	              function consider(candidate) {
  	                const clean = cardSegmentCleanPoint(candidate);
  	
  	                if (!clean || !cardSegmentPointInGeoPart(clean, part)) return;
  	
  	                const clearance = cardSegmentGeoPartClearance(clean, part);
  	
  	                if (clearance > bestClearance) {
  	                  best = clean;
  	                  bestClearance = clearance;
  	                }
  	              }
  	
  	              candidates.forEach(consider);
  	
  	              // A compact point-on-surface search. The winning point is always
  	              // inside the real segment and therefore cannot land in R1/the hole.
  	              const gridSize = 19;
  	
  	              for (let row = 0; row < gridSize; row++) {
  	                const lat = minLat + ((row + 0.5) / gridSize) * (maxLat - minLat);
  	
  	                for (let column = 0; column < gridSize; column++) {
  	                  const lng = minLng + ((column + 0.5) / gridSize) * (maxLng - minLng);
  	                  consider({ lat, lng });
  	                }
  	              }
  	
  	              if (best) return best;
  	
  	              return outer.find(point => cardSegmentPointInGeoPart(point, part)) || null;
  	            }
  	
  	            function getCardTemporarySegmentActualLabelPoint(segment) {
  	              const boundaryParts = Array.isArray(segment?.BoundaryParts)
  	              ? segment.BoundaryParts: Array.isArray(segment?.boundaryParts)
  	              ? segment.boundaryParts: [];
  	
  	              if (!boundaryParts.length) return null;
  	
  	              const rankedParts = boundaryParts.slice().sort((a, b) => {
  	                return Number(b?.AreaM2 || b?.areaM2 || 0) -
  	                Number(a?.AreaM2 || a?.areaM2 || 0);
  	              });
  	
  	              for (let index = 0; index < rankedParts.length; index++) {
  	                const point = cardSegmentFindGeoPartInteriorPoint(rankedParts[index]);
  	
  	                if (point) return point;
  	              }
  	
  	              return null;
  	            }
  	
  	            function getCardTemporarySegmentLabelPoint(segment) {
  	              const actual = getCardTemporarySegmentActualLabelPoint(segment);
  	
  	              if (actual) return actual;
  	
  	              const center = cardSegmentCleanPoint(segment?.Center || segment?.center);
  	              const startArc = cardSegmentCleanPoint(segment?.StartArc || segment?.startArc);
  	              const endArc = cardSegmentCleanPoint(segment?.EndArc || segment?.endArc);
  	
  	              if (!center || !startArc || !endArc) return null;
  	
  	              const radiusMeters = cardSegmentDistanceMeters(center, startArc);
  	              const startBearing = cardSegmentBearingDegrees(center, startArc);
  	              const endBearing = cardSegmentBearingDegrees(center, endArc);
  	              const sweep = cardSegmentClockwiseDelta(startBearing, endBearing) || 360;
  	              const middleBearing = startBearing + (sweep / 2);
  	
  	              return cardSegmentDestinationPoint(center, radiusMeters, middleBearing);
  	            }
  	
  	            function buildCardTemporarySegmentLabelText(segment) {
  	              const number = Number(segment?.SegmentNumber || segment?.segmentNumber || 0) || "";
  	              const name = safeString(segment?.Name || segment?.name || `Segment ${number}`).trim() || "Segment";
  	              const areaHa = Number(segment?.AreaHa ?? segment?.areaHa);
  	
  	              if (Number.isFinite(areaHa)) {
  	                return `${name}\n${areaHa.toFixed(4)} ha`;
  	              }
  	
  	              return name;
  	            }
  	
  	            function createCardTemporarySegmentLabelOverlay(position, text, map, zIndex) {
  	              if (
  	                !position ||
  	                !map ||
  	                typeof google === "undefined" ||
  	                !google?.maps?.OverlayView
  	              ) {
  	                return null;
  	              }
  	
  	              const labelPosition = cardSegmentCleanPoint(position);
  	              const labelText = safeString(text).trim();
  	
  	              if (!labelPosition || !labelText) return null;
  	
  	              function SegmentLabelOverlay() {
  	                this.position = labelPosition;
  	                this.text = labelText;
  	                this.map = map;
  	                this.div = null;
  	                this.zIndex = Number(zIndex) || 2147482500;
  	                this.setMap(map);
  	              }
  	
  	              SegmentLabelOverlay.prototype = new google.maps.OverlayView();
  	
  	              SegmentLabelOverlay.prototype.onAdd = function () {
  	                const div = document.createElement("div");
  	
  	                div.className = "trackit-map-temp-segment-label";
  	                div.innerHTML = this.text
  	                .split("\n")
  	                .map(line => `<span>${escapeHtml(line)}</span>`)
  	                .join("");
  	
  	                div.style.position = "absolute";
  	                div.style.transform = "translate(-50%, -100%)";
  	                div.style.pointerEvents = "none";
  	                div.style.zIndex = String(this.zIndex);
  	
  	                this.div = div;
  	
  	                const panes = this.getPanes();
  	
  	                if (panes && panes.overlayMouseTarget) {
  	                  panes.overlayMouseTarget.appendChild(div);
  	                } else if (panes && panes.floatPane) {
  	                  panes.floatPane.appendChild(div);
  	                }
  	              };
  	
  	              SegmentLabelOverlay.prototype.draw = function () {
  	                if (!this.div) return;
  	
  	                const projection = this.getProjection();
  	
  	                if (!projection) return;
  	
  	                const point = projection.fromLatLngToDivPixel(
  	                  new google.maps.LatLng(this.position.lat, this.position.lng)
  	                );
  	
  	                if (!point) return;
  	
  	                this.div.style.left = `${point.x}px`;
  	                this.div.style.top = `${point.y - 6}px`;
  	              };
  	
  	              SegmentLabelOverlay.prototype.onRemove = function () {
  	                if (this.div && this.div.parentNode) {
  	                  this.div.parentNode.removeChild(this.div);
  	                }
  	
  	                this.div = null;
  	              };
  	
  	              return new SegmentLabelOverlay();
  	            }
  	
  	            function formatCardTemporaryPointCoordinate(point) {
  	              const clean = cardSegmentCleanPoint(point);
  	
  	              if (!clean) return "";
  	
  	              return `${Number(clean.lat).toFixed(4)}, ${Number(clean.lng).toFixed(4)}`;
  	            }
  	
  	            function getCardTemporaryPointDedupeKey(point) {
  	              const clean = cardSegmentCleanPoint(point);
  	
  	              if (!clean) return "";
  	
  	              return `${Number(clean.lat).toFixed(8)}:${Number(clean.lng).toFixed(8)}`;
  	            }
  	
  	            function buildCardTemporaryPointLabelText(label, point) {
  	              const coordinate = formatCardTemporaryPointCoordinate(point);
  	
  	              if (!coordinate) return "";
  	
  	              return `${label || "Point"}\n${coordinate}`;
  	            }
  	
  	            function closeSegmentPointWhatsappPanel(overlay) {
  	              if (!overlay) return;
  	
  	              const panel =
  	              overlay.__trackitSharePanel ||
  	              overlay.div?.querySelector?.("[data-segment-point-share-panel]") ||
  	              null;
  	
  	              try {
  	                panel?.remove?.();
  	              } catch (_) {}
  	
  	              overlay.__trackitSharePanel = null;
  	              overlay.div?.classList?.remove?.("is-share-open");
  	
  	              if (activeSegmentPointLabelOverlay === overlay) {
  	                activeSegmentPointLabelOverlay = null;
  	                segmentPointWhatsappBusy = false;
  	              }
  	            }
  	
  	            function closeOtherSegmentPointWhatsappPanel(keepOverlay) {
  	              if (
  	                activeSegmentPointLabelOverlay &&
  	                activeSegmentPointLabelOverlay !== keepOverlay
  	              ) {
  	                closeSegmentPointWhatsappPanel(activeSegmentPointLabelOverlay);
  	              }
  	            }
  	
  	            function setSegmentPointWhatsappStatus(panel, message, state) {
  	              const status = panel?.querySelector?.("[data-segment-point-whatsapp-status]");
  	
  	              if (!status) return;
  	
  	              status.textContent = safeString(message);
  	              status.classList.toggle("success", state === "success");
  	              status.classList.toggle("error", state === "error");
  	            }
  	
  	            function updateSegmentPointWhatsappPlaceholder(panel) {
  	              const countrySelect = panel?.querySelector?.("[data-segment-point-whatsapp-country]");
  	              const phoneInput = panel?.querySelector?.("[data-segment-point-whatsapp-phone]");
  	
  	              if (!phoneInput) return;
  	
  	              const country = getPointWhatsappCountryByIso(countrySelect?.value || "ZA");
  	
  	              phoneInput.placeholder = country.allowAnyIntl
  	              ? "Full number e.g. +27821234567"
  	              : `${country.iso} WhatsApp e.g. ${country.example}`;
  	            }
  	
  	            async function sendSegmentPointWhatsapp(overlay, panel, pointItem) {
  	              if (
  	                !overlay ||
  	                !panel ||
  	                !pointItem?.point ||
  	                segmentPointWhatsappBusy
  	              ) {
  	                return;
  	              }
  	
  	              const coordinates = cardSegmentCleanPoint(pointItem.point);
  	              const phoneInput = panel.querySelector("[data-segment-point-whatsapp-phone]");
  	              const countrySelect = panel.querySelector("[data-segment-point-whatsapp-country]");
  	              const sendButton = panel.querySelector("[data-segment-point-whatsapp-send]");
  	
  	              const checkedNumber = normalisePointWhatsappNumber(
  	                phoneInput?.value,
  	                countrySelect?.value || "ZA"
  	              );
  	
  	              if (!checkedNumber.ok) {
  	                phoneInput?.classList?.add("invalid");
  	                phoneInput?.focus?.();
  	                setSegmentPointWhatsappStatus(panel, checkedNumber.error, "error");
  	                return;
  	              }
  	
  	              if (!coordinates) {
  	                setSegmentPointWhatsappStatus(panel, "Could not read this point's coordinates.", "error");
  	                return;
  	              }
  	
  	              const routeLink = buildPointGoogleMapsRouteUrl({
  	                Latitude: coordinates.lat,
  	                Longitude: coordinates.lng
  	              });
  	
  	              if (!routeLink) {
  	                setSegmentPointWhatsappStatus(panel, "Could not build a route for this point.", "error");
  	                return;
  	              }
  	
  	              phoneInput.classList.remove("invalid");
  	              phoneInput.value = checkedNumber.value;
  	
  	              const pointName = safeString(
  	                pointItem?.pointRecord?.Name ||
  	                pointItem?.pointRecord?.name ||
  	                pointItem?.label
  	              ).trim() || "Point";
  	              const destination =
  	              `${pointName} (${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)})`;
  	
  	              const payload = {
  	                To: checkedNumber.value,
  	                FromLocation: "Current Location",
  	                ToLocation: destination,
  	                Stops: "No stops",
  	                RouteLink: routeLink
  	              };
  	
  	              segmentPointWhatsappBusy = true;
  	
  	              try {
  	                setPointWhatsappButtonState(sendButton, "Sending...", true);
  	                setSegmentPointWhatsappStatus(panel, "Sending WhatsApp route…", "");
  	
  	                FIF_SILENT_CONSOLE.log("[TrackIT Segment Point WhatsApp] Sending template payload:", payload);
  	
  	                const result = await invokePointWhatsappService(payload);
  	
  	                FIF_SILENT_CONSOLE.log("[TrackIT Segment Point WhatsApp] Sent:", result);
  	                setSegmentPointWhatsappStatus(panel, "WhatsApp route sent.", "success");
  	
  	                setTimeout(() => {
  	                  if (
  	                    activeSegmentPointLabelOverlay === overlay &&
  	                    overlay.__trackitSharePanel === panel
  	                  ) {
  	                    closeSegmentPointWhatsappPanel(overlay);
  	                  }
  	                }, 120);
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.error("[TrackIT Segment Point WhatsApp] Send failed:", error);
  	
  	                const message = safeString(error?.message || error?.faultString || error);
  	
  	                if (message.includes("not available")) {
  	                  setSegmentPointWhatsappStatus(
  	                    panel,
  	                    "WhatsApp failed. Backendless service invoke is not available on this screen.",
  	                    "error"
  	                  );
  	                } else {
  	                  setSegmentPointWhatsappStatus(
  	                    panel,
  	                    "WhatsApp failed. Check the approved template, Backendless service and Twilio logs.",
  	                    "error"
  	                  );
  	                }
  	              } finally {
  	                segmentPointWhatsappBusy = false;
  	
  	                if (
  	                  activeSegmentPointLabelOverlay === overlay &&
  	                  overlay.__trackitSharePanel === panel &&
  	                  panel.isConnected
  	                ) {
  	                  setPointWhatsappButtonState(sendButton, "WhatsApp", false);
  	                }
  	              }
  	            }
  	
  	            function getSegmentPointRelatedSegments(pointItem) {
  	              const rowData = pointItem?.rowData || null;
  	              const segments = getCardSegmentationSegments(rowData);
  	              const relatedNumbers = Array.isArray(pointItem?.relatedSegmentNumbers)
  	              ? pointItem.relatedSegmentNumbers
  	              : Array.isArray(pointItem?.pointRecord?.RelatedSegmentNumbers)
  	              ? pointItem.pointRecord.RelatedSegmentNumbers
  	              : [];
  	
  	              return relatedNumbers.map(number => {
  	                return segments.find(segment => {
  	                  return Number(segment?.SegmentNumber || segment?.segmentNumber) === Number(number);
  	                }) || null;
  	              }).filter(Boolean);
  	            }
  	
  	            async function saveSegmentPointNames(overlay, panel, pointItem) {
  	              const rowData = pointItem?.rowData || null;
  	
  	              if (!rowData?.location || !panel) return;
  	
  	              const segmentation = ensureCardSegmentationPointRegistry(rowData) || getCardSegmentationRecord(rowData);
  	              const points = Array.isArray(segmentation?.Points) ? segmentation.Points : [];
  	              const pointId = safeString(pointItem?.pointRecord?.PointId || pointItem?.pointId).trim();
  	              const pointRecord = points.find(point => {
  	                return safeString(point?.PointId || point?.pointId).trim() === pointId;
  	              }) || pointItem?.pointRecord || null;
  	              const pointNameInput = panel.querySelector("[data-segment-point-name]");
  	              const segmentSelect = panel.querySelector("[data-segment-point-segment-select]");
  	              const segmentNameInput = panel.querySelector("[data-segment-point-segment-name]");
  	              const saveButton = panel.querySelector("[data-segment-point-name-save]");
  	              const selectedSegmentNumber = Number(segmentSelect?.value || 0);
  	              const segment = getCardSegmentationSegments(rowData).find(item => {
  	                return Number(item?.SegmentNumber || item?.segmentNumber) === selectedSegmentNumber;
  	              }) || null;
  	
  	              if (!pointRecord) {
  	                setSegmentPointWhatsappStatus(panel, "Could not find this saved point record.", "error");
  	                return;
  	              }
  	
  	              const nextPointName = safeString(pointNameInput?.value).trim() || safeString(pointRecord.DefaultName).trim() || "Point";
  	              const nextSegmentName = segment
  	              ? safeString(segmentNameInput?.value).trim() || `Segment ${selectedSegmentNumber}`
  	              : "";
  	              const previousPointName = pointRecord.Name;
  	              const previousPointUpdatedAt = pointRecord.NameUpdatedAt;
  	              const previousSegmentName = segment?.Name;
  	              const previousSegmentUpdatedAt = segment?.NameUpdatedAt;
  	              const previousMigrationPending = segmentation.PointMigrationPending;
  	              const previousNamesUpdatedAt = segmentation.NamesUpdatedAt;
  	              const namesUpdatedAt = new Date().toISOString();
  	
  	              pointRecord.Name = nextPointName;
  	              pointRecord.NameUpdatedAt = namesUpdatedAt;
  	              segmentation.PointMigrationPending = false;
  	              segmentation.NamesUpdatedAt = namesUpdatedAt;
  	
  	              if (segment) {
  	                segment.Name = nextSegmentName;
  	                segment.NameUpdatedAt = namesUpdatedAt;
  	              }
  	
  	              if (saveButton) {
  	                saveButton.disabled = true;
  	                saveButton.textContent = "Saving...";
  	              }
  	
  	              try {
  	                setSegmentPointWhatsappStatus(panel, "Saving point and segment names…", "");
  	
  	                const persistResult = await persistEditedLocationToBackendless(rowData.location);
  	
  	                if (!persistResult?.ok) {
  	                  throw new Error(persistResult?.reason || "The names were not persisted.");
  	                }
  	
  	                pointItem.label = nextPointName;
  	                pointItem.pointRecord = pointRecord;
  	
  	                refreshEditedLocationEverywhere(rowData, "location-segmentation-name-save");
  	                updateCardOverlayTextWithoutClosingPanel(
  	                  overlay,
  	                  buildCardTemporaryPointLabelText(nextPointName, pointItem.point)
  	                );
  	
  	                if (segment) {
  	                  refreshSegmentNameLabelsWithoutClosingPanel(rowData, segment);
  	                }
  	
  	                const title = panel.querySelector(".trackit-segment-point-share-title");
  	
  	                if (title) {
  	                  title.textContent = `Edit & Share ${nextPointName}`;
  	                }
  	
  	                setSegmentPointWhatsappStatus(panel, "Names saved.", "success");
  	              } catch (error) {
  	                pointRecord.Name = previousPointName;
  	                pointRecord.NameUpdatedAt = previousPointUpdatedAt;
  	                segmentation.PointMigrationPending = previousMigrationPending;
  	                segmentation.NamesUpdatedAt = previousNamesUpdatedAt;
  	
  	                if (segment) {
  	                  segment.Name = previousSegmentName;
  	                  segment.NameUpdatedAt = previousSegmentUpdatedAt;
  	                }
  	
  	                FIF_SILENT_CONSOLE.error("[TrackIT Segmentation] Could not save point/segment names.", error);
  	                setSegmentPointWhatsappStatus(
  	                  panel,
  	                  `Names were not saved. ${safeString(error?.message || error?.faultString || "Unknown error")}`,
  	                  "error"
  	                );
  	              } finally {
  	                if (saveButton && panel.isConnected) {
  	                  saveButton.disabled = false;
  	                  saveButton.textContent = "Save Names";
  	                }
  	              }
  	            }
  	
  	            function openSegmentPointWhatsappPanel(overlay, pointItem) {
  	              if (!overlay?.div || !pointItem?.point) return;
  	
  	              if (overlay.__trackitSharePanel) {
  	                closeSegmentPointWhatsappPanel(overlay);
  	                return;
  	              }
  	
  	              closeOtherSegmentPointWhatsappPanel(overlay);
  	
  	              const coordinates = cardSegmentCleanPoint(pointItem.point);
  	
  	              if (!coordinates) return;
  	
  	              const pointRecord = pointItem?.pointRecord || null;
  	              const pointName = safeString(
  	                pointRecord?.Name ||
  	                pointRecord?.name ||
  	                pointItem.label
  	              ).trim() || "Point";
  	              const relatedSegments = getSegmentPointRelatedSegments(pointItem);
  	              const firstSegment = relatedSegments[0] || null;
  	              const panel = document.createElement("div");
  	
  	              panel.className = "trackit-segment-point-share-panel";
  	              panel.setAttribute("data-segment-point-share-panel", "");
  	              panel.setAttribute("role", "dialog");
  	              panel.setAttribute("aria-label", `Edit and share ${pointName}`);
  	
  	              const segmentOptions = relatedSegments.map(segment => {
  	                const number = Number(segment?.SegmentNumber || segment?.segmentNumber || 0);
  	                const name = safeString(segment?.Name || segment?.name || `Segment ${number}`).trim();
  	
  	                return `<option value="${number}">${escapeHtml(name)}</option>`;
  	              }).join("");
  	
  	              panel.innerHTML = `
  	              <div class="trackit-segment-point-share-head">
  	              <div>
  	              <div class="trackit-segment-point-share-title">Edit &amp; Share ${escapeHtml(pointName)}</div>
  	              <div class="trackit-segment-point-share-meta">${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}</div>
  	              </div>
  	              <button class="trackit-segment-point-share-close" type="button" data-segment-point-whatsapp-close title="Close">×</button>
  	              </div>
  	
  	              <div class="trackit-segment-point-name-editor">
  	              <label class="trackit-segment-point-name-field">
  	              <span>Point name</span>
  	              <input
  	              class="trackit-segment-point-name-input"
  	              data-segment-point-name
  	              type="text"
  	              maxlength="80"
  	              value="${escapeHtml(pointName)}"
  	              autocomplete="off"
  	              >
  	              </label>
  	
  	              ${relatedSegments.length ? `
  	              <label class="trackit-segment-point-name-field">
  	              <span>Related segment</span>
  	              <select class="trackit-segment-point-segment-select" data-segment-point-segment-select>
  	              ${segmentOptions}
  	              </select>
  	              </label>
  	
  	              <label class="trackit-segment-point-name-field">
  	              <span>Segment name</span>
  	              <input
  	              class="trackit-segment-point-name-input"
  	              data-segment-point-segment-name
  	              type="text"
  	              maxlength="80"
  	              value="${escapeHtml(safeString(
  	                firstSegment?.Name ||
  	                firstSegment?.name ||
  	                (firstSegment ? `Segment ${Number(firstSegment?.SegmentNumber || firstSegment?.segmentNumber || 0)}` : "")
  	              ).trim())}"
  	              autocomplete="off"
  	              >
  	              </label>
  	              ` : ""}
  	
  	              <button class="trackit-segment-point-name-save" type="button" data-segment-point-name-save>
  	              Save Names
  	              </button>
  	              </div>
  	
  	              <div class="trackit-point-whatsapp-fields">
  	              <select class="trackit-point-whatsapp-country" data-segment-point-whatsapp-country aria-label="Country code">
  	              ${getPointWhatsappCountryOptionsHtml("ZA")}
  	              </select>
  	
  	              <input
  	              class="trackit-point-whatsapp-phone"
  	              data-segment-point-whatsapp-phone
  	              type="tel"
  	              placeholder="ZA WhatsApp e.g. 0821234567"
  	              autocomplete="tel"
  	              >
  	              </div>
  	
  	              <button
  	              class="trackit-point-whatsapp-btn"
  	              type="button"
  	              data-segment-point-whatsapp-send
  	              >
  	              ${getPointWhatsappButtonHtml("WhatsApp")}
  	              </button>
  	
  	              <div class="trackit-point-whatsapp-status" data-segment-point-whatsapp-status></div>
  	              `;
  	
  	              overlay.__trackitSharePanel = panel;
  	              activeSegmentPointLabelOverlay = overlay;
  	              overlay.div.classList.add("is-share-open");
  	              overlay.div.appendChild(panel);
  	
  	              ["click", "dblclick", "pointerdown", "mousedown", "touchstart", "wheel"].forEach(eventName => {
  	                panel.addEventListener(eventName, event => {
  	                  event.stopPropagation();
  	                }, {
  	                  passive: eventName === "touchstart" || eventName === "wheel"
  	                });
  	              });
  	
  	              try {
  	                google.maps.OverlayView.preventMapHitsAndGesturesFrom(panel);
  	              } catch (_) {}
  	
  	              const pointNameInput = panel.querySelector("[data-segment-point-name]");
  	              const segmentSelect = panel.querySelector("[data-segment-point-segment-select]");
  	              const segmentNameInput = panel.querySelector("[data-segment-point-segment-name]");
  	              const saveNamesButton = panel.querySelector("[data-segment-point-name-save]");
  	              const countrySelect = panel.querySelector("[data-segment-point-whatsapp-country]");
  	              const phoneInput = panel.querySelector("[data-segment-point-whatsapp-phone]");
  	              const sendButton = panel.querySelector("[data-segment-point-whatsapp-send]");
  	              const closeButton = panel.querySelector("[data-segment-point-whatsapp-close]");
  	
  	              function loadSelectedSegmentName() {
  	                if (!segmentSelect || !segmentNameInput) return;
  	
  	                const selectedNumber = Number(segmentSelect.value || 0);
  	                const selectedSegment = relatedSegments.find(segment => {
  	                  return Number(segment?.SegmentNumber || segment?.segmentNumber) === selectedNumber;
  	                }) || null;
  	
  	                segmentNameInput.value = safeString(
  	                  selectedSegment?.Name ||
  	                  selectedSegment?.name ||
  	                  (selectedNumber ? `Segment ${selectedNumber}` : "")
  	                ).trim();
  	              }
  	
  	              updateSegmentPointWhatsappPlaceholder(panel);
  	
  	              closeButton?.addEventListener("click", event => {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                closeSegmentPointWhatsappPanel(overlay);
  	              });
  	
  	              segmentSelect?.addEventListener("change", loadSelectedSegmentName);
  	
  	              [pointNameInput, segmentNameInput].filter(Boolean).forEach(input => {
  	                input.addEventListener("keydown", event => {
  	                  if (event.key !== "Enter") return;
  	
  	                  event.preventDefault();
  	                  event.stopPropagation();
  	                  saveSegmentPointNames(overlay, panel, pointItem);
  	                });
  	              });
  	
  	              saveNamesButton?.addEventListener("click", event => {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                saveSegmentPointNames(overlay, panel, pointItem);
  	              });
  	
  	              countrySelect?.addEventListener("change", () => {
  	                updateSegmentPointWhatsappPlaceholder(panel);
  	                phoneInput?.classList?.remove("invalid");
  	                setSegmentPointWhatsappStatus(panel, "", "");
  	
  	                if (!safeString(phoneInput?.value).trim()) return;
  	
  	                const checked = normalisePointWhatsappNumber(
  	                  phoneInput.value,
  	                  countrySelect.value
  	                );
  	
  	                phoneInput.classList.toggle("invalid", !checked.ok);
  	
  	                if (checked.ok) {
  	                  phoneInput.value = checked.value;
  	                  setSegmentPointWhatsappStatus(panel, "WhatsApp number normalised.", "success");
  	                } else {
  	                  setSegmentPointWhatsappStatus(panel, checked.error, "error");
  	                }
  	              });
  	
  	              phoneInput?.addEventListener("input", () => {
  	                phoneInput.classList.remove("invalid");
  	                setSegmentPointWhatsappStatus(panel, "", "");
  	              });
  	
  	              phoneInput?.addEventListener("blur", () => {
  	                if (!safeString(phoneInput.value).trim()) return;
  	
  	                const checked = normalisePointWhatsappNumber(
  	                  phoneInput.value,
  	                  countrySelect?.value || "ZA"
  	                );
  	
  	                phoneInput.classList.toggle("invalid", !checked.ok);
  	
  	                if (checked.ok) {
  	                  phoneInput.value = checked.value;
  	                } else {
  	                  setSegmentPointWhatsappStatus(panel, checked.error, "error");
  	                }
  	              });
  	
  	              phoneInput?.addEventListener("keydown", event => {
  	                if (event.key !== "Enter") return;
  	
  	                event.preventDefault();
  	                event.stopPropagation();
  	                sendSegmentPointWhatsapp(overlay, panel, pointItem);
  	              });
  	
  	              sendButton?.addEventListener("click", event => {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                sendSegmentPointWhatsapp(overlay, panel, pointItem);
  	              });
  	
  	              setTimeout(() => {
  	                try {
  	                  pointNameInput?.focus?.();
  	                  pointNameInput?.select?.();
  	                } catch (_) {}
  	              }, 0);
  	            }
  	
  	            function createCardTemporaryPointLabelOverlay(position, text, map, zIndex, options) {
  	              if (
  	                !position ||
  	                !map ||
  	                typeof google === "undefined" ||
  	                !google?.maps?.OverlayView
  	              ) {
  	                return null;
  	              }
  	
  	              const labelPosition = cardSegmentCleanPoint(position);
  	              const labelText = safeString(text).trim();
  	              const opts = options && typeof options === "object" ? options : {};
  	
  	              if (!labelPosition || !labelText) return null;
  	
  	              function PointLabelOverlay() {
  	                this.position = labelPosition;
  	                this.text = labelText;
  	                this.map = map;
  	                this.div = null;
  	                this.zIndex = Number(zIndex) || 2147482800;
  	                this.clickable = opts.clickable === true && typeof opts.onClick === "function";
  	                this.onClick = this.clickable ? opts.onClick : null;
  	                this.title = safeString(opts.title).trim();
  	                this.__trackitSharePanel = null;
  	                this.setMap(map);
  	              }
  	
  	              PointLabelOverlay.prototype = new google.maps.OverlayView();
  	
  	              PointLabelOverlay.prototype.onAdd = function () {
  	                const div = document.createElement("div");
  	
  	                div.className = "trackit-map-temp-point-label";
  	                div.innerHTML = this.text
  	                .split("\n")
  	                .map(line => `<span>${escapeHtml(line)}</span>`)
  	                .join("");
  	
  	                div.style.position = "absolute";
  	                div.style.transform = "translate(-50%, -118%)";
  	                div.style.pointerEvents = this.clickable ? "auto" : "none";
  	                div.style.cursor = this.clickable ? "pointer" : "default";
  	                div.style.zIndex = String(this.zIndex);
  	
  	                if (this.clickable) {
  	                  div.classList.add("is-clickable");
  	                  div.setAttribute("role", "button");
  	                  div.setAttribute("tabindex", "0");
  	                  div.setAttribute("aria-label", this.title || "Share saved segment point route on WhatsApp");
  	
  	                  if (this.title) {
  	                    div.title = this.title;
  	                  }
  	
  	                  ["pointerdown", "mousedown", "touchstart"].forEach(eventName => {
  	                    div.addEventListener(eventName, event => {
  	                      event.stopPropagation();
  	                    }, {
  	                      passive: true
  	                    });
  	                  });
  	
  	                  div.addEventListener("click", event => {
  	                    if (event.target?.closest?.("[data-segment-point-share-panel]")) return;
  	
  	                    event.preventDefault();
  	                    event.stopPropagation();
  	                    event.stopImmediatePropagation?.();
  	                    this.onClick?.(this, event);
  	                  });
  	
  	                  div.addEventListener("keydown", event => {
  	                    if (event.key !== "Enter" && event.key !== " ") return;
  	                    if (event.target?.closest?.("[data-segment-point-share-panel]")) return;
  	
  	                    event.preventDefault();
  	                    event.stopPropagation();
  	                    this.onClick?.(this, event);
  	                  });
  	
  	                  try {
  	                    google.maps.OverlayView.preventMapHitsAndGesturesFrom(div);
  	                  } catch (_) {}
  	                }
  	
  	                this.div = div;
  	
  	                const panes = this.getPanes();
  	
  	                if (panes && panes.overlayMouseTarget) {
  	                  panes.overlayMouseTarget.appendChild(div);
  	                } else if (panes && panes.floatPane) {
  	                  panes.floatPane.appendChild(div);
  	                }
  	              };
  	
  	              PointLabelOverlay.prototype.draw = function () {
  	                if (!this.div) return;
  	
  	                const projection = this.getProjection();
  	
  	                if (!projection) return;
  	
  	                const point = projection.fromLatLngToDivPixel(
  	                  new google.maps.LatLng(this.position.lat, this.position.lng)
  	                );
  	
  	                if (!point) return;
  	
  	                this.div.style.left = `${point.x}px`;
  	                this.div.style.top = `${point.y - 8}px`;
  	              };
  	
  	              PointLabelOverlay.prototype.onRemove = function () {
  	                closeSegmentPointWhatsappPanel(this);
  	
  	                if (this.div && this.div.parentNode) {
  	                  this.div.parentNode.removeChild(this.div);
  	                }
  	
  	                this.div = null;
  	              };
  	
  	              return new PointLabelOverlay();
  	            }
  	
  	            function collectCardTemporaryUniqueSegmentPoints(segments, segmentation, rowData) {
  	              const storedPoints = Array.isArray(segmentation?.Points)
  	              ? segmentation.Points
  	              : Array.isArray(segmentation?.points)
  	              ? segmentation.points
  	              : [];
  	
  	              if (storedPoints.length) {
  	                return storedPoints
  	                .map((pointRecord, index) => {
  	                  const point = cardSegmentCleanPoint(
  	                    pointRecord?.Coordinates ||
  	                    pointRecord?.coordinates ||
  	                    pointRecord?.Point ||
  	                    pointRecord?.point
  	                  );
  	                  const pointId = safeString(pointRecord?.PointId || pointRecord?.pointId).trim();
  	                  const label = safeString(
  	                    pointRecord?.Name ||
  	                    pointRecord?.name ||
  	                    pointRecord?.DefaultName ||
  	                    pointRecord?.defaultName ||
  	                    `Point ${index + 1}`
  	                  ).trim();
  	
  	                  if (!point || !pointId) return null;
  	
  	                  return {
  	                    key: pointId,
  	                    pointId,
  	                    label,
  	                    point,
  	                    pointRecord,
  	                    priority: pointRecord?.PointRole === "center" ? 100 : 10,
  	                    relatedSegmentNumbers: Array.isArray(pointRecord?.RelatedSegmentNumbers)
  	                    ? pointRecord.RelatedSegmentNumbers.slice()
  	                    : [],
  	                    rowData
  	                  };
  	                })
  	                .filter(Boolean)
  	                .sort((a, b) => {
  	                  const orderA = Number(a.pointRecord?.Order) || 0;
  	                  const orderB = Number(b.pointRecord?.Order) || 0;
  	                  return orderA - orderB;
  	                });
  	              }
  	
  	              // Legacy fallback for old segmentation records that have not yet
  	              // been migrated to the current point model.
  	              const byKey = Object.create(null);
  	              const ordered = [];
  	
  	              function addPoint(label, point, priority, segmentNumber) {
  	                const clean = cardSegmentCleanPoint(point);
  	                const key = getCardTemporaryPointDedupeKey(clean);
  	
  	                if (!clean || !key) return;
  	
  	                if (!byKey[key]) {
  	                  byKey[key] = {
  	                    key,
  	                    pointId: key,
  	                    label,
  	                    point: clean,
  	                    priority: Number(priority) || 0,
  	                    relatedSegmentNumbers: [],
  	                    rowData
  	                  };
  	
  	                  ordered.push(byKey[key]);
  	                }
  	
  	                if (segmentNumber && !byKey[key].relatedSegmentNumbers.includes(segmentNumber)) {
  	                  byKey[key].relatedSegmentNumbers.push(segmentNumber);
  	                }
  	
  	                if ((Number(priority) || 0) > byKey[key].priority) {
  	                  byKey[key].label = label;
  	                  byKey[key].priority = Number(priority) || 0;
  	                }
  	              }
  	
  	              (Array.isArray(segments) ? segments : []).forEach(segment => {
  	                const number = Number(segment?.SegmentNumber || segment?.segmentNumber || 0) || 0;
  	
  	                addPoint("Center", segment?.Center || segment?.center || segment?.Coordinates?.Center, 100, number);
  	                addPoint(`P${number}`, segment?.StartArc || segment?.startArc || segment?.Coordinates?.StartArc, 10, number);
  	                addPoint(`P${number + 1}`, segment?.EndArc || segment?.endArc || segment?.Coordinates?.EndArc, 10, number);
  	              });
  	
  	              return ordered;
  	            }
  	
  	
  	            function updateCardOverlayTextWithoutClosingPanel(overlay, text) {
  	              if (!overlay?.div) return;
  	
  	              const lines = safeString(text).trim().split("\n");
  	              const directSpans = Array.from(overlay.div.children || []).filter(child => {
  	                return child?.tagName === "SPAN";
  	              });
  	
  	              while (directSpans.length < lines.length) {
  	                const span = document.createElement("span");
  	                const panel = overlay.__trackitSharePanel || null;
  	
  	                if (panel && panel.parentNode === overlay.div) {
  	                  overlay.div.insertBefore(span, panel);
  	                } else {
  	                  overlay.div.appendChild(span);
  	                }
  	
  	                directSpans.push(span);
  	              }
  	
  	              directSpans.forEach((span, index) => {
  	                if (index < lines.length) {
  	                  span.textContent = lines[index];
  	                  span.style.display = "";
  	                } else {
  	                  span.style.display = "none";
  	                }
  	              });
  	
  	              overlay.text = lines.join("\n");
  	            }
  	
  	            function refreshSegmentNameLabelsWithoutClosingPanel(rowData, segment) {
  	              if (!rowData || !segment) return;
  	
  	              const runtime = getCardTemporarySegmentRuntime();
  	              const parentId = getCardLocationIdForRefresh(rowData.location) || safeString(rowData.value).trim() || "selected";
  	              const number = Number(segment?.SegmentNumber || segment?.segmentNumber || 0) || 0;
  	              const key = `${parentId}::segment::${number || segment.Name || ""}`;
  	              const overlay = runtime.labelsByKey?.[key] || null;
  	
  	              if (overlay) {
  	                const text = buildCardTemporarySegmentLabelText(segment);
  	                overlay.text = text;
  	
  	                if (overlay.div) {
  	                  overlay.div.innerHTML = text
  	                  .split("\n")
  	                  .map(line => `<span>${escapeHtml(line)}</span>`)
  	                  .join("");
  	                }
  	              }
  	            }
  	
  	            function renderCardResolvedDividerLines(rowData, segmentation, map, color) {
  	              if (
  	                !rowData?.location ||
  	                !segmentation ||
  	                !map ||
  	                typeof google === "undefined" ||
  	                !google?.maps?.Polyline
  	              ) {
  	                return;
  	              }
  	
  	              const base = getCardSegmentationBase(rowData);
  	              const localGeometry = cardSegmentBuildLocalGeometry(rowData.location, base?.center);
  	              const dividers = Array.isArray(segmentation?.Dividers)
  	              ? segmentation.Dividers
  	              : Array.isArray(segmentation?.dividers)
  	              ? segmentation.dividers
  	              : [];
  	
  	              if (!localGeometry || !dividers.length) return;
  	
  	              const runtime = getCardTemporarySegmentRuntime();
  	              const parentId = getCardLocationIdForRefresh(rowData.location) || safeString(rowData.value).trim() || "selected";
  	
  	              dividers.forEach(divider => {
  	                const dividerNumber = Number(divider?.DividerNumber || divider?.dividerNumber || 0) || 0;
  	                const bearing = Number(divider?.BearingDeg ?? divider?.bearingDeg);
  	
  	                if (!dividerNumber || !Number.isFinite(bearing)) return;
  	
  	                const intervals = cardSegmentGetUsableRayIntervalsLocal(localGeometry, bearing);
  	                const lines = intervals.map((interval, intervalIndex) => {
  	                  const start = localGeometry.toGeo(interval.startPoint);
  	                  const end = localGeometry.toGeo(interval.endPoint);
  	
  	                  if (!start || !end) return null;
  	
  	                  const line = new google.maps.Polyline({
  	                    path: [start, end],
  	                    strokeColor: color,
  	                    strokeOpacity: 0.98,
  	                    strokeWeight: 2,
  	                    clickable: false,
  	                    zIndex: 2147482450 + dividerNumber,
  	                    map
  	                  });
  	
  	                  line.__trackitTemporaryDividerNumber = dividerNumber;
  	                  line.__trackitTemporaryDividerInterval = intervalIndex;
  	
  	                  return line;
  	                }).filter(Boolean);
  	
  	                if (lines.length) {
  	                  runtime.dividerLinesByKey[`${parentId}::divider::${dividerNumber}`] = lines;
  	                }
  	              });
  	            }
  	
  	            function renderCardTemporarySegmentsOnMap(rowData) {
  	              clearCardTemporarySegmentPolygons();
  	
  	              if (!rowData || !rowData.location) return;
  	
  	              const segmentation = ensureCardSegmentationPointRegistry(rowData) || getCardSegmentationRecord(rowData);
  	              const segments = getCardSegmentationSegments(rowData);
  	
  	              if (!segments.length) return;
  	
  	              const map = resolveGMap(MapRoot);
  	
  	              if (!map || typeof google === "undefined" || !google?.maps?.Polygon) return;
  	
  	              const runtime = getCardTemporarySegmentRuntime();
  	              const parentId = getCardLocationIdForRefresh(rowData.location) || safeString(rowData.value).trim() || "selected";
  	              const color = getCardColor(rowData.location) || "#ff9a3d";
  	              const segmentsAreSaved = !!segmentation && !isCardSegmentationDirty(rowData);
  	
  	              segments.forEach(segment => {
  	                const number = Number(segment.SegmentNumber || segment.segmentNumber || 0) || 0;
  	                const key = `${parentId}::segment::${number || segment.Name || Date.now()}`;
  	                const polygonParts = buildCardTemporarySegmentPolygonPaths(segment);
  	
  	                if (!polygonParts.length) return;
  	
  	                try {
  	                  const polygons = polygonParts.map(paths => {
  	                    const polygon = new google.maps.Polygon({
  	                      paths,
  	                      strokeColor: color,
  	                      strokeOpacity: 0,
  	                      strokeWeight: 0,
  	                      fillColor: color,
  	                      fillOpacity: 0.10,
  	                      clickable: true,
  	                      zIndex: 2147482000 + number,
  	                      map
  	                    });
  	
  	                    polygon.__trackitTemporarySegmentKey = key;
  	                    polygon.__trackitTemporarySegmentData = segment;
  	
  	                    return polygon;
  	                  });
  	
  	                  runtime.polygonsByKey[key] = polygons;
  	
  	                  const labelPoint = getCardTemporarySegmentLabelPoint(segment);
  	                  const labelText = buildCardTemporarySegmentLabelText(segment);
  	                  const label = createCardTemporarySegmentLabelOverlay(
  	                    labelPoint,
  	                    labelText,
  	                    map,
  	                    2147482600 + number
  	                  );
  	
  	                  if (label) {
  	                    runtime.labelsByKey[key] = label;
  	                  }
  	                } catch (error) {
  	                  FIF_SILENT_CONSOLE.warn("[TrackIT Segmentation] Could not draw temporary segment.", {
  	                    segment,
  	                    error
  	                  });
  	                }
  	              });
  	
  	              // Draw each divider only through actual usable ground. For a cut
  	              // Ring this produces inner-boundary -> outer-boundary lines and never
  	              // paints red rays through R1/the blue excluded area. The centre label
  	              // remains visible as a separate point.
  	              renderCardResolvedDividerLines(rowData, segmentation, map, color);
  	
  	              const uniquePoints = collectCardTemporaryUniqueSegmentPoints(segments, segmentation, rowData);
  	
  	              uniquePoints.forEach((item, index) => {
  	                const pointLabelText = buildCardTemporaryPointLabelText(item.label, item.point);
  	
  	                if (!pointLabelText) return;
  	
  	                try {
  	                  const pointLabel = createCardTemporaryPointLabelOverlay(
  	                    item.point,
  	                    pointLabelText,
  	                    map,
  	                    2147482900 + index,
  	                    segmentsAreSaved
  	                    ? {
  	                      clickable: true,
  	                      title: `Edit and share ${safeString(item.label).trim() || "Point"}`,
  	                      onClick: overlay => {
  	                        openSegmentPointWhatsappPanel(overlay, item);
  	                      }
  	                    }
  	                    : null
  	                  );
  	
  	                  if (pointLabel) {
  	                    runtime.pointLabelsByKey[item.key] = pointLabel;
  	                  }
  	                } catch (error) {
  	                  FIF_SILENT_CONSOLE.warn("[TrackIT Segmentation] Could not draw temporary point label.", {
  	                    item,
  	                    error
  	                  });
  	                }
  	              });
  	            }
  	
  	            function focusCardTemporarySegmentRow(childRow) {
  	              if (!childRow || !childRow.__trackitTemporarySegment) return false;
  	
  	              const runtime = getCardTemporarySegmentRuntime();
  	              const stored = runtime.polygonsByKey?.[childRow.__trackitSegmentKey] || null;
  	              const polygons = Array.isArray(stored) ? stored : stored ? [stored]: [];
  	
  	              if (!polygons.length || typeof google === "undefined" || !google?.maps?.LatLngBounds) return false;
  	
  	              try {
  	                const map = resolveGMap(MapRoot);
  	                const bounds = new google.maps.LatLngBounds();
  	
  	                if (!map) return false;
  	
  	                polygons.forEach(polygon => {
  	                  const paths = polygon?.getPaths ? polygon.getPaths(): null;
  	
  	                  if (!paths || typeof paths.getLength !== "function") return;
  	
  	                  for (let pathIndex = 0; pathIndex < paths.getLength(); pathIndex++) {
  	                    const path = paths.getAt(pathIndex);
  	
  	                    if (!path || typeof path.getLength !== "function") continue;
  	
  	                    for (let pointIndex = 0; pointIndex < path.getLength(); pointIndex++) {
  	                      bounds.extend(path.getAt(pointIndex));
  	                    }
  	                  }
  	                });
  	
  	                if (!(bounds.isEmpty && bounds.isEmpty()) && typeof map.fitBounds === "function") {
  	                  map.fitBounds(bounds);
  	                }
  	
  	                return true;
  	              } catch (_) {
  	                return false;
  	              }
  	            }
  	
  	            async function generateTemporarySegmentationForCard(rowData) {
  	              if (!rowData || !rowData.location) return;
  	
  	              const countInput = actionCard.querySelector("[data-card-segment-count]");
  	              const count = Number(countInput?.value || 0);
  	              const built = buildCardTemporarySegmentation(rowData, count);
  	
  	              if (!built.ok) {
  	                window.alert(built.reason || "Could not generate segments.");
  	                return;
  	              }
  	
  	              const data = ensureCardLocationData(rowData.location);
  	
  	              actionCard.__selectedTemporarySegmentNumber = 0;
  	
  	              built.segmentation.IsSaved = false;
  	              built.segmentation.SavedAt = null;
  	
  	              data.Segmentation = built.segmentation;
  	
  	              setCardSegmentsVisible(rowData, true);
  	
  	              refreshEditedLocationEverywhere(rowData, "location-temporary-segmentation-draft");
  	
  	              openLocationActionCard(rowData);
  	            }
  	
  	            async function saveTemporarySegmentationForCard(rowData) {
  	              if (!rowData || !rowData.location) return;
  	
  	              const data = ensureCardLocationData(rowData.location);
  	              const segmentation = data.Segmentation || data.segmentation || null;
  	
  	              const segments = Array.isArray(segmentation?.Segments)
  	              ? segmentation.Segments: Array.isArray(segmentation?.segments)
  	              ? segmentation.segments: [];
  	
  	              if (!segmentation || !segments.length) {
  	                window.alert("There are no temporary segments to save.");
  	                return;
  	              }
  	
  	              const saveButton = actionCard.querySelector('[data-card-action="saveSegments"]');
  	
  	              if (saveButton) {
  	                saveButton.disabled = true;
  	                saveButton.classList.add("saving");
  	                saveButton.textContent = "Saving...";
  	              }
  	
  	              const previousSaveState = {
  	                IsSaved: segmentation.IsSaved,
  	                IsTemporary: segmentation.IsTemporary,
  	                SaveStatus: segmentation.SaveStatus,
  	                SavedAt: segmentation.SavedAt,
  	                PointMigrationPending: segmentation.PointMigrationPending
  	              };
  	
  	              try {
  	                ensureCardSegmentationPointRegistry(rowData);
  	
  	                segmentation.IsSaved = true;
  	                segmentation.IsTemporary = false;
  	                segmentation.SaveStatus = "saved";
  	                segmentation.SavedAt = new Date().toISOString();
  	                segmentation.PointMigrationPending = false;
  	
  	                data.Segmentation = segmentation;
  	
  	                try {
  	                  delete data.segmentation;
  	                } catch (_) {
  	                  data.segmentation = null;
  	                }
  	
  	                const persistResult = await persistEditedLocationToBackendless(rowData.location);
  	
  	                if (!persistResult?.ok) {
  	                  throw new Error(persistResult?.reason || "The segmentation was not persisted.");
  	                }
  	
  	                refreshEditedLocationEverywhere(rowData, "location-temporary-segmentation-save-complete");
  	
  	                FIF_SILENT_CONSOLE.groupCollapsed("[TrackIT Segmentation] Saved Segments");
  	                FIF_SILENT_CONSOLE.log("Location:", rowData.location);
  	                FIF_SILENT_CONSOLE.log("Segmentation:", segmentation);
  	                FIF_SILENT_CONSOLE.log("Persist Result:", persistResult);
  	                FIF_SILENT_CONSOLE.groupEnd();
  	
  	                openLocationActionCard(rowData);
  	              } catch (error) {
  	                segmentation.IsSaved = previousSaveState.IsSaved;
  	                segmentation.IsTemporary = previousSaveState.IsTemporary;
  	                segmentation.SaveStatus = previousSaveState.SaveStatus || "failed";
  	                segmentation.SavedAt = previousSaveState.SavedAt;
  	                segmentation.PointMigrationPending = previousSaveState.PointMigrationPending;
  	
  	                FIF_SILENT_CONSOLE.error("[TrackIT Segmentation] Save failed.", error);
  	
  	                window.alert(
  	                  "The temporary segments could not be saved.\n\n" +
  	                  (error?.message || error?.faultString || "Unknown error")
  	                );
  	              } finally {
  	                if (saveButton) {
  	                  saveButton.disabled = false;
  	                  saveButton.classList.remove("saving");
  	                  saveButton.textContent = "Save Segments";
  	                }
  	              }
  	            }
  	
  	            async function clearTemporarySegmentationForCard(rowData) {
  	              if (!rowData || !rowData.location) return;
  	
  	              const data = ensureCardLocationData(rowData.location);
  	
  	              actionCard.__selectedTemporarySegmentNumber = 0;
  	
  	              try {
  	                delete data.Segmentation;
  	                delete data.segmentation;
  	              } catch (_) {
  	                data.Segmentation = null;
  	                data.segmentation = null;
  	              }
  	
  	              clearCardTemporarySegmentPolygons();
  	              refreshEditedLocationEverywhere(rowData, "location-temporary-segmentation-clear-local");
  	
  	              try {
  	                await persistEditedLocationToBackendless(rowData.location);
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Segmentation] Could not persist cleared segmentation. It remains cleared in memory.", error);
  	              }
  	
  	              openLocationActionCard(rowData);
  	            }
  	
  	            function cloneCardLocation(location) {
  	              try {
  	                return JSON.parse(JSON.stringify(location || {}));
  	              } catch (_) {
  	                return {};
  	              }
  	            }
  	
  	            function ensureCardLocationData(location) {
  	              if (!location) return {};
  	
  	              if (!location.LocationData || typeof location.LocationData !== "object") {
  	                location.LocationData = {};
  	              }
  	
  	              return location.LocationData;
  	            }
  	
  	            function getCardDescription(location) {
  	              const data = getLocationData(location);
  	
  	              return (
  	                data?.Description ||
  	                data?.description ||
  	                location?.Description ||
  	                location?.description ||
  	                ""
  	              );
  	            }
  	
  	            function getCardColor(location) {
  	              const color = safeString(
  	                location?.Color ||
  	                location?.color ||
  	                location?.Colour ||
  	                location?.colour ||
  	                ""
  	              ).trim();
  	
  	              if (/^#([0-9a-f]{6})$/i.test(color)) return color;
  	
  	              return "#cc6633";
  	            }
  	
  	            function filterCardPhoneValue(value) {
  	              let text = safeString(value);
  	
  	              text = text.replace(/[^\d+]/g, "");
  	
  	              if (text.includes("+")) {
  	                text = "+" + text.replace(/\+/g, "");
  	              }
  	
  	              if (text.length > 1) {
  	                text = text.charAt(0) === "+"
  	                ? "+" + text.slice(1).replace(/\+/g, ""): text.replace(/\+/g, "");
  	              }
  	
  	              return text;
  	            }
  	
  	            function getCardEditField(name) {
  	              return actionCard.querySelector(`[data-card-edit-field="${name}"]`);
  	            }
  	
  	            function getCardEditValue(name) {
  	              const field = getCardEditField(name);
  	              return field ? safeString(field.value): "";
  	            }
  	
  	            function setCardLocationValue(location, primaryKey, secondaryKey, value) {
  	              if (!location || typeof location !== "object") return;
  	
  	              location[primaryKey] = value;
  	
  	              if (secondaryKey && location[secondaryKey] !== undefined) {
  	                location[secondaryKey] = value;
  	              }
  	            }
  	
  	            function getCardLocationObjectId(location) {
  	              return safeString(
  	                location?.objectId ||
  	                location?.ObjectId ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function getCardLocationIdForRefresh(location) {
  	              return safeString(
  	                getLocationValue(location) ||
  	                location?.objectId ||
  	                location?.ObjectId ||
  	                location?.ID ||
  	                location?.id ||
  	                ""
  	              ).trim();
  	            }
  	
  	            async function persistEditedLocationToBackendless(location) {
  	              if (!location || typeof location !== "object") {
  	                return {
  	                  ok: false,
  	                  skipped: true,
  	                  reason: "No location object"
  	                };
  	              }
  	
  	              const objectId = getCardLocationObjectId(location);
  	
  	              if (!objectId) {
  	                return {
  	                  ok: false,
  	                  skipped: true,
  	                  reason: "No Backendless objectId"
  	                };
  	              }
  	
  	              if (
  	                typeof Backendless === "undefined" ||
  	                !Backendless ||
  	                !Backendless.Data ||
  	                typeof Backendless.Data.of !== "function"
  	              ) {
  	                return {
  	                  ok: false,
  	                  skipped: true,
  	                  reason: "Backendless Data unavailable"
  	                };
  	              }
  	
  	              normaliseEntranceFieldsForBackendless(location);
  	
  	              const payload = cloneCardLocation(location);
  	              payload.objectId = objectId;
  	
  	              normaliseEntranceFieldsForBackendless(payload);
  	
  	              const saved = await Backendless.Data.of("Locations").save(payload);
  	
  	              if (saved && typeof saved === "object") {
  	                Object.assign(location, saved);
  	              }
  	
  	              return {
  	                ok: true,
  	                skipped: false,
  	                saved
  	              };
  	            }
  	
  	            function refreshEditedLocationEverywhere(rowData, reason) {
  	              if (!rowData || !rowData.location) return;
  	
  	              const location = rowData.location;
  	              const id = getCardLocationIdForRefresh(location);
  	
  	              try {
  	                writeSelectedLocationToAppData(location);
  	              } catch (_) {}
  	
  	              try {
  	                const appData = getAppBag();
  	
  	                if (appData) {
  	                  appData.SelectedLocation = location;
  	                  appData.SelectedLocationObjectId = id || null;
  	                  appData.SelectedLocationMarker = id || null;
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                const runtime =
  	                typeof window !== "undefined"
  	                ? window.TrackITLocationMapRenderer ||
  	                window.TrackITLocationRendererRuntime ||
  	                window.__TrackITLocationRendererRuntime ||
  	                null: null;
  	
  	                if (runtime && id && runtime.polygonsById && runtime.polygonsById[id]) {
  	                  const polygon = runtime.polygonsById[id];
  	                  const color = getCardColor(location);
  	
  	                  polygon.__trackitLocationRendererLocation = location;
  	
  	                  if (typeof polygon.setOptions === "function") {
  	                    polygon.setOptions({
  	                      strokeColor: color,
  	                      fillColor: color
  	                    });
  	                  }
  	                }
  	
  	                if (runtime && typeof runtime.refresh === "function") {
  	                  runtime.refresh({
  	                    reason: reason || "location-edit-save",
  	                    doFitBounds: false
  	                  });
  	                } else if (typeof renderSavedLocationsOnMap === "function") {
  	                  renderSavedLocationsOnMap(MAP_INPUT, {
  	                    reason: reason || "location-edit-save",
  	                    doFitBounds: false
  	                  });
  	                }
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not refresh edited location on map.", error);
  	              }
  	
  	              try {
  	                if (typeof paintSelectedRow === "function") {
  	                  paintSelectedRow(rowData, false);
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                if (DATA_CHANNEL) {
  	                  DATA_CHANNEL.selectedLocation = {
  	                    marker: id || null,
  	                    objectId: id || null,
  	                    location
  	                  };
  	                }
  	              } catch (_) {}
  	
  	              notifyCarvedShellLayout();
  	              setTimeout(notifyCarvedShellLayout, 80);
  	              setTimeout(notifyCarvedShellLayout, 220);
  	            }
  	
  	            function applyLiveEditColorPreview(rowData, color) {
  	              if (!rowData || !rowData.location) return;
  	
  	              const cleanColor = safeString(color).trim();
  	
  	              if (!/^#([0-9a-f]{6})$/i.test(cleanColor)) return;
  	
  	              const location = rowData.location;
  	              const id = getCardLocationIdForRefresh(location);
  	
  	              setCardLocationValue(location, "Color", "color", cleanColor);
  	
  	              if (location.Colour !== undefined) location.Colour = cleanColor;
  	              if (location.colour !== undefined) location.colour = cleanColor;
  	
  	              try {
  	                const runtime =
  	                typeof window !== "undefined"
  	                ? window.TrackITLocationMapRenderer ||
  	                window.TrackITLocationRendererRuntime ||
  	                window.__TrackITLocationRendererRuntime ||
  	                null: null;
  	
  	                if (runtime && id && runtime.polygonsById && runtime.polygonsById[id]) {
  	                  const polygon = runtime.polygonsById[id];
  	
  	                  polygon.__trackitLocationRendererLocation = location;
  	
  	                  if (typeof polygon.setOptions === "function") {
  	                    polygon.setOptions({
  	                      strokeColor: cleanColor,
  	                      fillColor: cleanColor
  	                    });
  	                  }
  	                }
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not apply live colour preview.", error);
  	              }
  	            }
  	
  	            function restoreEditSnapshotAndRefresh(rowData, reason) {
  	              if (!rowData || !rowData.location) return false;
  	
  	              const snapshot = actionCard.__editSnapshot;
  	
  	              if (!snapshot) return false;
  	
  	              restoreLocationObject(rowData.location, snapshot);
  	
  	              const restoredName = safeString(
  	                rowData.location?.Name ||
  	                rowData.location?.name ||
  	                rowData.label ||
  	                ""
  	              );
  	
  	              if (restoredName) {
  	                rowData.label = restoredName;
  	                selectedLabel = restoredName;
  	                searchInput.value = restoredName;
  	              }
  	
  	              refreshEditedLocationEverywhere(rowData, reason || "location-edit-revert");
  	
  	              return true;
  	            }
  	
  	            function bindLocationEditCardLiveFields(rowData) {
  	              const nameInput = getCardEditField("name");
  	              const colorInput = getCardEditField("color");
  	              const colorPreview = actionCard.querySelector(".trackit-card-color-preview");
  	              const title = actionCard.querySelector(".trackit-action-card-title");
  	              const typeSelect = getCardEditField("locationType");
  	
  	              const typePicker = actionCard.querySelector("[data-card-location-type-picker]");
  	
  	              if (typePicker) {
  	                const hiddenInput = getCardEditField("locationType");
  	                const toggle = typePicker.querySelector("[data-card-location-type-toggle]");
  	                const menu = typePicker.querySelector("[data-card-location-type-menu]");
  	                const labelNode = typePicker.querySelector("[data-card-location-type-label]");
  	                const dotNode = typePicker.querySelector(".trackit-card-type-picker-button .trackit-card-type-picker-dot");
  	
  	                function resizeAfterTypePickerChange() {
  	                  try {
  	                    notifyCarvedShellLayout();
  	                  } catch (_) {}
  	
  	                  try {
  	                    bridge?.resizeTopShell?.();
  	                  } catch (_) {}
  	
  	                  try {
  	                    const carvedRoot =
  	                    bridge?.uiRoot ||
  	                    document.getElementById("fif-carved-edge-shape-ui");
  	                    if (carvedRoot && typeof scheduleSearchPanelHeight === "function") {
  	                      scheduleSearchPanelHeight(carvedRoot);
  	                    }
  	                  } catch (_) {}
  	                }
  	
  	                function closeTypePicker() {
  	                  typePicker.classList.remove("open");
  	                  resizeAfterTypePickerChange();
  	                  setTimeout(resizeAfterTypePickerChange, 80);
  	                }
  	
  	                function openTypePicker() {
  	                  typePicker.classList.add("open");
  	                  resizeAfterTypePickerChange();
  	                  setTimeout(resizeAfterTypePickerChange, 80);
  	                }
  	
  	                toggle?.addEventListener("click", event => {
  	                  event.preventDefault();
  	                  event.stopPropagation();
  	
  	                  if (typePicker.classList.contains("open")) {
  	                    closeTypePicker();
  	                  } else {
  	                    openTypePicker();
  	                  }
  	                });
  	
  	                menu?.querySelectorAll("[data-card-location-type-value]").forEach(button => {
  	                  button.addEventListener("click", event => {
  	                    event.preventDefault();
  	                    event.stopPropagation();
  	
  	                    const value = safeString(button.getAttribute("data-card-location-type-value")).trim();
  	
  	                    if (value === ADD_NEW_LOCATION_TYPE_VALUE) {
  	                      closeTypePicker();
  	                      openLocationTypeManagerFromEditCard(rowData);
  	                      return;
  	                    }
  	
  	                    const selectedType = getCardLocationTypeOptionByValue(rowData, value);
  	
  	                    if (!selectedType || !hiddenInput) {
  	                      closeTypePicker();
  	                      return;
  	                    }
  	
  	                    hiddenInput.value = selectedType.value;
  	
  	                    if (labelNode) {
  	                      labelNode.textContent = selectedType.label;
  	                    }
  	
  	                    if (dotNode) {
  	                      dotNode.style.background = normalizeLocationTypeColorValue(selectedType.color);
  	                    }
  	
  	                    menu.querySelectorAll(".trackit-card-type-picker-option").forEach(option => {
  	                      option.classList.remove("is-selected");
  	                    });
  	
  	                    button.classList.add("is-selected");
  	
  	                    const colorInput = getCardEditField("color");
  	
  	                    if (colorInput) {
  	                      colorInput.value = normalizeLocationTypeColorValue(selectedType.color);
  	                      colorInput.dispatchEvent(new Event("change", {
  	                        bubbles: true
  	                      }));
  	                    }
  	
  	                    closeTypePicker();
  	                  });
  	                });
  	
  	                document.addEventListener("click", event => {
  	                  if (!typePicker.contains(event.target)) {
  	                    closeTypePicker();
  	                  }
  	                });
  	              }
  	
  	              if (nameInput && title) {
  	                nameInput.addEventListener("input", () => {
  	                  const nextName = safeString(nameInput.value).trim();
  	                  title.textContent = nextName || rowData?.label || "Location";
  	                });
  	              }
  	
  	              if (colorInput) {
  	                const applyColor = () => {
  	                  const nextColor = safeString(colorInput.value).trim() || "#cc6633";
  	
  	                  if (colorPreview) {
  	                    colorPreview.style.background = nextColor;
  	                  }
  	
  	                  applyLiveEditColorPreview(rowData, nextColor);
  	                };
  	
  	                colorInput.addEventListener("input", applyColor);
  	                colorInput.addEventListener("change", applyColor);
  	
  	                applyColor();
  	              }
  	            }
  	
  	            function cardEditField(label, fieldHtml) {
  	              return `
  	              <div class="trackit-card-edit-field">
  	              <div class="trackit-card-edit-label">${escapeHtml(label)}</div>
  	              ${fieldHtml}
  	              </div>
  	              `;
  	            }
  	
  	            function getCardCompanyRecord(rowData) {
  	              if (rowData?.companyEntry?.company) {
  	                return rowData.companyEntry.company;
  	              }
  	
  	              const location = rowData?.location || null;
  	              const locationId = safeString(getLocationValue(location)).trim();
  	
  	              if (!locationId) return null;
  	
  	              const allCompanies =
  	              Array.isArray(companies)
  	              ? companies: Array.isArray(DATA_CHANNEL?.companies)
  	              ? DATA_CHANNEL.companies: [];
  	
  	              for (let c = 0; c < allCompanies.length; c++) {
  	                const company = allCompanies[c];
  	                const companyLocations = flattenLocations(getCompanyLocations(company));
  	
  	                const found = companyLocations.some(item => {
  	                  return safeString(getLocationValue(item)).trim() === locationId;
  	                });
  	
  	                if (found) return company;
  	              }
  	
  	              return null;
  	            }
  	
  	            function getCardCompanyValue(rowData) {
  	              const company = getCardCompanyRecord(rowData);
  	
  	              if (company) {
  	                return safeString(
  	                  company.objectId ||
  	                  company.ObjectId ||
  	                  company.id ||
  	                  company.ID ||
  	                  getCompanyId(company, 0) ||
  	                  ""
  	                ).trim();
  	              }
  	
  	              return safeString(
  	                rowData?.companyEntry?.value ||
  	                rowData?.companyEntry?.id ||
  	                rowData?.companyEntry?.key ||
  	                createState.company ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function getCardCurrentTypeName(rowData) {
  	              const location = rowData?.location || null;
  	
  	              return safeString(
  	                getCardType(location, rowData) ||
  	                getLocationTypeName(location) ||
  	                location?.Type ||
  	                location?.type ||
  	                location?.LocationType ||
  	                location?.locationType ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function getCardLocationTypeOptions(rowData) {
  	              const company = getCardCompanyRecord(rowData);
  	
  	              if (!company) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Edit] Could not resolve field company for Location Type list.", {
  	                  rowData
  	                });
  	
  	                return [];
  	              }
  	
  	              const manifest = getCompanyManifest(company);
  	
  	              if (!manifest) return [];
  	
  	              if (!Array.isArray(manifest.LocationTypes)) {
  	                manifest.LocationTypes = [];
  	              }
  	
  	              return manifest.LocationTypes
  	              .map(record => {
  	                const normal = normalizeManifestLocationTypeRecord(record);
  	
  	                if (!normal) return null;
  	
  	                const label = safeString(normal.TypeName || normal.Name || normal.Label).trim();
  	
  	                if (!label) return null;
  	
  	                return {
  	                  value: safeString(normal.Value || createLocationTypeValue(label)).trim(),
  	                  label,
  	                  color: normalizeLocationTypeColorValue(normal.Color || DEFAULT_NEW_LOCATION_TYPE_COLOR),
  	                  raw: normal
  	                };
  	              })
  	              .filter(Boolean)
  	              .filter(option => option.value !== ADD_NEW_LOCATION_TYPE_VALUE)
  	              .sort((a, b) => a.label.localeCompare(b.label, undefined, {
  	                numeric: true,
  	                sensitivity: "base"
  	              }));
  	            }
  	
  	            function getCardLocationTypeValue(rowData) {
  	              const currentTypeName = getCardCurrentTypeName(rowData);
  	              const options = getCardLocationTypeOptions(rowData);
  	
  	              const found = options.find(option => {
  	                return safeString(option.label).trim().toLowerCase() === currentTypeName.toLowerCase();
  	              });
  	
  	              if (found) return found.value;
  	
  	              return options[0]?.value || "";
  	            }
  	
  	            function getCardLocationTypeOptionByValue(rowData, value) {
  	              const target = safeString(value).trim();
  	
  	              if (!target) return null;
  	
  	              return getCardLocationTypeOptions(rowData).find(option => {
  	                return safeString(option.value).trim() === target;
  	              }) || null;
  	            }
  	
  	            function buildCardLocationTypeSelect(rowData) {
  	              const options = getCardLocationTypeOptions(rowData);
  	              const selectedValue = getCardLocationTypeValue(rowData);
  	
  	              const selectedOption = options.find(option => {
  	                return safeString(option.value) === safeString(selectedValue);
  	              }) || options[0] || null;
  	
  	              const selectedLabel = selectedOption?.label || "Select Location Type";
  	              const selectedColor = normalizeLocationTypeColorValue(
  	                selectedOption?.color || DEFAULT_NEW_LOCATION_TYPE_COLOR
  	              );
  	
  	              return `
  	              <div class="trackit-card-type-picker" data-card-location-type-picker>
  	              <input
  	              type="hidden"
  	              data-card-edit-field="locationType"
  	              value="${escapeHtml(selectedOption?.value || "")}"
  	              />
  	
  	              <button
  	              class="trackit-card-type-picker-button"
  	              type="button"
  	              data-card-location-type-toggle
  	              >
  	              <span class="trackit-card-type-picker-dot" style="background:${escapeHtml(selectedColor)};"></span>
  	
  	              <span class="trackit-card-type-picker-label" data-card-location-type-label>
  	              ${escapeHtml(selectedLabel)}
  	              </span>
  	
  	              <span class="trackit-card-type-picker-caret">⌄</span>
  	              </button>
  	
  	              <div class="trackit-card-type-picker-menu" data-card-location-type-menu>
  	              <button
  	              class="trackit-card-type-picker-option is-add"
  	              type="button"
  	              data-card-location-type-value="${escapeHtml(ADD_NEW_LOCATION_TYPE_VALUE)}"
  	              >
  	              <span class="trackit-card-type-picker-add-icon">+</span>
  	              <span>Add New Location Type</span>
  	              </button>
  	
  	              ${options.map(option => `
  	                <button
  	                class="trackit-card-type-picker-option ${safeString(option.value) === safeString(selectedValue) ? "is-selected": ""}"
  	                type="button"
  	                data-card-location-type-value="${escapeHtml(option.value)}"
  	                data-card-location-type-label="${escapeHtml(option.label)}"
  	                data-card-location-type-color="${escapeHtml(option.color)}"
  	                >
  	                <span class="trackit-card-type-picker-dot" style="background:${escapeHtml(option.color)};"></span>
  	                <span>${escapeHtml(option.label)}</span>
  	                </button>
  	                `).join("")}
  	              </div>
  	              </div>
  	              `;
  	            }
  	
  	            function openLocationTypeManagerFromEditCard(rowData) {
  	              const company = getCardCompanyRecord(rowData);
  	              const companyValue = getCardCompanyValue(rowData);
  	
  	              if (!company || !companyValue) {
  	                window.alert("Cannot add a type because this location has no company context.");
  	                return;
  	              }
  	
  	              getCompanyManifest(company);
  	
  	              createState.company = companyValue;
  	              createState.typeManagerSource = "location-edit";
  	              createState.typeManagerReturnRowData = rowData;
  	
  	              createState.typeManagerName = "";
  	              createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	              createState.typeManagerOriginalName = "";
  	              createState.modalMode = "locationTypeManager";
  	              createState.helpTopic = "";
  	
  	              const carvedRoot =
  	              bridge?.uiRoot ||
  	              document.getElementById("fif-carved-edge-shape-ui");
  	              if (!carvedRoot) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not open Location Type Manager from edit card. Carved UI root not found.");
  	                return;
  	              }
  	
  	              renderModal(carvedRoot);
  	            }
  	
  	            function applySavedLocationTypeToEditCard(rowData, savedType) {
  	              if (!rowData || !savedType) return;
  	
  	              const select = getCardEditField("locationType");
  	              const colorInput = getCardEditField("color");
  	
  	              if (select) {
  	                const savedValue = safeString(savedType.value || createLocationTypeValue(savedType.label)).trim();
  	
  	                const existingOption = Array.from(select.options || []).find(option => {
  	                  return option.value === savedValue;
  	                });
  	
  	                if (!existingOption) {
  	                  const option = document.createElement("option");
  	                  option.value = savedValue;
  	                  option.textContent = safeString(savedType.label || savedType.TypeName || "New Type");
  	                  select.insertBefore(option, select.querySelector(`option[value="${ADD_NEW_LOCATION_TYPE_VALUE}"]`) || null);
  	                }
  	
  	                select.value = savedValue;
  	              }
  	
  	              if (colorInput) {
  	                const color = normalizeLocationTypeColorValue(savedType.color || savedType.Color || DEFAULT_NEW_LOCATION_TYPE_COLOR);
  	                colorInput.value = color;
  	              }
  	            }
  	
  	            function buildCardEditForm(rowData) {
  	              const location = rowData.location;
  	
  	              const name = safeString(
  	                location?.Name ||
  	                location?.name ||
  	                rowData.label ||
  	                ""
  	              );
  	
  	              const color = getCardColor(location);
  	              const description = safeString(getCardDescription(location));
  	              const contactName = safeString(getCardContactName(location));
  	              const contactNumber = safeString(getCardContactNumber(location));
  	
  	              return `
  	              <div class="trackit-card-edit-tools">
  	              <button class="trackit-card-tool-button" type="button" data-card-action="editShape">
  	              ✦ Edit Shape
  	              </button>
  	
  	              <button class="trackit-card-tool-button" type="button" data-card-action="setEntrance">
  	              ✦ Set Entrance
  	              </button>
  	
  	              <button class="trackit-card-tool-button" type="button" data-card-action="setFunctionality">
  	              ⚙ Set Functionality
  	              </button>
  	              </div>
  	
  	              <div class="trackit-card-edit-form">
  	              ${cardEditField("Name", `
  	                <input
  	                class="trackit-card-edit-input"
  	                type="text"
  	                value="${escapeHtml(name)}"
  	                data-card-edit-field="name"
  	                autocomplete="off"
  	                />
  	                `)}
  	
  	              ${cardEditField("Location Type", `
  	                ${buildCardLocationTypeSelect(rowData)}
  	                `)}
  	
  	              ${cardEditField("Color", `
  	                <div class="trackit-card-color-wrap">
  	                <input
  	                class="trackit-card-edit-color"
  	                type="color"
  	                value="${escapeHtml(color)}"
  	                data-card-edit-field="color"
  	                />
  	
  	                <div class="trackit-card-color-preview" style="background:${escapeHtml(color)}"></div>
  	                </div>
  	                `)}
  	
  	              ${cardEditField("Description", `
  	                <textarea
  	                class="trackit-card-edit-textarea"
  	                data-card-edit-field="description"
  	                autocomplete="off"
  	                >${escapeHtml(description)}</textarea>
  	                `)}
  	
  	              ${cardEditField("Contact Name", `
  	                <input
  	                class="trackit-card-edit-input"
  	                type="text"
  	                value="${escapeHtml(contactName)}"
  	                data-card-edit-field="contactName"
  	                autocomplete="off"
  	                placeholder="Contact Name"
  	                />
  	                `)}
  	
  	              ${cardEditField("Contact Number", `
  	                <input
  	                class="trackit-card-edit-input"
  	                type="tel"
  	                inputmode="tel"
  	                autocomplete="tel"
  	                value="${escapeHtml(contactNumber)}"
  	                data-card-edit-field="contactNumber"
  	                placeholder="+27821234567"
  	                />
  	                `)}
  	              </div>
  	              `;
  	            }
  	
  	            function normalizeCardFunctionality(location) {
  	              const data = ensureCardLocationData(location);
  	
  	              if (!data.Functionality || typeof data.Functionality !== "object") {
  	                data.Functionality = {};
  	              }
  	
  	              const functionality = data.Functionality;
  	
  	              return {
  	                eventsCapture:
  	                functionality.EventsCapture === true ||
  	                functionality.eventsCapture === true,
  	
  	                fuelLogic:
  	                functionality.FuelLogic === true ||
  	                functionality.fuelLogic === true,
  	
  	                loadLogic:
  	                functionality.LoadLogic === true ||
  	                functionality.loadLogic === true,
  	
  	                gateLogic:
  	                functionality.GateLogic === true ||
  	                functionality.gateLogic === true,
  	
  	                publicFuelStation:
  	                functionality.PublicFuelStation === true ||
  	                functionality.publicFuelStation === true,
  	
  	                fuelDepot:
  	                functionality.FuelDepot === true ||
  	                functionality.fuelDepot === true,
  	
  	                gatePhone: safeString(
  	                  functionality.GatePhone ||
  	                  functionality.gatePhone ||
  	                  ""
  	                )
  	              };
  	            }
  	
  	            function functionalityToggleRow(key, title, subtitle, checked, helpText) {
  	              return `
  	              <div class="trackit-card-functionality-row">
  	              <label class="trackit-card-functionality-main">
  	              <input
  	              type="checkbox"
  	              data-card-functionality-key="${escapeHtml(key)}"
  	              ${checked ? "checked": ""}
  	              />
  	
  	              <span class="trackit-card-functionality-box"></span>
  	
  	              <span class="trackit-card-functionality-text">
  	              <span class="trackit-card-functionality-title">${escapeHtml(title)}</span>
  	              <span class="trackit-card-functionality-subtitle">${escapeHtml(subtitle)}</span>
  	              </span>
  	              </label>
  	
  	              <button
  	              class="trackit-card-functionality-help"
  	              type="button"
  	              data-card-action="functionalityHelp"
  	              data-functionality-help-title="${escapeHtml(title)}"
  	              data-functionality-help-body="${escapeHtml(helpText)}"
  	              >?</button>
  	              </div>
  	              `;
  	            }
  	
  	            function openLocationFunctionalityCard(rowData) {
  	              if (!rowData) return;
  	
  	              const location = rowData.location;
  	              const functionality = normalizeCardFunctionality(location);
  	
  	              actionCard.__functionalityRowData = rowData;
  	
  	              actionCard.innerHTML = `
  	              <div class="trackit-action-card-header no-location-icon is-functionality">
  	              <div class="trackit-action-card-top-row">
  	              <button class="trackit-action-card-save" type="button" data-card-action="saveFunctionality" title="Save">🖫</button>
  	              <button class="trackit-action-card-close" type="button" data-card-close title="Close">×</button>
  	              </div>
  	
  	              <div class="trackit-action-card-title-wrap">
  	              <div class="trackit-action-card-title">Location Functionality</div>
  	              <div class="trackit-action-card-edit-subtitle">Configure Logic</div>
  	              </div>
  	              </div>
  	
  	              <div class="trackit-action-card-body">
  	              <div class="trackit-card-functionality-form">
  	              ${functionalityToggleRow(
  	                "eventsCapture",
  	                "Events Capture",
  	                "Capture events at this location",
  	                functionality.eventsCapture,
  	                "Allows this location to capture operational events such as arrivals, departures, delays, exceptions, inspections, notes, and activity records."
  	              )}
  	
  	              ${functionalityToggleRow(
  	                "fuelLogic",
  	                "Fuel Logic",
  	                "Enable fuel behaviour",
  	                functionality.fuelLogic,
  	                "Adds fuel-related behaviour to this location. Choose either Public Fuel Station or Depot. Only one fuel mode can be active."
  	              )}
  	
  	              <div class="trackit-card-functionality-fuel-options ${functionality.fuelLogic ? "open": ""}">
  	              ${functionalityToggleRow(
  	                "publicFuelStation",
  	                "Public Fuel Station",
  	                "External or commercial fuel point",
  	                functionality.publicFuelStation,
  	                "Marks the location as a public fuel station where vehicles can refuel through an external or commercial fuel provider."
  	              )}
  	
  	              ${functionalityToggleRow(
  	                "fuelDepot",
  	                "Depot",
  	                "Internal controlled fuel point",
  	                functionality.fuelDepot,
  	                "Marks the location as a company depot or internal controlled fuel point."
  	              )}
  	              </div>
  	
  	              ${
  	              SHOW_LOAD_AND_GATE_FUNCTIONALITY_OPTIONS
  	              ? `
  	              ${functionalityToggleRow(
  	                "loadLogic",
  	                "Load Logic",
  	                "Enable loading behaviour",
  	                functionality.loadLogic,
  	                "Adds load handling behaviour to this location. Use this for loading points, offloading points, collection areas, dispatch areas, or stock movement."
  	              )}
  	
  	              ${functionalityToggleRow(
  	                "gateLogic",
  	                "Gate Logic",
  	                "Enable gate contact logic",
  	                functionality.gateLogic,
  	                "Adds gate-related behaviour to this location. For now this captures a contact number for future gate communication or access-control functionality."
  	              )}
  	
  	              <div class="trackit-card-functionality-gate-phone ${functionality.gateLogic ? "open": ""}">
  	              <div class="trackit-card-edit-label">Gate Phone</div>
  	              <input
  	              class="trackit-card-edit-input trackit-card-functionality-phone"
  	              type="tel"
  	              inputmode="tel"
  	              autocomplete="tel"
  	              value="${escapeHtml(functionality.gatePhone)}"
  	              placeholder="+27821234567"
  	              data-card-functionality-phone
  	              />
  	              </div>
  	              `: `
  	              <!-- Load Logic and Gate Logic are temporarily hidden from Location Edit. -->
  	              `
  	              }
  	
  	              <div class="trackit-card-functionality-help-panel" data-card-functionality-help-panel></div>
  	              </div>
  	              </div>
  	              `;
  	
  	              actionCard.classList.add("open");
  	              actionCard.classList.add("editing");
  	
  	              const carvedRoot =
  	              bridge?.uiRoot ||
  	              document.getElementById("fif-carved-edge-shape-ui");
  	              function forceEditCardPanelResize() {
  	                try {
  	                  actionCard.style.maxHeight = "none";
  	                  actionCard.style.overflowY = "visible";
  	                } catch (_) {}
  	
  	                try {
  	                  notifyCarvedShellLayout();
  	                } catch (_) {}
  	
  	                try {
  	                  bridge?.resizeTopShell?.();
  	                } catch (_) {}
  	
  	                try {
  	                  if (carvedRoot && typeof scheduleSearchPanelHeight === "function") {
  	                    scheduleSearchPanelHeight(carvedRoot);
  	                  }
  	                } catch (_) {}
  	
  	                try {
  	                  window.dispatchEvent(new CustomEvent("trackitMapControlLayoutChanged"));
  	                } catch (_) {}
  	              }
  	
  	              forceEditCardPanelResize();
  	
  	              requestAnimationFrame(forceEditCardPanelResize);
  	
  	              [40,
  	                120,
  	                260,
  	                520,
  	                900].forEach(delay => {
  	                  setTimeout(forceEditCardPanelResize, delay);
  	                });
  	
  	              bindLocationEditCardLiveFields(rowData);
  	
  	              requestAnimationFrame(forceEditCardPanelResize);
  	              setTimeout(forceEditCardPanelResize, 180);
  	              setTimeout(forceEditCardPanelResize, 420);
  	
  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "openEdit",
  	                cardType: "location-edit-card",
  	                placeholder: false
  	              });
  	            }
  	
  	            function saveLocationFunctionalityCard(rowData) {
  	              if (!rowData) return;
  	
  	              const location = rowData.location;
  	              const data = ensureCardLocationData(location);
  	
  	              data.Functionality = data.Functionality || {};
  	
  	              const functionality = data.Functionality;
  	
  	              const eventsInput = actionCard.querySelector('[data-card-functionality-key="eventsCapture"]');
  	              const fuelInput = actionCard.querySelector('[data-card-functionality-key="fuelLogic"]');
  	              const publicInput = actionCard.querySelector('[data-card-functionality-key="publicFuelStation"]');
  	              const depotInput = actionCard.querySelector('[data-card-functionality-key="fuelDepot"]');
  	              const loadInput = actionCard.querySelector('[data-card-functionality-key="loadLogic"]');
  	              const gateInput = actionCard.querySelector('[data-card-functionality-key="gateLogic"]');
  	              const gatePhoneInput = actionCard.querySelector("[data-card-functionality-phone]");
  	
  	              functionality.EventsCapture = !!eventsInput?.checked;
  	              functionality.FuelLogic = !!fuelInput?.checked;
  	
  	              // Hidden options are left untouched so existing Load/Gate settings are preserved.
  	              if (loadInput) {
  	                functionality.LoadLogic = !!loadInput.checked;
  	              }
  	
  	              if (gateInput) {
  	                functionality.GateLogic = !!gateInput.checked;
  	                functionality.GatePhone = functionality.GateLogic
  	                ? filterCardPhoneValue(gatePhoneInput?.value || ""): "";
  	              }
  	
  	              functionality.PublicFuelStation = functionality.FuelLogic && !!publicInput?.checked;
  	              functionality.FuelDepot = functionality.FuelLogic && !!depotInput?.checked;
  	
  	              functionality.FuelMode = functionality.FuelLogic
  	              ? functionality.PublicFuelStation
  	              ? "publicFuelStation": functionality.FuelDepot
  	              ? "depot": "": "";
  	
  	              writeSelectedLocationToAppData(location);
  	
  	              FIF_SILENT_CONSOLE.groupCollapsed("[TrackIT Location Dropdown] Save Functionality");
  	              FIF_SILENT_CONSOLE.log("Location:", location);
  	              FIF_SILENT_CONSOLE.log("Functionality:", functionality);
  	              FIF_SILENT_CONSOLE.groupEnd();
  	
  	              emitRouterEvent(ROUTER_EVENTS.functionalityRequested, rowData, {
  	                action: "saveFunctionality",
  	                cardType: "location-functionality-card",
  	                functionality
  	              });
  	
  	              actionCard.classList.remove("functionality-editing");
  	              openLocationEditCard(rowData);
  	            }
  	
  	            function updateFunctionalityVisibility() {
  	              const fuelInput = actionCard.querySelector('[data-card-functionality-key="fuelLogic"]');
  	              const publicInput = actionCard.querySelector('[data-card-functionality-key="publicFuelStation"]');
  	              const depotInput = actionCard.querySelector('[data-card-functionality-key="fuelDepot"]');
  	              const gateInput = actionCard.querySelector('[data-card-functionality-key="gateLogic"]');
  	
  	              const fuelOptions = actionCard.querySelector(".trackit-card-functionality-fuel-options");
  	              const gatePhone = actionCard.querySelector(".trackit-card-functionality-gate-phone");
  	
  	              if (fuelOptions) {
  	                fuelOptions.classList.toggle("open", !!fuelInput?.checked);
  	              }
  	
  	              if (!fuelInput?.checked) {
  	                if (publicInput) publicInput.checked = false;
  	                if (depotInput) depotInput.checked = false;
  	              }
  	
  	              if (gatePhone) {
  	                gatePhone.classList.toggle("open", !!gateInput?.checked);
  	              }
  	
  	              if (!gateInput?.checked) {
  	                const gatePhoneInput = actionCard.querySelector("[data-card-functionality-phone]");
  	                if (gatePhoneInput) gatePhoneInput.value = "";
  	              }
  	
  	              notifyCarvedShellLayout();
  	            }
  	
  	            function getLocationFunctionalityForPopup(location) {
  	              const data = ensureCardLocationData(location);
  	              const functionality =
  	              data.Functionality ||
  	              data.functionality ||
  	              location?.Functionality ||
  	              location?.functionality ||
  	              {};
  	
  	              return {
  	                eventsCapture:
  	                functionality.EventsCapture === true ||
  	                functionality.eventsCapture === true,
  	
  	                fuelLogic:
  	                functionality.FuelLogic === true ||
  	                functionality.fuelLogic === true,
  	
  	                publicFuelStation:
  	                functionality.PublicFuelStation === true ||
  	                functionality.publicFuelStation === true,
  	
  	                fuelDepot:
  	                functionality.FuelDepot === true ||
  	                functionality.fuelDepot === true,
  	
  	                loadLogic:
  	                functionality.LoadLogic === true ||
  	                functionality.loadLogic === true,
  	
  	                gateLogic:
  	                functionality.GateLogic === true ||
  	                functionality.gateLogic === true,
  	
  	                gatePhone: safeString(
  	                  functionality.GatePhone ||
  	                  functionality.gatePhone ||
  	                  ""
  	                )
  	              };
  	            }
  	
  	            function openOriginalFunctionalityPopupFromCard(rowData) {
  	              if (!rowData || !rowData.location) return;
  	
  	              const location = rowData.location;
  	              const functionality = getLocationFunctionalityForPopup(location);
  	
  	              createState.functionality.eventsCapture = functionality.eventsCapture;
  	              createState.functionality.fuelLogic = functionality.fuelLogic;
  	              createState.functionality.publicFuelStation = functionality.publicFuelStation;
  	              createState.functionality.fuelDepot = functionality.fuelDepot;
  	              createState.functionality.loadLogic = functionality.loadLogic;
  	              createState.functionality.gateLogic = functionality.gateLogic;
  	              createState.functionality.gatePhone = functionality.gatePhone;
  	
  	              createState.modalMode = "functionality";
  	              createState.helpTopic = "";
  	
  	              if (window.__CarvedEdgeShapeUI) {
  	                window.__CarvedEdgeShapeUI.pendingSaveLocation = location;
  	                window.__CarvedEdgeShapeUI.pendingFunctionalityRowData = rowData;
  	                window.__CarvedEdgeShapeUI.pendingFunctionalitySource = "location-card";
  	
  	                window.__CarvedEdgeShapeUI.afterFunctionalitySave = function () {
  	                  try {
  	                    openLocationEditCard(rowData);
  	                  } catch (error) {
  	                    FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not return to edit card after functionality save.", error);
  	                  }
  	                };
  	              }
  	
  	              const carvedRoot =
  	              bridge?.uiRoot ||
  	              document.getElementById("fif-carved-edge-shape-ui");
  	              if (!carvedRoot) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not open original functionality popup. Carved UI root not found.");
  	                return;
  	              }
  	
  	              renderModal(carvedRoot);
  	            }
  	
  	            function openLocationEditCard(rowData) {
  	              if (!rowData) return;
  	
  	              const location = rowData.location;
  	
  	              actionCard.__editRowData = rowData;
  	              actionCard.__editSnapshot = cloneCardLocation(location);
  	
  	              actionCard.innerHTML = `
  	              <div class="trackit-action-card-header no-location-icon is-editing">
  	              <div class="trackit-action-card-top-row">
  	              <button class="trackit-action-card-delete" type="button" data-card-action="deleteLocation" title="Delete">🗑</button>
  	              <button class="trackit-action-card-undo" type="button" data-card-action="undoEdit" title="Undo">↩</button>
  	              <button class="trackit-action-card-save" type="button" data-card-action="saveEdit" title="Save">🖫</button>
  	              <button class="trackit-action-card-close" type="button" data-card-close title="Close">×</button>
  	              </div>
  	
  	              <div class="trackit-action-card-title-wrap">
  	              <div class="trackit-action-card-title">${escapeHtml(rowData.label)}</div>
  	              <div class="trackit-action-card-edit-subtitle">Edit Location</div>
  	              </div>
  	              </div>
  	
  	              <div class="trackit-action-card-body">
  	              ${buildCardEditForm(rowData)}
  	              </div>
  	              `;
  	
  	              actionCard.classList.add("open");
  	              actionCard.classList.add("editing");
  	
  	              const carvedRoot =
  	              bridge?.uiRoot ||
  	              document.getElementById("fif-carved-edge-shape-ui");
  	              function forceEditCardPanelResize() {
  	                try {
  	                  actionCard.style.maxHeight = "none";
  	                  actionCard.style.height = "auto";
  	                  actionCard.style.overflowY = "visible";
  	                  actionCard.style.overflow = "visible";
  	
  	                  const editBody = actionCard.querySelector(".trackit-action-card-body");
  	
  	                  if (editBody) {
  	                    editBody.style.maxHeight = "none";
  	                    editBody.style.height = "auto";
  	                    editBody.style.overflowY = "visible";
  	                    editBody.style.overflow = "visible";
  	                  }
  	                } catch (_) {}
  	
  	                try {
  	                  notifyCarvedShellLayout();
  	                } catch (_) {}
  	
  	                try {
  	                  bridge?.resizeTopShell?.();
  	                } catch (_) {}
  	
  	                try {
  	                  if (carvedRoot && typeof scheduleSearchPanelHeight === "function") {
  	                    scheduleSearchPanelHeight(carvedRoot);
  	                  }
  	                } catch (_) {}
  	
  	                try {
  	                  window.dispatchEvent(new CustomEvent("trackitMapControlLayoutChanged"));
  	                } catch (_) {}
  	              }
  	
  	              forceEditCardPanelResize();
  	
  	              requestAnimationFrame(forceEditCardPanelResize);
  	              [40,
  	                120,
  	                260,
  	                520].forEach(delay => {
  	                  setTimeout(forceEditCardPanelResize, delay);
  	                });
  	
  	              bindLocationEditCardLiveFields(rowData);
  	
  	              requestAnimationFrame(forceEditCardPanelResize);
  	              setTimeout(forceEditCardPanelResize, 160);
  	
  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "openEdit",
  	                cardType: "location-edit-card",
  	                placeholder: false
  	              });
  	            }
  	
  	            function restoreLocationObject(target, snapshot) {
  	              if (!target || !snapshot) return;
  	
  	              try {
  	                Object.keys(target).forEach(key => {
  	                  delete target[key];
  	                });
  	
  	                Object.keys(snapshot).forEach(key => {
  	                  target[key] = snapshot[key];
  	                });
  	              } catch (_) {}
  	            }
  	
  	            async function saveLocationEditCard(rowData) {
  	              if (!rowData || !rowData.location) return;
  	
  	              const location = rowData.location;
  	              const data = ensureCardLocationData(location);
  	
  	              const saveButton = actionCard.querySelector('[data-card-action="saveEdit"]');
  	
  	              const name = getCardEditValue("name").trim();
  	
  	              const selectedTypeValue = getCardEditValue("locationType").trim();
  	              const selectedType = getCardLocationTypeOptionByValue(rowData, selectedTypeValue);
  	              const selectedTypeName = safeString(selectedType?.label || getCardCurrentTypeName(rowData)).trim();
  	              const selectedTypeColor = normalizeLocationTypeColorValue(selectedType?.color || getCardEditValue("color"));
  	
  	              const color = getCardEditValue("color").trim() || selectedTypeColor || "#cc6633";
  	              const description = getCardEditValue("description");
  	              const contactName = getCardEditValue("contactName").trim();
  	              const contactNumber = filterCardPhoneValue(getCardEditValue("contactNumber"));
  	
  	              if (!name) {
  	                window.alert("Please enter a location name.");
  	                const nameInput = getCardEditField("name");
  	
  	                if (nameInput && typeof nameInput.focus === "function") {
  	                  nameInput.focus();
  	                }
  	
  	                return;
  	              }
  	
  	              if (saveButton) {
  	                saveButton.disabled = true;
  	                saveButton.classList.add("saving");
  	              }
  	
  	              try {
  	                setCardLocationValue(location, "Name", "name", name);
  	
  	                if (selectedTypeName) {
  	                  data.Type = selectedTypeName;
  	                  data.type = selectedTypeName;
  	                  data.LocationType = selectedTypeName;
  	                  data.locationType = selectedTypeName;
  	                  data.Color = color;
  	                  data.color = color;
  	                }
  	
  	                data.ContactName = contactName;
  	                data.contactName = contactName;
  	
  	                data.ContactNumber = contactNumber;
  	                data.contactNumber = contactNumber;
  	
  	                rowData.label = name;
  	                selectedLabel = name;
  	                searchInput.value = name;
  	
  	                refreshEditedLocationEverywhere(rowData, "location-edit-save-local");
  	
  	                const persistResult = await persistEditedLocationToBackendless(location);
  	
  	                if (persistResult && persistResult.ok) {
  	                  await syncSavedLocationWithFlespi("update", location);
  	                } else {
  	                  console.error("[FIF FlespiSync] Location edit not persisted, cannot synchronize", persistResult);
  	                  window.alert("Location edit was not saved in Backendless, so Flespi was not updated: " +
  	                    (persistResult?.reason || "Unknown reason"));
  	                }
  	
  	                refreshEditedLocationEverywhere(rowData, "location-edit-save-complete");
  	
  	                FIF_SILENT_CONSOLE.groupCollapsed("[TrackIT Location Dropdown] Save Edit");
  	                FIF_SILENT_CONSOLE.log("Location:", location);
  	                FIF_SILENT_CONSOLE.log("Row Data:", rowData);
  	                FIF_SILENT_CONSOLE.log("Persist Result:", persistResult);
  	                FIF_SILENT_CONSOLE.log("Saved Fields:", {
  	                  name,
  	                  selectedTypeName,
  	                  color,
  	                  description,
  	                  contactName,
  	                  contactNumber
  	                });
  	                FIF_SILENT_CONSOLE.groupEnd();
  	
  	                emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                  action: "saveEdit",
  	                  cardType: "location-edit-card",
  	                  placeholder: false,
  	                  persisted: !!persistResult.ok,
  	                  skippedPersistence: !!persistResult.skipped,
  	                  persistenceReason: persistResult.reason || ""
  	                });
  	
  	                actionCard.classList.remove("editing");
  	                actionCard.classList.remove("functionality-editing");
  	                actionCard.__editSnapshot = cloneCardLocation(location);
  	
  	                openLocationActionCard(rowData);
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.error("[TrackIT Location Dropdown] Save edit failed.", error);
  	
  	                window.alert(
  	                  "The location edit could not be saved.\n\n" +
  	                  (error?.message || error?.faultString || "Unknown error")
  	                );
  	              } finally {
  	                if (saveButton) {
  	                  saveButton.disabled = false;
  	                  saveButton.classList.remove("saving");
  	                }
  	              }
  	            }
  	
  	            function undoLocationEditCard(rowData) {
  	              if (!rowData) return;
  	
  	              restoreEditSnapshotAndRefresh(rowData, "location-edit-undo");
  	
  	              FIF_SILENT_CONSOLE.groupCollapsed("[TrackIT Location Dropdown] Undo Edit");
  	              FIF_SILENT_CONSOLE.log("Location:", rowData.location);
  	              FIF_SILENT_CONSOLE.log("Row Data:", rowData);
  	              FIF_SILENT_CONSOLE.groupEnd();
  	
  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "undoEdit",
  	                cardType: "location-edit-card",
  	                placeholder: false
  	              });
  	
  	              actionCard.classList.remove("editing");
  	              openLocationActionCard(rowData);
  	            }
  	
  	            function getDeleteLocationId(rowData) {
  	              return safeString(
  	                rowData?.value ||
  	                getLocationValue(rowData?.location) ||
  	                rowData?.location?.objectId ||
  	                rowData?.location?.ObjectId ||
  	                rowData?.location?.id ||
  	                rowData?.location?.ID ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function getDeleteLocationParentIdAny(location) {
  	              return safeString(
  	                location?.ParentId ||
  	                location?.parentId ||
  	                location?.ParentID ||
  	                location?.parentID ||
  	                location?.ParentLocationId ||
  	                location?.parentLocationId ||
  	                location?.ParentLocationID ||
  	                location?.parentLocationID ||
  	                location?.Parent?.objectId ||
  	                location?.parent?.objectId ||
  	                location?.Parent?.id ||
  	                location?.parent?.id ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function collectAllKnownDeleteLocations() {
  	              const result = [];
  	              const seen = new Set();
  	
  	              function add(location) {
  	                if (!location || typeof location !== "object") return;
  	
  	                const id = safeString(getLocationValue(location)).trim();
  	                const key = id || getLocationLabel(location) || JSON.stringify(location).slice(0, 80);
  	
  	                if (key && seen.has(key)) return;
  	                if (key) seen.add(key);
  	
  	                result.push(location);
  	
  	                try {
  	                  getLocationChildren(location).forEach(add);
  	                } catch (_) {}
  	              }
  	
  	              try {
  	                flatRows.forEach(row => add(row?.location));
  	              } catch (_) {}
  	
  	              try {
  	                const appData = getAppBag();
  	
  	                const companies =
  	                DATA_CHANNEL?.companies ||
  	                appData?.User?.Companies ||
  	                appData?.User?.companies ||
  	                appData?.Companies ||
  	                appData?.companies ||
  	                [];
  	
  	                if (Array.isArray(companies)) {
  	                  companies.forEach(company => {
  	                    try {
  	                      getCompanyLocations(company).forEach(add);
  	                    } catch (_) {}
  	                  });
  	                }
  	
  	                const registryStore =
  	                appData?.LocationRegistryStore ||
  	                appData?.locationRegistryStore ||
  	                null;
  	
  	                const byId = registryStore?.byId || registryStore?.ById || null;
  	
  	                if (byId && typeof byId === "object") {
  	                  Object.keys(byId).forEach(key => add(byId[key]));
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                if (Array.isArray(DATA_CHANNEL?.registryLocations)) {
  	                  DATA_CHANNEL.registryLocations.forEach(add);
  	                }
  	              } catch (_) {}
  	
  	              return result;
  	            }
  	
  	            function buildDeleteLocationGraph() {
  	              const locations = collectAllKnownDeleteLocations();
  	              const byId = Object.create(null);
  	              const childrenByParentId = Object.create(null);
  	
  	              function remember(location) {
  	                if (!location || typeof location !== "object") return "";
  	
  	                const id = safeString(getLocationValue(location)).trim();
  	
  	                if (!id) return "";
  	
  	                if (!byId[id]) {
  	                  byId[id] = location;
  	                }
  	
  	                return id;
  	              }
  	
  	              function link(parentId, childId) {
  	                const parent = safeString(parentId).trim();
  	                const child = safeString(childId).trim();
  	
  	                if (!parent || !child || parent === child) return;
  	
  	                if (!childrenByParentId[parent]) {
  	                  childrenByParentId[parent] = new Set();
  	                }
  	
  	                childrenByParentId[parent].add(child);
  	              }
  	
  	              function scan(location, explicitParentId) {
  	                if (!location || typeof location !== "object") return;
  	
  	                const id = remember(location);
  	
  	                if (!id) return;
  	
  	                if (explicitParentId) {
  	                  link(explicitParentId, id);
  	                }
  	
  	                const storedParentId = getDeleteLocationParentIdAny(location);
  	
  	                if (storedParentId) {
  	                  link(storedParentId, id);
  	                }
  	
  	                try {
  	                  getLocationChildren(location).forEach(child => {
  	                    const childId = remember(child);
  	
  	                    if (childId) {
  	                      link(id, childId);
  	                    }
  	
  	                    scan(child, id);
  	                  });
  	                } catch (_) {}
  	              }
  	
  	              locations.forEach(location => scan(location, ""));
  	
  	              return {
  	                byId,
  	                childrenByParentId
  	              };
  	            }
  	
  	            function collectDeleteLocationIds(location,
  	              ids = new Set()) {
  	              if (!location || typeof location !== "object") return ids;
  	
  	              const graph = buildDeleteLocationGraph();
  	
  	              const seedId = safeString(getLocationValue(location)).trim();
  	
  	              if (!seedId) return ids;
  	
  	              const queue = [seedId];
  	              const visited = new Set();
  	
  	              while (queue.length) {
  	                const currentId = safeString(queue.shift()).trim();
  	
  	                if (!currentId || visited.has(currentId)) continue;
  	
  	                visited.add(currentId);
  	                ids.add(currentId);
  	
  	                const children = graph.childrenByParentId[currentId];
  	
  	                if (children && children.size) {
  	                  children.forEach(childId => {
  	                    if (childId && !visited.has(childId)) {
  	                      queue.push(childId);
  	                    }
  	                  });
  	                }
  	
  	                const currentLocation = graph.byId[currentId];
  	
  	                if (currentLocation) {
  	                  try {
  	                    getLocationChildren(currentLocation).forEach(child => {
  	                      const childId = safeString(getLocationValue(child)).trim();
  	
  	                      if (childId && !visited.has(childId)) {
  	                        queue.push(childId);
  	                      }
  	                    });
  	                  } catch (_) {}
  	                }
  	              }
  	
  	              return ids;
  	            }
  	
  	            function removeLocationIdsFromArray(list,
  	              idsToRemove) {
  	              if (!Array.isArray(list) || !idsToRemove || !idsToRemove.size) return 0;
  	
  	              let removed = 0;
  	
  	              const childArrayKeys = [
  	                "Children",
  	                "children",
  	                "ChildLocations",
  	                "childLocations",
  	                "Locations",
  	                "locations",
  	                "Fields",
  	                "fields",
  	                "Segments",
  	                "segments",
  	                "Rings",
  	                "rings"
  	              ];
  	
  	              for (let i = list.length - 1; i >= 0; i--) {
  	                const item = list[i];
  	
  	                if (!item || typeof item !== "object") continue;
  	
  	                const id = safeString(getLocationValue(item)).trim();
  	
  	                if (id && idsToRemove.has(id)) {
  	                  list.splice(i, 1);
  	                  removed++;
  	                  continue;
  	                }
  	
  	                childArrayKeys.forEach(key => {
  	                  if (Array.isArray(item[key])) {
  	                    removed += removeLocationIdsFromArray(item[key], idsToRemove);
  	                  }
  	                });
  	              }
  	
  	              return removed;
  	            }
  	
  	            function removeDeletedLocationFromAppData(rowData,
  	              idsToRemove) {
  	              const appData = getAppBag();
  	
  	              if (!appData || !idsToRemove || !idsToRemove.size) {
  	                return {
  	                  removedCount: 0
  	                };
  	              }
  	
  	              let removedCount = 0;
  	
  	              const companies =
  	              DATA_CHANNEL?.companies ||
  	              appData?.User?.Companies ||
  	              appData?.User?.companies ||
  	              appData?.Companies ||
  	              appData?.companies ||
  	              [];
  	
  	              if (Array.isArray(companies)) {
  	                companies.forEach(company => {
  	                  removedCount += removeLocationIdsFromArray(getCompanyLocations(company), idsToRemove);
  	                });
  	              }
  	
  	              try {
  	                const registryStore =
  	                appData.LocationRegistryStore ||
  	                appData.locationRegistryStore ||
  	                null;
  	
  	                const byId = registryStore?.byId || registryStore?.ById || null;
  	
  	                if (byId && typeof byId === "object") {
  	                  idsToRemove.forEach(id => {
  	                    try {
  	                      delete byId[id];
  	                    } catch (_) {
  	                      byId[id] = undefined;
  	                    }
  	                  });
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                if (Array.isArray(DATA_CHANNEL?.registryLocations)) {
  	                  DATA_CHANNEL.registryLocations = DATA_CHANNEL.registryLocations.filter(location => {
  	                    const id = safeString(getLocationValue(location)).trim();
  	                    return !id || !idsToRemove.has(id);
  	                  });
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                const selectedId = safeString(
  	                  appData.SelectedLocationObjectId ||
  	                  appData.SelectedLocationMarker ||
  	                  getLocationValue(appData.SelectedLocation) ||
  	                  ""
  	                ).trim();
  	
  	                if (selectedId && idsToRemove.has(selectedId)) {
  	                  delete appData.SelectedLocation;
  	                  delete appData.SelectedLocationObjectId;
  	                  delete appData.SelectedLocationMarker;
  	                }
  	              } catch (_) {
  	                appData.SelectedLocation = null;
  	                appData.SelectedLocationObjectId = null;
  	                appData.SelectedLocationMarker = null;
  	              }
  	
  	              try {
  	                if (DATA_CHANNEL?.selectedLocation) {
  	                  const selectedId = safeString(
  	                    DATA_CHANNEL.selectedLocation.objectId ||
  	                    DATA_CHANNEL.selectedLocation.marker ||
  	                    getLocationValue(DATA_CHANNEL.selectedLocation.location) ||
  	                    ""
  	                  ).trim();
  	
  	                  if (!selectedId || idsToRemove.has(selectedId)) {
  	                    DATA_CHANNEL.selectedLocation = {
  	                      marker: null,
  	                      objectId: null,
  	                      location: null
  	                    };
  	                  }
  	                }
  	              } catch (_) {}
  	
  	              return {
  	                removedCount
  	              };
  	            }
  	
  	            function removeDeletedLocationFromDropdownState(idsToRemove) {
  	              if (!idsToRemove || !idsToRemove.size) return;
  	
  	              try {
  	                flatRows = flatRows.filter(row => {
  	                  const id = safeString(
  	                    row?.value ||
  	                    getLocationValue(row?.location) ||
  	                    ""
  	                  ).trim();
  	
  	                  return !id || !idsToRemove.has(id);
  	                });
  	              } catch (_) {}
  	
  	              try {
  	                if (selectedRowData) {
  	                  const selectedId = safeString(
  	                    selectedRowData.value ||
  	                    getLocationValue(selectedRowData.location) ||
  	                    ""
  	                  ).trim();
  	
  	                  if (selectedId && idsToRemove.has(selectedId)) {
  	                    selectedRowData = null;
  	                    selectedValue = null;
  	                    selectedItem = null;
  	                    selectedLabel = "";
  	
  	                    if (searchInput) {
  	                      searchInput.value = "";
  	                    }
  	
  	                    try {
  	                      selectedIcon.removeAttribute("src");
  	                    } catch (_) {}
  	
  	                    try {
  	                      dropdown.classList.remove("has-value");
  	                      dropdown.classList.remove("has-query");
  	                    } catch (_) {}
  	                  }
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function getDeletedLocationIdStore() {
  	              try {
  	                if (typeof window === "undefined") return new Set();
  	
  	                if (!window.__TrackITDeletedLocationIds) {
  	                  window.__TrackITDeletedLocationIds = new Set();
  	                }
  	
  	                return window.__TrackITDeletedLocationIds;
  	              } catch (_) {
  	                return new Set();
  	              }
  	            }
  	
  	            function rememberDeletedLocationIds(idsToRemove) {
  	              const store = getDeletedLocationIdStore();
  	
  	              Array.from(idsToRemove || []).forEach(id => {
  	                const clean = safeString(id).trim();
  	
  	                if (clean) {
  	                  store.add(clean);
  	                }
  	              });
  	            }
  	
  	            function isLocationIdDeleted(id) {
  	              const clean = safeString(id).trim();
  	
  	              if (!clean) return false;
  	
  	              try {
  	                return !!window.__TrackITDeletedLocationIds && window.__TrackITDeletedLocationIds.has(clean);
  	              } catch (_) {
  	                return false;
  	              }
  	            }
  	
  	            function removeDeletedLocationFromMap(idsToRemove) {
  	              if (!idsToRemove || !idsToRemove.size) return;
  	
  	              rememberDeletedLocationIds(idsToRemove);
  	
  	              try {
  	                const runtime =
  	                typeof window !== "undefined"
  	                ? window.TrackITLocationMapRenderer ||
  	                window.TrackITLocationRendererRuntime ||
  	                window.__TrackITLocationRendererRuntime ||
  	                null: null;
  	
  	                if (runtime) {
  	                  idsToRemove.forEach(id => {
  	                    const cleanId = safeString(id).trim();
  	
  	                    if (!cleanId) return;
  	
  	                    try {
  	                      const polygon = runtime.polygonsById?.[cleanId];
  	
  	                      if (polygon && typeof polygon.setMap === "function") {
  	                        polygon.setMap(null);
  	                      }
  	
  	                      if (runtime.polygonsById) {
  	                        delete runtime.polygonsById[cleanId];
  	                      }
  	                    } catch (_) {}
  	
  	                    try {
  	                      const marker = runtime.markersById?.[cleanId];
  	
  	                      if (marker && typeof marker.setMap === "function") {
  	                        marker.setMap(null);
  	                      }
  	
  	                      if (runtime.markersById) {
  	                        delete runtime.markersById[cleanId];
  	                      }
  	                    } catch (_) {}
  	
  	                    try {
  	                      const label = runtime.labelsById?.[cleanId];
  	
  	                      if (label && typeof label.setMap === "function") {
  	                        label.setMap(null);
  	                      }
  	
  	                      if (runtime.labelsById) {
  	                        delete runtime.labelsById[cleanId];
  	                      }
  	                    } catch (_) {}
  	
  	                    try {
  	                      if (window.LocationRegistry && typeof window.LocationRegistry.unregister === "function") {
  	                        window.LocationRegistry.unregister(cleanId);
  	                      }
  	                    } catch (_) {}
  	
  	                    try {
  	                      if (window.TrackITLocationRegistry && typeof window.TrackITLocationRegistry.unregister === "function") {
  	                        window.TrackITLocationRegistry.unregister(cleanId);
  	                      }
  	                    } catch (_) {}
  	
  	                    try {
  	                      if (window.__TrackITLocationRegistry && typeof window.__TrackITLocationRegistry.unregister === "function") {
  	                        window.__TrackITLocationRegistry.unregister(cleanId);
  	                      }
  	                    } catch (_) {}
  	                  });
  	
  	                  if (typeof runtime.refresh === "function") {
  	                    runtime.refresh({
  	                      reason: "location-delete",
  	                      doFitBounds: false
  	                    });
  	                  }
  	                } else if (typeof renderSavedLocationsOnMap === "function") {
  	                  renderSavedLocationsOnMap(MAP_INPUT, {
  	                    reason: "location-delete",
  	                    doFitBounds: false
  	                  });
  	                }
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not remove deleted location from map.", error);
  	              }
  	
  	              try {
  	                const label = runtime.labelsById?.[cleanId];
  	
  	                if (label && typeof label.setMap === "function") {
  	                  label.setMap(null);
  	                }
  	
  	                if (runtime.labelsById) {
  	                  delete runtime.labelsById[cleanId];
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function escapeBackendlessWhereString(value) {
  	              return safeString(value).replace(/'/g, "''");
  	            }
  	
  	            function buildObjectIdWhereClause(idsToDelete) {
  	              const ids = Array.from(idsToDelete || [])
  	              .map(id => safeString(id).trim())
  	              .filter(Boolean);
  	
  	              if (!ids.length) return "";
  	
  	              return ids
  	              .map(id => `objectId = '${escapeBackendlessWhereString(id)}'`)
  	              .join(" OR ");
  	            }
  	
  	            function getDeleteCompanyIdsForLocationIds(idsToDelete) {
  	              const ids = new Set();
  	              const appData = getAppBag();
  	
  	              const companies =
  	              DATA_CHANNEL?.companies ||
  	              appData?.User?.Companies ||
  	              appData?.User?.companies ||
  	              appData?.Companies ||
  	              appData?.companies ||
  	              [];
  	
  	              if (!Array.isArray(companies)) return ids;
  	
  	              companies.forEach((company, index) => {
  	                const companyId = safeString(getCompanyId(company, index)).trim();
  	
  	                if (!companyId) return;
  	
  	                const companyLocations = flattenLocations(getCompanyLocations(company));
  	
  	                const hasAnyDeletedLocation = companyLocations.some(location => {
  	                  const id = safeString(getLocationValue(location)).trim();
  	                  return id && idsToDelete.has(id);
  	                });
  	
  	                if (hasAnyDeletedLocation) {
  	                  ids.add(companyId);
  	                }
  	              });
  	
  	              return ids;
  	            }
  	
  	            function getDeleteParentIdsForLocationIds(idsToDelete) {
  	              const parentIds = new Set();
  	
  	              collectAllKnownDeleteLocations().forEach(location => {
  	                if (!location || typeof location !== "object") return;
  	
  	                const id = safeString(getLocationValue(location)).trim();
  	
  	                if (!id || !idsToDelete.has(id)) return;
  	
  	                const parentId = getDeleteLocationParentIdAny(location);
  	
  	                if (parentId) {
  	                  parentIds.add(parentId);
  	                }
  	              });
  	
  	              return parentIds;
  	            }
  	
  	            async function tryDeleteBackendlessRelation(tableName,
  	              parentObjectId,
  	              relationName,
  	              childIds) {
  	              const parentId = safeString(parentObjectId).trim();
  	              const rel = safeString(relationName).trim();
  	
  	              const ids = Array.from(childIds || [])
  	              .map(id => safeString(id).trim())
  	              .filter(Boolean);
  	
  	              if (!tableName || !parentId || !rel || !ids.length) {
  	                return {
  	                  ok: false,
  	                  skipped: true,
  	                  reason: "Missing table, parent, relation, or children"
  	                };
  	              }
  	
  	              if (
  	                typeof Backendless === "undefined" ||
  	                !Backendless ||
  	                !Backendless.Data ||
  	                typeof Backendless.Data.of !== "function"
  	              ) {
  	                return {
  	                  ok: false,
  	                  skipped: true,
  	                  reason: "Backendless unavailable"
  	                };
  	              }
  	
  	              const store = Backendless.Data.of(tableName);
  	
  	              if (!store || typeof store.deleteRelation !== "function") {
  	                return {
  	                  ok: false,
  	                  skipped: true,
  	                  reason: "deleteRelation unavailable"
  	                };
  	              }
  	
  	              try {
  	                const result = await store.deleteRelation(
  	                  {
  	                    objectId: parentId
  	                  },
  	                  rel,
  	                  ids.map(id => ({
  	                    objectId: id
  	                  }))
  	                );
  	
  	                return {
  	                  ok: true,
  	                  skipped: false,
  	                  result
  	                };
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Relation delete failed.", {
  	                  tableName,
  	                  parentId,
  	                  relationName: rel,
  	                  ids,
  	                  error
  	                });
  	
  	                return {
  	                  ok: false,
  	                  skipped: false,
  	                  error
  	                };
  	              }
  	            }
  	
  	            async function deleteLocationRelationsFromBackendless(idsToDelete) {
  	              const relationResults = [];
  	
  	              const companyIds = getDeleteCompanyIdsForLocationIds(idsToDelete);
  	              const parentIds = getDeleteParentIdsForLocationIds(idsToDelete);
  	
  	              for (const companyId of companyIds) {
  	                relationResults.push(
  	                  await tryDeleteBackendlessRelation(
  	                    typeof SAVE_TABLE_COMPANIES !== "undefined" ? SAVE_TABLE_COMPANIES: "Companies",
  	                    companyId,
  	                    typeof SAVE_COMPANY_LOCATIONS_RELATION !== "undefined" ? SAVE_COMPANY_LOCATIONS_RELATION: "Locations",
  	                    idsToDelete
  	                  )
  	                );
  	              }
  	
  	              for (const parentId of parentIds) {
  	                relationResults.push(
  	                  await tryDeleteBackendlessRelation(
  	                    typeof SAVE_TABLE_LOCATIONS !== "undefined" ? SAVE_TABLE_LOCATIONS: "Locations",
  	                    parentId,
  	                    typeof SAVE_PARENT_CHILDREN_RELATION !== "undefined" ? SAVE_PARENT_CHILDREN_RELATION: "Fields",
  	                    idsToDelete
  	                  )
  	                );
  	              }
  	
  	              return relationResults;
  	            }
  	
  	            async function invokeFlespiDeleteForLocationId(locationObjectId) {
  	              const objectId = safeString(locationObjectId).trim();
  	
  	              if (!objectId) {
  	                return {
  	                  ok: true,
  	                  skipped: true,
  	                  reason: "No objectId"
  	                };
  	              }
  	
  	              if (
  	                typeof Backendless === "undefined" ||
  	                !Backendless ||
  	                ![
  	                  Backendless.APIServices,
  	                  Backendless.CustomService,
  	                  Backendless.CustomServices
  	                ].some(service => service && typeof service.invoke === "function")
  	              ) {
  	                throw new Error("Backendless.CustomServices.invoke is not available. Cannot safely delete Flespi geofence before deleting Location.");
  	              }
  	
  	              function normalizeServiceResult(rawResult) {
  	                if (rawResult === undefined || rawResult === null) {
  	                  return null;
  	                }
  	
  	                if (typeof rawResult === "string") {
  	                  try {
  	                    return JSON.parse(rawResult);
  	                  } catch (_) {
  	                    return {
  	                      raw: rawResult
  	                    };
  	                  }
  	                }
  	
  	                return rawResult;
  	              }
  	
  	              function isConfirmedFlespiDelete(serviceResult, expectedObjectId) {
  	                const result = normalizeServiceResult(serviceResult);
  	
  	                if (!result || typeof result !== "object" || result.ok !== true) {
  	                  return false;
  	                }
  	
  	                // Never accept a response for a different Location.
  	                if (safeString(result.objectId).trim() !== safeString(expectedObjectId).trim()) {
  	                  return false;
  	                }
  	
  	                // An actual successful deletion is enough.
  	                if (result.action === "delete") {
  	                  return true;
  	                }
  	
  	                // Idempotency: absence verified via an available Flespi geofence list is
  	                // equally safe. This permits retry after an earlier partial deletion.
  	                // Do NOT trust the old deleteSkipped response without verification:
  	                // the old service could swallow failed Flespi list requests.
  	                if (result.action === "deleteSkipped" && result.absenceVerified === true) {
  	                  return true;
  	                }
  	
  	                return false;
  	              }
  	
  	              function summarizeServiceResult(serviceResult) {
  	                const result = normalizeServiceResult(serviceResult);
  	
  	                if (!result || typeof result !== "object") {
  	                  return safeString(serviceResult);
  	                }
  	
  	                return [
  	                  "ok=" + safeString(result.ok),
  	                  "action=" + safeString(result.action),
  	                  "absenceVerified=" + safeString(result.absenceVerified),
  	                  "flespiGeofenceId=" + safeString(result.flespiGeofenceId),
  	                  "message=" + safeString(result.message)
  	                ].join(", ");
  	              }
  	
  	              const attempts = [{
  	                label: "deleteGeofenceFromLocation direct arg",
  	                call: () => getFlespiApiInvoker().invoke(
  	                  "FlespiSync",
  	                  "deleteGeofenceFromLocation",
  	                  objectId
  	                )
  	              },
  	                {
  	                  label: "deleteGeofenceByObjectId direct arg",
  	                  call: () => getFlespiApiInvoker().invoke(
  	                    "FlespiSync",
  	                    "deleteGeofenceByObjectId",
  	                    objectId
  	                  )
  	                },
  	                {
  	                  label: "deleteGeofenceFromLocation array args",
  	                  call: () => getFlespiApiInvoker().invoke(
  	                    "FlespiSync",
  	                    "deleteGeofenceFromLocation",
  	                    [objectId]
  	                  )
  	                },
  	                {
  	                  label: "deleteGeofenceByObjectId array args",
  	                  call: () => getFlespiApiInvoker().invoke(
  	                    "FlespiSync",
  	                    "deleteGeofenceByObjectId",
  	                    [objectId]
  	                  )
  	                }];
  	
  	              const failures = [];
  	
  	              for (const attempt of attempts) {
  	                try {
  	                  FIF_SILENT_CONSOLE.log("[TrackIT Flespi Delete] Attempt:", {
  	                    objectId,
  	                    attempt: attempt.label
  	                  });
  	
  	                  const rawResult = await attempt.call();
  	                  const serviceResult = normalizeServiceResult(rawResult);
  	
  	                  FIF_SILENT_CONSOLE.log("[TrackIT Flespi Delete] Service response:", {
  	                    objectId,
  	                    attempt: attempt.label,
  	                    serviceResult
  	                  });
  	
  	                  if (isConfirmedFlespiDelete(serviceResult, objectId)) {
  	                    return {
  	                      ok: true,
  	                      objectId,
  	                      attempt: attempt.label,
  	                      result: serviceResult
  	                    };
  	                  }
  	
  	                  failures.push({
  	                    attempt: attempt.label,
  	                    message: "Service returned but did not confirm delete. " + summarizeServiceResult(serviceResult),
  	                    result: serviceResult
  	                  });
  	
  	                  FIF_SILENT_CONSOLE.warn("[TrackIT Flespi Delete] Attempt did not confirm delete.", {
  	                    objectId,
  	                    attempt: attempt.label,
  	                    serviceResult
  	                  });
  	
  	                } catch (error) {
  	                  const message = error?.message || error?.faultString || String(error);
  	
  	                  failures.push({
  	                    attempt: attempt.label,
  	                    message
  	                  });
  	
  	                  FIF_SILENT_CONSOLE.warn("[TrackIT Flespi Delete] Flespi delete attempt failed.", {
  	                    objectId,
  	                    attempt: attempt.label,
  	                    error
  	                  });
  	                }
  	              }
  	
  	              throw new Error(
  	                "Could not confirm Flespi geofence deletion before deleting Location. objectId=" +
  	                objectId +
  	                ". Failures: " +
  	                failures.map(item => item.attempt + ": " + item.message).join(" | ")
  	              );
  	            }
  	
  	            async function deleteFlespiGeofencesBeforeBackendlessDelete(idsToDelete) {
  	              if (!idsToDelete || !idsToDelete.size) {
  	                return {
  	                  ok: true,
  	                  deleted: [],
  	                  results: [],
  	                  reason: "No ids to delete"
  	                };
  	              }
  	
  	              const ids = Array.from(idsToDelete)
  	              .map(id => safeString(id).trim())
  	              .filter(Boolean);
  	
  	              const results = [];
  	
  	              for (const objectId of ids) {
  	                const result = await invokeFlespiDeleteForLocationId(objectId);
  	
  	                results.push(result);
  	              }
  	
  	              return {
  	                ok: true,
  	                deleted: ids,
  	                results
  	              };
  	            }
  	
  	            async function deleteLocationRecordsFromBackendless(idsToDelete) {
  	              if (!idsToDelete || !idsToDelete.size) {
  	                return {
  	                  ok: false,
  	                  deleted: [],
  	                  deletedCount: 0,
  	                  reason: "No objectId"
  	                };
  	              }
  	
  	              if (
  	                typeof Backendless === "undefined" ||
  	                !Backendless ||
  	                !Backendless.Data ||
  	                typeof Backendless.Data.of !== "function"
  	              ) {
  	                return {
  	                  ok: false,
  	                  deleted: [],
  	                  deletedCount: 0,
  	                  reason: "Backendless Data unavailable"
  	                };
  	              }
  	
  	              const ids = Array.from(idsToDelete)
  	              .map(id => safeString(id).trim())
  	              .filter(Boolean);
  	
  	              const whereClause = buildObjectIdWhereClause(ids);
  	
  	              if (!whereClause) {
  	                return {
  	                  ok: false,
  	                  deleted: [],
  	                  deletedCount: 0,
  	                  reason: "Empty where clause"
  	                };
  	              }
  	
  	              const store = Backendless.Data.of("Locations");
  	
  	              if (typeof store.bulkDelete !== "function") {
  	                throw new Error("Backendless bulkDelete is not available in this runtime.");
  	              }
  	
  	              const deletedCount = await store.bulkDelete(whereClause);
  	
  	              return {
  	                ok: true,
  	                deleted: ids,
  	                deletedCount,
  	                whereClause
  	              };
  	            }
  	
  	            function getDeleteConfirmBlackout() {
  	              let blackout = null;
  	
  	              try {
  	                blackout = root.__trackitDeleteConfirmBlackout || null;
  	              } catch (_) {
  	                blackout = null;
  	              }
  	
  	              if (blackout && document.body.contains(blackout)) {
  	                return blackout;
  	              }
  	
  	              blackout = document.createElement("div");
  	              blackout.className = "trackit-delete-confirm-blackout";
  	              blackout.setAttribute("aria-hidden", "true");
  	
  	              document.body.appendChild(blackout);
  	
  	              try {
  	                root.__trackitDeleteConfirmBlackout = blackout;
  	              } catch (_) {}
  	
  	              return blackout;
  	            }
  	
  	            function openDeleteConfirmBlackout() {
  	              const blackout = getDeleteConfirmBlackout();
  	
  	              blackout.classList.add("open");
  	
  	              try {
  	                document.documentElement.classList.add("trackit-delete-confirm-open");
  	                document.body.classList.add("trackit-delete-confirm-open");
  	              } catch (_) {}
  	
  	              return blackout;
  	            }
  	
  	            function closeDeleteConfirmBlackout() {
  	              const blackout = getDeleteConfirmBlackout();
  	
  	              blackout.classList.remove("open");
  	
  	              try {
  	                document.documentElement.classList.remove("trackit-delete-confirm-open");
  	                document.body.classList.remove("trackit-delete-confirm-open");
  	              } catch (_) {}
  	            }
  	
  	            function getDeleteConfirmPopup() {
  	              let popup = null;
  	
  	              try {
  	                popup = root.__trackitDeleteConfirmPopup || null;
  	              } catch (_) {
  	                popup = null;
  	              }
  	
  	              if (popup && document.body.contains(popup)) {
  	                return popup;
  	              }
  	
  	              popup = document.createElement("div");
  	              popup.className = "trackit-delete-confirm-popup";
  	              popup.setAttribute("role", "dialog");
  	              popup.setAttribute("aria-modal", "false");
  	              popup.setAttribute("aria-label", "Delete Location Confirmation");
  	
  	              document.body.appendChild(popup);
  	
  	              try {
  	                root.__trackitDeleteConfirmPopup = popup;
  	              } catch (_) {}
  	
  	              return popup;
  	            }
  	
  	            function closeDeleteConfirmPopup() {
  	              const popup = getDeleteConfirmPopup();
  	
  	              popup.classList.remove("open");
  	              popup.innerHTML = "";
  	              popup.__deleteConfirmContext = null;
  	              actionCard.__deleteConfirmContext = null;
  	
  	              closeDeleteConfirmBlackout();
  	            }
  	
  	            function getDeleteConfirmContext(rowData) {
  	              if (!rowData || !rowData.location) return null;
  	
  	              const location = rowData.location;
  	
  	              const locationName = safeString(
  	                rowData.label ||
  	                getLocationLabel(location) ||
  	                "this location"
  	              ).trim();
  	
  	              const idsToDelete = collectDeleteLocationIds(location);
  	              const primaryId = getDeleteLocationId(rowData);
  	
  	              if (primaryId) {
  	                idsToDelete.add(primaryId);
  	              }
  	
  	              const childCount = Math.max(0, idsToDelete.size - 1);
  	              const deleteCount = idsToDelete.size;
  	
  	              return {
  	                rowData,
  	                location,
  	                locationName,
  	                idsToDelete,
  	                childCount,
  	                deleteCount,
  	                returnMode: actionCard.classList.contains("editing") ? "edit": "view",
  	                editSnapshot: actionCard.__editSnapshot || null
  	              };
  	            }
  	
  	            function openDeleteConfirmCard(rowData) {
  	              const context = getDeleteConfirmContext(rowData);
  	
  	              if (!context) return;
  	
  	              if (!context.idsToDelete.size) {
  	                window.alert("This location cannot be deleted because it has no objectId.");
  	                return;
  	              }
  	
  	              const popup = getDeleteConfirmPopup();
  	
  	              actionCard.__deleteConfirmContext = context;
  	              popup.__deleteConfirmContext = context;
  	
  	              const childWarning = context.childCount
  	              ? `
  	              <div class="trackit-delete-popup-child-warning">
  	              This will also delete <strong>${context.childCount}</strong> nested child location${context.childCount === 1 ? "": "s"}.
  	              </div>
  	              `: "";
  	
  	              popup.innerHTML = `
  	              <div class="trackit-delete-popup-panel">
  	              <div class="trackit-delete-popup-head">
  	              <div class="trackit-delete-popup-icon">!</div>
  	
  	              <div class="trackit-delete-popup-title-block">
  	              <div class="trackit-delete-popup-title">Delete Location</div>
  	              <div class="trackit-delete-popup-subtitle">Permanent Action</div>
  	              </div>
  	
  	              <button class="trackit-delete-popup-close" type="button" data-delete-popup-cancel aria-label="Cancel delete">
  	              ×
  	              </button>
  	              </div>
  	
  	              <div class="trackit-delete-popup-body">
  	              <div class="trackit-delete-popup-name">
  	              ${escapeHtml(context.locationName)}
  	              </div>
  	
  	              <div class="trackit-delete-popup-copy">
  	              This will permanently remove ${context.deleteCount} location${context.deleteCount === 1 ? "": "s"} from the database, App Data, dropdown, and map.
  	              </div>
  	
  	              ${childWarning}
  	
  	              <label class="trackit-delete-popup-label">
  	              Type <strong>DELETE</strong> to confirm
  	              </label>
  	
  	              <input
  	              class="trackit-delete-popup-input"
  	              type="text"
  	              autocomplete="off"
  	              spellcheck="false"
  	              data-delete-confirm-input
  	              placeholder="DELETE"
  	              >
  	
  	              <div class="trackit-delete-popup-error" data-delete-confirm-error>
  	              Exact confirmation required.
  	              </div>
  	              </div>
  	
  	              <div class="trackit-delete-popup-actions">
  	              <button
  	              class="trackit-delete-popup-btn danger"
  	              type="button"
  	              data-delete-popup-confirm
  	              disabled
  	              >
  	              Delete
  	              </button>
  	
  	              <button
  	              class="trackit-delete-popup-btn"
  	              type="button"
  	              data-delete-popup-cancel
  	              >
  	              Cancel
  	              </button>
  	              </div>
  	              </div>
  	              `;
  	
  	              openDeleteConfirmBlackout();
  	              popup.classList.add("open");
  	
  	              bindDeleteConfirmPopupEvents();
  	
  	              setTimeout(() => {
  	                const input = popup.querySelector("[data-delete-confirm-input]");
  	
  	                try {
  	                  input?.focus?.();
  	                  input?.select?.();
  	                } catch (_) {}
  	              }, 30);
  	            }
  	
  	            function bindDeleteConfirmPopupEvents() {
  	              const popup = getDeleteConfirmPopup();
  	
  	              const input = popup.querySelector("[data-delete-confirm-input]");
  	              const deleteButton = popup.querySelector("[data-delete-popup-confirm]");
  	              const cancelButtons = popup.querySelectorAll("[data-delete-popup-cancel]");
  	              const error = popup.querySelector("[data-delete-confirm-error]");
  	
  	              if (!input || !deleteButton) return;
  	
  	              function refreshState() {
  	                const value = safeString(input.value).trim();
  	                const isValid = value === "DELETE";
  	
  	                deleteButton.disabled = !isValid;
  	
  	                if (error) {
  	                  error.classList.toggle("visible", !!value && !isValid);
  	                }
  	
  	                input.classList.toggle("is-valid", isValid);
  	                input.classList.toggle("is-invalid", !!value && !isValid);
  	              }
  	
  	              input.addEventListener("input", refreshState);
  	
  	              input.addEventListener("keydown", event => {
  	                if (event.key === "Enter") {
  	                  event.preventDefault();
  	
  	                  if (safeString(input.value).trim() === "DELETE") {
  	                    confirmDeleteLocationFromCard();
  	                  }
  	
  	                  return;
  	                }
  	
  	                if (event.key === "Escape") {
  	                  event.preventDefault();
  	                  cancelDeleteLocationConfirm();
  	                }
  	              });
  	
  	              deleteButton.addEventListener("click",
  	                event => {
  	                  event.preventDefault();
  	                  confirmDeleteLocationFromCard();
  	                });
  	
  	              cancelButtons.forEach(button => {
  	                button.addEventListener("click", event => {
  	                  event.preventDefault();
  	                  cancelDeleteLocationConfirm();
  	                });
  	              });
  	
  	              refreshState();
  	            }
  	
  	            function cancelDeleteLocationConfirm() {
  	              const popup = getDeleteConfirmPopup();
  	              const context = popup.__deleteConfirmContext || actionCard.__deleteConfirmContext || null;
  	              const rowData = context?.rowData || selectedRowData || null;
  	
  	              closeDeleteConfirmPopup();
  	
  	              if (!rowData) {
  	                return;
  	              }
  	
  	              if (context?.returnMode === "edit") {
  	                const snapshot = context.editSnapshot || actionCard.__editSnapshot || null;
  	
  	                openLocationEditCard(rowData);
  	
  	                if (snapshot) {
  	                  actionCard.__editSnapshot = snapshot;
  	                }
  	
  	                return;
  	              }
  	
  	              openLocationActionCard(rowData);
  	            }
  	
  	            function deleteLocationEditCard(rowData) {
  	              if (!rowData || !rowData.location) return;
  	
  	              if (typeof isShapeEditActive === "function" && isShapeEditActive()) {
  	                window.alert("Finish or cancel shape editing before deleting a location.");
  	                return;
  	              }
  	
  	              if (typeof isEntranceEditActive === "function" && isEntranceEditActive()) {
  	                window.alert("Finish or cancel entrance editing before deleting a location.");
  	                return;
  	              }
  	
  	              openDeleteConfirmCard(rowData);
  	            }
  	
  	            async function confirmDeleteLocationFromCard() {
  	              const popup = getDeleteConfirmPopup();
  	              const context = popup.__deleteConfirmContext || actionCard.__deleteConfirmContext || null;
  	
  	              if (!context || !context.rowData || !context.location || !context.idsToDelete) {
  	                window.alert("Delete confirmation context was lost. Please try again.");
  	                return;
  	              }
  	
  	              const input = popup.querySelector("[data-delete-confirm-input]");
  	              const typed = safeString(input?.value).trim();
  	
  	              if (typed !== "DELETE") {
  	                const error = popup.querySelector("[data-delete-confirm-error]");
  	
  	                if (error) {
  	                  error.classList.add("visible");
  	                }
  	
  	                if (input && typeof input.focus === "function") {
  	                  input.focus();
  	                }
  	
  	                return;
  	              }
  	
  	              const rowData = context.rowData;
  	              const location = context.location;
  	              const idsToDelete = context.idsToDelete;
  	
  	              const deleteButton = popup.querySelector("[data-delete-popup-confirm]");
  	              const cancelButton = popup.querySelector("[data-delete-popup-cancel]");
  	
  	              if (deleteButton) {
  	                deleteButton.disabled = true;
  	                deleteButton.classList.add("saving");
  	                deleteButton.textContent = "Deleting...";
  	              }
  	
  	              if (cancelButton) {
  	                cancelButton.disabled = true;
  	              }
  	
  	              try {
  	                // Mark as deleted only AFTER Backendless confirms deletion.
  	                // A failed Flespi call must never hide a still-existing Location.
  	
  	                // Sacred order:
  	                // 1. Delete Flespi geofences first.
  	                // 2. Remove Backendless relations second.
  	                // 3. Delete Backendless Location rows last.
  	                const flespiDeleteResult = await deleteFlespiGeofencesBeforeBackendlessDelete(idsToDelete);
  	                const relationDeleteResult = await deleteLocationRelationsFromBackendless(idsToDelete);
  	                const deleteResult = await deleteLocationRecordsFromBackendless(idsToDelete);
  	
  	                rememberDeletedLocationIds(idsToDelete);
  	                removeDeletedLocationFromAppData(rowData, idsToDelete);
  	                removeDeletedLocationFromDropdownState(idsToDelete);
  	                removeDeletedLocationFromMap(idsToDelete);
  	
  	                try {
  	                  refreshApp();
  	                } catch (_) {}
  	
  	                try {
  	                  refreshBackendlessApp();
  	                } catch (_) {}
  	
  	                try {
  	                  if (typeof renderMenu === "function") {
  	                    renderMenu(searchInput?.value || "");
  	                  }
  	                } catch (_) {}
  	
  	                emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                  action: "deleteLocation",
  	                  cardType: "location-delete-confirm-card",
  	                  placeholder: false,
  	                  deleted: true,
  	                  deletedIds: Array.from(idsToDelete),
  	                  backendlessDeletedIds: deleteResult.deleted || [],
  	                  flespiDeleteResult,
  	                  relationDeleteResult
  	                });
  	
  	                FIF_SILENT_CONSOLE.groupCollapsed("[TrackIT Location Dropdown] Delete Location");
  	                FIF_SILENT_CONSOLE.log("Deleted Location:", location);
  	                FIF_SILENT_CONSOLE.log("Row Data:", rowData);
  	                FIF_SILENT_CONSOLE.log("Deleted IDs:", Array.from(idsToDelete));
  	                FIF_SILENT_CONSOLE.log("Flespi Result:", flespiDeleteResult);
  	                FIF_SILENT_CONSOLE.log("Backendless Result:", deleteResult);
  	                FIF_SILENT_CONSOLE.groupEnd();
  	
  	                closeDeleteConfirmPopup();
  	
  	                actionCard.classList.remove("open");
  	                actionCard.classList.remove("editing");
  	                actionCard.classList.remove("functionality-editing");
  	                actionCard.classList.remove("shape-editing");
  	                actionCard.classList.remove("entrance-editing");
  	
  	                notifyCarvedShellReset();
  	                notifyCarvedShellLayout();
  	                setTimeout(notifyCarvedShellLayout, 80);
  	                setTimeout(notifyCarvedShellLayout, 220);
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.error("[TrackIT Location Dropdown] Delete failed.", error);
  	
  	                window.alert(
  	                  "The location could not be deleted.\n\n" +
  	                  (error?.message || error?.faultString || "Unknown error")
  	                );
  	
  	                if (deleteButton) {
  	                  deleteButton.disabled = false;
  	                  deleteButton.classList.remove("saving");
  	                  deleteButton.textContent = "Delete";
  	                }
  	
  	                if (cancelButton) {
  	                  cancelButton.disabled = false;
  	                }
  	              }
  	            }
  	
  	            function getShapeEditLocationId(rowData) {
  	              return safeString(
  	                rowData?.value ||
  	                getLocationValue(rowData?.location) ||
  	                rowData?.location?.objectId ||
  	                rowData?.location?.ObjectId ||
  	                rowData?.location?.id ||
  	                rowData?.location?.ID ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function getShapeEditRuntime() {
  	              try {
  	                return (
  	                  window.TrackITLocationMapRenderer ||
  	                  window.TrackITLocationRendererRuntime ||
  	                  window.__TrackITLocationRendererRuntime ||
  	                  null
  	                );
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function getShapeEditPolygon(rowData) {
  	              const id = getShapeEditLocationId(rowData);
  	              const runtime = getShapeEditRuntime();
  	
  	              if (!id || !runtime || !runtime.polygonsById) return null;
  	
  	              return runtime.polygonsById[id] || null;
  	            }
  	
  	            function getShapeEditMap(rowData) {
  	              const runtime = getShapeEditRuntime();
  	
  	              return (
  	                runtime?.map ||
  	                runtime?.mapRef ||
  	                resolveGMap?.(MapRoot) ||
  	                null
  	              );
  	            }
  	
  	            function shapeEditLatLngToPlain(value) {
  	              if (!value) return null;
  	
  	              const lat = typeof value.lat === "function" ? value.lat(): value.lat;
  	              const lng = typeof value.lng === "function" ? value.lng(): value.lng;
  	
  	              const point = {
  	                lat: Number(lat),
  	                lng: Number(lng)
  	              };
  	
  	              if (!Number.isFinite(point.lat) || !Number.isFinite(point.lng)) {
  	                return null;
  	              }
  	
  	              return point;
  	            }
  	
  	            function shapeEditPlainToLatLng(point) {
  	              const clean = makeCleanPlotPoint(point);
  	
  	              if (!clean) return null;
  	
  	              try {
  	                if (typeof google !== "undefined" && google?.maps?.LatLng) {
  	                  return new google.maps.LatLng(clean.lat, clean.lng);
  	                }
  	              } catch (_) {}
  	
  	              return {
  	                lat: clean.lat,
  	                lng: clean.lng
  	              };
  	            }
  	
  	            function shapeEditReadPath(path) {
  	              const points = [];
  	
  	              if (!path || typeof path.getLength !== "function") return points;
  	
  	              for (let i = 0; i < path.getLength(); i++) {
  	                const point = shapeEditLatLngToPlain(path.getAt(i));
  	
  	                if (point) points.push(point);
  	              }
  	
  	              return points;
  	            }
  	
  	            function shapeEditSetPath(path, points) {
  	              if (!path || !Array.isArray(points)) return;
  	
  	              path.clear();
  	
  	              points.forEach(point => {
  	                const latLng = shapeEditPlainToLatLng(point);
  	
  	                if (latLng) path.push(latLng);
  	              });
  	            }
  	
  	            function shapeEditClonePoints(points) {
  	              return Array.isArray(points)
  	              ? points
  	              .map(point => makeCleanPlotPoint(point))
  	              .filter(Boolean): [];
  	            }
  	
  	            function shapeEditGetBlockerId(blocker) {
  	              return safeString(
  	                blocker?.locationId ||
  	                blocker?.blockerId ||
  	                blocker?.id ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function shapeEditGetBlockerIdAny(blocker) {
  	              return safeString(
  	                blocker?.locationId ||
  	                blocker?.blockerId ||
  	                blocker?.id ||
  	                ""
  	              ).trim();
  	            }
  	
  	            function shapeEditFindBlockerById(blockersById,
  	              blockers,
  	              id) {
  	              const targetId = safeString(id).trim();
  	
  	              if (!targetId) return null;
  	
  	              if (blockersById && blockersById[targetId]) {
  	                return blockersById[targetId];
  	              }
  	
  	              const list = Array.isArray(blockers) ? blockers: [];
  	
  	              return list.find(blocker => {
  	                return shapeEditGetBlockerIdAny(blocker) === targetId;
  	              }) || null;
  	            }
  	
  	            function shapeEditIsDescendantOf(locationId, ancestorId, parentById) {
  	              const targetId = safeString(locationId).trim();
  	              const rootId = safeString(ancestorId).trim();
  	
  	              if (!targetId || !rootId || !parentById) return false;
  	
  	              let currentId = safeString(parentById[targetId]).trim();
  	              let guard = 0;
  	
  	              while (currentId && guard < 50) {
  	                if (currentId === rootId) return true;
  	                currentId = safeString(parentById[currentId]).trim();
  	                guard++;
  	              }
  	
  	              return false;
  	            }
  	
  	            function shapeEditUniqueBlockers(blockers) {
  	              const byId = Object.create(null);
  	              const result = [];
  	
  	              (Array.isArray(blockers) ? blockers: []).forEach(blocker => {
  	                if (!blocker || !Array.isArray(blocker.boundary) || blocker.boundary.length < 3) return;
  	
  	                const id = shapeEditGetBlockerIdAny(blocker);
  	
  	                if (!id) return;
  	                if (byId[id]) return;
  	
  	                byId[id] = true;
  	                result.push(blocker);
  	              });
  	
  	              return result;
  	            }
  	
  	            function getShapeEditBoundaryContext(rowData) {
  	              const editingId = getShapeEditLocationId(rowData);
  	
  	              let hierarchy = null;
  	
  	              try {
  	                hierarchy = typeof buildLocationHierarchyIndex === "function"
  	                ? buildLocationHierarchyIndex(): null;
  	              } catch (_) {
  	                hierarchy = null;
  	              }
  	
  	              let allBlockers = Array.isArray(hierarchy?.blockers)
  	              ? hierarchy.blockers: [];
  	
  	              if (!allBlockers.length) {
  	                try {
  	                  allBlockers = typeof getFreeGroundBlockers === "function"
  	                  ? getFreeGroundBlockers(): [];
  	                } catch (_) {
  	                  allBlockers = [];
  	                }
  	              }
  	
  	              const blockersById = hierarchy?.blockersById || Object.create(null);
  	              const parentById = hierarchy?.parentById || Object.create(null);
  	
  	              const editingBlocker = shapeEditFindBlockerById(blockersById, allBlockers, editingId);
  	              const parentId = editingId ? safeString(parentById[editingId]).trim(): "";
  	              const parentBlocker = parentId
  	              ? shapeEditFindBlockerById(blockersById, allBlockers, parentId): null;
  	
  	              let containedBlockers = [];
  	
  	              if (editingId) {
  	                try {
  	                  if (editingBlocker && typeof getDirectChildBlockersForParentBlocker === "function") {
  	                    containedBlockers = getDirectChildBlockersForParentBlocker(editingBlocker);
  	                  } else if (typeof getDirectChildBlockersForParentId === "function") {
  	                    containedBlockers = getDirectChildBlockersForParentId(editingId);
  	                  } else {
  	                    containedBlockers = allBlockers.filter(blocker => {
  	                      const id = shapeEditGetBlockerIdAny(blocker);
  	
  	                      return id && safeString(parentById[id]).trim() === editingId;
  	                    });
  	                  }
  	                } catch (_) {
  	                  containedBlockers = [];
  	                }
  	              }
  	
  	              containedBlockers = shapeEditUniqueBlockers(containedBlockers)
  	              .filter(blocker => {
  	                const id = shapeEditGetBlockerIdAny(blocker);
  	
  	                return id && id !== editingId;
  	              });
  	
  	              let conflictBlockers = [];
  	
  	              if (parentBlocker) {
  	                try {
  	                  conflictBlockers = typeof getChildLocationSiblingBlockers === "function"
  	                  ? getChildLocationSiblingBlockers(parentBlocker): [];
  	                } catch (_) {
  	                  conflictBlockers = [];
  	                }
  	
  	                if (!conflictBlockers.length) {
  	                  try {
  	                    conflictBlockers = typeof getDirectChildBlockersForParentBlocker === "function"
  	                    ? getDirectChildBlockersForParentBlocker(parentBlocker): [];
  	                  } catch (_) {
  	                    conflictBlockers = [];
  	                  }
  	                }
  	              } else {
  	                try {
  	                  conflictBlockers = typeof getTopLevelFreeGroundBlockers === "function"
  	                  ? getTopLevelFreeGroundBlockers(): [];
  	                } catch (_) {
  	                  conflictBlockers = [];
  	                }
  	
  	                if (!conflictBlockers.length) {
  	                  conflictBlockers = allBlockers;
  	                }
  	              }
  	
  	              const containedIds = Object.create(null);
  	
  	              containedBlockers.forEach(blocker => {
  	                const id = shapeEditGetBlockerIdAny(blocker);
  	
  	                if (id) containedIds[id] = true;
  	              });
  	
  	              conflictBlockers = shapeEditUniqueBlockers(conflictBlockers)
  	              .filter(blocker => {
  	                const id = shapeEditGetBlockerIdAny(blocker);
  	
  	                if (!id) return false;
  	                if (editingId && id === editingId) return false;
  	                if (parentId && id === parentId) return false;
  	                if (containedIds[id]) return false;
  	
  	                if (editingId && shapeEditIsDescendantOf(id, editingId, parentById)) {
  	                  return false;
  	                }
  	
  	                return true;
  	              });
  	
  	              return {
  	                editingId,
  	                editingBlocker,
  	                parentId,
  	                parentBlocker,
  	                allBlockers,
  	                containedBlockers,
  	                conflictBlockers,
  	                blockers: conflictBlockers,
  	                parentById
  	              };
  	            }
  	
  	            function getShapeEditBlockers(rowData) {
  	              return getShapeEditBoundaryContext(rowData).conflictBlockers;
  	            }
  	
  	            function shapeEditSegmentLeavesParent(a,
  	              b,
  	              parentBlocker) {
  	              const start = makeCleanPlotPoint(a);
  	              const end = makeCleanPlotPoint(b);
  	
  	              if (!start || !end || !parentBlocker || !Array.isArray(parentBlocker.boundary)) return false;
  	
  	              if (!pointInsideOrNearChildParent(start, parentBlocker)) return true;
  	              if (!pointInsideOrNearChildParent(end, parentBlocker)) return true;
  	
  	              let cuts = [0,
  	                1];
  	
  	              try {
  	                if (typeof getSegmentIntersectionsForBoundary === "function") {
  	                  const hits = getSegmentIntersectionsForBoundary(
  	                    start,
  	                    end,
  	                    parentBlocker.boundary,
  	                    parentBlocker
  	                  );
  	
  	                  (Array.isArray(hits) ? hits: []).forEach(hit => {
  	                    const t = Number(hit?.t);
  	
  	                    if (Number.isFinite(t) && t > FREE_GROUND_ROUTE_EPS && t < 1 - FREE_GROUND_ROUTE_EPS) {
  	                      cuts.push(t);
  	                    }
  	                  });
  	                }
  	              } catch (_) {}
  	
  	              cuts = Array.from(new Set(cuts.map(value => Number(value).toFixed(12))))
  	              .map(value => Number(value))
  	              .filter(value => Number.isFinite(value) && value >= 0 && value <= 1)
  	              .sort((x, y) => x - y);
  	
  	              for (let i = 0; i < cuts.length - 1; i++) {
  	                const fromT = cuts[i];
  	                const toT = cuts[i + 1];
  	
  	                if (toT - fromT <= FREE_GROUND_ROUTE_EPS) continue;
  	
  	                const midT = fromT + ((toT - fromT) / 2);
  	                const midPoint = interpolatePlotPoint(start, end, midT);
  	
  	                if (!pointInsideOrNearChildParent(midPoint, parentBlocker)) {
  	                  return true;
  	                }
  	              }
  	
  	              return false;
  	            }
  	
  	            function shapeEditRequiredChildOutsideRing(ring, context) {
  	              const children = Array.isArray(context?.containedBlockers)
  	              ? context.containedBlockers: [];
  	
  	              for (let i = 0; i < children.length; i++) {
  	                const childBlocker = children[i];
  	
  	                if (!childBlocker || !Array.isArray(childBlocker.boundary) || childBlocker.boundary.length < 3) {
  	                  continue;
  	                }
  	
  	                try {
  	                  if (!blockerBoundaryIsFullyInsideOuter(childBlocker, ring)) {
  	                    return childBlocker;
  	                  }
  	                } catch (_) {
  	                  continue;
  	                }
  	              }
  	
  	              return null;
  	            }
  	
  	            function shapeEditSnapPoint(point,
  	              rowData,
  	              headingStart) {
  	              const clean = makeCleanPlotPoint(point);
  	
  	              if (!clean) return null;
  	
  	              const context = getShapeEditBoundaryContext(rowData);
  	              const parentBlocker = context.parentBlocker || null;
  	
  	              if (parentBlocker && !pointInsideOrNearChildParent(clean, parentBlocker)) {
  	                let parentAnchor = null;
  	
  	                try {
  	                  parentAnchor = headingStart && typeof getBoundaryAnchorOnHeading === "function"
  	                  ? getBoundaryAnchorOnHeading(headingStart, clean, parentBlocker): null;
  	                } catch (_) {
  	                  parentAnchor = null;
  	                }
  	
  	                if (!parentAnchor) {
  	                  try {
  	                    parentAnchor = typeof nearestBoundaryAnchor === "function"
  	                    ? nearestBoundaryAnchor(clean, parentBlocker): null;
  	                  } catch (_) {
  	                    parentAnchor = null;
  	                  }
  	                }
  	
  	                if (parentAnchor && parentAnchor.point) {
  	                  return makeCleanPlotPoint(parentAnchor.point) || clean;
  	                }
  	              }
  	
  	              const blockers = context.conflictBlockers || [];
  	
  	              if (!blockers.length) return clean;
  	
  	              const SHAPE_EDIT_SNAP_DISTANCE_SQ = 1.6e-8;
  	
  	              let headingSnap = null;
  	
  	              if (typeof getBoundarySnapForPoint === "function") {
  	                try {
  	                  headingSnap = getBoundarySnapForPoint(clean, blockers, {
  	                    snapInside: true,
  	                    snapNearBoundary: false,
  	                    headingStart: headingStart || null
  	                  });
  	                } catch (_) {
  	                  headingSnap = null;
  	                }
  	              }
  	
  	              if (headingSnap && headingSnap.point) {
  	                return makeCleanPlotPoint(headingSnap.point) || clean;
  	              }
  	
  	              let best = null;
  	
  	              blockers.forEach(blocker => {
  	                if (!blocker || !Array.isArray(blocker.boundary) || blocker.boundary.length < 3) return;
  	
  	                let isInside = false;
  	
  	                try {
  	                  isInside = !!pointInStrictPlotBoundary(clean, blocker.boundary);
  	                } catch (_) {
  	                  isInside = false;
  	                }
  	
  	                let anchor = null;
  	
  	                try {
  	                  anchor = typeof nearestBoundaryAnchor === "function"
  	                  ? nearestBoundaryAnchor(clean, blocker): null;
  	                } catch (_) {
  	                  anchor = null;
  	                }
  	
  	                if (!anchor || !anchor.point) return;
  	
  	                const distanceSq = Number(anchor.distanceSq);
  	
  	                if (!Number.isFinite(distanceSq)) return;
  	
  	                const allowedDistanceSq = isInside
  	                ? Number.POSITIVE_INFINITY: SHAPE_EDIT_SNAP_DISTANCE_SQ;
  	
  	                if (distanceSq > allowedDistanceSq) return;
  	
  	                if (!best || distanceSq < best.distanceSq) {
  	                  best = {
  	                    point: anchor.point,
  	                    anchor,
  	                    blocker,
  	                    distanceSq,
  	                    reason: isInside ? "inside-location-boundary-snap": "near-location-boundary-snap"
  	                  };
  	                }
  	              });
  	
  	              if (best && best.point) {
  	                return makeCleanPlotPoint(best.point) || clean;
  	              }
  	
  	              return clean;
  	            }
  	
  	            function shapeEditPointInsideAnyBlocker(point, blockers) {
  	              if (!point || !Array.isArray(blockers)) return null;
  	
  	              for (let i = 0; i < blockers.length; i++) {
  	                const blocker = blockers[i];
  	
  	                if (!blocker || !Array.isArray(blocker.boundary)) continue;
  	
  	                try {
  	                  if (pointInStrictPlotBoundary(point, blocker.boundary)) {
  	                    return blocker;
  	                  }
  	                } catch (_) {}
  	              }
  	
  	              return null;
  	            }
  	
  	            function shapeEditSegmentOccupiesBlocker(a, b, blockers) {
  	              if (!a || !b || !Array.isArray(blockers)) return null;
  	
  	              const mid = {
  	                lat: (Number(a.lat) + Number(b.lat)) / 2,
  	                lng: (Number(a.lng) + Number(b.lng)) / 2
  	              };
  	
  	              const midBlocker = shapeEditPointInsideAnyBlocker(mid, blockers);
  	
  	              if (midBlocker) return midBlocker;
  	
  	              if (typeof getAllBoundaryEventsForSegment === "function") {
  	                try {
  	                  const events = getAllBoundaryEventsForSegment(a, b, blockers);
  	
  	                  if (Array.isArray(events) && events.length >= 2) {
  	                    return events[0]?.blocker || events[0] || null;
  	                  }
  	                } catch (_) {}
  	              }
  	
  	              return null;
  	            }
  	
  	            function shapeEditRingContainsBlocker(ring, blockers) {
  	              if (!Array.isArray(ring) || ring.length < 3 || !Array.isArray(blockers)) return null;
  	
  	              for (let i = 0; i < blockers.length; i++) {
  	                const blocker = blockers[i];
  	
  	                if (!blocker || !Array.isArray(blocker.boundary)) continue;
  	
  	                for (let j = 0; j < blocker.boundary.length; j++) {
  	                  const point = blocker.boundary[j];
  	
  	                  try {
  	                    if (pointInStrictPlotBoundary(point, ring)) {
  	                      return blocker;
  	                    }
  	                  } catch (_) {}
  	                }
  	              }
  	
  	              return null;
  	            }
  	
  	            function shapeEditSegmentsIntersectSelf(points) {
  	              if (!Array.isArray(points) || points.length < 4) return false;
  	              if (typeof lineIntersectionPoint !== "function") return false;
  	
  	              for (let i = 0; i < points.length; i++) {
  	                const a1 = points[i];
  	                const a2 = points[(i + 1) % points.length];
  	
  	                for (let j = i + 1; j < points.length; j++) {
  	                  const b1 = points[j];
  	                  const b2 = points[(j + 1) % points.length];
  	
  	                  const adjacent =
  	                  i === j ||
  	                  (i + 1) % points.length === j ||
  	                  i === (j + 1) % points.length;
  	
  	                  if (adjacent) continue;
  	
  	                  try {
  	                    const hit = lineIntersectionPoint(a1, a2, b1, b2);
  	
  	                    if (!hit || !hit.point) continue;
  	
  	                    if (
  	                      hit.t > FREE_GROUND_ROUTE_EPS &&
  	                      hit.t < 1 - FREE_GROUND_ROUTE_EPS &&
  	                      hit.u > FREE_GROUND_ROUTE_EPS &&
  	                      hit.u < 1 - FREE_GROUND_ROUTE_EPS
  	                    ) {
  	                      return true;
  	                    }
  	                  } catch (_) {}
  	                }
  	              }
  	
  	              return false;
  	            }
  	
  	            function validateShapeEditRing(points, rowData) {
  	              const ring = shapeEditClonePoints(points);
  	
  	              if (ring.length < 3) {
  	                return {
  	                  ok: false,
  	                  reason: "A shape must have at least three points."
  	                };
  	              }
  	
  	              if (shapeEditSegmentsIntersectSelf(ring)) {
  	                return {
  	                  ok: false,
  	                  reason: "The shape cannot cross over itself."
  	                };
  	              }
  	
  	              const context = getShapeEditBoundaryContext(rowData);
  	              const parentBlocker = context.parentBlocker || null;
  	              const blockers = context.conflictBlockers || context.blockers || [];
  	
  	              if (parentBlocker) {
  	                for (let i = 0; i < ring.length; i++) {
  	                  const point = ring[i];
  	
  	                  if (!pointInsideOrNearChildParent(point, parentBlocker)) {
  	                    return {
  	                      ok: false,
  	                      reason: `A child location must stay inside ${parentBlocker.locationName || "its parent location"}.`
  	                    };
  	                  }
  	                }
  	
  	                for (let i = 0; i < ring.length; i++) {
  	                  const a = ring[i];
  	                  const b = ring[(i + 1) % ring.length];
  	
  	                  if (shapeEditSegmentLeavesParent(a, b, parentBlocker)) {
  	                    return {
  	                      ok: false,
  	                      reason: `The child shape edge cannot leave ${parentBlocker.locationName || "its parent location"}.`
  	                    };
  	                  }
  	                }
  	              }
  	
  	              for (let i = 0; i < ring.length; i++) {
  	                const point = ring[i];
  	                const blocker = shapeEditPointInsideAnyBlocker(point, blockers);
  	
  	                if (blocker) {
  	                  return {
  	                    ok: false,
  	                    reason: `A point cannot sit inside ${blocker.locationName || "another location"}.`
  	                  };
  	                }
  	              }
  	
  	              for (let i = 0; i < ring.length; i++) {
  	                const a = ring[i];
  	                const b = ring[(i + 1) % ring.length];
  	                const blocker = shapeEditSegmentOccupiesBlocker(a, b, blockers);
  	
  	                if (blocker) {
  	                  return {
  	                    ok: false,
  	                    reason: `The shape edge cannot pass through ${blocker.locationName || "another location"}.`
  	                  };
  	                }
  	              }
  	
  	              const containedBlocker = shapeEditRingContainsBlocker(ring, blockers);
  	
  	              if (containedBlocker) {
  	                return {
  	                  ok: false,
  	                  reason: `The shape cannot cover ${containedBlocker.locationName || "another location"}.`
  	                };
  	              }
  	
  	              const childOutside = shapeEditRequiredChildOutsideRing(ring, context);
  	
  	              if (childOutside) {
  	                return {
  	                  ok: false,
  	                  reason: `${childOutside.locationName || "A child location"} must remain inside this location.`
  	                };
  	              }
  	
  	              return {
  	                ok: true,
  	                reason: ""
  	              };
  	            }
  	
  	            function setLocationPolygonFromShapeEdit(location, points) {
  	              if (!location || !Array.isArray(points) || points.length < 3) return;
  	
  	              const clean = shapeEditClonePoints(points);
  	              const existingPolygon =
  	              location?.Polygon ||
  	              location?.polygon ||
  	              location?.Boundary ||
  	              location?.boundary ||
  	              null;
  	              const existingCoordinates =
  	              existingPolygon?.coordinates ||
  	              existingPolygon?.Coordinates ||
  	              [];
  	              const preservedHoleCoordinates = Array.isArray(existingCoordinates)
  	              ? existingCoordinates.slice(1).map(ring => {
  	                return Array.isArray(ring)
  	                ? ring.map(point => Array.isArray(point)
  	                  ? [Number(point[0]), Number(point[1])]
  	                  : point
  	                ).filter(point => {
  	                  return Array.isArray(point) &&
  	                  Number.isFinite(point[0]) &&
  	                  Number.isFinite(point[1]);
  	                }): [];
  	              }).filter(ring => ring.length >= 4): [];
  	
  	              const closedCoordinates = clean.map(point => [
  	                Number(point.lng),
  	                Number(point.lat)
  	              ]);
  	
  	              const first = closedCoordinates[0];
  	              const last = closedCoordinates[closedCoordinates.length - 1];
  	
  	              if (
  	                first &&
  	                last &&
  	                (
  	                  Number(first[0]) !== Number(last[0]) ||
  	                  Number(first[1]) !== Number(last[1])
  	                )
  	              ) {
  	                closedCoordinates.push([first[0], first[1]]);
  	              }
  	
  	              const boundaryPoints = clean.map(point => ({
  	                x: Number(point.lng),
  	                y: Number(point.lat),
  	                lng: Number(point.lng),
  	                lat: Number(point.lat)
  	              }));
  	
  	              const nextPolygon = {
  	                type: "Polygon",
  	                coordinates: [closedCoordinates, ...preservedHoleCoordinates],
  	                boundary: {
  	                  points: boundaryPoints
  	                },
  	                points: boundaryPoints
  	              };
  	
  	              location.Polygon = nextPolygon;
  	              location.Boundary = nextPolygon;
  	
  	              if (location.LocationData && typeof location.LocationData === "object") {
  	                location.LocationData.Polygon = nextPolygon;
  	                location.LocationData.Boundary = nextPolygon;
  	              }
  	
  	              if (location.locationData && typeof location.locationData === "object") {
  	                location.locationData.Polygon = nextPolygon;
  	                location.locationData.Boundary = nextPolygon;
  	              }
  	
  	              return nextPolygon;
  	            }
  	
  	            function shapeEditRoundAreaValue(value, decimalPlaces) {
  	              const number = Number(value);
  	              const places = Math.max(0, Math.floor(Number(decimalPlaces) || 0));
  	
  	              if (!Number.isFinite(number)) return 0;
  	
  	              return Number(number.toFixed(places));
  	            }
  	
  	            function updateLocationAreaBeforeShapeSave(location) {
  	              if (!location || typeof location !== "object") {
  	                throw new Error("Cannot update the area because the edited location is missing.");
  	              }
  	
  	              const polygon =
  	              location.Polygon ||
  	              location.polygon ||
  	              location.Boundary ||
  	              location.boundary ||
  	              null;
  	
  	              if (!polygon) {
  	                throw new Error("Cannot update the area because the edited polygon is missing.");
  	              }
  	
  	              const areaM2 = Number(computeSavePolygonAreaM2(polygon));
  	
  	              if (!Number.isFinite(areaM2) || areaM2 <= 0) {
  	                throw new Error("The edited shape does not have a valid measurable area.");
  	              }
  	
  	              const areaHa = areaM2 / 10000;
  	              const acres = areaM2 * 0.000247105;
  	              const roundedM2 = shapeEditRoundAreaValue(areaM2, 2);
  	              const roundedHa = shapeEditRoundAreaValue(areaHa, 4);
  	              const roundedDataHa = shapeEditRoundAreaValue(areaHa, 6);
  	              const roundedAcres = shapeEditRoundAreaValue(acres, 2);
  	
  	              let data = null;
  	
  	              if (location.LocationData && typeof location.LocationData === "object") {
  	                data = location.LocationData;
  	              } else if (location.locationData && typeof location.locationData === "object") {
  	                data = location.locationData;
  	              } else if (location.Data && typeof location.Data === "object") {
  	                data = location.Data;
  	              } else if (location.data && typeof location.data === "object") {
  	                data = location.data;
  	              } else {
  	                location.LocationData = {};
  	                data = location.LocationData;
  	              }
  	
  	              let area = null;
  	
  	              if (data.Area && typeof data.Area === "object") {
  	                area = data.Area;
  	              } else if (data.area && typeof data.area === "object") {
  	                area = data.area;
  	              } else {
  	                data.Area = {};
  	                area = data.Area;
  	              }
  	
  	              // Canonical fields used by newly created Locations.
  	              area.m2 = roundedM2;
  	              area.Hectares = roundedDataHa;
  	              area.Acres = roundedAcres;
  	
  	              // Keep older casing variants synchronized when they already exist.
  	              if (Object.prototype.hasOwnProperty.call(area, "M2")) area.M2 = roundedM2;
  	              if (Object.prototype.hasOwnProperty.call(area, "SquareMeters")) area.SquareMeters = roundedM2;
  	              if (Object.prototype.hasOwnProperty.call(area, "squareMeters")) area.squareMeters = roundedM2;
  	              if (Object.prototype.hasOwnProperty.call(area, "hectares")) area.hectares = roundedDataHa;
  	              if (Object.prototype.hasOwnProperty.call(area, "Ha")) area.Ha = roundedDataHa;
  	              if (Object.prototype.hasOwnProperty.call(area, "ha")) area.ha = roundedDataHa;
  	              if (Object.prototype.hasOwnProperty.call(area, "HA")) area.HA = roundedDataHa;
  	              if (Object.prototype.hasOwnProperty.call(area, "acres")) area.acres = roundedAcres;
  	
  	              location.AreaHa = roundedHa;
  	
  	              if (Object.prototype.hasOwnProperty.call(location, "areaHa")) location.areaHa = roundedHa;
  	              if (Object.prototype.hasOwnProperty.call(location, "AreaM2")) location.AreaM2 = roundedM2;
  	              if (Object.prototype.hasOwnProperty.call(location, "areaM2")) location.areaM2 = roundedM2;
  	              if (Object.prototype.hasOwnProperty.call(location, "Hectares")) location.Hectares = roundedDataHa;
  	              if (Object.prototype.hasOwnProperty.call(location, "hectares")) location.hectares = roundedDataHa;
  	
  	              // The stored resolved geometry must describe the same boundary whose
  	              // area was just measured. Preserve unrelated geometry metadata.
  	              if (data.Geometry && typeof data.Geometry === "object") {
  	                data.Geometry.resolvedPoints = shapeEditClonePoints(
  	                  polygon?.boundary?.points || polygon?.points || []
  	                );
  	              } else if (data.geometry && typeof data.geometry === "object") {
  	                data.geometry.resolvedPoints = shapeEditClonePoints(
  	                  polygon?.boundary?.points || polygon?.points || []
  	                );
  	              }
  	
  	              return {
  	                areaM2: roundedM2,
  	                areaHa: roundedHa,
  	                dataAreaHa: roundedDataHa,
  	                acres: roundedAcres
  	              };
  	            }
  	
  	            function shapeEditFlashProblem(session, message) {
  	              if (!session) return;
  	
  	              session.lastProblem = message || "Invalid shape edit.";
  	
  	              try {
  	                const messageNode = actionCard.querySelector("[data-shape-edit-message]");
  	
  	                if (messageNode) {
  	                  messageNode.textContent = session.lastProblem;
  	                  messageNode.classList.add("is-error");
  	
  	                  setTimeout(() => {
  	                    try {
  	                      messageNode.classList.remove("is-error");
  	                    } catch (_) {}
  	                  }, 900);
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                if (session.polygon && typeof session.polygon.setOptions === "function") {
  	                  session.polygon.setOptions({
  	                    strokeColor: "#ff3333",
  	                    fillColor: "#ff3333"
  	                  });
  	
  	                  setTimeout(() => {
  	                    try {
  	                      session.polygon.setOptions({
  	                        strokeColor: session.color,
  	                        fillColor: session.color
  	                      });
  	                    } catch (_) {}
  	                  }, 450);
  	                }
  	              } catch (_) {}
  	            }
  	
  	            function stopShapeEditSession(options) {
  	              const opts = options || {};
  	              const session = activeShapeEditSession;
  	
  	              if (!session) return;
  	
  	              try {
  	                session.listeners.forEach(listener => {
  	                  try {
  	                    if (listener && typeof listener.remove === "function") {
  	                      listener.remove();
  	                    } else if (google?.maps?.event?.removeListener) {
  	                      google.maps.event.removeListener(listener);
  	                    }
  	                  } catch (_) {}
  	                });
  	              } catch (_) {}
  	
  	              try {
  	                if (session.polygon) {
  	                  session.polygon.setEditable(false);
  	                  session.polygon.setDraggable(false);
  	
  	                  if (opts.restoreOriginal) {
  	                    const path = session.polygon.getPath();
  	
  	                    shapeEditSetPath(path, session.originalPoints);
  	                  }
  	
  	                  session.polygon.setOptions({
  	                    strokeColor: session.color,
  	                    fillColor: session.color,
  	                    strokeWeight: 2,
  	                    zIndex: session.originalZIndex || undefined
  	                  });
  	                }
  	              } catch (_) {}
  	
  	              activeShapeEditSession = null;
  	            }
  	
  	            function setShapeEditMessage(session, message, isError) {
  	              if (!session || !session.messageNode) return;
  	
  	              session.messageNode.textContent = message || "";
  	
  	              if (isError) {
  	                session.messageNode.classList.add("is-error");
  	              } else {
  	                session.messageNode.classList.remove("is-error");
  	              }
  	            }
  	
  	            function shapeEditGetSafeIndex(session, index) {
  	              if (!session || !session.path) return -1;
  	
  	              const n = session.path.getLength();
  	
  	              const i = Number(index);
  	
  	              if (!Number.isFinite(i)) return -1;
  	              if (i < 0 || i >= n) return -1;
  	
  	              return i;
  	            }
  	
  	            function shapeEditGetHeadingStartForIndex(session, index) {
  	              if (!session || !session.path) return null;
  	
  	              const path = session.path;
  	              const n = path.getLength();
  	
  	              if (!Number.isFinite(Number(index)) || index < 0 || index >= n) return null;
  	
  	              const previousIndex = index > 0 ? index - 1: n - 1;
  	              const previous = shapeEditLatLngToPlain(path.getAt(previousIndex));
  	
  	              return previous || null;
  	            }
  	
  	            function shapeEditRemovePointAtIndex(session, index) {
  	              if (!session || !session.path) return false;
  	
  	              const path = session.path;
  	              const safeIndex = shapeEditGetSafeIndex(session, index);
  	
  	              if (safeIndex < 0) {
  	                setShapeEditMessage(session, "Right-click directly on a point to delete it.", true);
  	                return false;
  	              }
  	
  	              if (path.getLength() <= 3) {
  	                setShapeEditMessage(session, "A shape must keep at least three points.", true);
  	                return false;
  	              }
  	
  	              session.isInternalChange = true;
  	
  	              try {
  	                path.removeAt(safeIndex);
  	
  	                const candidate = shapeEditReadPath(path);
  	                const validation = validateShapeEditRing(candidate, session.rowData);
  	
  	                if (!validation.ok) {
  	                  shapeEditSetPath(path, session.previousValidPoints);
  	                  shapeEditFlashProblem(session, validation.reason);
  	                  return false;
  	                }
  	
  	                session.previousValidPoints = shapeEditClonePoints(candidate);
  	                setShapeEditMessage(session, "Point deleted. Shape edit is valid.", false);
  	
  	                return true;
  	              } finally {
  	                session.isInternalChange = false;
  	              }
  	            }
  	
  	            function bindShapeEditPathEvents(session) {
  	              if (!session || !session.path) return;
  	
  	              function handlePathChanged(index) {
  	                if (!activeShapeEditSession || activeShapeEditSession !== session) return;
  	                if (session.isInternalChange) return;
  	
  	                session.isInternalChange = true;
  	
  	                try {
  	                  const path = session.path;
  	                  const safeIndex = shapeEditGetSafeIndex(session, index);
  	
  	                  if (safeIndex >= 0) {
  	                    const current = shapeEditLatLngToPlain(path.getAt(safeIndex));
  	                    const headingStart = shapeEditGetHeadingStartForIndex(session, safeIndex);
  	                    const snapped = shapeEditSnapPoint(current, session.rowData, headingStart);
  	
  	                    if (snapped) {
  	                      path.setAt(safeIndex, shapeEditPlainToLatLng(snapped));
  	                    }
  	                  }
  	
  	                  const candidate = shapeEditReadPath(path);
  	                  const validation = validateShapeEditRing(candidate, session.rowData);
  	
  	                  if (!validation.ok) {
  	                    shapeEditSetPath(path, session.previousValidPoints);
  	                    shapeEditFlashProblem(session, validation.reason);
  	                    return;
  	                  }
  	
  	                  session.previousValidPoints = shapeEditClonePoints(candidate);
  	                  setShapeEditMessage(session, "Shape edit is valid. Drag points, then save.", false);
  	                } finally {
  	                  session.isInternalChange = false;
  	                }
  	              }
  	
  	              session.listeners.push(session.path.addListener("set_at", index => {
  	                handlePathChanged(index);
  	              }));
  	
  	              session.listeners.push(session.path.addListener("insert_at", index => {
  	                handlePathChanged(index);
  	              }));
  	
  	              session.listeners.push(session.path.addListener("remove_at", () => {
  	                if (session.isInternalChange) return;
  	
  	                session.isInternalChange = true;
  	
  	                try {
  	                  shapeEditSetPath(session.path, session.previousValidPoints);
  	                  setShapeEditMessage(session, "Use right-click on a point to delete it.", true);
  	                } finally {
  	                  session.isInternalChange = false;
  	                }
  	              }));
  	
  	              if (session.polygon && typeof session.polygon.addListener === "function") {
  	                session.listeners.push(session.polygon.addListener("rightclick", event => {
  	                  if (!event || !Number.isFinite(Number(event.vertex))) return;
  	
  	                  try {
  	                    if (event.domEvent && typeof event.domEvent.preventDefault === "function") {
  	                      event.domEvent.preventDefault();
  	                    }
  	                  } catch (_) {}
  	
  	                  shapeEditRemovePointAtIndex(session, Number(event.vertex));
  	                }));
  	              }
  	            }
  	
  	            function renderShapeEditCard(session) {
  	              if (!session || !actionCard) return;
  	
  	              const label = safeString(session.rowData?.label || getLocationLabel(session.location) || "Location");
  	
  	              actionCard.classList.add("editing");
  	              actionCard.classList.add("shape-editing");
  	
  	              actionCard.innerHTML = `
  	              <div class="trackit-action-card-inner trackit-shape-edit-inner">
  	              <div class="trackit-action-card-head trackit-shape-edit-head">
  	              <div>
  	              <div class="trackit-action-card-title">${escapeHtml(label)}</div>
  	              <div class="trackit-action-card-subtitle">Edit Shape</div>
  	              </div>
  	              </div>
  	
  	              <div class="trackit-shape-edit-status" data-shape-edit-message>
  	              Drag points. Right-click a point to delete it. Save or cancel to leave edit mode.
  	              </div>
  	
  	              <div class="trackit-shape-edit-actions trackit-shape-edit-actions-two">
  	              <button class="trackit-shape-edit-btn primary" type="button" data-card-action="saveShapeEdit">
  	              Save
  	              </button>
  	
  	              <button class="trackit-shape-edit-btn danger" type="button" data-card-action="cancelShapeEdit">
  	              Cancel
  	              </button>
  	              </div>
  	              </div>
  	              `;
  	
  	              session.messageNode = actionCard.querySelector("[data-shape-edit-message]");
  	
  	              notifyCarvedShellLayout();
  	              setTimeout(notifyCarvedShellLayout, 80);
  	              setTimeout(notifyCarvedShellLayout, 220);
  	            }
  	
  	            function beginShapeEdit(rowData) {
  	              if (!rowData || !rowData.location) return;
  	
  	              const polygon = getShapeEditPolygon(rowData);
  	              const map = getShapeEditMap(rowData);
  	
  	              if (!polygon || !map) {
  	                window.alert("This location shape is not ready on the map yet. Click the location again and try Edit Shape.");
  	                return;
  	              }
  	
  	              stopShapeEditSession({
  	                restoreOriginal: false
  	              });
  	
  	              const path = typeof polygon.getPath === "function" ? polygon.getPath(): null;
  	
  	              if (!path || typeof path.getLength !== "function" || path.getLength() < 3) {
  	                window.alert("This shape cannot be edited as a polygon yet.");
  	                return;
  	              }
  	
  	              const originalPoints = shapeEditReadPath(path);
  	              const validation = validateShapeEditRing(originalPoints, rowData);
  	
  	              if (!validation.ok) {
  	                window.alert("This shape cannot enter edit mode yet:\n\n" + validation.reason);
  	                return;
  	              }
  	
  	              const color = getCardColor(rowData.location) || "#ff9a3d";
  	
  	              activeShapeEditSession = {
  	                rowData,
  	                location: rowData.location,
  	                polygon,
  	                map,
  	                path,
  	                originalPoints: shapeEditClonePoints(originalPoints),
  	                previousValidPoints: shapeEditClonePoints(originalPoints),
  	                listeners: [],
  	                isInternalChange: false,
  	                color,
  	                originalZIndex: polygon.zIndex || null,
  	                messageNode: null,
  	                lastProblem: ""
  	              };
  	
  	              try {
  	                polygon.setOptions({
  	                  strokeColor: "#ff9a3d",
  	                  fillColor: color,
  	                  strokeWeight: 4,
  	                  zIndex: 2147483000
  	                });
  	
  	                polygon.setEditable(true);
  	                polygon.setDraggable(false);
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not enable editable polygon.", error);
  	              }
  	
  	              bindShapeEditPathEvents(activeShapeEditSession);
  	              renderShapeEditCard(activeShapeEditSession);
  	
  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "editShape",
  	                cardType: "location-shape-edit-card",
  	                placeholder: false
  	              });
  	            }
  	
  	            async function saveShapeEdit(rowData) {
  	              const session = activeShapeEditSession;
  	
  	              if (!session || session.rowData !== rowData) {
  	                window.alert("No active shape edit session found.");
  	                return;
  	              }
  	
  	              const points = shapeEditReadPath(session.path);
  	              const validation = validateShapeEditRing(points, rowData);
  	
  	              if (!validation.ok) {
  	                shapeEditFlashProblem(session, validation.reason);
  	                window.alert(validation.reason);
  	                return;
  	              }
  	
  	              const saveButton = actionCard.querySelector('[data-card-action="saveShapeEdit"]');
  	
  	              if (saveButton) {
  	                saveButton.disabled = true;
  	                saveButton.classList.add("saving");
  	              }
  	
  	              try {
  	                const finalPoints = shapeEditClonePoints(points);
  	
  	                setLocationPolygonFromShapeEdit(rowData.location, finalPoints);
  	
  	                // Sacred order for a shape edit:
  	                // 1. Replace the polygon.
  	                // 2. Measure the new usable area, including preserved holes.
  	                // 3. Update every stored area field.
  	                // 4. Only then refresh local state and persist the Location.
  	                const updatedArea = updateLocationAreaBeforeShapeSave(
  	                  rowData.location
  	                );
  	
  	                try {
  	                  writeSelectedLocationToAppData(rowData.location);
  	                } catch (_) {}
  	
  	                try {
  	                  if (typeof refreshEditedLocationEverywhere === "function") {
  	                    refreshEditedLocationEverywhere(rowData, "location-shape-edit-save-local");
  	                  }
  	                } catch (_) {}
  	
  	                if (typeof persistEditedLocationToBackendless === "function") {
  	                  await persistEditedLocationToBackendless(rowData.location);
  	                }
  	
  	                FIF_SILENT_CONSOLE.groupCollapsed("[TrackIT Location Dropdown] Shape Area Updated");
  	                FIF_SILENT_CONSOLE.log("Location:", rowData.location);
  	                FIF_SILENT_CONSOLE.log("Area m2:", updatedArea.areaM2);
  	                FIF_SILENT_CONSOLE.log("Area ha:", updatedArea.areaHa);
  	                FIF_SILENT_CONSOLE.log("Area acres:", updatedArea.acres);
  	                FIF_SILENT_CONSOLE.groupEnd();
  	
  	                stopShapeEditSession({
  	                  restoreOriginal: false
  	                });
  	
  	                try {
  	                  const runtime = getShapeEditRuntime();
  	
  	                  if (runtime && typeof runtime.refresh === "function") {
  	                    runtime.refresh({
  	                      reason: "location-shape-edit-save",
  	                      doFitBounds: false
  	                    });
  	                  } else if (typeof renderSavedLocationsOnMap === "function") {
  	                    renderSavedLocationsOnMap(MAP_INPUT, {
  	                      reason: "location-shape-edit-save",
  	                      doFitBounds: false
  	                    });
  	                  }
  	                } catch (_) {}
  	
  	                emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                  action: "saveShapeEdit",
  	                  cardType: "location-shape-edit-card",
  	                  placeholder: false
  	                });
  	
  	                actionCard.classList.remove("shape-editing");
  	                actionCard.classList.remove("editing");
  	
  	                openLocationActionCard(rowData);
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.error("[TrackIT Location Dropdown] Save shape edit failed.", error);
  	
  	                window.alert(
  	                  "The shape edit could not be saved.\n\n" +
  	                  (error?.message || error?.faultString || "Unknown error")
  	                );
  	              } finally {
  	                if (saveButton) {
  	                  saveButton.disabled = false;
  	                  saveButton.classList.remove("saving");
  	                }
  	              }
  	            }
  	
  	            function cancelShapeEdit(rowData) {
  	              stopShapeEditSession({
  	                restoreOriginal: true
  	              });
  	
  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "cancelShapeEdit",
  	                cardType: "location-shape-edit-card",
  	                placeholder: false
  	              });
  	
  	              actionCard.classList.remove("shape-editing");
  	              actionCard.classList.remove("editing");
  	
  	              openLocationActionCard(rowData);
  	            }
  	
  	            function isEntranceEditActive() {
  	              return !!activeEntranceEditSession;
  	            }
  	
  	            function getEntranceEditMap(rowData) {
  	              try {
  	                if (typeof getShapeEditMap === "function") {
  	                  const shapeMap = getShapeEditMap(rowData);
  	
  	                  if (shapeMap) return shapeMap;
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                return resolveGMap(MapRoot);
  	              } catch (_) {
  	                return null;
  	              }
  	            }
  	
  	            function cloneEntrancePoint(point) {
  	              if (!point) return null;
  	
  	              if (
  	                point &&
  	                typeof point === "object" &&
  	                safeString(point.type).toLowerCase() === "point" &&
  	                Array.isArray(point.coordinates) &&
  	                point.coordinates.length >= 2
  	              ) {
  	                const lng = Number(point.coordinates[0]);
  	                const lat = Number(point.coordinates[1]);
  	
  	                if (Number.isFinite(lat) && Number.isFinite(lng)) {
  	                  return {
  	                    lat,
  	                    lng
  	                  };
  	                }
  	              }
  	
  	              if (typeof point === "string") {
  	                const match = point.match(/POINT\s*\(\s*([-0-9.]+)\s+([-0-9.]+)\s*\)/i);
  	
  	                if (match) {
  	                  const lng = Number(match[1]);
  	                  const lat = Number(match[2]);
  	
  	                  if (Number.isFinite(lat) && Number.isFinite(lng)) {
  	                    return {
  	                      lat,
  	                      lng
  	                    };
  	                  }
  	                }
  	              }
  	
  	              const lat = Number(
  	                point.lat ??
  	                point.latitude ??
  	                point.Latitude ??
  	                point.y
  	              );
  	
  	              const lng = Number(
  	                point.lng ??
  	                point.longitude ??
  	                point.Longitude ??
  	                point.x
  	              );
  	
  	              if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  	
  	              return {
  	                lat,
  	                lng
  	              };
  	            }
  	
  	            function getLocationEntrancePoint(location) {
  	              return (
  	                cloneEntrancePoint(location?.EntrancePoint) ||
  	                cloneEntrancePoint(location?.entrancePoint) ||
  	                cloneEntrancePoint(location?.Entrance) ||
  	                cloneEntrancePoint(location?.entrance) ||
  	                cloneEntrancePoint(location?.EntryPoint) ||
  	                cloneEntrancePoint(location?.entryPoint) ||
  	                cloneEntrancePoint(location?.LocationData?.Shape?.EntrancePoint) ||
  	                cloneEntrancePoint(location?.LocationData?.EntrancePoint) ||
  	                cloneEntrancePoint(location?.LocationData?.entrancePoint) ||
  	                null
  	              );
  	            }
  	
  	            function makeEntrancePlainPoint(point) {
  	              const clean = cloneEntrancePoint(point);
  	
  	              if (!clean) return null;
  	
  	              return {
  	                lat: Number(clean.lat),
  	                lng: Number(clean.lng),
  	                x: Number(clean.lng),
  	                y: Number(clean.lat)
  	              };
  	            }
  	
  	            function makeEntranceGisPoint(point) {
  	              const clean = cloneEntrancePoint(point);
  	
  	              if (!clean) return null;
  	
  	              if (typeof buildSavePoint === "function") {
  	                return buildSavePoint(clean);
  	              }
  	
  	              return {
  	                type: "Point",
  	                coordinates: [
  	                  Number(clean.lng),
  	                  Number(clean.lat)
  	                ]
  	              };
  	            }
  	
  	            function removeEntranceAliasFields(target) {
  	              if (!target || typeof target !== "object") return;
  	
  	              delete target.entrancePoint;
  	              delete target.Entrance;
  	              delete target.entrance;
  	              delete target.EntryPoint;
  	              delete target.entryPoint;
  	            }
  	
  	            function normaliseEntranceFieldsForBackendless(location) {
  	              if (!location || typeof location !== "object") return;
  	
  	              const existingEntrance = cloneEntrancePoint(
  	                location.EntrancePoint ||
  	                location.entrancePoint ||
  	                location.Entrance ||
  	                location.entrance ||
  	                location.EntryPoint ||
  	                location.entryPoint ||
  	                location.LocationData?.Shape?.EntrancePoint ||
  	                location.LocationData?.EntrancePoint ||
  	                location.LocationData?.entrancePoint ||
  	                null
  	              );
  	
  	              removeEntranceAliasFields(location);
  	
  	              if (existingEntrance) {
  	                location.EntrancePoint = makeEntranceGisPoint(existingEntrance);
  	              }
  	
  	              if (location.LocationData && typeof location.LocationData === "object") {
  	                removeEntranceAliasFields(location.LocationData);
  	
  	                if (!location.LocationData.Shape || typeof location.LocationData.Shape !== "object") {
  	                  location.LocationData.Shape = {};
  	                }
  	
  	                removeEntranceAliasFields(location.LocationData.Shape);
  	
  	                if (existingEntrance) {
  	                  location.LocationData.Shape.EntrancePoint = makeEntrancePlainPoint(existingEntrance);
  	                }
  	              }
  	
  	              if (location.Shape && typeof location.Shape === "object") {
  	                removeEntranceAliasFields(location.Shape);
  	              }
  	            }
  	
  	            function setLocationEntrancePoint(location, point) {
  	              if (!location || !point) return;
  	
  	              const clean = cloneEntrancePoint(point);
  	
  	              if (!clean) return;
  	
  	              normaliseEntranceFieldsForBackendless(location);
  	
  	              location.EntrancePoint = makeEntranceGisPoint(clean);
  	
  	              if (!location.LocationData || typeof location.LocationData !== "object") {
  	                location.LocationData = {};
  	              }
  	
  	              if (!location.LocationData.Shape || typeof location.LocationData.Shape !== "object") {
  	                location.LocationData.Shape = {};
  	              }
  	
  	              location.LocationData.Shape.EntrancePoint = makeEntrancePlainPoint(clean);
  	
  	              normaliseEntranceFieldsForBackendless(location);
  	            }
  	
  	            function getEntranceEditBoundary(rowData) {
  	              if (!rowData || !rowData.location) return [];
  	
  	              let boundary = [];
  	
  	              try {
  	                if (typeof getPolygonLatLngsFromLocation === "function") {
  	                  boundary = getPolygonLatLngsFromLocation(rowData.location) || [];
  	                }
  	              } catch (_) {
  	                boundary = [];
  	              }
  	
  	              if ((!boundary || !boundary.length) && typeof getShapeEditPolygon === "function") {
  	                try {
  	                  const polygon = getShapeEditPolygon(rowData);
  	                  const path = polygon?.getPath?.();
  	
  	                  if (path && typeof shapeEditReadPath === "function") {
  	                    boundary = shapeEditReadPath(path);
  	                  }
  	                } catch (_) {}
  	              }
  	
  	              return Array.isArray(boundary)
  	              ? boundary
  	              .map(point => makeCleanPlotPoint(point))
  	              .filter(Boolean): [];
  	            }
  	
  	            function snapshotEntranceCreateState() {
  	              return {
  	                isPickingEntrance: createState.isPickingEntrance,
  	                entrancePoint: createState.entrancePoint ? {
  	                  ...createState.entrancePoint
  	                }: null,
  	                entranceMarker: createState.entranceMarker || null,
  	                plotDraftMap: createState.plotDraftMap || null,
  	                plotPoints: Array.isArray(createState.plotPoints) ? createState.plotPoints.slice(): [],
  	                plotRawPoints: Array.isArray(createState.plotRawPoints) ? createState.plotRawPoints.slice(): [],
  	                plotResolvedPoints: Array.isArray(createState.plotResolvedPoints) ? createState.plotResolvedPoints.slice(): []
  	              };
  	            }
  	
  	            function restoreEntranceCreateState(snapshot) {
  	              if (!snapshot) return;
  	
  	              createState.isPickingEntrance = snapshot.isPickingEntrance;
  	              createState.entrancePoint = snapshot.entrancePoint ? {
  	                ...snapshot.entrancePoint
  	              }: null;
  	              createState.entranceMarker = snapshot.entranceMarker || null;
  	              createState.plotDraftMap = snapshot.plotDraftMap || null;
  	              createState.plotPoints = Array.isArray(snapshot.plotPoints) ? snapshot.plotPoints.slice(): [];
  	              createState.plotRawPoints = Array.isArray(snapshot.plotRawPoints) ? snapshot.plotRawPoints.slice(): [];
  	              createState.plotResolvedPoints = Array.isArray(snapshot.plotResolvedPoints) ? snapshot.plotResolvedPoints.slice(): [];
  	            }
  	
  	            function hydrateCreateStateForEntranceEdit(rowData, map) {
  	              const boundary = getEntranceEditBoundary(rowData);
  	
  	              if (!Array.isArray(boundary) || boundary.length < 3) {
  	                return false;
  	              }
  	
  	              createState.plotDraftMap = map || getEntranceEditMap(rowData);
  	              createState.plotPoints = boundary.slice();
  	              createState.plotRawPoints = boundary.slice();
  	              createState.plotResolvedPoints = boundary.slice();
  	              createState.isPickingEntrance = true;
  	
  	              return true;
  	            }
  	
  	            function setEntranceEditMessage(message, isError) {
  	              const session = activeEntranceEditSession;
  	
  	              if (!session || !session.messageNode) return;
  	
  	              session.messageNode.textContent = message || "";
  	
  	              if (isError) {
  	                session.messageNode.classList.add("is-error");
  	              } else {
  	                session.messageNode.classList.remove("is-error");
  	              }
  	            }
  	
  	            function renderEntranceEditCard(session) {
  	              if (!session || !actionCard) return;
  	
  	              const label = safeString(
  	                session.rowData?.label ||
  	                getLocationLabel(session.location) ||
  	                "Location"
  	              );
  	
  	              actionCard.classList.add("editing");
  	              actionCard.classList.add("entrance-editing");
  	
  	              actionCard.innerHTML = `
  	              <div class="trackit-action-card-inner trackit-entrance-edit-inner">
  	              <div class="trackit-action-card-head trackit-entrance-edit-head">
  	              <div>
  	              <div class="trackit-action-card-title">${escapeHtml(label)}</div>
  	              <div class="trackit-action-card-subtitle">Pick Entrance</div>
  	              </div>
  	              </div>
  	
  	              <div class="trackit-entrance-edit-status" data-entrance-edit-message>
  	              Click near the selected location boundary. The marker will snap to the boundary and can be dragged along it.
  	              </div>
  	
  	              <div class="trackit-entrance-edit-actions">
  	              <button class="trackit-entrance-edit-btn primary" type="button" data-card-action="saveEntranceEdit">
  	              Save
  	              </button>
  	
  	              <button class="trackit-entrance-edit-btn danger" type="button" data-card-action="cancelEntranceEdit">
  	              Cancel
  	              </button>
  	              </div>
  	              </div>
  	              `;
  	
  	              session.messageNode = actionCard.querySelector("[data-entrance-edit-message]");
  	
  	              actionCard.classList.add("open");
  	
  	              notifyCarvedShellLayout();
  	              setTimeout(notifyCarvedShellLayout, 80);
  	              setTimeout(notifyCarvedShellLayout, 220);
  	            }
  	
  	            function stopEntranceEditSession(options) {
  	              const opts = options || {};
  	              const session = activeEntranceEditSession;
  	
  	              if (!session) return;
  	
  	              try {
  	                if (session.mapClickListener && typeof session.mapClickListener.remove === "function") {
  	                  session.mapClickListener.remove();
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                if (typeof window !== "undefined") {
  	                  delete window.__TrackITHandleEntranceEditMapClick;
  	                }
  	              } catch (_) {}
  	
  	              try {
  	                if (createState.entranceMarker && createState.entranceMarker !== session.previousCreateState?.entranceMarker) {
  	                  createState.entranceMarker.setMap(null);
  	                }
  	              } catch (_) {}
  	
  	              restoreEntranceCreateState(session.previousCreateState);
  	
  	              try {
  	                actionCard.classList.remove("entrance-editing");
  	                actionCard.classList.remove("editing");
  	              } catch (_) {}
  	
  	              activeEntranceEditSession = null;
  	            }
  	
  	            function handleEntranceEditMapClick(input) {
  	              const session = activeEntranceEditSession;
  	
  	              if (!session) return false;
  	
  	              const map = input?.map || session.map;
  	              const rawPoint =
  	              input?.point ||
  	              latLngEventToPlain(input?.event?.latLng) ||
  	              null;
  	
  	              if (!rawPoint) {
  	                setEntranceEditMessage("Click near the boundary to place the entrance.", true);
  	                return true;
  	              }
  	
  	              const picked = setEntrancePointSnapped(map, rawPoint);
  	
  	              createState.isPickingEntrance = true;
  	
  	              if (!picked || !createState.entrancePoint) {
  	                setEntranceEditMessage("Could not snap entrance to this boundary. Click closer to the selected location edge.", true);
  	                return true;
  	              }
  	
  	              session.hasPicked = true;
  	
  	              setEntranceEditMessage("Entrance selected. Drag the marker along the boundary, then save.", false);
  	
  	              return true;
  	            }
  	
  	            function beginEntranceEdit(rowData) {
  	              if (!rowData || !rowData.location) return;
  	
  	              const map = getEntranceEditMap(rowData);
  	
  	              if (!map) {
  	                window.alert("The map is not ready yet. Click the location again and try Set Entrance.");
  	                return;
  	              }
  	
  	              const boundary = getEntranceEditBoundary(rowData);
  	
  	              if (!Array.isArray(boundary) || boundary.length < 3) {
  	                window.alert("This location has no editable boundary for an entrance.");
  	                return;
  	              }
  	
  	              stopEntranceEditSession();
  	
  	              const previousCreateState = snapshotEntranceCreateState();
  	
  	              try {
  	                clearEntrancePointDraft();
  	              } catch (_) {}
  	
  	              activeEntranceEditSession = {
  	                rowData,
  	                location: rowData.location,
  	                map,
  	                previousCreateState,
  	                originalEntrance: getLocationEntrancePoint(rowData.location),
  	                hasPicked: false,
  	                mapClickListener: null,
  	                messageNode: null
  	              };
  	
  	              hydrateCreateStateForEntranceEdit(rowData, map);
  	
  	              const existingEntrance = activeEntranceEditSession.originalEntrance;
  	
  	              if (existingEntrance) {
  	                setEntrancePointSnapped(map, existingEntrance);
  	                createState.isPickingEntrance = true;
  	                activeEntranceEditSession.hasPicked = true;
  	              }
  	
  	              try {
  	                activeEntranceEditSession.mapClickListener = map.addListener("click", event => {
  	                  handleEntranceEditMapClick({
  	                    event,
  	                    map,
  	                    source: "map-click"
  	                  });
  	                });
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Entrance Edit] Could not bind map click.", error);
  	              }
  	
  	              try {
  	                if (typeof window !== "undefined") {
  	                  window.__TrackITHandleEntranceEditMapClick = handleEntranceEditMapClick;
  	                }
  	              } catch (_) {}
  	
  	              renderEntranceEditCard(activeEntranceEditSession);
  	
  	              if (existingEntrance) {
  	                setEntranceEditMessage("Existing entrance loaded. Drag it or click the boundary to move it, then save.", false);
  	              }
  	
  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "setEntrance",
  	                cardType: "location-entrance-edit-card",
  	                placeholder: false
  	              });
  	            }
  	
  	            async function saveEntranceEdit(rowData) {
  	              const session = activeEntranceEditSession;
  	
  	              if (!session || session.rowData !== rowData) {
  	                window.alert("No active entrance edit session found.");
  	                return;
  	              }
  	
  	              const point = cloneEntrancePoint(createState.entrancePoint);
  	
  	              if (!point) {
  	                window.alert("Please click the boundary to set an entrance point first.");
  	                return;
  	              }
  	
  	              const saveButton = actionCard.querySelector('[data-card-action="saveEntranceEdit"]');
  	
  	              if (saveButton) {
  	                saveButton.disabled = true;
  	                saveButton.classList.add("saving");
  	              }
  	
  	              try {
  	                setLocationEntrancePoint(rowData.location, point);
  	                normaliseEntranceFieldsForBackendless(rowData.location);
  	
  	                refreshEditedLocationEverywhere(rowData, "location-entrance-save-local");
  	
  	                if (typeof persistEditedLocationToBackendless === "function") {
  	                  await persistEditedLocationToBackendless(rowData.location);
  	                }
  	
  	                refreshEditedLocationEverywhere(rowData, "location-entrance-save-complete");
  	
  	                stopEntranceEditSession({
  	                  restoreOriginal: false
  	                });
  	
  	                openLocationActionCard(rowData);
  	              } catch (error) {
  	                FIF_SILENT_CONSOLE.error("[TrackIT Entrance Edit] Save failed.", error);
  	
  	                window.alert(
  	                  "The entrance could not be saved.\n\n" +
  	                  (error?.message || error?.faultString || "Unknown error")
  	                );
  	              } finally {
  	                if (saveButton) {
  	                  saveButton.disabled = false;
  	                  saveButton.classList.remove("saving");
  	                }
  	              }
  	            }
  	
  	            function cancelEntranceEdit(rowData) {
  	              stopEntranceEditSession({
  	                restoreOriginal: true
  	              });
  	
  	              if (rowData) {
  	                openLocationActionCard(rowData);
  	              }
  	            }
  	
  	            function cancelActiveEntranceEditBecauseClosed(reason) {
  	              const session = activeEntranceEditSession;
  	
  	              if (!session) return false;
  	
  	              const rowData = session.rowData || selectedRowData || null;
  	
  	              stopEntranceEditSession({
  	                restoreOriginal: true
  	              });
  	
  	              try {
  	                if (rowData) {
  	                  emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                    action: "cancelEntranceEdit",
  	                    cardType: "location-entrance-edit-card",
  	                    reason: reason || "card-closed",
  	                    placeholder: false
  	                  });
  	                }
  	              } catch (_) {}
  	
  	              return true;
  	            }
  	
  	            function setEntrancePlaceholder(rowData) {
  	              beginEntranceEdit(rowData);
  	            }
  	
  	            function openLocationActionCard(rowData) {
  	              if (!rowData) return;
  	
  	              actionCard.__cardRowData = rowData;
  	
  	              const location = rowData.location;
  	              const type = getCardType(location, rowData);
  	              const companyLabel = rowData.companyEntry?.label || "";
  	              const contactName = safeString(getCardContactName(location)).trim();
  	              const contactNumber = safeString(getCardContactNumber(location)).trim();
  	              const areaHa = getCardAreaHa(location);
  	              const perimeterMeters = getCardPerimeterMeters(location);
  	              const holePerimeterMeters = getCardHolePerimeterMeters(location);
  	              const eventsBlockHtml = buildCardEventsBlock(location);
  	              const segmentationBlockHtml = buildCardSegmentationBlock(rowData);
  	              const childrenListHtml = buildCardChildrenList(rowData);
  	
  	              let infoRows = "";
  	
  	              infoRows += cardInfoRow("Company", companyLabel || "—");
  	              infoRows += cardInfoRow("Type", type || "—");
  	              infoRows += cardInfoRow("Area (ha)", formatCardAreaHa(areaHa));
  	              infoRows += cardInfoRow("Perimeter", formatCardPerimeterMeters(perimeterMeters));
  	
  	              if (holePerimeterMeters !== null) {
  	                infoRows += cardInfoRow("Hole Perimeter", formatCardPerimeterMeters(holePerimeterMeters));
  	              }
  	
  	              if (contactName) {
  	                infoRows += cardInfoRow("Contact Name", contactName);
  	              }
  	
  	              if (contactNumber) {
  	                infoRows += cardInfoRow("Contact Number", contactNumber);
  	              }
  	
  	              actionCard.innerHTML = `
  	              <div class="trackit-action-card-header no-location-icon">
  	              <div class="trackit-action-card-top-row">
  	              <button class="trackit-action-card-edit" type="button" data-card-action="edit" title="Edit">✎</button>
  	              <button class="trackit-action-card-close" type="button" data-card-close title="Close">×</button>
  	              </div>
  	
  	              <div class="trackit-action-card-title-wrap">
  	              <div class="trackit-action-card-title">${escapeHtml(rowData.label)}</div>
  	              </div>
  	              </div>
  	
  	              <div class="trackit-action-card-body">
  	              ${infoRows}
  	              ${eventsBlockHtml}
  	              ${segmentationBlockHtml}
  	              ${childrenListHtml}
  	              </div>
  	              `;
  	
  	              actionCard.classList.add("open");
  	
  	              if (areCardSegmentsVisible(rowData)) {
  	                renderCardTemporarySegmentsOnMap(rowData);
  	              } else {
  	                clearCardTemporarySegmentPolygons();
  	              }
  	
  	              notifyCarvedShellLayout();
  	
  	              setTimeout(notifyCarvedShellLayout, 80);
  	              setTimeout(notifyCarvedShellLayout, 220);
  	
  	              FIF_SILENT_CONSOLE.groupCollapsed("[TrackIT Location Dropdown] Location Card Opened");
  	              FIF_SILENT_CONSOLE.log("Location:", location);
  	              FIF_SILENT_CONSOLE.log("Row Data:", rowData);
  	              FIF_SILENT_CONSOLE.log("Company:", rowData.companyEntry?.company || null);
  	              FIF_SILENT_CONSOLE.log("Contact Name:", contactName);
  	              FIF_SILENT_CONSOLE.log("Contact Number:", contactNumber);
  	              FIF_SILENT_CONSOLE.log("Area ha:", areaHa);
  	              FIF_SILENT_CONSOLE.log("Perimeter meters:", perimeterMeters);
  	              FIF_SILENT_CONSOLE.log("Hole perimeter meters:", holePerimeterMeters);
  	              FIF_SILENT_CONSOLE.groupEnd();
  	
  	              emitRouterEvent(ROUTER_EVENTS.cardRequested, rowData, {
  	                cardType: "location-card",
  	                visibleCardOpened: true
  	              });
  	            }
  	
  	            function openLocationEventsManager(rowData) {
  	              if (!rowData || !rowData.location) {
  	                window.alert("No location selected.");
  	                return;
  	              }
  	
  	              const location = rowData.location;
  	              const locationId = safeString(getLocationValue(location)).trim();
  	              const locationLabel = safeString(getLocationLabel(location) || rowData.label || locationId).trim();
  	              const appData = getAppBag();
  	              const eventCompany =
  	                rowData.companyEntry?.company ||
  	                rowData.company ||
  	                rowData.companyObject ||
  	                DATA_CHANNEL?.companies?.find(companyItem => {
  	                  return flattenLocations(getCompanyLocations(companyItem)).some(locationItem => {
  	                    return String(getLocationValue(locationItem)) === String(locationId);
  	                  });
  	                }) ||
  	                null;
  	
  	              if (!locationId) {
  	                window.alert("Selected location has no objectId.");
  	                return;
  	              }
  	
  	              const EVENTS_MOUNT_ID = "trackit-location-events-manager";
  	              const EVENTS_STYLE_ID = "trackit-location-events-manager-style";
  	              const TABLE_JOB_ENTRIES = "JobEntries";
  	              const TABLE_LOCATIONS = "Locations";
  	              const LOCATION_JOBS_RELATION_FIELD = "Jobs";
  	
  	              const existing = document.getElementById(EVENTS_MOUNT_ID);
  	
  	              if (existing) {
  	                existing.remove();
  	              }
  	
  	              document.getElementById(EVENTS_STYLE_ID)?.remove();
  	
  	              function hasBackendlessData() {
  	                return !!(
  	                  typeof Backendless !== "undefined" &&
  	                  Backendless &&
  	                  Backendless.Data &&
  	                  typeof Backendless.Data.of === "function"
  	                );
  	              }
  	
  	              // ---------------------------------------------------------
  	              // Dashboard-parity JobEntry Location / Field resolver.
  	              // ---------------------------------------------------------
  	              function clean(value) {
  	                return safeString(value).trim();
  	              }
  	
  	              function firstValue(values, fallback = "") {
  	                const rows = Array.isArray(values) ? values : [values];
  	                for (let index = 0; index < rows.length; index += 1) {
  	                  const value = rows[index];
  	                  if (value !== undefined && value !== null && clean(value) !== "") return value;
  	                }
  	                return fallback;
  	              }
  	
  	              function getDeep(source, path, fallback = "") {
  	                let value = source;
  	                const parts = Array.isArray(path) ? path : safeString(path).split(".");
  	                for (let index = 0; index < parts.length; index += 1) {
  	                  if (!value || typeof value !== "object" || !(parts[index] in value)) return fallback;
  	                  value = value[parts[index]];
  	                }
  	                return value === undefined ? fallback : value;
  	              }
  	
  	              function permissionNormalKey(value) {
  	                return clean(value).toLowerCase().replace(/[^a-z0-9]+/g, "");
  	              }
  	
  	              function uniqueStrings(values) {
  	                const seen = Object.create(null);
  	                const rows = [];
  	                (Array.isArray(values) ? values : [values]).forEach(value => {
  	                  const text = clean(value);
  	                  if (!text) return;
  	                  const key = text.toLowerCase();
  	                  if (seen[key]) return;
  	                  seen[key] = true;
  	                  rows.push(text);
  	                });
  	                return rows;
  	              }
  	
  	              const eventLocations = flattenLocations(getCompanyLocations(eventCompany));
  	              const eventLocationById = Object.create(null);
  	
  	              eventLocations.forEach(candidate => {
  	                const ids = uniqueStrings([
  	                  candidate && candidate.objectId,
  	                  candidate && candidate.ObjectId,
  	                  candidate && candidate.LocationId,
  	                  candidate && candidate.ID,
  	                  candidate && candidate.FID
  	                ].map(value => clean(value)).filter(Boolean));
  	
  	                ids.forEach(id => {
  	                  eventLocationById[permissionNormalKey(id)] = candidate;
  	                });
  	              });
  	
  	              function eventLocationForJob(job) {
  	                const direct = firstValue([
  	                  job && job.Location,
  	                  job && job.location,
  	                  job && job.Field,
  	                  job && job.field
  	                ], null);
  	
  	                if (direct && typeof direct === "object") return direct;
  	
  	                const ids = uniqueStrings([
  	                  job && job.LocationId,
  	                  job && job.LocationObjectId,
  	                  job && job.FieldId,
  	                  job && job.FieldObjectId,
  	                  getDeep(job, ["Location", "objectId"], ""),
  	                  getDeep(job, ["Field", "objectId"], "")
  	                ].map(value => clean(value)).filter(Boolean));
  	
  	                for (let index = 0; index < ids.length; index += 1) {
  	                  const found = eventLocationById[permissionNormalKey(ids[index])];
  	                  if (found) return found;
  	                }
  	
  	                return null;
  	              }
  	
  	              function eventFieldLabel(job) {
  	                const linked = eventLocationForJob(job);
  	                return clean(firstValue([
  	                  job && job.FieldLabel,
  	                  job && job.FieldName,
  	                  getDeep(job, ["Field", "Name"], ""),
  	                  getDeep(job, ["Field", "Label"], ""),
  	                  linked && linked.FieldName,
  	                  linked && linked.Name,
  	                  linked && linked.Label,
  	                  linked && linked.Title,
  	                  linked && linked.REF,
  	                  linked && linked.FID,
  	                  linked && linked.ID
  	                ], ""));
  	              }
  	
  	              function eventLocationDisplayLabel(job) {
  	                const linked = eventLocationForJob(job);
  	                const parent = linked && firstValue([
  	                  linked.ParentLocation,
  	                  linked.Parent,
  	                  linked.LocationParent,
  	                  linked.Site,
  	                  linked.Farm,
  	                  linked.Property,
  	                  linked.Group
  	                ], null);
  	
  	                return clean(firstValue([
  	                  job && job.LocationLabel,
  	                  job && job.LocationName,
  	                  job && job.SiteName,
  	                  job && job.FarmName,
  	                  job && job.PropertyName,
  	                  job && job.ParentLocationName,
  	                  getDeep(job, ["Location", "Name"], ""),
  	                  getDeep(job, ["Location", "Label"], ""),
  	                  parent && parent.Name,
  	                  parent && parent.LocationName,
  	                  parent && parent.Label,
  	                  parent && parent.Title,
  	                  linked && linked.ParentName,
  	                  linked && linked.SiteName,
  	                  linked && linked.FarmName,
  	                  linked && linked.PropertyName,
  	                  linked && linked.LocationName,
  	                  linked && linked.Name,
  	                  linked && linked.Label,
  	                  job && job.LocationId
  	                ], locationLabel || "Location"));
  	              }
  	
  	              function eventLocationLabel(job) {
  	                return eventFieldLabel(job) || eventLocationDisplayLabel(job) || locationLabel || "Location";
  	              }
  	
  	              function injectEventsStyles() {
  	                if (document.getElementById(EVENTS_STYLE_ID)) return;
  	
  	                const style = document.createElement("style");
  	                style.id = EVENTS_STYLE_ID;
  	                style.textContent = `
  	                #${EVENTS_MOUNT_ID} {
  	                position: fixed;
  	                inset: 0;
  	                z-index: 2147483647;
  	                overflow: hidden;
  	                background: rgba(0,0,0,0.85);
  	                padding: 10px;
  	                box-sizing: border-box;
  	                font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-root {
  	                padding: 12px;
  	                box-sizing: border-box;
  	                color: #f0f0f0;
  	                max-width: 1700px;
  	                margin: 0 auto;
  	                height: calc(100vh - 20px);
  	                display: flex;
  	                flex-direction: column;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-card {
  	                border: 1px solid #333;
  	                border-radius: 14px;
  	                background: rgba(16,16,16,0.94);
  	                padding: 12px;
  	                box-sizing: border-box;
  	                display: flex;
  	                flex-direction: column;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                height: 100%;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-row {
  	                display: flex;
  	                gap: 8px;
  	                align-items: center;
  	                flex-wrap: wrap;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-actions {
  	                display: flex;
  	                align-items: center;
  	                justify-content: space-between;
  	                gap: 10px;
  	                flex-wrap: wrap;
  	                margin-top: 10px;
  	                flex: 0 0 auto;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-title {
  	                font-size: 1.05rem;
  	                font-weight: 900;
  	                color: #fff;
  	                margin: 0;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-sub {
  	                font-size: 0.78rem;
  	                color: #b0b0b0;
  	                margin-top: 2px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-badge {
  	                font-size: 0.72rem;
  	                padding: 4px 10px;
  	                border-radius: 999px;
  	                background: #2a2f38;
  	                color: #d2d7de;
  	                white-space: nowrap;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-divider {
  	                height: 1px;
  	                background: #2a2a2a;
  	                margin: 12px 0;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-search-wrap {
  	                margin: 10px 0 12px 0;
  	                flex: 0 0 auto;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-search {
  	                width: 100%;
  	                box-sizing: border-box;
  	                border: 1px solid #4a4a4a;
  	                background: #0f0f0f;
  	                color: #fff;
  	                border-radius: 10px;
  	                padding: 10px 12px;
  	                font-size: 0.90rem;
  	                outline: none;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-search:focus {
  	                border-color: #CC6633;
  	                box-shadow: 0 0 0 1px #CC6633 inset;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn {
  	                border-radius: 999px;
  	                border: 1px solid #555;
  	                background: #333;
  	                color: #e0e0e0;
  	                font-size: 0.85rem;
  	                padding: 8px 12px;
  	                cursor: pointer;
  	                user-select: none;
  	                white-space: nowrap;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn:hover {
  	                background: #3c3c3c;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn-primary {
  	                background: #CC6633;
  	                border-color: #CC6633;
  	                color: #fff;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn-primary:hover {
  	                background: #e0733a;
  	                border-color: #e0733a;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn-danger {
  	                background: #7f1d1d;
  	                border-color: #a11f1f;
  	                color: #fff;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn-danger:hover {
  	                background: #991b1b;
  	                border-color: #b91c1c;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn-disabled {
  	                opacity: 0.55;
  	                cursor: not-allowed;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-events-box {
  	                border: 1px solid #333;
  	                border-radius: 12px;
  	                background: #101010;
  	                padding: 0;
  	                box-sizing: border-box;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                display: flex;
  	                flex-direction: column;
  	                overflow: hidden;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-tablewrap {
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                overflow: auto;
  	                border-radius: 12px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table {
  	                width: 100%;
  	                border-collapse: collapse;
  	                min-width: 1650px;
  	                background: #141414;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table th,
  	                #${EVENTS_MOUNT_ID} table.jel-table td {
  	                padding: 10px 10px;
  	                border-bottom: 1px solid #242424;
  	                text-align: left;
  	                vertical-align: top;
  	                font-size: 0.9rem;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table th {
  	                position: sticky;
  	                top: 0;
  	                background: #1c1c1c;
  	                z-index: 2;
  	                font-weight: 800;
  	                color: #f2f2f2;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-muted {
  	                color: #a0a4aa;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-empty {
  	                color: #a0a4aa;
  	                font-size: 0.95rem;
  	                padding: 10px 12px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-cell {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 4px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-big {
  	                font-size: 0.95rem;
  	                font-weight: 900;
  	                color: #ffffff;
  	                line-height: 1.15;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-small {
  	                font-size: 0.80rem;
  	                color: #c1c6ce;
  	                line-height: 1.15;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-smallline {
  	                display: block;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-dash {
  	                color: #80858f;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-num {
  	                font-variant-numeric: tabular-nums;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-actions-cell {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 6px;
  	                min-width: 96px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-action-modal {
  	                position: fixed;
  	                inset: 0;
  	                z-index: 2147483647;
  	                display: grid;
  	                place-items: center;
  	                padding: 18px;
  	                box-sizing: border-box;
  	                background: rgba(0,0,0,0.82);
  	                backdrop-filter: blur(7px);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-action-panel {
  	                width: min(760px, calc(100vw - 36px));
  	                max-height: calc(100vh - 36px);
  	                display: flex;
  	                flex-direction: column;
  	                overflow: hidden;
  	                border: 1px solid rgba(204,102,51,0.62);
  	                border-radius: 20px;
  	                color: #f8fafc;
  	                background: linear-gradient(145deg, rgba(25,25,25,0.995), rgba(8,10,12,0.995));
  	                box-shadow: 0 28px 80px rgba(0,0,0,0.68), inset 0 1px 0 rgba(255,255,255,0.04);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-action-head {
  	                display: flex;
  	                align-items: flex-start;
  	                justify-content: space-between;
  	                gap: 16px;
  	                padding: 18px 18px 15px;
  	                border-bottom: 1px solid rgba(255,255,255,0.09);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-action-title {
  	                color: #fff;
  	                font-size: 1.12rem;
  	                font-weight: 900;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-action-sub {
  	                margin-top: 4px;
  	                color: #aeb5bf;
  	                font-size: 0.78rem;
  	                line-height: 1.4;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-action-body {
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                overflow: auto;
  	                padding: 16px 18px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-editor-list {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 10px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-editor-row {
  	                padding: 12px;
  	                border: 1px solid rgba(255,255,255,0.10);
  	                border-radius: 14px;
  	                background: rgba(255,255,255,0.035);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-editor-row-head {
  	                display: flex;
  	                align-items: center;
  	                justify-content: space-between;
  	                gap: 10px;
  	                margin-bottom: 10px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-editor-context {
  	                color: #d7dce3;
  	                font-size: 0.78rem;
  	                font-weight: 800;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-editor-grid {
  	                display: grid;
  	                grid-template-columns: minmax(0,1fr) minmax(0,1fr);
  	                gap: 10px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-field-label {
  	                display: block;
  	                margin-bottom: 5px;
  	                color: #b7bdc7;
  	                font-size: 0.72rem;
  	                font-weight: 850;
  	                text-transform: uppercase;
  	                letter-spacing: 0.04em;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-field-input {
  	                width: 100%;
  	                height: 42px;
  	                padding: 0 11px;
  	                box-sizing: border-box;
  	                border: 1px solid #4a4a4a;
  	                border-radius: 10px;
  	                outline: none;
  	                color: #fff;
  	                background: #0f0f0f;
  	                font: inherit;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-field-input:focus {
  	                border-color: #CC6633;
  	                box-shadow: 0 0 0 2px rgba(204,102,51,0.16);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-editor-tools {
  	                display: flex;
  	                justify-content: flex-start;
  	                margin-top: 12px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-action-error {
  	                display: none;
  	                margin-top: 12px;
  	                padding: 10px 12px;
  	                border: 1px solid rgba(205,70,55,0.55);
  	                border-radius: 10px;
  	                color: #ffd6ce;
  	                background: rgba(112,28,21,0.28);
  	                font-size: 0.80rem;
  	                line-height: 1.4;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-action-error.visible {
  	                display: block;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-action-foot {
  	                display: flex;
  	                justify-content: flex-end;
  	                gap: 9px;
  	                padding: 14px 18px 18px;
  	                border-top: 1px solid rgba(255,255,255,0.08);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-delete-name {
  	                padding: 12px 13px;
  	                border: 1px solid rgba(204,102,51,0.34);
  	                border-radius: 12px;
  	                color: #fff;
  	                background: rgba(204,102,51,0.10);
  	                font-weight: 900;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-delete-copy {
  	                margin-top: 13px;
  	                color: #c8cbd1;
  	                font-size: 0.86rem;
  	                line-height: 1.5;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-delete-copy strong {
  	                color: #fff;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-delete-input {
  	                width: 100%;
  	                height: 48px;
  	                margin-top: 12px;
  	                padding: 0 13px;
  	                box-sizing: border-box;
  	                border: 1px solid #9f3428;
  	                border-radius: 12px;
  	                outline: none;
  	                color: #fff;
  	                background: #0d0d0d;
  	                font-size: 1rem;
  	                font-weight: 900;
  	                letter-spacing: 0.08em;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-delete-input:focus {
  	                border-color: #e65b44;
  	                box-shadow: 0 0 0 3px rgba(198,58,40,0.16);
  	                }
  	
  	                /* Fleet In Form dashboard alignment */
  	                #${EVENTS_MOUNT_ID} {
  	                padding: 34px 24px 24px;
  	                background: rgba(2,5,3,0.82);
  	                backdrop-filter: blur(10px);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-root {
  	                width: min(1920px, 100%);
  	                max-width: none;
  	                height: calc(100vh - 58px);
  	                padding: 0;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-card {
  	                padding: 0;
  	                border: 1px solid rgba(204,102,51,0.58);
  	                border-radius: 16px;
  	                background: linear-gradient(145deg,#151b17,#080c09 62%);
  	                box-shadow: 0 28px 90px rgba(0,0,0,0.72), inset 0 1px 0 rgba(255,255,255,0.035);
  	                overflow: hidden;
  	                isolation: isolate;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-head {
  	                display: flex;
  	                align-items: flex-start;
  	                justify-content: space-between;
  	                gap: 18px;
  	                padding: 18px 20px 16px;
  	                border-bottom: 1px solid rgba(255,255,255,0.075);
  	                background: linear-gradient(90deg,rgba(31,39,33,0.96),rgba(10,14,11,0.92));
  	                border-radius: 15px 15px 0 0;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-kicker {
  	                display: block;
  	                margin-bottom: 5px;
  	                color: #d27a4c;
  	                font-size: 0.68rem;
  	                font-weight: 950;
  	                letter-spacing: 0.09em;
  	                text-transform: uppercase;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-title {
  	                font-size: 1.48rem;
  	                line-height: 1.1;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-head-actions {
  	                display: flex;
  	                gap: 9px;
  	                align-items: center;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-main {
  	                display: flex;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                flex-direction: column;
  	                padding: 14px;
  	                overflow: hidden;
  	                border-radius: 0 0 15px 15px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-actions {
  	                margin: 0 0 10px;
  	                padding: 11px 12px;
  	                border: 1px solid rgba(255,255,255,0.075);
  	                border-radius: 11px;
  	                background: rgba(255,255,255,0.026);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-actions-meta {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 3px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn {
  	                box-sizing: border-box;
  	                min-height: 38px;
  	                padding: 0 14px;
  	                border: 1px solid rgba(204,102,51,0.48);
  	                border-radius: 9px;
  	                background: linear-gradient(145deg,#1b211c,#101411);
  	                color: #ecf0ed;
  	                font-size: 0.76rem;
  	                font-weight: 850;
  	                box-shadow: none;
  	                transition: border-color .16s ease, background .16s ease, transform .16s ease;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn:hover:not(:disabled) {
  	                border-color: #d87945;
  	                background: #242c25;
  	                transform: translateY(-1px);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn-primary {
  	                border-color: #b85a2f;
  	                background: linear-gradient(145deg,#b85a2f,#8e4122);
  	                color: #fff;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn-primary:hover:not(:disabled) {
  	                border-color: #e1814d;
  	                background: linear-gradient(145deg,#ca6838,#a64b27);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn-route {
  	                width: 100%;
  	                padding-left: 6px;
  	                padding-right: 6px;
  	                font-size: 0.70rem;
  	                white-space: nowrap;
  	                border-color: rgba(74,137,255,0.58);
  	                background: linear-gradient(145deg,#17335b,#102038);
  	                color: #dceaff;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn-route:hover:not(:disabled) {
  	                border-color: #6198ff;
  	                background: linear-gradient(145deg,#214579,#142d50);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-btn:disabled {
  	                opacity: 0.42;
  	                cursor: not-allowed;
  	                transform: none;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-badge {
  	                padding: 6px 10px;
  	                border: 1px solid rgba(255,255,255,0.075);
  	                border-radius: 8px;
  	                background: #111713;
  	                color: #99a49d;
  	                font-weight: 800;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-search-wrap {
  	                margin: 0 0 10px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-search {
  	                min-height: 44px;
  	                border-color: rgba(255,255,255,0.09);
  	                border-radius: 9px;
  	                background: #090e0b;
  	                color: #f2f5f3;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-divider { display: none; }
  	
  	                #${EVENTS_MOUNT_ID} .jel-events-box {
  	                border-color: rgba(255,255,255,0.08);
  	                border-radius: 10px;
  	                background: #090e0b;
  	                isolation: isolate;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-tablewrap {
  	                border-radius: inherit;
  	                overflow-y: auto;
  	                overflow-x: auto;
  	                scrollbar-gutter: stable;
  	                overscroll-behavior-x: contain;
  	                overflow-anchor: none;
  	                scroll-behavior: auto;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table {
  	                width: 100%;
  	                min-width: 1427px;
  	                table-layout: fixed;
  	                background: #0b100d;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table th,
  	                #${EVENTS_MOUNT_ID} table.jel-table td {
  	                padding: 12px 7px;
  	                border-bottom-color: rgba(255,255,255,0.065);
  	                overflow-wrap: normal;
  	                word-break: normal;
  	                box-sizing: border-box;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table th {
  	                background: #171d18;
  	                color: #aeb8b1;
  	                font-size: 0.67rem;
  	                letter-spacing: 0.035em;
  	                text-transform: uppercase;
  	                white-space: nowrap;
  	                overflow: hidden;
  	                text-overflow: ellipsis;
  	                }
  	
  	                /*
  	                 * Date and Field remain visible even when the user scrolls
  	                 * horizontally to Tracking / Actions.
  	                 */
  	                #${EVENTS_MOUNT_ID} table.jel-table th:nth-child(1),
  	                #${EVENTS_MOUNT_ID} table.jel-table td:nth-child(1) {
  	                position: sticky;
  	                left: 0;
  	                z-index: 4;
  	                width: 92px;
  	                min-width: 92px;
  	                max-width: 92px;
  	                background: #0b100d;
  	                box-shadow: 1px 0 0 rgba(255,255,255,0.07);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table th:nth-child(2),
  	                #${EVENTS_MOUNT_ID} table.jel-table td:nth-child(2) {
  	                position: sticky;
  	                left: 92px;
  	                z-index: 4;
  	                width: 120px;
  	                min-width: 120px;
  	                max-width: 120px;
  	                background: #0b100d;
  	                box-shadow: 1px 0 0 rgba(255,255,255,0.07);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table thead th:nth-child(1),
  	                #${EVENTS_MOUNT_ID} table.jel-table thead th:nth-child(2) {
  	                z-index: 7;
  	                background: #171d18;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table tbody tr:hover td:nth-child(1),
  	                #${EVENTS_MOUNT_ID} table.jel-table tbody tr:hover td:nth-child(2) {
  	                background: #101713;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table td {
  	                font-size: 0.78rem;
  	                line-height: 1.35;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table .jel-compact {
  	                white-space: nowrap;
  	                overflow: hidden;
  	                text-overflow: ellipsis;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} table.jel-table tbody tr:hover {
  	                background: rgba(204,102,51,0.045);
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-actions-cell {
  	                display: block;
  	                min-width: 0;
  	                gap: 7px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-actions-cell .jel-btn {
  	                width: 100%;
  	                padding-left: 7px;
  	                padding-right: 7px;
  	                font-size: 0.70rem;
  	                white-space: nowrap;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-window {
  	                position: fixed;
  	                z-index: 2147483647;
  	                width: min(1180px,calc(100vw - 36px));
  	                height: min(720px,calc(100vh - 58px));
  	                left: 50%;
  	                top: 50%;
  	                transform: translate(-50%,-50%);
  	                display: flex;
  	                flex-direction: column;
  	                overflow: hidden;
  	                resize: none;
  	                border: 1px solid rgba(204,102,51,0.72);
  	                border-radius: 16px;
  	                color: #eff4f0;
  	                background: #090e0b;
  	                box-shadow: 0 30px 100px rgba(0,0,0,0.82);
  	                isolation: isolate;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-head {
  	                display: flex;
  	                align-items: flex-start;
  	                justify-content: space-between;
  	                gap: 14px;
  	                padding: 13px 15px;
  	                border-bottom: 1px solid rgba(255,255,255,0.08);
  	                background: linear-gradient(90deg,#1a211c,#0c110e);
  	                cursor: move;
  	                user-select: none;
  	                border-radius: 15px 15px 0 0;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-head strong { display:block; color:#fff; font-size:1.05rem; }
  	                #${EVENTS_MOUNT_ID} .jel-track-head small { display:block; margin-top:4px; color:#929d96; font-size:.72rem; }
  	                #${EVENTS_MOUNT_ID} .jel-track-head .jel-row { flex-wrap:nowrap; }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-body {
  	                display: grid;
  	                grid-template-columns: minmax(0,1fr) 330px;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                overflow: hidden;
  	                border-radius: 0 0 15px 15px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-map-wrap { position:relative; min-height:320px; background:#101612; }
  	                #${EVENTS_MOUNT_ID} .jel-track-map { position:absolute; inset:0; }
  	                #${EVENTS_MOUNT_ID} .jel-track-state {
  	                position:absolute; inset:14px auto auto 14px; z-index:3; max-width:calc(100% - 28px);
  	                padding:9px 11px; border:1px solid rgba(204,102,51,.4); border-radius:9px;
  	                background:rgba(9,14,11,.91); color:#d6ddd8; font-size:.72rem; line-height:1.4;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-side {
  	                min-height:0; overflow:auto; padding:12px;
  	                border-left:1px solid rgba(255,255,255,.08); background:#0b100d;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-card {
  	                margin-bottom:9px; padding:11px; border:1px solid rgba(255,255,255,.075);
  	                border-radius:10px; background:#121813;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-card span {
  	                display:block; color:#d27a4c; font-size:.65rem; font-weight:900;
  	                letter-spacing:.065em; text-transform:uppercase;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-card strong { display:block; margin-top:5px; color:#f4f7f5; font-size:.88rem; }
  	                #${EVENTS_MOUNT_ID} .jel-track-card small { display:block; margin-top:4px; color:#87928b; font-size:.69rem; line-height:1.45; }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-grid {
  	                display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:8px;
  	                }
  	
  	                #${EVENTS_MOUNT_ID} .jel-track-legend {
  	                position:absolute; left:12px; bottom:12px; z-index:3; display:flex; gap:9px; flex-wrap:wrap;
  	                padding:7px 9px; border-radius:8px; background:rgba(5,8,6,.88); color:#d7ddd9; font-size:.66rem;
  	                }
  	                #${EVENTS_MOUNT_ID} .jel-track-legend i { width:9px; height:9px; display:inline-block; margin-right:4px; border-radius:50%; }
  	
  	                @media (max-width: 900px) {
  	                #${EVENTS_MOUNT_ID} { padding: 8px; }
  	                #${EVENTS_MOUNT_ID} .jel-root { height: calc(100vh - 16px); }
  	                #${EVENTS_MOUNT_ID} .jel-head { padding: 12px 14px; }
  	                #${EVENTS_MOUNT_ID} .jel-main { padding: 10px; }
  	                #${EVENTS_MOUNT_ID} table.jel-table th,
  	                #${EVENTS_MOUNT_ID} table.jel-table td { padding-top:10px; padding-bottom:10px; }
  	                #${EVENTS_MOUNT_ID} .jel-track-body { grid-template-columns:1fr; grid-template-rows:minmax(320px,1fr) auto; }
  	                #${EVENTS_MOUNT_ID} .jel-track-side { border-left:0; border-top:1px solid rgba(255,255,255,.08); max-height:230px; }
  	                }
  	
  	                @media (max-width: 640px) {
  	                #${EVENTS_MOUNT_ID} .jel-editor-grid {
  	                grid-template-columns: 1fr;
  	                }
  	                }
  	                `;
  	
  	                document.head.appendChild(style);
  	              }
  	
  	              function pick(obj, keys) {
  	                if (!obj || typeof obj !== "object") return "";
  	
  	                for (let i = 0; i < keys.length; i++) {
  	                  const value = obj[keys[i]];
  	
  	                  if (value === undefined || value === null) continue;
  	
  	                  const text = safeString(value).trim();
  	
  	                  if (text) return text;
  	                }
  	
  	                return "";
  	              }
  	
  	              function numberPick(obj, keys) {
  	                if (!obj || typeof obj !== "object") return null;
  	
  	                for (let i = 0; i < keys.length; i++) {
  	                  const value = obj[keys[i]];
  	
  	                  if (value === undefined || value === null || value === "") continue;
  	
  	                  const number = Number(value);
  	
  	                  if (Number.isFinite(number)) return number;
  	                }
  	
  	                return null;
  	              }
  	
  	              function pad2(value) {
  	                const number = Number(value);
  	
  	                if (!Number.isFinite(number)) return "00";
  	
  	                return number < 10 ? `0${number}`: String(number);
  	              }
  	
  	              function unwrapEventValue(value) {
  	                let current = value;
  	                let guard = 0;
  	
  	                while (
  	                  current &&
  	                  typeof current === "object" &&
  	                  !(current instanceof Date) &&
  	                  Object.prototype.hasOwnProperty.call(current, "value") &&
  	                  guard < 5
  	                ) {
  	                  current = current.value;
  	                  guard += 1;
  	                }
  	
  	                return current;
  	              }
  	
  	              function readEventPath(object, path) {
  	                if (!object || typeof object !== "object") return undefined;
  	                if (Object.prototype.hasOwnProperty.call(object, path)) return object[path];
  	
  	                const parts = String(path).split(".");
  	                let current = object;
  	
  	                for (let index = 0; index < parts.length; index += 1) {
  	                  if (!current || typeof current !== "object") return undefined;
  	                  if (!Object.prototype.hasOwnProperty.call(current, parts[index])) return undefined;
  	                  current = current[parts[index]];
  	                }
  	
  	                return current;
  	              }
  	
  	              function firstEventValue(object, paths) {
  	                for (let index = 0; index < paths.length; index += 1) {
  	                  const raw = unwrapEventValue(readEventPath(object, paths[index]));
  	
  	                  if (raw === undefined || raw === null) continue;
  	                  if (typeof raw === "string" && !raw.trim()) continue;
  	
  	                  return raw;
  	                }
  	
  	                return "";
  	              }
  	
  	              function asDate(value) {
  	                const raw = unwrapEventValue(value);
  	
  	                if (raw === undefined || raw === null || raw === "") return null;
  	                if (raw instanceof Date && !isNaN(raw.getTime())) return new Date(raw.getTime());
  	
  	                if (typeof raw === "number" && Number.isFinite(raw)) {
  	                  let stamp = raw;
  	                  if (stamp > 1000000000 && stamp < 100000000000) stamp *= 1000;
  	                  const numericDate = new Date(stamp);
  	                  return isNaN(numericDate.getTime()) ? null: numericDate;
  	                }
  	
  	                const text = safeString(raw).trim();
  	                if (!text) return null;
  	
  	                if (/^\d{10,13}$/.test(text)) {
  	                  let stamp = Number(text);
  	                  if (text.length === 10) stamp *= 1000;
  	                  const numericDate = new Date(stamp);
  	                  return isNaN(numericDate.getTime()) ? null: numericDate;
  	                }
  	
  	                const date = new Date(text);
  	                return isNaN(date.getTime()) ? null: date;
  	              }
  	
  	              function parseClockValue(value) {
  	                const raw = unwrapEventValue(value);
  	
  	                if (raw === undefined || raw === null || raw === "") {
  	                  return { label: "", minutes: null, timestamp: null };
  	                }
  	
  	                if (raw instanceof Date && !isNaN(raw.getTime())) {
  	                  return {
  	                    label: `${pad2(raw.getHours())}:${pad2(raw.getMinutes())}`,
  	                    minutes: raw.getHours() * 60 + raw.getMinutes(),
  	                    timestamp: raw.getTime()
  	                  };
  	                }
  	
  	                if (typeof raw === "number" && Number.isFinite(raw)) {
  	                  if (raw > 1000000000) {
  	                    const date = asDate(raw);
  	                    if (date) {
  	                      return {
  	                        label: `${pad2(date.getHours())}:${pad2(date.getMinutes())}`,
  	                        minutes: date.getHours() * 60 + date.getMinutes(),
  	                        timestamp: date.getTime()
  	                      };
  	                    }
  	                  }
  	
  	                  if (raw >= 0 && raw < 24) {
  	                    const minutes = Math.round(raw * 60);
  	                    return {
  	                      label: `${pad2(Math.floor(minutes / 60) % 24)}:${pad2(minutes % 60)}`,
  	                      minutes,
  	                      timestamp: null
  	                    };
  	                  }
  	
  	                  if (raw >= 0 && raw < 1440) {
  	                    const minutes = Math.round(raw);
  	                    return {
  	                      label: `${pad2(Math.floor(minutes / 60) % 24)}:${pad2(minutes % 60)}`,
  	                      minutes,
  	                      timestamp: null
  	                    };
  	                  }
  	                }
  	
  	                const text = safeString(raw).trim();
  	                if (!text) return { label: "", minutes: null, timestamp: null };
  	
  	                if (/^\d{10,13}$/.test(text)) {
  	                  const date = asDate(text);
  	                  if (date) {
  	                    return {
  	                      label: `${pad2(date.getHours())}:${pad2(date.getMinutes())}`,
  	                      minutes: date.getHours() * 60 + date.getMinutes(),
  	                      timestamp: date.getTime()
  	                    };
  	                  }
  	                }
  	
  	                let match = text.match(/(?:^|[T\s])(\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?\s*(AM|PM)?(?:$|[Z+\-\s])/i);
  	                if (!match) match = text.match(/^(\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?\s*(AM|PM)?$/i);
  	                if (!match) match = text.match(/^(\d{1,2})\s*h(?:ours?)?\s*(\d{1,2})?\s*m?/i);
  	
  	                if (match) {
  	                  let hours = Number(match[1]);
  	                  const minutesPart = Number(match[2] || 0);
  	                  const meridiem = safeString(match[3]).trim().toUpperCase();
  	
  	                  if (meridiem === "PM" && hours < 12) hours += 12;
  	                  if (meridiem === "AM" && hours === 12) hours = 0;
  	
  	                  if (hours >= 0 && hours < 24 && minutesPart >= 0 && minutesPart < 60) {
  	                    return {
  	                      label: `${pad2(hours)}:${pad2(minutesPart)}`,
  	                      minutes: hours * 60 + minutesPart,
  	                      timestamp: null
  	                    };
  	                  }
  	                }
  	
  	                const date = asDate(text);
  	                if (date) {
  	                  return {
  	                    label: `${pad2(date.getHours())}:${pad2(date.getMinutes())}`,
  	                    minutes: date.getHours() * 60 + date.getMinutes(),
  	                    timestamp: date.getTime()
  	                  };
  	                }
  	
  	                return { label: "", minutes: null, timestamp: null };
  	              }
  	
  	              function formatDate(value) {
  	                const date = asDate(value);
  	
  	                if (!date) return "";
  	
  	                return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
  	              }
  	
  	              function formatTime(value) {
  	                return parseClockValue(value).label;
  	              }
  	
  	              function formatDuration(seconds) {
  	                const value = Number(seconds);
  	
  	                if (!Number.isFinite(value) || value < 0) return "";
  	
  	                const totalSeconds = Math.round(value);
  	                const hours = Math.floor(totalSeconds / 3600);
  	                const minutes = Math.floor((totalSeconds % 3600) / 60);
  	
  	                if (hours > 0) return `${hours}h ${pad2(minutes)}m`;
  	
  	                return `${minutes}m`;
  	              }
  	
  	              function getBestTimeIn(job) {
  	                return firstEventValue(job, [
  	                  "TimeIn",
  	                  "timeIn",
  	                  "Time_In",
  	                  "time_in",
  	                  "StartTime",
  	                  "startTime",
  	                  "StartTimestamp",
  	                  "startTimestamp",
  	                  "StartedAt",
  	                  "startedAt",
  	                  "EnterTime",
  	                  "enterTime",
  	                  "EntryTime",
  	                  "entryTime",
  	                  "EntryTimestamp",
  	                  "entryTimestamp",
  	                  "EnteredAt",
  	                  "enteredAt",
  	                  "ArrivalTime",
  	                  "arrivalTime",
  	                  "ArrivedAt",
  	                  "arrivedAt",
  	                  "GeofenceEnterTime",
  	                  "geofenceEnterTime",
  	                  "GeofenceEntryTime",
  	                  "geofenceEntryTime",
  	                  "Data.TimeIn",
  	                  "Data.StartTime",
  	                  "Event.TimeIn",
  	                  "Event.StartTime",
  	                  "Times.TimeIn",
  	                  "Timing.TimeIn"
  	                ]);
  	              }
  	
  	              function getBestTimeOut(job) {
  	                return firstEventValue(job, [
  	                  "TimeOut",
  	                  "timeOut",
  	                  "Time_Out",
  	                  "time_out",
  	                  "EndTime",
  	                  "endTime",
  	                  "EndTimestamp",
  	                  "endTimestamp",
  	                  "EndedAt",
  	                  "endedAt",
  	                  "ExitTime",
  	                  "exitTime",
  	                  "ExitTimestamp",
  	                  "exitTimestamp",
  	                  "ExitedAt",
  	                  "exitedAt",
  	                  "DepartureTime",
  	                  "departureTime",
  	                  "DepartedAt",
  	                  "departedAt",
  	                  "GeofenceExitTime",
  	                  "geofenceExitTime",
  	                  "GeofenceDepartureTime",
  	                  "geofenceDepartureTime",
  	                  "Data.TimeOut",
  	                  "Data.EndTime",
  	                  "Event.TimeOut",
  	                  "Event.EndTime",
  	                  "Times.TimeOut",
  	                  "Timing.TimeOut"
  	                ]);
  	              }
  	
  	              function getBestDate(job) {
  	                const direct = firstEventValue(job, [
  	                  "DateISO",
  	                  "dateISO",
  	                  "Date",
  	                  "date",
  	                  "JobDate",
  	                  "jobDate",
  	                  "EventDate",
  	                  "eventDate"
  	                ]);
  	
  	                return direct ? formatDate(direct) || safeString(direct).trim():
  	                  formatDate(getBestTimeIn(job)) ||
  	                  formatDate(getBestTimeOut(job)) ||
  	                  "";
  	              }
  	
  	              function explicitDurationSeconds(job) {
  	                const seconds = numberPick(job, [
  	                  "DurationSeconds",
  	                  "durationSeconds",
  	                  "DurationSec",
  	                  "durationSec",
  	                  "ElapsedSeconds",
  	                  "elapsedSeconds",
  	                  "TimeSeconds",
  	                  "timeSeconds"
  	                ]);
  	                if (seconds !== null && seconds >= 0) return seconds;
  	
  	                const milliseconds = numberPick(job, [
  	                  "DurationMilliseconds",
  	                  "durationMilliseconds",
  	                  "DurationMS",
  	                  "durationMS",
  	                  "ElapsedMilliseconds",
  	                  "elapsedMilliseconds"
  	                ]);
  	                if (milliseconds !== null && milliseconds >= 0) return milliseconds / 1000;
  	
  	                const minutes = numberPick(job, [
  	                  "DurationMinutes",
  	                  "durationMinutes",
  	                  "ElapsedMinutes",
  	                  "elapsedMinutes",
  	                  "TimeMinutes",
  	                  "timeMinutes"
  	                ]);
  	                if (minutes !== null && minutes >= 0) return minutes * 60;
  	
  	                const hours = numberPick(job, [
  	                  "DurationHours",
  	                  "durationHours",
  	                  "ElapsedHours",
  	                  "elapsedHours",
  	                  "TimeHours",
  	                  "timeHours"
  	                ]);
  	                if (hours !== null && hours >= 0) return hours * 3600;
  	
  	                const raw = firstEventValue(job, [
  	                  "Duration",
  	                  "duration",
  	                  "Elapsed",
  	                  "elapsed",
  	                  "TimeTaken",
  	                  "timeTaken"
  	                ]);
  	
  	                if (raw === "") return null;
  	
  	                if (typeof raw === "number" && Number.isFinite(raw)) {
  	                  if (raw >= 0 && raw <= 24) return raw * 3600;
  	                  if (raw > 24 && raw <= 1440) return raw * 60;
  	                  return null;
  	                }
  	
  	                const text = safeString(raw).trim();
  	                if (!text) return null;
  	
  	                let match = text.match(/^(\d{1,3}):(\d{2})(?::(\d{2}))?$/);
  	                if (match) {
  	                  const hoursPart = Number(match[1]);
  	                  const minutesPart = Number(match[2]);
  	                  const secondsPart = Number(match[3] || 0);
  	                  return hoursPart * 3600 + minutesPart * 60 + secondsPart;
  	                }
  	
  	                match = text.match(/(?:(\d+(?:\.\d+)?)\s*h(?:ours?)?)?\s*(?:(\d+(?:\.\d+)?)\s*m(?:in(?:utes?)?)?)?\s*(?:(\d+(?:\.\d+)?)\s*s(?:ec(?:onds?)?)?)?/i);
  	                if (match && (match[1] || match[2] || match[3])) {
  	                  return Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0);
  	                }
  	
  	                const numeric = Number(text.replace(",", "."));
  	                if (Number.isFinite(numeric) && numeric >= 0) {
  	                  if (numeric <= 24) return numeric * 3600;
  	                  if (numeric <= 1440) return numeric * 60;
  	                }
  	
  	                return null;
  	              }
  	
  	              function getBestDuration(job) {
  	                const timeIn = parseClockValue(getBestTimeIn(job));
  	                const timeOut = parseClockValue(getBestTimeOut(job));
  	
  	                if (timeIn.timestamp !== null && timeOut.timestamp !== null) {
  	                  const difference = timeOut.timestamp - timeIn.timestamp;
  	                  if (difference >= 0) return Math.round(difference / 1000);
  	                }
  	
  	                if (timeIn.minutes !== null && timeOut.minutes !== null) {
  	                  let differenceMinutes = timeOut.minutes - timeIn.minutes;
  	                  if (differenceMinutes < 0) differenceMinutes += 1440;
  	                  return differenceMinutes * 60;
  	                }
  	
  	                return explicitDurationSeconds(job);
  	              }
  	
  	              function getBestArea(job) {
  	                const fromJob = numberPick(job, [
  	                  "Area",
  	                  "area",
  	                  "FieldArea",
  	                  "fieldArea",
  	                  "LocationArea",
  	                  "locationArea"
  	                ]);
  	
  	                if (fromJob !== null) return fromJob;
  	
  	                const linkedLocation = eventLocationForJob(job);
  	
  	                return numberPick(linkedLocation, [
  	                  "Area",
  	                  "area",
  	                  "FieldArea",
  	                  "fieldArea",
  	                  "Size",
  	                  "size",
  	                  "Hectares",
  	                  "hectares",
  	                  "Data.Area",
  	                  "Data.FieldArea",
  	                  "Data.Hectares",
  	                  "LocationData.Area",
  	                  "LocationData.Hectares"
  	                ]);
  	              }
  	
  	              function normalizeApplications(job) {
  	                let source = firstEventValue(job, [
  	                  "Applications",
  	                  "applications",
  	                  "Application",
  	                  "application",
  	                  "Data.Applications",
  	                  "data.applications"
  	                ]);
  	
  	                if (typeof source === "string") {
  	                  const text = source.trim();
  	                  if (text.startsWith("[") || text.startsWith("{")) {
  	                    try {
  	                      source = JSON.parse(text);
  	                    } catch (_) {
  	                      source = [];
  	                    }
  	                  }
  	                }
  	
  	                const apps = Array.isArray(source) ? source: source && typeof source === "object" ? [source]: [];
  	
  	                return apps.map(app => {
  	                  return {
  	                    Type: pick(app, ["Type", "type", "ApplicationType", "applicationType", "Action", "action", "Event", "event"]),
  	                    Product: pick(app, ["Product", "product", "Crop", "crop", "Material", "material", "Description", "description"]),
  	                    RateText: pick(app, ["RateText", "rateText", "Rate", "rate", "QuantityText", "quantityText", "Quantity", "quantity"]),
  	                    Registration: pick(app, ["Registration", "registration", "VehicleRegistration", "vehicleRegistration"]),
  	                    Trailer: pick(app, ["Trailer", "trailer", "TrailerRegistration", "trailerRegistration", "Implement", "implement"])
  	                  };
  	                }).filter(app => {
  	                  return app.Type || app.Product || app.RateText || app.Registration || app.Trailer;
  	                });
  	              }
  	
  	              function buildEventText(job) {
  	                const apps = normalizeApplications(job);
  	
  	                if (!apps.length) {
  	                  return pick(job, ["Event", "event", "Type", "type", "Name", "name"]) || "Event";
  	                }
  	
  	                return apps.map(app => {
  	                  const type = app.Type || "Event";
  	                  const reg = app.Registration || app.Trailer || "";
  	
  	                  return reg ? `${type} - ${reg}`: type;
  	                }).join(" | ");
  	              }
  	
  	              function buildProductText(job) {
  	                return normalizeApplications(job).map(app => {
  	                  if (app.Product && app.RateText) return `${app.Product} @ ${app.RateText}`;
  	                  return app.Product || app.RateText || "";
  	                }).filter(Boolean).join(" | ");
  	              }
  	
  	              function calculateFuelUsed(job) {
  	                if (!job || typeof job !== "object") return null;
  	
  	                const consumedIn = numberPick(job, ["FuelConsumedIn", "fuelConsumedIn"]);
  	                const consumedOut = numberPick(job, ["FuelConsumedOut", "fuelConsumedOut"]);
  	
  	                if (consumedIn !== null && consumedOut !== null) {
  	                  const delta = consumedOut - consumedIn;
  	                  if (Number.isFinite(delta) && delta > 0) return delta;
  	                }
  	
  	                const volumeIn = numberPick(job, ["FuelVolumeIn", "fuelVolumeIn"]);
  	                const volumeOut = numberPick(job, ["FuelVolumeOut", "fuelVolumeOut"]);
  	
  	                if (volumeIn !== null && volumeOut !== null) {
  	                  const delta = volumeIn - volumeOut;
  	                  if (Number.isFinite(delta) && delta > 0) return delta;
  	                }
  	
  	                const levelIn = numberPick(job, ["FuelLevelIn", "fuelLevelIn"]);
  	                const levelOut = numberPick(job, ["FuelLevelOut", "fuelLevelOut"]);
  	
  	                if (levelIn !== null && levelOut !== null) {
  	                  const delta = levelIn - levelOut;
  	                  if (Number.isFinite(delta) && delta > 0) return delta;
  	                }
  	
  	                const savedFuel = numberPick(job, ["Fuel", "fuel", "FuelUsed", "fuelUsed"]);
  	
  	                if (savedFuel !== null && savedFuel > 0) return savedFuel;
  	
  	                return null;
  	              }
  	
  	              function getFuelText(job) {
  	                const fuel = calculateFuelUsed(job);
  	
  	                if (fuel === null) return "";
  	
  	                return Number(fuel).toFixed(2);
  	              }
  	
  	              function buildMultilineEvent(job) {
  	                const apps = normalizeApplications(job);
  	                let headline = "";
  	                const extras = [];
  	
  	                apps.forEach(app => {
  	                  const type = safeString(app.Type).trim();
  	                  const reg = safeString(app.Registration).trim();
  	                  const trailer = safeString(app.Trailer).trim();
  	
  	                  let label = "";
  	
  	                  if (reg) label = type ? `${type} - ${reg}`: reg;
  	                  else if (trailer) label = type ? `${type} - ${trailer}`: trailer;
  	                  else label = type;
  	
  	                  if (!label) return;
  	
  	                  if (!headline) headline = label;
  	                  else extras.push(label);
  	                });
  	
  	                if (!headline) {
  	                  headline = pick(job, ["Event", "event", "Type", "type", "Name", "name"]) || "";
  	                }
  	
  	                return {
  	                  headline,
  	                  extras
  	                };
  	              }
  	
  	              function buildMultilineProducts(job) {
  	                return normalizeApplications(job).map(app => {
  	                  const product = safeString(app.Product).trim();
  	                  if (!product) return "";
  	
  	                  const labelBase = safeString(app.Registration || app.Trailer).trim();
  	                  return labelBase ? `${labelBase}: ${product}`: product;
  	                }).filter(Boolean);
  	              }
  	
  	              function buildMultilineRates(job) {
  	                return normalizeApplications(job).map(app => {
  	                  const rate = safeString(app.RateText).trim();
  	                  if (!rate) return "";
  	
  	                  const labelBase = safeString(app.Registration || app.Trailer).trim();
  	                  return labelBase ? `${labelBase}: ${rate}`: rate;
  	                }).filter(Boolean);
  	              }
  	
  	              function smallLines(lines) {
  	                const clean = Array.isArray(lines)
  	                ? lines.map(line => safeString(line).trim()).filter(Boolean): [];
  	
  	                if (!clean.length) return `<div class="jel-big jel-dash">-</div>`;
  	
  	                return `
  	                <div class="jel-small">
  	                ${clean.map(line => `<span class="jel-smallline">${escapeHtml(line)}</span>`).join("")}
  	                </div>
  	                `;
  	              }
  	
  	              function bigSmall(bigText, smallLineArray) {
  	                const big = safeString(bigText).trim();
  	                const small = Array.isArray(smallLineArray) ? smallLineArray: [];
  	
  	                return `
  	                <div class="jel-cell">
  	                <div class="jel-big ${big ? "": "jel-dash"}">${escapeHtml(big || "-")}</div>
  	                ${small.length ? smallLines(small): ""}
  	                </div>
  	                `;
  	              }
  	
  	              function getContractorText(job) {
  	                return pick(job,
  	                  [
  	                    "ContractorLabel",
  	                    "contractorLabel",
  	                    "ContractorName",
  	                    "contractorName",
  	                    "ContractorId",
  	                    "contractorId"
  	                  ]);
  	              }
  	
  	              function getDriverText(job) {
  	                const direct = pick(job, [
  	                  "DriverLabel", "driverLabel", "DriverName", "driverName",
  	                  "EmployeeLabel", "employeeLabel", "EmployeeName", "employeeName",
  	                  "OperatorLabel", "operatorLabel", "OperatorName", "operatorName",
  	                  "AssignedDriverName", "assignedDriverName", "CapturedByName", "capturedByName"
  	                ]);
  	
  	                if (direct) return direct;
  	
  	                const candidates = [
  	                  job?.Driver, job?.driver,
  	                  job?.Employee, job?.employee,
  	                  job?.Operator, job?.operator,
  	                  job?.AssignedDriver, job?.assignedDriver,
  	                  job?.Data?.Driver, job?.Data?.Employee, job?.Data?.Operator
  	                ];
  	
  	                for (let index = 0; index < candidates.length; index += 1) {
  	                  const candidate = candidates[index];
  	                  if (candidate === undefined || candidate === null) continue;
  	
  	                  if (typeof candidate === "string" || typeof candidate === "number") {
  	                    const text = safeString(candidate).trim();
  	                    if (text) return text;
  	                    continue;
  	                  }
  	
  	                  if (typeof candidate !== "object") continue;
  	
  	                  const label = pick(candidate, [
  	                    "FullName", "fullName", "DisplayName", "displayName",
  	                    "Name", "name", "Label", "label", "EmployeeName", "DriverName"
  	                  ]);
  	                  if (label) return label;
  	
  	                  const firstName = pick(candidate, ["FirstName", "firstName", "Firstname", "firstname"]);
  	                  const lastName = pick(candidate, ["LastName", "lastName", "Surname", "surname"]);
  	                  const combined = [firstName, lastName].filter(Boolean).join(" ").trim();
  	                  if (combined) return combined;
  	                }
  	
  	                return pick(job, [
  	                  "DriverId", "driverId", "EmployeeId", "employeeId",
  	                  "OperatorId", "operatorId", "AssignedDriverId", "assignedDriverId"
  	                ]);
  	              }
  	
  	              function getVehicleText(job) {
  	                return pick(job,
  	                  [
  	                    "VehicleLabel",
  	                    "vehicleLabel",
  	                    "VehicleRegistration",
  	                    "vehicleRegistration",
  	                    "VehicleName",
  	                    "vehicleName",
  	                    "VehicleId",
  	                    "vehicleId"
  	                  ]);
  	              }
  	
  	              function eventBoundaryTimestamp(job, boundary) {
  	                const raw = boundary === "out" ? getBestTimeOut(job) : getBestTimeIn(job);
  	                if (raw === undefined || raw === null || raw === "") return null;
  	
  	                const rawText = safeString(raw).trim();
  	                const hasFullDate = raw instanceof Date ||
  	                  typeof raw === "number" ||
  	                  /^\d{10,13}$/.test(rawText) ||
  	                  /^\d{4}-\d{2}-\d{2}[T\s]/.test(rawText);
  	
  	                if (hasFullDate) {
  	                  const fullDate = asDate(raw);
  	                  if (fullDate) return fullDate.getTime();
  	                }
  	
  	                const clock = parseClockValue(raw);
  	                if (clock.minutes === null) return null;
  	
  	                const baseText = safeString(getBestDate(job)).trim();
  	                const dateParts = baseText.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  	                const base = dateParts
  	                  ? new Date(Number(dateParts[1]), Number(dateParts[2]) - 1, Number(dateParts[3]), 0, 0, 0, 0)
  	                  : asDate(baseText);
  	                if (!base || Number.isNaN(base.getTime())) return null;
  	
  	                const combined = new Date(
  	                  base.getFullYear(),
  	                  base.getMonth(),
  	                  base.getDate(),
  	                  Math.floor(clock.minutes / 60),
  	                  clock.minutes % 60,
  	                  0,
  	                  0
  	                );
  	
  	                return Number.isNaN(combined.getTime()) ? null : combined.getTime();
  	              }
  	
  	              const EVENT_TRACKING_PADDING_MS = 5 * 60 * 1000;
  	              const EVENT_TRACKING_CACHE_VERSION = "event-tracking-v3-interactive-map";
  	
  	              function eventTrackingRange(job) {
  	                const recordedFrom = eventBoundaryTimestamp(job, "in");
  	                let recordedTo = eventBoundaryTimestamp(job, "out");
  	
  	                if (recordedFrom === null || recordedTo === null) return null;
  	                if (recordedTo <= recordedFrom && recordedTo + 86400000 > recordedFrom) recordedTo += 86400000;
  	                if (recordedTo <= recordedFrom) return null;
  	
  	                return {
  	                  recordedFrom,
  	                  recordedTo,
  	                  from: recordedFrom - EVENT_TRACKING_PADDING_MS,
  	                  to: recordedTo + EVENT_TRACKING_PADDING_MS,
  	                  paddingMs: EVENT_TRACKING_PADDING_MS
  	                };
  	              }
  	
  	              function eventTrackingParseJson(value, fallback) {
  	                if (value === undefined || value === null || value === "") return fallback;
  	                if (typeof value === "object") {
  	                  try { return JSON.parse(JSON.stringify(value)); }
  	                  catch (_) { return value; }
  	                }
  	
  	                const raw = safeString(value).trim();
  	                if (!raw) return fallback;
  	
  	                try { return JSON.parse(raw); }
  	                catch (_) { return fallback; }
  	              }
  	
  	              function eventTrackingCache(job) {
  	                const direct = firstEventValue(job, [
  	                  "Tracking",
  	                  "tracking",
  	                  "EventTracking",
  	                  "eventTracking",
  	                  "Data.EventTracking",
  	                  "Data.Tracking",
  	                  "data.eventTracking",
  	                  "data.tracking"
  	                ]);
  	
  	                const parsed = eventTrackingParseJson(direct, null);
  	                if (!parsed || typeof parsed !== "object") return null;
  	                if (safeString(parsed.version || parsed.Version || "") !== EVENT_TRACKING_CACHE_VERSION) return null;
  	
  	                return parsed;
  	              }
  	
  	              function eventTrackingNormaliseColor(value, fallback) {
  	                const textValue = safeString(value || "").trim();
  	
  	                if (
  	                  /^#[0-9a-f]{3,8}$/i.test(textValue) ||
  	                  /^rgba?\(/i.test(textValue) ||
  	                  /^hsla?\(/i.test(textValue) ||
  	                  /^[a-z]+$/i.test(textValue)
  	                ) {
  	                  return textValue;
  	                }
  	
  	                return fallback === undefined ? "" : fallback;
  	              }
  	
  	              function eventTrackingLocationColor(job) {
  	                const location = eventLocationForJob(job);
  	                const fallback = "#ff8a3c";
  	
  	                if (!location || typeof location !== "object") return fallback;
  	
  	                const paths = [
  	                  "Color",
  	                  "color",
  	                  "Colour",
  	                  "colour",
  	                  "LocationColor",
  	                  "locationColor",
  	                  "LocationColour",
  	                  "locationColour",
  	                  "PolygonColor",
  	                  "polygonColor",
  	                  "FillColor",
  	                  "fillColor",
  	                  "StrokeColor",
  	                  "strokeColor",
  	                  "HexColor",
  	                  "hexColor",
  	                  "HexColour",
  	                  "hexColour",
  	                  "Style.Color",
  	                  "Style.color",
  	                  "Style.Colour",
  	                  "Style.colour",
  	                  "Style.FillColor",
  	                  "Style.fillColor",
  	                  "Style.StrokeColor",
  	                  "Style.strokeColor",
  	                  "LocationData.Color",
  	                  "LocationData.color",
  	                  "LocationData.Colour",
  	                  "LocationData.colour",
  	                  "LocationData.LocationColor",
  	                  "LocationData.locationColor",
  	                  "LocationData.FillColor",
  	                  "LocationData.fillColor",
  	                  "LocationData.StrokeColor",
  	                  "LocationData.strokeColor",
  	                  "LocationData.Style.Color",
  	                  "LocationData.Style.color",
  	                  "LocationData.Style.FillColor",
  	                  "LocationData.Style.fillColor",
  	                  "LocationData.Style.StrokeColor",
  	                  "LocationData.Style.strokeColor",
  	                  "LocationData.Shape.Color",
  	                  "LocationData.Shape.color",
  	                  "LocationData.Shape.Colour",
  	                  "LocationData.Shape.colour",
  	                  "LocationData.Shape.FillColor",
  	                  "LocationData.Shape.fillColor",
  	                  "LocationData.Shape.StrokeColor",
  	                  "LocationData.Shape.strokeColor",
  	                  "Shape.Color",
  	                  "Shape.color",
  	                  "Shape.Colour",
  	                  "Shape.colour",
  	                  "Shape.FillColor",
  	                  "Shape.fillColor",
  	                  "Shape.StrokeColor",
  	                  "Shape.strokeColor"
  	                ];
  	
  	                for (let index = 0; index < paths.length; index += 1) {
  	                  const color = eventTrackingNormaliseColor(
  	                    readEventPath(location, paths[index]),
  	                    ""
  	                  );
  	
  	                  if (color) return color;
  	                }
  	
  	                return fallback;
  	              }
  	
  	              function eventTrackingPointEvents(raw) {
  	                const output = [];
  	
  	                function add(value) {
  	                  if (value === undefined || value === null) return;
  	
  	                  if (Array.isArray(value)) {
  	                    value.forEach(add);
  	                    return;
  	                  }
  	
  	                  if (typeof value === "object") {
  	                    const label = safeString(firstValue([
  	                      value.name,
  	                      value.Name,
  	                      value.type,
  	                      value.Type,
  	                      value.event,
  	                      value.Event,
  	                      value.label,
  	                      value.Label
  	                    ], "")).trim();
  	
  	                    if (label && !output.includes(label)) output.push(label);
  	                    return;
  	                  }
  	
  	                  const label = safeString(value).trim();
  	                  if (label && !output.includes(label)) output.push(label);
  	                }
  	
  	                if (raw && typeof raw === "object") {
  	                  add(raw.events);
  	                  add(raw.Events);
  	                  add(raw.event);
  	                  add(raw.Event);
  	                  add(raw.alarms);
  	                  add(raw.Alarms);
  	                  add(raw.alarm);
  	                  add(raw.Alarm);
  	                }
  	
  	                return output.slice(0, 24);
  	              }
  	
  	              function eventTrackingVehicleLimit(vehicle, names) {
  	                for (let index = 0; index < names.length; index += 1) {
  	                  const value = Number(trackingValue(vehicle, names[index]));
  	                  if (Number.isFinite(value) && value > 0) return value;
  	                }
  	
  	                return null;
  	              }
  	
  	              function eventTrackingPointRouteColor(point, vehicle) {
  	                const explicit = eventTrackingNormaliseColor(point && point.color, "");
  	                if (
  	                  explicit &&
  	                  /^(#ff0000|red|#00ff00|green|#ffff00|yellow)$/i.test(explicit)
  	                ) {
  	                  return explicit;
  	                }
  	
  	                const events = Array.isArray(point && point.events)
  	                  ? point.events.map(value => safeString(value))
  	                  : [];
  	
  	                const redEvents = [
  	                  "Speeding",
  	                  "Engine Over-Rev",
  	                  "Engine Over-Temperature",
  	                  "Throttle Overuse"
  	                ];
  	                const greenEvents = ["Green Band Driving"];
  	
  	                if (events.some(name => redEvents.includes(name))) return "#FF0000";
  	                if (events.some(name => greenEvents.includes(name))) return "#00FF00";
  	
  	                const speedLimit = eventTrackingVehicleLimit(vehicle, [
  	                  "CAN.Speed",
  	                  "CAN.SpeedLimit",
  	                  "CAN.MaxSpeed",
  	                  "SpeedLimit"
  	                ]);
  	                const rpmLimit = eventTrackingVehicleLimit(vehicle, [
  	                  "CAN.RPM",
  	                  "CAN.RPMLimit",
  	                  "CAN.MaxRPM"
  	                ]);
  	                const tempLimit = eventTrackingVehicleLimit(vehicle, [
  	                  "CAN.Temp",
  	                  "CAN.Temperature",
  	                  "CAN.MaxTemp"
  	                ]);
  	                const throttleLimit = eventTrackingVehicleLimit(vehicle, [
  	                  "CAN.ThrottlePct",
  	                  "CAN.Throttle",
  	                  "CAN.MaxThrottle"
  	                ]);
  	
  	                if (
  	                  (Number.isFinite(point && point.speed) && speedLimit !== null && point.speed > speedLimit) ||
  	                  (Number.isFinite(point && point.rpm) && rpmLimit !== null && point.rpm > rpmLimit) ||
  	                  (Number.isFinite(point && point.temperature) && tempLimit !== null && point.temperature > tempLimit) ||
  	                  (Number.isFinite(point && point.throttle) && throttleLimit !== null && point.throttle > throttleLimit)
  	                ) {
  	                  return "#FF0000";
  	                }
  	
  	                return "#FFFF00";
  	              }
  	
  	              function eventTrackingDarkenRouteColor(color, factor) {
  	                const value = eventTrackingNormaliseColor(color, "#FFFF00");
  	                const clean = String(value).replace("#", "");
  	
  	                if (!/^[0-9a-f]{6}$/i.test(clean)) return "#5a5a00";
  	
  	                const safeFactor = Math.max(0, Math.min(1, Number(factor) || 0.55));
  	                const red = Math.round(parseInt(clean.slice(0, 2), 16) * safeFactor);
  	                const green = Math.round(parseInt(clean.slice(2, 4), 16) * safeFactor);
  	                const blue = Math.round(parseInt(clean.slice(4, 6), 16) * safeFactor);
  	
  	                return "#" + [red, green, blue]
  	                  .map(value => value.toString(16).padStart(2, "0"))
  	                  .join("");
  	              }
  	
  	              function eventTrackingMixRouteColors(firstColor, secondColor, ratio) {
  	                function rgb(value) {
  	                  const clean = String(eventTrackingNormaliseColor(value, "#FFFF00")).replace("#", "");
  	                  if (!/^[0-9a-f]{6}$/i.test(clean)) return [255, 255, 0];
  	                  return [
  	                    parseInt(clean.slice(0, 2), 16),
  	                    parseInt(clean.slice(2, 4), 16),
  	                    parseInt(clean.slice(4, 6), 16)
  	                  ];
  	                }
  	
  	                const first = rgb(firstColor);
  	                const second = rgb(secondColor);
  	                const mix = Math.max(0, Math.min(1, Number(ratio) || 0.5));
  	
  	                return "#" + first.map((value, index) => {
  	                  return Math.round(value + (second[index] - value) * mix)
  	                    .toString(16)
  	                    .padStart(2, "0");
  	                }).join("");
  	              }
  	
  	              function eventTrackingRouteChevronIcon(color) {
  	                return {
  	                  path: "M -10 -7 L -4 -7 L 6 0 L -4 7 L -10 7 L 0 0 Z",
  	                  fillColor: eventTrackingDarkenRouteColor(color, 0.55),
  	                  fillOpacity: 0.20,
  	                  strokeColor: eventTrackingDarkenRouteColor(color, 0.34),
  	                  strokeOpacity: 0.25,
  	                  strokeWeight: 1,
  	                  scale: 0.72,
  	                  rotation: 270
  	                };
  	              }
  	
  	              function eventTrackingDirectionText(value) {
  	                const direction = Number(value);
  	                if (!Number.isFinite(direction)) return "—";
  	
  	                const labels = [
  	                  "N", "NNE", "NE", "ENE",
  	                  "E", "ESE", "SE", "SSE",
  	                  "S", "SSW", "SW", "WSW",
  	                  "W", "WNW", "NW", "NNW"
  	                ];
  	                const normalized = ((direction % 360) + 360) % 360;
  	                return `${labels[Math.round(normalized / 22.5) % 16]} · ${Math.round(normalized)}°`;
  	              }
  	
  	              function eventTrackingMetricText(value, suffix, decimals) {
  	                const numeric = Number(value);
  	                if (!Number.isFinite(numeric)) return "—";
  	                return numeric.toFixed(Number.isFinite(Number(decimals)) ? Number(decimals) : 0) + safeString(suffix || "");
  	              }
  	
  	              function eventTrackingCompactPoint(point) {
  	                if (!point) return null;
  	
  	                return {
  	                  timestamp: Number(point.timestamp),
  	                  lat: Number(point.lat),
  	                  lng: Number(point.lng),
  	                  speed: Number.isFinite(Number(point.speed)) ? Number(point.speed) : null,
  	                  rpm: Number.isFinite(Number(point.rpm)) ? Number(point.rpm) : null,
  	                  temperature: Number.isFinite(Number(point.temperature)) ? Number(point.temperature) : null,
  	                  throttle: Number.isFinite(Number(point.throttle)) ? Number(point.throttle) : null,
  	                  direction: Number.isFinite(Number(point.direction)) ? Number(point.direction) : null,
  	                  altitude: Number.isFinite(Number(point.altitude)) ? Number(point.altitude) : null,
  	                  odometer: Number.isFinite(Number(point.odometer)) ? Number(point.odometer) : null,
  	                  fuelLevel: Number.isFinite(Number(point.fuelLevel)) ? Number(point.fuelLevel) : null,
  	                  color: eventTrackingNormaliseColor(point.color, ""),
  	                  events: Array.isArray(point.events)
  	                    ? point.events.map(value => safeString(value)).filter(Boolean).slice(0, 24)
  	                    : [],
  	                  boundary: !!point.boundary,
  	                  boundaryType: safeString(point.boundaryType || "")
  	                };
  	              }
  	
  	              function eventTrackingRestorePoints(value) {
  	                return (Array.isArray(value) ? value : []).map(function (point) {
  	                  const timestamp = Number(point && point.timestamp);
  	                  const lat = Number(point && point.lat);
  	                  const lng = Number(point && point.lng);
  	
  	                  if (!Number.isFinite(timestamp) || !Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  	
  	                  return {
  	                    timestamp,
  	                    lat,
  	                    lng,
  	                    speed: Number.isFinite(Number(point.speed)) ? Number(point.speed) : null,
  	                    rpm: Number.isFinite(Number(point.rpm)) ? Number(point.rpm) : null,
  	                    temperature: Number.isFinite(Number(point.temperature)) ? Number(point.temperature) : null,
  	                    throttle: Number.isFinite(Number(point.throttle)) ? Number(point.throttle) : null,
  	                    direction: Number.isFinite(Number(point.direction)) ? Number(point.direction) : null,
  	                    altitude: Number.isFinite(Number(point.altitude)) ? Number(point.altitude) : null,
  	                    odometer: Number.isFinite(Number(point.odometer)) ? Number(point.odometer) : null,
  	                    fuelLevel: Number.isFinite(Number(point.fuelLevel)) ? Number(point.fuelLevel) : null,
  	                    color: eventTrackingNormaliseColor(point.color, ""),
  	                    events: Array.isArray(point.events)
  	                      ? point.events.map(value => safeString(value)).filter(Boolean)
  	                      : [],
  	                    boundary: !!point.boundary,
  	                    boundaryType: safeString(point.boundaryType || ""),
  	                    raw: null
  	                  };
  	                }).filter(Boolean).sort((a, b) => a.timestamp - b.timestamp);
  	              }
  	
  	              function eventTrackingClockWithSeconds(timestamp) {
  	                const date = new Date(Number(timestamp));
  	                if (Number.isNaN(date.getTime())) return "";
  	                return `${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;
  	              }
  	
  	              function eventTrackingCoordinateFromValue(value, preferLngLat) {
  	                if (!value) return null;
  	
  	                if (Array.isArray(value) && value.length >= 2) {
  	                  const first = Number(value[0]);
  	                  const second = Number(value[1]);
  	                  if (!Number.isFinite(first) || !Number.isFinite(second)) return null;
  	
  	                  let lat;
  	                  let lng;
  	
  	                  if (preferLngLat || Math.abs(first) > 90) {
  	                    lng = first;
  	                    lat = second;
  	                  } else if (Math.abs(second) > 90) {
  	                    lat = first;
  	                    lng = second;
  	                  } else {
  	                    lat = first;
  	                    lng = second;
  	                  }
  	
  	                  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  	                  return { lat, lng };
  	                }
  	
  	                if (typeof value === "object") {
  	                  const lat = Number(firstValue([
  	                    value.lat,
  	                    value.Lat,
  	                    value.latitude,
  	                    value.Latitude,
  	                    value.y,
  	                    value.Y
  	                  ], NaN));
  	                  const lng = Number(firstValue([
  	                    value.lng,
  	                    value.lon,
  	                    value.Lng,
  	                    value.Lon,
  	                    value.longitude,
  	                    value.Longitude,
  	                    value.x,
  	                    value.X
  	                  ], NaN));
  	
  	                  if (Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180) {
  	                    return { lat, lng };
  	                  }
  	                }
  	
  	                return null;
  	              }
  	
  	              function eventTrackingBoundaryRing(value, preferLngLat, depth) {
  	                depth = Number(depth || 0);
  	                if (depth > 7 || value === undefined || value === null) return [];
  	
  	                if (typeof value === "string") {
  	                  const parsed = eventTrackingParseJson(value, null);
  	                  return parsed ? eventTrackingBoundaryRing(parsed, preferLngLat, depth + 1) : [];
  	                }
  	
  	                if (Array.isArray(value)) {
  	                  if (!value.length) return [];
  	
  	                  const direct = value.map(item => eventTrackingCoordinateFromValue(item, preferLngLat)).filter(Boolean);
  	                  if (direct.length >= 3) return direct;
  	
  	                  for (let index = 0; index < value.length; index += 1) {
  	                    const nested = eventTrackingBoundaryRing(value[index], preferLngLat, depth + 1);
  	                    if (nested.length >= 3) return nested;
  	                  }
  	
  	                  return [];
  	                }
  	
  	                if (typeof value !== "object") return [];
  	
  	                const type = safeString(value.type || value.Type || "").toLowerCase();
  	                if (type === "feature") return eventTrackingBoundaryRing(value.geometry || value.Geometry, true, depth + 1);
  	                if (type === "polygon") return eventTrackingBoundaryRing(value.coordinates || value.Coordinates, true, depth + 1);
  	                if (type === "multipolygon") return eventTrackingBoundaryRing(value.coordinates || value.Coordinates, true, depth + 1);
  	
  	                const keys = [
  	                  "coordinates", "Coordinates",
  	                  "points", "Points",
  	                  "path", "Path",
  	                  "paths", "Paths",
  	                  "vertices", "Vertices",
  	                  "polygon", "Polygon",
  	                  "boundary", "Boundary",
  	                  "geometry", "Geometry",
  	                  "geojson", "GeoJSON"
  	                ];
  	
  	                for (let index = 0; index < keys.length; index += 1) {
  	                  if (value[keys[index]] === undefined) continue;
  	                  const nested = eventTrackingBoundaryRing(
  	                    value[keys[index]],
  	                    /coordinates|geojson|geometry/i.test(keys[index]) ? true : preferLngLat,
  	                    depth + 1
  	                  );
  	                  if (nested.length >= 3) return nested;
  	                }
  	
  	                return [];
  	              }
  	
  	              function eventTrackingBoundaryGeometry(job) {
  	                const linked = eventLocationForJob(job);
  	                if (!linked) return null;
  	
  	                const polygonPaths = [
  	                  "Boundary", "boundary",
  	                  "Polygon", "polygon",
  	                  "GeoJSON", "geojson",
  	                  "Geometry", "geometry",
  	                  "Coordinates", "coordinates",
  	                  "Points", "points",
  	                  "Path", "path",
  	                  "Geofence", "geofence",
  	                  "Fence", "fence",
  	                  "Data.Boundary", "Data.Polygon", "Data.GeoJSON", "Data.Geometry", "Data.Coordinates", "Data.Points", "Data.Path", "Data.Geofence",
  	                  "Data.Location.Boundary", "Data.Location.Polygon", "Data.Location.GeoJSON", "Data.Location.Geometry", "Data.Location.Coordinates",
  	                  "LocationData.Boundary", "LocationData.Polygon", "LocationData.GeoJSON", "LocationData.Geometry", "LocationData.Coordinates", "LocationData.Points", "LocationData.Path", "LocationData.Geofence"
  	                ];
  	
  	                for (let index = 0; index < polygonPaths.length; index += 1) {
  	                  const candidate = readEventPath(linked, polygonPaths[index]);
  	                  const ring = eventTrackingBoundaryRing(
  	                    unwrapEventValue(candidate),
  	                    /geojson|geometry|coordinates/i.test(polygonPaths[index]),
  	                    0
  	                  );
  	
  	                  if (ring.length >= 3) {
  	                    const first = ring[0];
  	                    const last = ring[ring.length - 1];
  	                    const closed = first && last && Math.abs(first.lat - last.lat) < 1e-9 && Math.abs(first.lng - last.lng) < 1e-9
  	                      ? ring.slice()
  	                      : ring.concat([{ lat: first.lat, lng: first.lng }]);
  	
  	                    return {
  	                      type: "polygon",
  	                      points: closed,
  	                      source: polygonPaths[index],
  	                      locationLabel: eventLocationDisplayLabel(job),
  	                      fieldLabel: eventFieldLabel(job)
  	                    };
  	                  }
  	                }
  	
  	                const centerLat = Number(firstValue([
  	                  linked.Latitude,
  	                  linked.latitude,
  	                  linked.lat,
  	                  readEventPath(linked, "Center.latitude"),
  	                  readEventPath(linked, "Center.lat"),
  	                  readEventPath(linked, "Data.Latitude"),
  	                  readEventPath(linked, "Data.Center.latitude"),
  	                  readEventPath(linked, "LocationData.Latitude"),
  	                  readEventPath(linked, "LocationData.Center.latitude")
  	                ], NaN));
  	
  	                const centerLng = Number(firstValue([
  	                  linked.Longitude,
  	                  linked.longitude,
  	                  linked.lng,
  	                  linked.lon,
  	                  readEventPath(linked, "Center.longitude"),
  	                  readEventPath(linked, "Center.lng"),
  	                  readEventPath(linked, "Data.Longitude"),
  	                  readEventPath(linked, "Data.Center.longitude"),
  	                  readEventPath(linked, "LocationData.Longitude"),
  	                  readEventPath(linked, "LocationData.Center.longitude")
  	                ], NaN));
  	
  	                const radius = Number(firstValue([
  	                  linked.Radius,
  	                  linked.radius,
  	                  linked.GeofenceRadius,
  	                  linked.geofenceRadius,
  	                  linked.BoundaryRadius,
  	                  readEventPath(linked, "Data.Radius"),
  	                  readEventPath(linked, "Data.GeofenceRadius"),
  	                  readEventPath(linked, "LocationData.Radius"),
  	                  readEventPath(linked, "LocationData.GeofenceRadius")
  	                ], NaN));
  	
  	                if (
  	                  Number.isFinite(centerLat) &&
  	                  Number.isFinite(centerLng) &&
  	                  Number.isFinite(radius) &&
  	                  radius > 0
  	                ) {
  	                  return {
  	                    type: "circle",
  	                    center: { lat: centerLat, lng: centerLng },
  	                    radiusMeters: radius,
  	                    source: "center-radius",
  	                    locationLabel: eventLocationDisplayLabel(job),
  	                    fieldLabel: eventFieldLabel(job)
  	                  };
  	                }
  	
  	                return null;
  	              }
  	
  	              function eventTrackingPointInsidePolygon(point, ring) {
  	                if (!point || !Array.isArray(ring) || ring.length < 3) return false;
  	
  	                let inside = false;
  	                const x = Number(point.lng);
  	                const y = Number(point.lat);
  	
  	                for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
  	                  const xi = Number(ring[i].lng);
  	                  const yi = Number(ring[i].lat);
  	                  const xj = Number(ring[j].lng);
  	                  const yj = Number(ring[j].lat);
  	
  	                  const intersects =
  	                    ((yi > y) !== (yj > y)) &&
  	                    (x < ((xj - xi) * (y - yi)) / ((yj - yi) || Number.EPSILON) + xi);
  	
  	                  if (intersects) inside = !inside;
  	                }
  	
  	                return inside;
  	              }
  	
  	              function eventTrackingPointInsideBoundary(point, boundary) {
  	                if (!point || !boundary) return false;
  	
  	                if (boundary.type === "polygon") {
  	                  return eventTrackingPointInsidePolygon(point, boundary.points);
  	                }
  	
  	                if (boundary.type === "circle" && boundary.center) {
  	                  return trackingDistanceMeters(point, boundary.center) <= Number(boundary.radiusMeters || 0);
  	                }
  	
  	                return false;
  	              }
  	
  	              function eventTrackingInterpolatedPoint(a, b, ratio, boundaryType) {
  	                ratio = Math.max(0, Math.min(1, Number(ratio) || 0));
  	
  	                return {
  	                  timestamp: Math.round(a.timestamp + (b.timestamp - a.timestamp) * ratio),
  	                  lat: a.lat + (b.lat - a.lat) * ratio,
  	                  lng: a.lng + (b.lng - a.lng) * ratio,
  	                  speed: Number.isFinite(Number(b.speed)) ? Number(b.speed) : Number.isFinite(Number(a.speed)) ? Number(a.speed) : null,
  	                  rpm: Number.isFinite(Number(b.rpm)) ? Number(b.rpm) : Number.isFinite(Number(a.rpm)) ? Number(a.rpm) : null,
  	                  temperature: Number.isFinite(Number(b.temperature)) ? Number(b.temperature) : Number.isFinite(Number(a.temperature)) ? Number(a.temperature) : null,
  	                  throttle: Number.isFinite(Number(b.throttle)) ? Number(b.throttle) : Number.isFinite(Number(a.throttle)) ? Number(a.throttle) : null,
  	                  direction: Number.isFinite(Number(b.direction)) ? Number(b.direction) : Number.isFinite(Number(a.direction)) ? Number(a.direction) : null,
  	                  altitude: Number.isFinite(Number(b.altitude)) ? Number(b.altitude) : Number.isFinite(Number(a.altitude)) ? Number(a.altitude) : null,
  	                  odometer: Number.isFinite(Number(a.odometer)) && Number.isFinite(Number(b.odometer))
  	                    ? a.odometer + (b.odometer - a.odometer) * ratio
  	                    : Number.isFinite(Number(b.odometer)) ? Number(b.odometer) : Number.isFinite(Number(a.odometer)) ? Number(a.odometer) : null,
  	                  fuelLevel: Number.isFinite(Number(a.fuelLevel)) && Number.isFinite(Number(b.fuelLevel))
  	                    ? a.fuelLevel + (b.fuelLevel - a.fuelLevel) * ratio
  	                    : Number.isFinite(Number(b.fuelLevel)) ? Number(b.fuelLevel) : Number.isFinite(Number(a.fuelLevel)) ? Number(a.fuelLevel) : null,
  	                  events: [],
  	                  color: eventTrackingNormaliseColor(
  	                    Number(ratio) >= 0.5 ? b.color : a.color,
  	                    "#FFFF00"
  	                  ),
  	                  raw: null,
  	                  boundary: true,
  	                  boundaryType: safeString(boundaryType || "")
  	                };
  	              }
  	
  	              function eventTrackingSegmentCrossing(a, b, boundary, transition) {
  	                if (!a || !b || !boundary) return null;
  	
  	                const startInside = eventTrackingPointInsideBoundary(a, boundary);
  	                const endInside = eventTrackingPointInsideBoundary(b, boundary);
  	                if (startInside === endInside) return null;
  	
  	                let low = 0;
  	                let high = 1;
  	                const expectedLowInside = startInside;
  	
  	                for (let iteration = 0; iteration < 28; iteration += 1) {
  	                  const middle = (low + high) / 2;
  	                  const probe = eventTrackingInterpolatedPoint(a, b, middle, transition);
  	                  const probeInside = eventTrackingPointInsideBoundary(probe, boundary);
  	
  	                  if (probeInside === expectedLowInside) low = middle;
  	                  else high = middle;
  	                }
  	
  	                return eventTrackingInterpolatedPoint(a, b, (low + high) / 2, transition);
  	              }
  	
  	              function eventTrackingFindBoundaryCrossings(points, boundary, range) {
  	                const entries = [];
  	                const exits = [];
  	
  	                for (let index = 1; index < points.length; index += 1) {
  	                  const previous = points[index - 1];
  	                  const current = points[index];
  	                  const wasInside = eventTrackingPointInsideBoundary(previous, boundary);
  	                  const isInside = eventTrackingPointInsideBoundary(current, boundary);
  	
  	                  if (wasInside === isInside) continue;
  	
  	                  if (!wasInside && isInside) {
  	                    const crossing = eventTrackingSegmentCrossing(previous, current, boundary, "entry");
  	                    if (crossing) entries.push({ crossing, before: previous, after: current, index });
  	                  } else if (wasInside && !isInside) {
  	                    const crossing = eventTrackingSegmentCrossing(previous, current, boundary, "exit");
  	                    if (crossing) exits.push({ crossing, before: previous, after: current, index });
  	                  }
  	                }
  	
  	                const recordedFrom = Number(range && range.recordedFrom);
  	                const recordedTo = Number(range && range.recordedTo);
  	
  	                entries.sort((left, right) =>
  	                  Math.abs(left.crossing.timestamp - recordedFrom) - Math.abs(right.crossing.timestamp - recordedFrom)
  	                );
  	
  	                let entry = entries[0] || null;
  	                let possibleExits = exits.filter(candidate => !entry || candidate.crossing.timestamp > entry.crossing.timestamp);
  	
  	                possibleExits.sort((left, right) =>
  	                  Math.abs(left.crossing.timestamp - recordedTo) - Math.abs(right.crossing.timestamp - recordedTo)
  	                );
  	
  	                let exit = possibleExits[0] || null;
  	
  	                if (!entry || !exit || exit.crossing.timestamp <= entry.crossing.timestamp) {
  	                  return {
  	                    ok: false,
  	                    entry: entry,
  	                    exit: exit,
  	                    entries,
  	                    exits,
  	                    reason: !entry
  	                      ? "No outside-to-inside boundary crossing was found in the padded tracking window."
  	                      : !exit
  	                        ? "No inside-to-outside boundary crossing was found after the entry crossing."
  	                        : "The detected boundary crossings are not in a valid order."
  	                  };
  	                }
  	
  	                return { ok: true, entry, exit, entries, exits, reason: "" };
  	              }
  	
  	              function eventTrackingRouteBetween(points, entryPoint, exitPoint) {
  	                const route = [entryPoint];
  	
  	                points.forEach(function (point) {
  	                  if (point.timestamp > entryPoint.timestamp && point.timestamp < exitPoint.timestamp) {
  	                    route.push(point);
  	                  }
  	                });
  	
  	                route.push(exitPoint);
  	
  	                return route.sort((a, b) => a.timestamp - b.timestamp);
  	              }
  	
  	              function reconcileEventTracking(job, points, searchRange) {
  	                const boundary = eventTrackingBoundaryGeometry(job);
  	                if (!boundary) {
  	                  return {
  	                    ok: false,
  	                    reason: "This Location has no readable polygon/geofence boundary in the loaded Location record.",
  	                    boundary: null,
  	                    searchRange,
  	                    routePoints: [],
  	                    analysis: null,
  	                    entry: null,
  	                    exit: null
  	                  };
  	                }
  	
  	                const crossings = eventTrackingFindBoundaryCrossings(points, boundary, searchRange);
  	                if (!crossings.ok) {
  	                  return {
  	                    ok: false,
  	                    reason: crossings.reason,
  	                    boundary,
  	                    searchRange,
  	                    routePoints: [],
  	                    analysis: null,
  	                    entry: crossings.entry,
  	                    exit: crossings.exit
  	                  };
  	                }
  	
  	                const entryPoint = crossings.entry.crossing;
  	                const exitPoint = crossings.exit.crossing;
  	                const correctedRange = {
  	                  from: entryPoint.timestamp,
  	                  to: exitPoint.timestamp,
  	                  recordedFrom: searchRange.recordedFrom,
  	                  recordedTo: searchRange.recordedTo,
  	                  paddingMs: searchRange.paddingMs
  	                };
  	                const routePoints = eventTrackingRouteBetween(points, entryPoint, exitPoint);
  	                const analysis = analyseEventTracking(routePoints, correctedRange);
  	
  	                return {
  	                  ok: true,
  	                  reason: "",
  	                  boundary,
  	                  searchRange,
  	                  correctedRange,
  	                  routePoints,
  	                  analysis,
  	                  entry: crossings.entry,
  	                  exit: crossings.exit,
  	                  crossings
  	                };
  	              }
  	
  	              function eventTrackingEvidenceFromReconciliation(job, loaded, searchPoints, result) {
  	                const corrected = result && result.correctedRange;
  	                const analysis = result && result.analysis;
  	                const entryPoint = result && result.entry && result.entry.crossing;
  	                const exitPoint = result && result.exit && result.exit.crossing;
  	
  	                return {
  	                  version: EVENT_TRACKING_CACHE_VERSION,
  	                  reconciled: !!(result && result.ok),
  	                  reconciledAt: new Date().toISOString(),
  	                  source: safeString(loaded && loaded.source || ""),
  	                  location: {
  	                    id: safeString(firstValue([
  	                      job && job.LocationId,
  	                      job && job.LocationObjectId,
  	                      getDeep(job, ["Location", "objectId"], "")
  	                    ], "")),
  	                    locationLabel: eventLocationDisplayLabel(job),
  	                    fieldLabel: eventFieldLabel(job)
  	                  },
  	                  recorded: {
  	                    from: result && result.searchRange ? result.searchRange.recordedFrom : null,
  	                    to: result && result.searchRange ? result.searchRange.recordedTo : null
  	                  },
  	                  searchWindow: {
  	                    from: result && result.searchRange ? result.searchRange.from : null,
  	                    to: result && result.searchRange ? result.searchRange.to : null,
  	                    paddingMs: EVENT_TRACKING_PADDING_MS
  	                  },
  	                  corrected: corrected && analysis ? {
  	                    from: corrected.from,
  	                    to: corrected.to,
  	                    durationSeconds: analysis.durationSeconds,
  	                    distanceMeters: analysis.distance,
  	                    movingSeconds: analysis.movingSeconds,
  	                    stoppedSeconds: analysis.stoppedSeconds,
  	                    averageSpeed: analysis.averageSpeed,
  	                    maximumSpeed: analysis.maxSpeed,
  	                    pointCount: result.routePoints.length
  	                  } : null,
  	                  boundary: result && result.boundary ? {
  	                    type: result.boundary.type,
  	                    source: result.boundary.source,
  	                    entry: entryPoint ? eventTrackingCompactPoint(entryPoint) : null,
  	                    exit: exitPoint ? eventTrackingCompactPoint(exitPoint) : null
  	                  } : null,
  	                  points: searchPoints.map(eventTrackingCompactPoint).filter(Boolean),
  	                  routePoints: (result && result.routePoints || []).map(eventTrackingCompactPoint).filter(Boolean),
  	                  reason: safeString(result && result.reason || "")
  	                };
  	              }
  	
  	              function eventTrackingApplyKnownField(payload, job, names, value, fallbackName) {
  	                for (let index = 0; index < names.length; index += 1) {
  	                  if (Object.prototype.hasOwnProperty.call(job || {}, names[index])) {
  	                    payload[names[index]] = value;
  	                    return names[index];
  	                  }
  	                }
  	
  	                if (fallbackName) {
  	                  payload[fallbackName] = value;
  	                  return fallbackName;
  	                }
  	
  	                return "";
  	              }
  	
  	              /*
  	               * JobEntries installations do not all use the same schema for
  	               * TimeIn / TimeOut. Some store a clock string, while others use
  	               * Backendless DATETIME (epoch milliseconds). Never force a clock
  	               * string into a DATETIME column.
  	               *
  	               * Match the datatype/shape already returned by Backendless.
  	               * If the current value is null/unknown, do not risk writing the
  	               * scalar field; the corrected timestamps are still persisted in
  	               * Data.EventTracking and used by the parity renderer.
  	               */
  	              function eventTrackingCompatibleTimeValue(existingValue, timestamp) {
  	                const ms = Number(timestamp);
  	                if (!Number.isFinite(ms)) return { usable: false, value: null };
  	
  	                if (existingValue instanceof Date) {
  	                  return {
  	                    usable: true,
  	                    value: new Date(ms)
  	                  };
  	                }
  	
  	                if (typeof existingValue === "number" && Number.isFinite(existingValue)) {
  	                  /*
  	                   * Preserve seconds-vs-milliseconds if an older numeric schema
  	                   * used Unix seconds. Backendless DATETIME normally returns ms.
  	                   */
  	                  return {
  	                    usable: true,
  	                    value: Math.abs(existingValue) < 100000000000
  	                      ? Math.round(ms / 1000)
  	                      : Math.round(ms)
  	                  };
  	                }
  	
  	                if (typeof existingValue === "string") {
  	                  const raw = existingValue.trim();
  	
  	                  if (!raw) {
  	                    return { usable: false, value: null };
  	                  }
  	
  	                  if (/^\d{10}$/.test(raw)) {
  	                    return {
  	                      usable: true,
  	                      value: String(Math.round(ms / 1000))
  	                    };
  	                  }
  	
  	                  if (/^\d{13}$/.test(raw)) {
  	                    return {
  	                      usable: true,
  	                      value: String(Math.round(ms))
  	                    };
  	                  }
  	
  	                  /*
  	                   * A full calendar datetime in a string-valued object usually
  	                   * represents a Backendless DATETIME that has been formatted by
  	                   * an intermediate layer. Use a real Date object for the SDK.
  	                   */
  	                  if (
  	                    /^\d{4}-\d{2}-\d{2}[T\s]/.test(raw) ||
  	                    !Number.isNaN(Date.parse(raw))
  	                  ) {
  	                    return {
  	                      usable: true,
  	                      value: new Date(ms)
  	                    };
  	                  }
  	
  	                  /*
  	                   * Genuine clock-only STRING column.
  	                   */
  	                  if (
  	                    /^\d{1,2}:\d{2}(?::\d{2})?(?:\s*[AP]M)?$/i.test(raw)
  	                  ) {
  	                    return {
  	                      usable: true,
  	                      value: eventTrackingClockWithSeconds(ms)
  	                    };
  	                  }
  	
  	                  /*
  	                   * Unknown non-empty string shape: preserve string semantics.
  	                   */
  	                  return {
  	                    usable: true,
  	                    value: eventTrackingClockWithSeconds(ms)
  	                  };
  	                }
  	
  	                /*
  	                 * Null/undefined/object descriptors do not give us enough
  	                 * information to safely infer the Backendless column datatype.
  	                 */
  	                return { usable: false, value: null };
  	              }
  	
  	              function eventTrackingApplyCompatibleTimeField(payload, job, names, timestamp) {
  	                for (let index = 0; index < names.length; index += 1) {
  	                  const name = names[index];
  	
  	                  if (!Object.prototype.hasOwnProperty.call(job || {}, name)) {
  	                    continue;
  	                  }
  	
  	                  const converted = eventTrackingCompatibleTimeValue(
  	                    job[name],
  	                    timestamp
  	                  );
  	
  	                  if (!converted.usable) {
  	                    return "";
  	                  }
  	
  	                  payload[name] = converted.value;
  	                  return name;
  	                }
  	
  	                /*
  	                 * Do not create TimeIn/TimeOut blindly. If the loaded JobEntry
  	                 * did not expose a known field we cannot know its schema type.
  	                 */
  	                return "";
  	              }
  	
  	              function eventTrackingCloneObject(value) {
  	                const parsed = eventTrackingParseJson(value, {});
  	                return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  	              }
  	
  	              async function saveEventTrackingReconciliation(job, evidence, result) {
  	                if (!hasBackendlessData()) {
  	                  throw new Error("The Database connection is unavailable, so the reconciled Job cannot be saved.");
  	                }
  	
  	                const objectId = jobEntryObjectId(job);
  	                if (!objectId) {
  	                  throw new Error("This Job Entry has no objectId and cannot be reconciled.");
  	                }
  	
  	                const store = Backendless.Data.of(TABLE_JOB_ENTRIES);
  	                if (!store || typeof store.save !== "function") {
  	                  throw new Error("The JobEntries save function is unavailable.");
  	                }
  	
  	                const corrected = result && result.correctedRange;
  	                const analysis = result && result.analysis;
  	                const basePayload = { objectId };
  	
  	                if (corrected && analysis) {
  	                  eventTrackingApplyCompatibleTimeField(
  	                    basePayload,
  	                    job,
  	                    ["TimeIn", "timeIn", "Time_In", "StartTime", "startTime", "EnterTime", "EntryTime"],
  	                    corrected.from
  	                  );
  	                  eventTrackingApplyCompatibleTimeField(
  	                    basePayload,
  	                    job,
  	                    ["TimeOut", "timeOut", "Time_Out", "EndTime", "endTime", "ExitTime", "DepartureTime"],
  	                    corrected.to
  	                  );
  	
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["DurationSeconds", "durationSeconds", "DurationSec", "durationSec"],
  	                    Math.round(analysis.durationSeconds),
  	                    ""
  	                  );
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["DurationMinutes", "durationMinutes"],
  	                    analysis.durationSeconds / 60,
  	                    ""
  	                  );
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["Distance", "distance", "DistanceKm", "distanceKm", "TrackedDistance", "trackedDistance"],
  	                    analysis.distance / 1000,
  	                    ""
  	                  );
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["MovingSeconds", "movingSeconds"],
  	                    Math.round(analysis.movingSeconds),
  	                    ""
  	                  );
  	                  eventTrackingApplyKnownField(
  	                    basePayload,
  	                    job,
  	                    ["StoppedSeconds", "stoppedSeconds"],
  	                    Math.round(analysis.stoppedSeconds),
  	                    ""
  	                  );
  	                }
  	
  	                const attempts = [];
  	                const existingData = eventTrackingCloneObject(job && job.Data);
  	                existingData.EventTracking = evidence;
  	
  	                attempts.push(Object.assign({}, basePayload, { Data: existingData }));
  	                attempts.push(Object.assign({}, basePayload, { Tracking: evidence }));
  	
  	                let lastError = null;
  	                let saved = null;
  	                let cacheField = "";
  	
  	                for (let index = 0; index < attempts.length; index += 1) {
  	                  try {
  	                    saved = await store.save(attempts[index]);
  	                    cacheField = index === 0 ? "Data.EventTracking" : "Tracking";
  	                    break;
  	                  } catch (error) {
  	                    lastError = error;
  	                  }
  	                }
  	
  	                if (!saved) {
  	                  /*
  	                   * Last-resort safe cache save:
  	                   * a customer schema may contain a TimeIn/TimeOut datatype we
  	                   * cannot infer from a null value. The visual reconciliation
  	                   * must still work and the evidence must still be persisted.
  	                   */
  	                  const safePayload = {
  	                    objectId: objectId,
  	                    Data: existingData
  	                  };
  	
  	                  try {
  	                    saved = await store.save(safePayload);
  	                    cacheField = "Data.EventTracking";
  	
  	                    /*
  	                     * Keep only fields Backendless accepted as persisted scalar
  	                     * values. The evidence JSON always holds corrected.from/to.
  	                     */
  	                    Object.keys(basePayload).forEach(function (key) {
  	                      if (key === "objectId") return;
  	
  	                      if (
  	                        key === "TimeIn" ||
  	                        key === "timeIn" ||
  	                        key === "Time_In" ||
  	                        key === "StartTime" ||
  	                        key === "startTime" ||
  	                        key === "EnterTime" ||
  	                        key === "EntryTime" ||
  	                        key === "TimeOut" ||
  	                        key === "timeOut" ||
  	                        key === "Time_Out" ||
  	                        key === "EndTime" ||
  	                        key === "endTime" ||
  	                        key === "ExitTime" ||
  	                        key === "DepartureTime"
  	                      ) {
  	                        delete basePayload[key];
  	                      }
  	                    });
  	                  } catch (safeError) {
  	                    throw lastError || safeError;
  	                  }
  	                }
  	
  	                if (saved && typeof saved === "object") Object.assign(job, saved);
  	                Object.assign(job, basePayload);
  	
  	                job.Data = eventTrackingCloneObject(job.Data);
  	                job.Data.EventTracking = evidence;
  	                job.Tracking = evidence;
  	
  	
  	                return {
  	                  saved: saved && typeof saved === "object" ? saved : basePayload,
  	                  cacheField,
  	                  cacheSaved: !!cacheField
  	                };
  	              }
  	
  	              function eventTrackingContextFromCache(job, searchRange) {
  	                const cache = eventTrackingCache(job);
  	                if (!cache || cache.reconciled !== true || !cache.corrected) return null;
  	
  	                const currentFrom = searchRange && Number(searchRange.recordedFrom);
  	                const currentTo = searchRange && Number(searchRange.recordedTo);
  	                const cachedCorrectedFrom = Number(cache.corrected.from);
  	                const cachedCorrectedTo = Number(cache.corrected.to);
  	
  	                if (
  	                  !Number.isFinite(cachedCorrectedFrom) ||
  	                  !Number.isFinite(cachedCorrectedTo) ||
  	                  cachedCorrectedTo <= cachedCorrectedFrom
  	                ) {
  	                  return null;
  	                }
  	
  	                const currentMatchesCorrected =
  	                  Number.isFinite(currentFrom) &&
  	                  Number.isFinite(currentTo) &&
  	                  Math.abs(currentFrom - cachedCorrectedFrom) <= 2000 &&
  	                  Math.abs(currentTo - cachedCorrectedTo) <= 2000;
  	
  	                const currentMatchesRecorded =
  	                  Number.isFinite(currentFrom) &&
  	                  Number.isFinite(currentTo) &&
  	                  Number.isFinite(Number(cache.recorded && cache.recorded.from)) &&
  	                  Number.isFinite(Number(cache.recorded && cache.recorded.to)) &&
  	                  Math.abs(currentFrom - Number(cache.recorded.from)) <= 2000 &&
  	                  Math.abs(currentTo - Number(cache.recorded.to)) <= 2000;
  	
  	                if (!currentMatchesCorrected && !currentMatchesRecorded) return null;
  	
  	                const routePoints = eventTrackingRestorePoints(cache.routePoints);
  	                const searchPoints = eventTrackingRestorePoints(cache.points);
  	                if (routePoints.length < 2) return null;
  	
  	                const correctedRange = {
  	                  from: cachedCorrectedFrom,
  	                  to: cachedCorrectedTo,
  	                  recordedFrom: Number(cache.recorded && cache.recorded.from),
  	                  recordedTo: Number(cache.recorded && cache.recorded.to),
  	                  paddingMs: Number(cache.searchWindow && cache.searchWindow.paddingMs) || EVENT_TRACKING_PADDING_MS
  	                };
  	
  	                const analysis = {
  	                  distance: Number(cache.corrected.distanceMeters) || 0,
  	                  durationSeconds: Number(cache.corrected.durationSeconds) || Math.max(0, (cachedCorrectedTo - cachedCorrectedFrom) / 1000),
  	                  movingSeconds: Number(cache.corrected.movingSeconds) || 0,
  	                  stoppedSeconds: Number(cache.corrected.stoppedSeconds) || 0,
  	                  maxSpeed: Number.isFinite(Number(cache.corrected.maximumSpeed)) ? Number(cache.corrected.maximumSpeed) : null,
  	                  averageSpeed: Number.isFinite(Number(cache.corrected.averageSpeed)) ? Number(cache.corrected.averageSpeed) : null,
  	                  first: routePoints[0] || null,
  	                  last: routePoints[routePoints.length - 1] || null
  	                };
  	
  	                return {
  	                  cache,
  	                  points: routePoints,
  	                  searchPoints,
  	                  analysis,
  	                  correctedRange,
  	                  boundary: eventTrackingBoundaryGeometry(job),
  	                  source: "Saved JobEntries tracking JSON"
  	                };
  	              }
  	
  	              function trackingValue(raw, keys) {
  	                if (!raw || typeof raw !== "object") return null;
  	
  	                for (let index = 0; index < keys.length; index += 1) {
  	                  const key = keys[index];
  	                  let value;
  	
  	                  if (Object.prototype.hasOwnProperty.call(raw, key)) {
  	                    value = raw[key];
  	                  } else {
  	                    value = key.split(".").reduce((current, part) => {
  	                      return current && current[part] !== undefined ? current[part] : undefined;
  	                    }, raw);
  	                  }
  	
  	                  if (value && typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "value")) {
  	                    value = value.value;
  	                  }
  	
  	                  if (value !== undefined && value !== null && value !== "") return value;
  	                }
  	
  	                return null;
  	              }
  	
  	              function trackingNumber(raw, keys) {
  	                const numeric = Number(trackingValue(raw, keys));
  	                return Number.isFinite(numeric) ? numeric : null;
  	              }
  	
  	              function trackingTimestamp(value) {
  	                if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.getTime();
  	                if (typeof value === "number" && Number.isFinite(value)) return value < 1e12 ? value * 1000 : value;
  	
  	                const raw = safeString(value).trim();
  	                if (!raw) return null;
  	
  	                const numeric = Number(raw);
  	                if (Number.isFinite(numeric)) return numeric < 1e12 ? numeric * 1000 : numeric;
  	
  	                const parsed = Date.parse(raw);
  	                return Number.isFinite(parsed) ? parsed : null;
  	              }
  	
  	              function trackerIdOf(vehicle) {
  	                return safeString(trackingValue(vehicle, [
  	                  "Tracker", "TrackerId", "TrackerID", "trackerId",
  	                  "Data.Tracking.TrackerId", "Data.Telematics.DeviceId", "DeviceId", "deviceId"
  	                ]) || "").trim();
  	              }
  	
  	              function objectIdOfEventAsset(value) {
  	                return safeString(trackingValue(value, ["objectId", "ObjectId", "objectID", "id", "ID"]) || "").trim();
  	              }
  	
  	              function normaliseMatchToken(value) {
  	                return safeString(value || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
  	              }
  	
  	              function eventVehicleCandidates() {
  	                const output = [];
  	                const add = value => {
  	                  if (!value || typeof value !== "object") return;
  	                  if (!output.includes(value)) output.push(value);
  	                };
  	                const addArray = value => (Array.isArray(value) ? value : value ? [value] : []).forEach(add);
  	
  	                addArray(eventCompany?.Tractors);
  	                addArray(eventCompany?.Vehicles);
  	                addArray(eventCompany?.Fleet);
  	                addArray(appData?.Tractors);
  	                addArray(appData?.Vehicles);
  	                add(appData?.SelectedTractor);
  	
  	                const companies = []
  	                  .concat(Array.isArray(appData?.Companies) ? appData.Companies : [])
  	                  .concat(Array.isArray(appData?.User?.Companies) ? appData.User.Companies : []);
  	
  	                companies.forEach(company => {
  	                  addArray(company?.Tractors);
  	                  addArray(company?.Vehicles);
  	                });
  	
  	                return output;
  	              }
  	
  	              function vehicleMatchTokens(vehicle) {
  	                return [
  	                  objectIdOfEventAsset(vehicle),
  	                  trackingValue(vehicle, ["VehicleId", "vehicleId", "TractorId", "tractorId"]),
  	                  trackingValue(vehicle, ["Registration", "registration", "VehicleRegistration", "vehicleRegistration"]),
  	                  trackingValue(vehicle, ["Label", "label", "Name", "name", "VehicleName", "vehicleName"]),
  	                  trackerIdOf(vehicle)
  	                ].map(normaliseMatchToken).filter(Boolean);
  	              }
  	
  	              function resolveEventVehicle(job) {
  	                const jobTokens = [
  	                  trackingValue(job, ["VehicleObjectId", "vehicleObjectId", "VehicleId", "vehicleId"]),
  	                  trackingValue(job, ["TractorObjectId", "tractorObjectId", "TractorId", "tractorId"]),
  	                  trackingValue(job, ["VehicleRegistration", "vehicleRegistration", "Registration", "registration"]),
  	                  trackingValue(job, ["VehicleLabel", "vehicleLabel", "VehicleName", "vehicleName"]),
  	                  getVehicleText(job)
  	                ].map(normaliseMatchToken).filter(Boolean);
  	
  	                let best = null;
  	                let bestScore = 0;
  	
  	                eventVehicleCandidates().forEach(vehicle => {
  	                  const candidates = vehicleMatchTokens(vehicle);
  	                  let score = 0;
  	
  	                  jobTokens.forEach(jobToken => {
  	                    candidates.forEach(vehicleToken => {
  	                      if (jobToken === vehicleToken) score = Math.max(score, 100);
  	                      else if (jobToken.length >= 5 && (jobToken.includes(vehicleToken) || vehicleToken.includes(jobToken))) {
  	                        score = Math.max(score, 45);
  	                      }
  	                    });
  	                  });
  	
  	                  if (score > bestScore) {
  	                    bestScore = score;
  	                    best = vehicle;
  	                  }
  	                });
  	
  	                return best;
  	              }
  	
  	              function trackingExtractRows(payload, depth = 0) {
  	                if (depth > 6 || payload === undefined || payload === null) return [];
  	                if (Array.isArray(payload)) return payload;
  	
  	                if (typeof payload === "string") {
  	                  try { return trackingExtractRows(JSON.parse(payload), depth + 1); }
  	                  catch (_) { return []; }
  	                }
  	
  	                if (typeof payload !== "object") return [];
  	
  	                const keys = ["result", "messages", "Tracking", "tracking", "rows", "items", "data", "body"];
  	                for (let index = 0; index < keys.length; index += 1) {
  	                  if (payload[keys[index]] === undefined) continue;
  	                  const rows = trackingExtractRows(payload[keys[index]], depth + 1);
  	                  if (rows.length || Array.isArray(payload[keys[index]])) return rows;
  	                }
  	
  	                return [];
  	              }
  	
  	              function trackingMessageTimestamp(row) {
  	                return trackingTimestamp(trackingValue(row, ["timestamp", "server.timestamp", "created", "time", "ts"]));
  	              }
  	
  	              function loadedEventTrackingRows(vehicle, from, to) {
  	                const sources = [
  	                  vehicle?.Tracking,
  	                  vehicle?.TrackingHistory,
  	                  vehicle?.TelemetryHistory,
  	                  appData?.Tracking?.[trackerIdOf(vehicle)]
  	                ];
  	
  	                for (let index = 0; index < sources.length; index += 1) {
  	                  const rows = trackingExtractRows(sources[index]).filter(row => {
  	                    const timestamp = trackingMessageTimestamp(row);
  	                    return timestamp !== null && timestamp >= from && timestamp <= to;
  	                  });
  	                  if (rows.length) return rows;
  	                }
  	
  	                return [];
  	              }
  	
  	              const EVENT_TRACKING_FUNCTION = "fn_2cdb14e20aec99596e5725c4e3064843";
  	              const EVENT_TRACKING_FIELDS = [
  	                "timestamp", "server.timestamp", "position.latitude", "position.longitude",
  	                "position.speed", "position.direction", "position.valid", "can.vehicle.speed",
  	                "can.vehicle.mileage", "can.fuel.level", "engine.ignition.status", "movement.status",
  	                "battery.voltage", "gsm.signal.level", "ident"
  	              ];
  	
  	              async function loadEventTracking(vehicle, range) {
  	                const trackerId = trackerIdOf(vehicle);
  	                if (!trackerId) throw new Error("The event vehicle has no tracker device ID.");
  	
  	                const payload = {
  	                  trackerId,
  	                  vehicleObjectId: objectIdOfEventAsset(vehicle),
  	                  registration: safeString(trackingValue(vehicle, ["Registration", "VehicleRegistration", "Label", "Name"]) || ""),
  	                  from: Math.floor(range.from / 1000),
  	                  to: Math.ceil(range.to / 1000),
  	                  fromIso: new Date(range.from).toISOString(),
  	                  toIso: new Date(range.to).toISOString(),
  	                  fields: EVENT_TRACKING_FIELDS.slice()
  	                };
  	
  	                const loaded = loadedEventTrackingRows(vehicle, range.from, range.to);
  	                if (loaded.length) return { rows: loaded, source: "Loaded vehicle tracking", payload };
  	
  	                const runtimes = [];
  	                try { if (typeof BackendlessUI !== "undefined" && BackendlessUI) runtimes.push(BackendlessUI); } catch (_) {}
  	                try { if (window.BackendlessUI && !runtimes.includes(window.BackendlessUI)) runtimes.push(window.BackendlessUI); } catch (_) {}
  	
  	                for (let index = 0; index < runtimes.length; index += 1) {
  	                  const custom = runtimes[index]?.Functions?.Custom;
  	                  const loader = custom?.[EVENT_TRACKING_FUNCTION];
  	                  if (typeof loader !== "function") continue;
  	
  	                  const hadSelected = Object.prototype.hasOwnProperty.call(appData || {}, "SelectedTractor");
  	                  const previous = appData?.SelectedTractor;
  	                  let returned;
  	
  	                  try {
  	                    if (appData) appData.SelectedTractor = vehicle;
  	                    returned = await loader.call(custom, appData, trackerId, new Date(range.to), new Date(range.from));
  	                  } finally {
  	                    if (appData) {
  	                      if (hadSelected) appData.SelectedTractor = previous;
  	                      else delete appData.SelectedTractor;
  	                    }
  	                  }
  	
  	                  const afterLoad = loadedEventTrackingRows(vehicle, range.from, range.to);
  	                  const returnedRows = trackingExtractRows(returned).filter(row => {
  	                    const timestamp = trackingMessageTimestamp(row);
  	                    return timestamp !== null && timestamp >= range.from && timestamp <= range.to;
  	                  });
  	
  	                  return { rows: afterLoad.length ? afterLoad : returnedRows, source: "TrackIT history loader", payload };
  	                }
  	
  	                const providers = [
  	                  [window.FIFTrackingProvider, "loadWindow"],
  	                  [window.FIFTrackingProvider, "loadHistory"],
  	                  [appData?.TrackingProvider, "loadWindow"]
  	                ];
  	
  	                for (let index = 0; index < providers.length; index += 1) {
  	                  const owner = providers[index][0];
  	                  const fn = owner?.[providers[index][1]];
  	                  if (typeof fn !== "function") continue;
  	                  const returned = await fn.call(owner, payload);
  	                  return { rows: trackingExtractRows(returned), source: "Installed tracking provider", payload };
  	                }
  	
  	                if (typeof Backendless !== "undefined" && Backendless?.APIServices?.invoke) {
  	                  const returned = await Backendless.APIServices.invoke("FIFTrackingService", "getTrackingWindow", payload);
  	                  return { rows: trackingExtractRows(returned), source: "Secure tracking service", payload };
  	                }
  	
  	                throw new Error("Tracking history is not connected. Install the TrackIT history function or FIFTrackingService.getTrackingWindow.");
  	              }
  	
  	              function normaliseTrackingPoints(rows, range, vehicle) {
  	                const seen = new Set();
  	
  	                return (Array.isArray(rows) ? rows : []).map(raw => {
  	                  const timestamp = trackingMessageTimestamp(raw);
  	                  const lat = trackingNumber(raw, ["position.latitude", "latitude", "lat"]);
  	                  const lng = trackingNumber(raw, ["position.longitude", "longitude", "lng", "lon"]);
  	
  	                  if (timestamp === null || timestamp < range.from || timestamp > range.to) return null;
  	                  if (lat === null || lng === null || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  	
  	                  const key = `${timestamp}|${lat.toFixed(7)}|${lng.toFixed(7)}`;
  	                  if (seen.has(key)) return null;
  	                  seen.add(key);
  	
  	                  const point = {
  	                    timestamp,
  	                    lat,
  	                    lng,
  	                    speed: trackingNumber(raw, ["position.speed", "can.vehicle.speed"]),
  	                    rpm: trackingNumber(raw, ["can.engine.rpm", "engine.rpm", "rpm"]),
  	                    temperature: trackingNumber(raw, ["can.engine.temperature", "engine.temperature", "engine.coolant.temperature", "temperature"]),
  	                    throttle: trackingNumber(raw, ["can.throttle.pedal.level", "throttle", "throttle.position"]),
  	                    direction: trackingNumber(raw, ["position.direction", "position.heading", "heading", "direction"]),
  	                    altitude: trackingNumber(raw, ["position.altitude", "altitude"]),
  	                    odometer: trackingNumber(raw, ["can.vehicle.mileage", "vehicle.mileage", "odometer"]),
  	                    fuelLevel: trackingNumber(raw, ["can.fuel.level", "fuel.level"]),
  	                    events: eventTrackingPointEvents(raw),
  	                    color: eventTrackingNormaliseColor(
  	                      firstValue([
  	                        raw && raw.color,
  	                        raw && raw.Color,
  	                        raw && raw.routeColor,
  	                        raw && raw.RouteColor
  	                      ], ""),
  	                      ""
  	                    ),
  	                    raw
  	                  };
  	
  	                  point.color = eventTrackingPointRouteColor(point, vehicle);
  	                  return point;
  	                }).filter(Boolean).sort((a, b) => a.timestamp - b.timestamp);
  	              }
  	
  	              function trackingDistanceMeters(a, b) {
  	                const radians = value => value * Math.PI / 180;
  	                const lat1 = radians(a.lat);
  	                const lat2 = radians(b.lat);
  	                const deltaLat = lat2 - lat1;
  	                const deltaLng = radians(b.lng - a.lng);
  	                const value = Math.sin(deltaLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) ** 2;
  	                return 6371000 * 2 * Math.atan2(Math.sqrt(value), Math.sqrt(1 - value));
  	              }
  	
  	              function analyseEventTracking(points, range) {
  	                let distance = 0;
  	                let maxSpeed = null;
  	                let speedTotal = 0;
  	                let speedCount = 0;
  	                let movingSeconds = 0;
  	
  	                for (let index = 0; index < points.length; index += 1) {
  	                  const point = points[index];
  	                  if (Number.isFinite(point.speed)) {
  	                    maxSpeed = maxSpeed === null ? point.speed : Math.max(maxSpeed, point.speed);
  	                    speedTotal += point.speed;
  	                    speedCount += 1;
  	                  }
  	
  	                  if (index > 0) {
  	                    const previous = points[index - 1];
  	                    const segment = trackingDistanceMeters(previous, point);
  	                    const seconds = Math.max(0, (point.timestamp - previous.timestamp) / 1000);
  	                    if (segment < 5000) distance += segment;
  	                    if ((Number.isFinite(point.speed) && point.speed > 3) || segment > 15) movingSeconds += Math.min(seconds, 300);
  	                  }
  	                }
  	
  	                const durationSeconds = Math.max(0, (range.to - range.from) / 1000);
  	                return {
  	                  distance,
  	                  durationSeconds,
  	                  movingSeconds: Math.min(durationSeconds, movingSeconds),
  	                  stoppedSeconds: Math.max(0, durationSeconds - movingSeconds),
  	                  maxSpeed,
  	                  averageSpeed: speedCount ? speedTotal / speedCount : null,
  	                  first: points[0] || null,
  	                  last: points[points.length - 1] || null
  	                };
  	              }
  	
  	              function formatTrackingDuration(seconds) {
  	                const value = Math.max(0, Math.round(Number(seconds) || 0));
  	                const hours = Math.floor(value / 3600);
  	                const minutes = Math.floor((value % 3600) / 60);
  	                const secs = value % 60;
  	                return hours ? `${hours}h ${pad2(minutes)}m` : minutes ? `${minutes}m ${pad2(secs)}s` : `${secs}s`;
  	              }
  	
  	              function trackingVehicleLabel(vehicle, job) {
  	                return safeString(trackingValue(vehicle, [
  	                  "Registration", "VehicleRegistration", "Label", "Name", "VehicleName"
  	                ]) || getVehicleText(job) || "Vehicle").trim();
  	              }
  	
  	              function eventGoogleMapsApiKey() {
  	                const scripts = Array.from(document.querySelectorAll('script[src*="maps.googleapis.com/maps/api/js"]'));
  	
  	                for (let index = 0; index < scripts.length; index += 1) {
  	                  try {
  	                    const key = new URL(scripts[index].src, window.location.href).searchParams.get("key");
  	                    if (key) return key;
  	                  } catch (_) {}
  	                }
  	
  	                return safeString(
  	                  appData?.GoogleMapsApiKey ||
  	                  appData?.Configuration?.GoogleMapsApiKey ||
  	                  appData?.Configuration?.Maps?.ApiKey ||
  	                  ""
  	                ).trim();
  	              }
  	
  	              function eventTrackingStaticMapUrl(context) {
  	                const key = eventGoogleMapsApiKey();
  	                const points = (context?.points || []).filter(point =>
  	                  point &&
  	                  Number.isFinite(Number(point.lat)) &&
  	                  Number.isFinite(Number(point.lng))
  	                );
  	
  	                if (!key || !points.length) return "";
  	
  	                function staticHex(value, fallback) {
  	                  const textValue = safeString(value || "").trim();
  	                  const fallbackValue = safeString(fallback || "#ff8a3c").trim();
  	
  	                  if (/^#[0-9a-f]{6}$/i.test(textValue)) {
  	                    return "0x" + textValue.slice(1).toLowerCase();
  	                  }
  	
  	                  if (/^#[0-9a-f]{3}$/i.test(textValue)) {
  	                    const short = textValue.slice(1);
  	                    return "0x" + short.split("").map(char => char + char).join("").toLowerCase();
  	                  }
  	
  	                  const basic = {
  	                    red: "0xff0000",
  	                    green: "0x00ff00",
  	                    yellow: "0xffff00",
  	                    orange: "0xff8a3c",
  	                    blue: "0x4a89ff",
  	                    purple: "0x7c3aed",
  	                    white: "0xffffff",
  	                    black: "0x000000"
  	                  };
  	
  	                  const named = basic[textValue.toLowerCase()];
  	                  if (named) return named;
  	
  	                  return staticHex(fallbackValue === textValue ? "#ff8a3c" : fallbackValue, "#ff8a3c");
  	                }
  	
  	                function decimatePath(pathPoints, maxPoints) {
  	                  const input = Array.isArray(pathPoints) ? pathPoints : [];
  	                  if (input.length <= maxPoints) return input.slice();
  	
  	                  const step = Math.max(1, Math.ceil(input.length / maxPoints));
  	                  const selected = input.filter((point, index) => index % step === 0);
  	
  	                  if (selected[0] !== input[0]) selected.unshift(input[0]);
  	                  if (selected[selected.length - 1] !== input[input.length - 1]) {
  	                    selected.push(input[input.length - 1]);
  	                  }
  	
  	                  return selected;
  	                }
  	
  	                const boundary = context?.boundary || eventTrackingBoundaryGeometry(context?.job);
  	                const locationColor = eventTrackingLocationColor(context?.job);
  	                const boundaryPoints = [];
  	
  	                if (
  	                  boundary &&
  	                  boundary.type === "polygon" &&
  	                  Array.isArray(boundary.points)
  	                ) {
  	                  boundary.points.forEach(point => {
  	                    const lat = Number(point && point.lat);
  	                    const lng = Number(point && point.lng);
  	
  	                    if (
  	                      Number.isFinite(lat) &&
  	                      Number.isFinite(lng) &&
  	                      Math.abs(lat) <= 90 &&
  	                      Math.abs(lng) <= 180
  	                    ) {
  	                      boundaryPoints.push({ lat, lng });
  	                    }
  	                  });
  	                } else if (
  	                  boundary &&
  	                  boundary.type === "circle" &&
  	                  boundary.center &&
  	                  Number.isFinite(Number(boundary.center.lat)) &&
  	                  Number.isFinite(Number(boundary.center.lng)) &&
  	                  Number.isFinite(Number(boundary.radiusMeters)) &&
  	                  Number(boundary.radiusMeters) > 0
  	                ) {
  	                  const centerLat = Number(boundary.center.lat);
  	                  const centerLng = Number(boundary.center.lng);
  	                  const radius = Number(boundary.radiusMeters);
  	                  const earth = 6371000;
  	
  	                  for (let index = 0; index <= 36; index += 1) {
  	                    const angle = (index / 36) * Math.PI * 2;
  	                    const north = Math.cos(angle) * radius;
  	                    const east = Math.sin(angle) * radius;
  	                    const lat = centerLat + (north / earth) * (180 / Math.PI);
  	                    const lng =
  	                      centerLng +
  	                      (east / (earth * Math.cos(centerLat * Math.PI / 180))) *
  	                        (180 / Math.PI);
  	
  	                    boundaryPoints.push({ lat, lng });
  	                  }
  	                }
  	
  	                // Match the live map: calculate the viewport from BOTH the corrected
  	                // route and the complete Location boundary.
  	                const viewportPoints = points.concat(boundaryPoints);
  	
  	                let minLat = Number(viewportPoints[0].lat);
  	                let maxLat = minLat;
  	                let minLng = Number(viewportPoints[0].lng);
  	                let maxLng = minLng;
  	
  	                viewportPoints.forEach(point => {
  	                  const lat = Number(point.lat);
  	                  const lng = Number(point.lng);
  	
  	                  minLat = Math.min(minLat, lat);
  	                  maxLat = Math.max(maxLat, lat);
  	                  minLng = Math.min(minLng, lng);
  	                  maxLng = Math.max(maxLng, lng);
  	                });
  	
  	                // Give the printable map breathing room, then calculate an explicit
  	                // centre/zoom for the WIDE report image. Relying on Static Maps
  	                // auto-fit/visible caused some long Location polygons to be clipped
  	                // even though the live Google Map was correctly fitBounds().
  	                const latSpan = Math.max(maxLat - minLat, 0.0005);
  	                const lngSpan = Math.max(maxLng - minLng, 0.0005);
  	                const latPad = Math.max(latSpan * 0.20, 0.00065);
  	                const lngPad = Math.max(lngSpan * 0.20, 0.00065);
  	
  	                const south = Math.max(-85, minLat - latPad);
  	                const north = Math.min(85, maxLat + latPad);
  	                const west = Math.max(-180, minLng - lngPad);
  	                const east = Math.min(180, maxLng + lngPad);
  	
  	                const staticWidth = 640;
  	                const staticHeight = 220;
  	
  	                function mercatorY(latitude) {
  	                  const lat = Math.max(-85, Math.min(85, Number(latitude) || 0));
  	                  const sin = Math.sin(lat * Math.PI / 180);
  	                  return 0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI);
  	                }
  	
  	                function inverseMercatorY(y) {
  	                  return Math.atan(
  	                    Math.sinh(Math.PI * (1 - 2 * y))
  	                  ) * 180 / Math.PI;
  	                }
  	
  	                const westX = (west + 180) / 360;
  	                const eastX = (east + 180) / 360;
  	                const northY = mercatorY(north);
  	                const southY = mercatorY(south);
  	                const longitudeFraction = Math.max(Math.abs(eastX - westX), 1e-9);
  	                const latitudeFraction = Math.max(Math.abs(southY - northY), 1e-9);
  	
  	                // Reserve physical pixel padding inside the returned Static Map.
  	                const usableWidth = Math.max(120, staticWidth - 90);
  	                const usableHeight = Math.max(90, staticHeight - 70);
  	                const zoomX = Math.log2(usableWidth / (256 * longitudeFraction));
  	                const zoomY = Math.log2(usableHeight / (256 * latitudeFraction));
  	                const staticZoom = Math.max(
  	                  0,
  	                  Math.min(20, Math.floor(Math.min(zoomX, zoomY)))
  	                );
  	
  	                const centerY = (northY + southY) / 2;
  	                const centerLat = inverseMercatorY(centerY);
  	                const centerLng = (west + east) / 2;
  	
  	                const params = new URLSearchParams({
  	                  size: staticWidth + "x" + staticHeight,
  	                  scale: "2",
  	                  maptype: "hybrid",
  	                  format: "png",
  	                  center: centerLat.toFixed(6) + "," + centerLng.toFixed(6),
  	                  zoom: String(staticZoom),
  	                  key
  	                });
  	
  	                // Draw the Location polygon / circle first.
  	                if (boundaryPoints.length >= 3) {
  	                  const selectedBoundary = decimatePath(boundaryPoints, 90);
  	                  const boundaryPath = selectedBoundary
  	                    .map(point =>
  	                      `${Number(point.lat).toFixed(6)},${Number(point.lng).toFixed(6)}`
  	                    )
  	                    .join("|");
  	
  	                  params.append(
  	                    "path",
  	                    `color:${staticHex(locationColor, "#ff8a3c")}e6|weight:3|fillcolor:${staticHex(locationColor, "#ff8a3c")}2b|${boundaryPath}`
  	                  );
  	                }
  	
  	                // TrackIT-style Red > Green > Yellow route segmentation.
  	                const routeSegments = [];
  	                let currentSegment = [];
  	                let currentColor = eventTrackingPointRouteColor(points[0], context?.vehicle);
  	
  	                points.forEach((point, index) => {
  	                  const color = eventTrackingPointRouteColor(point, context?.vehicle);
  	                  const previous = points[index - 1];
  	
  	                  if (previous && trackingDistanceMeters(previous, point) < 3) return;
  	
  	                  if (color !== currentColor) {
  	                    if (currentSegment.length >= 2) {
  	                      routeSegments.push({
  	                        color: currentColor,
  	                        points: currentSegment
  	                      });
  	                    }
  	
  	                    if (currentSegment.length) {
  	                      currentSegment = [currentSegment[currentSegment.length - 1], point];
  	                    } else {
  	                      currentSegment = [point];
  	                    }
  	
  	                    currentColor = color;
  	                  } else {
  	                    currentSegment.push(point);
  	                  }
  	                });
  	
  	                if (currentSegment.length >= 2) {
  	                  routeSegments.push({
  	                    color: currentColor,
  	                    points: currentSegment
  	                  });
  	                }
  	
  	                routeSegments.forEach(segment => {
  	                  const selected = decimatePath(segment.points, 70);
  	                  const routePath = selected
  	                    .map(point =>
  	                      `${Number(point.lat).toFixed(6)},${Number(point.lng).toFixed(6)}`
  	                    )
  	                    .join("|");
  	
  	                  params.append(
  	                    "path",
  	                    `color:${staticHex(segment.color, "#ffff00")}ff|weight:7|${routePath}`
  	                  );
  	                });
  	
  	                // Centre/zoom above is deliberately explicit. Do not ask the Static
  	                // Maps service to auto-fit the paths again, because that was the
  	                // source of the report-only cropping mismatch.
  	
  	                const first = points[0];
  	                const last = points[points.length - 1];
  	
  	                params.append(
  	                  "markers",
  	                  `color:green|label:I|${Number(first.lat).toFixed(6)},${Number(first.lng).toFixed(6)}`
  	                );
  	
  	                params.append(
  	                  "markers",
  	                  `color:orange|label:O|${Number(last.lat).toFixed(6)},${Number(last.lng).toFixed(6)}`
  	                );
  	
  	                return `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`;
  	              }
  	
  	              function printEventTrackingReport(trackWindow) {
  	                const context = trackWindow?.__eventTrackingContext;
  	                if (!context) return;
  	
  	                const printWindow = window.open("", "_blank", "width=1320,height=920");
  	                if (!printWindow) {
  	                  window.alert("The Event Tracking report window was blocked by the browser.");
  	                  return;
  	                }
  	
  	                const job = context.job;
  	                const range = context.range;
  	                const analysis = context.analysis;
  	                const mapUrl = eventTrackingStaticMapUrl(context);
  	                const reportBrandAsset = resolveReportBrandAsset(REPORT_SVG_INPUT);
  	                const eventInfo = buildMultilineEvent(job);
  	                const vehicleLabel = trackingVehicleLabel(context.vehicle, job);
  	                const generatedAt = new Date().toLocaleString();
  	                const inLabel = new Date(range.from).toLocaleString();
  	                const outLabel = new Date(range.to).toLocaleString();
  	                const recordedInLabel = context.searchRange && Number.isFinite(Number(context.searchRange.recordedFrom))
  	                  ? new Date(Number(context.searchRange.recordedFrom)).toLocaleString()
  	                  : "Not recorded";
  	                const recordedOutLabel = context.searchRange && Number.isFinite(Number(context.searchRange.recordedTo))
  	                  ? new Date(Number(context.searchRange.recordedTo)).toLocaleString()
  	                  : "Not recorded";
  	                const status = context.error
  	                  ? context.error
  	                  : `${context.points.length} GPS point${context.points.length === 1 ? "" : "s"} · ${context.source || "Tracking history"}`;
  	                const startPoint = analysis?.first;
  	                const endPoint = analysis?.last;
  	
  	                const html = `<!doctype html>
  	                <html><head><meta charset="utf-8"><title>Event Tracking Evidence</title>
  	                <style>
  	                @page{size:A4 landscape;margin:7mm}*{box-sizing:border-box}html,body{width:100%;margin:0;padding:0}body{color:#1d2821;font-family:Arial,sans-serif;font-size:9px;overflow:visible}
  	                header{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding-bottom:7px;border-bottom:3px solid #b85a2f}.brand-head{display:flex;align-items:flex-start;gap:12px;min-width:0}.brand{display:block;width:96px;max-height:46px;object-fit:contain;object-position:left top;flex:0 0 auto}.brand-copy{min-width:0}h1{margin:2px 0 0;font-size:19px}h2{margin:0 0 5px;color:#a44f2a;font-size:9px;letter-spacing:.08em;text-transform:uppercase}.meta{text-align:right;color:#607067;font-size:8px}
  	                .grid{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;margin:7px 0}.card{padding:6px;border:1px solid #d7ddd9;border-radius:6px;background:#f4f7f5}.card span{display:block;color:#6c7870;font-size:7px;font-weight:bold;text-transform:uppercase}.card strong{display:block;margin-top:3px;font-size:10px}
  	                .map{border:1px solid #b7c0ba;border-radius:7px;overflow:hidden;background:#111;display:grid;place-items:center;break-inside:avoid;page-break-inside:avoid}.map img{display:block;width:100%;height:auto;object-fit:contain;background:#111}.map p{min-height:220px;display:grid;place-items:center;max-width:none;width:100%;margin:0;padding:24px;text-align:center;color:#68736c}
  	                table{width:100%;margin-top:6px;border-collapse:collapse;break-inside:avoid;page-break-inside:avoid}th,td{padding:4px 5px;border:1px solid #d4dad6;text-align:left;line-height:1.25}th{width:16%;background:#edf1ee;color:#536159;text-transform:uppercase;font-size:7px}footer{display:flex;justify-content:space-between;margin-top:5px;color:#738078;font-size:7px;break-inside:avoid;page-break-inside:avoid}
  	                @media print{body{zoom:.98}header,.grid,.map,table,footer{break-inside:avoid;page-break-inside:avoid}}
  	                </style></head><body>
  	                <header><div class="brand-head">${reportBrandAsset ? `<img class="brand" src="${escapeHtml(reportBrandAsset)}" alt="Fleet In Form">` : ""}<div class="brand-copy"><h2>Fleet In Form · Event Tracking Evidence</h2><h1>${escapeHtml(vehicleLabel)} · ${escapeHtml(eventInfo.headline || "Location Event")}</h1><div>${escapeHtml(eventLocationDisplayLabel(job) || "Location")} · ${escapeHtml(eventFieldLabel(job) || "Field not recorded")}</div></div></div><div class="meta">Generated ${escapeHtml(generatedAt)}<br>${escapeHtml(status)}</div></header>
  	                <section class="grid">
  	                <div class="card"><span>Actual Time In</span><strong>${escapeHtml(inLabel)}</strong></div>
  	                <div class="card"><span>Actual Time Out</span><strong>${escapeHtml(outLabel)}</strong></div>
  	                <div class="card"><span>Event Duration</span><strong>${escapeHtml(formatTrackingDuration((range.to-range.from)/1000))}</strong></div>
  	                <div class="card"><span>Tracked Distance</span><strong>${analysis ? escapeHtml((analysis.distance/1000).toFixed(2)+" km") : "—"}</strong></div>
  	                </section>
  	                <div class="map">${mapUrl ? `<img src="${escapeHtml(mapUrl)}" alt="Hybrid map snapshot of event route">` : `<p>A printable Hybrid map snapshot is unavailable because no Google Static Maps key or GPS path was available. The tracking facts below remain part of this evidence report.</p>`}</div>
  	                <table><tbody>
  	                <tr><th>Vehicle</th><td>${escapeHtml(vehicleLabel)}</td><th>Tracker</th><td>${escapeHtml(trackerIdOf(context.vehicle) || "Not recorded")}</td></tr>
  	                <tr><th>Location</th><td>${escapeHtml(eventLocationDisplayLabel(job) || "Location")}</td><th>Field</th><td>${escapeHtml(eventFieldLabel(job) || "Not recorded")}</td></tr><tr><th>Event</th><td>${escapeHtml(eventInfo.headline || "Not recorded")}</td><th>Boundary Source</th><td>${escapeHtml(context.boundary && context.boundary.source || "Not recorded")}</td></tr>
  	                <tr><th>Recorded Window</th><td>${escapeHtml(recordedInLabel)} → ${escapeHtml(recordedOutLabel)}</td><th>Driver</th><td>${escapeHtml(getDriverText(job) || "Not recorded")}</td></tr><tr><th>Contractor</th><td>${escapeHtml(getContractorText(job) || "Not recorded")}</td><th>Tracker Source</th><td>${escapeHtml(context.source || "Not recorded")}</td></tr>
  	                <tr><th>Moving / Stopped</th><td>${analysis ? escapeHtml(formatTrackingDuration(analysis.movingSeconds)+" / "+formatTrackingDuration(analysis.stoppedSeconds)) : "—"}</td><th>Average / Max Speed</th><td>${analysis && analysis.averageSpeed !== null ? escapeHtml(analysis.averageSpeed.toFixed(1)+" / "+analysis.maxSpeed.toFixed(1)+" km/h") : "—"}</td></tr>
  	                <tr><th>First GPS Fix</th><td>${startPoint ? escapeHtml(new Date(startPoint.timestamp).toLocaleString()+` · ${startPoint.lat.toFixed(6)}, ${startPoint.lng.toFixed(6)}`) : "—"}</td><th>Last GPS Fix</th><td>${endPoint ? escapeHtml(new Date(endPoint.timestamp).toLocaleString()+` · ${endPoint.lat.toFixed(6)}, ${endPoint.lng.toFixed(6)}`) : "—"}</td></tr>
  	                </tbody></table>
  	                <footer><span>Route is reconciled from actual Location boundary entry → exit. Tracker history is searched with 5 minutes of padding on each side.</span><span>Fleet In Form</span></footer>
  	                <script>
  	                window.onload=function(){
  	                  window.focus();
  	                  var image=document.querySelector(".map img");
  	                  var printed=false;
  	                  function go(){
  	                    if(printed)return;
  	                    printed=true;
  	                    setTimeout(function(){window.print();},180);
  	                  }
  	                  if(!image||image.complete){go();return;}
  	                  image.addEventListener("load",go,{once:true});
  	                  image.addEventListener("error",go,{once:true});
  	                  setTimeout(go,2200);
  	                };
  	                <\/script>
  	                </body></html>`;
  	
  	                printWindow.document.open();
  	                printWindow.document.write(html);
  	                printWindow.document.close();
  	              }
  	
  	              function makeTrackingWindowDraggable(trackWindow) {
  	                const handle = trackWindow.querySelector("[data-jel-track-drag]");
  	                if (!handle) return;
  	
  	                handle.addEventListener("mousedown", event => {
  	                  if (event.button !== 0 || event.target.closest("button")) return;
  	                  const rect = trackWindow.getBoundingClientRect();
  	                  const offsetX = event.clientX - rect.left;
  	                  const offsetY = event.clientY - rect.top;
  	
  	                  trackWindow.style.transform = "none";
  	                  trackWindow.style.left = `${rect.left}px`;
  	                  trackWindow.style.top = `${rect.top}px`;
  	
  	                  const move = moveEvent => {
  	                    const maxLeft = Math.max(0, window.innerWidth - trackWindow.offsetWidth);
  	                    const maxTop = Math.max(0, window.innerHeight - trackWindow.offsetHeight);
  	                    trackWindow.style.left = `${Math.min(maxLeft,Math.max(0,moveEvent.clientX-offsetX))}px`;
  	                    trackWindow.style.top = `${Math.min(maxTop,Math.max(0,moveEvent.clientY-offsetY))}px`;
  	                  };
  	
  	                  const stop = () => {
  	                    document.removeEventListener("mousemove", move);
  	                    document.removeEventListener("mouseup", stop);
  	                  };
  	
  	                  document.addEventListener("mousemove", move);
  	                  document.addEventListener("mouseup", stop);
  	                  event.preventDefault();
  	                });
  	              }
  	
  	              function renderEventTrackingMap(trackWindow, points, range) {
  	                const mapNode = trackWindow.querySelector("[data-jel-track-map]");
  	                const state = trackWindow.querySelector("[data-jel-track-state]");
  	                const maps = window.google?.maps;
  	
  	                if (!maps || typeof maps.Map !== "function") {
  	                  if (state) state.textContent = "Google Maps is unavailable in this window.";
  	                  return null;
  	                }
  	
  	                const context = trackWindow?.__eventTrackingContext || {};
  	                const vehicle = context.vehicle || resolveEventVehicle(context.job);
  	                const eventLocation = eventLocationForJob(context.job);
  	                const eventBoundary = context.boundary || eventTrackingBoundaryGeometry(context.job);
  	                const locationColor = eventTrackingLocationColor(context.job);
  	                const fallbackLat = Number(trackingValue(eventLocation, ["Latitude", "latitude", "lat", "Center.latitude"]));
  	                const fallbackLng = Number(trackingValue(eventLocation, ["Longitude", "longitude", "lng", "lon", "Center.longitude"]));
  	                const center = points.length
  	                  ? { lat: points[Math.floor(points.length / 2)].lat, lng: points[Math.floor(points.length / 2)].lng }
  	                  : {
  	                    lat: Number.isFinite(fallbackLat) ? fallbackLat : -30.5595,
  	                    lng: Number.isFinite(fallbackLng) ? fallbackLng : 22.9375
  	                  };
  	
  	                const map = new maps.Map(mapNode, {
  	                  center,
  	                  zoom: points.length ? 15 : 6,
  	                  mapTypeId: maps.MapTypeId?.HYBRID || "hybrid",
  	                  mapTypeControl: true,
  	                  mapTypeControlOptions: {
  	                    mapTypeIds: [
  	                      maps.MapTypeId?.ROADMAP || "roadmap",
  	                      maps.MapTypeId?.SATELLITE || "satellite",
  	                      maps.MapTypeId?.HYBRID || "hybrid"
  	                    ]
  	                  },
  	                  fullscreenControl: true,
  	                  streetViewControl: false,
  	                  clickableIcons: true
  	                });
  	
  	                // Keep Google InfoWindow plumbing, but use our own close control
  	                // inside the Fleet In Form card so Google's floating X does not sit
  	                // above the popup.
  	                const pointPopupStyleId = "fif-event-point-popup-google-shell-css";
  	
  	                if (!document.getElementById(pointPopupStyleId)) {
  	                  const pointPopupStyle = document.createElement("style");
  	                  pointPopupStyle.id = pointPopupStyleId;
  	                  pointPopupStyle.textContent = `
  	                    .jel-track-window [data-jel-track-map] .gm-style-iw-c {
  	                      padding: 0 !important;
  	                      background: transparent !important;
  	                      box-shadow: none !important;
  	                      border-radius: 10px !important;
  	                      overflow: visible !important;
  	                    }
  	
  	                    .jel-track-window [data-jel-track-map] .gm-style-iw-d {
  	                      overflow: visible !important;
  	                      padding: 0 !important;
  	                      max-height: none !important;
  	                    }
  	
  	                    .jel-track-window [data-jel-track-map] .gm-style-iw-d > div {
  	                      overflow: visible !important;
  	                    }
  	
  	                    .jel-track-window [data-jel-track-map] .gm-ui-hover-effect {
  	                      display: none !important;
  	                    }
  	
  	                    .jel-track-window [data-jel-track-map] .gm-style-iw-tc {
  	                      filter: drop-shadow(0 2px 2px rgba(0,0,0,.42));
  	                    }
  	
  	                    .jel-track-window [data-jel-track-map] [data-jel-point-popup-close]:hover {
  	                      background: #24170f !important;
  	                      border-color: #cc6633 !important;
  	                      color: #ffffff !important;
  	                    }
  	
  	                    .jel-track-window [data-jel-track-map] [data-jel-point-popup-close]:focus-visible {
  	                      outline: 2px solid rgba(204,102,51,.72);
  	                      outline-offset: 2px;
  	                    }
  	                  `;
  	                  document.head.appendChild(pointPopupStyle);
  	                }
  	
  	                const infoWindow = new maps.InfoWindow({});
  	                let selectedPointMarker = null;
  	
  	                function pointInfoHtml(point) {
  	                  const speedLimit = eventTrackingVehicleLimit(vehicle, ["CAN.Speed", "CAN.SpeedLimit", "CAN.MaxSpeed", "SpeedLimit"]);
  	                  const rpmLimit = eventTrackingVehicleLimit(vehicle, ["CAN.RPM", "CAN.RPMLimit", "CAN.MaxRPM"]);
  	                  const tempLimit = eventTrackingVehicleLimit(vehicle, ["CAN.Temp", "CAN.Temperature", "CAN.MaxTemp"]);
  	
  	                  const speedOver = Number.isFinite(point.speed) && speedLimit !== null && point.speed > speedLimit;
  	                  const rpmOver = Number.isFinite(point.rpm) && rpmLimit !== null && point.rpm > rpmLimit;
  	                  const tempOver = Number.isFinite(point.temperature) && tempLimit !== null && point.temperature > tempLimit;
  	                  const eventList = Array.isArray(point.events) && point.events.length
  	                    ? `<div style="margin-top:8px;padding-top:7px;border-top:1px solid rgba(255,255,255,.12);"><b>Events:</b><div style="margin-top:3px;color:#d7dde2;">${point.events.map(value => escapeHtml(value)).join(" · ")}</div></div>`
  	                    : "";
  	
  	                  return `
  	                  <div style="position:relative;min-width:245px;max-width:310px;padding:10px 42px 10px 10px;border-radius:10px;background:#0b0f14;color:#fff;font:12px/1.42 system-ui,Arial,sans-serif;">
  	                    <button
  	                      type="button"
  	                      data-jel-point-popup-close
  	                      aria-label="Close tracking point"
  	                      title="Close"
  	                      style="
  	                        position:absolute;
  	                        top:8px;
  	                        right:8px;
  	                        width:26px;
  	                        height:26px;
  	                        padding:0;
  	                        display:grid;
  	                        place-items:center;
  	                        border:1px solid rgba(204,102,51,.42);
  	                        border-radius:7px;
  	                        background:#141a1f;
  	                        color:#e8edf2;
  	                        font:900 17px/1 system-ui,Arial,sans-serif;
  	                        cursor:pointer;
  	                        box-shadow:none;
  	                      "
  	                    >×</button>
  	                    <div style="font-size:13px;font-weight:850;margin-bottom:7px;">Tracking Point</div>
  	                    <div style="color:#aab5bf;margin-bottom:8px;">${escapeHtml(new Date(point.timestamp).toLocaleString())}</div>
  	
  	                    <div style="padding:6px 8px;border-radius:6px;background:${speedOver ? "#CC6633" : "rgba(255,255,255,.05)"};">
  	                      <b>Speed:</b> ${escapeHtml(eventTrackingMetricText(point.speed, " km/h", 1))}
  	                      ${speedLimit !== null ? `<span style="opacity:.6;"> · limit ${escapeHtml(eventTrackingMetricText(speedLimit, "", 0))}</span>` : ""}
  	                    </div>
  	
  	                    <div style="margin-top:5px;padding:6px 8px;border-radius:6px;background:${rpmOver ? "#7B08CD" : "rgba(255,255,255,.05)"};">
  	                      <b>RPM:</b> ${escapeHtml(eventTrackingMetricText(point.rpm, " RPM", 0))}
  	                      ${rpmLimit !== null ? `<span style="opacity:.6;"> · limit ${escapeHtml(eventTrackingMetricText(rpmLimit, "", 0))}</span>` : ""}
  	                    </div>
  	
  	                    <div style="margin-top:5px;padding:6px 8px;border-radius:6px;background:${tempOver ? "#ffc107" : "rgba(255,255,255,.05)"};color:${tempOver ? "#111" : "#fff"};">
  	                      <b>Engine Temp:</b> ${escapeHtml(eventTrackingMetricText(point.temperature, "°C", 1))}
  	                      ${tempLimit !== null ? `<span style="opacity:.6;"> · limit ${escapeHtml(eventTrackingMetricText(tempLimit, "", 0))}</span>` : ""}
  	                    </div>
  	
  	                    <div style="margin-top:7px;">
  	                      <b>Direction:</b> ${escapeHtml(eventTrackingDirectionText(point.direction))}<br>
  	                      <b>Altitude:</b> ${escapeHtml(eventTrackingMetricText(point.altitude, " m", 1))}
  	                    </div>
  	                    ${eventList}
  	                  </div>`;
  	                }
  	
  	                if (eventBoundary && eventBoundary.type === "polygon" && Array.isArray(eventBoundary.points)) {
  	                  const boundaryPath = eventBoundary.points.map(point => ({
  	                    lat: Number(point.lat),
  	                    lng: Number(point.lng)
  	                  }));
  	
  	                  new maps.Polygon({
  	                    map,
  	                    paths: boundaryPath,
  	                    clickable: false,
  	                    zIndex: 10,
  	                    strokeColor: locationColor,
  	                    strokeOpacity: 0.95,
  	                    strokeWeight: 2,
  	                    fillColor: locationColor,
  	                    fillOpacity: 0.16,
  	                    geodesic: true
  	                  });
  	                } else if (eventBoundary && eventBoundary.type === "circle" && eventBoundary.center) {
  	                  new maps.Circle({
  	                    map,
  	                    center: eventBoundary.center,
  	                    radius: Number(eventBoundary.radiusMeters || 0),
  	                    clickable: false,
  	                    zIndex: 10,
  	                    strokeColor: locationColor,
  	                    strokeOpacity: 0.95,
  	                    strokeWeight: 2,
  	                    fillColor: locationColor,
  	                    fillOpacity: 0.16
  	                  });
  	                }
  	
  	                if (points.length) {
  	                  const bounds = new maps.LatLngBounds();
  	
  	                  points.forEach(point => {
  	                    bounds.extend({ lat: point.lat, lng: point.lng });
  	                    point.color = eventTrackingPointRouteColor(point, vehicle);
  	                  });
  	
  	                  if (eventBoundary && eventBoundary.type === "polygon") {
  	                    eventBoundary.points.forEach(point => {
  	                      bounds.extend({
  	                        lat: Number(point.lat),
  	                        lng: Number(point.lng)
  	                      });
  	                    });
  	                  } else if (eventBoundary && eventBoundary.type === "circle" && eventBoundary.center) {
  	                    bounds.extend(eventBoundary.center);
  	                  }
  	
  	                  // TrackIT-style Red > Green > Yellow colour segmentation.
  	                  const segments = [];
  	                  let currentSegment = [];
  	                  let currentColor = points[0].color || "#FFFF00";
  	                  let previousTail = null;
  	
  	                  for (let index = 0; index < points.length; index += 1) {
  	                    const point = points[index];
  	                    const color = point.color || "#FFFF00";
  	                    const previous = points[index - 1];
  	
  	                    if (previous && trackingDistanceMeters(previous, point) < 3) continue;
  	
  	                    if (color !== currentColor) {
  	                      if (currentSegment.length >= 2) {
  	                        segments.push({
  	                          color: currentColor,
  	                          points: currentSegment
  	                        });
  	                      }
  	
  	                      if (previousTail && point) {
  	                        segments.push({
  	                          color: eventTrackingMixRouteColors(currentColor, color, 0.5),
  	                          points: [previousTail, point]
  	                        });
  	                      }
  	
  	                      currentColor = color;
  	                      currentSegment = [point];
  	                    } else {
  	                      currentSegment.push(point);
  	                    }
  	
  	                    previousTail = point;
  	                  }
  	
  	                  if (currentSegment.length >= 2) {
  	                    segments.push({
  	                      color: currentColor,
  	                      points: currentSegment
  	                    });
  	                  }
  	
  	                  segments.forEach(segment => {
  	                    const routePath = segment.points.map(point => ({
  	                      lat: point.lat,
  	                      lng: point.lng
  	                    }));
  	
  	                    new maps.Polyline({
  	                      map,
  	                      path: routePath,
  	                      strokeColor: segment.color,
  	                      strokeOpacity: 0.90,
  	                      strokeWeight: 10,
  	                      geodesic: true,
  	                      clickable: false,
  	                      zIndex: 50
  	                    });
  	
  	                    // Same repeating direction-chevron pattern as FineTrack.
  	                    new maps.Polyline({
  	                      map,
  	                      path: routePath,
  	                      strokeOpacity: 0,
  	                      strokeWeight: 10,
  	                      geodesic: true,
  	                      clickable: false,
  	                      icons: [{
  	                        icon: eventTrackingRouteChevronIcon(segment.color),
  	                        offset: "0px",
  	                        repeat: "22px"
  	                      }],
  	                      zIndex: 51
  	                    });
  	                  });
  	
  	                  // Every tracker point is now clickable. Small markers keep the
  	                  // route readable while exposing Speed / RPM / Temp / Direction.
  	                  points.forEach((point, index) => {
  	                    const isBoundaryPoint = !!point.boundary;
  	                    const marker = new maps.Marker({
  	                      map,
  	                      position: {
  	                        lat: point.lat,
  	                        lng: point.lng
  	                      },
  	                      title: `${new Date(point.timestamp).toLocaleTimeString()} · ${eventTrackingMetricText(point.speed, " km/h", 1)}`,
  	                      icon: {
  	                        path: maps.SymbolPath.CIRCLE,
  	                        scale: isBoundaryPoint ? 4.7 : 3.25,
  	                        fillColor: point.color || "#FFFF00",
  	                        fillOpacity: isBoundaryPoint ? 1 : 0.78,
  	                        strokeColor: "#ffffff",
  	                        strokeOpacity: isBoundaryPoint ? 1 : 0.62,
  	                        strokeWeight: isBoundaryPoint ? 1.7 : 1
  	                      },
  	                      zIndex: isBoundaryPoint ? 85 : 70,
  	                      optimized: true
  	                    });
  	
  	                    marker.addListener("click", () => {
  	                      if (selectedPointMarker && selectedPointMarker !== marker) {
  	                        try {
  	                          const selectedPoint = selectedPointMarker.__eventTrackingPoint;
  	                          selectedPointMarker.setIcon({
  	                            path: maps.SymbolPath.CIRCLE,
  	                            scale: selectedPoint && selectedPoint.boundary ? 4.7 : 3.25,
  	                            fillColor: selectedPoint && selectedPoint.color ? selectedPoint.color : "#FFFF00",
  	                            fillOpacity: selectedPoint && selectedPoint.boundary ? 1 : 0.78,
  	                            strokeColor: "#ffffff",
  	                            strokeOpacity: selectedPoint && selectedPoint.boundary ? 1 : 0.62,
  	                            strokeWeight: selectedPoint && selectedPoint.boundary ? 1.7 : 1
  	                          });
  	                        } catch (_) {}
  	                      }
  	
  	                      selectedPointMarker = marker;
  	                      marker.__eventTrackingPoint = point;
  	
  	                      marker.setIcon({
  	                        path: maps.SymbolPath.CIRCLE,
  	                        scale: isBoundaryPoint ? 6.2 : 5.2,
  	                        fillColor: point.color || "#FFFF00",
  	                        fillOpacity: 1,
  	                        strokeColor: "#ffffff",
  	                        strokeOpacity: 1,
  	                        strokeWeight: 2
  	                      });
  	
  	                      infoWindow.setContent(pointInfoHtml(point));
  	                      infoWindow.open({
  	                        map,
  	                        anchor: marker
  	                      });
  	
  	                      maps.event.addListenerOnce(infoWindow, "domready", () => {
  	                        const popupClose = mapNode.querySelector(
  	                          "[data-jel-point-popup-close]"
  	                        );
  	
  	                        if (popupClose) {
  	                          popupClose.onclick = event => {
  	                            event.preventDefault();
  	                            event.stopPropagation();
  	                            infoWindow.close();
  	                          };
  	                        }
  	                      });
  	                    });
  	
  	                    marker.__eventTrackingPoint = point;
  	                  });
  	
  	                  const first = points[0];
  	                  const last = points[points.length - 1];
  	
  	                  new maps.Circle({
  	                    map,
  	                    center: { lat: first.lat, lng: first.lng },
  	                    radius: 8,
  	                    fillColor: "#58d68d",
  	                    fillOpacity: 1,
  	                    strokeColor: "#ffffff",
  	                    strokeWeight: 2,
  	                    clickable: false,
  	                    zIndex: 90
  	                  });
  	
  	                  new maps.Circle({
  	                    map,
  	                    center: { lat: last.lat, lng: last.lng },
  	                    radius: 8,
  	                    fillColor: "#f39c4a",
  	                    fillOpacity: 1,
  	                    strokeColor: "#ffffff",
  	                    strokeWeight: 2,
  	                    clickable: false,
  	                    zIndex: 90
  	                  });
  	
  	                  infoWindow.addListener("closeclick", () => {
  	                    if (!selectedPointMarker) return;
  	
  	                    try {
  	                      const selectedPoint = selectedPointMarker.__eventTrackingPoint;
  	                      selectedPointMarker.setIcon({
  	                        path: maps.SymbolPath.CIRCLE,
  	                        scale: selectedPoint && selectedPoint.boundary ? 4.7 : 3.25,
  	                        fillColor: selectedPoint && selectedPoint.color ? selectedPoint.color : "#FFFF00",
  	                        fillOpacity: selectedPoint && selectedPoint.boundary ? 1 : 0.78,
  	                        strokeColor: "#ffffff",
  	                        strokeOpacity: selectedPoint && selectedPoint.boundary ? 1 : 0.62,
  	                        strokeWeight: selectedPoint && selectedPoint.boundary ? 1.7 : 1
  	                      });
  	                    } catch (_) {}
  	
  	                    selectedPointMarker = null;
  	                  });
  	
  	                  map.fitBounds(bounds, 48);
  	
  	                  const boundaryLegend = trackWindow.querySelector("[data-jel-boundary-swatch]");
  	                  if (boundaryLegend) boundaryLegend.style.background = locationColor;
  	
  	                  if (state) state.hidden = true;
  	                } else if (state) {
  	                  state.hidden = false;
  	                  state.textContent = `Hybrid map is active, but no GPS fixes were returned from ${new Date(range.from).toLocaleTimeString()} to ${new Date(range.to).toLocaleTimeString()}.`;
  	                }
  	
  	                setTimeout(() => maps.event?.trigger?.(map, "resize"), 80);
  	                return map;
  	              }
  	
  	              async function openEventTrackingWindow(job) {
  	                const searchRange = eventTrackingRange(job);
  	                const vehicle = resolveEventVehicle(job);
  	
  	                if (!searchRange) {
  	                  window.alert("This event needs both a valid Time In and Time Out before its route can be opened.");
  	                  return;
  	                }
  	
  	                if (!vehicle || !trackerIdOf(vehicle)) {
  	                  window.alert("The event vehicle could not be matched to a vehicle with an assigned tracker.");
  	                  return;
  	                }
  	
  	                mount.querySelector("[data-jel-track-window]")?.remove();
  	
  	                const eventInfo = buildMultilineEvent(job);
  	                const vehicleLabel = trackingVehicleLabel(vehicle, job);
  	                const trackWindow = document.createElement("section");
  	                trackWindow.className = "jel-track-window";
  	                trackWindow.setAttribute("data-jel-track-window", "");
  	
  	                trackWindow.innerHTML = `
  	                <header class="jel-track-head" data-jel-track-drag>
  	                <div>
  	                  <span class="jel-kicker">Event Tracking Evidence</span>
  	                  <strong>${escapeHtml(vehicleLabel)} · ${escapeHtml(eventInfo.headline || "Location Event")}</strong>
  	                  <small>${escapeHtml(eventLocationDisplayLabel(job))} · ${escapeHtml(eventFieldLabel(job) || "Field not recorded")} · EVENT PARITY V3.2</small>
  	                </div>
  	                <div class="jel-row">
  	                  <button class="jel-btn" type="button" data-jel-track-print disabled>Print Report</button>
  	                  <button class="jel-btn" type="button" data-jel-track-close>Close</button>
  	                </div>
  	                </header>
  	                <div class="jel-track-body">
  	                  <div class="jel-track-map-wrap">
  	                    <div class="jel-track-map" data-jel-track-map></div>
  	                    <div class="jel-track-state" data-jel-track-state>Checking saved tracking evidence…</div>
  	                    <div class="jel-track-legend">
  	                      <span><i style="background:#58d68d"></i>Actual In</span>
  	                      <span><i style="background:#FFFF00"></i>Normal</span>
  	                      <span><i style="background:#00FF00"></i>Green Band</span>
  	                      <span><i style="background:#FF0000"></i>Exception</span>
  	                      <span><i style="background:#f39c4a"></i>Actual Out</span>
  	                      <span><i data-jel-boundary-swatch style="background:#ff8a3c"></i>Location Boundary</span>
  	                    </div>
  	                  </div>
  	                  <aside class="jel-track-side" data-jel-track-summary>
  	                    <div class="jel-track-card">
  	                      <span>Tracking History</span>
  	                      <strong>Checking saved reconciliation…</strong>
  	                      <small>The live search extends 5 minutes before and after the recorded times, then recalculates the Job from the actual boundary crossings.</small>
  	                    </div>
  	                  </aside>
  	                </div>`;
  	
  	                mount.appendChild(trackWindow);
  	                makeTrackingWindowDraggable(trackWindow);
  	
  	                const closeButton = trackWindow.querySelector("[data-jel-track-close]");
  	                const printButton = trackWindow.querySelector("[data-jel-track-print]");
  	                const summary = trackWindow.querySelector("[data-jel-track-summary]");
  	                const stateNode = trackWindow.querySelector("[data-jel-track-state]");
  	
  	                closeButton.addEventListener("click", () => {
  	                  trackWindow.remove();
  	
  	                  requestAnimationFrame(() => {
  	                    const tableWrap = bodyEl && bodyEl.querySelector(".jel-tablewrap");
  	                    if (tableWrap) tableWrap.scrollLeft = 0;
  	                  });
  	                });
  	
  	                printButton.addEventListener("click", () => printEventTrackingReport(trackWindow));
  	
  	                function renderReconciledContext(context, cacheNote) {
  	                  if (!trackWindow.isConnected) return;
  	
  	                  const analysis = context.analysis;
  	                  const range = context.correctedRange;
  	                  const recordedFrom = Number(searchRange.recordedFrom);
  	                  const recordedTo = Number(searchRange.recordedTo);
  	                  const entryVarianceSeconds = Math.round((range.from - recordedFrom) / 1000);
  	                  const exitVarianceSeconds = Math.round((range.to - recordedTo) / 1000);
  	
  	                  trackWindow.__eventTrackingContext = {
  	                    job,
  	                    vehicle,
  	                    range,
  	                    searchRange,
  	                    points: context.points,
  	                    searchPoints: context.searchPoints || context.points,
  	                    analysis,
  	                    boundary: context.boundary || eventTrackingBoundaryGeometry(job),
  	                    source: context.source || "",
  	                    payload: context.payload || null,
  	                    cache: context.cache || null,
  	                    error: ""
  	                  };
  	
  	                  summary.innerHTML = `
  	                  <div class="jel-track-card">
  	                    <span>Location</span>
  	                    <strong>${escapeHtml(eventLocationDisplayLabel(job))}</strong>
  	                    <small>Field: ${escapeHtml(eventFieldLabel(job) || "Not recorded")}</small>
  	                  </div>
  	                  <div class="jel-track-card">
  	                    <span>Corrected Event Window</span>
  	                    <strong>${escapeHtml(formatTrackingDuration(analysis.durationSeconds))}</strong>
  	                    <small>${escapeHtml(new Date(range.from).toLocaleTimeString())} actual entry → ${escapeHtml(new Date(range.to).toLocaleTimeString())} actual exit</small>
  	                  </div>
  	                  <div class="jel-track-grid">
  	                    <div class="jel-track-card"><span>GPS Points</span><strong>${escapeHtml(String(context.points.length))}</strong><small>${escapeHtml(context.source || "Tracking history")}</small></div>
  	                    <div class="jel-track-card"><span>Distance</span><strong>${escapeHtml((analysis.distance / 1000).toFixed(2))} km</strong><small>Boundary-to-boundary GPS path</small></div>
  	                    <div class="jel-track-card"><span>Moving</span><strong>${escapeHtml(formatTrackingDuration(analysis.movingSeconds))}</strong><small>Within corrected event</small></div>
  	                    <div class="jel-track-card"><span>Stopped</span><strong>${escapeHtml(formatTrackingDuration(analysis.stoppedSeconds))}</strong><small>Within corrected event</small></div>
  	                  </div>
  	                  <div class="jel-track-card">
  	                    <span>Recorded vs Actual</span>
  	                    <strong>In ${entryVarianceSeconds >= 0 ? "+" : ""}${escapeHtml(String(entryVarianceSeconds))}s · Out ${exitVarianceSeconds >= 0 ? "+" : ""}${escapeHtml(String(exitVarianceSeconds))}s</strong>
  	                    <small>Recorded ${escapeHtml(new Date(recordedFrom).toLocaleTimeString())} → ${escapeHtml(new Date(recordedTo).toLocaleTimeString())}</small>
  	                  </div>
  	                  <div class="jel-track-card">
  	                    <span>Speed</span>
  	                    <strong>${analysis.averageSpeed === null ? "Not reported" : escapeHtml(analysis.averageSpeed.toFixed(1) + " km/h average")}</strong>
  	                    <small>${analysis.maxSpeed === null ? "Tracker did not report speed" : escapeHtml(analysis.maxSpeed.toFixed(1) + " km/h maximum")}</small>
  	                  </div>
  	                  <div class="jel-track-card">
  	                    <span>Boundary Evidence</span>
  	                    <strong>${analysis.first ? escapeHtml(new Date(analysis.first.timestamp).toLocaleString()) : "No entry crossing"}</strong>
  	                    <small>${analysis.last ? escapeHtml("Exit " + new Date(analysis.last.timestamp).toLocaleString()) : "No exit crossing"}${cacheNote ? " · " + escapeHtml(cacheNote) : ""}</small>
  	                  </div>`;
  	
  	                  renderEventTrackingMap(trackWindow, context.points, range);
  	                  if (stateNode) stateNode.hidden = true;
  	                  printButton.disabled = false;
  	                }
  	
  	                const cached = eventTrackingContextFromCache(job, searchRange);
  	                if (cached) {
  	                  renderReconciledContext(cached, "Hot loaded from JobEntries");
  	                  return;
  	                }
  	
  	                try {
  	                  if (stateNode) {
  	                    stateNode.hidden = false;
  	                    stateNode.textContent =
  	                      `Loading tracker history from ${new Date(searchRange.from).toLocaleTimeString()} to ${new Date(searchRange.to).toLocaleTimeString()} (5 minute padding on each side)…`;
  	                  }
  	
  	                  const loaded = await loadEventTracking(vehicle, searchRange);
  	                  if (!trackWindow.isConnected) return;
  	
  	                  const searchPoints = normaliseTrackingPoints(loaded.rows, searchRange, vehicle);
  	                  const reconciliation = reconcileEventTracking(job, searchPoints, searchRange);
  	
  	                  if (!reconciliation.ok) {
  	                    const rawAnalysis = analyseEventTracking(searchPoints, searchRange);
  	                    trackWindow.__eventTrackingContext = {
  	                      job,
  	                      vehicle,
  	                      range: searchRange,
  	                      searchRange,
  	                      points: searchPoints,
  	                      searchPoints,
  	                      analysis: rawAnalysis,
  	                      boundary: reconciliation.boundary,
  	                      source: loaded.source,
  	                      payload: loaded.payload,
  	                      error: reconciliation.reason
  	                    };
  	
  	                    summary.innerHTML = `
  	                    <div class="jel-track-card"><span>Location</span><strong>${escapeHtml(eventLocationDisplayLabel(job))}</strong><small>Field: ${escapeHtml(eventFieldLabel(job) || "Not recorded")}</small></div>
  	                    <div class="jel-track-card"><span>Boundary Reconciliation</span><strong>Review required</strong><small>${escapeHtml(reconciliation.reason)}</small></div>
  	                    <div class="jel-track-card"><span>Padded Search Window</span><strong>${escapeHtml(formatTrackingDuration((searchRange.to - searchRange.from) / 1000))}</strong><small>${escapeHtml(new Date(searchRange.from).toLocaleTimeString())} → ${escapeHtml(new Date(searchRange.to).toLocaleTimeString())} · ${escapeHtml(String(searchPoints.length))} GPS points</small></div>`;
  	
  	                    renderEventTrackingMap(trackWindow, searchPoints, searchRange);
  	                    printButton.disabled = false;
  	                    return;
  	                  }
  	
  	                  const evidence = eventTrackingEvidenceFromReconciliation(
  	                    job,
  	                    loaded,
  	                    searchPoints,
  	                    reconciliation
  	                  );
  	
  	                  let persistence = { cacheSaved: false, cacheField: "" };
  	                  try {
  	                    persistence = await saveEventTrackingReconciliation(job, evidence, reconciliation);
  	                  } catch (saveError) {
  	                    console.error("Event tracking reconciliation save failed:", saveError);
  	                  }
  	
  	                  if (!trackWindow.isConnected) return;
  	
  	                  renderEvents();
  	
  	                  renderReconciledContext({
  	                    points: reconciliation.routePoints,
  	                    searchPoints,
  	                    analysis: reconciliation.analysis,
  	                    correctedRange: reconciliation.correctedRange,
  	                    boundary: reconciliation.boundary,
  	                    source: persistence.cacheSaved
  	                      ? `${loaded.source} · saved to ${persistence.cacheField}`
  	                      : `${loaded.source} · Job corrected; tracking JSON cache not persisted`,
  	                    payload: loaded.payload,
  	                    cache: evidence
  	                  }, persistence.cacheSaved ? "Saved for hot load" : "Tracking cache save needs a JSON field");
  	
  	                } catch (error) {
  	                  if (!trackWindow.isConnected) return;
  	
  	                  const message = safeString(error?.message || error?.faultString || "Event tracking history could not be loaded.");
  	                  const analysis = analyseEventTracking([], searchRange);
  	
  	                  trackWindow.__eventTrackingContext = {
  	                    job,
  	                    vehicle,
  	                    range: searchRange,
  	                    searchRange,
  	                    points: [],
  	                    searchPoints: [],
  	                    analysis,
  	                    boundary: eventTrackingBoundaryGeometry(job),
  	                    source: "",
  	                    error: message
  	                  };
  	
  	                  if (stateNode) {
  	                    stateNode.hidden = false;
  	                    stateNode.textContent = "Hybrid Google Maps is ready; the route will appear when tracker history is connected.";
  	                  }
  	
  	                  summary.innerHTML = `
  	                    <div class="jel-track-card"><span>Tracking Unavailable</span><strong>History request did not complete</strong><small>${escapeHtml(message)}</small></div>
  	                    <div class="jel-track-card"><span>Requested Search Window</span><strong>${escapeHtml(new Date(searchRange.from).toLocaleString())}</strong><small>to ${escapeHtml(new Date(searchRange.to).toLocaleString())} · includes ±5 minute padding</small></div>`;
  	
  	                  renderEventTrackingMap(trackWindow, [], searchRange);
  	                  printButton.disabled = false;
  	                }
  	              }
  	
  	              function sortEvents(events) {
  	                return events.slice().sort((a, b) => {
  	                  const aDate = asDate(getBestTimeIn(a) || getBestTimeOut(a) || getBestDate(a));
  	                  const bDate = asDate(getBestTimeIn(b) || getBestTimeOut(b) || getBestDate(b));
  	
  	                  const aTime = aDate ? aDate.getTime(): 0;
  	                  const bTime = bDate ? bDate.getTime(): 0;
  	
  	                  return bTime - aTime;
  	                });
  	              }
  	
  	              function loadEventsViaRelation() {
  	                if (!hasBackendlessData()) {
  	                  return Promise.resolve({
  	                    ok: false,
  	                    jobs: [],
  	                    reason: "Backendless missing"
  	                  });
  	                }
  	
  	                const locationStore = Backendless.Data.of(TABLE_LOCATIONS);
  	
  	                if (!locationStore || typeof locationStore.loadRelations !== "function") {
  	                  return Promise.resolve({
  	                    ok: false,
  	                    jobs: [],
  	                    reason: "loadRelations missing"
  	                  });
  	                }
  	
  	                return locationStore.loadRelations(
  	                  {
  	                    objectId: locationId
  	                  },
  	                  LOCATION_JOBS_RELATION_FIELD,
  	                  null
  	                ).then(result => {
  	                    return {
  	                      ok: true,
  	                      jobs: Array.isArray(result) ? result: result ? [result]: [],
  	                      source: "Location.Jobs"
  	                    };
  	                  }).catch(error => {
  	                    return {
  	                      ok: false,
  	                      jobs: [],
  	                      reason: error?.message || error?.faultString || "Relation load failed"
  	                    };
  	                  });
  	              }
  	
  	              function loadEventsViaJobEntries() {
  	                if (!hasBackendlessData()) {
  	                  return Promise.resolve({
  	                    ok: false,
  	                    jobs: [],
  	                    reason: "Backendless missing"
  	                  });
  	                }
  	
  	                const store = Backendless.Data.of(TABLE_JOB_ENTRIES);
  	
  	                if (
  	                  !Backendless.DataQueryBuilder ||
  	                  typeof Backendless.DataQueryBuilder.create !== "function" ||
  	                  !store ||
  	                  typeof store.find !== "function"
  	                ) {
  	                  return Promise.resolve({
  	                    ok: false,
  	                    jobs: [],
  	                    reason: "Query builder missing"
  	                  });
  	                }
  	
  	                const safeLocationId = locationId.replace(/'/g, "\\'");
  	                const query = Backendless.DataQueryBuilder.create();
  	
  	                query.setWhereClause(`LocationId = '${safeLocationId}'`);
  	                query.setPageSize(100);
  	                query.setSortBy(["DateISO DESC"]);
  	
  	                return store.find(query).then(result => {
  	                  const jobs = Array.isArray(result)
  	                  ? result: Array.isArray(result?.data)
  	                  ? result.data: [];
  	
  	                  return {
  	                    ok: true,
  	                    jobs,
  	                    source: "JobEntries.LocationId"
  	                  };
  	                }).catch(error => {
  	                  return {
  	                    ok: false,
  	                    jobs: [],
  	                    reason: error?.message || error?.faultString || "JobEntries query failed"
  	                  };
  	                });
  	              }
  	
  	              function loadEvents() {
  	                return loadEventsViaRelation().then(relationResult => {
  	                  if (relationResult.ok && relationResult.jobs.length) {
  	                    return relationResult;
  	                  }
  	
  	                  return loadEventsViaJobEntries().then(queryResult => {
  	                    if (queryResult.ok) return queryResult;
  	
  	                    return relationResult.ok ? relationResult: queryResult;
  	                  });
  	                });
  	              }
  	
  	              function eventMatchesSearch(job, query) {
  	                if (!query) return true;
  	
  	                const blob = [
  	                  getBestDate(job),
  	                  eventLocationDisplayLabel(job),
  	                  eventFieldLabel(job),
  	                  buildEventText(job),
  	                  buildProductText(job),
  	                  getContractorText(job),
  	                  getDriverText(job),
  	                  getVehicleText(job),
  	                  formatTime(getBestTimeIn(job)),
  	                  formatTime(getBestTimeOut(job)),
  	                  formatDuration(getBestDuration(job)),
  	                  safeString(getBestArea(job) || "")
  	                ].join(" ").toLowerCase();
  	
  	                return blob.includes(query);
  	              }
  	
  	              function renderRows(jobs, query) {
  	                const visible = sortEvents(jobs).filter(job => eventMatchesSearch(job, query));
  	
  	                if (!visible.length) {
  	                  return `
  	                  <div class="jel-empty">
  	                  ${query ? "No matching jobs found.": "No jobs found for this location."}
  	                  </div>
  	                  `;
  	                }
  	
  	                return `
  	                <div class="jel-tablewrap">
  	                <table class="jel-table">
  	                <colgroup>
  	                <col style="width:92px">
  	                <col style="width:120px">
  	                <col style="width:70px">
  	                <col style="width:115px">
  	                <col style="width:115px">
  	                <col style="width:70px">
  	                <col style="width:110px">
  	                <col style="width:95px">
  	                <col style="width:110px">
  	                <col style="width:60px">
  	                <col style="width:72px">
  	                <col style="width:72px">
  	                <col style="width:76px">
  	                <col style="width:95px">
  	                <col style="width:155px">
  	                </colgroup>
  	                <thead>
  	                <tr>
  	                <th>Date</th>
  	                <th>Field</th>
  	                <th>Area</th>
  	                <th>Event</th>
  	                <th>Product</th>
  	                <th>Rate</th>
  	                <th>Contractor</th>
  	                <th>Driver</th>
  	                <th>Tractor</th>
  	                <th>Fuel</th>
  	                <th>Time In</th>
  	                <th>Time Out</th>
  	                <th>Duration</th>
  	                <th>Tracking</th>
  	                <th>Actions</th>
  	                </tr>
  	                </thead>
  	
  	                <tbody>
  	                ${visible.map((job, index) => {
  	                  const eventInfo = buildMultilineEvent(job);
  	                  const products = buildMultilineProducts(job);
  	                  const rates = buildMultilineRates(job);
  	                  const area = getBestArea(job);
  	                  const duration = getBestDuration(job);
  	                  const range = eventTrackingRange(job);
  	                  const eventVehicle = resolveEventVehicle(job);
  	                  const routeAvailable = !!range && !!eventVehicle && !!trackerIdOf(eventVehicle);
  	                  const routeReason = !range
  	                    ? "Time In and Time Out are required"
  	                    : !eventVehicle
  	                      ? "Event vehicle could not be matched"
  	                      : !trackerIdOf(eventVehicle)
  	                        ? "Vehicle has no tracker assigned"
  	                        : "Open Time In to Time Out tracking evidence";
  	
  	                  return `
  	                  <tr>
  	                  <td class="jel-compact">
  	                  <div class="${getBestDate(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getBestDate(job) || "-")}
  	                  </div>
  	                  </td>
  	
  	                  <td class="jel-compact">
  	                  <div class="${eventFieldLabel(job) || eventLocationLabel(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(eventFieldLabel(job) || eventLocationLabel(job) || "-")}
  	                  </div>
  	                  </td>
  	
  	                  <td>
  	                  <div class="${area === null ? "jel-muted jel-num": "jel-num"}">
  	                  ${area === null ? "-": escapeHtml(Number(area).toFixed(2))}
  	                  </div>
  	                  </td>
  	
  	                  <td>${bigSmall(eventInfo.headline, eventInfo.extras)}</td>
  	
  	                  <td>${smallLines(products)}</td>
  	
  	                  <td>${smallLines(rates)}</td>
  	
  	                  <td>
  	                  <div class="${getContractorText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getContractorText(job) || "-")}
  	                  </div>
  	                  </td>
  	
  	                  <td class="jel-compact">
  	                  <div class="${getDriverText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getDriverText(job) || "-")}
  	                  </div>
  	                  </td>
  	
  	                  <td class="jel-compact">
  	                  <div class="${getVehicleText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getVehicleText(job) || "-")}
  	                  </div>
  	                  </td>
  	
  	                  <td class="jel-compact">
  	                  <div class="${getFuelText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getFuelText(job) || "-")}
  	                  </div>
  	                  </td>
  	
  	                  <td class="jel-compact">
  	                  <div class="${formatTime(getBestTimeIn(job)) ? "jel-num": "jel-muted jel-num"}">
  	                  ${escapeHtml(formatTime(getBestTimeIn(job)) || "-")}
  	                  </div>
  	                  </td>
  	
  	                  <td class="jel-compact">
  	                  <div class="${formatTime(getBestTimeOut(job)) ? "jel-num": "jel-muted jel-num"}">
  	                  ${escapeHtml(formatTime(getBestTimeOut(job)) || "-")}
  	                  </div>
  	                  </td>
  	
  	                  <td class="jel-compact">
  	                  <div class="${duration === null ? "jel-muted jel-num": "jel-num"}">
  	                  ${escapeHtml(duration === null ? "-": formatDuration(duration))}
  	                  </div>
  	                  </td>
  	
  	                  <td>
  	                  <button class="jel-btn jel-btn-route" type="button" data-tem-route-index="${index}" title="${escapeHtml(routeReason)}" ${routeAvailable ? "" : "disabled"}>
  	                  ${routeAvailable ? "View Route" : "Unavailable"}
  	                  </button>
  	                  </td>
  	
  	                  <td>
  	                  <div class="jel-actions-cell">
  	                  <button class="jel-btn" type="button" data-tem-edit-index="${index}">Edit Products / Rates</button>
  	                  </div>
  	                  </td>
  	                  </tr>
  	                  `;
  	                }).join("")}
  	                </tbody>
  	                </table>
  	                </div>
  	                `;
  	              }
  	
  	              function jobEntryObjectId(job) {
  	                return safeString(
  	                  job?.objectId ||
  	                  job?.ObjectId ||
  	                  job?.objectID ||
  	                  job?.id ||
  	                  job?.ID ||
  	                  ""
  	                ).trim();
  	              }
  	
  	              function cloneEventApplication(value) {
  	                if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  	
  	                try {
  	                  return JSON.parse(JSON.stringify(value));
  	                } catch (_) {
  	                  return Object.assign({}, value);
  	                }
  	              }
  	
  	              function rawApplicationsForEdit(job) {
  	                let source = firstEventValue(job, [
  	                  "Applications",
  	                  "applications",
  	                  "Application",
  	                  "application",
  	                  "Data.Applications",
  	                  "data.applications"
  	                ]);
  	
  	                if (typeof source === "string") {
  	                  const raw = source.trim();
  	
  	                  if (raw.startsWith("[") || raw.startsWith("{")) {
  	                    try {
  	                      source = JSON.parse(raw);
  	                    } catch (_) {
  	                      source = [];
  	                    }
  	                  }
  	                }
  	
  	                if (Array.isArray(source)) {
  	                  return source.map(item => {
  	                    if (item && typeof item === "object") return cloneEventApplication(item);
  	                    const text = safeString(item).trim();
  	                    return text ? { Product: text, RateText: "" }: {};
  	                  });
  	                }
  	
  	                if (source && typeof source === "object") {
  	                  return [cloneEventApplication(source)];
  	                }
  	
  	                return [];
  	              }
  	
  	              const EVENT_PRODUCT_KEYS = [
  	                "Product", "product", "Crop", "crop", "Material", "material", "Description", "description"
  	              ];
  	
  	              const EVENT_RATE_KEYS = [
  	                "RateText", "rateText", "Rate", "rate", "QuantityText", "quantityText", "Quantity", "quantity"
  	              ];
  	
  	              function applicationProductValue(application) {
  	                return pick(application, EVENT_PRODUCT_KEYS);
  	              }
  	
  	              function applicationRateValue(application) {
  	                return pick(application, EVENT_RATE_KEYS);
  	              }
  	
  	              function applicationContextLabel(application, index) {
  	                const type = pick(application, ["Type", "type", "ApplicationType", "applicationType", "Action", "action", "Event", "event"]);
  	                const asset = pick(application, [
  	                  "Registration", "registration", "VehicleRegistration", "vehicleRegistration",
  	                  "Trailer", "trailer", "TrailerRegistration", "trailerRegistration", "Implement", "implement"
  	                ]);
  	
  	                if (type && asset) return `${type} - ${asset}`;
  	                if (asset) return asset;
  	                if (type) return type;
  	
  	                return `Additional Product / Rate ${index + 1}`;
  	              }
  	
  	              function applicationHasNonProductRateData(application) {
  	                if (!application || typeof application !== "object") return false;
  	
  	                const excluded = new Set(EVENT_PRODUCT_KEYS.concat(EVENT_RATE_KEYS));
  	
  	                return Object.keys(application).some(key => {
  	                  if (excluded.has(key)) return false;
  	
  	                  const value = application[key];
  	
  	                  if (value === undefined || value === null) return false;
  	                  if (typeof value === "string") return !!value.trim();
  	                  if (Array.isArray(value)) return value.length > 0;
  	                  if (typeof value === "object") return Object.keys(value).length > 0;
  	
  	                  return true;
  	                });
  	              }
  	
  	              function writeApplicationProductRate(application, product, rate) {
  	                const output = cloneEventApplication(application);
  	                const cleanProduct = safeString(product).trim();
  	                const cleanRate = safeString(rate).trim();
  	
  	                EVENT_PRODUCT_KEYS.forEach(key => {
  	                  if (Object.prototype.hasOwnProperty.call(output, key)) {
  	                    output[key] = cleanProduct;
  	                  }
  	                });
  	
  	                EVENT_RATE_KEYS.forEach(key => {
  	                  if (Object.prototype.hasOwnProperty.call(output, key)) {
  	                    output[key] = cleanRate;
  	                  }
  	                });
  	
  	                output.Product = cleanProduct;
  	                output.RateText = cleanRate;
  	
  	                return output;
  	              }
  	
  	              function closeEventsActionModal() {
  	                const modal = mount?.querySelector("[data-jel-action-modal]");
  	
  	                if (modal) modal.remove();
  	              }
  	
  	              function createEventsActionModal() {
  	                closeEventsActionModal();
  	
  	                const modal = document.createElement("div");
  	                modal.className = "jel-action-modal";
  	                modal.setAttribute("data-jel-action-modal", "");
  	
  	                modal.addEventListener("mousedown", event => {
  	                  if (event.target === modal) closeEventsActionModal();
  	                });
  	
  	                mount.appendChild(modal);
  	                return modal;
  	              }
  	
  	              function saveJobProductsAndRates(job, applications) {
  	                if (!hasBackendlessData()) {
  	                  return Promise.reject(new Error("The Database connection is unavailable."));
  	                }
  	
  	                const objectId = jobEntryObjectId(job);
  	
  	                if (!objectId) {
  	                  return Promise.reject(new Error("This Job Entry has no objectId and cannot be edited."));
  	                }
  	
  	                const store = Backendless.Data.of(TABLE_JOB_ENTRIES);
  	
  	                if (!store || typeof store.save !== "function") {
  	                  return Promise.reject(new Error("The JobEntries save function is unavailable."));
  	                }
  	
  	                return store.save({
  	                  objectId,
  	                  Applications: applications
  	                });
  	              }
  	
  	              function openJobProductsEditor(job) {
  	                const objectId = jobEntryObjectId(job);
  	
  	                if (!objectId) {
  	                  window.alert("This Job Entry has no objectId and cannot be edited.");
  	                  return;
  	                }
  	
  	                const originalApplications = rawApplicationsForEdit(job);
  	                const editorRows = originalApplications.map((application, index) => ({
  	                  raw: cloneEventApplication(application),
  	                  product: applicationProductValue(application),
  	                  rate: applicationRateValue(application),
  	                  removed: false,
  	                  added: false,
  	                  key: `existing-${index}-${Date.now()}`
  	                }));
  	
  	                if (!editorRows.length) {
  	                  editorRows.push({
  	                    raw: {},
  	                    product: "",
  	                    rate: "",
  	                    removed: false,
  	                    added: true,
  	                    key: `added-${Date.now()}-0`
  	                  });
  	                }
  	
  	                const modal = createEventsActionModal();
  	                let saving = false;
  	
  	                function visibleRows() {
  	                  return editorRows.filter(row => !row.removed);
  	                }
  	
  	                function renderEditor() {
  	                  const rows = visibleRows();
  	                  const eventInfo = buildMultilineEvent(job);
  	                  const jobLabel = [
  	                    getBestDate(job),
  	                    eventInfo.headline,
  	                    getVehicleText(job)
  	                  ].filter(Boolean).join(" · ") || objectId;
  	
  	                  modal.innerHTML = `
  	                  <div class="jel-action-panel" role="dialog" aria-modal="true" aria-label="Edit Job Products and Rates">
  	                  <div class="jel-action-head">
  	                  <div>
  	                  <div class="jel-action-title">Edit Products and Rates</div>
  	                  <div class="jel-action-sub">${escapeHtml(jobLabel)}<br>Only Product and Rate values can be changed here.</div>
  	                  </div>
  	                  <button class="jel-btn" type="button" data-jel-modal-close ${saving ? "disabled": ""}>✖ Close</button>
  	                  </div>
  	
  	                  <div class="jel-action-body">
  	                  <div class="jel-editor-list">
  	                  ${rows.length ? rows.map((row, visibleIndex) => {
  	                    const actualIndex = editorRows.indexOf(row);
  	                    return `
  	                    <div class="jel-editor-row">
  	                    <div class="jel-editor-row-head">
  	                    <div class="jel-editor-context">${escapeHtml(applicationContextLabel(row.raw, visibleIndex))}</div>
  	                    <button class="jel-btn jel-btn-danger" type="button" data-jel-remove-line="${actualIndex}" ${saving ? "disabled": ""}>Remove</button>
  	                    </div>
  	                    <div class="jel-editor-grid">
  	                    <label>
  	                    <span class="jel-field-label">Product</span>
  	                    <input class="jel-field-input" type="text" value="${escapeHtml(row.product)}" data-jel-product="${actualIndex}" placeholder="Product" ${saving ? "disabled": ""}>
  	                    </label>
  	                    <label>
  	                    <span class="jel-field-label">Rate</span>
  	                    <input class="jel-field-input" type="text" value="${escapeHtml(row.rate)}" data-jel-rate="${actualIndex}" placeholder="Rate" ${saving ? "disabled": ""}>
  	                    </label>
  	                    </div>
  	                    </div>
  	                    `;
  	                  }).join(""): '<div class="jel-empty">No Product / Rate lines. Add a new line below.</div>'}
  	                  </div>
  	
  	                  <div class="jel-editor-tools">
  	                  <button class="jel-btn jel-btn-primary" type="button" data-jel-add-line ${saving ? "disabled": ""}>+ Add Product / Rate</button>
  	                  </div>
  	
  	                  <div class="jel-action-error" data-jel-editor-error></div>
  	                  </div>
  	
  	                  <div class="jel-action-foot">
  	                  <button class="jel-btn" type="button" data-jel-modal-close ${saving ? "disabled": ""}>Cancel</button>
  	                  <button class="jel-btn jel-btn-primary" type="button" data-jel-save-products ${saving ? "disabled": ""}>${saving ? "Saving...": "Save Products and Rates"}</button>
  	                  </div>
  	                  </div>
  	                  `;
  	
  	                  modal.querySelectorAll("[data-jel-modal-close]").forEach(button => {
  	                    button.addEventListener("click", closeEventsActionModal);
  	                  });
  	
  	                  modal.querySelectorAll("[data-jel-product]").forEach(input => {
  	                    input.addEventListener("input", () => {
  	                      const index = Number(input.getAttribute("data-jel-product"));
  	                      if (editorRows[index]) editorRows[index].product = input.value;
  	                    });
  	                  });
  	
  	                  modal.querySelectorAll("[data-jel-rate]").forEach(input => {
  	                    input.addEventListener("input", () => {
  	                      const index = Number(input.getAttribute("data-jel-rate"));
  	                      if (editorRows[index]) editorRows[index].rate = input.value;
  	                    });
  	                  });
  	
  	                  modal.querySelectorAll("[data-jel-remove-line]").forEach(button => {
  	                    button.addEventListener("click", () => {
  	                      const index = Number(button.getAttribute("data-jel-remove-line"));
  	                      if (!editorRows[index]) return;
  	                      editorRows[index].removed = true;
  	                      renderEditor();
  	                    });
  	                  });
  	
  	                  modal.querySelector("[data-jel-add-line]")?.addEventListener("click", () => {
  	                    editorRows.push({
  	                      raw: {},
  	                      product: "",
  	                      rate: "",
  	                      removed: false,
  	                      added: true,
  	                      key: `added-${Date.now()}-${editorRows.length}`
  	                    });
  	                    renderEditor();
  	                    setTimeout(() => {
  	                      const inputs = modal.querySelectorAll("[data-jel-product]");
  	                      inputs[inputs.length - 1]?.focus?.();
  	                    }, 20);
  	                  });
  	
  	                  modal.querySelector("[data-jel-save-products]")?.addEventListener("click", async () => {
  	                    if (saving) return;
  	
  	                    const incomplete = visibleRows().find(row => {
  	                      const product = safeString(row.product).trim();
  	                      const rate = safeString(row.rate).trim();
  	                      return (product && !rate) || (!product && rate);
  	                    });
  	
  	                    const errorEl = modal.querySelector("[data-jel-editor-error]");
  	
  	                    if (incomplete) {
  	                      if (errorEl) {
  	                        errorEl.textContent = "Every Product line must also have a Rate, and every Rate must also have a Product.";
  	                        errorEl.classList.add("visible");
  	                      }
  	                      return;
  	                    }
  	
  	                    const updatedApplications = [];
  	
  	                    editorRows.forEach(row => {
  	                      const product = safeString(row.product).trim();
  	                      const rate = safeString(row.rate).trim();
  	                      const keepStructure = applicationHasNonProductRateData(row.raw);
  	
  	                      if (row.removed || (!product && !rate)) {
  	                        if (keepStructure) {
  	                          updatedApplications.push(writeApplicationProductRate(row.raw, "", ""));
  	                        }
  	                        return;
  	                      }
  	
  	                      updatedApplications.push(writeApplicationProductRate(row.raw, product, rate));
  	                    });
  	
  	                    saving = true;
  	                    renderEditor();
  	
  	                    try {
  	                      const saved = await saveJobProductsAndRates(job, updatedApplications);
  	
  	                      job.Applications = updatedApplications;
  	
  	                      if (saved && typeof saved === "object") {
  	                        Object.assign(job, saved);
  	                        job.Applications = updatedApplications;
  	                      }
  	
  	                      closeEventsActionModal();
  	                      renderEvents();
  	                      statusEl.textContent = "Products and Rates saved";
  	                    } catch (error) {
  	                      saving = false;
  	                      renderEditor();
  	                      const currentError = modal.querySelector("[data-jel-editor-error]");
  	                      if (currentError) {
  	                        currentError.textContent = safeString(error?.message || error?.faultString || "The Products and Rates could not be saved.");
  	                        currentError.classList.add("visible");
  	                      }
  	                    }
  	                  });
  	                }
  	
  	                renderEditor();
  	              }
  	
  	              function deleteJobEntryRecord(job) {
  	                if (!hasBackendlessData()) {
  	                  return Promise.reject(new Error("The Database connection is unavailable."));
  	                }
  	
  	                const objectId = jobEntryObjectId(job);
  	
  	                if (!objectId) {
  	                  return Promise.reject(new Error("This Job Entry has no objectId and cannot be deleted."));
  	                }
  	
  	                const store = Backendless.Data.of(TABLE_JOB_ENTRIES);
  	
  	                if (store && typeof store.remove === "function") {
  	                  return store.remove(job).catch(error => {
  	                    if (typeof store.bulkDelete !== "function") throw error;
  	                    const safeId = objectId.replace(/'/g, "\\'");
  	                    return store.bulkDelete(`objectId = '${safeId}'`);
  	                  });
  	                }
  	
  	                if (store && typeof store.bulkDelete === "function") {
  	                  const safeId = objectId.replace(/'/g, "\\'");
  	                  return store.bulkDelete(`objectId = '${safeId}'`);
  	                }
  	
  	                return Promise.reject(new Error("The JobEntries delete function is unavailable."));
  	              }
  	
  	              function openJobDeleteConfirmation(job) {
  	                const objectId = jobEntryObjectId(job);
  	
  	                if (!objectId) {
  	                  window.alert("This Job Entry has no objectId and cannot be deleted.");
  	                  return;
  	                }
  	
  	                const modal = createEventsActionModal();
  	                const eventInfo = buildMultilineEvent(job);
  	                const jobLabel = [
  	                  getBestDate(job),
  	                  eventInfo.headline,
  	                  getVehicleText(job)
  	                ].filter(Boolean).join(" · ") || objectId;
  	
  	                modal.innerHTML = `
  	                <div class="jel-action-panel" role="dialog" aria-modal="true" aria-label="Delete Job Entry">
  	                <div class="jel-action-head">
  	                <div>
  	                <div class="jel-action-title">Delete Job Entry</div>
  	                <div class="jel-action-sub">Permanent Database deletion</div>
  	                </div>
  	                <button class="jel-btn" type="button" data-jel-modal-close>✖ Close</button>
  	                </div>
  	
  	                <div class="jel-action-body">
  	                <div class="jel-delete-name">${escapeHtml(jobLabel)}</div>
  	                <div class="jel-delete-copy">
  	                This permanently deletes the complete Job Entry and all of its saved Product and Rate lines.<br>
  	                Type <strong>DELETE</strong> exactly to continue.
  	                </div>
  	                <input class="jel-delete-input" type="text" autocomplete="off" spellcheck="false" placeholder="DELETE" data-jel-delete-input>
  	                <div class="jel-action-error" data-jel-delete-error>Exact confirmation required.</div>
  	                </div>
  	
  	                <div class="jel-action-foot">
  	                <button class="jel-btn" type="button" data-jel-modal-close>Cancel</button>
  	                <button class="jel-btn jel-btn-danger" type="button" data-jel-confirm-delete disabled>Delete Permanently</button>
  	                </div>
  	                </div>
  	                `;
  	
  	                const input = modal.querySelector("[data-jel-delete-input]");
  	                const confirmButton = modal.querySelector("[data-jel-confirm-delete]");
  	                const errorEl = modal.querySelector("[data-jel-delete-error]");
  	                let deleting = false;
  	
  	                function refreshDeleteState() {
  	                  const value = safeString(input?.value || "").trim();
  	                  const valid = value === "DELETE";
  	
  	                  if (confirmButton) confirmButton.disabled = !valid || deleting;
  	                  if (errorEl) errorEl.classList.toggle("visible", !!value && !valid);
  	                }
  	
  	                modal.querySelectorAll("[data-jel-modal-close]").forEach(button => {
  	                  button.addEventListener("click", () => {
  	                    if (!deleting) closeEventsActionModal();
  	                  });
  	                });
  	
  	                input?.addEventListener("input", refreshDeleteState);
  	                input?.addEventListener("keydown", event => {
  	                  if (event.key === "Escape" && !deleting) {
  	                    event.preventDefault();
  	                    closeEventsActionModal();
  	                  }
  	
  	                  if (event.key === "Enter" && safeString(input.value).trim() === "DELETE" && !deleting) {
  	                    event.preventDefault();
  	                    confirmButton?.click();
  	                  }
  	                });
  	
  	                confirmButton?.addEventListener("click", async () => {
  	                  if (deleting || safeString(input?.value || "").trim() !== "DELETE") return;
  	
  	                  deleting = true;
  	                  confirmButton.disabled = true;
  	                  confirmButton.textContent = "Deleting...";
  	                  if (input) input.disabled = true;
  	
  	                  try {
  	                    await deleteJobEntryRecord(job);
  	
  	                    loadedJobs = loadedJobs.filter(item => {
  	                      if (item === job) return false;
  	                      return jobEntryObjectId(item) !== objectId;
  	                    });
  	
  	                    if (Array.isArray(location.Jobs)) {
  	                      location.Jobs = location.Jobs.filter(item => jobEntryObjectId(item) !== objectId);
  	                    }
  	
  	                    closeEventsActionModal();
  	                    renderEvents();
  	                    statusEl.textContent = "Job Entry deleted";
  	                  } catch (error) {
  	                    deleting = false;
  	                    confirmButton.disabled = false;
  	                    confirmButton.textContent = "Delete Permanently";
  	                    if (input) input.disabled = false;
  	                    if (errorEl) {
  	                      errorEl.textContent = safeString(error?.message || error?.faultString || "The Job Entry could not be deleted.");
  	                      errorEl.classList.add("visible");
  	                    }
  	                  }
  	                });
  	
  	                refreshDeleteState();
  	                setTimeout(() => input?.focus?.(), 30);
  	              }
  	
  	              function openEventsPrintWindow() {
  	                try {
  	                  const query = safeString(searchInput?.value || "").trim().toLowerCase();
  	                  const visibleJobs = sortEvents(loadedJobs).filter(job => eventMatchesSearch(job, query));
  	
  	                  if (!visibleJobs.length) {
  	                    window.alert(query
  	                      ? "There are no matching Job Events to print."
  	                      : "There are no Job Events to print.");
  	                    return;
  	                  }
  	
  	                  const printWindow = window.open("", "_blank", "width=1500,height=950");
  	
  	                  if (!printWindow) {
  	                    window.alert("The Job Events print window was blocked by the browser.");
  	                    return;
  	                  }
  	
  	                  const reportCompany =
  	                    rowData.companyEntry?.company ||
  	                    rowData.company ||
  	                    rowData.companyObject ||
  	                    null;
  	
  	                  const companyLabel = safeString(
  	                    reportCompany ? getCompanyName(reportCompany) : ""
  	                  ).trim();
  	
  	                  const locationTypeLabel = safeString(getLocationTypeName(location)).trim();
  	                  const locationReference = safeString(
  	                    location?.REF ||
  	                    location?.Ref ||
  	                    location?.ID ||
  	                    location?.Id ||
  	                    locationId
  	                  ).trim();
  	
  	                  const generatedAt = new Date().toLocaleString();
  	                  const dates = visibleJobs
  	                    .map(job => getBestDate(job))
  	                    .filter(Boolean)
  	                    .sort();
  	
  	                  const firstDate = dates.length ? dates[0] : "";
  	                  const lastDate = dates.length ? dates[dates.length - 1] : "";
  	                  const periodLabel = firstDate && lastDate
  	                    ? (firstDate === lastDate ? firstDate : `${firstDate} to ${lastDate}`)
  	                    : "Not recorded";
  	
  	                  let totalFuel = 0;
  	                  let fuelRecordCount = 0;
  	                  let totalDurationSeconds = 0;
  	                  let durationRecordCount = 0;
  	                  let productLineCount = 0;
  	                  let rateLineCount = 0;
  	
  	                  visibleJobs.forEach(job => {
  	                    const fuel = calculateFuelUsed(job);
  	                    const duration = getBestDuration(job);
  	
  	                    if (fuel !== null && Number.isFinite(Number(fuel))) {
  	                      totalFuel += Number(fuel);
  	                      fuelRecordCount += 1;
  	                    }
  	
  	                    if (duration !== null && Number.isFinite(Number(duration))) {
  	                      totalDurationSeconds += Number(duration);
  	                      durationRecordCount += 1;
  	                    }
  	
  	                    productLineCount += buildMultilineProducts(job).length;
  	                    rateLineCount += buildMultilineRates(job).length;
  	                  });
  	
  	                  function printDash(value) {
  	                    const textValue = safeString(value).trim();
  	                    return escapeHtml(textValue || "—");
  	                  }
  	
  	                  function printStack(lines) {
  	                    const cleanLines = Array.isArray(lines)
  	                      ? lines.map(line => safeString(line).trim()).filter(Boolean)
  	                      : [];
  	
  	                    if (!cleanLines.length) return '<span class="muted">—</span>';
  	
  	                    return '<div class="stack">' + cleanLines.map(line => {
  	                      return '<span>' + escapeHtml(line) + '</span>';
  	                    }).join("") + '</div>';
  	                  }
  	
  	                  const rowsHtml = visibleJobs.map(job => {
  	                    const eventInfo = buildMultilineEvent(job);
  	                    const eventLines = [eventInfo.headline].concat(eventInfo.extras || []).filter(Boolean);
  	                    const products = buildMultilineProducts(job);
  	                    const rates = buildMultilineRates(job);
  	                    const area = getBestArea(job);
  	                    const fuel = calculateFuelUsed(job);
  	                    const duration = getBestDuration(job);
  	                    const timeIn = formatTime(getBestTimeIn(job));
  	                    const timeOut = formatTime(getBestTimeOut(job));
  	
  	                    return ''
  	                      + '<tr>'
  	                      + '<td class="nowrap">' + printDash(getBestDate(job)) + '</td>'
  	                      + '<td>' + printDash(eventFieldLabel(job) || eventLocationLabel(job)) + '</td>'
  	                      + '<td class="num">' + (area === null ? '<span class="muted">—</span>' : escapeHtml(Number(area).toFixed(2))) + '</td>'
  	                      + '<td>' + printStack(eventLines) + '</td>'
  	                      + '<td>' + printStack(products) + '</td>'
  	                      + '<td>' + printStack(rates) + '</td>'
  	                      + '<td>' + printDash(getContractorText(job)) + '</td>'
  	                      + '<td>' + printDash(getDriverText(job)) + '</td>'
  	                      + '<td>' + printDash(getVehicleText(job)) + '</td>'
  	                      + '<td class="num">' + (fuel === null ? '<span class="muted">—</span>' : escapeHtml(Number(fuel).toFixed(2))) + '</td>'
  	                      + '<td class="num nowrap">' + printDash(timeIn) + '</td>'
  	                      + '<td class="num nowrap">' + printDash(timeOut) + '</td>'
  	                      + '<td class="num nowrap">' + (duration === null ? '<span class="muted">—</span>' : escapeHtml(formatDuration(duration))) + '</td>'
  	                      + '</tr>';
  	                  }).join("");
  	
  	                  const reportTitle = "Location Job Events Report";
  	                  const reportBrandAsset = resolveReportBrandAsset(REPORT_SVG_INPUT);
  	                  const reportBrandHtml = reportBrandAsset
  	                    ? '<img class="brand-logo" src="' + escapeHtml(reportBrandAsset) + '" alt="Fleet In Form">'
  	                    : '<div class="brand-mark">FIF</div>';
  	                  const filterLabel = query
  	                    ? `Filtered by: “${safeString(searchInput?.value || "").trim()}”`
  	                    : "Filter: None";
  	
  	                  const html = ''
  	                    + '<!doctype html>'
  	                    + '<html>'
  	                    + '<head>'
  	                    + '<meta charset="utf-8">'
  	                    + '<meta name="viewport" content="width=device-width,initial-scale=1">'
  	                    + '<title>' + escapeHtml(reportTitle) + '</title>'
  	                    + '<style>'
  	                    + '*{box-sizing:border-box;}'
  	                    + 'html,body{margin:0;padding:0;background:#fff;color:#111827;font-family:Arial,Helvetica,sans-serif;}'
  	                    + 'body{padding:24px 28px 30px;font-size:11px;}'
  	                    + '.report-head{display:flex;justify-content:space-between;align-items:flex-start;gap:24px;border-bottom:3px solid #cc6633;padding-bottom:13px;margin-bottom:16px;}'
  	                    + '.brand{display:flex;align-items:center;gap:11px;}'
  	                    + '.brand-mark{width:58px;height:42px;border-radius:8px;background:#111827;color:#fff;display:grid;place-items:center;font-size:17px;font-weight:900;border:3px solid #cc6633;flex:0 0 auto;}'
  	                    + '.brand-logo{display:block;width:auto;height:48px;max-width:180px;object-fit:contain;object-position:left center;flex:0 0 auto;}'
  	                    + '.title{font-size:25px;line-height:1.05;margin:0;color:#111827;}'
  	                    + '.subtitle{font-size:12px;color:#4b5563;margin-top:5px;}'
  	                    + '.head-meta{text-align:right;font-size:11px;line-height:1.55;color:#374151;min-width:270px;}'
  	                    + '.head-meta strong{color:#111827;}'
  	                    + '.summary-grid{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:9px;margin:0 0 16px;}'
  	                    + '.summary-card{border:1px solid #d1d5db;border-radius:8px;background:#f9fafb;padding:10px 11px;min-height:64px;break-inside:avoid;}'
  	                    + '.summary-label{font-size:9px;color:#6b7280;text-transform:uppercase;letter-spacing:.06em;font-weight:700;}'
  	                    + '.summary-value{font-size:15px;color:#111827;font-weight:800;margin-top:6px;line-height:1.15;word-break:break-word;}'
  	                    + '.report-section-title{font-size:13px;font-weight:800;margin:0 0 8px;color:#111827;}'
  	                    + '.table-shell{border:1px solid #cbd5e1;border-radius:7px;overflow:hidden;}'
  	                    + 'table{width:100%;border-collapse:collapse;table-layout:fixed;}'
  	                    + 'thead{display:table-header-group;}'
  	                    + 'thead th{background:#111827;color:#fff;font-size:8px;text-transform:uppercase;letter-spacing:.045em;padding:8px 6px;border-right:1px solid #334155;text-align:left;vertical-align:bottom;}'
  	                    + 'thead th:last-child{border-right:0;}'
  	                    + 'tbody td{font-size:8.2px;color:#111827;padding:7px 6px;border-top:1px solid #d1d5db;border-right:1px solid #e5e7eb;vertical-align:top;overflow-wrap:anywhere;line-height:1.3;}'
  	                    + 'tbody td:last-child{border-right:0;}'
  	                    + 'tbody tr:nth-child(even){background:#f8fafc;}'
  	                    + '.stack{display:flex;flex-direction:column;gap:2px;}'
  	                    + '.stack span:first-child{font-weight:700;}'
  	                    + '.muted{color:#94a3b8;font-weight:400!important;}'
  	                    + '.num{text-align:right;font-variant-numeric:tabular-nums;}'
  	                    + '.nowrap{white-space:nowrap;}'
  	                    + '.footer{margin-top:12px;padding-top:9px;border-top:1px solid #d1d5db;color:#64748b;font-size:9px;display:flex;justify-content:space-between;gap:16px;}'
  	                    + '.print-action{position:fixed;top:14px;right:14px;border:0;border-radius:8px;background:#cc6633;color:#fff;font-weight:800;padding:9px 14px;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.18);}'
  	                    + '@page{size:A3 landscape;margin:8mm;}'
  	                    + '@media print{body{padding:0}.print-action{display:none!important}.summary-card,tr,td,th{break-inside:avoid;page-break-inside:avoid}.table-shell{overflow:visible;border-radius:0}.footer{position:static}}'
  	                    + '</style>'
  	                    + '</head>'
  	                    + '<body>'
  	                    + '<button class="print-action" type="button" onclick="window.print()">Print / PDF</button>'
  	                    + '<header class="report-head">'
  	                    + '<div class="brand">'
  	                    + reportBrandHtml
  	                    + '<div><h1 class="title">' + escapeHtml(reportTitle) + '</h1>'
  	                    + '<div class="subtitle">Permanent operational Job Events for ' + printDash(locationLabel || locationId) + '</div></div>'
  	                    + '</div>'
  	                    + '<div class="head-meta">'
  	                    + '<div><strong>Company:</strong> ' + printDash(companyLabel) + '</div>'
  	                    + '<div><strong>Location:</strong> ' + printDash(locationLabel) + '</div>'
  	                    + '<div><strong>Reference:</strong> ' + printDash(locationReference) + '</div>'
  	                    + '<div><strong>Location type:</strong> ' + printDash(locationTypeLabel) + '</div>'
  	                    + '<div><strong>Generated:</strong> ' + escapeHtml(generatedAt) + '</div>'
  	                    + '<div><strong>' + escapeHtml(filterLabel) + '</strong></div>'
  	                    + '</div>'
  	                    + '</header>'
  	                    + '<section class="summary-grid">'
  	                    + '<div class="summary-card"><div class="summary-label">Location</div><div class="summary-value">' + printDash(locationLabel) + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Job Events</div><div class="summary-value">' + escapeHtml(String(visibleJobs.length)) + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Period</div><div class="summary-value" style="font-size:12px">' + escapeHtml(periodLabel) + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Fuel Recorded</div><div class="summary-value">' + (fuelRecordCount ? escapeHtml(totalFuel.toFixed(2) + ' L') : '—') + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Total Duration</div><div class="summary-value">' + (durationRecordCount ? escapeHtml(formatDuration(totalDurationSeconds)) : '—') + '</div></div>'
  	                    + '<div class="summary-card"><div class="summary-label">Product / Rate Lines</div><div class="summary-value">' + escapeHtml(productLineCount + ' / ' + rateLineCount) + '</div></div>'
  	                    + '</section>'
  	                    + '<div class="report-section-title">Job Event Register</div>'
  	                    + '<div class="table-shell">'
  	                    + '<table>'
  	                    + '<colgroup>'
  	                    + '<col style="width:7%"><col style="width:9%"><col style="width:4%"><col style="width:13%">'
  	                    + '<col style="width:10%"><col style="width:9%"><col style="width:8%"><col style="width:8%">'
  	                    + '<col style="width:8%"><col style="width:5%"><col style="width:7%"><col style="width:7%"><col style="width:5%">'
  	                    + '</colgroup>'
  	                    + '<thead><tr>'
  	                    + '<th>Date</th><th>Field</th><th>Area</th><th>Event</th><th>Product</th><th>Rate</th>'
  	                    + '<th>Contractor</th><th>Driver</th><th>Tractor</th><th>Fuel</th><th>Time In</th><th>Time Out</th><th>Duration</th>'
  	                    + '</tr></thead>'
  	                    + '<tbody>' + rowsHtml + '</tbody>'
  	                    + '</table>'
  	                    + '</div>'
  	                    + '<footer class="footer">'
  	                    + '<span>This report reflects the Job Events currently visible in the Location Events table.</span>'
  	                    + '<span>Generated by Fleet In Form</span>'
  	                    + '</footer>'
  	                    + '<script>window.onload=function(){window.focus();setTimeout(function(){window.print();},250);};<\/script>'
  	                    + '</body>'
  	                    + '</html>';
  	
  	                  printWindow.document.open();
  	                  printWindow.document.write(html);
  	                  printWindow.document.close();
  	                } catch (error) {
  	                  FIF_SILENT_CONSOLE.error("[TrackIT Location Events] Print report failed.", error);
  	                  window.alert("The Job Events report could not be prepared: " + safeString(
  	                    error?.message || error?.faultString || error
  	                  ));
  	                }
  	              }
  	
  	              injectEventsStyles();
  	
  	              const mount = document.createElement("div");
  	              mount.id = EVENTS_MOUNT_ID;
  	
  	              mount.innerHTML = `
  	              <div class="jel-root">
  	              <div class="jel-card">
  	              <header class="jel-head">
  	              <div>
  	              <span class="jel-kicker">Fleet In Form · Location Events</span>
  	              <div class="jel-title">Event Operations</div>
  	              <div class="jel-sub">${escapeHtml(locationLabel || locationId || "(No Location)")} · Dashboard boundary reconciliation</div>
  	              <div class="jel-badge" style="margin-top:6px;width:max-content">EVENT PARITY V3.2 · ${escapeHtml(LOCATION_CODE_BUILD)}</div>
  	              </div>
  	              <div class="jel-head-actions">
  	              <button class="jel-btn" type="button" data-tem-print>Print Report</button>
  	              <button class="jel-btn" type="button" data-tem-close>Close</button>
  	              </div>
  	              </header>
  	
  	              <main class="jel-main">
  	              <div class="jel-actions">
  	              <div class="jel-actions-meta">
  	              <div class="jel-badge" data-tem-status>Loading events...</div>
  	              <div class="jel-sub" data-tem-source></div>
  	              </div>
  	              <button class="jel-btn jel-btn-primary" type="button" data-tem-refresh>Refresh Events</button>
  	              </div>
  	
  	              <div class="jel-search-wrap">
  	              <input
  	              class="jel-search"
  	              type="text"
  	              placeholder="Search jobs, drivers, products, tractors, contractors, dates..."
  	              data-tem-search
  	              />
  	              </div>
  	
  	              <div class="jel-divider"></div>
  	
  	              <div class="jel-events-box" data-tem-body>
  	              <div class="jel-empty">Loading events...</div>
  	              </div>
  	              </main>
  	              </div>
  	              </div>
  	              `;
  	
  	              document.body.appendChild(mount);
  	
  	              const statusEl = mount.querySelector("[data-tem-status]");
  	              const bodyEl = mount.querySelector("[data-tem-body]");
  	              const searchInput = mount.querySelector("[data-tem-search]");
  	              const closeButton = mount.querySelector("[data-tem-close]");
  	              const refreshButton = mount.querySelector("[data-tem-refresh]");
  	
  	              const printButton = mount.querySelector("[data-tem-print]");
  	              const sourceEl = mount.querySelector("[data-tem-source]");
  	
  	              let loadedJobs = [];
  	
  	              function currentVisibleJobs() {
  	                const query = safeString(searchInput?.value || "").trim().toLowerCase();
  	                return sortEvents(loadedJobs).filter(job => eventMatchesSearch(job, query));
  	              }
  	
  	              function resetEventTableScroll() {
  	                const tableWrap = bodyEl && bodyEl.querySelector(".jel-tablewrap");
  	                if (!tableWrap) return;
  	
  	                /*
  	                 * Chrome can re-apply focus/scroll anchoring after the first
  	                 * animation frame. Reset more than once deliberately.
  	                 */
  	                tableWrap.scrollLeft = 0;
  	
  	                requestAnimationFrame(() => {
  	                  tableWrap.scrollLeft = 0;
  	
  	                  requestAnimationFrame(() => {
  	                    tableWrap.scrollLeft = 0;
  	                  });
  	                });
  	
  	                setTimeout(() => {
  	                  if (tableWrap.isConnected) tableWrap.scrollLeft = 0;
  	                }, 40);
  	              }
  	
  	              function renderEvents() {
  	                const query = safeString(searchInput?.value || "").trim().toLowerCase();
  	
  	                bodyEl.innerHTML = renderRows(loadedJobs, query);
  	                resetEventTableScroll();
  	
  	                statusEl.textContent = loadedJobs.length
  	                ? `Loaded ${loadedJobs.length} event(s)`: "No events found";
  	              }
  	
  	              function refreshEvents() {
  	                statusEl.textContent = "Loading events...";
  	                bodyEl.innerHTML = `<div class="jel-empty">Loading events...</div>`;
  	                refreshButton.disabled = true;
  	
  	                loadEvents().then(result => {
  	                  loadedJobs = Array.isArray(result.jobs) ? result.jobs: [];
  	
  	                  renderEvents();
  	
  	                  if (sourceEl) {
  	                    sourceEl.textContent = result.source ? `Source: ${result.source}`: "";
  	                  }
  	
  	                }).catch(error => {
  	                  loadedJobs = [];
  	                  statusEl.textContent = "Failed to load events";
  	                  bodyEl.innerHTML = `
  	                  <div class="jel-empty">
  	                  ${escapeHtml(error?.message || "Could not load events.")}
  	                  </div>
  	                  `;
  	                }).finally(() => {
  	                  refreshButton.disabled = false;
  	                });
  	              }
  	
  	              closeButton.addEventListener("click",
  	                () => {
  	                  mount.remove();
  	                });
  	
  	              refreshButton.addEventListener("click",
  	                () => {
  	                  refreshEvents();
  	                });
  	
  	              printButton.addEventListener("click",
  	                () => {
  	                  openEventsPrintWindow();
  	                });
  	
  	              searchInput.addEventListener("input",
  	                () => {
  	                  renderEvents();
  	                });
  	
  	              bodyEl.addEventListener("click", event => {
  	                const editButton = event.target.closest("[data-tem-edit-index]");
  	                const routeButton = event.target.closest("[data-tem-route-index]");
  	                const button = editButton || routeButton;
  	
  	                if (!button || !bodyEl.contains(button)) return;
  	
  	                const index = Number(
  	                  button.getAttribute(editButton ? "data-tem-edit-index": "data-tem-route-index")
  	                );
  	                const visibleJobs = currentVisibleJobs();
  	                const job = visibleJobs[index] || null;
  	
  	                if (!job) {
  	                  window.alert("This Job Entry is no longer available. Refresh the list and try again.");
  	                  return;
  	                }
  	
  	                /*
  	                 * A focused button in the far-right columns causes Chrome to
  	                 * horizontally scroll the table to keep it visible. Remove
  	                 * focus before opening either child window.
  	                 */
  	                try {
  	                  button.blur();
  	                } catch (_) {}
  	
  	                if (editButton) {
  	                  openJobProductsEditor(job);
  	                  return;
  	                }
  	
  	                openEventTrackingWindow(job);
  	              });
  	
  	              mount.addEventListener("mousedown",
  	                event => {
  	                  if (event.target === mount) {
  	                    mount.remove();
  	                  }
  	                });
  	
  	              if (appData) {
  	                appData.SelectedLocation = location;
  	                appData.SelectedLocationObjectId = locationId;
  	                appData.SelectedLocationMarker = locationId;
  	              }
  	
  	              refreshEvents();
  	            }
  	
  	            function openLocationCaptureEventForm(rowData) {
  	              if (!rowData || !rowData.location) {
  	                window.alert("No location selected.");
  	                return;
  	              }
  	
  	              const location = rowData.location;
  	              const locationId = safeString(getLocationValue(location)).trim();
  	              const locationLabel = safeString(getLocationLabel(location) || rowData.label || locationId).trim();
  	              const appData = getAppBag();
  	              const company =
  	              rowData.companyEntry?.company ||
  	              rowData.company ||
  	              rowData.companyObject ||
  	              DATA_CHANNEL?.companies?.find(companyItem => {
  	                const companyLocations = flattenLocations(getCompanyLocations(companyItem));
  	                return companyLocations.some(locationItem => {
  	                  return String(getLocationValue(locationItem)) === String(locationId);
  	                });
  	              }) ||
  	              null;
  	
  	              if (!locationId) {
  	                window.alert("Selected location has no objectId.");
  	                return;
  	              }
  	
  	              const MOUNT_ID = "trackit-location-capture-event-form";
  	              const STYLE_ID = "trackit-location-capture-event-form-style";
  	              const TABLE_JOB_ENTRIES = "JobEntries";
  	              const TABLE_LOCATIONS = "Locations";
  	              const LOCATION_JOBS_RELATION_FIELD = "Jobs";
  	
  	              const existing = document.getElementById(MOUNT_ID);
  	
  	              if (existing) {
  	                existing.remove();
  	              }
  	
  	              function toast(message) {
  	                window.alert(message);
  	              }
  	
  	              function deepClone(value) {
  	                try {
  	                  return JSON.parse(JSON.stringify(value));
  	                } catch (_) {
  	                  return value;
  	                }
  	              }
  	
  	              function safeLower(value) {
  	                return safeString(value).trim().toLowerCase();
  	              }
  	
  	              function nowId(prefix) {
  	                return `${prefix || "ID"}_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
  	              }
  	
  	              function todayISO() {
  	                const date = new Date();
  	                const yyyy = date.getFullYear();
  	                const mm = String(date.getMonth() + 1).padStart(2, "0");
  	                const dd = String(date.getDate()).padStart(2, "0");
  	
  	                return `${yyyy}-${mm}-${dd}`;
  	              }
  	
  	              function pickFirstNonEmptyString(object, keys) {
  	                if (!object || typeof object !== "object") return "";
  	
  	                for (let i = 0; i < keys.length; i++) {
  	                  const value = object[keys[i]];
  	
  	                  if (value === undefined || value === null) continue;
  	
  	                  const text = safeString(value).trim();
  	
  	                  if (text) return text;
  	                }
  	
  	                return "";
  	              }
  	
  	              function getIdFromAnyShape(value) {
  	                if (value === undefined || value === null) return "";
  	
  	                if (typeof value === "string" || typeof value === "number") {
  	                  return safeString(value).trim();
  	                }
  	
  	                if (typeof value === "object") {
  	                  return safeString(
  	                    value.LocationId ||
  	                    value.VehicleId ||
  	                    value.ContractorId ||
  	                    value.objectId ||
  	                    value.id ||
  	                    value.ID ||
  	                    value.Id ||
  	                    ""
  	                  ).trim();
  	                }
  	
  	                return "";
  	              }
  	
  	              function getVehiclesArray() {
  	                const user = appData?.User || {};
  	
  	                const list =
  	                company?.Tractors ||
  	                company?.tractors ||
  	                company?.Vehicles ||
  	                company?.vehicles ||
  	                company?.Vehicle ||
  	                company?.vehicle ||
  	                user.Tractors ||
  	                user.tractors ||
  	                user.Vehicles ||
  	                user.vehicles ||
  	                appData?.Tractors ||
  	                appData?.tractors ||
  	                appData?.Vehicles ||
  	                appData?.vehicles ||
  	                [];
  	
  	                FIF_SILENT_CONSOLE.log("[TrackIT Capture Event] Vehicle source:", {
  	                  company,
  	                  count: Array.isArray(list) ? list.length: 0,
  	                  list
  	                });
  	
  	                return Array.isArray(list) ? list.slice(): [];
  	              }
  	
  	              function getContractorsArray() {
  	                const user = appData?.User || {};
  	
  	                const list =
  	                company?.Contractors ||
  	                company?.contractors ||
  	                company?.Contractor ||
  	                company?.contractor ||
  	                user.Contractors ||
  	                user.contractors ||
  	                appData?.Contractors ||
  	                appData?.contractors ||
  	                [];
  	
  	                FIF_SILENT_CONSOLE.log("[TrackIT Capture Event] Contractor source:", {
  	                  company,
  	                  count: Array.isArray(list) ? list.length: 0,
  	                  list
  	                });
  	
  	                return Array.isArray(list) ? list.slice(): [];
  	              }
  	
  	              function vehicleToOption(vehicle) {
  	                if (vehicle === undefined || vehicle === null) return null;
  	
  	                if (typeof vehicle === "string" || typeof vehicle === "number") {
  	                  const text = safeString(vehicle).trim();
  	
  	                  if (!text) return null;
  	
  	                  return {
  	                    id: text,
  	                    label: text,
  	                    raw: null
  	                  };
  	                }
  	
  	                if (typeof vehicle === "object") {
  	                  let id = pickFirstNonEmptyString(vehicle, [
  	                    "VehicleId",
  	                    "TractorId",
  	                    "tractorId",
  	                    "objectId",
  	                    "id",
  	                    "ID",
  	                    "Id"
  	                  ]);
  	
  	                  let label = pickFirstNonEmptyString(vehicle, [
  	                    "Label",
  	                    "Name",
  	                    "name",
  	                    "Display",
  	                    "Registration",
  	                    "registration",
  	                    "Plate",
  	                    "plate",
  	                    "VehicleName",
  	                    "TractorName",
  	                    "tractorName",
  	                    "Title",
  	                    "title"
  	                  ]);
  	
  	                  if (!label) {
  	                    label = pickFirstNonEmptyString(vehicle, [
  	                      "registrationNumber",
  	                      "RegistrationNumber",
  	                      "registration",
  	                      "Registration",
  	                      "plateNumber",
  	                      "PlateNumber",
  	                      "plate",
  	                      "Plate",
  	                      "code",
  	                      "Code"
  	                    ]);
  	                  }
  	
  	                  if (!label) label = id || "(Vehicle)";
  	                  if (!id) id = label;
  	
  	                  return {
  	                    id,
  	                    label,
  	                    raw: vehicle
  	                  };
  	                }
  	
  	                return null;
  	              }
  	
  	              function contractorToOption(contractor) {
  	                if (contractor === undefined || contractor === null) return null;
  	
  	                if (typeof contractor === "string" || typeof contractor === "number") {
  	                  const text = safeString(contractor).trim();
  	
  	                  if (!text) return null;
  	
  	                  return {
  	                    id: text,
  	                    label: text,
  	                    raw: null
  	                  };
  	                }
  	
  	                if (typeof contractor === "object") {
  	                  let id = pickFirstNonEmptyString(contractor, ["ContractorId", "objectId", "id", "ID", "Id"]);
  	                  let label = pickFirstNonEmptyString(contractor, ["Name", "name"]);
  	
  	                  if (!label) {
  	                    label = pickFirstNonEmptyString(contractor, ["Label", "Company", "Display", "ContractorName", "Title"]);
  	                  }
  	
  	                  if (!label) {
  	                    label = pickFirstNonEmptyString(contractor, ["fullName", "contactName", "tradingName"]);
  	                  }
  	
  	                  if (!label) label = id || "(Contractor)";
  	                  if (!id) id = label;
  	
  	                  return {
  	                    id,
  	                    label,
  	                    raw: contractor
  	                  };
  	                }
  	
  	                return null;
  	              }
  	
  	              function buildVehicleOptionsAll() {
  	                return getVehiclesArray().map(vehicleToOption).filter(Boolean);
  	              }
  	
  	              function buildContractorOptionsAll() {
  	                return getContractorsArray().map(contractorToOption).filter(Boolean);
  	              }
  	
  	              function buildContractorIndexById() {
  	                const index = {};
  	
  	                getContractorsArray().forEach(contractor => {
  	                  let id = getIdFromAnyShape(contractor);
  	
  	                  if (!id && typeof contractor === "object") {
  	                    id = pickFirstNonEmptyString(contractor, ["ContractorId", "objectId", "id", "ID", "Id"]);
  	                  }
  	
  	                  if (!id) return;
  	
  	                  index[String(id)] = contractor;
  	                });
  	
  	                return index;
  	              }
  	
  	              function getContractorVehiclesArray(contractor) {
  	                if (!contractor || typeof contractor !== "object") return [];
  	
  	                const list =
  	                Array.isArray(contractor.Vehicles) ? contractor.Vehicles:
  	                Array.isArray(contractor.Tractors) ? contractor.Tractors:
  	                Array.isArray(contractor.VehicleIds) ? contractor.VehicleIds:
  	                Array.isArray(contractor.TractorIds) ? contractor.TractorIds:
  	                [];
  	
  	                return Array.isArray(list) ? list.slice(): [];
  	              }
  	
  	              function buildVehicleOptionsForContractor(contractorId) {
  	                const all = buildVehicleOptionsAll();
  	
  	                if (!contractorId) return all;
  	
  	                const contractorIndex = buildContractorIndexById();
  	                const contractor = contractorIndex[String(contractorId)] || null;
  	
  	                if (!contractor) return all;
  	
  	                const contractorVehicles = getContractorVehiclesArray(contractor);
  	                const allowed = {};
  	
  	                contractorVehicles.forEach(item => {
  	                  let id = getIdFromAnyShape(item);
  	
  	                  if (!id && typeof item === "object") {
  	                    id = pickFirstNonEmptyString(item, ["VehicleId", "objectId", "id", "ID", "Id"]);
  	                  }
  	
  	                  if (!id) return;
  	
  	                  allowed[String(id)] = true;
  	                });
  	
  	                const keys = Object.keys(allowed);
  	
  	                if (!keys.length) return [];
  	
  	                return all.filter(option => {
  	                  return !!allowed[String(option.id)];
  	                });
  	              }
  	
  	              function applicationTypeToString(value) {
  	                if (value === undefined || value === null) return "";
  	
  	                if (typeof value === "string") {
  	                  return safeString(value).trim();
  	                }
  	
  	                if (typeof value === "object") {
  	                  return pickFirstNonEmptyString(value, ["Type", "ApplicationType", "Name", "name", "Label", "Title", "Display"]);
  	                }
  	
  	                return "";
  	              }
  	
  	              function getApplicationTypes() {
  	                let list =
  	                company?.Manifest?.Applications && Array.isArray(company.Manifest.Applications)
  	                ? company.Manifest.Applications: [];
  	
  	                if (!list.length) {
  	                  const user = appData?.User || {};
  	
  	                  if (Array.isArray(user.ApplicationsCatalog)) {
  	                    list = user.ApplicationsCatalog;
  	                  }
  	                }
  	
  	                if (!list.length && Array.isArray(state.uiDraft.Applications)) {
  	                  list = state.uiDraft.Applications
  	                  .map(item => item?.Type || "")
  	                  .filter(Boolean);
  	                }
  	
  	                const seen = {};
  	                const result = [];
  	
  	                list.forEach(item => {
  	                  const type = applicationTypeToString(item);
  	
  	                  if (!type) return;
  	
  	                  const key = safeLower(type);
  	
  	                  if (seen[key]) return;
  	
  	                  seen[key] = true;
  	                  result.push(type);
  	                });
  	
  	                result.sort((a, b) => safeLower(a).localeCompare(safeLower(b)));
  	
  	                return result;
  	              }
  	
  	              function backendlessHasData() {
  	                return !!(
  	                  typeof Backendless !== "undefined" &&
  	                  Backendless &&
  	                  Backendless.Data &&
  	                  typeof Backendless.Data.of === "function"
  	                );
  	              }
  	
  	              function sanitizeForBackendless(value) {
  	                if (value === undefined || value === null) return value;
  	                if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return value;
  	                if (Array.isArray(value)) return value.map(sanitizeForBackendless);
  	
  	                if (typeof value === "object") {
  	                  const output = {};
  	
  	                  Object.keys(value).forEach(key => {
  	                    output[key] = sanitizeForBackendless(value[key]);
  	                  });
  	
  	                  return output;
  	                }
  	
  	                return value;
  	              }
  	
  	              function resolveAppTypeForValidation(application) {
  	                const type = safeString(application?.Type).trim();
  	                const other = safeString(application?.TypeOther).trim();
  	
  	                if (safeLower(type) === "other") return other;
  	
  	                return type;
  	              }
  	
  	              function toBackendlessPayloadFromDraft(draft) {
  	                const clean = sanitizeForBackendless(draft);
  	
  	                if (!Array.isArray(clean.Applications)) clean.Applications = [];
  	
  	                clean.Applications = clean.Applications.map(application => {
  	                  const type = safeString(application?.Type).trim();
  	                  const typeOther = safeString(application?.TypeOther).trim();
  	                  const product = safeString(application?.Product).trim();
  	                  const rateText = safeString(application?.RateText).trim();
  	                  const resolvedType = safeLower(type) === "other" ? typeOther: type;
  	
  	                  return {
  	                    Type: resolvedType,
  	                    Product: product,
  	                    RateText: rateText
  	                  };
  	                }).filter(application => {
  	                  return application.Type && application.Product && application.RateText;
  	                });
  	
  	                return clean;
  	              }
  	
  	              function saveJobEntryRow(payload) {
  	                if (!backendlessHasData()) {
  	                  FIF_SILENT_CONSOLE.warn("[TrackIT Capture Event] Backendless SDK not available.");
  	                  return Promise.resolve({
  	                    ok: false,
  	                    reason: "Backendless missing"
  	                  });
  	                }
  	
  	                return Backendless.Data.of(TABLE_JOB_ENTRIES).save(payload)
  	                .then(saved => {
  	                  return {
  	                    ok: true,
  	                    saved
  	                  };
  	                })
  	                .catch(error => {
  	                  return {
  	                    ok: false,
  	                    reason: error?.message || error?.faultString || "Save failed",
  	                    error
  	                  };
  	                });
  	              }
  	
  	              function linkJobToLocationJobsRelation(savedJob) {
  	                if (!backendlessHasData()) {
  	                  return Promise.resolve({
  	                    ok: true,
  	                    linked: false,
  	                    reason: "Backendless missing"
  	                  });
  	                }
  	
  	                const jobObjectId = safeString(savedJob?.objectId).trim();
  	
  	                if (!jobObjectId) {
  	                  return Promise.resolve({
  	                    ok: true,
  	                    linked: false,
  	                    reason: "Saved job missing objectId"
  	                  });
  	                }
  	
  	                const locationStore = Backendless.Data.of(TABLE_LOCATIONS);
  	
  	                if (!locationStore || typeof locationStore.addRelation !== "function") {
  	                  return Promise.resolve({
  	                    ok: true,
  	                    linked: false,
  	                    reason: "No addRelation method"
  	                  });
  	                }
  	
  	                return locationStore.addRelation(
  	                  {
  	                    objectId: locationId
  	                  },
  	                  LOCATION_JOBS_RELATION_FIELD,
  	                  [{
  	                    objectId: jobObjectId
  	                  }]
  	                ).then(result => {
  	                    return {
  	                      ok: true,
  	                      linked: true,
  	                      method: "addRelation",
  	                      result
  	                    };
  	                  }).catch(error => {
  	                    FIF_SILENT_CONSOLE.warn("[TrackIT Capture Event] Relation link failed.", error);
  	
  	                    return {
  	                      ok: true,
  	                      linked: false,
  	                      reason: "addRelation failed",
  	                      error
  	                    };
  	                  });
  	              }
  	
  	              function injectStylesOnce() {
  	                if (document.getElementById(STYLE_ID)) return;
  	
  	                const style = document.createElement("style");
  	                style.id = STYLE_ID;
  	                style.textContent = `
  	                #${MOUNT_ID} {
  	                position: fixed;
  	                inset: 0;
  	                z-index: 2147483647;
  	                overflow: auto;
  	                background: rgba(0,0,0,0.85);
  	                padding: 10px;
  	                box-sizing: border-box;
  	                }
  	
  	                #${MOUNT_ID} .jef-root {
  	                font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  	                padding: 12px;
  	                box-sizing: border-box;
  	                color: #f0f0f0;
  	                max-width: 900px;
  	                margin: 0 auto;
  	                }
  	
  	                #${MOUNT_ID} .jef-card {
  	                border: 1px solid #333;
  	                border-radius: 14px;
  	                background: rgba(16,16,16,0.94);
  	                padding: 12px;
  	                box-sizing: border-box;
  	                }
  	
  	                #${MOUNT_ID} .jef-header {
  	                display: flex;
  	                align-items: flex-start;
  	                justify-content: space-between;
  	                gap: 10px;
  	                flex-wrap: wrap;
  	                }
  	
  	                #${MOUNT_ID} .jef-title {
  	                font-size: 1.05rem;
  	                font-weight: 900;
  	                color: #fff;
  	                margin: 0;
  	                }
  	
  	                #${MOUNT_ID} .jef-sub {
  	                font-size: 0.78rem;
  	                color: #b0b0b0;
  	                margin-top: 2px;
  	                }
  	
  	                #${MOUNT_ID} .jef-badge {
  	                font-size: 0.72rem;
  	                padding: 4px 10px;
  	                border-radius: 999px;
  	                background: #2a2f38;
  	                color: #d2d7de;
  	                white-space: nowrap;
  	                }
  	
  	                #${MOUNT_ID} .jef-divider {
  	                height: 1px;
  	                background: #2a2a2a;
  	                margin: 12px 0;
  	                }
  	
  	                #${MOUNT_ID} .jef-grid {
  	                display: grid;
  	                grid-template-columns: 1fr;
  	                gap: 10px;
  	                }
  	
  	                #${MOUNT_ID} .jef-label {
  	                font-size: 0.8rem;
  	                color: #c9c9c9;
  	                margin-bottom: 4px;
  	                font-weight: 700;
  	                }
  	
  	                #${MOUNT_ID} .jef-input,
  	                #${MOUNT_ID} .jef-select {
  	                width: 100%;
  	                padding: 10px 12px;
  	                border-radius: 10px;
  	                border: 1px solid #444;
  	                background: #262626;
  	                color: #e8e8e8;
  	                outline: none;
  	                font-size: 0.95rem;
  	                box-sizing: border-box;
  	                }
  	
  	                #${MOUNT_ID} .jef-input:focus,
  	                #${MOUNT_ID} .jef-select:focus {
  	                border-color: #CC6633;
  	                box-shadow: 0 0 0 1px #CC6633;
  	                }
  	
  	                #${MOUNT_ID} .jef-row {
  	                display: flex;
  	                gap: 8px;
  	                align-items: center;
  	                flex-wrap: wrap;
  	                }
  	
  	                #${MOUNT_ID} .jef-actions {
  	                display: flex;
  	                align-items: center;
  	                justify-content: flex-end;
  	                gap: 8px;
  	                flex-wrap: wrap;
  	                margin-top: 10px;
  	                }
  	
  	                #${MOUNT_ID} .jef-btn {
  	                border-radius: 999px;
  	                border: 1px solid #555;
  	                background: #333;
  	                color: #e0e0e0;
  	                font-size: 0.85rem;
  	                padding: 8px 12px;
  	                cursor: pointer;
  	                user-select: none;
  	                white-space: nowrap;
  	                }
  	
  	                #${MOUNT_ID} .jef-btn:hover {
  	                background: #3c3c3c;
  	                }
  	
  	                #${MOUNT_ID} .jef-btn-primary {
  	                background: #CC6633;
  	                border-color: #CC6633;
  	                color: #fff;
  	                }
  	
  	                #${MOUNT_ID} .jef-btn-primary:hover {
  	                background: #e0733a;
  	                border-color: #e0733a;
  	                }
  	
  	                #${MOUNT_ID} .jef-btn-danger {
  	                background: #4a2020;
  	                border-color: #aa4444;
  	                color: #ffcccc;
  	                }
  	
  	                #${MOUNT_ID} .jef-btn-danger:hover {
  	                background: #5c2626;
  	                }
  	
  	                #${MOUNT_ID} .jef-btn-disabled {
  	                opacity: 0.55;
  	                cursor: not-allowed;
  	                }
  	
  	                #${MOUNT_ID} .jef-list {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 10px;
  	                margin-top: 10px;
  	                }
  	
  	                #${MOUNT_ID} .jef-app-row {
  	                border: 1px solid #3a3a3a;
  	                background: #1f1f1f;
  	                border-radius: 14px;
  	                padding: 10px;
  	                display: flex;
  	                flex-direction: column;
  	                gap: 8px;
  	                }
  	
  	                #${MOUNT_ID} .jef-app-grid {
  	                display: grid;
  	                grid-template-columns: 220px 1fr 220px;
  	                gap: 8px;
  	                align-items: end;
  	                }
  	
  	                #${MOUNT_ID} .jef-app-grid-2 {
  	                display: grid;
  	                grid-template-columns: 220px 1fr;
  	                gap: 8px;
  	                align-items: end;
  	                }
  	
  	                #${MOUNT_ID} .jef-app-actions {
  	                display: flex;
  	                justify-content: flex-end;
  	                gap: 8px;
  	                flex-wrap: wrap;
  	                }
  	
  	                #${MOUNT_ID} .jef-empty {
  	                color: #a0a4aa;
  	                font-size: 0.95rem;
  	                padding: 10px 2px;
  	                }
  	
  	                #${MOUNT_ID} .jef-readonly {
  	                width: 100%;
  	                padding: 10px 12px;
  	                border-radius: 10px;
  	                border: 1px solid #444;
  	                background: #1f1f1f;
  	                color: #e8e8e8;
  	                font-size: 0.95rem;
  	                box-sizing: border-box;
  	                }
  	
  	                @media (max-width: 720px) {
  	                #${MOUNT_ID} .jef-app-grid,
  	                #${MOUNT_ID} .jef-app-grid-2 {
  	                grid-template-columns: 1fr;
  	                }
  	                }
  	                `;
  	
  	                document.head.appendChild(style);
  	              }
  	
  	              function createInitialDraft() {
  	                return {
  	                  DraftId: nowId("DRAFT"),
  	                  DateISO: todayISO(),
  	                  LocationId: locationId,
  	                  LocationLabel: locationLabel,
  	                  VehicleId: "",
  	                  VehicleLabel: "",
  	                  ContractorId: "",
  	                  ContractorLabel: "",
  	                  Applications: []
  	                };
  	              }
  	
  	              function validate(uiDraft) {
  	                const problems = [];
  	
  	                if (!uiDraft.DateISO) problems.push("Date is required.");
  	                if (!uiDraft.LocationId) problems.push("Location is required.");
  	                if (!uiDraft.VehicleId) problems.push("Vehicle is required.");
  	
  	                const applications = Array.isArray(uiDraft.Applications) ? uiDraft.Applications: [];
  	
  	                if (!applications.length) {
  	                  problems.push("Add at least one application.");
  	                }
  	
  	                applications.forEach((application, index) => {
  	                  const type = resolveAppTypeForValidation(application);
  	                  const product = safeString(application?.Product).trim();
  	                  const rate = safeString(application?.RateText).trim();
  	
  	                  if (!type) problems.push(`Application #${index + 1} needs an Application Type.`);
  	                  if (!product) problems.push(`Application #${index + 1} needs a Product.`);
  	                  if (!rate) problems.push(`Application #${index + 1} needs a Rate.`);
  	                });
  	
  	                return problems;
  	              }
  	
  	              const state = {
  	                uiDraft: createInitialDraft(),
  	                isSaving: false,
  	                dirty: false,
  	                status: "Ready"
  	              };
  	
  	              function markDirty() {
  	                state.dirty = true;
  	                state.status = "Unsaved changes";
  	              }
  	
  	              function resetDraftAfterSave() {
  	                state.uiDraft = createInitialDraft();
  	                state.dirty = false;
  	                state.status = "Saved";
  	              }
  	
  	              function addApplicationRow() {
  	                markDirty();
  	
  	                if (!Array.isArray(state.uiDraft.Applications)) {
  	                  state.uiDraft.Applications = [];
  	                }
  	
  	                state.uiDraft.Applications.push({
  	                  Type: "",
  	                  TypeOther: "",
  	                  Product: "",
  	                  RateText: ""
  	                });
  	
  	                render();
  	              }
  	
  	              function removeApplicationRow(index) {
  	                if (!Array.isArray(state.uiDraft.Applications)) return;
  	                if (!state.uiDraft.Applications[index]) return;
  	
  	                markDirty();
  	                state.uiDraft.Applications.splice(index, 1);
  	                render();
  	              }
  	
  	              function setApplicationField(index, field, value) {
  	                if (!Array.isArray(state.uiDraft.Applications)) return;
  	                if (!state.uiDraft.Applications[index]) return;
  	
  	                markDirty();
  	                state.uiDraft.Applications[index][field] = safeString(value);
  	
  	                if (field === "Type" && safeLower(state.uiDraft.Applications[index].Type) !== "other") {
  	                  state.uiDraft.Applications[index].TypeOther = "";
  	                }
  	
  	                render();
  	              }
  	
  	              function saveNow() {
  	                if (state.isSaving) return;
  	
  	                state.uiDraft.LocationId = locationId;
  	                state.uiDraft.LocationLabel = locationLabel;
  	
  	                const problems = validate(state.uiDraft);
  	
  	                if (problems.length) {
  	                  toast(`Fix these before saving:\n\n- ${problems.join("\n- ")}`);
  	                  return;
  	                }
  	
  	                state.isSaving = true;
  	                state.status = "Saving...";
  	                render();
  	
  	                const payload = toBackendlessPayloadFromDraft(state.uiDraft);
  	
  	                payload.LocationId = locationId;
  	                payload.LocationLabel = locationLabel;
  	
  	                if (appData) {
  	                  if (!appData.User) appData.User = {};
  	                  appData.User.JobEntryDraft = deepClone(payload);
  	                }
  	
  	                return saveJobEntryRow(payload).then(result => {
  	                  if (!result || !result.ok) {
  	                    state.status = "Backend save failed";
  	                    state.isSaving = false;
  	                    render();
  	                    toast(`Backend save failed: ${result?.reason || "Unknown"}`);
  	                    return result;
  	                  }
  	
  	                  return linkJobToLocationJobsRelation(result.saved).then(linkResult => {
  	                    state.isSaving = false;
  	                    resetDraftAfterSave();
  	                    render();
  	
  	                    try {
  	                      if (typeof refreshEvents === "function") {
  	                        refreshEvents();
  	                      }
  	                    } catch (_) {}
  	
  	                    return {
  	                      ok: true,
  	                      saved: result.saved,
  	                      linked: !!linkResult?.linked,
  	                      link: linkResult || null
  	                    };
  	                  });
  	                });
  	              }
  	
  	              function render() {
  	                const mount = document.getElementById(MOUNT_ID);
  	
  	                if (!mount) return;
  	
  	                mount.innerHTML = "";
  	
  	                const badgeText = state.isSaving ? "Saving...": state.dirty ? "Unsaved changes": state.status || "Ready";
  	                const contractorOptions = buildContractorOptionsAll();
  	                const vehicleOptions = buildVehicleOptionsForContractor(state.uiDraft.ContractorId);
  	                const typeOptions = getApplicationTypes();
  	                const applications = Array.isArray(state.uiDraft.Applications) ? state.uiDraft.Applications: [];
  	                const TYPE_OTHER_LABEL = "Other";
  	
  	                mount.innerHTML = `
  	                <div class="jef-root">
  	                <div class="jef-card">
  	                <div class="jef-row" style="justify-content:flex-end;">
  	                <button class="jef-btn" type="button" data-jef-close>✖ Close</button>
  	                </div>
  	
  	                <div class="jef-header">
  	                <div>
  	                <div class="jef-title">Job Entry</div>
  	                <div class="jef-sub">${escapeHtml(locationLabel || locationId)}</div>
  	                </div>
  	
  	                <div class="jef-badge">${escapeHtml(badgeText)}</div>
  	                </div>
  	
  	                <div class="jef-divider"></div>
  	
  	                <div class="jef-grid">
  	                <div>
  	                <div class="jef-label">Date</div>
  	                <input class="jef-input" type="date" value="${escapeHtml(state.uiDraft.DateISO || todayISO())}" data-jef-date />
  	                </div>
  	
  	                <div>
  	                <div class="jef-label">Location</div>
  	                <div class="jef-readonly">${escapeHtml(locationLabel || locationId || "(No Location)")}</div>
  	                </div>
  	
  	                <div>
  	                <div class="jef-label">Contractor (optional)</div>
  	                <select class="jef-select" data-jef-contractor>
  	                <option value="">-- Select Contractor (optional) --</option>
  	                ${contractorOptions.map(option => {
  	                  return `
  	                  <option value="${escapeHtml(option.id)}" ${String(state.uiDraft.ContractorId || "") === String(option.id) ? "selected": ""}>
  	                  ${escapeHtml(option.label)}
  	                  </option>
  	                  `;
  	                }).join("")}
  	                </select>
  	                </div>
  	
  	                <div>
  	                <div class="jef-label">Vehicle</div>
  	                <select class="jef-select" data-jef-vehicle>
  	                <option value="">-- Select Vehicle --</option>
  	                ${vehicleOptions.map(option => {
  	                  return `
  	                  <option value="${escapeHtml(option.id)}" ${String(state.uiDraft.VehicleId || "") === String(option.id) ? "selected": ""}>
  	                  ${escapeHtml(option.label)}
  	                  </option>
  	                  `;
  	                }).join("")}
  	                </select>
  	                </div>
  	                </div>
  	
  	                <div class="jef-divider"></div>
  	
  	                <div class="jef-row">
  	                <button class="jef-btn jef-btn-primary ${state.isSaving ? "jef-btn-disabled": ""}" type="button" data-jef-add ${state.isSaving ? "disabled": ""}>
  	                + Add Application
  	                </button>
  	                </div>
  	
  	                <div class="jef-list">
  	                ${
  	                applications.length
  	                ? applications.map((application, index) => {
  	                  const typeValue = safeString(application.Type).trim();
  	
  	                  return `
  	                  <div class="jef-app-row" data-jef-app-index="${index}">
  	                  <div class="jef-app-grid">
  	                  <div>
  	                  <div class="jef-label">Application Type</div>
  	                  <select class="jef-select" data-jef-app-type="${index}" ${state.isSaving ? "disabled": ""}>
  	                  <option value="">-- Select Type --</option>
  	                  ${typeOptions.map(type => {
  	                    return `
  	                    <option value="${escapeHtml(type)}" ${String(typeValue) === String(type) ? "selected": ""}>
  	                    ${escapeHtml(type)}
  	                    </option>
  	                    `;
  	                  }).join("")}
  	                  <option value="${TYPE_OTHER_LABEL}" ${typeValue === TYPE_OTHER_LABEL ? "selected": ""}>${TYPE_OTHER_LABEL}</option>
  	                  </select>
  	                  </div>
  	
  	                  <div>
  	                  <div class="jef-label">Product</div>
  	                  <input
  	                  class="jef-input"
  	                  type="text"
  	                  value="${escapeHtml(application.Product || "")}"
  	                  placeholder="e.g. Calcitic Lime"
  	                  data-jef-app-product="${index}"
  	                  ${state.isSaving ? "disabled": ""}
  	                  />
  	                  </div>
  	
  	                  <div>
  	                  <div class="jef-label">Rate</div>
  	                  <input
  	                  class="jef-input"
  	                  type="text"
  	                  value="${escapeHtml(application.RateText || "")}"
  	                  placeholder="e.g. 200 kg/ha"
  	                  data-jef-app-rate="${index}"
  	                  ${state.isSaving ? "disabled": ""}
  	                  />
  	                  </div>
  	                  </div>
  	
  	                  ${
  	                  safeLower(application.Type) === safeLower(TYPE_OTHER_LABEL)
  	                  ? `
  	                  <div class="jef-app-grid-2">
  	                  <div>
  	                  <div class="jef-label">Type (Other)</div>
  	                  <input
  	                  class="jef-input"
  	                  type="text"
  	                  value="${escapeHtml(application.TypeOther || "")}"
  	                  placeholder="Type your application type"
  	                  data-jef-app-other="${index}"
  	                  ${state.isSaving ? "disabled": ""}
  	                  />
  	                  </div>
  	                  <div></div>
  	                  </div>
  	                  `: ""
  	                  }
  	
  	                  <div class="jef-app-actions">
  	                  <button class="jef-btn jef-btn-danger ${state.isSaving ? "jef-btn-disabled": ""}" type="button" data-jef-remove="${index}" ${state.isSaving ? "disabled": ""}>
  	                  Remove
  	                  </button>
  	                  </div>
  	                  </div>
  	                  `;
  	                }).join(""): `<div class="jef-empty">No applications yet. Click “+ Add Application”.</div>`
  	                }
  	                </div>
  	
  	                <div class="jef-divider"></div>
  	
  	                <div class="jef-actions">
  	                <button class="jef-btn jef-btn-primary ${(!state.dirty || state.isSaving) ? "jef-btn-disabled": ""}" type="button" data-jef-save ${(!state.dirty || state.isSaving) ? "disabled": ""}>
  	                Save
  	                </button>
  	                </div>
  	                </div>
  	                </div>
  	                `;
  	
  	                bindFormEvents(mount, contractorOptions, vehicleOptions);
  	              }
  	
  	              function bindFormEvents(mount, contractorOptions, vehicleOptions) {
  	                const closeButton = mount.querySelector("[data-jef-close]");
  	                const dateInput = mount.querySelector("[data-jef-date]");
  	                const contractorSelect = mount.querySelector("[data-jef-contractor]");
  	                const vehicleSelect = mount.querySelector("[data-jef-vehicle]");
  	                const addButton = mount.querySelector("[data-jef-add]");
  	                const saveButton = mount.querySelector("[data-jef-save]");
  	
  	                closeButton?.addEventListener("click", () => {
  	                  mount.remove();
  	                });
  	
  	                dateInput?.addEventListener("input", () => {
  	                  markDirty();
  	                  state.uiDraft.DateISO = dateInput.value || "";
  	                  render();
  	                });
  	
  	                contractorSelect?.addEventListener("change", () => {
  	                  markDirty();
  	
  	                  state.uiDraft.ContractorId = contractorSelect.value || "";
  	
  	                  const picked = contractorOptions.find(option => {
  	                    return String(option.id) === String(state.uiDraft.ContractorId);
  	                  });
  	
  	                  state.uiDraft.ContractorLabel = picked ? picked.label: "";
  	
  	                  const filteredVehicles = buildVehicleOptionsForContractor(state.uiDraft.ContractorId);
  	                  const stillAllowed = filteredVehicles.some(vehicle => {
  	                    return String(vehicle.id) === String(state.uiDraft.VehicleId || "");
  	                  });
  	
  	                  if (!stillAllowed) {
  	                    state.uiDraft.VehicleId = "";
  	                    state.uiDraft.VehicleLabel = "";
  	                  }
  	
  	                  render();
  	                });
  	
  	                vehicleSelect?.addEventListener("change",
  	                  () => {
  	                    markDirty();
  	
  	                    state.uiDraft.VehicleId = vehicleSelect.value || "";
  	
  	                    const picked = vehicleOptions.find(option => {
  	                      return String(option.id) === String(state.uiDraft.VehicleId);
  	                    });
  	
  	                    state.uiDraft.VehicleLabel = picked ? picked.label: "";
  	
  	                    render();
  	                  });
  	
  	                addButton?.addEventListener("click",
  	                  () => {
  	                    addApplicationRow();
  	                  });
  	
  	                saveButton?.addEventListener("click",
  	                  () => {
  	                    saveNow();
  	                  });
  	
  	                mount.querySelectorAll("[data-jef-remove]").forEach(button => {
  	                  button.addEventListener("click", () => {
  	                    removeApplicationRow(Number(button.getAttribute("data-jef-remove")));
  	                  });
  	                });
  	
  	                mount.querySelectorAll("[data-jef-app-type]").forEach(input => {
  	                  input.addEventListener("change", () => {
  	                    setApplicationField(Number(input.getAttribute("data-jef-app-type")), "Type", input.value || "");
  	                  });
  	                });
  	
  	                mount.querySelectorAll("[data-jef-app-product]").forEach(input => {
  	                  input.addEventListener("change", () => {
  	                    setApplicationField(Number(input.getAttribute("data-jef-app-product")), "Product", input.value || "");
  	                  });
  	                });
  	
  	                mount.querySelectorAll("[data-jef-app-rate]").forEach(input => {
  	                  input.addEventListener("change", () => {
  	                    setApplicationField(Number(input.getAttribute("data-jef-app-rate")), "RateText", input.value || "");
  	                  });
  	                });
  	
  	                mount.querySelectorAll("[data-jef-app-other]").forEach(input => {
  	                  input.addEventListener("change", () => {
  	                    setApplicationField(Number(input.getAttribute("data-jef-app-other")), "TypeOther", input.value || "");
  	                  });
  	                });
  	              }
  	
  	              injectStylesOnce();
  	
  	              const mount = document.createElement("div");
  	              mount.id = MOUNT_ID;
  	              document.body.appendChild(mount);
  	
  	              if (appData) {
  	                appData.SelectedLocation = location;
  	                appData.SelectedLocationObjectId = locationId;
  	                appData.SelectedLocationMarker = locationId;
  	              }
  	
  	              render();
  	            }
  	
  	            function handleCardAction(action) {
  	              const rowData = actionCard.__cardRowData || selectedRowData;
  	
  	              if (!rowData) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] No selected row for card action:", action);
  	                return;
  	              }
  	
  	              if (action === "edit") {
  	                openLocationEditCard(rowData);
  	                return;
  	              }
  	
  	              if (action === "saveEdit") {
  	                saveLocationEditCard(rowData);
  	                return;
  	              }
  	
  	              if (action === "undoEdit") {
  	                undoLocationEditCard(rowData);
  	                return;
  	              }
  	
  	              if (action === "deleteLocation") {
  	                deleteLocationEditCard(rowData);
  	                return;
  	              }
  	
  	              if (action === "confirmDeleteLocation") {
  	                confirmDeleteLocationFromCard();
  	                return;
  	              }
  	
  	              if (action === "cancelDeleteLocation") {
  	                cancelDeleteLocationConfirm();
  	                return;
  	              }
  	
  	              if (action === "editShape") {
  	                beginShapeEdit(rowData);
  	                return;
  	              }
  	
  	              if (action === "saveShapeEdit") {
  	                saveShapeEdit(rowData);
  	                return;
  	              }
  	
  	              if (action === "cancelShapeEdit") {
  	                cancelShapeEdit(rowData);
  	                return;
  	              }
  	
  	              if (action === "setEntrance") {
  	                setEntrancePlaceholder(rowData);
  	                return;
  	              }
  	
  	              if (action === "saveEntranceEdit") {
  	                saveEntranceEdit(rowData);
  	                return;
  	              }
  	
  	              if (action === "cancelEntranceEdit") {
  	                cancelEntranceEdit(rowData);
  	                return;
  	              }
  	
  	              if (action === "viewEvents") {
  	                openLocationEventsManager(rowData);
  	                return;
  	              }
  	
  	              if (action === "captureEvent") {
  	                openLocationCaptureEventForm(rowData);
  	                return;
  	              }
  	
  	              if (action === "generateSegments") {
  	                generateTemporarySegmentationForCard(rowData).catch(error => {
  	                  FIF_SILENT_CONSOLE.warn("[TrackIT Segmentation] Generate failed.", error);
  	                });
  	                return;
  	              }
  	
  	              if (action === "saveSegments") {
  	                saveTemporarySegmentationForCard(rowData).catch(error => {
  	                  FIF_SILENT_CONSOLE.warn("[TrackIT Segmentation] Save failed.", error);
  	                });
  	                return;
  	              }
  	
  	              if (action === "toggleSegments") {
  	                toggleCardSegmentsVisible(rowData);
  	                return;
  	              }
  	
  	              if (action === "clearSegments") {
  	                clearTemporarySegmentationForCard(rowData).catch(error => {
  	                  FIF_SILENT_CONSOLE.warn("[TrackIT Segmentation] Clear failed.", error);
  	                });
  	                return;
  	              }
  	
  	
  	              if (action === "setFunctionality") {
  	                openOriginalFunctionalityPopupFromCard(rowData);
  	                return;
  	              }
  	
  	              if (action === "saveFunctionality") {
  	                saveLocationFunctionalityCard(rowData);
  	                return;
  	              }
  	
  	              if (action === "functionalityHelp") {
  	                const button = event?.target?.closest?.("[data-card-action='functionalityHelp']");
  	                return;
  	              }
  	
  	              const eventMap = {
  	                dataCard: ROUTER_EVENTS.dataCardRequested,
  	                children: ROUTER_EVENTS.childrenRequested,
  	                functionality: ROUTER_EVENTS.functionalityRequested,
  	                edit: ROUTER_EVENTS.editRequested
  	              };
  	
  	              const eventName = eventMap[action];
  	
  	              FIF_SILENT_CONSOLE.groupCollapsed(`[TrackIT Location Dropdown] Placeholder Action: ${action}`);
  	              FIF_SILENT_CONSOLE.log("Location:", rowData.location);
  	              FIF_SILENT_CONSOLE.log("Row Data:", rowData);
  	              FIF_SILENT_CONSOLE.log("Event:", eventName || "");
  	              FIF_SILENT_CONSOLE.groupEnd();
  	
  	              if (eventName) {
  	                emitRouterEvent(eventName, rowData, {
  	                  action,
  	                  placeholder: true
  	                });
  	              }
  	
  	              if (action === "edit" && SEARCH_ACTION_MODE === "open-panel") {
  	                openLocationPanelAndFocusMap(rowData.location, MapRoot);
  	              }
  	            }
  	
  	            function routeSelectedLocation(rowData, mapFocused) {
  	              if (!rowData) return;
  	
  	              emitRouterEvent(ROUTER_EVENTS.selected, rowData, {
  	                mapFocused
  	              });
  	
  	              if (SEARCH_ACTION_MODE === "select-only") {
  	                return;
  	              }
  	
  	              if (SEARCH_ACTION_MODE === "open-panel") {
  	                openLocationPanelAndFocusMap(rowData.location, MapRoot);
  	                return;
  	              }
  	
  	              openLocationActionCard(rowData);
  	            }
  	
  	            function runLocationSelectionPipeline(rowData) {
  	              if (!rowData) return;
  	
  	              if (isShapeEditActive()) {
  	                flashActiveShapeEditLock("Shape editing is active. Save or cancel before selecting another location.");
  	                return;
  	              }
  	
  	              const location = rowData.location;
  	
  	              writeSelectedLocationToAppData(location);
  	
  	              const mapFocused = focusMapForSelectedLocation(location);
  	
  	              emitChange(rowData);
  	
  	              routeSelectedLocation(rowData, mapFocused);
  	            }
  	
  	            function getMapClickLocationId(locationOrId) {
  	              if (locationOrId === undefined || locationOrId === null) return "";
  	
  	              if (typeof locationOrId === "string" || typeof locationOrId === "number") {
  	                return String(locationOrId).trim();
  	              }
  	
  	              return safeString(getLocationValue(locationOrId)).trim();
  	            }
  	
  	            function findRowDataForMapClickedLocation(locationOrId) {
  	              const id = getMapClickLocationId(locationOrId);
  	
  	              if (!id) return null;
  	
  	              return (
  	                flatRows.find(row => String(row.value) === String(id)) ||
  	                flatRows.find(row => String(getLocationValue(row.location)) === String(id)) ||
  	                null
  	              );
  	            }
  	
  	            function openLocationCardFromMapClick(locationOrId, options) {
  	
  	              if (isEntranceEditActive()) {
  	                if (typeof window !== "undefined" && typeof window.__TrackITHandleEntranceEditMapClick === "function") {
  	                  const handled = window.__TrackITHandleEntranceEditMapClick({
  	                    map: options?.map || getEntranceEditMap(activeEntranceEditSession?.rowData),
  	                    point: options?.point || null,
  	                    locationOrId,
  	                    source: "location-map-click"
  	                  });
  	
  	                  return !!handled;
  	                }
  	
  	                return false;
  	              }
  	              if (isShapeEditActive()) {
  	                flashActiveShapeEditLock("Shape editing is active. Save or cancel before clicking another location.");
  	                return false;
  	              }
  	
  	              const rowData = findRowDataForMapClickedLocation(locationOrId);
  	
  	              if (!rowData) {
  	                FIF_SILENT_CONSOLE.warn("[TrackIT Location Dropdown] Could not find card row for map-clicked location.", {
  	                  locationOrId,
  	                  options,
  	                  flatRows
  	                });
  	
  	                return false;
  	              }
  	
  	              try {
  	                closeDropdown();
  	              } catch (_) {}
  	
  	              try {
  	                closeActionCard();
  	              } catch (_) {}
  	
  	              paintSelectedRow(rowData, false);
  	              writeSelectedLocationToAppData(rowData.location);
  	              emitChange(rowData);
  	
  	              openLocationActionCard(rowData);
  	
  	              emitRouterEvent(ROUTER_EVENTS.selected, rowData, {
  	                mapFocused: true,
  	                source: "trackit-location-map-click"
  	              });
  	
  	              return true;
  	            }
  	
  	            if (typeof window !== "undefined") {
  	              window.__TrackITOpenLocationCardFromMap = openLocationCardFromMapClick;
  	            }
  	
  	            // ============================================================
  	            // Rendering
  	            // ============================================================
  	
  	            function renderCompanyHeader(companyEntry, collapsed) {
  	              const header = document.createElement("div");
  	              header.className = "trackit-company-header";
  	
  	              if (collapsed) header.classList.add("collapsed");
  	
  	              const title = document.createElement("div");
  	              title.className = "trackit-company-title";
  	              title.textContent = companyEntry.label;
  	
  	              const meta = document.createElement("div");
  	              meta.className = "trackit-company-meta";
  	
  	              const caret = document.createElement("span");
  	              caret.className = "trackit-company-caret";
  	
  	              meta.appendChild(caret);
  	
  	              header.appendChild(title);
  	              header.appendChild(meta);
  	
  	              header.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleCompanyGroup(companyEntry);
  	              });
  	
  	              menu.appendChild(header);
  	            }
  	
  	            function renderCollapsedCompanyNote(companyEntry) {
  	              const collapsedNote = document.createElement("div");
  	              collapsedNote.className = "trackit-company-collapsed-note";
  	              collapsedNote.textContent = "";
  	
  	              collapsedNote.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleCompanyGroup(companyEntry);
  	              });
  	
  	              menu.appendChild(collapsedNote);
  	            }
  	
  	            function renderTypeGroupHeader(typeGroup, collapsed) {
  	              const header = document.createElement("div");
  	              header.className = "trackit-type-group-header";
  	
  	              if (collapsed) header.classList.add("collapsed");
  	
  	              const title = document.createElement("div");
  	              title.className = "trackit-type-group-title";
  	              title.textContent = typeGroup.label;
  	
  	              const meta = document.createElement("div");
  	              meta.className = "trackit-type-group-meta";
  	              meta.textContent = String(typeGroup.nodes.length);
  	
  	              const caret = document.createElement("span");
  	              caret.className = "trackit-type-group-caret";
  	
  	              header.appendChild(title);
  	              header.appendChild(meta);
  	              header.appendChild(caret);
  	
  	              header.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleTypeGroup(typeGroup.key);
  	              });
  	
  	              menu.appendChild(header);
  	            }
  	
  	            function renderCollapsedTypeGroupNote(typeGroup) {
  	              const collapsedNote = document.createElement("div");
  	              collapsedNote.className = "trackit-type-group-collapsed-note";
  	              collapsedNote.textContent = "";
  	
  	              collapsedNote.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleTypeGroup(typeGroup.key);
  	              });
  	
  	              menu.appendChild(collapsedNote);
  	            }
  	
  	            function refreshDropdownLayoutAfterTreeChange() {
  	              function runResizePass() {
  	                try {
  	                  if (typeof scheduleHubAndMenuResize === "function") {
  	                    scheduleHubAndMenuResize();
  	                  }
  	
  	                  if (typeof updateMenuHeightToBottom === "function") {
  	                    updateMenuHeightToBottom();
  	                  }
  	
  	                  if (typeof notifyCarvedShellLayout === "function") {
  	                    notifyCarvedShellLayout();
  	                  }
  	
  	                  try {
  	                    const bridge = window.__CarvedEdgeShapeDropdownBridge;
  	
  	                    if (bridge && typeof bridge.resizeTopShell === "function") {
  	                      bridge.resizeTopShell();
  	                    }
  	                  } catch (_) {}
  	                } catch (_) {}
  	              }
  	
  	              try {
  	                runResizePass();
  	
  	                requestAnimationFrame(runResizePass);
  	
  	                setTimeout(runResizePass, 40);
  	                setTimeout(runResizePass, 120);
  	                setTimeout(runResizePass, 260);
  	              } catch (_) {}
  	            }
  	
  	            function activateLocationRow(rowData,
  	              searchMode) {
  	              if (!rowData) return;
  	
  	              const hasChildren = hasAnyNodes(rowData.childrenNodes);
  	
  	              const isCollapsed =
  	              !searchMode &&
  	              hasChildren &&
  	              root.__trackitCollapsedLocationTree[rowData.key] === true;
  	
  	              if (hasChildren && isCollapsed) {
  	                root.__trackitCollapsedLocationTree[rowData.key] = false;
  	
  	                renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	                openDropdown();
  	                refreshDropdownLayoutAfterTreeChange();
  	
  	                return;
  	              }
  	
  	              paintSelectedRow(rowData, true);
  	              closeDropdown();
  	            }
  	
  	            function renderLocationRow(rowData, searchMode) {
  	              const rowIndex = visibleRows.length;
  	              visibleRows.push(rowData);
  	
  	              const row = document.createElement("div");
  	              row.className = "trackit-location-item";
  	              row.__locationValue = rowData.value;
  	              row.__rowIndex = rowIndex;
  	
  	              row.style.paddingLeft = `${22 + rowData.depth * 17}px`;
  	
  	              if (selectedValue && rowData.value === selectedValue) {
  	                row.classList.add("selected");
  	              }
  	
  	              const hasChildren = hasAnyNodes(rowData.childrenNodes);
  	              const collapsed =
  	              !searchMode &&
  	              hasChildren &&
  	              root.__trackitCollapsedLocationTree[rowData.key] === true;
  	
  	              const caretHit = document.createElement("span");
  	              caretHit.className = "trackit-location-caret-hit";
  	
  	              if (hasChildren) {
  	                const caret = document.createElement("span");
  	                caret.className = "trackit-location-caret";
  	
  	                if (collapsed) {
  	                  caret.classList.add("collapsed");
  	                }
  	
  	                caretHit.appendChild(caret);
  	
  	                caretHit.addEventListener("mousedown", function (event) {
  	                  event.preventDefault();
  	                  event.stopPropagation();
  	                  toggleLocationNode(rowData.key);
  	                });
  	              } else {
  	                caretHit.classList.add("empty");
  	              }
  	
  	              const img = document.createElement("img");
  	              img.className = "trackit-item-icon";
  	              img.alt = "";
  	              img.src = iconUrl(rowData.location);
  	
  	              const textWrap = document.createElement("div");
  	              textWrap.className = "trackit-item-text-wrap";
  	
  	              const labelElement = document.createElement("div");
  	              labelElement.className = "trackit-item-label";
  	              labelElement.textContent = rowData.label;
  	
  	              const metaElement = document.createElement("div");
  	              metaElement.className = "trackit-item-meta";
  	              metaElement.textContent = rowData.meta || " ";
  	
  	              textWrap.appendChild(labelElement);
  	              textWrap.appendChild(metaElement);
  	
  	              row.appendChild(caretHit);
  	              row.appendChild(img);
  	              row.appendChild(textWrap);
  	
  	              row.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	
  	                activateLocationRow(rowData, searchMode);
  	              });
  	
  	              menu.appendChild(row);
  	            }
  	
  	            function renderLocationNodes(nodes, q, searchMode, forceShowAll) {
  	              nodes.forEach(node => {
  	                const selfMatches = nodeSelfMatchesQuery(node, q);
  	                const treeMatches = nodeMatchesQuery(node, q);
  	
  	                const shouldShow =
  	                forceShowAll ||
  	                !searchMode ||
  	                selfMatches ||
  	                treeMatches;
  	
  	                if (!shouldShow) return;
  	
  	                renderLocationRow(node, searchMode);
  	
  	                const hasChildren = hasAnyNodes(node.childrenNodes);
  	
  	                if (!hasChildren) return;
  	
  	                const collapsed =
  	                !searchMode &&
  	                root.__trackitCollapsedLocationTree[node.key] === true;
  	
  	                const shouldRenderChildren =
  	                searchMode
  	                ? (forceShowAll || treeMatches || selfMatches): !collapsed;
  	
  	                if (!shouldRenderChildren) return;
  	
  	                renderLocationNodes(
  	                  node.childrenNodes,
  	                  q,
  	                  searchMode,
  	                  forceShowAll || (searchMode && selfMatches)
  	                );
  	              });
  	            }
  	
  	            function renderMenu(query) {
  	              if (isGoogleSearchMode()) {
  	                renderGoogleMenu(query);
  	                return;
  	              }
  	
  	              const q = String(query || "").trim().toLowerCase();
  	              const searchMode = !!q;
  	
  	              menu.innerHTML = "";
  	              visibleRows = [];
  	              activeIndex = -1;
  	
  	              let renderedAny = false;
  	
  	              if (!companyEntries.length) {
  	                const empty = document.createElement("div");
  	                empty.className = "trackit-empty";
  	                empty.textContent = "No companies or locations found";
  	                menu.appendChild(empty);
  	                return;
  	              }
  	
  	              companyEntries.forEach(companyEntry => {
  	                const companySelfMatches = companyMatchesQuery(companyEntry, q);
  	                const companyTreeMatches = companyEntry.typeGroups.some(typeGroup => {
  	                  if (String(typeGroup.label || "").toLowerCase().includes(q)) return true;
  	                  return typeGroup.nodes.some(node => nodeMatchesQuery(node, q));
  	                });
  	
  	                if (searchMode && !companySelfMatches && !companyTreeMatches) {
  	                  return;
  	                }
  	
  	                const companyCollapsed =
  	                !searchMode &&
  	                root.__trackitCollapsedLocationTree[companyEntry.key] === true;
  	
  	                renderCompanyHeader(companyEntry, companyCollapsed);
  	                renderedAny = true;
  	
  	                if (companyCollapsed) {
  	                  renderCollapsedCompanyNote(companyEntry);
  	                  return;
  	                }
  	
  	                companyEntry.typeGroups.forEach(typeGroup => {
  	                  if (!typeGroup.nodes.length) return;
  	
  	                  const typeSelfMatches = String(typeGroup.label || "").toLowerCase().includes(q);
  	                  const typeTreeMatches = typeGroup.nodes.some(node => nodeMatchesQuery(node, q));
  	
  	                  if (searchMode && !companySelfMatches && !typeSelfMatches && !typeTreeMatches) {
  	                    return;
  	                  }
  	
  	                  const typeCollapsed =
  	                  !searchMode &&
  	                  root.__trackitCollapsedLocationTree[typeGroup.key] === true;
  	
  	                  renderTypeGroupHeader(typeGroup, typeCollapsed);
  	                  renderedAny = true;
  	
  	                  if (typeCollapsed) {
  	                    renderCollapsedTypeGroupNote(typeGroup);
  	                    return;
  	                  }
  	
  	                  renderLocationNodes(
  	                    typeGroup.nodes,
  	                    q,
  	                    searchMode,
  	                    searchMode && (companySelfMatches || typeSelfMatches)
  	                  );
  	                });
  	              });
  	
  	              if (!renderedAny || (searchMode && !visibleRows.length)) {
  	                menu.innerHTML = "";
  	
  	                const empty = document.createElement("div");
  	                empty.className = "trackit-empty";
  	                empty.textContent = "No location found";
  	                menu.appendChild(empty);
  	              }
  	
  	              requestAnimationFrame(() => {
  	                if (dropdown.classList.contains("open")) updateMenuHeightToBottom();
  	              });
  	            }
  	
  	            // ============================================================
  	            // Initial render + existing selection
  	            // ============================================================
  	
  	            renderMenu("");
  	
  	            if (existingSelectedObjectId) {
  	              const existing = flatRows.find(row => row.value === String(existingSelectedObjectId));
  	
  	              if (existing) {
  	                paintSelectedRow(existing, false);
  	              }
  	            }
  	
  	            // ============================================================
  	            // Event listeners
  	            // ============================================================
  	
  	            control.addEventListener("click", function (event) {
  	              if (event.target.closest(".trackit-arrow-hit")) return;
  	              if (event.target.closest(".trackit-clear")) return;
  	              if (event.target.closest(".trackit-coordinate-toggle")) return;
  	              if (event.target.closest(".trackit-google-toggle")) return;
  	
  	              searchInput.focus();
  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	              openDropdown();
  	            });
  	
  	            arrowHit.addEventListener("mousedown",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleDropdownFromArrow();
  	              });
  	
  	            arrowHit.addEventListener("click",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	              });
  	
  	            googleToggle.addEventListener("mousedown",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	
  	                suppressFocusOpenUntil = Date.now() + 250;
  	                toggleLocationSearchMode();
  	
  	                searchInput.focus();
  	                renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	                openDropdown();
  	              });
  	
  	            googleToggle.addEventListener("click",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	              });
  	
  	            coordinateToggle.addEventListener("mousedown",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	
  	                suppressFocusOpenUntil = Date.now() + 250;
  	
  	                if (pointSearchActive) {
  	                  setPointSearchActive(false);
  	                  closeDropdown();
  	                  renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	                  return;
  	                }
  	
  	                setPointSearchActive(true);
  	
  	                const coordinates = parseCoordinateSearchValue(searchInput.value);
  	
  	                if (coordinates) {
  	                  runCoordinateSearch(searchInput.value, {
  	                    silentInvalid: false,
  	                    openEditor: true
  	                  });
  	                } else {
  	                  renderCoordinateSearchMessage("Point Search is ON. Click anywhere on the map to place a point.");
  	                }
  	              });
  	
  	            coordinateToggle.addEventListener("click",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	              });
  	
  	            menu.addEventListener("mousedown",
  	              function (event) {
  	                if (!isGoogleSearchMode()) return;
  	
  	                const googleRow = event.target.closest(".trackit-google-place-item");
  	
  	                if (!googleRow) return;
  	
  	                event.preventDefault();
  	                event.stopPropagation();
  	
  	                const index = Number(googleRow.__googlePredictionIndex);
  	
  	                if (!Number.isFinite(index)) return;
  	
  	                selectGooglePrediction(index);
  	              });
  	
  	            searchInput.addEventListener("focus",
  	              function () {
  	                if (Date.now() < suppressFocusOpenUntil) {
  	                  return;
  	                }
  	
  	                renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	                openDropdown();
  	
  	                setTimeout(() => {
  	                  try {
  	                    searchInput.select();
  	                  } catch (_) {}
  	                }, 0);
  	              });
  	
  	            searchInput.addEventListener("input",
  	              function () {
  	                const query = searchInput.value;
  	
  	                if (selectedValue && query !== selectedLabel) {
  	                  selectedValue = null;
  	                  selectedItem = null;
  	                  selectedLabel = "";
  	                  selectedRowData = null;
  	
  	                  selectedIcon.removeAttribute("src");
  	                  dropdown.classList.remove("has-value");
  	                  closeActionCard();
  	
  	                  menu.querySelectorAll(".trackit-location-item").forEach(element => {
  	                    element.classList.remove("selected");
  	                  });
  	                }
  	
  	                setQueryState();
  	                updateCoordinateSearchButtonState(query);
  	                renderMenu(query);
  	                openDropdown();
  	              });
  	
  	            searchInput.addEventListener("keydown",
  	              function (event) {
  	                if (
  	                  event.key === "Enter" &&
  	                  runCoordinateSearch(searchInput.value, {
  	                    silentInvalid: true,
  	                    openEditor: pointSearchActive
  	                  })
  	                ) {
  	                  event.preventDefault();
  	                  event.stopPropagation();
  	                  return;
  	                }
  	
  	                if (handleGoogleKeydown(event)) {
  	                  return;
  	                }
  	                if (event.key === "ArrowDown") {
  	                  event.preventDefault();
  	
  	                  if (!dropdown.classList.contains("open")) {
  	                    openDropdown();
  	                  }
  	
  	                  if (!visibleRows.length) return;
  	
  	                  activeIndex = activeIndex < visibleRows.length - 1 ? activeIndex + 1: 0;
  	                  paintActiveRow();
  	                  return;
  	                }
  	
  	                if (event.key === "ArrowUp") {
  	                  event.preventDefault();
  	
  	                  if (!visibleRows.length) return;
  	
  	                  activeIndex = activeIndex > 0 ? activeIndex - 1: visibleRows.length - 1;
  	                  paintActiveRow();
  	                  return;
  	                }
  	
  	                if (event.key === "Enter") {
  	                  if (activeIndex >= 0 && visibleRows[activeIndex]) {
  	                    event.preventDefault();
  	                    activateLocationRow(visibleRows[activeIndex], false);
  	                    return;
  	                  }
  	
  	                  if (activeIndex === -1 && visibleRows.length === 1) {
  	                    event.preventDefault();
  	                    activateLocationRow(visibleRows[0], false);
  	                    return;
  	                  }
  	                }
  	
  	                if (event.key === "Escape") {
  	                  if (pointSearchActive) {
  	                    setPointSearchActive(false);
  	                  }
  	
  	                  closeDropdown();
  	
  	                  if (selectedLabel) {
  	                    searchInput.value = selectedLabel;
  	                  }
  	
  	                  setQueryState();
  	                }
  	              });
  	
  	            clear.addEventListener("mousedown",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	
  	                clearSelected(true);
  	                searchInput.focus();
  	                openDropdown();
  	              });
  	
  	            pointEditorPanel.addEventListener("mousedown",
  	              function (event) {
  	                event.stopPropagation();
  	
  	                const actionButton = event.target.closest("[data-point-action]");
  	
  	                if (!actionButton) return;
  	
  	                event.preventDefault();
  	
  	                const action = actionButton.getAttribute("data-point-action");
  	
  	                if (action === "close") {
  	                  closePointEditor();
  	                  return;
  	                }
  	
  	                if (action === "save") {
  	                  saveActivePoint();
  	                  return;
  	                }
  	
  	                if (action === "delete") {
  	                  deleteActivePoint();
  	                  return;
  	                }
  	
  	                if (action === "whatsapp") {
  	                  sendActivePointWhatsapp();
  	                }
  	              });
  	
  	            pointEditorPanel.addEventListener("change",
  	              function (event) {
  	                const context = activePointContext;
  	
  	                if (!context?.point || !context?.marker) return;
  	                if (!event.target.matches('[data-point-field="company"]')) return;
  	                if (context.saved) return;
  	
  	                const company = findPointCompanyById(event.target.value);
  	
  	                context.company = company || null;
  	                context.marker.__trackitPointCompany = company || null;
  	                rememberPointCompany(company);
  	
  	                renderPointEditor();
  	
  	                if (pointSearchActive) {
  	                  renderSavedPointMarkers();
  	                }
  	              });
  	
  	            pointEditorPanel.addEventListener("input",
  	              function (event) {
  	                const context = activePointContext;
  	
  	                if (!context?.point || !context?.marker) return;
  	
  	                if (event.target.matches('[data-point-field="color"]')) {
  	                  const color = normalizePointColor(event.target.value);
  	                  context.point.Color = color;
  	                  setPointMarkerColor(context.marker, color);
  	                }
  	
  	                if (event.target.matches('[data-point-field="type"]')) {
  	                  context.point.Type = safeString(event.target.value);
  	                  try {
  	                    context.marker.setTitle(context.point.Type || "Point Location");
  	                  } catch (_) {}
  	
  	                  updatePointMarkerLabel(context.marker, context.point);
  	                }
  	              });
  	
  	            actionCard.addEventListener("mousedown",
  	              function (event) {
  	                event.stopPropagation();
  	
  	                const closeButton = event.target.closest("[data-card-close]");
  	
  	                if (closeButton) {
  	                  event.preventDefault();
  	                  closeActionCard();
  	                  return;
  	                }
  	
  	                const childButton = event.target.closest("[data-card-child-index]");
  	
  	                if (childButton) {
  	                  event.preventDefault();
  	
  	                  const index = Number(childButton.getAttribute("data-card-child-index"));
  	                  const childRow = actionCard.__childRows && actionCard.__childRows[index];
  	
  	                  if (!childRow) return;
  	
  	                  if (childRow.__trackitTemporarySegment) {
  	                    const cardRowData = actionCard.__cardRowData || selectedRowData || null;
  	
  	                    focusCardTemporarySegmentRow(childRow);
  	
  	                    if (cardRowData) {
  	                      showCardTemporarySegmentDetails(cardRowData, childRow);
  	                    }
  	
  	                    closeDropdown();
  	                    return;
  	                  }
  	
  	                  paintSelectedRow(childRow, true);
  	                  closeDropdown();
  	
  	                  return;
  	                }
  	
  	                const actionButton = event.target.closest("[data-card-action]");
  	
  	                if (actionButton) {
  	                  event.preventDefault();
  	
  	                  const action = actionButton.getAttribute("data-card-action");
  	
  	                  if (action === "functionalityHelp") {
  	                    const title = actionButton.getAttribute("data-functionality-help-title") || "Help";
  	                    const body = actionButton.getAttribute("data-functionality-help-body") || "";
  	                    const panel = actionCard.querySelector("[data-card-functionality-help-panel]");
  	
  	                    if (panel) {
  	                      panel.innerHTML = `
  	                      <div class="trackit-card-functionality-help-box">
  	                      <div class="trackit-card-functionality-help-title">${escapeHtml(title)}</div>
  	                      <div class="trackit-card-functionality-help-body">${escapeHtml(body)}</div>
  	                      </div>
  	                      `;
  	
  	                      notifyCarvedShellLayout();
  	                    }
  	
  	                    return;
  	                  }
  	
  	                  handleCardAction(action);
  	                }
  	              });
  	
  	            actionCard.addEventListener("input",
  	              function (event) {
  	                const target = event.target;
  	
  	                if (!target) return;
  	
  	                if (target.matches('[data-card-edit-field="contactNumber"]')) {
  	                  target.value = filterCardPhoneValue(target.value);
  	                }
  	
  	                if (target.matches("[data-card-segment-count]")) {
  	                  target.value = safeString(target.value).replace(/[^0-9]/g, "").slice(0, 3);
  	                }
  	
  	                if (target.matches("[data-card-functionality-phone]")) {
  	                  target.value = filterCardPhoneValue(target.value);
  	                }
  	
  	                if (target.matches('[data-card-edit-field="color"]')) {
  	                  const preview = actionCard.querySelector(".trackit-card-color-preview");
  	
  	                  if (preview) {
  	                    preview.style.background = target.value || "#cc6633";
  	                  }
  	                }
  	              });
  	
  	            actionCard.addEventListener("change",
  	              function (event) {
  	                const target = event.target;
  	
  	                if (!target) return;
  	
  	                if (target.matches("[data-card-functionality-key]")) {
  	                  const key = target.getAttribute("data-card-functionality-key");
  	
  	                  if (key === "publicFuelStation" && target.checked) {
  	                    const depotInput = actionCard.querySelector('[data-card-functionality-key="fuelDepot"]');
  	
  	                    if (depotInput) depotInput.checked = false;
  	                  }
  	
  	                  if (key === "fuelDepot" && target.checked) {
  	                    const publicInput = actionCard.querySelector('[data-card-functionality-key="publicFuelStation"]');
  	
  	                    if (publicInput) publicInput.checked = false;
  	                  }
  	
  	                  updateFunctionalityVisibility();
  	                }
  	              });
  	
  	            const documentClickHandler = function (event) {
  	              if (!dropdown.contains(event.target)) {
  	                closeDropdown();
  	
  	                if (selectedLabel) {
  	                  searchInput.value = selectedLabel;
  	                }
  	
  	                setQueryState();
  	              }
  	            };
  	
  	            const resizeHandler = function () {
  	              if (dropdown.classList.contains("open")) {
  	                scheduleHubAndMenuResize();
  	              }
  	            };
  	
  	            document.addEventListener("mousedown", documentClickHandler);
  	            window.addEventListener("resize", resizeHandler);
  	            window.addEventListener("orientationchange", resizeHandler);
  	            window.addEventListener("trackitMapControlLayoutChanged", mapControlLayoutHandler);
  	            window.addEventListener("trackitMapControlLayoutChanged", scheduleHubAndMenuResize);
  	
  	            bindMapControlLayoutListener();
  	
  	            // ============================================================
  	            // Public API + cleanup
  	            // ============================================================
  	
  	            root.__locationDropdownApi = {
  	              version: "placeholder-card-router-1",
  	              mode: SEARCH_ACTION_MODE,
  	              root,
  	              dropdown,
  	              menu,
  	              actionCard,
  	              pointEditorPanel,
  	              companies,
  	              companyEntries,
  	              getFlatRows() {
  	                return flatRows.slice();
  	              },
  	              getCollapsedCompanyIds() {
  	                return Array.from(dropdownCompanyVisibilityState.collapsedCompanyIds);
  	              },
  	              getSelected() {
  	                return {
  	                  value: selectedValue,
  	                  item: selectedItem,
  	                  location: selectedItem,
  	                  rowData: selectedRowData
  	                };
  	              },
  	              clear() {
  	                clearSelected(true);
  	              },
  	              open() {
  	                renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	                openDropdown();
  	              },
  	              close() {
  	                closeDropdown();
  	                closeActionCard();
  	                closePointEditor();
  	                setPointSearchActive(false);
  	              },
  	              setPointSearchActive(active) {
  	                setPointSearchActive(active === true);
  	              },
  	              isPointSearchActive() {
  	                return pointSearchActive;
  	              },
  	              refreshSavedPoints() {
  	                renderSavedPointMarkers();
  	              },
  	              refresh() {
  	                buildTreeRows();
  	                markDefaultCollapsedStates();
  	                renderMenu("");
  	              },
  	              openSelectedPlaceholderCard() {
  	                if (selectedRowData) {
  	                  openLocationActionCard(selectedRowData);
  	                }
  	              }
  	            };
  	
  	            root.__locationDropdownCleanup = function () {
  	
  	              try {
  	                setPointSearchActive(false);
  	                removePointMapClickListener();
  	                clearCoordinateSearchMarker();
  	                clearSavedPointMarkers();
  	                closePointEditor();
  	              } catch (_) {}
  	
  	              try {
  	                cancelActiveShapeEditBecauseClosed("dropdown-cleanup");
  	              } catch (_) {}
  	
  	              try {
  	                document.removeEventListener("mousedown", documentClickHandler);
  	              } catch (_) {}
  	
  	              try {
  	                window.removeEventListener("resize", resizeHandler);
  	                window.removeEventListener("orientationchange", resizeHandler);
  	                window.removeEventListener("trackitMapControlLayoutChanged", mapControlLayoutHandler);
  	                window.removeEventListener("trackitMapControlLayoutChanged", scheduleHubAndMenuResize);
  	              } catch (_) {}
  	
  	              if (mapControlWatchRetry) {
  	                try {
  	                  clearTimeout(mapControlWatchRetry);
  	                } catch (_) {}
  	
  	                mapControlWatchRetry = null;
  	              }
  	
  	              if (menuResizeRaf) {
  	                try {
  	                  cancelAnimationFrame(menuResizeRaf);
  	                } catch (_) {}
  	
  	                menuResizeRaf = 0;
  	              }
  	
  	              if (watchedMapControl) {
  	                try {
  	                  watchedMapControl.removeEventListener("click", mapControlLayoutHandler, true);
  	                } catch (_) {}
  	              }
  	
  	              if (mapControlMutationObserver) {
  	                try {
  	                  mapControlMutationObserver.disconnect();
  	                } catch (_) {}
  	              }
  	
  	              if (mapControlResizeObserver) {
  	                try {
  	                  mapControlResizeObserver.disconnect();
  	                } catch (_) {}
  	              }
  	
  	              resetHubHeight();
  	
  	              try {
  	                root.innerHTML = "";
  	              } catch (_) {}
  	            };
  	
  	            FIF_SILENT_CONSOLE.groupCollapsed("[TrackIT Location Dropdown] Loaded");
  	            FIF_SILENT_CONSOLE.log("Version:", "placeholder-card-router-1");
  	            FIF_SILENT_CONSOLE.log("Action Mode:", SEARCH_ACTION_MODE);
  	            FIF_SILENT_CONSOLE.log("Companies:", companies);
  	            FIF_SILENT_CONSOLE.log("Company Entries:", companyEntries);
  	            FIF_SILENT_CONSOLE.log("Flat Rows:", flatRows);
  	            FIF_SILENT_CONSOLE.log("Root:", root);
  	            FIF_SILENT_CONSOLE.log("Map Input:", MapRoot);
  	            FIF_SILENT_CONSOLE.groupEnd();
  	          })();
  	        }
  	      };
  	
  	      window.__CarvedEdgeShapeDropdownBridge = bridge;
  	
  	      FIF_SILENT_CONSOLE.groupCollapsed("[Carved Edge Shape UI] Dropdown Bridge Placeholder Mounted");
  	      FIF_SILENT_CONSOLE.log("Host:",
  	        host);
  	      FIF_SILENT_CONSOLE.log("Bridge:",
  	        bridge);
  	      FIF_SILENT_CONSOLE.groupEnd();
  	    }
  	
  	    function cleanupMountedTrackITDropdown(root) {
  	      try {
  	        const bridge = window.__CarvedEdgeShapeDropdownBridge || null;
  	        const bridgeHost = bridge && bridge.host ? bridge.host: null;
  	        const currentHost = root && root.querySelector
  	        ? root.querySelector("[data-location-dropdown-host]"): null;
  	
  	        const host = bridgeHost || currentHost;
  	
  	        if (host && typeof host.__locationDropdownCleanup === "function") {
  	          host.__locationDropdownCleanup();
  	          host.__locationDropdownCleanup = null;
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[Carved Edge Shape UI] Could not cleanup mounted TrackIT dropdown.", error);
  	      }
  	    }
  	
  	    function ensureTrackITSearchDropdownMounted(root) {
  	      try {
  	        if (!root || !root.isConnected || !DATA_CHANNEL) return;
  	
  	        const host = root.querySelector("[data-location-dropdown-host]");
  	
  	        if (!host) return;
  	
  	        if (host.querySelector(".trackit-location-dropdown")) {
  	          return;
  	        }
  	
  	        mountLocationDropdownBridgePlaceholder(root);
  	
  	        const bridge = window.__CarvedEdgeShapeDropdownBridge || null;
  	
  	        if (bridge && typeof bridge.mountTrackITDropdown === "function") {
  	          bridge.mountTrackITDropdown();
  	
  	          if (typeof bridge.resizeTopShell === "function") {
  	            bridge.resizeTopShell();
  	          }
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[Carved Edge Shape UI] Could not remount TrackIT dropdown.", error);
  	      }
  	    }
  	
  	    function getCompanyLabel(value) {
  	      const found = COMPANY_OPTIONS.find(item => item.value === value);
  	      return found ? found.label: "Company";
  	    }
  	
  	    function getActiveLocationTypeOptions() {
  	      return buildLocationTypeOptionsForCompany(createState.company);
  	    }
  	
  	    function getLocationType(value) {
  	      return getActiveLocationTypeOptions().find(item => item.value === value) || null;
  	    }
  	
  	    function resetFunctionalityState() {
  	      createState.functionality.eventsCapture = false;
  	      createState.functionality.fuelLogic = false;
  	      createState.functionality.publicFuelStation = false;
  	      createState.functionality.fuelDepot = false;
  	      createState.functionality.loadLogic = false;
  	      createState.functionality.gateLogic = false;
  	      createState.functionality.gatePhone = "";
  	    }
  	
  	    function resetCreateState() {
  	      unlockMapForPlotOrClose();
  	
  	      clearFreeGroundPlotDraft();
  	      createState.isCreating = false;
  	      createState.company = "";
  	      createState.locationType = "";
  	      createState.creationMode = "";
  	      createState.name = "";
  	      createState.openDropdown = "";
  	      createState.isPlotting = false;
  	      createState.isSaved = false;
  	      createState.modalMode = "";
  	      createState.helpTopic = "";
  	      createState.typeManagerName = "";
  	      createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	      createState.typeManagerOriginalName = "";
  	      resetFunctionalityState();
  	
  	      // Creation was cancelled/closed. Restore the normal cross-company map.
  	      refreshLocationCreationCompanyScope("location-create-scope-cleared");
  	    }
  	
  	    function removeExistingUI() {
  	      emergencyUnlockAnyCreateMapLock();
  	
  	      if (window.__CarvedEdgeShapeUI && typeof window.__CarvedEdgeShapeUI.cleanup === "function") {
  	        try {
  	          window.__CarvedEdgeShapeUI.cleanup();
  	        } catch (error) {
  	          FIF_SILENT_CONSOLE.warn("[Carved Edge Shape UI] Previous cleanup failed.", error);
  	        }
  	      }
  	
  	      const ids = Array.isArray(OLD_ENGINE_IDS) && OLD_ENGINE_IDS.length
  	      ? OLD_ENGINE_IDS: [ENGINE_ID];
  	
  	      ids.forEach(id => {
  	        const existing = document.getElementById(id);
  	
  	        if (existing && existing.parentNode) {
  	          existing.parentNode.removeChild(existing);
  	        }
  	      });
  	
  	      emergencyUnlockAnyCreateMapLock();
  	    }
  	
  	    function getMapForCreateLock() {
  	      return (
  	        createState.plotDraftMap ||
  	        resolveTrackITGoogleMap(MAP_INPUT) ||
  	        resolveTrackITGoogleMap(Map) ||
  	        null
  	      );
  	    }
  	
  	    function getGoogleMapDivForLock(map) {
  	      try {
  	        if (map && typeof map.getDiv === "function") {
  	          return map.getDiv();
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        const resolved = resolveTrackITGoogleMap(MAP_INPUT);
  	
  	        if (resolved && typeof resolved.getDiv === "function") {
  	          return resolved.getDiv();
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        return document.querySelector(".gm-style")?.parentElement || document.querySelector(".gm-style") || null;
  	      } catch (_) {
  	        return null;
  	      }
  	    }
  	
  	    function makeCreateMapLockOverlay(map) {
  	      const mapDiv = getGoogleMapDivForLock(map);
  	
  	      if (!mapDiv) return null;
  	
  	      let overlay = mapDiv.querySelector(":scope > .ces-create-map-lock-overlay");
  	
  	      if (overlay) return overlay;
  	
  	      overlay = document.createElement("div");
  	      overlay.className = "ces-create-map-lock-overlay";
  	      overlay.setAttribute("data-trackit-map-lock", "create-before-plot");
  	      overlay.title = "Click Plot Location to start plotting, or close creation mode.";
  	
  	      try {
  	        const computed = window.getComputedStyle(mapDiv);
  	
  	        if (computed && computed.position === "static") {
  	          mapDiv.__cesPreviousPosition = mapDiv.style.position || "";
  	          mapDiv.style.position = "relative";
  	        }
  	      } catch (_) {
  	        mapDiv.style.position = mapDiv.style.position || "relative";
  	      }
  	
  	      mapDiv.appendChild(overlay);
  	
  	      return overlay;
  	    }
  	
  	    function rememberMapLockOptions(map) {
  	      if (!map || createState.mapLockOriginalOptions) return;
  	
  	      function readOption(name) {
  	        try {
  	          if (typeof map.get === "function") {
  	            return map.get(name);
  	          }
  	        } catch (_) {}
  	
  	        return undefined;
  	      }
  	
  	      createState.mapLockOriginalOptions = {
  	        draggable: readOption("draggable"),
  	        gestureHandling: readOption("gestureHandling"),
  	        scrollwheel: readOption("scrollwheel"),
  	        disableDoubleClickZoom: readOption("disableDoubleClickZoom"),
  	        keyboardShortcuts: readOption("keyboardShortcuts"),
  	        clickableIcons: readOption("clickableIcons")
  	      };
  	    }
  	
  	    function restoreMapLockOptions(map) {
  	      if (!map || typeof map.setOptions !== "function") return;
  	
  	      const original = createState.mapLockOriginalOptions || {};
  	
  	      map.setOptions({
  	        draggable: original.draggable === undefined ? true: original.draggable,
  	        gestureHandling: original.gestureHandling === undefined ? "auto": original.gestureHandling,
  	        scrollwheel: original.scrollwheel === undefined ? true: original.scrollwheel,
  	        disableDoubleClickZoom: original.disableDoubleClickZoom === undefined ? false: original.disableDoubleClickZoom,
  	        keyboardShortcuts: original.keyboardShortcuts === undefined ? true: original.keyboardShortcuts,
  	        clickableIcons: original.clickableIcons === undefined ? true: original.clickableIcons
  	      });
  	    }
  	
  	    function lockMapUntilPlotMode() {
  	      const map = getMapForCreateLock();
  	
  	      createState.mapLockedUntilPlot = true;
  	
  	      if (!map) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Create Map Lock] Map not available yet; lock state stored.");
  	        return;
  	      }
  	
  	      createState.mapLockMap = map;
  	
  	      rememberMapLockOptions(map);
  	
  	      try {
  	        if (typeof map.setOptions === "function") {
  	          map.setOptions({
  	            draggable: false,
  	            gestureHandling: "none",
  	            scrollwheel: false,
  	            disableDoubleClickZoom: true,
  	            keyboardShortcuts: false,
  	            clickableIcons: false
  	          });
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Create Map Lock] Could not disable map gestures.", error);
  	      }
  	
  	      try {
  	        createState.mapLockOverlay = makeCreateMapLockOverlay(map);
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Create Map Lock] Could not add map lock overlay.", error);
  	      }
  	
  	      try {
  	        document.documentElement.classList.add("ces-create-map-locked");
  	        document.body?.classList.add("ces-create-map-locked");
  	      } catch (_) {}
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Create Map Lock] Map locked until Plot Location or close.");
  	    }
  	
  	    function unlockMapForPlotOrClose() {
  	      const map = createState.mapLockMap || getMapForCreateLock();
  	
  	      createState.mapLockedUntilPlot = false;
  	
  	      try {
  	        restoreMapLockOptions(map);
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Create Map Lock] Could not restore map gestures.", error);
  	      }
  	
  	      try {
  	        if (createState.mapLockOverlay && createState.mapLockOverlay.parentNode) {
  	          createState.mapLockOverlay.parentNode.removeChild(createState.mapLockOverlay);
  	        }
  	      } catch (_) {}
  	
  	      createState.mapLockOverlay = null;
  	      createState.mapLockMap = null;
  	      createState.mapLockOriginalOptions = null;
  	
  	      try {
  	        document.documentElement.classList.remove("ces-create-map-locked");
  	        document.body?.classList.remove("ces-create-map-locked");
  	      } catch (_) {}
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Create Map Lock] Map unlocked.");
  	    }
  	
  	    function emergencyUnlockAnyCreateMapLock() {
  	      try {
  	        document.querySelectorAll(".ces-create-map-lock-overlay").forEach(overlay => {
  	          try {
  	            overlay.remove();
  	          } catch (_) {}
  	        });
  	      } catch (_) {}
  	
  	      try {
  	        document.documentElement.classList.remove("ces-create-map-locked");
  	        document.body?.classList.remove("ces-create-map-locked");
  	      } catch (_) {}
  	
  	      try {
  	        const map = getMapForCreateLock();
  	
  	        if (map && typeof map.setOptions === "function") {
  	          map.setOptions({
  	            draggable: true,
  	            gestureHandling: "auto",
  	            scrollwheel: true,
  	            disableDoubleClickZoom: false,
  	            keyboardShortcuts: true,
  	            clickableIcons: true
  	          });
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Create Map Lock] Emergency unlock could not restore map options.", error);
  	      }
  	    }
  	
  	    function syncCreateMapLockState() {
  	      if (createState.isCreating && !createState.isPlotting && createState.mapLockedUntilPlot) {
  	        lockMapUntilPlotMode();
  	        return;
  	      }
  	
  	      if (!createState.mapLockedUntilPlot && createState.mapLockOverlay) {
  	        unlockMapForPlotOrClose();
  	      }
  	    }
  	    function getTopHeight() {
  	      if (!createState.isCreating) return 94;
  	      if (!createState.company) return 98;
  	      if (!createState.locationType) return 138;
  	      if (!createState.creationMode) return 218;
  	
  	      // Name input + always-visible Plot/Pick/Save button now need more room.
  	      if (!safeString(createState.name).trim()) return 300;
  	
  	      // Full creation mode: company + type + creation mode + name + action button.
  	      return 300;
  	    }
  	
  	    function clearSearchPanelResizeTimers() {
  	      if (searchPanelResizeRaf) {
  	        try {
  	          cancelAnimationFrame(searchPanelResizeRaf);
  	        } catch (_) {}
  	
  	        searchPanelResizeRaf = 0;
  	      }
  	
  	      searchPanelResizeTimeouts.forEach(timer => {
  	        try {
  	          clearTimeout(timer);
  	        } catch (_) {}
  	      });
  	
  	      searchPanelResizeTimeouts = [];
  	    }
  	
  	    function getTopPanelBottomLimit(root) {
  	      try {
  	        const engineRect = root.getBoundingClientRect();
  	
  	        const selectors = [
  	          ".ces-bottom-shape",
  	          ".ces-bottom-content",
  	          ".trackit-compact-map-control",
  	          ".trackit-map-control",
  	          "[data-map-control]",
  	          "[data-trackit-map-control]"
  	        ];
  	
  	        let nearestTop = Infinity;
  	
  	        selectors.forEach(selector => {
  	          root.querySelectorAll(selector).forEach(element => {
  	            const rect = element.getBoundingClientRect();
  	
  	            if (rect.width > 0 && rect.height > 0) {
  	              nearestTop = Math.min(nearestTop, rect.top);
  	            }
  	          });
  	
  	          document.querySelectorAll(selector).forEach(element => {
  	            const rect = element.getBoundingClientRect();
  	
  	            if (rect.width > 0 && rect.height > 0) {
  	              nearestTop = Math.min(nearestTop, rect.top);
  	            }
  	          });
  	        });
  	
  	        if (Number.isFinite(nearestTop)) {
  	          return Math.max(56, Math.floor(nearestTop - engineRect.top - 10));
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        const engineRect = root.getBoundingClientRect();
  	        return Math.max(56, Math.floor(window.innerHeight - engineRect.top - 86));
  	      } catch (_) {}
  	
  	      return 520;
  	    }
  	
  	    function setTopShapeHeight(root, height) {
  	      const topShape = root.querySelector(".ces-top-shape");
  	
  	      if (!topShape) return;
  	
  	      const safeHeight = Math.max(56, Math.floor(Number(height) || 94));
  	      const currentHeight = Number(topShape.getAttribute("data-ces-top-height") || 0);
  	
  	      if (currentHeight === safeHeight) {
  	        return;
  	      }
  	
  	      topShape.setAttribute("data-ces-top-height", String(safeHeight));
  	      topShape.style.transition = "none";
  	      topShape.style.height = `${safeHeight}px`;
  	
  	      topShape.querySelectorAll(".ces-panel-svg").forEach(svg => {
  	        try {
  	          svg.remove();
  	        } catch (_) {}
  	      });
  	
  	      topShape.insertAdjacentHTML("afterbegin", createTopSvg(safeHeight));
  	    }
  	
  	    function getOpenSearchPanelNaturalHeight(openPanel) {
  	      if (!openPanel) return 0;
  	
  	      try {
  	        const oldMaxHeight = openPanel.style.maxHeight;
  	        const oldHeight = openPanel.style.height;
  	        const oldOverflowY = openPanel.style.overflowY;
  	
  	        // Critical:
  	        // Temporarily remove the previous cap before measuring.
  	        // Otherwise the edit card measures its already-shrunk height.
  	        if (!openPanel.classList.contains("trackit-menu")) {
  	          openPanel.style.maxHeight = "none";
  	          openPanel.style.height = "auto";
  	          openPanel.style.overflowY = "visible";
  	        }
  	
  	        let naturalHeight = 0;
  	
  	        if (openPanel.classList.contains("trackit-action-card")) {
  	          const header = openPanel.querySelector(".trackit-action-card-header");
  	          const body = openPanel.querySelector(".trackit-action-card-body");
  	
  	          if (header) {
  	            const headerRect = header.getBoundingClientRect();
  	
  	            naturalHeight += Math.ceil(
  	              header.scrollHeight ||
  	              headerRect.height ||
  	              0
  	            );
  	          }
  	
  	          if (body) {
  	            const bodyRect = body.getBoundingClientRect();
  	
  	            naturalHeight += Math.ceil(
  	              body.scrollHeight ||
  	              bodyRect.height ||
  	              0
  	            );
  	          }
  	
  	          naturalHeight += 26;
  	        } else if (openPanel.classList.contains("trackit-menu")) {
  	          Array.from(openPanel.children).forEach(child => {
  	            const childRect = child.getBoundingClientRect();
  	
  	            naturalHeight += Math.ceil(
  	              child.scrollHeight ||
  	              childRect.height ||
  	              0
  	            );
  	          });
  	
  	          naturalHeight += 10;
  	        } else {
  	          const rect = openPanel.getBoundingClientRect();
  	
  	          naturalHeight = Math.ceil(
  	            openPanel.scrollHeight ||
  	            rect.height ||
  	            0
  	          );
  	        }
  	
  	        if (!openPanel.classList.contains("trackit-menu")) {
  	          openPanel.style.maxHeight = oldMaxHeight;
  	          openPanel.style.height = oldHeight;
  	          openPanel.style.overflowY = oldOverflowY;
  	        }
  	
  	        return Math.max(0, naturalHeight);
  	      } catch (_) {
  	        try {
  	          const rect = openPanel.getBoundingClientRect();
  	          return Math.ceil(openPanel.scrollHeight || rect.height || 0);
  	        } catch (_) {
  	          return 0;
  	        }
  	      }
  	    }
  	
  	    function getLiveSearchExpansionHeight(root) {
  	      const baseHeight = getTopHeight();
  	
  	      if (!root) return baseHeight;
  	
  	      const topShape = root.querySelector(".ces-top-shape");
  	      const topContent = root.querySelector(".ces-top-content");
  	      const host = root.querySelector("[data-location-dropdown-host]");
  	
  	      if (!topShape) return baseHeight;
  	
  	      let neededHeight = baseHeight;
  	
  	      try {
  	        const topRect = topShape.getBoundingClientRect();
  	
  	        if (topContent) {
  	          const contentRect = topContent.getBoundingClientRect();
  	          const contentTopInsideShell = Math.max(0, Math.ceil(contentRect.top - topRect.top));
  	          const contentHeight = Math.ceil(topContent.scrollHeight || contentRect.height || 0);
  	
  	          neededHeight = Math.max(
  	            neededHeight,
  	            contentTopInsideShell + contentHeight + 14
  	          );
  	        }
  	
  	        if (host) {
  	          const panels = host.querySelectorAll(`
  	            .trackit-location-dropdown.open .trackit-menu,
  	            .trackit-action-card.open,
  	            .trackit-card-type-picker.open .trackit-card-type-picker-menu
  	            `);
  	
  	          panels.forEach(panel => {
  	            const panelRect = panel.getBoundingClientRect();
  	
  	            if (!panelRect || panelRect.width <= 0) return;
  	
  	            const panelTopInsideShell = Math.max(0, Math.ceil(panelRect.top - topRect.top));
  	            const naturalHeight = getOpenSearchPanelNaturalHeight(panel);
  	
  	            neededHeight = Math.max(
  	              neededHeight,
  	              panelTopInsideShell + naturalHeight + 12
  	            );
  	          });
  	        }
  	      } catch (_) {
  	        return baseHeight;
  	      }
  	
  	      return Math.max(baseHeight,
  	        Math.ceil(neededHeight));
  	    }
  	
  	    function fitSearchDropdownToTopShell(root,
  	      finalHeight) {
  	      try {
  	        const topShape = root.querySelector(".ces-top-shape");
  	        const host = root.querySelector("[data-location-dropdown-host]");
  	
  	        if (!topShape || !host) return;
  	
  	        const panels = host.querySelectorAll(`
  	          .trackit-location-dropdown.open .trackit-menu,
  	          .trackit-action-card.open,
  	          .trackit-card-type-picker.open .trackit-card-type-picker-menu
  	          `);
  	
  	        if (!panels.length) return;
  	
  	        const topRect = topShape.getBoundingClientRect();
  	
  	        panels.forEach(panel => {
  	          const panelRect = panel.getBoundingClientRect();
  	
  	          if (!panelRect || panelRect.width <= 0) return;
  	
  	          const panelTopInsideShell = Math.ceil(panelRect.top - topRect.top);
  	          const availableHeight = Math.max(40, Math.floor(finalHeight - panelTopInsideShell - 10));
  	          const naturalHeight = getOpenSearchPanelNaturalHeight(panel);
  	          const fittedHeight = Math.max(40, Math.min(naturalHeight, availableHeight));
  	
  	          if (panel.classList.contains("trackit-menu")) {
  	            panel.style.setProperty("--trackit-menu-height", `${fittedHeight}px`);
  	            panel.style.height = `${fittedHeight}px`;
  	            panel.style.maxHeight = `${fittedHeight}px`;
  	            panel.style.overflowY = naturalHeight > fittedHeight ? "auto": "visible";
  	            return;
  	          }
  	
  	          if (panel.classList.contains("trackit-action-card")) {
  	            const header = panel.querySelector(".trackit-action-card-header");
  	            const body = panel.querySelector(".trackit-action-card-body");
  	
  	            const headerHeight = header
  	            ? Math.ceil(header.scrollHeight || header.getBoundingClientRect().height || 0): 0;
  	
  	            // Enough space:
  	            // The card and body must be fully open. No internal scrolling.
  	            if (naturalHeight <= fittedHeight + 2) {
  	              panel.style.maxHeight = "none";
  	              panel.style.height = "auto";
  	              panel.style.overflowY = "visible";
  	
  	              if (body) {
  	                body.style.maxHeight = "none";
  	                body.style.height = "auto";
  	                body.style.overflowY = "visible";
  	              }
  	
  	              return;
  	            }
  	
  	            // Not enough space:
  	            // Only now allow scrolling, and scroll the body, not the whole shell.
  	            const bodyMaxHeight = Math.max(80, fittedHeight - headerHeight - 18);
  	
  	            panel.style.maxHeight = `${fittedHeight}px`;
  	            panel.style.height = "auto";
  	            panel.style.overflowY = "hidden";
  	
  	            if (body) {
  	              body.style.maxHeight = `${bodyMaxHeight}px`;
  	              body.style.overflowY = "auto";
  	            }
  	
  	            return;
  	          }
  	
  	          panel.style.maxHeight = naturalHeight > fittedHeight ? `${fittedHeight}px`: "none";
  	          panel.style.overflowY = naturalHeight > fittedHeight ? "auto": "visible";
  	        });
  	      } catch (_) {}
  	    }
  	
  	    function updateSearchPanelHeight(root) {
  	      if (!root) return;
  	
  	      const baseHeight = getTopHeight();
  	      const neededHeight = getLiveSearchExpansionHeight(root);
  	      const bottomLimit = getTopPanelBottomLimit(root);
  	
  	      // The top panel must always fit content, but never pass 10px above Map Control.
  	      const finalHeight = Math.max(
  	        56,
  	        Math.min(
  	          Math.max(baseHeight, neededHeight),
  	          bottomLimit
  	        )
  	      );
  	
  	      setTopShapeHeight(root, finalHeight);
  	      fitSearchDropdownToTopShell(root, finalHeight);
  	    }
  	
  	    function scheduleSearchPanelHeight(root) {
  	      clearSearchPanelResizeTimers();
  	
  	      function runResizePass() {
  	        try {
  	          updateSearchPanelHeight(root);
  	        } catch (_) {}
  	      }
  	
  	      searchPanelResizeRaf = requestAnimationFrame(() => {
  	        searchPanelResizeRaf = 0;
  	        runResizePass();
  	      });
  	
  	      [30,
  	        80,
  	        160,
  	        320,
  	        640].forEach(delay => {
  	          const timer = setTimeout(runResizePass, delay);
  	          searchPanelResizeTimeouts.push(timer);
  	        });
  	    }
  	
  	    function bindSearchPanelMapControlWatcher(root) {
  	      try {
  	        if (!root || root.__searchPanelMapControlWatcherBound) return;
  	
  	        root.__searchPanelMapControlWatcherBound = true;
  	
  	        const handler = () => {
  	          scheduleSearchPanelHeight(root);
  	        };
  	
  	        root.__searchPanelMapControlHandler = handler;
  	
  	        window.addEventListener("resize", handler);
  	        window.addEventListener("trackitMapControlLayoutChanged", handler);
  	
  	        if (typeof ResizeObserver !== "undefined") {
  	          const observer = new ResizeObserver(handler);
  	
  	          [
  	            ".ces-top-shape",
  	            ".ces-top-content",
  	            ".ces-bottom-shape",
  	            ".ces-bottom-content",
  	            ".trackit-compact-map-control",
  	            ".trackit-map-control",
  	            "[data-map-control]",
  	            "[data-trackit-map-control]"
  	          ].forEach(selector => {
  	              root.querySelectorAll(selector).forEach(element => {
  	                try {
  	                  observer.observe(element);
  	                } catch (_) {}
  	              });
  	
  	              document.querySelectorAll(selector).forEach(element => {
  	                try {
  	                  observer.observe(element);
  	                } catch (_) {}
  	              });
  	            });
  	
  	          root.__searchPanelMapControlObserver = observer;
  	        } else {
  	          root.__searchPanelMapControlObserver = null;
  	        }
  	
  	        scheduleSearchPanelHeight(root);
  	      } catch (_) {}
  	    }
  	
  	    function unbindSearchPanelMapControlWatcher(root) {
  	      try {
  	        if (!root) return;
  	
  	        if (root.__searchPanelMapControlHandler) {
  	          window.removeEventListener("resize", root.__searchPanelMapControlHandler);
  	          window.removeEventListener("trackitMapControlLayoutChanged", root.__searchPanelMapControlHandler);
  	        }
  	
  	        if (root.__searchPanelMapControlObserver) {
  	          root.__searchPanelMapControlObserver.disconnect();
  	        }
  	
  	        root.__searchPanelMapControlWatcherBound = false;
  	        root.__searchPanelMapControlHandler = null;
  	        root.__searchPanelMapControlObserver = null;
  	      } catch (_) {}
  	    }
  	
  	    function resetSearchPanelHeight(root) {
  	      clearSearchPanelResizeTimers();
  	      setTopShapeHeight(root, getTopHeight());
  	    }
  	
  	    function getCurrentRequiredStep() {
  	      if (!createState.isCreating) return "";
  	      if (createState.modalMode) return "";
  	      if (!createState.company) return "company";
  	      if (!createState.locationType) return "locationType";
  	      if (!createState.creationMode) return "creationMode";
  	      if (!createState.name.trim()) return "name";
  	      if (!createState.isPlotting) return "plotLocation";
  	      if (createState.isPlotting && !createState.isSaved) return "saveLocation";
  	      return "";
  	    }
  	
  	    function clearAttention(root) {
  	      if (attentionTimer) {
  	        clearTimeout(attentionTimer);
  	        attentionTimer = null;
  	      }
  	
  	      if (!root) return;
  	
  	      root.querySelectorAll(".ces-needs-input").forEach(element => {
  	        element.classList.remove("ces-needs-input");
  	      });
  	    }
  	
  	    function scheduleAttention(root) {
  	      clearAttention(root);
  	
  	      const step = getCurrentRequiredStep();
  	      if (!step) return;
  	
  	      attentionTimer = setTimeout(() => {
  	        const stillCurrent = getCurrentRequiredStep();
  	        if (stillCurrent !== step) return;
  	
  	        let target = null;
  	
  	        if (step === "company") {
  	          target = root.querySelector(".ces-dd-company .ces-dd-button");
  	        }
  	
  	        if (step === "locationType") {
  	          target = root.querySelector(".ces-dd-location-type .ces-dd-button");
  	        }
  	
  	        if (step === "creationMode") {
  	          target = root.querySelector(".ces-creation-panel");
  	        }
  	
  	        if (step === "name") {
  	          target = root.querySelector(".ces-name-wrap");
  	        }
  	
  	        if (step === "plotLocation") {
  	          target = root.querySelector(".ces-plot-location-button");
  	        }
  	
  	        if (step === "saveLocation") {
  	          target = root.querySelector(".ces-save-location-button");
  	        }
  	
  	        if (target) {
  	          target.classList.add("ces-needs-input");
  	        }
  	      },
  	        5000);
  	    }
  	
  	    function injectStyles() {
  	      let style = document.getElementById(STYLE_ID);
  	
  	      if (!style) {
  	        style = document.createElement("style");
  	        style.id = STYLE_ID;
  	        document.head.appendChild(style);
  	      }
  	
  	      style.textContent = `
  	      #${ENGINE_ID} {
  	      position: fixed;
  	      top: 50px;
  	      right: 0;
  	      bottom: 0;
  	      width: 228px;
  	      z-index: 2147483647;
  	      pointer-events: none;
  	      font-family: Inter, Arial, sans-serif;
  	      color: #f8fafc;
  	      user-select: none;
  	      }
  	
  	      #${ENGINE_ID} * {
  	      box-sizing: border-box;
  	      }
  	
  	      #${ENGINE_ID} .ces-top-shape {
  	      position: absolute;
  	      top: 0;
  	      right: 0;
  	      width: 228px;
  	      pointer-events: none;
  	      overflow: visible;
  	      filter:
  	      drop-shadow(-12px 14px 16px rgba(0,0,0,0.34))
  	      drop-shadow(0 0 10px rgba(255,122,36,0.08));
  	      }
  	
  	      #${ENGINE_ID} .ces-panel-svg {
  	      position: absolute;
  	      inset: 0;
  	      width: 100%;
  	      height: 100%;
  	      overflow: visible;
  	      }
  	
  	      #${ENGINE_ID} .ces-top-content {
  	      position: absolute;
  	      top: 9px;
  	      left: 46px;
  	      width: 174px;
  	      pointer-events: auto;
  	      z-index: 10;
  	      }
  	
  	
  	      #${ENGINE_ID} .ces-location-line {
  	      display: grid;
  	      align-items: center;
  	      gap: 8px;
  	      height: 34px;
  	      }
  	
  	      #${ENGINE_ID} .ces-manager-line {
  	      grid-template-columns: 34px 1fr;
  	      }
  	
  	      #${ENGINE_ID} .ces-create-line {
  	      grid-template-columns: 34px 1fr 24px;
  	      }
  	
  	      #${ENGINE_ID} .ces-add-square {
  	      width: 34px;
  	      height: 34px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 14px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: #ff9a3d;
  	      font-size: 14px;
  	      background:
  	      radial-gradient(circle at 35% 25%, rgba(255,122,36,0.36), rgba(0,0,0,0.88) 72%);
  	      border: 1px solid rgba(255,122,36,0.58);
  	      box-shadow:
  	      0 0 18px rgba(255,122,36,0.20),
  	      inset 0 1px 0 rgba(255,255,255,0.08),
  	      inset 0 -1px 0 rgba(0,0,0,0.34);
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-add-square:hover {
  	      border-color: rgba(255,154,61,0.86);
  	      box-shadow:
  	      0 0 22px rgba(255,122,36,0.32),
  	      inset 0 1px 0 rgba(255,255,255,0.10),
  	      inset 0 -1px 0 rgba(0,0,0,0.34);
  	      }
  	
  	      #${ENGINE_ID} .ces-close-create {
  	      width: 24px;
  	      height: 24px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 10px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: rgba(255,216,191,0.82);
  	      font-size: 13px;
  	      font-weight: 950;
  	      background: rgba(0,0,0,0.54);
  	      border: 1px solid rgba(255,122,36,0.24);
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-close-create:hover {
  	      color: #ff9a3d;
  	      border-color: rgba(255,122,36,0.52);
  	      }
  	
  	      #${ENGINE_ID} .ces-title-wrap {
  	      min-width: 0;
  	      }
  	
  	      #${ENGINE_ID} .ces-title {
  	      max-width: 126px;
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      color: #ffd8bf;
  	      font-size: 12px;
  	      font-weight: 950;
  	      line-height: 1.05;
  	      }
  	
  	      #${ENGINE_ID} .ces-subtitle {
  	      margin-top: 4px;
  	      color: rgba(226,232,240,0.48);
  	      font-size: 7px;
  	      font-weight: 900;
  	      text-transform: uppercase;
  	      letter-spacing: 0.11em;
  	      }
  	
  	      #${ENGINE_ID} .ces-search,
  	      #${ENGINE_ID} .ces-name-wrap {
  	      width: 100%;
  	      height: 28px;
  	      margin-top: 8px;
  	      border-radius: 14px;
  	      display: grid;
  	      align-items: center;
  	      gap: 5px;
  	      padding: 0 9px;
  	      background: rgba(0,0,0,0.64);
  	      border: 1px solid rgba(255,122,36,0.18);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.04),
  	      0 0 12px rgba(255,122,36,0.05);
  	      }
  	
  	      #${ENGINE_ID} .ces-search {
  	      grid-template-columns: 18px 1fr 12px;
  	      }
  	
  	      #${ENGINE_ID} .ces-name-wrap {
  	      grid-template-columns: 18px 1fr;
  	      }
  	
  	      #${ENGINE_ID} .ces-search-icon,
  	      #${ENGINE_ID} .ces-name-icon {
  	      color: rgba(255,193,148,0.66);
  	      font-size: 12px;
  	      }
  	
  	      #${ENGINE_ID} .ces-search input,
  	      #${ENGINE_ID} .ces-name-wrap input {
  	      width: 100%;
  	      border: 0;
  	      outline: 0;
  	      background: transparent;
  	      color: rgba(248,250,252,0.82);
  	      font-size: 10px;
  	      font-weight: 750;
  	      }
  	
  	      #${ENGINE_ID} .ces-search input {
  	      pointer-events: none;
  	      }
  	
  	      #${ENGINE_ID} .ces-search input::placeholder,
  	      #${ENGINE_ID} .ces-name-wrap input::placeholder {
  	      color: rgba(226,232,240,0.44);
  	      }
  	
  	      #${ENGINE_ID} .ces-search-caret {
  	      color: rgba(255,122,36,0.62);
  	      font-size: 9px;
  	      text-align: right;
  	      pointer-events: none;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd {
  	      position: relative;
  	      width: 100%;
  	      margin-top: 8px;
  	      z-index: 50;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-button {
  	      width: 100%;
  	      height: 28px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 14px;
  	      display: grid;
  	      grid-template-columns: 18px 1fr 12px;
  	      align-items: center;
  	      gap: 5px;
  	      padding: 0 9px;
  	      color: rgba(248,250,252,0.82);
  	      text-align: left;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.11), rgba(255,122,36,0.00) 46%),
  	      linear-gradient(145deg, rgba(10,13,14,0.96), rgba(0,0,0,0.82));
  	      border: 1px solid rgba(255,122,36,0.22);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.045),
  	      0 0 12px rgba(255,122,36,0.06);
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-button:hover,
  	      #${ENGINE_ID} .ces-dd.ces-dd-open .ces-dd-button {
  	      border-color: rgba(255,122,36,0.48);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.055),
  	      0 0 16px rgba(255,122,36,0.12);
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-location-type .ces-dd-button {
  	      grid-template-columns: 18px 10px 1fr 12px;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-icon {
  	      color: rgba(255,193,148,0.68);
  	      font-size: 11px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-label {
  	      min-width: 0;
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      color: rgba(248,250,252,0.82);
  	      font-size: 10px;
  	      font-weight: 850;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-caret {
  	      color: rgba(255,122,36,0.66);
  	      font-size: 9px;
  	      text-align: right;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-dot {
  	      width: 8px;
  	      height: 8px;
  	      border-radius: 999px;
  	      display: block;
  	      background: rgba(255,122,36,0.85);
  	      box-shadow:
  	      0 0 0 3px rgba(255,122,36,0.09),
  	      0 0 10px rgba(255,122,36,0.28);
  	      }
  	
  	      #${ENGINE_ID} .ces-type-dot.ces-dot-empty {
  	      opacity: 0.28;
  	      background: rgba(255,255,255,0.28);
  	      box-shadow: none;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-list {
  	      position: absolute;
  	      top: 34px;
  	      left: 0;
  	      right: 0;
  	      max-height: 116px;
  	      overflow-y: auto;
  	      overflow-x: hidden;
  	      padding: 5px;
  	      border-radius: 15px;
  	      background:
  	      radial-gradient(circle at 0% 0%, rgba(255,122,36,0.13), rgba(255,122,36,0.00) 44%),
  	      linear-gradient(145deg, rgba(13,17,18,0.98), rgba(0,0,0,0.96));
  	      border: 1px solid rgba(255,122,36,0.34);
  	      box-shadow:
  	      -14px 16px 32px rgba(0,0,0,0.42),
  	      0 0 22px rgba(255,122,36,0.12),
  	      inset 0 1px 0 rgba(255,255,255,0.055);
  	      backdrop-filter: blur(18px);
  	      z-index: 200;
  	      display: none;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd.ces-dd-open .ces-dd-list {
  	      display: block;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-list::-webkit-scrollbar,
  	      #${ENGINE_ID} .ces-functionality-list::-webkit-scrollbar {
  	      width: 6px;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-list::-webkit-scrollbar-track,
  	      #${ENGINE_ID} .ces-functionality-list::-webkit-scrollbar-track {
  	      background: rgba(0,0,0,0.44);
  	      border-radius: 999px;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-list::-webkit-scrollbar-thumb,
  	      #${ENGINE_ID} .ces-functionality-list::-webkit-scrollbar-thumb {
  	      background:
  	      linear-gradient(
  	      to bottom,
  	      rgba(255,122,36,0.84),
  	      rgba(120,49,15,0.84)
  	      );
  	      border-radius: 999px;
  	      box-shadow: 0 0 8px rgba(255,122,36,0.32);
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-list,
  	      #${ENGINE_ID} .ces-functionality-list {
  	      scrollbar-width: thin;
  	      scrollbar-color: rgba(255,122,36,0.84) rgba(0,0,0,0.44);
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-option {
  	      width: 100%;
  	      min-height: 28px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 11px;
  	      display: grid;
  	      grid-template-columns: 1fr;
  	      align-items: center;
  	      gap: 7px;
  	      padding: 0 9px;
  	      color: rgba(248,250,252,0.78);
  	      background: transparent;
  	      text-align: left;
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-location-type .ces-dd-option {
  	      grid-template-columns: 10px 1fr;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-option span:last-child,
  	      #${ENGINE_ID} .ces-dd-option-label {
  	      min-width: 0;
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      font-size: 10px;
  	      font-weight: 820;
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-option:hover,
  	      #${ENGINE_ID} .ces-dd-option.ces-dd-option-selected {
  	      color: #ffd8bf;
  	      background:
  	      linear-gradient(145deg, rgba(255,122,36,0.18), rgba(255,122,36,0.04));
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.045),
  	      0 0 12px rgba(255,122,36,0.08);
  	      }
  	
  	      #${ENGINE_ID} .ces-dd-option + .ces-dd-option {
  	      margin-top: 3px;
  	      }
  	
  	      #${ENGINE_ID} .ces-creation-panel {
  	      margin-top: 8px;
  	      padding: 8px;
  	      border-radius: 16px;
  	      background: rgba(0,0,0,0.46);
  	      border: 1px solid rgba(255,122,36,0.16);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.04),
  	      0 0 12px rgba(255,122,36,0.05);
  	      }
  	
  	      #${ENGINE_ID} .ces-creation-title {
  	      color: rgba(255,216,191,0.78);
  	      font-size: 8px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.10em;
  	      margin-bottom: 7px;
  	      }
  	
  	      #${ENGINE_ID} .ces-mode-row {
  	      display: grid;
  	      grid-template-columns: 1fr 1fr 1fr;
  	      gap: 6px;
  	      }
  	
  	      #${ENGINE_ID} .ces-mode-button {
  	      height: 44px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 13px;
  	      display: flex;
  	      flex-direction: column;
  	      align-items: center;
  	      justify-content: center;
  	      gap: 4px;
  	      background: rgba(0,0,0,0.48);
  	      border: 1px solid rgba(255,122,36,0.16);
  	      color: rgba(255,216,191,0.62);
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-mode-button:hover,
  	      #${ENGINE_ID} .ces-mode-button.ces-mode-selected {
  	      border-color: rgba(255,122,36,0.62);
  	      color: #ffd8bf;
  	      box-shadow:
  	      0 0 14px rgba(255,122,36,0.14),
  	      inset 0 1px 0 rgba(255,255,255,0.05);
  	      }
  	
  	      #${ENGINE_ID} .ces-mode-shape {
  	      width: 20px;
  	      height: 16px;
  	      display: block;
  	      background: rgba(255,122,36,0.82);
  	      box-shadow: 0 0 10px rgba(255,122,36,0.28);
  	      }
  	
  	      #${ENGINE_ID} .ces-mode-polygon .ces-mode-shape {
  	      clip-path: polygon(18% 0, 82% 0, 100% 52%, 70% 100%, 24% 86%, 0 36%);
  	      }
  	
  	      #${ENGINE_ID} .ces-mode-pivot .ces-mode-shape {
  	      width: 18px;
  	      height: 18px;
  	      border-radius: 50%;
  	      }
  	
  	      #${ENGINE_ID} .ces-mode-wedge .ces-mode-shape {
  	      clip-path: polygon(0 0, 100% 50%, 0 100%);
  	      }
  	
  	      #${ENGINE_ID} .ces-mode-label {
  	      font-size: 7px;
  	      font-weight: 900;
  	      text-transform: uppercase;
  	      letter-spacing: 0.04em;
  	      }
  	
  	      #${ENGINE_ID} .ces-plot-location-button,
  	      #${ENGINE_ID} .ces-save-location-button {
  	      width: 100%;
  	      height: 32px;
  	      margin-top: 8px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 15px;
  	      display: grid;
  	      grid-template-columns: 22px 1fr;
  	      align-items: center;
  	      gap: 7px;
  	      padding: 0 10px;
  	      color: #ffd8bf;
  	      text-align: left;
  	      background:
  	      linear-gradient(145deg, rgba(255,127,39,0.50), rgba(91,36,11,0.68));
  	      border: 1px solid rgba(255,127,39,0.74);
  	      box-shadow:
  	      0 8px 20px rgba(255,96,24,0.16),
  	      0 0 14px rgba(255,122,36,0.12),
  	      inset 0 1px 0 rgba(255,221,195,0.18);
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-plot-location-button:hover,
  	      #${ENGINE_ID} .ces-save-location-button:hover {
  	      border-color: rgba(255,172,84,0.92);
  	      box-shadow:
  	      0 10px 24px rgba(255,96,24,0.20),
  	      0 0 20px rgba(255,122,36,0.18),
  	      inset 0 1px 0 rgba(255,221,195,0.22);
  	      }
  	
  	      #${ENGINE_ID} .ces-points-icon {
  	      position: relative;
  	      width: 18px;
  	      height: 18px;
  	      display: block;
  	      }
  	
  	      #${ENGINE_ID} .ces-points-icon::before {
  	      content: "";
  	      position: absolute;
  	      left: 4px;
  	      top: 4px;
  	      width: 10px;
  	      height: 10px;
  	      border-left: 1px solid rgba(255,154,61,0.72);
  	      border-bottom: 1px solid rgba(255,154,61,0.72);
  	      transform: rotate(-35deg);
  	      transform-origin: center;
  	      box-shadow: 0 0 8px rgba(255,122,36,0.22);
  	      }
  	
  	      #${ENGINE_ID} .ces-points-icon i {
  	      position: absolute;
  	      width: 5px;
  	      height: 5px;
  	      border-radius: 999px;
  	      background: #ff9a3d;
  	      box-shadow:
  	      0 0 0 3px rgba(255,122,36,0.10),
  	      0 0 10px rgba(255,122,36,0.38);
  	      }
  	
  	      #${ENGINE_ID} .ces-points-icon i:nth-child(1) {
  	      left: 1px;
  	      top: 1px;
  	      }
  	
  	      #${ENGINE_ID} .ces-points-icon i:nth-child(2) {
  	      right: 1px;
  	      top: 6px;
  	      }
  	
  	      #${ENGINE_ID} .ces-points-icon i:nth-child(3) {
  	      left: 5px;
  	      bottom: 1px;
  	      }
  	
  	      #${ENGINE_ID} .ces-save-icon {
  	      width: 20px;
  	      height: 20px;
  	      border-radius: 9px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: #ff9a3d;
  	      font-size: 12px;
  	      font-weight: 950;
  	      background: rgba(0,0,0,0.34);
  	      border: 1px solid rgba(255,122,36,0.28);
  	      }
  	
  	      #${ENGINE_ID} .ces-plot-location-button strong,
  	      #${ENGINE_ID} .ces-save-location-button strong {
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      font-size: 9px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      }
  	
  	      #${ENGINE_ID} .ces-screen-blocker {
  	      position: fixed;
  	      inset: 0;
  	      z-index: 2147483647;
  	      pointer-events: auto;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      padding: 24px;
  	      background:
  	      radial-gradient(circle at 50% 42%, rgba(255,122,36,0.12), rgba(0,0,0,0.00) 34%),
  	      rgba(0,0,0,0.72);
  	      backdrop-filter: blur(7px);
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-card {
  	      position: relative;
  	      width: min(390px, calc(100vw - 42px));
  	      max-height: min(620px, calc(100vh - 60px));
  	      overflow: hidden;
  	      padding: 18px;
  	      border-radius: 26px;
  	      background:
  	      radial-gradient(circle at 0% 0%, rgba(255,122,36,0.24), rgba(255,122,36,0.00) 42%),
  	      linear-gradient(145deg, rgba(18,24,26,0.98), rgba(0,0,0,0.94));
  	      border: 1px solid rgba(255,122,36,0.42);
  	      box-shadow:
  	      0 30px 80px rgba(0,0,0,0.58),
  	      0 0 38px rgba(255,122,36,0.16),
  	      inset 0 1px 0 rgba(255,255,255,0.075);
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-card::before {
  	      content: "";
  	      position: absolute;
  	      top: 0;
  	      left: 34px;
  	      right: 0;
  	      height: 1px;
  	      background:
  	      linear-gradient(
  	      to right,
  	      rgba(255,122,36,0.00),
  	      rgba(255,122,36,0.88),
  	      rgba(255,122,36,0.00)
  	      );
  	      box-shadow: 0 0 18px rgba(255,122,36,0.38);
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-header {
  	      display: grid;
  	      grid-template-columns: 38px 1fr 28px;
  	      gap: 10px;
  	      align-items: center;
  	      margin-bottom: 14px;
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-icon {
  	      width: 38px;
  	      height: 38px;
  	      border-radius: 16px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: #ff9a3d;
  	      font-size: 16px;
  	      font-weight: 950;
  	      background:
  	      radial-gradient(circle at 35% 25%, rgba(255,122,36,0.42), rgba(0,0,0,0.88) 72%);
  	      border: 1px solid rgba(255,122,36,0.58);
  	      box-shadow:
  	      0 0 22px rgba(255,122,36,0.24),
  	      inset 0 1px 0 rgba(255,255,255,0.08);
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-title {
  	      color: #ffd8bf;
  	      font-size: 15px;
  	      line-height: 1.1;
  	      font-weight: 950;
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-subtitle {
  	      margin-top: 4px;
  	      color: rgba(226,232,240,0.48);
  	      font-size: 8px;
  	      font-weight: 900;
  	      text-transform: uppercase;
  	      letter-spacing: 0.12em;
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-close {
  	      width: 28px;
  	      height: 28px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 11px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: rgba(255,216,191,0.82);
  	      font-size: 14px;
  	      font-weight: 950;
  	      background: rgba(0,0,0,0.46);
  	      border: 1px solid rgba(255,122,36,0.24);
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-close:hover {
  	      color: #ff9a3d;
  	      border-color: rgba(255,122,36,0.52);
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-body {
  	      color: rgba(248,250,252,0.82);
  	      font-size: 12px;
  	      font-weight: 750;
  	      line-height: 1.45;
  	      margin-bottom: 15px;
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-actions {
  	      display: grid;
  	      grid-template-columns: 1fr 1fr;
  	      gap: 8px;
  	      margin-top: 14px;
  	      }
  	      
  	      #${ENGINE_ID} .ces-modal-actions-2 {
  	      display: grid;
  	      margin-top: 14px;
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-primary,
  	      #${ENGINE_ID} .ces-modal-secondary {
  	      height: 34px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 15px;
  	      font-size: 9px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-primary {
  	      color: #ffd8bf;
  	      background:
  	      linear-gradient(145deg, rgba(255,127,39,0.50), rgba(91,36,11,0.68));
  	      border: 1px solid rgba(255,127,39,0.74);
  	      box-shadow:
  	      0 8px 20px rgba(255,96,24,0.16),
  	      inset 0 1px 0 rgba(255,221,195,0.18);
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-secondary {
  	      color: rgba(255,216,191,0.70);
  	      background: rgba(0,0,0,0.48);
  	      border: 1px solid rgba(255,122,36,0.18);
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-primary:hover {
  	      border-color: rgba(255,172,84,0.92);
  	      }
  	
  	      #${ENGINE_ID} .ces-modal-secondary:hover {
  	      color: #ffd8bf;
  	      border-color: rgba(255,122,36,0.44);
  	      }
  	
  	      #${ENGINE_ID} .ces-functionality-list {
  	      max-height: 390px;
  	      overflow-y: auto;
  	      padding-right: 4px;
  	      }
  	
  	      #${ENGINE_ID} .ces-functionality-item {
  	      min-height: 42px;
  	      border-radius: 17px;
  	      display: grid;
  	      grid-template-columns: 24px 1fr 24px;
  	      gap: 8px;
  	      align-items: center;
  	      padding: 8px 10px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.09), rgba(255,122,36,0.00) 48%),
  	      rgba(0,0,0,0.46);
  	      border: 1px solid rgba(255,122,36,0.16);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.035),
  	      0 0 12px rgba(255,122,36,0.04);
  	      }
  	
  	      #${ENGINE_ID} .ces-functionality-item + .ces-functionality-item,
  	      #${ENGINE_ID} .ces-fuel-sub-options {
  	      margin-top: 8px;
  	      }
  	
  	      #${ENGINE_ID} .ces-functionality-item.ces-sub-item {
  	      margin-left: 18px;
  	      min-height: 38px;
  	      background:
  	      linear-gradient(145deg, rgba(18,24,26,0.74), rgba(0,0,0,0.62));
  	      border-color: rgba(255,122,36,0.12);
  	      }
  	
  	      #${ENGINE_ID} .ces-check {
  	      width: 20px;
  	      height: 20px;
  	      position: relative;
  	      display: block;
  	      }
  	
  	      #${ENGINE_ID} .ces-check input {
  	      position: absolute;
  	      opacity: 0;
  	      pointer-events: none;
  	      }
  	
  	      #${ENGINE_ID} .ces-check-box {
  	      width: 20px;
  	      height: 20px;
  	      border-radius: 8px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      background: rgba(0,0,0,0.58);
  	      border: 1px solid rgba(255,122,36,0.28);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.05),
  	      0 0 10px rgba(255,122,36,0.06);
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-check-box::after {
  	      content: "✓";
  	      opacity: 0;
  	      color: #ff9a3d;
  	      font-size: 12px;
  	      font-weight: 950;
  	      transform: scale(0.4);
  	      transition:
  	      opacity 160ms ease,
  	      transform 160ms ease;
  	      }
  	
  	      #${ENGINE_ID} .ces-check input:checked + .ces-check-box {
  	      border-color: rgba(255,122,36,0.72);
  	      background:
  	      linear-gradient(145deg, rgba(255,127,39,0.28), rgba(0,0,0,0.58));
  	      box-shadow:
  	      0 0 16px rgba(255,122,36,0.16),
  	      inset 0 1px 0 rgba(255,255,255,0.07);
  	      }
  	
  	      #${ENGINE_ID} .ces-check input:checked + .ces-check-box::after {
  	      opacity: 1;
  	      transform: scale(1);
  	      }
  	
  	      #${ENGINE_ID} .ces-functionality-label {
  	      min-width: 0;
  	      }
  	
  	      #${ENGINE_ID} .ces-functionality-title {
  	      color: rgba(255,216,191,0.88);
  	      font-size: 11px;
  	      font-weight: 950;
  	      line-height: 1.1;
  	      }
  	
  	      #${ENGINE_ID} .ces-functionality-sub {
  	      margin-top: 3px;
  	      color: rgba(226,232,240,0.38);
  	      font-size: 7px;
  	      font-weight: 850;
  	      text-transform: uppercase;
  	      letter-spacing: 0.08em;
  	      }
  	
  	      #${ENGINE_ID} .ces-help-button {
  	      width: 22px;
  	      height: 22px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 9px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: rgba(255,216,191,0.76);
  	      font-size: 11px;
  	      font-weight: 950;
  	      background: rgba(0,0,0,0.50);
  	      border: 1px solid rgba(255,122,36,0.20);
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-help-button:hover {
  	      color: #ff9a3d;
  	      border-color: rgba(255,122,36,0.56);
  	      box-shadow: 0 0 12px rgba(255,122,36,0.14);
  	      }
  	
  	      #${ENGINE_ID} .ces-phone-wrap {
  	      height: 34px;
  	      margin-top: 8px;
  	      margin-left: 18px;
  	      border-radius: 15px;
  	      display: grid;
  	      grid-template-columns: 20px 1fr;
  	      align-items: center;
  	      gap: 7px;
  	      padding: 0 10px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.09), rgba(255,122,36,0.00) 48%),
  	      rgba(0,0,0,0.50);
  	      border: 1px solid rgba(255,122,36,0.16);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.035),
  	      0 0 12px rgba(255,122,36,0.04);
  	      }
  	
  	      #${ENGINE_ID} .ces-phone-icon {
  	      color: rgba(255,193,148,0.66);
  	      font-size: 12px;
  	      }
  	
  	      #${ENGINE_ID} .ces-phone-wrap input {
  	      width: 100%;
  	      border: 0;
  	      outline: 0;
  	      background: transparent;
  	      color: rgba(248,250,252,0.82);
  	      font-size: 10px;
  	      font-weight: 750;
  	      }
  	
  	      #${ENGINE_ID} .ces-phone-wrap input::placeholder {
  	      color: rgba(226,232,240,0.44);
  	      }
  	
  	      #${ENGINE_ID} .ces-help-pop {
  	      position: absolute;
  	      inset: 0;
  	      z-index: 10;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      padding: 18px;
  	      background: rgba(0,0,0,0.68);
  	      backdrop-filter: blur(4px);
  	      }
  	
  	      #${ENGINE_ID} .ces-help-card {
  	      width: 100%;
  	      padding: 15px;
  	      border-radius: 22px;
  	      background:
  	      radial-gradient(circle at 0% 0%, rgba(255,122,36,0.20), rgba(255,122,36,0.00) 42%),
  	      linear-gradient(145deg, rgba(18,24,26,0.99), rgba(0,0,0,0.96));
  	      border: 1px solid rgba(255,122,36,0.38);
  	      box-shadow:
  	      0 20px 60px rgba(0,0,0,0.56),
  	      0 0 28px rgba(255,122,36,0.14),
  	      inset 0 1px 0 rgba(255,255,255,0.07);
  	      }
  	
  	      #${ENGINE_ID} .ces-help-title {
  	      color: #ffd8bf;
  	      font-size: 13px;
  	      font-weight: 950;
  	      margin-bottom: 8px;
  	      }
  	
  	      #${ENGINE_ID} .ces-help-body {
  	      color: rgba(248,250,252,0.78);
  	      font-size: 11px;
  	      font-weight: 720;
  	      line-height: 1.45;
  	      }
  	
  	      #${ENGINE_ID} .ces-help-close {
  	      width: 100%;
  	      height: 32px;
  	      margin-top: 13px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 14px;
  	      color: #ffd8bf;
  	      background:
  	      linear-gradient(145deg, rgba(255,127,39,0.42), rgba(91,36,11,0.62));
  	      border: 1px solid rgba(255,127,39,0.66);
  	      font-size: 9px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-needs-input {
  	      animation: cesInputThrob 950ms ease-in-out infinite;
  	      }
  	
  	      #${ENGINE_ID} .ces-dropdown-bridge-host {
  	      width: 100%;
  	      margin-top: 8px;
  	      }
  	
  	      #${ENGINE_ID} .ces-dropdown-placeholder {
  	      width: 100%;
  	      height: 28px;
  	      border-radius: 14px;
  	      display: grid;
  	      grid-template-columns: 18px 1fr 12px;
  	      align-items: center;
  	      gap: 5px;
  	      padding: 0 9px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.11), rgba(255,122,36,0.00) 46%),
  	      linear-gradient(145deg, rgba(10,13,14,0.96), rgba(0,0,0,0.82));
  	      border: 1px solid rgba(255,122,36,0.22);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.045),
  	      0 0 12px rgba(255,122,36,0.06);
  	      }
  	
  	      #${ENGINE_ID} .ces-dropdown-placeholder-icon {
  	      color: rgba(255,193,148,0.68);
  	      font-size: 12px;
  	      }
  	
  	      #${ENGINE_ID} .ces-dropdown-placeholder-text {
  	      min-width: 0;
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      color: rgba(248,250,252,0.70);
  	      font-size: 10px;
  	      font-weight: 850;
  	      }
  	
  	      #${ENGINE_ID} .ces-dropdown-placeholder-caret {
  	      color: rgba(255,122,36,0.66);
  	      font-size: 9px;
  	      text-align: right;
  	      }
  	
  	      @keyframes cesInputThrob {
  	      0%, 100% {
  	      transform: scale(1);
  	      border-color: rgba(255,122,36,0.26);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.045),
  	      0 0 10px rgba(255,122,36,0.08);
  	      }
  	
  	      50% {
  	      transform: scale(1.035);
  	      border-color: rgba(255,122,36,0.92);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.075),
  	      0 0 22px rgba(255,122,36,0.38),
  	      0 0 34px rgba(255,122,36,0.14);
  	      }
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-card {
  	      width: 284px;
  	      max-width: 284px;
  	      padding: 18px 18px 20px 18px;
  	      border-radius: 28px;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-header {
  	      display: grid;
  	      grid-template-columns: 1fr 28px;
  	      gap: 10px;
  	      align-items: start;
  	      margin-bottom: 10px;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-heading {
  	      min-width: 0;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-card .ces-modal-title {
  	      max-width: 210px;
  	      color: #ffe1cc;
  	      font-size: 18px;
  	      line-height: 1.04;
  	      font-weight: 950;
  	      letter-spacing: -0.02em;
  	      white-space: normal;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-card .ces-modal-subtitle {
  	      margin-top: 4px;
  	      max-width: 210px;
  	      color: rgba(255,216,191,0.52);
  	      font-size: 9px;
  	      line-height: 1.1;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.08em;
  	      white-space: nowrap;
  	      overflow: hidden;
  	      text-overflow: ellipsis;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-close {
  	      position: static;
  	      width: 26px;
  	      height: 26px;
  	      align-self: start;
  	      justify-self: end;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-mode {
  	      min-height: 30px;
  	      display: grid;
  	      grid-template-columns: 1fr auto;
  	      gap: 8px;
  	      align-items: center;
  	      padding: 7px 9px;
  	      margin-bottom: 12px;
  	      border-radius: 15px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.08), rgba(255,122,36,0.00) 50%),
  	      rgba(0,0,0,0.34);
  	      border: 1px solid rgba(255,122,36,0.14);
  	      color: rgba(255,216,191,0.78);
  	      font-size: 10px;
  	      font-weight: 900;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-new-button {
  	      height: 22px;
  	      padding: 0 9px;
  	      border-radius: 999px;
  	      color: #ffd8bf;
  	      background: rgba(0,0,0,0.52);
  	      border: 1px solid rgba(255,122,36,0.24);
  	      font-size: 8px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-new-button:hover {
  	      border-color: rgba(255,122,36,0.70);
  	      color: #fff;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-form {
  	      display: grid;
  	      gap: 11px;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-field {
  	      display: grid;
  	      gap: 6px;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-field > span,
  	      #${ENGINE_ID} .ces-type-manager-section-title {
  	      color: rgba(255,216,191,0.72);
  	      font-size: 9px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.07em;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-input {
  	      width: 100%;
  	      height: 38px;
  	      border-radius: 17px;
  	      outline: 0;
  	      color: #f8fafc;
  	      font-size: 11px;
  	      font-weight: 850;
  	      padding: 0 13px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.09), rgba(255,122,36,0.00) 48%),
  	      rgba(0,0,0,0.50);
  	      border: 1px solid rgba(255,122,36,0.22);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.035),
  	      0 0 12px rgba(255,122,36,0.04);
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-input::placeholder {
  	      color: rgba(248,250,252,0.42);
  	      font-size: 10px;
  	      font-weight: 800;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-input:focus {
  	      border-color: rgba(255,122,36,0.72);
  	      box-shadow:
  	      0 0 0 2px rgba(255,122,36,0.10),
  	      inset 0 1px 0 rgba(255,255,255,0.045);
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-input.ces-needs-input {
  	      border-color: rgba(255,70,70,0.82);
  	      box-shadow:
  	      0 0 0 2px rgba(255,70,70,0.12),
  	      inset 0 1px 0 rgba(255,255,255,0.045);
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-color-row {
  	      height: 42px;
  	      display: grid;
  	      grid-template-columns: 30px 1fr;
  	      gap: 10px;
  	      align-items: center;
  	      padding: 6px 10px;
  	      border-radius: 18px;
  	      background:
  	      linear-gradient(145deg, rgba(13,17,18,0.92), rgba(0,0,0,0.76));
  	      border: 1px solid rgba(255,122,36,0.20);
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-color-preview {
  	      width: 24px;
  	      height: 24px;
  	      border-radius: 999px;
  	      display: block;
  	      border: 2px solid rgba(255,216,191,0.74);
  	      box-shadow:
  	      0 0 12px rgba(255,122,36,0.18),
  	      inset 0 1px 0 rgba(255,255,255,0.18);
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-color-input {
  	      width: 100%;
  	      height: 28px;
  	      border: 0;
  	      outline: 0;
  	      padding: 0;
  	      background: transparent;
  	      cursor: pointer;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-existing {
  	      margin-top: 13px;
  	      display: grid;
  	      gap: 7px;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-existing-row,
  	      #${ENGINE_ID} .ces-type-manager-empty {
  	      width: 100%;
  	      min-height: 36px;
  	      display: grid;
  	      grid-template-columns: 18px 1fr auto;
  	      gap: 9px;
  	      align-items: center;
  	      padding: 7px 10px;
  	      border-radius: 16px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.07), rgba(255,122,36,0.00) 50%),
  	      rgba(0,0,0,0.38);
  	      border: 1px solid rgba(255,122,36,0.13);
  	      color: rgba(248,250,252,0.84);
  	      font-size: 10px;
  	      font-weight: 850;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-existing-row {
  	      cursor: pointer;
  	      text-align: left;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-existing-row:hover,
  	      #${ENGINE_ID} .ces-type-manager-existing-selected {
  	      border-color: rgba(255,122,36,0.58);
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.16), rgba(255,122,36,0.00) 52%),
  	      rgba(0,0,0,0.48);
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-existing-name {
  	      min-width: 0;
  	      overflow: hidden;
  	      text-overflow: ellipsis;
  	      white-space: nowrap;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-edit-label {
  	      color: rgba(255,216,191,0.45);
  	      font-size: 8px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-existing-row:hover .ces-type-manager-edit-label,
  	      #${ENGINE_ID} .ces-type-manager-existing-selected .ces-type-manager-edit-label {
  	      color: #ff9a3d;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-empty {
  	      display: block;
  	      color: rgba(255,216,191,0.50);
  	      font-size: 10px;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-actions {
  	      margin-top: 16px;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-existing-row {
  	      display: grid !important;
  	      grid-template-columns: minmax(0, 1fr) auto !important;
  	      align-items: center !important;
  	      gap: 8px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-existing-edit {
  	      min-width: 0 !important;
  	      width: 100% !important;
  	      display: grid !important;
  	      grid-template-columns: auto minmax(0, 1fr) auto !important;
  	      align-items: center !important;
  	      gap: 8px !important;
  	      border: 0 !important;
  	      background: transparent !important;
  	      color: inherit !important;
  	      text-align: left !important;
  	      cursor: pointer !important;
  	      }
  	
  	      /* ============================================================
  	      Location Type Manager fixed-footer layout
  	      - Header/form/actions stay fixed inside the modal.
  	      - Only the Current Types list scrolls.
  	      ============================================================ */
  	
  	      #${ENGINE_ID} .ces-type-manager-card {
  	      max-height: calc(100dvh - 44px) !important;
  	      display: grid !important;
  	      grid-template-rows: auto auto auto minmax(0, 1fr) auto !important;
  	      overflow: hidden !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-header,
  	      #${ENGINE_ID} .ces-type-manager-mode,
  	      #${ENGINE_ID} .ces-type-manager-form,
  	      #${ENGINE_ID} .ces-type-manager-actions {
  	      min-height: 0 !important;
  	      flex-shrink: 0 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-existing {
  	      min-height: 0 !important;
  	      max-height: none !important;
  	      overflow-y: auto !important;
  	      overflow-x: hidden !important;
  	      padding-right: 4px !important;
  	      margin-top: 13px !important;
  	      align-self: stretch !important;
  	      overscroll-behavior: contain !important;
  	      scrollbar-gutter: stable !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-section-title {
  	      position: sticky !important;
  	      top: 0 !important;
  	      z-index: 2 !important;
  	      padding-bottom: 4px !important;
  	      background:
  	      linear-gradient(180deg, rgba(18,18,18,0.98), rgba(18,18,18,0.88)) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-actions {
  	      margin-top: 12px !important;
  	      padding-top: 10px !important;
  	      border-top: 1px solid rgba(255,122,36,0.16) !important;
  	      background:
  	      linear-gradient(180deg, rgba(18,18,18,0.88), rgba(18,18,18,0.98)) !important;
  	      z-index: 3 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-delete {
  	      height: 28px !important;
  	      padding: 0 10px !important;
  	      border-radius: 999px !important;
  	      border: 1px solid rgba(255,90,90,0.42) !important;
  	      background: rgba(255,60,60,0.10) !important;
  	      color: rgba(255,210,210,0.94) !important;
  	      font-size: 10px !important;
  	      font-weight: 900 !important;
  	      text-transform: uppercase !important;
  	      letter-spacing: 0.04em !important;
  	      cursor: pointer !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-type-manager-delete:hover {
  	      background: rgba(255,60,60,0.20) !important;
  	      border-color: rgba(255,100,100,0.66) !important;
  	      color: #ffffff !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-orange-edge {
  	      animation: cesEdgeGlow 4.8s ease-in-out infinite;
  	      }
  	
  	      #${ENGINE_ID} .ces-save-location-button.ces-saving-location,
  	      #${ENGINE_ID} .ces-save-location-button:disabled {
  	      opacity: 0.72;
  	      cursor: wait;
  	      pointer-events: none;
  	      }
  	
  	      #${ENGINE_ID} .ces-plot-location-button.ces-plot-location-disabled,
  	      #${ENGINE_ID} .ces-plot-location-button:disabled {
  	      opacity: 0.45;
  	      cursor: not-allowed;
  	      filter: grayscale(0.35);
  	      }
  	
  	      #${ENGINE_ID} .ces-plot-location-button {
  	      margin-top: 8px;
  	      }
  	
  	      #${ENGINE_ID} .ces-save-location-button {
  	      margin-top: 8px;
  	      }
  	
  	      #${ENGINE_ID} .ces-save-location-button.ces-picking-entrance {
  	      box-shadow: 0 0 0 2px rgba(255,255,255,0.22), 0 0 18px rgba(255,154,61,0.45);
  	      animation: cesEntrancePulse 1.1s ease-in-out infinite;
  	      }
  	
  	      html.ces-map-create-active:not(.ces-map-plot-active) .gm-style,
  	      body.ces-map-create-active:not(.ces-map-plot-active) .gm-style {
  	      filter: grayscale(0.95) brightness(0.48) contrast(0.85);
  	      transition: filter 180ms ease;
  	      }
  	
  	      html.ces-map-create-active.ces-map-plot-active .gm-style,
  	      body.ces-map-create-active.ces-map-plot-active .gm-style {
  	      filter: none;
  	      }
  	
  	      #${ENGINE_ID} .ces-save-location-button.ces-entrance-disabled,
  	      #${ENGINE_ID} .ces-save-location-button:disabled {
  	      opacity: 0.45;
  	      cursor: not-allowed;
  	      filter: grayscale(0.4);
  	      pointer-events: none;
  	      }
  	
  	      /* ============================================================
  	      Docked Map Control — Hardened Compact Console Layout
  	      ============================================================ */
  	
  	      #${ENGINE_ID} .ces-bottom-shape {
  	      position: absolute !important;
  	      right: 0 !important;
  	      bottom: 0 !important;
  	      top: auto !important;
  	      width: 200px;
  	      height: 56px;
  	      min-height: 56px;
  	      max-height: 56px;
  	      overflow: hidden !important;
  	      pointer-events: auto !important;
  	      padding: 0 !important;
  	      margin: 0 !important;
  	      border-radius: 22px 0 0 0 !important;
  	      border: 1px solid rgba(255,132,48,0.38) !important;
  	      border-right: 0 !important;
  	      border-bottom: 0 !important;
  	      background:
  	      radial-gradient(circle at 14% 10%, rgba(255,142,58,0.22), transparent 36%),
  	      linear-gradient(145deg, rgba(20,21,20,0.96), rgba(2,3,3,0.95)) !important;
  	      box-shadow:
  	      -14px -12px 30px rgba(0,0,0,0.42),
  	      inset 0 1px 0 rgba(255,255,255,0.075),
  	      inset 0 0 0 1px rgba(255,255,255,0.030),
  	      0 0 22px rgba(255,118,35,0.11) !important;
  	      backdrop-filter: blur(14px) saturate(1.18) !important;
  	      -webkit-backdrop-filter: blur(14px) saturate(1.18) !important;
  	      transition:
  	      width 170ms ease,
  	      height 170ms ease,
  	      box-shadow 170ms ease,
  	      filter 170ms ease !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-shape.ces-map-control-open {
  	      overflow: hidden !important;
  	      border-radius: 24px 0 0 0 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-content {
  	      position: relative !important;
  	      width: 100% !important;
  	      height: auto !important;
  	      max-height: none;
  	      overflow: hidden !important;
  	      pointer-events: auto !important;
  	      box-sizing: border-box !important;
  	      padding: 12px 14px 12px 18px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-shape.ces-map-control-open .ces-bottom-content {
  	      overflow-x: hidden !important;
  	      padding-right: 12px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-content {
  	      position: relative !important;
  	      width: 100% !important;
  	      height: auto !important;
  	      max-height: calc(100vh - 24px) !important;
  	      overflow: hidden !important;
  	      pointer-events: auto !important;
  	      box-sizing: border-box !important;
  	      padding: 12px 14px 12px 18px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-shape.ces-map-control-open .ces-bottom-content {
  	      overflow-y: auto !important;
  	      overflow-x: hidden !important;
  	      padding-right: 12px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-shape.ces-map-control-open .ces-bottom-content::-webkit-scrollbar {
  	      width: 6px;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-shape.ces-map-control-open .ces-bottom-content::-webkit-scrollbar-track {
  	      background: rgba(255,255,255,0.04);
  	      border-radius: 999px;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-shape.ces-map-control-open .ces-bottom-content::-webkit-scrollbar-thumb {
  	      background: rgba(255,138,61,0.55);
  	      border-radius: 999px;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-header {
  	      width: 100% !important;
  	      height: 38px !important;
  	      border: 0 !important;
  	      outline: 0 !important;
  	      background: transparent !important;
  	      color: inherit !important;
  	      display: grid !important;
  	      grid-template-columns: 31px minmax(0, 1fr) 16px !important;
  	      align-items: center !important;
  	      gap: 8px !important;
  	      padding: 0 !important;
  	      margin: 0 !important;
  	      cursor: pointer !important;
  	      text-align: left !important;
  	      appearance: none !important;
  	      -webkit-appearance: none !important;
  	      }
  	
  	      /* ============================================================
  	      MAP CONTROL — CANONICAL LAYOUT ONLY
  	      Keep this as the only body / zoom / measure layout block.
  	      ============================================================ */
  	
  	      #${ENGINE_ID} .ces-map-control-body {
  	      display: grid !important;
  	      grid-template-columns: minmax(0, 1fr) 56px !important;
  	      gap: 12px !important;
  	      align-items: start !important;
  	      margin-top: 12px !important;
  	      min-width: 0 !important;
  	      box-sizing: border-box !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-main {
  	      min-width: 0 !important;
  	      display: flex !important;
  	      flex-direction: column !important;
  	      gap: 12px !important;
  	      box-sizing: border-box !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-section {
  	      display: flex !important;
  	      flex-direction: column !important;
  	      gap: 7px !important;
  	      min-width: 0 !important;
  	      box-sizing: border-box !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-section-title {
  	      height: auto !important;
  	      min-height: 13px !important;
  	      display: flex !important;
  	      align-items: center !important;
  	      gap: 6px !important;
  	      color: rgba(255,232,208,0.78) !important;
  	      font-size: 8px !important;
  	      font-weight: 950 !important;
  	      letter-spacing: 0.12em !important;
  	      text-transform: uppercase !important;
  	      line-height: 1 !important;
  	      padding: 0 !important;
  	      margin: 0 !important;
  	      border: 0 !important;
  	      background: transparent !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-tools {
  	      display: grid !important;
  	      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	      grid-auto-rows: 38px !important;
  	      gap: 7px !important;
  	      min-width: 0 !important;
  	      box-sizing: border-box !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-measure-tools {
  	      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	      grid-auto-rows: 38px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-measure-tools .ces-map-control-tool:last-child:nth-child(odd) {
  	      grid-column: 1 / -1 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-zoom-rail {
  	      width: 56px !important;
  	      min-width: 56px !important;
  	      height: 286px !important;
  	      min-height: 286px !important;
  	      max-height: 286px !important;
  	
  	      display: grid !important;
  	      grid-template-rows: auto auto 32px 176px 32px !important;
  	      justify-items: center !important;
  	      align-items: center !important;
  	
  	      box-sizing: border-box !important;
  	      align-self: start !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-shape.ces-map-control-measuring .ces-map-control-zoom-rail {
  	      height: 360px !important;
  	      min-height: 360px !important;
  	      max-height: 360px !important;
  	      grid-template-rows: auto auto 32px 250px 32px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-slider-wrap {
  	      position: relative !important;
  	      display: flex !important;
  	      align-items: center !important;
  	      justify-content: center !important;
  	      width: 100% !important;
  	      height: 176px !important;
  	      min-height: 176px !important;
  	      max-height: 176px !important;
  	      margin: 8px 0 !important;
  	      padding: 0 !important;
  	      box-sizing: border-box !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-shape.ces-map-control-measuring .ces-map-control-slider-wrap {
  	      height: 250px !important;
  	      min-height: 250px !important;
  	      max-height: 250px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-slider-wrap::before {
  	      content: "" !important;
  	      position: absolute !important;
  	      top: 8px !important;
  	      bottom: 8px !important;
  	      left: 50% !important;
  	      width: 1px !important;
  	      transform: translateX(-50%) !important;
  	      background: repeating-linear-gradient(
  	      to bottom,
  	      rgba(255,255,255,0.18) 0,
  	      rgba(255,255,255,0.18) 1px,
  	      transparent 1px,
  	      transparent 8px
  	      ) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-zoom-slider {
  	      position: relative !important;
  	      z-index: 1 !important;
  	      writing-mode: vertical-lr !important;
  	      direction: rtl !important;
  	      width: 26px !important;
  	      height: 176px !important;
  	      min-height: 176px !important;
  	      max-height: 176px !important;
  	      accent-color: #ff7928 !important;
  	      cursor: pointer !important;
  	      margin: 0 !important;
  	      padding: 0 !important;
  	      appearance: auto !important;
  	      -webkit-appearance: slider-vertical !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-bottom-shape.ces-map-control-measuring .ces-map-control-zoom-slider {
  	      height: 250px !important;
  	      min-height: 250px !important;
  	      max-height: 250px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-header-icon {
  	      display: flex !important;
  	      align-items: center !important;
  	      justify-content: center !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-panel {
  	      margin-top: 10px !important;
  	      max-height: none !important;
  	      overflow: visible !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-rows {
  	      gap: 5px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-row {
  	      padding: 6px 0 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-actions {
  	      margin-top: 10px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-layer-icon {
  	      width: 30px !important;
  	      height: 30px !important;
  	      border-radius: 12px !important;
  	      display: flex !important;
  	      flex-direction: column !important;
  	      align-items: center !important;
  	      justify-content: center !important;
  	      gap: 3px !important;
  	      background:
  	      radial-gradient(circle at 35% 22%, rgba(255,153,70,0.42), rgba(4,5,5,0.92) 72%) !important;
  	      border: 1px solid rgba(255,132,48,0.54) !important;
  	      box-shadow:
  	      0 0 15px rgba(255,122,36,0.18),
  	      inset 0 1px 0 rgba(255,255,255,0.10) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-layer-icon span {
  	      width: 14px !important;
  	      height: 2px !important;
  	      border-radius: 999px !important;
  	      background: #ff9a3d !important;
  	      box-shadow: 0 0 8px rgba(255,122,36,0.34) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-header-text {
  	      min-width: 0 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-panel {
  	      position: relative !important;
  	      margin-top: 12px !important;
  	      padding: 14px !important;
  	      border-radius: 18px !important;
  	      border: 1px solid rgba(255,138,61,0.34) !important;
  	      background:
  	      radial-gradient(circle at top left, rgba(255,138,61,0.16), transparent 45%),
  	      rgba(0,0,0,0.42) !important;
  	      box-shadow:
  	      inset 0 0 0 1px rgba(255,255,255,0.04),
  	      0 14px 30px rgba(0,0,0,0.34) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-head {
  	      position: relative !important;
  	      display: grid !important;
  	      grid-template-columns: minmax(0, 1fr) 32px !important;
  	      align-items: start !important;
  	      gap: 10px !important;
  	      margin: 0 0 8px 0 !important;
  	      padding: 0 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-kicker {
  	      font-size: 9px !important;
  	      font-weight: 950 !important;
  	      text-transform: uppercase !important;
  	      letter-spacing: 0.16em !important;
  	      color: rgba(255,190,132,0.78) !important;
  	      line-height: 1 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-title {
  	      margin-top: 4px !important;
  	      font-size: 18px !important;
  	      font-weight: 950 !important;
  	      line-height: 1.05 !important;
  	      color: rgba(255,255,255,0.96) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-close {
  	      width: 30px !important;
  	      height: 30px !important;
  	      min-width: 30px !important;
  	      min-height: 30px !important;
  	
  	      display: grid !important;
  	      place-items: center !important;
  	
  	      justify-self: end !important;
  	      align-self: start !important;
  	
  	      margin: 0 !important;
  	      padding: 0 !important;
  	
  	      border-radius: 999px !important;
  	      border: 1px solid rgba(255,255,255,0.16) !important;
  	      background:
  	      radial-gradient(circle at 35% 25%, rgba(255,255,255,0.14), transparent 42%),
  	      rgba(255,255,255,0.075) !important;
  	
  	      color: rgba(255,255,255,0.86) !important;
  	      font-size: 18px !important;
  	      font-weight: 950 !important;
  	      line-height: 1 !important;
  	      text-align: center !important;
  	
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.10),
  	      0 8px 18px rgba(0,0,0,0.32) !important;
  	
  	      cursor: pointer !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-close:hover {
  	      border-color: rgba(255,138,61,0.55) !important;
  	      background:
  	      radial-gradient(circle at 35% 25%, rgba(255,255,255,0.14), transparent 42%),
  	      rgba(255,138,61,0.18) !important;
  	      color: #ffffff !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-help {
  	      margin-top: 8px !important;
  	      font-size: 13px !important;
  	      font-weight: 750 !important;
  	      line-height: 1.35 !important;
  	      color: rgba(255,255,255,0.82) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-rows {
  	      margin-top: 12px !important;
  	      display: grid !important;
  	      gap: 7px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-row {
  	      display: flex !important;
  	      align-items: baseline !important;
  	      justify-content: space-between !important;
  	      gap: 12px !important;
  	      padding: 7px 0 !important;
  	      border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-row span {
  	      font-size: 10px !important;
  	      font-weight: 950 !important;
  	      text-transform: uppercase !important;
  	      letter-spacing: 0.11em !important;
  	      color: rgba(255,190,132,0.72) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-data-row strong {
  	      font-size: 14px !important;
  	      font-weight: 950 !important;
  	      color: rgba(255,255,255,0.95) !important;
  	      text-align: right !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-actions {
  	      display: flex !important;
  	      justify-content: flex-start !important;
  	      gap: 8px !important;
  	      margin-top: 12px !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-actions button {
  	      height: 32px !important;
  	      padding: 0 12px !important;
  	      border-radius: 999px !important;
  	      border: 1px solid rgba(255,138,61,0.34) !important;
  	      background: rgba(255,138,61,0.10) !important;
  	      color: rgba(255,255,255,0.88) !important;
  	      font-size: 11px !important;
  	      font-weight: 950 !important;
  	      text-transform: uppercase !important;
  	      letter-spacing: 0.04em !important;
  	      cursor: pointer !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-measure-actions button:hover {
  	      background: rgba(255,138,61,0.22) !important;
  	      border-color: rgba(255,138,61,0.55) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-title {
  	      font-size: 11px !important;
  	      font-weight: 950 !important;
  	      letter-spacing: 0.10em !important;
  	      text-transform: uppercase !important;
  	      color: #ffe3c5 !important;
  	      line-height: 1 !important;
  	      white-space: nowrap !important;
  	      overflow: hidden !important;
  	      text-overflow: ellipsis !important;
  	      margin: 0 !important;
  	      padding: 0 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-subtitle {
  	      margin: 4px 0 0 !important;
  	      padding: 0 !important;
  	      font-size: 7px !important;
  	      font-weight: 950 !important;
  	      letter-spacing: 0.13em !important;
  	      text-transform: uppercase !important;
  	      color: rgba(255,255,255,0.56) !important;
  	      line-height: 1 !important;
  	      white-space: nowrap !important;
  	      overflow: hidden !important;
  	      text-overflow: ellipsis !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-caret {
  	      color: #ff8a3c !important;
  	      font-size: 12px !important;
  	      font-weight: 950 !important;
  	      display: flex !important;
  	      align-items: center !important;
  	      justify-content: center !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-section-title svg {
  	      width: 13px !important;
  	      height: 13px !important;
  	      color: #ff8a3c !important;
  	      flex: 0 0 auto !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-tool {
  	      width: auto !important;
  	      height: 36px !important;
  	      min-width: 0 !important;
  	      border-radius: 12px !important;
  	      border: 1px solid rgba(255,255,255,0.12) !important;
  	      outline: 0 !important;
  	      background:
  	      radial-gradient(circle at 100% 50%, rgba(255,122,36,0.08), transparent 46%),
  	      linear-gradient(145deg, rgba(255,255,255,0.055), rgba(255,255,255,0.018)) !important;
  	      color: rgba(255,255,255,0.78) !important;
  	      display: flex !important;
  	      align-items: center !important;
  	      justify-content: flex-start !important;
  	      gap: 7px !important;
  	      padding: 0 9px !important;
  	      margin: 0 !important;
  	      cursor: pointer !important;
  	      font-size: 9px !important;
  	      font-weight: 950 !important;
  	      letter-spacing: 0.01em !important;
  	      line-height: 1 !important;
  	      text-align: left !important;
  	      appearance: none !important;
  	      -webkit-appearance: none !important;
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.045),
  	      0 7px 15px rgba(0,0,0,0.14) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-tool svg {
  	      width: 14px !important;
  	      height: 14px !important;
  	      color: currentColor !important;
  	      flex: 0 0 auto !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-tool span {
  	      min-width: 0 !important;
  	      display: block !important;
  	      overflow: hidden !important;
  	      text-overflow: ellipsis !important;
  	      white-space: nowrap !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-tool:hover {
  	      color: #fff !important;
  	      border-color: rgba(255,137,56,0.58) !important;
  	      background: rgba(255,111,29,0.15) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-tool.active {
  	      color: #fff !important;
  	      border-color: rgba(255,137,56,0.84) !important;
  	      background:
  	      radial-gradient(circle at 94% 42%, rgba(255,157,72,0.18), transparent 50%),
  	      linear-gradient(145deg, rgba(255,112,30,0.42), rgba(84,30,8,0.64)) !important;
  	      box-shadow:
  	      inset 0 0 0 1px rgba(255,137,56,0.22),
  	      0 0 15px rgba(255,111,29,0.12) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-zoom-label {
  	      font-size: 8px !important;
  	      font-weight: 950 !important;
  	      letter-spacing: 0.12em !important;
  	      text-transform: uppercase !important;
  	      color: rgba(255,232,208,0.74) !important;
  	      line-height: 1 !important;
  	      margin: 0 0 5px !important;
  	      padding: 0 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-zoom-value {
  	      width: 31px !important;
  	      height: 31px !important;
  	      border-radius: 999px !important;
  	      border: 1px solid rgba(255,137,56,0.84) !important;
  	      background:
  	      radial-gradient(circle at 36% 26%, rgba(255,255,255,0.30), transparent 32%),
  	      radial-gradient(circle at 50% 50%, rgba(255,122,36,0.36), rgba(15,16,16,0.96) 70%) !important;
  	      color: #fff !important;
  	      font-size: 11px !important;
  	      font-weight: 950 !important;
  	      display: flex !important;
  	      align-items: center !important;
  	      justify-content: center !important;
  	      box-shadow:
  	      0 0 15px rgba(255,111,29,0.27),
  	      inset 0 1px 0 rgba(255,255,255,0.12) !important;
  	      margin: 0 0 6px !important;
  	      padding: 0 !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-zoom-btn {
  	      width: 34px !important;
  	      height: 28px !important;
  	      min-width: 34px !important;
  	      min-height: 28px !important;
  	      max-width: 34px !important;
  	      max-height: 28px !important;
  	
  	      display: grid !important;
  	      place-items: center !important;
  	
  	      justify-self: center !important;
  	      align-self: center !important;
  	
  	      margin: 0 auto !important;
  	      padding: 0 !important;
  	
  	      border-radius: 999px !important;
  	      border: 1px solid rgba(255,255,255,0.16) !important;
  	      background:
  	      radial-gradient(circle at 35% 25%, rgba(255,255,255,0.12), transparent 42%),
  	      rgba(255,255,255,0.075) !important;
  	
  	      color: rgba(255,255,255,0.92) !important;
  	      font-size: 19px !important;
  	      font-weight: 950 !important;
  	      line-height: 1 !important;
  	      text-align: center !important;
  	
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.10),
  	      0 8px 18px rgba(0,0,0,0.32) !important;
  	
  	      cursor: pointer !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-zoom-btn:hover {
  	      border-color: rgba(255,138,61,0.55) !important;
  	      background:
  	      radial-gradient(circle at 35% 25%, rgba(255,255,255,0.14), transparent 42%),
  	      rgba(255,138,61,0.16) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-zoom-btn:active {
  	      transform: translateY(1px) !important;
  	      }
  	      #${ENGINE_ID} .ces-map-control-zoom-btn:hover {
  	      background: rgba(255,111,29,0.20) !important;
  	      border-color: rgba(255,137,56,0.62) !important;
  	      }
  	
  	      #${ENGINE_ID} .ces-map-control-measure-tools .ces-map-control-tool:last-child:nth-child(odd) {
  	      grid-column: 1 / -1 !important;
  	      }
  	
  	      .ces-measure-data-row span {
  	      font-size: 10px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.11em;
  	      color: rgba(255,190,132,0.72);
  	      }
  	
  	      .ces-measure-data-row strong {
  	      font-size: 14px;
  	      font-weight: 950;
  	      color: rgba(255,255,255,0.95);
  	      text-align: right;
  	      }
  	
  	      .ces-measure-actions button {
  	      height: 32px;
  	      border-radius: 999px;
  	      border: 1px solid rgba(255,138,61,0.28);
  	      background: rgba(255,138,61,0.10);
  	      color: rgba(255,255,255,0.86);
  	      font-size: 10px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      cursor: pointer;
  	      }
  	
  	      .ces-measure-actions button:hover,
  	      .ces-measure-close:hover {
  	      background: rgba(255,138,61,0.22);
  	      border-color: rgba(255,138,61,0.55);
  	      }
  	
  	      @keyframes cesEntrancePulse {
  	      0%, 100% {
  	      transform: translateY(0);
  	      }
  	      50% {
  	      transform: translateY(-1px);
  	      }
  	      }
  	
  	      @keyframes cesEdgeGlow {
  	      0%, 100% {
  	      opacity: 0.62;
  	      }
  	
  	      50% {
  	      opacity: 1;
  	      }
  	      }
  	
  	      @media (prefers-reduced-motion: reduce) {
  	      #${ENGINE_ID} .ces-orange-edge,
  	      #${ENGINE_ID} .ces-needs-input {
  	      animation: none;
  	      }
  	      }
  	      `;
  	    }
  	
  	    function createTopSvg(height) {
  	      const h = Number(height) || 94;
  	      const bottom = h - 2;
  	      const bendY = Math.max(32, bottom - 22);
  	      const neckY = Math.min(48, Math.max(30, h - 26));
  	
  	      return `
  	      <svg class="ces-panel-svg" viewBox="0 0 228 ${h}" preserveAspectRatio="none" aria-hidden="true">
  	      <defs>
  	      <linearGradient id="cesTopFill" x1="0" y1="0" x2="1" y2="1">
  	      <stop offset="0" stop-color="#182224"/>
  	      <stop offset="0.42" stop-color="#050606"/>
  	      <stop offset="1" stop-color="#000000"/>
  	      </linearGradient>
  	
  	      <radialGradient id="cesTopHotspot" cx="0.16" cy="0.04" r="0.92">
  	      <stop offset="0" stop-color="#ff7a24" stop-opacity="0.34"/>
  	      <stop offset="0.34" stop-color="#ff7a24" stop-opacity="0.12"/>
  	      <stop offset="1" stop-color="#ff7a24" stop-opacity="0"/>
  	      </radialGradient>
  	      </defs>
  	
  	      <path
  	      d="
  	      M 8 0
  	      H 228
  	      V ${bottom}
  	      H 56
  	      C 42 ${bottom} 34 ${bottom - 8} 34 ${bendY}
  	      V ${neckY}
  	      C 34 24 24 8 8 0
  	      Z
  	      "
  	      fill="url(#cesTopFill)"
  	      />
  	
  	      <path
  	      d="
  	      M 8 0
  	      H 228
  	      V ${bottom}
  	      H 56
  	      C 42 ${bottom} 34 ${bottom - 8} 34 ${bendY}
  	      V ${neckY}
  	      C 34 24 24 8 8 0
  	      Z
  	      "
  	      fill="url(#cesTopHotspot)"
  	      opacity="0.88"
  	      />
  	
  	      <path
  	      class="ces-orange-edge"
  	      d="
  	      M 8 0
  	      H 228
  	      V ${bottom}
  	      H 56
  	      C 42 ${bottom} 34 ${bottom - 8} 34 ${bendY}
  	      V ${neckY}
  	      C 34 24 24 8 8 0
  	      Z
  	      "
  	      fill="none"
  	      stroke="#ff7a24"
  	      stroke-opacity="0.74"
  	      stroke-width="1.25"
  	      />
  	      </svg>
  	      `;
  	    }
  	
  	    function createPointsIcon() {
  	      return `
  	      <span class="ces-points-icon" aria-hidden="true">
  	      <i></i>
  	      <i></i>
  	      <i></i>
  	      </span>
  	      `;
  	    }
  	
  	    function createCompanyDropdown() {
  	      const isOpen = createState.openDropdown === "company";
  	      const label = getCompanyLabel(createState.company);
  	
  	      return `
  	      <div class="ces-dd ces-dd-company ${isOpen ? "ces-dd-open": ""}">
  	      <button class="ces-dd-button" type="button" data-dd-toggle="company">
  	      <span class="ces-dd-icon">▣</span>
  	      <span class="ces-dd-label">${escapeHtml(label)}</span>
  	      <span class="ces-dd-caret">${isOpen ? "⌃": "⌄"}</span>
  	      </button>
  	
  	      <div class="ces-dd-list">
  	      ${
  	      COMPANY_OPTIONS.map(option => `
  	        <button
  	        class="ces-dd-option ${createState.company === option.value ? "ces-dd-option-selected": ""}"
  	        type="button"
  	        data-company-value="${escapeHtml(option.value)}"
  	        >
  	        <span class="ces-dd-option-label">${escapeHtml(option.label)}</span>
  	        </button>
  	        `).join("")
  	      }
  	      </div>
  	      </div>
  	      `;
  	    }
  	
  	    function createLocationTypeDropdown() {
  	      const isOpen = createState.openDropdown === "locationType";
  	      const selectedType = getLocationType(createState.locationType);
  	      const label = selectedType ? selectedType.label: "Location Type";
  	      const color = selectedType ? selectedType.color: "";
  	
  	      return `
  	      <div class="ces-dd ces-dd-location-type ${isOpen ? "ces-dd-open": ""}">
  	      <button class="ces-dd-button" type="button" data-dd-toggle="locationType">
  	      <span class="ces-dd-icon">▤</span>
  	      <span
  	      class="ces-type-dot ${selectedType ? "": "ces-dot-empty"}"
  	      style="${selectedType ? `background:${escapeHtml(color)};`: ""}"
  	      ></span>
  	      <span class="ces-dd-label">${escapeHtml(label)}</span>
  	      <span class="ces-dd-caret">${isOpen ? "⌃": "⌄"}</span>
  	      </button>
  	
  	      <div class="ces-dd-list">
  	      ${
  	      getActiveLocationTypeOptions().map(option => `
  	        <button
  	        class="ces-dd-option ${createState.locationType === option.value ? "ces-dd-option-selected": ""}"
  	        type="button"
  	        data-location-type-value="${escapeHtml(option.value)}"
  	        >
  	        <span class="ces-type-dot" style="background:${escapeHtml(option.color)};"></span>
  	        <span class="ces-dd-option-label">${escapeHtml(option.label)}</span>
  	        </button>
  	        `).join("")
  	      }
  	      </div>
  	      </div>
  	      `;
  	    }
  	
  	    function createPlotOrSaveButton() {
  	      if (!createState.isPlotting) {
  	        const hasName = !!safeString(createState.name).trim();
  	
  	        return `
  	        <button
  	        class="ces-plot-location-button ${hasName ? "": "ces-plot-location-disabled"}"
  	        type="button"
  	        ${hasName ? "": "disabled"}
  	        >
  	        ${createPointsIcon()}
  	        <strong>Plot Location</strong>
  	        </button>
  	        `;
  	      }
  	
  	      if (!createState.entrancePoint) {
  	        const entranceStatus = getEntrancePrerequisiteStatus();
  	        const disabled = !entranceStatus.ready;
  	
  	        return `
  	        <button
  	        class="ces-save-location-button ${createState.isPickingEntrance ? "ces-picking-entrance": ""} ${disabled ? "ces-entrance-disabled": ""}"
  	        type="button"
  	        ${disabled ? "disabled": ""}
  	        title="${escapeHtml(entranceStatus.message)}"
  	        >
  	        <span class="ces-save-icon">⌖</span>
  	        <strong>${
  	        createState.isPickingEntrance
  	        ? "Click Boundary": entranceStatus.label
  	        }</strong>
  	        </button>
  	        `;
  	      }
  	
  	      return `
  	      <button class="ces-save-location-button" type="button">
  	      <span class="ces-save-icon">⚙</span>
  	      <strong>Add Functionality</strong>
  	      </button>
  	      `;
  	    }
  	
  	    function createTopContent() {
  	      if (!createState.isCreating) {
  	        return `
  	        <div class="ces-top-content">
  	        <div class="ces-location-line ces-manager-line">
  	        <button class="ces-add-square" type="button" title="Add Location">＋</button>
  	
  	        <div class="ces-title-wrap">
  	        <div class="ces-title">Location</div>
  	        <div class="ces-subtitle">Location Manager</div>
  	        </div>
  	        </div>
  	
  	        <div class="ces-dropdown-bridge-host" data-location-dropdown-host>
  	        <div class="ces-search">
  	        <span class="ces-search-icon">⌕</span>
  	        <input placeholder="Search Location" disabled />
  	        <span class="ces-search-caret">⌄</span>
  	        </div>
  	        </div>
  	        </div>
  	        `;
  	      }
  	
  	      return `
  	      <div class="ces-top-content">
  	      <div class="ces-location-line ces-create-line">
  	      <button class="ces-add-square" type="button" title="Add Location">＋</button>
  	
  	      <div class="ces-title-wrap">
  	      <div class="ces-title">Location</div>
  	      <div class="ces-subtitle">Location Manager</div>
  	      </div>
  	
  	      <button class="ces-close-create" type="button" title="Cancel">×</button>
  	      </div>
  	
  	      ${createCompanyDropdown()}
  	
  	      ${
  	      createState.company
  	      ? createLocationTypeDropdown(): ``
  	      }
  	
  	      ${
  	      createState.locationType
  	      ? `
  	      <div class="ces-creation-panel">
  	      <div class="ces-creation-title">Creation Mode</div>
  	
  	      <div class="ces-mode-row">
  	      <button class="ces-mode-button ces-mode-polygon ${createState.creationMode === "polygon" ? "ces-mode-selected": ""}" type="button" data-creation-mode="polygon">
  	      <span class="ces-mode-shape"></span>
  	      <span class="ces-mode-label">Polygon</span>
  	      </button>
  	
  	      <button class="ces-mode-button ces-mode-pivot ${createState.creationMode === "pivot" ? "ces-mode-selected": ""}" type="button" data-creation-mode="pivot">
  	      <span class="ces-mode-shape"></span>
  	      <span class="ces-mode-label">Pivot</span>
  	      </button>
  	
  	      <button class="ces-mode-button ces-mode-wedge ${createState.creationMode === "wedge" ? "ces-mode-selected": ""}" type="button" data-creation-mode="wedge">
  	      <span class="ces-mode-shape"></span>
  	      <span class="ces-mode-label">Wedge</span>
  	      </button>
  	      </div>
  	      </div>
  	      `: ``
  	      }
  	
  	      ${
  	      createState.creationMode
  	      ? `
  	      <div class="ces-name-wrap">
  	      <span class="ces-name-icon">✎</span>
  	      <input class="ces-name-input" placeholder="Location Name" value="${escapeHtml(createState.name)}" ${createState.isPlotting ? "disabled": ""} />
  	      </div>
  	
  	      ${createPlotOrSaveButton()}
  	      `: ``
  	      }
  	      </div>
  	      `;
  	    }
  	
  	    function createSavedModal() {
  	      return "";
  	    }
  	
  	    function createFunctionalityItem(key, title, subtitle, checked, isSubItem) {
  	      return `
  	      <div class="ces-functionality-item ${isSubItem ? "ces-sub-item": ""}">
  	      <label class="ces-check">
  	      <input type="checkbox" data-functionality-key="${escapeHtml(key)}" ${checked ? "checked": ""} />
  	      <span class="ces-check-box"></span>
  	      </label>
  	
  	      <div class="ces-functionality-label">
  	      <div class="ces-functionality-title">${escapeHtml(title)}</div>
  	      <div class="ces-functionality-sub">${escapeHtml(subtitle)}</div>
  	      </div>
  	
  	      <button class="ces-help-button" type="button" data-help-topic="${escapeHtml(key)}">?</button>
  	      </div>
  	      `;
  	    }
  	
  	    function createHelpPopup() {
  	      if (!createState.helpTopic) return "";
  	
  	      const help = HELP_TEXT[createState.helpTopic] || {
  	        title: "Description",
  	        body: "No description available."
  	      };
  	
  	      return `
  	      <div class="ces-help-pop">
  	      <div class="ces-help-card">
  	      <div class="ces-help-title">${escapeHtml(help.title)}</div>
  	      <div class="ces-help-body">${escapeHtml(help.body)}</div>
  	      <button class="ces-help-close" type="button" data-close-help>Close</button>
  	      </div>
  	      </div>
  	      `;
  	    }
  	
  	    function createFunctionalityModal() {
  	      const f = createState.functionality;
  	
  	      return `
  	      <div class="ces-screen-blocker">
  	      <div class="ces-modal-card">
  	      <div class="ces-modal-header">
  	      <div class="ces-modal-icon">⚙</div>
  	
  	      <div>
  	      <div class="ces-modal-title">Location Functionality</div>
  	      <div class="ces-modal-subtitle">Configure Logic</div>
  	      </div>
  	
  	      <button class="ces-modal-close" type="button" data-modal-reset title="Close">×</button>
  	      </div>
  	
  	      <div class="ces-functionality-list">
  	      ${createFunctionalityItem("eventsCapture", "Events Capture", "Capture events at this location", f.eventsCapture, false)}
  	
  	      ${createFunctionalityItem("fuelLogic", "Fuel Logic", "Enable fuel behaviour", f.fuelLogic, false)}
  	
  	      ${
  	      f.fuelLogic
  	      ? `
  	      <div class="ces-fuel-sub-options">
  	      ${createFunctionalityItem("publicFuelStation", "Public Fuel Station", "External fuel provider", f.publicFuelStation, true)}
  	      ${createFunctionalityItem("fuelDepot", "Depot", "Company fuel depot", f.fuelDepot, true)}
  	      </div>
  	      `: ``
  	      }
  	
  	      ${
  	      SHOW_LOAD_AND_GATE_FUNCTIONALITY_OPTIONS
  	      ? `
  	      ${createFunctionalityItem("loadLogic", "Load Logic", "Enable loading behaviour", f.loadLogic, false)}
  	
  	      ${createFunctionalityItem("gateLogic", "Gate Logic", "Enable gate contact logic", f.gateLogic, false)}
  	
  	      ${
  	      f.gateLogic
  	      ? `
  	      <div class="ces-phone-wrap">
  	      <span class="ces-phone-icon">☎</span>
  	      <input
  	      class="ces-gate-phone-input"
  	      type="tel"
  	      inputmode="tel"
  	      autocomplete="tel"
  	      placeholder="Phone Number"
  	      value="${escapeHtml(f.gatePhone)}"
  	      />
  	      </div>
  	      `: ``
  	      }
  	      `: `
  	      <!-- Load Logic and Gate Logic are temporarily hidden from Create/Edit functionality. -->
  	      `
  	      }
  	      </div>
  	
  	      <div class="ces-modal-actions-2">
  	      <button class="ces-modal-primary" type="button" data-save-functionality>
  	      ${createState.saveAfterFunctionality ? "Save Location": "Save Functionality"}
  	      </button>
  	      </div>
  	
  	      ${createHelpPopup()}
  	      </div>
  	      </div>
  	      `;
  	    }
  	
  	    function createLocationTypeManagerModal() {
  	      const companyLabel = getCompanyLabel(createState.company);
  	      const typeName = safeString(createState.typeManagerName);
  	      const typeColor = normalizeLocationTypeColorValue(createState.typeManagerColor);
  	      const originalName = safeString(createState.typeManagerOriginalName).trim();
  	      const isEditing = !!originalName;
  	
  	      const existingTypes = getActiveLocationTypeOptions()
  	      .filter(option => option.value !== ADD_NEW_LOCATION_TYPE_VALUE);
  	
  	      return `
  	      <div class="ces-screen-blocker">
  	      <div class="ces-modal-card ces-type-manager-card">
  	      <div class="ces-type-manager-header">
  	      <div class="ces-type-manager-heading">
  	      <div class="ces-modal-title">Location Type Manager</div>
  	      <div class="ces-modal-subtitle">${escapeHtml(companyLabel)}</div>
  	      </div>
  	
  	      <button class="ces-modal-close ces-type-manager-close" type="button" data-cancel-location-type-manager title="Close">×</button>
  	      </div>
  	
  	      <div class="ces-type-manager-mode">
  	      <span>${isEditing ? `Editing: ${escapeHtml(originalName)}`: `New Location Type`}</span>
  	
  	      ${
  	      isEditing
  	      ? `
  	      <button class="ces-type-manager-new-button" type="button" data-new-location-type-manager>
  	      New Type
  	      </button>
  	      `: ``
  	      }
  	      </div>
  	
  	      <div class="ces-type-manager-form">
  	      <label class="ces-type-manager-field">
  	      <span>Type Name</span>
  	      <input
  	      class="ces-type-manager-input"
  	      type="text"
  	      maxlength="60"
  	      autocomplete="off"
  	      placeholder="Example: Farm, Field, Gate"
  	      value="${escapeHtml(typeName)}"
  	      data-location-type-manager-name
  	      />
  	      </label>
  	
  	      <label class="ces-type-manager-field">
  	      <span>Color</span>
  	      <div class="ces-type-manager-color-row">
  	      <i class="ces-type-manager-color-preview" style="background:${escapeHtml(typeColor)};"></i>
  	      <input
  	      class="ces-type-manager-color-input"
  	      type="color"
  	      value="${escapeHtml(typeColor)}"
  	      data-location-type-manager-color
  	      />
  	      </div>
  	      </label>
  	      </div>
  	
  	      <div class="ces-type-manager-existing">
  	      <div class="ces-type-manager-section-title">Current Types</div>
  	
  	      ${
  	      existingTypes.length
  	      ? existingTypes.map((type, index) => `
  	        <div
  	        class="ces-type-manager-existing-row ${originalName && originalName.toLowerCase() === safeString(type.label).trim().toLowerCase() ? "ces-type-manager-existing-selected": ""}"
  	        >
  	        <button
  	        class="ces-type-manager-existing-edit"
  	        type="button"
  	        data-type-manager-edit-index="${index}"
  	        >
  	        <span class="ces-type-dot" style="background:${escapeHtml(type.color)};"></span>
  	
  	        <span class="ces-type-manager-existing-name">${escapeHtml(type.label)}</span>
  	
  	        <span class="ces-type-manager-edit-label">Edit</span>
  	        </button>
  	
  	        <button
  	        class="ces-type-manager-delete"
  	        type="button"
  	        data-type-manager-delete-index="${index}"
  	        title="Delete this type from the company Manifest only"
  	        >
  	        Delete
  	        </button>
  	        </div>
  	        `).join(""): `
  	      <div class="ces-type-manager-empty">
  	      No saved types yet.
  	      </div>
  	      `
  	      }
  	      </div>
  	
  	      <div class="ces-modal-actions ces-type-manager-actions">
  	      <button class="ces-modal-primary" type="button" data-save-location-type-manager>
  	      ${isEditing ? "Update Type": "Save Type"}
  	      </button>
  	
  	      <button class="ces-modal-secondary" type="button" data-cancel-location-type-manager>
  	      Cancel
  	      </button>
  	      </div>
  	      </div>
  	      </div>
  	      `;
  	    }
  	
  	    function createModal() {
  	      if (createState.modalMode === "functionality") {
  	        return createFunctionalityModal();
  	      }
  	
  	      if (createState.modalMode === "locationTypeManager") {
  	        return createLocationTypeManagerModal();
  	      }
  	
  	      return "";
  	    }
  	
  	    function bindModalEvents(root) {
  	      const resetButtons = root.querySelectorAll("[data-modal-reset]");
  	      // removed obsolete saved-modal functionality buttonconst openFunctionalityButton = root.querySelector("[data-open-functionality]");
  	      const functionalityInputs = root.querySelectorAll("[data-functionality-key]");
  	      const gatePhoneInput = root.querySelector(".ces-gate-phone-input");
  	      const helpButtons = root.querySelectorAll("[data-help-topic]");
  	      const closeHelpButton = root.querySelector("[data-close-help]");
  	      const saveFunctionalityButton = root.querySelector("[data-save-functionality]");
  	
  	      const typeManagerNameInput = root.querySelector("[data-location-type-manager-name]");
  	      const typeManagerColorInput = root.querySelector("[data-location-type-manager-color]");
  	      const saveLocationTypeButton = root.querySelector("[data-save-location-type-manager]");
  	      const cancelLocationTypeButtons = root.querySelectorAll("[data-cancel-location-type-manager]");
  	      const editLocationTypeButtons = root.querySelectorAll("[data-type-manager-edit-index]");
  	      const deleteLocationTypeButtons = root.querySelectorAll("[data-type-manager-delete-index]");
  	      const newLocationTypeButton = root.querySelector("[data-new-location-type-manager]");
  	
  	      resetButtons.forEach(button => {
  	        button.addEventListener("click", () => {
  	          resetCreateState();
  	
  	          renderTop(root);
  	          renderModal(root);
  	          ensureTrackITSearchDropdownMounted(root);
  	        });
  	      });
  	
  	      cancelLocationTypeButtons.forEach(button => {
  	        button.addEventListener("click", () => {
  	          createState.modalMode = "";
  	          createState.helpTopic = "";
  	          createState.typeManagerName = "";
  	          createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	          createState.typeManagerOriginalName = "";
  	
  	          renderTop(root);
  	          renderModal(root);
  	        });
  	      });
  	
  	      if (newLocationTypeButton) {
  	        newLocationTypeButton.addEventListener("click", () => {
  	          createState.typeManagerName = "";
  	          createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	          createState.typeManagerOriginalName = "";
  	
  	          renderModal(root);
  	        });
  	      }
  	
  	      editLocationTypeButtons.forEach(button => {
  	        button.addEventListener("click", () => {
  	          const index = Number(button.getAttribute("data-type-manager-edit-index"));
  	          const existingTypes = getActiveLocationTypeOptions()
  	          .filter(option => option.value !== ADD_NEW_LOCATION_TYPE_VALUE);
  	
  	          const selectedType = existingTypes[index];
  	
  	          if (!selectedType) return;
  	
  	          createState.typeManagerOriginalName = selectedType.label;
  	          createState.typeManagerName = selectedType.label;
  	          createState.typeManagerColor = normalizeLocationTypeColorValue(selectedType.color);
  	
  	          renderModal(root);
  	        });
  	      });
  	
  	      deleteLocationTypeButtons.forEach(button => {
  	        button.addEventListener("click",
  	          event => {
  	            try {
  	              event.preventDefault();
  	              event.stopPropagation();
  	            } catch (_) {}
  	
  	            const index = Number(button.getAttribute("data-type-manager-delete-index"));
  	
  	            const existingTypes = getActiveLocationTypeOptions()
  	            .filter(option => option.value !== ADD_NEW_LOCATION_TYPE_VALUE);
  	
  	            const selectedType = existingTypes[index];
  	
  	            if (!selectedType) return;
  	
  	            const typeName = safeString(selectedType.label).trim();
  	
  	            openLocationTypeDeleteConfirmPopup(selectedType, root);
  	          });
  	      });
  	
  	      if (typeManagerNameInput) {
  	        typeManagerNameInput.addEventListener("input", event => {
  	          createState.typeManagerName = event.target.value || "";
  	
  	          if (typeManagerNameInput.classList.contains("ces-needs-input")) {
  	            typeManagerNameInput.classList.remove("ces-needs-input");
  	          }
  	        });
  	      }
  	
  	      if (typeManagerColorInput) {
  	        typeManagerColorInput.addEventListener("input", event => {
  	          const color = normalizeLocationTypeColorValue(event.target.value);
  	
  	          createState.typeManagerColor = color;
  	          event.target.value = color;
  	
  	          const preview = root.querySelector(".ces-type-manager-color-preview");
  	
  	          if (preview) {
  	            preview.style.background = color;
  	          }
  	        });
  	      }
  	
  	      if (saveLocationTypeButton) {
  	        saveLocationTypeButton.addEventListener("click", () => {
  	          const typeName = safeString(createState.typeManagerName).trim();
  	          const typeColor = normalizeLocationTypeColorValue(createState.typeManagerColor);
  	
  	          if (!typeName) {
  	            const input = root.querySelector("[data-location-type-manager-name]");
  	
  	            if (input) {
  	              input.classList.add("ces-needs-input");
  	              input.focus();
  	            }
  	
  	            return;
  	          }
  	
  	          const savedType = upsertCompanyLocationType(
  	            createState.company,
  	            typeName,
  	            typeColor,
  	            createState.typeManagerOriginalName
  	          );
  	
  	          if (!savedType) return;
  	
  	          const source = safeString(createState.typeManagerSource).trim();
  	          const returnRowData = createState.typeManagerReturnRowData;
  	
  	          createState.modalMode = "";
  	          createState.helpTopic = "";
  	          createState.typeManagerName = "";
  	          createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	          createState.typeManagerOriginalName = "";
  	          createState.typeManagerSource = "";
  	          createState.typeManagerReturnRowData = null;
  	
  	          // Location Edit mode:
  	          // Do not reset create flow. Return to the open edit card and select the new type.
  	          if (source === "location-edit" && returnRowData) {
  	            renderModal(root);
  	
  	            try {
  	              applySavedLocationTypeToEditCard(returnRowData, savedType);
  	            } catch (error) {
  	              FIF_SILENT_CONSOLE.warn("[TrackIT Location Types] Saved type but could not apply it to edit card.", error);
  	            }
  	
  	            return;
  	          }
  	
  	          // Normal new-location creation flow:
  	          createState.locationType = savedType.value;
  	          createState.creationMode = "";
  	          createState.name = "";
  	          createState.openDropdown = "";
  	          createState.isPlotting = false;
  	          createState.isSaved = false;
  	
  	          renderTop(root);
  	          renderModal(root);
  	        });
  	      }
  	
  	      functionalityInputs.forEach(input => {
  	        input.addEventListener("change", () => {
  	          const key = input.getAttribute("data-functionality-key");
  	
  	          if (!key || !(key in createState.functionality)) return;
  	
  	          createState.functionality[key] = input.checked;
  	
  	          if (key === "fuelLogic" && !input.checked) {
  	            createState.functionality.publicFuelStation = false;
  	            createState.functionality.fuelDepot = false;
  	          }
  	
  	          if (key === "publicFuelStation" && input.checked) {
  	            createState.functionality.fuelDepot = false;
  	          }
  	
  	          if (key === "fuelDepot" && input.checked) {
  	            createState.functionality.publicFuelStation = false;
  	          }
  	
  	          if (key === "gateLogic" && !input.checked) {
  	            createState.functionality.gatePhone = "";
  	          }
  	
  	          renderModal(root);
  	        });
  	      });
  	
  	      if (gatePhoneInput) {
  	        gatePhoneInput.addEventListener("input", event => {
  	          let value = event.target.value || "";
  	
  	          value = value.replace(/[^\d+]/g, "");
  	
  	          if (value.includes("+")) {
  	            value = "+" + value.replace(/\+/g, "");
  	          }
  	
  	          if (value.length > 1) {
  	            value = value.charAt(0) === "+"
  	            ? "+" + value.slice(1).replace(/\+/g, ""): value.replace(/\+/g, "");
  	          }
  	
  	          event.target.value = value;
  	          createState.functionality.gatePhone = value;
  	        });
  	      }
  	
  	      helpButtons.forEach(button => {
  	        button.addEventListener("click", () => {
  	          createState.helpTopic = button.getAttribute("data-help-topic") || "";
  	          renderModal(root);
  	        });
  	      });
  	
  	      if (closeHelpButton) {
  	        closeHelpButton.addEventListener("click", () => {
  	          createState.helpTopic = "";
  	          renderModal(root);
  	        });
  	      }
  	
  	      if (saveFunctionalityButton) {
  	        saveFunctionalityButton.addEventListener("click", async () => {
  	          const functionalitySource = window.__CarvedEdgeShapeUI
  	          ? window.__CarvedEdgeShapeUI.pendingFunctionalitySource: "";
  	
  	          const isNewLocationFunctionalitySave =
  	          functionalitySource === "new-location-create" ||
  	          createState.saveAfterFunctionality === true;
  	
  	          if (isNewLocationFunctionalitySave) {
  	            try {
  	              saveFunctionalityButton.disabled = true;
  	              saveFunctionalityButton.classList.add("ces-saving-location");
  	              saveFunctionalityButton.innerHTML = "Saving Location...";
  	
  	              createState.isSavingLocation = true;
  	              createState.modalMode = "";
  	              createState.helpTopic = "";
  	
  	              await handleSaveCreatedLocation(root);
  	
  	              createState.saveAfterFunctionality = false;
  	              createState.isSavingLocation = false;
  	
  	              if (window.__CarvedEdgeShapeUI) {
  	                window.__CarvedEdgeShapeUI.pendingFunctionalitySource = "";
  	              }
  	
  	              return;
  	            } catch (error) {
  	              createState.isSavingLocation = false;
  	
  	              FIF_SILENT_CONSOLE.error("[TrackIT Save Channel] Save after functionality failed.", error);
  	
  	              window.alert(
  	                "Could not save this location.\n\n" +
  	                safeString(error?.message || error?.faultString || error || "Unknown save error")
  	              );
  	
  	              renderTop(root);
  	              renderModal(root);
  	
  	              return;
  	            }
  	          }
  	
  	          const targetLocation = window.__CarvedEdgeShapeUI
  	          ? window.__CarvedEdgeShapeUI.pendingSaveLocation: null;
  	
  	          const payload = {
  	            location: targetLocation,
  	            functionality: {
  	              eventsCapture: createState.functionality.eventsCapture,
  	              fuelLogic: createState.functionality.fuelLogic,
  	              fuelMode: createState.functionality.fuelLogic
  	              ? (
  	                createState.functionality.publicFuelStation
  	                ? "publicFuelStation": createState.functionality.fuelDepot
  	                ? "depot": ""
  	              ): "",
  	              publicFuelStation: createState.functionality.publicFuelStation,
  	              fuelDepot: createState.functionality.fuelDepot,
  	              loadLogic: createState.functionality.loadLogic,
  	              gateLogic: createState.functionality.gateLogic,
  	              gatePhone: createState.functionality.gatePhone
  	            }
  	          };
  	
  	          FIF_SILENT_CONSOLE.log("Save Functionality pressed:", payload);
  	
  	          if (targetLocation) {
  	            targetLocation.LocationData = targetLocation.LocationData || {};
  	            targetLocation.LocationData.Functionality = targetLocation.LocationData.Functionality || {};
  	
  	            targetLocation.LocationData.Functionality.EventsCapture = payload.functionality.eventsCapture;
  	            targetLocation.LocationData.Functionality.FuelLogic = payload.functionality.fuelLogic;
  	            targetLocation.LocationData.Functionality.FuelMode = payload.functionality.fuelMode;
  	            targetLocation.LocationData.Functionality.PublicFuelStation = payload.functionality.publicFuelStation;
  	            targetLocation.LocationData.Functionality.FuelDepot = payload.functionality.fuelDepot;
  	            targetLocation.LocationData.Functionality.LoadLogic = payload.functionality.loadLogic;
  	            targetLocation.LocationData.Functionality.GateLogic = payload.functionality.gateLogic;
  	            targetLocation.LocationData.Functionality.GatePhone = payload.functionality.gateLogic
  	            ? payload.functionality.gatePhone: "";
  	
  	            try {
  	              const appData = getAppBag();
  	
  	              if (appData) {
  	                appData.SelectedLocation = targetLocation;
  	                appData.SelectedLocationObjectId =
  	                targetLocation.objectId ||
  	                targetLocation.ObjectId ||
  	                targetLocation.id ||
  	                appData.SelectedLocationObjectId ||
  	                null;
  	
  	                appData.SelectedLocationMarker = appData.SelectedLocationObjectId;
  	              }
  	            } catch (_) {}
  	          }
  	
  	          if (window.__CarvedEdgeShapeUI) {
  	            window.__CarvedEdgeShapeUI.pendingFunctionalitySave = payload;
  	          }
  	
  	          createState.modalMode = "";
  	          createState.helpTopic = "";
  	
  	          renderModal(root);
  	
  	          try {
  	            const callback = window.__CarvedEdgeShapeUI
  	            ? window.__CarvedEdgeShapeUI.afterFunctionalitySave: null;
  	
  	            if (typeof callback === "function") {
  	              callback(payload);
  	            }
  	
  	            if (window.__CarvedEdgeShapeUI) {
  	              window.__CarvedEdgeShapeUI.afterFunctionalitySave = null;
  	            }
  	          } catch (error) {
  	            FIF_SILENT_CONSOLE.warn("[Carved Edge Shape UI] Could not run after functionality save callback.", error);
  	          }
  	        });
  	      }
  	    }
  	
  	    function renderModal(root) {
  	      let modalHost = root.querySelector(".ces-modal-host");
  	
  	      if (!modalHost) {
  	        modalHost = document.createElement("section");
  	        modalHost.className = "ces-modal-host";
  	        root.appendChild(modalHost);
  	      }
  	
  	      modalHost.innerHTML = createModal();
  	      bindModalEvents(root);
  	    }
  	
  	    function syncMapGreyedUntilPlotMode(root) {
  	      const createActive = !!createState.isCreating;
  	      const plotActive = !!(createState.isCreating && createState.isPlotting);
  	
  	      try {
  	        if (typeof document !== "undefined") {
  	          document.documentElement.classList.toggle("ces-map-create-active", createActive);
  	          document.documentElement.classList.toggle("ces-map-plot-active", plotActive);
  	
  	          if (document.body) {
  	            document.body.classList.toggle("ces-map-create-active", createActive);
  	            document.body.classList.toggle("ces-map-plot-active", plotActive);
  	          }
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (root && root.classList) {
  	          root.classList.toggle("ces-map-create-active", createActive);
  	          root.classList.toggle("ces-map-plot-active", plotActive);
  	        }
  	      } catch (_) {}
  	    }
  	
  	    function renderTop(root) {
  	      const topSection = root.querySelector(".ces-top-shape");
  	      const topHeight = getTopHeight();
  	
  	      if (!topSection) return;
  	
  	      syncMapGreyedUntilPlotMode(root);
  	
  	      cleanupMountedTrackITDropdown(root);
  	
  	      topSection.style.height = `${topHeight}px`;
  	      topSection.innerHTML = `
  	      ${createTopSvg(topHeight)}
  	      ${createTopContent()}
  	      `;
  	
  	      bindTopEvents(root);
  	      scheduleAttention(root);
  	      ensureTrackITSearchDropdownMounted(root);
  	
  	      scheduleSearchPanelHeight(root);
  	    }
  	
  	    // ====================================================================
  	    // MAP CONTROL — custom dock, Google Maps functionality
  	    // ====================================================================
  	
  	    function getMapControlSettingsBag() {
  	      const appData = getAppBag();
  	
  	      if (appData && typeof appData === "object") {
  	        if (!appData.TrackITMapSettings || typeof appData.TrackITMapSettings !== "object") {
  	          appData.TrackITMapSettings = {};
  	        }
  	
  	        return appData.TrackITMapSettings;
  	      }
  	
  	      if (!window.__TrackITMapSettingsLocal) {
  	        window.__TrackITMapSettingsLocal = {};
  	      }
  	
  	      return window.__TrackITMapSettingsLocal;
  	    }
  	
  	    function readMapControlSetting(key, fallback) {
  	      try {
  	        const settings = getMapControlSettingsBag();
  	
  	        return settings[key] !== undefined ? settings[key]: fallback;
  	      } catch (_) {
  	        return fallback;
  	      }
  	    }
  	
  	    function writeMapControlSetting(key, value) {
  	      try {
  	        const settings = getMapControlSettingsBag();
  	
  	        settings[key] = value;
  	      } catch (_) {}
  	    }
  	
  	    function getMapControlMap() {
  	      const existing =
  	      mapControlState.map ||
  	      getMapForCreateLock() ||
  	      resolveTrackITGoogleMap(MAP_INPUT) ||
  	      null;
  	
  	      if (existing) {
  	        mapControlState.map = existing;
  	      }
  	
  	      return existing;
  	    }
  	
  	    function initialiseMapControlStateFromSettings() {
  	      mapControlState.labelsOn = readMapControlSetting("labelsOn", true) !== false;
  	
  	      mapControlState.hideSecondaryLocations = !!readMapControlSetting(
  	        "hideSecondaryLocations",
  	        false
  	      );
  	
  	      mapControlState.hideAllLocations = !!readMapControlSetting(
  	        "hideAllLocations",
  	        false
  	      );
  	
  	      mapControlState.isOpen = !!readMapControlSetting(
  	        "panelOpenMapControl",
  	        false
  	      );
  	    }
  	
  	    const TRACKIT_NO_LABEL_STYLES = [{
  	      elementType: "labels",
  	      stylers: [{
  	        visibility: "off"
  	      }]
  	    },
  	      {
  	        featureType: "poi",
  	        stylers: [{
  	          visibility: "off"
  	        }]
  	      },
  	      {
  	        featureType: "transit",
  	        stylers: [{
  	          visibility: "off"
  	        }]
  	      }];
  	
  	    function applyMapControlAppearance() {
  	      const map = getMapControlMap();
  	
  	      if (!map) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Map Control] Map not ready for appearance update.");
  	        return false;
  	      }
  	
  	      const effectiveType = mapControlState.labelsOn ? "hybrid": "satellite";
  	
  	      try {
  	        if (typeof map.setMapTypeId === "function") {
  	          map.setMapTypeId(effectiveType);
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Map Control] Could not set map type.", error);
  	      }
  	
  	      try {
  	        if (typeof map.setOptions === "function") {
  	          map.setOptions({
  	            mapTypeControl: false,
  	            zoomControl: false,
  	            fullscreenControl: false,
  	            rotateControl: false,
  	            scaleControl: false,
  	            streetViewControl: false,
  	            clickableIcons: true,
  	            styles: mapControlState.labelsOn ? null: TRACKIT_NO_LABEL_STYLES
  	          });
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Map Control] Could not apply map options.", error);
  	      }
  	
  	      try {
  	        const panorama = typeof map.getStreetView === "function" ? map.getStreetView(): null;
  	
  	        if (panorama) {
  	          panorama.setVisible(false);
  	          panorama.setOptions({
  	            enableCloseButton: false,
  	            addressControl: false,
  	            fullscreenControl: false,
  	            panControl: false,
  	            zoomControl: false,
  	            linksControl: false
  	          });
  	        }
  	      } catch (_) {}
  	
  	      return true;
  	    }
  	
  	    function getMapControlZoom() {
  	      const map = getMapControlMap();
  	
  	      try {
  	        const zoom = map && typeof map.getZoom === "function" ? map.getZoom(): 1;
  	
  	        return Number.isFinite(Number(zoom)) ? Number(zoom): 1;
  	      } catch (_) {
  	        return 1;
  	      }
  	    }
  	
  	    function setMapControlZoom(nextZoom) {
  	      const map = getMapControlMap();
  	      const zoom = Math.max(1, Math.min(22, Math.round(Number(nextZoom) || 1)));
  	
  	      if (!map) return;
  	
  	      try {
  	        if (typeof map.setZoom === "function") {
  	          map.setZoom(zoom);
  	        }
  	
  	        writeMapControlSetting("zoom", zoom);
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Map Control] Could not set zoom.", error);
  	      }
  	    }
  	
  	    function isMapControlFullscreenActive() {
  	      const map = getMapControlMap();
  	
  	      try {
  	        const mapDiv = map && typeof map.getDiv === "function" ? map.getDiv(): null;
  	        const fs = document.fullscreenElement || document.webkitFullscreenElement || null;
  	
  	        return !!fs && !!mapDiv && (fs === mapDiv || fs.contains(mapDiv));
  	      } catch (_) {
  	        return false;
  	      }
  	    }
  	
  	    function toggleMapControlFullscreen() {
  	      const map = getMapControlMap();
  	
  	      try {
  	        const mapDiv = map && typeof map.getDiv === "function" ? map.getDiv(): null;
  	
  	        if (!mapDiv) return;
  	
  	        if (!document.fullscreenElement && !document.webkitFullscreenElement) {
  	          if (mapDiv.requestFullscreen) {
  	            mapDiv.requestFullscreen();
  	          } else if (mapDiv.webkitRequestFullscreen) {
  	            mapDiv.webkitRequestFullscreen();
  	          }
  	        } else {
  	          if (document.exitFullscreen) {
  	            document.exitFullscreen();
  	          } else if (document.webkitExitFullscreen) {
  	            document.webkitExitFullscreen();
  	          }
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Map Control] Fullscreen toggle failed.", error);
  	      }
  	    }
  	
  	    function emitMapControlLayoutChanged() {
  	      try {
  	        window.dispatchEvent(new CustomEvent("trackitMapControlLayoutChanged", {
  	          detail: {
  	            collapsed: !mapControlState.isOpen,
  	            open: !!mapControlState.isOpen,
  	            source: "trackit-map-control"
  	          }
  	        }));
  	      } catch (_) {}
  	    }
  	
  	    function setMapControlOpen(root, isOpen) {
  	      mapControlState.isOpen = !!isOpen;
  	      writeMapControlSetting("panelOpenMapControl", mapControlState.isOpen);
  	
  	      renderBottom(root);
  	
  	      emitMapControlLayoutChanged();
  	
  	      setTimeout(() => {
  	        emitMapControlLayoutChanged();
  	      }, 180);
  	    }
  	
  	    function applyMapControlLocationVisibility() {
  	      try {
  	        const runtime =
  	        typeof window !== "undefined"
  	        ? window.TrackITLocationMapRenderer ||
  	        window.TrackITLocationRendererRuntime ||
  	        window.__TrackITLocationRendererRuntime ||
  	        null: null;
  	
  	        if (runtime && typeof runtime.refresh === "function") {
  	          runtime.refresh({
  	            reason: "map-control-location-visibility",
  	            doFitBounds: false
  	          });
  	
  	          return true;
  	        }
  	
  	        if (typeof renderSavedLocationsOnMap === "function") {
  	          return renderSavedLocationsOnMap(MAP_INPUT, {
  	            reason: "map-control-location-visibility",
  	            doFitBounds: false
  	          });
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Map Control] Could not apply location visibility.", error);
  	      }
  	
  	      return false;
  	    }
  	
  	    function scheduleMapControlLocationVisibilityApply() {
  	      applyMapControlLocationVisibility();
  	
  	      setTimeout(() => {
  	        applyMapControlLocationVisibility();
  	      }, 80);
  	
  	      setTimeout(() => {
  	        applyMapControlLocationVisibility();
  	      }, 220);
  	    }
  	
  	    function applyAndRenderMapControl(root) {
  	      applyMapControlAppearance();
  	      applyMapControlLocationVisibility();
  	      renderBottom(root);
  	    }
  	
  	    function initialiseMapControl(root) {
  	      initialiseMapControlStateFromSettings();
  	
  	      const map = getMapControlMap();
  	
  	      if (map) {
  	        applyMapControlAppearance();
  	
  	        try {
  	          if (
  	            typeof google !== "undefined" &&
  	            google.maps &&
  	            google.maps.event &&
  	            typeof google.maps.event.addListener === "function" &&
  	            !map.__trackitNewThemeMapControlZoomListener
  	          ) {
  	            map.__trackitNewThemeMapControlZoomListener = google.maps.event.addListener(map, "zoom_changed", () => {
  	              try {
  	                writeMapControlSetting("zoom", getMapControlZoom());
  	
  	                if (root && root.isConnected && mapControlState.isOpen) {
  	                  renderBottom(root);
  	                }
  	              } catch (_) {}
  	            });
  	          }
  	        } catch (_) {}
  	      }
  	
  	      renderBottom(root);
  	    }
  	
  	    function isMapMeasureActive() {
  	      return !!measureState.isActive && !!measureState.mode;
  	    }
  	
  	    function getMeasureModeLabel(mode) {
  	      const value = safeString(mode).trim();
  	
  	      if (value === "measureRuler") return "Ruler";
  	      if (value === "measurePath") return "Path";
  	      if (value === "measurePolygon") return "Polygon";
  	      if (value === "measurePivot") return "Pivot";
  	      if (value === "measureWedge") return "Wedge";
  	
  	      return "Measure";
  	    }
  	
  	    function getMeasureModeInstruction(mode) {
  	      const value = safeString(mode).trim();
  	
  	      if (value === "measureRuler") return "Click two points to measure a straight distance.";
  	      if (value === "measurePath") return "Click multiple points to measure a path.";
  	      if (value === "measurePolygon") return "Click points around an area. Three or more points calculate area.";
  	      if (value === "measurePivot") return "Click centre point, then radius point.";
  	      if (value === "measureWedge") return "Click centre, radius point, then edge point.";
  	
  	      return "Choose a measuring tool.";
  	    }
  	
  	    function getMeasureRoot() {
  	      try {
  	        return document.getElementById(ENGINE_ID);
  	      } catch (_) {
  	        return null;
  	      }
  	    }
  	
  	    function refreshMeasurePanel() {
  	      const root = getMeasureRoot();
  	
  	      try {
  	        if (root && root.isConnected) {
  	          renderBottom(root);
  	        }
  	      } catch (_) {}
  	    }
  	
  	    function measureNumber(value) {
  	      const number = Number(value);
  	
  	      return Number.isFinite(number) ? number: null;
  	    }
  	
  	    function formatMeasureDistance(value) {
  	      const meters = measureNumber(value);
  	
  	      if (meters === null) return "—";
  	
  	      if (meters >= 1000) {
  	        return `${(meters / 1000).toFixed(2)} km`;
  	      }
  	
  	      return `${meters.toFixed(1)} m`;
  	    }
  	
  	    function formatMeasureAreaHa(value) {
  	      const m2 = measureNumber(value);
  	
  	      if (m2 === null) return "—";
  	
  	      return `${(m2 / 10000).toFixed(2)} ha`;
  	    }
  	
  	    function formatMeasureAreaM2(value) {
  	      const m2 = measureNumber(value);
  	
  	      if (m2 === null) return "—";
  	
  	      if (m2 >= 1000000) {
  	        return `${(m2 / 1000000).toFixed(3)} km²`;
  	      }
  	
  	      return `${m2.toFixed(0)} m²`;
  	    }
  	
  	    function measureLatLngToPlain(latLng) {
  	      try {
  	        if (!latLng) return null;
  	
  	        const lat = typeof latLng.lat === "function" ? latLng.lat(): latLng.lat;
  	        const lng = typeof latLng.lng === "function" ? latLng.lng(): latLng.lng;
  	
  	        const cleanLat = Number(lat);
  	        const cleanLng = Number(lng);
  	
  	        if (!Number.isFinite(cleanLat) || !Number.isFinite(cleanLng)) return null;
  	
  	        return {
  	          lat: cleanLat,
  	          lng: cleanLng
  	        };
  	      } catch (_) {
  	        return null;
  	      }
  	    }
  	
  	    function measureCleanPoint(point) {
  	      if (!point) return null;
  	
  	      const lat = Number(point.lat ?? point.latitude ?? point.y);
  	      const lng = Number(point.lng ?? point.longitude ?? point.x);
  	
  	      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  	
  	      return {
  	        lat,
  	        lng
  	      };
  	    }
  	
  	    function measureResolvePoint(rawPoint, options = {}) {
  	      const point = measureCleanPoint(rawPoint);
  	
  	      if (!point) return null;
  	
  	      const headingStart = measureCleanPoint(options.headingStart || null);
  	
  	      try {
  	        if (
  	          typeof getBoundarySnapForPoint === "function" &&
  	          typeof getFreeGroundBlockers === "function"
  	        ) {
  	          const snapped = getBoundarySnapForPoint(point, getFreeGroundBlockers(), {
  	            snapInside: !!headingStart,
  	            snapNearBoundary: true,
  	            headingStart: headingStart || null
  	          });
  	
  	          if (snapped && snapped.point) {
  	            const cleanSnap = measureCleanPoint(snapped.point);
  	
  	            if (cleanSnap) {
  	              return cleanSnap;
  	            }
  	          }
  	        }
  	      } catch (_) {}
  	
  	      return point;
  	    }
  	
  	    function measureDistanceMeters(a, b) {
  	      const p1 = measureCleanPoint(a);
  	      const p2 = measureCleanPoint(b);
  	
  	      if (!p1 || !p2) return 0;
  	
  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google?.maps?.geometry?.spherical?.computeDistanceBetween
  	        ) {
  	          return google.maps.geometry.spherical.computeDistanceBetween(
  	            new google.maps.LatLng(p1.lat, p1.lng),
  	            new google.maps.LatLng(p2.lat, p2.lng)
  	          );
  	        }
  	      } catch (_) {}
  	
  	      const radius = 6371008.8;
  	      const toRad = value => value * Math.PI / 180;
  	
  	      const phi1 = toRad(p1.lat);
  	      const phi2 = toRad(p2.lat);
  	      const deltaPhi = toRad(p2.lat - p1.lat);
  	      const deltaLambda = toRad(p2.lng - p1.lng);
  	
  	      const h =
  	      Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
  	      Math.cos(phi1) * Math.cos(phi2) *
  	      Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
  	
  	      return 2 * radius * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  	    }
  	
  	    function measurePathDistanceMeters(points) {
  	      const list = Array.isArray(points) ? points: [];
  	
  	      if (list.length < 2) return 0;
  	
  	      let total = 0;
  	
  	      for (let i = 0; i < list.length - 1; i++) {
  	        total += measureDistanceMeters(list[i], list[i + 1]);
  	      }
  	
  	      return total;
  	    }
  	
  	    function measureRingPerimeterMeters(points) {
  	      const list = Array.isArray(points) ? points: [];
  	
  	      if (list.length < 3) return 0;
  	
  	      let total = measurePathDistanceMeters(list);
  	
  	      total += measureDistanceMeters(list[list.length - 1], list[0]);
  	
  	      return total;
  	    }
  	
  	    function measurePolygonAreaM2(points) {
  	      const list = Array.isArray(points) ? points: [];
  	
  	      if (list.length < 3) return 0;
  	
  	      try {
  	        if (typeof rendererComputeArea === "function") {
  	          const area = rendererComputeArea(list);
  	
  	          if (Number.isFinite(Number(area))) {
  	            return Math.abs(Number(area));
  	          }
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google?.maps?.geometry?.spherical?.computeArea
  	        ) {
  	          return Math.abs(
  	            google.maps.geometry.spherical.computeArea(
  	              list.map(point => new google.maps.LatLng(point.lat, point.lng))
  	            )
  	          );
  	        }
  	      } catch (_) {}
  	
  	      const lat0 = list.reduce((sum, point) => sum + Number(point.lat), 0) / list.length;
  	      const metersPerDegLat = 111320;
  	      const metersPerDegLng = 111320 * Math.cos(lat0 * Math.PI / 180);
  	
  	      const projected = list.map(point => {
  	        return {
  	          x: Number(point.lng) * metersPerDegLng,
  	          y: Number(point.lat) * metersPerDegLat
  	        };
  	      });
  	
  	      let sum = 0;
  	
  	      for (let i = 0; i < projected.length; i++) {
  	        const a = projected[i];
  	        const b = projected[(i + 1) % projected.length];
  	
  	        sum += (a.x * b.y) - (b.x * a.y);
  	      }
  	
  	      return Math.abs(sum / 2);
  	    }
  	
  	    function measureBearingDegrees(fromPoint, toPoint) {
  	      const from = measureCleanPoint(fromPoint);
  	      const to = measureCleanPoint(toPoint);
  	
  	      if (!from || !to) return 0;
  	
  	      const toRad = value => value * Math.PI / 180;
  	      const toDeg = value => value * 180 / Math.PI;
  	
  	      const phi1 = toRad(from.lat);
  	      const phi2 = toRad(to.lat);
  	      const lambda1 = toRad(from.lng);
  	      const lambda2 = toRad(to.lng);
  	
  	      const y = Math.sin(lambda2 - lambda1) * Math.cos(phi2);
  	      const x =
  	      Math.cos(phi1) * Math.sin(phi2) -
  	      Math.sin(phi1) * Math.cos(phi2) * Math.cos(lambda2 - lambda1);
  	
  	      return (toDeg(Math.atan2(y, x)) + 360) % 360;
  	    }
  	
  	    function measureDestinationPoint(point, distanceMeters, bearingDegrees) {
  	      const start = measureCleanPoint(point);
  	
  	      if (!start) return null;
  	
  	      const radius = 6371008.8;
  	      const delta = distanceMeters / radius;
  	      const theta = bearingDegrees * Math.PI / 180;
  	
  	      const phi1 = start.lat * Math.PI / 180;
  	      const lambda1 = start.lng * Math.PI / 180;
  	
  	      const sinPhi2 =
  	      Math.sin(phi1) * Math.cos(delta) +
  	      Math.cos(phi1) * Math.sin(delta) * Math.cos(theta);
  	
  	      const phi2 = Math.asin(sinPhi2);
  	
  	      const y = Math.sin(theta) * Math.sin(delta) * Math.cos(phi1);
  	      const x = Math.cos(delta) - Math.sin(phi1) * Math.sin(phi2);
  	
  	      const lambda2 = lambda1 + Math.atan2(y, x);
  	
  	      return {
  	        lat: phi2 * 180 / Math.PI,
  	        lng: ((lambda2 * 180 / Math.PI + 540) % 360) - 180
  	      };
  	    }
  	
  	    function measureBuildPivotRing(center, radiusPoint) {
  	      const c = measureCleanPoint(center);
  	      const r = measureCleanPoint(radiusPoint);
  	
  	      if (!c || !r) return [];
  	
  	      const radiusMeters = measureDistanceMeters(c, r);
  	      const ring = [];
  	
  	      const steps = 360;
  	
  	      for (let i = 0; i < steps; i++) {
  	        ring.push(measureDestinationPoint(c, radiusMeters, i * 360 / steps));
  	      }
  	
  	      return ring.filter(Boolean);
  	    }
  	
  	    function measureBuildWedgeRing(center, radiusPoint, edgePoint) {
  	      const c = measureCleanPoint(center);
  	      const r = measureCleanPoint(radiusPoint);
  	      const e = measureCleanPoint(edgePoint);
  	
  	      if (!c || !r || !e) return [];
  	
  	      const radiusMeters = measureDistanceMeters(c, r);
  	      const startBearing = measureBearingDegrees(c, r);
  	      const endBearing = measureBearingDegrees(c, e);
  	
  	      let sweep = endBearing - startBearing;
  	
  	      if (sweep < 0) sweep += 360;
  	
  	      if (sweep <= 0.1) sweep = 360;
  	
  	      const steps = Math.max(24, Math.ceil(sweep / 1));
  	      const ring = [c];
  	
  	      for (let i = 0; i <= steps; i++) {
  	        const bearing = startBearing + (sweep * i / steps);
  	
  	        ring.push(measureDestinationPoint(c, radiusMeters, bearing));
  	      }
  	
  	      ring.push(c);
  	
  	      return ring.filter(Boolean);
  	    }
  	
  	    function measureSamePoint(a, b) {
  	      const p1 = measureCleanPoint(a);
  	      const p2 = measureCleanPoint(b);
  	
  	      if (!p1 || !p2) return false;
  	
  	      const eps =
  	      typeof FREE_GROUND_ROUTE_EPS !== "undefined"
  	      ? FREE_GROUND_ROUTE_EPS: 1e-10;
  	
  	      return (
  	        Math.abs(p1.lat - p2.lat) < eps &&
  	        Math.abs(p1.lng - p2.lng) < eps
  	      );
  	    }
  	
  	    function measurePushUniquePoint(list, point) {
  	      const clean = measureCleanPoint(point);
  	
  	      if (!clean || !Array.isArray(list)) return;
  	
  	      const last = list.length ? list[list.length - 1]: null;
  	
  	      if (last && measureSamePoint(last, clean)) return;
  	
  	      list.push(clean);
  	    }
  	
  	    function measureGetBoundaryEventsForSegment(a, b) {
  	      if (
  	        typeof getAllBoundaryEventsForSegment !== "function" ||
  	        typeof getFreeGroundBlockers !== "function"
  	      ) {
  	        return [];
  	      }
  	
  	      try {
  	        const blockers = getFreeGroundBlockers();
  	        const events = getAllBoundaryEventsForSegment(a, b, blockers);
  	
  	        return Array.isArray(events) ? events: [];
  	      } catch (_) {
  	        return [];
  	      }
  	    }
  	
  	    function measureRefineRingWithBoundaryIntersections(ring, options = {}) {
  	      const points = Array.isArray(ring)
  	      ? ring.map(measureCleanPoint).filter(Boolean): [];
  	
  	      if (points.length < 2) return points;
  	
  	      const closed = options.closed !== false;
  	      const refined = [];
  	
  	      const limit = closed ? points.length: points.length - 1;
  	
  	      for (let i = 0; i < limit; i++) {
  	        const a = points[i];
  	        const b = points[(i + 1) % points.length];
  	
  	        measurePushUniquePoint(refined, a);
  	
  	        const events = measureGetBoundaryEventsForSegment(a, b)
  	        .filter(event => {
  	          const t = Number(event?.t);
  	
  	          return Number.isFinite(t) && t > 0 && t < 1 && event?.point;
  	        })
  	        .sort((left, right) => Number(left.t) - Number(right.t));
  	
  	        events.forEach(event => {
  	          measurePushUniquePoint(refined, event.point);
  	        });
  	      }
  	
  	      if (!closed) {
  	        measurePushUniquePoint(refined, points[points.length - 1]);
  	      }
  	
  	      return refined;
  	    }
  	
  	    function measureCleanGeneratedRing(rawRing) {
  	      const ring = Array.isArray(rawRing)
  	      ? rawRing.map(measureCleanPoint).filter(Boolean): [];
  	
  	      if (ring.length >= 2 && measureSamePoint(ring[0], ring[ring.length - 1])) {
  	        ring.pop();
  	      }
  	
  	      return ring;
  	    }
  	
  	    function measureGetGeneratedMeasureBlockers() {
  	      try {
  	        if (typeof getTopLevelFreeGroundBlockers === "function") {
  	          const topLevelBlockers = getTopLevelFreeGroundBlockers();
  	
  	          if (Array.isArray(topLevelBlockers) && topLevelBlockers.length) {
  	            return topLevelBlockers;
  	          }
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (typeof getFreeGroundBlockers === "function") {
  	          const blockers = getFreeGroundBlockers();
  	
  	          if (Array.isArray(blockers)) {
  	            return blockers;
  	          }
  	        }
  	      } catch (_) {}
  	
  	      return [];
  	    }
  	
  	    function measureIsInChildResolverContext() {
  	      try {
  	        if (typeof resolveChildFreeGroundSnapDraft !== "function") return false;
  	        if (typeof getChildLocationParentBlocker !== "function") return false;
  	
  	        const parentBlocker = getChildLocationParentBlocker();
  	
  	        return !!(
  	          parentBlocker &&
  	          Array.isArray(parentBlocker.boundary) &&
  	          parentBlocker.boundary.length >= 3
  	        );
  	      } catch (_) {
  	        return false;
  	      }
  	    }
  	
  	    function measureResolveGeneratedMeasureRing(rawRing, options = {}) {
  	      const raw = measureCleanGeneratedRing(rawRing);
  	      const mode = safeString(options.mode || measureState.mode || "measure").trim();
  	
  	      if (raw.length < 3) {
  	        return {
  	          raw,
  	          points: raw,
  	          holeRings: [],
  	          holeLocations: [],
  	          snapSegments: [],
  	          usedGeneratedResolver: false,
  	          usedChildResolver: false
  	        };
  	      }
  	
  	      // CHILD MODE:
  	      // Parent boundary is the container.
  	      // Sibling child locations are blockers.
  	      // This is the resolver that already works in actual Child Create Mode.
  	      if (measureIsInChildResolverContext()) {
  	        try {
  	          const childResolved = resolveChildFreeGroundSnapDraft(raw, {
  	            source: `${mode}-measure-child-generated`,
  	            skipSiblingBlockers: false
  	          });
  	
  	          const childPoints = Array.isArray(childResolved?.points)
  	          ? childResolved.points.map(measureCleanPoint).filter(Boolean): [];
  	
  	          if (childPoints.length >= 3) {
  	            return {
  	              raw,
  	              points: childPoints,
  	              holeRings: Array.isArray(childResolved?.holeRings)
  	              ? childResolved.holeRings
  	              .map(ring => measureCleanGeneratedRing(ring))
  	              .filter(ring => ring.length >= 3): [],
  	              holeLocations: Array.isArray(childResolved?.holeLocations)
  	              ? childResolved.holeLocations: [],
  	              snapSegments: Array.isArray(childResolved?.snapSegments)
  	              ? childResolved.snapSegments: [],
  	              usedGeneratedResolver: true,
  	              usedChildResolver: true
  	            };
  	          }
  	        } catch (error) {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Measure] Child generated measure resolver failed. Falling back to free-ground resolver.", {
  	            mode,
  	            error
  	          });
  	        }
  	      }
  	
  	      // FREE GROUND MODE:
  	      // Existing top-level locations are blockers.
  	      // This is the resolver used for normal generated pivot/free-ground behaviour.
  	      try {
  	        if (typeof resolvePivotFreeGroundSnapDraft === "function") {
  	          const resolved = resolvePivotFreeGroundSnapDraft(raw, {
  	            blockers: measureGetGeneratedMeasureBlockers(),
  	            source: `${mode}-generated-measure`
  	          });
  	
  	          const points = Array.isArray(resolved?.points)
  	          ? resolved.points.map(measureCleanPoint).filter(Boolean): [];
  	
  	          if (points.length >= 3) {
  	            return {
  	              raw,
  	              points,
  	              holeRings: Array.isArray(resolved?.holeRings)
  	              ? resolved.holeRings
  	              .map(ring => measureCleanGeneratedRing(ring))
  	              .filter(ring => ring.length >= 3): [],
  	              holeLocations: Array.isArray(resolved?.holeLocations)
  	              ? resolved.holeLocations: [],
  	              snapSegments: Array.isArray(resolved?.snapSegments)
  	              ? resolved.snapSegments: [],
  	              usedGeneratedResolver: true,
  	              usedChildResolver: false
  	            };
  	          }
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Measure] Free-ground generated measure resolver failed. Falling back to intersection-only refine.", {
  	          mode,
  	          error
  	        });
  	      }
  	
  	      // LAST RESORT:
  	      // This is the old weaker behaviour. It only inserts intersection points.
  	      const fallback = measureRefineRingWithBoundaryIntersections(raw, {
  	        closed: true
  	      });
  	
  	      return {
  	        raw,
  	        points: fallback,
  	        holeRings: [],
  	        holeLocations: [],
  	        snapSegments: [],
  	        usedGeneratedResolver: false,
  	        usedChildResolver: false
  	      };
  	    }
  	
  	    function measurePointInRing(point, ring) {
  	      const p = measureCleanPoint(point);
  	      const cleanRing = Array.isArray(ring)
  	      ? ring.map(measureCleanPoint).filter(Boolean): [];
  	
  	      if (!p || cleanRing.length < 3) return false;
  	
  	      try {
  	        if (typeof pointInFreeGroundRing === "function") {
  	          return !!pointInFreeGroundRing(p, cleanRing);
  	        }
  	      } catch (_) {}
  	
  	      let inside = false;
  	
  	      for (let i = 0, j = cleanRing.length - 1; i < cleanRing.length; j = i++) {
  	        const a = cleanRing[i];
  	        const b = cleanRing[j];
  	
  	        const intersect =
  	        ((a.lat > p.lat) !== (b.lat > p.lat)) &&
  	        (
  	          p.lng <
  	          (b.lng - a.lng) * (p.lat - a.lat) / ((b.lat - a.lat) || 1e-12) + a.lng
  	        );
  	
  	        if (intersect) inside = !inside;
  	      }
  	
  	      return inside;
  	    }
  	
  	    function measureGetSegmentMidpoint(a, b) {
  	      const p1 = measureCleanPoint(a);
  	      const p2 = measureCleanPoint(b);
  	
  	      if (!p1 || !p2) return null;
  	
  	      return {
  	        lat: (p1.lat + p2.lat) / 2,
  	        lng: (p1.lng + p2.lng) / 2
  	      };
  	    }
  	
  	    function measureGetChildCookieCutters() {
  	      const result = {
  	        hasChildContext: false,
  	        parent: null,
  	        siblingBlockers: []
  	      };
  	
  	      try {
  	        if (typeof getChildLocationParentBlocker === "function") {
  	          const parent = getChildLocationParentBlocker();
  	
  	          if (
  	            parent &&
  	            Array.isArray(parent.boundary) &&
  	            parent.boundary.length >= 3
  	          ) {
  	            result.hasChildContext = true;
  	            result.parent = {
  	              ...parent,
  	              boundary: parent.boundary.map(measureCleanPoint).filter(Boolean)
  	            };
  	
  	            if (typeof getChildLocationSiblingBlockers === "function") {
  	              const siblings = getChildLocationSiblingBlockers(parent);
  	
  	              result.siblingBlockers = Array.isArray(siblings)
  	              ? siblings
  	              .filter(item => item && Array.isArray(item.boundary) && item.boundary.length >= 3)
  	              .map(item => {
  	                return {
  	                  ...item,
  	                  boundary: item.boundary.map(measureCleanPoint).filter(Boolean)
  	                };
  	              }): [];
  	            }
  	          }
  	        }
  	      } catch (_) {}
  	
  	      return result;
  	    }
  	
  	    function measureFindNearestBoundaryAnchor(point, blocker) {
  	      const p = measureCleanPoint(point);
  	      const boundary = Array.isArray(blocker?.boundary)
  	      ? blocker.boundary.map(measureCleanPoint).filter(Boolean): [];
  	
  	      if (!p || boundary.length < 2) return null;
  	
  	      let best = null;
  	
  	      for (let i = 0; i < boundary.length; i++) {
  	        const a = boundary[i];
  	        const b = boundary[(i + 1) % boundary.length];
  	
  	        try {
  	          let candidate = null;
  	
  	          if (typeof closestPointOnSegment === "function") {
  	            candidate = closestPointOnSegment(p, a, b);
  	          } else {
  	            const ax = a.lng;
  	            const ay = a.lat;
  	            const bx = b.lng;
  	            const by = b.lat;
  	            const px = p.lng;
  	            const py = p.lat;
  	
  	            const dx = bx - ax;
  	            const dy = by - ay;
  	            const len2 = dx * dx + dy * dy || 1e-12;
  	            const t = Math.max(0, Math.min(1, ((px - ax) * dx + (py - ay) * dy) / len2));
  	
  	            candidate = {
  	              lat: ay + dy * t,
  	              lng: ax + dx * t,
  	              t
  	            };
  	          }
  	
  	          const clean = measureCleanPoint(candidate);
  	
  	          if (!clean) continue;
  	
  	          const distanceSq =
  	          Math.pow(clean.lat - p.lat, 2) +
  	          Math.pow(clean.lng - p.lng, 2);
  	
  	          if (!best || distanceSq < best.distanceSq) {
  	            best = {
  	              blocker,
  	              point: clean,
  	              segmentIndex: i,
  	              t: Number.isFinite(Number(candidate?.t)) ? Number(candidate.t): 0,
  	              distanceSq
  	            };
  	          }
  	        } catch (_) {}
  	      }
  	
  	      return best;
  	    }
  	
  	    function measureWalkBoundaryBetweenCookieAnchors(fromAnchor, toAnchor, options = {}) {
  	      if (!fromAnchor || !toAnchor) return [];
  	
  	      const sameBlocker =
  	      fromAnchor.blocker &&
  	      toAnchor.blocker &&
  	      (
  	        fromAnchor.blocker === toAnchor.blocker ||
  	        safeString(fromAnchor.blocker.locationId) === safeString(toAnchor.blocker.locationId)
  	      );
  	
  	      if (!sameBlocker) return [];
  	
  	      const boundary = Array.isArray(fromAnchor.blocker.boundary)
  	      ? fromAnchor.blocker.boundary.map(measureCleanPoint).filter(Boolean): [];
  	
  	      if (boundary.length < 3) return [];
  	
  	      try {
  	        if (typeof walkBoundaryBetweenAnchors === "function") {
  	          const route = walkBoundaryBetweenAnchors(
  	            fromAnchor,
  	            toAnchor,
  	            boundary,
  	            {
  	              preferShortest: true,
  	              outerRing: options.outerRing || null
  	            }
  	          );
  	
  	          if (Array.isArray(route) && route.length) {
  	            return route.map(measureCleanPoint).filter(Boolean);
  	          }
  	        }
  	      } catch (_) {}
  	
  	      // Fallback boundary walk.
  	      const n = boundary.length;
  	      const startIndex = Math.max(0, Math.min(n - 1, Number(fromAnchor.segmentIndex) || 0));
  	      const endIndex = Math.max(0, Math.min(n - 1, Number(toAnchor.segmentIndex) || 0));
  	
  	      function forwardRoute() {
  	        const route = [fromAnchor.point];
  	        let i = (startIndex + 1) % n;
  	
  	        let guard = 0;
  	
  	        while (guard++ < n + 2) {
  	          route.push(boundary[i]);
  	
  	          if (i === endIndex) break;
  	
  	          i = (i + 1) % n;
  	        }
  	
  	        route.push(toAnchor.point);
  	
  	        return route;
  	      }
  	
  	      function backwardRoute() {
  	        const route = [fromAnchor.point];
  	        let i = startIndex;
  	
  	        let guard = 0;
  	
  	        while (guard++ < n + 2) {
  	          route.push(boundary[i]);
  	
  	          if (i === endIndex) break;
  	
  	          i = (i - 1 + n) % n;
  	        }
  	
  	        route.push(toAnchor.point);
  	
  	        return route;
  	      }
  	
  	      const forward = forwardRoute();
  	      const backward = backwardRoute();
  	
  	      const forwardDistance = measurePathDistanceMeters(forward);
  	      const backwardDistance = measurePathDistanceMeters(backward);
  	
  	      return forwardDistance <= backwardDistance ? forward: backward;
  	    }
  	
  	    function measureIsPointLegalInCookieContext(point, cutters) {
  	      const p = measureCleanPoint(point);
  	
  	      if (!p || !cutters || !cutters.hasChildContext) return true;
  	
  	      if (
  	        cutters.parent &&
  	        Array.isArray(cutters.parent.boundary) &&
  	        cutters.parent.boundary.length >= 3 &&
  	        !measurePointInRing(p, cutters.parent.boundary)
  	      ) {
  	        return false;
  	      }
  	
  	      const siblings = Array.isArray(cutters.siblingBlockers)
  	      ? cutters.siblingBlockers: [];
  	
  	      for (let i = 0; i < siblings.length; i++) {
  	        const blocker = siblings[i];
  	
  	        if (
  	          blocker &&
  	          Array.isArray(blocker.boundary) &&
  	          blocker.boundary.length >= 3 &&
  	          measurePointInRing(p, blocker.boundary)
  	        ) {
  	          return false;
  	        }
  	      }
  	
  	      return true;
  	    }
  	
  	    function measureFindPrimaryCookieBlocker(point, cutters) {
  	      const p = measureCleanPoint(point);
  	
  	      if (!p || !cutters || !cutters.hasChildContext) return null;
  	
  	      if (
  	        cutters.parent &&
  	        Array.isArray(cutters.parent.boundary) &&
  	        cutters.parent.boundary.length >= 3 &&
  	        !measurePointInRing(p, cutters.parent.boundary)
  	      ) {
  	        return cutters.parent;
  	      }
  	
  	      const siblings = Array.isArray(cutters.siblingBlockers)
  	      ? cutters.siblingBlockers: [];
  	
  	      for (let i = 0; i < siblings.length; i++) {
  	        const blocker = siblings[i];
  	
  	        if (
  	          blocker &&
  	          Array.isArray(blocker.boundary) &&
  	          blocker.boundary.length >= 3 &&
  	          measurePointInRing(p, blocker.boundary)
  	        ) {
  	          return blocker;
  	        }
  	      }
  	
  	      return null;
  	    }
  	
  	    function measureClipGeneratedShapeLive(rawRing, options = {}) {
  	      const raw = measureCleanGeneratedRing(rawRing);
  	      const mode = safeString(options.mode || measureState.mode || "measure");
  	
  	      const cutters = measureGetChildCookieCutters();
  	
  	      if (!cutters.hasChildContext || raw.length < 3) {
  	        return measureResolveGeneratedMeasureRing(raw, {
  	          mode
  	        });
  	      }
  	
  	      const refined = measureRefineRingWithBoundaryIntersections(raw, {
  	        closed: true
  	      });
  	
  	      if (!refined.length) {
  	        return {
  	          raw,
  	          points: raw,
  	          holeRings: [],
  	          holeLocations: [],
  	          snapSegments: [],
  	          usedCookieCutter: false
  	        };
  	      }
  	
  	      const output = [];
  	      let gapStartAnchor = null;
  	      let previousLegalPoint = null;
  	      let previousWasLegal = null;
  	
  	      for (let i = 0; i < refined.length; i++) {
  	        const current = refined[i];
  	        const next = refined[(i + 1) % refined.length];
  	        const mid = measureGetSegmentMidpoint(current, next);
  	
  	        const currentLegal = measureIsPointLegalInCookieContext(current, cutters);
  	        const segmentLegal = measureIsPointLegalInCookieContext(mid || current, cutters);
  	
  	        if (previousWasLegal === null) {
  	          previousWasLegal = currentLegal;
  	        }
  	
  	        if (currentLegal && !previousWasLegal && gapStartAnchor) {
  	          const blocker = gapStartAnchor.blocker || measureFindPrimaryCookieBlocker(current, cutters);
  	          const endAnchor = measureFindNearestBoundaryAnchor(current, blocker);
  	
  	          const route = measureWalkBoundaryBetweenCookieAnchors(
  	            gapStartAnchor,
  	            endAnchor,
  	            {
  	              outerRing: raw
  	            }
  	          );
  	
  	          if (route.length) {
  	            route.forEach(point => measurePushUniquePoint(output, point));
  	          } else {
  	            measurePushUniquePoint(output, current);
  	          }
  	
  	          gapStartAnchor = null;
  	        }
  	
  	        if (currentLegal) {
  	          measurePushUniquePoint(output, current);
  	          previousLegalPoint = current;
  	        }
  	
  	        if (currentLegal && !segmentLegal) {
  	          const blocker = measureFindPrimaryCookieBlocker(mid || next, cutters);
  	          const startAnchor = measureFindNearestBoundaryAnchor(next, blocker);
  	
  	          gapStartAnchor = startAnchor || {
  	            blocker,
  	            point: current,
  	            segmentIndex: 0,
  	            t: 0
  	          };
  	        }
  	
  	        previousWasLegal = segmentLegal;
  	      }
  	
  	      if (output.length < 3) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Measure] Live cookie cutter produced too few points; using child resolver fallback.", {
  	          mode,
  	          outputLength: output.length
  	        });
  	
  	        return measureResolveGeneratedMeasureRing(raw, {
  	          mode
  	        });
  	      }
  	
  	      return {
  	        raw,
  	        points: output,
  	        holeRings: [],
  	        holeLocations: [],
  	        snapSegments: [],
  	        usedGeneratedResolver: true,
  	        usedChildResolver: true,
  	        usedCookieCutter: true
  	      };
  	    }
  	
  	    function measureBuildPolygonPathsFromResolved(resolved) {
  	      const outer = Array.isArray(resolved?.points)
  	      ? resolved.points.map(measureCleanPoint).filter(Boolean): [];
  	
  	      if (outer.length < 3) return [];
  	
  	      const paths = [outer];
  	
  	      const holes = Array.isArray(resolved?.holeRings)
  	      ? resolved.holeRings: [];
  	
  	      holes.forEach(ring => {
  	        const clean = measureCleanGeneratedRing(ring);
  	
  	        if (clean.length >= 3) {
  	          paths.push(clean);
  	        }
  	      });
  	
  	      return paths;
  	    }
  	
  	    function measureAreaM2WithHoles(outerRing,
  	      holeRings) {
  	      const outerArea = measurePolygonAreaM2(outerRing);
  	
  	      if (!Array.isArray(holeRings) || !holeRings.length) {
  	        return outerArea;
  	      }
  	
  	      let holeArea = 0;
  	
  	      holeRings.forEach(ring => {
  	        const clean = measureCleanGeneratedRing(ring);
  	
  	        if (clean.length >= 3) {
  	          holeArea += measurePolygonAreaM2(clean);
  	        }
  	      });
  	
  	      return Math.max(0,
  	        outerArea - holeArea);
  	    }
  	
  	    function measureClearTemporaryOverlays(options = {}) {
  	      const preserveMarkers = !!options.preserveMarkers;
  	
  	      if (!preserveMarkers) {
  	        if (Array.isArray(measureState.markers)) {
  	          measureState.markers.forEach(item => {
  	            try {
  	              if (item && typeof item.setMap === "function") {
  	                item.setMap(null);
  	              }
  	            } catch (_) {}
  	          });
  	        }
  	
  	        measureState.markers = [];
  	      }
  	
  	      if (Array.isArray(measureState.guideLines)) {
  	        measureState.guideLines.forEach(item => {
  	          try {
  	            if (item && typeof item.setMap === "function") {
  	              item.setMap(null);
  	            }
  	          } catch (_) {}
  	        });
  	      }
  	
  	      measureState.guideLines = [];
  	
  	      [
  	        "polyline",
  	        "polygon",
  	        "circle"
  	      ].forEach(key => {
  	          try {
  	            if (measureState[key] && typeof measureState[key].setMap === "function") {
  	              measureState[key].setMap(null);
  	            }
  	          } catch (_) {}
  	
  	          measureState[key] = null;
  	        });
  	    }
  	
  	    function measureResetResults() {
  	      measureState.results = {
  	        distanceMeters: 0,
  	        perimeterMeters: 0,
  	        areaM2: 0,
  	        radiusMeters: 0,
  	        diameterMeters: 0,
  	        circumferenceMeters: 0,
  	        arcMeters: 0,
  	        pointCount: Array.isArray(measureState.points) ? measureState.points.length: 0
  	      };
  	    }
  	
  	    function measureClonePoint(point) {
  	      const clean = measureCleanPoint(point);
  	
  	      if (!clean) return null;
  	
  	      return {
  	        lat: clean.lat,
  	        lng: clean.lng
  	      };
  	    }
  	
  	    function measureOffsetPoint(point, delta) {
  	      const clean = measureCleanPoint(point);
  	
  	      if (!clean || !delta) return null;
  	
  	      return {
  	        lat: clean.lat + Number(delta.lat || 0),
  	        lng: clean.lng + Number(delta.lng || 0)
  	      };
  	    }
  	
  	    function getMeasurePointHandleLabel(index) {
  	      const mode = safeString(measureState.mode);
  	
  	      if (mode === "measurePivot") {
  	        if (index === 0) return "C";
  	        if (index === 1) return "R";
  	      }
  	
  	      if (mode === "measureWedge") {
  	        if (index === 0) return "C";
  	        if (index === 1) return "R";
  	        if (index === 2) return "E";
  	      }
  	
  	      return String(index + 1);
  	    }
  	
  	    function getMeasurePointHandleColor(index) {
  	      const mode = safeString(measureState.mode);
  	
  	      if (
  	        (mode === "measurePivot" || mode === "measureWedge") &&
  	        index === 0
  	      ) {
  	        return "#8dff63";
  	      }
  	
  	      return "#ff8a3d";
  	    }
  	
  	    function measureGetMarkerEventPoint(event) {
  	      return measureLatLngToPlain(event?.latLng);
  	    }
  	
  	    function measureApplyDraggedPoint(index, rawPoint) {
  	      if (!Array.isArray(measureState.points)) {
  	        measureState.points = [];
  	      }
  	
  	      if (!Array.isArray(measureState.rawPoints)) {
  	        measureState.rawPoints = [];
  	      }
  	
  	      const safeIndex = Number(index);
  	
  	      if (!Number.isInteger(safeIndex) || safeIndex < 0) return false;
  	
  	      const raw = measureCleanPoint(rawPoint);
  	
  	      if (!raw) return false;
  	
  	      const mode = safeString(measureState.mode);
  	
  	      const headingStart =
  	      (
  	        mode === "measurePivot" ||
  	        mode === "measureWedge"
  	      ) &&
  	      safeIndex > 0
  	      ? measureCleanPoint(measureState.points[0]): null;
  	
  	      const resolved = measureResolvePoint(raw, {
  	        headingStart
  	      }) || raw;
  	
  	      const points = measureState.points;
  	      const rawPoints = measureState.rawPoints;
  	
  	      const oldPoint = measureCleanPoint(points[safeIndex]);
  	
  	      if (!oldPoint) return false;
  	
  	      const shouldMoveWholeShape =
  	      safeIndex === 0 &&
  	      (
  	        mode === "measurePivot" ||
  	        mode === "measureWedge"
  	      ) &&
  	      points.length > 1;
  	
  	      if (shouldMoveWholeShape) {
  	        const delta = {
  	          lat: resolved.lat - oldPoint.lat,
  	          lng: resolved.lng - oldPoint.lng
  	        };
  	
  	        measureState.points = points
  	        .map(point => measureOffsetPoint(point, delta))
  	        .filter(Boolean);
  	
  	        measureState.rawPoints = measureState.points.map(measureClonePoint).filter(Boolean);
  	
  	        return true;
  	      }
  	
  	      points[safeIndex] = resolved;
  	      rawPoints[safeIndex] = raw;
  	
  	      return true;
  	    }
  	
  	    function measureSyncMarkers(map, points) {
  	      if (!map || !Array.isArray(points)) return;
  	
  	      if (!Array.isArray(measureState.markers)) {
  	        measureState.markers = [];
  	      }
  	
  	      while (measureState.markers.length > points.length) {
  	        const marker = measureState.markers.pop();
  	
  	        try {
  	          if (marker && typeof marker.setMap === "function") {
  	            marker.setMap(null);
  	          }
  	        } catch (_) {}
  	      }
  	
  	      points.forEach((point, index) => {
  	        let marker = measureState.markers[index] || null;
  	
  	        if (!marker) {
  	          marker = measureCreateMarker(map, point, index);
  	
  	          if (marker) {
  	            measureState.markers[index] = marker;
  	          }
  	
  	          return;
  	        }
  	
  	        try {
  	          marker.__trackitMeasurePointIndex = index;
  	
  	          if (typeof marker.setPosition === "function") {
  	            marker.setPosition(point);
  	          }
  	
  	          if (typeof marker.setLabel === "function") {
  	            marker.setLabel({
  	              text: getMeasurePointHandleLabel(index),
  	              color: "#ffffff",
  	              fontSize: "10px",
  	              fontWeight: "900"
  	            });
  	          }
  	
  	          if (typeof marker.setIcon === "function") {
  	            marker.setIcon({
  	              path: google.maps.SymbolPath.CIRCLE,
  	              scale: index === 0 &&
  	              (
  	                measureState.mode === "measurePivot" ||
  	                measureState.mode === "measureWedge"
  	              )
  	              ? 8: 7,
  	              fillColor: getMeasurePointHandleColor(index),
  	              fillOpacity: 1,
  	              strokeColor: "#111111",
  	              strokeWeight: 3
  	            });
  	          }
  	        } catch (_) {}
  	      });
  	    }
  	
  	    function measureCreateMarker(map,
  	      point,
  	      index) {
  	      if (
  	        !map ||
  	        !point ||
  	        typeof google === "undefined" ||
  	        !google?.maps ||
  	        !google.maps.Marker
  	      ) {
  	        return null;
  	      }
  	
  	      try {
  	        const marker = new google.maps.Marker({
  	          map,
  	          position: point,
  	          clickable: true,
  	          draggable: true,
  	          optimized: false,
  	          crossOnDrag: false,
  	          cursor: "grab",
  	          zIndex: 2147483607,
  	          label: {
  	            text: getMeasurePointHandleLabel(index),
  	            color: "#ffffff",
  	            fontSize: "10px",
  	            fontWeight: "900"
  	          },
  	          icon: {
  	            path: google.maps.SymbolPath.CIRCLE,
  	            scale: index === 0 &&
  	            (
  	              measureState.mode === "measurePivot" ||
  	              measureState.mode === "measureWedge"
  	            )
  	            ? 8: 7,
  	            fillColor: getMeasurePointHandleColor(index),
  	            fillOpacity: 1,
  	            strokeColor: "#111111",
  	            strokeWeight: 3
  	          }
  	        });
  	
  	        marker.__trackitMeasurePointIndex = index;
  	
  	        marker.addListener("dragstart", event => {
  	          try {
  	            measureState.isDraggingPoint = true;
  	            measureState.draggingMarkerIndex = marker.__trackitMeasurePointIndex;
  	            marker.setCursor?.("grabbing");
  	          } catch (_) {}
  	        });
  	
  	        marker.addListener("drag", event => {
  	          const markerIndex = marker.__trackitMeasurePointIndex;
  	          const rawPoint = measureGetMarkerEventPoint(event);
  	
  	          if (!rawPoint) return;
  	
  	          const changed = measureApplyDraggedPoint(markerIndex, rawPoint);
  	
  	          if (!changed) return;
  	
  	          measureRenderDraft({
  	            preserveMarkers: true
  	          });
  	        });
  	
  	        marker.addListener("dragend",
  	          event => {
  	            const markerIndex = marker.__trackitMeasurePointIndex;
  	            const rawPoint = measureGetMarkerEventPoint(event);
  	
  	            if (rawPoint) {
  	              measureApplyDraggedPoint(markerIndex, rawPoint);
  	            }
  	
  	            try {
  	              measureState.isDraggingPoint = false;
  	              measureState.draggingMarkerIndex = -1;
  	              measureState.lastDragAt = Date.now();
  	              marker.setCursor?.("grab");
  	            } catch (_) {}
  	
  	            measureRenderDraft({
  	              preserveMarkers: true
  	            });
  	
  	            refreshMeasurePanel();
  	          });
  	
  	        return marker;
  	      } catch (_) {
  	        return null;
  	      }
  	    }
  	
  	    function measureRenderDraft(options = {}) {
  	      const map = measureState.map || getMapControlMap();
  	
  	      if (!map || typeof google === "undefined" || !google?.maps) return;
  	
  	      const points = Array.isArray(measureState.points) ? measureState.points: [];
  	      const mode = measureState.mode;
  	
  	      measureClearTemporaryOverlays(options);
  	      measureResetResults();
  	
  	      if (options && options.preserveMarkers) {
  	        measureSyncMarkers(map, points);
  	      } else {
  	        points.forEach((point, index) => {
  	          const marker = measureCreateMarker(map, point, index);
  	
  	          if (marker) {
  	            measureState.markers.push(marker);
  	          }
  	        });
  	      }
  	
  	      if (mode === "measureRuler") {
  	        const used = points.slice(0, 2);
  	
  	        if (used.length >= 2) {
  	          measureState.results.distanceMeters = measureDistanceMeters(used[0], used[1]);
  	
  	          measureState.polyline = new google.maps.Polyline({
  	            map,
  	            path: used,
  	            strokeColor: "#ff8a3d",
  	            strokeOpacity: 0.98,
  	            strokeWeight: 3,
  	            clickable: false,
  	            zIndex: 2147483605
  	          });
  	        }
  	
  	        measureState.message = used.length < 2
  	        ? "Click the second point.": "Ruler complete. Click Ruler again to restart, or Clear.";
  	      }
  	
  	      if (mode === "measurePath") {
  	        measureState.results.distanceMeters = measurePathDistanceMeters(points);
  	
  	        if (points.length >= 2) {
  	          measureState.polyline = new google.maps.Polyline({
  	            map,
  	            path: points,
  	            strokeColor: "#ff8a3d",
  	            strokeOpacity: 0.98,
  	            strokeWeight: 3,
  	            clickable: false,
  	            zIndex: 2147483605
  	          });
  	        }
  	
  	        measureState.message = points.length
  	        ? "Continue clicking to extend the path.": "Click the first path point.";
  	      }
  	
  	      if (mode === "measurePolygon") {
  	        measureState.results.perimeterMeters = measureRingPerimeterMeters(points);
  	        measureState.results.areaM2 = measurePolygonAreaM2(points);
  	
  	        if (points.length >= 2) {
  	          measureState.polyline = new google.maps.Polyline({
  	            map,
  	            path: points,
  	            strokeColor: "#ff8a3d",
  	            strokeOpacity: 0.98,
  	            strokeWeight: 2,
  	            clickable: false,
  	            zIndex: 2147483604
  	          });
  	        }
  	
  	        if (points.length >= 3) {
  	          const refinedPoints = measureRefineRingWithBoundaryIntersections(points, {
  	            closed: true
  	          });
  	
  	          measureState.polygon = new google.maps.Polygon({
  	            map,
  	            paths: refinedPoints,
  	            strokeColor: "#ff8a3d",
  	            strokeOpacity: 0.98,
  	            strokeWeight: 2,
  	            fillColor: "#ff8a3d",
  	            fillOpacity: 0.24,
  	            clickable: false,
  	            zIndex: 2147483603
  	          });
  	        }
  	
  	        measureState.message = points.length < 3
  	        ? "Click at least three points to calculate area.": "Continue clicking to refine the polygon area.";
  	      }
  	
  	      if (mode === "measurePivot") {
  	        const center = points[0] || null;
  	        const radiusPoint = points[1] || null;
  	
  	        if (center && radiusPoint) {
  	          const radiusMeters = measureDistanceMeters(center, radiusPoint);
  	
  	          const resolved = measureClipGeneratedShapeLive(
  	            measureBuildPivotRing(center, radiusPoint),
  	            {
  	              mode: "measurePivot"
  	            }
  	          );
  	
  	          const ring = resolved.points || [];
  	          const polygonPaths = measureBuildPolygonPathsFromResolved(resolved);
  	
  	          measureState.results.radiusMeters = radiusMeters;
  	          measureState.results.diameterMeters = radiusMeters * 2;
  	
  	          // Important:
  	          // For generated/clipped measurement, perimeter and area must come from the
  	          // displayed resolved shape, not from the perfect mathematical circle.
  	          measureState.results.circumferenceMeters = ring.length >= 3
  	          ? measureRingPerimeterMeters(ring): 2 * Math.PI * radiusMeters;
  	
  	          measureState.results.perimeterMeters = measureState.results.circumferenceMeters;
  	
  	          measureState.results.areaM2 = ring.length >= 3
  	          ? measureAreaM2WithHoles(ring, resolved.holeRings): Math.PI * radiusMeters * radiusMeters;
  	
  	          measureState.guideLines.push(
  	            new google.maps.Polyline({
  	              map,
  	              path: [center, radiusPoint],
  	              strokeColor: "#ff8a3d",
  	              strokeOpacity: 0.98,
  	              strokeWeight: 2,
  	              clickable: false,
  	              zIndex: 2147483604
  	            })
  	          );
  	
  	          if (polygonPaths.length) {
  	            measureState.polygon = new google.maps.Polygon({
  	              map,
  	              paths: polygonPaths,
  	              strokeColor: "#ff8a3d",
  	              strokeOpacity: 0.98,
  	              strokeWeight: 2,
  	              fillColor: "#ff8a3d",
  	              fillOpacity: 0.22,
  	              clickable: false,
  	              zIndex: 2147483603
  	            });
  	          }
  	        }
  	
  	        measureState.message = points.length < 1
  	        ? "Click the pivot centre.": points.length < 2
  	        ? "Click the radius point.": "Pivot measurement complete. Click Pivot again to restart, or Clear.";
  	      }
  	
  	      if (mode === "measureWedge") {
  	        const center = points[0] || null;
  	        const radiusPoint = points[1] || null;
  	        const edgePoint = points[2] || null;
  	
  	        if (center && radiusPoint) {
  	          measureState.guideLines.push(
  	            new google.maps.Polyline({
  	              map,
  	              path: [center, radiusPoint],
  	              strokeColor: "#ff8a3d",
  	              strokeOpacity: 0.98,
  	              strokeWeight: 2,
  	              clickable: false,
  	              zIndex: 2147483604
  	            })
  	          );
  	        }
  	
  	        if (center && edgePoint) {
  	          measureState.guideLines.push(
  	            new google.maps.Polyline({
  	              map,
  	              path: [center, edgePoint],
  	              strokeColor: "#ff8a3d",
  	              strokeOpacity: 0.98,
  	              strokeWeight: 2,
  	              clickable: false,
  	              zIndex: 2147483604
  	            })
  	          );
  	        }
  	
  	        if (center && radiusPoint && edgePoint) {
  	          const radiusMeters = measureDistanceMeters(center, radiusPoint);
  	          const startBearing = measureBearingDegrees(center, radiusPoint);
  	          const endBearing = measureBearingDegrees(center, edgePoint);
  	
  	          let sweep = endBearing - startBearing;
  	
  	          if (sweep < 0) sweep += 360;
  	          if (sweep <= 0.1) sweep = 360;
  	
  	          const rawWedgeRing =
  	          typeof buildWedgeRawPoints === "function"
  	          ? buildWedgeRawPoints(center, radiusPoint, edgePoint): measureBuildWedgeRing(center, radiusPoint, edgePoint);
  	
  	          const resolved = measureClipGeneratedShapeLive(rawWedgeRing, {
  	            mode: "measureWedge"
  	          });
  	
  	          const ring = resolved.points || [];
  	          const polygonPaths = measureBuildPolygonPathsFromResolved(resolved);
  	
  	          const rawAreaM2 = Math.PI * radiusMeters * radiusMeters * (sweep / 360);
  	          const rawArcMeters = 2 * Math.PI * radiusMeters * (sweep / 360);
  	          const rawPerimeterMeters = rawArcMeters + (radiusMeters * 2);
  	
  	          measureState.results.radiusMeters = radiusMeters;
  	
  	          // Arc remains the intended mathematical arc.
  	          // Perimeter and area come from the displayed resolved shape.
  	          measureState.results.arcMeters = rawArcMeters;
  	
  	          measureState.results.perimeterMeters = ring.length >= 3
  	          ? measureRingPerimeterMeters(ring): rawPerimeterMeters;
  	
  	          measureState.results.areaM2 = ring.length >= 3
  	          ? measureAreaM2WithHoles(ring, resolved.holeRings): rawAreaM2;
  	
  	          if (polygonPaths.length) {
  	            measureState.polygon = new google.maps.Polygon({
  	              map,
  	              paths: polygonPaths,
  	              strokeColor: "#ff8a3d",
  	              strokeOpacity: 0.98,
  	              strokeWeight: 2,
  	              fillColor: "#ff8a3d",
  	              fillOpacity: 0.22,
  	              clickable: false,
  	              zIndex: 2147483603
  	            });
  	          }
  	        }
  	
  	        measureState.message = points.length < 1
  	        ? "Click the wedge centre.": points.length < 2
  	        ? "Click the radius point.": points.length < 3
  	        ? "Click the edge point.": "Wedge measurement complete. Click Wedge again to restart, or Clear.";
  	      }
  	
  	      measureState.results.pointCount = points.length;
  	    }
  	
  	    function startMapMeasureMode(mode) {
  	      const map = getMapControlMap();
  	
  	      if (!map) {
  	        measureState.message = "Map is not ready yet.";
  	        refreshMeasurePanel();
  	        return;
  	      }
  	
  	      if (measureState.mode === mode && measureState.isActive) {
  	        measureState.rawPoints = [];
  	        measureState.points = [];
  	      } else {
  	        measureState.mode = mode;
  	        measureState.rawPoints = [];
  	        measureState.points = [];
  	      }
  	
  	      measureState.isActive = true;
  	      measureState.map = map;
  	      measureState.message = getMeasureModeInstruction(mode);
  	
  	      measureRenderDraft();
  	      bindMapMeasureClick(map);
  	      refreshMeasurePanel();
  	    }
  	
  	    function clearMapMeasure() {
  	      measureState.rawPoints = [];
  	      measureState.points = [];
  	      measureState.message = getMeasureModeInstruction(measureState.mode);
  	
  	      measureRenderDraft();
  	      refreshMeasurePanel();
  	    }
  	
  	    function closeMapMeasure() {
  	      measureClearTemporaryOverlays();
  	
  	      measureState.isActive = false;
  	      measureState.mode = "";
  	      measureState.map = null;
  	      measureState.rawPoints = [];
  	      measureState.points = [];
  	      measureState.message = "Choose a measure tool.";
  	
  	      measureResetResults();
  	      refreshMeasurePanel();
  	    }
  	
  	    function undoMapMeasurePoint() {
  	      if (!measureState.points.length) return;
  	
  	      measureState.points.pop();
  	      measureState.rawPoints.pop();
  	
  	      measureRenderDraft();
  	      refreshMeasurePanel();
  	    }
  	
  	    function handleMapMeasureClick(map, rawPoint) {
  	      if (!isMapMeasureActive()) return false;
  	
  	      if (measureState.lastDragAt && Date.now() - measureState.lastDragAt < 350) {
  	        return true;
  	      }
  	
  	      const mode = measureState.mode;
  	
  	      const headingStart =
  	      (
  	        mode === "measurePivot" ||
  	        mode === "measureWedge"
  	      ) &&
  	      measureState.points.length > 0
  	      ? measureCleanPoint(measureState.points[0]): null;
  	
  	      const point = measureResolvePoint(rawPoint, {
  	        headingStart
  	      });
  	
  	      if (!point) return true;
  	
  	      if (mode === "measureRuler" && measureState.points.length >= 2) {
  	        measureState.rawPoints = [];
  	        measureState.points = [];
  	      }
  	
  	      if (mode === "measurePivot" && measureState.points.length >= 2) {
  	        measureState.rawPoints = [];
  	        measureState.points = [];
  	      }
  	
  	      if (mode === "measureWedge" && measureState.points.length >= 3) {
  	        measureState.rawPoints = [];
  	        measureState.points = [];
  	      }
  	
  	      measureState.rawPoints.push(rawPoint);
  	      measureState.points.push(point);
  	      measureState.map = map;
  	
  	      measureRenderDraft();
  	      refreshMeasurePanel();
  	
  	      return true;
  	    }
  	
  	    function bindMapMeasureClick(map) {
  	      if (!map || map.__trackitMeasureClickBound) return;
  	
  	      map.__trackitMeasureClickBound = true;
  	
  	      try {
  	        map.addListener("click", event => {
  	          if (!isMapMeasureActive()) return;
  	
  	          const point = measureLatLngToPlain(event?.latLng);
  	
  	          handleMapMeasureClick(map, point);
  	        });
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Measure] Could not bind measure click.",
  	          error);
  	      }
  	    }
  	
  	    function createMeasureDataPanelHtml() {
  	      if (!measureState.isActive) return "";
  	
  	      const mode = measureState.mode;
  	      const results = measureState.results || {};
  	      const title = getMeasureModeLabel(mode);
  	
  	      let rows = "";
  	
  	      function row(label, value) {
  	        rows += `
  	        <div class="ces-measure-data-row">
  	        <span>${escapeHtml(label)}</span>
  	        <strong>${escapeHtml(value)}</strong>
  	        </div>
  	        `;
  	      }
  	
  	      if (mode === "measureRuler") {
  	        row("Distance", formatMeasureDistance(results.distanceMeters));
  	      }
  	
  	      if (mode === "measurePath") {
  	        row("Total Distance", formatMeasureDistance(results.distanceMeters));
  	        row("Points", safeString(results.pointCount || 0));
  	      }
  	
  	      if (mode === "measurePolygon") {
  	        row("Perimeter", formatMeasureDistance(results.perimeterMeters));
  	        row("Area", formatMeasureAreaHa(results.areaM2));
  	        row("Area m²", formatMeasureAreaM2(results.areaM2));
  	        row("Points", safeString(results.pointCount || 0));
  	      }
  	
  	      if (mode === "measurePivot") {
  	        row("Radius", formatMeasureDistance(results.radiusMeters));
  	        row("Diameter", formatMeasureDistance(results.diameterMeters));
  	        row("Circumference", formatMeasureDistance(results.circumferenceMeters));
  	        row("Area", formatMeasureAreaHa(results.areaM2));
  	      }
  	
  	      if (mode === "measureWedge") {
  	        row("Radius", formatMeasureDistance(results.radiusMeters));
  	        row("Arc", formatMeasureDistance(results.arcMeters));
  	        row("Perimeter", formatMeasureDistance(results.perimeterMeters));
  	        row("Area", formatMeasureAreaHa(results.areaM2));
  	      }
  	
  	      return `
  	      <div class="ces-measure-data-panel">
  	      <div class="ces-measure-data-head">
  	      <div>
  	      <div class="ces-measure-data-kicker">Measure</div>
  	      <div class="ces-measure-data-title">${escapeHtml(title)}</div>
  	      </div>
  	
  	      <button class="ces-measure-close" type="button" data-map-tool="measureClose" title="Close Measure">×</button>
  	      </div>
  	
  	      <div class="ces-measure-help">${escapeHtml(measureState.message || "")}</div>
  	
  	      <div class="ces-measure-data-rows">
  	      ${rows}
  	      </div>
  	
  	      <div class="ces-measure-actions">
  	      <button type="button" data-map-tool="measureUndo">Undo Point</button>
  	      <button type="button" data-map-tool="measureClear">Clear</button>
  	      </div>
  	      </div>
  	      `;
  	    }
  	
  	    function createMapControlIcon(type) {
  	      const key = safeString(type).trim().toLowerCase();
  	
  	
  	
  	      if (key === "traffic") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <path d="M6 17h12M7.5 17v2.2M16.5 17v2.2M7 14l1.3-5.5h7.4L17 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  	        <path d="M7 14h10v3H7v-3z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  	        </svg>
  	        `;
  	      }
  	
  	      if (key === "labels") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <path d="M5 5h14v14H5V5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  	        <path d="M8 9h8M8 13h6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  	        </svg>
  	        `;
  	      }
  	
  	      if (key === "fullscreen") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <path d="M8 4H4v4M16 4h4v4M8 20H4v-4M16 20h4v-4" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
  	        </svg>
  	        `;
  	      }
  	
  	      if (key === "secondarylocations") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <path d="M7 7h8v8H7V7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  	        <path d="M11 11h6v6h-6v-6z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" opacity="0.72"/>
  	        <path d="M5 19L19 5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
  	        </svg>
  	        `;
  	      }
  	
  	      if (key === "alllocations") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <path d="M12 21s6-5.4 6-11a6 6 0 1 0-12 0c0 5.6 6 11 6 11z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  	        <circle cx="12" cy="10" r="2" fill="none" stroke="currentColor" stroke-width="1.6"/>
  	        <path d="M5 20L20 5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
  	        </svg>
  	        `;
  	      }
  	
  	      if (key === "measureruler") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <path d="M4 17L17 4l3 3L7 20l-3-3z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  	        <path d="M8 16l-1.5-1.5M11 13l-1.5-1.5M14 10l-1.5-1.5M17 7l-1.5-1.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
  	        </svg>
  	        `;
  	      }
  	
  	      if (key === "measurepath") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <path d="M5 17c4-8 10 2 14-6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
  	        <circle cx="5" cy="17" r="2" fill="none" stroke="currentColor" stroke-width="1.6"/>
  	        <circle cx="12" cy="13" r="2" fill="none" stroke="currentColor" stroke-width="1.6"/>
  	        <circle cx="19" cy="11" r="2" fill="none" stroke="currentColor" stroke-width="1.6"/>
  	        </svg>
  	        `;
  	      }
  	
  	      if (key === "measurepolygon") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <path d="M6 7l7-3 6 6-3 8-9 1-3-7 2-5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  	        <circle cx="6" cy="7" r="1.3" fill="currentColor"/>
  	        <circle cx="13" cy="4" r="1.3" fill="currentColor"/>
  	        <circle cx="19" cy="10" r="1.3" fill="currentColor"/>
  	        <circle cx="16" cy="18" r="1.3" fill="currentColor"/>
  	        </svg>
  	        `;
  	      }
  	
  	      if (key === "measurepivot") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" stroke-width="1.8"/>
  	        <circle cx="12" cy="12" r="1.6" fill="currentColor"/>
  	        <path d="M12 12h7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  	        </svg>
  	        `;
  	      }
  	
  	      if (key === "measurewedge") {
  	        return `
  	        <svg viewBox="0 0 24 24" aria-hidden="true">
  	        <path d="M12 12l7-1a7 7 0 0 1-5 7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  	        <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
  	        <path d="M12 12l3-6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  	        </svg>
  	        `;
  	      }
  	
  	
  	      return `
  	      <svg viewBox="0 0 24 24" aria-hidden="true">
  	      <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" stroke-width="1.8"/>
  	      </svg>
  	      `;
  	    }
  	
  	
  	    function createMapToolButton(tool, label, active) {
  	      return `
  	      <button
  	      class="ces-map-control-tool ${active ? "active": ""}"
  	      type="button"
  	      data-map-tool="${escapeHtml(tool)}"
  	      aria-pressed="${active ? "true": "false"}"
  	      title="${escapeHtml(label)}"
  	      >
  	      ${createMapControlIcon(tool)}
  	      <span>${escapeHtml(label)}</span>
  	      </button>
  	      `;
  	    }
  	
  	    function sizeMapControlShell(bottomSection, isOpen) {
  	      if (!bottomSection) return;
  	
  	      function setStyle(element, property, value) {
  	        if (!element) return;
  	
  	        try {
  	          element.style.setProperty(property, value, "important");
  	        } catch (_) {
  	          try {
  	            element.style[property] = value;
  	          } catch (_) {}
  	        }
  	      }
  	
  	      const content = bottomSection.querySelector(".ces-bottom-content");
  	
  	      const viewportHeight =
  	      typeof window !== "undefined" && window.innerHeight
  	      ? window.innerHeight: 900;
  	
  	      const maxHeight = Math.max(360, viewportHeight - 24);
  	      const closedHeight = 56;
  	      const closedWidth = 200;
  	      const openWidth = measureState.isActive ? 350: 300;
  	
  	      if (!isOpen) {
  	        setStyle(bottomSection, "width", `${closedWidth}px`);
  	        setStyle(bottomSection, "height", `${closedHeight}px`);
  	        setStyle(bottomSection, "min-height", `${closedHeight}px`);
  	        setStyle(bottomSection, "max-height", `${closedHeight}px`);
  	        setStyle(bottomSection, "overflow", "hidden");
  	        setStyle(bottomSection, "right", "0");
  	        setStyle(bottomSection, "bottom", "0");
  	        setStyle(bottomSection, "top", "auto");
  	        setStyle(bottomSection, "border-radius", "22px 0 0 0");
  	
  	        if (content) {
  	          setStyle(content, "max-height", `${closedHeight}px`);
  	          setStyle(content, "overflow", "hidden");
  	          setStyle(content, "overflow-x", "hidden");
  	          setStyle(content, "overflow-y", "hidden");
  	        }
  	
  	        return;
  	
  	        try {
  	          window.dispatchEvent(new CustomEvent("trackitMapControlLayoutChanged"));
  	        } catch (_) {}
  	      }
  	
  	      if (content) {
  	        setStyle(content, "max-height", "none");
  	        setStyle(content, "overflow", "visible");
  	        setStyle(content, "overflow-x", "hidden");
  	        setStyle(content, "overflow-y", "visible");
  	      }
  	
  	      const contentHeight = content ? Math.ceil(content.scrollHeight): 0;
  	      const wantedHeight = Math.max(320, contentHeight + 2);
  	      const finalHeight = Math.min(wantedHeight, maxHeight);
  	
  	      setStyle(bottomSection, "width", `${openWidth}px`);
  	      setStyle(bottomSection, "height", `${finalHeight}px`);
  	      setStyle(bottomSection, "min-height", `${finalHeight}px`);
  	      setStyle(bottomSection, "max-height", `${maxHeight}px`);
  	      setStyle(bottomSection, "overflow", "hidden");
  	      setStyle(bottomSection, "right", "0");
  	      setStyle(bottomSection, "bottom", "0");
  	      setStyle(bottomSection, "top", "auto");
  	      setStyle(bottomSection, "border-radius", "24px 0 0 0");
  	
  	      if (content) {
  	        setStyle(content, "max-height", `${finalHeight}px`);
  	        setStyle(content, "overflow-x", "hidden");
  	        setStyle(content, "overflow-y", wantedHeight > maxHeight ? "auto": "visible");
  	      }
  	
  	      try {
  	        window.dispatchEvent(new CustomEvent("trackitMapControlLayoutChanged"));
  	      } catch (_) {}
  	    }
  	
  	    function renderBottom(root) {
  	      const bottomSection = root.querySelector(".ces-bottom-shape");
  	
  	      if (!bottomSection) return;
  	
  	      const isOpen = !!mapControlState.isOpen;
  	      const zoom = getMapControlZoom();
  	      const fullscreenActive = isMapControlFullscreenActive();
  	
  	      const labelState = mapControlState.labelsOn ? "Labels On": "Labels Off";
  	      const measureActive = !!measureState.isActive;
  	
  	      bottomSection.classList.toggle("ces-map-control-open", isOpen);
  	      bottomSection.classList.toggle("ces-map-control-measuring", measureActive);
  	
  	
  	      bottomSection.innerHTML = `
  	      <div class="ces-bottom-content" data-trackit-new-map-control>
  	      <button class="ces-map-control-header" type="button" data-map-control-toggle>
  	      <div class="ces-map-control-header-icon">
  	      <div class="ces-layer-icon">
  	      <span></span>
  	      <span></span>
  	      <span></span>
  	      </div>
  	      </div>
  	
  	      <div class="ces-map-control-header-text">
  	      <div class="ces-map-title">Map Control</div>
  	      <div class="ces-map-subtitle">${escapeHtml(labelState)}</div>
  	      </div>
  	
  	      <div class="ces-caret">${isOpen ? "⌃": "⌄"}</div>
  	      </button>
  	
  	      ${
  	      isOpen
  	      ? `
  	      <div class="ces-map-control-body">
  	      <div class="ces-map-control-main">
  	      <div class="ces-map-control-section">
  	      <div class="ces-map-control-section-title">
  	      ${createMapControlIcon("labels")}
  	      <span>Tools</span>
  	      </div>
  	
  	      <div class="ces-map-control-tools">
  	      ${createMapToolButton("labels", "Labels", mapControlState.labelsOn)}
  	      ${createMapToolButton("secondaryLocations", "Secondary", mapControlState.hideSecondaryLocations)}
  	      ${createMapToolButton("allLocations", "All Locs", mapControlState.hideAllLocations)}
  	      ${createMapToolButton("fullscreen", "Full", fullscreenActive)}
  	      </div>
  	      </div>
  	
  	      <div class="ces-map-control-section">
  	      <div class="ces-map-control-section-title ces-map-control-measure-title">
  	      ${createMapControlIcon("measureRuler")}
  	      <span>Measure</span>
  	      </div>
  	
  	      <div class="ces-map-control-tools ces-map-control-measure-tools">
  	      ${createMapToolButton("measureRuler", "Ruler", measureState.mode === "measureRuler")}
  	      ${createMapToolButton("measurePath", "Path", measureState.mode === "measurePath")}
  	      ${createMapToolButton("measurePolygon", "Polygon", measureState.mode === "measurePolygon")}
  	      ${createMapToolButton("measurePivot", "Pivot", measureState.mode === "measurePivot")}
  	      ${createMapToolButton("measureWedge", "Wedge", measureState.mode === "measureWedge")}
  	      </div>
  	
  	      ${createMeasureDataPanelHtml()}
  	      </div>
  	      </div>
  	
  	      <div class="ces-map-control-zoom-rail">
  	      <div class="ces-map-control-zoom-label">Zoom</div>
  	      <div class="ces-map-control-zoom-value">${zoom}</div>
  	
  	      <button class="ces-map-control-zoom-btn" type="button" data-map-zoom-plus>+</button>
  	
  	      <div class="ces-map-control-slider-wrap">
  	      <input
  	      class="ces-map-control-zoom-slider"
  	      type="range"
  	      min="1"
  	      max="22"
  	      step="1"
  	      value="${zoom}"
  	      data-map-zoom-slider
  	      >
  	      </div>
  	
  	      <button class="ces-map-control-zoom-btn" type="button" data-map-zoom-minus>−</button>
  	      </div>
  	      </div>
  	      `: ""
  	      }
  	      </div>
  	      `;
  	
  	      sizeMapControlShell(bottomSection, isOpen);
  	
  	      requestAnimationFrame(() => {
  	        sizeMapControlShell(bottomSection, !!mapControlState.isOpen);
  	      });
  	
  	      setTimeout(() => {
  	        sizeMapControlShell(bottomSection, !!mapControlState.isOpen);
  	      }, 60);
  	
  	      bindBottomEvents(root);
  	    }
  	
  	    function bindBottomEvents(root) {
  	      const bottomSection = root.querySelector(".ces-bottom-shape");
  	
  	      if (!bottomSection) return;
  	
  	      const toggle = bottomSection.querySelector("[data-map-control-toggle]");
  	      const toolButtons = bottomSection.querySelectorAll("[data-map-tool]");
  	      const zoomMinus = bottomSection.querySelector("[data-map-zoom-minus]");
  	      const zoomPlus = bottomSection.querySelector("[data-map-zoom-plus]");
  	      const zoomSlider = bottomSection.querySelector("[data-map-zoom-slider]");
  	
  	      function stop(event) {
  	        event.preventDefault();
  	        event.stopPropagation();
  	      }
  	
  	      if (!bottomSection.__cesMapControlStopperBound) {
  	        bottomSection.__cesMapControlStopperBound = true;
  	
  	        [
  	          "mousedown",
  	          "dblclick",
  	          "wheel",
  	          "touchstart",
  	          "pointerdown"
  	        ].forEach(eventName => {
  	            bottomSection.addEventListener(eventName, event => {
  	              event.stopPropagation();
  	            }, {
  	              passive: false
  	            });
  	          });
  	
  	        bottomSection.addEventListener("click", event => {
  	          event.stopPropagation();
  	
  	          const target = event.target;
  	
  	          const clickedControl =
  	          target?.closest?.("[data-map-control-toggle]") ||
  	          target?.closest?.("[data-map-tool]") ||
  	          target?.closest?.("[data-map-zoom-minus]") ||
  	          target?.closest?.("[data-map-zoom-plus]") ||
  	          target?.closest?.("[data-map-zoom-slider]");
  	
  	          if (clickedControl) return;
  	
  	          if (!mapControlState.isOpen) {
  	            event.preventDefault();
  	            setMapControlOpen(root, true);
  	          }
  	        },
  	          {
  	            passive: false
  	          });
  	      }
  	
  	      if (toggle) {
  	        toggle.addEventListener("click", event => {
  	          stop(event);
  	
  	          setMapControlOpen(root, !mapControlState.isOpen);
  	        });
  	      }
  	
  	      toolButtons.forEach(button => {
  	        button.addEventListener("click", event => {
  	          stop(event);
  	
  	          const tool = button.getAttribute("data-map-tool") || "";
  	
  	          if (
  	            tool === "measureRuler" ||
  	            tool === "measurePath" ||
  	            tool === "measurePolygon" ||
  	            tool === "measurePivot" ||
  	            tool === "measureWedge"
  	          ) {
  	            startMapMeasureMode(tool);
  	            renderBottom(root);
  	            return;
  	          }
  	
  	          if (tool === "measureClear") {
  	            clearMapMeasure();
  	            renderBottom(root);
  	            return;
  	          }
  	
  	          if (tool === "measureClose") {
  	            closeMapMeasure();
  	            renderBottom(root);
  	            return;
  	          }
  	
  	          if (tool === "measureUndo") {
  	            undoMapMeasurePoint();
  	            renderBottom(root);
  	            return;
  	          }
  	
  	
  	          if (tool === "labels") {
  	            mapControlState.labelsOn = !mapControlState.labelsOn;
  	            writeMapControlSetting("labelsOn", mapControlState.labelsOn);
  	
  	            applyMapControlAppearance();
  	            scheduleMapControlLocationVisibilityApply();
  	            renderBottom(root);
  	            return;
  	          }
  	
  	          if (tool === "secondaryLocations") {
  	            mapControlState.hideSecondaryLocations = !mapControlState.hideSecondaryLocations;
  	            writeMapControlSetting("hideSecondaryLocations", mapControlState.hideSecondaryLocations);
  	
  	            scheduleMapControlLocationVisibilityApply();
  	            renderBottom(root);
  	            return;
  	          }
  	
  	          if (tool === "allLocations") {
  	            mapControlState.hideAllLocations = !mapControlState.hideAllLocations;
  	            writeMapControlSetting("hideAllLocations", mapControlState.hideAllLocations);
  	
  	            scheduleMapControlLocationVisibilityApply();
  	            renderBottom(root);
  	            return;
  	          }
  	
  	          if (tool === "fullscreen") {
  	            toggleMapControlFullscreen();
  	
  	            setTimeout(() => {
  	              renderBottom(root);
  	            }, 180);
  	
  	            return;
  	          }
  	        });
  	      });
  	
  	      if (zoomMinus) {
  	        zoomMinus.addEventListener("click", event => {
  	          stop(event);
  	
  	          setMapControlZoom(getMapControlZoom() - 1);
  	          renderBottom(root);
  	        });
  	      }
  	
  	      if (zoomPlus) {
  	        zoomPlus.addEventListener("click", event => {
  	          stop(event);
  	
  	          setMapControlZoom(getMapControlZoom() + 1);
  	          renderBottom(root);
  	        });
  	      }
  	
  	      if (zoomSlider) {
  	        zoomSlider.addEventListener("input", event => {
  	          event.stopPropagation();
  	
  	          setMapControlZoom(event.target.value);
  	
  	          const value = bottomSection.querySelector(".ces-map-control-zoom-value");
  	
  	          if (value) {
  	            value.textContent = String(getMapControlZoom());
  	          }
  	        });
  	
  	        zoomSlider.addEventListener("change",
  	          event => {
  	            stop(event);
  	
  	            setMapControlZoom(event.target.value);
  	            renderBottom(root);
  	          });
  	      }
  	    }
  	
  	    function bindTopEvents(root) {
  	      const addButton = root.querySelector(".ces-add-square");
  	      const closeButton = root.querySelector(".ces-close-create");
  	      const dropdownToggles = root.querySelectorAll("[data-dd-toggle]");
  	      const companyOptions = root.querySelectorAll("[data-company-value]");
  	      const locationTypeOptions = root.querySelectorAll("[data-location-type-value]");
  	      const modeButtons = root.querySelectorAll(".ces-mode-button");
  	      const nameInput = root.querySelector(".ces-name-input");
  	      const plotButton = root.querySelector(".ces-plot-location-button");
  	      const saveButton = root.querySelector(".ces-save-location-button");
  	
  	      if (addButton && !createState.isCreating) {
  	        addButton.addEventListener("click", () => {
  	          createState.isCreating = true;
  	          createState.company = "";
  	          createState.locationType = "";
  	          createState.creationMode = "";
  	          createState.name = "";
  	          createState.openDropdown = "";
  	          createState.isPlotting = false;
  	          createState.isSaved = false;
  	          createState.modalMode = "";
  	          createState.helpTopic = "";
  	          createState.typeManagerName = "";
  	          createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	          createState.typeManagerOriginalName = "";
  	          resetFunctionalityState();
  	
  	          lockMapUntilPlotMode();
  	
  	          renderTop(root);
  	          renderModal(root);
  	        });
  	      }
  	
  	      if (closeButton) {
  	        closeButton.addEventListener("click", () => {
  	          unlockMapForPlotOrClose();
  	
  	          resetCreateState();
  	
  	          renderTop(root);
  	          renderModal(root);
  	          ensureTrackITSearchDropdownMounted(root);
  	        });
  	      }
  	
  	      dropdownToggles.forEach(button => {
  	        button.addEventListener("click", event => {
  	          event.stopPropagation();
  	
  	          if (createState.isPlotting) return;
  	
  	          const targetDropdown = button.getAttribute("data-dd-toggle") || "";
  	
  	          createState.openDropdown =
  	          createState.openDropdown === targetDropdown
  	          ? "": targetDropdown;
  	
  	          renderTop(root);
  	        });
  	      });
  	
  	      companyOptions.forEach(button => {
  	        button.addEventListener("click",
  	          event => {
  	            event.stopPropagation();
  	
  	            if (createState.isPlotting) return;
  	
  	            createState.company = button.getAttribute("data-company-value") || "";
  	            createState.locationType = "";
  	            createState.creationMode = "";
  	            createState.name = "";
  	            createState.openDropdown = "";
  	            createState.isPlotting = false;
  	            createState.isSaved = false;
  	
  	            renderTop(root);
  	            refreshLocationCreationCompanyScope("location-create-company-selected");
  	          });
  	      });
  	
  	      locationTypeOptions.forEach(button => {
  	        button.addEventListener("click",
  	          event => {
  	            event.stopPropagation();
  	
  	            if (createState.isPlotting) return;
  	
  	            const selectedValue = button.getAttribute("data-location-type-value") || "";
  	
  	            if (selectedValue === ADD_NEW_LOCATION_TYPE_VALUE) {
  	              createState.modalMode = "locationTypeManager";
  	              createState.helpTopic = "";
  	              createState.typeManagerName = "";
  	              createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	              createState.typeManagerOriginalName = "";
  	              createState.openDropdown = "";
  	              createState.creationMode = "";
  	              createState.name = "";
  	              createState.isPlotting = false;
  	              createState.isSaved = false;
  	
  	              renderTop(root);
  	              renderModal(root);
  	              return;
  	            }
  	
  	            createState.locationType = selectedValue;
  	            createState.creationMode = "";
  	            createState.name = "";
  	            createState.openDropdown = "";
  	            createState.isPlotting = false;
  	            createState.isSaved = false;
  	            createState.modalMode = "";
  	            createState.helpTopic = "";
  	
  	            renderTop(root);
  	            renderModal(root);
  	          });
  	      });
  	
  	      modeButtons.forEach(button => {
  	        button.addEventListener("click",
  	          () => {
  	            if (createState.isPlotting) return;
  	
  	            createState.creationMode = button.getAttribute("data-creation-mode") || "";
  	            createState.openDropdown = "";
  	            createState.name = "";
  	            createState.isPlotting = false;
  	            createState.isSaved = false;
  	
  	            renderTop(root);
  	          });
  	      });
  	
  	      if (nameInput) {
  	        nameInput.addEventListener("input", event => {
  	          createState.name = event.target.value;
  	          createState.openDropdown = "";
  	          createState.isPlotting = false;
  	          createState.isSaved = false;
  	
  	          clearAttention(root);
  	
  	          const hasName = !!safeString(createState.name).trim();
  	          const livePlotButton = root.querySelector(".ces-plot-location-button");
  	
  	          if (livePlotButton) {
  	            livePlotButton.disabled = !hasName;
  	            livePlotButton.classList.toggle("ces-plot-location-disabled", !hasName);
  	          }
  	
  	          scheduleAttention(root);
  	        });
  	      }
  	
  	      if (plotButton) {
  	        plotButton.addEventListener("click", () => {
  	          if (!safeString(createState.name).trim()) return;
  	
  	          unlockMapForPlotOrClose();
  	
  	          beginFreeGroundPlotting();
  	
  	          renderTop(root);
  	        });
  	      }
  	
  	      if (saveButton) {
  	        saveButton.addEventListener("click", () => {
  	          if (!createState.entrancePoint) {
  	            const entranceStatus = getEntrancePrerequisiteStatus();
  	
  	            if (!entranceStatus.ready) {
  	              window.alert(entranceStatus.message);
  	              renderTop(root);
  	              renderModal(root);
  	              return;
  	            }
  	
  	            const started = beginEntrancePointPicking();
  	
  	            if (started) {
  	              renderTop(root);
  	              renderModal(root);
  	            }
  	
  	            return;
  	          }
  	
  	          createState.saveAfterFunctionality = true;
  	          createState.modalMode = "functionality";
  	          createState.helpTopic = "";
  	          createState.openDropdown = "";
  	
  	          if (window.__CarvedEdgeShapeUI) {
  	            window.__CarvedEdgeShapeUI.pendingFunctionalitySource = "new-location-create";
  	            window.__CarvedEdgeShapeUI.pendingSaveLocation = null;
  	          }
  	
  	          renderTop(root);
  	          renderModal(root);
  	        });
  	      }
  	    }
  	
  	    function getMapVisibilityElements(mapComponent) {
  	      const found = [];
  	      const seen = new Set();
  	
  	      function addElement(element) {
  	        if (!element) return;
  	
  	        try {
  	          if (typeof Element !== "undefined" && !(element instanceof Element)) return;
  	        } catch (_) {
  	          return;
  	        }
  	
  	        if (seen.has(element)) return;
  	
  	        seen.add(element);
  	        found.push(element);
  	
  	        try {
  	          const closestBlock =
  	          element.closest(".bl-block") ||
  	          element.closest(".bl-customComponent") ||
  	          element.closest(".bl-component") ||
  	          element.closest("[data-component-id]") ||
  	          element.closest("[data-uid]") ||
  	          null;
  	
  	          if (closestBlock && !seen.has(closestBlock)) {
  	            seen.add(closestBlock);
  	            found.push(closestBlock);
  	          }
  	        } catch (_) {}
  	      }
  	
  	      function addFromCandidate(candidate) {
  	        if (!candidate) return;
  	
  	        try {
  	          const resolved = resolveElementFromComponent(candidate);
  	
  	          if (resolved) {
  	            addElement(resolved);
  	          }
  	        } catch (_) {}
  	
  	        try {
  	          if (typeof candidate.getDiv === "function") {
  	            addElement(candidate.getDiv());
  	          }
  	        } catch (_) {}
  	
  	        try {
  	          if (candidate.element) addElement(candidate.element);
  	          if (candidate.el) addElement(candidate.el);
  	          if (candidate.node) addElement(candidate.node);
  	          if (candidate.domNode) addElement(candidate.domNode);
  	        } catch (_) {}
  	
  	        try {
  	          if (candidate.map && typeof candidate.map.getDiv === "function") {
  	            addElement(candidate.map.getDiv());
  	          }
  	        } catch (_) {}
  	
  	        try {
  	          if (candidate.map?.map && typeof candidate.map.map.getDiv === "function") {
  	            addElement(candidate.map.map.getDiv());
  	          }
  	        } catch (_) {}
  	      }
  	
  	      [
  	        mapComponent,
  	        MAP_INPUT,
  	        mapComponent?.map,
  	        mapComponent?.map?.map,
  	        MAP_INPUT?.map,
  	        MAP_INPUT?.map?.map
  	      ].forEach(addFromCandidate);
  	
  	      if (!found.length) {
  	        try {
  	          document.querySelectorAll(".gm-style").forEach(addElement);
  	        } catch (_) {}
  	      }
  	
  	      return found;
  	    }
  	
  	    function closeFloatingLocationOverlays() {
  	      [
  	        "trackit-location-events-manager",
  	        "trackit-location-capture-event-form",
  	        "job-entry-list-mobile-portrait-mount",
  	        "job-entry-form-mobile-portrait-mount"
  	      ].forEach(id => {
  	          const existing = document.getElementById(id);
  	
  	          if (existing && existing.parentNode) {
  	            existing.parentNode.removeChild(existing);
  	          }
  	        });
  	    }
  	
  	    function setCarvedUIVisibleForMap(root,
  	      isVisible) {
  	      if (!root) return;
  	
  	      if (isVisible) {
  	        if (!root.__cesHiddenBecauseMapInvisible) return;
  	
  	        root.__cesHiddenBecauseMapInvisible = false;
  	
  	        root.style.removeProperty("display");
  	        root.style.removeProperty("visibility");
  	        root.style.removeProperty("opacity");
  	        root.style.removeProperty("pointer-events");
  	
  	        if (root.__cesOriginalDisplay) {
  	          root.style.display = root.__cesOriginalDisplay;
  	        }
  	
  	        return;
  	      }
  	
  	      if (root.__cesHiddenBecauseMapInvisible) return;
  	
  	      root.__cesHiddenBecauseMapInvisible = true;
  	      root.__cesOriginalDisplay = root.style.display || "";
  	
  	      createState.openDropdown = "";
  	      createState.modalMode = "";
  	      createState.helpTopic = "";
  	
  	      closeFloatingLocationOverlays();
  	
  	      try {
  	        cleanupMountedTrackITDropdown(root);
  	      } catch (_) {}
  	
  	      root.style.setProperty("display", "none", "important");
  	      root.style.setProperty("visibility", "hidden", "important");
  	      root.style.setProperty("opacity", "0", "important");
  	      root.style.setProperty("pointer-events", "none", "important");
  	    }
  	
  	    function isElementAndParentsVisible(element) {
  	      if (!element || !element.isConnected) return false;
  	
  	      let current = element;
  	
  	      while (current && current.nodeType === 1) {
  	        try {
  	          const styles = window.getComputedStyle(current);
  	
  	          if (!styles) return false;
  	          if (styles.display === "none") return false;
  	          if (styles.visibility === "hidden") return false;
  	          if (styles.visibility === "collapse") return false;
  	          if (Number(styles.opacity) === 0) return false;
  	        } catch (_) {}
  	
  	        current = current.parentElement;
  	      }
  	
  	      try {
  	        const rect = element.getBoundingClientRect();
  	        const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
  	        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
  	
  	        if (!rect) return false;
  	        if (rect.width <= 0 || rect.height <= 0) return false;
  	        if (rect.bottom <= 0) return false;
  	        if (rect.right <= 0) return false;
  	        if (rect.top >= viewportHeight) return false;
  	        if (rect.left >= viewportWidth) return false;
  	
  	        return true;
  	      } catch (_) {
  	        return false;
  	      }
  	    }
  	
  	    function isAnyMapElementVisibleOnScreen(mapComponent) {
  	      const mapElements = getMapVisibilityElements(mapComponent);
  	
  	      if (!mapElements.length) return false;
  	
  	      return mapElements.some(element => {
  	        return isElementAndParentsVisible(element);
  	      });
  	    }
  	
  	    function bindMapVisibilityVanisher(root, mapComponent) {
  	      if (!root) return;
  	
  	      let rafId = 0;
  	      let observer = null;
  	      let intervalId = 0;
  	
  	      const checkVisibility = () => {
  	        rafId = 0;
  	
  	        if (!root || !root.isConnected) return;
  	
  	        const isVisible = isAnyMapElementVisibleOnScreen(mapComponent);
  	
  	        setCarvedUIVisibleForMap(root, isVisible);
  	      };
  	
  	      const scheduleCheck = () => {
  	        if (rafId) return;
  	
  	        rafId = requestAnimationFrame(checkVisibility);
  	      };
  	
  	      try {
  	        observer = new MutationObserver(scheduleCheck);
  	
  	        observer.observe(document.body, {
  	          attributes: true,
  	          childList: true,
  	          subtree: true,
  	          attributeFilter: ["class", "style", "hidden", "aria-hidden"]
  	        });
  	      } catch (_) {
  	        observer = null;
  	      }
  	
  	      window.addEventListener("scroll", scheduleCheck, true);
  	      window.addEventListener("resize", scheduleCheck);
  	      window.addEventListener("orientationchange", scheduleCheck);
  	      window.addEventListener("trackitMapControlLayoutChanged", scheduleCheck);
  	      document.addEventListener("visibilitychange", scheduleCheck);
  	
  	      intervalId = window.setInterval(scheduleCheck, 250);
  	
  	      root.__mapVisibilityCleanup = () => {
  	        try {
  	          if (observer) observer.disconnect();
  	        } catch (_) {}
  	
  	        try {
  	          window.removeEventListener("scroll", scheduleCheck, true);
  	          window.removeEventListener("resize", scheduleCheck);
  	          window.removeEventListener("orientationchange", scheduleCheck);
  	          window.removeEventListener("trackitMapControlLayoutChanged", scheduleCheck);
  	          document.removeEventListener("visibilitychange", scheduleCheck);
  	        } catch (_) {}
  	
  	        try {
  	          if (intervalId) window.clearInterval(intervalId);
  	        } catch (_) {}
  	
  	        try {
  	          if (rafId) cancelAnimationFrame(rafId);
  	        } catch (_) {}
  	
  	        root.__mapVisibilityCleanup = null;
  	      };
  	
  	      checkVisibility();
  	
  	      setTimeout(scheduleCheck, 100);
  	      setTimeout(scheduleCheck, 350);
  	      setTimeout(scheduleCheck, 800);
  	    }
  	
  	    function isTrackITGoogleMapInstance(value) {
  	      try {
  	        if (!value) return false;
  	
  	        return (
  	          typeof value.getDiv === "function" &&
  	          typeof value.setOptions === "function" &&
  	          typeof value.getZoom === "function" &&
  	          typeof value.setZoom === "function"
  	        );
  	      } catch (_) {
  	        return false;
  	      }
  	    }
  	
  	    function resolveTrackITGoogleMap(mapComponent) {
  	      const candidates = [
  	        mapComponent?.map?.map,
  	        mapComponent?.map,
  	        mapComponent?.googleMap,
  	        mapComponent?.GoogleMap,
  	        mapComponent?.instance,
  	        mapComponent?.gMap,
  	        mapComponent?.GMap,
  	        mapComponent,
  	
  	        MAP_INPUT?.map?.map,
  	        MAP_INPUT?.map,
  	        MAP_INPUT?.googleMap,
  	        MAP_INPUT?.GoogleMap,
  	        MAP_INPUT?.instance,
  	        MAP_INPUT?.gMap,
  	        MAP_INPUT?.GMap,
  	        MAP_INPUT
  	      ];
  	
  	      for (let i = 0; i < candidates.length; i++) {
  	        if (isTrackITGoogleMapInstance(candidates[i])) {
  	          return candidates[i];
  	        }
  	      }
  	
  	      return null;
  	    }
  	
  	    function rendererNumber(value) {
  	      const number = typeof value === "string" ? Number(value): value;
  	
  	      return Number.isFinite(number) ? number: null;
  	    }
  	
  	    function rendererGetLocationId(location) {
  	      return safeString(getLocationValue(location)).trim();
  	    }
  	
  	    function rendererGetLocationName(location) {
  	      return safeString(getLocationName(location)).trim() || "Location";
  	    }
  	
  	    function rendererGetLocationColor(location) {
  	      return (
  	        getLocationTypeColor(location) ||
  	        location?.Color ||
  	        location?.color ||
  	        location?.Colour ||
  	        location?.colour ||
  	        "#ff9a3d"
  	      );
  	    }
  	
  	    function rendererRingToLatLngs(ring) {
  	      if (!Array.isArray(ring)) return null;
  	
  	      const points = [];
  	
  	      ring.forEach(coord => {
  	        if (Array.isArray(coord) && coord.length >= 2) {
  	          const lng = rendererNumber(coord[0]);
  	          const lat = rendererNumber(coord[1]);
  	
  	          if (lat !== null && lng !== null) {
  	            points.push({
  	              lat, lng
  	            });
  	          }
  	
  	          return;
  	        }
  	
  	        if (coord && typeof coord === "object") {
  	          const lat = rendererNumber(
  	            coord.lat ??
  	            coord.Lat ??
  	            coord.latitude ??
  	            coord.Latitude ??
  	            coord.y ??
  	            coord.Y
  	          );
  	
  	          const lng = rendererNumber(
  	            coord.lng ??
  	            coord.Lng ??
  	            coord.lon ??
  	            coord.Lon ??
  	            coord.longitude ??
  	            coord.Longitude ??
  	            coord.x ??
  	            coord.X
  	          );
  	
  	          if (lat !== null && lng !== null) {
  	            points.push({
  	              lat, lng
  	            });
  	          }
  	        }
  	      });
  	
  	      if (points.length >= 2) {
  	        const first = points[0];
  	        const last = points[points.length - 1];
  	
  	        if (first.lat === last.lat && first.lng === last.lng) {
  	          points.pop();
  	        }
  	      }
  	
  	      return points.length >= 3 ? points: null;
  	    }
  	
  	    function rendererSignedArea(points) {
  	      if (!Array.isArray(points) || points.length < 3) return 0;
  	
  	      let sum = 0;
  	
  	      for (let i = 0; i < points.length; i++) {
  	        const a = points[i];
  	        const b = points[(i + 1) % points.length];
  	
  	        sum += (a.lng * b.lat) - (b.lng * a.lat);
  	      }
  	
  	      return sum / 2;
  	    }
  	
  	    function rendererEnsureWinding(points, wantCCW) {
  	      if (!Array.isArray(points) || points.length < 3) return points;
  	
  	      const area = rendererSignedArea(points);
  	      const isCCW = area > 0;
  	
  	      if (wantCCW && !isCCW) return points.slice().reverse();
  	      if (!wantCCW && isCCW) return points.slice().reverse();
  	
  	      return points;
  	    }
  	
  	    function rendererRingsToPaths(rings) {
  	      if (!Array.isArray(rings) || !rings.length) return null;
  	
  	      const paths = [];
  	
  	      rings.forEach(ring => {
  	        const points = rendererRingToLatLngs(ring);
  	
  	        if (points && points.length >= 3) {
  	          paths.push(points);
  	        }
  	      });
  	
  	      if (!paths.length) return null;
  	
  	      paths[0] = rendererEnsureWinding(paths[0], true);
  	
  	      for (let i = 1; i < paths.length; i++) {
  	        paths[i] = rendererEnsureWinding(paths[i], false);
  	      }
  	
  	      return paths;
  	    }
  	
  	    function rendererGetPolygonPaths(location) {
  	      const polygon =
  	      location?.Polygon ||
  	      location?.polygon ||
  	      location?.Boundary ||
  	      location?.boundary ||
  	      location?.LocationData?.Polygon ||
  	      location?.LocationData?.polygon ||
  	      location?.LocationData?.Boundary ||
  	      location?.LocationData?.boundary ||
  	      null;
  	
  	      if (!polygon) return null;
  	
  	      if (Array.isArray(polygon.coordinates)) {
  	        return rendererRingsToPaths(polygon.coordinates);
  	      }
  	
  	      if (Array.isArray(polygon.Coordinates)) {
  	        return rendererRingsToPaths(polygon.Coordinates);
  	      }
  	
  	      const boundaryPoints =
  	      polygon?.boundary?.points ||
  	      polygon?.Boundary?.points ||
  	      polygon?.points ||
  	      polygon?.Points ||
  	      null;
  	
  	      if (Array.isArray(boundaryPoints)) {
  	        const outer = rendererRingToLatLngs(boundaryPoints);
  	
  	        if (!outer || outer.length < 3) return null;
  	
  	        const paths = [rendererEnsureWinding(outer, true)];
  	
  	        const holes = polygon?.holes || polygon?.Holes || [];
  	
  	        if (Array.isArray(holes)) {
  	          holes.forEach(holeObject => {
  	            const holePoints =
  	            holeObject?.points ||
  	            holeObject?.Points ||
  	            holeObject?.boundary?.points ||
  	            holeObject?.Boundary?.points ||
  	            null;
  	
  	            const hole = rendererRingToLatLngs(holePoints);
  	
  	            if (hole && hole.length >= 3) {
  	              paths.push(rendererEnsureWinding(hole, false));
  	            }
  	          });
  	        }
  	
  	        return paths;
  	      }
  	
  	      return null;
  	    }
  	
  	    function rendererNormalizeGooglePolygonPaths(paths) {
  	      if (!Array.isArray(paths) || !paths.length) return null;
  	
  	      if (!Array.isArray(paths[0]) || paths[0].length < 3) return null;
  	
  	      if (paths.length === 1) return paths[0];
  	
  	      return paths;
  	    }
  	
  	    function rendererComputeArea(points) {
  	      if (!Array.isArray(points) || points.length < 3) return 0;
  	
  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google?.maps?.geometry?.spherical &&
  	          typeof google.maps.geometry.spherical.computeArea === "function"
  	        ) {
  	          const path = points.map(point => {
  	            return new google.maps.LatLng(point.lat, point.lng);
  	          });
  	
  	          const area = google.maps.geometry.spherical.computeArea(path);
  	
  	          return Number.isFinite(area) ? area: 0;
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        let meanLat = 0;
  	
  	        points.forEach(point => {
  	          meanLat += point.lat;
  	        });
  	
  	        meanLat = meanLat / points.length;
  	
  	        const metersPerDegLat = 111132.92;
  	        const metersPerDegLng = 111319.49 * Math.cos(meanLat * Math.PI / 180);
  	
  	        let sum = 0;
  	
  	        for (let i = 0; i < points.length; i++) {
  	          const p1 = points[i];
  	          const p2 = points[(i + 1) % points.length];
  	
  	          const x1 = p1.lng * metersPerDegLng;
  	          const y1 = p1.lat * metersPerDegLat;
  	          const x2 = p2.lng * metersPerDegLng;
  	          const y2 = p2.lat * metersPerDegLat;
  	
  	          sum += (x1 * y2) - (x2 * y1);
  	        }
  	
  	        return Math.abs(sum) / 2;
  	      } catch (_) {
  	        return 0;
  	      }
  	    }
  	
  	    function rendererCollectLocations() {
  	      const appData = getAppBag() || APP_DATA;
  	      const result = [];
  	      const seen = new Set();
  	      const scopedCompanyLocationIds = new Set();
  	      const companyScope = getLocationCreationCompanyScope(appData);
  	
  	      function addLocation(location) {
  	        if (!location || typeof location !== "object") return;
  	
  	        const id = rendererGetLocationId(location);
  	
  	        if (!id) return;
  	
  	        if (typeof isLocationIdDeleted === "function" && isLocationIdDeleted(id)) {
  	          return;
  	        }
  	
  	        if (seen.has(id)) return;
  	
  	        seen.add(id);
  	        result.push(location);
  	      }
  	
  	      const companies =
  	      DATA_CHANNEL?.companies ||
  	      appData?.User?.Companies ||
  	      appData?.User?.companies ||
  	      appData?.Companies ||
  	      appData?.companies ||
  	      [];
  	
  	      const sourceCompanies = companyScope.active
  	      ? (companyScope.company ? [companyScope.company]: [])
  	      : (Array.isArray(companies) ? companies: []);
  	
  	      sourceCompanies.forEach(company => {
  	        flattenLocations(getCompanyLocations(company)).forEach(location => {
  	          const id = rendererGetLocationId(location);
  	
  	          if (companyScope.active && id) {
  	            scopedCompanyLocationIds.add(id);
  	          }
  	
  	          addLocation(location);
  	        });
  	      });
  	
  	      getRegistryLocations(appData).forEach(location => {
  	        if (companyScope.active) {
  	          const id = rendererGetLocationId(location);
  	
  	          // Registry entries are allowed only when the selected Company's
  	          // Locations relation also owns that exact saved Location.
  	          if (!id || !scopedCompanyLocationIds.has(id)) return;
  	        }
  	
  	        addLocation(location);
  	      });
  	
  	      return result;
  	    }
  	
  	    function ensureTrackITLocationRegistry() {
  	      if (
  	        window.LocationRegistry &&
  	        typeof window.LocationRegistry.register === "function" &&
  	        typeof window.LocationRegistry.unregister === "function"
  	      ) {
  	        window.TrackITLocationRegistry = window.LocationRegistry;
  	        window.__TrackITLocationRegistry = window.LocationRegistry;
  	        return window.LocationRegistry;
  	      }
  	
  	      const store = Object.create(null);
  	
  	      const api = {
  	        register(payload) {
  	          payload = payload || {};
  	
  	          const location = payload.location || payload.loc || null;
  	          const id = rendererGetLocationId(location);
  	
  	          if (!id) return false;
  	
  	          store[id] = {
  	            id,
  	            location,
  	            polygon: payload.polygon || null,
  	            marker: payload.marker || null,
  	            geometryMeta: payload.geometryMeta || null
  	          };
  	
  	          return true;
  	        },
  	
  	        unregister(id) {
  	          id = safeString(id).trim();
  	
  	          if (!id || !store[id]) return false;
  	
  	          try {
  	            if (store[id].polygon && typeof store[id].polygon.setMap === "function") {
  	              store[id].polygon.setMap(null);
  	            }
  	          } catch (_) {}
  	
  	          delete store[id];
  	
  	          return true;
  	        },
  	
  	        removeById(id) {
  	          return api.unregister(id);
  	        },
  	
  	        getRuntime(id) {
  	          id = safeString(id).trim();
  	
  	          return id && store[id] ? store[id]: null;
  	        },
  	
  	        getAllRuntimeIds() {
  	          return Object.keys(store);
  	        },
  	
  	        pruneMissing(liveIds) {
  	          Object.keys(store).forEach(id => {
  	            if (!liveIds || !liveIds[id]) {
  	              api.unregister(id);
  	            }
  	          });
  	
  	          return true;
  	        },
  	
  	        clearRuntime() {
  	          Object.keys(store).forEach(id => {
  	            api.unregister(id);
  	          });
  	
  	          return true;
  	        },
  	
  	        resetRuntime() {
  	          return api.clearRuntime();
  	        },
  	
  	        reset() {
  	          return api.clearRuntime();
  	        },
  	
  	        openLocation(id) {
  	          const runtime = api.getRuntime(id);
  	
  	          if (!runtime) return false;
  	
  	          if (
  	            window.LocationRegistryUI &&
  	            typeof window.LocationRegistryUI.openEditPanel === "function"
  	          ) {
  	            window.LocationRegistryUI.openEditPanel({
  	              loc: runtime.location,
  	              polygon: runtime.polygon,
  	              marker: runtime.marker,
  	              registryApi: api
  	            });
  	
  	            return true;
  	          }
  	
  	          return false;
  	        }
  	      };
  	
  	      window.LocationRegistry = api;
  	      window.TrackITLocationRegistry = api;
  	      window.__TrackITLocationRegistry = api;
  	
  	      return api;
  	    }
  	
  	    function rendererWriteSelectedLocation(location) {
  	      const appData = getAppBag();
  	
  	      if (!appData || !location) return;
  	
  	      const id = rendererGetLocationId(location);
  	
  	      appData.SelectedLocation = location;
  	      appData.SelectedLocationObjectId = id;
  	      appData.SelectedLocationMarker = id;
  	    }
  	
  	    function rendererFocusPolygon(map, polygon) {
  	      try {
  	        if (
  	          !map ||
  	          !polygon ||
  	          typeof google === "undefined" ||
  	          !google?.maps?.LatLngBounds
  	        ) {
  	          return false;
  	        }
  	
  	        const bounds = new google.maps.LatLngBounds();
  	        const paths = polygon.getPaths ? polygon.getPaths(): null;
  	
  	        if (!paths || typeof paths.getLength !== "function") return false;
  	
  	        for (let pathIndex = 0; pathIndex < paths.getLength(); pathIndex++) {
  	          const path = paths.getAt(pathIndex);
  	
  	          if (!path || typeof path.getLength !== "function") continue;
  	
  	          for (let i = 0; i < path.getLength(); i++) {
  	            bounds.extend(path.getAt(i));
  	          }
  	        }
  	
  	        if (bounds.isEmpty && bounds.isEmpty()) return false;
  	
  	        if (typeof map.fitBounds === "function") {
  	          map.fitBounds(bounds);
  	          return true;
  	        }
  	      } catch (_) {}
  	
  	      return false;
  	    }
  	
  	    function isCreatePlottingActive() {
  	      return !!(
  	        createState &&
  	        createState.isCreating === true &&
  	        createState.isPlotting === true
  	      );
  	    }
  	
  	    function getFreeGroundPlotColor() {
  	      const options = buildLocationTypeOptionsForCompany(createState.company);
  	
  	      const selectedType = options.find(option => {
  	        return String(option.value) === String(createState.locationType);
  	      });
  	
  	      return (
  	        selectedType?.color ||
  	        selectedType?.Color ||
  	        DEFAULT_NEW_LOCATION_TYPE_COLOR
  	      );
  	    }
  	
  	    function latLngEventToPlain(latLng) {
  	      if (!latLng) return null;
  	
  	      const lat = typeof latLng.lat === "function" ? latLng.lat(): latLng.lat;
  	      const lng = typeof latLng.lng === "function" ? latLng.lng(): latLng.lng;
  	
  	      if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return null;
  	
  	      return {
  	        lat: Number(lat),
  	        lng: Number(lng)
  	      };
  	    }
  	
  	    function clearFreeGroundPlotDraft() {
  	      try {
  	        if (Array.isArray(createState.plotDraftMarkers)) {
  	          createState.plotDraftMarkers.forEach(marker => {
  	            try {
  	              marker.setMap(null);
  	            } catch (_) {}
  	          });
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (Array.isArray(createState.plotDraftMidMarkers)) {
  	          createState.plotDraftMidMarkers.forEach(marker => {
  	            try {
  	              marker.setMap(null);
  	            } catch (_) {}
  	          });
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (Array.isArray(createState.plotDraftHeadingMarkers)) {
  	          createState.plotDraftHeadingMarkers.forEach(marker => {
  	            try {
  	              marker.setMap(null);
  	            } catch (_) {}
  	          });
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPolyline) {
  	          createState.plotDraftPolyline.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftRawPolyline) {
  	          createState.plotDraftRawPolyline.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPolygon) {
  	          createState.plotDraftPolygon.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPivotCenterMarker) {
  	          createState.plotDraftPivotCenterMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPivotRadiusMarker) {
  	          createState.plotDraftPivotRadiusMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPivotRadiusLine) {
  	          createState.plotDraftPivotRadiusLine.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftWedgeCenterMarker) {
  	          createState.plotDraftWedgeCenterMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftWedgeRadiusMarker) {
  	          createState.plotDraftWedgeRadiusMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftWedgeEdgeMarker) {
  	          createState.plotDraftWedgeEdgeMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftWedgeRadiusLine) {
  	          createState.plotDraftWedgeRadiusLine.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftWedgeEdgeLine) {
  	          createState.plotDraftWedgeEdgeLine.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      createState.plotPoints = [];
  	      createState.plotRawPoints = [];
  	      createState.plotResolvedPoints = [];
  	      createState.plotSnapSegments = [];
  	      createState.plotHeadingPoints = [];
  	      createState.plotHoleRings = [];
  	      createState.plotHoleLocations = [];
  	
  	      createState.plotActiveRawIndex = -1;
  	      createState.plotCrossingWarnAt = 0;
  	
  	      createState.plotParentLocation = null;
  	      createState.plotParentLocationId = "";
  	
  	      createState.childShapeMode = "";
  	      createState.childFixedCenter = null;
  	      createState.childRadiusPoint = null;
  	      createState.childEdgePoint = null;
  	
  	      clearEntrancePointDraft();
  	
  	      createState.plotDraftMarkers = [];
  	      createState.plotDraftMidMarkers = [];
  	      createState.plotDraftHeadingMarkers = [];
  	      createState.plotDraftPolyline = null;
  	      createState.plotDraftRawPolyline = null;
  	      createState.plotDraftPolygon = null;
  	      createState.plotDraftPivotCenterMarker = null;
  	      createState.plotDraftPivotRadiusMarker = null;
  	      createState.plotDraftPivotRadiusLine = null;
  	
  	      createState.plotDraftWedgeCenterMarker = null;
  	      createState.plotDraftWedgeRadiusMarker = null;
  	      createState.plotDraftWedgeEdgeMarker = null;
  	      createState.plotDraftWedgeRadiusLine = null;
  	      createState.plotDraftWedgeEdgeLine = null;
  	    }
  	
  	    function resetFreeGroundPlotDraftOnly() {
  	      clearFreeGroundPlotDraft();
  	
  	      createState.plotMode = "free-ground";
  	      createState.plotParentLocation = null;
  	      createState.plotParentLocationId = "";
  	
  	      createState.childShapeMode = "";
  	      createState.childFixedCenter = null;
  	      createState.childRadiusPoint = null;
  	      createState.childEdgePoint = null;
  	
  	      clearEntrancePointDraft();
  	
  	      createState.plotDraftMarkers = [];
  	
  	      createState.plotPivotCenter = null;
  	      createState.plotPivotRadiusPoint = null;
  	      createState.plotPivotRadiusMeters = 0;
  	      createState.plotDraftPivotCenterMarker = null;
  	      createState.plotDraftPivotRadiusMarker = null;
  	      createState.plotDraftPivotRadiusLine = null;
  	
  	      createState.plotDraftWedgeCenterMarker = null;
  	      createState.plotDraftWedgeRadiusMarker = null;
  	      createState.plotDraftWedgeEdgeMarker = null;
  	      createState.plotDraftWedgeRadiusLine = null;
  	      createState.plotDraftWedgeEdgeLine = null;
  	
  	      createState.plotWedgeCenter = null;
  	      createState.plotWedgeRadiusPoint = null;
  	      createState.plotWedgeEdgePoint = null;
  	      createState.plotWedgeRadiusMeters = 0;
  	      createState.plotDraftWedgeCenterMarker = null;
  	      createState.plotDraftWedgeRadiusMarker = null;
  	      createState.plotDraftWedgeEdgeMarker = null;
  	      createState.plotDraftWedgeRadiusLine = null;
  	      createState.plotDraftWedgeEdgeLine = null;
  	    }
  	
  	    function beginFreeGroundPlotting() {
  	      unlockMapForPlotOrClose();
  	
  	      resetFreeGroundPlotDraftOnly();
  	
  	      createState.isPlotting = true;
  	      createState.isSaved = false;
  	      createState.openDropdown = "";
  	
  	      const map = resolveTrackITGoogleMap(MAP_INPUT);
  	
  	      if (map) {
  	        createState.plotDraftMap = map;
  	        bindCreatePlotFreeGroundClick(map);
  	      }
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Plotting started:", {
  	        company: createState.company,
  	        locationType: createState.locationType,
  	        creationMode: createState.creationMode,
  	        name: createState.name
  	      });
  	    }
  	
  	    function createPlotMarker(map, point, index) {
  	      if (
  	        typeof google === "undefined" ||
  	        !google.maps ||
  	        !google.maps.Marker
  	      ) {
  	        return null;
  	      }
  	
  	      try {
  	        return new google.maps.Marker({
  	          map,
  	          position: point,
  	          label: String(index + 1),
  	          title: `Point ${index + 1}`
  	        });
  	      } catch (_) {
  	        return null;
  	      }
  	    }
  	
  	    function freeGroundPointEquals(a, b) {
  	      if (!a || !b) return false;
  	
  	      return (
  	        Math.abs(Number(a.lat) - Number(b.lat)) < 1e-9 &&
  	        Math.abs(Number(a.lng) - Number(b.lng)) < 1e-9
  	      );
  	    }
  	
  	    function freeGroundOrientation(p, q, r) {
  	      const value =
  	      ((Number(q.lat) - Number(p.lat)) * (Number(r.lng) - Number(q.lng))) -
  	      ((Number(q.lng) - Number(p.lng)) * (Number(r.lat) - Number(q.lat)));
  	
  	      if (Math.abs(value) < 1e-12) return 0;
  	
  	      return value > 0 ? 1: 2;
  	    }
  	
  	    function freeGroundOnSegment(p, q, r) {
  	      return (
  	        Number(q.lng) <= Math.max(Number(p.lng), Number(r.lng)) + 1e-12 &&
  	        Number(q.lng) >= Math.min(Number(p.lng), Number(r.lng)) - 1e-12 &&
  	        Number(q.lat) <= Math.max(Number(p.lat), Number(r.lat)) + 1e-12 &&
  	        Number(q.lat) >= Math.min(Number(p.lat), Number(r.lat)) - 1e-12
  	      );
  	    }
  	
  	    function freeGroundSegmentsIntersect(p1, q1, p2, q2) {
  	      const o1 = freeGroundOrientation(p1, q1, p2);
  	      const o2 = freeGroundOrientation(p1, q1, q2);
  	      const o3 = freeGroundOrientation(p2, q2, p1);
  	      const o4 = freeGroundOrientation(p2, q2, q1);
  	
  	      // Only block a real X-crossing.
  	      // Touching, sharing a point, or following the same boundary is allowed during live snap.
  	      return (
  	        o1 !== 0 &&
  	        o2 !== 0 &&
  	        o3 !== 0 &&
  	        o4 !== 0 &&
  	        o1 !== o2 &&
  	        o3 !== o4
  	      );
  	    }
  	
  	    function freeGroundEdgesAreAdjacent(i, j, edgeCount) {
  	      if (i === j) return true;
  	      if (Math.abs(i - j) === 1) return true;
  	
  	      if (i === 0 && j === edgeCount - 1) return true;
  	      if (j === 0 && i === edgeCount - 1) return true;
  	
  	      return false;
  	    }
  	
  	    function freeGroundSelfIntersects(points) {
  	      try {
  	        if (!Array.isArray(points) || points.length < 4) return false;
  	
  	        const clean = [];
  	
  	        points.forEach(point => {
  	          const p = {
  	            lat: Number(point?.lat),
  	            lng: Number(point?.lng)
  	          };
  	
  	          if (!Number.isFinite(p.lat) || !Number.isFinite(p.lng)) return;
  	
  	          const last = clean.length ? clean[clean.length - 1]: null;
  	
  	          if (last && freeGroundPointEquals(last, p)) return;
  	
  	          clean.push(p);
  	        });
  	
  	        if (clean.length >= 2 && freeGroundPointEquals(clean[0], clean[clean.length - 1])) {
  	          clean.pop();
  	        }
  	
  	        if (clean.length < 4) return false;
  	
  	        const edgeCount = clean.length;
  	
  	        for (let i = 0; i < edgeCount; i++) {
  	          const a1 = clean[i];
  	          const a2 = clean[(i + 1) % edgeCount];
  	
  	          if (!a1 || !a2) continue;
  	          if (freeGroundPointEquals(a1, a2)) continue;
  	
  	          for (let j = i + 1; j < edgeCount; j++) {
  	            if (freeGroundEdgesAreAdjacent(i, j, edgeCount)) continue;
  	
  	            const b1 = clean[j];
  	            const b2 = clean[(j + 1) % edgeCount];
  	
  	            if (!b1 || !b2) continue;
  	            if (freeGroundPointEquals(b1, b2)) continue;
  	
  	            if (freeGroundSegmentsIntersect(a1, a2, b1, b2)) {
  	              return true;
  	            }
  	          }
  	        }
  	
  	        return false;
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Self-intersection check failed.", error);
  	        return false;
  	      }
  	    }
  	
  	    function warnFreeGroundCrossingOnce() {
  	      const now = Date.now();
  	
  	      if (now - Number(createState.plotCrossingWarnAt || 0) < 1200) return;
  	
  	      createState.plotCrossingWarnAt = now;
  	
  	      window.alert(
  	        "Location boundaries cannot cross.\n\n" +
  	        "Please move the point so the shape stays clean and does not fold over itself."
  	      );
  	    }
  	
  	    function validateFreeGroundRawCandidate(rawPoints, source) {
  	      const raw = Array.isArray(rawPoints)
  	      ? rawPoints.map(point => {
  	        return {
  	          lat: Number(point?.lat),
  	          lng: Number(point?.lng)
  	        };
  	      }).filter(point => {
  	        return Number.isFinite(point.lat) && Number.isFinite(point.lng);
  	      }): [];
  	
  	      if (createState.plotMode === "child-location") {
  	        const generatedChild = isGeneratedCreationMode();
  	
  	        const resolved = generatedChild
  	        ? resolveGeneratedChildFreeGroundSnapDraft(raw): resolveChildFreeGroundSnapDraft(raw);
  	
  	        const points = Array.isArray(resolved?.points) ? resolved.points: [];
  	
  	        // Normal child polygons must never cross over themselves.
  	        // Previously this was only logged for debugging, which allowed bad child
  	        // polygons inside Pivot/Wedge parents.
  	        if (!generatedChild && raw.length >= 4) {
  	          const rawCrosses = freeGroundSelfIntersects(raw);
  	          const resolvedCrosses = freeGroundSelfIntersects(points);
  	
  	          if (rawCrosses || resolvedCrosses) {
  	            warnFreeGroundCrossingOnce();
  	
  	            FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Child polygon rejected because boundary crosses itself.", {
  	              source,
  	              creationMode: createState.creationMode,
  	              childShapeMode: createState.childShapeMode,
  	              rawCrosses,
  	              resolvedCrosses,
  	              raw,
  	              resolvedPoints: points,
  	              snapSegments: resolved?.snapSegments || []
  	            });
  	
  	            return null;
  	          }
  	        }
  	
  	        // Generated child shapes are still handled by the generated resolver.
  	        // Do not reject those here unless we deliberately harden generated clipping later.
  	        if (generatedChild && raw.length >= 4 && freeGroundSelfIntersects(points)) {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Generated Child Shape Wizard] Generated child resolved boundary currently crosses itself. Allowing for generated resolver debugging.", {
  	            source,
  	            creationMode: createState.creationMode,
  	            childShapeMode: createState.childShapeMode,
  	            raw,
  	            resolvedPoints: points,
  	            snapSegments: resolved?.snapSegments || []
  	          });
  	        }
  	
  	        return resolved;
  	      }
  	
  	      // Normal Free Ground Polygon must never be allowed to fold/cross over itself.
  	      // Check raw intent before the resolver can hide the bad user action.
  	      if (!isGeneratedCreationMode() && raw.length >= 4 && freeGroundSelfIntersects(raw)) {
  	        warnFreeGroundCrossingOnce();
  	
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Free Ground polygon rejected because raw boundary crosses itself.", {
  	          source,
  	          creationMode: createState.creationMode,
  	          raw
  	        });
  	
  	        return null;
  	      }
  	
  	      const resolved = resolveFreeGroundSnapDraft(raw);
  	
  	      if (isGeneratedCreationMode()) {
  	        const points = Array.isArray(resolved?.points) ? resolved.points: [];
  	
  	        if (raw.length >= 4 && freeGroundSelfIntersects(points)) {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Generated Shape Wizard] Generated resolved boundary currently crosses itself. Allowing for resolver debugging.", {
  	            source,
  	            creationMode: createState.creationMode,
  	            raw,
  	            resolvedPoints: points,
  	            snapSegments: resolved?.snapSegments || []
  	          });
  	        }
  	
  	        return resolved;
  	      }
  	
  	      // With fewer than 4 raw intent points, the user cannot create a true self-crossing polygon.
  	      // The resolved snapped route may already contain extra boundary points, so do not reject yet.
  	      if (raw.length < 4) {
  	        return resolved;
  	      }
  	
  	      const points = Array.isArray(resolved?.points) ? resolved.points: [];
  	
  	      if (freeGroundSelfIntersects(points)) {
  	        warnFreeGroundCrossingOnce();
  	
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Candidate rejected because resolved boundary crosses itself.", {
  	          source,
  	          raw,
  	          resolvedPoints: points,
  	          snapSegments: resolved?.snapSegments || []
  	        });
  	
  	        return null;
  	      }
  	
  	      return resolved;
  	    }
  	
  	    function freeGroundMidpointBetween(a, b) {
  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google &&
  	          google.maps &&
  	          google.maps.geometry &&
  	          google.maps.geometry.spherical &&
  	          typeof google.maps.geometry.spherical.interpolate === "function"
  	        ) {
  	          const aLL = new google.maps.LatLng(Number(a.lat), Number(a.lng));
  	          const bLL = new google.maps.LatLng(Number(b.lat), Number(b.lng));
  	          const mid = google.maps.geometry.spherical.interpolate(aLL, bLL, 0.5);
  	
  	          return {
  	            lat: mid.lat(),
  	            lng: mid.lng()
  	          };
  	        }
  	      } catch (_) {}
  	
  	      return {
  	        lat: (Number(a.lat) + Number(b.lat)) / 2,
  	        lng: (Number(a.lng) + Number(b.lng)) / 2
  	      };
  	    }
  	
  	    function makeFreeGroundVertexIcon(isActive) {
  	      const color = getFreeGroundPlotColor();
  	
  	      return {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        scale: isActive ? 7: 5,
  	        fillColor: color,
  	        fillOpacity: 1,
  	        strokeColor: isActive ? "#ffffff": "#111111",
  	        strokeWeight: isActive ? 3: 2
  	      };
  	    }
  	
  	    function makeFreeGroundMidpointIcon() {
  	      return {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        scale: 4,
  	        fillColor: "#ffffff",
  	        fillOpacity: 0.95,
  	        strokeColor: getFreeGroundPlotColor(),
  	        strokeWeight: 2
  	      };
  	    }
  	
  	    function clearFreeGroundMidMarkers() {
  	      try {
  	        if (Array.isArray(createState.plotDraftMidMarkers)) {
  	          createState.plotDraftMidMarkers.forEach(marker => {
  	            try {
  	              marker.setMap(null);
  	            } catch (_) {}
  	          });
  	        }
  	      } catch (_) {}
  	
  	      createState.plotDraftMidMarkers = [];
  	    }
  	
  	    function commitFreeGroundRawPoints(map, nextRawPoints, source, activeIndex) {
  	      const resolved = validateFreeGroundRawCandidate(nextRawPoints, source);
  	
  	      if (!resolved) return false;
  	
  	      createState.plotRawPoints = nextRawPoints.map(point => {
  	        return {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        };
  	      });
  	
  	      createState.plotPoints = resolved.points || [];
  	      createState.plotResolvedPoints = createState.plotPoints.slice();
  	      createState.plotSnapSegments = resolved.snapSegments || [];
  	      createState.plotHeadingPoints = resolved.headingPoints || [];
  	      createState.plotHoleRings = resolved.holeRings || [];
  	      createState.plotHoleLocations = resolved.holeLocations || [];
  	      clearEntrancePointDraft();
  	
  	      if (Number.isFinite(Number(activeIndex))) {
  	        createState.plotActiveRawIndex = Number(activeIndex);
  	      }
  	
  	      redrawFreeGroundPlot(map || createState.plotDraftMap);
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Raw edit committed:", {
  	        source,
  	        rawPoints: createState.plotRawPoints,
  	        resolvedPoints: createState.plotPoints,
  	        snapSegments: createState.plotSnapSegments
  	      });
  	
  	      return true;
  	    }
  	
  	    function insertFreeGroundRawPointAt(insertAt, point, makeActive) {
  	      if (!point) return false;
  	
  	      const raw = Array.isArray(createState.plotRawPoints)
  	      ? createState.plotRawPoints.slice(): [];
  	
  	      const cleanPoint = {
  	        lat: Number(point.lat),
  	        lng: Number(point.lng)
  	      };
  	
  	      if (!Number.isFinite(cleanPoint.lat) || !Number.isFinite(cleanPoint.lng)) {
  	        return false;
  	      }
  	
  	      const safeIndex = Math.max(0, Math.min(Number(insertAt) || 0, raw.length));
  	
  	      raw.splice(safeIndex, 0, cleanPoint);
  	
  	      return commitFreeGroundRawPoints(
  	        createState.plotDraftMap,
  	        raw,
  	        "insert-raw-midpoint",
  	        makeActive ? safeIndex: createState.plotActiveRawIndex
  	      );
  	    }
  	
  	    function rebuildFreeGroundMidpointMarkers(map) {
  	      clearFreeGroundMidMarkers();
  	
  	      if (
  	        typeof google === "undefined" ||
  	        !google.maps ||
  	        !google.maps.Marker ||
  	        !google.maps.SymbolPath
  	      ) {
  	        return;
  	      }
  	
  	      const raw = Array.isArray(createState.plotRawPoints)
  	      ? createState.plotRawPoints: [];
  	
  	      const n = raw.length;
  	
  	      if (n < 2) return;
  	
  	      const edgeCount = n >= 3 ? n: n - 1;
  	
  	      for (let i = 0; i < edgeCount; i++) {
  	        const edgeStartIndex = i;
  	        const a = raw[edgeStartIndex];
  	        const b = raw[(edgeStartIndex + 1) % n];
  	
  	        if (!a || !b) continue;
  	
  	        const mid = freeGroundMidpointBetween(a, b);
  	
  	        let insertAt = edgeStartIndex + 1;
  	
  	        if (edgeStartIndex === n - 1) {
  	          insertAt = n;
  	        }
  	
  	        try {
  	          const marker = new google.maps.Marker({
  	            position: {
  	              lat: Number(mid.lat),
  	              lng: Number(mid.lng)
  	            },
  	            map,
  	            draggable: true,
  	            icon: makeFreeGroundMidpointIcon(),
  	            title: "Insert point",
  	            zIndex: 2147483602
  	          });
  	
  	          marker.addListener("click", function () {
  	            insertFreeGroundRawPointAt(insertAt, mid, true);
  	          });
  	
  	          marker.addListener("dragend", function () {
  	            const pos = marker.getPosition();
  	
  	            if (!pos) return;
  	
  	            const candidate = {
  	              lat: pos.lat(),
  	              lng: pos.lng()
  	            };
  	
  	            const inserted = insertFreeGroundRawPointAt(insertAt, candidate, true);
  	
  	            if (!inserted) {
  	              try {
  	                marker.setPosition({
  	                  lat: Number(mid.lat),
  	                  lng: Number(mid.lng)
  	                });
  	              } catch (_) {}
  	            }
  	          });
  	
  	          createState.plotDraftMidMarkers.push(marker);
  	        } catch (_) {}
  	      }
  	    }
  	
  	    function createHeadingMarker(map,
  	      point,
  	      index) {
  	      if (
  	        typeof google === "undefined" ||
  	        !google.maps ||
  	        !google.maps.Marker ||
  	        !google.maps.SymbolPath
  	      ) {
  	        return null;
  	      }
  	
  	      try {
  	        return new google.maps.Marker({
  	          map,
  	          position: point,
  	          title: `Heading Point ${index + 1}`,
  	          icon: {
  	            path: google.maps.SymbolPath.CIRCLE,
  	            scale: 5,
  	            fillColor: "#25c7ff",
  	            fillOpacity: 1,
  	            strokeColor: "#ffffff",
  	            strokeWeight: 2
  	          },
  	          zIndex: 2147483601
  	        });
  	      } catch (_) {
  	        return null;
  	      }
  	    }
  	
  	    function samePlotPoint(a, b) {
  	      if (!a || !b) return false;
  	
  	      return (
  	        Math.abs(Number(a.lat) - Number(b.lat)) < 1e-9 &&
  	        Math.abs(Number(a.lng) - Number(b.lng)) < 1e-9
  	      );
  	    }
  	
  	    function pushPlotPoint(list, point) {
  	      if (!Array.isArray(list) || !point) return;
  	
  	      const clean = {
  	        lat: Number(point.lat),
  	        lng: Number(point.lng)
  	      };
  	
  	      if (!Number.isFinite(clean.lat) || !Number.isFinite(clean.lng)) return;
  	
  	      const last = list.length ? list[list.length - 1]: null;
  	
  	      if (samePlotPoint(last, clean)) return;
  	
  	      list.push(clean);
  	    }
  	
  	    function plotDistanceSq(a, b) {
  	      if (!a || !b) return 0;
  	
  	      const dx = Number(a.lng) - Number(b.lng);
  	      const dy = Number(a.lat) - Number(b.lat);
  	
  	      return (dx * dx) + (dy * dy);
  	    }
  	
  	    function plotRouteDistanceSq(points) {
  	      if (!Array.isArray(points) || points.length < 2) return 0;
  	
  	      let total = 0;
  	
  	      for (let i = 0; i < points.length - 1; i++) {
  	        total += plotDistanceSq(points[i], points[i + 1]);
  	      }
  	
  	      return total;
  	    }
  	
  	    function pointOnBoundarySegment(point, a, b) {
  	      if (!point || !a || !b) return false;
  	
  	      const px = Number(point.lng);
  	      const py = Number(point.lat);
  	      const ax = Number(a.lng);
  	      const ay = Number(a.lat);
  	      const bx = Number(b.lng);
  	      const by = Number(b.lat);
  	
  	      const cross = ((py - ay) * (bx - ax)) - ((px - ax) * (by - ay));
  	
  	      if (Math.abs(cross) > 1e-10) return false;
  	
  	      const dot = ((px - ax) * (bx - ax)) + ((py - ay) * (by - ay));
  	
  	      if (dot < -1e-10) return false;
  	
  	      const lengthSq = ((bx - ax) * (bx - ax)) + ((by - ay) * (by - ay));
  	
  	      if (dot - lengthSq > 1e-10) return false;
  	
  	      return true;
  	    }
  	
  	    function pointInPlotBoundary(point, boundary) {
  	      if (!point || !Array.isArray(boundary) || boundary.length < 3) return false;
  	
  	      const x = Number(point.lng);
  	      const y = Number(point.lat);
  	
  	      if (!Number.isFinite(x) || !Number.isFinite(y)) return false;
  	
  	      for (let edgeIndex = 0; edgeIndex < boundary.length; edgeIndex++) {
  	        const a = boundary[edgeIndex];
  	        const b = boundary[(edgeIndex + 1) % boundary.length];
  	
  	        if (pointOnBoundarySegment(point, a, b)) {
  	          return true;
  	        }
  	      }
  	
  	      let inside = false;
  	
  	      for (let i = 0, j = boundary.length - 1; i < boundary.length; j = i++) {
  	        const xi = Number(boundary[i].lng);
  	        const yi = Number(boundary[i].lat);
  	        const xj = Number(boundary[j].lng);
  	        const yj = Number(boundary[j].lat);
  	
  	        if (
  	          !Number.isFinite(xi) ||
  	          !Number.isFinite(yi) ||
  	          !Number.isFinite(xj) ||
  	          !Number.isFinite(yj)
  	        ) {
  	          continue;
  	        }
  	
  	        const intersects =
  	        ((yi > y) !== (yj > y)) &&
  	        (x < ((xj - xi) * (y - yi) / ((yj - yi) || 1e-12)) + xi);
  	
  	        if (intersects) inside = !inside;
  	      }
  	
  	      return inside;
  	    }
  	
  	    function lineIntersectionPoint(a, b, c, d) {
  	      const r = {
  	        x: b.lng - a.lng,
  	        y: b.lat - a.lat
  	      };
  	
  	      const s = {
  	        x: d.lng - c.lng,
  	        y: d.lat - c.lat
  	      };
  	
  	      const denominator = (r.x * s.y) - (r.y * s.x);
  	
  	      if (Math.abs(denominator) < 1e-12) return null;
  	
  	      const qmp = {
  	        x: c.lng - a.lng,
  	        y: c.lat - a.lat
  	      };
  	
  	      const t = ((qmp.x * s.y) - (qmp.y * s.x)) / denominator;
  	      const u = ((qmp.x * r.y) - (qmp.y * r.x)) / denominator;
  	
  	      if (t < -1e-9 || t > 1 + 1e-9 || u < -1e-9 || u > 1 + 1e-9) return null;
  	
  	      return {
  	        point: {
  	          lat: a.lat + (t * (b.lat - a.lat)),
  	          lng: a.lng + (t * (b.lng - a.lng))
  	        },
  	        t: Math.max(0, Math.min(1, t)),
  	        u: Math.max(0, Math.min(1, u))
  	      };
  	    }
  	
  	    function nearestPointOnBoundary(point, boundary) {
  	      const hit = nearestBoundaryHit(point, boundary);
  	
  	      return hit ? hit.point: null;
  	    }
  	
  	    function nearestBoundaryHit(point, boundary) {
  	      if (!point || !Array.isArray(boundary) || boundary.length < 2) return null;
  	
  	      let best = null;
  	
  	      function projectPointToSegment(p, a, b, segmentIndex) {
  	        const ax = Number(a.lng);
  	        const ay = Number(a.lat);
  	        const bx = Number(b.lng);
  	        const by = Number(b.lat);
  	        const px = Number(p.lng);
  	        const py = Number(p.lat);
  	
  	        const dx = bx - ax;
  	        const dy = by - ay;
  	        const lengthSq = (dx * dx) + (dy * dy);
  	
  	        if (lengthSq <= 1e-18) {
  	          return {
  	            point: {
  	              lat: ay,
  	              lng: ax
  	            },
  	            segmentIndex,
  	            distanceSq: ((px - ax) * (px - ax)) + ((py - ay) * (py - ay))
  	          };
  	        }
  	
  	        let t = (((px - ax) * dx) + ((py - ay) * dy)) / lengthSq;
  	
  	        t = Math.max(0, Math.min(1, t));
  	
  	        const x = ax + (t * dx);
  	        const y = ay + (t * dy);
  	
  	        return {
  	          point: {
  	            lat: y,
  	            lng: x
  	          },
  	          segmentIndex,
  	          distanceSq: ((px - x) * (px - x)) + ((py - y) * (py - y))
  	        };
  	      }
  	
  	      for (let i = 0; i < boundary.length; i++) {
  	        const a = boundary[i];
  	        const b = boundary[(i + 1) % boundary.length];
  	
  	        const projected = projectPointToSegment(point, a, b, i);
  	
  	        if (!best || projected.distanceSq < best.distanceSq) {
  	          best = projected;
  	        }
  	      }
  	
  	      return best;
  	    }
  	
  	    function getLocationOuterBoundary(location) {
  	      const paths = rendererGetPolygonPaths(location);
  	
  	      if (!Array.isArray(paths) || !paths.length) return null;
  	
  	      const outer = paths[0];
  	
  	      if (!Array.isArray(outer) || outer.length < 3) return null;
  	
  	      return outer.map(point => {
  	        return {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        };
  	      }).filter(point => {
  	        return Number.isFinite(point.lat) && Number.isFinite(point.lng);
  	      });
  	    }
  	
  	    function makeLocationBlocker(location) {
  	      if (!location) return null;
  	
  	      const boundary = getLocationOuterBoundary(location);
  	
  	      if (!Array.isArray(boundary) || boundary.length < 3) return null;
  	
  	      return {
  	        location,
  	        locationId: rendererGetLocationId(location),
  	        locationName: rendererGetLocationName(location),
  	        boundary,
  	        area: rendererComputeArea(boundary)
  	      };
  	    }
  	
  	    function getLocationHierarchyParentId(location) {
  	      if (!location || typeof location !== "object") return "";
  	
  	      return safeString(
  	        location.ParentId ||
  	        location.parentId ||
  	        location.ParentID ||
  	        location.parentID ||
  	        location.ParentLocationId ||
  	        location.parentLocationId ||
  	        location.ParentLocationID ||
  	        location.parentLocationID ||
  	        location.Parent?.objectId ||
  	        location.parent?.objectId ||
  	        location.Parent?.ObjectId ||
  	        location.parent?.ObjectId ||
  	        location.Parent?.id ||
  	        location.parent?.id ||
  	        location.Parent?.ID ||
  	        location.parent?.ID ||
  	        ""
  	      ).trim();
  	    }
  	
  	    function sortLocationBlockersByAreaAndId(blockers) {
  	      return (Array.isArray(blockers) ? blockers: []).slice().sort((a, b) => {
  	        const areaA = Number(a?.area) || 0;
  	        const areaB = Number(b?.area) || 0;
  	
  	        if (areaA < areaB) return -1;
  	        if (areaA > areaB) return 1;
  	
  	        return safeString(a?.locationId).localeCompare(safeString(b?.locationId));
  	      });
  	    }
  	
  	    function buildLocationHierarchyIndex() {
  	      const locations = rendererCollectLocations();
  	      const byId = Object.create(null);
  	      const blockersById = Object.create(null);
  	      const explicitParentById = Object.create(null);
  	      const nestedParentById = Object.create(null);
  	      const parentById = Object.create(null);
  	
  	      const list = Array.isArray(locations) ? locations: [];
  	
  	      list.forEach(location => {
  	        if (!location || typeof location !== "object") return;
  	
  	        const id = safeString(rendererGetLocationId(location)).trim();
  	
  	        if (!id) return;
  	
  	        if (!byId[id]) {
  	          byId[id] = location;
  	        }
  	
  	        const explicitParentId = getLocationHierarchyParentId(location);
  	
  	        if (explicitParentId) {
  	          explicitParentById[id] = explicitParentId;
  	        }
  	
  	        const blocker = makeLocationBlocker(location);
  	
  	        if (blocker) {
  	          blockersById[id] = blocker;
  	        }
  	      });
  	
  	      list.forEach(parentLocation => {
  	        if (!parentLocation || typeof parentLocation !== "object") return;
  	
  	        const parentId = safeString(rendererGetLocationId(parentLocation)).trim();
  	
  	        if (!parentId) return;
  	
  	        getLocationChildren(parentLocation).forEach(childLocation => {
  	          const childId = safeString(rendererGetLocationId(childLocation)).trim();
  	
  	          if (!childId || childId === parentId) return;
  	
  	          nestedParentById[childId] = parentId;
  	        });
  	      });
  	
  	      Object.keys(byId).forEach(id => {
  	        const explicitParentId = safeString(explicitParentById[id]).trim();
  	        const nestedParentId = safeString(nestedParentById[id]).trim();
  	
  	        // Only treat explicit ParentId as a Location parent if that parent is
  	        // actually a saved Location in this same hierarchy. This avoids
  	        // mistaking Company IDs for Location parent IDs.
  	        if (explicitParentId && byId[explicitParentId]) {
  	          parentById[id] = explicitParentId;
  	          return;
  	        }
  	
  	        if (nestedParentId && byId[nestedParentId]) {
  	          parentById[id] = nestedParentId;
  	          return;
  	        }
  	
  	        parentById[id] = "";
  	      });
  	
  	      const blockers = Object.keys(blockersById).map(id => blockersById[id]);
  	
  	      // Geometry fallback:
  	      // If a Location has no explicit/nested parent relation but is fully
  	      // contained inside another Location, infer the smallest containing
  	      // Location as its direct parent.
  	      blockers.forEach(childBlocker => {
  	        const childId = safeString(childBlocker?.locationId).trim();
  	
  	        if (!childId || parentById[childId]) return;
  	
  	        const childArea = Number(childBlocker.area) || 0;
  	
  	        const containingParents = blockers.filter(parentBlocker => {
  	          const parentId = safeString(parentBlocker?.locationId).trim();
  	
  	          if (!parentId || parentId === childId) return false;
  	
  	          const parentArea = Number(parentBlocker.area) || 0;
  	
  	          if (parentArea <= childArea) return false;
  	
  	          return blockerBoundaryIsFullyInsideOuter(childBlocker, parentBlocker.boundary);
  	        });
  	
  	        if (!containingParents.length) return;
  	
  	        containingParents.sort((a, b) => {
  	          const areaA = Number(a.area) || 0;
  	          const areaB = Number(b.area) || 0;
  	
  	          if (areaA < areaB) return -1;
  	          if (areaA > areaB) return 1;
  	
  	          return safeString(a.locationId).localeCompare(safeString(b.locationId));
  	        });
  	
  	        parentById[childId] = safeString(containingParents[0].locationId).trim();
  	      });
  	
  	      return {
  	        byId,
  	        blockers,
  	        blockersById,
  	        parentById
  	      };
  	    }
  	
  	    function getDirectChildBlockersForParentId(parentId) {
  	      const targetParentId = safeString(parentId).trim();
  	      const hierarchy = buildLocationHierarchyIndex();
  	
  	      const directChildren = hierarchy.blockers.filter(blocker => {
  	        const id = safeString(blocker?.locationId).trim();
  	
  	        if (!id) return false;
  	
  	        return safeString(hierarchy.parentById[id]).trim() === targetParentId;
  	      });
  	
  	      return sortLocationBlockersByAreaAndId(directChildren);
  	    }
  	
  	    function blockerIsImmediateGeometryChildOfParent(blocker,
  	      parentBlocker,
  	      allBlockers) {
  	      if (
  	        !blocker ||
  	        !parentBlocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        blocker.boundary.length < 3 ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return false;
  	      }
  	
  	      const blockerId = safeString(blocker.locationId).trim();
  	      const parentId = safeString(parentBlocker.locationId).trim();
  	
  	      if (!blockerId || !parentId || blockerId === parentId) return false;
  	
  	      if (!blockerBoundaryIsFullyInsideOuter(blocker, parentBlocker.boundary)) {
  	        return false;
  	      }
  	
  	      const blockerArea = Number(blocker.area) || 0;
  	      const parentArea = Number(parentBlocker.area) || 0;
  	      const list = Array.isArray(allBlockers) ? allBlockers: [];
  	
  	      // If another saved Location sits between the parent and this blocker,
  	      // then this blocker is a nephew/niece/grandchild, not a direct sibling.
  	      const hasIntermediateParent = list.some(candidate => {
  	        if (!candidate || !Array.isArray(candidate.boundary) || candidate.boundary.length < 3) {
  	          return false;
  	        }
  	
  	        const candidateId = safeString(candidate.locationId).trim();
  	
  	        if (!candidateId || candidateId === blockerId || candidateId === parentId) {
  	          return false;
  	        }
  	
  	        const candidateArea = Number(candidate.area) || 0;
  	
  	        if (candidateArea <= blockerArea || candidateArea >= parentArea) {
  	          return false;
  	        }
  	
  	        return (
  	          blockerBoundaryIsFullyInsideOuter(blocker, candidate.boundary) &&
  	          blockerBoundaryIsFullyInsideOuter(candidate, parentBlocker.boundary)
  	        );
  	      });
  	
  	      return !hasIntermediateParent;
  	    }
  	
  	    function getDirectChildBlockersForParentBlocker(parentBlocker) {
  	      if (
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return [];
  	      }
  	
  	      const parentId = safeString(parentBlocker.locationId).trim();
  	      const hierarchy = buildLocationHierarchyIndex();
  	      const allBlockers = Array.isArray(hierarchy.blockers) ? hierarchy.blockers: [];
  	
  	      const byId = Object.create(null);
  	
  	      function remember(blocker, reason) {
  	        if (!blocker || !Array.isArray(blocker.boundary) || blocker.boundary.length < 3) return;
  	
  	        const id = safeString(blocker.locationId).trim();
  	
  	        if (!id) return;
  	        if (parentId && id === parentId) return;
  	
  	        if (!byId[id]) {
  	          byId[id] = Object.assign({}, blocker, {
  	            siblingDetectReason: reason || "unknown"
  	          });
  	        }
  	      }
  	
  	      // 1. Explicit ParentId / nested Fields relationship.
  	      // This is the strongest source of truth.
  	      if (parentId) {
  	        getDirectChildBlockersForParentId(parentId).forEach(blocker => {
  	          remember(blocker, "explicit-parent-or-fields");
  	        });
  	      }
  	
  	      // 2. Geometry fallback.
  	      // Do not skip this just because explicit data found some children.
  	      // Backendless relation loading / old rows can be incomplete, so we must merge.
  	      allBlockers.forEach(blocker => {
  	        if (
  	          blockerIsImmediateGeometryChildOfParent(
  	            blocker,
  	            parentBlocker,
  	            allBlockers
  	          )
  	        ) {
  	          remember(blocker, "geometry-direct-child");
  	        }
  	      });
  	
  	      const result = Object.keys(byId).map(id => byId[id]);
  	
  	      return sortLocationBlockersByAreaAndId(result);
  	    }
  	
  	    function getTopLevelFreeGroundBlockers() {
  	      return getDirectChildBlockersForParentId("");
  	    }
  	
  	    function getFreeGroundBlockers() {
  	      const locations = rendererCollectLocations();
  	      const blockers = [];
  	
  	      locations.forEach(location => {
  	        const boundary = getLocationOuterBoundary(location);
  	
  	        if (!Array.isArray(boundary) || boundary.length < 3) return;
  	
  	        blockers.push({
  	          location,
  	          locationId: rendererGetLocationId(location),
  	          locationName: rendererGetLocationName(location),
  	          boundary,
  	          area: rendererComputeArea(boundary)
  	        });
  	      });
  	
  	      blockers.sort((a, b) => {
  	        const areaA = Number(a.area) || 0;
  	        const areaB = Number(b.area) || 0;
  	
  	        if (areaA < areaB) return -1;
  	        if (areaA > areaB) return 1;
  	
  	        return String(a.locationId).localeCompare(String(b.locationId));
  	      });
  	
  	      return blockers;
  	    }
  	
  	    function getContainingBlockerForPoint(point,
  	      blockers) {
  	      const list = Array.isArray(blockers) ? blockers: getFreeGroundBlockers();
  	
  	      for (let i = 0; i < list.length; i++) {
  	        const blocker = list[i];
  	
  	        if (!blocker || !Array.isArray(blocker.boundary)) continue;
  	
  	        if (pointInPlotBoundary(point, blocker.boundary)) {
  	          return blocker;
  	        }
  	      }
  	
  	      return null;
  	    }
  	
  	    function getContainingParentBlockerForPoint(point, clickedLocation) {
  	      const cleanPoint = makeCleanPlotPoint(point);
  	
  	      if (!cleanPoint) {
  	        return clickedLocation
  	        ? {
  	          location: clickedLocation,
  	          locationId: rendererGetLocationId(clickedLocation),
  	          locationName: rendererGetLocationName(clickedLocation),
  	          boundary: getLocationOuterBoundary(clickedLocation) || [],
  	          area: rendererComputeArea(getLocationOuterBoundary(clickedLocation) || [])
  	        }: null;
  	      }
  	
  	      // Parent selection must inspect all saved boundaries so the chosen parent
  	      // is the deepest/smallest containing Location.
  	      // Do not restrict this to top-level blockers.
  	      const blockers = getFreeGroundBlockers();
  	      const containing = [];
  	
  	      blockers.forEach(blocker => {
  	        if (!blocker || !Array.isArray(blocker.boundary) || blocker.boundary.length < 3) {
  	          return;
  	        }
  	
  	        if (pointInPlotBoundary(cleanPoint, blocker.boundary)) {
  	          containing.push(blocker);
  	        }
  	      });
  	
  	      if (containing.length) {
  	        // For child creation, the parent must be the deepest/smallest
  	        // containing Location. If the click is inside Dam, and Dam is inside
  	        // Sheltered Vale, the new child belongs to Dam.
  	        containing.sort((a, b) => {
  	          const areaA = Number(a.area) || 0;
  	          const areaB = Number(b.area) || 0;
  	
  	          if (areaA < areaB) return -1;
  	          if (areaA > areaB) return 1;
  	
  	          return String(a.locationId || "").localeCompare(String(b.locationId || ""));
  	        });
  	
  	        return containing[0];
  	      }
  	
  	      if (clickedLocation) {
  	        const boundary = getLocationOuterBoundary(clickedLocation) || [];
  	
  	        return {
  	          location: clickedLocation,
  	          locationId: rendererGetLocationId(clickedLocation),
  	          locationName: rendererGetLocationName(clickedLocation),
  	          boundary,
  	          area: rendererComputeArea(boundary)
  	        };
  	      }
  	
  	      return null;
  	    }
  	    function getChildShapeModeLabel(mode) {
  	      const value = safeString(mode).trim().toLowerCase();
  	
  	      if (value === "ring") return "Ring";
  	      if (value === "segment") return "Segment";
  	
  	      return "Polygon";
  	    }
  	
  	    function getCreationTypeLabel(value) {
  	      const mode = safeString(value).trim().toLowerCase();
  	
  	      if (mode === "pivot") return "Pivot";
  	      if (mode === "wedge") return "Wedge";
  	      if (mode === "ring") return "Ring";
  	      if (mode === "segment") return "Segment";
  	
  	      return "Polygon";
  	    }
  	
  	    function getEffectiveCreationTypeForSave() {
  	      if (
  	        createState.plotMode === "child-location" &&
  	        createState.childShapeMode
  	      ) {
  	        return getCreationTypeLabel(createState.childShapeMode);
  	      }
  	
  	      return getCreationTypeLabel(createState.creationMode);
  	    }
  	
  	    function countCleanPlotPointsForEntrance(points) {
  	      if (!Array.isArray(points)) return 0;
  	
  	      return points
  	      .map(point => makeCleanPlotPoint(point))
  	      .filter(Boolean)
  	      .length;
  	    }
  	
  	    function hasUsablePlotPointForEntrance(point) {
  	      return !!makeCleanPlotPoint(point);
  	    }
  	
  	    function getEntrancePrerequisiteStatus() {
  	      const effectiveType = safeString(getEffectiveCreationTypeForSave())
  	      .trim()
  	      .toLowerCase();
  	
  	      const polygonPointCount = Math.max(
  	        countCleanPlotPointsForEntrance(createState.plotRawPoints),
  	        countCleanPlotPointsForEntrance(createState.plotResolvedPoints),
  	        countCleanPlotPointsForEntrance(createState.plotPoints)
  	      );
  	
  	      if (effectiveType === "polygon") {
  	        const ready = polygonPointCount > 2;
  	
  	        return {
  	          ready,
  	          label: ready ? "Pick Entrance": "Need 3 Points",
  	          message: "Please add at least 3 polygon points before picking an entrance point."
  	        };
  	      }
  	
  	      if (effectiveType === "pivot" || effectiveType === "ring") {
  	        const hasCenter = hasUsablePlotPointForEntrance(
  	          createState.plotPivotCenter ||
  	          createState.childFixedCenter
  	        );
  	
  	        const hasRadius = hasUsablePlotPointForEntrance(
  	          createState.plotPivotRadiusPoint ||
  	          createState.childRadiusPoint
  	        );
  	
  	        const ready = hasCenter && hasRadius;
  	
  	        return {
  	          ready,
  	          label: ready ? "Pick Entrance": "Need C + R",
  	          message: "Please set the centre and radius before picking an entrance point."
  	        };
  	      }
  	
  	      if (effectiveType === "wedge" || effectiveType === "segment") {
  	        const hasCenter = hasUsablePlotPointForEntrance(
  	          createState.plotWedgeCenter ||
  	          createState.childFixedCenter
  	        );
  	
  	        const hasRadius = hasUsablePlotPointForEntrance(
  	          createState.plotWedgeRadiusPoint ||
  	          createState.childRadiusPoint
  	        );
  	
  	        const hasEdge = hasUsablePlotPointForEntrance(
  	          createState.plotWedgeEdgePoint ||
  	          createState.childEdgePoint
  	        );
  	
  	        const ready = hasCenter && hasRadius && hasEdge;
  	
  	        return {
  	          ready,
  	          label: ready ? "Pick Entrance": "Need C + R + E",
  	          message: "Please set the centre, radius, and edge point before picking an entrance point."
  	        };
  	      }
  	
  	      const fallbackReady = polygonPointCount > 2;
  	
  	      return {
  	        ready: fallbackReady,
  	        label: fallbackReady ? "Pick Entrance": "Finish Shape",
  	        message: "Please finish the location shape before picking an entrance point."
  	      };
  	    }
  	
  	    // ====================================================================
  	    // SAVE CHANNEL — Backendless Locations + Company relation + AppData sync
  	    // ====================================================================
  	
  	    const SAVE_TABLE_LOCATIONS = "Locations";
  	    const SAVE_TABLE_COMPANIES = "Companies";
  	    const SAVE_COMPANY_LOCATIONS_RELATION = "Locations";
  	    const SAVE_PARENT_CHILDREN_RELATION = "Fields";
  	
  	    function backendlessDataAvailable() {
  	      return !!(
  	        typeof Backendless !== "undefined" &&
  	        Backendless &&
  	        Backendless.Data &&
  	        typeof Backendless.Data.of === "function"
  	      );
  	    }
  	
  	    function safeCloneForSave(value) {
  	      try {
  	        return value === undefined ? undefined: JSON.parse(JSON.stringify(value));
  	      } catch (_) {
  	        return value;
  	      }
  	    }
  	
  	    function roundSaveNumber(value, decimals) {
  	      const n = Number(value);
  	      const d = Number.isFinite(Number(decimals)) ? Number(decimals): 2;
  	
  	      if (!Number.isFinite(n)) return 0;
  	
  	      const factor = Math.pow(10, d);
  	
  	      return Math.round(n * factor) / factor;
  	    }
  	
  	    function closeSaveRing(points) {
  	      const clean = Array.isArray(points)
  	      ? points.map(point => makeCleanPlotPoint(point)).filter(Boolean): [];
  	
  	      if (clean.length < 3) return [];
  	
  	      const ring = clean.map(point => {
  	        return [
  	          Number(point.lng),
  	          Number(point.lat)
  	        ];
  	      });
  	
  	      const first = ring[0];
  	      const last = ring[ring.length - 1];
  	
  	      if (
  	        !last ||
  	        Number(first[0]) !== Number(last[0]) ||
  	        Number(first[1]) !== Number(last[1])
  	      ) {
  	        ring.push([
  	          Number(first[0]),
  	          Number(first[1])
  	        ]);
  	      }
  	
  	      return ring;
  	    }
  	
  	    function ringLngLatToLatLngPoints(ring) {
  	      if (!Array.isArray(ring)) return [];
  	
  	      const points = ring.map(coord => {
  	        if (!Array.isArray(coord) || coord.length < 2) return null;
  	
  	        const lng = Number(coord[0]);
  	        const lat = Number(coord[1]);
  	
  	        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  	
  	        return {
  	          lat,
  	          lng
  	        };
  	      }).filter(Boolean);
  	
  	      if (points.length >= 2) {
  	        const first = points[0];
  	        const last = points[points.length - 1];
  	
  	        if (
  	          Math.abs(Number(first.lat) - Number(last.lat)) < 1e-12 &&
  	          Math.abs(Number(first.lng) - Number(last.lng)) < 1e-12
  	        ) {
  	          points.pop();
  	        }
  	      }
  	
  	      return points;
  	    }
  	
  	    function buildSavePolygonGeoJson() {
  	      const outerPoints = Array.isArray(createState.plotResolvedPoints) && createState.plotResolvedPoints.length
  	      ? createState.plotResolvedPoints: createState.plotPoints;
  	
  	      const outerRing = closeSaveRing(outerPoints);
  	
  	      if (!outerRing.length) return null;
  	
  	      const coordinates = [outerRing];
  	
  	      const holes = Array.isArray(createState.plotHoleRings)
  	      ? createState.plotHoleRings: [];
  	
  	      holes.forEach(holeRing => {
  	        const closedHole = closeSaveRing(holeRing);
  	
  	        if (closedHole.length >= 4) {
  	          coordinates.push(closedHole);
  	        }
  	      });
  	
  	      return {
  	        type: "Polygon",
  	        coordinates
  	      };
  	    }
  	
  	    function buildSavePoint(point) {
  	      const clean = makeCleanPlotPoint(point);
  	
  	      if (!clean) return null;
  	
  	      return {
  	        type: "Point",
  	        coordinates: [
  	          Number(clean.lng),
  	          Number(clean.lat)
  	        ]
  	      };
  	    }
  	
  	    function computeSavePolygonAreaM2(polygonGeoJson) {
  	      if (
  	        !polygonGeoJson ||
  	        !Array.isArray(polygonGeoJson.coordinates) ||
  	        !polygonGeoJson.coordinates.length
  	      ) {
  	        return 0;
  	      }
  	
  	      const outer = ringLngLatToLatLngPoints(polygonGeoJson.coordinates[0]);
  	      let total = rendererComputeArea(outer);
  	
  	      for (let i = 1; i < polygonGeoJson.coordinates.length; i++) {
  	        const hole = ringLngLatToLatLngPoints(polygonGeoJson.coordinates[i]);
  	        total -= rendererComputeArea(hole);
  	      }
  	
  	      return Math.max(0, Number(total) || 0);
  	    }
  	
  	    function computeCentroidForSave(points) {
  	      const clean = Array.isArray(points)
  	      ? points.map(point => makeCleanPlotPoint(point)).filter(Boolean): [];
  	
  	      if (!clean.length) return null;
  	
  	      let sumLat = 0;
  	      let sumLng = 0;
  	
  	      clean.forEach(point => {
  	        sumLat += Number(point.lat);
  	        sumLng += Number(point.lng);
  	      });
  	
  	      return {
  	        lat: sumLat / clean.length,
  	        lng: sumLng / clean.length
  	      };
  	    }
  	
  	    function getSaveCentrePoint(effectiveCreationType) {
  	      const type = safeString(effectiveCreationType).trim().toLowerCase();
  	
  	      if (type === "pivot") {
  	        return makeCleanPlotPoint(createState.plotPivotCenter || createState.childFixedCenter);
  	      }
  	
  	      if (type === "wedge") {
  	        return makeCleanPlotPoint(createState.plotWedgeCenter || createState.childFixedCenter);
  	      }
  	
  	      if (type === "ring" || type === "segment") {
  	        return makeCleanPlotPoint(createState.childFixedCenter);
  	      }
  	
  	      return computeCentroidForSave(
  	        Array.isArray(createState.plotResolvedPoints) && createState.plotResolvedPoints.length
  	        ? createState.plotResolvedPoints: createState.plotPoints
  	      );
  	    }
  	
  	    function resolveSelectedCompanyForSave() {
  	      return getCompanyObjectByValue(createState.company) || null;
  	    }
  	
  	    function resolveCompanyOwnerIdForSave(company) {
  	      return (
  	        company?.ownerId ||
  	        company?.OwnerId ||
  	        company?.ownerID ||
  	        company?.OwnerID ||
  	        company?.User?.objectId ||
  	        company?.user?.objectId ||
  	        company?.Owner?.objectId ||
  	        company?.owner?.objectId ||
  	        ""
  	      );
  	    }
  	
  	    function generateLocationIdForSave(effectiveCreationType) {
  	      const type = safeString(effectiveCreationType || "LOC")
  	      .trim()
  	      .toUpperCase()
  	      .replace(/[^A-Z0-9]+/g, "")
  	      .slice(0, 3) || "LOC";
  	
  	      return `${type}-${Date.now().toString(36).toUpperCase()}`;
  	    }
  	
  	
  	    function buildCreateFunctionalityPayload() {
  	      const fuelMode = createState.functionality.fuelLogic
  	      ? (
  	        createState.functionality.publicFuelStation
  	        ? "publicFuelStation": createState.functionality.fuelDepot
  	        ? "depot": ""
  	      ): "";
  	
  	      return {
  	        eventsCapture: !!createState.functionality.eventsCapture,
  	        fuelLogic: !!createState.functionality.fuelLogic,
  	        fuelMode,
  	        publicFuelStation: !!createState.functionality.publicFuelStation,
  	        fuelDepot: !!createState.functionality.fuelDepot,
  	        loadLogic: !!createState.functionality.loadLogic,
  	        gateLogic: !!createState.functionality.gateLogic,
  	        gatePhone: createState.functionality.gateLogic
  	        ? safeString(createState.functionality.gatePhone): ""
  	      };
  	    }
  	
  	    function buildLocationDataForSave(areaM2, centrePoint, effectiveCreationType) {
  	      const hectares = areaM2 / 10000;
  	      const acres = areaM2 * 0.000247105;
  	
  	      const functionality = buildCreateFunctionalityPayload();
  	
  	      const data = {
  	        Area: {
  	          m2: roundSaveNumber(areaM2, 2),
  	          Acres: roundSaveNumber(acres, 2),
  	          Center: centrePoint ? {
  	            lat: Number(centrePoint.lat),
  	            lng: Number(centrePoint.lng)
  	          }: null,
  	          Hectares: roundSaveNumber(hectares, 2),
  	          Functionality: {
  	            FuelLogic: functionality.fuelLogic,
  	            FuelMode: functionality.fuelMode,
  	            GateLogic: functionality.gateLogic,
  	            LoadLogic: functionality.loadLogic,
  	            EventsCapture: functionality.eventsCapture
  	          }
  	        },
  	        FuelItems: [],
  	        ContactName: "",
  	        Description: "",
  	        ContactNumber: ""
  	      };
  	
  	      data.CreationType = effectiveCreationType;
  	      data.creationMode = createState.creationMode || "";
  	      data.childShapeMode = createState.childShapeMode || "";
  	      data.parentLocationId = createState.plotParentLocationId || "";
  	
  	      data.Geometry = {
  	        rawPoints: safeCloneForSave(createState.plotRawPoints || []),
  	        resolvedPoints: safeCloneForSave(createState.plotResolvedPoints || createState.plotPoints || []),
  	        holeRings: safeCloneForSave(createState.plotHoleRings || []),
  	        snapSegments: safeCloneForSave(createState.plotSnapSegments || [])
  	      };
  	
  	      data.Shape = {
  	        PivotCenter: makeCleanPlotPoint(createState.plotPivotCenter),
  	        PivotRadiusPoint: makeCleanPlotPoint(createState.plotPivotRadiusPoint),
  	        PivotRadiusMeters: Number(createState.plotPivotRadiusMeters || 0),
  	
  	        WedgeCenter: makeCleanPlotPoint(createState.plotWedgeCenter),
  	        WedgeRadiusPoint: makeCleanPlotPoint(createState.plotWedgeRadiusPoint),
  	        WedgeEdgePoint: makeCleanPlotPoint(createState.plotWedgeEdgePoint),
  	        WedgeRadiusMeters: Number(createState.plotWedgeRadiusMeters || 0),
  	
  	        ChildFixedCenter: makeCleanPlotPoint(createState.childFixedCenter),
  	        ChildRadiusPoint: makeCleanPlotPoint(createState.childRadiusPoint),
  	        ChildEdgePoint: makeCleanPlotPoint(createState.childEdgePoint),
  	
  	        EntrancePoint: makeCleanPlotPoint(createState.entrancePoint)
  	      };
  	
  	      data.Functionality = {
  	        EventsCapture: functionality.eventsCapture,
  	        FuelLogic: functionality.fuelLogic,
  	        FuelMode: functionality.fuelMode,
  	        PublicFuelStation: functionality.publicFuelStation,
  	        FuelDepot: functionality.fuelDepot,
  	        LoadLogic: functionality.loadLogic,
  	        GateLogic: functionality.gateLogic,
  	        GatePhone: functionality.gatePhone
  	      };
  	
  	      return data;
  	    }
  	
  	    function buildLocationSavePayload() {
  	      const selectedType = getLocationType(createState.locationType);
  	      const company = resolveSelectedCompanyForSave();
  	      const effectiveCreationType = getEffectiveCreationTypeForSave();
  	
  	      const polygon = buildSavePolygonGeoJson();
  	
  	      if (!polygon) {
  	        throw new Error("Cannot save location because the resolved polygon is empty.");
  	      }
  	
  	      const entrancePoint = makeCleanPlotPoint(createState.entrancePoint);
  	
  	      if (!entrancePoint) {
  	        throw new Error("Please pick an entrance point before saving.");
  	      }
  	
  	      const centrePoint = getSaveCentrePoint(effectiveCreationType);
  	      const areaM2 = computeSavePolygonAreaM2(polygon);
  	      const areaHa = areaM2 / 10000;
  	      const typeName = selectedType ? selectedType.label: createState.locationType;
  	      const color = selectedType ? selectedType.color: getFreeGroundPlotColor();
  	      const parentId = safeString(createState.plotParentLocationId || "").trim();
  	
  	      const payload = {
  	        ID: generateLocationIdForSave(effectiveCreationType),
  	        Name: safeString(createState.name).trim(),
  	        Type: typeName,
  	        Color: color,
  	
  	        CreationType: effectiveCreationType,
  	
  	        Polygon: polygon,
  	        EntrancePoint: buildSavePoint(entrancePoint),
  	        Centre: buildSavePoint(centrePoint),
  	
  	        AreaHa: roundSaveNumber(areaHa, 4),
  	
  	        ParentId: parentId || null,
  	        ownerId: resolveCompanyOwnerIdForSave(company) || null,
  	
  	        LocationData: buildLocationDataForSave(areaM2, centrePoint, effectiveCreationType)
  	      };
  	
  	      return {
  	        payload,
  	        company,
  	        parentId,
  	        effectiveCreationType,
  	        localPolygonForMap: safeCloneForSave(polygon),
  	        localEntranceForMap: safeCloneForSave(payload.EntrancePoint),
  	        localCentreForMap: safeCloneForSave(payload.Centre)
  	      };
  	    }
  	
  	    async function saveLocationRowToBackendless(payload) {
  	      if (!backendlessDataAvailable()) {
  	        throw new Error("Backendless Data is not available. Cannot save Location.");
  	      }
  	
  	      return Backendless.Data.of(SAVE_TABLE_LOCATIONS).save(payload);
  	    }
  	
  	    async function tryAddBackendlessRelation(tableName, parentRef, relationName, childRefs) {
  	      if (!backendlessDataAvailable()) {
  	        return {
  	          ok: false,
  	          reason: "Backendless missing"
  	        };
  	      }
  	
  	      const store = Backendless.Data.of(tableName);
  	
  	      if (!store || typeof store.addRelation !== "function") {
  	        return {
  	          ok: false,
  	          reason: "addRelation missing"
  	        };
  	      }
  	
  	      const children = Array.isArray(childRefs) ? childRefs: [childRefs];
  	
  	      const attempts = [
  	        async () => store.addRelation(parentRef, relationName, children),
  	        async () => store.addRelation(
  	          typeof parentRef === "string" ? {
  	            objectId: parentRef
  	          }: parentRef,
  	          relationName,
  	          children.map(child => {
  	            return typeof child === "string" ? {
  	              objectId: child
  	            }: child;
  	          })
  	        ),
  	        async () => store.addRelation(
  	          typeof parentRef === "string" ? parentRef: parentRef?.objectId,
  	          relationName,
  	          children.map(child => typeof child === "string" ? child: child?.objectId).filter(Boolean)
  	        )
  	      ];
  	
  	      let lastError = null;
  	
  	      for (let i = 0; i < attempts.length; i++) {
  	        try {
  	          const result = await attempts[i]();
  	
  	          return {
  	            ok: true,
  	            result,
  	            attempt: i + 1
  	          };
  	        } catch (error) {
  	          lastError = error;
  	        }
  	      }
  	
  	      FIF_SILENT_CONSOLE.warn("[TrackIT Save Channel] Relation add failed.", {
  	        tableName,
  	        parentRef,
  	        relationName,
  	        childRefs,
  	        error: lastError
  	      });
  	
  	      return {
  	        ok: false,
  	        error: lastError
  	      };
  	    }
  	
  	    function findLocationInCompanyById(company, locationId) {
  	      const target = safeString(locationId).trim();
  	
  	      if (!company || !target) return null;
  	
  	      const locations = flattenLocations(getCompanyLocations(company));
  	
  	      return locations.find(location => {
  	        return safeString(getLocationValue(location)).trim() === target;
  	      }) || null;
  	    }
  	
  	    function upsertLocationIntoArray(list, location) {
  	      if (!Array.isArray(list) || !location) return false;
  	
  	      const id = safeString(getLocationValue(location)).trim();
  	
  	      if (!id) {
  	        list.push(location);
  	        return true;
  	      }
  	
  	      const existingIndex = list.findIndex(item => {
  	        return safeString(getLocationValue(item)).trim() === id;
  	      });
  	
  	      if (existingIndex >= 0) {
  	        list[existingIndex] = location;
  	      } else {
  	        list.push(location);
  	      }
  	
  	      return true;
  	    }
  	
  	    function syncSavedLocationIntoAppData(savedLocation, company, parentId) {
  	      if (!savedLocation || !company) return false;
  	
  	      if (!Array.isArray(company.Locations)) {
  	        company.Locations = Array.isArray(company.locations) ? company.locations: [];
  	      }
  	
  	      upsertLocationIntoArray(company.Locations, savedLocation);
  	
  	      if (parentId) {
  	        const parent = findLocationInCompanyById(company, parentId);
  	
  	        if (parent) {
  	          if (!Array.isArray(parent.Fields)) {
  	            parent.Fields = Array.isArray(parent.fields) ? parent.fields: [];
  	          }
  	
  	          upsertLocationIntoArray(parent.Fields, savedLocation);
  	        } else {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Save Channel] Parent not found in local company AppData.", {
  	            parentId,
  	            savedLocation
  	          });
  	        }
  	      }
  	
  	      const appData = getAppBag();
  	
  	      if (appData && appData.User && Array.isArray(appData.User.Companies)) {
  	        const companyId = safeString(getCompanyId(company, 0)).trim();
  	
  	        const appCompany = appData.User.Companies.find((item, index) => {
  	          return safeString(getCompanyId(item, index)).trim() === companyId;
  	        });
  	
  	        if (appCompany && appCompany !== company) {
  	          if (!Array.isArray(appCompany.Locations)) {
  	            appCompany.Locations = Array.isArray(appCompany.locations) ? appCompany.locations: [];
  	          }
  	
  	          upsertLocationIntoArray(appCompany.Locations, savedLocation);
  	
  	          if (parentId) {
  	            const appParent = findLocationInCompanyById(appCompany, parentId);
  	
  	            if (appParent) {
  	              if (!Array.isArray(appParent.Fields)) {
  	                appParent.Fields = Array.isArray(appParent.fields) ? appParent.fields: [];
  	              }
  	
  	              upsertLocationIntoArray(appParent.Fields, savedLocation);
  	            }
  	          }
  	        }
  	      }
  	
  	      return true;
  	    }
  	
  	    async function linkSavedLocationRelations(savedLocation, company, parentId) {
  	      const savedId = safeString(savedLocation?.objectId).trim();
  	      const companyId = safeString(getCompanyId(company || {}, 0)).trim();
  	
  	      if (!savedId) {
  	        return {
  	          companyLinked: false,
  	          parentLinked: false,
  	          reason: "Saved location has no objectId"
  	        };
  	      }
  	
  	      let companyLinked = false;
  	      let parentLinked = false;
  	
  	      if (companyId) {
  	        const companyResult = await tryAddBackendlessRelation(
  	          SAVE_TABLE_COMPANIES,
  	          companyId,
  	          SAVE_COMPANY_LOCATIONS_RELATION,
  	          [savedId]
  	        );
  	
  	        companyLinked = !!companyResult.ok;
  	      }
  	
  	      if (parentId) {
  	        const parentResult = await tryAddBackendlessRelation(
  	          SAVE_TABLE_LOCATIONS,
  	          parentId,
  	          SAVE_PARENT_CHILDREN_RELATION,
  	          [savedId]
  	        );
  	
  	        parentLinked = !!parentResult.ok;
  	      }
  	
  	      return {
  	        companyLinked,
  	        parentLinked
  	      };
  	    }
  	
  	    function restoreLocalGeometryAfterSave(savedLocation, localPolygon, localEntrance, localCentre) {
  	      if (!savedLocation) return savedLocation;
  	
  	      // For immediate post-save use, local geometry must win.
  	      // Backendless may return GIS fields in a different shape, or omit some nested JSON.
  	      if (localPolygon && Array.isArray(localPolygon.coordinates)) {
  	        savedLocation.Polygon = localPolygon;
  	      }
  	
  	      if (localEntrance && Array.isArray(localEntrance.coordinates)) {
  	        savedLocation.EntrancePoint = localEntrance;
  	      }
  	
  	      if (localCentre && Array.isArray(localCentre.coordinates)) {
  	        savedLocation.Centre = localCentre;
  	      }
  	
  	      const plainCentre = readPlainPointFromCandidate(
  	        localCentre ||
  	        savedLocation.Centre ||
  	        savedLocation.centre ||
  	        savedLocation.Center ||
  	        savedLocation.center ||
  	        null
  	      );
  	
  	      if (!plainCentre) {
  	        return savedLocation;
  	      }
  	
  	      const cleanCentre = {
  	        lat: Number(plainCentre.lat),
  	        lng: Number(plainCentre.lng)
  	      };
  	
  	      if (!Number.isFinite(cleanCentre.lat) || !Number.isFinite(cleanCentre.lng)) {
  	        return savedLocation;
  	      }
  	
  	      const creationType = safeString(
  	        savedLocation.CreationType ||
  	        savedLocation.creationType ||
  	        savedLocation.creation_type ||
  	        savedLocation.CreationMode ||
  	        savedLocation.creationMode ||
  	        savedLocation.LocationData?.CreationType ||
  	        savedLocation.locationData?.CreationType ||
  	        savedLocation.LocationData?.creationType ||
  	        savedLocation.locationData?.creationType ||
  	        ""
  	      ).trim().toLowerCase();
  	
  	      // Non-enumerable runtime centre.
  	      // This gives child Ring/Segment creation the correct parent centre immediately,
  	      // without polluting the saved DB row with extra fields.
  	      try {
  	        Object.defineProperty(savedLocation, "__trackitParentCentre", {
  	          value: cleanCentre,
  	          writable: true,
  	          configurable: true,
  	          enumerable: false
  	        });
  	      } catch (_) {
  	        savedLocation.__trackitParentCentre = cleanCentre;
  	      }
  	
  	      if (!savedLocation.LocationData || typeof savedLocation.LocationData !== "object") {
  	        savedLocation.LocationData = {};
  	      }
  	
  	      if (!savedLocation.LocationData.Area || typeof savedLocation.LocationData.Area !== "object") {
  	        savedLocation.LocationData.Area = {};
  	      }
  	
  	      savedLocation.LocationData.Area.Center = cleanCentre;
  	
  	      if (!savedLocation.LocationData.Shape || typeof savedLocation.LocationData.Shape !== "object") {
  	        savedLocation.LocationData.Shape = {};
  	      }
  	
  	      if (creationType === "pivot") {
  	        savedLocation.LocationData.Shape.PivotCenter = cleanCentre;
  	      }
  	
  	      if (creationType === "wedge") {
  	        savedLocation.LocationData.Shape.WedgeCenter = cleanCentre;
  	      }
  	
  	      if (creationType === "ring" || creationType === "segment") {
  	        savedLocation.LocationData.Shape.ChildFixedCenter = cleanCentre;
  	      }
  	
  	      return savedLocation;
  	    }
  	
  	    async function handleSaveCreatedLocation(root) {
  	      const saveContext = buildLocationSavePayload();
  	
  	      const savedRaw = await saveLocationRowToBackendless(saveContext.payload);
  	
  	      const savedLocation = restoreLocalGeometryAfterSave(
  	        Object.assign({}, saveContext.payload, savedRaw || {}),
  	        saveContext.localPolygonForMap,
  	        saveContext.localEntranceForMap,
  	        saveContext.localCentreForMap
  	      );
  	
  	      await linkSavedLocationRelations(
  	        savedLocation,
  	        saveContext.company,
  	        saveContext.parentId
  	      );
  	
  	      syncSavedLocationIntoAppData(
  	        savedLocation,
  	        saveContext.company,
  	        saveContext.parentId
  	      );
  	
  	      // The database commit is complete. Explicitly create/repair the remote
  	      // geofence and expose failures; never report unsynced locations as synced.
  	      await syncSavedLocationWithFlespi("create", savedLocation);
  	
  	      try {
  	        if (window.__CarvedEdgeShapeUI) {
  	          window.__CarvedEdgeShapeUI.pendingSaveLocation = savedLocation;
  	          window.__CarvedEdgeShapeUI.lastSavedLocation = savedLocation;
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        const appBag = getAppBag() || APP_DATA;
  	        DATA_CHANNEL = createDataChannel(appBag);
  	        COMPANY_OPTIONS = DATA_CHANNEL.companyOptions;
  	
  	        if (window.__CarvedEdgeShapeUI) {
  	          window.__CarvedEdgeShapeUI.dataChannel = DATA_CHANNEL;
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Save Channel] Could not refresh data channel after save.", error);
  	      }
  	
  	      // Save completed. Fully close creation mode and return the top control
  	      // to normal Location/Search mode.
  	      createState.isSaved = true;
  	
  	      clearFreeGroundPlotDraft();
  	
  	      createState.isCreating = false;
  	      createState.isPlotting = false;
  	      createState.openDropdown = "";
  	      createState.modalMode = "";
  	      createState.helpTopic = "";
  	
  	      createState.company = "";
  	      createState.locationType = "";
  	      createState.creationMode = "";
  	      createState.name = "";
  	
  	      createState.plotMode = "free-ground";
  	      createState.plotParentLocation = null;
  	      createState.plotParentLocationId = "";
  	
  	      createState.childShapeMode = "";
  	      createState.childFixedCenter = null;
  	      createState.childRadiusPoint = null;
  	      createState.childEdgePoint = null;
  	
  	      createState.isPickingEntrance = false;
  	      createState.saveAfterFunctionality = false;
  	      createState.isSavingLocation = false;
  	
  	      resetFunctionalityState();
  	
  	      // The save and Company relation are complete. Creation isolation can
  	      // now end and the normal cross-company visibility settings are restored.
  	      refreshLocationCreationCompanyScope("location-create-save-complete");
  	
  	      try {
  	        if (window.__CarvedEdgeShapeUI) {
  	          window.__CarvedEdgeShapeUI.pendingFunctionalitySource = "";
  	          window.__CarvedEdgeShapeUI.pendingSaveLocation = savedLocation;
  	          window.__CarvedEdgeShapeUI.lastSavedLocation = savedLocation;
  	        }
  	      } catch (_) {}
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Save Channel] Location saved successfully. Creation mode closed.", {
  	        savedLocation,
  	        saveContext
  	      });
  	
  	      renderTop(root);
  	      renderModal(root);
  	      ensureTrackITSearchDropdownMounted(root);
  	
  	      return savedLocation;
  	    }
  	
  	    function readPlainPointFromCandidate(value) {
  	      if (!value) return null;
  	
  	      if (Array.isArray(value) && value.length >= 2) {
  	        const a = Number(value[0]);
  	        const b = Number(value[1]);
  	
  	        if (Number.isFinite(a) && Number.isFinite(b)) {
  	          if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
  	            return {
  	              lat: a,
  	              lng: b
  	            };
  	          }
  	
  	          if (Math.abs(a) <= 180 && Math.abs(b) <= 90) {
  	            return {
  	              lat: b,
  	              lng: a
  	            };
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      if (typeof value !== "object") return null;
  	
  	      // GeoJSON / Backendless GIS Point:
  	      // { type: "Point", coordinates: [lng, lat] }
  	      if (Array.isArray(value.coordinates) && value.coordinates.length >= 2) {
  	        const lng = Number(value.coordinates[0]);
  	        const lat = Number(value.coordinates[1]);
  	
  	        if (Number.isFinite(lat) && Number.isFinite(lng)) {
  	          return {
  	            lat,
  	            lng
  	          };
  	        }
  	      }
  	
  	      if (Array.isArray(value.Coordinates) && value.Coordinates.length >= 2) {
  	        const lng = Number(value.Coordinates[0]);
  	        const lat = Number(value.Coordinates[1]);
  	
  	        if (Number.isFinite(lat) && Number.isFinite(lng)) {
  	          return {
  	            lat,
  	            lng
  	          };
  	        }
  	      }
  	
  	      const lat = Number(
  	        value.lat ??
  	        value.Lat ??
  	        value.latitude ??
  	        value.Latitude ??
  	        value.y ??
  	        value.Y
  	      );
  	
  	      const lng = Number(
  	        value.lng ??
  	        value.Lng ??
  	        value.lon ??
  	        value.Lon ??
  	        value.longitude ??
  	        value.Longitude ??
  	        value.x ??
  	        value.X
  	      );
  	
  	      if (Number.isFinite(lat) && Number.isFinite(lng)) {
  	        return {
  	          lat,
  	          lng
  	        };
  	      }
  	
  	      return null;
  	    }
  	
  	    function getBoundaryCentroidPoint(boundary) {
  	      const ring = cleanFreeGroundRing(boundary);
  	
  	      if (!ring.length) return null;
  	
  	      let twiceArea = 0;
  	      let cx = 0;
  	      let cy = 0;
  	
  	      for (let i = 0; i < ring.length; i++) {
  	        const a = ring[i];
  	        const b = ring[(i + 1) % ring.length];
  	
  	        const ax = Number(a.lng);
  	        const ay = Number(a.lat);
  	        const bx = Number(b.lng);
  	        const by = Number(b.lat);
  	
  	        const cross = (ax * by) - (bx * ay);
  	
  	        twiceArea += cross;
  	        cx += (ax + bx) * cross;
  	        cy += (ay + by) * cross;
  	      }
  	
  	      if (Math.abs(twiceArea) > 1e-12) {
  	        return {
  	          lat: cy / (3 * twiceArea),
  	          lng: cx / (3 * twiceArea)
  	        };
  	      }
  	
  	      const total = ring.reduce((sum, point) => {
  	        sum.lat += Number(point.lat);
  	        sum.lng += Number(point.lng);
  	        return sum;
  	      }, {
  	        lat: 0,
  	        lng: 0
  	      });
  	
  	      return {
  	        lat: total.lat / ring.length,
  	        lng: total.lng / ring.length
  	      };
  	    }
  	
  	    function getChildFixedCenterFromParent(parentBlocker) {
  	      const location = parentBlocker?.location || null;
  	
  	      if (!location || typeof location !== "object") {
  	        return null;
  	      }
  	
  	      function cleanCandidate(value) {
  	        const point = readPlainPointFromCandidate(value);
  	
  	        if (!point) return null;
  	
  	        return {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        };
  	      }
  	
  	      function getGeneratedType() {
  	        return safeString(
  	          location.CreationType ||
  	          location.creationType ||
  	          location.creation_type ||
  	          location.CreationMode ||
  	          location.creationMode ||
  	          location.LocationData?.CreationType ||
  	          location.locationData?.CreationType ||
  	          location.LocationData?.creationType ||
  	          location.locationData?.creationType ||
  	          location.LocationData?.CreationMode ||
  	          location.locationData?.CreationMode ||
  	          location.LocationData?.creationMode ||
  	          location.locationData?.creationMode ||
  	          ""
  	        ).trim().toLowerCase();
  	      }
  	
  	      // 1. Runtime centre written immediately after save.
  	      const runtimeCentre = cleanCandidate(
  	        location.__trackitParentCentre ||
  	        parentBlocker.__trackitParentCentre ||
  	        null
  	      );
  	
  	      if (runtimeCentre) return runtimeCentre;
  	
  	      // 2. Existing generated-centre resolver.
  	      // This already prefers Shape.PivotCenter / Shape.ChildFixedCenter for generated shapes.
  	      if (typeof getSavedLocationCentrePoint === "function") {
  	        const savedCentre = getSavedLocationCentrePoint(location);
  	
  	        if (savedCentre) return savedCentre;
  	      }
  	
  	      // 3. Explicit immediate-save paths.
  	      // These are the important ones for freshly saved Pivot/Wedge/Ring/Segment parents.
  	      const directCandidates = [
  	        location?.LocationData?.Shape?.ChildFixedCenter,
  	        location?.LocationData?.Shape?.childFixedCenter,
  	        location?.locationData?.Shape?.ChildFixedCenter,
  	        location?.locationData?.Shape?.childFixedCenter,
  	        location?.LocationData?.shape?.ChildFixedCenter,
  	        location?.LocationData?.shape?.childFixedCenter,
  	        location?.locationData?.shape?.ChildFixedCenter,
  	        location?.locationData?.shape?.childFixedCenter,
  	
  	        location?.LocationData?.Shape?.PivotCenter,
  	        location?.LocationData?.Shape?.pivotCenter,
  	        location?.locationData?.Shape?.PivotCenter,
  	        location?.locationData?.Shape?.pivotCenter,
  	        location?.LocationData?.shape?.PivotCenter,
  	        location?.LocationData?.shape?.pivotCenter,
  	        location?.locationData?.shape?.PivotCenter,
  	        location?.locationData?.shape?.pivotCenter,
  	
  	        location?.LocationData?.Shape?.WedgeCenter,
  	        location?.LocationData?.Shape?.wedgeCenter,
  	        location?.locationData?.Shape?.WedgeCenter,
  	        location?.locationData?.Shape?.wedgeCenter,
  	        location?.LocationData?.shape?.WedgeCenter,
  	        location?.LocationData?.shape?.wedgeCenter,
  	        location?.locationData?.shape?.WedgeCenter,
  	        location?.locationData?.shape?.wedgeCenter,
  	
  	        location?.LocationData?.Area?.Center,
  	        location?.LocationData?.Area?.center,
  	        location?.locationData?.Area?.Center,
  	        location?.locationData?.Area?.center,
  	        location?.LocationData?.area?.Center,
  	        location?.LocationData?.area?.center,
  	        location?.locationData?.area?.Center,
  	        location?.locationData?.area?.center,
  	
  	        location?.PivotCenter,
  	        location?.pivotCenter,
  	        location?.WedgeCenter,
  	        location?.wedgeCenter,
  	        location?.ChildFixedCenter,
  	        location?.childFixedCenter,
  	
  	        location?.Centre,
  	        location?.centre,
  	        location?.Center,
  	        location?.center,
  	
  	        parentBlocker?.centre,
  	        parentBlocker?.center,
  	        parentBlocker?.Centre,
  	        parentBlocker?.Center
  	      ];
  	
  	      for (let i = 0; i < directCandidates.length; i++) {
  	        const point = cleanCandidate(directCandidates[i]);
  	
  	        if (point) return point;
  	      }
  	
  	      const pathCandidates = [
  	        "LocationData.Shape.ChildFixedCenter",
  	        "LocationData.Shape.childFixedCenter",
  	        "locationData.Shape.ChildFixedCenter",
  	        "locationData.Shape.childFixedCenter",
  	        "LocationData.shape.ChildFixedCenter",
  	        "LocationData.shape.childFixedCenter",
  	        "locationData.shape.ChildFixedCenter",
  	        "locationData.shape.childFixedCenter",
  	
  	        "LocationData.Shape.PivotCenter",
  	        "LocationData.Shape.pivotCenter",
  	        "locationData.Shape.PivotCenter",
  	        "locationData.Shape.pivotCenter",
  	        "LocationData.shape.PivotCenter",
  	        "LocationData.shape.pivotCenter",
  	        "locationData.shape.PivotCenter",
  	        "locationData.shape.pivotCenter",
  	
  	        "LocationData.Shape.WedgeCenter",
  	        "LocationData.Shape.wedgeCenter",
  	        "locationData.Shape.WedgeCenter",
  	        "locationData.Shape.wedgeCenter",
  	        "LocationData.shape.WedgeCenter",
  	        "LocationData.shape.wedgeCenter",
  	        "locationData.shape.WedgeCenter",
  	        "locationData.shape.wedgeCenter",
  	
  	        "LocationData.Area.Center",
  	        "LocationData.Area.center",
  	        "locationData.Area.Center",
  	        "locationData.Area.center",
  	        "LocationData.area.Center",
  	        "LocationData.area.center",
  	        "locationData.area.Center",
  	        "locationData.area.center",
  	
  	        "Pivot.Center",
  	        "pivot.center",
  	        "Wedge.Center",
  	        "wedge.center",
  	        "Geometry.Center",
  	        "geometry.center",
  	        "Polygon.Center",
  	        "polygon.center"
  	      ];
  	
  	      for (let i = 0; i < pathCandidates.length; i++) {
  	        const point = cleanCandidate(
  	          getObjectProperty(location, pathCandidates[i])
  	        );
  	
  	        if (point) return point;
  	      }
  	
  	      const generatedType = getGeneratedType();
  	
  	      const isGeneratedParent =
  	      generatedType === "pivot" ||
  	      generatedType === "wedge" ||
  	      generatedType === "ring" ||
  	      generatedType === "segment" ||
  	      isPivotOrWedgeLocation(location);
  	
  	      // Critical:
  	      // For generated parents, never use centre mass as fallback.
  	      // A Pivot / Wedge / Ring / Segment must use its mathematical centre.
  	      if (isGeneratedParent) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Child Shape Wizard] Generated parent centre missing. Refusing centroid fallback.", {
  	          generatedType,
  	          parentLocationId: parentBlocker?.locationId,
  	          parentLocationName: parentBlocker?.locationName,
  	          location,
  	          parentBlocker
  	        });
  	
  	        return null;
  	      }
  	
  	      return getBoundaryCentroidPoint(parentBlocker?.boundary || []);
  	    }
  	
  	    function isPivotOrWedgeLocation(location) {
  	      if (!location || typeof location !== "object") return false;
  	
  	      const combined = [
  	        getLocationTypeName(location),
  	
  	        location.CreationType,
  	        location.creationType,
  	        location.creation_type,
  	        location.CreationMode,
  	        location.creationMode,
  	
  	        location.LocationType,
  	        location.locationType,
  	        location.Type,
  	        location.type,
  	        location.FieldType,
  	        location.fieldType,
  	        location.Shape,
  	        location.shape,
  	        location.FieldShape,
  	        location.fieldShape,
  	        location.GeometryType,
  	        location.geometryType,
  	
  	        location.LocationData?.CreationType,
  	        location.LocationData?.creationType,
  	        location.LocationData?.CreationMode,
  	        location.LocationData?.creationMode,
  	        location.LocationData?.GeometryType,
  	        location.LocationData?.geometryType,
  	        location.LocationData?.Shape,
  	        location.LocationData?.shape,
  	
  	        location.geometryMeta?.type,
  	        location.GeometryMeta?.type,
  	        location.geometryMeta?.Type,
  	        location.GeometryMeta?.Type,
  	
  	        location.LocationCategory,
  	        location.locationCategory,
  	        location.Category,
  	        location.category
  	      ]
  	      .map(value => safeString(value).trim().toLowerCase())
  	      .filter(Boolean)
  	      .join(" ");
  	
  	      return (
  	        combined.includes("pivot") ||
  	        combined.includes("wedge")
  	      );
  	    }
  	
  	    function confirmChildShapeModeForParent(parentLocation, context) {
  	      if (typeof document === "undefined") {
  	        return Promise.resolve("");
  	      }
  	
  	      const name = rendererGetLocationName(parentLocation);
  	      const parentType = isPivotOrWedgeLocation(parentLocation)
  	      ? "Pivot / Wedge": "Location";
  	
  	      return new Promise(resolve => {
  	        let resolved = false;
  	
  	        function closePrompt(result) {
  	          if (resolved) return;
  	
  	          resolved = true;
  	
  	          try {
  	            document.removeEventListener("keydown", handleKeydown, true);
  	          } catch (_) {}
  	
  	          try {
  	            if (overlay && overlay.parentNode) {
  	              overlay.parentNode.removeChild(overlay);
  	            }
  	          } catch (_) {}
  	
  	          resolve(result || "");
  	        }
  	
  	        function handleKeydown(event) {
  	          if (event.key === "Escape") {
  	            event.preventDefault();
  	            closePrompt("");
  	          }
  	        }
  	
  	        const overlay = document.createElement("div");
  	
  	        overlay.className = "trackit-child-shape-mode-confirm";
  	        overlay.innerHTML = `
  	        <div class="trackit-child-shape-mode-backdrop"></div>
  	
  	        <div class="trackit-child-shape-mode-card" role="dialog" aria-modal="true">
  	        <div class="trackit-child-shape-mode-glow"></div>
  	
  	        <div class="trackit-child-shape-mode-icon">↳</div>
  	
  	        <div class="trackit-child-shape-mode-kicker">Child Shape Mode</div>
  	
  	        <div class="trackit-child-shape-mode-title">
  	        Create child inside ${escapeHtml(name)}
  	        </div>
  	
  	        <div class="trackit-child-shape-mode-body">
  	        This parent is a ${escapeHtml(parentType)}. Choose how the child should be drawn.
  	        The selected main Creation Mode will be ignored for this child.
  	        </div>
  	
  	        <div class="trackit-child-shape-mode-parent">
  	        <span>Parent Boundary</span>
  	        <strong>${escapeHtml(name)}</strong>
  	        </div>
  	
  	        <div class="trackit-child-shape-mode-options">
  	        <button type="button" data-child-shape-mode="polygon">
  	        <strong>Polygon</strong>
  	        <span>Normal child polygon points.</span>
  	        </button>
  	
  	        <button type="button" data-child-shape-mode="ring">
  	        <strong>Ring</strong>
  	        <span>Centre locked to the parent centre. Click sets radius.</span>
  	        </button>
  	
  	        <button type="button" data-child-shape-mode="segment">
  	        <strong>Segment</strong>
  	        <span>Centre locked to the parent centre. Click start arm, then end arm.</span>
  	        </button>
  	        </div>
  	
  	        <div class="trackit-child-shape-mode-actions">
  	        <button class="trackit-child-shape-mode-cancel" type="button">Cancel</button>
  	        </div>
  	        </div>
  	        `;
  	
  	        const style = document.createElement("style");
  	
  	        style.textContent = `
  	        .trackit-child-shape-mode-confirm {
  	        position: fixed;
  	        inset: 0;
  	        z-index: 2147483647;
  	        font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  	        }
  	
  	        .trackit-child-shape-mode-backdrop {
  	        position: absolute;
  	        inset: 0;
  	        background: rgba(0, 0, 0, 0.58);
  	        backdrop-filter: blur(4px);
  	        }
  	
  	        .trackit-child-shape-mode-card {
  	        position: absolute;
  	        left: 50%;
  	        top: 50%;
  	        transform: translate(-50%, -50%);
  	        width: min(560px, calc(100vw - 32px));
  	        border-radius: 28px;
  	        padding: 26px;
  	        color: #f7efe8;
  	        background: linear-gradient(145deg, rgba(48, 26, 12, 0.98), rgba(11, 10, 9, 0.98));
  	        border: 1px solid rgba(255, 151, 57, 0.38);
  	        box-shadow: 0 28px 80px rgba(0,0,0,0.62);
  	        overflow: hidden;
  	        }
  	
  	        .trackit-child-shape-mode-glow {
  	        position: absolute;
  	        inset: auto auto -90px -80px;
  	        width: 240px;
  	        height: 240px;
  	        border-radius: 999px;
  	        background: rgba(255, 137, 44, 0.18);
  	        filter: blur(26px);
  	        pointer-events: none;
  	        }
  	
  	        .trackit-child-shape-mode-icon {
  	        width: 58px;
  	        height: 58px;
  	        border-radius: 20px;
  	        display: grid;
  	        place-items: center;
  	        color: #130801;
  	        background: linear-gradient(145deg, #ffc16c, #ff8a2c);
  	        font-size: 31px;
  	        font-weight: 900;
  	        margin-bottom: 16px;
  	        }
  	
  	        .trackit-child-shape-mode-kicker {
  	        text-transform: uppercase;
  	        letter-spacing: 0.12em;
  	        color: #f2bb82;
  	        font-weight: 900;
  	        font-size: 13px;
  	        margin-bottom: 8px;
  	        }
  	
  	        .trackit-child-shape-mode-title {
  	        font-size: 26px;
  	        line-height: 1.12;
  	        font-weight: 950;
  	        margin-bottom: 12px;
  	        }
  	
  	        .trackit-child-shape-mode-body {
  	        color: rgba(255,255,255,0.74);
  	        line-height: 1.55;
  	        font-size: 15px;
  	        margin-bottom: 18px;
  	        }
  	
  	        .trackit-child-shape-mode-parent {
  	        border: 1px solid rgba(255, 145, 45, 0.35);
  	        background: rgba(255, 129, 35, 0.08);
  	        border-radius: 18px;
  	        padding: 14px 16px;
  	        margin-bottom: 14px;
  	        }
  	
  	        .trackit-child-shape-mode-parent span {
  	        display: block;
  	        text-transform: uppercase;
  	        color: #f0b272;
  	        font-size: 12px;
  	        font-weight: 900;
  	        letter-spacing: 0.08em;
  	        margin-bottom: 5px;
  	        }
  	
  	        .trackit-child-shape-mode-parent strong {
  	        font-size: 16px;
  	        }
  	
  	        .trackit-child-shape-mode-options {
  	        display: grid;
  	        gap: 10px;
  	        margin: 16px 0 18px;
  	        }
  	
  	        .trackit-child-shape-mode-options button {
  	        width: 100%;
  	        text-align: left;
  	        border: 1px solid rgba(255,255,255,0.12);
  	        background: rgba(255,255,255,0.06);
  	        color: #fff;
  	        border-radius: 16px;
  	        padding: 13px 15px;
  	        cursor: pointer;
  	        transition: transform 0.12s ease, border-color 0.12s ease, background 0.12s ease;
  	        }
  	
  	        .trackit-child-shape-mode-options button:hover {
  	        transform: translateY(-1px);
  	        border-color: rgba(255, 151, 57, 0.55);
  	        background: rgba(255, 137, 44, 0.12);
  	        }
  	
  	        .trackit-child-shape-mode-options strong {
  	        display: block;
  	        font-size: 16px;
  	        margin-bottom: 4px;
  	        }
  	
  	        .trackit-child-shape-mode-options span {
  	        display: block;
  	        color: rgba(255,255,255,0.68);
  	        font-size: 13px;
  	        }
  	
  	        .trackit-child-shape-mode-actions {
  	        display: flex;
  	        justify-content: flex-end;
  	        }
  	
  	        .trackit-child-shape-mode-cancel {
  	        min-width: 140px;
  	        border: 1px solid rgba(255,255,255,0.14);
  	        border-radius: 16px;
  	        padding: 13px 18px;
  	        color: #f7efe8;
  	        background: rgba(255,255,255,0.08);
  	        font-weight: 850;
  	        cursor: pointer;
  	        }
  	        `;
  	
  	        overlay.appendChild(style);
  	        document.body.appendChild(overlay);
  	
  	        overlay.querySelectorAll("[data-child-shape-mode]").forEach(button => {
  	          button.addEventListener("click", () => {
  	            closePrompt(button.getAttribute("data-child-shape-mode") || "");
  	          });
  	        });
  	
  	        const cancelButton = overlay.querySelector(".trackit-child-shape-mode-cancel");
  	        const backdrop = overlay.querySelector(".trackit-child-shape-mode-backdrop");
  	
  	        if (cancelButton) {
  	          cancelButton.addEventListener("click", () => closePrompt(""));
  	        }
  	
  	        if (backdrop) {
  	          backdrop.addEventListener("click", () => closePrompt(""));
  	        }
  	
  	        document.addEventListener("keydown", handleKeydown, true);
  	      });
  	    }
  	
  	    function beginChildLocationFromParentWithMode(map,
  	      parentBlocker,
  	      clickedPoint,
  	      childShapeMode) {
  	      const mode = safeString(childShapeMode || "polygon").trim().toLowerCase();
  	
  	      if (!parentBlocker || !parentBlocker.location || !clickedPoint) {
  	        return false;
  	      }
  	
  	      clearFreeGroundPlotDraft();
  	
  	      createState.plotMode = "child-location";
  	      createState.plotParentLocation = parentBlocker.location;
  	      createState.plotParentLocationId = parentBlocker.locationId || rendererGetLocationId(parentBlocker.location);
  	
  	      createState.childShapeMode = mode || "polygon";
  	      createState.childFixedCenter = null;
  	      createState.childRadiusPoint = null;
  	      createState.childEdgePoint = null;
  	
  	      if (createState.childShapeMode === "polygon") {
  	        addFreeGroundPlotPoint(map, clickedPoint, "child-polygon-first-point");
  	
  	        FIF_SILENT_CONSOLE.log("[TrackIT Child Shape Wizard] Started Child Polygon:", {
  	          parentLocationId: createState.plotParentLocationId,
  	          parentLocation: createState.plotParentLocation,
  	          firstPoint: clickedPoint
  	        });
  	
  	        return true;
  	      }
  	
  	      const fixedCenter = getChildFixedCenterFromParent(parentBlocker);
  	
  	      if (!fixedCenter) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Child Shape Wizard] Could not resolve fixed parent centre. Falling back to Child Polygon.", {
  	          parentBlocker,
  	          clickedPoint,
  	          requestedMode: createState.childShapeMode
  	        });
  	
  	        createState.childShapeMode = "polygon";
  	        addFreeGroundPlotPoint(map, clickedPoint, "child-polygon-fallback-first-point");
  	
  	        return true;
  	      }
  	
  	      createState.childFixedCenter = fixedCenter;
  	
  	      if (createState.childShapeMode === "ring") {
  	        const ringRadiusPoint = clampChildGeneratedRadiusPointToParentRadius(
  	          fixedCenter,
  	          clickedPoint,
  	          "child-ring-radius"
  	        );
  	
  	        createState.childFixedCenter = fixedCenter;
  	        createState.childRadiusPoint = ringRadiusPoint;
  	        createState.plotPivotCenter = fixedCenter;
  	
  	        return applyPivotCircleFromCenterAndRadiusPoint(
  	          map || createState.plotDraftMap,
  	          fixedCenter,
  	          ringRadiusPoint,
  	          "child-ring-radius",
  	          {
  	            live: false
  	          }
  	        );
  	      }
  	
  	      if (createState.childShapeMode === "segment") {
  	        const radiusPoint = clampChildGeneratedRadiusPointToParentRadius(
  	          fixedCenter,
  	          clickedPoint,
  	          "child-segment-radius"
  	        );
  	
  	        if (!radiusPoint) return false;
  	
  	        createState.childRadiusPoint = radiusPoint;
  	        createState.plotWedgeCenter = fixedCenter;
  	        createState.plotWedgeRadiusPoint = radiusPoint;
  	        createState.plotWedgeEdgePoint = null;
  	        createState.plotWedgeRadiusMeters = pivotDistanceMeters(fixedCenter, radiusPoint);
  	        createState.isSaved = false;
  	
  	        redrawFreeGroundPlot(map || createState.plotDraftMap);
  	
  	        FIF_SILENT_CONSOLE.log("[TrackIT Child Shape Wizard] Started Child Segment:", {
  	          parentLocationId: createState.plotParentLocationId,
  	          fixedCenter,
  	          radiusPoint
  	        });
  	
  	        return true;
  	      }
  	
  	      createState.childShapeMode = "polygon";
  	      addFreeGroundPlotPoint(map, clickedPoint, "child-polygon-unknown-mode-first-point");
  	
  	      return true;
  	    }
  	
  	    function handleChildShapeModePoint(map, point, source) {
  	      const cleanPoint = makeCleanPlotPoint(point);
  	
  	      if (!cleanPoint) return false;
  	
  	      const mode = safeString(createState.childShapeMode || "polygon").trim().toLowerCase();
  	
  	      if (!mode || mode === "polygon") {
  	        addFreeGroundPlotPoint(map, cleanPoint, source || "child-polygon-point");
  	        return true;
  	      }
  	
  	      let fixedCenter = makeCleanPlotPoint(createState.childFixedCenter);
  	
  	      if (!fixedCenter) {
  	        fixedCenter = getChildFixedCenterFromParent(getChildLocationParentBlocker());
  	        createState.childFixedCenter = fixedCenter;
  	      }
  	
  	      if (!fixedCenter) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Child Shape Wizard] Child generated mode has no fixed parent centre. Falling back to polygon point.", {
  	          mode,
  	          point: cleanPoint,
  	          parentLocationId: createState.plotParentLocationId
  	        });
  	
  	        createState.childShapeMode = "polygon";
  	        addFreeGroundPlotPoint(map, cleanPoint, "child-generated-fallback-polygon-point");
  	
  	        return true;
  	      }
  	
  	      if (mode === "ring") {
  	        const radiusPoint = clampChildGeneratedRadiusPointToParentRadius(
  	          fixedCenter,
  	          cleanPoint,
  	          source || "child-ring-radius"
  	        );
  	
  	        createState.childFixedCenter = fixedCenter;
  	        createState.childRadiusPoint = radiusPoint;
  	        createState.childEdgePoint = null;
  	        createState.plotPivotCenter = fixedCenter;
  	
  	        return applyPivotCircleFromCenterAndRadiusPoint(
  	          map || createState.plotDraftMap,
  	          fixedCenter,
  	          radiusPoint,
  	          source || "child-ring-radius",
  	          {
  	            live: false
  	          }
  	        );
  	      }
  	
  	      if (mode === "segment") {
  	        const existingRadius = makeCleanPlotPoint(createState.childRadiusPoint);
  	
  	        if (!existingRadius) {
  	          const radiusPoint = clampChildGeneratedRadiusPointToParentRadius(
  	            fixedCenter,
  	            cleanPoint,
  	            source || "child-segment-radius"
  	          );
  	
  	          createState.childFixedCenter = fixedCenter;
  	          createState.childRadiusPoint = radiusPoint;
  	          createState.childEdgePoint = null;
  	
  	          createState.plotWedgeCenter = fixedCenter;
  	          createState.plotWedgeRadiusPoint = radiusPoint;
  	          createState.plotWedgeEdgePoint = null;
  	          createState.plotWedgeRadiusMeters = pivotDistanceMeters(fixedCenter, radiusPoint);
  	          createState.isSaved = false;
  	
  	          redrawFreeGroundPlot(map || createState.plotDraftMap);
  	
  	          FIF_SILENT_CONSOLE.log("[TrackIT Child Shape Wizard] Child Segment radius/start arm set:", {
  	            fixedCenter,
  	            radiusPoint
  	          });
  	
  	          return true;
  	        }
  	
  	        createState.childEdgePoint = cleanPoint;
  	
  	        return applyWedgeFromControlPoints(
  	          map || createState.plotDraftMap,
  	          fixedCenter,
  	          existingRadius,
  	          cleanPoint,
  	          source || "child-segment-edge",
  	          {
  	            live: false
  	          }
  	        );
  	      }
  	
  	      addFreeGroundPlotPoint(map, cleanPoint, source || "child-location-point");
  	      return true;
  	    }
  	
  	    function beginChildLocationFromParent(map, parentBlocker, clickedPoint) {
  	      if (!parentBlocker || !parentBlocker.location || !clickedPoint) {
  	        return false;
  	      }
  	
  	      clearFreeGroundPlotDraft();
  	
  	      createState.plotMode = "child-location";
  	      createState.plotParentLocation = parentBlocker.location;
  	      createState.plotParentLocationId = parentBlocker.locationId || rendererGetLocationId(parentBlocker.location);
  	
  	      createState.childShapeMode = "polygon";
  	      createState.childFixedCenter = null;
  	      createState.childRadiusPoint = null;
  	      createState.childEdgePoint = null;
  	
  	      addFreeGroundPlotPoint(map, clickedPoint, "child-location-first-point");
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Switched to Child Location Mode:", {
  	        parentLocationId: createState.plotParentLocationId,
  	        parentLocation: createState.plotParentLocation,
  	        firstPoint: clickedPoint
  	      });
  	
  	      return true;
  	    }
  	
  	    function getChildLocationParentBlocker() {
  	      const parentLocation = createState.plotParentLocation || null;
  	      const parentId = safeString(
  	        createState.plotParentLocationId ||
  	        rendererGetLocationId(parentLocation)
  	      );
  	
  	      if (parentLocation) {
  	        const direct = makeLocationBlocker(parentLocation);
  	
  	        if (direct) return direct;
  	      }
  	
  	      if (!parentId) return null;
  	
  	      const blockers = getFreeGroundBlockers();
  	
  	      return blockers.find(blocker => {
  	        return safeString(blocker.locationId) === parentId;
  	      }) || null;
  	    }
  	
  	    function getSavedLocationCentrePoint(location) {
  	      if (!location || typeof location !== "object") return null;
  	
  	      function pointFromGeoPoint(value) {
  	        if (!value) return null;
  	
  	        if (Array.isArray(value.coordinates) && value.coordinates.length >= 2) {
  	          const lng = Number(value.coordinates[0]);
  	          const lat = Number(value.coordinates[1]);
  	
  	          if (Number.isFinite(lat) && Number.isFinite(lng)) {
  	            return {
  	              lat,
  	              lng
  	            };
  	          }
  	        }
  	
  	        return makeCleanPlotPoint(value);
  	      }
  	
  	      const type = safeString(
  	        location.CreationType ||
  	        location.creationType ||
  	        location.LocationData?.CreationType ||
  	        location.locationData?.CreationType ||
  	        location.LocationData?.creationType ||
  	        location.locationData?.creationType ||
  	        ""
  	      ).trim().toLowerCase();
  	
  	      const shape =
  	      location.LocationData?.Shape ||
  	      location.locationData?.Shape ||
  	      location.LocationData?.shape ||
  	      location.locationData?.shape ||
  	      null;
  	
  	      const shapeGeneratedCentre = makeCleanPlotPoint(
  	        shape?.ChildFixedCenter ||
  	        shape?.childFixedCenter ||
  	        shape?.PivotCenter ||
  	        shape?.pivotCenter ||
  	        shape?.WedgeCenter ||
  	        shape?.wedgeCenter ||
  	        null
  	      );
  	
  	      const topLevelCentre = pointFromGeoPoint(
  	        location.Centre ||
  	        location.centre ||
  	        location.Center ||
  	        location.center ||
  	        null
  	      );
  	
  	      const areaCenter = makeCleanPlotPoint(
  	        location.LocationData?.Area?.Center ||
  	        location.locationData?.Area?.Center ||
  	        location.LocationData?.area?.center ||
  	        location.locationData?.area?.center ||
  	        null
  	      );
  	
  	      const isGeneratedCentreType =
  	      type === "pivot" ||
  	      type === "wedge" ||
  	      type === "ring" ||
  	      type === "segment";
  	
  	      // For generated shapes, the mathematical centre must win.
  	      // Do not let polygon centroid / area centre override PivotCenter / ChildFixedCenter.
  	      if (isGeneratedCentreType) {
  	        return (
  	          shapeGeneratedCentre ||
  	          topLevelCentre ||
  	          areaCenter ||
  	          null
  	        );
  	      }
  	
  	      return (
  	        topLevelCentre ||
  	        areaCenter ||
  	        shapeGeneratedCentre ||
  	        null
  	      );
  	    }
  	
  	    function getLocationCreationTypeForSiblingCheck(location) {
  	      return safeString(
  	        location?.CreationType ||
  	        location?.creationType ||
  	        location?.LocationData?.CreationType ||
  	        location?.locationData?.CreationType ||
  	        location?.LocationData?.creationType ||
  	        location?.locationData?.creationType ||
  	        ""
  	      ).trim().toLowerCase();
  	    }
  	
  	    function pointsAreNearSameCentre(a, b, toleranceMeters) {
  	      const pointA = makeCleanPlotPoint(a);
  	      const pointB = makeCleanPlotPoint(b);
  	
  	      if (!pointA || !pointB) return false;
  	
  	      const distance = pivotDistanceMeters(pointA, pointB);
  	
  	      return Number.isFinite(distance) && distance <= Number(toleranceMeters || 2);
  	    }
  	
  	    function getParentGeneratedCentreForSiblingCheck(parentBlocker) {
  	      const stateCentre = makeCleanPlotPoint(createState.childFixedCenter);
  	
  	      if (stateCentre) return stateCentre;
  	
  	      const savedCentre = getSavedLocationCentrePoint(parentBlocker?.location);
  	
  	      if (savedCentre) return savedCentre;
  	
  	      const location = parentBlocker?.location || null;
  	
  	      const locationType = safeString(
  	        location?.CreationType ||
  	        location?.creationType ||
  	        location?.LocationData?.CreationType ||
  	        location?.locationData?.CreationType ||
  	        ""
  	      ).trim().toLowerCase();
  	
  	      if (
  	        locationType === "pivot" ||
  	        locationType === "wedge" ||
  	        locationType === "ring" ||
  	        locationType === "segment"
  	      ) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Child Mode] Generated parent has no saved centre available yet. Avoiding centroid fallback.", {
  	          locationType,
  	          parentLocationId: parentBlocker?.locationId,
  	          location,
  	          boundary: parentBlocker?.boundary
  	        });
  	
  	        return null;
  	      }
  	
  	      return computeCentroidForSave(parentBlocker?.boundary || []);
  	    }
  	
  	    function blockerLooksLikeSameCentreGeneratedSibling(blocker, parentBlocker, parentCentre) {
  	      if (
  	        !blocker ||
  	        !parentBlocker ||
  	        !parentCentre ||
  	        !Array.isArray(blocker.boundary) ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        blocker.boundary.length < 3 ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return false;
  	      }
  	
  	      const blockerId = safeString(blocker.locationId).trim();
  	      const parentId = safeString(parentBlocker.locationId).trim();
  	
  	      if (!blockerId || !parentId || blockerId === parentId) return false;
  	
  	      if (!blockerBoundaryIsFullyInsideOuter(blocker, parentBlocker.boundary)) {
  	        return false;
  	      }
  	
  	      const type = getLocationCreationTypeForSiblingCheck(blocker.location);
  	
  	      if (
  	        type !== "ring" &&
  	        type !== "segment" &&
  	        type !== "pivot" &&
  	        type !== "wedge"
  	      ) {
  	        return false;
  	      }
  	
  	      const blockerCentre = getSavedLocationCentrePoint(blocker.location);
  	
  	      return pointsAreNearSameCentre(blockerCentre, parentCentre, 3);
  	    }
  	
  	    function getChildLocationSiblingBlockers(parentBlocker) {
  	      if (
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return [];
  	      }
  	
  	      const parentId = safeString(parentBlocker.locationId).trim();
  	      const byId = Object.create(null);
  	
  	      function remember(blocker, reason) {
  	        const id = safeString(blocker?.locationId).trim();
  	
  	        if (!id) return;
  	        if (parentId && id === parentId) return;
  	
  	        if (!byId[id]) {
  	          byId[id] = Object.assign({}, blocker, {
  	            siblingDetectReason: reason || blocker.siblingDetectReason || "child-sibling"
  	          });
  	        }
  	      }
  	
  	      getDirectChildBlockersForParentBlocker(parentBlocker)
  	      .forEach(blocker => {
  	        remember(blocker, blocker.siblingDetectReason || "direct-child");
  	      });
  	
  	      // Extra safety for Ring/Segment/Pivot/Wedge children:
  	      // concentric generated siblings can look nested geometrically, especially
  	      // if older records do not have ParentId/Fields loaded. If they share the
  	      // same parent centre and sit inside the current parent, they must still be
  	      // treated as siblings for exclusion.
  	      const mode = safeString(createState.childShapeMode || createState.creationMode).trim().toLowerCase();
  	
  	      if (
  	        mode === "ring" ||
  	        mode === "segment" ||
  	        mode === "pivot" ||
  	        mode === "wedge"
  	      ) {
  	        const parentCentre = getParentGeneratedCentreForSiblingCheck(parentBlocker);
  	        const hierarchy = buildLocationHierarchyIndex();
  	        const allBlockers = Array.isArray(hierarchy.blockers) ? hierarchy.blockers: [];
  	
  	        allBlockers.forEach(blocker => {
  	          if (
  	            blockerLooksLikeSameCentreGeneratedSibling(
  	              blocker,
  	              parentBlocker,
  	              parentCentre
  	            )
  	          ) {
  	            remember(blocker, "same-centre-generated-sibling");
  	          }
  	        });
  	      }
  	
  	      const result = Object.keys(byId).map(id => byId[id]);
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Child Generated Wizard] Child sibling blockers resolved:",
  	        {
  	          parentLocationId: parentId,
  	          childShapeMode: createState.childShapeMode,
  	          creationMode: createState.creationMode,
  	          siblingCount: result.length,
  	          siblings: result.map(blocker => {
  	            return {
  	              id: blocker.locationId,
  	              name: blocker.locationName,
  	              reason: blocker.siblingDetectReason,
  	              type: getLocationCreationTypeForSiblingCheck(blocker.location)
  	            };
  	          })
  	        });
  	
  	      return sortLocationBlockersByAreaAndId(result);
  	    }
  	
  	    function pointInsideOrNearChildParent(point,
  	      parentBlocker) {
  	      const cleanPoint = makeCleanPlotPoint(point);
  	
  	      if (
  	        !cleanPoint ||
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return false;
  	      }
  	
  	      if (pointInPlotBoundary(cleanPoint, parentBlocker.boundary)) return true;
  	
  	      const nearest = nearestBoundaryHit(cleanPoint, parentBlocker.boundary);
  	
  	      if (!nearest) return false;
  	
  	      return Number(nearest.distanceSq || 0) <= 5e-9;
  	    }
  	
  	    function getChildParentAnchorForPoint(point, parentBlocker) {
  	      if (!point || !parentBlocker) return null;
  	
  	      const anchor = normalizeAnchorForBlocker(point, parentBlocker);
  	
  	      if (!anchor || !anchor.point) return null;
  	
  	      return anchor;
  	    }
  	
  	    function getChildClippedTarget(startPoint, rawTargetPoint, parentBlocker) {
  	      const cleanTarget = makeCleanPlotPoint(rawTargetPoint);
  	      const cleanStart = makeCleanPlotPoint(startPoint);
  	
  	      if (!cleanTarget || !parentBlocker) {
  	        return {
  	          point: cleanTarget,
  	          anchor: null,
  	          clipped: false,
  	          rawPoint: cleanTarget
  	        };
  	      }
  	
  	      if (pointInsideOrNearChildParent(cleanTarget, parentBlocker)) {
  	        return {
  	          point: cleanTarget,
  	          anchor: getChildParentAnchorForPoint(cleanTarget, parentBlocker),
  	          clipped: false,
  	          rawPoint: cleanTarget
  	        };
  	      }
  	
  	      let anchor = null;
  	
  	      if (cleanStart) {
  	        anchor = getFirstBoundaryAnchorOnSegmentForBlocker(
  	          cleanStart,
  	          cleanTarget,
  	          parentBlocker
  	        );
  	      }
  	
  	      if (!anchor) {
  	        anchor = normalizeAnchorForBlocker(cleanTarget, parentBlocker);
  	      }
  	
  	      if (!anchor || !anchor.point) {
  	        return {
  	          point: cleanTarget,
  	          anchor: null,
  	          clipped: false,
  	          rawPoint: cleanTarget
  	        };
  	      }
  	
  	      return {
  	        point: anchor.point,
  	        anchor,
  	        clipped: true,
  	        rawPoint: cleanTarget
  	      };
  	    }
  	
  	    const FREE_GROUND_ROUTE_EPS = 1e-7;
  	    const FREE_GROUND_BOUNDARY_SNAP_DISTANCE_SQ = 2.5e-10;
  	    const FREE_GROUND_MAX_EDGE_EVENTS = 80;
  	
  	    function makeCleanPlotPoint(point) {
  	      if (!point) return null;
  	
  	      const clean = {
  	        lat: Number(point.lat),
  	        lng: Number(point.lng)
  	      };
  	
  	      if (!Number.isFinite(clean.lat) || !Number.isFinite(clean.lng)) {
  	        return null;
  	      }
  	
  	      return clean;
  	    }
  	
  	    function setEntrancePointOnPayload(payload, entrancePoint) {
  	      const point = makeCleanPlotPoint(entrancePoint);
  	
  	      if (!payload || !point) {
  	        if (payload) payload.EntrancePoint = null;
  	        return payload;
  	      }
  	
  	      payload.EntrancePoint = {
  	        type: "Point",
  	        coordinates: [
  	          Number(point.lng),
  	          Number(point.lat)
  	        ]
  	      };
  	
  	      return payload;
  	    }
  	
  	    function getResolvedBoundaryForEntrance() {
  	      const points = Array.isArray(createState.plotResolvedPoints) && createState.plotResolvedPoints.length
  	      ? createState.plotResolvedPoints: Array.isArray(createState.plotPoints)
  	      ? createState.plotPoints: [];
  	
  	      return cleanFreeGroundRing(points);
  	    }
  	
  	    function projectPointToSegmentPlain(point, a, b) {
  	      const p = makeCleanPlotPoint(point);
  	      const start = makeCleanPlotPoint(a);
  	      const end = makeCleanPlotPoint(b);
  	
  	      if (!p || !start || !end) return null;
  	
  	      const lat0 = Number(p.lat) * Math.PI / 180;
  	      const cosLat = Math.cos(lat0) || 1;
  	
  	      const px = Number(p.lng) * cosLat;
  	      const py = Number(p.lat);
  	
  	      const ax = Number(start.lng) * cosLat;
  	      const ay = Number(start.lat);
  	
  	      const bx = Number(end.lng) * cosLat;
  	      const by = Number(end.lat);
  	
  	      const dx = bx - ax;
  	      const dy = by - ay;
  	      const len2 = (dx * dx) + (dy * dy);
  	
  	      if (!len2) {
  	        return {
  	          point: {
  	            lat: start.lat,
  	            lng: start.lng
  	          },
  	          dist2: ((px - ax) * (px - ax)) + ((py - ay) * (py - ay))
  	        };
  	      }
  	
  	      let t = ((px - ax) * dx + (py - ay) * dy) / len2;
  	
  	      t = Math.max(0, Math.min(1, t));
  	
  	      const sx = ax + (t * dx);
  	      const sy = ay + (t * dy);
  	
  	      const snapped = {
  	        lat: sy,
  	        lng: sx / cosLat
  	      };
  	
  	      const ddx = px - sx;
  	      const ddy = py - sy;
  	
  	      return {
  	        point: snapped,
  	        dist2: (ddx * ddx) + (ddy * ddy),
  	        segmentT: t
  	      };
  	    }
  	
  	    function snapEntrancePointToResolvedBoundary(rawPoint) {
  	      const point = makeCleanPlotPoint(rawPoint);
  	      const ring = getResolvedBoundaryForEntrance();
  	
  	      if (!point || !Array.isArray(ring) || ring.length < 3) {
  	        return null;
  	      }
  	
  	      let best = null;
  	
  	      for (let i = 0; i < ring.length; i++) {
  	        const a = ring[i];
  	        const b = ring[(i + 1) % ring.length];
  	
  	        if (!a || !b) continue;
  	
  	        if (
  	          Math.abs(Number(a.lat) - Number(b.lat)) < 1e-12 &&
  	          Math.abs(Number(a.lng) - Number(b.lng)) < 1e-12
  	        ) {
  	          continue;
  	        }
  	
  	        const projected = projectPointToSegmentPlain(point, a, b);
  	
  	        if (!projected) continue;
  	
  	        if (!best || projected.dist2 < best.dist2) {
  	          best = {
  	            ...projected,
  	            segmentIndex: i
  	          };
  	        }
  	      }
  	
  	      return best ? best.point: null;
  	    }
  	
  	    function makeEntranceMarkerIcon() {
  	      const fill = getFreeGroundPlotColor();
  	
  	      if (
  	        typeof google === "undefined" ||
  	        !google.maps ||
  	        !google.maps.SymbolPath
  	      ) {
  	        return null;
  	      }
  	
  	      return {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        scale: 7,
  	        fillColor: fill,
  	        fillOpacity: 1,
  	        strokeColor: "#ffffff",
  	        strokeWeight: 3
  	      };
  	    }
  	
  	    function clearEntrancePointDraft() {
  	      createState.entrancePoint = null;
  	      createState.isPickingEntrance = false;
  	
  	      try {
  	        if (createState.entranceMarker) {
  	          createState.entranceMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      createState.entranceMarker = null;
  	    }
  	
  	    function setEntrancePointSnapped(map, rawPoint) {
  	      const targetMap = map || createState.plotDraftMap;
  	      const snapped = snapEntrancePointToResolvedBoundary(rawPoint);
  	
  	      if (!snapped) {
  	        window.alert("Please create the boundary first, then click near the boundary to set the entrance point.");
  	        return false;
  	      }
  	
  	      createState.entrancePoint = {
  	        lat: Number(snapped.lat),
  	        lng: Number(snapped.lng)
  	      };
  	
  	      createState.isPickingEntrance = false;
  	
  	      if (
  	        typeof google === "undefined" ||
  	        !google.maps ||
  	        !google.maps.Marker ||
  	        !targetMap
  	      ) {
  	        return true;
  	      }
  	
  	      const markerPosition = {
  	        lat: createState.entrancePoint.lat,
  	        lng: createState.entrancePoint.lng
  	      };
  	
  	      try {
  	        if (!createState.entranceMarker) {
  	          createState.entranceMarker = new google.maps.Marker({
  	            map: targetMap,
  	            position: markerPosition,
  	            draggable: true,
  	            clickable: true,
  	            cursor: "grab",
  	            draggableCursor: "grabbing",
  	            crossOnDrag: false,
  	            icon: makeEntranceMarkerIcon(),
  	            title: "Entrance Point - drag along boundary",
  	            zIndex: 2147483606
  	          });
  	
  	          createState.entranceMarker.__trackitEntranceDragging = false;
  	
  	          function readEntranceDragPoint(event) {
  	            try {
  	              if (event && event.latLng) {
  	                return {
  	                  lat: typeof event.latLng.lat === "function" ? event.latLng.lat(): event.latLng.lat,
  	                  lng: typeof event.latLng.lng === "function" ? event.latLng.lng(): event.latLng.lng
  	                };
  	              }
  	            } catch (_) {}
  	
  	            try {
  	              const markerPosition = createState.entranceMarker?.getPosition?.();
  	
  	              if (markerPosition) {
  	                return {
  	                  lat: typeof markerPosition.lat === "function" ? markerPosition.lat(): markerPosition.lat,
  	                  lng: typeof markerPosition.lng === "function" ? markerPosition.lng(): markerPosition.lng
  	                };
  	              }
  	            } catch (_) {}
  	
  	            return null;
  	          }
  	
  	          function applyEntranceBoundarySlide(rawDragPoint, logLabel) {
  	            if (!createState.entranceMarker) return false;
  	
  	            const liveSnap = snapEntrancePointToResolvedBoundary(rawDragPoint);
  	
  	            if (!liveSnap) {
  	              if (createState.entrancePoint) {
  	                try {
  	                  createState.entranceMarker.setPosition({
  	                    lat: Number(createState.entrancePoint.lat),
  	                    lng: Number(createState.entrancePoint.lng)
  	                  });
  	                } catch (_) {}
  	              }
  	
  	              return false;
  	            }
  	
  	            const nextPosition = {
  	              lat: Number(liveSnap.lat),
  	              lng: Number(liveSnap.lng)
  	            };
  	
  	            createState.entrancePoint = nextPosition;
  	
  	            try {
  	              createState.entranceMarker.__trackitEntranceDragging = true;
  	              createState.entranceMarker.setPosition(nextPosition);
  	            } catch (_) {} finally {
  	              createState.entranceMarker.__trackitEntranceDragging = false;
  	            }
  	
  	            if (logLabel) {
  	              FIF_SILENT_CONSOLE.log(logLabel, {
  	                rawDragPoint,
  	                entrancePoint: createState.entrancePoint
  	              });
  	            }
  	
  	            return true;
  	          }
  	
  	          createState.entranceMarker.addListener("drag", event => {
  	            if (!createState.entranceMarker) return;
  	            if (createState.entranceMarker.__trackitEntranceDragging) return;
  	
  	            const rawDragPoint = readEntranceDragPoint(event);
  	
  	            if (!rawDragPoint) return;
  	
  	            applyEntranceBoundarySlide(rawDragPoint, "");
  	          });
  	
  	          createState.entranceMarker.addListener("dragend",
  	            event => {
  	              if (!createState.entranceMarker) return;
  	
  	              const rawDragPoint = readEntranceDragPoint(event);
  	
  	              if (!rawDragPoint) return;
  	
  	              applyEntranceBoundarySlide(
  	                rawDragPoint,
  	                "[TrackIT Entrance Wizard] Entrance point dragged and snapped to boundary:"
  	              );
  	            });
  	        } else {
  	          createState.entranceMarker.setPosition(markerPosition);
  	          createState.entranceMarker.setIcon(makeEntranceMarkerIcon());
  	          createState.entranceMarker.setMap(targetMap);
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Entrance Wizard] Could not create entrance marker.", error);
  	      }
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Entrance Wizard] Entrance point snapped:", {
  	        rawPoint,
  	        entrancePoint: createState.entrancePoint
  	      });
  	
  	      return true;
  	    }
  	
  	    function beginEntrancePointPicking() {
  	      const entranceStatus = getEntrancePrerequisiteStatus();
  	
  	      if (!entranceStatus.ready) {
  	        window.alert(entranceStatus.message);
  	        return false;
  	      }
  	
  	      const ring = getResolvedBoundaryForEntrance();
  	
  	      if (!Array.isArray(ring) || ring.length < 3) {
  	        window.alert("Please finish the location boundary before picking an entrance point.");
  	        return false;
  	      }
  	
  	      createState.isPickingEntrance = true;
  	      createState.openDropdown = "";
  	      createState.modalMode = "";
  	      createState.helpTopic = "";
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Entrance Wizard] Pick Entrance mode started.");
  	
  	      return true;
  	    }
  	
  	    function interpolatePlotPoint(fromPoint, toPoint, t) {
  	      return {
  	        lat: Number(fromPoint.lat) + ((Number(toPoint.lat) - Number(fromPoint.lat)) * t),
  	        lng: Number(fromPoint.lng) + ((Number(toPoint.lng) - Number(fromPoint.lng)) * t)
  	      };
  	    }
  	
  	    function plotPointToLineDistanceSq(point, lineA, lineB) {
  	      const px = Number(point.lng);
  	      const py = Number(point.lat);
  	      const ax = Number(lineA.lng);
  	      const ay = Number(lineA.lat);
  	      const bx = Number(lineB.lng);
  	      const by = Number(lineB.lat);
  	
  	      const dx = bx - ax;
  	      const dy = by - ay;
  	      const lengthSq = (dx * dx) + (dy * dy);
  	
  	      if (lengthSq <= 1e-18) {
  	        return ((px - ax) * (px - ax)) + ((py - ay) * (py - ay));
  	      }
  	
  	      let t = (((px - ax) * dx) + ((py - ay) * dy)) / lengthSq;
  	
  	      t = Math.max(0, Math.min(1, t));
  	
  	      const x = ax + (t * dx);
  	      const y = ay + (t * dy);
  	
  	      return ((px - x) * (px - x)) + ((py - y) * (py - y));
  	    }
  	
  	    function pointTouchesPlotBoundary(point, boundary) {
  	      if (!point || !Array.isArray(boundary) || boundary.length < 3) return false;
  	
  	      for (let i = 0; i < boundary.length; i++) {
  	        const a = boundary[i];
  	        const b = boundary[(i + 1) % boundary.length];
  	
  	        if (pointOnBoundarySegment(point, a, b)) {
  	          return true;
  	        }
  	      }
  	
  	      return false;
  	    }
  	
  	    function pointInStrictPlotBoundary(point, boundary) {
  	      if (!point || !Array.isArray(boundary) || boundary.length < 3) return false;
  	
  	      if (pointTouchesPlotBoundary(point, boundary)) {
  	        return false;
  	      }
  	
  	      const x = Number(point.lng);
  	      const y = Number(point.lat);
  	
  	      if (!Number.isFinite(x) || !Number.isFinite(y)) return false;
  	
  	      let inside = false;
  	
  	      for (let i = 0, j = boundary.length - 1; i < boundary.length; j = i++) {
  	        const xi = Number(boundary[i].lng);
  	        const yi = Number(boundary[i].lat);
  	        const xj = Number(boundary[j].lng);
  	        const yj = Number(boundary[j].lat);
  	
  	        if (
  	          !Number.isFinite(xi) ||
  	          !Number.isFinite(yi) ||
  	          !Number.isFinite(xj) ||
  	          !Number.isFinite(yj)
  	        ) {
  	          continue;
  	        }
  	
  	        const intersects =
  	        ((yi > y) !== (yj > y)) &&
  	        (x < ((xj - xi) * (y - yi) / ((yj - yi) || 1e-12)) + xi);
  	
  	        if (intersects) inside = !inside;
  	      }
  	
  	      return inside;
  	    }
  	
  	    function nearestBoundaryAnchor(point, blocker) {
  	      if (!point || !blocker || !Array.isArray(blocker.boundary)) return null;
  	
  	      const boundary = blocker.boundary;
  	      let best = null;
  	
  	      for (let i = 0; i < boundary.length; i++) {
  	        const a = boundary[i];
  	        const b = boundary[(i + 1) % boundary.length];
  	
  	        const ax = Number(a.lng);
  	        const ay = Number(a.lat);
  	        const bx = Number(b.lng);
  	        const by = Number(b.lat);
  	        const px = Number(point.lng);
  	        const py = Number(point.lat);
  	
  	        const dx = bx - ax;
  	        const dy = by - ay;
  	        const lengthSq = (dx * dx) + (dy * dy);
  	
  	        let segmentT = 0;
  	        let x = ax;
  	        let y = ay;
  	
  	        if (lengthSq > 1e-18) {
  	          segmentT = (((px - ax) * dx) + ((py - ay) * dy)) / lengthSq;
  	          segmentT = Math.max(0, Math.min(1, segmentT));
  	          x = ax + (segmentT * dx);
  	          y = ay + (segmentT * dy);
  	        }
  	
  	        const distanceSq = ((px - x) * (px - x)) + ((py - y) * (py - y));
  	
  	        if (!best || distanceSq < best.distanceSq) {
  	          best = {
  	            point: {
  	              lat: y,
  	              lng: x
  	            },
  	            blocker,
  	            blockerId: blocker.locationId || "",
  	            locationId: blocker.locationId || "",
  	            locationName: blocker.locationName || "",
  	            segmentIndex: i,
  	            segmentT,
  	            distanceSq
  	          };
  	        }
  	      }
  	
  	      return best;
  	    }
  	
  	    function nearestPointOnBoundary(point, boundary) {
  	      if (!point || !Array.isArray(boundary) || boundary.length < 2) return null;
  	
  	      const fakeBlocker = {
  	        locationId: "",
  	        locationName: "",
  	        boundary
  	      };
  	
  	      const anchor = nearestBoundaryAnchor(point, fakeBlocker);
  	
  	      return anchor ? anchor.point: null;
  	    }
  	
  	    function getStrictContainingBlockerForPoint(point, blockers) {
  	      const list = Array.isArray(blockers) ? blockers: getFreeGroundBlockers();
  	
  	      for (let i = 0; i < list.length; i++) {
  	        const blocker = list[i];
  	
  	        if (!blocker || !Array.isArray(blocker.boundary)) continue;
  	
  	        if (pointInStrictPlotBoundary(point, blocker.boundary)) {
  	          return blocker;
  	        }
  	      }
  	
  	      return null;
  	    }
  	
  	    function getBoundaryAnchorOnHeading(headingStart, headingTarget, blocker) {
  	      if (
  	        !headingStart ||
  	        !headingTarget ||
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3
  	      ) {
  	        return null;
  	      }
  	
  	      const start = {
  	        lat: Number(headingStart.lat),
  	        lng: Number(headingStart.lng)
  	      };
  	
  	      const target = {
  	        lat: Number(headingTarget.lat),
  	        lng: Number(headingTarget.lng)
  	      };
  	
  	      if (
  	        !Number.isFinite(start.lat) ||
  	        !Number.isFinite(start.lng) ||
  	        !Number.isFinite(target.lat) ||
  	        !Number.isFinite(target.lng)
  	      ) {
  	        return null;
  	      }
  	
  	      const dx = target.lng - start.lng;
  	      const dy = target.lat - start.lat;
  	
  	      if (Math.abs(dx) < 1e-14 && Math.abs(dy) < 1e-14) {
  	        return null;
  	      }
  	
  	      // Important:
  	      // The clicked point is a HEADING, not necessarily the final snap point.
  	      // So extend the ray far beyond the clicked point and find the first boundary hit
  	      // in that heading direction.
  	      const rayEnd = {
  	        lat: start.lat + (dy * 1000),
  	        lng: start.lng + (dx * 1000)
  	      };
  	
  	      let best = null;
  	
  	      for (let i = 0; i < blocker.boundary.length; i++) {
  	        const a = blocker.boundary[i];
  	        const b = blocker.boundary[(i + 1) % blocker.boundary.length];
  	
  	        const hit = lineIntersectionPoint(start, rayEnd, a, b);
  	
  	        if (!hit || !hit.point) continue;
  	
  	        if (hit.t <= FREE_GROUND_ROUTE_EPS) continue;
  	        if (hit.t > 1 + FREE_GROUND_ROUTE_EPS) continue;
  	
  	        if (!best || hit.t < best.t) {
  	          best = {
  	            t: hit.t,
  	            point: hit.point,
  	            blocker,
  	            blockerId: blocker.locationId || "",
  	            locationId: blocker.locationId || "",
  	            locationName: blocker.locationName || "",
  	            segmentIndex: i,
  	            segmentT: Math.max(0, Math.min(1, Number(hit.u) || 0)),
  	            distanceSq: 0
  	          };
  	        }
  	      }
  	
  	      return best;
  	    }
  	
  	    function getBoundarySnapForPoint(point, blockers, options) {
  	      const opts = options || {};
  	      const list = Array.isArray(blockers) ? blockers: getFreeGroundBlockers();
  	
  	      let bestNear = null;
  	
  	      for (let i = 0; i < list.length; i++) {
  	        const blocker = list[i];
  	
  	        if (!blocker || !Array.isArray(blocker.boundary)) continue;
  	
  	        if (opts.snapInside && pointInStrictPlotBoundary(point, blocker.boundary)) {
  	          const headingAnchor = getBoundaryAnchorOnHeading(
  	            opts.headingStart || null,
  	            point,
  	            blocker
  	          );
  	
  	          if (headingAnchor) {
  	            return {
  	              point: headingAnchor.point,
  	              anchor: headingAnchor,
  	              blocker,
  	              reason: "inside-existing-location-heading-intersection",
  	              rawPoint: point
  	            };
  	          }
  	
  	          // Only use nearest fallback when we do NOT have a heading.
  	          // If we have a heading, nearest snapping creates the wrong vertical side-snap.
  	          if (!opts.headingStart) {
  	            const insideAnchor = nearestBoundaryAnchor(point, blocker);
  	
  	            if (insideAnchor) {
  	              return {
  	                point: insideAnchor.point,
  	                anchor: insideAnchor,
  	                blocker,
  	                reason: "inside-existing-location-nearest-boundary",
  	                rawPoint: point
  	              };
  	            }
  	          }
  	        }
  	
  	        if (opts.snapNearBoundary) {
  	          const nearAnchor = nearestBoundaryAnchor(point, blocker);
  	
  	          if (!nearAnchor) continue;
  	
  	          if (
  	            nearAnchor.distanceSq <= FREE_GROUND_BOUNDARY_SNAP_DISTANCE_SQ &&
  	            (!bestNear || nearAnchor.distanceSq < bestNear.anchor.distanceSq)
  	          ) {
  	            bestNear = {
  	              point: nearAnchor.point,
  	              anchor: nearAnchor,
  	              blocker,
  	              reason: "near-existing-boundary",
  	              rawPoint: point
  	            };
  	          }
  	        }
  	      }
  	
  	      return bestNear;
  	    }
  	
  	    function sameBlocker(a, b) {
  	      if (!a || !b) return false;
  	
  	      return String(a.locationId || a.blockerId || "") === String(b.locationId || b.blockerId || "");
  	    }
  	
  	    function sameAnchorBlocker(a, b) {
  	      if (!a || !b) return false;
  	
  	      return String(a.locationId || a.blockerId || "") === String(b.locationId || b.blockerId || "");
  	    }
  	
  	    function getSegmentIntersectionsForBoundary(fromPoint, toPoint, boundary, blocker) {
  	      if (!fromPoint || !toPoint || !Array.isArray(boundary) || boundary.length < 3) return [];
  	
  	      const hits = [];
  	
  	      for (let i = 0; i < boundary.length; i++) {
  	        const a = boundary[i];
  	        const b = boundary[(i + 1) % boundary.length];
  	        const hit = lineIntersectionPoint(fromPoint, toPoint, a, b);
  	
  	        if (!hit || !hit.point) continue;
  	
  	        const duplicate = hits.some(existing => {
  	          return (
  	            samePlotPoint(existing.point, hit.point) &&
  	            Math.abs(Number(existing.t) - Number(hit.t)) < FREE_GROUND_ROUTE_EPS
  	          );
  	        });
  	
  	        if (duplicate) continue;
  	
  	        hits.push({
  	          point: hit.point,
  	          t: Math.max(0, Math.min(1, Number(hit.t))),
  	          segmentT: Math.max(0, Math.min(1, Number(hit.u))),
  	          segmentIndex: i,
  	          blocker: blocker || null,
  	          blockerId: blocker?.locationId || "",
  	          locationId: blocker?.locationId || "",
  	          locationName: blocker?.locationName || ""
  	        });
  	      }
  	
  	      hits.sort((a, b) => a.t - b.t);
  	
  	      return hits;
  	    }
  	
  	    function getAllBoundaryEventsForSegment(fromPoint, toPoint, blockers) {
  	      const list = Array.isArray(blockers) ? blockers: getFreeGroundBlockers();
  	      const events = [];
  	
  	      list.forEach(blocker => {
  	        if (!blocker || !Array.isArray(blocker.boundary)) return;
  	
  	        const hits = getSegmentIntersectionsForBoundary(
  	          fromPoint,
  	          toPoint,
  	          blocker.boundary,
  	          blocker
  	        );
  	
  	        hits.forEach(hit => {
  	          if (hit.t <= FREE_GROUND_ROUTE_EPS || hit.t >= 1 - FREE_GROUND_ROUTE_EPS) return;
  	
  	          const anchor = {
  	            point: hit.point,
  	            blocker,
  	            blockerId: blocker.locationId || "",
  	            locationId: blocker.locationId || "",
  	            locationName: blocker.locationName || "",
  	            segmentIndex: hit.segmentIndex,
  	            segmentT: hit.segmentT,
  	            distanceSq: 0
  	          };
  	
  	          events.push({
  	            t: hit.t,
  	            point: hit.point,
  	            blocker,
  	            blockerId: blocker.locationId || "",
  	            locationId: blocker.locationId || "",
  	            locationName: blocker.locationName || "",
  	            anchor,
  	            anchors: [anchor],
  	            kind: "boundary-hit"
  	          });
  	        });
  	      });
  	
  	      events.sort((a,
  	        b) => a.t - b.t);
  	
  	      const deduped = [];
  	
  	      events.forEach(event => {
  	        const existing = deduped.find(item => {
  	          return (
  	            Math.abs(Number(item.t) - Number(event.t)) < FREE_GROUND_ROUTE_EPS &&
  	            samePlotPoint(item.point, event.point)
  	          );
  	        });
  	
  	        if (existing) {
  	          existing.anchors = existing.anchors || [];
  	
  	          event.anchors.forEach(anchor => {
  	            const duplicateAnchor = existing.anchors.some(existingAnchor => {
  	              return (
  	                sameAnchorBlocker(existingAnchor, anchor) &&
  	                Number(existingAnchor.segmentIndex) === Number(anchor.segmentIndex)
  	              );
  	            });
  	
  	            if (!duplicateAnchor) existing.anchors.push(anchor);
  	          });
  	
  	          return;
  	        }
  	
  	        deduped.push(event);
  	      });
  	
  	      return deduped.slice(0, FREE_GROUND_MAX_EDGE_EVENTS);
  	    }
  	
  	    function findEventAnchorForBlocker(event, blocker) {
  	      if (!event || !blocker) return null;
  	
  	      const blockerId = String(blocker.locationId || "");
  	
  	      if (event.anchor && String(event.anchor.locationId || event.anchor.blockerId || "") === blockerId) {
  	        return event.anchor;
  	      }
  	
  	      const anchors = Array.isArray(event.anchors) ? event.anchors: [];
  	
  	      for (let i = 0; i < anchors.length; i++) {
  	        const anchor = anchors[i];
  	
  	        if (String(anchor.locationId || anchor.blockerId || "") === blockerId) {
  	          return anchor;
  	        }
  	      }
  	
  	      return null;
  	    }
  	
  	    function normalizeAnchorForBlocker(point, blocker) {
  	      if (!point || !blocker) return null;
  	
  	      const existing = nearestBoundaryAnchor(point, blocker);
  	
  	      if (!existing) return null;
  	
  	      return existing;
  	    }
  	
  	    function buildForwardBoundaryRoute(boundary, startAnchor, endAnchor) {
  	      if (
  	        !Array.isArray(boundary) ||
  	        boundary.length < 3 ||
  	        !startAnchor ||
  	        !endAnchor
  	      ) {
  	        return [];
  	      }
  	
  	      const n = boundary.length;
  	      const route = [];
  	
  	      const startSegmentIndex = Number(startAnchor.segmentIndex);
  	      const endSegmentIndex = Number(endAnchor.segmentIndex);
  	      const startSegmentT = Number(startAnchor.segmentT) || 0;
  	      const endSegmentT = Number(endAnchor.segmentT) || 0;
  	
  	      pushPlotPoint(route, startAnchor.point);
  	
  	      const sameSegment = startSegmentIndex === endSegmentIndex;
  	      const directOnSameSegment = sameSegment && startSegmentT <= endSegmentT + FREE_GROUND_ROUTE_EPS;
  	
  	      if (!directOnSameSegment) {
  	        let index = (startSegmentIndex + 1) % n;
  	        const stop = (endSegmentIndex + 1) % n;
  	        const forceFullWrap = sameSegment && startSegmentT > endSegmentT + FREE_GROUND_ROUTE_EPS;
  	        let guard = 0;
  	
  	        if (forceFullWrap) {
  	          while (guard < n) {
  	            pushPlotPoint(route, boundary[index]);
  	            index = (index + 1) % n;
  	            guard++;
  	          }
  	        } else {
  	          while (index !== stop && guard < n + 2) {
  	            pushPlotPoint(route, boundary[index]);
  	            index = (index + 1) % n;
  	            guard++;
  	          }
  	        }
  	      }
  	
  	      pushPlotPoint(route, endAnchor.point);
  	
  	      return route;
  	    }
  	
  	    function buildBackwardBoundaryRoute(boundary, startAnchor, endAnchor) {
  	      const forwardFromEnd = buildForwardBoundaryRoute(boundary, endAnchor, startAnchor);
  	
  	      return forwardFromEnd.slice().reverse();
  	    }
  	
  	    function pointInsideOrNearRouteOuter(point, outerRing) {
  	      if (!point || !Array.isArray(outerRing) || outerRing.length < 3) return true;
  	
  	      if (pointInPlotBoundary(point, outerRing)) return true;
  	
  	      const nearest = nearestBoundaryHit(point, outerRing);
  	
  	      if (!nearest) return false;
  	
  	      // Tolerance for snapped farm boundaries / dragged raw rings.
  	      return Number(nearest.distanceSq || 0) <= 5e-9;
  	    }
  	
  	    function pointInsideOrNearRawOuter(point, outerRing) {
  	      if (!point || !Array.isArray(outerRing) || outerRing.length < 3) return true;
  	
  	      if (pointInPlotBoundary(point, outerRing)) return true;
  	
  	      const nearest = nearestBoundaryHit(point, outerRing);
  	
  	      if (!nearest) return false;
  	
  	      // Small tolerance for snapped points and dragged raw rings.
  	      return Number(nearest.distanceSq || 0) <= 5e-9;
  	    }
  	
  	    function scoreBoundaryRoute(route, headingStart, headingTarget, options) {
  	      if (!Array.isArray(route) || !route.length) return Number.POSITIVE_INFINITY;
  	
  	      const opts = options || {};
  	      const outerRing = cleanFreeGroundRing(opts.outerRing || []);
  	
  	      let outsideRawOuterPenalty = 0;
  	      let lineDistanceScore = 0;
  	      let routeLengthScore = 0;
  	      let count = 0;
  	
  	      for (let i = 0; i < route.length; i++) {
  	        const point = route[i];
  	
  	        lineDistanceScore += plotPointToLineDistanceSq(point, headingStart, headingTarget);
  	        count++;
  	
  	        if (outerRing.length >= 3 && !pointInsideOrNearRawOuter(point, outerRing)) {
  	          outsideRawOuterPenalty += 1000000;
  	        }
  	
  	        if (i > 0) {
  	          routeLengthScore += plotDistanceSq(route[i - 1], point);
  	
  	          if (outerRing.length >= 3) {
  	            const midPoint = {
  	              lat: (Number(route[i - 1].lat) + Number(point.lat)) / 2,
  	              lng: (Number(route[i - 1].lng) + Number(point.lng)) / 2
  	            };
  	
  	            if (!pointInsideOrNearRawOuter(midPoint, outerRing)) {
  	              outsideRawOuterPenalty += 1000000;
  	            }
  	          }
  	        }
  	      }
  	
  	      const averageLineDistance = count ? lineDistanceScore / count: lineDistanceScore;
  	
  	      // First priority: choose the boundary walk that remains inside the user's raw intended shape.
  	      // Then prefer the shorter legal detour.
  	      // Heading closeness is only a small tie-breaker.
  	      return outsideRawOuterPenalty + routeLengthScore + (averageLineDistance * 0.05);
  	    }
  	
  	    function walkBoundaryBetweenAnchors(blocker, startAnchor, endAnchor, headingStart, headingTarget, options) {
  	      if (
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        !startAnchor ||
  	        !endAnchor
  	      ) {
  	        return [];
  	      }
  	
  	      if (!sameAnchorBlocker(startAnchor, endAnchor)) {
  	        return [];
  	      }
  	
  	      const boundary = blocker.boundary;
  	
  	      const forward = buildForwardBoundaryRoute(boundary, startAnchor, endAnchor);
  	      const backward = buildBackwardBoundaryRoute(boundary, startAnchor, endAnchor);
  	
  	      const forwardScore = scoreBoundaryRoute(forward, headingStart, headingTarget, options);
  	      const backwardScore = scoreBoundaryRoute(backward, headingStart, headingTarget, options);
  	
  	      return forwardScore <= backwardScore ? forward: backward;
  	    }
  	
  	    function addBoundaryRouteToResolved(resolved, route) {
  	      if (!Array.isArray(resolved) || !Array.isArray(route)) return;
  	
  	      route.forEach(point => {
  	        pushPlotPoint(resolved, point);
  	      });
  	    }
  	
  	    function getHeadingRunsForBlocker(cleanStart, cleanRawTarget, blocker, startAnchor, targetAnchor) {
  	      if (
  	        !cleanStart ||
  	        !cleanRawTarget ||
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3
  	      ) {
  	        return [];
  	      }
  	
  	      const events = [];
  	
  	      const startEventAnchor =
  	      startAnchor && sameAnchorBlocker(startAnchor, blocker)
  	      ? startAnchor: null;
  	
  	      const targetEventAnchor =
  	      targetAnchor && sameAnchorBlocker(targetAnchor, blocker)
  	      ? targetAnchor: null;
  	
  	      events.push({
  	        t: 0,
  	        point: cleanStart,
  	        anchor: startEventAnchor,
  	        kind: "start"
  	      });
  	
  	      const hits = getSegmentIntersectionsForBoundary(
  	        cleanStart,
  	        cleanRawTarget,
  	        blocker.boundary,
  	        blocker
  	      ).filter(hit => {
  	          return hit.t > FREE_GROUND_ROUTE_EPS && hit.t < 1 - FREE_GROUND_ROUTE_EPS;
  	        });
  	
  	      hits.forEach(hit => {
  	        events.push({
  	          t: hit.t,
  	          point: hit.point,
  	          anchor: {
  	            point: hit.point,
  	            blocker,
  	            blockerId: blocker.locationId || "",
  	            locationId: blocker.locationId || "",
  	            locationName: blocker.locationName || "",
  	            segmentIndex: hit.segmentIndex,
  	            segmentT: hit.segmentT,
  	            distanceSq: 0
  	          },
  	          kind: "heading-boundary-hit"
  	        });
  	      });
  	
  	      events.push({
  	        t: 1,
  	        point: cleanRawTarget,
  	        anchor: targetEventAnchor,
  	        kind: "target"
  	      });
  	
  	      events.sort((a, b) => a.t - b.t);
  	
  	      const compactEvents = [];
  	
  	      events.forEach(event => {
  	        const duplicate = compactEvents.find(existing => {
  	          return (
  	            Math.abs(Number(existing.t) - Number(event.t)) < FREE_GROUND_ROUTE_EPS &&
  	            samePlotPoint(existing.point, event.point)
  	          );
  	        });
  	
  	        if (duplicate) {
  	          if (!duplicate.anchor && event.anchor) {
  	            duplicate.anchor = event.anchor;
  	          }
  	
  	          return;
  	        }
  	
  	        compactEvents.push(event);
  	      });
  	
  	      const runs = [];
  	
  	      for (let i = 0; i < compactEvents.length - 1; i++) {
  	        const left = compactEvents[i];
  	        const right = compactEvents[i + 1];
  	
  	        const leftT = Number(left.t);
  	        const rightT = Number(right.t);
  	
  	        if (!Number.isFinite(leftT) || !Number.isFinite(rightT)) continue;
  	        if (rightT - leftT <= FREE_GROUND_ROUTE_EPS) continue;
  	
  	        const midT = (leftT + rightT) / 2;
  	        const midPoint = interpolatePlotPoint(cleanStart, cleanRawTarget, midT);
  	
  	        if (!pointInStrictPlotBoundary(midPoint, blocker.boundary)) continue;
  	
  	        const entryAnchor =
  	        left.anchor ||
  	        normalizeAnchorForBlocker(left.point, blocker);
  	
  	        const exitAnchor =
  	        right.anchor ||
  	        normalizeAnchorForBlocker(right.point, blocker);
  	
  	        if (!entryAnchor || !exitAnchor) continue;
  	        if (samePlotPoint(entryAnchor.point, exitAnchor.point)) continue;
  	
  	        runs.push({
  	          blocker,
  	          entryT: leftT,
  	          exitT: rightT,
  	          entryAnchor,
  	          exitAnchor
  	        });
  	      }
  	
  	      return runs;
  	    }
  	
  	    function getHeadingBoundaryRuns(cleanStart, cleanRawTarget, blockers, startAnchor, targetAnchor) {
  	      const list = Array.isArray(blockers) ? blockers: [];
  	      const runs = [];
  	
  	      list.forEach(blocker => {
  	        const blockerRuns = getHeadingRunsForBlocker(
  	          cleanStart,
  	          cleanRawTarget,
  	          blocker,
  	          startAnchor,
  	          targetAnchor
  	        );
  	
  	        blockerRuns.forEach(run => {
  	          runs.push(run);
  	        });
  	      });
  	
  	      runs.sort((a, b) => {
  	        if (a.entryT < b.entryT) return -1;
  	        if (a.entryT > b.entryT) return 1;
  	        if (a.exitT < b.exitT) return -1;
  	        if (a.exitT > b.exitT) return 1;
  	        return String(a.blocker?.locationId || "").localeCompare(String(b.blocker?.locationId || ""));
  	      });
  	
  	      const cleanRuns = [];
  	
  	      runs.forEach(run => {
  	        const last = cleanRuns.length ? cleanRuns[cleanRuns.length - 1]: null;
  	
  	        if (last && run.entryT < last.exitT - FREE_GROUND_ROUTE_EPS) {
  	          return;
  	        }
  	
  	        cleanRuns.push(run);
  	      });
  	
  	      return cleanRuns;
  	    }
  	
  	    function resolveFreeGroundEdgeByHeadingRuns(
  	      cleanStart,
  	      startAnchor,
  	      cleanRawTarget,
  	      targetPoint,
  	      targetAnchor,
  	      blockers,
  	      opts,
  	      existingHeadingPoints
  	    ) {
  	      const runs = getHeadingBoundaryRuns(
  	        cleanStart,
  	        cleanRawTarget,
  	        blockers,
  	        startAnchor,
  	        targetAnchor
  	      );
  	
  	      if (!runs.length) return null;
  	
  	      const addedPoints = [];
  	      const headingPoints = Array.isArray(existingHeadingPoints)
  	      ? existingHeadingPoints.slice(): [];
  	
  	      const snapSegments = [];
  	      let latestAnchor = startAnchor || null;
  	
  	      runs.forEach(run => {
  	        pushPlotPoint(addedPoints, run.entryAnchor.point);
  	
  	        const route = walkBoundaryBetweenAnchors(
  	          run.blocker,
  	          run.entryAnchor,
  	          run.exitAnchor,
  	          cleanStart,
  	          cleanRawTarget,
  	          {
  	            outerRing: opts && opts.outerRing
  	          }
  	        );
  	
  	        if (route.length) {
  	          addBoundaryRouteToResolved(addedPoints, route);
  	          latestAnchor = run.exitAnchor;
  	
  	          snapSegments.push({
  	            type: opts && opts.isClosing
  	            ? "closing-heading-intersection-boundary-walk": "heading-intersection-boundary-walk",
  	            locationId: run.blocker.locationId || "",
  	            locationName: run.blocker.locationName || "",
  	            entryPoint: run.entryAnchor.point,
  	            exitPoint: run.exitAnchor.point,
  	            rawTargetPoint: cleanRawTarget,
  	            route
  	          });
  	        }
  	      });
  	
  	      const targetInsideBlocker = getStrictContainingBlockerForPoint(
  	        cleanRawTarget,
  	        blockers
  	      );
  	
  	      const shouldEndAtSnappedTarget =
  	      !!targetInsideBlocker ||
  	      !!(opts && opts.isClosing) ||
  	      !!(opts && opts.targetAnchor);
  	
  	      const finalPoint = shouldEndAtSnappedTarget
  	      ? targetPoint || cleanRawTarget: cleanRawTarget;
  	
  	      pushPlotPoint(addedPoints,
  	        finalPoint);
  	
  	      return {
  	        points: addedPoints,
  	        anchor: shouldEndAtSnappedTarget
  	        ? targetAnchor || latestAnchor || null: null,
  	        headingPoints,
  	        snapSegments
  	      };
  	    }
  	
  	    function resolveFreeGroundEdgeLive(startPoint,
  	      startAnchor,
  	      rawTargetPoint,
  	      blockers,
  	      options) {
  	      const opts = options || {};
  	      const cleanStart = makeCleanPlotPoint(startPoint);
  	      const cleanRawTarget = makeCleanPlotPoint(rawTargetPoint);
  	
  	      const addedPoints = [];
  	      const headingPoints = [];
  	      const snapSegments = [];
  	
  	      if (!cleanStart || !cleanRawTarget) {
  	        return {
  	          points: [],
  	          anchor: null,
  	          headingPoints,
  	          snapSegments
  	        };
  	      }
  	
  	      const cleanHeadingStart = makeCleanPlotPoint(opts.headingStart) || cleanStart;
  	
  	      const forcedTargetAnchor = opts.targetAnchor || null;
  	      const targetSnap = forcedTargetAnchor
  	      ? {
  	        point: forcedTargetAnchor.point,
  	        anchor: forcedTargetAnchor,
  	        blocker: forcedTargetAnchor.blocker || null,
  	        reason: "forced-target-anchor",
  	        rawPoint: cleanRawTarget
  	      }: getBoundarySnapForPoint(cleanRawTarget, blockers, {
  	          snapInside: true,
  	          snapNearBoundary: true,
  	          headingStart: cleanHeadingStart
  	        });
  	
  	      const targetPoint = targetSnap?.point
  	      ? makeCleanPlotPoint(targetSnap.point): cleanRawTarget;
  	
  	      const targetAnchor = targetSnap?.anchor || null;
  	
  	      const headingEvents = getAllBoundaryEventsForSegment(
  	        cleanHeadingStart,
  	        cleanRawTarget,
  	        blockers
  	      );
  	
  	      const segmentEvents = getAllBoundaryEventsForSegment(
  	        cleanStart,
  	        targetPoint,
  	        blockers
  	      );
  	
  	      const hasRawHeadingInteriorEvents = headingEvents.length > 0;
  	
  	      if (targetSnap && !samePlotPoint(cleanRawTarget, targetPoint)) {
  	        headingPoints.push(cleanRawTarget);
  	      }
  	
  	      const headingRunResult = resolveFreeGroundEdgeByHeadingRuns(
  	        cleanHeadingStart,
  	        startAnchor || null,
  	        cleanRawTarget,
  	        targetPoint,
  	        targetAnchor || null,
  	        blockers,
  	        opts,
  	        headingPoints
  	      );
  	
  	      if (headingRunResult) {
  	        return headingRunResult;
  	      }
  	      if (
  	        startAnchor &&
  	        targetAnchor &&
  	        sameAnchorBlocker(startAnchor, targetAnchor) &&
  	        !hasRawHeadingInteriorEvents
  	      ) {
  	        const blocker = startAnchor.blocker || targetAnchor.blocker;
  	
  	        const route = walkBoundaryBetweenAnchors(
  	          blocker,
  	          startAnchor,
  	          targetAnchor,
  	          cleanHeadingStart,
  	          cleanRawTarget,
  	          {
  	            outerRing: opts && opts.outerRing
  	          }
  	        );
  	
  	        if (route.length) {
  	          addBoundaryRouteToResolved(addedPoints, route);
  	
  	          snapSegments.push({
  	            type: opts.isClosing ? "closing-boundary-anchor-walk": "boundary-anchor-walk",
  	            locationId: blocker?.locationId || startAnchor.locationId || "",
  	            locationName: blocker?.locationName || startAnchor.locationName || "",
  	            fromPoint: startAnchor.point,
  	            toPoint: targetAnchor.point,
  	            rawTargetPoint: cleanRawTarget,
  	            route
  	          });
  	
  	          return {
  	            points: addedPoints,
  	            anchor: targetAnchor,
  	            headingPoints,
  	            snapSegments
  	          };
  	        }
  	      }
  	
  	      const events = [{
  	        t: 0,
  	        point: cleanStart,
  	        anchor: startAnchor || null,
  	        anchors: startAnchor ? [startAnchor]: [],
  	        kind: "start"
  	      },
  	        ...segmentEvents,
  	        {
  	          t: 1,
  	          point: targetPoint,
  	          anchor: targetAnchor || null,
  	          anchors: targetAnchor ? [targetAnchor]: [],
  	          kind: "target"
  	        }];
  	
  	      events.sort((a, b) => a.t - b.t);
  	
  	      const compactEvents = [];
  	
  	      events.forEach(event => {
  	        const existing = compactEvents.find(item => {
  	          return (
  	            Math.abs(Number(item.t) - Number(event.t)) < FREE_GROUND_ROUTE_EPS &&
  	            samePlotPoint(item.point, event.point)
  	          );
  	        });
  	
  	        if (existing) {
  	          existing.anchors = existing.anchors || [];
  	
  	          const anchors = Array.isArray(event.anchors)
  	          ? event.anchors: event.anchor
  	          ? [event.anchor]: [];
  	
  	          anchors.forEach(anchor => {
  	            const duplicateAnchor = existing.anchors.some(existingAnchor => {
  	              return sameAnchorBlocker(existingAnchor, anchor);
  	            });
  	
  	            if (!duplicateAnchor) existing.anchors.push(anchor);
  	          });
  	
  	          if (!existing.anchor && event.anchor) existing.anchor = event.anchor;
  	
  	          return;
  	        }
  	
  	        compactEvents.push(event);
  	      });
  	
  	      let latestAnchor = startAnchor || null;
  	
  	      for (let i = 0; i < compactEvents.length - 1; i++) {
  	        const left = compactEvents[i];
  	        const right = compactEvents[i + 1];
  	
  	        if (!left || !right) continue;
  	
  	        const leftT = Number(left.t);
  	        const rightT = Number(right.t);
  	
  	        if (!Number.isFinite(leftT) || !Number.isFinite(rightT)) continue;
  	        if (rightT - leftT <= FREE_GROUND_ROUTE_EPS) continue;
  	
  	        const midT = (leftT + rightT) / 2;
  	        const midPoint = interpolatePlotPoint(cleanStart, targetPoint, midT);
  	        const insideBlocker = getStrictContainingBlockerForPoint(midPoint, blockers);
  	
  	        if (insideBlocker) {
  	          const entryAnchor =
  	          findEventAnchorForBlocker(left, insideBlocker) ||
  	          normalizeAnchorForBlocker(left.point, insideBlocker);
  	
  	          const exitAnchor =
  	          findEventAnchorForBlocker(right, insideBlocker) ||
  	          normalizeAnchorForBlocker(right.point, insideBlocker);
  	
  	          if (entryAnchor && exitAnchor) {
  	            const route = walkBoundaryBetweenAnchors(
  	              insideBlocker,
  	              entryAnchor,
  	              exitAnchor,
  	              cleanStart,
  	              cleanRawTarget,
  	              {
  	                outerRing: opts && opts.outerRing
  	              }
  	            );
  	
  	            if (route.length) {
  	              addBoundaryRouteToResolved(addedPoints, route);
  	              latestAnchor = exitAnchor;
  	
  	              snapSegments.push({
  	                type: opts.isClosing ? "closing-multi-cross-boundary-walk": "multi-cross-boundary-walk",
  	                locationId: insideBlocker.locationId || "",
  	                locationName: insideBlocker.locationName || "",
  	                entryPoint: entryAnchor.point,
  	                exitPoint: exitAnchor.point,
  	                rawTargetPoint: cleanRawTarget,
  	                route
  	              });
  	
  	              continue;
  	            }
  	          }
  	
  	          const fallbackExit = normalizeAnchorForBlocker(right.point, insideBlocker);
  	
  	          if (fallbackExit && fallbackExit.point) {
  	            pushPlotPoint(addedPoints, fallbackExit.point);
  	            latestAnchor = fallbackExit;
  	
  	            snapSegments.push({
  	              type: "multi-cross-fallback-exit",
  	              locationId: insideBlocker.locationId || "",
  	              locationName: insideBlocker.locationName || "",
  	              rawTargetPoint: cleanRawTarget,
  	              exitPoint: fallbackExit.point
  	            });
  	
  	            continue;
  	          }
  	        }
  	
  	        pushPlotPoint(addedPoints, right.point);
  	
  	        if (right.anchor) {
  	          latestAnchor = right.anchor;
  	        } else if (Array.isArray(right.anchors) && right.anchors.length) {
  	          latestAnchor = right.anchors[0];
  	        } else {
  	          latestAnchor = null;
  	        }
  	      }
  	
  	      return {
  	        points: addedPoints,
  	        anchor: targetAnchor || latestAnchor || null,
  	        headingPoints,
  	        snapSegments
  	      };
  	    }
  	
  	    function resolveClosingSnapIfNeeded(resolved, firstAnchor, lastAnchor, blockers, snapSegments, headingPoints, rawOuterRing) {
  	      if (!Array.isArray(resolved) || resolved.length < 3) return;
  	
  	      const first = resolved[0];
  	      const last = resolved[resolved.length - 1];
  	
  	      if (!first || !last || samePlotPoint(first, last)) return;
  	
  	      const closingResult = resolveFreeGroundEdgeLive(
  	        last,
  	        lastAnchor || null,
  	        first,
  	        blockers,
  	        {
  	          isClosing: true,
  	          targetAnchor: firstAnchor || null,
  	          headingStart: Array.isArray(rawOuterRing) && rawOuterRing.length
  	          ? rawOuterRing[rawOuterRing.length - 1]: last,
  	          outerRing: rawOuterRing
  	        }
  	      );
  	
  	      const closingPoints = Array.isArray(closingResult.points)
  	      ? closingResult.points: [];
  	
  	      closingPoints.forEach(point => {
  	        if (!samePlotPoint(point, first)) {
  	          pushPlotPoint(resolved, point);
  	        }
  	      });
  	
  	      if (Array.isArray(closingResult.snapSegments)) {
  	        closingResult.snapSegments.forEach(segment => {
  	          snapSegments.push(segment);
  	        });
  	      }
  	
  	      if (Array.isArray(closingResult.headingPoints)) {
  	        closingResult.headingPoints.forEach(point => {
  	          headingPoints.push(point);
  	        });
  	      }
  	    }
  	
  	    function cleanFreeGroundRing(points) {
  	      const ring = Array.isArray(points)
  	      ? points.map(point => {
  	        return {
  	          lat: Number(point?.lat),
  	          lng: Number(point?.lng)
  	        };
  	      }).filter(point => {
  	        return Number.isFinite(point.lat) && Number.isFinite(point.lng);
  	      }): [];
  	
  	      if (ring.length >= 2 && samePlotPoint(ring[0], ring[ring.length - 1])) {
  	        ring.pop();
  	      }
  	
  	      return ring;
  	    }
  	
  	    function signedFreeGroundRingArea(points) {
  	      const ring = cleanFreeGroundRing(points);
  	
  	      if (ring.length < 3) return 0;
  	
  	      let total = 0;
  	
  	      for (let i = 0; i < ring.length; i++) {
  	        const a = ring[i];
  	        const b = ring[(i + 1) % ring.length];
  	
  	        total += (Number(a.lng) * Number(b.lat)) - (Number(b.lng) * Number(a.lat));
  	      }
  	
  	      return total / 2;
  	    }
  	
  	    function makeHoleRingOppositeOuter(holeBoundary, outerBoundary) {
  	      const hole = cleanFreeGroundRing(holeBoundary);
  	      const outer = cleanFreeGroundRing(outerBoundary);
  	
  	      if (hole.length < 3 || outer.length < 3) return [];
  	
  	      const outerArea = signedFreeGroundRingArea(outer);
  	      const holeArea = signedFreeGroundRingArea(hole);
  	
  	      if (!outerArea || !holeArea) return hole;
  	
  	      // Holes must run opposite to the outer ring.
  	      if ((outerArea > 0 && holeArea > 0) || (outerArea < 0 && holeArea < 0)) {
  	        return hole.slice().reverse();
  	      }
  	
  	      return hole;
  	    }
  	
  	    function getRingAveragePoint(points) {
  	      const ring = cleanFreeGroundRing(points);
  	
  	      if (!ring.length) return null;
  	
  	      const total = ring.reduce((sum, point) => {
  	        sum.lat += Number(point.lat);
  	        sum.lng += Number(point.lng);
  	        return sum;
  	      }, {
  	        lat: 0,
  	        lng: 0
  	      });
  	
  	      return {
  	        lat: total.lat / ring.length,
  	        lng: total.lng / ring.length
  	      };
  	    }
  	
  	    function pointIsInsideOrVeryNearRing(point, ring) {
  	      if (!point || !Array.isArray(ring) || ring.length < 3) return false;
  	
  	      if (pointInPlotBoundary(point, ring)) return true;
  	
  	      const nearest = nearestBoundaryHit(point, ring);
  	
  	      if (!nearest) return false;
  	
  	      // Small tolerance for snapped/touched farm boundaries.
  	      return Number(nearest.distanceSq || 0) <= 1e-9;
  	    }
  	
  	    function ringsHaveRealCrossing(ringA, ringB) {
  	      const a = cleanFreeGroundRing(ringA);
  	      const b = cleanFreeGroundRing(ringB);
  	
  	      if (a.length < 3 || b.length < 3) return false;
  	
  	      for (let i = 0; i < a.length; i++) {
  	        const a1 = a[i];
  	        const a2 = a[(i + 1) % a.length];
  	
  	        for (let j = 0; j < b.length; j++) {
  	          const b1 = b[j];
  	          const b2 = b[(j + 1) % b.length];
  	
  	          if (freeGroundSegmentsIntersect(a1, a2, b1, b2)) {
  	            return true;
  	          }
  	        }
  	      }
  	
  	      return false;
  	    }
  	
  	    function blockerBoundaryIsFullyInsideOuter(blocker, outerBoundary) {
  	      if (
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3 ||
  	        !Array.isArray(outerBoundary) ||
  	        outerBoundary.length < 3
  	      ) {
  	        return false;
  	      }
  	
  	      const boundary = cleanFreeGroundRing(blocker.boundary);
  	      const outer = cleanFreeGroundRing(outerBoundary);
  	
  	      if (boundary.length < 3 || outer.length < 3) return false;
  	
  	      const blockerCenter = getRingAveragePoint(boundary);
  	
  	      if (!blockerCenter || !pointInPlotBoundary(blockerCenter, outer)) {
  	        return false;
  	      }
  	
  	      // If the two rings truly X-cross, this is overlap/snap territory, not a clean donut.
  	      // Touching or boundary-following is allowed.
  	      if (ringsHaveRealCrossing(boundary, outer)) {
  	        return false;
  	      }
  	
  	      let insideOrNearCount = 0;
  	
  	      for (let i = 0; i < boundary.length; i++) {
  	        if (pointIsInsideOrVeryNearRing(boundary[i], outer)) {
  	          insideOrNearCount++;
  	        }
  	      }
  	
  	      if (!insideOrNearCount) return false;
  	
  	      // Perfect case.
  	      if (insideOrNearCount === boundary.length) return true;
  	
  	      // Real farm geometry can have tiny tolerance misses after snapping.
  	      // If the centre is inside, no true crossing exists, and most points are inside/near,
  	      // treat it as a donut hole.
  	      return (insideOrNearCount / boundary.length) >= 0.8;
  	    }
  	
  	    function pointInsideOrNearConfirmedHoleOuter(point, outer) {
  	      if (!point || !Array.isArray(outer) || outer.length < 3) return false;
  	
  	      if (pointInPlotBoundary(point, outer)) return true;
  	
  	      const nearest = nearestBoundaryHit(point, outer);
  	
  	      if (!nearest) return false;
  	
  	      return Number(nearest.distanceSq || 0) <= 1e-9;
  	    }
  	
  	    function ringsHaveConfirmedHoleCrossing(ringA, ringB) {
  	      const a = cleanFreeGroundRing(ringA);
  	      const b = cleanFreeGroundRing(ringB);
  	
  	      if (a.length < 3 || b.length < 3) return false;
  	
  	      for (let i = 0; i < a.length; i++) {
  	        const a1 = a[i];
  	        const a2 = a[(i + 1) % a.length];
  	
  	        for (let j = 0; j < b.length; j++) {
  	          const b1 = b[j];
  	          const b2 = b[(j + 1) % b.length];
  	
  	          if (freeGroundSegmentsIntersect(a1, a2, b1, b2)) {
  	            return true;
  	          }
  	        }
  	      }
  	
  	      return false;
  	    }
  	
  	    function blockerIsConfirmedRoutingDonutHole(blocker, outerBoundary) {
  	      if (
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3 ||
  	        !Array.isArray(outerBoundary) ||
  	        outerBoundary.length < 3
  	      ) {
  	        return false;
  	      }
  	
  	      const boundary = cleanFreeGroundRing(blocker.boundary);
  	      const outer = cleanFreeGroundRing(outerBoundary);
  	
  	      if (boundary.length < 3 || outer.length < 3) return false;
  	
  	      // If the new outer ring really cuts across the old Location,
  	      // this is not a confirmed donut yet. It must remain a blocker.
  	      if (ringsHaveConfirmedHoleCrossing(boundary, outer)) {
  	        return false;
  	      }
  	
  	      let insideOrNearCount = 0;
  	      let strictInsideCount = 0;
  	
  	      for (let i = 0; i < boundary.length; i++) {
  	        const point = boundary[i];
  	
  	        if (pointInsideOrNearConfirmedHoleOuter(point, outer)) {
  	          insideOrNearCount++;
  	        }
  	
  	        if (pointInStrictPlotBoundary(point, outer)) {
  	          strictInsideCount++;
  	        }
  	      }
  	
  	      if (!strictInsideCount) return false;
  	
  	      // This must be high. Otherwise a partial include gets removed from
  	      // routeBlockers too early and the boundary walk disappears.
  	      return (insideOrNearCount / boundary.length) >= 0.92;
  	    }
  	
  	    function rawEdgeCutsBlocker(startPoint, endPoint, blocker) {
  	      const start = makeCleanPlotPoint(startPoint);
  	      const end = makeCleanPlotPoint(endPoint);
  	
  	      if (
  	        !start ||
  	        !end ||
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3
  	      ) {
  	        return false;
  	      }
  	
  	      const boundary = cleanFreeGroundRing(blocker.boundary);
  	
  	      if (boundary.length < 3) return false;
  	
  	      if (pointInStrictPlotBoundary(start, boundary)) return true;
  	      if (pointInStrictPlotBoundary(end, boundary)) return true;
  	
  	      const hits = getSegmentIntersectionsForBoundary(
  	        start,
  	        end,
  	        boundary,
  	        blocker
  	      ).filter(hit => {
  	          return hit.t > FREE_GROUND_ROUTE_EPS && hit.t < 1 - FREE_GROUND_ROUTE_EPS;
  	        });
  	
  	      if (hits.length) return true;
  	
  	      const midPoint = interpolatePlotPoint(start, end, 0.5);
  	
  	      return pointInStrictPlotBoundary(midPoint, boundary);
  	    }
  	
  	    function rawRingCutsBlocker(rawBoundary, blocker) {
  	      const raw = cleanFreeGroundRing(rawBoundary);
  	
  	      if (
  	        raw.length < 3 ||
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3
  	      ) {
  	        return false;
  	      }
  	
  	      for (let i = 0; i < raw.length; i++) {
  	        const a = raw[i];
  	        const b = raw[(i + 1) % raw.length];
  	
  	        if (rawEdgeCutsBlocker(a, b, blocker)) {
  	          return true;
  	        }
  	      }
  	
  	      return false;
  	    }
  	
  	    function buildRawCutBlockerIdLookup(rawBoundary, blockers) {
  	      const lookup = Object.create(null);
  	      const list = Array.isArray(blockers) ? blockers: [];
  	
  	      list.forEach(blocker => {
  	        if (!blocker) return;
  	
  	        const id = String(blocker.locationId || "");
  	
  	        if (!id) return;
  	
  	        if (rawRingCutsBlocker(rawBoundary, blocker)) {
  	          lookup[id] = true;
  	        }
  	      });
  	
  	      return lookup;
  	    }
  	
  	    function blockerAreaForNestedHolePrune(blocker) {
  	      if (!blocker || !Array.isArray(blocker.boundary)) return 0;
  	
  	      const explicitArea = Number(blocker.area);
  	
  	      if (Number.isFinite(explicitArea) && explicitArea > 0) {
  	        return explicitArea;
  	      }
  	
  	      try {
  	        return Number(rendererComputeArea(cleanFreeGroundRing(blocker.boundary))) || 0;
  	      } catch (_) {
  	        return 0;
  	      }
  	    }
  	
  	    function pruneNestedDonutHoleBlockers(blockers) {
  	      const list = Array.isArray(blockers)
  	      ? blockers.filter(blocker => {
  	        return blocker && Array.isArray(blocker.boundary) && blocker.boundary.length >= 3;
  	      }): [];
  	
  	      if (list.length <= 1) return list;
  	
  	      // For donut holes we want the OUTERMOST blocker boundaries.
  	      // If one confirmed hole sits fully inside another confirmed hole,
  	      // the smaller one must not also be added as a hole, otherwise nested
  	      // holes can visually re-fill/cancel.
  	      const sorted = list.slice().sort((a, b) => {
  	        const areaA = blockerAreaForNestedHolePrune(a);
  	        const areaB = blockerAreaForNestedHolePrune(b);
  	
  	        if (areaA > areaB) return -1;
  	        if (areaA < areaB) return 1;
  	
  	        return safeString(a?.locationId).localeCompare(safeString(b?.locationId));
  	      });
  	
  	      const kept = [];
  	
  	      sorted.forEach(candidate => {
  	        const candidateId = safeString(candidate?.locationId).trim();
  	
  	        const isInsideAlreadyKeptHole = kept.some(outer => {
  	          const outerId = safeString(outer?.locationId).trim();
  	
  	          if (candidateId && outerId && candidateId === outerId) return true;
  	
  	          return blockerBoundaryIsFullyInsideOuter(candidate, outer.boundary);
  	        });
  	
  	        if (!isInsideAlreadyKeptHole) {
  	          kept.push(candidate);
  	        }
  	      });
  	
  	      return kept;
  	    }
  	
  	    function pruneNestedHoleResult(result) {
  	      if (
  	        !result ||
  	        !Array.isArray(result.holeRings) ||
  	        !Array.isArray(result.holeLocations) ||
  	        result.holeRings.length <= 1
  	      ) {
  	        return result || {
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      const entries = result.holeRings.map((ring, index) => {
  	        const location = result.holeLocations[index] || {};
  	
  	        return {
  	          ring,
  	          location,
  	          blocker: {
  	            locationId: location.locationId || location.id || `hole-${index}`,
  	            locationName: location.locationName || location.name || "",
  	            boundary: ring,
  	            area: rendererComputeArea(cleanFreeGroundRing(ring)),
  	            location: location.location || null
  	          }
  	        };
  	      }).filter(entry => {
  	        return Array.isArray(entry.ring) && entry.ring.length >= 3;
  	      });
  	
  	      if (entries.length <= 1) {
  	        return {
  	          holeRings: entries.map(entry => entry.ring),
  	          holeLocations: entries.map(entry => entry.location)
  	        };
  	      }
  	
  	      const sorted = entries.slice().sort((a, b) => {
  	        const areaA = Number(a.blocker.area) || 0;
  	        const areaB = Number(b.blocker.area) || 0;
  	
  	        if (areaA > areaB) return -1;
  	        if (areaA < areaB) return 1;
  	
  	        return safeString(a.blocker.locationId).localeCompare(safeString(b.blocker.locationId));
  	      });
  	
  	      const kept = [];
  	
  	      sorted.forEach(entry => {
  	        const nested = kept.some(outerEntry => {
  	          return blockerBoundaryIsFullyInsideOuter(
  	            entry.blocker,
  	            outerEntry.blocker.boundary
  	          );
  	        });
  	
  	        if (!nested) {
  	          kept.push(entry);
  	        }
  	      });
  	
  	      return {
  	        holeRings: kept.map(entry => entry.ring),
  	        holeLocations: kept.map(entry => entry.location)
  	      };
  	    }
  	
  	    function buildFreeGroundConfirmedDonutHoles(outerBoundary,
  	      blockers) {
  	      const outer = cleanFreeGroundRing(outerBoundary);
  	
  	      if (outer.length < 3) {
  	        return {
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      const list = Array.isArray(blockers) ? blockers: [];
  	
  	      const confirmedHoleBlockers = [];
  	
  	      list.forEach(blocker => {
  	        if (!blocker || !Array.isArray(blocker.boundary)) return;
  	
  	        if (!blockerIsConfirmedRoutingDonutHole(blocker, outer)) return;
  	
  	        confirmedHoleBlockers.push(blocker);
  	      });
  	
  	      const prunedHoleBlockers = pruneNestedDonutHoleBlockers(confirmedHoleBlockers);
  	
  	      const holeRings = [];
  	      const holeLocations = [];
  	
  	      prunedHoleBlockers.forEach(blocker => {
  	        const holeRing = makeHoleRingOppositeOuter(blocker.boundary, outer);
  	
  	        if (!Array.isArray(holeRing) || holeRing.length < 3) return;
  	
  	        holeRings.push(holeRing);
  	
  	        holeLocations.push({
  	          locationId: blocker.locationId || "",
  	          locationName: blocker.locationName || "",
  	          location: blocker.location || null,
  	          points: holeRing
  	        });
  	      });
  	
  	      return {
  	        holeRings,
  	        holeLocations
  	      };
  	    }
  	
  	    function buildFreeGroundDonutHoles(outerBoundary,
  	      blockers) {
  	      const outer = cleanFreeGroundRing(outerBoundary);
  	
  	      if (outer.length < 3) {
  	        return {
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      const list = Array.isArray(blockers) ? blockers: [];
  	      const holeRings = [];
  	      const holeLocations = [];
  	
  	      list.forEach(blocker => {
  	        if (!blocker || !Array.isArray(blocker.boundary)) return;
  	
  	        if (!blockerBoundaryIsFullyInsideOuter(blocker, outer)) return;
  	
  	        const holeRing = makeHoleRingOppositeOuter(blocker.boundary, outer);
  	
  	        if (!Array.isArray(holeRing) || holeRing.length < 3) return;
  	
  	        holeRings.push(holeRing);
  	
  	        holeLocations.push({
  	          locationId: blocker.locationId || "",
  	          locationName: blocker.locationName || "",
  	          location: blocker.location || null,
  	          points: holeRing
  	        });
  	      });
  	
  	      return {
  	        holeRings,
  	        holeLocations
  	      };
  	    }
  	
  	    function makeBoundaryAnchorFromHit(hit,
  	      blocker) {
  	      if (!hit || !hit.point || !blocker) return null;
  	
  	      return {
  	        point: hit.point,
  	        blocker,
  	        blockerId: blocker.locationId || "",
  	        locationId: blocker.locationId || "",
  	        locationName: blocker.locationName || "",
  	        segmentIndex: hit.segmentIndex,
  	        segmentT: hit.segmentT,
  	        distanceSq: 0
  	      };
  	    }
  	
  	    function getFirstBoundaryAnchorOnSegmentForBlocker(fromPoint, toPoint, blocker) {
  	      const from = makeCleanPlotPoint(fromPoint);
  	      const to = makeCleanPlotPoint(toPoint);
  	
  	      if (
  	        !from ||
  	        !to ||
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3
  	      ) {
  	        return null;
  	      }
  	
  	      const hits = getSegmentIntersectionsForBoundary(
  	        from,
  	        to,
  	        blocker.boundary,
  	        blocker
  	      ).filter(hit => {
  	          return hit.t > FREE_GROUND_ROUTE_EPS && hit.t < 1 - FREE_GROUND_ROUTE_EPS;
  	        });
  	
  	      if (!hits.length) return null;
  	
  	      return makeBoundaryAnchorFromHit(hits[0], blocker);
  	    }
  	
  	    function getAnchorForCurrentBoundaryPoint(point, blocker) {
  	      if (
  	        !point ||
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3
  	      ) {
  	        return null;
  	      }
  	
  	      const snap = getBoundarySnapForPoint(point, [blocker], {
  	        snapInside: false,
  	        snapNearBoundary: true
  	      });
  	
  	      if (snap && snap.anchor && samePlotPoint(snap.point, point)) {
  	        return snap.anchor;
  	      }
  	
  	      return null;
  	    }
  	
  	    function resolveInsideRawPointBoundaryCorner(
  	      lastResolvedPoint,
  	      startAnchor,
  	      previousRawPoint,
  	      insideRawPoint,
  	      nextRawPoint,
  	      blocker,
  	      rawOuterRing
  	    ) {
  	      const lastResolved = makeCleanPlotPoint(lastResolvedPoint);
  	      const previousRaw = makeCleanPlotPoint(previousRawPoint);
  	      const insideRaw = makeCleanPlotPoint(insideRawPoint);
  	      const nextRaw = makeCleanPlotPoint(nextRawPoint);
  	
  	      if (
  	        !lastResolved ||
  	        !previousRaw ||
  	        !insideRaw ||
  	        !nextRaw ||
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3
  	      ) {
  	        return null;
  	      }
  	
  	      let entryAnchor = null;
  	
  	      if (
  	        startAnchor &&
  	        sameAnchorBlocker(startAnchor, blocker) &&
  	        samePlotPoint(startAnchor.point, lastResolved)
  	      ) {
  	        entryAnchor = startAnchor;
  	      }
  	
  	      if (!entryAnchor) {
  	        entryAnchor = getFirstBoundaryAnchorOnSegmentForBlocker(
  	          previousRaw,
  	          insideRaw,
  	          blocker
  	        );
  	      }
  	
  	      if (!entryAnchor) {
  	        entryAnchor = getAnchorForCurrentBoundaryPoint(lastResolved, blocker);
  	      }
  	
  	      const exitAnchor = getFirstBoundaryAnchorOnSegmentForBlocker(
  	        insideRaw,
  	        nextRaw,
  	        blocker
  	      );
  	
  	      if (!entryAnchor || !exitAnchor) return null;
  	      if (!sameAnchorBlocker(entryAnchor, exitAnchor)) return null;
  	      if (samePlotPoint(entryAnchor.point, exitAnchor.point)) return null;
  	
  	      const route = walkBoundaryBetweenAnchors(
  	        blocker,
  	        entryAnchor,
  	        exitAnchor,
  	        previousRaw,
  	        nextRaw,
  	        {
  	          outerRing: rawOuterRing
  	        }
  	      );
  	
  	      if (!Array.isArray(route) || !route.length) return null;
  	
  	      const points = [];
  	
  	      pushPlotPoint(points, entryAnchor.point);
  	      addBoundaryRouteToResolved(points, route);
  	      pushPlotPoint(points, exitAnchor.point);
  	
  	      return {
  	        points,
  	        anchor: exitAnchor,
  	        headingPoints: [insideRaw],
  	        snapSegments: [{
  	          type: "inside-raw-point-boundary-corner",
  	          locationId: blocker.locationId || "",
  	          locationName: blocker.locationName || "",
  	          rawPoint: insideRaw,
  	          entryPoint: entryAnchor.point,
  	          exitPoint: exitAnchor.point,
  	          previousRawPoint: previousRaw,
  	          nextRawPoint: nextRaw,
  	          route
  	        }]
  	      };
  	    }
  	
  	    function getChildParentRawEdgeAnchors(fromRawPoint, toRawPoint, parentBlocker) {
  	      const from = makeCleanPlotPoint(fromRawPoint);
  	      const to = makeCleanPlotPoint(toRawPoint);
  	
  	      if (
  	        !from ||
  	        !to ||
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return [];
  	      }
  	
  	      return getSegmentIntersectionsForBoundary(
  	        from,
  	        to,
  	        parentBlocker.boundary,
  	        parentBlocker
  	      )
  	      .filter(hit => {
  	        return hit && hit.point &&
  	        hit.t > FREE_GROUND_ROUTE_EPS &&
  	        hit.t < 1 - FREE_GROUND_ROUTE_EPS;
  	      })
  	      .map(hit => makeBoundaryAnchorFromHit(hit, parentBlocker))
  	      .filter(Boolean);
  	    }
  	
  	    function appendChildParentBoundaryWalk(
  	      resolved,
  	      parentBlocker,
  	      fromAnchor,
  	      toAnchor,
  	      headingStart,
  	      headingTarget,
  	      snapSegments,
  	      reason,
  	      routeOuterRing
  	    ) {
  	      if (
  	        !Array.isArray(resolved) ||
  	        !parentBlocker ||
  	        !fromAnchor ||
  	        !toAnchor ||
  	        !fromAnchor.point ||
  	        !toAnchor.point
  	      ) {
  	        return null;
  	      }
  	
  	      if (samePlotPoint(fromAnchor.point, toAnchor.point)) {
  	        pushPlotPoint(resolved, toAnchor.point);
  	        return toAnchor;
  	      }
  	
  	      const routeIntentRing = cleanFreeGroundRing(routeOuterRing || []);
  	
  	      const route = walkBoundaryBetweenAnchors(
  	        parentBlocker,
  	        fromAnchor,
  	        toAnchor,
  	        headingStart,
  	        headingTarget,
  	        {
  	          outerRing: routeIntentRing.length >= 3
  	          ? routeIntentRing: parentBlocker.boundary
  	        }
  	      );
  	
  	      if (Array.isArray(route) && route.length) {
  	        addBoundaryRouteToResolved(resolved, route);
  	      } else {
  	        pushPlotPoint(resolved, toAnchor.point);
  	      }
  	
  	      if (Array.isArray(snapSegments)) {
  	        snapSegments.push({
  	          type: reason || "child-parent-boundary-walk",
  	          locationId: parentBlocker.locationId || "",
  	          locationName: parentBlocker.locationName || "",
  	          fromPoint: fromAnchor.point,
  	          toPoint: toAnchor.point,
  	          rawStartPoint: headingStart,
  	          rawTargetPoint: headingTarget,
  	          route: Array.isArray(route) ? route: []
  	        });
  	      }
  	
  	      return toAnchor;
  	    }
  	
  	    function appendChildSiblingResolvedEdge(
  	      resolved,
  	      anchorState,
  	      targetPoint,
  	      rawHeadingStart,
  	      routeBlockers,
  	      rawIntentRing,
  	      headingPoints,
  	      snapSegments,
  	      isClosing
  	    ) {
  	      const startPoint = Array.isArray(resolved) && resolved.length
  	      ? resolved[resolved.length - 1]: null;
  	
  	      const target = makeCleanPlotPoint(targetPoint);
  	
  	      if (!startPoint || !target) return null;
  	
  	      const edgeResult = resolveFreeGroundEdgeLive(
  	        startPoint,
  	        anchorState && anchorState.anchor ? anchorState.anchor: null,
  	        target,
  	        routeBlockers,
  	        {
  	          isClosing: !!isClosing,
  	          headingStart: rawHeadingStart || startPoint,
  	          outerRing: rawIntentRing
  	        }
  	      );
  	
  	      const edgePoints = Array.isArray(edgeResult.points)
  	      ? edgeResult.points: [];
  	
  	      if (edgePoints.length) {
  	        edgePoints.forEach(point => {
  	          pushPlotPoint(resolved, point);
  	        });
  	      } else {
  	        pushPlotPoint(resolved, target);
  	      }
  	
  	      if (anchorState) {
  	        anchorState.anchor = edgeResult.anchor || null;
  	      }
  	
  	      if (Array.isArray(edgeResult.headingPoints)) {
  	        edgeResult.headingPoints.forEach(point => {
  	          headingPoints.push(point);
  	        });
  	      }
  	
  	      if (Array.isArray(edgeResult.snapSegments)) {
  	        edgeResult.snapSegments.forEach(segment => {
  	          snapSegments.push(segment);
  	        });
  	      }
  	
  	      return edgeResult.anchor || null;
  	    }
  	
  	    function resolveChildFreeGroundSnapDraft(rawPoints, options) {
  	      const childResolverOptions = options && typeof options === "object" ? options: {};
  	      const raw = Array.isArray(rawPoints)
  	      ? rawPoints.filter(point => {
  	        return point && Number.isFinite(Number(point.lat)) && Number.isFinite(Number(point.lng));
  	      }).map(point => {
  	        return {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        };
  	      }): [];
  	
  	      if (!raw.length) {
  	        return {
  	          points: [],
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      const parentBlocker = getChildLocationParentBlocker();
  	
  	      if (
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Child mode has no valid parent boundary. Falling back to raw points.", {
  	          parentLocationId: createState.plotParentLocationId,
  	          parentLocation: createState.plotParentLocation
  	        });
  	
  	        return {
  	          points: raw,
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      const parentBoundary = cleanFreeGroundRing(parentBlocker.boundary);
  	      const siblingBlockers = childResolverOptions.skipSiblingBlockers
  	      ? []: getChildLocationSiblingBlockers(parentBlocker);
  	
  	      // Problem 1 fix:
  	      // Sibling walk-around must use the user's raw child polygon as intent,
  	      // not the parent boundary. The parent is only the container wall.
  	      const rawIntentRing = raw;
  	
  	      const rawCutSiblingIds = buildRawCutBlockerIdLookup(raw, siblingBlockers);
  	
  	      const holeCandidateSiblings = siblingBlockers.filter(blocker => {
  	        const id = safeString(blocker?.locationId);
  	
  	        if (!id) return true;
  	
  	        return !rawCutSiblingIds[id];
  	      });
  	
  	      const rawDonut = raw.length >= 3
  	      ? buildFreeGroundConfirmedDonutHoles(raw,
  	        holeCandidateSiblings): {
  	        holeRings: [],
  	        holeLocations: []
  	      };
  	
  	      const donutHoleIds = Object.create(null);
  	
  	      rawDonut.holeLocations.forEach(hole => {
  	        if (!hole || !hole.locationId) return;
  	        donutHoleIds[safeString(hole.locationId)] = true;
  	      });
  	
  	      const routeBlockers = siblingBlockers.filter(blocker => {
  	        const id = safeString(blocker?.locationId);
  	
  	        if (!id) return true;
  	
  	        if (rawCutSiblingIds[id]) return true;
  	
  	        return !donutHoleIds[id];
  	      });
  	
  	      const resolved = [];
  	      const headingPoints = [];
  	      const snapSegments = [];
  	      const siblingAnchorState = {
  	        anchor: null
  	      };
  	
  	      let parentWallAnchor = null;
  	
  	      const firstRaw = raw[0];
  	      const firstInsideParent = pointInsideOrNearChildParent(firstRaw,
  	        parentBlocker);
  	
  	      if (firstInsideParent) {
  	        pushPlotPoint(resolved, firstRaw);
  	      } else {
  	        const firstAnchor = normalizeAnchorForBlocker(firstRaw, parentBlocker);
  	
  	        if (firstAnchor && firstAnchor.point) {
  	          pushPlotPoint(resolved, firstAnchor.point);
  	          parentWallAnchor = firstAnchor;
  	          headingPoints.push(firstRaw);
  	
  	          snapSegments.push({
  	            type: "child-first-point-snapped-to-parent-boundary",
  	            locationId: parentBlocker.locationId || "",
  	            locationName: parentBlocker.locationName || "",
  	            rawPoint: firstRaw,
  	            boundaryPoint: firstAnchor.point
  	          });
  	        } else {
  	          pushPlotPoint(resolved, firstRaw);
  	        }
  	      }
  	
  	      function processChildRawEdge(previousRawPoint, rawTargetPoint, isClosing) {
  	        const previousRaw = makeCleanPlotPoint(previousRawPoint);
  	        const rawTarget = makeCleanPlotPoint(rawTargetPoint);
  	
  	        if (!previousRaw || !rawTarget) return;
  	
  	        const previousInsideParent = pointInsideOrNearChildParent(previousRaw, parentBlocker);
  	        const targetInsideParent = pointInsideOrNearChildParent(rawTarget, parentBlocker);
  	
  	        const parentHits = getChildParentRawEdgeAnchors(
  	          previousRaw,
  	          rawTarget,
  	          parentBlocker
  	        );
  	
  	        // Normal case: the raw edge stays inside the parent.
  	        // Only siblings need to be avoided.
  	        if (previousInsideParent && targetInsideParent && !parentHits.length) {
  	          appendChildSiblingResolvedEdge(
  	            resolved,
  	            siblingAnchorState,
  	            rawTarget,
  	            previousRaw,
  	            routeBlockers,
  	            rawIntentRing,
  	            headingPoints,
  	            snapSegments,
  	            isClosing
  	          );
  	
  	          parentWallAnchor = null;
  	          return;
  	        }
  	
  	        // Edge leaves the parent.
  	        // IMPORTANT: exit point comes from previousRaw -> rawTarget,
  	        // not from the already-clipped boundary point.
  	        if (previousInsideParent && !targetInsideParent) {
  	          const exitAnchor = parentHits[0] || normalizeAnchorForBlocker(rawTarget, parentBlocker);
  	
  	          if (exitAnchor && exitAnchor.point) {
  	            appendChildSiblingResolvedEdge(
  	              resolved,
  	              siblingAnchorState,
  	              exitAnchor.point,
  	              previousRaw,
  	              routeBlockers,
  	              rawIntentRing,
  	              headingPoints,
  	              snapSegments,
  	              false
  	            );
  	
  	            parentWallAnchor = exitAnchor;
  	            siblingAnchorState.anchor = null;
  	
  	            headingPoints.push(rawTarget);
  	
  	            snapSegments.push({
  	              type: "child-edge-exited-parent-on-raw-line",
  	              locationId: parentBlocker.locationId || "",
  	              locationName: parentBlocker.locationName || "",
  	              rawStartPoint: previousRaw,
  	              rawTargetPoint: rawTarget,
  	              exitPoint: exitAnchor.point
  	            });
  	          }
  	
  	          return;
  	        }
  	
  	        // Edge starts outside and enters the parent.
  	        // Walk the parent wall from the previous exit to the real raw-line entry.
  	        if (!previousInsideParent && targetInsideParent) {
  	          const entryAnchor = parentHits[0] || normalizeAnchorForBlocker(previousRaw, parentBlocker);
  	
  	          if (entryAnchor && entryAnchor.point) {
  	            if (parentWallAnchor && !samePlotPoint(parentWallAnchor.point, entryAnchor.point)) {
  	              appendChildParentBoundaryWalk(
  	                resolved,
  	                parentBlocker,
  	                parentWallAnchor,
  	                entryAnchor,
  	                previousRaw,
  	                rawTarget,
  	                snapSegments,
  	                "child-parent-wall-walk-to-raw-entry",
  	                rawIntentRing
  	              );
  	            } else {
  	              pushPlotPoint(resolved, entryAnchor.point);
  	            }
  	
  	            parentWallAnchor = null;
  	            siblingAnchorState.anchor = null;
  	
  	            appendChildSiblingResolvedEdge(
  	              resolved,
  	              siblingAnchorState,
  	              rawTarget,
  	              entryAnchor.point,
  	              routeBlockers,
  	              rawIntentRing,
  	              headingPoints,
  	              snapSegments,
  	              isClosing
  	            );
  	          }
  	
  	          return;
  	        }
  	
  	        // Edge starts outside and ends outside.
  	        // If the raw line passes through the parent, keep the inside chord.
  	        // Do NOT walk the parent boundary between the two intersections.
  	        if (!previousInsideParent && !targetInsideParent) {
  	          headingPoints.push(rawTarget);
  	
  	          if (!parentHits.length) {
  	            snapSegments.push({
  	              type: "child-raw-edge-outside-parent-skipped",
  	              locationId: parentBlocker.locationId || "",
  	              locationName: parentBlocker.locationName || "",
  	              rawStartPoint: previousRaw,
  	              rawTargetPoint: rawTarget
  	            });
  	
  	            return;
  	          }
  	
  	          const entryAnchor = parentHits[0];
  	          const exitAnchor = parentHits[parentHits.length - 1];
  	
  	          if (!entryAnchor || !entryAnchor.point) {
  	            return;
  	          }
  	
  	          // First connect the previous parent-wall exit to this raw-line entry.
  	          // This is the only place where the parent boundary should be walked.
  	          if (
  	            parentWallAnchor &&
  	            parentWallAnchor.point &&
  	            !samePlotPoint(parentWallAnchor.point, entryAnchor.point)
  	          ) {
  	            appendChildParentBoundaryWalk(
  	              resolved,
  	              parentBlocker,
  	              parentWallAnchor,
  	              entryAnchor,
  	              previousRaw,
  	              rawTarget,
  	              snapSegments,
  	              "child-parent-wall-walk-between-outside-raw-edges",
  	              rawIntentRing
  	            );
  	          } else {
  	            pushPlotPoint(resolved, entryAnchor.point);
  	          }
  	
  	          siblingAnchorState.anchor = null;
  	
  	          // Tangent / single-hit case: no real inside chord exists.
  	          if (
  	            !exitAnchor ||
  	            !exitAnchor.point ||
  	            samePlotPoint(entryAnchor.point, exitAnchor.point)
  	          ) {
  	            parentWallAnchor = entryAnchor;
  	            return;
  	          }
  	
  	          // Now keep the legal inside portion of the user's raw line.
  	          // This is the yellow line in your screenshot.
  	          appendChildSiblingResolvedEdge(
  	            resolved,
  	            siblingAnchorState,
  	            exitAnchor.point,
  	            previousRaw,
  	            routeBlockers,
  	            rawIntentRing,
  	            headingPoints,
  	            snapSegments,
  	            false
  	          );
  	
  	          snapSegments.push({
  	            type: "child-parent-raw-line-inside-chord",
  	            locationId: parentBlocker.locationId || "",
  	            locationName: parentBlocker.locationName || "",
  	            rawStartPoint: previousRaw,
  	            rawTargetPoint: rawTarget,
  	            entryPoint: entryAnchor.point,
  	            exitPoint: exitAnchor.point
  	          });
  	
  	          parentWallAnchor = exitAnchor;
  	          siblingAnchorState.anchor = null;
  	
  	          return;
  	        }
  	
  	        // Both points are inside, but the raw edge still crossed the parent boundary.
  	        // This can happen around concave parent edges. Use true raw-line parent intersections.
  	        if (previousInsideParent && targetInsideParent && parentHits.length >= 2) {
  	          const exitAnchor = parentHits[0];
  	          const entryAnchor = parentHits[parentHits.length - 1];
  	
  	          appendChildSiblingResolvedEdge(
  	            resolved,
  	            siblingAnchorState,
  	            exitAnchor.point,
  	            previousRaw,
  	            routeBlockers,
  	            rawIntentRing,
  	            headingPoints,
  	            snapSegments,
  	            false
  	          );
  	
  	          appendChildParentBoundaryWalk(
  	            resolved,
  	            parentBlocker,
  	            exitAnchor,
  	            entryAnchor,
  	            previousRaw,
  	            rawTarget,
  	            snapSegments,
  	            "child-parent-wall-walk-across-concave-outside-section",
  	            rawIntentRing
  	          );
  	
  	          siblingAnchorState.anchor = null;
  	          parentWallAnchor = null;
  	
  	          appendChildSiblingResolvedEdge(
  	            resolved,
  	            siblingAnchorState,
  	            rawTarget,
  	            entryAnchor.point,
  	            routeBlockers,
  	            rawIntentRing,
  	            headingPoints,
  	            snapSegments,
  	            isClosing
  	          );
  	        }
  	      }
  	
  	      for (let i = 1; i < raw.length; i++) {
  	        processChildRawEdge(raw[i - 1], raw[i], false);
  	      }
  	
  	      if (raw.length >= 3) {
  	        processChildRawEdge(raw[raw.length - 1], raw[0], true);
  	      }
  	
  	      const resolvedDonut = buildFreeGroundConfirmedDonutHoles(
  	        resolved,
  	        holeCandidateSiblings
  	      );
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Child Location resolver complete:", {
  	        parentLocationId: parentBlocker.locationId,
  	        parentLocationName: parentBlocker.locationName,
  	        siblingBlockerCount: siblingBlockers.length,
  	        rawPoints: raw.length,
  	        resolvedPoints: resolved.length,
  	        holeCount: resolvedDonut.holeRings.length,
  	        snapSegments
  	      });
  	
  	      return {
  	        points: resolved,
  	        headingPoints,
  	        snapSegments,
  	        holeRings: resolvedDonut.holeRings || [],
  	        holeLocations: resolvedDonut.holeLocations || []
  	      };
  	    }
  	
  	    function getPivotRawPointAtPath(raw, pathT) {
  	      const ring = cleanFreeGroundRing(raw);
  	      const n = ring.length;
  	
  	      if (!n) return null;
  	
  	      let t = Number(pathT) || 0;
  	
  	      while (t < 0) t += n;
  	      while (t >= n) t -= n;
  	
  	      const index = Math.floor(t) % n;
  	      const localT = t - Math.floor(t);
  	      const a = ring[index];
  	      const b = ring[(index + 1) % n];
  	
  	      return interpolatePlotPoint(a, b, localT);
  	    }
  	
  	    function getPivotAbsolutePointAtPath(raw, pathT) {
  	      const ring = cleanFreeGroundRing(raw);
  	      const n = ring.length;
  	
  	      if (!n) return null;
  	
  	      const t = Number(pathT) || 0;
  	      const index = Math.floor(t);
  	      const localT = t - index;
  	      const a = ring[((index % n) + n) % n];
  	      const b = ring[(((index + 1) % n) + n) % n];
  	
  	      return interpolatePlotPoint(a, b, localT);
  	    }
  	
  	    function normalizePivotPathT(pathT, ringLength) {
  	      const n = Number(ringLength) || 0;
  	
  	      if (!n) return 0;
  	
  	      let t = Number(pathT) || 0;
  	
  	      while (t < 0) t += n;
  	      while (t >= n) t -= n;
  	
  	      if (Math.abs(t - n) < FREE_GROUND_ROUTE_EPS) return 0;
  	
  	      return t;
  	    }
  	
  	    function pivotPathTInsideRun(pathT, run, ringLength) {
  	      const n = Number(ringLength) || 0;
  	
  	      if (!n || !run) return false;
  	
  	      let t = Number(pathT) || 0;
  	      let entry = Number(run.entryPathT);
  	      let exit = Number(run.exitPathT);
  	
  	      if (!Number.isFinite(entry) || !Number.isFinite(exit)) return false;
  	
  	      if (exit < entry) exit += n;
  	
  	      while (t < entry) t += n;
  	
  	      return t > entry + FREE_GROUND_ROUTE_EPS && t < exit - FREE_GROUND_ROUTE_EPS;
  	    }
  	
  	    function getPivotBoundaryRunsForBlocker(raw, blocker) {
  	      const ring = cleanFreeGroundRing(raw);
  	      const n = ring.length;
  	
  	      if (
  	        n < 3 ||
  	        !blocker ||
  	        !Array.isArray(blocker.boundary) ||
  	        blocker.boundary.length < 3
  	      ) {
  	        return [];
  	      }
  	
  	      const events = [];
  	
  	      for (let i = 0; i < n; i++) {
  	        const a = ring[i];
  	        const b = ring[(i + 1) % n];
  	
  	        const hits = getSegmentIntersectionsForBoundary(
  	          a,
  	          b,
  	          blocker.boundary,
  	          blocker
  	        );
  	
  	        hits.forEach(hit => {
  	          if (!hit || !hit.point) return;
  	
  	          const hitT = Math.max(0, Math.min(1, Number(hit.t) || 0));
  	          const pathT = normalizePivotPathT(i + hitT, n);
  	
  	          const duplicate = events.some(existing => {
  	            return (
  	              Math.abs(Number(existing.pathT) - pathT) < FREE_GROUND_ROUTE_EPS ||
  	              samePlotPoint(existing.point, hit.point)
  	            );
  	          });
  	
  	          if (duplicate) return;
  	
  	          const anchor = makeBoundaryAnchorFromHit(hit, blocker);
  	
  	          if (!anchor) return;
  	
  	          events.push({
  	            pathT,
  	            point: hit.point,
  	            anchor,
  	            blocker
  	          });
  	        });
  	      }
  	
  	      events.sort((a, b) => a.pathT - b.pathT);
  	
  	      if (events.length < 2) return [];
  	
  	      const runs = [];
  	
  	      for (let i = 0; i < events.length; i++) {
  	        const entry = events[i];
  	        const exit = events[(i + 1) % events.length];
  	
  	        const entryPathT = Number(entry.pathT);
  	        let exitPathT = Number(exit.pathT);
  	
  	        if (i === events.length - 1 || exitPathT <= entryPathT + FREE_GROUND_ROUTE_EPS) {
  	          exitPathT += n;
  	        }
  	
  	        if (exitPathT - entryPathT <= FREE_GROUND_ROUTE_EPS) continue;
  	
  	        const midPathT = entryPathT + ((exitPathT - entryPathT) / 2);
  	        const midPoint = getPivotRawPointAtPath(ring, midPathT);
  	
  	        // Only replace the arc if the circle arc between these two real
  	        // intersection points is inside the old Location blocker.
  	        if (!midPoint || !pointInStrictPlotBoundary(midPoint, blocker.boundary)) {
  	          continue;
  	        }
  	
  	        if (!entry.anchor || !exit.anchor) continue;
  	        if (samePlotPoint(entry.anchor.point, exit.anchor.point)) continue;
  	
  	        runs.push({
  	          blocker,
  	          entryPathT,
  	          exitPathT,
  	          entryAnchor: entry.anchor,
  	          exitAnchor: exit.anchor
  	        });
  	      }
  	
  	      return runs;
  	    }
  	
  	    function getPivotBoundaryRuns(raw, blockers) {
  	      const ring = cleanFreeGroundRing(raw);
  	      const n = ring.length;
  	      const list = Array.isArray(blockers) ? blockers: [];
  	      const runs = [];
  	
  	      if (n < 3) return runs;
  	
  	      list.forEach(blocker => {
  	        getPivotBoundaryRunsForBlocker(ring, blocker).forEach(run => {
  	          runs.push(run);
  	        });
  	      });
  	
  	      runs.sort((a, b) => {
  	        if (a.entryPathT < b.entryPathT) return -1;
  	        if (a.entryPathT > b.entryPathT) return 1;
  	        if (a.exitPathT < b.exitPathT) return -1;
  	        if (a.exitPathT > b.exitPathT) return 1;
  	
  	        return String(a.blocker?.locationId || "").localeCompare(
  	          String(b.blocker?.locationId || "")
  	        );
  	      });
  	
  	      return runs;
  	    }
  	
  	    function getPivotParentBoundaryRunsForBlocker(raw,
  	      parentBlocker) {
  	      const ring = cleanFreeGroundRing(raw);
  	      const n = ring.length;
  	
  	      if (
  	        n < 3 ||
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return [];
  	      }
  	
  	      const events = [];
  	
  	      for (let i = 0; i < n; i++) {
  	        const a = ring[i];
  	        const b = ring[(i + 1) % n];
  	
  	        const hits = getSegmentIntersectionsForBoundary(
  	          a,
  	          b,
  	          parentBlocker.boundary,
  	          parentBlocker
  	        );
  	
  	        hits.forEach(hit => {
  	          if (!hit || !hit.point) return;
  	
  	          const hitT = Math.max(0, Math.min(1, Number(hit.t) || 0));
  	          const pathT = normalizePivotPathT(i + hitT, n);
  	
  	          const duplicate = events.some(existing => {
  	            return (
  	              Math.abs(Number(existing.pathT) - pathT) < FREE_GROUND_ROUTE_EPS ||
  	              samePlotPoint(existing.point, hit.point)
  	            );
  	          });
  	
  	          if (duplicate) return;
  	
  	          const anchor = makeBoundaryAnchorFromHit(hit, parentBlocker);
  	
  	          if (!anchor) return;
  	
  	          events.push({
  	            pathT,
  	            point: hit.point,
  	            anchor,
  	            blocker: parentBlocker
  	          });
  	        });
  	      }
  	
  	      events.sort((a, b) => a.pathT - b.pathT);
  	
  	      if (events.length < 2) return [];
  	
  	      const runs = [];
  	
  	      for (let i = 0; i < events.length; i++) {
  	        const entry = events[i];
  	        const exit = events[(i + 1) % events.length];
  	
  	        const entryPathT = Number(entry.pathT);
  	        let exitPathT = Number(exit.pathT);
  	
  	        if (i === events.length - 1 || exitPathT <= entryPathT + FREE_GROUND_ROUTE_EPS) {
  	          exitPathT += n;
  	        }
  	
  	        if (exitPathT - entryPathT <= FREE_GROUND_ROUTE_EPS) continue;
  	
  	        const midPathT = entryPathT + ((exitPathT - entryPathT) / 2);
  	        const midPoint = getPivotRawPointAtPath(ring, midPathT);
  	
  	        // Parent boundary is a container.
  	        // For the parent, the illegal generated arc is OUTSIDE the parent.
  	        // This is the opposite of sibling blockers, where the illegal arc is INSIDE.
  	        if (!midPoint || pointInsideOrNearChildParent(midPoint, parentBlocker)) {
  	          continue;
  	        }
  	
  	        if (!entry.anchor || !exit.anchor) continue;
  	        if (samePlotPoint(entry.anchor.point, exit.anchor.point)) continue;
  	
  	        runs.push({
  	          blocker: parentBlocker,
  	          entryPathT,
  	          exitPathT,
  	          entryAnchor: entry.anchor,
  	          exitAnchor: exit.anchor
  	        });
  	      }
  	
  	      return runs;
  	    }
  	
  	    function getPivotParentBoundaryRuns(raw, parentBlocker) {
  	      const ring = cleanFreeGroundRing(raw);
  	
  	      if (
  	        ring.length < 3 ||
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return [];
  	      }
  	
  	      const runs = getPivotParentBoundaryRunsForBlocker(ring, parentBlocker);
  	
  	      runs.sort((a, b) => {
  	        if (a.entryPathT < b.entryPathT) return -1;
  	        if (a.entryPathT > b.entryPathT) return 1;
  	        if (a.exitPathT < b.exitPathT) return -1;
  	        if (a.exitPathT > b.exitPathT) return 1;
  	
  	        return String(a.blocker?.locationId || "").localeCompare(
  	          String(b.blocker?.locationId || "")
  	        );
  	      });
  	
  	      return runs;
  	    }
  	
  	    function getGeneratedChildParentStartPathT(raw,
  	      parentBlocker,
  	      runs) {
  	      const ring = cleanFreeGroundRing(raw);
  	      const n = ring.length;
  	      const runList = Array.isArray(runs) ? runs: [];
  	
  	      if (!n) return 0;
  	
  	      for (let i = 0; i < n; i++) {
  	        const point = ring[i];
  	
  	        if (!pointInsideOrNearChildParent(point, parentBlocker)) {
  	          continue;
  	        }
  	
  	        const insideIllegalParentRun = runList.some(run => {
  	          return pivotPathTInsideRun(i, run, n);
  	        });
  	
  	        if (!insideIllegalParentRun) return i;
  	      }
  	
  	      return 0;
  	    }
  	
  	    function resolveGeneratedChildParentBoundaryPass(rawPoints, parentBlocker) {
  	      const raw = cleanFreeGroundRing(rawPoints);
  	
  	      if (!raw.length) {
  	        return {
  	          points: [],
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      if (raw.length < 3) {
  	        return {
  	          points: raw,
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      if (
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return {
  	          points: raw,
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      const parentRuns = getPivotParentBoundaryRuns(raw, parentBlocker);
  	
  	      if (!parentRuns.length) {
  	        if (generatedChildPointsStayInsideParent(raw, parentBlocker)) {
  	          return {
  	            points: raw,
  	            headingPoints: [],
  	            snapSegments: [],
  	            holeRings: [],
  	            holeLocations: []
  	          };
  	        }
  	
  	        // Last-resort fallback only.
  	        // This should rarely run now, but keeps the app safe if a strange parent shape
  	        // has no clean intersection pair.
  	        return resolveChildFreeGroundSnapDraft(raw, {
  	          skipSiblingBlockers: true,
  	          generatedChildParentPass: true,
  	          source: "generated-child-parent-fallback"
  	        });
  	      }
  	
  	      const n = raw.length;
  	      const startPathT = getGeneratedChildParentStartPathT(raw, parentBlocker, parentRuns);
  	
  	      const normalizedRuns = parentRuns
  	      .map(run => normalizePivotBoundaryRun(run, startPathT, n))
  	      .filter(Boolean)
  	      .sort((a, b) => a.normalizedEntry - b.normalizedEntry);
  	
  	      const cleanRuns = [];
  	
  	      normalizedRuns.forEach(run => {
  	        const last = cleanRuns.length ? cleanRuns[cleanRuns.length - 1]: null;
  	
  	        if (last && run.normalizedEntry < last.normalizedExit - FREE_GROUND_ROUTE_EPS) {
  	          return;
  	        }
  	
  	        cleanRuns.push(run);
  	      });
  	
  	      const resolved = [];
  	      const snapSegments = [];
  	      let cursor = 0;
  	
  	      cleanRuns.forEach(run => {
  	        const entryAbsT = startPathT + run.normalizedEntry;
  	        const exitAbsT = startPathT + run.normalizedExit;
  	
  	        appendPivotRawArc(
  	          resolved,
  	          raw,
  	          startPathT + cursor,
  	          entryAbsT
  	        );
  	
  	        const route = walkBoundaryBetweenAnchors(
  	          parentBlocker,
  	          run.entryAnchor,
  	          run.exitAnchor,
  	          run.entryAnchor.point,
  	          run.exitAnchor.point,
  	          {
  	            outerRing: raw
  	          }
  	        );
  	
  	        if (Array.isArray(route) && route.length) {
  	          addBoundaryRouteToResolved(resolved, route);
  	        } else {
  	          pushPlotPoint(resolved, run.entryAnchor.point);
  	          pushPlotPoint(resolved, run.exitAnchor.point);
  	        }
  	
  	        snapSegments.push({
  	          type: "generated-child-parent-boundary-run",
  	          locationId: parentBlocker?.locationId || "",
  	          locationName: parentBlocker?.locationName || "",
  	          entryPoint: run.entryAnchor.point,
  	          exitPoint: run.exitAnchor.point,
  	          route: Array.isArray(route) ? route: []
  	        });
  	
  	        cursor = Math.max(cursor, run.normalizedExit);
  	      });
  	
  	      appendPivotRawArc(
  	        resolved,
  	        raw,
  	        startPathT + cursor,
  	        startPathT + n
  	      );
  	
  	      if (resolved.length < 3) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Child Generated Wizard] Grouped parent pass produced too few points. Falling back to child resolver.", {
  	          parentLocationId: parentBlocker?.locationId,
  	          parentLocationName: parentBlocker?.locationName,
  	          rawPoints: raw.length,
  	          parentRuns: cleanRuns.length
  	        });
  	
  	        return resolveChildFreeGroundSnapDraft(raw, {
  	          skipSiblingBlockers: true,
  	          generatedChildParentPass: true,
  	          source: "generated-child-parent-fallback-too-few-points"
  	        });
  	      }
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Child Generated Wizard] Grouped parent boundary pass complete:", {
  	        parentLocationId: parentBlocker?.locationId,
  	        parentLocationName: parentBlocker?.locationName,
  	        rawPoints: raw.length,
  	        resolvedPoints: resolved.length,
  	        parentRuns: cleanRuns.length,
  	        snapSegments
  	      });
  	
  	      return {
  	        points: resolved,
  	        headingPoints: [],
  	        snapSegments,
  	        holeRings: [],
  	        holeLocations: []
  	      };
  	    }
  	
  	    function getPivotStartPathT(raw,
  	      routeBlockers,
  	      runs) {
  	      const ring = cleanFreeGroundRing(raw);
  	      const n = ring.length;
  	      const blockers = Array.isArray(routeBlockers) ? routeBlockers: [];
  	      const runList = Array.isArray(runs) ? runs: [];
  	
  	      if (!n) return 0;
  	
  	      for (let i = 0; i < n; i++) {
  	        const point = ring[i];
  	
  	        const insideBlocker = blockers.some(blocker => {
  	          return (
  	            blocker &&
  	            Array.isArray(blocker.boundary) &&
  	            pointInStrictPlotBoundary(point, blocker.boundary)
  	          );
  	        });
  	
  	        if (insideBlocker) continue;
  	
  	        const insideRun = runList.some(run => {
  	          return pivotPathTInsideRun(i, run, n);
  	        });
  	
  	        if (!insideRun) return i;
  	      }
  	
  	      return 0;
  	    }
  	
  	    function normalizePivotBoundaryRun(run, startPathT, ringLength) {
  	      const n = Number(ringLength) || 0;
  	
  	      if (!run || !n) return null;
  	
  	      let entry = Number(run.entryPathT);
  	      let exit = Number(run.exitPathT);
  	
  	      if (!Number.isFinite(entry) || !Number.isFinite(exit)) return null;
  	
  	      if (exit < entry) exit += n;
  	
  	      let normalizedEntry = entry - startPathT;
  	
  	      while (normalizedEntry < 0) {
  	        normalizedEntry += n;
  	        exit += n;
  	      }
  	
  	      while (normalizedEntry >= n) {
  	        normalizedEntry -= n;
  	        exit -= n;
  	      }
  	
  	      let normalizedExit = exit - startPathT;
  	
  	      while (normalizedExit <= normalizedEntry + FREE_GROUND_ROUTE_EPS) {
  	        normalizedExit += n;
  	      }
  	
  	      if (normalizedEntry >= n - FREE_GROUND_ROUTE_EPS) return null;
  	
  	      return Object.assign({}, run, {
  	        normalizedEntry,
  	        normalizedExit
  	      });
  	    }
  	
  	    function appendPivotRawArc(resolved, raw, startAbsT, endAbsT) {
  	      const ring = cleanFreeGroundRing(raw);
  	      const n = ring.length;
  	
  	      if (!Array.isArray(resolved) || n < 3) return;
  	
  	      const from = Number(startAbsT);
  	      const to = Number(endAbsT);
  	
  	      if (!Number.isFinite(from) || !Number.isFinite(to)) return;
  	      if (to < from + FREE_GROUND_ROUTE_EPS) return;
  	
  	      const startPoint = getPivotAbsolutePointAtPath(ring, from);
  	
  	      if (startPoint) {
  	        pushPlotPoint(resolved, startPoint);
  	      }
  	
  	      let nextVertex = Math.floor(from) + 1;
  	
  	      while (nextVertex < to - FREE_GROUND_ROUTE_EPS) {
  	        const vertex = ring[((nextVertex % n) + n) % n];
  	
  	        if (vertex) {
  	          pushPlotPoint(resolved, vertex);
  	        }
  	
  	        nextVertex++;
  	
  	        if (nextVertex > from + n + 2) break;
  	      }
  	
  	      const endPoint = getPivotAbsolutePointAtPath(ring, to);
  	
  	      if (endPoint) {
  	        pushPlotPoint(resolved, endPoint);
  	      }
  	    }
  	
  	    function resolvePivotFreeGroundSnapDraft(rawPoints, options) {
  	      const resolverOptions = options && typeof options === "object" ? options: {};
  	      const raw = cleanFreeGroundRing(rawPoints);
  	
  	      if (!raw.length) {
  	        return {
  	          points: [],
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      if (raw.length < 3) {
  	        return {
  	          points: raw,
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      const blockers = Array.isArray(resolverOptions.blockers)
  	      ? resolverOptions.blockers: (
  	        typeof getTopLevelFreeGroundBlockers === "function"
  	        ? getTopLevelFreeGroundBlockers(): getFreeGroundBlockers()
  	      );
  	      const rawCutBlockerIds = buildRawCutBlockerIdLookup(raw, blockers);
  	
  	      const holeCandidateBlockers = blockers.filter(blocker => {
  	        const id = String(blocker?.locationId || "");
  	
  	        if (!id) return true;
  	
  	        return !rawCutBlockerIds[id];
  	      });
  	
  	      const rawDonut = buildFreeGroundConfirmedDonutHoles(raw,
  	        holeCandidateBlockers);
  	      const donutHoleIds = Object.create(null);
  	
  	      rawDonut.holeLocations.forEach(hole => {
  	        if (!hole || !hole.locationId) return;
  	
  	        donutHoleIds[String(hole.locationId)] = true;
  	      });
  	
  	      const routeBlockers = blockers.filter(blocker => {
  	        const id = String(blocker?.locationId || "");
  	
  	        if (!id) return true;
  	        if (rawCutBlockerIds[id]) return true;
  	
  	        return !donutHoleIds[id];
  	      });
  	
  	      const allRuns = getPivotBoundaryRuns(raw,
  	        routeBlockers);
  	
  	      if (!allRuns.length) {
  	        const donut = buildFreeGroundConfirmedDonutHoles(raw, holeCandidateBlockers);
  	
  	        return {
  	          points: raw,
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: donut.holeRings,
  	          holeLocations: donut.holeLocations
  	        };
  	      }
  	
  	      const n = raw.length;
  	      const startPathT = getPivotStartPathT(raw, routeBlockers, allRuns);
  	
  	      const normalizedRuns = allRuns
  	      .map(run => normalizePivotBoundaryRun(run, startPathT, n))
  	      .filter(Boolean)
  	      .sort((a, b) => a.normalizedEntry - b.normalizedEntry);
  	
  	      const cleanRuns = [];
  	
  	      normalizedRuns.forEach(run => {
  	        const last = cleanRuns.length ? cleanRuns[cleanRuns.length - 1]: null;
  	
  	        if (last && run.normalizedEntry < last.normalizedExit - FREE_GROUND_ROUTE_EPS) {
  	          return;
  	        }
  	
  	        cleanRuns.push(run);
  	      });
  	
  	      const resolved = [];
  	      const snapSegments = [];
  	      let cursor = 0;
  	
  	      cleanRuns.forEach(run => {
  	        const entryAbsT = startPathT + run.normalizedEntry;
  	        const exitAbsT = startPathT + run.normalizedExit;
  	
  	        appendPivotRawArc(
  	          resolved,
  	          raw,
  	          startPathT + cursor,
  	          entryAbsT
  	        );
  	
  	        const route = walkBoundaryBetweenAnchors(
  	          run.blocker,
  	          run.entryAnchor,
  	          run.exitAnchor,
  	          run.entryAnchor.point,
  	          run.exitAnchor.point,
  	          {
  	            outerRing: raw
  	          }
  	        );
  	
  	        if (Array.isArray(route) && route.length) {
  	          addBoundaryRouteToResolved(resolved, route);
  	        } else {
  	          pushPlotPoint(resolved, run.entryAnchor.point);
  	          pushPlotPoint(resolved, run.exitAnchor.point);
  	        }
  	
  	        snapSegments.push({
  	          type: "pivot-boundary-intersection-run",
  	          locationId: run.blocker?.locationId || "",
  	          locationName: run.blocker?.locationName || "",
  	          entryPoint: run.entryAnchor.point,
  	          exitPoint: run.exitAnchor.point,
  	          route: Array.isArray(route) ? route: []
  	        });
  	
  	        cursor = Math.max(cursor, run.normalizedExit);
  	      });
  	
  	      appendPivotRawArc(
  	        resolved,
  	        raw,
  	        startPathT + cursor,
  	        startPathT + n
  	      );
  	
  	      const resolvedDonut = buildFreeGroundConfirmedDonutHoles(
  	        resolved,
  	        holeCandidateBlockers
  	      );
  	
  	      const donut = {
  	        holeRings: [],
  	        holeLocations: []
  	      };
  	
  	      const donutSeen = Object.create(null);
  	
  	      function addPivotDonutResult(result) {
  	        if (!result || !Array.isArray(result.holeLocations)) return;
  	
  	        result.holeLocations.forEach((hole, index) => {
  	          const id = String(hole?.locationId || "");
  	
  	          if (!id || donutSeen[id]) return;
  	
  	          const ring = Array.isArray(result.holeRings)
  	          ? result.holeRings[index]: hole.points;
  	
  	          if (!Array.isArray(ring) || ring.length < 3) return;
  	
  	          donutSeen[id] = true;
  	          donut.holeRings.push(ring);
  	          donut.holeLocations.push(hole);
  	        });
  	      }
  	
  	      addPivotDonutResult(rawDonut);
  	      addPivotDonutResult(resolvedDonut);
  	
  	      donut.holeLocations.forEach(hole => {
  	        snapSegments.push({
  	          type: "pivot-donut-hole-created",
  	          locationId: hole.locationId,
  	          locationName: hole.locationName,
  	          points: hole.points
  	        });
  	      });
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Pivot Wizard] Pivot grouped boundary resolver complete:",
  	        {
  	          rawPoints: raw.length,
  	          resolvedPoints: resolved.length,
  	          boundaryRuns: cleanRuns.length,
  	          holeCount: donut.holeRings.length,
  	          snapSegments
  	        });
  	
  	      return {
  	        points: resolved,
  	        headingPoints: [],
  	        snapSegments,
  	        holeRings: donut.holeRings,
  	        holeLocations: donut.holeLocations
  	      };
  	    }
  	
  	    function combineGeneratedChildHoleResults(results) {
  	      const combined = {
  	        holeRings: [],
  	        holeLocations: []
  	      };
  	
  	      const seen = Object.create(null);
  	      const list = Array.isArray(results) ? results: [];
  	
  	      list.forEach(result => {
  	        if (!result || !Array.isArray(result.holeLocations)) return;
  	
  	        result.holeLocations.forEach((hole, index) => {
  	          const id = safeString(hole?.locationId || hole?.id || index).trim();
  	
  	          if (!id || seen[id]) return;
  	
  	          const ring = Array.isArray(result.holeRings)
  	          ? result.holeRings[index]: hole?.points;
  	
  	          if (!Array.isArray(ring) || ring.length < 3) return;
  	
  	          seen[id] = true;
  	          combined.holeRings.push(ring);
  	          combined.holeLocations.push(hole);
  	        });
  	      });
  	
  	      return pruneNestedHoleResult(combined);
  	    }
  	
  	    function generatedChildPointsStayInsideParent(points, parentBlocker) {
  	      const list = Array.isArray(points) ? points: [];
  	
  	      if (
  	        !list.length ||
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        return false;
  	      }
  	
  	      return list.every(point => {
  	        return pointInsideOrNearChildParent(point, parentBlocker);
  	      });
  	    }
  	
  	    function resolveGeneratedChildFreeGroundSnapDraft(rawPoints) {
  	      const raw = Array.isArray(rawPoints)
  	      ? rawPoints.filter(point => {
  	        return point && Number.isFinite(Number(point.lat)) && Number.isFinite(Number(point.lng));
  	      }).map(point => {
  	        return {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        };
  	      }): [];
  	
  	      if (!raw.length) {
  	        return {
  	          points: [],
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      const parentBlocker = getChildLocationParentBlocker();
  	
  	      if (
  	        !parentBlocker ||
  	        !Array.isArray(parentBlocker.boundary) ||
  	        parentBlocker.boundary.length < 3
  	      ) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Child Generated Wizard] Child generated mode has no valid parent boundary. Falling back to raw generated points.", {
  	          parentLocationId: createState.plotParentLocationId,
  	          parentLocation: createState.plotParentLocation,
  	          raw
  	        });
  	
  	        return {
  	          points: raw,
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      const siblingBlockers = getChildLocationSiblingBlockers(parentBlocker);
  	
  	      // First pass:
  	      // For generated child Pivot/Ring/Wedge/Segment, sibling cuts must use
  	      // real raw-shape/sibling intersections, not point-by-point child polygon walking.
  	      const siblingResolved = resolvePivotFreeGroundSnapDraft(raw, {
  	        blockers: siblingBlockers,
  	        source: "child-generated-sibling-grouped-pass"
  	      });
  	
  	      const siblingPoints = Array.isArray(siblingResolved?.points) && siblingResolved.points.length
  	      ? siblingResolved.points: raw;
  	
  	      const needsParentPass = !generatedChildPointsStayInsideParent(
  	        siblingPoints,
  	        parentBlocker
  	      );
  	
  	      // Second pass:
  	      // Only clip/walk against the parent boundary if the sibling-resolved
  	      // generated shape actually leaves the parent. If it already stays inside,
  	      // do not re-process it, because that can create tiny stitch artifacts
  	      // at sibling entry/exit intersections.
  	      const parentResolved = needsParentPass
  	      ? resolveGeneratedChildParentBoundaryPass(
  	        siblingPoints,
  	        parentBlocker
  	      ): {
  	        points: siblingPoints,
  	        headingPoints: [],
  	        snapSegments: [],
  	        holeRings: [],
  	        holeLocations: []
  	      };
  	
  	      const holes = combineGeneratedChildHoleResults([
  	        siblingResolved,
  	        parentResolved
  	      ]);
  	
  	      const snapSegments = [];
  	
  	      if (Array.isArray(siblingResolved?.snapSegments)) {
  	        siblingResolved.snapSegments.forEach(segment => {
  	          snapSegments.push(Object.assign({}, segment, {
  	            childGeneratedPass: "siblings"
  	          }));
  	        });
  	      }
  	
  	      if (Array.isArray(parentResolved?.snapSegments)) {
  	        parentResolved.snapSegments.forEach(segment => {
  	          snapSegments.push(Object.assign({}, segment, {
  	            childGeneratedPass: "parent"
  	          }));
  	        });
  	      }
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Child Generated Wizard] Generated child resolved with grouped sibling pass and parent-only pass:", {
  	        creationMode: createState.creationMode,
  	        childShapeMode: createState.childShapeMode,
  	        parentLocationId: createState.plotParentLocationId,
  	        rawPoints: raw.length,
  	        siblingResolvedPoints: siblingPoints.length,
  	        needsParentPass,
  	        finalResolvedPoints: Array.isArray(parentResolved?.points) ? parentResolved.points.length: 0,
  	        siblingBlockers: siblingBlockers.map(blocker => {
  	          return {
  	            locationId: blocker.locationId,
  	            locationName: blocker.locationName
  	          };
  	        }),
  	        snapSegments
  	      });
  	
  	      return {
  	        points: Array.isArray(parentResolved?.points) ? parentResolved.points: siblingPoints,
  	        headingPoints: [],
  	        snapSegments,
  	        holeRings: holes.holeRings,
  	        holeLocations: holes.holeLocations
  	      };
  	    }
  	
  	    function resolveFreeGroundSnapDraft(rawPoints) {
  	      const raw = Array.isArray(rawPoints)
  	      ? rawPoints.filter(point => {
  	        return point && Number.isFinite(Number(point.lat)) && Number.isFinite(Number(point.lng));
  	      }).map(point => {
  	        return {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        };
  	      }): [];
  	
  	      if (createState.plotMode === "child-location") {
  	        if (isGeneratedCreationMode()) {
  	          return resolveGeneratedChildFreeGroundSnapDraft(raw);
  	        }
  	
  	        return resolveChildFreeGroundSnapDraft(raw);
  	      }
  	
  	      if (!raw.length) {
  	        return {
  	          points: [],
  	          headingPoints: [],
  	          snapSegments: [],
  	          holeRings: [],
  	          holeLocations: []
  	        };
  	      }
  	
  	      if (
  	        createState.creationMode === "pivot" ||
  	        createState.creationMode === "wedge"
  	      ) {
  	        return resolvePivotFreeGroundSnapDraft(raw);
  	      }
  	
  	      // Top-level Free Ground resolves only against top-level saved Locations.
  	      // Children, nephews, grandchildren, and deeper descendants must not become
  	      // blockers or donut holes at this level.
  	      const blockers = typeof getTopLevelFreeGroundBlockers === "function"
  	      ? getTopLevelFreeGroundBlockers(): getFreeGroundBlockers();
  	
  	      const rawCutBlockerIds = buildRawCutBlockerIdLookup(raw, blockers);
  	
  	      const holeCandidateBlockers = blockers.filter(blocker => {
  	        const id = String(blocker?.locationId || "");
  	
  	        if (!id) return true;
  	
  	        // If the user's raw ring cuts this Location, it must remain a blocker.
  	        // It is not allowed to become a donut hole yet.
  	        return !rawCutBlockerIds[id];
  	      });
  	
  	      const rawDonut = raw.length >= 3
  	      ? buildFreeGroundConfirmedDonutHoles(raw,
  	        holeCandidateBlockers): {
  	        holeRings: [],
  	        holeLocations: []
  	      };
  	      const donutHoleIds = Object.create(null);
  	
  	      rawDonut.holeLocations.forEach(hole => {
  	        if (!hole || !hole.locationId) return;
  	        donutHoleIds[String(hole.locationId)] = true;
  	      });
  	
  	      // Important:
  	      // If an old Location is fully inside the user's raw outer ring,
  	      // it is a donut hole, not a routing blocker.
  	      const routeBlockers = blockers.filter(blocker => {
  	        const id = String(blocker?.locationId || "");
  	
  	        if (!id) return true;
  	
  	        // Raw-cut blockers must stay active so the boundary walk can happen.
  	        if (rawCutBlockerIds[id]) return true;
  	
  	        return !donutHoleIds[id];
  	      });
  	
  	      const resolved = [];
  	      const headingPoints = [];
  	      const snapSegments = [];
  	
  	      const firstSnap = getBoundarySnapForPoint(raw[0],
  	        routeBlockers,
  	        {
  	          snapInside: true,
  	          snapNearBoundary: true
  	        });
  	
  	      let firstAnchor = null;
  	      let currentAnchor = null;
  	
  	      if (firstSnap && firstSnap.point && firstSnap.anchor) {
  	        pushPlotPoint(resolved, firstSnap.point);
  	        firstAnchor = firstSnap.anchor;
  	        currentAnchor = firstSnap.anchor;
  	
  	        if (!samePlotPoint(raw[0], firstSnap.point)) {
  	          headingPoints.push(raw[0]);
  	        }
  	
  	        snapSegments.push({
  	          type: "first-point-snapped-to-boundary",
  	          locationId: firstSnap.anchor.locationId || "",
  	          locationName: firstSnap.anchor.locationName || "",
  	          rawPoint: raw[0],
  	          boundaryPoint: firstSnap.point,
  	          reason: firstSnap.reason
  	        });
  	      } else {
  	        pushPlotPoint(resolved, raw[0]);
  	
  	        const firstNearBoundary = getBoundarySnapForPoint(raw[0], routeBlockers, {
  	          snapInside: false,
  	          snapNearBoundary: true
  	        });
  	
  	        if (firstNearBoundary && samePlotPoint(firstNearBoundary.point, raw[0])) {
  	          firstAnchor = firstNearBoundary.anchor;
  	          currentAnchor = firstNearBoundary.anchor;
  	        }
  	      }
  	
  	      for (let i = 1; i < raw.length; i++) {
  	        const lastResolvedPoint = resolved.length
  	        ? resolved[resolved.length - 1]: null;
  	
  	        if (!lastResolvedPoint) {
  	          pushPlotPoint(resolved, raw[i]);
  	          currentAnchor = null;
  	          continue;
  	        }
  	
  	        let startAnchor = null;
  	
  	        if (currentAnchor && samePlotPoint(currentAnchor.point, lastResolvedPoint)) {
  	          startAnchor = currentAnchor;
  	        } else {
  	          const startSnap = getBoundarySnapForPoint(lastResolvedPoint, routeBlockers, {
  	            snapInside: false,
  	            snapNearBoundary: true
  	          });
  	
  	          if (startSnap && startSnap.anchor && samePlotPoint(startSnap.point, lastResolvedPoint)) {
  	            startAnchor = startSnap.anchor;
  	          }
  	        }
  	
  	        const insideRawBlocker = getStrictContainingBlockerForPoint(
  	          raw[i],
  	          routeBlockers
  	        );
  	
  	        const nextRawForInsideCorner =
  	        raw.length >= 3
  	        ? raw[(i + 1) % raw.length]: raw[i + 1];
  	
  	        const insideCornerResult =
  	        insideRawBlocker && nextRawForInsideCorner
  	        ? resolveInsideRawPointBoundaryCorner(
  	          lastResolvedPoint,
  	          startAnchor,
  	          raw[i - 1],
  	          raw[i],
  	          nextRawForInsideCorner,
  	          insideRawBlocker,
  	          raw
  	        ): null;
  	
  	        if (insideCornerResult) {
  	          const cornerPoints = Array.isArray(insideCornerResult.points)
  	          ? insideCornerResult.points: [];
  	
  	          cornerPoints.forEach(point => {
  	            pushPlotPoint(resolved, point);
  	          });
  	
  	          if (Array.isArray(insideCornerResult.headingPoints)) {
  	            insideCornerResult.headingPoints.forEach(point => {
  	              headingPoints.push(point);
  	            });
  	          }
  	
  	          if (Array.isArray(insideCornerResult.snapSegments)) {
  	            insideCornerResult.snapSegments.forEach(segment => {
  	              snapSegments.push(segment);
  	            });
  	          }
  	
  	          currentAnchor = insideCornerResult.anchor || null;
  	          continue;
  	        }
  	
  	        const edgeResult = resolveFreeGroundEdgeLive(
  	          lastResolvedPoint,
  	          startAnchor,
  	          raw[i],
  	          routeBlockers,
  	          {
  	            isClosing: false,
  	            headingStart: raw[i - 1],
  	            outerRing: raw
  	          }
  	        );
  	
  	        const edgePoints = Array.isArray(edgeResult.points)
  	        ? edgeResult.points: [];
  	
  	        edgePoints.forEach(point => {
  	          pushPlotPoint(resolved, point);
  	        });
  	
  	        if (Array.isArray(edgeResult.headingPoints)) {
  	          edgeResult.headingPoints.forEach(point => {
  	            headingPoints.push(point);
  	          });
  	        }
  	
  	        if (Array.isArray(edgeResult.snapSegments)) {
  	          edgeResult.snapSegments.forEach(segment => {
  	            snapSegments.push(segment);
  	          });
  	        }
  	
  	        currentAnchor = edgeResult.anchor || null;
  	      }
  	
  	      resolveClosingSnapIfNeeded(
  	        resolved,
  	        firstAnchor,
  	        currentAnchor,
  	        routeBlockers,
  	        snapSegments,
  	        headingPoints,
  	        raw
  	      );
  	
  	      const resolvedDonut = buildFreeGroundConfirmedDonutHoles(
  	        resolved,
  	        holeCandidateBlockers
  	      );
  	
  	      const donut = {
  	        holeRings: [],
  	        holeLocations: []
  	      };
  	
  	      const donutSeen = Object.create(null);
  	
  	      function addConfirmedDonutResult(result) {
  	        if (!result || !Array.isArray(result.holeLocations)) return;
  	
  	        result.holeLocations.forEach((hole, index) => {
  	          const id = String(hole?.locationId || "");
  	
  	          if (!id || donutSeen[id]) return;
  	
  	          const ring = Array.isArray(result.holeRings)
  	          ? result.holeRings[index]: hole.points;
  	
  	          if (!Array.isArray(ring) || ring.length < 3) return;
  	
  	          donutSeen[id] = true;
  	          donut.holeRings.push(ring);
  	          donut.holeLocations.push(hole);
  	        });
  	      }
  	
  	      addConfirmedDonutResult(rawDonut);
  	      addConfirmedDonutResult(resolvedDonut);
  	
  	      donut.holeLocations.forEach(hole => {
  	        snapSegments.push({
  	          type: "donut-hole-created",
  	          locationId: hole.locationId,
  	          locationName: hole.locationName,
  	          points: hole.points
  	        });
  	      });
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Multi-cross live resolver complete:",
  	        {
  	          rawPoints: raw.length,
  	          resolvedPoints: resolved.length,
  	          holeCount: donut.holeRings.length,
  	          holeLocations: donut.holeLocations,
  	          snapSegments
  	        });
  	
  	      return {
  	        points: resolved,
  	        headingPoints,
  	        snapSegments,
  	        holeRings: donut.holeRings,
  	        holeLocations: donut.holeLocations
  	      };
  	    }
  	
  	    function isGeneratedCreationMode() {
  	      const creationMode = safeString(createState.creationMode).trim().toLowerCase();
  	      const childShapeMode = safeString(createState.childShapeMode).trim().toLowerCase();
  	
  	      if (createState.plotMode === "child-location") {
  	        // If a child submode was chosen from the child prompt, it wins.
  	        // Polygon must stay polygon even if the main Creation Mode is Pivot/Wedge.
  	        if (childShapeMode) {
  	          return (
  	            childShapeMode === "ring" ||
  	            childShapeMode === "segment"
  	          );
  	        }
  	
  	        // Empty childShapeMode means this is a normal child using the selected
  	        // main Creation Mode, e.g. Pivot/Wedge inside a Polygon parent.
  	        return (
  	          creationMode === "pivot" ||
  	          creationMode === "wedge"
  	        );
  	      }
  	
  	      return (
  	        creationMode === "pivot" ||
  	        creationMode === "wedge"
  	      );
  	    }
  	
  	    function redrawFreeGroundPlot(map) {
  	      if (!map) return;
  	
  	      const points = Array.isArray(createState.plotPoints)
  	      ? createState.plotPoints: [];
  	
  	      const rawPoints = Array.isArray(createState.plotRawPoints)
  	      ? createState.plotRawPoints: [];
  	
  	      const headingPoints = Array.isArray(createState.plotHeadingPoints)
  	      ? createState.plotHeadingPoints: rawPoints.filter(rawPoint => {
  	        return !points.some(point => samePlotPoint(point, rawPoint));
  	      });
  	
  	      const color = getFreeGroundPlotColor();
  	
  	      try {
  	        if (Array.isArray(createState.plotDraftMarkers)) {
  	          createState.plotDraftMarkers.forEach(marker => {
  	            try {
  	              marker.setMap(null);
  	            } catch (_) {}
  	          });
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (Array.isArray(createState.plotDraftHeadingMarkers)) {
  	          createState.plotDraftHeadingMarkers.forEach(marker => {
  	            try {
  	              marker.setMap(null);
  	            } catch (_) {}
  	          });
  	        }
  	      } catch (_) {}
  	
  	      clearFreeGroundMidMarkers();
  	
  	      try {
  	        if (createState.plotDraftPolyline) {
  	          createState.plotDraftPolyline.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftRawPolyline) {
  	          createState.plotDraftRawPolyline.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPolygon) {
  	          createState.plotDraftPolygon.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      createState.plotDraftMarkers = [];
  	      createState.plotDraftHeadingMarkers = [];
  	      createState.plotDraftPolyline = null;
  	      createState.plotDraftRawPolyline = null;
  	      createState.plotDraftPolygon = null;
  	
  	      const rawEditPoints = Array.isArray(createState.plotRawPoints)
  	      ? createState.plotRawPoints: [];
  	
  	      if (!isGeneratedCreationMode()) {
  	        rawEditPoints.forEach((point, index) => {
  	          if (
  	            typeof google === "undefined" ||
  	            !google.maps ||
  	            !google.maps.Marker ||
  	            !google.maps.SymbolPath
  	          ) {
  	            return;
  	          }
  	
  	          try {
  	            const marker = new google.maps.Marker({
  	              map,
  	              position: point,
  	              draggable: true,
  	              label: String(index + 1),
  	              title: `Raw Point ${index + 1}`,
  	              icon: makeFreeGroundVertexIcon(index === createState.plotActiveRawIndex),
  	              zIndex: 2147483603
  	            });
  	
  	            marker.addListener("click", function () {
  	              createState.plotActiveRawIndex = index;
  	              redrawFreeGroundPlot(map);
  	            });
  	
  	            marker.addListener("dragend", function () {
  	              const pos = marker.getPosition();
  	
  	              if (!pos) return;
  	
  	              const candidate = {
  	                lat: pos.lat(),
  	                lng: pos.lng()
  	              };
  	
  	              const nextRawPoints = createState.plotRawPoints.slice();
  	
  	              nextRawPoints[index] = candidate;
  	
  	              const committed = commitFreeGroundRawPoints(
  	                map,
  	                nextRawPoints,
  	                "drag-raw-point",
  	                index
  	              );
  	
  	              if (!committed) {
  	                try {
  	                  marker.setPosition({
  	                    lat: Number(point.lat),
  	                    lng: Number(point.lng)
  	                  });
  	                } catch (_) {}
  	              }
  	            });
  	
  	            marker.addListener("rightclick",
  	              function () {
  	                const raw = Array.isArray(createState.plotRawPoints)
  	                ? createState.plotRawPoints.slice(): [];
  	
  	                if (raw.length <= 3) return;
  	
  	                raw.splice(index, 1);
  	
  	                const nextActive = Math.max(0, Math.min(index, raw.length - 1));
  	
  	                commitFreeGroundRawPoints(
  	                  map,
  	                  raw,
  	                  "delete-raw-point",
  	                  nextActive
  	                );
  	              });
  	
  	            createState.plotDraftMarkers.push(marker);
  	          } catch (_) {}
  	        });
  	      }
  	
  	      if (!isGeneratedCreationMode()) {
  	        headingPoints.forEach((point,
  	          index) => {
  	          const marker = createHeadingMarker(map,
  	            point,
  	            index);
  	
  	          if (marker) {
  	            createState.plotDraftHeadingMarkers.push(marker);
  	          }
  	        });
  	      }
  	
  	      if (isGeneratedCreationMode()) {
  	        clearFreeGroundMidMarkers();
  	      } else {
  	        rebuildFreeGroundMidpointMarkers(map);
  	      }
  	
  	      if (
  	        !isGeneratedCreationMode() &&
  	        rawPoints.length >= 2 &&
  	        typeof google !== "undefined" &&
  	        google.maps &&
  	        google.maps.Polyline
  	      ) {
  	        try {
  	          createState.plotDraftRawPolyline = new google.maps.Polyline({
  	            map,
  	            path: rawPoints,
  	            strokeColor: "#25c7ff",
  	            strokeOpacity: 0.75,
  	            strokeWeight: 2,
  	            clickable: false,
  	            zIndex: 2147483598
  	          });
  	        } catch (_) {}
  	      }
  	
  	      if (
  	        points.length >= 2 &&
  	        typeof google !== "undefined" &&
  	        google.maps &&
  	        google.maps.Polyline
  	      ) {
  	        try {
  	          createState.plotDraftPolyline = new google.maps.Polyline({
  	            map,
  	            path: points,
  	            strokeColor: color,
  	            strokeOpacity: 1,
  	            strokeWeight: 4,
  	            clickable: false,
  	            zIndex: 2147483600
  	          });
  	        } catch (_) {}
  	      }
  	
  	      if (
  	        points.length >= 3 &&
  	        typeof google !== "undefined" &&
  	        google.maps &&
  	        google.maps.Polygon
  	      ) {
  	        try {
  	          const holeRings = Array.isArray(createState.plotHoleRings)
  	          ? createState.plotHoleRings: [];
  	
  	          const polygonPaths = [
  	            points,
  	            ...holeRings.filter(ring => Array.isArray(ring) && ring.length >= 3)
  	          ];
  	
  	          createState.plotDraftPolygon = new google.maps.Polygon({
  	            map,
  	            paths: polygonPaths,
  	            strokeColor: color,
  	            strokeOpacity: 1,
  	            strokeWeight: 4,
  	            fillColor: color,
  	            fillOpacity: 0.22,
  	            clickable: false,
  	            zIndex: 2147483599
  	          });
  	        } catch (_) {}
  	      }
  	
  	      redrawPivotControlMarkers(map);
  	      redrawWedgeControlMarkers(map);
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Draft recalculated:", {
  	        mode: createState.plotMode,
  	        rawPoints,
  	        resolvedPoints: points,
  	        holeRings: createState.plotHoleRings || [],
  	        holeLocations: createState.plotHoleLocations || [],
  	        snapSegments: createState.plotSnapSegments || []
  	      });
  	    }
  	
  	    function getPivotCircleSegmentCount(radiusMeters) {
  	      const radius = Number(radiusMeters) || 0;
  	
  	      if (radius > 2500) return 96;
  	      if (radius > 1000) return 84;
  	      if (radius > 300) return 72;
  	
  	      return 56;
  	    }
  	
  	    function pivotDistanceMeters(centerPoint, radiusPoint) {
  	      const center = makeCleanPlotPoint(centerPoint);
  	      const radius = makeCleanPlotPoint(radiusPoint);
  	
  	      if (!center || !radius) return 0;
  	
  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google.maps &&
  	          google.maps.geometry &&
  	          google.maps.geometry.spherical &&
  	          typeof google.maps.geometry.spherical.computeDistanceBetween === "function"
  	        ) {
  	          return google.maps.geometry.spherical.computeDistanceBetween(
  	            new google.maps.LatLng(center.lat, center.lng),
  	            new google.maps.LatLng(radius.lat, radius.lng)
  	          );
  	        }
  	      } catch (_) {}
  	
  	      const metersPerLat = 111320;
  	      const metersPerLng = 111320 * Math.cos(Number(center.lat) * Math.PI / 180);
  	
  	      const dy = (Number(radius.lat) - Number(center.lat)) * metersPerLat;
  	      const dx = (Number(radius.lng) - Number(center.lng)) * metersPerLng;
  	
  	      return Math.sqrt((dx * dx) + (dy * dy));
  	    }
  	
  	    function getGeneratedParentTypeForRadiusClamp(location) {
  	      if (!location || typeof location !== "object") return "";
  	
  	      const shape =
  	      location.LocationData?.Shape ||
  	      location.locationData?.Shape ||
  	      location.LocationData?.shape ||
  	      location.locationData?.shape ||
  	      {};
  	
  	      const type = safeString(
  	        location.CreationType ||
  	        location.creationType ||
  	        location.creation_type ||
  	        location.CreationMode ||
  	        location.creationMode ||
  	        location.LocationData?.CreationType ||
  	        location.locationData?.CreationType ||
  	        location.LocationData?.creationType ||
  	        location.locationData?.creationType ||
  	        location.LocationData?.creationMode ||
  	        location.locationData?.creationMode ||
  	        location.LocationData?.childShapeMode ||
  	        location.locationData?.childShapeMode ||
  	        ""
  	      ).trim().toLowerCase();
  	
  	      if (
  	        type === "pivot" ||
  	        type === "wedge" ||
  	        type === "ring" ||
  	        type === "segment"
  	      ) {
  	        return type;
  	      }
  	
  	      if (shape.PivotCenter || shape.pivotCenter) return "pivot";
  	      if (shape.WedgeCenter || shape.wedgeCenter) return "wedge";
  	
  	      if (
  	        (shape.ChildFixedCenter || shape.childFixedCenter) &&
  	        (shape.ChildRadiusPoint || shape.childRadiusPoint)
  	      ) {
  	        return "ring";
  	      }
  	
  	      return "";
  	    }
  	
  	    function getGeneratedParentRadiusMetersForChildClamp(parentBlocker, fixedCenter) {
  	      const location = parentBlocker?.location || null;
  	      const center = makeCleanPlotPoint(fixedCenter);
  	
  	      if (!location || !center) return 0;
  	
  	      const generatedType = getGeneratedParentTypeForRadiusClamp(location);
  	
  	      if (!generatedType) return 0;
  	
  	      const shape =
  	      location.LocationData?.Shape ||
  	      location.locationData?.Shape ||
  	      location.LocationData?.shape ||
  	      location.locationData?.shape ||
  	      {};
  	
  	      const directRadiusCandidates = [
  	        shape.PivotRadiusMeters,
  	        shape.pivotRadiusMeters,
  	        shape.WedgeRadiusMeters,
  	        shape.wedgeRadiusMeters,
  	        shape.ChildRadiusMeters,
  	        shape.childRadiusMeters,
  	
  	        location.PivotRadiusMeters,
  	        location.pivotRadiusMeters,
  	        location.WedgeRadiusMeters,
  	        location.wedgeRadiusMeters,
  	        location.ChildRadiusMeters,
  	        location.childRadiusMeters
  	      ];
  	
  	      for (let i = 0; i < directRadiusCandidates.length; i++) {
  	        const value = Number(directRadiusCandidates[i]);
  	
  	        if (Number.isFinite(value) && value > 0.25) {
  	          return value;
  	        }
  	      }
  	
  	      const radiusPointCandidates = [
  	        shape.ChildRadiusPoint,
  	        shape.childRadiusPoint,
  	        shape.PivotRadiusPoint,
  	        shape.pivotRadiusPoint,
  	        shape.WedgeRadiusPoint,
  	        shape.wedgeRadiusPoint,
  	
  	        location.ChildRadiusPoint,
  	        location.childRadiusPoint,
  	        location.PivotRadiusPoint,
  	        location.pivotRadiusPoint,
  	        location.WedgeRadiusPoint,
  	        location.wedgeRadiusPoint
  	      ];
  	
  	      for (let i = 0; i < radiusPointCandidates.length; i++) {
  	        const point = makeCleanPlotPoint(radiusPointCandidates[i]);
  	
  	        if (!point) continue;
  	
  	        const meters = pivotDistanceMeters(center, point);
  	
  	        if (Number.isFinite(meters) && meters > 0.25) {
  	          return meters;
  	        }
  	      }
  	
  	      return 0;
  	    }
  	
  	    function getPointFromCenterTowardsTargetAtMeters(centerPoint, targetPoint, meters) {
  	      const center = makeCleanPlotPoint(centerPoint);
  	      const target = makeCleanPlotPoint(targetPoint);
  	      const distanceMeters = Number(meters);
  	
  	      if (!center || !target || !Number.isFinite(distanceMeters) || distanceMeters <= 0) {
  	        return target;
  	      }
  	
  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google.maps &&
  	          google.maps.geometry &&
  	          google.maps.geometry.spherical &&
  	          typeof google.maps.geometry.spherical.computeHeading === "function" &&
  	          typeof google.maps.geometry.spherical.computeOffset === "function"
  	        ) {
  	          const centerLL = new google.maps.LatLng(center.lat, center.lng);
  	          const targetLL = new google.maps.LatLng(target.lat, target.lng);
  	          const heading = google.maps.geometry.spherical.computeHeading(centerLL, targetLL);
  	          const snapped = google.maps.geometry.spherical.computeOffset(centerLL, distanceMeters, heading);
  	
  	          return {
  	            lat: snapped.lat(),
  	            lng: snapped.lng()
  	          };
  	        }
  	      } catch (_) {}
  	
  	      const metersPerLat = 111320;
  	      const metersPerLng = 111320 * Math.cos(Number(center.lat) * Math.PI / 180);
  	
  	      const dxMeters = (Number(target.lng) - Number(center.lng)) * metersPerLng;
  	      const dyMeters = (Number(target.lat) - Number(center.lat)) * metersPerLat;
  	      const length = Math.sqrt((dxMeters * dxMeters) + (dyMeters * dyMeters));
  	
  	      if (!Number.isFinite(length) || length <= 0.000001) {
  	        return target;
  	      }
  	
  	      const scale = distanceMeters / length;
  	
  	      return {
  	        lat: Number(center.lat) + ((dyMeters * scale) / metersPerLat),
  	        lng: Number(center.lng) + ((dxMeters * scale) / metersPerLng)
  	      };
  	    }
  	
  	    function clampChildGeneratedRadiusPointToParentRadius(centerPoint, radiusPoint, source) {
  	      const center = makeCleanPlotPoint(centerPoint);
  	      const requested = makeCleanPlotPoint(radiusPoint);
  	
  	      if (!center || !requested) return requested;
  	
  	      if (safeString(createState.plotMode).trim().toLowerCase() !== "child-location") {
  	        return requested;
  	      }
  	
  	      const childMode = safeString(createState.childShapeMode || createState.creationMode)
  	      .trim()
  	      .toLowerCase();
  	
  	      if (
  	        childMode !== "ring" &&
  	        childMode !== "segment" &&
  	        childMode !== "pivot" &&
  	        childMode !== "wedge"
  	      ) {
  	        return requested;
  	      }
  	
  	      const parentBlocker =
  	      typeof getChildLocationParentBlocker === "function"
  	      ? getChildLocationParentBlocker(): null;
  	
  	      const parentRadiusMeters = getGeneratedParentRadiusMetersForChildClamp(parentBlocker, center);
  	
  	      if (!Number.isFinite(parentRadiusMeters) || parentRadiusMeters <= 0.25) {
  	        return requested;
  	      }
  	
  	      const requestedRadiusMeters = pivotDistanceMeters(center, requested);
  	
  	      if (
  	        !Number.isFinite(requestedRadiusMeters) ||
  	        requestedRadiusMeters <= parentRadiusMeters
  	      ) {
  	        return requested;
  	      }
  	
  	      const snapped = getPointFromCenterTowardsTargetAtMeters(
  	        center,
  	        requested,
  	        parentRadiusMeters
  	      );
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Child Generated Wizard] Radius clamped to parent radius boundary:", {
  	        source: source || "child-generated-radius",
  	        childMode,
  	        parentLocationId: parentBlocker?.locationId || createState.plotParentLocationId || "",
  	        parentLocationName: parentBlocker?.locationName || "",
  	        parentRadiusMeters,
  	        requestedRadiusMeters,
  	        center,
  	        requested,
  	        snapped
  	      });
  	
  	      return snapped || requested;
  	    }
  	
  	    function buildPivotCircleRawPoints(centerPoint, radiusPoint) {
  	      const center = makeCleanPlotPoint(centerPoint);
  	      const radius = makeCleanPlotPoint(radiusPoint);
  	
  	      if (!center || !radius) return [];
  	
  	      const radiusMeters = pivotDistanceMeters(center, radius);
  	
  	      if (!Number.isFinite(radiusMeters) || radiusMeters <= 0.25) {
  	        return [];
  	      }
  	
  	      const segmentCount = getPivotCircleSegmentCount(radiusMeters);
  	      const points = [];
  	
  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google.maps &&
  	          google.maps.geometry &&
  	          google.maps.geometry.spherical &&
  	          typeof google.maps.geometry.spherical.computeOffset === "function"
  	        ) {
  	          const centerLL = new google.maps.LatLng(center.lat, center.lng);
  	
  	          for (let i = 0; i < segmentCount; i++) {
  	            const heading = (360 / segmentCount) * i;
  	            const point = google.maps.geometry.spherical.computeOffset(
  	              centerLL,
  	              radiusMeters,
  	              heading
  	            );
  	
  	            points.push({
  	              lat: point.lat(),
  	              lng: point.lng()
  	            });
  	          }
  	
  	          return points;
  	        }
  	      } catch (_) {}
  	
  	      const metersPerLat = 111320;
  	      const metersPerLng = 111320 * Math.cos(Number(center.lat) * Math.PI / 180);
  	
  	      for (let i = 0; i < segmentCount; i++) {
  	        const angle = ((360 / segmentCount) * i) * Math.PI / 180;
  	
  	        points.push({
  	          lat: Number(center.lat) + ((Math.cos(angle) * radiusMeters) / metersPerLat),
  	          lng: Number(center.lng) + ((Math.sin(angle) * radiusMeters) / metersPerLng)
  	        });
  	      }
  	
  	      return points;
  	    }
  	
  	    function clearPivotGeneratedGeometryOnly() {
  	      createState.plotPoints = [];
  	      createState.plotRawPoints = [];
  	      createState.plotResolvedPoints = [];
  	      createState.plotSnapSegments = [];
  	      createState.plotHeadingPoints = [];
  	      createState.plotHoleRings = [];
  	      createState.plotHoleLocations = [];
  	      createState.plotActiveRawIndex = -1;
  	      createState.plotPivotRadiusPoint = null;
  	      createState.plotPivotRadiusMeters = 0;
  	    }
  	
  	    function setPivotCenterPoint(map, point, source) {
  	      const center = makeCleanPlotPoint(point);
  	
  	      if (!center) return false;
  	
  	      clearPivotGeneratedGeometryOnly();
  	
  	      createState.plotPivotCenter = center;
  	      createState.isSaved = false;
  	
  	      redrawFreeGroundPlot(map || createState.plotDraftMap);
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Pivot Wizard] Pivot center set:", {
  	        source: source || "pivot-center",
  	        center,
  	        mode: createState.plotMode
  	      });
  	
  	      return true;
  	    }
  	
  	    function redrawPivotLiveGeometryOnly(map) {
  	      const targetMap = map || createState.plotDraftMap;
  	
  	      if (
  	        !targetMap ||
  	        typeof google === "undefined" ||
  	        !google.maps
  	      ) {
  	        return;
  	      }
  	
  	      const points = Array.isArray(createState.plotPoints)
  	      ? createState.plotPoints: [];
  	
  	      const holeRings = Array.isArray(createState.plotHoleRings)
  	      ? createState.plotHoleRings: [];
  	
  	      const center = makeCleanPlotPoint(createState.plotPivotCenter);
  	      const radius = makeCleanPlotPoint(createState.plotPivotRadiusPoint);
  	      const color = getFreeGroundPlotColor();
  	
  	      try {
  	        if (createState.plotDraftPolyline) {
  	          createState.plotDraftPolyline.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPolygon) {
  	          createState.plotDraftPolygon.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      createState.plotDraftPolyline = null;
  	      createState.plotDraftPolygon = null;
  	
  	      if (
  	        points.length >= 2 &&
  	        google.maps.Polyline
  	      ) {
  	        try {
  	          createState.plotDraftPolyline = new google.maps.Polyline({
  	            map: targetMap,
  	            path: points,
  	            strokeColor: color,
  	            strokeOpacity: 1,
  	            strokeWeight: 4,
  	            clickable: false,
  	            zIndex: 2147483600
  	          });
  	        } catch (_) {}
  	      }
  	
  	      if (
  	        points.length >= 3 &&
  	        google.maps.Polygon
  	      ) {
  	        try {
  	          const polygonPaths = [
  	            points,
  	            ...holeRings.filter(ring => Array.isArray(ring) && ring.length >= 3)
  	          ];
  	
  	          createState.plotDraftPolygon = new google.maps.Polygon({
  	            map: targetMap,
  	            paths: polygonPaths,
  	            strokeColor: color,
  	            strokeOpacity: 1,
  	            strokeWeight: 4,
  	            fillColor: color,
  	            fillOpacity: 0.22,
  	            clickable: false,
  	            zIndex: 2147483599
  	          });
  	        } catch (_) {}
  	      }
  	
  	      try {
  	        if (center && createState.plotDraftPivotCenterMarker) {
  	          createState.plotDraftPivotCenterMarker.setPosition(center);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (radius && createState.plotDraftPivotRadiusMarker) {
  	          createState.plotDraftPivotRadiusMarker.setPosition(radius);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (center && radius) {
  	          if (
  	            createState.plotDraftPivotRadiusLine &&
  	            typeof createState.plotDraftPivotRadiusLine.setPath === "function"
  	          ) {
  	            createState.plotDraftPivotRadiusLine.setPath([center, radius]);
  	          } else if (google.maps.Polyline) {
  	            createState.plotDraftPivotRadiusLine = new google.maps.Polyline({
  	              map: targetMap,
  	              path: [center, radius],
  	              strokeColor: color,
  	              strokeOpacity: 0.95,
  	              strokeWeight: 2,
  	              clickable: false,
  	              zIndex: 2147483604
  	            });
  	          }
  	        }
  	      } catch (_) {}
  	    }
  	
  	    function redrawPivotLiveGeometryOnly(map) {
  	      const targetMap = map || createState.plotDraftMap;
  	
  	      if (
  	        !targetMap ||
  	        typeof google === "undefined" ||
  	        !google.maps
  	      ) {
  	        return;
  	      }
  	
  	      const points = Array.isArray(createState.plotPoints)
  	      ? createState.plotPoints: [];
  	
  	      const holeRings = Array.isArray(createState.plotHoleRings)
  	      ? createState.plotHoleRings: [];
  	
  	      const center = makeCleanPlotPoint(createState.plotPivotCenter);
  	      const radius = makeCleanPlotPoint(createState.plotPivotRadiusPoint);
  	      const color = getFreeGroundPlotColor();
  	
  	      try {
  	        if (createState.plotDraftPolyline) {
  	          createState.plotDraftPolyline.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPolygon) {
  	          createState.plotDraftPolygon.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      createState.plotDraftPolyline = null;
  	      createState.plotDraftPolygon = null;
  	
  	      if (
  	        points.length >= 2 &&
  	        google.maps.Polyline
  	      ) {
  	        try {
  	          createState.plotDraftPolyline = new google.maps.Polyline({
  	            map: targetMap,
  	            path: points,
  	            strokeColor: color,
  	            strokeOpacity: 1,
  	            strokeWeight: 4,
  	            clickable: false,
  	            zIndex: 2147483600
  	          });
  	        } catch (_) {}
  	      }
  	
  	      if (
  	        points.length >= 3 &&
  	        google.maps.Polygon
  	      ) {
  	        try {
  	          const polygonPaths = [
  	            points,
  	            ...holeRings.filter(ring => Array.isArray(ring) && ring.length >= 3)
  	          ];
  	
  	          createState.plotDraftPolygon = new google.maps.Polygon({
  	            map: targetMap,
  	            paths: polygonPaths,
  	            strokeColor: color,
  	            strokeOpacity: 1,
  	            strokeWeight: 4,
  	            fillColor: color,
  	            fillOpacity: 0.22,
  	            clickable: false,
  	            zIndex: 2147483599
  	          });
  	        } catch (_) {}
  	      }
  	
  	      try {
  	        if (center && createState.plotDraftPivotCenterMarker) {
  	          createState.plotDraftPivotCenterMarker.setPosition(center);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (radius && createState.plotDraftPivotRadiusMarker) {
  	          createState.plotDraftPivotRadiusMarker.setPosition(radius);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (center && radius) {
  	          if (
  	            createState.plotDraftPivotRadiusLine &&
  	            typeof createState.plotDraftPivotRadiusLine.setPath === "function"
  	          ) {
  	            createState.plotDraftPivotRadiusLine.setPath([center, radius]);
  	          } else if (google.maps.Polyline) {
  	            createState.plotDraftPivotRadiusLine = new google.maps.Polyline({
  	              map: targetMap,
  	              path: [center, radius],
  	              strokeColor: color,
  	              strokeOpacity: 0.95,
  	              strokeWeight: 2,
  	              clickable: false,
  	              zIndex: 2147483604
  	            });
  	          }
  	        }
  	      } catch (_) {}
  	    }
  	
  	    function applyPivotCircleFromCenterAndRadiusPoint(map, centerPoint, radiusPoint, source, options) {
  	      const center = makeCleanPlotPoint(centerPoint);
  	      let radius = makeCleanPlotPoint(radiusPoint);
  	      const targetMap = map || createState.plotDraftMap;
  	      const isLive = !!options?.live;
  	
  	      if (!center || !radius) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Pivot Wizard] Cannot build Pivot circle without center and radius point.", {
  	          center,
  	          radius,
  	          source: source || "pivot-radius"
  	        });
  	
  	        return false;
  	      }
  	
  	      radius = clampChildGeneratedRadiusPointToParentRadius(
  	        center,
  	        radius,
  	        source || "pivot-radius"
  	      );
  	
  	      const rawCircle = buildPivotCircleRawPoints(center, radius);
  	      const radiusMeters = pivotDistanceMeters(center, radius);
  	
  	      if (!rawCircle.length || !Number.isFinite(radiusMeters) || radiusMeters <= 0.25) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Pivot Wizard] Pivot radius is too small.", {
  	          center,
  	          radius,
  	          radiusMeters,
  	          source: source || "pivot-radius"
  	        });
  	
  	        return false;
  	      }
  	
  	      const resolved = validateFreeGroundRawCandidate(
  	        rawCircle,
  	        source || "pivot-radius"
  	      );
  	
  	      if (!resolved) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Pivot Wizard] Pivot generated circle was rejected by live resolver.", {
  	          center,
  	          radius,
  	          radiusMeters,
  	          rawCircle,
  	          source: source || "pivot-radius"
  	        });
  	
  	        return false;
  	      }
  	
  	      createState.plotPivotCenter = center;
  	      createState.plotPivotRadiusPoint = radius;
  	      createState.plotPivotRadiusMeters = radiusMeters;
  	      if (
  	        safeString(createState.plotMode).trim().toLowerCase() === "child-location" &&
  	        safeString(createState.childShapeMode).trim().toLowerCase() === "ring"
  	      ) {
  	        createState.childFixedCenter = center;
  	        createState.childRadiusPoint = radius;
  	      }
  	      createState.plotRawPoints = rawCircle.map(point => {
  	        return {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        };
  	      });
  	
  	      createState.plotPoints = resolved.points || [];
  	      createState.plotResolvedPoints = createState.plotPoints.slice();
  	      createState.plotSnapSegments = resolved.snapSegments || [];
  	      createState.plotHeadingPoints = resolved.headingPoints || [];
  	      createState.plotHoleRings = resolved.holeRings || [];
  	      createState.plotHoleLocations = resolved.holeLocations || [];
  	      createState.plotActiveRawIndex = -1;
  	      createState.isSaved = false;
  	
  	      if (isLive) {
  	        redrawPivotLiveGeometryOnly(targetMap);
  	      } else {
  	        redrawFreeGroundPlot(targetMap);
  	      }
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Pivot Wizard] Pivot circle generated and live boundaries applied:", {
  	        source: source || "pivot-radius",
  	        live: isLive,
  	        center,
  	        radius,
  	        radiusMeters,
  	        rawCirclePoints: rawCircle.length,
  	        resolvedPoints: createState.plotPoints.length,
  	        snapSegments: createState.plotSnapSegments,
  	        holeLocations: createState.plotHoleLocations
  	      });
  	
  	      return true;
  	    }
  	
  	    function commitPivotCircleFromRadiusPoint(map, radiusPoint, source) {
  	      return applyPivotCircleFromCenterAndRadiusPoint(
  	        map || createState.plotDraftMap,
  	        createState.plotPivotCenter,
  	        radiusPoint,
  	        source || "pivot-radius",
  	        {
  	          live: false
  	        }
  	      );
  	    }
  	
  	    function normalizeWedgeHeadingDegrees(value) {
  	      let heading = Number(value) || 0;
  	
  	      while (heading < 0) heading += 360;
  	      while (heading >= 360) heading -= 360;
  	
  	      return heading;
  	    }
  	
  	    function getWedgeClockwiseSweepDegrees(startHeading, endHeading) {
  	      const start = normalizeWedgeHeadingDegrees(startHeading);
  	      const end = normalizeWedgeHeadingDegrees(endHeading);
  	
  	      let sweep = (end - start + 360) % 360;
  	
  	      // Same heading means no wedge. A true 360° shape should be created as a Pivot,
  	      // not as a Wedge. Anything just before 360° remains valid.
  	      if (sweep < 0.000001) {
  	        sweep = 0;
  	      }
  	
  	      return sweep;
  	    }
  	
  	    // Backwards-safe wrapper in case any older call still references this name.
  	    function getWedgeSignedShortestDelta(startHeading, endHeading) {
  	      return getWedgeClockwiseSweepDegrees(startHeading, endHeading);
  	    }
  	
  	    function getWedgeHeadingFromCenter(centerPoint, targetPoint) {
  	      const center = makeCleanPlotPoint(centerPoint);
  	      const target = makeCleanPlotPoint(targetPoint);
  	
  	      if (!center || !target) return 0;
  	
  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google.maps &&
  	          google.maps.geometry &&
  	          google.maps.geometry.spherical &&
  	          typeof google.maps.geometry.spherical.computeHeading === "function"
  	        ) {
  	          return normalizeWedgeHeadingDegrees(
  	            google.maps.geometry.spherical.computeHeading(
  	              new google.maps.LatLng(center.lat, center.lng),
  	              new google.maps.LatLng(target.lat, target.lng)
  	            )
  	          );
  	        }
  	      } catch (_) {}
  	
  	      const metersPerLat = 111320;
  	      const metersPerLng = 111320 * Math.cos(Number(center.lat) * Math.PI / 180);
  	
  	      const dy = (Number(target.lat) - Number(center.lat)) * metersPerLat;
  	      const dx = (Number(target.lng) - Number(center.lng)) * metersPerLng;
  	
  	      return normalizeWedgeHeadingDegrees(Math.atan2(dx, dy) * 180 / Math.PI);
  	    }
  	
  	    function getWedgePointFromHeading(centerPoint, radiusMeters, headingDegrees) {
  	      const center = makeCleanPlotPoint(centerPoint);
  	      const radius = Number(radiusMeters) || 0;
  	      const heading = normalizeWedgeHeadingDegrees(headingDegrees);
  	
  	      if (!center || !Number.isFinite(radius) || radius <= 0) return null;
  	
  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google.maps &&
  	          google.maps.geometry &&
  	          google.maps.geometry.spherical &&
  	          typeof google.maps.geometry.spherical.computeOffset === "function"
  	        ) {
  	          const point = google.maps.geometry.spherical.computeOffset(
  	            new google.maps.LatLng(center.lat, center.lng),
  	            radius,
  	            heading
  	          );
  	
  	          return {
  	            lat: point.lat(),
  	            lng: point.lng()
  	          };
  	        }
  	      } catch (_) {}
  	
  	      const angle = heading * Math.PI / 180;
  	      const metersPerLat = 111320;
  	      const metersPerLng = 111320 * Math.cos(Number(center.lat) * Math.PI / 180);
  	
  	      return {
  	        lat: Number(center.lat) + ((Math.cos(angle) * radius) / metersPerLat),
  	        lng: Number(center.lng) + ((Math.sin(angle) * radius) / metersPerLng)
  	      };
  	    }
  	
  	    function getWedgeArcSegmentCount(radiusMeters, sweepDegrees) {
  	      const radius = Number(radiusMeters) || 0;
  	      const sweep = Math.abs(Number(sweepDegrees) || 0);
  	
  	      let byAngle = Math.ceil(sweep / 5);
  	
  	      if (radius > 2500) byAngle = Math.ceil(sweep / 4);
  	      if (radius > 1000) byAngle = Math.ceil(sweep / 4.5);
  	
  	      return Math.max(8, Math.min(72, byAngle));
  	    }
  	
  	    function buildWedgeRawPoints(centerPoint, radiusPoint, edgePoint) {
  	      const center = makeCleanPlotPoint(centerPoint);
  	      const radiusControl = makeCleanPlotPoint(radiusPoint);
  	      const edgeControl = makeCleanPlotPoint(edgePoint);
  	
  	      if (!center || !radiusControl || !edgeControl) return [];
  	
  	      const radiusMeters = pivotDistanceMeters(center, radiusControl);
  	
  	      if (!Number.isFinite(radiusMeters) || radiusMeters <= 0.25) {
  	        return [];
  	      }
  	
  	      const startHeading = getWedgeHeadingFromCenter(center, radiusControl);
  	      const endHeading = getWedgeHeadingFromCenter(center, edgeControl);
  	      const sweep = getWedgeClockwiseSweepDegrees(startHeading, endHeading);
  	
  	      if (sweep < 1) {
  	        return [];
  	      }
  	
  	      const segmentCount = getWedgeArcSegmentCount(radiusMeters, sweep);
  	      const points = [];
  	
  	      points.push(center);
  	
  	      for (let i = 0; i <= segmentCount; i++) {
  	        const t = i / segmentCount;
  	        const heading = startHeading + (sweep * t);
  	        const point = getWedgePointFromHeading(center, radiusMeters, heading);
  	
  	        if (point) {
  	          points.push(point);
  	        }
  	      }
  	
  	      return points;
  	    }
  	    
  	    function isChildGeneratedWedgeControlMode() {
  	  if (safeString(createState.plotMode).trim().toLowerCase() !== "child-location") {
  	    return false;
  	  }
  	
  	  const mode = safeString(createState.childShapeMode || createState.creationMode)
  	  .trim()
  	  .toLowerCase();
  	
  	  return mode === "wedge" || mode === "segment";
  	}
  	
  	function pointIsNearBoundary(point, boundary, toleranceSq) {
  	  const clean = makeCleanPlotPoint(point);
  	
  	  if (!clean || !Array.isArray(boundary) || boundary.length < 3) return false;
  	
  	  const nearest = nearestBoundaryHit(clean, boundary);
  	
  	  return !!nearest && Number(nearest.distanceSq || 0) <= Number(toleranceSq || 5e-9);
  	}
  	
  	function pointInsideBlockerInterior(point, blocker) {
  	  const clean = makeCleanPlotPoint(point);
  	
  	  if (
  	    !clean ||
  	    !blocker ||
  	    !Array.isArray(blocker.boundary) ||
  	    blocker.boundary.length < 3
  	  ) {
  	    return false;
  	  }
  	
  	  if (!pointInPlotBoundary(clean, blocker.boundary)) return false;
  	
  	  // Boundary touch is allowed. Interior overlap is not.
  	  return !pointIsNearBoundary(clean, blocker.boundary, 5e-9);
  	}
  	
  	function pointAlongSegmentByT(fromPoint, toPoint, t) {
  	  const from = makeCleanPlotPoint(fromPoint);
  	  const to = makeCleanPlotPoint(toPoint);
  	  const value = Number(t);
  	
  	  if (!from || !to || !Number.isFinite(value)) return null;
  	
  	  return {
  	    lat: Number(from.lat) + ((Number(to.lat) - Number(from.lat)) * value),
  	    lng: Number(from.lng) + ((Number(to.lng) - Number(from.lng)) * value)
  	  };
  	}
  	
  	function nudgePointBackTowardsCenter(centerPoint, boundaryPoint, metersBack) {
  	  const center = makeCleanPlotPoint(centerPoint);
  	  const boundary = makeCleanPlotPoint(boundaryPoint);
  	
  	  if (!center || !boundary) return boundary;
  	
  	  const distance = pivotDistanceMeters(center, boundary);
  	
  	  if (!Number.isFinite(distance) || distance <= 0.25) {
  	    return boundary;
  	  }
  	
  	  const back = Math.max(0.1, Number(metersBack || 0.35));
  	  const nextDistance = Math.max(0.1, distance - back);
  	
  	  return getPointFromCenterTowardsTargetAtMeters(center, boundary, nextDistance) || boundary;
  	}
  	
  	function getFirstBlockingHitOnRay(centerPoint, requestedPoint, blocker) {
  	  const center = makeCleanPlotPoint(centerPoint);
  	  const requested = makeCleanPlotPoint(requestedPoint);
  	
  	  if (
  	    !center ||
  	    !requested ||
  	    !blocker ||
  	    !Array.isArray(blocker.boundary) ||
  	    blocker.boundary.length < 3
  	  ) {
  	    return null;
  	  }
  	
  	  const hits = getSegmentIntersectionsForBoundary(
  	    center,
  	    requested,
  	    blocker.boundary,
  	    blocker
  	  ).filter(hit => {
  	    return hit && hit.point && hit.t > FREE_GROUND_ROUTE_EPS && hit.t < 1 + FREE_GROUND_ROUTE_EPS;
  	  });
  	
  	  if (!hits.length) return null;
  	
  	  return hits[0];
  	}
  	
  	function limitChildGeneratedControlPointOnRay(centerPoint, requestedPoint, source) {
  	  const center = makeCleanPlotPoint(centerPoint);
  	  const requested = makeCleanPlotPoint(requestedPoint);
  	
  	  if (!center || !requested) {
  	    return {
  	      point: requested,
  	      blocked: false,
  	      reason: ""
  	    };
  	  }
  	
  	  if (!isChildGeneratedWedgeControlMode()) {
  	    return {
  	      point: requested,
  	      blocked: false,
  	      reason: ""
  	    };
  	  }
  	
  	  const parentBlocker = getChildLocationParentBlocker();
  	
  	  if (
  	    !parentBlocker ||
  	    !Array.isArray(parentBlocker.boundary) ||
  	    parentBlocker.boundary.length < 3
  	  ) {
  	    return {
  	      point: requested,
  	      blocked: false,
  	      reason: ""
  	    };
  	  }
  	
  	  let limited = requested;
  	
  	  if (!pointInsideOrNearChildParent(requested, parentBlocker)) {
  	    const parentHit =
  	    getFirstBlockingHitOnRay(center, requested, parentBlocker) ||
  	    normalizeAnchorForBlocker(requested, parentBlocker);
  	
  	    if (parentHit && parentHit.point) {
  	      limited = nudgePointBackTowardsCenter(center, parentHit.point, 0.35);
  	
  	      return {
  	        point: limited,
  	        blocked: true,
  	        reason: "parent-boundary",
  	        blocker: parentBlocker
  	      };
  	    }
  	
  	    return {
  	      point: requested,
  	      blocked: true,
  	      reason: "outside-parent-no-anchor",
  	      blocker: parentBlocker
  	    };
  	  }
  	
  	  const siblingBlockers = getChildLocationSiblingBlockers(parentBlocker);
  	
  	  let bestSiblingHit = null;
  	  let bestSiblingBlocker = null;
  	
  	  siblingBlockers.forEach(blocker => {
  	    if (
  	      !blocker ||
  	      !Array.isArray(blocker.boundary) ||
  	      blocker.boundary.length < 3
  	    ) {
  	      return;
  	    }
  	
  	    if (pointInsideBlockerInterior(requested, blocker)) {
  	      const hit =
  	      getFirstBlockingHitOnRay(center, requested, blocker) ||
  	      normalizeAnchorForBlocker(requested, blocker);
  	
  	      if (hit && hit.point && (!bestSiblingHit || Number(hit.t || 1) < Number(bestSiblingHit.t || 1))) {
  	        bestSiblingHit = hit;
  	        bestSiblingBlocker = blocker;
  	      }
  	
  	      return;
  	    }
  	
  	    const hits = getSegmentIntersectionsForBoundary(
  	      center,
  	      requested,
  	      blocker.boundary,
  	      blocker
  	    ).filter(hit => {
  	      return hit && hit.point && hit.t > FREE_GROUND_ROUTE_EPS && hit.t < 1 - FREE_GROUND_ROUTE_EPS;
  	    });
  	
  	    hits.forEach(hit => {
  	      const sampleT = Math.min(1, Number(hit.t) + 0.0005);
  	      const samplePoint = pointAlongSegmentByT(center, requested, sampleT);
  	
  	      // Only block when the ray is entering sibling interior.
  	      // Tangent touches / boundary-following should remain allowed.
  	      if (!samplePoint || !pointInsideBlockerInterior(samplePoint, blocker)) return;
  	
  	      if (!bestSiblingHit || Number(hit.t || 1) < Number(bestSiblingHit.t || 1)) {
  	        bestSiblingHit = hit;
  	        bestSiblingBlocker = blocker;
  	      }
  	    });
  	  });
  	
  	  if (bestSiblingHit && bestSiblingHit.point) {
  	    return {
  	      point: nudgePointBackTowardsCenter(center, bestSiblingHit.point, 0.35),
  	      blocked: true,
  	      reason: "sibling-boundary",
  	      blocker: bestSiblingBlocker
  	    };
  	  }
  	
  	  return {
  	    point: requested,
  	    blocked: false,
  	    reason: ""
  	  };
  	}
  	
  	function childGeneratedRawWedgeStaysInsideAllowedArea(rawPoints, source) {
  	  if (!isChildGeneratedWedgeControlMode()) return true;
  	
  	  const parentBlocker = getChildLocationParentBlocker();
  	
  	  if (
  	    !parentBlocker ||
  	    !Array.isArray(parentBlocker.boundary) ||
  	    parentBlocker.boundary.length < 3
  	  ) {
  	    return true;
  	  }
  	
  	  const ring = cleanFreeGroundRing(rawPoints);
  	
  	  if (!Array.isArray(ring) || ring.length < 3) return false;
  	
  	  for (let i = 0; i < ring.length; i++) {
  	    if (!pointInsideOrNearChildParent(ring[i], parentBlocker)) {
  	      FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Child Wedge rejected because raw point leaves parent.", {
  	        source: source || "wedge",
  	        point: ring[i],
  	        parentLocationId: parentBlocker.locationId || createState.plotParentLocationId || ""
  	      });
  	
  	      return false;
  	    }
  	  }
  	
  	  if (ringsHaveRealCrossing(ring, parentBlocker.boundary)) {
  	    FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Child Wedge rejected because raw boundary crosses parent.", {
  	      source: source || "wedge",
  	      parentLocationId: parentBlocker.locationId || createState.plotParentLocationId || ""
  	    });
  	
  	    return false;
  	  }
  	
  	  const siblingBlockers = getChildLocationSiblingBlockers(parentBlocker);
  	
  	  for (let i = 0; i < siblingBlockers.length; i++) {
  	    const sibling = siblingBlockers[i];
  	
  	    if (
  	      !sibling ||
  	      !Array.isArray(sibling.boundary) ||
  	      sibling.boundary.length < 3
  	    ) {
  	      continue;
  	    }
  	
  	    for (let p = 0; p < ring.length; p++) {
  	      if (pointInsideBlockerInterior(ring[p], sibling)) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Child Wedge rejected because raw point enters sibling.", {
  	          source: source || "wedge",
  	          siblingLocationId: sibling.locationId || "",
  	          siblingLocationName: sibling.locationName || "",
  	          point: ring[p]
  	        });
  	
  	        return false;
  	      }
  	    }
  	
  	    if (ringsHaveRealCrossing(ring, sibling.boundary)) {
  	      FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Child Wedge rejected because raw boundary crosses sibling.", {
  	        source: source || "wedge",
  	        siblingLocationId: sibling.locationId || "",
  	        siblingLocationName: sibling.locationName || ""
  	      });
  	
  	      return false;
  	    }
  	  }
  	
  	  return true;
  	}
  	
  	function forceMarkerBackToCurrentWedgePoint(marker, point) {
  	  const clean = makeCleanPlotPoint(point);
  	
  	  if (!marker || !clean || typeof marker.setPosition !== "function") return;
  	
  	  try {
  	    marker.setPosition(clean);
  	  } catch (_) {}
  	}
  	
  	    function setWedgeCenterPoint(map, point, source) {
  	      const center = makeCleanPlotPoint(point);
  	
  	      if (!center) return false;
  	
  	      createState.plotWedgeCenter = center;
  	      createState.plotWedgeRadiusPoint = null;
  	      createState.plotWedgeEdgePoint = null;
  	      createState.plotWedgeRadiusMeters = 0;
  	
  	      createState.plotRawPoints = [];
  	      createState.plotPoints = [];
  	      createState.plotResolvedPoints = [];
  	      createState.plotSnapSegments = [];
  	      createState.plotHeadingPoints = [];
  	      createState.plotHoleRings = [];
  	      createState.plotHoleLocations = [];
  	      createState.plotActiveRawIndex = -1;
  	      createState.isSaved = false;
  	
  	      redrawFreeGroundPlot(map || createState.plotDraftMap);
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Wedge Wizard] Wedge center set:", {
  	        source: source || "wedge-center",
  	        center
  	      });
  	
  	      return true;
  	    }
  	
  	    function setWedgeRadiusPoint(map, point, source) {
  	      let radius = makeCleanPlotPoint(point);
  	      const center = makeCleanPlotPoint(createState.plotWedgeCenter);
  	
  	      if (!center || !radius) return false;
  	
  	      radius = clampChildGeneratedRadiusPointToParentRadius(
  	        center,
  	        radius,
  	        source || "wedge-radius"
  	      );
  	
  	      const radiusMeters = pivotDistanceMeters(center, radius);
  	
  	      if (!Number.isFinite(radiusMeters) || radiusMeters <= 0.25) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Wedge radius is too small.", {
  	          center,
  	          radius,
  	          radiusMeters,
  	          source: source || "wedge-radius"
  	        });
  	
  	        return false;
  	      }
  	
  	      createState.plotWedgeRadiusPoint = radius;
  	      createState.plotWedgeRadiusMeters = radiusMeters;
  	      createState.plotWedgeEdgePoint = null;
  	
  	      createState.plotRawPoints = [];
  	      createState.plotPoints = [];
  	      createState.plotResolvedPoints = [];
  	      createState.plotSnapSegments = [];
  	      createState.plotHeadingPoints = [];
  	      createState.plotHoleRings = [];
  	      createState.plotHoleLocations = [];
  	      createState.plotActiveRawIndex = -1;
  	      createState.isSaved = false;
  	
  	      redrawFreeGroundPlot(map || createState.plotDraftMap);
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Wedge Wizard] Wedge radius/start arm set:", {
  	        source: source || "wedge-radius",
  	        center,
  	        radius,
  	        radiusMeters
  	      });
  	
  	      return true;
  	    }
  	
  	    function applyWedgeFromControlPoints(map, centerPoint, radiusPoint, edgePoint, source, options) {
  	      const center = makeCleanPlotPoint(centerPoint);
  	      let radius = makeCleanPlotPoint(radiusPoint);
  	      const edge = makeCleanPlotPoint(edgePoint);
  	      const targetMap = map || createState.plotDraftMap;
  	      const isLive = !!options?.live;
  	
  	      if (!center || !radius || !edge) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Cannot build Wedge without center, radius and edge point.", {
  	          center,
  	          radius,
  	          edge,
  	          source: source || "wedge"
  	        });
  	
  	        return false;
  	      }
  	
  	      radius = clampChildGeneratedRadiusPointToParentRadius(
  	        center,
  	        radius,
  	        source || "wedge"
  	      );
  	
  	      const rawWedge = buildWedgeRawPoints(center, radius, edge);
  	      const radiusMeters = pivotDistanceMeters(center, radius);
  	
  	      if (!rawWedge.length || !Number.isFinite(radiusMeters) || radiusMeters <= 0.25) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Wedge generated shape was invalid or too small.", {
  	          center,
  	          radius,
  	          edge,
  	          radiusMeters,
  	          rawWedge,
  	          source: source || "wedge"
  	        });
  	
  	        return false;
  	      }
  	
  	      const resolved = validateFreeGroundRawCandidate(
  	        rawWedge,
  	        source || "wedge"
  	      );
  	
  	      if (!resolved) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Wedge generated shape was rejected by live resolver.", {
  	          center,
  	          radius,
  	          edge,
  	          radiusMeters,
  	          rawWedge,
  	          source: source || "wedge"
  	        });
  	
  	        return false;
  	      }
  	
  	      const startHeading = getWedgeHeadingFromCenter(center, radius);
  	      const endHeading = getWedgeHeadingFromCenter(center, edge);
  	      const projectedRadius = getWedgePointFromHeading(center, radiusMeters, startHeading) || radius;
  	      const projectedEdge = getWedgePointFromHeading(center, radiusMeters, endHeading) || edge;
  	
  	      createState.plotWedgeCenter = center;
  	      createState.plotWedgeRadiusPoint = projectedRadius;
  	      createState.plotWedgeEdgePoint = projectedEdge;
  	      createState.plotWedgeRadiusMeters = radiusMeters;
  	
  	      if (
  	        safeString(createState.plotMode).trim().toLowerCase() === "child-location" &&
  	        safeString(createState.childShapeMode).trim().toLowerCase() === "segment"
  	      ) {
  	        createState.childFixedCenter = center;
  	        createState.childRadiusPoint = projectedRadius;
  	        createState.childEdgePoint = projectedEdge;
  	      }
  	
  	      createState.plotRawPoints = rawWedge.map(point => {
  	        return {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        };
  	      });
  	
  	      createState.plotPoints = resolved.points || [];
  	      createState.plotResolvedPoints = createState.plotPoints.slice();
  	      createState.plotSnapSegments = resolved.snapSegments || [];
  	      createState.plotHeadingPoints = resolved.headingPoints || [];
  	      createState.plotHoleRings = resolved.holeRings || [];
  	      createState.plotHoleLocations = resolved.holeLocations || [];
  	      createState.plotActiveRawIndex = -1;
  	      createState.isSaved = false;
  	
  	      clearEntrancePointDraft();
  	
  	      if (isLive) {
  	        redrawWedgeLiveGeometryOnly(targetMap);
  	      } else {
  	        redrawFreeGroundPlot(targetMap);
  	      }
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Wedge Wizard] Wedge generated and live boundaries applied:", {
  	        source: source || "wedge",
  	        live: isLive,
  	        center,
  	        radius: projectedRadius,
  	        edge: projectedEdge,
  	        radiusMeters,
  	        rawWedgePoints: rawWedge.length,
  	        resolvedPoints: createState.plotPoints.length,
  	        snapSegments: createState.plotSnapSegments,
  	        holeLocations: createState.plotHoleLocations
  	      });
  	
  	      return true;
  	    }
  	
  	    function commitWedgeFromEdgePoint(map, edgePoint, source) {
  	      return applyWedgeFromControlPoints(
  	        map || createState.plotDraftMap,
  	        createState.plotWedgeCenter,
  	        createState.plotWedgeRadiusPoint,
  	        edgePoint,
  	        source || "wedge-edge"
  	      );
  	    }
  	    function translateWedgeControlPoint(point, delta) {
  	      const clean = makeCleanPlotPoint(point);
  	
  	      if (!clean || !delta) return null;
  	
  	      const lat = Number(clean.lat) + Number(delta.lat || 0);
  	      const lng = Number(clean.lng) + Number(delta.lng || 0);
  	
  	      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  	
  	      return {
  	        lat,
  	        lng
  	      };
  	    }
  	
  	    function redrawWedgeLiveGeometryOnly(map) {
  	      const targetMap = map || createState.plotDraftMap;
  	
  	      if (
  	        !targetMap ||
  	        typeof google === "undefined" ||
  	        !google.maps
  	      ) {
  	        return;
  	      }
  	
  	      const points = Array.isArray(createState.plotPoints)
  	      ? createState.plotPoints: [];
  	
  	      const holeRings = Array.isArray(createState.plotHoleRings)
  	      ? createState.plotHoleRings: [];
  	
  	      const center = makeCleanPlotPoint(createState.plotWedgeCenter);
  	      const radius = makeCleanPlotPoint(createState.plotWedgeRadiusPoint);
  	      const edge = makeCleanPlotPoint(createState.plotWedgeEdgePoint);
  	      const color = getFreeGroundPlotColor();
  	
  	      if (
  	        points.length >= 2 &&
  	        google.maps.Polyline
  	      ) {
  	        try {
  	          if (
  	            createState.plotDraftPolyline &&
  	            typeof createState.plotDraftPolyline.setPath === "function"
  	          ) {
  	            createState.plotDraftPolyline.setPath(points);
  	          } else {
  	            createState.plotDraftPolyline = new google.maps.Polyline({
  	              map: targetMap,
  	              path: points,
  	              strokeColor: color,
  	              strokeOpacity: 1,
  	              strokeWeight: 4,
  	              clickable: false,
  	              zIndex: 2147483600
  	            });
  	          }
  	        } catch (_) {}
  	      } else {
  	        try {
  	          if (createState.plotDraftPolyline) {
  	            createState.plotDraftPolyline.setMap(null);
  	          }
  	        } catch (_) {}
  	
  	        createState.plotDraftPolyline = null;
  	      }
  	
  	      if (
  	        points.length >= 3 &&
  	        google.maps.Polygon
  	      ) {
  	        try {
  	          const polygonPaths = [
  	            points,
  	            ...holeRings.filter(ring => Array.isArray(ring) && ring.length >= 3)
  	          ];
  	
  	          if (
  	            createState.plotDraftPolygon &&
  	            typeof createState.plotDraftPolygon.setPaths === "function"
  	          ) {
  	            createState.plotDraftPolygon.setPaths(polygonPaths);
  	          } else {
  	            createState.plotDraftPolygon = new google.maps.Polygon({
  	              map: targetMap,
  	              paths: polygonPaths,
  	              strokeColor: color,
  	              strokeOpacity: 1,
  	              strokeWeight: 4,
  	              fillColor: color,
  	              fillOpacity: 0.22,
  	              clickable: false,
  	              zIndex: 2147483599
  	            });
  	          }
  	        } catch (_) {}
  	      } else {
  	        try {
  	          if (createState.plotDraftPolygon) {
  	            createState.plotDraftPolygon.setMap(null);
  	          }
  	        } catch (_) {}
  	
  	        createState.plotDraftPolygon = null;
  	      }
  	
  	      try {
  	        if (center && createState.plotDraftWedgeCenterMarker) {
  	          createState.plotDraftWedgeCenterMarker.setPosition(center);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (radius && createState.plotDraftWedgeRadiusMarker) {
  	          createState.plotDraftWedgeRadiusMarker.setPosition(radius);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (edge && createState.plotDraftWedgeEdgeMarker) {
  	          createState.plotDraftWedgeEdgeMarker.setPosition(edge);
  	        }
  	      } catch (_) {}
  	
  	      const showWedgeGuideLines = !(
  	        Array.isArray(createState.plotPoints) &&
  	        createState.plotPoints.length >= 3
  	      );
  	
  	      if (showWedgeGuideLines && center && radius) {
  	        try {
  	          if (
  	            createState.plotDraftWedgeRadiusLine &&
  	            typeof createState.plotDraftWedgeRadiusLine.setPath === "function"
  	          ) {
  	            createState.plotDraftWedgeRadiusLine.setPath([center, radius]);
  	          } else if (google.maps.Polyline) {
  	            createState.plotDraftWedgeRadiusLine = new google.maps.Polyline({
  	              map: targetMap,
  	              path: [center, radius],
  	              strokeColor: color,
  	              strokeOpacity: 0.95,
  	              strokeWeight: 2,
  	              clickable: false,
  	              zIndex: 2147483604
  	            });
  	          }
  	        } catch (_) {}
  	      } else {
  	        try {
  	          if (createState.plotDraftWedgeRadiusLine) {
  	            createState.plotDraftWedgeRadiusLine.setMap(null);
  	          }
  	        } catch (_) {}
  	
  	        createState.plotDraftWedgeRadiusLine = null;
  	      }
  	
  	      if (showWedgeGuideLines && center && edge) {
  	        try {
  	          if (
  	            createState.plotDraftWedgeEdgeLine &&
  	            typeof createState.plotDraftWedgeEdgeLine.setPath === "function"
  	          ) {
  	            createState.plotDraftWedgeEdgeLine.setPath([center, edge]);
  	          } else if (google.maps.Polyline) {
  	            createState.plotDraftWedgeEdgeLine = new google.maps.Polyline({
  	              map: targetMap,
  	              path: [center, edge],
  	              strokeColor: color,
  	              strokeOpacity: 0.95,
  	              strokeWeight: 2,
  	              clickable: false,
  	              zIndex: 2147483604
  	            });
  	          }
  	        } catch (_) {}
  	      } else {
  	        try {
  	          if (createState.plotDraftWedgeEdgeLine) {
  	            createState.plotDraftWedgeEdgeLine.setMap(null);
  	          }
  	        } catch (_) {}
  	
  	        createState.plotDraftWedgeEdgeLine = null;
  	      }
  	    }
  	
  	    function makeWedgeControlIcon(label, isCenter) {
  	      return {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        scale: isCenter ? 8: 7,
  	        fillColor: isCenter ? "#ffffff": getFreeGroundPlotColor(),
  	        fillOpacity: 1,
  	        strokeColor: isCenter ? getFreeGroundPlotColor(): "#ffffff",
  	        strokeWeight: 3,
  	        labelOrigin: new google.maps.Point(0, 0)
  	      };
  	    }
  	
  	    function clearWedgeControlMarkers() {
  	      try {
  	        if (createState.plotDraftWedgeCenterMarker) {
  	          createState.plotDraftWedgeCenterMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftWedgeRadiusMarker) {
  	          createState.plotDraftWedgeRadiusMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftWedgeEdgeMarker) {
  	          createState.plotDraftWedgeEdgeMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftWedgeRadiusLine) {
  	          createState.plotDraftWedgeRadiusLine.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftWedgeEdgeLine) {
  	          createState.plotDraftWedgeEdgeLine.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      createState.plotDraftWedgeCenterMarker = null;
  	      createState.plotDraftWedgeRadiusMarker = null;
  	      createState.plotDraftWedgeEdgeMarker = null;
  	      createState.plotDraftWedgeRadiusLine = null;
  	      createState.plotDraftWedgeEdgeLine = null;
  	    }
  	
  	    function redrawWedgeControlMarkers(map) {
  	      clearWedgeControlMarkers();
  	
  	      const isChildSegmentMode = (
  	        createState.plotMode === "child-location" &&
  	        createState.childShapeMode === "segment"
  	      );
  	
  	      if (
  	        (createState.creationMode !== "wedge" && !isChildSegmentMode) ||
  	        !map ||
  	        typeof google === "undefined" ||
  	        !google.maps ||
  	        !google.maps.Marker
  	      ) {
  	        return;
  	      }
  	
  	      const center = makeCleanPlotPoint(createState.plotWedgeCenter);
  	      const radius = makeCleanPlotPoint(createState.plotWedgeRadiusPoint);
  	      const edge = makeCleanPlotPoint(createState.plotWedgeEdgePoint);
  	
  	      if (!center) return;
  	
  	      try {
  	        const centerMarker = new google.maps.Marker({
  	          map,
  	          position: center,
  	          draggable: !isChildSegmentMode,
  	          title: isChildSegmentMode ? "Segment center locked to parent": "Wedge center",
  	          label: "C",
  	          icon: makeWedgeControlIcon("C", true),
  	          zIndex: 2147483605
  	        });
  	
  	        let centerDragStart = null;
  	
  	        centerMarker.addListener("dragstart", () => {
  	          centerDragStart = {
  	            center: makeCleanPlotPoint(createState.plotWedgeCenter),
  	            radius: makeCleanPlotPoint(createState.plotWedgeRadiusPoint),
  	            edge: makeCleanPlotPoint(createState.plotWedgeEdgePoint)
  	          };
  	        });
  	
  	        function moveWedgeCenter(event, isLive) {
  	          const nextCenter = latLngEventToPlain(event?.latLng);
  	
  	          if (!nextCenter) return false;
  	
  	          if (!centerDragStart || !centerDragStart.center) {
  	            centerDragStart = {
  	              center: makeCleanPlotPoint(createState.plotWedgeCenter) || center,
  	              radius: makeCleanPlotPoint(createState.plotWedgeRadiusPoint),
  	              edge: makeCleanPlotPoint(createState.plotWedgeEdgePoint)
  	            };
  	          }
  	
  	          if (!centerDragStart.center) return false;
  	
  	          const delta = {
  	            lat: Number(nextCenter.lat) - Number(centerDragStart.center.lat),
  	            lng: Number(nextCenter.lng) - Number(centerDragStart.center.lng)
  	          };
  	
  	          if (!Number.isFinite(delta.lat) || !Number.isFinite(delta.lng)) {
  	            return false;
  	          }
  	
  	          const nextRadius = centerDragStart.radius
  	          ? translateWedgeControlPoint(centerDragStart.radius, delta): null;
  	
  	          const nextEdge = centerDragStart.edge
  	          ? translateWedgeControlPoint(centerDragStart.edge, delta): null;
  	
  	          // Full Wedge: move the whole shape. R and E travel with C.
  	          if (nextRadius && nextEdge) {
  	            return applyWedgeFromControlPoints(
  	              map,
  	              nextCenter,
  	              nextRadius,
  	              nextEdge,
  	              isLive ? "drag-wedge-center-live": "drag-wedge-center",
  	              {
  	                live: isLive
  	              }
  	            );
  	          }
  	
  	          // Partial Wedge: centre + radius only. Move the construction controls smoothly.
  	          if (nextRadius) {
  	            createState.plotWedgeCenter = nextCenter;
  	            createState.plotWedgeRadiusPoint = nextRadius;
  	            createState.plotWedgeEdgePoint = null;
  	            createState.plotWedgeRadiusMeters = pivotDistanceMeters(nextCenter, nextRadius);
  	            createState.plotRawPoints = [];
  	            createState.plotPoints = [];
  	            createState.plotResolvedPoints = [];
  	            createState.plotSnapSegments = [];
  	            createState.plotHeadingPoints = [];
  	            createState.plotHoleRings = [];
  	            createState.plotHoleLocations = [];
  	            createState.isSaved = false;
  	
  	            if (isLive) {
  	              redrawWedgeLiveGeometryOnly(map);
  	            } else {
  	              redrawFreeGroundPlot(map);
  	            }
  	
  	            return true;
  	          }
  	
  	          // Centre only.
  	          createState.plotWedgeCenter = nextCenter;
  	          createState.plotWedgeRadiusPoint = null;
  	          createState.plotWedgeEdgePoint = null;
  	          createState.plotWedgeRadiusMeters = 0;
  	          createState.plotRawPoints = [];
  	          createState.plotPoints = [];
  	          createState.plotResolvedPoints = [];
  	          createState.plotSnapSegments = [];
  	          createState.plotHeadingPoints = [];
  	          createState.plotHoleRings = [];
  	          createState.plotHoleLocations = [];
  	          createState.isSaved = false;
  	
  	          if (isLive) {
  	            redrawWedgeLiveGeometryOnly(map);
  	          } else {
  	            redrawFreeGroundPlot(map);
  	          }
  	
  	          return true;
  	        }
  	
  	        centerMarker.addListener("drag", event => {
  	          moveWedgeCenter(event, true);
  	        });
  	
  	        centerMarker.addListener("dragend", event => {
  	          const committed = moveWedgeCenter(event, false);
  	
  	          if (!committed) {
  	            redrawFreeGroundPlot(map);
  	          }
  	
  	          centerDragStart = null;
  	        });
  	
  	        createState.plotDraftWedgeCenterMarker = centerMarker;
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Could not create Wedge center marker.",
  	          error);
  	      }
  	
  	      if (radius) {
  	        try {
  	          const radiusMarker = new google.maps.Marker({
  	            map,
  	            position: radius,
  	            draggable: true,
  	            title: "Wedge radius / start arm",
  	            label: "R",
  	            icon: makeWedgeControlIcon("R", false),
  	            zIndex: 2147483606
  	          });
  	
  	          function moveWedgeRadius(event, isLive) {
  	            const nextRadius = latLngEventToPlain(event?.latLng);
  	
  	            if (!nextRadius) return false;
  	
  	            const currentCenter = makeCleanPlotPoint(createState.plotWedgeCenter);
  	            const currentEdge = makeCleanPlotPoint(createState.plotWedgeEdgePoint);
  	
  	            if (!currentCenter) return false;
  	
  	            // Full Wedge: resize / rotate start arm live.
  	            if (currentEdge) {
  	              return applyWedgeFromControlPoints(
  	                map,
  	                currentCenter,
  	                nextRadius,
  	                currentEdge,
  	                isLive ? "drag-wedge-radius-live": "drag-wedge-radius",
  	                {
  	                  live: isLive
  	                }
  	              );
  	            }
  	
  	            // Partial Wedge: only update the construction arm.
  	            const radiusMeters = pivotDistanceMeters(currentCenter, nextRadius);
  	
  	            if (!Number.isFinite(radiusMeters) || radiusMeters <= 0.25) {
  	              return false;
  	            }
  	
  	            createState.plotWedgeRadiusPoint = nextRadius;
  	            createState.plotWedgeRadiusMeters = radiusMeters;
  	            createState.plotRawPoints = [];
  	            createState.plotPoints = [];
  	            createState.plotResolvedPoints = [];
  	            createState.plotSnapSegments = [];
  	            createState.plotHeadingPoints = [];
  	            createState.plotHoleRings = [];
  	            createState.plotHoleLocations = [];
  	            createState.isSaved = false;
  	
  	            if (isLive) {
  	              redrawWedgeLiveGeometryOnly(map);
  	            } else {
  	              redrawFreeGroundPlot(map);
  	            }
  	
  	            return true;
  	          }
  	
  	          radiusMarker.addListener("drag", event => {
  	            moveWedgeRadius(event, true);
  	          });
  	
  	          radiusMarker.addListener("dragend", event => {
  	            const committed = moveWedgeRadius(event, false);
  	
  	            if (!committed) {
  	              redrawFreeGroundPlot(map);
  	            }
  	          });
  	
  	          createState.plotDraftWedgeRadiusMarker = radiusMarker;
  	        } catch (error) {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Could not create Wedge radius marker.",
  	            error);
  	        }
  	      }
  	
  	      if (edge) {
  	        try {
  	          const edgeMarker = new google.maps.Marker({
  	            map,
  	            position: edge,
  	            draggable: true,
  	            title: "Wedge edge / end arm",
  	            label: "E",
  	            icon: makeWedgeControlIcon("E", false),
  	            zIndex: 2147483607
  	          });
  	
  	          function moveWedgeEdge(event, isLive) {
  	            const nextEdge = latLngEventToPlain(event?.latLng);
  	
  	            if (!nextEdge) return false;
  	
  	            const currentCenter = makeCleanPlotPoint(createState.plotWedgeCenter);
  	            const currentRadius = makeCleanPlotPoint(createState.plotWedgeRadiusPoint);
  	
  	            if (!currentCenter || !currentRadius) return false;
  	
  	            return applyWedgeFromControlPoints(
  	              map,
  	              currentCenter,
  	              currentRadius,
  	              nextEdge,
  	              isLive ? "drag-wedge-edge-live": "drag-wedge-edge",
  	              {
  	                live: isLive
  	              }
  	            );
  	          }
  	
  	          edgeMarker.addListener("drag", event => {
  	            moveWedgeEdge(event, true);
  	          });
  	
  	          edgeMarker.addListener("dragend", event => {
  	            const committed = moveWedgeEdge(event, false);
  	
  	            if (!committed) {
  	              redrawFreeGroundPlot(map);
  	            }
  	          });
  	
  	          createState.plotDraftWedgeEdgeMarker = edgeMarker;
  	        } catch (error) {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Could not create Wedge edge marker.",
  	            error);
  	        }
  	      }
  	
  	      const showWedgeGuideLines = !(
  	        Array.isArray(createState.plotPoints) &&
  	        createState.plotPoints.length >= 3
  	      );
  	
  	      if (showWedgeGuideLines) {
  	        try {
  	          if (google.maps.Polyline && center && radius) {
  	            createState.plotDraftWedgeRadiusLine = new google.maps.Polyline({
  	              map,
  	              path: [center, radius],
  	              strokeColor: getFreeGroundPlotColor(),
  	              strokeOpacity: 0.95,
  	              strokeWeight: 2,
  	              clickable: false,
  	              zIndex: 2147483604
  	            });
  	          }
  	        } catch (_) {}
  	
  	        try {
  	          if (google.maps.Polyline && center && edge) {
  	            createState.plotDraftWedgeEdgeLine = new google.maps.Polyline({
  	              map,
  	              path: [center, edge],
  	              strokeColor: getFreeGroundPlotColor(),
  	              strokeOpacity: 0.95,
  	              strokeWeight: 2,
  	              clickable: false,
  	              zIndex: 2147483604
  	            });
  	          }
  	        } catch (_) {}
  	      }
  	    }
  	
  	    async function handleWedgeExistingLocationClick(location, clickedPoint, map) {
  	      if (!clickedPoint) return false;
  	
  	      const hasCenter = !!makeCleanPlotPoint(createState.plotWedgeCenter);
  	      const hasRadius = !!makeCleanPlotPoint(createState.plotWedgeRadiusPoint);
  	
  	      if (hasCenter && hasRadius) {
  	        return commitWedgeFromEdgePoint(
  	          map,
  	          clickedPoint,
  	          "wedge-edge-inside-existing-location"
  	        );
  	      }
  	
  	      if (hasCenter && !hasRadius) {
  	        return setWedgeRadiusPoint(
  	          map,
  	          clickedPoint,
  	          "wedge-radius-inside-existing-location"
  	        );
  	      }
  	
  	      if (createState.plotMode === "child-location") {
  	        return setWedgeCenterPoint(
  	          map,
  	          clickedPoint,
  	          "wedge-child-center-inside-parent"
  	        );
  	      }
  	
  	      const parentBlocker = getContainingParentBlockerForPoint(clickedPoint, location);
  	
  	      if (!parentBlocker || !parentBlocker.location) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Could not identify parent Location for child Wedge.", {
  	          clickedPoint,
  	          clickedLocation: location
  	        });
  	
  	        return true;
  	      }
  	
  	      const makeChild = await confirmCreateAsChildLocation(parentBlocker.location, {
  	        clickedPoint,
  	        clickedLocation: location,
  	        parentBlocker
  	      });
  	
  	      if (!makeChild) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Wedge Wizard] Child Wedge creation cancelled.", {
  	          parentLocationId: parentBlocker.locationId,
  	          parentLocation: parentBlocker.location,
  	          clickedPoint
  	        });
  	
  	        return true;
  	      }
  	
  	      clearFreeGroundPlotDraft();
  	
  	      createState.plotMode = "child-location";
  	      createState.plotParentLocation = parentBlocker.location;
  	      createState.plotParentLocationId = parentBlocker.locationId || rendererGetLocationId(parentBlocker.location);
  	
  	      // Empty childShapeMode means: use the selected main Creation Mode.
  	      // For this case, that is a normal child Wedge inside a Polygon parent.
  	      createState.childShapeMode = "";
  	      createState.childFixedCenter = null;
  	      createState.childRadiusPoint = null;
  	      createState.childEdgePoint = null;
  	
  	      setWedgeCenterPoint(
  	        map,
  	        clickedPoint,
  	        "wedge-child-center"
  	      );
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Wedge Wizard] Switched to Child Wedge Mode:", {
  	        parentLocationId: createState.plotParentLocationId,
  	        parentLocation: createState.plotParentLocation,
  	        center: clickedPoint
  	      });
  	
  	      return true;
  	    }
  	
  	    async function handleWedgeMapClick(map, point) {
  	      if (!isCreatePlottingActive()) return false;
  	      if (!point) return false;
  	
  	      const hasCenter = !!makeCleanPlotPoint(createState.plotWedgeCenter);
  	      const hasRadius = !!makeCleanPlotPoint(createState.plotWedgeRadiusPoint);
  	
  	      if (!hasCenter) {
  	        return setWedgeCenterPoint(
  	          map,
  	          point,
  	          createState.plotMode === "child-location"
  	          ? "wedge-child-center": "wedge-center"
  	        );
  	      }
  	
  	      if (!hasRadius) {
  	        return setWedgeRadiusPoint(
  	          map,
  	          point,
  	          createState.plotMode === "child-location"
  	          ? "wedge-child-radius": "wedge-radius"
  	        );
  	      }
  	
  	      return commitWedgeFromEdgePoint(
  	        map,
  	        point,
  	        createState.plotMode === "child-location"
  	        ? "wedge-child-edge": "wedge-edge"
  	      );
  	    }
  	
  	    async function handleActiveChildLocationPoint(map, point, source) {
  	      if (!point) return false;
  	
  	      const childMode = safeString(createState.childShapeMode || "")
  	      .trim()
  	      .toLowerCase();
  	
  	      // Special child submodes:
  	      // Polygon / Ring / Segment chosen from the child shape prompt.
  	      if (childMode) {
  	        return handleChildShapeModePoint(
  	          map,
  	          point,
  	          source || "child-location-point"
  	        );
  	      }
  	
  	      // Normal child Pivot/Wedge inside a Polygon parent.
  	      // These must continue using the selected main Creation Mode.
  	      if (createState.creationMode === "pivot") {
  	        return await handlePivotMapClick(
  	          map,
  	          point
  	        );
  	      }
  	
  	      if (createState.creationMode === "wedge") {
  	        return await handleWedgeMapClick(
  	          map,
  	          point
  	        );
  	      }
  	
  	      // Normal child Polygon.
  	      return handleChildShapeModePoint(
  	        map,
  	        point,
  	        source || "child-location-point"
  	      );
  	    }
  	
  	    function makePivotControlIcon(label, isCenter) {
  	      return {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        scale: isCenter ? 8: 7,
  	        fillColor: isCenter ? "#ffffff": getFreeGroundPlotColor(),
  	        fillOpacity: 1,
  	        strokeColor: isCenter ? getFreeGroundPlotColor(): "#ffffff",
  	        strokeWeight: 3,
  	        labelOrigin: new google.maps.Point(0, 0)
  	      };
  	    }
  	
  	    function clearPivotControlMarkers() {
  	      try {
  	        if (createState.plotDraftPivotCenterMarker) {
  	          createState.plotDraftPivotCenterMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPivotRadiusMarker) {
  	          createState.plotDraftPivotRadiusMarker.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      try {
  	        if (createState.plotDraftPivotRadiusLine) {
  	          createState.plotDraftPivotRadiusLine.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      createState.plotDraftPivotCenterMarker = null;
  	      createState.plotDraftPivotRadiusMarker = null;
  	      createState.plotDraftPivotRadiusLine = null;
  	    }
  	
  	    function redrawPivotControlMarkers(map) {
  	      clearPivotControlMarkers();
  	
  	      const isChildRingMode = (
  	        createState.plotMode === "child-location" &&
  	        createState.childShapeMode === "ring"
  	      );
  	
  	      if (
  	        (createState.creationMode !== "pivot" && !isChildRingMode) ||
  	        !map ||
  	        typeof google === "undefined" ||
  	        !google.maps ||
  	        !google.maps.Marker
  	      ) {
  	        return;
  	      }
  	
  	      const center = makeCleanPlotPoint(createState.plotPivotCenter);
  	      const radius = makeCleanPlotPoint(createState.plotPivotRadiusPoint);
  	
  	      if (!center) return;
  	
  	      try {
  	        const centerMarker = new google.maps.Marker({
  	          map,
  	          position: center,
  	          draggable: !isChildRingMode,
  	          title: isChildRingMode ? "Ring center locked to parent": "Pivot center",
  	          label: "C",
  	          icon: makePivotControlIcon("C", true),
  	          zIndex: 2147483605
  	        });
  	
  	        let centerDragStartCenter = null;
  	        let centerDragStartRadius = null;
  	
  	        centerMarker.addListener("dragstart", () => {
  	          centerDragStartCenter = makeCleanPlotPoint(createState.plotPivotCenter);
  	          centerDragStartRadius = makeCleanPlotPoint(createState.plotPivotRadiusPoint);
  	        });
  	
  	        centerMarker.addListener("drag", event => {
  	          const nextCenter = latLngEventToPlain(event?.latLng);
  	
  	          if (!nextCenter) return;
  	
  	          if (!centerDragStartCenter) {
  	            centerDragStartCenter = makeCleanPlotPoint(createState.plotPivotCenter) || center;
  	          }
  	
  	          if (!centerDragStartRadius) {
  	            centerDragStartRadius = makeCleanPlotPoint(createState.plotPivotRadiusPoint);
  	          }
  	
  	          if (!centerDragStartRadius) {
  	            createState.plotPivotCenter = nextCenter;
  	            return;
  	          }
  	
  	          const deltaLat = Number(nextCenter.lat) - Number(centerDragStartCenter.lat);
  	          const deltaLng = Number(nextCenter.lng) - Number(centerDragStartCenter.lng);
  	
  	          const nextRadius = {
  	            lat: Number(centerDragStartRadius.lat) + deltaLat,
  	            lng: Number(centerDragStartRadius.lng) + deltaLng
  	          };
  	
  	          applyPivotCircleFromCenterAndRadiusPoint(
  	            map,
  	            nextCenter,
  	            nextRadius,
  	            "drag-pivot-center-live",
  	            {
  	              live: true
  	            }
  	          );
  	        });
  	
  	        centerMarker.addListener("dragend",
  	          event => {
  	            const nextCenter = latLngEventToPlain(event?.latLng);
  	
  	            if (!nextCenter) return;
  	
  	            if (!centerDragStartCenter) {
  	              centerDragStartCenter = makeCleanPlotPoint(createState.plotPivotCenter) || center;
  	            }
  	
  	            if (!centerDragStartRadius) {
  	              centerDragStartRadius = makeCleanPlotPoint(createState.plotPivotRadiusPoint);
  	            }
  	
  	            if (!centerDragStartRadius) {
  	              createState.plotPivotCenter = nextCenter;
  	              redrawFreeGroundPlot(map);
  	              return;
  	            }
  	
  	            const deltaLat = Number(nextCenter.lat) - Number(centerDragStartCenter.lat);
  	            const deltaLng = Number(nextCenter.lng) - Number(centerDragStartCenter.lng);
  	
  	            const nextRadius = {
  	              lat: Number(centerDragStartRadius.lat) + deltaLat,
  	              lng: Number(centerDragStartRadius.lng) + deltaLng
  	            };
  	
  	            const committed = applyPivotCircleFromCenterAndRadiusPoint(
  	              map,
  	              nextCenter,
  	              nextRadius,
  	              "drag-pivot-center",
  	              {
  	                live: false
  	              }
  	            );
  	
  	            if (!committed) {
  	              redrawFreeGroundPlot(map);
  	            }
  	
  	            centerDragStartCenter = null;
  	            centerDragStartRadius = null;
  	          });
  	
  	        createState.plotDraftPivotCenterMarker = centerMarker;
  	      } catch (_) {}
  	
  	      if (!radius) return;
  	
  	      try {
  	        const radiusMarker = new google.maps.Marker({
  	          map,
  	          position: radius,
  	          draggable: true,
  	          title: "Pivot radius",
  	          label: "R",
  	          icon: makePivotControlIcon("R", false),
  	          zIndex: 2147483606
  	        });
  	
  	        radiusMarker.addListener("drag", event => {
  	          const nextRadius = latLngEventToPlain(event?.latLng);
  	
  	          if (!nextRadius) return;
  	
  	          applyPivotCircleFromCenterAndRadiusPoint(
  	            map,
  	            createState.plotPivotCenter,
  	            nextRadius,
  	            "drag-pivot-radius-live",
  	            {
  	              live: true
  	            }
  	          );
  	        });
  	
  	        radiusMarker.addListener("dragend",
  	          event => {
  	            const nextRadius = latLngEventToPlain(event?.latLng);
  	
  	            if (!nextRadius) return;
  	
  	            const committed = applyPivotCircleFromCenterAndRadiusPoint(
  	              map,
  	              createState.plotPivotCenter,
  	              nextRadius,
  	              "drag-pivot-radius",
  	              {
  	                live: false
  	              }
  	            );
  	
  	            if (!committed) {
  	              redrawFreeGroundPlot(map);
  	            }
  	          });
  	
  	        createState.plotDraftPivotRadiusMarker = radiusMarker;
  	      } catch (_) {}
  	
  	      try {
  	        if (google.maps.Polyline) {
  	          createState.plotDraftPivotRadiusLine = new google.maps.Polyline({
  	            map,
  	            path: [center, radius],
  	            strokeColor: getFreeGroundPlotColor(),
  	            strokeOpacity: 0.95,
  	            strokeWeight: 2,
  	            clickable: false,
  	            zIndex: 2147483604
  	          });
  	        }
  	      } catch (_) {}
  	    }
  	
  	    async function handlePivotExistingLocationClick(location, clickedPoint, map) {
  	      if (!clickedPoint) return false;
  	
  	      const hasCenter = !!makeCleanPlotPoint(createState.plotPivotCenter);
  	
  	      if (hasCenter) {
  	        return commitPivotCircleFromRadiusPoint(
  	          map,
  	          clickedPoint,
  	          "pivot-radius-inside-existing-location"
  	        );
  	      }
  	
  	      if (createState.plotMode === "child-location") {
  	        return setPivotCenterPoint(
  	          map,
  	          clickedPoint,
  	          "pivot-child-center-inside-parent"
  	        );
  	      }
  	
  	      const parentBlocker = getContainingParentBlockerForPoint(clickedPoint, location);
  	
  	      if (!parentBlocker || !parentBlocker.location) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Pivot Wizard] Could not identify parent Location for child Pivot.", {
  	          clickedPoint,
  	          clickedLocation: location
  	        });
  	
  	        return true;
  	      }
  	
  	      const makeChild = await confirmCreateAsChildLocation(parentBlocker.location, {
  	        clickedPoint,
  	        clickedLocation: location,
  	        parentBlocker
  	      });
  	
  	      if (!makeChild) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Pivot Wizard] Child Pivot creation cancelled.", {
  	          parentLocationId: parentBlocker.locationId,
  	          parentLocation: parentBlocker.location,
  	          clickedPoint
  	        });
  	
  	        return true;
  	      }
  	
  	      clearFreeGroundPlotDraft();
  	
  	      createState.plotMode = "child-location";
  	      createState.plotParentLocation = parentBlocker.location;
  	      createState.plotParentLocationId = parentBlocker.locationId || rendererGetLocationId(parentBlocker.location);
  	
  	      // Empty childShapeMode means: use the selected main Creation Mode.
  	      // For this case, that is a normal child Pivot inside a Polygon parent.
  	      createState.childShapeMode = "";
  	      createState.childFixedCenter = null;
  	      createState.childRadiusPoint = null;
  	      createState.childEdgePoint = null;
  	
  	      setPivotCenterPoint(
  	        map,
  	        clickedPoint,
  	        "pivot-child-center"
  	      );
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Pivot Wizard] Switched to Child Pivot Mode:", {
  	        parentLocationId: createState.plotParentLocationId,
  	        parentLocation: createState.plotParentLocation,
  	        center: clickedPoint
  	      });
  	
  	      return true;
  	    }
  	
  	    async function handlePivotMapClick(map, point) {
  	      if (!isCreatePlottingActive()) return false;
  	      if (!point) return false;
  	
  	      const hasCenter = !!makeCleanPlotPoint(createState.plotPivotCenter);
  	
  	      if (!hasCenter) {
  	        return setPivotCenterPoint(
  	          map,
  	          point,
  	          createState.plotMode === "child-location"
  	          ? "pivot-child-center": "pivot-center"
  	        );
  	      }
  	
  	      return commitPivotCircleFromRadiusPoint(
  	        map,
  	        point,
  	        createState.plotMode === "child-location"
  	        ? "pivot-child-radius": "pivot-radius"
  	      );
  	    }
  	
  	    function addFreeGroundPlotPoint(map, point, source) {
  	      if (!isCreatePlottingActive()) return false;
  	      if (!point) return false;
  	
  	      const cleanPoint = {
  	        lat: Number(point.lat),
  	        lng: Number(point.lng)
  	      };
  	
  	      if (!Number.isFinite(cleanPoint.lat) || !Number.isFinite(cleanPoint.lng)) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Invalid plot point ignored.", point);
  	        return false;
  	      }
  	
  	      if (!Array.isArray(createState.plotRawPoints)) {
  	        createState.plotRawPoints = [];
  	      }
  	
  	      const nextRawPoints = createState.plotRawPoints.slice();
  	
  	      nextRawPoints.push(cleanPoint);
  	
  	      const committed = commitFreeGroundRawPoints(
  	        map || createState.plotDraftMap,
  	        nextRawPoints,
  	        source || "free-ground",
  	        nextRawPoints.length - 1
  	      );
  	
  	      if (!committed) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Point rejected.", {
  	          source: source || "free-ground",
  	          point: cleanPoint
  	        });
  	
  	        return false;
  	      }
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Point added and live snap applied:", {
  	        source: source || "free-ground",
  	        rawPoint: cleanPoint,
  	        rawTotal: createState.plotRawPoints.length,
  	        resolvedTotal: createState.plotPoints.length,
  	        snapSegments: createState.plotSnapSegments,
  	        mode: createState.plotMode
  	      });
  	
  	      return true;
  	    }
  	
  	    function findBoundaryPointOnHeading(lastPoint, clickedPoint, location) {
  	      const boundary = getLocationOuterBoundary(location);
  	
  	      if (!boundary || boundary.length < 3) return null;
  	
  	      let best = null;
  	
  	      for (let i = 0; i < boundary.length; i++) {
  	        const a = boundary[i];
  	        const b = boundary[(i + 1) % boundary.length];
  	        const hit = lineIntersectionPoint(lastPoint, clickedPoint, a, b);
  	
  	        if (!hit) continue;
  	
  	        if (!best || hit.t < best.t) {
  	          best = {
  	            point: hit.point,
  	            t: hit.t,
  	            segmentIndex: i
  	          };
  	        }
  	      }
  	
  	      if (best && best.point) {
  	        return best.point;
  	      }
  	
  	      return nearestPointOnBoundary(clickedPoint, boundary);
  	    }
  	
  	    function confirmCreateAsChildLocation(parentLocation, details) {
  	      if (freeGroundChildPromptOpen) {
  	        return Promise.resolve(false);
  	      }
  	
  	      const name = rendererGetLocationName(parentLocation);
  	      const parentId = rendererGetLocationId(parentLocation);
  	      const clickedLocation = details?.clickedLocation || null;
  	      const clickedName = clickedLocation ? rendererGetLocationName(clickedLocation): "";
  	      const clickedIsDifferent = clickedLocation && rendererGetLocationId(clickedLocation) !== parentId;
  	
  	      freeGroundChildPromptOpen = true;
  	
  	      return new Promise(resolvePrompt => {
  	        let resolved = false;
  	
  	        function closePrompt(result) {
  	          if (resolved) return;
  	
  	          resolved = true;
  	          freeGroundChildPromptOpen = false;
  	
  	          try {
  	            document.removeEventListener("keydown", handleKeydown, true);
  	          } catch (_) {}
  	
  	          try {
  	            if (overlay && overlay.parentNode) {
  	              overlay.parentNode.removeChild(overlay);
  	            }
  	          } catch (_) {}
  	
  	          resolvePrompt(!!result);
  	        }
  	
  	        function handleKeydown(event) {
  	          if (event.key === "Escape") {
  	            event.preventDefault();
  	            closePrompt(false);
  	          }
  	        }
  	
  	        const overlay = document.createElement("div");
  	
  	        overlay.className = "trackit-free-ground-child-confirm";
  	        overlay.innerHTML = `
  	        <div class="trackit-free-ground-child-confirm-backdrop"></div>
  	
  	        <div class="trackit-free-ground-child-confirm-card" role="dialog" aria-modal="true">
  	        <div class="trackit-free-ground-child-confirm-glow"></div>
  	
  	        <div class="trackit-free-ground-child-confirm-icon">↳</div>
  	
  	        <div class="trackit-free-ground-child-confirm-kicker">Child Location Required</div>
  	
  	        <div class="trackit-free-ground-child-confirm-title">
  	        Create inside ${escapeHtml(name)}
  	        </div>
  	
  	        <div class="trackit-free-ground-child-confirm-body">
  	        This starting point is inside an existing Primary Free Ground Location.
  	        A new Primary Location cannot be created inside another Primary Location.
  	        </div>
  	
  	        <div class="trackit-free-ground-child-confirm-parent">
  	        <span>Parent Boundary</span>
  	        <strong>${escapeHtml(name)}</strong>
  	        </div>
  	
  	        ${
  	        clickedIsDifferent
  	        ? `
  	        <div class="trackit-free-ground-child-confirm-note">
  	        You clicked inside <strong>${escapeHtml(clickedName)}</strong>, but the containing parent boundary is
  	        <strong>${escapeHtml(name)}</strong>.
  	        </div>
  	        `: ""
  	        }
  	
  	        <div class="trackit-free-ground-child-confirm-warning">
  	        If you proceed, this plot will become a Child Location and future points must stay inside the parent boundary.
  	        </div>
  	
  	        <div class="trackit-free-ground-child-confirm-actions">
  	        <button type="button" class="trackit-free-ground-child-confirm-cancel">
  	        Cancel
  	        </button>
  	
  	        <button type="button" class="trackit-free-ground-child-confirm-proceed">
  	        Create Child Location
  	        </button>
  	        </div>
  	        </div>
  	        `;
  	
  	        const style = document.createElement("style");
  	
  	        style.textContent = `
  	        .trackit-free-ground-child-confirm {
  	        position: fixed;
  	        inset: 0;
  	        z-index: 2147483647;
  	        display: grid;
  	        place-items: center;
  	        padding: 22px;
  	        font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  	        }
  	
  	        .trackit-free-ground-child-confirm-backdrop {
  	        position: absolute;
  	        inset: 0;
  	        background:
  	        radial-gradient(circle at 50% 20%, rgba(255,122,36,0.22), rgba(0,0,0,0.00) 34%),
  	        rgba(0,0,0,0.74);
  	        backdrop-filter: blur(8px);
  	        }
  	
  	        .trackit-free-ground-child-confirm-card {
  	        position: relative;
  	        width: min(430px, calc(100vw - 44px));
  	        padding: 20px;
  	        border-radius: 28px;
  	        overflow: hidden;
  	        color: rgba(255,244,235,0.96);
  	        background:
  	        radial-gradient(circle at 0% 0%, rgba(255,122,36,0.28), rgba(255,122,36,0.00) 42%),
  	        linear-gradient(145deg, rgba(23,18,15,0.98), rgba(7,8,10,0.98));
  	        border: 1px solid rgba(255,154,61,0.34);
  	        box-shadow:
  	        0 26px 80px rgba(0,0,0,0.70),
  	        inset 0 1px 0 rgba(255,255,255,0.08);
  	        }
  	
  	        .trackit-free-ground-child-confirm-glow {
  	        position: absolute;
  	        inset: auto -40px -80px -40px;
  	        height: 140px;
  	        background: radial-gradient(circle, rgba(255,122,36,0.24), rgba(255,122,36,0.00) 68%);
  	        pointer-events: none;
  	        }
  	
  	        .trackit-free-ground-child-confirm-icon {
  	        width: 46px;
  	        height: 46px;
  	        display: grid;
  	        place-items: center;
  	        border-radius: 18px;
  	        margin-bottom: 12px;
  	        color: #111;
  	        background: linear-gradient(145deg, #ffb45c, #ff7a24);
  	        box-shadow: 0 12px 34px rgba(255,122,36,0.32);
  	        font-size: 27px;
  	        font-weight: 900;
  	        }
  	
  	        .trackit-free-ground-child-confirm-kicker {
  	        font-size: 11px;
  	        font-weight: 900;
  	        letter-spacing: 0.14em;
  	        text-transform: uppercase;
  	        color: rgba(255,184,123,0.84);
  	        margin-bottom: 6px;
  	        }
  	
  	        .trackit-free-ground-child-confirm-title {
  	        font-size: 22px;
  	        line-height: 1.12;
  	        font-weight: 950;
  	        letter-spacing: -0.04em;
  	        margin-bottom: 10px;
  	        }
  	
  	        .trackit-free-ground-child-confirm-body {
  	        font-size: 13px;
  	        line-height: 1.55;
  	        color: rgba(255,226,207,0.76);
  	        margin-bottom: 14px;
  	        }
  	
  	        .trackit-free-ground-child-confirm-parent {
  	        display: grid;
  	        gap: 4px;
  	        padding: 12px 13px;
  	        border-radius: 18px;
  	        background: rgba(255,122,36,0.10);
  	        border: 1px solid rgba(255,154,61,0.22);
  	        margin-bottom: 10px;
  	        }
  	
  	        .trackit-free-ground-child-confirm-parent span {
  	        font-size: 10px;
  	        font-weight: 900;
  	        letter-spacing: 0.12em;
  	        text-transform: uppercase;
  	        color: rgba(255,184,123,0.74);
  	        }
  	
  	        .trackit-free-ground-child-confirm-parent strong {
  	        font-size: 14px;
  	        color: rgba(255,247,240,0.96);
  	        }
  	
  	        .trackit-free-ground-child-confirm-note,
  	        .trackit-free-ground-child-confirm-warning {
  	        font-size: 12px;
  	        line-height: 1.45;
  	        color: rgba(255,226,207,0.72);
  	        padding: 10px 12px;
  	        border-radius: 16px;
  	        background: rgba(0,0,0,0.22);
  	        border: 1px solid rgba(255,255,255,0.07);
  	        margin-bottom: 10px;
  	        }
  	
  	        .trackit-free-ground-child-confirm-warning {
  	        color: rgba(255,213,178,0.86);
  	        border-color: rgba(255,154,61,0.16);
  	        }
  	
  	        .trackit-free-ground-child-confirm-actions {
  	        position: relative;
  	        display: grid;
  	        grid-template-columns: 1fr 1.25fr;
  	        gap: 10px;
  	        margin-top: 16px;
  	        }
  	
  	        .trackit-free-ground-child-confirm-actions button {
  	        min-height: 42px;
  	        border: 0;
  	        border-radius: 16px;
  	        font-size: 13px;
  	        font-weight: 900;
  	        cursor: pointer;
  	        }
  	
  	        .trackit-free-ground-child-confirm-cancel {
  	        color: rgba(255,226,207,0.82);
  	        background: rgba(255,255,255,0.08);
  	        box-shadow: inset 0 0 0 1px rgba(255,255,255,0.10);
  	        }
  	
  	        .trackit-free-ground-child-confirm-proceed {
  	        color: #160b03;
  	        background: linear-gradient(145deg, #ffb45c, #ff7a24);
  	        box-shadow: 0 14px 34px rgba(255,122,36,0.28);
  	        }
  	
  	        .trackit-free-ground-child-confirm-actions button:hover {
  	        transform: translateY(-1px);
  	        }
  	        `;
  	
  	        overlay.appendChild(style);
  	        document.body.appendChild(overlay);
  	
  	        const cancelButton = overlay.querySelector(".trackit-free-ground-child-confirm-cancel");
  	        const proceedButton = overlay.querySelector(".trackit-free-ground-child-confirm-proceed");
  	        const backdrop = overlay.querySelector(".trackit-free-ground-child-confirm-backdrop");
  	
  	        if (cancelButton) {
  	          cancelButton.addEventListener("click", () => closePrompt(false));
  	        }
  	
  	        if (proceedButton) {
  	          proceedButton.addEventListener("click", () => closePrompt(true));
  	          setTimeout(() => {
  	            try {
  	              proceedButton.focus();
  	            } catch (_) {}
  	          }, 0);
  	        }
  	
  	        if (backdrop) {
  	          backdrop.addEventListener("click", () => closePrompt(false));
  	        }
  	
  	        document.addEventListener("keydown", handleKeydown, true);
  	      });
  	    }
  	
  	    async function handleExistingLocationDuringFreeGroundPlot(location,
  	      clickedPoint,
  	      map) {
  	      if (!isCreatePlottingActive()) return false;
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Existing Location clicked:");
  	      FIF_SILENT_CONSOLE.log(location);
  	
  	      if (!clickedPoint) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Existing Location click had no valid point.");
  	        return false;
  	      }
  	
  	      // Entrance picking must win over every polygon/child/pivot/wedge click route.
  	      // Saved parent/child polygons can intercept the click before the map click fires,
  	      // so this must be handled here as well as in handleFreeGroundMapClick().
  	      if (createState.isPickingEntrance) {
  	        const picked = setEntrancePointSnapped(map, clickedPoint);
  	
  	        return !!picked;
  	      }
  	
  	      if (createState.plotMode === "child-location") {
  	        return await handleActiveChildLocationPoint(
  	          map,
  	          clickedPoint,
  	          "child-location-point-inside-parent"
  	        );
  	      }
  	
  	      const rawPoints = Array.isArray(createState.plotRawPoints)
  	      ? createState.plotRawPoints: [];
  	
  	      if (!rawPoints.length) {
  	        const parentBlocker = getContainingParentBlockerForPoint(clickedPoint, location);
  	
  	        if (!parentBlocker || !parentBlocker.location) {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Could not identify parent Location for child creation.", {
  	            clickedPoint,
  	            clickedLocation: location
  	          });
  	
  	          return true;
  	        }
  	
  	        if (isPivotOrWedgeLocation(parentBlocker.location)) {
  	          const childShapeMode = await confirmChildShapeModeForParent(parentBlocker.location, {
  	            clickedPoint,
  	            clickedLocation: location,
  	            parentBlocker
  	          });
  	
  	          if (childShapeMode) {
  	            beginChildLocationFromParentWithMode(
  	              map,
  	              parentBlocker,
  	              clickedPoint,
  	              childShapeMode
  	            );
  	
  	            return true;
  	          }
  	
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Child Shape Wizard] Child Shape Mode selection cancelled.", {
  	            parentLocationId: parentBlocker.locationId,
  	            parentLocation: parentBlocker.location,
  	            clickedPoint
  	          });
  	
  	          return true;
  	        }
  	
  	        if (createState.creationMode === "pivot") {
  	          return await handlePivotExistingLocationClick(location, clickedPoint, map);
  	        }
  	
  	        if (createState.creationMode === "wedge") {
  	          return await handleWedgeExistingLocationClick(location, clickedPoint, map);
  	        }
  	
  	        const makeChild = await confirmCreateAsChildLocation(parentBlocker.location, {
  	          clickedPoint,
  	          clickedLocation: location,
  	          parentBlocker
  	        });
  	
  	        if (makeChild) {
  	          beginChildLocationFromParent(map, parentBlocker, clickedPoint);
  	          return true;
  	        }
  	
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Child Location creation cancelled.", {
  	          parentLocationId: parentBlocker.locationId,
  	          parentLocation: parentBlocker.location,
  	          clickedPoint
  	        });
  	
  	        return true;
  	      }
  	
  	      if (createState.creationMode === "pivot") {
  	        return await handlePivotExistingLocationClick(location, clickedPoint, map);
  	      }
  	
  	      if (createState.creationMode === "wedge") {
  	        return await handleWedgeExistingLocationClick(location, clickedPoint, map);
  	      }
  	
  	      addFreeGroundPlotPoint(map, clickedPoint, "free-ground-heading-inside-existing-location");
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Existing Location used as heading point. Live snap recalculated:", {
  	        headingPoint: clickedPoint,
  	        clickedLocation: location,
  	        rawPoints: createState.plotRawPoints,
  	        resolvedPoints: createState.plotPoints
  	      });
  	
  	      return true;
  	    }
  	
  	    async function handleFreeGroundMapClick(map, point) {
  	      if (!isCreatePlottingActive()) return false;
  	
  	      if (!point) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Map click had no valid lat/lng.");
  	        return false;
  	      }
  	
  	      if (createState.isPickingEntrance) {
  	        const picked = setEntrancePointSnapped(map, point);
  	
  	        return !!picked;
  	      }
  	
  	      if (createState.plotMode === "child-location") {
  	        return await handleActiveChildLocationPoint(
  	          map,
  	          point,
  	          "child-location-point"
  	        );
  	      }
  	
  	      if (createState.creationMode === "pivot") {
  	        return await handlePivotMapClick(map, point);
  	      }
  	
  	      if (createState.creationMode === "wedge") {
  	        return await handleWedgeMapClick(map, point);
  	      }
  	
  	      const rawPoints = Array.isArray(createState.plotRawPoints)
  	      ? createState.plotRawPoints: [];
  	
  	      if (!rawPoints.length) {
  	        const containingBlocker = getContainingBlockerForPoint(point, getFreeGroundBlockers());
  	
  	        if (containingBlocker && containingBlocker.location) {
  	          return await handleExistingLocationDuringFreeGroundPlot(containingBlocker.location, point, map);
  	        }
  	      }
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Free Ground Wizard] Free Ground");
  	
  	      addFreeGroundPlotPoint(map, point, "free-ground");
  	
  	      return true;
  	    }
  	
  	    function bindCreatePlotFreeGroundClick(map) {
  	      if (!map || map.__trackitCreatePlotFreeGroundClickBound) return;
  	
  	      map.__trackitCreatePlotFreeGroundClickBound = true;
  	
  	      try {
  	        map.addListener("click", function (event) {
  	          if (!isCreatePlottingActive()) return;
  	
  	          const lastPolygonClickAt = map.__trackitCreateLastPolygonClickAt || 0;
  	
  	          if (Date.now() - lastPolygonClickAt < 120) {
  	            return;
  	          }
  	
  	          const point = latLngEventToPlain(event?.latLng);
  	
  	          handleFreeGroundMapClick(map, point).then(() => {
  	            try {
  	              const root = document.getElementById(ENGINE_ID);
  	
  	              if (root && DATA_CHANNEL) {
  	                renderTop(root);
  	                renderModal(root);
  	              }
  	            } catch (_) {}
  	          }).catch(error => {
  	            FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Free Ground map click failed.", error);
  	          });
  	        });
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Could not bind free-ground map click.",
  	          error);
  	      }
  	    }
  	
  	    function rendererOpenLocation(location,
  	      polygon,
  	      map,
  	      clickEvent) {
  	      if (isMapMeasureActive()) {
  	        try {
  	          if (map) {
  	            map.__trackitCreateLastPolygonClickAt = Date.now();
  	          }
  	        } catch (_) {}
  	
  	        const clickedPoint = measureLatLngToPlain(clickEvent?.latLng);
  	
  	        handleMapMeasureClick(map, clickedPoint);
  	
  	        return;
  	      }
  	      if (isCreatePlottingActive()) {
  	        try {
  	          if (map) {
  	            map.__trackitCreateLastPolygonClickAt = Date.now();
  	          }
  	        } catch (_) {}
  	
  	        const clickedPoint = latLngEventToPlain(clickEvent?.latLng);
  	
  	        handleExistingLocationDuringFreeGroundPlot(location, clickedPoint, map).then(() => {
  	          try {
  	            const root = document.getElementById(ENGINE_ID);
  	
  	            if (root && DATA_CHANNEL) {
  	              renderTop(root);
  	              renderModal(root);
  	            }
  	          } catch (_) {}
  	        }).catch(error => {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Free Ground Wizard] Existing Location plot click failed.", error);
  	        });
  	
  	        return;
  	      }
  	
  	      if (
  	        typeof window !== "undefined" &&
  	        typeof window.__TrackITHandleEntranceEditMapClick === "function"
  	      ) {
  	        const clickedPoint = latLngEventToPlain(clickEvent?.latLng);
  	
  	        const handled = window.__TrackITHandleEntranceEditMapClick({
  	          location,
  	          polygon,
  	          map,
  	          point: clickedPoint,
  	          source: "renderer-polygon-click"
  	        });
  	
  	        if (handled) return;
  	      }
  	
  	      const id = rendererGetLocationId(location);
  	
  	      rendererWriteSelectedLocation(location);
  	
  	      try {
  	        rendererFocusPolygon(map,
  	          polygon);
  	      } catch (_) {}
  	
  	      try {
  	        if (
  	          typeof window !== "undefined" &&
  	          typeof window.__TrackITOpenLocationCardFromMap === "function"
  	        ) {
  	          const opened = window.__TrackITOpenLocationCardFromMap(location, {
  	            id,
  	            polygon,
  	            map,
  	            source: "trackit-location-map-renderer"
  	          });
  	
  	          if (opened) return;
  	        }
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Location Renderer] Could not open dropdown card from map click.", error);
  	      }
  	
  	      try {
  	        window.dispatchEvent(new CustomEvent("trackitLocationMapPolygonClicked", {
  	          detail: {
  	            id,
  	            location,
  	            polygon,
  	            source: "trackit-location-map-renderer"
  	          }
  	        }));
  	      } catch (_) {}
  	
  	      FIF_SILENT_CONSOLE.warn("[TrackIT Location Renderer] Map location clicked, but no card bridge handled it.", {
  	        id,
  	        location
  	      });
  	    }
  	
  	    function getTrackITLocationRendererRuntime() {
  	      if (!window.TrackITLocationMapRenderer) {
  	        window.TrackITLocationMapRenderer = {
  	          version: "carved-edge-integrated-location-renderer-v1",
  	          polygonsById: {},
  	          labelsById: {},
  	          labelZoomListener: null,
  	          map: null,
  	          mapRef: null,
  	          renderCount: 0,
  	          lastHydratedCount: 0,
  	          lastRenderedCount: 0
  	        };
  	      }
  	
  	      const runtime = window.TrackITLocationMapRenderer;
  	
  	      runtime.version = "carved-edge-integrated-location-renderer-v1-live";
  	      runtime.polygonsById = runtime.polygonsById || {};
  	      runtime.labelsById = runtime.labelsById || {};
  	      runtime.renderCount = Number(runtime.renderCount) || 0;
  	      runtime.lastHydratedCount = Number(runtime.lastHydratedCount) || 0;
  	      runtime.lastRenderedCount = Number(runtime.lastRenderedCount) || 0;
  	
  	      runtime.cleanup = function cleanup() {
  	        const polygons = this.polygonsById || {};
  	
  	        Object.keys(polygons).forEach(id => {
  	          try {
  	            if (polygons[id] && typeof polygons[id].setMap === "function") {
  	              polygons[id].setMap(null);
  	            }
  	          } catch (_) {}
  	        });
  	
  	        this.polygonsById = {};
  	
  	        const labels = this.labelsById || {};
  	
  	        Object.keys(labels).forEach(id => {
  	          try {
  	            if (labels[id] && typeof labels[id].setMap === "function") {
  	              labels[id].setMap(null);
  	            }
  	          } catch (_) {}
  	        });
  	
  	        this.labelsById = {};
  	
  	        try {
  	          if (this.labelZoomListener && typeof this.labelZoomListener.remove === "function") {
  	            this.labelZoomListener.remove();
  	          }
  	        } catch (_) {}
  	
  	        this.labelZoomListener = null;
  	
  	        try {
  	          if (
  	            window.LocationRegistry &&
  	            typeof window.LocationRegistry.clearRuntime === "function"
  	          ) {
  	            window.LocationRegistry.clearRuntime();
  	          }
  	        } catch (_) {}
  	      };
  	
  	      runtime.refresh = function refresh(options) {
  	        return renderSavedLocationsOnMap(this.map || MAP_INPUT, options || {
  	          reason: "manual-refresh",
  	          doFitBounds: false
  	        });
  	      };
  	
  	      window.LocationRendererRuntime = runtime;
  	      window.TrackITLocationRendererRuntime = runtime;
  	      window.__TrackITLocationRendererRuntime = runtime;
  	
  	      return runtime;
  	    }
  	
  	    function rendererGetLocationParentIdAny(location) {
  	      return (
  	        location?.ParentId ||
  	        location?.parentId ||
  	        location?.ParentID ||
  	        location?.parentID ||
  	        location?.ParentLocationId ||
  	        location?.parentLocationId ||
  	        location?.ParentLocationID ||
  	        location?.parentLocationID ||
  	        location?.Parent?.objectId ||
  	        location?.parent?.objectId ||
  	        location?.Parent?.id ||
  	        location?.parent?.id ||
  	        ""
  	      );
  	    }
  	
  	    function rendererCollectChildLocationIds() {
  	      const appData = getAppBag() || APP_DATA;
  	      const childIds = new Set();
  	      const companyScope = getLocationCreationCompanyScope(appData);
  	
  	      const companies =
  	      DATA_CHANNEL?.companies ||
  	      appData?.User?.Companies ||
  	      appData?.User?.companies ||
  	      appData?.Companies ||
  	      appData?.companies ||
  	      [];
  	
  	      function walk(location) {
  	        if (!location || typeof location !== "object") return;
  	
  	        const children = getLocationChildren(location);
  	
  	        children.forEach(child => {
  	          const childId = rendererGetLocationId(child) || getLocationValue(child);
  	
  	          if (childId) {
  	            childIds.add(String(childId));
  	          }
  	
  	          walk(child);
  	        });
  	      }
  	
  	      const sourceCompanies = companyScope.active
  	      ? (companyScope.company ? [companyScope.company]: [])
  	      : (Array.isArray(companies) ? companies: []);
  	
  	      sourceCompanies.forEach(company => {
  	        getCompanyLocations(company).forEach(walk);
  	      });
  	
  	      return childIds;
  	    }
  	
  	    function rendererGetMapControlVisibilityState() {
  	      let hideAllLocations = !!mapControlState.hideAllLocations;
  	      let hideSecondaryLocations = !!mapControlState.hideSecondaryLocations;
  	
  	      try {
  	        hideAllLocations = !!readMapControlSetting(
  	          "hideAllLocations",
  	          hideAllLocations
  	        );
  	      } catch (_) {}
  	
  	      try {
  	        hideSecondaryLocations = !!readMapControlSetting(
  	          "hideSecondaryLocations",
  	          hideSecondaryLocations
  	        );
  	      } catch (_) {}
  	
  	      mapControlState.hideAllLocations = hideAllLocations;
  	      mapControlState.hideSecondaryLocations = hideSecondaryLocations;
  	
  	      return {
  	        hideAllLocations,
  	        hideSecondaryLocations,
  	        hiddenCompanyLocationIds: getDropdownCollapsedCompanyLocationIds()
  	      };
  	    }
  	
  	    function rendererIsSecondaryLocation(location, id, childLocationIds) {
  	      if (!location) return false;
  	
  	      if (rendererGetLocationParentIdAny(location)) return true;
  	
  	      if (id && childLocationIds && childLocationIds.has(String(id))) {
  	        return true;
  	      }
  	
  	      const typeText = [
  	        location?.LocationType,
  	        location?.locationType,
  	        location?.Type,
  	        location?.type,
  	        location?.FieldType,
  	        location?.fieldType,
  	        location?.Shape,
  	        location?.shape,
  	        location?.CreationType,
  	        location?.creationType,
  	        location?.GeometryType,
  	        location?.geometryType
  	      ]
  	      .filter(Boolean)
  	      .join(" ")
  	      .toLowerCase();
  	
  	      return (
  	        typeText.includes("segment") ||
  	        typeText.includes("ring")
  	      );
  	    }
  	
  	    function rendererShouldRenderLocation(location, id, childLocationIds, visibilityState) {
  	      if (visibilityState.hideAllLocations) return false;
  	
  	      if (
  	        id &&
  	        visibilityState.hiddenCompanyLocationIds &&
  	        visibilityState.hiddenCompanyLocationIds.has(String(id))
  	      ) {
  	        return false;
  	      }
  	
  	      if (
  	        visibilityState.hideSecondaryLocations &&
  	        rendererIsSecondaryLocation(location, id, childLocationIds)
  	      ) {
  	        return false;
  	      }
  	
  	      return true;
  	    }
  	
  	    function rendererGetMapZoom(map) {
  	      try {
  	        const zoom =
  	        typeof map?.getZoom === "function"
  	        ? map.getZoom(): map?.zoom;
  	
  	        const number = Number(zoom);
  	
  	        return Number.isFinite(number) ? number: null;
  	      } catch (_) {
  	        return null;
  	      }
  	    }
  	
  	    function rendererShouldShowLocationLabels(map) {
  	      const LABEL_MIN_ZOOM = 16;
  	      const zoom = rendererGetMapZoom(map);
  	
  	      if (zoom === null) return false;
  	
  	      return zoom >= LABEL_MIN_ZOOM;
  	    }
  	
  	    function rendererApplyLocationLabelVisibility(runtime, map) {
  	      if (!runtime || !runtime.labelsById) return;
  	
  	      const visible = rendererShouldShowLocationLabels(map);
  	
  	      Object.keys(runtime.labelsById).forEach(id => {
  	        const label = runtime.labelsById[id];
  	
  	        try {
  	          if (label && typeof label.setTrackITLabelVisible === "function") {
  	            label.setTrackITLabelVisible(visible);
  	          }
  	        } catch (_) {}
  	      });
  	    }
  	
  	    function rendererEnsureLocationLabelZoomListener(runtime,
  	      map) {
  	      if (!runtime || !map) return;
  	
  	      if (runtime.labelZoomListener) return;
  	
  	      try {
  	        if (typeof map.addListener === "function") {
  	          runtime.labelZoomListener = map.addListener("zoom_changed", () => {
  	            rendererApplyLocationLabelVisibility(runtime, map);
  	          });
  	        }
  	      } catch (_) {}
  	    }
  	
  	    function rendererGetStoredAreaHa(location) {
  	      const data =
  	      location?.LocationData ||
  	      location?.locationData ||
  	      {};
  	
  	      const area =
  	      data?.Area ||
  	      data?.area ||
  	      location?.Area ||
  	      location?.area ||
  	      null;
  	
  	      const hectares = rendererNumber(
  	        area?.Hectares ??
  	        area?.hectares ??
  	        area?.Ha ??
  	        area?.ha ??
  	        area?.HA ??
  	        location?.AreaHa ??
  	        location?.areaHa ??
  	        location?.Hectares ??
  	        location?.hectares ??
  	        null
  	      );
  	
  	      if (hectares !== null) return hectares;
  	
  	      const squareMeters = rendererNumber(
  	        area?.m2 ??
  	        area?.M2 ??
  	        area?.SquareMeters ??
  	        area?.squareMeters ??
  	        location?.AreaM2 ??
  	        location?.areaM2 ??
  	        location?.SquareMeters ??
  	        location?.squareMeters ??
  	        null
  	      );
  	
  	      if (squareMeters !== null) return squareMeters / 10000;
  	
  	      return null;
  	    }
  	
  	    function rendererFormatAreaHaForMapLabel(location, computedAreaM2) {
  	      const storedHa = rendererGetStoredAreaHa(location);
  	
  	      if (storedHa !== null) {
  	        return `${storedHa.toFixed(2)} ha`;
  	      }
  	
  	      const m2 = rendererNumber(computedAreaM2);
  	
  	      if (m2 === null) return "— ha";
  	
  	      return `${(m2 / 10000).toFixed(2)} ha`;
  	    }
  	
  	    function rendererGetPolygonLabelPosition(points) {
  	      if (!Array.isArray(points) || points.length < 3) return null;
  	
  	      const validPoints = points
  	      .map(point => {
  	        if (!point) return null;
  	
  	        const lat = Number(point.lat);
  	        const lng = Number(point.lng);
  	
  	        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  	
  	        return {
  	          lat,
  	          lng
  	        };
  	      })
  	      .filter(Boolean);
  	
  	      if (!validPoints.length) return null;
  	
  	      let minLat = Infinity;
  	      let maxLat = -Infinity;
  	      let minLng = Infinity;
  	      let maxLng = -Infinity;
  	
  	      validPoints.forEach(point => {
  	        minLat = Math.min(minLat, point.lat);
  	        maxLat = Math.max(maxLat, point.lat);
  	        minLng = Math.min(minLng, point.lng);
  	        maxLng = Math.max(maxLng, point.lng);
  	      });
  	
  	      const latRange = Math.max(0.00000001, maxLat - minLat);
  	      const lngRange = Math.max(0.00000001, maxLng - minLng);
  	
  	      // Use the actual saved boundary point closest to the south-west / bottom-left corner.
  	      // Do not use centre mass. Centre mass creates bad labels on wedges, rings, arcs and concave shapes.
  	      let bestPoint = null;
  	      let bestScore = Infinity;
  	
  	      validPoints.forEach(point => {
  	        const bottomScore = (point.lat - minLat) / latRange;
  	        const leftScore = (point.lng - minLng) / lngRange;
  	
  	        // Bottom is slightly more important than left, because the user wants the label at the lower edge.
  	        const score = (bottomScore * 1.35) + leftScore;
  	
  	        if (score < bestScore) {
  	          bestScore = score;
  	          bestPoint = point;
  	        }
  	      });
  	
  	      return bestPoint;
  	    }
  	
  	    function rendererBuildLocationMapLabelHtml(location,
  	      areaM2) {
  	      const name = rendererGetLocationName(location);
  	      const areaText = rendererFormatAreaHaForMapLabel(location,
  	        areaM2);
  	
  	      return `
  	      <div class="trackit-map-location-label-name">${escapeHtml(name)}</div>
  	      <div class="trackit-map-location-label-area">${escapeHtml(areaText)}</div>
  	      `;
  	    }
  	
  	    function rendererCreateLocationLabelOverlay(map,
  	      position,
  	      html,
  	      zIndex) {
  	      const overlay = new google.maps.OverlayView();
  	
  	      overlay.__trackitPosition = position;
  	      overlay.__trackitHtml = html;
  	      overlay.__trackitZIndex = zIndex || 1;
  	      overlay.__trackitDiv = null;
  	      overlay.__trackitVisible = rendererShouldShowLocationLabels(map);
  	
  	      overlay.onAdd = function () {
  	        const div = document.createElement("div");
  	
  	        div.className = "trackit-map-location-label";
  	        div.innerHTML = overlay.__trackitHtml;
  	
  	        div.style.position = "absolute";
  	        div.style.transform = "translate(4px, -100%)";
  	        div.style.pointerEvents = "none";
  	        div.style.background = "rgba(0,0,0,0.84)";
  	        div.style.color = "#fff";
  	        div.style.border = "1px solid rgba(255,255,255,0.16)";
  	        div.style.borderRadius = "8px";
  	        div.style.padding = "4px 7px 5px";
  	        div.style.fontFamily = "Inter, Arial, sans-serif";
  	        div.style.fontSize = "10px";
  	        div.style.fontWeight = "900";
  	        div.style.lineHeight = "1.14";
  	        div.style.letterSpacing = "0.01em";
  	        div.style.textAlign = "center";
  	        div.style.whiteSpace = "nowrap";
  	        div.style.boxShadow = "0 8px 18px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,154,61,0.12)";
  	        div.style.backdropFilter = "blur(5px)";
  	        div.style.webkitBackdropFilter = "blur(5px)";
  	        div.style.zIndex = String(overlay.__trackitZIndex);
  	        div.style.display = overlay.__trackitVisible ? "block": "none";
  	
  	        overlay.__trackitDiv = div;
  	
  	        const panes = overlay.getPanes();
  	
  	        if (panes && panes.floatPane) {
  	          panes.floatPane.appendChild(div);
  	        }
  	      };
  	
  	      overlay.draw = function () {
  	        const div = overlay.__trackitDiv;
  	        const projection = overlay.getProjection();
  	
  	        if (!div || !projection || !overlay.__trackitPosition) return;
  	
  	        const point = projection.fromLatLngToDivPixel(
  	          new google.maps.LatLng(
  	            overlay.__trackitPosition.lat,
  	            overlay.__trackitPosition.lng
  	          )
  	        );
  	
  	        if (!point) return;
  	
  	        div.style.left = `${point.x}px`;
  	        div.style.top = `${point.y}px`;
  	        div.style.zIndex = String(overlay.__trackitZIndex);
  	        div.style.display = overlay.__trackitVisible ? "block": "none";
  	        div.innerHTML = overlay.__trackitHtml;
  	      };
  	
  	      overlay.onRemove = function () {
  	        if (overlay.__trackitDiv && overlay.__trackitDiv.parentNode) {
  	          overlay.__trackitDiv.parentNode.removeChild(overlay.__trackitDiv);
  	        }
  	
  	        overlay.__trackitDiv = null;
  	      };
  	
  	      overlay.setTrackITLabelData = function (nextPosition, nextHtml, nextZIndex) {
  	        overlay.__trackitPosition = nextPosition;
  	        overlay.__trackitHtml = nextHtml;
  	        overlay.__trackitZIndex = nextZIndex || overlay.__trackitZIndex || 1;
  	
  	        if (overlay.__trackitDiv) {
  	          overlay.__trackitDiv.innerHTML = nextHtml;
  	          overlay.__trackitDiv.style.zIndex = String(overlay.__trackitZIndex);
  	          overlay.__trackitDiv.style.display = overlay.__trackitVisible ? "block": "none";
  	        }
  	
  	        try {
  	          overlay.draw();
  	        } catch (_) {}
  	      };
  	
  	      overlay.setTrackITLabelVisible = function (visible) {
  	        overlay.__trackitVisible = !!visible;
  	
  	        if (overlay.__trackitDiv) {
  	          overlay.__trackitDiv.style.display = overlay.__trackitVisible ? "block": "none";
  	        }
  	      };
  	
  	      overlay.setMap(map);
  	
  	      return overlay;
  	    }
  	
  	    function rendererUpsertLocationMapLabel(runtime, map, item, zIndex) {
  	      if (!runtime || !map || !item || !item.id) return;
  	
  	      if (
  	        typeof google === "undefined" ||
  	        !google?.maps ||
  	        typeof google.maps.OverlayView !== "function"
  	      ) {
  	        return;
  	      }
  	
  	      if (!runtime.labelsById) {
  	        runtime.labelsById = {};
  	      }
  	
  	      rendererEnsureLocationLabelZoomListener(runtime, map);
  	
  	      const position = rendererGetPolygonLabelPosition(item.outer);
  	
  	      if (!position) return;
  	
  	      const html = rendererBuildLocationMapLabelHtml(item.location, item.area);
  	      const labelZIndex = (zIndex || 99900000) + 100000;
  	      const shouldShow = rendererShouldShowLocationLabels(map);
  	
  	      let overlay = runtime.labelsById[item.id] || null;
  	
  	      if (overlay && typeof overlay.setTrackITLabelData === "function") {
  	        overlay.setTrackITLabelData(position, html, labelZIndex);
  	
  	        try {
  	          overlay.setMap(map);
  	        } catch (_) {}
  	
  	        try {
  	          overlay.setTrackITLabelVisible(shouldShow);
  	        } catch (_) {}
  	
  	        return;
  	      }
  	
  	      overlay = rendererCreateLocationLabelOverlay(map, position, html, labelZIndex);
  	      runtime.labelsById[item.id] = overlay;
  	
  	      try {
  	        overlay.setTrackITLabelVisible(shouldShow);
  	      } catch (_) {}
  	    }
  	
  	    function rendererRemoveLocationMapLabel(runtime, id) {
  	      if (!runtime || !runtime.labelsById || !id) return;
  	
  	      const label = runtime.labelsById[id];
  	
  	      try {
  	        if (label && typeof label.setMap === "function") {
  	          label.setMap(null);
  	        }
  	      } catch (_) {}
  	
  	      delete runtime.labelsById[id];
  	    }
  	
  	    function renderSavedLocationsOnMap(mapComponent, options) {
  	      options = options || {};
  	
  	      const runtime = getTrackITLocationRendererRuntime();
  	      const registry = ensureTrackITLocationRegistry();
  	      const map = resolveTrackITGoogleMap(mapComponent);
  	
  	      if (!map) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Location Renderer] Google map not ready yet.");
  	        return false;
  	      }
  	
  	      runtime.map = map;
  	
  	      bindCreatePlotFreeGroundClick(map);
  	      bindMapMeasureClick(map);
  	
  	      const locations = rendererCollectLocations();
  	      const childLocationIds = rendererCollectChildLocationIds();
  	      const visibilityState = rendererGetMapControlVisibilityState();
  	
  	      runtime.lastHydratedCount = locations.length;
  	
  	      if (runtime.mapRef && runtime.mapRef !== map) {
  	        runtime.cleanup();
  	      }
  	
  	      runtime.mapRef = map;
  	
  	      const renderable = [];
  	
  	      locations.forEach(location => {
  	        const id = rendererGetLocationId(location);
  	
  	        if (!id) return;
  	
  	        if (!rendererShouldRenderLocation(location, id, childLocationIds, visibilityState)) {
  	          return;
  	        }
  	
  	        const paths = rendererGetPolygonPaths(location);
  	
  	        if (!paths || !paths[0] || paths[0].length < 3) return;
  	
  	        renderable.push({
  	          id,
  	          location,
  	          paths,
  	          outer: paths[0],
  	          area: rendererComputeArea(paths[0])
  	        });
  	      });
  	
  	      renderable.sort((a, b) => {
  	        return (b.area || 0) - (a.area || 0);
  	      });
  	
  	      const liveIds = Object.create(null);
  	
  	      renderable.forEach(item => {
  	        liveIds[item.id] = true;
  	      });
  	
  	      Object.keys(runtime.polygonsById).forEach(id => {
  	        if (liveIds[id]) return;
  	
  	        try {
  	          runtime.polygonsById[id].setMap(null);
  	        } catch (_) {}
  	
  	        delete runtime.polygonsById[id];
  	
  	        rendererRemoveLocationMapLabel(runtime, id);
  	      });
  	
  	      if (runtime.labelsById) {
  	        Object.keys(runtime.labelsById).forEach(id => {
  	          if (liveIds[id]) return;
  	
  	          rendererRemoveLocationMapLabel(runtime, id);
  	        });
  	      }
  	
  	      try {
  	        if (registry && typeof registry.pruneMissing === "function") {
  	          registry.pruneMissing(liveIds);
  	        }
  	      } catch (_) {}
  	
  	      let renderedCount = 0;
  	      let reusedCount = 0;
  	      const bounds =
  	      typeof google !== "undefined" && google?.maps?.LatLngBounds
  	      ? new google.maps.LatLngBounds(): null;
  	
  	      renderable.forEach((item, index) => {
  	        const color = rendererGetLocationColor(item.location);
  	        const zIndex = 99900000 + index;
  	        const googlePaths = rendererNormalizeGooglePolygonPaths(item.paths);
  	
  	        let polygon = runtime.polygonsById[item.id] || null;
  	
  	        if (polygon) {
  	          reusedCount++;
  	
  	          try {
  	            polygon.setPaths(googlePaths);
  	          } catch (_) {}
  	
  	          try {
  	            polygon.setOptions({
  	              strokeColor: color,
  	              strokeOpacity: 0.9,
  	              strokeWeight: 2,
  	              fillColor: color,
  	              fillOpacity: 0.3,
  	              fillRule: "evenodd",
  	              clickable: true,
  	              zIndex
  	            });
  	          } catch (_) {}
  	
  	          try {
  	            polygon.setMap(map);
  	          } catch (_) {}
  	        } else {
  	          try {
  	            polygon = new google.maps.Polygon({
  	              paths: googlePaths,
  	              strokeColor: color,
  	              strokeOpacity: 0.9,
  	              strokeWeight: 2,
  	              fillColor: color,
  	              fillOpacity: 0.3,
  	              fillRule: "evenodd",
  	              clickable: true,
  	              zIndex,
  	              map
  	            });
  	          } catch (error) {
  	            FIF_SILENT_CONSOLE.warn("[TrackIT Location Renderer] Could not create polygon.", {
  	              id: item.id,
  	              name: rendererGetLocationName(item.location),
  	              error
  	            });
  	
  	            return;
  	          }
  	
  	          runtime.polygonsById[item.id] = polygon;
  	          renderedCount++;
  	        }
  	
  	        polygon.__trackitLocationRendererLocation = item.location;
  	        polygon.__trackitLocationRendererId = item.id;
  	
  	        if (!polygon.__trackitLocationRendererClickBound) {
  	          polygon.__trackitLocationRendererClickBound = true;
  	
  	          polygon.addListener("click", event => {
  	            try {
  	              map.__trackitCreateLastPolygonClickAt = Date.now();
  	            } catch (_) {}
  	
  	            rendererOpenLocation(
  	              polygon.__trackitLocationRendererLocation,
  	              polygon,
  	              map,
  	              event
  	            );
  	          });
  	        }
  	        rendererUpsertLocationMapLabel(runtime, map, item, zIndex);
  	        try {
  	          registry.register({
  	            location: item.location,
  	            polygon,
  	            geometryMeta: {
  	              type:
  	              item.location?.CreationType ||
  	              item.location?.creationType ||
  	              item.location?.GeometryType ||
  	              item.location?.geometryType ||
  	              "Polygon"
  	            }
  	          });
  	        } catch (_) {}
  	
  	        if (bounds) {
  	          item.outer.forEach(point => {
  	            try {
  	              bounds.extend(point);
  	            } catch (_) {}
  	          });
  	        }
  	      });
  	
  	      if (options.doFitBounds !== false && bounds) {
  	        try {
  	          if (!(bounds.isEmpty && bounds.isEmpty())) {
  	            map.fitBounds(bounds);
  	
  	            if (
  	              typeof google !== "undefined" &&
  	              google?.maps?.event &&
  	              typeof google.maps.event.addListenerOnce === "function"
  	            ) {
  	              google.maps.event.addListenerOnce(map, "bounds_changed", () => {
  	                try {
  	                  const zoom = map.getZoom();
  	
  	                  if (Number.isFinite(zoom) && zoom > 18) {
  	                    map.setZoom(18);
  	                  }
  	                } catch (_) {}
  	              });
  	            }
  	          }
  	        } catch (_) {}
  	      }
  	
  	      runtime.renderCount += 1;
  	      runtime.lastRenderedCount = renderable.length;
  	
  	      FIF_SILENT_CONSOLE.log("[TrackIT Location Renderer] Render complete:",
  	        {
  	          locationsTotal: locations.length,
  	          renderablePolygons: renderable.length,
  	          renderedNew: renderedCount,
  	          reused: reusedCount,
  	          reason: options.reason || "",
  	          renderCount: runtime.renderCount
  	        });
  	
  	      return true;
  	    }
  	
  	    function startLocationMapRenderer(mapComponent) {
  	      const startedAt = Date.now();
  	
  	      function attempt(reason,
  	        doFitBounds) {
  	        const ok = renderSavedLocationsOnMap(mapComponent,
  	          {
  	            reason,
  	            doFitBounds
  	          });
  	
  	        if (ok) return;
  	
  	        if (Date.now() - startedAt < 7000) {
  	          setTimeout(() => {
  	            attempt(reason, doFitBounds);
  	          }, 120);
  	        }
  	      }
  	
  	      attempt("initial", true);
  	
  	      setTimeout(() => {
  	        renderSavedLocationsOnMap(mapComponent, {
  	          reason: "settled-500ms",
  	          doFitBounds: false
  	        });
  	      }, 500);
  	
  	      setTimeout(() => {
  	        renderSavedLocationsOnMap(mapComponent, {
  	          reason: "settled-1500ms",
  	          doFitBounds: false
  	        });
  	      }, 1500);
  	
  	      setTimeout(() => {
  	        renderSavedLocationsOnMap(mapComponent, {
  	          reason: "settled-3000ms",
  	          doFitBounds: false
  	        });
  	      }, 3000);
  	    }
  	
  	    function createUI() {
  	      injectStyles();
  	
  	      const root = document.createElement("div");
  	      root.id = ENGINE_ID;
  	
  	      root.innerHTML = `
  	      <section class="ces-top-shape"></section>
  	      <section class="ces-bottom-shape"></section>
  	      <section class="ces-modal-host"></section>
  	      `;
  	
  	      renderTop(root);
  	      initialiseMapControl(root);
  	      renderModal(root);
  	      mountLocationDropdownBridgePlaceholder(root);
  	
  	      const documentClickHandler = event => {
  	        if (!root.contains(event.target) && createState.openDropdown) {
  	          createState.openDropdown = "";
  	          renderTop(root);
  	        }
  	      };
  	
  	      document.addEventListener("click", documentClickHandler);
  	
  	      root.__cleanup = () => {
  	        document.removeEventListener("click", documentClickHandler);
  	        clearAttention(root);
  	        clearSearchPanelResizeTimers();
  	        unbindSearchPanelMapControlWatcher(root);
  	        clearFreeGroundPlotDraft();
  	
  	        try {
  	          if (
  	            window.TrackITLocationMapRenderer &&
  	            typeof window.TrackITLocationMapRenderer.cleanup === "function"
  	          ) {
  	            window.TrackITLocationMapRenderer.cleanup();
  	          }
  	        } catch (_) {}
  	
  	        if (typeof root.__mapVisibilityCleanup === "function") {
  	          root.__mapVisibilityCleanup();
  	        }
  	      };
  	
  	      return root;
  	    }
  	
  	    try {
  	      if (!APP_DATA) {
  	        resolve({
  	          ok: false,
  	          reason: "App Data missing"
  	        });
  	
  	        return;
  	      }
  	
  	      const mapComponent = resolveComponent(MAP_INPUT);
  	
  	      if (!mapComponent && !MAP_INPUT) {
  	        resolve({
  	          ok: false,
  	          reason: "Map component missing"
  	        });
  	
  	        return;
  	      }
  	
  	      removeExistingUI();
  	
  	      const appBag = getAppBag() || APP_DATA;
  	      DATA_CHANNEL = createDataChannel(appBag);
  	      COMPANY_OPTIONS = DATA_CHANNEL.companyOptions;
  	
  	      printDataChannelOnLoad(DATA_CHANNEL);
  	
  	      const uiElement = createUI();
  	
  	      document.body.appendChild(uiElement);
  	
  	      if (
  	        window.__CarvedEdgeShapeDropdownBridge &&
  	        typeof window.__CarvedEdgeShapeDropdownBridge.mountTrackITDropdown === "function"
  	      ) {
  	        window.__CarvedEdgeShapeDropdownBridge.mountTrackITDropdown();
  	
  	        if (typeof window.__CarvedEdgeShapeDropdownBridge.resizeTopShell === "function") {
  	          window.__CarvedEdgeShapeDropdownBridge.resizeTopShell();
  	        }
  	      }
  	
  	      bindSearchPanelMapControlWatcher(uiElement);
  	
  	      try {
  	        ensureTrackITLocationRegistry();
  	        getTrackITLocationRendererRuntime();
  	      } catch (error) {
  	        FIF_SILENT_CONSOLE.warn("[TrackIT Location Renderer] Could not pre-create registry/runtime.", error);
  	      }
  	
  	      startLocationMapRenderer(mapComponent);
  	
  	      bindMapVisibilityVanisher(uiElement, mapComponent);
  	
  	      setTimeout(() => {
  	        try {
  	          initialiseMapControl(uiElement);
  	        } catch (error) {
  	          FIF_SILENT_CONSOLE.warn("[TrackIT Map Control] Delayed initialise failed.", error);
  	        }
  	      }, 350);
  	
  	      const result = {
  	        ok: true,
  	        mountMode: "fixed-carved-edge-shape-ui",
  	        mapComponentFound: !!mapComponent || !!MAP_INPUT,
  	        createState
  	      };
  	
  	      window.__CarvedEdgeShapeUI = {
  	        appData: APP_DATA,
  	        mapInput: MAP_INPUT,
  	        mapComponent,
  	        createState,
  	        uiElement,
  	        pendingSaveLocation: null,
  	        pendingFunctionalitySave: null,
  	        dataChannel: DATA_CHANNEL,
  	        dropdownBridge: window.__CarvedEdgeShapeDropdownBridge || null,
  	        refreshDataChannel() {
  	          const appBag = getAppBag() || APP_DATA;
  	          DATA_CHANNEL = createDataChannel(appBag);
  	          COMPANY_OPTIONS = DATA_CHANNEL.companyOptions;
  	          printDataChannelOnLoad(DATA_CHANNEL);
  	          return DATA_CHANNEL;
  	        },
  	        cleanup() {
  	          try {
  	            const bridge = window.__CarvedEdgeShapeDropdownBridge;
  	            const host = bridge && bridge.host;
  	
  	            if (host && typeof host.__locationDropdownCleanup === "function") {
  	              host.__locationDropdownCleanup();
  	            }
  	          } catch (_) {}
  	
  	          if (uiElement && typeof uiElement.__cleanup === "function") {
  	            uiElement.__cleanup();
  	          }
  	        }
  	      };
  	
  	      FIF_SILENT_CONSOLE.log("Carved Edge Shape UI mounted:", result);
  	
  	      resolve(result);
  	    } catch (error) {
  	      FIF_SILENT_CONSOLE.error("Carved Edge Shape UI failed:", error);
  	
  	      resolve({
  	        ok: false,
  	        reason: error.message,
  	        error
  	      });
  	    }
  	  })();
  	});

  })(App, Map, 'data:image/png;base64,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');

}

})
define('./functions/601f96e6c6e413ff585a05b78783325d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_601f96e6c6e413ff585a05b78783325d'] = async function fn_601f96e6c6e413ff585a05b78783325d(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/629c27af68227fc75311860d0568b097/code.js', () => { 

BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097'] = function fn_629c27af68227fc75311860d0568b097(Object) {
return ((Object === null) == true || (typeof Object === 'undefined') == true)
}

})
define('./functions/74292d41839aba2dadf7c548b26b0dbe/code.js', () => { 

BackendlessUI.Functions.Custom['fn_74292d41839aba2dadf7c548b26b0dbe'] = async function fn_74292d41839aba2dadf7c548b26b0dbe(Data, Kind, Path, Custom, Exclude, Only, Header) {
return (await (async function(Data, Source, Custom, Exclude, Only, Header) {
	(function (row, source, custom, exclude, only, header) {
	
	  /* ================= CONFIG ================= */
	  const GMAPS_KEY = 'GMAPS_KEY'.trim();
	  const MAP_ID    = 'MAP_ID'.trim();
	
	  /* ================= CONTEXT ================= */
	  const hasGrid = !!(source && source.api && source.node);
	  if (!row || typeof row !== 'object') row = (source && source.data) || {};
	  const isArr = Array.isArray;
	  const isObj = v => v && typeof v === 'object' && !Array.isArray(v);
	
	  /* ================= CSS ONCE ================= */
	  if (!window.__agfSticky) {
	    window.__agfSticky = true;
	    const css = `
	      .agf-modal{position:fixed;inset:0;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;z-index:2147483647;font:14px system-ui,Segoe UI,Roboto,Arial}
	      .agf-card{width:min(1000px,96vw);max-height:94vh;background:#11171c;color:#fff;border:1px solid #333;border-radius:12px;box-shadow:0 10px 40px rgba(0,0,0,.6);display:flex;flex-direction:column}
	      .agf-hd{position:sticky;top:0;background:#11171c;display:flex;justify-content:space-between;align-items:center;padding:12px 16px;border-bottom:1px solid #333;font-weight:600}
	      .agf-body{flex:1;min-height:0;overflow:auto}
	      .agf-bd{padding:16px;display:grid;gap:14px;grid-template-columns:repeat(2,minmax(0,1fr))}
	      .agf-row{display:flex;flex-direction:column;gap:6px}
	      .agf-row.full{grid-column:1/-1}
	      .agf-input,.agf-textarea,.agf-select{background:#0c1116;color:#fff;border:1px solid #555;border-radius:8px;padding:8px;min-height:36px}
	      .agf-textarea{min-height:90px;resize:vertical}
	      .agf-ft{position:sticky;bottom:0;background:#11171c;padding:12px 16px;display:flex;gap:10px;justify-content:flex-end;border-top:1px solid #333}
	      .agf-btn{padding:8px 12px;border-radius:8px;border:1px solid #555;background:#222;color:#fff;cursor:pointer}
	      .agf-btn.primary{background:#cc6633;border-color:#cc6633}
	      .agf-inline{display:grid;grid-template-columns:1fr 1fr;gap:8px;align-items:center}
	      .agf-map-wrap{grid-column:1/-1;border:1px solid #2b3137;border-radius:12px;background:#0c1116;overflow:hidden}
	      .agf-map-toolbar{display:flex;gap:8px;align-items:center;padding:8px;border-bottom:1px solid #2b3137}
	      .agf-map{height:420px}
	      .agf-hide{display:none !important}
	      .agf-readonly{opacity:.7}
	    `;
	    const s=document.createElement('style'); s.textContent=css; document.head.appendChild(s);
	  }
	
	  /* ================= HELPERS ================= */
	  const looksLatLng = v => isObj(v) && Number.isFinite(v.lat) && Number.isFinite(v.lng);
	  const re = {
	    isoDate:/^\d{4}-\d{2}-\d{2}$/,
	    isoDT:/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2})?$/,
	    email:/^[^\s@]+@[^\s@]+\.[^\s@]+$/,
	    url:/^(https?:\/\/|www\.)/i,
	    phone:/^[+\d][\d ()\-+.]{5,}$/,
	    hex:/^#([0-9a-f]{3}|[0-9a-f]{6})$/i
	  };
	  const humanize = k => String(k)
	    .replace(/([a-z0-9])([A-Z])/g,'$1 $2').replace(/[_\-]+/g,' ')
	    .replace(/\s+/g,' ').trim().replace(/\b\w/g,c=>c.toUpperCase())
	    .replace(/\bId\b/g,'ID');
	
	  const getByPath = (obj, path) => path.split('.').reduce((o,k)=> (o && k in o)?o[k]:undefined, obj);
	  function ensurePath(obj, path, fallback){
	    const parts = path.split('.'); let o=obj;
	    for (let i=0;i<parts.length-1;i++){ const k=parts[i]; if (!isObj(o[k])) o[k]={}; o=o[k]; }
	    const last=parts[parts.length-1]; if (o[last]===undefined && fallback!==undefined) o[last]=fallback; return o;
	  }
	  const setByPath = (obj, path, val) => { const o=ensurePath(obj,path); o[path.split('.').pop()]=val; };
	
	  function kindOf(val){
	    if (typeof val === 'boolean') return 'boolean';
	    if (typeof val === 'number')  return 'number';
	    if (typeof val === 'string'){
	      if (re.isoDT.test(val)) return 'datetime';
	      if (re.isoDate.test(val)) return 'date';
	      if (re.email.test(val)) return 'email';
	      if (re.url.test(val))   return 'url';
	      if (re.phone.test(val)) return 'tel';
	      if (re.hex.test(val))   return 'color';
	      if (val.length>120 || /\n/.test(val)) return 'textarea';
	      return 'string';
	    }
	    if (Array.isArray(val)) return 'array';
	    if (isObj(val)) {
	      if (val?.type==='Point'   && isArr(val.coordinates)) return 'geopoint';
	      if (val?.type==='Polygon' && isArr(val.coordinates)) return 'geopoly';
	      if (looksLatLng(val)) return 'latlng';
	      return 'object';
	    }
	    return 'string';
	  }
	
	  const toLatLng = (xy) => ({ lat:Number(xy[1]), lng:Number(xy[0]) });
	  const toXY    = (ll) => [ Number(ll.lng), Number(ll.lat) ];
	
	  function boundsForRadiusMeters(center, meters){
	    const dLat = meters/111320;
	    const dLng = meters/(111320*Math.cos(center.lat*Math.PI/180)||1);
	    return new google.maps.LatLngBounds(
	      new google.maps.LatLng(center.lat-dLat, center.lng-dLng),
	      new google.maps.LatLng(center.lat+dLat, center.lng+dLng)
	    );
	  }
	
	  function loadMapsOnce(apiKey){
	    if (window.google && window.google.maps) return Promise.resolve();
	    if (window.__gmapsPromise) return window.__gmapsPromise;
	    const found=[...document.scripts].find(s=>s.src.includes('maps.googleapis.com/maps/api/js'));
	    if (found){
	      return (window.__gmapsPromise=new Promise((res,rej)=>{
	        if (window.google && window.google.maps) return res();
	        found.addEventListener('load',()=>res(),{once:true});
	        found.addEventListener('error',()=>rej(new Error('Google Maps failed to load (existing)')),{once:true});
	      }));
	    }
	    window.__gmapsPromise=new Promise((res,rej)=>{
	      const s=document.createElement('script');
	      s.src=`https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&v=weekly`;
	      s.async=true; s.defer=true; s.onload=()=>res(); s.onerror=()=>rej(new Error('Google Maps failed to load (new)'));
	      document.head.appendChild(s);
	    });
	    return window.__gmapsPromise;
	  }
	
	  /* ============ CHOICE META (robust) ============ */
	  const norm = s => String(s).toLowerCase().replace(/[\s_:-]/g,'');
	  function pickKey(obj, candidates){
	    const map = new Map(Object.keys(obj).map(k=>[norm(k),k]));
	    for (const c of candidates){ const hit = map.get(norm(c)); if (hit) return hit; }
	    return null;
	  }
	  function getChoiceMeta(spec){
	    if (!isObj(spec)) return null;
	
	    // Look for explicit type hints
	    const typeKey = pickKey(spec, ['Type']);
	    const typeVal = typeKey ? String(spec[typeKey]).toLowerCase() : '';
	    const typeSaysMulti = ['dropdown','multiselect','multi','multi-select'].includes(typeVal);
	    const typeSaysSingle = ['select','single','single-select'].includes(typeVal);
	
	    // Check for direct options at root
	    const optKey = pickKey(spec, ['Options','Choices','Values','Items','List']);
	    let options = optKey && isArr(spec[optKey]) ? spec[optKey] : null;
	
	    // Check for Multiple Choice container (various spellings)
	    const mcKey = pickKey(spec, ['MultipleChoice','Multiple Choice','multipleChoice','multiple choice']);
	    if (!options && mcKey && isObj(spec[mcKey])) {
	      const inner = spec[mcKey];
	      const innerOptKey = pickKey(inner, ['Options','Choices','Values','Items','List']);
	      if (innerOptKey && isArr(inner[innerOptKey])) options = inner[innerOptKey];
	    }
	
	    // Multi-selection flag anywhere (root or inside mc)
	    const multiFlags = ['MultipleSelection','Multiple Selection','Multiple','multi','multiSelect','multiselect'];
	    function readMulti(obj){
	      const k = pickKey(obj, multiFlags);
	      return k ? !!obj[k] : undefined;
	    }
	    let multi = readMulti(spec);
	    if (multi === undefined && mcKey && isObj(spec[mcKey])) multi = readMulti(spec[mcKey]);
	    if (multi === undefined) multi = typeSaysMulti ? true : (typeSaysSingle ? false : false);
	
	    if (options && options.length){
	      return { options, multi };
	    }
	    return null;
	  }
	
	  /* ============ CUSTOM / EXCLUDE / ONLY ============ */
	  const customList = (isArr(custom) ? custom : []).filter(Boolean);
	  const excludeSet = new Set((isArr(exclude)?exclude:[]).map(String));
	  const onlyList   = (isArr(only)?only:[]).map(String);
	
	  const customByPath = {};
	  const customOrder  = [];
	  for (const c of customList) {
	    const origKey = pickKey(c, ['Title Original','title original','TitleOriginal']);
	    const path = String(origKey ? c[origKey] : '').trim();
	    if (!path) continue;
	    customByPath[path] = c;
	    customOrder.push(path);
	  }
	
	  const allKeys = Object.keys(row);
	  let fieldsOrder = [];
	  if (onlyList.length) {
	    fieldsOrder = onlyList.slice();
	  } else {
	    for (const p of customOrder) if (!excludeSet.has(p) && allKeys.includes(p)) fieldsOrder.push(p);
	    for (const k of allKeys) if (!excludeSet.has(k) && !fieldsOrder.includes(k)) fieldsOrder.push(k);
	  }
	
	  /* ============ MAP VISIBILITY ============ */
	  function hasValidPoint(r){
	    if (r.Point?.type==='Point' && isArr(r.Point.coordinates)) {
	      const [x,y]=r.Point.coordinates; return Number.isFinite(x)&&Number.isFinite(y);
	    }
	    if (looksLatLng(r.Location)) return true;
	    return false;
	  }
	  function hasValidFence(r){
	    const ring = r['Geo Fences']?.coordinates?.[0];
	    return isArr(ring) && ring.length>=3 && ring.every(p=>isArr(p)&&p.length>=2&&Number.isFinite(p[0])&&Number.isFinite(p[1]));
	  }
	  function shouldShowMap(r){
	    if (onlyList.length){
	      const needs = new Set(onlyList);
	      const listedGeo = needs.has('Point') || needs.has('Location') || needs.has('Geo Fences');
	      return listedGeo && (hasValidPoint(r) || hasValidFence(r));
	    }
	    if (excludeSet.has('Point') && excludeSet.has('Location') && excludeSet.has('Geo Fences')) return false;
	    return hasValidPoint(r) || hasValidFence(r);
	  }
	
	  /* ============ FIELD BUILDERS ============ */
	  function makeRow(label,full){ const r=document.createElement('div'); r.className='agf-row'+(full?' full':''); const l=document.createElement('label'); l.textContent=label; r.appendChild(l); return r; }
	
	  function buildSelect(label, path, spec, meta){
	    const r=makeRow(label);
	    const sel=document.createElement('select');
	    sel.className='agf-select';
	    if (meta.multi) sel.multiple = true;
	
	    const current = getByPath(row,path);
	    const curSet  = new Set(isArr(current)?current:[current].filter(v=>v!==undefined && v!==null));
	    if (!meta.multi){
	      const ph=document.createElement('option');
	      ph.value=''; ph.textContent='— Select —';
	      sel.appendChild(ph);
	    }
	
	    for (const o of meta.options){
	      const valStr = String(o);
	      const opt=document.createElement('option'); opt.value=valStr; opt.textContent=valStr;
	      if (curSet.has(o) || curSet.has(valStr)) opt.selected=true;
	      sel.appendChild(opt);
	    }
	
	    sel.onchange = () => {
	      if (meta.multi){
	        const vals=[...sel.options].filter(o=>o.selected).map(o=>o.value);
	        setByPath(row,path,vals);
	      } else {
	        const v=sel.value;
	        setByPath(row,path, v === '' ? null : v);
	      }
	    };
	    const editableKey = pickKey(spec, ['Editable']);
	    if (editableKey && spec[editableKey] === false){ sel.disabled=true; sel.classList.add('agf-readonly'); }
	    r.appendChild(sel); return r;
	  }
	
	  function buildSimpleInput(label, value, onChange, type='text', editable=true){
	    const r=makeRow(label); let el;
	    if (type==='textarea'){ el=document.createElement('textarea'); el.className='agf-textarea'; el.value=value||''; el.oninput=e=>onChange(e.target.value); }
	    else if (type==='boolean'){ el=document.createElement('input'); el.type='checkbox'; el.checked=!!value; el.onchange=e=>onChange(!!e.target.checked); }
	    else { el=document.createElement('input'); el.type=(type==='string'?'text':type); el.className='agf-input'; el.value=(value??''); el.oninput=e=>onChange(e.target.value); }
	    if (!editable){ el.disabled=true; el.classList.add('agf-readonly'); }
	    r.appendChild(el); return r;
	  }
	
	  function getSpecFor(path){
	    // merge defaults + custom with case-insensitive keys
	    const base = {
	      'Title Original': path,
	      'Title Displayed': humanize(path.split('.').pop()),
	      Display: true,
	      Editable: true
	    };
	    const c = customByPath[path];
	    if (!c) return base;
	
	    const out = { ...base };
	    const td = pickKey(c, ['Title Displayed','title displayed','TitleDisplayed']);
	    if (td) out['Title Displayed'] = String(c[td]);
	    const disp = pickKey(c, ['Display']); if (disp) out.Display = !!c[disp];
	    const ed   = pickKey(c, ['Editable']); if (ed) out.Editable = !!c[ed];
	    const type = pickKey(c, ['Type']); if (type) out.Type = String(c[type]).toLowerCase();
	
	    const rootOpt = pickKey(c, ['Options','Choices','Values','Items','List']);
	    if (rootOpt && isArr(c[rootOpt])) out.Options = c[rootOpt].slice();
	
	    const multiFlag = pickKey(c, ['MultipleSelection','Multiple Selection','Multiple','multi','multiSelect','multiselect']);
	    if (multiFlag) out.MultipleSelection = !!c[multiFlag];
	
	    const mcKey = pickKey(c, ['MultipleChoice','Multiple Choice','multipleChoice','multiple choice']);
	    if (mcKey) out.MultipleChoice = c[mcKey];
	
	    return out;
	  }
	
	  function buildFieldFromSpec(spec){
	    const pathKey = pickKey(spec, ['Title Original','title original','TitleOriginal']);
	    const path = String(pathKey ? spec[pathKey] : '').trim();
	    const labelKey = pickKey(spec, ['Title Displayed','title displayed','TitleDisplayed']);
	    const label = (labelKey ? String(spec[labelKey]).trim() : '') || humanize(path.split('.').pop());
	    const displayKey = pickKey(spec, ['Display']);
	    if (displayKey && spec[displayKey] === false) return null;
	
	    // SELECT / DROPDOWN
	    const choiceMeta = getChoiceMeta(spec);
	    if (choiceMeta) return buildSelect(label, path, spec, choiceMeta);
	
	    // GEO fields (manual inputs)
	    let val = getByPath(row, path);
	    if (path==='Location' || path==='Point'){
	      const r = makeRow(label);
	      const wrap=document.createElement('div'); wrap.className='agf-inline';
	      const lat=document.createElement('input'); lat.type='number'; lat.step='any'; lat.className='agf-input'; lat.placeholder='Lat';
	      const lng=document.createElement('input'); lng.type='number'; lng.step='any'; lng.className='agf-input'; lng.placeholder='Lng';
	      let ll;
	      if (path==='Point' && val && val.type==='Point' && isArr(val.coordinates)) ll=toLatLng(val.coordinates);
	      else if (path==='Location' && looksLatLng(val)) ll={lat:val.lat, lng:val.lng};
	      else ll={lat:'', lng:''};
	      lat.value=(ll.lat??''); lng.value=(ll.lng??'');
	      const setHost=()=>{ const nll={lat:Number(lat.value||0), lng:Number(lng.value||0)};
	        if (path==='Point'){ ensurePath(row,'Point',{type:'Point',coordinates:[0,0]}); row.Point.coordinates=toXY(nll); }
	        else { ensurePath(row,'Location',{lat:0,lng:0}); row.Location=nll; }
	      };
	      lat.oninput=lng.oninput=setHost;
	      const editableKey = pickKey(spec, ['Editable']);
	      if (editableKey && spec[editableKey] === false){ lat.disabled=true; lng.disabled=true; lat.classList.add('agf-readonly'); lng.classList.add('agf-readonly'); }
	      wrap.append(lat,lng); r.appendChild(wrap); return r;
	    }
	    if (path==='Geo Fences'){ return document.createComment('Geo Fences handled by map'); }
	
	    // Standard inputs
	    const typeKey = pickKey(spec, ['Type']);
	    const tOverride = typeKey ? String(spec[typeKey]).toLowerCase() : null;
	    const t = tOverride || kindOf(val);
	
	    const editableKey = pickKey(spec, ['Editable']);
	    const editable = !(editableKey && spec[editableKey] === false);
	
	    if (t==='object' || t==='array'){
	      const text = val ? JSON.stringify(val,null,2) : '';
	      return buildSimpleInput(label,text,v=>{ try{ setByPath(row,path,JSON.parse(v)); }catch{} },'textarea',editable);
	    }
	    if (t==='boolean') return buildSimpleInput(label,!!val,v=>setByPath(row,path,!!v),'boolean',editable);
	    if (t==='number')  return buildSimpleInput(label,(val??''),v=>setByPath(row,path,(v===''?null:Number(v))),'number',editable);
	    if (t==='date')    return buildSimpleInput(label,(val||'').slice(0,10),v=>setByPath(row,path,v||''),'date',editable);
	    if (t==='datetime'){ const init=val && re.isoDT.test(val)?val.replace('Z',''):''; return buildSimpleInput(label,init,v=>setByPath(row,path,v||''),'datetime-local',editable); }
	    if (t==='textarea')return buildSimpleInput(label,val||'',v=>setByPath(row,path,v),'textarea',editable);
	    if (t==='color')   return buildSimpleInput(label,val||'#000000',v=>setByPath(row,path,v||'#000000'),'color',editable);
	    return buildSimpleInput(label,val||'',v=>setByPath(row,path,v), (t==='string'?'text':t), editable);
	  }
	
	  /* ============ MAP SECTION ============ */
	  function normalizePolygon(poly){
	    if (!poly || !poly.coordinates || !isArr(poly.coordinates[0])) return poly;
	    const ring = poly.coordinates[0]; if (!ring.length) return poly;
	    const f=ring[0], l=ring[ring.length-1]; if (f[0]!==l[0]||f[1]!==l[1]) ring.push([...f]); poly.coordinates=[ring]; return poly;
	  }
	
	  function buildMapSection(host){
	    if (!shouldShowMap(host)) return null;
	
	    const cPoint = customByPath['Point'] || customByPath['Location'];
	    const cFence = customByPath['Geo Fences'];
	    const canEditPoint = cPoint ? (cPoint.Editable !== false) : true;
	    const canEditFence = cFence ? (cFence.Editable !== false) : true;
	    const hasFenceNow = hasValidFence(host);
	
	    const box = document.createElement('div'); box.className='agf-map-wrap agf-row full';
	    const toolbar = document.createElement('div'); toolbar.className='agf-map-toolbar';
	    const lbl = document.createElement('div'); lbl.textContent = 'Map (hybrid, traffic on)';
	    const editBtn = document.createElement('button'); editBtn.className='agf-btn'+((!canEditFence||!hasFenceNow)?' agf-hide':''); editBtn.textContent='Edit';
	    const doneBtn = document.createElement('button'); doneBtn.className='agf-btn agf-hide'; doneBtn.textContent='Done';
	    const colorInp = document.createElement('input'); colorInp.type='color'; colorInp.className='agf-input'+(hasFenceNow?'':' agf-hide'); colorInp.style.width='54px';
	    colorInp.value = (host.Color && re.hex.test(host.Color) ? host.Color : '#FF0000');
	    toolbar.append(lbl, editBtn, doneBtn, colorInp);
	
	    const mapDiv = document.createElement('div'); mapDiv.className='agf-map';
	    box.append(toolbar, mapDiv);
	
	    (async () => {
	      await loadMapsOnce(GMAPS_KEY);
	
	      let MapCtor=google.maps.Map, TrafficCtor=google.maps.TrafficLayer, AdvancedMarker=null;
	      if (google.maps.importLibrary){
	        const mapsMod=await google.maps.importLibrary('maps');
	        MapCtor=mapsMod.Map; TrafficCtor=mapsMod.TrafficLayer || google.maps.TrafficLayer;
	        try{ const markerMod=await google.maps.importLibrary('marker'); AdvancedMarker=markerMod.AdvancedMarkerElement||null; }catch{}
	      } else {
	        AdvancedMarker = google.maps?.marker?.AdvancedMarkerElement || null;
	      }
	
	      const ringXY = host['Geo Fences']?.coordinates?.[0] || [];
	      const pathLL = hasFenceNow ? ringXY.map(toLatLng) : [];
	      let start = (host.Point?.type==='Point' && isArr(host.Point.coordinates)) ? toLatLng(host.Point.coordinates)
	                : (looksLatLng(host.Location) ? {lat:host.Location.lat, lng:host.Location.lng}
	                : (pathLL[0] || {lat:-28.8133, lng:29.54567}));
	
	      const map = new MapCtor(mapDiv, {
	        center:start, zoom:16, mapTypeId:'hybrid', mapId:MAP_ID || undefined,
	        streetViewControl:false, fullscreenControl:true, mapTypeControl:false, gestureHandling:'greedy'
	      });
	      try { new TrafficCtor().setMap(map); } catch {}
	
	      const getPoint = () => {
	        if (host.Point?.type==='Point' && isArr(host.Point.coordinates)) return toLatLng(host.Point.coordinates);
	        if (looksLatLng(host.Location)) return { lat:Number(host.Location.lat)||0, lng:Number(host.Location.lng)||0 };
	        return start;
	      };
	      const setPoint = (ll) => {
	        if (host.Point && host.Point.type==='Point') host.Point.coordinates = toXY(ll);
	        else host.Location = { lat:Number(ll.lat), lng:Number(ll.lng) };
	      };
	
	      let marker;
	      const markerOpts = { map, position:getPoint() };
	      if (AdvancedMarker){
	        marker = new AdvancedMarker({ ...markerOpts, gmpDraggable: !!canEditPoint });
	        marker.addListener('dragend',e=>{ if (!canEditPoint) return; const p=e.latLng; setPoint({lat:p.lat(),lng:p.lng()}); map.panTo(p); });
	      } else {
	        marker = new google.maps.Marker({ ...markerOpts, draggable: !!canEditPoint });
	        marker.addListener('dragend',e=>{ if (!canEditPoint) return; const p=e.latLng; setPoint({lat:p.lat(),lng:p.lng()}); map.panTo(p); });
	      }
	
	      normalizePolygon(host['Geo Fences']);
	      let polygon=null;
	      if (hasFenceNow){
	        polygon = new google.maps.Polygon({
	          map, paths:pathLL, strokeColor: colorInp.value, fillColor: colorInp.value,
	          strokeOpacity:.9, fillOpacity:.2, strokeWeight:2, editable:false
	        });
	        const b=new google.maps.LatLngBounds(); pathLL.forEach(p=>b.extend(p)); if(!b.isEmpty()) map.fitBounds(b);
	      } else {
	        const b=boundsForRadiusMeters(getPoint(),2000); map.fitBounds(b);
	      }
	
	      const applyColor = (hex)=>{ try{ polygon && polygon.setOptions({strokeColor:hex, fillColor:hex}); }catch{}; host.Color=hex; };
	      colorInp.oninput=()=>applyColor(colorInp.value);
	
	      let polygonEditing=false;
	      map.addListener('click',e=>{
	        if (!polygonEditing && canEditPoint){
	          marker.setPosition(e.latLng); setPoint({lat:e.latLng.lat(), lng:e.latLng.lng()}); map.panTo(e.latLng);
	        }
	      });
	
	      function writePolygonToRow(){
	        if (!polygon) return;
	        const path=polygon.getPath(); const pts=[];
	        for (let i=0;i<path.getLength();i++){ const p=path.getAt(i); pts.push({lat:p.lat(), lng:p.lng()}); }
	        if (pts.length && (pts[0].lat!==pts[pts.length-1].lat || pts[0].lng!==pts[pts.length-1].lng)) pts.push({...pts[0]});
	        host['Geo Fences']={ type:'Polygon', coordinates:[ pts.map(toXY) ] };
	      }
	      function toggleEditing(on){
	        if (!canEditFence || !polygon) return;
	        polygonEditing=!!on; polygon.setEditable(on);
	        if (on){ editBtn.classList.add('agf-hide'); doneBtn.classList.remove('agf-hide'); }
	        else { writePolygonToRow(); editBtn.classList.remove('agf-hide'); doneBtn.classList.add('agf-hide'); }
	      }
	      editBtn.onclick=()=>toggleEditing(true);
	      doneBtn.onclick=()=>toggleEditing(false);
	
	      if (polygon){
	        const path=polygon.getPath();
	        ['insert_at','remove_at','set_at'].forEach(evt => path.addListener(evt, ()=>{ if (polygonEditing) writePolygonToRow(); }));
	      }
	    })();
	
	    return box;
	  }
	
	  /* ============ MODAL UI ============ */
	  const modal=document.createElement('div'); modal.className='agf-modal';
	  const card=document.createElement('div'); card.className='agf-card';
	  const hd=document.createElement('div'); hd.className='agf-hd';
	 const title = document.createElement('div');
	const headerText = (header && String(header).trim()) || 'Edit Row';
	title.textContent = headerText;
	  const closeX=document.createElement('div'); closeX.textContent='✕'; closeX.style.cursor='pointer';
	  const bodyWrap=document.createElement('div'); bodyWrap.className='agf-body';
	  const bd=document.createElement('div'); bd.className='agf-bd';
	  const ft=document.createElement('div'); ft.className='agf-ft';
	  const btnCancel=document.createElement('button'); btnCancel.type='button'; btnCancel.className='agf-btn'; btnCancel.textContent='Cancel';
	  const btnSave=document.createElement('button'); btnSave.type='button'; btnSave.className='agf-btn primary'; btnSave.textContent='Save';
	
	  const mapSection = buildMapSection(row);
	  if (mapSection) bd.appendChild(mapSection);
	
	  for (const key of (only ? (isArr(only)?only:[]) : (function(){
	    const excludeSet = new Set((isArr(exclude)?exclude:[]).map(String));
	    const customOrder = Object.keys(customByPath);
	    const rest = Object.keys(row).filter(k=>!excludeSet.has(k) && !customOrder.includes(k));
	    return [...customOrder, ...rest];
	  })())) {
	    if (!key || (exclude && (new Set((isArr(exclude)?exclude:[]).map(String))).has(key))) continue;
	    const spec = getSpecFor(key);
	    const el = buildFieldFromSpec(spec);
	    if (el) bd.appendChild(el);
	  }
	
	  bodyWrap.appendChild(bd); hd.append(title, closeX); ft.append(btnCancel, btnSave); card.append(hd, bodyWrap, ft); modal.append(card); document.body.appendChild(modal);
	
	  const closeModal=()=>modal.remove(); closeX.onclick=btnCancel.onclick=closeModal;
	  modal.addEventListener('click',e=>{ if(e.target===modal) closeModal(); });
	  document.addEventListener('keydown',function onEsc(ev){ if(ev.key==='Escape'){ document.removeEventListener('keydown',onEsc); closeModal(); } });
	
	  /* ============ SAVE → GRID (flash) ============ */
	  btnSave.onclick=function(){
	    try{
	      if (hasGrid){
	        const api = source.api;
	        const node = source.node;
	        node.setData(row);
	        if (api.refreshCells) api.refreshCells({ rowNodes:[node], force:true });
	        if (api.redrawRows)   api.redrawRows({ rowNodes:[node] });
	        if (api.applyTransaction) api.applyTransaction({ update:[row] });
	        setTimeout(()=>{ if (api.refreshCells) api.refreshCells({ rowNodes:[node], force:true }); if (api.flashCells) api.flashCells({ rowNodes:[node] }); }, 0);
	      } else {
	        window.dispatchEvent(new CustomEvent('agf:save', { detail:{ row, source } }));
	      }
	    }catch(_){}
	    closeModal();
	  };
	})(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	

})(Data, ({ [`kind`]: Kind,[`path`]: Path }), Custom, Exclude, Only, Header))
}

})
define('./functions/74c621ab98a12163bece4cad7be292b9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_74c621ab98a12163bece4cad7be292b9'] = async function fn_74c621ab98a12163bece4cad7be292b9(listToConcatenate, valuesToConcatenate) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.concat(array, ...values)
})(listToConcatenate, valuesToConcatenate))
}

})
define('./functions/7508d2443aea24ba74d73b27671a9829/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7508d2443aea24ba74d73b27671a9829'] = async function fn_7508d2443aea24ba74d73b27671a9829(listToModify, indexesOfElementsToRemove) {
return (await (async function(array, indexes) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.pullAt(array, ...indexes)
})(listToModify, indexesOfElementsToRemove))
}

})
define('./functions/77bed231064ec0e2a7d4ac07f751667a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_77bed231064ec0e2a7d4ac07f751667a'] = async function fn_77bed231064ec0e2a7d4ac07f751667a(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.findIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/79a6f77258336011dee2ccdfcf062c76/code.js', () => { 

BackendlessUI.Functions.Custom['fn_79a6f77258336011dee2ccdfcf062c76'] = async function fn_79a6f77258336011dee2ccdfcf062c76(listToInspect, valuesToExclude, filterFunction) {
return (await (async function(array, values, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceBy(array, values, iteratee)
})(listToInspect, valuesToExclude, filterFunction))
}

})
define('./functions/7bd98f3e8e1d5a6571e78cd4492f75a8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7bd98f3e8e1d5a6571e78cd4492f75a8'] = async function fn_7bd98f3e8e1d5a6571e78cd4492f75a8(listToModify, valuesToRemove, comparatorFunction) {
  await (async function(array, values, comparator) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllWith(array, values, comparator)
  })(listToModify, valuesToRemove, comparatorFunction);

}

})
define('./functions/7e649ea1525e52829e82c43fc4f84e2f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7e649ea1525e52829e82c43fc4f84e2f'] = async function fn_7e649ea1525e52829e82c43fc4f84e2f(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flatten(array)
})(listToFlatten))
}

})
define('./functions/84c352dcf0d18e7fa2ca41bb0fa92c91/code.js', () => { 

BackendlessUI.Functions.Custom['fn_84c352dcf0d18e7fa2ca41bb0fa92c91'] = async function fn_84c352dcf0d18e7fa2ca41bb0fa92c91(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/854e825608123b86707265b1cfb74f87/code.js', () => { 

BackendlessUI.Functions.Custom['fn_854e825608123b86707265b1cfb74f87'] = async function fn_854e825608123b86707265b1cfb74f87(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/871f7915b3813eddab1f92a989ad7f0a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_871f7915b3813eddab1f92a989ad7f0a'] = async function fn_871f7915b3813eddab1f92a989ad7f0a(Locations, AppDat) {
  await (async function(Locations, AppData) {
  	// ============================================================================
  	// Area Calculator — Backendless Custom Code
  	// Arguments: Locations, AppData  (Backendless is global)
  	// ============================================================================
  	
  	if (!Array.isArray(Locations)) {
  	  console.warn("Locations missing or invalid");
  	  return;
  	}
  	
  	// Earth radius in meters
  	const R = 6378137;
  	
  	// ------------------------------------------------------------
  	// Deg → Rad
  	// ------------------------------------------------------------
  	const toRad = d => d * Math.PI / 180;
  	
  	// ------------------------------------------------------------
  	// Round to 2 decimals
  	// ------------------------------------------------------------
  	function round2(n) {
  	  return Math.round(n * 100) / 100;
  	}
  	
  	// ------------------------------------------------------------
  	// Spherical Excess polygon area
  	// coords = [ [lng,lat], ... ] (closed ring)
  	// ------------------------------------------------------------
  	function computeSphericalPolygonArea(coords) {
  	  if (!coords || coords.length < 4) return 0;
  	
  	  let total = 0;
  	
  	  for (let i = 0; i < coords.length - 1; i++) {
  	    const [lng1, lat1] = coords[i];
  	    const [lng2, lat2] = coords[i + 1];
  	
  	    const φ1 = toRad(lat1);
  	    const φ2 = toRad(lat2);
  	    const λ1 = toRad(lng1);
  	    const λ2 = toRad(lng2);
  	
  	    const dλ = λ2 - λ1;
  	
  	    const t = Math.tan(φ2 / 2 + Math.PI / 4);
  	    const b = Math.tan(φ1 / 2 + Math.PI / 4);
  	
  	    total += Math.atan2(
  	      Math.sin(dλ) * b * t,
  	      1 + b * t * Math.cos(dλ)
  	    );
  	  }
  	
  	  return Math.abs(total * 2 * R * R);
  	}
  	
  	// ============================================================================
  	// UNIVERSAL polygon ring extractor (GeoJSON + Legacy/Proxy formats)
  	// ============================================================================
  	function extractRing(poly) {
  	  if (!poly) return null;
  	
  	  // --- GeoJSON ---
  	  if (
  	    poly.type === "Polygon" &&
  	    Array.isArray(poly.coordinates) &&
  	    Array.isArray(poly.coordinates[0])
  	  ) {
  	    return poly.coordinates[0].map(c => [Number(c[0]), Number(c[1])]);
  	  }
  	
  	  // --- Legacy boundary.points (FleetInForm / Proxy objects) ---
  	  if (poly.boundary && Array.isArray(poly.boundary.points)) {
  	    return poly.boundary.points
  	      .map(p => {
  	        const lng =
  	          (typeof p.x === "number" ? p.x : null) ??
  	          (typeof p.lng === "number" ? p.lng : null) ??
  	          (typeof p.srs?.x === "number" ? p.srs.x : null) ??
  	          (typeof p.srse?.x === "number" ? p.srse.x : null);
  	
  	        const lat =
  	          (typeof p.y === "number" ? p.y : null) ??
  	          (typeof p.lat === "number" ? p.lat : null) ??
  	          (typeof p.srs?.y === "number" ? p.srs.y : null) ??
  	          (typeof p.srse?.y === "number" ? p.srse.y : null);
  	
  	        if (lng == null || lat == null) return null;
  	        return [Number(lng), Number(lat)];
  	      })
  	      .filter(Boolean);
  	  }
  	
  	  return null;
  	}
  	
  	// ============================================================================
  	// SANITISER — removes invalid fields, proxies, UI junk
  	// Also normalises Type to match Backendless dropdown validation
  	// ============================================================================
  	function cleanLocation(loc) {
  	
  	  // ----- TYPE NORMALISATION -----
  	  let t = (loc.Type || "").trim();
  	
  	  const normalizedType = (() => {
  	    const val = t.toLowerCase();
  	
  	    if (val.includes("load") || val.includes("offload"))
  	      return "Load/Offload Point";
  	
  	    if (val.includes("fuel") && val.includes("station"))
  	      return "Fuel Station";
  	
  	    if (val.includes("fuel") && val.includes("bowser"))
  	      return "Fuel Bowser";
  	
  	    if (val.includes("farm"))
  	      return "Farm";
  	
  	    if (val.includes("field"))
  	      return "Field";
  	
  	    if (val.includes("depot"))
  	      return "Depot";
  	
  	    if (val.includes("service"))
  	      return "Service Centre";
  	
  	    if (val.includes("gate"))
  	      return "Gate";
  	
  	    return "Load/Offload Point"; // fallback
  	  })();
  	
  	  return {
  	    objectId: loc.objectId || null,
  	    Name: loc.Name || "",
  	    Color: loc.Color || null,
  	    Type: normalizedType,
  	    EntrancePoint: loc.EntrancePoint ? JSON.parse(JSON.stringify(loc.EntrancePoint)) : null,
  	    Polygon: loc.Polygon ? JSON.parse(JSON.stringify(loc.Polygon)) : null,
  	    LocationData: loc.LocationData ? JSON.parse(JSON.stringify(loc.LocationData)) : {},
  	    created: loc.created || null,
  	    updated: Date.now(),
  	    ___class: "Locations"
  	  };
  	}
  	
  	// ============================================================================
  	// AppData sync (same pattern as your main editor)
  	// ============================================================================
  	function syncIntoAppData(loc) {
  	  if (!AppData || !AppData.User || !Array.isArray(AppData.User.Companies)) return;
  	
  	  const companies = AppData.User.Companies;
  	  const oid = loc.objectId;
  	
  	  companies.forEach(co => {
  	    if (!Array.isArray(co.Locations)) return;
  	    const idx = co.Locations.findIndex(l => l && l.objectId === oid);
  	    if (idx >= 0) co.Locations[idx] = loc;
  	  });
  	}
  	
  	// ============================================================================
  	// 1) Collect Locations requiring Area calculation
  	// ============================================================================
  	const changed = [];
  	
  	Locations.forEach(loc => {
  	  const ld = loc.LocationData = loc.LocationData || {};
  	
  	  // Already has Area → skip
  	  if (ld.Area) return;
  	
  	  const ring = extractRing(loc.Polygon);
  	  if (!ring || ring.length < 3) return;
  	
  	  // Close ring if needed
  	  const first = ring[0];
  	  const last = ring[ring.length - 1];
  	  if (first[0] !== last[0] || first[1] !== last[1]) {
  	    ring.push([...first]);
  	  }
  	
  	  // Compute area
  	  const areaM2 = computeSphericalPolygonArea(ring);
  	
  	  // Store rounded values
  	  ld.Area = {
  	    m2: round2(areaM2),
  	    Hectares: round2(areaM2 / 10000),
  	    Acres: round2(areaM2 * 0.000247105)
  	  };
  	
  	  changed.push(loc);
  	  syncIntoAppData(loc);
  	});
  	
  	if (!changed.length) {
  	  console.info("No locations required area calculation.");
  	  return;
  	}
  	
  	// ============================================================================
  	// 2) Build Backendless Unit-of-Work bulk UPSERT
  	// ============================================================================
  	const payload = {
  	  isAtomic: false,
  	  operations: changed.map((loc, index) => ({
  	    opResultId: `op${index}`,
  	    operationType: "UPSERT",
  	    table: "Locations",
  	    payload: cleanLocation(loc)
  	  }))
  	};
  	
  	// ============================================================================
  	// 3) Execute Unit-of-Work
  	// ============================================================================
  	return fetch(
  	  `https://api.backendless.com/${Backendless.appId}/${Backendless.apiKey}/transaction/unit-of-work`,
  	  {
  	    method: "POST",
  	    headers: { "Content-Type": "application/json" },
  	    body: JSON.stringify(payload)
  	  }
  	)
  	  .then(r => r.json())
  	  .then(result => {
  	    if (result.error) {
  	      console.error("Bulk upsert failed:", result);
  	      alert("Bulk upsert failed — see console.");
  	      return;
  	    }
  	
  	    // apply returned values
  	    changed.forEach((loc, index) => {
  	      const returned = result[`op${index}`]?.result;
  	      if (returned) Object.assign(loc, returned);
  	    });
  	
  	    console.info(`Updated ${changed.length} Locations with new Area values.`);
  	    return changed;
  	  })
  	  .catch(err => {
  	    console.error("Bulk upsert exception:", err);
  	    alert("Bulk upsert failed — see console.");
  	  });

  })(Locations, AppDat);

}

})
define('./functions/8835b8cf7f6cffe8039af6fea3d1e9a8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8835b8cf7f6cffe8039af6fea3d1e9a8'] = async function fn_8835b8cf7f6cffe8039af6fea3d1e9a8(Map) {
  await (async function(Map) {
  	/* 
  	Inputs: Map
  	Outputs: 
  	  MapReady (boolean)
  	  MapObject (google.maps.Map)
  	  Wrapper (any)
  	  Element (DOM)
  	Purpose:
  	  - Resolves Google Map instance from any wrapper.
  	  - Waits for initialization (async safe).
  	  - Automatically cleans old markers/polylines/polygons.
  	*/
  	
  	return (async () => {
  	
  	  // === Tunables ===
  	  const TIMEOUT_MS = 10000;  // Max wait
  	  const STABLE_COUNT = 1;    // Require N consecutive good ticks
  	
  	  // === Tiny utils ===
  	  const nextFrame = () => new Promise(r => requestAnimationFrame(r));
  	  const sleep = (ms) => new Promise(r => setTimeout(r, ms));
  	  const now = () => (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
  	
  	  const isGmAvailable = () =>
  	    typeof window !== "undefined" &&
  	    window.google && window.google.maps &&
  	    typeof window.google.maps.Map === "function";
  	
  	  const tryImportMaps = async () => {
  	    try {
  	      if (window?.google?.maps?.importLibrary && !isGmAvailable()) {
  	        await Promise.race([
  	          window.google.maps.importLibrary("maps"),
  	          nextFrame()
  	        ]);
  	      }
  	    } catch (_) { /* ignore */ }
  	  };
  	
  	  // === Core extractors ===
  	  const extractMap = (candidate) => {
  	    if (!candidate) return null;
  	    try {
  	      if (isGmAvailable() && candidate instanceof window.google.maps.Map) return candidate;
  	
  	      const directCandidates = [];
  	      const push = (x) => { if (x) directCandidates.push(x); };
  	
  	      push(candidate.map);
  	      if (typeof candidate.map === "function") push(candidate.map());
  	      push(candidate.map?.map);
  	      if (typeof candidate.map?.getMap === "function") push(candidate.map.getMap());
  	      if (typeof candidate.getMap === "function") push(candidate.getMap());
  	      push(candidate.googleMap);
  	      push(candidate.gMap);
  	      push(candidate.gmap);
  	      push(candidate.__map);
  	      push(candidate._map);
  	      push(candidate.api?.map);
  	      if (candidate.mapComponent?.getMap) push(candidate.mapComponent.getMap());
  	      push(candidate.$mapObject);
  	      push(candidate.$refs?.map?.$mapObject);
  	
  	      for (const c of directCandidates) {
  	        if (!c) continue;
  	        if (isGmAvailable() && c instanceof window.google.maps.Map) return c;
  	        if (c && typeof c.getCenter === "function" && typeof c.panTo === "function") return c; // duck type
  	      }
  	
  	      if (typeof candidate.getCenter === "function" && typeof candidate.panTo === "function") return candidate;
  	    } catch (_) {}
  	    return null;
  	  };
  	
  	  const getEl = (candidate, mapInstance) => {
  	    try {
  	      if (!candidate) return mapInstance?.getDiv?.() || null;
  	      if (typeof candidate.el === "function") return candidate.el();
  	      if (candidate.el) return candidate.el;
  	      if (candidate.element) return candidate.element;
  	      if (candidate.$el) return candidate.$el;
  	      if (mapInstance?.getDiv) return mapInstance.getDiv();
  	    } catch (_) {}
  	    return null;
  	  };
  	
  	  const isWrapperLikelyValid = (candidate) =>
  	    !!candidate && (("map" in candidate) || ("el" in candidate) || ("element" in candidate) || ("center" in candidate));
  	
  	  // === Initial fast path ===
  	  let wrapper = Map;
  	  let mapInstance = extractMap(wrapper);
  	  let el = getEl(wrapper, mapInstance);
  	
  	  if (mapInstance) {
  	    cleanMap(mapInstance);
  	    return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	  }
  	
  	  tryImportMaps();
  	  const deadline = now() + TIMEOUT_MS;
  	  let stable = 0;
  	
  	  // === Main wait loop ===
  	  while (now() < deadline) {
  	    if (!isWrapperLikelyValid(wrapper)) {
  	      if (document.hidden) await sleep(10); else await nextFrame();
  	      continue;
  	    }
  	
  	    if (!isGmAvailable()) {
  	      if (document.hidden) await sleep(10); else await nextFrame();
  	      continue;
  	    }
  	
  	    mapInstance = extractMap(wrapper);
  	    el = getEl(wrapper, mapInstance);
  	    const elOk = !el || !!el.isConnected || !!(el?.ownerDocument);
  	
  	    if (mapInstance && elOk) {
  	      stable++;
  	      if (stable >= STABLE_COUNT) {
  	        cleanMap(mapInstance);
  	        return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	      }
  	    } else {
  	      stable = 0;
  	    }
  	
  	    if (document.hidden) await sleep(10); else await nextFrame();
  	  }
  	
  	  // === Timeout fallback ===
  	  console.warn("⚠️ Map Loader: Timed out waiting for map initialization.");
  	  return { MapReady: false, MapObject: mapInstance || null, Wrapper: wrapper || null, Element: el || null };
  	
  	
  	  // === Inner Cleaner Function ===
  	  function cleanMap(Map) {
  	    if (!Map || !isGmAvailable()) {
  	      console.warn("Map Cleaner: Map or Google Maps not initialized.");
  	      return;
  	    }
  	
  	    const clear = (arrName) => {
  	      const arr = Map[arrName];
  	      if (arr && Array.isArray(arr)) {
  	        arr.forEach(i => { if (i?.setMap) i.setMap(null); });
  	        Map[arrName] = [];
  	      }
  	    };
  	
  	    clear("_allMarkers");
  	    clear("_allPolylines");
  	    clear("_allPolygons");
  	    clear("_allOverlays");
  	
  	    Map._selectedMarker = null;
  	    Map._popupInfoWindow = null;
  	
  	    }
  	
  	})();

  })(Map);
  await (async function(uid) {
  	return new Promise(resolve => {
  	    function wait() {
  	        const el = ___arguments.context.getComponentByUid(uid);
  	        if (el !== undefined && el !== null) {
  	            resolve(el);
  	        } else {
  	            setTimeout(wait, 5); // try again in 5ms
  	        }
  	    }
  	    wait();
  	});

  })(null);

}

})
define('./functions/8c6afca1481cdc048f1c296a77be1975/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8c6afca1481cdc048f1c296a77be1975'] = async function fn_8c6afca1481cdc048f1c296a77be1975(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flattenDeep(array)
})(listToFlatten))
}

})
define('./functions/8f4b34774e84b8b3681c852e49ed1ac5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8f4b34774e84b8b3681c852e49ed1ac5'] = async function fn_8f4b34774e84b8b3681c852e49ed1ac5(listToSlice, startPosition, endPosition) {
return (await (async function(array, start, end) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (start == null) {
	  start = 0
	}

	if (end == null) {
	  end = array.length
	}

	return _.slice(array, start, end)
})(listToSlice, startPosition, endPosition))
}

})
define('./functions/9458f55be4fb02eee2e72e0b6b1c347c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9458f55be4fb02eee2e72e0b6b1c347c'] = async function fn_9458f55be4fb02eee2e72e0b6b1c347c(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/95a8a1ed4f6da56382e43a6149f25d0c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_95a8a1ed4f6da56382e43a6149f25d0c'] = async function fn_95a8a1ed4f6da56382e43a6149f25d0c(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeRightWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/9743fcc6f0cc18c8ec28a5f4d0d17e34/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9743fcc6f0cc18c8ec28a5f4d0d17e34'] = async function fn_9743fcc6f0cc18c8ec28a5f4d0d17e34(listToModify, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.remove(array, predicate)
})(listToModify, valuePickerFunction))
}

})
define('./functions/9832dc9bfd3b3ee8a3da7ebc55af6ac9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9832dc9bfd3b3ee8a3da7ebc55af6ac9'] = async function fn_9832dc9bfd3b3ee8a3da7ebc55af6ac9(AppData, Devices, To, From, Tractor) {
var Tracking, h, item, Result, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  if ((Array.isArray(Devices)) == true) {
    Result = (getObjectProperty((getObjectProperty((await (async function(devices, to, from, parameters) {
    	/**
    	 * GPS - Device Requests (DEV ONLY: hardcoded token)
    	 * Args expected from Codeless:
    	 *   - devices    : Array<string>
    	 *   - from       : number|string|null  (optional, Unix seconds)
    	 *   - to         : number|string|null  (optional, Unix seconds)
    	 *   - parameters : Array<string>|null  (optional)
    	 */
    	
    	const AUTH_TOKEN = "FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW";
    	
    	// ---------- helpers ----------
    	function toNumOrNull(v) {
    	  if (v === "" || v === null || typeof v === "undefined") return null;
    	  const n = Number(v);
    	  return Number.isFinite(n) ? n : null;
    	}
    	
    	function normalizeDevices(list) {
    	  const flat = [];
    	  const stack = Array.isArray(list) ? [...list] : [];
    	  while (stack.length) {
    	    const x = stack.shift();
    	    if (Array.isArray(x)) stack.push(...x);
    	    else if (x !== null && typeof x !== "undefined") {
    	      const s = String(x).trim();
    	      if (s) flat.push(s);
    	    }
    	  }
    	  return Array.from(new Set(flat)); // dedupe
    	}
    	
    	function normalizeParameters(v) {
    	  if (!v) return null;
    	  if (typeof v === "string") return v.trim() || null;
    	  if (Array.isArray(v)) return v.map(s => String(s).trim()).filter(Boolean).join(",");
    	  if (typeof v === "object") {
    	    try {
    	      const vals = Object.values(v).map(x => String(x).trim()).filter(Boolean);
    	      if (vals.length) return vals.join(",");
    	    } catch (e) {}
    	  }
    	  return null;
    	}
    	
    	function buildUrl(path, dataObj) {
    	  const dataStr = encodeURIComponent(JSON.stringify(dataObj || {}));
    	  return `https://flespi.io/gw/${path}?data=${dataStr}`;
    	}
    	
    	async function getJson(url, headers) {
    	  const r = await fetch(url, { method: "GET", headers });
    	  if (!r.ok) {
    	    const t = await r.text().catch(() => "");
    	    return { ok: false, status: r.status, body: t };
    	  }
    	  const body = await r.json().catch(() => ({}));
    	  return { ok: true, status: r.status, body };
    	}
    	
    	// ---------- main ----------
    	return (async () => {
    	  try {
    	    const safeParams = typeof parameters === "undefined" ? null : parameters;
    	    const authHeader = AUTH_TOKEN.startsWith("FlespiToken ")
    	      ? AUTH_TOKEN
    	      : "FlespiToken " + AUTH_TOKEN;
    	
    	    if (!authHeader)
    	      return { ok: false, error: { code: 401, message: "Missing Flespi token." } };
    	
    	    const devs = normalizeDevices(devices);
    	    if (!devs.length)
    	      return { ok: false, error: { code: 400, message: "devices must be a non-empty list" } };
    	
    	    const fromNum = toNumOrNull(from);
    	    const toNum = toNumOrNull(to);
    	    const fields =
    	      normalizeParameters(safeParams) ||
    	      "timestamp,position.latitude,position.longitude,position.speed,engine.ignition.status";
    	
    	    const headers = {
    	      "Content-Type": "application/json",
    	      "Authorization": authHeader,
    	    };
    	
    	    console.log("🟢 Fields:", fields);
    	
    	    if (!Number.isFinite(fromNum) || !Number.isFinite(toNum))
    	      return { ok: false, error: { code: 400, message: "Missing valid timestamps." } };
    	
    	    // ============================================================
    	    // RANGE MODE with SERVER-SIDE FILTER
    	    // ============================================================
    	    const tasks = devs.map(async (dev) => {
    	      const urlRange = buildUrl(`devices/${dev}/messages`, {
    	        from: fromNum,
    	        to: toNum,
    	        fields,
    	        filter: "engine.ignition.status=true" // 🧩 << HARD FILTER HERE
    	      });
    	
    	      console.log(`🌐 Requesting device ${dev}:`, urlRange);
    	
    	      try {
    	        const { ok, body } = await getJson(urlRange, headers);
    	
    	        let results = [];
    	        if (Array.isArray(body?.result)) results = body.result;
    	        else if (Array.isArray(body?.results)) results = body.results;
    	        else if (Array.isArray(body?.messages)) results = body.messages;
    	        else if (Array.isArray(body?.items)) results = body.items;
    	        else if (Array.isArray(body?.responses?.[0]?.result))
    	          results = body.responses[0].result;
    	        else if (Array.isArray(body?.responses?.[0]?.messages))
    	          results = body.responses[0].messages;
    	
    	        console.log(`✅ Device ${dev} → ${results.length} ignition-ON messages`);
    	        return { device: dev, result: results, mode: "range" };
    	      } catch (e) {
    	        console.error(`❌ Error fetching device ${dev}:`, e);
    	        return { device: dev, error: { code: 500, message: e?.message || "fetch failed" } };
    	      }
    	    });
    	
    	    const results = await Promise.all(tasks);
    	    return { ok: true, data: { mode: "range", results }, error: null };
    	
    	  } catch (e) {
    	    console.error("💥 Internal Error:", e);
    	    return { ok: false, error: { code: 500, message: e?.message || "Internal error" } };
    	  }
    	})();

    })(Devices, To, From, (await (async function(CAN) {
    	/**
    	 * Extract unique field paths from a nested CAN JSON config
    	 * @param {Object} CAN
    	 * @returns {Array<string>}
    	 */
    	function extractFieldPaths(obj, result = new Set()) {
    	  if (!obj || typeof obj !== 'object') return result;
    	
    	  for (const [key, value] of Object.entries(obj)) {
    	    // Check for a 'field' key that looks like a parameter path
    	    if (key === 'field' && typeof value === 'string') {
    	      result.add(value.trim());
    	    }
    	
    	    // Check for multiple fields array (like "fields": ["a", "b"])
    	    if (key === 'fields' && Array.isArray(value)) {
    	      for (const f of value) {
    	        if (typeof f === 'string') result.add(f.trim());
    	      }
    	    }
    	
    	    // Recurse into objects and arrays
    	    if (typeof value === 'object') extractFieldPaths(value, result);
    	  }
    	
    	  return result;
    	}
    	
    	// === MAIN ENTRY ===
    	try {
    	  const fields = Array.from(extractFieldPaths(CAN));
    	  return fields.sort(); // Alphabetically sorted
    	} catch (err) {
    	  return { error: err.message || err };
    	}

    })((getObjectProperty(Tractor, 'CAN')))))), 'data')), 'results'));
    await (async function(devices, to, from, parameters) {
    	/**
    	 * GPS - Device Requests (DEV ONLY: hardcoded token)
    	 * Args expected from Codeless:
    	 *   - devices    : Array<string>
    	 *   - from       : number|string|null  (optional, Unix seconds)
    	 *   - to         : number|string|null  (optional, Unix seconds)
    	 *   - parameters : Array<string>|null  (optional)
    	 */
    	
    	const AUTH_TOKEN = "FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW";
    	
    	// ---------- helpers ----------
    	function toNumOrNull(v) {
    	  if (v === "" || v === null || typeof v === "undefined") return null;
    	  const n = Number(v);
    	  return Number.isFinite(n) ? n : null;
    	}
    	
    	function normalizeDevices(list) {
    	  const flat = [];
    	  const stack = Array.isArray(list) ? [...list] : [];
    	  while (stack.length) {
    	    const x = stack.shift();
    	    if (Array.isArray(x)) stack.push(...x);
    	    else if (x !== null && typeof x !== "undefined") {
    	      const s = String(x).trim();
    	      if (s) flat.push(s);
    	    }
    	  }
    	  return Array.from(new Set(flat)); // dedupe
    	}
    	
    	function normalizeParameters(v) {
    	  if (!v) return null;
    	  if (typeof v === "string") return v.trim() || null;
    	  if (Array.isArray(v)) return v.map(s => String(s).trim()).filter(Boolean).join(",");
    	  if (typeof v === "object") {
    	    try {
    	      const vals = Object.values(v).map(x => String(x).trim()).filter(Boolean);
    	      if (vals.length) return vals.join(",");
    	    } catch (e) {}
    	  }
    	  return null;
    	}
    	
    	function buildUrl(path, dataObj) {
    	  const dataStr = encodeURIComponent(JSON.stringify(dataObj || {}));
    	  return `https://flespi.io/gw/${path}?data=${dataStr}`;
    	}
    	
    	async function getJson(url, headers) {
    	  const r = await fetch(url, { method: "GET", headers });
    	  if (!r.ok) {
    	    const t = await r.text().catch(() => "");
    	    return { ok: false, status: r.status, body: t };
    	  }
    	  const body = await r.json().catch(() => ({}));
    	  return { ok: true, status: r.status, body };
    	}
    	
    	// ---------- main ----------
    	return (async () => {
    	  try {
    	    const safeParams = typeof parameters === "undefined" ? null : parameters;
    	    const authHeader = AUTH_TOKEN.startsWith("FlespiToken ")
    	      ? AUTH_TOKEN
    	      : "FlespiToken " + AUTH_TOKEN;
    	
    	    if (!authHeader)
    	      return { ok: false, error: { code: 401, message: "Missing Flespi token." } };
    	
    	    const devs = normalizeDevices(devices);
    	    if (!devs.length)
    	      return { ok: false, error: { code: 400, message: "devices must be a non-empty list" } };
    	
    	    const fromNum = toNumOrNull(from);
    	    const toNum = toNumOrNull(to);
    	    const fields =
    	      normalizeParameters(safeParams) ||
    	      "timestamp,position.latitude,position.longitude,position.speed,engine.ignition.status";
    	
    	    const headers = {
    	      "Content-Type": "application/json",
    	      "Authorization": authHeader,
    	    };
    	
    	    console.log("🟢 Fields:", fields);
    	
    	    if (!Number.isFinite(fromNum) || !Number.isFinite(toNum))
    	      return { ok: false, error: { code: 400, message: "Missing valid timestamps." } };
    	
    	    // ============================================================
    	    // RANGE MODE with SERVER-SIDE FILTER
    	    // ============================================================
    	    const tasks = devs.map(async (dev) => {
    	      const urlRange = buildUrl(`devices/${dev}/messages`, {
    	        from: fromNum,
    	        to: toNum,
    	        fields,
    	        filter: "engine.ignition.status=true" // 🧩 << HARD FILTER HERE
    	      });
    	
    	      console.log(`🌐 Requesting device ${dev}:`, urlRange);
    	
    	      try {
    	        const { ok, body } = await getJson(urlRange, headers);
    	
    	        let results = [];
    	        if (Array.isArray(body?.result)) results = body.result;
    	        else if (Array.isArray(body?.results)) results = body.results;
    	        else if (Array.isArray(body?.messages)) results = body.messages;
    	        else if (Array.isArray(body?.items)) results = body.items;
    	        else if (Array.isArray(body?.responses?.[0]?.result))
    	          results = body.responses[0].result;
    	        else if (Array.isArray(body?.responses?.[0]?.messages))
    	          results = body.responses[0].messages;
    	
    	        console.log(`✅ Device ${dev} → ${results.length} ignition-ON messages`);
    	        return { device: dev, result: results, mode: "range" };
    	      } catch (e) {
    	        console.error(`❌ Error fetching device ${dev}:`, e);
    	        return { device: dev, error: { code: 500, message: e?.message || "fetch failed" } };
    	      }
    	    });
    	
    	    const results = await Promise.all(tasks);
    	    return { ok: true, data: { mode: "range", results }, error: null };
    	
    	  } catch (e) {
    	    console.error("💥 Internal Error:", e);
    	    return { ok: false, error: { code: 500, message: e?.message || "Internal error" } };
    	  }
    	})();

    })(Devices, To, From, (await (async function(CAN) {
    	/**
    	 * Extract unique field paths from a nested CAN JSON config
    	 * @param {Object} CAN
    	 * @returns {Array<string>}
    	 */
    	function extractFieldPaths(obj, result = new Set()) {
    	  if (!obj || typeof obj !== 'object') return result;
    	
    	  for (const [key, value] of Object.entries(obj)) {
    	    // Check for a 'field' key that looks like a parameter path
    	    if (key === 'field' && typeof value === 'string') {
    	      result.add(value.trim());
    	    }
    	
    	    // Check for multiple fields array (like "fields": ["a", "b"])
    	    if (key === 'fields' && Array.isArray(value)) {
    	      for (const f of value) {
    	        if (typeof f === 'string') result.add(f.trim());
    	      }
    	    }
    	
    	    // Recurse into objects and arrays
    	    if (typeof value === 'object') extractFieldPaths(value, result);
    	  }
    	
    	  return result;
    	}
    	
    	// === MAIN ENTRY ===
    	try {
    	  const fields = Array.from(extractFieldPaths(CAN));
    	  return fields.sort(); // Alphabetically sorted
    	} catch (err) {
    	  return { error: err.message || err };
    	}

    })((getObjectProperty(Tractor, 'CAN')))));
    try {
      var j_list = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        var h_list = (getObjectProperty(j, 'Tractors'));
        for (var h_index in h_list) {
          h = h_list[h_index];
          try {
            Tracking = (await asyncListFind(Result, async (item) => {


             return ((getObjectProperty(item, 'device')) == (getObjectProperty(h, 'Tracker')));
            }));

          } catch (error) {

          }
          try {
            h['Tracking'] = (getObjectProperty((getObjectProperty(Tracking, 'result')), 'result'));

          } catch (error) {

          }
          try {
            (getObjectProperty(AppData, 'SelectedTractor'))['Tracking'] = (getObjectProperty((getObjectProperty(Tracking, 'result')), 'result'));

          } catch (error) {

          }
        }
      }

    } catch (error) {

    }
  } else {
    await (async function(devices, to, from, parameters) {
    	/**
    	 * GPS - Device Requests (DEV ONLY: hardcoded token)
    	 * Args expected from Codeless:
    	 *   - devices    : Array<string>
    	 *   - from       : number|string|null  (optional, Unix seconds)
    	 *   - to         : number|string|null  (optional, Unix seconds)
    	 *   - parameters : Array<string>|null  (optional)
    	 */
    	
    	const AUTH_TOKEN = "FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW";
    	
    	// ---------- helpers ----------
    	function toNumOrNull(v) {
    	  if (v === "" || v === null || typeof v === "undefined") return null;
    	  const n = Number(v);
    	  return Number.isFinite(n) ? n : null;
    	}
    	
    	function normalizeDevices(list) {
    	  const flat = [];
    	  const stack = Array.isArray(list) ? [...list] : [];
    	  while (stack.length) {
    	    const x = stack.shift();
    	    if (Array.isArray(x)) stack.push(...x);
    	    else if (x !== null && typeof x !== "undefined") {
    	      const s = String(x).trim();
    	      if (s) flat.push(s);
    	    }
    	  }
    	  return Array.from(new Set(flat)); // dedupe
    	}
    	
    	function normalizeParameters(v) {
    	  if (!v) return null;
    	  if (typeof v === "string") return v.trim() || null;
    	  if (Array.isArray(v)) return v.map(s => String(s).trim()).filter(Boolean).join(",");
    	  if (typeof v === "object") {
    	    try {
    	      const vals = Object.values(v).map(x => String(x).trim()).filter(Boolean);
    	      if (vals.length) return vals.join(",");
    	    } catch (e) {}
    	  }
    	  return null;
    	}
    	
    	function buildUrl(path, dataObj) {
    	  const dataStr = encodeURIComponent(JSON.stringify(dataObj || {}));
    	  return `https://flespi.io/gw/${path}?data=${dataStr}`;
    	}
    	
    	async function getJson(url, headers) {
    	  const r = await fetch(url, { method: "GET", headers });
    	  if (!r.ok) {
    	    const t = await r.text().catch(() => "");
    	    return { ok: false, status: r.status, body: t };
    	  }
    	  const body = await r.json().catch(() => ({}));
    	  return { ok: true, status: r.status, body };
    	}
    	
    	// ---------- main ----------
    	return (async () => {
    	  try {
    	    const safeParams = typeof parameters === "undefined" ? null : parameters;
    	    const authHeader = AUTH_TOKEN.startsWith("FlespiToken ")
    	      ? AUTH_TOKEN
    	      : "FlespiToken " + AUTH_TOKEN;
    	
    	    if (!authHeader)
    	      return { ok: false, error: { code: 401, message: "Missing Flespi token." } };
    	
    	    const devs = normalizeDevices(devices);
    	    if (!devs.length)
    	      return { ok: false, error: { code: 400, message: "devices must be a non-empty list" } };
    	
    	    const fromNum = toNumOrNull(from);
    	    const toNum = toNumOrNull(to);
    	    const fields =
    	      normalizeParameters(safeParams) ||
    	      "timestamp,position.latitude,position.longitude,position.speed,engine.ignition.status";
    	
    	    const headers = {
    	      "Content-Type": "application/json",
    	      "Authorization": authHeader,
    	    };
    	
    	    console.log("🟢 Fields:", fields);
    	
    	    if (!Number.isFinite(fromNum) || !Number.isFinite(toNum))
    	      return { ok: false, error: { code: 400, message: "Missing valid timestamps." } };
    	
    	    // ============================================================
    	    // RANGE MODE with SERVER-SIDE FILTER
    	    // ============================================================
    	    const tasks = devs.map(async (dev) => {
    	      const urlRange = buildUrl(`devices/${dev}/messages`, {
    	        from: fromNum,
    	        to: toNum,
    	        fields,
    	        filter: "engine.ignition.status=true" // 🧩 << HARD FILTER HERE
    	      });
    	
    	      console.log(`🌐 Requesting device ${dev}:`, urlRange);
    	
    	      try {
    	        const { ok, body } = await getJson(urlRange, headers);
    	
    	        let results = [];
    	        if (Array.isArray(body?.result)) results = body.result;
    	        else if (Array.isArray(body?.results)) results = body.results;
    	        else if (Array.isArray(body?.messages)) results = body.messages;
    	        else if (Array.isArray(body?.items)) results = body.items;
    	        else if (Array.isArray(body?.responses?.[0]?.result))
    	          results = body.responses[0].result;
    	        else if (Array.isArray(body?.responses?.[0]?.messages))
    	          results = body.responses[0].messages;
    	
    	        console.log(`✅ Device ${dev} → ${results.length} ignition-ON messages`);
    	        return { device: dev, result: results, mode: "range" };
    	      } catch (e) {
    	        console.error(`❌ Error fetching device ${dev}:`, e);
    	        return { device: dev, error: { code: 500, message: e?.message || "fetch failed" } };
    	      }
    	    });
    	
    	    const results = await Promise.all(tasks);
    	    return { ok: true, data: { mode: "range", results }, error: null };
    	
    	  } catch (e) {
    	    console.error("💥 Internal Error:", e);
    	    return { ok: false, error: { code: 500, message: e?.message || "Internal error" } };
    	  }
    	})();

    })([Devices], To, From, (await (async function(CAN) {
    	/**
    	 * Extract unique field paths from a nested CAN JSON config
    	 * @param {Object} CAN
    	 * @returns {Array<string>}
    	 */
    	function extractFieldPaths(obj, result = new Set()) {
    	  if (!obj || typeof obj !== 'object') return result;
    	
    	  for (const [key, value] of Object.entries(obj)) {
    	    // Check for a 'field' key that looks like a parameter path
    	    if (key === 'field' && typeof value === 'string') {
    	      result.add(value.trim());
    	    }
    	
    	    // Check for multiple fields array (like "fields": ["a", "b"])
    	    if (key === 'fields' && Array.isArray(value)) {
    	      for (const f of value) {
    	        if (typeof f === 'string') result.add(f.trim());
    	      }
    	    }
    	
    	    // Recurse into objects and arrays
    	    if (typeof value === 'object') extractFieldPaths(value, result);
    	  }
    	
    	  return result;
    	}
    	
    	// === MAIN ENTRY ===
    	try {
    	  const fields = Array.from(extractFieldPaths(CAN));
    	  return fields.sort(); // Alphabetically sorted
    	} catch (err) {
    	  return { error: err.message || err };
    	}

    })((getObjectProperty(Tractor, 'CAN')))));
    Result = (getObjectProperty((getObjectProperty((await (async function(devices, to, from, parameters) {
    	/**
    	 * GPS - Device Requests (DEV ONLY: hardcoded token)
    	 * Args expected from Codeless:
    	 *   - devices    : Array<string>
    	 *   - from       : number|string|null  (optional, Unix seconds)
    	 *   - to         : number|string|null  (optional, Unix seconds)
    	 *   - parameters : Array<string>|null  (optional)
    	 */
    	
    	const AUTH_TOKEN = "FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW";
    	
    	// ---------- helpers ----------
    	function toNumOrNull(v) {
    	  if (v === "" || v === null || typeof v === "undefined") return null;
    	  const n = Number(v);
    	  return Number.isFinite(n) ? n : null;
    	}
    	
    	function normalizeDevices(list) {
    	  const flat = [];
    	  const stack = Array.isArray(list) ? [...list] : [];
    	  while (stack.length) {
    	    const x = stack.shift();
    	    if (Array.isArray(x)) stack.push(...x);
    	    else if (x !== null && typeof x !== "undefined") {
    	      const s = String(x).trim();
    	      if (s) flat.push(s);
    	    }
    	  }
    	  return Array.from(new Set(flat)); // dedupe
    	}
    	
    	function normalizeParameters(v) {
    	  if (!v) return null;
    	  if (typeof v === "string") return v.trim() || null;
    	  if (Array.isArray(v)) return v.map(s => String(s).trim()).filter(Boolean).join(",");
    	  if (typeof v === "object") {
    	    try {
    	      const vals = Object.values(v).map(x => String(x).trim()).filter(Boolean);
    	      if (vals.length) return vals.join(",");
    	    } catch (e) {}
    	  }
    	  return null;
    	}
    	
    	function buildUrl(path, dataObj) {
    	  const dataStr = encodeURIComponent(JSON.stringify(dataObj || {}));
    	  return `https://flespi.io/gw/${path}?data=${dataStr}`;
    	}
    	
    	async function getJson(url, headers) {
    	  const r = await fetch(url, { method: "GET", headers });
    	  if (!r.ok) {
    	    const t = await r.text().catch(() => "");
    	    return { ok: false, status: r.status, body: t };
    	  }
    	  const body = await r.json().catch(() => ({}));
    	  return { ok: true, status: r.status, body };
    	}
    	
    	// ---------- main ----------
    	return (async () => {
    	  try {
    	    const safeParams = typeof parameters === "undefined" ? null : parameters;
    	    const authHeader = AUTH_TOKEN.startsWith("FlespiToken ")
    	      ? AUTH_TOKEN
    	      : "FlespiToken " + AUTH_TOKEN;
    	
    	    if (!authHeader)
    	      return { ok: false, error: { code: 401, message: "Missing Flespi token." } };
    	
    	    const devs = normalizeDevices(devices);
    	    if (!devs.length)
    	      return { ok: false, error: { code: 400, message: "devices must be a non-empty list" } };
    	
    	    const fromNum = toNumOrNull(from);
    	    const toNum = toNumOrNull(to);
    	    const fields =
    	      normalizeParameters(safeParams) ||
    	      "timestamp,position.latitude,position.longitude,position.speed,engine.ignition.status";
    	
    	    const headers = {
    	      "Content-Type": "application/json",
    	      "Authorization": authHeader,
    	    };
    	
    	    console.log("🟢 Fields:", fields);
    	
    	    if (!Number.isFinite(fromNum) || !Number.isFinite(toNum))
    	      return { ok: false, error: { code: 400, message: "Missing valid timestamps." } };
    	
    	    // ============================================================
    	    // RANGE MODE with SERVER-SIDE FILTER
    	    // ============================================================
    	    const tasks = devs.map(async (dev) => {
    	      const urlRange = buildUrl(`devices/${dev}/messages`, {
    	        from: fromNum,
    	        to: toNum,
    	        fields,
    	        filter: "engine.ignition.status=true" // 🧩 << HARD FILTER HERE
    	      });
    	
    	      console.log(`🌐 Requesting device ${dev}:`, urlRange);
    	
    	      try {
    	        const { ok, body } = await getJson(urlRange, headers);
    	
    	        let results = [];
    	        if (Array.isArray(body?.result)) results = body.result;
    	        else if (Array.isArray(body?.results)) results = body.results;
    	        else if (Array.isArray(body?.messages)) results = body.messages;
    	        else if (Array.isArray(body?.items)) results = body.items;
    	        else if (Array.isArray(body?.responses?.[0]?.result))
    	          results = body.responses[0].result;
    	        else if (Array.isArray(body?.responses?.[0]?.messages))
    	          results = body.responses[0].messages;
    	
    	        console.log(`✅ Device ${dev} → ${results.length} ignition-ON messages`);
    	        return { device: dev, result: results, mode: "range" };
    	      } catch (e) {
    	        console.error(`❌ Error fetching device ${dev}:`, e);
    	        return { device: dev, error: { code: 500, message: e?.message || "fetch failed" } };
    	      }
    	    });
    	
    	    const results = await Promise.all(tasks);
    	    return { ok: true, data: { mode: "range", results }, error: null };
    	
    	  } catch (e) {
    	    console.error("💥 Internal Error:", e);
    	    return { ok: false, error: { code: 500, message: e?.message || "Internal error" } };
    	  }
    	})();

    })([Devices], To, From, (await (async function(CAN) {
    	/**
    	 * Extract unique field paths from a nested CAN JSON config
    	 * @param {Object} CAN
    	 * @returns {Array<string>}
    	 */
    	function extractFieldPaths(obj, result = new Set()) {
    	  if (!obj || typeof obj !== 'object') return result;
    	
    	  for (const [key, value] of Object.entries(obj)) {
    	    // Check for a 'field' key that looks like a parameter path
    	    if (key === 'field' && typeof value === 'string') {
    	      result.add(value.trim());
    	    }
    	
    	    // Check for multiple fields array (like "fields": ["a", "b"])
    	    if (key === 'fields' && Array.isArray(value)) {
    	      for (const f of value) {
    	        if (typeof f === 'string') result.add(f.trim());
    	      }
    	    }
    	
    	    // Recurse into objects and arrays
    	    if (typeof value === 'object') extractFieldPaths(value, result);
    	  }
    	
    	  return result;
    	}
    	
    	// === MAIN ENTRY ===
    	try {
    	  const fields = Array.from(extractFieldPaths(CAN));
    	  return fields.sort(); // Alphabetically sorted
    	} catch (err) {
    	  return { error: err.message || err };
    	}

    })((getObjectProperty(Tractor, 'CAN')))))), 'data')), 'results'));
    try {
      var j_list2 = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        var h_list2 = (getObjectProperty(j, 'Tractors'));
        for (var h_index2 in h_list2) {
          h = h_list2[h_index2];
          try {
            Tracking = (await asyncListFind(Result, async (item) => {


             return ((getObjectProperty(item, 'device')) == (getObjectProperty(h, 'Tracker')));
            }));

          } catch (error) {

          }
          try {
            h['Tracking'] = (getObjectProperty((getObjectProperty(Tracking, 'result')), 'result'));

          } catch (error) {

          }
          try {
            (getObjectProperty(AppData, 'SelectedTractor'))['Tracking'] = (getObjectProperty((getObjectProperty(Tracking, 'result')), 'result'));

          } catch (error) {

          }
        }
      }

    } catch (error) {

    }
  }

}

})
define('./functions/999feb957f5b94173b9718e30975e8ae/code.js', () => { 

BackendlessUI.Functions.Custom['fn_999feb957f5b94173b9718e30975e8ae'] = async function fn_999feb957f5b94173b9718e30975e8ae(AppData, UID, Panel, PanelBlock, Map) {
var Locations, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Locations2() {
  Locations = [];
  var j_list = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Locations'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Locations, k);
    }
  }
  return Locations
}


  await (async function(uid) {
  	return new Promise(resolve => {
  	    function wait() {
  	        const el = ___arguments.context.getComponentByUid(uid);
  	        if (el !== undefined && el !== null) {
  	            resolve(el);
  	        } else {
  	            setTimeout(wait, 5); // try again in 5ms
  	        }
  	    }
  	    wait();
  	});

  })(UID);
  await (async function(AppData, Locations) {
  	// ========================================================================
  	// MODULE: Location Registry v3.4 (Complete Rewrite + Zoom-to-16 on EDIT BEGIN)
  	// PURPOSE: Headless-safe registry for Location runtime + persistence
  	// DESIGN:
  	//   - AppData = persistent JSON descriptors ONLY
  	//   - window.LocationRuntimeRegistry = live map objects + listeners
  	//   - Registry NEVER requires Map to exist
  	//   - Global edit-lock so only one location can be master at a time,
  	//     all others forced into slave mode (no click / no edit / no drag)
  	//   - v3.4 POLICY (YOUR REQUIREMENT):
  	//       * In EDIT MODE: ALL polygons MUST NOT be selectable (NO clicks)
  	//       * In EDIT MODE: click-through MUST be allowed (map receives clicks)
  	//       * Visual: outline-only (no fill) so drawing is clean
  	//   - NEW REQUIREMENT (YOUR WORDING):
  	//       * When it goes into EDIT MODE, it MUST set the MAP passed into the code to zoom 16
  	//
  	// MAP-SAFE: DOES NOT USE new Map() OR new Set()
  	//
  	// CONTEXT: Backendless Advanced Custom Code Block
  	// AUTHOR : Raymond + Rog
  	// ========================================================================
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 0: SAFE GLOBAL RESOLUTION (Golden Standard)
  	// ------------------------------------------------------------------------
  	var BackendlessSafe = (typeof Backendless !== "undefined" ? Backendless : null);
  	var AppDataSafe     = (typeof AppData     !== "undefined" ? AppData     : null);
  	var LocationsSafe   = (typeof Locations   !== "undefined" ? Locations   : null);
  	var PanelSafe       = (typeof Panel       !== "undefined" ? Panel       : null);
  	
  	// NOTE: Map is OPTIONAL here (often a wrapper in UI Builder)
  	var MapSafe         = (typeof Map         !== "undefined" ? Map         : null);
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 1: INITIALISE PERSISTENT STORE (JSON ONLY)
  	// ------------------------------------------------------------------------
  	if (AppDataSafe && !AppDataSafe.LocationRegistryStore) {
  	  AppDataSafe.LocationRegistryStore = {
  	    version: "store-v3.4",
  	    byId: {}
  	  };
  	}
  	
  	var STORE = AppDataSafe ? AppDataSafe.LocationRegistryStore : { byId: {} };
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 2: SAFE DICT SHIM (NO new Map())
  	// ------------------------------------------------------------------------
  	function createSafeMap() {
  	  var _store = Object.create(null);
  	  return {
  	    has: function (k) { return Object.prototype.hasOwnProperty.call(_store, String(k)); },
  	    get: function (k) {
  	      k = String(k);
  	      return Object.prototype.hasOwnProperty.call(_store, k) ? _store[k] : undefined;
  	    },
  	    set: function (k, v) { _store[String(k)] = v; return this; },
  	    delete: function (k) {
  	      k = String(k);
  	      if (Object.prototype.hasOwnProperty.call(_store, k)) { delete _store[k]; return true; }
  	      return false;
  	    },
  	    clear: function () { _store = Object.create(null); },
  	    forEach: function (fn) {
  	      for (var k in _store) if (Object.prototype.hasOwnProperty.call(_store, k)) fn(_store[k], k);
  	    },
  	    values: function () {
  	      var out = [];
  	      for (var k in _store) if (Object.prototype.hasOwnProperty.call(_store, k)) out.push(_store[k]);
  	      return out;
  	    }
  	  };
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 3: INITIALISE RUNTIME REGISTRY (LIVE OBJECTS)
  	// ------------------------------------------------------------------------
  	if (!window.LocationRuntimeRegistry) {
  	  window.LocationRuntimeRegistry = {
  	    version: "runtime-v3.4",
  	
  	    byId: createSafeMap(),      // id → runtime entry
  	    activeId: null,
  	
  	    // Global edit lock
  	    editLock: { owner: null, activeId: null, mode: "idle" },
  	
  	    // Snapshots for restoring options after slave/clickthrough
  	    slaveSnapshot: createSafeMap(), // id -> { poly:{...}, marker:{...} }
  	
  	    // click-through mode state
  	    clickThrough: { owner: null, mode: "off" },
  	
  	    // OPTIONAL pinned map ref (explicitly passed in)
  	    gMapRef: null
  	  };
  	}
  	
  	var RUNTIME = window.LocationRuntimeRegistry;
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 4: LOW-LEVEL HELPERS (SAFE)
  	// ------------------------------------------------------------------------
  	function getLocId(loc) {
  	  return (loc && (loc.objectId || loc.ObjectId || loc.id)) || null;
  	}
  	
  	function safeRemoveListener(h) {
  	  try { google.maps.event.removeListener(h); } catch (_) {}
  	}
  	
  	function removeAllListeners(runtime) {
  	  if (!runtime || !Array.isArray(runtime.listeners)) return;
  	  runtime.listeners.forEach(safeRemoveListener);
  	  runtime.listeners = [];
  	}
  	
  	function removeMapObjects(runtime) {
  	  if (!runtime) return;
  	
  	  if (runtime.polygon) {
  	    try { runtime.polygon.setMap(null); } catch (_) {}
  	    runtime.polygon = null;
  	  }
  	
  	  if (runtime.marker) {
  	    try { runtime.marker.setMap(null); } catch (_) {}
  	    runtime.marker = null;
  	  }
  	}
  	
  	function dispatchEventSafe(type, detail) {
  	  try { window.dispatchEvent(new CustomEvent(type, { detail: detail || {} })); } catch (_) {}
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 4.5: MAP RESOLUTION (MATCH WIZARD CONTRACT + "MAP PASSED IN")
  	// ------------------------------------------------------------------------
  	function resolveGMap(MapMaybe) {
  	  // Works with common UI wrappers:
  	  //   Map.map.map
  	  //   Map.map
  	  //   Map
  	  var g =
  	    (MapMaybe && MapMaybe.map && MapMaybe.map.map) ||
  	    (MapMaybe && MapMaybe.map) ||
  	    MapMaybe ||
  	    null;
  	
  	  return g || null;
  	}
  	
  	function isRealGoogleMap(m) {
  	  try {
  	    return !!(m && typeof m.setZoom === "function" && typeof m.getZoom === "function");
  	  } catch (_) {
  	    return false;
  	  }
  	}
  	
  	function getBestMap(runtime, polygon, marker, payloadMap) {
  	  // Priority order:
  	  //  1) Explicitly passed in via setMapRef (YOUR REQUIREMENT)
  	  //  2) Map passed in register(payload).map
  	  //  3) runtime.gMap pinned at register time
  	  //  4) polygon/marker.getMap()
  	  //  5) resolveGMap(MapSafe) or resolveGMap(global Map)
  	  try {
  	    var m = null;
  	
  	    // 1) explicit
  	    m = resolveGMap(RUNTIME.gMapRef);
  	    if (isRealGoogleMap(m)) return m;
  	
  	    // 2) payload map
  	    m = resolveGMap(payloadMap);
  	    if (isRealGoogleMap(m)) return m;
  	
  	    // 3) runtime pinned
  	    m = resolveGMap(runtime && runtime.gMap ? runtime.gMap : null);
  	    if (isRealGoogleMap(m)) return m;
  	
  	    // 4) object map
  	    try {
  	      m = (polygon && typeof polygon.getMap === "function") ? polygon.getMap() : null;
  	      if (isRealGoogleMap(m)) return m;
  	    } catch (_) {}
  	
  	    try {
  	      m = (marker && typeof marker.getMap === "function") ? marker.getMap() : null;
  	      if (isRealGoogleMap(m)) return m;
  	    } catch (_) {}
  	
  	    // 5) globals
  	    m = resolveGMap(MapSafe);
  	    if (isRealGoogleMap(m)) return m;
  	
  	    m = resolveGMap(typeof Map !== "undefined" ? Map : null);
  	    if (isRealGoogleMap(m)) return m;
  	
  	    return null;
  	  } catch (_) {
  	    return null;
  	  }
  	}
  	
  	function getPolygonBoundsCenter(polygon) {
  	  // Better center than "first point"
  	  try {
  	    if (!polygon || typeof polygon.getPath !== "function") return null;
  	
  	    var path = polygon.getPath();
  	    if (!path || typeof path.getLength !== "function") return null;
  	
  	    var len = path.getLength();
  	    if (!len || len < 1) return null;
  	
  	    var b = new google.maps.LatLngBounds();
  	    for (var i = 0; i < len; i++) {
  	      var p = path.getAt(i);
  	      if (p) b.extend(p);
  	    }
  	
  	    if (typeof b.getCenter === "function") return b.getCenter();
  	    return null;
  	  } catch (_) {
  	    return null;
  	  }
  	}
  	
  	function forceZoom16Now(gMap) {
  	  try { if (gMap && typeof gMap.setZoom === "function") gMap.setZoom(16); } catch (_) {}
  	}
  	
  	function forceZoom16AfterEdit(gMap) {
  	  // This beats “something else” resetting the zoom.
  	  try {
  	    if (!gMap) return false;
  	
  	    // Attempt 1: immediate
  	    forceZoom16Now(gMap);
  	
  	    // Attempt 2: short delay (beats fitBounds / idle handlers)
  	    setTimeout(function () { forceZoom16Now(gMap); }, 60);
  	
  	    // Attempt 3: after idle (last word)
  	    try {
  	      if (google && google.maps && google.maps.event && typeof google.maps.event.addListenerOnce === "function") {
  	        google.maps.event.addListenerOnce(gMap, "idle", function () {
  	          forceZoom16Now(gMap);
  	        });
  	      }
  	    } catch (_) {}
  	
  	    return true;
  	  } catch (_) {
  	    return false;
  	  }
  	}
  	
  	function centerAndZoomOnEdit(runtime, polygon, marker, payloadMap) {
  	  // The ONE place we ensure your requirement:
  	  // "when it goes into edit mode ... set map ... to 16"
  	  try {
  	    var gMap = getBestMap(runtime, polygon, marker, payloadMap);
  	    if (!gMap) return false;
  	
  	    var center = getPolygonBoundsCenter(polygon);
  	    if (center) {
  	      try {
  	        if (typeof gMap.panTo === "function") gMap.panTo(center);
  	        else if (typeof gMap.setCenter === "function") gMap.setCenter(center);
  	      } catch (_) {
  	        try { if (typeof gMap.setCenter === "function") gMap.setCenter(center); } catch (_) {}
  	      }
  	    }
  	
  	    return forceZoom16AfterEdit(gMap);
  	  } catch (_) {
  	    return false;
  	  }
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 5: ENSURE / UPDATE STORE DESCRIPTOR (PURE JSON)
  	// ------------------------------------------------------------------------
  	function ensureStoreDescriptor(loc, geometryMeta) {
  	  var id = getLocId(loc);
  	  if (!id) return null;
  	
  	  var desc = STORE.byId[id] || {};
  	
  	  desc.id        = id;
  	  desc.Name      = (loc && loc.Name)  || desc.Name  || "";
  	  desc.Type      = (loc && loc.Type)  || desc.Type  || "";
  	  desc.Color     = (loc && loc.Color) || desc.Color || "";
  	  desc.CompanyId = (loc && loc.Company && loc.Company.objectId) || desc.CompanyId || "";
  	
  	  desc.GeometryMeta = geometryMeta || desc.GeometryMeta || { type: "Polygon" };
  	
  	  if (loc && loc.Polygon)        desc.Polygon       = loc.Polygon;
  	  if (loc && loc.EntrancePoint)  desc.EntrancePoint = loc.EntrancePoint;
  	
  	  STORE.byId[id] = desc;
  	  return desc;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 6: GLOBAL EDIT LOCK + SLAVE MODE (v3.4 POLICY)
  	// ------------------------------------------------------------------------
  	function isLocked() {
  	  return !!(RUNTIME.editLock && RUNTIME.editLock.mode === "editing" && RUNTIME.editLock.owner);
  	}
  	
  	function snapshotRuntimeOptions(id, runtime) {
  	  if (!id || !runtime) return;
  	  if (!RUNTIME.slaveSnapshot) RUNTIME.slaveSnapshot = createSafeMap();
  	  if (RUNTIME.slaveSnapshot.has(id)) return;
  	
  	  var snap = { poly: null, marker: null };
  	
  	  if (runtime.polygon) {
  	    snap.poly = {
  	      clickable: (typeof runtime.polygon.getClickable === "function") ? runtime.polygon.getClickable() : true,
  	      editable:  (typeof runtime.polygon.getEditable  === "function") ? runtime.polygon.getEditable()  : false,
  	      draggable: (typeof runtime.polygon.getDraggable === "function") ? runtime.polygon.getDraggable() : false,
  	      zIndex:    (typeof runtime.polygon.get === "function") ? runtime.polygon.get("zIndex") : null,
  	      fillOpacity:   (typeof runtime.polygon.get === "function") ? runtime.polygon.get("fillOpacity") : null,
  	      strokeOpacity: (typeof runtime.polygon.get === "function") ? runtime.polygon.get("strokeOpacity") : null,
  	      strokeWeight:  (typeof runtime.polygon.get === "function") ? runtime.polygon.get("strokeWeight") : null
  	    };
  	  }
  	
  	  if (runtime.marker) {
  	    snap.marker = {
  	      clickable: (typeof runtime.marker.getClickable === "function") ? runtime.marker.getClickable() : true,
  	      draggable: (typeof runtime.marker.getDraggable === "function") ? runtime.marker.getDraggable() : false,
  	      zIndex:    (typeof runtime.marker.get === "function") ? runtime.marker.get("zIndex") : null
  	    };
  	  }
  	
  	  RUNTIME.slaveSnapshot.set(id, snap);
  	}
  	
  	function restoreSlaveMode() {
  	  if (!RUNTIME.slaveSnapshot) return;
  	
  	  RUNTIME.byId.forEach(function (runtime, id) {
  	    var snap = RUNTIME.slaveSnapshot.get(id);
  	    if (!runtime || !snap) return;
  	
  	    if (runtime.polygon && snap.poly) {
  	      try {
  	        runtime.polygon.setOptions({
  	          clickable: !!snap.poly.clickable,
  	          editable: !!snap.poly.editable,
  	          draggable: !!snap.poly.draggable,
  	          fillOpacity: (snap.poly.fillOpacity === null || snap.poly.fillOpacity === undefined) ? 0.30 : snap.poly.fillOpacity,
  	          strokeOpacity: (snap.poly.strokeOpacity === null || snap.poly.strokeOpacity === undefined) ? 1 : snap.poly.strokeOpacity,
  	          strokeWeight: (snap.poly.strokeWeight === null || snap.poly.strokeWeight === undefined) ? 2 : snap.poly.strokeWeight,
  	          zIndex: (snap.poly.zIndex === null || snap.poly.zIndex === undefined) ? 99999999 : snap.poly.zIndex
  	        });
  	      } catch (_) {}
  	    }
  	
  	    if (runtime.marker && snap.marker) {
  	      try {
  	        runtime.marker.setOptions({
  	          clickable: !!snap.marker.clickable,
  	          draggable: !!snap.marker.draggable,
  	          zIndex: (snap.marker.zIndex === null || snap.marker.zIndex === undefined) ? 99999999 : snap.marker.zIndex
  	        });
  	      } catch (_) {}
  	    }
  	  });
  	
  	  try { RUNTIME.slaveSnapshot.clear(); } catch (_) {}
  	}
  	
  	function applyEditModePolicy() {
  	  // v3.4: In edit mode, NOTHING is selectable; click-through must be allowed.
  	  // Visual: outline-only.
  	  RUNTIME.byId.forEach(function (runtime, id) {
  	    if (!runtime || !id) return;
  	    snapshotRuntimeOptions(id, runtime);
  	
  	    if (runtime.polygon) {
  	      try {
  	        runtime.polygon.setOptions({
  	          clickable: false,
  	          editable: false,
  	          draggable: false,
  	          fillOpacity: 0,
  	          strokeOpacity: 1,
  	          strokeWeight: 2,
  	          zIndex: 1
  	        });
  	      } catch (_) {}
  	    }
  	
  	    if (runtime.marker) {
  	      try {
  	        runtime.marker.setOptions({
  	          clickable: false,
  	          draggable: false,
  	          zIndex: 1
  	        });
  	      } catch (_) {}
  	    }
  	  });
  	}
  	
  	function beginEditSession(activeId, owner, opts) {
  	  // opts may carry:
  	  //   { polygon, marker, map } (to satisfy "Map passed in" requirement)
  	  owner = owner || "REGISTRY";
  	  opts = opts || {};
  	
  	  // if someone else owns lock, refuse
  	  if (RUNTIME.editLock && RUNTIME.editLock.owner && RUNTIME.editLock.owner !== owner) return false;
  	
  	  RUNTIME.editLock = { owner: owner, activeId: activeId || null, mode: "editing" };
  	  RUNTIME.activeId = activeId || null;
  	
  	  // Enforce policy immediately
  	  applyEditModePolicy();
  	
  	  // NEW: Zoom-to-16 MUST happen when entering edit mode
  	  try {
  	    var rt = (activeId && RUNTIME.byId && RUNTIME.byId.get) ? (RUNTIME.byId.get(activeId) || null) : null;
  	    centerAndZoomOnEdit(rt, opts.polygon || (rt && rt.polygon) || null, opts.marker || (rt && rt.marker) || null, opts.map || null);
  	  } catch (_) {}
  	
  	  dispatchEventSafe("location:edit:begin", { activeId: activeId || null, owner: owner });
  	  return true;
  	}
  	
  	function endEditSession(owner) {
  	  owner = owner || (RUNTIME.editLock ? RUNTIME.editLock.owner : null);
  	
  	  // only owner can release
  	  if (RUNTIME.editLock && RUNTIME.editLock.owner && owner && RUNTIME.editLock.owner !== owner) return false;
  	
  	  restoreSlaveMode();
  	
  	  var prev = RUNTIME.editLock || { owner: null, activeId: null };
  	  RUNTIME.editLock = { owner: null, activeId: null, mode: "idle" };
  	  RUNTIME.activeId = null;
  	
  	  dispatchEventSafe("location:edit:end", { activeId: prev.activeId || null, owner: prev.owner || null });
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 6.6: EXPLICIT CLICK-THROUGH MODE (OPTIONAL API)
  	// ------------------------------------------------------------------------
  	function beginMapClickThrough(owner) {
  	  owner = owner || "WIZARD";
  	
  	  if (!RUNTIME.clickThrough) RUNTIME.clickThrough = { owner: null, mode: "off" };
  	
  	  if (RUNTIME.clickThrough.owner && RUNTIME.clickThrough.owner !== owner) return false;
  	
  	  RUNTIME.clickThrough = { owner: owner, mode: "on" };
  	
  	  RUNTIME.byId.forEach(function (runtime, id) {
  	    if (!runtime || !id) return;
  	    snapshotRuntimeOptions(id, runtime);
  	
  	    if (runtime.polygon) {
  	      try {
  	        runtime.polygon.setOptions({
  	          clickable: false,
  	          editable: false,
  	          draggable: false,
  	          fillOpacity: 0,
  	          strokeOpacity: 1
  	        });
  	      } catch (_) {}
  	    }
  	
  	    if (runtime.marker) {
  	      try {
  	        runtime.marker.setOptions({
  	          clickable: false,
  	          draggable: false
  	        });
  	      } catch (_) {}
  	    }
  	  });
  	
  	  dispatchEventSafe("location:clickthrough:begin", { owner: owner });
  	  return true;
  	}
  	
  	function endMapClickThrough(owner) {
  	  owner = owner || (RUNTIME.clickThrough ? RUNTIME.clickThrough.owner : null);
  	
  	  if (!RUNTIME.clickThrough) RUNTIME.clickThrough = { owner: null, mode: "off" };
  	
  	  if (RUNTIME.clickThrough.owner && owner && RUNTIME.clickThrough.owner !== owner) return false;
  	
  	  restoreSlaveMode();
  	
  	  RUNTIME.clickThrough = { owner: null, mode: "off" };
  	  dispatchEventSafe("location:clickthrough:end", { owner: owner });
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 7: UI DELEGATION (NO UI LOGIC HERE)
  	// ------------------------------------------------------------------------
  	function openEditPanel(loc, polygon, marker) {
  	  var ui = window.LocationRegistryUI;
  	
  	  if (ui && typeof ui.openEditPanel === "function") {
  	    try {
  	      ui.openEditPanel({
  	        loc: loc,
  	        polygon: polygon,
  	        marker: marker || null,
  	        registryApi: window.LocationRegistry
  	      });
  	      return;
  	    } catch (_) {}
  	  }
  	
  	  // Minimal fallback
  	  try {
  	    if (typeof ___arguments !== "undefined" && ___arguments && ___arguments.context && ___arguments.context.setComponentDataStoreByUid) {
  	      ___arguments.context.setComponentDataStoreByUid(
  	        "12b83f221428faab7998dcb80dd3337b",
  	        {
  	          Location: loc,
  	          Polygon: polygon,
  	          EntranceMarker: marker || null,
  	          AppData: AppDataSafe,
  	          Registry: window.LocationRegistry
  	        }
  	      );
  	    }
  	
  	    if (PanelSafe) PanelSafe.display = true;
  	  } catch (_) {}
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 8: CANONICAL LISTENER ATTACHMENT (ONLY PLACE)
  	// ------------------------------------------------------------------------
  	function attachCanonicalListeners(loc, polygon, marker) {
  	  var handles = [];
  	  var id = getLocId(loc);
  	
  	  handles.push(
  	    polygon.addListener("mouseover", function () {
  	      if (isLocked()) return;
  	      if (polygon.getEditable && polygon.getEditable()) return;
  	      try { polygon.setOptions({ fillOpacity: 0.45 }); } catch (_) {}
  	    })
  	  );
  	
  	  handles.push(
  	    polygon.addListener("mouseout", function () {
  	      if (isLocked()) return;
  	      if (polygon.getEditable && polygon.getEditable()) return;
  	      try { polygon.setOptions({ fillOpacity: 0.3 }); } catch (_) {}
  	    })
  	  );
  	
  	  // Polygon click => edit (and edit begin enforces zoom 16)
  	  handles.push(
  	    polygon.addListener("click", function () {
  	      var clickId = getLocId(loc);
  	      if (!clickId) return;
  	
  	      // v3.4 RULE: In edit mode, ALL polygons NOT selectable
  	      if (isLocked()) return;
  	
  	      if (RUNTIME.activeId && RUNTIME.activeId !== clickId) {
  	        exitEdit("REGISTRY_CLICK");
  	      }
  	
  	      // Enter edit mode (THIS is where zoom happens now)
  	      beginEditSession(clickId, "REGISTRY_CLICK", { polygon: polygon, marker: marker, map: null });
  	
  	      openEditPanel(loc, polygon, marker);
  	
  	      dispatchEventSafe("location:clicked", { id: clickId, loc: loc });
  	    })
  	  );
  	
  	  // Marker click mirrors polygon click
  	  if (marker && marker.addListener) {
  	    handles.push(
  	      marker.addListener("click", function () {
  	        var clickId = getLocId(loc);
  	        if (!clickId) return;
  	
  	        if (isLocked()) return;
  	
  	        if (RUNTIME.activeId && RUNTIME.activeId !== clickId) {
  	          exitEdit("REGISTRY_CLICK");
  	        }
  	
  	        beginEditSession(clickId, "REGISTRY_CLICK", { polygon: polygon, marker: marker, map: null });
  	
  	        openEditPanel(loc, polygon, marker);
  	
  	        dispatchEventSafe("location:clicked", { id: clickId, loc: loc });
  	      })
  	    );
  	  }
  	
  	  return handles;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 9: PUBLIC API — REGISTER (v3.1 contract)
  	// ------------------------------------------------------------------------
  	function register(payload) {
  	  var loc     = (payload && (payload.location || payload.loc)) || null;
  	  var polygon = (payload && payload.polygon) || null;
  	  var marker  = (payload && (payload.marker || payload.entranceMarker)) || null;
  	  var geometryMeta = (payload && (payload.geometryMeta || payload.geometry)) || null;
  	
  	  // NEW: allow register(payload).map to explicitly pass the map in
  	  var payloadMap = (payload && payload.map) ? payload.map : null;
  	
  	  var id = getLocId(loc);
  	  if (!id || !polygon) return false;
  	
  	  if (RUNTIME.byId.has(id)) {
  	    unregister(id, { keepStore: true });
  	  }
  	
  	  ensureStoreDescriptor(loc, geometryMeta || { type: "Polygon" });
  	
  	  var listeners = attachCanonicalListeners(loc, polygon, marker);
  	
  	  // Pin best-known map for this runtime (helps in edit begin)
  	  var gMapRef = null;
  	  try {
  	    gMapRef = getBestMap(null, polygon, marker, payloadMap);
  	  } catch (_) {}
  	
  	  RUNTIME.byId.set(id, {
  	    id: id,
  	    location: loc,
  	    polygon: polygon,
  	    marker: marker || null,
  	    listeners: listeners,
  	    geometryMeta: geometryMeta || { type: "Polygon" },
  	    createdAt: Date.now(),
  	
  	    // pinned map for this runtime
  	    gMap: gMapRef
  	  });
  	
  	  // v3.4: If locked OR clickThrough, enforce policy immediately for newly registered entries
  	  if (isLocked()) {
  	    applyEditModePolicy();
  	  } else if (RUNTIME.clickThrough && RUNTIME.clickThrough.mode === "on") {
  	    beginMapClickThrough(RUNTIME.clickThrough.owner || "WIZARD");
  	  }
  	
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 10: PUBLIC API — UNREGISTER
  	// ------------------------------------------------------------------------
  	function unregister(id, opts) {
  	  opts = opts || {};
  	  var keepStore = !!opts.keepStore;
  	
  	  var runtime = RUNTIME.byId.get(id);
  	  if (runtime) {
  	    removeAllListeners(runtime);
  	    removeMapObjects(runtime);
  	    RUNTIME.byId.delete(id);
  	  }
  	
  	  if (RUNTIME.activeId === id) {
  	    exitEdit("REGISTRY_INTERNAL");
  	  }
  	
  	  if (!keepStore) {
  	    try { delete STORE.byId[id]; } catch (_) {}
  	  }
  	
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 11: EXIT EDIT MODE
  	// ------------------------------------------------------------------------
  	function exitEdit(owner) {
  	  var id = RUNTIME.activeId;
  	  if (id) {
  	    var runtime = RUNTIME.byId.get(id);
  	    if (runtime && runtime.polygon) {
  	      try { runtime.polygon.setEditable(false); } catch (_) {}
  	    }
  	  }
  	
  	  if (PanelSafe) PanelSafe.display = false;
  	
  	  endEditSession();
  	
  	  RUNTIME.activeId = null;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 12: DELETE EVERYWHERE (SERVER OPTIONAL)
  	// ------------------------------------------------------------------------
  	async function deleteEverywhere(locationId) {
  	  if (!locationId) return false;
  	
  	  if (BackendlessSafe && BackendlessSafe.Data && BackendlessSafe.Data.of) {
  	    try { await BackendlessSafe.Data.of("Locations").remove({ objectId: locationId }); } catch (_) {}
  	  }
  	
  	  if (AppDataSafe && AppDataSafe.User && AppDataSafe.User.Companies) {
  	    AppDataSafe.User.Companies.forEach(function (co) {
  	      if (!Array.isArray(co.Locations)) return;
  	      co.Locations = co.Locations.filter(function (l) { return l && l.objectId !== locationId; });
  	    });
  	  }
  	
  	  if (Array.isArray(LocationsSafe)) {
  	    var idx = LocationsSafe.findIndex(function (l) { return l && l.objectId === locationId; });
  	    if (idx >= 0) LocationsSafe.splice(idx, 1);
  	  }
  	
  	  unregister(locationId, { keepStore: false });
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 13: HYDRATE STORE (NO MAP REQUIRED)
  	// ------------------------------------------------------------------------
  	function hydrateFromLocations(locs) {
  	  if (!Array.isArray(locs)) return 0;
  	
  	  locs.forEach(function (loc) {
  	    ensureStoreDescriptor(loc, (loc && loc.GeometryMeta) || { type: "Polygon" });
  	  });
  	
  	  return locs.length;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 14: PUBLIC API (GLOBAL) — v3.4 + MAP PASS-IN SUPPORT
  	// ------------------------------------------------------------------------
  	window.LocationRegistry = {
  	  version: "v3.4",
  	
  	  // v3.1 contract
  	  register: register,
  	  unregister: unregister,
  	  exitEdit: exitEdit,
  	  deleteEverywhere: deleteEverywhere,
  	
  	  getRuntime: function (id) { return RUNTIME.byId.get(id) || null; },
  	  hasRuntime: function (id) { return RUNTIME.byId.has(id); },
  	  allRuntime: function () { return (RUNTIME.byId && typeof RUNTIME.byId.values === "function") ? RUNTIME.byId.values() : []; },
  	
  	  getStore: function (id) { return STORE.byId[id] || null; },
  	  allStore: function () { return STORE.byId; },
  	
  	  hydrateFromLocations: hydrateFromLocations,
  	
  	  // lock + policy (edit mode)
  	  beginEditSession: beginEditSession,
  	  endEditSession: endEditSession,
  	  isLocked: isLocked,
  	  getLock: function () { return RUNTIME.editLock || { owner: null, activeId: null, mode: "idle" }; },
  	
  	  // explicit click-through
  	  beginMapClickThrough: beginMapClickThrough,
  	  endMapClickThrough: endMapClickThrough,
  	  getClickThrough: function () { return RUNTIME.clickThrough || { owner: null, mode: "off" }; },
  	
  	  // NEW: explicitly pass the map into the registry (YOUR REQUIREMENT)
  	  // Usage: window.LocationRegistry.setMapRef(Map)  (wrapper or real map)
  	  setMapRef: function (mapObj) {
  	    try {
  	      RUNTIME.gMapRef = mapObj || null;
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  },
  	
  	  // NEW: force zoom now (debug / manual)
  	  forceZoom16: function () {
  	    try {
  	      var m = getBestMap(null, null, null, null);
  	      if (!m) return false;
  	      forceZoom16AfterEdit(m);
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  }
  	};
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 15: BOOTSTRAP (SAFE, HEADLESS)
  	// ------------------------------------------------------------------------
  	try {
  	  if (Array.isArray(LocationsSafe)) {
  	    hydrateFromLocations(LocationsSafe);
  	  }
  	} catch (_) {}

  })(AppData, (await Locations2()));
  await (async function(Locations, AppData, Panel, PanelBlock, Map) {
  	// ========================================================================
  	// MODULE: Simple Wizard v4.1 (Complete Rewrite + Uniform Hard Delete Location)
  	// (Registry-Driven Depict + Authoritative AppData Rehydrate + True Hard Refresh + Prune + Timing-Safe UI Pump + Optional List Sync)
  	// MAP-SAFE: DOES NOT USE new Map() OR new Set()
  	//
  	// PURPOSE:
  	//   - Depict (render) Locations polygons on the Google Map reliably
  	//   - Register polygons into LocationRegistry (registry owns listeners/state)
  	//   - Never attach polygon listeners here
  	//   - TRUE HARD REFRESH after save:
  	//       * Rehydrates a FRESH locations list from AppData (authoritative)
  	//       * Prunes deleted locations
  	//       * Clears wizard-owned polygons so new ones can render
  	//       * Never gets stuck on the initial provided Locations array
  	//   - Supports BOTH polygon formats:
  	//       A) loc.Polygon.boundary.points[{x,y}]   (x=lng, y=lat)
  	//       B) GeoJSON { type:"Polygon", coordinates:[[lng,lat]...] }
  	//   - TIMING-SAFE UI PUMP:
  	//       window.LocationRegistryUI.openEditPanel(payload) will:
  	//         * open the panel FIRST
  	//         * wait until panel is detectably open (poll w/ fail-safe)
  	//         * inject hub datastore (latest click wins)
  	//   - OPTIONAL LIST SYNC:
  	//       window.LocationRegistryUI.refreshList() can hydrate a Dynamic List by UID
  	//   - UNIFORM HARD DELETE LOCATION (NEW):
  	//       * Field-wizard style prompt (type DELETE)
  	//       * DB -> AppData -> global Locations -> Registry -> Map -> Repeater/Panel
  	//
  	// AUTHOR : Raymond + Rog
  	// ========================================================================


  	// ------------------------------------------------------------------------
  	// STEP 0: SAFE GLOBAL RESOLUTION (Golden Standard)
  	// ------------------------------------------------------------------------
  	var BackendlessSafe = (typeof Backendless !== "undefined" ? Backendless: null);
  	var AppDataSafe = (typeof AppData !== "undefined" ? AppData: null);
  	var PanelSafe = (typeof Panel !== "undefined" ? Panel: null);
  	var PanelBlockSafe = (typeof PanelBlock !== "undefined" ? PanelBlock: null);
  	var MapSafe = (typeof Map !== "undefined" ? Map: null);

  	var RegistrySafe = (typeof window.LocationRegistry !== "undefined" ? window.LocationRegistry: null);

  	// Backendless context (often present in custom code blocks)
  	var ContextSafe =
  	(typeof ___arguments !== "undefined" && ___arguments && ___arguments.context)
  	? ___arguments.context: null;


  	// ------------------------------------------------------------------------
  	// STEP 1: CONFIG
  	// ------------------------------------------------------------------------
  	var SIMPLE_WIZARD_CFG = {
  	  version: "v4.1-authoritative-appdata-hard-refresh+uniform-hard-delete-location",

  	  // Map readiness
  	  mapReadyTimeoutMs: 3500,

  	  // Fit bounds behavior
  	  doFitBoundsOnRender: true,
  	  maxZoomAfterFit: 18,

  	  // Rendering defaults
  	  defaultColor: "#00BCD4",
  	  strokeWeight: 2,
  	  strokeOpacity: 0.9,
  	  fillOpacity: 0.3,

  	  // Layering base zIndex
  	  zIndexBase: 99900000,

  	  // HUB / PANEL PUMP SETTINGS
  	  hubDataStoreUid: "12b83f221428faab7998dcb80dd3337b",

  	  // OPTIONAL: DynamicList UID to keep in sync (set null to disable)
  	  locationsListComponentUid: "c19f60f9470e0b5c1255ba7824783adf",

  	  // PANEL TIMING / RETRY
  	  panelDetectMaxAttempts: 30,
  	  // 30 * 40ms = 1200ms
  	  panelDetectDelayMs: 40,
  	  panelFailSafeInject: true,

  	  // Diagnostics
  	  logPrefix: "[SimpleWizard v4.1]",
  	  verbose: true,
  	  traceClicks: true
  	};


  	// ------------------------------------------------------------------------
  	// STEP 2: LOGGING + UTILS
  	// ------------------------------------------------------------------------
  	function log() {
  	  if (!SIMPLE_WIZARD_CFG.verbose) return;
  	  try {
  	    console.log.apply(console, arguments);
  	  } catch (_) {}
  	}
  	function warn() {
  	  try {
  	    console.warn.apply(console, arguments);
  	  } catch (_) {}
  	}
  	function isFn(fn) {
  	  return typeof fn === "function";
  	}

  	function dictHas(dict, key) {
  	  return !!(dict && key && Object.prototype.hasOwnProperty.call(dict, key));
  	}
  	function dictGet(dict, key) {
  	  return dictHas(dict, key) ? dict[key]: null;
  	}
  	function dictSet(dict, key, val) {
  	  if (!dict || !key) return;
  	  dict[key] = val;
  	}
  	function dictKeys(dict) {
  	  try {
  	    return Object.keys(dict || {});
  	  } catch (_) {
  	    return [];
  	  }
  	}

  	function getLocNameKey(loc) {
  	  try {
  	    var n = (loc && (loc.Name || loc.name)) ? String(loc.Name || loc.name): "";
  	    return n.trim().toLowerCase();
  	  } catch (_) {
  	    return "";
  	  }
  	}

  	function sortLocationsByNameAlpha(list) {
  	  if (!Array.isArray(list)) return [];

  	  // Copy so we never mutate upstream AppData arrays unexpectedly
  	  var out = list.slice(0);

  	  out.sort(function (a, b) {
  	    var an = getLocNameKey(a);
  	    var bn = getLocNameKey(b);

  	    if (an < bn) return -1;
  	    if (an > bn) return 1;

  	    // Tie-breaker: objectId (keeps order deterministic)
  	    var aid = getLocId(a) ? String(getLocId(a)): "";
  	    var bid = getLocId(b) ? String(getLocId(b)): "";

  	    if (aid < bid) return -1;
  	    if (aid > bid) return 1;

  	    return 0;
  	  });

  	  return out;
  	}

  	// ------------------------------------------------------------
  	// PATCH: EXCLUDE CHILD LOCATIONS FROM LIST (ParentId != null)
  	// ------------------------------------------------------------
  	function isNullishOrEmpty(v) {
  	  return (v === null || v === undefined || String(v).trim() === "");
  	}

  	function isTopLevelLocation(loc) {
  	  try {
  	    // Support both ParentId and parentId defensively
  	    var pid =
  	    (loc && (loc.ParentId !== undefined)) ? loc.ParentId:
  	    (loc && (loc.parentId !== undefined)) ? loc.parentId:
  	    null;

  	    // Only include top-level (no parent)
  	    return isNullishOrEmpty(pid);
  	  } catch (_) {
  	    return true;
  	  }
  	}

  	function filterTopLevelLocations(list) {
  	  if (!Array.isArray(list)) return [];
  	  return list.filter(function (loc) {
  	    return !!loc && isTopLevelLocation(loc);
  	  });
  	}

  	function getLocId(loc) {
  	  return (loc && (loc.objectId || loc.ObjectId || loc.id)) || null;
  	}


  	function _getProp(obj, path) {
  	  try {
  	    if (!obj || !path || typeof path !== "string") return undefined;
  	    if (obj[path] !== undefined) return obj[path];

  	    var parts = path.split(".");
  	    var cur = obj;
  	    for (var i = 0; i < parts.length; i++) {
  	      if (!cur) return undefined;
  	      var key = parts[i];
  	      if (cur[key] === undefined) return undefined;
  	      cur = cur[key];
  	    }
  	    return cur;
  	  } catch (_) {
  	    return undefined;
  	  }
  	}

  	function resolveAppDataAuthoritative() {
  	  // Priority: ContextSafe.appData (most current) -> AppDataSafe -> window.AppData
  	  try {
  	    if (ContextSafe && ContextSafe.appData) return ContextSafe.appData;
  	  } catch (_) {}
  	  if (AppDataSafe) return AppDataSafe;

  	  try {
  	    var wAD = (typeof window !== "undefined" && typeof window.AppData !== "undefined") ? window.AppData: null;
  	    return wAD || null;
  	  } catch (_) {
  	    return null;
  	  }
  	}

  	function _flattenLocationsFromAppData(appData) {
  	  // Returns a deduped list of locations from AppData.User.Companies[].Locations
  	  var out = [];
  	  var seen = Object.create(null);

  	  try {
  	    var companies = _getProp(appData, "User.Companies");
  	    if (!Array.isArray(companies)) return out;

  	    for (var j = 0; j < companies.length; j++) {
  	      var comp = companies[j];
  	      var locs = _getProp(comp, "Locations");
  	      if (!Array.isArray(locs)) continue;

  	      for (var k = 0; k < locs.length; k++) {
  	        var loc = locs[k];
  	        if (!loc) continue;

  	        var id = (loc.objectId != null) ? String(loc.objectId): "";
  	        if (!id) continue;
  	        if (seen[id]) continue;

  	        seen[id] = true;
  	        out.push(loc);
  	      }
  	    }
  	  } catch (_) {}

  	  return out;
  	}

  	function getLocationsFallbackGlobal() {
  	  // Fallback ONLY (non-authoritative): global Locations
  	  try {
  	    var _Locations = (typeof Locations !== "undefined" ? Locations: null);
  	    return Array.isArray(_Locations) ? _Locations: [];
  	  } catch (_) {
  	    return [];
  	  }
  	}


  	// ------------------------------------------------------------------------
  	// STEP 3: HARD PRECONDITIONS
  	// ------------------------------------------------------------------------
  	if (!RegistrySafe || !isFn(RegistrySafe.register) || !isFn(RegistrySafe.unregister)) {
  	  warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ LocationRegistry missing or incomplete. Aborting.");
  	  return;
  	}


  	// ------------------------------------------------------------------------
  	// STEP 4: MAP RESOLUTION (MATCH WORKING CONTRACT)
  	// ------------------------------------------------------------------------
  	function resolveGMap(MapMaybe) {
  	  var g =
  	  (MapMaybe && MapMaybe.map && MapMaybe.map.map) ||
  	  (MapMaybe && MapMaybe.map) ||
  	  MapMaybe ||
  	  null;

  	  return g || null;
  	}

  	var gMap = resolveGMap(MapSafe);

  	if (!gMap) {
  	  warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ Map not resolved. Aborting.");
  	  return;
  	}


  	// ------------------------------------------------------------------------
  	// STEP 5: UI PUMP OWNER (LocationRegistryUI) + OPTIONAL LIST SYNC
  	// ------------------------------------------------------------------------
  	if (!window.__LocationHubUIState_v41) {
  	  window.__LocationHubUIState_v41 = {
  	    lastLocationId: null,
  	    lastPumpAt: 0,
  	    pumpCount: 0,

  	    // Latest-wins queue
  	    pendingPayload: null,
  	    injectLoopActive: false,
  	    injectAttempt: 0
  	  };
  	}
  	var HUBSTATE = window.__LocationHubUIState_v41;

  	function forceOpenPanel() {
  	  if (!PanelSafe) return;

  	  try {
  	    if (typeof PanelSafe.show === "function") {
  	      PanelSafe.show(); return;
  	    }
  	    if (typeof PanelSafe.open === "function") {
  	      PanelSafe.open(); return;
  	    }
  	    if (typeof PanelSafe.setVisible === "function") {
  	      PanelSafe.setVisible(true); return;
  	    }
  	    if ("visible" in PanelSafe) {
  	      PanelSafe.visible = true; return;
  	    }
  	    if ("display" in PanelSafe) {
  	      PanelSafe.display = true; return;
  	    }
  	  } catch (_) {}
  	}

  	function isPanelOpenDetected() {
  	  try {
  	    if (!PanelSafe) return false;

  	    if (typeof PanelSafe.isVisible === "function") return !!PanelSafe.isVisible();
  	    if (typeof PanelSafe.isOpen === "function") return !!PanelSafe.isOpen();

  	    if ("display" in PanelSafe) return !!PanelSafe.display;
  	    if ("visible" in PanelSafe) return !!PanelSafe.visible;

  	    return false;
  	  } catch (_) {
  	    return false;
  	  }
  	}

  	function pushHubDatastore(payload) {
  	  try {
  	    if (!ContextSafe || typeof ContextSafe.setComponentDataStoreByUid !== "function") {
  	      return false;
  	    }

  	    var loc = payload.loc || null;

  	    // ✅ Normalize Area keys so Rings + Fields use the same schema
  	    var area = _normalizeAreaOnLocation(loc);

  	    ContextSafe.setComponentDataStoreByUid(
  	      SIMPLE_WIZARD_CFG.hubDataStoreUid,
  	      {
  	        Location: loc,
  	        Polygon: payload.polygon || null,
  	        EntranceMarker: payload.marker || null,
  	        AppData: resolveAppDataAuthoritative(),
  	        Registry: payload.registryApi || window.LocationRegistry || null,

  	        // Optional convenience fields for UI bindings
  	        AreaHa: area.ha,
  	        AreaM2: area.m2,
  	        AreaAcres: area.acres
  	      }
  	    );

  	    return true;
  	  } catch (e) {
  	    warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Hub datastore push failed:", e);
  	    return false;
  	  }
  	}

  	function _toNum(v) {
  	  if (v === null || v === undefined) return null;
  	  var n = (typeof v === "string") ? Number(v) : v;
  	  return (typeof n === "number" && !isNaN(n)) ? n : null;
  	}

  	function _getAreaObj(loc) {
  	  try {
  	    return (loc && loc.LocationData && loc.LocationData.Area) ? loc.LocationData.Area : null;
  	  } catch (_) {
  	    return null;
  	  }
  	}

  	function _normalizeAreaOnLocation(loc) {
  	  try {
  	    if (!loc) return { ha: null, m2: null, acres: null };

  	    var A = _getAreaObj(loc);
  	    if (!A) return { ha: null, m2: null, acres: null };

  	    // Accept multiple possible keys (Ring currently uses Hectares/Acres/m2)
  	    var ha =
  	      _toNum(A.ha) !== null ? _toNum(A.ha) :
  	      _toNum(A.Hectares) !== null ? _toNum(A.Hectares) :
  	      _toNum(A.hectares);

  	    var m2 =
  	      _toNum(A.m2) !== null ? _toNum(A.m2) :
  	      _toNum(A.M2);

  	    var acres =
  	      _toNum(A.acres) !== null ? _toNum(A.acres) :
  	      _toNum(A.Acres);

  	    // 🔧 Normalize for UI bindings (do not break existing)
  	    if (ha !== null && A.ha === undefined) A.ha = ha;
  	    if (ha !== null && A.Hectares === undefined) A.Hectares = ha;

  	    if (m2 !== null && A.m2 === undefined) A.m2 = m2;
  	    if (acres !== null && A.acres === undefined) A.acres = acres;

  	    // Optional: simple top-level access for dumb bindings
  	    if (ha !== null && loc.AreaHa === undefined) loc.AreaHa = ha;

  	    return { ha: ha, m2: m2, acres: acres };
  	  } catch (_) {
  	    return { ha: null, m2: null, acres: null };
  	  }
  	}


  	function _setDynamicListItemsByUid(componentUid, listItems) {
  	  try {
  	    if (!componentUid) return false;

  	    // Prefer an explicitly provided UI context (best), else fall back to ContextSafe, else ___arguments.context
  	    var ctx =
  	    (window.__SimpleWizardUIContext_v41) ? window.__SimpleWizardUIContext_v41:
  	    (ContextSafe) ? ContextSafe:
  	    ((typeof ___arguments !== "undefined" && ___arguments && ___arguments.context) ? ___arguments.context: null);

  	    if (!ctx || typeof ctx.getComponentByUid !== "function") return false;

  	    var cmp = ctx.getComponentByUid(componentUid);
  	    if (!cmp) return false;

  	    cmp.dynamicListItems = Array.isArray(listItems) ? listItems: [];
  	    return true;
  	  } catch (_) {
  	    return false;
  	  }
  	}

  	function refreshLocationsDynamicListIfEnabled() {
  	  try {
  	    var uid = SIMPLE_WIZARD_CFG.locationsListComponentUid;
  	    if (!uid) return false;

  	    var ad = resolveAppDataAuthoritative();
  	    if (!ad) return false;

  	    var list = _flattenLocationsFromAppData(ad);

  	    // Exclude any Location that has a parent (ParentId not null/empty)
  	    list = filterTopLevelLocations(list);

  	    // Sort alphanumeric by Name (deterministic)
  	    list = sortLocationsByNameAlpha(list);

  	    return _setDynamicListItemsByUid(uid, list);

  	  } catch (_) {
  	    return false;
  	  }
  	}


  	function scheduleInjectLatest() {
  	  if (HUBSTATE.injectLoopActive) return;

  	  HUBSTATE.injectLoopActive = true;
  	  HUBSTATE.injectAttempt = 0;

  	  var maxAttempts = SIMPLE_WIZARD_CFG.panelDetectMaxAttempts;
  	  var delayMs = SIMPLE_WIZARD_CFG.panelDetectDelayMs;

  	  function tick() {
  	    HUBSTATE.injectAttempt++;

  	    var payload = HUBSTATE.pendingPayload || {};
  	    var loc = payload.loc || null;
  	    var id = getLocId(loc);

  	    var open = isPanelOpenDetected();

  	    if (SIMPLE_WIZARD_CFG.traceClicks) {
  	      try {
  	        log(SIMPLE_WIZARD_CFG.logPrefix, "🟧 Inject Wait Tick", {
  	          attempt: HUBSTATE.injectAttempt,
  	          maxAttempts: maxAttempts,
  	          panelOpenDetected: open,
  	          pendingId: id,
  	          pendingName: loc && loc.Name
  	        });
  	      } catch (_) {}
  	    }

  	    if (open) {
  	      var ok = pushHubDatastore(payload);

  	      try {
  	        HUBSTATE.lastPumpAt = Date.now();
  	        HUBSTATE.lastLocationId = id;
  	        HUBSTATE.pumpCount = (HUBSTATE.pumpCount || 0) + 1;
  	      } catch (_) {}

  	      if (SIMPLE_WIZARD_CFG.traceClicks) {
  	        try {
  	          log(SIMPLE_WIZARD_CFG.logPrefix, "🟩 Injected After Open", {
  	            id: id,
  	            name: loc && loc.Name,
  	            pushedDatastore: !!ok,
  	            attempts: HUBSTATE.injectAttempt
  	          });
  	        } catch (_) {}
  	      }

  	      // Optional list sync (safe)
  	      refreshLocationsDynamicListIfEnabled();

  	      HUBSTATE.injectLoopActive = false;
  	      HUBSTATE.injectAttempt = 0;
  	      return;
  	    }

  	    if (HUBSTATE.injectAttempt >= maxAttempts) {
  	      if (SIMPLE_WIZARD_CFG.panelFailSafeInject) {
  	        var ok2 = pushHubDatastore(payload);

  	        try {
  	          HUBSTATE.lastPumpAt = Date.now();
  	          HUBSTATE.lastLocationId = id;
  	          HUBSTATE.pumpCount = (HUBSTATE.pumpCount || 0) + 1;
  	        } catch (_) {}

  	        warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Panel open not detected; fail-safe inject executed.", {
  	          id: id,
  	          name: loc && loc.Name,
  	          pushedDatastore: !!ok2,
  	          attempts: HUBSTATE.injectAttempt
  	        });

  	        refreshLocationsDynamicListIfEnabled();
  	      } else {
  	        warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Panel open not detected; injection aborted (fail-safe disabled).", {
  	          pendingId: id,
  	          pendingName: loc && loc.Name,
  	          attempts: HUBSTATE.injectAttempt
  	        });
  	      }

  	      HUBSTATE.injectLoopActive = false;
  	      HUBSTATE.injectAttempt = 0;
  	      return;
  	    }

  	    setTimeout(tick, delayMs);
  	  }

  	  setTimeout(tick, 0);
  	}

  	// Define/overwrite UI owner cleanly
  	window.LocationRegistryUI = {
  	  openEditPanel: function (payload) {
  	    payload = payload || {};

  	    var loc = payload.loc || null;
  	    var id = getLocId(loc);
  	    var poly = payload.polygon || null;

  	    // Latest wins
  	    HUBSTATE.pendingPayload = payload;

  	    if (SIMPLE_WIZARD_CFG.traceClicks) {
  	      try {
  	        log(SIMPLE_WIZARD_CFG.logPrefix, "🟦 Polygon Click Pump (queued)", {
  	          id: id,
  	          name: loc && loc.Name,
  	          type: loc && loc.Type,
  	          hasPolygonObj: !!poly,
  	          hasContext: !!ContextSafe,
  	          panelOpenDetectedNow: isPanelOpenDetected(),
  	          injectLoopActive: !!HUBSTATE.injectLoopActive
  	        });
  	      } catch (_) {}
  	    }

  	    forceOpenPanel();
  	    scheduleInjectLatest();
  	  },

  	  refreshList: function () {
  	    return refreshLocationsDynamicListIfEnabled();
  	  }
  	};


  	// ------------------------------------------------------------------------
  	// STEP 5.1: GLOBAL TRACE FOR REGISTRY CLICK EVENT (location:clicked)
  	// ------------------------------------------------------------------------
  	if (!window.__SimpleWizardClickTraceAttached_v41) {
  	  window.__SimpleWizardClickTraceAttached_v41 = true;

  	  try {
  	    window.addEventListener("location:clicked", function (ev) {
  	      try {
  	        if (!SIMPLE_WIZARD_CFG.traceClicks) return;
  	        var d = (ev && ev.detail) ? ev.detail: {};

  	        log(SIMPLE_WIZARD_CFG.logPrefix, "🟨 location:clicked event", {
  	          id: d.id,
  	          name: d.loc && d.loc.Name,
  	          type: d.loc && d.loc.Type,
  	          time: Date.now()
  	        });
  	      } catch (_) {}
  	    });
  	  } catch (e) {
  	    warn(SIMPLE_WIZARD_CFG.logPrefix,
  	      "⚠️ Failed to attach location:clicked listener:",
  	      e);
  	  }
  	}


  	// ------------------------------------------------------------------------
  	// STEP 6: RUNTIME STATE (IDEMPOTENT, MAP-SAFE)
  	// ------------------------------------------------------------------------
  	if (!window.__SimpleWizardRuntime_v41) {
  	  window.__SimpleWizardRuntime_v41 = {
  	    version: SIMPLE_WIZARD_CFG.version,

  	    // wizard-owned polygons only (we do NOT assume registry runtime is complete)
  	    polygonsById: {},
  	    // id -> polygon (wizard created)

  	    lastMapRef: null,
  	    renderCount: 0,

  	    // authoritative sources that can be set externally
  	    overrideLocations: null,
  	    // if set, used before AppData
  	    overrideAppData: null,
  	    // if set, used before ContextSafe/AppDataSafe
  	    lastHydratedCount: 0
  	  };
  	}
  	var SWR = window.__SimpleWizardRuntime_v41;


  	// ------------------------------------------------------------------------
  	// STEP 7: GEOMETRY EXTRACTION (BOTH FORMATS)
  	// ------------------------------------------------------------------------
  	function normalizeNumber(n) {
  	  var x = (typeof n === "string") ? Number(n): n;
  	  return (typeof x === "number" && !isNaN(x)) ? x: null;
  	}

  	function ringToLatLngs(ring) {
  	  if (!Array.isArray(ring)) return null;

  	  var pts = [];
  	  for (var i = 0; i < ring.length; i++) {
  	    var c = ring[i];
  	    if (!Array.isArray(c) || c.length < 2) continue;

  	    var lng = normalizeNumber(c[0]);
  	    var lat = normalizeNumber(c[1]);
  	    if (lat === null || lng === null) continue;

  	    pts.push({
  	      lat: lat, lng: lng
  	    });
  	  }

  	  // remove closure point if present
  	  if (pts.length >= 2) {
  	    var a = pts[0];
  	    var b = pts[pts.length - 1];
  	    if (a.lat === b.lat && a.lng === b.lng) pts.pop();
  	  }

  	  return pts.length >= 3 ? pts: null;
  	}

  	// Signed area (shoelace) on lng/lat plane.
  	// > 0 => CCW, < 0 => CW (for x=lng, y=lat)
  	function signedAreaLngLat(pts) {
  	  if (!pts || pts.length < 3) return 0;
  	  var sum = 0;
  	  for (var i = 0; i < pts.length; i++) {
  	    var a = pts[i];
  	    var b = pts[(i + 1) % pts.length];
  	    sum += (a.lng * b.lat) - (b.lng * a.lat);
  	  }
  	  return sum / 2;
  	}

  	function ensureWinding(pts, wantCCW) {
  	  if (!pts || pts.length < 3) return pts;
  	  var area = signedAreaLngLat(pts);
  	  var isCCW = area > 0;
  	  if (wantCCW && !isCCW) return pts.slice(0).reverse();
  	  if (!wantCCW && isCCW) return pts.slice(0).reverse();
  	  return pts;
  	}

  	function nearlyEqual(a, b, eps) {
  	  eps = (typeof eps === "number") ? eps : 1e-10;
  	  return Math.abs(a - b) <= eps;
  	}

  	function pointNearlyEqual(p, q, eps) {
  	  if (!p || !q) return false;
  	  return nearlyEqual(p.lat, q.lat, eps) && nearlyEqual(p.lng, q.lng, eps);
  	}

  	function getCentreLatLngFromLoc(loc) {
  	  try {
  	    // Support loc.Centre GeoJSON: { type:"Point", coordinates:[lng,lat] }
  	    var c = (loc && loc.Centre && Array.isArray(loc.Centre.coordinates)) ? loc.Centre.coordinates : null;
  	    if (!c || c.length < 2) return null;
  	    return { lng: normalizeNumber(c[0]), lat: normalizeNumber(c[1]) };
  	  } catch (_) {
  	    return null;
  	  }
  	}

  	function ringLooksInvalidAsHole(loc, ringPts) {
  	  if (!ringPts || ringPts.length < 3) return true;

  	  // Drop only tiny/degenerate rings
  	  try {
  	    var aSqm = computeAreaSqm(ringPts);
  	    if (aSqm < 1) return true; // 1 m²
  	  } catch (_) {}

  	  return false;
  	}



  	function sanitizePathsForGoogle(loc, paths) {
  	  // paths is [outer, hole1, hole2...]
  	  if (!Array.isArray(paths) || !paths.length) return paths;
  	  if (!Array.isArray(paths[0]) || paths[0].length < 3) return null;

  	  var out = [paths[0]];

  	  if (paths.length === 1) return out;

  	  for (var h = 1; h < paths.length; h++) {
  	    var ring = paths[h];
  	    if (!Array.isArray(ring) || ring.length < 3) continue;
  	    if (ringLooksInvalidAsHole(loc, ring)) continue;
  	    out.push(ring);
  	  }

  	  return out;
  	}


  	function ringsToPaths(rings) {
  	  if (!Array.isArray(rings) || !rings.length) return null;

  	  var out = [];
  	  for (var i = 0; i < rings.length; i++) {
  	    var pts = ringToLatLngs(rings[i]);
  	    if (!pts || pts.length < 3) continue;
  	    out.push(pts);
  	  }

  	  // Must have at least the outer ring
  	  if (!out.length) return null;

  	  // Normalize winding so holes render under default nonzero fill rule:
  	  // outer = CCW, holes = CW
  	  out[0] = ensureWinding(out[0], true);
  	  for (var h = 1; h < out.length; h++) {
  	    out[h] = ensureWinding(out[h], false);
  	  }

  	  return out;
  	}

  	function normalizeGooglePolygonPaths(paths) {
  	  // Google wants:
  	  //  - Single ring: LatLngLiteral[]
  	  //  - With holes: LatLngLiteral[][]
  	  if (!Array.isArray(paths)) return paths;
  	  if (paths.length === 1 && Array.isArray(paths[0])) return paths[0];
  	  return paths;
  	}




  	function boundaryPointsToLatLngs(points) {
  	  if (!Array.isArray(points)) return null;

  	  var pts = [];
  	  for (var i = 0; i < points.length; i++) {
  	    var p = points[i];
  	    if (!p) continue;

  	    // Contract: p.x = lng, p.y = lat
  	    var lng = normalizeNumber(p.x);
  	    var lat = normalizeNumber(p.y);

  	    if (lat === null || lng === null) continue;
  	    pts.push({
  	      lat: lat, lng: lng
  	    });
  	  }

  	  // remove closure point if present
  	  if (pts.length >= 2) {
  	    var a = pts[0];
  	    var b = pts[pts.length - 1];
  	    if (a.lat === b.lat && a.lng === b.lng) pts.pop();
  	  }

  	  return pts.length >= 3 ? pts: null;
  	}

  	function getPolygonPaths(loc) {
  	  var poly = loc && loc.Polygon;
  	  if (!poly) return null;

  	  // -------------------------------------------------
  	  // 1️⃣ GeoJSON support (keep this intact)
  	  // -------------------------------------------------
  	  if (poly.type === "Polygon" && Array.isArray(poly.coordinates)) {
  	    return ringsToPaths(poly.coordinates);
  	  }

  	  // -------------------------------------------------
  	  // 2️⃣ Custom Structure: boundary + holes
  	  // -------------------------------------------------
  	  var boundaryPoints =
  	    (poly.boundary && Array.isArray(poly.boundary.points))
  	      ? poly.boundary.points
  	      : null;

  	  if (!boundaryPoints) return null;

  	  var outer = boundaryPointsToLatLngs(boundaryPoints);
  	  if (!outer || outer.length < 3) return null;

  	  var paths = [outer];

  	  // 🔥 THIS IS THE FIX
  	  if (Array.isArray(poly.holes) && poly.holes.length > 0) {
  	    for (var h = 0; h < poly.holes.length; h++) {
  	      var holeObj = poly.holes[h];
  	      if (!holeObj || !Array.isArray(holeObj.points)) continue;

  	      var hole = boundaryPointsToLatLngs(holeObj.points);
  	      if (hole && hole.length >= 3) {
  	        paths.push(hole);
  	      }
  	    }
  	  }

  	  return paths;
  	}




  	// ------------------------------------------------------------------------
  	// STEP 8: BOUNDS + AREA (FOR LAYERING)
  	// ------------------------------------------------------------------------
  	function safeBounds() {
  	  try {
  	    return new google.maps.LatLngBounds();
  	  } catch (_) {
  	    return null;
  	  }
  	}

  	function extendBounds(bounds, coords) {
  	  if (!bounds || !coords || !coords.length) return;
  	  for (var i = 0; i < coords.length; i++) {
  	    try {
  	      bounds.extend(coords[i]);
  	    } catch (_) {}
  	  }
  	}

  	function boundsIsEmpty(bounds) {
  	  try {
  	    return !bounds || bounds.isEmpty();
  	  } catch (_) {
  	    return true;
  	  }
  	}

  	function mapLooksReady(m) {
  	  try {
  	    if (m && isFn(m.getBounds)) return !!m.getBounds();
  	    return false;
  	  } catch (_) {
  	    return false;
  	  }
  	}

  	function debugMapInfo() {
  	  try {
  	    var c = (gMap && isFn(gMap.getCenter)) ? gMap.getCenter(): null;
  	    var z = (gMap && isFn(gMap.getZoom)) ? gMap.getZoom(): null;
  	    log(SIMPLE_WIZARD_CFG.logPrefix, "🧭 Map center/zoom:", c ? {
  	      lat: c.lat(), lng: c.lng()
  	    }: c, z);
  	  } catch (_) {}
  	}

  	function computeAreaSqm(coords) {
  	  if (!Array.isArray(coords) || coords.length < 3) return 0;

  	  // Prefer geometry library if present
  	  try {
  	    if (google &&
  	      google.maps &&
  	      google.maps.geometry &&
  	      google.maps.geometry.spherical &&
  	      typeof google.maps.geometry.spherical.computeArea === "function") {
  	      var path = [];
  	      for (var i = 0; i < coords.length; i++) {
  	        path.push(new google.maps.LatLng(coords[i].lat, coords[i].lng));
  	      }
  	      var a = google.maps.geometry.spherical.computeArea(path);
  	      return (typeof a === "number" && !isNaN(a)) ? a: 0;
  	    }
  	  } catch (_) {}

  	  // Fallback: planar shoelace (good enough for ordering)
  	  try {
  	    var meanLat = 0;
  	    for (var j = 0; j < coords.length; j++) meanLat += coords[j].lat;
  	    meanLat = meanLat / coords.length;

  	    var mPerDegLat = 111132.92;
  	    var mPerDegLng = 111319.49 * Math.cos(meanLat * Math.PI / 180);

  	    var sum = 0;
  	    for (var k = 0; k < coords.length; k++) {
  	      var p1 = coords[k];
  	      var p2 = coords[(k + 1) % coords.length];

  	      var x1 = p1.lng * mPerDegLng;
  	      var y1 = p1.lat * mPerDegLat;
  	      var x2 = p2.lng * mPerDegLng;
  	      var y2 = p2.lat * mPerDegLat;

  	      sum += (x1 * y2 - x2 * y1);
  	    }

  	    var area = Math.abs(sum) / 2;
  	    return (typeof area === "number" && !isNaN(area)) ? area: 0;
  	  } catch (_) {
  	    return 0;
  	  }
  	}


  	// ------------------------------------------------------------------------
  	// STEP 9: AUTHORITATIVE LOCATIONS RESOLUTION (THE FIX)
  	// ------------------------------------------------------------------------
  	function resolveLocationsAuthoritative() {
  	  // Priority:
  	  //  1) SWR.overrideLocations if set via SimpleWizard.setLocations()
  	  //  2) SWR.overrideAppData if set via SimpleWizard.setAppData()
  	  //  3) ContextSafe.appData / AppDataSafe / window.AppData
  	  //  4) global Locations fallback
  	  try {
  	    if (Array.isArray(SWR.overrideLocations)) return SWR.overrideLocations;
  	  } catch (_) {}

  	  var appData = null;

  	  try {
  	    if (SWR.overrideAppData) appData = SWR.overrideAppData;
  	  } catch (_) {}

  	  if (!appData) appData = resolveAppDataAuthoritative();

  	  var fromAD = _flattenLocationsFromAppData(appData);
  	  if (fromAD && fromAD.length) return fromAD;

  	  return getLocationsFallbackGlobal();
  	}


  	// ------------------------------------------------------------------------
  	// STEP 10: HARD CLEANUP + PRUNE + REGISTRY CONSISTENCY
  	// ------------------------------------------------------------------------
  	function _removeWizardPolygonById(id) {
  	  var poly = dictGet(SWR.polygonsById, id);
  	  try {
  	    if (poly && isFn(poly.setMap)) poly.setMap(null);
  	  } catch (_) {}
  	  try {
  	    delete SWR.polygonsById[id];
  	  } catch (_) {}
  	}

  	function _unregisterIfPossible(id, keepStore) {
  	  try {
  	    if (RegistrySafe && isFn(RegistrySafe.unregister)) {
  	      RegistrySafe.unregister(id, {
  	        keepStore: !!keepStore
  	      });
  	    }
  	  } catch (_) {}
  	}

  	function pruneMissingLocations(liveIdsDict) {
  	  // 1) Remove wizard-owned polygons no longer present
  	  dictKeys(SWR.polygonsById).forEach(function (existingId) {
  	    if (!dictHas(liveIdsDict, existingId)) {
  	      _removeWizardPolygonById(existingId);
  	    }
  	  });

  	  // 2) Ask registry to unregister missing IDs if it can (optional)
  	  try {
  	    if (RegistrySafe && isFn(RegistrySafe.pruneMissing)) {
  	      RegistrySafe.pruneMissing(liveIdsDict);
  	      return;
  	    }
  	  } catch (_) {}

  	  // 3) Fallback: If registry exposes runtimes, attempt to unregister missing
  	  try {
  	    if (RegistrySafe && isFn(RegistrySafe.getAllRuntimeIds)) {
  	      var ids = RegistrySafe.getAllRuntimeIds();
  	      if (Array.isArray(ids)) {
  	        for (var i = 0; i < ids.length; i++) {
  	          var id = ids[i];
  	          if (!dictHas(liveIdsDict, id)) _unregisterIfPossible(id, true);
  	        }
  	      }
  	    }
  	  } catch (_) {}
  	}

  	function cleanupAllWizardPolygons() {
  	  var ids = dictKeys(SWR.polygonsById);
  	  for (var i = 0; i < ids.length; i++) _removeWizardPolygonById(ids[i]);
  	  SWR.polygonsById = {};
  	}

  	function hardResetRegistryRuntimeIfSupported() {
  	  try {
  	    if (RegistrySafe && isFn(RegistrySafe.clearRuntime)) RegistrySafe.clearRuntime();
  	  } catch (_) {}
  	  try {
  	    if (RegistrySafe && isFn(RegistrySafe.resetRuntime)) RegistrySafe.resetRuntime();
  	  } catch (_) {}
  	  try {
  	    if (RegistrySafe && isFn(RegistrySafe.reset)) RegistrySafe.reset();
  	  } catch (_) {}
  	}

  	function ensureRegistryPolygonOnMapAndZ(id, zIndex) {
  	  // Returns:
  	  //   { ok:true, polygon: <poly> } if registry already has a polygon we can keep
  	  //   { ok:false } if registry has no polygon runtime and we should draw/register
  	  try {
  	    if (!RegistrySafe || !isFn(RegistrySafe.getRuntime)) return {
  	      ok: false
  	    };

  	    var rt = RegistrySafe.getRuntime(id);
  	    if (!rt || !rt.polygon) return {
  	      ok: false
  	    };

  	    var poly = rt.polygon;

  	    try {
  	      if (poly.getMap && poly.getMap() !== gMap && isFn(poly.setMap)) poly.setMap(gMap);
  	    } catch (_) {}

  	    try {
  	      if (typeof zIndex === "number" && isFn(poly.setOptions)) {
  	        poly.setOptions({
  	          zIndex: zIndex
  	        });
  	      }
  	    } catch (_) {}

  	    return {
  	      ok: true,
  	      polygon: poly
  	    };
  	  } catch (_) {
  	    return {
  	      ok: false
  	    };
  	  }
  	}


  	// ------------------------------------------------------------------------
  	// STEP 11: RENDER (DEPICT) LOCATIONS + LAYERING (AUTHORITATIVE)
  	// ------------------------------------------------------------------------
  	function renderAllLocations(opts) {
  	  opts = opts || {};
  	  var doFit = (opts.doFitBounds !== undefined) ? !!opts.doFitBounds: !!SIMPLE_WIZARD_CFG.doFitBoundsOnRender;

  	  // If map reference changed, hard cleanup wizard polygons
  	  if (SWR.lastMapRef && SWR.lastMapRef !== gMap) {
  	    cleanupAllWizardPolygons();
  	  }
  	  SWR.lastMapRef = gMap;

  	  debugMapInfo();

  	  // ALWAYS resolve fresh list
  	  var liveLocations = resolveLocationsAuthoritative();
  	  SWR.lastHydratedCount = liveLocations.length;

  	  // Build liveIds dict for prune
  	  var liveIds = {};
  	  for (var i0 = 0; i0 < liveLocations.length; i0++) {
  	    var loc0 = liveLocations[i0];
  	    var id0 = getLocId(loc0);
  	    if (id0) liveIds[id0] = true;
  	  }

  	  // Prune missing
  	  pruneMissingLocations(liveIds);

  	  var bounds = safeBounds();

  	  var renderedNew = 0;
  	  var reusedRegistryRuntime = 0;
  	  var skippedNoPolygon = 0;
  	  var skippedBadGeometry = 0;

  	  // Build candidates with area for layering
  	  var renderList = [];
  	  for (var i = 0; i < liveLocations.length; i++) {
  	    var loc = liveLocations[i];
  	    var id = getLocId(loc);
  	    if (!id) continue;

  	for (var i = 0; i < liveLocations.length; i++) {
  	  var loc = liveLocations[i];
  	  var id = getLocId(loc);
  	  if (!id) continue;

  	  // --- compute once ---
  	  var rawPaths = getPolygonPaths(loc);
  	  var rawRingCount = (rawPaths && Array.isArray(rawPaths)) ? rawPaths.length : 0;

  	  // --- sanitize once ---
  	  var paths = sanitizePathsForGoogle(loc, rawPaths);
  	  var ringCount = (paths && Array.isArray(paths)) ? paths.length : 0;

  	  // --- validate ---
  	  if (!paths) {
  	    skippedNoPolygon++;
  	    continue;
  	  }
  	  if (!paths[0] || paths[0].length < 3) {
  	    skippedBadGeometry++;
  	    continue;
  	  }

  	  // --- debug: distinguish "none" vs "dropped" vs "kept" ---
  	  if (rawRingCount <= 1) {
  	    console.log("[SimpleWizard] NO HOLES", loc.Name, getLocId(loc), "rings:", rawRingCount);
  	  } else if (ringCount > 1) {
  	    console.log("[SimpleWizard] KEPT HOLES", loc.Name, getLocId(loc), "rings:", rawRingCount, "->", ringCount);
  	  } else {
  	    console.log("[SimpleWizard] DROPPED HOLES", loc.Name, getLocId(loc), "rings:", rawRingCount, "->", ringCount);
  	  }

  	  var outer = paths[0];

  	  renderList.push({
  	    id: id,
  	    loc: loc,
  	    paths: paths,
  	    coords: outer,
  	    areaSqm: computeAreaSqm(outer)
  	  });

  	  if (paths && paths.length > 1) {
  	    console.log("[SimpleWizard] HOLE PATHS", loc.Name, getLocId(loc), "rings:", paths.length);
  	  }
  	}


  	if (rawRingCount <= 1) {
  	  console.log("[SimpleWizard] NO HOLES", loc.Name, getLocId(loc), "rings:", rawRingCount);
  	} else if (ringCount > 1) {
  	  console.log("[SimpleWizard] KEPT HOLES", loc.Name, getLocId(loc), "rings:", rawRingCount, "->", ringCount);
  	} else {
  	  console.log("[SimpleWizard] DROPPED HOLES", loc.Name, getLocId(loc), "rings:", rawRingCount, "->", ringCount);
  	}

  	    var outer = paths[0];

  	    renderList.push({
  	      id: id,
  	      loc: loc,
  	      paths: paths,
  	      coords: outer, // keep existing name for bounds/area ordering (outer only)
  	      areaSqm: computeAreaSqm(outer)
  	    });

  	    if (paths && paths.length > 1) {
  	      console.log("[SimpleWizard] HOLE PATHS", loc.Name, getLocId(loc), "rings:", paths.length);
  	    }

  	  }

  	  // Sort: largest first (largest drawn first, smallest on top)
  	  renderList.sort(function (a, b) {
  	    return (b.areaSqm || 0) - (a.areaSqm || 0);
  	  });

  	  if (SIMPLE_WIZARD_CFG.traceClicks) {
  	    try {
  	      log(SIMPLE_WIZARD_CFG.logPrefix, "🧩 Layering order (largest -> smallest)", renderList.map(function (r) {
  	        return {
  	          id: r.id,
  	          name: r.loc && r.loc.Name,
  	          type: r.loc && r.loc.Type,
  	          areaSqm: Math.round(r.areaSqm || 0)
  	        };
  	      }));
  	    } catch (_) {}
  	  }

  	  // Render / Reuse registry runtime
  	  for (var k = 0; k < renderList.length; k++) {
  	    var item = renderList[k];
  	    var locX = item.loc;
  	    var idX = item.id;
  	    var coordsX = item.coords;
  	    var pathsX = item.paths;

  	    var color = (locX && locX.Color) ? locX.Color: SIMPLE_WIZARD_CFG.defaultColor;
  	    var zLayer = (SIMPLE_WIZARD_CFG.zIndexBase || 0) + k;

  	    // If registry already has runtime polygon, prefer reusing it (no double-register)
  	    var keep = ensureRegistryPolygonOnMapAndZ(idX, zLayer);
  	    if (keep.ok) {
  	      reusedRegistryRuntime++;

  	      // IMPORTANT: refresh geometry in-place so new holes render
  	      try {
  	        if (keep.polygon && typeof keep.polygon.setPaths === "function") {
  	          keep.polygon.setPaths(normalizeGooglePolygonPaths(pathsX));
  	        }
  	      } catch (_) {}

  	      // IMPORTANT: holes require even-odd fill rule
  	      try {
  	        if (keep.polygon && typeof keep.polygon.setOptions === "function") {
  	          keep.polygon.setOptions({
  	            fillRule: "evenodd"
  	          });
  	        }
  	      } catch (_) {}

  	      extendBounds(bounds, coordsX);
  	      continue;
  	    }



  	    // If wizard previously created one for this id, remove it (geometry/color could change)
  	    _removeWizardPolygonById(idX);

  	    // Create polygon
  	    var polygon = null;
  	    try {
  	      polygon = new google.maps.Polygon({
  	        paths: normalizeGooglePolygonPaths(pathsX),

  	        strokeColor: color,
  	        strokeOpacity: SIMPLE_WIZARD_CFG.strokeOpacity,
  	        strokeWeight: SIMPLE_WIZARD_CFG.strokeWeight,
  	        fillColor: color,
  	        fillOpacity: SIMPLE_WIZARD_CFG.fillOpacity,

  	        // IMPORTANT: holes require even-odd fill rule
  	        fillRule: "evenodd",

  	        clickable: true,
  	        zIndex: zLayer,
  	        map: gMap
  	      });
  	    } catch (e1) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Polygon create failed:", idX, e1);
  	      continue;
  	    }

  	    extendBounds(bounds, coordsX);

  	    // Register with registry (registry owns listeners/state)
  	    try {
  	      RegistrySafe.register({
  	        location: locX,
  	        polygon: polygon,
  	        geometryMeta: {
  	          type: (locX && (locX.CreationType || (locX.GeometryMeta && locX.GeometryMeta.type))) || "Polygon"
  	        }
  	      });
  	    } catch (e2) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Registry register failed:", idX, e2);
  	      try {
  	        polygon.setMap(null);
  	      } catch (_) {}
  	      continue;
  	    }

  	    dictSet(SWR.polygonsById, idX, polygon);
  	    renderedNew++;
  	  }

  	  // Fit bounds
  	  try {
  	    if (doFit && bounds && !boundsIsEmpty(bounds) && isFn(gMap.fitBounds)) {
  	      gMap.fitBounds(bounds);

  	      if (google && google.maps && google.maps.event && isFn(google.maps.event.addListenerOnce)) {
  	        google.maps.event.addListenerOnce(gMap, "bounds_changed", function () {
  	          try {
  	            if (isFn(gMap.getZoom) && isFn(gMap.setZoom)) {
  	              var z = gMap.getZoom();
  	              if (z > SIMPLE_WIZARD_CFG.maxZoomAfterFit) gMap.setZoom(SIMPLE_WIZARD_CFG.maxZoomAfterFit);
  	            }
  	          } catch (_) {}
  	        });
  	      }
  	    }
  	  } catch (_) {}

  	  try {
  	    SWR.renderCount = (SWR.renderCount || 0) + 1;
  	  } catch (_) {}

  	  log(SIMPLE_WIZARD_CFG.logPrefix,
  	    "✅ Render complete:",
  	    {
  	      renderedNew: renderedNew,
  	      reusedRegistryRuntime: reusedRegistryRuntime,
  	      skippedNoPolygon: skippedNoPolygon,
  	      skippedBadGeometry: skippedBadGeometry,
  	      locationsTotal: liveLocations.length,
  	      renderCount: SWR.renderCount,
  	      reason: opts.reason || null
  	    });

  	  // Optional list sync
  	  refreshLocationsDynamicListIfEnabled();
  	}


  	// ------------------------------------------------------------------------
  	// STEP 12: MAP READY GUARDS + PUBLIC API (THE FIXED CONTRACT)
  	// ------------------------------------------------------------------------
  	function onMapReadyRunOnce() {
  	  if (window.__SimpleWizardHasRunOnce_v41 === true) return;
  	  window.__SimpleWizardHasRunOnce_v41 = true;
  	  renderAllLocations({
  	    reason: "initial"
  	  });
  	}

  	function attachReadyGuards() {
  	  if (mapLooksReady(gMap)) {
  	    onMapReadyRunOnce();
  	    return;
  	  }

  	  try {
  	    if (google && google.maps && google.maps.event && isFn(google.maps.event.addListenerOnce)) {
  	      google.maps.event.addListenerOnce(gMap, "idle", function () {
  	        onMapReadyRunOnce();
  	      });
  	    }
  	  } catch (_) {}

  	  setTimeout(function () {
  	    onMapReadyRunOnce();
  	  }, SIMPLE_WIZARD_CFG.mapReadyTimeoutMs);
  	}


  	// ------------------------------------------------------------------------
  	// STEP 13: START + EXPORTED API
  	// ------------------------------------------------------------------------
  	try {
  	  window.__SimpleWizardHasRunOnce_v41 = false;

  	  window.SimpleWizard = window.SimpleWizard || {};

  	  // ------------------------------------------------------------
  	  // PATCH: Allow UI Builder panel OnMounted to hand us its context
  	  // ------------------------------------------------------------
  	  window.SimpleWizard.setUIContext = function (ctx) {
  	    try {
  	      window.__SimpleWizardUIContext_v41 = ctx || null;
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  };

  	  // ------------------------------------------------------------
  	  // PATCH: Allow panel to tell wizard which dynamic list UID to sync
  	  // ------------------------------------------------------------
  	  window.SimpleWizard.setLocationsListUid = function (uid) {
  	    try {
  	      SIMPLE_WIZARD_CFG.locationsListComponentUid = uid || null;
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  };

  	  // ============================================================
  	  // NEW: Uniform Hard Delete Location (Field Wizard look & feel)
  	  // Usage:
  	  //   window.SimpleWizard.hardDeleteLocationPrompt(locationObjectId)
  	  // ============================================================
  	  window.SimpleWizard.hardDeleteLocationPrompt = function (locationObjectId) {

  	    // ------------------------------------------------------------
  	    // STEP 0: SAFE GLOBAL RESOLUTION (Golden Standard)
  	    // ------------------------------------------------------------
  	    var _Backendless = (typeof Backendless !== "undefined" ? Backendless: null);
  	    var _LocationRegistry = (typeof window !== "undefined"
  	      ? (typeof window.LocationRegistry !== "undefined" ? window.LocationRegistry: null): null);
  	    var _SimpleWizard = (typeof window !== "undefined"
  	      ? (typeof window.SimpleWizard !== "undefined" ? window.SimpleWizard: null): null);
  	    var _LocationRegistryUI = (typeof window !== "undefined"
  	      ? (typeof window.LocationRegistryUI !== "undefined" ? window.LocationRegistryUI: null): null);

  	    var _Panel = (typeof Panel !== "undefined" ? Panel: null);
  	    var _Hub = (typeof Hub !== "undefined" ? Hub: null);

  	    var _AppData = null;
  	    try {
  	      _AppData = (typeof resolveAppDataAuthoritative === "function") ? resolveAppDataAuthoritative(): null;
  	    } catch (_) {}
  	    if (!_AppData) _AppData = (typeof AppData !== "undefined" ? AppData: null);

  	    var id = (locationObjectId != null) ? String(locationObjectId).trim(): "";
  	    if (!id) {
  	      alert("Delete failed: locationObjectId is empty."); return false;
  	    }
  	    if (!_Backendless || !_Backendless.Data || typeof _Backendless.Data.of !== "function") {
  	      alert("Delete failed: Backendless not available.");
  	      return false;
  	    }

  	    // ------------------------------------------------------------
  	    // STEP 1: PROMPT UI (type DELETE)
  	    // ------------------------------------------------------------
  	    function mountRoot() {
  	      try {
  	        if (_Panel && _Panel.el) return _Panel.el;
  	        if (_Hub && _Hub.el) return _Hub.el;
  	        if (_Hub) return _Hub;
  	      } catch (_) {}
  	      return document.body;
  	    }

  	    // Prevent multiple prompts
  	    try {
  	      var existing = document.getElementById("__hardDeletePrompt");
  	      if (existing) existing.remove();
  	    } catch (_) {}

  	    var root = mountRoot();

  	    var overlay = document.createElement("div");
  	    overlay.id = "__hardDeletePrompt";
  	    Object.assign(overlay.style, {
  	      position: "fixed",
  	      inset: "0",
  	      background: "rgba(0,0,0,0.65)",
  	      zIndex: 999999,
  	      display: "flex",
  	      alignItems: "center",
  	      justifyContent: "center",
  	      fontFamily: "system-ui, sans-serif"
  	    });

  	    var card = document.createElement("div");
  	    Object.assign(card.style, {
  	      width: "360px",
  	      background: "#1f1f1f",
  	      color: "#fff",
  	      borderRadius: "12px",
  	      border: "1px solid rgba(204,102,51,0.8)",
  	      boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
  	      padding: "14px 14px 12px"
  	    });

  	    var title = document.createElement("div");
  	    title.textContent = "Hard Delete Location";
  	    Object.assign(title.style, {
  	      fontWeight: "700", fontSize: "14px", color: "#CC6633"
  	    });

  	    var msg = document.createElement("div");
  	    msg.innerHTML =
  	    "This will permanently delete the Location everywhere.<br>" +
  	    "<div style='margin-top:6px;font-size:11px;color:#bbb'>Location objectId: <b style='color:#eee'>" + id + "</b></div>" +
  	    "<div style='margin-top:10px;font-size:12px;color:#ddd'>Type <b>DELETE</b> to enable the button.</div>";

  	    var input = document.createElement("input");
  	    input.type = "text";
  	    input.placeholder = "Type DELETE";
  	    Object.assign(input.style, {
  	      width: "100%",
  	      padding: "8px",
  	      marginTop: "10px",
  	      borderRadius: "8px",
  	      border: "none",
  	      outline: "none",
  	      background: "#2a2a2a",
  	      color: "#fff",
  	      fontSize: "13px"
  	    });

  	    var row = document.createElement("div");
  	    Object.assign(row.style, {
  	      display: "flex", gap: "8px", marginTop: "12px"
  	    });

  	    function btnStyle(bg) {
  	      return {
  	        flex: "1",
  	        padding: "8px",
  	        borderRadius: "8px",
  	        border: "none",
  	        cursor: "pointer",
  	        color: "#fff",
  	        fontWeight: "700",
  	        background: bg,
  	        fontSize: "13px"
  	      };
  	    }

  	    var cancelBtn = document.createElement("button");
  	    cancelBtn.textContent = "Cancel";
  	    Object.assign(cancelBtn.style, btnStyle("#444"));

  	    var delBtn = document.createElement("button");
  	    delBtn.textContent = "Delete";
  	    Object.assign(delBtn.style, btnStyle("#7a1f1f"));
  	    delBtn.disabled = true;
  	    delBtn.style.opacity = "0.5";
  	    delBtn.style.cursor = "not-allowed";

  	    var status = document.createElement("div");
  	    Object.assign(status.style, {
  	      marginTop: "10px", fontSize: "11px", color: "#aaa", minHeight: "14px"
  	    });

  	    input.oninput = function () {
  	      var ok = String(input.value || "").trim().toUpperCase() === "DELETE";
  	      delBtn.disabled = !ok;
  	      delBtn.style.opacity = ok ? "1": "0.5";
  	      delBtn.style.cursor = ok ? "pointer": "not-allowed";
  	    };

  	    function closePrompt() {
  	      try {
  	        overlay.remove();
  	      } catch (_) {}
  	    }

  	    cancelBtn.onclick = function () {
  	      closePrompt();
  	    };

  	    overlay.addEventListener("click", function (e) {
  	      if (e && e.target === overlay) closePrompt();
  	    });

  	    card.appendChild(title);
  	    card.appendChild(msg);
  	    card.appendChild(input);
  	    row.appendChild(cancelBtn);
  	    row.appendChild(delBtn);
  	    card.appendChild(row);
  	    card.appendChild(status);
  	    overlay.appendChild(card);
  	    root.appendChild(overlay);

  	    // ------------------------------------------------------------
  	    // STEP 2: DELETE HELPERS
  	    // ------------------------------------------------------------
  	    function purgeLocationFromAppData(appData,
  	      objectId) {
  	      try {
  	        if (!appData || !appData.User || !Array.isArray(appData.User.Companies)) return;

  	        var comps = appData.User.Companies;

  	        for (var ci = 0; ci < comps.length; ci++) {
  	          var comp = comps[ci];
  	          if (!comp) continue;

  	          if (Array.isArray(comp.Locations)) {
  	            comp.Locations = comp.Locations.filter(function (L) {
  	              if (!L) return false;
  	              return String(L.objectId || L.id || "") !== String(objectId);
  	            });
  	          }
  	        }
  	      } catch (_) {}
  	    }

  	    function buildAllLocationsFromAppData(appData) {
  	      var out = [];
  	      var seen = Object.create(null);

  	      function pushDedup(x) {
  	        try {
  	          if (!x) return;
  	          var oid = (x.objectId != null) ? String(x.objectId): "";
  	          if (!oid || seen[oid]) return;
  	          seen[oid] = true;
  	          out.push(x);
  	        } catch (_) {}
  	      }

  	      try {
  	        var comps = (appData && appData.User && Array.isArray(appData.User.Companies)) ? appData.User.Companies: [];
  	        for (var ci = 0; ci < comps.length; ci++) {
  	          var comp = comps[ci];
  	          var locs = (comp && Array.isArray(comp.Locations)) ? comp.Locations: [];
  	          for (var li = 0; li < locs.length; li++) pushDedup(locs[li]);
  	        }
  	      } catch (_) {}

  	      return out;
  	    }

  	    // ------------------------------------------------------------
  	    // STEP 3: HARD DELETE PIPELINE
  	    // ------------------------------------------------------------
  	    async function hardDeleteEverywhere(objectId) {

  	      // 1) DB delete
  	      status.textContent = "Deleting from database.";
  	      await _Backendless.Data.of("Locations").remove({
  	        objectId: objectId
  	      });

  	      // 2) AppData purge
  	      status.textContent = "Purging from AppData.";
  	      purgeLocationFromAppData(_AppData, objectId);

  	      // 2.5) ALSO purge from global Locations array (legacy binding safety)
  	      try {
  	        var LocationsSafe = (typeof Locations !== "undefined" ? Locations: null);
  	        if (Array.isArray(LocationsSafe)) {
  	          LocationsSafe = LocationsSafe.filter(function (l) {
  	            return l && String(l.objectId || l.id || "") !== String(objectId);
  	          });
  	          try {
  	            Locations = LocationsSafe;
  	          } catch (_) {}
  	        }
  	      } catch (_) {}

  	      // 3) Registry cleanup + (optional) hydrate
  	      status.textContent = "Refreshing registry.";
  	      var allLocs = buildAllLocationsFromAppData(_AppData);

  	      if (_LocationRegistry) {
  	        try {
  	          if (typeof _LocationRegistry.removeById === "function") _LocationRegistry.removeById(objectId);
  	        } catch (_) {}
  	        try {
  	          if (typeof _LocationRegistry.unregister === "function") _LocationRegistry.unregister(objectId, {
  	            keepStore: true
  	          });
  	        } catch (_) {}

  	        // If your registry expects reset/hydrate for full consistency, do it (tolerant)
  	        try {
  	          if (typeof _LocationRegistry.reset === "function") _LocationRegistry.reset();
  	        } catch (_) {}
  	        try {
  	          if (typeof _LocationRegistry.hydrateFromLocations === "function") _LocationRegistry.hydrateFromLocations(allLocs);
  	          else if (typeof _LocationRegistry.hydrate === "function") _LocationRegistry.hydrate(allLocs);
  	        } catch (_) {}
  	      }

  	      // 4) Map redraw (wizard pipeline)
  	      status.textContent = "Refreshing map.";
  	      if (_SimpleWizard) {
  	        if (typeof _SimpleWizard.hardRefresh === "function") _SimpleWizard.hardRefresh({
  	          reason: "hard-delete-location", doFitBounds: false
  	        });
  	        else if (typeof _SimpleWizard.refresh === "function") _SimpleWizard.refresh({
  	          reason: "hard-delete-location", doFitBounds: false
  	        });
  	      }

  	      // 5) UI last: repeater/list refresh
  	      status.textContent = "Refreshing panel.";
  	      setTimeout(function () {
  	        try {
  	          if (_LocationRegistryUI && typeof _LocationRegistryUI.refreshList === "function") _LocationRegistryUI.refreshList();
  	        } catch (_) {}

  	        try {
  	          if (typeof window !== "undefined" && window && typeof window.dispatchEvent === "function") {
  	            window.dispatchEvent(new CustomEvent("LocationRegistry:updated", {
  	              detail: {
  	                reason: "hard-delete-location", objectId: objectId
  	              }
  	            }));
  	          }
  	        } catch (_) {}
  	      },
  	        0);
  	    }

  	    delBtn.onclick = async function () {
  	      delBtn.disabled = true;
  	      cancelBtn.disabled = true;
  	      input.disabled = true;

  	      try {
  	        await hardDeleteEverywhere(id);
  	        status.textContent = "Deleted successfully.";
  	        setTimeout(function () {
  	          closePrompt();
  	          alert("Location deleted successfully.");
  	        },
  	          250);
  	      } catch (e) {
  	        try {
  	          console.error("[HardDeleteLocation]",
  	            e);
  	        } catch (_) {}
  	        status.textContent = "Delete failed. Check console.";
  	        delBtn.disabled = false;
  	        cancelBtn.disabled = false;
  	        input.disabled = false;
  	      }
  	    };

  	    return true;
  	  };

  	  // --- Primary refresh (always rehydrates from AppData) ---
  	  window.SimpleWizard.refresh = function (opts) {
  	    opts = opts || {};
  	    try {
  	      renderAllLocations({
  	        reason: opts.reason || "manual",
  	        doFitBounds: (opts.doFitBounds !== undefined) ? !!opts.doFitBounds: undefined
  	      });
  	    } catch (e) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix,
  	        "❌ refresh() failed:",
  	        e);
  	    }
  	  };

  	  // --- True hard refresh after save (clears wizard polygons + optional registry runtime reset) ---
  	  window.SimpleWizard.hardRefresh = function (opts) {
  	    opts = opts || {};
  	    try {
  	      cleanupAllWizardPolygons();

  	      if (opts.resetRegistryRuntime === true) {
  	        hardResetRegistryRuntimeIfSupported();
  	      }

  	      renderAllLocations({
  	        reason: opts.reason || "hardRefresh",
  	        doFitBounds: (opts.doFitBounds !== undefined) ? !!opts.doFitBounds: true
  	      });

  	      return true;
  	    } catch (e) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ hardRefresh() failed:", e);
  	      return false;
  	    }
  	  };

  	  // --- Authoritative hooks ---
  	  window.SimpleWizard.setLocations = function (locs) {
  	    try {
  	      SWR.overrideLocations = Array.isArray(locs) ? locs: null; return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  };

  	  window.SimpleWizard.setAppData = function (appData) {
  	    try {
  	      SWR.overrideAppData = appData || null; return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  };

  	  window.SimpleWizard.hardRefreshFromAppData = function (appData, fallbackLocations, opts) {
  	    opts = opts || {};
  	    try {
  	      SWR.overrideAppData = appData || null;
  	      SWR.overrideLocations = Array.isArray(fallbackLocations) ? fallbackLocations: null;

  	      cleanupAllWizardPolygons();

  	      if (opts.resetRegistryRuntime === true) {
  	        hardResetRegistryRuntimeIfSupported();
  	      }

  	      renderAllLocations({
  	        reason: opts.reason || "hardRefreshFromAppData",
  	        doFitBounds: (opts.doFitBounds !== undefined) ? !!opts.doFitBounds: true
  	      });

  	      return {
  	        ok: true,
  	        locations: SWR.lastHydratedCount
  	      };
  	    } catch (e) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ hardRefreshFromAppData() failed:", e);
  	      return {
  	        ok: false,
  	        error: e
  	      };
  	    }
  	  };

  	  // --- Debug helper ---
  	  window.SimpleWizard.getLastHydratedCount = function () {
  	    try {
  	      return SWR.lastHydratedCount || 0;
  	    } catch (_) {
  	      return 0;
  	    }
  	  };

  	  log(SIMPLE_WIZARD_CFG.logPrefix, "▶ Starting:", SIMPLE_WIZARD_CFG.version, {
  	    locationsInitial: resolveLocationsAuthoritative().length,
  	    hubDataStoreUid: SIMPLE_WIZARD_CFG.hubDataStoreUid,
  	    listUid: SIMPLE_WIZARD_CFG.locationsListComponentUid,
  	    hasContext: !!ContextSafe,
  	    traceClicks: !!SIMPLE_WIZARD_CFG.traceClicks,
  	    panelDetectMaxAttempts: SIMPLE_WIZARD_CFG.panelDetectMaxAttempts,
  	    panelDetectDelayMs: SIMPLE_WIZARD_CFG.panelDetectDelayMs,
  	    panelFailSafeInject: SIMPLE_WIZARD_CFG.panelFailSafeInject,
  	    zIndexBase: SIMPLE_WIZARD_CFG.zIndexBase
  	  });

  	  attachReadyGuards();
  	} catch (fatal) {
  	  warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ Fatal error:", fatal);
  	}
  })((await Locations2()), AppData, Panel, PanelBlock, Map);

}

})
define('./functions/99baf5867ace567d1f12784621d9f6dc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_99baf5867ace567d1f12784621d9f6dc'] = async function fn_99baf5867ace567d1f12784621d9f6dc() {
  if (await Backendless.UserService.isValidLogin()) {
  } else {
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
  }

}

})
define('./functions/9ef225438f774527c9eb1feb6044ce26/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9ef225438f774527c9eb1feb6044ce26'] = async function fn_9ef225438f774527c9eb1feb6044ce26(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/a1856c74d27745ecf1c18a8269e6103d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a1856c74d27745ecf1c18a8269e6103d'] = async function fn_a1856c74d27745ecf1c18a8269e6103d(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	    fromIndex = array.length - 1
	}

	return _.findLastIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/a376d7d6007e9dbebe6eea15750b4b61/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a376d7d6007e9dbebe6eea15750b4b61'] = async function fn_a376d7d6007e9dbebe6eea15750b4b61(listToInspect, comparatorFunction) {
return (await (async function(array, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqWith(array, comparator)
})(listToInspect, comparatorFunction))
}

})
define('./functions/a66c80cfedbfbaf191e559e77438ebe9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a66c80cfedbfbaf191e559e77438ebe9'] = async function fn_a66c80cfedbfbaf191e559e77438ebe9(App, MAP) {
  await (async function(APP, SVG, MAP) {
  	/*
  	 * Fleet In Form — MOBILE TRACK V1.0.30
  	 * Backendless UI Builder Custom Code
  	 *
  	 * Inputs:
  	 *   App  - App / AppData object
  	 *   SVG  - Fleet In Form logo (raw SVG, data URI, base64 PNG or URL)
  	 *   MAP  - Backendless UI Builder Google Map component (Get component by id)
  	 *
  	 * Mount behaviour:
  	 *   - Runs immediately on mount.
  	 *   - Builds a full-screen, touch-first Google HYBRID tracking interface.
  	 *   - MAP is used as the Google Maps API bootstrap / readiness source.
  	 *   - Once the Backendless Map proves window.google.maps is ready, Mobile
  	 *     Tracking creates its OWN full-screen HYBRID map inside its fixed root.
  	 *   - This avoids Backendless stacking-context / wrapper clipping problems that
  	 *     can leave a reused Map component black even though Google Maps has loaded.
  	 *   - The old API-loader path remains only as a fallback when MAP is absent.
  	 *   - Reads accessible Tractors from AppData.User.Companies.
  	 *   - LIVE mode refreshes the latest Flespi position every 60 seconds.
  	 *   - The live fleet initially fits to the bounds of every vehicle with GPS.
  	 *   - Manual LIVE refresh / return to LIVE fits the complete fleet again.
  	 *   - Vehicle summary shows Last Moved, not merely the last telemetry update.
  	 *   - Logout opens the themed app switcher directly below the top-right button
  	 *     when the user has access to another Fleet In Form application.
  	 *   - Users without another application privilege are logged out immediately.
  	 *   - The switcher always retains a real Log Out option for multi-app users.
  	 *   - LIVE markers use the canonical TrackIT vehicle-colour badge and pulse rings.
  	 *   - Historical tracks run the canonical CAN Event Engine and use the same
  	 *     red / green / yellow route coding plus Start / Stop / Idle / End / Fuel markers.
  	 *   - Tapping any historical route point opens the old FineTrack-style
  	 *     point data reduced to Speed, Revs, Temp and Idle, in that order.
  	 *   - Includes the canonical old TrackIT Map Control: map type, zoom,
  	 *     traffic, labels, fullscreen, Directions, WhatsApp route sending
  	 *     (including assigned-driver send) and AppData company Locations.
  	 *   - Mobile top bar is intentionally minimal: Fleet In Form SVG left,
  	 *     Logout right. The old top-bar Refresh button is removed.
  	 *   - Map Control docks directly against the top edge of the mobile bottom sheet.
  	 *   - The separate floating Fit/Locate ('brightness') button is removed.
  	 *   - Map Control is re-parented out of the Google map stacking context so
  	 *     it can sit above (not behind) the bottom tracking panel.
  	 *   - V1.0.11 is map-first: compact glass bottom dock, one-line vehicle
  	 *     summary on wide screens, reduced duplication, and no wasted footer.
  	 *   - Mobile map actions are reduced to Directions and Locations only.
  	 *   - Directions uses a focused 4-step workflow and hides normal tracking
  	 *     chrome while points, stops, destination and share data are selected.
  	 *   - Historical modes: 30 Minutes / 1 Hour / 3 Hours / 6 Hours.
  	 *   - Historical route includes route metrics and a mobile scrub/replay control.
  	 *   - V1.0.18 prioritises the LIVE vehicle selector: moving vehicles first,
  	 *     alphanumeric within the moving group, then all other vehicles alphanumeric.
  	 *   - Every currently moving vehicle is marked with a green dot in the selector.
  	 *   - V1.0.23 fixes the vehicle selector layering by opening its list as a
  	 *     TRUE FULL-SCREEN overlay above the map and bottom tracking dock.
  	 *   - V1.0.25 makes repeated Mobile Tracking -> Office switching reliable by
  	 *     leaving Office initialisation to the newly mounted Office page. The
  	 *     outgoing Mobile Tracking page now only ensures the local Office key exists
  	 *     and never waits on the long-lived Office loader before navigation.
  	 *   - V1.0.28 preserves the in-memory AppData.User object, verifies that the
  	 *     Backendless session is still valid, destroys any old shared app-switcher
  	 *     runtime, restores the destination AppData.APP value required by Office,
  	 *     and then performs exactly one Backendless SPA navigation call.
  	 *   - V1.0.29 shares the protected logout contract with the Office switcher:
  	 *     background logout calls left alive by an outgoing SPA page are blocked,
  	 *     while the user's explicit Log Out choice still destroys the session.
  	 *   - V1.0.30 adds Snapshot to the permission-aware app switcher when the
  	 *     user's Settings contains Overview, matching the login-page permission rule.
  	 *   - Vehicle icons remain on the LEFT of every selector row.
  	 *   - Movement indication is restored exactly: GREEN whenever the existing
  	 *     live-status logic says MOVING. The ONLY override is RED when the same
  	 *     warning logic that creates the red warning ring is active.
  	 *   - The long-press action InfoWindow remains anchored above the vehicle and
  	 *     no longer shows Google Maps' internal horizontal/vertical scrollbars.
  	 *   - Directions and direct Backendless/Twilio WhatsApp behaviour are unchanged.
  	 *
  	 * Runtime rules:
  	 *   - Map/markers are updated in place; the map is never rebuilt during refresh.
  	 *   - First successful LIVE load fits the fleet once. Later refreshes never steal
  	 *     the user's zoom or pan position.
  	 *   - A selected vehicle can be followed without affecting the rest of the fleet.
  	 *   - LIVE polling pauses while a historical route is displayed and resumes when
  	 *     LIVE is selected again.
  	 *   - Mobile browser background throttling is respected; returning to the page
  	 *     triggers an immediate refresh when the 60-second refresh is overdue.
  	 */

  	return await (async function FIFMobileTrackV1_0_30(App, SVG, MAP) {
  	  "use strict";

  	  const VERSION = "1.0.30";
  	  const ROOT_ID = "fif-mobile-track-root";
  	  const STYLE_ID = "fif-mobile-track-style";
  	  const RUNTIME_KEY = "__FIF_MOBILE_TRACK_RUNTIME__";
  	  const LOGOUT_GUARD_KEY = "__FIF_LOGOUT_GUARD_V1__";
  	  const LIVE_REFRESH_MS = 60000;
  	  const STALE_AFTER_SEC = 300;
  	  const OFFLINE_AFTER_SEC = 900;
  	  const MAX_ROUTE_POINTS = 1200;
  	  const MAX_REPLAY_POINTS = 240;
  	  const DEFAULT_CENTER = { lat: -30.5595, lng: 22.9375 };
  	  const DEFAULT_ZOOM = 5;

  	  /*
  	   * Keep one logout guard alive across Backendless SPA page transitions.
  	   * Office installs it before opening Mobile Tracking; Mobile re-installs it
  	   * immediately on mount in case the SDK service object was recreated.
  	   */
  	  function installLogoutGuard() {
  	    try {
  	      if (
  	        typeof Backendless === "undefined" ||
  	        !Backendless.UserService ||
  	        typeof Backendless.UserService.logout !== "function"
  	      ) {
  	        return null;
  	      }

  	      const service = Backendless.UserService;
  	      const existing = window[LOGOUT_GUARD_KEY];

  	      if (
  	        existing &&
  	        existing.service === service &&
  	        service.logout === existing.wrapper
  	      ) {
  	        return existing;
  	      }

  	      const original =
  	        existing &&
  	        existing.service === service &&
  	        typeof existing.original === "function"
  	          ? existing.original
  	          : service.logout;

  	      const guard = {
  	        version: "1.0",
  	        service: service,
  	        original: original,
  	        wrapper: null,
  	        explicitBusy: false,
  	        blockedCount: existing && existing.blockedCount
  	          ? existing.blockedCount
  	          : 0,
  	        async explicitLogout() {
  	          if (guard.explicitBusy) return false;
  	          guard.explicitBusy = true;

  	          try {
  	            return await guard.original.apply(guard.service, arguments);
  	          } finally {
  	            guard.explicitBusy = false;
  	          }
  	        }
  	      };

  	      guard.wrapper = function protectedBackendlessLogout() {
  	        guard.blockedCount += 1;
  	        console.warn(
  	          "[FIF Logout Guard] Blocked a background logout during app switching.",
  	          { blockedCount: guard.blockedCount }
  	        );
  	        return Promise.resolve(false);
  	      };

  	      try {
  	        service.logout = guard.wrapper;
  	      } catch (_) {
  	        Object.defineProperty(service, "logout", {
  	          configurable: true,
  	          writable: true,
  	          value: guard.wrapper
  	        });
  	      }

  	      if (service.logout !== guard.wrapper) return null;

  	      window[LOGOUT_GUARD_KEY] = guard;
  	      return guard;
  	    } catch (error) {
  	      console.error("[FIF Logout Guard] Could not install.", error);
  	      return null;
  	    }
  	  }

  	  const logoutGuard = installLogoutGuard();

  	  /*
  	   * Compatibility fallback copied from the user's existing TrackIT telemetry
  	   * function. The resolver first checks App/AppData for a replacement token,
  	   * so this can be migrated without changing the tracking UI.
  	   */
  	  const LEGACY_FLESPI_AUTH = "FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW";

  	  // ---------------------------------------------------------------------------
  	  // Tiny helpers
  	  // ---------------------------------------------------------------------------
  	  function clean(value) {
  	    return value === null || value === undefined ? "" : String(value).trim();
  	  }

  	  function lower(value) {
  	    return clean(value).toLowerCase();
  	  }

  	  function arr(value) {
  	    return Array.isArray(value) ? value : [];
  	  }

  	  function num(value) {
  	    const n = Number(value);
  	    return Number.isFinite(n) ? n : null;
  	  }

  	  function bool(value) {
  	    if (value === true || value === false) return value;
  	    const s = lower(value);
  	    if (!s) return false;
  	    return s === "true" || s === "1" || s === "yes" || s === "on";
  	  }

  	  function unwrap(value) {
  	    if (
  	      value &&
  	      typeof value === "object" &&
  	      !Array.isArray(value) &&
  	      Object.prototype.hasOwnProperty.call(value, "value")
  	    ) {
  	      return value.value;
  	    }
  	    return value;
  	  }

  	  function getPath(object, path, fallback) {
  	    if (!object || !path) return fallback;

  	    if (Object.prototype.hasOwnProperty.call(object, path)) {
  	      const direct = unwrap(object[path]);
  	      return direct === undefined ? fallback : direct;
  	    }

  	    const parts = String(path).split(".");
  	    let cursor = object;

  	    for (let i = 0; i < parts.length; i += 1) {
  	      if (
  	        cursor === null ||
  	        cursor === undefined ||
  	        !Object.prototype.hasOwnProperty.call(Object(cursor), parts[i])
  	      ) {
  	        return fallback;
  	      }
  	      cursor = cursor[parts[i]];
  	    }

  	    const result = unwrap(cursor);
  	    return result === undefined ? fallback : result;
  	  }

  	  function firstValue(values, fallback) {
  	    for (let i = 0; i < values.length; i += 1) {
  	      const value = unwrap(values[i]);
  	      if (value !== null && value !== undefined && clean(value) !== "") {
  	        return value;
  	      }
  	    }
  	    return fallback;
  	  }

  	  function escapeHtml(value) {
  	    return clean(value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/"/g, "&quot;")
  	      .replace(/'/g, "&#039;");
  	  }

  	  function escapeAttr(value) {
  	    return escapeHtml(value);
  	  }

  	  function clamp(value, min, max) {
  	    return Math.max(min, Math.min(max, value));
  	  }

  	  function appBag() {
  	    if (App && App.data && typeof App.data === "object") return App.data;
  	    if (App && typeof App === "object" && !("data" in App)) return App;

  	    try {
  	      if (
  	        typeof BackendlessUI !== "undefined" &&
  	        BackendlessUI.App &&
  	        BackendlessUI.App.data
  	      ) {
  	        return BackendlessUI.App.data;
  	      }
  	    } catch (_) {}

  	    if (typeof window !== "undefined" && window.AppData) {
  	      return window.AppData.data || window.AppData;
  	    }

  	    return {};
  	  }

  	  function objectIdOf(value) {
  	    return clean(
  	      firstValue([
  	        value && value.objectId,
  	        value && value.ObjectId,
  	        value && value.objectID,
  	        value && value.id,
  	        value && value.ID
  	      ], "")
  	    );
  	  }

  	  function companyName(company) {
  	    return clean(
  	      firstValue([
  	        company && company.Name,
  	        company && company.CompanyName,
  	        getPath(company, "Manifest.Profile.TradingName", ""),
  	        getPath(company, "Manifest.Profile.Company_Name", ""),
  	        getPath(company, "Manifest.Profile.LegalName", "")
  	      ], "Company")
  	    );
  	  }

  	  function vehicleRegistration(tractor) {
  	    return clean(
  	      firstValue([
  	        getPath(tractor, "Data.Vehicle.Identity.Registration", ""),
  	        getPath(tractor, "Data.Vehicle.Identity.FID", ""),
  	        tractor && tractor.Registration,
  	        tractor && tractor.FID,
  	        tractor && tractor.ID,
  	        objectIdOf(tractor)
  	      ], "Vehicle")
  	    );
  	  }

  	  function vehicleSubtitle(tractor) {
  	    const make = clean(getPath(tractor, "Data.Vehicle.Identity.Make", ""));
  	    const model = clean(getPath(tractor, "Data.Vehicle.Identity.Model", ""));
  	    const year = clean(getPath(tractor, "Data.Vehicle.Identity.Year", ""));
  	    return [make, model, year].filter(Boolean).join(" · ");
  	  }

  	  function vehicleColor(tractor) {
  	    const value = clean(
  	      firstValue([
  	        getPath(tractor, "Data.Vehicle.Appearance.Color", ""),
  	        tractor && tractor.color,
  	        tractor && tractor.Color
  	      ], "")
  	    );
  	    return /^#[0-9a-f]{6}$/i.test(value) ? value : "#d46d34";
  	  }

  	  function trackerId(tractor) {
  	    return clean(
  	      firstValue([
  	        tractor && tractor.Tracker,
  	        getPath(tractor, "Data.Telematics.DeviceId", ""),
  	        getPath(tractor, "Data.Telematics.Provisioning.FlespiDeviceId", "")
  	      ], "")
  	    );
  	  }

  	  function normaliseLogo(value) {
  	    let logo = clean(value);
  	    if (!logo) return "";

  	    if (/^<svg[\s>]/i.test(logo)) {
  	      return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(logo);
  	    }

  	    if (/^iVBORw0KGgo/.test(logo)) {
  	      return "data:image/png;base64," + logo;
  	    }

  	    if (
  	      /^data:image\//i.test(logo) ||
  	      /^https?:\/\//i.test(logo) ||
  	      /^blob:/i.test(logo)
  	    ) {
  	      return logo;
  	    }

  	    return "";
  	  }

  	  function formatNumber(value, digits) {
  	    const n = num(value);
  	    if (n === null) return "—";
  	    return n.toLocaleString(undefined, {
  	      minimumFractionDigits: digits || 0,
  	      maximumFractionDigits: digits || 0
  	    });
  	  }

  	  function formatDistance(km) {
  	    if (!Number.isFinite(km)) return "—";
  	    if (km < 1) return Math.round(km * 1000) + " m";
  	    return formatNumber(km, km < 10 ? 1 : 0) + " km";
  	  }

  	  function formatClock(seconds) {
  	    const sec = Math.max(0, Math.round(Number(seconds) || 0));
  	    const h = Math.floor(sec / 3600);
  	    const m = Math.floor((sec % 3600) / 60);
  	    if (h > 0) return h + "h " + m + "m";
  	    return m + "m";
  	  }

  	  function timestampSeconds(message) {
  	    const value = num(
  	      firstValue([
  	        getPath(message, "timestamp", null),
  	        getPath(message, "server.timestamp", null),
  	        getPath(message, "device.timestamp", null)
  	      ], null)
  	    );
  	    return value;
  	  }

  	  function timeAgo(timestampSec) {
  	    const ts = num(timestampSec);
  	    if (ts === null) return "No timestamp";

  	    const diff = Math.max(0, Math.round(Date.now() / 1000 - ts));
  	    if (diff < 30) return "Just now";
  	    if (diff < 60) return diff + " sec ago";
  	    if (diff < 3600) return Math.floor(diff / 60) + " min ago";
  	    if (diff < 86400) return Math.floor(diff / 3600) + " h ago";
  	    return Math.floor(diff / 86400) + " d ago";
  	  }

  	  function formatLocalTime(timestampSec) {
  	    const ts = num(timestampSec);
  	    if (ts === null) return "—";
  	    try {
  	      return new Date(ts * 1000).toLocaleString(undefined, {
  	        day: "2-digit",
  	        month: "short",
  	        hour: "2-digit",
  	        minute: "2-digit",
  	        second: "2-digit"
  	      });
  	    } catch (_) {
  	      return "—";
  	    }
  	  }

  	  function validPoint(message) {
  	    const lat = num(getPath(message, "position.latitude", null));
  	    const lng = num(getPath(message, "position.longitude", null));

  	    if (
  	      lat === null ||
  	      lng === null ||
  	      Math.abs(lat) > 90 ||
  	      Math.abs(lng) > 180 ||
  	      (lat === 0 && lng === 0)
  	    ) {
  	      return null;
  	    }

  	    return { lat: lat, lng: lng };
  	  }

  	  function speedOf(message) {
  	    return Math.max(
  	      0,
  	      num(
  	        firstValue([
  	          getPath(message, "position.speed", null),
  	          getPath(message, "can.vehicle.speed", null),
  	          getPath(message, "vehicle.speed", null)
  	        ], 0)
  	      ) || 0
  	    );
  	  }

  	  function headingOf(message) {
  	    const heading = num(
  	      firstValue([
  	        getPath(message, "position.direction", null),
  	        getPath(message, "position.heading", null),
  	        getPath(message, "vehicle.heading", null)
  	      ], 0)
  	    );
  	    return ((heading || 0) % 360 + 360) % 360;
  	  }

  	  function ignitionOf(message) {
  	    return bool(
  	      firstValue([
  	        getPath(message, "engine.ignition.status", null),
  	        getPath(message, "engine.ignition", null),
  	        getPath(message, "ignition.status", null)
  	      ], false)
  	    );
  	  }

  	  function movementOf(message) {
  	    const raw = firstValue([
  	      getPath(message, "movement.status", null),
  	      getPath(message, "position.movement.status", null)
  	    ], null);

  	    if (raw !== null && raw !== undefined && clean(raw) !== "") {
  	      return bool(raw);
  	    }

  	    return speedOf(message) > 2;
  	  }

  	  function haversineKm(a, b) {
  	    if (!a || !b) return 0;
  	    const R = 6371;
  	    const toRad = function (degrees) {
  	      return degrees * Math.PI / 180;
  	    };
  	    const dLat = toRad(b.lat - a.lat);
  	    const dLng = toRad(b.lng - a.lng);
  	    const lat1 = toRad(a.lat);
  	    const lat2 = toRad(b.lat);
  	    const sinLat = Math.sin(dLat / 2);
  	    const sinLng = Math.sin(dLng / 2);
  	    const x =
  	      sinLat * sinLat +
  	      Math.cos(lat1) * Math.cos(lat2) * sinLng * sinLng;
  	    return 2 * R * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  	  }

  	  function routeDistanceKm(points) {
  	    let total = 0;
  	    for (let i = 1; i < points.length; i += 1) {
  	      total += haversineKm(points[i - 1], points[i]);
  	    }
  	    return total;
  	  }

  	  function sampleEvenly(list, max) {
  	    if (!Array.isArray(list) || list.length <= max) return list.slice();

  	    const output = [];
  	    const lastIndex = list.length - 1;

  	    for (let i = 0; i < max; i += 1) {
  	      const index = Math.round((i / (max - 1)) * lastIndex);
  	      const item = list[index];
  	      if (!output.length || output[output.length - 1] !== item) {
  	        output.push(item);
  	      }
  	    }

  	    if (output[output.length - 1] !== list[lastIndex]) {
  	      output.push(list[lastIndex]);
  	    }

  	    return output;
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Runtime cleanup / duplicate mount protection
  	  // ---------------------------------------------------------------------------
  	  if (
  	    typeof window !== "undefined" &&
  	    window[RUNTIME_KEY] &&
  	    typeof window[RUNTIME_KEY].destroy === "function"
  	  ) {
  	    try {
  	      window[RUNTIME_KEY].destroy();
  	    } catch (_) {}
  	  }

  	  const state = {
  	    destroyed: false,
  	    mode: "live",
  	    historyMinutes: 60,
  	    companies: [],
  	    vehicles: [],
  	    selectedKey: "",
  	    liveByKey: Object.create(null),
  	    lastMovedByKey: Object.create(null),
  	    lastMovedResolvedByKey: Object.create(null),
  	    lastMovedPromiseByKey: Object.create(null),
  	    markerByKey: Object.create(null),
  	    pulseMarkerByKey: Object.create(null),
  	    pulseModeByKey: Object.create(null),
  	    pulseStartedByKey: Object.create(null),
  	    pulseAnimationFrame: null,
  	    fitDone: false,
  	    followSelected: false,
  	    liveTimer: null,
  	    countdownTimer: null,
  	    nextLiveAt: 0,
  	    liveBusy: false,
  	    historyBusy: false,
  	    historyRequestId: 0,
  	    maps: null,
  	    map: null,
  	    mapWrapper: null,
  	    mapHost: null,
  	    mapDiv: null,
  	    mapHostSnapshot: null,
  	    mapDivSnapshot: null,
  	    usingPassedMap: false,
  	    infoWindow: null,
  	    historyLayers: [],
  	    historyPoints: [],
  	    historyEvents: {},
  	    replayPoints: [],
  	    replayIndex: 0,
  	    replayTimer: null,
  	    replayMarker: null,
  	    historySelectionMarker: null,
  	    routeSummary: null,
  	    lastError: "",
  	    lastLiveSuccessAt: 0,
  	    visibilityHandler: null,
  	    pageHideHandler: null,
  	    markerLongPressTimer: null,
  	    markerLongPressVehicleKey: "",
  	    markerLongPressTriggered: false,
  	    vehicleActionInfoWindow: null,
  	    vehiclePickerOpen: false,
  	    appMenuOpen: false,
  	    appMenuUser: null,
  	    appMenuOutsideHandler: null,
  	    appMenuKeyHandler: null
  	  };

  	  function destroy() {
  	    if (state.destroyed) return;
  	    state.destroyed = true;

  	    if (state.liveTimer) clearTimeout(state.liveTimer);
  	    if (state.countdownTimer) clearInterval(state.countdownTimer);
  	    if (state.replayTimer) clearInterval(state.replayTimer);
  	    if (state.markerLongPressTimer) clearTimeout(state.markerLongPressTimer);
  	    state.markerLongPressTimer = null;

  	    try {
  	      if (
  	        state.vehicleActionInfoWindow &&
  	        typeof state.vehicleActionInfoWindow.close === "function"
  	      ) {
  	        state.vehicleActionInfoWindow.close();
  	      }
  	    } catch (_) {}
  	    state.vehicleActionInfoWindow = null;
  	    if (
  	      state.pulseAnimationFrame &&
  	      typeof cancelAnimationFrame === "function"
  	    ) {
  	      cancelAnimationFrame(state.pulseAnimationFrame);
  	      state.pulseAnimationFrame = null;
  	    }

  	    Object.keys(state.pulseMarkerByKey).forEach(function (key) {
  	      try {
  	        const pulse = state.pulseMarkerByKey[key];
  	        if (pulse && typeof pulse.setMap === "function") {
  	          pulse.setMap(null);
  	        }
  	      } catch (_) {}
  	    });
  	    state.pulseMarkerByKey = Object.create(null);
  	    state.pulseModeByKey = Object.create(null);
  	    state.pulseStartedByKey = Object.create(null);

  	    state.historyLayers.forEach(function (layer) {
  	      try {
  	        if (layer && typeof layer.setMap === "function") layer.setMap(null);
  	      } catch (_) {}
  	    });

  	    Object.keys(state.markerByKey).forEach(function (key) {
  	      try {
  	        state.markerByKey[key].setMap(null);
  	      } catch (_) {}
  	    });

  	    try {
  	      if (state.replayMarker) state.replayMarker.setMap(null);
  	    } catch (_) {}

  	    try {
  	      if (state.historySelectionMarker) {
  	        state.historySelectionMarker.setMap(null);
  	        state.historySelectionMarker = null;
  	      }
  	    } catch (_) {}

  	    /*
  	     * We never destroy the Backendless Map component itself. Restore only the
  	     * inline styles/classes that Mobile Tracking temporarily changed.
  	     */
  	    try {
  	      if (state.mapHost && state.mapHostSnapshot) {
  	        state.mapHost.style.cssText = state.mapHostSnapshot.cssText;
  	        state.mapHost.className = state.mapHostSnapshot.className;
  	      }
  	      if (
  	        state.mapDiv &&
  	        state.mapDiv !== state.mapHost &&
  	        state.mapDivSnapshot
  	      ) {
  	        state.mapDiv.style.cssText = state.mapDivSnapshot.cssText;
  	        state.mapDiv.className = state.mapDivSnapshot.className;
  	      }
  	    } catch (_) {}

  	    if (state.visibilityHandler) {
  	      document.removeEventListener("visibilitychange", state.visibilityHandler);
  	    }

  	    if (state.pageHideHandler) {
  	      window.removeEventListener("pagehide", state.pageHideHandler);
  	    }

  	    if (state.appMenuOutsideHandler) {
  	      document.removeEventListener(
  	        "pointerdown",
  	        state.appMenuOutsideHandler,
  	        true
  	      );
  	      state.appMenuOutsideHandler = null;
  	    }

  	    if (state.appMenuKeyHandler) {
  	      document.removeEventListener(
  	        "keydown",
  	        state.appMenuKeyHandler,
  	        true
  	      );
  	      state.appMenuKeyHandler = null;
  	    }

  	    const root = document.getElementById(ROOT_ID);
  	    if (root) root.remove();

  	    const style = document.getElementById(STYLE_ID);
  	    if (style) style.remove();

  	    [
  	      "trackit-compact-map-control-css",
  	      "trackit-google-info-window-padding-css",
  	      "fif-mobile-track-map-control-override"
  	    ].forEach(function (styleId) {
  	      try {
  	        const node = document.getElementById(styleId);
  	        if (node) node.remove();
  	      } catch (_) {}
  	    });

  	    if (typeof window !== "undefined" && window[RUNTIME_KEY]) {
  	      delete window[RUNTIME_KEY];
  	    }
  	  }

  	  if (typeof window !== "undefined") {
  	    window[RUNTIME_KEY] = {
  	      version: VERSION,
  	      destroy: destroy,
  	      refresh: function () {
  	        if (state.mode === "live") return refreshLive(true);
  	        return loadHistory(state.historyMinutes);
  	      }
  	    };
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Data discovery
  	  // ---------------------------------------------------------------------------
  	  function loadVehicleDirectory() {
  	    const data = appBag();

  	    const companies = arr(
  	      firstValue([
  	        getPath(data, "User.Companies", null),
  	        data && data.Companies
  	      ], [])
  	    );

  	    const seen = Object.create(null);
  	    const vehicles = [];

  	    companies.forEach(function (company, companyIndex) {
  	      arr(company && company.Tractors).forEach(function (tractor, tractorIndex) {
  	        if (!tractor || typeof tractor !== "object") return;

  	        const tracker = trackerId(tractor);
  	        if (!tracker) return;

  	        const key =
  	          tracker ||
  	          objectIdOf(tractor) ||
  	          vehicleRegistration(tractor) ||
  	          String(companyIndex) + ":" + String(tractorIndex);

  	        if (seen[key]) return;
  	        seen[key] = true;

  	        vehicles.push({
  	          key: key,
  	          tracker: tracker,
  	          tractor: tractor,
  	          company: company,
  	          registration: vehicleRegistration(tractor),
  	          subtitle: vehicleSubtitle(tractor),
  	          color: vehicleColor(tractor)
  	        });
  	      });
  	    });

  	    state.companies = companies;
  	    state.vehicles = vehicles;

  	    if (
  	      !state.selectedKey ||
  	      !vehicles.some(function (vehicle) {
  	        return vehicle.key === state.selectedKey;
  	      })
  	    ) {
  	      state.selectedKey = vehicles.length ? vehicles[0].key : "";
  	    }
  	  }

  	  function selectedVehicle() {
  	    return state.vehicles.find(function (vehicle) {
  	      return vehicle.key === state.selectedKey;
  	    }) || null;
  	  }

  	  function vehicleByTracker(id) {
  	    const wanted = clean(id);
  	    if (!wanted) return null;
  	    return state.vehicles.find(function (vehicle) {
  	      return vehicle.tracker === wanted;
  	    }) || null;
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Flespi transport
  	  // ---------------------------------------------------------------------------
  	  function resolveFlespiAuth() {
  	    const data = appBag();
  	    let token = clean(
  	      firstValue([
  	        getPath(data, "FlespiToken", ""),
  	        getPath(data, "Tracking.FlespiToken", ""),
  	        getPath(data, "Config.FlespiToken", ""),
  	        getPath(data, "Settings.FlespiToken", ""),
  	        App && App.FlespiToken
  	      ], "")
  	    );

  	    if (!token) token = LEGACY_FLESPI_AUTH;
  	    if (!token) return "";

  	    return /^FlespiToken\s+/i.test(token)
  	      ? token
  	      : "FlespiToken " + token;
  	  }

  	  function buildFlespiUrl(path, payload) {
  	    return (
  	      "https://flespi.io/gw/" +
  	      path +
  	      "?data=" +
  	      encodeURIComponent(JSON.stringify(payload || {}))
  	    );
  	  }

  	  async function flespiGet(path, payload) {
  	    const auth = resolveFlespiAuth();
  	    if (!auth) throw new Error("Flespi authorization is not configured.");

  	    const response = await fetch(buildFlespiUrl(path, payload), {
  	      method: "GET",
  	      headers: {
  	        "Content-Type": "application/json",
  	        "Authorization": auth
  	      }
  	    });

  	    if (!response.ok) {
  	      const detail = clean(await response.text().catch(function () {
  	        return "";
  	      }));
  	      throw new Error(
  	        "Flespi request failed (" +
  	        response.status +
  	        ")" +
  	        (detail ? ": " + detail.slice(0, 180) : ".")
  	      );
  	    }

  	    return await response.json();
  	  }

  	  function normaliseResultList(body) {
  	    if (!body) return [];
  	    if (Array.isArray(body)) return body;

  	    const candidates = [
  	      body.result,
  	      body.results,
  	      body.messages,
  	      body.items,
  	      body.data && body.data.result,
  	      body.responses && body.responses[0] && body.responses[0].result,
  	      body.responses && body.responses[0] && body.responses[0].messages
  	    ];

  	    for (let i = 0; i < candidates.length; i += 1) {
  	      if (Array.isArray(candidates[i])) return candidates[i];
  	    }

  	    return [];
  	  }

  	  async function fetchLatest() {
  	    const ids = state.vehicles
  	      .map(function (vehicle) { return vehicle.tracker; })
  	      .filter(Boolean);

  	    if (!ids.length) return [];

  	    const body = await flespiGet(
  	      "devices/" + ids.join(",") + "/messages",
  	      { count: 1, reverse: true }
  	    );

  	    return normaliseResultList(body);
  	  }

  	  function messageShowsMovement(message) {
  	    if (!message) return false;
  	    return movementOf(message) || speedOf(message) > 2;
  	  }

  	  async function resolveLastMoved(vehicle, force) {
  	    if (!vehicle || !vehicle.key || !vehicle.tracker) return null;

  	    const key = vehicle.key;
  	    const current = state.liveByKey[key];

  	    /*
  	     * A currently moving vehicle gives us an exact answer without a second
  	     * Flespi request.
  	     */
  	    if (current && messageShowsMovement(current)) {
  	      const movedAt = timestampSeconds(current);
  	      if (movedAt !== null) {
  	        state.lastMovedByKey[key] = movedAt;
  	        state.lastMovedResolvedByKey[key] = true;
  	        return movedAt;
  	      }
  	    }

  	    if (!force && state.lastMovedResolvedByKey[key]) {
  	      return state.lastMovedByKey[key] || null;
  	    }

  	    if (state.lastMovedPromiseByKey[key]) {
  	      return state.lastMovedPromiseByKey[key];
  	    }

  	    state.lastMovedPromiseByKey[key] = (async function () {
  	      try {
  	        /*
  	         * Reverse lookup only for the selected vehicle. 1,000 lightweight
  	         * messages normally spans far beyond the periods in which movement is
  	         * relevant, without multiplying the live fleet request by 28 vehicles.
  	         */
  	        const body = await flespiGet(
  	          "devices/" + vehicle.tracker + "/messages",
  	          {
  	            count: 1000,
  	            reverse: true,
  	            fields: [
  	              "timestamp",
  	              "server.timestamp",
  	              "movement.status",
  	              "position.speed"
  	            ].join(",")
  	          }
  	        );

  	        const rows = normaliseResultList(body);

  	        for (let index = 0; index < rows.length; index += 1) {
  	          const row = rows[index];
  	          if (!messageShowsMovement(row)) continue;

  	          const movedAt = timestampSeconds(row);
  	          if (movedAt === null) continue;

  	          state.lastMovedByKey[key] = movedAt;
  	          state.lastMovedResolvedByKey[key] = true;
  	          return movedAt;
  	        }

  	        /*
  	         * If Flespi has no movement sample in the returned window, do not call
  	         * the latest telemetry time "movement". Leave the value unknown.
  	         */
  	        state.lastMovedByKey[key] = null;
  	        state.lastMovedResolvedByKey[key] = true;
  	        return null;
  	      } catch (_) {
  	        /*
  	         * Tracking itself remains usable if this convenience lookup fails.
  	         * Do not mark it resolved so another selection can retry later.
  	         */
  	        return state.lastMovedByKey[key] || null;
  	      } finally {
  	        delete state.lastMovedPromiseByKey[key];

  	        if (
  	          state.mode === "live" &&
  	          state.selectedKey === key
  	        ) {
  	          renderSummaryCard();
  	        }
  	      }
  	    })();

  	    return state.lastMovedPromiseByKey[key];
  	  }

  	  function resolveSelectedLastMoved() {
  	    const vehicle = selectedVehicle();
  	    if (!vehicle || state.mode !== "live") return;

  	    /*
  	     * Fire-and-forget: live map rendering must never wait on the deeper
  	     * historical movement lookup.
  	     */
  	    resolveLastMoved(vehicle, false).catch(function () {});
  	  }

  	  async function runCanonicalCanEventEngine(Tractor, CAN, Locations, AppData) {
  	  // ---------- tiny utils ----------
  	  const isObj = v => v && typeof v === 'object';
  	  const own = (o, k) => Object.prototype.hasOwnProperty.call(o, k);
  	  const toNum = v => {
  	    const n = Number(v); return Number.isFinite(n) ? n: null;
  	  };
  	  const toBool = v => {
  	    if (typeof v === 'boolean') return v;
  	    if (v === 1 || v === 0) return !!v;
  	    if (typeof v === 'string') {
  	      const s = v.trim().toLowerCase(); if (s === 'true')return true; if (s === 'false')return false;
  	    }
  	    return !!v;
  	  };
  	  const byPath = (obj, dot) => {
  	    if (!obj || dot == null) return undefined;
  	    const key = String(dot);
  	    if (own(obj, key)) return obj[key]; // allow literal dotted keys
  	    let cur = obj;
  	    for (const seg of key.split('.')) {
  	      if (cur == null) return undefined; cur = cur[seg];
  	    }
  	    return cur;
  	  };
  	  // JSON Pointer reader (supports ~0/~1 unescape)
  	  function getByPointer(root, pointer) {
  	    if (!root || pointer == null) return undefined;
  	    const unescape = s => s.replace(/~1/g, '/').replace(/~0/g, '~');
  	    const parts = String(pointer).split('/').filter(Boolean).map(unescape);
  	    let cur = root;
  	    for (const key of parts) {
  	      if (cur == null) return undefined; cur = cur[key];
  	    }
  	    return cur;
  	  }
  	  // Universal ref resolver: accepts {"$ref":"#/A/B"}, "#/A/B", "A.B", "A/B", primitives
  	  const resolveRef = (root, ref) => {
  	    if (ref == null) return undefined;
  	    if (typeof ref === 'object' && ref.$ref != null) {
  	      const p = String(ref.$ref);
  	      if (p.startsWith('#/')) return getByPointer(root, p.slice(2));
  	      if (p.startsWith('#.')) return byPath(root, p.slice(2));
  	      return p.includes('/') ? getByPointer(root, p): byPath(root, p);
  	    }
  	    if (typeof ref === 'string') {
  	      if (ref.startsWith('#/')) return getByPointer(root, ref.slice(2));
  	      if (ref.startsWith('#.')) return byPath(root, ref.slice(2));
  	      return ref.includes('/') ? getByPointer(root, ref): byPath(root, ref);
  	    }
  	    return ref; // primitive
  	  };
  	  const normTsMs = (t) => {
  	    const n = toNum(t); if (n == null) return null; return n < 1e11 ? n*1000: n;
  	  };

  	  // Seconds-first duration readers with backward compatibility for old *_ms keys
  	  const readSeconds = (primarySec, legacyMs, fallbackSec = 0) => {
  	    const sec = toNum(primarySec);
  	    if (sec != null) return sec;

  	    const ms = toNum(legacyMs);
  	    if (ms != null) return ms / 1000;

  	    return fallbackSec;
  	  };

  	  const readWindowSeconds = (spec, fallbackSec = 0) => {
  	    if (!isObj(spec)) return fallbackSec;

  	    const sec =
  	    toNum(spec.s) ??
  	    toNum(spec.sec) ??
  	    toNum(spec.seconds);

  	    if (sec != null) return sec;

  	    const ms = toNum(spec.ms);
  	    if (ms != null) return ms / 1000;

  	    return fallbackSec;
  	  };

  	  const haversineM = (lat1, lon1, lat2, lon2) => {
  	    if (![lat1, lon1, lat2, lon2].every(Number.isFinite)) return 0;
  	    const R = 6371000,
  	    toRad = d => d*Math.PI/180;
  	    const dLat = toRad(lat2-lat1),
  	    dLon = toRad(lon2-lon1);
  	    const a = Math.sin(dLat/2)**2 + Math.cos(toRad(lat1))*Math.cos(toRad(lat2))*Math.sin(dLon/2)**2;
  	    return 2*R*Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  	  };

  	  // ---------- guard ----------
  	  if (!isObj(CAN) || !Array.isArray(CAN.Events)) {
  	    return {
  	      ok: false,
  	      error: 'CAN.Events[] missing or invalid',
  	      events: {},
  	      stats: {
  	        eventsDefined: 0,
  	        logsCount: 0
  	      },
  	      debug: {},
  	      errors: ['Schema']
  	    };
  	  }

  	  // ---------- discover logs ----------
  	  const discoverLogs = (tractor) => {
  	    if (!isObj(tractor)) return [];
  	    const candidates = ['Logs',
  	      'Tracking',
  	      'History',
  	      'LocationHistory',
  	      'track',
  	      'telemetry',
  	      'data',
  	      'items'];
  	    for (const p of candidates) {
  	      const v = byPath(tractor, p);
  	      if (Array.isArray(v) && v.length) return v.slice();
  	    }
  	    return [];
  	  };
  	  let logs = discoverLogs(Tractor);

  	  // ---------- stream keys ----------
  	  const latKey = resolveRef(CAN, '#/Stream/lat') || 'position.latitude';
  	  const lonKey = resolveRef(CAN, '#/Stream/lon') || 'position.longitude';
  	  const tsKey = resolveRef(CAN, '#/Stream/timestamp') || 'timestamp';
  	  const odoKey = resolveRef(CAN, '#/Stream/odometer_km') || null;
  	  const speedKey = resolveRef(CAN, '#/Stream/speed') || 'position.speed';
  	  const fbSpeedKey = resolveRef(CAN, '#/Stream/fallback_speed') || null;

  	  const tractorIdleLimitSec =
  	  toNum(byPath(Tractor, 'CAN.Idle')) ??
  	  toNum(byPath(Tractor, 'CAN.idle')) ??
  	  toNum(byPath(Tractor, 'CAN.Engine.Idle')) ??
  	  toNum(byPath(Tractor, 'CAN.Engine.idle')) ??
  	  toNum(resolveRef(CAN, '#/Idle')) ??
  	  toNum(resolveRef(CAN, '#/idle')) ??
  	  0;

  	  // ---------- prep logs ----------
  	  logs = logs
  	  .map(r => {
  	    const ts = normTsMs(byPath(r, tsKey));
  	    const lat = toNum(byPath(r, latKey));
  	    const lon = toNum(byPath(r, lonKey));
  	    let spd = toNum(byPath(r, speedKey));
  	    if (spd == null && fbSpeedKey) spd = toNum(byPath(r, fbSpeedKey));
  	    const odoKm = odoKey ? toNum(byPath(r, odoKey)): null;
  	    return {
  	      ...r,
  	      __ts: ts,
  	      __lat: lat,
  	      __lon: lon,
  	      __spd: spd,
  	      __odoKm: odoKm,
  	      __derived: {}
  	    };
  	  })
  	  .filter(r => r.__ts != null)
  	  .sort((a, b) => a.__ts - b.__ts);

  	  // ---------- derived drift (10s) ----------
  	  const DRIFT_WINDOW_S = 10;
  	  const DRIFT_WINDOW_MS = DRIFT_WINDOW_S * 1000;
  	  {
  	    let q = [];
  	    for (const r of logs) {
  	      q.push(r);
  	      while (q.length && (r.__ts - q[0].__ts) > DRIFT_WINDOW_MS) q.shift();
  	      let gpsM = 0,
  	      speedM = 0;
  	      for (let i = 1; i < q.length; i++) {
  	        const a = q[i-1],
  	        b = q[i];
  	        const dt = (b.__ts - a.__ts)/1000;
  	        gpsM += haversineM(a.__lat??NaN, a.__lon??NaN, b.__lat??NaN, b.__lon??NaN);
  	        const s = toNum(a.__spd) ?? 0; // km/h
  	        speedM += (s/3.6) * dt;
  	      }
  	      const drift_mps = Math.max(0, (speedM - gpsM) / Math.max(1, (q[q.length-1].__ts - q[0].__ts)/1000));
  	      r.__derived['drift.kph_10s'] = drift_mps * 3.6;
  	    }
  	  }

  	  // ---------- signal functions ----------
  	  const valueFns = {
  	    value: (row, spec) => spec.field != null ? byPath(row, spec.field): undefined,
  	    abs: (row, spec) => {
  	      const v = valueFns.value(row, spec); const n = toNum(v); return n == null?null: Math.abs(n);
  	    },
  	    any: (row, spec) => (spec.fields || []).some(f => toBool(byPath(row, f))),
  	    both: (row, spec) => {
  	      const A = spec.a?.field ? byPath(row, spec.a.field): undefined;
  	      const B = spec.b?.field ? byPath(row, spec.b.field): undefined;
  	      const op = spec.op || 'and'; const trig = spec.trigger;
  	      switch (op) {
  	        case 'and': return toBool(A) && toBool(B);
  	        case 'and_not_b': return toBool(A) && !toBool(B);
  	        case 'both_false': return !toBool(A) && !toBool(B);
  	        case 'not_a_and_b_gt': {
  	            const n = toNum(B); const t = toNum(resolveRef(CAN, trig) ?? trig);
  	            return !toBool(A) && n != null && t != null && n > t;
  	          }
  	        default: return toBool(A) && toBool(B);
  	      }
  	    },
  	    rate: (row, spec, ctx) => {
  	      const lookSec = readWindowSeconds(spec.lookback, 60);
  	      const lookMs = lookSec * 1000;
  	      const i = ctx.idx,
  	      baseTs = row.__ts; let j = i;
  	      while (j > 0 && (baseTs - ctx.logs[j-1].__ts) <= lookMs) j--;
  	      const first = ctx.logs[j],
  	      last = row;
  	      const vFirst = toNum(byPath(first, spec.field)); const vLast = toNum(byPath(last, spec.field));
  	      if (vFirst == null || vLast == null) return null;
  	      const dtSec = Math.max(1, (last.__ts - first.__ts)/1000);
  	      return (vLast - vFirst) * (60 / dtSec); // per minute
  	    },
  	    delta: (row, spec, ctx) => {
  	      const lookSamples = spec.lookback?.samples ?? null;
  	      const lookSec = readWindowSeconds(spec.lookback, null);
  	      const lookMs = lookSec != null ? lookSec * 1000: null;
  	      const i = ctx.idx; let j = i; let count = 0; const tNow = row.__ts;
  	      while (j > 0 && ((lookSamples != null ? count < lookSamples: true) && (lookMs != null ? (tNow - ctx.logs[j-1].__ts) <= lookMs: true))) {
  	        j--; count++;
  	      }
  	      const first = ctx.logs[j],
  	      last = row;
  	      const a = toNum(byPath(first, spec.field)),
  	      b = toNum(byPath(last, spec.field));
  	      if (a == null || b == null) return null;
  	      let d = b - a;
  	      const dir = (spec.direction || 'either').toLowerCase();
  	      if (dir === 'drop') d = Math.min(0, d) * -1;
  	      if (dir === 'rise') d = Math.max(0, d);
  	      if (isObj(spec.transform) && spec.transform.to === 'liters') {
  	        const cap = toNum(resolveRef(CAN, spec.transform.capacityRef));
  	        if (cap != null && a <= 100 && b <= 100) d = (Math.abs(b - a) / 100) * cap;
  	      }
  	      return Math.abs(d);
  	    },
  	    jitter: (row, spec, ctx) => {
  	      const lookSec = readWindowSeconds(spec.lookback, 120);
  	      const lookMs = lookSec * 1000;
  	      const i = ctx.idx; let j = i; const tNow = row.__ts; let lo=+Infinity,
  	      hi=-Infinity;
  	      while (j >= 0 && (tNow - ctx.logs[j].__ts) <= lookMs) {
  	        const v = toNum(byPath(ctx.logs[j], spec.field));
  	        if (v != null) {
  	          if (v < lo) lo = v; if (v > hi) hi = v;
  	        }
  	        j--;
  	      }
  	      return (hi>-Infinity && lo<+Infinity) ? (hi - lo): null;
  	    },
  	    edge: (row, spec, ctx) => {
  	      if (ctx.idx === 0) return false; const prev = ctx.logs[ctx.idx-1]; return byPath(prev, spec.field) !== byPath(row, spec.field);
  	    },
  	    edge_any: (row, spec, ctx) => {
  	      if (ctx.idx === 0) return false; const prev = ctx.logs[ctx.idx-1]; return (spec.fields || []).some(f => byPath(prev, f) !== byPath(row, f));
  	    },
  	    edge_count: (row, spec, ctx) => {
  	      const lookSec = readWindowSeconds(spec.lookback, 10);
  	      const lookMs = lookSec * 1000; const tNow = row.__ts; let count = 0;
  	      for (let j = ctx.idx; j > 0 && (tNow - ctx.logs[j-1].__ts) <= lookMs; j--) {
  	        const a = byPath(ctx.logs[j], spec.field),
  	        b = byPath(ctx.logs[j-1], spec.field);
  	        if (a !== b) count++;
  	      }
  	      return count;
  	    },
  	    drift: (row, spec) => row.__derived['drift.kph_10s'] ?? 0
  	  };

  	  // ---------- comparators / tests ----------
  	  const opTest = {
  	    '>': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) > toNum(t),
  	    '>=': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) >= toNum(t),
  	    '<': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) < toNum(t),
  	    '<=': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) <= toNum(t),
  	    '==': (v, t) => v === t,
  	    '!=': (v, t) => v !== t,
  	    'truthy': v => toBool(v),
  	    'falsy': v => !toBool(v),
  	    'between': (v, t) => {
  	      const lo = toNum(t?.lo),
  	      hi = toNum(t?.hi),
  	      n = toNum(v); return n != null && lo != null && hi != null && n >= lo && n <= hi;
  	    },
  	    'cycles': (v, t) => {
  	      const n = toNum(v),
  	      thr = toNum(t); return n != null && thr != null && n >= thr;
  	    },
  	    'time_between': (row, t, localField = 'localtime') => {
  	      const lo = String(t?.lo || '00:00'),
  	      hi = String(t?.hi || '23:59');
  	      const ts = normTsMs(byPath(row, localField) ?? row.__ts); if (ts == null) return false;
  	      const d = new Date(ts),
  	      hh = String(d.getHours()).padStart(2, '0'),
  	      mm = String(d.getMinutes()).padStart(2, '0'),
  	      cur = `${hh}:${mm}`;
  	      return (lo <= hi) ? (cur >= lo && cur <= hi): (cur >= lo || cur <= hi); // midnight wrap
  	    },
  	    'truthy_any': (row, t) => (t?.fields || []).some(f => toBool(byPath(row, f))),
  	    'falsy_any': (row, t) => (t?.fields || []).some(f => !toBool(byPath(row, f))),
  	  };

  	  // ---------- gates ----------
  	  function mergeGateDefaults(gates, defaults) {
  	    if (isObj(gates) && gates.disable_defaults === true) {
  	      if (!Array.isArray(gates.requireAll) && !Array.isArray(gates.requireAny)) return null;

  	      return {
  	        requireAll: Array.isArray(gates.requireAll) ? [...gates.requireAll] : [],
  	        requireAny: Array.isArray(gates.requireAny) ? [...gates.requireAny] : []
  	      };
  	    }

  	    if (!defaults && !gates) return null;

  	    const out = {
  	      requireAll: [],
  	      requireAny: []
  	    };

  	    if (isObj(defaults)) {
  	      if (Array.isArray(defaults.requireAll)) out.requireAll.push(...defaults.requireAll);
  	      if (Array.isArray(defaults.requireAny)) out.requireAny.push(...defaults.requireAny);
  	    }

  	    if (isObj(gates)) {
  	      if (Array.isArray(gates.requireAll)) out.requireAll.push(...gates.requireAll);
  	      if (Array.isArray(gates.requireAny)) out.requireAny.push(...gates.requireAny);
  	    }

  	    return out;
  	  }
  	  function gatesPass(row, gates) {
  	    const EngCfg = CAN.Engine || {};
  	    const merged = mergeGateDefaults(gates, EngCfg.gates_defaults);
  	    if (!merged) return true;
  	    const check = (g) => {
  	      const op = (g?.op || 'truthy').toLowerCase();
  	      if (op === 'time_between') {
  	        return opTest['time_between'](row, {
  	          lo: resolveRef(CAN, g.lo), hi: resolveRef(CAN, g.hi)
  	        }, g.field || 'localtime');
  	      }
  	      if (op === 'truthy_any' || op === 'falsy_any') {
  	        return opTest[op](row, {
  	          fields: g.fields || []
  	        });
  	      }
  	      const v = g.field != null ? byPath(row, g.field): undefined;
  	      const trig = resolveRef(CAN, g.trigger) ?? g.trigger;
  	      const fn = opTest[op] || (()=>false);
  	      return fn(v, trig);
  	    };
  	    if (Array.isArray(merged.requireAll) && merged.requireAll.length) {
  	      for (const g of merged.requireAll) {
  	        if (!check(g)) return false;
  	      }
  	    }
  	    if (Array.isArray(merged.requireAny) && merged.requireAny.length) {
  	      let any = false; for (const g of merged.requireAny) {
  	        if (check(g)) {
  	          any = true; break;
  	        }
  	      }
  	      if (!any) return false;
  	    }
  	    return true;
  	  }

  	  // ---------- segmentation helpers ----------
  	  const includeFullPoint = !!resolveRef(CAN, '#/Engine/points/include_full_point');

  	  const pushPoint = (ctx, row, val) => {
  	    if (ctx.firstTs == null) ctx.firstTs = row.__ts;
  	    if (ctx.prevLat == null) ctx.prevLat = row.__lat ?? null;
  	    if (ctx.prevLon == null) ctx.prevLon = row.__lon ?? null;

  	    const rawPointTs = byPath(row, 'timestamp');
  	    const rawPointTsNum = toNum(rawPointTs);
  	    const pointTsSec = rawPointTsNum != null
  	    ? Math.floor(rawPointTsNum): Math.floor(Number(row.__ts) / 1000);

  	    const pt = {
  	      timestamp: pointTsSec,
  	      value: val,
  	      lat: Number.isFinite(row.__lat) ? row.__lat: undefined,
  	      lon: Number.isFinite(row.__lon) ? row.__lon: undefined
  	    };
  	    if (includeFullPoint) pt.point = row;

  	    ctx.curPts.push(pt);
  	    ctx.lastTs = row.__ts;
  	  };

  	  const stepDistance = (ctx, row, prevRow) => {
  	    if (row.__odoKm != null && prevRow?.__odoKm != null) {
  	      ctx.distM += Math.max(0, (row.__odoKm - prevRow.__odoKm)) * 1000;
  	    } else if (
  	      Number.isFinite(ctx.prevLat) && Number.isFinite(ctx.prevLon) &&
  	      Number.isFinite(row.__lat) && Number.isFinite(row.__lon)
  	    ) {
  	      ctx.distM += haversineM(ctx.prevLat, ctx.prevLon, row.__lat, row.__lon);
  	    }
  	    ctx.prevLat = row.__lat ?? ctx.prevLat;
  	    ctx.prevLon = row.__lon ?? ctx.prevLon;
  	    ctx.lastTs = row.__ts;
  	  };

  	  const resetSeg = (ctx) => {
  	    ctx.curPts = [];
  	    ctx.aggSum = 0;
  	    ctx.aggMax = -Infinity;
  	    ctx.aggCount = 0;
  	    ctx.firstTs = null;
  	    ctx.lastTs = null;
  	    ctx.distM = 0;
  	    ctx.prevLat = null;
  	    ctx.prevLon = null;
  	    ctx.startVal = null;
  	    ctx.lastVal = null;
  	    ctx.maxIdleTotal = null;
  	    ctx.maxIdlePoint = null;
  	  };
  	  const flushSeg = (ctx, debugMap) => {
  	    if (!ctx.curPts.length) return;

  	    const durMs = Math.max(0, (ctx.lastTs ?? ctx.firstTs) - (ctx.firstTs ?? ctx.lastTs));
  	    // Idle duration comes from Flespi's cumulative counter, not from the span
  	    // between received packets. A single packet can therefore be a valid idle.
  	    if (ctx.ruleName !== "Idle Event" && durMs < (ctx.minDurMs || 0)) {
  	      if (debugMap) debugMap.discardedShort++;
  	      return resetSeg(ctx);
  	    }

  	    if (ctx.ruleName === "Idle Event") {
  	      const finalIdleSec = toNum(ctx.maxIdleTotal);

  	      if (finalIdleSec == null || finalIdleSec < (ctx.idleLimitSec || 0)) {
  	        if (debugMap) debugMap.discardedShort++;
  	        return resetSeg(ctx);
  	      }

  	      const startTs = (ctx.curPts && ctx.curPts.length && ctx.curPts[0])
  	      ? ctx.curPts[0].timestamp: null;
  	      const maxPoint = ctx.maxIdlePoint ||
  	        ((ctx.curPts && ctx.curPts.length) ? ctx.curPts[ctx.curPts.length - 1] : null);

  	      ctx.segments.push({
  	        start: startTs,
  	        start_iso: startTs ? new Date(startTs * 1000).toISOString(): null,

  	        idle_seconds: Math.round(finalIdleSec),
  	        idle_human: (() => {
  	          var s = Math.round(finalIdleSec);
  	          var h = Math.floor(s / 3600);
  	          var m = Math.floor((s % 3600) / 60);
  	          var sec = s % 60;

  	          var out = [];
  	          if (h > 0) out.push(h + "h");
  	          if (m > 0 || h > 0) out.push(m + "m");
  	          out.push(sec + "s");

  	          return out.join(" ");
  	        })(),

  	        // One marker per Flespi idle event: only the point carrying the
  	        // highest idle.total value is returned.
  	        Points: maxPoint ? [maxPoint] : []
  	      });

  	      return resetSeg(ctx);
  	    }

  	    // --- Custom flush for Fuel Gain/Loss
  	    if (ctx.ruleName === "Fuel Gain (Refuel)" || ctx.ruleName === "Fuel Loss") {
  	      if (ctx.curPts.length) {
  	        const lastPt = ctx.curPts[ctx.curPts.length - 1];
  	        if (ctx.lastVal == null && lastPt?.value != null) ctx.lastVal = lastPt.value;
  	      }

  	      ctx.segments.push({
  	        distance: Math.round(ctx.distM * 1000) / 1000,
  	        duration: Math.round((durMs / 1000) * 1000) / 1000,
  	        ChangeL: Math.round(((ctx.lastVal ?? 0) - (ctx.startVal ?? 0)) * 1000) / 1000,
  	        Points: ctx.curPts
  	      });
  	    } else {
  	      ctx.segments.push({
  	        distance: Math.round(ctx.distM * 1000) / 1000,
  	        duration: Math.round((durMs / 1000) * 1000) / 1000,
  	        AVG: ctx.aggCount ? (ctx.aggSum / ctx.aggCount): null,
  	        Max: ctx.aggMax > -Infinity ? ctx.aggMax: null,
  	        Points: ctx.curPts
  	      });
  	    }

  	    resetSeg(ctx);
  	  };

  	  const EngCfg = CAN.Engine || {};
  	  const stabDefaults = EngCfg.stability_defaults || {};

  	  // ---------- dedicated Flespi idle event reader ----------
  	  // Flespi has already decided whether the vehicle is idling. Its idle.total
  	  // value is a cumulative counter for the CURRENT idle interval. This reader
  	  // therefore does not recalculate idle from speed, RPM, ignition or packet
  	  // type. BLE and CAN packets are both valid carrier packets for Flespi state.
  	  function buildFlespiIdleEvents(sourceLogs, rule, idleLimitSec) {
  	    const cfg = isObj(rule?.flespi_idle) ? rule.flespi_idle : {};
  	    const stateFields = Array.isArray(cfg.state_fields) && cfg.state_fields.length
  	      ? cfg.state_fields
  	      : ['idle.status', 'idle'];
  	    const counterFields = Array.isArray(cfg.counter_fields) && cfg.counter_fields.length
  	      ? cfg.counter_fields
  	      : ['idle.total', 'totalidle'];
  	    const resetDropSec = Math.max(0, toNum(cfg.reset_drop_s) ?? 1);

  	    const readFirstDefined = (row, fields) => {
  	      for (const field of fields) {
  	        const value = byPath(row, field);
  	        if (value !== undefined && value !== null) return value;
  	      }
  	      return undefined;
  	    };

  	    const readCounter = (row) => {
  	      for (const field of counterFields) {
  	        const n = toNum(byPath(row, field));
  	        if (n != null) return n;
  	      }
  	      return null;
  	    };

  	    const makeIdlePoint = (row, value) => {
  	      const rawTs = toNum(byPath(row, tsKey));
  	      const tsSec = rawTs != null
  	        ? rawTs
  	        : Number(row.__ts) / 1000;

  	      const pt = {
  	        timestamp: tsSec,
  	        value,
  	        lat: Number.isFinite(row.__lat) ? row.__lat : undefined,
  	        lon: Number.isFinite(row.__lon) ? row.__lon : undefined
  	      };
  	      if (includeFullPoint) pt.point = row;
  	      return pt;
  	    };

  	    const humanDuration = (seconds) => {
  	      let s = Math.round(seconds);
  	      const h = Math.floor(s / 3600);
  	      const m = Math.floor((s % 3600) / 60);
  	      s %= 60;
  	      const out = [];
  	      if (h > 0) out.push(h + 'h');
  	      if (m > 0 || h > 0) out.push(m + 'm');
  	      out.push(s + 's');
  	      return out.join(' ');
  	    };

  	    const segments = [];
  	    const stats = {
  	      stateTrueRows: 0,
  	      counterRows: 0,
  	      counterResets: 0,
  	      discardedShort: 0
  	    };

  	    let active = null;

  	    const startActive = (row, counter) => {
  	      active = {
  	        firstRowTsSec: Number(row.__ts) / 1000,
  	        lastCounter: counter,
  	        maxCounter: null,
  	        maxPoint: null
  	      };
  	    };

  	    const updateActive = (row, counter) => {
  	      if (counter == null) return;
  	      stats.counterRows++;
  	      active.lastCounter = counter;
  	      if (active.maxCounter == null || counter >= active.maxCounter) {
  	        active.maxCounter = counter;
  	        active.maxPoint = makeIdlePoint(row, counter);
  	      }
  	    };

  	    const closeActive = () => {
  	      if (!active) return;

  	      const maxSec = toNum(active.maxCounter);
  	      const maxPoint = active.maxPoint;
  	      if (maxSec == null || !maxPoint || maxSec < Math.max(0, idleLimitSec || 0)) {
  	        stats.discardedShort++;
  	        active = null;
  	        return;
  	      }

  	      // The counter tells us the event's actual age. Deriving the start from
  	      // the highest counter is more accurate than relying on the first packet,
  	      // which may only arrive after 120 seconds.
  	      const endTs = toNum(maxPoint.timestamp);
  	      const derivedStartTs = endTs != null
  	        ? endTs - maxSec
  	        : active.firstRowTsSec;

  	      segments.push({
  	        start: derivedStartTs,
  	        start_iso: Number.isFinite(derivedStartTs)
  	          ? new Date(derivedStartTs * 1000).toISOString()
  	          : null,
  	        end: endTs,
  	        end_iso: Number.isFinite(endTs)
  	          ? new Date(endTs * 1000).toISOString()
  	          : null,
  	        idle_seconds: Math.round(maxSec),
  	        idle_human: humanDuration(maxSec),
  	        source: 'flespi.idle.total',
  	        // Exactly one map marker: the packet containing the greatest value
  	        // reached by idle.total during this Flespi interval.
  	        Points: [maxPoint]
  	      });

  	      active = null;
  	    };

  	    for (const row of sourceLogs) {
  	      const stateRaw = readFirstDefined(row, stateFields);
  	      const counter = readCounter(row);

  	      // A packet with no Flespi idle state is not an idle=false transition.
  	      // Ignore it so unrelated telemetry packets cannot split an interval.
  	      if (stateRaw === undefined || stateRaw === null) continue;

  	      const idleState = toBool(stateRaw);
  	      if (!idleState) {
  	        closeActive();
  	        continue;
  	      }

  	      stats.stateTrueRows++;

  	      if (!active) {
  	        startActive(row, counter);
  	      } else if (
  	        counter != null &&
  	        active.lastCounter != null &&
  	        counter < active.lastCounter - resetDropSec
  	      ) {
  	        // A falling cumulative counter means Flespi has started a new idle
  	        // interval even when the false transition packet was absent.
  	        stats.counterResets++;
  	        closeActive();
  	        startActive(row, counter);
  	      }

  	      updateActive(row, counter);
  	    }

  	    closeActive();
  	    return { segments, stats };
  	  }

  	  // ---------- main loop ----------
  	  const debug = {};
  	  const eventsOut = {};
  	  if (!isObj(Tractor.Events)) Tractor.Events = {};
  	  const logsCount = logs.length;

  	  for (const rule of CAN.Events) {
  	    if (!isObj(rule) || !rule.name) continue;

  	    // enabled (supports {$ref:"#/..."} or boolean)
  	    let enabled = true;
  	    if (own(rule, 'enabled')) enabled = toBool(resolveRef(CAN, rule.enabled));
  	    debug[rule.name] = {
  	      rows: logsCount,
  	      gatePass: 0,
  	      testPass: 0,
  	      segments: 0,
  	      discardedShort: 0,
  	      missingField: 0
  	    };
  	    if (!enabled) {
  	      Tractor.Events[rule.name] = []; eventsOut[rule.name] = []; continue;
  	    }

  	    // Idle is deliberately handled outside the generic event segmenter.
  	    // Flespi owns the state and duration; we only collapse each interval to
  	    // the single packet holding its highest idle.total value.
  	    if (rule.name === "Idle Event") {
  	      const built = buildFlespiIdleEvents(logs, rule, tractorIdleLimitSec);
  	      debug[rule.name].gatePass = built.stats.stateTrueRows;
  	      debug[rule.name].testPass = built.stats.counterRows;
  	      debug[rule.name].segments = built.segments.length;
  	      debug[rule.name].discardedShort = built.stats.discardedShort;
  	      debug[rule.name].counterResets = built.stats.counterResets;
  	      Tractor.Events[rule.name] = built.segments;
  	      eventsOut[rule.name] = built.segments;
  	      continue;
  	    }

  	    // segmentation
  	    const seg = rule.segmentation || {};
  	    const isIdleRule = rule.name === "Idle Event";
  	    // Flespi already determines idling. For Idle Event, group its cumulative
  	    // counter readings into one event instead of flushing every reading.
  	    const enterWhen = isIdleRule
  	      ? 'test_passes'
  	      : (seg.enter_when || 'test_passes').toLowerCase();
  	    const exitWhen = isIdleRule
  	      ? 'test_fails'
  	      : (seg.exit_when || 'test_fails').toLowerCase();

  	    const maxGapSec = readSeconds(
  	      resolveRef(CAN, seg.max_gap_s) ?? seg.max_gap_s,
  	      resolveRef(CAN, seg.max_gap_ms) ?? seg.max_gap_ms,
  	      30
  	    );

  	    const minDurSec = readSeconds(
  	      resolveRef(CAN, seg.min_duration_s) ?? seg.min_duration_s,
  	      resolveRef(CAN, seg.min_duration_ms) ?? seg.min_duration_ms,
  	      0
  	    );

  	    const maxGapMs = maxGapSec * 1000;
  	    // Tracker packets in the supplied data occasionally land 31 seconds apart,
  	    // so the generic 30-second default splits one Flespi idle counter sequence.
  	    const idleMaxGapSec = readSeconds(
  	      resolveRef(CAN, seg.idle_max_gap_s) ?? seg.idle_max_gap_s,
  	      resolveRef(CAN, seg.idle_max_gap_ms) ?? seg.idle_max_gap_ms,
  	      90
  	    );
  	    const effectiveMaxGapMs = isIdleRule
  	      ? Math.max(maxGapMs, idleMaxGapSec * 1000)
  	      : maxGapMs;
  	    const minDurMs = minDurSec * 1000;
  	    // aggregation
  	    const agg = rule.aggregation || null;
  	    const valueFromPath = agg?.value_from || 'calc.signal';
  	    const wantAvg = agg?.metrics?.includes('avg');
  	    const wantMax = agg?.metrics?.includes('max');

  	    const ctx = {
  	      ruleName: rule.name,
  	      segments: [],
  	      curPts: [],
  	      aggSum: 0,
  	      aggMax: -Infinity,
  	      aggCount: 0,
  	      firstTs: null,
  	      lastTs: null,
  	      prevTs: null,
  	      distM: 0,
  	      prevLat: null,
  	      prevLon: null,
  	      minDurMs,
  	      idleLimitSec: isIdleRule ? tractorIdleLimitSec: 0,
  	      maxIdleTotal: null,
  	      maxIdlePoint: null
  	    };

  	    const dwellSec = readSeconds(stabDefaults.dwell_s, stabDefaults.dwell_ms, 0); // reserved
  	    const dwellMs = dwellSec * 1000; // reserved
  	    const hyst = toNum(stabDefaults.hysteresis) ?? 0; // reserved

  	    for (let i = 0; i < logs.length; i++) {
  	      const row = logs[i];
  	      const ts = row.__ts;

  	      // Flespi's idle counter is authoritative. Extra speed/ignition gates can
  	      // flicker and split one real idle into several false events.
  	      const gatesOk = isIdleRule ? true : gatesPass(row, rule.gates);
  	      if (!gatesOk) {
  	        if (exitWhen === 'either' || exitWhen === 'test_fails' || exitWhen === 'no_rebound_failed_or_test_fails') flushSeg(ctx, debug[rule.name]);
  	        continue;
  	      }
  	      debug[rule.name].gatePass++;

  	      if (ctx.prevTs != null && effectiveMaxGapMs > 0 && (ts - ctx.prevTs) > effectiveMaxGapMs) {
  	        flushSeg(ctx, debug[rule.name]);
  	      }
  	      ctx.prevTs = ts;

  	      const calc = rule.calc || {};
  	      const sigSpec = calc.signal || {
  	        fn: 'value',
  	        field: rule.field
  	      };
  	      const sigFn = valueFns[sigSpec.fn || 'value'] || valueFns.value;
  	      const sigVal = sigFn(row, sigSpec, {
  	        idx: i, logs
  	      });

  	      const testSpec = calc.test || {
  	        op: 'truthy'
  	      };
  	      let testPass = false;
  	      const op = (testSpec.op || 'truthy').toLowerCase();
  	      if (op === 'time_between') {
  	        testPass = opTest['time_between'](row, {
  	          lo: resolveRef(CAN, testSpec.lo), hi: resolveRef(CAN, testSpec.hi)
  	        }, testSpec.field || 'localtime');
  	      } else if (op === 'between') {
  	        testPass = opTest['between'](sigVal, {
  	          lo: resolveRef(CAN, testSpec.lo), hi: resolveRef(CAN, testSpec.hi)
  	        });
  	      } else if (op === 'cycles') {
  	        const thr = resolveRef(CAN, testSpec.threshold) ?? testSpec.threshold;
  	        testPass = opTest['cycles'](sigVal, thr);
  	      } else {
  	        const thr = resolveRef(CAN, testSpec.threshold) ?? resolveRef(CAN, testSpec.thresholdRef) ?? testSpec.threshold;
  	        const cmp = opTest[op] || opTest['truthy'];
  	        testPass = cmp(sigVal, thr);
  	      }
  	      if (testPass) debug[rule.name].testPass++;

  	      // stability (no_rebound)
  	      let stabilityOk = true;
  	      if (isObj(calc.stability) && isObj(calc.stability.no_rebound) && testPass) {
  	        const winS = toNum(calc.stability.no_rebound.window_s) ?? 180;
  	        const tolP = toNum(calc.stability.no_rebound.tolerance_pct) ?? 20;
  	        const until = ts + winS*1000;
  	        for (let j = i+1; j < logs.length && logs[j].__ts <= until; j++) {
  	          const vj = sigFn(logs[j], sigSpec, {
  	            idx: j, logs
  	          });
  	          if (toNum(vj) != null && toNum(sigVal) != null) {
  	            const rebound = (vj >= sigVal*(1 - tolP/100));
  	            if (rebound) {
  	              stabilityOk = false; break;
  	            }
  	          }
  	        }
  	      }

  	      const nowPass = gatesOk && testPass && stabilityOk;

  	      // The Idle Event signal is the Flespi state (idle.status / idle).
  	      // The duration comes separately from idle.total. Keep those two jobs
  	      // separate so a boolean state is never mistaken for the duration.
  	      const aggVal = valueFromPath === 'calc.signal'
  	        ? sigVal
  	        : (byPath({
  	            calc: { signal: sigVal }
  	          }, valueFromPath) ?? byPath(row, valueFromPath));
  	      const idleCounterNow = isIdleRule ? toNum(aggVal) : null;

  	      // A positive falling counter while Flespi still says idle means a new
  	      // Flespi idle event has begun without an intervening false packet.
  	      if (isIdleRule && nowPass && ctx.curPts.length) {
  	        const idleMax = toNum(ctx.maxIdleTotal);
  	        if (idleCounterNow != null && idleCounterNow > 0 &&
  	            idleMax != null && idleCounterNow < idleMax) {
  	          flushSeg(ctx, debug[rule.name]);
  	        }
  	      }

  	      // For Idle Event points, store idle.total as the point value. For every
  	      // other rule, retain the calculated signal value.
  	      const pointValue = isIdleRule && idleCounterNow != null
  	        ? idleCounterNow
  	        : sigVal;

  	      // aggregation
  	      const doAgg = () => {
  	        const n = toNum(aggVal);

  	        if (isIdleRule && n != null && n >= 0) {
  	          if (ctx.maxIdleTotal == null || n >= ctx.maxIdleTotal) {
  	            ctx.maxIdleTotal = n;
  	            const currentPoint = ctx.curPts.length
  	              ? ctx.curPts[ctx.curPts.length - 1]
  	              : null;
  	            ctx.maxIdlePoint = currentPoint
  	              ? JSON.parse(JSON.stringify(currentPoint))
  	              : null;
  	          }
  	        }

  	        if (n != null) {
  	          // --- Handle Fuel Gain/Loss as pure change (sum only)
  	          if (rule.name === "Fuel Gain (Refuel)" || rule.name === "Fuel Loss") {
  	            if (ctx.startVal == null) ctx.startVal = n;
  	            ctx.lastVal = n;
  	          } else {
  	            if (wantAvg) {
  	              ctx.aggSum += n;
  	              ctx.aggCount++;
  	            }
  	            if (wantMax && n > ctx.aggMax) ctx.aggMax = n;
  	          }
  	        }
  	      };



  	      // segmentation
  	      if (!isIdleRule && (rule.segmentation?.enter_when || '').toLowerCase() === 'immediate' && nowPass) {
  	        pushPoint(ctx, row, pointValue); stepDistance(ctx, row, logs[i-1]); doAgg(); flushSeg(ctx, debug[rule.name]); continue;
  	      }
  	      if (!ctx.curPts.length) {
  	        if ((['test_passes', 'both'].includes(enterWhen)) && nowPass) {
  	          pushPoint(ctx, row, pointValue); stepDistance(ctx, row, logs[i-1]); doAgg(); continue;
  	        }
  	      } else {
  	        if ((exitWhen === 'test_fails' && !nowPass) ||
  	          (exitWhen === 'either' && (!gatesOk || !testPass)) ||
  	          (exitWhen === 'no_rebound_failed_or_test_fails' && (!testPass || !stabilityOk)) ||
  	          (exitWhen === 'stabilized' && !nowPass)) {
  	          flushSeg(ctx, debug[rule.name]); continue;
  	        }
  	        pushPoint(ctx, row, pointValue); stepDistance(ctx, row, logs[i-1]); doAgg();
  	      }
  	    } // logs loop

  	    flushSeg(ctx, debug[rule.name]);
  	    debug[rule.name].segments = ctx.segments.length;
  	    Tractor.Events[rule.name] = ctx.segments;
  	    eventsOut[rule.name] = ctx.segments;
  	  }

  	  // ===== FleetInForm In/Out Event Engine v11 (Bidirectional SmartFuel) =====
  	  try {
  	    const toPlain = v => JSON.parse(JSON.stringify(v));
  	    const toRad = x => (x * Math.PI) / 180;
  	    const haversineM = (a, b) => {
  	      const R = 6371000;
  	      const dLat = toRad(b.lat - a.lat);
  	      const dLon = toRad(b.lon - a.lon);
  	      const sLat = Math.sin(dLat / 2);
  	      const sLon = Math.sin(dLon / 2);
  	      const cLatA = Math.cos(toRad(a.lat));
  	      const cLatB = Math.cos(toRad(b.lat));
  	      const aVal = sLat * sLat + cLatA * cLatB * sLon * sLon;
  	      return 2 * R * Math.atan2(Math.sqrt(aVal), Math.sqrt(1 - aVal));
  	    };

  	    // ---------- Polygon helpers ----------
  	    function normalizePolygon(poly) {
  	      if (!poly || !poly.coordinates) return [];
  	      let rings = poly.coordinates;
  	      if (Array.isArray(rings[0]) && Array.isArray(rings[0][0]) && Array.isArray(rings[0][0][0])) rings = rings[0];
  	      return rings
  	      .map(ring =>
  	        ring
  	        .filter(p => Array.isArray(p) && p.length >= 2)
  	        .map(p => [Number(p[0]), Number(p[1])])
  	        .filter(p => Number.isFinite(p[0]) && Number.isFinite(p[1]))
  	      )
  	      .filter(r => r.length >= 3);
  	    }

  	    function pointInRing(lon, lat, ring) {
  	      let inside = false;
  	      for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
  	        const [xi,
  	          yi] = ring[i];
  	        const [xj,
  	          yj] = ring[j];
  	        const intersect =
  	        (yi > lat) !== (yj > lat) && lon < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
  	        if (intersect) inside = !inside;
  	      }
  	      return inside;
  	    }

  	    function pointInPolygon(lon, lat, rings) {
  	      if (!rings?.length) return false;
  	      if (!pointInRing(lon, lat, rings[0])) return false;
  	      for (let k = 1; k < rings.length; k++) if (pointInRing(lon, lat, rings[k])) return false;
  	      return true;
  	    }

  	    // ---------- Smart Fuel Metric (multi-source fallback) ----------
  	    function getFuelMetric(r) {
  	      if (!r || typeof r !== "object") return {
  	        val: null,
  	        src: null
  	      };
  	      const keys = [
  	        "can.tracker.counted.fuel.consumed",
  	        "can.fuel.consumed",
  	        "can.fuel.used",
  	        "can.fuel.liters",
  	        "gps.fuel.used"
  	      ];

  	      for (const k of keys) {
  	        const v = Number(r[k]);
  	        if (Number.isFinite(v)) return {
  	          val: v,
  	          src: k
  	        };
  	      }
  	      return {
  	        val: null,
  	        src: null
  	      };
  	    }

  	    function getFuelLevelPct(r, tankCap) {
  	      const pct = Number(r["can.fuel.level"]);
  	      if (Number.isFinite(pct) && pct >= 0 && pct <= 100) return pct;

  	      const vol = Number(r["can.fuel.volume"]);
  	      if (Number.isFinite(vol) && Number.isFinite(tankCap) && tankCap > 0) {
  	        return Math.min(100, Math.max(0, (vol / tankCap) * 100));
  	      }
  	      return null;
  	    }

  	    // ---------- Trailer label helpers ----------
  	    function uniquePush(list, v) {
  	      if (!list) return;
  	      if (v == null) return;
  	      var s = String(v);
  	      if (list.indexOf(s) === -1) list.push(s);
  	    }

  	    function getTrailerLabelsFromPoint(p, lookup) {
  	      var out = [];
  	      if (!p || typeof p !== "object") return out;

  	      var beacons = p.ble && Array.isArray(p.ble.beacons) ? p.ble.beacons: [];
  	      for (var i = 0; i < beacons.length; i++) {
  	        var b = beacons[i];
  	        var id = b && b.id != null ? String(b.id): null;
  	        if (!id) continue;

  	        var label = lookup && lookup[id] ? lookup[id]: null;
  	        if (label) uniquePush(out, label);
  	      }
  	      return out;
  	    }

  	    const calcDistance = (pts) => {
  	      let d = 0;
  	      for (let i = 1; i < pts.length; i++) {
  	        const a = pts[i - 1];
  	        const b = pts[i];
  	        const A = {
  	          lat: Number(a["position.latitude"]),
  	          lon: Number(a["position.longitude"])
  	        };
  	        const B = {
  	          lat: Number(b["position.latitude"]),
  	          lon: Number(b["position.longitude"])
  	        };
  	        if (Number.isFinite(A.lat) && Number.isFinite(A.lon) && Number.isFinite(B.lat) && Number.isFinite(B.lon))
  	          d += haversineM(A, B);
  	      }
  	      return d;
  	    };

  	    // ---------- Data Prep ----------
  	    const locations = Array.isArray(Locations) ? Locations.map(toPlain): [];
  	    const track = Array.isArray(Tractor.Tracking) ? Tractor.Tracking.map(toPlain): [];
  	    if (!track.length) return;

  	    const geos = locations.map(loc => ({
  	      Name: loc.Name || loc.ID,
  	      ID: loc.ID,
  	      Location: loc,
  	      Rings: normalizePolygon(loc.Polygon || loc.GeoFences || loc["Geo Fences"]),
  	      inside: false,
  	      activeVisit: null
  	    }));

  	    // ---------- Trailer lookup (EYEID -> "Application - Registration") ----------
  	    var trailerLabelByEyeId = {};

  	    try {
  	      var companies = (AppData && AppData.User && AppData.User.Companies) ? AppData.User.Companies: [];
  	      for (var ci = 0; ci < companies.length; ci++) {
  	        var comp = companies[ci];
  	        var trailers = comp && comp.Trailers ? comp.Trailers: [];
  	        for (var ti = 0; ti < trailers.length; ti++) {
  	          var tr = trailers[ti];
  	          var eye = tr ? tr.EYEID: null;
  	          if (!eye) continue;

  	          var app = tr.Application != null ? String(tr.Application): "";
  	          var reg = tr.Registration != null ? String(tr.Registration): "";

  	          var label = (app && reg) ? (app + " - " + reg): (app ? app: (reg ? reg: (tr.ID != null ? String(tr.ID): String(eye))));

  	          trailerLabelByEyeId[String(eye)] = label;
  	        }
  	      }
  	    } catch (e) {
  	      trailerLabelByEyeId = {};
  	    }

  	    const finalEvents = [];

  	    // ---------- Main Loop ----------
  	    for (let i = 0; i < track.length; i++) {
  	      const p = track[i];
  	      const lat = Number(p["position.latitude"]);
  	      const lon = Number(p["position.longitude"]);
  	      const ts = Number(p.timestamp);
  	      if (!Number.isFinite(lat) || !Number.isFinite(lon) || !Number.isFinite(ts)) continue;

  	      for (const g of geos) {
  	        if (!g.Rings.length) continue;
  	        const inside = pointInPolygon(lon, lat, g.Rings);

  	        // ENTER event
  	        if (!g.inside && inside) {
  	          g.inside = true;
  	          const fuel = getFuelMetric(p);
  	          g.activeVisit = {
  	            type: (i === 0 ? "Started In Location": "Entered Location"),
  	            Name: g.Name,
  	            Location: g.Location,
  	            lat_in: lat,
  	            lon_in: lon,
  	            ts_in: ts,
  	            time_in: new Date(ts * 1000).toISOString(),
  	            fuel_in: fuel.val,
  	            fuel_src: fuel.src,

  	            // ✅ NEW: trailers seen during this visit (Application - Registration)
  	            trailers: getTrailerLabelsFromPoint(p, trailerLabelByEyeId),

  	            points: [p]
  	          };
  	        }

  	        // STILL INSIDE
  	        else if (g.inside && inside && g.activeVisit) {
  	          g.activeVisit.points.push(p);

  	          // ✅ NEW: accumulate trailers while inside zone
  	          var tLabs = getTrailerLabelsFromPoint(p, trailerLabelByEyeId);
  	          for (var tt = 0; tt < tLabs.length; tt++) {
  	            uniquePush(g.activeVisit.trailers, tLabs[tt]);
  	          }

  	          // Forward capture for missing fuel_in
  	          if (!Number.isFinite(g.activeVisit.fuel_in)) {
  	            const fNow = getFuelMetric(p);
  	            if (Number.isFinite(fNow.val)) {
  	              g.activeVisit.fuel_in = fNow.val;
  	              g.activeVisit.fuel_src = fNow.src;
  	            }
  	          }
  	        }

  	        // EXIT event
  	        else if (g.inside && !inside && g.activeVisit) {
  	          const last = g.activeVisit.points[g.activeVisit.points.length - 1] || p;
  	          const tsOut = Number(last.timestamp) || ts;
  	          const durationSec = tsOut - g.activeVisit.ts_in;
  	          const distM = calcDistance(g.activeVisit.points);

  	          // --- Fuel recovery logic ---
  	          const fStart = getFuelMetric(g.activeVisit.points.find(r => getFuelMetric(r).val != null) || {});
  	          let fEnd = getFuelMetric(last);
  	          if (!Number.isFinite(fEnd.val)) {
  	            // reverse-search last valid fuel reading in zone
  	            for (let j = g.activeVisit.points.length - 1; j >= 0; j--) {
  	              const tryF = getFuelMetric(g.activeVisit.points[j]);
  	              if (Number.isFinite(tryF.val)) {
  	                fEnd = tryF; break;
  	              }
  	            }
  	          }

  	          let fuelUsed = (Number.isFinite(fStart.val) && Number.isFinite(fEnd.val))
  	          ? (fEnd.val - fStart.val): null;

  	          // --- Fuel fallback: use level% drop if consumed isn't available ---
  	          if (!Number.isFinite(fuelUsed)) {
  	            const tankCap = Number(Tractor?.CAN?.Tank);
  	            if (Number.isFinite(tankCap) && tankCap > 0) {
  	              const pStart = getFuelLevelPct(g.activeVisit.points[0], tankCap);
  	              const pEnd = getFuelLevelPct(last, tankCap);
  	              if (Number.isFinite(pStart) && Number.isFinite(pEnd)) {
  	                const liters = ((pStart - pEnd) / 100) * tankCap;
  	                if (Number.isFinite(liters) && liters > 0) fuelUsed = liters;
  	              }
  	            }
  	          }


  	          const distKm = distM / 1000;
  	          const kmPerL = (fuelUsed && fuelUsed > 0) ? distKm / fuelUsed: null;
  	          const LperH = (fuelUsed && durationSec > 0) ? (fuelUsed / (durationSec / 3600)): null;

  	          g.activeVisit = {
  	            ...g.activeVisit,
  	            type_out: "Left Location",
  	            ts_out: tsOut,
  	            time_out: new Date(tsOut * 1000).toISOString(),
  	            lat_out: Number(last["position.latitude"]) || lat,
  	            lon_out: Number(last["position.longitude"]) || lon,
  	            duration_sec: durationSec,
  	            distance_m: distM,
  	            fuel_out: fEnd.val,
  	            fuel_src_out: fEnd.src,
  	            fuel_used: fuelUsed,
  	            km_per_litre: kmPerL,
  	            litres_per_hour: LperH
  	          };

  	          finalEvents.push(g.activeVisit);
  	          g.inside = false;
  	          g.activeVisit = null;
  	        }
  	      }
  	    }

  	    // ---------- Close still-active zones ----------
  	    const last = track[track.length - 1];
  	    const lastTs = Number(last.timestamp);
  	    for (const g of geos) {
  	      if (g.inside && g.activeVisit) {
  	        const durationSec = lastTs - g.activeVisit.ts_in;
  	        const distM = calcDistance(g.activeVisit.points);

  	        const fStart = getFuelMetric(g.activeVisit.points.find(r => getFuelMetric(r).val != null) || {});
  	        let fEnd = getFuelMetric(last);
  	        if (!Number.isFinite(fEnd.val)) {
  	          for (let j = g.activeVisit.points.length - 1; j >= 0; j--) {
  	            const tryF = getFuelMetric(g.activeVisit.points[j]);
  	            if (Number.isFinite(tryF.val)) {
  	              fEnd = tryF; break;
  	            }
  	          }
  	        }

  	        let fuelUsed = (Number.isFinite(fStart.val) && Number.isFinite(fEnd.val))
  	        ? (fEnd.val - fStart.val): null;

  	        // --- Fuel fallback: use level% drop if consumed isn't available ---
  	        if (!Number.isFinite(fuelUsed)) {
  	          const tankCap = Number(Tractor?.CAN?.Tank);
  	          if (Number.isFinite(tankCap) && tankCap > 0) {
  	            const pStart = getFuelLevelPct(g.activeVisit.points[0], tankCap);
  	            const pEnd = getFuelLevelPct(last, tankCap);
  	            if (Number.isFinite(pStart) && Number.isFinite(pEnd)) {
  	              const liters = ((pStart - pEnd) / 100) * tankCap;
  	              if (Number.isFinite(liters) && liters > 0) fuelUsed = liters;
  	            }
  	          }
  	        }


  	        const distKm = distM / 1000;
  	        const kmPerL = (fuelUsed && fuelUsed > 0) ? distKm / fuelUsed: null;
  	        const LperH = (fuelUsed && durationSec > 0) ? (fuelUsed / (durationSec / 3600)): null;

  	        g.activeVisit = {
  	          ...g.activeVisit,
  	          type_out: "In Location",
  	          ts_out: lastTs,
  	          time_out: new Date(lastTs * 1000).toISOString(),
  	          duration_sec: durationSec,
  	          distance_m: distM,
  	          fuel_out: fEnd.val,
  	          fuel_src_out: fEnd.src,
  	          fuel_used: fuelUsed,
  	          km_per_litre: kmPerL,
  	          litres_per_hour: LperH
  	        };

  	        finalEvents.push(g.activeVisit);
  	      }
  	    }

  	    Tractor.Events["Location Events"] = finalEvents;
  	    Tractor.CurrentLocation = geos.filter(g => g.inside).map(g => g.Name).join(", ") || null;


  	  } catch (err) {
  	        /* Mobile history analysis: intentionally silent. */
  	    Tractor.Events["Location Events"] = [{
  	      error: String(err)
  	    }];
  	  }


  	  // ---------- compute Max summary (v4: flat-key safe) ----------
  	  const maxSummary = {
  	    MaxSpeed: 0,
  	    MaxRPM: 0,
  	    MaxTemp: 0,
  	    MaxThrottle: 0,
  	    // ✅ NEW
  	    TotalIdleSec: 0,
  	    TotalDistKm: 0,
  	    TotalFuelL: 0 // ✅ new field
  	  };

  	  // 1️⃣ Aggregate from event segments
  	  for (const [key, segs] of Object.entries(eventsOut)) {
  	    for (const s of segs) {
  	      if (s.Max != null) {
  	        if (/speed/i.test(key)) maxSummary.MaxSpeed = Math.max(maxSummary.MaxSpeed, s.Max);
  	        if (/rpm/i.test(key)) maxSummary.MaxRPM = Math.max(maxSummary.MaxRPM, s.Max);
  	        if (/temp|heat/i.test(key)) maxSummary.MaxTemp = Math.max(maxSummary.MaxTemp, s.Max);
  	        if (/throttle/i.test(key)) maxSummary.MaxThrottle = Math.max(maxSummary.MaxThrottle, s.Max);

  	      }

  	    }
  	  }

  	  // 2️⃣ Direct fallback verification from logs  — REPLACED (ES5-safe)
  	  if (Array.isArray(logs) && logs.length) {
  	    var distKm = 0;

  	    // --- Smart Distance Calculation (odometer → GPS fallback) ---
  	    var odoVals = [];
  	    for (var i = 0; i < logs.length; i++) {
  	      var od = toNum(logs[i]["can.vehicle.mileage"]);
  	      if (Number.isFinite(od)) odoVals.push(od);
  	    }

  	    if (odoVals.length >= 2) {
  	      distKm = Math.max(0, odoVals[odoVals.length - 1] - odoVals[0]);
  	    } else {
  	      var gpsVals = [];
  	      for (var j = 0; j < logs.length; j++) {
  	        var gvRaw = logs[j]["vehicle.mileage"] != null
  	        ? logs[j]["vehicle.mileage"]: (logs[j]["gps.odometer"] != null ? logs[j]["gps.odometer"]: logs[j]["gps.mileage"]);
  	        var gv = toNum(gvRaw);
  	        if (Number.isFinite(gv)) gpsVals.push(gv);
  	      }
  	      if (gpsVals.length >= 2) {
  	        distKm = Math.max(0, gpsVals[gpsVals.length - 1] - gpsVals[0]);
  	      }
  	    }

  	    // --- Update max metrics (speed/rpm/temp) ---
  	    for (var k = 0; k < logs.length; k++) {
  	      var rk = logs[k];
  	      var spd = toNum(rk.__spd != null ? rk.__spd: rk["position.speed"]);
  	      var rpm = toNum(rk["can.engine.rpm"]);
  	      var tmp = toNum(rk["can.engine.temperature"]);
  	      var thr = toNum(rk["can.throttle.pedal.level"]);
  	      if (Number.isFinite(spd)) maxSummary.MaxSpeed = Math.max(maxSummary.MaxSpeed, spd);
  	      if (Number.isFinite(rpm)) maxSummary.MaxRPM = Math.max(maxSummary.MaxRPM, rpm);
  	      if (Number.isFinite(tmp)) maxSummary.MaxTemp = Math.max(maxSummary.MaxTemp, tmp);
  	      if (Number.isFinite(thr)) maxSummary.MaxThrottle = Math.max(maxSummary.MaxThrottle, thr);
  	    }

  	    // --- Commit distance (do NOT also add event segment distances elsewhere) ---
  	    maxSummary.TotalDistKm += distKm;

  	    // --- ✅ Smart Fuel Consumed Aggregation (First+Last Valid CAN, fallback GPS) ---
  	    if (Array.isArray(logs) && logs.length) {
  	      const getFuelValue = (r, key) => {
  	        const v = Number(r[key]);
  	        return Number.isFinite(v) ? v: null;
  	      };

  	      // 1️⃣ Try CAN fuel.consumed
  	      const firstCan = logs.find(r => getFuelValue(r, "can.fuel.consumed") != null);
  	      const lastCan = [...logs].reverse().find(r => getFuelValue(r, "can.fuel.consumed") != null);

  	      if (firstCan && lastCan) {
  	        const start = getFuelValue(firstCan, "can.fuel.consumed");
  	        const end = getFuelValue(lastCan, "can.fuel.consumed");
  	        if (Number.isFinite(start) && Number.isFinite(end) && end >= start) {
  	          maxSummary.TotalFuelL = end - start;
  	        }
  	      } else {
  	        // 2️⃣ Fallback: gps.fuel.used
  	        const firstGps = logs.find(r => getFuelValue(r, "gps.fuel.used") != null);
  	        const lastGps = [...logs].reverse().find(r => getFuelValue(r, "gps.fuel.used") != null);
  	        if (firstGps && lastGps) {
  	          const start = getFuelValue(firstGps, "gps.fuel.used");
  	          const end = getFuelValue(lastGps, "gps.fuel.used");
  	          if (Number.isFinite(start) && Number.isFinite(end) && end >= start) {
  	            maxSummary.TotalFuelL = end - start;
  	          }
  	        }
  	      }
  	    }



  	    // --- IdleSec: prefer CAN "Idle Event" segments; else fall back once ---
  	    var idleSegs = eventsOut["Idle Event"];
  	    if (Array.isArray(idleSegs) && idleSegs.length) {
  	      for (var s = 0; s < idleSegs.length; s++) {
  	        var seg = idleSegs[s];
  	        if (seg && Number.isFinite(seg.idle_seconds)) {
  	          maxSummary.TotalIdleSec += seg.idle_seconds;
  	        }
  	      }
  	    } else {
  	      // Flespi is authoritative for idling. Do not infer idle from speed < 1:
  	      // a parked vehicle with the engine off is stationary, not idling.
  	      maxSummary.TotalIdleSec += 0;
  	    }
  	  }


  	  Tractor.Events.Max = {
  	    Speed: Math.round(maxSummary.MaxSpeed || 0),
  	    RPM: Math.round(maxSummary.MaxRPM || 0),
  	    Temp: Math.round(maxSummary.MaxTemp || 0),
  	    Throttle: Math.round(maxSummary.MaxThrottle || 0),
  	    IdleSec: Math.round(maxSummary.TotalIdleSec || 0),
  	    DistM: Math.round((maxSummary.TotalDistKm || 0) * 1000000) / 1000,
  	    DistKm: Math.round((maxSummary.TotalDistKm || 0) * 1000) / 1000,
  	    FuelL: Math.round((maxSummary.TotalFuelL || 0) * 1000) / 1000
  	  };

  	  // === MaxData (per-metric object with full original point data) ===
  	  (() => {
  	    if (!Array.isArray(logs) || !logs.length) return;

  	    const maxData = {};
  	    const maxVals = Tractor.Events.Max;

  	    // Helper: find all logs where metric matches its max
  	    const findFullPoints = (metric, maxVal) => {
  	      if (maxVal == null) return [];
  	      const matches = [];

  	      for (const r of logs) {
  	        const val =
  	        metric === "Speed" ? (r.__spd ?? r["position.speed"]):
  	        metric === "RPM" ? r["can.engine.rpm"]:
  	        metric === "Temp" ? r["can.engine.temperature"]:
  	        null;

  	        if (val != null && Math.round(val) === Math.round(maxVal)) {
  	          // Include the full raw record (cloned to avoid mutations)
  	          matches.push(JSON.parse(JSON.stringify(r)));
  	        }
  	      }
  	      return matches;
  	    };

  	    // Create per-metric objects with full data
  	    maxData.Speed = {
  	      value: maxVals.Speed,
  	      Points: findFullPoints("Speed", maxVals.Speed)
  	    };

  	    maxData.RPM = {
  	      value: maxVals.RPM,
  	      Points: findFullPoints("RPM", maxVals.RPM)
  	    };

  	    // === Throttle Overuse (pedal level max) ===
  	    maxData.Throttle = {
  	      value: maxVals.Throttle,
  	      Points: (() => {
  	        const matches = [];
  	        for (const r of logs) {
  	          const thr = toNum(r["can.throttle.pedal.level"]);
  	          if (thr != null && Math.round(thr) === Math.round(maxVals.Throttle)) {
  	            matches.push(JSON.parse(JSON.stringify(r)));
  	          }
  	        }
  	        return matches;
  	      })()
  	    };


  	    maxData.Temp = {
  	      value: maxVals.Temp,
  	      Points: findFullPoints("Temp",
  	        maxVals.Temp)
  	    };

  	    maxData.IdleSec = {
  	      value: maxVals.IdleSec,
  	      Points: [] // You can later tie this to Idle segments if you want
  	    };

  	    maxData.DistKm = {
  	      value: maxVals.DistKm,
  	      Points: [] // Derived from odometer/gps, no single point
  	    };

  	    maxData.FuelL = {
  	      value: maxVals.FuelL,
  	      Points: [] // Derived from first+last, no single point
  	    };

  	    Tractor.Events.MaxData = maxData;
  	  })();


  	  // 4️⃣ Optional formatted string
  	  const mins = Math.floor(maxSummary.TotalIdleSec / 60);
  	  const secs = Math.round(maxSummary.TotalIdleSec % 60);
  	  Tractor.Events.Max.IdleFmt = `${mins}m ${secs}s`;
  	        /* Local historical analysis does not refresh App Data. */
  	  return {
  	    ok: true,
  	    events: eventsOut,
  	    stats: {
  	      eventsDefined: CAN.Events.length,
  	      logsCount: logs.length
  	    },
  	    debug,
  	    errors: []
  	  };
  	  }

  	  function canonicalColorizeTracking(historyTractor) {
  	    if (
  	      !historyTractor ||
  	      !Array.isArray(historyTractor.Tracking)
  	    ) {
  	      return;
  	    }

  	    const redEvents = [
  	      "Speeding",
  	      "Engine Over-Rev",
  	      "Engine Over-Temperature",
  	      "Throttle Overuse"
  	    ];
  	    const greenEvents = ["Green Band Driving"];
  	    const colorMap = {
  	      red: "#FF0000",
  	      green: "#00FF00",
  	      yellow: "#FFFF00"
  	    };
  	    const tsMap = Object.create(null);

  	    Object.keys(historyTractor.Events || {}).forEach(function (eventName) {
  	      const segments = historyTractor.Events[eventName];
  	      if (!Array.isArray(segments)) return;

  	      const severity =
  	        redEvents.indexOf(eventName) >= 0
  	          ? "red"
  	          : greenEvents.indexOf(eventName) >= 0
  	            ? "green"
  	            : null;

  	      if (!severity) return;

  	      segments.forEach(function (segment) {
  	        if (!segment || !Array.isArray(segment.Points)) return;

  	        segment.Points.forEach(function (point) {
  	          const ts = Number(point && point.timestamp);
  	          if (!ts) return;

  	          if (!tsMap[ts]) {
  	            tsMap[ts] = {
  	              events: [],
  	              color: "yellow"
  	            };
  	          }

  	          if (tsMap[ts].events.indexOf(eventName) < 0) {
  	            tsMap[ts].events.push(eventName);
  	          }

  	          if (severity === "red") {
  	            tsMap[ts].color = "red";
  	          } else if (
  	            severity === "green" &&
  	            tsMap[ts].color !== "red"
  	          ) {
  	            tsMap[ts].color = "green";
  	          }
  	        });
  	      });
  	    });

  	    historyTractor.Tracking.forEach(function (row) {
  	      const ts = Number(row && row.timestamp);
  	      const found = tsMap[ts];

  	      if (found) {
  	        row.color = colorMap[found.color];
  	        row.events = found.events.slice();
  	      } else {
  	        row.color = colorMap.yellow;
  	        row.events = [];
  	      }
  	    });
  	  }

  	  function fallbackColorizeHistory(historyTractor) {
  	    if (
  	      !historyTractor ||
  	      !Array.isArray(historyTractor.Tracking)
  	    ) {
  	      return;
  	    }

  	    const can = historyTractor.CAN || {};
  	    const speedLimit = num(can.Speed);
  	    const rpmLimit = num(can.RPM);
  	    const tempLimit = num(can.Temp);
  	    const throttleLimit = num(
  	      firstValue([
  	        can.Throttle,
  	        can.ThrottleLimit,
  	        getPath(can, "Engine.Throttle", null)
  	      ], null)
  	    );

  	    historyTractor.Tracking.forEach(function (row) {
  	      const sourceEvents = arr(row && row.events).map(function (eventName) {
  	        return clean(eventName);
  	      });

  	      let red =
  	        sourceEvents.indexOf("Speeding") >= 0 ||
  	        sourceEvents.indexOf("Engine Over-Rev") >= 0 ||
  	        sourceEvents.indexOf("Engine Over-Temperature") >= 0 ||
  	        sourceEvents.indexOf("Throttle Overuse") >= 0;

  	      const green =
  	        sourceEvents.indexOf("Green Band Driving") >= 0;

  	      const speed = num(
  	        firstValue([
  	          getPath(row, "position.speed", null),
  	          getPath(row, "can.vehicle.speed", null)
  	        ], null)
  	      );
  	      const rpm = num(getPath(row, "can.engine.rpm", null));
  	      const temp = num(
  	        getPath(row, "can.engine.temperature", null)
  	      );
  	      const throttle = num(
  	        firstValue([
  	          getPath(row, "can.throttle.pedal.level", null),
  	          getPath(row, "can.accelerator.pedal.position", null)
  	        ], null)
  	      );

  	      if (
  	        speed !== null &&
  	        speedLimit !== null &&
  	        speed > speedLimit
  	      ) {
  	        red = true;
  	      }
  	      if (
  	        rpm !== null &&
  	        rpmLimit !== null &&
  	        rpm > rpmLimit
  	      ) {
  	        red = true;
  	      }
  	      if (
  	        temp !== null &&
  	        tempLimit !== null &&
  	        temp > tempLimit
  	      ) {
  	        red = true;
  	      }
  	      if (
  	        throttle !== null &&
  	        throttleLimit !== null &&
  	        throttle > throttleLimit
  	      ) {
  	        red = true;
  	      }

  	      row.color = red
  	        ? "#FF0000"
  	        : green
  	          ? "#00FF00"
  	          : "#FFFF00";
  	    });
  	  }

  	  function historyLocations() {
  	    const data = appBag();

  	    return arr(
  	      firstValue([
  	        data && data.Locations,
  	        getPath(data, "User.Locations", null),
  	        []
  	      ], [])
  	    );
  	  }

  	  async function analyseHistoricalMessages(vehicle, messages) {
  	    const sourceTractor =
  	      vehicle && vehicle.tractor
  	        ? vehicle.tractor
  	        : {};

  	    /*
  	     * Temporary local Tractor. Event analysis must never overwrite the live
  	     * AppData Tractor or persist anything back to Backendless.
  	     */
  	    const historyTractor = Object.assign(
  	      {},
  	      sourceTractor,
  	      {
  	        CAN:
  	          sourceTractor.CAN ||
  	          getPath(sourceTractor, "Data.CAN", {}) ||
  	          {},
  	        Tracking: messages.map(function (message) {
  	          return Object.assign({}, message);
  	        }),
  	        Events: {}
  	      }
  	    );

  	    let eventEngineOk = false;

  	    try {
  	      if (
  	        historyTractor.CAN &&
  	        Array.isArray(historyTractor.CAN.Events)
  	      ) {
  	        const result =
  	          await runCanonicalCanEventEngine(
  	            historyTractor,
  	            historyTractor.CAN,
  	            historyLocations(),
  	            appBag()
  	          );

  	        eventEngineOk = !!(result && result.ok);
  	      }
  	    } catch (_) {
  	      eventEngineOk = false;
  	    }

  	    if (eventEngineOk) {
  	      canonicalColorizeTracking(historyTractor);
  	    } else {
  	      fallbackColorizeHistory(historyTractor);
  	    }

  	    return {
  	      messages: historyTractor.Tracking,
  	      events: historyTractor.Events || {},
  	      canonicalEvents: eventEngineOk
  	    };
  	  }

  	  async function fetchHistory(vehicle, minutes) {
  	    if (!vehicle || !vehicle.tracker) {
  	      throw new Error("Select a tracked vehicle.");
  	    }

  	    const to = Math.floor(Date.now() / 1000);
  	    const from =
  	      to - Math.max(1, Number(minutes) || 60) * 60;

  	    /*
  	     * Deliberately request the complete telemetry rows. CAN.Events is
  	     * descriptor-driven and may refer to fields that cannot be predicted by
  	     * Mobile Tracking in advance.
  	     */
  	    const body = await flespiGet(
  	      "devices/" + vehicle.tracker + "/messages",
  	      {
  	        from: from,
  	        to: to
  	      }
  	    );

  	    const rows = normaliseResultList(body)
  	      .filter(function (message) {
  	        return (
  	          !!validPoint(message) &&
  	          timestampSeconds(message) !== null
  	        );
  	      })
  	      .sort(function (a, b) {
  	        return (
  	          timestampSeconds(a) -
  	          timestampSeconds(b)
  	        );
  	      });

  	    const deduped = [];
  	    let lastSignature = "";

  	    rows.forEach(function (message) {
  	      const point = validPoint(message);
  	      const signature = [
  	        timestampSeconds(message),
  	        point.lat.toFixed(6),
  	        point.lng.toFixed(6)
  	      ].join("|");

  	      if (signature === lastSignature) return;
  	      lastSignature = signature;
  	      deduped.push(message);
  	    });

  	    return await analyseHistoricalMessages(
  	      vehicle,
  	      deduped
  	    );
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Passed Backendless Map component resolver
  	  // ---------------------------------------------------------------------------
  	  function mobileTrackingGoogleMapsAvailable() {
  	    return !!(
  	      typeof window !== "undefined" &&
  	      window.google &&
  	      window.google.maps &&
  	      typeof window.google.maps.Map === "function"
  	    );
  	  }

  	  function mobileTrackingIsGoogleMapLike(value) {
  	    if (!value) return false;

  	    try {
  	      if (
  	        mobileTrackingGoogleMapsAvailable() &&
  	        value instanceof window.google.maps.Map
  	      ) {
  	        return true;
  	      }
  	    } catch (_) {}

  	    /*
  	     * Duck typing is intentional. Backendless can wrap the native Map object,
  	     * but these methods reliably distinguish the usable Google map instance.
  	     */
  	    return !!(
  	      typeof value.getCenter === "function" &&
  	      typeof value.panTo === "function" &&
  	      typeof value.setOptions === "function" &&
  	      typeof value.getDiv === "function"
  	    );
  	  }

  	  function mobileTrackingExtractMap(candidate) {
  	    if (!candidate) return null;

  	    const candidates = [];
  	    const push = function (value) {
  	      if (value) candidates.push(value);
  	    };

  	    try {
  	      push(candidate);

  	      push(candidate.map);
  	      if (typeof candidate.map === "function") {
  	        try { push(candidate.map()); } catch (_) {}
  	      }

  	      push(candidate.map && candidate.map.map);

  	      if (
  	        candidate.map &&
  	        typeof candidate.map.getMap === "function"
  	      ) {
  	        try { push(candidate.map.getMap()); } catch (_) {}
  	      }

  	      if (typeof candidate.getMap === "function") {
  	        try { push(candidate.getMap()); } catch (_) {}
  	      }

  	      push(candidate.googleMap);
  	      push(candidate.GoogleMap);
  	      push(candidate.gMap);
  	      push(candidate.GMap);
  	      push(candidate.gmap);
  	      push(candidate.__map);
  	      push(candidate._map);
  	      push(candidate.instance);
  	      push(candidate.api && candidate.api.map);

  	      if (
  	        candidate.mapComponent &&
  	        typeof candidate.mapComponent.getMap === "function"
  	      ) {
  	        try { push(candidate.mapComponent.getMap()); } catch (_) {}
  	      }

  	      push(candidate.$mapObject);
  	      push(
  	        candidate.$refs &&
  	        candidate.$refs.map &&
  	        candidate.$refs.map.$mapObject
  	      );
  	    } catch (_) {}

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      if (mobileTrackingIsGoogleMapLike(candidates[index])) {
  	        return candidates[index];
  	      }
  	    }

  	    return null;
  	  }

  	  function mobileTrackingExtractMapElement(candidate, mapInstance) {
  	    const isElement = function (value) {
  	      return !!(
  	        value &&
  	        typeof HTMLElement !== "undefined" &&
  	        value instanceof HTMLElement
  	      );
  	    };

  	    try {
  	      if (candidate) {
  	        if (typeof candidate.el === "function") {
  	          const value = candidate.el();
  	          if (isElement(value)) return value;
  	        }

  	        if (isElement(candidate.el)) return candidate.el;
  	        if (isElement(candidate.element)) return candidate.element;
  	        if (isElement(candidate.$el)) return candidate.$el;
  	      }

  	      if (mapInstance && typeof mapInstance.getDiv === "function") {
  	        const value = mapInstance.getDiv();
  	        if (isElement(value)) return value;
  	      }
  	    } catch (_) {}

  	    return null;
  	  }

  	  async function mobileTrackingResolvePassedMap(mapInput) {
  	    if (!mapInput) {
  	      return {
  	        ready: false,
  	        wrapper: null,
  	        map: null,
  	        element: null,
  	        maps: null
  	      };
  	    }

  	    const nextFrame = function () {
  	      return new Promise(function (resolve) {
  	        if (typeof requestAnimationFrame === "function") {
  	          requestAnimationFrame(resolve);
  	        } else {
  	          setTimeout(resolve, 16);
  	        }
  	      });
  	    };

  	    const sleep = function (ms) {
  	      return new Promise(function (resolve) {
  	        setTimeout(resolve, ms);
  	      });
  	    };

  	    /*
  	     * On Page Enter often runs a fraction before Backendless finishes mounting
  	     * the Map component. Wait for the real map instance rather than attempting
  	     * to create a second Google Map.
  	     */
  	    const deadline = Date.now() + 12000;
  	    let mapInstance = mobileTrackingExtractMap(mapInput);
  	    let mapElement = mobileTrackingExtractMapElement(
  	      mapInput,
  	      mapInstance
  	    );

  	    while (Date.now() < deadline) {
  	      if (
  	        mapInstance &&
  	        mobileTrackingGoogleMapsAvailable()
  	      ) {
  	        return {
  	          ready: true,
  	          wrapper: mapInput,
  	          map: mapInstance,
  	          element: mapElement,
  	          maps: window.google.maps
  	        };
  	      }

  	      /*
  	       * Some current Google Maps loaders expose importLibrary before the actual
  	       * Map component has finished creating its instance.
  	       */
  	      try {
  	        if (
  	          window.google &&
  	          window.google.maps &&
  	          typeof window.google.maps.importLibrary === "function"
  	        ) {
  	          await Promise.race([
  	            window.google.maps.importLibrary("maps"),
  	            nextFrame()
  	          ]);
  	        }
  	      } catch (_) {}

  	      if (document.hidden) await sleep(20);
  	      else await nextFrame();

  	      mapInstance = mobileTrackingExtractMap(mapInput);
  	      mapElement = mobileTrackingExtractMapElement(
  	        mapInput,
  	        mapInstance
  	      );
  	    }

  	    return {
  	      ready: false,
  	      wrapper: mapInput,
  	      map: mapInstance,
  	      element: mapElement,
  	      maps:
  	        mobileTrackingGoogleMapsAvailable()
  	          ? window.google.maps
  	          : null
  	    };
  	  }

  	  function mobileTrackingSnapshotElement(element) {
  	    if (!element) return null;
  	    return {
  	      cssText: element.style.cssText || "",
  	      className: element.className || ""
  	    };
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Google Maps loading — aligned with the FIF Dashboard loader
  	  // ---------------------------------------------------------------------------
  	  function mobileTrackingGoogleMapsKey() {
  	    const data = appBag();

  	    const configuredKey = clean(
  	      firstValue([
  	        getPath(data, "GoogleMapsApiKey", ""),
  	        getPath(data, "Settings.GoogleMapsApiKey", ""),
  	        getPath(data, "Configuration.GoogleMapsApiKey", ""),
  	        getPath(data, "Configuration.Maps.ApiKey", ""),
  	        getPath(data, "Tracking.GoogleMapsApiKey", ""),
  	        getPath(App, "GoogleMapsApiKey", ""),
  	        typeof window !== "undefined"
  	          ? window.GOOGLE_MAPS_API_KEY
  	          : "",
  	        ""
  	      ], "")
  	    );

  	    if (configuredKey) return configuredKey;
  	    if (typeof document === "undefined") return "";

  	    /*
  	     * This is important in Backendless UI Builder: another FIF component may
  	     * already have loaded Google Maps. Reuse the key from that script instead
  	     * of requiring this mobile function to receive it separately.
  	     */
  	    const mapsScript = Array.prototype.find.call(
  	      document.scripts || [],
  	      function (script) {
  	        return /maps\.googleapis\.com\/maps\/api\/js/i.test(
  	          script.src || ""
  	        );
  	      }
  	    );

  	    if (!mapsScript || !mapsScript.src) return "";

  	    try {
  	      return clean(
  	        new URL(
  	          mapsScript.src,
  	          window.location.href
  	        ).searchParams.get("key")
  	      );
  	    } catch (_) {
  	      const match = mapsScript.src.match(/[?&]key=([^&]+)/i);
  	      return match
  	        ? clean(decodeURIComponent(match[1]))
  	        : "";
  	    }
  	  }

  	  function mobileTrackingEnsureGoogleMaps() {
  	    if (
  	      typeof window !== "undefined" &&
  	      window.google &&
  	      window.google.maps &&
  	      typeof window.google.maps.Map === "function"
  	    ) {
  	      return Promise.resolve(window.google.maps);
  	    }

  	    /*
  	     * Use the exact shared promise name used by the Dashboard. This prevents
  	     * Dashboard + Mobile Track from injecting two Google Maps scripts while
  	     * both functions are mounting.
  	     */
  	    if (window.__fifGoogleMapsPromise) {
  	      return window.__fifGoogleMapsPromise;
  	    }

  	    window.__fifGoogleMapsPromise = new Promise(function (
  	      resolve,
  	      reject
  	    ) {
  	      let settled = false;

  	      const finish = function () {
  	        if (settled) return;

  	        if (
  	          typeof window !== "undefined" &&
  	          window.google &&
  	          window.google.maps &&
  	          typeof window.google.maps.Map === "function"
  	        ) {
  	          settled = true;
  	          resolve(window.google.maps);
  	        }
  	      };

  	      const fail = function (message) {
  	        if (settled) return;
  	        settled = true;

  	        /*
  	         * Clear the failed shared promise so a later mount can retry after
  	         * AppData/configuration has been corrected.
  	         */
  	        try {
  	          delete window.__fifGoogleMapsPromise;
  	        } catch (_) {
  	          window.__fifGoogleMapsPromise = null;
  	        }

  	        reject(new Error(message));
  	      };

  	      const existing = Array.prototype.find.call(
  	        document.scripts || [],
  	        function (script) {
  	          return /maps\.googleapis\.com\/maps\/api\/js/i.test(
  	            script.src || ""
  	          );
  	        }
  	      );

  	      if (existing) {
  	        /*
  	         * Same strategy as the Dashboard: attach to the existing Maps script
  	         * rather than adding another copy.
  	         */
  	        existing.addEventListener(
  	          "load",
  	          finish,
  	          { once: true }
  	        );

  	        existing.addEventListener(
  	          "error",
  	          function () {
  	            fail("Google Maps could not load.");
  	          },
  	          { once: true }
  	        );

  	        /*
  	         * The script may have completed before these listeners were attached.
  	         * Poll briefly for google.maps.Map rather than assuming a load event
  	         * will still fire.
  	         */
  	        const deadline = Date.now() + 10000;

  	        const waitForExisting = function () {
  	          finish();
  	          if (settled) return;

  	          if (Date.now() >= deadline) {
  	            fail(
  	              "Google Maps script was found, but the Maps JavaScript API did not become ready."
  	            );
  	            return;
  	          }

  	          setTimeout(waitForExisting, 80);
  	        };

  	        waitForExisting();
  	        return;
  	      }

  	      const key = mobileTrackingGoogleMapsKey();

  	      if (!key) {
  	        fail(
  	          "Google Maps is not loaded and GoogleMapsApiKey is not configured in App Data."
  	        );
  	        return;
  	      }

  	      const script = document.createElement("script");
  	      script.src =
  	        "https://maps.googleapis.com/maps/api/js?key=" +
  	        encodeURIComponent(key) +
  	        "&v=weekly";
  	      script.async = true;
  	      script.defer = true;

  	      script.addEventListener(
  	        "load",
  	        function () {
  	          finish();

  	          /*
  	           * Very occasionally the script load event arrives one task before
  	           * google.maps.Map is exposed. Give it a short readiness window.
  	           */
  	          if (!settled) {
  	            const deadline = Date.now() + 4000;

  	            const waitForMaps = function () {
  	              finish();
  	              if (settled) return;

  	              if (Date.now() >= deadline) {
  	                fail(
  	                  "Google Maps loaded without the Maps JavaScript API."
  	                );
  	                return;
  	              }

  	              setTimeout(waitForMaps, 50);
  	            };

  	            waitForMaps();
  	          }
  	        },
  	        { once: true }
  	      );

  	      script.addEventListener(
  	        "error",
  	        function () {
  	          fail("Google Maps could not load.");
  	        },
  	        { once: true }
  	      );

  	      document.head.appendChild(script);
  	    });

  	    return window.__fifGoogleMapsPromise;
  	  }

  	  // ---------------------------------------------------------------------------
  	  // UI
  	  // ---------------------------------------------------------------------------
  	  function icon(name) {
  	    const icons = {
  	      refresh:
  	        '<svg viewBox="0 0 24 24"><path d="M20 6v5h-5M4 18v-5h5M6.1 8.2A7 7 0 0 1 18.8 7L20 11M4 13l1.2 4A7 7 0 0 0 17.9 15.8"/></svg>',
  	      locate:
  	        '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/></svg>',
  	      play:
  	        '<svg viewBox="0 0 24 24"><path d="M8 5l11 7-11 7z"/></svg>',
  	      pause:
  	        '<svg viewBox="0 0 24 24"><path d="M8 5v14M16 5v14"/></svg>',
  	      car:
  	        '<svg viewBox="0 0 24 24"><path d="M5 17h14l-1-6-2-4H8l-2 4-1 6zM7 17v2M17 17v2M7 13h10"/><circle cx="8" cy="16" r="1"/><circle cx="16" cy="16" r="1"/></svg>',
  	      history:
  	        '<svg viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5M12 7v5l3 2"/></svg>',
  	      chevron:
  	        '<svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>',
  	      logout:
  	        '<svg viewBox="0 0 24 24"><path d="M10 5H5v14h5M14 8l4 4-4 4M9 12h9"/></svg>',
  	      directions:
  	        '<svg viewBox="0 0 24 24"><path d="M6 19V6.5A2.5 2.5 0 0 1 8.5 4H17M14 1l3 3-3 3M6 19l-3-3M6 19l3-3M10 10h4a3 3 0 0 1 3 3v5"/></svg>',
  	      location:
  	        '<svg viewBox="0 0 24 24"><path d="M12 21s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12z"/><circle cx="12" cy="9" r="2.4"/></svg>'
  	    };
  	    return icons[name] || "";
  	  }

  	  function injectStyle() {
  	    const old = document.getElementById(STYLE_ID);
  	    if (old) old.remove();

  	    const style = document.createElement("style");
  	    style.id = STYLE_ID;
  	    style.textContent = `
  	      #${ROOT_ID} {
  	        --fif-accent:#c86a37;
  	        --fif-accent-2:#ef9a61;
  	        --fif-bg:#090b0a;
  	        --fif-panel:rgba(15,18,16,.94);
  	        --fif-panel-2:rgba(24,28,25,.94);
  	        --fif-border:rgba(210,111,57,.34);
  	        --fif-text:#f6f4ef;
  	        --fif-muted:#9da49f;
  	        --fif-good:#71d47b;
  	        --fif-warn:#ffb44a;
  	        --fif-bad:#f06868;
  	        position:fixed;
  	        inset:0;
  	        z-index:2147482000;
  	        background:transparent;
  	        color:var(--fif-text);
  	        pointer-events:none;
  	        font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  	        overflow:hidden;
  	        touch-action:manipulation;
  	        -webkit-tap-highlight-color:transparent;
  	      }
  	      #${ROOT_ID} *{box-sizing:border-box}
  	      #${ROOT_ID} button,
  	      #${ROOT_ID} select,
  	      #${ROOT_ID} input{font:inherit}
  	      #${ROOT_ID} .fmt-map{
  	        position:absolute;
  	        inset:0;
  	        z-index:0;
  	        width:100%;
  	        height:100%;
  	        min-width:100%;
  	        min-height:100%;
  	        background:#111;
  	        display:block;
  	        pointer-events:auto;
  	      }
  	      #${ROOT_ID} .fmt-map:after{
  	        content:"";
  	        position:absolute;
  	        inset:0;
  	        pointer-events:none;
  	        box-shadow:inset 0 0 70px rgba(0,0,0,.24);
  	      }
  	      #${ROOT_ID} .fmt-top{
  	        position:absolute;
  	        z-index:55;
  	        top:max(8px,env(safe-area-inset-top));
  	        left:8px;
  	        right:8px;
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        pointer-events:none;
  	      }
  	      #${ROOT_ID} .fmt-top-logo,
  	      #${ROOT_ID} .fmt-icon-btn{
  	        pointer-events:auto;
  	        backdrop-filter:blur(16px);
  	        -webkit-backdrop-filter:blur(16px);
  	        background:rgba(9,11,10,.84);
  	        border:1px solid rgba(210,111,57,.30);
  	        box-shadow:0 8px 24px rgba(0,0,0,.28);
  	      }
  	      #${ROOT_ID} .fmt-top-logo{
  	        width:50px;
  	        height:46px;
  	        border-radius:14px;
  	        display:flex;
  	        align-items:center;
  	        justify-content:center;
  	        padding:4px;
  	      }
  	      #${ROOT_ID} .fmt-logo{
  	        width:42px;
  	        height:30px;
  	        display:flex;
  	        align-items:center;
  	        justify-content:center;
  	        overflow:hidden;
  	      }
  	      #${ROOT_ID} .fmt-logo img{
  	        max-width:100%;
  	        max-height:100%;
  	        object-fit:contain;
  	      }
  	      #${ROOT_ID} .fmt-icon-btn{
  	        width:46px;
  	        height:46px;
  	        border-radius:14px;
  	        color:#fff;
  	        display:grid;
  	        place-items:center;
  	        cursor:pointer;
  	        border-color:rgba(210,111,57,.30);
  	      }
  	      #${ROOT_ID} .fmt-icon-btn:active{transform:scale(.96)}
  	      #${ROOT_ID} .fmt-icon-btn svg{
  	        width:20px;
  	        height:20px;
  	        fill:none;
  	        stroke:currentColor;
  	        stroke-width:2;
  	        stroke-linecap:round;
  	        stroke-linejoin:round;
  	      }
  	      #${ROOT_ID} .fmt-logout-wrap{
  	        position:relative;
  	        pointer-events:auto;
  	      }
  	      #${ROOT_ID} .fmt-app-menu{
  	        position:absolute;
  	        z-index:2147483647;
  	        top:calc(100% + 6px);
  	        right:0;
  	        width:210px;
  	        max-width:calc(100vw - 16px);
  	        max-height:260px;
  	        padding:5px;
  	        box-sizing:border-box;
  	        overflow-x:hidden;
  	        overflow-y:auto;
  	        color:#fff;
  	        background:
  	          radial-gradient(circle at 18% 0%,rgba(255,133,49,.14),transparent 35%),
  	          repeating-radial-gradient(
  	            ellipse at 34% 118%,
  	            transparent 0,
  	            transparent 9px,
  	            rgba(255,116,34,.12) 10px,
  	            transparent 12px
  	          ),
  	          linear-gradient(145deg,rgba(16,17,16,.985),rgba(3,7,7,.99));
  	        border:1px solid rgba(255,122,36,.52);
  	        border-radius:13px;
  	        box-shadow:
  	          0 18px 34px rgba(0,0,0,.48),
  	          inset 0 1px 0 rgba(255,255,255,.055),
  	          inset 0 -18px 38px rgba(0,0,0,.24);
  	        transform-origin:top right;
  	        animation:fmt-app-menu-in .14s ease-out;
  	        pointer-events:auto;
  	      }
  	      #${ROOT_ID} .fmt-app-menu[hidden]{display:none!important}
  	      #${ROOT_ID} .fmt-app-option{
  	        display:block;
  	        width:100%;
  	        min-height:34px;
  	        margin:2px 0;
  	        padding:8px 11px;
  	        box-sizing:border-box;
  	        border:0;
  	        border-radius:9px;
  	        color:rgba(255,255,255,.88);
  	        background:transparent;
  	        font:800 13px/1.35 system-ui,sans-serif;
  	        text-align:left;
  	        cursor:pointer;
  	        transition:background .14s ease,color .14s ease,box-shadow .14s ease;
  	      }
  	      #${ROOT_ID} .fmt-app-option:hover,
  	      #${ROOT_ID} .fmt-app-option:focus-visible{
  	        color:#fff;
  	        outline:none;
  	        background:rgba(255,138,61,.14);
  	      }
  	      #${ROOT_ID} .fmt-app-option:active{
  	        color:#fff;
  	        background:linear-gradient(145deg,rgba(255,122,36,.28),rgba(95,42,17,.32));
  	        box-shadow:
  	          inset 0 0 0 1px rgba(255,138,61,.34),
  	          inset 0 0 18px rgba(255,105,25,.12);
  	      }
  	      #${ROOT_ID} .fmt-app-option:disabled{
  	        opacity:.48;
  	        cursor:default;
  	      }
  	      #${ROOT_ID} .fmt-app-option.logout{
  	        margin-top:5px;
  	        color:#ff8a3d;
  	        border-top:1px solid rgba(255,122,36,.25);
  	        border-radius:0 0 9px 9px;
  	      }
  	      #${ROOT_ID} .fmt-app-status{
  	        display:none;
  	        padding:7px 11px 5px;
  	        color:#ff8a3d;
  	        font:700 12px/1.35 system-ui,sans-serif;
  	      }
  	      #${ROOT_ID} .fmt-app-status.visible{display:block}
  	      @keyframes fmt-app-menu-in{
  	        from{opacity:0;transform:translateY(-4px) scale(.98)}
  	        to{opacity:1;transform:translateY(0) scale(1)}
  	      }

  	      /* MAP-FIRST BOTTOM DOCK */
  	      #${ROOT_ID} .fmt-sheet{
  	        position:absolute;
  	        pointer-events:auto;
  	        z-index:25;
  	        left:8px;
  	        right:8px;
  	        bottom:max(8px,env(safe-area-inset-bottom));
  	        min-height:0;
  	        max-height:min(44vh,350px);
  	        padding:7px 9px 8px;
  	        border:1px solid rgba(210,111,57,.26);
  	        border-radius:18px;
  	        background:
  	          linear-gradient(180deg,rgba(24,28,25,.94),rgba(10,12,11,.965));
  	        backdrop-filter:blur(20px);
  	        -webkit-backdrop-filter:blur(20px);
  	        box-shadow:0 14px 42px rgba(0,0,0,.42);
  	        overflow:auto;
  	        overscroll-behavior:contain;
  	      }
  	      #${ROOT_ID} .fmt-grab{
  	        width:38px;
  	        height:3px;
  	        border-radius:999px;
  	        background:rgba(255,255,255,.20);
  	        margin:0 auto 6px;
  	      }

  	      #${ROOT_ID} .fmt-mode-row{
  	        display:grid;
  	        grid-template-columns:1.08fr repeat(4,1fr);
  	        gap:5px;
  	        padding:0;
  	        margin:0 0 6px;
  	        position:static;
  	        background:none;
  	      }
  	      #${ROOT_ID} .fmt-mode{
  	        min-width:0;
  	        min-height:36px;
  	        border-radius:10px;
  	        border:1px solid rgba(255,255,255,.075);
  	        background:rgba(255,255,255,.045);
  	        color:#d8ddd9;
  	        font-weight:850;
  	        font-size:10px;
  	        padding:0 5px;
  	        cursor:pointer;
  	        white-space:nowrap;
  	      }
  	      #${ROOT_ID} .fmt-mode.active{
  	        color:#fff;
  	        border-color:rgba(220,117,61,.70);
  	        background:linear-gradient(180deg,rgba(190,91,45,.94),rgba(133,62,30,.96));
  	        box-shadow:0 5px 16px rgba(180,81,35,.20);
  	      }
  	      #${ROOT_ID} .fmt-live-dot{
  	        display:inline-block;
  	        width:6px;
  	        height:6px;
  	        border-radius:50%;
  	        margin-right:4px;
  	        background:var(--fif-good);
  	        box-shadow:0 0 0 3px rgba(113,212,123,.10);
  	      }

  	      #${ROOT_ID} .fmt-map-actions{
  	        display:grid;
  	        grid-template-columns:repeat(2,minmax(0,1fr));
  	        gap:5px;
  	        margin:0 0 6px;
  	        position:relative;
  	      }
  	      #${ROOT_ID} .fmt-map-action{
  	        min-height:34px;
  	        border-radius:10px;
  	        border:1px solid rgba(255,255,255,.075);
  	        background:rgba(255,255,255,.035);
  	        color:#dce1dd;
  	        display:flex;
  	        align-items:center;
  	        justify-content:center;
  	        gap:7px;
  	        padding:0 9px;
  	        font-size:9px;
  	        font-weight:900;
  	        cursor:pointer;
  	      }
  	      #${ROOT_ID} .fmt-map-action svg{
  	        width:15px;height:15px;fill:none;stroke:currentColor;
  	        stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round
  	      }
  	      #${ROOT_ID} .fmt-map-action.active{
  	        color:#fff;
  	        border-color:rgba(221,116,59,.62);
  	        background:rgba(180,82,37,.22);
  	      }
  	      /* The legacy desktop map control is engine-only on Mobile. */
  	      #${ROOT_ID} .trackit-compact-map-control,
  	      #${ROOT_ID} > .trackit-compact-map-control{
  	        display:none !important;
  	      }

  	      /* Guided Directions: map + wizard only. */
  	      #${ROOT_ID}.directions-active .fmt-top,
  	      #${ROOT_ID}.directions-active .fmt-sheet{
  	        opacity:0 !important;
  	        visibility:hidden !important;
  	        pointer-events:none !important;
  	      }

  	      #${ROOT_ID} > .trackit-directions-popup.fif-directions-wizard{
  	        position:fixed !important;
  	        z-index:95 !important;
  	        left:50% !important;
  	        right:auto !important;
  	        top:auto !important;
  	        bottom:max(10px,env(safe-area-inset-bottom)) !important;
  	        transform:translateX(-50%) !important;
  	        width:min(520px,calc(100vw - 18px)) !important;
  	        max-width:none !important;
  	        max-height:min(50vh,440px) !important;
  	        overflow:auto !important;
  	        overscroll-behavior:contain !important;
  	        margin:0 !important;
  	        padding:0 !important;
  	        border-radius:18px !important;
  	        border:1px solid rgba(214,108,52,.40) !important;
  	        background:linear-gradient(180deg,rgba(22,25,22,.985),rgba(8,10,9,.99)) !important;
  	        box-shadow:0 18px 48px rgba(0,0,0,.54) !important;
  	        color:#fff !important;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .trackit-directions-popup-header{
  	        cursor:default !important;
  	        padding:11px 12px 9px !important;
  	        border-bottom:1px solid rgba(255,255,255,.06) !important;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .trackit-directions-popup-title{
  	        font-size:15px !important;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .trackit-directions-popup-subtitle{
  	        margin-top:2px !important;
  	        color:#aab1ac !important;
  	        font-size:9px !important;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-progress{
  	        display:grid;
  	        grid-template-columns:repeat(4,1fr);
  	        gap:4px;
  	        padding:8px 10px 0;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-progress-step{
  	        min-height:25px;
  	        display:flex;
  	        align-items:center;
  	        justify-content:center;
  	        border-radius:8px;
  	        border:1px solid rgba(255,255,255,.07);
  	        background:rgba(255,255,255,.025);
  	        color:#747d77;
  	        font-size:8px;
  	        font-weight:900;
  	        text-transform:uppercase;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-progress-step.complete{
  	        color:#b8dcbc;
  	        border-color:rgba(97,180,106,.24);
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-progress-step.active{
  	        color:#fff;
  	        border-color:rgba(220,115,57,.55);
  	        background:rgba(184,83,37,.22);
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .trackit-directions-status{
  	        margin:8px 10px 0 !important;
  	        padding:7px 9px !important;
  	        border-radius:9px !important;
  	        background:rgba(255,255,255,.03) !important;
  	        color:#c7cec9 !important;
  	        font-size:9px !important;
  	        line-height:1.35 !important;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-step{
  	        display:none;
  	        padding:9px 10px 2px;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-step.active{
  	        display:block;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-help{
  	        margin:0 0 7px;
  	        color:#9da69f;
  	        font-size:9px;
  	        line-height:1.4;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .trackit-directions-search-line{
  	        grid-template-columns:46px minmax(0,1fr) !important;
  	        gap:7px !important;
  	        margin:0 !important;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard input,
  	      #${ROOT_ID} > .fif-directions-wizard select{
  	        min-height:40px !important;
  	        border-radius:10px !important;
  	        font-size:12px !important;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .trackit-directions-popup-body{
  	        padding:0 !important;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .trackit-directions-row{
  	        min-height:30px !important;
  	        padding:5px 1px !important;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-footer{
  	        display:grid;
  	        grid-template-columns:.72fr 1.28fr;
  	        gap:7px;
  	        padding:9px 10px 10px;
  	        border-top:1px solid rgba(255,255,255,.06);
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-back,
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-next{
  	        min-height:39px;
  	        border-radius:10px;
  	        border:1px solid rgba(255,255,255,.08);
  	        font-size:10px;
  	        font-weight:900;
  	        cursor:pointer;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-back{
  	        background:rgba(255,255,255,.045);
  	        color:#d7ddd8;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-next{
  	        background:linear-gradient(180deg,rgba(190,91,45,.96),rgba(133,62,30,.98));
  	        border-color:rgba(220,117,61,.68);
  	        color:#fff;
  	      }
  	      #${ROOT_ID} > .fif-directions-wizard .fif-directions-next:disabled{
  	        opacity:.42;
  	        cursor:not-allowed;
  	      }
  	      @media (orientation:landscape) and (max-height:540px){
  	        #${ROOT_ID} > .trackit-directions-popup.fif-directions-wizard{
  	          width:min(430px,42vw) !important;
  	          left:auto !important;
  	          right:8px !important;
  	          transform:none !important;
  	          bottom:8px !important;
  	          max-height:calc(100dvh - 16px) !important;
  	        }
  	      }

  	      #${ROOT_ID} .fmt-field-label{
  	        min-height:15px;
  	        margin:0 2px 4px;
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        gap:8px;
  	        color:#9ca49e;
  	        font-size:8.5px;
  	        font-weight:900;
  	        letter-spacing:.075em;
  	        text-transform:uppercase;
  	      }
  	      #${ROOT_ID} .fmt-field-meta{
  	        display:flex;
  	        align-items:center;
  	        gap:7px;
  	        min-width:0;
  	        text-align:right;
  	        color:#909892;
  	      }
  	      #${ROOT_ID} .fmt-field-meta > span{
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	      #${ROOT_ID} .fmt-meta-sep{opacity:.35}
  	      #${ROOT_ID} .fmt-countdown{
  	        color:#bfc6c1;
  	        font-weight:850;
  	      }

  	      #${ROOT_ID} .fmt-select-wrap{
  	        position:relative;
  	        min-width:0;
  	      }
  	      #${ROOT_ID} .fmt-select{
  	        display:none!important;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-button{
  	        width:100%;
  	        min-height:40px;
  	        display:grid;
  	        grid-template-columns:31px minmax(0,1fr) auto 12px;
  	        align-items:center;
  	        gap:7px;
  	        border:1px solid rgba(255,255,255,.085);
  	        border-radius:11px;
  	        background:rgba(8,11,9,.84);
  	        color:#fff;
  	        padding:3px 10px 3px 7px;
  	        outline:none;
  	        cursor:pointer;
  	        text-align:left;
  	        box-sizing:border-box;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-button:focus,
  	      #${ROOT_ID} .fmt-select-wrap.open .fmt-vehicle-picker-button{
  	        border-color:rgba(211,106,53,.62);
  	        box-shadow:0 0 0 2px rgba(198,96,46,.10);
  	      }
  	      #${ROOT_ID} .fmt-picker-icon{
  	        width:29px;
  	        height:29px;
  	        display:block;
  	        object-fit:contain;
  	      }
  	      #${ROOT_ID} .fmt-picker-copy{
  	        min-width:0;
  	        display:flex;
  	        flex-direction:column;
  	        justify-content:center;
  	      }
  	      #${ROOT_ID} .fmt-picker-registration{
  	        min-width:0;
  	        color:#fff;
  	        font-size:11px;
  	        line-height:13px;
  	        font-weight:900;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	      #${ROOT_ID} .fmt-picker-company{
  	        min-width:0;
  	        margin-top:1px;
  	        color:#89928c;
  	        font-size:8px;
  	        line-height:10px;
  	        font-weight:720;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	      #${ROOT_ID} .fmt-picker-status-dot{
  	        width:8px;
  	        height:8px;
  	        flex:none;
  	        border-radius:50%;
  	        opacity:0;
  	        box-shadow:none;
  	      }
  	      #${ROOT_ID} .fmt-picker-status-dot.moving{
  	        opacity:1;
  	        background:#18a058;
  	        box-shadow:0 0 0 3px rgba(24,160,88,.13);
  	      }
  	      #${ROOT_ID} .fmt-picker-status-dot.warning{
  	        opacity:1;
  	        background:#ee4b2b;
  	        box-shadow:0 0 0 3px rgba(238,75,43,.14);
  	      }
  	      #${ROOT_ID} .fmt-picker-chevron{
  	        width:0;
  	        height:0;
  	        border-left:4px solid transparent;
  	        border-right:4px solid transparent;
  	        border-top:5px solid #8f9791;
  	        transition:transform 120ms ease;
  	        justify-self:end;
  	      }
  	      #${ROOT_ID} .fmt-select-wrap.open .fmt-picker-chevron{
  	        transform:rotate(180deg);
  	      }
  	      /*
  	       * FULL-SCREEN vehicle selector.
  	       *
  	       * When opened the menu is temporarily re-parented directly under ROOT_ID,
  	       * so the bottom sheet's overflow/backdrop-filter can never clip it.
  	       */
  	      #${ROOT_ID} .fmt-vehicle-picker-menu{
  	        display:none;
  	      }
  	      #${ROOT_ID}.vehicle-picker-open > .fmt-vehicle-picker-menu{
  	        position:absolute;
  	        inset:0;
  	        z-index:2147483646;
  	        display:block;
  	        width:100%;
  	        height:100%;
  	        max-width:none;
  	        max-height:none;
  	        overflow-y:auto;
  	        overflow-x:hidden;
  	        overscroll-behavior:contain;
  	        pointer-events:auto;
  	        border:0;
  	        border-radius:0;
  	        background:
  	          linear-gradient(180deg,rgba(13,17,14,.995),rgba(7,9,8,.998));
  	        box-shadow:none;
  	        padding:
  	          max(10px,env(safe-area-inset-top))
  	          10px
  	          max(12px,env(safe-area-inset-bottom));
  	        box-sizing:border-box;
  	        scrollbar-width:thin;
  	        scrollbar-color:rgba(190,190,190,.42) rgba(255,255,255,.03);
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-header{
  	        position:sticky;
  	        top:0;
  	        z-index:3;
  	        min-height:48px;
  	        display:grid;
  	        grid-template-columns:minmax(0,1fr) auto;
  	        align-items:center;
  	        gap:10px;
  	        margin:-2px -2px 6px;
  	        padding:5px 5px 9px;
  	        background:linear-gradient(180deg,#0d110e 72%,rgba(13,17,14,.90));
  	        border-bottom:1px solid rgba(211,106,53,.30);
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-header-copy{
  	        min-width:0;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-header-copy strong{
  	        display:block;
  	        color:#fff;
  	        font-size:15px;
  	        line-height:18px;
  	        font-weight:950;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-header-copy span{
  	        display:block;
  	        margin-top:2px;
  	        color:#8f9892;
  	        font-size:9px;
  	        line-height:11px;
  	        font-weight:760;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-close{
  	        width:42px;
  	        height:42px;
  	        display:grid;
  	        place-items:center;
  	        border:1px solid rgba(255,255,255,.09);
  	        border-radius:11px;
  	        background:rgba(255,255,255,.045);
  	        color:#fff;
  	        font-size:24px;
  	        line-height:1;
  	        cursor:pointer;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-option{
  	        width:100%;
  	        min-height:46px;
  	        display:grid;
  	        grid-template-columns:31px minmax(0,1fr) auto;
  	        align-items:center;
  	        gap:7px;
  	        padding:4px 7px;
  	        margin:0;
  	        border:0;
  	        border-bottom:1px solid rgba(255,255,255,.055);
  	        border-radius:8px;
  	        background:transparent;
  	        color:#fff;
  	        text-align:left;
  	        cursor:pointer;
  	        box-sizing:border-box;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-option:last-child{
  	        border-bottom:0;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-option:hover,
  	      #${ROOT_ID} .fmt-vehicle-picker-option.selected{
  	        background:rgba(211,106,53,.17);
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-option.selected{
  	        box-shadow:inset 0 0 0 1px rgba(211,106,53,.26);
  	      }
  	      #${ROOT_ID} .fmt-vehicle-picker-empty{
  	        padding:10px;
  	        color:#8d968f;
  	        font-size:10px;
  	        font-weight:760;
  	      }

  	      /* Vehicle card becomes a compact information rail on wider screens. */
  	      #${ROOT_ID} .fmt-card{
  	        margin-top:6px;
  	        padding:8px 9px;
  	        border-radius:12px;
  	        border:1px solid rgba(255,255,255,.065);
  	        background:rgba(255,255,255,.028);
  	        display:grid;
  	        grid-template-columns:minmax(150px,.72fr) minmax(0,2.28fr);
  	        align-items:center;
  	        gap:10px;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-head{
  	        min-width:0;
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        gap:8px;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-title{min-width:0}
  	      #${ROOT_ID} .fmt-vehicle-title strong{
  	        display:block;
  	        font-size:14px;
  	        line-height:1.12;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-title span{
  	        display:block;
  	        margin-top:2px;
  	        color:#929b95;
  	        font-size:9px;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	      #${ROOT_ID} .fmt-state{
  	        flex:none;
  	        border-radius:999px;
  	        padding:4px 7px;
  	        font-weight:900;
  	        font-size:8px;
  	        border:1px solid rgba(255,255,255,.08);
  	      }
  	      #${ROOT_ID} .fmt-state.moving{
  	        color:#bff5c5;
  	        background:rgba(62,142,74,.18);
  	      }
  	      #${ROOT_ID} .fmt-state.parked{
  	        color:#d7dbd8;
  	        background:rgba(255,255,255,.055);
  	      }
  	      #${ROOT_ID} .fmt-state.stale{
  	        color:#ffd59b;
  	        background:rgba(207,127,39,.17);
  	      }
  	      #${ROOT_ID} .fmt-state.offline{
  	        color:#ffb1b1;
  	        background:rgba(179,57,57,.18);
  	      }
  	      #${ROOT_ID} .fmt-stats{
  	        display:grid;
  	        grid-template-columns:repeat(4,minmax(0,1fr));
  	        gap:5px;
  	        margin:0;
  	      }
  	      #${ROOT_ID} .fmt-stat{
  	        min-width:0;
  	        min-height:43px;
  	        padding:6px 7px;
  	        border-radius:9px;
  	        background:rgba(6,9,7,.86);
  	        border:1px solid rgba(255,255,255,.045);
  	        display:flex;
  	        flex-direction:column;
  	        justify-content:center;
  	      }
  	      #${ROOT_ID} .fmt-stat span{
  	        display:block;
  	        color:#7f8882;
  	        font-size:7px;
  	        font-weight:900;
  	        text-transform:uppercase;
  	        letter-spacing:.07em;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	      #${ROOT_ID} .fmt-stat strong{
  	        display:block;
  	        margin-top:2px;
  	        font-size:11px;
  	        line-height:1.1;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }

  	      #${ROOT_ID} .fmt-history-controls{
  	        display:none;
  	        margin-top:6px;
  	        padding-top:6px;
  	        border-top:1px solid rgba(255,255,255,.05);
  	      }
  	      #${ROOT_ID}.history .fmt-history-controls{display:block}
  	      #${ROOT_ID} .fmt-replay-row{
  	        display:grid;
  	        grid-template-columns:38px 1fr;
  	        gap:8px;
  	        align-items:center;
  	      }
  	      #${ROOT_ID} .fmt-replay-btn{
  	        width:38px;
  	        height:38px;
  	        border:1px solid rgba(210,111,57,.34);
  	        border-radius:10px;
  	        background:rgba(190,92,43,.14);
  	        color:#fff;
  	        display:grid;
  	        place-items:center;
  	        cursor:pointer;
  	      }
  	      #${ROOT_ID} .fmt-replay-btn svg{
  	        width:17px;
  	        height:17px;
  	        fill:none;
  	        stroke:currentColor;
  	        stroke-width:2.2;
  	        stroke-linecap:round;
  	        stroke-linejoin:round;
  	      }
  	      #${ROOT_ID} .fmt-replay-btn svg path[d^="M8 5l"]{
  	        fill:currentColor;
  	        stroke:none;
  	      }
  	      #${ROOT_ID} .fmt-slider{
  	        width:100%;
  	        accent-color:var(--fif-accent);
  	      }
  	      #${ROOT_ID} .fmt-replay-meta{
  	        margin-top:3px;
  	        padding-left:46px;
  	        color:#8d9690;
  	        font-size:8.5px;
  	        display:flex;
  	        justify-content:space-between;
  	        gap:10px;
  	      }

  	      /* Old footer was wasted vertical space; countdown now lives beside fleet status. */
  	      #${ROOT_ID} .fmt-foot{display:none !important}

  	      #${ROOT_ID} .fmt-error{
  	        display:none;
  	        margin-top:5px;
  	        border:1px solid rgba(237,102,102,.24);
  	        background:rgba(137,41,41,.14);
  	        color:#ffd0d0;
  	        padding:7px 9px;
  	        border-radius:9px;
  	        font-size:9.5px;
  	        line-height:1.3;
  	      }
  	      #${ROOT_ID} .fmt-error.show{display:block}
  	      #${ROOT_ID} .fmt-loading{
  	        position:absolute;
  	        pointer-events:none;
  	        z-index:70;
  	        left:50%;
  	        top:50%;
  	        transform:translate(-50%,-50%);
  	        border:1px solid var(--fif-border);
  	        background:rgba(9,11,10,.93);
  	        color:#fff;
  	        border-radius:14px;
  	        padding:10px 12px;
  	        box-shadow:0 12px 34px rgba(0,0,0,.34);
  	        display:none;
  	        align-items:center;
  	        gap:9px;
  	        font-size:11px;
  	        font-weight:750;
  	      }
  	      #${ROOT_ID} .fmt-loading.show{display:flex}
  	      #${ROOT_ID} .fmt-spinner{
  	        width:16px;
  	        height:16px;
  	        border-radius:50%;
  	        border:2px solid rgba(255,255,255,.17);
  	        border-top-color:var(--fif-accent-2);
  	        animation:fmtspin .7s linear infinite;
  	      }
  	      @keyframes fmtspin{to{transform:rotate(360deg)}}
  	      #${ROOT_ID} .fmt-toast{
  	        position:absolute;
  	        z-index:80;
  	        left:10px;
  	        right:10px;
  	        top:calc(max(8px,env(safe-area-inset-top)) + 54px);
  	        margin:auto;
  	        max-width:520px;
  	        opacity:0;
  	        transform:translateY(-8px);
  	        pointer-events:none;
  	        transition:.2s ease;
  	        background:rgba(10,12,11,.96);
  	        border:1px solid var(--fif-border);
  	        border-radius:12px;
  	        padding:9px 11px;
  	        color:#fff;
  	        font-size:10.5px;
  	        box-shadow:0 12px 34px rgba(0,0,0,.38);
  	      }
  	      #${ROOT_ID} .fmt-toast.show{
  	        opacity:1;
  	        transform:translateY(0);
  	      }
  	      #${ROOT_ID} .fmt-map-error{
  	        position:absolute;
  	        inset:0;
  	        display:grid;
  	        place-items:center;
  	        padding:22px;
  	        background:radial-gradient(circle at 50% 20%,#242820,#090b0a 65%);
  	      }
  	      #${ROOT_ID} .fmt-map-error-card{
  	        width:min(100%,440px);
  	        border:1px solid var(--fif-border);
  	        border-radius:20px;
  	        padding:18px;
  	        background:rgba(15,18,16,.92);
  	        box-shadow:0 18px 46px rgba(0,0,0,.4);
  	      }
  	      #${ROOT_ID} .fmt-map-error-card strong{font-size:17px}
  	      #${ROOT_ID} .fmt-map-error-card p{
  	        color:var(--fif-muted);
  	        font-size:12px;
  	        line-height:1.5;
  	      }

  	      /* Phone portrait: keep the dock compact but allow the vehicle head above metrics. */
  	      @media (max-width:620px){
  	        #${ROOT_ID} .fmt-sheet{
  	          left:5px;
  	          right:5px;
  	          bottom:max(5px,env(safe-area-inset-bottom));
  	          padding:6px 7px 7px;
  	          border-radius:16px;
  	          max-height:min(49vh,390px);
  	        }
  	        #${ROOT_ID} .fmt-mode-row{gap:4px}
  	        #${ROOT_ID} .fmt-mode{
  	          min-height:35px;
  	          font-size:8.5px;
  	          padding:0 2px;
  	        }
  	        #${ROOT_ID} .fmt-card{
  	          grid-template-columns:1fr;
  	          gap:6px;
  	        }
  	        #${ROOT_ID} .fmt-vehicle-head{
  	          min-height:27px;
  	        }
  	        #${ROOT_ID} .fmt-stats{
  	          grid-template-columns:repeat(4,minmax(0,1fr));
  	          gap:4px;
  	        }
  	        #${ROOT_ID} .fmt-stat{
  	          min-height:39px;
  	          padding:5px;
  	        }
  	        #${ROOT_ID} .fmt-stat span{font-size:6.3px}
  	        #${ROOT_ID} .fmt-stat strong{font-size:9.5px}
  	        #${ROOT_ID} .fmt-field-meta{
  	          max-width:70%;
  	          gap:5px;
  	        }
  	      }

  	      @media (max-width:370px){
  	        #${ROOT_ID} .fmt-mode{
  	          font-size:7.7px;
  	        }
  	        #${ROOT_ID} .fmt-stats{
  	          grid-template-columns:repeat(2,minmax(0,1fr));
  	        }
  	        #${ROOT_ID} .fmt-stat{
  	          min-height:35px;
  	        }
  	      }

  	      /* Landscape phone: narrow right-side command dock, maximum map visibility. */
  	      @media (orientation:landscape) and (max-height:540px){
  	        #${ROOT_ID} .fmt-sheet{
  	          left:auto;
  	          right:6px;
  	          top:6px;
  	          bottom:6px;
  	          width:min(370px,43vw);
  	          max-height:none;
  	          height:auto;
  	          border-radius:16px;
  	          padding:6px 7px;
  	        }
  	        #${ROOT_ID} .fmt-mode-row{
  	          grid-template-columns:repeat(5,1fr);
  	        }
  	        #${ROOT_ID} .fmt-card{
  	          grid-template-columns:1fr;
  	        }
  	        #${ROOT_ID} .fmt-top{
  	          right:calc(min(370px,43vw) + 14px);
  	        }
  	        #${ROOT_ID} .fmt-stats{
  	          grid-template-columns:repeat(2,1fr);
  	        }
  	      }
  	      /* =========================================================
  	       * V1.0.14 ULTRA-COMPACT MOBILE DOCK
  	       * ========================================================= */
  	      #${ROOT_ID} .fmt-top{
  	        left:auto;
  	        right:8px;
  	        width:auto;
  	        justify-content:flex-end;
  	      }
  	      #${ROOT_ID} .fmt-top-logo{display:none!important}

  	      #${ROOT_ID} .fmt-sheet{
  	        left:6px;
  	        right:6px;
  	        bottom:max(6px,env(safe-area-inset-bottom));
  	        padding:5px 6px 6px;
  	        border-radius:16px;
  	        max-height:min(38vh,285px);
  	        overflow:auto;
  	      }
  	      #${ROOT_ID} .fmt-grab{
  	        width:34px;
  	        margin:0 auto 5px;
  	      }

  	      #${ROOT_ID} .fmt-primary-row{
  	        display:grid;
  	        grid-template-columns:64px minmax(0,1fr);
  	        gap:5px;
  	        margin:0 0 5px;
  	      }
  	      #${ROOT_ID} .fmt-live-logo{
  	        position:relative;
  	        min-height:38px;
  	        border-radius:11px;
  	        border:1px solid rgba(255,255,255,.08);
  	        background:rgba(255,255,255,.04);
  	        display:flex;
  	        align-items:center;
  	        justify-content:center;
  	        padding:3px 6px;
  	        cursor:pointer;
  	        overflow:hidden;
  	      }
  	      #${ROOT_ID} .fmt-live-logo.active{
  	        border-color:rgba(220,117,61,.68);
  	        background:
  	          linear-gradient(180deg,rgba(181,84,40,.44),rgba(92,43,22,.42));
  	        box-shadow:0 4px 14px rgba(179,80,35,.16);
  	      }
  	      #${ROOT_ID} .fmt-live-logo-image{
  	        width:50px;
  	        height:29px;
  	        display:flex;
  	        align-items:center;
  	        justify-content:center;
  	      }
  	      #${ROOT_ID} .fmt-live-logo-image img{
  	        max-width:100%;
  	        max-height:100%;
  	        object-fit:contain;
  	      }
  	      #${ROOT_ID} .fmt-live-logo-image svg{
  	        width:25px;
  	        height:25px;
  	        fill:none;
  	        stroke:#fff;
  	      }
  	      #${ROOT_ID} .fmt-live-led{
  	        position:absolute;
  	        right:5px;
  	        bottom:4px;
  	        width:6px;
  	        height:6px;
  	        border-radius:50%;
  	        background:#73d87f;
  	        box-shadow:0 0 0 3px rgba(115,216,127,.11);
  	      }
  	      #${ROOT_ID}.history .fmt-live-led{
  	        background:#66706a;
  	        box-shadow:none;
  	      }

  	      #${ROOT_ID} .fmt-history-select-wrap{
  	        position:relative;
  	      }
  	      #${ROOT_ID} .fmt-history-select{
  	        width:100%;
  	        min-height:38px;
  	        appearance:none;
  	        -webkit-appearance:none;
  	        border:1px solid rgba(255,255,255,.08);
  	        border-radius:11px;
  	        background:rgba(255,255,255,.04);
  	        color:#dce1dd;
  	        padding:0 34px 0 11px;
  	        outline:none;
  	        font-size:10px;
  	        font-weight:900;
  	        text-transform:uppercase;
  	      }
  	      #${ROOT_ID}.history .fmt-history-select{
  	        color:#fff;
  	        border-color:rgba(220,117,61,.68);
  	        background:
  	          linear-gradient(180deg,rgba(181,84,40,.33),rgba(92,43,22,.30));
  	      }
  	      #${ROOT_ID} .fmt-history-select-wrap > svg{
  	        position:absolute;
  	        right:10px;
  	        top:50%;
  	        width:14px;
  	        height:14px;
  	        transform:translateY(-50%);
  	        fill:none;
  	        stroke:#8e9791;
  	        stroke-width:2;
  	        pointer-events:none;
  	      }

  	      /* Old five-button mode strip is no longer part of Mobile. */
  	      #${ROOT_ID} .fmt-mode-row{display:none!important}

  	      #${ROOT_ID} .fmt-map-actions{
  	        gap:5px;
  	        margin:0 0 5px;
  	      }
  	      #${ROOT_ID} .fmt-map-action{
  	        min-height:31px;
  	        border-radius:9px;
  	        font-size:8.5px;
  	        gap:6px;
  	      }
  	      #${ROOT_ID} .fmt-map-action svg{
  	        width:14px;
  	        height:14px;
  	      }

  	      #${ROOT_ID} .fmt-field-label,
  	      #${ROOT_ID} .fmt-field-meta{
  	        display:none!important;
  	      }

  	      #${ROOT_ID} .fmt-vehicle-row{
  	        display:grid;
  	        grid-template-columns:minmax(0,1fr) auto;
  	        gap:5px;
  	        align-items:center;
  	        margin:0 0 5px;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-row .fmt-vehicle-picker-button{
  	        min-height:38px;
  	        border-radius:10px;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-row .fmt-state{
  	        min-width:58px;
  	        min-height:30px;
  	        display:flex;
  	        align-items:center;
  	        justify-content:center;
  	        padding:0 7px;
  	        font-size:7.5px;
  	        white-space:nowrap;
  	      }

  	      /* The selected vehicle dropdown already IS the vehicle title. */
  	      #${ROOT_ID} .fmt-card{
  	        margin:0;
  	        padding:0;
  	        border:0;
  	        background:transparent;
  	        display:block;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-head{
  	        display:none!important;
  	      }
  	      #${ROOT_ID} .fmt-stats{
  	        display:grid;
  	        grid-template-columns:repeat(3,minmax(0,1fr));
  	        gap:4px;
  	        margin:0;
  	      }
  	      #${ROOT_ID} .fmt-stat{
  	        min-height:36px;
  	        padding:5px 6px;
  	        border-radius:8px;
  	      }
  	      #${ROOT_ID} .fmt-stat span{
  	        font-size:6.3px;
  	      }
  	      #${ROOT_ID} .fmt-stat strong{
  	        margin-top:1px;
  	        font-size:9.5px;
  	      }

  	      #${ROOT_ID} .fmt-history-controls{
  	        margin-top:5px;
  	        padding-top:5px;
  	      }
  	      #${ROOT_ID} .fmt-replay-row{
  	        grid-template-columns:34px 1fr;
  	        gap:6px;
  	      }
  	      #${ROOT_ID} .fmt-replay-btn{
  	        width:34px;
  	        height:34px;
  	        border-radius:9px;
  	      }
  	      #${ROOT_ID} .fmt-replay-meta{
  	        padding-left:40px;
  	        margin-top:2px;
  	        font-size:8px;
  	      }

  	      #${ROOT_ID} .fmt-error{
  	        margin-top:4px;
  	        padding:6px 8px;
  	      }

  	      @media (max-width:370px){
  	        #${ROOT_ID} .fmt-primary-row{
  	          grid-template-columns:58px minmax(0,1fr);
  	        }
  	        #${ROOT_ID} .fmt-live-logo-image{
  	          width:45px;
  	        }
  	        #${ROOT_ID} .fmt-stats{
  	          grid-template-columns:repeat(3,minmax(0,1fr));
  	        }
  	        #${ROOT_ID} .fmt-stat strong{
  	          font-size:8.7px;
  	        }
  	      }

  	      @media (orientation:landscape) and (max-height:540px){
  	        #${ROOT_ID} .fmt-sheet{
  	          left:auto;
  	          right:6px;
  	          top:auto;
  	          bottom:6px;
  	          width:min(330px,40vw);
  	          height:auto;
  	          max-height:calc(100dvh - 12px);
  	          border-radius:16px;
  	          padding:5px 6px 6px;
  	        }
  	        #${ROOT_ID} .fmt-top{
  	          right:calc(min(330px,40vw) + 14px);
  	        }
  	      }

  	      #${ROOT_ID} .fmt-vehicle-action-bubble{
  	        width:min(310px,76vw);
  	        box-sizing:border-box;
  	        color:#fff;
  	        font-family:Inter,Arial,sans-serif;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-head{
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        gap:9px;
  	        padding:3px 2px 9px;
  	        border-bottom:1px solid rgba(255,255,255,.08);
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-title{
  	        min-width:0;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-title strong{
  	        display:block;
  	        font-size:13px;
  	        line-height:1.2;
  	        font-weight:950;
  	        color:#fff;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-title span{
  	        display:block;
  	        margin-top:3px;
  	        color:#98a19b;
  	        font-size:9px;
  	        font-weight:760;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-body{
  	        padding-top:9px;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-btn{
  	        width:100%;
  	        min-height:44px;
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        gap:10px;
  	        margin:0 0 7px;
  	        padding:0 11px;
  	        border:1px solid rgba(255,255,255,.10);
  	        border-radius:10px;
  	        background:rgba(255,255,255,.045);
  	        color:#fff;
  	        font-size:11px;
  	        font-weight:900;
  	        text-align:left;
  	        cursor:pointer;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-btn:last-of-type{
  	        margin-bottom:0;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-btn:hover{
  	        border-color:rgba(216,104,52,.68);
  	        background:rgba(216,104,52,.14);
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-btn .fmt-action-arrow{
  	        color:#d66d38;
  	        font-size:17px;
  	        flex:none;
  	      }
  	      #${ROOT_ID} .fmt-whatsapp-panel{
  	        margin-top:8px;
  	        padding:9px;
  	        border:1px solid rgba(115,216,127,.20);
  	        border-radius:10px;
  	        background:rgba(47,105,55,.10);
  	        display:none;
  	      }
  	      #${ROOT_ID} .fmt-whatsapp-panel.show{
  	        display:block;
  	      }
  	      #${ROOT_ID} .fmt-whatsapp-panel label{
  	        display:block;
  	        margin-bottom:6px;
  	        color:#bcc5bf;
  	        font-size:9px;
  	        font-weight:850;
  	        text-transform:uppercase;
  	        letter-spacing:.04em;
  	      }
  	      #${ROOT_ID} .fmt-whatsapp-row{
  	        display:grid;
  	        grid-template-columns:minmax(0,1fr) auto;
  	        gap:6px;
  	      }
  	      #${ROOT_ID} .fmt-whatsapp-input{
  	        min-width:0;
  	        min-height:42px;
  	        border:1px solid rgba(255,255,255,.11);
  	        border-radius:9px;
  	        background:#090b0a;
  	        color:#fff;
  	        padding:0 10px;
  	        outline:none;
  	        font-size:16px;
  	      }
  	      #${ROOT_ID} .fmt-whatsapp-send{
  	        min-width:72px;
  	        min-height:42px;
  	        border:1px solid rgba(115,216,127,.42);
  	        border-radius:9px;
  	        background:linear-gradient(180deg,rgba(58,145,73,.88),rgba(33,100,45,.94));
  	        color:#fff;
  	        padding:0 10px;
  	        font-size:10px;
  	        font-weight:950;
  	        cursor:pointer;
  	      }
  	      #${ROOT_ID} .fmt-whatsapp-help{
  	        margin-top:6px;
  	        color:#818b84;
  	        font-size:8px;
  	        line-height:1.35;
  	      }

  	      #${ROOT_ID} .gm-style .gm-style-iw-c{
  	        background:#111411!important;
  	        color:#fff!important;
  	        border-radius:14px!important;
  	        border:1px solid rgba(213,109,55,.35)!important;
  	        box-shadow:0 12px 34px rgba(0,0,0,.44)!important;
  	        overflow:visible!important;
  	        max-height:none!important;
  	      }
  	      #${ROOT_ID} .gm-style .gm-style-iw-d{
  	        overflow:visible!important;
  	        overflow-x:visible!important;
  	        overflow-y:visible!important;
  	        max-height:none!important;
  	        padding:0!important;
  	      }
  	      #${ROOT_ID} .fmt-vehicle-action-bubble{
  	        overflow:visible!important;
  	      }
  	      #${ROOT_ID} .gm-style .gm-style-iw-tc:after{background:#111411!important}
  	      #${ROOT_ID} .gm-ui-hover-effect span{background-color:#fff!important}
  	      @media (max-width:380px){
  	        #${ROOT_ID} .fmt-top-logo{width:56px;height:48px}
  	        #${ROOT_ID} .fmt-icon-btn{width:48px;height:48px}
  	        #${ROOT_ID} .fmt-logo{width:44px;height:32px}
  	        #${ROOT_ID} .fmt-stats{grid-template-columns:repeat(2,1fr)}
  	        #${ROOT_ID} .fmt-sheet{max-height:61vh}
  	      }
  	      @media (orientation:landscape) and (max-height:520px){
  	        #${ROOT_ID} .fmt-sheet{left:auto;width:min(390px,48vw);max-height:100%;height:100%;border-radius:22px 0 0 22px;padding-top:max(12px,env(safe-area-inset-top))}
  	        #${ROOT_ID} .fmt-top{right:calc(min(390px,48vw) + 10px)}
  	      }
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function mountShell() {
  	    const old = document.getElementById(ROOT_ID);
  	    if (old) old.remove();

  	    const logo = normaliseLogo(SVG);
  	    const root = document.createElement("section");
  	    root.id = ROOT_ID;
  	    root.innerHTML = `
  	      <div class="fmt-map" data-map></div>

  	      <div class="fmt-top">
  	        <div class="fmt-logout-wrap" data-app-menu-wrap>
  	          <button
  	            class="fmt-icon-btn"
  	            type="button"
  	            data-action="logout"
  	            aria-label="Switch application or log out"
  	            aria-haspopup="menu"
  	            aria-expanded="false"
  	            title="Switch App / Logout"
  	          >
  	            ${icon("logout")}
  	          </button>
  	          <div
  	            class="fmt-app-menu"
  	            data-app-menu
  	            role="menu"
  	            aria-label="Available applications"
  	            hidden
  	          ></div>
  	        </div>
  	      </div>

  	      <div class="fmt-sheet">
  	        <div class="fmt-grab"></div>

  	        <div class="fmt-primary-row">
  	          <button
  	            type="button"
  	            class="fmt-live-logo active"
  	            data-mode="live"
  	            aria-label="Live tracking"
  	            title="Live Tracking"
  	          >
  	            <span class="fmt-live-led"></span>
  	            <span class="fmt-live-logo-image">
  	              ${logo ? '<img src="' + escapeAttr(logo) + '" alt="Fleet In Form">' : icon("car")}
  	            </span>
  	          </button>

  	          <div class="fmt-history-select-wrap">
  	            <select class="fmt-history-select" data-history-select aria-label="Historical tracking interval">
  	              <option value="">Historical</option>
  	              <option value="30">30 MIN</option>
  	              <option value="60">1 HOUR</option>
  	              <option value="180">3 HOURS</option>
  	              <option value="360">6 HOURS</option>
  	            </select>
  	            ${icon("chevron")}
  	          </div>
  	        </div>

  	        <div class="fmt-map-actions" data-map-actions>
  	          <button type="button" class="fmt-map-action" data-mobile-map-action="directions">
  	            ${icon("directions")}
  	            <span>Directions</span>
  	          </button>
  	          <button type="button" class="fmt-map-action" data-mobile-map-action="locations" aria-pressed="false">
  	            ${icon("location")}
  	            <span data-mobile-locations-label>Locations</span>
  	          </button>
  	        </div>

  	        <div class="fmt-vehicle-row">
  	          <div class="fmt-select-wrap" data-vehicle-picker>
  	            <select class="fmt-select" data-vehicle-select aria-label="Vehicle"></select>
  	            <button
  	              type="button"
  	              class="fmt-vehicle-picker-button"
  	              data-vehicle-picker-button
  	              aria-haspopup="listbox"
  	              aria-expanded="false"
  	              aria-label="Vehicle"
  	            ></button>
  	            <div
  	              class="fmt-vehicle-picker-menu"
  	              data-vehicle-picker-menu
  	              role="listbox"
  	              aria-label="Vehicles"
  	            ></div>
  	          </div>
  	          <span class="fmt-state parked" data-selected-status>—</span>
  	        </div>

  	        <div class="fmt-card" data-summary-card></div>

  	        <div class="fmt-history-controls">
  	          <div class="fmt-replay-row">
  	            <button type="button" class="fmt-replay-btn" data-action="replay" aria-label="Play route">
  	              ${icon("play")}
  	            </button>
  	            <input class="fmt-slider" data-replay-slider type="range" min="0" max="0" value="0" step="1" aria-label="Route position">
  	          </div>
  	          <div class="fmt-replay-meta">
  	            <span data-replay-time>—</span>
  	            <span data-replay-speed>—</span>
  	          </div>
  	        </div>

  	        <div class="fmt-error" data-error></div>

  	      </div>

  	      <div class="fmt-loading" data-loading>
  	        <span class="fmt-spinner"></span>
  	        <span data-loading-text>Loading…</span>
  	      </div>

  	      <div class="fmt-toast" data-toast></div>
  	    `;

  	    document.body.appendChild(root);
  	    return root;
  	  }

  	  injectStyle();
  	  const root = mountShell();

  	  function el(selector) {
  	    return root.querySelector(selector);
  	  }

  	  function showLoading(show, text) {
  	    const node = el("[data-loading]");
  	    const copy = el("[data-loading-text]");
  	    if (copy && text) copy.textContent = text;
  	    if (node) node.classList.toggle("show", !!show);
  	  }

  	  let toastTimer = null;
  	  function toast(message) {
  	    const node = el("[data-toast]");
  	    if (!node) return;

  	    node.textContent = clean(message);
  	    node.classList.add("show");

  	    if (toastTimer) clearTimeout(toastTimer);
  	    toastTimer = setTimeout(function () {
  	      if (node) node.classList.remove("show");
  	    }, 3200);
  	  }

  	  function setError(message) {
  	    state.lastError = clean(message);
  	    const node = el("[data-error]");
  	    if (!node) return;

  	    node.textContent = state.lastError;
  	    node.classList.toggle("show", !!state.lastError);
  	  }

  	  function vehicleIsMovingNow(vehicle) {
  	    if (!vehicle) return false;
  	    return liveStatus(state.liveByKey[vehicle.key]).className === "moving";
  	  }

  	  function vehiclePickerIndicator(vehicle) {
  	    if (!vehicle) return "";

  	    const message = state.liveByKey[vehicle.key];
  	    const visual = liveVehicleVisualState(vehicle, message);

  	    // IMPORTANT:
  	    // Preserve the ORIGINAL movement-dot rule exactly.
  	    // A vehicle is GREEN whenever liveStatus() says MOVING.
  	    // The ONLY change is that the same red-ring warning state overrides
  	    // that green dot and makes it RED.
  	    if (visual.warning) return "warning";
  	    if (vehicleIsMovingNow(vehicle)) return "moving";
  	    return "";
  	  }

  	  function vehiclePickerIconUrl(vehicle) {
  	    const message = vehicle ? state.liveByKey[vehicle.key] : null;

  	    return (
  	      "data:image/svg+xml;charset=UTF-8," +
  	      encodeURIComponent(
  	        liveBadgeSvg(
  	          vehicle || { color: "#d46d34" },
  	          message || {}
  	        )
  	      )
  	    );
  	  }

  	  function compareVehicleAlphaNumeric(a, b) {
  	    const registrationCompare = clean(a && a.registration).localeCompare(
  	      clean(b && b.registration),
  	      undefined,
  	      { sensitivity: "base", numeric: true }
  	    );

  	    if (registrationCompare !== 0) return registrationCompare;

  	    return companyName(a && a.company).localeCompare(
  	      companyName(b && b.company),
  	      undefined,
  	      { sensitivity: "base", numeric: true }
  	    );
  	  }

  	  function orderedVehiclesForSelector() {
  	    return state.vehicles.slice().sort(function (a, b) {
  	      const aMoving = vehicleIsMovingNow(a);
  	      const bMoving = vehicleIsMovingNow(b);

  	      if (aMoving !== bMoving) {
  	        return aMoving ? -1 : 1;
  	      }

  	      return compareVehicleAlphaNumeric(a, b);
  	    });
  	  }

  	  function vehicleOptionsHtml() {
  	    if (!state.vehicles.length) {
  	      return '<option value="">No tracked vehicles available</option>';
  	    }

  	    return orderedVehiclesForSelector().map(function (vehicle) {
  	      return (
  	        '<option value="' +
  	        escapeAttr(vehicle.key) +
  	        '"' +
  	        (vehicle.key === state.selectedKey ? " selected" : "") +
  	        ">" +
  	        escapeHtml(vehicle.registration) +
  	        " — " +
  	        escapeHtml(companyName(vehicle.company)) +
  	        "</option>"
  	      );
  	    }).join("");
  	  }

  	  function vehiclePickerRowHtml(vehicle, selected) {
  	    const indicator = vehiclePickerIndicator(vehicle);

  	    return (
  	      '<button type="button" class="fmt-vehicle-picker-option' +
  	      (selected ? " selected" : "") +
  	      '" data-vehicle-picker-key="' +
  	      escapeAttr(vehicle.key) +
  	      '" role="option" aria-selected="' +
  	      (selected ? "true" : "false") +
  	      '">' +
  	        '<img class="fmt-picker-icon" src="' +
  	        escapeAttr(vehiclePickerIconUrl(vehicle)) +
  	        '" alt="">' +
  	        '<span class="fmt-picker-copy">' +
  	          '<span class="fmt-picker-registration">' +
  	            escapeHtml(vehicle.registration) +
  	          '</span>' +
  	          '<span class="fmt-picker-company">' +
  	            escapeHtml(companyName(vehicle.company)) +
  	          '</span>' +
  	        '</span>' +
  	        '<span class="fmt-picker-status-dot ' +
  	          escapeAttr(indicator) +
  	        '" aria-hidden="true"></span>' +
  	      '</button>'
  	    );
  	  }

  	  function renderVehiclePicker() {
  	    const wrap = el("[data-vehicle-picker]");
  	    const button = el("[data-vehicle-picker-button]");
  	    const menu = el("[data-vehicle-picker-menu]");

  	    if (!wrap || !button || !menu) return;

  	    const ordered = orderedVehiclesForSelector();
  	    const selected =
  	      ordered.find(function (vehicle) {
  	        return vehicle.key === state.selectedKey;
  	      }) ||
  	      ordered[0] ||
  	      null;

  	    if (!selected) {
  	      button.innerHTML =
  	        '<span></span>' +
  	        '<span class="fmt-picker-copy">' +
  	          '<span class="fmt-picker-registration">No tracked vehicles available</span>' +
  	        '</span>' +
  	        '<span></span>' +
  	        '<span class="fmt-picker-chevron"></span>';

  	      menu.innerHTML =
  	        '<div class="fmt-vehicle-picker-empty">No tracked vehicles available</div>';
  	      button.disabled = true;
  	      return;
  	    }

  	    button.disabled = false;

  	    const indicator = vehiclePickerIndicator(selected);

  	    button.innerHTML =
  	      '<img class="fmt-picker-icon" src="' +
  	      escapeAttr(vehiclePickerIconUrl(selected)) +
  	      '" alt="">' +
  	      '<span class="fmt-picker-copy">' +
  	        '<span class="fmt-picker-registration">' +
  	          escapeHtml(selected.registration) +
  	        '</span>' +
  	        '<span class="fmt-picker-company">' +
  	          escapeHtml(companyName(selected.company)) +
  	        '</span>' +
  	      '</span>' +
  	      '<span class="fmt-picker-status-dot ' +
  	        escapeAttr(indicator) +
  	      '" aria-hidden="true"></span>' +
  	      '<span class="fmt-picker-chevron" aria-hidden="true"></span>';

  	    menu.innerHTML =
  	      '<div class="fmt-vehicle-picker-header">' +
  	        '<div class="fmt-vehicle-picker-header-copy">' +
  	          '<strong>Vehicles</strong>' +
  	          '<span>Moving vehicles first · warning overrides movement dot</span>' +
  	        '</div>' +
  	        '<button type="button" class="fmt-vehicle-picker-close" ' +
  	          'data-vehicle-picker-close aria-label="Close vehicle list">×</button>' +
  	      '</div>' +
  	      ordered.map(function (vehicle) {
  	        return vehiclePickerRowHtml(
  	          vehicle,
  	          vehicle.key === selected.key
  	        );
  	      }).join("");

  	    wrap.classList.toggle("open", !!state.vehiclePickerOpen);
  	    button.setAttribute(
  	      "aria-expanded",
  	      state.vehiclePickerOpen ? "true" : "false"
  	    );
  	  }

  	  function setVehiclePickerOpen(open) {
  	    state.vehiclePickerOpen = !!open;

  	    const wrap = el("[data-vehicle-picker]");
  	    const button = el("[data-vehicle-picker-button]");
  	    const menu = el("[data-vehicle-picker-menu]");

  	    if (state.vehiclePickerOpen) {
  	      // Move the menu OUT of the scrollable bottom dock. This is the important
  	      // layering fix: the selector now lives directly under the full-screen root.
  	      if (menu && menu.parentNode !== root) {
  	        root.appendChild(menu);
  	      }

  	      root.classList.add("vehicle-picker-open");
  	    } else {
  	      root.classList.remove("vehicle-picker-open");

  	      // Put the menu back beside the button when closed so normal component
  	      // teardown/remount behaviour remains simple and predictable.
  	      if (menu && wrap && menu.parentNode !== wrap) {
  	        wrap.appendChild(menu);
  	      }
  	    }

  	    if (wrap) {
  	      wrap.classList.toggle("open", state.vehiclePickerOpen);
  	    }

  	    if (button) {
  	      button.setAttribute(
  	        "aria-expanded",
  	        state.vehiclePickerOpen ? "true" : "false"
  	      );
  	    }
  	  }

  	  function updateVehicleSelect() {
  	    const select = el("[data-vehicle-select]");
  	    if (!select) return;

  	    const currentValue = state.selectedKey;
  	    select.innerHTML = vehicleOptionsHtml();

  	    if (
  	      currentValue &&
  	      Array.from(select.options).some(function (option) {
  	        return option.value === currentValue;
  	      })
  	    ) {
  	      select.value = currentValue;
  	    }

  	    renderVehiclePicker();
  	  }

  	  function liveStatus(message) {
  	    if (!message) {
  	      return { label: "NO DATA", className: "offline" };
  	    }

  	    const ts = timestampSeconds(message);
  	    const age = ts === null ? Infinity : Date.now() / 1000 - ts;

  	    if (age >= OFFLINE_AFTER_SEC) {
  	      return { label: "OFFLINE", className: "offline" };
  	    }

  	    if (age >= STALE_AFTER_SEC) {
  	      return { label: "STALE", className: "stale" };
  	    }

  	    if (movementOf(message)) {
  	      return { label: "MOVING", className: "moving" };
  	    }

  	    return {
  	      label: ignitionOf(message) ? "STOPPED" : "PARKED",
  	      className: "parked"
  	    };
  	  }

  	  function fleetSummary() {
  	    let moving = 0;
  	    let stale = 0;

  	    state.vehicles.forEach(function (vehicle) {
  	      const message = state.liveByKey[vehicle.key];
  	      const status = liveStatus(message);
  	      if (status.className === "moving") moving += 1;
  	      if (
  	        status.className === "stale" ||
  	        status.className === "offline"
  	      ) {
  	        stale += 1;
  	      }
  	    });

  	    return {
  	      total: state.vehicles.length,
  	      moving: moving,
  	      stale: stale
  	    };
  	  }

  	  function renderSummaryCard() {
  	    const card =
  	      el("[data-summary-card]");
  	    const statusNode =
  	      el("[data-selected-status]");

  	    if (!card) return;

  	    const vehicle =
  	      selectedVehicle();

  	    if (!vehicle) {
  	      card.innerHTML = "";
  	      if (statusNode) {
  	        statusNode.className =
  	          "fmt-state offline";
  	        statusNode.textContent =
  	          "NO DATA";
  	      }
  	      return;
  	    }

  	    if (state.mode === "history") {
  	      const summary =
  	        state.routeSummary;

  	      if (statusNode) {
  	        statusNode.className =
  	          "fmt-state parked";
  	        statusNode.textContent =
  	          summary ? "ROUTE" : "HISTORY";
  	      }

  	      card.innerHTML = `
  	        <div class="fmt-stats">
  	          <div class="fmt-stat">
  	            <span>Distance</span>
  	            <strong>${summary ? escapeHtml(formatDistance(summary.distanceKm)) : "—"}</strong>
  	          </div>
  	          <div class="fmt-stat">
  	            <span>Duration</span>
  	            <strong>${summary ? escapeHtml(formatClock(summary.durationSec)) : "—"}</strong>
  	          </div>
  	          <div class="fmt-stat">
  	            <span>Max Speed</span>
  	            <strong>${summary ? escapeHtml(formatNumber(summary.maxSpeed, 0) + " km/h") : "—"}</strong>
  	          </div>
  	        </div>
  	      `;
  	      return;
  	    }

  	    const message =
  	      state.liveByKey[vehicle.key];
  	    const status =
  	      liveStatus(message);
  	    const speed =
  	      message ? speedOf(message) : 0;
  	    const ignition =
  	      message
  	        ? ignitionOf(message)
  	        : false;
  	    const lastMovedAt =
  	      state.lastMovedByKey[vehicle.key] !==
  	      undefined
  	        ? state.lastMovedByKey[vehicle.key]
  	        : (
  	            message &&
  	            messageShowsMovement(message)
  	              ? timestampSeconds(message)
  	              : null
  	          );

  	    if (statusNode) {
  	      statusNode.className =
  	        "fmt-state " +
  	        status.className;
  	      statusNode.textContent =
  	        status.label;
  	    }

  	    card.innerHTML = `
  	      <div class="fmt-stats">
  	        <div class="fmt-stat">
  	          <span>Speed</span>
  	          <strong>${message ? escapeHtml(formatNumber(speed, 0) + " km/h") : "—"}</strong>
  	        </div>
  	        <div class="fmt-stat">
  	          <span>Ignition</span>
  	          <strong>${message ? (ignition ? "ON" : "OFF") : "—"}</strong>
  	        </div>
  	        <div class="fmt-stat">
  	          <span>Last Moved</span>
  	          <strong>${lastMovedAt ? escapeHtml(timeAgo(lastMovedAt)) : "—"}</strong>
  	        </div>
  	      </div>
  	    `;
  	  }

  	  function updateCountdown() {
  	    const node = el("[data-countdown]");
  	    if (!node) return;

  	    if (state.mode !== "live") {
  	      node.textContent = state.historyBusy
  	        ? "Loading route…"
  	        : "Historical track";
  	      return;
  	    }

  	    if (state.liveBusy) {
  	      node.textContent = "Updating live…";
  	      return;
  	    }

  	    if (!state.nextLiveAt) {
  	      node.textContent = "Live ready";
  	      return;
  	    }

  	    const left = Math.max(0, Math.ceil((state.nextLiveAt - Date.now()) / 1000));
  	    node.textContent = "Next update " + left + "s";
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Canonical old TrackIT Map Control compatibility wrapper
  	  // ---------------------------------------------------------------------------
  	  function setMobileDirectionsUiActive(active) {
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return;

  	    root.classList.toggle(
  	      "directions-active",
  	      !!active
  	    );

  	    root.querySelector(
  	      '[data-mobile-map-action="directions"]'
  	    )?.classList?.toggle(
  	      "active",
  	      !!active
  	    );

  	    if (active) {
  	      try {
  	        state.infoWindow?.close?.();
  	      } catch (_) {}
  	    }
  	  }

  	  function finishMobileDirectionsWizard(map) {
  	    const s = map && map.__trackitDirections;
  	    if (!s) {
  	      setMobileDirectionsUiActive(false);
  	      return;
  	    }

  	    if (s.mapClickListener) {
  	      try {
  	        window.google.maps.event.removeListener(
  	          s.mapClickListener
  	        );
  	      } catch (_) {}
  	      s.mapClickListener = null;
  	    }

  	    if (s.__fifWizardTimer) {
  	      clearInterval(s.__fifWizardTimer);
  	      s.__fifWizardTimer = null;
  	    }

  	    try {
  	      s.popup?.remove?.();
  	    } catch (_) {}
  	    s.popup = null;

  	    /*
  	     * Leave the calculated DirectionsRenderer + A/B/stop markers on the map,
  	     * but stop accepting new map/vehicle points.
  	     */
  	    s.active = false;
  	    s.waitingFor = 0;
  	    s.activeSlot = "";

  	    setMobileDirectionsUiActive(false);
  	  }

  	  function syncMobileDirectionsWizard(map) {
  	    const s = map && map.__trackitDirections;
  	    const popup = s && s.popup;
  	    if (!s || !popup || !popup.classList.contains("fif-directions-wizard")) {
  	      return;
  	    }

  	    const step = Math.max(
  	      1,
  	      Math.min(
  	        4,
  	        Number(s.__fifWizardStep) || 1
  	      )
  	    );
  	    s.__fifWizardStep = step;

  	    popup.querySelectorAll(
  	      ".fif-directions-step"
  	    ).forEach(function (node) {
  	      node.classList.toggle(
  	        "active",
  	        Number(
  	          node.getAttribute("data-fif-step")
  	        ) === step
  	      );
  	    });

  	    popup.querySelectorAll(
  	      ".fif-directions-progress-step"
  	    ).forEach(function (node) {
  	      const nodeStep = Number(
  	        node.getAttribute("data-fif-step")
  	      );

  	      node.classList.toggle(
  	        "active",
  	        nodeStep === step
  	      );
  	      node.classList.toggle(
  	        "complete",
  	        nodeStep < step
  	      );
  	    });

  	    const subtitle = popup.querySelector(
  	      ".trackit-directions-popup-subtitle"
  	    );
  	    const status = popup.querySelector(
  	      ".trackit-directions-status"
  	    );
  	    const back = popup.querySelector(
  	      ".fif-directions-back"
  	    );
  	    const next = popup.querySelector(
  	      ".fif-directions-next"
  	    );
  	    const routeText = String(
  	      popup.querySelector(
  	        ".trackit-directions-route-text"
  	      )?.textContent || ""
  	    ).trim();
  	    const routeReady =
  	      !!routeText &&
  	      routeText !== "—";

  	    const titles = {
  	      1: "Step 1 of 4 · From",
  	      2: "Step 2 of 4 · Stops",
  	      3: "Step 3 of 4 · To",
  	      4: "Step 4 of 4 · Review & Share"
  	    };

  	    if (subtitle) {
  	      subtitle.textContent =
  	        step === 4 && routeReady
  	          ? routeText
  	          : titles[step];
  	    }

  	    if (back) {
  	      back.hidden = step === 1;
  	    }

  	    if (next) {
  	      if (step === 1) {
  	        next.textContent = "Next · Stops";
  	        next.disabled = !s.point1;
  	      } else if (step === 2) {
  	        next.textContent = "Next · Destination";
  	        next.disabled = false;
  	      } else if (step === 3) {
  	        next.textContent =
  	          routeReady
  	            ? "Review Route"
  	            : "Select Destination";
  	        next.disabled =
  	          !s.point2 || !routeReady;
  	      } else {
  	        next.textContent = "Done";
  	        next.disabled = !routeReady;
  	      }
  	    }

  	    if (status) {
  	      if (step === 1) {
  	        status.textContent = s.point1
  	          ? "Origin selected. Continue to optional stops."
  	          : "Choose From: search, enter a vehicle, tap the map, or tap a vehicle.";
  	      } else if (step === 2) {
  	        status.textContent =
  	          "Stops are optional. Tap Add Stop for each stop, or continue directly to Destination.";
  	      } else if (step === 3) {
  	        status.textContent = s.point2
  	          ? (
  	              routeReady
  	                ? "Route calculated. Review it."
  	                : "Calculating route…"
  	            )
  	          : "Choose To: search, enter a vehicle, tap the map, or tap a vehicle.";
  	      } else {
  	        status.textContent =
  	          "Review the route, WhatsApp it to the driver or another number, then tap Done.";
  	      }
  	    }

  	    /*
  	     * Old Directions auto-routes as soon as To exists. Therefore Mobile uses
  	     * From -> optional Stops -> To -> Review. It keeps the old engine intact
  	     * while still giving us a proper guided workflow.
  	     */
  	    if (step === 1) {
  	      s.active = true;
  	      s.activeSlot = "from";
  	    } else if (step === 2) {
  	      const onWaypoint =
  	        String(s.activeSlot || "").startsWith(
  	          "waypoint:"
  	        );

  	      /*
  	       * Prevent an accidental map tap during the optional-stops step from
  	       * becoming the Destination. Add Stop re-enables point capture.
  	       */
  	      if (!onWaypoint) {
  	        s.active = false;
  	      }
  	    } else if (step === 3) {
  	      s.active = true;
  	      s.activeSlot = "to";
  	    } else {
  	      s.active = false;
  	    }
  	  }

  	  function wizardizeDirectionsPopup(map) {
  	    const root = document.getElementById(ROOT_ID);
  	    const s = map && map.__trackitDirections;
  	    const popup = s && s.popup;

  	    if (!root || !s || !popup) return false;

  	    if (popup.parentNode !== root) {
  	      root.appendChild(popup);
  	    }

  	    popup.classList.add(
  	      "fif-directions-wizard"
  	    );
  	    setMobileDirectionsUiActive(true);

  	    if (!popup.__fifWizardBuilt) {
  	      popup.__fifWizardBuilt = true;

  	      const header = popup.querySelector(
  	        ".trackit-directions-popup-header"
  	      );
  	      const searchWrap = popup.querySelector(
  	        ".trackit-directions-search-wrap"
  	      );
  	      const fromRow = popup.querySelector(
  	        '[data-route-row="from"]'
  	      );
  	      const waypoints = popup.querySelector(
  	        ".trackit-directions-waypoints"
  	      );
  	      const addStop = popup.querySelector(
  	        ".trackit-directions-add-stop"
  	      );
  	      const toRow = popup.querySelector(
  	        '[data-route-row="to"]'
  	      );
  	      const status = popup.querySelector(
  	        ".trackit-directions-status"
  	      );
  	      const body = popup.querySelector(
  	        ".trackit-directions-popup-body"
  	      );

  	      if (
  	        !header ||
  	        !fromRow ||
  	        !waypoints ||
  	        !addStop ||
  	        !toRow ||
  	        !status ||
  	        !body
  	      ) {
  	        return false;
  	      }

  	      const progress =
  	        document.createElement("div");
  	      progress.className =
  	        "fif-directions-progress";
  	      progress.innerHTML = `
  	        <div class="fif-directions-progress-step active" data-fif-step="1">From</div>
  	        <div class="fif-directions-progress-step" data-fif-step="2">Stops</div>
  	        <div class="fif-directions-progress-step" data-fif-step="3">To</div>
  	        <div class="fif-directions-progress-step" data-fif-step="4">Share</div>
  	      `;

  	      header.insertAdjacentElement(
  	        "afterend",
  	        progress
  	      );

  	      const makeStep = function (
  	        number,
  	        helpText
  	      ) {
  	        const step =
  	          document.createElement("div");
  	        step.className =
  	          "fif-directions-step";
  	        step.setAttribute(
  	          "data-fif-step",
  	          String(number)
  	        );

  	        if (helpText) {
  	          const help =
  	            document.createElement("div");
  	          help.className =
  	            "fif-directions-help";
  	          help.textContent =
  	            helpText;
  	          step.appendChild(help);
  	        }

  	        return step;
  	      };

  	      const step1 = makeStep(
  	        1,
  	        "Select where the route starts."
  	      );
  	      const step2 = makeStep(
  	        2,
  	        "Stops are optional. Add one only when needed."
  	      );
  	      const step3 = makeStep(
  	        3,
  	        "Select the final destination."
  	      );
  	      const step4 = makeStep(
  	        4,
  	        ""
  	      );

  	      step1.appendChild(fromRow);
  	      step2.appendChild(waypoints);
  	      step2.appendChild(addStop);
  	      step3.appendChild(toRow);
  	      step4.appendChild(body);

  	      status.insertAdjacentElement(
  	        "afterend",
  	        step1
  	      );
  	      step1.insertAdjacentElement(
  	        "afterend",
  	        step2
  	      );
  	      step2.insertAdjacentElement(
  	        "afterend",
  	        step3
  	      );
  	      step3.insertAdjacentElement(
  	        "afterend",
  	        step4
  	      );

  	      if (searchWrap) {
  	        searchWrap.remove();
  	      }

  	      const footer =
  	        document.createElement("div");
  	      footer.className =
  	        "fif-directions-footer";
  	      footer.innerHTML = `
  	        <button type="button" class="fif-directions-back">Back</button>
  	        <button type="button" class="fif-directions-next">Next · Stops</button>
  	      `;
  	      popup.appendChild(footer);

  	      const back = footer.querySelector(
  	        ".fif-directions-back"
  	      );
  	      const next = footer.querySelector(
  	        ".fif-directions-next"
  	      );
  	      const close = popup.querySelector(
  	        ".trackit-directions-popup-close"
  	      );
  	      const newRoute = popup.querySelector(
  	        ".trackit-directions-new"
  	      );

  	      back?.addEventListener(
  	        "click",
  	        function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          s.__fifWizardStep = Math.max(
  	            1,
  	            Number(
  	              s.__fifWizardStep || 1
  	            ) - 1
  	          );
  	          syncMobileDirectionsWizard(map);
  	        }
  	      );

  	      next?.addEventListener(
  	        "click",
  	        function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          const step =
  	            Number(
  	              s.__fifWizardStep || 1
  	            );

  	          if (step === 1) {
  	            if (!s.point1) return;
  	            s.__fifWizardStep = 2;
  	          } else if (step === 2) {
  	            s.__fifWizardStep = 3;
  	          } else if (step === 3) {
  	            const routeText = String(
  	              popup.querySelector(
  	                ".trackit-directions-route-text"
  	              )?.textContent || ""
  	            ).trim();

  	            if (
  	              !s.point2 ||
  	              !routeText ||
  	              routeText === "—"
  	            ) {
  	              return;
  	            }
  	            s.__fifWizardStep = 4;
  	          } else {
  	            finishMobileDirectionsWizard(map);
  	            return;
  	          }

  	          syncMobileDirectionsWizard(map);
  	        }
  	      );

  	      /*
  	       * The old Add Stop listener runs first. Re-enable the old map click
  	       * capture immediately afterward so the user can tap the stop position.
  	       */
  	      addStop.addEventListener(
  	        "click",
  	        function () {
  	          setTimeout(function () {
  	            if (
  	              Number(
  	                s.__fifWizardStep || 1
  	              ) === 2
  	            ) {
  	              s.active = true;
  	              syncMobileDirectionsWizard(map);
  	            }
  	          }, 0);
  	        }
  	      );

  	      close?.addEventListener(
  	        "click",
  	        function () {
  	          setTimeout(function () {
  	            if (s.__fifWizardTimer) {
  	              clearInterval(
  	                s.__fifWizardTimer
  	              );
  	              s.__fifWizardTimer = null;
  	            }
  	            setMobileDirectionsUiActive(false);
  	          }, 0);
  	        }
  	      );

  	      newRoute?.addEventListener(
  	        "click",
  	        function () {
  	          setTimeout(function () {
  	            s.__fifWizardStep = 1;
  	            setMobileDirectionsUiActive(true);
  	            syncMobileDirectionsWizard(map);
  	          }, 0);
  	        }
  	      );
  	    }

  	    s.__fifWizardStep = 1;
  	    syncMobileDirectionsWizard(map);

  	    if (s.__fifWizardTimer) {
  	      clearInterval(s.__fifWizardTimer);
  	    }

  	    s.__fifWizardTimer =
  	      setInterval(function () {
  	        if (
  	          !s.popup ||
  	          !document.body.contains(
  	            s.popup
  	          )
  	        ) {
  	          clearInterval(
  	            s.__fifWizardTimer
  	          );
  	          s.__fifWizardTimer = null;
  	          setMobileDirectionsUiActive(false);
  	          return;
  	        }

  	        const step =
  	          Number(
  	            s.__fifWizardStep || 1
  	          );

  	        /*
  	         * Selecting From automatically advances to Stops. Selecting To lets
  	         * the old engine calculate its route, then advances to Review.
  	         */
  	        if (step === 1 && s.point1) {
  	          s.__fifWizardStep = 2;
  	        } else if (
  	          step === 3 &&
  	          s.point2
  	        ) {
  	          const routeText = String(
  	            s.popup.querySelector(
  	              ".trackit-directions-route-text"
  	            )?.textContent || ""
  	          ).trim();

  	          if (
  	            routeText &&
  	            routeText !== "—"
  	          ) {
  	            s.__fifWizardStep = 4;
  	          }
  	        }

  	        syncMobileDirectionsWizard(map);
  	      }, 180);

  	    return true;
  	  }

  	  function startMobileDirectionsWizard(map) {
  	    if (
  	      !map ||
  	      typeof map.__trackitStartDirectionsMode !==
  	        "function"
  	    ) {
  	      return false;
  	    }

  	    map.__trackitStartDirectionsMode();

  	    requestAnimationFrame(function () {
  	      wizardizeDirectionsPopup(map);
  	    });

  	    setTimeout(function () {
  	      wizardizeDirectionsPopup(map);
  	    }, 70);

  	    return true;
  	  }

  	  function installSlimBottomMapControls(map) {
  	    const root =
  	      document.getElementById(ROOT_ID);
  	    if (!root || !map) return false;

  	    const directionsButton =
  	      root.querySelector(
  	        '[data-mobile-map-action="directions"]'
  	      );
  	    const locationsButton =
  	      root.querySelector(
  	        '[data-mobile-map-action="locations"]'
  	      );
  	    const locationsLabel =
  	      root.querySelector(
  	        "[data-mobile-locations-label]"
  	      );

  	    const mapDiv =
  	      typeof map.getDiv === "function"
  	        ? map.getDiv()
  	        : null;
  	    const legacyControl =
  	      (
  	        mapDiv &&
  	        mapDiv.querySelector(
  	          ".trackit-compact-map-control"
  	        )
  	      ) ||
  	      document.querySelector(
  	        ".trackit-compact-map-control"
  	      );

  	    /*
  	     * Directions + Locations logic has already been wired by the old TrackIT
  	     * engine. Remove its desktop shell; Mobile exposes only our two buttons.
  	     */
  	    if (legacyControl) {
  	      try {
  	        legacyControl.remove();
  	      } catch (_) {
  	        legacyControl.style.display =
  	          "none";
  	      }
  	    }

  	    const paintLocations =
  	      function () {
  	        const on =
  	          typeof map.__trackitLocationsAllOn ===
  	            "function"
  	            ? !!map.__trackitLocationsAllOn()
  	            : false;

  	        if (locationsButton) {
  	          locationsButton.classList.toggle(
  	            "active",
  	            on
  	          );
  	          locationsButton.setAttribute(
  	            "aria-pressed",
  	            on ? "true" : "false"
  	          );
  	        }

  	        if (locationsLabel) {
  	          locationsLabel.textContent =
  	            on
  	              ? "Locations On"
  	              : "Locations";
  	        }
  	      };

  	    if (
  	      directionsButton &&
  	      !directionsButton.__fifDirectionsWired
  	    ) {
  	      directionsButton.__fifDirectionsWired =
  	        true;

  	      directionsButton.addEventListener(
  	        "click",
  	        function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          startMobileDirectionsWizard(map);
  	        }
  	      );
  	    }

  	    if (
  	      locationsButton &&
  	      !locationsButton.__fifLocationsWired
  	    ) {
  	      locationsButton.__fifLocationsWired =
  	        true;

  	      locationsButton.addEventListener(
  	        "click",
  	        function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          const currentlyOn =
  	            typeof map.__trackitLocationsAllOn ===
  	              "function"
  	              ? !!map.__trackitLocationsAllOn()
  	              : false;

  	          if (
  	            typeof map.__trackitSetAllLocations ===
  	            "function"
  	          ) {
  	            /*
  	             * OFF -> ON draws EVERY company Location.
  	             * ON  -> OFF removes EVERY company Location.
  	             */
  	            map.__trackitSetAllLocations(
  	              !currentlyOn,
  	              false
  	            );
  	          }

  	          paintLocations();
  	        }
  	      );
  	    }

  	    map.__fifPaintMobileLocations =
  	      paintLocations;

  	    paintLocations();
  	    return true;
  	  }

  	  function installOldTrackitMapControl(map) {
  	    if (
  	      !map ||
  	      typeof window === "undefined" ||
  	      !window.google ||
  	      !window.google.maps
  	    ) {
  	      return false;
  	    }

  	    const google = window.google;

  	    function getAppBag() {
  	      return appBag();
  	    }

  	    function refreshApp() {
  	      /*
  	       * Intentionally no full Backendless App refresh here. The original Map
  	       * Control used refresh only after writing TrackITMapSettings into AppData.
  	       * Mobile Tracking reads the same mutable AppData object immediately, and
  	       * remounting this page would destroy the live map session.
  	       */
  	      return true;
  	    }

  	    function injectGoogleInfoWindowPaddingCss() {
  	      const old = document.getElementById(
  	        "trackit-google-info-window-padding-css"
  	      );
  	      if (old) old.remove();

  	      const style = document.createElement("style");
  	      style.id = "trackit-google-info-window-padding-css";
  	      style.textContent = `
  	        .gm-style .gm-style-iw-c {
  	          padding:10px !important;
  	          border-radius:14px !important;
  	          overflow:visible !important;
  	          max-height:none !important;
  	        }
  	        .gm-style .gm-style-iw-d {
  	          overflow:visible !important;
  	          max-height:none !important;
  	          padding:0 !important;
  	          box-sizing:border-box !important;
  	        }
  	      `;
  	      document.head.appendChild(style);
  	    }

  	      	  function addTrackitUnifiedMapControl(map) {
  	      	    if (!map || typeof google === "undefined" || !(map instanceof google.maps.Map)) {
  	      	      console.error("[TrackIT Map Controls] Invalid map.");
  	      	      return;
  	      	    }

  	      	    const CONTROL_VERSION = "trackit-map-control-fleet-ces-shell-v11-whatsapp-driver-autosend";

  	      	    injectGoogleInfoWindowPaddingCss();

  	      	    map.setOptions({
  	      	      mapTypeControl: false,
  	      	      zoomControl: false,
  	      	      fullscreenControl: false,
  	      	      rotateControl: false,
  	      	      scaleControl: false,
  	      	      streetViewControl: false,

  	      	      // Keep Google map labels/POI labels clickable.
  	      	      clickableIcons: true
  	      	    });

  	      	    try {
  	      	      const panorama = map.getStreetView();
  	      	      panorama.setVisible(false);
  	      	      panorama.setOptions({
  	      	        enableCloseButton: false,
  	      	        addressControl: false,
  	      	        fullscreenControl: false,
  	      	        panControl: false,
  	      	        zoomControl: false,
  	      	        linksControl: false
  	      	      });
  	      	    } catch (_) {}

  	      	    const mapDiv = map.getDiv ? map.getDiv(): null;

  	      	    const existingControl =
  	      	    mapDiv?.querySelector?.(".trackit-compact-map-control") ||
  	      	    document.querySelector(".trackit-compact-map-control");

  	      	    if (
  	      	      map.__trackitUnifiedMapControlReady &&
  	      	      map.__trackitUnifiedMapControlVersion === CONTROL_VERSION &&
  	      	      existingControl
  	      	    ) {
  	      	      return;
  	      	    }

  	      	    // ---------- Directions Mode ----------
  	      	    const TRACKIT_WHATSAPP_SERVICE_NAME = "WhatsApp";
  	      	    const TRACKIT_WHATSAPP_METHOD_NAME = "Send_Directions_Template";

  	      	    function getTrackitDirectionsState() {
  	      	      if (!map.__trackitDirections) {
  	      	        map.__trackitDirections = {
  	      	          active: false,
  	      	          waitingFor: 0,

  	      	          point1: null,
  	      	          point2: null,

  	      	          point1Label: "",
  	      	          point2Label: "",

  	      	          // Populated only when the From point is an actual fleet vehicle.
  	      	          // Used by the WhatsApp Driver button to send the route directly to the assigned driver.
  	      	          fromVehicle: null,

  	      	          waypoints: [],
  	      	          activeSlot: "from",

  	      	          mapClickListener: null,
  	      	          directionsService: null,
  	      	          directionsRenderer: null,
  	      	          geocoder: null,

  	      	          pointMarkers: [],
  	      	          pointMarkerBySlot: {},

  	      	          popup: null
  	      	        };
  	      	      }

  	      	      const s = map.__trackitDirections;

  	      	      if (!Array.isArray(s.waypoints)) s.waypoints = [];
  	      	      if (!s.pointMarkerBySlot) s.pointMarkerBySlot = {};
  	      	      if (!s.activeSlot) s.activeSlot = "from";
  	      	      if (s.point1Label === undefined) s.point1Label = "";
  	      	      if (s.point2Label === undefined) s.point2Label = "";
  	      	      if (s.fromVehicle === undefined) s.fromVehicle = null;

  	      	      return s;
  	      	    }

  	      	    function setDirectionsButtonText(text) {
  	      	      try {
  	      	        const span = directionsBtn.querySelector("span");
  	      	        if (span) span.textContent = text;
  	      	        directionsBtn.title = text;
  	      	      } catch (_) {}
  	      	    }

  	      	    function paintDirectionsButton() {
  	      	      const s = getTrackitDirectionsState();

  	      	      directionsBtn.classList.toggle("active", !!s.active);

  	      	      if (!s.active) {
  	      	        setDirectionsButtonText("Directions");
  	      	        return;
  	      	      }

  	      	      if (!s.point1) {
  	      	        setDirectionsButtonText("Set From");
  	      	        return;
  	      	      }

  	      	      if (!s.point2) {
  	      	        setDirectionsButtonText("Set To");
  	      	        return;
  	      	      }

  	      	      setDirectionsButtonText("Directions");
  	      	    }

  	      	    function normaliseDirectionsLatLng(value) {
  	      	      if (!value) return null;

  	      	      if (value.lat !== undefined && value.lng !== undefined) {
  	      	        const lat = typeof value.lat === "function" ? value.lat(): Number(value.lat);
  	      	        const lng = typeof value.lng === "function" ? value.lng(): Number(value.lng);

  	      	        if (
  	      	          Number.isFinite(lat) &&
  	      	          Number.isFinite(lng) &&
  	      	          Math.abs(lat) <= 90 &&
  	      	          Math.abs(lng) <= 180
  	      	        ) {
  	      	          return {
  	      	            lat,
  	      	            lng
  	      	          };
  	      	        }
  	      	      }

  	      	      return null;
  	      	    }

  	      	    function makeDirectionsPointMarker(position, label) {
  	      	      const svg = `
  	      	      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  	      	      <path d="M16 41s13-12.2 13-25A13 13 0 1 0 3 16c0 12.8 13 25 13 25Z"
  	      	      fill="rgba(0,0,0,0.88)"
  	      	      stroke="rgba(255,138,61,0.95)"
  	      	      stroke-width="2"/>
  	      	      <circle cx="16" cy="16" r="8" fill="#ff8a3c"/>
  	      	      <text x="16" y="20" text-anchor="middle"
  	      	      font-family="Arial, sans-serif"
  	      	      font-size="11"
  	      	      font-weight="900"
  	      	      fill="#fff">${String(label || "•")}</text>
  	      	      </svg>
  	      	      `;

  	      	      return new google.maps.Marker({
  	      	        position,
  	      	        map,
  	      	        clickable: false,
  	      	        zIndex: 999,
  	      	        icon: {
  	      	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
  	      	          scaledSize: new google.maps.Size(32, 42),
  	      	          anchor: new google.maps.Point(16, 41)
  	      	        }
  	      	      });
  	      	    }

  	      	    function clearDirectionsMarkers() {
  	      	      const s = getTrackitDirectionsState();

  	      	      (s.pointMarkers || []).forEach(marker => {
  	      	        try {
  	      	          marker.setMap(null);
  	      	        } catch (_) {}
  	      	      });

  	      	      Object.keys(s.pointMarkerBySlot || {}).forEach(slot => {
  	      	        try {
  	      	          s.pointMarkerBySlot[slot].setMap(null);
  	      	        } catch (_) {}
  	      	      });

  	      	      s.pointMarkers = [];
  	      	      s.pointMarkerBySlot = {};
  	      	    }

  	      	    function clearDirectionsPopup() {
  	      	      const s = getTrackitDirectionsState();

  	      	      try {
  	      	        if (s.popup) {
  	      	          s.popup.remove();
  	      	          s.popup = null;
  	      	        }
  	      	      } catch (_) {
  	      	        s.popup = null;
  	      	      }
  	      	    }

  	      	    function clearDirectionsRouteOnly() {
  	      	      const s = getTrackitDirectionsState();

  	      	      try {
  	      	        if (s.directionsRenderer) {
  	      	          s.directionsRenderer.setMap(null);
  	      	          s.directionsRenderer = null;
  	      	        }
  	      	      } catch (_) {
  	      	        s.directionsRenderer = null;
  	      	      }

  	      	      clearDirectionsMarkers();
  	      	    }

  	      	    function stopDirectionsMode() {
  	      	      const s = getTrackitDirectionsState();

  	      	      if (s.mapClickListener) {
  	      	        try {
  	      	          google.maps.event.removeListener(s.mapClickListener);
  	      	        } catch (_) {}

  	      	        s.mapClickListener = null;
  	      	      }

  	      	      clearDirectionsRouteOnly();
  	      	      clearDirectionsPopup();

  	      	      s.active = false;
  	      	      s.waitingFor = 0;
  	      	      s.point1 = null;
  	      	      s.point2 = null;
  	      	      s.point1Label = "";
  	      	      s.point2Label = "";
  	      	      s.fromVehicle = null;
  	      	      s.waypoints = [];
  	      	      s.activeSlot = "from";

  	      	      paintDirectionsButton();
  	      	    }

  	      	    function toggleDirectionsMode() {
  	      	      const s = getTrackitDirectionsState();

  	      	      if (s.active) {
  	      	        stopDirectionsMode();
  	      	      } else {
  	      	        startDirectionsMode();
  	      	      }
  	      	    }

  	      	    function getDirectionsSlotOrder() {
  	      	      const s = getTrackitDirectionsState();

  	      	      return [
  	      	        "from",
  	      	        ...s.waypoints.map((_, index) => `waypoint:${index}`),
  	      	        "to"
  	      	      ];
  	      	    }

  	      	    function getDirectionsPointForSlot(slot) {
  	      	      const s = getTrackitDirectionsState();

  	      	      if (slot === "from") return s.point1;
  	      	      if (slot === "to") return s.point2;

  	      	      if (String(slot).startsWith("waypoint:")) {
  	      	        const index = Number(String(slot).split(":")[1]);
  	      	        return s.waypoints[index]?.point || null;
  	      	      }

  	      	      return null;
  	      	    }

  	      	    function getNextEmptyDirectionsSlot() {
  	      	      const s = getTrackitDirectionsState();

  	      	      if (!s.point1) return "from";

  	      	      for (let i = 0; i < s.waypoints.length; i++) {
  	      	        if (!s.waypoints[i]?.point) return `waypoint:${i}`;
  	      	      }

  	      	      if (!s.point2) return "to";

  	      	      return "to";
  	      	    }

  	      	    function setNextDirectionsSlotAfter(slot) {
  	      	      const s = getTrackitDirectionsState();
  	      	      const order = getDirectionsSlotOrder();
  	      	      const index = order.indexOf(slot);

  	      	      for (let i = index + 1; i < order.length; i++) {
  	      	        if (!getDirectionsPointForSlot(order[i])) {
  	      	          s.activeSlot = order[i];
  	      	          return;
  	      	        }
  	      	      }

  	      	      s.activeSlot = getNextEmptyDirectionsSlot();
  	      	    }

  	      	    function getDirectionsMarkerLabelForSlot(slot) {
  	      	      if (slot === "from") return "A";
  	      	      if (slot === "to") return "B";

  	      	      if (String(slot).startsWith("waypoint:")) {
  	      	        const index = Number(String(slot).split(":")[1]);
  	      	        return String(index + 1);
  	      	      }

  	      	      return "•";
  	      	    }

  	      	    function formatDirectionsPointText(point, label) {
  	      	      if (label) return String(label);
  	      	      if (!point) return "—";

  	      	      return `${Number(point.lat).toFixed(5)}, ${Number(point.lng).toFixed(5)}`;
  	      	    }

  	      	    function setDirectionsInputValue(slot, text) {
  	      	      const s = getTrackitDirectionsState();
  	      	      const popup = s.popup;

  	      	      if (!popup) return;

  	      	      const input = popup.querySelector(`[data-route-slot="${slot}"]`);

  	      	      if (input) {
  	      	        input.value = text || "";
  	      	      }
  	      	    }

  	      	    function clearDirectionsMarkerForSlot(slot) {
  	      	      const s = getTrackitDirectionsState();

  	      	      try {
  	      	        if (s.pointMarkerBySlot?.[slot]) {
  	      	          s.pointMarkerBySlot[slot].setMap(null);
  	      	          delete s.pointMarkerBySlot[slot];
  	      	        }
  	      	      } catch (_) {}
  	      	    }

  	      	    function normaliseDirectionsVehicleMeta(vehicleMeta) {
  	      	      if (!vehicleMeta || typeof vehicleMeta !== "object") return null;

  	      	      return {
  	      	        id: String(vehicleMeta.id || "").trim(),
  	      	        label: String(vehicleMeta.label || "").trim(),
  	      	        registration: String(vehicleMeta.registration || "").trim(),
  	      	        tracker: String(vehicleMeta.tracker || "").trim(),
  	      	        driverName: String(vehicleMeta.driverName || "").trim(),
  	      	        driverPhone: String(vehicleMeta.driverPhone || "").trim()
  	      	      };
  	      	    }

  	      	    function setDirectionsSlot(slot, point, labelText, vehicleMeta) {
  	      	      const s = getTrackitDirectionsState();
  	      	      const normalised = normaliseDirectionsLatLng(point);

  	      	      if (!normalised) return false;

  	      	      s.active = true;

  	      	      const label = String(labelText || "").trim();

  	      	      if (slot === "from") {
  	      	        s.point1 = normalised;
  	      	        s.point1Label = label;

  	      	        // A place search or dropped pin passes no vehicleMeta, which correctly
  	      	        // removes the WhatsApp Driver action from the From point.
  	      	        s.fromVehicle = normaliseDirectionsVehicleMeta(vehicleMeta);
  	      	      } else if (slot === "to") {
  	      	        s.point2 = normalised;
  	      	        s.point2Label = label;
  	      	      } else if (String(slot).startsWith("waypoint:")) {
  	      	        const index = Number(String(slot).split(":")[1]);

  	      	        if (!s.waypoints[index]) {
  	      	          s.waypoints[index] = {
  	      	            point: null,
  	      	            label: ""
  	      	          };
  	      	        }

  	      	        s.waypoints[index].point = normalised;
  	      	        s.waypoints[index].label = label;
  	      	      }

  	      	      clearDirectionsMarkerForSlot(slot);

  	      	      s.pointMarkerBySlot[slot] = makeDirectionsPointMarker(
  	      	        normalised,
  	      	        getDirectionsMarkerLabelForSlot(slot)
  	      	      );

  	      	      setDirectionsInputValue(slot, formatDirectionsPointText(normalised, label));
  	      	      setNextDirectionsSlotAfter(slot);

  	      	      paintDirectionsButton();
  	      	      updateDirectionsPopup(null, null);

  	      	      if (s.point1 && s.point2) {
  	      	        calculateAndDisplayRoute();
  	      	      }

  	      	      return true;
  	      	    }

  	      	    function addDirectionsPoint(position, labelText, vehicleMeta) {
  	      	      const s = getTrackitDirectionsState();
  	      	      const point = normaliseDirectionsLatLng(position);

  	      	      if (!s.active || !point) return false;

  	      	      const slot = s.activeSlot || getNextEmptyDirectionsSlot();

  	      	      if (!getDirectionsPointForSlot(slot)) {
  	      	        return setDirectionsSlot(slot, point, labelText, vehicleMeta);
  	      	      }

  	      	      return setDirectionsSlot(getNextEmptyDirectionsSlot(), point, labelText, vehicleMeta);
  	      	    }

  	      	    function getVehicleDirectionsLabelFromTractor(t, fallback) {
  	      	      return String(
  	      	        t?.FID ||
  	      	        t?.ID ||
  	      	        t?.Registration ||
  	      	        t?.Tracker ||
  	      	        t?.Location?.ident ||
  	      	        fallback ||
  	      	        "Vehicle"
  	      	      );
  	      	    }

  	      	    function getDirectionsDriverDetailsFromTractor(t) {
  	      	      const ViewC = t?.ViewC || t?.viewC || {};
  	      	      const D1 = ViewC?.Driver1 || ViewC?.driver1 || null;

  	      	      if (!D1) {
  	      	        return {
  	      	          driverName: "",
  	      	          driverPhone: ""
  	      	        };
  	      	      }

  	      	      const driverName = String(
  	      	        D1.name ||
  	      	        [D1.first_name || D1.firstName, D1.last_name || D1.lastName]
  	      	        .filter(Boolean)
  	      	        .join(" ") ||
  	      	        D1.username ||
  	      	        ""
  	      	      ).trim();

  	      	      const driverPhone = String(
  	      	        D1?.Data_Details?.employee_details?.contact_details?.phone_number ||
  	      	        D1?.mobile ||
  	      	        D1?.phone ||
  	      	        D1?.tel ||
  	      	        ""
  	      	      ).trim();

  	      	      return {
  	      	        driverName,
  	      	        driverPhone
  	      	      };
  	      	    }

  	      	    function getDirectionsVehicleMetaFromTractor(t, fallbackId) {
  	      	      const driver = getDirectionsDriverDetailsFromTractor(t);

  	      	      return {
  	      	        id: String(fallbackId || t?.FID || t?.ID || t?.Registration || t?.Tracker || "").trim(),
  	      	        label: getVehicleDirectionsLabelFromTractor(t, fallbackId),
  	      	        registration: String(t?.Registration || t?.Location?.Registration || "").trim(),
  	      	        tracker: String(t?.Tracker || t?.Location?.ident || "").trim(),
  	      	        driverName: driver.driverName,
  	      	        driverPhone: driver.driverPhone
  	      	      };
  	      	    }

  	      	    function getDirectionsVehicleChoices(query) {
  	      	      const q = String(query || "").trim().toLowerCase();
  	      	      const pins = map.__truckPins || {};
  	      	      const rows = [];

  	      	      Object.keys(pins).forEach(id => {
  	      	        const pin = pins[id];
  	      	        const marker = pin?.marker;

  	      	        if (!marker || !marker.getPosition) return;

  	      	        const t = pin?.tractor || {};
  	      	        const meta = getDirectionsVehicleMetaFromTractor(t, id);
  	      	        const label = meta.label;
  	      	        const registration = meta.registration;
  	      	        const tracker = meta.tracker;

  	      	        const haystack = [label,
  	      	          registration,
  	      	          tracker,
  	      	          meta.driverName,
  	      	          id]
  	      	        .filter(Boolean)
  	      	        .join(" ")
  	      	        .toLowerCase();

  	      	        if (q && !haystack.includes(q)) return;

  	      	        rows.push({
  	      	          ...meta,
  	      	          id,
  	      	          position: marker.getPosition()
  	      	        });
  	      	      });

  	      	      rows.sort((a, b) => String(a.label).localeCompare(String(b.label), undefined, {
  	      	        numeric: true,
  	      	        sensitivity: "base"
  	      	      }));

  	      	      return rows.slice(0,
  	      	        10);
  	      	    }

  	      	    function findExactVehicleChoice(text) {
  	      	      const q = String(text || "").trim().toLowerCase();

  	      	      if (!q) return null;

  	      	      const choices = getDirectionsVehicleChoices(q);

  	      	      return choices.find(choice =>
  	      	        String(choice.label || "").toLowerCase() === q ||
  	      	        String(choice.registration || "").toLowerCase() === q ||
  	      	        String(choice.tracker || "").toLowerCase() === q ||
  	      	        String(choice.id || "").toLowerCase() === q
  	      	      ) || choices[0] || null;
  	      	    }

  	      	    function hideVehicleSuggest(input) {
  	      	      const box = input?.parentElement?.querySelector?.(".trackit-directions-vehicle-suggest");

  	      	      if (box) {
  	      	        box.classList.remove("visible");
  	      	        box.innerHTML = "";
  	      	      }
  	      	    }

  	      	    function showVehicleSuggest(input, slot) {
  	      	      if (!input) return;

  	      	      const box = input.parentElement?.querySelector?.(".trackit-directions-vehicle-suggest");

  	      	      if (!box) return;

  	      	      const choices = getDirectionsVehicleChoices(input.value);

  	      	      box.innerHTML = "";

  	      	      if (!choices.length || !String(input.value || "").trim()) {
  	      	        box.classList.remove("visible");
  	      	        return;
  	      	      }

  	      	      choices.forEach(choice => {
  	      	        const btn = document.createElement("button");
  	      	        btn.type = "button";
  	      	        btn.className = "trackit-directions-vehicle-option";

  	      	        btn.innerHTML = `
  	      	        <span class="trackit-directions-vehicle-id">${choice.label}</span>
  	      	        <span class="trackit-directions-vehicle-meta">Vehicle</span>
  	      	        `;

  	      	        btn.addEventListener("click", function (event) {
  	      	          event.preventDefault();
  	      	          event.stopPropagation();

  	      	          setDirectionsSlot(slot, choice.position, choice.label, choice);
  	      	          input.value = choice.label;
  	      	          hideVehicleSuggest(input);
  	      	        });

  	      	        box.appendChild(btn);
  	      	      });

  	      	      box.classList.add("visible");
  	      	    }

  	      	    function renderDirectionsWaypoints() {
  	      	      const s = getTrackitDirectionsState();
  	      	      const popup = s.popup;

  	      	      if (!popup) return;

  	      	      const wrap = popup.querySelector(".trackit-directions-waypoints");

  	      	      if (!wrap) return;

  	      	      wrap.innerHTML = "";

  	      	      s.waypoints.forEach((wp, index) => {
  	      	        const slot = `waypoint:${index}`;

  	      	        const row = document.createElement("div");
  	      	        row.className = "trackit-directions-search-line";
  	      	        row.setAttribute("data-route-row", slot);

  	      	        row.innerHTML = `
  	      	        <span>Stop ${index + 1}</span>
  	      	        <div class="trackit-directions-input-wrap">
  	      	        <input class="trackit-directions-waypoint" data-route-slot="${slot}" type="text" placeholder="Search place / vehicle ID / click map" autocomplete="off">
  	      	        <div class="trackit-directions-vehicle-suggest"></div>
  	      	        </div>
  	      	        <button type="button" class="trackit-directions-remove-stop">×</button>
  	      	        `;

  	      	        const input = row.querySelector("input");
  	      	        const removeBtn = row.querySelector(".trackit-directions-remove-stop");

  	      	        if (input) {
  	      	          input.value = formatDirectionsPointText(wp.point, wp.label);
  	      	          wireDirectionsInput(input, slot);
  	      	        }

  	      	        removeBtn?.addEventListener("click", function (event) {
  	      	          event.preventDefault();
  	      	          event.stopPropagation();

  	      	          removeDirectionsWaypoint(index);
  	      	        });

  	      	        wrap.appendChild(row);
  	      	      });
  	      	    }

  	      	    function addDirectionsWaypoint(point,
  	      	      labelText) {
  	      	      const s = getTrackitDirectionsState();
  	      	      const index = s.waypoints.length;

  	      	      s.waypoints.push({
  	      	        point: null,
  	      	        label: ""
  	      	      });

  	      	      renderDirectionsWaypoints();

  	      	      const slot = `waypoint:${index}`;
  	      	      s.activeSlot = slot;

  	      	      if (point) {
  	      	        setDirectionsSlot(slot, point, labelText);
  	      	      } else {
  	      	        updateDirectionsPopup(null, null);

  	      	        setTimeout(() => {
  	      	          try {
  	      	            s.popup?.querySelector?.(`[data-route-slot="${slot}"]`)?.focus?.();
  	      	          } catch (_) {}
  	      	        }, 0);
  	      	      }
  	      	    }

  	      	    function removeDirectionsWaypoint(index) {
  	      	      const s = getTrackitDirectionsState();

  	      	      clearDirectionsMarkerForSlot(`waypoint:${index}`);

  	      	      s.waypoints.splice(index, 1);

  	      	      Object.keys(s.pointMarkerBySlot || {}).forEach(slot => {
  	      	        if (slot.startsWith("waypoint:")) {
  	      	          clearDirectionsMarkerForSlot(slot);
  	      	        }
  	      	      });

  	      	      renderDirectionsWaypoints();

  	      	      s.waypoints.forEach((wp, newIndex) => {
  	      	        if (wp?.point) {
  	      	          const slot = `waypoint:${newIndex}`;
  	      	          s.pointMarkerBySlot[slot] = makeDirectionsPointMarker(wp.point, String(newIndex + 1));
  	      	        }
  	      	      });

  	      	      s.activeSlot = getNextEmptyDirectionsSlot();

  	      	      updateDirectionsPopup(null,
  	      	        null);

  	      	      if (s.point1 && s.point2) {
  	      	        calculateAndDisplayRoute();
  	      	      }
  	      	    }

  	      	    function wireDirectionsInput(input, slot) {
  	      	      if (!input || input.__trackitDirectionsInputWired) return;

  	      	      input.__trackitDirectionsInputWired = true;

  	      	      input.addEventListener("focus", function () {
  	      	        const s = getTrackitDirectionsState();
  	      	        s.activeSlot = slot;
  	      	        updateDirectionsPopup(null, null);
  	      	      });

  	      	      input.addEventListener("input", function () {
  	      	        const s = getTrackitDirectionsState();
  	      	        s.activeSlot = slot;

  	      	        if (slot === "from") {
  	      	          s.fromVehicle = null;
  	      	          updateDirectionsPopup(null, null);
  	      	        }

  	      	        showVehicleSuggest(input, slot);
  	      	      });

  	      	      input.addEventListener("keydown", function (event) {
  	      	        if (event.key !== "Enter") return;

  	      	        event.preventDefault();
  	      	        event.stopPropagation();

  	      	        const vehicle = findExactVehicleChoice(input.value);

  	      	        if (vehicle) {
  	      	          setDirectionsSlot(slot, vehicle.position, vehicle.label, vehicle);
  	      	          input.value = vehicle.label;
  	      	          hideVehicleSuggest(input);
  	      	          return;
  	      	        }

  	      	        geocodeDirectionsInput(input.value, slot);
  	      	      });

  	      	      input.addEventListener("blur",
  	      	        function () {
  	      	          setTimeout(() => hideVehicleSuggest(input), 180);
  	      	        });

  	      	      if (google.maps.places?.Autocomplete) {
  	      	        const autocomplete = new google.maps.places.Autocomplete(input, {
  	      	          fields: ["geometry", "name", "formatted_address"],
  	      	          types: ["geocode", "establishment"]
  	      	        });

  	      	        try {
  	      	          autocomplete.bindTo("bounds", map);
  	      	        } catch (_) {}

  	      	        autocomplete.addListener("place_changed", function () {
  	      	          const place = autocomplete.getPlace();
  	      	          const location = place?.geometry?.location;

  	      	          if (!location) {
  	      	            console.warn("[TrackIT Directions] Place has no geometry:", place);
  	      	            return;
  	      	          }

  	      	          const point = normaliseDirectionsLatLng(location);

  	      	          if (!point) return;

  	      	          const label = place.formatted_address || place.name || input.value;

  	      	          setDirectionsSlot(slot, point, label);
  	      	          input.value = label;
  	      	          hideVehicleSuggest(input);
  	      	        });
  	      	      } else {
  	      	        console.warn("[TrackIT Directions] Google Places library not loaded. Add libraries=places to your Google Maps script.");
  	      	      }
  	      	    }

  	      	    function geocodeDirectionsInput(text, slot) {
  	      	      const query = String(text || "").trim();

  	      	      if (!query) return;

  	      	      const vehicle = findExactVehicleChoice(query);

  	      	      if (vehicle) {
  	      	        setDirectionsSlot(slot, vehicle.position, vehicle.label, vehicle);
  	      	        return;
  	      	      }

  	      	      const s = getTrackitDirectionsState();

  	      	      if (!s.geocoder) {
  	      	        s.geocoder = new google.maps.Geocoder();
  	      	      }

  	      	      s.geocoder.geocode({
  	      	        address: query
  	      	      }, function (results, status) {
  	      	        if (status === "OK" && results?.[0]?.geometry?.location) {
  	      	          const point = normaliseDirectionsLatLng(results[0].geometry.location);
  	      	          const label = results[0].formatted_address || query;

  	      	          if (point) {
  	      	            setDirectionsSlot(slot, point, label);
  	      	          }

  	      	          return;
  	      	        }

  	      	        console.warn("[TrackIT Directions] Geocode failed:", status, query);
  	      	        updateDirectionsStatusText("Search failed. Try a more specific address or vehicle ID.");
  	      	      });
  	      	    }

  	      	    function formatDirectionsDistance(route) {
  	      	      let metres = 0;

  	      	      try {
  	      	        route.legs.forEach(leg => {
  	      	          metres += Number(leg.distance?.value || 0);
  	      	        });
  	      	      } catch (_) {}

  	      	      if (!metres) return "—";

  	      	      if (metres >= 1000) {
  	      	        return `${(metres / 1000).toFixed(1).replace(/\.0$/, "")} km`;
  	      	      }

  	      	      return `${Math.round(metres)} m`;
  	      	    }

  	      	    function formatDirectionsDuration(route) {
  	      	      let seconds = 0;

  	      	      try {
  	      	        route.legs.forEach(leg => {
  	      	          seconds += Number(leg.duration?.value || 0);
  	      	        });
  	      	      } catch (_) {}

  	      	      if (!seconds) return "—";

  	      	      const mins = Math.round(seconds / 60);

  	      	      if (mins < 60) return `${mins} min`;

  	      	      const h = Math.floor(mins / 60);
  	      	      const m = mins % 60;

  	      	      return m ? `${h} hr ${m} min`: `${h} hr`;
  	      	    }

  	      	    function updateDirectionsStatusText(text) {
  	      	      const s = getTrackitDirectionsState();
  	      	      const status = s.popup?.querySelector?.(".trackit-directions-status");

  	      	      if (status) {
  	      	        status.textContent = text;
  	      	      }
  	      	    }

  	      	    function createDirectionsPopup(route, request) {
  	      	      const s = getTrackitDirectionsState();
  	      	      const mapDiv = map.getDiv();

  	      	      if (!mapDiv) return;

  	      	      let popup = s.popup;

  	      	      if (!popup) {
  	      	        popup = document.createElement("div");
  	      	        popup.className = "trackit-directions-popup";

  	      	        popup.innerHTML = `
  	      	        <div class="trackit-directions-popup-header">
  	      	        <div>
  	      	        <div class="trackit-directions-popup-title">Directions</div>
  	      	        <div class="trackit-directions-popup-subtitle">Build Route</div>
  	      	        </div>
  	      	        <button type="button" class="trackit-directions-popup-close">×</button>
  	      	        </div>

  	      	        <div class="trackit-directions-search-wrap">

  	      	        <div class="trackit-directions-search-line no-remove" data-route-row="from">
  	      	        <span>From</span>
  	      	        <div class="trackit-directions-input-wrap">
  	      	        <input class="trackit-directions-from" data-route-slot="from" type="text" placeholder="Search place / vehicle ID / click map" autocomplete="off">
  	      	        <div class="trackit-directions-vehicle-suggest"></div>
  	      	        </div>
  	      	        </div>

  	      	        <div class="trackit-directions-waypoints"></div>

  	      	        <button type="button" class="trackit-directions-add-stop">+ Add Stop</button>

  	      	        <div class="trackit-directions-search-line no-remove" data-route-row="to">
  	      	        <span>To</span>
  	      	        <div class="trackit-directions-input-wrap">
  	      	        <input class="trackit-directions-to" data-route-slot="to" type="text" placeholder="Search place / vehicle ID / click map" autocomplete="off">
  	      	        <div class="trackit-directions-vehicle-suggest"></div>
  	      	        </div>
  	      	        </div>

  	      	        </div>

  	      	        <div class="trackit-directions-status">Choose From. Search, type vehicle ID, click map, or click a vehicle.</div>

  	      	        <div class="trackit-directions-popup-body">
  	      	        <div class="trackit-directions-row">
  	      	        <span>From</span>
  	      	        <strong class="trackit-directions-from-text">—</strong>
  	      	        </div>
  	      	        <div class="trackit-directions-row">
  	      	        <span>Stops</span>
  	      	        <strong class="trackit-directions-stops-text">0</strong>
  	      	        </div>
  	      	        <div class="trackit-directions-row">
  	      	        <span>To</span>
  	      	        <strong class="trackit-directions-to-text">—</strong>
  	      	        </div>
  	      	        <div class="trackit-directions-row">
  	      	        <span>Route</span>
  	      	        <strong class="trackit-directions-route-text">—</strong>
  	      	        </div>

  	      	        <div class="trackit-directions-actions">
  	      	        <button type="button" class="trackit-directions-new">Clear/New Route</button>
  	      	        </div>

  	      	        <div class="trackit-directions-whatsapp-wrap">
  	      	        <select class="trackit-directions-country-select" aria-label="Country code">
  	      	        ${getWhatsappCountryOptionsHtml("ZA")}
  	      	        </select>

  	      	        <input class="trackit-directions-whatsapp-phone" type="tel" placeholder="ZA WhatsApp e.g. 0821234567" autocomplete="tel">

  	      	        <button type="button" class="trackit-directions-driver-btn" hidden disabled>
  	      	        ${getTrackitWhatsappButtonHtml("WhatsApp Driver")}
  	      	        </button>

  	      	        <button type="button" class="trackit-directions-whatsapp-btn">
  	      	        ${getTrackitWhatsappButtonHtml("WhatsApp")}
  	      	        </button>
  	      	        </div>
  	      	        </div>
  	      	        `;

  	      	        popup.style.right = "0px";
  	      	        popup.style.left = "auto";
  	      	        popup.style.top = "50px";

  	      	        mapDiv.appendChild(popup);
  	      	        s.popup = popup;

  	      	        wireDirectionsPopupEvents(popup);
  	      	        renderDirectionsWaypoints();
  	      	        wireDirectionsInput(popup.querySelector(".trackit-directions-from"), "from");
  	      	        wireDirectionsInput(popup.querySelector(".trackit-directions-to"), "to");
  	      	      }

  	      	      updateDirectionsPopup(route || null, request || null);
  	      	    }

  	      	    function updateDirectionsPopup(route, request) {
  	      	      const s = getTrackitDirectionsState();
  	      	      const popup = s.popup;

  	      	      if (!popup) return;

  	      	      const subtitle = popup.querySelector(".trackit-directions-popup-subtitle");
  	      	      const status = popup.querySelector(".trackit-directions-status");
  	      	      const fromText = popup.querySelector(".trackit-directions-from-text");
  	      	      const stopsText = popup.querySelector(".trackit-directions-stops-text");
  	      	      const toText = popup.querySelector(".trackit-directions-to-text");
  	      	      const routeText = popup.querySelector(".trackit-directions-route-text");
  	      	      const whatsappWrap = popup.querySelector(".trackit-directions-whatsapp-wrap");
  	      	      const driverBtn = popup.querySelector(".trackit-directions-driver-btn");

  	      	      const fromVehicle = s.fromVehicle;
  	      	      const hasFromVehicle = !!fromVehicle;
  	      	      const hasDriverPhone = !!String(fromVehicle?.driverPhone || "").trim();

  	      	      whatsappWrap?.classList?.toggle("has-driver", hasFromVehicle);

  	      	      if (driverBtn) {
  	      	        driverBtn.hidden = !hasFromVehicle;
  	      	        driverBtn.disabled = !hasDriverPhone;
  	      	        driverBtn.classList.toggle("missing", hasFromVehicle && !hasDriverPhone);
  	      	        driverBtn.title = hasDriverPhone
  	      	        ? `Send route immediately to ${fromVehicle?.driverName || "driver"}`
  	      	        : "No driver mobile number is available for this vehicle";

  	      	        const driverBtnText = driverBtn.querySelector("span");
  	      	        if (driverBtnText) {
  	      	          driverBtnText.textContent = hasDriverPhone ? "WhatsApp Driver": "Driver Number Missing";
  	      	        }
  	      	      }

  	      	      if (fromText) {
  	      	        fromText.textContent = formatDirectionsPointText(s.point1, s.point1Label);
  	      	      }

  	      	      if (toText) {
  	      	        toText.textContent = formatDirectionsPointText(s.point2, s.point2Label);
  	      	      }

  	      	      if (stopsText) {
  	      	        stopsText.textContent = String(s.waypoints.filter(wp => !!wp?.point).length);
  	      	      }

  	      	      if (route && routeText) {
  	      	        routeText.textContent = `${formatDirectionsDistance(route)} • ${formatDirectionsDuration(route)}`;
  	      	      } else if (routeText) {
  	      	        routeText.textContent = "—";
  	      	      }

  	      	      if (route && subtitle) {
  	      	        subtitle.textContent = `${formatDirectionsDistance(route)} • ${formatDirectionsDuration(route)}`;
  	      	      } else if (subtitle) {
  	      	        subtitle.textContent = "Build Route";
  	      	      }

  	      	      if (status) {
  	      	        if (!s.active) {
  	      	          status.textContent = "Directions inactive.";
  	      	        } else if (!s.point1) {
  	      	          status.textContent = "Choose From. Search, type vehicle ID, click map, or click a vehicle.";
  	      	        } else if (!s.point2) {
  	      	          status.textContent = "Choose To. Search, type vehicle ID, click map, or click a vehicle.";
  	      	        } else if (route) {
  	      	          status.textContent = "Route ready.";
  	      	        } else {
  	      	          status.textContent = "Route ready to calculate.";
  	      	        }
  	      	      }
  	      	    }

  	      	    function wireDirectionsPopupEvents(popup) {
  	      	      const closeBtn = popup.querySelector(".trackit-directions-popup-close");
  	      	      const clearBtn = popup.querySelector(".trackit-directions-clear");
  	      	      const newBtn = popup.querySelector(".trackit-directions-new");
  	      	      const addStopBtn = popup.querySelector(".trackit-directions-add-stop");
  	      	      const whatsappBtn = popup.querySelector(".trackit-directions-whatsapp-btn");
  	      	      const driverBtn = popup.querySelector(".trackit-directions-driver-btn");
  	      	      const header = popup.querySelector(".trackit-directions-popup-header");
  	      	      const countrySelect = popup.querySelector(".trackit-directions-country-select");
  	      	      const phoneInput = popup.querySelector(".trackit-directions-whatsapp-phone");

  	      	      updateWhatsappPhonePlaceholder(popup);

  	      	      countrySelect?.addEventListener("change", function () {
  	      	        updateWhatsappPhonePlaceholder(popup);

  	      	        if (!phoneInput?.value) return;

  	      	        const checked = normaliseWhatsappNumber(phoneInput.value, countrySelect.value);

  	      	        phoneInput.classList.toggle("invalid", !checked.ok);

  	      	        if (checked.ok) {
  	      	          phoneInput.value = checked.value;
  	      	          updateDirectionsStatusText("WhatsApp number normalised.");
  	      	        } else {
  	      	          updateDirectionsStatusText(checked.error);
  	      	        }
  	      	      });

  	      	      phoneInput?.addEventListener("input",
  	      	        function () {
  	      	          phoneInput.classList.remove("invalid");
  	      	        });

  	      	      phoneInput?.addEventListener("blur",
  	      	        function () {
  	      	          if (!phoneInput.value) return;

  	      	          const checked = normaliseWhatsappNumber(phoneInput.value, countrySelect?.value || "ZA");

  	      	          phoneInput.classList.toggle("invalid", !checked.ok);

  	      	          if (checked.ok) {
  	      	            phoneInput.value = checked.value;
  	      	          }
  	      	        });

  	      	      closeBtn?.addEventListener("click",
  	      	        function (event) {
  	      	          event.preventDefault();
  	      	          event.stopPropagation();

  	      	          stopDirectionsMode();
  	      	        });

  	      	      clearBtn?.addEventListener("click",
  	      	        function (event) {
  	      	          event.preventDefault();
  	      	          event.stopPropagation();

  	      	          stopDirectionsMode();
  	      	        });

  	      	      newBtn?.addEventListener("click",
  	      	        function (event) {
  	      	          event.preventDefault();
  	      	          event.stopPropagation();

  	      	          startDirectionsMode();
  	      	        });

  	      	      addStopBtn?.addEventListener("click",
  	      	        function (event) {
  	      	          event.preventDefault();
  	      	          event.stopPropagation();

  	      	          addDirectionsWaypoint();
  	      	        });

  	      	      driverBtn?.addEventListener("click",
  	      	        async function (event) {
  	      	          event.preventDefault();
  	      	          event.stopPropagation();

  	      	          const s = getTrackitDirectionsState();
  	      	          const driverPhone = String(s.fromVehicle?.driverPhone || "").trim();

  	      	          if (!driverPhone) {
  	      	            updateDirectionsStatusText("No driver mobile number is available for the From vehicle.");
  	      	            return;
  	      	          }

  	      	          // Put the assigned driver's number into the same field used by the
  	      	          // standard WhatsApp button, then call the exact same send function.
  	      	          phoneInput.value = driverPhone;
  	      	          phoneInput.classList.remove("invalid");

  	      	          await sendDirectionsWhatsapp(driverBtn);
  	      	        });

  	      	      whatsappBtn?.addEventListener("click",
  	      	        async function (event) {
  	      	          event.preventDefault();
  	      	          event.stopPropagation();

  	      	          await sendDirectionsWhatsapp(whatsappBtn);
  	      	        });

  	      	      let dragging = false;
  	      	      let startX = 0;
  	      	      let startY = 0;
  	      	      let startLeft = 0;
  	      	      let startTop = 0;

  	      	      header?.addEventListener("mousedown",
  	      	        function (event) {
  	      	          event.preventDefault();
  	      	          event.stopPropagation();

  	      	          const rect = popup.getBoundingClientRect();
  	      	          const parentRect = map.getDiv().getBoundingClientRect();

  	      	          dragging = true;
  	      	          startX = event.clientX;
  	      	          startY = event.clientY;
  	      	          startLeft = rect.left - parentRect.left;
  	      	          startTop = rect.top - parentRect.top;

  	      	          popup.style.right = "auto";
  	      	          popup.style.left = `${startLeft}px`;
  	      	          popup.style.top = `${startTop}px`;

  	      	          document.body.style.userSelect = "none";
  	      	        });

  	      	      document.addEventListener("mousemove",
  	      	        function (event) {
  	      	          if (!dragging) return;

  	      	          event.preventDefault();

  	      	          const mapDiv = map.getDiv();
  	      	          const maxLeft = Math.max(0, mapDiv.clientWidth - popup.offsetWidth - 6);
  	      	          const maxTop = Math.max(0, mapDiv.clientHeight - popup.offsetHeight - 6);

  	      	          const nextLeft = startLeft + (event.clientX - startX);
  	      	          const nextTop = startTop + (event.clientY - startY);

  	      	          popup.style.left = `${Math.min(maxLeft, Math.max(0, nextLeft))}px`;
  	      	          popup.style.top = `${Math.min(maxTop, Math.max(0, nextTop))}px`;
  	      	        });

  	      	      document.addEventListener("mouseup",
  	      	        function () {
  	      	          if (!dragging) return;

  	      	          dragging = false;
  	      	          document.body.style.userSelect = "";
  	      	        });

  	      	      ["mousedown", "dblclick", "wheel", "touchstart", "pointerdown", "click"].forEach(evtName => {
  	      	        popup.addEventListener(evtName, function (event) {
  	      	          event.stopPropagation();
  	      	        }, {
  	      	          passive: false
  	      	        });
  	      	      });
  	      	    }

  	      	    function startDirectionsMode() {
  	      	      const s = getTrackitDirectionsState();

  	      	      clearDirectionsRouteOnly();

  	      	      closeMapControlPanel(false);

  	      	      s.active = true;
  	      	      s.waitingFor = 1;

  	      	      s.point1 = null;
  	      	      s.point2 = null;
  	      	      s.point1Label = "";
  	      	      s.point2Label = "";
  	      	      s.fromVehicle = null;
  	      	      s.waypoints = [];
  	      	      s.activeSlot = "from";

  	      	      createDirectionsPopup(null,
  	      	        null);
  	      	      renderDirectionsWaypoints();

  	      	      const fromInput = s.popup?.querySelector?.(".trackit-directions-from");
  	      	      const toInput = s.popup?.querySelector?.(".trackit-directions-to");

  	      	      if (fromInput) fromInput.value = "";
  	      	      if (toInput) toInput.value = "";

  	      	      if (s.mapClickListener) {
  	      	        try {
  	      	          google.maps.event.removeListener(s.mapClickListener);
  	      	        } catch (_) {}
  	      	      }

  	      	      s.mapClickListener = map.addListener("click", function (event) {
  	      	        try {
  	      	          addDirectionsPoint(event.latLng, "Dropped Pin");
  	      	        } catch (e) {
  	      	          console.warn("[TrackIT Directions] Map point failed:", e);
  	      	        }
  	      	      });

  	      	      paintDirectionsButton();
  	      	      updateDirectionsPopup(null, null);

  	      	      setTimeout(() => {
  	      	        try {
  	      	          fromInput?.focus?.();
  	      	        } catch (_) {}
  	      	      }, 0);
  	      	    }

  	      	    function calculateAndDisplayRoute() {
  	      	      const s = getTrackitDirectionsState();

  	      	      if (!s.point1 || !s.point2) return;

  	      	      if (!s.directionsService) {
  	      	        s.directionsService = new google.maps.DirectionsService();
  	      	      }

  	      	      if (s.directionsRenderer) {
  	      	        try {
  	      	          s.directionsRenderer.setMap(null);
  	      	        } catch (_) {}
  	      	      }

  	      	      s.directionsRenderer = new google.maps.DirectionsRenderer({
  	      	        map,
  	      	        suppressMarkers: true,
  	      	        preserveViewport: false,
  	      	        polylineOptions: {
  	      	          strokeColor: "#ff8a3c",
  	      	          strokeOpacity: 0.95,
  	      	          strokeWeight: 5,
  	      	          zIndex: 900
  	      	        }
  	      	      });

  	      	      const request = {
  	      	        origin: s.point1,
  	      	        destination: s.point2,
  	      	        waypoints: s.waypoints
  	      	        .filter(wp => !!wp?.point)
  	      	        .map(wp => ({
  	      	          location: wp.point,
  	      	          stopover: true
  	      	        })),
  	      	        optimizeWaypoints: false,
  	      	        travelMode: google.maps.TravelMode.DRIVING,
  	      	        provideRouteAlternatives: false
  	      	      };

  	      	      setDirectionsButtonText("Routing...");
  	      	      updateDirectionsPopup(null, request);

  	      	      s.directionsService.route(request, function (result, status) {
  	      	        if (status === "OK" && result?.routes?.length) {
  	      	          s.directionsRenderer.setDirections(result);

  	      	          const route = result.routes[0];

  	      	          createDirectionsPopup(route, request);
  	      	          updateDirectionsPopup(route, request);

  	      	          s.active = true;
  	      	          s.waitingFor = 0;

  	      	          setDirectionsButtonText("Directions");
  	      	          directionsBtn.classList.add("active");

  	      	          return;
  	      	        }

  	      	        console.warn("[TrackIT Directions] Route failed:", status, result);

  	      	        setDirectionsButtonText("No Route");
  	      	        updateDirectionsStatusText("Route failed. Check road access or selected points.");

  	      	        setTimeout(() => {
  	      	          paintDirectionsButton();
  	      	        }, 1200);
  	      	      });
  	      	    }

  	      	    function formatMapsPoint(point) {
  	      	      if (!point) return "";

  	      	      return `${Number(point.lat).toFixed(7)},${Number(point.lng).toFixed(7)}`;
  	      	    }

  	      	    function buildGoogleMapsDirectionsUrl() {
  	      	      const s = getTrackitDirectionsState();

  	      	      if (!s.point1 || !s.point2) return "";

  	      	      const params = new URLSearchParams();

  	      	      params.set("api", "1");
  	      	      params.set("origin", formatMapsPoint(s.point1));
  	      	      params.set("destination", formatMapsPoint(s.point2));
  	      	      params.set("travelmode", "driving");

  	      	      const stops = (s.waypoints || [])
  	      	      .filter(wp => !!wp?.point)
  	      	      .map(wp => formatMapsPoint(wp.point))
  	      	      .filter(Boolean);

  	      	      if (stops.length) {
  	      	        params.set("waypoints", stops.join("|"));
  	      	      }

  	      	      return `https://www.google.com/maps/dir/?${params.toString()}`;
  	      	    }

  	      	    const TRACKIT_WHATSAPP_COUNTRIES = [{
  	      	      iso: "ZA",
  	      	      label: "South Africa",
  	      	      dial: "+27",
  	      	      example: "0821234567",
  	      	      nsnMin: 9,
  	      	      nsnMax: 9,
  	      	      mobilePattern: /^[6-8]\d{8}$/
  	      	    },
  	      	      {
  	      	        iso: "BW",
  	      	        label: "Botswana",
  	      	        dial: "+267",
  	      	        example: "71234567",
  	      	        nsnMin: 7,
  	      	        nsnMax: 8
  	      	      },
  	      	      {
  	      	        iso: "NA",
  	      	        label: "Namibia",
  	      	        dial: "+264",
  	      	        example: "811234567",
  	      	        nsnMin: 8,
  	      	        nsnMax: 9
  	      	      },
  	      	      {
  	      	        iso: "ZW",
  	      	        label: "Zimbabwe",
  	      	        dial: "+263",
  	      	        example: "771234567",
  	      	        nsnMin: 9,
  	      	        nsnMax: 9
  	      	      },
  	      	      {
  	      	        iso: "ZM",
  	      	        label: "Zambia",
  	      	        dial: "+260",
  	      	        example: "971234567",
  	      	        nsnMin: 9,
  	      	        nsnMax: 9
  	      	      },
  	      	      {
  	      	        iso: "MZ",
  	      	        label: "Mozambique",
  	      	        dial: "+258",
  	      	        example: "841234567",
  	      	        nsnMin: 9,
  	      	        nsnMax: 9
  	      	      },
  	      	      {
  	      	        iso: "LS",
  	      	        label: "Lesotho",
  	      	        dial: "+266",
  	      	        example: "50123456",
  	      	        nsnMin: 8,
  	      	        nsnMax: 8
  	      	      },
  	      	      {
  	      	        iso: "SZ",
  	      	        label: "Eswatini",
  	      	        dial: "+268",
  	      	        example: "76123456",
  	      	        nsnMin: 8,
  	      	        nsnMax: 8
  	      	      },
  	      	      {
  	      	        iso: "MW",
  	      	        label: "Malawi",
  	      	        dial: "+265",
  	      	        example: "991234567",
  	      	        nsnMin: 9,
  	      	        nsnMax: 9
  	      	      },
  	      	      {
  	      	        iso: "GB",
  	      	        label: "United Kingdom",
  	      	        dial: "+44",
  	      	        example: "7123456789",
  	      	        nsnMin: 9,
  	      	        nsnMax: 10
  	      	      },
  	      	      {
  	      	        iso: "US",
  	      	        label: "United States",
  	      	        dial: "+1",
  	      	        example: "3133950896",
  	      	        nsnMin: 10,
  	      	        nsnMax: 10
  	      	      },
  	      	      {
  	      	        iso: "INTL",
  	      	        label: "International",
  	      	        dial: "",
  	      	        example: "+27821234567",
  	      	        nsnMin: 8,
  	      	        nsnMax: 15,
  	      	        allowAnyIntl: true
  	      	      }];

  	      	    function getWhatsappCountryByIso(iso) {
  	      	      return TRACKIT_WHATSAPP_COUNTRIES.find(c => c.iso === iso) || TRACKIT_WHATSAPP_COUNTRIES[0];
  	      	    }

  	      	    function getWhatsappCountryOptionsHtml(selectedIso) {
  	      	      return TRACKIT_WHATSAPP_COUNTRIES.map(country => {
  	      	        const selected = country.iso === selectedIso ? "selected": "";
  	      	        const label = country.dial
  	      	        ? `${country.iso} ${country.dial}`: `${country.iso} +`;

  	      	        return `<option value="${country.iso}" ${selected}>${label}</option>`;
  	      	      }).join("");
  	      	    }

  	      	    function getSelectedWhatsappCountry(popup) {
  	      	      const select = popup?.querySelector?.(".trackit-directions-country-select");
  	      	      return getWhatsappCountryByIso(select?.value || "ZA");
  	      	    }

  	      	    function updateWhatsappPhonePlaceholder(popup) {
  	      	      const country = getSelectedWhatsappCountry(popup);
  	      	      const phoneInput = popup?.querySelector?.(".trackit-directions-whatsapp-phone");

  	      	      if (!phoneInput) return;

  	      	      if (country.allowAnyIntl) {
  	      	        phoneInput.placeholder = "Full number e.g. +27821234567";
  	      	        return;
  	      	      }

  	      	      phoneInput.placeholder = `${country.iso} WhatsApp e.g. ${country.example}`;
  	      	    }

  	      	    function normaliseWhatsappNumber(raw, countryIso) {
  	      	      const country = getWhatsappCountryByIso(countryIso || "ZA");

  	      	      let text = String(raw || "").trim();

  	      	      if (!text) {
  	      	        return {
  	      	          ok: false,
  	      	          value: "",
  	      	          error: "Enter a WhatsApp number first."
  	      	        };
  	      	      }

  	      	      text = text.replace(/^whatsapp:/i, "").trim();
  	      	      text = text.replace(/[^\d+]/g, "");

  	      	      const plusCount = (text.match(/\+/g) || []).length;

  	      	      if (plusCount > 1 || (text.includes("+") && !text.startsWith("+"))) {
  	      	        return {
  	      	          ok: false,
  	      	          value: "",
  	      	          error: "Invalid WhatsApp number format."
  	      	        };
  	      	      }

  	      	      let digits = text.replace(/\D/g, "");

  	      	      if (country.allowAnyIntl) {
  	      	        if (!text.startsWith("+")) {
  	      	          return {
  	      	            ok: false,
  	      	            value: "",
  	      	            error: "Use full international format, for example +27821234567."
  	      	          };
  	      	        }

  	      	        if (digits.length < 8 || digits.length > 15) {
  	      	          return {
  	      	            ok: false,
  	      	            value: "",
  	      	            error: "WhatsApp number must be 8 to 15 digits in international format."
  	      	          };
  	      	        }

  	      	        return {
  	      	          ok: true,
  	      	          value: `+${digits}`,
  	      	          country
  	      	        };
  	      	      }

  	      	      const dialDigits = country.dial.replace(/\D/g, "");
  	      	      let nationalNumber = "";

  	      	      if (text.startsWith("+")) {
  	      	        if (!digits.startsWith(dialDigits)) {
  	      	          return {
  	      	            ok: false,
  	      	            value: "",
  	      	            error: `Number does not match selected country ${country.iso} ${country.dial}.`
  	      	          };
  	      	        }

  	      	        nationalNumber = digits.slice(dialDigits.length);
  	      	      } else {
  	      	        if (digits.startsWith(dialDigits) && digits.length > dialDigits.length + 3) {
  	      	          nationalNumber = digits.slice(dialDigits.length);
  	      	        } else {
  	      	          nationalNumber = digits;
  	      	        }

  	      	        // Local SA-style trunk prefix:
  	      	        // 0821234567 -> 821234567
  	      	        if (nationalNumber.startsWith("0")) {
  	      	          nationalNumber = nationalNumber.slice(1);
  	      	        }
  	      	      }

  	      	      if (
  	      	        nationalNumber.length < country.nsnMin ||
  	      	        nationalNumber.length > country.nsnMax
  	      	      ) {
  	      	        return {
  	      	          ok: false,
  	      	          value: "",
  	      	          error: `${country.iso} number must be ${country.nsnMin === country.nsnMax ? country.nsnMin: `${country.nsnMin}-${country.nsnMax}`} digits after ${country.dial}.`
  	      	        };
  	      	      }

  	      	      if (country.mobilePattern && !country.mobilePattern.test(nationalNumber)) {
  	      	        return {
  	      	          ok: false,
  	      	          value: "",
  	      	          error: `That does not look like a valid ${country.iso} mobile WhatsApp number.`
  	      	        };
  	      	      }

  	      	      const e164 = `${country.dial}${nationalNumber}`;
  	      	      const e164Digits = e164.replace(/\D/g, "");

  	      	      if (e164Digits.length < 8 || e164Digits.length > 15) {
  	      	        return {
  	      	          ok: false,
  	      	          value: "",
  	      	          error: "WhatsApp number must be valid international E.164 format."
  	      	        };
  	      	      }

  	      	      return {
  	      	        ok: true,
  	      	        value: e164,
  	      	        country
  	      	      };
  	      	    }

  	      	    function getTrackitWhatsappButtonHtml(label) {
  	      	      return `
  	      	      <svg class="trackit-whatsapp-icon" viewBox="0 0 32 32" aria-hidden="true">
  	      	      <path fill="currentColor" d="M16.02 3.2C9.02 3.2 3.34 8.78 3.34 15.66c0 2.22.6 4.38 1.74 6.27L3.2 28.8l7.08-1.84a12.9 12.9 0 0 0 5.74 1.36c7 0 12.68-5.58 12.68-12.46S23.02 3.2 16.02 3.2Zm0 22.98c-1.84 0-3.64-.49-5.2-1.42l-.37-.22-4.2 1.09 1.12-4.02-.25-.41a10.06 10.06 0 0 1-1.56-5.34c0-5.69 4.7-10.32 10.46-10.32s10.46 4.63 10.46 10.32-4.7 10.32-10.46 10.32Zm5.74-7.72c-.31-.15-1.84-.9-2.13-1-.29-.1-.5-.15-.71.15-.21.31-.82 1-.99 1.2-.18.2-.36.23-.67.08-.31-.15-1.31-.48-2.5-1.53-.92-.81-1.54-1.81-1.72-2.12-.18-.3-.02-.47.13-.62.14-.14.31-.36.47-.54.16-.18.21-.31.31-.51.1-.2.05-.38-.03-.54-.08-.15-.71-1.69-.97-2.31-.25-.6-.51-.52-.71-.53h-.6c-.21 0-.55.08-.84.38-.29.3-1.1 1.06-1.1 2.59s1.13 3.01 1.29 3.22c.16.2 2.23 3.35 5.41 4.7.76.32 1.35.51 1.81.65.76.24 1.45.21 2 .13.61-.09 1.84-.74 2.1-1.45.26-.71.26-1.32.18-1.45-.08-.13-.29-.2-.6-.36Z"/>
  	      	      </svg>
  	      	      <span>${label}</span>
  	      	      `;
  	      	    }

  	      	    function setTrackitWhatsappButtonState(button, label, sending) {
  	      	      if (!button) return;

  	      	      button.classList.toggle("sending", !!sending);
  	      	      button.innerHTML = getTrackitWhatsappButtonHtml(label);
  	      	    }

  	      	    function getDirectionsSummaryForWhatsapp() {
  	      	      const s = getTrackitDirectionsState();

  	      	      const from = formatDirectionsPointText(s.point1, s.point1Label);
  	      	      const to = formatDirectionsPointText(s.point2, s.point2Label);
  	      	      const stops = (s.waypoints || [])
  	      	      .filter(wp => !!wp?.point)
  	      	      .map((wp, index) => `${index + 1}. ${formatDirectionsPointText(wp.point, wp.label)}`);

  	      	      return {
  	      	        from,
  	      	        to,
  	      	        stops
  	      	      };
  	      	    }

  	      	    async function sendDirectionsWhatsapp(triggerButton) {
  	      	      const s = getTrackitDirectionsState();
  	      	      const popup = s.popup;

  	      	      if (!popup) return;

  	      	      const phoneInput = popup.querySelector(".trackit-directions-whatsapp-phone");
  	      	      const countrySelect = popup.querySelector(".trackit-directions-country-select");
  	      	      const normalWhatsappBtn = popup.querySelector(".trackit-directions-whatsapp-btn");
  	      	      const sendBtn = triggerButton || normalWhatsappBtn;
  	      	      const idleButtonLabel = sendBtn?.classList?.contains("trackit-directions-driver-btn")
  	      	      ? "WhatsApp Driver"
  	      	      : "WhatsApp";

  	      	      const checkedNumber = normaliseWhatsappNumber(
  	      	        phoneInput?.value,
  	      	        countrySelect?.value || "ZA"
  	      	      );

  	      	      if (!checkedNumber.ok) {
  	      	        updateDirectionsStatusText(checkedNumber.error);
  	      	        phoneInput?.classList?.add("invalid");
  	      	        phoneInput?.focus?.();
  	      	        return;
  	      	      }

  	      	      phoneInput.classList.remove("invalid");
  	      	      phoneInput.value = checkedNumber.value;

  	      	      const to = checkedNumber.value;

  	      	      if (!s.point1 || !s.point2) {
  	      	        updateDirectionsStatusText("Build a route before sending.");
  	      	        return;
  	      	      }

  	      	      const mapsUrl = buildGoogleMapsDirectionsUrl();

  	      	      if (!mapsUrl) {
  	      	        updateDirectionsStatusText("Could not build Google Maps route link.");
  	      	        return;
  	      	      }

  	      	      const summary = getDirectionsSummaryForWhatsapp();

  	      	      const stopsText = summary.stops.length
  	      	      ? summary.stops.join("\n"): "No stops";

  	      	      const payload = {
  	      	        To: to,
  	      	        FromLocation: summary.from,
  	      	        ToLocation: summary.to,
  	      	        Stops: stopsText,
  	      	        RouteLink: mapsUrl
  	      	      };

  	      	      try {
  	      	        setTrackitWhatsappButtonState(sendBtn, "Sending...", true);

  	      	        updateDirectionsStatusText("Sending WhatsApp route...");

  	      	        console.log("[TrackIT WhatsApp] Sending template payload:", payload);

  	      	        const result = await invokeTrackitWhatsAppService(payload);

  	      	        updateDirectionsStatusText("WhatsApp route sent.");
  	      	        console.log("[TrackIT WhatsApp] Sent:", result);

  	      	      } catch (error) {
  	      	        console.error("[TrackIT WhatsApp] Send failed:", error);

  	      	        const message = error?.message || String(error || "");

  	      	        if (message.includes("not available")) {
  	      	          updateDirectionsStatusText("WhatsApp failed. Backendless service invoke is not available on this screen.");
  	      	        } else {
  	      	          updateDirectionsStatusText("WhatsApp failed. Check template approval, Backendless service config, and Twilio logs.");
  	      	        }

  	      	      } finally {
  	      	        setTrackitWhatsappButtonState(sendBtn, idleButtonLabel, false);
  	      	      }
  	      	    }

  	      	    async function invokeTrackitWhatsAppService(payload) {
  	      	      const serviceArgs = {
  	      	        To: payload.To,
  	      	        FromLocation: payload.FromLocation,
  	      	        ToLocation: payload.ToLocation,
  	      	        Stops: payload.Stops,
  	      	        RouteLink: payload.RouteLink
  	      	      };

  	      	      console.log("[TrackIT WhatsApp] Backendless service args:", serviceArgs);

  	      	      if (
  	      	        typeof Backendless !== "undefined" &&
  	      	        Backendless.CustomServices &&
  	      	        typeof Backendless.CustomServices.invoke === "function"
  	      	      ) {
  	      	        return Backendless.CustomServices.invoke(
  	      	          TRACKIT_WHATSAPP_SERVICE_NAME,
  	      	          TRACKIT_WHATSAPP_METHOD_NAME,
  	      	          serviceArgs
  	      	        );
  	      	      }

  	      	      if (
  	      	        typeof BackendlessUI !== "undefined" &&
  	      	        BackendlessUI.Backendless &&
  	      	        BackendlessUI.Backendless.CustomServices &&
  	      	        typeof BackendlessUI.Backendless.CustomServices.invoke === "function"
  	      	      ) {
  	      	        return BackendlessUI.Backendless.CustomServices.invoke(
  	      	          TRACKIT_WHATSAPP_SERVICE_NAME,
  	      	          TRACKIT_WHATSAPP_METHOD_NAME,
  	      	          serviceArgs
  	      	        );
  	      	      }

  	      	      if (
  	      	        typeof window !== "undefined" &&
  	      	        window.Backendless &&
  	      	        window.Backendless.CustomServices &&
  	      	        typeof window.Backendless.CustomServices.invoke === "function"
  	      	      ) {
  	      	        return window.Backendless.CustomServices.invoke(
  	      	          TRACKIT_WHATSAPP_SERVICE_NAME,
  	      	          TRACKIT_WHATSAPP_METHOD_NAME,
  	      	          serviceArgs
  	      	        );
  	      	      }

  	      	      throw new Error("Backendless CustomServices.invoke is not available.");
  	      	    }

  	      	    map.__trackitAddDirectionsPoint = addDirectionsPoint;
  	      	    map.__trackitGetDirectionsVehicleMeta = getDirectionsVehicleMetaFromTractor;
  	      	    map.__trackitStartDirectionsMode = startDirectionsMode;
  	      	    map.__trackitStopDirectionsMode = stopDirectionsMode;
  	      	    map.__trackitToggleDirectionsMode = toggleDirectionsMode;


  	      	    try {
  	      	      const positions = [
  	      	        google.maps.ControlPosition.RIGHT_BOTTOM,
  	      	        google.maps.ControlPosition.LEFT_BOTTOM,
  	      	        google.maps.ControlPosition.RIGHT_TOP,
  	      	        google.maps.ControlPosition.LEFT_TOP
  	      	      ];

  	      	      positions.forEach(pos => {
  	      	        const controls = map.controls[pos];

  	      	        for (let i = controls.getLength() - 1; i >= 0; i--) {
  	      	          const item = controls.getAt(i);

  	      	          if (item?.__trackitUnifiedMapControl) {
  	      	            controls.removeAt(i);
  	      	          }
  	      	        }
  	      	      });
  	      	    } catch (_) {}

  	      	    if (map.__trackitMapControlListeners) {
  	      	      map.__trackitMapControlListeners.forEach(listener => {
  	      	        try {
  	      	          google.maps.event.removeListener(listener);
  	      	        } catch (_) {}
  	      	      });
  	      	    }

  	      	    if (map.__trackitDomControlListeners) {
  	      	      map.__trackitDomControlListeners.forEach(({
  	      	        target, event, handler
  	      	      }) => {
  	      	        try {
  	      	          target.removeEventListener(event, handler);
  	      	        } catch (_) {}
  	      	      });
  	      	    }

  	      	    map.__trackitMapControlListeners = [];
  	      	    map.__trackitDomControlListeners = [];
  	      	    map.__trackitUnifiedMapControlReady = false;
  	      	    map.__trackitUnifiedMapControlVersion = "";

  	      	    const NO_LABEL_STYLES = [{
  	      	      elementType: "labels",
  	      	      stylers: [{
  	      	        visibility: "off"
  	      	      }]
  	      	    },
  	      	      {
  	      	        featureType: "poi",
  	      	        stylers: [{
  	      	          visibility: "off"
  	      	        }]
  	      	      },
  	      	      {
  	      	        featureType: "transit",
  	      	        stylers: [{
  	      	          visibility: "off"
  	      	        }]
  	      	      }];

  	      	    function getSettingsBag() {
  	      	      const bag = getAppBag();

  	      	      if (bag) {
  	      	        if (!bag.TrackITMapSettings) {
  	      	          bag.TrackITMapSettings = {};
  	      	        }

  	      	        return bag.TrackITMapSettings;
  	      	      }

  	      	      if (!map.__trackitLocalMapSettings) {
  	      	        map.__trackitLocalMapSettings = {};
  	      	      }

  	      	      return map.__trackitLocalMapSettings;
  	      	    }

  	      	    function writeSetting(key, value) {
  	      	      const settings = getSettingsBag();
  	      	      settings[key] = value;

  	      	      try {
  	      	        refreshApp();
  	      	      } catch (_) {}
  	      	    }

  	      	    function readSetting(key, fallback) {
  	      	      const settings = getSettingsBag();
  	      	      return settings[key] !== undefined ? settings[key]: fallback;
  	      	    }

  	      	    const oldStyle = document.getElementById("trackit-compact-map-control-css");
  	      	    if (oldStyle) oldStyle.remove();

  	      	    const style = document.createElement("style");
  	      	    style.id = "trackit-compact-map-control-css";

  	      	    style.textContent = `
  	      	    .trackit-compact-map-control.ces-bottom-shape {
  	      	    position: absolute !important;
  	      	    right: 0 !important;
  	      	    bottom: 0 !important;
  	      	    top: auto !important;
  	      	    z-index: 999999 !important;
  	      	    pointer-events: auto !important;
  	      	    box-sizing: border-box !important;
  	      	    color: #fff !important;
  	      	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;

  	      	    background:
  	      	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.16), transparent 32%),
  	      	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;

  	      	    border-top: 1px solid rgba(255,122,36,0.52) !important;
  	      	    border-left: 1px solid rgba(255,122,36,0.52) !important;
  	      	    border-right: 0 !important;
  	      	    border-bottom: 0 !important;

  	      	    box-shadow:
  	      	    -12px -16px 32px rgba(0,0,0,0.40),
  	      	    inset 0 1px 0 rgba(255,255,255,0.045),
  	      	    inset 0 -18px 38px rgba(0,0,0,0.24) !important;

  	      	    user-select: none !important;
  	      	    }

  	      	    .trackit-compact-map-control.ces-bottom-shape::before {
  	      	    content: "" !important;
  	      	    position: absolute !important;
  	      	    inset: 0 !important;
  	      	    pointer-events: none !important;
  	      	    z-index: 1 !important;
  	      	    opacity: 0.16 !important;
  	      	    background:
  	      	    repeating-radial-gradient(
  	      	    ellipse at 34% 118%,
  	      	    transparent 0,
  	      	    transparent 9px,
  	      	    rgba(255,116,34,0.20) 10px,
  	      	    transparent 12px
  	      	    ) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-bottom-content {
  	      	    position: relative !important;
  	      	    z-index: 2 !important;
  	      	    width: 100% !important;
  	      	    height: auto !important;
  	      	    padding: 10px 12px 12px 12px !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-compact-map-control.collapsed .ces-bottom-content {
  	      	    padding: 9px 12px !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-header {
  	      	    width: 100% !important;
  	      	    height: 38px !important;
  	      	    border: 0 !important;
  	      	    outline: 0 !important;
  	      	    background: transparent !important;
  	      	    color: inherit !important;
  	      	    display: grid !important;
  	      	    grid-template-columns: 31px minmax(0, 1fr) 16px !important;
  	      	    align-items: center !important;
  	      	    gap: 8px !important;
  	      	    padding: 0 !important;
  	      	    margin: 0 !important;
  	      	    cursor: pointer !important;
  	      	    text-align: left !important;
  	      	    appearance: none !important;
  	      	    -webkit-appearance: none !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-layer-icon {
  	      	    width: 30px !important;
  	      	    height: 30px !important;
  	      	    border-radius: 12px !important;
  	      	    display: flex !important;
  	      	    flex-direction: column !important;
  	      	    align-items: center !important;
  	      	    justify-content: center !important;
  	      	    gap: 3px !important;
  	      	    background:
  	      	    radial-gradient(circle at 35% 22%, rgba(255,153,70,0.42), rgba(4,5,5,0.92) 72%) !important;
  	      	    border: 1px solid rgba(255,132,48,0.54) !important;
  	      	    box-shadow:
  	      	    0 0 15px rgba(255,122,36,0.18),
  	      	    inset 0 1px 0 rgba(255,255,255,0.10) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-layer-icon span {
  	      	    width: 14px !important;
  	      	    height: 2px !important;
  	      	    border-radius: 999px !important;
  	      	    background: #ff9a3d !important;
  	      	    box-shadow: 0 0 8px rgba(255,122,36,0.34) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-header-text {
  	      	    min-width: 0 !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-title {
  	      	    font-size: 11px !important;
  	      	    font-weight: 950 !important;
  	      	    letter-spacing: 0.10em !important;
  	      	    text-transform: uppercase !important;
  	      	    color: #ffe3c5 !important;
  	      	    line-height: 1 !important;
  	      	    white-space: nowrap !important;
  	      	    overflow: hidden !important;
  	      	    text-overflow: ellipsis !important;
  	      	    margin: 0 !important;
  	      	    padding: 0 !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-subtitle {
  	      	    margin: 4px 0 0 !important;
  	      	    padding: 0 !important;
  	      	    font-size: 7px !important;
  	      	    font-weight: 950 !important;
  	      	    letter-spacing: 0.13em !important;
  	      	    text-transform: uppercase !important;
  	      	    color: rgba(255,255,255,0.56) !important;
  	      	    line-height: 1 !important;
  	      	    white-space: nowrap !important;
  	      	    overflow: hidden !important;
  	      	    text-overflow: ellipsis !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-caret {
  	      	    color: #ff8a3c !important;
  	      	    font-size: 12px !important;
  	      	    font-weight: 950 !important;
  	      	    display: flex !important;
  	      	    align-items: center !important;
  	      	    justify-content: center !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-body {
  	      	    display: grid !important;
  	      	    grid-template-columns: minmax(0, 1fr) 56px !important;
  	      	    gap: 12px !important;
  	      	    align-items: start !important;
  	      	    margin-top: 12px !important;
  	      	    min-width: 0 !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-compact-map-control.collapsed .ces-map-control-body {
  	      	    display: none !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-main {
  	      	    min-width: 0 !important;
  	      	    display: flex !important;
  	      	    flex-direction: column !important;
  	      	    gap: 12px !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-section {
  	      	    display: flex !important;
  	      	    flex-direction: column !important;
  	      	    gap: 7px !important;
  	      	    min-width: 0 !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-section-title {
  	      	    height: auto !important;
  	      	    min-height: 13px !important;
  	      	    display: flex !important;
  	      	    align-items: center !important;
  	      	    gap: 6px !important;
  	      	    color: rgba(255,232,208,0.78) !important;
  	      	    font-size: 8px !important;
  	      	    font-weight: 950 !important;
  	      	    letter-spacing: 0.12em !important;
  	      	    text-transform: uppercase !important;
  	      	    line-height: 1 !important;
  	      	    padding: 0 !important;
  	      	    margin: 0 !important;
  	      	    border: 0 !important;
  	      	    background: transparent !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-section-title svg {
  	      	    width: 13px !important;
  	      	    height: 13px !important;
  	      	    color: #ff8a3c !important;
  	      	    flex: 0 0 auto !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-tools {
  	      	    display: grid !important;
  	      	    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	      	    grid-auto-rows: 38px !important;
  	      	    gap: 7px !important;
  	      	    min-width: 0 !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-compact-map-control .fleet-map-type-tools {
  	      	    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-tool {
  	      	    width: auto !important;
  	      	    height: 36px !important;
  	      	    min-width: 0 !important;
  	      	    border-radius: 13px !important;
  	      	    border: 1px solid rgba(255,255,255,0.10) !important;
  	      	    background:
  	      	    linear-gradient(145deg, rgba(255,255,255,0.055), rgba(255,255,255,0.018)) !important;
  	      	    color: rgba(255,255,255,0.78) !important;
  	      	    display: flex !important;
  	      	    align-items: center !important;
  	      	    justify-content: flex-start !important;
  	      	    gap: 8px !important;
  	      	    padding: 0 10px !important;
  	      	    box-sizing: border-box !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 950 !important;
  	      	    text-align: left !important;
  	      	    overflow: hidden !important;
  	      	    box-shadow:
  	      	    inset 0 0 0 1px rgba(255,255,255,0.025),
  	      	    0 7px 14px rgba(0,0,0,0.18) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-tool svg {
  	      	    width: 14px !important;
  	      	    height: 14px !important;
  	      	    color: rgba(255,255,255,0.78) !important;
  	      	    flex: 0 0 14px !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-tool span {
  	      	    min-width: 0 !important;
  	      	    overflow: hidden !important;
  	      	    text-overflow: ellipsis !important;
  	      	    white-space: nowrap !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-tool:hover {
  	      	    color: #fff !important;
  	      	    border-color: rgba(255,138,61,0.38) !important;
  	      	    background: rgba(255,138,61,0.10) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-tool.active,
  	      	    .trackit-compact-map-control .ces-map-control-tool.fullscreen-active {
  	      	    color: #fff !important;
  	      	    border-color: rgba(255,138,61,0.62) !important;
  	      	    background:
  	      	    linear-gradient(145deg, rgba(255,122,36,0.28), rgba(95,42,17,0.32)) !important;
  	      	    box-shadow:
  	      	    inset 0 0 0 1px rgba(255,138,61,0.30),
  	      	    inset 0 0 18px rgba(255,105,25,0.12),
  	      	    0 7px 14px rgba(0,0,0,0.18) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-tool.active svg,
  	      	    .trackit-compact-map-control .ces-map-control-tool.fullscreen-active svg {
  	      	    color: #ff9a3d !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-zoom-rail {
  	      	    width: 56px !important;
  	      	    min-width: 56px !important;
  	      	    height: 286px !important;
  	      	    min-height: 286px !important;
  	      	    max-height: 286px !important;
  	      	    display: grid !important;
  	      	    grid-template-rows: auto auto 32px 176px 32px !important;
  	      	    justify-items: center !important;
  	      	    align-items: center !important;
  	      	    box-sizing: border-box !important;
  	      	    align-self: start !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-zoom-label {
  	      	    color: rgba(255,232,208,0.78) !important;
  	      	    font-size: 8px !important;
  	      	    font-weight: 950 !important;
  	      	    letter-spacing: 0.12em !important;
  	      	    text-transform: uppercase !important;
  	      	    line-height: 1 !important;
  	      	    margin: 0 0 6px !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-zoom-value {
  	      	    width: 36px !important;
  	      	    height: 36px !important;
  	      	    border-radius: 999px !important;
  	      	    display: flex !important;
  	      	    align-items: center !important;
  	      	    justify-content: center !important;
  	      	    background:
  	      	    radial-gradient(circle at 40% 35%, rgba(255,255,255,0.22), rgba(25,25,25,0.88) 70%) !important;
  	      	    border: 2px solid rgba(255,122,39,0.68) !important;
  	      	    color: #fff !important;
  	      	    font-size: 12px !important;
  	      	    font-weight: 950 !important;
  	      	    box-shadow:
  	      	    0 0 10px rgba(255,105,25,0.24),
  	      	    inset 0 0 0 1px rgba(255,255,255,0.12) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-zoom-btn {
  	      	    width: 32px !important;
  	      	    height: 32px !important;
  	      	    border-radius: 999px !important;
  	      	    border: 1px solid rgba(255,255,255,0.12) !important;
  	      	    background: rgba(255,255,255,0.045) !important;
  	      	    color: #fff !important;
  	      	    cursor: pointer !important;
  	      	    font-weight: 950 !important;
  	      	    font-size: 16px !important;
  	      	    line-height: 1 !important;
  	      	    padding: 0 !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-zoom-btn:hover {
  	      	    background: rgba(255,111,29,0.16) !important;
  	      	    border-color: rgba(255,137,56,0.46) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-slider-wrap {
  	      	    position: relative !important;
  	      	    display: flex !important;
  	      	    align-items: center !important;
  	      	    justify-content: center !important;
  	      	    width: 100% !important;
  	      	    height: 176px !important;
  	      	    min-height: 176px !important;
  	      	    max-height: 176px !important;
  	      	    margin: 8px 0 !important;
  	      	    padding: 0 !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-slider-wrap::before {
  	      	    content: "" !important;
  	      	    position: absolute !important;
  	      	    top: 8px !important;
  	      	    bottom: 8px !important;
  	      	    left: 50% !important;
  	      	    width: 1px !important;
  	      	    transform: translateX(-50%) !important;
  	      	    background: repeating-linear-gradient(
  	      	    to bottom,
  	      	    rgba(255,255,255,0.18) 0,
  	      	    rgba(255,255,255,0.18) 1px,
  	      	    transparent 1px,
  	      	    transparent 8px
  	      	    ) !important;
  	      	    }

  	      	    .trackit-compact-map-control .ces-map-control-zoom-slider {
  	      	    position: relative !important;
  	      	    z-index: 1 !important;
  	      	    writing-mode: vertical-lr !important;
  	      	    direction: rtl !important;
  	      	    width: 26px !important;
  	      	    height: 176px !important;
  	      	    min-height: 176px !important;
  	      	    max-height: 176px !important;
  	      	    accent-color: #ff7928 !important;
  	      	    cursor: pointer !important;
  	      	    margin: 0 !important;
  	      	    padding: 0 !important;
  	      	    appearance: auto !important;
  	      	    -webkit-appearance: slider-vertical !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-toggle-row {
  	      	    position: relative !important;
  	      	    width: 100% !important;
  	      	    user-select: none !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-toggle-row input {
  	      	    position: absolute !important;
  	      	    opacity: 0 !important;
  	      	    pointer-events: none !important;
  	      	    width: 0 !important;
  	      	    height: 0 !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-tick {
  	      	    width: 13px !important;
  	      	    height: 13px !important;
  	      	    flex: 0 0 13px !important;
  	      	    border-radius: 4px !important;
  	      	    border: 1px solid rgba(255,255,255,0.24) !important;
  	      	    background: rgba(255,255,255,0.045) !important;
  	      	    box-shadow:
  	      	    inset 0 0 0 1px rgba(255,255,255,0.025),
  	      	    0 4px 8px rgba(0,0,0,0.18) !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-toggle-row input:checked + .trackit-location-tick {
  	      	    border-color: rgba(255,138,61,0.72) !important;
  	      	    background:
  	      	    radial-gradient(circle at 40% 35%, rgba(255,154,61,0.95), rgba(255,122,36,0.26) 72%) !important;
  	      	    box-shadow:
  	      	    0 0 10px rgba(255,122,36,0.22),
  	      	    inset 0 0 0 1px rgba(255,255,255,0.16) !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-list {
  	      	    display: none !important;
  	      	    max-height: 116px !important;
  	      	    overflow-y: auto !important;
  	      	    overflow-x: hidden !important;
  	      	    padding: 2px 3px 2px 0 !important;
  	      	    margin: 0 !important;
  	      	    gap: 5px !important;
  	      	    flex-direction: column !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-list.visible {
  	      	    display: flex !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-list::-webkit-scrollbar {
  	      	    width: 5px !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-list::-webkit-scrollbar-thumb {
  	      	    background: rgba(255,122,36,0.42) !important;
  	      	    border-radius: 999px !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-row {
  	      	    width: 100% !important;
  	      	    height: 30px !important;
  	      	    min-height: 30px !important;
  	      	    border-radius: 11px !important;
  	      	    border: 1px solid rgba(255,255,255,0.09) !important;
  	      	    background:
  	      	    linear-gradient(145deg, rgba(255,255,255,0.045), rgba(255,255,255,0.014)) !important;
  	      	    color: rgba(255,255,255,0.76) !important;
  	      	    display: grid !important;
  	      	    grid-template-columns: minmax(0, 1fr) auto !important;
  	      	    align-items: center !important;
  	      	    gap: 8px !important;
  	      	    padding: 0 9px !important;
  	      	    box-sizing: border-box !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 9px !important;
  	      	    font-weight: 900 !important;
  	      	    text-align: left !important;
  	      	    overflow: hidden !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-row:hover {
  	      	    color: #fff !important;
  	      	    border-color: rgba(255,138,61,0.34) !important;
  	      	    background: rgba(255,138,61,0.09) !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-row.active {
  	      	    color: #fff !important;
  	      	    border-color: rgba(255,138,61,0.60) !important;
  	      	    background:
  	      	    linear-gradient(145deg, rgba(255,122,36,0.24), rgba(95,42,17,0.28)) !important;
  	      	    box-shadow:
  	      	    inset 0 0 0 1px rgba(255,138,61,0.24),
  	      	    0 7px 14px rgba(0,0,0,0.16) !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-row {
  	      	    position: relative !important;
  	      	    grid-template-columns: 14px minmax(0, 1fr) auto !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-row input {
  	      	    position: absolute !important;
  	      	    opacity: 0 !important;
  	      	    pointer-events: none !important;
  	      	    width: 0 !important;
  	      	    height: 0 !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-row .trackit-location-tick {
  	      	    width: 13px !important;
  	      	    height: 13px !important;
  	      	    border-radius: 4px !important;
  	      	    border: 1px solid rgba(255,255,255,0.24) !important;
  	      	    background: rgba(255,255,255,0.045) !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-row input:checked + .trackit-location-tick {
  	      	    border-color: rgba(255,138,61,0.72) !important;
  	      	    background:
  	      	    radial-gradient(circle at 40% 35%, rgba(255,154,61,0.95), rgba(255,122,36,0.26) 72%) !important;
  	      	    box-shadow:
  	      	    0 0 10px rgba(255,122,36,0.22),
  	      	    inset 0 0 0 1px rgba(255,255,255,0.16) !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-name {
  	      	    min-width: 0 !important;
  	      	    overflow: hidden !important;
  	      	    text-overflow: ellipsis !important;
  	      	    white-space: nowrap !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-company-count {
  	      	    opacity: 0.58 !important;
  	      	    font-size: 8px !important;
  	      	    font-weight: 950 !important;
  	      	    }

  	      	    .trackit-compact-map-control .trackit-location-empty {
  	      	    color: rgba(255,255,255,0.48) !important;
  	      	    font-size: 9px !important;
  	      	    font-weight: 800 !important;
  	      	    padding: 5px 2px !important;
  	      	    }

  	      	    .trackit-location-label-black {
  	      	    position: absolute !important;
  	      	    transform: translate(-50%, -100%) !important;
  	      	    background: rgba(0,0,0,0.86) !important;
  	      	    color: #fff !important;
  	      	    border: 1px solid rgba(255,255,255,0.18) !important;
  	      	    border-radius: 7px !important;
  	      	    padding: 3px 7px !important;
  	      	    font: 900 10px/1.2 Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	      	    letter-spacing: 0.02em !important;
  	      	    white-space: nowrap !important;
  	      	    pointer-events: none !important;
  	      	    box-shadow:
  	      	    0 4px 10px rgba(0,0,0,0.42),
  	      	    inset 0 1px 0 rgba(255,255,255,0.08) !important;
  	      	    }


  	      	    .trackit-directions-popup-header {
  	      	    height: 48px !important;
  	      	    display: flex !important;
  	      	    align-items: center !important;
  	      	    justify-content: space-between !important;
  	      	    gap: 10px !important;
  	      	    padding: 8px 10px !important;
  	      	    box-sizing: border-box !important;
  	      	    cursor: move !important;
  	      	    border-bottom: 1px solid rgba(255,255,255,0.08) !important;
  	      	    background: rgba(255,138,61,0.08) !important;
  	      	    }

  	      	    .trackit-directions-popup-title {
  	      	    font-size: 12px !important;
  	      	    font-weight: 950 !important;
  	      	    letter-spacing: 0.10em !important;
  	      	    text-transform: uppercase !important;
  	      	    color: #ffe3c5 !important;
  	      	    line-height: 1 !important;
  	      	    }

  	      	    .trackit-directions-popup-subtitle {
  	      	    margin-top: 5px !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 850 !important;
  	      	    color: rgba(255,255,255,0.66) !important;
  	      	    line-height: 1 !important;
  	      	    }

  	      	    .trackit-directions-popup-close {
  	      	    width: 26px !important;
  	      	    height: 26px !important;
  	      	    border-radius: 999px !important;
  	      	    border: 1px solid rgba(255,255,255,0.14) !important;
  	      	    background: rgba(255,255,255,0.06) !important;
  	      	    color: #fff !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 18px !important;
  	      	    font-weight: 900 !important;
  	      	    line-height: 22px !important;
  	      	    padding: 0 !important;
  	      	    }

  	      	    .trackit-directions-popup-body {
  	      	    padding: 10px !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-directions-search-wrap {
  	      	    display: flex !important;
  	      	    flex-direction: column !important;
  	      	    gap: 8px !important;
  	      	    padding: 10px !important;
  	      	    box-sizing: border-box !important;
  	      	    border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	      	    }

  	      	    .trackit-directions-search-line {
  	      	    display: grid !important;
  	      	    grid-template-columns: 42px minmax(0, 1fr) !important;
  	      	    align-items: center !important;
  	      	    gap: 8px !important;
  	      	    }

  	      	    .trackit-directions-search-line span {
  	      	    font-size: 9px !important;
  	      	    font-weight: 950 !important;
  	      	    text-transform: uppercase !important;
  	      	    color: rgba(255,232,208,0.74) !important;
  	      	    letter-spacing: 0.08em !important;
  	      	    }

  	      	    .trackit-directions-search-line input {
  	      	    width: 100% !important;
  	      	    height: 30px !important;
  	      	    min-width: 0 !important;
  	      	    border-radius: 10px !important;
  	      	    border: 1px solid rgba(255,255,255,0.12) !important;
  	      	    background: rgba(255,255,255,0.06) !important;
  	      	    color: #fff !important;
  	      	    outline: none !important;
  	      	    padding: 0 9px !important;
  	      	    box-sizing: border-box !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 800 !important;
  	      	    }

  	      	    .trackit-directions-search-line input::placeholder {
  	      	    color: rgba(255,255,255,0.42) !important;
  	      	    }

  	      	    .trackit-directions-search-line input:focus {
  	      	    border-color: rgba(255,138,61,0.56) !important;
  	      	    background: rgba(255,138,61,0.10) !important;
  	      	    }

  	      	    .trackit-directions-status {
  	      	    padding: 0 10px 8px !important;
  	      	    color: rgba(255,255,255,0.62) !important;
  	      	    font-size: 9px !important;
  	      	    font-weight: 850 !important;
  	      	    line-height: 1.25 !important;
  	      	    }

  	      	    .trackit-directions-popup .pac-container {
  	      	    z-index: 1000002 !important;
  	      	    }

  	      	    .trackit-directions-row {
  	      	    display: grid !important;
  	      	    grid-template-columns: 44px minmax(0, 1fr) !important;
  	      	    gap: 8px !important;
  	      	    align-items: center !important;
  	      	    padding: 6px 0 !important;
  	      	    border-bottom: 1px solid rgba(255,255,255,0.06) !important;
  	      	    }

  	      	    .trackit-directions-row span {
  	      	    font-size: 9px !important;
  	      	    font-weight: 950 !important;
  	      	    text-transform: uppercase !important;
  	      	    color: rgba(255,232,208,0.70) !important;
  	      	    }

  	      	    .trackit-directions-row strong {
  	      	    min-width: 0 !important;
  	      	    overflow: hidden !important;
  	      	    text-overflow: ellipsis !important;
  	      	    white-space: nowrap !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 850 !important;
  	      	    color: rgba(255,255,255,0.82) !important;
  	      	    text-align: right !important;
  	      	    }

  	      	    .trackit-directions-actions {
  	      	    display: grid !important;
  	      	    grid-template-columns: 1fr 1fr !important;
  	      	    gap: 7px !important;
  	      	    margin-top: 10px !important;
  	      	    }

  	      	    .trackit-directions-actions button {
  	      	    height: 30px !important;
  	      	    border-radius: 11px !important;
  	      	    border: 1px solid rgba(255,255,255,0.10) !important;
  	      	    background: rgba(255,255,255,0.045) !important;
  	      	    color: rgba(255,255,255,0.82) !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 900 !important;
  	      	    }

  	      	    .trackit-directions-actions button:hover {
  	      	    color: #fff !important;
  	      	    border-color: rgba(255,138,61,0.38) !important;
  	      	    background: rgba(255,138,61,0.10) !important;
  	      	    }

  	      	    /* ---------- Google Places dropdown dark styling ---------- */
  	      	    .pac-container {
  	      	    z-index: 1000005 !important;
  	      	    border-radius: 14px !important;
  	      	    overflow: hidden !important;
  	      	    border: 1px solid rgba(255,122,36,0.48) !important;
  	      	    background:
  	      	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.14), transparent 35%),
  	      	    linear-gradient(145deg, rgba(16,17,16,0.98), rgba(3,7,7,0.99)) !important;
  	      	    box-shadow:
  	      	    0 18px 34px rgba(0,0,0,0.46),
  	      	    inset 0 1px 0 rgba(255,255,255,0.055) !important;
  	      	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	      	    }

  	      	    .pac-item {
  	      	    height: auto !important;
  	      	    min-height: 36px !important;
  	      	    padding: 8px 10px !important;
  	      	    border-top: 1px solid rgba(255,255,255,0.06) !important;
  	      	    color: rgba(255,255,255,0.66) !important;
  	      	    background: transparent !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 10px !important;
  	      	    line-height: 1.25 !important;
  	      	    }

  	      	    .pac-item:hover,
  	      	    .pac-item-selected {
  	      	    background: rgba(255,138,61,0.14) !important;
  	      	    }

  	      	    .pac-item-query {
  	      	    color: #ffe3c5 !important;
  	      	    font-weight: 950 !important;
  	      	    font-size: 10px !important;
  	      	    }

  	      	    .pac-matched {
  	      	    color: #ff9a3d !important;
  	      	    font-weight: 950 !important;
  	      	    }

  	      	    .pac-icon {
  	      	    filter: invert(1) opacity(0.75) !important;
  	      	    }

  	      	    /* ---------- TrackIT vehicle suggestions ---------- */
  	      	    .trackit-directions-input-wrap {
  	      	    position: relative !important;
  	      	    min-width: 0 !important;
  	      	    width: 100% !important;
  	      	    }

  	      	    .trackit-directions-vehicle-suggest {
  	      	    display: none !important;
  	      	    position: absolute !important;
  	      	    top: 34px !important;
  	      	    left: 0 !important;
  	      	    right: 0 !important;
  	      	    z-index: 1000004 !important;
  	      	    max-height: 168px !important;
  	      	    overflow-y: auto !important;
  	      	    overflow-x: hidden !important;
  	      	    border-radius: 13px !important;
  	      	    border: 1px solid rgba(255,122,36,0.44) !important;
  	      	    background:
  	      	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.13), transparent 35%),
  	      	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	      	    box-shadow: 0 14px 26px rgba(0,0,0,0.42) !important;
  	      	    padding: 4px !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-directions-vehicle-suggest.visible {
  	      	    display: block !important;
  	      	    }

  	      	    .trackit-directions-vehicle-option {
  	      	    width: 100% !important;
  	      	    min-height: 32px !important;
  	      	    border: 0 !important;
  	      	    border-radius: 10px !important;
  	      	    background: transparent !important;
  	      	    color: rgba(255,255,255,0.78) !important;
  	      	    display: grid !important;
  	      	    grid-template-columns: minmax(0, 1fr) auto !important;
  	      	    align-items: center !important;
  	      	    gap: 8px !important;
  	      	    padding: 6px 8px !important;
  	      	    box-sizing: border-box !important;
  	      	    cursor: pointer !important;
  	      	    text-align: left !important;
  	      	    }

  	      	    .trackit-directions-vehicle-option:hover {
  	      	    background: rgba(255,138,61,0.14) !important;
  	      	    color: #fff !important;
  	      	    }

  	      	    .trackit-directions-vehicle-id {
  	      	    min-width: 0 !important;
  	      	    overflow: hidden !important;
  	      	    text-overflow: ellipsis !important;
  	      	    white-space: nowrap !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 950 !important;
  	      	    color: #ffe3c5 !important;
  	      	    }

  	      	    .trackit-directions-vehicle-meta {
  	      	    font-size: 8px !important;
  	      	    font-weight: 900 !important;
  	      	    color: rgba(255,255,255,0.50) !important;
  	      	    text-transform: uppercase !important;
  	      	    }

  	      	    .trackit-directions-waypoints {
  	      	    display: flex !important;
  	      	    flex-direction: column !important;
  	      	    gap: 8px !important;
  	      	    }

  	      	    .trackit-directions-search-line {
  	      	    display: grid !important;
  	      	    grid-template-columns: 42px minmax(0, 1fr) 24px !important;
  	      	    align-items: center !important;
  	      	    gap: 8px !important;
  	      	    }

  	      	    .trackit-directions-search-line.no-remove {
  	      	    grid-template-columns: 42px minmax(0, 1fr) !important;
  	      	    }

  	      	    .trackit-directions-remove-stop {
  	      	    width: 22px !important;
  	      	    height: 22px !important;
  	      	    border-radius: 999px !important;
  	      	    border: 1px solid rgba(255,255,255,0.12) !important;
  	      	    background: rgba(255,255,255,0.045) !important;
  	      	    color: rgba(255,255,255,0.78) !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 14px !important;
  	      	    font-weight: 950 !important;
  	      	    line-height: 18px !important;
  	      	    padding: 0 !important;
  	      	    }

  	      	    .trackit-directions-remove-stop:hover {
  	      	    color: #fff !important;
  	      	    border-color: rgba(255,138,61,0.45) !important;
  	      	    background: rgba(255,138,61,0.14) !important;
  	      	    }

  	      	    .trackit-directions-add-stop {
  	      	    height: 30px !important;
  	      	    border-radius: 11px !important;
  	      	    border: 1px solid rgba(255,138,61,0.35) !important;
  	      	    background: rgba(255,138,61,0.08) !important;
  	      	    color: #ffe3c5 !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 950 !important;
  	      	    letter-spacing: 0.04em !important;
  	      	    }

  	      	    .trackit-directions-add-stop:hover {
  	      	    background: rgba(255,138,61,0.16) !important;
  	      	    border-color: rgba(255,138,61,0.62) !important;
  	      	    color: #fff !important;
  	      	    }

  	      	    /* ---------- Directions: Google dropdown dark styling ---------- */
  	      	    .pac-container {
  	      	    z-index: 1000005 !important;
  	      	    border-radius: 14px !important;
  	      	    overflow: hidden !important;
  	      	    border: 1px solid rgba(255,122,36,0.48) !important;
  	      	    background:
  	      	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.14), transparent 35%),
  	      	    linear-gradient(145deg, rgba(16,17,16,0.98), rgba(3,7,7,0.99)) !important;
  	      	    box-shadow:
  	      	    0 18px 34px rgba(0,0,0,0.46),
  	      	    inset 0 1px 0 rgba(255,255,255,0.055) !important;
  	      	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	      	    }

  	      	    .pac-item {
  	      	    min-height: 36px !important;
  	      	    padding: 8px 10px !important;
  	      	    border-top: 1px solid rgba(255,255,255,0.06) !important;
  	      	    color: rgba(255,255,255,0.66) !important;
  	      	    background: transparent !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 10px !important;
  	      	    line-height: 1.25 !important;
  	      	    }

  	      	    .pac-item:hover,
  	      	    .pac-item-selected {
  	      	    background: rgba(255,138,61,0.14) !important;
  	      	    }

  	      	    .pac-item-query {
  	      	    color: #ffe3c5 !important;
  	      	    font-weight: 950 !important;
  	      	    font-size: 10px !important;
  	      	    }

  	      	    .pac-matched {
  	      	    color: #ff9a3d !important;
  	      	    font-weight: 950 !important;
  	      	    }

  	      	    .pac-icon {
  	      	    filter: invert(1) opacity(0.75) !important;
  	      	    }

  	      	    .trackit-directions-popup {
  	      	    position: absolute !important;
  	      	    z-index: 999998 !important;
  	      	    width: 330px !important;
  	      	    border-radius: 16px !important;
  	      	    overflow: visible !important;
  	      	    color: #fff !important;
  	      	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	      	    background:
  	      	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.16), transparent 32%),
  	      	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	      	    border: 1px solid rgba(255,122,36,0.52) !important;
  	      	    box-shadow:
  	      	    0 18px 34px rgba(0,0,0,0.45),
  	      	    inset 0 1px 0 rgba(255,255,255,0.055) !important;
  	      	    pointer-events: auto !important;
  	      	    }

  	      	    .trackit-directions-popup-header {
  	      	    height: 48px !important;
  	      	    display: flex !important;
  	      	    align-items: center !important;
  	      	    justify-content: space-between !important;
  	      	    gap: 10px !important;
  	      	    padding: 8px 10px !important;
  	      	    box-sizing: border-box !important;
  	      	    cursor: move !important;
  	      	    border-bottom: 1px solid rgba(255,255,255,0.08) !important;
  	      	    background: rgba(255,138,61,0.08) !important;
  	      	    border-radius: 16px 16px 0 0 !important;
  	      	    }

  	      	    .trackit-directions-popup-title {
  	      	    font-size: 12px !important;
  	      	    font-weight: 950 !important;
  	      	    letter-spacing: 0.10em !important;
  	      	    text-transform: uppercase !important;
  	      	    color: #ffe3c5 !important;
  	      	    line-height: 1 !important;
  	      	    }

  	      	    .trackit-directions-popup-subtitle {
  	      	    margin-top: 5px !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 850 !important;
  	      	    color: rgba(255,255,255,0.66) !important;
  	      	    line-height: 1 !important;
  	      	    }

  	      	    .trackit-directions-popup-close {
  	      	    width: 26px !important;
  	      	    height: 26px !important;
  	      	    border-radius: 999px !important;
  	      	    border: 1px solid rgba(255,255,255,0.14) !important;
  	      	    background: rgba(255,255,255,0.06) !important;
  	      	    color: #fff !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 18px !important;
  	      	    font-weight: 900 !important;
  	      	    line-height: 22px !important;
  	      	    padding: 0 !important;
  	      	    }

  	      	    .trackit-directions-search-wrap {
  	      	    display: flex !important;
  	      	    flex-direction: column !important;
  	      	    gap: 8px !important;
  	      	    padding: 10px !important;
  	      	    box-sizing: border-box !important;
  	      	    border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	      	    }

  	      	    .trackit-directions-search-line {
  	      	    display: grid !important;
  	      	    grid-template-columns: 46px minmax(0, 1fr) 24px !important;
  	      	    align-items: center !important;
  	      	    gap: 8px !important;
  	      	    min-width: 0 !important;
  	      	    }

  	      	    .trackit-directions-search-line.no-remove {
  	      	    grid-template-columns: 46px minmax(0, 1fr) !important;
  	      	    }

  	      	    .trackit-directions-search-line span {
  	      	    font-size: 9px !important;
  	      	    font-weight: 950 !important;
  	      	    text-transform: uppercase !important;
  	      	    color: rgba(255,232,208,0.74) !important;
  	      	    letter-spacing: 0.08em !important;
  	      	    }

  	      	    .trackit-directions-input-wrap {
  	      	    position: relative !important;
  	      	    min-width: 0 !important;
  	      	    width: 100% !important;
  	      	    }

  	      	    .trackit-directions-search-line input,
  	      	    .trackit-directions-whatsapp-wrap input {
  	      	    width: 100% !important;
  	      	    height: 30px !important;
  	      	    min-width: 0 !important;
  	      	    border-radius: 10px !important;
  	      	    border: 1px solid rgba(255,255,255,0.12) !important;
  	      	    background: rgba(255,255,255,0.06) !important;
  	      	    color: #fff !important;
  	      	    outline: none !important;
  	      	    padding: 0 9px !important;
  	      	    box-sizing: border-box !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 850 !important;
  	      	    }

  	      	    .trackit-directions-search-line input::placeholder,
  	      	    .trackit-directions-whatsapp-wrap input::placeholder {
  	      	    color: rgba(255,255,255,0.42) !important;
  	      	    }

  	      	    .trackit-directions-search-line input:focus {
  	      	    border-color: rgba(255,138,61,0.56) !important;
  	      	    background: rgba(255,138,61,0.10) !important;
  	      	    }

  	      	    .trackit-directions-vehicle-suggest {
  	      	    display: none !important;
  	      	    position: absolute !important;
  	      	    top: 34px !important;
  	      	    left: 0 !important;
  	      	    right: 0 !important;
  	      	    z-index: 1000004 !important;
  	      	    max-height: 168px !important;
  	      	    overflow-y: auto !important;
  	      	    overflow-x: hidden !important;
  	      	    border-radius: 13px !important;
  	      	    border: 1px solid rgba(255,122,36,0.44) !important;
  	      	    background:
  	      	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.13), transparent 35%),
  	      	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	      	    box-shadow: 0 14px 26px rgba(0,0,0,0.42) !important;
  	      	    padding: 4px !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-directions-vehicle-suggest.visible {
  	      	    display: block !important;
  	      	    }

  	      	    .trackit-directions-vehicle-option {
  	      	    width: 100% !important;
  	      	    min-height: 32px !important;
  	      	    border: 0 !important;
  	      	    border-radius: 10px !important;
  	      	    background: transparent !important;
  	      	    color: rgba(255,255,255,0.78) !important;
  	      	    display: grid !important;
  	      	    grid-template-columns: minmax(0, 1fr) auto !important;
  	      	    align-items: center !important;
  	      	    gap: 8px !important;
  	      	    padding: 6px 8px !important;
  	      	    box-sizing: border-box !important;
  	      	    cursor: pointer !important;
  	      	    text-align: left !important;
  	      	    }

  	      	    .trackit-directions-vehicle-option:hover {
  	      	    background: rgba(255,138,61,0.14) !important;
  	      	    color: #fff !important;
  	      	    }

  	      	    .trackit-directions-vehicle-id {
  	      	    min-width: 0 !important;
  	      	    overflow: hidden !important;
  	      	    text-overflow: ellipsis !important;
  	      	    white-space: nowrap !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 950 !important;
  	      	    color: #ffe3c5 !important;
  	      	    }

  	      	    .trackit-directions-vehicle-meta {
  	      	    font-size: 8px !important;
  	      	    font-weight: 900 !important;
  	      	    color: rgba(255,255,255,0.50) !important;
  	      	    text-transform: uppercase !important;
  	      	    }

  	      	    .trackit-directions-waypoints {
  	      	    display: flex !important;
  	      	    flex-direction: column !important;
  	      	    gap: 8px !important;
  	      	    }

  	      	    .trackit-directions-add-stop,
  	      	    .trackit-directions-remove-stop {
  	      	    cursor: pointer !important;
  	      	    }

  	      	    .trackit-directions-add-stop {
  	      	    height: 30px !important;
  	      	    border-radius: 11px !important;
  	      	    border: 1px solid rgba(255,138,61,0.35) !important;
  	      	    background: rgba(255,138,61,0.08) !important;
  	      	    color: #ffe3c5 !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 950 !important;
  	      	    letter-spacing: 0.04em !important;
  	      	    }

  	      	    .trackit-directions-add-stop:hover {
  	      	    background: rgba(255,138,61,0.16) !important;
  	      	    border-color: rgba(255,138,61,0.62) !important;
  	      	    color: #fff !important;
  	      	    }

  	      	    .trackit-directions-remove-stop {
  	      	    width: 22px !important;
  	      	    height: 22px !important;
  	      	    border-radius: 999px !important;
  	      	    border: 1px solid rgba(255,255,255,0.12) !important;
  	      	    background: rgba(255,255,255,0.045) !important;
  	      	    color: rgba(255,255,255,0.78) !important;
  	      	    font-size: 14px !important;
  	      	    font-weight: 950 !important;
  	      	    line-height: 18px !important;
  	      	    padding: 0 !important;
  	      	    }

  	      	    .trackit-directions-remove-stop:hover {
  	      	    color: #fff !important;
  	      	    border-color: rgba(255,138,61,0.45) !important;
  	      	    background: rgba(255,138,61,0.14) !important;
  	      	    }

  	      	    .trackit-directions-status {
  	      	    padding: 8px 10px !important;
  	      	    color: rgba(255,255,255,0.62) !important;
  	      	    font-size: 9px !important;
  	      	    font-weight: 850 !important;
  	      	    line-height: 1.25 !important;
  	      	    border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	      	    }

  	      	    .trackit-directions-popup-body {
  	      	    padding: 10px !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-directions-row {
  	      	    display: grid !important;
  	      	    grid-template-columns: 48px minmax(0, 1fr) !important;
  	      	    gap: 8px !important;
  	      	    align-items: center !important;
  	      	    padding: 6px 0 !important;
  	      	    border-bottom: 1px solid rgba(255,255,255,0.06) !important;
  	      	    }

  	      	    .trackit-directions-row span {
  	      	    font-size: 9px !important;
  	      	    font-weight: 950 !important;
  	      	    text-transform: uppercase !important;
  	      	    color: rgba(255,232,208,0.70) !important;
  	      	    }

  	      	    .trackit-directions-row strong {
  	      	    min-width: 0 !important;
  	      	    overflow: hidden !important;
  	      	    text-overflow: ellipsis !important;
  	      	    white-space: nowrap !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 850 !important;
  	      	    color: rgba(255,255,255,0.82) !important;
  	      	    text-align: right !important;
  	      	    }

  	      	    .trackit-directions-actions {
  	      	    display: grid !important;
  	      	    grid-template-columns: 1fr 1fr !important;
  	      	    gap: 7px !important;
  	      	    margin-top: 10px !important;
  	      	    }

  	      	    .trackit-directions-actions button {
  	      	    height: 30px !important;
  	      	    border-radius: 11px !important;
  	      	    border: 1px solid rgba(255,255,255,0.10) !important;
  	      	    background: rgba(255,255,255,0.045) !important;
  	      	    color: rgba(255,255,255,0.82) !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 900 !important;
  	      	    }

  	      	    .trackit-directions-actions button:hover {
  	      	    color: #fff !important;
  	      	    border-color: rgba(255,138,61,0.38) !important;
  	      	    background: rgba(255,138,61,0.10) !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-wrap {
  	      	    display: grid !important;
  	      	    grid-template-columns: minmax(0, 1fr) auto !important;
  	      	    gap: 7px !important;
  	      	    margin-top: 10px !important;
  	      	    align-items: center !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-wrap input:focus {
  	      	    border-color: rgba(37,211,102,0.62) !important;
  	      	    background: rgba(37,211,102,0.10) !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-btn {
  	      	    height: 30px !important;
  	      	    border-radius: 11px !important;
  	      	    border: 1px solid rgba(37,211,102,0.42) !important;
  	      	    background: rgba(37,211,102,0.10) !important;
  	      	    color: #d8ffe6 !important;
  	      	    cursor: pointer !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 950 !important;
  	      	    white-space: nowrap !important;
  	      	    padding: 0 10px !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-btn:hover {
  	      	    border-color: rgba(37,211,102,0.78) !important;
  	      	    background: rgba(37,211,102,0.18) !important;
  	      	    color: #fff !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-btn.sending {
  	      	    opacity: 0.72 !important;
  	      	    pointer-events: none !important;
  	      	    }

  	      	    .gm-svpc {
  	      	    display: none !important;
  	      	    opacity: 0 !important;
  	      	    pointer-events: none !important;
  	      	    }

  	      	    /* ---------- Directions popup docked right refinement ---------- */

  	      	    .trackit-directions-popup {
  	      	    position: absolute !important;
  	      	    top: 50px !important;
  	      	    right: 0 !important;
  	      	    left: auto !important;
  	      	    width: 430px !important;
  	      	    max-width: calc(100vw - 12px) !important;
  	      	    border-radius: 0 0 0 24px !important;
  	      	    overflow: hidden !important;
  	      	    border-top: 1px solid rgba(255,122,36,0.58) !important;
  	      	    border-left: 1px solid rgba(255,122,36,0.58) !important;
  	      	    border-right: 0 !important;
  	      	    border-bottom: 1px solid rgba(255,122,36,0.46) !important;
  	      	    box-shadow:
  	      	    -16px 18px 36px rgba(0,0,0,0.44),
  	      	    inset 0 1px 0 rgba(255,255,255,0.045) !important;
  	      	    }

  	      	    .trackit-directions-popup-header {
  	      	    cursor: default !important;
  	      	    border-radius: 0 !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-wrap {
  	      	    display: grid !important;
  	      	    grid-template-columns: 86px minmax(0, 1fr) 114px !important;
  	      	    gap: 7px !important;
  	      	    align-items: center !important;
  	      	    width: 100% !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-directions-country-select {
  	      	    height: 38px !important;
  	      	    min-width: 0 !important;
  	      	    border-radius: 12px !important;
  	      	    border: 1px solid rgba(255,138,61,0.34) !important;
  	      	    background:
  	      	    linear-gradient(145deg, rgba(255,138,61,0.15), rgba(255,255,255,0.035)) !important;
  	      	    color: rgba(255,232,208,0.92) !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 950 !important;
  	      	    padding: 0 8px !important;
  	      	    outline: 0 !important;
  	      	    box-sizing: border-box !important;
  	      	    cursor: pointer !important;
  	      	    }

  	      	    .trackit-directions-country-select option {
  	      	    background: #111 !important;
  	      	    color: #fff !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-phone {
  	      	    height: 38px !important;
  	      	    min-width: 0 !important;
  	      	    border-radius: 12px !important;
  	      	    border: 1px solid rgba(255,255,255,0.12) !important;
  	      	    background: rgba(255,255,255,0.055) !important;
  	      	    color: #fff !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 850 !important;
  	      	    padding: 0 10px !important;
  	      	    outline: 0 !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-phone::placeholder {
  	      	    color: rgba(255,255,255,0.38) !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-phone:focus {
  	      	    border-color: rgba(255,138,61,0.68) !important;
  	      	    background: rgba(255,138,61,0.08) !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-phone.invalid {
  	      	    border-color: rgba(255,70,70,0.85) !important;
  	      	    background: rgba(255,45,45,0.10) !important;
  	      	    box-shadow:
  	      	    0 0 0 1px rgba(255,70,70,0.22),
  	      	    0 0 14px rgba(255,45,45,0.16) !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-btn {
  	      	    height: 38px !important;
  	      	    min-width: 0 !important;
  	      	    border-radius: 12px !important;
  	      	    display: flex !important;
  	      	    align-items: center !important;
  	      	    justify-content: center !important;
  	      	    gap: 7px !important;
  	      	    border: 1px solid rgba(51,214,105,0.58) !important;
  	      	    background:
  	      	    linear-gradient(145deg, rgba(37,211,102,0.24), rgba(9,58,29,0.78)) !important;
  	      	    color: #eaffef !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 950 !important;
  	      	    padding: 0 10px !important;
  	      	    box-sizing: border-box !important;
  	      	    cursor: pointer !important;
  	      	    white-space: nowrap !important;
  	      	    box-shadow:
  	      	    inset 0 0 0 1px rgba(255,255,255,0.06),
  	      	    0 7px 14px rgba(0,0,0,0.20) !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-btn:hover {
  	      	    border-color: rgba(80,255,139,0.78) !important;
  	      	    background:
  	      	    linear-gradient(145deg, rgba(37,211,102,0.34), rgba(9,75,36,0.86)) !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-btn.sending {
  	      	    opacity: 0.72 !important;
  	      	    pointer-events: none !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-btn .trackit-whatsapp-icon {
  	      	    width: 16px !important;
  	      	    height: 16px !important;
  	      	    flex: 0 0 16px !important;
  	      	    color: #25d366 !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-btn span {
  	      	    overflow: hidden !important;
  	      	    text-overflow: ellipsis !important;
  	      	    white-space: nowrap !important;
  	      	    }

  	      	    /* ============================================================
  	      	    TrackIT Directions Popup Layout Patch
  	      	    Width: 300px
  	      	    Add Stop aligned to search inputs
  	      	    Clear/New Route single action
  	      	    WhatsApp number row + button row
  	      	    ============================================================ */

  	      	    .trackit-directions-popup {
  	      	    width: 300px !important;
  	      	    max-width: calc(100vw - 12px) !important;
  	      	    }

  	      	    /* Keep labelled rows compact inside 300px popup */
  	      	    .trackit-directions-search-line,
  	      	    .trackit-directions-search-line.no-remove {
  	      	    grid-template-columns: 52px minmax(0, 1fr) !important;
  	      	    gap: 8px !important;
  	      	    }

  	      	    /* Add Stop should match From/To input width, not full popup width */
  	      	    .trackit-directions-add-stop {
  	      	    width: calc(100% - 60px) !important;
  	      	    margin-left: 60px !important;
  	      	    margin-right: 0 !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    /* Only one action button now */
  	      	    .trackit-directions-actions {
  	      	    display: grid !important;
  	      	    grid-template-columns: minmax(0, 1fr) !important;
  	      	    gap: 0 !important;
  	      	    margin-top: 10px !important;
  	      	    }

  	      	    .trackit-directions-actions .trackit-directions-new {
  	      	    width: 100% !important;
  	      	    }

  	      	    .trackit-directions-actions .trackit-directions-clear {
  	      	    display: none !important;
  	      	    }

  	      	    /* WhatsApp number area:
  	      	    Row 1 = country select + phone input
  	      	    Row 2 = WhatsApp button alone, justified right
  	      	    */
  	      	    .trackit-directions-whatsapp-wrap {
  	      	    display: grid !important;
  	      	    grid-template-columns: 78px minmax(0, 1fr) !important;
  	      	    grid-auto-rows: 38px !important;
  	      	    gap: 7px !important;
  	      	    align-items: center !important;
  	      	    width: 100% !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-directions-country-select {
  	      	    grid-column: 1 !important;
  	      	    grid-row: 1 !important;
  	      	    width: 100% !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-phone {
  	      	    grid-column: 2 !important;
  	      	    grid-row: 1 !important;
  	      	    width: 100% !important;
  	      	    }

  	      	    .trackit-directions-driver-btn,
  	      	    .trackit-directions-whatsapp-btn {
  	      	    grid-column: 1 / -1 !important;
  	      	    justify-self: end !important;
  	      	    width: auto !important;
  	      	    min-width: 122px !important;
  	      	    padding-left: 14px !important;
  	      	    padding-right: 14px !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-btn {
  	      	    grid-row: 2 !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-wrap.has-driver .trackit-directions-driver-btn {
  	      	    display: flex !important;
  	      	    grid-row: 2 !important;
  	      	    justify-self: stretch !important;
  	      	    width: 100% !important;
  	      	    }

  	      	    .trackit-directions-whatsapp-wrap.has-driver .trackit-directions-whatsapp-btn {
  	      	    grid-row: 3 !important;
  	      	    }

  	      	    .trackit-directions-driver-btn {
  	      	    height: 38px !important;
  	      	    min-width: 0 !important;
  	      	    border-radius: 12px !important;
  	      	    align-items: center !important;
  	      	    justify-content: center !important;
  	      	    gap: 7px !important;
  	      	    border: 1px solid rgba(37,211,102,0.48) !important;
  	      	    background: rgba(37,211,102,0.12) !important;
  	      	    color: #eaffef !important;
  	      	    font-size: 10px !important;
  	      	    font-weight: 950 !important;
  	      	    box-sizing: border-box !important;
  	      	    cursor: pointer !important;
  	      	    white-space: nowrap !important;
  	      	    }

  	      	    .trackit-directions-driver-btn:hover:not(:disabled) {
  	      	    border-color: rgba(80,255,139,0.78) !important;
  	      	    background: rgba(37,211,102,0.22) !important;
  	      	    }

  	      	    .trackit-directions-driver-btn:disabled,
  	      	    .trackit-directions-driver-btn.missing {
  	      	    opacity: 0.48 !important;
  	      	    cursor: not-allowed !important;
  	      	    }

  	      	    .trackit-directions-driver-btn .trackit-whatsapp-icon {
  	      	    width: 16px !important;
  	      	    height: 16px !important;
  	      	    flex: 0 0 16px !important;
  	      	    color: #25d366 !important;
  	      	    }

  	      	    /* ============================================================
  	      	    TrackIT Directions Stop Delete Alignment Patch
  	      	    Keeps waypoint delete button next to the Stop input bar
  	      	    ============================================================ */

  	      	    /* Only waypoint rows need the third column for delete */
  	      	    .trackit-directions-search-line[data-route-row^="waypoint:"] {
  	      	    display: grid !important;
  	      	    grid-template-columns: 52px minmax(0, 1fr) 30px !important;
  	      	    gap: 8px !important;
  	      	    align-items: center !important;
  	      	    }

  	      	    /* Stop label */
  	      	    .trackit-directions-search-line[data-route-row^="waypoint:"] > span {
  	      	    grid-column: 1 !important;
  	      	    grid-row: 1 !important;
  	      	    align-self: center !important;
  	      	    }

  	      	    /* Stop search/select input */
  	      	    .trackit-directions-search-line[data-route-row^="waypoint:"] .trackit-directions-input-wrap {
  	      	    grid-column: 2 !important;
  	      	    grid-row: 1 !important;
  	      	    width: 100% !important;
  	      	    min-width: 0 !important;
  	      	    }

  	      	    /* Delete button sits directly beside the input */
  	      	    .trackit-directions-search-line[data-route-row^="waypoint:"] .trackit-directions-remove-stop {
  	      	    grid-column: 3 !important;
  	      	    grid-row: 1 !important;

  	      	    width: 28px !important;
  	      	    height: 28px !important;
  	      	    min-width: 28px !important;
  	      	    min-height: 28px !important;

  	      	    margin: 0 !important;
  	      	    padding: 0 !important;

  	      	    align-self: center !important;
  	      	    justify-self: center !important;

  	      	    border-radius: 999px !important;
  	      	    border: 1px solid rgba(255,255,255,0.14) !important;

  	      	    background: rgba(255,255,255,0.055) !important;
  	      	    color: rgba(255,255,255,0.86) !important;

  	      	    display: flex !important;
  	      	    align-items: center !important;
  	      	    justify-content: center !important;

  	      	    font-size: 18px !important;
  	      	    font-weight: 950 !important;
  	      	    line-height: 1 !important;

  	      	    cursor: pointer !important;
  	      	    box-sizing: border-box !important;
  	      	    }

  	      	    .trackit-directions-search-line[data-route-row^="waypoint:"] .trackit-directions-remove-stop:hover {
  	      	    color: #fff !important;
  	      	    border-color: rgba(255,138,61,0.55) !important;
  	      	    background: rgba(255,138,61,0.16) !important;
  	      	    }
  	      	    `;

  	      	    document.head.appendChild(style);

  	      	    let currentMapType = readSetting("mapType", "hybrid") || "hybrid";
  	      	    let trafficOn = readSetting("trafficOn", true);
  	      	    let collapsed = readSetting("panelCollapsedV8", true);
  	      	    let labelsOn = readSetting("labelsOn", true);

  	      	    // Default OFF. Once user switches it on, it can remember the state.
  	      	    let locationsOn = readSetting("locationsOn", false) === true;

  	      	    function normaliseSavedLocationCompanyKeys(value) {
  	      	      if (Array.isArray(value)) {
  	      	        return value.map(String).filter(Boolean);
  	      	      }

  	      	      if (value && typeof value === "object") {
  	      	        return Object.keys(value).filter(key => value[key]);
  	      	      }

  	      	      if (typeof value === "string" && value.trim()) {
  	      	        try {
  	      	          const parsed = JSON.parse(value);
  	      	          if (Array.isArray(parsed)) return parsed.map(String).filter(Boolean);
  	      	        } catch (_) {}

  	      	        return value.split(",").map(v => v.trim()).filter(Boolean);
  	      	      }

  	      	      return [];
  	      	    }

  	      	    let checkedLocationCompanyKeys = normaliseSavedLocationCompanyKeys(
  	      	      readSetting("checkedLocationCompanyKeys", [])
  	      	    );

  	      	    try {
  	      	      map.setMapTypeId(currentMapType);
  	      	    } catch (_) {}

  	      	    if (!map.__trackitTrafficLayer) {
  	      	      map.__trackitTrafficLayer = new google.maps.TrafficLayer();
  	      	    }

  	      	    map.__trackitTrafficLayer.setMap(trafficOn ? map: null);

  	      	    const control = document.createElement("div");
  	      	    control.className = "trackit-compact-map-control ces-bottom-shape";
  	      	    control.__trackitUnifiedMapControl = true;
  	      	    control.setAttribute("data-trackit-map-control", "fleet");

  	      	    if (collapsed) {
  	      	      control.classList.add("collapsed");
  	      	    }

  	      	    const shellContent = document.createElement("div");
  	      	    shellContent.className = "ces-bottom-content";
  	      	    shellContent.setAttribute("data-trackit-new-map-control", "fleet");

  	      	    const header = document.createElement("button");
  	      	    header.type = "button";
  	      	    header.className = "ces-map-control-header";
  	      	    header.setAttribute("data-map-control-toggle", "fleet");

  	      	    const headerIcon = document.createElement("div");
  	      	    headerIcon.className = "ces-map-control-header-icon";
  	      	    headerIcon.innerHTML = `
  	      	    <div class="ces-layer-icon">
  	      	    <span></span>
  	      	    <span></span>
  	      	    <span></span>
  	      	    </div>
  	      	    `;

  	      	    const headerText = document.createElement("div");
  	      	    headerText.className = "ces-map-control-header-text";

  	      	    const title = document.createElement("div");
  	      	    title.className = "ces-map-title";
  	      	    title.textContent = "Map Control";

  	      	    const subtitle = document.createElement("div");
  	      	    subtitle.className = "ces-map-subtitle";

  	      	    headerText.appendChild(title);
  	      	    headerText.appendChild(subtitle);

  	      	    const collapseIcon = document.createElement("div");
  	      	    collapseIcon.className = "ces-caret";

  	      	    header.appendChild(headerIcon);
  	      	    header.appendChild(headerText);
  	      	    header.appendChild(collapseIcon);

  	      	    const body = document.createElement("div");
  	      	    body.className = "ces-map-control-body";

  	      	    const main = document.createElement("div");
  	      	    main.className = "ces-map-control-main";

  	      	    const mapTypeSection = document.createElement("div");
  	      	    mapTypeSection.className = "ces-map-control-section";

  	      	    const typeLabelRow = sectionLabel("Map Type", iconLayers());

  	      	    const typeTabs = document.createElement("div");
  	      	    typeTabs.className = "ces-map-control-tools fleet-map-type-tools";

  	      	    const mapTypes = [{
  	      	      id: "roadmap",
  	      	      label: "Road",
  	      	      icon: iconRoadmap()
  	      	    },
  	      	      {
  	      	        id: "satellite",
  	      	        label: "Sat",
  	      	        icon: iconSatellite()
  	      	      },
  	      	      {
  	      	        id: "hybrid",
  	      	        label: "Hybrid",
  	      	        icon: iconLayers()
  	      	      },
  	      	      {
  	      	        id: "terrain",
  	      	        label: "Terrain",
  	      	        icon: iconTerrain()
  	      	      }];

  	      	    const typeButtons = {};

  	      	    mapTypes.forEach(type => {
  	      	      const btn = document.createElement("button");
  	      	      btn.type = "button";
  	      	      btn.className = "ces-map-control-tool fleet-map-type-btn";
  	      	      btn.dataset.mapType = type.id;
  	      	      btn.innerHTML = `${type.icon}<span>${type.label}</span>`;

  	      	      btn.addEventListener("click", function (event) {
  	      	        event.preventDefault();
  	      	        event.stopPropagation();

  	      	        currentMapType = type.id;

  	      	        writeSetting("mapType", type.id);
  	      	        applyMapAppearance();
  	      	        paintMapTypeButtons();
  	      	      });

  	      	      typeButtons[type.id] = btn;
  	      	      typeTabs.appendChild(btn);
  	      	    });

  	      	    mapTypeSection.appendChild(typeLabelRow);
  	      	    mapTypeSection.appendChild(typeTabs);

  	      	    const toolsSection = document.createElement("div");
  	      	    toolsSection.className = "ces-map-control-section";

  	      	    const toolsLabelRow = sectionLabel("Tools", iconLayers());

  	      	    const toolsGrid = document.createElement("div");
  	      	    toolsGrid.className = "ces-map-control-tools fleet-map-tools";

  	      	    const trafficBtn = toolButton("Traffic", iconTraffic());
  	      	    const labelsBtn = toolButton("Labels", iconLabel());
  	      	    const fullscreenBtn = toolButton("Fullscreen", iconFullscreen());
  	      	    const directionsBtn = toolButton("Directions", iconDirections());

  	      	    toolsGrid.appendChild(trafficBtn);
  	      	    toolsGrid.appendChild(labelsBtn);
  	      	    toolsGrid.appendChild(fullscreenBtn);
  	      	    toolsGrid.appendChild(directionsBtn);

  	      	    toolsSection.appendChild(toolsLabelRow);
  	      	    toolsSection.appendChild(toolsGrid);

  	      	    // ---------- App Data Locations UI ----------
  	      	    const locationsSection = document.createElement("div");
  	      	    locationsSection.className = "ces-map-control-section trackit-locations-section";

  	      	    const locationsLabelRow = sectionLabel("Locations", iconLocation());

  	      	    const locationsToggleRow = document.createElement("label");
  	      	    locationsToggleRow.className = "ces-map-control-tool trackit-location-toggle-row";

  	      	    const locationsCheckbox = document.createElement("input");
  	      	    locationsCheckbox.type = "checkbox";
  	      	    locationsCheckbox.checked = !!locationsOn;

  	      	    const locationsTick = document.createElement("span");
  	      	    locationsTick.className = "trackit-location-tick";

  	      	    const locationsText = document.createElement("span");
  	      	    locationsText.textContent = "View Locations";

  	      	    locationsToggleRow.appendChild(locationsCheckbox);
  	      	    locationsToggleRow.appendChild(locationsTick);

  	      	    const locationsIconWrap = document.createElement("span");
  	      	    locationsIconWrap.innerHTML = iconLocation();
  	      	    locationsToggleRow.appendChild(locationsIconWrap.firstElementChild);

  	      	    locationsToggleRow.appendChild(locationsText);

  	      	    const locationsList = document.createElement("div");
  	      	    locationsList.className = "trackit-location-company-list";

  	      	    locationsSection.appendChild(locationsLabelRow);
  	      	    locationsSection.appendChild(locationsToggleRow);
  	      	    locationsSection.appendChild(locationsList);

  	      	    main.appendChild(mapTypeSection);
  	      	    main.appendChild(toolsSection);
  	      	    main.appendChild(locationsSection);

  	      	    const zoomPanel = document.createElement("div");
  	      	    zoomPanel.className = "ces-map-control-zoom-rail";

  	      	    const zoomTitle = document.createElement("div");
  	      	    zoomTitle.className = "ces-map-control-zoom-label";
  	      	    zoomTitle.textContent = "Zoom";

  	      	    const zoomValue = document.createElement("div");
  	      	    zoomValue.className = "ces-map-control-zoom-value";

  	      	    const zoomPlus = document.createElement("button");
  	      	    zoomPlus.type = "button";
  	      	    zoomPlus.className = "ces-map-control-zoom-btn";
  	      	    zoomPlus.textContent = "+";

  	      	    const sliderWrap = document.createElement("div");
  	      	    sliderWrap.className = "ces-map-control-slider-wrap";

  	      	    const zoomSlider = document.createElement("input");
  	      	    zoomSlider.className = "ces-map-control-zoom-slider";
  	      	    zoomSlider.type = "range";
  	      	    zoomSlider.min = "1";
  	      	    zoomSlider.max = "22";
  	      	    zoomSlider.step = "1";

  	      	    const ticks = document.createElement("div");
  	      	    ticks.className = "ces-map-control-ticks";

  	      	    sliderWrap.appendChild(zoomSlider);
  	      	    sliderWrap.appendChild(ticks);

  	      	    const zoomMinus = document.createElement("button");
  	      	    zoomMinus.type = "button";
  	      	    zoomMinus.className = "ces-map-control-zoom-btn";
  	      	    zoomMinus.textContent = "−";

  	      	    zoomPanel.appendChild(zoomTitle);
  	      	    zoomPanel.appendChild(zoomValue);
  	      	    zoomPanel.appendChild(zoomPlus);
  	      	    zoomPanel.appendChild(sliderWrap);
  	      	    zoomPanel.appendChild(zoomMinus);

  	      	    body.appendChild(main);
  	      	    body.appendChild(zoomPanel);

  	      	    shellContent.appendChild(header);
  	      	    shellContent.appendChild(body);
  	      	    control.appendChild(shellContent);

  	      	    ["mousedown",
  	      	      "dblclick",
  	      	      "wheel",
  	      	      "touchstart",
  	      	      "pointerdown"].forEach(evtName => {
  	      	        control.addEventListener(evtName, function (event) {
  	      	          event.stopPropagation();
  	      	        }, {
  	      	          passive: false
  	      	        });
  	      	      });

  	      	    try {
  	      	      const mapDivForMount = map.getDiv();

  	      	      if (mapDivForMount) {
  	      	        mapDivForMount.style.position = mapDivForMount.style.position || "relative";

  	      	        const oldMountedControl = mapDivForMount.querySelector(".trackit-compact-map-control");

  	      	        if (oldMountedControl && oldMountedControl !== control) {
  	      	          oldMountedControl.remove();
  	      	        }

  	      	        control.style.position = "absolute";
  	      	        control.style.right = "0";
  	      	        control.style.bottom = "0";
  	      	        control.style.margin = "0";
  	      	        control.style.zIndex = "999999";
  	      	        control.style.pointerEvents = "auto";

  	      	        mapDivForMount.appendChild(control);
  	      	      } else {
  	      	        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	      	      }
  	      	    } catch (error) {
  	      	      console.warn("[TrackIT Map Controls] Could not mount absolute control. Falling back to Google controls.", error);

  	      	      try {
  	      	        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	      	      } catch (_) {}
  	      	    }

  	      	    map.__trackitUnifiedMapControlReady = true;
  	      	    map.__trackitUnifiedMapControlVersion = CONTROL_VERSION;

  	      	    function sectionLabel(text, icon) {
  	      	      const row = document.createElement("div");
  	      	      row.className = "ces-map-control-section-title";
  	      	      row.innerHTML = `
  	      	      ${icon}
  	      	      <span>${text}</span>
  	      	      `;
  	      	      return row;
  	      	    }

  	      	    function toolButton(label, icon) {
  	      	      const btn = document.createElement("button");
  	      	      btn.type = "button";
  	      	      btn.className = "ces-map-control-tool";
  	      	      btn.innerHTML = `${icon}<span>${label}</span>`;
  	      	      return btn;
  	      	    }

  	      	    function sizeFleetMapControlShell(control, isOpen) {
  	      	      if (!control) return;

  	      	      function setStyle(element, property, value) {
  	      	        try {
  	      	          element.style.setProperty(property, value, "important");
  	      	        } catch (_) {
  	      	          try {
  	      	            element.style[property] = value;
  	      	          } catch (_) {}
  	      	        }
  	      	      }

  	      	      const content = control.querySelector(".ces-bottom-content");

  	      	      const viewportHeight =
  	      	      typeof window !== "undefined" && window.innerHeight
  	      	      ? window.innerHeight: 900;

  	      	      const maxHeight = Math.max(360, viewportHeight - 24);
  	      	      const closedHeight = 56;
  	      	      const closedWidth = 200;
  	      	      const openWidth = 300;

  	      	      if (!isOpen) {
  	      	        setStyle(control, "width", `${closedWidth}px`);
  	      	        setStyle(control, "height", `${closedHeight}px`);
  	      	        setStyle(control, "min-height", `${closedHeight}px`);
  	      	        setStyle(control, "max-height", `${closedHeight}px`);
  	      	        setStyle(control, "overflow", "hidden");
  	      	        setStyle(control, "right", "0");
  	      	        setStyle(control, "bottom", "0");
  	      	        setStyle(control, "top", "auto");
  	      	        setStyle(control, "border-radius", "22px 0 0 0");

  	      	        if (content) {
  	      	          setStyle(content, "max-height", `${closedHeight}px`);
  	      	          setStyle(content, "overflow", "hidden");
  	      	          setStyle(content, "overflow-x", "hidden");
  	      	          setStyle(content, "overflow-y", "hidden");
  	      	        }

  	      	        return;
  	      	      }

  	      	      if (content) {
  	      	        setStyle(content, "max-height", "none");
  	      	        setStyle(content, "overflow", "visible");
  	      	        setStyle(content, "overflow-x", "hidden");
  	      	        setStyle(content, "overflow-y", "visible");
  	      	      }

  	      	      const contentHeight = content ? Math.ceil(content.scrollHeight): 0;
  	      	      const wantedHeight = Math.max(320, contentHeight + 2);
  	      	      const finalHeight = Math.min(wantedHeight, maxHeight);

  	      	      setStyle(control, "width", `${openWidth}px`);
  	      	      setStyle(control, "height", `${finalHeight}px`);
  	      	      setStyle(control, "min-height", `${finalHeight}px`);
  	      	      setStyle(control, "max-height", `${maxHeight}px`);
  	      	      setStyle(control, "overflow", "hidden");
  	      	      setStyle(control, "right", "0");
  	      	      setStyle(control, "bottom", "0");
  	      	      setStyle(control, "top", "auto");
  	      	      setStyle(control, "border-radius", "24px 0 0 0");

  	      	      if (content) {
  	      	        setStyle(content, "max-height", `${finalHeight}px`);
  	      	        setStyle(content, "overflow-x", "hidden");
  	      	        setStyle(content, "overflow-y", wantedHeight > maxHeight ? "auto": "visible");
  	      	      }
  	      	    }

  	      	    function applyMapAppearance() {
  	      	      // Hybrid is satellite imagery plus Google labels.
  	      	      // When Labels are OFF and user chose Hybrid, Satellite is the closest clean version.
  	      	      const effectiveType = (!labelsOn && currentMapType === "hybrid")
  	      	      ? "satellite": currentMapType;

  	      	      try {
  	      	        map.setMapTypeId(effectiveType);
  	      	      } catch (_) {}

  	      	      try {
  	      	        map.setOptions({
  	      	          styles: labelsOn ? null: NO_LABEL_STYLES
  	      	        });
  	      	      } catch (_) {}
  	      	    }

  	      	    function paintMapTypeButtons() {
  	      	      Object.keys(typeButtons).forEach(key => {
  	      	        typeButtons[key].classList.toggle("active", key === currentMapType);
  	      	      });
  	      	    }

  	      	    function updateZoomUi() {
  	      	      const z = map.getZoom() || 1;

  	      	      zoomSlider.value = String(z);
  	      	      zoomValue.textContent = String(z);

  	      	      writeSetting("zoom", z);
  	      	    }

  	      	    function updateHeaderState() {
  	      	      collapseIcon.textContent = collapsed ? "⌄": "⌃";
  	      	      subtitle.textContent = labelsOn ? "Labels On": "Labels Off";
  	      	    }

  	      	    function paintToggleButtons() {
  	      	      trafficBtn.classList.toggle("active", !!trafficOn);
  	      	      labelsBtn.classList.toggle("active", !!labelsOn);
  	      	      paintFullscreenState();
  	      	      updateHeaderState();
  	      	    }

  	      	    // ---------- App Data Geo Location Layer ----------
  	      	    function locNum(v) {
  	      	      return typeof v === "number" ? v: Number(v);
  	      	    }

  	      	    function locGetPath(o, p) {
  	      	      if (!o || !p) return undefined;

  	      	      if (Object.prototype.hasOwnProperty.call(o, p)) {
  	      	        return o[p];
  	      	      }

  	      	      return String(p).split(".").reduce((a, k) => {
  	      	        return a && a[k] !== undefined ? a[k]: undefined;
  	      	      }, o);
  	      	    }

  	      	    function locFirstString(obj, keys) {
  	      	      for (const key of keys) {
  	      	        const v = locGetPath(obj, key);

  	      	        if (typeof v === "string" && v.trim()) {
  	      	          return v.trim();
  	      	        }

  	      	        if (typeof v === "number" && Number.isFinite(v)) {
  	      	          return String(v);
  	      	        }
  	      	      }

  	      	      return "";
  	      	    }

  	      	    function saveCheckedLocationCompanies() {
  	      	      writeSetting("checkedLocationCompanyKeys", checkedLocationCompanyKeys.slice());
  	      	    }

  	      	    function isLocationCompanyChecked(key) {
  	      	      return checkedLocationCompanyKeys.includes(String(key));
  	      	    }

  	      	    function setLocationCompanyChecked(key, checked) {
  	      	      key = String(key);

  	      	      if (checked) {
  	      	        if (!checkedLocationCompanyKeys.includes(key)) {
  	      	          checkedLocationCompanyKeys.push(key);
  	      	        }
  	      	      } else {
  	      	        checkedLocationCompanyKeys = checkedLocationCompanyKeys.filter(k => k !== key);
  	      	      }

  	      	      saveCheckedLocationCompanies();
  	      	    }

  	      	    function getTrackitLocationLayer() {
  	      	      if (!map.__trackitAppLocationLayer) {
  	      	        map.__trackitAppLocationLayer = {
  	      	          companyLayers: {}
  	      	        };
  	      	      }

  	      	      if (!map.__trackitAppLocationLayer.companyLayers) {
  	      	        map.__trackitAppLocationLayer.companyLayers = {};
  	      	      }

  	      	      return map.__trackitAppLocationLayer;
  	      	    }

  	      	    function clearAppLocationLayer(companyKey) {
  	      	      const layer = getTrackitLocationLayer();

  	      	      function clearItems(items) {
  	      	        (items || []).forEach(item => {
  	      	          try {
  	      	            if (item?.setMap) item.setMap(null);
  	      	            else if (item?.remove) item.remove();
  	      	          } catch (_) {}
  	      	        });
  	      	      }

  	      	      if (companyKey) {
  	      	        const key = String(companyKey);
  	      	        const companyLayer = layer.companyLayers[key];

  	      	        if (companyLayer) {
  	      	          clearItems(companyLayer.overlays);
  	      	          clearItems(companyLayer.labels);
  	      	          delete layer.companyLayers[key];
  	      	        }

  	      	        return;
  	      	      }

  	      	      Object.keys(layer.companyLayers).forEach(key => {
  	      	        const companyLayer = layer.companyLayers[key];
  	      	        clearItems(companyLayer.overlays);
  	      	        clearItems(companyLayer.labels);
  	      	      });

  	      	      layer.companyLayers = {};
  	      	    }

  	      	    function normaliseObjectArray(value) {
  	      	      if (!value) return [];

  	      	      if (Array.isArray(value)) {
  	      	        return value.filter(v => v && typeof v === "object");
  	      	      }

  	      	      if (typeof value === "object") {
  	      	        return Object.values(value).filter(v => v && typeof v === "object");
  	      	      }

  	      	      return [];
  	      	    }

  	      	    function getCompanyDisplayName(company, index) {
  	      	      const direct = locFirstString(company, [
  	      	        "Name",
  	      	        "name",
  	      	        "CompanyName",
  	      	        "companyName",
  	      	        "Company",
  	      	        "company",
  	      	        "DisplayName",
  	      	        "displayName",
  	      	        "TradingName",
  	      	        "tradingName",
  	      	        "ClientName",
  	      	        "clientName",
  	      	        "CustomerName",
  	      	        "customerName",
  	      	        "Title",
  	      	        "title"
  	      	      ]);

  	      	      if (direct) return direct;

  	      	      const first = locFirstString(company, ["FirstName", "firstName", "first_name"]);
  	      	      const last = locFirstString(company, ["LastName", "lastName", "last_name"]);
  	      	      const full = [first,
  	      	        last].filter(Boolean).join(" ").trim();

  	      	      return full || `Company ${index + 1}`;
  	      	    }

  	      	    function getCompanyKey(company, name, index) {
  	      	      return String(
  	      	        company?.objectId ||
  	      	        company?.ObjectId ||
  	      	        company?.CompanyId ||
  	      	        company?.companyId ||
  	      	        company?.id ||
  	      	        company?.ID ||
  	      	        company?.FID ||
  	      	        name ||
  	      	        `company-${index}`
  	      	      );
  	      	    }

  	      	    function getLocationName(loc, index) {
  	      	      return locFirstString(loc, [
  	      	        "Name",
  	      	        "name",
  	      	        "LocationName",
  	      	        "locationName",
  	      	        "LocationName.Name",
  	      	        "Location.name",
  	      	        "Location",
  	      	        "location",
  	      	        "FarmName",
  	      	        "farmName",
  	      	        "FieldName",
  	      	        "fieldName",
  	      	        "SiteName",
  	      	        "siteName",
  	      	        "Description",
  	      	        "description",
  	      	        "Title",
  	      	        "title",
  	      	        "label",
  	      	        "Label"
  	      	      ]) || `Location ${index + 1}`;
  	      	    }

  	      	    function readBackendlessArg(name, lowerName, index) {
  	      	      try {
  	      	        if (typeof ___arguments !== "undefined" && ___arguments) {
  	      	          if (___arguments[name] !== undefined) return ___arguments[name];
  	      	          if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	      	          if (___arguments[index] !== undefined) return ___arguments[index];
  	      	        }
  	      	      } catch (_) {}

  	      	      return undefined;
  	      	    }

  	      	    function parseMaybeJson(value) {
  	      	      if (typeof value !== "string") return value;

  	      	      const text = value.trim();
  	      	      if (!text) return value;

  	      	      if (
  	      	        (text.startsWith("[") && text.endsWith("]")) ||
  	      	        (text.startsWith("{") && text.endsWith("}"))
  	      	      ) {
  	      	        try {
  	      	          return JSON.parse(text);
  	      	        } catch (_) {
  	      	          return value;
  	      	        }
  	      	      }

  	      	      return value;
  	      	    }

  	      	    function validLatLng(lat, lng) {
  	      	      return (
  	      	        Number.isFinite(lat) &&
  	      	        Number.isFinite(lng) &&
  	      	        Math.abs(lat) <= 90 &&
  	      	        Math.abs(lng) <= 180
  	      	      );
  	      	    }

  	      	    function pointFromPair(pair, geoJsonOrder) {
  	      	      if (!Array.isArray(pair) || pair.length < 2) return null;

  	      	      const a = locNum(pair[0]);
  	      	      const b = locNum(pair[1]);

  	      	      if (!Number.isFinite(a) || !Number.isFinite(b)) return null;

  	      	      let lat;
  	      	      let lng;

  	      	      if (geoJsonOrder) {
  	      	        lat = b;
  	      	        lng = a;
  	      	      } else if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
  	      	        lat = a;
  	      	        lng = b;
  	      	      } else if (Math.abs(b) <= 90 && Math.abs(a) <= 180) {
  	      	        lat = b;
  	      	        lng = a;
  	      	      } else {
  	      	        return null;
  	      	      }

  	      	      return validLatLng(lat, lng) ? {
  	      	        lat,
  	      	        lng
  	      	      }: null;
  	      	    }

  	      	    function pointFromString(value, geoJsonOrder) {
  	      	      if (typeof value !== "string") return null;

  	      	      const text = value.trim();
  	      	      if (!text) return null;

  	      	      const parsed = parseMaybeJson(text);
  	      	      if (parsed !== value) {
  	      	        return coercePoint(parsed, geoJsonOrder);
  	      	      }

  	      	      const match = text.match(/(-?\d+(?:\.\d+)?)\s*[,; ]\s*(-?\d+(?:\.\d+)?)/);
  	      	      if (!match) return null;

  	      	      return pointFromPair([match[1], match[2]], geoJsonOrder);
  	      	    }

  	      	    function coercePoint(value, geoJsonOrder) {
  	      	      value = parseMaybeJson(value);

  	      	      if (!value) return null;

  	      	      if (Array.isArray(value)) {
  	      	        return pointFromPair(value, geoJsonOrder);
  	      	      }

  	      	      if (typeof value === "string") {
  	      	        return pointFromString(value, geoJsonOrder);
  	      	      }

  	      	      if (typeof value !== "object") return null;

  	      	      const pairs = [
  	      	        ["lat",
  	      	          "lng"],
  	      	        ["lat",
  	      	          "lon"],
  	      	        ["lat",
  	      	          "long"],
  	      	        ["latitude",
  	      	          "longitude"],
  	      	        ["Latitude",
  	      	          "Longitude"],
  	      	        ["LAT",
  	      	          "LNG"],

  	      	        ["_lat",
  	      	          "_lng"],
  	      	        ["_latitude",
  	      	          "_longitude"],

  	      	        ["x",
  	      	          "y"],
  	      	        ["X",
  	      	          "Y"],

  	      	        ["position.latitude",
  	      	          "position.longitude"],
  	      	        ["Position.Latitude",
  	      	          "Position.Longitude"],

  	      	        ["Location.position.latitude",
  	      	          "Location.position.longitude"],
  	      	        ["location.position.latitude",
  	      	          "location.position.longitude"],

  	      	        ["geoPoint.latitude",
  	      	          "geoPoint.longitude"],
  	      	        ["GeoPoint.latitude",
  	      	          "GeoPoint.longitude"],

  	      	        ["Coordinates.latitude",
  	      	          "Coordinates.longitude"],
  	      	        ["coordinates.latitude",
  	      	          "coordinates.longitude"],

  	      	        ["Center.lat",
  	      	          "Center.lng"],
  	      	        ["center.lat",
  	      	          "center.lng"],
  	      	        ["Centre.lat",
  	      	          "Centre.lng"],
  	      	        ["centre.lat",
  	      	          "centre.lng"],

  	      	        ["LocationData.Center.lat",
  	      	          "LocationData.Center.lng"],
  	      	        ["LocationData.center.lat",
  	      	          "LocationData.center.lng"],
  	      	        ["LocationData.Centre.lat",
  	      	          "LocationData.Centre.lng"],
  	      	        ["LocationData.centre.lat",
  	      	          "LocationData.centre.lng"],

  	      	        ["LocationData.Shape.Center.lat",
  	      	          "LocationData.Shape.Center.lng"],
  	      	        ["LocationData.Shape.center.lat",
  	      	          "LocationData.Shape.center.lng"],
  	      	        ["LocationData.Shape.Centre.lat",
  	      	          "LocationData.Shape.Centre.lng"],
  	      	        ["LocationData.Shape.centre.lat",
  	      	          "LocationData.Shape.centre.lng"],

  	      	        ["LocationData.Shape.PivotCenter.lat",
  	      	          "LocationData.Shape.PivotCenter.lng"],
  	      	        ["LocationData.Shape.pivotCenter.lat",
  	      	          "LocationData.Shape.pivotCenter.lng"],

  	      	        ["LocationData.Shape.WedgeCenter.lat",
  	      	          "LocationData.Shape.WedgeCenter.lng"],
  	      	        ["LocationData.Shape.wedgeCenter.lat",
  	      	          "LocationData.Shape.wedgeCenter.lng"],

  	      	        ["LocationData.Shape.EntrancePoint.lat",
  	      	          "LocationData.Shape.EntrancePoint.lng"],
  	      	        ["LocationData.Shape.entrancePoint.lat",
  	      	          "LocationData.Shape.entrancePoint.lng"],

  	      	        ["EntrancePoint.lat",
  	      	          "EntrancePoint.lng"],
  	      	        ["entrancePoint.lat",
  	      	          "entrancePoint.lng"]
  	      	      ];

  	      	      for (const pair of pairs) {
  	      	        let lat = locNum(locGetPath(value, pair[0]));
  	      	        let lng = locNum(locGetPath(value, pair[1]));

  	      	        // x/y is often lng/lat, so reverse it when needed.
  	      	        if ((pair[0] === "x" || pair[0] === "X") && validLatLng(lng, lat)) {
  	      	          return {
  	      	            lat: lng,
  	      	            lng: lat
  	      	          };
  	      	        }

  	      	        if (validLatLng(lat, lng)) {
  	      	          return {
  	      	            lat,
  	      	            lng
  	      	          };
  	      	        }
  	      	      }

  	      	      return null;
  	      	    }

  	      	    function readPointFromObject(obj) {
  	      	      return coercePoint(obj, false);
  	      	    }

  	      	    function collectPointsFromArray(value, output, geoJsonOrder, depth = 0) {
  	      	      if (depth > 8) return;

  	      	      value = parseMaybeJson(value);

  	      	      if (!value) return;

  	      	      const directPoint = coercePoint(value, geoJsonOrder);
  	      	      if (directPoint) {
  	      	        output.push(directPoint);
  	      	        return;
  	      	      }

  	      	      if (typeof value === "string") {
  	      	        const text = value.trim();

  	      	        // Handles simple strings like:
  	      	        // "-29.1,30.1;-29.2,30.2;-29.3,30.3"
  	      	        const pairs = text.match(/-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?/g);

  	      	        if (pairs && pairs.length >= 3) {
  	      	          pairs.forEach(pairText => {
  	      	            const p = pointFromString(pairText, geoJsonOrder);
  	      	            if (p) output.push(p);
  	      	          });
  	      	        }

  	      	        return;
  	      	      }

  	      	      if (Array.isArray(value)) {
  	      	        value.forEach(item => {
  	      	          collectPointsFromArray(item, output, geoJsonOrder, depth + 1);
  	      	        });

  	      	        return;
  	      	      }

  	      	      if (typeof value === "object") {
  	      	        const likelyArrays = [
  	      	          value.points,
  	      	          value.Points,
  	      	          value.path,
  	      	          value.Path,
  	      	          value.paths,
  	      	          value.Paths,
  	      	          value.coordinates,
  	      	          value.Coordinates,
  	      	          value.polygon,
  	      	          value.Polygon,
  	      	          value.boundary,
  	      	          value.Boundary,
  	      	          value.rings,
  	      	          value.Rings,
  	      	          value.plotPoints,
  	      	          value.plotRawPoints,
  	      	          value.plotResolvedPoints,
  	      	          value.PlotPoints,
  	      	          value.PlotRawPoints,
  	      	          value.PlotResolvedPoints
  	      	        ];

  	      	        likelyArrays.forEach(item => {
  	      	          collectPointsFromArray(item, output, geoJsonOrder, depth + 1);
  	      	        });
  	      	      }
  	      	    }

  	      	    function cleanLocationPath(points) {
  	      	      const cleaned = [];
  	      	      const seen = new Set();

  	      	      (points || []).forEach(p => {
  	      	        if (!p || !validLatLng(p.lat, p.lng)) return;

  	      	        const key = `${Number(p.lat).toFixed(7)},${Number(p.lng).toFixed(7)}`;

  	      	        if (seen.has(key)) return;
  	      	        seen.add(key);

  	      	        cleaned.push({
  	      	          lat: Number(p.lat),
  	      	          lng: Number(p.lng)
  	      	        });
  	      	      });

  	      	      return cleaned;
  	      	    }

  	      	    function readPathFromLocation(loc) {
  	      	      if (!loc || typeof loc !== "object") return [];

  	      	      const candidates = [{
  	      	        key: "path",
  	      	        geoJson: false
  	      	      },
  	      	        {
  	      	          key: "Path",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "paths",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Paths",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "points",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Points",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "boundary",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Boundary",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "polygon",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Polygon",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "rings",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Rings",
  	      	          geoJson: false
  	      	        },

  	      	        {
  	      	          key: "Shape.path",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Shape.Path",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Shape.points",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Shape.Points",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Shape.polygon",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Shape.Polygon",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Shape.boundary",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Shape.Boundary",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Shape.rings",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "Shape.Rings",
  	      	          geoJson: false
  	      	        },

  	      	        {
  	      	          key: "shape.path",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "shape.points",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "shape.polygon",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "shape.boundary",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "shape.rings",
  	      	          geoJson: false
  	      	        },

  	      	        {
  	      	          key: "LocationData.Points",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.points",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Path",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.path",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Polygon",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.polygon",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Boundary",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.boundary",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Rings",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.rings",
  	      	          geoJson: false
  	      	        },

  	      	        {
  	      	          key: "LocationData.Shape.Points",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.points",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.Path",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.path",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.Polygon",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.polygon",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.Boundary",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.boundary",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.Rings",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.rings",
  	      	          geoJson: false
  	      	        },

  	      	        {
  	      	          key: "LocationData.Shape.plotPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.plotRawPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.plotResolvedPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.PlotPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.PlotRawPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.PlotResolvedPoints",
  	      	          geoJson: false
  	      	        },

  	      	        {
  	      	          key: "PlotPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "plotPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "PlotRawPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "plotRawPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "PlotResolvedPoints",
  	      	          geoJson: false
  	      	        },
  	      	        {
  	      	          key: "plotResolvedPoints",
  	      	          geoJson: false
  	      	        },

  	      	        {
  	      	          key: "coordinates",
  	      	          geoJson: true
  	      	        },
  	      	        {
  	      	          key: "Coordinates",
  	      	          geoJson: true
  	      	        },
  	      	        {
  	      	          key: "geometry.coordinates",
  	      	          geoJson: true
  	      	        },
  	      	        {
  	      	          key: "Geometry.Coordinates",
  	      	          geoJson: true
  	      	        },
  	      	        {
  	      	          key: "LocationData.geometry.coordinates",
  	      	          geoJson: true
  	      	        },
  	      	        {
  	      	          key: "LocationData.Geometry.Coordinates",
  	      	          geoJson: true
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.coordinates",
  	      	          geoJson: true
  	      	        },
  	      	        {
  	      	          key: "LocationData.Shape.Coordinates",
  	      	          geoJson: true
  	      	        }];

  	      	      for (const candidate of candidates) {
  	      	        const raw = locGetPath(loc, candidate.key);
  	      	        const points = [];

  	      	        collectPointsFromArray(raw, points, candidate.geoJson);

  	      	        const cleaned = cleanLocationPath(points);

  	      	        if (cleaned.length >= 3) {
  	      	          return cleaned;
  	      	        }
  	      	      }

  	      	      return [];
  	      	    }

  	      	    function locationHasGeo(loc) {
  	      	      return !!readPointFromObject(loc) || readPathFromLocation(loc).length >= 3;
  	      	    }

  	      	    function getLocationValueFromTrackit(location) {
  	      	      return (
  	      	        location?.objectId ||
  	      	        location?.ObjectId ||
  	      	        location?.id ||
  	      	        location?.ID ||
  	      	        location?.LocationId ||
  	      	        location?.locationId ||
  	      	        null
  	      	      );
  	      	    }

  	      	    function getLocationChildrenFromTrackit(location) {
  	      	      const arrays = [
  	      	        location?.Children,
  	      	        location?.children,
  	      	        location?.ChildLocations,
  	      	        location?.childLocations,
  	      	        location?.Locations,
  	      	        location?.locations,
  	      	        location?.Fields,
  	      	        location?.fields,
  	      	        location?.Segments,
  	      	        location?.segments,
  	      	        location?.Rings,
  	      	        location?.rings
  	      	      ];

  	      	      const result = [];
  	      	      const seen = new Set();

  	      	      arrays.forEach(list => {
  	      	        if (!Array.isArray(list)) return;

  	      	        list.forEach(child => {
  	      	          if (!child || typeof child !== "object") return;

  	      	          const key = getLocationValueFromTrackit(child) || child;

  	      	          if (seen.has(key)) return;

  	      	          seen.add(key);
  	      	          result.push(child);
  	      	        });
  	      	      });

  	      	      return result;
  	      	    }

  	      	    function flattenLocationsFromTrackit(locations, output = [], seen = new Set()) {
  	      	      if (!Array.isArray(locations)) return output;

  	      	      locations.forEach(location => {
  	      	        if (!location || typeof location !== "object") return;

  	      	        const key =
  	      	        getLocationValueFromTrackit(location) ||
  	      	        getLocationName(location, output.length);

  	      	        if (key && seen.has(key)) return;
  	      	        if (key) seen.add(key);

  	      	        output.push(location);

  	      	        flattenLocationsFromTrackit(
  	      	          getLocationChildrenFromTrackit(location),
  	      	          output,
  	      	          seen
  	      	        );
  	      	      });

  	      	      return output;
  	      	    }

  	      	    function getCompaniesFromTrackitAppData(appData) {
  	      	      const listInput =
  	      	      typeof List !== "undefined"
  	      	      ? List: readBackendlessArg("List",
  	      	        "list",
  	      	        1);

  	      	      if (Array.isArray(listInput) && listInput.length) {
  	      	        return listInput;
  	      	      }

  	      	      const userCompanies =
  	      	      appData?.User?.Companies ||
  	      	      appData?.User?.companies ||
  	      	      appData?.Companies ||
  	      	      appData?.companies ||
  	      	      [];

  	      	      return Array.isArray(userCompanies) ? userCompanies: [];
  	      	    }

  	      	    function getCompanyLocationsFromTrackit(company) {
  	      	      const locations =
  	      	      company?.Locations ||
  	      	      company?.locations ||
  	      	      company?.Location ||
  	      	      company?.location ||
  	      	      company?.PropertyLocations ||
  	      	      company?.propertyLocations ||
  	      	      company?.GeoLocations ||
  	      	      company?.geoLocations ||
  	      	      [];

  	      	      return Array.isArray(locations) ? locations: [];
  	      	    }

  	      	    function getAppLocationCompanies() {
  	      	      const appData = getAppBag();
  	      	      const companies = getCompaniesFromTrackitAppData(appData);

  	      	      const results = [];
  	      	      const seenCompanies = new Set();

  	      	      companies.forEach((company, index) => {
  	      	        if (!company || typeof company !== "object") return;

  	      	        const name = getCompanyDisplayName(company, index);
  	      	        const key = getCompanyKey(company, name, index);

  	      	        if (seenCompanies.has(key)) return;
  	      	        seenCompanies.add(key);

  	      	        const rawLocations = getCompanyLocationsFromTrackit(company);
  	      	        const flattenedLocations = flattenLocationsFromTrackit(rawLocations);

  	      	        const drawableLocations = flattenedLocations.filter(location => {
  	      	          try {
  	      	            return locationHasGeo(location);
  	      	          } catch (_) {
  	      	            return false;
  	      	          }
  	      	        });

  	      	        results.push({
  	      	          key,
  	      	          name,
  	      	          company,
  	      	          locations: drawableLocations,
  	      	          rawLocationCount: flattenedLocations.length
  	      	        });
  	      	      });

  	      	      results.sort((a, b) => {
  	      	        return String(a.name).localeCompare(String(b.name), undefined, {
  	      	          numeric: true,
  	      	          sensitivity: "base"
  	      	        });
  	      	      });

  	      	      console.log("[TrackIT Locations] Companies loaded:",
  	      	        results.map(c => ({
  	      	          name: c.name,
  	      	          key: c.key,
  	      	          drawableLocations: c.locations.length,
  	      	          rawLocations: c.rawLocationCount
  	      	        })));

  	      	      return results;
  	      	    }

  	      	    function getLocationCenter(loc) {
  	      	      const path = readPathFromLocation(loc);

  	      	      if (path.length >= 3) {
  	      	        try {
  	      	          const b = new google.maps.LatLngBounds();
  	      	          path.forEach(p => b.extend(p));
  	      	          const center = b.getCenter();

  	      	          return {
  	      	            lat: center.lat(),
  	      	            lng: center.lng()
  	      	          };
  	      	        } catch (_) {
  	      	          const total = path.reduce((acc, p) => {
  	      	            acc.lat += p.lat;
  	      	            acc.lng += p.lng;
  	      	            return acc;
  	      	          }, {
  	      	            lat: 0, lng: 0
  	      	          });

  	      	          return {
  	      	            lat: total.lat / path.length,
  	      	            lng: total.lng / path.length
  	      	          };
  	      	        }
  	      	      }

  	      	      return readPointFromObject(loc);
  	      	    }

  	      	    function createBlackLocationLabel(position, text) {
  	      	      const overlay = new google.maps.OverlayView();
  	      	      let div = null;

  	      	      overlay.onAdd = function () {
  	      	        div = document.createElement("div");
  	      	        div.className = "trackit-location-label-black";
  	      	        div.textContent = text || "Location";

  	      	        const panes = overlay.getPanes();

  	      	        if (panes?.floatPane) {
  	      	          panes.floatPane.appendChild(div);
  	      	        }
  	      	      };

  	      	      overlay.draw = function () {
  	      	        if (!div) return;

  	      	        const projection = overlay.getProjection();
  	      	        if (!projection) return;

  	      	        const point = projection.fromLatLngToDivPixel(
  	      	          new google.maps.LatLng(position.lat, position.lng)
  	      	        );

  	      	        if (!point) return;

  	      	        div.style.left = `${point.x}px`;
  	      	        div.style.top = `${point.y - 8}px`;
  	      	      };

  	      	      overlay.onRemove = function () {
  	      	        if (div) {
  	      	          div.remove();
  	      	          div = null;
  	      	        }
  	      	      };

  	      	      overlay.setMap(map);

  	      	      return overlay;
  	      	    }

  	      	    function createSmallLocationMarker(position, color) {
  	      	      const markerColor = normaliseLocationColor(color, "#ff8a3c");

  	      	      const svg = `
  	      	      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  	      	      <circle cx="9" cy="9" r="6" fill="rgba(0,0,0,0.88)" stroke="rgba(255,255,255,0.72)" stroke-width="2"/>
  	      	      <circle cx="9" cy="9" r="2.8" fill="${markerColor}"/>
  	      	      </svg>
  	      	      `;

  	      	      return new google.maps.Marker({
  	      	        position,
  	      	        map,
  	      	        clickable: false,
  	      	        zIndex: 20,
  	      	        icon: {
  	      	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
  	      	          scaledSize: new google.maps.Size(18, 18),
  	      	          anchor: new google.maps.Point(9, 9)
  	      	        }
  	      	      });
  	      	    }

  	      	    function normaliseLocationColor(value, fallback) {
  	      	      if (value === undefined || value === null) return fallback;

  	      	      if (typeof value === "object") {
  	      	        const nested =
  	      	        value.hex ||
  	      	        value.Hex ||
  	      	        value.color ||
  	      	        value.Color ||
  	      	        value.colour ||
  	      	        value.Colour ||
  	      	        value.value ||
  	      	        value.Value ||
  	      	        value.background ||
  	      	        value.Background ||
  	      	        value.stroke ||
  	      	        value.Stroke ||
  	      	        value.fill ||
  	      	        value.Fill;

  	      	        return normaliseLocationColor(nested, fallback);
  	      	      }

  	      	      const text = String(value).trim();

  	      	      if (!text) return fallback;

  	      	      // Hex, rgb, rgba, hsl, hsla, or named CSS colour.
  	      	      if (
  	      	        /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(text) ||
  	      	        /^rgba?\(/i.test(text) ||
  	      	        /^hsla?\(/i.test(text) ||
  	      	        /^[a-z]+$/i.test(text)
  	      	      ) {
  	      	        return text;
  	      	      }

  	      	      return fallback;
  	      	    }

  	      	    function getLocationColor(loc, company) {
  	      	      const fallback = "#ff8a3c";

  	      	      const locationColorPaths = [
  	      	        "Color",
  	      	        "color",
  	      	        "Colour",
  	      	        "colour",
  	      	        "LocationColor",
  	      	        "locationColor",
  	      	        "LocationColour",
  	      	        "locationColour",
  	      	        "PolygonColor",
  	      	        "polygonColor",
  	      	        "FillColor",
  	      	        "fillColor",
  	      	        "StrokeColor",
  	      	        "strokeColor",
  	      	        "HexColor",
  	      	        "hexColor",
  	      	        "HexColour",
  	      	        "hexColour",

  	      	        "Style.Color",
  	      	        "Style.color",
  	      	        "Style.Colour",
  	      	        "Style.colour",
  	      	        "Style.FillColor",
  	      	        "Style.fillColor",
  	      	        "Style.StrokeColor",
  	      	        "Style.strokeColor",

  	      	        "LocationData.Color",
  	      	        "LocationData.color",
  	      	        "LocationData.Colour",
  	      	        "LocationData.colour",
  	      	        "LocationData.LocationColor",
  	      	        "LocationData.locationColor",
  	      	        "LocationData.FillColor",
  	      	        "LocationData.fillColor",
  	      	        "LocationData.StrokeColor",
  	      	        "LocationData.strokeColor",

  	      	        "LocationData.Style.Color",
  	      	        "LocationData.Style.color",
  	      	        "LocationData.Style.FillColor",
  	      	        "LocationData.Style.fillColor",
  	      	        "LocationData.Style.StrokeColor",
  	      	        "LocationData.Style.strokeColor",

  	      	        "LocationData.Shape.Color",
  	      	        "LocationData.Shape.color",
  	      	        "LocationData.Shape.Colour",
  	      	        "LocationData.Shape.colour",
  	      	        "LocationData.Shape.FillColor",
  	      	        "LocationData.Shape.fillColor",
  	      	        "LocationData.Shape.StrokeColor",
  	      	        "LocationData.Shape.strokeColor",

  	      	        "Shape.Color",
  	      	        "Shape.color",
  	      	        "Shape.Colour",
  	      	        "Shape.colour",
  	      	        "Shape.FillColor",
  	      	        "Shape.fillColor",
  	      	        "Shape.StrokeColor",
  	      	        "Shape.strokeColor"
  	      	      ];

  	      	      for (const path of locationColorPaths) {
  	      	        const color = normaliseLocationColor(locGetPath(loc, path), null);
  	      	        if (color) return color;
  	      	      }

  	      	      const companyColorPaths = [
  	      	        "Color",
  	      	        "color",
  	      	        "Colour",
  	      	        "colour",
  	      	        "CompanyColor",
  	      	        "companyColor",
  	      	        "CompanyColour",
  	      	        "companyColour",
  	      	        "Style.Color",
  	      	        "Style.color"
  	      	      ];

  	      	      for (const path of companyColorPaths) {
  	      	        const color = normaliseLocationColor(locGetPath(company, path), null);
  	      	        if (color) return color;
  	      	      }

  	      	      return fallback;
  	      	    }

  	      	    function getSouthWestPoint(points) {
  	      	      if (!Array.isArray(points) || !points.length) return null;

  	      	      let chosen = null;

  	      	      points.forEach(p => {
  	      	        if (!p || !validLatLng(Number(p.lat), Number(p.lng))) return;

  	      	        const point = {
  	      	          lat: Number(p.lat),
  	      	          lng: Number(p.lng)
  	      	        };

  	      	        if (!chosen) {
  	      	          chosen = point;
  	      	          return;
  	      	        }

  	      	        // South = smaller latitude.
  	      	        // West = smaller longitude.
  	      	        // We choose the point that is most south first, then most west.
  	      	        if (
  	      	          point.lat < chosen.lat ||
  	      	          (point.lat === chosen.lat && point.lng < chosen.lng)
  	      	        ) {
  	      	          chosen = point;
  	      	        }
  	      	      });

  	      	      return chosen;
  	      	    }

  	      	    function drawCompanyLocations(company,
  	      	      fitToLocations) {
  	      	      if (!company) return;

  	      	      const companyKey = String(company.key);

  	      	      clearAppLocationLayer(companyKey);

  	      	      const layer = getTrackitLocationLayer();

  	      	      layer.companyLayers[companyKey] = {
  	      	        overlays: [],
  	      	        labels: []
  	      	      };

  	      	      const companyLayer = layer.companyLayers[companyKey];

  	      	      const bounds = new google.maps.LatLngBounds();
  	      	      let drawn = 0;

  	      	      (company.locations || []).forEach((loc, index) => {
  	      	        const label = getLocationName(loc, index);
  	      	        const path = readPathFromLocation(loc);
  	      	        const center = getLocationCenter(loc);
  	      	        const locationColor = getLocationColor(loc, company);

  	      	        if (!center) {
  	      	          console.warn("[TrackIT Locations] Location skipped, no center:", loc);
  	      	          return;
  	      	        }

  	      	        if (path.length >= 3) {
  	      	          const polygon = new google.maps.Polygon({
  	      	            paths: path,
  	      	            map,
  	      	            clickable: false,
  	      	            zIndex: 10,

  	      	            strokeColor: locationColor,
  	      	            strokeOpacity: 0.95,
  	      	            strokeWeight: 2,
  	      	            fillColor: locationColor,
  	      	            fillOpacity: 0.16
  	      	          });

  	      	          companyLayer.overlays.push(polygon);

  	      	          path.forEach(p => bounds.extend(p));

  	      	          console.log("[TrackIT Locations] Polygon drawn:", {
  	      	            company: company.name,
  	      	            label,
  	      	            points: path.length
  	      	          });

  	      	        } else {
  	      	          const marker = createSmallLocationMarker(center, locationColor);

  	      	          companyLayer.overlays.push(marker);
  	      	          bounds.extend(center);

  	      	          console.log("[TrackIT Locations] Point drawn:", {
  	      	            company: company.name,
  	      	            label,
  	      	            center
  	      	          });
  	      	        }

  	      	        const labelPosition = path.length >= 3
  	      	        ? (getSouthWestPoint(path) || center): center;

  	      	        const labelOverlay = createBlackLocationLabel(labelPosition, label);

  	      	        companyLayer.labels.push(labelOverlay);

  	      	        drawn++;
  	      	      });

  	      	      if (fitToLocations && drawn > 0) {
  	      	        try {
  	      	          if (drawn === 1) {
  	      	            map.panTo(bounds.getCenter());

  	      	            if ((map.getZoom() || 1) < 15) {
  	      	              map.setZoom(15);
  	      	            }
  	      	          } else {
  	      	            map.fitBounds(bounds, {
  	      	              top: 80,
  	      	              right: 80,
  	      	              bottom: 80,
  	      	              left: 80
  	      	            });
  	      	          }
  	      	        } catch (_) {}
  	      	      }

  	      	      if (drawn === 0) {
  	      	        console.warn("[TrackIT Locations] Company checked but no drawable geo found:", company);
  	      	      }
  	      	    }

  	      	    function renderCheckedLocationCompanies(fitToLocations) {
  	      	      const companies = map.__trackitLocationCompanies || [];

  	      	      checkedLocationCompanyKeys.forEach(key => {
  	      	        const company = companies.find(c => String(c.key) === String(key));

  	      	        if (company) {
  	      	          drawCompanyLocations(company, fitToLocations);
  	      	        }
  	      	      });
  	      	    }

  	      	    function renderLocationCompanyList() {
  	      	      const companies = getAppLocationCompanies();

  	      	      map.__trackitLocationCompanies = companies;

  	      	      locationsList.innerHTML = "";

  	      	      if (!companies.length) {
  	      	        const empty = document.createElement("div");
  	      	        empty.className = "trackit-location-empty";
  	      	        empty.textContent = "No companies found";
  	      	        locationsList.appendChild(empty);
  	      	        return;
  	      	      }

  	      	      companies.forEach(company => {
  	      	        const checked = isLocationCompanyChecked(company.key);

  	      	        const row = document.createElement("label");
  	      	        row.className = "trackit-location-company-row";
  	      	        row.classList.toggle("active", checked);

  	      	        const checkbox = document.createElement("input");
  	      	        checkbox.type = "checkbox";
  	      	        checkbox.checked = checked;

  	      	        const tick = document.createElement("span");
  	      	        tick.className = "trackit-location-tick";

  	      	        const name = document.createElement("span");
  	      	        name.className = "trackit-location-company-name";
  	      	        name.textContent = company.name;

  	      	        const count = document.createElement("span");
  	      	        count.className = "trackit-location-company-count";
  	      	        count.textContent = String(company.locations.length);

  	      	        row.appendChild(checkbox);
  	      	        row.appendChild(tick);
  	      	        row.appendChild(name);
  	      	        row.appendChild(count);

  	      	        checkbox.addEventListener("change", function (event) {
  	      	          event.stopPropagation();

  	      	          const nowChecked = !!checkbox.checked;

  	      	          setLocationCompanyChecked(company.key, nowChecked);

  	      	          row.classList.toggle("active", nowChecked);

  	      	          if (nowChecked) {
  	      	            drawCompanyLocations(company, true);
  	      	          } else {
  	      	            clearAppLocationLayer(company.key);
  	      	          }

  	      	          sizeFleetMapControlShell(control, !collapsed);
  	      	        });

  	      	        row.addEventListener("click",
  	      	          function (event) {
  	      	            event.stopPropagation();
  	      	          });

  	      	        locationsList.appendChild(row);
  	      	      });
  	      	    }

  	      	    function paintLocationsUi() {
  	      	      locationsCheckbox.checked = !!locationsOn;
  	      	      locationsList.classList.toggle("visible", !!locationsOn);
  	      	    }

  	      	    function syncLocationLayerFromSettings(fitToLocations) {
  	              const companies =
  	                getAppLocationCompanies();

  	              map.__trackitLocationCompanies =
  	                companies;

  	              /*
  	               * MOBILE LOCATION RULE:
  	               * There is no per-company selection.
  	               * ON  = every available company Location.
  	               * OFF = no Location overlays.
  	               */
  	              checkedLocationCompanyKeys =
  	                locationsOn
  	                  ? companies.map(
  	                      company =>
  	                        String(company.key)
  	                    )
  	                  : [];

  	              saveCheckedLocationCompanies();
  	      	      paintLocationsUi();

  	      	      if (!locationsOn) {
  	      	        clearAppLocationLayer();
  	      	        return;
  	      	      }

  	      	      renderLocationCompanyList();
  	      	      renderCheckedLocationCompanies(
  	                fitToLocations
  	              );
  	      	    }

  	            function setAllLocationCompaniesEnabled(
  	              enabled,
  	              fitToLocations
  	            ) {
  	              locationsOn = !!enabled;

  	              const companies =
  	                getAppLocationCompanies();

  	              map.__trackitLocationCompanies =
  	                companies;

  	              checkedLocationCompanyKeys =
  	                locationsOn
  	                  ? companies.map(
  	                      company =>
  	                        String(company.key)
  	                    )
  	                  : [];

  	              writeSetting(
  	                "locationsOn",
  	                locationsOn
  	              );
  	              saveCheckedLocationCompanies();

  	              if (!locationsOn) {
  	                clearAppLocationLayer();
  	              } else {
  	                renderLocationCompanyList();
  	                renderCheckedLocationCompanies(
  	                  !!fitToLocations
  	                );
  	              }

  	              paintLocationsUi();

  	              try {
  	                map.__fifPaintMobileLocations?.();
  	              } catch (_) {}

  	              return locationsOn;
  	            }

  	            map.__trackitLocationsAllOn =
  	              function () {
  	                return !!locationsOn;
  	              };

  	            map.__trackitSetAllLocations =
  	              setAllLocationCompaniesEnabled;

  	      	    function isFullscreenActive() {
  	      	      const mapDiv = map.getDiv();
  	      	      const fs = document.fullscreenElement || document.webkitFullscreenElement || null;

  	      	      return !!fs && (fs === mapDiv || fs.contains(mapDiv));
  	      	    }

  	      	    function paintFullscreenState() {
  	      	      fullscreenBtn.classList.toggle("active", isFullscreenActive());
  	      	      fullscreenBtn.classList.toggle("fullscreen-active", isFullscreenActive());
  	      	    }

  	      	    function toggleFullscreen() {
  	      	      const mapDiv = map.getDiv();

  	      	      try {
  	      	        if (!document.fullscreenElement && !document.webkitFullscreenElement) {
  	      	          if (mapDiv.requestFullscreen) mapDiv.requestFullscreen();
  	      	          else if (mapDiv.webkitRequestFullscreen) mapDiv.webkitRequestFullscreen();
  	      	        } else {
  	      	          if (document.exitFullscreen) document.exitFullscreen();
  	      	          else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
  	      	        }
  	      	      } catch (e) {
  	      	        console.warn("[TrackIT Map Controls] Fullscreen failed:", e);
  	      	      }

  	      	      setTimeout(paintFullscreenState, 150);
  	      	    }

  	      	    function applyMapControlCollapsedState(saveSetting) {
  	      	      control.classList.toggle("collapsed", collapsed);
  	      	      updateHeaderState();
  	      	      sizeFleetMapControlShell(control, !collapsed);

  	      	      if (saveSetting) {
  	      	        writeSetting("panelCollapsedV8", collapsed);
  	      	      }
  	      	    }

  	      	    function toggleMapControlPanel(saveSetting = true) {
  	      	      collapsed = !collapsed;
  	      	      applyMapControlCollapsedState(saveSetting);
  	      	    }

  	      	    function closeMapControlPanel(saveSetting = false) {
  	      	      if (collapsed) return;

  	      	      collapsed = true;
  	      	      applyMapControlCollapsedState(saveSetting);
  	      	    }

  	      	    function openMapControlPanel(saveSetting = false) {
  	      	      if (!collapsed) return;

  	      	      collapsed = false;
  	      	      applyMapControlCollapsedState(saveSetting);
  	      	    }

  	      	    /* Optional external hooks if we ever need them elsewhere */
  	      	    map.__trackitCloseMapControlPanel = closeMapControlPanel;
  	      	    map.__trackitOpenMapControlPanel = openMapControlPanel;
  	      	    map.__trackitToggleMapControlPanel = toggleMapControlPanel;

  	      	    header.addEventListener("click", function (event) {
  	      	      event.preventDefault();
  	      	      event.stopPropagation();

  	      	      toggleMapControlPanel(true);
  	      	    });

  	      	    zoomPlus.addEventListener("click", function (event) {
  	      	      event.preventDefault();
  	      	      event.stopPropagation();

  	      	      const z = map.getZoom() || 1;
  	      	      map.setZoom(Math.min(22, z + 1));
  	      	    });

  	      	    zoomMinus.addEventListener("click", function (event) {
  	      	      event.preventDefault();
  	      	      event.stopPropagation();

  	      	      const z = map.getZoom() || 1;
  	      	      map.setZoom(Math.max(1, z - 1));
  	      	    });

  	      	    zoomSlider.addEventListener("input", function (event) {
  	      	      event.preventDefault();
  	      	      event.stopPropagation();

  	      	      map.setZoom(Number(zoomSlider.value));
  	      	    });

  	      	    trafficBtn.addEventListener("click", function (event) {
  	      	      event.preventDefault();
  	      	      event.stopPropagation();

  	      	      trafficOn = !trafficOn;
  	      	      map.__trackitTrafficLayer.setMap(trafficOn ? map: null);

  	      	      writeSetting("trafficOn", trafficOn);
  	      	      paintToggleButtons();
  	      	    });

  	      	    labelsBtn.addEventListener("click", function (event) {
  	      	      event.preventDefault();
  	      	      event.stopPropagation();

  	      	      labelsOn = !labelsOn;

  	      	      writeSetting("labelsOn", labelsOn);
  	      	      applyMapAppearance();
  	      	      paintToggleButtons();
  	      	    });

  	      	    fullscreenBtn.addEventListener("click", function (event) {
  	      	      event.preventDefault();
  	      	      event.stopPropagation();

  	      	      toggleFullscreen();
  	      	    });

  	      	    directionsBtn.addEventListener("click", function (event) {
  	      	      event.preventDefault();
  	      	      event.stopPropagation();

  	      	      if (typeof event.stopImmediatePropagation === "function") {
  	      	        event.stopImmediatePropagation();
  	      	      }

  	      	      toggleDirectionsMode();
  	      	      sizeFleetMapControlShell(control, !collapsed);
  	      	    });

  	      	    locationsCheckbox.addEventListener("change",
  	      	      function (event) {
  	      	        event.preventDefault();
  	      	        event.stopPropagation();

  	                setAllLocationCompaniesEnabled(
  	                  !!locationsCheckbox.checked,
  	                  false
  	                );

  	      	        sizeFleetMapControlShell(
  	                  control,
  	                  !collapsed
  	                );
  	      	      });

  	      	    map.__trackitMapControlListeners.push(
  	      	      map.addListener("zoom_changed", updateZoomUi)
  	      	    );

  	      	    map.__trackitMapControlListeners.push(
  	      	      map.addListener("maptypeid_changed", function () {
  	      	        paintMapTypeButtons();
  	      	      })
  	      	    );

  	      	    const fullscreenHandler = function () {
  	      	      paintFullscreenState();
  	      	    };

  	      	    document.addEventListener("fullscreenchange",
  	      	      fullscreenHandler);
  	      	    document.addEventListener("webkitfullscreenchange",
  	      	      fullscreenHandler);

  	      	    map.__trackitDomControlListeners.push({
  	      	      target: document,
  	      	      event: "fullscreenchange",
  	      	      handler: fullscreenHandler
  	      	    });

  	      	    map.__trackitDomControlListeners.push({
  	      	      target: document,
  	      	      event: "webkitfullscreenchange",
  	      	      handler: fullscreenHandler
  	      	    });

  	      	    const resizeHandler = function () {
  	      	      sizeFleetMapControlShell(control,
  	      	        !collapsed);
  	      	    };

  	      	    if (typeof window !== "undefined") {
  	      	      window.addEventListener("resize", resizeHandler);
  	      	      map.__trackitDomControlListeners.push({
  	      	        target: window,
  	      	        event: "resize",
  	      	        handler: resizeHandler
  	      	      });
  	      	    }

  	      	    const savedZoom = readSetting("zoom", null);

  	      	    if (savedZoom !== null && savedZoom !== undefined) {
  	      	      try {
  	      	        map.setZoom(Number(savedZoom));
  	      	      } catch (_) {}
  	      	    }

  	      	    applyMapAppearance();
  	      	    updateZoomUi();
  	      	    updateHeaderState();
  	      	    sizeFleetMapControlShell(control, !collapsed);
  	      	    paintMapTypeButtons();
  	      	    paintToggleButtons();
  	      	    paintDirectionsButton();
  	      	    syncLocationLayerFromSettings(false);
  	      	    sizeFleetMapControlShell(control, !collapsed);

  	      	    function svgBase(paths) {
  	      	      return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
  	      	    }

  	      	    function iconLayers() {
  	      	      return svgBase(`
  	      	        <path d="M12 3 3 8l9 5 9-5-9-5Z"/>
  	      	        <path d="M3 12l9 5 9-5"/>
  	      	        <path d="M3 16l9 5 9-5"/>
  	      	        `);
  	      	    }

  	      	    function iconRoadmap() {
  	      	      return svgBase(`
  	      	        <path d="M4 18V6l5-2 6 2 5-2v12l-5 2-6-2-5 2Z"/>
  	      	        <path d="M9 4v12"/>
  	      	        <path d="M15 6v12"/>
  	      	        <path d="M12 9h.01"/>
  	      	        <path d="M17 11h.01"/>
  	      	        `);
  	      	    }

  	      	    function iconSatellite() {
  	      	      return svgBase(`
  	      	        <path d="m6 14 4 4"/>
  	      	        <path d="m14 6 4 4"/>
  	      	        <path d="m8 16 8-8"/>
  	      	        <rect x="12" y="3" width="7" height="5" rx="1" transform="rotate(45 12 3)"/>
  	      	        <rect x="4" y="13" width="7" height="5" rx="1" transform="rotate(45 4 13)"/>
  	      	        <path d="M17 17c1.5-1.5 2-3.5 1.2-5.2"/>
  	      	        <path d="M20 20c2.5-2.5 3-6 1.4-8.8"/>
  	      	        `);
  	      	    }

  	      	    function iconTerrain() {
  	      	      return svgBase(`
  	      	        <path d="m3 18 6-10 4 6 3-5 5 9H3Z"/>
  	      	        <path d="m8.5 12 2 2"/>
  	      	        <path d="m15.5 13 2 2"/>
  	      	        `);
  	      	    }

  	      	    function iconDirections() {
  	      	      return svgBase(`
  	      	        <path d="M6 19V6.5A2.5 2.5 0 0 1 8.5 4H17"/>
  	      	        <path d="M14 1l3 3-3 3"/>
  	      	        <path d="M6 19l-3-3"/>
  	      	        <path d="M6 19l3-3"/>
  	      	        <path d="M10 10h4a3 3 0 0 1 3 3v5"/>
  	      	        `);
  	      	    }

  	      	    function iconTraffic() {
  	      	      return svgBase(`
  	      	        <path d="M6 16h12"/>
  	      	        <path d="M7 16v3"/>
  	      	        <path d="M17 16v3"/>
  	      	        <path d="M7 13l1.5-5h7L17 13"/>
  	      	        <path d="M8 13h8"/>
  	      	        <circle cx="8.5" cy="16" r="1"/>
  	      	        <circle cx="15.5" cy="16" r="1"/>
  	      	        `);
  	      	    }

  	      	    function iconLocation() {
  	      	      return svgBase(`
  	      	        <path d="M12 21s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12Z"/>
  	      	        <circle cx="12" cy="9" r="2.4"/>
  	      	        `);
  	      	    }

  	      	    function iconFullscreen() {
  	      	      return svgBase(`
  	      	        <path d="M8 3H3v5"/>
  	      	        <path d="M16 3h5v5"/>
  	      	        <path d="M8 21H3v-5"/>
  	      	        <path d="M16 21h5v-5"/>
  	      	        `);
  	      	    }

  	      	    function iconLabel() {
  	      	      return svgBase(`
  	      	        <path d="M5 5h14v14H5z"/>
  	      	        <path d="M8 9h8"/>
  	      	        <path d="M8 12h6"/>
  	      	        <path d="M8 15h4"/>
  	      	        `);
  	      	    }
  	      	  }

  	    addTrackitUnifiedMapControl(map);
  	    installSlimBottomMapControls(map);
  	    return true;
  	  }


  	  // ---------------------------------------------------------------------------
  	  // Map
  	  // ---------------------------------------------------------------------------
  	  function initOwnedMobileMap() {
  	    const mapElement = el("[data-map]");
  	    if (!state.maps || typeof state.maps.Map !== "function") {
  	      throw new Error("Google Maps is unavailable in this window.");
  	    }

  	    if (!mapElement) {
  	      throw new Error("Mobile Tracking map container is missing.");
  	    }

  	    mapElement.style.display = "block";
  	    mapElement.style.pointerEvents = "auto";
  	    mapElement.style.width = "100%";
  	    mapElement.style.height = "100%";

  	    state.map = new state.maps.Map(mapElement, {
  	      center: DEFAULT_CENTER,
  	      zoom: DEFAULT_ZOOM,
  	      mapTypeId: "hybrid",
  	      gestureHandling: "greedy",
  	      clickableIcons: false,
  	      disableDefaultUI: true,
  	      zoomControl: true,
  	      zoomControlOptions: {
  	        position: state.maps.ControlPosition.LEFT_CENTER
  	      },
  	      streetViewControl: false,
  	      fullscreenControl: false,
  	      rotateControl: false,
  	      scaleControl: false,
  	      keyboardShortcuts: false
  	    });

  	    state.infoWindow = new state.maps.InfoWindow();

  	    /*
  	     * Force one post-layout resize after the fixed root has real dimensions.
  	     * This makes tile projection deterministic on both desktop preview and
  	     * actual mobile browsers.
  	     */
  	    requestAnimationFrame(function () {
  	      try {
  	        if (
  	          state.maps &&
  	          state.maps.event &&
  	          typeof state.maps.event.trigger === "function"
  	        ) {
  	          state.maps.event.trigger(state.map, "resize");
  	        }
  	        state.map.setCenter(DEFAULT_CENTER);
  	      } catch (_) {}
  	    });
  	  }

  	  const LIVE_BADGE_CFG = {
  	    W: 176,
  	    H: 176,
  	    CX: 88,
  	    CY: 88,
  	    OUTER_R: 44,
  	    DOT_R: 18,
  	    PTR_LEN: 40,
  	    PTR_HALF: 24,
  	    SCALE: 0.30,
  	    OUTLINE_W: 6,
  	    MOVING_SPEED_KMH: 2,
  	    COLORS: {
  	      truckFallback: "#18a058",
  	      moving: "#18a058",
  	      stopped: "#7a7a7a",
  	      warning: "#ee4b2b",
  	      stroke: "#101010",
  	      innerRim: "rgba(255,255,255,0.35)",
  	      outline: "#ffffff"
  	    },
  	    PULSE: {
  	      moving: {
  	        periodMs: 950,
  	        minScale: 1.0,
  	        maxScale: 3.0,
  	        minOpacity: 0.40,
  	        maxOpacity: 0.60
  	      },
  	      warning: {
  	        periodMs: 950,
  	        minScale: 1.0,
  	        maxScale: 3.0,
  	        minOpacity: 0.60,
  	        maxOpacity: 0.90
  	      }
  	    }
  	  };

  	  function liveVehicleWarnings(vehicle, message) {
  	    const can =
  	      (vehicle && vehicle.tractor && vehicle.tractor.CAN) ||
  	      getPath(
  	        vehicle && vehicle.tractor,
  	        "Data.CAN",
  	        {}
  	      ) ||
  	      {};

  	    const speed = num(getPath(message, "position.speed", null));
  	    const rpm = num(getPath(message, "can.engine.rpm", null));
  	    const temp = num(
  	      getPath(message, "can.engine.temperature", null)
  	    );

  	    const speedLimit = num(can.Speed);
  	    const rpmLimit = num(can.RPM);
  	    const tempLimit = num(can.Temp);

  	    const warnings = [];

  	    if (
  	      speed !== null &&
  	      speedLimit !== null &&
  	      speed > speedLimit
  	    ) {
  	      warnings.push("Speed");
  	    }
  	    if (
  	      rpm !== null &&
  	      rpmLimit !== null &&
  	      rpm > rpmLimit
  	    ) {
  	      warnings.push("Revs");
  	    }
  	    if (
  	      temp !== null &&
  	      tempLimit !== null &&
  	      temp > tempLimit
  	    ) {
  	      warnings.push("Temp");
  	    }

  	    return warnings;
  	  }

  	  function liveVehicleVisualState(vehicle, message) {
  	    const ageStatus = liveStatus(message);
  	    const fresh =
  	      ageStatus.className !== "offline" &&
  	      ageStatus.className !== "stale";

  	    const warnings =
  	      fresh
  	        ? liveVehicleWarnings(vehicle, message)
  	        : [];

  	    const warning = warnings.length > 0;
  	    const moving =
  	      fresh &&
  	      !!message &&
  	      speedOf(message) > LIVE_BADGE_CFG.MOVING_SPEED_KMH;

  	    return {
  	      warnings: warnings,
  	      warning: warning,
  	      moving: moving,
  	      statusColor:
  	        warning
  	          ? LIVE_BADGE_CFG.COLORS.warning
  	          : moving
  	            ? LIVE_BADGE_CFG.COLORS.moving
  	            : LIVE_BADGE_CFG.COLORS.stopped,
  	      pulseMode:
  	        warning
  	          ? "warning"
  	          : moving
  	            ? "moving"
  	            : null
  	    };
  	  }

  	  function liveBadgeSvg(vehicle, message) {
  	    const cfg = LIVE_BADGE_CFG;
  	    const visual = liveVehicleVisualState(
  	      vehicle,
  	      message
  	    );
  	    const truckColor =
  	      vehicle && vehicle.color
  	        ? vehicle.color
  	        : cfg.COLORS.truckFallback;

  	    const angle = headingOf(message);
  	    const tipY =
  	      cfg.CY -
  	      cfg.OUTER_R -
  	      cfg.PTR_LEN;
  	    const baseY =
  	      cfg.CY -
  	      cfg.OUTER_R +
  	      2;

  	    return `
  	      <svg xmlns="http://www.w3.org/2000/svg"
  	        width="${cfg.W}" height="${cfg.H}"
  	        viewBox="0 0 ${cfg.W} ${cfg.H}">
  	        <circle
  	          cx="${cfg.CX}" cy="${cfg.CY}"
  	          r="${cfg.OUTER_R}"
  	          fill="none"
  	          stroke="${cfg.COLORS.outline}"
  	          stroke-width="${cfg.OUTLINE_W}"/>
  	        <g transform="rotate(${angle}, ${cfg.CX}, ${cfg.CY})">
  	          <path
  	            d="M ${cfg.CX},${tipY}
  	               L ${cfg.CX - cfg.PTR_HALF},${baseY}
  	               L ${cfg.CX + cfg.PTR_HALF},${baseY} Z"
  	            fill="none"
  	            stroke="${cfg.COLORS.outline}"
  	            stroke-width="${cfg.OUTLINE_W}"/>
  	        </g>
  	        <circle
  	          cx="${cfg.CX}" cy="${cfg.CY}"
  	          r="${cfg.OUTER_R}"
  	          fill="${truckColor}"
  	          stroke="${cfg.COLORS.stroke}"
  	          stroke-width="2"/>
  	        <circle
  	          cx="${cfg.CX}" cy="${cfg.CY}"
  	          r="${cfg.DOT_R}"
  	          fill="${visual.statusColor}"
  	          stroke="${cfg.COLORS.outline}"
  	          stroke-width="2"/>
  	        <circle
  	          cx="${cfg.CX}" cy="${cfg.CY}"
  	          r="${cfg.DOT_R - 3}"
  	          fill="none"
  	          stroke="${cfg.COLORS.innerRim}"
  	          stroke-width="2"/>
  	        <g transform="rotate(${angle}, ${cfg.CX}, ${cfg.CY})">
  	          <path
  	            d="M ${cfg.CX},${tipY}
  	               L ${cfg.CX - cfg.PTR_HALF},${baseY}
  	               L ${cfg.CX + cfg.PTR_HALF},${baseY} Z"
  	            fill="${truckColor}"
  	            stroke="${cfg.COLORS.stroke}"
  	            stroke-width="2"/>
  	        </g>
  	      </svg>
  	    `;
  	  }

  	  function liveMarkerIcon(vehicle, message, selected) {
  	    const cfg = LIVE_BADGE_CFG;
  	    const scale =
  	      cfg.SCALE *
  	      (selected ? 1.08 : 1);
  	    const width = Math.round(cfg.W * scale);
  	    const height = Math.round(cfg.H * scale);

  	    return {
  	      url:
  	        "data:image/svg+xml;charset=UTF-8," +
  	        encodeURIComponent(
  	          liveBadgeSvg(vehicle, message)
  	        ),
  	      scaledSize:
  	        new state.maps.Size(width, height),
  	      anchor:
  	        new state.maps.Point(
  	          Math.round(
  	            width *
  	            (cfg.CX / cfg.W)
  	          ),
  	          Math.round(
  	            height *
  	            (cfg.CY / cfg.H)
  	          )
  	        )
  	    };
  	  }

  	  function livePulseSvg(mode) {
  	    const cfg = LIVE_BADGE_CFG;
  	    const color =
  	      mode === "warning"
  	        ? cfg.COLORS.warning
  	        : cfg.COLORS.moving;

  	    return `
  	      <svg xmlns="http://www.w3.org/2000/svg"
  	        width="${cfg.W}" height="${cfg.H}"
  	        viewBox="0 0 ${cfg.W} ${cfg.H}">
  	        <circle
  	          cx="${cfg.CX}"
  	          cy="${cfg.CY}"
  	          r="${cfg.OUTER_R + 2}"
  	          fill="none"
  	          stroke="${color}"
  	          stroke-width="12"/>
  	      </svg>
  	    `;
  	  }

  	  function ensureLivePulseAnimation() {
  	    if (
  	      state.pulseAnimationFrame ||
  	      typeof requestAnimationFrame !== "function"
  	    ) {
  	      return;
  	    }

  	    const tick = function () {
  	      state.pulseAnimationFrame = null;

  	      if (state.destroyed) return;

  	      const now =
  	        typeof performance !== "undefined" &&
  	        performance.now
  	          ? performance.now()
  	          : Date.now();

  	      let active = 0;

  	      Object.keys(
  	        state.pulseMarkerByKey
  	      ).forEach(function (key) {
  	        const marker =
  	          state.pulseMarkerByKey[key];
  	        const mode =
  	          state.pulseModeByKey[key];

  	        if (!marker || !mode) return;

  	        if (state.mode !== "live") {
  	          marker.setVisible(false);
  	          return;
  	        }

  	        marker.setVisible(true);
  	        active += 1;

  	        const cfg =
  	          LIVE_BADGE_CFG.PULSE[mode];
  	        const start =
  	          state.pulseStartedByKey[key] ||
  	          now;
  	        const phase =
  	          ((now - start) % cfg.periodMs) /
  	          cfg.periodMs;

  	        const scale =
  	          cfg.minScale +
  	          (cfg.maxScale - cfg.minScale) *
  	          phase;
  	        const opacity =
  	          cfg.maxOpacity -
  	          (cfg.maxOpacity - cfg.minOpacity) *
  	          phase;

  	        const baseW =
  	          Math.round(
  	            LIVE_BADGE_CFG.W *
  	            LIVE_BADGE_CFG.SCALE
  	          );
  	        const baseH =
  	          Math.round(
  	            LIVE_BADGE_CFG.H *
  	            LIVE_BADGE_CFG.SCALE
  	          );

  	        const width =
  	          Math.max(
  	            1,
  	            Math.round(baseW * scale)
  	          );
  	        const height =
  	          Math.max(
  	            1,
  	            Math.round(baseH * scale)
  	          );

  	        marker.setIcon({
  	          url:
  	            "data:image/svg+xml;charset=UTF-8," +
  	            encodeURIComponent(
  	              livePulseSvg(mode)
  	            ),
  	          scaledSize:
  	            new state.maps.Size(
  	              width,
  	              height
  	            ),
  	          anchor:
  	            new state.maps.Point(
  	              Math.round(
  	                width *
  	                (
  	                  LIVE_BADGE_CFG.CX /
  	                  LIVE_BADGE_CFG.W
  	                )
  	              ),
  	              Math.round(
  	                height *
  	                (
  	                  LIVE_BADGE_CFG.CY /
  	                  LIVE_BADGE_CFG.H
  	                )
  	              )
  	            )
  	        });
  	        marker.setOpacity(opacity);
  	      });

  	      if (active > 0) {
  	        state.pulseAnimationFrame =
  	          requestAnimationFrame(tick);
  	      }
  	    };

  	    state.pulseAnimationFrame =
  	      requestAnimationFrame(tick);
  	  }

  	  function syncLivePulse(vehicle, message, point) {
  	    if (
  	      !vehicle ||
  	      !point ||
  	      !state.map
  	    ) {
  	      return;
  	    }

  	    const key = vehicle.key;
  	    const visual =
  	      liveVehicleVisualState(
  	        vehicle,
  	        message
  	      );
  	    const mode = visual.pulseMode;
  	    let pulse =
  	      state.pulseMarkerByKey[key];

  	    if (!mode) {
  	      if (pulse) {
  	        pulse.setMap(null);
  	        delete state.pulseMarkerByKey[key];
  	      }
  	      delete state.pulseModeByKey[key];
  	      delete state.pulseStartedByKey[key];
  	      return;
  	    }

  	    if (!pulse) {
  	      pulse =
  	        new state.maps.Marker({
  	          map: state.map,
  	          position: point,
  	          clickable: false,
  	          optimized: true,
  	          zIndex: 40
  	        });
  	      state.pulseMarkerByKey[key] = pulse;
  	      state.pulseStartedByKey[key] =
  	        typeof performance !== "undefined" &&
  	        performance.now
  	          ? performance.now()
  	          : Date.now();
  	    }

  	    if (
  	      state.pulseModeByKey[key] !== mode
  	    ) {
  	      state.pulseModeByKey[key] = mode;
  	      state.pulseStartedByKey[key] =
  	        typeof performance !== "undefined" &&
  	        performance.now
  	          ? performance.now()
  	          : Date.now();
  	    }

  	    pulse.setPosition(point);
  	    pulse.setMap(state.map);
  	    pulse.setVisible(
  	      state.mode === "live"
  	    );

  	    ensureLivePulseAnimation();
  	  }

  	  function liveVehicleDriverOnboard(vehicle) {
  	    const tractor =
  	      vehicle && vehicle.tractor
  	        ? vehicle.tractor
  	        : {};

  	    const viewC =
  	      tractor.ViewC ||
  	      tractor.viewC ||
  	      {};

  	    const driver =
  	      viewC.Driver1 ||
  	      viewC.driver1 ||
  	      null;

  	    if (!driver) {
  	      return null;
  	    }

  	    const name =
  	      clean(
  	        firstValue([
  	          driver.name,
  	          [
  	            driver.first_name ||
  	              driver.firstName,
  	            driver.last_name ||
  	              driver.lastName
  	          ]
  	            .filter(Boolean)
  	            .join(" "),
  	          driver.username,
  	          ""
  	        ], "")
  	      );

  	    const phone =
  	      clean(
  	        firstValue([
  	          getPath(
  	            driver,
  	            "Data_Details.employee_details.contact_details.phone_number",
  	            ""
  	          ),
  	          driver.mobile,
  	          driver.phone,
  	          driver.tel,
  	          ""
  	        ], "")
  	      );

  	    /*
  	     * Driver1 existing means a driver is onboard/assigned to the live vehicle.
  	     * Keep the block visible even if an old driver record is missing a phone
  	     * number, so the operator can immediately see the data problem.
  	     */
  	    return {
  	      name:
  	        name ||
  	        "Driver Onboard",
  	      phone: phone
  	    };
  	  }

  	  function liveDriverBlockHtml(driver) {
  	    if (!driver) return "";

  	    const phone =
  	      driver.phone ||
  	      "Number not recorded";

  	    return (
  	      '<div style="' +
  	      'display:grid;' +
  	      'grid-template-columns:minmax(0,1fr) auto;' +
  	      'align-items:center;' +
  	      'gap:10px;' +
  	      'margin-top:8px;' +
  	      'padding:7px 8px;' +
  	      'border-radius:9px;' +
  	      'border:1px solid rgba(82,164,231,.20);' +
  	      'background:rgba(39,89,126,.15)">' +

  	      '<div style="' +
  	      'min-width:0">' +
  	      '<div style="' +
  	      'font-size:7.5px;' +
  	      'font-weight:900;' +
  	      'color:#82bce7;' +
  	      'text-transform:uppercase;' +
  	      'letter-spacing:.05em">' +
  	      'Driver Onboard' +
  	      '</div>' +
  	      '<div style="' +
  	      'margin-top:2px;' +
  	      'font-size:11px;' +
  	      'font-weight:900;' +
  	      'color:#fff;' +
  	      'white-space:nowrap;' +
  	      'overflow:hidden;' +
  	      'text-overflow:ellipsis">' +
  	      escapeHtml(driver.name) +
  	      '</div>' +
  	      '</div>' +

  	      '<div style="' +
  	      'font-size:10px;' +
  	      'font-weight:850;' +
  	      'color:' +
  	      (
  	        driver.phone
  	          ? '#dbefff'
  	          : '#9ca49e'
  	      ) +
  	      ';white-space:nowrap">' +
  	      escapeHtml(phone) +
  	      '</div>' +

  	      '</div>'
  	    );
  	  }

  	  function liveVehiclePopupTelemetry(vehicle, message) {
  	    const tractor =
  	      vehicle && vehicle.tractor
  	        ? vehicle.tractor
  	        : {};

  	    const can =
  	      tractor.CAN ||
  	      getPath(
  	        tractor,
  	        "Data.CAN",
  	        {}
  	      ) ||
  	      {};

  	    const speed =
  	      num(
  	        getPath(
  	          message,
  	          "position.speed",
  	          null
  	        )
  	      );

  	    const temp =
  	      num(
  	        getPath(
  	          message,
  	          "can.engine.temperature",
  	          null
  	        )
  	      );

  	    const revs =
  	      num(
  	        getPath(
  	          message,
  	          "can.engine.rpm",
  	          null
  	        )
  	      );

  	    const idle =
  	      historicalIdleSeconds({
  	        raw: message || {}
  	      });

  	    const speedLimit =
  	      num(can.Speed);
  	    const tempLimit =
  	      num(can.Temp);
  	    const revsLimit =
  	      num(can.RPM);

  	    return {
  	      speed: speed,
  	      temp: temp,
  	      revs: revs,
  	      idle: idle,

  	      speedWarning:
  	        speed !== null &&
  	        speedLimit !== null &&
  	        speed > speedLimit,

  	      tempWarning:
  	        temp !== null &&
  	        tempLimit !== null &&
  	        temp > tempLimit,

  	      revsWarning:
  	        revs !== null &&
  	        revsLimit !== null &&
  	        revs > revsLimit
  	    };
  	  }

  	  function livePopupValue(
  	    value,
  	    suffix,
  	    decimals
  	  ) {
  	    if (
  	      value === null ||
  	      value === undefined ||
  	      !Number.isFinite(
  	        Number(value)
  	      )
  	    ) {
  	      return "—";
  	    }

  	    return (
  	      formatNumber(
  	        Number(value),
  	        decimals
  	      ) +
  	      suffix
  	    );
  	  }

  	  function livePopupMetricBlock(
  	    label,
  	    value,
  	    warning,
  	    idleActive
  	  ) {
  	    const warningStyle =
  	      warning
  	        ? (
  	            "border:1px solid rgba(255,78,60,.72);" +
  	            "background:linear-gradient(180deg,rgba(139,35,29,.82),rgba(69,17,15,.88));" +
  	            "box-shadow:inset 0 0 0 1px rgba(255,110,95,.10);"
  	          )
  	        : (
  	            idleActive
  	              ? (
  	                  "border:1px solid rgba(255,197,56,.38);" +
  	                  "background:rgba(96,72,12,.34);"
  	                )
  	              : (
  	                  "border:1px solid rgba(255,255,255,.055);" +
  	                  "background:#0a0c0b;"
  	                )
  	          );

  	    return (
  	      '<div style="' +
  	      'min-width:0;border-radius:9px;padding:7px 8px;' +
  	      warningStyle +
  	      '">' +
  	      '<div style="' +
  	      'font-size:7.5px;color:' +
  	      (
  	        warning
  	          ? '#ffd3cc'
  	          : idleActive
  	            ? '#ffe29a'
  	            : '#7f8781'
  	      ) +
  	      ';font-weight:850;text-transform:uppercase;' +
  	      'letter-spacing:.045em">' +
  	      escapeHtml(label) +
  	      '</div>' +
  	      '<strong style="' +
  	      'display:block;margin-top:2px;' +
  	      'font-size:12px;line-height:1.15;color:#fff;' +
  	      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' +
  	      escapeHtml(value) +
  	      '</strong>' +
  	      '</div>'
  	    );
  	  }

  	  function closeVehicleActionPopup() {
  	    try {
  	      if (
  	        state.vehicleActionInfoWindow &&
  	        typeof state.vehicleActionInfoWindow.close === "function"
  	      ) {
  	        state.vehicleActionInfoWindow.close();
  	      }
  	    } catch (_) {}

  	    state.vehicleActionInfoWindow = null;
  	  }

  	  function currentVehiclePoint(vehicle) {
  	    if (!vehicle) return null;
  	    const message = state.liveByKey[vehicle.key];
  	    return message ? validPoint(message) : null;
  	  }

  	  function isMobileMapDevice() {
  	    const ua = navigator.userAgent || "";
  	    return (
  	      /Android|iPhone|iPad|iPod|Mobile/i.test(ua) ||
  	      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  	    );
  	  }

  	  function openDeviceDirections(point, vehicle) {
  	    if (!point) {
  	      toast("This vehicle has no valid live location.");
  	      return;
  	    }

  	    const lat = Number(point.lat);
  	    const lng = Number(point.lng);

  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
  	      toast("This vehicle has no valid live location.");
  	      return;
  	    }

  	    const coordinate = lat.toFixed(6) + "," + lng.toFixed(6);
  	    const label = clean(vehicle && vehicle.registration) || "Vehicle";
  	    const ua = navigator.userAgent || "";
  	    const isiOS =
  	      /iPad|iPhone|iPod/i.test(ua) ||
  	      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  	    const isAndroid = /Android/i.test(ua);

  	    // PHONE / TABLET:
  	    // hand the destination to the device's installed mapping software.
  	    if (isMobileMapDevice()) {
  	      if (isiOS) {
  	        window.location.href =
  	          "maps://?daddr=" +
  	          encodeURIComponent(coordinate) +
  	          "&dirflg=d";
  	        return;
  	      }

  	      if (isAndroid) {
  	        window.location.href =
  	          "geo:0,0?q=" +
  	          encodeURIComponent(coordinate + "(" + label + ")");
  	        return;
  	      }
  	    }

  	    // PC / DESKTOP BROWSER:
  	    // always open Google Maps directions in a NEW tab.
  	    const desktopUrl =
  	      "https://www.google.com/maps/dir/?api=1&destination=" +
  	      encodeURIComponent(coordinate) +
  	      "&travelmode=driving";

  	    window.open(desktopUrl, "_blank", "noopener,noreferrer");
  	  }

  	  const VEHICLE_LOCATION_WHATSAPP_SERVICE_NAME = "WhatsApp";
  	  const VEHICLE_LOCATION_WHATSAPP_METHOD_NAME = "Send_Directions_Template";

  	  function normaliseWhatsappCell(value) {
  	    let text = clean(value);

  	    if (!text) {
  	      return {
  	        ok: false,
  	        value: "",
  	        error: "Enter a WhatsApp number first."
  	      };
  	    }

  	    text = text.replace(/^whatsapp:/i, "").trim();
  	    text = text.replace(/[^\d+]/g, "");

  	    const plusCount = (text.match(/\+/g) || []).length;

  	    if (
  	      plusCount > 1 ||
  	      (text.includes("+") && !text.startsWith("+"))
  	    ) {
  	      return {
  	        ok: false,
  	        value: "",
  	        error: "Invalid WhatsApp number format."
  	      };
  	    }

  	    let digits = text.replace(/\D/g, "");

  	    // Existing TrackIT behaviour for the normal ZA field:
  	    // 0821234567 -> +27821234567
  	    if (!text.startsWith("+")) {
  	      if (digits.startsWith("27") && digits.length > 10) {
  	        digits = digits.slice(2);
  	      }

  	      if (digits.startsWith("0")) {
  	        digits = digits.slice(1);
  	      }

  	      if (digits.length !== 9) {
  	        return {
  	          ok: false,
  	          value: "",
  	          error: "Enter a valid South African mobile number, for example 0821234567."
  	        };
  	      }

  	      if (!/^[6-8]\d{8}$/.test(digits)) {
  	        return {
  	          ok: false,
  	          value: "",
  	          error: "That does not look like a valid South African mobile WhatsApp number."
  	        };
  	      }

  	      return {
  	        ok: true,
  	        value: "+27" + digits,
  	        error: ""
  	      };
  	    }

  	    // Full international format is accepted exactly as the existing TrackIT
  	    // WhatsApp normaliser does for its International option.
  	    if (digits.length < 8 || digits.length > 15) {
  	      return {
  	        ok: false,
  	        value: "",
  	        error: "WhatsApp number must be 8 to 15 digits in international format."
  	      };
  	    }

  	    return {
  	      ok: true,
  	      value: "+" + digits,
  	      error: ""
  	    };
  	  }

  	  function vehicleLocationMapsUrl(point) {
  	    if (!point) return "";

  	    const lat = Number(point.lat);
  	    const lng = Number(point.lng);

  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return "";

  	    const coordinate = lat.toFixed(6) + "," + lng.toFixed(6);

  	    return (
  	      "https://www.google.com/maps/search/?api=1&query=" +
  	      encodeURIComponent(coordinate)
  	    );
  	  }

  	  async function invokeVehicleLocationWhatsAppService(payload) {
  	    const serviceArgs = {
  	      To: payload.To,
  	      FromLocation: payload.FromLocation,
  	      ToLocation: payload.ToLocation,
  	      Stops: payload.Stops,
  	      RouteLink: payload.RouteLink
  	    };

  	    console.log(
  	      "[TrackIT Vehicle WhatsApp] Backendless service args:",
  	      serviceArgs
  	    );

  	    if (
  	      typeof Backendless !== "undefined" &&
  	      Backendless.CustomServices &&
  	      typeof Backendless.CustomServices.invoke === "function"
  	    ) {
  	      return Backendless.CustomServices.invoke(
  	        VEHICLE_LOCATION_WHATSAPP_SERVICE_NAME,
  	        VEHICLE_LOCATION_WHATSAPP_METHOD_NAME,
  	        serviceArgs
  	      );
  	    }

  	    if (
  	      typeof BackendlessUI !== "undefined" &&
  	      BackendlessUI.Backendless &&
  	      BackendlessUI.Backendless.CustomServices &&
  	      typeof BackendlessUI.Backendless.CustomServices.invoke === "function"
  	    ) {
  	      return BackendlessUI.Backendless.CustomServices.invoke(
  	        VEHICLE_LOCATION_WHATSAPP_SERVICE_NAME,
  	        VEHICLE_LOCATION_WHATSAPP_METHOD_NAME,
  	        serviceArgs
  	      );
  	    }

  	    if (
  	      typeof window !== "undefined" &&
  	      window.Backendless &&
  	      window.Backendless.CustomServices &&
  	      typeof window.Backendless.CustomServices.invoke === "function"
  	    ) {
  	      return window.Backendless.CustomServices.invoke(
  	        VEHICLE_LOCATION_WHATSAPP_SERVICE_NAME,
  	        VEHICLE_LOCATION_WHATSAPP_METHOD_NAME,
  	        serviceArgs
  	      );
  	    }

  	    throw new Error(
  	      "Backendless CustomServices.invoke is not available."
  	    );
  	  }

  	  async function sendVehicleLocationWhatsapp(
  	    vehicle,
  	    point,
  	    rawPhone,
  	    sendButton
  	  ) {
  	    if (!vehicle || !point) {
  	      toast("This vehicle has no valid live location.");
  	      return false;
  	    }

  	    const checked = normaliseWhatsappCell(rawPhone);

  	    if (!checked.ok) {
  	      toast(checked.error);
  	      return false;
  	    }

  	    const lat = Number(point.lat);
  	    const lng = Number(point.lng);

  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
  	      toast("This vehicle has no valid live location.");
  	      return false;
  	    }

  	    const coordinate =
  	      lat.toFixed(6) + ", " + lng.toFixed(6);
  	    const mapsUrl = vehicleLocationMapsUrl(point);

  	    if (!mapsUrl) {
  	      toast("Could not build the vehicle location link.");
  	      return false;
  	    }

  	    // SAME Backendless/Twilio template structure used by the existing
  	    // TrackIT Directions WhatsApp sender.
  	    const payload = {
  	      To: checked.value,
  	      FromLocation:
  	        vehicle.registration +
  	        " — " +
  	        companyName(vehicle.company),
  	      ToLocation: coordinate,
  	      Stops: "No stops",
  	      RouteLink: mapsUrl
  	    };

  	    const originalText =
  	      sendButton ? sendButton.textContent : "";

  	    try {
  	      if (sendButton) {
  	        sendButton.disabled = true;
  	        sendButton.textContent = "Sending...";
  	      }

  	      console.log(
  	        "[TrackIT Vehicle WhatsApp] Sending template payload:",
  	        payload
  	      );

  	      const result =
  	        await invokeVehicleLocationWhatsAppService(payload);

  	      console.log(
  	        "[TrackIT Vehicle WhatsApp] Sent:",
  	        result
  	      );

  	      toast(
  	        "Vehicle location WhatsApp sent to " +
  	        checked.value +
  	        "."
  	      );

  	      return true;
  	    } catch (error) {
  	      console.error(
  	        "[TrackIT Vehicle WhatsApp] Send failed:",
  	        error
  	      );

  	      const message =
  	        error && error.message
  	          ? error.message
  	          : String(error || "");

  	      if (message.includes("not available")) {
  	        toast(
  	          "WhatsApp failed. Backendless service invoke is not available on this screen."
  	        );
  	      } else {
  	        toast(
  	          "WhatsApp failed. Check the Backendless WhatsApp service and Twilio logs."
  	        );
  	      }

  	      return false;
  	    } finally {
  	      if (sendButton) {
  	        sendButton.disabled = false;
  	        sendButton.textContent =
  	          originalText || "Send";
  	      }
  	    }
  	  }

  	  function buildVehicleActionBubble(vehicle, point) {
  	    const bubble = document.createElement("div");
  	    bubble.className = "fmt-vehicle-action-bubble";
  	    bubble.setAttribute("role", "dialog");
  	    bubble.setAttribute("aria-label", "Vehicle location actions");

  	    bubble.innerHTML = `
  	      <div class="fmt-vehicle-action-head">
  	        <div class="fmt-vehicle-action-title">
  	          <strong>${escapeHtml(vehicle.registration)}</strong>
  	          <span>${escapeHtml(companyName(vehicle.company))}</span>
  	        </div>
  	      </div>

  	      <div class="fmt-vehicle-action-body">
  	        <button type="button" class="fmt-vehicle-action-btn" data-vehicle-action="directions">
  	          <span>Directions to Vehicle</span>
  	          <span class="fmt-action-arrow">›</span>
  	        </button>

  	        <button type="button" class="fmt-vehicle-action-btn" data-vehicle-action="whatsapp">
  	          <span>Send Location by WhatsApp</span>
  	          <span class="fmt-action-arrow">›</span>
  	        </button>

  	        <div class="fmt-whatsapp-panel" data-vehicle-whatsapp-panel>
  	          <label>Cellphone number</label>
  	          <div class="fmt-whatsapp-row">
  	            <input
  	              class="fmt-whatsapp-input"
  	              data-vehicle-whatsapp-phone
  	              type="tel"
  	              inputmode="tel"
  	              autocomplete="tel"
  	              placeholder="082 123 4567"
  	            >
  	            <button type="button" class="fmt-whatsapp-send" data-vehicle-action="send-whatsapp">Send</button>
  	          </div>
  	          <div class="fmt-whatsapp-help">
  	            Sends directly through Fleet In Form WhatsApp. South African 0-prefix numbers are converted to +27 automatically.
  	          </div>
  	        </div>
  	      </div>
  	    `;

  	    const directionsButton =
  	      bubble.querySelector('[data-vehicle-action="directions"]');
  	    const whatsappButton =
  	      bubble.querySelector('[data-vehicle-action="whatsapp"]');
  	    const whatsappPanel =
  	      bubble.querySelector("[data-vehicle-whatsapp-panel]");
  	    const phoneInput =
  	      bubble.querySelector("[data-vehicle-whatsapp-phone]");
  	    const sendButton =
  	      bubble.querySelector('[data-vehicle-action="send-whatsapp"]');

  	    if (directionsButton) {
  	      directionsButton.addEventListener("click", function () {
  	        openDeviceDirections(point, vehicle);
  	      });
  	    }

  	    if (whatsappButton && whatsappPanel) {
  	      whatsappButton.addEventListener("click", function () {
  	        whatsappPanel.classList.toggle("show");

  	        if (whatsappPanel.classList.contains("show") && phoneInput) {
  	          setTimeout(function () {
  	            try {
  	              phoneInput.focus();
  	            } catch (_) {}
  	          }, 0);
  	        }
  	      });
  	    }

  	    if (sendButton && phoneInput) {
  	      sendButton.addEventListener("click", async function () {
  	        const sent = await sendVehicleLocationWhatsapp(
  	          vehicle,
  	          point,
  	          phoneInput.value,
  	          sendButton
  	        );

  	        if (sent) {
  	          closeVehicleActionPopup();
  	        }
  	      });
  	    }

  	    if (phoneInput) {
  	      phoneInput.addEventListener("keydown", async function (event) {
  	        if (event.key === "Enter") {
  	          event.preventDefault();

  	          const sent = await sendVehicleLocationWhatsapp(
  	            vehicle,
  	            point,
  	            phoneInput.value,
  	            sendButton
  	          );

  	          if (sent) {
  	            closeVehicleActionPopup();
  	          }
  	        }
  	      });
  	    }

  	    return bubble;
  	  }

  	  function showVehicleActionPopup(vehicle, marker) {
  	    if (!vehicle || !marker || !state.map || !state.maps) return;

  	    const point = currentVehiclePoint(vehicle);

  	    if (!point) {
  	      toast("This vehicle has no valid live location.");
  	      return;
  	    }

  	    closeVehicleActionPopup();

  	    // Do not leave the normal telemetry InfoWindow sitting on top of the
  	    // action bubble.
  	    try {
  	      if (state.infoWindow) state.infoWindow.close();
  	    } catch (_) {}

  	    const content = buildVehicleActionBubble(vehicle, point);

  	    const infoWindow = new state.maps.InfoWindow({
  	      content: content,
  	      disableAutoPan: false,
  	      maxWidth: 330
  	    });

  	    infoWindow.addListener("domready", function () {
  	      try {
  	        const bubble = root.querySelector(".fmt-vehicle-action-bubble");
  	        if (!bubble) return;

  	        const inner = bubble.closest(".gm-style-iw-d");
  	        const shell = bubble.closest(".gm-style-iw-c");

  	        if (inner) {
  	          inner.style.setProperty("overflow", "visible", "important");
  	          inner.style.setProperty("overflow-x", "visible", "important");
  	          inner.style.setProperty("overflow-y", "visible", "important");
  	          inner.style.setProperty("max-height", "none", "important");
  	          inner.style.setProperty("padding", "0", "important");
  	        }

  	        if (shell) {
  	          shell.style.setProperty("overflow", "visible", "important");
  	          shell.style.setProperty("max-height", "none", "important");
  	        }
  	      } catch (_) {}
  	    });

  	    infoWindow.addListener("closeclick", function () {
  	      if (state.vehicleActionInfoWindow === infoWindow) {
  	        state.vehicleActionInfoWindow = null;
  	      }
  	    });

  	    state.vehicleActionInfoWindow = infoWindow;

  	    // Anchoring to the marker makes Google's normal info-window stem point
  	    // directly at the vehicle and positions the bubble above the icon.
  	    infoWindow.open({
  	      map: state.map,
  	      anchor: marker,
  	      shouldFocus: false
  	    });
  	  }

  	  function cancelMarkerLongPress() {
  	    if (state.markerLongPressTimer) {
  	      clearTimeout(state.markerLongPressTimer);
  	      state.markerLongPressTimer = null;
  	    }
  	    state.markerLongPressVehicleKey = "";
  	  }

  	  function beginMarkerLongPress(vehicle, marker) {
  	    cancelMarkerLongPress();

  	    if (!vehicle || !marker) return;

  	    state.markerLongPressTriggered = false;
  	    state.markerLongPressVehicleKey = vehicle.key;

  	    state.markerLongPressTimer = setTimeout(function () {
  	      state.markerLongPressTimer = null;

  	      if (state.markerLongPressVehicleKey !== vehicle.key) return;

  	      state.markerLongPressTriggered = true;
  	      showVehicleActionPopup(vehicle, marker);

  	      // Keep the long-press flag alive through the synthetic click that some
  	      // mobile browsers emit immediately after touch release.
  	      setTimeout(function () {
  	        state.markerLongPressTriggered = false;
  	      }, 550);
  	    }, 650);
  	  }

  	  function markerInfoHtml(vehicle, message) {
  	    const status =
  	      liveStatus(message);

  	    const telemetry =
  	      liveVehiclePopupTelemetry(
  	        vehicle,
  	        message
  	      );

  	    const driver =
  	      liveVehicleDriverOnboard(
  	        vehicle
  	      );

  	    const warningNames = [];

  	    if (telemetry.speedWarning) {
  	      warningNames.push("SPEED");
  	    }
  	    if (telemetry.tempWarning) {
  	      warningNames.push("TEMP");
  	    }
  	    if (telemetry.revsWarning) {
  	      warningNames.push("REVS");
  	    }

  	    const hasWarning =
  	      warningNames.length > 0;

  	    const idleSeconds =
  	      telemetry.idle;

  	    const idleActive =
  	      idleSeconds !== null &&
  	      Number.isFinite(
  	        Number(idleSeconds)
  	      ) &&
  	      Number(idleSeconds) > 0;

  	    const idleValue =
  	      idleSeconds === null
  	        ? "—"
  	        : formatClock(
  	            Math.max(
  	              0,
  	              Number(idleSeconds) || 0
  	            )
  	          );

  	    const speedValue =
  	      livePopupValue(
  	        telemetry.speed,
  	        " km/h",
  	        0
  	      );

  	    const tempValue =
  	      livePopupValue(
  	        telemetry.temp,
  	        " °C",
  	        1
  	      );

  	    const revsValue =
  	      livePopupValue(
  	        telemetry.revs,
  	        " RPM",
  	        0
  	      );

  	    const warningBanner =
  	      hasWarning
  	        ? (
  	            '<div style="' +
  	            'margin-top:8px;padding:7px 8px;border-radius:9px;' +
  	            'border:1px solid rgba(255,77,61,.62);' +
  	            'background:linear-gradient(180deg,rgba(159,42,32,.92),rgba(92,23,18,.94));' +
  	            'color:#fff;font-size:9px;font-weight:950;' +
  	            'letter-spacing:.035em;text-transform:uppercase">' +
  	            '⚠ WARNING — ' +
  	            escapeHtml(
  	              warningNames.join(" / ")
  	            ) +
  	            '</div>'
  	          )
  	        : "";

  	    return `
  	      <div style="
  	        min-width:220px;
  	        max-width:270px;
  	        padding:3px 1px;
  	        color:#f7f5ef;
  	        font-family:Inter,Arial,sans-serif
  	      ">
  	        <div style="
  	          display:flex;
  	          align-items:flex-start;
  	          justify-content:space-between;
  	          gap:8px
  	        ">
  	          <div style="min-width:0">
  	            <div style="
  	              font-size:15px;
  	              font-weight:900;
  	              white-space:nowrap;
  	              overflow:hidden;
  	              text-overflow:ellipsis
  	            ">
  	              ${escapeHtml(vehicle.registration)}
  	            </div>
  	            <div style="
  	              margin-top:2px;
  	              color:#9ca49e;
  	              font-size:9px;
  	              white-space:nowrap;
  	              overflow:hidden;
  	              text-overflow:ellipsis
  	            ">
  	              ${escapeHtml(companyName(vehicle.company))}
  	            </div>
  	          </div>

  	          <div style="
  	            flex:none;
  	            padding:4px 7px;
  	            border-radius:999px;
  	            border:1px solid ${hasWarning ? "rgba(255,80,65,.38)" : "rgba(255,255,255,.08)"};
  	            background:${hasWarning ? "rgba(151,39,31,.30)" : "rgba(255,255,255,.045)"};
  	            color:${hasWarning ? "#ffb6ac" : "#cbd1cd"};
  	            font-size:7.5px;
  	            font-weight:950;
  	            text-transform:uppercase
  	          ">
  	            ${escapeHtml(hasWarning ? "WARNING" : status.label)}
  	          </div>
  	        </div>

  	        ${warningBanner}
  	        ${liveDriverBlockHtml(driver)}

  	        <div style="
  	          display:grid;
  	          grid-template-columns:repeat(2,minmax(0,1fr));
  	          gap:6px;
  	          margin-top:8px
  	        ">
  	          ${livePopupMetricBlock(
  	            "Speed",
  	            speedValue,
  	            telemetry.speedWarning,
  	            false
  	          )}
  	          ${livePopupMetricBlock(
  	            "Temp",
  	            tempValue,
  	            telemetry.tempWarning,
  	            false
  	          )}
  	          ${livePopupMetricBlock(
  	            "Revs",
  	            revsValue,
  	            telemetry.revsWarning,
  	            false
  	          )}
  	          ${livePopupMetricBlock(
  	            "Idle",
  	            idleValue,
  	            false,
  	            idleActive
  	          )}
  	        </div>

  	        <div style="
  	          margin-top:7px;
  	          color:#929a94;
  	          font-size:8.5px
  	        ">
  	          ${escapeHtml(
  	            formatLocalTime(
  	              timestampSeconds(message)
  	            )
  	          )}
  	        </div>
  	      </div>
  	    `;
  	  }

  	  function updateLiveMarkers(fitFirstLoad) {
  	    if (!state.map) return;

  	    const bounds =
  	      new state.maps.LatLngBounds();
  	    let count = 0;

  	    state.vehicles.forEach(function (vehicle) {
  	      const message =
  	        state.liveByKey[vehicle.key];
  	      const point =
  	        message
  	          ? validPoint(message)
  	          : null;
  	      const existing =
  	        state.markerByKey[vehicle.key];

  	      if (!point) {
  	        if (existing) {
  	          existing.setVisible(false);
  	        }

  	        const pulse =
  	          state.pulseMarkerByKey[
  	            vehicle.key
  	          ];
  	        if (pulse) {
  	          pulse.setVisible(false);
  	        }
  	        return;
  	      }

  	      const selected =
  	        vehicle.key === state.selectedKey;
  	      let marker = existing;

  	      if (!marker) {
  	        marker =
  	          new state.maps.Marker({
  	            map: state.map,
  	            position: point,
  	            title: vehicle.registration,
  	            optimized: true
  	          });

  	        marker.addListener("mousedown", function () {
  	          beginMarkerLongPress(vehicle, marker);
  	        });

  	        marker.addListener("mouseup", function () {
  	          cancelMarkerLongPress();
  	        });

  	        marker.addListener("mouseout", function () {
  	          cancelMarkerLongPress();
  	        });

  	        marker.addListener("dragstart", function () {
  	          cancelMarkerLongPress();
  	        });

  	        // Desktop fallback: right-click opens the same action menu immediately.
  	        marker.addListener("rightclick", function () {
  	          cancelMarkerLongPress();
  	          state.markerLongPressTriggered = true;
  	          showVehicleActionPopup(vehicle, marker);
  	          setTimeout(function () {
  	            state.markerLongPressTriggered = false;
  	          }, 350);
  	        });

  	        marker.addListener(
  	          "click",
  	          function () {
  	            if (state.markerLongPressTriggered) {
  	              state.markerLongPressTriggered = false;
  	              return;
  	            }

  	            if (
  	              state.map &&
  	              state.map.__trackitDirections &&
  	              state.map.__trackitDirections.active &&
  	              typeof state.map.__trackitAddDirectionsPoint === "function"
  	            ) {
  	              try {
  	                const meta =
  	                  typeof state.map.__trackitGetDirectionsVehicleMeta === "function"
  	                    ? state.map.__trackitGetDirectionsVehicleMeta(
  	                        vehicle.tractor,
  	                        vehicle.key
  	                      )
  	                    : null;

  	                state.map.__trackitAddDirectionsPoint(
  	                  marker.getPosition(),
  	                  vehicle.registration,
  	                  meta
  	                );
  	                return;
  	              } catch (_) {}
  	            }

  	            closeVehicleActionPopup();

  	            state.selectedKey =
  	              vehicle.key;
  	            updateVehicleSelect();
  	            refreshMarkerStyles();
  	            renderSummaryCard();
  	            resolveSelectedLastMoved();

  	            state.infoWindow.setContent(
  	              markerInfoHtml(
  	                vehicle,
  	                state.liveByKey[
  	                  vehicle.key
  	                ]
  	              )
  	            );
  	            state.infoWindow.open({
  	              map: state.map,
  	              anchor: marker
  	            });
  	          }
  	        );

  	        state.markerByKey[
  	          vehicle.key
  	        ] = marker;
  	      }

  	      const visual =
  	        liveVehicleVisualState(
  	          vehicle,
  	          message
  	        );

  	      marker.setVisible(
  	        state.mode === "live"
  	      );
  	      marker.setPosition(point);
  	      marker.setIcon(
  	        liveMarkerIcon(
  	          vehicle,
  	          message,
  	          selected
  	        )
  	      );

  	      if (!state.map.__truckPins) {
  	        state.map.__truckPins = {};
  	      }

  	      const canonicalPin =
  	        state.map.__truckPins[vehicle.key] || {};

  	      canonicalPin.marker = marker;
  	      canonicalPin.tractor = vehicle.tractor;
  	      canonicalPin.objectId = objectIdOf(vehicle.tractor);
  	      state.map.__truckPins[vehicle.key] = canonicalPin;
  	      marker.setTitle(
  	        vehicle.registration +
  	        (
  	          visual.warning
  	            ? " • WARNING"
  	            : visual.moving
  	              ? " • moving"
  	              : " • stopped"
  	        )
  	      );
  	      marker.setZIndex(
  	        selected ? 600 : 200
  	      );

  	      syncLivePulse(
  	        vehicle,
  	        message,
  	        point
  	      );

  	      bounds.extend(point);
  	      count += 1;
  	    });

  	    if (
  	      fitFirstLoad &&
  	      count > 0
  	    ) {
  	      if (count === 1) {
  	        const only =
  	          state.vehicles.find(
  	            function (vehicle) {
  	              return !!validPoint(
  	                state.liveByKey[
  	                  vehicle.key
  	                ]
  	              );
  	            }
  	          );

  	        if (only) {
  	          state.map.setCenter(
  	            validPoint(
  	              state.liveByKey[
  	                only.key
  	              ]
  	            )
  	          );
  	          state.map.setZoom(14);
  	        }
  	      } else {
  	        state.map.fitBounds(
  	          bounds,
  	          {
  	            top: 78,
  	            right: 28,
  	            bottom: 320,
  	            left: 28
  	          }
  	        );

  	        state.maps.event.addListenerOnce(
  	          state.map,
  	          "idle",
  	          function () {
  	            try {
  	              if (
  	                state.map.getZoom() > 14
  	              ) {
  	                state.map.setZoom(14);
  	              }
  	            } catch (_) {}
  	          }
  	        );
  	      }

  	      state.fitDone = true;
  	    }

  	    if (state.followSelected) {
  	      const vehicle =
  	        selectedVehicle();
  	      const point =
  	        vehicle &&
  	        validPoint(
  	          state.liveByKey[
  	            vehicle.key
  	          ]
  	        );

  	      if (point) {
  	        state.map.panTo(point);
  	      }
  	    }
  	  }

  	  function refreshMarkerStyles() {
  	    state.vehicles.forEach(function (vehicle) {
  	      const marker =
  	        state.markerByKey[vehicle.key];
  	      const message =
  	        state.liveByKey[vehicle.key];

  	      if (!marker || !message) return;

  	      marker.setIcon(
  	        liveMarkerIcon(
  	          vehicle,
  	          message,
  	          vehicle.key ===
  	            state.selectedKey
  	        )
  	      );
  	      marker.setZIndex(
  	        vehicle.key ===
  	          state.selectedKey
  	          ? 600
  	          : 200
  	      );

  	      const point =
  	        validPoint(message);
  	      if (point) {
  	        syncLivePulse(
  	          vehicle,
  	          message,
  	          point
  	        );
  	      }
  	    });
  	  }

  	  function fitVisibleLive() {
  	    if (!state.map) return;

  	    if (state.mode === "history" && state.historyPoints.length) {
  	      fitRoute();
  	      return;
  	    }

  	    const bounds = new state.maps.LatLngBounds();
  	    let count = 0;

  	    state.vehicles.forEach(function (vehicle) {
  	      const point = validPoint(state.liveByKey[vehicle.key]);
  	      if (!point) return;
  	      bounds.extend(point);
  	      count += 1;
  	    });

  	    if (count === 1) {
  	      state.map.setCenter(bounds.getCenter());
  	      state.map.setZoom(16);
  	    } else if (count > 1) {
  	      state.map.fitBounds(bounds, {
  	        top: 78,
  	        right: 28,
  	        bottom: 320,
  	        left: 28
  	      });
  	    }
  	  }

  	  function clearHistoryLayers() {
  	    if (state.replayTimer) {
  	      clearInterval(state.replayTimer);
  	      state.replayTimer = null;
  	    }

  	    state.historyLayers.forEach(function (layer) {
  	      try {
  	        layer.setMap(null);
  	      } catch (_) {}
  	    });

  	    state.historyLayers = [];

  	    if (state.replayMarker) {
  	      try {
  	        state.replayMarker.setMap(null);
  	      } catch (_) {}
  	      state.replayMarker = null;
  	    }

  	    if (state.historySelectionMarker) {
  	      try {
  	        state.historySelectionMarker.setMap(null);
  	      } catch (_) {}
  	      state.historySelectionMarker = null;
  	    }

  	    state.historyPoints = [];
  	    state.historyEvents = {};
  	    state.replayPoints = [];
  	    state.replayIndex = 0;
  	    state.routeSummary = null;
  	    updateReplayUi();
  	  }

  	  function historyPoint(message) {
  	    const point = validPoint(message);
  	    if (!point) return null;

  	    return {
  	      lat: point.lat,
  	      lng: point.lng,
  	      timestamp: timestampSeconds(message),
  	      speed: speedOf(message),
  	      heading: headingOf(message),
  	      ignition: ignitionOf(message),
  	      color:
  	        clean(message && message.color) ||
  	        "#FFFF00",
  	      events:
  	        arr(message && message.events),
  	      raw: message
  	    };
  	  }

  	  function markerCircleIcon(
  	    color,
  	    scale,
  	    label
  	  ) {
  	    return {
  	      path:
  	        "M0,0 m-6,0 " +
  	        "a6,6 0 1,0 12,0 " +
  	        "a6,6 0 1,0 -12,0",
  	      fillColor: color,
  	      fillOpacity: 1,
  	      strokeColor: "#ffffff",
  	      strokeWeight: 1.5,
  	      scale: scale || 1.5,
  	      anchor:
  	        new state.maps.Point(0, 0),
  	      labelOrigin:
  	        new state.maps.Point(0, -14)
  	    };
  	  }

  	  function historyMarker(
  	    point,
  	    color,
  	    label,
  	    scale,
  	    zIndex,
  	    title,
  	    lines
  	  ) {
  	    if (!point) return null;

  	    const marker =
  	      new state.maps.Marker({
  	        map: state.map,
  	        position: {
  	          lat: point.lat,
  	          lng: point.lng
  	        },
  	        icon:
  	          markerCircleIcon(
  	            color,
  	            scale || 1.5,
  	            label || ""
  	          ),
  	        label:
  	          label
  	            ? {
  	                text: label,
  	                color: "#ffffff",
  	                fontSize: "11px",
  	                fontWeight: "bold"
  	              }
  	            : null,
  	        title: title || "",
  	        zIndex: zIndex || 900
  	      });

  	    if (title) {
  	      marker.addListener(
  	        "click",
  	        function () {
  	          const body =
  	            arr(lines).map(
  	              function (line) {
  	                return (
  	                  '<div style="' +
  	                  'margin-top:4px;color:#d9dedb;' +
  	                  'font-size:11px">' +
  	                  escapeHtml(line) +
  	                  "</div>"
  	                );
  	              }
  	            ).join("");

  	          state.infoWindow.setContent(
  	            '<div style="' +
  	            'min-width:190px;padding:5px 3px;' +
  	            'color:#fff;font-family:Inter,Arial,sans-serif">' +
  	            '<div style="' +
  	            'font-size:14px;font-weight:900;color:' +
  	            escapeAttr(color) +
  	            '">' +
  	            escapeHtml(title) +
  	            "</div>" +
  	            body +
  	            "</div>"
  	          );
  	          state.infoWindow.open({
  	            map: state.map,
  	            anchor: marker
  	          });
  	        }
  	      );
  	    }

  	    state.historyLayers.push(marker);
  	    return marker;
  	  }

  	  function historyEventTimestampMs(value) {
  	    if (
  	      value === null ||
  	      value === undefined
  	    ) {
  	      return null;
  	    }

  	    if (typeof value === "number") {
  	      if (!Number.isFinite(value)) {
  	        return null;
  	      }
  	      return value < 1e12
  	        ? value * 1000
  	        : value;
  	    }

  	    const numeric = Number(value);
  	    if (Number.isFinite(numeric)) {
  	      return numeric < 1e12
  	        ? numeric * 1000
  	        : numeric;
  	    }

  	    const parsed = Date.parse(value);
  	    return Number.isFinite(parsed)
  	      ? parsed
  	      : null;
  	  }

  	  function historyEventWindow(segment) {
  	    if (!segment) return null;

  	    const points =
  	      arr(segment.Points);
  	    const first =
  	      points.length
  	        ? points[0]
  	        : null;
  	    const last =
  	      points.length
  	        ? points[
  	            points.length - 1
  	          ]
  	        : null;

  	    const start =
  	      historyEventTimestampMs(
  	        firstValue([
  	          segment.start_iso,
  	          segment.start,
  	          first && first.timestamp
  	        ], null)
  	      );

  	    if (!Number.isFinite(start)) {
  	      return null;
  	    }

  	    let end =
  	      historyEventTimestampMs(
  	        firstValue([
  	          segment.end_iso,
  	          segment.end,
  	          last && last.timestamp
  	        ], null)
  	      );

  	    const idleSeconds =
  	      num(segment.idle_seconds);

  	    if (
  	      idleSeconds !== null &&
  	      idleSeconds >= 0
  	    ) {
  	      const durationEnd =
  	        start +
  	        idleSeconds * 1000;
  	      end =
  	        Number.isFinite(end)
  	          ? Math.max(end, durationEnd)
  	          : durationEnd;
  	    }

  	    if (!Number.isFinite(end)) {
  	      const duration =
  	        num(segment.duration);
  	      end =
  	        duration !== null
  	          ? start +
  	            Math.max(0, duration) *
  	            1000
  	          : start;
  	    }

  	    return {
  	      startMs: start,
  	      endMs: Math.max(start, end)
  	    };
  	  }

  	  function closestHistoryPointToTime(
  	    points,
  	    timestampMs
  	  ) {
  	    let best = null;
  	    let bestDiff = Infinity;

  	    points.forEach(function (point) {
  	      const pointMs =
  	        historyEventTimestampMs(
  	          point.timestamp
  	        );
  	      if (!Number.isFinite(pointMs)) {
  	        return;
  	      }

  	      const diff =
  	        Math.abs(
  	          pointMs - timestampMs
  	        );

  	      if (diff < bestDiff) {
  	        best = point;
  	        bestDiff = diff;
  	      }
  	    });

  	    return best;
  	  }

  	  function eventSegmentPoint(
  	    segment,
  	    points
  	  ) {
  	    const win =
  	      historyEventWindow(segment);

  	    if (win) {
  	      const routePoint =
  	        closestHistoryPointToTime(
  	          points,
  	          win.startMs
  	        );

  	      if (
  	        routePoint &&
  	        Math.abs(
  	          historyEventTimestampMs(
  	            routePoint.timestamp
  	          ) -
  	          win.startMs
  	        ) <= 120000
  	      ) {
  	        return routePoint;
  	      }
  	    }

  	    const source =
  	      arr(segment && segment.Points)[0];

  	    if (!source) return null;

  	    const lat = num(
  	      firstValue([
  	        source.lat,
  	        source.latitude,
  	        source.point &&
  	          source.point[
  	            "position.latitude"
  	          ]
  	      ], null)
  	    );
  	    const lng = num(
  	      firstValue([
  	        source.lon,
  	        source.lng,
  	        source.longitude,
  	        source.point &&
  	          source.point[
  	            "position.longitude"
  	          ]
  	      ], null)
  	    );

  	    if (
  	      lat === null ||
  	      lng === null ||
  	      Math.abs(lat) > 90 ||
  	      Math.abs(lng) > 180 ||
  	      (lat === 0 && lng === 0)
  	    ) {
  	      return null;
  	    }

  	    return {
  	      lat: lat,
  	      lng: lng,
  	      timestamp:
  	        num(source.timestamp) || 0,
  	      speed: 0,
  	      heading: 0,
  	      raw: source.point || source
  	    };
  	  }

  	  function pointInsideEventWindows(
  	    point,
  	    windows
  	  ) {
  	    const pointMs =
  	      historyEventTimestampMs(
  	        point && point.timestamp
  	      );

  	    if (!Number.isFinite(pointMs)) {
  	      return false;
  	    }

  	    return windows.some(
  	      function (win) {
  	        return (
  	          pointMs >= win.startMs -
  	            15000 &&
  	          pointMs <= win.endMs +
  	            15000
  	        );
  	      }
  	    );
  	  }

  	  function buildHistoryStopSegments(
  	    points,
  	    idleWindows
  	  ) {
  	    const output = [];
  	    let current = null;

  	    const flush = function () {
  	      if (
  	        current &&
  	        current.points.length
  	      ) {
  	        output.push(current);
  	      }
  	      current = null;
  	    };

  	    points.forEach(function (point) {
  	      const stopped =
  	        Number.isFinite(
  	          Number(point.speed)
  	        ) &&
  	        Number(point.speed) < 1;

  	      const idle =
  	        pointInsideEventWindows(
  	          point,
  	          idleWindows
  	        ) ||
  	        arr(
  	          point.raw &&
  	          point.raw.events
  	        ).some(function (eventName) {
  	          return (
  	            lower(eventName).indexOf(
  	              "idle"
  	            ) >= 0
  	          );
  	        });

  	      if (stopped && !idle) {
  	        if (!current) {
  	          current = {
  	            points: []
  	          };
  	        }
  	        current.points.push(point);
  	      } else {
  	        flush();
  	      }
  	    });

  	    flush();
  	    return output;
  	  }

  	  function historyStopDuration(
  	    segment
  	  ) {
  	    if (
  	      !segment ||
  	      !segment.points ||
  	      !segment.points.length
  	    ) {
  	      return 0;
  	    }

  	    const first =
  	      segment.points[0];
  	    const last =
  	      segment.points[
  	        segment.points.length - 1
  	      ];

  	    return Math.max(
  	      0,
  	      (
  	        Number(last.timestamp || 0) -
  	        Number(first.timestamp || 0)
  	      )
  	    );
  	  }

  	  function historyFuelMarkerSvg(
  	    color,
  	    symbol
  	  ) {
  	    return `
  	      <svg xmlns="http://www.w3.org/2000/svg"
  	        width="48" height="48"
  	        viewBox="0 0 48 48">
  	        <circle cx="24" cy="24" r="21"
  	          fill="rgba(10,12,11,.92)"
  	          stroke="${color}"
  	          stroke-width="3"/>
  	        <path
  	          d="M16 15h14v7l4 4v10H16z
  	             M20 15v-3h8v3
  	             M20 22h7"
  	          fill="none"
  	          stroke="${color}"
  	          stroke-width="2.5"
  	          stroke-linecap="round"
  	          stroke-linejoin="round"/>
  	        <text x="24" y="34"
  	          text-anchor="middle"
  	          font-family="Arial,sans-serif"
  	          font-size="15"
  	          font-weight="900"
  	          fill="#fff">${symbol}</text>
  	      </svg>
  	    `;
  	  }

  	  function addHistoryFuelMarkers(
  	    eventList,
  	    points,
  	    gain
  	  ) {
  	    const color =
  	      gain
  	        ? "#00cc44"
  	        : "#ff3b30";
  	    const title =
  	      gain
  	        ? "Fuel Gain"
  	        : "Fuel Loss";
  	    const symbol =
  	      gain ? "+" : "−";

  	    arr(eventList).forEach(
  	      function (segment, index) {
  	        const point =
  	          eventSegmentPoint(
  	            segment,
  	            points
  	          );

  	        if (!point) return;

  	        const svg =
  	          historyFuelMarkerSvg(
  	            color,
  	            symbol
  	          );

  	        const marker =
  	          new state.maps.Marker({
  	            map: state.map,
  	            position: {
  	              lat: point.lat,
  	              lng: point.lng
  	            },
  	            title:
  	              title +
  	              " #" +
  	              String(index + 1),
  	            zIndex: 1050,
  	            icon: {
  	              url:
  	                "data:image/svg+xml;charset=UTF-8," +
  	                encodeURIComponent(svg),
  	              scaledSize:
  	                new state.maps.Size(
  	                  44,
  	                  44
  	                ),
  	              anchor:
  	                new state.maps.Point(
  	                  22,
  	                  22
  	                )
  	            }
  	          });

  	        marker.addListener(
  	          "click",
  	          function () {
  	            const win =
  	              historyEventWindow(
  	                segment
  	              );
  	            const change =
  	              num(segment.ChangeL);

  	            state.infoWindow.setContent(
  	              '<div style="' +
  	              'min-width:190px;padding:5px 3px;' +
  	              'color:#fff;font-family:Inter,Arial,sans-serif">' +
  	              '<div style="' +
  	              'font-size:14px;font-weight:900;color:' +
  	              color +
  	              '">' +
  	              title +
  	              "</div>" +
  	              '<div style="margin-top:5px;color:#d9dedb;font-size:11px">' +
  	              "Time: " +
  	              escapeHtml(
  	                formatLocalTime(
  	                  win
  	                    ? win.startMs /
  	                      1000
  	                    : point.timestamp
  	                )
  	              ) +
  	              "</div>" +
  	              (
  	                change !== null
  	                  ? '<div style="margin-top:4px;color:#d9dedb;font-size:11px">' +
  	                    "Change: " +
  	                    escapeHtml(
  	                      formatNumber(
  	                        change,
  	                        1
  	                      )
  	                    ) +
  	                    " L</div>"
  	                  : ""
  	              ) +
  	              "</div>"
  	            );

  	            state.infoWindow.open({
  	              map: state.map,
  	              anchor: marker
  	            });
  	          }
  	        );

  	        state.historyLayers.push(
  	          marker
  	        );
  	      }
  	    );
  	  }

  	  function mixRouteColors(a, b) {
  	    const parse = function (hex) {
  	      const cleanHex =
  	        clean(hex).replace("#", "");
  	      if (
  	        !/^[0-9a-f]{6}$/i.test(
  	          cleanHex
  	        )
  	      ) {
  	        return [255, 255, 0];
  	      }

  	      return [
  	        parseInt(
  	          cleanHex.slice(0, 2),
  	          16
  	        ),
  	        parseInt(
  	          cleanHex.slice(2, 4),
  	          16
  	        ),
  	        parseInt(
  	          cleanHex.slice(4, 6),
  	          16
  	        )
  	      ];
  	    };

  	    const one = parse(a);
  	    const two = parse(b);

  	    return (
  	      "#" +
  	      one.map(function (value, index) {
  	        return Math.round(
  	          (
  	            value +
  	            two[index]
  	          ) / 2
  	        )
  	          .toString(16)
  	          .padStart(2, "0");
  	      }).join("")
  	    );
  	  }

  	  function darkenRouteColor(
  	    hex,
  	    factor
  	  ) {
  	    const cleanHex =
  	      clean(hex).replace("#", "");

  	    if (
  	      !/^[0-9a-f]{6}$/i.test(
  	        cleanHex
  	      )
  	    ) {
  	      return "#006600";
  	    }

  	    const safe =
  	      clamp(
  	        Number(factor) || 0.55,
  	        0,
  	        1
  	      );

  	    return (
  	      "#" +
  	      [0, 2, 4].map(
  	        function (offset) {
  	          return Math.round(
  	            parseInt(
  	              cleanHex.slice(
  	                offset,
  	                offset + 2
  	              ),
  	              16
  	            ) * safe
  	          )
  	            .toString(16)
  	            .padStart(2, "0");
  	        }
  	      ).join("")
  	    );
  	  }

  	  function routeChevronIcon(
  	    baseColor
  	  ) {
  	    return {
  	      path:
  	        "M -10 -7 L -4 -7 " +
  	        "L 6 0 L -4 7 " +
  	        "L -10 7 L 0 0 Z",
  	      fillColor:
  	        darkenRouteColor(
  	          baseColor,
  	          0.55
  	        ),
  	      fillOpacity: 0.20,
  	      strokeColor:
  	        darkenRouteColor(
  	          baseColor,
  	          0.34
  	        ),
  	      strokeOpacity: 0.25,
  	      strokeWeight: 1,
  	      scale: 0.72,
  	      rotation: 270
  	    };
  	  }

  	  function historicalIdleSeconds(point) {
  	    const raw =
  	      point && point.raw
  	        ? point.raw
  	        : {};

  	    const idleTotal = num(
  	      firstValue([
  	        getPath(raw, "idle.total", null),
  	        raw.totalidle
  	      ], null)
  	    );

  	    const idleActiveRaw =
  	      firstValue([
  	        getPath(raw, "idle.status", null),
  	        raw.idle
  	      ], null);

  	    const idleActive =
  	      idleActiveRaw === true ||
  	      idleActiveRaw === 1 ||
  	      lower(idleActiveRaw) === "true";

  	    /*
  	     * Flespi's idle.total is the cumulative duration of the CURRENT idle
  	     * interval. If the point is not in idle and has no counter, show zero
  	     * rather than inventing a duration.
  	     */
  	    if (
  	      idleTotal !== null &&
  	      idleTotal >= 0
  	    ) {
  	      return idleTotal;
  	    }

  	    return idleActive ? null : 0;
  	  }

  	  function historicalPointMetrics(point) {
  	    const raw =
  	      point && point.raw
  	        ? point.raw
  	        : {};
  	    const vehicle =
  	      selectedVehicle();
  	    const tractor =
  	      vehicle && vehicle.tractor
  	        ? vehicle.tractor
  	        : {};
  	    const can =
  	      tractor.CAN ||
  	      getPath(
  	        tractor,
  	        "Data.CAN",
  	        {}
  	      ) ||
  	      {};

  	    const speed = num(
  	      getPath(
  	        raw,
  	        "position.speed",
  	        null
  	      )
  	    );
  	    const revs = num(
  	      getPath(
  	        raw,
  	        "can.engine.rpm",
  	        null
  	      )
  	    );
  	    const temp = num(
  	      getPath(
  	        raw,
  	        "can.engine.temperature",
  	        null
  	      )
  	    );
  	    const idle =
  	      historicalIdleSeconds(point);

  	    const speedLimit =
  	      num(can.Speed);
  	    const revLimit =
  	      num(can.RPM);
  	    const tempLimit =
  	      num(can.Temp);

  	    return {
  	      speed: speed,
  	      revs: revs,
  	      temp: temp,
  	      idle: idle,
  	      speedOver:
  	        speed !== null &&
  	        speedLimit !== null &&
  	        speed > speedLimit,
  	      revsOver:
  	        revs !== null &&
  	        revLimit !== null &&
  	        revs > revLimit,
  	      tempOver:
  	        temp !== null &&
  	        tempLimit !== null &&
  	        temp > tempLimit
  	    };
  	  }

  	  function historicalMetricValue(
  	    value,
  	    suffix,
  	    decimals
  	  ) {
  	    if (
  	      value === null ||
  	      value === undefined ||
  	      !Number.isFinite(Number(value))
  	    ) {
  	      return "—";
  	    }

  	    return (
  	      formatNumber(
  	        Number(value),
  	        decimals
  	      ) +
  	      suffix
  	    );
  	  }

  	  function historicalPointPopupHtml(point) {
  	    const metrics =
  	      historicalPointMetrics(point);

  	    const rows = [
  	      {
  	        label: "Speed",
  	        value:
  	          historicalMetricValue(
  	            metrics.speed,
  	            " km/h",
  	            1
  	          ),
  	        over: metrics.speedOver,
  	        accent: "#CC6633"
  	      },
  	      {
  	        label: "Revs",
  	        value:
  	          historicalMetricValue(
  	            metrics.revs,
  	            " RPM",
  	            0
  	          ),
  	        over: metrics.revsOver,
  	        accent: "#7B08CD"
  	      },
  	      {
  	        label: "Temp",
  	        value:
  	          historicalMetricValue(
  	            metrics.temp,
  	            " °C",
  	            1
  	          ),
  	        over: metrics.tempOver,
  	        accent: "#947F00"
  	      },
  	      {
  	        label: "Idle",
  	        value:
  	          metrics.idle === null
  	            ? "—"
  	            : formatClock(
  	                Math.max(
  	                  0,
  	                  metrics.idle
  	                )
  	              ),
  	        over:
  	          metrics.idle !== null &&
  	          metrics.idle > 0,
  	        accent: "#ffcc00"
  	      }
  	    ];

  	    return (
  	      '<div style="' +
  	      'min-width:210px;' +
  	      'padding:4px 2px;' +
  	      'font-family:Inter,Arial,sans-serif;' +
  	      'color:#fff">' +
  	      rows.map(
  	        function (row) {
  	          const background =
  	            row.over
  	              ? row.accent
  	              : "#0d100f";
  	          const valueColor =
  	            row.over &&
  	            row.label === "Temp"
  	              ? "#fff"
  	              : "#fff";

  	          return (
  	            '<div style="' +
  	            'display:grid;' +
  	            'grid-template-columns:72px 1fr;' +
  	            'align-items:center;' +
  	            'gap:12px;' +
  	            'padding:9px 10px;' +
  	            'margin:4px 0;' +
  	            'border-radius:8px;' +
  	            'background:' +
  	            background +
  	            ';' +
  	            'border:1px solid rgba(255,255,255,.10)">' +
  	            '<div style="' +
  	            'font-size:12px;' +
  	            'font-weight:800;' +
  	            'color:rgba(255,255,255,.78)">' +
  	            escapeHtml(row.label) +
  	            '</div>' +
  	            '<div style="' +
  	            'font-size:14px;' +
  	            'font-weight:950;' +
  	            'text-align:right;' +
  	            'white-space:nowrap;' +
  	            'color:' +
  	            valueColor +
  	            '">' +
  	            escapeHtml(row.value) +
  	            '</div>' +
  	            '</div>'
  	          );
  	        }
  	      ).join("") +
  	      '</div>'
  	    );
  	  }

  	  function historicalSelectedPointIcon(point) {
  	    const vehicle =
  	      selectedVehicle();
  	    const fill =
  	      vehicle && vehicle.color
  	        ? vehicle.color
  	        : "#d46d34";
  	    const heading =
  	      Number.isFinite(
  	        Number(point && point.heading)
  	      )
  	        ? Number(point.heading)
  	        : 0;

  	    /*
  	     * This is the compact directional point marker used by the old
  	     * historical FineTrack view.
  	     */
  	    return {
  	      path:
  	        "M -4,-12 L 0,-20 L 4,-12 " +
  	        "A 10,10 0 1,1 -4,-12 Z",
  	      fillColor: fill,
  	      fillOpacity: 1,
  	      strokeWeight: 2,
  	      strokeColor: "#ffffff",
  	      rotation: heading,
  	      scale: 1.45,
  	      anchor:
  	        new state.maps.Point(0, 0)
  	    };
  	  }

  	  function showHistoricalPointData(point) {
  	    if (!point || !state.map) return;

  	    if (!state.historySelectionMarker) {
  	      state.historySelectionMarker =
  	        new state.maps.Marker({
  	          map: state.map,
  	          clickable: false,
  	          zIndex: 1400
  	        });
  	    }

  	    state.historySelectionMarker.setMap(
  	      state.map
  	    );
  	    state.historySelectionMarker.setPosition({
  	      lat: point.lat,
  	      lng: point.lng
  	    });
  	    state.historySelectionMarker.setIcon(
  	      historicalSelectedPointIcon(point)
  	    );

  	    state.infoWindow.setContent(
  	      historicalPointPopupHtml(point)
  	    );

  	    state.infoWindow.open({
  	      map: state.map,
  	      anchor:
  	        state.historySelectionMarker
  	    });
  	  }

  	  function nearestHistoricalPoint(
  	    latLng,
  	    points
  	  ) {
  	    if (
  	      !latLng ||
  	      !Array.isArray(points) ||
  	      !points.length
  	    ) {
  	      return null;
  	    }

  	    const clicked = {
  	      lat:
  	        typeof latLng.lat === "function"
  	          ? latLng.lat()
  	          : Number(latLng.lat),
  	      lng:
  	        typeof latLng.lng === "function"
  	          ? latLng.lng()
  	          : Number(latLng.lng)
  	    };

  	    if (
  	      !Number.isFinite(clicked.lat) ||
  	      !Number.isFinite(clicked.lng)
  	    ) {
  	      return null;
  	    }

  	    let nearest = null;
  	    let nearestDistance =
  	      Infinity;

  	    points.forEach(
  	      function (point) {
  	        const distance =
  	          haversineKm(
  	            clicked,
  	            point
  	          );

  	        if (
  	          distance <
  	          nearestDistance
  	        ) {
  	          nearestDistance =
  	            distance;
  	          nearest = point;
  	        }
  	      }
  	    );

  	    return nearest;
  	  }

  	  function historyRouteSegments(
  	    points
  	  ) {
  	    if (!points.length) return [];

  	    const segments = [];
  	    let currentColor =
  	      points[0].color ||
  	      "#FFFF00";
  	    let current = [];
  	    let previousTail = null;

  	    points.forEach(function (point) {
  	      const color =
  	        point.color ||
  	        "#FFFF00";
  	      const previous =
  	        current.length
  	          ? current[
  	              current.length - 1
  	            ]
  	          : null;

  	      /*
  	       * Ignore GPS chatter of less than three metres, as the canonical
  	       * TrackIT renderer does.
  	       */
  	      if (
  	        previous &&
  	        haversineKm(
  	          previous,
  	          point
  	        ) * 1000 < 3
  	      ) {
  	        return;
  	      }

  	      if (color !== currentColor) {
  	        if (current.length >= 2) {
  	          segments.push({
  	            color: currentColor,
  	            points: current.slice()
  	          });
  	        }

  	        if (previousTail) {
  	          segments.push({
  	            color:
  	              mixRouteColors(
  	                currentColor,
  	                color
  	              ),
  	            points: [
  	              previousTail,
  	              point
  	            ]
  	          });
  	        }

  	        currentColor = color;
  	        current = [point];
  	      } else {
  	        current.push(point);
  	      }

  	      previousTail = point;
  	    });

  	    if (current.length >= 2) {
  	      segments.push({
  	        color: currentColor,
  	        points: current
  	      });
  	    }

  	    return segments;
  	  }

  	  function sampleHistoryPoints(
  	    points,
  	    maxPoints
  	  ) {
  	    if (points.length <= maxPoints) {
  	      return points.slice();
  	    }

  	    const mandatory =
  	      new Set([0, points.length - 1]);

  	    for (
  	      let index = 1;
  	      index < points.length;
  	      index += 1
  	    ) {
  	      if (
  	        points[index].color !==
  	        points[index - 1].color
  	      ) {
  	        mandatory.add(index - 1);
  	        mandatory.add(index);
  	      }

  	      if (
  	        points[index].events &&
  	        points[index].events.length
  	      ) {
  	        mandatory.add(index);
  	      }
  	    }

  	    const evenly =
  	      sampleEvenly(
  	        points.map(function (_, index) {
  	          return index;
  	        }),
  	        Math.max(
  	          2,
  	          maxPoints -
  	          mandatory.size
  	        )
  	      );

  	    evenly.forEach(function (index) {
  	      mandatory.add(index);
  	    });

  	    return Array.from(mandatory)
  	      .sort(function (a, b) {
  	        return a - b;
  	      })
  	      .slice(0, maxPoints)
  	      .map(function (index) {
  	        return points[index];
  	      });
  	  }

  	  function renderHistoryRoute(history) {
  	    clearHistoryLayers();

  	    const messages =
  	      history &&
  	      Array.isArray(history.messages)
  	        ? history.messages
  	        : [];

  	    state.historyEvents =
  	      history &&
  	      history.events &&
  	      typeof history.events === "object"
  	        ? history.events
  	        : {};

  	    const allPoints =
  	      messages
  	        .map(historyPoint)
  	        .filter(Boolean);

  	    state.historyPoints =
  	      allPoints;

  	    const displayPoints =
  	      sampleHistoryPoints(
  	        allPoints,
  	        MAX_ROUTE_POINTS
  	      );

  	    state.replayPoints =
  	      sampleEvenly(
  	        allPoints,
  	        MAX_REPLAY_POINTS
  	      );

  	    if (!allPoints.length) {
  	      renderSummaryCard();
  	      toast(
  	        "No GPS points were returned for this interval."
  	      );
  	      return;
  	    }

  	    const segments =
  	      historyRouteSegments(
  	        displayPoints
  	      );

  	    segments.forEach(
  	      function (segment) {
  	        const path =
  	          segment.points.map(
  	            function (point) {
  	              return {
  	                lat: point.lat,
  	                lng: point.lng
  	              };
  	            }
  	          );

  	        const outline =
  	          new state.maps.Polyline({
  	            map: state.map,
  	            path: path,
  	            geodesic: true,
  	            strokeColor: "#090b0a",
  	            strokeOpacity: 0.82,
  	            strokeWeight: 13,
  	            clickable: false,
  	            zIndex: 300
  	          });

  	        const route =
  	          new state.maps.Polyline({
  	            map: state.map,
  	            path: path,
  	            geodesic: true,
  	            strokeColor:
  	              segment.color,
  	            strokeOpacity: 0.90,
  	            strokeWeight: 10,
  	            clickable: false,
  	            zIndex: 310
  	          });

  	        const arrows =
  	          new state.maps.Polyline({
  	            map: state.map,
  	            path: path,
  	            geodesic: true,
  	            strokeOpacity: 0,
  	            strokeWeight: 10,
  	            clickable: false,
  	            icons: [{
  	              icon:
  	                routeChevronIcon(
  	                  segment.color
  	                ),
  	              offset: "0px",
  	              repeat: "22px"
  	            }],
  	            zIndex: 311
  	          });

  	        const hitRoute =
  	          new state.maps.Polyline({
  	            map: state.map,
  	            path: path,
  	            geodesic: true,
  	            strokeColor: "#ffffff",
  	            strokeOpacity: 0.01,
  	            strokeWeight: 28,
  	            clickable: true,
  	            zIndex: 312
  	          });

  	        hitRoute.addListener(
  	          "click",
  	          function (event) {
  	            const point =
  	              nearestHistoricalPoint(
  	                event && event.latLng,
  	                segment.points
  	              );

  	            if (point) {
  	              showHistoricalPointData(
  	                point
  	              );
  	            }
  	          }
  	        );

  	        state.historyLayers.push(
  	          outline,
  	          route,
  	          arrows,
  	          hitRoute
  	        );
  	      }
  	    );

  	    const first =
  	      allPoints[0];
  	    const last =
  	      allPoints[
  	        allPoints.length - 1
  	      ];

  	    historyMarker(
  	      first,
  	      "#00cc44",
  	      "START",
  	      1.5,
  	      1001,
  	      "Start",
  	      [
  	        "Time: " +
  	        formatLocalTime(
  	          first.timestamp
  	        )
  	      ]
  	    );

  	    if (allPoints.length > 1) {
  	      historyMarker(
  	        last,
  	        "#cc0000",
  	        "END",
  	        1.5,
  	        1001,
  	        "End",
  	        [
  	          "Time: " +
  	          formatLocalTime(
  	            last.timestamp
  	          )
  	        ]
  	      );
  	    }

  	    const idleEvents =
  	      arr(
  	        state.historyEvents[
  	          "Idle Event"
  	        ]
  	      );
  	    const idleWindows =
  	      idleEvents
  	        .map(historyEventWindow)
  	        .filter(Boolean);

  	    const idleSeen = [];

  	    idleEvents.forEach(
  	      function (segment) {
  	        const point =
  	          eventSegmentPoint(
  	            segment,
  	            allPoints
  	          );
  	        const win =
  	          historyEventWindow(
  	            segment
  	          );

  	        if (!point || !win) return;

  	        const duplicate =
  	          idleSeen.some(
  	            function (existing) {
  	              const sameStart =
  	                Math.abs(
  	                  existing.win.startMs -
  	                  win.startMs
  	                ) <= 2000;
  	              const close =
  	                haversineKm(
  	                  existing.point,
  	                  point
  	                ) * 1000 <= 30;

  	              return sameStart && close;
  	            }
  	          );

  	        if (duplicate) return;

  	        idleSeen.push({
  	          point: point,
  	          win: win
  	        });

  	        historyMarker(
  	          point,
  	          "#ffcc00",
  	          "",
  	          1.5,
  	          999,
  	          "Idle Event",
  	          [
  	            "Start: " +
  	            formatLocalTime(
  	              win.startMs / 1000
  	            ),
  	            "Idle: " +
  	            formatClock(
  	              num(
  	                segment.idle_seconds
  	              ) ||
  	              Math.max(
  	                0,
  	                (
  	                  win.endMs -
  	                  win.startMs
  	                ) / 1000
  	              )
  	            )
  	          ]
  	        );
  	      }
  	    );

  	    const stops =
  	      buildHistoryStopSegments(
  	        allPoints,
  	        idleWindows
  	      );

  	    stops.forEach(
  	      function (segment) {
  	        const point =
  	          segment.points[0];
  	        if (!point) return;

  	        historyMarker(
  	          point,
  	          "#cc0000",
  	          "",
  	          1.25,
  	          998,
  	          "Stopped",
  	          [
  	            "Stopped Time: " +
  	            formatLocalTime(
  	              point.timestamp
  	            ),
  	            "Duration: " +
  	            formatClock(
  	              historyStopDuration(
  	                segment
  	              )
  	            )
  	          ]
  	        );
  	      }
  	    );

  	    const gainEvents =
  	      arr(
  	        state.historyEvents[
  	          "Fuel Gain (Refuel)"
  	        ]
  	      ).length
  	        ? arr(
  	            state.historyEvents[
  	              "Fuel Gain (Refuel)"
  	            ]
  	          )
  	        : arr(
  	            state.historyEvents[
  	              "Fuel Gain"
  	            ]
  	          );

  	    addHistoryFuelMarkers(
  	      gainEvents,
  	      allPoints,
  	      true
  	    );
  	    addHistoryFuelMarkers(
  	      arr(
  	        state.historyEvents[
  	          "Fuel Loss"
  	        ]
  	      ),
  	      allPoints,
  	      false
  	    );

  	    const firstTs =
  	      first.timestamp || 0;
  	    const lastTs =
  	      last.timestamp || firstTs;
  	    const maxSpeed =
  	      allPoints.reduce(
  	        function (max, point) {
  	          return Math.max(
  	            max,
  	            point.speed || 0
  	          );
  	        },
  	        0
  	      );

  	    state.routeSummary = {
  	      distanceKm:
  	        routeDistanceKm(
  	          allPoints
  	        ),
  	      durationSec:
  	        Math.max(
  	          0,
  	          lastTs - firstTs
  	        ),
  	      maxSpeed: maxSpeed,
  	      points: allPoints.length
  	    };

  	    state.replayIndex =
  	      Math.max(
  	        0,
  	        state.replayPoints.length - 1
  	      );

  	    renderSummaryCard();
  	    updateReplayUi();
  	    placeReplayMarker(
  	      state.replayIndex,
  	      false
  	    );
  	    fitRoute();
  	  }

  	  function fitRoute() {
  	    if (!state.map || !state.historyPoints.length) return;

  	    const bounds = new state.maps.LatLngBounds();
  	    state.historyPoints.forEach(function (point) {
  	      bounds.extend({ lat: point.lat, lng: point.lng });
  	    });

  	    if (state.historyPoints.length === 1) {
  	      state.map.setCenter(bounds.getCenter());
  	      state.map.setZoom(17);
  	    } else {
  	      state.map.fitBounds(bounds, {
  	        top: 90,
  	        right: 35,
  	        bottom: 310,
  	        left: 35
  	      });
  	    }
  	  }

  	  function replayIcon() {
  	    return state.replayTimer ? icon("pause") : icon("play");
  	  }

  	  function updateReplayUi() {
  	    const slider = el("[data-replay-slider]");
  	    const button = el('[data-action="replay"]');
  	    const time = el("[data-replay-time]");
  	    const speed = el("[data-replay-speed]");

  	    const max = Math.max(0, state.replayPoints.length - 1);
  	    state.replayIndex = clamp(state.replayIndex, 0, max);

  	    if (slider) {
  	      slider.max = String(max);
  	      slider.value = String(state.replayIndex);
  	      slider.disabled = state.replayPoints.length < 2;
  	    }

  	    if (button) {
  	      button.innerHTML = replayIcon();
  	      button.disabled = state.replayPoints.length < 2;
  	    }

  	    const point = state.replayPoints[state.replayIndex];

  	    if (time) {
  	      time.textContent = point
  	        ? formatLocalTime(point.timestamp)
  	        : "—";
  	    }

  	    if (speed) {
  	      speed.textContent = point
  	        ? formatNumber(point.speed, 0) + " km/h"
  	        : "—";
  	    }
  	  }

  	  function replayMarkerSymbol(point) {
  	    const vehicle =
  	      selectedVehicle();

  	    const replayMessage =
  	      point && point.raw
  	        ? point.raw
  	        : {
  	            "position.direction":
  	              point
  	                ? point.heading
  	                : 0,
  	            "position.speed":
  	              point
  	                ? point.speed
  	                : 0
  	          };

  	    return liveMarkerIcon(
  	      vehicle || {
  	        color: "#d46d34"
  	      },
  	      replayMessage,
  	      true
  	    );
  	  }

  	  function placeReplayMarker(index, pan) {
  	    const point = state.replayPoints[index];
  	    if (!point || !state.map) return;

  	    if (!state.replayMarker) {
  	      state.replayMarker = new state.maps.Marker({
  	        map: state.map,
  	        position: point,
  	        icon: replayMarkerSymbol(point),
  	        zIndex: 980
  	      });
  	    } else {
  	      state.replayMarker.setPosition(point);
  	      state.replayMarker.setIcon(replayMarkerSymbol(point));
  	      state.replayMarker.setMap(state.map);
  	    }

  	    state.replayIndex = index;
  	    updateReplayUi();

  	    if (pan) state.map.panTo(point);
  	  }

  	  function toggleReplay() {
  	    if (state.replayPoints.length < 2) return;

  	    if (state.replayTimer) {
  	      clearInterval(state.replayTimer);
  	      state.replayTimer = null;
  	      updateReplayUi();
  	      return;
  	    }

  	    if (state.replayIndex >= state.replayPoints.length - 1) {
  	      state.replayIndex = 0;
  	      placeReplayMarker(0, true);
  	    }

  	    state.replayTimer = setInterval(function () {
  	      if (
  	        state.destroyed ||
  	        state.mode !== "history" ||
  	        state.replayIndex >= state.replayPoints.length - 1
  	      ) {
  	        clearInterval(state.replayTimer);
  	        state.replayTimer = null;
  	        updateReplayUi();
  	        return;
  	      }

  	      placeReplayMarker(state.replayIndex + 1, true);
  	    }, 260);

  	    updateReplayUi();
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Live refresh
  	  // ---------------------------------------------------------------------------
  	  function applyLatestMessages(messages) {
  	    arr(messages).forEach(function (message) {
  	      const deviceId = clean(
  	        firstValue([
  	          getPath(message, "device.id", ""),
  	          getPath(message, "deviceId", ""),
  	          getPath(message, "id", "")
  	        ], "")
  	      );

  	      const vehicle = vehicleByTracker(deviceId);
  	      if (!vehicle) return;

  	      const previous = state.liveByKey[vehicle.key];
  	      const previousTs = previous ? timestampSeconds(previous) : null;
  	      const nextTs = timestampSeconds(message);

  	      if (
  	        previous &&
  	        previousTs !== null &&
  	        nextTs !== null &&
  	        nextTs < previousTs
  	      ) {
  	        return;
  	      }

  	      state.liveByKey[vehicle.key] = message;

  	      if (messageShowsMovement(message)) {
  	        const movedAt = timestampSeconds(message);
  	        if (movedAt !== null) {
  	          state.lastMovedByKey[vehicle.key] = movedAt;
  	          state.lastMovedResolvedByKey[vehicle.key] = true;
  	        }
  	      }

  	      /*
  	       * Preserve the same AppData tractor objects used elsewhere in FIF.
  	       * This gives other mobile components immediate access to the fresh
  	       * latest location without requiring an App refresh.
  	       */
  	      try {
  	        vehicle.tractor.Location = message;
  	      } catch (_) {}
  	    });
  	  }

  	  function scheduleNextLive() {
  	    if (state.destroyed || state.mode !== "live") return;

  	    if (state.liveTimer) clearTimeout(state.liveTimer);

  	    state.nextLiveAt = Date.now() + LIVE_REFRESH_MS;
  	    updateCountdown();

  	    state.liveTimer = setTimeout(function () {
  	      refreshLive(false);
  	    }, LIVE_REFRESH_MS);
  	  }

  	  async function refreshLive(manual) {
  	    if (
  	      state.destroyed ||
  	      state.mode !== "live" ||
  	      state.liveBusy
  	    ) {
  	      return false;
  	    }

  	    state.liveBusy = true;
  	    setError("");
  	    updateCountdown();

  	    if (manual) showLoading(true, "Refreshing live positions…");

  	    try {
  	      loadVehicleDirectory();
  	      updateVehicleSelect();

  	      const messages = await fetchLatest();
  	      applyLatestMessages(messages);

  	      // Live status is now known. Rebuild the visual selector so currently
  	      // moving vehicles rise to the top, moving dots are green, and the same
  	      // warning state used by the red map ring turns the right-hand dot RED.
  	      updateVehicleSelect();

  	      state.lastLiveSuccessAt = Date.now();

  	      const firstFleetFit = !state.fitDone;
  	      updateLiveMarkers(firstFleetFit);

  	      if (manual && !firstFleetFit) {
  	        fitVisibleLive();
  	      }

  	      renderSummaryCard();
  	      resolveSelectedLastMoved();

  	      if (manual) toast("Live positions updated.");
  	      return true;
  	    } catch (error) {
  	      const message = clean(error && error.message) || "Live tracking could not be refreshed.";
  	      setError(message);
  	      return false;
  	    } finally {
  	      state.liveBusy = false;
  	      showLoading(false);
  	      scheduleNextLive();
  	      updateCountdown();
  	    }
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Historical tracking
  	  // ---------------------------------------------------------------------------
  	  function setModeButtons() {
  	    root.classList.toggle(
  	      "history",
  	      state.mode === "history"
  	    );
  	    root.classList.toggle(
  	      "live",
  	      state.mode === "live"
  	    );

  	    const liveButton =
  	      root.querySelector(
  	        '[data-mode="live"]'
  	      );
  	    if (liveButton) {
  	      liveButton.classList.toggle(
  	        "active",
  	        state.mode === "live"
  	      );
  	    }

  	    const historySelect =
  	      root.querySelector(
  	        "[data-history-select]"
  	      );
  	    if (historySelect) {
  	      historySelect.value =
  	        state.mode === "history"
  	          ? String(state.historyMinutes)
  	          : "";
  	    }

  	    Object.keys(
  	      state.markerByKey
  	    ).forEach(function (key) {
  	      const marker =
  	        state.markerByKey[key];
  	      if (marker) {
  	        marker.setVisible(
  	          state.mode === "live"
  	        );
  	      }
  	    });

  	    Object.keys(
  	      state.pulseMarkerByKey
  	    ).forEach(function (key) {
  	      const pulse =
  	        state.pulseMarkerByKey[key];
  	      if (pulse) {
  	        pulse.setVisible(
  	          state.mode === "live"
  	        );
  	      }
  	    });

  	    if (state.mode === "live") {
  	      ensureLivePulseAnimation();
  	    }

  	    updateCountdown();
  	  }

  	  function stopLiveSchedule() {
  	    if (state.liveTimer) {
  	      clearTimeout(state.liveTimer);
  	      state.liveTimer = null;
  	    }
  	    state.nextLiveAt = 0;
  	    updateCountdown();
  	  }

  	  async function loadHistory(minutes) {
  	    if (state.destroyed || state.historyBusy) return false;

  	    const vehicle = selectedVehicle();
  	    if (!vehicle) {
  	      toast("No tracked vehicle is available.");
  	      return false;
  	    }

  	    state.mode = "history";
  	    state.historyMinutes = Number(minutes) || 60;
  	    state.historyBusy = true;
  	    const requestId = ++state.historyRequestId;

  	    stopLiveSchedule();
  	    setModeButtons();
  	    setError("");
  	    showLoading(
  	      true,
  	      "Loading " +
  	        (state.historyMinutes < 60
  	          ? state.historyMinutes + " minute"
  	          : state.historyMinutes / 60 + " hour") +
  	        " track…"
  	    );

  	    try {
  	      const history = await fetchHistory(
  	        vehicle,
  	        state.historyMinutes
  	      );

  	      if (
  	        state.destroyed ||
  	        requestId !== state.historyRequestId
  	      ) {
  	        return false;
  	      }

  	      renderHistoryRoute(history);
  	      toast(
  	        history &&
  	        Array.isArray(history.messages) &&
  	        history.messages.length
  	          ? "Historical track loaded."
  	          : "No route points found in this interval."
  	      );
  	      return true;
  	    } catch (error) {
  	      if (requestId === state.historyRequestId) {
  	        clearHistoryLayers();
  	        setError(
  	          clean(error && error.message) ||
  	            "Historical track could not be loaded."
  	        );
  	        renderSummaryCard();
  	      }
  	      return false;
  	    } finally {
  	      if (requestId === state.historyRequestId) {
  	        state.historyBusy = false;
  	        showLoading(false);
  	        updateCountdown();
  	      }
  	    }
  	  }

  	  async function switchToLive() {
  	    state.historyRequestId += 1;
  	    state.historyBusy = false;
  	    state.mode = "live";
  	    clearHistoryLayers();
  	    setModeButtons();
  	    setError("");
  	    updateLiveMarkers(false);
  	    renderSummaryCard();
  	    await refreshLive(true);
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Permission-aware application switcher
  	  // ---------------------------------------------------------------------------
  	  const APPLICATION_PAGES = Object.freeze({
  	    FIFM: "FIFM",
  	    Office: "Office",
  	    Road: "Road",
  	    Bowser: "Bowser",
  	    "Mobile Tracking": "MobileTracking",
  	    Snapshot: "Snapshot"
  	  });

  	  function normaliseApplicationName(value) {
  	    const name = clean(value);

  	    switch (lower(name)) {
  	      case "fifm":
  	        return "FIFM";
  	      case "office":
  	        return "Office";
  	      case "road":
  	        return "Road";
  	      case "bowser":
  	        return "Bowser";
  	      case "mobiletracking":
  	      case "mobile tracking":
  	        return "Mobile Tracking";
  	      case "snapshot":
  	        return "Snapshot";
  	      default:
  	        return name;
  	    }
  	  }

  	  function allowedApplicationsFor(user) {
  	    const raw = Array.isArray(user && user.APP)
  	      ? user.APP
  	      : clean(user && user.APP).split(",");

  	    const allowed = raw
  	      .map(normaliseApplicationName)
  	      .filter(function (name) {
  	        return !!APPLICATION_PAGES[name];
  	      });

  	    if (lower(user && user.Office).indexOf("livetrack") !== -1) {
  	      allowed.push("Mobile Tracking");
  	    }

  	    if (lower(user && user.Settings).indexOf("overview") !== -1) {
  	      allowed.push("Snapshot");
  	    }

  	    return allowed.filter(function (name, index, list) {
  	      return list.indexOf(name) === index;
  	    });
  	  }

  	  async function resolveAppMenuUser() {
  	    const data = appBag();
  	    let user = data && data.User ? data.User : null;

  	    if (
  	      !user &&
  	      typeof Backendless !== "undefined" &&
  	      Backendless.UserService &&
  	      typeof Backendless.UserService.getCurrentUser === "function"
  	    ) {
  	      user = await Backendless.UserService.getCurrentUser(true);
  	    }

  	    if (user && data && typeof data === "object") {
  	      data.User = user;
  	    }

  	    return user;
  	  }

  	  function setAppMenuOpen(open) {
  	    const menu = el("[data-app-menu]");
  	    const button = el('[data-action="logout"]');

  	    state.appMenuOpen = !!open;

  	    if (menu) menu.hidden = !state.appMenuOpen;
  	    if (button) {
  	      button.setAttribute(
  	        "aria-expanded",
  	        state.appMenuOpen ? "true" : "false"
  	      );
  	    }

  	    if (state.appMenuOpen && menu) {
  	      setTimeout(function () {
  	        const first = menu.querySelector(".fmt-app-option");
  	        if (first && typeof first.focus === "function") first.focus();
  	      }, 0);
  	    }
  	  }

  	  function setAppMenuStatus(message, isError) {
  	    const status = el("[data-app-menu-status]");
  	    if (!status) return;

  	    const text = clean(message);
  	    status.textContent = text;
  	    status.classList.toggle("visible", !!text);
  	    status.style.color = isError ? "#ff5b45" : "#ff8a3d";
  	  }

  	  function renderAppMenu(applications) {
  	    const menu = el("[data-app-menu]");
  	    if (!menu) return;

  	    menu.innerHTML = "";

  	    applications.forEach(function (name) {
  	      const option = document.createElement("button");
  	      option.type = "button";
  	      option.className = "fmt-app-option";
  	      option.setAttribute("role", "menuitem");
  	      option.setAttribute("data-switch-app", name);
  	      option.textContent = name;
  	      menu.appendChild(option);
  	    });

  	    const logout = document.createElement("button");
  	    logout.type = "button";
  	    logout.className = "fmt-app-option logout";
  	    logout.setAttribute("role", "menuitem");
  	    logout.setAttribute("data-app-menu-logout", "true");
  	    logout.textContent = "Log Out";
  	    menu.appendChild(logout);

  	    const status = document.createElement("div");
  	    status.className = "fmt-app-status";
  	    status.setAttribute("data-app-menu-status", "");
  	    menu.appendChild(status);
  	  }

  	  function readLocalJSON(key) {
  	    try {
  	      return JSON.parse(localStorage.getItem(key));
  	    } catch (_) {
  	      return null;
  	    }
  	  }

  	  function generateShortUUID() {
  	    try {
  	      if (
  	        globalThis.crypto &&
  	        typeof globalThis.crypto.randomUUID === "function"
  	      ) {
  	        return globalThis.crypto
  	          .randomUUID()
  	          .replace(/-/g, "")
  	          .slice(0, 8);
  	      }
  	    } catch (_) {}

  	    return Math.random().toString(16).slice(2, 10);
  	  }

  	  async function prepareOfficeApplication(user) {
  	    const localKey = clean(user && user.Local_Key);

  	    if (!localKey) {
  	      throw new Error("The user does not have a Local_Key.");
  	    }

  	    const stored = readLocalJSON(localKey);

  	    if (stored === null) {
  	      localStorage.setItem(
  	        localKey,
  	        JSON.stringify({
  	          "Lets See this Work": generateShortUUID()
  	        })
  	      );
  	    }

  	    /*
  	     * Do not run fn_2cdb14e20aec99596e5725c4e3064843 here.
  	     *
  	     * That loader belongs to the Office page lifecycle and can remain active
  	     * after its first run. Awaiting it from the outgoing Mobile Tracking page
  	     * makes the first return to Office work, but can block every later return.
  	     * Office receives the existing AppData/User object and performs its own
  	     * normal initialisation after navigation.
  	     */
  	    return true;
  	  }

  	  async function navigateToApplicationPage(pageName, applicationName) {
  	    /*
  	     * Keep the current Backendless AppData/User object alive so Office can read
  	     * User.Home and User.Office while mounting. Office also expects APP to name
  	     * the destination application; leaving it as "Mobile Tracking" can make the
  	     * Office lifecycle reject the mount and send the user to Login.
  	     *
  	     * This is only a state assignment. The old fn_302... selector/router is not
  	     * called, and Navigator.goToPage is still invoked exactly once.
  	     */
  	    if (
  	      typeof BackendlessUI === "undefined" ||
  	      !BackendlessUI.Navigator ||
  	      typeof BackendlessUI.Navigator.goToPage !== "function"
  	    ) {
  	      throw new Error("Application navigation is unavailable.");
  	    }

  	    let sessionValid = true;

  	    try {
  	      if (
  	        typeof Backendless !== "undefined" &&
  	        Backendless.UserService &&
  	        typeof Backendless.UserService.isValidLogin === "function"
  	      ) {
  	        sessionValid = !!(await Backendless.UserService.isValidLogin());
  	      }
  	    } catch (_) {
  	      sessionValid = false;
  	    }

  	    console.info("[App Switcher Navigation]", {
  	      version: VERSION,
  	      targetApp: applicationName,
  	      targetPage: pageName,
  	      sessionValid: sessionValid,
  	      logoutGuardActive: !!installLogoutGuard()
  	    });

  	    if (!sessionValid) {
  	      throw new Error("Your session has ended. Please log in again.");
  	    }

  	    const data = appBag();
  	    if (data && typeof data === "object") {
  	      data.APP = applicationName;
  	    }

  	    /*
  	     * Remove the menu and document listeners created by the shared Office
  	     * logout button before leaving Mobile Tracking. This makes repeated
  	     * Office <-> Mobile cycles deterministic even when Backendless keeps an
  	     * outgoing page mounted briefly.
  	     */
  	    try {
  	      const sharedRuntime = window.__FIF_SHARED_APP_SWITCHER_V2__;
  	      if (sharedRuntime && typeof sharedRuntime.cleanup === "function") {
  	        sharedRuntime.cleanup();
  	      }
  	      delete window.__FIF_SHARED_APP_SWITCHER_V2__;
  	    } catch (_) {}

  	    await Promise.resolve(
  	      BackendlessUI.Navigator.goToPage(pageName, undefined)
  	    );

  	    return true;
  	  }

  	  async function switchApplication(appName) {
  	    const user = state.appMenuUser || (await resolveAppMenuUser());
  	    const target = normaliseApplicationName(appName);
  	    const allowed = allowedApplicationsFor(user);

  	    if (!user || allowed.indexOf(target) === -1) {
  	      setAppMenuStatus(
  	        "You do not have permission to open this application.",
  	        true
  	      );
  	      return false;
  	    }

  	    if (!APPLICATION_PAGES[target]) {
  	      setAppMenuStatus("The selected application is unavailable.", true);
  	      return false;
  	    }

  	    setAppMenuStatus("Opening " + target + "…", false);
  	    stopLiveSchedule();

  	    if (state.replayTimer) {
  	      clearInterval(state.replayTimer);
  	      state.replayTimer = null;
  	    }

  	    try {
  	      if (target === "Office") {
  	        await prepareOfficeApplication(user);
  	      }

  	      await navigateToApplicationPage(
  	        APPLICATION_PAGES[target],
  	        target
  	      );

  	      setTimeout(function () {
  	        try {
  	          if (document.getElementById(ROOT_ID)) destroy();
  	        } catch (_) {}
  	      }, 500);

  	      return true;
  	    } catch (error) {
  	      showLoading(false);
  	      scheduleNextLive();
  	      setAppMenuStatus(
  	        clean(error && error.message) ||
  	          "The selected application could not be opened.",
  	        true
  	      );
  	      return false;
  	    }
  	  }

  	  async function handleLogoutButton() {
  	    if (state.appMenuOpen) {
  	      setAppMenuOpen(false);
  	      return;
  	    }

  	    try {
  	      const user = await resolveAppMenuUser();
  	      const otherApplications = allowedApplicationsFor(user).filter(
  	        function (name) {
  	          return name !== "Mobile Tracking";
  	        }
  	      );

  	      /* No other application privileges: perform a normal logout. */
  	      if (!user || !otherApplications.length) {
  	        await logoutUser();
  	        return;
  	      }

  	      state.appMenuUser = user;
  	      renderAppMenu(otherApplications);
  	      setAppMenuOpen(true);
  	    } catch (error) {
  	      setAppMenuOpen(false);
  	      setError(
  	        clean(error && error.message) ||
  	          "The application menu could not be opened."
  	      );
  	    }
  	  }

  	  async function logoutUser() {
  	    if (
  	      typeof Backendless === "undefined" ||
  	      !Backendless.UserService ||
  	      typeof Backendless.UserService.logout !== "function"
  	    ) {
  	      throw new Error(
  	        "Backendless logout is unavailable on this page."
  	      );
  	    }

  	    if (
  	      typeof BackendlessUI === "undefined" ||
  	      !BackendlessUI.Navigator ||
  	      typeof BackendlessUI.Navigator.goToPage !== "function"
  	    ) {
  	      throw new Error(
  	        "The Fleet In Form Login navigator is unavailable."
  	      );
  	    }

  	    setAppMenuOpen(false);
  	    showLoading(true, "Logging out…");
  	    stopLiveSchedule();

  	    if (state.replayTimer) {
  	      clearInterval(state.replayTimer);
  	      state.replayTimer = null;
  	    }

  	    try {
  	      const data = appBag();
  	      if (data && typeof data === "object") data.APP = null;

  	      const activeGuard = installLogoutGuard() || logoutGuard;

  	      if (
  	        activeGuard &&
  	        typeof activeGuard.explicitLogout === "function"
  	      ) {
  	        await activeGuard.explicitLogout();
  	      } else {
  	        await Backendless.UserService.logout();
  	      }

  	      /*
  	       * Fleet In Form mobile logout contract:
  	       * destroy the Backendless session, then return to Login.
  	       */
  	      await Promise.resolve(
  	        BackendlessUI.Navigator.goToPage(
  	          "Login",
  	          undefined
  	        )
  	      );

  	      /*
  	       * Navigation normally destroys the page for us. This is only a cleanup
  	       * fallback when the UI Builder keeps the old page mounted briefly.
  	       */
  	      setTimeout(function () {
  	        try {
  	          if (document.getElementById(ROOT_ID)) destroy();
  	        } catch (_) {}
  	      }, 500);

  	      return true;
  	    } catch (error) {
  	      showLoading(false);
  	      scheduleNextLive();
  	      setError(
  	        clean(error && error.message) ||
  	          "Logout could not be completed."
  	      );
  	      return false;
  	    }
  	  }

  	  // ---------------------------------------------------------------------------
  	  // Events
  	  // ---------------------------------------------------------------------------
  	  root.addEventListener("click", function (event) {
  	    const appOption =
  	      event.target.closest("[data-switch-app]");
  	    const appMenuLogout =
  	      event.target.closest("[data-app-menu-logout]");
  	    const pickerButton =
  	      event.target.closest("[data-vehicle-picker-button]");
  	    const pickerOption =
  	      event.target.closest("[data-vehicle-picker-key]");
  	    const pickerClose =
  	      event.target.closest("[data-vehicle-picker-close]");
  	    const pickerWrap =
  	      event.target.closest("[data-vehicle-picker]");
  	    const pickerMenu =
  	      event.target.closest("[data-vehicle-picker-menu]");

  	    if (appOption) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      const target = clean(
  	        appOption.getAttribute("data-switch-app")
  	      );

  	      appOption.disabled = true;
  	      switchApplication(target).then(function (opened) {
  	        if (!opened && appOption.isConnected) {
  	          appOption.disabled = false;
  	        }
  	      });
  	      return;
  	    }

  	    if (appMenuLogout) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      appMenuLogout.disabled = true;
  	      logoutUser();
  	      return;
  	    }

  	    if (pickerClose) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      setVehiclePickerOpen(false);
  	      return;
  	    }

  	    if (pickerButton) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      setVehiclePickerOpen(!state.vehiclePickerOpen);
  	      return;
  	    }

  	    if (pickerOption) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      const key =
  	        clean(pickerOption.getAttribute("data-vehicle-picker-key"));
  	      const select = el("[data-vehicle-select]");

  	      if (select && key) {
  	        select.value = key;
  	        setVehiclePickerOpen(false);
  	        select.dispatchEvent(
  	          new Event("change", { bubbles: true })
  	        );
  	      }

  	      return;
  	    }

  	    if (state.vehiclePickerOpen) {
  	      if (pickerMenu) {
  	        // A click on empty full-screen menu space closes it. Header/rows have
  	        // their own handlers above.
  	        if (
  	          event.target === pickerMenu ||
  	          event.target.closest(".fmt-vehicle-picker-header-copy")
  	        ) {
  	          setVehiclePickerOpen(false);
  	          return;
  	        }
  	      } else if (!pickerWrap) {
  	        setVehiclePickerOpen(false);
  	      }
  	    }

  	    const button = event.target.closest("button");
  	    if (!button) return;

  	    const action = clean(button.getAttribute("data-action"));
  	    const mode = clean(button.getAttribute("data-mode"));

  	    if (mode === "live") {
  	      switchToLive();
  	      return;
  	    }

  	    if (action === "logout") {
  	      handleLogoutButton();
  	      return;
  	    }

  	    if (action === "replay") {
  	      toggleReplay();
  	    }
  	  });

  	  state.appMenuOutsideHandler = function (event) {
  	    if (!state.appMenuOpen) return;

  	    const target = event && event.target;
  	    const wrap = el("[data-app-menu-wrap]");

  	    if (wrap && target && wrap.contains(target)) return;
  	    setAppMenuOpen(false);
  	  };

  	  state.appMenuKeyHandler = function (event) {
  	    if (!state.appMenuOpen) return;
  	    if (event && event.key === "Escape") setAppMenuOpen(false);
  	  };

  	  document.addEventListener(
  	    "pointerdown",
  	    state.appMenuOutsideHandler,
  	    true
  	  );

  	  document.addEventListener(
  	    "keydown",
  	    state.appMenuKeyHandler,
  	    true
  	  );

  	  const historySelect =
  	    el("[data-history-select]");

  	  if (historySelect) {
  	    historySelect.addEventListener(
  	      "change",
  	      function () {
  	        const minutes =
  	          Number(
  	            historySelect.value || 0
  	          );

  	        if (minutes > 0) {
  	          loadHistory(minutes);
  	        } else if (
  	          state.mode === "history"
  	        ) {
  	          switchToLive();
  	        }
  	      }
  	    );
  	  }

  	  const vehicleSelect = el("[data-vehicle-select]");
  	  if (vehicleSelect) {
  	    vehicleSelect.addEventListener("change", function () {
  	      state.selectedKey = clean(vehicleSelect.value);
  	      setVehiclePickerOpen(false);
  	      renderVehiclePicker();
  	      refreshMarkerStyles();
  	      renderSummaryCard();
  	      resolveSelectedLastMoved();

  	      if (state.mode === "history") {
  	        loadHistory(state.historyMinutes);
  	        return;
  	      }

  	      const vehicle = selectedVehicle();
  	      const message =
  	        vehicle && state.liveByKey[vehicle.key];
  	      const point = message && validPoint(message);

  	      if (point && state.map) {
  	        state.map.panTo(point);
  	        if (state.map.getZoom() < 14) state.map.setZoom(14);
  	      }
  	    });
  	  }

  	  const replaySlider = el("[data-replay-slider]");
  	  if (replaySlider) {
  	    replaySlider.addEventListener("input", function () {
  	      if (state.replayTimer) {
  	        clearInterval(state.replayTimer);
  	        state.replayTimer = null;
  	      }

  	      placeReplayMarker(Number(replaySlider.value || 0), false);
  	    });
  	  }

  	  state.visibilityHandler = function () {
  	    if (
  	      document.visibilityState === "visible" &&
  	      state.mode === "live" &&
  	      !state.liveBusy &&
  	      (!state.nextLiveAt || Date.now() >= state.nextLiveAt)
  	    ) {
  	      refreshLive(false);
  	    }
  	  };

  	  document.addEventListener(
  	    "visibilitychange",
  	    state.visibilityHandler
  	  );

  	  state.pageHideHandler = function () {
  	    if (state.liveTimer) {
  	      clearTimeout(state.liveTimer);
  	      state.liveTimer = null;
  	    }
  	  };

  	  window.addEventListener("pagehide", state.pageHideHandler);

  	  state.countdownTimer = setInterval(updateCountdown, 1000);

  	  // ---------------------------------------------------------------------------
  	  // Boot
  	  // ---------------------------------------------------------------------------
  	  loadVehicleDirectory();
  	  updateVehicleSelect();
  	  renderSummaryCard();

  	  showLoading(true, "Starting Mobile Tracking…");

  	  try {
  	    if (MAP) {
  	      showLoading(true, "Connecting to Google Maps…");

  	      /*
  	       * The passed Backendless Map is deliberately NOT reused as the visible
  	       * tracking map. Its job is to make Backendless load Google Maps and give
  	       * us a reliable readiness signal. Reusing its DOM can be clipped by the
  	       * UI Builder's parent stacking contexts, which is exactly what produced
  	       * the black map area in V1.0.3.
  	       */
  	      const passedMap =
  	        await mobileTrackingResolvePassedMap(MAP);

  	      if (
  	        passedMap &&
  	        passedMap.maps &&
  	        typeof passedMap.maps.Map === "function"
  	      ) {
  	        state.maps = passedMap.maps;
  	      } else if (
  	        typeof window !== "undefined" &&
  	        window.google &&
  	        window.google.maps &&
  	        typeof window.google.maps.Map === "function"
  	      ) {
  	        state.maps = window.google.maps;
  	      } else {
  	        throw new Error(
  	          "The Backendless Map component did not make Google Maps ready."
  	        );
  	      }

  	      state.usingPassedMap = false;
  	      initOwnedMobileMap();
  	      installOldTrackitMapControl(state.map);
  	    } else {
  	      /*
  	       * Compatibility fallback when MAP is not wired.
  	       */
  	      const maps =
  	        await mobileTrackingEnsureGoogleMaps();

  	      if (!maps || typeof maps.Map !== "function") {
  	        throw new Error(
  	          "Google Maps loaded without the Maps JavaScript API."
  	        );
  	      }

  	      state.maps = maps;
  	      state.usingPassedMap = false;
  	      initOwnedMobileMap();
  	      installOldTrackitMapControl(state.map);
  	    }

  	    if (!state.vehicles.length) {
  	      showLoading(false);
  	      setError(
  	        "No tracked Tractors were found in AppData.User.Companies."
  	      );
  	      return window[RUNTIME_KEY];
  	    }

  	    await refreshLive(false);
  	    showLoading(false);
  	  } catch (error) {
  	    showLoading(false);
  	    setError(
  	      clean(error && error.message) ||
  	        "Mobile Tracking could not start."
  	    );
  	  }

  	  return window[RUNTIME_KEY];
  	})(App, SVG, MAP);

  })(App, 'data:image/png;base64,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', MAP);

}

})
define('./functions/a868a6a4f6678dfcdaf2fbd8ee89f031/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a868a6a4f6678dfcdaf2fbd8ee89f031'] = async function fn_a868a6a4f6678dfcdaf2fbd8ee89f031(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAll(array, values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/ab413a982236a49bcc125023ef64d39b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ab413a982236a49bcc125023ef64d39b'] = async function fn_ab413a982236a49bcc125023ef64d39b(Map, AppData, Tractors, From, To, Live, Parameters, Repeater, Track, Wait, Hub) {
var Wait, Locations, Tractor, item, Clocking, Sorter, Decision, Tractors1, k, j, error, Clocking_Function, Stations, Idle_Markers, Max_Markers, Over_Temp_Markers, Over_Speed_Markers, Over_Rev_Markers, Fuel_Loss_List, Refuel_List, Markers, Clock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function LiveTrack() {
  await new Promise(r => setTimeout(r, 500 || 0));
  await (async function(Map) {
  	/* Inputs: Map
  	   Outputs: MapReady (boolean), MapObject (google.maps.Map), Wrapper (any), Element (DOM)
  	*/
  	return (async () => {
  	  // ---- Tunables (kept aggressive) ----
  	  const TIMEOUT_MS   = 10000; // hard cap (down from 12000)
  	  const STABLE_COUNT = 1;     // require 1 consecutive "good" tick (was 3)
  	
  	  // ---- tiny utils ----
  	  const nextFrame = () => new Promise(r => requestAnimationFrame(r));
  	  const sleep = (ms) => new Promise(r => setTimeout(r, ms));
  	  const now = () => (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
  	
  	  const isGmAvailable = () =>
  	    typeof window !== "undefined" &&
  	    window.google && window.google.maps &&
  	    typeof window.google.maps.Map === "function";
  	
  	  // Best-effort: if using the new loader, nudge it without stalling
  	  const tryImportMaps = async () => {
  	    try {
  	      if (window?.google?.maps?.importLibrary && !isGmAvailable()) {
  	        // Race with a single frame so we don't block the fast path
  	        await Promise.race([
  	          window.google.maps.importLibrary("maps"),
  	          nextFrame()
  	        ]);
  	      }
  	    } catch (_) { /* ignore */ }
  	  };
  	
  	  // Broadened resolver (checks common wrapper shapes + duck-type)
  	  const extractMap = (candidate) => {
  	    if (!candidate) return null;
  	    try {
  	      // Already a google.maps.Map
  	      if (isGmAvailable() && candidate instanceof window.google.maps.Map) return candidate;
  	
  	      // Common shapes
  	      const directCandidates = [];
  	      const push = (x) => { if (x) directCandidates.push(x); };
  	
  	      push(candidate.map);
  	      if (typeof candidate.map === "function") push(candidate.map());
  	      push(candidate.map?.map);
  	      if (typeof candidate.map?.getMap === "function") push(candidate.map.getMap());
  	      if (typeof candidate.getMap === "function") push(candidate.getMap());
  	      push(candidate.googleMap);
  	      push(candidate.gMap);
  	      push(candidate.gmap);
  	      push(candidate.__map);
  	      push(candidate._map);
  	      push(candidate.api?.map);
  	      if (candidate.mapComponent?.getMap) push(candidate.mapComponent.getMap());
  	      push(candidate.$mapObject);
  	      push(candidate.$refs?.map?.$mapObject);
  	
  	      // Evaluate the candidates
  	      for (const c of directCandidates) {
  	        if (!c) continue;
  	        if (isGmAvailable() && c instanceof window.google.maps.Map) return c;
  	        if (c && typeof c.getCenter === "function" && typeof c.panTo === "function") return c; // duck-typed
  	      }
  	
  	      // Some wrappers expose map methods directly
  	      if (typeof candidate.getCenter === "function" && typeof candidate.panTo === "function") {
  	        return candidate;
  	      }
  	    } catch (_) {}
  	    return null;
  	  };
  	
  	  const getEl = (candidate, mapInstance) => {
  	    try {
  	      if (!candidate) return mapInstance?.getDiv?.() || null;
  	      // typical wrapper patterns
  	      if (typeof candidate.el === "function") return candidate.el();
  	      if (candidate.el) return candidate.el;
  	      if (candidate.element) return candidate.element;
  	      if (candidate.$el) return candidate.$el;
  	      // fall back to the map's div if present
  	      if (mapInstance?.getDiv) return mapInstance.getDiv();
  	    } catch (_) {}
  	    return null;
  	  };
  	
  	  const isWrapperLikelyValid = (candidate) =>
  	    !!candidate && (("map" in candidate) || ("el" in candidate) || ("element" in candidate) || ("center" in candidate));
  	
  	  // ---- initial resolve (fast path) ----
  	  let wrapper = Map;
  	  let mapInstance = extractMap(wrapper);
  	  let el = getEl(wrapper, mapInstance);
  	
  	  if (mapInstance) {
  	    return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	  }
  	
  	  // Nudge the loader if needed, but don't block the loop
  	  tryImportMaps();
  	
  	  const deadline = now() + TIMEOUT_MS;
  	  let stable = 0;
  	
  	  // ---- high-frequency loop: rAF preferred, timer as fallback if background tab ----
  	  while (now() < deadline) {
  	    // Lightweight early re-checks
  	    if (!isWrapperLikelyValid(wrapper)) {
  	      // In background tabs rAF is throttled; use a tiny sleep fallback
  	      if (document.hidden) await sleep(10); else await nextFrame();
  	      continue;
  	    }
  	
  	    if (!isGmAvailable()) {
  	      // Give the loader one frame (or 10ms if background) to settle
  	      if (document.hidden) await sleep(10); else await nextFrame();
  	      continue;
  	    }
  	
  	    mapInstance = extractMap(wrapper);
  	    el = getEl(wrapper, mapInstance);
  	    const elOk = !el || !!el.isConnected || !!(el?.ownerDocument);
  	
  	    if (mapInstance && elOk) {
  	      stable++;
  	      if (stable >= STABLE_COUNT) {
  	        return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	      }
  	    } else {
  	      stable = 0;
  	    }
  	
  	    if (document.hidden) await sleep(10); else await nextFrame();
  	  }
  	
  	  // Timeout: hand back what we found (useful for diagnostics)
  	  return { MapReady: false, MapObject: mapInstance || null, Wrapper: wrapper || null, Element: el || null };
  	})();

  })(Map);
  await (async function(googleMapComponent, locations, Centre, FineTrack, App) {
  	function addMinimalTruckPins(googleMapComponent, items, centre /* boolean */, fineTrack /* optional */, App /* AppData */) {

  	  // ============================================================
  	  // TrackIT Truck Pins + Compact Unified Map Controls
  	  // Removed: Scale, Rotate, North Up
  	  // Kept: Map Type, Zoom, Traffic, Street View, Fullscreen
  	  // ============================================================

  	  // ---------- AppData helpers ----------
  	  function setSelectedInApp(t) {
  	    let plain = t;

  	    try {
  	      plain = JSON.parse(JSON.stringify(t));
  	    } catch (_) {}

  	    let wrote = false;

  	    if (App?.data && typeof App.data === "object") {
  	      App.data.SelectedTractor = plain;
  	      wrote = true;
  	    }

  	    if (App && !("data" in App)) {
  	      App.SelectedTractor = plain;
  	      wrote = true;
  	    }

  	    if (!wrote && typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	      BackendlessUI.App.data.SelectedTractor = plain;
  	      wrote = true;
  	    }

  	    if (!wrote && typeof window !== "undefined" && window.AppData) {
  	      (window.AppData.data || window.AppData).SelectedTractor = plain;
  	      wrote = true;
  	    }

  	    try {
  	      BackendlessUI?.App?.refresh?.();
  	    } catch (_) {}

  	    if (!wrote) {
  	      console.warn("[TrackIT] AppData root not found. Could not set SelectedTractor.");
  	    }
  	  }

  	  function readSelectedTractorMarkerId() {
  	    try {
  	      if (App?.data && "SelectedTractorMarker" in App.data) {
  	        return App.data.SelectedTractorMarker || null;
  	      }

  	      if (App && !("data" in App) && "SelectedTractorMarker" in App) {
  	        return App.SelectedTractorMarker || null;
  	      }

  	      if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	        return BackendlessUI.App.data.SelectedTractorMarker || null;
  	      }

  	      if (typeof window !== "undefined" && window.AppData) {
  	        return (window.AppData.data || window.AppData).SelectedTractorMarker || null;
  	      }
  	    } catch (_) {}

  	    return null;
  	  }

  	  function writeSelectedTractorMarkerId(val /* string or null to clear */) {
  	    let wrote = false;

  	    const clearOrSet = (bag) => {
  	      if (!bag) return false;

  	      if (val == null) {
  	        try {
  	          delete bag.SelectedTractorMarker;
  	        } catch (_) {
  	          bag.SelectedTractorMarker = null;
  	        }
  	      } else {
  	        bag.SelectedTractorMarker = val;
  	      }

  	      return true;
  	    };

  	    if (App?.data) {
  	      wrote = clearOrSet(App.data) || wrote;
  	    }

  	    if (App && !("data" in App)) {
  	      wrote = clearOrSet(App) || wrote;
  	    }

  	    if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	      wrote = clearOrSet(BackendlessUI.App.data) || wrote;
  	    }

  	    if (typeof window !== "undefined" && window.AppData) {
  	      wrote = clearOrSet(window.AppData.data || window.AppData) || wrote;
  	    }

  	    try {
  	      BackendlessUI?.App?.refresh?.();
  	    } catch (_) {}

  	    if (!wrote) {
  	      console.warn("[TrackIT] AppData root not found. Could not write SelectedTractorMarker.");
  	    }
  	  }

  	  function getAppBag() {
  	    if (App?.data && typeof App.data === "object") return App.data;
  	    if (App && typeof App === "object" && !("data" in App)) return App;

  	    if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	      return BackendlessUI.App.data;
  	    }

  	    if (typeof window !== "undefined" && window.AppData) {
  	      return window.AppData.data || window.AppData;
  	    }

  	    return null;
  	  }

  	  function refreshApp() {
  	    try {
  	      BackendlessUI?.App?.refresh?.();
  	    } catch (_) {}
  	  }

  	  // ---------- Google InfoWindow spacing ----------
  	  function injectGoogleInfoWindowPaddingCss() {
  	    const old = document.getElementById("trackit-google-info-window-padding-css");
  	    if (old) old.remove();

  	    const style = document.createElement("style");
  	    style.id = "trackit-google-info-window-padding-css";

  	    style.textContent = `
  	    .gm-style .gm-style-iw-c {
  	    padding: 10px !important;
  	    border-radius: 14px !important;
  	    overflow: visible !important;
  	    background: transparent !important;
  	    box-shadow: none !important;
  	    max-height: none !important;
  	    }

  	    .gm-style .gm-style-iw-d {
  	    overflow: visible !important;
  	    max-height: none !important;
  	    padding: 0 !important;
  	    box-sizing: border-box !important;
  	    }

  	    .gm-style .gm-style-iw-d > div {
  	    overflow: visible !important;
  	    max-height: none !important;
  	    padding: 0 !important;
  	    box-sizing: border-box !important;
  	    }

  	    .gm-style .gm-style-iw-tc {
  	    filter: drop-shadow(0 2px 2px rgba(0,0,0,0.45)) !important;
  	    }

  	    .gm-style .gm-ui-hover-effect {
  	    top: 7px !important;
  	    right: 7px !important;
  	    width: 25px !important;
  	    height: 25px !important;
  	    border-radius: 50% !important;
  	    background: rgba(3, 8, 8, 0.64) !important;
  	    opacity: 1 !important;
  	    z-index: 50 !important;
  	    }

  	    .gm-style .gm-ui-hover-effect span {
  	    background-color: rgba(255,255,255,0.86) !important;
  	    width: 17px !important;
  	    height: 17px !important;
  	    margin: 4px !important;
  	    }

  	    .gm-style .gm-ui-hover-effect:hover {
  	    background: rgba(20, 20, 20, 0.86) !important;
  	    }
  	    `;

  	    document.head.appendChild(style);
  	  }

  	  // ---------- Compact unified map controls ----------
  	  function addTrackitUnifiedMapControl(map) {
  	    if (!map || typeof google === "undefined" || !(map instanceof google.maps.Map)) {
  	      console.error("[TrackIT Map Controls] Invalid map.");
  	      return;
  	    }

  	    const CONTROL_VERSION = "trackit-map-control-fleet-ces-shell-v11-whatsapp-driver-autosend";

  	    injectGoogleInfoWindowPaddingCss();

  	    map.setOptions({
  	      mapTypeControl: false,
  	      zoomControl: false,
  	      fullscreenControl: false,
  	      rotateControl: false,
  	      scaleControl: false,
  	      streetViewControl: false,

  	      // Keep Google map labels/POI labels clickable.
  	      clickableIcons: true
  	    });

  	    try {
  	      const panorama = map.getStreetView();
  	      panorama.setVisible(false);
  	      panorama.setOptions({
  	        enableCloseButton: false,
  	        addressControl: false,
  	        fullscreenControl: false,
  	        panControl: false,
  	        zoomControl: false,
  	        linksControl: false
  	      });
  	    } catch (_) {}

  	    const mapDiv = map.getDiv ? map.getDiv(): null;

  	    const existingControl =
  	    mapDiv?.querySelector?.(".trackit-compact-map-control") ||
  	    document.querySelector(".trackit-compact-map-control");

  	    if (
  	      map.__trackitUnifiedMapControlReady &&
  	      map.__trackitUnifiedMapControlVersion === CONTROL_VERSION &&
  	      existingControl
  	    ) {
  	      return;
  	    }

  	    // ---------- Directions Mode ----------
  	    const TRACKIT_WHATSAPP_SERVICE_NAME = "WhatsApp";
  	    const TRACKIT_WHATSAPP_METHOD_NAME = "Send_Directions_Template";

  	    function getTrackitDirectionsState() {
  	      if (!map.__trackitDirections) {
  	        map.__trackitDirections = {
  	          active: false,
  	          waitingFor: 0,

  	          point1: null,
  	          point2: null,

  	          point1Label: "",
  	          point2Label: "",

  	          // Populated only when the From point is an actual fleet vehicle.
  	          // Used by the WhatsApp Driver button to send the route directly to the assigned driver.
  	          fromVehicle: null,

  	          waypoints: [],
  	          activeSlot: "from",

  	          mapClickListener: null,
  	          directionsService: null,
  	          directionsRenderer: null,
  	          geocoder: null,

  	          pointMarkers: [],
  	          pointMarkerBySlot: {},

  	          popup: null
  	        };
  	      }

  	      const s = map.__trackitDirections;

  	      if (!Array.isArray(s.waypoints)) s.waypoints = [];
  	      if (!s.pointMarkerBySlot) s.pointMarkerBySlot = {};
  	      if (!s.activeSlot) s.activeSlot = "from";
  	      if (s.point1Label === undefined) s.point1Label = "";
  	      if (s.point2Label === undefined) s.point2Label = "";
  	      if (s.fromVehicle === undefined) s.fromVehicle = null;

  	      return s;
  	    }

  	    function setDirectionsButtonText(text) {
  	      try {
  	        const span = directionsBtn.querySelector("span");
  	        if (span) span.textContent = text;
  	        directionsBtn.title = text;
  	      } catch (_) {}
  	    }

  	    function paintDirectionsButton() {
  	      const s = getTrackitDirectionsState();

  	      directionsBtn.classList.toggle("active", !!s.active);

  	      if (!s.active) {
  	        setDirectionsButtonText("Directions");
  	        return;
  	      }

  	      if (!s.point1) {
  	        setDirectionsButtonText("Set From");
  	        return;
  	      }

  	      if (!s.point2) {
  	        setDirectionsButtonText("Set To");
  	        return;
  	      }

  	      setDirectionsButtonText("Directions");
  	    }

  	    function normaliseDirectionsLatLng(value) {
  	      if (!value) return null;

  	      if (value.lat !== undefined && value.lng !== undefined) {
  	        const lat = typeof value.lat === "function" ? value.lat(): Number(value.lat);
  	        const lng = typeof value.lng === "function" ? value.lng(): Number(value.lng);

  	        if (
  	          Number.isFinite(lat) &&
  	          Number.isFinite(lng) &&
  	          Math.abs(lat) <= 90 &&
  	          Math.abs(lng) <= 180
  	        ) {
  	          return {
  	            lat,
  	            lng
  	          };
  	        }
  	      }

  	      return null;
  	    }

  	    function makeDirectionsPointMarker(position, label) {
  	      const svg = `
  	      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  	      <path d="M16 41s13-12.2 13-25A13 13 0 1 0 3 16c0 12.8 13 25 13 25Z"
  	      fill="rgba(0,0,0,0.88)"
  	      stroke="rgba(255,138,61,0.95)"
  	      stroke-width="2"/>
  	      <circle cx="16" cy="16" r="8" fill="#ff8a3c"/>
  	      <text x="16" y="20" text-anchor="middle"
  	      font-family="Arial, sans-serif"
  	      font-size="11"
  	      font-weight="900"
  	      fill="#fff">${String(label || "•")}</text>
  	      </svg>
  	      `;

  	      return new google.maps.Marker({
  	        position,
  	        map,
  	        clickable: false,
  	        zIndex: 999,
  	        icon: {
  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
  	          scaledSize: new google.maps.Size(32, 42),
  	          anchor: new google.maps.Point(16, 41)
  	        }
  	      });
  	    }

  	    function clearDirectionsMarkers() {
  	      const s = getTrackitDirectionsState();

  	      (s.pointMarkers || []).forEach(marker => {
  	        try {
  	          marker.setMap(null);
  	        } catch (_) {}
  	      });

  	      Object.keys(s.pointMarkerBySlot || {}).forEach(slot => {
  	        try {
  	          s.pointMarkerBySlot[slot].setMap(null);
  	        } catch (_) {}
  	      });

  	      s.pointMarkers = [];
  	      s.pointMarkerBySlot = {};
  	    }

  	    function clearDirectionsPopup() {
  	      const s = getTrackitDirectionsState();

  	      try {
  	        if (s.popup) {
  	          s.popup.remove();
  	          s.popup = null;
  	        }
  	      } catch (_) {
  	        s.popup = null;
  	      }
  	    }

  	    function clearDirectionsRouteOnly() {
  	      const s = getTrackitDirectionsState();

  	      try {
  	        if (s.directionsRenderer) {
  	          s.directionsRenderer.setMap(null);
  	          s.directionsRenderer = null;
  	        }
  	      } catch (_) {
  	        s.directionsRenderer = null;
  	      }

  	      clearDirectionsMarkers();
  	    }

  	    function stopDirectionsMode() {
  	      const s = getTrackitDirectionsState();

  	      if (s.mapClickListener) {
  	        try {
  	          google.maps.event.removeListener(s.mapClickListener);
  	        } catch (_) {}

  	        s.mapClickListener = null;
  	      }

  	      clearDirectionsRouteOnly();
  	      clearDirectionsPopup();

  	      s.active = false;
  	      s.waitingFor = 0;
  	      s.point1 = null;
  	      s.point2 = null;
  	      s.point1Label = "";
  	      s.point2Label = "";
  	      s.fromVehicle = null;
  	      s.waypoints = [];
  	      s.activeSlot = "from";

  	      paintDirectionsButton();
  	    }

  	    function toggleDirectionsMode() {
  	      const s = getTrackitDirectionsState();

  	      if (s.active) {
  	        stopDirectionsMode();
  	      } else {
  	        startDirectionsMode();
  	      }
  	    }

  	    function getDirectionsSlotOrder() {
  	      const s = getTrackitDirectionsState();

  	      return [
  	        "from",
  	        ...s.waypoints.map((_, index) => `waypoint:${index}`),
  	        "to"
  	      ];
  	    }

  	    function getDirectionsPointForSlot(slot) {
  	      const s = getTrackitDirectionsState();

  	      if (slot === "from") return s.point1;
  	      if (slot === "to") return s.point2;

  	      if (String(slot).startsWith("waypoint:")) {
  	        const index = Number(String(slot).split(":")[1]);
  	        return s.waypoints[index]?.point || null;
  	      }

  	      return null;
  	    }

  	    function getNextEmptyDirectionsSlot() {
  	      const s = getTrackitDirectionsState();

  	      if (!s.point1) return "from";

  	      for (let i = 0; i < s.waypoints.length; i++) {
  	        if (!s.waypoints[i]?.point) return `waypoint:${i}`;
  	      }

  	      if (!s.point2) return "to";

  	      return "to";
  	    }

  	    function setNextDirectionsSlotAfter(slot) {
  	      const s = getTrackitDirectionsState();
  	      const order = getDirectionsSlotOrder();
  	      const index = order.indexOf(slot);

  	      for (let i = index + 1; i < order.length; i++) {
  	        if (!getDirectionsPointForSlot(order[i])) {
  	          s.activeSlot = order[i];
  	          return;
  	        }
  	      }

  	      s.activeSlot = getNextEmptyDirectionsSlot();
  	    }

  	    function getDirectionsMarkerLabelForSlot(slot) {
  	      if (slot === "from") return "A";
  	      if (slot === "to") return "B";

  	      if (String(slot).startsWith("waypoint:")) {
  	        const index = Number(String(slot).split(":")[1]);
  	        return String(index + 1);
  	      }

  	      return "•";
  	    }

  	    function formatDirectionsPointText(point, label) {
  	      if (label) return String(label);
  	      if (!point) return "—";

  	      return `${Number(point.lat).toFixed(5)}, ${Number(point.lng).toFixed(5)}`;
  	    }

  	    function setDirectionsInputValue(slot, text) {
  	      const s = getTrackitDirectionsState();
  	      const popup = s.popup;

  	      if (!popup) return;

  	      const input = popup.querySelector(`[data-route-slot="${slot}"]`);

  	      if (input) {
  	        input.value = text || "";
  	      }
  	    }

  	    function clearDirectionsMarkerForSlot(slot) {
  	      const s = getTrackitDirectionsState();

  	      try {
  	        if (s.pointMarkerBySlot?.[slot]) {
  	          s.pointMarkerBySlot[slot].setMap(null);
  	          delete s.pointMarkerBySlot[slot];
  	        }
  	      } catch (_) {}
  	    }

  	    function normaliseDirectionsVehicleMeta(vehicleMeta) {
  	      if (!vehicleMeta || typeof vehicleMeta !== "object") return null;

  	      return {
  	        id: String(vehicleMeta.id || "").trim(),
  	        label: String(vehicleMeta.label || "").trim(),
  	        registration: String(vehicleMeta.registration || "").trim(),
  	        tracker: String(vehicleMeta.tracker || "").trim(),
  	        driverName: String(vehicleMeta.driverName || "").trim(),
  	        driverPhone: String(vehicleMeta.driverPhone || "").trim()
  	      };
  	    }

  	    function setDirectionsSlot(slot, point, labelText, vehicleMeta) {
  	      const s = getTrackitDirectionsState();
  	      const normalised = normaliseDirectionsLatLng(point);

  	      if (!normalised) return false;

  	      s.active = true;

  	      const label = String(labelText || "").trim();

  	      if (slot === "from") {
  	        s.point1 = normalised;
  	        s.point1Label = label;

  	        // A place search or dropped pin passes no vehicleMeta, which correctly
  	        // removes the WhatsApp Driver action from the From point.
  	        s.fromVehicle = normaliseDirectionsVehicleMeta(vehicleMeta);
  	      } else if (slot === "to") {
  	        s.point2 = normalised;
  	        s.point2Label = label;
  	      } else if (String(slot).startsWith("waypoint:")) {
  	        const index = Number(String(slot).split(":")[1]);

  	        if (!s.waypoints[index]) {
  	          s.waypoints[index] = {
  	            point: null,
  	            label: ""
  	          };
  	        }

  	        s.waypoints[index].point = normalised;
  	        s.waypoints[index].label = label;
  	      }

  	      clearDirectionsMarkerForSlot(slot);

  	      s.pointMarkerBySlot[slot] = makeDirectionsPointMarker(
  	        normalised,
  	        getDirectionsMarkerLabelForSlot(slot)
  	      );

  	      setDirectionsInputValue(slot, formatDirectionsPointText(normalised, label));
  	      setNextDirectionsSlotAfter(slot);

  	      paintDirectionsButton();
  	      updateDirectionsPopup(null, null);

  	      if (s.point1 && s.point2) {
  	        calculateAndDisplayRoute();
  	      }

  	      return true;
  	    }

  	    function addDirectionsPoint(position, labelText, vehicleMeta) {
  	      const s = getTrackitDirectionsState();
  	      const point = normaliseDirectionsLatLng(position);

  	      if (!s.active || !point) return false;

  	      const slot = s.activeSlot || getNextEmptyDirectionsSlot();

  	      if (!getDirectionsPointForSlot(slot)) {
  	        return setDirectionsSlot(slot, point, labelText, vehicleMeta);
  	      }

  	      return setDirectionsSlot(getNextEmptyDirectionsSlot(), point, labelText, vehicleMeta);
  	    }

  	    function getVehicleDirectionsLabelFromTractor(t, fallback) {
  	      return String(
  	        t?.FID ||
  	        t?.ID ||
  	        t?.Registration ||
  	        t?.Tracker ||
  	        t?.Location?.ident ||
  	        fallback ||
  	        "Vehicle"
  	      );
  	    }

  	    function getDirectionsDriverDetailsFromTractor(t) {
  	      const ViewC = t?.ViewC || t?.viewC || {};
  	      const D1 = ViewC?.Driver1 || ViewC?.driver1 || null;

  	      if (!D1) {
  	        return {
  	          driverName: "",
  	          driverPhone: ""
  	        };
  	      }

  	      const driverName = String(
  	        D1.name ||
  	        [D1.first_name || D1.firstName, D1.last_name || D1.lastName]
  	        .filter(Boolean)
  	        .join(" ") ||
  	        D1.username ||
  	        ""
  	      ).trim();

  	      const driverPhone = String(
  	        D1?.Data_Details?.employee_details?.contact_details?.phone_number ||
  	        D1?.mobile ||
  	        D1?.phone ||
  	        D1?.tel ||
  	        ""
  	      ).trim();

  	      return {
  	        driverName,
  	        driverPhone
  	      };
  	    }

  	    function getDirectionsVehicleMetaFromTractor(t, fallbackId) {
  	      const driver = getDirectionsDriverDetailsFromTractor(t);

  	      return {
  	        id: String(fallbackId || t?.FID || t?.ID || t?.Registration || t?.Tracker || "").trim(),
  	        label: getVehicleDirectionsLabelFromTractor(t, fallbackId),
  	        registration: String(t?.Registration || t?.Location?.Registration || "").trim(),
  	        tracker: String(t?.Tracker || t?.Location?.ident || "").trim(),
  	        driverName: driver.driverName,
  	        driverPhone: driver.driverPhone
  	      };
  	    }

  	    function getDirectionsVehicleChoices(query) {
  	      const q = String(query || "").trim().toLowerCase();
  	      const pins = map.__truckPins || {};
  	      const rows = [];

  	      Object.keys(pins).forEach(id => {
  	        const pin = pins[id];
  	        const marker = pin?.marker;

  	        if (!marker || !marker.getPosition) return;

  	        const t = pin?.tractor || {};
  	        const meta = getDirectionsVehicleMetaFromTractor(t, id);
  	        const label = meta.label;
  	        const registration = meta.registration;
  	        const tracker = meta.tracker;

  	        const haystack = [label,
  	          registration,
  	          tracker,
  	          meta.driverName,
  	          id]
  	        .filter(Boolean)
  	        .join(" ")
  	        .toLowerCase();

  	        if (q && !haystack.includes(q)) return;

  	        rows.push({
  	          ...meta,
  	          id,
  	          position: marker.getPosition()
  	        });
  	      });

  	      rows.sort((a, b) => String(a.label).localeCompare(String(b.label), undefined, {
  	        numeric: true,
  	        sensitivity: "base"
  	      }));

  	      return rows.slice(0,
  	        10);
  	    }

  	    function findExactVehicleChoice(text) {
  	      const q = String(text || "").trim().toLowerCase();

  	      if (!q) return null;

  	      const choices = getDirectionsVehicleChoices(q);

  	      return choices.find(choice =>
  	        String(choice.label || "").toLowerCase() === q ||
  	        String(choice.registration || "").toLowerCase() === q ||
  	        String(choice.tracker || "").toLowerCase() === q ||
  	        String(choice.id || "").toLowerCase() === q
  	      ) || choices[0] || null;
  	    }

  	    function hideVehicleSuggest(input) {
  	      const box = input?.parentElement?.querySelector?.(".trackit-directions-vehicle-suggest");

  	      if (box) {
  	        box.classList.remove("visible");
  	        box.innerHTML = "";
  	      }
  	    }

  	    function showVehicleSuggest(input, slot) {
  	      if (!input) return;

  	      const box = input.parentElement?.querySelector?.(".trackit-directions-vehicle-suggest");

  	      if (!box) return;

  	      const choices = getDirectionsVehicleChoices(input.value);

  	      box.innerHTML = "";

  	      if (!choices.length || !String(input.value || "").trim()) {
  	        box.classList.remove("visible");
  	        return;
  	      }

  	      choices.forEach(choice => {
  	        const btn = document.createElement("button");
  	        btn.type = "button";
  	        btn.className = "trackit-directions-vehicle-option";

  	        btn.innerHTML = `
  	        <span class="trackit-directions-vehicle-id">${choice.label}</span>
  	        <span class="trackit-directions-vehicle-meta">Vehicle</span>
  	        `;

  	        btn.addEventListener("click", function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          setDirectionsSlot(slot, choice.position, choice.label, choice);
  	          input.value = choice.label;
  	          hideVehicleSuggest(input);
  	        });

  	        box.appendChild(btn);
  	      });

  	      box.classList.add("visible");
  	    }

  	    function renderDirectionsWaypoints() {
  	      const s = getTrackitDirectionsState();
  	      const popup = s.popup;

  	      if (!popup) return;

  	      const wrap = popup.querySelector(".trackit-directions-waypoints");

  	      if (!wrap) return;

  	      wrap.innerHTML = "";

  	      s.waypoints.forEach((wp, index) => {
  	        const slot = `waypoint:${index}`;

  	        const row = document.createElement("div");
  	        row.className = "trackit-directions-search-line";
  	        row.setAttribute("data-route-row", slot);

  	        row.innerHTML = `
  	        <span>Stop ${index + 1}</span>
  	        <div class="trackit-directions-input-wrap">
  	        <input class="trackit-directions-waypoint" data-route-slot="${slot}" type="text" placeholder="Search place / vehicle ID / click map" autocomplete="off">
  	        <div class="trackit-directions-vehicle-suggest"></div>
  	        </div>
  	        <button type="button" class="trackit-directions-remove-stop">×</button>
  	        `;

  	        const input = row.querySelector("input");
  	        const removeBtn = row.querySelector(".trackit-directions-remove-stop");

  	        if (input) {
  	          input.value = formatDirectionsPointText(wp.point, wp.label);
  	          wireDirectionsInput(input, slot);
  	        }

  	        removeBtn?.addEventListener("click", function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          removeDirectionsWaypoint(index);
  	        });

  	        wrap.appendChild(row);
  	      });
  	    }

  	    function addDirectionsWaypoint(point,
  	      labelText) {
  	      const s = getTrackitDirectionsState();
  	      const index = s.waypoints.length;

  	      s.waypoints.push({
  	        point: null,
  	        label: ""
  	      });

  	      renderDirectionsWaypoints();

  	      const slot = `waypoint:${index}`;
  	      s.activeSlot = slot;

  	      if (point) {
  	        setDirectionsSlot(slot, point, labelText);
  	      } else {
  	        updateDirectionsPopup(null, null);

  	        setTimeout(() => {
  	          try {
  	            s.popup?.querySelector?.(`[data-route-slot="${slot}"]`)?.focus?.();
  	          } catch (_) {}
  	        }, 0);
  	      }
  	    }

  	    function removeDirectionsWaypoint(index) {
  	      const s = getTrackitDirectionsState();

  	      clearDirectionsMarkerForSlot(`waypoint:${index}`);

  	      s.waypoints.splice(index, 1);

  	      Object.keys(s.pointMarkerBySlot || {}).forEach(slot => {
  	        if (slot.startsWith("waypoint:")) {
  	          clearDirectionsMarkerForSlot(slot);
  	        }
  	      });

  	      renderDirectionsWaypoints();

  	      s.waypoints.forEach((wp, newIndex) => {
  	        if (wp?.point) {
  	          const slot = `waypoint:${newIndex}`;
  	          s.pointMarkerBySlot[slot] = makeDirectionsPointMarker(wp.point, String(newIndex + 1));
  	        }
  	      });

  	      s.activeSlot = getNextEmptyDirectionsSlot();

  	      updateDirectionsPopup(null,
  	        null);

  	      if (s.point1 && s.point2) {
  	        calculateAndDisplayRoute();
  	      }
  	    }

  	    function wireDirectionsInput(input, slot) {
  	      if (!input || input.__trackitDirectionsInputWired) return;

  	      input.__trackitDirectionsInputWired = true;

  	      input.addEventListener("focus", function () {
  	        const s = getTrackitDirectionsState();
  	        s.activeSlot = slot;
  	        updateDirectionsPopup(null, null);
  	      });

  	      input.addEventListener("input", function () {
  	        const s = getTrackitDirectionsState();
  	        s.activeSlot = slot;

  	        if (slot === "from") {
  	          s.fromVehicle = null;
  	          updateDirectionsPopup(null, null);
  	        }

  	        showVehicleSuggest(input, slot);
  	      });

  	      input.addEventListener("keydown", function (event) {
  	        if (event.key !== "Enter") return;

  	        event.preventDefault();
  	        event.stopPropagation();

  	        const vehicle = findExactVehicleChoice(input.value);

  	        if (vehicle) {
  	          setDirectionsSlot(slot, vehicle.position, vehicle.label, vehicle);
  	          input.value = vehicle.label;
  	          hideVehicleSuggest(input);
  	          return;
  	        }

  	        geocodeDirectionsInput(input.value, slot);
  	      });

  	      input.addEventListener("blur",
  	        function () {
  	          setTimeout(() => hideVehicleSuggest(input), 180);
  	        });

  	      if (google.maps.places?.Autocomplete) {
  	        const autocomplete = new google.maps.places.Autocomplete(input, {
  	          fields: ["geometry", "name", "formatted_address"],
  	          types: ["geocode", "establishment"]
  	        });

  	        try {
  	          autocomplete.bindTo("bounds", map);
  	        } catch (_) {}

  	        autocomplete.addListener("place_changed", function () {
  	          const place = autocomplete.getPlace();
  	          const location = place?.geometry?.location;

  	          if (!location) {
  	            console.warn("[TrackIT Directions] Place has no geometry:", place);
  	            return;
  	          }

  	          const point = normaliseDirectionsLatLng(location);

  	          if (!point) return;

  	          const label = place.formatted_address || place.name || input.value;

  	          setDirectionsSlot(slot, point, label);
  	          input.value = label;
  	          hideVehicleSuggest(input);
  	        });
  	      } else {
  	        console.warn("[TrackIT Directions] Google Places library not loaded. Add libraries=places to your Google Maps script.");
  	      }
  	    }

  	    function geocodeDirectionsInput(text, slot) {
  	      const query = String(text || "").trim();

  	      if (!query) return;

  	      const vehicle = findExactVehicleChoice(query);

  	      if (vehicle) {
  	        setDirectionsSlot(slot, vehicle.position, vehicle.label, vehicle);
  	        return;
  	      }

  	      const s = getTrackitDirectionsState();

  	      if (!s.geocoder) {
  	        s.geocoder = new google.maps.Geocoder();
  	      }

  	      s.geocoder.geocode({
  	        address: query
  	      }, function (results, status) {
  	        if (status === "OK" && results?.[0]?.geometry?.location) {
  	          const point = normaliseDirectionsLatLng(results[0].geometry.location);
  	          const label = results[0].formatted_address || query;

  	          if (point) {
  	            setDirectionsSlot(slot, point, label);
  	          }

  	          return;
  	        }

  	        console.warn("[TrackIT Directions] Geocode failed:", status, query);
  	        updateDirectionsStatusText("Search failed. Try a more specific address or vehicle ID.");
  	      });
  	    }

  	    function formatDirectionsDistance(route) {
  	      let metres = 0;

  	      try {
  	        route.legs.forEach(leg => {
  	          metres += Number(leg.distance?.value || 0);
  	        });
  	      } catch (_) {}

  	      if (!metres) return "—";

  	      if (metres >= 1000) {
  	        return `${(metres / 1000).toFixed(1).replace(/\.0$/, "")} km`;
  	      }

  	      return `${Math.round(metres)} m`;
  	    }

  	    function formatDirectionsDuration(route) {
  	      let seconds = 0;

  	      try {
  	        route.legs.forEach(leg => {
  	          seconds += Number(leg.duration?.value || 0);
  	        });
  	      } catch (_) {}

  	      if (!seconds) return "—";

  	      const mins = Math.round(seconds / 60);

  	      if (mins < 60) return `${mins} min`;

  	      const h = Math.floor(mins / 60);
  	      const m = mins % 60;

  	      return m ? `${h} hr ${m} min`: `${h} hr`;
  	    }

  	    function updateDirectionsStatusText(text) {
  	      const s = getTrackitDirectionsState();
  	      const status = s.popup?.querySelector?.(".trackit-directions-status");

  	      if (status) {
  	        status.textContent = text;
  	      }
  	    }

  	    function createDirectionsPopup(route, request) {
  	      const s = getTrackitDirectionsState();
  	      const mapDiv = map.getDiv();

  	      if (!mapDiv) return;

  	      let popup = s.popup;

  	      if (!popup) {
  	        popup = document.createElement("div");
  	        popup.className = "trackit-directions-popup";

  	        popup.innerHTML = `
  	        <div class="trackit-directions-popup-header">
  	        <div>
  	        <div class="trackit-directions-popup-title">Directions</div>
  	        <div class="trackit-directions-popup-subtitle">Build Route</div>
  	        </div>
  	        <button type="button" class="trackit-directions-popup-close">×</button>
  	        </div>

  	        <div class="trackit-directions-search-wrap">

  	        <div class="trackit-directions-search-line no-remove" data-route-row="from">
  	        <span>From</span>
  	        <div class="trackit-directions-input-wrap">
  	        <input class="trackit-directions-from" data-route-slot="from" type="text" placeholder="Search place / vehicle ID / click map" autocomplete="off">
  	        <div class="trackit-directions-vehicle-suggest"></div>
  	        </div>
  	        </div>

  	        <div class="trackit-directions-waypoints"></div>

  	        <button type="button" class="trackit-directions-add-stop">+ Add Stop</button>

  	        <div class="trackit-directions-search-line no-remove" data-route-row="to">
  	        <span>To</span>
  	        <div class="trackit-directions-input-wrap">
  	        <input class="trackit-directions-to" data-route-slot="to" type="text" placeholder="Search place / vehicle ID / click map" autocomplete="off">
  	        <div class="trackit-directions-vehicle-suggest"></div>
  	        </div>
  	        </div>

  	        </div>

  	        <div class="trackit-directions-status">Choose From. Search, type vehicle ID, click map, or click a vehicle.</div>

  	        <div class="trackit-directions-popup-body">
  	        <div class="trackit-directions-row">
  	        <span>From</span>
  	        <strong class="trackit-directions-from-text">—</strong>
  	        </div>
  	        <div class="trackit-directions-row">
  	        <span>Stops</span>
  	        <strong class="trackit-directions-stops-text">0</strong>
  	        </div>
  	        <div class="trackit-directions-row">
  	        <span>To</span>
  	        <strong class="trackit-directions-to-text">—</strong>
  	        </div>
  	        <div class="trackit-directions-row">
  	        <span>Route</span>
  	        <strong class="trackit-directions-route-text">—</strong>
  	        </div>

  	        <div class="trackit-directions-actions">
  	        <button type="button" class="trackit-directions-new">Clear/New Route</button>
  	        </div>

  	        <div class="trackit-directions-whatsapp-wrap">
  	        <select class="trackit-directions-country-select" aria-label="Country code">
  	        ${getWhatsappCountryOptionsHtml("ZA")}
  	        </select>

  	        <input class="trackit-directions-whatsapp-phone" type="tel" placeholder="ZA WhatsApp e.g. 0821234567" autocomplete="tel">

  	        <button type="button" class="trackit-directions-driver-btn" hidden disabled>
  	        ${getTrackitWhatsappButtonHtml("WhatsApp Driver")}
  	        </button>

  	        <button type="button" class="trackit-directions-whatsapp-btn">
  	        ${getTrackitWhatsappButtonHtml("WhatsApp")}
  	        </button>
  	        </div>
  	        </div>
  	        `;

  	        popup.style.right = "0px";
  	        popup.style.left = "auto";
  	        popup.style.top = "50px";

  	        mapDiv.appendChild(popup);
  	        s.popup = popup;

  	        wireDirectionsPopupEvents(popup);
  	        renderDirectionsWaypoints();
  	        wireDirectionsInput(popup.querySelector(".trackit-directions-from"), "from");
  	        wireDirectionsInput(popup.querySelector(".trackit-directions-to"), "to");
  	      }

  	      updateDirectionsPopup(route || null, request || null);
  	    }

  	    function updateDirectionsPopup(route, request) {
  	      const s = getTrackitDirectionsState();
  	      const popup = s.popup;

  	      if (!popup) return;

  	      const subtitle = popup.querySelector(".trackit-directions-popup-subtitle");
  	      const status = popup.querySelector(".trackit-directions-status");
  	      const fromText = popup.querySelector(".trackit-directions-from-text");
  	      const stopsText = popup.querySelector(".trackit-directions-stops-text");
  	      const toText = popup.querySelector(".trackit-directions-to-text");
  	      const routeText = popup.querySelector(".trackit-directions-route-text");
  	      const whatsappWrap = popup.querySelector(".trackit-directions-whatsapp-wrap");
  	      const driverBtn = popup.querySelector(".trackit-directions-driver-btn");

  	      const fromVehicle = s.fromVehicle;
  	      const hasFromVehicle = !!fromVehicle;
  	      const hasDriverPhone = !!String(fromVehicle?.driverPhone || "").trim();

  	      whatsappWrap?.classList?.toggle("has-driver", hasFromVehicle);

  	      if (driverBtn) {
  	        driverBtn.hidden = !hasFromVehicle;
  	        driverBtn.disabled = !hasDriverPhone;
  	        driverBtn.classList.toggle("missing", hasFromVehicle && !hasDriverPhone);
  	        driverBtn.title = hasDriverPhone
  	        ? `Send route immediately to ${fromVehicle?.driverName || "driver"}`
  	        : "No driver mobile number is available for this vehicle";

  	        const driverBtnText = driverBtn.querySelector("span");
  	        if (driverBtnText) {
  	          driverBtnText.textContent = hasDriverPhone ? "WhatsApp Driver": "Driver Number Missing";
  	        }
  	      }

  	      if (fromText) {
  	        fromText.textContent = formatDirectionsPointText(s.point1, s.point1Label);
  	      }

  	      if (toText) {
  	        toText.textContent = formatDirectionsPointText(s.point2, s.point2Label);
  	      }

  	      if (stopsText) {
  	        stopsText.textContent = String(s.waypoints.filter(wp => !!wp?.point).length);
  	      }

  	      if (route && routeText) {
  	        routeText.textContent = `${formatDirectionsDistance(route)} • ${formatDirectionsDuration(route)}`;
  	      } else if (routeText) {
  	        routeText.textContent = "—";
  	      }

  	      if (route && subtitle) {
  	        subtitle.textContent = `${formatDirectionsDistance(route)} • ${formatDirectionsDuration(route)}`;
  	      } else if (subtitle) {
  	        subtitle.textContent = "Build Route";
  	      }

  	      if (status) {
  	        if (!s.active) {
  	          status.textContent = "Directions inactive.";
  	        } else if (!s.point1) {
  	          status.textContent = "Choose From. Search, type vehicle ID, click map, or click a vehicle.";
  	        } else if (!s.point2) {
  	          status.textContent = "Choose To. Search, type vehicle ID, click map, or click a vehicle.";
  	        } else if (route) {
  	          status.textContent = "Route ready.";
  	        } else {
  	          status.textContent = "Route ready to calculate.";
  	        }
  	      }
  	    }

  	    function wireDirectionsPopupEvents(popup) {
  	      const closeBtn = popup.querySelector(".trackit-directions-popup-close");
  	      const clearBtn = popup.querySelector(".trackit-directions-clear");
  	      const newBtn = popup.querySelector(".trackit-directions-new");
  	      const addStopBtn = popup.querySelector(".trackit-directions-add-stop");
  	      const whatsappBtn = popup.querySelector(".trackit-directions-whatsapp-btn");
  	      const driverBtn = popup.querySelector(".trackit-directions-driver-btn");
  	      const header = popup.querySelector(".trackit-directions-popup-header");
  	      const countrySelect = popup.querySelector(".trackit-directions-country-select");
  	      const phoneInput = popup.querySelector(".trackit-directions-whatsapp-phone");

  	      updateWhatsappPhonePlaceholder(popup);

  	      countrySelect?.addEventListener("change", function () {
  	        updateWhatsappPhonePlaceholder(popup);

  	        if (!phoneInput?.value) return;

  	        const checked = normaliseWhatsappNumber(phoneInput.value, countrySelect.value);

  	        phoneInput.classList.toggle("invalid", !checked.ok);

  	        if (checked.ok) {
  	          phoneInput.value = checked.value;
  	          updateDirectionsStatusText("WhatsApp number normalised.");
  	        } else {
  	          updateDirectionsStatusText(checked.error);
  	        }
  	      });

  	      phoneInput?.addEventListener("input",
  	        function () {
  	          phoneInput.classList.remove("invalid");
  	        });

  	      phoneInput?.addEventListener("blur",
  	        function () {
  	          if (!phoneInput.value) return;

  	          const checked = normaliseWhatsappNumber(phoneInput.value, countrySelect?.value || "ZA");

  	          phoneInput.classList.toggle("invalid", !checked.ok);

  	          if (checked.ok) {
  	            phoneInput.value = checked.value;
  	          }
  	        });

  	      closeBtn?.addEventListener("click",
  	        function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          stopDirectionsMode();
  	        });

  	      clearBtn?.addEventListener("click",
  	        function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          stopDirectionsMode();
  	        });

  	      newBtn?.addEventListener("click",
  	        function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          startDirectionsMode();
  	        });

  	      addStopBtn?.addEventListener("click",
  	        function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          addDirectionsWaypoint();
  	        });

  	      driverBtn?.addEventListener("click",
  	        async function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          const s = getTrackitDirectionsState();
  	          const driverPhone = String(s.fromVehicle?.driverPhone || "").trim();

  	          if (!driverPhone) {
  	            updateDirectionsStatusText("No driver mobile number is available for the From vehicle.");
  	            return;
  	          }

  	          // Put the assigned driver's number into the same field used by the
  	          // standard WhatsApp button, then call the exact same send function.
  	          phoneInput.value = driverPhone;
  	          phoneInput.classList.remove("invalid");

  	          await sendDirectionsWhatsapp(driverBtn);
  	        });

  	      whatsappBtn?.addEventListener("click",
  	        async function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          await sendDirectionsWhatsapp(whatsappBtn);
  	        });

  	      let dragging = false;
  	      let startX = 0;
  	      let startY = 0;
  	      let startLeft = 0;
  	      let startTop = 0;

  	      header?.addEventListener("mousedown",
  	        function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();

  	          const rect = popup.getBoundingClientRect();
  	          const parentRect = map.getDiv().getBoundingClientRect();

  	          dragging = true;
  	          startX = event.clientX;
  	          startY = event.clientY;
  	          startLeft = rect.left - parentRect.left;
  	          startTop = rect.top - parentRect.top;

  	          popup.style.right = "auto";
  	          popup.style.left = `${startLeft}px`;
  	          popup.style.top = `${startTop}px`;

  	          document.body.style.userSelect = "none";
  	        });

  	      document.addEventListener("mousemove",
  	        function (event) {
  	          if (!dragging) return;

  	          event.preventDefault();

  	          const mapDiv = map.getDiv();
  	          const maxLeft = Math.max(0, mapDiv.clientWidth - popup.offsetWidth - 6);
  	          const maxTop = Math.max(0, mapDiv.clientHeight - popup.offsetHeight - 6);

  	          const nextLeft = startLeft + (event.clientX - startX);
  	          const nextTop = startTop + (event.clientY - startY);

  	          popup.style.left = `${Math.min(maxLeft, Math.max(0, nextLeft))}px`;
  	          popup.style.top = `${Math.min(maxTop, Math.max(0, nextTop))}px`;
  	        });

  	      document.addEventListener("mouseup",
  	        function () {
  	          if (!dragging) return;

  	          dragging = false;
  	          document.body.style.userSelect = "";
  	        });

  	      ["mousedown", "dblclick", "wheel", "touchstart", "pointerdown", "click"].forEach(evtName => {
  	        popup.addEventListener(evtName, function (event) {
  	          event.stopPropagation();
  	        }, {
  	          passive: false
  	        });
  	      });
  	    }

  	    function startDirectionsMode() {
  	      const s = getTrackitDirectionsState();

  	      clearDirectionsRouteOnly();

  	      closeMapControlPanel(false);

  	      s.active = true;
  	      s.waitingFor = 1;

  	      s.point1 = null;
  	      s.point2 = null;
  	      s.point1Label = "";
  	      s.point2Label = "";
  	      s.fromVehicle = null;
  	      s.waypoints = [];
  	      s.activeSlot = "from";

  	      createDirectionsPopup(null,
  	        null);
  	      renderDirectionsWaypoints();

  	      const fromInput = s.popup?.querySelector?.(".trackit-directions-from");
  	      const toInput = s.popup?.querySelector?.(".trackit-directions-to");

  	      if (fromInput) fromInput.value = "";
  	      if (toInput) toInput.value = "";

  	      if (s.mapClickListener) {
  	        try {
  	          google.maps.event.removeListener(s.mapClickListener);
  	        } catch (_) {}
  	      }

  	      s.mapClickListener = map.addListener("click", function (event) {
  	        try {
  	          addDirectionsPoint(event.latLng, "Dropped Pin");
  	        } catch (e) {
  	          console.warn("[TrackIT Directions] Map point failed:", e);
  	        }
  	      });

  	      paintDirectionsButton();
  	      updateDirectionsPopup(null, null);

  	      setTimeout(() => {
  	        try {
  	          fromInput?.focus?.();
  	        } catch (_) {}
  	      }, 0);
  	    }

  	    function calculateAndDisplayRoute() {
  	      const s = getTrackitDirectionsState();

  	      if (!s.point1 || !s.point2) return;

  	      if (!s.directionsService) {
  	        s.directionsService = new google.maps.DirectionsService();
  	      }

  	      if (s.directionsRenderer) {
  	        try {
  	          s.directionsRenderer.setMap(null);
  	        } catch (_) {}
  	      }

  	      s.directionsRenderer = new google.maps.DirectionsRenderer({
  	        map,
  	        suppressMarkers: true,
  	        preserveViewport: false,
  	        polylineOptions: {
  	          strokeColor: "#ff8a3c",
  	          strokeOpacity: 0.95,
  	          strokeWeight: 5,
  	          zIndex: 900
  	        }
  	      });

  	      const request = {
  	        origin: s.point1,
  	        destination: s.point2,
  	        waypoints: s.waypoints
  	        .filter(wp => !!wp?.point)
  	        .map(wp => ({
  	          location: wp.point,
  	          stopover: true
  	        })),
  	        optimizeWaypoints: false,
  	        travelMode: google.maps.TravelMode.DRIVING,
  	        provideRouteAlternatives: false
  	      };

  	      setDirectionsButtonText("Routing...");
  	      updateDirectionsPopup(null, request);

  	      s.directionsService.route(request, function (result, status) {
  	        if (status === "OK" && result?.routes?.length) {
  	          s.directionsRenderer.setDirections(result);

  	          const route = result.routes[0];

  	          createDirectionsPopup(route, request);
  	          updateDirectionsPopup(route, request);

  	          s.active = true;
  	          s.waitingFor = 0;

  	          setDirectionsButtonText("Directions");
  	          directionsBtn.classList.add("active");

  	          return;
  	        }

  	        console.warn("[TrackIT Directions] Route failed:", status, result);

  	        setDirectionsButtonText("No Route");
  	        updateDirectionsStatusText("Route failed. Check road access or selected points.");

  	        setTimeout(() => {
  	          paintDirectionsButton();
  	        }, 1200);
  	      });
  	    }

  	    function formatMapsPoint(point) {
  	      if (!point) return "";

  	      return `${Number(point.lat).toFixed(7)},${Number(point.lng).toFixed(7)}`;
  	    }

  	    function buildGoogleMapsDirectionsUrl() {
  	      const s = getTrackitDirectionsState();

  	      if (!s.point1 || !s.point2) return "";

  	      const params = new URLSearchParams();

  	      params.set("api", "1");
  	      params.set("origin", formatMapsPoint(s.point1));
  	      params.set("destination", formatMapsPoint(s.point2));
  	      params.set("travelmode", "driving");

  	      const stops = (s.waypoints || [])
  	      .filter(wp => !!wp?.point)
  	      .map(wp => formatMapsPoint(wp.point))
  	      .filter(Boolean);

  	      if (stops.length) {
  	        params.set("waypoints", stops.join("|"));
  	      }

  	      return `https://www.google.com/maps/dir/?${params.toString()}`;
  	    }

  	    const TRACKIT_WHATSAPP_COUNTRIES = [{
  	      iso: "ZA",
  	      label: "South Africa",
  	      dial: "+27",
  	      example: "0821234567",
  	      nsnMin: 9,
  	      nsnMax: 9,
  	      mobilePattern: /^[6-8]\d{8}$/
  	    },
  	      {
  	        iso: "BW",
  	        label: "Botswana",
  	        dial: "+267",
  	        example: "71234567",
  	        nsnMin: 7,
  	        nsnMax: 8
  	      },
  	      {
  	        iso: "NA",
  	        label: "Namibia",
  	        dial: "+264",
  	        example: "811234567",
  	        nsnMin: 8,
  	        nsnMax: 9
  	      },
  	      {
  	        iso: "ZW",
  	        label: "Zimbabwe",
  	        dial: "+263",
  	        example: "771234567",
  	        nsnMin: 9,
  	        nsnMax: 9
  	      },
  	      {
  	        iso: "ZM",
  	        label: "Zambia",
  	        dial: "+260",
  	        example: "971234567",
  	        nsnMin: 9,
  	        nsnMax: 9
  	      },
  	      {
  	        iso: "MZ",
  	        label: "Mozambique",
  	        dial: "+258",
  	        example: "841234567",
  	        nsnMin: 9,
  	        nsnMax: 9
  	      },
  	      {
  	        iso: "LS",
  	        label: "Lesotho",
  	        dial: "+266",
  	        example: "50123456",
  	        nsnMin: 8,
  	        nsnMax: 8
  	      },
  	      {
  	        iso: "SZ",
  	        label: "Eswatini",
  	        dial: "+268",
  	        example: "76123456",
  	        nsnMin: 8,
  	        nsnMax: 8
  	      },
  	      {
  	        iso: "MW",
  	        label: "Malawi",
  	        dial: "+265",
  	        example: "991234567",
  	        nsnMin: 9,
  	        nsnMax: 9
  	      },
  	      {
  	        iso: "GB",
  	        label: "United Kingdom",
  	        dial: "+44",
  	        example: "7123456789",
  	        nsnMin: 9,
  	        nsnMax: 10
  	      },
  	      {
  	        iso: "US",
  	        label: "United States",
  	        dial: "+1",
  	        example: "3133950896",
  	        nsnMin: 10,
  	        nsnMax: 10
  	      },
  	      {
  	        iso: "INTL",
  	        label: "International",
  	        dial: "",
  	        example: "+27821234567",
  	        nsnMin: 8,
  	        nsnMax: 15,
  	        allowAnyIntl: true
  	      }];

  	    function getWhatsappCountryByIso(iso) {
  	      return TRACKIT_WHATSAPP_COUNTRIES.find(c => c.iso === iso) || TRACKIT_WHATSAPP_COUNTRIES[0];
  	    }

  	    function getWhatsappCountryOptionsHtml(selectedIso) {
  	      return TRACKIT_WHATSAPP_COUNTRIES.map(country => {
  	        const selected = country.iso === selectedIso ? "selected": "";
  	        const label = country.dial
  	        ? `${country.iso} ${country.dial}`: `${country.iso} +`;

  	        return `<option value="${country.iso}" ${selected}>${label}</option>`;
  	      }).join("");
  	    }

  	    function getSelectedWhatsappCountry(popup) {
  	      const select = popup?.querySelector?.(".trackit-directions-country-select");
  	      return getWhatsappCountryByIso(select?.value || "ZA");
  	    }

  	    function updateWhatsappPhonePlaceholder(popup) {
  	      const country = getSelectedWhatsappCountry(popup);
  	      const phoneInput = popup?.querySelector?.(".trackit-directions-whatsapp-phone");

  	      if (!phoneInput) return;

  	      if (country.allowAnyIntl) {
  	        phoneInput.placeholder = "Full number e.g. +27821234567";
  	        return;
  	      }

  	      phoneInput.placeholder = `${country.iso} WhatsApp e.g. ${country.example}`;
  	    }

  	    function normaliseWhatsappNumber(raw, countryIso) {
  	      const country = getWhatsappCountryByIso(countryIso || "ZA");

  	      let text = String(raw || "").trim();

  	      if (!text) {
  	        return {
  	          ok: false,
  	          value: "",
  	          error: "Enter a WhatsApp number first."
  	        };
  	      }

  	      text = text.replace(/^whatsapp:/i, "").trim();
  	      text = text.replace(/[^\d+]/g, "");

  	      const plusCount = (text.match(/\+/g) || []).length;

  	      if (plusCount > 1 || (text.includes("+") && !text.startsWith("+"))) {
  	        return {
  	          ok: false,
  	          value: "",
  	          error: "Invalid WhatsApp number format."
  	        };
  	      }

  	      let digits = text.replace(/\D/g, "");

  	      if (country.allowAnyIntl) {
  	        if (!text.startsWith("+")) {
  	          return {
  	            ok: false,
  	            value: "",
  	            error: "Use full international format, for example +27821234567."
  	          };
  	        }

  	        if (digits.length < 8 || digits.length > 15) {
  	          return {
  	            ok: false,
  	            value: "",
  	            error: "WhatsApp number must be 8 to 15 digits in international format."
  	          };
  	        }

  	        return {
  	          ok: true,
  	          value: `+${digits}`,
  	          country
  	        };
  	      }

  	      const dialDigits = country.dial.replace(/\D/g, "");
  	      let nationalNumber = "";

  	      if (text.startsWith("+")) {
  	        if (!digits.startsWith(dialDigits)) {
  	          return {
  	            ok: false,
  	            value: "",
  	            error: `Number does not match selected country ${country.iso} ${country.dial}.`
  	          };
  	        }

  	        nationalNumber = digits.slice(dialDigits.length);
  	      } else {
  	        if (digits.startsWith(dialDigits) && digits.length > dialDigits.length + 3) {
  	          nationalNumber = digits.slice(dialDigits.length);
  	        } else {
  	          nationalNumber = digits;
  	        }

  	        // Local SA-style trunk prefix:
  	        // 0821234567 -> 821234567
  	        if (nationalNumber.startsWith("0")) {
  	          nationalNumber = nationalNumber.slice(1);
  	        }
  	      }

  	      if (
  	        nationalNumber.length < country.nsnMin ||
  	        nationalNumber.length > country.nsnMax
  	      ) {
  	        return {
  	          ok: false,
  	          value: "",
  	          error: `${country.iso} number must be ${country.nsnMin === country.nsnMax ? country.nsnMin: `${country.nsnMin}-${country.nsnMax}`} digits after ${country.dial}.`
  	        };
  	      }

  	      if (country.mobilePattern && !country.mobilePattern.test(nationalNumber)) {
  	        return {
  	          ok: false,
  	          value: "",
  	          error: `That does not look like a valid ${country.iso} mobile WhatsApp number.`
  	        };
  	      }

  	      const e164 = `${country.dial}${nationalNumber}`;
  	      const e164Digits = e164.replace(/\D/g, "");

  	      if (e164Digits.length < 8 || e164Digits.length > 15) {
  	        return {
  	          ok: false,
  	          value: "",
  	          error: "WhatsApp number must be valid international E.164 format."
  	        };
  	      }

  	      return {
  	        ok: true,
  	        value: e164,
  	        country
  	      };
  	    }

  	    function getTrackitWhatsappButtonHtml(label) {
  	      return `
  	      <svg class="trackit-whatsapp-icon" viewBox="0 0 32 32" aria-hidden="true">
  	      <path fill="currentColor" d="M16.02 3.2C9.02 3.2 3.34 8.78 3.34 15.66c0 2.22.6 4.38 1.74 6.27L3.2 28.8l7.08-1.84a12.9 12.9 0 0 0 5.74 1.36c7 0 12.68-5.58 12.68-12.46S23.02 3.2 16.02 3.2Zm0 22.98c-1.84 0-3.64-.49-5.2-1.42l-.37-.22-4.2 1.09 1.12-4.02-.25-.41a10.06 10.06 0 0 1-1.56-5.34c0-5.69 4.7-10.32 10.46-10.32s10.46 4.63 10.46 10.32-4.7 10.32-10.46 10.32Zm5.74-7.72c-.31-.15-1.84-.9-2.13-1-.29-.1-.5-.15-.71.15-.21.31-.82 1-.99 1.2-.18.2-.36.23-.67.08-.31-.15-1.31-.48-2.5-1.53-.92-.81-1.54-1.81-1.72-2.12-.18-.3-.02-.47.13-.62.14-.14.31-.36.47-.54.16-.18.21-.31.31-.51.1-.2.05-.38-.03-.54-.08-.15-.71-1.69-.97-2.31-.25-.6-.51-.52-.71-.53h-.6c-.21 0-.55.08-.84.38-.29.3-1.1 1.06-1.1 2.59s1.13 3.01 1.29 3.22c.16.2 2.23 3.35 5.41 4.7.76.32 1.35.51 1.81.65.76.24 1.45.21 2 .13.61-.09 1.84-.74 2.1-1.45.26-.71.26-1.32.18-1.45-.08-.13-.29-.2-.6-.36Z"/>
  	      </svg>
  	      <span>${label}</span>
  	      `;
  	    }

  	    function setTrackitWhatsappButtonState(button, label, sending) {
  	      if (!button) return;

  	      button.classList.toggle("sending", !!sending);
  	      button.innerHTML = getTrackitWhatsappButtonHtml(label);
  	    }

  	    function getDirectionsSummaryForWhatsapp() {
  	      const s = getTrackitDirectionsState();

  	      const from = formatDirectionsPointText(s.point1, s.point1Label);
  	      const to = formatDirectionsPointText(s.point2, s.point2Label);
  	      const stops = (s.waypoints || [])
  	      .filter(wp => !!wp?.point)
  	      .map((wp, index) => `${index + 1}. ${formatDirectionsPointText(wp.point, wp.label)}`);

  	      return {
  	        from,
  	        to,
  	        stops
  	      };
  	    }

  	    async function sendDirectionsWhatsapp(triggerButton) {
  	      const s = getTrackitDirectionsState();
  	      const popup = s.popup;

  	      if (!popup) return;

  	      const phoneInput = popup.querySelector(".trackit-directions-whatsapp-phone");
  	      const countrySelect = popup.querySelector(".trackit-directions-country-select");
  	      const normalWhatsappBtn = popup.querySelector(".trackit-directions-whatsapp-btn");
  	      const sendBtn = triggerButton || normalWhatsappBtn;
  	      const idleButtonLabel = sendBtn?.classList?.contains("trackit-directions-driver-btn")
  	      ? "WhatsApp Driver"
  	      : "WhatsApp";

  	      const checkedNumber = normaliseWhatsappNumber(
  	        phoneInput?.value,
  	        countrySelect?.value || "ZA"
  	      );

  	      if (!checkedNumber.ok) {
  	        updateDirectionsStatusText(checkedNumber.error);
  	        phoneInput?.classList?.add("invalid");
  	        phoneInput?.focus?.();
  	        return;
  	      }

  	      phoneInput.classList.remove("invalid");
  	      phoneInput.value = checkedNumber.value;

  	      const to = checkedNumber.value;

  	      if (!s.point1 || !s.point2) {
  	        updateDirectionsStatusText("Build a route before sending.");
  	        return;
  	      }

  	      const mapsUrl = buildGoogleMapsDirectionsUrl();

  	      if (!mapsUrl) {
  	        updateDirectionsStatusText("Could not build Google Maps route link.");
  	        return;
  	      }

  	      const summary = getDirectionsSummaryForWhatsapp();

  	      const stopsText = summary.stops.length
  	      ? summary.stops.join("\n"): "No stops";

  	      const payload = {
  	        To: to,
  	        FromLocation: summary.from,
  	        ToLocation: summary.to,
  	        Stops: stopsText,
  	        RouteLink: mapsUrl
  	      };

  	      try {
  	        setTrackitWhatsappButtonState(sendBtn, "Sending...", true);

  	        updateDirectionsStatusText("Sending WhatsApp route...");

  	        console.log("[TrackIT WhatsApp] Sending template payload:", payload);

  	        const result = await invokeTrackitWhatsAppService(payload);

  	        updateDirectionsStatusText("WhatsApp route sent.");
  	        console.log("[TrackIT WhatsApp] Sent:", result);

  	      } catch (error) {
  	        console.error("[TrackIT WhatsApp] Send failed:", error);

  	        const message = error?.message || String(error || "");

  	        if (message.includes("not available")) {
  	          updateDirectionsStatusText("WhatsApp failed. Backendless service invoke is not available on this screen.");
  	        } else {
  	          updateDirectionsStatusText("WhatsApp failed. Check template approval, Backendless service config, and Twilio logs.");
  	        }

  	      } finally {
  	        setTrackitWhatsappButtonState(sendBtn, idleButtonLabel, false);
  	      }
  	    }

  	    async function invokeTrackitWhatsAppService(payload) {
  	      const serviceArgs = {
  	        To: payload.To,
  	        FromLocation: payload.FromLocation,
  	        ToLocation: payload.ToLocation,
  	        Stops: payload.Stops,
  	        RouteLink: payload.RouteLink
  	      };

  	      console.log("[TrackIT WhatsApp] Backendless service args:", serviceArgs);

  	      if (
  	        typeof Backendless !== "undefined" &&
  	        Backendless.CustomServices &&
  	        typeof Backendless.CustomServices.invoke === "function"
  	      ) {
  	        return Backendless.CustomServices.invoke(
  	          TRACKIT_WHATSAPP_SERVICE_NAME,
  	          TRACKIT_WHATSAPP_METHOD_NAME,
  	          serviceArgs
  	        );
  	      }

  	      if (
  	        typeof BackendlessUI !== "undefined" &&
  	        BackendlessUI.Backendless &&
  	        BackendlessUI.Backendless.CustomServices &&
  	        typeof BackendlessUI.Backendless.CustomServices.invoke === "function"
  	      ) {
  	        return BackendlessUI.Backendless.CustomServices.invoke(
  	          TRACKIT_WHATSAPP_SERVICE_NAME,
  	          TRACKIT_WHATSAPP_METHOD_NAME,
  	          serviceArgs
  	        );
  	      }

  	      if (
  	        typeof window !== "undefined" &&
  	        window.Backendless &&
  	        window.Backendless.CustomServices &&
  	        typeof window.Backendless.CustomServices.invoke === "function"
  	      ) {
  	        return window.Backendless.CustomServices.invoke(
  	          TRACKIT_WHATSAPP_SERVICE_NAME,
  	          TRACKIT_WHATSAPP_METHOD_NAME,
  	          serviceArgs
  	        );
  	      }

  	      throw new Error("Backendless CustomServices.invoke is not available.");
  	    }

  	    map.__trackitAddDirectionsPoint = addDirectionsPoint;
  	    map.__trackitGetDirectionsVehicleMeta = getDirectionsVehicleMetaFromTractor;
  	    map.__trackitStartDirectionsMode = startDirectionsMode;
  	    map.__trackitStopDirectionsMode = stopDirectionsMode;
  	    map.__trackitToggleDirectionsMode = toggleDirectionsMode;


  	    try {
  	      const positions = [
  	        google.maps.ControlPosition.RIGHT_BOTTOM,
  	        google.maps.ControlPosition.LEFT_BOTTOM,
  	        google.maps.ControlPosition.RIGHT_TOP,
  	        google.maps.ControlPosition.LEFT_TOP
  	      ];

  	      positions.forEach(pos => {
  	        const controls = map.controls[pos];

  	        for (let i = controls.getLength() - 1; i >= 0; i--) {
  	          const item = controls.getAt(i);

  	          if (item?.__trackitUnifiedMapControl) {
  	            controls.removeAt(i);
  	          }
  	        }
  	      });
  	    } catch (_) {}

  	    if (map.__trackitMapControlListeners) {
  	      map.__trackitMapControlListeners.forEach(listener => {
  	        try {
  	          google.maps.event.removeListener(listener);
  	        } catch (_) {}
  	      });
  	    }

  	    if (map.__trackitDomControlListeners) {
  	      map.__trackitDomControlListeners.forEach(({
  	        target, event, handler
  	      }) => {
  	        try {
  	          target.removeEventListener(event, handler);
  	        } catch (_) {}
  	      });
  	    }

  	    map.__trackitMapControlListeners = [];
  	    map.__trackitDomControlListeners = [];
  	    map.__trackitUnifiedMapControlReady = false;
  	    map.__trackitUnifiedMapControlVersion = "";

  	    const NO_LABEL_STYLES = [{
  	      elementType: "labels",
  	      stylers: [{
  	        visibility: "off"
  	      }]
  	    },
  	      {
  	        featureType: "poi",
  	        stylers: [{
  	          visibility: "off"
  	        }]
  	      },
  	      {
  	        featureType: "transit",
  	        stylers: [{
  	          visibility: "off"
  	        }]
  	      }];

  	    function getSettingsBag() {
  	      const bag = getAppBag();

  	      if (bag) {
  	        if (!bag.TrackITMapSettings) {
  	          bag.TrackITMapSettings = {};
  	        }

  	        return bag.TrackITMapSettings;
  	      }

  	      if (!map.__trackitLocalMapSettings) {
  	        map.__trackitLocalMapSettings = {};
  	      }

  	      return map.__trackitLocalMapSettings;
  	    }

  	    function writeSetting(key, value) {
  	      const settings = getSettingsBag();
  	      settings[key] = value;

  	      try {
  	        refreshApp();
  	      } catch (_) {}
  	    }

  	    function readSetting(key, fallback) {
  	      const settings = getSettingsBag();
  	      return settings[key] !== undefined ? settings[key]: fallback;
  	    }

  	    const oldStyle = document.getElementById("trackit-compact-map-control-css");
  	    if (oldStyle) oldStyle.remove();

  	    const style = document.createElement("style");
  	    style.id = "trackit-compact-map-control-css";

  	    style.textContent = `
  	    .trackit-compact-map-control.ces-bottom-shape {
  	    position: absolute !important;
  	    right: 0 !important;
  	    bottom: 0 !important;
  	    top: auto !important;
  	    z-index: 999999 !important;
  	    pointer-events: auto !important;
  	    box-sizing: border-box !important;
  	    color: #fff !important;
  	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;

  	    background:
  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.16), transparent 32%),
  	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;

  	    border-top: 1px solid rgba(255,122,36,0.52) !important;
  	    border-left: 1px solid rgba(255,122,36,0.52) !important;
  	    border-right: 0 !important;
  	    border-bottom: 0 !important;

  	    box-shadow:
  	    -12px -16px 32px rgba(0,0,0,0.40),
  	    inset 0 1px 0 rgba(255,255,255,0.045),
  	    inset 0 -18px 38px rgba(0,0,0,0.24) !important;

  	    user-select: none !important;
  	    }

  	    .trackit-compact-map-control.ces-bottom-shape::before {
  	    content: "" !important;
  	    position: absolute !important;
  	    inset: 0 !important;
  	    pointer-events: none !important;
  	    z-index: 1 !important;
  	    opacity: 0.16 !important;
  	    background:
  	    repeating-radial-gradient(
  	    ellipse at 34% 118%,
  	    transparent 0,
  	    transparent 9px,
  	    rgba(255,116,34,0.20) 10px,
  	    transparent 12px
  	    ) !important;
  	    }

  	    .trackit-compact-map-control .ces-bottom-content {
  	    position: relative !important;
  	    z-index: 2 !important;
  	    width: 100% !important;
  	    height: auto !important;
  	    padding: 10px 12px 12px 12px !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-compact-map-control.collapsed .ces-bottom-content {
  	    padding: 9px 12px !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-header {
  	    width: 100% !important;
  	    height: 38px !important;
  	    border: 0 !important;
  	    outline: 0 !important;
  	    background: transparent !important;
  	    color: inherit !important;
  	    display: grid !important;
  	    grid-template-columns: 31px minmax(0, 1fr) 16px !important;
  	    align-items: center !important;
  	    gap: 8px !important;
  	    padding: 0 !important;
  	    margin: 0 !important;
  	    cursor: pointer !important;
  	    text-align: left !important;
  	    appearance: none !important;
  	    -webkit-appearance: none !important;
  	    }

  	    .trackit-compact-map-control .ces-layer-icon {
  	    width: 30px !important;
  	    height: 30px !important;
  	    border-radius: 12px !important;
  	    display: flex !important;
  	    flex-direction: column !important;
  	    align-items: center !important;
  	    justify-content: center !important;
  	    gap: 3px !important;
  	    background:
  	    radial-gradient(circle at 35% 22%, rgba(255,153,70,0.42), rgba(4,5,5,0.92) 72%) !important;
  	    border: 1px solid rgba(255,132,48,0.54) !important;
  	    box-shadow:
  	    0 0 15px rgba(255,122,36,0.18),
  	    inset 0 1px 0 rgba(255,255,255,0.10) !important;
  	    }

  	    .trackit-compact-map-control .ces-layer-icon span {
  	    width: 14px !important;
  	    height: 2px !important;
  	    border-radius: 999px !important;
  	    background: #ff9a3d !important;
  	    box-shadow: 0 0 8px rgba(255,122,36,0.34) !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-header-text {
  	    min-width: 0 !important;
  	    }

  	    .trackit-compact-map-control .ces-map-title {
  	    font-size: 11px !important;
  	    font-weight: 950 !important;
  	    letter-spacing: 0.10em !important;
  	    text-transform: uppercase !important;
  	    color: #ffe3c5 !important;
  	    line-height: 1 !important;
  	    white-space: nowrap !important;
  	    overflow: hidden !important;
  	    text-overflow: ellipsis !important;
  	    margin: 0 !important;
  	    padding: 0 !important;
  	    }

  	    .trackit-compact-map-control .ces-map-subtitle {
  	    margin: 4px 0 0 !important;
  	    padding: 0 !important;
  	    font-size: 7px !important;
  	    font-weight: 950 !important;
  	    letter-spacing: 0.13em !important;
  	    text-transform: uppercase !important;
  	    color: rgba(255,255,255,0.56) !important;
  	    line-height: 1 !important;
  	    white-space: nowrap !important;
  	    overflow: hidden !important;
  	    text-overflow: ellipsis !important;
  	    }

  	    .trackit-compact-map-control .ces-caret {
  	    color: #ff8a3c !important;
  	    font-size: 12px !important;
  	    font-weight: 950 !important;
  	    display: flex !important;
  	    align-items: center !important;
  	    justify-content: center !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-body {
  	    display: grid !important;
  	    grid-template-columns: minmax(0, 1fr) 56px !important;
  	    gap: 12px !important;
  	    align-items: start !important;
  	    margin-top: 12px !important;
  	    min-width: 0 !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-compact-map-control.collapsed .ces-map-control-body {
  	    display: none !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-main {
  	    min-width: 0 !important;
  	    display: flex !important;
  	    flex-direction: column !important;
  	    gap: 12px !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-section {
  	    display: flex !important;
  	    flex-direction: column !important;
  	    gap: 7px !important;
  	    min-width: 0 !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-section-title {
  	    height: auto !important;
  	    min-height: 13px !important;
  	    display: flex !important;
  	    align-items: center !important;
  	    gap: 6px !important;
  	    color: rgba(255,232,208,0.78) !important;
  	    font-size: 8px !important;
  	    font-weight: 950 !important;
  	    letter-spacing: 0.12em !important;
  	    text-transform: uppercase !important;
  	    line-height: 1 !important;
  	    padding: 0 !important;
  	    margin: 0 !important;
  	    border: 0 !important;
  	    background: transparent !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-section-title svg {
  	    width: 13px !important;
  	    height: 13px !important;
  	    color: #ff8a3c !important;
  	    flex: 0 0 auto !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-tools {
  	    display: grid !important;
  	    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	    grid-auto-rows: 38px !important;
  	    gap: 7px !important;
  	    min-width: 0 !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-compact-map-control .fleet-map-type-tools {
  	    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-tool {
  	    width: auto !important;
  	    height: 36px !important;
  	    min-width: 0 !important;
  	    border-radius: 13px !important;
  	    border: 1px solid rgba(255,255,255,0.10) !important;
  	    background:
  	    linear-gradient(145deg, rgba(255,255,255,0.055), rgba(255,255,255,0.018)) !important;
  	    color: rgba(255,255,255,0.78) !important;
  	    display: flex !important;
  	    align-items: center !important;
  	    justify-content: flex-start !important;
  	    gap: 8px !important;
  	    padding: 0 10px !important;
  	    box-sizing: border-box !important;
  	    cursor: pointer !important;
  	    font-size: 10px !important;
  	    font-weight: 950 !important;
  	    text-align: left !important;
  	    overflow: hidden !important;
  	    box-shadow:
  	    inset 0 0 0 1px rgba(255,255,255,0.025),
  	    0 7px 14px rgba(0,0,0,0.18) !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-tool svg {
  	    width: 14px !important;
  	    height: 14px !important;
  	    color: rgba(255,255,255,0.78) !important;
  	    flex: 0 0 14px !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-tool span {
  	    min-width: 0 !important;
  	    overflow: hidden !important;
  	    text-overflow: ellipsis !important;
  	    white-space: nowrap !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-tool:hover {
  	    color: #fff !important;
  	    border-color: rgba(255,138,61,0.38) !important;
  	    background: rgba(255,138,61,0.10) !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-tool.active,
  	    .trackit-compact-map-control .ces-map-control-tool.fullscreen-active {
  	    color: #fff !important;
  	    border-color: rgba(255,138,61,0.62) !important;
  	    background:
  	    linear-gradient(145deg, rgba(255,122,36,0.28), rgba(95,42,17,0.32)) !important;
  	    box-shadow:
  	    inset 0 0 0 1px rgba(255,138,61,0.30),
  	    inset 0 0 18px rgba(255,105,25,0.12),
  	    0 7px 14px rgba(0,0,0,0.18) !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-tool.active svg,
  	    .trackit-compact-map-control .ces-map-control-tool.fullscreen-active svg {
  	    color: #ff9a3d !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-zoom-rail {
  	    width: 56px !important;
  	    min-width: 56px !important;
  	    height: 286px !important;
  	    min-height: 286px !important;
  	    max-height: 286px !important;
  	    display: grid !important;
  	    grid-template-rows: auto auto 32px 176px 32px !important;
  	    justify-items: center !important;
  	    align-items: center !important;
  	    box-sizing: border-box !important;
  	    align-self: start !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-zoom-label {
  	    color: rgba(255,232,208,0.78) !important;
  	    font-size: 8px !important;
  	    font-weight: 950 !important;
  	    letter-spacing: 0.12em !important;
  	    text-transform: uppercase !important;
  	    line-height: 1 !important;
  	    margin: 0 0 6px !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-zoom-value {
  	    width: 36px !important;
  	    height: 36px !important;
  	    border-radius: 999px !important;
  	    display: flex !important;
  	    align-items: center !important;
  	    justify-content: center !important;
  	    background:
  	    radial-gradient(circle at 40% 35%, rgba(255,255,255,0.22), rgba(25,25,25,0.88) 70%) !important;
  	    border: 2px solid rgba(255,122,39,0.68) !important;
  	    color: #fff !important;
  	    font-size: 12px !important;
  	    font-weight: 950 !important;
  	    box-shadow:
  	    0 0 10px rgba(255,105,25,0.24),
  	    inset 0 0 0 1px rgba(255,255,255,0.12) !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-zoom-btn {
  	    width: 32px !important;
  	    height: 32px !important;
  	    border-radius: 999px !important;
  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	    background: rgba(255,255,255,0.045) !important;
  	    color: #fff !important;
  	    cursor: pointer !important;
  	    font-weight: 950 !important;
  	    font-size: 16px !important;
  	    line-height: 1 !important;
  	    padding: 0 !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-zoom-btn:hover {
  	    background: rgba(255,111,29,0.16) !important;
  	    border-color: rgba(255,137,56,0.46) !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-slider-wrap {
  	    position: relative !important;
  	    display: flex !important;
  	    align-items: center !important;
  	    justify-content: center !important;
  	    width: 100% !important;
  	    height: 176px !important;
  	    min-height: 176px !important;
  	    max-height: 176px !important;
  	    margin: 8px 0 !important;
  	    padding: 0 !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-slider-wrap::before {
  	    content: "" !important;
  	    position: absolute !important;
  	    top: 8px !important;
  	    bottom: 8px !important;
  	    left: 50% !important;
  	    width: 1px !important;
  	    transform: translateX(-50%) !important;
  	    background: repeating-linear-gradient(
  	    to bottom,
  	    rgba(255,255,255,0.18) 0,
  	    rgba(255,255,255,0.18) 1px,
  	    transparent 1px,
  	    transparent 8px
  	    ) !important;
  	    }

  	    .trackit-compact-map-control .ces-map-control-zoom-slider {
  	    position: relative !important;
  	    z-index: 1 !important;
  	    writing-mode: vertical-lr !important;
  	    direction: rtl !important;
  	    width: 26px !important;
  	    height: 176px !important;
  	    min-height: 176px !important;
  	    max-height: 176px !important;
  	    accent-color: #ff7928 !important;
  	    cursor: pointer !important;
  	    margin: 0 !important;
  	    padding: 0 !important;
  	    appearance: auto !important;
  	    -webkit-appearance: slider-vertical !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-toggle-row {
  	    position: relative !important;
  	    width: 100% !important;
  	    user-select: none !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-toggle-row input {
  	    position: absolute !important;
  	    opacity: 0 !important;
  	    pointer-events: none !important;
  	    width: 0 !important;
  	    height: 0 !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-tick {
  	    width: 13px !important;
  	    height: 13px !important;
  	    flex: 0 0 13px !important;
  	    border-radius: 4px !important;
  	    border: 1px solid rgba(255,255,255,0.24) !important;
  	    background: rgba(255,255,255,0.045) !important;
  	    box-shadow:
  	    inset 0 0 0 1px rgba(255,255,255,0.025),
  	    0 4px 8px rgba(0,0,0,0.18) !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-toggle-row input:checked + .trackit-location-tick {
  	    border-color: rgba(255,138,61,0.72) !important;
  	    background:
  	    radial-gradient(circle at 40% 35%, rgba(255,154,61,0.95), rgba(255,122,36,0.26) 72%) !important;
  	    box-shadow:
  	    0 0 10px rgba(255,122,36,0.22),
  	    inset 0 0 0 1px rgba(255,255,255,0.16) !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-list {
  	    display: none !important;
  	    max-height: 116px !important;
  	    overflow-y: auto !important;
  	    overflow-x: hidden !important;
  	    padding: 2px 3px 2px 0 !important;
  	    margin: 0 !important;
  	    gap: 5px !important;
  	    flex-direction: column !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-list.visible {
  	    display: flex !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-list::-webkit-scrollbar {
  	    width: 5px !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-list::-webkit-scrollbar-thumb {
  	    background: rgba(255,122,36,0.42) !important;
  	    border-radius: 999px !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-row {
  	    width: 100% !important;
  	    height: 30px !important;
  	    min-height: 30px !important;
  	    border-radius: 11px !important;
  	    border: 1px solid rgba(255,255,255,0.09) !important;
  	    background:
  	    linear-gradient(145deg, rgba(255,255,255,0.045), rgba(255,255,255,0.014)) !important;
  	    color: rgba(255,255,255,0.76) !important;
  	    display: grid !important;
  	    grid-template-columns: minmax(0, 1fr) auto !important;
  	    align-items: center !important;
  	    gap: 8px !important;
  	    padding: 0 9px !important;
  	    box-sizing: border-box !important;
  	    cursor: pointer !important;
  	    font-size: 9px !important;
  	    font-weight: 900 !important;
  	    text-align: left !important;
  	    overflow: hidden !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-row:hover {
  	    color: #fff !important;
  	    border-color: rgba(255,138,61,0.34) !important;
  	    background: rgba(255,138,61,0.09) !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-row.active {
  	    color: #fff !important;
  	    border-color: rgba(255,138,61,0.60) !important;
  	    background:
  	    linear-gradient(145deg, rgba(255,122,36,0.24), rgba(95,42,17,0.28)) !important;
  	    box-shadow:
  	    inset 0 0 0 1px rgba(255,138,61,0.24),
  	    0 7px 14px rgba(0,0,0,0.16) !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-row {
  	    position: relative !important;
  	    grid-template-columns: 14px minmax(0, 1fr) auto !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-row input {
  	    position: absolute !important;
  	    opacity: 0 !important;
  	    pointer-events: none !important;
  	    width: 0 !important;
  	    height: 0 !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-row .trackit-location-tick {
  	    width: 13px !important;
  	    height: 13px !important;
  	    border-radius: 4px !important;
  	    border: 1px solid rgba(255,255,255,0.24) !important;
  	    background: rgba(255,255,255,0.045) !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-row input:checked + .trackit-location-tick {
  	    border-color: rgba(255,138,61,0.72) !important;
  	    background:
  	    radial-gradient(circle at 40% 35%, rgba(255,154,61,0.95), rgba(255,122,36,0.26) 72%) !important;
  	    box-shadow:
  	    0 0 10px rgba(255,122,36,0.22),
  	    inset 0 0 0 1px rgba(255,255,255,0.16) !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-name {
  	    min-width: 0 !important;
  	    overflow: hidden !important;
  	    text-overflow: ellipsis !important;
  	    white-space: nowrap !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-company-count {
  	    opacity: 0.58 !important;
  	    font-size: 8px !important;
  	    font-weight: 950 !important;
  	    }

  	    .trackit-compact-map-control .trackit-location-empty {
  	    color: rgba(255,255,255,0.48) !important;
  	    font-size: 9px !important;
  	    font-weight: 800 !important;
  	    padding: 5px 2px !important;
  	    }

  	    .trackit-location-label-black {
  	    position: absolute !important;
  	    transform: translate(-50%, -100%) !important;
  	    background: rgba(0,0,0,0.86) !important;
  	    color: #fff !important;
  	    border: 1px solid rgba(255,255,255,0.18) !important;
  	    border-radius: 7px !important;
  	    padding: 3px 7px !important;
  	    font: 900 10px/1.2 Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	    letter-spacing: 0.02em !important;
  	    white-space: nowrap !important;
  	    pointer-events: none !important;
  	    box-shadow:
  	    0 4px 10px rgba(0,0,0,0.42),
  	    inset 0 1px 0 rgba(255,255,255,0.08) !important;
  	    }


  	    .trackit-directions-popup-header {
  	    height: 48px !important;
  	    display: flex !important;
  	    align-items: center !important;
  	    justify-content: space-between !important;
  	    gap: 10px !important;
  	    padding: 8px 10px !important;
  	    box-sizing: border-box !important;
  	    cursor: move !important;
  	    border-bottom: 1px solid rgba(255,255,255,0.08) !important;
  	    background: rgba(255,138,61,0.08) !important;
  	    }

  	    .trackit-directions-popup-title {
  	    font-size: 12px !important;
  	    font-weight: 950 !important;
  	    letter-spacing: 0.10em !important;
  	    text-transform: uppercase !important;
  	    color: #ffe3c5 !important;
  	    line-height: 1 !important;
  	    }

  	    .trackit-directions-popup-subtitle {
  	    margin-top: 5px !important;
  	    font-size: 10px !important;
  	    font-weight: 850 !important;
  	    color: rgba(255,255,255,0.66) !important;
  	    line-height: 1 !important;
  	    }

  	    .trackit-directions-popup-close {
  	    width: 26px !important;
  	    height: 26px !important;
  	    border-radius: 999px !important;
  	    border: 1px solid rgba(255,255,255,0.14) !important;
  	    background: rgba(255,255,255,0.06) !important;
  	    color: #fff !important;
  	    cursor: pointer !important;
  	    font-size: 18px !important;
  	    font-weight: 900 !important;
  	    line-height: 22px !important;
  	    padding: 0 !important;
  	    }

  	    .trackit-directions-popup-body {
  	    padding: 10px !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-directions-search-wrap {
  	    display: flex !important;
  	    flex-direction: column !important;
  	    gap: 8px !important;
  	    padding: 10px !important;
  	    box-sizing: border-box !important;
  	    border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	    }

  	    .trackit-directions-search-line {
  	    display: grid !important;
  	    grid-template-columns: 42px minmax(0, 1fr) !important;
  	    align-items: center !important;
  	    gap: 8px !important;
  	    }

  	    .trackit-directions-search-line span {
  	    font-size: 9px !important;
  	    font-weight: 950 !important;
  	    text-transform: uppercase !important;
  	    color: rgba(255,232,208,0.74) !important;
  	    letter-spacing: 0.08em !important;
  	    }

  	    .trackit-directions-search-line input {
  	    width: 100% !important;
  	    height: 30px !important;
  	    min-width: 0 !important;
  	    border-radius: 10px !important;
  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	    background: rgba(255,255,255,0.06) !important;
  	    color: #fff !important;
  	    outline: none !important;
  	    padding: 0 9px !important;
  	    box-sizing: border-box !important;
  	    font-size: 10px !important;
  	    font-weight: 800 !important;
  	    }

  	    .trackit-directions-search-line input::placeholder {
  	    color: rgba(255,255,255,0.42) !important;
  	    }

  	    .trackit-directions-search-line input:focus {
  	    border-color: rgba(255,138,61,0.56) !important;
  	    background: rgba(255,138,61,0.10) !important;
  	    }

  	    .trackit-directions-status {
  	    padding: 0 10px 8px !important;
  	    color: rgba(255,255,255,0.62) !important;
  	    font-size: 9px !important;
  	    font-weight: 850 !important;
  	    line-height: 1.25 !important;
  	    }

  	    .trackit-directions-popup .pac-container {
  	    z-index: 1000002 !important;
  	    }

  	    .trackit-directions-row {
  	    display: grid !important;
  	    grid-template-columns: 44px minmax(0, 1fr) !important;
  	    gap: 8px !important;
  	    align-items: center !important;
  	    padding: 6px 0 !important;
  	    border-bottom: 1px solid rgba(255,255,255,0.06) !important;
  	    }

  	    .trackit-directions-row span {
  	    font-size: 9px !important;
  	    font-weight: 950 !important;
  	    text-transform: uppercase !important;
  	    color: rgba(255,232,208,0.70) !important;
  	    }

  	    .trackit-directions-row strong {
  	    min-width: 0 !important;
  	    overflow: hidden !important;
  	    text-overflow: ellipsis !important;
  	    white-space: nowrap !important;
  	    font-size: 10px !important;
  	    font-weight: 850 !important;
  	    color: rgba(255,255,255,0.82) !important;
  	    text-align: right !important;
  	    }

  	    .trackit-directions-actions {
  	    display: grid !important;
  	    grid-template-columns: 1fr 1fr !important;
  	    gap: 7px !important;
  	    margin-top: 10px !important;
  	    }

  	    .trackit-directions-actions button {
  	    height: 30px !important;
  	    border-radius: 11px !important;
  	    border: 1px solid rgba(255,255,255,0.10) !important;
  	    background: rgba(255,255,255,0.045) !important;
  	    color: rgba(255,255,255,0.82) !important;
  	    cursor: pointer !important;
  	    font-size: 10px !important;
  	    font-weight: 900 !important;
  	    }

  	    .trackit-directions-actions button:hover {
  	    color: #fff !important;
  	    border-color: rgba(255,138,61,0.38) !important;
  	    background: rgba(255,138,61,0.10) !important;
  	    }

  	    /* ---------- Google Places dropdown dark styling ---------- */
  	    .pac-container {
  	    z-index: 1000005 !important;
  	    border-radius: 14px !important;
  	    overflow: hidden !important;
  	    border: 1px solid rgba(255,122,36,0.48) !important;
  	    background:
  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.14), transparent 35%),
  	    linear-gradient(145deg, rgba(16,17,16,0.98), rgba(3,7,7,0.99)) !important;
  	    box-shadow:
  	    0 18px 34px rgba(0,0,0,0.46),
  	    inset 0 1px 0 rgba(255,255,255,0.055) !important;
  	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	    }

  	    .pac-item {
  	    height: auto !important;
  	    min-height: 36px !important;
  	    padding: 8px 10px !important;
  	    border-top: 1px solid rgba(255,255,255,0.06) !important;
  	    color: rgba(255,255,255,0.66) !important;
  	    background: transparent !important;
  	    cursor: pointer !important;
  	    font-size: 10px !important;
  	    line-height: 1.25 !important;
  	    }

  	    .pac-item:hover,
  	    .pac-item-selected {
  	    background: rgba(255,138,61,0.14) !important;
  	    }

  	    .pac-item-query {
  	    color: #ffe3c5 !important;
  	    font-weight: 950 !important;
  	    font-size: 10px !important;
  	    }

  	    .pac-matched {
  	    color: #ff9a3d !important;
  	    font-weight: 950 !important;
  	    }

  	    .pac-icon {
  	    filter: invert(1) opacity(0.75) !important;
  	    }

  	    /* ---------- TrackIT vehicle suggestions ---------- */
  	    .trackit-directions-input-wrap {
  	    position: relative !important;
  	    min-width: 0 !important;
  	    width: 100% !important;
  	    }

  	    .trackit-directions-vehicle-suggest {
  	    display: none !important;
  	    position: absolute !important;
  	    top: 34px !important;
  	    left: 0 !important;
  	    right: 0 !important;
  	    z-index: 1000004 !important;
  	    max-height: 168px !important;
  	    overflow-y: auto !important;
  	    overflow-x: hidden !important;
  	    border-radius: 13px !important;
  	    border: 1px solid rgba(255,122,36,0.44) !important;
  	    background:
  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.13), transparent 35%),
  	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	    box-shadow: 0 14px 26px rgba(0,0,0,0.42) !important;
  	    padding: 4px !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-directions-vehicle-suggest.visible {
  	    display: block !important;
  	    }

  	    .trackit-directions-vehicle-option {
  	    width: 100% !important;
  	    min-height: 32px !important;
  	    border: 0 !important;
  	    border-radius: 10px !important;
  	    background: transparent !important;
  	    color: rgba(255,255,255,0.78) !important;
  	    display: grid !important;
  	    grid-template-columns: minmax(0, 1fr) auto !important;
  	    align-items: center !important;
  	    gap: 8px !important;
  	    padding: 6px 8px !important;
  	    box-sizing: border-box !important;
  	    cursor: pointer !important;
  	    text-align: left !important;
  	    }

  	    .trackit-directions-vehicle-option:hover {
  	    background: rgba(255,138,61,0.14) !important;
  	    color: #fff !important;
  	    }

  	    .trackit-directions-vehicle-id {
  	    min-width: 0 !important;
  	    overflow: hidden !important;
  	    text-overflow: ellipsis !important;
  	    white-space: nowrap !important;
  	    font-size: 10px !important;
  	    font-weight: 950 !important;
  	    color: #ffe3c5 !important;
  	    }

  	    .trackit-directions-vehicle-meta {
  	    font-size: 8px !important;
  	    font-weight: 900 !important;
  	    color: rgba(255,255,255,0.50) !important;
  	    text-transform: uppercase !important;
  	    }

  	    .trackit-directions-waypoints {
  	    display: flex !important;
  	    flex-direction: column !important;
  	    gap: 8px !important;
  	    }

  	    .trackit-directions-search-line {
  	    display: grid !important;
  	    grid-template-columns: 42px minmax(0, 1fr) 24px !important;
  	    align-items: center !important;
  	    gap: 8px !important;
  	    }

  	    .trackit-directions-search-line.no-remove {
  	    grid-template-columns: 42px minmax(0, 1fr) !important;
  	    }

  	    .trackit-directions-remove-stop {
  	    width: 22px !important;
  	    height: 22px !important;
  	    border-radius: 999px !important;
  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	    background: rgba(255,255,255,0.045) !important;
  	    color: rgba(255,255,255,0.78) !important;
  	    cursor: pointer !important;
  	    font-size: 14px !important;
  	    font-weight: 950 !important;
  	    line-height: 18px !important;
  	    padding: 0 !important;
  	    }

  	    .trackit-directions-remove-stop:hover {
  	    color: #fff !important;
  	    border-color: rgba(255,138,61,0.45) !important;
  	    background: rgba(255,138,61,0.14) !important;
  	    }

  	    .trackit-directions-add-stop {
  	    height: 30px !important;
  	    border-radius: 11px !important;
  	    border: 1px solid rgba(255,138,61,0.35) !important;
  	    background: rgba(255,138,61,0.08) !important;
  	    color: #ffe3c5 !important;
  	    cursor: pointer !important;
  	    font-size: 10px !important;
  	    font-weight: 950 !important;
  	    letter-spacing: 0.04em !important;
  	    }

  	    .trackit-directions-add-stop:hover {
  	    background: rgba(255,138,61,0.16) !important;
  	    border-color: rgba(255,138,61,0.62) !important;
  	    color: #fff !important;
  	    }

  	    /* ---------- Directions: Google dropdown dark styling ---------- */
  	    .pac-container {
  	    z-index: 1000005 !important;
  	    border-radius: 14px !important;
  	    overflow: hidden !important;
  	    border: 1px solid rgba(255,122,36,0.48) !important;
  	    background:
  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.14), transparent 35%),
  	    linear-gradient(145deg, rgba(16,17,16,0.98), rgba(3,7,7,0.99)) !important;
  	    box-shadow:
  	    0 18px 34px rgba(0,0,0,0.46),
  	    inset 0 1px 0 rgba(255,255,255,0.055) !important;
  	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	    }

  	    .pac-item {
  	    min-height: 36px !important;
  	    padding: 8px 10px !important;
  	    border-top: 1px solid rgba(255,255,255,0.06) !important;
  	    color: rgba(255,255,255,0.66) !important;
  	    background: transparent !important;
  	    cursor: pointer !important;
  	    font-size: 10px !important;
  	    line-height: 1.25 !important;
  	    }

  	    .pac-item:hover,
  	    .pac-item-selected {
  	    background: rgba(255,138,61,0.14) !important;
  	    }

  	    .pac-item-query {
  	    color: #ffe3c5 !important;
  	    font-weight: 950 !important;
  	    font-size: 10px !important;
  	    }

  	    .pac-matched {
  	    color: #ff9a3d !important;
  	    font-weight: 950 !important;
  	    }

  	    .pac-icon {
  	    filter: invert(1) opacity(0.75) !important;
  	    }

  	    .trackit-directions-popup {
  	    position: absolute !important;
  	    z-index: 999998 !important;
  	    width: 330px !important;
  	    border-radius: 16px !important;
  	    overflow: visible !important;
  	    color: #fff !important;
  	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	    background:
  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.16), transparent 32%),
  	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	    border: 1px solid rgba(255,122,36,0.52) !important;
  	    box-shadow:
  	    0 18px 34px rgba(0,0,0,0.45),
  	    inset 0 1px 0 rgba(255,255,255,0.055) !important;
  	    pointer-events: auto !important;
  	    }

  	    .trackit-directions-popup-header {
  	    height: 48px !important;
  	    display: flex !important;
  	    align-items: center !important;
  	    justify-content: space-between !important;
  	    gap: 10px !important;
  	    padding: 8px 10px !important;
  	    box-sizing: border-box !important;
  	    cursor: move !important;
  	    border-bottom: 1px solid rgba(255,255,255,0.08) !important;
  	    background: rgba(255,138,61,0.08) !important;
  	    border-radius: 16px 16px 0 0 !important;
  	    }

  	    .trackit-directions-popup-title {
  	    font-size: 12px !important;
  	    font-weight: 950 !important;
  	    letter-spacing: 0.10em !important;
  	    text-transform: uppercase !important;
  	    color: #ffe3c5 !important;
  	    line-height: 1 !important;
  	    }

  	    .trackit-directions-popup-subtitle {
  	    margin-top: 5px !important;
  	    font-size: 10px !important;
  	    font-weight: 850 !important;
  	    color: rgba(255,255,255,0.66) !important;
  	    line-height: 1 !important;
  	    }

  	    .trackit-directions-popup-close {
  	    width: 26px !important;
  	    height: 26px !important;
  	    border-radius: 999px !important;
  	    border: 1px solid rgba(255,255,255,0.14) !important;
  	    background: rgba(255,255,255,0.06) !important;
  	    color: #fff !important;
  	    cursor: pointer !important;
  	    font-size: 18px !important;
  	    font-weight: 900 !important;
  	    line-height: 22px !important;
  	    padding: 0 !important;
  	    }

  	    .trackit-directions-search-wrap {
  	    display: flex !important;
  	    flex-direction: column !important;
  	    gap: 8px !important;
  	    padding: 10px !important;
  	    box-sizing: border-box !important;
  	    border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	    }

  	    .trackit-directions-search-line {
  	    display: grid !important;
  	    grid-template-columns: 46px minmax(0, 1fr) 24px !important;
  	    align-items: center !important;
  	    gap: 8px !important;
  	    min-width: 0 !important;
  	    }

  	    .trackit-directions-search-line.no-remove {
  	    grid-template-columns: 46px minmax(0, 1fr) !important;
  	    }

  	    .trackit-directions-search-line span {
  	    font-size: 9px !important;
  	    font-weight: 950 !important;
  	    text-transform: uppercase !important;
  	    color: rgba(255,232,208,0.74) !important;
  	    letter-spacing: 0.08em !important;
  	    }

  	    .trackit-directions-input-wrap {
  	    position: relative !important;
  	    min-width: 0 !important;
  	    width: 100% !important;
  	    }

  	    .trackit-directions-search-line input,
  	    .trackit-directions-whatsapp-wrap input {
  	    width: 100% !important;
  	    height: 30px !important;
  	    min-width: 0 !important;
  	    border-radius: 10px !important;
  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	    background: rgba(255,255,255,0.06) !important;
  	    color: #fff !important;
  	    outline: none !important;
  	    padding: 0 9px !important;
  	    box-sizing: border-box !important;
  	    font-size: 10px !important;
  	    font-weight: 850 !important;
  	    }

  	    .trackit-directions-search-line input::placeholder,
  	    .trackit-directions-whatsapp-wrap input::placeholder {
  	    color: rgba(255,255,255,0.42) !important;
  	    }

  	    .trackit-directions-search-line input:focus {
  	    border-color: rgba(255,138,61,0.56) !important;
  	    background: rgba(255,138,61,0.10) !important;
  	    }

  	    .trackit-directions-vehicle-suggest {
  	    display: none !important;
  	    position: absolute !important;
  	    top: 34px !important;
  	    left: 0 !important;
  	    right: 0 !important;
  	    z-index: 1000004 !important;
  	    max-height: 168px !important;
  	    overflow-y: auto !important;
  	    overflow-x: hidden !important;
  	    border-radius: 13px !important;
  	    border: 1px solid rgba(255,122,36,0.44) !important;
  	    background:
  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.13), transparent 35%),
  	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	    box-shadow: 0 14px 26px rgba(0,0,0,0.42) !important;
  	    padding: 4px !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-directions-vehicle-suggest.visible {
  	    display: block !important;
  	    }

  	    .trackit-directions-vehicle-option {
  	    width: 100% !important;
  	    min-height: 32px !important;
  	    border: 0 !important;
  	    border-radius: 10px !important;
  	    background: transparent !important;
  	    color: rgba(255,255,255,0.78) !important;
  	    display: grid !important;
  	    grid-template-columns: minmax(0, 1fr) auto !important;
  	    align-items: center !important;
  	    gap: 8px !important;
  	    padding: 6px 8px !important;
  	    box-sizing: border-box !important;
  	    cursor: pointer !important;
  	    text-align: left !important;
  	    }

  	    .trackit-directions-vehicle-option:hover {
  	    background: rgba(255,138,61,0.14) !important;
  	    color: #fff !important;
  	    }

  	    .trackit-directions-vehicle-id {
  	    min-width: 0 !important;
  	    overflow: hidden !important;
  	    text-overflow: ellipsis !important;
  	    white-space: nowrap !important;
  	    font-size: 10px !important;
  	    font-weight: 950 !important;
  	    color: #ffe3c5 !important;
  	    }

  	    .trackit-directions-vehicle-meta {
  	    font-size: 8px !important;
  	    font-weight: 900 !important;
  	    color: rgba(255,255,255,0.50) !important;
  	    text-transform: uppercase !important;
  	    }

  	    .trackit-directions-waypoints {
  	    display: flex !important;
  	    flex-direction: column !important;
  	    gap: 8px !important;
  	    }

  	    .trackit-directions-add-stop,
  	    .trackit-directions-remove-stop {
  	    cursor: pointer !important;
  	    }

  	    .trackit-directions-add-stop {
  	    height: 30px !important;
  	    border-radius: 11px !important;
  	    border: 1px solid rgba(255,138,61,0.35) !important;
  	    background: rgba(255,138,61,0.08) !important;
  	    color: #ffe3c5 !important;
  	    font-size: 10px !important;
  	    font-weight: 950 !important;
  	    letter-spacing: 0.04em !important;
  	    }

  	    .trackit-directions-add-stop:hover {
  	    background: rgba(255,138,61,0.16) !important;
  	    border-color: rgba(255,138,61,0.62) !important;
  	    color: #fff !important;
  	    }

  	    .trackit-directions-remove-stop {
  	    width: 22px !important;
  	    height: 22px !important;
  	    border-radius: 999px !important;
  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	    background: rgba(255,255,255,0.045) !important;
  	    color: rgba(255,255,255,0.78) !important;
  	    font-size: 14px !important;
  	    font-weight: 950 !important;
  	    line-height: 18px !important;
  	    padding: 0 !important;
  	    }

  	    .trackit-directions-remove-stop:hover {
  	    color: #fff !important;
  	    border-color: rgba(255,138,61,0.45) !important;
  	    background: rgba(255,138,61,0.14) !important;
  	    }

  	    .trackit-directions-status {
  	    padding: 8px 10px !important;
  	    color: rgba(255,255,255,0.62) !important;
  	    font-size: 9px !important;
  	    font-weight: 850 !important;
  	    line-height: 1.25 !important;
  	    border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	    }

  	    .trackit-directions-popup-body {
  	    padding: 10px !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-directions-row {
  	    display: grid !important;
  	    grid-template-columns: 48px minmax(0, 1fr) !important;
  	    gap: 8px !important;
  	    align-items: center !important;
  	    padding: 6px 0 !important;
  	    border-bottom: 1px solid rgba(255,255,255,0.06) !important;
  	    }

  	    .trackit-directions-row span {
  	    font-size: 9px !important;
  	    font-weight: 950 !important;
  	    text-transform: uppercase !important;
  	    color: rgba(255,232,208,0.70) !important;
  	    }

  	    .trackit-directions-row strong {
  	    min-width: 0 !important;
  	    overflow: hidden !important;
  	    text-overflow: ellipsis !important;
  	    white-space: nowrap !important;
  	    font-size: 10px !important;
  	    font-weight: 850 !important;
  	    color: rgba(255,255,255,0.82) !important;
  	    text-align: right !important;
  	    }

  	    .trackit-directions-actions {
  	    display: grid !important;
  	    grid-template-columns: 1fr 1fr !important;
  	    gap: 7px !important;
  	    margin-top: 10px !important;
  	    }

  	    .trackit-directions-actions button {
  	    height: 30px !important;
  	    border-radius: 11px !important;
  	    border: 1px solid rgba(255,255,255,0.10) !important;
  	    background: rgba(255,255,255,0.045) !important;
  	    color: rgba(255,255,255,0.82) !important;
  	    cursor: pointer !important;
  	    font-size: 10px !important;
  	    font-weight: 900 !important;
  	    }

  	    .trackit-directions-actions button:hover {
  	    color: #fff !important;
  	    border-color: rgba(255,138,61,0.38) !important;
  	    background: rgba(255,138,61,0.10) !important;
  	    }

  	    .trackit-directions-whatsapp-wrap {
  	    display: grid !important;
  	    grid-template-columns: minmax(0, 1fr) auto !important;
  	    gap: 7px !important;
  	    margin-top: 10px !important;
  	    align-items: center !important;
  	    }

  	    .trackit-directions-whatsapp-wrap input:focus {
  	    border-color: rgba(37,211,102,0.62) !important;
  	    background: rgba(37,211,102,0.10) !important;
  	    }

  	    .trackit-directions-whatsapp-btn {
  	    height: 30px !important;
  	    border-radius: 11px !important;
  	    border: 1px solid rgba(37,211,102,0.42) !important;
  	    background: rgba(37,211,102,0.10) !important;
  	    color: #d8ffe6 !important;
  	    cursor: pointer !important;
  	    font-size: 10px !important;
  	    font-weight: 950 !important;
  	    white-space: nowrap !important;
  	    padding: 0 10px !important;
  	    }

  	    .trackit-directions-whatsapp-btn:hover {
  	    border-color: rgba(37,211,102,0.78) !important;
  	    background: rgba(37,211,102,0.18) !important;
  	    color: #fff !important;
  	    }

  	    .trackit-directions-whatsapp-btn.sending {
  	    opacity: 0.72 !important;
  	    pointer-events: none !important;
  	    }

  	    .gm-svpc {
  	    display: none !important;
  	    opacity: 0 !important;
  	    pointer-events: none !important;
  	    }

  	    /* ---------- Directions popup docked right refinement ---------- */

  	    .trackit-directions-popup {
  	    position: absolute !important;
  	    top: 50px !important;
  	    right: 0 !important;
  	    left: auto !important;
  	    width: 430px !important;
  	    max-width: calc(100vw - 12px) !important;
  	    border-radius: 0 0 0 24px !important;
  	    overflow: hidden !important;
  	    border-top: 1px solid rgba(255,122,36,0.58) !important;
  	    border-left: 1px solid rgba(255,122,36,0.58) !important;
  	    border-right: 0 !important;
  	    border-bottom: 1px solid rgba(255,122,36,0.46) !important;
  	    box-shadow:
  	    -16px 18px 36px rgba(0,0,0,0.44),
  	    inset 0 1px 0 rgba(255,255,255,0.045) !important;
  	    }

  	    .trackit-directions-popup-header {
  	    cursor: default !important;
  	    border-radius: 0 !important;
  	    }

  	    .trackit-directions-whatsapp-wrap {
  	    display: grid !important;
  	    grid-template-columns: 86px minmax(0, 1fr) 114px !important;
  	    gap: 7px !important;
  	    align-items: center !important;
  	    width: 100% !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-directions-country-select {
  	    height: 38px !important;
  	    min-width: 0 !important;
  	    border-radius: 12px !important;
  	    border: 1px solid rgba(255,138,61,0.34) !important;
  	    background:
  	    linear-gradient(145deg, rgba(255,138,61,0.15), rgba(255,255,255,0.035)) !important;
  	    color: rgba(255,232,208,0.92) !important;
  	    font-size: 10px !important;
  	    font-weight: 950 !important;
  	    padding: 0 8px !important;
  	    outline: 0 !important;
  	    box-sizing: border-box !important;
  	    cursor: pointer !important;
  	    }

  	    .trackit-directions-country-select option {
  	    background: #111 !important;
  	    color: #fff !important;
  	    }

  	    .trackit-directions-whatsapp-phone {
  	    height: 38px !important;
  	    min-width: 0 !important;
  	    border-radius: 12px !important;
  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	    background: rgba(255,255,255,0.055) !important;
  	    color: #fff !important;
  	    font-size: 10px !important;
  	    font-weight: 850 !important;
  	    padding: 0 10px !important;
  	    outline: 0 !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-directions-whatsapp-phone::placeholder {
  	    color: rgba(255,255,255,0.38) !important;
  	    }

  	    .trackit-directions-whatsapp-phone:focus {
  	    border-color: rgba(255,138,61,0.68) !important;
  	    background: rgba(255,138,61,0.08) !important;
  	    }

  	    .trackit-directions-whatsapp-phone.invalid {
  	    border-color: rgba(255,70,70,0.85) !important;
  	    background: rgba(255,45,45,0.10) !important;
  	    box-shadow:
  	    0 0 0 1px rgba(255,70,70,0.22),
  	    0 0 14px rgba(255,45,45,0.16) !important;
  	    }

  	    .trackit-directions-whatsapp-btn {
  	    height: 38px !important;
  	    min-width: 0 !important;
  	    border-radius: 12px !important;
  	    display: flex !important;
  	    align-items: center !important;
  	    justify-content: center !important;
  	    gap: 7px !important;
  	    border: 1px solid rgba(51,214,105,0.58) !important;
  	    background:
  	    linear-gradient(145deg, rgba(37,211,102,0.24), rgba(9,58,29,0.78)) !important;
  	    color: #eaffef !important;
  	    font-size: 10px !important;
  	    font-weight: 950 !important;
  	    padding: 0 10px !important;
  	    box-sizing: border-box !important;
  	    cursor: pointer !important;
  	    white-space: nowrap !important;
  	    box-shadow:
  	    inset 0 0 0 1px rgba(255,255,255,0.06),
  	    0 7px 14px rgba(0,0,0,0.20) !important;
  	    }

  	    .trackit-directions-whatsapp-btn:hover {
  	    border-color: rgba(80,255,139,0.78) !important;
  	    background:
  	    linear-gradient(145deg, rgba(37,211,102,0.34), rgba(9,75,36,0.86)) !important;
  	    }

  	    .trackit-directions-whatsapp-btn.sending {
  	    opacity: 0.72 !important;
  	    pointer-events: none !important;
  	    }

  	    .trackit-directions-whatsapp-btn .trackit-whatsapp-icon {
  	    width: 16px !important;
  	    height: 16px !important;
  	    flex: 0 0 16px !important;
  	    color: #25d366 !important;
  	    }

  	    .trackit-directions-whatsapp-btn span {
  	    overflow: hidden !important;
  	    text-overflow: ellipsis !important;
  	    white-space: nowrap !important;
  	    }

  	    /* ============================================================
  	    TrackIT Directions Popup Layout Patch
  	    Width: 300px
  	    Add Stop aligned to search inputs
  	    Clear/New Route single action
  	    WhatsApp number row + button row
  	    ============================================================ */

  	    .trackit-directions-popup {
  	    width: 300px !important;
  	    max-width: calc(100vw - 12px) !important;
  	    }

  	    /* Keep labelled rows compact inside 300px popup */
  	    .trackit-directions-search-line,
  	    .trackit-directions-search-line.no-remove {
  	    grid-template-columns: 52px minmax(0, 1fr) !important;
  	    gap: 8px !important;
  	    }

  	    /* Add Stop should match From/To input width, not full popup width */
  	    .trackit-directions-add-stop {
  	    width: calc(100% - 60px) !important;
  	    margin-left: 60px !important;
  	    margin-right: 0 !important;
  	    box-sizing: border-box !important;
  	    }

  	    /* Only one action button now */
  	    .trackit-directions-actions {
  	    display: grid !important;
  	    grid-template-columns: minmax(0, 1fr) !important;
  	    gap: 0 !important;
  	    margin-top: 10px !important;
  	    }

  	    .trackit-directions-actions .trackit-directions-new {
  	    width: 100% !important;
  	    }

  	    .trackit-directions-actions .trackit-directions-clear {
  	    display: none !important;
  	    }

  	    /* WhatsApp number area:
  	    Row 1 = country select + phone input
  	    Row 2 = WhatsApp button alone, justified right
  	    */
  	    .trackit-directions-whatsapp-wrap {
  	    display: grid !important;
  	    grid-template-columns: 78px minmax(0, 1fr) !important;
  	    grid-auto-rows: 38px !important;
  	    gap: 7px !important;
  	    align-items: center !important;
  	    width: 100% !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-directions-country-select {
  	    grid-column: 1 !important;
  	    grid-row: 1 !important;
  	    width: 100% !important;
  	    }

  	    .trackit-directions-whatsapp-phone {
  	    grid-column: 2 !important;
  	    grid-row: 1 !important;
  	    width: 100% !important;
  	    }

  	    .trackit-directions-driver-btn,
  	    .trackit-directions-whatsapp-btn {
  	    grid-column: 1 / -1 !important;
  	    justify-self: end !important;
  	    width: auto !important;
  	    min-width: 122px !important;
  	    padding-left: 14px !important;
  	    padding-right: 14px !important;
  	    }

  	    .trackit-directions-whatsapp-btn {
  	    grid-row: 2 !important;
  	    }

  	    .trackit-directions-whatsapp-wrap.has-driver .trackit-directions-driver-btn {
  	    display: flex !important;
  	    grid-row: 2 !important;
  	    justify-self: stretch !important;
  	    width: 100% !important;
  	    }

  	    .trackit-directions-whatsapp-wrap.has-driver .trackit-directions-whatsapp-btn {
  	    grid-row: 3 !important;
  	    }

  	    .trackit-directions-driver-btn {
  	    height: 38px !important;
  	    min-width: 0 !important;
  	    border-radius: 12px !important;
  	    align-items: center !important;
  	    justify-content: center !important;
  	    gap: 7px !important;
  	    border: 1px solid rgba(37,211,102,0.48) !important;
  	    background: rgba(37,211,102,0.12) !important;
  	    color: #eaffef !important;
  	    font-size: 10px !important;
  	    font-weight: 950 !important;
  	    box-sizing: border-box !important;
  	    cursor: pointer !important;
  	    white-space: nowrap !important;
  	    }

  	    .trackit-directions-driver-btn:hover:not(:disabled) {
  	    border-color: rgba(80,255,139,0.78) !important;
  	    background: rgba(37,211,102,0.22) !important;
  	    }

  	    .trackit-directions-driver-btn:disabled,
  	    .trackit-directions-driver-btn.missing {
  	    opacity: 0.48 !important;
  	    cursor: not-allowed !important;
  	    }

  	    .trackit-directions-driver-btn .trackit-whatsapp-icon {
  	    width: 16px !important;
  	    height: 16px !important;
  	    flex: 0 0 16px !important;
  	    color: #25d366 !important;
  	    }

  	    /* ============================================================
  	    TrackIT Directions Stop Delete Alignment Patch
  	    Keeps waypoint delete button next to the Stop input bar
  	    ============================================================ */

  	    /* Only waypoint rows need the third column for delete */
  	    .trackit-directions-search-line[data-route-row^="waypoint:"] {
  	    display: grid !important;
  	    grid-template-columns: 52px minmax(0, 1fr) 30px !important;
  	    gap: 8px !important;
  	    align-items: center !important;
  	    }

  	    /* Stop label */
  	    .trackit-directions-search-line[data-route-row^="waypoint:"] > span {
  	    grid-column: 1 !important;
  	    grid-row: 1 !important;
  	    align-self: center !important;
  	    }

  	    /* Stop search/select input */
  	    .trackit-directions-search-line[data-route-row^="waypoint:"] .trackit-directions-input-wrap {
  	    grid-column: 2 !important;
  	    grid-row: 1 !important;
  	    width: 100% !important;
  	    min-width: 0 !important;
  	    }

  	    /* Delete button sits directly beside the input */
  	    .trackit-directions-search-line[data-route-row^="waypoint:"] .trackit-directions-remove-stop {
  	    grid-column: 3 !important;
  	    grid-row: 1 !important;

  	    width: 28px !important;
  	    height: 28px !important;
  	    min-width: 28px !important;
  	    min-height: 28px !important;

  	    margin: 0 !important;
  	    padding: 0 !important;

  	    align-self: center !important;
  	    justify-self: center !important;

  	    border-radius: 999px !important;
  	    border: 1px solid rgba(255,255,255,0.14) !important;

  	    background: rgba(255,255,255,0.055) !important;
  	    color: rgba(255,255,255,0.86) !important;

  	    display: flex !important;
  	    align-items: center !important;
  	    justify-content: center !important;

  	    font-size: 18px !important;
  	    font-weight: 950 !important;
  	    line-height: 1 !important;

  	    cursor: pointer !important;
  	    box-sizing: border-box !important;
  	    }

  	    .trackit-directions-search-line[data-route-row^="waypoint:"] .trackit-directions-remove-stop:hover {
  	    color: #fff !important;
  	    border-color: rgba(255,138,61,0.55) !important;
  	    background: rgba(255,138,61,0.16) !important;
  	    }
  	    `;

  	    document.head.appendChild(style);

  	    let currentMapType = readSetting("mapType", "hybrid") || "hybrid";
  	    let trafficOn = readSetting("trafficOn", true);
  	    let collapsed = readSetting("panelCollapsedV8", true);
  	    let labelsOn = readSetting("labelsOn", true);

  	    // Default OFF. Once user switches it on, it can remember the state.
  	    let locationsOn = readSetting("locationsOn", false) === true;

  	    function normaliseSavedLocationCompanyKeys(value) {
  	      if (Array.isArray(value)) {
  	        return value.map(String).filter(Boolean);
  	      }

  	      if (value && typeof value === "object") {
  	        return Object.keys(value).filter(key => value[key]);
  	      }

  	      if (typeof value === "string" && value.trim()) {
  	        try {
  	          const parsed = JSON.parse(value);
  	          if (Array.isArray(parsed)) return parsed.map(String).filter(Boolean);
  	        } catch (_) {}

  	        return value.split(",").map(v => v.trim()).filter(Boolean);
  	      }

  	      return [];
  	    }

  	    let checkedLocationCompanyKeys = normaliseSavedLocationCompanyKeys(
  	      readSetting("checkedLocationCompanyKeys", [])
  	    );

  	    try {
  	      map.setMapTypeId(currentMapType);
  	    } catch (_) {}

  	    if (!map.__trackitTrafficLayer) {
  	      map.__trackitTrafficLayer = new google.maps.TrafficLayer();
  	    }

  	    map.__trackitTrafficLayer.setMap(trafficOn ? map: null);

  	    const control = document.createElement("div");
  	    control.className = "trackit-compact-map-control ces-bottom-shape";
  	    control.__trackitUnifiedMapControl = true;
  	    control.setAttribute("data-trackit-map-control", "fleet");

  	    if (collapsed) {
  	      control.classList.add("collapsed");
  	    }

  	    const shellContent = document.createElement("div");
  	    shellContent.className = "ces-bottom-content";
  	    shellContent.setAttribute("data-trackit-new-map-control", "fleet");

  	    const header = document.createElement("button");
  	    header.type = "button";
  	    header.className = "ces-map-control-header";
  	    header.setAttribute("data-map-control-toggle", "fleet");

  	    const headerIcon = document.createElement("div");
  	    headerIcon.className = "ces-map-control-header-icon";
  	    headerIcon.innerHTML = `
  	    <div class="ces-layer-icon">
  	    <span></span>
  	    <span></span>
  	    <span></span>
  	    </div>
  	    `;

  	    const headerText = document.createElement("div");
  	    headerText.className = "ces-map-control-header-text";

  	    const title = document.createElement("div");
  	    title.className = "ces-map-title";
  	    title.textContent = "Map Control";

  	    const subtitle = document.createElement("div");
  	    subtitle.className = "ces-map-subtitle";

  	    headerText.appendChild(title);
  	    headerText.appendChild(subtitle);

  	    const collapseIcon = document.createElement("div");
  	    collapseIcon.className = "ces-caret";

  	    header.appendChild(headerIcon);
  	    header.appendChild(headerText);
  	    header.appendChild(collapseIcon);

  	    const body = document.createElement("div");
  	    body.className = "ces-map-control-body";

  	    const main = document.createElement("div");
  	    main.className = "ces-map-control-main";

  	    const mapTypeSection = document.createElement("div");
  	    mapTypeSection.className = "ces-map-control-section";

  	    const typeLabelRow = sectionLabel("Map Type", iconLayers());

  	    const typeTabs = document.createElement("div");
  	    typeTabs.className = "ces-map-control-tools fleet-map-type-tools";

  	    const mapTypes = [{
  	      id: "roadmap",
  	      label: "Road",
  	      icon: iconRoadmap()
  	    },
  	      {
  	        id: "satellite",
  	        label: "Sat",
  	        icon: iconSatellite()
  	      },
  	      {
  	        id: "hybrid",
  	        label: "Hybrid",
  	        icon: iconLayers()
  	      },
  	      {
  	        id: "terrain",
  	        label: "Terrain",
  	        icon: iconTerrain()
  	      }];

  	    const typeButtons = {};

  	    mapTypes.forEach(type => {
  	      const btn = document.createElement("button");
  	      btn.type = "button";
  	      btn.className = "ces-map-control-tool fleet-map-type-btn";
  	      btn.dataset.mapType = type.id;
  	      btn.innerHTML = `${type.icon}<span>${type.label}</span>`;

  	      btn.addEventListener("click", function (event) {
  	        event.preventDefault();
  	        event.stopPropagation();

  	        currentMapType = type.id;

  	        writeSetting("mapType", type.id);
  	        applyMapAppearance();
  	        paintMapTypeButtons();
  	      });

  	      typeButtons[type.id] = btn;
  	      typeTabs.appendChild(btn);
  	    });

  	    mapTypeSection.appendChild(typeLabelRow);
  	    mapTypeSection.appendChild(typeTabs);

  	    const toolsSection = document.createElement("div");
  	    toolsSection.className = "ces-map-control-section";

  	    const toolsLabelRow = sectionLabel("Tools", iconLayers());

  	    const toolsGrid = document.createElement("div");
  	    toolsGrid.className = "ces-map-control-tools fleet-map-tools";

  	    const trafficBtn = toolButton("Traffic", iconTraffic());
  	    const labelsBtn = toolButton("Labels", iconLabel());
  	    const fullscreenBtn = toolButton("Fullscreen", iconFullscreen());
  	    const directionsBtn = toolButton("Directions", iconDirections());

  	    toolsGrid.appendChild(trafficBtn);
  	    toolsGrid.appendChild(labelsBtn);
  	    toolsGrid.appendChild(fullscreenBtn);
  	    toolsGrid.appendChild(directionsBtn);

  	    toolsSection.appendChild(toolsLabelRow);
  	    toolsSection.appendChild(toolsGrid);

  	    // ---------- App Data Locations UI ----------
  	    const locationsSection = document.createElement("div");
  	    locationsSection.className = "ces-map-control-section trackit-locations-section";

  	    const locationsLabelRow = sectionLabel("Locations", iconLocation());

  	    const locationsToggleRow = document.createElement("label");
  	    locationsToggleRow.className = "ces-map-control-tool trackit-location-toggle-row";

  	    const locationsCheckbox = document.createElement("input");
  	    locationsCheckbox.type = "checkbox";
  	    locationsCheckbox.checked = !!locationsOn;

  	    const locationsTick = document.createElement("span");
  	    locationsTick.className = "trackit-location-tick";

  	    const locationsText = document.createElement("span");
  	    locationsText.textContent = "View Locations";

  	    locationsToggleRow.appendChild(locationsCheckbox);
  	    locationsToggleRow.appendChild(locationsTick);

  	    const locationsIconWrap = document.createElement("span");
  	    locationsIconWrap.innerHTML = iconLocation();
  	    locationsToggleRow.appendChild(locationsIconWrap.firstElementChild);

  	    locationsToggleRow.appendChild(locationsText);

  	    const locationsList = document.createElement("div");
  	    locationsList.className = "trackit-location-company-list";

  	    locationsSection.appendChild(locationsLabelRow);
  	    locationsSection.appendChild(locationsToggleRow);
  	    locationsSection.appendChild(locationsList);

  	    main.appendChild(mapTypeSection);
  	    main.appendChild(toolsSection);
  	    main.appendChild(locationsSection);

  	    const zoomPanel = document.createElement("div");
  	    zoomPanel.className = "ces-map-control-zoom-rail";

  	    const zoomTitle = document.createElement("div");
  	    zoomTitle.className = "ces-map-control-zoom-label";
  	    zoomTitle.textContent = "Zoom";

  	    const zoomValue = document.createElement("div");
  	    zoomValue.className = "ces-map-control-zoom-value";

  	    const zoomPlus = document.createElement("button");
  	    zoomPlus.type = "button";
  	    zoomPlus.className = "ces-map-control-zoom-btn";
  	    zoomPlus.textContent = "+";

  	    const sliderWrap = document.createElement("div");
  	    sliderWrap.className = "ces-map-control-slider-wrap";

  	    const zoomSlider = document.createElement("input");
  	    zoomSlider.className = "ces-map-control-zoom-slider";
  	    zoomSlider.type = "range";
  	    zoomSlider.min = "1";
  	    zoomSlider.max = "22";
  	    zoomSlider.step = "1";

  	    const ticks = document.createElement("div");
  	    ticks.className = "ces-map-control-ticks";

  	    sliderWrap.appendChild(zoomSlider);
  	    sliderWrap.appendChild(ticks);

  	    const zoomMinus = document.createElement("button");
  	    zoomMinus.type = "button";
  	    zoomMinus.className = "ces-map-control-zoom-btn";
  	    zoomMinus.textContent = "−";

  	    zoomPanel.appendChild(zoomTitle);
  	    zoomPanel.appendChild(zoomValue);
  	    zoomPanel.appendChild(zoomPlus);
  	    zoomPanel.appendChild(sliderWrap);
  	    zoomPanel.appendChild(zoomMinus);

  	    body.appendChild(main);
  	    body.appendChild(zoomPanel);

  	    shellContent.appendChild(header);
  	    shellContent.appendChild(body);
  	    control.appendChild(shellContent);

  	    ["mousedown",
  	      "dblclick",
  	      "wheel",
  	      "touchstart",
  	      "pointerdown"].forEach(evtName => {
  	        control.addEventListener(evtName, function (event) {
  	          event.stopPropagation();
  	        }, {
  	          passive: false
  	        });
  	      });

  	    try {
  	      const mapDivForMount = map.getDiv();

  	      if (mapDivForMount) {
  	        mapDivForMount.style.position = mapDivForMount.style.position || "relative";

  	        const oldMountedControl = mapDivForMount.querySelector(".trackit-compact-map-control");

  	        if (oldMountedControl && oldMountedControl !== control) {
  	          oldMountedControl.remove();
  	        }

  	        control.style.position = "absolute";
  	        control.style.right = "0";
  	        control.style.bottom = "0";
  	        control.style.margin = "0";
  	        control.style.zIndex = "999999";
  	        control.style.pointerEvents = "auto";

  	        mapDivForMount.appendChild(control);
  	      } else {
  	        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	      }
  	    } catch (error) {
  	      console.warn("[TrackIT Map Controls] Could not mount absolute control. Falling back to Google controls.", error);

  	      try {
  	        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	      } catch (_) {}
  	    }

  	    map.__trackitUnifiedMapControlReady = true;
  	    map.__trackitUnifiedMapControlVersion = CONTROL_VERSION;

  	    function sectionLabel(text, icon) {
  	      const row = document.createElement("div");
  	      row.className = "ces-map-control-section-title";
  	      row.innerHTML = `
  	      ${icon}
  	      <span>${text}</span>
  	      `;
  	      return row;
  	    }

  	    function toolButton(label, icon) {
  	      const btn = document.createElement("button");
  	      btn.type = "button";
  	      btn.className = "ces-map-control-tool";
  	      btn.innerHTML = `${icon}<span>${label}</span>`;
  	      return btn;
  	    }

  	    function sizeFleetMapControlShell(control, isOpen) {
  	      if (!control) return;

  	      function setStyle(element, property, value) {
  	        try {
  	          element.style.setProperty(property, value, "important");
  	        } catch (_) {
  	          try {
  	            element.style[property] = value;
  	          } catch (_) {}
  	        }
  	      }

  	      const content = control.querySelector(".ces-bottom-content");

  	      const viewportHeight =
  	      typeof window !== "undefined" && window.innerHeight
  	      ? window.innerHeight: 900;

  	      const maxHeight = Math.max(360, viewportHeight - 24);
  	      const closedHeight = 56;
  	      const closedWidth = 200;
  	      const openWidth = 300;

  	      if (!isOpen) {
  	        setStyle(control, "width", `${closedWidth}px`);
  	        setStyle(control, "height", `${closedHeight}px`);
  	        setStyle(control, "min-height", `${closedHeight}px`);
  	        setStyle(control, "max-height", `${closedHeight}px`);
  	        setStyle(control, "overflow", "hidden");
  	        setStyle(control, "right", "0");
  	        setStyle(control, "bottom", "0");
  	        setStyle(control, "top", "auto");
  	        setStyle(control, "border-radius", "22px 0 0 0");

  	        if (content) {
  	          setStyle(content, "max-height", `${closedHeight}px`);
  	          setStyle(content, "overflow", "hidden");
  	          setStyle(content, "overflow-x", "hidden");
  	          setStyle(content, "overflow-y", "hidden");
  	        }

  	        return;
  	      }

  	      if (content) {
  	        setStyle(content, "max-height", "none");
  	        setStyle(content, "overflow", "visible");
  	        setStyle(content, "overflow-x", "hidden");
  	        setStyle(content, "overflow-y", "visible");
  	      }

  	      const contentHeight = content ? Math.ceil(content.scrollHeight): 0;
  	      const wantedHeight = Math.max(320, contentHeight + 2);
  	      const finalHeight = Math.min(wantedHeight, maxHeight);

  	      setStyle(control, "width", `${openWidth}px`);
  	      setStyle(control, "height", `${finalHeight}px`);
  	      setStyle(control, "min-height", `${finalHeight}px`);
  	      setStyle(control, "max-height", `${maxHeight}px`);
  	      setStyle(control, "overflow", "hidden");
  	      setStyle(control, "right", "0");
  	      setStyle(control, "bottom", "0");
  	      setStyle(control, "top", "auto");
  	      setStyle(control, "border-radius", "24px 0 0 0");

  	      if (content) {
  	        setStyle(content, "max-height", `${finalHeight}px`);
  	        setStyle(content, "overflow-x", "hidden");
  	        setStyle(content, "overflow-y", wantedHeight > maxHeight ? "auto": "visible");
  	      }
  	    }

  	    function applyMapAppearance() {
  	      // Hybrid is satellite imagery plus Google labels.
  	      // When Labels are OFF and user chose Hybrid, Satellite is the closest clean version.
  	      const effectiveType = (!labelsOn && currentMapType === "hybrid")
  	      ? "satellite": currentMapType;

  	      try {
  	        map.setMapTypeId(effectiveType);
  	      } catch (_) {}

  	      try {
  	        map.setOptions({
  	          styles: labelsOn ? null: NO_LABEL_STYLES
  	        });
  	      } catch (_) {}
  	    }

  	    function paintMapTypeButtons() {
  	      Object.keys(typeButtons).forEach(key => {
  	        typeButtons[key].classList.toggle("active", key === currentMapType);
  	      });
  	    }

  	    function updateZoomUi() {
  	      const z = map.getZoom() || 1;

  	      zoomSlider.value = String(z);
  	      zoomValue.textContent = String(z);

  	      writeSetting("zoom", z);
  	    }

  	    function updateHeaderState() {
  	      collapseIcon.textContent = collapsed ? "⌄": "⌃";
  	      subtitle.textContent = labelsOn ? "Labels On": "Labels Off";
  	    }

  	    function paintToggleButtons() {
  	      trafficBtn.classList.toggle("active", !!trafficOn);
  	      labelsBtn.classList.toggle("active", !!labelsOn);
  	      paintFullscreenState();
  	      updateHeaderState();
  	    }

  	    // ---------- App Data Geo Location Layer ----------
  	    function locNum(v) {
  	      return typeof v === "number" ? v: Number(v);
  	    }

  	    function locGetPath(o, p) {
  	      if (!o || !p) return undefined;

  	      if (Object.prototype.hasOwnProperty.call(o, p)) {
  	        return o[p];
  	      }

  	      return String(p).split(".").reduce((a, k) => {
  	        return a && a[k] !== undefined ? a[k]: undefined;
  	      }, o);
  	    }

  	    function locFirstString(obj, keys) {
  	      for (const key of keys) {
  	        const v = locGetPath(obj, key);

  	        if (typeof v === "string" && v.trim()) {
  	          return v.trim();
  	        }

  	        if (typeof v === "number" && Number.isFinite(v)) {
  	          return String(v);
  	        }
  	      }

  	      return "";
  	    }

  	    function saveCheckedLocationCompanies() {
  	      writeSetting("checkedLocationCompanyKeys", checkedLocationCompanyKeys.slice());
  	    }

  	    function isLocationCompanyChecked(key) {
  	      return checkedLocationCompanyKeys.includes(String(key));
  	    }

  	    function setLocationCompanyChecked(key, checked) {
  	      key = String(key);

  	      if (checked) {
  	        if (!checkedLocationCompanyKeys.includes(key)) {
  	          checkedLocationCompanyKeys.push(key);
  	        }
  	      } else {
  	        checkedLocationCompanyKeys = checkedLocationCompanyKeys.filter(k => k !== key);
  	      }

  	      saveCheckedLocationCompanies();
  	    }

  	    function getTrackitLocationLayer() {
  	      if (!map.__trackitAppLocationLayer) {
  	        map.__trackitAppLocationLayer = {
  	          companyLayers: {}
  	        };
  	      }

  	      if (!map.__trackitAppLocationLayer.companyLayers) {
  	        map.__trackitAppLocationLayer.companyLayers = {};
  	      }

  	      return map.__trackitAppLocationLayer;
  	    }

  	    function clearAppLocationLayer(companyKey) {
  	      const layer = getTrackitLocationLayer();

  	      function clearItems(items) {
  	        (items || []).forEach(item => {
  	          try {
  	            if (item?.setMap) item.setMap(null);
  	            else if (item?.remove) item.remove();
  	          } catch (_) {}
  	        });
  	      }

  	      if (companyKey) {
  	        const key = String(companyKey);
  	        const companyLayer = layer.companyLayers[key];

  	        if (companyLayer) {
  	          clearItems(companyLayer.overlays);
  	          clearItems(companyLayer.labels);
  	          delete layer.companyLayers[key];
  	        }

  	        return;
  	      }

  	      Object.keys(layer.companyLayers).forEach(key => {
  	        const companyLayer = layer.companyLayers[key];
  	        clearItems(companyLayer.overlays);
  	        clearItems(companyLayer.labels);
  	      });

  	      layer.companyLayers = {};
  	    }

  	    function normaliseObjectArray(value) {
  	      if (!value) return [];

  	      if (Array.isArray(value)) {
  	        return value.filter(v => v && typeof v === "object");
  	      }

  	      if (typeof value === "object") {
  	        return Object.values(value).filter(v => v && typeof v === "object");
  	      }

  	      return [];
  	    }

  	    function getCompanyDisplayName(company, index) {
  	      const direct = locFirstString(company, [
  	        "Name",
  	        "name",
  	        "CompanyName",
  	        "companyName",
  	        "Company",
  	        "company",
  	        "DisplayName",
  	        "displayName",
  	        "TradingName",
  	        "tradingName",
  	        "ClientName",
  	        "clientName",
  	        "CustomerName",
  	        "customerName",
  	        "Title",
  	        "title"
  	      ]);

  	      if (direct) return direct;

  	      const first = locFirstString(company, ["FirstName", "firstName", "first_name"]);
  	      const last = locFirstString(company, ["LastName", "lastName", "last_name"]);
  	      const full = [first,
  	        last].filter(Boolean).join(" ").trim();

  	      return full || `Company ${index + 1}`;
  	    }

  	    function getCompanyKey(company, name, index) {
  	      return String(
  	        company?.objectId ||
  	        company?.ObjectId ||
  	        company?.CompanyId ||
  	        company?.companyId ||
  	        company?.id ||
  	        company?.ID ||
  	        company?.FID ||
  	        name ||
  	        `company-${index}`
  	      );
  	    }

  	    function getLocationName(loc, index) {
  	      return locFirstString(loc, [
  	        "Name",
  	        "name",
  	        "LocationName",
  	        "locationName",
  	        "LocationName.Name",
  	        "Location.name",
  	        "Location",
  	        "location",
  	        "FarmName",
  	        "farmName",
  	        "FieldName",
  	        "fieldName",
  	        "SiteName",
  	        "siteName",
  	        "Description",
  	        "description",
  	        "Title",
  	        "title",
  	        "label",
  	        "Label"
  	      ]) || `Location ${index + 1}`;
  	    }

  	    function readBackendlessArg(name, lowerName, index) {
  	      try {
  	        if (typeof ___arguments !== "undefined" && ___arguments) {
  	          if (___arguments[name] !== undefined) return ___arguments[name];
  	          if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	          if (___arguments[index] !== undefined) return ___arguments[index];
  	        }
  	      } catch (_) {}

  	      return undefined;
  	    }

  	    function parseMaybeJson(value) {
  	      if (typeof value !== "string") return value;

  	      const text = value.trim();
  	      if (!text) return value;

  	      if (
  	        (text.startsWith("[") && text.endsWith("]")) ||
  	        (text.startsWith("{") && text.endsWith("}"))
  	      ) {
  	        try {
  	          return JSON.parse(text);
  	        } catch (_) {
  	          return value;
  	        }
  	      }

  	      return value;
  	    }

  	    function validLatLng(lat, lng) {
  	      return (
  	        Number.isFinite(lat) &&
  	        Number.isFinite(lng) &&
  	        Math.abs(lat) <= 90 &&
  	        Math.abs(lng) <= 180
  	      );
  	    }

  	    function pointFromPair(pair, geoJsonOrder) {
  	      if (!Array.isArray(pair) || pair.length < 2) return null;

  	      const a = locNum(pair[0]);
  	      const b = locNum(pair[1]);

  	      if (!Number.isFinite(a) || !Number.isFinite(b)) return null;

  	      let lat;
  	      let lng;

  	      if (geoJsonOrder) {
  	        lat = b;
  	        lng = a;
  	      } else if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
  	        lat = a;
  	        lng = b;
  	      } else if (Math.abs(b) <= 90 && Math.abs(a) <= 180) {
  	        lat = b;
  	        lng = a;
  	      } else {
  	        return null;
  	      }

  	      return validLatLng(lat, lng) ? {
  	        lat,
  	        lng
  	      }: null;
  	    }

  	    function pointFromString(value, geoJsonOrder) {
  	      if (typeof value !== "string") return null;

  	      const text = value.trim();
  	      if (!text) return null;

  	      const parsed = parseMaybeJson(text);
  	      if (parsed !== value) {
  	        return coercePoint(parsed, geoJsonOrder);
  	      }

  	      const match = text.match(/(-?\d+(?:\.\d+)?)\s*[,; ]\s*(-?\d+(?:\.\d+)?)/);
  	      if (!match) return null;

  	      return pointFromPair([match[1], match[2]], geoJsonOrder);
  	    }

  	    function coercePoint(value, geoJsonOrder) {
  	      value = parseMaybeJson(value);

  	      if (!value) return null;

  	      if (Array.isArray(value)) {
  	        return pointFromPair(value, geoJsonOrder);
  	      }

  	      if (typeof value === "string") {
  	        return pointFromString(value, geoJsonOrder);
  	      }

  	      if (typeof value !== "object") return null;

  	      const pairs = [
  	        ["lat",
  	          "lng"],
  	        ["lat",
  	          "lon"],
  	        ["lat",
  	          "long"],
  	        ["latitude",
  	          "longitude"],
  	        ["Latitude",
  	          "Longitude"],
  	        ["LAT",
  	          "LNG"],

  	        ["_lat",
  	          "_lng"],
  	        ["_latitude",
  	          "_longitude"],

  	        ["x",
  	          "y"],
  	        ["X",
  	          "Y"],

  	        ["position.latitude",
  	          "position.longitude"],
  	        ["Position.Latitude",
  	          "Position.Longitude"],

  	        ["Location.position.latitude",
  	          "Location.position.longitude"],
  	        ["location.position.latitude",
  	          "location.position.longitude"],

  	        ["geoPoint.latitude",
  	          "geoPoint.longitude"],
  	        ["GeoPoint.latitude",
  	          "GeoPoint.longitude"],

  	        ["Coordinates.latitude",
  	          "Coordinates.longitude"],
  	        ["coordinates.latitude",
  	          "coordinates.longitude"],

  	        ["Center.lat",
  	          "Center.lng"],
  	        ["center.lat",
  	          "center.lng"],
  	        ["Centre.lat",
  	          "Centre.lng"],
  	        ["centre.lat",
  	          "centre.lng"],

  	        ["LocationData.Center.lat",
  	          "LocationData.Center.lng"],
  	        ["LocationData.center.lat",
  	          "LocationData.center.lng"],
  	        ["LocationData.Centre.lat",
  	          "LocationData.Centre.lng"],
  	        ["LocationData.centre.lat",
  	          "LocationData.centre.lng"],

  	        ["LocationData.Shape.Center.lat",
  	          "LocationData.Shape.Center.lng"],
  	        ["LocationData.Shape.center.lat",
  	          "LocationData.Shape.center.lng"],
  	        ["LocationData.Shape.Centre.lat",
  	          "LocationData.Shape.Centre.lng"],
  	        ["LocationData.Shape.centre.lat",
  	          "LocationData.Shape.centre.lng"],

  	        ["LocationData.Shape.PivotCenter.lat",
  	          "LocationData.Shape.PivotCenter.lng"],
  	        ["LocationData.Shape.pivotCenter.lat",
  	          "LocationData.Shape.pivotCenter.lng"],

  	        ["LocationData.Shape.WedgeCenter.lat",
  	          "LocationData.Shape.WedgeCenter.lng"],
  	        ["LocationData.Shape.wedgeCenter.lat",
  	          "LocationData.Shape.wedgeCenter.lng"],

  	        ["LocationData.Shape.EntrancePoint.lat",
  	          "LocationData.Shape.EntrancePoint.lng"],
  	        ["LocationData.Shape.entrancePoint.lat",
  	          "LocationData.Shape.entrancePoint.lng"],

  	        ["EntrancePoint.lat",
  	          "EntrancePoint.lng"],
  	        ["entrancePoint.lat",
  	          "entrancePoint.lng"]
  	      ];

  	      for (const pair of pairs) {
  	        let lat = locNum(locGetPath(value, pair[0]));
  	        let lng = locNum(locGetPath(value, pair[1]));

  	        // x/y is often lng/lat, so reverse it when needed.
  	        if ((pair[0] === "x" || pair[0] === "X") && validLatLng(lng, lat)) {
  	          return {
  	            lat: lng,
  	            lng: lat
  	          };
  	        }

  	        if (validLatLng(lat, lng)) {
  	          return {
  	            lat,
  	            lng
  	          };
  	        }
  	      }

  	      return null;
  	    }

  	    function readPointFromObject(obj) {
  	      return coercePoint(obj, false);
  	    }

  	    function collectPointsFromArray(value, output, geoJsonOrder, depth = 0) {
  	      if (depth > 8) return;

  	      value = parseMaybeJson(value);

  	      if (!value) return;

  	      const directPoint = coercePoint(value, geoJsonOrder);
  	      if (directPoint) {
  	        output.push(directPoint);
  	        return;
  	      }

  	      if (typeof value === "string") {
  	        const text = value.trim();

  	        // Handles simple strings like:
  	        // "-29.1,30.1;-29.2,30.2;-29.3,30.3"
  	        const pairs = text.match(/-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?/g);

  	        if (pairs && pairs.length >= 3) {
  	          pairs.forEach(pairText => {
  	            const p = pointFromString(pairText, geoJsonOrder);
  	            if (p) output.push(p);
  	          });
  	        }

  	        return;
  	      }

  	      if (Array.isArray(value)) {
  	        value.forEach(item => {
  	          collectPointsFromArray(item, output, geoJsonOrder, depth + 1);
  	        });

  	        return;
  	      }

  	      if (typeof value === "object") {
  	        const likelyArrays = [
  	          value.points,
  	          value.Points,
  	          value.path,
  	          value.Path,
  	          value.paths,
  	          value.Paths,
  	          value.coordinates,
  	          value.Coordinates,
  	          value.polygon,
  	          value.Polygon,
  	          value.boundary,
  	          value.Boundary,
  	          value.rings,
  	          value.Rings,
  	          value.plotPoints,
  	          value.plotRawPoints,
  	          value.plotResolvedPoints,
  	          value.PlotPoints,
  	          value.PlotRawPoints,
  	          value.PlotResolvedPoints
  	        ];

  	        likelyArrays.forEach(item => {
  	          collectPointsFromArray(item, output, geoJsonOrder, depth + 1);
  	        });
  	      }
  	    }

  	    function cleanLocationPath(points) {
  	      const cleaned = [];
  	      const seen = new Set();

  	      (points || []).forEach(p => {
  	        if (!p || !validLatLng(p.lat, p.lng)) return;

  	        const key = `${Number(p.lat).toFixed(7)},${Number(p.lng).toFixed(7)}`;

  	        if (seen.has(key)) return;
  	        seen.add(key);

  	        cleaned.push({
  	          lat: Number(p.lat),
  	          lng: Number(p.lng)
  	        });
  	      });

  	      return cleaned;
  	    }

  	    function readPathFromLocation(loc) {
  	      if (!loc || typeof loc !== "object") return [];

  	      const candidates = [{
  	        key: "path",
  	        geoJson: false
  	      },
  	        {
  	          key: "Path",
  	          geoJson: false
  	        },
  	        {
  	          key: "paths",
  	          geoJson: false
  	        },
  	        {
  	          key: "Paths",
  	          geoJson: false
  	        },
  	        {
  	          key: "points",
  	          geoJson: false
  	        },
  	        {
  	          key: "Points",
  	          geoJson: false
  	        },
  	        {
  	          key: "boundary",
  	          geoJson: false
  	        },
  	        {
  	          key: "Boundary",
  	          geoJson: false
  	        },
  	        {
  	          key: "polygon",
  	          geoJson: false
  	        },
  	        {
  	          key: "Polygon",
  	          geoJson: false
  	        },
  	        {
  	          key: "rings",
  	          geoJson: false
  	        },
  	        {
  	          key: "Rings",
  	          geoJson: false
  	        },

  	        {
  	          key: "Shape.path",
  	          geoJson: false
  	        },
  	        {
  	          key: "Shape.Path",
  	          geoJson: false
  	        },
  	        {
  	          key: "Shape.points",
  	          geoJson: false
  	        },
  	        {
  	          key: "Shape.Points",
  	          geoJson: false
  	        },
  	        {
  	          key: "Shape.polygon",
  	          geoJson: false
  	        },
  	        {
  	          key: "Shape.Polygon",
  	          geoJson: false
  	        },
  	        {
  	          key: "Shape.boundary",
  	          geoJson: false
  	        },
  	        {
  	          key: "Shape.Boundary",
  	          geoJson: false
  	        },
  	        {
  	          key: "Shape.rings",
  	          geoJson: false
  	        },
  	        {
  	          key: "Shape.Rings",
  	          geoJson: false
  	        },

  	        {
  	          key: "shape.path",
  	          geoJson: false
  	        },
  	        {
  	          key: "shape.points",
  	          geoJson: false
  	        },
  	        {
  	          key: "shape.polygon",
  	          geoJson: false
  	        },
  	        {
  	          key: "shape.boundary",
  	          geoJson: false
  	        },
  	        {
  	          key: "shape.rings",
  	          geoJson: false
  	        },

  	        {
  	          key: "LocationData.Points",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.points",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Path",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.path",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Polygon",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.polygon",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Boundary",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.boundary",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Rings",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.rings",
  	          geoJson: false
  	        },

  	        {
  	          key: "LocationData.Shape.Points",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.points",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.Path",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.path",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.Polygon",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.polygon",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.Boundary",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.boundary",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.Rings",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.rings",
  	          geoJson: false
  	        },

  	        {
  	          key: "LocationData.Shape.plotPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.plotRawPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.plotResolvedPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.PlotPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.PlotRawPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "LocationData.Shape.PlotResolvedPoints",
  	          geoJson: false
  	        },

  	        {
  	          key: "PlotPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "plotPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "PlotRawPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "plotRawPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "PlotResolvedPoints",
  	          geoJson: false
  	        },
  	        {
  	          key: "plotResolvedPoints",
  	          geoJson: false
  	        },

  	        {
  	          key: "coordinates",
  	          geoJson: true
  	        },
  	        {
  	          key: "Coordinates",
  	          geoJson: true
  	        },
  	        {
  	          key: "geometry.coordinates",
  	          geoJson: true
  	        },
  	        {
  	          key: "Geometry.Coordinates",
  	          geoJson: true
  	        },
  	        {
  	          key: "LocationData.geometry.coordinates",
  	          geoJson: true
  	        },
  	        {
  	          key: "LocationData.Geometry.Coordinates",
  	          geoJson: true
  	        },
  	        {
  	          key: "LocationData.Shape.coordinates",
  	          geoJson: true
  	        },
  	        {
  	          key: "LocationData.Shape.Coordinates",
  	          geoJson: true
  	        }];

  	      for (const candidate of candidates) {
  	        const raw = locGetPath(loc, candidate.key);
  	        const points = [];

  	        collectPointsFromArray(raw, points, candidate.geoJson);

  	        const cleaned = cleanLocationPath(points);

  	        if (cleaned.length >= 3) {
  	          return cleaned;
  	        }
  	      }

  	      return [];
  	    }

  	    function locationHasGeo(loc) {
  	      return !!readPointFromObject(loc) || readPathFromLocation(loc).length >= 3;
  	    }

  	    function getLocationValueFromTrackit(location) {
  	      return (
  	        location?.objectId ||
  	        location?.ObjectId ||
  	        location?.id ||
  	        location?.ID ||
  	        location?.LocationId ||
  	        location?.locationId ||
  	        null
  	      );
  	    }

  	    function getLocationChildrenFromTrackit(location) {
  	      const arrays = [
  	        location?.Children,
  	        location?.children,
  	        location?.ChildLocations,
  	        location?.childLocations,
  	        location?.Locations,
  	        location?.locations,
  	        location?.Fields,
  	        location?.fields,
  	        location?.Segments,
  	        location?.segments,
  	        location?.Rings,
  	        location?.rings
  	      ];

  	      const result = [];
  	      const seen = new Set();

  	      arrays.forEach(list => {
  	        if (!Array.isArray(list)) return;

  	        list.forEach(child => {
  	          if (!child || typeof child !== "object") return;

  	          const key = getLocationValueFromTrackit(child) || child;

  	          if (seen.has(key)) return;

  	          seen.add(key);
  	          result.push(child);
  	        });
  	      });

  	      return result;
  	    }

  	    function flattenLocationsFromTrackit(locations, output = [], seen = new Set()) {
  	      if (!Array.isArray(locations)) return output;

  	      locations.forEach(location => {
  	        if (!location || typeof location !== "object") return;

  	        const key =
  	        getLocationValueFromTrackit(location) ||
  	        getLocationName(location, output.length);

  	        if (key && seen.has(key)) return;
  	        if (key) seen.add(key);

  	        output.push(location);

  	        flattenLocationsFromTrackit(
  	          getLocationChildrenFromTrackit(location),
  	          output,
  	          seen
  	        );
  	      });

  	      return output;
  	    }

  	    function getCompaniesFromTrackitAppData(appData) {
  	      const listInput =
  	      typeof List !== "undefined"
  	      ? List: readBackendlessArg("List",
  	        "list",
  	        1);

  	      if (Array.isArray(listInput) && listInput.length) {
  	        return listInput;
  	      }

  	      const userCompanies =
  	      appData?.User?.Companies ||
  	      appData?.User?.companies ||
  	      appData?.Companies ||
  	      appData?.companies ||
  	      [];

  	      return Array.isArray(userCompanies) ? userCompanies: [];
  	    }

  	    function getCompanyLocationsFromTrackit(company) {
  	      const locations =
  	      company?.Locations ||
  	      company?.locations ||
  	      company?.Location ||
  	      company?.location ||
  	      company?.PropertyLocations ||
  	      company?.propertyLocations ||
  	      company?.GeoLocations ||
  	      company?.geoLocations ||
  	      [];

  	      return Array.isArray(locations) ? locations: [];
  	    }

  	    function getAppLocationCompanies() {
  	      const appData = getAppBag();
  	      const companies = getCompaniesFromTrackitAppData(appData);

  	      const results = [];
  	      const seenCompanies = new Set();

  	      companies.forEach((company, index) => {
  	        if (!company || typeof company !== "object") return;

  	        const name = getCompanyDisplayName(company, index);
  	        const key = getCompanyKey(company, name, index);

  	        if (seenCompanies.has(key)) return;
  	        seenCompanies.add(key);

  	        const rawLocations = getCompanyLocationsFromTrackit(company);
  	        const flattenedLocations = flattenLocationsFromTrackit(rawLocations);

  	        const drawableLocations = flattenedLocations.filter(location => {
  	          try {
  	            return locationHasGeo(location);
  	          } catch (_) {
  	            return false;
  	          }
  	        });

  	        results.push({
  	          key,
  	          name,
  	          company,
  	          locations: drawableLocations,
  	          rawLocationCount: flattenedLocations.length
  	        });
  	      });

  	      results.sort((a, b) => {
  	        return String(a.name).localeCompare(String(b.name), undefined, {
  	          numeric: true,
  	          sensitivity: "base"
  	        });
  	      });

  	      console.log("[TrackIT Locations] Companies loaded:",
  	        results.map(c => ({
  	          name: c.name,
  	          key: c.key,
  	          drawableLocations: c.locations.length,
  	          rawLocations: c.rawLocationCount
  	        })));

  	      return results;
  	    }

  	    function getLocationCenter(loc) {
  	      const path = readPathFromLocation(loc);

  	      if (path.length >= 3) {
  	        try {
  	          const b = new google.maps.LatLngBounds();
  	          path.forEach(p => b.extend(p));
  	          const center = b.getCenter();

  	          return {
  	            lat: center.lat(),
  	            lng: center.lng()
  	          };
  	        } catch (_) {
  	          const total = path.reduce((acc, p) => {
  	            acc.lat += p.lat;
  	            acc.lng += p.lng;
  	            return acc;
  	          }, {
  	            lat: 0, lng: 0
  	          });

  	          return {
  	            lat: total.lat / path.length,
  	            lng: total.lng / path.length
  	          };
  	        }
  	      }

  	      return readPointFromObject(loc);
  	    }

  	    function createBlackLocationLabel(position, text) {
  	      const overlay = new google.maps.OverlayView();
  	      let div = null;

  	      overlay.onAdd = function () {
  	        div = document.createElement("div");
  	        div.className = "trackit-location-label-black";
  	        div.textContent = text || "Location";

  	        const panes = overlay.getPanes();

  	        if (panes?.floatPane) {
  	          panes.floatPane.appendChild(div);
  	        }
  	      };

  	      overlay.draw = function () {
  	        if (!div) return;

  	        const projection = overlay.getProjection();
  	        if (!projection) return;

  	        const point = projection.fromLatLngToDivPixel(
  	          new google.maps.LatLng(position.lat, position.lng)
  	        );

  	        if (!point) return;

  	        div.style.left = `${point.x}px`;
  	        div.style.top = `${point.y - 8}px`;
  	      };

  	      overlay.onRemove = function () {
  	        if (div) {
  	          div.remove();
  	          div = null;
  	        }
  	      };

  	      overlay.setMap(map);

  	      return overlay;
  	    }

  	    function createSmallLocationMarker(position, color) {
  	      const markerColor = normaliseLocationColor(color, "#ff8a3c");

  	      const svg = `
  	      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  	      <circle cx="9" cy="9" r="6" fill="rgba(0,0,0,0.88)" stroke="rgba(255,255,255,0.72)" stroke-width="2"/>
  	      <circle cx="9" cy="9" r="2.8" fill="${markerColor}"/>
  	      </svg>
  	      `;

  	      return new google.maps.Marker({
  	        position,
  	        map,
  	        clickable: false,
  	        zIndex: 20,
  	        icon: {
  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
  	          scaledSize: new google.maps.Size(18, 18),
  	          anchor: new google.maps.Point(9, 9)
  	        }
  	      });
  	    }

  	    function normaliseLocationColor(value, fallback) {
  	      if (value === undefined || value === null) return fallback;

  	      if (typeof value === "object") {
  	        const nested =
  	        value.hex ||
  	        value.Hex ||
  	        value.color ||
  	        value.Color ||
  	        value.colour ||
  	        value.Colour ||
  	        value.value ||
  	        value.Value ||
  	        value.background ||
  	        value.Background ||
  	        value.stroke ||
  	        value.Stroke ||
  	        value.fill ||
  	        value.Fill;

  	        return normaliseLocationColor(nested, fallback);
  	      }

  	      const text = String(value).trim();

  	      if (!text) return fallback;

  	      // Hex, rgb, rgba, hsl, hsla, or named CSS colour.
  	      if (
  	        /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(text) ||
  	        /^rgba?\(/i.test(text) ||
  	        /^hsla?\(/i.test(text) ||
  	        /^[a-z]+$/i.test(text)
  	      ) {
  	        return text;
  	      }

  	      return fallback;
  	    }

  	    function getLocationColor(loc, company) {
  	      const fallback = "#ff8a3c";

  	      const locationColorPaths = [
  	        "Color",
  	        "color",
  	        "Colour",
  	        "colour",
  	        "LocationColor",
  	        "locationColor",
  	        "LocationColour",
  	        "locationColour",
  	        "PolygonColor",
  	        "polygonColor",
  	        "FillColor",
  	        "fillColor",
  	        "StrokeColor",
  	        "strokeColor",
  	        "HexColor",
  	        "hexColor",
  	        "HexColour",
  	        "hexColour",

  	        "Style.Color",
  	        "Style.color",
  	        "Style.Colour",
  	        "Style.colour",
  	        "Style.FillColor",
  	        "Style.fillColor",
  	        "Style.StrokeColor",
  	        "Style.strokeColor",

  	        "LocationData.Color",
  	        "LocationData.color",
  	        "LocationData.Colour",
  	        "LocationData.colour",
  	        "LocationData.LocationColor",
  	        "LocationData.locationColor",
  	        "LocationData.FillColor",
  	        "LocationData.fillColor",
  	        "LocationData.StrokeColor",
  	        "LocationData.strokeColor",

  	        "LocationData.Style.Color",
  	        "LocationData.Style.color",
  	        "LocationData.Style.FillColor",
  	        "LocationData.Style.fillColor",
  	        "LocationData.Style.StrokeColor",
  	        "LocationData.Style.strokeColor",

  	        "LocationData.Shape.Color",
  	        "LocationData.Shape.color",
  	        "LocationData.Shape.Colour",
  	        "LocationData.Shape.colour",
  	        "LocationData.Shape.FillColor",
  	        "LocationData.Shape.fillColor",
  	        "LocationData.Shape.StrokeColor",
  	        "LocationData.Shape.strokeColor",

  	        "Shape.Color",
  	        "Shape.color",
  	        "Shape.Colour",
  	        "Shape.colour",
  	        "Shape.FillColor",
  	        "Shape.fillColor",
  	        "Shape.StrokeColor",
  	        "Shape.strokeColor"
  	      ];

  	      for (const path of locationColorPaths) {
  	        const color = normaliseLocationColor(locGetPath(loc, path), null);
  	        if (color) return color;
  	      }

  	      const companyColorPaths = [
  	        "Color",
  	        "color",
  	        "Colour",
  	        "colour",
  	        "CompanyColor",
  	        "companyColor",
  	        "CompanyColour",
  	        "companyColour",
  	        "Style.Color",
  	        "Style.color"
  	      ];

  	      for (const path of companyColorPaths) {
  	        const color = normaliseLocationColor(locGetPath(company, path), null);
  	        if (color) return color;
  	      }

  	      return fallback;
  	    }

  	    function getSouthWestPoint(points) {
  	      if (!Array.isArray(points) || !points.length) return null;

  	      let chosen = null;

  	      points.forEach(p => {
  	        if (!p || !validLatLng(Number(p.lat), Number(p.lng))) return;

  	        const point = {
  	          lat: Number(p.lat),
  	          lng: Number(p.lng)
  	        };

  	        if (!chosen) {
  	          chosen = point;
  	          return;
  	        }

  	        // South = smaller latitude.
  	        // West = smaller longitude.
  	        // We choose the point that is most south first, then most west.
  	        if (
  	          point.lat < chosen.lat ||
  	          (point.lat === chosen.lat && point.lng < chosen.lng)
  	        ) {
  	          chosen = point;
  	        }
  	      });

  	      return chosen;
  	    }

  	    function drawCompanyLocations(company,
  	      fitToLocations) {
  	      if (!company) return;

  	      const companyKey = String(company.key);

  	      clearAppLocationLayer(companyKey);

  	      const layer = getTrackitLocationLayer();

  	      layer.companyLayers[companyKey] = {
  	        overlays: [],
  	        labels: []
  	      };

  	      const companyLayer = layer.companyLayers[companyKey];

  	      const bounds = new google.maps.LatLngBounds();
  	      let drawn = 0;

  	      (company.locations || []).forEach((loc, index) => {
  	        const label = getLocationName(loc, index);
  	        const path = readPathFromLocation(loc);
  	        const center = getLocationCenter(loc);
  	        const locationColor = getLocationColor(loc, company);

  	        if (!center) {
  	          console.warn("[TrackIT Locations] Location skipped, no center:", loc);
  	          return;
  	        }

  	        if (path.length >= 3) {
  	          const polygon = new google.maps.Polygon({
  	            paths: path,
  	            map,
  	            clickable: false,
  	            zIndex: 10,

  	            strokeColor: locationColor,
  	            strokeOpacity: 0.95,
  	            strokeWeight: 2,
  	            fillColor: locationColor,
  	            fillOpacity: 0.16
  	          });

  	          companyLayer.overlays.push(polygon);

  	          path.forEach(p => bounds.extend(p));

  	          console.log("[TrackIT Locations] Polygon drawn:", {
  	            company: company.name,
  	            label,
  	            points: path.length
  	          });

  	        } else {
  	          const marker = createSmallLocationMarker(center, locationColor);

  	          companyLayer.overlays.push(marker);
  	          bounds.extend(center);

  	          console.log("[TrackIT Locations] Point drawn:", {
  	            company: company.name,
  	            label,
  	            center
  	          });
  	        }

  	        const labelPosition = path.length >= 3
  	        ? (getSouthWestPoint(path) || center): center;

  	        const labelOverlay = createBlackLocationLabel(labelPosition, label);

  	        companyLayer.labels.push(labelOverlay);

  	        drawn++;
  	      });

  	      if (fitToLocations && drawn > 0) {
  	        try {
  	          if (drawn === 1) {
  	            map.panTo(bounds.getCenter());

  	            if ((map.getZoom() || 1) < 15) {
  	              map.setZoom(15);
  	            }
  	          } else {
  	            map.fitBounds(bounds, {
  	              top: 80,
  	              right: 80,
  	              bottom: 80,
  	              left: 80
  	            });
  	          }
  	        } catch (_) {}
  	      }

  	      if (drawn === 0) {
  	        console.warn("[TrackIT Locations] Company checked but no drawable geo found:", company);
  	      }
  	    }

  	    function renderCheckedLocationCompanies(fitToLocations) {
  	      const companies = map.__trackitLocationCompanies || [];

  	      checkedLocationCompanyKeys.forEach(key => {
  	        const company = companies.find(c => String(c.key) === String(key));

  	        if (company) {
  	          drawCompanyLocations(company, fitToLocations);
  	        }
  	      });
  	    }

  	    function renderLocationCompanyList() {
  	      const companies = getAppLocationCompanies();

  	      map.__trackitLocationCompanies = companies;

  	      locationsList.innerHTML = "";

  	      if (!companies.length) {
  	        const empty = document.createElement("div");
  	        empty.className = "trackit-location-empty";
  	        empty.textContent = "No companies found";
  	        locationsList.appendChild(empty);
  	        return;
  	      }

  	      companies.forEach(company => {
  	        const checked = isLocationCompanyChecked(company.key);

  	        const row = document.createElement("label");
  	        row.className = "trackit-location-company-row";
  	        row.classList.toggle("active", checked);

  	        const checkbox = document.createElement("input");
  	        checkbox.type = "checkbox";
  	        checkbox.checked = checked;

  	        const tick = document.createElement("span");
  	        tick.className = "trackit-location-tick";

  	        const name = document.createElement("span");
  	        name.className = "trackit-location-company-name";
  	        name.textContent = company.name;

  	        const count = document.createElement("span");
  	        count.className = "trackit-location-company-count";
  	        count.textContent = String(company.locations.length);

  	        row.appendChild(checkbox);
  	        row.appendChild(tick);
  	        row.appendChild(name);
  	        row.appendChild(count);

  	        checkbox.addEventListener("change", function (event) {
  	          event.stopPropagation();

  	          const nowChecked = !!checkbox.checked;

  	          setLocationCompanyChecked(company.key, nowChecked);

  	          row.classList.toggle("active", nowChecked);

  	          if (nowChecked) {
  	            drawCompanyLocations(company, true);
  	          } else {
  	            clearAppLocationLayer(company.key);
  	          }

  	          sizeFleetMapControlShell(control, !collapsed);
  	        });

  	        row.addEventListener("click",
  	          function (event) {
  	            event.stopPropagation();
  	          });

  	        locationsList.appendChild(row);
  	      });
  	    }

  	    function paintLocationsUi() {
  	      locationsCheckbox.checked = !!locationsOn;
  	      locationsList.classList.toggle("visible", !!locationsOn);
  	    }

  	    function syncLocationLayerFromSettings(fitToLocations) {
  	      paintLocationsUi();

  	      if (!locationsOn) {
  	        clearAppLocationLayer();
  	        return;
  	      }

  	      renderLocationCompanyList();
  	      renderCheckedLocationCompanies(fitToLocations);
  	    }

  	    function isFullscreenActive() {
  	      const mapDiv = map.getDiv();
  	      const fs = document.fullscreenElement || document.webkitFullscreenElement || null;

  	      return !!fs && (fs === mapDiv || fs.contains(mapDiv));
  	    }

  	    function paintFullscreenState() {
  	      fullscreenBtn.classList.toggle("active", isFullscreenActive());
  	      fullscreenBtn.classList.toggle("fullscreen-active", isFullscreenActive());
  	    }

  	    function toggleFullscreen() {
  	      const mapDiv = map.getDiv();

  	      try {
  	        if (!document.fullscreenElement && !document.webkitFullscreenElement) {
  	          if (mapDiv.requestFullscreen) mapDiv.requestFullscreen();
  	          else if (mapDiv.webkitRequestFullscreen) mapDiv.webkitRequestFullscreen();
  	        } else {
  	          if (document.exitFullscreen) document.exitFullscreen();
  	          else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
  	        }
  	      } catch (e) {
  	        console.warn("[TrackIT Map Controls] Fullscreen failed:", e);
  	      }

  	      setTimeout(paintFullscreenState, 150);
  	    }

  	    function applyMapControlCollapsedState(saveSetting) {
  	      control.classList.toggle("collapsed", collapsed);
  	      updateHeaderState();
  	      sizeFleetMapControlShell(control, !collapsed);

  	      if (saveSetting) {
  	        writeSetting("panelCollapsedV8", collapsed);
  	      }
  	    }

  	    function toggleMapControlPanel(saveSetting = true) {
  	      collapsed = !collapsed;
  	      applyMapControlCollapsedState(saveSetting);
  	    }

  	    function closeMapControlPanel(saveSetting = false) {
  	      if (collapsed) return;

  	      collapsed = true;
  	      applyMapControlCollapsedState(saveSetting);
  	    }

  	    function openMapControlPanel(saveSetting = false) {
  	      if (!collapsed) return;

  	      collapsed = false;
  	      applyMapControlCollapsedState(saveSetting);
  	    }

  	    /* Optional external hooks if we ever need them elsewhere */
  	    map.__trackitCloseMapControlPanel = closeMapControlPanel;
  	    map.__trackitOpenMapControlPanel = openMapControlPanel;
  	    map.__trackitToggleMapControlPanel = toggleMapControlPanel;

  	    header.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      toggleMapControlPanel(true);
  	    });

  	    zoomPlus.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      const z = map.getZoom() || 1;
  	      map.setZoom(Math.min(22, z + 1));
  	    });

  	    zoomMinus.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      const z = map.getZoom() || 1;
  	      map.setZoom(Math.max(1, z - 1));
  	    });

  	    zoomSlider.addEventListener("input", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      map.setZoom(Number(zoomSlider.value));
  	    });

  	    trafficBtn.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      trafficOn = !trafficOn;
  	      map.__trackitTrafficLayer.setMap(trafficOn ? map: null);

  	      writeSetting("trafficOn", trafficOn);
  	      paintToggleButtons();
  	    });

  	    labelsBtn.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      labelsOn = !labelsOn;

  	      writeSetting("labelsOn", labelsOn);
  	      applyMapAppearance();
  	      paintToggleButtons();
  	    });

  	    fullscreenBtn.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      toggleFullscreen();
  	    });

  	    directionsBtn.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      if (typeof event.stopImmediatePropagation === "function") {
  	        event.stopImmediatePropagation();
  	      }

  	      toggleDirectionsMode();
  	      sizeFleetMapControlShell(control, !collapsed);
  	    });

  	    locationsCheckbox.addEventListener("change",
  	      function (event) {
  	        event.preventDefault();
  	        event.stopPropagation();

  	        locationsOn = !!locationsCheckbox.checked;
  	        writeSetting("locationsOn", locationsOn);

  	        if (!locationsOn) {
  	          clearAppLocationLayer();
  	        } else {
  	          renderLocationCompanyList();
  	          renderCheckedLocationCompanies(false);
  	        }

  	        paintLocationsUi();
  	        sizeFleetMapControlShell(control, !collapsed);
  	      });

  	    map.__trackitMapControlListeners.push(
  	      map.addListener("zoom_changed", updateZoomUi)
  	    );

  	    map.__trackitMapControlListeners.push(
  	      map.addListener("maptypeid_changed", function () {
  	        paintMapTypeButtons();
  	      })
  	    );

  	    const fullscreenHandler = function () {
  	      paintFullscreenState();
  	    };

  	    document.addEventListener("fullscreenchange",
  	      fullscreenHandler);
  	    document.addEventListener("webkitfullscreenchange",
  	      fullscreenHandler);

  	    map.__trackitDomControlListeners.push({
  	      target: document,
  	      event: "fullscreenchange",
  	      handler: fullscreenHandler
  	    });

  	    map.__trackitDomControlListeners.push({
  	      target: document,
  	      event: "webkitfullscreenchange",
  	      handler: fullscreenHandler
  	    });

  	    const resizeHandler = function () {
  	      sizeFleetMapControlShell(control,
  	        !collapsed);
  	    };

  	    if (typeof window !== "undefined") {
  	      window.addEventListener("resize", resizeHandler);
  	      map.__trackitDomControlListeners.push({
  	        target: window,
  	        event: "resize",
  	        handler: resizeHandler
  	      });
  	    }

  	    const savedZoom = readSetting("zoom", null);

  	    if (savedZoom !== null && savedZoom !== undefined) {
  	      try {
  	        map.setZoom(Number(savedZoom));
  	      } catch (_) {}
  	    }

  	    applyMapAppearance();
  	    updateZoomUi();
  	    updateHeaderState();
  	    sizeFleetMapControlShell(control, !collapsed);
  	    paintMapTypeButtons();
  	    paintToggleButtons();
  	    paintDirectionsButton();
  	    syncLocationLayerFromSettings(false);
  	    sizeFleetMapControlShell(control, !collapsed);

  	    function svgBase(paths) {
  	      return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
  	    }

  	    function iconLayers() {
  	      return svgBase(`
  	        <path d="M12 3 3 8l9 5 9-5-9-5Z"/>
  	        <path d="M3 12l9 5 9-5"/>
  	        <path d="M3 16l9 5 9-5"/>
  	        `);
  	    }

  	    function iconRoadmap() {
  	      return svgBase(`
  	        <path d="M4 18V6l5-2 6 2 5-2v12l-5 2-6-2-5 2Z"/>
  	        <path d="M9 4v12"/>
  	        <path d="M15 6v12"/>
  	        <path d="M12 9h.01"/>
  	        <path d="M17 11h.01"/>
  	        `);
  	    }

  	    function iconSatellite() {
  	      return svgBase(`
  	        <path d="m6 14 4 4"/>
  	        <path d="m14 6 4 4"/>
  	        <path d="m8 16 8-8"/>
  	        <rect x="12" y="3" width="7" height="5" rx="1" transform="rotate(45 12 3)"/>
  	        <rect x="4" y="13" width="7" height="5" rx="1" transform="rotate(45 4 13)"/>
  	        <path d="M17 17c1.5-1.5 2-3.5 1.2-5.2"/>
  	        <path d="M20 20c2.5-2.5 3-6 1.4-8.8"/>
  	        `);
  	    }

  	    function iconTerrain() {
  	      return svgBase(`
  	        <path d="m3 18 6-10 4 6 3-5 5 9H3Z"/>
  	        <path d="m8.5 12 2 2"/>
  	        <path d="m15.5 13 2 2"/>
  	        `);
  	    }

  	    function iconDirections() {
  	      return svgBase(`
  	        <path d="M6 19V6.5A2.5 2.5 0 0 1 8.5 4H17"/>
  	        <path d="M14 1l3 3-3 3"/>
  	        <path d="M6 19l-3-3"/>
  	        <path d="M6 19l3-3"/>
  	        <path d="M10 10h4a3 3 0 0 1 3 3v5"/>
  	        `);
  	    }

  	    function iconTraffic() {
  	      return svgBase(`
  	        <path d="M6 16h12"/>
  	        <path d="M7 16v3"/>
  	        <path d="M17 16v3"/>
  	        <path d="M7 13l1.5-5h7L17 13"/>
  	        <path d="M8 13h8"/>
  	        <circle cx="8.5" cy="16" r="1"/>
  	        <circle cx="15.5" cy="16" r="1"/>
  	        `);
  	    }

  	    function iconLocation() {
  	      return svgBase(`
  	        <path d="M12 21s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12Z"/>
  	        <circle cx="12" cy="9" r="2.4"/>
  	        `);
  	    }

  	    function iconFullscreen() {
  	      return svgBase(`
  	        <path d="M8 3H3v5"/>
  	        <path d="M16 3h5v5"/>
  	        <path d="M8 21H3v-5"/>
  	        <path d="M16 21h5v-5"/>
  	        `);
  	    }

  	    function iconLabel() {
  	      return svgBase(`
  	        <path d="M5 5h14v14H5z"/>
  	        <path d="M8 9h8"/>
  	        <path d="M8 12h6"/>
  	        <path d="M8 15h4"/>
  	        `);
  	    }
  	  }
  	  // ---------- FineTrack opener ----------
  	  window.__fineTrackComponent = fineTrack || null;

  	  window.__bl_open_fineTrack = async function () {
  	    try {
  	      const c = window.__fineTrackComponent;

  	      if (!c) return;

  	      const alreadyOpen = (!!c.display) || (!!c.isOpen);

  	      if (alreadyOpen) {
  	        if ("display" in c) c.display = false;
  	        if ("controlVisibility" in c) c.controlVisibility = false;
  	        if ("isOpen" in c) c.isOpen = false;

  	        if (typeof c.close === "function") {
  	          try {
  	            c.close();
  	          } catch (_) {}
  	        }

  	        await new Promise(r => setTimeout(r, 0));
  	      }

  	      if ("display" in c) c.display = true;
  	      if ("controlVisibility" in c) c.controlVisibility = true;
  	      if ("isOpen" in c) c.isOpen = true;

  	      if (typeof c.open === "function") {
  	        c.open();
  	      }

  	    } catch (e) {
  	      console.error("FineTrack open failed:", e);
  	    }
  	  };

  	  // ---------- popup -> set selected + open panel ----------
  	  window.__truckFineTrackClick = function (id) {
  	    try {
  	      const m = window.__truckFollow_map;
  	      const pin = m?.__truckPins?.[id];
  	      const t = pin?.tractor;

  	      if (!t) return;

  	      window.SelectedTractor = t;
  	      setSelectedInApp(t);
  	      window.__bl_open_fineTrack();

  	    } catch (e) {
  	      console.error("FineTrack click failed:", e);
  	    }
  	  };

  	  // ---------- map guard ----------
  	  if (!googleMapComponent?.map?.map || !(googleMapComponent.map.map instanceof google.maps.Map)) {
  	    console.error("Invalid Google Map component.");
  	    return;
  	  }

  	  const map = googleMapComponent.map.map;

  	  // Hard safety: disable Google POI/place popups even if controls are not rebuilt.
  	  try {
  	    map.setOptions({
  	      clickableIcons: true,
  	      streetViewControl: false
  	    });

  	    const panorama = map.getStreetView();
  	    panorama.setVisible(false);
  	  } catch (_) {}

  	  injectGoogleInfoWindowPaddingCss();
  	  addTrackitUnifiedMapControl(map);

  	  // ---------- follow state / toggles ----------
  	  if (!map.__follow) {
  	    map.__follow = {
  	      enabled: false,
  	      id: null
  	    };
  	  }

  	  window.__truckFollow_map = map;

  	  function setFollowOn(id) {
  	    const s = map.__truckPins && map.__truckPins[id];

  	    map.__follow.enabled = true;
  	    map.__follow.id = id;

  	    if (s?.marker) {
  	      const pos = s.marker.getPosition();

  	      map.panTo(pos);

  	      // When a truck icon is clicked / followed, zoom into vehicle level.
  	      try {
  	        if (map.getZoom() !== 18) {
  	          map.setZoom(18);
  	        }
  	      } catch (_) {}
  	    }

  	    if (map.__truckInfoWindow?.__currentTractor) {
  	      map.__truckInfoWindow.setContent(buildInfoHtml(map.__truckInfoWindow.__currentTractor));
  	    }
  	  }

  	  function toggleFollow(id) {
  	    const wasOn = map.__follow.enabled && map.__follow.id === id;

  	    if (wasOn) {
  	      map.__follow.enabled = false;
  	      map.__follow.id = null;
  	    } else {
  	      setFollowOn(id);
  	    }

  	    if (map.__truckInfoWindow?.__currentTractor) {
  	      map.__truckInfoWindow.setContent(buildInfoHtml(map.__truckInfoWindow.__currentTractor));
  	    }
  	  }

  	  window.__truckFollowToggle = toggleFollow;

  	  function refreshIfCurrent(id) {
  	    const iw = map.__truckInfoWindow;

  	    if (!iw || !iw.getMap()) return;
  	    if (iw.__currentId !== id) return;

  	    const t = store[id]?.tractor;

  	    if (!t) return;

  	    iw.setContent(buildInfoHtml(t));
  	  }

  	  // ---------- visuals config ----------
  	  const CFG = {
  	    W: 176,
  	    H: 176,
  	    CX: 88,
  	    CY: 88,
  	    OUTER_R: 44,
  	    DOT_R: 18,
  	    PTR_LEN: 40,
  	    PTR_HALF: 24,
  	    SCALE: 0.30,
  	    HEADING_OFFSET: 0,
  	    MOVING_SPEED_KMH: 2,

  	    COLORS: {
  	      truckFallback: "#18a058",
  	      status: {
  	        moving: "#18a058",
  	        stopped: "#7a7a7a",
  	        warn: "#ee4b2b"
  	      },
  	      pulse: {
  	        moving: "#18a058",
  	        warn: "#ee4b2b"
  	      },
  	      stroke: "#101010",
  	      innerRim: "rgba(255,255,255,0.35)",
  	      outline: "#ffffff"
  	    },

  	    OUTLINE_W: 6,

  	    PULSE: {
  	      moving: {
  	        periodMs: 950,
  	        minScale: 1.0,
  	        maxScale: 3.00,
  	        minOpacity: 0.40,
  	        maxOpacity: 0.60
  	      },
  	      warning: {
  	        periodMs: 950,
  	        minScale: 1.0,
  	        maxScale: 3.00,
  	        minOpacity: 0.60,
  	        maxOpacity: 0.90
  	      }
  	    },

  	    DEBUG: false
  	  };

  	  const WARN_COL = {
  	    speed: "#CC6633",
  	    rpm: "#7B08CD",
  	    temp: "#947F00"
  	  };

  	  // ---------- stores / infoWindow ----------
  	  if (!map.__truckPins) {
  	    map.__truckPins = {};
  	  }

  	  const store = map.__truckPins;

  	  function resetFleetMapView() {
  	    try {
  	      const bounds = new google.maps.LatLngBounds();
  	      let count = 0;

  	      Object.keys(store || {}).forEach(id => {
  	        const marker = store[id]?.marker;
  	        if (!marker || !marker.getPosition) return;

  	        const pos = marker.getPosition();
  	        if (!pos) return;

  	        bounds.extend(pos);
  	        count++;
  	      });

  	      if (count === 0) return;

  	      // Turn follow off so the next refresh does not immediately pan back to the closed truck.
  	      if (map.__follow) {
  	        map.__follow.enabled = false;
  	        map.__follow.id = null;
  	      }

  	      if (count === 1) {
  	        map.setCenter(bounds.getCenter());

  	        // Single-vehicle fallback. Change 14 if you want a different reset zoom.
  	        map.setZoom(14);
  	        return;
  	      }

  	      map.fitBounds(bounds, {
  	        top: 80,
  	        right: 80,
  	        bottom: 80,
  	        left: 80
  	      });

  	      // Prevent reset from staying too close if all vehicles are near each other.
  	      google.maps.event.addListenerOnce(map, "idle", function () {
  	        try {
  	          if (map.getZoom() > 14) {
  	            map.setZoom(14);
  	          }
  	        } catch (_) {}
  	      });

  	    } catch (e) {
  	      console.warn("[TrackIT] Fleet map reset failed:",
  	        e);
  	    }
  	  }

  	  if (!map.__truckInfoWindow) {
  	    map.__truckInfoWindow = new google.maps.InfoWindow({});
  	  }

  	  if (!map.__popupCloseBound) {
  	    map.__popupCloseBound = true;

  	    google.maps.event.addListener(map.__truckInfoWindow, "closeclick", () => {
  	      writeSelectedTractorMarkerId(null);

  	      map.__truckInfoWindow.__currentId = null;
  	      map.__truckInfoWindow.__currentTractor = null;

  	      if (map.__follow) {
  	        map.__follow.enabled = false;
  	        map.__follow.id = null;
  	      }

  	      // IMPORTANT:
  	      // Do NOT reset, fitBounds, setCenter, panTo, or setZoom here.
  	      // Closing the popup must keep the current map center and zoom exactly as-is.
  	    });
  	  }

  	  // ---------- utils ----------
  	  const num = (v) => {
  	    return typeof v === "number" ? v: Number(v);
  	  };

  	  const bool = (v) => {
  	    return (
  	      v === true ||
  	      v === 1 ||
  	      (
  	        typeof v === "string" &&
  	        ["true", "1", "yes", "y", "on"].includes(v.toLowerCase())
  	      )
  	    );
  	  };

  	  const getPath = (o,
  	    p) => {
  	    if (!o || !p) return undefined;

  	    if (Object.prototype.hasOwnProperty.call(o, p)) {
  	      return o[p];
  	    }

  	    return p.split(".").reduce((a, k) => {
  	      return (a && a[k] !== undefined) ? a[k]: undefined;
  	    }, o);
  	  };

  	  const fmtNum = (v, d = 1) => {
  	    return Number.isFinite(+v)
  	    ? (+v)
  	    .toFixed(d)
  	    .replace(/\.0+$/, "")
  	    .replace(/(\.\d*[1-9])0+$/, "$1"): "–";
  	  };

  	  const degToCompass = (deg) => {
  	    return ["N",
  	      "NNE",
  	      "NE",
  	      "ENE",
  	      "E",
  	      "ESE",
  	      "SE",
  	      "SSE",
  	      "S",
  	      "SSW",
  	      "SW",
  	      "WSW",
  	      "W",
  	      "WNW",
  	      "NW",
  	      "NNW"][
  	      Math.floor(((+deg || 0) + 11.25) / 22.5) % 16
  	    ];
  	  };

  	  function safeJsString(value) {
  	    return String(value ?? "")
  	    .replace(/\\/g, "\\\\")
  	    .replace(/'/g, "\\'")
  	    .replace(/\r/g, "")
  	    .replace(/\n/g, "\\n");
  	  }

  	  function overLimitRowMeta( {
  	    spd, rpm, tmp, limSpd, limRpm, limTmp
  	  }) {
  	    return {
  	      speedColor: (Number.isFinite(spd) && Number.isFinite(limSpd) && spd > limSpd) ? WARN_COL.speed: "",
  	      rpmColor: (Number.isFinite(rpm) && Number.isFinite(limRpm) && rpm > limRpm) ? WARN_COL.rpm: "",
  	      tempColor: (Number.isFinite(tmp) && Number.isFinite(limTmp) && tmp > limTmp) ? WARN_COL.temp: ""
  	    };
  	  }

  	  function collectWarnings(T) {
  	    const L = T?.Location || {};
  	    const Lim = T?.CAN || {};

  	    const spd = num(L["position.speed"]);
  	    const rpm = num(L["can.engine.rpm"]);
  	    const tmp = num(L["can.engine.temperature"]);

  	    const limSpd = num(Lim?.Speed);
  	    const limRpm = num(Lim?.RPM);
  	    const limTmp = num(Lim?.Temp);

  	    const rows = [];

  	    if (Number.isFinite(spd) && Number.isFinite(limSpd) && spd > limSpd) rows.push("spd");
  	    if (Number.isFinite(rpm) && Number.isFinite(limRpm) && rpm > limRpm) rows.push("rpm");
  	    if (Number.isFinite(tmp) && Number.isFinite(limTmp) && tmp > limTmp) rows.push("tmp");

  	    return rows;
  	  }

  	  function buildInfoHtml(T) {
  	    const L = T?.Location || {};
  	    const Lim = T?.CAN || {};
  	    const ViewC = T?.ViewC || T?.viewC || {};
  	    const D1 = ViewC?.Driver1 || ViewC?.driver1 || null;

  	    const ident = (T.FID || T.ID || T.Registration || T.Tracker || "Unit");
  	    const reg = T.Registration || L.Registration || "—";
  	    const fleet = T.FID || T.ID || "—";

  	    const driver =
  	    (
  	      D1 &&
  	      (
  	        D1.name ||
  	        [D1.first_name || D1.firstName, D1.last_name || D1.lastName].filter(Boolean).join(" ") ||
  	        D1.username
  	      )
  	    ) || "—";

  	    const phone =
  	    D1?.Data_Details?.employee_details?.contact_details?.phone_number ||
  	    D1?.mobile ||
  	    D1?.phone ||
  	    D1?.tel ||
  	    "—";

  	    const speed = getPath(L, "position.speed");
  	    const rpm = getPath(L, "can.engine.rpm");
  	    const temp = getPath(L, "can.engine.temperature");
  	    const alt = getPath(L, "position.altitude");
  	    const dir = getPath(L, "position.direction");

  	    const {
  	      speedColor,
  	      rpmColor,
  	      tempColor
  	    } = overLimitRowMeta({
  	        spd: num(speed),
  	        rpm: num(rpm),
  	        tmp: num(temp),
  	        limSpd: num(Lim?.Speed),
  	        limRpm: num(Lim?.RPM),
  	        limTmp: num(Lim?.Temp)
  	      });

  	    const id = getId(T);
  	    const safeId = safeJsString(id);
  	    const following = map.__follow?.enabled && map.__follow.id === id;

  	    const rows = [{
  	      k: "Fleet ID",
  	      v: fleet
  	    },
  	      {
  	        k: "Registration",
  	        v: reg
  	      },
  	      {
  	        k: "Driver",
  	        v: driver
  	      },
  	      {
  	        k: "Driver Mobile",
  	        v: phone
  	      },
  	      {
  	        k: "Engine Temp.",
  	        v: `${fmtNum(temp)} °C`,
  	        style: tempColor
  	      },
  	      {
  	        k: "Speed",
  	        v: `${fmtNum(speed)} km/h${Number.isFinite(num(Lim?.Speed)) ? `  (limit ${fmtNum(Lim.Speed)})`: ""}`,
  	        style: speedColor
  	      },
  	      {
  	        k: "RPM",
  	        v: `${fmtNum(rpm, 0)} RPM${Number.isFinite(num(Lim?.RPM)) ? `  (limit ${fmtNum(Lim.RPM, 0)})`: ""}`,
  	        style: rpmColor
  	      },
  	      {
  	        k: "Altitude",
  	        v: `${fmtNum(alt, 0)} m`
  	      },
  	      {
  	        k: "Direction",
  	        v: degToCompass(num(dir))
  	      }];

  	    return `
  	    <div style="position:relative;font:500 13px/1.4 system-ui,-apple-system,Segoe UI,Roboto,Arial;min-width:290px;max-width:360px;color:#fff;padding:8px 10px 14px 10px;box-sizing:border-box;">

  	    <!-- Line 1: Google X only. Do not put anything else here. -->
  	    <div style="height:10px;"></div>

  	    <!-- Line 2: FineTrack icon + reg on left, small Following button on right -->
  	    <div style="height:28px;display:flex;align-items:center;justify-content:space-between;gap:10px;box-sizing:border-box;padding:0 2px;">

  	    <div
  	    onclick="window.__truckFineTrackClick('${safeId}')"
  	    title="Open Fine Track"
  	    style="display:flex;align-items:center;gap:8px;cursor:pointer;min-width:0;flex:1 1 auto;"
  	    >
  	    <span style="display:inline-flex;align-items:center;justify-content:center;width:20px;height:22px;flex:0 0 22px;">
  	    <svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true" style="pointer-events:none;display:block;">
  	    <path d="M5 8c0-2 1-3.8 2.6-4.9" stroke="#cc6633" stroke-width="4" fill="none" stroke-linecap="round"/>
  	    <path d="M2.5 8c0-3.3 1.7-6.2 4.4-7.8" stroke="#cc6633" stroke-width="4" fill="none" stroke-linecap="round" opacity="0.7"/>
  	    <path d="M19 8c0-2-1-3.8-2.6-4.9" stroke="#cc6633" stroke-width="4" fill="none" stroke-linecap="round"/>
  	    <path d="M21.5 8c0-3.3-1.7-6.2 4.4-7.8" stroke="#cc6633" stroke-width="4" fill="none" stroke-linecap="round" opacity="0.7"/>
  	    <path d="M12 2c3.31 0 6 2.69 6 6c0 4.97-6 12-6 12S6 12.97 6 8c0-3.31 2.69-6 6-6z" stroke="#cc6633" stroke-width="4" fill="none" stroke-linejoin="round"/>
  	    <circle cx="12" cy="8" r="2" fill="#cc6633"/>
  	    </svg>
  	    </span>

  	    <span style="font-weight:950;font-size:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-shadow:0 1px 3px rgba(0,0,0,0.78);">
  	    ${String(ident)}
  	    </span>
  	    </div>

  	    <button
  	    onclick="window.__truckFollowToggle('${safeId}')"
  	    style="height:20px;flex:0 0 auto;border:1px solid rgba(255,255,255,0.38);background:${following ? "#2fa85b": "rgba(255,255,255,0.08)"};color:#fff;padding:0 6px;border-radius:5px;font-size:10px;font-weight:850;line-height:18px;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,0.28);"
  	    >
  	    ${following ? "Following": "Follow"}
  	    </button>

  	    </div>

  	    <div style="height:8px;"></div>

  	    <div>
  	    ${rows.map(r => `
  	      <div style="display:grid;grid-template-columns:130px 1fr;align-items:center;gap:12px;padding:4px 8px;margin:2px 0;border-radius:4px;${r.style ? `background:${r.style};`: ""}">
  	      <div style="opacity:0.82;font-weight:700;white-space:nowrap;text-shadow:0 1px 2px rgba(0,0,0,0.55);">${r.k}</div>
  	      <div style="font-weight:850;text-align:right;white-space:nowrap;text-shadow:0 1px 2px rgba(0,0,0,0.65);">${r.v}</div>
  	      </div>
  	      `).join("")}
  	    </div>

  	    <div style="height:12px;"></div>
  	    </div>
  	    `;
  	  }

  	  // ---------- position / identity ----------
  	  const getLatLng = (it) => {
  	    if (Number.isFinite(it?.lat) && Number.isFinite(it?.lng)) {
  	      return {
  	        lat: num(it.lat),
  	        lng: num(it.lng)
  	      };
  	    }

  	    const L = it?.Location || it?.Tractor?.Location;
  	    const lat = num(getPath(L, "position.latitude"));
  	    const lng = num(getPath(L, "position.longitude"));

  	    return (Number.isFinite(lat) && Number.isFinite(lng))
  	    ? {
  	      lat,
  	      lng
  	    }: {
  	      lat: NaN,
  	      lng: NaN
  	    };
  	  };

  	  const getId = (o) => {
  	    const t = o?.Tractor || o;

  	    return (
  	      t?.FID ||
  	      t?.ID ||
  	      t?.Registration ||
  	      t?.Tracker ||
  	      t?.Location?.ident ||
  	      null
  	    );
  	  };

  	  const getObjectId = (o) => {
  	    return (
  	      o?.Tractor?.objectId ||
  	      o?.objectId ||
  	      o?.Location?.objectId ||
  	      null
  	    );
  	  };

  	  const isMoving = (t) => {
  	    const L = t?.Location || t?.Tractor?.Location || t || {};
  	    const spd = num(getPath(L, "position.speed"));

  	    if (Number.isFinite(spd)) {
  	      return spd > CFG.MOVING_SPEED_KMH;
  	    }

  	    const canSpd = num(t?.CAN?.Speed ?? t?.Tractor?.CAN?.Speed ?? t?.["can.vehicle.speed"]);

  	    if (Number.isFinite(canSpd)) {
  	      return canSpd > CFG.MOVING_SPEED_KMH;
  	    }

  	    return bool(getPath(L, "movement.status")) === true;
  	  };

  	  const hasWarning = (t) => {
  	    return collectWarnings(t).length > 0;
  	  };

  	  // ---------- badge svgs ----------
  	  function svgBadge(o) {
  	    const W = CFG.W;
  	    const H = CFG.H;
  	    const CX = CFG.CX;
  	    const CY = CFG.CY;
  	    const R = CFG.OUTER_R;
  	    const DR = CFG.DOT_R;
  	    const PH = CFG.PTR_HALF;
  	    const PL = CFG.PTR_LEN;
  	    const ang = (+o.headingDeg || 0) + CFG.HEADING_OFFSET;

  	    const tipY = CY - R - PL;
  	    const baseY = CY - R + 2;

  	    return `
  	    <svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}">
  	    <circle cx="${CX}" cy="${CY}" r="${R}" fill="none" stroke="${CFG.COLORS.outline}" stroke-width="${CFG.OUTLINE_W}"/>

  	    <g transform="rotate(${ang}, ${CX}, ${CY})">
  	    <path d="M ${CX},${tipY} L ${CX - PH},${baseY} L ${CX + PH},${baseY} Z"
  	    fill="none"
  	    stroke="${CFG.COLORS.outline}"
  	    stroke-width="${CFG.OUTLINE_W}"/>
  	    </g>

  	    <circle cx="${CX}" cy="${CY}" r="${R}"
  	    fill="${o.truckColor}"
  	    stroke="${CFG.COLORS.stroke}"
  	    stroke-width="2"/>

  	    <circle cx="${CX}" cy="${CY}" r="${DR}"
  	    fill="${o.statusColor}"
  	    stroke="${CFG.COLORS.outline}"
  	    stroke-width="2"/>

  	    <circle cx="${CX}" cy="${CY}" r="${DR - 3}"
  	    fill="none"
  	    stroke="${CFG.COLORS.innerRim}"
  	    stroke-width="2"/>

  	    <g transform="rotate(${ang}, ${CX}, ${CY})">
  	    <path d="M ${CX},${tipY} L ${CX - PH},${baseY} L ${CX + PH},${baseY} Z"
  	    fill="${o.truckColor}"
  	    stroke="${CFG.COLORS.stroke}"
  	    width="2"/>
  	    </g>
  	    </svg>
  	    `;
  	  }

  	  function svgPulse(color) {
  	    const R = CFG.OUTER_R + 2;

  	    return `
  	    <svg xmlns="http://www.w3.org/2000/svg" width="${CFG.W}" height="${CFG.H}" viewBox="0 0 ${CFG.W} ${CFG.H}">
  	    <circle cx="${CFG.CX}" cy="${CFG.CY}" r="${R}" fill="none" stroke="${color}" stroke-width="12"/>
  	    </svg>
  	    `;
  	  }

  	  // ---------- render / update ----------
  	  const seen = new Set();
  	  const validPoints = [];

  	  (items || []).forEach((raw = {}) => {
  	    const T = raw?.Location || raw?.CAN || raw?.FID ? raw: (raw?.Tractor || raw);
  	    const {
  	      lat, lng
  	    } = getLatLng(raw);

  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

  	    validPoints.push({
  	      lat, lng
  	    });

  	    const id = getId(T);

  	    if (!id) return;

  	    seen.add(id);

  	    const moving = isMoving(T);
  	    const warning = hasWarning(T);

  	    const statusColor = warning
  	    ? CFG.COLORS.status.warn: moving
  	    ? CFG.COLORS.status.moving: CFG.COLORS.status.stopped;

  	    const truckColor = T.color || CFG.COLORS.truckFallback;
  	    const headingDeg = num(getPath((T.Location || {}), "position.direction")) || 0;

  	    const scaledW = Math.round(CFG.W * CFG.SCALE);
  	    const scaledH = Math.round(CFG.H * CFG.SCALE);

  	    const anchorX = Math.round(scaledW * (CFG.CX / CFG.W));
  	    const anchorY = Math.round(scaledH * (CFG.CY / CFG.H));

  	    const icon = {
  	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgBadge({
  	        truckColor, statusColor, headingDeg
  	      }))}`,
  	      scaledSize: new google.maps.Size(scaledW, scaledH),
  	      anchor: new google.maps.Point(anchorX, anchorY)
  	    };

  	    if (store[id]?.marker) {
  	      const m = store[id].marker;

  	      m.setPosition({
  	        lat, lng
  	      });

  	      if (m.getIcon()?.url !== icon.url) {
  	        m.setIcon(icon);
  	      }

  	      m.setTitle(`${T.FID ?? T.ID ?? "Unit"}${warning ? " • WARNING": moving ? " • moving": " • stopped"}`);

  	      store[id].tractor = T;
  	      store[id].objectId = getObjectId(T);

  	      refreshIfCurrent(id);

  	    } else {
  	      store[id] = store[id] || {};
  	      store[id].tractor = T;
  	      store[id].objectId = getObjectId(T);

  	      store[id].marker = new google.maps.Marker({
  	        position: {
  	          lat, lng
  	        },
  	        map,
  	        icon,
  	        draggable: false,
  	        title: `${T.FID ?? T.ID ?? "Unit"}${warning ? " • WARNING": moving ? " • moving": " • stopped"}`
  	      });

  	      store[id].marker.addListener("click", () => {

  	        try {
  	          const dir = map.__trackitDirections;

  	          if (dir?.active) {
  	            const pos = store[id]?.marker?.getPosition?.();
  	            const currentTractorForDirections = store[id]?.tractor || {};

  	            const vehicleLabel =
  	            currentTractorForDirections?.FID ||
  	            currentTractorForDirections?.ID ||
  	            currentTractorForDirections?.Registration ||
  	            currentTractorForDirections?.Tracker ||
  	            id;

  	            if (pos && typeof map.__trackitAddDirectionsPoint === "function") {
  	              const vehicleMeta = typeof map.__trackitGetDirectionsVehicleMeta === "function"
  	              ? map.__trackitGetDirectionsVehicleMeta(currentTractorForDirections, id)
  	              : null;

  	              map.__trackitAddDirectionsPoint(pos, String(vehicleLabel), vehicleMeta);
  	            }

  	            // Direction mode blocks normal vehicle popup.
  	            return;
  	          }
  	        } catch (_) {}
  	        try {
  	          const dir = map.__trackitDirections;

  	          if (dir?.active) {
  	            const pos = store[id]?.marker?.getPosition?.();
  	            const currentTractorForDirections = store[id]?.tractor || {};

  	            const vehicleLabel =
  	            currentTractorForDirections?.FID ||
  	            currentTractorForDirections?.ID ||
  	            currentTractorForDirections?.Registration ||
  	            currentTractorForDirections?.Tracker ||
  	            id;

  	            if (pos && typeof map.__trackitAddDirectionsPoint === "function") {
  	              const vehicleMeta = typeof map.__trackitGetDirectionsVehicleMeta === "function"
  	              ? map.__trackitGetDirectionsVehicleMeta(currentTractorForDirections, id)
  	              : null;

  	              map.__trackitAddDirectionsPoint(pos, String(vehicleLabel), vehicleMeta);
  	            }

  	            // Direction mode temporarily blocks the vehicle popup.
  	            return;
  	          }
  	        } catch (_) {}

  	        const currentTractor = store[id]?.tractor;

  	        if (!currentTractor) return;

  	        const html = buildInfoHtml(currentTractor);

  	        map.__truckInfoWindow.__currentTractor = currentTractor;
  	        map.__truckInfoWindow.__currentId = id;
  	        map.__truckInfoWindow.setContent(html);
  	        map.__truckInfoWindow.open({
  	          anchor: store[id].marker,
  	          map
  	        });

  	        setFollowOn(id);

  	        try {
  	          writeSelectedTractorMarkerId(store[id].objectId || null);
  	        } catch (_) {}
  	      });
  	    }

  	    if (map.__follow?.enabled && map.__follow.id === id) {
  	      map.panTo({
  	        lat, lng
  	      });
  	    }

  	    // ---------- pulse moving / warning ----------
  	    const mode = warning ? "warning": (moving ? "moving": null);

  	    if (!mode) {
  	      if (store[id].timerId) {
  	        clearInterval(store[id].timerId);
  	        store[id].timerId = null;
  	      }

  	      if (store[id].pulseMarker) {
  	        store[id].pulseMarker.setMap(null);
  	        store[id].pulseMarker = null;
  	      }

  	    } else {
  	      const pulseCfg = CFG.PULSE[mode];
  	      const pulseCol = warning ? CFG.COLORS.pulse.warn: CFG.COLORS.pulse.moving;
  	      const pulseSvg = svgPulse(pulseCol);

  	      if (!store[id].pulseMarker) {
  	        store[id].pulseMarker = new google.maps.Marker({
  	          position: {
  	            lat, lng
  	          },
  	          map,
  	          clickable: false,
  	          zIndex: 0,
  	          opacity: pulseCfg.maxOpacity,
  	          icon: {
  	            url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pulseSvg)}`,
  	            scaledSize: new google.maps.Size(scaledW, scaledH),
  	            anchor: new google.maps.Point(anchorX, anchorY)
  	          }
  	        });

  	      } else {
  	        store[id].pulseMarker.setPosition({
  	          lat, lng
  	        });

  	        store[id].pulseMarker.setIcon({
  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pulseSvg)}`,
  	          scaledSize: new google.maps.Size(scaledW, scaledH),
  	          anchor: new google.maps.Point(anchorX, anchorY)
  	        });
  	      }

  	      if (store[id].timerId) {
  	        clearInterval(store[id].timerId);
  	        store[id].timerId = null;
  	      }

  	      const {
  	        periodMs,
  	        minScale,
  	        maxScale,
  	        minOpacity,
  	        maxOpacity
  	      } = pulseCfg;

  	      const pulseMarker = store[id].pulseMarker;
  	      let t0 = performance.now();

  	      store[id].timerId = setInterval(() => {
  	        const now = performance.now();
  	        const phase = ((now - t0) % periodMs) / periodMs;

  	        const s = minScale + (maxScale - minScale) * phase;
  	        const a = maxOpacity - (maxOpacity - minOpacity) * phase;

  	        const w = Math.max(1, Math.round(scaledW * s));
  	        const h = Math.max(1, Math.round(scaledH * s));

  	        pulseMarker.setIcon({
  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pulseSvg)}`,
  	          scaledSize: new google.maps.Size(w, h),
  	          anchor: new google.maps.Point(
  	            Math.round(w * (CFG.CX / CFG.W)),
  	            Math.round(h * (CFG.CY / CFG.H))
  	          )
  	        });

  	        pulseMarker.setOpacity(a);
  	      }, 40);
  	    }
  	  });

  	  // ---------- cleanup ----------
  	  Object.keys(store).forEach((id) => {
  	    if (seen.has(id)) return;

  	    if (map.__follow?.enabled && map.__follow.id === id) {
  	      map.__follow.enabled = false;
  	      map.__follow.id = null;
  	    }

  	    store[id]?.marker?.setMap(null);

  	    if (store[id]?.timerId) {
  	      clearInterval(store[id].timerId);
  	    }

  	    store[id]?.pulseMarker?.setMap(null);

  	    delete store[id];
  	  });

  	  // ---------- initial fit / center only ----------
  	  // Do this only once. After that, keep the user's current zoom and center.
  	  if (!map.__trackitInitialFleetViewDone && !map.__follow?.enabled && centre === true) {
  	    map.__trackitInitialFleetViewDone = true;

  	    if (validPoints.length === 1) {
  	      map.setCenter(validPoints[0]);

  	    } else if (validPoints.length > 1) {
  	      const b = new google.maps.LatLngBounds();

  	      validPoints.forEach(p => b.extend(p));

  	      map.fitBounds(b);
  	    }
  	  }

  	  // ---------- AppData watcher: open + FOLLOW when SelectedTractorMarker matches ----------
  	  if (!map.__selectedMarkerWatcher) {
  	    map.__selectedMarkerWatcher = {
  	      timer: null,
  	      lastSeen: null
  	    };

  	    const tick = () => {
  	      try {
  	        const st = map.__selectedMarkerWatcher;
  	        const selId = readSelectedTractorMarkerId();

  	        if (!selId) {
  	          st.lastSeen = null;
  	          return;
  	        }

  	        if (selId === st.lastSeen) return;

  	        let matchId = null;
  	        let pin = null;

  	        for (const id of Object.keys(store)) {
  	          if (store[id]?.objectId && store[id].objectId === selId) {
  	            matchId = id;
  	            pin = store[id];
  	            break;
  	          }
  	        }

  	        if (pin?.marker) {
  	          const T = pin.tractor;

  	          map.__truckInfoWindow.__currentTractor = T;
  	          map.__truckInfoWindow.__currentId = matchId;
  	          map.__truckInfoWindow.setContent(buildInfoHtml(T));
  	          map.__truckInfoWindow.open({
  	            anchor: pin.marker,
  	            map
  	          });

  	          setFollowOn(matchId);
  	        }

  	        st.lastSeen = selId;

  	      } catch (e) {
  	        console.warn("SelectedTractorMarker watcher error:", e);
  	      }
  	    };

  	    map.__selectedMarkerWatcher.timer = setInterval(tick, 250);
  	  }

  	  if (CFG.DEBUG) {
  	    console.debug("TruckPins: active =", Object.keys(store).length, "follow =", map.__follow);
  	  }
  	}

  	// --- Usage Custom Code block ---
  	try {
  	  const googleMapComponent = arguments[0];
  	  const items = arguments[1];
  	  const centre = arguments[2];
  	  const fineTrack = arguments[3];
  	  const App = arguments[4];

  	  addMinimalTruckPins(googleMapComponent, items, centre, fineTrack, App);

  	} catch (e) {
  	  console.error("Error adding minimal truck pins:", e);
  	}
  })(Map, (await Promise.all((await asyncListFilter(Tractors, async (item) => {


   return (!((getObjectProperty(item, 'Location')) === null));
  })).map(async item => {; return ({ [`lat`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'position.latitude')),[`lng`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'position.longitude')),[`ID`]: (getObjectProperty(item, 'ID')),[`movement`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'movement.status')),[`Tractor`]: item });}))), true, Track, AppData);
  Tractors1 = [];
  var j_list = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Tractors1, k);
    }
  }
  await (async function(Repeater, Items) {
  	/*
  	 * BULLETPROOF TRACKIT REPEATER UPDATE
  	 *
  	 * arguments[0] = Repeater component
  	 * arguments[1] = Tractors1 array
  	 *
  	 * This block NEVER intentionally throws.
  	 */
  	
  	const repeater = arguments[0];
  	const source = arguments[1];
  	
  	const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  	
  	
  	// ------------------------------------------------------------
  	// Safe property reader.
  	// Supports BOTH:
  	//   obj["can.engine.rpm"]
  	// and:
  	//   obj.can.engine.rpm
  	// ------------------------------------------------------------
  	function getValue(obj, path) {
  	  try {
  	    if (obj == null) return undefined;
  	
  	    // Backendless/Flespi objects often actually contain dotted keys.
  	    if (Object.prototype.hasOwnProperty.call(obj, path)) {
  	      return obj[path];
  	    }
  	
  	    const parts = String(path).split(".");
  	    let value = obj;
  	
  	    for (const part of parts) {
  	      if (value == null) return undefined;
  	      value = value[part];
  	    }
  	
  	    return value;
  	
  	  } catch (_) {
  	    return undefined;
  	  }
  	}
  	
  	
  	// ------------------------------------------------------------
  	// Numeric helper.
  	// Returns NaN instead of throwing.
  	// ------------------------------------------------------------
  	function numberValue(value) {
  	  if (value === null || value === undefined || value === "") {
  	    return NaN;
  	  }
  	
  	  const n = Number(value);
  	  return Number.isFinite(n) ? n : NaN;
  	}
  	
  	
  	// ------------------------------------------------------------
  	// Work on a clean array.
  	// Never trust incoming component/page data.
  	// ------------------------------------------------------------
  	const tractors = Array.isArray(source)
  	  ? source.filter(item => item && typeof item === "object")
  	  : [];
  	
  	let result = [];
  	
  	try {
  	
  	  result = tractors.filter(item => {
  	
  	    try {
  	
  	      const location = getValue(item, "Location");
  	
  	      // Original first filter:
  	      // Location must exist.
  	      if (location === null || location === undefined) {
  	        return false;
  	      }
  	
  	
  	      // Original Tracker null/undefined check.
  	      const tracker = getValue(item, "Tracker");
  	
  	      if (tracker === null || tracker === undefined) {
  	        return false;
  	      }
  	
  	
  	      // --------------------------------------------------------
  	      // GPS warning condition.
  	      // --------------------------------------------------------
  	      const rpmWarning =
  	        getValue(location, "GPSWarnings.RPM") === true;
  	
  	      const speedWarning =
  	        getValue(location, "GPSWarnings.Speed") === true;
  	
  	      const tempWarning =
  	        getValue(location, "GPSWarnings.Temp") === true;
  	
  	
  	      if (rpmWarning || speedWarning || tempWarning) {
  	        return true;
  	      }
  	
  	
  	      // --------------------------------------------------------
  	      // Movement / RPM logic from your current Codeless blocks.
  	      // --------------------------------------------------------
  	      const rpmRaw = getValue(location, "can.engine.rpm");
  	      const speedRaw = getValue(location, "position.speed");
  	
  	      const speed = numberValue(speedRaw);
  	
  	
  	      // No RPM available:
  	      // moving above 2 km/h counts.
  	      if (rpmRaw === null || rpmRaw === undefined) {
  	        return Number.isFinite(speed) && speed > 2;
  	      }
  	
  	
  	      const rpm = numberValue(rpmRaw);
  	
  	      if (!Number.isFinite(rpm)) {
  	        return false;
  	      }
  	
  	      if (!Number.isFinite(speed)) {
  	        return false;
  	      }
  	
  	
  	      // Engine running while stationary.
  	      if (rpm > 100 && speed === 0) {
  	        return true;
  	      }
  	
  	
  	      // Engine running while moving.
  	      if (rpm > 100 && speed > 2) {
  	        return true;
  	      }
  	
  	
  	      return false;
  	
  	    } catch (itemError) {
  	
  	      console.warn(
  	        "[TrackIT Repeater] Skipped bad tractor record:",
  	        itemError,
  	        item
  	      );
  	
  	      return false;
  	    }
  	
  	  });
  	
  	
  	  // ------------------------------------------------------------
  	  // Sort by FID.
  	  // Same basic behaviour as your current ascending Sort block.
  	  // ------------------------------------------------------------
  	  result.sort((a, b) => {
  	
  	    try {
  	
  	      const av = getValue(a, "FID");
  	      const bv = getValue(b, "FID");
  	
  	      if (av === bv) return 0;
  	      if (av === null || av === undefined) return 1;
  	      if (bv === null || bv === undefined) return -1;
  	
  	      if (av > bv) return 1;
  	      if (av < bv) return -1;
  	
  	      return 0;
  	
  	    } catch (_) {
  	      return 0;
  	    }
  	
  	  });
  	
  	} catch (filterError) {
  	
  	  console.error(
  	    "[TrackIT Repeater] Filter/sort failed:",
  	    filterError
  	  );
  	
  	  result = [];
  	}
  	
  	
  	// ============================================================
  	// CRITICAL RACE-CONDITION PROTECTION
  	// ============================================================
  	
  	// If Backendless is between destroying and recreating the page,
  	// Repeater may legitimately be undefined.
  	//
  	// DO NOT THROW.
  	// DO NOT TOUCH .display.
  	// LiveTrack can continue normally.
  	if (
  	  repeater === null ||
  	  repeater === undefined ||
  	  (
  	    typeof repeater !== "object" &&
  	    typeof repeater !== "function"
  	  )
  	) {
  	
  	  console.warn(
  	    "[TrackIT Repeater] Component not ready - update safely skipped."
  	  );
  	
  	  return result;
  	}
  	
  	
  	// ------------------------------------------------------------
  	// Updating a Backendless component can itself race with page
  	// destruction, so retry transient setter failures a few times.
  	// ------------------------------------------------------------
  	let updated = false;
  	
  	for (let attempt = 1; attempt <= 4; attempt++) {
  	
  	  try {
  	
  	    repeater.dynamicListItems = result;
  	
  	    updated = true;
  	    break;
  	
  	  } catch (error) {
  	
  	    console.warn(
  	      `[TrackIT Repeater] Update attempt ${attempt}/4 failed.`,
  	      error
  	    );
  	
  	    if (attempt < 4) {
  	      await sleep(50);
  	    }
  	  }
  	}
  	
  	
  	if (!updated) {
  	
  	  console.warn(
  	    "[TrackIT Repeater] Component disappeared during update. " +
  	    "LiveTrack will continue without crashing."
  	  );
  	
  	  return result;
  	}
  	
  	
  	// ============================================================
  	// OPTIONAL REDRAW
  	// ============================================================
  	//
  	// Your old code did:
  	//
  	//     Repeater.display = false;
  	//     Repeater.display = true;
  	//
  	// Do it safely and yield one browser frame between the two.
  	//
  	// If Backendless destroys the component here, we simply abandon
  	// the redraw instead of taking down the whole page.
  	// ============================================================
  	
  	try {
  	
  	  if ("display" in repeater) {
  	
  	    repeater.display = false;
  	
  	    await new Promise(resolve => {
  	      if (typeof requestAnimationFrame === "function") {
  	        requestAnimationFrame(() => resolve());
  	      } else {
  	        setTimeout(resolve, 0);
  	      }
  	    });
  	
  	    try {
  	      repeater.display = true;
  	    } catch (showError) {
  	
  	      console.warn(
  	        "[TrackIT Repeater] Repeater disappeared during redraw.",
  	        showError
  	      );
  	    }
  	  }
  	
  	} catch (redrawError) {
  	
  	  console.warn(
  	    "[TrackIT Repeater] Redraw skipped safely:",
  	    redrawError
  	  );
  	}
  	
  	
  	return result;
  })(Repeater, (await asyncListSort((await asyncListFilter((await asyncListFilter(Tractors1, async (item) => {


   return (!((getObjectProperty(item, 'Location')) === null));
  })), async (item) => {
     if (!(await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(item, 'Tracker'))))) {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(item, 'Location')), 'GPSWarnings')), 'RPM')) == true || (getObjectProperty((getObjectProperty((getObjectProperty(item, 'Location')), 'GPSWarnings')), 'Speed')) == true || (getObjectProperty((getObjectProperty((getObjectProperty(item, 'Location')), 'GPSWarnings')), 'Temp')) == true) {
        Decision = true;
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty((getObjectProperty(item, 'Location')), 'can.engine.rpm'))))) {
          if ((getObjectProperty((getObjectProperty(item, 'Location')), 'position.speed')) > 2) {
            Decision = true;
          } else {
            Decision = false;
          }
        } else {
          if ((getObjectProperty((getObjectProperty(item, 'Location')), 'can.engine.rpm')) > 100 && (getObjectProperty((getObjectProperty(item, 'Location')), 'position.speed')) == 0) {
            Decision = true;
          } else {
            if ((getObjectProperty((getObjectProperty(item, 'Location')), 'can.engine.rpm')) > 100 && (getObjectProperty((getObjectProperty(item, 'Location')), 'position.speed')) > 2) {
              Decision = true;
            } else {
              Decision = false;
            }
          }
        }
      }
    } else {
      Decision = false;
    }


   return Decision;
  })), 1, async (Sorter) => {


   return (getObjectProperty(Sorter, 'FID'));
  })));
}

/**
 * Describe this function...
 */
async function Multi_Track() {
  Clocking = await Clocking2();
  await LiveTrack();
  await new Promise(r => setTimeout(r, Wait || 0));
  while (Live) {
    await new Promise(r => setTimeout(r, Wait || 0));
    await BackendlessUI.Functions.Custom['fn_2cdb14e20aec99596e5725c4e3064843'](AppData, (await Promise.all((getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies')).map(async item => {; return (await Promise.all((getObjectProperty(item, 'Tractors')).map(async Tractor => {; return (getObjectProperty(Tractor, 'Tracker'));})));}))), null, null);
    await LiveTrack();
  }
}

/**
 * Describe this function...
 */
async function Clocking2() {
  if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097'](From)) || (await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097'](To))) {
    Clocking_Function = null;
  } else {
    Clocking_Function = (await Backendless.Data.of('Clocking').find(Backendless.DataQueryBuilder.create().setWhereClause((await (async function(TimeIn, TimeOut, IDTractor) {
    	// Build a WHERE clause to find clockings that overlap [TimeIn, TimeOut]
    	// for the given truck (IDTractor). Assumes IDTractor is a STRING column.
    	// If it's a RELATION, change idField to 'IDTractor.objectId' below.
    	
    	function toMs(v){
    	  if (v == null) throw new Error('Missing date/timestamp');
    	  if (v instanceof Date) return v.getTime();
    	  if (typeof v === 'number' && !Number.isNaN(v)) return Math.round(v < 1e12 ? v*1000 : v);
    	  if (typeof v === 'string'){
    	    const s = v.trim();
    	    if (s === '') throw new Error('Empty date string');
    	    if (/^-?\d+$/.test(s)) { const n = Number(s); return Math.round(n < 1e12 ? n*1000 : n); }
    	    const t = Date.parse(s); if (!Number.isNaN(t)) return t;
    	  }
    	  throw new Error('Invalid date/timestamp: ' + v);
    	}
    	
    	// pull inputs (works in Codeless runtime)
    	const startMs = toMs((typeof inputs !== 'undefined' ? inputs.TimeIn  : TimeIn));
    	const endMs   = toMs((typeof inputs !== 'undefined' ? inputs.TimeOut : TimeOut));
    	let   truckId =        (typeof inputs !== 'undefined' ? inputs.IDTractor : IDTractor);
    	
    	if (!truckId) throw new Error('IDTractor is required');
    	
    	// swap if user supplied reversed window
    	let a = startMs, b = endMs;
    	if (a > b) { const t = a; a = b; b = t; }
    	
    	// escape single quotes in id
    	truckId = String(truckId).replace(/'/g, "''");
    	
    	// ---- choose the field name ----
    	// STRING column:
    	const idField = 'IDTractor';
    	// If it's a RELATION, use this instead:
    	// const idField = 'IDTractor.objectId';
    	
    	// final WHERE (inclusive edges)
    	const where =
    	  `(${idField} = '${truckId}') AND (TimeIn <= ${b}) AND (TimeOut IS NULL OR TimeOut >= ${a})`;
    	
    	// optional debug
    	// console.log('WHERE:', where);
    	
    	return where;

    })(((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty((From[0]), 'timestamp')))) ? null : (getObjectProperty((From[0]), 'timestamp'))), ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty((To.slice(-1)[0]), 'timestamp')))) ? null : (getObjectProperty((To.slice(-1)[0]), 'timestamp'))), (getObjectProperty(Tractor, 'objectId'))))).setPageSize(100)));
  }
  return Clocking_Function
}

/**
 * Describe this function...
 */
async function Stations2() {
  try {
    Stations = [];
    var j_list2 = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      var k_list2 = (getObjectProperty(j, 'Stations'));
      for (var k_index2 in k_list2) {
        k = k_list2[k_index2];
        addItemToList(Stations, k);
      }
    }

  } catch (error) {
    console.log(error);

  }
  return Stations
}

/**
 * Describe this function...
 */
async function Single_Track() {
  try {
    Map['display'] = false;

  } catch (error) {

  }
  await (async function(Image) {
  	function spinnerOverlay(args) {
  	  const { App, waitKey = "SpinnerDone", msgKey = "SpinnerMsg", Image } = args || {};
  	  if (!App || document.getElementById("fleetSpinner")) return;
  	
  	  const overlay = document.createElement("div");
  	  overlay.id = "fleetSpinner";
  	  Object.assign(overlay.style, {
  	    position: "fixed",
  	    inset: "0",
  	    zIndex: "2147483647",
  	    background: "rgba(5,5,5,1)",
  	    display: "flex",
  	    flexDirection: "column",
  	    alignItems: "center",
  	    justifyContent: "center",
  	    color: "#fff",
  	    fontFamily: "Inter, sans-serif",
  	    transition: "opacity 0.45s ease",
  	  });
  	
  	  // --- Logo ---
  	  const logo = document.createElement("img");
  	  if (Image) logo.src = Image;
  	  logo.style.cssText = `
  	    width:200px;
  	    height:auto;
  	    margin-bottom:30px;
  	    opacity:0;
  	    transform:scale(0.8);
  	    filter:drop-shadow(0 0 12px rgba(204,102,51,0.8));
  	    animation: logoFade 2.5s ease forwards;
  	  `;
  	
  	  // --- Spinner ---
  	  const spinner = document.createElement("div");
  	  spinner.style.cssText = `
  	    width:70px;height:70px;
  	    border:6px solid rgba(255,255,255,0.15);
  	    border-top:6px solid #CC6633;
  	    border-radius:50%;
  	    animation:spin 1s linear infinite;
  	    box-shadow:0 0 20px rgba(204,102,51,0.4);
  	  `;
  	
  	  // --- Message text (dramatic pulse) ---
  	  const msg = document.createElement("div");
  	  msg.textContent = App?.[msgKey] || "Loading…";
  	  msg.style.cssText = `
  	    margin-top:28px;
  	    font-size:1.3em;
  	    font-weight:700;
  	    text-align:center;
  	    letter-spacing:0.5px;
  	    opacity:0;
  	    animation: fadeIn 1.5s ease forwards, textPulse 4s ease-in-out infinite 1.5s;
  	  `;
  	
  	  // --- Styles ---
  	  const style = document.createElement("style");
  	  style.textContent = `
  	    @keyframes spin {
  	      0%{transform:rotate(0)}100%{transform:rotate(360deg)}
  	    }
  	    @keyframes fadeIn {
  	      from{opacity:0;transform:translateY(8px)}
  	      to{opacity:1;transform:translateY(0)}
  	    }
  	    @keyframes logoFade {
  	      0% {opacity:0;transform:scale(0.8);}
  	      60% {opacity:0.9;transform:scale(1.1);}
  	      100% {opacity:1;transform:scale(1);}
  	    }
  	    @keyframes textPulse {
  	      0%,100% {
  	        opacity:0.4;
  	        transform:scale(1);
  	        text-shadow:0 0 0 rgba(204,102,51,0);
  	      }
  	      50% {
  	        opacity:1;
  	        transform:scale(1.3);
  	        text-shadow:0 0 25px rgba(204,102,51,0.9);
  	        color:#fff8f0;
  	      }
  	    }
  	  `;
  	
  	  overlay.append(logo, spinner, msg);
  	  document.body.append(style, overlay);
  	
  	  let last = msg.textContent;
  	  const poller = setInterval(() => {
  	    if (App[msgKey] && App[msgKey] !== last) {
  	      msg.textContent = App[msgKey];
  	      last = App[msgKey];
  	    }
  	    if (App[waitKey]) {
  	      clearInterval(poller);
  	      overlay.style.opacity = "0";
  	      setTimeout(() => overlay.remove(), 400);
  	      delete App[waitKey];
  	      delete App[msgKey];
  	    }
  	  }, 250);
  	}
  	
  	spinnerOverlay({ App: AppData, Image });

  })('data:image/png;base64,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');
  AppData['SpinnerMsg'] = 'Acquiring Tracking Data';
  Tractor = Tractors[0];
  Map['display'] = true;
  try {
    await BackendlessUI.Functions.Custom['fn_2cdb14e20aec99596e5725c4e3064843'](AppData, (getObjectProperty((getObjectProperty(AppData, 'SelectedTractor')), 'Tracker')), To, From);

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      AppData['SpinnerMsg'] = 'Error In Fetching Data';
      await new Promise(r => setTimeout(r, 4000 || 0));
      AppData['SpinnerDone'] = true;
    }

  }
  AppData['SpinnerMsg'] = 'Analysing Events... ';
  await (async function(Tractor, CAN, Locations, AppData) {
  	// === CAN Event Engine (v2) — Rog Mode (no logs) ===
  	// Inputs (Codeless args): Tractor, CAN, Locations, AppData
  	// Output: { ok, events, stats, debug, errors }

  	return (async function run(Tractor, CAN, Locations, AppData) {
  	  // ---------- tiny utils ----------
  	  const isObj = v => v && typeof v === 'object';
  	  const own = (o, k) => Object.prototype.hasOwnProperty.call(o, k);
  	  const toNum = v => {
  	    const n = Number(v); return Number.isFinite(n) ? n: null;
  	  };
  	  const toBool = v => {
  	    if (typeof v === 'boolean') return v;
  	    if (v === 1 || v === 0) return !!v;
  	    if (typeof v === 'string') {
  	      const s = v.trim().toLowerCase(); if (s === 'true')return true; if (s === 'false')return false;
  	    }
  	    return !!v;
  	  };
  	  const byPath = (obj, dot) => {
  	    if (!obj || dot == null) return undefined;
  	    const key = String(dot);
  	    if (own(obj, key)) return obj[key]; // allow literal dotted keys
  	    let cur = obj;
  	    for (const seg of key.split('.')) {
  	      if (cur == null) return undefined; cur = cur[seg];
  	    }
  	    return cur;
  	  };
  	  // JSON Pointer reader (supports ~0/~1 unescape)
  	  function getByPointer(root, pointer) {
  	    if (!root || pointer == null) return undefined;
  	    const unescape = s => s.replace(/~1/g, '/').replace(/~0/g, '~');
  	    const parts = String(pointer).split('/').filter(Boolean).map(unescape);
  	    let cur = root;
  	    for (const key of parts) {
  	      if (cur == null) return undefined; cur = cur[key];
  	    }
  	    return cur;
  	  }
  	  // Universal ref resolver: accepts {"$ref":"#/A/B"}, "#/A/B", "A.B", "A/B", primitives
  	  const resolveRef = (root, ref) => {
  	    if (ref == null) return undefined;
  	    if (typeof ref === 'object' && ref.$ref != null) {
  	      const p = String(ref.$ref);
  	      if (p.startsWith('#/')) return getByPointer(root, p.slice(2));
  	      if (p.startsWith('#.')) return byPath(root, p.slice(2));
  	      return p.includes('/') ? getByPointer(root, p): byPath(root, p);
  	    }
  	    if (typeof ref === 'string') {
  	      if (ref.startsWith('#/')) return getByPointer(root, ref.slice(2));
  	      if (ref.startsWith('#.')) return byPath(root, ref.slice(2));
  	      return ref.includes('/') ? getByPointer(root, ref): byPath(root, ref);
  	    }
  	    return ref; // primitive
  	  };
  	  const normTsMs = (t) => {
  	    const n = toNum(t); if (n == null) return null; return n < 1e11 ? n*1000: n;
  	  };

  	  // Seconds-first duration readers with backward compatibility for old *_ms keys
  	  const readSeconds = (primarySec, legacyMs, fallbackSec = 0) => {
  	    const sec = toNum(primarySec);
  	    if (sec != null) return sec;

  	    const ms = toNum(legacyMs);
  	    if (ms != null) return ms / 1000;

  	    return fallbackSec;
  	  };

  	  const readWindowSeconds = (spec, fallbackSec = 0) => {
  	    if (!isObj(spec)) return fallbackSec;

  	    const sec =
  	    toNum(spec.s) ??
  	    toNum(spec.sec) ??
  	    toNum(spec.seconds);

  	    if (sec != null) return sec;

  	    const ms = toNum(spec.ms);
  	    if (ms != null) return ms / 1000;

  	    return fallbackSec;
  	  };

  	  const haversineM = (lat1, lon1, lat2, lon2) => {
  	    if (![lat1, lon1, lat2, lon2].every(Number.isFinite)) return 0;
  	    const R = 6371000,
  	    toRad = d => d*Math.PI/180;
  	    const dLat = toRad(lat2-lat1),
  	    dLon = toRad(lon2-lon1);
  	    const a = Math.sin(dLat/2)**2 + Math.cos(toRad(lat1))*Math.cos(toRad(lat2))*Math.sin(dLon/2)**2;
  	    return 2*R*Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  	  };

  	  // ---------- guard ----------
  	  if (!isObj(CAN) || !Array.isArray(CAN.Events)) {
  	    return {
  	      ok: false,
  	      error: 'CAN.Events[] missing or invalid',
  	      events: {},
  	      stats: {
  	        eventsDefined: 0,
  	        logsCount: 0
  	      },
  	      debug: {},
  	      errors: ['Schema']
  	    };
  	  }

  	  // ---------- discover logs ----------
  	  const discoverLogs = (tractor) => {
  	    if (!isObj(tractor)) return [];
  	    const candidates = ['Logs',
  	      'Tracking',
  	      'History',
  	      'LocationHistory',
  	      'track',
  	      'telemetry',
  	      'data',
  	      'items'];
  	    for (const p of candidates) {
  	      const v = byPath(tractor, p);
  	      if (Array.isArray(v) && v.length) return v.slice();
  	    }
  	    return [];
  	  };
  	  let logs = discoverLogs(Tractor);

  	  // ---------- stream keys ----------
  	  const latKey = resolveRef(CAN, '#/Stream/lat') || 'position.latitude';
  	  const lonKey = resolveRef(CAN, '#/Stream/lon') || 'position.longitude';
  	  const tsKey = resolveRef(CAN, '#/Stream/timestamp') || 'timestamp';
  	  const odoKey = resolveRef(CAN, '#/Stream/odometer_km') || null;
  	  const speedKey = resolveRef(CAN, '#/Stream/speed') || 'position.speed';
  	  const fbSpeedKey = resolveRef(CAN, '#/Stream/fallback_speed') || null;

  	  const tractorIdleLimitSec =
  	  toNum(byPath(Tractor, 'CAN.Idle')) ??
  	  toNum(byPath(Tractor, 'CAN.idle')) ??
  	  toNum(byPath(Tractor, 'CAN.Engine.Idle')) ??
  	  toNum(byPath(Tractor, 'CAN.Engine.idle')) ??
  	  toNum(resolveRef(CAN, '#/Idle')) ??
  	  toNum(resolveRef(CAN, '#/idle')) ??
  	  0;

  	  // ---------- prep logs ----------
  	  logs = logs
  	  .map(r => {
  	    const ts = normTsMs(byPath(r, tsKey));
  	    const lat = toNum(byPath(r, latKey));
  	    const lon = toNum(byPath(r, lonKey));
  	    let spd = toNum(byPath(r, speedKey));
  	    if (spd == null && fbSpeedKey) spd = toNum(byPath(r, fbSpeedKey));
  	    const odoKm = odoKey ? toNum(byPath(r, odoKey)): null;
  	    return {
  	      ...r,
  	      __ts: ts,
  	      __lat: lat,
  	      __lon: lon,
  	      __spd: spd,
  	      __odoKm: odoKm,
  	      __derived: {}
  	    };
  	  })
  	  .filter(r => r.__ts != null)
  	  .sort((a, b) => a.__ts - b.__ts);

  	  // ---------- derived drift (10s) ----------
  	  const DRIFT_WINDOW_S = 10;
  	  const DRIFT_WINDOW_MS = DRIFT_WINDOW_S * 1000;
  	  {
  	    let q = [];
  	    for (const r of logs) {
  	      q.push(r);
  	      while (q.length && (r.__ts - q[0].__ts) > DRIFT_WINDOW_MS) q.shift();
  	      let gpsM = 0,
  	      speedM = 0;
  	      for (let i = 1; i < q.length; i++) {
  	        const a = q[i-1],
  	        b = q[i];
  	        const dt = (b.__ts - a.__ts)/1000;
  	        gpsM += haversineM(a.__lat??NaN, a.__lon??NaN, b.__lat??NaN, b.__lon??NaN);
  	        const s = toNum(a.__spd) ?? 0; // km/h
  	        speedM += (s/3.6) * dt;
  	      }
  	      const drift_mps = Math.max(0, (speedM - gpsM) / Math.max(1, (q[q.length-1].__ts - q[0].__ts)/1000));
  	      r.__derived['drift.kph_10s'] = drift_mps * 3.6;
  	    }
  	  }

  	  // ---------- signal functions ----------
  	  const valueFns = {
  	    value: (row, spec) => spec.field != null ? byPath(row, spec.field): undefined,
  	    abs: (row, spec) => {
  	      const v = valueFns.value(row, spec); const n = toNum(v); return n == null?null: Math.abs(n);
  	    },
  	    any: (row, spec) => (spec.fields || []).some(f => toBool(byPath(row, f))),
  	    both: (row, spec) => {
  	      const A = spec.a?.field ? byPath(row, spec.a.field): undefined;
  	      const B = spec.b?.field ? byPath(row, spec.b.field): undefined;
  	      const op = spec.op || 'and'; const trig = spec.trigger;
  	      switch (op) {
  	        case 'and': return toBool(A) && toBool(B);
  	        case 'and_not_b': return toBool(A) && !toBool(B);
  	        case 'both_false': return !toBool(A) && !toBool(B);
  	        case 'not_a_and_b_gt': {
  	            const n = toNum(B); const t = toNum(resolveRef(CAN, trig) ?? trig);
  	            return !toBool(A) && n != null && t != null && n > t;
  	          }
  	        default: return toBool(A) && toBool(B);
  	      }
  	    },
  	    rate: (row, spec, ctx) => {
  	      const lookSec = readWindowSeconds(spec.lookback, 60);
  	      const lookMs = lookSec * 1000;
  	      const i = ctx.idx,
  	      baseTs = row.__ts; let j = i;
  	      while (j > 0 && (baseTs - ctx.logs[j-1].__ts) <= lookMs) j--;
  	      const first = ctx.logs[j],
  	      last = row;
  	      const vFirst = toNum(byPath(first, spec.field)); const vLast = toNum(byPath(last, spec.field));
  	      if (vFirst == null || vLast == null) return null;
  	      const dtSec = Math.max(1, (last.__ts - first.__ts)/1000);
  	      return (vLast - vFirst) * (60 / dtSec); // per minute
  	    },
  	    delta: (row, spec, ctx) => {
  	      const lookSamples = spec.lookback?.samples ?? null;
  	      const lookSec = readWindowSeconds(spec.lookback, null);
  	      const lookMs = lookSec != null ? lookSec * 1000: null;
  	      const i = ctx.idx; let j = i; let count = 0; const tNow = row.__ts;
  	      while (j > 0 && ((lookSamples != null ? count < lookSamples: true) && (lookMs != null ? (tNow - ctx.logs[j-1].__ts) <= lookMs: true))) {
  	        j--; count++;
  	      }
  	      const first = ctx.logs[j],
  	      last = row;
  	      const a = toNum(byPath(first, spec.field)),
  	      b = toNum(byPath(last, spec.field));
  	      if (a == null || b == null) return null;
  	      let d = b - a;
  	      const dir = (spec.direction || 'either').toLowerCase();
  	      if (dir === 'drop') d = Math.min(0, d) * -1;
  	      if (dir === 'rise') d = Math.max(0, d);
  	      if (isObj(spec.transform) && spec.transform.to === 'liters') {
  	        const cap = toNum(resolveRef(CAN, spec.transform.capacityRef));
  	        if (cap != null && a <= 100 && b <= 100) d = (Math.abs(b - a) / 100) * cap;
  	      }
  	      return Math.abs(d);
  	    },
  	    jitter: (row, spec, ctx) => {
  	      const lookSec = readWindowSeconds(spec.lookback, 120);
  	      const lookMs = lookSec * 1000;
  	      const i = ctx.idx; let j = i; const tNow = row.__ts; let lo=+Infinity,
  	      hi=-Infinity;
  	      while (j >= 0 && (tNow - ctx.logs[j].__ts) <= lookMs) {
  	        const v = toNum(byPath(ctx.logs[j], spec.field));
  	        if (v != null) {
  	          if (v < lo) lo = v; if (v > hi) hi = v;
  	        }
  	        j--;
  	      }
  	      return (hi>-Infinity && lo<+Infinity) ? (hi - lo): null;
  	    },
  	    edge: (row, spec, ctx) => {
  	      if (ctx.idx === 0) return false; const prev = ctx.logs[ctx.idx-1]; return byPath(prev, spec.field) !== byPath(row, spec.field);
  	    },
  	    edge_any: (row, spec, ctx) => {
  	      if (ctx.idx === 0) return false; const prev = ctx.logs[ctx.idx-1]; return (spec.fields || []).some(f => byPath(prev, f) !== byPath(row, f));
  	    },
  	    edge_count: (row, spec, ctx) => {
  	      const lookSec = readWindowSeconds(spec.lookback, 10);
  	      const lookMs = lookSec * 1000; const tNow = row.__ts; let count = 0;
  	      for (let j = ctx.idx; j > 0 && (tNow - ctx.logs[j-1].__ts) <= lookMs; j--) {
  	        const a = byPath(ctx.logs[j], spec.field),
  	        b = byPath(ctx.logs[j-1], spec.field);
  	        if (a !== b) count++;
  	      }
  	      return count;
  	    },
  	    drift: (row, spec) => row.__derived['drift.kph_10s'] ?? 0
  	  };

  	  // ---------- comparators / tests ----------
  	  const opTest = {
  	    '>': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) > toNum(t),
  	    '>=': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) >= toNum(t),
  	    '<': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) < toNum(t),
  	    '<=': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) <= toNum(t),
  	    '==': (v, t) => v === t,
  	    '!=': (v, t) => v !== t,
  	    'truthy': v => toBool(v),
  	    'falsy': v => !toBool(v),
  	    'between': (v, t) => {
  	      const lo = toNum(t?.lo),
  	      hi = toNum(t?.hi),
  	      n = toNum(v); return n != null && lo != null && hi != null && n >= lo && n <= hi;
  	    },
  	    'cycles': (v, t) => {
  	      const n = toNum(v),
  	      thr = toNum(t); return n != null && thr != null && n >= thr;
  	    },
  	    'time_between': (row, t, localField = 'localtime') => {
  	      const lo = String(t?.lo || '00:00'),
  	      hi = String(t?.hi || '23:59');
  	      const ts = normTsMs(byPath(row, localField) ?? row.__ts); if (ts == null) return false;
  	      const d = new Date(ts),
  	      hh = String(d.getHours()).padStart(2, '0'),
  	      mm = String(d.getMinutes()).padStart(2, '0'),
  	      cur = `${hh}:${mm}`;
  	      return (lo <= hi) ? (cur >= lo && cur <= hi): (cur >= lo || cur <= hi); // midnight wrap
  	    },
  	    'truthy_any': (row, t) => (t?.fields || []).some(f => toBool(byPath(row, f))),
  	    'falsy_any': (row, t) => (t?.fields || []).some(f => !toBool(byPath(row, f))),
  	  };

  	  // ---------- gates ----------
  	  function mergeGateDefaults(gates, defaults) {
  	    if (isObj(gates) && gates.disable_defaults === true) {
  	      if (!Array.isArray(gates.requireAll) && !Array.isArray(gates.requireAny)) return null;

  	      return {
  	        requireAll: Array.isArray(gates.requireAll) ? [...gates.requireAll] : [],
  	        requireAny: Array.isArray(gates.requireAny) ? [...gates.requireAny] : []
  	      };
  	    }

  	    if (!defaults && !gates) return null;

  	    const out = {
  	      requireAll: [],
  	      requireAny: []
  	    };

  	    if (isObj(defaults)) {
  	      if (Array.isArray(defaults.requireAll)) out.requireAll.push(...defaults.requireAll);
  	      if (Array.isArray(defaults.requireAny)) out.requireAny.push(...defaults.requireAny);
  	    }

  	    if (isObj(gates)) {
  	      if (Array.isArray(gates.requireAll)) out.requireAll.push(...gates.requireAll);
  	      if (Array.isArray(gates.requireAny)) out.requireAny.push(...gates.requireAny);
  	    }

  	    return out;
  	  }
  	  function gatesPass(row, gates) {
  	    const EngCfg = CAN.Engine || {};
  	    const merged = mergeGateDefaults(gates, EngCfg.gates_defaults);
  	    if (!merged) return true;
  	    const check = (g) => {
  	      const op = (g?.op || 'truthy').toLowerCase();
  	      if (op === 'time_between') {
  	        return opTest['time_between'](row, {
  	          lo: resolveRef(CAN, g.lo), hi: resolveRef(CAN, g.hi)
  	        }, g.field || 'localtime');
  	      }
  	      if (op === 'truthy_any' || op === 'falsy_any') {
  	        return opTest[op](row, {
  	          fields: g.fields || []
  	        });
  	      }
  	      const v = g.field != null ? byPath(row, g.field): undefined;
  	      const trig = resolveRef(CAN, g.trigger) ?? g.trigger;
  	      const fn = opTest[op] || (()=>false);
  	      return fn(v, trig);
  	    };
  	    if (Array.isArray(merged.requireAll) && merged.requireAll.length) {
  	      for (const g of merged.requireAll) {
  	        if (!check(g)) return false;
  	      }
  	    }
  	    if (Array.isArray(merged.requireAny) && merged.requireAny.length) {
  	      let any = false; for (const g of merged.requireAny) {
  	        if (check(g)) {
  	          any = true; break;
  	        }
  	      }
  	      if (!any) return false;
  	    }
  	    return true;
  	  }

  	  // ---------- segmentation helpers ----------
  	  const includeFullPoint = !!resolveRef(CAN, '#/Engine/points/include_full_point');

  	  const pushPoint = (ctx, row, val) => {
  	    if (ctx.firstTs == null) ctx.firstTs = row.__ts;
  	    if (ctx.prevLat == null) ctx.prevLat = row.__lat ?? null;
  	    if (ctx.prevLon == null) ctx.prevLon = row.__lon ?? null;

  	    const rawPointTs = byPath(row, 'timestamp');
  	    const rawPointTsNum = toNum(rawPointTs);
  	    const pointTsSec = rawPointTsNum != null
  	    ? Math.floor(rawPointTsNum): Math.floor(Number(row.__ts) / 1000);

  	    const pt = {
  	      timestamp: pointTsSec,
  	      value: val,
  	      lat: Number.isFinite(row.__lat) ? row.__lat: undefined,
  	      lon: Number.isFinite(row.__lon) ? row.__lon: undefined
  	    };
  	    if (includeFullPoint) pt.point = row;

  	    ctx.curPts.push(pt);
  	    ctx.lastTs = row.__ts;
  	  };

  	  const stepDistance = (ctx, row, prevRow) => {
  	    if (row.__odoKm != null && prevRow?.__odoKm != null) {
  	      ctx.distM += Math.max(0, (row.__odoKm - prevRow.__odoKm)) * 1000;
  	    } else if (
  	      Number.isFinite(ctx.prevLat) && Number.isFinite(ctx.prevLon) &&
  	      Number.isFinite(row.__lat) && Number.isFinite(row.__lon)
  	    ) {
  	      ctx.distM += haversineM(ctx.prevLat, ctx.prevLon, row.__lat, row.__lon);
  	    }
  	    ctx.prevLat = row.__lat ?? ctx.prevLat;
  	    ctx.prevLon = row.__lon ?? ctx.prevLon;
  	    ctx.lastTs = row.__ts;
  	  };

  	  const resetSeg = (ctx) => {
  	    ctx.curPts = [];
  	    ctx.aggSum = 0;
  	    ctx.aggMax = -Infinity;
  	    ctx.aggCount = 0;
  	    ctx.firstTs = null;
  	    ctx.lastTs = null;
  	    ctx.distM = 0;
  	    ctx.prevLat = null;
  	    ctx.prevLon = null;
  	    ctx.startVal = null;
  	    ctx.lastVal = null;
  	    ctx.maxIdleTotal = null;
  	    ctx.maxIdlePoint = null;
  	  };
  	  const flushSeg = (ctx, debugMap) => {
  	    if (!ctx.curPts.length) return;

  	    const durMs = Math.max(0, (ctx.lastTs ?? ctx.firstTs) - (ctx.firstTs ?? ctx.lastTs));
  	    // Idle duration comes from Flespi's cumulative counter, not from the span
  	    // between received packets. A single packet can therefore be a valid idle.
  	    if (ctx.ruleName !== "Idle Event" && durMs < (ctx.minDurMs || 0)) {
  	      if (debugMap) debugMap.discardedShort++;
  	      return resetSeg(ctx);
  	    }

  	    if (ctx.ruleName === "Idle Event") {
  	      const finalIdleSec = toNum(ctx.maxIdleTotal);

  	      if (finalIdleSec == null || finalIdleSec < (ctx.idleLimitSec || 0)) {
  	        if (debugMap) debugMap.discardedShort++;
  	        return resetSeg(ctx);
  	      }

  	      const startTs = (ctx.curPts && ctx.curPts.length && ctx.curPts[0])
  	      ? ctx.curPts[0].timestamp: null;
  	      const maxPoint = ctx.maxIdlePoint ||
  	        ((ctx.curPts && ctx.curPts.length) ? ctx.curPts[ctx.curPts.length - 1] : null);

  	      ctx.segments.push({
  	        start: startTs,
  	        start_iso: startTs ? new Date(startTs * 1000).toISOString(): null,

  	        idle_seconds: Math.round(finalIdleSec),
  	        idle_human: (() => {
  	          var s = Math.round(finalIdleSec);
  	          var h = Math.floor(s / 3600);
  	          var m = Math.floor((s % 3600) / 60);
  	          var sec = s % 60;

  	          var out = [];
  	          if (h > 0) out.push(h + "h");
  	          if (m > 0 || h > 0) out.push(m + "m");
  	          out.push(sec + "s");

  	          return out.join(" ");
  	        })(),

  	        // One marker per Flespi idle event: only the point carrying the
  	        // highest idle.total value is returned.
  	        Points: maxPoint ? [maxPoint] : []
  	      });

  	      return resetSeg(ctx);
  	    }

  	    // --- Custom flush for Fuel Gain/Loss
  	    if (ctx.ruleName === "Fuel Gain (Refuel)" || ctx.ruleName === "Fuel Loss") {
  	      if (ctx.curPts.length) {
  	        const lastPt = ctx.curPts[ctx.curPts.length - 1];
  	        if (ctx.lastVal == null && lastPt?.value != null) ctx.lastVal = lastPt.value;
  	      }

  	      ctx.segments.push({
  	        distance: Math.round(ctx.distM * 1000) / 1000,
  	        duration: Math.round((durMs / 1000) * 1000) / 1000,
  	        ChangeL: Math.round(((ctx.lastVal ?? 0) - (ctx.startVal ?? 0)) * 1000) / 1000,
  	        Points: ctx.curPts
  	      });
  	    } else {
  	      ctx.segments.push({
  	        distance: Math.round(ctx.distM * 1000) / 1000,
  	        duration: Math.round((durMs / 1000) * 1000) / 1000,
  	        AVG: ctx.aggCount ? (ctx.aggSum / ctx.aggCount): null,
  	        Max: ctx.aggMax > -Infinity ? ctx.aggMax: null,
  	        Points: ctx.curPts
  	      });
  	    }

  	    resetSeg(ctx);
  	  };

  	  const EngCfg = CAN.Engine || {};
  	  const stabDefaults = EngCfg.stability_defaults || {};

  	  // ---------- dedicated Flespi idle event reader ----------
  	  // Flespi has already decided whether the vehicle is idling. Its idle.total
  	  // value is a cumulative counter for the CURRENT idle interval. This reader
  	  // therefore does not recalculate idle from speed, RPM, ignition or packet
  	  // type. BLE and CAN packets are both valid carrier packets for Flespi state.
  	  function buildFlespiIdleEvents(sourceLogs, rule, idleLimitSec) {
  	    const cfg = isObj(rule?.flespi_idle) ? rule.flespi_idle : {};
  	    const stateFields = Array.isArray(cfg.state_fields) && cfg.state_fields.length
  	      ? cfg.state_fields
  	      : ['idle.status', 'idle'];
  	    const counterFields = Array.isArray(cfg.counter_fields) && cfg.counter_fields.length
  	      ? cfg.counter_fields
  	      : ['idle.total', 'totalidle'];
  	    const resetDropSec = Math.max(0, toNum(cfg.reset_drop_s) ?? 1);

  	    const readFirstDefined = (row, fields) => {
  	      for (const field of fields) {
  	        const value = byPath(row, field);
  	        if (value !== undefined && value !== null) return value;
  	      }
  	      return undefined;
  	    };

  	    const readCounter = (row) => {
  	      for (const field of counterFields) {
  	        const n = toNum(byPath(row, field));
  	        if (n != null) return n;
  	      }
  	      return null;
  	    };

  	    const makeIdlePoint = (row, value) => {
  	      const rawTs = toNum(byPath(row, tsKey));
  	      const tsSec = rawTs != null
  	        ? rawTs
  	        : Number(row.__ts) / 1000;

  	      const pt = {
  	        timestamp: tsSec,
  	        value,
  	        lat: Number.isFinite(row.__lat) ? row.__lat : undefined,
  	        lon: Number.isFinite(row.__lon) ? row.__lon : undefined
  	      };
  	      if (includeFullPoint) pt.point = row;
  	      return pt;
  	    };

  	    const humanDuration = (seconds) => {
  	      let s = Math.round(seconds);
  	      const h = Math.floor(s / 3600);
  	      const m = Math.floor((s % 3600) / 60);
  	      s %= 60;
  	      const out = [];
  	      if (h > 0) out.push(h + 'h');
  	      if (m > 0 || h > 0) out.push(m + 'm');
  	      out.push(s + 's');
  	      return out.join(' ');
  	    };

  	    const segments = [];
  	    const stats = {
  	      stateTrueRows: 0,
  	      counterRows: 0,
  	      counterResets: 0,
  	      discardedShort: 0
  	    };

  	    let active = null;

  	    const startActive = (row, counter) => {
  	      active = {
  	        firstRowTsSec: Number(row.__ts) / 1000,
  	        lastCounter: counter,
  	        maxCounter: null,
  	        maxPoint: null
  	      };
  	    };

  	    const updateActive = (row, counter) => {
  	      if (counter == null) return;
  	      stats.counterRows++;
  	      active.lastCounter = counter;
  	      if (active.maxCounter == null || counter >= active.maxCounter) {
  	        active.maxCounter = counter;
  	        active.maxPoint = makeIdlePoint(row, counter);
  	      }
  	    };

  	    const closeActive = () => {
  	      if (!active) return;

  	      const maxSec = toNum(active.maxCounter);
  	      const maxPoint = active.maxPoint;
  	      if (maxSec == null || !maxPoint || maxSec < Math.max(0, idleLimitSec || 0)) {
  	        stats.discardedShort++;
  	        active = null;
  	        return;
  	      }

  	      // The counter tells us the event's actual age. Deriving the start from
  	      // the highest counter is more accurate than relying on the first packet,
  	      // which may only arrive after 120 seconds.
  	      const endTs = toNum(maxPoint.timestamp);
  	      const derivedStartTs = endTs != null
  	        ? endTs - maxSec
  	        : active.firstRowTsSec;

  	      segments.push({
  	        start: derivedStartTs,
  	        start_iso: Number.isFinite(derivedStartTs)
  	          ? new Date(derivedStartTs * 1000).toISOString()
  	          : null,
  	        end: endTs,
  	        end_iso: Number.isFinite(endTs)
  	          ? new Date(endTs * 1000).toISOString()
  	          : null,
  	        idle_seconds: Math.round(maxSec),
  	        idle_human: humanDuration(maxSec),
  	        source: 'flespi.idle.total',
  	        // Exactly one map marker: the packet containing the greatest value
  	        // reached by idle.total during this Flespi interval.
  	        Points: [maxPoint]
  	      });

  	      active = null;
  	    };

  	    for (const row of sourceLogs) {
  	      const stateRaw = readFirstDefined(row, stateFields);
  	      const counter = readCounter(row);

  	      // A packet with no Flespi idle state is not an idle=false transition.
  	      // Ignore it so unrelated telemetry packets cannot split an interval.
  	      if (stateRaw === undefined || stateRaw === null) continue;

  	      const idleState = toBool(stateRaw);
  	      if (!idleState) {
  	        closeActive();
  	        continue;
  	      }

  	      stats.stateTrueRows++;

  	      if (!active) {
  	        startActive(row, counter);
  	      } else if (
  	        counter != null &&
  	        active.lastCounter != null &&
  	        counter < active.lastCounter - resetDropSec
  	      ) {
  	        // A falling cumulative counter means Flespi has started a new idle
  	        // interval even when the false transition packet was absent.
  	        stats.counterResets++;
  	        closeActive();
  	        startActive(row, counter);
  	      }

  	      updateActive(row, counter);
  	    }

  	    closeActive();
  	    return { segments, stats };
  	  }

  	  // ---------- main loop ----------
  	  const debug = {};
  	  const eventsOut = {};
  	  if (!isObj(Tractor.Events)) Tractor.Events = {};
  	  const logsCount = logs.length;

  	  for (const rule of CAN.Events) {
  	    if (!isObj(rule) || !rule.name) continue;

  	    // enabled (supports {$ref:"#/..."} or boolean)
  	    let enabled = true;
  	    if (own(rule, 'enabled')) enabled = toBool(resolveRef(CAN, rule.enabled));
  	    debug[rule.name] = {
  	      rows: logsCount,
  	      gatePass: 0,
  	      testPass: 0,
  	      segments: 0,
  	      discardedShort: 0,
  	      missingField: 0
  	    };
  	    if (!enabled) {
  	      Tractor.Events[rule.name] = []; eventsOut[rule.name] = []; continue;
  	    }

  	    // Idle is deliberately handled outside the generic event segmenter.
  	    // Flespi owns the state and duration; we only collapse each interval to
  	    // the single packet holding its highest idle.total value.
  	    if (rule.name === "Idle Event") {
  	      const built = buildFlespiIdleEvents(logs, rule, tractorIdleLimitSec);
  	      debug[rule.name].gatePass = built.stats.stateTrueRows;
  	      debug[rule.name].testPass = built.stats.counterRows;
  	      debug[rule.name].segments = built.segments.length;
  	      debug[rule.name].discardedShort = built.stats.discardedShort;
  	      debug[rule.name].counterResets = built.stats.counterResets;
  	      Tractor.Events[rule.name] = built.segments;
  	      eventsOut[rule.name] = built.segments;
  	      continue;
  	    }

  	    // segmentation
  	    const seg = rule.segmentation || {};
  	    const isIdleRule = rule.name === "Idle Event";
  	    // Flespi already determines idling. For Idle Event, group its cumulative
  	    // counter readings into one event instead of flushing every reading.
  	    const enterWhen = isIdleRule
  	      ? 'test_passes'
  	      : (seg.enter_when || 'test_passes').toLowerCase();
  	    const exitWhen = isIdleRule
  	      ? 'test_fails'
  	      : (seg.exit_when || 'test_fails').toLowerCase();

  	    const maxGapSec = readSeconds(
  	      resolveRef(CAN, seg.max_gap_s) ?? seg.max_gap_s,
  	      resolveRef(CAN, seg.max_gap_ms) ?? seg.max_gap_ms,
  	      30
  	    );

  	    const minDurSec = readSeconds(
  	      resolveRef(CAN, seg.min_duration_s) ?? seg.min_duration_s,
  	      resolveRef(CAN, seg.min_duration_ms) ?? seg.min_duration_ms,
  	      0
  	    );

  	    const maxGapMs = maxGapSec * 1000;
  	    // Tracker packets in the supplied data occasionally land 31 seconds apart,
  	    // so the generic 30-second default splits one Flespi idle counter sequence.
  	    const idleMaxGapSec = readSeconds(
  	      resolveRef(CAN, seg.idle_max_gap_s) ?? seg.idle_max_gap_s,
  	      resolveRef(CAN, seg.idle_max_gap_ms) ?? seg.idle_max_gap_ms,
  	      90
  	    );
  	    const effectiveMaxGapMs = isIdleRule
  	      ? Math.max(maxGapMs, idleMaxGapSec * 1000)
  	      : maxGapMs;
  	    const minDurMs = minDurSec * 1000;
  	    // aggregation
  	    const agg = rule.aggregation || null;
  	    const valueFromPath = agg?.value_from || 'calc.signal';
  	    const wantAvg = agg?.metrics?.includes('avg');
  	    const wantMax = agg?.metrics?.includes('max');

  	    const ctx = {
  	      ruleName: rule.name,
  	      segments: [],
  	      curPts: [],
  	      aggSum: 0,
  	      aggMax: -Infinity,
  	      aggCount: 0,
  	      firstTs: null,
  	      lastTs: null,
  	      prevTs: null,
  	      distM: 0,
  	      prevLat: null,
  	      prevLon: null,
  	      minDurMs,
  	      idleLimitSec: isIdleRule ? tractorIdleLimitSec: 0,
  	      maxIdleTotal: null,
  	      maxIdlePoint: null
  	    };

  	    const dwellSec = readSeconds(stabDefaults.dwell_s, stabDefaults.dwell_ms, 0); // reserved
  	    const dwellMs = dwellSec * 1000; // reserved
  	    const hyst = toNum(stabDefaults.hysteresis) ?? 0; // reserved

  	    for (let i = 0; i < logs.length; i++) {
  	      const row = logs[i];
  	      const ts = row.__ts;

  	      // Flespi's idle counter is authoritative. Extra speed/ignition gates can
  	      // flicker and split one real idle into several false events.
  	      const gatesOk = isIdleRule ? true : gatesPass(row, rule.gates);
  	      if (!gatesOk) {
  	        if (exitWhen === 'either' || exitWhen === 'test_fails' || exitWhen === 'no_rebound_failed_or_test_fails') flushSeg(ctx, debug[rule.name]);
  	        continue;
  	      }
  	      debug[rule.name].gatePass++;

  	      if (ctx.prevTs != null && effectiveMaxGapMs > 0 && (ts - ctx.prevTs) > effectiveMaxGapMs) {
  	        flushSeg(ctx, debug[rule.name]);
  	      }
  	      ctx.prevTs = ts;

  	      const calc = rule.calc || {};
  	      const sigSpec = calc.signal || {
  	        fn: 'value',
  	        field: rule.field
  	      };
  	      const sigFn = valueFns[sigSpec.fn || 'value'] || valueFns.value;
  	      const sigVal = sigFn(row, sigSpec, {
  	        idx: i, logs
  	      });

  	      const testSpec = calc.test || {
  	        op: 'truthy'
  	      };
  	      let testPass = false;
  	      const op = (testSpec.op || 'truthy').toLowerCase();
  	      if (op === 'time_between') {
  	        testPass = opTest['time_between'](row, {
  	          lo: resolveRef(CAN, testSpec.lo), hi: resolveRef(CAN, testSpec.hi)
  	        }, testSpec.field || 'localtime');
  	      } else if (op === 'between') {
  	        testPass = opTest['between'](sigVal, {
  	          lo: resolveRef(CAN, testSpec.lo), hi: resolveRef(CAN, testSpec.hi)
  	        });
  	      } else if (op === 'cycles') {
  	        const thr = resolveRef(CAN, testSpec.threshold) ?? testSpec.threshold;
  	        testPass = opTest['cycles'](sigVal, thr);
  	      } else {
  	        const thr = resolveRef(CAN, testSpec.threshold) ?? resolveRef(CAN, testSpec.thresholdRef) ?? testSpec.threshold;
  	        const cmp = opTest[op] || opTest['truthy'];
  	        testPass = cmp(sigVal, thr);
  	      }
  	      if (testPass) debug[rule.name].testPass++;

  	      // stability (no_rebound)
  	      let stabilityOk = true;
  	      if (isObj(calc.stability) && isObj(calc.stability.no_rebound) && testPass) {
  	        const winS = toNum(calc.stability.no_rebound.window_s) ?? 180;
  	        const tolP = toNum(calc.stability.no_rebound.tolerance_pct) ?? 20;
  	        const until = ts + winS*1000;
  	        for (let j = i+1; j < logs.length && logs[j].__ts <= until; j++) {
  	          const vj = sigFn(logs[j], sigSpec, {
  	            idx: j, logs
  	          });
  	          if (toNum(vj) != null && toNum(sigVal) != null) {
  	            const rebound = (vj >= sigVal*(1 - tolP/100));
  	            if (rebound) {
  	              stabilityOk = false; break;
  	            }
  	          }
  	        }
  	      }

  	      const nowPass = gatesOk && testPass && stabilityOk;

  	      // The Idle Event signal is the Flespi state (idle.status / idle).
  	      // The duration comes separately from idle.total. Keep those two jobs
  	      // separate so a boolean state is never mistaken for the duration.
  	      const aggVal = valueFromPath === 'calc.signal'
  	        ? sigVal
  	        : (byPath({
  	            calc: { signal: sigVal }
  	          }, valueFromPath) ?? byPath(row, valueFromPath));
  	      const idleCounterNow = isIdleRule ? toNum(aggVal) : null;

  	      // A positive falling counter while Flespi still says idle means a new
  	      // Flespi idle event has begun without an intervening false packet.
  	      if (isIdleRule && nowPass && ctx.curPts.length) {
  	        const idleMax = toNum(ctx.maxIdleTotal);
  	        if (idleCounterNow != null && idleCounterNow > 0 &&
  	            idleMax != null && idleCounterNow < idleMax) {
  	          flushSeg(ctx, debug[rule.name]);
  	        }
  	      }

  	      // For Idle Event points, store idle.total as the point value. For every
  	      // other rule, retain the calculated signal value.
  	      const pointValue = isIdleRule && idleCounterNow != null
  	        ? idleCounterNow
  	        : sigVal;

  	      // aggregation
  	      const doAgg = () => {
  	        const n = toNum(aggVal);

  	        if (isIdleRule && n != null && n >= 0) {
  	          if (ctx.maxIdleTotal == null || n >= ctx.maxIdleTotal) {
  	            ctx.maxIdleTotal = n;
  	            const currentPoint = ctx.curPts.length
  	              ? ctx.curPts[ctx.curPts.length - 1]
  	              : null;
  	            ctx.maxIdlePoint = currentPoint
  	              ? JSON.parse(JSON.stringify(currentPoint))
  	              : null;
  	          }
  	        }

  	        if (n != null) {
  	          // --- Handle Fuel Gain/Loss as pure change (sum only)
  	          if (rule.name === "Fuel Gain (Refuel)" || rule.name === "Fuel Loss") {
  	            if (ctx.startVal == null) ctx.startVal = n;
  	            ctx.lastVal = n;
  	          } else {
  	            if (wantAvg) {
  	              ctx.aggSum += n;
  	              ctx.aggCount++;
  	            }
  	            if (wantMax && n > ctx.aggMax) ctx.aggMax = n;
  	          }
  	        }
  	      };



  	      // segmentation
  	      if (!isIdleRule && (rule.segmentation?.enter_when || '').toLowerCase() === 'immediate' && nowPass) {
  	        pushPoint(ctx, row, pointValue); stepDistance(ctx, row, logs[i-1]); doAgg(); flushSeg(ctx, debug[rule.name]); continue;
  	      }
  	      if (!ctx.curPts.length) {
  	        if ((['test_passes', 'both'].includes(enterWhen)) && nowPass) {
  	          pushPoint(ctx, row, pointValue); stepDistance(ctx, row, logs[i-1]); doAgg(); continue;
  	        }
  	      } else {
  	        if ((exitWhen === 'test_fails' && !nowPass) ||
  	          (exitWhen === 'either' && (!gatesOk || !testPass)) ||
  	          (exitWhen === 'no_rebound_failed_or_test_fails' && (!testPass || !stabilityOk)) ||
  	          (exitWhen === 'stabilized' && !nowPass)) {
  	          flushSeg(ctx, debug[rule.name]); continue;
  	        }
  	        pushPoint(ctx, row, pointValue); stepDistance(ctx, row, logs[i-1]); doAgg();
  	      }
  	    } // logs loop

  	    flushSeg(ctx, debug[rule.name]);
  	    debug[rule.name].segments = ctx.segments.length;
  	    Tractor.Events[rule.name] = ctx.segments;
  	    eventsOut[rule.name] = ctx.segments;
  	  }

  	  // ===== FleetInForm In/Out Event Engine v11 (Bidirectional SmartFuel) =====
  	  try {
  	    const toPlain = v => JSON.parse(JSON.stringify(v));
  	    const toRad = x => (x * Math.PI) / 180;
  	    const haversineM = (a, b) => {
  	      const R = 6371000;
  	      const dLat = toRad(b.lat - a.lat);
  	      const dLon = toRad(b.lon - a.lon);
  	      const sLat = Math.sin(dLat / 2);
  	      const sLon = Math.sin(dLon / 2);
  	      const cLatA = Math.cos(toRad(a.lat));
  	      const cLatB = Math.cos(toRad(b.lat));
  	      const aVal = sLat * sLat + cLatA * cLatB * sLon * sLon;
  	      return 2 * R * Math.atan2(Math.sqrt(aVal), Math.sqrt(1 - aVal));
  	    };

  	    // ---------- Polygon helpers ----------
  	    function normalizePolygon(poly) {
  	      if (!poly || !poly.coordinates) return [];
  	      let rings = poly.coordinates;
  	      if (Array.isArray(rings[0]) && Array.isArray(rings[0][0]) && Array.isArray(rings[0][0][0])) rings = rings[0];
  	      return rings
  	      .map(ring =>
  	        ring
  	        .filter(p => Array.isArray(p) && p.length >= 2)
  	        .map(p => [Number(p[0]), Number(p[1])])
  	        .filter(p => Number.isFinite(p[0]) && Number.isFinite(p[1]))
  	      )
  	      .filter(r => r.length >= 3);
  	    }

  	    function pointInRing(lon, lat, ring) {
  	      let inside = false;
  	      for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
  	        const [xi,
  	          yi] = ring[i];
  	        const [xj,
  	          yj] = ring[j];
  	        const intersect =
  	        (yi > lat) !== (yj > lat) && lon < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
  	        if (intersect) inside = !inside;
  	      }
  	      return inside;
  	    }

  	    function pointInPolygon(lon, lat, rings) {
  	      if (!rings?.length) return false;
  	      if (!pointInRing(lon, lat, rings[0])) return false;
  	      for (let k = 1; k < rings.length; k++) if (pointInRing(lon, lat, rings[k])) return false;
  	      return true;
  	    }

  	    // ---------- Smart Fuel Metric (multi-source fallback) ----------
  	    function getFuelMetric(r) {
  	      if (!r || typeof r !== "object") return {
  	        val: null,
  	        src: null
  	      };
  	      const keys = [
  	        "can.tracker.counted.fuel.consumed",
  	        "can.fuel.consumed",
  	        "can.fuel.used",
  	        "can.fuel.liters",
  	        "gps.fuel.used"
  	      ];

  	      for (const k of keys) {
  	        const v = Number(r[k]);
  	        if (Number.isFinite(v)) return {
  	          val: v,
  	          src: k
  	        };
  	      }
  	      return {
  	        val: null,
  	        src: null
  	      };
  	    }

  	    function getFuelLevelPct(r, tankCap) {
  	      const pct = Number(r["can.fuel.level"]);
  	      if (Number.isFinite(pct) && pct >= 0 && pct <= 100) return pct;

  	      const vol = Number(r["can.fuel.volume"]);
  	      if (Number.isFinite(vol) && Number.isFinite(tankCap) && tankCap > 0) {
  	        return Math.min(100, Math.max(0, (vol / tankCap) * 100));
  	      }
  	      return null;
  	    }

  	    // ---------- Trailer label helpers ----------
  	    function uniquePush(list, v) {
  	      if (!list) return;
  	      if (v == null) return;
  	      var s = String(v);
  	      if (list.indexOf(s) === -1) list.push(s);
  	    }

  	    function getTrailerLabelsFromPoint(p, lookup) {
  	      var out = [];
  	      if (!p || typeof p !== "object") return out;

  	      var beacons = p.ble && Array.isArray(p.ble.beacons) ? p.ble.beacons: [];
  	      for (var i = 0; i < beacons.length; i++) {
  	        var b = beacons[i];
  	        var id = b && b.id != null ? String(b.id): null;
  	        if (!id) continue;

  	        var label = lookup && lookup[id] ? lookup[id]: null;
  	        if (label) uniquePush(out, label);
  	      }
  	      return out;
  	    }

  	    const calcDistance = (pts) => {
  	      let d = 0;
  	      for (let i = 1; i < pts.length; i++) {
  	        const a = pts[i - 1];
  	        const b = pts[i];
  	        const A = {
  	          lat: Number(a["position.latitude"]),
  	          lon: Number(a["position.longitude"])
  	        };
  	        const B = {
  	          lat: Number(b["position.latitude"]),
  	          lon: Number(b["position.longitude"])
  	        };
  	        if (Number.isFinite(A.lat) && Number.isFinite(A.lon) && Number.isFinite(B.lat) && Number.isFinite(B.lon))
  	          d += haversineM(A, B);
  	      }
  	      return d;
  	    };

  	    // ---------- Data Prep ----------
  	    const locations = Array.isArray(Locations) ? Locations.map(toPlain): [];
  	    const track = Array.isArray(Tractor.Tracking) ? Tractor.Tracking.map(toPlain): [];
  	    if (!track.length) return;

  	    const geos = locations.map(loc => ({
  	      Name: loc.Name || loc.ID,
  	      ID: loc.ID,
  	      Location: loc,
  	      Rings: normalizePolygon(loc.Polygon || loc.GeoFences || loc["Geo Fences"]),
  	      inside: false,
  	      activeVisit: null
  	    }));

  	    // ---------- Trailer lookup (EYEID -> "Application - Registration") ----------
  	    var trailerLabelByEyeId = {};

  	    try {
  	      var companies = (AppData && AppData.User && AppData.User.Companies) ? AppData.User.Companies: [];
  	      for (var ci = 0; ci < companies.length; ci++) {
  	        var comp = companies[ci];
  	        var trailers = comp && comp.Trailers ? comp.Trailers: [];
  	        for (var ti = 0; ti < trailers.length; ti++) {
  	          var tr = trailers[ti];
  	          var eye = tr ? tr.EYEID: null;
  	          if (!eye) continue;

  	          var app = tr.Application != null ? String(tr.Application): "";
  	          var reg = tr.Registration != null ? String(tr.Registration): "";

  	          var label = (app && reg) ? (app + " - " + reg): (app ? app: (reg ? reg: (tr.ID != null ? String(tr.ID): String(eye))));

  	          trailerLabelByEyeId[String(eye)] = label;
  	        }
  	      }
  	    } catch (e) {
  	      trailerLabelByEyeId = {};
  	    }

  	    const finalEvents = [];

  	    // ---------- Main Loop ----------
  	    for (let i = 0; i < track.length; i++) {
  	      const p = track[i];
  	      const lat = Number(p["position.latitude"]);
  	      const lon = Number(p["position.longitude"]);
  	      const ts = Number(p.timestamp);
  	      if (!Number.isFinite(lat) || !Number.isFinite(lon) || !Number.isFinite(ts)) continue;

  	      for (const g of geos) {
  	        if (!g.Rings.length) continue;
  	        const inside = pointInPolygon(lon, lat, g.Rings);

  	        // ENTER event
  	        if (!g.inside && inside) {
  	          g.inside = true;
  	          const fuel = getFuelMetric(p);
  	          g.activeVisit = {
  	            type: (i === 0 ? "Started In Location": "Entered Location"),
  	            Name: g.Name,
  	            Location: g.Location,
  	            lat_in: lat,
  	            lon_in: lon,
  	            ts_in: ts,
  	            time_in: new Date(ts * 1000).toISOString(),
  	            fuel_in: fuel.val,
  	            fuel_src: fuel.src,

  	            // ✅ NEW: trailers seen during this visit (Application - Registration)
  	            trailers: getTrailerLabelsFromPoint(p, trailerLabelByEyeId),

  	            points: [p]
  	          };
  	        }

  	        // STILL INSIDE
  	        else if (g.inside && inside && g.activeVisit) {
  	          g.activeVisit.points.push(p);

  	          // ✅ NEW: accumulate trailers while inside zone
  	          var tLabs = getTrailerLabelsFromPoint(p, trailerLabelByEyeId);
  	          for (var tt = 0; tt < tLabs.length; tt++) {
  	            uniquePush(g.activeVisit.trailers, tLabs[tt]);
  	          }

  	          // Forward capture for missing fuel_in
  	          if (!Number.isFinite(g.activeVisit.fuel_in)) {
  	            const fNow = getFuelMetric(p);
  	            if (Number.isFinite(fNow.val)) {
  	              g.activeVisit.fuel_in = fNow.val;
  	              g.activeVisit.fuel_src = fNow.src;
  	            }
  	          }
  	        }

  	        // EXIT event
  	        else if (g.inside && !inside && g.activeVisit) {
  	          const last = g.activeVisit.points[g.activeVisit.points.length - 1] || p;
  	          const tsOut = Number(last.timestamp) || ts;
  	          const durationSec = tsOut - g.activeVisit.ts_in;
  	          const distM = calcDistance(g.activeVisit.points);

  	          // --- Fuel recovery logic ---
  	          const fStart = getFuelMetric(g.activeVisit.points.find(r => getFuelMetric(r).val != null) || {});
  	          let fEnd = getFuelMetric(last);
  	          if (!Number.isFinite(fEnd.val)) {
  	            // reverse-search last valid fuel reading in zone
  	            for (let j = g.activeVisit.points.length - 1; j >= 0; j--) {
  	              const tryF = getFuelMetric(g.activeVisit.points[j]);
  	              if (Number.isFinite(tryF.val)) {
  	                fEnd = tryF; break;
  	              }
  	            }
  	          }

  	          let fuelUsed = (Number.isFinite(fStart.val) && Number.isFinite(fEnd.val))
  	          ? (fEnd.val - fStart.val): null;

  	          // --- Fuel fallback: use level% drop if consumed isn't available ---
  	          if (!Number.isFinite(fuelUsed)) {
  	            const tankCap = Number(Tractor?.CAN?.Tank);
  	            if (Number.isFinite(tankCap) && tankCap > 0) {
  	              const pStart = getFuelLevelPct(g.activeVisit.points[0], tankCap);
  	              const pEnd = getFuelLevelPct(last, tankCap);
  	              if (Number.isFinite(pStart) && Number.isFinite(pEnd)) {
  	                const liters = ((pStart - pEnd) / 100) * tankCap;
  	                if (Number.isFinite(liters) && liters > 0) fuelUsed = liters;
  	              }
  	            }
  	          }


  	          const distKm = distM / 1000;
  	          const kmPerL = (fuelUsed && fuelUsed > 0) ? distKm / fuelUsed: null;
  	          const LperH = (fuelUsed && durationSec > 0) ? (fuelUsed / (durationSec / 3600)): null;

  	          g.activeVisit = {
  	            ...g.activeVisit,
  	            type_out: "Left Location",
  	            ts_out: tsOut,
  	            time_out: new Date(tsOut * 1000).toISOString(),
  	            lat_out: Number(last["position.latitude"]) || lat,
  	            lon_out: Number(last["position.longitude"]) || lon,
  	            duration_sec: durationSec,
  	            distance_m: distM,
  	            fuel_out: fEnd.val,
  	            fuel_src_out: fEnd.src,
  	            fuel_used: fuelUsed,
  	            km_per_litre: kmPerL,
  	            litres_per_hour: LperH
  	          };

  	          finalEvents.push(g.activeVisit);
  	          g.inside = false;
  	          g.activeVisit = null;
  	        }
  	      }
  	    }

  	    // ---------- Close still-active zones ----------
  	    const last = track[track.length - 1];
  	    const lastTs = Number(last.timestamp);
  	    for (const g of geos) {
  	      if (g.inside && g.activeVisit) {
  	        const durationSec = lastTs - g.activeVisit.ts_in;
  	        const distM = calcDistance(g.activeVisit.points);

  	        const fStart = getFuelMetric(g.activeVisit.points.find(r => getFuelMetric(r).val != null) || {});
  	        let fEnd = getFuelMetric(last);
  	        if (!Number.isFinite(fEnd.val)) {
  	          for (let j = g.activeVisit.points.length - 1; j >= 0; j--) {
  	            const tryF = getFuelMetric(g.activeVisit.points[j]);
  	            if (Number.isFinite(tryF.val)) {
  	              fEnd = tryF; break;
  	            }
  	          }
  	        }

  	        let fuelUsed = (Number.isFinite(fStart.val) && Number.isFinite(fEnd.val))
  	        ? (fEnd.val - fStart.val): null;

  	        // --- Fuel fallback: use level% drop if consumed isn't available ---
  	        if (!Number.isFinite(fuelUsed)) {
  	          const tankCap = Number(Tractor?.CAN?.Tank);
  	          if (Number.isFinite(tankCap) && tankCap > 0) {
  	            const pStart = getFuelLevelPct(g.activeVisit.points[0], tankCap);
  	            const pEnd = getFuelLevelPct(last, tankCap);
  	            if (Number.isFinite(pStart) && Number.isFinite(pEnd)) {
  	              const liters = ((pStart - pEnd) / 100) * tankCap;
  	              if (Number.isFinite(liters) && liters > 0) fuelUsed = liters;
  	            }
  	          }
  	        }


  	        const distKm = distM / 1000;
  	        const kmPerL = (fuelUsed && fuelUsed > 0) ? distKm / fuelUsed: null;
  	        const LperH = (fuelUsed && durationSec > 0) ? (fuelUsed / (durationSec / 3600)): null;

  	        g.activeVisit = {
  	          ...g.activeVisit,
  	          type_out: "In Location",
  	          ts_out: lastTs,
  	          time_out: new Date(lastTs * 1000).toISOString(),
  	          duration_sec: durationSec,
  	          distance_m: distM,
  	          fuel_out: fEnd.val,
  	          fuel_src_out: fEnd.src,
  	          fuel_used: fuelUsed,
  	          km_per_litre: kmPerL,
  	          litres_per_hour: LperH
  	        };

  	        finalEvents.push(g.activeVisit);
  	      }
  	    }

  	    Tractor.Events["Location Events"] = finalEvents;
  	    Tractor.CurrentLocation = geos.filter(g => g.inside).map(g => g.Name).join(", ") || null;


  	  } catch (err) {
  	    console.error("!!! In/Out Engine v11 Crash:", err);
  	    Tractor.Events["Location Events"] = [{
  	      error: String(err)
  	    }];
  	  }


  	  // ---------- compute Max summary (v4: flat-key safe) ----------
  	  const maxSummary = {
  	    MaxSpeed: 0,
  	    MaxRPM: 0,
  	    MaxTemp: 0,
  	    MaxThrottle: 0,
  	    // ✅ NEW
  	    TotalIdleSec: 0,
  	    TotalDistKm: 0,
  	    TotalFuelL: 0 // ✅ new field
  	  };

  	  // 1️⃣ Aggregate from event segments
  	  for (const [key, segs] of Object.entries(eventsOut)) {
  	    for (const s of segs) {
  	      if (s.Max != null) {
  	        if (/speed/i.test(key)) maxSummary.MaxSpeed = Math.max(maxSummary.MaxSpeed, s.Max);
  	        if (/rpm/i.test(key)) maxSummary.MaxRPM = Math.max(maxSummary.MaxRPM, s.Max);
  	        if (/temp|heat/i.test(key)) maxSummary.MaxTemp = Math.max(maxSummary.MaxTemp, s.Max);
  	        if (/throttle/i.test(key)) maxSummary.MaxThrottle = Math.max(maxSummary.MaxThrottle, s.Max);

  	      }

  	    }
  	  }

  	  // 2️⃣ Direct fallback verification from logs  — REPLACED (ES5-safe)
  	  if (Array.isArray(logs) && logs.length) {
  	    var distKm = 0;

  	    // --- Smart Distance Calculation (odometer → GPS fallback) ---
  	    var odoVals = [];
  	    for (var i = 0; i < logs.length; i++) {
  	      var od = toNum(logs[i]["can.vehicle.mileage"]);
  	      if (Number.isFinite(od)) odoVals.push(od);
  	    }

  	    if (odoVals.length >= 2) {
  	      distKm = Math.max(0, odoVals[odoVals.length - 1] - odoVals[0]);
  	    } else {
  	      var gpsVals = [];
  	      for (var j = 0; j < logs.length; j++) {
  	        var gvRaw = logs[j]["vehicle.mileage"] != null
  	        ? logs[j]["vehicle.mileage"]: (logs[j]["gps.odometer"] != null ? logs[j]["gps.odometer"]: logs[j]["gps.mileage"]);
  	        var gv = toNum(gvRaw);
  	        if (Number.isFinite(gv)) gpsVals.push(gv);
  	      }
  	      if (gpsVals.length >= 2) {
  	        distKm = Math.max(0, gpsVals[gpsVals.length - 1] - gpsVals[0]);
  	      }
  	    }

  	    // --- Update max metrics (speed/rpm/temp) ---
  	    for (var k = 0; k < logs.length; k++) {
  	      var rk = logs[k];
  	      var spd = toNum(rk.__spd != null ? rk.__spd: rk["position.speed"]);
  	      var rpm = toNum(rk["can.engine.rpm"]);
  	      var tmp = toNum(rk["can.engine.temperature"]);
  	      var thr = toNum(rk["can.throttle.pedal.level"]);
  	      if (Number.isFinite(spd)) maxSummary.MaxSpeed = Math.max(maxSummary.MaxSpeed, spd);
  	      if (Number.isFinite(rpm)) maxSummary.MaxRPM = Math.max(maxSummary.MaxRPM, rpm);
  	      if (Number.isFinite(tmp)) maxSummary.MaxTemp = Math.max(maxSummary.MaxTemp, tmp);
  	      if (Number.isFinite(thr)) maxSummary.MaxThrottle = Math.max(maxSummary.MaxThrottle, thr);
  	    }

  	    // --- Commit distance (do NOT also add event segment distances elsewhere) ---
  	    maxSummary.TotalDistKm += distKm;

  	    // --- ✅ Smart Fuel Consumed Aggregation (First+Last Valid CAN, fallback GPS) ---
  	    if (Array.isArray(logs) && logs.length) {
  	      const getFuelValue = (r, key) => {
  	        const v = Number(r[key]);
  	        return Number.isFinite(v) ? v: null;
  	      };

  	      // 1️⃣ Try CAN fuel.consumed
  	      const firstCan = logs.find(r => getFuelValue(r, "can.fuel.consumed") != null);
  	      const lastCan = [...logs].reverse().find(r => getFuelValue(r, "can.fuel.consumed") != null);

  	      if (firstCan && lastCan) {
  	        const start = getFuelValue(firstCan, "can.fuel.consumed");
  	        const end = getFuelValue(lastCan, "can.fuel.consumed");
  	        if (Number.isFinite(start) && Number.isFinite(end) && end >= start) {
  	          maxSummary.TotalFuelL = end - start;
  	        }
  	      } else {
  	        // 2️⃣ Fallback: gps.fuel.used
  	        const firstGps = logs.find(r => getFuelValue(r, "gps.fuel.used") != null);
  	        const lastGps = [...logs].reverse().find(r => getFuelValue(r, "gps.fuel.used") != null);
  	        if (firstGps && lastGps) {
  	          const start = getFuelValue(firstGps, "gps.fuel.used");
  	          const end = getFuelValue(lastGps, "gps.fuel.used");
  	          if (Number.isFinite(start) && Number.isFinite(end) && end >= start) {
  	            maxSummary.TotalFuelL = end - start;
  	          }
  	        }
  	      }
  	    }



  	    // --- IdleSec: prefer CAN "Idle Event" segments; else fall back once ---
  	    var idleSegs = eventsOut["Idle Event"];
  	    if (Array.isArray(idleSegs) && idleSegs.length) {
  	      for (var s = 0; s < idleSegs.length; s++) {
  	        var seg = idleSegs[s];
  	        if (seg && Number.isFinite(seg.idle_seconds)) {
  	          maxSummary.TotalIdleSec += seg.idle_seconds;
  	        }
  	      }
  	    } else {
  	      // Flespi is authoritative for idling. Do not infer idle from speed < 1:
  	      // a parked vehicle with the engine off is stationary, not idling.
  	      maxSummary.TotalIdleSec += 0;
  	    }
  	  }


  	  Tractor.Events.Max = {
  	    Speed: Math.round(maxSummary.MaxSpeed || 0),
  	    RPM: Math.round(maxSummary.MaxRPM || 0),
  	    Temp: Math.round(maxSummary.MaxTemp || 0),
  	    Throttle: Math.round(maxSummary.MaxThrottle || 0),
  	    IdleSec: Math.round(maxSummary.TotalIdleSec || 0),
  	    DistM: Math.round((maxSummary.TotalDistKm || 0) * 1000000) / 1000,
  	    DistKm: Math.round((maxSummary.TotalDistKm || 0) * 1000) / 1000,
  	    FuelL: Math.round((maxSummary.TotalFuelL || 0) * 1000) / 1000
  	  };

  	  // === MaxData (per-metric object with full original point data) ===
  	  (() => {
  	    if (!Array.isArray(logs) || !logs.length) return;

  	    const maxData = {};
  	    const maxVals = Tractor.Events.Max;

  	    // Helper: find all logs where metric matches its max
  	    const findFullPoints = (metric, maxVal) => {
  	      if (maxVal == null) return [];
  	      const matches = [];

  	      for (const r of logs) {
  	        const val =
  	        metric === "Speed" ? (r.__spd ?? r["position.speed"]):
  	        metric === "RPM" ? r["can.engine.rpm"]:
  	        metric === "Temp" ? r["can.engine.temperature"]:
  	        null;

  	        if (val != null && Math.round(val) === Math.round(maxVal)) {
  	          // Include the full raw record (cloned to avoid mutations)
  	          matches.push(JSON.parse(JSON.stringify(r)));
  	        }
  	      }
  	      return matches;
  	    };

  	    // Create per-metric objects with full data
  	    maxData.Speed = {
  	      value: maxVals.Speed,
  	      Points: findFullPoints("Speed", maxVals.Speed)
  	    };

  	    maxData.RPM = {
  	      value: maxVals.RPM,
  	      Points: findFullPoints("RPM", maxVals.RPM)
  	    };

  	    // === Throttle Overuse (pedal level max) ===
  	    maxData.Throttle = {
  	      value: maxVals.Throttle,
  	      Points: (() => {
  	        const matches = [];
  	        for (const r of logs) {
  	          const thr = toNum(r["can.throttle.pedal.level"]);
  	          if (thr != null && Math.round(thr) === Math.round(maxVals.Throttle)) {
  	            matches.push(JSON.parse(JSON.stringify(r)));
  	          }
  	        }
  	        return matches;
  	      })()
  	    };


  	    maxData.Temp = {
  	      value: maxVals.Temp,
  	      Points: findFullPoints("Temp",
  	        maxVals.Temp)
  	    };

  	    maxData.IdleSec = {
  	      value: maxVals.IdleSec,
  	      Points: [] // You can later tie this to Idle segments if you want
  	    };

  	    maxData.DistKm = {
  	      value: maxVals.DistKm,
  	      Points: [] // Derived from odometer/gps, no single point
  	    };

  	    maxData.FuelL = {
  	      value: maxVals.FuelL,
  	      Points: [] // Derived from first+last, no single point
  	    };

  	    Tractor.Events.MaxData = maxData;
  	  })();


  	  // 4️⃣ Optional formatted string
  	  const mins = Math.floor(maxSummary.TotalIdleSec / 60);
  	  const secs = Math.round(maxSummary.TotalIdleSec % 60);
  	  Tractor.Events.Max.IdleFmt = `${mins}m ${secs}s`;

  	  try {
  	    BackendlessUI?.App?.refresh?.();
  	  } catch {}

  	  return {
  	    ok: true,
  	    events: eventsOut,
  	    stats: {
  	      eventsDefined: CAN.Events.length,
  	      logsCount: logs.length
  	    },
  	    debug,
  	    errors: []
  	  };
  	})(Tractor, CAN, Locations, AppData);
  })((getObjectProperty(AppData, 'SelectedTractor')), (getObjectProperty((getObjectProperty(AppData, 'SelectedTractor')), 'CAN')), Locations, AppData);
  await (async function(Tractor) {
  	// === Colorize Tracking (Rog Mode v2 — Backendless Safe) ===
  	// Purpose: Annotates each Tractor.Tracking point with { color, events[] }
  	// Precedence: Red > Green > Yellow
  	
  	(function colorizeTracking(Tractor) {
  	  if (!Tractor || !Array.isArray(Tractor.Tracking)) {
  	    console.warn('[ColorizeTracking] Missing Tractor.Tracking');
  	    return;
  	  }
  	
  	  const redEvents = [
  	    'Speeding', 'Engine Over-Rev', 'Engine Over-Temperature', 'Throttle Overuse'
  	  ];
  	  const greenEvents = ['Green Band Driving'];
  	  const colorMap = { red: '#FF0000', green: '#00FF00', yellow: '#FFFF00' };
  	
  	  // --- simple object lookup instead of Map ---
  	  const tsMap = {};
  	
  	  // Collect event timestamps
  	  for (const [eventName, segs] of Object.entries(Tractor.Events || {})) {
  	    if (!Array.isArray(segs)) continue;
  	    const severity =
  	      redEvents.includes(eventName) ? 'red' :
  	      greenEvents.includes(eventName) ? 'green' : null;
  	    if (!severity) continue;
  	
  	    for (const seg of segs) {
  	      if (!Array.isArray(seg.Points)) continue;
  	      for (const pt of seg.Points) {
  	        const ts = Number(pt.timestamp);
  	        if (!ts) continue;
  	        if (!tsMap[ts]) tsMap[ts] = { events: [], color: 'yellow' };
  	
  	        // push unique event
  	        if (!tsMap[ts].events.includes(eventName)) tsMap[ts].events.push(eventName);
  	
  	        // color precedence
  	        if (severity === 'red') tsMap[ts].color = 'red';
  	        else if (severity === 'green' && tsMap[ts].color !== 'red') tsMap[ts].color = 'green';
  	      }
  	    }
  	  }
  	
  	  // Apply to Tracking[]
  	  let redCount = 0, greenCount = 0, yellowCount = 0;
  	  for (const row of Tractor.Tracking) {
  	    const ts = Number(row.timestamp);
  	    const found = tsMap[ts];
  	    if (found) {
  	      row.color = colorMap[found.color];
  	      row.events = found.events;
  	      if (found.color === 'red') redCount++;
  	      else if (found.color === 'green') greenCount++;
  	    } else {
  	      row.color = colorMap.yellow;
  	      row.events = [];
  	      yellowCount++;
  	    }
  	  }
  	
  	 })(Tractor);

  })((getObjectProperty(AppData, 'SelectedTractor')));
  AppData['SpinnerMsg'] = 'Checking Map Status...';
  await (async function(Map) {
  	/* 
  	Inputs: Map
  	Outputs: 
  	  MapReady (boolean)
  	  MapObject (google.maps.Map)
  	  Wrapper (any)
  	  Element (DOM)
  	Purpose:
  	  - Resolves Google Map instance from any wrapper.
  	  - Waits for initialization (async safe).
  	  - Automatically cleans old markers/polylines/polygons.
  	*/
  	
  	return (async () => {
  	
  	  // === Tunables ===
  	  const TIMEOUT_MS = 10000;  // Max wait
  	  const STABLE_COUNT = 1;    // Require N consecutive good ticks
  	
  	  // === Tiny utils ===
  	  const nextFrame = () => new Promise(r => requestAnimationFrame(r));
  	  const sleep = (ms) => new Promise(r => setTimeout(r, ms));
  	  const now = () => (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
  	
  	  const isGmAvailable = () =>
  	    typeof window !== "undefined" &&
  	    window.google && window.google.maps &&
  	    typeof window.google.maps.Map === "function";
  	
  	  const tryImportMaps = async () => {
  	    try {
  	      if (window?.google?.maps?.importLibrary && !isGmAvailable()) {
  	        await Promise.race([
  	          window.google.maps.importLibrary("maps"),
  	          nextFrame()
  	        ]);
  	      }
  	    } catch (_) { /* ignore */ }
  	  };
  	
  	  // === Core extractors ===
  	  const extractMap = (candidate) => {
  	    if (!candidate) return null;
  	    try {
  	      if (isGmAvailable() && candidate instanceof window.google.maps.Map) return candidate;
  	
  	      const directCandidates = [];
  	      const push = (x) => { if (x) directCandidates.push(x); };
  	
  	      push(candidate.map);
  	      if (typeof candidate.map === "function") push(candidate.map());
  	      push(candidate.map?.map);
  	      if (typeof candidate.map?.getMap === "function") push(candidate.map.getMap());
  	      if (typeof candidate.getMap === "function") push(candidate.getMap());
  	      push(candidate.googleMap);
  	      push(candidate.gMap);
  	      push(candidate.gmap);
  	      push(candidate.__map);
  	      push(candidate._map);
  	      push(candidate.api?.map);
  	      if (candidate.mapComponent?.getMap) push(candidate.mapComponent.getMap());
  	      push(candidate.$mapObject);
  	      push(candidate.$refs?.map?.$mapObject);
  	
  	      for (const c of directCandidates) {
  	        if (!c) continue;
  	        if (isGmAvailable() && c instanceof window.google.maps.Map) return c;
  	        if (c && typeof c.getCenter === "function" && typeof c.panTo === "function") return c; // duck type
  	      }
  	
  	      if (typeof candidate.getCenter === "function" && typeof candidate.panTo === "function") return candidate;
  	    } catch (_) {}
  	    return null;
  	  };
  	
  	  const getEl = (candidate, mapInstance) => {
  	    try {
  	      if (!candidate) return mapInstance?.getDiv?.() || null;
  	      if (typeof candidate.el === "function") return candidate.el();
  	      if (candidate.el) return candidate.el;
  	      if (candidate.element) return candidate.element;
  	      if (candidate.$el) return candidate.$el;
  	      if (mapInstance?.getDiv) return mapInstance.getDiv();
  	    } catch (_) {}
  	    return null;
  	  };
  	
  	  const isWrapperLikelyValid = (candidate) =>
  	    !!candidate && (("map" in candidate) || ("el" in candidate) || ("element" in candidate) || ("center" in candidate));
  	
  	  // === Initial fast path ===
  	  let wrapper = Map;
  	  let mapInstance = extractMap(wrapper);
  	  let el = getEl(wrapper, mapInstance);
  	
  	  if (mapInstance) {
  	    cleanMap(mapInstance);
  	    return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	  }
  	
  	  tryImportMaps();
  	  const deadline = now() + TIMEOUT_MS;
  	  let stable = 0;
  	
  	  // === Main wait loop ===
  	  while (now() < deadline) {
  	    if (!isWrapperLikelyValid(wrapper)) {
  	      if (document.hidden) await sleep(10); else await nextFrame();
  	      continue;
  	    }
  	
  	    if (!isGmAvailable()) {
  	      if (document.hidden) await sleep(10); else await nextFrame();
  	      continue;
  	    }
  	
  	    mapInstance = extractMap(wrapper);
  	    el = getEl(wrapper, mapInstance);
  	    const elOk = !el || !!el.isConnected || !!(el?.ownerDocument);
  	
  	    if (mapInstance && elOk) {
  	      stable++;
  	      if (stable >= STABLE_COUNT) {
  	        cleanMap(mapInstance);
  	        return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	      }
  	    } else {
  	      stable = 0;
  	    }
  	
  	    if (document.hidden) await sleep(10); else await nextFrame();
  	  }
  	
  	  // === Timeout fallback ===
  	  console.warn("⚠️ Map Loader: Timed out waiting for map initialization.");
  	  return { MapReady: false, MapObject: mapInstance || null, Wrapper: wrapper || null, Element: el || null };
  	
  	
  	  // === Inner Cleaner Function ===
  	  function cleanMap(Map) {
  	    if (!Map || !isGmAvailable()) {
  	      console.warn("Map Cleaner: Map or Google Maps not initialized.");
  	      return;
  	    }
  	
  	    const clear = (arrName) => {
  	      const arr = Map[arrName];
  	      if (arr && Array.isArray(arr)) {
  	        arr.forEach(i => { if (i?.setMap) i.setMap(null); });
  	        Map[arrName] = [];
  	      }
  	    };
  	
  	    clear("_allMarkers");
  	    clear("_allPolylines");
  	    clear("_allPolygons");
  	    clear("_allOverlays");
  	
  	    Map._selectedMarker = null;
  	    Map._popupInfoWindow = null;
  	
  	    }
  	
  	})();

  })(Map);
  await (async function(googleMapComponent, App, Locations, Images, Hub, SVG) {
  	// === Global CSS for Fuel Gauge Animations ===
  	if (!document.getElementById("fuelGaugeAnimations")) {
  	  const style = document.createElement("style");
  	  style.id = "fuelGaugeAnimations";
  	  style.textContent = `
  	  @keyframes fuelFill {
  	  from { width:0%; }
  	  to   { width:var(--target-width,100%); }
  	  }
  	  @keyframes fuelPulse {
  	  0% {
  	  box-shadow: 0 0 8px rgba(255, 0, 0, 0.9),
  	  0 0 14px rgba(255, 80, 0, 0.8);
  	  filter: drop-shadow(0 0 6px rgba(255, 50, 0, 0.9));
  	  opacity: 1;
  	  }
  	  50% {
  	  box-shadow: 0 0 20px rgba(255, 0, 0, 1),
  	  0 0 30px rgba(255, 80, 0, 0.9);
  	  filter: drop-shadow(0 0 14px rgba(255, 0, 0, 1));
  	  opacity: 0.8;
  	  }
  	  100% {
  	  box-shadow: 0 0 8px rgba(255, 0, 0, 0.9),
  	  0 0 14px rgba(255, 80, 0, 0.8);
  	  filter: drop-shadow(0 0 6px rgba(255, 50, 0, 0.9));
  	  opacity: 1;
  	  }
  	  }

  	  `;
  	  document.head.appendChild(style);
  	}

  	// === Global CSS: fadeIn for detached panel ===
  	if (!document.getElementById("rogFadeAnim")) {
  	  const style = document.createElement("style");
  	  style.id = "rogFadeAnim";
  	  style.textContent = `
  	  @keyframes fadeIn {
  	  from { opacity: 0; transform: translateY(-10px); }
  	  to   { opacity: 1; transform: translateY(0); }
  	  }`;
  	  document.head.appendChild(style);
  	}

  	// === Global CSS: Compare A/B marker labels ===
  	if (!document.getElementById("trackitCompareMarkerLabelCss")) {
  	  const style = document.createElement("style");
  	  style.id = "trackitCompareMarkerLabelCss";
  	  style.textContent = `
  	  .trackit-compare-marker-label {
  	  font-size: 26px !important;
  	  font-weight: 950 !important;
  	  color: #fff !important;
  	  text-shadow:
  	  -2px -2px 0 #000,
  	  2px -2px 0 #000,
  	  -2px  2px 0 #000,
  	  2px  2px 0 #000,
  	  0px  0px 8px #000,
  	  0px  0px 14px #000 !important;
  	  line-height: 1 !important;
  	  }
  	  `;
  	  document.head.appendChild(style);
  	}

  	// ======================================================================
  	// ============ TrackIT Compact Map Control - Standalone =================
  	// ======================================================================
  	// ======================================================================
  	// TrackIT Map Lifecycle Manager
  	// ======================================================================

  	function destroyFineTrackMapRuntime(map) {
  	  if (!map) return;

  	  // Stop an active Fine Track replay before removing its marker and controls.
  	  try {
  	    map.__fineTrackReplayCleanup?.();
  	  } catch (_) {}
  	  map.__fineTrackReplayCleanup = null;

  	  // --------------------------------------------------
  	  // Remove Google Maps event listeners
  	  // --------------------------------------------------

  	  if (Array.isArray(map.__fineTrackMapControlListeners)) {
  	    map.__fineTrackMapControlListeners.forEach(listener => {
  	      try {
  	        google.maps.event.removeListener(listener);
  	      } catch (_) {}
  	    });
  	  }

  	  map.__fineTrackMapControlListeners = [];

  	  // --------------------------------------------------
  	  // Remove DOM event listeners
  	  // --------------------------------------------------

  	  if (Array.isArray(map.__fineTrackDomControlListeners)) {
  	    map.__fineTrackDomControlListeners.forEach(record => {
  	      try {
  	        record?.target?.removeEventListener?.(
  	          record.event,
  	          record.handler,
  	          record.options
  	        );
  	      } catch (_) {}
  	    });
  	  }

  	  map.__fineTrackDomControlListeners = [];

  	  // --------------------------------------------------
  	  // Remove overlays created by this code
  	  // --------------------------------------------------

  	  if (Array.isArray(map.__fineTrackManagedOverlays)) {
  	    map.__fineTrackManagedOverlays.forEach(overlay => {
  	      try {
  	        overlay?.setMap?.(null);
  	      } catch (_) {}

  	      try {
  	        overlay?.close?.();
  	      } catch (_) {}
  	    });
  	  }

  	  map.__fineTrackManagedOverlays = [];

  	  // --------------------------------------------------
  	  // Remove managed DOM elements
  	  // --------------------------------------------------

  	  if (Array.isArray(map.__fineTrackManagedElements)) {
  	    map.__fineTrackManagedElements.forEach(element => {
  	      try {
  	        element?.remove?.();
  	      } catch (_) {}
  	    });
  	  }

  	  map.__fineTrackManagedElements = [];

  	  // --------------------------------------------------
  	  // Remove previous controls from this map only
  	  // --------------------------------------------------

  	  try {
  	    const mapDiv = map.getDiv?.();

  	    mapDiv
  	      ?.querySelectorAll?.(
  	        ".fine-track-compact-map-control," +
  	        "#fineTrackReplayPanel," +
  	        "#fineTrackReplayLauncher," +
  	        "#fineTrackDetachedPopup"
  	      )
  	      ?.forEach?.(element => {
  	        try {
  	          element.remove();
  	        } catch (_) {}
  	      });

  	    // The details panel is mounted on document.body, not inside the map.
  	    document.getElementById("fineTrackDetachedPopup")?.remove();
  	  } catch (_) {}

  	  // --------------------------------------------------
  	  // Remove controls inserted into Google control arrays
  	  // --------------------------------------------------

  	  try {
  	    const positions = [
  	      google.maps.ControlPosition.RIGHT_BOTTOM,
  	      google.maps.ControlPosition.LEFT_BOTTOM,
  	      google.maps.ControlPosition.RIGHT_TOP,
  	      google.maps.ControlPosition.LEFT_TOP
  	    ];

  	    positions.forEach(position => {
  	      const controls = map.controls?.[position];

  	      if (!controls) return;

  	      for (let index = controls.getLength() - 1; index >= 0; index--) {
  	        const item = controls.getAt(index);

  	        if (
  	          item?.__fineTrackUnifiedMapControl ||
  	          item?.dataset?.fineTrackMapControl
  	        ) {
  	          controls.removeAt(index);
  	        }
  	      }
  	    });
  	  } catch (_) {}

  	  // --------------------------------------------------
  	  // Remove comparison overlays
  	  // --------------------------------------------------

  	  try {
  	    window._fineTrackCompareOverlay?.setMap?.(null);
  	  } catch (_) {}

  	  try {
  	    window._fineTrackCompareOverlayPulse?.setMap?.(null);
  	  } catch (_) {}

  	  window._fineTrackCompareOverlay = null;
  	  window._fineTrackCompareOverlayPulse = null;

  	  if (window._fineTrackComparePulseTimer) {
  	    clearInterval(window._fineTrackComparePulseTimer);
  	    window._fineTrackComparePulseTimer = null;
  	  }

  	  // --------------------------------------------------
  	  // Remove stale global keyboard listener
  	  // --------------------------------------------------

  	  try {
  	    if (window._fineTrackKeyHandler) {
  	      window.removeEventListener(
  	        "keydown",
  	        window._fineTrackKeyHandler
  	      );
  	    }
  	  } catch (_) {}

  	  window._fineTrackKeyHandler = null;

  	  // --------------------------------------------------
  	  // Close stale information windows
  	  // --------------------------------------------------

  	  try {
  	    window._fineTrackWarnHubInfo?.close?.();
  	  } catch (_) {}

  	  window._fineTrackWarnHubInfo = null;

  	  // --------------------------------------------------
  	  // Reset map interaction
  	  // --------------------------------------------------

  	  try {
  	    map.setOptions({
  	      draggable: true,
  	      scrollwheel: true,
  	      disableDoubleClickZoom: false,
  	      keyboardShortcuts: true,
  	      gestureHandling: "auto",
  	      clickableIcons: true
  	    });

  	    map.getDiv().style.cursor = "";
  	  } catch (_) {}

  	  map.__fineTrackRoutePanelMapLocked = false;
  	  map.__fineTrackUnifiedMapControlReady = false;
  	  map.__fineTrackUnifiedMapControlVersion = "";
  	}

  	function registerFineTrackOverlay(map, overlay) {
  	  if (!map || !overlay) return overlay;

  	  if (!Array.isArray(map.__fineTrackManagedOverlays)) {
  	    map.__fineTrackManagedOverlays = [];
  	  }

  	  map.__fineTrackManagedOverlays.push(overlay);
  	  return overlay;
  	}

  	function registerFineTrackElement(map, element) {
  	  if (!map || !element) return element;

  	  if (!Array.isArray(map.__fineTrackManagedElements)) {
  	    map.__fineTrackManagedElements = [];
  	  }

  	  map.__fineTrackManagedElements.push(element);
  	  return element;
  	}

  	function addFineTrackUnifiedMapControl(map, App) {
  	  if (
  	    !map ||
  	    typeof google === "undefined" ||
  	    !(map instanceof google.maps.Map)
  	  ) {
  	    console.error("[TrackIT Map Controls] Invalid map.");
  	    return;
  	  }

  	  const CONTROL_VERSION =
  	    "trackit-map-control-route-v4-clean-lifecycle";

  	  /*
  	   * Always clear the previous runtime.
  	   *
  	   * Fine Track and Live Track may reuse the same map instance. The previous
  	   * version used an early return and retained stale controls and listeners.
  	   */
  	  destroyFineTrackMapRuntime(map);

  	  try {
  	    App?.FineTrackSelectedMarker?.setMap?.(null);
  	  } catch (_) {}

  	  if (App && typeof App === "object") {
  	    App.FineTrackSelectedMarker = null;
  	    App._tripReplayActive = false;
  	  }

  	  map.setOptions({
  	    mapTypeControl: false,
  	    zoomControl: false,
  	    fullscreenControl: false,
  	    rotateControl: false,
  	    scaleControl: false,
  	    streetViewControl: false,
  	    clickableIcons: true
  	  });

  	  try {
  	    const panorama = map.getStreetView();
  	    panorama.setVisible(false);
  	    panorama.setOptions({
  	      enableCloseButton: false,
  	      addressControl: false,
  	      fullscreenControl: false,
  	      panControl: false,
  	      zoomControl: false,
  	      linksControl: false
  	    });
  	  } catch (_) {}

  	  const mapDiv = map.getDiv ? map.getDiv(): null;

  	  try {
  	    const positions = [
  	      google.maps.ControlPosition.RIGHT_BOTTOM,
  	      google.maps.ControlPosition.LEFT_BOTTOM,
  	      google.maps.ControlPosition.RIGHT_TOP,
  	      google.maps.ControlPosition.LEFT_TOP
  	    ];

  	    positions.forEach(pos => {
  	      const controls = map.controls[pos];

  	      for (let i = controls.getLength() - 1; i >= 0; i--) {
  	        const item = controls.getAt(i);

  	        if (item?.__fineTrackUnifiedMapControl) {
  	          controls.removeAt(i);
  	        }
  	      }
  	    });
  	  } catch (_) {}

  	  try {
  	    mapDiv?.querySelectorAll?.(".fine-track-compact-map-control")?.forEach(node => node.remove());
  	  } catch (_) {}

  	  if (map.__fineTrackMapControlListeners) {
  	    map.__fineTrackMapControlListeners.forEach(listener => {
  	      try {
  	        google.maps.event.removeListener(listener);
  	      } catch (_) {}
  	    });
  	  }

  	  if (map.__fineTrackDomControlListeners) {
  	    map.__fineTrackDomControlListeners.forEach(({
  	      target, event, handler
  	    }) => {
  	      try {
  	        target.removeEventListener(event, handler);
  	      } catch (_) {}
  	    });
  	  }

  	  map.__fineTrackMapControlListeners = [];
  	  map.__fineTrackDomControlListeners = [];
  	  map.__fineTrackUnifiedMapControlReady = false;
  	  map.__fineTrackUnifiedMapControlVersion = "";

  	  function getAppBag() {
  	    if (App?.data && typeof App.data === "object") return App.data;
  	    if (App && typeof App === "object" && !("data" in App)) return App;

  	    if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	      return BackendlessUI.App.data;
  	    }

  	    if (typeof window !== "undefined" && window.AppData) {
  	      return window.AppData.data || window.AppData;
  	    }

  	    return null;
  	  }

  	  function refreshApp() {
  	    try {
  	      BackendlessUI?.App?.refresh?.();
  	    } catch (_) {}
  	  }

  	  function getSettingsBag() {
  	    const bag = getAppBag();

  	    if (bag) {
  	      if (!bag.FineTrackMapSettings) {
  	        bag.FineTrackMapSettings = {};
  	      }

  	      return bag.FineTrackMapSettings;
  	    }

  	    if (!map.__fineTrackLocalMapSettings) {
  	      map.__fineTrackLocalMapSettings = {};
  	    }

  	    return map.__fineTrackLocalMapSettings;
  	  }

  	  function writeSetting(key, value) {
  	  const settings = getSettingsBag();

  	  if (!settings || typeof settings !== "object") {
  	    return;
  	  }

  	  settings[key] = value;

  	  /*
  	   * These are client-side map preferences.
  	   *
  	   * Do not call BackendlessUI.App.refresh() here.
  	   * Refreshing the entire application rebuilds the map while the previous
  	   * Google Maps overlays and listeners are still alive.
  	   */
  	}

  	  function readSetting(key, fallback) {
  	    const settings = getSettingsBag();
  	    return settings[key] !== undefined ? settings[key]: fallback;
  	  }

  	  const NO_LABEL_STYLES = [{
  	    elementType: "labels",
  	    stylers: [{
  	      visibility: "off"
  	    }]
  	  },
  	    {
  	      featureType: "poi",
  	      stylers: [{
  	        visibility: "off"
  	      }]
  	    },
  	    {
  	      featureType: "transit",
  	      stylers: [{
  	        visibility: "off"
  	      }]
  	    }];

  	  const oldStyle = document.getElementById("fine-track-map-control-css");
  	  if (oldStyle) oldStyle.remove();

  	  const style = document.createElement("style");
  	  style.id = "fine-track-map-control-css";

  	  style.textContent = `
  	  .fine-track-compact-map-control.ces-bottom-shape {
  	  position: absolute !important;
  	  right: 0 !important;
  	  bottom: 0 !important;
  	  top: auto !important;
  	  z-index: 999999 !important;
  	  pointer-events: auto !important;
  	  box-sizing: border-box !important;
  	  color: #fff !important;
  	  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	  background:
  	  radial-gradient(circle at 18% 0%, rgba(255,133,49,0.16), transparent 32%),
  	  linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	  border-top: 1px solid rgba(255,122,36,0.52) !important;
  	  border-left: 1px solid rgba(255,122,36,0.52) !important;
  	  border-right: 0 !important;
  	  border-bottom: 0 !important;
  	  box-shadow:
  	  -12px -16px 32px rgba(0,0,0,0.40),
  	  inset 0 1px 0 rgba(255,255,255,0.045),
  	  inset 0 -18px 38px rgba(0,0,0,0.24) !important;
  	  user-select: none !important;
  	  }

  	  .fine-track-compact-map-control.ces-bottom-shape:not(.collapsed) {
  	  width: 300px !important;
  	  min-width: 300px !important;
  	  max-width: 300px !important;
  	  }

  	  .fine-track-compact-map-control.ces-bottom-shape::before {
  	  content: "" !important;
  	  position: absolute !important;
  	  inset: 0 !important;
  	  pointer-events: none !important;
  	  z-index: 1 !important;
  	  opacity: 0.16 !important;
  	  background:
  	  repeating-radial-gradient(
  	  ellipse at 34% 118%,
  	  transparent 0,
  	  transparent 9px,
  	  rgba(255,116,34,0.20) 10px,
  	  transparent 12px
  	  ) !important;
  	  }

  	  .fine-track-compact-map-control .ces-bottom-content {
  	  position: relative !important;
  	  z-index: 2 !important;
  	  width: 100% !important;
  	  height: auto !important;
  	  padding: 10px 12px 12px 12px !important;
  	  box-sizing: border-box !important;
  	  }

  	  .fine-track-compact-map-control.collapsed .ces-bottom-content {
  	  padding: 9px 12px !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-header {
  	  width: 100% !important;
  	  height: 38px !important;
  	  border: 0 !important;
  	  outline: 0 !important;
  	  background: transparent !important;
  	  color: inherit !important;
  	  display: grid !important;
  	  grid-template-columns: 31px minmax(0, 1fr) 16px !important;
  	  align-items: center !important;
  	  gap: 8px !important;
  	  padding: 0 !important;
  	  margin: 0 !important;
  	  cursor: pointer !important;
  	  text-align: left !important;
  	  appearance: none !important;
  	  -webkit-appearance: none !important;
  	  }

  	  .fine-track-compact-map-control .ces-layer-icon {
  	  width: 30px !important;
  	  height: 30px !important;
  	  border-radius: 12px !important;
  	  display: flex !important;
  	  flex-direction: column !important;
  	  align-items: center !important;
  	  justify-content: center !important;
  	  gap: 3px !important;
  	  background:
  	  radial-gradient(circle at 35% 22%, rgba(255,153,70,0.42), rgba(4,5,5,0.92) 72%) !important;
  	  border: 1px solid rgba(255,132,48,0.54) !important;
  	  box-shadow:
  	  0 0 15px rgba(255,122,36,0.18),
  	  inset 0 1px 0 rgba(255,255,255,0.10) !important;
  	  }

  	  .fine-track-compact-map-control .ces-layer-icon span {
  	  width: 14px !important;
  	  height: 2px !important;
  	  border-radius: 999px !important;
  	  background: #ff9a3d !important;
  	  box-shadow: 0 0 8px rgba(255,122,36,0.34) !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-header-text {
  	  min-width: 0 !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-title {
  	  font-size: 11px !important;
  	  font-weight: 950 !important;
  	  letter-spacing: 0.10em !important;
  	  text-transform: uppercase !important;
  	  color: #ffe3c5 !important;
  	  line-height: 1 !important;
  	  white-space: nowrap !important;
  	  overflow: hidden !important;
  	  text-overflow: ellipsis !important;
  	  margin: 0 !important;
  	  padding: 0 !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-subtitle {
  	  margin: 4px 0 0 !important;
  	  padding: 0 !important;
  	  font-size: 7px !important;
  	  font-weight: 950 !important;
  	  letter-spacing: 0.13em !important;
  	  text-transform: uppercase !important;
  	  color: rgba(255,255,255,0.56) !important;
  	  line-height: 1 !important;
  	  white-space: nowrap !important;
  	  overflow: hidden !important;
  	  text-overflow: ellipsis !important;
  	  }

  	  .fine-track-compact-map-control .ces-caret {
  	  color: #ff8a3c !important;
  	  font-size: 12px !important;
  	  font-weight: 950 !important;
  	  display: flex !important;
  	  align-items: center !important;
  	  justify-content: center !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-body {
  	  display: grid !important;
  	  grid-template-columns: minmax(0, 1fr) 56px !important;
  	  gap: 12px !important;
  	  align-items: start !important;
  	  margin-top: 12px !important;
  	  min-width: 0 !important;
  	  box-sizing: border-box !important;
  	  }

  	  .fine-track-compact-map-control.collapsed .ces-map-control-body {
  	  display: none !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-main {
  	  min-width: 0 !important;
  	  display: flex !important;
  	  flex-direction: column !important;
  	  gap: 12px !important;
  	  box-sizing: border-box !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-section {
  	  display: flex !important;
  	  flex-direction: column !important;
  	  gap: 7px !important;
  	  min-width: 0 !important;
  	  box-sizing: border-box !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-section-title {
  	  height: auto !important;
  	  min-height: 13px !important;
  	  display: flex !important;
  	  align-items: center !important;
  	  gap: 6px !important;
  	  color: rgba(255,232,208,0.78) !important;
  	  font-size: 8px !important;
  	  font-weight: 950 !important;
  	  letter-spacing: 0.12em !important;
  	  text-transform: uppercase !important;
  	  line-height: 1 !important;
  	  padding: 0 !important;
  	  margin: 0 !important;
  	  border: 0 !important;
  	  background: transparent !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-section-title svg {
  	  width: 13px !important;
  	  height: 13px !important;
  	  color: #ff8a3c !important;
  	  flex: 0 0 auto !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-tools {
  	  display: grid !important;
  	  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	  grid-auto-rows: 38px !important;
  	  gap: 7px !important;
  	  min-width: 0 !important;
  	  box-sizing: border-box !important;
  	  }

  	  .fine-track-compact-map-control .fleet-map-type-tools {
  	  grid-template-columns: minmax(0, 1fr) !important;
  	  grid-auto-rows: 38px !important;
  	  }

  	  .fine-track-compact-map-control .fleet-map-type-tools .ces-map-control-tool {
  	  width: 100% !important;
  	  height: 36px !important;
  	  justify-content: flex-start !important;
  	  }

  	  .fine-track-compact-map-control .route-map-tools {
  	  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-tool {
  	  width: auto !important;
  	  height: 36px !important;
  	  min-width: 0 !important;
  	  border-radius: 13px !important;
  	  border: 1px solid rgba(255,255,255,0.10) !important;
  	  background:
  	  linear-gradient(145deg, rgba(255,255,255,0.055), rgba(255,255,255,0.018)) !important;
  	  color: rgba(255,255,255,0.78) !important;
  	  display: flex !important;
  	  align-items: center !important;
  	  justify-content: flex-start !important;
  	  gap: 8px !important;
  	  padding: 0 10px !important;
  	  box-sizing: border-box !important;
  	  cursor: pointer !important;
  	  font-size: 10px !important;
  	  font-weight: 950 !important;
  	  text-align: left !important;
  	  overflow: hidden !important;
  	  box-shadow:
  	  inset 0 0 0 1px rgba(255,255,255,0.025),
  	  0 7px 14px rgba(0,0,0,0.18) !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-tool svg {
  	  width: 14px !important;
  	  height: 14px !important;
  	  color: rgba(255,255,255,0.78) !important;
  	  flex: 0 0 14px !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-tool span {
  	  min-width: 0 !important;
  	  overflow: hidden !important;
  	  text-overflow: ellipsis !important;
  	  white-space: nowrap !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-tool:hover {
  	  color: #fff !important;
  	  border-color: rgba(255,138,61,0.38) !important;
  	  background: rgba(255,138,61,0.10) !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-tool.active,
  	  .fine-track-compact-map-control .ces-map-control-tool.fullscreen-active {
  	  color: #fff !important;
  	  border-color: rgba(255,138,61,0.62) !important;
  	  background:
  	  linear-gradient(145deg, rgba(255,122,36,0.28), rgba(95,42,17,0.32)) !important;
  	  box-shadow:
  	  inset 0 0 0 1px rgba(255,138,61,0.30),
  	  inset 0 0 18px rgba(255,105,25,0.12),
  	  0 7px 14px rgba(0,0,0,0.18) !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-tool.active svg,
  	  .fine-track-compact-map-control .ces-map-control-tool.fullscreen-active svg {
  	  color: #ff9a3d !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-zoom-rail {
  	  width: 56px !important;
  	  min-width: 56px !important;
  	  height: 286px !important;
  	  min-height: 286px !important;
  	  max-height: 286px !important;
  	  display: grid !important;
  	  grid-template-rows: auto auto 32px 176px 32px !important;
  	  justify-items: center !important;
  	  align-items: center !important;
  	  box-sizing: border-box !important;
  	  align-self: start !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-zoom-label {
  	  color: rgba(255,232,208,0.78) !important;
  	  font-size: 8px !important;
  	  font-weight: 950 !important;
  	  letter-spacing: 0.12em !important;
  	  text-transform: uppercase !important;
  	  line-height: 1 !important;
  	  margin: 0 0 6px !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-zoom-value {
  	  width: 36px !important;
  	  height: 36px !important;
  	  border-radius: 999px !important;
  	  display: flex !important;
  	  align-items: center !important;
  	  justify-content: center !important;
  	  background:
  	  radial-gradient(circle at 40% 35%, rgba(255,255,255,0.22), rgba(25,25,25,0.88) 70%) !important;
  	  border: 2px solid rgba(255,122,39,0.68) !important;
  	  color: #fff !important;
  	  font-size: 12px !important;
  	  font-weight: 950 !important;
  	  box-shadow:
  	  0 0 10px rgba(255,105,25,0.24),
  	  inset 0 0 0 1px rgba(255,255,255,0.12) !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-zoom-btn {
  	  width: 32px !important;
  	  height: 32px !important;
  	  border-radius: 999px !important;
  	  border: 1px solid rgba(255,255,255,0.12) !important;
  	  background: rgba(255,255,255,0.045) !important;
  	  color: #fff !important;
  	  cursor: pointer !important;
  	  font-weight: 950 !important;
  	  font-size: 16px !important;
  	  line-height: 1 !important;
  	  padding: 0 !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-zoom-btn:hover {
  	  background: rgba(255,111,29,0.16) !important;
  	  border-color: rgba(255,137,56,0.46) !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-slider-wrap {
  	  position: relative !important;
  	  display: flex !important;
  	  align-items: center !important;
  	  justify-content: center !important;
  	  width: 100% !important;
  	  height: 176px !important;
  	  min-height: 176px !important;
  	  max-height: 176px !important;
  	  margin: 8px 0 !important;
  	  padding: 0 !important;
  	  box-sizing: border-box !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-slider-wrap::before {
  	  content: "" !important;
  	  position: absolute !important;
  	  top: 8px !important;
  	  bottom: 8px !important;
  	  left: 50% !important;
  	  width: 1px !important;
  	  transform: translateX(-50%) !important;
  	  background: repeating-linear-gradient(
  	  to bottom,
  	  rgba(255,255,255,0.18) 0,
  	  rgba(255,255,255,0.18) 1px,
  	  transparent 1px,
  	  transparent 8px
  	  ) !important;
  	  }

  	  .fine-track-compact-map-control .ces-map-control-zoom-slider {
  	  position: relative !important;
  	  z-index: 1 !important;
  	  writing-mode: vertical-lr !important;
  	  direction: rtl !important;
  	  width: 26px !important;
  	  height: 176px !important;
  	  min-height: 176px !important;
  	  max-height: 176px !important;
  	  accent-color: #ff7928 !important;
  	  cursor: pointer !important;
  	  margin: 0 !important;
  	  padding: 0 !important;
  	  appearance: auto !important;
  	  -webkit-appearance: slider-vertical !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-card {
  	  border-radius: 15px !important;
  	  border: 1px solid rgba(255,255,255,0.105) !important;
  	  background:
  	  radial-gradient(circle at 18% 10%, rgba(255,120,35,0.10), transparent 38%),
  	  linear-gradient(145deg, rgba(255,255,255,0.050), rgba(255,255,255,0.018)) !important;
  	  overflow: hidden !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-head {
  	  width: 100% !important;
  	  height: 32px !important;
  	  border: none !important;
  	  outline: none !important;
  	  background: transparent !important;
  	  color: rgba(255,255,255,0.84) !important;
  	  display: flex !important;
  	  align-items: center !important;
  	  gap: 8px !important;
  	  cursor: pointer !important;
  	  padding: 0 10px !important;
  	  box-sizing: border-box !important;
  	  font-size: 10.5px !important;
  	  font-weight: 900 !important;
  	  text-align: left !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-head:hover {
  	  color: #fff !important;
  	  background: rgba(255,111,29,0.12) !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-head svg {
  	  width: 15px !important;
  	  height: 15px !important;
  	  color: #ff7928 !important;
  	  flex: 0 0 15px !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-title {
  	  flex: 1 !important;
  	  white-space: nowrap !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-chevron {
  	  width: 8px !important;
  	  height: 8px !important;
  	  border-top: 2px solid #ff8a3c !important;
  	  border-left: 2px solid #ff8a3c !important;
  	  transform: rotate(45deg) !important;
  	  transition: transform 140ms ease !important;
  	  flex: 0 0 8px !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-card.legend-collapsed .trackit-compact-legend-chevron {
  	  transform: rotate(225deg) !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-body {
  	  display: grid !important;
  	  gap: 6px !important;
  	  padding: 0 9px 9px 9px !important;
  	  max-height: 180px !important;
  	  overflow-y: auto !important;
  	  overflow-x: hidden !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-body::-webkit-scrollbar {
  	  width: 5px !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-body::-webkit-scrollbar-thumb {
  	  background: rgba(255,122,36,0.42) !important;
  	  border-radius: 999px !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-card.legend-collapsed .trackit-compact-legend-body {
  	  display: none !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-row {
  	  display: grid !important;
  	  grid-template-columns: 28px 1fr !important;
  	  align-items: center !important;
  	  gap: 8px !important;
  	  min-height: 26px !important;
  	  padding: 4px 6px !important;
  	  border-radius: 10px !important;
  	  background: rgba(0,0,0,0.18) !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-swatch {
  	  width: 28px !important;
  	  height: 22px !important;
  	  display: flex !important;
  	  align-items: center !important;
  	  justify-content: center !important;
  	  position: relative !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-dot {
  	  width: 12px !important;
  	  height: 12px !important;
  	  border-radius: 50% !important;
  	  border: 1.5px solid #fff !important;
  	  box-shadow: 0 0 8px rgba(0,0,0,0.45) !important;
  	  display: inline-block !important;
  	  box-sizing: border-box !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-dot-label {
  	  position: absolute !important;
  	  top: -7px !important;
  	  left: 50% !important;
  	  transform: translateX(-50%) !important;
  	  font-size: 7px !important;
  	  font-weight: 950 !important;
  	  color: #fff !important;
  	  text-shadow: 0 1px 3px rgba(0,0,0,0.95) !important;
  	  white-space: nowrap !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-line {
  	  width: 24px !important;
  	  height: 5px !important;
  	  border-radius: 999px !important;
  	  background: #e53935 !important;
  	  box-shadow: 0 0 8px rgba(229,57,53,0.65) !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-poly {
  	  width: 22px !important;
  	  height: 16px !important;
  	  border: 2px solid #00bcd4 !important;
  	  background: rgba(0,188,212,0.23) !important;
  	  border-radius: 5px !important;
  	  box-sizing: border-box !important;
  	  position: relative !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-poly::after {
  	  content: "" !important;
  	  position: absolute !important;
  	  right: -5px !important;
  	  bottom: -5px !important;
  	  width: 8px !important;
  	  height: 8px !important;
  	  border-radius: 50% !important;
  	  background: #00bcd4 !important;
  	  border: 1.5px solid #fff !important;
  	  box-sizing: border-box !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-pin {
  	  width: 0 !important;
  	  height: 0 !important;
  	  border-left: 7px solid transparent !important;
  	  border-right: 7px solid transparent !important;
  	  border-bottom: 18px solid #2196F3 !important;
  	  filter: drop-shadow(0 0 5px rgba(0,0,0,0.55)) !important;
  	  position: relative !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-pin::after {
  	  content: "" !important;
  	  position: absolute !important;
  	  left: -4px !important;
  	  top: 9px !important;
  	  width: 8px !important;
  	  height: 8px !important;
  	  border-radius: 50% !important;
  	  background: #fff !important;
  	  opacity: 0.9 !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-fuel svg {
  	  width: 22px !important;
  	  height: 22px !important;
  	  filter: drop-shadow(0 0 5px rgba(0,0,0,0.55)) !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-copy {
  	  min-width: 0 !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-name {
  	  font-size: 10px !important;
  	  font-weight: 950 !important;
  	  color: rgba(255,255,255,0.92) !important;
  	  line-height: 1.1 !important;
  	  }

  	  .fine-track-compact-map-control .trackit-compact-legend-desc {
  	  font-size: 8.5px !important;
  	  color: rgba(255,255,255,0.54) !important;
  	  line-height: 1.2 !important;
  	  margin-top: 2px !important;
  	  }

  	  .gm-svpc {
  	  display: none !important;
  	  opacity: 0 !important;
  	  pointer-events: none !important;
  	  }
  	  `;

  	  document.head.appendChild(style);

  	  let currentMapType = readSetting("mapType", "hybrid") || "hybrid";

  	  if (currentMapType === "satellite") {
  	    currentMapType = "hybrid";
  	    writeSetting("mapType", "hybrid");
  	  }

  	  let collapsed = readSetting("panelCollapsedV8", true);
  	  let labelsOn = readSetting("labelsOn", true);
  	  let legendCollapsed = readSetting("legendCollapsedV1", true);

  	  try {
  	    map.setMapTypeId(currentMapType);
  	  } catch (_) {}

  	  try {
  	    if (map.__trackitTrafficLayer) {
  	      map.__trackitTrafficLayer.setMap(null);
  	      map.__trackitTrafficLayer = null;
  	    }
  	  } catch (_) {}

  	  const control = document.createElement("div");
  	  registerFineTrackElement(map, control);

  	  control.className = "fine-track-compact-map-control ces-bottom-shape";
  	  control.__fineTrackUnifiedMapControl = true;
  	  control.setAttribute("data-fine-track-map-control", "route-snapshot");

  	  if (collapsed) {
  	    control.classList.add("collapsed");
  	  }

  	  const shellContent = document.createElement("div");
  	  shellContent.className = "ces-bottom-content";
  	  shellContent.setAttribute("data-fine-track-new-map-control", "route-snapshot");

  	  const header = document.createElement("button");
  	  header.type = "button";
  	  header.className = "ces-map-control-header";
  	  header.setAttribute("data-fine-track-map-control-toggle", "route-snapshot");

  	  const headerIcon = document.createElement("div");
  	  headerIcon.className = "ces-map-control-header-icon";
  	  headerIcon.innerHTML = `
  	  <div class="ces-layer-icon">
  	  <span></span>
  	  <span></span>
  	  <span></span>
  	  </div>
  	  `;

  	  const headerText = document.createElement("div");
  	  headerText.className = "ces-map-control-header-text";

  	  const title = document.createElement("div");
  	  title.className = "ces-map-title";
  	  title.textContent = "Map Control";

  	  const subtitle = document.createElement("div");
  	  subtitle.className = "ces-map-subtitle";

  	  headerText.appendChild(title);
  	  headerText.appendChild(subtitle);

  	  const collapseIcon = document.createElement("div");
  	  collapseIcon.className = "ces-caret";

  	  header.appendChild(headerIcon);
  	  header.appendChild(headerText);
  	  header.appendChild(collapseIcon);

  	  const body = document.createElement("div");
  	  body.className = "ces-map-control-body";

  	  const main = document.createElement("div");
  	  main.className = "ces-map-control-main";

  	  const mapTypeSection = document.createElement("div");
  	  mapTypeSection.className = "ces-map-control-section";

  	  const typeTabs = document.createElement("div");
  	  typeTabs.className = "ces-map-control-tools fleet-map-type-tools";

  	  const mapTypes = [{
  	    id: "roadmap",
  	    label: "Road",
  	    icon: iconRoadmap()
  	  },
  	    {
  	      id: "hybrid",
  	      label: "Hybrid",
  	      icon: iconLayers()
  	    },
  	    {
  	      id: "terrain",
  	      label: "Terrain",
  	      icon: iconTerrain()
  	    }];

  	  const typeButtons = {};

  	  mapTypes.forEach(type => {
  	    const btn = document.createElement("button");
  	    btn.type = "button";
  	    btn.className = "ces-map-control-tool fleet-map-type-btn";
  	    btn.dataset.mapType = type.id;
  	    btn.innerHTML = `${type.icon}<span>${type.label}</span>`;

  	    btn.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      currentMapType = type.id;

  	      writeSetting("mapType", type.id);
  	      applyMapAppearance();
  	      paintMapTypeButtons();
  	    });

  	    typeButtons[type.id] = btn;
  	    typeTabs.appendChild(btn);
  	  });

  	  mapTypeSection.appendChild(sectionLabel("Map Type", iconLayers()));
  	  mapTypeSection.appendChild(typeTabs);

  	  const toolsSection = document.createElement("div");
  	  toolsSection.className = "ces-map-control-section";

  	  const toolsGrid = document.createElement("div");
  	  toolsGrid.className = "ces-map-control-tools route-map-tools";

  	  const labelsBtn = toolButton("Labels", iconLabel());
  	  const fullscreenBtn = toolButton("Fullscreen", iconFullscreen());

  	  toolsGrid.appendChild(labelsBtn);
  	  toolsGrid.appendChild(fullscreenBtn);

  	  toolsSection.appendChild(sectionLabel("Tools", iconLayers()));
  	  toolsSection.appendChild(toolsGrid);

  	  const legendSection = document.createElement("div");
  	  legendSection.className = "ces-map-control-section trackit-route-legend-section";
  	  legendSection.appendChild(sectionLabel("Route", iconMapLegend()));
  	  legendSection.appendChild(buildMapLegend());

  	  main.appendChild(mapTypeSection);
  	  main.appendChild(toolsSection);
  	  main.appendChild(legendSection);

  	  const zoomPanel = document.createElement("div");
  	  zoomPanel.className = "ces-map-control-zoom-rail";

  	  const zoomTitle = document.createElement("div");
  	  zoomTitle.className = "ces-map-control-zoom-label";
  	  zoomTitle.textContent = "Zoom";

  	  const zoomValue = document.createElement("div");
  	  zoomValue.className = "ces-map-control-zoom-value";

  	  const zoomPlus = document.createElement("button");
  	  zoomPlus.type = "button";
  	  zoomPlus.className = "ces-map-control-zoom-btn";
  	  zoomPlus.textContent = "+";

  	  const sliderWrap = document.createElement("div");
  	  sliderWrap.className = "ces-map-control-slider-wrap";

  	  const zoomSlider = document.createElement("input");
  	  zoomSlider.className = "ces-map-control-zoom-slider";
  	  zoomSlider.type = "range";
  	  zoomSlider.min = "1";
  	  zoomSlider.max = "22";
  	  zoomSlider.step = "1";

  	  const ticks = document.createElement("div");
  	  ticks.className = "ces-map-control-ticks";

  	  sliderWrap.appendChild(zoomSlider);
  	  sliderWrap.appendChild(ticks);

  	  const zoomMinus = document.createElement("button");
  	  zoomMinus.type = "button";
  	  zoomMinus.className = "ces-map-control-zoom-btn";
  	  zoomMinus.textContent = "−";

  	  zoomPanel.appendChild(zoomTitle);
  	  zoomPanel.appendChild(zoomValue);
  	  zoomPanel.appendChild(zoomPlus);
  	  zoomPanel.appendChild(sliderWrap);
  	  zoomPanel.appendChild(zoomMinus);

  	  body.appendChild(main);
  	  body.appendChild(zoomPanel);

  	  shellContent.appendChild(header);
  	  shellContent.appendChild(body);
  	  control.appendChild(shellContent);

  	  ["mousedown",
  	    "dblclick",
  	    "wheel",
  	    "touchstart",
  	    "pointerdown",
  	    "click"].forEach(evtName => {
  	      control.addEventListener(evtName, function (event) {
  	        event.stopPropagation();
  	      }, {
  	        passive: false
  	      });
  	    });

  	  try {
  	    const mapDivForMount = map.getDiv?.();

  	    if (mapDivForMount) {
  	      const computedPosition = window.getComputedStyle?.(mapDivForMount)?.position;

  	      if (!computedPosition || computedPosition === "static") {
  	        mapDivForMount.style.position = "relative";
  	      }

  	      control.style.position = "absolute";
  	      control.style.right = "0";
  	      control.style.bottom = "0";
  	      control.style.margin = "0";
  	      control.style.zIndex = "999999";
  	      control.style.pointerEvents = "auto";

  	      mapDivForMount.appendChild(control);
  	    } else {
  	      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	    }
  	  } catch (error) {
  	    console.warn("[TrackIT Map Controls] Could not mount absolute control. Falling back to Google controls.", error);

  	    try {
  	      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	    } catch (_) {}
  	  }

  	  map.__fineTrackUnifiedMapControlReady = true;
  	  map.__fineTrackUnifiedMapControlVersion = CONTROL_VERSION;

  	  function sectionLabel(text, icon) {
  	    const row = document.createElement("div");
  	    row.className = "ces-map-control-section-title";
  	    row.innerHTML = `
  	    ${icon}
  	    <span>${text}</span>
  	    `;
  	    return row;
  	  }

  	  function toolButton(label, icon) {
  	    const btn = document.createElement("button");
  	    btn.type = "button";
  	    btn.className = "ces-map-control-tool";
  	    btn.innerHTML = `${icon}<span>${label}</span>`;
  	    return btn;
  	  }

  	  function buildMapLegend() {
  	    const card = document.createElement("div");
  	    card.className = "trackit-compact-legend-card";

  	    if (legendCollapsed) {
  	      card.classList.add("legend-collapsed");
  	    }

  	    const head = document.createElement("button");
  	    head.type = "button";
  	    head.className = "trackit-compact-legend-head";

  	    const icon = document.createElement("div");
  	    icon.innerHTML = iconMapLegend();

  	    const title = document.createElement("div");
  	    title.className = "trackit-compact-legend-title";
  	    title.textContent = "Map Legend";

  	    const chevron = document.createElement("div");
  	    chevron.className = "trackit-compact-legend-chevron";

  	    head.appendChild(icon);
  	    head.appendChild(title);
  	    head.appendChild(chevron);

  	    const body = document.createElement("div");
  	    body.className = "trackit-compact-legend-body";

  	    const rows = [{
  	      type: "line",
  	      title: "Route",
  	      desc: "Tracked route line for the trip."
  	    },
  	      {
  	        type: "dotLabel",
  	        color: "#00cc44",
  	        label: "START",
  	        title: "Start",
  	        desc: "First valid tracking point."
  	      },
  	      {
  	        type: "dot",
  	        color: "#cc0000",
  	        title: "Stop",
  	        desc: "Vehicle stopped or parked."
  	      },
  	      {
  	        type: "dot",
  	        color: "#ffcc00",
  	        title: "Idle",
  	        desc: "First point of each idle event."
  	      },
  	      {
  	        type: "dotLabel",
  	        color: "#cc0000",
  	        label: "END",
  	        title: "End",
  	        desc: "Last valid tracking point."
  	      },
  	      {
  	        type: "fuelGain",
  	        title: "Fuel Gain",
  	        desc: "Fuel increased / refuel detected."
  	      },
  	      {
  	        type: "fuelLoss",
  	        title: "Fuel Loss",
  	        desc: "Fuel dropped / loss detected."
  	      },
  	      {
  	        type: "polygon",
  	        title: "Location",
  	        desc: "Saved geofence and entrance point."
  	      },
  	      {
  	        type: "pin",
  	        title: "Selected Point",
  	        desc: "Clicked or hovered track point."
  	      }];

  	    rows.forEach(item => {
  	      body.appendChild(makeLegendRow(item));
  	    });

  	    head.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();

  	      legendCollapsed = !legendCollapsed;
  	      card.classList.toggle("legend-collapsed", legendCollapsed);
  	      writeSetting("legendCollapsedV1", legendCollapsed);
  	      sizeRouteMapControlShell(control, !collapsed);
  	    });

  	    card.appendChild(head);
  	    card.appendChild(body);

  	    return card;
  	  }

  	  function makeLegendRow(item) {
  	    const row = document.createElement("div");
  	    row.className = "trackit-compact-legend-row";

  	    const swatch = makeLegendSwatch(item);

  	    const copy = document.createElement("div");
  	    copy.className = "trackit-compact-legend-copy";

  	    const name = document.createElement("div");
  	    name.className = "trackit-compact-legend-name";
  	    name.textContent = item.title || "";

  	    const desc = document.createElement("div");
  	    desc.className = "trackit-compact-legend-desc";
  	    desc.textContent = item.desc || "";

  	    copy.appendChild(name);
  	    copy.appendChild(desc);

  	    row.appendChild(swatch);
  	    row.appendChild(copy);

  	    return row;
  	  }

  	  function makeLegendSwatch(item) {
  	    const swatch = document.createElement("div");
  	    swatch.className = "trackit-compact-legend-swatch";

  	    if (item.type === "line") {
  	      const line = document.createElement("div");
  	      line.className = "trackit-compact-legend-line";
  	      swatch.appendChild(line);
  	      return swatch;
  	    }

  	    if (item.type === "dot" || item.type === "dotLabel") {
  	      const dot = document.createElement("span");
  	      dot.className = "trackit-compact-legend-dot";
  	      dot.style.background = item.color || "#ffcc00";

  	      swatch.appendChild(dot);

  	      if (item.label) {
  	        const label = document.createElement("span");
  	        label.className = "trackit-compact-legend-dot-label";
  	        label.textContent = item.label;
  	        swatch.appendChild(label);
  	      }

  	      return swatch;
  	    }

  	    if (item.type === "fuelGain") {
  	      swatch.classList.add("trackit-compact-legend-fuel");
  	      swatch.innerHTML = legendJerryCanSvg("#00cc44");
  	      return swatch;
  	    }

  	    if (item.type === "fuelLoss") {
  	      swatch.classList.add("trackit-compact-legend-fuel");
  	      swatch.innerHTML = legendJerryCanSvg("#ff3b30");
  	      return swatch;
  	    }

  	    if (item.type === "polygon") {
  	      const poly = document.createElement("div");
  	      poly.className = "trackit-compact-legend-poly";
  	      swatch.appendChild(poly);
  	      return swatch;
  	    }

  	    if (item.type === "pin") {
  	      const pin = document.createElement("div");
  	      pin.className = "trackit-compact-legend-pin";
  	      swatch.appendChild(pin);
  	      return swatch;
  	    }

  	    return swatch;
  	  }

  	  function legendJerryCanSvg(color) {
  	    const safeColor = color || "#ff7928";

  	    return `
  	    <svg viewBox="0 0 32 32" aria-hidden="true">
  	    <path
  	    d="M9 4h9l5 5v18a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
  	    fill="${safeColor}"
  	    stroke="#fff"
  	    stroke-width="1.7"
  	    stroke-linejoin="round"
  	    />
  	    <path
  	    d="M18 4v6h6"
  	    fill="none"
  	    stroke="#fff"
  	    stroke-width="1.7"
  	    stroke-linecap="round"
  	    stroke-linejoin="round"
  	    />
  	    <path
  	    d="M12 9h5"
  	    stroke="rgba(0,0,0,0.45)"
  	    stroke-width="2"
  	    stroke-linecap="round"
  	    />
  	    <path
  	    d="M12 16c2.7-3.8 5.5-3.8 8.2 0-1 4.6-7.2 4.6-8.2 0Z"
  	    fill="rgba(0,0,0,0.32)"
  	    />
  	    </svg>
  	    `;
  	  }

  	  function iconMapLegend() {
  	    return svgBase(`
  	      <path d="M4 6h16"/>
  	      <path d="M4 12h16"/>
  	      <path d="M4 18h16"/>
  	      <circle cx="7" cy="6" r="1.6"/>
  	      <circle cx="7" cy="12" r="1.6"/>
  	      <circle cx="7" cy="18" r="1.6"/>
  	      `);
  	  }

  	  function sizeRouteMapControlShell(control, isOpen) {
  	    if (!control) return;

  	    function setStyle(element, property, value) {
  	      try {
  	        element.style.setProperty(property, value, "important");
  	      } catch (_) {
  	        try {
  	          element.style[property] = value;
  	        } catch (_) {}
  	      }
  	    }

  	    const content = control.querySelector(".ces-bottom-content");

  	    const viewportHeight =
  	    typeof window !== "undefined" && window.innerHeight
  	    ? window.innerHeight: 900;

  	    const maxHeight = Math.max(360, viewportHeight - 24);
  	    const closedHeight = 56;
  	    const closedWidth = 200;
  	    const openWidth = 300;

  	    if (!isOpen) {
  	      setStyle(control, "width", `${closedWidth}px`);
  	      setStyle(control, "height", `${closedHeight}px`);
  	      setStyle(control, "min-height", `${closedHeight}px`);
  	      setStyle(control, "max-height", `${closedHeight}px`);
  	      setStyle(control, "overflow", "hidden");
  	      setStyle(control, "right", "0");
  	      setStyle(control, "bottom", "0");
  	      setStyle(control, "top", "auto");
  	      setStyle(control, "border-radius", "22px 0 0 0");

  	      if (content) {
  	        setStyle(content, "max-height", `${closedHeight}px`);
  	        setStyle(content, "overflow", "hidden");
  	        setStyle(content, "overflow-x", "hidden");
  	        setStyle(content, "overflow-y", "hidden");
  	      }

  	      return;
  	    }

  	    if (content) {
  	      setStyle(content, "max-height", "none");
  	      setStyle(content, "overflow", "visible");
  	      setStyle(content, "overflow-x", "hidden");
  	      setStyle(content, "overflow-y", "visible");
  	    }

  	    const contentHeight = content ? Math.ceil(content.scrollHeight): 0;
  	    const wantedHeight = Math.max(320, contentHeight + 2);
  	    const finalHeight = Math.min(wantedHeight, maxHeight);

  	    setStyle(control, "width", `${openWidth}px`);
  	    setStyle(control, "height", `${finalHeight}px`);
  	    setStyle(control, "min-height", `${finalHeight}px`);
  	    setStyle(control, "max-height", `${maxHeight}px`);
  	    setStyle(control, "overflow", "hidden");
  	    setStyle(control, "right", "0");
  	    setStyle(control, "bottom", "0");
  	    setStyle(control, "top", "auto");
  	    setStyle(control, "border-radius", "24px 0 0 0");

  	    if (content) {
  	      setStyle(content, "max-height", `${finalHeight}px`);
  	      setStyle(content, "overflow-x", "hidden");
  	      setStyle(content, "overflow-y", wantedHeight > maxHeight ? "auto": "visible");
  	    }
  	  }

  	  function applyMapAppearance() {
  	    let effectiveType = currentMapType;

  	    /*
  	     * Hybrid is satellite imagery with Google labels.
  	     * Satellite is the same imagery without those labels.
  	     */
  	    if (currentMapType === "hybrid") {
  	      effectiveType = labelsOn ? "hybrid": "satellite";
  	    }

  	    try {
  	      map.setMapTypeId(effectiveType);
  	    } catch (_) {}

  	    try {
  	      if (
  	        currentMapType === "roadmap" ||
  	        currentMapType === "terrain"
  	      ) {
  	        map.setOptions({
  	          styles: labelsOn ? []: NO_LABEL_STYLES
  	        });
  	      } else {
  	        // Clear styles left by Fine Track before using hybrid/satellite.
  	        map.setOptions({
  	          styles: []
  	        });
  	      }
  	    } catch (_) {}

  	    updateHeaderState();
  	  }

  	  function paintMapTypeButtons() {
  	    Object.keys(typeButtons).forEach(key => {
  	      typeButtons[key].classList.toggle("active", key === currentMapType);
  	    });
  	  }

  	  function updateZoomUi() {
  	    const z = map.getZoom() || 1;

  	    zoomSlider.value = String(z);
  	    zoomValue.textContent = String(z);

  	    writeSetting("zoom", z);
  	  }

  	  function updateHeaderState() {
  	    collapseIcon.textContent = collapsed ? "⌄": "⌃";
  	    subtitle.textContent = labelsOn ? "Labels On": "Labels Off";
  	  }

  	  function paintToggleButtons() {
  	    labelsBtn.classList.toggle("active", !!labelsOn);
  	    paintFullscreenState();
  	    updateHeaderState();
  	  }

  	  function isFullscreenActive() {
  	    const mapDiv = map.getDiv();
  	    const fs = document.fullscreenElement || document.webkitFullscreenElement || null;

  	    return !!fs && (fs === mapDiv || fs.contains(mapDiv));
  	  }

  	  function paintFullscreenState() {
  	    fullscreenBtn.classList.toggle("active", isFullscreenActive());
  	    fullscreenBtn.classList.toggle("fullscreen-active", isFullscreenActive());
  	  }

  	  function toggleFullscreen() {
  	    const mapDiv = map.getDiv();

  	    try {
  	      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
  	        if (mapDiv.requestFullscreen) mapDiv.requestFullscreen();
  	        else if (mapDiv.webkitRequestFullscreen) mapDiv.webkitRequestFullscreen();
  	      } else {
  	        if (document.exitFullscreen) document.exitFullscreen();
  	        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
  	      }
  	    } catch (e) {
  	      console.warn("[TrackIT Map Controls] Fullscreen failed:", e);
  	    }

  	    setTimeout(paintFullscreenState, 150);
  	  }

  	  header.addEventListener("click", function (event) {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    collapsed = !collapsed;

  	    control.classList.toggle("collapsed", collapsed);
  	    updateHeaderState();
  	    sizeRouteMapControlShell(control, !collapsed);
  	    writeSetting("panelCollapsedV8", collapsed);
  	  });

  	  zoomPlus.addEventListener("click", function (event) {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    const z = map.getZoom() || 1;
  	    map.setZoom(Math.min(22, z + 1));
  	  });

  	  zoomMinus.addEventListener("click", function (event) {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    const z = map.getZoom() || 1;
  	    map.setZoom(Math.max(1, z - 1));
  	  });

  	  zoomSlider.addEventListener("input", function (event) {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    map.setZoom(Number(zoomSlider.value));
  	  });

  	  labelsBtn.addEventListener("click", function (event) {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    labelsOn = !labelsOn;

  	    writeSetting("labelsOn", labelsOn);
  	    applyMapAppearance();
  	    paintToggleButtons();
  	  });

  	  fullscreenBtn.addEventListener("click", function (event) {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    toggleFullscreen();
  	  });

  	  map.__fineTrackMapControlListeners.push(
  	    map.addListener("zoom_changed", updateZoomUi)
  	  );

  	  map.__fineTrackMapControlListeners.push(
  	    map.addListener("maptypeid_changed", function () {
  	      paintMapTypeButtons();
  	    })
  	  );

  	  const fullscreenHandler = function () {
  	    paintFullscreenState();
  	  };

  	  document.addEventListener("fullscreenchange", fullscreenHandler);
  	  document.addEventListener("webkitfullscreenchange", fullscreenHandler);

  	  map.__fineTrackDomControlListeners.push({
  	    target: document,
  	    event: "fullscreenchange",
  	    handler: fullscreenHandler
  	  });

  	  map.__fineTrackDomControlListeners.push({
  	    target: document,
  	    event: "webkitfullscreenchange",
  	    handler: fullscreenHandler
  	  });

  	  const resizeHandler = function () {
  	    sizeRouteMapControlShell(control, !collapsed);
  	  };

  	  if (typeof window !== "undefined") {
  	    window.addEventListener("resize", resizeHandler);
  	    map.__fineTrackDomControlListeners.push({
  	      target: window,
  	      event: "resize",
  	      handler: resizeHandler
  	    });
  	  }

  	  const savedZoom = readSetting("zoom", null);

  	  if (savedZoom !== null && savedZoom !== undefined) {
  	    try {
  	      map.setZoom(Number(savedZoom));
  	    } catch (_) {}
  	  }

  	  applyMapAppearance();
  	  updateZoomUi();
  	  updateHeaderState();
  	  sizeRouteMapControlShell(control, !collapsed);
  	  paintMapTypeButtons();
  	  paintToggleButtons();
  	  sizeRouteMapControlShell(control, !collapsed);

  	  function svgBase(paths) {
  	    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
  	  }

  	  function iconLayers() {
  	    return svgBase(`
  	      <path d="M12 3 3 8l9 5 9-5-9-5Z"/>
  	      <path d="M3 12l9 5 9-5"/>
  	      <path d="M3 16l9 5 9-5"/>
  	      `);
  	  }

  	  function iconRoadmap() {
  	    return svgBase(`
  	      <path d="M4 18V6l5-2 6 2 5-2v12l-5 2-6-2-5 2Z"/>
  	      <path d="M9 4v12"/>
  	      <path d="M15 6v12"/>
  	      <path d="M12 9h.01"/>
  	      <path d="M17 11h.01"/>
  	      `);
  	  }

  	  function iconSatellite() {
  	    return svgBase(`
  	      <path d="m6 14 4 4"/>
  	      <path d="m14 6 4 4"/>
  	      <path d="m8 16 8-8"/>
  	      <rect x="12" y="3" width="7" height="5" rx="1" transform="rotate(45 12 3)"/>
  	      <rect x="4" y="13" width="7" height="5" rx="1" transform="rotate(45 4 13)"/>
  	      <path d="M17 17c1.5-1.5 2-3.5 1.2-5.2"/>
  	      <path d="M20 20c2.5-2.5 3-6 1.4-8.8"/>
  	      `);
  	  }

  	  function iconTerrain() {
  	    return svgBase(`
  	      <path d="m3 18 6-10 4 6 3-5 5 9H3Z"/>
  	      <path d="m8.5 12 2 2"/>
  	      <path d="m15.5 13 2 2"/>
  	      `);
  	  }

  	  function iconTraffic() {
  	    return svgBase(`
  	      <path d="M6 16h12"/>
  	      <path d="M7 16v3"/>
  	      <path d="M17 16v3"/>
  	      <path d="M7 13l1.5-5h7L17 13"/>
  	      <path d="M8 13h8"/>
  	      <circle cx="8.5" cy="16" r="1"/>
  	      <circle cx="15.5" cy="16" r="1"/>
  	      `);
  	  }

  	  function iconFullscreen() {
  	    return svgBase(`
  	      <path d="M8 3H3v5"/>
  	      <path d="M16 3h5v5"/>
  	      <path d="M8 21H3v-5"/>
  	      <path d="M16 21h5v-5"/>
  	      `);
  	  }

  	  function iconLabel() {
  	    return svgBase(`
  	      <path d="M5 5h14v14H5z"/>
  	      <path d="M8 9h8"/>
  	      <path d="M8 12h6"/>
  	      <path d="M8 15h4"/>
  	      `);
  	  }
  	}

  	(function polylineTrackSnapshot(args) {
  	  const {
  	    googleMapComponent, App, Locations, Images, Hub, SVG
  	  } = args || {};

  	  const TrackitReportLogo =
  	  args?.SVG ||
  	  SVG ||
  	  args?.Images?.Logo ||
  	  args?.Images?.ReportLogo ||
  	  args?.Images?.logo ||
  	  args?.Images?.reportLogo ||
  	  args?.App?.ReportLogo ||
  	  args?.App?.reportLogo ||
  	  args?.App?.Logo ||
  	  args?.App?.logo ||
  	  args?.App?.data?.ReportLogo ||
  	  args?.App?.data?.reportLogo ||
  	  args?.App?.data?.Logo ||
  	  args?.App?.data?.logo ||
  	  "";
  	  const map = googleMapComponent?.map?.map;
  	  if (!map) return;

  	  /*
  	   * Fine Track can reuse the same Google Map instance as Live Track.
  	   * Always restore normal interaction and clear stale label-hiding styles
  	   * before rebuilding Fine Track.
  	   */
  	  try {
  	    map.setOptions({
  	      draggable: true,
  	      scrollwheel: true,
  	      disableDoubleClickZoom: false,
  	      keyboardShortcuts: true,
  	      gestureHandling: "auto",
  	      clickableIcons: true,
  	      styles: []
  	    });

  	    map.__fineTrackRoutePanelMapLocked = false;

  	    const mapElement = map.getDiv?.();
  	    if (mapElement?.style) {
  	      mapElement.style.cursor = "";
  	    }
  	  } catch (error) {
  	    console.warn("[Fine Track] Could not restore map interaction:", error);
  	  }

  	  // Add Fine Track map controls immediately after map is available.
  	  // This must run before the tractor/path guards so the controls still appear
  	  // even when there is no selected tractor or no tracking data.
  	  try {
  	    addFineTrackUnifiedMapControl(map, App);
  	  } catch (e) {
  	    console.warn("[Fine Track Map Controls] Failed to load:", e);
  	  }

  	  const tractor = App?.SelectedTractor;
  	  if (!tractor || !Array.isArray(tractor.Tracking)) return;

  	  // ---------- Path ----------
  	  const path = tractor.Tracking.map((p, idx) => {
  	    const lat = p["position.latitude"];
  	    const lng = p["position.longitude"];
  	    return lat != null && lng != null ? {
  	      lat, lng, raw: p, idx
  	    }: null;
  	  }).filter(Boolean);
  	  if (!path.length) return;


  	  // ---------- Utils ----------
  	  const toRad = x => (x * Math.PI) / 180;

  	  const smartFuelConsumed = (r) => {
  	    if (!r || typeof r !== "object") return null;
  	    const keys = [
  	      "can.tracker.counted.fuel.consumed",
  	      "can.fuel.consumed",
  	      "can.fuel.used",
  	      "can.fuel.liters",
  	      "gps.fuel.used"
  	    ];
  	    for (const k of keys) {
  	      const v = Number(r[k]);
  	      if (Number.isFinite(v)) return v;
  	    }
  	    return null;
  	  };



  	  const smartOdoKm = (r) => {
  	    if (!r || typeof r !== "object") return null;
  	    const keys = [
  	      "vehicle.mileage",
  	      "can.vehicle.mileage",
  	      "can.tracker.counted.mileage",
  	      "gps.odometer",
  	      "gps.mileage"
  	    ];
  	    for (const k of keys) {
  	      const v = Number(r[k]);
  	      if (Number.isFinite(v)) return v;
  	    }
  	    return null;
  	  };

  	  const smartFuelPct = (raw, tankCap) => {
  	    let pct = Number(raw?.["can.fuel.level"]);
  	    if (Number.isFinite(pct) && pct >= 0 && pct <= 100) return pct;

  	    const vol = Number(raw?.["can.fuel.volume"]);
  	    if (Number.isFinite(vol) && Number.isFinite(tankCap) && tankCap > 0) {
  	      const p = (vol / tankCap) * 100;
  	      return Math.min(100, Math.max(0, p));
  	    }

  	    return null;
  	  };

  	  const calcFuelUsedBest = (startRaw, endRaw, tankCap) => {
  	    const fStart = smartFuelConsumed(startRaw);
  	    const fEnd = smartFuelConsumed(endRaw);

  	    let fuelByConsumed =
  	    (Number.isFinite(fStart) && Number.isFinite(fEnd))
  	    ? (fEnd - fStart): null;

  	    const lvlStart = smartFuelPct(startRaw, tankCap);
  	    const lvlEnd = smartFuelPct(endRaw, tankCap);

  	    let fuelByLevel =
  	    (Number.isFinite(lvlStart) && Number.isFinite(lvlEnd) && Number.isFinite(tankCap) && tankCap > 0)
  	    ? ((lvlStart - lvlEnd) / 100) * tankCap: null;

  	    // Normalize
  	    if (fuelByConsumed != null && fuelByConsumed <= 0) fuelByConsumed = null;
  	    if (fuelByLevel != null && fuelByLevel <= 0) fuelByLevel = null;

  	    // Scale-detect consumed using level as reference
  	    if (fuelByConsumed != null && fuelByLevel != null) {
  	      const ratio = fuelByLevel / fuelByConsumed;

  	      if (ratio > 8 && ratio < 12) {
  	        fuelByConsumed = fuelByConsumed * 10;
  	      } else if (ratio > 80 && ratio < 120) {
  	        fuelByConsumed = fuelByConsumed * 100;
  	      }
  	    }

  	    // Choose
  	    if (fuelByConsumed != null && fuelByLevel != null) {
  	      const diff = Math.abs(fuelByConsumed - fuelByLevel);
  	      const rel = diff / fuelByLevel;

  	      if (rel <= 0.35) return {
  	        fuelUsedL: fuelByConsumed,
  	        method: "CAN(consumed)"
  	      };
  	      return {
  	        fuelUsedL: fuelByLevel,
  	        method: "CAN(level)"
  	      };
  	    }

  	    if (fuelByConsumed != null) return {
  	      fuelUsedL: fuelByConsumed,
  	      method: "CAN(consumed)"
  	    };
  	    if (fuelByLevel != null) return {
  	      fuelUsedL: fuelByLevel,
  	      method: "CAN(level)"
  	    };

  	    return {
  	      fuelUsedL: null,
  	      method: "—"
  	    };
  	  };

  	  const haversineM = (a, b) => {
  	    const R = 6371000;
  	    const dLat = toRad(b.lat - a.lat);
  	    const dLon = toRad(b.lng - a.lng);
  	    const sLat = Math.sin(dLat / 2);
  	    const sLon = Math.sin(dLon / 2);
  	    const cLatA = Math.cos(toRad(a.lat));
  	    const cLatB = Math.cos(toRad(b.lat));
  	    const aVal = sLat * sLat + cLatA * cLatB * sLon * sLon;
  	    return 2 * R * Math.atan2(Math.sqrt(aVal), Math.sqrt(1 - aVal));
  	  };

  	  const degToCompass = deg =>
  	  ["N",
  	    "NNE",
  	    "NE",
  	    "ENE",
  	    "E",
  	    "ESE",
  	    "SE",
  	    "SSE",
  	    "S",
  	    "SSW",
  	    "SW",
  	    "WSW",
  	    "W",
  	    "WNW",
  	    "NW",
  	    "NNW"]
  	  [Math.floor(((+deg || 0)+11.25)/22.5)%16];
  	  const fmt = (v, u = "", d = 0)=>Number.isFinite(+v)?`${(+v).toFixed(d)}${u}`: "—";
  	  const mixColors = (c1, c2, w = 0.5)=> {
  	    if (!c1||!c2)return c1 || c2 || "#FFFF00";
  	    const h = h=>parseInt(h, 16);
  	    const r = Math.round(h(c1.slice(1, 3))*(1-w)+h(c2.slice(1, 3))*w);
  	    const g = Math.round(h(c1.slice(3, 5))*(1-w)+h(c2.slice(3, 5))*w);
  	    const b = Math.round(h(c1.slice(5, 7))*(1-w)+h(c2.slice(5, 7))*w);
  	    return`#${[r,
  	      g,
  	      b].map(x => x.toString(16).padStart(2, "0")).join("")}`;
  	  };

  	  // ---------- Timestamp parser (auto ms/seconds) ----------
  	  const parseTs = raw => {
  	    let t = raw?.timestamp;
  	    if (t == null) return null;
  	    if (typeof t === "number" && Number.isFinite(t)) return t < 1e12 ? t * 1000: t;
  	    if (typeof t === "string") {
  	      const n = Number(t);
  	      if (Number.isFinite(n)) return n < 1e12 ? n * 1000: n;
  	      const d = Date.parse(t);
  	      if (Number.isFinite(d)) return d;
  	    }
  	    return null;
  	  };

  	  const sumDistanceM = pts => {
  	    let s = 0;
  	    for (let i = 1; i < pts.length; i++) s += haversineM(pts[i-1], pts[i]);
  	    return s;
  	  };

  	  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

  	  // --- Baseline (stable) consumption from CAN file ---
  	  // Supports both old + new key names
  	  const getBaselineKmPerL = () => {
  	    const raw =
  	    tractor?.CAN?.["ConsumptionAverage(km/L)"] ??
  	    tractor?.CAN?.["ConsumptionAverage(km/l)"];

  	    const v = Number(raw);
  	    if (!Number.isFinite(v) || v <= 0) return null;

  	    // Sanity clamp (adjust if needed for your fleet)
  	    return clamp(v, 0.2, 50);
  	  };

  	  // Estimate km/L near a given point using a trailing window (time OR distance)
  	  const estimateKmPerLWindow = (endIdx, tankCap) => {

  	    if (!Number.isFinite(endIdx) || endIdx < 0) return {
  	      kmPerL: null,
  	      method: "—"
  	    };

  	    const endPt = path[endIdx];
  	    const tEnd = parseTs(endPt?.raw);
  	    if (!endPt || !Number.isFinite(tEnd)) return {
  	      kmPerL: null,
  	      method: "—"
  	    };

  	    // Window targets (tweak if you want)
  	    const maxMinutes = 15; // trailing time window
  	    const maxDistKm = 4; // OR trailing distance window
  	    const maxPointsBack = 250; // cap scan cost

  	    let startIdx = endIdx;
  	    let distM = 0;
  	    let scanned = 0;

  	    // Walk backwards until we satisfy either distance or time window
  	    while (startIdx > 0 && scanned < maxPointsBack) {
  	      const prev = path[startIdx - 1];
  	      const cur = path[startIdx];

  	      const tPrev = parseTs(prev?.raw);
  	      if (!Number.isFinite(tPrev)) break;

  	      distM += haversineM(prev, cur);
  	      const minutes = (tEnd - tPrev) / 60000;

  	      startIdx--;

  	      if (distM >= maxDistKm * 1000) break;
  	      if (minutes >= maxMinutes) break;

  	      scanned++;
  	    }

  	    const startPt = path[startIdx];
  	    if (!startPt) return {
  	      kmPerL: null,
  	      method: "—"
  	    };

  	    // Build window points for along-path distance (more realistic than straight-line)
  	    const windowPts = path.slice(startIdx, endIdx + 1);
  	    const alongKm = windowPts.length >= 2 ? (sumDistanceM(windowPts) / 1000): 0;

  	    // Need meaningful movement
  	    if (alongKm < 0.25) return {
  	      kmPerL: null,
  	      method: "—"
  	    };

  	    const fu = calcFuelUsedBest(startPt.raw, endPt.raw, tankCap);
  	    const fuelUsed = fu.fuelUsedL;

  	    // Reject tiny / nonsense fuel used
  	    if (!(fuelUsed != null && fuelUsed > 0.15)) return {
  	      kmPerL: null,
  	      method: "—"
  	    };

  	    let kmPerL = alongKm / fuelUsed;

  	    // Clamp to sane range to prevent spikes from tiny denominators
  	    kmPerL = clamp(kmPerL, 0.5, 25);

  	    return {
  	      kmPerL,
  	      method: `Window (${fu.method})`
  	    };
  	  };


  	  const hms = ms => {
  	    if (!Number.isFinite(ms) || ms < 0) return "—";
  	    const s = Math.floor(ms / 1000);
  	    const hh = Math.floor(s / 3600);
  	    const mm = Math.floor((s % 3600) / 60);
  	    const ss = s % 60;
  	    return `${hh}:${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
  	  };

  	  // ---------- Time Formatter ----------
  	  const fmtTime = ts => {
  	    const t = parseTs({
  	      timestamp: ts
  	    });
  	    if (!t) return "—";
  	    const d = new Date(t);
  	    return d.toLocaleString("en-ZA", {
  	      year: "numeric", month: "short", day: "2-digit",
  	      hour: "2-digit", minute: "2-digit", second: "2-digit"
  	    });
  	  };

  	  // ---------- State ----------
  	  let isClickLocked = false,
  	  hoverPaused = false;
  	  let activeInfo = null,
  	  hoverMarker = null;
  	  const trackMarkers = [];
  	  const compareState = {
  	    active: false,
  	    pointA: null,
  	    pointB: null,
  	    markerB: null,
  	    sectionId: null
  	  };

  	  function applyCompareMarkerLabel(marker, label) {
  	    if (!marker || !label) return;

  	    try {
  	      const currentIcon = marker.getIcon?.();

  	      if (currentIcon && typeof currentIcon === "object") {
  	        marker.setIcon({
  	          ...currentIcon,
  	          labelOrigin: new google.maps.Point(18, -26)
  	        });
  	      }

  	      marker.setLabel({
  	        text: String(label),
  	        color: "#fff",
  	        fontSize: "26px",
  	        fontWeight: "950",
  	        className: "trackit-compare-marker-label"
  	      });

  	      marker.setZIndex(label === "A" ? 2100: 2200);
  	    } catch (e) {
  	      console.warn("[TrackIT Compare] Failed to label marker:", e);
  	    }
  	  }

  	  function startCompareFromPoint(point, button, section) {
  	    if (!point) return;

  	    if (button) {
  	      button.disabled = true;
  	      button.textContent = "Select second point…";
  	      button.style.opacity = "0.75";
  	      button.style.cursor = "default";
  	    }

  	    if (section) {
  	      section.style.display = "block";
  	      section.innerHTML = `<div style="color:#aaa;font-size:13px;">Awaiting Point B...</div>`;
  	    }

  	    compareState.active = true;
  	    compareState.pointA = point;
  	    compareState.pointB = null;
  	    compareState.sectionId = section?.id || null;

  	    if (App.FineTrackSelectedMarker?.setMap) {
  	      App.FineTrackSelectedMarker.setPosition({
  	        lat: point.lat,
  	        lng: point.lng
  	      });

  	      App.FineTrackSelectedMarker.setMap(map);
  	      applyCompareMarkerLabel(App.FineTrackSelectedMarker, "A");
  	    }

  	    unlockRouteMapForCompare();
  	  };
  	  // ---------- TrackIT Sacred Button Helpers ----------
  	  function applyTrackitIconButtonStyle(btn) {
  	    Object.assign(btn.style, {
  	      width: "40px",
  	      height: "40px",
  	      minWidth: "40px",
  	      maxWidth: "40px",
  	      minHeight: "40px",
  	      maxHeight: "40px",
  	      borderRadius: "15px",
  	      border: "none",
  	      background: "transparent",
  	      color: "#fff",
  	      display: "flex",
  	      alignItems: "center",
  	      justifyContent: "center",
  	      padding: "0",
  	      margin: "0",
  	      cursor: "pointer",
  	      lineHeight: "1",
  	      boxSizing: "border-box",
  	      transition: "box-shadow 0.18s ease",
  	      WebkitUserSelect: "none",
  	      MozUserSelect: "none",
  	      msUserSelect: "none",
  	      userSelect: "none",
  	      WebkitUserDrag: "none",
  	      userDrag: "none",
  	      pointerEvents: "auto",
  	      outline: "none"
  	    });

  	    btn.onmouseenter = () => {
  	      btn.style.background = "transparent";
  	      btn.style.color = "#fff";
  	      btn.style.boxShadow = `
  	      0 0 0 2px rgba(204,102,51,0.45),
  	      0 0 12px rgba(204,102,51,0.72),
  	      0 0 24px rgba(204,102,51,0.38)
  	      `;
  	    };

  	    btn.onmouseleave = () => {
  	      btn.style.background = "transparent";
  	      btn.style.color = "#fff";
  	      btn.style.boxShadow = "none";
  	    };

  	    btn.onmousedown = () => {
  	      btn.style.background = "transparent";
  	      btn.style.color = "#fff";
  	      btn.style.boxShadow = `
  	      0 0 0 2px rgba(204,102,51,0.65),
  	      0 0 10px rgba(204,102,51,0.85)
  	      `;
  	    };

  	    btn.onmouseup = () => {
  	      btn.style.background = "transparent";
  	      btn.style.color = "#fff";
  	      btn.style.boxShadow = `
  	      0 0 0 2px rgba(204,102,51,0.45),
  	      0 0 12px rgba(204,102,51,0.72),
  	      0 0 24px rgba(204,102,51,0.38)
  	      `;
  	    };

  	    btn.onfocus = () => {
  	      btn.style.background = "transparent";
  	      btn.style.color = "#fff";
  	      btn.style.boxShadow = `
  	      0 0 0 2px rgba(204,102,51,0.45),
  	      0 0 12px rgba(204,102,51,0.72),
  	      0 0 24px rgba(204,102,51,0.38)
  	      `;
  	    };

  	    btn.onblur = () => {
  	      btn.style.background = "transparent";
  	      btn.style.color = "#fff";
  	      btn.style.boxShadow = "none";
  	    };
  	  }

  	  function trackitPrinterIconSvg() {
  	    return `
  	    <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"
  	    fill="currentColor">
  	    <path d="M7 3h10a1 1 0 0 1 1 1v4H6V4a1 1 0 0 1 1-1Z"></path>
  	    <path d="M6 16H5a3 3 0 0 1-3-3v-3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-1v-4H6v4Z"></path>
  	    <path d="M7 13h10v8H7v-8Z"></path>
  	    <path d="M9 15h6v1.5H9V15Z" fill="rgba(0,0,0,0.45)"></path>
  	    <path d="M9 18h6v1.5H9V18Z" fill="rgba(0,0,0,0.45)"></path>
  	    </svg>
  	    `;
  	  }

  	  function normalizeTrackitPanelBodyContent(body) {
  	    if (!body) return;

  	    Object.assign(body.style, {
  	      width: "100%",
  	      maxWidth: "none",
  	      padding: "10px",
  	      margin: "0",
  	      boxSizing: "border-box",
  	      overflowX: "hidden"
  	    });

  	    const root =
  	    body.querySelector("#popupRoot") ||
  	    body.querySelector("[data-trackit-panel-card='true']") ||
  	    body.querySelector("div[style*='max-width']") ||
  	    body.firstElementChild;

  	    if (root && root.style) {
  	      root.style.width = "100%";
  	      root.style.maxWidth = "none";
  	      root.style.minWidth = "0";
  	      root.style.margin = "0";
  	      root.style.boxSizing = "border-box";
  	    }
  	  }

  	  function trackitCloseIconSvg() {
  	    return `
  	    <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"
  	    fill="none" stroke="currentColor" stroke-width="3"
  	    stroke-linecap="round" stroke-linejoin="round">
  	    <path d="M6 6l12 12"></path>
  	    <path d="M18 6L6 18"></path>
  	    </svg>
  	    `;
  	  }

  	  // ---------- Temporary Map Lock while side panel is open ----------
  	  let routePanelMapLocked = false;

  	  function setRoutePanelMapLocked(locked) {
  	    routePanelMapLocked = !!locked;
  	    map.__fineTrackRoutePanelMapLocked = routePanelMapLocked;

  	    try {
  	      if (routePanelMapLocked) {
  	        // Stop map movement while the side details panel is open.
  	        map.setOptions({
  	          draggable: false,
  	          scrollwheel: false,
  	          disableDoubleClickZoom: true,
  	          keyboardShortcuts: false,
  	          gestureHandling: "none"
  	        });

  	        map.getDiv().style.cursor = "default";
  	      } else {
  	        // Restore map movement.
  	        map.setOptions({
  	          draggable: true,
  	          scrollwheel: true,
  	          disableDoubleClickZoom: false,
  	          keyboardShortcuts: true,
  	          gestureHandling: "auto"
  	        });

  	        map.getDiv().style.cursor = "";
  	      }
  	    } catch (e) {
  	      console.warn("[TrackIT Route] Map lock failed:", e);
  	    }
  	  }

  	  function lockRouteMapForPanel() {
  	    // Do not lock while selecting the second comparison point.
  	    if (compareState.active) return;

  	    setRoutePanelMapLocked(true);
  	  }

  	  function unlockRouteMapForCompare() {
  	    setRoutePanelMapLocked(false);
  	  }

  	  function unlockRouteMapFromPanelClose() {
  	    setRoutePanelMapLocked(false);
  	  }

  	  // ---------- Clear Popups / Hover Markers ----------
  	  const clearPopup = () => {
  	    setRoutePanelMapLocked(false);
  	    // Remove hover marker
  	    if (hoverMarker?.setMap) hoverMarker.setMap(null);
  	    hoverMarker = null;

  	    // Close active info window
  	    if (activeInfo?.close) activeInfo.close();
  	    activeInfo = null;

  	    // Reset flags
  	    isClickLocked = false;
  	    hoverPaused = false;

  	    // Clean compare labels / overlay marker
  	    if (App.FineTrackSelectedMarker?.setLabel) App.FineTrackSelectedMarker.setLabel(null);
  	    if (compareState.markerB?.setMap) compareState.markerB.setMap(null);
  	    compareState.markerB = null;
  	    compareState.pointA = null;
  	    compareState.pointB = null;
  	    compareState.sectionId = null;
  	    compareState.active = false;

  	    // 🧩 NEW: Only clear main marker if user pressed Esc or fully exits (no compare, no panel open)
  	    const panelOpen = !!document.getElementById("fineTrackDetachedPopup");
  	    if (!compareState.active && !panelOpen && App.FineTrackSelectedMarker?.setMap) {
  	      App.FineTrackSelectedMarker.setMap(null);
  	      App.FineTrackSelectedMarker = null;
  	    }
  	  };


  	  // ---------- Route Marker Context Report Helpers ----------
  	  // These do NOT replace marker click behaviour.
  	  // They only add marker context to the big hover/click report.

  	  const routeIdleSegments = Array.isArray(tractor?.Events?.["Idle Event"])
  	  ? tractor.Events["Idle Event"]: [];

  	  function routeMarkerTsMs(v) {
  	    if (v == null) return null;

  	    if (typeof v === "number") {
  	      return Number.isFinite(v) ? (v < 1e12 ? v * 1000: v): null;
  	    }

  	    if (typeof v === "string") {
  	      const n = Number(v);

  	      if (Number.isFinite(n)) {
  	        return n < 1e12 ? n * 1000: n;
  	      }

  	      const d = Date.parse(v);
  	      return Number.isFinite(d) ? d: null;
  	    }

  	    return null;
  	  }

  	  function routeMarkerTime(v) {
  	    const ms = routeMarkerTsMs(v);

  	    if (!Number.isFinite(ms)) return "—";

  	    const d = new Date(ms);
  	    if (isNaN(d)) return "—";

  	    const pad = n => String(n).padStart(2, "0");

  	    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  	  }

  	  function routeMarkerDuration(seconds) {
  	    const s = Number(seconds);

  	    if (!Number.isFinite(s) || s < 1) return "0s";

  	    const h = Math.floor(s / 3600);
  	    const m = Math.floor((s % 3600) / 60);
  	    const sec = Math.floor(s % 60);

  	    if (h) return `${h}h ${m}m ${sec}s`;
  	    if (m) return `${m}m ${sec}s`;
  	    return `${sec}s`;
  	  }

  	  function routePointTime(point) {
  	    return routeMarkerTime(point?.raw?.timestamp ?? point?.timestamp);
  	  }

  	  function routePointIsStart(point) {
  	    if (!point || !path.length) return false;
  	    return point.idx === path[0].idx;
  	  }

  	  function routePointIsEnd(point) {
  	    if (!point || !path.length) return false;
  	    return point.idx === path[path.length - 1].idx;
  	  }

  	  function routePointSpeed(point) {
  	    const n = Number(point?.raw?.["position.speed"]);
  	    return Number.isFinite(n) ? n: null;
  	  }

  	  function routeHasRawIdle(point) {
  	    const evs = Array.isArray(point?.raw?.events) ? point.raw.events: [];
  	    return evs.some(e => String(e || "").toLowerCase().includes("idle"));
  	  }

  	  function routeIdleWindowMs(seg) {
  	    if (!seg || typeof seg !== "object") return null;

  	    const firstPoint = Array.isArray(seg.Points) && seg.Points.length
  	    ? seg.Points[0]: null;

  	    const lastPoint = Array.isArray(seg.Points) && seg.Points.length
  	    ? seg.Points[seg.Points.length - 1]: null;

  	    const startMs =
  	    routeMarkerTsMs(seg.start_iso) ||
  	    routeMarkerTsMs(seg.start) ||
  	    routeMarkerTsMs(firstPoint?.timestamp);

  	    let endMs = routeMarkerTsMs(lastPoint?.timestamp);

  	    if (!Number.isFinite(endMs) && Number.isFinite(startMs) && Number.isFinite(Number(seg.idle_seconds))) {
  	      endMs = startMs + Number(seg.idle_seconds) * 1000;
  	    }

  	    if (!Number.isFinite(startMs)) return null;

  	    if (!Number.isFinite(endMs)) {
  	      endMs = startMs;
  	    }

  	    return {
  	      startMs,
  	      endMs
  	    };
  	  }

  	  function routeIdlePosition(seg) {
  	    if (!seg || typeof seg !== "object") return null;

  	    let lat = Number(seg.lat ?? seg.latitude);
  	    let lng = Number(seg.lon ?? seg.lng ?? seg.longitude);

  	    if ((!Number.isFinite(lat) || !Number.isFinite(lng)) && Array.isArray(seg.Points) && seg.Points.length) {
  	      const p = seg.Points[0];

  	      lat = Number(
  	        p.lat ??
  	        p.latitude ??
  	        p.point?.["position.latitude"]
  	      );

  	      lng = Number(
  	        p.lon ??
  	        p.lng ??
  	        p.longitude ??
  	        p.point?.["position.longitude"]
  	      );
  	    }

  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  	    return {
  	      lat,
  	      lng
  	    };
  	  }

  	  function routeFindIdleSegment(point) {
  	    if (!point || !routeIdleSegments.length) return null;

  	    const pointMs = routeMarkerTsMs(point.raw?.timestamp ?? point.timestamp);
  	    const pointLat = Number(point.lat ?? point.raw?.["position.latitude"]);
  	    const pointLng = Number(point.lng ?? point.lon ?? point.raw?.["position.longitude"]);

  	    if (Number.isFinite(pointMs)) {
  	      for (const seg of routeIdleSegments) {
  	        const win = routeIdleWindowMs(seg);
  	        if (!win) continue;

  	        const padMs = 15000;

  	        if (pointMs >= win.startMs - padMs && pointMs <= win.endMs + padMs) {
  	          return seg;
  	        }
  	      }
  	    }

  	    if (Number.isFinite(pointLat) && Number.isFinite(pointLng)) {
  	      for (const seg of routeIdleSegments) {
  	        const pos = routeIdlePosition(seg);
  	        if (!pos) continue;

  	        const d = haversineM(
  	          {
  	            lat: pointLat, lng: pointLng
  	          },
  	          {
  	            lat: pos.lat, lng: pos.lng
  	          }
  	        );

  	        if (d <= 60) {
  	          return seg;
  	        }
  	      }
  	    }

  	    return null;
  	  }

  	  function routePointIsIdle(point) {
  	    return !!routeFindIdleSegment(point) || routeHasRawIdle(point);
  	  }

  	  function routePointIsStopped(point) {
  	    const spd = routePointSpeed(point);
  	    return Number.isFinite(spd) && spd < 1;
  	  }

  	  function routeBuildStopSegments() {
  	    const segments = [];
  	    let current = null;

  	    function flush() {
  	      if (current && current.points.length) {
  	        segments.push(current);
  	      }

  	      current = null;
  	    }

  	    path.forEach(point => {
  	      const stopped = routePointIsStopped(point);
  	      const idle = routePointIsIdle(point);

  	      // Stopped-only becomes red.
  	      // Real idle becomes yellow, not red.
  	      if (stopped && !idle) {
  	        if (!current) {
  	          current = {
  	            points: []
  	          };
  	        }

  	        current.points.push(point);
  	      } else {
  	        flush();
  	      }
  	    });

  	    flush();

  	    return segments;
  	  }

  	  const routeStopSegments = routeBuildStopSegments();

  	  function routeFindStopSegment(point) {
  	    if (!point || !routeStopSegments.length) return null;

  	    return routeStopSegments.find(seg =>
  	      Array.isArray(seg.points) &&
  	      seg.points.some(p => p.idx === point.idx)
  	    ) || null;
  	  }

  	  function routeStopDurationSeconds(seg) {
  	    if (!seg || !Array.isArray(seg.points) || !seg.points.length) return 0;

  	    const first = seg.points[0];
  	    const last = seg.points[seg.points.length - 1];

  	    const startMs = routeMarkerTsMs(first.raw?.timestamp ?? first.timestamp);
  	    const endMs = routeMarkerTsMs(last.raw?.timestamp ?? last.timestamp);

  	    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return 0;

  	    return Math.max(0, Math.round((endMs - startMs) / 1000));
  	  }

  	  function routeMarkerContextHtml(point) {
  	    if (!point) return "";

  	    const rows = [];

  	    if (routePointIsStart(point)) {
  	      rows.push({
  	        color: "#00cc44",
  	        title: "Start Marker",
  	        lines: [
  	          `Time: ${routePointTime(point)}`
  	        ]
  	      });
  	    }

  	    const idleSeg = routeFindIdleSegment(point);

  	    if (idleSeg || routeHasRawIdle(point)) {
  	      const idleStart =
  	      routeMarkerTime(idleSeg?.start_iso) ||
  	      routeMarkerTime(idleSeg?.start) ||
  	      routeMarkerTime(idleSeg?.Points?.[0]?.timestamp) ||
  	      routePointTime(point);

  	      const idleText =
  	      idleSeg?.idle_human ||
  	      routeMarkerDuration(idleSeg?.idle_seconds || 0);

  	      rows.push({
  	        color: "#ffcc00",
  	        title: "Idle Marker",
  	        lines: [
  	          `Start: ${idleStart}`,
  	          `Idle: ${idleText}`
  	        ]
  	      });
  	    }

  	    const stopSeg = routeFindStopSegment(point);

  	    if (stopSeg) {
  	      rows.push({
  	        color: "#cc0000",
  	        title: "Stopped Marker",
  	        lines: [
  	          `Stopped Time: ${routePointTime(stopSeg.points[0])}`,
  	          `Duration: ${routeMarkerDuration(routeStopDurationSeconds(stopSeg))}`
  	        ]
  	      });
  	    }

  	    if (routePointIsEnd(point)) {
  	      rows.push({
  	        color: "#cc0000",
  	        title: "End Marker",
  	        lines: [
  	          `Time: ${routePointTime(point)}`
  	        ]
  	      });
  	    }

  	    if (!rows.length) return "";

  	    return `
  	    <div style="margin-top:10px;border-top:1px solid #333;padding-top:8px;">
  	    <b>Marker Report:</b>
  	    ${rows.map(row => `
  	      <div style="
  	      margin-top:6px;
  	      padding:7px 8px;
  	      border-radius:7px;
  	      background:#000;
  	      border-left:4px solid ${row.color};
  	      ">
  	      <div style="font-weight:700;color:${row.color};">${row.title}</div>
  	      <div style="margin-top:3px;line-height:1.4;color:#fff;">
  	      ${row.lines.join("<br>")}
  	      </div>
  	      </div>
  	      `).join("")}
  	    </div>
  	    `;
  	  }

  	  // ---------- Popup ----------
  	  const showPopup = (point, isClick) => {
  	    const raw = point.raw; if (!raw) return;
  	    // --- Fuel Live Calculations ---
  	    const tankCap = +tractor?.CAN?.Tank || 0;

  	    // --- Fuel percentage fallback ---
  	    const fuelPct = smartFuelPct(raw, tankCap);
  	    const fuelLitres =
  	    (Number.isFinite(fuelPct) && Number.isFinite(tankCap) && tankCap > 0)
  	    ? (fuelPct / 100) * tankCap: null;



  	    // --- Range: baseline (stable) first, then window, then trip fallback ---
  	    const endIdx = Number.isFinite(point.idx) ? point.idx: null;

  	    let kmPerL = null;
  	    let kmPerLMethod = "—";

  	    // 1) Baseline from CAN config (most stable)
  	    const baselineKmPerL = getBaselineKmPerL();
  	    if (baselineKmPerL != null) {
  	      kmPerL = baselineKmPerL;
  	      kmPerLMethod = "CAN Avg (km/L)";
  	    }

  	    // 2) Window estimate (optional improvement if you want it, only used if no baseline)
  	    if (kmPerL == null && endIdx != null) {
  	      const est = estimateKmPerLWindow(endIdx, tankCap);
  	      kmPerL = est.kmPerL;
  	      kmPerLMethod = est.method;
  	    }

  	    // 3) Trip fallback (only if no baseline and no window)
  	    if (kmPerL == null) {
  	      const tracking = tractor?.Tracking || [];
  	      const first = tracking[0] || {};
  	      const startOdo = smartOdoKm(first);
  	      const curOdo = smartOdoKm(raw);

  	      const fuTrip = calcFuelUsedBest(first, raw, tankCap);
  	      const fuelUsedTrip = fuTrip.fuelUsedL;

  	      const distKmTrip =
  	      (Number.isFinite(startOdo) && Number.isFinite(curOdo))
  	      ? (curOdo - startOdo): null;

  	      if (fuelUsedTrip != null && fuelUsedTrip > 0.5 && distKmTrip != null && distKmTrip > 0.5) {
  	        kmPerL = clamp(distKmTrip / fuelUsedTrip, 0.5, 25);
  	        kmPerLMethod = `Trip (${fuTrip.method})`;
  	      }
  	    }

  	    const fuelRange =
  	    (kmPerL != null && fuelLitres != null)
  	    ? (fuelLitres * kmPerL): null;



  	    const heading = +raw["position.direction"] || 0;
  	    const fill = tractor.color || "#2196F3";
  	    const events = Array.isArray(raw.events) ? raw.events: [];
  	    const markerContextHtml = routeMarkerContextHtml(point);
  	    if (hoverMarker?.setMap) hoverMarker.setMap(null);

  	    const marker = new google.maps.Marker({
  	      position: {
  	        lat: point.lat, lng: point.lng
  	      }, map,
  	      icon: {
  	        path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	        fillColor: fill, fillOpacity: 1, strokeWeight: 2, strokeColor: "#fff",
  	        rotation: heading, scale: 1.6, anchor: new google.maps.Point(0, 0)
  	      },
  	      zIndex: 1200
  	    });

  	    registerFineTrackOverlay(map, marker);

  	    // 🧩 Ensure global reference before any click listeners
  	    App.FineTrackSelectedMarker = marker;


  	    marker.addListener("click", () => {
  	      // 🧩 Do NOT clear active marker; only reset overlays and info
  	      if (activeInfo?.close) activeInfo.close();
  	      activeInfo = null;
  	      document.getElementById("fineTrackDetachedPopup")?.remove();


  	      // === Build Full Snapshot HTML (with Compare Integration) ===
  	      const driverObj = App?.SelectedTractor?.FVC?.Driver1;
  	      const driverName = driverObj?.name || "—";
  	      const driverPhone = driverObj?.Data_Details?.employee_details?.contact_details?.phone_number || "—";
  	      const driverEmail = driverObj?.email || "—";

  	      const spd = +point.raw["position.speed"];
  	      const rpm = +point.raw["can.engine.rpm"];
  	      const tmp = +point.raw["can.engine.temperature"];
  	      const alt = +point.raw["position.altitude"];
  	      const dir = +point.raw["position.direction"];
  	      const tankCap = +tractor?.CAN?.Tank || 0;
  	      const fuelPct = smartFuelPct(point.raw, tankCap);
  	      const fuelLitres =
  	      (Number.isFinite(fuelPct) && Number.isFinite(tankCap) && tankCap > 0)
  	      ? (fuelPct / 100) * tankCap: null;


  	      const events = Array.isArray(point.raw.events) ? point.raw.events: [];

  	      const html = `
  	      <div data-trackit-panel-card="true" style="
  	      width:100%;
  	      max-width:none;
  	      min-width:0;
  	      box-sizing:border-box;
  	      font:14px system-ui,sans-serif;
  	      color:#fff;
  	      background:#0b0f14;
  	      padding:10px;
  	      border-radius:8px;
  	      ">
  	      <div style="font-weight:600;margin-bottom:8px;">Point Details</div>
  	      <div><b>Driver:</b> ${driverName}</div>
  	      <div><b>Mobile:</b> ${driverPhone}</div>
  	      <div><b>Email:</b> ${driverEmail}</div>
  	      <div style="margin-top:8px;"><b>Time:</b> ${fmtTime(point.raw.timestamp)}</div>

  	      <div style="margin-top:10px;padding:6px 8px;border-radius:6px;
  	      background:${tmp > limTmp ? '#ffc107': '#000'};color:${tmp > limTmp ? '#000': '#fff'};">
  	      Engine Temp: ${fmt(tmp, '°C')}
  	      </div>

  	      <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	      background:${spd > limSpd ? '#CC6633': '#000'};color:#fff;">
  	      Speed: ${fmt(spd, ' km/h')} <span style="opacity:0.6">(limit ${limSpd})</span>
  	      </div>

  	      <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	      background:${rpm > limRpm ? '#9c27b0': '#000'};color:#fff;">
  	      RPM: ${fmt(rpm, ' RPM')} <span style="opacity:0.6">(limit ${limRpm})</span>
  	      </div>


  	      <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	      background:${(+raw["can.throttle.pedal.level"] || 0) > limThrottle ? '#00b7ff': '#000'};
  	      color:${(+raw["can.throttle.pedal.level"] || 0) > limThrottle ? '#000': '#fff'};">
  	      Throttle: ${fmt(+raw["can.throttle.pedal.level"], ' %')} <span style="opacity:0.6">(limit ${limThrottle}%)</span>
  	      </div>

  	      <div style="margin-top:10px;">
  	      <b>Altitude:</b> ${fmt(alt, ' m')}<br>
  	      <b>Direction:</b> ${degToCompass(dir)}
  	      </div>

  	      <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	      <b>Fuel Stats:</b><br>
  	      Fuel Level: ${fmt(fuelPct, "%")}<br>
  	      Fuel Litres: ${fmt(fuelLitres, " L", 1)}
  	      <div style="margin-top:8px;display:flex;align-items:center;gap:6px;">
  	      <div style="width:16px;text-align:left;font-size:12px;color:#aaa;">E</div>
  	      <div style="flex:1;height:12px;background:#222;border-radius:6px;overflow:hidden;position:relative;">
  	      <div style="width:${fuelPct}%;height:100%;
  	      background:${fuelPct > 70 ? '#00cc44': fuelPct > 35 ? '#ffcc00': '#ff1a1a'};
  	      border-radius:6px;transition:width 0.5s ease-out;"></div>
  	      </div>
  	      <div style="width:16px;text-align:right;font-size:12px;color:#aaa;">F</div>
  	      </div>
  	      </div>

  	      <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	      <b>Events at this point:</b>
  	      ${events.length
  	      ? `<ul style="margin:4px 0;padding-left:16px;">${events.map(ev => `<li>${ev}</li>`).join("")}</ul>`: `<div style="color:#999;font-size:12px;">No events</div>`}
  	      </div>

  	      ${markerContextHtml}

  	      <button id="cmpBtn"
  	      style="margin-top:14px;padding:8px 10px;background:#2196F3;color:#fff;
  	      border:none;border-radius:8px;cursor:pointer;width:100%;font-weight:600;">
  	      Compare from here
  	      </button>
  	      </div>
  	      `;

  	      attachLeftComparePanel(point, Hub);

  	      // Lock map while the side panel is open.
  	      // It unlocks when Compare from here or X is pressed.
  	      lockRouteMapForPanel();

  	      const panel = document.getElementById("fineTrackDetachedPopup");
  	      if (panel) {
  	        const body = panel.querySelector("#panelBody");
  	        if (body) {
  	          body.innerHTML = html;
  	          normalizeTrackitPanelBodyContent(body);

  	          body.scrollTo({
  	            top: 0,
  	            behavior: "smooth"
  	          });

  	          const cmpBtn = body.querySelector("#cmpBtn");
  	          if (cmpBtn) {
  	            cmpBtn.onclick = () => {
  	              startCompareFromPoint(point, cmpBtn, null);
  	            };
  	          }
  	        }
  	      }

  	      hoverPaused = true;
  	    });

  	    if (isClick) {
  	      App.FineTrackSelectedMarker = marker; isClickLocked = true;
  	    } else {
  	      hoverMarker = marker;
  	    }

  	    // ---------- Driver Data (from FVC.Driver1) ----------
  	    const driverObj = App?.SelectedTractor?.FVC?.Driver1;
  	    const driverName = driverObj?.name || "—";
  	    const driverPhone = driverObj?.Data_Details?.employee_details?.contact_details?.phone_number || "—";
  	    const driverEmail = driverObj?.email || "—";


  	    const spd = +raw["position.speed"];
  	    const rpm = +raw["can.engine.rpm"];
  	    const tmp = +raw["can.engine.temperature"];
  	    const alt = +raw["position.altitude"];
  	    const dir = +raw["position.direction"];
  	    const limSpd = +tractor?.CAN?.Speed || 80;
  	    const limRpm = +tractor?.CAN?.RPM || 1500;
  	    const limTmp = +tractor?.CAN?.Temp || 100;
  	    const limThrottle = +tractor?.CAN?.ThrottlePct || 85;
  	    const tempOver = tmp > limTmp,
  	    speedOver = spd > limSpd,
  	    rpmOver = rpm > limRpm;
  	    const eventList = events.length
  	    ? `<ul id="eventList" style="padding-left:16px;margin:6px 0;color:#fff;font-size:13px;list-style-type:disc;">
  	    ${events.map((ev, i) => `<li data-ev-index="${i}" data-ev='${JSON.stringify(ev)}' style="cursor:pointer;">${ev}</li>`).join("")}
  	    </ul>`: `<div style="color:#aaa;font-size:13px;margin-top:4px;">No active events</div>`;;
  	    const compareBtnId = `cmp_${Math.random().toString(36).slice(2)}`;
  	    const cmpSectionId = `cmp_sec_${compareBtnId}`;
  	    const compareBtnHTML = isClick
  	    ? `<button id="${compareBtnId}" style="margin-top:12px;padding:8px 10px;background:#2196F3;color:#fff;border:none;border-radius:8px;cursor:pointer;width:100%;font-weight:600">📊 Compare from here</button>`: "";

  	    const content = `
  	    <div id="popupRoot" style="font:14px system-ui,sans-serif;background:#111;border-radius:10px;padding:12px;min-width:260px;max-width:340px;color:#fff;">
  	    <div><b>Driver:</b> ${driverName}</div>
  	    <div><b>Mobile:</b> ${driverPhone}</div>
  	    <div><b>Email:</b> ${driverEmail}</div>
  	    <div style="margin-top:8px;"><b>Time:</b> ${fmtTime(raw.timestamp)}</div>
  	    <div style="margin:10px 0 0;padding:6px 8px;border-radius:6px;font-weight:500;
  	    background:${tempOver ? '#ffc107': '#000'};color:${tempOver ? '#000': '#fff'};">
  	    Engine Temp: ${fmt(tmp, '°C')} <span style="opacity:0.6">(limit ${limTmp}°C)</span>
  	    </div>

  	    <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	    background:${speedOver ? '#CC6633': '#000'};color:#fff;">
  	    Speed: ${fmt(spd, ' km/h')} <span style="opacity:0.6">(limit ${limSpd})</span>
  	    </div>

  	    <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	    background:${rpmOver ? '#9c27b0': '#000'};color:#fff;">
  	    RPM: ${fmt(rpm, ' RPM')} <span style="opacity:0.6">(limit ${limRpm})</span>
  	    </div>

  	    <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	    background:${(+raw["can.throttle.pedal.level"] || 0) > limThrottle ? '#00b7ff': '#000'};
  	    color:${(+raw["can.throttle.pedal.level"] || 0) > limThrottle ? '#000': '#fff'};">
  	    Throttle: ${fmt(+raw["can.throttle.pedal.level"], ' %')} <span style="opacity:0.6">(limit ${limThrottle}%)</span>
  	    </div>
  	    <div style="margin-top:10px;">
  	    <b>Altitude:</b> ${fmt(alt, ' m')}<br><b>Direction:</b> ${degToCompass(dir)}
  	    </div>
  	    <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	    <b>Fuel Stats:</b><br>
  	    <div style="margin-top:4px;font-size:13px;line-height:1.4;">
  	    <span style="opacity:.8;">Fuel Level:</span> ${fmt(fuelPct, "%", 0)}<br>
  	    <span style="opacity:.8;">Fuel Litres:</span> ${fmt(fuelLitres, " L", 1)}<br>
  	    <span style="opacity:.8;">Range:</span> ${fmt(fuelRange, " km", 1)}
  	    <span style="opacity:.55;font-size:12px;"> (${kmPerLMethod})</span>

  	    </div>

  	    <!-- Gauge -->
  	    <div style="margin-top:8px;display:flex;align-items:center;gap:6px;">
  	    <div style="width:16px;text-align:left;font-size:12px;color:#aaa;">E</div>

  	    ${(() => {
  	      const level = Math.min(100, Math.max(0, fuelPct));
  	      const rawLow = +tractor?.CAN?.LowFuel || 0;
  	      const lowFuel = rawLow < 1 ? rawLow * 100: rawLow;
  	      const isLow = level <= lowFuel;

  	      const color =
  	      level > 70 ? "#00cc44":
  	      level > 35 ? "#ffcc00":
  	      "#ff1a1a";

  	      // Outer gauge container throbs when low
  	      return `
  	      <div style="
  	      flex:1;
  	      height:12px;
  	      background:#222;
  	      border-radius:6px;
  	      overflow:hidden;
  	      position:relative;
  	      ${isLow ? 'animation:fuelPulse 1.2s infinite ease-in-out;': ''}
  	      ">
  	      <div style="
  	      width:${level}%;
  	      height:100%;
  	      background:${color};
  	      border-radius:6px;
  	      transition:width 0.5s ease-out;
  	      "></div>

  	      <div style="
  	      position:absolute;
  	      top:-18px;
  	      right:4px;
  	      font-size:12px;
  	      font-weight:600;
  	      color:${isLow ? '#ff4444': '#aaa'};
  	      ${isLow ? 'animation:fuelPulse 1.2s infinite ease-in-out;': ''}
  	      ">${level.toFixed(0)}%</div>
  	      </div>
  	      `;
  	    })()}

  	    <div style="width:16px;text-align:right;font-size:12px;color:#aaa;">F</div>
  	    </div>

  	    </div>


  	    <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	    <b>Events at this point:</b>${eventList}
  	    </div>

  	    ${markerContextHtml}

  	    ${compareBtnHTML}
  	    <div id="${cmpSectionId}" style="display:none;margin-top:10px;"></div>
  	    </div>`;

  	    if (!isClick) {
  	      if (activeInfo) activeInfo.close();
  	      const info = new google.maps.InfoWindow({
  	        content
  	      });
  	      registerFineTrackOverlay(map, info);

  	      info.open(map, marker);
  	      activeInfo = info;

  	      google.maps.event.addListener(info, "closeclick", () => {
  	        clearPopup();
  	        clearCompareOverlays();
  	      });
  	    }


  	  };

  	  function detachPopup(info, map, point, Hub) {
  	    document.getElementById("fineTrackDetachedPopup")?.remove();

  	    // If we're in compare mode, skip InfoWindow copy and attach a left panel
  	    if (compareState.active) {
  	      attachLeftComparePanel(point, Hub);
  	      return;
  	    }

  	    const iwOuter = map.getDiv().querySelector(".gm-style-iw");
  	    if (!iwOuter) return;


  	    let hubEl = Hub?.el || Hub;
  	    if (!hubEl || !(hubEl instanceof HTMLElement)) {
  	      hubEl = document.body;
  	    }


  	    const detached = document.createElement("div");
  	    registerFineTrackElement(map, detached);

  	    detached.id = "fineTrackDetachedPopup";
  	    detached.innerHTML = iwOuter.innerHTML;

  	    // --- Wire up Compare button inside detached panel ---
  	    setTimeout(() => {
  	      const cmpBtn = detached.querySelector("button[id^='cmp_']");
  	      const cmpSec = detached.querySelector("div[id^='cmp_sec_']");
  	      if (cmpBtn && cmpSec) {
  	        cmpBtn.onclick = () => {
  	          startCompareFromPoint(
  	            point,
  	            cmpBtn,
  	            cmpSec
  	          );
  	        };
  	      }
  	    },
  	      100);


  	    // Remove pin + close buttons
  	    detached.querySelectorAll("#detachBtn, .gm-ui-hover-effect").forEach(el => el.remove());

  	    // === Core container styles ===
  	    Object.assign(detached.style,
  	      {
  	        position: "fixed",
  	        background: "rgba(20,20,20,0.96)",
  	        color: "#fff",
  	        zIndex: 9999,
  	        borderRadius: "10px",
  	        borderTop: "2px solid #CC6633",
  	        boxShadow: "0 4px 12px rgba(204,102,51,0.6)",
  	        fontFamily: "Segoe UI, sans-serif",
  	        animation: "fadeIn 0.35s ease",
  	        overflowY: "auto",
  	        overflowX: "hidden",
  	        scrollBehavior: "smooth"
  	      });

  	    // --- Sticky reattach header ---
  	    const header = document.createElement("div");
  	    Object.assign(header.style,
  	      {
  	        position: "sticky",
  	        top: "0",
  	        background: "rgba(25,25,25,0.98)",
  	        padding: "8px",
  	        borderBottom: "1px solid rgba(204,102,51,0.4)",
  	        zIndex: 10
  	      });

  	    const reBtn = document.createElement("button");
  	    reBtn.textContent = "↩ Reattach";
  	    Object.assign(reBtn.style,
  	      {
  	        background: "#CC6633",
  	        color: "#fff",
  	        border: "none",
  	        borderRadius: "6px",
  	        padding: "6px 12px",
  	        cursor: "pointer",
  	        fontWeight: "600",
  	        width: "100%",
  	        boxShadow: "0 0 8px rgba(204,102,51,0.6)",
  	      });
  	    reBtn.onclick = () => {
  	      detached.remove();
  	      showPopup(point,
  	        true);

  	      // 🔄 After the popup is recreated, restore compare if active
  	      setTimeout(() => {
  	        if (compareState.active && compareState.pointA && compareState.sectionId) {
  	          const sec = document.getElementById(compareState.sectionId);
  	          if (sec && compareState.markerB) {
  	            const html = buildInlineReport(compareState.pointA, {
  	              lat: compareState.markerB.getPosition().lat(),
  	              lng: compareState.markerB.getPosition().lng(),
  	              raw: compareState.markerB.raw || {} // fallback if needed
  	            });
  	            sec.innerHTML = html;
  	            sec.style.display = "block";
  	          }
  	        }
  	      },
  	        200);
  	    };

  	    header.appendChild(reBtn);

  	    // Add header before other content
  	    detached.prepend(header);

  	    // --- Position flush under Hub ---
  	    function positionPopup() {
  	      try {
  	        const rect = hubEl.getBoundingClientRect();
  	        const headerBar = document.querySelector("header, .topbar, .navbar, #top-bar");
  	        const headerH = headerBar ? headerBar.getBoundingClientRect().height: 0;

  	        detached.style.left = `${rect.left}px`;
  	        detached.style.top = `${rect.bottom}px`;
  	        detached.style.width = `${rect.width}px`;
  	        detached.style.height = `calc(100vh - ${rect.bottom - headerH}px)`;
  	        detached.style.maxHeight = `calc(100vh - ${rect.top}px)`;
  	      } catch (err) {
  	        console.warn("Positioning error:",
  	          err);
  	      }
  	    }

  	    document.body.appendChild(detached);
  	    // 🔧 Make sure it's above Google Maps overlays
  	    detached.style.pointerEvents = "auto";
  	    detached.style.zIndex = 9999999;

  	    // Fix for Google Maps parent clipping
  	    const mapCanvas = map.getDiv().querySelector("canvas");
  	    if (mapCanvas && mapCanvas.parentElement) {
  	      mapCanvas.parentElement.style.overflow = "visible";
  	    }
  	    // --- Attach BELOW Hub (use ONLY passed Hub) ---
  	    const hubElAuto = Hub?.el || Hub;

  	    if (!(hubElAuto instanceof HTMLElement)) {
  	      console.error("❌ Invalid Hub reference. Hub must be a DOM element or have .el.");
  	      return;
  	    }


  	    // --- Wait until Hub has proper size before attaching ---
  	    function waitForStableHub(callback, attempts = 0) {
  	      const rect = hubElAuto.getBoundingClientRect();
  	      const ready = rect.width > 100 && rect.height > 50; // sanity check

  	      if (ready) {
  	        callback(rect);
  	      } else if (attempts < 50) {
  	        requestAnimationFrame(() => waitForStableHub(callback, attempts + 1));
  	      } else {
  	        console.warn("⚠️ Hub never stabilized — using current rect anyway");
  	        callback(rect);
  	      }
  	    }

  	    // --- Final attachment logic (Full-height below Hub, same width) ---
  	    waitForStableHub((rect) => {
  	      const headerBar = document.querySelector("header, .topbar, .navbar, #top-bar");
  	      const headerH = headerBar ? headerBar.getBoundingClientRect().height: 0;

  	      Object.assign(detached.style, {
  	        position: "fixed",
  	        left: `${rect.left}px`, // align with Hub
  	        top: `${rect.bottom + 0}px`, // directly below Hub
  	        width: `${rect.width}px`, // same width as Hub
  	        height: `calc(100vh - ${rect.bottom + 12}px)`, // fill rest of vertical space
  	        background: "rgba(20,20,20,0.96)",
  	        color: "#fff",
  	        zIndex: 9999999,
  	        borderRadius: "10px",
  	        borderTop: "2px solid #CC6633",
  	        boxShadow: "0 4px 12px rgba(204,102,51,0.6)",
  	        overflowY: "auto",
  	        overflowX: "hidden",
  	        scrollBehavior: "smooth",
  	        pointerEvents: "auto",
  	        display: "block",
  	        opacity: "1",
  	        visibility: "visible",
  	      });

  	    });



  	    info.close();

  	    // Optional scroll focus
  	    try {
  	      hubEl.scrollIntoView({
  	        behavior: "smooth", block: "end"
  	      });
  	    } catch (e) {
  	      console.warn("Hub scroll error:", e);
  	    }

  	  }

  	  function attachLeftComparePanel(point, Hub) {
  	    // Remove any old version.
  	    document.getElementById("fineTrackDetachedPopup")?.remove();

  	    const panel = document.createElement("div");
  	    registerFineTrackElement(map, panel);

  	    panel.id = "fineTrackDetachedPopup";

  	    Object.assign(panel.style, {
  	      position: "fixed",
  	      top: "50px",
  	      left: "0",
  	      width: "300px",
  	      height: "calc(100vh - 50px)",
  	      background: "rgba(20,20,20,0.96)",
  	      color: "#fff",
  	      borderRight: "2px solid #CC6633",
  	      overflowY: "auto",
  	      overflowX: "hidden",
  	      animation: "fadeIn 0.35s ease",
  	      zIndex: 9999999,
  	      fontFamily: "Segoe UI, sans-serif",
  	      boxShadow: "4px 0 12px rgba(204,102,51,0.5)",
  	      boxSizing: "border-box"
  	    });

  	    // --- Header ---
  	    const header = document.createElement("div");

  	    Object.assign(header.style, {
  	      position: "sticky",
  	      top: "0",
  	      height: "50px",
  	      minHeight: "50px",
  	      background: "rgba(25,25,25,0.98)",
  	      padding: "5px 8px",
  	      borderBottom: "1px solid rgba(204,102,51,0.4)",
  	      display: "flex",
  	      justifyContent: "space-between",
  	      alignItems: "center",
  	      fontWeight: "600",
  	      color: "#CC6633",
  	      zIndex: 10,
  	      boxSizing: "border-box"
  	    });

  	    const headerTitle = document.createElement("div");
  	    headerTitle.textContent = compareState.active ? "Point Compare": "Point Details";

  	    Object.assign(headerTitle.style, {
  	      flex: "1 1 auto",
  	      minWidth: "0",
  	      overflow: "hidden",
  	      whiteSpace: "nowrap",
  	      textOverflow: "ellipsis"
  	    });

  	    header.appendChild(headerTitle);

  	    const headerActions = document.createElement("div");

  	    Object.assign(headerActions.style, {
  	      display: "flex",
  	      alignItems: "center",
  	      justifyContent: "flex-end",
  	      gap: "8px",
  	      flex: "0 0 auto"
  	    });

  	    // Print button: works for both single-point and compare reports.
  	    if (point) {
  	      const printBtn = document.createElement("button");
  	      printBtn.type = "button";
  	      printBtn.title = compareState.active ? "Print compare report": "Print point report";
  	      printBtn.setAttribute(
  	        "aria-label",
  	        compareState.active ? "Print compare report": "Print point report"
  	      );
  	      printBtn.innerHTML = trackitPrinterIconSvg();

  	      applyTrackitIconButtonStyle(printBtn);

  	      printBtn.onclick = () => {
  	        if (compareState.active) {
  	          if (!compareState.pointA || !compareState.pointB) {
  	            alert("Select the second comparison point before printing.");
  	            return;
  	          }

  	          openComparePrintReport(compareState.pointA, compareState.pointB);
  	          return;
  	        }

  	        openSinglePointPrintReport(point);
  	      };

  	      headerActions.appendChild(printBtn);
  	    }

  	    // Close button.
  	    const closeBtn = document.createElement("button");
  	    closeBtn.type = "button";
  	    closeBtn.title = "Close";
  	    closeBtn.setAttribute("aria-label", "Close panel");
  	    closeBtn.innerHTML = trackitCloseIconSvg();

  	    applyTrackitIconButtonStyle(closeBtn);

  	    closeBtn.onclick = () => {
  	      unlockRouteMapFromPanelClose();

  	      document.getElementById("fineTrackDetachedPopup")?.remove();

  	      // When user closes panel, remove marker safely.
  	      if (App.FineTrackSelectedMarker?.setMap) {
  	        App.FineTrackSelectedMarker.setMap(null);
  	        App.FineTrackSelectedMarker = null;
  	      }

  	      // Clear compare overlays if needed.
  	      if (compareState.active) {
  	        clearCompareOverlays();
  	        compareState.active = false;
  	        compareState.pointA = null;
  	        compareState.pointB = null;
  	        compareState.markerB?.setMap?.(null);
  	        compareState.markerB = null;
  	        compareState.sectionId = null;
  	      }

  	      hoverPaused = false;
  	      isClickLocked = false;

  	      // Always restore Hub visibility on panel close.
  	      try {
  	        const hubEl = Hub?.el || Hub;
  	        if (hubEl?.style) {
  	          hubEl.style.display = "";
  	        }
  	      } catch (err) {
  	        console.warn("⚠️ Hub restore failed:", err);
  	      }
  	    };

  	    headerActions.appendChild(closeBtn);
  	    header.appendChild(headerActions);
  	    panel.appendChild(header);

  	    // --- Body ---
  	    const body = document.createElement("div");
  	    body.id = "panelBody";

  	    Object.assign(body.style, {
  	      width: "100%",
  	      maxWidth: "none",
  	      padding: "10px",
  	      margin: "0",
  	      boxSizing: "border-box",
  	      overflowX: "hidden"
  	    });

  	    body.innerHTML =
  	    compareState.sectionId &&
  	    document.getElementById(compareState.sectionId)
  	    ? document.getElementById(compareState.sectionId).innerHTML: `<div style="color:#aaa;">Loading snapshot data...</div>`;

  	    panel.appendChild(body);
  	    document.body.appendChild(panel);

  	    normalizeTrackitPanelBodyContent(body);

  	    // Reinstate marker visibility if map lost reference.
  	    try {
  	      if (App.FineTrackSelectedMarker && !App.FineTrackSelectedMarker.getMap()) {
  	        App.FineTrackSelectedMarker.setMap(map);
  	        App.FineTrackSelectedMarker.setZIndex(3000);
  	        console.log("🧭 Restored marker visibility after panel attach");
  	      }
  	    } catch (err) {
  	      console.warn("Marker restore failed:", err);
  	    }

  	    // Hide Hub if viewport is narrow.
  	    try {
  	      const hubEl = Hub?.el || Hub;

  	      if (window.innerWidth < 900 && hubEl?.style) {
  	        hubEl.style.display = "none";
  	      } else if (hubEl?.style) {
  	        hubEl.style.display = "";
  	      }
  	    } catch (err) {
  	      console.warn("⚠️ Hub hide check failed:", err);
  	    }

  	    // Keep marker managed only by the main click handler.
  	    try {
  	      if (App.FineTrackSelectedMarker instanceof google.maps.Marker) {
  	        App.FineTrackSelectedMarker.setZIndex(3000);
  	      }
  	    } catch (err) {
  	      console.warn("Marker check failed:", err);
  	    }
  	  }

  	  // ---------- Inline Compare Builder (Directional + Pulsing Overlay, Z-Indexed + GPS Fuel Fallback) ----------
  	  const buildInlineReport = (A,
  	    B) => {
  	    const tA = parseTs(A.raw),
  	    tB = parseTs(B.raw);
  	    if (!Number.isFinite(tA) || !Number.isFinite(tB)) return "<div>Invalid timestamps</div>";

  	    const startTime = Math.min(tA, tB);
  	    const endTime = Math.max(tA, tB);
  	    const dur = endTime - startTime;

  	    const startPoint = (tA <= tB) ? A: B;
  	    const endPoint = (tA <= tB) ? B: A;

  	    // Extract window points
  	    const windowPts = path.filter(p => {
  	      const tp = parseTs(p.raw);
  	      return tp != null && tp >= startTime && tp <= endTime;
  	    });

  	    // Directional metrics
  	    const alongM = windowPts.length >= 2 ? sumDistanceM(windowPts): haversineM(startPoint, endPoint);
  	    let maxSpeed=-Infinity,
  	    maxRpm=-Infinity,
  	    sumSpeed = 0,
  	    sumRpm = 0,
  	    countSpeed = 0,
  	    countRpm = 0;
  	    const evSet = new Set();

  	    for (const p of windowPts) {
  	      const s = +p.raw["position.speed"],
  	      r = +p.raw["can.engine.rpm"];
  	      if (Number.isFinite(s)) {
  	        maxSpeed = Math.max(maxSpeed, s); sumSpeed += s; countSpeed++;
  	      }
  	      if (Number.isFinite(r)) {
  	        maxRpm = Math.max(maxRpm, r); sumRpm += r; countRpm++;
  	      }
  	      (p.raw.events || []).forEach(e => evSet.add(e));
  	    }

  	    const avgSpeed = countSpeed ? sumSpeed/countSpeed: null;
  	    const avgRpm = countRpm ? sumRpm/countRpm: null;

  	    // --- Fuel Used (single source of truth) ---
  	    const tankCap = +tractor?.CAN?.Tank || 0;

  	    const fu = calcFuelUsedBest(startPoint.raw, endPoint.raw, tankCap);
  	    const fuel = fu.fuelUsedL;
  	    const fuelMethod = fu.method;

  	    const distKm = alongM / 1000;
  	    const kmPerL = (fuel != null && fuel > 0) ? distKm / fuel: null;
  	    const fuelPerHour = (fuel != null && dur > 0) ? fuel / (dur/3600000): null;

  	    const altStart = +startPoint.raw["position.altitude"];
  	    const altEnd = +endPoint.raw["position.altitude"];
  	    const dAlt = (Number.isFinite(altStart) && Number.isFinite(altEnd)) ? (altEnd-altStart): null;

  	    const u = tractor?.CAN?.Units || {};
  	    const fmtTimeHM = ms=> {
  	      if (!Number.isFinite(ms) || ms <= 0)return "—";
  	      const totalMin = Math.floor(ms/60000);
  	      const hh = Math.floor(totalMin/60);
  	      const mm = totalMin%60;
  	      return `${hh}h ${mm}m`;
  	    };

  	    // --- Build Report HTML ---
  	    const html = `
  	    <div style="font-size:13px;color:#fff;background:#0b0f14;padding:8px;border-radius:6px;">
  	    <div style="font-weight:600;margin-bottom:6px;">Comparison to selected point</div>
  	    <div style="display:grid;grid-template-columns:auto 1fr;gap:4px 10px;">
  	    <div style="opacity:.8">Dist. along path:</div><div>${fmt(distKm, ' km', 2)}</div>
  	    <div style="opacity:.8">Time:</div><div>${fmtTimeHM(dur)}</div>
  	    <div style="opacity:.8">Max SPD:</div><div>${fmt(maxSpeed, ` ${u.speed || 'km/h'}`, 0)}</div>
  	    <div style="opacity:.8">Avg SPD:</div><div>${avgSpeed != null?fmt(avgSpeed, ` ${u.speed || 'km/h'}`, 1): '—'}</div>
  	    <div style="opacity:.8">Max RPM:</div><div>${fmt(maxRpm, ` ${u.rpm || 'rpm'}`, 0)}</div>
  	    <div style="opacity:.8">Avg RPM:</div><div>${avgRpm != null?fmt(avgRpm, ` ${u.rpm || 'rpm'}`, 0): '—'}</div>
  	    <div style="opacity:.8">Fuel Total:</div>
  	    <div>${fuel != null ? `${fmt(fuel, ` ${u.fuel_l || 'L'}`, 2)} <span style="opacity:.65;font-size:12px;">(${fuelMethod})</span>`: '—'}</div>

  	    <div style="opacity:.8">Km/Litre:</div><div>${kmPerL != null?fmt(kmPerL, '', 2): '—'}</div>
  	    <div style="opacity:.8">Litre/Hour:</div><div>${fuelPerHour != null?fmt(fuelPerHour, '', 2): '—'}</div>
  	    <div style="opacity:.8">Δ Altitude:</div><div>${dAlt != null?(dAlt > 0?'+': '')+fmt(dAlt, ' m', 0): '—'}</div>
  	    </div>
  	    <div style="margin-top:6px;border-top:1px solid #22303f;padding-top:4px;font-weight:600;">All Events</div>
  	    ${evSet.size
  	    ? `<ul style="margin:4px 0;padding-left:16px;font-size:12px;">${[...evSet].map(e => `<li>${e}</li>`).join("")}</ul>`: `<div style="color:#9fb0c0;font-size:12px;">None</div>`}
  	    </div>`;

  	    // --- Clear any old overlays first ---
  	    clearCompareOverlays();

  	    // --- Add static black + orange overlay ---
  	    const overlayPath = windowPts.map(p => ({
  	      lat: p.lat, lng: p.lng
  	    }));
  	    if (overlayPath.length >= 2) {
  	      window._fineTrackCompareOverlay = new google.maps.Polyline({
  	        path: overlayPath,
  	        strokeColor: '#000000',
  	        strokeOpacity: 0.6,
  	        strokeWeight: 12,
  	        zIndex: 9999999,
  	        map
  	      });
  	      registerFineTrackOverlay(map, window._fineTrackCompareOverlay);

  	      window._fineTrackCompareOverlayPulse = new google.maps.Polyline({
  	        path: overlayPath,
  	        strokeColor: 'rgba(255,140,0,0.8)',
  	        strokeOpacity: 0.8,
  	        strokeWeight: 4,
  	        zIndex: 999999999,
  	        map
  	      });
  	      registerFineTrackOverlay(map, window._fineTrackCompareOverlayPulse);
  	    }

  	    return html;
  	  };

  	  function buildSnapshotBlock(raw, title = "Point") {
  	    if (!raw) return "<div>No data</div>";

  	    const spd = +raw["position.speed"];
  	    const rpm = +raw["can.engine.rpm"];
  	    const tmp = +raw["can.engine.temperature"];
  	    const alt = +raw["position.altitude"];
  	    const dir = +raw["position.direction"];
  	    const fuelPct = +raw["can.fuel.level"];
  	    const tankCap = +App?.SelectedTractor?.CAN?.Tank || 0;
  	    const fuelLitres = (fuelPct / 100) * tankCap;

  	    const isA = String(title).toUpperCase().includes("A");
  	    const color = isA ? "#00ccff": "#ffcc00";

  	    return `
  	    <div style="
  	    font-size:13px;
  	    background:#0b0f14;
  	    padding:10px;
  	    border-radius:8px;
  	    color:#fff;
  	    border-left:4px solid ${color};
  	    margin-bottom:8px;
  	    ">
  	    <div style="
  	    font-weight:800;
  	    color:${color};
  	    font-size:14px;
  	    ">${title}</div>

  	    <div><b>Time:</b> ${fmtTime(raw.timestamp)}</div>
  	    <div><b>Temp:</b> ${fmt(tmp, "°C")}</div>
  	    <div><b>Speed:</b> ${fmt(spd, " km/h")}</div>
  	    <div><b>RPM:</b> ${fmt(rpm, " RPM")}</div>
  	    <div><b>Altitude:</b> ${fmt(alt, " m")}</div>
  	    <div><b>Direction:</b> ${degToCompass(dir)}</div>
  	    <div style="margin-top:8px;"><b>Fuel Level:</b> ${fmt(fuelPct, "%")} (${fmt(fuelLitres, " L", 1)})</div>
  	    </div>`;
  	  }

  	  function escReport(value) {
  	    return String(value ?? "—")
  	    .replace(/&/g, "&amp;")
  	    .replace(/</g, "&lt;")
  	    .replace(/>/g, "&gt;")
  	    .replace(/"/g, "&quot;")
  	    .replace(/'/g, "&#039;");
  	  }

  	  function fmtReportDuration(ms) {
  	    if (!Number.isFinite(ms) || ms < 0) return "—";

  	    const totalSec = Math.floor(ms / 1000);
  	    const hh = Math.floor(totalSec / 3600);
  	    const mm = Math.floor((totalSec % 3600) / 60);
  	    const ss = totalSec % 60;

  	    if (hh > 0) return `${hh}h ${mm}m ${ss}s`;
  	    return `${mm}m ${ss}s`;
  	  }

  	  function getReportVehicleName() {
  	    return (
  	      tractor?.Registration ||
  	      tractor?.registration ||
  	      tractor?.Name ||
  	      tractor?.name ||
  	      tractor?.VehicleName ||
  	      tractor?.vehicleName ||
  	      App?.SelectedTractor?.Registration ||
  	      App?.SelectedTractor?.Name ||
  	      "Vehicle"
  	    );
  	  }

  	  function collectCompareReportData(A, B) {
  	    const tA = parseTs(A?.raw);
  	    const tB = parseTs(B?.raw);

  	    if (!Number.isFinite(tA) || !Number.isFinite(tB)) return null;

  	    const startTime = Math.min(tA, tB);
  	    const endTime = Math.max(tA, tB);
  	    const durationMs = endTime - startTime;

  	    const startPoint = tA <= tB ? A: B;
  	    const endPoint = tA <= tB ? B: A;

  	    const windowPts = path.filter(p => {
  	      const tp = parseTs(p.raw);
  	      return Number.isFinite(tp) && tp >= startTime && tp <= endTime;
  	    });

  	    const alongM = windowPts.length >= 2
  	    ? sumDistanceM(windowPts): haversineM(startPoint, endPoint);

  	    const tankCap = +tractor?.CAN?.Tank || 0;
  	    const fu = calcFuelUsedBest(startPoint.raw, endPoint.raw, tankCap);
  	    const fuelUsed = fu.fuelUsedL;

  	    let maxSpeed = null;
  	    let maxRpm = null;
  	    let maxTemp = null;
  	    let sumSpeed = 0;
  	    let countSpeed = 0;
  	    let sumRpm = 0;
  	    let countRpm = 0;
  	    let idleMs = 0;

  	    const eventCounts = Object.create(null);

  	    for (let i = 0; i < windowPts.length; i++) {
  	      const p = windowPts[i];
  	      const raw = p.raw || {};

  	      const spd = Number(raw["position.speed"]);
  	      const rpm = Number(raw["can.engine.rpm"]);
  	      const tmp = Number(raw["can.engine.temperature"]);

  	      if (Number.isFinite(spd)) {
  	        maxSpeed = maxSpeed == null ? spd: Math.max(maxSpeed, spd);
  	        sumSpeed += spd;
  	        countSpeed++;
  	      }

  	      if (Number.isFinite(rpm)) {
  	        maxRpm = maxRpm == null ? rpm: Math.max(maxRpm, rpm);
  	        sumRpm += rpm;
  	        countRpm++;
  	      }

  	      if (Number.isFinite(tmp)) {
  	        maxTemp = maxTemp == null ? tmp: Math.max(maxTemp, tmp);
  	      }

  	      const events = Array.isArray(raw.events) ? raw.events: [];
  	      events.forEach(ev => {
  	        const name = String(ev || "Unknown Event");
  	        eventCounts[name] = (eventCounts[name] || 0) + 1;
  	      });

  	      if (i > 0) {
  	        const prev = windowPts[i - 1];
  	        const prevTs = parseTs(prev.raw);
  	        const curTs = parseTs(raw);
  	        const prevSpeed = Number(prev.raw?.["position.speed"]);
  	        const curSpeed = Number(raw["position.speed"]);

  	        if (
  	          Number.isFinite(prevTs) &&
  	          Number.isFinite(curTs) &&
  	          curTs > prevTs &&
  	          (
  	            (Number.isFinite(prevSpeed) && prevSpeed < 1) ||
  	            (Number.isFinite(curSpeed) && curSpeed < 1)
  	          )
  	        ) {
  	          idleMs += curTs - prevTs;
  	        }
  	      }
  	    }

  	    const distKm = alongM / 1000;
  	    const avgSpeed = countSpeed ? sumSpeed / countSpeed: null;
  	    const avgRpm = countRpm ? sumRpm / countRpm: null;
  	    const kmPerL = fuelUsed != null && fuelUsed > 0 ? distKm / fuelUsed: null;
  	    const litresPerHour = fuelUsed != null && durationMs > 0
  	    ? fuelUsed / (durationMs / 3600000): null;

  	    const altStart = Number(startPoint.raw?.["position.altitude"]);
  	    const altEnd = Number(endPoint.raw?.["position.altitude"]);
  	    const deltaAlt = Number.isFinite(altStart) && Number.isFinite(altEnd)
  	    ? altEnd - altStart: null;

  	    return {
  	      startPoint,
  	      endPoint,
  	      startTime,
  	      endTime,
  	      durationMs,
  	      idleMs,
  	      points: windowPts.length,
  	      distKm,
  	      maxSpeed,
  	      avgSpeed,
  	      maxRpm,
  	      avgRpm,
  	      maxTemp,
  	      fuelUsed,
  	      fuelMethod: fu.method,
  	      kmPerL,
  	      litresPerHour,
  	      deltaAlt,
  	      tankCap,
  	      events: Object.keys(eventCounts).map(name => ({
  	        name,
  	        count: eventCounts[name]
  	      }))
  	    };
  	  }

  	  function getReportLogoHtml() {
  	    let logo = TrackitReportLogo || "";

  	    // Backendless sometimes passes values wrapped strangely.
  	    if (logo && typeof logo === "object") {
  	      logo =
  	      logo.url ||
  	      logo.src ||
  	      logo.data ||
  	      logo.value ||
  	      logo.fileURL ||
  	      logo.fileUrl ||
  	      "";
  	    }

  	    let logoText = String(logo || "").trim();

  	    // Remove accidental wrapping quotes.
  	    logoText = logoText
  	    .replace(/^['"]+/, "")
  	    .replace(/['"]+$/, "")
  	    .trim();

  	    // Debug once so we can see what Backendless is actually passing.
  	    console.log("[TrackIT Print Logo] resolved:", {
  	      type: typeof logo,
  	      length: logoText.length,
  	      prefix: logoText.slice(0, 80),
  	      isDataImage: /^data:image\//i.test(logoText)
  	    });

  	    if (!logoText) {
  	      return `<div class="logo-pill">Fleet In Form</div>`;
  	    }

  	    // Raw base64 PNG without data prefix.
  	    if (logoText.startsWith("iVBORw0KGgo")) {
  	      logoText = `data:image/png;base64,${logoText}`;
  	    }

  	    // Raw base64 JPEG without data prefix.
  	    if (logoText.startsWith("/9j/")) {
  	      logoText = `data:image/jpeg;base64,${logoText}`;
  	    }

  	    // Data URL image: PNG, JPEG, SVG, WEBP, etc.
  	    if (/^data:image\//i.test(logoText)) {
  	      return `
  	      <img
  	      class="report-logo-img"
  	      src="${escReport(logoText)}"
  	      alt="Fleet In Form"
  	      onerror="console.warn('[TrackIT Print Logo] Logo image failed to load')"
  	      >
  	      `;
  	    }

  	    // Raw SVG markup.
  	    if (logoText.startsWith("<svg") || logoText.includes("<svg")) {
  	      return `<div class="report-logo-svg">${logoText}</div>`;
  	    }

  	    // Normal image URL.
  	    if (
  	      logoText.startsWith("http://") ||
  	      logoText.startsWith("https://") ||
  	      logoText.startsWith("/")
  	    ) {
  	      return `
  	      <img
  	      class="report-logo-img"
  	      src="${escReport(logoText)}"
  	      alt="Fleet In Form"
  	      >
  	      `;
  	    }

  	    return `<div class="logo-pill">Fleet In Form</div>`;
  	  }

  	  function trackitPrintSleep(ms) {
  	    return new Promise(resolve => setTimeout(resolve, ms));
  	  }

  	  function trackitWaitForMapIdle(timeoutMs = 900) {
  	    return new Promise(resolve => {
  	      let done = false;

  	      const finish = () => {
  	        if (done) return;
  	        done = true;
  	        resolve();
  	      };

  	      try {
  	        if (
  	          typeof google !== "undefined" &&
  	          google?.maps?.event?.addListenerOnce &&
  	          map?.addListener
  	        ) {
  	          google.maps.event.addListenerOnce(map, "idle", finish);
  	        }
  	      } catch (_) {}

  	      setTimeout(finish, timeoutMs);
  	    });
  	  }

  	  function trackitGetMapSnapshotTarget() {
  	    return (
  	      map?.getDiv?.() ||
  	      document.querySelector(".gm-style") ||
  	      document.querySelector(".mapboxgl-map")
  	    );
  	  }

  	  async function trackitCaptureMapDataUrl() {
  	    const mapDiv = trackitGetMapSnapshotTarget();
  	    if (!mapDiv) return null;

  	    await trackitWaitForMapIdle(900);
  	    await trackitPrintSleep(250);

  	    try {
  	      if (typeof googleMapComponent?.takeSnapshot === "function") {
  	        const snap = await googleMapComponent.takeSnapshot();

  	        if (typeof snap === "string" && snap.startsWith("data:image/")) {
  	          return snap;
  	        }

  	        if (snap?.dataUrl && typeof snap.dataUrl === "string") {
  	          return snap.dataUrl;
  	        }

  	        if (snap?.url && typeof snap.url === "string") {
  	          return snap.url;
  	        }
  	      }
  	    } catch (e) {
  	      console.warn("[TrackIT Print] Component map snapshot failed:", e);
  	    }

  	    try {
  	      if (typeof map?.takeSnapshot === "function") {
  	        const snap = await map.takeSnapshot();

  	        if (typeof snap === "string" && snap.startsWith("data:image/")) {
  	          return snap;
  	        }

  	        if (snap?.dataUrl && typeof snap.dataUrl === "string") {
  	          return snap.dataUrl;
  	        }

  	        if (snap?.url && typeof snap.url === "string") {
  	          return snap.url;
  	        }
  	      }
  	    } catch (e) {
  	      console.warn("[TrackIT Print] Map takeSnapshot failed:", e);
  	    }

  	    try {
  	      if (typeof html2canvas === "function") {
  	        const canvas = await html2canvas(mapDiv, {
  	          useCORS: true,
  	          allowTaint: false,
  	          backgroundColor: null,
  	          logging: false,
  	          scale: Math.min(2, window.devicePixelRatio || 1)
  	        });

  	        return canvas.toDataURL("image/png");
  	      }

  	      console.warn("[TrackIT Print] html2canvas is not available for map snapshot fallback.");
  	    } catch (e) {
  	      console.warn("[TrackIT Print] html2canvas map snapshot failed:", e);
  	    }

  	    return null;
  	  }

  	  function trackitRememberMapView() {
  	    try {
  	      const c = map?.getCenter?.();

  	      return {
  	        center: c
  	        ? {
  	          lat: c.lat(),
  	          lng: c.lng()
  	        }: null,
  	        zoom: map?.getZoom?.() ?? null
  	      };
  	    } catch (_) {
  	      return {
  	        center: null,
  	        zoom: null
  	      };
  	    }
  	  }

  	  async function trackitRestoreMapView(view) {
  	    if (!view) return;

  	    try {
  	      if (view.center) map.setCenter(view.center);
  	      if (Number.isFinite(view.zoom)) map.setZoom(view.zoom);
  	      await trackitWaitForMapIdle(700);
  	    } catch (_) {}
  	  }

  	  function trackitEnsureTemporaryPrintMarker(point, label) {
  	    if (!point || typeof google === "undefined" || !google?.maps?.Marker) {
  	      return null;
  	    }

  	    try {
  	      const marker = new google.maps.Marker({
  	        position: {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        },
  	        map,
  	        label: label
  	        ? {
  	          text: String(label),
  	          color: "#fff",
  	          fontSize: "18px",
  	          fontWeight: "900"
  	        }: undefined,
  	        zIndex: 2500,
  	        title: label ? `Print ${label}`: "Print Point"
  	      });

  	      return marker;
  	    } catch (e) {
  	      console.warn("[TrackIT Print] Temporary print marker failed:", e);
  	      return null;
  	    }
  	  }

  	  async function trackitPrepareSinglePointMapSnapshot(point) {
  	    const previousView = trackitRememberMapView();
  	    const tempMarkers = [];

  	    try {
  	      if (point && Number.isFinite(Number(point.lat)) && Number.isFinite(Number(point.lng))) {
  	        const pos = {
  	          lat: Number(point.lat),
  	          lng: Number(point.lng)
  	        };

  	        map.setCenter(pos);

  	        const z = map.getZoom?.();
  	        if (!Number.isFinite(z) || z < 16) {
  	          map.setZoom(16);
  	        }

  	        if (!App?.FineTrackSelectedMarker?.getMap?.()) {
  	          const marker = trackitEnsureTemporaryPrintMarker(point, "P");
  	          if (marker) tempMarkers.push(marker);
  	        }
  	      }

  	      const dataUrl = await trackitCaptureMapDataUrl();
  	      return buildTrackitPrintMapSnapshotHtml(
  	        dataUrl,
  	        "Map Snapshot",
  	        "Selected point position at print time."
  	      );
  	    } finally {
  	      tempMarkers.forEach(marker => {
  	        try {
  	          marker.setMap(null);
  	        } catch (_) {}
  	      });

  	      await trackitRestoreMapView(previousView);
  	    }
  	  }

  	  async function trackitPrepareCompareMapSnapshot(A, B) {
  	    const previousView = trackitRememberMapView();
  	    const tempMarkers = [];

  	    try {
  	      const bounds = new google.maps.LatLngBounds();

  	      [A,
  	        B].forEach(point => {
  	          if (point && Number.isFinite(Number(point.lat)) && Number.isFinite(Number(point.lng))) {
  	            bounds.extend({
  	              lat: Number(point.lat),
  	              lng: Number(point.lng)
  	            });
  	          }
  	        });

  	      if (!bounds.isEmpty()) {
  	        map.fitBounds(bounds, 85);

  	        const z = map.getZoom?.();
  	        if (Number.isFinite(z) && z > 18) {
  	          map.setZoom(18);
  	        }
  	      }

  	      if (!App?.FineTrackSelectedMarker?.getMap?.()) {
  	        const markerA = trackitEnsureTemporaryPrintMarker(A, "A");
  	        if (markerA) tempMarkers.push(markerA);
  	      }

  	      if (!compareState?.markerB?.getMap?.()) {
  	        const markerB = trackitEnsureTemporaryPrintMarker(B, "B");
  	        if (markerB) tempMarkers.push(markerB);
  	      }

  	      const dataUrl = await trackitCaptureMapDataUrl();
  	      return buildTrackitPrintMapSnapshotHtml(
  	        dataUrl,
  	        "Map Snapshot",
  	        "Point A to Point B comparison at print time."
  	      );
  	    } finally {
  	      tempMarkers.forEach(marker => {
  	        try {
  	          marker.setMap(null);
  	        } catch (_) {}
  	      });

  	      await trackitRestoreMapView(previousView);
  	    }
  	  }

  	  function buildTrackitPrintMapSnapshotHtml(dataUrl, title = "Map Snapshot", note = "") {
  	    const safeTitle = escReport(title);
  	    const safeNote = escReport(note || "");

  	    if (!dataUrl) {
  	      return `
  	      <div class="section-title">${safeTitle}</div>
  	      <div class="map-snapshot map-snapshot-empty">
  	      Map snapshot unavailable. The report data is still valid.
  	      </div>
  	      ${safeNote ? `<div class="map-snapshot-note">${safeNote}</div>`: ""}
  	      `;
  	    }

  	    return `
  	    <div class="section-title">${safeTitle}</div>
  	    <div class="map-snapshot">
  	    <img src="${escReport(dataUrl)}" alt="${safeTitle}">
  	    </div>
  	    ${safeNote ? `<div class="map-snapshot-note">${safeNote}</div>`: ""}
  	    `;
  	  }

  	  function buildTrackitPrintLoadingHtml(title) {
  	    return `
  	    <!doctype html>
  	    <html>
  	    <head>
  	    <meta charset="utf-8">
  	    <title>${escReport(title)}</title>
  	    <style>
  	    body {
  	    margin: 0;
  	    padding: 30px;
  	    font-family: Arial, Helvetica, sans-serif;
  	    color: #111;
  	    }

  	    .loading-card {
  	    max-width: 520px;
  	    margin: 40px auto;
  	    padding: 18px 20px;
  	    border: 1px solid #ddd;
  	    border-radius: 12px;
  	    box-shadow: 0 8px 24px rgba(0,0,0,0.08);
  	    }

  	    .loading-title {
  	    font-weight: 800;
  	    font-size: 16px;
  	    margin-bottom: 8px;
  	    }

  	    .loading-copy {
  	    font-size: 13px;
  	    color: #555;
  	    }
  	    </style>
  	    </head>
  	    <body>
  	    <div class="loading-card">
  	    <div class="loading-title">${escReport(title)}</div>
  	    <div class="loading-copy">Capturing map snapshot and building report…</div>
  	    </div>
  	    </body>
  	    </html>
  	    `;
  	  }

  	  function buildComparePrintReport(A, B, mapSnapshotHtml = "") {
  	    const d = collectCompareReportData(A, B);
  	    if (!d) return null;

  	    const vehicleName = getReportVehicleName();
  	    const reportLogoHtml = getReportLogoHtml();

  	    const driverObj = tractor?.FVC?.Driver1;
  	    const driverName = driverObj?.name || "—";
  	    const driverPhone =
  	    driverObj?.Data_Details?.employee_details?.contact_details?.phone_number || "—";
  	    const driverEmail = driverObj?.email || "—";

  	    const nowText = new Date().toLocaleString("en-ZA", {
  	      year: "numeric",
  	      month: "2-digit",
  	      day: "2-digit",
  	      hour: "2-digit",
  	      minute: "2-digit"
  	    });

  	    const buildPointRows = (label, point) => {
  	      const raw = point?.raw || {};
  	      const fuelPct = smartFuelPct(raw, d.tankCap);

  	      const fuelLitres =
  	      Number.isFinite(fuelPct) &&
  	      Number.isFinite(d.tankCap) &&
  	      d.tankCap > 0
  	      ? (fuelPct / 100) * d.tankCap: null;

  	      return `
  	      <div class="point-card">
  	      <div class="point-title">${escReport(label)}</div>

  	      <div class="point-grid">
  	      <div>Time</div>
  	      <strong>${escReport(fmtTime(raw.timestamp))}</strong>

  	      <div>Speed</div>
  	      <strong>${escReport(fmt(+raw["position.speed"], " km/h", 0))}</strong>

  	      <div>RPM</div>
  	      <strong>${escReport(fmt(+raw["can.engine.rpm"], " RPM", 0))}</strong>

  	      <div>Temp</div>
  	      <strong>${escReport(fmt(+raw["can.engine.temperature"], "°", 0))}</strong>

  	      <div>Altitude</div>
  	      <strong>${escReport(fmt(+raw["position.altitude"], " m", 0))}</strong>

  	      <div>Direction</div>
  	      <strong>${escReport(degToCompass(+raw["position.direction"]))}</strong>

  	      <div>Fuel Level</div>
  	      <strong>${escReport(fmt(fuelPct, "%", 0))}</strong>

  	      <div>Fuel Litres</div>
  	      <strong>${escReport(fmt(fuelLitres, " L", 1))}</strong>
  	      </div>
  	      </div>
  	      `;
  	    };

  	    const eventRows = d.events.length
  	    ? d.events.map(ev => `
  	      <tr>
  	      <td>${escReport(ev.name)}</td>
  	      <td>${escReport(ev.count)}</td>
  	      </tr>
  	      `).join(""): `
  	    <tr>
  	    <td colspan="2">No events recorded.</td>
  	    </tr>
  	    `;

  	    const deltaAltText =
  	    d.deltaAlt != null
  	    ? `${d.deltaAlt > 0 ? "+": ""}${fmt(d.deltaAlt, " m", 0)}`: "—";

  	    return `
  	    <!doctype html>
  	    <html>
  	    <head>
  	    <meta charset="utf-8">
  	    <title>Point Compare Report - ${escReport(vehicleName)}</title>

  	    <style>
  	    @page {
  	    size: A4 portrait;
  	    margin: 8mm;
  	    }

  	    * {
  	    box-sizing: border-box;
  	    }

  	    html,
  	    body {
  	    margin: 0;
  	    padding: 0;
  	    background: #fff;
  	    color: #111;
  	    font-family: Arial, Helvetica, sans-serif;
  	    font-size: 8.5px;
  	    line-height: 1.16;
  	    }

  	    .print-actions {
  	    position: fixed;
  	    top: 10px;
  	    right: 10px;
  	    z-index: 9999;
  	    }

  	    .print-actions button {
  	    padding: 8px 14px;
  	    border: 1px solid #999;
  	    border-radius: 8px;
  	    background: #fff;
  	    cursor: pointer;
  	    font-weight: 700;
  	    }

  	    .report {
  	    width: 100%;
  	    max-width: 190mm;
  	    margin: 0 auto;
  	    }

  	    .top-line {
  	    display: grid;
  	    grid-template-columns: 120px 1fr 120px;
  	    align-items: start;
  	    gap: 8px;
  	    margin-bottom: 3px;
  	    font-size: 7.5px;
  	    }

  	    .top-title {
  	    text-align: center;
  	    font-weight: 700;
  	    font-size: 8px;
  	    }

  	    .brand-row {
  	    display: flex;
  	    align-items: center;
  	    gap: 8px;
  	    margin: 2px 0 4px;
  	    }

  	    .logo-wrap {
  	    width: 78px;
  	    height: 26px;
  	    display: flex;
  	    align-items: center;
  	    justify-content: flex-start;
  	    overflow: hidden;
  	    flex: 0 0 78px;
  	    }

  	    .report-logo-img {
  	    max-width: 78px;
  	    max-height: 26px;
  	    object-fit: contain;
  	    display: block;
  	    }

  	    .report-logo-svg {
  	    width: 78px;
  	    height: 26px;
  	    display: flex;
  	    align-items: center;
  	    justify-content: flex-start;
  	    }

  	    .report-logo-svg svg {
  	    max-width: 78px;
  	    max-height: 26px;
  	    display: block;
  	    }

  	    .logo-pill {
  	    width: 78px;
  	    height: 26px;
  	    background: #111;
  	    color: #fff;
  	    border-left: 7px solid #cc6633;
  	    display: flex;
  	    align-items: center;
  	    justify-content: center;
  	    font-size: 7.5px;
  	    font-weight: 700;
  	    font-style: italic;
  	    }

  	    .vehicle-name {
  	    font-size: 14px;
  	    color: #666;
  	    font-weight: 700;
  	    line-height: 1.05;
  	    }

  	    .vehicle-sub {
  	    font-size: 8.5px;
  	    color: #111;
  	    margin-top: 1px;
  	    }

  	    .rule {
  	    border-top: 3px double #555;
  	    margin: 4px 0 7px;
  	    }

  	    .section-title {
  	    color: #777;
  	    font-size: 11.5px;
  	    font-weight: 700;
  	    margin: 7px 0 4px;
  	    }

  	    .summary-grid {
  	    display: grid;
  	    grid-template-columns: repeat(6, 1fr);
  	    gap: 5px 10px;
  	    margin-bottom: 4px;
  	    }

  	    .metric {
  	    min-height: 20px;
  	    }

  	    .metric .label {
  	    font-weight: 700;
  	    font-size: 8px;
  	    }

  	    .metric .value {
  	    font-size: 8px;
  	    margin-top: 1px;
  	    }

  	    .note {
  	    color: #444;
  	    font-size: 7px;
  	    margin: 2px 0 5px;
  	    white-space: nowrap;
  	    overflow: hidden;
  	    text-overflow: ellipsis;
  	    }

  	    .driver-row {
  	    display: grid;
  	    grid-template-columns: repeat(3, 1fr);
  	    gap: 8px;
  	    margin-bottom: 5px;
  	    font-size: 8.5px;
  	    }

  	    .driver-row strong {
  	    font-size: 8.5px;
  	    }

  	    .point-grid-wrap {
  	    display: grid;
  	    grid-template-columns: 1fr 1fr;
  	    gap: 8px;
  	    margin-bottom: 6px;
  	    }

  	    .point-card {
  	    border: 1px solid #d6d6d6;
  	    border-radius: 3px;
  	    padding: 5px 6px;
  	    page-break-inside: avoid;
  	    }

  	    .point-title {
  	    font-size: 8.5px;
  	    font-weight: 700;
  	    margin-bottom: 4px;
  	    }

  	    .point-grid {
  	    display: grid;
  	    grid-template-columns: 64px 1fr;
  	    gap: 2px 6px;
  	    font-size: 7.7px;
  	    }

  	    .point-grid strong {
  	    font-size: 7.7px;
  	    }

  	    .bottom-grid {
  	    display: grid;
  	    grid-template-columns: 1.45fr 1fr;
  	    gap: 10px;
  	    align-items: start;
  	    }

  	    table {
  	    width: 100%;
  	    border-collapse: collapse;
  	    margin: 0;
  	    page-break-inside: avoid;
  	    }

  	    th {
  	    text-align: left;
  	    border-bottom: 1px solid #888;
  	    padding: 2.5px 2px;
  	    font-size: 7.6px;
  	    }

  	    td {
  	    padding: 2.2px 2px;
  	    border-bottom: 1px solid #e1e1e1;
  	    font-size: 7.6px;
  	    vertical-align: top;
  	    }

  	    .event-table th,
  	    .event-table td {
  	    font-size: 7.3px;
  	    }

  	    .compact-small {
  	    font-size: 7.2px;
  	    }

  	    .map-snapshot {
  	    width: 100%;
  	    height: 43mm;
  	    border: 1px solid #cfcfcf;
  	    border-radius: 4px;
  	    overflow: hidden;
  	    background: #f2f2f2;
  	    page-break-inside: avoid;
  	    margin-bottom: 5px;
  	    }

  	    .map-snapshot img {
  	    width: 100%;
  	    height: 100%;
  	    object-fit: cover;
  	    display: block;
  	    }

  	    .map-snapshot-empty {
  	    display: flex;
  	    align-items: center;
  	    justify-content: center;
  	    color: #666;
  	    font-size: 8px;
  	    }

  	    .map-snapshot-note {
  	    color: #555;
  	    font-size: 7px;
  	    margin: 2px 0 5px;
  	    }

  	    @media print {
  	    .print-actions {
  	    display: none;
  	    }

  	    html,
  	    body {
  	    -webkit-print-color-adjust: exact;
  	    print-color-adjust: exact;
  	    }
  	    }
  	    </style>
  	    </head>

  	    <body>
  	    <div class="print-actions">
  	    <button onclick="window.print()">Print</button>
  	    </div>

  	    <div class="report">
  	    <div class="top-line">
  	    <div>${escReport(nowText)}</div>
  	    <div class="top-title">Fleet In Form - Point Compare Report</div>
  	    <div></div>
  	    </div>

  	    <div class="brand-row">
  	    <div class="logo-wrap">
  	    ${reportLogoHtml}
  	    </div>

  	    <div>
  	    <div class="vehicle-name">${escReport(vehicleName)}</div>
  	    <div class="vehicle-sub">${escReport(vehicleName)}</div>
  	    </div>
  	    </div>

  	    <div class="rule"></div>

  	    <div class="section-title">Trip Summary</div>

  	    <div class="summary-grid">
  	    <div class="metric">
  	    <div class="label">Start</div>
  	    <div class="value">${escReport(fmtTime(d.startPoint.raw.timestamp))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">End</div>
  	    <div class="value">${escReport(fmtTime(d.endPoint.raw.timestamp))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Points</div>
  	    <div class="value">${escReport(d.points)}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Distance</div>
  	    <div class="value">${escReport(fmt(d.distKm, " km", 2))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Time</div>
  	    <div class="value">${escReport(fmtReportDuration(d.durationMs))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Idle</div>
  	    <div class="value">${escReport(fmtReportDuration(d.idleMs))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Max Speed</div>
  	    <div class="value">${escReport(fmt(d.maxSpeed, " km/h", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Avg Speed</div>
  	    <div class="value">${escReport(fmt(d.avgSpeed, " km/h", 1))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Max RPM</div>
  	    <div class="value">${escReport(fmt(d.maxRpm, "", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Avg RPM</div>
  	    <div class="value">${escReport(fmt(d.avgRpm, "", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Max Temp</div>
  	    <div class="value">${escReport(fmt(d.maxTemp, "°", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Fuel Used</div>
  	    <div class="value">${escReport(fmt(d.fuelUsed, " L", 2))}</div>
  	    </div>
  	    </div>

  	    <div class="note">
  	    Point comparison report uses selected route points. Fuel method: ${escReport(d.fuelMethod)}.
  	    </div>

  	    ${mapSnapshotHtml}

  	    <div class="section-title">Driver Information</div>

  	    <div class="driver-row">
  	    <div><strong>Name:</strong> ${escReport(driverName)}</div>
  	    <div><strong>Phone:</strong> ${escReport(driverPhone)}</div>
  	    <div><strong>Email:</strong> ${escReport(driverEmail)}</div>
  	    </div>

  	    <div class="section-title">Selected Points</div>

  	    <div class="point-grid-wrap">
  	    ${buildPointRows("Start Point", d.startPoint)}
  	    ${buildPointRows("End Point", d.endPoint)}
  	    </div>

  	    <div class="bottom-grid">
  	    <div>
  	    <div class="section-title">Comparison Summary</div>

  	    <table>
  	    <thead>
  	    <tr>
  	    <th>Metric</th>
  	    <th>Value</th>
  	    </tr>
  	    </thead>

  	    <tbody>
  	    <tr>
  	    <td>Distance along path</td>
  	    <td>${escReport(fmt(d.distKm, " km", 2))}</td>
  	    </tr>

  	    <tr>
  	    <td>Time</td>
  	    <td>${escReport(fmtReportDuration(d.durationMs))}</td>
  	    </tr>

  	    <tr>
  	    <td>Average Speed</td>
  	    <td>${escReport(fmt(d.avgSpeed, " km/h", 1))}</td>
  	    </tr>

  	    <tr>
  	    <td>Max Speed</td>
  	    <td>${escReport(fmt(d.maxSpeed, " km/h", 0))}</td>
  	    </tr>

  	    <tr>
  	    <td>Average RPM</td>
  	    <td>${escReport(fmt(d.avgRpm, " rpm", 0))}</td>
  	    </tr>

  	    <tr>
  	    <td>Max RPM</td>
  	    <td>${escReport(fmt(d.maxRpm, " rpm", 0))}</td>
  	    </tr>

  	    <tr>
  	    <td>Fuel Total</td>
  	    <td>${escReport(fmt(d.fuelUsed, " L", 2))}</td>
  	    </tr>

  	    <tr>
  	    <td>Km/Litre</td>
  	    <td>${escReport(fmt(d.kmPerL, "", 2))}</td>
  	    </tr>

  	    <tr>
  	    <td>Litre/Hour</td>
  	    <td>${escReport(fmt(d.litresPerHour, "", 2))}</td>
  	    </tr>

  	    <tr>
  	    <td>Δ Altitude</td>
  	    <td>${escReport(deltaAltText)}</td>
  	    </tr>
  	    </tbody>
  	    </table>
  	    </div>

  	    <div>
  	    <div class="section-title">Event Summary</div>

  	    <table class="event-table">
  	    <thead>
  	    <tr>
  	    <th>Event</th>
  	    <th>Occurrences</th>
  	    </tr>
  	    </thead>

  	    <tbody>
  	    ${eventRows}
  	    </tbody>
  	    </table>
  	    </div>
  	    </div>
  	    </div>
  	    </body>
  	    </html>
  	    `;
  	  }

  	  async function openComparePrintReport(A, B) {
  	    const w = window.open("", "_blank", "width=1100,height=800");

  	    if (!w) {
  	      alert("Print window was blocked by the browser. Allow popups for this site and try again.");
  	      return;
  	    }

  	    w.document.open();
  	    w.document.write(buildTrackitPrintLoadingHtml("Point Compare Report"));
  	    w.document.close();

  	    const mapSnapshotHtml = await trackitPrepareCompareMapSnapshot(A, B);
  	    const html = buildComparePrintReport(A, B, mapSnapshotHtml);

  	    if (!html) {
  	      alert("No valid comparison data is available to print.");
  	      try {
  	        w.close();
  	      } catch (_) {}
  	      return;
  	    }

  	    w.document.open();
  	    w.document.write(html);
  	    w.document.close();

  	    setTimeout(() => {
  	      try {
  	        w.focus();
  	        w.print();
  	      } catch (e) {
  	        console.warn("[TrackIT Print] Print failed:", e);
  	      }
  	    }, 350);
  	  }

  	  function collectSinglePointPrintReportData(point) {
  	    const raw = point?.raw;

  	    if (!raw) return null;

  	    const tankCap = +tractor?.CAN?.Tank || 0;
  	    const fuelPct = smartFuelPct(raw, tankCap);

  	    const fuelLitres =
  	    Number.isFinite(fuelPct) &&
  	    Number.isFinite(tankCap) &&
  	    tankCap > 0
  	    ? (fuelPct / 100) * tankCap: null;

  	    const baselineKmPerL = getBaselineKmPerL();

  	    const fuelRange =
  	    baselineKmPerL != null &&
  	    fuelLitres != null
  	    ? fuelLitres * baselineKmPerL: null;

  	    const events = Array.isArray(raw.events) ? raw.events: [];

  	    const markerRows = [];

  	    if (routePointIsStart(point)) {
  	      markerRows.push({
  	        title: "Start Marker",
  	        value: `Time: ${routePointTime(point)}`
  	      });
  	    }

  	    const idleSeg = routeFindIdleSegment(point);

  	    if (idleSeg || routeHasRawIdle(point)) {
  	      const idleStart =
  	      routeMarkerTime(idleSeg?.start_iso) ||
  	      routeMarkerTime(idleSeg?.start) ||
  	      routeMarkerTime(idleSeg?.Points?.[0]?.timestamp) ||
  	      routePointTime(point);

  	      const idleText =
  	      idleSeg?.idle_human ||
  	      routeMarkerDuration(idleSeg?.idle_seconds || 0);

  	      markerRows.push({
  	        title: "Idle Marker",
  	        value: `Start: ${idleStart} | Idle: ${idleText}`
  	      });
  	    }

  	    const stopSeg = routeFindStopSegment(point);

  	    if (stopSeg) {
  	      markerRows.push({
  	        title: "Stopped Marker",
  	        value: `Stopped Time: ${routePointTime(stopSeg.points[0])} | Duration: ${routeMarkerDuration(routeStopDurationSeconds(stopSeg))}`
  	      });
  	    }

  	    if (routePointIsEnd(point)) {
  	      markerRows.push({
  	        title: "End Marker",
  	        value: `Time: ${routePointTime(point)}`
  	      });
  	    }

  	    return {
  	      raw,
  	      lat: point.lat,
  	      lng: point.lng,
  	      timestamp: raw.timestamp,

  	      speed: Number(raw["position.speed"]),
  	      rpm: Number(raw["can.engine.rpm"]),
  	      temp: Number(raw["can.engine.temperature"]),
  	      throttle: Number(raw["can.throttle.pedal.level"]),
  	      altitude: Number(raw["position.altitude"]),
  	      direction: Number(raw["position.direction"]),

  	      fuelPct,
  	      fuelLitres,
  	      fuelRange,
  	      fuelMethod: baselineKmPerL != null ? "CAN Avg (km/L)": "—",

  	      events,
  	      markerRows,

  	      limits: {
  	        speed: +tractor?.CAN?.Speed || 80,
  	        rpm: +tractor?.CAN?.RPM || 1500,
  	        temp: +tractor?.CAN?.Temp || 100,
  	        throttle: +tractor?.CAN?.ThrottlePct || 85
  	      }
  	    };
  	  }

  	  function buildSinglePointPrintReport(point, mapSnapshotHtml = "") {
  	    const d = collectSinglePointPrintReportData(point);

  	    if (!d) return null;

  	    const vehicleName = getReportVehicleName();
  	    const reportLogoHtml = getReportLogoHtml();

  	    const driverObj = tractor?.FVC?.Driver1;
  	    const driverName = driverObj?.name || "—";
  	    const driverPhone =
  	    driverObj?.Data_Details?.employee_details?.contact_details?.phone_number || "—";
  	    const driverEmail = driverObj?.email || "—";

  	    const nowText = new Date().toLocaleString("en-ZA", {
  	      year: "numeric",
  	      month: "2-digit",
  	      day: "2-digit",
  	      hour: "2-digit",
  	      minute: "2-digit"
  	    });

  	    const eventRows = d.events.length
  	    ? d.events.map(ev => `
  	      <tr>
  	      <td>${escReport(ev)}</td>
  	      </tr>
  	      `).join(""): `
  	    <tr>
  	    <td>No events recorded at this point.</td>
  	    </tr>
  	    `;

  	    const markerRows = d.markerRows.length
  	    ? d.markerRows.map(row => `
  	      <tr>
  	      <td>${escReport(row.title)}</td>
  	      <td>${escReport(row.value)}</td>
  	      </tr>
  	      `).join(""): `
  	    <tr>
  	    <td colspan="2">No marker context for this point.</td>
  	    </tr>
  	    `;

  	    return `
  	    <!doctype html>
  	    <html>
  	    <head>
  	    <meta charset="utf-8">
  	    <title>Point Report - ${escReport(vehicleName)}</title>

  	    <style>
  	    @page {
  	    size: A4 portrait;
  	    margin: 10mm;
  	    }

  	    * {
  	    box-sizing: border-box;
  	    }

  	    html,
  	    body {
  	    margin: 0;
  	    padding: 0;
  	    background: #fff;
  	    color: #111;
  	    font-family: Arial, Helvetica, sans-serif;
  	    font-size: 10px;
  	    line-height: 1.25;
  	    }

  	    .print-actions {
  	    position: fixed;
  	    top: 10px;
  	    right: 10px;
  	    z-index: 9999;
  	    }

  	    .print-actions button {
  	    padding: 8px 14px;
  	    border: 1px solid #999;
  	    border-radius: 8px;
  	    background: #fff;
  	    cursor: pointer;
  	    font-weight: 700;
  	    }

  	    .report {
  	    width: 100%;
  	    max-width: 190mm;
  	    margin: 0 auto;
  	    }

  	    .top-line {
  	    display: grid;
  	    grid-template-columns: 120px 1fr 120px;
  	    align-items: start;
  	    gap: 8px;
  	    margin-bottom: 4px;
  	    font-size: 8px;
  	    }

  	    .top-title {
  	    text-align: center;
  	    font-weight: 700;
  	    font-size: 9px;
  	    }

  	    .brand-row {
  	    display: flex;
  	    align-items: center;
  	    gap: 8px;
  	    margin: 3px 0 5px;
  	    }

  	    .logo-wrap {
  	    width: 90px;
  	    height: 30px;
  	    display: flex;
  	    align-items: center;
  	    justify-content: flex-start;
  	    overflow: hidden;
  	    flex: 0 0 90px;
  	    }

  	    .report-logo-img {
  	    max-width: 90px;
  	    max-height: 30px;
  	    object-fit: contain;
  	    display: block;
  	    }

  	    .report-logo-svg {
  	    width: 90px;
  	    height: 30px;
  	    display: flex;
  	    align-items: center;
  	    justify-content: flex-start;
  	    }

  	    .report-logo-svg svg {
  	    max-width: 90px;
  	    max-height: 30px;
  	    display: block;
  	    }

  	    .logo-pill {
  	    width: 90px;
  	    height: 30px;
  	    background: #111;
  	    color: #fff;
  	    border-left: 7px solid #cc6633;
  	    display: flex;
  	    align-items: center;
  	    justify-content: center;
  	    font-size: 8px;
  	    font-weight: 700;
  	    font-style: italic;
  	    }

  	    .vehicle-name {
  	    font-size: 16px;
  	    color: #666;
  	    font-weight: 700;
  	    line-height: 1.05;
  	    }

  	    .vehicle-sub {
  	    font-size: 9px;
  	    color: #111;
  	    margin-top: 1px;
  	    }

  	    .rule {
  	    border-top: 3px double #555;
  	    margin: 5px 0 8px;
  	    }

  	    .section-title {
  	    color: #777;
  	    font-size: 12px;
  	    font-weight: 700;
  	    margin: 8px 0 5px;
  	    }

  	    .summary-grid {
  	    display: grid;
  	    grid-template-columns: repeat(4, 1fr);
  	    gap: 7px 12px;
  	    margin-bottom: 7px;
  	    }

  	    .metric .label {
  	    font-weight: 700;
  	    font-size: 8.5px;
  	    }

  	    .metric .value {
  	    font-size: 9px;
  	    margin-top: 2px;
  	    }

  	    .driver-row {
  	    display: grid;
  	    grid-template-columns: repeat(3, 1fr);
  	    gap: 8px;
  	    margin-bottom: 6px;
  	    font-size: 9px;
  	    }

  	    table {
  	    width: 100%;
  	    border-collapse: collapse;
  	    margin: 0;
  	    page-break-inside: avoid;
  	    }

  	    th {
  	    text-align: left;
  	    border-bottom: 1px solid #888;
  	    padding: 4px 3px;
  	    font-size: 8.5px;
  	    }

  	    td {
  	    padding: 4px 3px;
  	    border-bottom: 1px solid #e1e1e1;
  	    font-size: 8.5px;
  	    vertical-align: top;
  	    }

  	    .bottom-grid {
  	    display: grid;
  	    grid-template-columns: 1.2fr 1fr;
  	    gap: 12px;
  	    align-items: start;
  	    }

  	    .note {
  	    color: #444;
  	    font-size: 8px;
  	    margin-top: 4px;
  	    }

  	    .map-snapshot {
  	    width: 100%;
  	    height: 50mm;
  	    border: 1px solid #cfcfcf;
  	    border-radius: 4px;
  	    overflow: hidden;
  	    background: #f2f2f2;
  	    page-break-inside: avoid;
  	    margin-bottom: 6px;
  	    }

  	    .map-snapshot img {
  	    width: 100%;
  	    height: 100%;
  	    object-fit: cover;
  	    display: block;
  	    }

  	    .map-snapshot-empty {
  	    display: flex;
  	    align-items: center;
  	    justify-content: center;
  	    color: #666;
  	    font-size: 8px;
  	    }

  	    .map-snapshot-note {
  	    color: #555;
  	    font-size: 7.5px;
  	    margin: 3px 0 6px;
  	    }

  	    @media print {
  	    .print-actions {
  	    display: none;
  	    }

  	    html,
  	    body {
  	    -webkit-print-color-adjust: exact;
  	    print-color-adjust: exact;
  	    }
  	    }
  	    </style>
  	    </head>

  	    <body>
  	    <div class="print-actions">
  	    <button onclick="window.print()">Print</button>
  	    </div>

  	    <div class="report">
  	    <div class="top-line">
  	    <div>${escReport(nowText)}</div>
  	    <div class="top-title">Fleet In Form - Point Report</div>
  	    <div></div>
  	    </div>

  	    <div class="brand-row">
  	    <div class="logo-wrap">
  	    ${reportLogoHtml}
  	    </div>

  	    <div>
  	    <div class="vehicle-name">${escReport(vehicleName)}</div>
  	    <div class="vehicle-sub">Single Selected Point</div>
  	    </div>
  	    </div>

  	    <div class="rule"></div>

  	    <div class="section-title">Point Summary</div>

  	    <div class="summary-grid">
  	    <div class="metric">
  	    <div class="label">Time</div>
  	    <div class="value">${escReport(fmtTime(d.timestamp))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Latitude</div>
  	    <div class="value">${escReport(fmt(d.lat, "", 6))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Longitude</div>
  	    <div class="value">${escReport(fmt(d.lng, "", 6))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Direction</div>
  	    <div class="value">${escReport(degToCompass(d.direction))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Speed</div>
  	    <div class="value">${escReport(fmt(d.speed, " km/h", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">RPM</div>
  	    <div class="value">${escReport(fmt(d.rpm, " RPM", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Engine Temp</div>
  	    <div class="value">${escReport(fmt(d.temp, "°C", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Throttle</div>
  	    <div class="value">${escReport(fmt(d.throttle, " %", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Altitude</div>
  	    <div class="value">${escReport(fmt(d.altitude, " m", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Fuel Level</div>
  	    <div class="value">${escReport(fmt(d.fuelPct, "%", 0))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Fuel Litres</div>
  	    <div class="value">${escReport(fmt(d.fuelLitres, " L", 1))}</div>
  	    </div>

  	    <div class="metric">
  	    <div class="label">Range</div>
  	    <div class="value">${escReport(fmt(d.fuelRange, " km", 1))}</div>
  	    </div>
  	    </div>

  	    <div class="note">
  	    Range method: ${escReport(d.fuelMethod)}.
  	    Limits: Speed ${escReport(d.limits.speed)} km/h, RPM ${escReport(d.limits.rpm)}, Temp ${escReport(d.limits.temp)}°C, Throttle ${escReport(d.limits.throttle)}%.
  	    </div>

  	    ${mapSnapshotHtml}

  	    <div class="section-title">Driver Information</div>

  	    <div class="driver-row">
  	    <div><strong>Name:</strong> ${escReport(driverName)}</div>
  	    <div><strong>Phone:</strong> ${escReport(driverPhone)}</div>
  	    <div><strong>Email:</strong> ${escReport(driverEmail)}</div>
  	    </div>

  	    <div class="bottom-grid">
  	    <div>
  	    <div class="section-title">Events At This Point</div>

  	    <table>
  	    <thead>
  	    <tr>
  	    <th>Event</th>
  	    </tr>
  	    </thead>

  	    <tbody>
  	    ${eventRows}
  	    </tbody>
  	    </table>
  	    </div>

  	    <div>
  	    <div class="section-title">Marker Context</div>

  	    <table>
  	    <thead>
  	    <tr>
  	    <th>Marker</th>
  	    <th>Details</th>
  	    </tr>
  	    </thead>

  	    <tbody>
  	    ${markerRows}
  	    </tbody>
  	    </table>
  	    </div>
  	    </div>
  	    </div>
  	    </body>
  	    </html>
  	    `;
  	  }

  	  async function openSinglePointPrintReport(point) {
  	    const w = window.open("", "_blank", "width=1100,height=800");

  	    if (!w) {
  	      alert("Print window was blocked by the browser. Allow popups for this site and try again.");
  	      return;
  	    }

  	    w.document.open();
  	    w.document.write(buildTrackitPrintLoadingHtml("Point Report"));
  	    w.document.close();

  	    const mapSnapshotHtml = await trackitPrepareSinglePointMapSnapshot(point);
  	    const html = buildSinglePointPrintReport(point, mapSnapshotHtml);

  	    if (!html) {
  	      alert("No valid point data is available to print.");
  	      try {
  	        w.close();
  	      } catch (_) {}
  	      return;
  	    }

  	    w.document.open();
  	    w.document.write(html);
  	    w.document.close();

  	    setTimeout(() => {
  	      try {
  	        w.focus();
  	        w.print();
  	      } catch (e) {
  	        console.warn("[TrackIT Print] Single point print failed:", e);
  	      }
  	    }, 350);
  	  }

  	  // --- Clear overlays when popup closes or new compare starts ---
  	  const clearCompareOverlays = () => {
  	    if (window._fineTrackCompareOverlay) {
  	      window._fineTrackCompareOverlay.setMap(null); window._fineTrackCompareOverlay = null;
  	    }
  	    if (window._fineTrackCompareOverlayPulse) {
  	      window._fineTrackCompareOverlayPulse.setMap(null); window._fineTrackCompareOverlayPulse = null;
  	    }
  	    if (window._fineTrackComparePulseTimer) {
  	      clearInterval(window._fineTrackComparePulseTimer); window._fineTrackComparePulseTimer = null;
  	    }
  	  };


  	  // ---------- Segments + Draw ----------
  	  const segments = []; let currentSegment = [],
  	  currentColor = path[0].raw.color || "#FFFF00",
  	  prevTail = null;
  	  for (let i = 0; i < path.length; i++) {
  	    const p = path[i],
  	    c = p.raw.color || "#FFFF00",
  	    prev = path[i-1];
  	    if (prev && haversineM(prev, p) < 3)continue;
  	    if (c !== currentColor) {
  	      if (currentSegment.length >= 2)segments.push({
  	        color: currentColor, points: currentSegment
  	      });
  	      if (prevTail && p) {
  	        const blend = mixColors(currentColor, c, 0.5); segments.push({
  	          color: blend, points: [prevTail, p]});
  	      }
  	      currentColor = c; currentSegment = [p];
  	    } else {
  	      currentSegment.push(p);
  	    }
  	    prevTail = p;
  	  }
  	  if (currentSegment.length >= 2)segments.push({
  	    color: currentColor, points: currentSegment
  	  });

  	  function trackitDarkenRouteColor(hex, factor) {
  	    const clean = String(hex || "#FFFF00").replace("#", "");

  	    if (!/^[0-9a-f]{6}$/i.test(clean)) {
  	      return "#006600";
  	    }

  	    const safeFactor = Math.max(0, Math.min(1, Number(factor) || 0.55));

  	    const r = Math.round(parseInt(clean.slice(0, 2), 16) * safeFactor);
  	    const g = Math.round(parseInt(clean.slice(2, 4), 16) * safeFactor);
  	    const b = Math.round(parseInt(clean.slice(4, 6), 16) * safeFactor);

  	    return "#" + [r,
  	      g,
  	      b]
  	    .map(v => v.toString(16).padStart(2, "0"))
  	    .join("");
  	  }

  	  function trackitRouteChevronIcon(baseColor) {
  	    return {
  	      // Corrected +90° because Google was rendering the custom symbol 90° anti-clockwise.
  	      path: "M -10 -7 L -4 -7 L 6 0 L -4 7 L -10 7 L 0 0 Z",
  	      fillColor: trackitDarkenRouteColor(baseColor, 0.55),
  	      fillOpacity: 0.20,
  	      strokeColor: trackitDarkenRouteColor(baseColor, 0.34),
  	      strokeOpacity: 0.25,
  	      strokeWeight: 1,
  	      scale: 0.72,
  	      rotation: 270
  	    };
  	  }

  	  segments.forEach(seg => {
  	    const routePath = seg.points.map(p => ({
  	      lat: p.lat,
  	      lng: p.lng
  	    }));

  	    const poly = new google.maps.Polyline({
  	      path: routePath,
  	      strokeColor: seg.color,
  	      strokeOpacity: 0.9,
  	      strokeWeight: 10,
  	      geodesic: true,
  	      map,
  	      zIndex: 50
  	    });
  	    registerFineTrackOverlay(map, poly);

  	    const directionPolyline = new google.maps.Polyline({
  	      path: routePath,
  	      strokeOpacity: 0,
  	      strokeWeight: 10,
  	      geodesic: true,
  	      clickable: false,
  	      icons: [{
  	        icon: trackitRouteChevronIcon(seg.color),
  	        offset: "0px",
  	        repeat: "22px"
  	      }],
  	      map,
  	      zIndex: 51
  	    });
  	    registerFineTrackOverlay(map, directionPolyline);

  	    poly.addListener("mouseover", e=> {
  	      // Respect TripReplay lock: when active, hover should not fire
  	      if (isClickLocked || hoverPaused || App._tripReplayActive || map.__fineTrackRoutePanelMapLocked) return;
  	      const m = {
  	        lat: e.latLng.lat(),
  	        lng: e.latLng.lng()}; let nearest = seg.points[0],
  	      dMin = 1e9;
  	      for (const p of seg.points) {
  	        const d = haversineM(m, p); if (d < dMin) {
  	          nearest = p; dMin = d;
  	        }}
  	      if (nearest)showPopup(nearest, false);
  	    });

  	    poly.addListener("mouseout",
  	      ()=> {
  	        if (!isClickLocked&&!hoverPaused&&!App._tripReplayActive)clearPopup();
  	      });

  	    poly.addListener("click",
  	      e => {
  	        if (App._tripReplayActive) return; // Disable during replay

  	        // While the side panel is open, block normal route clicks.
  	        // Allow clicks only when selecting the second compare point.
  	        if (map.__fineTrackRoutePanelMapLocked && !(compareState.active && compareState.pointA)) {
  	          return;
  	        }

  	        const m = {
  	          lat: e.latLng.lat(),
  	          lng: e.latLng.lng()
  	        };
  	        let nearest = seg.points[0],
  	        dMin = 1e9;
  	        for (const p of seg.points) {
  	          const d = haversineM(m, p);
  	          if (d < dMin) {
  	            nearest = p; dMin = d;
  	          }
  	        }
  	        if (!nearest) return;

  	        // --- If in Compare Mode ---
  	        if (compareState.active && compareState.pointA) {
  	          if (compareState.markerB?.setMap) compareState.markerB.setMap(null);
  	          const heading = +nearest.raw["position.direction"] || 0;
  	          const fill = tractor.color || "#2196F3";
  	          compareState.markerB = new google.maps.Marker({
  	            position: {
  	              lat: nearest.lat,
  	              lng: nearest.lng
  	            },
  	            map,
  	            icon: {
  	              path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	              fillColor: fill,
  	              fillOpacity: 1,
  	              strokeWeight: 2,
  	              strokeColor: "#fff",
  	              rotation: heading,
  	              scale: 1.6,
  	              anchor: new google.maps.Point(0, 0),
  	              labelOrigin: new google.maps.Point(18, -26)
  	            },
  	            label: {
  	              text: "B",
  	              color: "#fff",
  	              fontSize: "26px",
  	              fontWeight: "950",
  	              className: "trackit-compare-marker-label"
  	            },
  	            zIndex: 2200
  	          });
  	          registerFineTrackOverlay(map, compareState.markerB);

  	          compareState.pointB = nearest;

  	          const baseInfo = buildSnapshotBlock(compareState.pointA.raw, "Point A");
  	          const afterInfo = buildSnapshotBlock(nearest.raw, "Point B");
  	          const compareHtml = buildInlineReport(compareState.pointA, nearest);

  	          const html = `
  	          <div style="padding:8px 0;">
  	          ${baseInfo}
  	          ${afterInfo}
  	          <div style="margin-top:10px;border-top:1px solid #333;padding-top:10px;">
  	          ${compareHtml}
  	          </div>
  	          </div>
  	          `;

  	          document.getElementById("fineTrackDetachedPopup")?.remove();
  	          attachLeftComparePanel(nearest, Hub);

  	          lockRouteMapForPanel();

  	          const panel = document.getElementById("fineTrackDetachedPopup");
  	          if (panel) {
  	            const body = panel.querySelector("#panelBody");
  	            if (body) {
  	              body.innerHTML = html;
  	            }
  	          }

  	          return;
  	        }

  	        // --- NORMAL CLICK: Keep marker, open left info panel ---
  	        hoverPaused = true;
  	        isClickLocked = true;

  	        const heading = +nearest.raw["position.direction"] || 0;
  	        const fill = tractor.color || "#2196F3";

  	        // ✅ Ensure marker stays (no recreation)
  	        if (!App.FineTrackSelectedMarker) {
  	          App.FineTrackSelectedMarker = new google.maps.Marker({
  	            position: {
  	              lat: nearest.lat, lng: nearest.lng
  	            },
  	            map,
  	            icon: {
  	              path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	              fillColor: fill,
  	              fillOpacity: 1,
  	              strokeWeight: 2,
  	              strokeColor: "#fff",
  	              rotation: heading,
  	              scale: 1.6,
  	              anchor: new google.maps.Point(0, 0)
  	            },
  	            zIndex: 2000
  	          });
  	          registerFineTrackOverlay(map, App.FineTrackSelectedMarker);
  	        } else {
  	          App.FineTrackSelectedMarker.setPosition({
  	            lat: nearest.lat, lng: nearest.lng
  	          });
  	          App.FineTrackSelectedMarker.setIcon({
  	            path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	            fillColor: fill,
  	            fillOpacity: 1,
  	            strokeWeight: 2,
  	            strokeColor: "#fff",
  	            rotation: heading,
  	            scale: 1.6,
  	            anchor: new google.maps.Point(0, 0)
  	          });
  	          App.FineTrackSelectedMarker.setMap(map); // ✅ force rebind to map
  	        }

  	        const markerContextHtml = routeMarkerContextHtml(nearest);
  	        // Build same info content, but now for panel
  	        const html = `
  	        <div style="font-size:13px;color:#fff;background:#0b0f14;padding:10px;border-radius:8px;">
  	        <div style="font-weight:600;margin-bottom:6px;">Driver Info</div>
  	        <div><b>Driver:</b> ${App?.SelectedTractor?.FVC?.Driver1?.name || "—"}</div>
  	        <div><b>Mobile:</b> ${App?.SelectedTractor?.FVC?.Driver1?.Data_Details?.employee_details?.contact_details?.phone_number || "—"}</div>
  	        <div><b>Email:</b> ${App?.SelectedTractor?.FVC?.Driver1?.email || "—"}</div>
  	        <div style="margin-top:10px;"><b>Time:</b> ${fmtTime(nearest.raw.timestamp)}</div>
  	        <div style="margin-top:6px;"><b>Engine Temp:</b> ${fmt(+nearest.raw["can.engine.temperature"], "°C")}</div>
  	        <div><b>Speed:</b> ${fmt(+nearest.raw["position.speed"], " km/h")}</div>
  	        <div><b>RPM:</b> ${fmt(+nearest.raw["can.engine.rpm"], " RPM")}</div>
  	        <div style="margin-top:6px;"><b>Altitude:</b> ${fmt(+nearest.raw["position.altitude"], " m")}</div>
  	        <div><b>Direction:</b> ${degToCompass(+nearest.raw["position.direction"])}</div>
  	        <div style="margin-top:8px;border-top:1px solid #333;padding-top:6px;">
  	        <b>Fuel Stats:</b><br>
  	        ${(() => {
  	          const tankCap = +tractor?.CAN?.Tank || 0;
  	          const fuelPct = smartFuelPct(nearest.raw, tankCap);
  	          const fuelLitres =
  	          (Number.isFinite(fuelPct) && Number.isFinite(tankCap) && tankCap > 0)
  	          ? (fuelPct / 100) * tankCap: null;

  	          const baselineKmPerL = getBaselineKmPerL();
  	          const fuelRange =
  	          (baselineKmPerL != null && fuelLitres != null)
  	          ? (fuelLitres * baselineKmPerL): null;

  	          return `
  	          Fuel Level: ${fmt(fuelPct, "%", 0)}<br>
  	          Fuel Litres: ${fmt(fuelLitres, " L", 1)}<br>
  	          Range: ${fmt(fuelRange, " km", 1)} <span style="opacity:.55;font-size:12px;">(CAN Avg)</span>
  	          `;
  	        })()}
  	        </div>

  	        <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	        <b>Events at this point:</b>
  	        ${(nearest.raw.events || []).length
  	        ? `<ul style="margin:4px 0;padding-left:16px;">${nearest.raw.events.map(e => `<li>${e}</li>`).join("")}</ul>`: `<div style="color:#999;font-size:12px;">No events</div>`}
  	        </div>
  	        </div>`;

  	        document.getElementById("fineTrackDetachedPopup")?.remove();
  	        attachLeftComparePanel(nearest, Hub);
  	        const panel = document.getElementById("fineTrackDetachedPopup");
  	        if (panel) {
  	          const body = panel.querySelector("#panelBody");
  	          if (body) body.innerHTML = html;
  	        }
  	      });



  	  });

  	  // ---------- START/END/STOP/IDLE ----------
  	  const makeMarker = (pos, color, label = "", scale = 1.5, z = 999) => {
  	    const marker = new google.maps.Marker({
  	      position: {
  	        lat: pos.lat,
  	        lng: pos.lng
  	      },
  	      map,
  	      icon: {
  	        path: "M0,0 m-6,0 a6,6 0 1,0 12,0 a6,6 0 1,0 -12,0",
  	        fillColor: color,
  	        fillOpacity: 1,
  	        strokeColor: "#fff",
  	        strokeWeight: 1.5,
  	        scale,
  	        anchor: new google.maps.Point(0,
  	          0),
  	        labelOrigin: new google.maps.Point(0,
  	          -14)
  	      },
  	      label: label
  	      ? {
  	        text: label,
  	        color: "#fff",
  	        fontSize: "11px",
  	        fontWeight: "bold"
  	      }: null,
  	      zIndex: z
  	    });
  	    registerFineTrackOverlay(map, marker);

  	    trackMarkers.push(marker);
  	    return marker;
  	  };

  	  // ---------- Marker report helpers ----------
  	  function markerReportNumber(v) {
  	    const n = Number(v);
  	    return Number.isFinite(n) ? n: null;
  	  }

  	  function markerReportTimestampMs(v) {
  	    if (v == null) return null;

  	    if (typeof v === "number") {
  	      return Number.isFinite(v) ? (v < 1e12 ? v * 1000: v): null;
  	    }

  	    if (typeof v === "string") {
  	      const n = Number(v);

  	      if (Number.isFinite(n)) {
  	        return n < 1e12 ? n * 1000: n;
  	      }

  	      const d = Date.parse(v);
  	      return Number.isFinite(d) ? d: null;
  	    }

  	    return null;
  	  }

  	  function markerReportFormatTime(v) {
  	    const ms = markerReportTimestampMs(v);

  	    if (!Number.isFinite(ms)) return "—";

  	    const d = new Date(ms);
  	    if (isNaN(d)) return "—";

  	    const pad = n => String(n).padStart(2, "0");

  	    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  	  }

  	  function markerReportFormatDuration(seconds) {
  	    const s = Number(seconds);

  	    if (!Number.isFinite(s) || s < 1) return "0s";

  	    const h = Math.floor(s / 3600);
  	    const m = Math.floor((s % 3600) / 60);
  	    const sec = Math.floor(s % 60);

  	    if (h) return `${h}h ${m}m ${sec}s`;
  	    if (m) return `${m}m ${sec}s`;
  	    return `${sec}s`;
  	  }

  	  function markerPointTime(point) {
  	    return markerReportFormatTime(point?.raw?.timestamp ?? point?.timestamp);
  	  }

  	  function closeRouteMarkerInfoWindow() {
  	    if (activeInfo?.close) {
  	      activeInfo.close();
  	      activeInfo = null;
  	    }

  	    try {
  	      if (window._fineTrackWarnHubInfo?.close) {
  	        window._fineTrackWarnHubInfo.close();
  	        window._fineTrackWarnHubInfo = null;
  	      }
  	    } catch (_) {}
  	  }

  	  function openMarkerReport(marker, title, lines) {
  	    if (!marker || !map) return;

  	    closeRouteMarkerInfoWindow();

  	    const safeLines = Array.isArray(lines) ? lines.filter(Boolean): [];

  	    const html = `
  	    <div style="
  	    font:14px system-ui,sans-serif;
  	    background:#111;
  	    border-radius:10px;
  	    padding:12px;
  	    min-width:240px;
  	    color:#fff;
  	    ">
  	    <div style="
  	    font-weight:600;
  	    font-size:15px;
  	    color:#CC6633;
  	    ">${title}</div>

  	    <div style="
  	    margin-top:6px;
  	    line-height:1.4em;
  	    ">
  	    ${safeLines.join("<br>")}
  	    </div>
  	    </div>
  	    `;

  	    window._fineTrackWarnHubInfo = new google.maps.InfoWindow({
  	      content: html
  	    });
  	    registerFineTrackOverlay(map, window._fineTrackWarnHubInfo);

  	    window._fineTrackWarnHubInfo.open(map, marker);
  	  }

  	  // ---------- Idle report helpers ----------
  	  const idleSegments = Array.isArray(tractor?.Events?.["Idle Event"])
  	  ? tractor.Events["Idle Event"]: [];

  	  function getIdleSegmentWindowMs(seg) {
  	    if (!seg || typeof seg !== "object") return null;

  	    const firstPoint = Array.isArray(seg.Points) && seg.Points.length
  	    ? seg.Points[0]: null;

  	    const lastPoint = Array.isArray(seg.Points) && seg.Points.length
  	    ? seg.Points[seg.Points.length - 1]: null;

  	    const startMs =
  	    markerReportTimestampMs(seg.start_iso) ||
  	    markerReportTimestampMs(seg.start) ||
  	    markerReportTimestampMs(firstPoint?.timestamp);

  	    let endMs = markerReportTimestampMs(lastPoint?.timestamp);

  	    if (!Number.isFinite(endMs) && Number.isFinite(startMs) && Number.isFinite(Number(seg.idle_seconds))) {
  	      endMs = startMs + Number(seg.idle_seconds) * 1000;
  	    }

  	    if (!Number.isFinite(startMs)) return null;

  	    if (!Number.isFinite(endMs)) {
  	      endMs = startMs;
  	    }

  	    return {
  	      startMs,
  	      endMs
  	    };
  	  }

  	  function getIdleSegmentPosition(seg) {
  	    if (!seg || typeof seg !== "object") return null;

  	    let lat = markerReportNumber(seg.lat ?? seg.latitude);
  	    let lng = markerReportNumber(seg.lon ?? seg.lng ?? seg.longitude);

  	    if ((!Number.isFinite(lat) || !Number.isFinite(lng)) && Array.isArray(seg.Points) && seg.Points.length) {
  	      const p = seg.Points[0];

  	      lat = markerReportNumber(
  	        p.lat ??
  	        p.latitude ??
  	        p.point?.["position.latitude"]
  	      );

  	      lng = markerReportNumber(
  	        p.lon ??
  	        p.lng ??
  	        p.longitude ??
  	        p.point?.["position.longitude"]
  	      );
  	    }

  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  	    return {
  	      lat,
  	      lng
  	    };
  	  }

  	  function findIdleSegmentForPoint(point) {
  	    if (!point || !idleSegments.length) return null;

  	    const pointMs = markerReportTimestampMs(point.raw?.timestamp ?? point.timestamp);
  	    const pointLat = markerReportNumber(point.lat ?? point.raw?.["position.latitude"]);
  	    const pointLng = markerReportNumber(point.lng ?? point.lon ?? point.raw?.["position.longitude"]);

  	    // Best match: timestamp inside idle segment.
  	    if (Number.isFinite(pointMs)) {
  	      for (const seg of idleSegments) {
  	        const win = getIdleSegmentWindowMs(seg);
  	        if (!win) continue;

  	        const padMs = 15000;

  	        if (pointMs >= win.startMs - padMs && pointMs <= win.endMs + padMs) {
  	          return seg;
  	        }
  	      }
  	    }

  	    // Fallback: nearby idle segment position.
  	    if (Number.isFinite(pointLat) && Number.isFinite(pointLng)) {
  	      for (const seg of idleSegments) {
  	        const pos = getIdleSegmentPosition(seg);
  	        if (!pos) continue;

  	        const d = haversineM(
  	          {
  	            lat: pointLat, lng: pointLng
  	          },
  	          {
  	            lat: pos.lat, lng: pos.lng
  	          }
  	        );

  	        if (d <= 60) {
  	          return seg;
  	        }
  	      }
  	    }

  	    return null;
  	  }

  	  function buildIdleMarkerReportLines(idleSeg) {
  	    const startText =
  	    markerReportFormatTime(idleSeg?.start_iso) ||
  	    markerReportFormatTime(idleSeg?.start) ||
  	    markerReportFormatTime(idleSeg?.Points?.[0]?.timestamp) ||
  	    "—";

  	    const idleText =
  	    idleSeg?.idle_human ||
  	    markerReportFormatDuration(idleSeg?.idle_seconds || 0);

  	    return [
  	      `Start: ${startText}`,
  	      `Idle: ${idleText}`
  	    ];
  	  }

  	  function openIdleMarkerReport(marker, point, idleSeg) {
  	    if (!marker || !idleSeg) return;

  	    openMarkerReport(
  	      marker,
  	      "Idle Event",
  	      buildIdleMarkerReportLines(idleSeg)
  	    );
  	  }

  	  // ---------- Stop report helpers ----------
  	  function isStoppedPoint(point) {
  	    const spd = Number(point?.raw?.["position.speed"]);
  	    return Number.isFinite(spd) && spd < 1;
  	  }

  	  function hasRawIdleEvent(point) {
  	    const evs = (point?.raw?.events || []).map(e => String(e || "").toLowerCase());
  	    return evs.some(e => e.includes("idle"));
  	  }

  	  function isConfirmedIdlePoint(point) {
  	    return !!findIdleSegmentForPoint(point) || hasRawIdleEvent(point);
  	  }

  	  function buildStopSegments(points) {
  	    const segments = [];
  	    let current = null;

  	    function flushCurrent() {
  	      if (current && current.points.length) {
  	        segments.push(current);
  	      }

  	      current = null;
  	    }

  	    points.forEach(point => {
  	      const stopped = isStoppedPoint(point);
  	      const idle = isConfirmedIdlePoint(point);

  	      // Red stop markers should be stopped-only.
  	      // Real idle gets yellow instead.
  	      if (stopped && !idle) {
  	        if (!current) {
  	          current = {
  	            points: []
  	          };
  	        }

  	        current.points.push(point);
  	      } else {
  	        flushCurrent();
  	      }
  	    });

  	    flushCurrent();

  	    return segments;
  	  }

  	  function getStopSegmentDurationSeconds(seg) {
  	    if (!seg || !Array.isArray(seg.points) || !seg.points.length) return 0;

  	    const first = seg.points[0];
  	    const last = seg.points[seg.points.length - 1];

  	    const startMs = markerReportTimestampMs(first.raw?.timestamp ?? first.timestamp);
  	    const endMs = markerReportTimestampMs(last.raw?.timestamp ?? last.timestamp);

  	    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return 0;

  	    return Math.max(0, Math.round((endMs - startMs) / 1000));
  	  }

  	  function buildStopMarkerReportLines(stopSeg) {
  	    const first = stopSeg?.points?.[0];
  	    const stoppedTime = markerPointTime(first);
  	    const duration = markerReportFormatDuration(getStopSegmentDurationSeconds(stopSeg));

  	    return [
  	      `Stopped Time: ${stoppedTime}`,
  	      `Duration: ${duration}`
  	    ];
  	  }

  	  // ---------- Start marker: green, time only ----------
  	  if (path.length) {
  	    const startMarker = makeMarker(path[0], "#00cc44", "START", 1.5, 1001);

  	    startMarker.addListener("click", () => {
  	      openMarkerReport(startMarker, "Start", [
  	        `Time: ${markerPointTime(path[0])}`
  	      ]);
  	    });
  	  }

  	  // ---------- End marker ----------
  	  if (path.length > 1) {
  	    const endPoint = path[path.length - 1];
  	    const endMarker = makeMarker(endPoint, "#cc0000", "END", 1.5, 1001);

  	    endMarker.addListener("click", () => {
  	      openMarkerReport(endMarker, "End", [
  	        `Time: ${markerPointTime(endPoint)}`
  	      ]);
  	    });
  	  }

  	  // ---------- Yellow idle markers: ONE marker per Idle Event ----------
  	  // Idle Event segments are authoritative. Plot the first tracking point in each
  	  // event only. Do not loop over every path point and do not combine segment
  	  // markers with raw idle markers, because that creates duplicate yellow dots.

  	  const idleMarkerBool = value => {
  	    if (value === true || value === 1) return true;
  	    if (value === false || value === 0 || value == null) return false;
  	    return String(value).trim().toLowerCase() === "true";
  	  };

  	  const idleMarkerPointMs = point =>
  	  markerReportTimestampMs(point?.raw?.timestamp ?? point?.timestamp);

  	  const idleMarkerTotal = point => {
  	    const raw = point?.raw || {};
  	    const n = Number(raw["idle.total"] ?? raw.totalidle);
  	    return Number.isFinite(n) && n >= 0 ? n: null;
  	  };

  	  const idleMarkerExplicitActive = point => {
  	    const raw = point?.raw || {};

  	    if (raw["idle.status"] !== undefined) {
  	      return idleMarkerBool(raw["idle.status"]);
  	    }

  	    if (raw.idle !== undefined) {
  	      return idleMarkerBool(raw.idle);
  	    }

  	    return hasRawIdleEvent(point);
  	  };

  	  // Use the widest reliable event window. Some event-engine versions return
  	  // only one Point, so idle_seconds must still extend the event end time.
  	  const idleMarkerSegmentWindow = seg => {
  	    if (!seg || typeof seg !== "object") return null;

  	    const firstSegPoint = Array.isArray(seg.Points) && seg.Points.length
  	    ? seg.Points[0]: null;

  	    const lastSegPoint = Array.isArray(seg.Points) && seg.Points.length
  	    ? seg.Points[seg.Points.length - 1]: null;

  	    const startMs =
  	    markerReportTimestampMs(seg.start_iso) ||
  	    markerReportTimestampMs(seg.start) ||
  	    markerReportTimestampMs(firstSegPoint?.timestamp);

  	    if (!Number.isFinite(startMs)) return null;

  	    const pointEndMs = markerReportTimestampMs(lastSegPoint?.timestamp);
  	    const idleSeconds = Number(seg.idle_seconds);
  	    const durationEndMs = Number.isFinite(idleSeconds) && idleSeconds >= 0
  	    ? startMs + idleSeconds * 1000: null;

  	    let endMs = startMs;
  	    if (Number.isFinite(pointEndMs)) endMs = Math.max(endMs, pointEndMs);
  	    if (Number.isFinite(durationEndMs)) endMs = Math.max(endMs, durationEndMs);

  	    return {
  	      startMs,
  	      endMs
  	    };
  	  };

  	  const idleMarkerDistanceM = (a, b) => {
  	    if (!a || !b) return Infinity;

  	    const aLat = Number(a.lat);
  	    const aLng = Number(a.lng);
  	    const bLat = Number(b.lat);
  	    const bLng = Number(b.lng);

  	    if (![aLat, aLng, bLat, bLng].every(Number.isFinite)) return Infinity;

  	    return haversineM(
  	      {
  	        lat: aLat, lng: aLng
  	      },
  	      {
  	        lat: bLat, lng: bLng
  	      }
  	    );
  	  };

  	  // Find the true first route point for the event. Prefer an explicitly active
  	  // idle point at/near the event start. Fall back to the closest route point,
  	  // then to the first coordinate stored in the event itself.
  	  const firstPathPointForIdleSegment = seg => {
  	    const win = idleMarkerSegmentWindow(seg);
  	    if (!win) return null;

  	    const earlyToleranceMs = 5000;
  	    const lateToleranceMs = 15000;

  	    for (const point of path) {
  	      const pointMs = idleMarkerPointMs(point);
  	      if (!Number.isFinite(pointMs)) continue;
  	      if (pointMs < win.startMs - earlyToleranceMs) continue;
  	      if (pointMs > win.endMs + lateToleranceMs) break;

  	      if (idleMarkerExplicitActive(point)) {
  	        return point;
  	      }
  	    }

  	    let nearest = null;
  	    let nearestDiff = Infinity;

  	    for (const point of path) {
  	      const pointMs = idleMarkerPointMs(point);
  	      if (!Number.isFinite(pointMs)) continue;

  	      const diff = Math.abs(pointMs - win.startMs);
  	      if (diff < nearestDiff) {
  	        nearest = point;
  	        nearestDiff = diff;
  	      }
  	    }

  	    if (nearest && nearestDiff <= 120000) {
  	      return nearest;
  	    }

  	    const segPoint = Array.isArray(seg.Points) && seg.Points.length
  	    ? seg.Points[0]: null;

  	    const lat = Number(
  	      segPoint?.lat ??
  	      segPoint?.latitude ??
  	      segPoint?.point?.["position.latitude"] ??
  	      seg.lat ??
  	      seg.latitude
  	    );

  	    const lng = Number(
  	      segPoint?.lon ??
  	      segPoint?.lng ??
  	      segPoint?.longitude ??
  	      segPoint?.point?.["position.longitude"] ??
  	      seg.lon ??
  	      seg.lng ??
  	      seg.longitude
  	    );

  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  	    return {
  	      lat,
  	      lng,
  	      timestamp: win.startMs / 1000,
  	      raw: segPoint?.point || {
  	        timestamp: win.startMs / 1000,
  	        "position.latitude": lat,
  	        "position.longitude": lng,
  	        "idle.status": true,
  	        "idle.total": Number(seg.idle_seconds) || 0
  	      }
  	    };
  	  };

  	  const idleMarkerRecords = [];

  	  if (idleSegments.length) {
  	    // Primary path: exactly one candidate for each generated Idle Event.
  	    const sortedIdleSegments = idleSegments
  	    .map(seg => ({
  	      seg,
  	      win: idleMarkerSegmentWindow(seg)
  	    }))
  	    .filter(item => item.win)
  	    .sort((a, b) => a.win.startMs - b.win.startMs);

  	    sortedIdleSegments.forEach(item => {
  	      const point = firstPathPointForIdleSegment(item.seg);
  	      if (!point) return;

  	      // Defensive dedupe for duplicate/overlapping event objects. Two records
  	      // are considered the same idle event only when their time windows overlap
  	      // and their first positions are close. Consecutive genuine idle events
  	      // therefore remain separate.
  	      const duplicate = idleMarkerRecords.find(existing => {
  	        const windowsOverlap =
  	        item.win.startMs <= existing.win.endMs + 2000 &&
  	        existing.win.startMs <= item.win.endMs + 2000;

  	        const sameStart =
  	        Math.abs(item.win.startMs - existing.win.startMs) <= 2000;

  	        const closePosition = idleMarkerDistanceM(point, existing.point) <= 30;

  	        return sameStart || (windowsOverlap && closePosition);
  	      });

  	      if (duplicate) {
  	        // Keep the earliest marker position, but retain the event with the
  	        // longest reported duration for the click report.
  	        const existingSeconds = Number(duplicate.seg?.idle_seconds) || 0;
  	        const candidateSeconds = Number(item.seg?.idle_seconds) || 0;

  	        if (candidateSeconds > existingSeconds) {
  	          duplicate.seg = item.seg;
  	          duplicate.win.endMs = Math.max(duplicate.win.endMs, item.win.endMs);
  	        }

  	        return;
  	      }

  	      idleMarkerRecords.push({
  	        point,
  	        seg: item.seg,
  	        win: item.win
  	      });
  	    });
  	  } else {
  	    // Historical fallback only when no generated Idle Event segments exist.
  	    // Ignore isolated false packets and use the increasing Flespi counter to
  	    // keep one continuous raw sequence together.
  	    let rawSequence = null;

  	    const flushRawSequence = () => {
  	      if (rawSequence?.point) {
  	        idleMarkerRecords.push(rawSequence);
  	      }
  	      rawSequence = null;
  	    };

  	    path.forEach(point => {
  	      if (!idleMarkerExplicitActive(point)) return;

  	      const pointMs = idleMarkerPointMs(point);
  	      const total = idleMarkerTotal(point);

  	      const counterReset =
  	      rawSequence &&
  	      total != null &&
  	      rawSequence.lastTotal != null &&
  	      total + 0.001 < rawSequence.lastTotal;

  	      const staleGap =
  	      rawSequence &&
  	      Number.isFinite(pointMs) &&
  	      Number.isFinite(rawSequence.lastMs) &&
  	      pointMs - rawSequence.lastMs > 185000;

  	      if (!rawSequence || counterReset || staleGap) {
  	        flushRawSequence();
  	        rawSequence = {
  	          point,
  	          seg: null,
  	          win: {
  	            startMs: pointMs,
  	            endMs: pointMs
  	          },
  	          lastMs: pointMs,
  	          lastTotal: total,
  	          maxIdleTotal: total ?? 0
  	        };
  	        return;
  	      }

  	      rawSequence.lastMs = pointMs;
  	      rawSequence.lastTotal = total;
  	      rawSequence.win.endMs = Number.isFinite(pointMs)
  	      ? pointMs: rawSequence.win.endMs;

  	      if (total != null && total > rawSequence.maxIdleTotal) {
  	        rawSequence.maxIdleTotal = total;
  	      }
  	    });

  	    flushRawSequence();
  	  }

  	  idleMarkerRecords.forEach(record => {
  	    const firstPoint = record.point;
  	    if (!firstPoint) return;

  	    const marker = makeMarker(firstPoint, "#ffcc00", "", 1.5, 999);

  	    marker.addListener("click", () => {
  	      if (record.seg) {
  	        openIdleMarkerReport(marker, firstPoint, record.seg);
  	        return;
  	      }

  	      openMarkerReport(marker, "Idle Event", [
  	        `Start: ${markerPointTime(firstPoint)}`,
  	        `Idle: ${markerReportFormatDuration(record.maxIdleTotal || 0)}`
  	      ]);
  	    });
  	  });

  	  // ---------- Red stopped markers ----------
  	  const stopSegments = buildStopSegments(path);

  	  stopSegments.forEach(stopSeg => {
  	    const first = stopSeg.points[0];
  	    if (!first) return;

  	    const marker = makeMarker(first, "#cc0000", "", 1.25, 998);

  	    marker.addListener("click", () => {
  	      openMarkerReport(marker, "Stopped", buildStopMarkerReportLines(stopSeg));
  	    });
  	  });
  	  // ---------- ESC ----------
  	  window.removeEventListener("keydown",
  	    window._fineTrackKeyHandler);
  	  window._fineTrackKeyHandler = e=> {
  	    if (e.key === "Escape") {
  	      clearPopup();
  	    }};
  	  window.addEventListener("keydown", window._fineTrackKeyHandler);

  	  // ---------- Center Map ----------
  	  if (path.length) {
  	    const bounds = new google.maps.LatLngBounds();
  	    path.forEach(p => bounds.extend(p));
  	    map.fitBounds(bounds, {
  	      top: 80, right: 80, bottom: 80, left: 80
  	    });
  	    const currentZoom = map.getZoom();
  	    if (currentZoom > 18) map.setZoom(18); // optional upper limit
  	  }

  	  // === Add Event Markers (Fuel Gain / Fuel Loss) ===
  	  try {
  	    const events = App?.SelectedTractor?.Events || {};
  	    const gainEvents =
  	    Array.isArray(events["Fuel Gain (Refuel)"])
  	    ? events["Fuel Gain (Refuel)"]: Array.isArray(events["Fuel Gain"])
  	    ? events["Fuel Gain"]: [];

  	    const lossEvents = Array.isArray(events["Fuel Loss"]) ? events["Fuel Loss"]: [];

  	    const makeSVGMarker = (svgText, position, label, infoHtml, z = 1600) => {
  	      if (!svgText || !position) return;
  	      const iconUrl = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgText)}`;

  	      const marker = new google.maps.Marker({
  	        position,
  	        map,
  	        title: label || "",
  	        zIndex: z,
  	        icon: {
  	          url: iconUrl,
  	          scaledSize: new google.maps.Size(56, 56), // 48–64px looks good
  	          anchor: new google.maps.Point(28, 28) // centers it
  	        }
  	      });
  	      registerFineTrackOverlay(map, marker);

  	      if (infoHtml) {
  	        const info = new google.maps.InfoWindow({
  	          content: infoHtml
  	        });
  	        registerFineTrackOverlay(map, info);
  	        marker.addListener("click", () => info.open(map, marker));
  	      }
  	      return marker;
  	    };


  	    const makeInfo = (ev) => {
  	      const startTs = new Date((ev.Points?.[0]?.timestamp ?? 0) * 1000);
  	      return `
  	      <div style="font:13px system-ui;color:#fff;background:#111;padding:8px;border-radius:8px;min-width:200px;">
  	      <b>${ev.eventType || "Fuel Loss"}</b><br>
  	      <div style="opacity:.8">Time:</div>${startTs.toLocaleString("en-ZA")}<br>
  	      <div style="opacity:.8">Distance:</div>${ev.distance ?? "—"} m<br>
  	      <div style="opacity:.8">Avg:</div>${ev.AVG ?? "—"} km/h<br>
  	      <div style="opacity:.8">Max:</div>${ev.Max ?? "—"} km/h
  	      </div>`;
  	    };

  	    const addMarkers = (list, svg, labelPrefix) => {
  	      list.forEach((ev, i) => {
  	        const pt = ev.Points?.[0];
  	        if (!pt) return;

  	        const lat = Number(pt.lat ?? pt.point?.["position.latitude"]);
  	        const lng = Number(pt.lon ?? pt.point?.["position.longitude"]);
  	        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;


  	        makeSVGMarker(
  	          svg,
  	          {
  	            lat, lng
  	          },
  	          `${labelPrefix} #${i + 1}`,
  	          makeInfo(ev)
  	        );
  	      });
  	    };

  	    addMarkers(gainEvents,
  	      Images?.FuelGain,
  	      "Fuel Gain");
  	    addMarkers(lossEvents,
  	      Images?.FuelLoss,
  	      "Fuel Loss");

  	  } catch (err) {
  	    console.warn("Fuel Event marker error:",
  	      err);
  	  }

  	  // === Add Location Polygons & Entrance Markers === (Backendless structure)
  	  try {
  	    const locations = Locations; // already destructured from args
  	    if (Array.isArray(locations) && locations.length) {
  	      locations.forEach(loc => {
  	        const color = loc.Color || "#00BCD4";
  	        const name = loc.Name || loc.REF || "Unnamed";

  	        // Backendless polygon + entrance point
  	        const polyData = loc.Polygon?.boundary?.points; // [{x, y}, ...]
  	        const entry = loc.EntrancePoint
  	        ? {
  	          lat: Number(loc.EntrancePoint.y), lng: Number(loc.EntrancePoint.x)
  	        }: null;

  	        // --- Draw Polygon ---
  	        if (Array.isArray(polyData) && polyData.length) {
  	          const path = polyData.map(p => ({
  	            lat: Number(p.y), lng: Number(p.x)
  	          }));
  	          const polygon = new google.maps.Polygon({
  	            paths: path,
  	            strokeColor: color,
  	            strokeOpacity: 0.9,
  	            strokeWeight: 2,
  	            fillColor: color,
  	            fillOpacity: 0.25,
  	            map,
  	            zIndex: 1
  	          });
  	          registerFineTrackOverlay(map, polygon);

  	          const info = new google.maps.InfoWindow({
  	            content: `
  	            <div style="font:14px system-ui,sans-serif;">
  	            <b>${name}</b><br>
  	            <div style="color:#666;margin-top:4px;">${loc.Type || ""}</div>
  	            </div>`
  	          });
  	          registerFineTrackOverlay(map, info);

  	          polygon.addListener("click", e => info.open(map, {
  	            position: e.latLng
  	          }));
  	          polygon.addListener("mouseover", () => polygon.setOptions({
  	            fillOpacity: 0.45
  	          }));
  	          polygon.addListener("mouseout", () => polygon.setOptions({
  	            fillOpacity: 0.25
  	          }));
  	        }

  	        // --- Entrance Marker ---
  	        if (entry) {
  	          const marker = new google.maps.Marker({
  	            position: entry,
  	            map,
  	            title: `${name} Entrance`,
  	            icon: {
  	              path: google.maps.SymbolPath.CIRCLE,
  	              scale: 4,
  	              fillColor: color,
  	              fillOpacity: 1,
  	              strokeColor: "#fff",
  	              strokeWeight: 1.5
  	            },
  	            zIndex: 2
  	          });
  	          registerFineTrackOverlay(map, marker);

  	          const info = new google.maps.InfoWindow({
  	            content: `
  	            <div style="font:13px system-ui,sans-serif;color:#333;">
  	            🚪 <b>${name}</b><br>
  	            <div style="color:#666;margin-top:3px;">Entrance Point</div>
  	            </div>`
  	          });
  	          registerFineTrackOverlay(map, info);

  	          marker.addListener("click", () => info.open(map, marker));
  	        }
  	      });
  	    }
  	  } catch (err) {
  	    console.warn("Location render error:",
  	      err);
  	  }

  	  // ======================================================================
  	  // ============ TripReplay (Centered Launcher + Extended Speed) ==========
  	  // ======================================================================
  	  (function tripReplayController() {
  	    if (!map || !tractor || !Array.isArray(tractor.Tracking) || !tractor.Tracking.length) return;
  	    const replayPath = path;
  	    const tractorColor = tractor.color || "#2196F3";

  	    // Clean previous instances
  	    ["fineTrackReplayPanel",
  	      "fineTrackReplayLauncher",
  	      "fineTrackReplayPulseStyle"].forEach(id => {
  	        const el = document.getElementById(id);
  	        if (el)el.remove();
  	      });

  	    // --- Inject pulse keyframes ---
  	    const pulseStyle = document.createElement("style");
  	    registerFineTrackElement(map, pulseStyle);

  	    pulseStyle.id = "fineTrackReplayPulseStyle";
  	    pulseStyle.textContent = `
  	    @keyframes pulse {
  	    0% { box-shadow: 0 0 0 0 rgba(204,102,51,0.7); }
  	    70% { box-shadow: 0 0 0 8px rgba(204,102,51,0); }
  	    100% { box-shadow: 0 0 0 0 rgba(204,102,51,0); }
  	    }
  	    `;
  	    document.head.appendChild(pulseStyle);

  	    // --- Square Launcher Button ---
  	    const launcher = document.createElement("div");
  	    registerFineTrackElement(map, launcher);

  	    launcher.id = "fineTrackReplayLauncher";
  	    Object.assign(launcher.style,
  	      {
  	        position: "absolute",
  	        bottom: "14px",
  	        left: "14px",
  	        width: "48px",
  	        height: "48px",
  	        borderRadius: "10px",
  	        background: "rgba(0,0,0,0.6)",
  	        display: "flex",
  	        alignItems: "center",
  	        justifyContent: "center",
  	        color: "#CC6633",
  	        cursor: "pointer",
  	        zIndex: 9998,
  	        userSelect: "none",
  	        fontSize: "24px",
  	        fontWeight: "bold",
  	        transition: "transform 0.2s ease, box-shadow 0.2s ease"
  	      });
  	    launcher.innerHTML = "▶";
  	    map.getDiv().appendChild(launcher);

  	    // Hover pulse
  	    launcher.addEventListener("mouseenter",
  	      ()=> {
  	        launcher.style.animation = "pulse 1.6s infinite";
  	        launcher.style.transform = "scale(1.1)";
  	      });
  	    launcher.addEventListener("mouseleave",
  	      ()=> {
  	        launcher.style.animation = "none";
  	        launcher.style.transform = "scale(1.0)";
  	      });

  	    // --- Replay Panel ---
  	    const panel = document.createElement("div");
  	    registerFineTrackElement(map, panel);

  	    panel.id = "fineTrackReplayPanel";
  	    Object.assign(panel.style,
  	      {
  	        position: "absolute",
  	        bottom: "70px",
  	        left: "12px",
  	        background: "rgba(20,20,20,0.6)",
  	        color: "#fff",
  	        padding: "12px 14px",
  	        borderRadius: "10px",
  	        font: "13px system-ui",
  	        zIndex: 9999,
  	        width: "340px",
  	        boxShadow: "0 0 10px rgba(0,0,0,0.4)",
  	        userSelect: "none",
  	        display: "none"
  	      });
  	    panel.innerHTML = `
  	    <div style="display:flex;align-items:center;justify-content:space-between;">
  	    <div style="display:flex;gap:6px;">
  	    <button id="replayPlay"  style="width:38px;height:34px;border:none;border-radius:6px;background:#CC6633;color:#fff;cursor:pointer;font-weight:900;">▶</button>
  	    <button id="replayPause" style="width:38px;height:34px;border:none;border-radius:6px;background:#555;color:#fff;cursor:pointer;font-weight:900;">⏸</button>
  	    </div>
  	    <div id="replayClose" style="cursor:pointer;font-size:16px;font-weight:bold;">✕</div>
  	    </div>
  	    <div style="margin-top:10px;">Speed:
  	    <input id="replaySpeed" type="range" min="0.01" max="0.16" step="0.01" value="0.08" style="vertical-align:middle;width:180px;">
  	    <span id="replaySpeedVal">1×</span>
  	    </div>
  	    <div style="height:10px;background:#333;border-radius:4px;overflow:hidden;margin-top:6px;cursor:pointer;">
  	    <div id="replayProgress" style="height:100%;width:0%;background:${tractorColor};transition:width 0.1s;"></div>
  	    </div>
  	    `;
  	    map.getDiv().appendChild(panel);

  	    // --- Show / Hide Logic ---
  	    launcher.onclick = ()=> {
  	      panel.style.display = "block"; launcher.style.display = "none";
  	    };
  	    const closePanel = ()=> {
  	      stop(); panel.style.display = "none"; launcher.style.display = "flex";
  	    };
  	    panel.querySelector("#replayClose").onclick = closePanel;

  	    // --- State ---
  	    let idx = 0, playing = false, paused = false, timer = null;
  	    let replayMarker = null;
  	    const btnPlay = panel.querySelector("#replayPlay");
  	    const btnPause = panel.querySelector("#replayPause");
  	    const speedInput = panel.querySelector("#replaySpeed");
  	    const speedVal = panel.querySelector("#replaySpeedVal");
  	    const progBar = panel.querySelector("#replayProgress");
  	    const barContainer = progBar.parentElement;

  	    const BTN_ORANGE = "#CC6633";
  	    const BTN_GREY = "#555";

  	    function paintReplayButtons() {
  	      const isRunning = playing && !paused;

  	      // Play: orange when not playing, grey when playing.
  	      btnPlay.style.background = isRunning ? BTN_GREY: BTN_ORANGE;
  	      btnPlay.style.opacity = isRunning ? "0.82": "1";

  	      // Pause: opposite.
  	      btnPause.style.background = isRunning ? BTN_ORANGE: BTN_GREY;
  	      btnPause.style.opacity = isRunning ? "1": "0.82";
  	    }

  	    function formatReplaySpeedLabel(actualSpeed) {
  	      const displaySpeed = Number(actualSpeed) / 0.08;

  	      if (!Number.isFinite(displaySpeed)) {
  	        return "1×";
  	      }

  	      const rounded = Math.round(displaySpeed * 10) / 10;

  	      if (Math.abs(rounded - Math.round(rounded)) < 0.001) {
  	        return `${Math.round(rounded)}×`;
  	      }

  	      return `${rounded.toFixed(1)}×`;
  	    }

  	    speedInput.oninput = () => {
  	      speedVal.textContent = formatReplaySpeedLabel(speedInput.value);
  	    };

  	    // Force correct starting label.
  	    speedVal.textContent = formatReplaySpeedLabel(speedInput.value);
  	    const setReplayActive = on=> {
  	      App._tripReplayActive=!!on;
  	    };

  	    // --- Marker Helpers ---
  	    const initMarker = ()=> {
  	      if (replayMarker)replayMarker.setMap(null);
  	      const f = replayPath[0];
  	      replayMarker = new google.maps.Marker({
  	        position: f, map,
  	        icon: {
  	          path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	          fillColor: tractorColor, fillOpacity: 1,
  	          strokeWeight: 2, strokeColor: "#fff",
  	          rotation: +f.raw["position.direction"] || 0,
  	          scale: 1.8, anchor: new google.maps.Point(0, 0)
  	        },
  	        zIndex: 2000
  	      });
  	      registerFineTrackOverlay(map, replayMarker);
  	    };
  	    const updateMarker = p=> {
  	      if (!replayMarker)return;
  	      replayMarker.setPosition(p);
  	      replayMarker.setIcon({
  	        path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	        fillColor: tractorColor, fillOpacity: 1,
  	        strokeWeight: 2, strokeColor: "#fff",
  	        rotation: +p.raw["position.direction"] || 0,
  	        scale: 1.8, anchor: new google.maps.Point(0, 0)
  	      });
  	    };
  	    const setProgress = ()=> {
  	      const pct = Math.max(0, Math.min(100, (idx/(replayPath.length-1))*100));
  	      progBar.style.width = `${pct}%`;
  	    };

  	    // --- Seek ---
  	    const seekTo = fraction=> {
  	      idx = Math.max(0, Math.min(replayPath.length-1, Math.round(fraction*(replayPath.length-1))));
  	      const p = replayPath[idx];
  	      updateMarker(p); setProgress(); map.panTo(p);
  	    };
  	    barContainer.addEventListener("click", e=> {
  	      const rect = barContainer.getBoundingClientRect();
  	      const frac = (e.clientX-rect.left)/rect.width;
  	      seekTo(frac);
  	    });

  	    // --- Timestamp Playback ---
  	    const resetReplayToBeginning = (keepMarker) => {
  	      playing = false;
  	      paused = false;
  	      clearTimeout(timer);
  	      timer = null;
  	      setReplayActive(false);

  	      idx = 0;
  	      setProgress();

  	      if (keepMarker) {
  	        if (!replayMarker) {
  	          initMarker();
  	        } else {
  	          updateMarker(replayPath[0]);
  	        }

  	        map.panTo(replayPath[0]);
  	      } else if (replayMarker) {
  	        replayMarker.setMap(null);
  	        replayMarker = null;
  	      }

  	      paintReplayButtons();
  	    };

  	    const advance = () => {
  	      if (!playing || paused) return;

  	      idx++;

  	      // End of route:
  	      // reset to the beginning, stop playback, and reset button colours.
  	      if (idx >= replayPath.length) {
  	        resetReplayToBeginning(true);
  	        return;
  	      }

  	      const cur = replayPath[idx];
  	      const prev = replayPath[idx - 1];

  	      updateMarker(cur);
  	      setProgress();
  	      map.panTo(cur);

  	      const t1 = +prev.raw.timestamp;
  	      const t2 = +cur.raw.timestamp;

  	      let delta = (Number.isFinite(t1) && Number.isFinite(t2)) ? t2 - t1: 1000;
  	      if (delta <= 0) delta = 1000;

  	      const speed = parseFloat(speedInput.value || "0.08");
  	      timer = setTimeout(advance, delta / speed);
  	    };

  	    const play = () => {
  	      if (playing && !paused) return;

  	      // If user presses play after route ended or after reset, start cleanly.
  	      if (idx >= replayPath.length - 1) {
  	        idx = 0;
  	        setProgress();
  	      }

  	      if (!replayMarker) {
  	        initMarker();
  	      }

  	      playing = true;
  	      paused = false;
  	      setReplayActive(true);
  	      clearTimeout(timer);

  	      paintReplayButtons();
  	      advance();
  	    };

  	    const pause = () => {
  	      if (!playing) return;

  	      paused = true;
  	      playing = false;
  	      clearTimeout(timer);
  	      timer = null;
  	      setReplayActive(false);

  	      paintReplayButtons();
  	    };

  	    const stop = () => {
  	      resetReplayToBeginning(false);
  	    };

  	    map.__fineTrackReplayCleanup = () => {
  	      try {
  	        stop();
  	      } catch (_) {}

  	      try {
  	        panel.remove();
  	      } catch (_) {}

  	      try {
  	        launcher.remove();
  	      } catch (_) {}
  	    };

  	    btnPlay.onclick = play;
  	    btnPause.onclick = pause;

  	    paintReplayButtons();

  	    const replayEscapeHandler = e => {
  	      if (e.key === "Escape") closePanel();
  	    };

  	    window.addEventListener("keydown", replayEscapeHandler);
  	    map.__fineTrackDomControlListeners.push({
  	      target: window,
  	      event: "keydown",
  	      handler: replayEscapeHandler
  	    });
  	  })();

  	})({
  	  googleMapComponent, App, Locations, Images, Hub
  	});
  })(Map, AppData, Locations, ({ [`FuelLoss`]: '<svg xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" id="svg22349" inkscape:version="0.48.3.1 r9886" viewBox="0 0 430.2 440" sodipodi:version="0.32" version="1.0" sodipodi:docname="_svgclean2.svg">   <sodipodi:namedview id="base" bordercolor="#666666" inkscape:pageshadow="2" guidetolerance="10.0" pagecolor="#ffffff" gridtolerance="10.0" inkscape:window-maximized="0" inkscape:window-width="743" inkscape:zoom="1" objecttolerance="10.0" showgrid="false" borderopacity="1.0" inkscape:current-layer="layer1" inkscape:cx="215.02547" inkscape:cy="218.71371" inkscape:window-y="0" inkscape:window-x="0" inkscape:window-height="484" showborder="false" inkscape:pageopacity="0.0"/>   <sodipodi:namedview id="namedview4" bordercolor="#666666" inkscape:pageshadow="2" inkscape:window-y="25" pagecolor="#ffffff" inkscape:window-width="1280" inkscape:zoom="1.4" inkscape:window-x="0" borderopacity="1.0" inkscape:current-layer="layer1" inkscape:cx="330.58005" inkscape:cy="240.69922" inkscape:window-height="949" inkscape:pageopacity="0.0" inkscape:document-units="px"/>   <g id="layer1" inkscape:label="Calque 1" inkscape:groupmode="layer" transform="translate(-5.5995 -3.6428)">     <path id="path22357" inkscape:connector-curvature="0" sodipodi:nodetypes="ccssssccccccc" style="fill-rule:evenodd;fill:#e43434" d="m60.709 3.6428c-11.428 8.5712-52.98 53.709-52.98 53.709 0.0005 0-5.5895 220.45 1.3424 232.17 12.594 21.27 157.02 106.64 170.92 106.98 5.23 0.12 97.26-54.56 98.79-59.63 5.63-18.77 4.73-186.19 0.88-205.16-3.51-17.32-81.07-91.603-81.07-91.603l-137.88-36.465zm10.359 32.265c30.002 6.429 68.922 17.021 71.072 29.163-1.79 5-4.51 7.048-8.41 10.649-5.81 0.469-35.581-15.019-49.08-19.911-3.499-4.892-13.582-19.187-13.582-19.901z"/>     <path id="path22359" inkscape:connector-curvature="0" sodipodi:nodetypes="ccccccccccccssscccccccsc" style="opacity:.25;fill-rule:evenodd;fill:#4a4a4a" d="m196.11 38.852c-8.7-4.751-35.53-6.651-40 5.714-4.27 11.806 8.23 75.614 25.65 108.58 32.32-3.16 66.92-4.78 95.05-23.45-6.75-13.78-71.26-85.699-80.7-90.848zm-127.72-2.929c-15.714 11.429-14.026 36.219-14.026 36.219s71.313 15.524 80.723 5.2c-21.3-3.895-33.14-13.076-50.809-20.649-7.552-6.83-6.71-15.301-15.888-20.77zm-37.806 72.677c-2.857 10 33.643 96.87 33.643 96.87s-32.806 65.3-34.235 71.02c-1.429 5.71 35.735-37.64 37.164-50.5 1.428-12.86 2.143-31.95-0.714-37.66-2.858-5.72-37.287-81.16-35.858-79.73zm90.833 35.04c-17.14 25.72-38.568 52.86-38.568 52.86s42.858-38.57 45.718-44.29c2.85-5.71-8.58-10-7.15-8.57zm-40.711 82.15c0 12.85 36.431 87.14 36.431 87.14s12.14 15.71 12.14 8.57-47.142-84.29-48.571-95.71z"/>     <path id="path22361" inkscape:connector-curvature="0" sodipodi:nodetypes="cssccccssccssccccccc" style="opacity:.25;fill-rule:evenodd;fill:#000000" d="m353.73 324.55c-6.06 10.6-2.02 11.11 9.09 20.71 11.11 9.59 25.25 13.13 18.69 3.53-6.57-9.59-27.28-24.75-27.78-24.24zm-83.07-191.2c2.21-1.02 4.02-3.33 7.91-2.82 6.17 46.97 5.78 90.83 1.44 161.21 32.31 3.87 42.13 5.12 48.56 6.19 25.71 4.28 100.71 52.86 107.14 80.71 0.91 3.94-5.36 13.4-10.56 18.75 10.51 13.93-2.7 25.72-22.36 13.93-9.67 6.07-56.08 32.32-63.51 32.32-15.71 0-150.71-37.14-179.29-45.71-28.57-8.57-163.1-103.02-148.81-108.73-0.593 11.82 157.92 103.78 167.12 105.93-1.43-43.25 1.31-167.85 4.55-237.2 18.9-7.73 38.49-4.92 33.61-11.34-4.87-6.42-16.28-38.72-16.28-38.72l53.54 3.03c7.07 7.07 13.46 12.61 16.94 22.45z"/>     <path id="path22363" inkscape:connector-curvature="0" sodipodi:nodetypes="ccsscsc" style="fill-rule:evenodd;fill:#474747" d="m201.93 73.888c21.43-11.429 21.08-10.332 21.08-10.332s23.54-9.25 32.11 13.607 0.23 30.447-8.05 36.217c-4.95 3.45-20.49 9.51-20.49 9.51s-26.59-3.53-28.01-20.68c-1.43-17.139 2.94-32.868 3.36-28.322z"/>     <path id="path22365" inkscape:connector-curvature="0" sodipodi:nodetypes="css" style="fill-rule:evenodd;fill:#000000" d="m232.94 66.413c-11.77 1.992-13.64 40.217 10.68 38.567 23.58-1.59 6.32-41.444-10.68-38.567z"/>     <path id="path29389" inkscape:connector-curvature="0" sodipodi:nodetypes="cscsccccccccccccccccsccssccccscccccc" style="opacity:.5;fill-rule:evenodd;fill:#ffffff" d="m130.71 52.571s16.78 7.143 12.5 13.215c-4.29 6.071-25.72 19.285-25.72 19.285s31.79-10.714 32.5-17.5c0.72-6.785-18.92-15.357-19.28-15zm-95.358 58.929 37.143 67.86-3.929 13.21-33.214-81.07zm27.5 116.79h9.286l-38.929 48.92 29.643-48.92zm65.718-73.93-49.646 49.64-1.072 18.93 56.788 102.86-52.502-111.08 46.432-60.35zm116.31-91.189s-15.4-2.02-18.69-0.758c-3.28 1.263-25 11.87-25 11.87l20.46-7.071s-2.78 11.616-2.02 15.657 2.27-14.142 5.3-16.162c3.03-2.021 20.21-3.536 19.95-3.536zm-185.96-57.028-51.429 51.428 0.3571 231.43s2.1428-223.57 3.5719-227.86c1.428-4.283 48.214-55.354 47.5-54.997zm3.647-0.694 130.38 33.933-34.19 6.566 12.09-6.819-108.28-33.68z"/>   </g>   <metadata id="metadata13">     <rdf:RDF>       <cc:Work>         <dc:format>image/svg+xml</dc:format>         <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>         <cc:license rdf:resource="http://creativecommons.org/licenses/publicdomain/"/>         <dc:publisher>           <cc:Agent rdf:about="http://openclipart.org/">             <dc:title>Openclipart</dc:title>           </cc:Agent>         </dc:publisher>       </cc:Work>       <cc:License rdf:about="http://creativecommons.org/licenses/publicdomain/">         <cc:permits rdf:resource="http://creativecommons.org/ns#Reproduction"/>         <cc:permits rdf:resource="http://creativecommons.org/ns#Distribution"/>         <cc:permits rdf:resource="http://creativecommons.org/ns#DerivativeWorks"/>       </cc:License>     </rdf:RDF>   </metadata> </svg>',[`FuelGain`]: '<svg xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" id="svg22349" inkscape:version="0.48.3.1 r9886" viewBox="0 0 430.2 440" sodipodi:version="0.32" version="1.0" sodipodi:docname="_svgclean2.svg">   <g id="layer1" inkscape:label="Calque 1" inkscape:groupmode="layer" transform="translate(-5.5995 -3.6428)">     <path id="path22357" inkscape:connector-curvature="0" sodipodi:nodetypes="ccssssccccccc" style="fill-rule:evenodd;fill:#1e6de3" d="m60.709 3.6428c-11.428 8.5712-52.98 53.709-52.98 53.709 0.0005 0-5.5895 220.45 1.3424 232.17 12.594 21.27 157.02 106.64 170.92 106.98 5.23 0.12 97.26-54.56 98.79-59.63 5.63-18.77 4.73-186.19 0.88-205.16-3.51-17.32-81.07-91.603-81.07-91.603l-137.88-36.465zm10.359 32.265c30.002 6.429 68.922 17.021 71.072 29.163-1.79 5-4.51 7.048-8.41 10.649-5.81 0.469-35.581-15.019-49.08-19.911-3.499-4.892-13.582-19.187-13.582-19.901z"/>     <path id="path22359" style="opacity:.25;fill-rule:evenodd;fill:#4a4a4a" d="m196.11 38.852c-8.7-4.751-35.53-6.651-40 5.714-4.27 11.806 8.23 75.614 25.65 108.58 32.32-3.16 66.92-4.78 95.05-23.45-6.75-13.78-71.26-85.699-80.7-90.848zm-127.72-2.929c-15.714 11.429-14.026 36.219-14.026 36.219s71.313 15.524 80.723 5.2c-21.3-3.895-33.14-13.076-50.809-20.649-7.552-6.83-6.71-15.301-15.888-20.77zm-37.806 72.677c-2.857 10 33.643 96.87 33.643 96.87s-32.806 65.3-34.235 71.02c-1.429 5.71 35.735-37.64 37.164-50.5 1.428-12.86 2.143-31.95-0.714-37.66-2.858-5.72-37.287-81.16-35.858-79.73zm90.833 35.04c-17.14 25.72-38.568 52.86-38.568 52.86s42.858-38.57 45.718-44.29c2.85-5.71-8.58-10-7.15-8.57zm-40.711 82.15c0 12.85 36.431 87.14 36.431 87.14s12.14 15.71 12.14 8.57-47.142-84.29-48.571-95.71z"/>     <path id="path22361" style="opacity:.25;fill-rule:evenodd;fill:#000000" d="m353.73 324.55c-6.06 10.6-2.02 11.11 9.09 20.71 11.11 9.59 25.25 13.13 18.69 3.53-6.57-9.59-27.28-24.75-27.78-24.24zm-83.07-191.2c2.21-1.02 4.02-3.33 7.91-2.82 6.17 46.97 5.78 90.83 1.44 161.21 32.31 3.87 42.13 5.12 48.56 6.19 25.71 4.28 100.71 52.86 107.14 80.71 0.91 3.94-5.36 13.4-10.56 18.75 10.51 13.93-2.7 25.72-22.36 13.93-9.67 6.07-56.08 32.32-63.51 32.32-15.71 0-150.71-37.14-179.29-45.71-28.57-8.57-163.1-103.02-148.81-108.73-0.593 11.82 157.92 103.78 167.12 105.93-1.43-43.25 1.31-167.85 4.55-237.2 18.9-7.73 38.49-4.92 33.61-11.34-4.87-6.42-16.28-38.72-16.28-38.72l53.54 3.03c7.07 7.07 13.46 12.61 16.94 22.45z"/>     <path id="path22363" style="fill-rule:evenodd;fill:#474747" d="m201.93 73.888c21.43-11.429 21.08-10.332 21.08-10.332s23.54-9.25 32.11 13.607 0.23 30.447-8.05 36.217c-4.95 3.45-20.49 9.51-20.49 9.51s-26.59-3.53-28.01-20.68c-1.43-17.139 2.94-32.868 3.36-28.322z"/>     <path id="path22365" style="fill-rule:evenodd;fill:#000000" d="m232.94 66.413c-11.77 1.992-13.64 40.217 10.68 38.567 23.58-1.59 6.32-41.444-10.68-38.567z"/>     <path id="path29389" style="opacity:.5;fill-rule:evenodd;fill:#ffffff" d="m130.71 52.571s16.78 7.143 12.5 13.215c-4.29 6.071-25.72 19.285-25.72 19.285s31.79-10.714 32.5-17.5c0.72-6.785-18.92-15.357-19.28-15zm-95.358 58.929 37.143 67.86-3.929 13.21-33.214-81.07zm27.5 116.79h9.286l-38.929 48.92 29.643-48.92zm65.718-73.93-49.646 49.64-1.072 18.93 56.788 102.86-52.502-111.08 46.432-60.35zm116.31-91.189s-15.4-2.02-18.69-0.758c-3.28 1.263-25 11.87-25 11.87l20.46-7.071s-2.78 11.616-2.02 15.657 2.27-14.142 5.3-16.162c3.03-2.021 20.21-3.536 19.95-3.536zm-185.96-57.028-51.429 51.428 0.3571 231.43s2.1428-223.57 3.5719-227.86c1.428-4.283 48.214-55.354 47.5-54.997zm3.647-0.694 130.38 33.933-34.19 6.566 12.09-6.819-108.28-33.68z"/>   </g> </svg>' }), Hub, 'data:image/png;base64,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');
  AppData['SpinnerDone'] = true;
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function Markers2() {
  Markers = (await Promise.all(From.map(async item => {  Clock = (await asyncListFind(Clocking, async (Clock) => {


     return (await (async function(Timestamp, In, Out) {
    	return (In <= Timestamp) && (
    	    (Out == null && Timestamp >= In) ||
    	    (Out != null && Timestamp <= Out)
    	);

    })(((getObjectProperty(item, 'timestamp')) * 1000), (getObjectProperty(Clock, 'TimeIn')), (getObjectProperty(Clock, 'TimeOut'))));
    }));
  ; return ({ [`lat`]: false ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: false ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: undefined,[`color`]: undefined,[`Speed`]: false ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: false ? null : (getObjectProperty(item, 'position.direction')) });})));
  return Markers.concat((Refuel_List.concat((Fuel_Loss_List.concat((Over_Rev_Markers.concat((Over_Speed_Markers.concat((Over_Temp_Markers.concat((Max_Markers.concat(Idle_Markers)))))))))))))
}

/**
 * Describe this function...
 */
async function Locations2() {
  try {
    Locations = [];
    var j_list3 = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
    for (var j_index3 in j_list3) {
      j = j_list3[j_index3];
      var k_list3 = (getObjectProperty(j, 'Locations'));
      for (var k_index3 in k_list3) {
        k = k_list3[k_index3];
        addItemToList(Locations, k);
      }
    }

  } catch (error) {
    console.log(error);

  }
  return Locations
}


  await (async function(Map, AppData, Tractors, From, To, Live, Repeater, Track, Hub) {
  	/*
  	===============================================================================
  	FLEET IN FORM — TRACKIT MASTER CONTROLLER
  	Backendless Custom Code Block

  	ARGUMENT ORDER — CREATE THESE EXACTLY IN BACKENDLESS:
  	  0  Map
  	  1  AppData
  	  2  Tractors
  	  3  From
  	  4  To
  	  5  Live
  	  6  Repeater
  	  7  Track
  	  8  Hub

  	PURPOSE
  	  Replaces the large outer Codeless orchestration tree with one Custom Code block
  	  while preserving the existing TrackIT/FineTrack rendering and analysis engine.

  	IMPORTANT
  	  - Do NOT tick "Return result".
  	  - Keep the existing tracking-data custom function:
  	      fn_2cdb14e20aec99596e5725c4e3064843
  	  - This controller cancels stale live loops when a new TrackIT run starts.
  	  - It also stops itself if the map DOM is destroyed during app/page switching.
  	===============================================================================
  	*/

  	// -----------------------------------------------------------------------------
  	// Backendless supplies these Custom Code arguments directly:
  	// Map, AppData, Tractors, From, To, Live, Repeater, Track, Hub
  	// DO NOT redeclare them here.
  	// -----------------------------------------------------------------------------

  	// Normalise only values that are safe to mutate as function arguments.
  	if (!Array.isArray(Tractors)) Tractors = [];
  	Live = (Live === true);

  	// -----------------------------------------------------------------------------
  	// Master lifecycle / stale-run protection
  	// -----------------------------------------------------------------------------
  	const __trackitRoot =
  	  typeof window !== "undefined"
  	    ? window
  	    : (typeof globalThis !== "undefined" ? globalThis : {});

  	try {
  	  const previous = __trackitRoot.__FIF_TRACKIT_MASTER_RUNTIME__;
  	  if (previous && typeof previous.cancel === "function") {
  	    previous.cancel("superseded");
  	  }
  	} catch (_) {}

  	const __trackitRuntime = {
  	  id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
  	  cancelled: false,
  	  reason: "",
  	  startedAt: Date.now(),

  	  cancel(reason) {
  	    this.cancelled = true;
  	    this.reason = String(reason || "cancelled");
  	  }
  	};

  	__trackitRoot.__FIF_TRACKIT_MASTER_RUNTIME__ = __trackitRuntime;

  	function __trackitGetMapElement() {
  	  try {
  	    const candidates = [
  	      typeof Map?.el === "function" ? Map.el() : Map?.el,
  	      Map?.element,
  	      Map?.$el,
  	      Map?.map?.map?.getDiv?.(),
  	      Map?.map?.getDiv?.(),
  	      Map?.getDiv?.()
  	    ];

  	    for (const el of candidates) {
  	      if (el && typeof el === "object") return el;
  	    }
  	  } catch (_) {}

  	  return null;
  	}

  	function __trackitAlive() {
  	  try {
  	    if (__trackitRuntime.cancelled) return false;

  	    if (
  	      __trackitRoot.__FIF_TRACKIT_MASTER_RUNTIME__ !== __trackitRuntime
  	    ) {
  	      __trackitRuntime.cancel("replaced");
  	      return false;
  	    }

  	    // If Backendless has destroyed the old page/map, kill this run.
  	    const el = __trackitGetMapElement();

  	    if (
  	      el &&
  	      "isConnected" in el &&
  	      el.isConnected === false
  	    ) {
  	      __trackitRuntime.cancel("map-detached");
  	      return false;
  	    }

  	    return true;
  	  } catch (_) {
  	    return !__trackitRuntime.cancelled;
  	  }
  	}

  	async function __trackitSleep(ms) {
  	  let remaining = Number(ms);

  	  if (!Number.isFinite(remaining) || remaining < 0) remaining = 0;

  	  const deadline = Date.now() + remaining;

  	  while (Date.now() < deadline) {
  	    if (!__trackitAlive()) return false;

  	    const left = deadline - Date.now();
  	    await new Promise(resolve =>
  	      setTimeout(resolve, Math.min(250, Math.max(0, left)))
  	    );
  	  }

  	  return __trackitAlive();
  	}

  	function __trackitLog(level, ...args) {
  	  try {
  	    const fn = console?.[level] || console?.log;
  	    fn?.call(console, "[TrackIT Master]", ...args);
  	  } catch (_) {}
  	}

  	// Hard requirements. Fail safely instead of throwing into Backendless onOpen.
  	if (!AppData || typeof AppData !== "object") {
  	  __trackitLog("error", "AppData argument is missing. TrackIT run aborted safely.");
  	  __trackitRuntime.cancel("missing-appdata");
  	  return;
  	}

  	if (!Map) {
  	  __trackitLog("error", "Map argument is missing. TrackIT run aborted safely.");
  	  __trackitRuntime.cancel("missing-map");
  	  return;
  	}

  	__trackitLog(
  	  "log",
  	  "Starting",
  	  {
  	    runId: __trackitRuntime.id,
  	    tractorCount: Tractors.length,
  	    live: Live
  	  }
  	);

  	var Wait, Locations, Sorter, Decision, item, Tractors1, k, j, Tractor, Clocking, error, Clocking_Function, Stations, Idle_Markers, Max_Markers, Over_Temp_Markers, Over_Speed_Markers, Over_Rev_Markers, Fuel_Loss_List, Refuel_List, Markers, Clock;

  	function getObjectProperty(object, propPath) {
  	  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
  	    return object[propPath]
  	  }

  	  const propsNamesList = propPath.split('.')

  	  let result = object

  	  for (let i = 0; i < propsNamesList.length; i++) {
  	    if (!result || result[propsNamesList[i]] === undefined) {
  	      return
  	    }

  	    result = result[propsNamesList[i]]
  	  }

  	  return result
  	}

  	async function asyncListFilter(sourceList, callback) {
  	  const list = await Promise.all(sourceList.map(async source => ({
  	    source,
  	    value: await callback(source),
  	  })));

  	  const resultList = list.filter(item => item.value)

  	  return resultList.map(item => item.source)
  	}

  	function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

  	function sortBy(list, order) {
  	  return list.sort(function(elementA, elementB) {
  	     const a = elementA.value
  	     const b = elementB.value
  	     let result = 0

  	     if (a > b) result = 1
  	     if (a < b) result = -1

  	     return result * order
  	   })
  	}

  	async function asyncListSort(sourceList, order, callback) {
  	 const list = await Promise.all(sourceList.map(async source => ({
  	   source,
  	   value: await callback(source),
  	 })));

  	 sortBy(list, order);

  	 return list.map(item => item.source)
  	}

  	/**
  	 * Describe this function...
  	 */
  	async function LiveTrack() {
  	  if (!await __trackitSleep(500)) return;
  	  await (async function(Map) {
  	  	/* Inputs: Map
  	  	   Outputs: MapReady (boolean), MapObject (google.maps.Map), Wrapper (any), Element (DOM)
  	  	*/
  	  	return (async () => {
  	  	  // ---- Tunables (kept aggressive) ----
  	  	  const TIMEOUT_MS   = 10000; // hard cap (down from 12000)
  	  	  const STABLE_COUNT = 1;     // require 1 consecutive "good" tick (was 3)

  	  	  // ---- tiny utils ----
  	  	  const nextFrame = () => new Promise(r => requestAnimationFrame(r));
  	  	  const sleep = (ms) => new Promise(r => setTimeout(r, ms));
  	  	  const now = () => (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();

  	  	  const isGmAvailable = () =>
  	  	    typeof window !== "undefined" &&
  	  	    window.google && window.google.maps &&
  	  	    typeof window.google.maps.Map === "function";

  	  	  // Best-effort: if using the new loader, nudge it without stalling
  	  	  const tryImportMaps = async () => {
  	  	    try {
  	  	      if (window?.google?.maps?.importLibrary && !isGmAvailable()) {
  	  	        // Race with a single frame so we don't block the fast path
  	  	        await Promise.race([
  	  	          window.google.maps.importLibrary("maps"),
  	  	          nextFrame()
  	  	        ]);
  	  	      }
  	  	    } catch (_) { /* ignore */ }
  	  	  };

  	  	  // Broadened resolver (checks common wrapper shapes + duck-type)
  	  	  const extractMap = (candidate) => {
  	  	    if (!candidate) return null;
  	  	    try {
  	  	      // Already a google.maps.Map
  	  	      if (isGmAvailable() && candidate instanceof window.google.maps.Map) return candidate;

  	  	      // Common shapes
  	  	      const directCandidates = [];
  	  	      const push = (x) => { if (x) directCandidates.push(x); };

  	  	      push(candidate.map);
  	  	      if (typeof candidate.map === "function") push(candidate.map());
  	  	      push(candidate.map?.map);
  	  	      if (typeof candidate.map?.getMap === "function") push(candidate.map.getMap());
  	  	      if (typeof candidate.getMap === "function") push(candidate.getMap());
  	  	      push(candidate.googleMap);
  	  	      push(candidate.gMap);
  	  	      push(candidate.gmap);
  	  	      push(candidate.__map);
  	  	      push(candidate._map);
  	  	      push(candidate.api?.map);
  	  	      if (candidate.mapComponent?.getMap) push(candidate.mapComponent.getMap());
  	  	      push(candidate.$mapObject);
  	  	      push(candidate.$refs?.map?.$mapObject);

  	  	      // Evaluate the candidates
  	  	      for (const c of directCandidates) {
  	  	        if (!c) continue;
  	  	        if (isGmAvailable() && c instanceof window.google.maps.Map) return c;
  	  	        if (c && typeof c.getCenter === "function" && typeof c.panTo === "function") return c; // duck-typed
  	  	      }

  	  	      // Some wrappers expose map methods directly
  	  	      if (typeof candidate.getCenter === "function" && typeof candidate.panTo === "function") {
  	  	        return candidate;
  	  	      }
  	  	    } catch (_) {}
  	  	    return null;
  	  	  };

  	  	  const getEl = (candidate, mapInstance) => {
  	  	    try {
  	  	      if (!candidate) return mapInstance?.getDiv?.() || null;
  	  	      // typical wrapper patterns
  	  	      if (typeof candidate.el === "function") return candidate.el();
  	  	      if (candidate.el) return candidate.el;
  	  	      if (candidate.element) return candidate.element;
  	  	      if (candidate.$el) return candidate.$el;
  	  	      // fall back to the map's div if present
  	  	      if (mapInstance?.getDiv) return mapInstance.getDiv();
  	  	    } catch (_) {}
  	  	    return null;
  	  	  };

  	  	  const isWrapperLikelyValid = (candidate) =>
  	  	    !!candidate && (("map" in candidate) || ("el" in candidate) || ("element" in candidate) || ("center" in candidate));

  	  	  // ---- initial resolve (fast path) ----
  	  	  let wrapper = Map;
  	  	  let mapInstance = extractMap(wrapper);
  	  	  let el = getEl(wrapper, mapInstance);

  	  	  if (mapInstance) {
  	  	    return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	  	  }

  	  	  // Nudge the loader if needed, but don't block the loop
  	  	  tryImportMaps();

  	  	  const deadline = now() + TIMEOUT_MS;
  	  	  let stable = 0;

  	  	  // ---- high-frequency loop: rAF preferred, timer as fallback if background tab ----
  	  	  while (now() < deadline) {
  	  	    // Lightweight early re-checks
  	  	    if (!isWrapperLikelyValid(wrapper)) {
  	  	      // In background tabs rAF is throttled; use a tiny sleep fallback
  	  	      if (document.hidden) await sleep(10); else await nextFrame();
  	  	      continue;
  	  	    }

  	  	    if (!isGmAvailable()) {
  	  	      // Give the loader one frame (or 10ms if background) to settle
  	  	      if (document.hidden) await sleep(10); else await nextFrame();
  	  	      continue;
  	  	    }

  	  	    mapInstance = extractMap(wrapper);
  	  	    el = getEl(wrapper, mapInstance);
  	  	    const elOk = !el || !!el.isConnected || !!(el?.ownerDocument);

  	  	    if (mapInstance && elOk) {
  	  	      stable++;
  	  	      if (stable >= STABLE_COUNT) {
  	  	        return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	  	      }
  	  	    } else {
  	  	      stable = 0;
  	  	    }

  	  	    if (document.hidden) await sleep(10); else await nextFrame();
  	  	  }

  	  	  // Timeout: hand back what we found (useful for diagnostics)
  	  	  return { MapReady: false, MapObject: mapInstance || null, Wrapper: wrapper || null, Element: el || null };
  	  	})();

  	  })(Map);
  	  await (async function(googleMapComponent, locations, Centre, FineTrack, App) {
  	  	function addMinimalTruckPins(googleMapComponent, items, centre /* boolean */, fineTrack /* optional */, App /* AppData */) {

  	  	  // ============================================================
  	  	  // TrackIT Truck Pins + Compact Unified Map Controls
  	  	  // Removed: Scale, Rotate, North Up
  	  	  // Kept: Map Type, Zoom, Traffic, Street View, Fullscreen
  	  	  // ============================================================

  	  	  // ---------- AppData helpers ----------
  	  	  function setSelectedInApp(t) {
  	  	    let plain = t;

  	  	    try {
  	  	      plain = JSON.parse(JSON.stringify(t));
  	  	    } catch (_) {}

  	  	    let wrote = false;

  	  	    if (App?.data && typeof App.data === "object") {
  	  	      App.data.SelectedTractor = plain;
  	  	      wrote = true;
  	  	    }

  	  	    if (App && !("data" in App)) {
  	  	      App.SelectedTractor = plain;
  	  	      wrote = true;
  	  	    }

  	  	    if (!wrote && typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	  	      BackendlessUI.App.data.SelectedTractor = plain;
  	  	      wrote = true;
  	  	    }

  	  	    if (!wrote && typeof window !== "undefined" && window.AppData) {
  	  	      (window.AppData.data || window.AppData).SelectedTractor = plain;
  	  	      wrote = true;
  	  	    }

  	  	    try {
  	  	      BackendlessUI?.App?.refresh?.();
  	  	    } catch (_) {}

  	  	    if (!wrote) {
  	  	      console.warn("[TrackIT] AppData root not found. Could not set SelectedTractor.");
  	  	    }
  	  	  }

  	  	  function readSelectedTractorMarkerId() {
  	  	    try {
  	  	      if (App?.data && "SelectedTractorMarker" in App.data) {
  	  	        return App.data.SelectedTractorMarker || null;
  	  	      }

  	  	      if (App && !("data" in App) && "SelectedTractorMarker" in App) {
  	  	        return App.SelectedTractorMarker || null;
  	  	      }

  	  	      if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	  	        return BackendlessUI.App.data.SelectedTractorMarker || null;
  	  	      }

  	  	      if (typeof window !== "undefined" && window.AppData) {
  	  	        return (window.AppData.data || window.AppData).SelectedTractorMarker || null;
  	  	      }
  	  	    } catch (_) {}

  	  	    return null;
  	  	  }

  	  	  function writeSelectedTractorMarkerId(val /* string or null to clear */) {
  	  	    let wrote = false;

  	  	    const clearOrSet = (bag) => {
  	  	      if (!bag) return false;

  	  	      if (val == null) {
  	  	        try {
  	  	          delete bag.SelectedTractorMarker;
  	  	        } catch (_) {
  	  	          bag.SelectedTractorMarker = null;
  	  	        }
  	  	      } else {
  	  	        bag.SelectedTractorMarker = val;
  	  	      }

  	  	      return true;
  	  	    };

  	  	    if (App?.data) {
  	  	      wrote = clearOrSet(App.data) || wrote;
  	  	    }

  	  	    if (App && !("data" in App)) {
  	  	      wrote = clearOrSet(App) || wrote;
  	  	    }

  	  	    if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	  	      wrote = clearOrSet(BackendlessUI.App.data) || wrote;
  	  	    }

  	  	    if (typeof window !== "undefined" && window.AppData) {
  	  	      wrote = clearOrSet(window.AppData.data || window.AppData) || wrote;
  	  	    }

  	  	    try {
  	  	      BackendlessUI?.App?.refresh?.();
  	  	    } catch (_) {}

  	  	    if (!wrote) {
  	  	      console.warn("[TrackIT] AppData root not found. Could not write SelectedTractorMarker.");
  	  	    }
  	  	  }

  	  	  function getAppBag() {
  	  	    if (App?.data && typeof App.data === "object") return App.data;
  	  	    if (App && typeof App === "object" && !("data" in App)) return App;

  	  	    if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	  	      return BackendlessUI.App.data;
  	  	    }

  	  	    if (typeof window !== "undefined" && window.AppData) {
  	  	      return window.AppData.data || window.AppData;
  	  	    }

  	  	    return null;
  	  	  }

  	  	  function refreshApp() {
  	  	    try {
  	  	      BackendlessUI?.App?.refresh?.();
  	  	    } catch (_) {}
  	  	  }

  	  	  // ---------- Google InfoWindow spacing ----------
  	  	  function injectGoogleInfoWindowPaddingCss() {
  	  	    const old = document.getElementById("trackit-google-info-window-padding-css");
  	  	    if (old) old.remove();

  	  	    const style = document.createElement("style");
  	  	    style.id = "trackit-google-info-window-padding-css";

  	  	    style.textContent = `
  	  	    .gm-style .gm-style-iw-c {
  	  	    padding: 10px !important;
  	  	    border-radius: 14px !important;
  	  	    overflow: visible !important;
  	  	    background: transparent !important;
  	  	    box-shadow: none !important;
  	  	    max-height: none !important;
  	  	    }

  	  	    .gm-style .gm-style-iw-d {
  	  	    overflow: visible !important;
  	  	    max-height: none !important;
  	  	    padding: 0 !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .gm-style .gm-style-iw-d > div {
  	  	    overflow: visible !important;
  	  	    max-height: none !important;
  	  	    padding: 0 !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .gm-style .gm-style-iw-tc {
  	  	    filter: drop-shadow(0 2px 2px rgba(0,0,0,0.45)) !important;
  	  	    }

  	  	    .gm-style .gm-ui-hover-effect {
  	  	    top: 7px !important;
  	  	    right: 7px !important;
  	  	    width: 25px !important;
  	  	    height: 25px !important;
  	  	    border-radius: 50% !important;
  	  	    background: rgba(3, 8, 8, 0.64) !important;
  	  	    opacity: 1 !important;
  	  	    z-index: 50 !important;
  	  	    }

  	  	    .gm-style .gm-ui-hover-effect span {
  	  	    background-color: rgba(255,255,255,0.86) !important;
  	  	    width: 17px !important;
  	  	    height: 17px !important;
  	  	    margin: 4px !important;
  	  	    }

  	  	    .gm-style .gm-ui-hover-effect:hover {
  	  	    background: rgba(20, 20, 20, 0.86) !important;
  	  	    }
  	  	    `;

  	  	    document.head.appendChild(style);
  	  	  }

  	  	  // ---------- Compact unified map controls ----------
  	  	  function addTrackitUnifiedMapControl(map) {
  	  	    if (!map || typeof google === "undefined" || !(map instanceof google.maps.Map)) {
  	  	      console.error("[TrackIT Map Controls] Invalid map.");
  	  	      return;
  	  	    }

  	  	    const CONTROL_VERSION = "trackit-map-control-fleet-ces-shell-v11-whatsapp-driver-autosend";

  	  	    injectGoogleInfoWindowPaddingCss();

  	  	    map.setOptions({
  	  	      mapTypeControl: false,
  	  	      zoomControl: false,
  	  	      fullscreenControl: false,
  	  	      rotateControl: false,
  	  	      scaleControl: false,
  	  	      streetViewControl: false,

  	  	      // Keep Google map labels/POI labels clickable.
  	  	      clickableIcons: true
  	  	    });

  	  	    try {
  	  	      const panorama = map.getStreetView();
  	  	      panorama.setVisible(false);
  	  	      panorama.setOptions({
  	  	        enableCloseButton: false,
  	  	        addressControl: false,
  	  	        fullscreenControl: false,
  	  	        panControl: false,
  	  	        zoomControl: false,
  	  	        linksControl: false
  	  	      });
  	  	    } catch (_) {}

  	  	    const mapDiv = map.getDiv ? map.getDiv(): null;

  	  	    const existingControl =
  	  	    mapDiv?.querySelector?.(".trackit-compact-map-control") ||
  	  	    document.querySelector(".trackit-compact-map-control");

  	  	    if (
  	  	      map.__trackitUnifiedMapControlReady &&
  	  	      map.__trackitUnifiedMapControlVersion === CONTROL_VERSION &&
  	  	      existingControl
  	  	    ) {
  	  	      return;
  	  	    }

  	  	    // ---------- Directions Mode ----------
  	  	    const TRACKIT_WHATSAPP_SERVICE_NAME = "WhatsApp";
  	  	    const TRACKIT_WHATSAPP_METHOD_NAME = "Send_Directions_Template";

  	  	    function getTrackitDirectionsState() {
  	  	      if (!map.__trackitDirections) {
  	  	        map.__trackitDirections = {
  	  	          active: false,
  	  	          waitingFor: 0,

  	  	          point1: null,
  	  	          point2: null,

  	  	          point1Label: "",
  	  	          point2Label: "",

  	  	          // Populated only when the From point is an actual fleet vehicle.
  	  	          // Used by the WhatsApp Driver button to send the route directly to the assigned driver.
  	  	          fromVehicle: null,

  	  	          waypoints: [],
  	  	          activeSlot: "from",

  	  	          mapClickListener: null,
  	  	          directionsService: null,
  	  	          directionsRenderer: null,
  	  	          geocoder: null,

  	  	          pointMarkers: [],
  	  	          pointMarkerBySlot: {},

  	  	          popup: null
  	  	        };
  	  	      }

  	  	      const s = map.__trackitDirections;

  	  	      if (!Array.isArray(s.waypoints)) s.waypoints = [];
  	  	      if (!s.pointMarkerBySlot) s.pointMarkerBySlot = {};
  	  	      if (!s.activeSlot) s.activeSlot = "from";
  	  	      if (s.point1Label === undefined) s.point1Label = "";
  	  	      if (s.point2Label === undefined) s.point2Label = "";
  	  	      if (s.fromVehicle === undefined) s.fromVehicle = null;

  	  	      return s;
  	  	    }

  	  	    function setDirectionsButtonText(text) {
  	  	      try {
  	  	        const span = directionsBtn.querySelector("span");
  	  	        if (span) span.textContent = text;
  	  	        directionsBtn.title = text;
  	  	      } catch (_) {}
  	  	    }

  	  	    function paintDirectionsButton() {
  	  	      const s = getTrackitDirectionsState();

  	  	      directionsBtn.classList.toggle("active", !!s.active);

  	  	      if (!s.active) {
  	  	        setDirectionsButtonText("Directions");
  	  	        return;
  	  	      }

  	  	      if (!s.point1) {
  	  	        setDirectionsButtonText("Set From");
  	  	        return;
  	  	      }

  	  	      if (!s.point2) {
  	  	        setDirectionsButtonText("Set To");
  	  	        return;
  	  	      }

  	  	      setDirectionsButtonText("Directions");
  	  	    }

  	  	    function normaliseDirectionsLatLng(value) {
  	  	      if (!value) return null;

  	  	      if (value.lat !== undefined && value.lng !== undefined) {
  	  	        const lat = typeof value.lat === "function" ? value.lat(): Number(value.lat);
  	  	        const lng = typeof value.lng === "function" ? value.lng(): Number(value.lng);

  	  	        if (
  	  	          Number.isFinite(lat) &&
  	  	          Number.isFinite(lng) &&
  	  	          Math.abs(lat) <= 90 &&
  	  	          Math.abs(lng) <= 180
  	  	        ) {
  	  	          return {
  	  	            lat,
  	  	            lng
  	  	          };
  	  	        }
  	  	      }

  	  	      return null;
  	  	    }

  	  	    function makeDirectionsPointMarker(position, label) {
  	  	      const svg = `
  	  	      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  	  	      <path d="M16 41s13-12.2 13-25A13 13 0 1 0 3 16c0 12.8 13 25 13 25Z"
  	  	      fill="rgba(0,0,0,0.88)"
  	  	      stroke="rgba(255,138,61,0.95)"
  	  	      stroke-width="2"/>
  	  	      <circle cx="16" cy="16" r="8" fill="#ff8a3c"/>
  	  	      <text x="16" y="20" text-anchor="middle"
  	  	      font-family="Arial, sans-serif"
  	  	      font-size="11"
  	  	      font-weight="900"
  	  	      fill="#fff">${String(label || "•")}</text>
  	  	      </svg>
  	  	      `;

  	  	      return new google.maps.Marker({
  	  	        position,
  	  	        map,
  	  	        clickable: false,
  	  	        zIndex: 999,
  	  	        icon: {
  	  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
  	  	          scaledSize: new google.maps.Size(32, 42),
  	  	          anchor: new google.maps.Point(16, 41)
  	  	        }
  	  	      });
  	  	    }

  	  	    function clearDirectionsMarkers() {
  	  	      const s = getTrackitDirectionsState();

  	  	      (s.pointMarkers || []).forEach(marker => {
  	  	        try {
  	  	          marker.setMap(null);
  	  	        } catch (_) {}
  	  	      });

  	  	      Object.keys(s.pointMarkerBySlot || {}).forEach(slot => {
  	  	        try {
  	  	          s.pointMarkerBySlot[slot].setMap(null);
  	  	        } catch (_) {}
  	  	      });

  	  	      s.pointMarkers = [];
  	  	      s.pointMarkerBySlot = {};
  	  	    }

  	  	    function clearDirectionsPopup() {
  	  	      const s = getTrackitDirectionsState();

  	  	      try {
  	  	        if (s.popup) {
  	  	          s.popup.remove();
  	  	          s.popup = null;
  	  	        }
  	  	      } catch (_) {
  	  	        s.popup = null;
  	  	      }
  	  	    }

  	  	    function clearDirectionsRouteOnly() {
  	  	      const s = getTrackitDirectionsState();

  	  	      try {
  	  	        if (s.directionsRenderer) {
  	  	          s.directionsRenderer.setMap(null);
  	  	          s.directionsRenderer = null;
  	  	        }
  	  	      } catch (_) {
  	  	        s.directionsRenderer = null;
  	  	      }

  	  	      clearDirectionsMarkers();
  	  	    }

  	  	    function stopDirectionsMode() {
  	  	      const s = getTrackitDirectionsState();

  	  	      if (s.mapClickListener) {
  	  	        try {
  	  	          google.maps.event.removeListener(s.mapClickListener);
  	  	        } catch (_) {}

  	  	        s.mapClickListener = null;
  	  	      }

  	  	      clearDirectionsRouteOnly();
  	  	      clearDirectionsPopup();

  	  	      s.active = false;
  	  	      s.waitingFor = 0;
  	  	      s.point1 = null;
  	  	      s.point2 = null;
  	  	      s.point1Label = "";
  	  	      s.point2Label = "";
  	  	      s.fromVehicle = null;
  	  	      s.waypoints = [];
  	  	      s.activeSlot = "from";

  	  	      paintDirectionsButton();
  	  	    }

  	  	    function toggleDirectionsMode() {
  	  	      const s = getTrackitDirectionsState();

  	  	      if (s.active) {
  	  	        stopDirectionsMode();
  	  	      } else {
  	  	        startDirectionsMode();
  	  	      }
  	  	    }

  	  	    function getDirectionsSlotOrder() {
  	  	      const s = getTrackitDirectionsState();

  	  	      return [
  	  	        "from",
  	  	        ...s.waypoints.map((_, index) => `waypoint:${index}`),
  	  	        "to"
  	  	      ];
  	  	    }

  	  	    function getDirectionsPointForSlot(slot) {
  	  	      const s = getTrackitDirectionsState();

  	  	      if (slot === "from") return s.point1;
  	  	      if (slot === "to") return s.point2;

  	  	      if (String(slot).startsWith("waypoint:")) {
  	  	        const index = Number(String(slot).split(":")[1]);
  	  	        return s.waypoints[index]?.point || null;
  	  	      }

  	  	      return null;
  	  	    }

  	  	    function getNextEmptyDirectionsSlot() {
  	  	      const s = getTrackitDirectionsState();

  	  	      if (!s.point1) return "from";

  	  	      for (let i = 0; i < s.waypoints.length; i++) {
  	  	        if (!s.waypoints[i]?.point) return `waypoint:${i}`;
  	  	      }

  	  	      if (!s.point2) return "to";

  	  	      return "to";
  	  	    }

  	  	    function setNextDirectionsSlotAfter(slot) {
  	  	      const s = getTrackitDirectionsState();
  	  	      const order = getDirectionsSlotOrder();
  	  	      const index = order.indexOf(slot);

  	  	      for (let i = index + 1; i < order.length; i++) {
  	  	        if (!getDirectionsPointForSlot(order[i])) {
  	  	          s.activeSlot = order[i];
  	  	          return;
  	  	        }
  	  	      }

  	  	      s.activeSlot = getNextEmptyDirectionsSlot();
  	  	    }

  	  	    function getDirectionsMarkerLabelForSlot(slot) {
  	  	      if (slot === "from") return "A";
  	  	      if (slot === "to") return "B";

  	  	      if (String(slot).startsWith("waypoint:")) {
  	  	        const index = Number(String(slot).split(":")[1]);
  	  	        return String(index + 1);
  	  	      }

  	  	      return "•";
  	  	    }

  	  	    function formatDirectionsPointText(point, label) {
  	  	      if (label) return String(label);
  	  	      if (!point) return "—";

  	  	      return `${Number(point.lat).toFixed(5)}, ${Number(point.lng).toFixed(5)}`;
  	  	    }

  	  	    function setDirectionsInputValue(slot, text) {
  	  	      const s = getTrackitDirectionsState();
  	  	      const popup = s.popup;

  	  	      if (!popup) return;

  	  	      const input = popup.querySelector(`[data-route-slot="${slot}"]`);

  	  	      if (input) {
  	  	        input.value = text || "";
  	  	      }
  	  	    }

  	  	    function clearDirectionsMarkerForSlot(slot) {
  	  	      const s = getTrackitDirectionsState();

  	  	      try {
  	  	        if (s.pointMarkerBySlot?.[slot]) {
  	  	          s.pointMarkerBySlot[slot].setMap(null);
  	  	          delete s.pointMarkerBySlot[slot];
  	  	        }
  	  	      } catch (_) {}
  	  	    }

  	  	    function normaliseDirectionsVehicleMeta(vehicleMeta) {
  	  	      if (!vehicleMeta || typeof vehicleMeta !== "object") return null;

  	  	      return {
  	  	        id: String(vehicleMeta.id || "").trim(),
  	  	        label: String(vehicleMeta.label || "").trim(),
  	  	        registration: String(vehicleMeta.registration || "").trim(),
  	  	        tracker: String(vehicleMeta.tracker || "").trim(),
  	  	        driverName: String(vehicleMeta.driverName || "").trim(),
  	  	        driverPhone: String(vehicleMeta.driverPhone || "").trim()
  	  	      };
  	  	    }

  	  	    function setDirectionsSlot(slot, point, labelText, vehicleMeta) {
  	  	      const s = getTrackitDirectionsState();
  	  	      const normalised = normaliseDirectionsLatLng(point);

  	  	      if (!normalised) return false;

  	  	      s.active = true;

  	  	      const label = String(labelText || "").trim();

  	  	      if (slot === "from") {
  	  	        s.point1 = normalised;
  	  	        s.point1Label = label;

  	  	        // A place search or dropped pin passes no vehicleMeta, which correctly
  	  	        // removes the WhatsApp Driver action from the From point.
  	  	        s.fromVehicle = normaliseDirectionsVehicleMeta(vehicleMeta);
  	  	      } else if (slot === "to") {
  	  	        s.point2 = normalised;
  	  	        s.point2Label = label;
  	  	      } else if (String(slot).startsWith("waypoint:")) {
  	  	        const index = Number(String(slot).split(":")[1]);

  	  	        if (!s.waypoints[index]) {
  	  	          s.waypoints[index] = {
  	  	            point: null,
  	  	            label: ""
  	  	          };
  	  	        }

  	  	        s.waypoints[index].point = normalised;
  	  	        s.waypoints[index].label = label;
  	  	      }

  	  	      clearDirectionsMarkerForSlot(slot);

  	  	      s.pointMarkerBySlot[slot] = makeDirectionsPointMarker(
  	  	        normalised,
  	  	        getDirectionsMarkerLabelForSlot(slot)
  	  	      );

  	  	      setDirectionsInputValue(slot, formatDirectionsPointText(normalised, label));
  	  	      setNextDirectionsSlotAfter(slot);

  	  	      paintDirectionsButton();
  	  	      updateDirectionsPopup(null, null);

  	  	      if (s.point1 && s.point2) {
  	  	        calculateAndDisplayRoute();
  	  	      }

  	  	      return true;
  	  	    }

  	  	    function addDirectionsPoint(position, labelText, vehicleMeta) {
  	  	      const s = getTrackitDirectionsState();
  	  	      const point = normaliseDirectionsLatLng(position);

  	  	      if (!s.active || !point) return false;

  	  	      const slot = s.activeSlot || getNextEmptyDirectionsSlot();

  	  	      if (!getDirectionsPointForSlot(slot)) {
  	  	        return setDirectionsSlot(slot, point, labelText, vehicleMeta);
  	  	      }

  	  	      return setDirectionsSlot(getNextEmptyDirectionsSlot(), point, labelText, vehicleMeta);
  	  	    }

  	  	    function getVehicleDirectionsLabelFromTractor(t, fallback) {
  	  	      return String(
  	  	        t?.FID ||
  	  	        t?.ID ||
  	  	        t?.Registration ||
  	  	        t?.Tracker ||
  	  	        t?.Location?.ident ||
  	  	        fallback ||
  	  	        "Vehicle"
  	  	      );
  	  	    }

  	  	    function getDirectionsDriverDetailsFromTractor(t) {
  	  	      const ViewC = t?.ViewC || t?.viewC || {};
  	  	      const D1 = ViewC?.Driver1 || ViewC?.driver1 || null;

  	  	      if (!D1) {
  	  	        return {
  	  	          driverName: "",
  	  	          driverPhone: ""
  	  	        };
  	  	      }

  	  	      const driverName = String(
  	  	        D1.name ||
  	  	        [D1.first_name || D1.firstName, D1.last_name || D1.lastName]
  	  	        .filter(Boolean)
  	  	        .join(" ") ||
  	  	        D1.username ||
  	  	        ""
  	  	      ).trim();

  	  	      const driverPhone = String(
  	  	        D1?.Data_Details?.employee_details?.contact_details?.phone_number ||
  	  	        D1?.mobile ||
  	  	        D1?.phone ||
  	  	        D1?.tel ||
  	  	        ""
  	  	      ).trim();

  	  	      return {
  	  	        driverName,
  	  	        driverPhone
  	  	      };
  	  	    }

  	  	    function getDirectionsVehicleMetaFromTractor(t, fallbackId) {
  	  	      const driver = getDirectionsDriverDetailsFromTractor(t);

  	  	      return {
  	  	        id: String(fallbackId || t?.FID || t?.ID || t?.Registration || t?.Tracker || "").trim(),
  	  	        label: getVehicleDirectionsLabelFromTractor(t, fallbackId),
  	  	        registration: String(t?.Registration || t?.Location?.Registration || "").trim(),
  	  	        tracker: String(t?.Tracker || t?.Location?.ident || "").trim(),
  	  	        driverName: driver.driverName,
  	  	        driverPhone: driver.driverPhone
  	  	      };
  	  	    }

  	  	    function getDirectionsVehicleChoices(query) {
  	  	      const q = String(query || "").trim().toLowerCase();
  	  	      const pins = map.__truckPins || {};
  	  	      const rows = [];

  	  	      Object.keys(pins).forEach(id => {
  	  	        const pin = pins[id];
  	  	        const marker = pin?.marker;

  	  	        if (!marker || !marker.getPosition) return;

  	  	        const t = pin?.tractor || {};
  	  	        const meta = getDirectionsVehicleMetaFromTractor(t, id);
  	  	        const label = meta.label;
  	  	        const registration = meta.registration;
  	  	        const tracker = meta.tracker;

  	  	        const haystack = [label,
  	  	          registration,
  	  	          tracker,
  	  	          meta.driverName,
  	  	          id]
  	  	        .filter(Boolean)
  	  	        .join(" ")
  	  	        .toLowerCase();

  	  	        if (q && !haystack.includes(q)) return;

  	  	        rows.push({
  	  	          ...meta,
  	  	          id,
  	  	          position: marker.getPosition()
  	  	        });
  	  	      });

  	  	      rows.sort((a, b) => String(a.label).localeCompare(String(b.label), undefined, {
  	  	        numeric: true,
  	  	        sensitivity: "base"
  	  	      }));

  	  	      return rows.slice(0,
  	  	        10);
  	  	    }

  	  	    function findExactVehicleChoice(text) {
  	  	      const q = String(text || "").trim().toLowerCase();

  	  	      if (!q) return null;

  	  	      const choices = getDirectionsVehicleChoices(q);

  	  	      return choices.find(choice =>
  	  	        String(choice.label || "").toLowerCase() === q ||
  	  	        String(choice.registration || "").toLowerCase() === q ||
  	  	        String(choice.tracker || "").toLowerCase() === q ||
  	  	        String(choice.id || "").toLowerCase() === q
  	  	      ) || choices[0] || null;
  	  	    }

  	  	    function hideVehicleSuggest(input) {
  	  	      const box = input?.parentElement?.querySelector?.(".trackit-directions-vehicle-suggest");

  	  	      if (box) {
  	  	        box.classList.remove("visible");
  	  	        box.innerHTML = "";
  	  	      }
  	  	    }

  	  	    function showVehicleSuggest(input, slot) {
  	  	      if (!input) return;

  	  	      const box = input.parentElement?.querySelector?.(".trackit-directions-vehicle-suggest");

  	  	      if (!box) return;

  	  	      const choices = getDirectionsVehicleChoices(input.value);

  	  	      box.innerHTML = "";

  	  	      if (!choices.length || !String(input.value || "").trim()) {
  	  	        box.classList.remove("visible");
  	  	        return;
  	  	      }

  	  	      choices.forEach(choice => {
  	  	        const btn = document.createElement("button");
  	  	        btn.type = "button";
  	  	        btn.className = "trackit-directions-vehicle-option";

  	  	        btn.innerHTML = `
  	  	        <span class="trackit-directions-vehicle-id">${choice.label}</span>
  	  	        <span class="trackit-directions-vehicle-meta">Vehicle</span>
  	  	        `;

  	  	        btn.addEventListener("click", function (event) {
  	  	          event.preventDefault();
  	  	          event.stopPropagation();

  	  	          setDirectionsSlot(slot, choice.position, choice.label, choice);
  	  	          input.value = choice.label;
  	  	          hideVehicleSuggest(input);
  	  	        });

  	  	        box.appendChild(btn);
  	  	      });

  	  	      box.classList.add("visible");
  	  	    }

  	  	    function renderDirectionsWaypoints() {
  	  	      const s = getTrackitDirectionsState();
  	  	      const popup = s.popup;

  	  	      if (!popup) return;

  	  	      const wrap = popup.querySelector(".trackit-directions-waypoints");

  	  	      if (!wrap) return;

  	  	      wrap.innerHTML = "";

  	  	      s.waypoints.forEach((wp, index) => {
  	  	        const slot = `waypoint:${index}`;

  	  	        const row = document.createElement("div");
  	  	        row.className = "trackit-directions-search-line";
  	  	        row.setAttribute("data-route-row", slot);

  	  	        row.innerHTML = `
  	  	        <span>Stop ${index + 1}</span>
  	  	        <div class="trackit-directions-input-wrap">
  	  	        <input class="trackit-directions-waypoint" data-route-slot="${slot}" type="text" placeholder="Search place / vehicle ID / click map" autocomplete="off">
  	  	        <div class="trackit-directions-vehicle-suggest"></div>
  	  	        </div>
  	  	        <button type="button" class="trackit-directions-remove-stop">×</button>
  	  	        `;

  	  	        const input = row.querySelector("input");
  	  	        const removeBtn = row.querySelector(".trackit-directions-remove-stop");

  	  	        if (input) {
  	  	          input.value = formatDirectionsPointText(wp.point, wp.label);
  	  	          wireDirectionsInput(input, slot);
  	  	        }

  	  	        removeBtn?.addEventListener("click", function (event) {
  	  	          event.preventDefault();
  	  	          event.stopPropagation();

  	  	          removeDirectionsWaypoint(index);
  	  	        });

  	  	        wrap.appendChild(row);
  	  	      });
  	  	    }

  	  	    function addDirectionsWaypoint(point,
  	  	      labelText) {
  	  	      const s = getTrackitDirectionsState();
  	  	      const index = s.waypoints.length;

  	  	      s.waypoints.push({
  	  	        point: null,
  	  	        label: ""
  	  	      });

  	  	      renderDirectionsWaypoints();

  	  	      const slot = `waypoint:${index}`;
  	  	      s.activeSlot = slot;

  	  	      if (point) {
  	  	        setDirectionsSlot(slot, point, labelText);
  	  	      } else {
  	  	        updateDirectionsPopup(null, null);

  	  	        setTimeout(() => {
  	  	          try {
  	  	            s.popup?.querySelector?.(`[data-route-slot="${slot}"]`)?.focus?.();
  	  	          } catch (_) {}
  	  	        }, 0);
  	  	      }
  	  	    }

  	  	    function removeDirectionsWaypoint(index) {
  	  	      const s = getTrackitDirectionsState();

  	  	      clearDirectionsMarkerForSlot(`waypoint:${index}`);

  	  	      s.waypoints.splice(index, 1);

  	  	      Object.keys(s.pointMarkerBySlot || {}).forEach(slot => {
  	  	        if (slot.startsWith("waypoint:")) {
  	  	          clearDirectionsMarkerForSlot(slot);
  	  	        }
  	  	      });

  	  	      renderDirectionsWaypoints();

  	  	      s.waypoints.forEach((wp, newIndex) => {
  	  	        if (wp?.point) {
  	  	          const slot = `waypoint:${newIndex}`;
  	  	          s.pointMarkerBySlot[slot] = makeDirectionsPointMarker(wp.point, String(newIndex + 1));
  	  	        }
  	  	      });

  	  	      s.activeSlot = getNextEmptyDirectionsSlot();

  	  	      updateDirectionsPopup(null,
  	  	        null);

  	  	      if (s.point1 && s.point2) {
  	  	        calculateAndDisplayRoute();
  	  	      }
  	  	    }

  	  	    function wireDirectionsInput(input, slot) {
  	  	      if (!input || input.__trackitDirectionsInputWired) return;

  	  	      input.__trackitDirectionsInputWired = true;

  	  	      input.addEventListener("focus", function () {
  	  	        const s = getTrackitDirectionsState();
  	  	        s.activeSlot = slot;
  	  	        updateDirectionsPopup(null, null);
  	  	      });

  	  	      input.addEventListener("input", function () {
  	  	        const s = getTrackitDirectionsState();
  	  	        s.activeSlot = slot;

  	  	        if (slot === "from") {
  	  	          s.fromVehicle = null;
  	  	          updateDirectionsPopup(null, null);
  	  	        }

  	  	        showVehicleSuggest(input, slot);
  	  	      });

  	  	      input.addEventListener("keydown", function (event) {
  	  	        if (event.key !== "Enter") return;

  	  	        event.preventDefault();
  	  	        event.stopPropagation();

  	  	        const vehicle = findExactVehicleChoice(input.value);

  	  	        if (vehicle) {
  	  	          setDirectionsSlot(slot, vehicle.position, vehicle.label, vehicle);
  	  	          input.value = vehicle.label;
  	  	          hideVehicleSuggest(input);
  	  	          return;
  	  	        }

  	  	        geocodeDirectionsInput(input.value, slot);
  	  	      });

  	  	      input.addEventListener("blur",
  	  	        function () {
  	  	          setTimeout(() => hideVehicleSuggest(input), 180);
  	  	        });

  	  	      if (google.maps.places?.Autocomplete) {
  	  	        const autocomplete = new google.maps.places.Autocomplete(input, {
  	  	          fields: ["geometry", "name", "formatted_address"],
  	  	          types: ["geocode", "establishment"]
  	  	        });

  	  	        try {
  	  	          autocomplete.bindTo("bounds", map);
  	  	        } catch (_) {}

  	  	        autocomplete.addListener("place_changed", function () {
  	  	          const place = autocomplete.getPlace();
  	  	          const location = place?.geometry?.location;

  	  	          if (!location) {
  	  	            console.warn("[TrackIT Directions] Place has no geometry:", place);
  	  	            return;
  	  	          }

  	  	          const point = normaliseDirectionsLatLng(location);

  	  	          if (!point) return;

  	  	          const label = place.formatted_address || place.name || input.value;

  	  	          setDirectionsSlot(slot, point, label);
  	  	          input.value = label;
  	  	          hideVehicleSuggest(input);
  	  	        });
  	  	      } else {
  	  	        console.warn("[TrackIT Directions] Google Places library not loaded. Add libraries=places to your Google Maps script.");
  	  	      }
  	  	    }

  	  	    function geocodeDirectionsInput(text, slot) {
  	  	      const query = String(text || "").trim();

  	  	      if (!query) return;

  	  	      const vehicle = findExactVehicleChoice(query);

  	  	      if (vehicle) {
  	  	        setDirectionsSlot(slot, vehicle.position, vehicle.label, vehicle);
  	  	        return;
  	  	      }

  	  	      const s = getTrackitDirectionsState();

  	  	      if (!s.geocoder) {
  	  	        s.geocoder = new google.maps.Geocoder();
  	  	      }

  	  	      s.geocoder.geocode({
  	  	        address: query
  	  	      }, function (results, status) {
  	  	        if (status === "OK" && results?.[0]?.geometry?.location) {
  	  	          const point = normaliseDirectionsLatLng(results[0].geometry.location);
  	  	          const label = results[0].formatted_address || query;

  	  	          if (point) {
  	  	            setDirectionsSlot(slot, point, label);
  	  	          }

  	  	          return;
  	  	        }

  	  	        console.warn("[TrackIT Directions] Geocode failed:", status, query);
  	  	        updateDirectionsStatusText("Search failed. Try a more specific address or vehicle ID.");
  	  	      });
  	  	    }

  	  	    function formatDirectionsDistance(route) {
  	  	      let metres = 0;

  	  	      try {
  	  	        route.legs.forEach(leg => {
  	  	          metres += Number(leg.distance?.value || 0);
  	  	        });
  	  	      } catch (_) {}

  	  	      if (!metres) return "—";

  	  	      if (metres >= 1000) {
  	  	        return `${(metres / 1000).toFixed(1).replace(/\.0$/, "")} km`;
  	  	      }

  	  	      return `${Math.round(metres)} m`;
  	  	    }

  	  	    function formatDirectionsDuration(route) {
  	  	      let seconds = 0;

  	  	      try {
  	  	        route.legs.forEach(leg => {
  	  	          seconds += Number(leg.duration?.value || 0);
  	  	        });
  	  	      } catch (_) {}

  	  	      if (!seconds) return "—";

  	  	      const mins = Math.round(seconds / 60);

  	  	      if (mins < 60) return `${mins} min`;

  	  	      const h = Math.floor(mins / 60);
  	  	      const m = mins % 60;

  	  	      return m ? `${h} hr ${m} min`: `${h} hr`;
  	  	    }

  	  	    function updateDirectionsStatusText(text) {
  	  	      const s = getTrackitDirectionsState();
  	  	      const status = s.popup?.querySelector?.(".trackit-directions-status");

  	  	      if (status) {
  	  	        status.textContent = text;
  	  	      }
  	  	    }

  	  	    function createDirectionsPopup(route, request) {
  	  	      const s = getTrackitDirectionsState();
  	  	      const mapDiv = map.getDiv();

  	  	      if (!mapDiv) return;

  	  	      let popup = s.popup;

  	  	      if (!popup) {
  	  	        popup = document.createElement("div");
  	  	        popup.className = "trackit-directions-popup";

  	  	        popup.innerHTML = `
  	  	        <div class="trackit-directions-popup-header">
  	  	        <div>
  	  	        <div class="trackit-directions-popup-title">Directions</div>
  	  	        <div class="trackit-directions-popup-subtitle">Build Route</div>
  	  	        </div>
  	  	        <button type="button" class="trackit-directions-popup-close">×</button>
  	  	        </div>

  	  	        <div class="trackit-directions-search-wrap">

  	  	        <div class="trackit-directions-search-line no-remove" data-route-row="from">
  	  	        <span>From</span>
  	  	        <div class="trackit-directions-input-wrap">
  	  	        <input class="trackit-directions-from" data-route-slot="from" type="text" placeholder="Search place / vehicle ID / click map" autocomplete="off">
  	  	        <div class="trackit-directions-vehicle-suggest"></div>
  	  	        </div>
  	  	        </div>

  	  	        <div class="trackit-directions-waypoints"></div>

  	  	        <button type="button" class="trackit-directions-add-stop">+ Add Stop</button>

  	  	        <div class="trackit-directions-search-line no-remove" data-route-row="to">
  	  	        <span>To</span>
  	  	        <div class="trackit-directions-input-wrap">
  	  	        <input class="trackit-directions-to" data-route-slot="to" type="text" placeholder="Search place / vehicle ID / click map" autocomplete="off">
  	  	        <div class="trackit-directions-vehicle-suggest"></div>
  	  	        </div>
  	  	        </div>

  	  	        </div>

  	  	        <div class="trackit-directions-status">Choose From. Search, type vehicle ID, click map, or click a vehicle.</div>

  	  	        <div class="trackit-directions-popup-body">
  	  	        <div class="trackit-directions-row">
  	  	        <span>From</span>
  	  	        <strong class="trackit-directions-from-text">—</strong>
  	  	        </div>
  	  	        <div class="trackit-directions-row">
  	  	        <span>Stops</span>
  	  	        <strong class="trackit-directions-stops-text">0</strong>
  	  	        </div>
  	  	        <div class="trackit-directions-row">
  	  	        <span>To</span>
  	  	        <strong class="trackit-directions-to-text">—</strong>
  	  	        </div>
  	  	        <div class="trackit-directions-row">
  	  	        <span>Route</span>
  	  	        <strong class="trackit-directions-route-text">—</strong>
  	  	        </div>

  	  	        <div class="trackit-directions-actions">
  	  	        <button type="button" class="trackit-directions-new">Clear/New Route</button>
  	  	        </div>

  	  	        <div class="trackit-directions-whatsapp-wrap">
  	  	        <select class="trackit-directions-country-select" aria-label="Country code">
  	  	        ${getWhatsappCountryOptionsHtml("ZA")}
  	  	        </select>

  	  	        <input class="trackit-directions-whatsapp-phone" type="tel" placeholder="ZA WhatsApp e.g. 0821234567" autocomplete="tel">

  	  	        <button type="button" class="trackit-directions-driver-btn" hidden disabled>
  	  	        ${getTrackitWhatsappButtonHtml("WhatsApp Driver")}
  	  	        </button>

  	  	        <button type="button" class="trackit-directions-whatsapp-btn">
  	  	        ${getTrackitWhatsappButtonHtml("WhatsApp")}
  	  	        </button>
  	  	        </div>
  	  	        </div>
  	  	        `;

  	  	        popup.style.right = "0px";
  	  	        popup.style.left = "auto";
  	  	        popup.style.top = "50px";

  	  	        mapDiv.appendChild(popup);
  	  	        s.popup = popup;

  	  	        wireDirectionsPopupEvents(popup);
  	  	        renderDirectionsWaypoints();
  	  	        wireDirectionsInput(popup.querySelector(".trackit-directions-from"), "from");
  	  	        wireDirectionsInput(popup.querySelector(".trackit-directions-to"), "to");
  	  	      }

  	  	      updateDirectionsPopup(route || null, request || null);
  	  	    }

  	  	    function updateDirectionsPopup(route, request) {
  	  	      const s = getTrackitDirectionsState();
  	  	      const popup = s.popup;

  	  	      if (!popup) return;

  	  	      const subtitle = popup.querySelector(".trackit-directions-popup-subtitle");
  	  	      const status = popup.querySelector(".trackit-directions-status");
  	  	      const fromText = popup.querySelector(".trackit-directions-from-text");
  	  	      const stopsText = popup.querySelector(".trackit-directions-stops-text");
  	  	      const toText = popup.querySelector(".trackit-directions-to-text");
  	  	      const routeText = popup.querySelector(".trackit-directions-route-text");
  	  	      const whatsappWrap = popup.querySelector(".trackit-directions-whatsapp-wrap");
  	  	      const driverBtn = popup.querySelector(".trackit-directions-driver-btn");

  	  	      const fromVehicle = s.fromVehicle;
  	  	      const hasFromVehicle = !!fromVehicle;
  	  	      const hasDriverPhone = !!String(fromVehicle?.driverPhone || "").trim();

  	  	      whatsappWrap?.classList?.toggle("has-driver", hasFromVehicle);

  	  	      if (driverBtn) {
  	  	        driverBtn.hidden = !hasFromVehicle;
  	  	        driverBtn.disabled = !hasDriverPhone;
  	  	        driverBtn.classList.toggle("missing", hasFromVehicle && !hasDriverPhone);
  	  	        driverBtn.title = hasDriverPhone
  	  	        ? `Send route immediately to ${fromVehicle?.driverName || "driver"}`
  	  	        : "No driver mobile number is available for this vehicle";

  	  	        const driverBtnText = driverBtn.querySelector("span");
  	  	        if (driverBtnText) {
  	  	          driverBtnText.textContent = hasDriverPhone ? "WhatsApp Driver": "Driver Number Missing";
  	  	        }
  	  	      }

  	  	      if (fromText) {
  	  	        fromText.textContent = formatDirectionsPointText(s.point1, s.point1Label);
  	  	      }

  	  	      if (toText) {
  	  	        toText.textContent = formatDirectionsPointText(s.point2, s.point2Label);
  	  	      }

  	  	      if (stopsText) {
  	  	        stopsText.textContent = String(s.waypoints.filter(wp => !!wp?.point).length);
  	  	      }

  	  	      if (route && routeText) {
  	  	        routeText.textContent = `${formatDirectionsDistance(route)} • ${formatDirectionsDuration(route)}`;
  	  	      } else if (routeText) {
  	  	        routeText.textContent = "—";
  	  	      }

  	  	      if (route && subtitle) {
  	  	        subtitle.textContent = `${formatDirectionsDistance(route)} • ${formatDirectionsDuration(route)}`;
  	  	      } else if (subtitle) {
  	  	        subtitle.textContent = "Build Route";
  	  	      }

  	  	      if (status) {
  	  	        if (!s.active) {
  	  	          status.textContent = "Directions inactive.";
  	  	        } else if (!s.point1) {
  	  	          status.textContent = "Choose From. Search, type vehicle ID, click map, or click a vehicle.";
  	  	        } else if (!s.point2) {
  	  	          status.textContent = "Choose To. Search, type vehicle ID, click map, or click a vehicle.";
  	  	        } else if (route) {
  	  	          status.textContent = "Route ready.";
  	  	        } else {
  	  	          status.textContent = "Route ready to calculate.";
  	  	        }
  	  	      }
  	  	    }

  	  	    function wireDirectionsPopupEvents(popup) {
  	  	      const closeBtn = popup.querySelector(".trackit-directions-popup-close");
  	  	      const clearBtn = popup.querySelector(".trackit-directions-clear");
  	  	      const newBtn = popup.querySelector(".trackit-directions-new");
  	  	      const addStopBtn = popup.querySelector(".trackit-directions-add-stop");
  	  	      const whatsappBtn = popup.querySelector(".trackit-directions-whatsapp-btn");
  	  	      const driverBtn = popup.querySelector(".trackit-directions-driver-btn");
  	  	      const header = popup.querySelector(".trackit-directions-popup-header");
  	  	      const countrySelect = popup.querySelector(".trackit-directions-country-select");
  	  	      const phoneInput = popup.querySelector(".trackit-directions-whatsapp-phone");

  	  	      updateWhatsappPhonePlaceholder(popup);

  	  	      countrySelect?.addEventListener("change", function () {
  	  	        updateWhatsappPhonePlaceholder(popup);

  	  	        if (!phoneInput?.value) return;

  	  	        const checked = normaliseWhatsappNumber(phoneInput.value, countrySelect.value);

  	  	        phoneInput.classList.toggle("invalid", !checked.ok);

  	  	        if (checked.ok) {
  	  	          phoneInput.value = checked.value;
  	  	          updateDirectionsStatusText("WhatsApp number normalised.");
  	  	        } else {
  	  	          updateDirectionsStatusText(checked.error);
  	  	        }
  	  	      });

  	  	      phoneInput?.addEventListener("input",
  	  	        function () {
  	  	          phoneInput.classList.remove("invalid");
  	  	        });

  	  	      phoneInput?.addEventListener("blur",
  	  	        function () {
  	  	          if (!phoneInput.value) return;

  	  	          const checked = normaliseWhatsappNumber(phoneInput.value, countrySelect?.value || "ZA");

  	  	          phoneInput.classList.toggle("invalid", !checked.ok);

  	  	          if (checked.ok) {
  	  	            phoneInput.value = checked.value;
  	  	          }
  	  	        });

  	  	      closeBtn?.addEventListener("click",
  	  	        function (event) {
  	  	          event.preventDefault();
  	  	          event.stopPropagation();

  	  	          stopDirectionsMode();
  	  	        });

  	  	      clearBtn?.addEventListener("click",
  	  	        function (event) {
  	  	          event.preventDefault();
  	  	          event.stopPropagation();

  	  	          stopDirectionsMode();
  	  	        });

  	  	      newBtn?.addEventListener("click",
  	  	        function (event) {
  	  	          event.preventDefault();
  	  	          event.stopPropagation();

  	  	          startDirectionsMode();
  	  	        });

  	  	      addStopBtn?.addEventListener("click",
  	  	        function (event) {
  	  	          event.preventDefault();
  	  	          event.stopPropagation();

  	  	          addDirectionsWaypoint();
  	  	        });

  	  	      driverBtn?.addEventListener("click",
  	  	        async function (event) {
  	  	          event.preventDefault();
  	  	          event.stopPropagation();

  	  	          const s = getTrackitDirectionsState();
  	  	          const driverPhone = String(s.fromVehicle?.driverPhone || "").trim();

  	  	          if (!driverPhone) {
  	  	            updateDirectionsStatusText("No driver mobile number is available for the From vehicle.");
  	  	            return;
  	  	          }

  	  	          // Put the assigned driver's number into the same field used by the
  	  	          // standard WhatsApp button, then call the exact same send function.
  	  	          phoneInput.value = driverPhone;
  	  	          phoneInput.classList.remove("invalid");

  	  	          await sendDirectionsWhatsapp(driverBtn);
  	  	        });

  	  	      whatsappBtn?.addEventListener("click",
  	  	        async function (event) {
  	  	          event.preventDefault();
  	  	          event.stopPropagation();

  	  	          await sendDirectionsWhatsapp(whatsappBtn);
  	  	        });

  	  	      let dragging = false;
  	  	      let startX = 0;
  	  	      let startY = 0;
  	  	      let startLeft = 0;
  	  	      let startTop = 0;

  	  	      header?.addEventListener("mousedown",
  	  	        function (event) {
  	  	          event.preventDefault();
  	  	          event.stopPropagation();

  	  	          const rect = popup.getBoundingClientRect();
  	  	          const parentRect = map.getDiv().getBoundingClientRect();

  	  	          dragging = true;
  	  	          startX = event.clientX;
  	  	          startY = event.clientY;
  	  	          startLeft = rect.left - parentRect.left;
  	  	          startTop = rect.top - parentRect.top;

  	  	          popup.style.right = "auto";
  	  	          popup.style.left = `${startLeft}px`;
  	  	          popup.style.top = `${startTop}px`;

  	  	          document.body.style.userSelect = "none";
  	  	        });

  	  	      document.addEventListener("mousemove",
  	  	        function (event) {
  	  	          if (!dragging) return;

  	  	          event.preventDefault();

  	  	          const mapDiv = map.getDiv();
  	  	          const maxLeft = Math.max(0, mapDiv.clientWidth - popup.offsetWidth - 6);
  	  	          const maxTop = Math.max(0, mapDiv.clientHeight - popup.offsetHeight - 6);

  	  	          const nextLeft = startLeft + (event.clientX - startX);
  	  	          const nextTop = startTop + (event.clientY - startY);

  	  	          popup.style.left = `${Math.min(maxLeft, Math.max(0, nextLeft))}px`;
  	  	          popup.style.top = `${Math.min(maxTop, Math.max(0, nextTop))}px`;
  	  	        });

  	  	      document.addEventListener("mouseup",
  	  	        function () {
  	  	          if (!dragging) return;

  	  	          dragging = false;
  	  	          document.body.style.userSelect = "";
  	  	        });

  	  	      ["mousedown", "dblclick", "wheel", "touchstart", "pointerdown", "click"].forEach(evtName => {
  	  	        popup.addEventListener(evtName, function (event) {
  	  	          event.stopPropagation();
  	  	        }, {
  	  	          passive: false
  	  	        });
  	  	      });
  	  	    }

  	  	    function startDirectionsMode() {
  	  	      const s = getTrackitDirectionsState();

  	  	      clearDirectionsRouteOnly();

  	  	      closeMapControlPanel(false);

  	  	      s.active = true;
  	  	      s.waitingFor = 1;

  	  	      s.point1 = null;
  	  	      s.point2 = null;
  	  	      s.point1Label = "";
  	  	      s.point2Label = "";
  	  	      s.fromVehicle = null;
  	  	      s.waypoints = [];
  	  	      s.activeSlot = "from";

  	  	      createDirectionsPopup(null,
  	  	        null);
  	  	      renderDirectionsWaypoints();

  	  	      const fromInput = s.popup?.querySelector?.(".trackit-directions-from");
  	  	      const toInput = s.popup?.querySelector?.(".trackit-directions-to");

  	  	      if (fromInput) fromInput.value = "";
  	  	      if (toInput) toInput.value = "";

  	  	      if (s.mapClickListener) {
  	  	        try {
  	  	          google.maps.event.removeListener(s.mapClickListener);
  	  	        } catch (_) {}
  	  	      }

  	  	      s.mapClickListener = map.addListener("click", function (event) {
  	  	        try {
  	  	          addDirectionsPoint(event.latLng, "Dropped Pin");
  	  	        } catch (e) {
  	  	          console.warn("[TrackIT Directions] Map point failed:", e);
  	  	        }
  	  	      });

  	  	      paintDirectionsButton();
  	  	      updateDirectionsPopup(null, null);

  	  	      setTimeout(() => {
  	  	        try {
  	  	          fromInput?.focus?.();
  	  	        } catch (_) {}
  	  	      }, 0);
  	  	    }

  	  	    function calculateAndDisplayRoute() {
  	  	      const s = getTrackitDirectionsState();

  	  	      if (!s.point1 || !s.point2) return;

  	  	      if (!s.directionsService) {
  	  	        s.directionsService = new google.maps.DirectionsService();
  	  	      }

  	  	      if (s.directionsRenderer) {
  	  	        try {
  	  	          s.directionsRenderer.setMap(null);
  	  	        } catch (_) {}
  	  	      }

  	  	      s.directionsRenderer = new google.maps.DirectionsRenderer({
  	  	        map,
  	  	        suppressMarkers: true,
  	  	        preserveViewport: false,
  	  	        polylineOptions: {
  	  	          strokeColor: "#ff8a3c",
  	  	          strokeOpacity: 0.95,
  	  	          strokeWeight: 5,
  	  	          zIndex: 900
  	  	        }
  	  	      });

  	  	      const request = {
  	  	        origin: s.point1,
  	  	        destination: s.point2,
  	  	        waypoints: s.waypoints
  	  	        .filter(wp => !!wp?.point)
  	  	        .map(wp => ({
  	  	          location: wp.point,
  	  	          stopover: true
  	  	        })),
  	  	        optimizeWaypoints: false,
  	  	        travelMode: google.maps.TravelMode.DRIVING,
  	  	        provideRouteAlternatives: false
  	  	      };

  	  	      setDirectionsButtonText("Routing...");
  	  	      updateDirectionsPopup(null, request);

  	  	      s.directionsService.route(request, function (result, status) {
  	  	        if (status === "OK" && result?.routes?.length) {
  	  	          s.directionsRenderer.setDirections(result);

  	  	          const route = result.routes[0];

  	  	          createDirectionsPopup(route, request);
  	  	          updateDirectionsPopup(route, request);

  	  	          s.active = true;
  	  	          s.waitingFor = 0;

  	  	          setDirectionsButtonText("Directions");
  	  	          directionsBtn.classList.add("active");

  	  	          return;
  	  	        }

  	  	        console.warn("[TrackIT Directions] Route failed:", status, result);

  	  	        setDirectionsButtonText("No Route");
  	  	        updateDirectionsStatusText("Route failed. Check road access or selected points.");

  	  	        setTimeout(() => {
  	  	          paintDirectionsButton();
  	  	        }, 1200);
  	  	      });
  	  	    }

  	  	    function formatMapsPoint(point) {
  	  	      if (!point) return "";

  	  	      return `${Number(point.lat).toFixed(7)},${Number(point.lng).toFixed(7)}`;
  	  	    }

  	  	    function buildGoogleMapsDirectionsUrl() {
  	  	      const s = getTrackitDirectionsState();

  	  	      if (!s.point1 || !s.point2) return "";

  	  	      const params = new URLSearchParams();

  	  	      params.set("api", "1");
  	  	      params.set("origin", formatMapsPoint(s.point1));
  	  	      params.set("destination", formatMapsPoint(s.point2));
  	  	      params.set("travelmode", "driving");

  	  	      const stops = (s.waypoints || [])
  	  	      .filter(wp => !!wp?.point)
  	  	      .map(wp => formatMapsPoint(wp.point))
  	  	      .filter(Boolean);

  	  	      if (stops.length) {
  	  	        params.set("waypoints", stops.join("|"));
  	  	      }

  	  	      return `https://www.google.com/maps/dir/?${params.toString()}`;
  	  	    }

  	  	    const TRACKIT_WHATSAPP_COUNTRIES = [{
  	  	      iso: "ZA",
  	  	      label: "South Africa",
  	  	      dial: "+27",
  	  	      example: "0821234567",
  	  	      nsnMin: 9,
  	  	      nsnMax: 9,
  	  	      mobilePattern: /^[6-8]\d{8}$/
  	  	    },
  	  	      {
  	  	        iso: "BW",
  	  	        label: "Botswana",
  	  	        dial: "+267",
  	  	        example: "71234567",
  	  	        nsnMin: 7,
  	  	        nsnMax: 8
  	  	      },
  	  	      {
  	  	        iso: "NA",
  	  	        label: "Namibia",
  	  	        dial: "+264",
  	  	        example: "811234567",
  	  	        nsnMin: 8,
  	  	        nsnMax: 9
  	  	      },
  	  	      {
  	  	        iso: "ZW",
  	  	        label: "Zimbabwe",
  	  	        dial: "+263",
  	  	        example: "771234567",
  	  	        nsnMin: 9,
  	  	        nsnMax: 9
  	  	      },
  	  	      {
  	  	        iso: "ZM",
  	  	        label: "Zambia",
  	  	        dial: "+260",
  	  	        example: "971234567",
  	  	        nsnMin: 9,
  	  	        nsnMax: 9
  	  	      },
  	  	      {
  	  	        iso: "MZ",
  	  	        label: "Mozambique",
  	  	        dial: "+258",
  	  	        example: "841234567",
  	  	        nsnMin: 9,
  	  	        nsnMax: 9
  	  	      },
  	  	      {
  	  	        iso: "LS",
  	  	        label: "Lesotho",
  	  	        dial: "+266",
  	  	        example: "50123456",
  	  	        nsnMin: 8,
  	  	        nsnMax: 8
  	  	      },
  	  	      {
  	  	        iso: "SZ",
  	  	        label: "Eswatini",
  	  	        dial: "+268",
  	  	        example: "76123456",
  	  	        nsnMin: 8,
  	  	        nsnMax: 8
  	  	      },
  	  	      {
  	  	        iso: "MW",
  	  	        label: "Malawi",
  	  	        dial: "+265",
  	  	        example: "991234567",
  	  	        nsnMin: 9,
  	  	        nsnMax: 9
  	  	      },
  	  	      {
  	  	        iso: "GB",
  	  	        label: "United Kingdom",
  	  	        dial: "+44",
  	  	        example: "7123456789",
  	  	        nsnMin: 9,
  	  	        nsnMax: 10
  	  	      },
  	  	      {
  	  	        iso: "US",
  	  	        label: "United States",
  	  	        dial: "+1",
  	  	        example: "3133950896",
  	  	        nsnMin: 10,
  	  	        nsnMax: 10
  	  	      },
  	  	      {
  	  	        iso: "INTL",
  	  	        label: "International",
  	  	        dial: "",
  	  	        example: "+27821234567",
  	  	        nsnMin: 8,
  	  	        nsnMax: 15,
  	  	        allowAnyIntl: true
  	  	      }];

  	  	    function getWhatsappCountryByIso(iso) {
  	  	      return TRACKIT_WHATSAPP_COUNTRIES.find(c => c.iso === iso) || TRACKIT_WHATSAPP_COUNTRIES[0];
  	  	    }

  	  	    function getWhatsappCountryOptionsHtml(selectedIso) {
  	  	      return TRACKIT_WHATSAPP_COUNTRIES.map(country => {
  	  	        const selected = country.iso === selectedIso ? "selected": "";
  	  	        const label = country.dial
  	  	        ? `${country.iso} ${country.dial}`: `${country.iso} +`;

  	  	        return `<option value="${country.iso}" ${selected}>${label}</option>`;
  	  	      }).join("");
  	  	    }

  	  	    function getSelectedWhatsappCountry(popup) {
  	  	      const select = popup?.querySelector?.(".trackit-directions-country-select");
  	  	      return getWhatsappCountryByIso(select?.value || "ZA");
  	  	    }

  	  	    function updateWhatsappPhonePlaceholder(popup) {
  	  	      const country = getSelectedWhatsappCountry(popup);
  	  	      const phoneInput = popup?.querySelector?.(".trackit-directions-whatsapp-phone");

  	  	      if (!phoneInput) return;

  	  	      if (country.allowAnyIntl) {
  	  	        phoneInput.placeholder = "Full number e.g. +27821234567";
  	  	        return;
  	  	      }

  	  	      phoneInput.placeholder = `${country.iso} WhatsApp e.g. ${country.example}`;
  	  	    }

  	  	    function normaliseWhatsappNumber(raw, countryIso) {
  	  	      const country = getWhatsappCountryByIso(countryIso || "ZA");

  	  	      let text = String(raw || "").trim();

  	  	      if (!text) {
  	  	        return {
  	  	          ok: false,
  	  	          value: "",
  	  	          error: "Enter a WhatsApp number first."
  	  	        };
  	  	      }

  	  	      text = text.replace(/^whatsapp:/i, "").trim();
  	  	      text = text.replace(/[^\d+]/g, "");

  	  	      const plusCount = (text.match(/\+/g) || []).length;

  	  	      if (plusCount > 1 || (text.includes("+") && !text.startsWith("+"))) {
  	  	        return {
  	  	          ok: false,
  	  	          value: "",
  	  	          error: "Invalid WhatsApp number format."
  	  	        };
  	  	      }

  	  	      let digits = text.replace(/\D/g, "");

  	  	      if (country.allowAnyIntl) {
  	  	        if (!text.startsWith("+")) {
  	  	          return {
  	  	            ok: false,
  	  	            value: "",
  	  	            error: "Use full international format, for example +27821234567."
  	  	          };
  	  	        }

  	  	        if (digits.length < 8 || digits.length > 15) {
  	  	          return {
  	  	            ok: false,
  	  	            value: "",
  	  	            error: "WhatsApp number must be 8 to 15 digits in international format."
  	  	          };
  	  	        }

  	  	        return {
  	  	          ok: true,
  	  	          value: `+${digits}`,
  	  	          country
  	  	        };
  	  	      }

  	  	      const dialDigits = country.dial.replace(/\D/g, "");
  	  	      let nationalNumber = "";

  	  	      if (text.startsWith("+")) {
  	  	        if (!digits.startsWith(dialDigits)) {
  	  	          return {
  	  	            ok: false,
  	  	            value: "",
  	  	            error: `Number does not match selected country ${country.iso} ${country.dial}.`
  	  	          };
  	  	        }

  	  	        nationalNumber = digits.slice(dialDigits.length);
  	  	      } else {
  	  	        if (digits.startsWith(dialDigits) && digits.length > dialDigits.length + 3) {
  	  	          nationalNumber = digits.slice(dialDigits.length);
  	  	        } else {
  	  	          nationalNumber = digits;
  	  	        }

  	  	        // Local SA-style trunk prefix:
  	  	        // 0821234567 -> 821234567
  	  	        if (nationalNumber.startsWith("0")) {
  	  	          nationalNumber = nationalNumber.slice(1);
  	  	        }
  	  	      }

  	  	      if (
  	  	        nationalNumber.length < country.nsnMin ||
  	  	        nationalNumber.length > country.nsnMax
  	  	      ) {
  	  	        return {
  	  	          ok: false,
  	  	          value: "",
  	  	          error: `${country.iso} number must be ${country.nsnMin === country.nsnMax ? country.nsnMin: `${country.nsnMin}-${country.nsnMax}`} digits after ${country.dial}.`
  	  	        };
  	  	      }

  	  	      if (country.mobilePattern && !country.mobilePattern.test(nationalNumber)) {
  	  	        return {
  	  	          ok: false,
  	  	          value: "",
  	  	          error: `That does not look like a valid ${country.iso} mobile WhatsApp number.`
  	  	        };
  	  	      }

  	  	      const e164 = `${country.dial}${nationalNumber}`;
  	  	      const e164Digits = e164.replace(/\D/g, "");

  	  	      if (e164Digits.length < 8 || e164Digits.length > 15) {
  	  	        return {
  	  	          ok: false,
  	  	          value: "",
  	  	          error: "WhatsApp number must be valid international E.164 format."
  	  	        };
  	  	      }

  	  	      return {
  	  	        ok: true,
  	  	        value: e164,
  	  	        country
  	  	      };
  	  	    }

  	  	    function getTrackitWhatsappButtonHtml(label) {
  	  	      return `
  	  	      <svg class="trackit-whatsapp-icon" viewBox="0 0 32 32" aria-hidden="true">
  	  	      <path fill="currentColor" d="M16.02 3.2C9.02 3.2 3.34 8.78 3.34 15.66c0 2.22.6 4.38 1.74 6.27L3.2 28.8l7.08-1.84a12.9 12.9 0 0 0 5.74 1.36c7 0 12.68-5.58 12.68-12.46S23.02 3.2 16.02 3.2Zm0 22.98c-1.84 0-3.64-.49-5.2-1.42l-.37-.22-4.2 1.09 1.12-4.02-.25-.41a10.06 10.06 0 0 1-1.56-5.34c0-5.69 4.7-10.32 10.46-10.32s10.46 4.63 10.46 10.32-4.7 10.32-10.46 10.32Zm5.74-7.72c-.31-.15-1.84-.9-2.13-1-.29-.1-.5-.15-.71.15-.21.31-.82 1-.99 1.2-.18.2-.36.23-.67.08-.31-.15-1.31-.48-2.5-1.53-.92-.81-1.54-1.81-1.72-2.12-.18-.3-.02-.47.13-.62.14-.14.31-.36.47-.54.16-.18.21-.31.31-.51.1-.2.05-.38-.03-.54-.08-.15-.71-1.69-.97-2.31-.25-.6-.51-.52-.71-.53h-.6c-.21 0-.55.08-.84.38-.29.3-1.1 1.06-1.1 2.59s1.13 3.01 1.29 3.22c.16.2 2.23 3.35 5.41 4.7.76.32 1.35.51 1.81.65.76.24 1.45.21 2 .13.61-.09 1.84-.74 2.1-1.45.26-.71.26-1.32.18-1.45-.08-.13-.29-.2-.6-.36Z"/>
  	  	      </svg>
  	  	      <span>${label}</span>
  	  	      `;
  	  	    }

  	  	    function setTrackitWhatsappButtonState(button, label, sending) {
  	  	      if (!button) return;

  	  	      button.classList.toggle("sending", !!sending);
  	  	      button.innerHTML = getTrackitWhatsappButtonHtml(label);
  	  	    }

  	  	    function getDirectionsSummaryForWhatsapp() {
  	  	      const s = getTrackitDirectionsState();

  	  	      const from = formatDirectionsPointText(s.point1, s.point1Label);
  	  	      const to = formatDirectionsPointText(s.point2, s.point2Label);
  	  	      const stops = (s.waypoints || [])
  	  	      .filter(wp => !!wp?.point)
  	  	      .map((wp, index) => `${index + 1}. ${formatDirectionsPointText(wp.point, wp.label)}`);

  	  	      return {
  	  	        from,
  	  	        to,
  	  	        stops
  	  	      };
  	  	    }

  	  	    async function sendDirectionsWhatsapp(triggerButton) {
  	  	      const s = getTrackitDirectionsState();
  	  	      const popup = s.popup;

  	  	      if (!popup) return;

  	  	      const phoneInput = popup.querySelector(".trackit-directions-whatsapp-phone");
  	  	      const countrySelect = popup.querySelector(".trackit-directions-country-select");
  	  	      const normalWhatsappBtn = popup.querySelector(".trackit-directions-whatsapp-btn");
  	  	      const sendBtn = triggerButton || normalWhatsappBtn;
  	  	      const idleButtonLabel = sendBtn?.classList?.contains("trackit-directions-driver-btn")
  	  	      ? "WhatsApp Driver"
  	  	      : "WhatsApp";

  	  	      const checkedNumber = normaliseWhatsappNumber(
  	  	        phoneInput?.value,
  	  	        countrySelect?.value || "ZA"
  	  	      );

  	  	      if (!checkedNumber.ok) {
  	  	        updateDirectionsStatusText(checkedNumber.error);
  	  	        phoneInput?.classList?.add("invalid");
  	  	        phoneInput?.focus?.();
  	  	        return;
  	  	      }

  	  	      phoneInput.classList.remove("invalid");
  	  	      phoneInput.value = checkedNumber.value;

  	  	      const to = checkedNumber.value;

  	  	      if (!s.point1 || !s.point2) {
  	  	        updateDirectionsStatusText("Build a route before sending.");
  	  	        return;
  	  	      }

  	  	      const mapsUrl = buildGoogleMapsDirectionsUrl();

  	  	      if (!mapsUrl) {
  	  	        updateDirectionsStatusText("Could not build Google Maps route link.");
  	  	        return;
  	  	      }

  	  	      const summary = getDirectionsSummaryForWhatsapp();

  	  	      const stopsText = summary.stops.length
  	  	      ? summary.stops.join("\n"): "No stops";

  	  	      const payload = {
  	  	        To: to,
  	  	        FromLocation: summary.from,
  	  	        ToLocation: summary.to,
  	  	        Stops: stopsText,
  	  	        RouteLink: mapsUrl
  	  	      };

  	  	      try {
  	  	        setTrackitWhatsappButtonState(sendBtn, "Sending...", true);

  	  	        updateDirectionsStatusText("Sending WhatsApp route...");

  	  	        console.log("[TrackIT WhatsApp] Sending template payload:", payload);

  	  	        const result = await invokeTrackitWhatsAppService(payload);

  	  	        updateDirectionsStatusText("WhatsApp route sent.");
  	  	        console.log("[TrackIT WhatsApp] Sent:", result);

  	  	      } catch (error) {
  	  	        console.error("[TrackIT WhatsApp] Send failed:", error);

  	  	        const message = error?.message || String(error || "");

  	  	        if (message.includes("not available")) {
  	  	          updateDirectionsStatusText("WhatsApp failed. Backendless service invoke is not available on this screen.");
  	  	        } else {
  	  	          updateDirectionsStatusText("WhatsApp failed. Check template approval, Backendless service config, and Twilio logs.");
  	  	        }

  	  	      } finally {
  	  	        setTrackitWhatsappButtonState(sendBtn, idleButtonLabel, false);
  	  	      }
  	  	    }

  	  	    async function invokeTrackitWhatsAppService(payload) {
  	  	      const serviceArgs = {
  	  	        To: payload.To,
  	  	        FromLocation: payload.FromLocation,
  	  	        ToLocation: payload.ToLocation,
  	  	        Stops: payload.Stops,
  	  	        RouteLink: payload.RouteLink
  	  	      };

  	  	      console.log("[TrackIT WhatsApp] Backendless service args:", serviceArgs);

  	  	      if (
  	  	        typeof Backendless !== "undefined" &&
  	  	        Backendless.CustomServices &&
  	  	        typeof Backendless.CustomServices.invoke === "function"
  	  	      ) {
  	  	        return Backendless.CustomServices.invoke(
  	  	          TRACKIT_WHATSAPP_SERVICE_NAME,
  	  	          TRACKIT_WHATSAPP_METHOD_NAME,
  	  	          serviceArgs
  	  	        );
  	  	      }

  	  	      if (
  	  	        typeof BackendlessUI !== "undefined" &&
  	  	        BackendlessUI.Backendless &&
  	  	        BackendlessUI.Backendless.CustomServices &&
  	  	        typeof BackendlessUI.Backendless.CustomServices.invoke === "function"
  	  	      ) {
  	  	        return BackendlessUI.Backendless.CustomServices.invoke(
  	  	          TRACKIT_WHATSAPP_SERVICE_NAME,
  	  	          TRACKIT_WHATSAPP_METHOD_NAME,
  	  	          serviceArgs
  	  	        );
  	  	      }

  	  	      if (
  	  	        typeof window !== "undefined" &&
  	  	        window.Backendless &&
  	  	        window.Backendless.CustomServices &&
  	  	        typeof window.Backendless.CustomServices.invoke === "function"
  	  	      ) {
  	  	        return window.Backendless.CustomServices.invoke(
  	  	          TRACKIT_WHATSAPP_SERVICE_NAME,
  	  	          TRACKIT_WHATSAPP_METHOD_NAME,
  	  	          serviceArgs
  	  	        );
  	  	      }

  	  	      throw new Error("Backendless CustomServices.invoke is not available.");
  	  	    }

  	  	    map.__trackitAddDirectionsPoint = addDirectionsPoint;
  	  	    map.__trackitGetDirectionsVehicleMeta = getDirectionsVehicleMetaFromTractor;
  	  	    map.__trackitStartDirectionsMode = startDirectionsMode;
  	  	    map.__trackitStopDirectionsMode = stopDirectionsMode;
  	  	    map.__trackitToggleDirectionsMode = toggleDirectionsMode;


  	  	    try {
  	  	      const positions = [
  	  	        google.maps.ControlPosition.RIGHT_BOTTOM,
  	  	        google.maps.ControlPosition.LEFT_BOTTOM,
  	  	        google.maps.ControlPosition.RIGHT_TOP,
  	  	        google.maps.ControlPosition.LEFT_TOP
  	  	      ];

  	  	      positions.forEach(pos => {
  	  	        const controls = map.controls[pos];

  	  	        for (let i = controls.getLength() - 1; i >= 0; i--) {
  	  	          const item = controls.getAt(i);

  	  	          if (item?.__trackitUnifiedMapControl) {
  	  	            controls.removeAt(i);
  	  	          }
  	  	        }
  	  	      });
  	  	    } catch (_) {}

  	  	    if (map.__trackitMapControlListeners) {
  	  	      map.__trackitMapControlListeners.forEach(listener => {
  	  	        try {
  	  	          google.maps.event.removeListener(listener);
  	  	        } catch (_) {}
  	  	      });
  	  	    }

  	  	    if (map.__trackitDomControlListeners) {
  	  	      map.__trackitDomControlListeners.forEach(({
  	  	        target, event, handler
  	  	      }) => {
  	  	        try {
  	  	          target.removeEventListener(event, handler);
  	  	        } catch (_) {}
  	  	      });
  	  	    }

  	  	    map.__trackitMapControlListeners = [];
  	  	    map.__trackitDomControlListeners = [];
  	  	    map.__trackitUnifiedMapControlReady = false;
  	  	    map.__trackitUnifiedMapControlVersion = "";

  	  	    const NO_LABEL_STYLES = [{
  	  	      elementType: "labels",
  	  	      stylers: [{
  	  	        visibility: "off"
  	  	      }]
  	  	    },
  	  	      {
  	  	        featureType: "poi",
  	  	        stylers: [{
  	  	          visibility: "off"
  	  	        }]
  	  	      },
  	  	      {
  	  	        featureType: "transit",
  	  	        stylers: [{
  	  	          visibility: "off"
  	  	        }]
  	  	      }];

  	  	    function getSettingsBag() {
  	  	      const bag = getAppBag();

  	  	      if (bag) {
  	  	        if (!bag.TrackITMapSettings) {
  	  	          bag.TrackITMapSettings = {};
  	  	        }

  	  	        return bag.TrackITMapSettings;
  	  	      }

  	  	      if (!map.__trackitLocalMapSettings) {
  	  	        map.__trackitLocalMapSettings = {};
  	  	      }

  	  	      return map.__trackitLocalMapSettings;
  	  	    }

  	  	    function writeSetting(key, value) {
  	  	      const settings = getSettingsBag();
  	  	      settings[key] = value;

  	  	      try {
  	  	        refreshApp();
  	  	      } catch (_) {}
  	  	    }

  	  	    function readSetting(key, fallback) {
  	  	      const settings = getSettingsBag();
  	  	      return settings[key] !== undefined ? settings[key]: fallback;
  	  	    }

  	  	    const oldStyle = document.getElementById("trackit-compact-map-control-css");
  	  	    if (oldStyle) oldStyle.remove();

  	  	    const style = document.createElement("style");
  	  	    style.id = "trackit-compact-map-control-css";

  	  	    style.textContent = `
  	  	    .trackit-compact-map-control.ces-bottom-shape {
  	  	    position: absolute !important;
  	  	    right: 0 !important;
  	  	    bottom: 0 !important;
  	  	    top: auto !important;
  	  	    z-index: 999999 !important;
  	  	    pointer-events: auto !important;
  	  	    box-sizing: border-box !important;
  	  	    color: #fff !important;
  	  	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;

  	  	    background:
  	  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.16), transparent 32%),
  	  	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;

  	  	    border-top: 1px solid rgba(255,122,36,0.52) !important;
  	  	    border-left: 1px solid rgba(255,122,36,0.52) !important;
  	  	    border-right: 0 !important;
  	  	    border-bottom: 0 !important;

  	  	    box-shadow:
  	  	    -12px -16px 32px rgba(0,0,0,0.40),
  	  	    inset 0 1px 0 rgba(255,255,255,0.045),
  	  	    inset 0 -18px 38px rgba(0,0,0,0.24) !important;

  	  	    user-select: none !important;
  	  	    }

  	  	    .trackit-compact-map-control.ces-bottom-shape::before {
  	  	    content: "" !important;
  	  	    position: absolute !important;
  	  	    inset: 0 !important;
  	  	    pointer-events: none !important;
  	  	    z-index: 1 !important;
  	  	    opacity: 0.16 !important;
  	  	    background:
  	  	    repeating-radial-gradient(
  	  	    ellipse at 34% 118%,
  	  	    transparent 0,
  	  	    transparent 9px,
  	  	    rgba(255,116,34,0.20) 10px,
  	  	    transparent 12px
  	  	    ) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-bottom-content {
  	  	    position: relative !important;
  	  	    z-index: 2 !important;
  	  	    width: 100% !important;
  	  	    height: auto !important;
  	  	    padding: 10px 12px 12px 12px !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-compact-map-control.collapsed .ces-bottom-content {
  	  	    padding: 9px 12px !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-header {
  	  	    width: 100% !important;
  	  	    height: 38px !important;
  	  	    border: 0 !important;
  	  	    outline: 0 !important;
  	  	    background: transparent !important;
  	  	    color: inherit !important;
  	  	    display: grid !important;
  	  	    grid-template-columns: 31px minmax(0, 1fr) 16px !important;
  	  	    align-items: center !important;
  	  	    gap: 8px !important;
  	  	    padding: 0 !important;
  	  	    margin: 0 !important;
  	  	    cursor: pointer !important;
  	  	    text-align: left !important;
  	  	    appearance: none !important;
  	  	    -webkit-appearance: none !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-layer-icon {
  	  	    width: 30px !important;
  	  	    height: 30px !important;
  	  	    border-radius: 12px !important;
  	  	    display: flex !important;
  	  	    flex-direction: column !important;
  	  	    align-items: center !important;
  	  	    justify-content: center !important;
  	  	    gap: 3px !important;
  	  	    background:
  	  	    radial-gradient(circle at 35% 22%, rgba(255,153,70,0.42), rgba(4,5,5,0.92) 72%) !important;
  	  	    border: 1px solid rgba(255,132,48,0.54) !important;
  	  	    box-shadow:
  	  	    0 0 15px rgba(255,122,36,0.18),
  	  	    inset 0 1px 0 rgba(255,255,255,0.10) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-layer-icon span {
  	  	    width: 14px !important;
  	  	    height: 2px !important;
  	  	    border-radius: 999px !important;
  	  	    background: #ff9a3d !important;
  	  	    box-shadow: 0 0 8px rgba(255,122,36,0.34) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-header-text {
  	  	    min-width: 0 !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-title {
  	  	    font-size: 11px !important;
  	  	    font-weight: 950 !important;
  	  	    letter-spacing: 0.10em !important;
  	  	    text-transform: uppercase !important;
  	  	    color: #ffe3c5 !important;
  	  	    line-height: 1 !important;
  	  	    white-space: nowrap !important;
  	  	    overflow: hidden !important;
  	  	    text-overflow: ellipsis !important;
  	  	    margin: 0 !important;
  	  	    padding: 0 !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-subtitle {
  	  	    margin: 4px 0 0 !important;
  	  	    padding: 0 !important;
  	  	    font-size: 7px !important;
  	  	    font-weight: 950 !important;
  	  	    letter-spacing: 0.13em !important;
  	  	    text-transform: uppercase !important;
  	  	    color: rgba(255,255,255,0.56) !important;
  	  	    line-height: 1 !important;
  	  	    white-space: nowrap !important;
  	  	    overflow: hidden !important;
  	  	    text-overflow: ellipsis !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-caret {
  	  	    color: #ff8a3c !important;
  	  	    font-size: 12px !important;
  	  	    font-weight: 950 !important;
  	  	    display: flex !important;
  	  	    align-items: center !important;
  	  	    justify-content: center !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-body {
  	  	    display: grid !important;
  	  	    grid-template-columns: minmax(0, 1fr) 56px !important;
  	  	    gap: 12px !important;
  	  	    align-items: start !important;
  	  	    margin-top: 12px !important;
  	  	    min-width: 0 !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-compact-map-control.collapsed .ces-map-control-body {
  	  	    display: none !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-main {
  	  	    min-width: 0 !important;
  	  	    display: flex !important;
  	  	    flex-direction: column !important;
  	  	    gap: 12px !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-section {
  	  	    display: flex !important;
  	  	    flex-direction: column !important;
  	  	    gap: 7px !important;
  	  	    min-width: 0 !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-section-title {
  	  	    height: auto !important;
  	  	    min-height: 13px !important;
  	  	    display: flex !important;
  	  	    align-items: center !important;
  	  	    gap: 6px !important;
  	  	    color: rgba(255,232,208,0.78) !important;
  	  	    font-size: 8px !important;
  	  	    font-weight: 950 !important;
  	  	    letter-spacing: 0.12em !important;
  	  	    text-transform: uppercase !important;
  	  	    line-height: 1 !important;
  	  	    padding: 0 !important;
  	  	    margin: 0 !important;
  	  	    border: 0 !important;
  	  	    background: transparent !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-section-title svg {
  	  	    width: 13px !important;
  	  	    height: 13px !important;
  	  	    color: #ff8a3c !important;
  	  	    flex: 0 0 auto !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-tools {
  	  	    display: grid !important;
  	  	    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	  	    grid-auto-rows: 38px !important;
  	  	    gap: 7px !important;
  	  	    min-width: 0 !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-compact-map-control .fleet-map-type-tools {
  	  	    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-tool {
  	  	    width: auto !important;
  	  	    height: 36px !important;
  	  	    min-width: 0 !important;
  	  	    border-radius: 13px !important;
  	  	    border: 1px solid rgba(255,255,255,0.10) !important;
  	  	    background:
  	  	    linear-gradient(145deg, rgba(255,255,255,0.055), rgba(255,255,255,0.018)) !important;
  	  	    color: rgba(255,255,255,0.78) !important;
  	  	    display: flex !important;
  	  	    align-items: center !important;
  	  	    justify-content: flex-start !important;
  	  	    gap: 8px !important;
  	  	    padding: 0 10px !important;
  	  	    box-sizing: border-box !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 950 !important;
  	  	    text-align: left !important;
  	  	    overflow: hidden !important;
  	  	    box-shadow:
  	  	    inset 0 0 0 1px rgba(255,255,255,0.025),
  	  	    0 7px 14px rgba(0,0,0,0.18) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-tool svg {
  	  	    width: 14px !important;
  	  	    height: 14px !important;
  	  	    color: rgba(255,255,255,0.78) !important;
  	  	    flex: 0 0 14px !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-tool span {
  	  	    min-width: 0 !important;
  	  	    overflow: hidden !important;
  	  	    text-overflow: ellipsis !important;
  	  	    white-space: nowrap !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-tool:hover {
  	  	    color: #fff !important;
  	  	    border-color: rgba(255,138,61,0.38) !important;
  	  	    background: rgba(255,138,61,0.10) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-tool.active,
  	  	    .trackit-compact-map-control .ces-map-control-tool.fullscreen-active {
  	  	    color: #fff !important;
  	  	    border-color: rgba(255,138,61,0.62) !important;
  	  	    background:
  	  	    linear-gradient(145deg, rgba(255,122,36,0.28), rgba(95,42,17,0.32)) !important;
  	  	    box-shadow:
  	  	    inset 0 0 0 1px rgba(255,138,61,0.30),
  	  	    inset 0 0 18px rgba(255,105,25,0.12),
  	  	    0 7px 14px rgba(0,0,0,0.18) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-tool.active svg,
  	  	    .trackit-compact-map-control .ces-map-control-tool.fullscreen-active svg {
  	  	    color: #ff9a3d !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-zoom-rail {
  	  	    width: 56px !important;
  	  	    min-width: 56px !important;
  	  	    height: 286px !important;
  	  	    min-height: 286px !important;
  	  	    max-height: 286px !important;
  	  	    display: grid !important;
  	  	    grid-template-rows: auto auto 32px 176px 32px !important;
  	  	    justify-items: center !important;
  	  	    align-items: center !important;
  	  	    box-sizing: border-box !important;
  	  	    align-self: start !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-zoom-label {
  	  	    color: rgba(255,232,208,0.78) !important;
  	  	    font-size: 8px !important;
  	  	    font-weight: 950 !important;
  	  	    letter-spacing: 0.12em !important;
  	  	    text-transform: uppercase !important;
  	  	    line-height: 1 !important;
  	  	    margin: 0 0 6px !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-zoom-value {
  	  	    width: 36px !important;
  	  	    height: 36px !important;
  	  	    border-radius: 999px !important;
  	  	    display: flex !important;
  	  	    align-items: center !important;
  	  	    justify-content: center !important;
  	  	    background:
  	  	    radial-gradient(circle at 40% 35%, rgba(255,255,255,0.22), rgba(25,25,25,0.88) 70%) !important;
  	  	    border: 2px solid rgba(255,122,39,0.68) !important;
  	  	    color: #fff !important;
  	  	    font-size: 12px !important;
  	  	    font-weight: 950 !important;
  	  	    box-shadow:
  	  	    0 0 10px rgba(255,105,25,0.24),
  	  	    inset 0 0 0 1px rgba(255,255,255,0.12) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-zoom-btn {
  	  	    width: 32px !important;
  	  	    height: 32px !important;
  	  	    border-radius: 999px !important;
  	  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	  	    background: rgba(255,255,255,0.045) !important;
  	  	    color: #fff !important;
  	  	    cursor: pointer !important;
  	  	    font-weight: 950 !important;
  	  	    font-size: 16px !important;
  	  	    line-height: 1 !important;
  	  	    padding: 0 !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-zoom-btn:hover {
  	  	    background: rgba(255,111,29,0.16) !important;
  	  	    border-color: rgba(255,137,56,0.46) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-slider-wrap {
  	  	    position: relative !important;
  	  	    display: flex !important;
  	  	    align-items: center !important;
  	  	    justify-content: center !important;
  	  	    width: 100% !important;
  	  	    height: 176px !important;
  	  	    min-height: 176px !important;
  	  	    max-height: 176px !important;
  	  	    margin: 8px 0 !important;
  	  	    padding: 0 !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-slider-wrap::before {
  	  	    content: "" !important;
  	  	    position: absolute !important;
  	  	    top: 8px !important;
  	  	    bottom: 8px !important;
  	  	    left: 50% !important;
  	  	    width: 1px !important;
  	  	    transform: translateX(-50%) !important;
  	  	    background: repeating-linear-gradient(
  	  	    to bottom,
  	  	    rgba(255,255,255,0.18) 0,
  	  	    rgba(255,255,255,0.18) 1px,
  	  	    transparent 1px,
  	  	    transparent 8px
  	  	    ) !important;
  	  	    }

  	  	    .trackit-compact-map-control .ces-map-control-zoom-slider {
  	  	    position: relative !important;
  	  	    z-index: 1 !important;
  	  	    writing-mode: vertical-lr !important;
  	  	    direction: rtl !important;
  	  	    width: 26px !important;
  	  	    height: 176px !important;
  	  	    min-height: 176px !important;
  	  	    max-height: 176px !important;
  	  	    accent-color: #ff7928 !important;
  	  	    cursor: pointer !important;
  	  	    margin: 0 !important;
  	  	    padding: 0 !important;
  	  	    appearance: auto !important;
  	  	    -webkit-appearance: slider-vertical !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-toggle-row {
  	  	    position: relative !important;
  	  	    width: 100% !important;
  	  	    user-select: none !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-toggle-row input {
  	  	    position: absolute !important;
  	  	    opacity: 0 !important;
  	  	    pointer-events: none !important;
  	  	    width: 0 !important;
  	  	    height: 0 !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-tick {
  	  	    width: 13px !important;
  	  	    height: 13px !important;
  	  	    flex: 0 0 13px !important;
  	  	    border-radius: 4px !important;
  	  	    border: 1px solid rgba(255,255,255,0.24) !important;
  	  	    background: rgba(255,255,255,0.045) !important;
  	  	    box-shadow:
  	  	    inset 0 0 0 1px rgba(255,255,255,0.025),
  	  	    0 4px 8px rgba(0,0,0,0.18) !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-toggle-row input:checked + .trackit-location-tick {
  	  	    border-color: rgba(255,138,61,0.72) !important;
  	  	    background:
  	  	    radial-gradient(circle at 40% 35%, rgba(255,154,61,0.95), rgba(255,122,36,0.26) 72%) !important;
  	  	    box-shadow:
  	  	    0 0 10px rgba(255,122,36,0.22),
  	  	    inset 0 0 0 1px rgba(255,255,255,0.16) !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-list {
  	  	    display: none !important;
  	  	    max-height: 116px !important;
  	  	    overflow-y: auto !important;
  	  	    overflow-x: hidden !important;
  	  	    padding: 2px 3px 2px 0 !important;
  	  	    margin: 0 !important;
  	  	    gap: 5px !important;
  	  	    flex-direction: column !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-list.visible {
  	  	    display: flex !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-list::-webkit-scrollbar {
  	  	    width: 5px !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-list::-webkit-scrollbar-thumb {
  	  	    background: rgba(255,122,36,0.42) !important;
  	  	    border-radius: 999px !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-row {
  	  	    width: 100% !important;
  	  	    height: 30px !important;
  	  	    min-height: 30px !important;
  	  	    border-radius: 11px !important;
  	  	    border: 1px solid rgba(255,255,255,0.09) !important;
  	  	    background:
  	  	    linear-gradient(145deg, rgba(255,255,255,0.045), rgba(255,255,255,0.014)) !important;
  	  	    color: rgba(255,255,255,0.76) !important;
  	  	    display: grid !important;
  	  	    grid-template-columns: minmax(0, 1fr) auto !important;
  	  	    align-items: center !important;
  	  	    gap: 8px !important;
  	  	    padding: 0 9px !important;
  	  	    box-sizing: border-box !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 9px !important;
  	  	    font-weight: 900 !important;
  	  	    text-align: left !important;
  	  	    overflow: hidden !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-row:hover {
  	  	    color: #fff !important;
  	  	    border-color: rgba(255,138,61,0.34) !important;
  	  	    background: rgba(255,138,61,0.09) !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-row.active {
  	  	    color: #fff !important;
  	  	    border-color: rgba(255,138,61,0.60) !important;
  	  	    background:
  	  	    linear-gradient(145deg, rgba(255,122,36,0.24), rgba(95,42,17,0.28)) !important;
  	  	    box-shadow:
  	  	    inset 0 0 0 1px rgba(255,138,61,0.24),
  	  	    0 7px 14px rgba(0,0,0,0.16) !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-row {
  	  	    position: relative !important;
  	  	    grid-template-columns: 14px minmax(0, 1fr) auto !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-row input {
  	  	    position: absolute !important;
  	  	    opacity: 0 !important;
  	  	    pointer-events: none !important;
  	  	    width: 0 !important;
  	  	    height: 0 !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-row .trackit-location-tick {
  	  	    width: 13px !important;
  	  	    height: 13px !important;
  	  	    border-radius: 4px !important;
  	  	    border: 1px solid rgba(255,255,255,0.24) !important;
  	  	    background: rgba(255,255,255,0.045) !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-row input:checked + .trackit-location-tick {
  	  	    border-color: rgba(255,138,61,0.72) !important;
  	  	    background:
  	  	    radial-gradient(circle at 40% 35%, rgba(255,154,61,0.95), rgba(255,122,36,0.26) 72%) !important;
  	  	    box-shadow:
  	  	    0 0 10px rgba(255,122,36,0.22),
  	  	    inset 0 0 0 1px rgba(255,255,255,0.16) !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-name {
  	  	    min-width: 0 !important;
  	  	    overflow: hidden !important;
  	  	    text-overflow: ellipsis !important;
  	  	    white-space: nowrap !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-company-count {
  	  	    opacity: 0.58 !important;
  	  	    font-size: 8px !important;
  	  	    font-weight: 950 !important;
  	  	    }

  	  	    .trackit-compact-map-control .trackit-location-empty {
  	  	    color: rgba(255,255,255,0.48) !important;
  	  	    font-size: 9px !important;
  	  	    font-weight: 800 !important;
  	  	    padding: 5px 2px !important;
  	  	    }

  	  	    .trackit-location-label-black {
  	  	    position: absolute !important;
  	  	    transform: translate(-50%, -100%) !important;
  	  	    background: rgba(0,0,0,0.86) !important;
  	  	    color: #fff !important;
  	  	    border: 1px solid rgba(255,255,255,0.18) !important;
  	  	    border-radius: 7px !important;
  	  	    padding: 3px 7px !important;
  	  	    font: 900 10px/1.2 Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	  	    letter-spacing: 0.02em !important;
  	  	    white-space: nowrap !important;
  	  	    pointer-events: none !important;
  	  	    box-shadow:
  	  	    0 4px 10px rgba(0,0,0,0.42),
  	  	    inset 0 1px 0 rgba(255,255,255,0.08) !important;
  	  	    }


  	  	    .trackit-directions-popup-header {
  	  	    height: 48px !important;
  	  	    display: flex !important;
  	  	    align-items: center !important;
  	  	    justify-content: space-between !important;
  	  	    gap: 10px !important;
  	  	    padding: 8px 10px !important;
  	  	    box-sizing: border-box !important;
  	  	    cursor: move !important;
  	  	    border-bottom: 1px solid rgba(255,255,255,0.08) !important;
  	  	    background: rgba(255,138,61,0.08) !important;
  	  	    }

  	  	    .trackit-directions-popup-title {
  	  	    font-size: 12px !important;
  	  	    font-weight: 950 !important;
  	  	    letter-spacing: 0.10em !important;
  	  	    text-transform: uppercase !important;
  	  	    color: #ffe3c5 !important;
  	  	    line-height: 1 !important;
  	  	    }

  	  	    .trackit-directions-popup-subtitle {
  	  	    margin-top: 5px !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 850 !important;
  	  	    color: rgba(255,255,255,0.66) !important;
  	  	    line-height: 1 !important;
  	  	    }

  	  	    .trackit-directions-popup-close {
  	  	    width: 26px !important;
  	  	    height: 26px !important;
  	  	    border-radius: 999px !important;
  	  	    border: 1px solid rgba(255,255,255,0.14) !important;
  	  	    background: rgba(255,255,255,0.06) !important;
  	  	    color: #fff !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 18px !important;
  	  	    font-weight: 900 !important;
  	  	    line-height: 22px !important;
  	  	    padding: 0 !important;
  	  	    }

  	  	    .trackit-directions-popup-body {
  	  	    padding: 10px !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-directions-search-wrap {
  	  	    display: flex !important;
  	  	    flex-direction: column !important;
  	  	    gap: 8px !important;
  	  	    padding: 10px !important;
  	  	    box-sizing: border-box !important;
  	  	    border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	  	    }

  	  	    .trackit-directions-search-line {
  	  	    display: grid !important;
  	  	    grid-template-columns: 42px minmax(0, 1fr) !important;
  	  	    align-items: center !important;
  	  	    gap: 8px !important;
  	  	    }

  	  	    .trackit-directions-search-line span {
  	  	    font-size: 9px !important;
  	  	    font-weight: 950 !important;
  	  	    text-transform: uppercase !important;
  	  	    color: rgba(255,232,208,0.74) !important;
  	  	    letter-spacing: 0.08em !important;
  	  	    }

  	  	    .trackit-directions-search-line input {
  	  	    width: 100% !important;
  	  	    height: 30px !important;
  	  	    min-width: 0 !important;
  	  	    border-radius: 10px !important;
  	  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	  	    background: rgba(255,255,255,0.06) !important;
  	  	    color: #fff !important;
  	  	    outline: none !important;
  	  	    padding: 0 9px !important;
  	  	    box-sizing: border-box !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 800 !important;
  	  	    }

  	  	    .trackit-directions-search-line input::placeholder {
  	  	    color: rgba(255,255,255,0.42) !important;
  	  	    }

  	  	    .trackit-directions-search-line input:focus {
  	  	    border-color: rgba(255,138,61,0.56) !important;
  	  	    background: rgba(255,138,61,0.10) !important;
  	  	    }

  	  	    .trackit-directions-status {
  	  	    padding: 0 10px 8px !important;
  	  	    color: rgba(255,255,255,0.62) !important;
  	  	    font-size: 9px !important;
  	  	    font-weight: 850 !important;
  	  	    line-height: 1.25 !important;
  	  	    }

  	  	    .trackit-directions-popup .pac-container {
  	  	    z-index: 1000002 !important;
  	  	    }

  	  	    .trackit-directions-row {
  	  	    display: grid !important;
  	  	    grid-template-columns: 44px minmax(0, 1fr) !important;
  	  	    gap: 8px !important;
  	  	    align-items: center !important;
  	  	    padding: 6px 0 !important;
  	  	    border-bottom: 1px solid rgba(255,255,255,0.06) !important;
  	  	    }

  	  	    .trackit-directions-row span {
  	  	    font-size: 9px !important;
  	  	    font-weight: 950 !important;
  	  	    text-transform: uppercase !important;
  	  	    color: rgba(255,232,208,0.70) !important;
  	  	    }

  	  	    .trackit-directions-row strong {
  	  	    min-width: 0 !important;
  	  	    overflow: hidden !important;
  	  	    text-overflow: ellipsis !important;
  	  	    white-space: nowrap !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 850 !important;
  	  	    color: rgba(255,255,255,0.82) !important;
  	  	    text-align: right !important;
  	  	    }

  	  	    .trackit-directions-actions {
  	  	    display: grid !important;
  	  	    grid-template-columns: 1fr 1fr !important;
  	  	    gap: 7px !important;
  	  	    margin-top: 10px !important;
  	  	    }

  	  	    .trackit-directions-actions button {
  	  	    height: 30px !important;
  	  	    border-radius: 11px !important;
  	  	    border: 1px solid rgba(255,255,255,0.10) !important;
  	  	    background: rgba(255,255,255,0.045) !important;
  	  	    color: rgba(255,255,255,0.82) !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 900 !important;
  	  	    }

  	  	    .trackit-directions-actions button:hover {
  	  	    color: #fff !important;
  	  	    border-color: rgba(255,138,61,0.38) !important;
  	  	    background: rgba(255,138,61,0.10) !important;
  	  	    }

  	  	    /* ---------- Google Places dropdown dark styling ---------- */
  	  	    .pac-container {
  	  	    z-index: 1000005 !important;
  	  	    border-radius: 14px !important;
  	  	    overflow: hidden !important;
  	  	    border: 1px solid rgba(255,122,36,0.48) !important;
  	  	    background:
  	  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.14), transparent 35%),
  	  	    linear-gradient(145deg, rgba(16,17,16,0.98), rgba(3,7,7,0.99)) !important;
  	  	    box-shadow:
  	  	    0 18px 34px rgba(0,0,0,0.46),
  	  	    inset 0 1px 0 rgba(255,255,255,0.055) !important;
  	  	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	  	    }

  	  	    .pac-item {
  	  	    height: auto !important;
  	  	    min-height: 36px !important;
  	  	    padding: 8px 10px !important;
  	  	    border-top: 1px solid rgba(255,255,255,0.06) !important;
  	  	    color: rgba(255,255,255,0.66) !important;
  	  	    background: transparent !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 10px !important;
  	  	    line-height: 1.25 !important;
  	  	    }

  	  	    .pac-item:hover,
  	  	    .pac-item-selected {
  	  	    background: rgba(255,138,61,0.14) !important;
  	  	    }

  	  	    .pac-item-query {
  	  	    color: #ffe3c5 !important;
  	  	    font-weight: 950 !important;
  	  	    font-size: 10px !important;
  	  	    }

  	  	    .pac-matched {
  	  	    color: #ff9a3d !important;
  	  	    font-weight: 950 !important;
  	  	    }

  	  	    .pac-icon {
  	  	    filter: invert(1) opacity(0.75) !important;
  	  	    }

  	  	    /* ---------- TrackIT vehicle suggestions ---------- */
  	  	    .trackit-directions-input-wrap {
  	  	    position: relative !important;
  	  	    min-width: 0 !important;
  	  	    width: 100% !important;
  	  	    }

  	  	    .trackit-directions-vehicle-suggest {
  	  	    display: none !important;
  	  	    position: absolute !important;
  	  	    top: 34px !important;
  	  	    left: 0 !important;
  	  	    right: 0 !important;
  	  	    z-index: 1000004 !important;
  	  	    max-height: 168px !important;
  	  	    overflow-y: auto !important;
  	  	    overflow-x: hidden !important;
  	  	    border-radius: 13px !important;
  	  	    border: 1px solid rgba(255,122,36,0.44) !important;
  	  	    background:
  	  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.13), transparent 35%),
  	  	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	  	    box-shadow: 0 14px 26px rgba(0,0,0,0.42) !important;
  	  	    padding: 4px !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-directions-vehicle-suggest.visible {
  	  	    display: block !important;
  	  	    }

  	  	    .trackit-directions-vehicle-option {
  	  	    width: 100% !important;
  	  	    min-height: 32px !important;
  	  	    border: 0 !important;
  	  	    border-radius: 10px !important;
  	  	    background: transparent !important;
  	  	    color: rgba(255,255,255,0.78) !important;
  	  	    display: grid !important;
  	  	    grid-template-columns: minmax(0, 1fr) auto !important;
  	  	    align-items: center !important;
  	  	    gap: 8px !important;
  	  	    padding: 6px 8px !important;
  	  	    box-sizing: border-box !important;
  	  	    cursor: pointer !important;
  	  	    text-align: left !important;
  	  	    }

  	  	    .trackit-directions-vehicle-option:hover {
  	  	    background: rgba(255,138,61,0.14) !important;
  	  	    color: #fff !important;
  	  	    }

  	  	    .trackit-directions-vehicle-id {
  	  	    min-width: 0 !important;
  	  	    overflow: hidden !important;
  	  	    text-overflow: ellipsis !important;
  	  	    white-space: nowrap !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 950 !important;
  	  	    color: #ffe3c5 !important;
  	  	    }

  	  	    .trackit-directions-vehicle-meta {
  	  	    font-size: 8px !important;
  	  	    font-weight: 900 !important;
  	  	    color: rgba(255,255,255,0.50) !important;
  	  	    text-transform: uppercase !important;
  	  	    }

  	  	    .trackit-directions-waypoints {
  	  	    display: flex !important;
  	  	    flex-direction: column !important;
  	  	    gap: 8px !important;
  	  	    }

  	  	    .trackit-directions-search-line {
  	  	    display: grid !important;
  	  	    grid-template-columns: 42px minmax(0, 1fr) 24px !important;
  	  	    align-items: center !important;
  	  	    gap: 8px !important;
  	  	    }

  	  	    .trackit-directions-search-line.no-remove {
  	  	    grid-template-columns: 42px minmax(0, 1fr) !important;
  	  	    }

  	  	    .trackit-directions-remove-stop {
  	  	    width: 22px !important;
  	  	    height: 22px !important;
  	  	    border-radius: 999px !important;
  	  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	  	    background: rgba(255,255,255,0.045) !important;
  	  	    color: rgba(255,255,255,0.78) !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 14px !important;
  	  	    font-weight: 950 !important;
  	  	    line-height: 18px !important;
  	  	    padding: 0 !important;
  	  	    }

  	  	    .trackit-directions-remove-stop:hover {
  	  	    color: #fff !important;
  	  	    border-color: rgba(255,138,61,0.45) !important;
  	  	    background: rgba(255,138,61,0.14) !important;
  	  	    }

  	  	    .trackit-directions-add-stop {
  	  	    height: 30px !important;
  	  	    border-radius: 11px !important;
  	  	    border: 1px solid rgba(255,138,61,0.35) !important;
  	  	    background: rgba(255,138,61,0.08) !important;
  	  	    color: #ffe3c5 !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 950 !important;
  	  	    letter-spacing: 0.04em !important;
  	  	    }

  	  	    .trackit-directions-add-stop:hover {
  	  	    background: rgba(255,138,61,0.16) !important;
  	  	    border-color: rgba(255,138,61,0.62) !important;
  	  	    color: #fff !important;
  	  	    }

  	  	    /* ---------- Directions: Google dropdown dark styling ---------- */
  	  	    .pac-container {
  	  	    z-index: 1000005 !important;
  	  	    border-radius: 14px !important;
  	  	    overflow: hidden !important;
  	  	    border: 1px solid rgba(255,122,36,0.48) !important;
  	  	    background:
  	  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.14), transparent 35%),
  	  	    linear-gradient(145deg, rgba(16,17,16,0.98), rgba(3,7,7,0.99)) !important;
  	  	    box-shadow:
  	  	    0 18px 34px rgba(0,0,0,0.46),
  	  	    inset 0 1px 0 rgba(255,255,255,0.055) !important;
  	  	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	  	    }

  	  	    .pac-item {
  	  	    min-height: 36px !important;
  	  	    padding: 8px 10px !important;
  	  	    border-top: 1px solid rgba(255,255,255,0.06) !important;
  	  	    color: rgba(255,255,255,0.66) !important;
  	  	    background: transparent !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 10px !important;
  	  	    line-height: 1.25 !important;
  	  	    }

  	  	    .pac-item:hover,
  	  	    .pac-item-selected {
  	  	    background: rgba(255,138,61,0.14) !important;
  	  	    }

  	  	    .pac-item-query {
  	  	    color: #ffe3c5 !important;
  	  	    font-weight: 950 !important;
  	  	    font-size: 10px !important;
  	  	    }

  	  	    .pac-matched {
  	  	    color: #ff9a3d !important;
  	  	    font-weight: 950 !important;
  	  	    }

  	  	    .pac-icon {
  	  	    filter: invert(1) opacity(0.75) !important;
  	  	    }

  	  	    .trackit-directions-popup {
  	  	    position: absolute !important;
  	  	    z-index: 999998 !important;
  	  	    width: 330px !important;
  	  	    border-radius: 16px !important;
  	  	    overflow: visible !important;
  	  	    color: #fff !important;
  	  	    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	  	    background:
  	  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.16), transparent 32%),
  	  	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	  	    border: 1px solid rgba(255,122,36,0.52) !important;
  	  	    box-shadow:
  	  	    0 18px 34px rgba(0,0,0,0.45),
  	  	    inset 0 1px 0 rgba(255,255,255,0.055) !important;
  	  	    pointer-events: auto !important;
  	  	    }

  	  	    .trackit-directions-popup-header {
  	  	    height: 48px !important;
  	  	    display: flex !important;
  	  	    align-items: center !important;
  	  	    justify-content: space-between !important;
  	  	    gap: 10px !important;
  	  	    padding: 8px 10px !important;
  	  	    box-sizing: border-box !important;
  	  	    cursor: move !important;
  	  	    border-bottom: 1px solid rgba(255,255,255,0.08) !important;
  	  	    background: rgba(255,138,61,0.08) !important;
  	  	    border-radius: 16px 16px 0 0 !important;
  	  	    }

  	  	    .trackit-directions-popup-title {
  	  	    font-size: 12px !important;
  	  	    font-weight: 950 !important;
  	  	    letter-spacing: 0.10em !important;
  	  	    text-transform: uppercase !important;
  	  	    color: #ffe3c5 !important;
  	  	    line-height: 1 !important;
  	  	    }

  	  	    .trackit-directions-popup-subtitle {
  	  	    margin-top: 5px !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 850 !important;
  	  	    color: rgba(255,255,255,0.66) !important;
  	  	    line-height: 1 !important;
  	  	    }

  	  	    .trackit-directions-popup-close {
  	  	    width: 26px !important;
  	  	    height: 26px !important;
  	  	    border-radius: 999px !important;
  	  	    border: 1px solid rgba(255,255,255,0.14) !important;
  	  	    background: rgba(255,255,255,0.06) !important;
  	  	    color: #fff !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 18px !important;
  	  	    font-weight: 900 !important;
  	  	    line-height: 22px !important;
  	  	    padding: 0 !important;
  	  	    }

  	  	    .trackit-directions-search-wrap {
  	  	    display: flex !important;
  	  	    flex-direction: column !important;
  	  	    gap: 8px !important;
  	  	    padding: 10px !important;
  	  	    box-sizing: border-box !important;
  	  	    border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	  	    }

  	  	    .trackit-directions-search-line {
  	  	    display: grid !important;
  	  	    grid-template-columns: 46px minmax(0, 1fr) 24px !important;
  	  	    align-items: center !important;
  	  	    gap: 8px !important;
  	  	    min-width: 0 !important;
  	  	    }

  	  	    .trackit-directions-search-line.no-remove {
  	  	    grid-template-columns: 46px minmax(0, 1fr) !important;
  	  	    }

  	  	    .trackit-directions-search-line span {
  	  	    font-size: 9px !important;
  	  	    font-weight: 950 !important;
  	  	    text-transform: uppercase !important;
  	  	    color: rgba(255,232,208,0.74) !important;
  	  	    letter-spacing: 0.08em !important;
  	  	    }

  	  	    .trackit-directions-input-wrap {
  	  	    position: relative !important;
  	  	    min-width: 0 !important;
  	  	    width: 100% !important;
  	  	    }

  	  	    .trackit-directions-search-line input,
  	  	    .trackit-directions-whatsapp-wrap input {
  	  	    width: 100% !important;
  	  	    height: 30px !important;
  	  	    min-width: 0 !important;
  	  	    border-radius: 10px !important;
  	  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	  	    background: rgba(255,255,255,0.06) !important;
  	  	    color: #fff !important;
  	  	    outline: none !important;
  	  	    padding: 0 9px !important;
  	  	    box-sizing: border-box !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 850 !important;
  	  	    }

  	  	    .trackit-directions-search-line input::placeholder,
  	  	    .trackit-directions-whatsapp-wrap input::placeholder {
  	  	    color: rgba(255,255,255,0.42) !important;
  	  	    }

  	  	    .trackit-directions-search-line input:focus {
  	  	    border-color: rgba(255,138,61,0.56) !important;
  	  	    background: rgba(255,138,61,0.10) !important;
  	  	    }

  	  	    .trackit-directions-vehicle-suggest {
  	  	    display: none !important;
  	  	    position: absolute !important;
  	  	    top: 34px !important;
  	  	    left: 0 !important;
  	  	    right: 0 !important;
  	  	    z-index: 1000004 !important;
  	  	    max-height: 168px !important;
  	  	    overflow-y: auto !important;
  	  	    overflow-x: hidden !important;
  	  	    border-radius: 13px !important;
  	  	    border: 1px solid rgba(255,122,36,0.44) !important;
  	  	    background:
  	  	    radial-gradient(circle at 18% 0%, rgba(255,133,49,0.13), transparent 35%),
  	  	    linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	  	    box-shadow: 0 14px 26px rgba(0,0,0,0.42) !important;
  	  	    padding: 4px !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-directions-vehicle-suggest.visible {
  	  	    display: block !important;
  	  	    }

  	  	    .trackit-directions-vehicle-option {
  	  	    width: 100% !important;
  	  	    min-height: 32px !important;
  	  	    border: 0 !important;
  	  	    border-radius: 10px !important;
  	  	    background: transparent !important;
  	  	    color: rgba(255,255,255,0.78) !important;
  	  	    display: grid !important;
  	  	    grid-template-columns: minmax(0, 1fr) auto !important;
  	  	    align-items: center !important;
  	  	    gap: 8px !important;
  	  	    padding: 6px 8px !important;
  	  	    box-sizing: border-box !important;
  	  	    cursor: pointer !important;
  	  	    text-align: left !important;
  	  	    }

  	  	    .trackit-directions-vehicle-option:hover {
  	  	    background: rgba(255,138,61,0.14) !important;
  	  	    color: #fff !important;
  	  	    }

  	  	    .trackit-directions-vehicle-id {
  	  	    min-width: 0 !important;
  	  	    overflow: hidden !important;
  	  	    text-overflow: ellipsis !important;
  	  	    white-space: nowrap !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 950 !important;
  	  	    color: #ffe3c5 !important;
  	  	    }

  	  	    .trackit-directions-vehicle-meta {
  	  	    font-size: 8px !important;
  	  	    font-weight: 900 !important;
  	  	    color: rgba(255,255,255,0.50) !important;
  	  	    text-transform: uppercase !important;
  	  	    }

  	  	    .trackit-directions-waypoints {
  	  	    display: flex !important;
  	  	    flex-direction: column !important;
  	  	    gap: 8px !important;
  	  	    }

  	  	    .trackit-directions-add-stop,
  	  	    .trackit-directions-remove-stop {
  	  	    cursor: pointer !important;
  	  	    }

  	  	    .trackit-directions-add-stop {
  	  	    height: 30px !important;
  	  	    border-radius: 11px !important;
  	  	    border: 1px solid rgba(255,138,61,0.35) !important;
  	  	    background: rgba(255,138,61,0.08) !important;
  	  	    color: #ffe3c5 !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 950 !important;
  	  	    letter-spacing: 0.04em !important;
  	  	    }

  	  	    .trackit-directions-add-stop:hover {
  	  	    background: rgba(255,138,61,0.16) !important;
  	  	    border-color: rgba(255,138,61,0.62) !important;
  	  	    color: #fff !important;
  	  	    }

  	  	    .trackit-directions-remove-stop {
  	  	    width: 22px !important;
  	  	    height: 22px !important;
  	  	    border-radius: 999px !important;
  	  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	  	    background: rgba(255,255,255,0.045) !important;
  	  	    color: rgba(255,255,255,0.78) !important;
  	  	    font-size: 14px !important;
  	  	    font-weight: 950 !important;
  	  	    line-height: 18px !important;
  	  	    padding: 0 !important;
  	  	    }

  	  	    .trackit-directions-remove-stop:hover {
  	  	    color: #fff !important;
  	  	    border-color: rgba(255,138,61,0.45) !important;
  	  	    background: rgba(255,138,61,0.14) !important;
  	  	    }

  	  	    .trackit-directions-status {
  	  	    padding: 8px 10px !important;
  	  	    color: rgba(255,255,255,0.62) !important;
  	  	    font-size: 9px !important;
  	  	    font-weight: 850 !important;
  	  	    line-height: 1.25 !important;
  	  	    border-bottom: 1px solid rgba(255,255,255,0.07) !important;
  	  	    }

  	  	    .trackit-directions-popup-body {
  	  	    padding: 10px !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-directions-row {
  	  	    display: grid !important;
  	  	    grid-template-columns: 48px minmax(0, 1fr) !important;
  	  	    gap: 8px !important;
  	  	    align-items: center !important;
  	  	    padding: 6px 0 !important;
  	  	    border-bottom: 1px solid rgba(255,255,255,0.06) !important;
  	  	    }

  	  	    .trackit-directions-row span {
  	  	    font-size: 9px !important;
  	  	    font-weight: 950 !important;
  	  	    text-transform: uppercase !important;
  	  	    color: rgba(255,232,208,0.70) !important;
  	  	    }

  	  	    .trackit-directions-row strong {
  	  	    min-width: 0 !important;
  	  	    overflow: hidden !important;
  	  	    text-overflow: ellipsis !important;
  	  	    white-space: nowrap !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 850 !important;
  	  	    color: rgba(255,255,255,0.82) !important;
  	  	    text-align: right !important;
  	  	    }

  	  	    .trackit-directions-actions {
  	  	    display: grid !important;
  	  	    grid-template-columns: 1fr 1fr !important;
  	  	    gap: 7px !important;
  	  	    margin-top: 10px !important;
  	  	    }

  	  	    .trackit-directions-actions button {
  	  	    height: 30px !important;
  	  	    border-radius: 11px !important;
  	  	    border: 1px solid rgba(255,255,255,0.10) !important;
  	  	    background: rgba(255,255,255,0.045) !important;
  	  	    color: rgba(255,255,255,0.82) !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 900 !important;
  	  	    }

  	  	    .trackit-directions-actions button:hover {
  	  	    color: #fff !important;
  	  	    border-color: rgba(255,138,61,0.38) !important;
  	  	    background: rgba(255,138,61,0.10) !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-wrap {
  	  	    display: grid !important;
  	  	    grid-template-columns: minmax(0, 1fr) auto !important;
  	  	    gap: 7px !important;
  	  	    margin-top: 10px !important;
  	  	    align-items: center !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-wrap input:focus {
  	  	    border-color: rgba(37,211,102,0.62) !important;
  	  	    background: rgba(37,211,102,0.10) !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-btn {
  	  	    height: 30px !important;
  	  	    border-radius: 11px !important;
  	  	    border: 1px solid rgba(37,211,102,0.42) !important;
  	  	    background: rgba(37,211,102,0.10) !important;
  	  	    color: #d8ffe6 !important;
  	  	    cursor: pointer !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 950 !important;
  	  	    white-space: nowrap !important;
  	  	    padding: 0 10px !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-btn:hover {
  	  	    border-color: rgba(37,211,102,0.78) !important;
  	  	    background: rgba(37,211,102,0.18) !important;
  	  	    color: #fff !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-btn.sending {
  	  	    opacity: 0.72 !important;
  	  	    pointer-events: none !important;
  	  	    }

  	  	    .gm-svpc {
  	  	    display: none !important;
  	  	    opacity: 0 !important;
  	  	    pointer-events: none !important;
  	  	    }

  	  	    /* ---------- Directions popup docked right refinement ---------- */

  	  	    .trackit-directions-popup {
  	  	    position: absolute !important;
  	  	    top: 50px !important;
  	  	    right: 0 !important;
  	  	    left: auto !important;
  	  	    width: 430px !important;
  	  	    max-width: calc(100vw - 12px) !important;
  	  	    border-radius: 0 0 0 24px !important;
  	  	    overflow: hidden !important;
  	  	    border-top: 1px solid rgba(255,122,36,0.58) !important;
  	  	    border-left: 1px solid rgba(255,122,36,0.58) !important;
  	  	    border-right: 0 !important;
  	  	    border-bottom: 1px solid rgba(255,122,36,0.46) !important;
  	  	    box-shadow:
  	  	    -16px 18px 36px rgba(0,0,0,0.44),
  	  	    inset 0 1px 0 rgba(255,255,255,0.045) !important;
  	  	    }

  	  	    .trackit-directions-popup-header {
  	  	    cursor: default !important;
  	  	    border-radius: 0 !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-wrap {
  	  	    display: grid !important;
  	  	    grid-template-columns: 86px minmax(0, 1fr) 114px !important;
  	  	    gap: 7px !important;
  	  	    align-items: center !important;
  	  	    width: 100% !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-directions-country-select {
  	  	    height: 38px !important;
  	  	    min-width: 0 !important;
  	  	    border-radius: 12px !important;
  	  	    border: 1px solid rgba(255,138,61,0.34) !important;
  	  	    background:
  	  	    linear-gradient(145deg, rgba(255,138,61,0.15), rgba(255,255,255,0.035)) !important;
  	  	    color: rgba(255,232,208,0.92) !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 950 !important;
  	  	    padding: 0 8px !important;
  	  	    outline: 0 !important;
  	  	    box-sizing: border-box !important;
  	  	    cursor: pointer !important;
  	  	    }

  	  	    .trackit-directions-country-select option {
  	  	    background: #111 !important;
  	  	    color: #fff !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-phone {
  	  	    height: 38px !important;
  	  	    min-width: 0 !important;
  	  	    border-radius: 12px !important;
  	  	    border: 1px solid rgba(255,255,255,0.12) !important;
  	  	    background: rgba(255,255,255,0.055) !important;
  	  	    color: #fff !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 850 !important;
  	  	    padding: 0 10px !important;
  	  	    outline: 0 !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-phone::placeholder {
  	  	    color: rgba(255,255,255,0.38) !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-phone:focus {
  	  	    border-color: rgba(255,138,61,0.68) !important;
  	  	    background: rgba(255,138,61,0.08) !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-phone.invalid {
  	  	    border-color: rgba(255,70,70,0.85) !important;
  	  	    background: rgba(255,45,45,0.10) !important;
  	  	    box-shadow:
  	  	    0 0 0 1px rgba(255,70,70,0.22),
  	  	    0 0 14px rgba(255,45,45,0.16) !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-btn {
  	  	    height: 38px !important;
  	  	    min-width: 0 !important;
  	  	    border-radius: 12px !important;
  	  	    display: flex !important;
  	  	    align-items: center !important;
  	  	    justify-content: center !important;
  	  	    gap: 7px !important;
  	  	    border: 1px solid rgba(51,214,105,0.58) !important;
  	  	    background:
  	  	    linear-gradient(145deg, rgba(37,211,102,0.24), rgba(9,58,29,0.78)) !important;
  	  	    color: #eaffef !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 950 !important;
  	  	    padding: 0 10px !important;
  	  	    box-sizing: border-box !important;
  	  	    cursor: pointer !important;
  	  	    white-space: nowrap !important;
  	  	    box-shadow:
  	  	    inset 0 0 0 1px rgba(255,255,255,0.06),
  	  	    0 7px 14px rgba(0,0,0,0.20) !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-btn:hover {
  	  	    border-color: rgba(80,255,139,0.78) !important;
  	  	    background:
  	  	    linear-gradient(145deg, rgba(37,211,102,0.34), rgba(9,75,36,0.86)) !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-btn.sending {
  	  	    opacity: 0.72 !important;
  	  	    pointer-events: none !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-btn .trackit-whatsapp-icon {
  	  	    width: 16px !important;
  	  	    height: 16px !important;
  	  	    flex: 0 0 16px !important;
  	  	    color: #25d366 !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-btn span {
  	  	    overflow: hidden !important;
  	  	    text-overflow: ellipsis !important;
  	  	    white-space: nowrap !important;
  	  	    }

  	  	    /* ============================================================
  	  	    TrackIT Directions Popup Layout Patch
  	  	    Width: 300px
  	  	    Add Stop aligned to search inputs
  	  	    Clear/New Route single action
  	  	    WhatsApp number row + button row
  	  	    ============================================================ */

  	  	    .trackit-directions-popup {
  	  	    width: 300px !important;
  	  	    max-width: calc(100vw - 12px) !important;
  	  	    }

  	  	    /* Keep labelled rows compact inside 300px popup */
  	  	    .trackit-directions-search-line,
  	  	    .trackit-directions-search-line.no-remove {
  	  	    grid-template-columns: 52px minmax(0, 1fr) !important;
  	  	    gap: 8px !important;
  	  	    }

  	  	    /* Add Stop should match From/To input width, not full popup width */
  	  	    .trackit-directions-add-stop {
  	  	    width: calc(100% - 60px) !important;
  	  	    margin-left: 60px !important;
  	  	    margin-right: 0 !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    /* Only one action button now */
  	  	    .trackit-directions-actions {
  	  	    display: grid !important;
  	  	    grid-template-columns: minmax(0, 1fr) !important;
  	  	    gap: 0 !important;
  	  	    margin-top: 10px !important;
  	  	    }

  	  	    .trackit-directions-actions .trackit-directions-new {
  	  	    width: 100% !important;
  	  	    }

  	  	    .trackit-directions-actions .trackit-directions-clear {
  	  	    display: none !important;
  	  	    }

  	  	    /* WhatsApp number area:
  	  	    Row 1 = country select + phone input
  	  	    Row 2 = WhatsApp button alone, justified right
  	  	    */
  	  	    .trackit-directions-whatsapp-wrap {
  	  	    display: grid !important;
  	  	    grid-template-columns: 78px minmax(0, 1fr) !important;
  	  	    grid-auto-rows: 38px !important;
  	  	    gap: 7px !important;
  	  	    align-items: center !important;
  	  	    width: 100% !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-directions-country-select {
  	  	    grid-column: 1 !important;
  	  	    grid-row: 1 !important;
  	  	    width: 100% !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-phone {
  	  	    grid-column: 2 !important;
  	  	    grid-row: 1 !important;
  	  	    width: 100% !important;
  	  	    }

  	  	    .trackit-directions-driver-btn,
  	  	    .trackit-directions-whatsapp-btn {
  	  	    grid-column: 1 / -1 !important;
  	  	    justify-self: end !important;
  	  	    width: auto !important;
  	  	    min-width: 122px !important;
  	  	    padding-left: 14px !important;
  	  	    padding-right: 14px !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-btn {
  	  	    grid-row: 2 !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-wrap.has-driver .trackit-directions-driver-btn {
  	  	    display: flex !important;
  	  	    grid-row: 2 !important;
  	  	    justify-self: stretch !important;
  	  	    width: 100% !important;
  	  	    }

  	  	    .trackit-directions-whatsapp-wrap.has-driver .trackit-directions-whatsapp-btn {
  	  	    grid-row: 3 !important;
  	  	    }

  	  	    .trackit-directions-driver-btn {
  	  	    height: 38px !important;
  	  	    min-width: 0 !important;
  	  	    border-radius: 12px !important;
  	  	    align-items: center !important;
  	  	    justify-content: center !important;
  	  	    gap: 7px !important;
  	  	    border: 1px solid rgba(37,211,102,0.48) !important;
  	  	    background: rgba(37,211,102,0.12) !important;
  	  	    color: #eaffef !important;
  	  	    font-size: 10px !important;
  	  	    font-weight: 950 !important;
  	  	    box-sizing: border-box !important;
  	  	    cursor: pointer !important;
  	  	    white-space: nowrap !important;
  	  	    }

  	  	    .trackit-directions-driver-btn:hover:not(:disabled) {
  	  	    border-color: rgba(80,255,139,0.78) !important;
  	  	    background: rgba(37,211,102,0.22) !important;
  	  	    }

  	  	    .trackit-directions-driver-btn:disabled,
  	  	    .trackit-directions-driver-btn.missing {
  	  	    opacity: 0.48 !important;
  	  	    cursor: not-allowed !important;
  	  	    }

  	  	    .trackit-directions-driver-btn .trackit-whatsapp-icon {
  	  	    width: 16px !important;
  	  	    height: 16px !important;
  	  	    flex: 0 0 16px !important;
  	  	    color: #25d366 !important;
  	  	    }

  	  	    /* ============================================================
  	  	    TrackIT Directions Stop Delete Alignment Patch
  	  	    Keeps waypoint delete button next to the Stop input bar
  	  	    ============================================================ */

  	  	    /* Only waypoint rows need the third column for delete */
  	  	    .trackit-directions-search-line[data-route-row^="waypoint:"] {
  	  	    display: grid !important;
  	  	    grid-template-columns: 52px minmax(0, 1fr) 30px !important;
  	  	    gap: 8px !important;
  	  	    align-items: center !important;
  	  	    }

  	  	    /* Stop label */
  	  	    .trackit-directions-search-line[data-route-row^="waypoint:"] > span {
  	  	    grid-column: 1 !important;
  	  	    grid-row: 1 !important;
  	  	    align-self: center !important;
  	  	    }

  	  	    /* Stop search/select input */
  	  	    .trackit-directions-search-line[data-route-row^="waypoint:"] .trackit-directions-input-wrap {
  	  	    grid-column: 2 !important;
  	  	    grid-row: 1 !important;
  	  	    width: 100% !important;
  	  	    min-width: 0 !important;
  	  	    }

  	  	    /* Delete button sits directly beside the input */
  	  	    .trackit-directions-search-line[data-route-row^="waypoint:"] .trackit-directions-remove-stop {
  	  	    grid-column: 3 !important;
  	  	    grid-row: 1 !important;

  	  	    width: 28px !important;
  	  	    height: 28px !important;
  	  	    min-width: 28px !important;
  	  	    min-height: 28px !important;

  	  	    margin: 0 !important;
  	  	    padding: 0 !important;

  	  	    align-self: center !important;
  	  	    justify-self: center !important;

  	  	    border-radius: 999px !important;
  	  	    border: 1px solid rgba(255,255,255,0.14) !important;

  	  	    background: rgba(255,255,255,0.055) !important;
  	  	    color: rgba(255,255,255,0.86) !important;

  	  	    display: flex !important;
  	  	    align-items: center !important;
  	  	    justify-content: center !important;

  	  	    font-size: 18px !important;
  	  	    font-weight: 950 !important;
  	  	    line-height: 1 !important;

  	  	    cursor: pointer !important;
  	  	    box-sizing: border-box !important;
  	  	    }

  	  	    .trackit-directions-search-line[data-route-row^="waypoint:"] .trackit-directions-remove-stop:hover {
  	  	    color: #fff !important;
  	  	    border-color: rgba(255,138,61,0.55) !important;
  	  	    background: rgba(255,138,61,0.16) !important;
  	  	    }
  	  	    `;

  	  	    document.head.appendChild(style);

  	  	    let currentMapType = readSetting("mapType", "hybrid") || "hybrid";
  	  	    let trafficOn = readSetting("trafficOn", true);
  	  	    let collapsed = readSetting("panelCollapsedV8", true);
  	  	    let labelsOn = readSetting("labelsOn", true);

  	  	    // Default OFF. Once user switches it on, it can remember the state.
  	  	    let locationsOn = readSetting("locationsOn", false) === true;

  	  	    function normaliseSavedLocationCompanyKeys(value) {
  	  	      if (Array.isArray(value)) {
  	  	        return value.map(String).filter(Boolean);
  	  	      }

  	  	      if (value && typeof value === "object") {
  	  	        return Object.keys(value).filter(key => value[key]);
  	  	      }

  	  	      if (typeof value === "string" && value.trim()) {
  	  	        try {
  	  	          const parsed = JSON.parse(value);
  	  	          if (Array.isArray(parsed)) return parsed.map(String).filter(Boolean);
  	  	        } catch (_) {}

  	  	        return value.split(",").map(v => v.trim()).filter(Boolean);
  	  	      }

  	  	      return [];
  	  	    }

  	  	    let checkedLocationCompanyKeys = normaliseSavedLocationCompanyKeys(
  	  	      readSetting("checkedLocationCompanyKeys", [])
  	  	    );

  	  	    try {
  	  	      map.setMapTypeId(currentMapType);
  	  	    } catch (_) {}

  	  	    if (!map.__trackitTrafficLayer) {
  	  	      map.__trackitTrafficLayer = new google.maps.TrafficLayer();
  	  	    }

  	  	    map.__trackitTrafficLayer.setMap(trafficOn ? map: null);

  	  	    const control = document.createElement("div");
  	  	    control.className = "trackit-compact-map-control ces-bottom-shape";
  	  	    control.__trackitUnifiedMapControl = true;
  	  	    control.setAttribute("data-trackit-map-control", "fleet");

  	  	    if (collapsed) {
  	  	      control.classList.add("collapsed");
  	  	    }

  	  	    const shellContent = document.createElement("div");
  	  	    shellContent.className = "ces-bottom-content";
  	  	    shellContent.setAttribute("data-trackit-new-map-control", "fleet");

  	  	    const header = document.createElement("button");
  	  	    header.type = "button";
  	  	    header.className = "ces-map-control-header";
  	  	    header.setAttribute("data-map-control-toggle", "fleet");

  	  	    const headerIcon = document.createElement("div");
  	  	    headerIcon.className = "ces-map-control-header-icon";
  	  	    headerIcon.innerHTML = `
  	  	    <div class="ces-layer-icon">
  	  	    <span></span>
  	  	    <span></span>
  	  	    <span></span>
  	  	    </div>
  	  	    `;

  	  	    const headerText = document.createElement("div");
  	  	    headerText.className = "ces-map-control-header-text";

  	  	    const title = document.createElement("div");
  	  	    title.className = "ces-map-title";
  	  	    title.textContent = "Map Control";

  	  	    const subtitle = document.createElement("div");
  	  	    subtitle.className = "ces-map-subtitle";

  	  	    headerText.appendChild(title);
  	  	    headerText.appendChild(subtitle);

  	  	    const collapseIcon = document.createElement("div");
  	  	    collapseIcon.className = "ces-caret";

  	  	    header.appendChild(headerIcon);
  	  	    header.appendChild(headerText);
  	  	    header.appendChild(collapseIcon);

  	  	    const body = document.createElement("div");
  	  	    body.className = "ces-map-control-body";

  	  	    const main = document.createElement("div");
  	  	    main.className = "ces-map-control-main";

  	  	    const mapTypeSection = document.createElement("div");
  	  	    mapTypeSection.className = "ces-map-control-section";

  	  	    const typeLabelRow = sectionLabel("Map Type", iconLayers());

  	  	    const typeTabs = document.createElement("div");
  	  	    typeTabs.className = "ces-map-control-tools fleet-map-type-tools";

  	  	    const mapTypes = [{
  	  	      id: "roadmap",
  	  	      label: "Road",
  	  	      icon: iconRoadmap()
  	  	    },
  	  	      {
  	  	        id: "satellite",
  	  	        label: "Sat",
  	  	        icon: iconSatellite()
  	  	      },
  	  	      {
  	  	        id: "hybrid",
  	  	        label: "Hybrid",
  	  	        icon: iconLayers()
  	  	      },
  	  	      {
  	  	        id: "terrain",
  	  	        label: "Terrain",
  	  	        icon: iconTerrain()
  	  	      }];

  	  	    const typeButtons = {};

  	  	    mapTypes.forEach(type => {
  	  	      const btn = document.createElement("button");
  	  	      btn.type = "button";
  	  	      btn.className = "ces-map-control-tool fleet-map-type-btn";
  	  	      btn.dataset.mapType = type.id;
  	  	      btn.innerHTML = `${type.icon}<span>${type.label}</span>`;

  	  	      btn.addEventListener("click", function (event) {
  	  	        event.preventDefault();
  	  	        event.stopPropagation();

  	  	        currentMapType = type.id;

  	  	        writeSetting("mapType", type.id);
  	  	        applyMapAppearance();
  	  	        paintMapTypeButtons();
  	  	      });

  	  	      typeButtons[type.id] = btn;
  	  	      typeTabs.appendChild(btn);
  	  	    });

  	  	    mapTypeSection.appendChild(typeLabelRow);
  	  	    mapTypeSection.appendChild(typeTabs);

  	  	    const toolsSection = document.createElement("div");
  	  	    toolsSection.className = "ces-map-control-section";

  	  	    const toolsLabelRow = sectionLabel("Tools", iconLayers());

  	  	    const toolsGrid = document.createElement("div");
  	  	    toolsGrid.className = "ces-map-control-tools fleet-map-tools";

  	  	    const trafficBtn = toolButton("Traffic", iconTraffic());
  	  	    const labelsBtn = toolButton("Labels", iconLabel());
  	  	    const fullscreenBtn = toolButton("Fullscreen", iconFullscreen());
  	  	    const directionsBtn = toolButton("Directions", iconDirections());

  	  	    toolsGrid.appendChild(trafficBtn);
  	  	    toolsGrid.appendChild(labelsBtn);
  	  	    toolsGrid.appendChild(fullscreenBtn);
  	  	    toolsGrid.appendChild(directionsBtn);

  	  	    toolsSection.appendChild(toolsLabelRow);
  	  	    toolsSection.appendChild(toolsGrid);

  	  	    // ---------- App Data Locations UI ----------
  	  	    const locationsSection = document.createElement("div");
  	  	    locationsSection.className = "ces-map-control-section trackit-locations-section";

  	  	    const locationsLabelRow = sectionLabel("Locations", iconLocation());

  	  	    const locationsToggleRow = document.createElement("label");
  	  	    locationsToggleRow.className = "ces-map-control-tool trackit-location-toggle-row";

  	  	    const locationsCheckbox = document.createElement("input");
  	  	    locationsCheckbox.type = "checkbox";
  	  	    locationsCheckbox.checked = !!locationsOn;

  	  	    const locationsTick = document.createElement("span");
  	  	    locationsTick.className = "trackit-location-tick";

  	  	    const locationsText = document.createElement("span");
  	  	    locationsText.textContent = "View Locations";

  	  	    locationsToggleRow.appendChild(locationsCheckbox);
  	  	    locationsToggleRow.appendChild(locationsTick);

  	  	    const locationsIconWrap = document.createElement("span");
  	  	    locationsIconWrap.innerHTML = iconLocation();
  	  	    locationsToggleRow.appendChild(locationsIconWrap.firstElementChild);

  	  	    locationsToggleRow.appendChild(locationsText);

  	  	    const locationsList = document.createElement("div");
  	  	    locationsList.className = "trackit-location-company-list";

  	  	    locationsSection.appendChild(locationsLabelRow);
  	  	    locationsSection.appendChild(locationsToggleRow);
  	  	    locationsSection.appendChild(locationsList);

  	  	    main.appendChild(mapTypeSection);
  	  	    main.appendChild(toolsSection);
  	  	    main.appendChild(locationsSection);

  	  	    const zoomPanel = document.createElement("div");
  	  	    zoomPanel.className = "ces-map-control-zoom-rail";

  	  	    const zoomTitle = document.createElement("div");
  	  	    zoomTitle.className = "ces-map-control-zoom-label";
  	  	    zoomTitle.textContent = "Zoom";

  	  	    const zoomValue = document.createElement("div");
  	  	    zoomValue.className = "ces-map-control-zoom-value";

  	  	    const zoomPlus = document.createElement("button");
  	  	    zoomPlus.type = "button";
  	  	    zoomPlus.className = "ces-map-control-zoom-btn";
  	  	    zoomPlus.textContent = "+";

  	  	    const sliderWrap = document.createElement("div");
  	  	    sliderWrap.className = "ces-map-control-slider-wrap";

  	  	    const zoomSlider = document.createElement("input");
  	  	    zoomSlider.className = "ces-map-control-zoom-slider";
  	  	    zoomSlider.type = "range";
  	  	    zoomSlider.min = "1";
  	  	    zoomSlider.max = "22";
  	  	    zoomSlider.step = "1";

  	  	    const ticks = document.createElement("div");
  	  	    ticks.className = "ces-map-control-ticks";

  	  	    sliderWrap.appendChild(zoomSlider);
  	  	    sliderWrap.appendChild(ticks);

  	  	    const zoomMinus = document.createElement("button");
  	  	    zoomMinus.type = "button";
  	  	    zoomMinus.className = "ces-map-control-zoom-btn";
  	  	    zoomMinus.textContent = "−";

  	  	    zoomPanel.appendChild(zoomTitle);
  	  	    zoomPanel.appendChild(zoomValue);
  	  	    zoomPanel.appendChild(zoomPlus);
  	  	    zoomPanel.appendChild(sliderWrap);
  	  	    zoomPanel.appendChild(zoomMinus);

  	  	    body.appendChild(main);
  	  	    body.appendChild(zoomPanel);

  	  	    shellContent.appendChild(header);
  	  	    shellContent.appendChild(body);
  	  	    control.appendChild(shellContent);

  	  	    ["mousedown",
  	  	      "dblclick",
  	  	      "wheel",
  	  	      "touchstart",
  	  	      "pointerdown"].forEach(evtName => {
  	  	        control.addEventListener(evtName, function (event) {
  	  	          event.stopPropagation();
  	  	        }, {
  	  	          passive: false
  	  	        });
  	  	      });

  	  	    try {
  	  	      const mapDivForMount = map.getDiv();

  	  	      if (mapDivForMount) {
  	  	        mapDivForMount.style.position = mapDivForMount.style.position || "relative";

  	  	        const oldMountedControl = mapDivForMount.querySelector(".trackit-compact-map-control");

  	  	        if (oldMountedControl && oldMountedControl !== control) {
  	  	          oldMountedControl.remove();
  	  	        }

  	  	        control.style.position = "absolute";
  	  	        control.style.right = "0";
  	  	        control.style.bottom = "0";
  	  	        control.style.margin = "0";
  	  	        control.style.zIndex = "999999";
  	  	        control.style.pointerEvents = "auto";

  	  	        mapDivForMount.appendChild(control);
  	  	      } else {
  	  	        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	  	      }
  	  	    } catch (error) {
  	  	      console.warn("[TrackIT Map Controls] Could not mount absolute control. Falling back to Google controls.", error);

  	  	      try {
  	  	        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	  	      } catch (_) {}
  	  	    }

  	  	    map.__trackitUnifiedMapControlReady = true;
  	  	    map.__trackitUnifiedMapControlVersion = CONTROL_VERSION;

  	  	    function sectionLabel(text, icon) {
  	  	      const row = document.createElement("div");
  	  	      row.className = "ces-map-control-section-title";
  	  	      row.innerHTML = `
  	  	      ${icon}
  	  	      <span>${text}</span>
  	  	      `;
  	  	      return row;
  	  	    }

  	  	    function toolButton(label, icon) {
  	  	      const btn = document.createElement("button");
  	  	      btn.type = "button";
  	  	      btn.className = "ces-map-control-tool";
  	  	      btn.innerHTML = `${icon}<span>${label}</span>`;
  	  	      return btn;
  	  	    }

  	  	    function sizeFleetMapControlShell(control, isOpen) {
  	  	      if (!control) return;

  	  	      function setStyle(element, property, value) {
  	  	        try {
  	  	          element.style.setProperty(property, value, "important");
  	  	        } catch (_) {
  	  	          try {
  	  	            element.style[property] = value;
  	  	          } catch (_) {}
  	  	        }
  	  	      }

  	  	      const content = control.querySelector(".ces-bottom-content");

  	  	      const viewportHeight =
  	  	      typeof window !== "undefined" && window.innerHeight
  	  	      ? window.innerHeight: 900;

  	  	      const maxHeight = Math.max(360, viewportHeight - 24);
  	  	      const closedHeight = 56;
  	  	      const closedWidth = 200;
  	  	      const openWidth = 300;

  	  	      if (!isOpen) {
  	  	        setStyle(control, "width", `${closedWidth}px`);
  	  	        setStyle(control, "height", `${closedHeight}px`);
  	  	        setStyle(control, "min-height", `${closedHeight}px`);
  	  	        setStyle(control, "max-height", `${closedHeight}px`);
  	  	        setStyle(control, "overflow", "hidden");
  	  	        setStyle(control, "right", "0");
  	  	        setStyle(control, "bottom", "0");
  	  	        setStyle(control, "top", "auto");
  	  	        setStyle(control, "border-radius", "22px 0 0 0");

  	  	        if (content) {
  	  	          setStyle(content, "max-height", `${closedHeight}px`);
  	  	          setStyle(content, "overflow", "hidden");
  	  	          setStyle(content, "overflow-x", "hidden");
  	  	          setStyle(content, "overflow-y", "hidden");
  	  	        }

  	  	        return;
  	  	      }

  	  	      if (content) {
  	  	        setStyle(content, "max-height", "none");
  	  	        setStyle(content, "overflow", "visible");
  	  	        setStyle(content, "overflow-x", "hidden");
  	  	        setStyle(content, "overflow-y", "visible");
  	  	      }

  	  	      const contentHeight = content ? Math.ceil(content.scrollHeight): 0;
  	  	      const wantedHeight = Math.max(320, contentHeight + 2);
  	  	      const finalHeight = Math.min(wantedHeight, maxHeight);

  	  	      setStyle(control, "width", `${openWidth}px`);
  	  	      setStyle(control, "height", `${finalHeight}px`);
  	  	      setStyle(control, "min-height", `${finalHeight}px`);
  	  	      setStyle(control, "max-height", `${maxHeight}px`);
  	  	      setStyle(control, "overflow", "hidden");
  	  	      setStyle(control, "right", "0");
  	  	      setStyle(control, "bottom", "0");
  	  	      setStyle(control, "top", "auto");
  	  	      setStyle(control, "border-radius", "24px 0 0 0");

  	  	      if (content) {
  	  	        setStyle(content, "max-height", `${finalHeight}px`);
  	  	        setStyle(content, "overflow-x", "hidden");
  	  	        setStyle(content, "overflow-y", wantedHeight > maxHeight ? "auto": "visible");
  	  	      }
  	  	    }

  	  	    function applyMapAppearance() {
  	  	      // Hybrid is satellite imagery plus Google labels.
  	  	      // When Labels are OFF and user chose Hybrid, Satellite is the closest clean version.
  	  	      const effectiveType = (!labelsOn && currentMapType === "hybrid")
  	  	      ? "satellite": currentMapType;

  	  	      try {
  	  	        map.setMapTypeId(effectiveType);
  	  	      } catch (_) {}

  	  	      try {
  	  	        map.setOptions({
  	  	          styles: labelsOn ? null: NO_LABEL_STYLES
  	  	        });
  	  	      } catch (_) {}
  	  	    }

  	  	    function paintMapTypeButtons() {
  	  	      Object.keys(typeButtons).forEach(key => {
  	  	        typeButtons[key].classList.toggle("active", key === currentMapType);
  	  	      });
  	  	    }

  	  	    function updateZoomUi() {
  	  	      const z = map.getZoom() || 1;

  	  	      zoomSlider.value = String(z);
  	  	      zoomValue.textContent = String(z);

  	  	      writeSetting("zoom", z);
  	  	    }

  	  	    function updateHeaderState() {
  	  	      collapseIcon.textContent = collapsed ? "⌄": "⌃";
  	  	      subtitle.textContent = labelsOn ? "Labels On": "Labels Off";
  	  	    }

  	  	    function paintToggleButtons() {
  	  	      trafficBtn.classList.toggle("active", !!trafficOn);
  	  	      labelsBtn.classList.toggle("active", !!labelsOn);
  	  	      paintFullscreenState();
  	  	      updateHeaderState();
  	  	    }

  	  	    // ---------- App Data Geo Location Layer ----------
  	  	    function locNum(v) {
  	  	      return typeof v === "number" ? v: Number(v);
  	  	    }

  	  	    function locGetPath(o, p) {
  	  	      if (!o || !p) return undefined;

  	  	      if (Object.prototype.hasOwnProperty.call(o, p)) {
  	  	        return o[p];
  	  	      }

  	  	      return String(p).split(".").reduce((a, k) => {
  	  	        return a && a[k] !== undefined ? a[k]: undefined;
  	  	      }, o);
  	  	    }

  	  	    function locFirstString(obj, keys) {
  	  	      for (const key of keys) {
  	  	        const v = locGetPath(obj, key);

  	  	        if (typeof v === "string" && v.trim()) {
  	  	          return v.trim();
  	  	        }

  	  	        if (typeof v === "number" && Number.isFinite(v)) {
  	  	          return String(v);
  	  	        }
  	  	      }

  	  	      return "";
  	  	    }

  	  	    function saveCheckedLocationCompanies() {
  	  	      writeSetting("checkedLocationCompanyKeys", checkedLocationCompanyKeys.slice());
  	  	    }

  	  	    function isLocationCompanyChecked(key) {
  	  	      return checkedLocationCompanyKeys.includes(String(key));
  	  	    }

  	  	    function setLocationCompanyChecked(key, checked) {
  	  	      key = String(key);

  	  	      if (checked) {
  	  	        if (!checkedLocationCompanyKeys.includes(key)) {
  	  	          checkedLocationCompanyKeys.push(key);
  	  	        }
  	  	      } else {
  	  	        checkedLocationCompanyKeys = checkedLocationCompanyKeys.filter(k => k !== key);
  	  	      }

  	  	      saveCheckedLocationCompanies();
  	  	    }

  	  	    function getTrackitLocationLayer() {
  	  	      if (!map.__trackitAppLocationLayer) {
  	  	        map.__trackitAppLocationLayer = {
  	  	          companyLayers: {}
  	  	        };
  	  	      }

  	  	      if (!map.__trackitAppLocationLayer.companyLayers) {
  	  	        map.__trackitAppLocationLayer.companyLayers = {};
  	  	      }

  	  	      return map.__trackitAppLocationLayer;
  	  	    }

  	  	    function clearAppLocationLayer(companyKey) {
  	  	      const layer = getTrackitLocationLayer();

  	  	      function clearItems(items) {
  	  	        (items || []).forEach(item => {
  	  	          try {
  	  	            if (item?.setMap) item.setMap(null);
  	  	            else if (item?.remove) item.remove();
  	  	          } catch (_) {}
  	  	        });
  	  	      }

  	  	      if (companyKey) {
  	  	        const key = String(companyKey);
  	  	        const companyLayer = layer.companyLayers[key];

  	  	        if (companyLayer) {
  	  	          clearItems(companyLayer.overlays);
  	  	          clearItems(companyLayer.labels);
  	  	          delete layer.companyLayers[key];
  	  	        }

  	  	        return;
  	  	      }

  	  	      Object.keys(layer.companyLayers).forEach(key => {
  	  	        const companyLayer = layer.companyLayers[key];
  	  	        clearItems(companyLayer.overlays);
  	  	        clearItems(companyLayer.labels);
  	  	      });

  	  	      layer.companyLayers = {};
  	  	    }

  	  	    function normaliseObjectArray(value) {
  	  	      if (!value) return [];

  	  	      if (Array.isArray(value)) {
  	  	        return value.filter(v => v && typeof v === "object");
  	  	      }

  	  	      if (typeof value === "object") {
  	  	        return Object.values(value).filter(v => v && typeof v === "object");
  	  	      }

  	  	      return [];
  	  	    }

  	  	    function getCompanyDisplayName(company, index) {
  	  	      const direct = locFirstString(company, [
  	  	        "Name",
  	  	        "name",
  	  	        "CompanyName",
  	  	        "companyName",
  	  	        "Company",
  	  	        "company",
  	  	        "DisplayName",
  	  	        "displayName",
  	  	        "TradingName",
  	  	        "tradingName",
  	  	        "ClientName",
  	  	        "clientName",
  	  	        "CustomerName",
  	  	        "customerName",
  	  	        "Title",
  	  	        "title"
  	  	      ]);

  	  	      if (direct) return direct;

  	  	      const first = locFirstString(company, ["FirstName", "firstName", "first_name"]);
  	  	      const last = locFirstString(company, ["LastName", "lastName", "last_name"]);
  	  	      const full = [first,
  	  	        last].filter(Boolean).join(" ").trim();

  	  	      return full || `Company ${index + 1}`;
  	  	    }

  	  	    function getCompanyKey(company, name, index) {
  	  	      return String(
  	  	        company?.objectId ||
  	  	        company?.ObjectId ||
  	  	        company?.CompanyId ||
  	  	        company?.companyId ||
  	  	        company?.id ||
  	  	        company?.ID ||
  	  	        company?.FID ||
  	  	        name ||
  	  	        `company-${index}`
  	  	      );
  	  	    }

  	  	    function getLocationName(loc, index) {
  	  	      return locFirstString(loc, [
  	  	        "Name",
  	  	        "name",
  	  	        "LocationName",
  	  	        "locationName",
  	  	        "LocationName.Name",
  	  	        "Location.name",
  	  	        "Location",
  	  	        "location",
  	  	        "FarmName",
  	  	        "farmName",
  	  	        "FieldName",
  	  	        "fieldName",
  	  	        "SiteName",
  	  	        "siteName",
  	  	        "Description",
  	  	        "description",
  	  	        "Title",
  	  	        "title",
  	  	        "label",
  	  	        "Label"
  	  	      ]) || `Location ${index + 1}`;
  	  	    }

  	  	    function readBackendlessArg(name, lowerName, index) {
  	  	      try {
  	  	        if (typeof ___arguments !== "undefined" && ___arguments) {
  	  	          if (___arguments[name] !== undefined) return ___arguments[name];
  	  	          if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	  	          if (___arguments[index] !== undefined) return ___arguments[index];
  	  	        }
  	  	      } catch (_) {}

  	  	      return undefined;
  	  	    }

  	  	    function parseMaybeJson(value) {
  	  	      if (typeof value !== "string") return value;

  	  	      const text = value.trim();
  	  	      if (!text) return value;

  	  	      if (
  	  	        (text.startsWith("[") && text.endsWith("]")) ||
  	  	        (text.startsWith("{") && text.endsWith("}"))
  	  	      ) {
  	  	        try {
  	  	          return JSON.parse(text);
  	  	        } catch (_) {
  	  	          return value;
  	  	        }
  	  	      }

  	  	      return value;
  	  	    }

  	  	    function validLatLng(lat, lng) {
  	  	      return (
  	  	        Number.isFinite(lat) &&
  	  	        Number.isFinite(lng) &&
  	  	        Math.abs(lat) <= 90 &&
  	  	        Math.abs(lng) <= 180
  	  	      );
  	  	    }

  	  	    function pointFromPair(pair, geoJsonOrder) {
  	  	      if (!Array.isArray(pair) || pair.length < 2) return null;

  	  	      const a = locNum(pair[0]);
  	  	      const b = locNum(pair[1]);

  	  	      if (!Number.isFinite(a) || !Number.isFinite(b)) return null;

  	  	      let lat;
  	  	      let lng;

  	  	      if (geoJsonOrder) {
  	  	        lat = b;
  	  	        lng = a;
  	  	      } else if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
  	  	        lat = a;
  	  	        lng = b;
  	  	      } else if (Math.abs(b) <= 90 && Math.abs(a) <= 180) {
  	  	        lat = b;
  	  	        lng = a;
  	  	      } else {
  	  	        return null;
  	  	      }

  	  	      return validLatLng(lat, lng) ? {
  	  	        lat,
  	  	        lng
  	  	      }: null;
  	  	    }

  	  	    function pointFromString(value, geoJsonOrder) {
  	  	      if (typeof value !== "string") return null;

  	  	      const text = value.trim();
  	  	      if (!text) return null;

  	  	      const parsed = parseMaybeJson(text);
  	  	      if (parsed !== value) {
  	  	        return coercePoint(parsed, geoJsonOrder);
  	  	      }

  	  	      const match = text.match(/(-?\d+(?:\.\d+)?)\s*[,; ]\s*(-?\d+(?:\.\d+)?)/);
  	  	      if (!match) return null;

  	  	      return pointFromPair([match[1], match[2]], geoJsonOrder);
  	  	    }

  	  	    function coercePoint(value, geoJsonOrder) {
  	  	      value = parseMaybeJson(value);

  	  	      if (!value) return null;

  	  	      if (Array.isArray(value)) {
  	  	        return pointFromPair(value, geoJsonOrder);
  	  	      }

  	  	      if (typeof value === "string") {
  	  	        return pointFromString(value, geoJsonOrder);
  	  	      }

  	  	      if (typeof value !== "object") return null;

  	  	      const pairs = [
  	  	        ["lat",
  	  	          "lng"],
  	  	        ["lat",
  	  	          "lon"],
  	  	        ["lat",
  	  	          "long"],
  	  	        ["latitude",
  	  	          "longitude"],
  	  	        ["Latitude",
  	  	          "Longitude"],
  	  	        ["LAT",
  	  	          "LNG"],

  	  	        ["_lat",
  	  	          "_lng"],
  	  	        ["_latitude",
  	  	          "_longitude"],

  	  	        ["x",
  	  	          "y"],
  	  	        ["X",
  	  	          "Y"],

  	  	        ["position.latitude",
  	  	          "position.longitude"],
  	  	        ["Position.Latitude",
  	  	          "Position.Longitude"],

  	  	        ["Location.position.latitude",
  	  	          "Location.position.longitude"],
  	  	        ["location.position.latitude",
  	  	          "location.position.longitude"],

  	  	        ["geoPoint.latitude",
  	  	          "geoPoint.longitude"],
  	  	        ["GeoPoint.latitude",
  	  	          "GeoPoint.longitude"],

  	  	        ["Coordinates.latitude",
  	  	          "Coordinates.longitude"],
  	  	        ["coordinates.latitude",
  	  	          "coordinates.longitude"],

  	  	        ["Center.lat",
  	  	          "Center.lng"],
  	  	        ["center.lat",
  	  	          "center.lng"],
  	  	        ["Centre.lat",
  	  	          "Centre.lng"],
  	  	        ["centre.lat",
  	  	          "centre.lng"],

  	  	        ["LocationData.Center.lat",
  	  	          "LocationData.Center.lng"],
  	  	        ["LocationData.center.lat",
  	  	          "LocationData.center.lng"],
  	  	        ["LocationData.Centre.lat",
  	  	          "LocationData.Centre.lng"],
  	  	        ["LocationData.centre.lat",
  	  	          "LocationData.centre.lng"],

  	  	        ["LocationData.Shape.Center.lat",
  	  	          "LocationData.Shape.Center.lng"],
  	  	        ["LocationData.Shape.center.lat",
  	  	          "LocationData.Shape.center.lng"],
  	  	        ["LocationData.Shape.Centre.lat",
  	  	          "LocationData.Shape.Centre.lng"],
  	  	        ["LocationData.Shape.centre.lat",
  	  	          "LocationData.Shape.centre.lng"],

  	  	        ["LocationData.Shape.PivotCenter.lat",
  	  	          "LocationData.Shape.PivotCenter.lng"],
  	  	        ["LocationData.Shape.pivotCenter.lat",
  	  	          "LocationData.Shape.pivotCenter.lng"],

  	  	        ["LocationData.Shape.WedgeCenter.lat",
  	  	          "LocationData.Shape.WedgeCenter.lng"],
  	  	        ["LocationData.Shape.wedgeCenter.lat",
  	  	          "LocationData.Shape.wedgeCenter.lng"],

  	  	        ["LocationData.Shape.EntrancePoint.lat",
  	  	          "LocationData.Shape.EntrancePoint.lng"],
  	  	        ["LocationData.Shape.entrancePoint.lat",
  	  	          "LocationData.Shape.entrancePoint.lng"],

  	  	        ["EntrancePoint.lat",
  	  	          "EntrancePoint.lng"],
  	  	        ["entrancePoint.lat",
  	  	          "entrancePoint.lng"]
  	  	      ];

  	  	      for (const pair of pairs) {
  	  	        let lat = locNum(locGetPath(value, pair[0]));
  	  	        let lng = locNum(locGetPath(value, pair[1]));

  	  	        // x/y is often lng/lat, so reverse it when needed.
  	  	        if ((pair[0] === "x" || pair[0] === "X") && validLatLng(lng, lat)) {
  	  	          return {
  	  	            lat: lng,
  	  	            lng: lat
  	  	          };
  	  	        }

  	  	        if (validLatLng(lat, lng)) {
  	  	          return {
  	  	            lat,
  	  	            lng
  	  	          };
  	  	        }
  	  	      }

  	  	      return null;
  	  	    }

  	  	    function readPointFromObject(obj) {
  	  	      return coercePoint(obj, false);
  	  	    }

  	  	    function collectPointsFromArray(value, output, geoJsonOrder, depth = 0) {
  	  	      if (depth > 8) return;

  	  	      value = parseMaybeJson(value);

  	  	      if (!value) return;

  	  	      const directPoint = coercePoint(value, geoJsonOrder);
  	  	      if (directPoint) {
  	  	        output.push(directPoint);
  	  	        return;
  	  	      }

  	  	      if (typeof value === "string") {
  	  	        const text = value.trim();

  	  	        // Handles simple strings like:
  	  	        // "-29.1,30.1;-29.2,30.2;-29.3,30.3"
  	  	        const pairs = text.match(/-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?/g);

  	  	        if (pairs && pairs.length >= 3) {
  	  	          pairs.forEach(pairText => {
  	  	            const p = pointFromString(pairText, geoJsonOrder);
  	  	            if (p) output.push(p);
  	  	          });
  	  	        }

  	  	        return;
  	  	      }

  	  	      if (Array.isArray(value)) {
  	  	        value.forEach(item => {
  	  	          collectPointsFromArray(item, output, geoJsonOrder, depth + 1);
  	  	        });

  	  	        return;
  	  	      }

  	  	      if (typeof value === "object") {
  	  	        const likelyArrays = [
  	  	          value.points,
  	  	          value.Points,
  	  	          value.path,
  	  	          value.Path,
  	  	          value.paths,
  	  	          value.Paths,
  	  	          value.coordinates,
  	  	          value.Coordinates,
  	  	          value.polygon,
  	  	          value.Polygon,
  	  	          value.boundary,
  	  	          value.Boundary,
  	  	          value.rings,
  	  	          value.Rings,
  	  	          value.plotPoints,
  	  	          value.plotRawPoints,
  	  	          value.plotResolvedPoints,
  	  	          value.PlotPoints,
  	  	          value.PlotRawPoints,
  	  	          value.PlotResolvedPoints
  	  	        ];

  	  	        likelyArrays.forEach(item => {
  	  	          collectPointsFromArray(item, output, geoJsonOrder, depth + 1);
  	  	        });
  	  	      }
  	  	    }

  	  	    function cleanLocationPath(points) {
  	  	      const cleaned = [];
  	  	      const seen = new Set();

  	  	      (points || []).forEach(p => {
  	  	        if (!p || !validLatLng(p.lat, p.lng)) return;

  	  	        const key = `${Number(p.lat).toFixed(7)},${Number(p.lng).toFixed(7)}`;

  	  	        if (seen.has(key)) return;
  	  	        seen.add(key);

  	  	        cleaned.push({
  	  	          lat: Number(p.lat),
  	  	          lng: Number(p.lng)
  	  	        });
  	  	      });

  	  	      return cleaned;
  	  	    }

  	  	    function readPathFromLocation(loc) {
  	  	      if (!loc || typeof loc !== "object") return [];

  	  	      const candidates = [{
  	  	        key: "path",
  	  	        geoJson: false
  	  	      },
  	  	        {
  	  	          key: "Path",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "paths",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Paths",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "points",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Points",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "boundary",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Boundary",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "polygon",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Polygon",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "rings",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Rings",
  	  	          geoJson: false
  	  	        },

  	  	        {
  	  	          key: "Shape.path",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Shape.Path",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Shape.points",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Shape.Points",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Shape.polygon",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Shape.Polygon",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Shape.boundary",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Shape.Boundary",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Shape.rings",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "Shape.Rings",
  	  	          geoJson: false
  	  	        },

  	  	        {
  	  	          key: "shape.path",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "shape.points",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "shape.polygon",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "shape.boundary",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "shape.rings",
  	  	          geoJson: false
  	  	        },

  	  	        {
  	  	          key: "LocationData.Points",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.points",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Path",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.path",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Polygon",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.polygon",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Boundary",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.boundary",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Rings",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.rings",
  	  	          geoJson: false
  	  	        },

  	  	        {
  	  	          key: "LocationData.Shape.Points",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.points",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.Path",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.path",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.Polygon",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.polygon",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.Boundary",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.boundary",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.Rings",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.rings",
  	  	          geoJson: false
  	  	        },

  	  	        {
  	  	          key: "LocationData.Shape.plotPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.plotRawPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.plotResolvedPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.PlotPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.PlotRawPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.PlotResolvedPoints",
  	  	          geoJson: false
  	  	        },

  	  	        {
  	  	          key: "PlotPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "plotPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "PlotRawPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "plotRawPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "PlotResolvedPoints",
  	  	          geoJson: false
  	  	        },
  	  	        {
  	  	          key: "plotResolvedPoints",
  	  	          geoJson: false
  	  	        },

  	  	        {
  	  	          key: "coordinates",
  	  	          geoJson: true
  	  	        },
  	  	        {
  	  	          key: "Coordinates",
  	  	          geoJson: true
  	  	        },
  	  	        {
  	  	          key: "geometry.coordinates",
  	  	          geoJson: true
  	  	        },
  	  	        {
  	  	          key: "Geometry.Coordinates",
  	  	          geoJson: true
  	  	        },
  	  	        {
  	  	          key: "LocationData.geometry.coordinates",
  	  	          geoJson: true
  	  	        },
  	  	        {
  	  	          key: "LocationData.Geometry.Coordinates",
  	  	          geoJson: true
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.coordinates",
  	  	          geoJson: true
  	  	        },
  	  	        {
  	  	          key: "LocationData.Shape.Coordinates",
  	  	          geoJson: true
  	  	        }];

  	  	      for (const candidate of candidates) {
  	  	        const raw = locGetPath(loc, candidate.key);
  	  	        const points = [];

  	  	        collectPointsFromArray(raw, points, candidate.geoJson);

  	  	        const cleaned = cleanLocationPath(points);

  	  	        if (cleaned.length >= 3) {
  	  	          return cleaned;
  	  	        }
  	  	      }

  	  	      return [];
  	  	    }

  	  	    function locationHasGeo(loc) {
  	  	      return !!readPointFromObject(loc) || readPathFromLocation(loc).length >= 3;
  	  	    }

  	  	    function getLocationValueFromTrackit(location) {
  	  	      return (
  	  	        location?.objectId ||
  	  	        location?.ObjectId ||
  	  	        location?.id ||
  	  	        location?.ID ||
  	  	        location?.LocationId ||
  	  	        location?.locationId ||
  	  	        null
  	  	      );
  	  	    }

  	  	    function getLocationChildrenFromTrackit(location) {
  	  	      const arrays = [
  	  	        location?.Children,
  	  	        location?.children,
  	  	        location?.ChildLocations,
  	  	        location?.childLocations,
  	  	        location?.Locations,
  	  	        location?.locations,
  	  	        location?.Fields,
  	  	        location?.fields,
  	  	        location?.Segments,
  	  	        location?.segments,
  	  	        location?.Rings,
  	  	        location?.rings
  	  	      ];

  	  	      const result = [];
  	  	      const seen = new Set();

  	  	      arrays.forEach(list => {
  	  	        if (!Array.isArray(list)) return;

  	  	        list.forEach(child => {
  	  	          if (!child || typeof child !== "object") return;

  	  	          const key = getLocationValueFromTrackit(child) || child;

  	  	          if (seen.has(key)) return;

  	  	          seen.add(key);
  	  	          result.push(child);
  	  	        });
  	  	      });

  	  	      return result;
  	  	    }

  	  	    function flattenLocationsFromTrackit(locations, output = [], seen = new Set()) {
  	  	      if (!Array.isArray(locations)) return output;

  	  	      locations.forEach(location => {
  	  	        if (!location || typeof location !== "object") return;

  	  	        const key =
  	  	        getLocationValueFromTrackit(location) ||
  	  	        getLocationName(location, output.length);

  	  	        if (key && seen.has(key)) return;
  	  	        if (key) seen.add(key);

  	  	        output.push(location);

  	  	        flattenLocationsFromTrackit(
  	  	          getLocationChildrenFromTrackit(location),
  	  	          output,
  	  	          seen
  	  	        );
  	  	      });

  	  	      return output;
  	  	    }

  	  	    function getCompaniesFromTrackitAppData(appData) {
  	  	      const listInput =
  	  	      typeof List !== "undefined"
  	  	      ? List: readBackendlessArg("List",
  	  	        "list",
  	  	        1);

  	  	      if (Array.isArray(listInput) && listInput.length) {
  	  	        return listInput;
  	  	      }

  	  	      const userCompanies =
  	  	      appData?.User?.Companies ||
  	  	      appData?.User?.companies ||
  	  	      appData?.Companies ||
  	  	      appData?.companies ||
  	  	      [];

  	  	      return Array.isArray(userCompanies) ? userCompanies: [];
  	  	    }

  	  	    function getCompanyLocationsFromTrackit(company) {
  	  	      const locations =
  	  	      company?.Locations ||
  	  	      company?.locations ||
  	  	      company?.Location ||
  	  	      company?.location ||
  	  	      company?.PropertyLocations ||
  	  	      company?.propertyLocations ||
  	  	      company?.GeoLocations ||
  	  	      company?.geoLocations ||
  	  	      [];

  	  	      return Array.isArray(locations) ? locations: [];
  	  	    }

  	  	    function getAppLocationCompanies() {
  	  	      const appData = getAppBag();
  	  	      const companies = getCompaniesFromTrackitAppData(appData);

  	  	      const results = [];
  	  	      const seenCompanies = new Set();

  	  	      companies.forEach((company, index) => {
  	  	        if (!company || typeof company !== "object") return;

  	  	        const name = getCompanyDisplayName(company, index);
  	  	        const key = getCompanyKey(company, name, index);

  	  	        if (seenCompanies.has(key)) return;
  	  	        seenCompanies.add(key);

  	  	        const rawLocations = getCompanyLocationsFromTrackit(company);
  	  	        const flattenedLocations = flattenLocationsFromTrackit(rawLocations);

  	  	        const drawableLocations = flattenedLocations.filter(location => {
  	  	          try {
  	  	            return locationHasGeo(location);
  	  	          } catch (_) {
  	  	            return false;
  	  	          }
  	  	        });

  	  	        results.push({
  	  	          key,
  	  	          name,
  	  	          company,
  	  	          locations: drawableLocations,
  	  	          rawLocationCount: flattenedLocations.length
  	  	        });
  	  	      });

  	  	      results.sort((a, b) => {
  	  	        return String(a.name).localeCompare(String(b.name), undefined, {
  	  	          numeric: true,
  	  	          sensitivity: "base"
  	  	        });
  	  	      });

  	  	      console.log("[TrackIT Locations] Companies loaded:",
  	  	        results.map(c => ({
  	  	          name: c.name,
  	  	          key: c.key,
  	  	          drawableLocations: c.locations.length,
  	  	          rawLocations: c.rawLocationCount
  	  	        })));

  	  	      return results;
  	  	    }

  	  	    function getLocationCenter(loc) {
  	  	      const path = readPathFromLocation(loc);

  	  	      if (path.length >= 3) {
  	  	        try {
  	  	          const b = new google.maps.LatLngBounds();
  	  	          path.forEach(p => b.extend(p));
  	  	          const center = b.getCenter();

  	  	          return {
  	  	            lat: center.lat(),
  	  	            lng: center.lng()
  	  	          };
  	  	        } catch (_) {
  	  	          const total = path.reduce((acc, p) => {
  	  	            acc.lat += p.lat;
  	  	            acc.lng += p.lng;
  	  	            return acc;
  	  	          }, {
  	  	            lat: 0, lng: 0
  	  	          });

  	  	          return {
  	  	            lat: total.lat / path.length,
  	  	            lng: total.lng / path.length
  	  	          };
  	  	        }
  	  	      }

  	  	      return readPointFromObject(loc);
  	  	    }

  	  	    function createBlackLocationLabel(position, text) {
  	  	      const overlay = new google.maps.OverlayView();
  	  	      let div = null;

  	  	      overlay.onAdd = function () {
  	  	        div = document.createElement("div");
  	  	        div.className = "trackit-location-label-black";
  	  	        div.textContent = text || "Location";

  	  	        const panes = overlay.getPanes();

  	  	        if (panes?.floatPane) {
  	  	          panes.floatPane.appendChild(div);
  	  	        }
  	  	      };

  	  	      overlay.draw = function () {
  	  	        if (!div) return;

  	  	        const projection = overlay.getProjection();
  	  	        if (!projection) return;

  	  	        const point = projection.fromLatLngToDivPixel(
  	  	          new google.maps.LatLng(position.lat, position.lng)
  	  	        );

  	  	        if (!point) return;

  	  	        div.style.left = `${point.x}px`;
  	  	        div.style.top = `${point.y - 8}px`;
  	  	      };

  	  	      overlay.onRemove = function () {
  	  	        if (div) {
  	  	          div.remove();
  	  	          div = null;
  	  	        }
  	  	      };

  	  	      overlay.setMap(map);

  	  	      return overlay;
  	  	    }

  	  	    function createSmallLocationMarker(position, color) {
  	  	      const markerColor = normaliseLocationColor(color, "#ff8a3c");

  	  	      const svg = `
  	  	      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  	  	      <circle cx="9" cy="9" r="6" fill="rgba(0,0,0,0.88)" stroke="rgba(255,255,255,0.72)" stroke-width="2"/>
  	  	      <circle cx="9" cy="9" r="2.8" fill="${markerColor}"/>
  	  	      </svg>
  	  	      `;

  	  	      return new google.maps.Marker({
  	  	        position,
  	  	        map,
  	  	        clickable: false,
  	  	        zIndex: 20,
  	  	        icon: {
  	  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
  	  	          scaledSize: new google.maps.Size(18, 18),
  	  	          anchor: new google.maps.Point(9, 9)
  	  	        }
  	  	      });
  	  	    }

  	  	    function normaliseLocationColor(value, fallback) {
  	  	      if (value === undefined || value === null) return fallback;

  	  	      if (typeof value === "object") {
  	  	        const nested =
  	  	        value.hex ||
  	  	        value.Hex ||
  	  	        value.color ||
  	  	        value.Color ||
  	  	        value.colour ||
  	  	        value.Colour ||
  	  	        value.value ||
  	  	        value.Value ||
  	  	        value.background ||
  	  	        value.Background ||
  	  	        value.stroke ||
  	  	        value.Stroke ||
  	  	        value.fill ||
  	  	        value.Fill;

  	  	        return normaliseLocationColor(nested, fallback);
  	  	      }

  	  	      const text = String(value).trim();

  	  	      if (!text) return fallback;

  	  	      // Hex, rgb, rgba, hsl, hsla, or named CSS colour.
  	  	      if (
  	  	        /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(text) ||
  	  	        /^rgba?\(/i.test(text) ||
  	  	        /^hsla?\(/i.test(text) ||
  	  	        /^[a-z]+$/i.test(text)
  	  	      ) {
  	  	        return text;
  	  	      }

  	  	      return fallback;
  	  	    }

  	  	    function getLocationColor(loc, company) {
  	  	      const fallback = "#ff8a3c";

  	  	      const locationColorPaths = [
  	  	        "Color",
  	  	        "color",
  	  	        "Colour",
  	  	        "colour",
  	  	        "LocationColor",
  	  	        "locationColor",
  	  	        "LocationColour",
  	  	        "locationColour",
  	  	        "PolygonColor",
  	  	        "polygonColor",
  	  	        "FillColor",
  	  	        "fillColor",
  	  	        "StrokeColor",
  	  	        "strokeColor",
  	  	        "HexColor",
  	  	        "hexColor",
  	  	        "HexColour",
  	  	        "hexColour",

  	  	        "Style.Color",
  	  	        "Style.color",
  	  	        "Style.Colour",
  	  	        "Style.colour",
  	  	        "Style.FillColor",
  	  	        "Style.fillColor",
  	  	        "Style.StrokeColor",
  	  	        "Style.strokeColor",

  	  	        "LocationData.Color",
  	  	        "LocationData.color",
  	  	        "LocationData.Colour",
  	  	        "LocationData.colour",
  	  	        "LocationData.LocationColor",
  	  	        "LocationData.locationColor",
  	  	        "LocationData.FillColor",
  	  	        "LocationData.fillColor",
  	  	        "LocationData.StrokeColor",
  	  	        "LocationData.strokeColor",

  	  	        "LocationData.Style.Color",
  	  	        "LocationData.Style.color",
  	  	        "LocationData.Style.FillColor",
  	  	        "LocationData.Style.fillColor",
  	  	        "LocationData.Style.StrokeColor",
  	  	        "LocationData.Style.strokeColor",

  	  	        "LocationData.Shape.Color",
  	  	        "LocationData.Shape.color",
  	  	        "LocationData.Shape.Colour",
  	  	        "LocationData.Shape.colour",
  	  	        "LocationData.Shape.FillColor",
  	  	        "LocationData.Shape.fillColor",
  	  	        "LocationData.Shape.StrokeColor",
  	  	        "LocationData.Shape.strokeColor",

  	  	        "Shape.Color",
  	  	        "Shape.color",
  	  	        "Shape.Colour",
  	  	        "Shape.colour",
  	  	        "Shape.FillColor",
  	  	        "Shape.fillColor",
  	  	        "Shape.StrokeColor",
  	  	        "Shape.strokeColor"
  	  	      ];

  	  	      for (const path of locationColorPaths) {
  	  	        const color = normaliseLocationColor(locGetPath(loc, path), null);
  	  	        if (color) return color;
  	  	      }

  	  	      const companyColorPaths = [
  	  	        "Color",
  	  	        "color",
  	  	        "Colour",
  	  	        "colour",
  	  	        "CompanyColor",
  	  	        "companyColor",
  	  	        "CompanyColour",
  	  	        "companyColour",
  	  	        "Style.Color",
  	  	        "Style.color"
  	  	      ];

  	  	      for (const path of companyColorPaths) {
  	  	        const color = normaliseLocationColor(locGetPath(company, path), null);
  	  	        if (color) return color;
  	  	      }

  	  	      return fallback;
  	  	    }

  	  	    function getSouthWestPoint(points) {
  	  	      if (!Array.isArray(points) || !points.length) return null;

  	  	      let chosen = null;

  	  	      points.forEach(p => {
  	  	        if (!p || !validLatLng(Number(p.lat), Number(p.lng))) return;

  	  	        const point = {
  	  	          lat: Number(p.lat),
  	  	          lng: Number(p.lng)
  	  	        };

  	  	        if (!chosen) {
  	  	          chosen = point;
  	  	          return;
  	  	        }

  	  	        // South = smaller latitude.
  	  	        // West = smaller longitude.
  	  	        // We choose the point that is most south first, then most west.
  	  	        if (
  	  	          point.lat < chosen.lat ||
  	  	          (point.lat === chosen.lat && point.lng < chosen.lng)
  	  	        ) {
  	  	          chosen = point;
  	  	        }
  	  	      });

  	  	      return chosen;
  	  	    }

  	  	    function drawCompanyLocations(company,
  	  	      fitToLocations) {
  	  	      if (!company) return;

  	  	      const companyKey = String(company.key);

  	  	      clearAppLocationLayer(companyKey);

  	  	      const layer = getTrackitLocationLayer();

  	  	      layer.companyLayers[companyKey] = {
  	  	        overlays: [],
  	  	        labels: []
  	  	      };

  	  	      const companyLayer = layer.companyLayers[companyKey];

  	  	      const bounds = new google.maps.LatLngBounds();
  	  	      let drawn = 0;

  	  	      (company.locations || []).forEach((loc, index) => {
  	  	        const label = getLocationName(loc, index);
  	  	        const path = readPathFromLocation(loc);
  	  	        const center = getLocationCenter(loc);
  	  	        const locationColor = getLocationColor(loc, company);

  	  	        if (!center) {
  	  	          console.warn("[TrackIT Locations] Location skipped, no center:", loc);
  	  	          return;
  	  	        }

  	  	        if (path.length >= 3) {
  	  	          const polygon = new google.maps.Polygon({
  	  	            paths: path,
  	  	            map,
  	  	            clickable: false,
  	  	            zIndex: 10,

  	  	            strokeColor: locationColor,
  	  	            strokeOpacity: 0.95,
  	  	            strokeWeight: 2,
  	  	            fillColor: locationColor,
  	  	            fillOpacity: 0.16
  	  	          });

  	  	          companyLayer.overlays.push(polygon);

  	  	          path.forEach(p => bounds.extend(p));

  	  	          console.log("[TrackIT Locations] Polygon drawn:", {
  	  	            company: company.name,
  	  	            label,
  	  	            points: path.length
  	  	          });

  	  	        } else {
  	  	          const marker = createSmallLocationMarker(center, locationColor);

  	  	          companyLayer.overlays.push(marker);
  	  	          bounds.extend(center);

  	  	          console.log("[TrackIT Locations] Point drawn:", {
  	  	            company: company.name,
  	  	            label,
  	  	            center
  	  	          });
  	  	        }

  	  	        const labelPosition = path.length >= 3
  	  	        ? (getSouthWestPoint(path) || center): center;

  	  	        const labelOverlay = createBlackLocationLabel(labelPosition, label);

  	  	        companyLayer.labels.push(labelOverlay);

  	  	        drawn++;
  	  	      });

  	  	      if (fitToLocations && drawn > 0) {
  	  	        try {
  	  	          if (drawn === 1) {
  	  	            map.panTo(bounds.getCenter());

  	  	            if ((map.getZoom() || 1) < 15) {
  	  	              map.setZoom(15);
  	  	            }
  	  	          } else {
  	  	            map.fitBounds(bounds, {
  	  	              top: 80,
  	  	              right: 80,
  	  	              bottom: 80,
  	  	              left: 80
  	  	            });
  	  	          }
  	  	        } catch (_) {}
  	  	      }

  	  	      if (drawn === 0) {
  	  	        console.warn("[TrackIT Locations] Company checked but no drawable geo found:", company);
  	  	      }
  	  	    }

  	  	    function renderCheckedLocationCompanies(fitToLocations) {
  	  	      const companies = map.__trackitLocationCompanies || [];

  	  	      checkedLocationCompanyKeys.forEach(key => {
  	  	        const company = companies.find(c => String(c.key) === String(key));

  	  	        if (company) {
  	  	          drawCompanyLocations(company, fitToLocations);
  	  	        }
  	  	      });
  	  	    }

  	  	    function renderLocationCompanyList() {
  	  	      const companies = getAppLocationCompanies();

  	  	      map.__trackitLocationCompanies = companies;

  	  	      locationsList.innerHTML = "";

  	  	      if (!companies.length) {
  	  	        const empty = document.createElement("div");
  	  	        empty.className = "trackit-location-empty";
  	  	        empty.textContent = "No companies found";
  	  	        locationsList.appendChild(empty);
  	  	        return;
  	  	      }

  	  	      companies.forEach(company => {
  	  	        const checked = isLocationCompanyChecked(company.key);

  	  	        const row = document.createElement("label");
  	  	        row.className = "trackit-location-company-row";
  	  	        row.classList.toggle("active", checked);

  	  	        const checkbox = document.createElement("input");
  	  	        checkbox.type = "checkbox";
  	  	        checkbox.checked = checked;

  	  	        const tick = document.createElement("span");
  	  	        tick.className = "trackit-location-tick";

  	  	        const name = document.createElement("span");
  	  	        name.className = "trackit-location-company-name";
  	  	        name.textContent = company.name;

  	  	        const count = document.createElement("span");
  	  	        count.className = "trackit-location-company-count";
  	  	        count.textContent = String(company.locations.length);

  	  	        row.appendChild(checkbox);
  	  	        row.appendChild(tick);
  	  	        row.appendChild(name);
  	  	        row.appendChild(count);

  	  	        checkbox.addEventListener("change", function (event) {
  	  	          event.stopPropagation();

  	  	          const nowChecked = !!checkbox.checked;

  	  	          setLocationCompanyChecked(company.key, nowChecked);

  	  	          row.classList.toggle("active", nowChecked);

  	  	          if (nowChecked) {
  	  	            drawCompanyLocations(company, true);
  	  	          } else {
  	  	            clearAppLocationLayer(company.key);
  	  	          }

  	  	          sizeFleetMapControlShell(control, !collapsed);
  	  	        });

  	  	        row.addEventListener("click",
  	  	          function (event) {
  	  	            event.stopPropagation();
  	  	          });

  	  	        locationsList.appendChild(row);
  	  	      });
  	  	    }

  	  	    function paintLocationsUi() {
  	  	      locationsCheckbox.checked = !!locationsOn;
  	  	      locationsList.classList.toggle("visible", !!locationsOn);
  	  	    }

  	  	    function syncLocationLayerFromSettings(fitToLocations) {
  	  	      paintLocationsUi();

  	  	      if (!locationsOn) {
  	  	        clearAppLocationLayer();
  	  	        return;
  	  	      }

  	  	      renderLocationCompanyList();
  	  	      renderCheckedLocationCompanies(fitToLocations);
  	  	    }

  	  	    function isFullscreenActive() {
  	  	      const mapDiv = map.getDiv();
  	  	      const fs = document.fullscreenElement || document.webkitFullscreenElement || null;

  	  	      return !!fs && (fs === mapDiv || fs.contains(mapDiv));
  	  	    }

  	  	    function paintFullscreenState() {
  	  	      fullscreenBtn.classList.toggle("active", isFullscreenActive());
  	  	      fullscreenBtn.classList.toggle("fullscreen-active", isFullscreenActive());
  	  	    }

  	  	    function toggleFullscreen() {
  	  	      const mapDiv = map.getDiv();

  	  	      try {
  	  	        if (!document.fullscreenElement && !document.webkitFullscreenElement) {
  	  	          if (mapDiv.requestFullscreen) mapDiv.requestFullscreen();
  	  	          else if (mapDiv.webkitRequestFullscreen) mapDiv.webkitRequestFullscreen();
  	  	        } else {
  	  	          if (document.exitFullscreen) document.exitFullscreen();
  	  	          else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
  	  	        }
  	  	      } catch (e) {
  	  	        console.warn("[TrackIT Map Controls] Fullscreen failed:", e);
  	  	      }

  	  	      setTimeout(paintFullscreenState, 150);
  	  	    }

  	  	    function applyMapControlCollapsedState(saveSetting) {
  	  	      control.classList.toggle("collapsed", collapsed);
  	  	      updateHeaderState();
  	  	      sizeFleetMapControlShell(control, !collapsed);

  	  	      if (saveSetting) {
  	  	        writeSetting("panelCollapsedV8", collapsed);
  	  	      }
  	  	    }

  	  	    function toggleMapControlPanel(saveSetting = true) {
  	  	      collapsed = !collapsed;
  	  	      applyMapControlCollapsedState(saveSetting);
  	  	    }

  	  	    function closeMapControlPanel(saveSetting = false) {
  	  	      if (collapsed) return;

  	  	      collapsed = true;
  	  	      applyMapControlCollapsedState(saveSetting);
  	  	    }

  	  	    function openMapControlPanel(saveSetting = false) {
  	  	      if (!collapsed) return;

  	  	      collapsed = false;
  	  	      applyMapControlCollapsedState(saveSetting);
  	  	    }

  	  	    /* Optional external hooks if we ever need them elsewhere */
  	  	    map.__trackitCloseMapControlPanel = closeMapControlPanel;
  	  	    map.__trackitOpenMapControlPanel = openMapControlPanel;
  	  	    map.__trackitToggleMapControlPanel = toggleMapControlPanel;

  	  	    header.addEventListener("click", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      toggleMapControlPanel(true);
  	  	    });

  	  	    zoomPlus.addEventListener("click", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      const z = map.getZoom() || 1;
  	  	      map.setZoom(Math.min(22, z + 1));
  	  	    });

  	  	    zoomMinus.addEventListener("click", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      const z = map.getZoom() || 1;
  	  	      map.setZoom(Math.max(1, z - 1));
  	  	    });

  	  	    zoomSlider.addEventListener("input", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      map.setZoom(Number(zoomSlider.value));
  	  	    });

  	  	    trafficBtn.addEventListener("click", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      trafficOn = !trafficOn;
  	  	      map.__trackitTrafficLayer.setMap(trafficOn ? map: null);

  	  	      writeSetting("trafficOn", trafficOn);
  	  	      paintToggleButtons();
  	  	    });

  	  	    labelsBtn.addEventListener("click", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      labelsOn = !labelsOn;

  	  	      writeSetting("labelsOn", labelsOn);
  	  	      applyMapAppearance();
  	  	      paintToggleButtons();
  	  	    });

  	  	    fullscreenBtn.addEventListener("click", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      toggleFullscreen();
  	  	    });

  	  	    directionsBtn.addEventListener("click", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      if (typeof event.stopImmediatePropagation === "function") {
  	  	        event.stopImmediatePropagation();
  	  	      }

  	  	      toggleDirectionsMode();
  	  	      sizeFleetMapControlShell(control, !collapsed);
  	  	    });

  	  	    locationsCheckbox.addEventListener("change",
  	  	      function (event) {
  	  	        event.preventDefault();
  	  	        event.stopPropagation();

  	  	        locationsOn = !!locationsCheckbox.checked;
  	  	        writeSetting("locationsOn", locationsOn);

  	  	        if (!locationsOn) {
  	  	          clearAppLocationLayer();
  	  	        } else {
  	  	          renderLocationCompanyList();
  	  	          renderCheckedLocationCompanies(false);
  	  	        }

  	  	        paintLocationsUi();
  	  	        sizeFleetMapControlShell(control, !collapsed);
  	  	      });

  	  	    map.__trackitMapControlListeners.push(
  	  	      map.addListener("zoom_changed", updateZoomUi)
  	  	    );

  	  	    map.__trackitMapControlListeners.push(
  	  	      map.addListener("maptypeid_changed", function () {
  	  	        paintMapTypeButtons();
  	  	      })
  	  	    );

  	  	    const fullscreenHandler = function () {
  	  	      paintFullscreenState();
  	  	    };

  	  	    document.addEventListener("fullscreenchange",
  	  	      fullscreenHandler);
  	  	    document.addEventListener("webkitfullscreenchange",
  	  	      fullscreenHandler);

  	  	    map.__trackitDomControlListeners.push({
  	  	      target: document,
  	  	      event: "fullscreenchange",
  	  	      handler: fullscreenHandler
  	  	    });

  	  	    map.__trackitDomControlListeners.push({
  	  	      target: document,
  	  	      event: "webkitfullscreenchange",
  	  	      handler: fullscreenHandler
  	  	    });

  	  	    const resizeHandler = function () {
  	  	      sizeFleetMapControlShell(control,
  	  	        !collapsed);
  	  	    };

  	  	    if (typeof window !== "undefined") {
  	  	      window.addEventListener("resize", resizeHandler);
  	  	      map.__trackitDomControlListeners.push({
  	  	        target: window,
  	  	        event: "resize",
  	  	        handler: resizeHandler
  	  	      });
  	  	    }

  	  	    const savedZoom = readSetting("zoom", null);

  	  	    if (savedZoom !== null && savedZoom !== undefined) {
  	  	      try {
  	  	        map.setZoom(Number(savedZoom));
  	  	      } catch (_) {}
  	  	    }

  	  	    applyMapAppearance();
  	  	    updateZoomUi();
  	  	    updateHeaderState();
  	  	    sizeFleetMapControlShell(control, !collapsed);
  	  	    paintMapTypeButtons();
  	  	    paintToggleButtons();
  	  	    paintDirectionsButton();
  	  	    syncLocationLayerFromSettings(false);
  	  	    sizeFleetMapControlShell(control, !collapsed);

  	  	    function svgBase(paths) {
  	  	      return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
  	  	    }

  	  	    function iconLayers() {
  	  	      return svgBase(`
  	  	        <path d="M12 3 3 8l9 5 9-5-9-5Z"/>
  	  	        <path d="M3 12l9 5 9-5"/>
  	  	        <path d="M3 16l9 5 9-5"/>
  	  	        `);
  	  	    }

  	  	    function iconRoadmap() {
  	  	      return svgBase(`
  	  	        <path d="M4 18V6l5-2 6 2 5-2v12l-5 2-6-2-5 2Z"/>
  	  	        <path d="M9 4v12"/>
  	  	        <path d="M15 6v12"/>
  	  	        <path d="M12 9h.01"/>
  	  	        <path d="M17 11h.01"/>
  	  	        `);
  	  	    }

  	  	    function iconSatellite() {
  	  	      return svgBase(`
  	  	        <path d="m6 14 4 4"/>
  	  	        <path d="m14 6 4 4"/>
  	  	        <path d="m8 16 8-8"/>
  	  	        <rect x="12" y="3" width="7" height="5" rx="1" transform="rotate(45 12 3)"/>
  	  	        <rect x="4" y="13" width="7" height="5" rx="1" transform="rotate(45 4 13)"/>
  	  	        <path d="M17 17c1.5-1.5 2-3.5 1.2-5.2"/>
  	  	        <path d="M20 20c2.5-2.5 3-6 1.4-8.8"/>
  	  	        `);
  	  	    }

  	  	    function iconTerrain() {
  	  	      return svgBase(`
  	  	        <path d="m3 18 6-10 4 6 3-5 5 9H3Z"/>
  	  	        <path d="m8.5 12 2 2"/>
  	  	        <path d="m15.5 13 2 2"/>
  	  	        `);
  	  	    }

  	  	    function iconDirections() {
  	  	      return svgBase(`
  	  	        <path d="M6 19V6.5A2.5 2.5 0 0 1 8.5 4H17"/>
  	  	        <path d="M14 1l3 3-3 3"/>
  	  	        <path d="M6 19l-3-3"/>
  	  	        <path d="M6 19l3-3"/>
  	  	        <path d="M10 10h4a3 3 0 0 1 3 3v5"/>
  	  	        `);
  	  	    }

  	  	    function iconTraffic() {
  	  	      return svgBase(`
  	  	        <path d="M6 16h12"/>
  	  	        <path d="M7 16v3"/>
  	  	        <path d="M17 16v3"/>
  	  	        <path d="M7 13l1.5-5h7L17 13"/>
  	  	        <path d="M8 13h8"/>
  	  	        <circle cx="8.5" cy="16" r="1"/>
  	  	        <circle cx="15.5" cy="16" r="1"/>
  	  	        `);
  	  	    }

  	  	    function iconLocation() {
  	  	      return svgBase(`
  	  	        <path d="M12 21s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12Z"/>
  	  	        <circle cx="12" cy="9" r="2.4"/>
  	  	        `);
  	  	    }

  	  	    function iconFullscreen() {
  	  	      return svgBase(`
  	  	        <path d="M8 3H3v5"/>
  	  	        <path d="M16 3h5v5"/>
  	  	        <path d="M8 21H3v-5"/>
  	  	        <path d="M16 21h5v-5"/>
  	  	        `);
  	  	    }

  	  	    function iconLabel() {
  	  	      return svgBase(`
  	  	        <path d="M5 5h14v14H5z"/>
  	  	        <path d="M8 9h8"/>
  	  	        <path d="M8 12h6"/>
  	  	        <path d="M8 15h4"/>
  	  	        `);
  	  	    }
  	  	  }
  	  	  // ---------- FineTrack opener ----------
  	  	  window.__fineTrackComponent = fineTrack || null;

  	  	  window.__bl_open_fineTrack = async function () {
  	  	    try {
  	  	      const c = window.__fineTrackComponent;

  	  	      if (!c) return;

  	  	      const alreadyOpen = (!!c.display) || (!!c.isOpen);

  	  	      if (alreadyOpen) {
  	  	        if ("display" in c) c.display = false;
  	  	        if ("controlVisibility" in c) c.controlVisibility = false;
  	  	        if ("isOpen" in c) c.isOpen = false;

  	  	        if (typeof c.close === "function") {
  	  	          try {
  	  	            c.close();
  	  	          } catch (_) {}
  	  	        }

  	  	        await new Promise(r => setTimeout(r, 0));
  	  	      }

  	  	      if ("display" in c) c.display = true;
  	  	      if ("controlVisibility" in c) c.controlVisibility = true;
  	  	      if ("isOpen" in c) c.isOpen = true;

  	  	      if (typeof c.open === "function") {
  	  	        c.open();
  	  	      }

  	  	    } catch (e) {
  	  	      console.error("FineTrack open failed:", e);
  	  	    }
  	  	  };

  	  	  // ---------- popup -> set selected + open panel ----------
  	  	  window.__truckFineTrackClick = function (id) {
  	  	    try {
  	  	      const m = window.__truckFollow_map;
  	  	      const pin = m?.__truckPins?.[id];
  	  	      const t = pin?.tractor;

  	  	      if (!t) return;

  	  	      window.SelectedTractor = t;
  	  	      setSelectedInApp(t);
  	  	      window.__bl_open_fineTrack();

  	  	    } catch (e) {
  	  	      console.error("FineTrack click failed:", e);
  	  	    }
  	  	  };

  	  	  // ---------- map guard ----------
  	  	  if (!googleMapComponent?.map?.map || !(googleMapComponent.map.map instanceof google.maps.Map)) {
  	  	    console.error("Invalid Google Map component.");
  	  	    return;
  	  	  }

  	  	  const map = googleMapComponent.map.map;

  	  	  // Hard safety: disable Google POI/place popups even if controls are not rebuilt.
  	  	  try {
  	  	    map.setOptions({
  	  	      clickableIcons: true,
  	  	      streetViewControl: false
  	  	    });

  	  	    const panorama = map.getStreetView();
  	  	    panorama.setVisible(false);
  	  	  } catch (_) {}

  	  	  injectGoogleInfoWindowPaddingCss();
  	  	  addTrackitUnifiedMapControl(map);

  	  	  // ---------- follow state / toggles ----------
  	  	  if (!map.__follow) {
  	  	    map.__follow = {
  	  	      enabled: false,
  	  	      id: null
  	  	    };
  	  	  }

  	  	  window.__truckFollow_map = map;

  	  	  function setFollowOn(id) {
  	  	    const s = map.__truckPins && map.__truckPins[id];

  	  	    map.__follow.enabled = true;
  	  	    map.__follow.id = id;

  	  	    if (s?.marker) {
  	  	      const pos = s.marker.getPosition();

  	  	      map.panTo(pos);

  	  	      // When a truck icon is clicked / followed, zoom into vehicle level.
  	  	      try {
  	  	        if (map.getZoom() !== 18) {
  	  	          map.setZoom(18);
  	  	        }
  	  	      } catch (_) {}
  	  	    }

  	  	    if (map.__truckInfoWindow?.__currentTractor) {
  	  	      map.__truckInfoWindow.setContent(buildInfoHtml(map.__truckInfoWindow.__currentTractor));
  	  	    }
  	  	  }

  	  	  function toggleFollow(id) {
  	  	    const wasOn = map.__follow.enabled && map.__follow.id === id;

  	  	    if (wasOn) {
  	  	      map.__follow.enabled = false;
  	  	      map.__follow.id = null;
  	  	    } else {
  	  	      setFollowOn(id);
  	  	    }

  	  	    if (map.__truckInfoWindow?.__currentTractor) {
  	  	      map.__truckInfoWindow.setContent(buildInfoHtml(map.__truckInfoWindow.__currentTractor));
  	  	    }
  	  	  }

  	  	  window.__truckFollowToggle = toggleFollow;

  	  	  function refreshIfCurrent(id) {
  	  	    const iw = map.__truckInfoWindow;

  	  	    if (!iw || !iw.getMap()) return;
  	  	    if (iw.__currentId !== id) return;

  	  	    const t = store[id]?.tractor;

  	  	    if (!t) return;

  	  	    iw.setContent(buildInfoHtml(t));
  	  	  }

  	  	  // ---------- visuals config ----------
  	  	  const CFG = {
  	  	    W: 176,
  	  	    H: 176,
  	  	    CX: 88,
  	  	    CY: 88,
  	  	    OUTER_R: 44,
  	  	    DOT_R: 18,
  	  	    PTR_LEN: 40,
  	  	    PTR_HALF: 24,
  	  	    SCALE: 0.30,
  	  	    HEADING_OFFSET: 0,
  	  	    MOVING_SPEED_KMH: 2,

  	  	    COLORS: {
  	  	      truckFallback: "#18a058",
  	  	      status: {
  	  	        moving: "#18a058",
  	  	        stopped: "#7a7a7a",
  	  	        warn: "#ee4b2b"
  	  	      },
  	  	      pulse: {
  	  	        moving: "#18a058",
  	  	        warn: "#ee4b2b"
  	  	      },
  	  	      stroke: "#101010",
  	  	      innerRim: "rgba(255,255,255,0.35)",
  	  	      outline: "#ffffff"
  	  	    },

  	  	    OUTLINE_W: 6,

  	  	    PULSE: {
  	  	      moving: {
  	  	        periodMs: 950,
  	  	        minScale: 1.0,
  	  	        maxScale: 3.00,
  	  	        minOpacity: 0.40,
  	  	        maxOpacity: 0.60
  	  	      },
  	  	      warning: {
  	  	        periodMs: 950,
  	  	        minScale: 1.0,
  	  	        maxScale: 3.00,
  	  	        minOpacity: 0.60,
  	  	        maxOpacity: 0.90
  	  	      }
  	  	    },

  	  	    DEBUG: false
  	  	  };

  	  	  const WARN_COL = {
  	  	    speed: "#CC6633",
  	  	    rpm: "#7B08CD",
  	  	    temp: "#947F00"
  	  	  };

  	  	  // ---------- stores / infoWindow ----------
  	  	  if (!map.__truckPins) {
  	  	    map.__truckPins = {};
  	  	  }

  	  	  const store = map.__truckPins;

  	  	  function resetFleetMapView() {
  	  	    try {
  	  	      const bounds = new google.maps.LatLngBounds();
  	  	      let count = 0;

  	  	      Object.keys(store || {}).forEach(id => {
  	  	        const marker = store[id]?.marker;
  	  	        if (!marker || !marker.getPosition) return;

  	  	        const pos = marker.getPosition();
  	  	        if (!pos) return;

  	  	        bounds.extend(pos);
  	  	        count++;
  	  	      });

  	  	      if (count === 0) return;

  	  	      // Turn follow off so the next refresh does not immediately pan back to the closed truck.
  	  	      if (map.__follow) {
  	  	        map.__follow.enabled = false;
  	  	        map.__follow.id = null;
  	  	      }

  	  	      if (count === 1) {
  	  	        map.setCenter(bounds.getCenter());

  	  	        // Single-vehicle fallback. Change 14 if you want a different reset zoom.
  	  	        map.setZoom(14);
  	  	        return;
  	  	      }

  	  	      map.fitBounds(bounds, {
  	  	        top: 80,
  	  	        right: 80,
  	  	        bottom: 80,
  	  	        left: 80
  	  	      });

  	  	      // Prevent reset from staying too close if all vehicles are near each other.
  	  	      google.maps.event.addListenerOnce(map, "idle", function () {
  	  	        try {
  	  	          if (map.getZoom() > 14) {
  	  	            map.setZoom(14);
  	  	          }
  	  	        } catch (_) {}
  	  	      });

  	  	    } catch (e) {
  	  	      console.warn("[TrackIT] Fleet map reset failed:",
  	  	        e);
  	  	    }
  	  	  }

  	  	  if (!map.__truckInfoWindow) {
  	  	    map.__truckInfoWindow = new google.maps.InfoWindow({});
  	  	  }

  	  	  if (!map.__popupCloseBound) {
  	  	    map.__popupCloseBound = true;

  	  	    google.maps.event.addListener(map.__truckInfoWindow, "closeclick", () => {
  	  	      writeSelectedTractorMarkerId(null);

  	  	      map.__truckInfoWindow.__currentId = null;
  	  	      map.__truckInfoWindow.__currentTractor = null;

  	  	      if (map.__follow) {
  	  	        map.__follow.enabled = false;
  	  	        map.__follow.id = null;
  	  	      }

  	  	      // IMPORTANT:
  	  	      // Do NOT reset, fitBounds, setCenter, panTo, or setZoom here.
  	  	      // Closing the popup must keep the current map center and zoom exactly as-is.
  	  	    });
  	  	  }

  	  	  // ---------- utils ----------
  	  	  const num = (v) => {
  	  	    return typeof v === "number" ? v: Number(v);
  	  	  };

  	  	  const bool = (v) => {
  	  	    return (
  	  	      v === true ||
  	  	      v === 1 ||
  	  	      (
  	  	        typeof v === "string" &&
  	  	        ["true", "1", "yes", "y", "on"].includes(v.toLowerCase())
  	  	      )
  	  	    );
  	  	  };

  	  	  const getPath = (o,
  	  	    p) => {
  	  	    if (!o || !p) return undefined;

  	  	    if (Object.prototype.hasOwnProperty.call(o, p)) {
  	  	      return o[p];
  	  	    }

  	  	    return p.split(".").reduce((a, k) => {
  	  	      return (a && a[k] !== undefined) ? a[k]: undefined;
  	  	    }, o);
  	  	  };

  	  	  const fmtNum = (v, d = 1) => {
  	  	    return Number.isFinite(+v)
  	  	    ? (+v)
  	  	    .toFixed(d)
  	  	    .replace(/\.0+$/, "")
  	  	    .replace(/(\.\d*[1-9])0+$/, "$1"): "–";
  	  	  };

  	  	  const degToCompass = (deg) => {
  	  	    return ["N",
  	  	      "NNE",
  	  	      "NE",
  	  	      "ENE",
  	  	      "E",
  	  	      "ESE",
  	  	      "SE",
  	  	      "SSE",
  	  	      "S",
  	  	      "SSW",
  	  	      "SW",
  	  	      "WSW",
  	  	      "W",
  	  	      "WNW",
  	  	      "NW",
  	  	      "NNW"][
  	  	      Math.floor(((+deg || 0) + 11.25) / 22.5) % 16
  	  	    ];
  	  	  };

  	  	  function safeJsString(value) {
  	  	    return String(value ?? "")
  	  	    .replace(/\\/g, "\\\\")
  	  	    .replace(/'/g, "\\'")
  	  	    .replace(/\r/g, "")
  	  	    .replace(/\n/g, "\\n");
  	  	  }

  	  	  function overLimitRowMeta( {
  	  	    spd, rpm, tmp, limSpd, limRpm, limTmp
  	  	  }) {
  	  	    return {
  	  	      speedColor: (Number.isFinite(spd) && Number.isFinite(limSpd) && spd > limSpd) ? WARN_COL.speed: "",
  	  	      rpmColor: (Number.isFinite(rpm) && Number.isFinite(limRpm) && rpm > limRpm) ? WARN_COL.rpm: "",
  	  	      tempColor: (Number.isFinite(tmp) && Number.isFinite(limTmp) && tmp > limTmp) ? WARN_COL.temp: ""
  	  	    };
  	  	  }

  	  	  function collectWarnings(T) {
  	  	    const L = T?.Location || {};
  	  	    const Lim = T?.CAN || {};

  	  	    const spd = num(L["position.speed"]);
  	  	    const rpm = num(L["can.engine.rpm"]);
  	  	    const tmp = num(L["can.engine.temperature"]);

  	  	    const limSpd = num(Lim?.Speed);
  	  	    const limRpm = num(Lim?.RPM);
  	  	    const limTmp = num(Lim?.Temp);

  	  	    const rows = [];

  	  	    if (Number.isFinite(spd) && Number.isFinite(limSpd) && spd > limSpd) rows.push("spd");
  	  	    if (Number.isFinite(rpm) && Number.isFinite(limRpm) && rpm > limRpm) rows.push("rpm");
  	  	    if (Number.isFinite(tmp) && Number.isFinite(limTmp) && tmp > limTmp) rows.push("tmp");

  	  	    return rows;
  	  	  }

  	  	  function buildInfoHtml(T) {
  	  	    const L = T?.Location || {};
  	  	    const Lim = T?.CAN || {};
  	  	    const ViewC = T?.ViewC || T?.viewC || {};
  	  	    const D1 = ViewC?.Driver1 || ViewC?.driver1 || null;

  	  	    const ident = (T.FID || T.ID || T.Registration || T.Tracker || "Unit");
  	  	    const reg = T.Registration || L.Registration || "—";
  	  	    const fleet = T.FID || T.ID || "—";

  	  	    const driver =
  	  	    (
  	  	      D1 &&
  	  	      (
  	  	        D1.name ||
  	  	        [D1.first_name || D1.firstName, D1.last_name || D1.lastName].filter(Boolean).join(" ") ||
  	  	        D1.username
  	  	      )
  	  	    ) || "—";

  	  	    const phone =
  	  	    D1?.Data_Details?.employee_details?.contact_details?.phone_number ||
  	  	    D1?.mobile ||
  	  	    D1?.phone ||
  	  	    D1?.tel ||
  	  	    "—";

  	  	    const speed = getPath(L, "position.speed");
  	  	    const rpm = getPath(L, "can.engine.rpm");
  	  	    const temp = getPath(L, "can.engine.temperature");
  	  	    const alt = getPath(L, "position.altitude");
  	  	    const dir = getPath(L, "position.direction");

  	  	    const {
  	  	      speedColor,
  	  	      rpmColor,
  	  	      tempColor
  	  	    } = overLimitRowMeta({
  	  	        spd: num(speed),
  	  	        rpm: num(rpm),
  	  	        tmp: num(temp),
  	  	        limSpd: num(Lim?.Speed),
  	  	        limRpm: num(Lim?.RPM),
  	  	        limTmp: num(Lim?.Temp)
  	  	      });

  	  	    const id = getId(T);
  	  	    const safeId = safeJsString(id);
  	  	    const following = map.__follow?.enabled && map.__follow.id === id;

  	  	    const rows = [{
  	  	      k: "Fleet ID",
  	  	      v: fleet
  	  	    },
  	  	      {
  	  	        k: "Registration",
  	  	        v: reg
  	  	      },
  	  	      {
  	  	        k: "Driver",
  	  	        v: driver
  	  	      },
  	  	      {
  	  	        k: "Driver Mobile",
  	  	        v: phone
  	  	      },
  	  	      {
  	  	        k: "Engine Temp.",
  	  	        v: `${fmtNum(temp)} °C`,
  	  	        style: tempColor
  	  	      },
  	  	      {
  	  	        k: "Speed",
  	  	        v: `${fmtNum(speed)} km/h${Number.isFinite(num(Lim?.Speed)) ? `  (limit ${fmtNum(Lim.Speed)})`: ""}`,
  	  	        style: speedColor
  	  	      },
  	  	      {
  	  	        k: "RPM",
  	  	        v: `${fmtNum(rpm, 0)} RPM${Number.isFinite(num(Lim?.RPM)) ? `  (limit ${fmtNum(Lim.RPM, 0)})`: ""}`,
  	  	        style: rpmColor
  	  	      },
  	  	      {
  	  	        k: "Altitude",
  	  	        v: `${fmtNum(alt, 0)} m`
  	  	      },
  	  	      {
  	  	        k: "Direction",
  	  	        v: degToCompass(num(dir))
  	  	      }];

  	  	    return `
  	  	    <div style="position:relative;font:500 13px/1.4 system-ui,-apple-system,Segoe UI,Roboto,Arial;min-width:290px;max-width:360px;color:#fff;padding:8px 10px 14px 10px;box-sizing:border-box;">

  	  	    <!-- Line 1: Google X only. Do not put anything else here. -->
  	  	    <div style="height:10px;"></div>

  	  	    <!-- Line 2: FineTrack icon + reg on left, small Following button on right -->
  	  	    <div style="height:28px;display:flex;align-items:center;justify-content:space-between;gap:10px;box-sizing:border-box;padding:0 2px;">

  	  	    <div
  	  	    onclick="window.__truckFineTrackClick('${safeId}')"
  	  	    title="Open Fine Track"
  	  	    style="display:flex;align-items:center;gap:8px;cursor:pointer;min-width:0;flex:1 1 auto;"
  	  	    >
  	  	    <span style="display:inline-flex;align-items:center;justify-content:center;width:20px;height:22px;flex:0 0 22px;">
  	  	    <svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true" style="pointer-events:none;display:block;">
  	  	    <path d="M5 8c0-2 1-3.8 2.6-4.9" stroke="#cc6633" stroke-width="4" fill="none" stroke-linecap="round"/>
  	  	    <path d="M2.5 8c0-3.3 1.7-6.2 4.4-7.8" stroke="#cc6633" stroke-width="4" fill="none" stroke-linecap="round" opacity="0.7"/>
  	  	    <path d="M19 8c0-2-1-3.8-2.6-4.9" stroke="#cc6633" stroke-width="4" fill="none" stroke-linecap="round"/>
  	  	    <path d="M21.5 8c0-3.3-1.7-6.2 4.4-7.8" stroke="#cc6633" stroke-width="4" fill="none" stroke-linecap="round" opacity="0.7"/>
  	  	    <path d="M12 2c3.31 0 6 2.69 6 6c0 4.97-6 12-6 12S6 12.97 6 8c0-3.31 2.69-6 6-6z" stroke="#cc6633" stroke-width="4" fill="none" stroke-linejoin="round"/>
  	  	    <circle cx="12" cy="8" r="2" fill="#cc6633"/>
  	  	    </svg>
  	  	    </span>

  	  	    <span style="font-weight:950;font-size:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-shadow:0 1px 3px rgba(0,0,0,0.78);">
  	  	    ${String(ident)}
  	  	    </span>
  	  	    </div>

  	  	    <button
  	  	    onclick="window.__truckFollowToggle('${safeId}')"
  	  	    style="height:20px;flex:0 0 auto;border:1px solid rgba(255,255,255,0.38);background:${following ? "#2fa85b": "rgba(255,255,255,0.08)"};color:#fff;padding:0 6px;border-radius:5px;font-size:10px;font-weight:850;line-height:18px;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,0.28);"
  	  	    >
  	  	    ${following ? "Following": "Follow"}
  	  	    </button>

  	  	    </div>

  	  	    <div style="height:8px;"></div>

  	  	    <div>
  	  	    ${rows.map(r => `
  	  	      <div style="display:grid;grid-template-columns:130px 1fr;align-items:center;gap:12px;padding:4px 8px;margin:2px 0;border-radius:4px;${r.style ? `background:${r.style};`: ""}">
  	  	      <div style="opacity:0.82;font-weight:700;white-space:nowrap;text-shadow:0 1px 2px rgba(0,0,0,0.55);">${r.k}</div>
  	  	      <div style="font-weight:850;text-align:right;white-space:nowrap;text-shadow:0 1px 2px rgba(0,0,0,0.65);">${r.v}</div>
  	  	      </div>
  	  	      `).join("")}
  	  	    </div>

  	  	    <div style="height:12px;"></div>
  	  	    </div>
  	  	    `;
  	  	  }

  	  	  // ---------- position / identity ----------
  	  	  const getLatLng = (it) => {
  	  	    if (Number.isFinite(it?.lat) && Number.isFinite(it?.lng)) {
  	  	      return {
  	  	        lat: num(it.lat),
  	  	        lng: num(it.lng)
  	  	      };
  	  	    }

  	  	    const L = it?.Location || it?.Tractor?.Location;
  	  	    const lat = num(getPath(L, "position.latitude"));
  	  	    const lng = num(getPath(L, "position.longitude"));

  	  	    return (Number.isFinite(lat) && Number.isFinite(lng))
  	  	    ? {
  	  	      lat,
  	  	      lng
  	  	    }: {
  	  	      lat: NaN,
  	  	      lng: NaN
  	  	    };
  	  	  };

  	  	  const getId = (o) => {
  	  	    const t = o?.Tractor || o;

  	  	    return (
  	  	      t?.FID ||
  	  	      t?.ID ||
  	  	      t?.Registration ||
  	  	      t?.Tracker ||
  	  	      t?.Location?.ident ||
  	  	      null
  	  	    );
  	  	  };

  	  	  const getObjectId = (o) => {
  	  	    return (
  	  	      o?.Tractor?.objectId ||
  	  	      o?.objectId ||
  	  	      o?.Location?.objectId ||
  	  	      null
  	  	    );
  	  	  };

  	  	  const isMoving = (t) => {
  	  	    const L = t?.Location || t?.Tractor?.Location || t || {};
  	  	    const spd = num(getPath(L, "position.speed"));

  	  	    if (Number.isFinite(spd)) {
  	  	      return spd > CFG.MOVING_SPEED_KMH;
  	  	    }

  	  	    const canSpd = num(t?.CAN?.Speed ?? t?.Tractor?.CAN?.Speed ?? t?.["can.vehicle.speed"]);

  	  	    if (Number.isFinite(canSpd)) {
  	  	      return canSpd > CFG.MOVING_SPEED_KMH;
  	  	    }

  	  	    return bool(getPath(L, "movement.status")) === true;
  	  	  };

  	  	  const hasWarning = (t) => {
  	  	    return collectWarnings(t).length > 0;
  	  	  };

  	  	  // ---------- badge svgs ----------
  	  	  function svgBadge(o) {
  	  	    const W = CFG.W;
  	  	    const H = CFG.H;
  	  	    const CX = CFG.CX;
  	  	    const CY = CFG.CY;
  	  	    const R = CFG.OUTER_R;
  	  	    const DR = CFG.DOT_R;
  	  	    const PH = CFG.PTR_HALF;
  	  	    const PL = CFG.PTR_LEN;
  	  	    const ang = (+o.headingDeg || 0) + CFG.HEADING_OFFSET;

  	  	    const tipY = CY - R - PL;
  	  	    const baseY = CY - R + 2;

  	  	    return `
  	  	    <svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}">
  	  	    <circle cx="${CX}" cy="${CY}" r="${R}" fill="none" stroke="${CFG.COLORS.outline}" stroke-width="${CFG.OUTLINE_W}"/>

  	  	    <g transform="rotate(${ang}, ${CX}, ${CY})">
  	  	    <path d="M ${CX},${tipY} L ${CX - PH},${baseY} L ${CX + PH},${baseY} Z"
  	  	    fill="none"
  	  	    stroke="${CFG.COLORS.outline}"
  	  	    stroke-width="${CFG.OUTLINE_W}"/>
  	  	    </g>

  	  	    <circle cx="${CX}" cy="${CY}" r="${R}"
  	  	    fill="${o.truckColor}"
  	  	    stroke="${CFG.COLORS.stroke}"
  	  	    stroke-width="2"/>

  	  	    <circle cx="${CX}" cy="${CY}" r="${DR}"
  	  	    fill="${o.statusColor}"
  	  	    stroke="${CFG.COLORS.outline}"
  	  	    stroke-width="2"/>

  	  	    <circle cx="${CX}" cy="${CY}" r="${DR - 3}"
  	  	    fill="none"
  	  	    stroke="${CFG.COLORS.innerRim}"
  	  	    stroke-width="2"/>

  	  	    <g transform="rotate(${ang}, ${CX}, ${CY})">
  	  	    <path d="M ${CX},${tipY} L ${CX - PH},${baseY} L ${CX + PH},${baseY} Z"
  	  	    fill="${o.truckColor}"
  	  	    stroke="${CFG.COLORS.stroke}"
  	  	    width="2"/>
  	  	    </g>
  	  	    </svg>
  	  	    `;
  	  	  }

  	  	  function svgPulse(color) {
  	  	    const R = CFG.OUTER_R + 2;

  	  	    return `
  	  	    <svg xmlns="http://www.w3.org/2000/svg" width="${CFG.W}" height="${CFG.H}" viewBox="0 0 ${CFG.W} ${CFG.H}">
  	  	    <circle cx="${CFG.CX}" cy="${CFG.CY}" r="${R}" fill="none" stroke="${color}" stroke-width="12"/>
  	  	    </svg>
  	  	    `;
  	  	  }

  	  	  // ---------- render / update ----------
  	  	  const seen = new Set();
  	  	  const validPoints = [];

  	  	  (items || []).forEach((raw = {}) => {
  	  	    const T = raw?.Location || raw?.CAN || raw?.FID ? raw: (raw?.Tractor || raw);
  	  	    const {
  	  	      lat, lng
  	  	    } = getLatLng(raw);

  	  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

  	  	    validPoints.push({
  	  	      lat, lng
  	  	    });

  	  	    const id = getId(T);

  	  	    if (!id) return;

  	  	    seen.add(id);

  	  	    const moving = isMoving(T);
  	  	    const warning = hasWarning(T);

  	  	    const statusColor = warning
  	  	    ? CFG.COLORS.status.warn: moving
  	  	    ? CFG.COLORS.status.moving: CFG.COLORS.status.stopped;

  	  	    const truckColor = T.color || CFG.COLORS.truckFallback;
  	  	    const headingDeg = num(getPath((T.Location || {}), "position.direction")) || 0;

  	  	    const scaledW = Math.round(CFG.W * CFG.SCALE);
  	  	    const scaledH = Math.round(CFG.H * CFG.SCALE);

  	  	    const anchorX = Math.round(scaledW * (CFG.CX / CFG.W));
  	  	    const anchorY = Math.round(scaledH * (CFG.CY / CFG.H));

  	  	    const icon = {
  	  	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgBadge({
  	  	        truckColor, statusColor, headingDeg
  	  	      }))}`,
  	  	      scaledSize: new google.maps.Size(scaledW, scaledH),
  	  	      anchor: new google.maps.Point(anchorX, anchorY)
  	  	    };

  	  	    if (store[id]?.marker) {
  	  	      const m = store[id].marker;

  	  	      m.setPosition({
  	  	        lat, lng
  	  	      });

  	  	      if (m.getIcon()?.url !== icon.url) {
  	  	        m.setIcon(icon);
  	  	      }

  	  	      m.setTitle(`${T.FID ?? T.ID ?? "Unit"}${warning ? " • WARNING": moving ? " • moving": " • stopped"}`);

  	  	      store[id].tractor = T;
  	  	      store[id].objectId = getObjectId(T);

  	  	      refreshIfCurrent(id);

  	  	    } else {
  	  	      store[id] = store[id] || {};
  	  	      store[id].tractor = T;
  	  	      store[id].objectId = getObjectId(T);

  	  	      store[id].marker = new google.maps.Marker({
  	  	        position: {
  	  	          lat, lng
  	  	        },
  	  	        map,
  	  	        icon,
  	  	        draggable: false,
  	  	        title: `${T.FID ?? T.ID ?? "Unit"}${warning ? " • WARNING": moving ? " • moving": " • stopped"}`
  	  	      });

  	  	      store[id].marker.addListener("click", () => {

  	  	        try {
  	  	          const dir = map.__trackitDirections;

  	  	          if (dir?.active) {
  	  	            const pos = store[id]?.marker?.getPosition?.();
  	  	            const currentTractorForDirections = store[id]?.tractor || {};

  	  	            const vehicleLabel =
  	  	            currentTractorForDirections?.FID ||
  	  	            currentTractorForDirections?.ID ||
  	  	            currentTractorForDirections?.Registration ||
  	  	            currentTractorForDirections?.Tracker ||
  	  	            id;

  	  	            if (pos && typeof map.__trackitAddDirectionsPoint === "function") {
  	  	              const vehicleMeta = typeof map.__trackitGetDirectionsVehicleMeta === "function"
  	  	              ? map.__trackitGetDirectionsVehicleMeta(currentTractorForDirections, id)
  	  	              : null;

  	  	              map.__trackitAddDirectionsPoint(pos, String(vehicleLabel), vehicleMeta);
  	  	            }

  	  	            // Direction mode blocks normal vehicle popup.
  	  	            return;
  	  	          }
  	  	        } catch (_) {}
  	  	        try {
  	  	          const dir = map.__trackitDirections;

  	  	          if (dir?.active) {
  	  	            const pos = store[id]?.marker?.getPosition?.();
  	  	            const currentTractorForDirections = store[id]?.tractor || {};

  	  	            const vehicleLabel =
  	  	            currentTractorForDirections?.FID ||
  	  	            currentTractorForDirections?.ID ||
  	  	            currentTractorForDirections?.Registration ||
  	  	            currentTractorForDirections?.Tracker ||
  	  	            id;

  	  	            if (pos && typeof map.__trackitAddDirectionsPoint === "function") {
  	  	              const vehicleMeta = typeof map.__trackitGetDirectionsVehicleMeta === "function"
  	  	              ? map.__trackitGetDirectionsVehicleMeta(currentTractorForDirections, id)
  	  	              : null;

  	  	              map.__trackitAddDirectionsPoint(pos, String(vehicleLabel), vehicleMeta);
  	  	            }

  	  	            // Direction mode temporarily blocks the vehicle popup.
  	  	            return;
  	  	          }
  	  	        } catch (_) {}

  	  	        const currentTractor = store[id]?.tractor;

  	  	        if (!currentTractor) return;

  	  	        const html = buildInfoHtml(currentTractor);

  	  	        map.__truckInfoWindow.__currentTractor = currentTractor;
  	  	        map.__truckInfoWindow.__currentId = id;
  	  	        map.__truckInfoWindow.setContent(html);
  	  	        map.__truckInfoWindow.open({
  	  	          anchor: store[id].marker,
  	  	          map
  	  	        });

  	  	        setFollowOn(id);

  	  	        try {
  	  	          writeSelectedTractorMarkerId(store[id].objectId || null);
  	  	        } catch (_) {}
  	  	      });
  	  	    }

  	  	    if (map.__follow?.enabled && map.__follow.id === id) {
  	  	      map.panTo({
  	  	        lat, lng
  	  	      });
  	  	    }

  	  	    // ---------- pulse moving / warning ----------
  	  	    const mode = warning ? "warning": (moving ? "moving": null);

  	  	    if (!mode) {
  	  	      if (store[id].timerId) {
  	  	        clearInterval(store[id].timerId);
  	  	        store[id].timerId = null;
  	  	      }

  	  	      if (store[id].pulseMarker) {
  	  	        store[id].pulseMarker.setMap(null);
  	  	        store[id].pulseMarker = null;
  	  	      }

  	  	    } else {
  	  	      const pulseCfg = CFG.PULSE[mode];
  	  	      const pulseCol = warning ? CFG.COLORS.pulse.warn: CFG.COLORS.pulse.moving;
  	  	      const pulseSvg = svgPulse(pulseCol);

  	  	      if (!store[id].pulseMarker) {
  	  	        store[id].pulseMarker = new google.maps.Marker({
  	  	          position: {
  	  	            lat, lng
  	  	          },
  	  	          map,
  	  	          clickable: false,
  	  	          zIndex: 0,
  	  	          opacity: pulseCfg.maxOpacity,
  	  	          icon: {
  	  	            url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pulseSvg)}`,
  	  	            scaledSize: new google.maps.Size(scaledW, scaledH),
  	  	            anchor: new google.maps.Point(anchorX, anchorY)
  	  	          }
  	  	        });

  	  	      } else {
  	  	        store[id].pulseMarker.setPosition({
  	  	          lat, lng
  	  	        });

  	  	        store[id].pulseMarker.setIcon({
  	  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pulseSvg)}`,
  	  	          scaledSize: new google.maps.Size(scaledW, scaledH),
  	  	          anchor: new google.maps.Point(anchorX, anchorY)
  	  	        });
  	  	      }

  	  	      if (store[id].timerId) {
  	  	        clearInterval(store[id].timerId);
  	  	        store[id].timerId = null;
  	  	      }

  	  	      const {
  	  	        periodMs,
  	  	        minScale,
  	  	        maxScale,
  	  	        minOpacity,
  	  	        maxOpacity
  	  	      } = pulseCfg;

  	  	      const pulseMarker = store[id].pulseMarker;
  	  	      let t0 = performance.now();

  	  	      store[id].timerId = setInterval(() => {
  	  	        const now = performance.now();
  	  	        const phase = ((now - t0) % periodMs) / periodMs;

  	  	        const s = minScale + (maxScale - minScale) * phase;
  	  	        const a = maxOpacity - (maxOpacity - minOpacity) * phase;

  	  	        const w = Math.max(1, Math.round(scaledW * s));
  	  	        const h = Math.max(1, Math.round(scaledH * s));

  	  	        pulseMarker.setIcon({
  	  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pulseSvg)}`,
  	  	          scaledSize: new google.maps.Size(w, h),
  	  	          anchor: new google.maps.Point(
  	  	            Math.round(w * (CFG.CX / CFG.W)),
  	  	            Math.round(h * (CFG.CY / CFG.H))
  	  	          )
  	  	        });

  	  	        pulseMarker.setOpacity(a);
  	  	      }, 40);
  	  	    }
  	  	  });

  	  	  // ---------- cleanup ----------
  	  	  Object.keys(store).forEach((id) => {
  	  	    if (seen.has(id)) return;

  	  	    if (map.__follow?.enabled && map.__follow.id === id) {
  	  	      map.__follow.enabled = false;
  	  	      map.__follow.id = null;
  	  	    }

  	  	    store[id]?.marker?.setMap(null);

  	  	    if (store[id]?.timerId) {
  	  	      clearInterval(store[id].timerId);
  	  	    }

  	  	    store[id]?.pulseMarker?.setMap(null);

  	  	    delete store[id];
  	  	  });

  	  	  // ---------- initial fit / center only ----------
  	  	  // Do this only once. After that, keep the user's current zoom and center.
  	  	  if (!map.__trackitInitialFleetViewDone && !map.__follow?.enabled && centre === true) {
  	  	    map.__trackitInitialFleetViewDone = true;

  	  	    if (validPoints.length === 1) {
  	  	      map.setCenter(validPoints[0]);

  	  	    } else if (validPoints.length > 1) {
  	  	      const b = new google.maps.LatLngBounds();

  	  	      validPoints.forEach(p => b.extend(p));

  	  	      map.fitBounds(b);
  	  	    }
  	  	  }

  	  	  // ---------- AppData watcher: open + FOLLOW when SelectedTractorMarker matches ----------
  	  	  if (!map.__selectedMarkerWatcher) {
  	  	    map.__selectedMarkerWatcher = {
  	  	      timer: null,
  	  	      lastSeen: null
  	  	    };

  	  	    const tick = () => {
  	  	      try {
  	  	        const st = map.__selectedMarkerWatcher;
  	  	        const selId = readSelectedTractorMarkerId();

  	  	        if (!selId) {
  	  	          st.lastSeen = null;
  	  	          return;
  	  	        }

  	  	        if (selId === st.lastSeen) return;

  	  	        let matchId = null;
  	  	        let pin = null;

  	  	        for (const id of Object.keys(store)) {
  	  	          if (store[id]?.objectId && store[id].objectId === selId) {
  	  	            matchId = id;
  	  	            pin = store[id];
  	  	            break;
  	  	          }
  	  	        }

  	  	        if (pin?.marker) {
  	  	          const T = pin.tractor;

  	  	          map.__truckInfoWindow.__currentTractor = T;
  	  	          map.__truckInfoWindow.__currentId = matchId;
  	  	          map.__truckInfoWindow.setContent(buildInfoHtml(T));
  	  	          map.__truckInfoWindow.open({
  	  	            anchor: pin.marker,
  	  	            map
  	  	          });

  	  	          setFollowOn(matchId);
  	  	        }

  	  	        st.lastSeen = selId;

  	  	      } catch (e) {
  	  	        console.warn("SelectedTractorMarker watcher error:", e);
  	  	      }
  	  	    };

  	  	    map.__selectedMarkerWatcher.timer = setInterval(tick, 250);
  	  	  }

  	  	  if (CFG.DEBUG) {
  	  	    console.debug("TruckPins: active =", Object.keys(store).length, "follow =", map.__follow);
  	  	  }
  	  	}

  	  	// --- Usage Custom Code block ---
  	  	try {
  	  	  const googleMapComponent = arguments[0];
  	  	  const items = arguments[1];
  	  	  const centre = arguments[2];
  	  	  const fineTrack = arguments[3];
  	  	  const App = arguments[4];

  	  	  addMinimalTruckPins(googleMapComponent, items, centre, fineTrack, App);

  	  	} catch (e) {
  	  	  console.error("Error adding minimal truck pins:", e);
  	  	}
  	  })(Map, (await Promise.all((await asyncListFilter(Tractors, async (item) => {


  	   return (!((getObjectProperty(item, 'Location')) === null));
  	  })).map(async item => {; return ({ [`lat`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'position.latitude')),[`lng`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'position.longitude')),[`ID`]: (getObjectProperty(item, 'ID')),[`movement`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'movement.status')),[`Tractor`]: item });}))), true, Track, AppData);
  	  Tractors1 = [];
  	  var j_list = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
  	  for (var j_index in j_list) {
  	    j = j_list[j_index];
  	    var k_list = (getObjectProperty(j, 'Tractors'));
  	    for (var k_index in k_list) {
  	      k = k_list[k_index];
  	      addItemToList(Tractors1, k);
  	    }
  	  }
  	  await (async function(Repeater, Items) {
  	  	/*
  	  	 * BULLETPROOF TRACKIT REPEATER UPDATE
  	  	 *
  	  	 * arguments[0] = Repeater component
  	  	 * arguments[1] = Tractors1 array
  	  	 *
  	  	 * This block NEVER intentionally throws.
  	  	 */

  	  	const repeater = arguments[0];
  	  	const source = arguments[1];

  	  	const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));


  	  	// ------------------------------------------------------------
  	  	// Safe property reader.
  	  	// Supports BOTH:
  	  	//   obj["can.engine.rpm"]
  	  	// and:
  	  	//   obj.can.engine.rpm
  	  	// ------------------------------------------------------------
  	  	function getValue(obj, path) {
  	  	  try {
  	  	    if (obj == null) return undefined;

  	  	    // Backendless/Flespi objects often actually contain dotted keys.
  	  	    if (Object.prototype.hasOwnProperty.call(obj, path)) {
  	  	      return obj[path];
  	  	    }

  	  	    const parts = String(path).split(".");
  	  	    let value = obj;

  	  	    for (const part of parts) {
  	  	      if (value == null) return undefined;
  	  	      value = value[part];
  	  	    }

  	  	    return value;

  	  	  } catch (_) {
  	  	    return undefined;
  	  	  }
  	  	}


  	  	// ------------------------------------------------------------
  	  	// Numeric helper.
  	  	// Returns NaN instead of throwing.
  	  	// ------------------------------------------------------------
  	  	function numberValue(value) {
  	  	  if (value === null || value === undefined || value === "") {
  	  	    return NaN;
  	  	  }

  	  	  const n = Number(value);
  	  	  return Number.isFinite(n) ? n : NaN;
  	  	}


  	  	// ------------------------------------------------------------
  	  	// Work on a clean array.
  	  	// Never trust incoming component/page data.
  	  	// ------------------------------------------------------------
  	  	const tractors = Array.isArray(source)
  	  	  ? source.filter(item => item && typeof item === "object")
  	  	  : [];

  	  	let result = [];

  	  	try {

  	  	  result = tractors.filter(item => {

  	  	    try {

  	  	      const location = getValue(item, "Location");

  	  	      // Original first filter:
  	  	      // Location must exist.
  	  	      if (location === null || location === undefined) {
  	  	        return false;
  	  	      }


  	  	      // Original Tracker null/undefined check.
  	  	      const tracker = getValue(item, "Tracker");

  	  	      if (tracker === null || tracker === undefined) {
  	  	        return false;
  	  	      }


  	  	      // --------------------------------------------------------
  	  	      // GPS warning condition.
  	  	      // --------------------------------------------------------
  	  	      const rpmWarning =
  	  	        getValue(location, "GPSWarnings.RPM") === true;

  	  	      const speedWarning =
  	  	        getValue(location, "GPSWarnings.Speed") === true;

  	  	      const tempWarning =
  	  	        getValue(location, "GPSWarnings.Temp") === true;


  	  	      if (rpmWarning || speedWarning || tempWarning) {
  	  	        return true;
  	  	      }


  	  	      // --------------------------------------------------------
  	  	      // Movement / RPM logic from your current Codeless blocks.
  	  	      // --------------------------------------------------------
  	  	      const rpmRaw = getValue(location, "can.engine.rpm");
  	  	      const speedRaw = getValue(location, "position.speed");

  	  	      const speed = numberValue(speedRaw);


  	  	      // No RPM available:
  	  	      // moving above 2 km/h counts.
  	  	      if (rpmRaw === null || rpmRaw === undefined) {
  	  	        return Number.isFinite(speed) && speed > 2;
  	  	      }


  	  	      const rpm = numberValue(rpmRaw);

  	  	      if (!Number.isFinite(rpm)) {
  	  	        return false;
  	  	      }

  	  	      if (!Number.isFinite(speed)) {
  	  	        return false;
  	  	      }


  	  	      // Engine running while stationary.
  	  	      if (rpm > 100 && speed === 0) {
  	  	        return true;
  	  	      }


  	  	      // Engine running while moving.
  	  	      if (rpm > 100 && speed > 2) {
  	  	        return true;
  	  	      }


  	  	      return false;

  	  	    } catch (itemError) {

  	  	      console.warn(
  	  	        "[TrackIT Repeater] Skipped bad tractor record:",
  	  	        itemError,
  	  	        item
  	  	      );

  	  	      return false;
  	  	    }

  	  	  });


  	  	  // ------------------------------------------------------------
  	  	  // Sort by FID.
  	  	  // Same basic behaviour as your current ascending Sort block.
  	  	  // ------------------------------------------------------------
  	  	  result.sort((a, b) => {

  	  	    try {

  	  	      const av = getValue(a, "FID");
  	  	      const bv = getValue(b, "FID");

  	  	      if (av === bv) return 0;
  	  	      if (av === null || av === undefined) return 1;
  	  	      if (bv === null || bv === undefined) return -1;

  	  	      if (av > bv) return 1;
  	  	      if (av < bv) return -1;

  	  	      return 0;

  	  	    } catch (_) {
  	  	      return 0;
  	  	    }

  	  	  });

  	  	} catch (filterError) {

  	  	  console.error(
  	  	    "[TrackIT Repeater] Filter/sort failed:",
  	  	    filterError
  	  	  );

  	  	  result = [];
  	  	}


  	  	// ============================================================
  	  	// CRITICAL RACE-CONDITION PROTECTION
  	  	// ============================================================

  	  	// If Backendless is between destroying and recreating the page,
  	  	// Repeater may legitimately be undefined.
  	  	//
  	  	// DO NOT THROW.
  	  	// DO NOT TOUCH .display.
  	  	// LiveTrack can continue normally.
  	  	if (
  	  	  repeater === null ||
  	  	  repeater === undefined ||
  	  	  (
  	  	    typeof repeater !== "object" &&
  	  	    typeof repeater !== "function"
  	  	  )
  	  	) {

  	  	  console.warn(
  	  	    "[TrackIT Repeater] Component not ready - update safely skipped."
  	  	  );

  	  	  return result;
  	  	}


  	  	// ------------------------------------------------------------
  	  	// Updating a Backendless component can itself race with page
  	  	// destruction, so retry transient setter failures a few times.
  	  	// ------------------------------------------------------------
  	  	let updated = false;

  	  	for (let attempt = 1; attempt <= 4; attempt++) {

  	  	  try {

  	  	    repeater.dynamicListItems = result;

  	  	    updated = true;
  	  	    break;

  	  	  } catch (error) {

  	  	    console.warn(
  	  	      `[TrackIT Repeater] Update attempt ${attempt}/4 failed.`,
  	  	      error
  	  	    );

  	  	    if (attempt < 4) {
  	  	      await sleep(50);
  	  	    }
  	  	  }
  	  	}


  	  	if (!updated) {

  	  	  console.warn(
  	  	    "[TrackIT Repeater] Component disappeared during update. " +
  	  	    "LiveTrack will continue without crashing."
  	  	  );

  	  	  return result;
  	  	}


  	  	// ============================================================
  	  	// OPTIONAL REDRAW
  	  	// ============================================================
  	  	//
  	  	// Your old code did:
  	  	//
  	  	//     Repeater.display = false;
  	  	//     Repeater.display = true;
  	  	//
  	  	// Do it safely and yield one browser frame between the two.
  	  	//
  	  	// If Backendless destroys the component here, we simply abandon
  	  	// the redraw instead of taking down the whole page.
  	  	// ============================================================

  	  	try {

  	  	  if ("display" in repeater) {

  	  	    repeater.display = false;

  	  	    await new Promise(resolve => {
  	  	      if (typeof requestAnimationFrame === "function") {
  	  	        requestAnimationFrame(() => resolve());
  	  	      } else {
  	  	        setTimeout(resolve, 0);
  	  	      }
  	  	    });

  	  	    try {
  	  	      repeater.display = true;
  	  	    } catch (showError) {

  	  	      console.warn(
  	  	        "[TrackIT Repeater] Repeater disappeared during redraw.",
  	  	        showError
  	  	      );
  	  	    }
  	  	  }

  	  	} catch (redrawError) {

  	  	  console.warn(
  	  	    "[TrackIT Repeater] Redraw skipped safely:",
  	  	    redrawError
  	  	  );
  	  	}


  	  	return result;
  	  })(Repeater, (await asyncListSort((await asyncListFilter((await asyncListFilter(Tractors1, async (item) => {


  	   return (!((getObjectProperty(item, 'Location')) === null));
  	  })), async (item) => {
  	     if (!(await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(item, 'Tracker'))))) {
  	      if ((getObjectProperty((getObjectProperty((getObjectProperty(item, 'Location')), 'GPSWarnings')), 'RPM')) == true || (getObjectProperty((getObjectProperty((getObjectProperty(item, 'Location')), 'GPSWarnings')), 'Speed')) == true || (getObjectProperty((getObjectProperty((getObjectProperty(item, 'Location')), 'GPSWarnings')), 'Temp')) == true) {
  	        Decision = true;
  	      } else {
  	        if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty((getObjectProperty(item, 'Location')), 'can.engine.rpm'))))) {
  	          if ((getObjectProperty((getObjectProperty(item, 'Location')), 'position.speed')) > 2) {
  	            Decision = true;
  	          } else {
  	            Decision = false;
  	          }
  	        } else {
  	          if ((getObjectProperty((getObjectProperty(item, 'Location')), 'can.engine.rpm')) > 100 && (getObjectProperty((getObjectProperty(item, 'Location')), 'position.speed')) == 0) {
  	            Decision = true;
  	          } else {
  	            if ((getObjectProperty((getObjectProperty(item, 'Location')), 'can.engine.rpm')) > 100 && (getObjectProperty((getObjectProperty(item, 'Location')), 'position.speed')) > 2) {
  	              Decision = true;
  	            } else {
  	              Decision = false;
  	            }
  	          }
  	        }
  	      }
  	    } else {
  	      Decision = false;
  	    }


  	   return Decision;
  	  })), 1, async (Sorter) => {


  	   return (getObjectProperty(Sorter, 'FID'));
  	  })));
  	}

  	/**
  	 * Describe this function...
  	 */
  	async function Multi_Track() {
  	  if (!__trackitAlive()) return;

  	  try {
  	    Clocking = await Clocking2();
  	  } catch (error) {
  	    __trackitLog("warn", "Clocking load failed; continuing without it.", error);
  	    Clocking = null;
  	  }

  	  if (!__trackitAlive()) return;

  	  try {
  	    await LiveTrack();
  	  } catch (error) {
  	    __trackitLog("error", "Initial LiveTrack render failed.", error);
  	  }

  	  // Non-live multi-vehicle view renders once and exits.
  	  if (!Live || !__trackitAlive()) return;

  	  while (Live && __trackitAlive()) {

  	    // One controlled wait per refresh cycle.
  	    if (!await __trackitSleep(Wait || 40000)) return;
  	    if (!__trackitAlive()) return;

  	    try {
  	      const companies =
  	        getObjectProperty(
  	          getObjectProperty(AppData, "User"),
  	          "Companies"
  	        );

  	      const trackerGroups = await Promise.all(
  	        (Array.isArray(companies) ? companies : []).map(async company => {
  	          const companyTractors = getObjectProperty(company, "Tractors");

  	          return await Promise.all(
  	            (Array.isArray(companyTractors) ? companyTractors : [])
  	              .map(async Tractor => getObjectProperty(Tractor, "Tracker"))
  	          );
  	        })
  	      );

  	      if (!__trackitAlive()) return;

  	      await BackendlessUI.Functions.Custom[
  	        "fn_2cdb14e20aec99596e5725c4e3064843"
  	      ](
  	        AppData,
  	        trackerGroups,
  	        null,
  	        null
  	      );

  	    } catch (error) {
  	      // A transient data failure must not kill the live runtime.
  	      __trackitLog(
  	        "warn",
  	        "Live tracking refresh failed; next cycle will retry.",
  	        error
  	      );
  	    }

  	    if (!__trackitAlive()) return;

  	    try {
  	      await LiveTrack();
  	    } catch (error) {
  	      __trackitLog(
  	        "warn",
  	        "LiveTrack redraw failed; next cycle will retry.",
  	        error
  	      );
  	    }
  	  }
  	}

  	/**
  	 * Describe this function...
  	 */
  	async function Single_Track() {
  	  try {
  	    Map['display'] = false;

  	  } catch (error) {

  	  }
  	  await (async function(Image) {
  	  	function spinnerOverlay(args) {
  	  	  const { App, waitKey = "SpinnerDone", msgKey = "SpinnerMsg", Image } = args || {};
  	  	  if (!App || document.getElementById("fleetSpinner")) return;

  	  	  const overlay = document.createElement("div");
  	  	  overlay.id = "fleetSpinner";
  	  	  Object.assign(overlay.style, {
  	  	    position: "fixed",
  	  	    inset: "0",
  	  	    zIndex: "2147483647",
  	  	    background: "rgba(5,5,5,1)",
  	  	    display: "flex",
  	  	    flexDirection: "column",
  	  	    alignItems: "center",
  	  	    justifyContent: "center",
  	  	    color: "#fff",
  	  	    fontFamily: "Inter, sans-serif",
  	  	    transition: "opacity 0.45s ease",
  	  	  });

  	  	  // --- Logo ---
  	  	  const logo = document.createElement("img");
  	  	  if (Image) logo.src = Image;
  	  	  logo.style.cssText = `
  	  	    width:200px;
  	  	    height:auto;
  	  	    margin-bottom:30px;
  	  	    opacity:0;
  	  	    transform:scale(0.8);
  	  	    filter:drop-shadow(0 0 12px rgba(204,102,51,0.8));
  	  	    animation: logoFade 2.5s ease forwards;
  	  	  `;

  	  	  // --- Spinner ---
  	  	  const spinner = document.createElement("div");
  	  	  spinner.style.cssText = `
  	  	    width:70px;height:70px;
  	  	    border:6px solid rgba(255,255,255,0.15);
  	  	    border-top:6px solid #CC6633;
  	  	    border-radius:50%;
  	  	    animation:spin 1s linear infinite;
  	  	    box-shadow:0 0 20px rgba(204,102,51,0.4);
  	  	  `;

  	  	  // --- Message text (dramatic pulse) ---
  	  	  const msg = document.createElement("div");
  	  	  msg.textContent = App?.[msgKey] || "Loading…";
  	  	  msg.style.cssText = `
  	  	    margin-top:28px;
  	  	    font-size:1.3em;
  	  	    font-weight:700;
  	  	    text-align:center;
  	  	    letter-spacing:0.5px;
  	  	    opacity:0;
  	  	    animation: fadeIn 1.5s ease forwards, textPulse 4s ease-in-out infinite 1.5s;
  	  	  `;

  	  	  // --- Styles ---
  	  	  const style = document.createElement("style");
  	  	  style.textContent = `
  	  	    @keyframes spin {
  	  	      0%{transform:rotate(0)}100%{transform:rotate(360deg)}
  	  	    }
  	  	    @keyframes fadeIn {
  	  	      from{opacity:0;transform:translateY(8px)}
  	  	      to{opacity:1;transform:translateY(0)}
  	  	    }
  	  	    @keyframes logoFade {
  	  	      0% {opacity:0;transform:scale(0.8);}
  	  	      60% {opacity:0.9;transform:scale(1.1);}
  	  	      100% {opacity:1;transform:scale(1);}
  	  	    }
  	  	    @keyframes textPulse {
  	  	      0%,100% {
  	  	        opacity:0.4;
  	  	        transform:scale(1);
  	  	        text-shadow:0 0 0 rgba(204,102,51,0);
  	  	      }
  	  	      50% {
  	  	        opacity:1;
  	  	        transform:scale(1.3);
  	  	        text-shadow:0 0 25px rgba(204,102,51,0.9);
  	  	        color:#fff8f0;
  	  	      }
  	  	    }
  	  	  `;

  	  	  overlay.append(logo, spinner, msg);
  	  	  document.body.append(style, overlay);

  	  	  let last = msg.textContent;
  	  	  const poller = setInterval(() => {
  	  	    if (App[msgKey] && App[msgKey] !== last) {
  	  	      msg.textContent = App[msgKey];
  	  	      last = App[msgKey];
  	  	    }
  	  	    if (App[waitKey]) {
  	  	      clearInterval(poller);
  	  	      overlay.style.opacity = "0";
  	  	      setTimeout(() => overlay.remove(), 400);
  	  	      delete App[waitKey];
  	  	      delete App[msgKey];
  	  	    }
  	  	  }, 250);
  	  	}

  	  	spinnerOverlay({ App: AppData, Image });

  	  })('data:image/png;base64,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');
  	  AppData['SpinnerMsg'] = 'Acquiring Tracking Data';
  	  Tractor = Tractors[0];
  	  Map['display'] = true;
  	  try {
  	    await BackendlessUI.Functions.Custom['fn_2cdb14e20aec99596e5725c4e3064843'](AppData, (getObjectProperty((getObjectProperty(AppData, 'SelectedTractor')), 'Tracker')), To, From);

  	  } catch (error) {
  	    console.log(error);

  	  } finally {
  	    if (error) {
  	      AppData['SpinnerMsg'] = 'Error In Fetching Data';
  	      await new Promise(r => setTimeout(r, 4000 || 0));
  	      AppData['SpinnerDone'] = true;
  	    }

  	  }
  	  AppData['SpinnerMsg'] = 'Analysing Events... ';
  	  await (async function(Tractor, CAN, Locations, AppData) {
  	  	// === CAN Event Engine (v2) — Rog Mode (no logs) ===
  	  	// Inputs (Codeless args): Tractor, CAN, Locations, AppData
  	  	// Output: { ok, events, stats, debug, errors }

  	  	return (async function run(Tractor, CAN, Locations, AppData) {
  	  	  // ---------- tiny utils ----------
  	  	  const isObj = v => v && typeof v === 'object';
  	  	  const own = (o, k) => Object.prototype.hasOwnProperty.call(o, k);
  	  	  const toNum = v => {
  	  	    const n = Number(v); return Number.isFinite(n) ? n: null;
  	  	  };
  	  	  const toBool = v => {
  	  	    if (typeof v === 'boolean') return v;
  	  	    if (v === 1 || v === 0) return !!v;
  	  	    if (typeof v === 'string') {
  	  	      const s = v.trim().toLowerCase(); if (s === 'true')return true; if (s === 'false')return false;
  	  	    }
  	  	    return !!v;
  	  	  };
  	  	  const byPath = (obj, dot) => {
  	  	    if (!obj || dot == null) return undefined;
  	  	    const key = String(dot);
  	  	    if (own(obj, key)) return obj[key]; // allow literal dotted keys
  	  	    let cur = obj;
  	  	    for (const seg of key.split('.')) {
  	  	      if (cur == null) return undefined; cur = cur[seg];
  	  	    }
  	  	    return cur;
  	  	  };
  	  	  // JSON Pointer reader (supports ~0/~1 unescape)
  	  	  function getByPointer(root, pointer) {
  	  	    if (!root || pointer == null) return undefined;
  	  	    const unescape = s => s.replace(/~1/g, '/').replace(/~0/g, '~');
  	  	    const parts = String(pointer).split('/').filter(Boolean).map(unescape);
  	  	    let cur = root;
  	  	    for (const key of parts) {
  	  	      if (cur == null) return undefined; cur = cur[key];
  	  	    }
  	  	    return cur;
  	  	  }
  	  	  // Universal ref resolver: accepts {"$ref":"#/A/B"}, "#/A/B", "A.B", "A/B", primitives
  	  	  const resolveRef = (root, ref) => {
  	  	    if (ref == null) return undefined;
  	  	    if (typeof ref === 'object' && ref.$ref != null) {
  	  	      const p = String(ref.$ref);
  	  	      if (p.startsWith('#/')) return getByPointer(root, p.slice(2));
  	  	      if (p.startsWith('#.')) return byPath(root, p.slice(2));
  	  	      return p.includes('/') ? getByPointer(root, p): byPath(root, p);
  	  	    }
  	  	    if (typeof ref === 'string') {
  	  	      if (ref.startsWith('#/')) return getByPointer(root, ref.slice(2));
  	  	      if (ref.startsWith('#.')) return byPath(root, ref.slice(2));
  	  	      return ref.includes('/') ? getByPointer(root, ref): byPath(root, ref);
  	  	    }
  	  	    return ref; // primitive
  	  	  };
  	  	  const normTsMs = (t) => {
  	  	    const n = toNum(t); if (n == null) return null; return n < 1e11 ? n*1000: n;
  	  	  };

  	  	  // Seconds-first duration readers with backward compatibility for old *_ms keys
  	  	  const readSeconds = (primarySec, legacyMs, fallbackSec = 0) => {
  	  	    const sec = toNum(primarySec);
  	  	    if (sec != null) return sec;

  	  	    const ms = toNum(legacyMs);
  	  	    if (ms != null) return ms / 1000;

  	  	    return fallbackSec;
  	  	  };

  	  	  const readWindowSeconds = (spec, fallbackSec = 0) => {
  	  	    if (!isObj(spec)) return fallbackSec;

  	  	    const sec =
  	  	    toNum(spec.s) ??
  	  	    toNum(spec.sec) ??
  	  	    toNum(spec.seconds);

  	  	    if (sec != null) return sec;

  	  	    const ms = toNum(spec.ms);
  	  	    if (ms != null) return ms / 1000;

  	  	    return fallbackSec;
  	  	  };

  	  	  const haversineM = (lat1, lon1, lat2, lon2) => {
  	  	    if (![lat1, lon1, lat2, lon2].every(Number.isFinite)) return 0;
  	  	    const R = 6371000,
  	  	    toRad = d => d*Math.PI/180;
  	  	    const dLat = toRad(lat2-lat1),
  	  	    dLon = toRad(lon2-lon1);
  	  	    const a = Math.sin(dLat/2)**2 + Math.cos(toRad(lat1))*Math.cos(toRad(lat2))*Math.sin(dLon/2)**2;
  	  	    return 2*R*Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  	  	  };

  	  	  // ---------- guard ----------
  	  	  if (!isObj(CAN) || !Array.isArray(CAN.Events)) {
  	  	    return {
  	  	      ok: false,
  	  	      error: 'CAN.Events[] missing or invalid',
  	  	      events: {},
  	  	      stats: {
  	  	        eventsDefined: 0,
  	  	        logsCount: 0
  	  	      },
  	  	      debug: {},
  	  	      errors: ['Schema']
  	  	    };
  	  	  }

  	  	  // ---------- discover logs ----------
  	  	  const discoverLogs = (tractor) => {
  	  	    if (!isObj(tractor)) return [];
  	  	    const candidates = ['Logs',
  	  	      'Tracking',
  	  	      'History',
  	  	      'LocationHistory',
  	  	      'track',
  	  	      'telemetry',
  	  	      'data',
  	  	      'items'];
  	  	    for (const p of candidates) {
  	  	      const v = byPath(tractor, p);
  	  	      if (Array.isArray(v) && v.length) return v.slice();
  	  	    }
  	  	    return [];
  	  	  };
  	  	  let logs = discoverLogs(Tractor);

  	  	  // ---------- stream keys ----------
  	  	  const latKey = resolveRef(CAN, '#/Stream/lat') || 'position.latitude';
  	  	  const lonKey = resolveRef(CAN, '#/Stream/lon') || 'position.longitude';
  	  	  const tsKey = resolveRef(CAN, '#/Stream/timestamp') || 'timestamp';
  	  	  const odoKey = resolveRef(CAN, '#/Stream/odometer_km') || null;
  	  	  const speedKey = resolveRef(CAN, '#/Stream/speed') || 'position.speed';
  	  	  const fbSpeedKey = resolveRef(CAN, '#/Stream/fallback_speed') || null;

  	  	  const tractorIdleLimitSec =
  	  	  toNum(byPath(Tractor, 'CAN.Idle')) ??
  	  	  toNum(byPath(Tractor, 'CAN.idle')) ??
  	  	  toNum(byPath(Tractor, 'CAN.Engine.Idle')) ??
  	  	  toNum(byPath(Tractor, 'CAN.Engine.idle')) ??
  	  	  toNum(resolveRef(CAN, '#/Idle')) ??
  	  	  toNum(resolveRef(CAN, '#/idle')) ??
  	  	  0;

  	  	  // ---------- prep logs ----------
  	  	  logs = logs
  	  	  .map(r => {
  	  	    const ts = normTsMs(byPath(r, tsKey));
  	  	    const lat = toNum(byPath(r, latKey));
  	  	    const lon = toNum(byPath(r, lonKey));
  	  	    let spd = toNum(byPath(r, speedKey));
  	  	    if (spd == null && fbSpeedKey) spd = toNum(byPath(r, fbSpeedKey));
  	  	    const odoKm = odoKey ? toNum(byPath(r, odoKey)): null;
  	  	    return {
  	  	      ...r,
  	  	      __ts: ts,
  	  	      __lat: lat,
  	  	      __lon: lon,
  	  	      __spd: spd,
  	  	      __odoKm: odoKm,
  	  	      __derived: {}
  	  	    };
  	  	  })
  	  	  .filter(r => r.__ts != null)
  	  	  .sort((a, b) => a.__ts - b.__ts);

  	  	  // ---------- derived drift (10s) ----------
  	  	  const DRIFT_WINDOW_S = 10;
  	  	  const DRIFT_WINDOW_MS = DRIFT_WINDOW_S * 1000;
  	  	  {
  	  	    let q = [];
  	  	    for (const r of logs) {
  	  	      q.push(r);
  	  	      while (q.length && (r.__ts - q[0].__ts) > DRIFT_WINDOW_MS) q.shift();
  	  	      let gpsM = 0,
  	  	      speedM = 0;
  	  	      for (let i = 1; i < q.length; i++) {
  	  	        const a = q[i-1],
  	  	        b = q[i];
  	  	        const dt = (b.__ts - a.__ts)/1000;
  	  	        gpsM += haversineM(a.__lat??NaN, a.__lon??NaN, b.__lat??NaN, b.__lon??NaN);
  	  	        const s = toNum(a.__spd) ?? 0; // km/h
  	  	        speedM += (s/3.6) * dt;
  	  	      }
  	  	      const drift_mps = Math.max(0, (speedM - gpsM) / Math.max(1, (q[q.length-1].__ts - q[0].__ts)/1000));
  	  	      r.__derived['drift.kph_10s'] = drift_mps * 3.6;
  	  	    }
  	  	  }

  	  	  // ---------- signal functions ----------
  	  	  const valueFns = {
  	  	    value: (row, spec) => spec.field != null ? byPath(row, spec.field): undefined,
  	  	    abs: (row, spec) => {
  	  	      const v = valueFns.value(row, spec); const n = toNum(v); return n == null?null: Math.abs(n);
  	  	    },
  	  	    any: (row, spec) => (spec.fields || []).some(f => toBool(byPath(row, f))),
  	  	    both: (row, spec) => {
  	  	      const A = spec.a?.field ? byPath(row, spec.a.field): undefined;
  	  	      const B = spec.b?.field ? byPath(row, spec.b.field): undefined;
  	  	      const op = spec.op || 'and'; const trig = spec.trigger;
  	  	      switch (op) {
  	  	        case 'and': return toBool(A) && toBool(B);
  	  	        case 'and_not_b': return toBool(A) && !toBool(B);
  	  	        case 'both_false': return !toBool(A) && !toBool(B);
  	  	        case 'not_a_and_b_gt': {
  	  	            const n = toNum(B); const t = toNum(resolveRef(CAN, trig) ?? trig);
  	  	            return !toBool(A) && n != null && t != null && n > t;
  	  	          }
  	  	        default: return toBool(A) && toBool(B);
  	  	      }
  	  	    },
  	  	    rate: (row, spec, ctx) => {
  	  	      const lookSec = readWindowSeconds(spec.lookback, 60);
  	  	      const lookMs = lookSec * 1000;
  	  	      const i = ctx.idx,
  	  	      baseTs = row.__ts; let j = i;
  	  	      while (j > 0 && (baseTs - ctx.logs[j-1].__ts) <= lookMs) j--;
  	  	      const first = ctx.logs[j],
  	  	      last = row;
  	  	      const vFirst = toNum(byPath(first, spec.field)); const vLast = toNum(byPath(last, spec.field));
  	  	      if (vFirst == null || vLast == null) return null;
  	  	      const dtSec = Math.max(1, (last.__ts - first.__ts)/1000);
  	  	      return (vLast - vFirst) * (60 / dtSec); // per minute
  	  	    },
  	  	    delta: (row, spec, ctx) => {
  	  	      const lookSamples = spec.lookback?.samples ?? null;
  	  	      const lookSec = readWindowSeconds(spec.lookback, null);
  	  	      const lookMs = lookSec != null ? lookSec * 1000: null;
  	  	      const i = ctx.idx; let j = i; let count = 0; const tNow = row.__ts;
  	  	      while (j > 0 && ((lookSamples != null ? count < lookSamples: true) && (lookMs != null ? (tNow - ctx.logs[j-1].__ts) <= lookMs: true))) {
  	  	        j--; count++;
  	  	      }
  	  	      const first = ctx.logs[j],
  	  	      last = row;
  	  	      const a = toNum(byPath(first, spec.field)),
  	  	      b = toNum(byPath(last, spec.field));
  	  	      if (a == null || b == null) return null;
  	  	      let d = b - a;
  	  	      const dir = (spec.direction || 'either').toLowerCase();
  	  	      if (dir === 'drop') d = Math.min(0, d) * -1;
  	  	      if (dir === 'rise') d = Math.max(0, d);
  	  	      if (isObj(spec.transform) && spec.transform.to === 'liters') {
  	  	        const cap = toNum(resolveRef(CAN, spec.transform.capacityRef));
  	  	        if (cap != null && a <= 100 && b <= 100) d = (Math.abs(b - a) / 100) * cap;
  	  	      }
  	  	      return Math.abs(d);
  	  	    },
  	  	    jitter: (row, spec, ctx) => {
  	  	      const lookSec = readWindowSeconds(spec.lookback, 120);
  	  	      const lookMs = lookSec * 1000;
  	  	      const i = ctx.idx; let j = i; const tNow = row.__ts; let lo=+Infinity,
  	  	      hi=-Infinity;
  	  	      while (j >= 0 && (tNow - ctx.logs[j].__ts) <= lookMs) {
  	  	        const v = toNum(byPath(ctx.logs[j], spec.field));
  	  	        if (v != null) {
  	  	          if (v < lo) lo = v; if (v > hi) hi = v;
  	  	        }
  	  	        j--;
  	  	      }
  	  	      return (hi>-Infinity && lo<+Infinity) ? (hi - lo): null;
  	  	    },
  	  	    edge: (row, spec, ctx) => {
  	  	      if (ctx.idx === 0) return false; const prev = ctx.logs[ctx.idx-1]; return byPath(prev, spec.field) !== byPath(row, spec.field);
  	  	    },
  	  	    edge_any: (row, spec, ctx) => {
  	  	      if (ctx.idx === 0) return false; const prev = ctx.logs[ctx.idx-1]; return (spec.fields || []).some(f => byPath(prev, f) !== byPath(row, f));
  	  	    },
  	  	    edge_count: (row, spec, ctx) => {
  	  	      const lookSec = readWindowSeconds(spec.lookback, 10);
  	  	      const lookMs = lookSec * 1000; const tNow = row.__ts; let count = 0;
  	  	      for (let j = ctx.idx; j > 0 && (tNow - ctx.logs[j-1].__ts) <= lookMs; j--) {
  	  	        const a = byPath(ctx.logs[j], spec.field),
  	  	        b = byPath(ctx.logs[j-1], spec.field);
  	  	        if (a !== b) count++;
  	  	      }
  	  	      return count;
  	  	    },
  	  	    drift: (row, spec) => row.__derived['drift.kph_10s'] ?? 0
  	  	  };

  	  	  // ---------- comparators / tests ----------
  	  	  const opTest = {
  	  	    '>': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) > toNum(t),
  	  	    '>=': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) >= toNum(t),
  	  	    '<': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) < toNum(t),
  	  	    '<=': (v, t) => toNum(v) != null && toNum(t) != null && toNum(v) <= toNum(t),
  	  	    '==': (v, t) => v === t,
  	  	    '!=': (v, t) => v !== t,
  	  	    'truthy': v => toBool(v),
  	  	    'falsy': v => !toBool(v),
  	  	    'between': (v, t) => {
  	  	      const lo = toNum(t?.lo),
  	  	      hi = toNum(t?.hi),
  	  	      n = toNum(v); return n != null && lo != null && hi != null && n >= lo && n <= hi;
  	  	    },
  	  	    'cycles': (v, t) => {
  	  	      const n = toNum(v),
  	  	      thr = toNum(t); return n != null && thr != null && n >= thr;
  	  	    },
  	  	    'time_between': (row, t, localField = 'localtime') => {
  	  	      const lo = String(t?.lo || '00:00'),
  	  	      hi = String(t?.hi || '23:59');
  	  	      const ts = normTsMs(byPath(row, localField) ?? row.__ts); if (ts == null) return false;
  	  	      const d = new Date(ts),
  	  	      hh = String(d.getHours()).padStart(2, '0'),
  	  	      mm = String(d.getMinutes()).padStart(2, '0'),
  	  	      cur = `${hh}:${mm}`;
  	  	      return (lo <= hi) ? (cur >= lo && cur <= hi): (cur >= lo || cur <= hi); // midnight wrap
  	  	    },
  	  	    'truthy_any': (row, t) => (t?.fields || []).some(f => toBool(byPath(row, f))),
  	  	    'falsy_any': (row, t) => (t?.fields || []).some(f => !toBool(byPath(row, f))),
  	  	  };

  	  	  // ---------- gates ----------
  	  	  function mergeGateDefaults(gates, defaults) {
  	  	    if (isObj(gates) && gates.disable_defaults === true) {
  	  	      if (!Array.isArray(gates.requireAll) && !Array.isArray(gates.requireAny)) return null;

  	  	      return {
  	  	        requireAll: Array.isArray(gates.requireAll) ? [...gates.requireAll] : [],
  	  	        requireAny: Array.isArray(gates.requireAny) ? [...gates.requireAny] : []
  	  	      };
  	  	    }

  	  	    if (!defaults && !gates) return null;

  	  	    const out = {
  	  	      requireAll: [],
  	  	      requireAny: []
  	  	    };

  	  	    if (isObj(defaults)) {
  	  	      if (Array.isArray(defaults.requireAll)) out.requireAll.push(...defaults.requireAll);
  	  	      if (Array.isArray(defaults.requireAny)) out.requireAny.push(...defaults.requireAny);
  	  	    }

  	  	    if (isObj(gates)) {
  	  	      if (Array.isArray(gates.requireAll)) out.requireAll.push(...gates.requireAll);
  	  	      if (Array.isArray(gates.requireAny)) out.requireAny.push(...gates.requireAny);
  	  	    }

  	  	    return out;
  	  	  }
  	  	  function gatesPass(row, gates) {
  	  	    const EngCfg = CAN.Engine || {};
  	  	    const merged = mergeGateDefaults(gates, EngCfg.gates_defaults);
  	  	    if (!merged) return true;
  	  	    const check = (g) => {
  	  	      const op = (g?.op || 'truthy').toLowerCase();
  	  	      if (op === 'time_between') {
  	  	        return opTest['time_between'](row, {
  	  	          lo: resolveRef(CAN, g.lo), hi: resolveRef(CAN, g.hi)
  	  	        }, g.field || 'localtime');
  	  	      }
  	  	      if (op === 'truthy_any' || op === 'falsy_any') {
  	  	        return opTest[op](row, {
  	  	          fields: g.fields || []
  	  	        });
  	  	      }
  	  	      const v = g.field != null ? byPath(row, g.field): undefined;
  	  	      const trig = resolveRef(CAN, g.trigger) ?? g.trigger;
  	  	      const fn = opTest[op] || (()=>false);
  	  	      return fn(v, trig);
  	  	    };
  	  	    if (Array.isArray(merged.requireAll) && merged.requireAll.length) {
  	  	      for (const g of merged.requireAll) {
  	  	        if (!check(g)) return false;
  	  	      }
  	  	    }
  	  	    if (Array.isArray(merged.requireAny) && merged.requireAny.length) {
  	  	      let any = false; for (const g of merged.requireAny) {
  	  	        if (check(g)) {
  	  	          any = true; break;
  	  	        }
  	  	      }
  	  	      if (!any) return false;
  	  	    }
  	  	    return true;
  	  	  }

  	  	  // ---------- segmentation helpers ----------
  	  	  const includeFullPoint = !!resolveRef(CAN, '#/Engine/points/include_full_point');

  	  	  const pushPoint = (ctx, row, val) => {
  	  	    if (ctx.firstTs == null) ctx.firstTs = row.__ts;
  	  	    if (ctx.prevLat == null) ctx.prevLat = row.__lat ?? null;
  	  	    if (ctx.prevLon == null) ctx.prevLon = row.__lon ?? null;

  	  	    const rawPointTs = byPath(row, 'timestamp');
  	  	    const rawPointTsNum = toNum(rawPointTs);
  	  	    const pointTsSec = rawPointTsNum != null
  	  	    ? Math.floor(rawPointTsNum): Math.floor(Number(row.__ts) / 1000);

  	  	    const pt = {
  	  	      timestamp: pointTsSec,
  	  	      value: val,
  	  	      lat: Number.isFinite(row.__lat) ? row.__lat: undefined,
  	  	      lon: Number.isFinite(row.__lon) ? row.__lon: undefined
  	  	    };
  	  	    if (includeFullPoint) pt.point = row;

  	  	    ctx.curPts.push(pt);
  	  	    ctx.lastTs = row.__ts;
  	  	  };

  	  	  const stepDistance = (ctx, row, prevRow) => {
  	  	    if (row.__odoKm != null && prevRow?.__odoKm != null) {
  	  	      ctx.distM += Math.max(0, (row.__odoKm - prevRow.__odoKm)) * 1000;
  	  	    } else if (
  	  	      Number.isFinite(ctx.prevLat) && Number.isFinite(ctx.prevLon) &&
  	  	      Number.isFinite(row.__lat) && Number.isFinite(row.__lon)
  	  	    ) {
  	  	      ctx.distM += haversineM(ctx.prevLat, ctx.prevLon, row.__lat, row.__lon);
  	  	    }
  	  	    ctx.prevLat = row.__lat ?? ctx.prevLat;
  	  	    ctx.prevLon = row.__lon ?? ctx.prevLon;
  	  	    ctx.lastTs = row.__ts;
  	  	  };

  	  	  const resetSeg = (ctx) => {
  	  	    ctx.curPts = [];
  	  	    ctx.aggSum = 0;
  	  	    ctx.aggMax = -Infinity;
  	  	    ctx.aggCount = 0;
  	  	    ctx.firstTs = null;
  	  	    ctx.lastTs = null;
  	  	    ctx.distM = 0;
  	  	    ctx.prevLat = null;
  	  	    ctx.prevLon = null;
  	  	    ctx.startVal = null;
  	  	    ctx.lastVal = null;
  	  	    ctx.maxIdleTotal = null;
  	  	    ctx.maxIdlePoint = null;
  	  	  };
  	  	  const flushSeg = (ctx, debugMap) => {
  	  	    if (!ctx.curPts.length) return;

  	  	    const durMs = Math.max(0, (ctx.lastTs ?? ctx.firstTs) - (ctx.firstTs ?? ctx.lastTs));
  	  	    // Idle duration comes from Flespi's cumulative counter, not from the span
  	  	    // between received packets. A single packet can therefore be a valid idle.
  	  	    if (ctx.ruleName !== "Idle Event" && durMs < (ctx.minDurMs || 0)) {
  	  	      if (debugMap) debugMap.discardedShort++;
  	  	      return resetSeg(ctx);
  	  	    }

  	  	    if (ctx.ruleName === "Idle Event") {
  	  	      const finalIdleSec = toNum(ctx.maxIdleTotal);

  	  	      if (finalIdleSec == null || finalIdleSec < (ctx.idleLimitSec || 0)) {
  	  	        if (debugMap) debugMap.discardedShort++;
  	  	        return resetSeg(ctx);
  	  	      }

  	  	      const startTs = (ctx.curPts && ctx.curPts.length && ctx.curPts[0])
  	  	      ? ctx.curPts[0].timestamp: null;
  	  	      const maxPoint = ctx.maxIdlePoint ||
  	  	        ((ctx.curPts && ctx.curPts.length) ? ctx.curPts[ctx.curPts.length - 1] : null);

  	  	      ctx.segments.push({
  	  	        start: startTs,
  	  	        start_iso: startTs ? new Date(startTs * 1000).toISOString(): null,

  	  	        idle_seconds: Math.round(finalIdleSec),
  	  	        idle_human: (() => {
  	  	          var s = Math.round(finalIdleSec);
  	  	          var h = Math.floor(s / 3600);
  	  	          var m = Math.floor((s % 3600) / 60);
  	  	          var sec = s % 60;

  	  	          var out = [];
  	  	          if (h > 0) out.push(h + "h");
  	  	          if (m > 0 || h > 0) out.push(m + "m");
  	  	          out.push(sec + "s");

  	  	          return out.join(" ");
  	  	        })(),

  	  	        // One marker per Flespi idle event: only the point carrying the
  	  	        // highest idle.total value is returned.
  	  	        Points: maxPoint ? [maxPoint] : []
  	  	      });

  	  	      return resetSeg(ctx);
  	  	    }

  	  	    // --- Custom flush for Fuel Gain/Loss
  	  	    if (ctx.ruleName === "Fuel Gain (Refuel)" || ctx.ruleName === "Fuel Loss") {
  	  	      if (ctx.curPts.length) {
  	  	        const lastPt = ctx.curPts[ctx.curPts.length - 1];
  	  	        if (ctx.lastVal == null && lastPt?.value != null) ctx.lastVal = lastPt.value;
  	  	      }

  	  	      ctx.segments.push({
  	  	        distance: Math.round(ctx.distM * 1000) / 1000,
  	  	        duration: Math.round((durMs / 1000) * 1000) / 1000,
  	  	        ChangeL: Math.round(((ctx.lastVal ?? 0) - (ctx.startVal ?? 0)) * 1000) / 1000,
  	  	        Points: ctx.curPts
  	  	      });
  	  	    } else {
  	  	      ctx.segments.push({
  	  	        distance: Math.round(ctx.distM * 1000) / 1000,
  	  	        duration: Math.round((durMs / 1000) * 1000) / 1000,
  	  	        AVG: ctx.aggCount ? (ctx.aggSum / ctx.aggCount): null,
  	  	        Max: ctx.aggMax > -Infinity ? ctx.aggMax: null,
  	  	        Points: ctx.curPts
  	  	      });
  	  	    }

  	  	    resetSeg(ctx);
  	  	  };

  	  	  const EngCfg = CAN.Engine || {};
  	  	  const stabDefaults = EngCfg.stability_defaults || {};

  	  	  // ---------- dedicated Flespi idle event reader ----------
  	  	  // Flespi has already decided whether the vehicle is idling. Its idle.total
  	  	  // value is a cumulative counter for the CURRENT idle interval. This reader
  	  	  // therefore does not recalculate idle from speed, RPM, ignition or packet
  	  	  // type. BLE and CAN packets are both valid carrier packets for Flespi state.
  	  	  function buildFlespiIdleEvents(sourceLogs, rule, idleLimitSec) {
  	  	    const cfg = isObj(rule?.flespi_idle) ? rule.flespi_idle : {};
  	  	    const stateFields = Array.isArray(cfg.state_fields) && cfg.state_fields.length
  	  	      ? cfg.state_fields
  	  	      : ['idle.status', 'idle'];
  	  	    const counterFields = Array.isArray(cfg.counter_fields) && cfg.counter_fields.length
  	  	      ? cfg.counter_fields
  	  	      : ['idle.total', 'totalidle'];
  	  	    const resetDropSec = Math.max(0, toNum(cfg.reset_drop_s) ?? 1);

  	  	    const readFirstDefined = (row, fields) => {
  	  	      for (const field of fields) {
  	  	        const value = byPath(row, field);
  	  	        if (value !== undefined && value !== null) return value;
  	  	      }
  	  	      return undefined;
  	  	    };

  	  	    const readCounter = (row) => {
  	  	      for (const field of counterFields) {
  	  	        const n = toNum(byPath(row, field));
  	  	        if (n != null) return n;
  	  	      }
  	  	      return null;
  	  	    };

  	  	    const makeIdlePoint = (row, value) => {
  	  	      const rawTs = toNum(byPath(row, tsKey));
  	  	      const tsSec = rawTs != null
  	  	        ? rawTs
  	  	        : Number(row.__ts) / 1000;

  	  	      const pt = {
  	  	        timestamp: tsSec,
  	  	        value,
  	  	        lat: Number.isFinite(row.__lat) ? row.__lat : undefined,
  	  	        lon: Number.isFinite(row.__lon) ? row.__lon : undefined
  	  	      };
  	  	      if (includeFullPoint) pt.point = row;
  	  	      return pt;
  	  	    };

  	  	    const humanDuration = (seconds) => {
  	  	      let s = Math.round(seconds);
  	  	      const h = Math.floor(s / 3600);
  	  	      const m = Math.floor((s % 3600) / 60);
  	  	      s %= 60;
  	  	      const out = [];
  	  	      if (h > 0) out.push(h + 'h');
  	  	      if (m > 0 || h > 0) out.push(m + 'm');
  	  	      out.push(s + 's');
  	  	      return out.join(' ');
  	  	    };

  	  	    const segments = [];
  	  	    const stats = {
  	  	      stateTrueRows: 0,
  	  	      counterRows: 0,
  	  	      counterResets: 0,
  	  	      discardedShort: 0
  	  	    };

  	  	    let active = null;

  	  	    const startActive = (row, counter) => {
  	  	      active = {
  	  	        firstRowTsSec: Number(row.__ts) / 1000,
  	  	        lastCounter: counter,
  	  	        maxCounter: null,
  	  	        maxPoint: null
  	  	      };
  	  	    };

  	  	    const updateActive = (row, counter) => {
  	  	      if (counter == null) return;
  	  	      stats.counterRows++;
  	  	      active.lastCounter = counter;
  	  	      if (active.maxCounter == null || counter >= active.maxCounter) {
  	  	        active.maxCounter = counter;
  	  	        active.maxPoint = makeIdlePoint(row, counter);
  	  	      }
  	  	    };

  	  	    const closeActive = () => {
  	  	      if (!active) return;

  	  	      const maxSec = toNum(active.maxCounter);
  	  	      const maxPoint = active.maxPoint;
  	  	      if (maxSec == null || !maxPoint || maxSec < Math.max(0, idleLimitSec || 0)) {
  	  	        stats.discardedShort++;
  	  	        active = null;
  	  	        return;
  	  	      }

  	  	      // The counter tells us the event's actual age. Deriving the start from
  	  	      // the highest counter is more accurate than relying on the first packet,
  	  	      // which may only arrive after 120 seconds.
  	  	      const endTs = toNum(maxPoint.timestamp);
  	  	      const derivedStartTs = endTs != null
  	  	        ? endTs - maxSec
  	  	        : active.firstRowTsSec;

  	  	      segments.push({
  	  	        start: derivedStartTs,
  	  	        start_iso: Number.isFinite(derivedStartTs)
  	  	          ? new Date(derivedStartTs * 1000).toISOString()
  	  	          : null,
  	  	        end: endTs,
  	  	        end_iso: Number.isFinite(endTs)
  	  	          ? new Date(endTs * 1000).toISOString()
  	  	          : null,
  	  	        idle_seconds: Math.round(maxSec),
  	  	        idle_human: humanDuration(maxSec),
  	  	        source: 'flespi.idle.total',
  	  	        // Exactly one map marker: the packet containing the greatest value
  	  	        // reached by idle.total during this Flespi interval.
  	  	        Points: [maxPoint]
  	  	      });

  	  	      active = null;
  	  	    };

  	  	    for (const row of sourceLogs) {
  	  	      const stateRaw = readFirstDefined(row, stateFields);
  	  	      const counter = readCounter(row);

  	  	      // A packet with no Flespi idle state is not an idle=false transition.
  	  	      // Ignore it so unrelated telemetry packets cannot split an interval.
  	  	      if (stateRaw === undefined || stateRaw === null) continue;

  	  	      const idleState = toBool(stateRaw);
  	  	      if (!idleState) {
  	  	        closeActive();
  	  	        continue;
  	  	      }

  	  	      stats.stateTrueRows++;

  	  	      if (!active) {
  	  	        startActive(row, counter);
  	  	      } else if (
  	  	        counter != null &&
  	  	        active.lastCounter != null &&
  	  	        counter < active.lastCounter - resetDropSec
  	  	      ) {
  	  	        // A falling cumulative counter means Flespi has started a new idle
  	  	        // interval even when the false transition packet was absent.
  	  	        stats.counterResets++;
  	  	        closeActive();
  	  	        startActive(row, counter);
  	  	      }

  	  	      updateActive(row, counter);
  	  	    }

  	  	    closeActive();
  	  	    return { segments, stats };
  	  	  }

  	  	  // ---------- main loop ----------
  	  	  const debug = {};
  	  	  const eventsOut = {};
  	  	  if (!isObj(Tractor.Events)) Tractor.Events = {};
  	  	  const logsCount = logs.length;

  	  	  for (const rule of CAN.Events) {
  	  	    if (!isObj(rule) || !rule.name) continue;

  	  	    // enabled (supports {$ref:"#/..."} or boolean)
  	  	    let enabled = true;
  	  	    if (own(rule, 'enabled')) enabled = toBool(resolveRef(CAN, rule.enabled));
  	  	    debug[rule.name] = {
  	  	      rows: logsCount,
  	  	      gatePass: 0,
  	  	      testPass: 0,
  	  	      segments: 0,
  	  	      discardedShort: 0,
  	  	      missingField: 0
  	  	    };
  	  	    if (!enabled) {
  	  	      Tractor.Events[rule.name] = []; eventsOut[rule.name] = []; continue;
  	  	    }

  	  	    // Idle is deliberately handled outside the generic event segmenter.
  	  	    // Flespi owns the state and duration; we only collapse each interval to
  	  	    // the single packet holding its highest idle.total value.
  	  	    if (rule.name === "Idle Event") {
  	  	      const built = buildFlespiIdleEvents(logs, rule, tractorIdleLimitSec);
  	  	      debug[rule.name].gatePass = built.stats.stateTrueRows;
  	  	      debug[rule.name].testPass = built.stats.counterRows;
  	  	      debug[rule.name].segments = built.segments.length;
  	  	      debug[rule.name].discardedShort = built.stats.discardedShort;
  	  	      debug[rule.name].counterResets = built.stats.counterResets;
  	  	      Tractor.Events[rule.name] = built.segments;
  	  	      eventsOut[rule.name] = built.segments;
  	  	      continue;
  	  	    }

  	  	    // segmentation
  	  	    const seg = rule.segmentation || {};
  	  	    const isIdleRule = rule.name === "Idle Event";
  	  	    // Flespi already determines idling. For Idle Event, group its cumulative
  	  	    // counter readings into one event instead of flushing every reading.
  	  	    const enterWhen = isIdleRule
  	  	      ? 'test_passes'
  	  	      : (seg.enter_when || 'test_passes').toLowerCase();
  	  	    const exitWhen = isIdleRule
  	  	      ? 'test_fails'
  	  	      : (seg.exit_when || 'test_fails').toLowerCase();

  	  	    const maxGapSec = readSeconds(
  	  	      resolveRef(CAN, seg.max_gap_s) ?? seg.max_gap_s,
  	  	      resolveRef(CAN, seg.max_gap_ms) ?? seg.max_gap_ms,
  	  	      30
  	  	    );

  	  	    const minDurSec = readSeconds(
  	  	      resolveRef(CAN, seg.min_duration_s) ?? seg.min_duration_s,
  	  	      resolveRef(CAN, seg.min_duration_ms) ?? seg.min_duration_ms,
  	  	      0
  	  	    );

  	  	    const maxGapMs = maxGapSec * 1000;
  	  	    // Tracker packets in the supplied data occasionally land 31 seconds apart,
  	  	    // so the generic 30-second default splits one Flespi idle counter sequence.
  	  	    const idleMaxGapSec = readSeconds(
  	  	      resolveRef(CAN, seg.idle_max_gap_s) ?? seg.idle_max_gap_s,
  	  	      resolveRef(CAN, seg.idle_max_gap_ms) ?? seg.idle_max_gap_ms,
  	  	      90
  	  	    );
  	  	    const effectiveMaxGapMs = isIdleRule
  	  	      ? Math.max(maxGapMs, idleMaxGapSec * 1000)
  	  	      : maxGapMs;
  	  	    const minDurMs = minDurSec * 1000;
  	  	    // aggregation
  	  	    const agg = rule.aggregation || null;
  	  	    const valueFromPath = agg?.value_from || 'calc.signal';
  	  	    const wantAvg = agg?.metrics?.includes('avg');
  	  	    const wantMax = agg?.metrics?.includes('max');

  	  	    const ctx = {
  	  	      ruleName: rule.name,
  	  	      segments: [],
  	  	      curPts: [],
  	  	      aggSum: 0,
  	  	      aggMax: -Infinity,
  	  	      aggCount: 0,
  	  	      firstTs: null,
  	  	      lastTs: null,
  	  	      prevTs: null,
  	  	      distM: 0,
  	  	      prevLat: null,
  	  	      prevLon: null,
  	  	      minDurMs,
  	  	      idleLimitSec: isIdleRule ? tractorIdleLimitSec: 0,
  	  	      maxIdleTotal: null,
  	  	      maxIdlePoint: null
  	  	    };

  	  	    const dwellSec = readSeconds(stabDefaults.dwell_s, stabDefaults.dwell_ms, 0); // reserved
  	  	    const dwellMs = dwellSec * 1000; // reserved
  	  	    const hyst = toNum(stabDefaults.hysteresis) ?? 0; // reserved

  	  	    for (let i = 0; i < logs.length; i++) {
  	  	      const row = logs[i];
  	  	      const ts = row.__ts;

  	  	      // Flespi's idle counter is authoritative. Extra speed/ignition gates can
  	  	      // flicker and split one real idle into several false events.
  	  	      const gatesOk = isIdleRule ? true : gatesPass(row, rule.gates);
  	  	      if (!gatesOk) {
  	  	        if (exitWhen === 'either' || exitWhen === 'test_fails' || exitWhen === 'no_rebound_failed_or_test_fails') flushSeg(ctx, debug[rule.name]);
  	  	        continue;
  	  	      }
  	  	      debug[rule.name].gatePass++;

  	  	      if (ctx.prevTs != null && effectiveMaxGapMs > 0 && (ts - ctx.prevTs) > effectiveMaxGapMs) {
  	  	        flushSeg(ctx, debug[rule.name]);
  	  	      }
  	  	      ctx.prevTs = ts;

  	  	      const calc = rule.calc || {};
  	  	      const sigSpec = calc.signal || {
  	  	        fn: 'value',
  	  	        field: rule.field
  	  	      };
  	  	      const sigFn = valueFns[sigSpec.fn || 'value'] || valueFns.value;
  	  	      const sigVal = sigFn(row, sigSpec, {
  	  	        idx: i, logs
  	  	      });

  	  	      const testSpec = calc.test || {
  	  	        op: 'truthy'
  	  	      };
  	  	      let testPass = false;
  	  	      const op = (testSpec.op || 'truthy').toLowerCase();
  	  	      if (op === 'time_between') {
  	  	        testPass = opTest['time_between'](row, {
  	  	          lo: resolveRef(CAN, testSpec.lo), hi: resolveRef(CAN, testSpec.hi)
  	  	        }, testSpec.field || 'localtime');
  	  	      } else if (op === 'between') {
  	  	        testPass = opTest['between'](sigVal, {
  	  	          lo: resolveRef(CAN, testSpec.lo), hi: resolveRef(CAN, testSpec.hi)
  	  	        });
  	  	      } else if (op === 'cycles') {
  	  	        const thr = resolveRef(CAN, testSpec.threshold) ?? testSpec.threshold;
  	  	        testPass = opTest['cycles'](sigVal, thr);
  	  	      } else {
  	  	        const thr = resolveRef(CAN, testSpec.threshold) ?? resolveRef(CAN, testSpec.thresholdRef) ?? testSpec.threshold;
  	  	        const cmp = opTest[op] || opTest['truthy'];
  	  	        testPass = cmp(sigVal, thr);
  	  	      }
  	  	      if (testPass) debug[rule.name].testPass++;

  	  	      // stability (no_rebound)
  	  	      let stabilityOk = true;
  	  	      if (isObj(calc.stability) && isObj(calc.stability.no_rebound) && testPass) {
  	  	        const winS = toNum(calc.stability.no_rebound.window_s) ?? 180;
  	  	        const tolP = toNum(calc.stability.no_rebound.tolerance_pct) ?? 20;
  	  	        const until = ts + winS*1000;
  	  	        for (let j = i+1; j < logs.length && logs[j].__ts <= until; j++) {
  	  	          const vj = sigFn(logs[j], sigSpec, {
  	  	            idx: j, logs
  	  	          });
  	  	          if (toNum(vj) != null && toNum(sigVal) != null) {
  	  	            const rebound = (vj >= sigVal*(1 - tolP/100));
  	  	            if (rebound) {
  	  	              stabilityOk = false; break;
  	  	            }
  	  	          }
  	  	        }
  	  	      }

  	  	      const nowPass = gatesOk && testPass && stabilityOk;

  	  	      // The Idle Event signal is the Flespi state (idle.status / idle).
  	  	      // The duration comes separately from idle.total. Keep those two jobs
  	  	      // separate so a boolean state is never mistaken for the duration.
  	  	      const aggVal = valueFromPath === 'calc.signal'
  	  	        ? sigVal
  	  	        : (byPath({
  	  	            calc: { signal: sigVal }
  	  	          }, valueFromPath) ?? byPath(row, valueFromPath));
  	  	      const idleCounterNow = isIdleRule ? toNum(aggVal) : null;

  	  	      // A positive falling counter while Flespi still says idle means a new
  	  	      // Flespi idle event has begun without an intervening false packet.
  	  	      if (isIdleRule && nowPass && ctx.curPts.length) {
  	  	        const idleMax = toNum(ctx.maxIdleTotal);
  	  	        if (idleCounterNow != null && idleCounterNow > 0 &&
  	  	            idleMax != null && idleCounterNow < idleMax) {
  	  	          flushSeg(ctx, debug[rule.name]);
  	  	        }
  	  	      }

  	  	      // For Idle Event points, store idle.total as the point value. For every
  	  	      // other rule, retain the calculated signal value.
  	  	      const pointValue = isIdleRule && idleCounterNow != null
  	  	        ? idleCounterNow
  	  	        : sigVal;

  	  	      // aggregation
  	  	      const doAgg = () => {
  	  	        const n = toNum(aggVal);

  	  	        if (isIdleRule && n != null && n >= 0) {
  	  	          if (ctx.maxIdleTotal == null || n >= ctx.maxIdleTotal) {
  	  	            ctx.maxIdleTotal = n;
  	  	            const currentPoint = ctx.curPts.length
  	  	              ? ctx.curPts[ctx.curPts.length - 1]
  	  	              : null;
  	  	            ctx.maxIdlePoint = currentPoint
  	  	              ? JSON.parse(JSON.stringify(currentPoint))
  	  	              : null;
  	  	          }
  	  	        }

  	  	        if (n != null) {
  	  	          // --- Handle Fuel Gain/Loss as pure change (sum only)
  	  	          if (rule.name === "Fuel Gain (Refuel)" || rule.name === "Fuel Loss") {
  	  	            if (ctx.startVal == null) ctx.startVal = n;
  	  	            ctx.lastVal = n;
  	  	          } else {
  	  	            if (wantAvg) {
  	  	              ctx.aggSum += n;
  	  	              ctx.aggCount++;
  	  	            }
  	  	            if (wantMax && n > ctx.aggMax) ctx.aggMax = n;
  	  	          }
  	  	        }
  	  	      };



  	  	      // segmentation
  	  	      if (!isIdleRule && (rule.segmentation?.enter_when || '').toLowerCase() === 'immediate' && nowPass) {
  	  	        pushPoint(ctx, row, pointValue); stepDistance(ctx, row, logs[i-1]); doAgg(); flushSeg(ctx, debug[rule.name]); continue;
  	  	      }
  	  	      if (!ctx.curPts.length) {
  	  	        if ((['test_passes', 'both'].includes(enterWhen)) && nowPass) {
  	  	          pushPoint(ctx, row, pointValue); stepDistance(ctx, row, logs[i-1]); doAgg(); continue;
  	  	        }
  	  	      } else {
  	  	        if ((exitWhen === 'test_fails' && !nowPass) ||
  	  	          (exitWhen === 'either' && (!gatesOk || !testPass)) ||
  	  	          (exitWhen === 'no_rebound_failed_or_test_fails' && (!testPass || !stabilityOk)) ||
  	  	          (exitWhen === 'stabilized' && !nowPass)) {
  	  	          flushSeg(ctx, debug[rule.name]); continue;
  	  	        }
  	  	        pushPoint(ctx, row, pointValue); stepDistance(ctx, row, logs[i-1]); doAgg();
  	  	      }
  	  	    } // logs loop

  	  	    flushSeg(ctx, debug[rule.name]);
  	  	    debug[rule.name].segments = ctx.segments.length;
  	  	    Tractor.Events[rule.name] = ctx.segments;
  	  	    eventsOut[rule.name] = ctx.segments;
  	  	  }

  	  	  // ===== FleetInForm In/Out Event Engine v11 (Bidirectional SmartFuel) =====
  	  	  try {
  	  	    const toPlain = v => JSON.parse(JSON.stringify(v));
  	  	    const toRad = x => (x * Math.PI) / 180;
  	  	    const haversineM = (a, b) => {
  	  	      const R = 6371000;
  	  	      const dLat = toRad(b.lat - a.lat);
  	  	      const dLon = toRad(b.lon - a.lon);
  	  	      const sLat = Math.sin(dLat / 2);
  	  	      const sLon = Math.sin(dLon / 2);
  	  	      const cLatA = Math.cos(toRad(a.lat));
  	  	      const cLatB = Math.cos(toRad(b.lat));
  	  	      const aVal = sLat * sLat + cLatA * cLatB * sLon * sLon;
  	  	      return 2 * R * Math.atan2(Math.sqrt(aVal), Math.sqrt(1 - aVal));
  	  	    };

  	  	    // ---------- Polygon helpers ----------
  	  	    function normalizePolygon(poly) {
  	  	      if (!poly || !poly.coordinates) return [];
  	  	      let rings = poly.coordinates;
  	  	      if (Array.isArray(rings[0]) && Array.isArray(rings[0][0]) && Array.isArray(rings[0][0][0])) rings = rings[0];
  	  	      return rings
  	  	      .map(ring =>
  	  	        ring
  	  	        .filter(p => Array.isArray(p) && p.length >= 2)
  	  	        .map(p => [Number(p[0]), Number(p[1])])
  	  	        .filter(p => Number.isFinite(p[0]) && Number.isFinite(p[1]))
  	  	      )
  	  	      .filter(r => r.length >= 3);
  	  	    }

  	  	    function pointInRing(lon, lat, ring) {
  	  	      let inside = false;
  	  	      for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
  	  	        const [xi,
  	  	          yi] = ring[i];
  	  	        const [xj,
  	  	          yj] = ring[j];
  	  	        const intersect =
  	  	        (yi > lat) !== (yj > lat) && lon < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
  	  	        if (intersect) inside = !inside;
  	  	      }
  	  	      return inside;
  	  	    }

  	  	    function pointInPolygon(lon, lat, rings) {
  	  	      if (!rings?.length) return false;
  	  	      if (!pointInRing(lon, lat, rings[0])) return false;
  	  	      for (let k = 1; k < rings.length; k++) if (pointInRing(lon, lat, rings[k])) return false;
  	  	      return true;
  	  	    }

  	  	    // ---------- Smart Fuel Metric (multi-source fallback) ----------
  	  	    function getFuelMetric(r) {
  	  	      if (!r || typeof r !== "object") return {
  	  	        val: null,
  	  	        src: null
  	  	      };
  	  	      const keys = [
  	  	        "can.tracker.counted.fuel.consumed",
  	  	        "can.fuel.consumed",
  	  	        "can.fuel.used",
  	  	        "can.fuel.liters",
  	  	        "gps.fuel.used"
  	  	      ];

  	  	      for (const k of keys) {
  	  	        const v = Number(r[k]);
  	  	        if (Number.isFinite(v)) return {
  	  	          val: v,
  	  	          src: k
  	  	        };
  	  	      }
  	  	      return {
  	  	        val: null,
  	  	        src: null
  	  	      };
  	  	    }

  	  	    function getFuelLevelPct(r, tankCap) {
  	  	      const pct = Number(r["can.fuel.level"]);
  	  	      if (Number.isFinite(pct) && pct >= 0 && pct <= 100) return pct;

  	  	      const vol = Number(r["can.fuel.volume"]);
  	  	      if (Number.isFinite(vol) && Number.isFinite(tankCap) && tankCap > 0) {
  	  	        return Math.min(100, Math.max(0, (vol / tankCap) * 100));
  	  	      }
  	  	      return null;
  	  	    }

  	  	    // ---------- Trailer label helpers ----------
  	  	    function uniquePush(list, v) {
  	  	      if (!list) return;
  	  	      if (v == null) return;
  	  	      var s = String(v);
  	  	      if (list.indexOf(s) === -1) list.push(s);
  	  	    }

  	  	    function getTrailerLabelsFromPoint(p, lookup) {
  	  	      var out = [];
  	  	      if (!p || typeof p !== "object") return out;

  	  	      var beacons = p.ble && Array.isArray(p.ble.beacons) ? p.ble.beacons: [];
  	  	      for (var i = 0; i < beacons.length; i++) {
  	  	        var b = beacons[i];
  	  	        var id = b && b.id != null ? String(b.id): null;
  	  	        if (!id) continue;

  	  	        var label = lookup && lookup[id] ? lookup[id]: null;
  	  	        if (label) uniquePush(out, label);
  	  	      }
  	  	      return out;
  	  	    }

  	  	    const calcDistance = (pts) => {
  	  	      let d = 0;
  	  	      for (let i = 1; i < pts.length; i++) {
  	  	        const a = pts[i - 1];
  	  	        const b = pts[i];
  	  	        const A = {
  	  	          lat: Number(a["position.latitude"]),
  	  	          lon: Number(a["position.longitude"])
  	  	        };
  	  	        const B = {
  	  	          lat: Number(b["position.latitude"]),
  	  	          lon: Number(b["position.longitude"])
  	  	        };
  	  	        if (Number.isFinite(A.lat) && Number.isFinite(A.lon) && Number.isFinite(B.lat) && Number.isFinite(B.lon))
  	  	          d += haversineM(A, B);
  	  	      }
  	  	      return d;
  	  	    };

  	  	    // ---------- Data Prep ----------
  	  	    const locations = Array.isArray(Locations) ? Locations.map(toPlain): [];
  	  	    const track = Array.isArray(Tractor.Tracking) ? Tractor.Tracking.map(toPlain): [];
  	  	    if (!track.length) return;

  	  	    const geos = locations.map(loc => ({
  	  	      Name: loc.Name || loc.ID,
  	  	      ID: loc.ID,
  	  	      Location: loc,
  	  	      Rings: normalizePolygon(loc.Polygon || loc.GeoFences || loc["Geo Fences"]),
  	  	      inside: false,
  	  	      activeVisit: null
  	  	    }));

  	  	    // ---------- Trailer lookup (EYEID -> "Application - Registration") ----------
  	  	    var trailerLabelByEyeId = {};

  	  	    try {
  	  	      var companies = (AppData && AppData.User && AppData.User.Companies) ? AppData.User.Companies: [];
  	  	      for (var ci = 0; ci < companies.length; ci++) {
  	  	        var comp = companies[ci];
  	  	        var trailers = comp && comp.Trailers ? comp.Trailers: [];
  	  	        for (var ti = 0; ti < trailers.length; ti++) {
  	  	          var tr = trailers[ti];
  	  	          var eye = tr ? tr.EYEID: null;
  	  	          if (!eye) continue;

  	  	          var app = tr.Application != null ? String(tr.Application): "";
  	  	          var reg = tr.Registration != null ? String(tr.Registration): "";

  	  	          var label = (app && reg) ? (app + " - " + reg): (app ? app: (reg ? reg: (tr.ID != null ? String(tr.ID): String(eye))));

  	  	          trailerLabelByEyeId[String(eye)] = label;
  	  	        }
  	  	      }
  	  	    } catch (e) {
  	  	      trailerLabelByEyeId = {};
  	  	    }

  	  	    const finalEvents = [];

  	  	    // ---------- Main Loop ----------
  	  	    for (let i = 0; i < track.length; i++) {
  	  	      const p = track[i];
  	  	      const lat = Number(p["position.latitude"]);
  	  	      const lon = Number(p["position.longitude"]);
  	  	      const ts = Number(p.timestamp);
  	  	      if (!Number.isFinite(lat) || !Number.isFinite(lon) || !Number.isFinite(ts)) continue;

  	  	      for (const g of geos) {
  	  	        if (!g.Rings.length) continue;
  	  	        const inside = pointInPolygon(lon, lat, g.Rings);

  	  	        // ENTER event
  	  	        if (!g.inside && inside) {
  	  	          g.inside = true;
  	  	          const fuel = getFuelMetric(p);
  	  	          g.activeVisit = {
  	  	            type: (i === 0 ? "Started In Location": "Entered Location"),
  	  	            Name: g.Name,
  	  	            Location: g.Location,
  	  	            lat_in: lat,
  	  	            lon_in: lon,
  	  	            ts_in: ts,
  	  	            time_in: new Date(ts * 1000).toISOString(),
  	  	            fuel_in: fuel.val,
  	  	            fuel_src: fuel.src,

  	  	            // ✅ NEW: trailers seen during this visit (Application - Registration)
  	  	            trailers: getTrailerLabelsFromPoint(p, trailerLabelByEyeId),

  	  	            points: [p]
  	  	          };
  	  	        }

  	  	        // STILL INSIDE
  	  	        else if (g.inside && inside && g.activeVisit) {
  	  	          g.activeVisit.points.push(p);

  	  	          // ✅ NEW: accumulate trailers while inside zone
  	  	          var tLabs = getTrailerLabelsFromPoint(p, trailerLabelByEyeId);
  	  	          for (var tt = 0; tt < tLabs.length; tt++) {
  	  	            uniquePush(g.activeVisit.trailers, tLabs[tt]);
  	  	          }

  	  	          // Forward capture for missing fuel_in
  	  	          if (!Number.isFinite(g.activeVisit.fuel_in)) {
  	  	            const fNow = getFuelMetric(p);
  	  	            if (Number.isFinite(fNow.val)) {
  	  	              g.activeVisit.fuel_in = fNow.val;
  	  	              g.activeVisit.fuel_src = fNow.src;
  	  	            }
  	  	          }
  	  	        }

  	  	        // EXIT event
  	  	        else if (g.inside && !inside && g.activeVisit) {
  	  	          const last = g.activeVisit.points[g.activeVisit.points.length - 1] || p;
  	  	          const tsOut = Number(last.timestamp) || ts;
  	  	          const durationSec = tsOut - g.activeVisit.ts_in;
  	  	          const distM = calcDistance(g.activeVisit.points);

  	  	          // --- Fuel recovery logic ---
  	  	          const fStart = getFuelMetric(g.activeVisit.points.find(r => getFuelMetric(r).val != null) || {});
  	  	          let fEnd = getFuelMetric(last);
  	  	          if (!Number.isFinite(fEnd.val)) {
  	  	            // reverse-search last valid fuel reading in zone
  	  	            for (let j = g.activeVisit.points.length - 1; j >= 0; j--) {
  	  	              const tryF = getFuelMetric(g.activeVisit.points[j]);
  	  	              if (Number.isFinite(tryF.val)) {
  	  	                fEnd = tryF; break;
  	  	              }
  	  	            }
  	  	          }

  	  	          let fuelUsed = (Number.isFinite(fStart.val) && Number.isFinite(fEnd.val))
  	  	          ? (fEnd.val - fStart.val): null;

  	  	          // --- Fuel fallback: use level% drop if consumed isn't available ---
  	  	          if (!Number.isFinite(fuelUsed)) {
  	  	            const tankCap = Number(Tractor?.CAN?.Tank);
  	  	            if (Number.isFinite(tankCap) && tankCap > 0) {
  	  	              const pStart = getFuelLevelPct(g.activeVisit.points[0], tankCap);
  	  	              const pEnd = getFuelLevelPct(last, tankCap);
  	  	              if (Number.isFinite(pStart) && Number.isFinite(pEnd)) {
  	  	                const liters = ((pStart - pEnd) / 100) * tankCap;
  	  	                if (Number.isFinite(liters) && liters > 0) fuelUsed = liters;
  	  	              }
  	  	            }
  	  	          }


  	  	          const distKm = distM / 1000;
  	  	          const kmPerL = (fuelUsed && fuelUsed > 0) ? distKm / fuelUsed: null;
  	  	          const LperH = (fuelUsed && durationSec > 0) ? (fuelUsed / (durationSec / 3600)): null;

  	  	          g.activeVisit = {
  	  	            ...g.activeVisit,
  	  	            type_out: "Left Location",
  	  	            ts_out: tsOut,
  	  	            time_out: new Date(tsOut * 1000).toISOString(),
  	  	            lat_out: Number(last["position.latitude"]) || lat,
  	  	            lon_out: Number(last["position.longitude"]) || lon,
  	  	            duration_sec: durationSec,
  	  	            distance_m: distM,
  	  	            fuel_out: fEnd.val,
  	  	            fuel_src_out: fEnd.src,
  	  	            fuel_used: fuelUsed,
  	  	            km_per_litre: kmPerL,
  	  	            litres_per_hour: LperH
  	  	          };

  	  	          finalEvents.push(g.activeVisit);
  	  	          g.inside = false;
  	  	          g.activeVisit = null;
  	  	        }
  	  	      }
  	  	    }

  	  	    // ---------- Close still-active zones ----------
  	  	    const last = track[track.length - 1];
  	  	    const lastTs = Number(last.timestamp);
  	  	    for (const g of geos) {
  	  	      if (g.inside && g.activeVisit) {
  	  	        const durationSec = lastTs - g.activeVisit.ts_in;
  	  	        const distM = calcDistance(g.activeVisit.points);

  	  	        const fStart = getFuelMetric(g.activeVisit.points.find(r => getFuelMetric(r).val != null) || {});
  	  	        let fEnd = getFuelMetric(last);
  	  	        if (!Number.isFinite(fEnd.val)) {
  	  	          for (let j = g.activeVisit.points.length - 1; j >= 0; j--) {
  	  	            const tryF = getFuelMetric(g.activeVisit.points[j]);
  	  	            if (Number.isFinite(tryF.val)) {
  	  	              fEnd = tryF; break;
  	  	            }
  	  	          }
  	  	        }

  	  	        let fuelUsed = (Number.isFinite(fStart.val) && Number.isFinite(fEnd.val))
  	  	        ? (fEnd.val - fStart.val): null;

  	  	        // --- Fuel fallback: use level% drop if consumed isn't available ---
  	  	        if (!Number.isFinite(fuelUsed)) {
  	  	          const tankCap = Number(Tractor?.CAN?.Tank);
  	  	          if (Number.isFinite(tankCap) && tankCap > 0) {
  	  	            const pStart = getFuelLevelPct(g.activeVisit.points[0], tankCap);
  	  	            const pEnd = getFuelLevelPct(last, tankCap);
  	  	            if (Number.isFinite(pStart) && Number.isFinite(pEnd)) {
  	  	              const liters = ((pStart - pEnd) / 100) * tankCap;
  	  	              if (Number.isFinite(liters) && liters > 0) fuelUsed = liters;
  	  	            }
  	  	          }
  	  	        }


  	  	        const distKm = distM / 1000;
  	  	        const kmPerL = (fuelUsed && fuelUsed > 0) ? distKm / fuelUsed: null;
  	  	        const LperH = (fuelUsed && durationSec > 0) ? (fuelUsed / (durationSec / 3600)): null;

  	  	        g.activeVisit = {
  	  	          ...g.activeVisit,
  	  	          type_out: "In Location",
  	  	          ts_out: lastTs,
  	  	          time_out: new Date(lastTs * 1000).toISOString(),
  	  	          duration_sec: durationSec,
  	  	          distance_m: distM,
  	  	          fuel_out: fEnd.val,
  	  	          fuel_src_out: fEnd.src,
  	  	          fuel_used: fuelUsed,
  	  	          km_per_litre: kmPerL,
  	  	          litres_per_hour: LperH
  	  	        };

  	  	        finalEvents.push(g.activeVisit);
  	  	      }
  	  	    }

  	  	    Tractor.Events["Location Events"] = finalEvents;
  	  	    Tractor.CurrentLocation = geos.filter(g => g.inside).map(g => g.Name).join(", ") || null;


  	  	  } catch (err) {
  	  	    console.error("!!! In/Out Engine v11 Crash:", err);
  	  	    Tractor.Events["Location Events"] = [{
  	  	      error: String(err)
  	  	    }];
  	  	  }


  	  	  // ---------- compute Max summary (v4: flat-key safe) ----------
  	  	  const maxSummary = {
  	  	    MaxSpeed: 0,
  	  	    MaxRPM: 0,
  	  	    MaxTemp: 0,
  	  	    MaxThrottle: 0,
  	  	    // ✅ NEW
  	  	    TotalIdleSec: 0,
  	  	    TotalDistKm: 0,
  	  	    TotalFuelL: 0 // ✅ new field
  	  	  };

  	  	  // 1️⃣ Aggregate from event segments
  	  	  for (const [key, segs] of Object.entries(eventsOut)) {
  	  	    for (const s of segs) {
  	  	      if (s.Max != null) {
  	  	        if (/speed/i.test(key)) maxSummary.MaxSpeed = Math.max(maxSummary.MaxSpeed, s.Max);
  	  	        if (/rpm/i.test(key)) maxSummary.MaxRPM = Math.max(maxSummary.MaxRPM, s.Max);
  	  	        if (/temp|heat/i.test(key)) maxSummary.MaxTemp = Math.max(maxSummary.MaxTemp, s.Max);
  	  	        if (/throttle/i.test(key)) maxSummary.MaxThrottle = Math.max(maxSummary.MaxThrottle, s.Max);

  	  	      }

  	  	    }
  	  	  }

  	  	  // 2️⃣ Direct fallback verification from logs  — REPLACED (ES5-safe)
  	  	  if (Array.isArray(logs) && logs.length) {
  	  	    var distKm = 0;

  	  	    // --- Smart Distance Calculation (odometer → GPS fallback) ---
  	  	    var odoVals = [];
  	  	    for (var i = 0; i < logs.length; i++) {
  	  	      var od = toNum(logs[i]["can.vehicle.mileage"]);
  	  	      if (Number.isFinite(od)) odoVals.push(od);
  	  	    }

  	  	    if (odoVals.length >= 2) {
  	  	      distKm = Math.max(0, odoVals[odoVals.length - 1] - odoVals[0]);
  	  	    } else {
  	  	      var gpsVals = [];
  	  	      for (var j = 0; j < logs.length; j++) {
  	  	        var gvRaw = logs[j]["vehicle.mileage"] != null
  	  	        ? logs[j]["vehicle.mileage"]: (logs[j]["gps.odometer"] != null ? logs[j]["gps.odometer"]: logs[j]["gps.mileage"]);
  	  	        var gv = toNum(gvRaw);
  	  	        if (Number.isFinite(gv)) gpsVals.push(gv);
  	  	      }
  	  	      if (gpsVals.length >= 2) {
  	  	        distKm = Math.max(0, gpsVals[gpsVals.length - 1] - gpsVals[0]);
  	  	      }
  	  	    }

  	  	    // --- Update max metrics (speed/rpm/temp) ---
  	  	    for (var k = 0; k < logs.length; k++) {
  	  	      var rk = logs[k];
  	  	      var spd = toNum(rk.__spd != null ? rk.__spd: rk["position.speed"]);
  	  	      var rpm = toNum(rk["can.engine.rpm"]);
  	  	      var tmp = toNum(rk["can.engine.temperature"]);
  	  	      var thr = toNum(rk["can.throttle.pedal.level"]);
  	  	      if (Number.isFinite(spd)) maxSummary.MaxSpeed = Math.max(maxSummary.MaxSpeed, spd);
  	  	      if (Number.isFinite(rpm)) maxSummary.MaxRPM = Math.max(maxSummary.MaxRPM, rpm);
  	  	      if (Number.isFinite(tmp)) maxSummary.MaxTemp = Math.max(maxSummary.MaxTemp, tmp);
  	  	      if (Number.isFinite(thr)) maxSummary.MaxThrottle = Math.max(maxSummary.MaxThrottle, thr);
  	  	    }

  	  	    // --- Commit distance (do NOT also add event segment distances elsewhere) ---
  	  	    maxSummary.TotalDistKm += distKm;

  	  	    // --- ✅ Smart Fuel Consumed Aggregation (First+Last Valid CAN, fallback GPS) ---
  	  	    if (Array.isArray(logs) && logs.length) {
  	  	      const getFuelValue = (r, key) => {
  	  	        const v = Number(r[key]);
  	  	        return Number.isFinite(v) ? v: null;
  	  	      };

  	  	      // 1️⃣ Try CAN fuel.consumed
  	  	      const firstCan = logs.find(r => getFuelValue(r, "can.fuel.consumed") != null);
  	  	      const lastCan = [...logs].reverse().find(r => getFuelValue(r, "can.fuel.consumed") != null);

  	  	      if (firstCan && lastCan) {
  	  	        const start = getFuelValue(firstCan, "can.fuel.consumed");
  	  	        const end = getFuelValue(lastCan, "can.fuel.consumed");
  	  	        if (Number.isFinite(start) && Number.isFinite(end) && end >= start) {
  	  	          maxSummary.TotalFuelL = end - start;
  	  	        }
  	  	      } else {
  	  	        // 2️⃣ Fallback: gps.fuel.used
  	  	        const firstGps = logs.find(r => getFuelValue(r, "gps.fuel.used") != null);
  	  	        const lastGps = [...logs].reverse().find(r => getFuelValue(r, "gps.fuel.used") != null);
  	  	        if (firstGps && lastGps) {
  	  	          const start = getFuelValue(firstGps, "gps.fuel.used");
  	  	          const end = getFuelValue(lastGps, "gps.fuel.used");
  	  	          if (Number.isFinite(start) && Number.isFinite(end) && end >= start) {
  	  	            maxSummary.TotalFuelL = end - start;
  	  	          }
  	  	        }
  	  	      }
  	  	    }



  	  	    // --- IdleSec: prefer CAN "Idle Event" segments; else fall back once ---
  	  	    var idleSegs = eventsOut["Idle Event"];
  	  	    if (Array.isArray(idleSegs) && idleSegs.length) {
  	  	      for (var s = 0; s < idleSegs.length; s++) {
  	  	        var seg = idleSegs[s];
  	  	        if (seg && Number.isFinite(seg.idle_seconds)) {
  	  	          maxSummary.TotalIdleSec += seg.idle_seconds;
  	  	        }
  	  	      }
  	  	    } else {
  	  	      // Flespi is authoritative for idling. Do not infer idle from speed < 1:
  	  	      // a parked vehicle with the engine off is stationary, not idling.
  	  	      maxSummary.TotalIdleSec += 0;
  	  	    }
  	  	  }


  	  	  Tractor.Events.Max = {
  	  	    Speed: Math.round(maxSummary.MaxSpeed || 0),
  	  	    RPM: Math.round(maxSummary.MaxRPM || 0),
  	  	    Temp: Math.round(maxSummary.MaxTemp || 0),
  	  	    Throttle: Math.round(maxSummary.MaxThrottle || 0),
  	  	    IdleSec: Math.round(maxSummary.TotalIdleSec || 0),
  	  	    DistM: Math.round((maxSummary.TotalDistKm || 0) * 1000000) / 1000,
  	  	    DistKm: Math.round((maxSummary.TotalDistKm || 0) * 1000) / 1000,
  	  	    FuelL: Math.round((maxSummary.TotalFuelL || 0) * 1000) / 1000
  	  	  };

  	  	  // === MaxData (per-metric object with full original point data) ===
  	  	  (() => {
  	  	    if (!Array.isArray(logs) || !logs.length) return;

  	  	    const maxData = {};
  	  	    const maxVals = Tractor.Events.Max;

  	  	    // Helper: find all logs where metric matches its max
  	  	    const findFullPoints = (metric, maxVal) => {
  	  	      if (maxVal == null) return [];
  	  	      const matches = [];

  	  	      for (const r of logs) {
  	  	        const val =
  	  	        metric === "Speed" ? (r.__spd ?? r["position.speed"]):
  	  	        metric === "RPM" ? r["can.engine.rpm"]:
  	  	        metric === "Temp" ? r["can.engine.temperature"]:
  	  	        null;

  	  	        if (val != null && Math.round(val) === Math.round(maxVal)) {
  	  	          // Include the full raw record (cloned to avoid mutations)
  	  	          matches.push(JSON.parse(JSON.stringify(r)));
  	  	        }
  	  	      }
  	  	      return matches;
  	  	    };

  	  	    // Create per-metric objects with full data
  	  	    maxData.Speed = {
  	  	      value: maxVals.Speed,
  	  	      Points: findFullPoints("Speed", maxVals.Speed)
  	  	    };

  	  	    maxData.RPM = {
  	  	      value: maxVals.RPM,
  	  	      Points: findFullPoints("RPM", maxVals.RPM)
  	  	    };

  	  	    // === Throttle Overuse (pedal level max) ===
  	  	    maxData.Throttle = {
  	  	      value: maxVals.Throttle,
  	  	      Points: (() => {
  	  	        const matches = [];
  	  	        for (const r of logs) {
  	  	          const thr = toNum(r["can.throttle.pedal.level"]);
  	  	          if (thr != null && Math.round(thr) === Math.round(maxVals.Throttle)) {
  	  	            matches.push(JSON.parse(JSON.stringify(r)));
  	  	          }
  	  	        }
  	  	        return matches;
  	  	      })()
  	  	    };


  	  	    maxData.Temp = {
  	  	      value: maxVals.Temp,
  	  	      Points: findFullPoints("Temp",
  	  	        maxVals.Temp)
  	  	    };

  	  	    maxData.IdleSec = {
  	  	      value: maxVals.IdleSec,
  	  	      Points: [] // You can later tie this to Idle segments if you want
  	  	    };

  	  	    maxData.DistKm = {
  	  	      value: maxVals.DistKm,
  	  	      Points: [] // Derived from odometer/gps, no single point
  	  	    };

  	  	    maxData.FuelL = {
  	  	      value: maxVals.FuelL,
  	  	      Points: [] // Derived from first+last, no single point
  	  	    };

  	  	    Tractor.Events.MaxData = maxData;
  	  	  })();


  	  	  // 4️⃣ Optional formatted string
  	  	  const mins = Math.floor(maxSummary.TotalIdleSec / 60);
  	  	  const secs = Math.round(maxSummary.TotalIdleSec % 60);
  	  	  Tractor.Events.Max.IdleFmt = `${mins}m ${secs}s`;

  	  	  try {
  	  	    BackendlessUI?.App?.refresh?.();
  	  	  } catch {}

  	  	  return {
  	  	    ok: true,
  	  	    events: eventsOut,
  	  	    stats: {
  	  	      eventsDefined: CAN.Events.length,
  	  	      logsCount: logs.length
  	  	    },
  	  	    debug,
  	  	    errors: []
  	  	  };
  	  	})(Tractor, CAN, Locations, AppData);
  	  })((getObjectProperty(AppData, 'SelectedTractor')), (getObjectProperty((getObjectProperty(AppData, 'SelectedTractor')), 'CAN')), Locations, AppData);
  	  await (async function(Tractor) {
  	  	// === Colorize Tracking (Rog Mode v2 — Backendless Safe) ===
  	  	// Purpose: Annotates each Tractor.Tracking point with { color, events[] }
  	  	// Precedence: Red > Green > Yellow

  	  	(function colorizeTracking(Tractor) {
  	  	  if (!Tractor || !Array.isArray(Tractor.Tracking)) {
  	  	    console.warn('[ColorizeTracking] Missing Tractor.Tracking');
  	  	    return;
  	  	  }

  	  	  const redEvents = [
  	  	    'Speeding', 'Engine Over-Rev', 'Engine Over-Temperature', 'Throttle Overuse'
  	  	  ];
  	  	  const greenEvents = ['Green Band Driving'];
  	  	  const colorMap = { red: '#FF0000', green: '#00FF00', yellow: '#FFFF00' };

  	  	  // --- simple object lookup instead of Map ---
  	  	  const tsMap = {};

  	  	  // Collect event timestamps
  	  	  for (const [eventName, segs] of Object.entries(Tractor.Events || {})) {
  	  	    if (!Array.isArray(segs)) continue;
  	  	    const severity =
  	  	      redEvents.includes(eventName) ? 'red' :
  	  	      greenEvents.includes(eventName) ? 'green' : null;
  	  	    if (!severity) continue;

  	  	    for (const seg of segs) {
  	  	      if (!Array.isArray(seg.Points)) continue;
  	  	      for (const pt of seg.Points) {
  	  	        const ts = Number(pt.timestamp);
  	  	        if (!ts) continue;
  	  	        if (!tsMap[ts]) tsMap[ts] = { events: [], color: 'yellow' };

  	  	        // push unique event
  	  	        if (!tsMap[ts].events.includes(eventName)) tsMap[ts].events.push(eventName);

  	  	        // color precedence
  	  	        if (severity === 'red') tsMap[ts].color = 'red';
  	  	        else if (severity === 'green' && tsMap[ts].color !== 'red') tsMap[ts].color = 'green';
  	  	      }
  	  	    }
  	  	  }

  	  	  // Apply to Tracking[]
  	  	  let redCount = 0, greenCount = 0, yellowCount = 0;
  	  	  for (const row of Tractor.Tracking) {
  	  	    const ts = Number(row.timestamp);
  	  	    const found = tsMap[ts];
  	  	    if (found) {
  	  	      row.color = colorMap[found.color];
  	  	      row.events = found.events;
  	  	      if (found.color === 'red') redCount++;
  	  	      else if (found.color === 'green') greenCount++;
  	  	    } else {
  	  	      row.color = colorMap.yellow;
  	  	      row.events = [];
  	  	      yellowCount++;
  	  	    }
  	  	  }

  	  	 })(Tractor);

  	  })((getObjectProperty(AppData, 'SelectedTractor')));
  	  AppData['SpinnerMsg'] = 'Checking Map Status...';
  	  await (async function(Map) {
  	  	/*
  	  	Inputs: Map
  	  	Outputs:
  	  	  MapReady (boolean)
  	  	  MapObject (google.maps.Map)
  	  	  Wrapper (any)
  	  	  Element (DOM)
  	  	Purpose:
  	  	  - Resolves Google Map instance from any wrapper.
  	  	  - Waits for initialization (async safe).
  	  	  - Automatically cleans old markers/polylines/polygons.
  	  	*/

  	  	return (async () => {

  	  	  // === Tunables ===
  	  	  const TIMEOUT_MS = 10000;  // Max wait
  	  	  const STABLE_COUNT = 1;    // Require N consecutive good ticks

  	  	  // === Tiny utils ===
  	  	  const nextFrame = () => new Promise(r => requestAnimationFrame(r));
  	  	  const sleep = (ms) => new Promise(r => setTimeout(r, ms));
  	  	  const now = () => (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();

  	  	  const isGmAvailable = () =>
  	  	    typeof window !== "undefined" &&
  	  	    window.google && window.google.maps &&
  	  	    typeof window.google.maps.Map === "function";

  	  	  const tryImportMaps = async () => {
  	  	    try {
  	  	      if (window?.google?.maps?.importLibrary && !isGmAvailable()) {
  	  	        await Promise.race([
  	  	          window.google.maps.importLibrary("maps"),
  	  	          nextFrame()
  	  	        ]);
  	  	      }
  	  	    } catch (_) { /* ignore */ }
  	  	  };

  	  	  // === Core extractors ===
  	  	  const extractMap = (candidate) => {
  	  	    if (!candidate) return null;
  	  	    try {
  	  	      if (isGmAvailable() && candidate instanceof window.google.maps.Map) return candidate;

  	  	      const directCandidates = [];
  	  	      const push = (x) => { if (x) directCandidates.push(x); };

  	  	      push(candidate.map);
  	  	      if (typeof candidate.map === "function") push(candidate.map());
  	  	      push(candidate.map?.map);
  	  	      if (typeof candidate.map?.getMap === "function") push(candidate.map.getMap());
  	  	      if (typeof candidate.getMap === "function") push(candidate.getMap());
  	  	      push(candidate.googleMap);
  	  	      push(candidate.gMap);
  	  	      push(candidate.gmap);
  	  	      push(candidate.__map);
  	  	      push(candidate._map);
  	  	      push(candidate.api?.map);
  	  	      if (candidate.mapComponent?.getMap) push(candidate.mapComponent.getMap());
  	  	      push(candidate.$mapObject);
  	  	      push(candidate.$refs?.map?.$mapObject);

  	  	      for (const c of directCandidates) {
  	  	        if (!c) continue;
  	  	        if (isGmAvailable() && c instanceof window.google.maps.Map) return c;
  	  	        if (c && typeof c.getCenter === "function" && typeof c.panTo === "function") return c; // duck type
  	  	      }

  	  	      if (typeof candidate.getCenter === "function" && typeof candidate.panTo === "function") return candidate;
  	  	    } catch (_) {}
  	  	    return null;
  	  	  };

  	  	  const getEl = (candidate, mapInstance) => {
  	  	    try {
  	  	      if (!candidate) return mapInstance?.getDiv?.() || null;
  	  	      if (typeof candidate.el === "function") return candidate.el();
  	  	      if (candidate.el) return candidate.el;
  	  	      if (candidate.element) return candidate.element;
  	  	      if (candidate.$el) return candidate.$el;
  	  	      if (mapInstance?.getDiv) return mapInstance.getDiv();
  	  	    } catch (_) {}
  	  	    return null;
  	  	  };

  	  	  const isWrapperLikelyValid = (candidate) =>
  	  	    !!candidate && (("map" in candidate) || ("el" in candidate) || ("element" in candidate) || ("center" in candidate));

  	  	  // === Initial fast path ===
  	  	  let wrapper = Map;
  	  	  let mapInstance = extractMap(wrapper);
  	  	  let el = getEl(wrapper, mapInstance);

  	  	  if (mapInstance) {
  	  	    cleanMap(mapInstance);
  	  	    return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	  	  }

  	  	  tryImportMaps();
  	  	  const deadline = now() + TIMEOUT_MS;
  	  	  let stable = 0;

  	  	  // === Main wait loop ===
  	  	  while (now() < deadline) {
  	  	    if (!isWrapperLikelyValid(wrapper)) {
  	  	      if (document.hidden) await sleep(10); else await nextFrame();
  	  	      continue;
  	  	    }

  	  	    if (!isGmAvailable()) {
  	  	      if (document.hidden) await sleep(10); else await nextFrame();
  	  	      continue;
  	  	    }

  	  	    mapInstance = extractMap(wrapper);
  	  	    el = getEl(wrapper, mapInstance);
  	  	    const elOk = !el || !!el.isConnected || !!(el?.ownerDocument);

  	  	    if (mapInstance && elOk) {
  	  	      stable++;
  	  	      if (stable >= STABLE_COUNT) {
  	  	        cleanMap(mapInstance);
  	  	        return { MapReady: true, MapObject: mapInstance, Wrapper: wrapper, Element: el };
  	  	      }
  	  	    } else {
  	  	      stable = 0;
  	  	    }

  	  	    if (document.hidden) await sleep(10); else await nextFrame();
  	  	  }

  	  	  // === Timeout fallback ===
  	  	  console.warn("⚠️ Map Loader: Timed out waiting for map initialization.");
  	  	  return { MapReady: false, MapObject: mapInstance || null, Wrapper: wrapper || null, Element: el || null };


  	  	  // === Inner Cleaner Function ===
  	  	  function cleanMap(Map) {
  	  	    if (!Map || !isGmAvailable()) {
  	  	      console.warn("Map Cleaner: Map or Google Maps not initialized.");
  	  	      return;
  	  	    }

  	  	    const clear = (arrName) => {
  	  	      const arr = Map[arrName];
  	  	      if (arr && Array.isArray(arr)) {
  	  	        arr.forEach(i => { if (i?.setMap) i.setMap(null); });
  	  	        Map[arrName] = [];
  	  	      }
  	  	    };

  	  	    clear("_allMarkers");
  	  	    clear("_allPolylines");
  	  	    clear("_allPolygons");
  	  	    clear("_allOverlays");

  	  	    Map._selectedMarker = null;
  	  	    Map._popupInfoWindow = null;

  	  	    }

  	  	})();

  	  })(Map);
  	  await (async function(googleMapComponent, App, Locations, Images, Hub, SVG) {
  	  	// === Global CSS for Fuel Gauge Animations ===
  	  	if (!document.getElementById("fuelGaugeAnimations")) {
  	  	  const style = document.createElement("style");
  	  	  style.id = "fuelGaugeAnimations";
  	  	  style.textContent = `
  	  	  @keyframes fuelFill {
  	  	  from { width:0%; }
  	  	  to   { width:var(--target-width,100%); }
  	  	  }
  	  	  @keyframes fuelPulse {
  	  	  0% {
  	  	  box-shadow: 0 0 8px rgba(255, 0, 0, 0.9),
  	  	  0 0 14px rgba(255, 80, 0, 0.8);
  	  	  filter: drop-shadow(0 0 6px rgba(255, 50, 0, 0.9));
  	  	  opacity: 1;
  	  	  }
  	  	  50% {
  	  	  box-shadow: 0 0 20px rgba(255, 0, 0, 1),
  	  	  0 0 30px rgba(255, 80, 0, 0.9);
  	  	  filter: drop-shadow(0 0 14px rgba(255, 0, 0, 1));
  	  	  opacity: 0.8;
  	  	  }
  	  	  100% {
  	  	  box-shadow: 0 0 8px rgba(255, 0, 0, 0.9),
  	  	  0 0 14px rgba(255, 80, 0, 0.8);
  	  	  filter: drop-shadow(0 0 6px rgba(255, 50, 0, 0.9));
  	  	  opacity: 1;
  	  	  }
  	  	  }

  	  	  `;
  	  	  document.head.appendChild(style);
  	  	}

  	  	// === Global CSS: fadeIn for detached panel ===
  	  	if (!document.getElementById("rogFadeAnim")) {
  	  	  const style = document.createElement("style");
  	  	  style.id = "rogFadeAnim";
  	  	  style.textContent = `
  	  	  @keyframes fadeIn {
  	  	  from { opacity: 0; transform: translateY(-10px); }
  	  	  to   { opacity: 1; transform: translateY(0); }
  	  	  }`;
  	  	  document.head.appendChild(style);
  	  	}

  	  	// === Global CSS: Compare A/B marker labels ===
  	  	if (!document.getElementById("trackitCompareMarkerLabelCss")) {
  	  	  const style = document.createElement("style");
  	  	  style.id = "trackitCompareMarkerLabelCss";
  	  	  style.textContent = `
  	  	  .trackit-compare-marker-label {
  	  	  font-size: 26px !important;
  	  	  font-weight: 950 !important;
  	  	  color: #fff !important;
  	  	  text-shadow:
  	  	  -2px -2px 0 #000,
  	  	  2px -2px 0 #000,
  	  	  -2px  2px 0 #000,
  	  	  2px  2px 0 #000,
  	  	  0px  0px 8px #000,
  	  	  0px  0px 14px #000 !important;
  	  	  line-height: 1 !important;
  	  	  }
  	  	  `;
  	  	  document.head.appendChild(style);
  	  	}

  	  	// ======================================================================
  	  	// ============ TrackIT Compact Map Control - Standalone =================
  	  	// ======================================================================
  	  	// ======================================================================
  	  	// TrackIT Map Lifecycle Manager
  	  	// ======================================================================

  	  	function destroyFineTrackMapRuntime(map) {
  	  	  if (!map) return;

  	  	  // Stop an active Fine Track replay before removing its marker and controls.
  	  	  try {
  	  	    map.__fineTrackReplayCleanup?.();
  	  	  } catch (_) {}
  	  	  map.__fineTrackReplayCleanup = null;

  	  	  // --------------------------------------------------
  	  	  // Remove Google Maps event listeners
  	  	  // --------------------------------------------------

  	  	  if (Array.isArray(map.__fineTrackMapControlListeners)) {
  	  	    map.__fineTrackMapControlListeners.forEach(listener => {
  	  	      try {
  	  	        google.maps.event.removeListener(listener);
  	  	      } catch (_) {}
  	  	    });
  	  	  }

  	  	  map.__fineTrackMapControlListeners = [];

  	  	  // --------------------------------------------------
  	  	  // Remove DOM event listeners
  	  	  // --------------------------------------------------

  	  	  if (Array.isArray(map.__fineTrackDomControlListeners)) {
  	  	    map.__fineTrackDomControlListeners.forEach(record => {
  	  	      try {
  	  	        record?.target?.removeEventListener?.(
  	  	          record.event,
  	  	          record.handler,
  	  	          record.options
  	  	        );
  	  	      } catch (_) {}
  	  	    });
  	  	  }

  	  	  map.__fineTrackDomControlListeners = [];

  	  	  // --------------------------------------------------
  	  	  // Remove overlays created by this code
  	  	  // --------------------------------------------------

  	  	  if (Array.isArray(map.__fineTrackManagedOverlays)) {
  	  	    map.__fineTrackManagedOverlays.forEach(overlay => {
  	  	      try {
  	  	        overlay?.setMap?.(null);
  	  	      } catch (_) {}

  	  	      try {
  	  	        overlay?.close?.();
  	  	      } catch (_) {}
  	  	    });
  	  	  }

  	  	  map.__fineTrackManagedOverlays = [];

  	  	  // --------------------------------------------------
  	  	  // Remove managed DOM elements
  	  	  // --------------------------------------------------

  	  	  if (Array.isArray(map.__fineTrackManagedElements)) {
  	  	    map.__fineTrackManagedElements.forEach(element => {
  	  	      try {
  	  	        element?.remove?.();
  	  	      } catch (_) {}
  	  	    });
  	  	  }

  	  	  map.__fineTrackManagedElements = [];

  	  	  // --------------------------------------------------
  	  	  // Remove previous controls from this map only
  	  	  // --------------------------------------------------

  	  	  try {
  	  	    const mapDiv = map.getDiv?.();

  	  	    mapDiv
  	  	      ?.querySelectorAll?.(
  	  	        ".fine-track-compact-map-control," +
  	  	        "#fineTrackReplayPanel," +
  	  	        "#fineTrackReplayLauncher," +
  	  	        "#fineTrackDetachedPopup"
  	  	      )
  	  	      ?.forEach?.(element => {
  	  	        try {
  	  	          element.remove();
  	  	        } catch (_) {}
  	  	      });

  	  	    // The details panel is mounted on document.body, not inside the map.
  	  	    document.getElementById("fineTrackDetachedPopup")?.remove();
  	  	  } catch (_) {}

  	  	  // --------------------------------------------------
  	  	  // Remove controls inserted into Google control arrays
  	  	  // --------------------------------------------------

  	  	  try {
  	  	    const positions = [
  	  	      google.maps.ControlPosition.RIGHT_BOTTOM,
  	  	      google.maps.ControlPosition.LEFT_BOTTOM,
  	  	      google.maps.ControlPosition.RIGHT_TOP,
  	  	      google.maps.ControlPosition.LEFT_TOP
  	  	    ];

  	  	    positions.forEach(position => {
  	  	      const controls = map.controls?.[position];

  	  	      if (!controls) return;

  	  	      for (let index = controls.getLength() - 1; index >= 0; index--) {
  	  	        const item = controls.getAt(index);

  	  	        if (
  	  	          item?.__fineTrackUnifiedMapControl ||
  	  	          item?.dataset?.fineTrackMapControl
  	  	        ) {
  	  	          controls.removeAt(index);
  	  	        }
  	  	      }
  	  	    });
  	  	  } catch (_) {}

  	  	  // --------------------------------------------------
  	  	  // Remove comparison overlays
  	  	  // --------------------------------------------------

  	  	  try {
  	  	    window._fineTrackCompareOverlay?.setMap?.(null);
  	  	  } catch (_) {}

  	  	  try {
  	  	    window._fineTrackCompareOverlayPulse?.setMap?.(null);
  	  	  } catch (_) {}

  	  	  window._fineTrackCompareOverlay = null;
  	  	  window._fineTrackCompareOverlayPulse = null;

  	  	  if (window._fineTrackComparePulseTimer) {
  	  	    clearInterval(window._fineTrackComparePulseTimer);
  	  	    window._fineTrackComparePulseTimer = null;
  	  	  }

  	  	  // --------------------------------------------------
  	  	  // Remove stale global keyboard listener
  	  	  // --------------------------------------------------

  	  	  try {
  	  	    if (window._fineTrackKeyHandler) {
  	  	      window.removeEventListener(
  	  	        "keydown",
  	  	        window._fineTrackKeyHandler
  	  	      );
  	  	    }
  	  	  } catch (_) {}

  	  	  window._fineTrackKeyHandler = null;

  	  	  // --------------------------------------------------
  	  	  // Close stale information windows
  	  	  // --------------------------------------------------

  	  	  try {
  	  	    window._fineTrackWarnHubInfo?.close?.();
  	  	  } catch (_) {}

  	  	  window._fineTrackWarnHubInfo = null;

  	  	  // --------------------------------------------------
  	  	  // Reset map interaction
  	  	  // --------------------------------------------------

  	  	  try {
  	  	    map.setOptions({
  	  	      draggable: true,
  	  	      scrollwheel: true,
  	  	      disableDoubleClickZoom: false,
  	  	      keyboardShortcuts: true,
  	  	      gestureHandling: "auto",
  	  	      clickableIcons: true
  	  	    });

  	  	    map.getDiv().style.cursor = "";
  	  	  } catch (_) {}

  	  	  map.__fineTrackRoutePanelMapLocked = false;
  	  	  map.__fineTrackUnifiedMapControlReady = false;
  	  	  map.__fineTrackUnifiedMapControlVersion = "";
  	  	}

  	  	function registerFineTrackOverlay(map, overlay) {
  	  	  if (!map || !overlay) return overlay;

  	  	  if (!Array.isArray(map.__fineTrackManagedOverlays)) {
  	  	    map.__fineTrackManagedOverlays = [];
  	  	  }

  	  	  map.__fineTrackManagedOverlays.push(overlay);
  	  	  return overlay;
  	  	}

  	  	function registerFineTrackElement(map, element) {
  	  	  if (!map || !element) return element;

  	  	  if (!Array.isArray(map.__fineTrackManagedElements)) {
  	  	    map.__fineTrackManagedElements = [];
  	  	  }

  	  	  map.__fineTrackManagedElements.push(element);
  	  	  return element;
  	  	}

  	  	function addFineTrackUnifiedMapControl(map, App) {
  	  	  if (
  	  	    !map ||
  	  	    typeof google === "undefined" ||
  	  	    !(map instanceof google.maps.Map)
  	  	  ) {
  	  	    console.error("[TrackIT Map Controls] Invalid map.");
  	  	    return;
  	  	  }

  	  	  const CONTROL_VERSION =
  	  	    "trackit-map-control-route-v4-clean-lifecycle";

  	  	  /*
  	  	   * Always clear the previous runtime.
  	  	   *
  	  	   * Fine Track and Live Track may reuse the same map instance. The previous
  	  	   * version used an early return and retained stale controls and listeners.
  	  	   */
  	  	  destroyFineTrackMapRuntime(map);

  	  	  try {
  	  	    App?.FineTrackSelectedMarker?.setMap?.(null);
  	  	  } catch (_) {}

  	  	  if (App && typeof App === "object") {
  	  	    App.FineTrackSelectedMarker = null;
  	  	    App._tripReplayActive = false;
  	  	  }

  	  	  map.setOptions({
  	  	    mapTypeControl: false,
  	  	    zoomControl: false,
  	  	    fullscreenControl: false,
  	  	    rotateControl: false,
  	  	    scaleControl: false,
  	  	    streetViewControl: false,
  	  	    clickableIcons: true
  	  	  });

  	  	  try {
  	  	    const panorama = map.getStreetView();
  	  	    panorama.setVisible(false);
  	  	    panorama.setOptions({
  	  	      enableCloseButton: false,
  	  	      addressControl: false,
  	  	      fullscreenControl: false,
  	  	      panControl: false,
  	  	      zoomControl: false,
  	  	      linksControl: false
  	  	    });
  	  	  } catch (_) {}

  	  	  const mapDiv = map.getDiv ? map.getDiv(): null;

  	  	  try {
  	  	    const positions = [
  	  	      google.maps.ControlPosition.RIGHT_BOTTOM,
  	  	      google.maps.ControlPosition.LEFT_BOTTOM,
  	  	      google.maps.ControlPosition.RIGHT_TOP,
  	  	      google.maps.ControlPosition.LEFT_TOP
  	  	    ];

  	  	    positions.forEach(pos => {
  	  	      const controls = map.controls[pos];

  	  	      for (let i = controls.getLength() - 1; i >= 0; i--) {
  	  	        const item = controls.getAt(i);

  	  	        if (item?.__fineTrackUnifiedMapControl) {
  	  	          controls.removeAt(i);
  	  	        }
  	  	      }
  	  	    });
  	  	  } catch (_) {}

  	  	  try {
  	  	    mapDiv?.querySelectorAll?.(".fine-track-compact-map-control")?.forEach(node => node.remove());
  	  	  } catch (_) {}

  	  	  if (map.__fineTrackMapControlListeners) {
  	  	    map.__fineTrackMapControlListeners.forEach(listener => {
  	  	      try {
  	  	        google.maps.event.removeListener(listener);
  	  	      } catch (_) {}
  	  	    });
  	  	  }

  	  	  if (map.__fineTrackDomControlListeners) {
  	  	    map.__fineTrackDomControlListeners.forEach(({
  	  	      target, event, handler
  	  	    }) => {
  	  	      try {
  	  	        target.removeEventListener(event, handler);
  	  	      } catch (_) {}
  	  	    });
  	  	  }

  	  	  map.__fineTrackMapControlListeners = [];
  	  	  map.__fineTrackDomControlListeners = [];
  	  	  map.__fineTrackUnifiedMapControlReady = false;
  	  	  map.__fineTrackUnifiedMapControlVersion = "";

  	  	  function getAppBag() {
  	  	    if (App?.data && typeof App.data === "object") return App.data;
  	  	    if (App && typeof App === "object" && !("data" in App)) return App;

  	  	    if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	  	      return BackendlessUI.App.data;
  	  	    }

  	  	    if (typeof window !== "undefined" && window.AppData) {
  	  	      return window.AppData.data || window.AppData;
  	  	    }

  	  	    return null;
  	  	  }

  	  	  function refreshApp() {
  	  	    try {
  	  	      BackendlessUI?.App?.refresh?.();
  	  	    } catch (_) {}
  	  	  }

  	  	  function getSettingsBag() {
  	  	    const bag = getAppBag();

  	  	    if (bag) {
  	  	      if (!bag.FineTrackMapSettings) {
  	  	        bag.FineTrackMapSettings = {};
  	  	      }

  	  	      return bag.FineTrackMapSettings;
  	  	    }

  	  	    if (!map.__fineTrackLocalMapSettings) {
  	  	      map.__fineTrackLocalMapSettings = {};
  	  	    }

  	  	    return map.__fineTrackLocalMapSettings;
  	  	  }

  	  	  function writeSetting(key, value) {
  	  	  const settings = getSettingsBag();

  	  	  if (!settings || typeof settings !== "object") {
  	  	    return;
  	  	  }

  	  	  settings[key] = value;

  	  	  /*
  	  	   * These are client-side map preferences.
  	  	   *
  	  	   * Do not call BackendlessUI.App.refresh() here.
  	  	   * Refreshing the entire application rebuilds the map while the previous
  	  	   * Google Maps overlays and listeners are still alive.
  	  	   */
  	  	}

  	  	  function readSetting(key, fallback) {
  	  	    const settings = getSettingsBag();
  	  	    return settings[key] !== undefined ? settings[key]: fallback;
  	  	  }

  	  	  const NO_LABEL_STYLES = [{
  	  	    elementType: "labels",
  	  	    stylers: [{
  	  	      visibility: "off"
  	  	    }]
  	  	  },
  	  	    {
  	  	      featureType: "poi",
  	  	      stylers: [{
  	  	        visibility: "off"
  	  	      }]
  	  	    },
  	  	    {
  	  	      featureType: "transit",
  	  	      stylers: [{
  	  	        visibility: "off"
  	  	      }]
  	  	    }];

  	  	  const oldStyle = document.getElementById("fine-track-map-control-css");
  	  	  if (oldStyle) oldStyle.remove();

  	  	  const style = document.createElement("style");
  	  	  style.id = "fine-track-map-control-css";

  	  	  style.textContent = `
  	  	  .fine-track-compact-map-control.ces-bottom-shape {
  	  	  position: absolute !important;
  	  	  right: 0 !important;
  	  	  bottom: 0 !important;
  	  	  top: auto !important;
  	  	  z-index: 999999 !important;
  	  	  pointer-events: auto !important;
  	  	  box-sizing: border-box !important;
  	  	  color: #fff !important;
  	  	  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	  	  background:
  	  	  radial-gradient(circle at 18% 0%, rgba(255,133,49,0.16), transparent 32%),
  	  	  linear-gradient(145deg, rgba(16,17,16,0.985), rgba(3,7,7,0.99)) !important;
  	  	  border-top: 1px solid rgba(255,122,36,0.52) !important;
  	  	  border-left: 1px solid rgba(255,122,36,0.52) !important;
  	  	  border-right: 0 !important;
  	  	  border-bottom: 0 !important;
  	  	  box-shadow:
  	  	  -12px -16px 32px rgba(0,0,0,0.40),
  	  	  inset 0 1px 0 rgba(255,255,255,0.045),
  	  	  inset 0 -18px 38px rgba(0,0,0,0.24) !important;
  	  	  user-select: none !important;
  	  	  }

  	  	  .fine-track-compact-map-control.ces-bottom-shape:not(.collapsed) {
  	  	  width: 300px !important;
  	  	  min-width: 300px !important;
  	  	  max-width: 300px !important;
  	  	  }

  	  	  .fine-track-compact-map-control.ces-bottom-shape::before {
  	  	  content: "" !important;
  	  	  position: absolute !important;
  	  	  inset: 0 !important;
  	  	  pointer-events: none !important;
  	  	  z-index: 1 !important;
  	  	  opacity: 0.16 !important;
  	  	  background:
  	  	  repeating-radial-gradient(
  	  	  ellipse at 34% 118%,
  	  	  transparent 0,
  	  	  transparent 9px,
  	  	  rgba(255,116,34,0.20) 10px,
  	  	  transparent 12px
  	  	  ) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-bottom-content {
  	  	  position: relative !important;
  	  	  z-index: 2 !important;
  	  	  width: 100% !important;
  	  	  height: auto !important;
  	  	  padding: 10px 12px 12px 12px !important;
  	  	  box-sizing: border-box !important;
  	  	  }

  	  	  .fine-track-compact-map-control.collapsed .ces-bottom-content {
  	  	  padding: 9px 12px !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-header {
  	  	  width: 100% !important;
  	  	  height: 38px !important;
  	  	  border: 0 !important;
  	  	  outline: 0 !important;
  	  	  background: transparent !important;
  	  	  color: inherit !important;
  	  	  display: grid !important;
  	  	  grid-template-columns: 31px minmax(0, 1fr) 16px !important;
  	  	  align-items: center !important;
  	  	  gap: 8px !important;
  	  	  padding: 0 !important;
  	  	  margin: 0 !important;
  	  	  cursor: pointer !important;
  	  	  text-align: left !important;
  	  	  appearance: none !important;
  	  	  -webkit-appearance: none !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-layer-icon {
  	  	  width: 30px !important;
  	  	  height: 30px !important;
  	  	  border-radius: 12px !important;
  	  	  display: flex !important;
  	  	  flex-direction: column !important;
  	  	  align-items: center !important;
  	  	  justify-content: center !important;
  	  	  gap: 3px !important;
  	  	  background:
  	  	  radial-gradient(circle at 35% 22%, rgba(255,153,70,0.42), rgba(4,5,5,0.92) 72%) !important;
  	  	  border: 1px solid rgba(255,132,48,0.54) !important;
  	  	  box-shadow:
  	  	  0 0 15px rgba(255,122,36,0.18),
  	  	  inset 0 1px 0 rgba(255,255,255,0.10) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-layer-icon span {
  	  	  width: 14px !important;
  	  	  height: 2px !important;
  	  	  border-radius: 999px !important;
  	  	  background: #ff9a3d !important;
  	  	  box-shadow: 0 0 8px rgba(255,122,36,0.34) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-header-text {
  	  	  min-width: 0 !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-title {
  	  	  font-size: 11px !important;
  	  	  font-weight: 950 !important;
  	  	  letter-spacing: 0.10em !important;
  	  	  text-transform: uppercase !important;
  	  	  color: #ffe3c5 !important;
  	  	  line-height: 1 !important;
  	  	  white-space: nowrap !important;
  	  	  overflow: hidden !important;
  	  	  text-overflow: ellipsis !important;
  	  	  margin: 0 !important;
  	  	  padding: 0 !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-subtitle {
  	  	  margin: 4px 0 0 !important;
  	  	  padding: 0 !important;
  	  	  font-size: 7px !important;
  	  	  font-weight: 950 !important;
  	  	  letter-spacing: 0.13em !important;
  	  	  text-transform: uppercase !important;
  	  	  color: rgba(255,255,255,0.56) !important;
  	  	  line-height: 1 !important;
  	  	  white-space: nowrap !important;
  	  	  overflow: hidden !important;
  	  	  text-overflow: ellipsis !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-caret {
  	  	  color: #ff8a3c !important;
  	  	  font-size: 12px !important;
  	  	  font-weight: 950 !important;
  	  	  display: flex !important;
  	  	  align-items: center !important;
  	  	  justify-content: center !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-body {
  	  	  display: grid !important;
  	  	  grid-template-columns: minmax(0, 1fr) 56px !important;
  	  	  gap: 12px !important;
  	  	  align-items: start !important;
  	  	  margin-top: 12px !important;
  	  	  min-width: 0 !important;
  	  	  box-sizing: border-box !important;
  	  	  }

  	  	  .fine-track-compact-map-control.collapsed .ces-map-control-body {
  	  	  display: none !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-main {
  	  	  min-width: 0 !important;
  	  	  display: flex !important;
  	  	  flex-direction: column !important;
  	  	  gap: 12px !important;
  	  	  box-sizing: border-box !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-section {
  	  	  display: flex !important;
  	  	  flex-direction: column !important;
  	  	  gap: 7px !important;
  	  	  min-width: 0 !important;
  	  	  box-sizing: border-box !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-section-title {
  	  	  height: auto !important;
  	  	  min-height: 13px !important;
  	  	  display: flex !important;
  	  	  align-items: center !important;
  	  	  gap: 6px !important;
  	  	  color: rgba(255,232,208,0.78) !important;
  	  	  font-size: 8px !important;
  	  	  font-weight: 950 !important;
  	  	  letter-spacing: 0.12em !important;
  	  	  text-transform: uppercase !important;
  	  	  line-height: 1 !important;
  	  	  padding: 0 !important;
  	  	  margin: 0 !important;
  	  	  border: 0 !important;
  	  	  background: transparent !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-section-title svg {
  	  	  width: 13px !important;
  	  	  height: 13px !important;
  	  	  color: #ff8a3c !important;
  	  	  flex: 0 0 auto !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-tools {
  	  	  display: grid !important;
  	  	  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  	  	  grid-auto-rows: 38px !important;
  	  	  gap: 7px !important;
  	  	  min-width: 0 !important;
  	  	  box-sizing: border-box !important;
  	  	  }

  	  	  .fine-track-compact-map-control .fleet-map-type-tools {
  	  	  grid-template-columns: minmax(0, 1fr) !important;
  	  	  grid-auto-rows: 38px !important;
  	  	  }

  	  	  .fine-track-compact-map-control .fleet-map-type-tools .ces-map-control-tool {
  	  	  width: 100% !important;
  	  	  height: 36px !important;
  	  	  justify-content: flex-start !important;
  	  	  }

  	  	  .fine-track-compact-map-control .route-map-tools {
  	  	  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-tool {
  	  	  width: auto !important;
  	  	  height: 36px !important;
  	  	  min-width: 0 !important;
  	  	  border-radius: 13px !important;
  	  	  border: 1px solid rgba(255,255,255,0.10) !important;
  	  	  background:
  	  	  linear-gradient(145deg, rgba(255,255,255,0.055), rgba(255,255,255,0.018)) !important;
  	  	  color: rgba(255,255,255,0.78) !important;
  	  	  display: flex !important;
  	  	  align-items: center !important;
  	  	  justify-content: flex-start !important;
  	  	  gap: 8px !important;
  	  	  padding: 0 10px !important;
  	  	  box-sizing: border-box !important;
  	  	  cursor: pointer !important;
  	  	  font-size: 10px !important;
  	  	  font-weight: 950 !important;
  	  	  text-align: left !important;
  	  	  overflow: hidden !important;
  	  	  box-shadow:
  	  	  inset 0 0 0 1px rgba(255,255,255,0.025),
  	  	  0 7px 14px rgba(0,0,0,0.18) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-tool svg {
  	  	  width: 14px !important;
  	  	  height: 14px !important;
  	  	  color: rgba(255,255,255,0.78) !important;
  	  	  flex: 0 0 14px !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-tool span {
  	  	  min-width: 0 !important;
  	  	  overflow: hidden !important;
  	  	  text-overflow: ellipsis !important;
  	  	  white-space: nowrap !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-tool:hover {
  	  	  color: #fff !important;
  	  	  border-color: rgba(255,138,61,0.38) !important;
  	  	  background: rgba(255,138,61,0.10) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-tool.active,
  	  	  .fine-track-compact-map-control .ces-map-control-tool.fullscreen-active {
  	  	  color: #fff !important;
  	  	  border-color: rgba(255,138,61,0.62) !important;
  	  	  background:
  	  	  linear-gradient(145deg, rgba(255,122,36,0.28), rgba(95,42,17,0.32)) !important;
  	  	  box-shadow:
  	  	  inset 0 0 0 1px rgba(255,138,61,0.30),
  	  	  inset 0 0 18px rgba(255,105,25,0.12),
  	  	  0 7px 14px rgba(0,0,0,0.18) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-tool.active svg,
  	  	  .fine-track-compact-map-control .ces-map-control-tool.fullscreen-active svg {
  	  	  color: #ff9a3d !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-zoom-rail {
  	  	  width: 56px !important;
  	  	  min-width: 56px !important;
  	  	  height: 286px !important;
  	  	  min-height: 286px !important;
  	  	  max-height: 286px !important;
  	  	  display: grid !important;
  	  	  grid-template-rows: auto auto 32px 176px 32px !important;
  	  	  justify-items: center !important;
  	  	  align-items: center !important;
  	  	  box-sizing: border-box !important;
  	  	  align-self: start !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-zoom-label {
  	  	  color: rgba(255,232,208,0.78) !important;
  	  	  font-size: 8px !important;
  	  	  font-weight: 950 !important;
  	  	  letter-spacing: 0.12em !important;
  	  	  text-transform: uppercase !important;
  	  	  line-height: 1 !important;
  	  	  margin: 0 0 6px !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-zoom-value {
  	  	  width: 36px !important;
  	  	  height: 36px !important;
  	  	  border-radius: 999px !important;
  	  	  display: flex !important;
  	  	  align-items: center !important;
  	  	  justify-content: center !important;
  	  	  background:
  	  	  radial-gradient(circle at 40% 35%, rgba(255,255,255,0.22), rgba(25,25,25,0.88) 70%) !important;
  	  	  border: 2px solid rgba(255,122,39,0.68) !important;
  	  	  color: #fff !important;
  	  	  font-size: 12px !important;
  	  	  font-weight: 950 !important;
  	  	  box-shadow:
  	  	  0 0 10px rgba(255,105,25,0.24),
  	  	  inset 0 0 0 1px rgba(255,255,255,0.12) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-zoom-btn {
  	  	  width: 32px !important;
  	  	  height: 32px !important;
  	  	  border-radius: 999px !important;
  	  	  border: 1px solid rgba(255,255,255,0.12) !important;
  	  	  background: rgba(255,255,255,0.045) !important;
  	  	  color: #fff !important;
  	  	  cursor: pointer !important;
  	  	  font-weight: 950 !important;
  	  	  font-size: 16px !important;
  	  	  line-height: 1 !important;
  	  	  padding: 0 !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-zoom-btn:hover {
  	  	  background: rgba(255,111,29,0.16) !important;
  	  	  border-color: rgba(255,137,56,0.46) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-slider-wrap {
  	  	  position: relative !important;
  	  	  display: flex !important;
  	  	  align-items: center !important;
  	  	  justify-content: center !important;
  	  	  width: 100% !important;
  	  	  height: 176px !important;
  	  	  min-height: 176px !important;
  	  	  max-height: 176px !important;
  	  	  margin: 8px 0 !important;
  	  	  padding: 0 !important;
  	  	  box-sizing: border-box !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-slider-wrap::before {
  	  	  content: "" !important;
  	  	  position: absolute !important;
  	  	  top: 8px !important;
  	  	  bottom: 8px !important;
  	  	  left: 50% !important;
  	  	  width: 1px !important;
  	  	  transform: translateX(-50%) !important;
  	  	  background: repeating-linear-gradient(
  	  	  to bottom,
  	  	  rgba(255,255,255,0.18) 0,
  	  	  rgba(255,255,255,0.18) 1px,
  	  	  transparent 1px,
  	  	  transparent 8px
  	  	  ) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .ces-map-control-zoom-slider {
  	  	  position: relative !important;
  	  	  z-index: 1 !important;
  	  	  writing-mode: vertical-lr !important;
  	  	  direction: rtl !important;
  	  	  width: 26px !important;
  	  	  height: 176px !important;
  	  	  min-height: 176px !important;
  	  	  max-height: 176px !important;
  	  	  accent-color: #ff7928 !important;
  	  	  cursor: pointer !important;
  	  	  margin: 0 !important;
  	  	  padding: 0 !important;
  	  	  appearance: auto !important;
  	  	  -webkit-appearance: slider-vertical !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-card {
  	  	  border-radius: 15px !important;
  	  	  border: 1px solid rgba(255,255,255,0.105) !important;
  	  	  background:
  	  	  radial-gradient(circle at 18% 10%, rgba(255,120,35,0.10), transparent 38%),
  	  	  linear-gradient(145deg, rgba(255,255,255,0.050), rgba(255,255,255,0.018)) !important;
  	  	  overflow: hidden !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-head {
  	  	  width: 100% !important;
  	  	  height: 32px !important;
  	  	  border: none !important;
  	  	  outline: none !important;
  	  	  background: transparent !important;
  	  	  color: rgba(255,255,255,0.84) !important;
  	  	  display: flex !important;
  	  	  align-items: center !important;
  	  	  gap: 8px !important;
  	  	  cursor: pointer !important;
  	  	  padding: 0 10px !important;
  	  	  box-sizing: border-box !important;
  	  	  font-size: 10.5px !important;
  	  	  font-weight: 900 !important;
  	  	  text-align: left !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-head:hover {
  	  	  color: #fff !important;
  	  	  background: rgba(255,111,29,0.12) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-head svg {
  	  	  width: 15px !important;
  	  	  height: 15px !important;
  	  	  color: #ff7928 !important;
  	  	  flex: 0 0 15px !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-title {
  	  	  flex: 1 !important;
  	  	  white-space: nowrap !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-chevron {
  	  	  width: 8px !important;
  	  	  height: 8px !important;
  	  	  border-top: 2px solid #ff8a3c !important;
  	  	  border-left: 2px solid #ff8a3c !important;
  	  	  transform: rotate(45deg) !important;
  	  	  transition: transform 140ms ease !important;
  	  	  flex: 0 0 8px !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-card.legend-collapsed .trackit-compact-legend-chevron {
  	  	  transform: rotate(225deg) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-body {
  	  	  display: grid !important;
  	  	  gap: 6px !important;
  	  	  padding: 0 9px 9px 9px !important;
  	  	  max-height: 180px !important;
  	  	  overflow-y: auto !important;
  	  	  overflow-x: hidden !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-body::-webkit-scrollbar {
  	  	  width: 5px !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-body::-webkit-scrollbar-thumb {
  	  	  background: rgba(255,122,36,0.42) !important;
  	  	  border-radius: 999px !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-card.legend-collapsed .trackit-compact-legend-body {
  	  	  display: none !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-row {
  	  	  display: grid !important;
  	  	  grid-template-columns: 28px 1fr !important;
  	  	  align-items: center !important;
  	  	  gap: 8px !important;
  	  	  min-height: 26px !important;
  	  	  padding: 4px 6px !important;
  	  	  border-radius: 10px !important;
  	  	  background: rgba(0,0,0,0.18) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-swatch {
  	  	  width: 28px !important;
  	  	  height: 22px !important;
  	  	  display: flex !important;
  	  	  align-items: center !important;
  	  	  justify-content: center !important;
  	  	  position: relative !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-dot {
  	  	  width: 12px !important;
  	  	  height: 12px !important;
  	  	  border-radius: 50% !important;
  	  	  border: 1.5px solid #fff !important;
  	  	  box-shadow: 0 0 8px rgba(0,0,0,0.45) !important;
  	  	  display: inline-block !important;
  	  	  box-sizing: border-box !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-dot-label {
  	  	  position: absolute !important;
  	  	  top: -7px !important;
  	  	  left: 50% !important;
  	  	  transform: translateX(-50%) !important;
  	  	  font-size: 7px !important;
  	  	  font-weight: 950 !important;
  	  	  color: #fff !important;
  	  	  text-shadow: 0 1px 3px rgba(0,0,0,0.95) !important;
  	  	  white-space: nowrap !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-line {
  	  	  width: 24px !important;
  	  	  height: 5px !important;
  	  	  border-radius: 999px !important;
  	  	  background: #e53935 !important;
  	  	  box-shadow: 0 0 8px rgba(229,57,53,0.65) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-poly {
  	  	  width: 22px !important;
  	  	  height: 16px !important;
  	  	  border: 2px solid #00bcd4 !important;
  	  	  background: rgba(0,188,212,0.23) !important;
  	  	  border-radius: 5px !important;
  	  	  box-sizing: border-box !important;
  	  	  position: relative !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-poly::after {
  	  	  content: "" !important;
  	  	  position: absolute !important;
  	  	  right: -5px !important;
  	  	  bottom: -5px !important;
  	  	  width: 8px !important;
  	  	  height: 8px !important;
  	  	  border-radius: 50% !important;
  	  	  background: #00bcd4 !important;
  	  	  border: 1.5px solid #fff !important;
  	  	  box-sizing: border-box !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-pin {
  	  	  width: 0 !important;
  	  	  height: 0 !important;
  	  	  border-left: 7px solid transparent !important;
  	  	  border-right: 7px solid transparent !important;
  	  	  border-bottom: 18px solid #2196F3 !important;
  	  	  filter: drop-shadow(0 0 5px rgba(0,0,0,0.55)) !important;
  	  	  position: relative !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-pin::after {
  	  	  content: "" !important;
  	  	  position: absolute !important;
  	  	  left: -4px !important;
  	  	  top: 9px !important;
  	  	  width: 8px !important;
  	  	  height: 8px !important;
  	  	  border-radius: 50% !important;
  	  	  background: #fff !important;
  	  	  opacity: 0.9 !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-fuel svg {
  	  	  width: 22px !important;
  	  	  height: 22px !important;
  	  	  filter: drop-shadow(0 0 5px rgba(0,0,0,0.55)) !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-copy {
  	  	  min-width: 0 !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-name {
  	  	  font-size: 10px !important;
  	  	  font-weight: 950 !important;
  	  	  color: rgba(255,255,255,0.92) !important;
  	  	  line-height: 1.1 !important;
  	  	  }

  	  	  .fine-track-compact-map-control .trackit-compact-legend-desc {
  	  	  font-size: 8.5px !important;
  	  	  color: rgba(255,255,255,0.54) !important;
  	  	  line-height: 1.2 !important;
  	  	  margin-top: 2px !important;
  	  	  }

  	  	  .gm-svpc {
  	  	  display: none !important;
  	  	  opacity: 0 !important;
  	  	  pointer-events: none !important;
  	  	  }
  	  	  `;

  	  	  document.head.appendChild(style);

  	  	  let currentMapType = readSetting("mapType", "hybrid") || "hybrid";

  	  	  if (currentMapType === "satellite") {
  	  	    currentMapType = "hybrid";
  	  	    writeSetting("mapType", "hybrid");
  	  	  }

  	  	  let collapsed = readSetting("panelCollapsedV8", true);
  	  	  let labelsOn = readSetting("labelsOn", true);
  	  	  let legendCollapsed = readSetting("legendCollapsedV1", true);

  	  	  try {
  	  	    map.setMapTypeId(currentMapType);
  	  	  } catch (_) {}

  	  	  try {
  	  	    if (map.__trackitTrafficLayer) {
  	  	      map.__trackitTrafficLayer.setMap(null);
  	  	      map.__trackitTrafficLayer = null;
  	  	    }
  	  	  } catch (_) {}

  	  	  const control = document.createElement("div");
  	  	  registerFineTrackElement(map, control);

  	  	  control.className = "fine-track-compact-map-control ces-bottom-shape";
  	  	  control.__fineTrackUnifiedMapControl = true;
  	  	  control.setAttribute("data-fine-track-map-control", "route-snapshot");

  	  	  if (collapsed) {
  	  	    control.classList.add("collapsed");
  	  	  }

  	  	  const shellContent = document.createElement("div");
  	  	  shellContent.className = "ces-bottom-content";
  	  	  shellContent.setAttribute("data-fine-track-new-map-control", "route-snapshot");

  	  	  const header = document.createElement("button");
  	  	  header.type = "button";
  	  	  header.className = "ces-map-control-header";
  	  	  header.setAttribute("data-fine-track-map-control-toggle", "route-snapshot");

  	  	  const headerIcon = document.createElement("div");
  	  	  headerIcon.className = "ces-map-control-header-icon";
  	  	  headerIcon.innerHTML = `
  	  	  <div class="ces-layer-icon">
  	  	  <span></span>
  	  	  <span></span>
  	  	  <span></span>
  	  	  </div>
  	  	  `;

  	  	  const headerText = document.createElement("div");
  	  	  headerText.className = "ces-map-control-header-text";

  	  	  const title = document.createElement("div");
  	  	  title.className = "ces-map-title";
  	  	  title.textContent = "Map Control";

  	  	  const subtitle = document.createElement("div");
  	  	  subtitle.className = "ces-map-subtitle";

  	  	  headerText.appendChild(title);
  	  	  headerText.appendChild(subtitle);

  	  	  const collapseIcon = document.createElement("div");
  	  	  collapseIcon.className = "ces-caret";

  	  	  header.appendChild(headerIcon);
  	  	  header.appendChild(headerText);
  	  	  header.appendChild(collapseIcon);

  	  	  const body = document.createElement("div");
  	  	  body.className = "ces-map-control-body";

  	  	  const main = document.createElement("div");
  	  	  main.className = "ces-map-control-main";

  	  	  const mapTypeSection = document.createElement("div");
  	  	  mapTypeSection.className = "ces-map-control-section";

  	  	  const typeTabs = document.createElement("div");
  	  	  typeTabs.className = "ces-map-control-tools fleet-map-type-tools";

  	  	  const mapTypes = [{
  	  	    id: "roadmap",
  	  	    label: "Road",
  	  	    icon: iconRoadmap()
  	  	  },
  	  	    {
  	  	      id: "hybrid",
  	  	      label: "Hybrid",
  	  	      icon: iconLayers()
  	  	    },
  	  	    {
  	  	      id: "terrain",
  	  	      label: "Terrain",
  	  	      icon: iconTerrain()
  	  	    }];

  	  	  const typeButtons = {};

  	  	  mapTypes.forEach(type => {
  	  	    const btn = document.createElement("button");
  	  	    btn.type = "button";
  	  	    btn.className = "ces-map-control-tool fleet-map-type-btn";
  	  	    btn.dataset.mapType = type.id;
  	  	    btn.innerHTML = `${type.icon}<span>${type.label}</span>`;

  	  	    btn.addEventListener("click", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      currentMapType = type.id;

  	  	      writeSetting("mapType", type.id);
  	  	      applyMapAppearance();
  	  	      paintMapTypeButtons();
  	  	    });

  	  	    typeButtons[type.id] = btn;
  	  	    typeTabs.appendChild(btn);
  	  	  });

  	  	  mapTypeSection.appendChild(sectionLabel("Map Type", iconLayers()));
  	  	  mapTypeSection.appendChild(typeTabs);

  	  	  const toolsSection = document.createElement("div");
  	  	  toolsSection.className = "ces-map-control-section";

  	  	  const toolsGrid = document.createElement("div");
  	  	  toolsGrid.className = "ces-map-control-tools route-map-tools";

  	  	  const labelsBtn = toolButton("Labels", iconLabel());
  	  	  const fullscreenBtn = toolButton("Fullscreen", iconFullscreen());

  	  	  toolsGrid.appendChild(labelsBtn);
  	  	  toolsGrid.appendChild(fullscreenBtn);

  	  	  toolsSection.appendChild(sectionLabel("Tools", iconLayers()));
  	  	  toolsSection.appendChild(toolsGrid);

  	  	  const legendSection = document.createElement("div");
  	  	  legendSection.className = "ces-map-control-section trackit-route-legend-section";
  	  	  legendSection.appendChild(sectionLabel("Route", iconMapLegend()));
  	  	  legendSection.appendChild(buildMapLegend());

  	  	  main.appendChild(mapTypeSection);
  	  	  main.appendChild(toolsSection);
  	  	  main.appendChild(legendSection);

  	  	  const zoomPanel = document.createElement("div");
  	  	  zoomPanel.className = "ces-map-control-zoom-rail";

  	  	  const zoomTitle = document.createElement("div");
  	  	  zoomTitle.className = "ces-map-control-zoom-label";
  	  	  zoomTitle.textContent = "Zoom";

  	  	  const zoomValue = document.createElement("div");
  	  	  zoomValue.className = "ces-map-control-zoom-value";

  	  	  const zoomPlus = document.createElement("button");
  	  	  zoomPlus.type = "button";
  	  	  zoomPlus.className = "ces-map-control-zoom-btn";
  	  	  zoomPlus.textContent = "+";

  	  	  const sliderWrap = document.createElement("div");
  	  	  sliderWrap.className = "ces-map-control-slider-wrap";

  	  	  const zoomSlider = document.createElement("input");
  	  	  zoomSlider.className = "ces-map-control-zoom-slider";
  	  	  zoomSlider.type = "range";
  	  	  zoomSlider.min = "1";
  	  	  zoomSlider.max = "22";
  	  	  zoomSlider.step = "1";

  	  	  const ticks = document.createElement("div");
  	  	  ticks.className = "ces-map-control-ticks";

  	  	  sliderWrap.appendChild(zoomSlider);
  	  	  sliderWrap.appendChild(ticks);

  	  	  const zoomMinus = document.createElement("button");
  	  	  zoomMinus.type = "button";
  	  	  zoomMinus.className = "ces-map-control-zoom-btn";
  	  	  zoomMinus.textContent = "−";

  	  	  zoomPanel.appendChild(zoomTitle);
  	  	  zoomPanel.appendChild(zoomValue);
  	  	  zoomPanel.appendChild(zoomPlus);
  	  	  zoomPanel.appendChild(sliderWrap);
  	  	  zoomPanel.appendChild(zoomMinus);

  	  	  body.appendChild(main);
  	  	  body.appendChild(zoomPanel);

  	  	  shellContent.appendChild(header);
  	  	  shellContent.appendChild(body);
  	  	  control.appendChild(shellContent);

  	  	  ["mousedown",
  	  	    "dblclick",
  	  	    "wheel",
  	  	    "touchstart",
  	  	    "pointerdown",
  	  	    "click"].forEach(evtName => {
  	  	      control.addEventListener(evtName, function (event) {
  	  	        event.stopPropagation();
  	  	      }, {
  	  	        passive: false
  	  	      });
  	  	    });

  	  	  try {
  	  	    const mapDivForMount = map.getDiv?.();

  	  	    if (mapDivForMount) {
  	  	      const computedPosition = window.getComputedStyle?.(mapDivForMount)?.position;

  	  	      if (!computedPosition || computedPosition === "static") {
  	  	        mapDivForMount.style.position = "relative";
  	  	      }

  	  	      control.style.position = "absolute";
  	  	      control.style.right = "0";
  	  	      control.style.bottom = "0";
  	  	      control.style.margin = "0";
  	  	      control.style.zIndex = "999999";
  	  	      control.style.pointerEvents = "auto";

  	  	      mapDivForMount.appendChild(control);
  	  	    } else {
  	  	      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	  	    }
  	  	  } catch (error) {
  	  	    console.warn("[TrackIT Map Controls] Could not mount absolute control. Falling back to Google controls.", error);

  	  	    try {
  	  	      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(control);
  	  	    } catch (_) {}
  	  	  }

  	  	  map.__fineTrackUnifiedMapControlReady = true;
  	  	  map.__fineTrackUnifiedMapControlVersion = CONTROL_VERSION;

  	  	  function sectionLabel(text, icon) {
  	  	    const row = document.createElement("div");
  	  	    row.className = "ces-map-control-section-title";
  	  	    row.innerHTML = `
  	  	    ${icon}
  	  	    <span>${text}</span>
  	  	    `;
  	  	    return row;
  	  	  }

  	  	  function toolButton(label, icon) {
  	  	    const btn = document.createElement("button");
  	  	    btn.type = "button";
  	  	    btn.className = "ces-map-control-tool";
  	  	    btn.innerHTML = `${icon}<span>${label}</span>`;
  	  	    return btn;
  	  	  }

  	  	  function buildMapLegend() {
  	  	    const card = document.createElement("div");
  	  	    card.className = "trackit-compact-legend-card";

  	  	    if (legendCollapsed) {
  	  	      card.classList.add("legend-collapsed");
  	  	    }

  	  	    const head = document.createElement("button");
  	  	    head.type = "button";
  	  	    head.className = "trackit-compact-legend-head";

  	  	    const icon = document.createElement("div");
  	  	    icon.innerHTML = iconMapLegend();

  	  	    const title = document.createElement("div");
  	  	    title.className = "trackit-compact-legend-title";
  	  	    title.textContent = "Map Legend";

  	  	    const chevron = document.createElement("div");
  	  	    chevron.className = "trackit-compact-legend-chevron";

  	  	    head.appendChild(icon);
  	  	    head.appendChild(title);
  	  	    head.appendChild(chevron);

  	  	    const body = document.createElement("div");
  	  	    body.className = "trackit-compact-legend-body";

  	  	    const rows = [{
  	  	      type: "line",
  	  	      title: "Route",
  	  	      desc: "Tracked route line for the trip."
  	  	    },
  	  	      {
  	  	        type: "dotLabel",
  	  	        color: "#00cc44",
  	  	        label: "START",
  	  	        title: "Start",
  	  	        desc: "First valid tracking point."
  	  	      },
  	  	      {
  	  	        type: "dot",
  	  	        color: "#cc0000",
  	  	        title: "Stop",
  	  	        desc: "Vehicle stopped or parked."
  	  	      },
  	  	      {
  	  	        type: "dot",
  	  	        color: "#ffcc00",
  	  	        title: "Idle",
  	  	        desc: "First point of each idle event."
  	  	      },
  	  	      {
  	  	        type: "dotLabel",
  	  	        color: "#cc0000",
  	  	        label: "END",
  	  	        title: "End",
  	  	        desc: "Last valid tracking point."
  	  	      },
  	  	      {
  	  	        type: "fuelGain",
  	  	        title: "Fuel Gain",
  	  	        desc: "Fuel increased / refuel detected."
  	  	      },
  	  	      {
  	  	        type: "fuelLoss",
  	  	        title: "Fuel Loss",
  	  	        desc: "Fuel dropped / loss detected."
  	  	      },
  	  	      {
  	  	        type: "polygon",
  	  	        title: "Location",
  	  	        desc: "Saved geofence and entrance point."
  	  	      },
  	  	      {
  	  	        type: "pin",
  	  	        title: "Selected Point",
  	  	        desc: "Clicked or hovered track point."
  	  	      }];

  	  	    rows.forEach(item => {
  	  	      body.appendChild(makeLegendRow(item));
  	  	    });

  	  	    head.addEventListener("click", function (event) {
  	  	      event.preventDefault();
  	  	      event.stopPropagation();

  	  	      legendCollapsed = !legendCollapsed;
  	  	      card.classList.toggle("legend-collapsed", legendCollapsed);
  	  	      writeSetting("legendCollapsedV1", legendCollapsed);
  	  	      sizeRouteMapControlShell(control, !collapsed);
  	  	    });

  	  	    card.appendChild(head);
  	  	    card.appendChild(body);

  	  	    return card;
  	  	  }

  	  	  function makeLegendRow(item) {
  	  	    const row = document.createElement("div");
  	  	    row.className = "trackit-compact-legend-row";

  	  	    const swatch = makeLegendSwatch(item);

  	  	    const copy = document.createElement("div");
  	  	    copy.className = "trackit-compact-legend-copy";

  	  	    const name = document.createElement("div");
  	  	    name.className = "trackit-compact-legend-name";
  	  	    name.textContent = item.title || "";

  	  	    const desc = document.createElement("div");
  	  	    desc.className = "trackit-compact-legend-desc";
  	  	    desc.textContent = item.desc || "";

  	  	    copy.appendChild(name);
  	  	    copy.appendChild(desc);

  	  	    row.appendChild(swatch);
  	  	    row.appendChild(copy);

  	  	    return row;
  	  	  }

  	  	  function makeLegendSwatch(item) {
  	  	    const swatch = document.createElement("div");
  	  	    swatch.className = "trackit-compact-legend-swatch";

  	  	    if (item.type === "line") {
  	  	      const line = document.createElement("div");
  	  	      line.className = "trackit-compact-legend-line";
  	  	      swatch.appendChild(line);
  	  	      return swatch;
  	  	    }

  	  	    if (item.type === "dot" || item.type === "dotLabel") {
  	  	      const dot = document.createElement("span");
  	  	      dot.className = "trackit-compact-legend-dot";
  	  	      dot.style.background = item.color || "#ffcc00";

  	  	      swatch.appendChild(dot);

  	  	      if (item.label) {
  	  	        const label = document.createElement("span");
  	  	        label.className = "trackit-compact-legend-dot-label";
  	  	        label.textContent = item.label;
  	  	        swatch.appendChild(label);
  	  	      }

  	  	      return swatch;
  	  	    }

  	  	    if (item.type === "fuelGain") {
  	  	      swatch.classList.add("trackit-compact-legend-fuel");
  	  	      swatch.innerHTML = legendJerryCanSvg("#00cc44");
  	  	      return swatch;
  	  	    }

  	  	    if (item.type === "fuelLoss") {
  	  	      swatch.classList.add("trackit-compact-legend-fuel");
  	  	      swatch.innerHTML = legendJerryCanSvg("#ff3b30");
  	  	      return swatch;
  	  	    }

  	  	    if (item.type === "polygon") {
  	  	      const poly = document.createElement("div");
  	  	      poly.className = "trackit-compact-legend-poly";
  	  	      swatch.appendChild(poly);
  	  	      return swatch;
  	  	    }

  	  	    if (item.type === "pin") {
  	  	      const pin = document.createElement("div");
  	  	      pin.className = "trackit-compact-legend-pin";
  	  	      swatch.appendChild(pin);
  	  	      return swatch;
  	  	    }

  	  	    return swatch;
  	  	  }

  	  	  function legendJerryCanSvg(color) {
  	  	    const safeColor = color || "#ff7928";

  	  	    return `
  	  	    <svg viewBox="0 0 32 32" aria-hidden="true">
  	  	    <path
  	  	    d="M9 4h9l5 5v18a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
  	  	    fill="${safeColor}"
  	  	    stroke="#fff"
  	  	    stroke-width="1.7"
  	  	    stroke-linejoin="round"
  	  	    />
  	  	    <path
  	  	    d="M18 4v6h6"
  	  	    fill="none"
  	  	    stroke="#fff"
  	  	    stroke-width="1.7"
  	  	    stroke-linecap="round"
  	  	    stroke-linejoin="round"
  	  	    />
  	  	    <path
  	  	    d="M12 9h5"
  	  	    stroke="rgba(0,0,0,0.45)"
  	  	    stroke-width="2"
  	  	    stroke-linecap="round"
  	  	    />
  	  	    <path
  	  	    d="M12 16c2.7-3.8 5.5-3.8 8.2 0-1 4.6-7.2 4.6-8.2 0Z"
  	  	    fill="rgba(0,0,0,0.32)"
  	  	    />
  	  	    </svg>
  	  	    `;
  	  	  }

  	  	  function iconMapLegend() {
  	  	    return svgBase(`
  	  	      <path d="M4 6h16"/>
  	  	      <path d="M4 12h16"/>
  	  	      <path d="M4 18h16"/>
  	  	      <circle cx="7" cy="6" r="1.6"/>
  	  	      <circle cx="7" cy="12" r="1.6"/>
  	  	      <circle cx="7" cy="18" r="1.6"/>
  	  	      `);
  	  	  }

  	  	  function sizeRouteMapControlShell(control, isOpen) {
  	  	    if (!control) return;

  	  	    function setStyle(element, property, value) {
  	  	      try {
  	  	        element.style.setProperty(property, value, "important");
  	  	      } catch (_) {
  	  	        try {
  	  	          element.style[property] = value;
  	  	        } catch (_) {}
  	  	      }
  	  	    }

  	  	    const content = control.querySelector(".ces-bottom-content");

  	  	    const viewportHeight =
  	  	    typeof window !== "undefined" && window.innerHeight
  	  	    ? window.innerHeight: 900;

  	  	    const maxHeight = Math.max(360, viewportHeight - 24);
  	  	    const closedHeight = 56;
  	  	    const closedWidth = 200;
  	  	    const openWidth = 300;

  	  	    if (!isOpen) {
  	  	      setStyle(control, "width", `${closedWidth}px`);
  	  	      setStyle(control, "height", `${closedHeight}px`);
  	  	      setStyle(control, "min-height", `${closedHeight}px`);
  	  	      setStyle(control, "max-height", `${closedHeight}px`);
  	  	      setStyle(control, "overflow", "hidden");
  	  	      setStyle(control, "right", "0");
  	  	      setStyle(control, "bottom", "0");
  	  	      setStyle(control, "top", "auto");
  	  	      setStyle(control, "border-radius", "22px 0 0 0");

  	  	      if (content) {
  	  	        setStyle(content, "max-height", `${closedHeight}px`);
  	  	        setStyle(content, "overflow", "hidden");
  	  	        setStyle(content, "overflow-x", "hidden");
  	  	        setStyle(content, "overflow-y", "hidden");
  	  	      }

  	  	      return;
  	  	    }

  	  	    if (content) {
  	  	      setStyle(content, "max-height", "none");
  	  	      setStyle(content, "overflow", "visible");
  	  	      setStyle(content, "overflow-x", "hidden");
  	  	      setStyle(content, "overflow-y", "visible");
  	  	    }

  	  	    const contentHeight = content ? Math.ceil(content.scrollHeight): 0;
  	  	    const wantedHeight = Math.max(320, contentHeight + 2);
  	  	    const finalHeight = Math.min(wantedHeight, maxHeight);

  	  	    setStyle(control, "width", `${openWidth}px`);
  	  	    setStyle(control, "height", `${finalHeight}px`);
  	  	    setStyle(control, "min-height", `${finalHeight}px`);
  	  	    setStyle(control, "max-height", `${maxHeight}px`);
  	  	    setStyle(control, "overflow", "hidden");
  	  	    setStyle(control, "right", "0");
  	  	    setStyle(control, "bottom", "0");
  	  	    setStyle(control, "top", "auto");
  	  	    setStyle(control, "border-radius", "24px 0 0 0");

  	  	    if (content) {
  	  	      setStyle(content, "max-height", `${finalHeight}px`);
  	  	      setStyle(content, "overflow-x", "hidden");
  	  	      setStyle(content, "overflow-y", wantedHeight > maxHeight ? "auto": "visible");
  	  	    }
  	  	  }

  	  	  function applyMapAppearance() {
  	  	    let effectiveType = currentMapType;

  	  	    /*
  	  	     * Hybrid is satellite imagery with Google labels.
  	  	     * Satellite is the same imagery without those labels.
  	  	     */
  	  	    if (currentMapType === "hybrid") {
  	  	      effectiveType = labelsOn ? "hybrid": "satellite";
  	  	    }

  	  	    try {
  	  	      map.setMapTypeId(effectiveType);
  	  	    } catch (_) {}

  	  	    try {
  	  	      if (
  	  	        currentMapType === "roadmap" ||
  	  	        currentMapType === "terrain"
  	  	      ) {
  	  	        map.setOptions({
  	  	          styles: labelsOn ? []: NO_LABEL_STYLES
  	  	        });
  	  	      } else {
  	  	        // Clear styles left by Fine Track before using hybrid/satellite.
  	  	        map.setOptions({
  	  	          styles: []
  	  	        });
  	  	      }
  	  	    } catch (_) {}

  	  	    updateHeaderState();
  	  	  }

  	  	  function paintMapTypeButtons() {
  	  	    Object.keys(typeButtons).forEach(key => {
  	  	      typeButtons[key].classList.toggle("active", key === currentMapType);
  	  	    });
  	  	  }

  	  	  function updateZoomUi() {
  	  	    const z = map.getZoom() || 1;

  	  	    zoomSlider.value = String(z);
  	  	    zoomValue.textContent = String(z);

  	  	    writeSetting("zoom", z);
  	  	  }

  	  	  function updateHeaderState() {
  	  	    collapseIcon.textContent = collapsed ? "⌄": "⌃";
  	  	    subtitle.textContent = labelsOn ? "Labels On": "Labels Off";
  	  	  }

  	  	  function paintToggleButtons() {
  	  	    labelsBtn.classList.toggle("active", !!labelsOn);
  	  	    paintFullscreenState();
  	  	    updateHeaderState();
  	  	  }

  	  	  function isFullscreenActive() {
  	  	    const mapDiv = map.getDiv();
  	  	    const fs = document.fullscreenElement || document.webkitFullscreenElement || null;

  	  	    return !!fs && (fs === mapDiv || fs.contains(mapDiv));
  	  	  }

  	  	  function paintFullscreenState() {
  	  	    fullscreenBtn.classList.toggle("active", isFullscreenActive());
  	  	    fullscreenBtn.classList.toggle("fullscreen-active", isFullscreenActive());
  	  	  }

  	  	  function toggleFullscreen() {
  	  	    const mapDiv = map.getDiv();

  	  	    try {
  	  	      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
  	  	        if (mapDiv.requestFullscreen) mapDiv.requestFullscreen();
  	  	        else if (mapDiv.webkitRequestFullscreen) mapDiv.webkitRequestFullscreen();
  	  	      } else {
  	  	        if (document.exitFullscreen) document.exitFullscreen();
  	  	        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
  	  	      }
  	  	    } catch (e) {
  	  	      console.warn("[TrackIT Map Controls] Fullscreen failed:", e);
  	  	    }

  	  	    setTimeout(paintFullscreenState, 150);
  	  	  }

  	  	  header.addEventListener("click", function (event) {
  	  	    event.preventDefault();
  	  	    event.stopPropagation();

  	  	    collapsed = !collapsed;

  	  	    control.classList.toggle("collapsed", collapsed);
  	  	    updateHeaderState();
  	  	    sizeRouteMapControlShell(control, !collapsed);
  	  	    writeSetting("panelCollapsedV8", collapsed);
  	  	  });

  	  	  zoomPlus.addEventListener("click", function (event) {
  	  	    event.preventDefault();
  	  	    event.stopPropagation();

  	  	    const z = map.getZoom() || 1;
  	  	    map.setZoom(Math.min(22, z + 1));
  	  	  });

  	  	  zoomMinus.addEventListener("click", function (event) {
  	  	    event.preventDefault();
  	  	    event.stopPropagation();

  	  	    const z = map.getZoom() || 1;
  	  	    map.setZoom(Math.max(1, z - 1));
  	  	  });

  	  	  zoomSlider.addEventListener("input", function (event) {
  	  	    event.preventDefault();
  	  	    event.stopPropagation();

  	  	    map.setZoom(Number(zoomSlider.value));
  	  	  });

  	  	  labelsBtn.addEventListener("click", function (event) {
  	  	    event.preventDefault();
  	  	    event.stopPropagation();

  	  	    labelsOn = !labelsOn;

  	  	    writeSetting("labelsOn", labelsOn);
  	  	    applyMapAppearance();
  	  	    paintToggleButtons();
  	  	  });

  	  	  fullscreenBtn.addEventListener("click", function (event) {
  	  	    event.preventDefault();
  	  	    event.stopPropagation();

  	  	    toggleFullscreen();
  	  	  });

  	  	  map.__fineTrackMapControlListeners.push(
  	  	    map.addListener("zoom_changed", updateZoomUi)
  	  	  );

  	  	  map.__fineTrackMapControlListeners.push(
  	  	    map.addListener("maptypeid_changed", function () {
  	  	      paintMapTypeButtons();
  	  	    })
  	  	  );

  	  	  const fullscreenHandler = function () {
  	  	    paintFullscreenState();
  	  	  };

  	  	  document.addEventListener("fullscreenchange", fullscreenHandler);
  	  	  document.addEventListener("webkitfullscreenchange", fullscreenHandler);

  	  	  map.__fineTrackDomControlListeners.push({
  	  	    target: document,
  	  	    event: "fullscreenchange",
  	  	    handler: fullscreenHandler
  	  	  });

  	  	  map.__fineTrackDomControlListeners.push({
  	  	    target: document,
  	  	    event: "webkitfullscreenchange",
  	  	    handler: fullscreenHandler
  	  	  });

  	  	  const resizeHandler = function () {
  	  	    sizeRouteMapControlShell(control, !collapsed);
  	  	  };

  	  	  if (typeof window !== "undefined") {
  	  	    window.addEventListener("resize", resizeHandler);
  	  	    map.__fineTrackDomControlListeners.push({
  	  	      target: window,
  	  	      event: "resize",
  	  	      handler: resizeHandler
  	  	    });
  	  	  }

  	  	  const savedZoom = readSetting("zoom", null);

  	  	  if (savedZoom !== null && savedZoom !== undefined) {
  	  	    try {
  	  	      map.setZoom(Number(savedZoom));
  	  	    } catch (_) {}
  	  	  }

  	  	  applyMapAppearance();
  	  	  updateZoomUi();
  	  	  updateHeaderState();
  	  	  sizeRouteMapControlShell(control, !collapsed);
  	  	  paintMapTypeButtons();
  	  	  paintToggleButtons();
  	  	  sizeRouteMapControlShell(control, !collapsed);

  	  	  function svgBase(paths) {
  	  	    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
  	  	  }

  	  	  function iconLayers() {
  	  	    return svgBase(`
  	  	      <path d="M12 3 3 8l9 5 9-5-9-5Z"/>
  	  	      <path d="M3 12l9 5 9-5"/>
  	  	      <path d="M3 16l9 5 9-5"/>
  	  	      `);
  	  	  }

  	  	  function iconRoadmap() {
  	  	    return svgBase(`
  	  	      <path d="M4 18V6l5-2 6 2 5-2v12l-5 2-6-2-5 2Z"/>
  	  	      <path d="M9 4v12"/>
  	  	      <path d="M15 6v12"/>
  	  	      <path d="M12 9h.01"/>
  	  	      <path d="M17 11h.01"/>
  	  	      `);
  	  	  }

  	  	  function iconSatellite() {
  	  	    return svgBase(`
  	  	      <path d="m6 14 4 4"/>
  	  	      <path d="m14 6 4 4"/>
  	  	      <path d="m8 16 8-8"/>
  	  	      <rect x="12" y="3" width="7" height="5" rx="1" transform="rotate(45 12 3)"/>
  	  	      <rect x="4" y="13" width="7" height="5" rx="1" transform="rotate(45 4 13)"/>
  	  	      <path d="M17 17c1.5-1.5 2-3.5 1.2-5.2"/>
  	  	      <path d="M20 20c2.5-2.5 3-6 1.4-8.8"/>
  	  	      `);
  	  	  }

  	  	  function iconTerrain() {
  	  	    return svgBase(`
  	  	      <path d="m3 18 6-10 4 6 3-5 5 9H3Z"/>
  	  	      <path d="m8.5 12 2 2"/>
  	  	      <path d="m15.5 13 2 2"/>
  	  	      `);
  	  	  }

  	  	  function iconTraffic() {
  	  	    return svgBase(`
  	  	      <path d="M6 16h12"/>
  	  	      <path d="M7 16v3"/>
  	  	      <path d="M17 16v3"/>
  	  	      <path d="M7 13l1.5-5h7L17 13"/>
  	  	      <path d="M8 13h8"/>
  	  	      <circle cx="8.5" cy="16" r="1"/>
  	  	      <circle cx="15.5" cy="16" r="1"/>
  	  	      `);
  	  	  }

  	  	  function iconFullscreen() {
  	  	    return svgBase(`
  	  	      <path d="M8 3H3v5"/>
  	  	      <path d="M16 3h5v5"/>
  	  	      <path d="M8 21H3v-5"/>
  	  	      <path d="M16 21h5v-5"/>
  	  	      `);
  	  	  }

  	  	  function iconLabel() {
  	  	    return svgBase(`
  	  	      <path d="M5 5h14v14H5z"/>
  	  	      <path d="M8 9h8"/>
  	  	      <path d="M8 12h6"/>
  	  	      <path d="M8 15h4"/>
  	  	      `);
  	  	  }
  	  	}

  	  	(function polylineTrackSnapshot(args) {
  	  	  const {
  	  	    googleMapComponent, App, Locations, Images, Hub, SVG
  	  	  } = args || {};

  	  	  const TrackitReportLogo =
  	  	  args?.SVG ||
  	  	  SVG ||
  	  	  args?.Images?.Logo ||
  	  	  args?.Images?.ReportLogo ||
  	  	  args?.Images?.logo ||
  	  	  args?.Images?.reportLogo ||
  	  	  args?.App?.ReportLogo ||
  	  	  args?.App?.reportLogo ||
  	  	  args?.App?.Logo ||
  	  	  args?.App?.logo ||
  	  	  args?.App?.data?.ReportLogo ||
  	  	  args?.App?.data?.reportLogo ||
  	  	  args?.App?.data?.Logo ||
  	  	  args?.App?.data?.logo ||
  	  	  "";
  	  	  const map = googleMapComponent?.map?.map;
  	  	  if (!map) return;

  	  	  /*
  	  	   * Fine Track can reuse the same Google Map instance as Live Track.
  	  	   * Always restore normal interaction and clear stale label-hiding styles
  	  	   * before rebuilding Fine Track.
  	  	   */
  	  	  try {
  	  	    map.setOptions({
  	  	      draggable: true,
  	  	      scrollwheel: true,
  	  	      disableDoubleClickZoom: false,
  	  	      keyboardShortcuts: true,
  	  	      gestureHandling: "auto",
  	  	      clickableIcons: true,
  	  	      styles: []
  	  	    });

  	  	    map.__fineTrackRoutePanelMapLocked = false;

  	  	    const mapElement = map.getDiv?.();
  	  	    if (mapElement?.style) {
  	  	      mapElement.style.cursor = "";
  	  	    }
  	  	  } catch (error) {
  	  	    console.warn("[Fine Track] Could not restore map interaction:", error);
  	  	  }

  	  	  // Add Fine Track map controls immediately after map is available.
  	  	  // This must run before the tractor/path guards so the controls still appear
  	  	  // even when there is no selected tractor or no tracking data.
  	  	  try {
  	  	    addFineTrackUnifiedMapControl(map, App);
  	  	  } catch (e) {
  	  	    console.warn("[Fine Track Map Controls] Failed to load:", e);
  	  	  }

  	  	  const tractor = App?.SelectedTractor;
  	  	  if (!tractor || !Array.isArray(tractor.Tracking)) return;

  	  	  // ---------- Path ----------
  	  	  const path = tractor.Tracking.map((p, idx) => {
  	  	    const lat = p["position.latitude"];
  	  	    const lng = p["position.longitude"];
  	  	    return lat != null && lng != null ? {
  	  	      lat, lng, raw: p, idx
  	  	    }: null;
  	  	  }).filter(Boolean);
  	  	  if (!path.length) return;


  	  	  // ---------- Utils ----------
  	  	  const toRad = x => (x * Math.PI) / 180;

  	  	  const smartFuelConsumed = (r) => {
  	  	    if (!r || typeof r !== "object") return null;
  	  	    const keys = [
  	  	      "can.tracker.counted.fuel.consumed",
  	  	      "can.fuel.consumed",
  	  	      "can.fuel.used",
  	  	      "can.fuel.liters",
  	  	      "gps.fuel.used"
  	  	    ];
  	  	    for (const k of keys) {
  	  	      const v = Number(r[k]);
  	  	      if (Number.isFinite(v)) return v;
  	  	    }
  	  	    return null;
  	  	  };



  	  	  const smartOdoKm = (r) => {
  	  	    if (!r || typeof r !== "object") return null;
  	  	    const keys = [
  	  	      "vehicle.mileage",
  	  	      "can.vehicle.mileage",
  	  	      "can.tracker.counted.mileage",
  	  	      "gps.odometer",
  	  	      "gps.mileage"
  	  	    ];
  	  	    for (const k of keys) {
  	  	      const v = Number(r[k]);
  	  	      if (Number.isFinite(v)) return v;
  	  	    }
  	  	    return null;
  	  	  };

  	  	  const smartFuelPct = (raw, tankCap) => {
  	  	    let pct = Number(raw?.["can.fuel.level"]);
  	  	    if (Number.isFinite(pct) && pct >= 0 && pct <= 100) return pct;

  	  	    const vol = Number(raw?.["can.fuel.volume"]);
  	  	    if (Number.isFinite(vol) && Number.isFinite(tankCap) && tankCap > 0) {
  	  	      const p = (vol / tankCap) * 100;
  	  	      return Math.min(100, Math.max(0, p));
  	  	    }

  	  	    return null;
  	  	  };

  	  	  const calcFuelUsedBest = (startRaw, endRaw, tankCap) => {
  	  	    const fStart = smartFuelConsumed(startRaw);
  	  	    const fEnd = smartFuelConsumed(endRaw);

  	  	    let fuelByConsumed =
  	  	    (Number.isFinite(fStart) && Number.isFinite(fEnd))
  	  	    ? (fEnd - fStart): null;

  	  	    const lvlStart = smartFuelPct(startRaw, tankCap);
  	  	    const lvlEnd = smartFuelPct(endRaw, tankCap);

  	  	    let fuelByLevel =
  	  	    (Number.isFinite(lvlStart) && Number.isFinite(lvlEnd) && Number.isFinite(tankCap) && tankCap > 0)
  	  	    ? ((lvlStart - lvlEnd) / 100) * tankCap: null;

  	  	    // Normalize
  	  	    if (fuelByConsumed != null && fuelByConsumed <= 0) fuelByConsumed = null;
  	  	    if (fuelByLevel != null && fuelByLevel <= 0) fuelByLevel = null;

  	  	    // Scale-detect consumed using level as reference
  	  	    if (fuelByConsumed != null && fuelByLevel != null) {
  	  	      const ratio = fuelByLevel / fuelByConsumed;

  	  	      if (ratio > 8 && ratio < 12) {
  	  	        fuelByConsumed = fuelByConsumed * 10;
  	  	      } else if (ratio > 80 && ratio < 120) {
  	  	        fuelByConsumed = fuelByConsumed * 100;
  	  	      }
  	  	    }

  	  	    // Choose
  	  	    if (fuelByConsumed != null && fuelByLevel != null) {
  	  	      const diff = Math.abs(fuelByConsumed - fuelByLevel);
  	  	      const rel = diff / fuelByLevel;

  	  	      if (rel <= 0.35) return {
  	  	        fuelUsedL: fuelByConsumed,
  	  	        method: "CAN(consumed)"
  	  	      };
  	  	      return {
  	  	        fuelUsedL: fuelByLevel,
  	  	        method: "CAN(level)"
  	  	      };
  	  	    }

  	  	    if (fuelByConsumed != null) return {
  	  	      fuelUsedL: fuelByConsumed,
  	  	      method: "CAN(consumed)"
  	  	    };
  	  	    if (fuelByLevel != null) return {
  	  	      fuelUsedL: fuelByLevel,
  	  	      method: "CAN(level)"
  	  	    };

  	  	    return {
  	  	      fuelUsedL: null,
  	  	      method: "—"
  	  	    };
  	  	  };

  	  	  const haversineM = (a, b) => {
  	  	    const R = 6371000;
  	  	    const dLat = toRad(b.lat - a.lat);
  	  	    const dLon = toRad(b.lng - a.lng);
  	  	    const sLat = Math.sin(dLat / 2);
  	  	    const sLon = Math.sin(dLon / 2);
  	  	    const cLatA = Math.cos(toRad(a.lat));
  	  	    const cLatB = Math.cos(toRad(b.lat));
  	  	    const aVal = sLat * sLat + cLatA * cLatB * sLon * sLon;
  	  	    return 2 * R * Math.atan2(Math.sqrt(aVal), Math.sqrt(1 - aVal));
  	  	  };

  	  	  const degToCompass = deg =>
  	  	  ["N",
  	  	    "NNE",
  	  	    "NE",
  	  	    "ENE",
  	  	    "E",
  	  	    "ESE",
  	  	    "SE",
  	  	    "SSE",
  	  	    "S",
  	  	    "SSW",
  	  	    "SW",
  	  	    "WSW",
  	  	    "W",
  	  	    "WNW",
  	  	    "NW",
  	  	    "NNW"]
  	  	  [Math.floor(((+deg || 0)+11.25)/22.5)%16];
  	  	  const fmt = (v, u = "", d = 0)=>Number.isFinite(+v)?`${(+v).toFixed(d)}${u}`: "—";
  	  	  const mixColors = (c1, c2, w = 0.5)=> {
  	  	    if (!c1||!c2)return c1 || c2 || "#FFFF00";
  	  	    const h = h=>parseInt(h, 16);
  	  	    const r = Math.round(h(c1.slice(1, 3))*(1-w)+h(c2.slice(1, 3))*w);
  	  	    const g = Math.round(h(c1.slice(3, 5))*(1-w)+h(c2.slice(3, 5))*w);
  	  	    const b = Math.round(h(c1.slice(5, 7))*(1-w)+h(c2.slice(5, 7))*w);
  	  	    return`#${[r,
  	  	      g,
  	  	      b].map(x => x.toString(16).padStart(2, "0")).join("")}`;
  	  	  };

  	  	  // ---------- Timestamp parser (auto ms/seconds) ----------
  	  	  const parseTs = raw => {
  	  	    let t = raw?.timestamp;
  	  	    if (t == null) return null;
  	  	    if (typeof t === "number" && Number.isFinite(t)) return t < 1e12 ? t * 1000: t;
  	  	    if (typeof t === "string") {
  	  	      const n = Number(t);
  	  	      if (Number.isFinite(n)) return n < 1e12 ? n * 1000: n;
  	  	      const d = Date.parse(t);
  	  	      if (Number.isFinite(d)) return d;
  	  	    }
  	  	    return null;
  	  	  };

  	  	  const sumDistanceM = pts => {
  	  	    let s = 0;
  	  	    for (let i = 1; i < pts.length; i++) s += haversineM(pts[i-1], pts[i]);
  	  	    return s;
  	  	  };

  	  	  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

  	  	  // --- Baseline (stable) consumption from CAN file ---
  	  	  // Supports both old + new key names
  	  	  const getBaselineKmPerL = () => {
  	  	    const raw =
  	  	    tractor?.CAN?.["ConsumptionAverage(km/L)"] ??
  	  	    tractor?.CAN?.["ConsumptionAverage(km/l)"];

  	  	    const v = Number(raw);
  	  	    if (!Number.isFinite(v) || v <= 0) return null;

  	  	    // Sanity clamp (adjust if needed for your fleet)
  	  	    return clamp(v, 0.2, 50);
  	  	  };

  	  	  // Estimate km/L near a given point using a trailing window (time OR distance)
  	  	  const estimateKmPerLWindow = (endIdx, tankCap) => {

  	  	    if (!Number.isFinite(endIdx) || endIdx < 0) return {
  	  	      kmPerL: null,
  	  	      method: "—"
  	  	    };

  	  	    const endPt = path[endIdx];
  	  	    const tEnd = parseTs(endPt?.raw);
  	  	    if (!endPt || !Number.isFinite(tEnd)) return {
  	  	      kmPerL: null,
  	  	      method: "—"
  	  	    };

  	  	    // Window targets (tweak if you want)
  	  	    const maxMinutes = 15; // trailing time window
  	  	    const maxDistKm = 4; // OR trailing distance window
  	  	    const maxPointsBack = 250; // cap scan cost

  	  	    let startIdx = endIdx;
  	  	    let distM = 0;
  	  	    let scanned = 0;

  	  	    // Walk backwards until we satisfy either distance or time window
  	  	    while (startIdx > 0 && scanned < maxPointsBack) {
  	  	      const prev = path[startIdx - 1];
  	  	      const cur = path[startIdx];

  	  	      const tPrev = parseTs(prev?.raw);
  	  	      if (!Number.isFinite(tPrev)) break;

  	  	      distM += haversineM(prev, cur);
  	  	      const minutes = (tEnd - tPrev) / 60000;

  	  	      startIdx--;

  	  	      if (distM >= maxDistKm * 1000) break;
  	  	      if (minutes >= maxMinutes) break;

  	  	      scanned++;
  	  	    }

  	  	    const startPt = path[startIdx];
  	  	    if (!startPt) return {
  	  	      kmPerL: null,
  	  	      method: "—"
  	  	    };

  	  	    // Build window points for along-path distance (more realistic than straight-line)
  	  	    const windowPts = path.slice(startIdx, endIdx + 1);
  	  	    const alongKm = windowPts.length >= 2 ? (sumDistanceM(windowPts) / 1000): 0;

  	  	    // Need meaningful movement
  	  	    if (alongKm < 0.25) return {
  	  	      kmPerL: null,
  	  	      method: "—"
  	  	    };

  	  	    const fu = calcFuelUsedBest(startPt.raw, endPt.raw, tankCap);
  	  	    const fuelUsed = fu.fuelUsedL;

  	  	    // Reject tiny / nonsense fuel used
  	  	    if (!(fuelUsed != null && fuelUsed > 0.15)) return {
  	  	      kmPerL: null,
  	  	      method: "—"
  	  	    };

  	  	    let kmPerL = alongKm / fuelUsed;

  	  	    // Clamp to sane range to prevent spikes from tiny denominators
  	  	    kmPerL = clamp(kmPerL, 0.5, 25);

  	  	    return {
  	  	      kmPerL,
  	  	      method: `Window (${fu.method})`
  	  	    };
  	  	  };


  	  	  const hms = ms => {
  	  	    if (!Number.isFinite(ms) || ms < 0) return "—";
  	  	    const s = Math.floor(ms / 1000);
  	  	    const hh = Math.floor(s / 3600);
  	  	    const mm = Math.floor((s % 3600) / 60);
  	  	    const ss = s % 60;
  	  	    return `${hh}:${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
  	  	  };

  	  	  // ---------- Time Formatter ----------
  	  	  const fmtTime = ts => {
  	  	    const t = parseTs({
  	  	      timestamp: ts
  	  	    });
  	  	    if (!t) return "—";
  	  	    const d = new Date(t);
  	  	    return d.toLocaleString("en-ZA", {
  	  	      year: "numeric", month: "short", day: "2-digit",
  	  	      hour: "2-digit", minute: "2-digit", second: "2-digit"
  	  	    });
  	  	  };

  	  	  // ---------- State ----------
  	  	  let isClickLocked = false,
  	  	  hoverPaused = false;
  	  	  let activeInfo = null,
  	  	  hoverMarker = null;
  	  	  const trackMarkers = [];
  	  	  const compareState = {
  	  	    active: false,
  	  	    pointA: null,
  	  	    pointB: null,
  	  	    markerB: null,
  	  	    sectionId: null
  	  	  };

  	  	  function applyCompareMarkerLabel(marker, label) {
  	  	    if (!marker || !label) return;

  	  	    try {
  	  	      const currentIcon = marker.getIcon?.();

  	  	      if (currentIcon && typeof currentIcon === "object") {
  	  	        marker.setIcon({
  	  	          ...currentIcon,
  	  	          labelOrigin: new google.maps.Point(18, -26)
  	  	        });
  	  	      }

  	  	      marker.setLabel({
  	  	        text: String(label),
  	  	        color: "#fff",
  	  	        fontSize: "26px",
  	  	        fontWeight: "950",
  	  	        className: "trackit-compare-marker-label"
  	  	      });

  	  	      marker.setZIndex(label === "A" ? 2100: 2200);
  	  	    } catch (e) {
  	  	      console.warn("[TrackIT Compare] Failed to label marker:", e);
  	  	    }
  	  	  }

  	  	  function startCompareFromPoint(point, button, section) {
  	  	    if (!point) return;

  	  	    if (button) {
  	  	      button.disabled = true;
  	  	      button.textContent = "Select second point…";
  	  	      button.style.opacity = "0.75";
  	  	      button.style.cursor = "default";
  	  	    }

  	  	    if (section) {
  	  	      section.style.display = "block";
  	  	      section.innerHTML = `<div style="color:#aaa;font-size:13px;">Awaiting Point B...</div>`;
  	  	    }

  	  	    compareState.active = true;
  	  	    compareState.pointA = point;
  	  	    compareState.pointB = null;
  	  	    compareState.sectionId = section?.id || null;

  	  	    if (App.FineTrackSelectedMarker?.setMap) {
  	  	      App.FineTrackSelectedMarker.setPosition({
  	  	        lat: point.lat,
  	  	        lng: point.lng
  	  	      });

  	  	      App.FineTrackSelectedMarker.setMap(map);
  	  	      applyCompareMarkerLabel(App.FineTrackSelectedMarker, "A");
  	  	    }

  	  	    unlockRouteMapForCompare();
  	  	  };
  	  	  // ---------- TrackIT Sacred Button Helpers ----------
  	  	  function applyTrackitIconButtonStyle(btn) {
  	  	    Object.assign(btn.style, {
  	  	      width: "40px",
  	  	      height: "40px",
  	  	      minWidth: "40px",
  	  	      maxWidth: "40px",
  	  	      minHeight: "40px",
  	  	      maxHeight: "40px",
  	  	      borderRadius: "15px",
  	  	      border: "none",
  	  	      background: "transparent",
  	  	      color: "#fff",
  	  	      display: "flex",
  	  	      alignItems: "center",
  	  	      justifyContent: "center",
  	  	      padding: "0",
  	  	      margin: "0",
  	  	      cursor: "pointer",
  	  	      lineHeight: "1",
  	  	      boxSizing: "border-box",
  	  	      transition: "box-shadow 0.18s ease",
  	  	      WebkitUserSelect: "none",
  	  	      MozUserSelect: "none",
  	  	      msUserSelect: "none",
  	  	      userSelect: "none",
  	  	      WebkitUserDrag: "none",
  	  	      userDrag: "none",
  	  	      pointerEvents: "auto",
  	  	      outline: "none"
  	  	    });

  	  	    btn.onmouseenter = () => {
  	  	      btn.style.background = "transparent";
  	  	      btn.style.color = "#fff";
  	  	      btn.style.boxShadow = `
  	  	      0 0 0 2px rgba(204,102,51,0.45),
  	  	      0 0 12px rgba(204,102,51,0.72),
  	  	      0 0 24px rgba(204,102,51,0.38)
  	  	      `;
  	  	    };

  	  	    btn.onmouseleave = () => {
  	  	      btn.style.background = "transparent";
  	  	      btn.style.color = "#fff";
  	  	      btn.style.boxShadow = "none";
  	  	    };

  	  	    btn.onmousedown = () => {
  	  	      btn.style.background = "transparent";
  	  	      btn.style.color = "#fff";
  	  	      btn.style.boxShadow = `
  	  	      0 0 0 2px rgba(204,102,51,0.65),
  	  	      0 0 10px rgba(204,102,51,0.85)
  	  	      `;
  	  	    };

  	  	    btn.onmouseup = () => {
  	  	      btn.style.background = "transparent";
  	  	      btn.style.color = "#fff";
  	  	      btn.style.boxShadow = `
  	  	      0 0 0 2px rgba(204,102,51,0.45),
  	  	      0 0 12px rgba(204,102,51,0.72),
  	  	      0 0 24px rgba(204,102,51,0.38)
  	  	      `;
  	  	    };

  	  	    btn.onfocus = () => {
  	  	      btn.style.background = "transparent";
  	  	      btn.style.color = "#fff";
  	  	      btn.style.boxShadow = `
  	  	      0 0 0 2px rgba(204,102,51,0.45),
  	  	      0 0 12px rgba(204,102,51,0.72),
  	  	      0 0 24px rgba(204,102,51,0.38)
  	  	      `;
  	  	    };

  	  	    btn.onblur = () => {
  	  	      btn.style.background = "transparent";
  	  	      btn.style.color = "#fff";
  	  	      btn.style.boxShadow = "none";
  	  	    };
  	  	  }

  	  	  function trackitPrinterIconSvg() {
  	  	    return `
  	  	    <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"
  	  	    fill="currentColor">
  	  	    <path d="M7 3h10a1 1 0 0 1 1 1v4H6V4a1 1 0 0 1 1-1Z"></path>
  	  	    <path d="M6 16H5a3 3 0 0 1-3-3v-3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-1v-4H6v4Z"></path>
  	  	    <path d="M7 13h10v8H7v-8Z"></path>
  	  	    <path d="M9 15h6v1.5H9V15Z" fill="rgba(0,0,0,0.45)"></path>
  	  	    <path d="M9 18h6v1.5H9V18Z" fill="rgba(0,0,0,0.45)"></path>
  	  	    </svg>
  	  	    `;
  	  	  }

  	  	  function normalizeTrackitPanelBodyContent(body) {
  	  	    if (!body) return;

  	  	    Object.assign(body.style, {
  	  	      width: "100%",
  	  	      maxWidth: "none",
  	  	      padding: "10px",
  	  	      margin: "0",
  	  	      boxSizing: "border-box",
  	  	      overflowX: "hidden"
  	  	    });

  	  	    const root =
  	  	    body.querySelector("#popupRoot") ||
  	  	    body.querySelector("[data-trackit-panel-card='true']") ||
  	  	    body.querySelector("div[style*='max-width']") ||
  	  	    body.firstElementChild;

  	  	    if (root && root.style) {
  	  	      root.style.width = "100%";
  	  	      root.style.maxWidth = "none";
  	  	      root.style.minWidth = "0";
  	  	      root.style.margin = "0";
  	  	      root.style.boxSizing = "border-box";
  	  	    }
  	  	  }

  	  	  function trackitCloseIconSvg() {
  	  	    return `
  	  	    <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"
  	  	    fill="none" stroke="currentColor" stroke-width="3"
  	  	    stroke-linecap="round" stroke-linejoin="round">
  	  	    <path d="M6 6l12 12"></path>
  	  	    <path d="M18 6L6 18"></path>
  	  	    </svg>
  	  	    `;
  	  	  }

  	  	  // ---------- Temporary Map Lock while side panel is open ----------
  	  	  let routePanelMapLocked = false;

  	  	  function setRoutePanelMapLocked(locked) {
  	  	    routePanelMapLocked = !!locked;
  	  	    map.__fineTrackRoutePanelMapLocked = routePanelMapLocked;

  	  	    try {
  	  	      if (routePanelMapLocked) {
  	  	        // Stop map movement while the side details panel is open.
  	  	        map.setOptions({
  	  	          draggable: false,
  	  	          scrollwheel: false,
  	  	          disableDoubleClickZoom: true,
  	  	          keyboardShortcuts: false,
  	  	          gestureHandling: "none"
  	  	        });

  	  	        map.getDiv().style.cursor = "default";
  	  	      } else {
  	  	        // Restore map movement.
  	  	        map.setOptions({
  	  	          draggable: true,
  	  	          scrollwheel: true,
  	  	          disableDoubleClickZoom: false,
  	  	          keyboardShortcuts: true,
  	  	          gestureHandling: "auto"
  	  	        });

  	  	        map.getDiv().style.cursor = "";
  	  	      }
  	  	    } catch (e) {
  	  	      console.warn("[TrackIT Route] Map lock failed:", e);
  	  	    }
  	  	  }

  	  	  function lockRouteMapForPanel() {
  	  	    // Do not lock while selecting the second comparison point.
  	  	    if (compareState.active) return;

  	  	    setRoutePanelMapLocked(true);
  	  	  }

  	  	  function unlockRouteMapForCompare() {
  	  	    setRoutePanelMapLocked(false);
  	  	  }

  	  	  function unlockRouteMapFromPanelClose() {
  	  	    setRoutePanelMapLocked(false);
  	  	  }

  	  	  // ---------- Clear Popups / Hover Markers ----------
  	  	  const clearPopup = () => {
  	  	    setRoutePanelMapLocked(false);
  	  	    // Remove hover marker
  	  	    if (hoverMarker?.setMap) hoverMarker.setMap(null);
  	  	    hoverMarker = null;

  	  	    // Close active info window
  	  	    if (activeInfo?.close) activeInfo.close();
  	  	    activeInfo = null;

  	  	    // Reset flags
  	  	    isClickLocked = false;
  	  	    hoverPaused = false;

  	  	    // Clean compare labels / overlay marker
  	  	    if (App.FineTrackSelectedMarker?.setLabel) App.FineTrackSelectedMarker.setLabel(null);
  	  	    if (compareState.markerB?.setMap) compareState.markerB.setMap(null);
  	  	    compareState.markerB = null;
  	  	    compareState.pointA = null;
  	  	    compareState.pointB = null;
  	  	    compareState.sectionId = null;
  	  	    compareState.active = false;

  	  	    // 🧩 NEW: Only clear main marker if user pressed Esc or fully exits (no compare, no panel open)
  	  	    const panelOpen = !!document.getElementById("fineTrackDetachedPopup");
  	  	    if (!compareState.active && !panelOpen && App.FineTrackSelectedMarker?.setMap) {
  	  	      App.FineTrackSelectedMarker.setMap(null);
  	  	      App.FineTrackSelectedMarker = null;
  	  	    }
  	  	  };


  	  	  // ---------- Route Marker Context Report Helpers ----------
  	  	  // These do NOT replace marker click behaviour.
  	  	  // They only add marker context to the big hover/click report.

  	  	  const routeIdleSegments = Array.isArray(tractor?.Events?.["Idle Event"])
  	  	  ? tractor.Events["Idle Event"]: [];

  	  	  function routeMarkerTsMs(v) {
  	  	    if (v == null) return null;

  	  	    if (typeof v === "number") {
  	  	      return Number.isFinite(v) ? (v < 1e12 ? v * 1000: v): null;
  	  	    }

  	  	    if (typeof v === "string") {
  	  	      const n = Number(v);

  	  	      if (Number.isFinite(n)) {
  	  	        return n < 1e12 ? n * 1000: n;
  	  	      }

  	  	      const d = Date.parse(v);
  	  	      return Number.isFinite(d) ? d: null;
  	  	    }

  	  	    return null;
  	  	  }

  	  	  function routeMarkerTime(v) {
  	  	    const ms = routeMarkerTsMs(v);

  	  	    if (!Number.isFinite(ms)) return "—";

  	  	    const d = new Date(ms);
  	  	    if (isNaN(d)) return "—";

  	  	    const pad = n => String(n).padStart(2, "0");

  	  	    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  	  	  }

  	  	  function routeMarkerDuration(seconds) {
  	  	    const s = Number(seconds);

  	  	    if (!Number.isFinite(s) || s < 1) return "0s";

  	  	    const h = Math.floor(s / 3600);
  	  	    const m = Math.floor((s % 3600) / 60);
  	  	    const sec = Math.floor(s % 60);

  	  	    if (h) return `${h}h ${m}m ${sec}s`;
  	  	    if (m) return `${m}m ${sec}s`;
  	  	    return `${sec}s`;
  	  	  }

  	  	  function routePointTime(point) {
  	  	    return routeMarkerTime(point?.raw?.timestamp ?? point?.timestamp);
  	  	  }

  	  	  function routePointIsStart(point) {
  	  	    if (!point || !path.length) return false;
  	  	    return point.idx === path[0].idx;
  	  	  }

  	  	  function routePointIsEnd(point) {
  	  	    if (!point || !path.length) return false;
  	  	    return point.idx === path[path.length - 1].idx;
  	  	  }

  	  	  function routePointSpeed(point) {
  	  	    const n = Number(point?.raw?.["position.speed"]);
  	  	    return Number.isFinite(n) ? n: null;
  	  	  }

  	  	  function routeHasRawIdle(point) {
  	  	    const evs = Array.isArray(point?.raw?.events) ? point.raw.events: [];
  	  	    return evs.some(e => String(e || "").toLowerCase().includes("idle"));
  	  	  }

  	  	  function routeIdleWindowMs(seg) {
  	  	    if (!seg || typeof seg !== "object") return null;

  	  	    const firstPoint = Array.isArray(seg.Points) && seg.Points.length
  	  	    ? seg.Points[0]: null;

  	  	    const lastPoint = Array.isArray(seg.Points) && seg.Points.length
  	  	    ? seg.Points[seg.Points.length - 1]: null;

  	  	    const startMs =
  	  	    routeMarkerTsMs(seg.start_iso) ||
  	  	    routeMarkerTsMs(seg.start) ||
  	  	    routeMarkerTsMs(firstPoint?.timestamp);

  	  	    let endMs = routeMarkerTsMs(lastPoint?.timestamp);

  	  	    if (!Number.isFinite(endMs) && Number.isFinite(startMs) && Number.isFinite(Number(seg.idle_seconds))) {
  	  	      endMs = startMs + Number(seg.idle_seconds) * 1000;
  	  	    }

  	  	    if (!Number.isFinite(startMs)) return null;

  	  	    if (!Number.isFinite(endMs)) {
  	  	      endMs = startMs;
  	  	    }

  	  	    return {
  	  	      startMs,
  	  	      endMs
  	  	    };
  	  	  }

  	  	  function routeIdlePosition(seg) {
  	  	    if (!seg || typeof seg !== "object") return null;

  	  	    let lat = Number(seg.lat ?? seg.latitude);
  	  	    let lng = Number(seg.lon ?? seg.lng ?? seg.longitude);

  	  	    if ((!Number.isFinite(lat) || !Number.isFinite(lng)) && Array.isArray(seg.Points) && seg.Points.length) {
  	  	      const p = seg.Points[0];

  	  	      lat = Number(
  	  	        p.lat ??
  	  	        p.latitude ??
  	  	        p.point?.["position.latitude"]
  	  	      );

  	  	      lng = Number(
  	  	        p.lon ??
  	  	        p.lng ??
  	  	        p.longitude ??
  	  	        p.point?.["position.longitude"]
  	  	      );
  	  	    }

  	  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  	  	    return {
  	  	      lat,
  	  	      lng
  	  	    };
  	  	  }

  	  	  function routeFindIdleSegment(point) {
  	  	    if (!point || !routeIdleSegments.length) return null;

  	  	    const pointMs = routeMarkerTsMs(point.raw?.timestamp ?? point.timestamp);
  	  	    const pointLat = Number(point.lat ?? point.raw?.["position.latitude"]);
  	  	    const pointLng = Number(point.lng ?? point.lon ?? point.raw?.["position.longitude"]);

  	  	    if (Number.isFinite(pointMs)) {
  	  	      for (const seg of routeIdleSegments) {
  	  	        const win = routeIdleWindowMs(seg);
  	  	        if (!win) continue;

  	  	        const padMs = 15000;

  	  	        if (pointMs >= win.startMs - padMs && pointMs <= win.endMs + padMs) {
  	  	          return seg;
  	  	        }
  	  	      }
  	  	    }

  	  	    if (Number.isFinite(pointLat) && Number.isFinite(pointLng)) {
  	  	      for (const seg of routeIdleSegments) {
  	  	        const pos = routeIdlePosition(seg);
  	  	        if (!pos) continue;

  	  	        const d = haversineM(
  	  	          {
  	  	            lat: pointLat, lng: pointLng
  	  	          },
  	  	          {
  	  	            lat: pos.lat, lng: pos.lng
  	  	          }
  	  	        );

  	  	        if (d <= 60) {
  	  	          return seg;
  	  	        }
  	  	      }
  	  	    }

  	  	    return null;
  	  	  }

  	  	  function routePointIsIdle(point) {
  	  	    return !!routeFindIdleSegment(point) || routeHasRawIdle(point);
  	  	  }

  	  	  function routePointIsStopped(point) {
  	  	    const spd = routePointSpeed(point);
  	  	    return Number.isFinite(spd) && spd < 1;
  	  	  }

  	  	  function routeBuildStopSegments() {
  	  	    const segments = [];
  	  	    let current = null;

  	  	    function flush() {
  	  	      if (current && current.points.length) {
  	  	        segments.push(current);
  	  	      }

  	  	      current = null;
  	  	    }

  	  	    path.forEach(point => {
  	  	      const stopped = routePointIsStopped(point);
  	  	      const idle = routePointIsIdle(point);

  	  	      // Stopped-only becomes red.
  	  	      // Real idle becomes yellow, not red.
  	  	      if (stopped && !idle) {
  	  	        if (!current) {
  	  	          current = {
  	  	            points: []
  	  	          };
  	  	        }

  	  	        current.points.push(point);
  	  	      } else {
  	  	        flush();
  	  	      }
  	  	    });

  	  	    flush();

  	  	    return segments;
  	  	  }

  	  	  const routeStopSegments = routeBuildStopSegments();

  	  	  function routeFindStopSegment(point) {
  	  	    if (!point || !routeStopSegments.length) return null;

  	  	    return routeStopSegments.find(seg =>
  	  	      Array.isArray(seg.points) &&
  	  	      seg.points.some(p => p.idx === point.idx)
  	  	    ) || null;
  	  	  }

  	  	  function routeStopDurationSeconds(seg) {
  	  	    if (!seg || !Array.isArray(seg.points) || !seg.points.length) return 0;

  	  	    const first = seg.points[0];
  	  	    const last = seg.points[seg.points.length - 1];

  	  	    const startMs = routeMarkerTsMs(first.raw?.timestamp ?? first.timestamp);
  	  	    const endMs = routeMarkerTsMs(last.raw?.timestamp ?? last.timestamp);

  	  	    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return 0;

  	  	    return Math.max(0, Math.round((endMs - startMs) / 1000));
  	  	  }

  	  	  function routeMarkerContextHtml(point) {
  	  	    if (!point) return "";

  	  	    const rows = [];

  	  	    if (routePointIsStart(point)) {
  	  	      rows.push({
  	  	        color: "#00cc44",
  	  	        title: "Start Marker",
  	  	        lines: [
  	  	          `Time: ${routePointTime(point)}`
  	  	        ]
  	  	      });
  	  	    }

  	  	    const idleSeg = routeFindIdleSegment(point);

  	  	    if (idleSeg || routeHasRawIdle(point)) {
  	  	      const idleStart =
  	  	      routeMarkerTime(idleSeg?.start_iso) ||
  	  	      routeMarkerTime(idleSeg?.start) ||
  	  	      routeMarkerTime(idleSeg?.Points?.[0]?.timestamp) ||
  	  	      routePointTime(point);

  	  	      const idleText =
  	  	      idleSeg?.idle_human ||
  	  	      routeMarkerDuration(idleSeg?.idle_seconds || 0);

  	  	      rows.push({
  	  	        color: "#ffcc00",
  	  	        title: "Idle Marker",
  	  	        lines: [
  	  	          `Start: ${idleStart}`,
  	  	          `Idle: ${idleText}`
  	  	        ]
  	  	      });
  	  	    }

  	  	    const stopSeg = routeFindStopSegment(point);

  	  	    if (stopSeg) {
  	  	      rows.push({
  	  	        color: "#cc0000",
  	  	        title: "Stopped Marker",
  	  	        lines: [
  	  	          `Stopped Time: ${routePointTime(stopSeg.points[0])}`,
  	  	          `Duration: ${routeMarkerDuration(routeStopDurationSeconds(stopSeg))}`
  	  	        ]
  	  	      });
  	  	    }

  	  	    if (routePointIsEnd(point)) {
  	  	      rows.push({
  	  	        color: "#cc0000",
  	  	        title: "End Marker",
  	  	        lines: [
  	  	          `Time: ${routePointTime(point)}`
  	  	        ]
  	  	      });
  	  	    }

  	  	    if (!rows.length) return "";

  	  	    return `
  	  	    <div style="margin-top:10px;border-top:1px solid #333;padding-top:8px;">
  	  	    <b>Marker Report:</b>
  	  	    ${rows.map(row => `
  	  	      <div style="
  	  	      margin-top:6px;
  	  	      padding:7px 8px;
  	  	      border-radius:7px;
  	  	      background:#000;
  	  	      border-left:4px solid ${row.color};
  	  	      ">
  	  	      <div style="font-weight:700;color:${row.color};">${row.title}</div>
  	  	      <div style="margin-top:3px;line-height:1.4;color:#fff;">
  	  	      ${row.lines.join("<br>")}
  	  	      </div>
  	  	      </div>
  	  	      `).join("")}
  	  	    </div>
  	  	    `;
  	  	  }

  	  	  // ---------- Popup ----------
  	  	  const showPopup = (point, isClick) => {
  	  	    const raw = point.raw; if (!raw) return;
  	  	    // --- Fuel Live Calculations ---
  	  	    const tankCap = +tractor?.CAN?.Tank || 0;

  	  	    // --- Fuel percentage fallback ---
  	  	    const fuelPct = smartFuelPct(raw, tankCap);
  	  	    const fuelLitres =
  	  	    (Number.isFinite(fuelPct) && Number.isFinite(tankCap) && tankCap > 0)
  	  	    ? (fuelPct / 100) * tankCap: null;



  	  	    // --- Range: baseline (stable) first, then window, then trip fallback ---
  	  	    const endIdx = Number.isFinite(point.idx) ? point.idx: null;

  	  	    let kmPerL = null;
  	  	    let kmPerLMethod = "—";

  	  	    // 1) Baseline from CAN config (most stable)
  	  	    const baselineKmPerL = getBaselineKmPerL();
  	  	    if (baselineKmPerL != null) {
  	  	      kmPerL = baselineKmPerL;
  	  	      kmPerLMethod = "CAN Avg (km/L)";
  	  	    }

  	  	    // 2) Window estimate (optional improvement if you want it, only used if no baseline)
  	  	    if (kmPerL == null && endIdx != null) {
  	  	      const est = estimateKmPerLWindow(endIdx, tankCap);
  	  	      kmPerL = est.kmPerL;
  	  	      kmPerLMethod = est.method;
  	  	    }

  	  	    // 3) Trip fallback (only if no baseline and no window)
  	  	    if (kmPerL == null) {
  	  	      const tracking = tractor?.Tracking || [];
  	  	      const first = tracking[0] || {};
  	  	      const startOdo = smartOdoKm(first);
  	  	      const curOdo = smartOdoKm(raw);

  	  	      const fuTrip = calcFuelUsedBest(first, raw, tankCap);
  	  	      const fuelUsedTrip = fuTrip.fuelUsedL;

  	  	      const distKmTrip =
  	  	      (Number.isFinite(startOdo) && Number.isFinite(curOdo))
  	  	      ? (curOdo - startOdo): null;

  	  	      if (fuelUsedTrip != null && fuelUsedTrip > 0.5 && distKmTrip != null && distKmTrip > 0.5) {
  	  	        kmPerL = clamp(distKmTrip / fuelUsedTrip, 0.5, 25);
  	  	        kmPerLMethod = `Trip (${fuTrip.method})`;
  	  	      }
  	  	    }

  	  	    const fuelRange =
  	  	    (kmPerL != null && fuelLitres != null)
  	  	    ? (fuelLitres * kmPerL): null;



  	  	    const heading = +raw["position.direction"] || 0;
  	  	    const fill = tractor.color || "#2196F3";
  	  	    const events = Array.isArray(raw.events) ? raw.events: [];
  	  	    const markerContextHtml = routeMarkerContextHtml(point);
  	  	    if (hoverMarker?.setMap) hoverMarker.setMap(null);

  	  	    const marker = new google.maps.Marker({
  	  	      position: {
  	  	        lat: point.lat, lng: point.lng
  	  	      }, map,
  	  	      icon: {
  	  	        path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	  	        fillColor: fill, fillOpacity: 1, strokeWeight: 2, strokeColor: "#fff",
  	  	        rotation: heading, scale: 1.6, anchor: new google.maps.Point(0, 0)
  	  	      },
  	  	      zIndex: 1200
  	  	    });

  	  	    registerFineTrackOverlay(map, marker);

  	  	    // 🧩 Ensure global reference before any click listeners
  	  	    App.FineTrackSelectedMarker = marker;


  	  	    marker.addListener("click", () => {
  	  	      // 🧩 Do NOT clear active marker; only reset overlays and info
  	  	      if (activeInfo?.close) activeInfo.close();
  	  	      activeInfo = null;
  	  	      document.getElementById("fineTrackDetachedPopup")?.remove();


  	  	      // === Build Full Snapshot HTML (with Compare Integration) ===
  	  	      const driverObj = App?.SelectedTractor?.FVC?.Driver1;
  	  	      const driverName = driverObj?.name || "—";
  	  	      const driverPhone = driverObj?.Data_Details?.employee_details?.contact_details?.phone_number || "—";
  	  	      const driverEmail = driverObj?.email || "—";

  	  	      const spd = +point.raw["position.speed"];
  	  	      const rpm = +point.raw["can.engine.rpm"];
  	  	      const tmp = +point.raw["can.engine.temperature"];
  	  	      const alt = +point.raw["position.altitude"];
  	  	      const dir = +point.raw["position.direction"];
  	  	      const tankCap = +tractor?.CAN?.Tank || 0;
  	  	      const fuelPct = smartFuelPct(point.raw, tankCap);
  	  	      const fuelLitres =
  	  	      (Number.isFinite(fuelPct) && Number.isFinite(tankCap) && tankCap > 0)
  	  	      ? (fuelPct / 100) * tankCap: null;


  	  	      const events = Array.isArray(point.raw.events) ? point.raw.events: [];

  	  	      const html = `
  	  	      <div data-trackit-panel-card="true" style="
  	  	      width:100%;
  	  	      max-width:none;
  	  	      min-width:0;
  	  	      box-sizing:border-box;
  	  	      font:14px system-ui,sans-serif;
  	  	      color:#fff;
  	  	      background:#0b0f14;
  	  	      padding:10px;
  	  	      border-radius:8px;
  	  	      ">
  	  	      <div style="font-weight:600;margin-bottom:8px;">Point Details</div>
  	  	      <div><b>Driver:</b> ${driverName}</div>
  	  	      <div><b>Mobile:</b> ${driverPhone}</div>
  	  	      <div><b>Email:</b> ${driverEmail}</div>
  	  	      <div style="margin-top:8px;"><b>Time:</b> ${fmtTime(point.raw.timestamp)}</div>

  	  	      <div style="margin-top:10px;padding:6px 8px;border-radius:6px;
  	  	      background:${tmp > limTmp ? '#ffc107': '#000'};color:${tmp > limTmp ? '#000': '#fff'};">
  	  	      Engine Temp: ${fmt(tmp, '°C')}
  	  	      </div>

  	  	      <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	  	      background:${spd > limSpd ? '#CC6633': '#000'};color:#fff;">
  	  	      Speed: ${fmt(spd, ' km/h')} <span style="opacity:0.6">(limit ${limSpd})</span>
  	  	      </div>

  	  	      <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	  	      background:${rpm > limRpm ? '#9c27b0': '#000'};color:#fff;">
  	  	      RPM: ${fmt(rpm, ' RPM')} <span style="opacity:0.6">(limit ${limRpm})</span>
  	  	      </div>


  	  	      <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	  	      background:${(+raw["can.throttle.pedal.level"] || 0) > limThrottle ? '#00b7ff': '#000'};
  	  	      color:${(+raw["can.throttle.pedal.level"] || 0) > limThrottle ? '#000': '#fff'};">
  	  	      Throttle: ${fmt(+raw["can.throttle.pedal.level"], ' %')} <span style="opacity:0.6">(limit ${limThrottle}%)</span>
  	  	      </div>

  	  	      <div style="margin-top:10px;">
  	  	      <b>Altitude:</b> ${fmt(alt, ' m')}<br>
  	  	      <b>Direction:</b> ${degToCompass(dir)}
  	  	      </div>

  	  	      <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	  	      <b>Fuel Stats:</b><br>
  	  	      Fuel Level: ${fmt(fuelPct, "%")}<br>
  	  	      Fuel Litres: ${fmt(fuelLitres, " L", 1)}
  	  	      <div style="margin-top:8px;display:flex;align-items:center;gap:6px;">
  	  	      <div style="width:16px;text-align:left;font-size:12px;color:#aaa;">E</div>
  	  	      <div style="flex:1;height:12px;background:#222;border-radius:6px;overflow:hidden;position:relative;">
  	  	      <div style="width:${fuelPct}%;height:100%;
  	  	      background:${fuelPct > 70 ? '#00cc44': fuelPct > 35 ? '#ffcc00': '#ff1a1a'};
  	  	      border-radius:6px;transition:width 0.5s ease-out;"></div>
  	  	      </div>
  	  	      <div style="width:16px;text-align:right;font-size:12px;color:#aaa;">F</div>
  	  	      </div>
  	  	      </div>

  	  	      <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	  	      <b>Events at this point:</b>
  	  	      ${events.length
  	  	      ? `<ul style="margin:4px 0;padding-left:16px;">${events.map(ev => `<li>${ev}</li>`).join("")}</ul>`: `<div style="color:#999;font-size:12px;">No events</div>`}
  	  	      </div>

  	  	      ${markerContextHtml}

  	  	      <button id="cmpBtn"
  	  	      style="margin-top:14px;padding:8px 10px;background:#2196F3;color:#fff;
  	  	      border:none;border-radius:8px;cursor:pointer;width:100%;font-weight:600;">
  	  	      Compare from here
  	  	      </button>
  	  	      </div>
  	  	      `;

  	  	      attachLeftComparePanel(point, Hub);

  	  	      // Lock map while the side panel is open.
  	  	      // It unlocks when Compare from here or X is pressed.
  	  	      lockRouteMapForPanel();

  	  	      const panel = document.getElementById("fineTrackDetachedPopup");
  	  	      if (panel) {
  	  	        const body = panel.querySelector("#panelBody");
  	  	        if (body) {
  	  	          body.innerHTML = html;
  	  	          normalizeTrackitPanelBodyContent(body);

  	  	          body.scrollTo({
  	  	            top: 0,
  	  	            behavior: "smooth"
  	  	          });

  	  	          const cmpBtn = body.querySelector("#cmpBtn");
  	  	          if (cmpBtn) {
  	  	            cmpBtn.onclick = () => {
  	  	              startCompareFromPoint(point, cmpBtn, null);
  	  	            };
  	  	          }
  	  	        }
  	  	      }

  	  	      hoverPaused = true;
  	  	    });

  	  	    if (isClick) {
  	  	      App.FineTrackSelectedMarker = marker; isClickLocked = true;
  	  	    } else {
  	  	      hoverMarker = marker;
  	  	    }

  	  	    // ---------- Driver Data (from FVC.Driver1) ----------
  	  	    const driverObj = App?.SelectedTractor?.FVC?.Driver1;
  	  	    const driverName = driverObj?.name || "—";
  	  	    const driverPhone = driverObj?.Data_Details?.employee_details?.contact_details?.phone_number || "—";
  	  	    const driverEmail = driverObj?.email || "—";


  	  	    const spd = +raw["position.speed"];
  	  	    const rpm = +raw["can.engine.rpm"];
  	  	    const tmp = +raw["can.engine.temperature"];
  	  	    const alt = +raw["position.altitude"];
  	  	    const dir = +raw["position.direction"];
  	  	    const limSpd = +tractor?.CAN?.Speed || 80;
  	  	    const limRpm = +tractor?.CAN?.RPM || 1500;
  	  	    const limTmp = +tractor?.CAN?.Temp || 100;
  	  	    const limThrottle = +tractor?.CAN?.ThrottlePct || 85;
  	  	    const tempOver = tmp > limTmp,
  	  	    speedOver = spd > limSpd,
  	  	    rpmOver = rpm > limRpm;
  	  	    const eventList = events.length
  	  	    ? `<ul id="eventList" style="padding-left:16px;margin:6px 0;color:#fff;font-size:13px;list-style-type:disc;">
  	  	    ${events.map((ev, i) => `<li data-ev-index="${i}" data-ev='${JSON.stringify(ev)}' style="cursor:pointer;">${ev}</li>`).join("")}
  	  	    </ul>`: `<div style="color:#aaa;font-size:13px;margin-top:4px;">No active events</div>`;;
  	  	    const compareBtnId = `cmp_${Math.random().toString(36).slice(2)}`;
  	  	    const cmpSectionId = `cmp_sec_${compareBtnId}`;
  	  	    const compareBtnHTML = isClick
  	  	    ? `<button id="${compareBtnId}" style="margin-top:12px;padding:8px 10px;background:#2196F3;color:#fff;border:none;border-radius:8px;cursor:pointer;width:100%;font-weight:600">📊 Compare from here</button>`: "";

  	  	    const content = `
  	  	    <div id="popupRoot" style="font:14px system-ui,sans-serif;background:#111;border-radius:10px;padding:12px;min-width:260px;max-width:340px;color:#fff;">
  	  	    <div><b>Driver:</b> ${driverName}</div>
  	  	    <div><b>Mobile:</b> ${driverPhone}</div>
  	  	    <div><b>Email:</b> ${driverEmail}</div>
  	  	    <div style="margin-top:8px;"><b>Time:</b> ${fmtTime(raw.timestamp)}</div>
  	  	    <div style="margin:10px 0 0;padding:6px 8px;border-radius:6px;font-weight:500;
  	  	    background:${tempOver ? '#ffc107': '#000'};color:${tempOver ? '#000': '#fff'};">
  	  	    Engine Temp: ${fmt(tmp, '°C')} <span style="opacity:0.6">(limit ${limTmp}°C)</span>
  	  	    </div>

  	  	    <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	  	    background:${speedOver ? '#CC6633': '#000'};color:#fff;">
  	  	    Speed: ${fmt(spd, ' km/h')} <span style="opacity:0.6">(limit ${limSpd})</span>
  	  	    </div>

  	  	    <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	  	    background:${rpmOver ? '#9c27b0': '#000'};color:#fff;">
  	  	    RPM: ${fmt(rpm, ' RPM')} <span style="opacity:0.6">(limit ${limRpm})</span>
  	  	    </div>

  	  	    <div style="margin-top:6px;padding:6px 8px;border-radius:6px;
  	  	    background:${(+raw["can.throttle.pedal.level"] || 0) > limThrottle ? '#00b7ff': '#000'};
  	  	    color:${(+raw["can.throttle.pedal.level"] || 0) > limThrottle ? '#000': '#fff'};">
  	  	    Throttle: ${fmt(+raw["can.throttle.pedal.level"], ' %')} <span style="opacity:0.6">(limit ${limThrottle}%)</span>
  	  	    </div>
  	  	    <div style="margin-top:10px;">
  	  	    <b>Altitude:</b> ${fmt(alt, ' m')}<br><b>Direction:</b> ${degToCompass(dir)}
  	  	    </div>
  	  	    <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	  	    <b>Fuel Stats:</b><br>
  	  	    <div style="margin-top:4px;font-size:13px;line-height:1.4;">
  	  	    <span style="opacity:.8;">Fuel Level:</span> ${fmt(fuelPct, "%", 0)}<br>
  	  	    <span style="opacity:.8;">Fuel Litres:</span> ${fmt(fuelLitres, " L", 1)}<br>
  	  	    <span style="opacity:.8;">Range:</span> ${fmt(fuelRange, " km", 1)}
  	  	    <span style="opacity:.55;font-size:12px;"> (${kmPerLMethod})</span>

  	  	    </div>

  	  	    <!-- Gauge -->
  	  	    <div style="margin-top:8px;display:flex;align-items:center;gap:6px;">
  	  	    <div style="width:16px;text-align:left;font-size:12px;color:#aaa;">E</div>

  	  	    ${(() => {
  	  	      const level = Math.min(100, Math.max(0, fuelPct));
  	  	      const rawLow = +tractor?.CAN?.LowFuel || 0;
  	  	      const lowFuel = rawLow < 1 ? rawLow * 100: rawLow;
  	  	      const isLow = level <= lowFuel;

  	  	      const color =
  	  	      level > 70 ? "#00cc44":
  	  	      level > 35 ? "#ffcc00":
  	  	      "#ff1a1a";

  	  	      // Outer gauge container throbs when low
  	  	      return `
  	  	      <div style="
  	  	      flex:1;
  	  	      height:12px;
  	  	      background:#222;
  	  	      border-radius:6px;
  	  	      overflow:hidden;
  	  	      position:relative;
  	  	      ${isLow ? 'animation:fuelPulse 1.2s infinite ease-in-out;': ''}
  	  	      ">
  	  	      <div style="
  	  	      width:${level}%;
  	  	      height:100%;
  	  	      background:${color};
  	  	      border-radius:6px;
  	  	      transition:width 0.5s ease-out;
  	  	      "></div>

  	  	      <div style="
  	  	      position:absolute;
  	  	      top:-18px;
  	  	      right:4px;
  	  	      font-size:12px;
  	  	      font-weight:600;
  	  	      color:${isLow ? '#ff4444': '#aaa'};
  	  	      ${isLow ? 'animation:fuelPulse 1.2s infinite ease-in-out;': ''}
  	  	      ">${level.toFixed(0)}%</div>
  	  	      </div>
  	  	      `;
  	  	    })()}

  	  	    <div style="width:16px;text-align:right;font-size:12px;color:#aaa;">F</div>
  	  	    </div>

  	  	    </div>


  	  	    <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	  	    <b>Events at this point:</b>${eventList}
  	  	    </div>

  	  	    ${markerContextHtml}

  	  	    ${compareBtnHTML}
  	  	    <div id="${cmpSectionId}" style="display:none;margin-top:10px;"></div>
  	  	    </div>`;

  	  	    if (!isClick) {
  	  	      if (activeInfo) activeInfo.close();
  	  	      const info = new google.maps.InfoWindow({
  	  	        content
  	  	      });
  	  	      registerFineTrackOverlay(map, info);

  	  	      info.open(map, marker);
  	  	      activeInfo = info;

  	  	      google.maps.event.addListener(info, "closeclick", () => {
  	  	        clearPopup();
  	  	        clearCompareOverlays();
  	  	      });
  	  	    }


  	  	  };

  	  	  function detachPopup(info, map, point, Hub) {
  	  	    document.getElementById("fineTrackDetachedPopup")?.remove();

  	  	    // If we're in compare mode, skip InfoWindow copy and attach a left panel
  	  	    if (compareState.active) {
  	  	      attachLeftComparePanel(point, Hub);
  	  	      return;
  	  	    }

  	  	    const iwOuter = map.getDiv().querySelector(".gm-style-iw");
  	  	    if (!iwOuter) return;


  	  	    let hubEl = Hub?.el || Hub;
  	  	    if (!hubEl || !(hubEl instanceof HTMLElement)) {
  	  	      hubEl = document.body;
  	  	    }


  	  	    const detached = document.createElement("div");
  	  	    registerFineTrackElement(map, detached);

  	  	    detached.id = "fineTrackDetachedPopup";
  	  	    detached.innerHTML = iwOuter.innerHTML;

  	  	    // --- Wire up Compare button inside detached panel ---
  	  	    setTimeout(() => {
  	  	      const cmpBtn = detached.querySelector("button[id^='cmp_']");
  	  	      const cmpSec = detached.querySelector("div[id^='cmp_sec_']");
  	  	      if (cmpBtn && cmpSec) {
  	  	        cmpBtn.onclick = () => {
  	  	          startCompareFromPoint(
  	  	            point,
  	  	            cmpBtn,
  	  	            cmpSec
  	  	          );
  	  	        };
  	  	      }
  	  	    },
  	  	      100);


  	  	    // Remove pin + close buttons
  	  	    detached.querySelectorAll("#detachBtn, .gm-ui-hover-effect").forEach(el => el.remove());

  	  	    // === Core container styles ===
  	  	    Object.assign(detached.style,
  	  	      {
  	  	        position: "fixed",
  	  	        background: "rgba(20,20,20,0.96)",
  	  	        color: "#fff",
  	  	        zIndex: 9999,
  	  	        borderRadius: "10px",
  	  	        borderTop: "2px solid #CC6633",
  	  	        boxShadow: "0 4px 12px rgba(204,102,51,0.6)",
  	  	        fontFamily: "Segoe UI, sans-serif",
  	  	        animation: "fadeIn 0.35s ease",
  	  	        overflowY: "auto",
  	  	        overflowX: "hidden",
  	  	        scrollBehavior: "smooth"
  	  	      });

  	  	    // --- Sticky reattach header ---
  	  	    const header = document.createElement("div");
  	  	    Object.assign(header.style,
  	  	      {
  	  	        position: "sticky",
  	  	        top: "0",
  	  	        background: "rgba(25,25,25,0.98)",
  	  	        padding: "8px",
  	  	        borderBottom: "1px solid rgba(204,102,51,0.4)",
  	  	        zIndex: 10
  	  	      });

  	  	    const reBtn = document.createElement("button");
  	  	    reBtn.textContent = "↩ Reattach";
  	  	    Object.assign(reBtn.style,
  	  	      {
  	  	        background: "#CC6633",
  	  	        color: "#fff",
  	  	        border: "none",
  	  	        borderRadius: "6px",
  	  	        padding: "6px 12px",
  	  	        cursor: "pointer",
  	  	        fontWeight: "600",
  	  	        width: "100%",
  	  	        boxShadow: "0 0 8px rgba(204,102,51,0.6)",
  	  	      });
  	  	    reBtn.onclick = () => {
  	  	      detached.remove();
  	  	      showPopup(point,
  	  	        true);

  	  	      // 🔄 After the popup is recreated, restore compare if active
  	  	      setTimeout(() => {
  	  	        if (compareState.active && compareState.pointA && compareState.sectionId) {
  	  	          const sec = document.getElementById(compareState.sectionId);
  	  	          if (sec && compareState.markerB) {
  	  	            const html = buildInlineReport(compareState.pointA, {
  	  	              lat: compareState.markerB.getPosition().lat(),
  	  	              lng: compareState.markerB.getPosition().lng(),
  	  	              raw: compareState.markerB.raw || {} // fallback if needed
  	  	            });
  	  	            sec.innerHTML = html;
  	  	            sec.style.display = "block";
  	  	          }
  	  	        }
  	  	      },
  	  	        200);
  	  	    };

  	  	    header.appendChild(reBtn);

  	  	    // Add header before other content
  	  	    detached.prepend(header);

  	  	    // --- Position flush under Hub ---
  	  	    function positionPopup() {
  	  	      try {
  	  	        const rect = hubEl.getBoundingClientRect();
  	  	        const headerBar = document.querySelector("header, .topbar, .navbar, #top-bar");
  	  	        const headerH = headerBar ? headerBar.getBoundingClientRect().height: 0;

  	  	        detached.style.left = `${rect.left}px`;
  	  	        detached.style.top = `${rect.bottom}px`;
  	  	        detached.style.width = `${rect.width}px`;
  	  	        detached.style.height = `calc(100vh - ${rect.bottom - headerH}px)`;
  	  	        detached.style.maxHeight = `calc(100vh - ${rect.top}px)`;
  	  	      } catch (err) {
  	  	        console.warn("Positioning error:",
  	  	          err);
  	  	      }
  	  	    }

  	  	    document.body.appendChild(detached);
  	  	    // 🔧 Make sure it's above Google Maps overlays
  	  	    detached.style.pointerEvents = "auto";
  	  	    detached.style.zIndex = 9999999;

  	  	    // Fix for Google Maps parent clipping
  	  	    const mapCanvas = map.getDiv().querySelector("canvas");
  	  	    if (mapCanvas && mapCanvas.parentElement) {
  	  	      mapCanvas.parentElement.style.overflow = "visible";
  	  	    }
  	  	    // --- Attach BELOW Hub (use ONLY passed Hub) ---
  	  	    const hubElAuto = Hub?.el || Hub;

  	  	    if (!(hubElAuto instanceof HTMLElement)) {
  	  	      console.error("❌ Invalid Hub reference. Hub must be a DOM element or have .el.");
  	  	      return;
  	  	    }


  	  	    // --- Wait until Hub has proper size before attaching ---
  	  	    function waitForStableHub(callback, attempts = 0) {
  	  	      const rect = hubElAuto.getBoundingClientRect();
  	  	      const ready = rect.width > 100 && rect.height > 50; // sanity check

  	  	      if (ready) {
  	  	        callback(rect);
  	  	      } else if (attempts < 50) {
  	  	        requestAnimationFrame(() => waitForStableHub(callback, attempts + 1));
  	  	      } else {
  	  	        console.warn("⚠️ Hub never stabilized — using current rect anyway");
  	  	        callback(rect);
  	  	      }
  	  	    }

  	  	    // --- Final attachment logic (Full-height below Hub, same width) ---
  	  	    waitForStableHub((rect) => {
  	  	      const headerBar = document.querySelector("header, .topbar, .navbar, #top-bar");
  	  	      const headerH = headerBar ? headerBar.getBoundingClientRect().height: 0;

  	  	      Object.assign(detached.style, {
  	  	        position: "fixed",
  	  	        left: `${rect.left}px`, // align with Hub
  	  	        top: `${rect.bottom + 0}px`, // directly below Hub
  	  	        width: `${rect.width}px`, // same width as Hub
  	  	        height: `calc(100vh - ${rect.bottom + 12}px)`, // fill rest of vertical space
  	  	        background: "rgba(20,20,20,0.96)",
  	  	        color: "#fff",
  	  	        zIndex: 9999999,
  	  	        borderRadius: "10px",
  	  	        borderTop: "2px solid #CC6633",
  	  	        boxShadow: "0 4px 12px rgba(204,102,51,0.6)",
  	  	        overflowY: "auto",
  	  	        overflowX: "hidden",
  	  	        scrollBehavior: "smooth",
  	  	        pointerEvents: "auto",
  	  	        display: "block",
  	  	        opacity: "1",
  	  	        visibility: "visible",
  	  	      });

  	  	    });



  	  	    info.close();

  	  	    // Optional scroll focus
  	  	    try {
  	  	      hubEl.scrollIntoView({
  	  	        behavior: "smooth", block: "end"
  	  	      });
  	  	    } catch (e) {
  	  	      console.warn("Hub scroll error:", e);
  	  	    }

  	  	  }

  	  	  function attachLeftComparePanel(point, Hub) {
  	  	    // Remove any old version.
  	  	    document.getElementById("fineTrackDetachedPopup")?.remove();

  	  	    const panel = document.createElement("div");
  	  	    registerFineTrackElement(map, panel);

  	  	    panel.id = "fineTrackDetachedPopup";

  	  	    Object.assign(panel.style, {
  	  	      position: "fixed",
  	  	      top: "50px",
  	  	      left: "0",
  	  	      width: "300px",
  	  	      height: "calc(100vh - 50px)",
  	  	      background: "rgba(20,20,20,0.96)",
  	  	      color: "#fff",
  	  	      borderRight: "2px solid #CC6633",
  	  	      overflowY: "auto",
  	  	      overflowX: "hidden",
  	  	      animation: "fadeIn 0.35s ease",
  	  	      zIndex: 9999999,
  	  	      fontFamily: "Segoe UI, sans-serif",
  	  	      boxShadow: "4px 0 12px rgba(204,102,51,0.5)",
  	  	      boxSizing: "border-box"
  	  	    });

  	  	    // --- Header ---
  	  	    const header = document.createElement("div");

  	  	    Object.assign(header.style, {
  	  	      position: "sticky",
  	  	      top: "0",
  	  	      height: "50px",
  	  	      minHeight: "50px",
  	  	      background: "rgba(25,25,25,0.98)",
  	  	      padding: "5px 8px",
  	  	      borderBottom: "1px solid rgba(204,102,51,0.4)",
  	  	      display: "flex",
  	  	      justifyContent: "space-between",
  	  	      alignItems: "center",
  	  	      fontWeight: "600",
  	  	      color: "#CC6633",
  	  	      zIndex: 10,
  	  	      boxSizing: "border-box"
  	  	    });

  	  	    const headerTitle = document.createElement("div");
  	  	    headerTitle.textContent = compareState.active ? "Point Compare": "Point Details";

  	  	    Object.assign(headerTitle.style, {
  	  	      flex: "1 1 auto",
  	  	      minWidth: "0",
  	  	      overflow: "hidden",
  	  	      whiteSpace: "nowrap",
  	  	      textOverflow: "ellipsis"
  	  	    });

  	  	    header.appendChild(headerTitle);

  	  	    const headerActions = document.createElement("div");

  	  	    Object.assign(headerActions.style, {
  	  	      display: "flex",
  	  	      alignItems: "center",
  	  	      justifyContent: "flex-end",
  	  	      gap: "8px",
  	  	      flex: "0 0 auto"
  	  	    });

  	  	    // Print button: works for both single-point and compare reports.
  	  	    if (point) {
  	  	      const printBtn = document.createElement("button");
  	  	      printBtn.type = "button";
  	  	      printBtn.title = compareState.active ? "Print compare report": "Print point report";
  	  	      printBtn.setAttribute(
  	  	        "aria-label",
  	  	        compareState.active ? "Print compare report": "Print point report"
  	  	      );
  	  	      printBtn.innerHTML = trackitPrinterIconSvg();

  	  	      applyTrackitIconButtonStyle(printBtn);

  	  	      printBtn.onclick = () => {
  	  	        if (compareState.active) {
  	  	          if (!compareState.pointA || !compareState.pointB) {
  	  	            alert("Select the second comparison point before printing.");
  	  	            return;
  	  	          }

  	  	          openComparePrintReport(compareState.pointA, compareState.pointB);
  	  	          return;
  	  	        }

  	  	        openSinglePointPrintReport(point);
  	  	      };

  	  	      headerActions.appendChild(printBtn);
  	  	    }

  	  	    // Close button.
  	  	    const closeBtn = document.createElement("button");
  	  	    closeBtn.type = "button";
  	  	    closeBtn.title = "Close";
  	  	    closeBtn.setAttribute("aria-label", "Close panel");
  	  	    closeBtn.innerHTML = trackitCloseIconSvg();

  	  	    applyTrackitIconButtonStyle(closeBtn);

  	  	    closeBtn.onclick = () => {
  	  	      unlockRouteMapFromPanelClose();

  	  	      document.getElementById("fineTrackDetachedPopup")?.remove();

  	  	      // When user closes panel, remove marker safely.
  	  	      if (App.FineTrackSelectedMarker?.setMap) {
  	  	        App.FineTrackSelectedMarker.setMap(null);
  	  	        App.FineTrackSelectedMarker = null;
  	  	      }

  	  	      // Clear compare overlays if needed.
  	  	      if (compareState.active) {
  	  	        clearCompareOverlays();
  	  	        compareState.active = false;
  	  	        compareState.pointA = null;
  	  	        compareState.pointB = null;
  	  	        compareState.markerB?.setMap?.(null);
  	  	        compareState.markerB = null;
  	  	        compareState.sectionId = null;
  	  	      }

  	  	      hoverPaused = false;
  	  	      isClickLocked = false;

  	  	      // Always restore Hub visibility on panel close.
  	  	      try {
  	  	        const hubEl = Hub?.el || Hub;
  	  	        if (hubEl?.style) {
  	  	          hubEl.style.display = "";
  	  	        }
  	  	      } catch (err) {
  	  	        console.warn("⚠️ Hub restore failed:", err);
  	  	      }
  	  	    };

  	  	    headerActions.appendChild(closeBtn);
  	  	    header.appendChild(headerActions);
  	  	    panel.appendChild(header);

  	  	    // --- Body ---
  	  	    const body = document.createElement("div");
  	  	    body.id = "panelBody";

  	  	    Object.assign(body.style, {
  	  	      width: "100%",
  	  	      maxWidth: "none",
  	  	      padding: "10px",
  	  	      margin: "0",
  	  	      boxSizing: "border-box",
  	  	      overflowX: "hidden"
  	  	    });

  	  	    body.innerHTML =
  	  	    compareState.sectionId &&
  	  	    document.getElementById(compareState.sectionId)
  	  	    ? document.getElementById(compareState.sectionId).innerHTML: `<div style="color:#aaa;">Loading snapshot data...</div>`;

  	  	    panel.appendChild(body);
  	  	    document.body.appendChild(panel);

  	  	    normalizeTrackitPanelBodyContent(body);

  	  	    // Reinstate marker visibility if map lost reference.
  	  	    try {
  	  	      if (App.FineTrackSelectedMarker && !App.FineTrackSelectedMarker.getMap()) {
  	  	        App.FineTrackSelectedMarker.setMap(map);
  	  	        App.FineTrackSelectedMarker.setZIndex(3000);
  	  	        console.log("🧭 Restored marker visibility after panel attach");
  	  	      }
  	  	    } catch (err) {
  	  	      console.warn("Marker restore failed:", err);
  	  	    }

  	  	    // Hide Hub if viewport is narrow.
  	  	    try {
  	  	      const hubEl = Hub?.el || Hub;

  	  	      if (window.innerWidth < 900 && hubEl?.style) {
  	  	        hubEl.style.display = "none";
  	  	      } else if (hubEl?.style) {
  	  	        hubEl.style.display = "";
  	  	      }
  	  	    } catch (err) {
  	  	      console.warn("⚠️ Hub hide check failed:", err);
  	  	    }

  	  	    // Keep marker managed only by the main click handler.
  	  	    try {
  	  	      if (App.FineTrackSelectedMarker instanceof google.maps.Marker) {
  	  	        App.FineTrackSelectedMarker.setZIndex(3000);
  	  	      }
  	  	    } catch (err) {
  	  	      console.warn("Marker check failed:", err);
  	  	    }
  	  	  }

  	  	  // ---------- Inline Compare Builder (Directional + Pulsing Overlay, Z-Indexed + GPS Fuel Fallback) ----------
  	  	  const buildInlineReport = (A,
  	  	    B) => {
  	  	    const tA = parseTs(A.raw),
  	  	    tB = parseTs(B.raw);
  	  	    if (!Number.isFinite(tA) || !Number.isFinite(tB)) return "<div>Invalid timestamps</div>";

  	  	    const startTime = Math.min(tA, tB);
  	  	    const endTime = Math.max(tA, tB);
  	  	    const dur = endTime - startTime;

  	  	    const startPoint = (tA <= tB) ? A: B;
  	  	    const endPoint = (tA <= tB) ? B: A;

  	  	    // Extract window points
  	  	    const windowPts = path.filter(p => {
  	  	      const tp = parseTs(p.raw);
  	  	      return tp != null && tp >= startTime && tp <= endTime;
  	  	    });

  	  	    // Directional metrics
  	  	    const alongM = windowPts.length >= 2 ? sumDistanceM(windowPts): haversineM(startPoint, endPoint);
  	  	    let maxSpeed=-Infinity,
  	  	    maxRpm=-Infinity,
  	  	    sumSpeed = 0,
  	  	    sumRpm = 0,
  	  	    countSpeed = 0,
  	  	    countRpm = 0;
  	  	    const evSet = new Set();

  	  	    for (const p of windowPts) {
  	  	      const s = +p.raw["position.speed"],
  	  	      r = +p.raw["can.engine.rpm"];
  	  	      if (Number.isFinite(s)) {
  	  	        maxSpeed = Math.max(maxSpeed, s); sumSpeed += s; countSpeed++;
  	  	      }
  	  	      if (Number.isFinite(r)) {
  	  	        maxRpm = Math.max(maxRpm, r); sumRpm += r; countRpm++;
  	  	      }
  	  	      (p.raw.events || []).forEach(e => evSet.add(e));
  	  	    }

  	  	    const avgSpeed = countSpeed ? sumSpeed/countSpeed: null;
  	  	    const avgRpm = countRpm ? sumRpm/countRpm: null;

  	  	    // --- Fuel Used (single source of truth) ---
  	  	    const tankCap = +tractor?.CAN?.Tank || 0;

  	  	    const fu = calcFuelUsedBest(startPoint.raw, endPoint.raw, tankCap);
  	  	    const fuel = fu.fuelUsedL;
  	  	    const fuelMethod = fu.method;

  	  	    const distKm = alongM / 1000;
  	  	    const kmPerL = (fuel != null && fuel > 0) ? distKm / fuel: null;
  	  	    const fuelPerHour = (fuel != null && dur > 0) ? fuel / (dur/3600000): null;

  	  	    const altStart = +startPoint.raw["position.altitude"];
  	  	    const altEnd = +endPoint.raw["position.altitude"];
  	  	    const dAlt = (Number.isFinite(altStart) && Number.isFinite(altEnd)) ? (altEnd-altStart): null;

  	  	    const u = tractor?.CAN?.Units || {};
  	  	    const fmtTimeHM = ms=> {
  	  	      if (!Number.isFinite(ms) || ms <= 0)return "—";
  	  	      const totalMin = Math.floor(ms/60000);
  	  	      const hh = Math.floor(totalMin/60);
  	  	      const mm = totalMin%60;
  	  	      return `${hh}h ${mm}m`;
  	  	    };

  	  	    // --- Build Report HTML ---
  	  	    const html = `
  	  	    <div style="font-size:13px;color:#fff;background:#0b0f14;padding:8px;border-radius:6px;">
  	  	    <div style="font-weight:600;margin-bottom:6px;">Comparison to selected point</div>
  	  	    <div style="display:grid;grid-template-columns:auto 1fr;gap:4px 10px;">
  	  	    <div style="opacity:.8">Dist. along path:</div><div>${fmt(distKm, ' km', 2)}</div>
  	  	    <div style="opacity:.8">Time:</div><div>${fmtTimeHM(dur)}</div>
  	  	    <div style="opacity:.8">Max SPD:</div><div>${fmt(maxSpeed, ` ${u.speed || 'km/h'}`, 0)}</div>
  	  	    <div style="opacity:.8">Avg SPD:</div><div>${avgSpeed != null?fmt(avgSpeed, ` ${u.speed || 'km/h'}`, 1): '—'}</div>
  	  	    <div style="opacity:.8">Max RPM:</div><div>${fmt(maxRpm, ` ${u.rpm || 'rpm'}`, 0)}</div>
  	  	    <div style="opacity:.8">Avg RPM:</div><div>${avgRpm != null?fmt(avgRpm, ` ${u.rpm || 'rpm'}`, 0): '—'}</div>
  	  	    <div style="opacity:.8">Fuel Total:</div>
  	  	    <div>${fuel != null ? `${fmt(fuel, ` ${u.fuel_l || 'L'}`, 2)} <span style="opacity:.65;font-size:12px;">(${fuelMethod})</span>`: '—'}</div>

  	  	    <div style="opacity:.8">Km/Litre:</div><div>${kmPerL != null?fmt(kmPerL, '', 2): '—'}</div>
  	  	    <div style="opacity:.8">Litre/Hour:</div><div>${fuelPerHour != null?fmt(fuelPerHour, '', 2): '—'}</div>
  	  	    <div style="opacity:.8">Δ Altitude:</div><div>${dAlt != null?(dAlt > 0?'+': '')+fmt(dAlt, ' m', 0): '—'}</div>
  	  	    </div>
  	  	    <div style="margin-top:6px;border-top:1px solid #22303f;padding-top:4px;font-weight:600;">All Events</div>
  	  	    ${evSet.size
  	  	    ? `<ul style="margin:4px 0;padding-left:16px;font-size:12px;">${[...evSet].map(e => `<li>${e}</li>`).join("")}</ul>`: `<div style="color:#9fb0c0;font-size:12px;">None</div>`}
  	  	    </div>`;

  	  	    // --- Clear any old overlays first ---
  	  	    clearCompareOverlays();

  	  	    // --- Add static black + orange overlay ---
  	  	    const overlayPath = windowPts.map(p => ({
  	  	      lat: p.lat, lng: p.lng
  	  	    }));
  	  	    if (overlayPath.length >= 2) {
  	  	      window._fineTrackCompareOverlay = new google.maps.Polyline({
  	  	        path: overlayPath,
  	  	        strokeColor: '#000000',
  	  	        strokeOpacity: 0.6,
  	  	        strokeWeight: 12,
  	  	        zIndex: 9999999,
  	  	        map
  	  	      });
  	  	      registerFineTrackOverlay(map, window._fineTrackCompareOverlay);

  	  	      window._fineTrackCompareOverlayPulse = new google.maps.Polyline({
  	  	        path: overlayPath,
  	  	        strokeColor: 'rgba(255,140,0,0.8)',
  	  	        strokeOpacity: 0.8,
  	  	        strokeWeight: 4,
  	  	        zIndex: 999999999,
  	  	        map
  	  	      });
  	  	      registerFineTrackOverlay(map, window._fineTrackCompareOverlayPulse);
  	  	    }

  	  	    return html;
  	  	  };

  	  	  function buildSnapshotBlock(raw, title = "Point") {
  	  	    if (!raw) return "<div>No data</div>";

  	  	    const spd = +raw["position.speed"];
  	  	    const rpm = +raw["can.engine.rpm"];
  	  	    const tmp = +raw["can.engine.temperature"];
  	  	    const alt = +raw["position.altitude"];
  	  	    const dir = +raw["position.direction"];
  	  	    const fuelPct = +raw["can.fuel.level"];
  	  	    const tankCap = +App?.SelectedTractor?.CAN?.Tank || 0;
  	  	    const fuelLitres = (fuelPct / 100) * tankCap;

  	  	    const isA = String(title).toUpperCase().includes("A");
  	  	    const color = isA ? "#00ccff": "#ffcc00";

  	  	    return `
  	  	    <div style="
  	  	    font-size:13px;
  	  	    background:#0b0f14;
  	  	    padding:10px;
  	  	    border-radius:8px;
  	  	    color:#fff;
  	  	    border-left:4px solid ${color};
  	  	    margin-bottom:8px;
  	  	    ">
  	  	    <div style="
  	  	    font-weight:800;
  	  	    color:${color};
  	  	    font-size:14px;
  	  	    ">${title}</div>

  	  	    <div><b>Time:</b> ${fmtTime(raw.timestamp)}</div>
  	  	    <div><b>Temp:</b> ${fmt(tmp, "°C")}</div>
  	  	    <div><b>Speed:</b> ${fmt(spd, " km/h")}</div>
  	  	    <div><b>RPM:</b> ${fmt(rpm, " RPM")}</div>
  	  	    <div><b>Altitude:</b> ${fmt(alt, " m")}</div>
  	  	    <div><b>Direction:</b> ${degToCompass(dir)}</div>
  	  	    <div style="margin-top:8px;"><b>Fuel Level:</b> ${fmt(fuelPct, "%")} (${fmt(fuelLitres, " L", 1)})</div>
  	  	    </div>`;
  	  	  }

  	  	  function escReport(value) {
  	  	    return String(value ?? "—")
  	  	    .replace(/&/g, "&amp;")
  	  	    .replace(/</g, "&lt;")
  	  	    .replace(/>/g, "&gt;")
  	  	    .replace(/"/g, "&quot;")
  	  	    .replace(/'/g, "&#039;");
  	  	  }

  	  	  function fmtReportDuration(ms) {
  	  	    if (!Number.isFinite(ms) || ms < 0) return "—";

  	  	    const totalSec = Math.floor(ms / 1000);
  	  	    const hh = Math.floor(totalSec / 3600);
  	  	    const mm = Math.floor((totalSec % 3600) / 60);
  	  	    const ss = totalSec % 60;

  	  	    if (hh > 0) return `${hh}h ${mm}m ${ss}s`;
  	  	    return `${mm}m ${ss}s`;
  	  	  }

  	  	  function getReportVehicleName() {
  	  	    return (
  	  	      tractor?.Registration ||
  	  	      tractor?.registration ||
  	  	      tractor?.Name ||
  	  	      tractor?.name ||
  	  	      tractor?.VehicleName ||
  	  	      tractor?.vehicleName ||
  	  	      App?.SelectedTractor?.Registration ||
  	  	      App?.SelectedTractor?.Name ||
  	  	      "Vehicle"
  	  	    );
  	  	  }

  	  	  function collectCompareReportData(A, B) {
  	  	    const tA = parseTs(A?.raw);
  	  	    const tB = parseTs(B?.raw);

  	  	    if (!Number.isFinite(tA) || !Number.isFinite(tB)) return null;

  	  	    const startTime = Math.min(tA, tB);
  	  	    const endTime = Math.max(tA, tB);
  	  	    const durationMs = endTime - startTime;

  	  	    const startPoint = tA <= tB ? A: B;
  	  	    const endPoint = tA <= tB ? B: A;

  	  	    const windowPts = path.filter(p => {
  	  	      const tp = parseTs(p.raw);
  	  	      return Number.isFinite(tp) && tp >= startTime && tp <= endTime;
  	  	    });

  	  	    const alongM = windowPts.length >= 2
  	  	    ? sumDistanceM(windowPts): haversineM(startPoint, endPoint);

  	  	    const tankCap = +tractor?.CAN?.Tank || 0;
  	  	    const fu = calcFuelUsedBest(startPoint.raw, endPoint.raw, tankCap);
  	  	    const fuelUsed = fu.fuelUsedL;

  	  	    let maxSpeed = null;
  	  	    let maxRpm = null;
  	  	    let maxTemp = null;
  	  	    let sumSpeed = 0;
  	  	    let countSpeed = 0;
  	  	    let sumRpm = 0;
  	  	    let countRpm = 0;
  	  	    let idleMs = 0;

  	  	    const eventCounts = Object.create(null);

  	  	    for (let i = 0; i < windowPts.length; i++) {
  	  	      const p = windowPts[i];
  	  	      const raw = p.raw || {};

  	  	      const spd = Number(raw["position.speed"]);
  	  	      const rpm = Number(raw["can.engine.rpm"]);
  	  	      const tmp = Number(raw["can.engine.temperature"]);

  	  	      if (Number.isFinite(spd)) {
  	  	        maxSpeed = maxSpeed == null ? spd: Math.max(maxSpeed, spd);
  	  	        sumSpeed += spd;
  	  	        countSpeed++;
  	  	      }

  	  	      if (Number.isFinite(rpm)) {
  	  	        maxRpm = maxRpm == null ? rpm: Math.max(maxRpm, rpm);
  	  	        sumRpm += rpm;
  	  	        countRpm++;
  	  	      }

  	  	      if (Number.isFinite(tmp)) {
  	  	        maxTemp = maxTemp == null ? tmp: Math.max(maxTemp, tmp);
  	  	      }

  	  	      const events = Array.isArray(raw.events) ? raw.events: [];
  	  	      events.forEach(ev => {
  	  	        const name = String(ev || "Unknown Event");
  	  	        eventCounts[name] = (eventCounts[name] || 0) + 1;
  	  	      });

  	  	      if (i > 0) {
  	  	        const prev = windowPts[i - 1];
  	  	        const prevTs = parseTs(prev.raw);
  	  	        const curTs = parseTs(raw);
  	  	        const prevSpeed = Number(prev.raw?.["position.speed"]);
  	  	        const curSpeed = Number(raw["position.speed"]);

  	  	        if (
  	  	          Number.isFinite(prevTs) &&
  	  	          Number.isFinite(curTs) &&
  	  	          curTs > prevTs &&
  	  	          (
  	  	            (Number.isFinite(prevSpeed) && prevSpeed < 1) ||
  	  	            (Number.isFinite(curSpeed) && curSpeed < 1)
  	  	          )
  	  	        ) {
  	  	          idleMs += curTs - prevTs;
  	  	        }
  	  	      }
  	  	    }

  	  	    const distKm = alongM / 1000;
  	  	    const avgSpeed = countSpeed ? sumSpeed / countSpeed: null;
  	  	    const avgRpm = countRpm ? sumRpm / countRpm: null;
  	  	    const kmPerL = fuelUsed != null && fuelUsed > 0 ? distKm / fuelUsed: null;
  	  	    const litresPerHour = fuelUsed != null && durationMs > 0
  	  	    ? fuelUsed / (durationMs / 3600000): null;

  	  	    const altStart = Number(startPoint.raw?.["position.altitude"]);
  	  	    const altEnd = Number(endPoint.raw?.["position.altitude"]);
  	  	    const deltaAlt = Number.isFinite(altStart) && Number.isFinite(altEnd)
  	  	    ? altEnd - altStart: null;

  	  	    return {
  	  	      startPoint,
  	  	      endPoint,
  	  	      startTime,
  	  	      endTime,
  	  	      durationMs,
  	  	      idleMs,
  	  	      points: windowPts.length,
  	  	      distKm,
  	  	      maxSpeed,
  	  	      avgSpeed,
  	  	      maxRpm,
  	  	      avgRpm,
  	  	      maxTemp,
  	  	      fuelUsed,
  	  	      fuelMethod: fu.method,
  	  	      kmPerL,
  	  	      litresPerHour,
  	  	      deltaAlt,
  	  	      tankCap,
  	  	      events: Object.keys(eventCounts).map(name => ({
  	  	        name,
  	  	        count: eventCounts[name]
  	  	      }))
  	  	    };
  	  	  }

  	  	  function getReportLogoHtml() {
  	  	    let logo = TrackitReportLogo || "";

  	  	    // Backendless sometimes passes values wrapped strangely.
  	  	    if (logo && typeof logo === "object") {
  	  	      logo =
  	  	      logo.url ||
  	  	      logo.src ||
  	  	      logo.data ||
  	  	      logo.value ||
  	  	      logo.fileURL ||
  	  	      logo.fileUrl ||
  	  	      "";
  	  	    }

  	  	    let logoText = String(logo || "").trim();

  	  	    // Remove accidental wrapping quotes.
  	  	    logoText = logoText
  	  	    .replace(/^['"]+/, "")
  	  	    .replace(/['"]+$/, "")
  	  	    .trim();

  	  	    // Debug once so we can see what Backendless is actually passing.
  	  	    console.log("[TrackIT Print Logo] resolved:", {
  	  	      type: typeof logo,
  	  	      length: logoText.length,
  	  	      prefix: logoText.slice(0, 80),
  	  	      isDataImage: /^data:image\//i.test(logoText)
  	  	    });

  	  	    if (!logoText) {
  	  	      return `<div class="logo-pill">Fleet In Form</div>`;
  	  	    }

  	  	    // Raw base64 PNG without data prefix.
  	  	    if (logoText.startsWith("iVBORw0KGgo")) {
  	  	      logoText = `data:image/png;base64,${logoText}`;
  	  	    }

  	  	    // Raw base64 JPEG without data prefix.
  	  	    if (logoText.startsWith("/9j/")) {
  	  	      logoText = `data:image/jpeg;base64,${logoText}`;
  	  	    }

  	  	    // Data URL image: PNG, JPEG, SVG, WEBP, etc.
  	  	    if (/^data:image\//i.test(logoText)) {
  	  	      return `
  	  	      <img
  	  	      class="report-logo-img"
  	  	      src="${escReport(logoText)}"
  	  	      alt="Fleet In Form"
  	  	      onerror="console.warn('[TrackIT Print Logo] Logo image failed to load')"
  	  	      >
  	  	      `;
  	  	    }

  	  	    // Raw SVG markup.
  	  	    if (logoText.startsWith("<svg") || logoText.includes("<svg")) {
  	  	      return `<div class="report-logo-svg">${logoText}</div>`;
  	  	    }

  	  	    // Normal image URL.
  	  	    if (
  	  	      logoText.startsWith("http://") ||
  	  	      logoText.startsWith("https://") ||
  	  	      logoText.startsWith("/")
  	  	    ) {
  	  	      return `
  	  	      <img
  	  	      class="report-logo-img"
  	  	      src="${escReport(logoText)}"
  	  	      alt="Fleet In Form"
  	  	      >
  	  	      `;
  	  	    }

  	  	    return `<div class="logo-pill">Fleet In Form</div>`;
  	  	  }

  	  	  function trackitPrintSleep(ms) {
  	  	    return new Promise(resolve => setTimeout(resolve, ms));
  	  	  }

  	  	  function trackitWaitForMapIdle(timeoutMs = 900) {
  	  	    return new Promise(resolve => {
  	  	      let done = false;

  	  	      const finish = () => {
  	  	        if (done) return;
  	  	        done = true;
  	  	        resolve();
  	  	      };

  	  	      try {
  	  	        if (
  	  	          typeof google !== "undefined" &&
  	  	          google?.maps?.event?.addListenerOnce &&
  	  	          map?.addListener
  	  	        ) {
  	  	          google.maps.event.addListenerOnce(map, "idle", finish);
  	  	        }
  	  	      } catch (_) {}

  	  	      setTimeout(finish, timeoutMs);
  	  	    });
  	  	  }

  	  	  function trackitGetMapSnapshotTarget() {
  	  	    return (
  	  	      map?.getDiv?.() ||
  	  	      document.querySelector(".gm-style") ||
  	  	      document.querySelector(".mapboxgl-map")
  	  	    );
  	  	  }

  	  	  async function trackitCaptureMapDataUrl() {
  	  	    const mapDiv = trackitGetMapSnapshotTarget();
  	  	    if (!mapDiv) return null;

  	  	    await trackitWaitForMapIdle(900);
  	  	    await trackitPrintSleep(250);

  	  	    try {
  	  	      if (typeof googleMapComponent?.takeSnapshot === "function") {
  	  	        const snap = await googleMapComponent.takeSnapshot();

  	  	        if (typeof snap === "string" && snap.startsWith("data:image/")) {
  	  	          return snap;
  	  	        }

  	  	        if (snap?.dataUrl && typeof snap.dataUrl === "string") {
  	  	          return snap.dataUrl;
  	  	        }

  	  	        if (snap?.url && typeof snap.url === "string") {
  	  	          return snap.url;
  	  	        }
  	  	      }
  	  	    } catch (e) {
  	  	      console.warn("[TrackIT Print] Component map snapshot failed:", e);
  	  	    }

  	  	    try {
  	  	      if (typeof map?.takeSnapshot === "function") {
  	  	        const snap = await map.takeSnapshot();

  	  	        if (typeof snap === "string" && snap.startsWith("data:image/")) {
  	  	          return snap;
  	  	        }

  	  	        if (snap?.dataUrl && typeof snap.dataUrl === "string") {
  	  	          return snap.dataUrl;
  	  	        }

  	  	        if (snap?.url && typeof snap.url === "string") {
  	  	          return snap.url;
  	  	        }
  	  	      }
  	  	    } catch (e) {
  	  	      console.warn("[TrackIT Print] Map takeSnapshot failed:", e);
  	  	    }

  	  	    try {
  	  	      if (typeof html2canvas === "function") {
  	  	        const canvas = await html2canvas(mapDiv, {
  	  	          useCORS: true,
  	  	          allowTaint: false,
  	  	          backgroundColor: null,
  	  	          logging: false,
  	  	          scale: Math.min(2, window.devicePixelRatio || 1)
  	  	        });

  	  	        return canvas.toDataURL("image/png");
  	  	      }

  	  	      console.warn("[TrackIT Print] html2canvas is not available for map snapshot fallback.");
  	  	    } catch (e) {
  	  	      console.warn("[TrackIT Print] html2canvas map snapshot failed:", e);
  	  	    }

  	  	    return null;
  	  	  }

  	  	  function trackitRememberMapView() {
  	  	    try {
  	  	      const c = map?.getCenter?.();

  	  	      return {
  	  	        center: c
  	  	        ? {
  	  	          lat: c.lat(),
  	  	          lng: c.lng()
  	  	        }: null,
  	  	        zoom: map?.getZoom?.() ?? null
  	  	      };
  	  	    } catch (_) {
  	  	      return {
  	  	        center: null,
  	  	        zoom: null
  	  	      };
  	  	    }
  	  	  }

  	  	  async function trackitRestoreMapView(view) {
  	  	    if (!view) return;

  	  	    try {
  	  	      if (view.center) map.setCenter(view.center);
  	  	      if (Number.isFinite(view.zoom)) map.setZoom(view.zoom);
  	  	      await trackitWaitForMapIdle(700);
  	  	    } catch (_) {}
  	  	  }

  	  	  function trackitEnsureTemporaryPrintMarker(point, label) {
  	  	    if (!point || typeof google === "undefined" || !google?.maps?.Marker) {
  	  	      return null;
  	  	    }

  	  	    try {
  	  	      const marker = new google.maps.Marker({
  	  	        position: {
  	  	          lat: Number(point.lat),
  	  	          lng: Number(point.lng)
  	  	        },
  	  	        map,
  	  	        label: label
  	  	        ? {
  	  	          text: String(label),
  	  	          color: "#fff",
  	  	          fontSize: "18px",
  	  	          fontWeight: "900"
  	  	        }: undefined,
  	  	        zIndex: 2500,
  	  	        title: label ? `Print ${label}`: "Print Point"
  	  	      });

  	  	      return marker;
  	  	    } catch (e) {
  	  	      console.warn("[TrackIT Print] Temporary print marker failed:", e);
  	  	      return null;
  	  	    }
  	  	  }

  	  	  async function trackitPrepareSinglePointMapSnapshot(point) {
  	  	    const previousView = trackitRememberMapView();
  	  	    const tempMarkers = [];

  	  	    try {
  	  	      if (point && Number.isFinite(Number(point.lat)) && Number.isFinite(Number(point.lng))) {
  	  	        const pos = {
  	  	          lat: Number(point.lat),
  	  	          lng: Number(point.lng)
  	  	        };

  	  	        map.setCenter(pos);

  	  	        const z = map.getZoom?.();
  	  	        if (!Number.isFinite(z) || z < 16) {
  	  	          map.setZoom(16);
  	  	        }

  	  	        if (!App?.FineTrackSelectedMarker?.getMap?.()) {
  	  	          const marker = trackitEnsureTemporaryPrintMarker(point, "P");
  	  	          if (marker) tempMarkers.push(marker);
  	  	        }
  	  	      }

  	  	      const dataUrl = await trackitCaptureMapDataUrl();
  	  	      return buildTrackitPrintMapSnapshotHtml(
  	  	        dataUrl,
  	  	        "Map Snapshot",
  	  	        "Selected point position at print time."
  	  	      );
  	  	    } finally {
  	  	      tempMarkers.forEach(marker => {
  	  	        try {
  	  	          marker.setMap(null);
  	  	        } catch (_) {}
  	  	      });

  	  	      await trackitRestoreMapView(previousView);
  	  	    }
  	  	  }

  	  	  async function trackitPrepareCompareMapSnapshot(A, B) {
  	  	    const previousView = trackitRememberMapView();
  	  	    const tempMarkers = [];

  	  	    try {
  	  	      const bounds = new google.maps.LatLngBounds();

  	  	      [A,
  	  	        B].forEach(point => {
  	  	          if (point && Number.isFinite(Number(point.lat)) && Number.isFinite(Number(point.lng))) {
  	  	            bounds.extend({
  	  	              lat: Number(point.lat),
  	  	              lng: Number(point.lng)
  	  	            });
  	  	          }
  	  	        });

  	  	      if (!bounds.isEmpty()) {
  	  	        map.fitBounds(bounds, 85);

  	  	        const z = map.getZoom?.();
  	  	        if (Number.isFinite(z) && z > 18) {
  	  	          map.setZoom(18);
  	  	        }
  	  	      }

  	  	      if (!App?.FineTrackSelectedMarker?.getMap?.()) {
  	  	        const markerA = trackitEnsureTemporaryPrintMarker(A, "A");
  	  	        if (markerA) tempMarkers.push(markerA);
  	  	      }

  	  	      if (!compareState?.markerB?.getMap?.()) {
  	  	        const markerB = trackitEnsureTemporaryPrintMarker(B, "B");
  	  	        if (markerB) tempMarkers.push(markerB);
  	  	      }

  	  	      const dataUrl = await trackitCaptureMapDataUrl();
  	  	      return buildTrackitPrintMapSnapshotHtml(
  	  	        dataUrl,
  	  	        "Map Snapshot",
  	  	        "Point A to Point B comparison at print time."
  	  	      );
  	  	    } finally {
  	  	      tempMarkers.forEach(marker => {
  	  	        try {
  	  	          marker.setMap(null);
  	  	        } catch (_) {}
  	  	      });

  	  	      await trackitRestoreMapView(previousView);
  	  	    }
  	  	  }

  	  	  function buildTrackitPrintMapSnapshotHtml(dataUrl, title = "Map Snapshot", note = "") {
  	  	    const safeTitle = escReport(title);
  	  	    const safeNote = escReport(note || "");

  	  	    if (!dataUrl) {
  	  	      return `
  	  	      <div class="section-title">${safeTitle}</div>
  	  	      <div class="map-snapshot map-snapshot-empty">
  	  	      Map snapshot unavailable. The report data is still valid.
  	  	      </div>
  	  	      ${safeNote ? `<div class="map-snapshot-note">${safeNote}</div>`: ""}
  	  	      `;
  	  	    }

  	  	    return `
  	  	    <div class="section-title">${safeTitle}</div>
  	  	    <div class="map-snapshot">
  	  	    <img src="${escReport(dataUrl)}" alt="${safeTitle}">
  	  	    </div>
  	  	    ${safeNote ? `<div class="map-snapshot-note">${safeNote}</div>`: ""}
  	  	    `;
  	  	  }

  	  	  function buildTrackitPrintLoadingHtml(title) {
  	  	    return `
  	  	    <!doctype html>
  	  	    <html>
  	  	    <head>
  	  	    <meta charset="utf-8">
  	  	    <title>${escReport(title)}</title>
  	  	    <style>
  	  	    body {
  	  	    margin: 0;
  	  	    padding: 30px;
  	  	    font-family: Arial, Helvetica, sans-serif;
  	  	    color: #111;
  	  	    }

  	  	    .loading-card {
  	  	    max-width: 520px;
  	  	    margin: 40px auto;
  	  	    padding: 18px 20px;
  	  	    border: 1px solid #ddd;
  	  	    border-radius: 12px;
  	  	    box-shadow: 0 8px 24px rgba(0,0,0,0.08);
  	  	    }

  	  	    .loading-title {
  	  	    font-weight: 800;
  	  	    font-size: 16px;
  	  	    margin-bottom: 8px;
  	  	    }

  	  	    .loading-copy {
  	  	    font-size: 13px;
  	  	    color: #555;
  	  	    }
  	  	    </style>
  	  	    </head>
  	  	    <body>
  	  	    <div class="loading-card">
  	  	    <div class="loading-title">${escReport(title)}</div>
  	  	    <div class="loading-copy">Capturing map snapshot and building report…</div>
  	  	    </div>
  	  	    </body>
  	  	    </html>
  	  	    `;
  	  	  }

  	  	  function buildComparePrintReport(A, B, mapSnapshotHtml = "") {
  	  	    const d = collectCompareReportData(A, B);
  	  	    if (!d) return null;

  	  	    const vehicleName = getReportVehicleName();
  	  	    const reportLogoHtml = getReportLogoHtml();

  	  	    const driverObj = tractor?.FVC?.Driver1;
  	  	    const driverName = driverObj?.name || "—";
  	  	    const driverPhone =
  	  	    driverObj?.Data_Details?.employee_details?.contact_details?.phone_number || "—";
  	  	    const driverEmail = driverObj?.email || "—";

  	  	    const nowText = new Date().toLocaleString("en-ZA", {
  	  	      year: "numeric",
  	  	      month: "2-digit",
  	  	      day: "2-digit",
  	  	      hour: "2-digit",
  	  	      minute: "2-digit"
  	  	    });

  	  	    const buildPointRows = (label, point) => {
  	  	      const raw = point?.raw || {};
  	  	      const fuelPct = smartFuelPct(raw, d.tankCap);

  	  	      const fuelLitres =
  	  	      Number.isFinite(fuelPct) &&
  	  	      Number.isFinite(d.tankCap) &&
  	  	      d.tankCap > 0
  	  	      ? (fuelPct / 100) * d.tankCap: null;

  	  	      return `
  	  	      <div class="point-card">
  	  	      <div class="point-title">${escReport(label)}</div>

  	  	      <div class="point-grid">
  	  	      <div>Time</div>
  	  	      <strong>${escReport(fmtTime(raw.timestamp))}</strong>

  	  	      <div>Speed</div>
  	  	      <strong>${escReport(fmt(+raw["position.speed"], " km/h", 0))}</strong>

  	  	      <div>RPM</div>
  	  	      <strong>${escReport(fmt(+raw["can.engine.rpm"], " RPM", 0))}</strong>

  	  	      <div>Temp</div>
  	  	      <strong>${escReport(fmt(+raw["can.engine.temperature"], "°", 0))}</strong>

  	  	      <div>Altitude</div>
  	  	      <strong>${escReport(fmt(+raw["position.altitude"], " m", 0))}</strong>

  	  	      <div>Direction</div>
  	  	      <strong>${escReport(degToCompass(+raw["position.direction"]))}</strong>

  	  	      <div>Fuel Level</div>
  	  	      <strong>${escReport(fmt(fuelPct, "%", 0))}</strong>

  	  	      <div>Fuel Litres</div>
  	  	      <strong>${escReport(fmt(fuelLitres, " L", 1))}</strong>
  	  	      </div>
  	  	      </div>
  	  	      `;
  	  	    };

  	  	    const eventRows = d.events.length
  	  	    ? d.events.map(ev => `
  	  	      <tr>
  	  	      <td>${escReport(ev.name)}</td>
  	  	      <td>${escReport(ev.count)}</td>
  	  	      </tr>
  	  	      `).join(""): `
  	  	    <tr>
  	  	    <td colspan="2">No events recorded.</td>
  	  	    </tr>
  	  	    `;

  	  	    const deltaAltText =
  	  	    d.deltaAlt != null
  	  	    ? `${d.deltaAlt > 0 ? "+": ""}${fmt(d.deltaAlt, " m", 0)}`: "—";

  	  	    return `
  	  	    <!doctype html>
  	  	    <html>
  	  	    <head>
  	  	    <meta charset="utf-8">
  	  	    <title>Point Compare Report - ${escReport(vehicleName)}</title>

  	  	    <style>
  	  	    @page {
  	  	    size: A4 portrait;
  	  	    margin: 8mm;
  	  	    }

  	  	    * {
  	  	    box-sizing: border-box;
  	  	    }

  	  	    html,
  	  	    body {
  	  	    margin: 0;
  	  	    padding: 0;
  	  	    background: #fff;
  	  	    color: #111;
  	  	    font-family: Arial, Helvetica, sans-serif;
  	  	    font-size: 8.5px;
  	  	    line-height: 1.16;
  	  	    }

  	  	    .print-actions {
  	  	    position: fixed;
  	  	    top: 10px;
  	  	    right: 10px;
  	  	    z-index: 9999;
  	  	    }

  	  	    .print-actions button {
  	  	    padding: 8px 14px;
  	  	    border: 1px solid #999;
  	  	    border-radius: 8px;
  	  	    background: #fff;
  	  	    cursor: pointer;
  	  	    font-weight: 700;
  	  	    }

  	  	    .report {
  	  	    width: 100%;
  	  	    max-width: 190mm;
  	  	    margin: 0 auto;
  	  	    }

  	  	    .top-line {
  	  	    display: grid;
  	  	    grid-template-columns: 120px 1fr 120px;
  	  	    align-items: start;
  	  	    gap: 8px;
  	  	    margin-bottom: 3px;
  	  	    font-size: 7.5px;
  	  	    }

  	  	    .top-title {
  	  	    text-align: center;
  	  	    font-weight: 700;
  	  	    font-size: 8px;
  	  	    }

  	  	    .brand-row {
  	  	    display: flex;
  	  	    align-items: center;
  	  	    gap: 8px;
  	  	    margin: 2px 0 4px;
  	  	    }

  	  	    .logo-wrap {
  	  	    width: 78px;
  	  	    height: 26px;
  	  	    display: flex;
  	  	    align-items: center;
  	  	    justify-content: flex-start;
  	  	    overflow: hidden;
  	  	    flex: 0 0 78px;
  	  	    }

  	  	    .report-logo-img {
  	  	    max-width: 78px;
  	  	    max-height: 26px;
  	  	    object-fit: contain;
  	  	    display: block;
  	  	    }

  	  	    .report-logo-svg {
  	  	    width: 78px;
  	  	    height: 26px;
  	  	    display: flex;
  	  	    align-items: center;
  	  	    justify-content: flex-start;
  	  	    }

  	  	    .report-logo-svg svg {
  	  	    max-width: 78px;
  	  	    max-height: 26px;
  	  	    display: block;
  	  	    }

  	  	    .logo-pill {
  	  	    width: 78px;
  	  	    height: 26px;
  	  	    background: #111;
  	  	    color: #fff;
  	  	    border-left: 7px solid #cc6633;
  	  	    display: flex;
  	  	    align-items: center;
  	  	    justify-content: center;
  	  	    font-size: 7.5px;
  	  	    font-weight: 700;
  	  	    font-style: italic;
  	  	    }

  	  	    .vehicle-name {
  	  	    font-size: 14px;
  	  	    color: #666;
  	  	    font-weight: 700;
  	  	    line-height: 1.05;
  	  	    }

  	  	    .vehicle-sub {
  	  	    font-size: 8.5px;
  	  	    color: #111;
  	  	    margin-top: 1px;
  	  	    }

  	  	    .rule {
  	  	    border-top: 3px double #555;
  	  	    margin: 4px 0 7px;
  	  	    }

  	  	    .section-title {
  	  	    color: #777;
  	  	    font-size: 11.5px;
  	  	    font-weight: 700;
  	  	    margin: 7px 0 4px;
  	  	    }

  	  	    .summary-grid {
  	  	    display: grid;
  	  	    grid-template-columns: repeat(6, 1fr);
  	  	    gap: 5px 10px;
  	  	    margin-bottom: 4px;
  	  	    }

  	  	    .metric {
  	  	    min-height: 20px;
  	  	    }

  	  	    .metric .label {
  	  	    font-weight: 700;
  	  	    font-size: 8px;
  	  	    }

  	  	    .metric .value {
  	  	    font-size: 8px;
  	  	    margin-top: 1px;
  	  	    }

  	  	    .note {
  	  	    color: #444;
  	  	    font-size: 7px;
  	  	    margin: 2px 0 5px;
  	  	    white-space: nowrap;
  	  	    overflow: hidden;
  	  	    text-overflow: ellipsis;
  	  	    }

  	  	    .driver-row {
  	  	    display: grid;
  	  	    grid-template-columns: repeat(3, 1fr);
  	  	    gap: 8px;
  	  	    margin-bottom: 5px;
  	  	    font-size: 8.5px;
  	  	    }

  	  	    .driver-row strong {
  	  	    font-size: 8.5px;
  	  	    }

  	  	    .point-grid-wrap {
  	  	    display: grid;
  	  	    grid-template-columns: 1fr 1fr;
  	  	    gap: 8px;
  	  	    margin-bottom: 6px;
  	  	    }

  	  	    .point-card {
  	  	    border: 1px solid #d6d6d6;
  	  	    border-radius: 3px;
  	  	    padding: 5px 6px;
  	  	    page-break-inside: avoid;
  	  	    }

  	  	    .point-title {
  	  	    font-size: 8.5px;
  	  	    font-weight: 700;
  	  	    margin-bottom: 4px;
  	  	    }

  	  	    .point-grid {
  	  	    display: grid;
  	  	    grid-template-columns: 64px 1fr;
  	  	    gap: 2px 6px;
  	  	    font-size: 7.7px;
  	  	    }

  	  	    .point-grid strong {
  	  	    font-size: 7.7px;
  	  	    }

  	  	    .bottom-grid {
  	  	    display: grid;
  	  	    grid-template-columns: 1.45fr 1fr;
  	  	    gap: 10px;
  	  	    align-items: start;
  	  	    }

  	  	    table {
  	  	    width: 100%;
  	  	    border-collapse: collapse;
  	  	    margin: 0;
  	  	    page-break-inside: avoid;
  	  	    }

  	  	    th {
  	  	    text-align: left;
  	  	    border-bottom: 1px solid #888;
  	  	    padding: 2.5px 2px;
  	  	    font-size: 7.6px;
  	  	    }

  	  	    td {
  	  	    padding: 2.2px 2px;
  	  	    border-bottom: 1px solid #e1e1e1;
  	  	    font-size: 7.6px;
  	  	    vertical-align: top;
  	  	    }

  	  	    .event-table th,
  	  	    .event-table td {
  	  	    font-size: 7.3px;
  	  	    }

  	  	    .compact-small {
  	  	    font-size: 7.2px;
  	  	    }

  	  	    .map-snapshot {
  	  	    width: 100%;
  	  	    height: 43mm;
  	  	    border: 1px solid #cfcfcf;
  	  	    border-radius: 4px;
  	  	    overflow: hidden;
  	  	    background: #f2f2f2;
  	  	    page-break-inside: avoid;
  	  	    margin-bottom: 5px;
  	  	    }

  	  	    .map-snapshot img {
  	  	    width: 100%;
  	  	    height: 100%;
  	  	    object-fit: cover;
  	  	    display: block;
  	  	    }

  	  	    .map-snapshot-empty {
  	  	    display: flex;
  	  	    align-items: center;
  	  	    justify-content: center;
  	  	    color: #666;
  	  	    font-size: 8px;
  	  	    }

  	  	    .map-snapshot-note {
  	  	    color: #555;
  	  	    font-size: 7px;
  	  	    margin: 2px 0 5px;
  	  	    }

  	  	    @media print {
  	  	    .print-actions {
  	  	    display: none;
  	  	    }

  	  	    html,
  	  	    body {
  	  	    -webkit-print-color-adjust: exact;
  	  	    print-color-adjust: exact;
  	  	    }
  	  	    }
  	  	    </style>
  	  	    </head>

  	  	    <body>
  	  	    <div class="print-actions">
  	  	    <button onclick="window.print()">Print</button>
  	  	    </div>

  	  	    <div class="report">
  	  	    <div class="top-line">
  	  	    <div>${escReport(nowText)}</div>
  	  	    <div class="top-title">Fleet In Form - Point Compare Report</div>
  	  	    <div></div>
  	  	    </div>

  	  	    <div class="brand-row">
  	  	    <div class="logo-wrap">
  	  	    ${reportLogoHtml}
  	  	    </div>

  	  	    <div>
  	  	    <div class="vehicle-name">${escReport(vehicleName)}</div>
  	  	    <div class="vehicle-sub">${escReport(vehicleName)}</div>
  	  	    </div>
  	  	    </div>

  	  	    <div class="rule"></div>

  	  	    <div class="section-title">Trip Summary</div>

  	  	    <div class="summary-grid">
  	  	    <div class="metric">
  	  	    <div class="label">Start</div>
  	  	    <div class="value">${escReport(fmtTime(d.startPoint.raw.timestamp))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">End</div>
  	  	    <div class="value">${escReport(fmtTime(d.endPoint.raw.timestamp))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Points</div>
  	  	    <div class="value">${escReport(d.points)}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Distance</div>
  	  	    <div class="value">${escReport(fmt(d.distKm, " km", 2))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Time</div>
  	  	    <div class="value">${escReport(fmtReportDuration(d.durationMs))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Idle</div>
  	  	    <div class="value">${escReport(fmtReportDuration(d.idleMs))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Max Speed</div>
  	  	    <div class="value">${escReport(fmt(d.maxSpeed, " km/h", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Avg Speed</div>
  	  	    <div class="value">${escReport(fmt(d.avgSpeed, " km/h", 1))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Max RPM</div>
  	  	    <div class="value">${escReport(fmt(d.maxRpm, "", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Avg RPM</div>
  	  	    <div class="value">${escReport(fmt(d.avgRpm, "", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Max Temp</div>
  	  	    <div class="value">${escReport(fmt(d.maxTemp, "°", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Fuel Used</div>
  	  	    <div class="value">${escReport(fmt(d.fuelUsed, " L", 2))}</div>
  	  	    </div>
  	  	    </div>

  	  	    <div class="note">
  	  	    Point comparison report uses selected route points. Fuel method: ${escReport(d.fuelMethod)}.
  	  	    </div>

  	  	    ${mapSnapshotHtml}

  	  	    <div class="section-title">Driver Information</div>

  	  	    <div class="driver-row">
  	  	    <div><strong>Name:</strong> ${escReport(driverName)}</div>
  	  	    <div><strong>Phone:</strong> ${escReport(driverPhone)}</div>
  	  	    <div><strong>Email:</strong> ${escReport(driverEmail)}</div>
  	  	    </div>

  	  	    <div class="section-title">Selected Points</div>

  	  	    <div class="point-grid-wrap">
  	  	    ${buildPointRows("Start Point", d.startPoint)}
  	  	    ${buildPointRows("End Point", d.endPoint)}
  	  	    </div>

  	  	    <div class="bottom-grid">
  	  	    <div>
  	  	    <div class="section-title">Comparison Summary</div>

  	  	    <table>
  	  	    <thead>
  	  	    <tr>
  	  	    <th>Metric</th>
  	  	    <th>Value</th>
  	  	    </tr>
  	  	    </thead>

  	  	    <tbody>
  	  	    <tr>
  	  	    <td>Distance along path</td>
  	  	    <td>${escReport(fmt(d.distKm, " km", 2))}</td>
  	  	    </tr>

  	  	    <tr>
  	  	    <td>Time</td>
  	  	    <td>${escReport(fmtReportDuration(d.durationMs))}</td>
  	  	    </tr>

  	  	    <tr>
  	  	    <td>Average Speed</td>
  	  	    <td>${escReport(fmt(d.avgSpeed, " km/h", 1))}</td>
  	  	    </tr>

  	  	    <tr>
  	  	    <td>Max Speed</td>
  	  	    <td>${escReport(fmt(d.maxSpeed, " km/h", 0))}</td>
  	  	    </tr>

  	  	    <tr>
  	  	    <td>Average RPM</td>
  	  	    <td>${escReport(fmt(d.avgRpm, " rpm", 0))}</td>
  	  	    </tr>

  	  	    <tr>
  	  	    <td>Max RPM</td>
  	  	    <td>${escReport(fmt(d.maxRpm, " rpm", 0))}</td>
  	  	    </tr>

  	  	    <tr>
  	  	    <td>Fuel Total</td>
  	  	    <td>${escReport(fmt(d.fuelUsed, " L", 2))}</td>
  	  	    </tr>

  	  	    <tr>
  	  	    <td>Km/Litre</td>
  	  	    <td>${escReport(fmt(d.kmPerL, "", 2))}</td>
  	  	    </tr>

  	  	    <tr>
  	  	    <td>Litre/Hour</td>
  	  	    <td>${escReport(fmt(d.litresPerHour, "", 2))}</td>
  	  	    </tr>

  	  	    <tr>
  	  	    <td>Δ Altitude</td>
  	  	    <td>${escReport(deltaAltText)}</td>
  	  	    </tr>
  	  	    </tbody>
  	  	    </table>
  	  	    </div>

  	  	    <div>
  	  	    <div class="section-title">Event Summary</div>

  	  	    <table class="event-table">
  	  	    <thead>
  	  	    <tr>
  	  	    <th>Event</th>
  	  	    <th>Occurrences</th>
  	  	    </tr>
  	  	    </thead>

  	  	    <tbody>
  	  	    ${eventRows}
  	  	    </tbody>
  	  	    </table>
  	  	    </div>
  	  	    </div>
  	  	    </div>
  	  	    </body>
  	  	    </html>
  	  	    `;
  	  	  }

  	  	  async function openComparePrintReport(A, B) {
  	  	    const w = window.open("", "_blank", "width=1100,height=800");

  	  	    if (!w) {
  	  	      alert("Print window was blocked by the browser. Allow popups for this site and try again.");
  	  	      return;
  	  	    }

  	  	    w.document.open();
  	  	    w.document.write(buildTrackitPrintLoadingHtml("Point Compare Report"));
  	  	    w.document.close();

  	  	    const mapSnapshotHtml = await trackitPrepareCompareMapSnapshot(A, B);
  	  	    const html = buildComparePrintReport(A, B, mapSnapshotHtml);

  	  	    if (!html) {
  	  	      alert("No valid comparison data is available to print.");
  	  	      try {
  	  	        w.close();
  	  	      } catch (_) {}
  	  	      return;
  	  	    }

  	  	    w.document.open();
  	  	    w.document.write(html);
  	  	    w.document.close();

  	  	    setTimeout(() => {
  	  	      try {
  	  	        w.focus();
  	  	        w.print();
  	  	      } catch (e) {
  	  	        console.warn("[TrackIT Print] Print failed:", e);
  	  	      }
  	  	    }, 350);
  	  	  }

  	  	  function collectSinglePointPrintReportData(point) {
  	  	    const raw = point?.raw;

  	  	    if (!raw) return null;

  	  	    const tankCap = +tractor?.CAN?.Tank || 0;
  	  	    const fuelPct = smartFuelPct(raw, tankCap);

  	  	    const fuelLitres =
  	  	    Number.isFinite(fuelPct) &&
  	  	    Number.isFinite(tankCap) &&
  	  	    tankCap > 0
  	  	    ? (fuelPct / 100) * tankCap: null;

  	  	    const baselineKmPerL = getBaselineKmPerL();

  	  	    const fuelRange =
  	  	    baselineKmPerL != null &&
  	  	    fuelLitres != null
  	  	    ? fuelLitres * baselineKmPerL: null;

  	  	    const events = Array.isArray(raw.events) ? raw.events: [];

  	  	    const markerRows = [];

  	  	    if (routePointIsStart(point)) {
  	  	      markerRows.push({
  	  	        title: "Start Marker",
  	  	        value: `Time: ${routePointTime(point)}`
  	  	      });
  	  	    }

  	  	    const idleSeg = routeFindIdleSegment(point);

  	  	    if (idleSeg || routeHasRawIdle(point)) {
  	  	      const idleStart =
  	  	      routeMarkerTime(idleSeg?.start_iso) ||
  	  	      routeMarkerTime(idleSeg?.start) ||
  	  	      routeMarkerTime(idleSeg?.Points?.[0]?.timestamp) ||
  	  	      routePointTime(point);

  	  	      const idleText =
  	  	      idleSeg?.idle_human ||
  	  	      routeMarkerDuration(idleSeg?.idle_seconds || 0);

  	  	      markerRows.push({
  	  	        title: "Idle Marker",
  	  	        value: `Start: ${idleStart} | Idle: ${idleText}`
  	  	      });
  	  	    }

  	  	    const stopSeg = routeFindStopSegment(point);

  	  	    if (stopSeg) {
  	  	      markerRows.push({
  	  	        title: "Stopped Marker",
  	  	        value: `Stopped Time: ${routePointTime(stopSeg.points[0])} | Duration: ${routeMarkerDuration(routeStopDurationSeconds(stopSeg))}`
  	  	      });
  	  	    }

  	  	    if (routePointIsEnd(point)) {
  	  	      markerRows.push({
  	  	        title: "End Marker",
  	  	        value: `Time: ${routePointTime(point)}`
  	  	      });
  	  	    }

  	  	    return {
  	  	      raw,
  	  	      lat: point.lat,
  	  	      lng: point.lng,
  	  	      timestamp: raw.timestamp,

  	  	      speed: Number(raw["position.speed"]),
  	  	      rpm: Number(raw["can.engine.rpm"]),
  	  	      temp: Number(raw["can.engine.temperature"]),
  	  	      throttle: Number(raw["can.throttle.pedal.level"]),
  	  	      altitude: Number(raw["position.altitude"]),
  	  	      direction: Number(raw["position.direction"]),

  	  	      fuelPct,
  	  	      fuelLitres,
  	  	      fuelRange,
  	  	      fuelMethod: baselineKmPerL != null ? "CAN Avg (km/L)": "—",

  	  	      events,
  	  	      markerRows,

  	  	      limits: {
  	  	        speed: +tractor?.CAN?.Speed || 80,
  	  	        rpm: +tractor?.CAN?.RPM || 1500,
  	  	        temp: +tractor?.CAN?.Temp || 100,
  	  	        throttle: +tractor?.CAN?.ThrottlePct || 85
  	  	      }
  	  	    };
  	  	  }

  	  	  function buildSinglePointPrintReport(point, mapSnapshotHtml = "") {
  	  	    const d = collectSinglePointPrintReportData(point);

  	  	    if (!d) return null;

  	  	    const vehicleName = getReportVehicleName();
  	  	    const reportLogoHtml = getReportLogoHtml();

  	  	    const driverObj = tractor?.FVC?.Driver1;
  	  	    const driverName = driverObj?.name || "—";
  	  	    const driverPhone =
  	  	    driverObj?.Data_Details?.employee_details?.contact_details?.phone_number || "—";
  	  	    const driverEmail = driverObj?.email || "—";

  	  	    const nowText = new Date().toLocaleString("en-ZA", {
  	  	      year: "numeric",
  	  	      month: "2-digit",
  	  	      day: "2-digit",
  	  	      hour: "2-digit",
  	  	      minute: "2-digit"
  	  	    });

  	  	    const eventRows = d.events.length
  	  	    ? d.events.map(ev => `
  	  	      <tr>
  	  	      <td>${escReport(ev)}</td>
  	  	      </tr>
  	  	      `).join(""): `
  	  	    <tr>
  	  	    <td>No events recorded at this point.</td>
  	  	    </tr>
  	  	    `;

  	  	    const markerRows = d.markerRows.length
  	  	    ? d.markerRows.map(row => `
  	  	      <tr>
  	  	      <td>${escReport(row.title)}</td>
  	  	      <td>${escReport(row.value)}</td>
  	  	      </tr>
  	  	      `).join(""): `
  	  	    <tr>
  	  	    <td colspan="2">No marker context for this point.</td>
  	  	    </tr>
  	  	    `;

  	  	    return `
  	  	    <!doctype html>
  	  	    <html>
  	  	    <head>
  	  	    <meta charset="utf-8">
  	  	    <title>Point Report - ${escReport(vehicleName)}</title>

  	  	    <style>
  	  	    @page {
  	  	    size: A4 portrait;
  	  	    margin: 10mm;
  	  	    }

  	  	    * {
  	  	    box-sizing: border-box;
  	  	    }

  	  	    html,
  	  	    body {
  	  	    margin: 0;
  	  	    padding: 0;
  	  	    background: #fff;
  	  	    color: #111;
  	  	    font-family: Arial, Helvetica, sans-serif;
  	  	    font-size: 10px;
  	  	    line-height: 1.25;
  	  	    }

  	  	    .print-actions {
  	  	    position: fixed;
  	  	    top: 10px;
  	  	    right: 10px;
  	  	    z-index: 9999;
  	  	    }

  	  	    .print-actions button {
  	  	    padding: 8px 14px;
  	  	    border: 1px solid #999;
  	  	    border-radius: 8px;
  	  	    background: #fff;
  	  	    cursor: pointer;
  	  	    font-weight: 700;
  	  	    }

  	  	    .report {
  	  	    width: 100%;
  	  	    max-width: 190mm;
  	  	    margin: 0 auto;
  	  	    }

  	  	    .top-line {
  	  	    display: grid;
  	  	    grid-template-columns: 120px 1fr 120px;
  	  	    align-items: start;
  	  	    gap: 8px;
  	  	    margin-bottom: 4px;
  	  	    font-size: 8px;
  	  	    }

  	  	    .top-title {
  	  	    text-align: center;
  	  	    font-weight: 700;
  	  	    font-size: 9px;
  	  	    }

  	  	    .brand-row {
  	  	    display: flex;
  	  	    align-items: center;
  	  	    gap: 8px;
  	  	    margin: 3px 0 5px;
  	  	    }

  	  	    .logo-wrap {
  	  	    width: 90px;
  	  	    height: 30px;
  	  	    display: flex;
  	  	    align-items: center;
  	  	    justify-content: flex-start;
  	  	    overflow: hidden;
  	  	    flex: 0 0 90px;
  	  	    }

  	  	    .report-logo-img {
  	  	    max-width: 90px;
  	  	    max-height: 30px;
  	  	    object-fit: contain;
  	  	    display: block;
  	  	    }

  	  	    .report-logo-svg {
  	  	    width: 90px;
  	  	    height: 30px;
  	  	    display: flex;
  	  	    align-items: center;
  	  	    justify-content: flex-start;
  	  	    }

  	  	    .report-logo-svg svg {
  	  	    max-width: 90px;
  	  	    max-height: 30px;
  	  	    display: block;
  	  	    }

  	  	    .logo-pill {
  	  	    width: 90px;
  	  	    height: 30px;
  	  	    background: #111;
  	  	    color: #fff;
  	  	    border-left: 7px solid #cc6633;
  	  	    display: flex;
  	  	    align-items: center;
  	  	    justify-content: center;
  	  	    font-size: 8px;
  	  	    font-weight: 700;
  	  	    font-style: italic;
  	  	    }

  	  	    .vehicle-name {
  	  	    font-size: 16px;
  	  	    color: #666;
  	  	    font-weight: 700;
  	  	    line-height: 1.05;
  	  	    }

  	  	    .vehicle-sub {
  	  	    font-size: 9px;
  	  	    color: #111;
  	  	    margin-top: 1px;
  	  	    }

  	  	    .rule {
  	  	    border-top: 3px double #555;
  	  	    margin: 5px 0 8px;
  	  	    }

  	  	    .section-title {
  	  	    color: #777;
  	  	    font-size: 12px;
  	  	    font-weight: 700;
  	  	    margin: 8px 0 5px;
  	  	    }

  	  	    .summary-grid {
  	  	    display: grid;
  	  	    grid-template-columns: repeat(4, 1fr);
  	  	    gap: 7px 12px;
  	  	    margin-bottom: 7px;
  	  	    }

  	  	    .metric .label {
  	  	    font-weight: 700;
  	  	    font-size: 8.5px;
  	  	    }

  	  	    .metric .value {
  	  	    font-size: 9px;
  	  	    margin-top: 2px;
  	  	    }

  	  	    .driver-row {
  	  	    display: grid;
  	  	    grid-template-columns: repeat(3, 1fr);
  	  	    gap: 8px;
  	  	    margin-bottom: 6px;
  	  	    font-size: 9px;
  	  	    }

  	  	    table {
  	  	    width: 100%;
  	  	    border-collapse: collapse;
  	  	    margin: 0;
  	  	    page-break-inside: avoid;
  	  	    }

  	  	    th {
  	  	    text-align: left;
  	  	    border-bottom: 1px solid #888;
  	  	    padding: 4px 3px;
  	  	    font-size: 8.5px;
  	  	    }

  	  	    td {
  	  	    padding: 4px 3px;
  	  	    border-bottom: 1px solid #e1e1e1;
  	  	    font-size: 8.5px;
  	  	    vertical-align: top;
  	  	    }

  	  	    .bottom-grid {
  	  	    display: grid;
  	  	    grid-template-columns: 1.2fr 1fr;
  	  	    gap: 12px;
  	  	    align-items: start;
  	  	    }

  	  	    .note {
  	  	    color: #444;
  	  	    font-size: 8px;
  	  	    margin-top: 4px;
  	  	    }

  	  	    .map-snapshot {
  	  	    width: 100%;
  	  	    height: 50mm;
  	  	    border: 1px solid #cfcfcf;
  	  	    border-radius: 4px;
  	  	    overflow: hidden;
  	  	    background: #f2f2f2;
  	  	    page-break-inside: avoid;
  	  	    margin-bottom: 6px;
  	  	    }

  	  	    .map-snapshot img {
  	  	    width: 100%;
  	  	    height: 100%;
  	  	    object-fit: cover;
  	  	    display: block;
  	  	    }

  	  	    .map-snapshot-empty {
  	  	    display: flex;
  	  	    align-items: center;
  	  	    justify-content: center;
  	  	    color: #666;
  	  	    font-size: 8px;
  	  	    }

  	  	    .map-snapshot-note {
  	  	    color: #555;
  	  	    font-size: 7.5px;
  	  	    margin: 3px 0 6px;
  	  	    }

  	  	    @media print {
  	  	    .print-actions {
  	  	    display: none;
  	  	    }

  	  	    html,
  	  	    body {
  	  	    -webkit-print-color-adjust: exact;
  	  	    print-color-adjust: exact;
  	  	    }
  	  	    }
  	  	    </style>
  	  	    </head>

  	  	    <body>
  	  	    <div class="print-actions">
  	  	    <button onclick="window.print()">Print</button>
  	  	    </div>

  	  	    <div class="report">
  	  	    <div class="top-line">
  	  	    <div>${escReport(nowText)}</div>
  	  	    <div class="top-title">Fleet In Form - Point Report</div>
  	  	    <div></div>
  	  	    </div>

  	  	    <div class="brand-row">
  	  	    <div class="logo-wrap">
  	  	    ${reportLogoHtml}
  	  	    </div>

  	  	    <div>
  	  	    <div class="vehicle-name">${escReport(vehicleName)}</div>
  	  	    <div class="vehicle-sub">Single Selected Point</div>
  	  	    </div>
  	  	    </div>

  	  	    <div class="rule"></div>

  	  	    <div class="section-title">Point Summary</div>

  	  	    <div class="summary-grid">
  	  	    <div class="metric">
  	  	    <div class="label">Time</div>
  	  	    <div class="value">${escReport(fmtTime(d.timestamp))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Latitude</div>
  	  	    <div class="value">${escReport(fmt(d.lat, "", 6))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Longitude</div>
  	  	    <div class="value">${escReport(fmt(d.lng, "", 6))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Direction</div>
  	  	    <div class="value">${escReport(degToCompass(d.direction))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Speed</div>
  	  	    <div class="value">${escReport(fmt(d.speed, " km/h", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">RPM</div>
  	  	    <div class="value">${escReport(fmt(d.rpm, " RPM", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Engine Temp</div>
  	  	    <div class="value">${escReport(fmt(d.temp, "°C", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Throttle</div>
  	  	    <div class="value">${escReport(fmt(d.throttle, " %", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Altitude</div>
  	  	    <div class="value">${escReport(fmt(d.altitude, " m", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Fuel Level</div>
  	  	    <div class="value">${escReport(fmt(d.fuelPct, "%", 0))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Fuel Litres</div>
  	  	    <div class="value">${escReport(fmt(d.fuelLitres, " L", 1))}</div>
  	  	    </div>

  	  	    <div class="metric">
  	  	    <div class="label">Range</div>
  	  	    <div class="value">${escReport(fmt(d.fuelRange, " km", 1))}</div>
  	  	    </div>
  	  	    </div>

  	  	    <div class="note">
  	  	    Range method: ${escReport(d.fuelMethod)}.
  	  	    Limits: Speed ${escReport(d.limits.speed)} km/h, RPM ${escReport(d.limits.rpm)}, Temp ${escReport(d.limits.temp)}°C, Throttle ${escReport(d.limits.throttle)}%.
  	  	    </div>

  	  	    ${mapSnapshotHtml}

  	  	    <div class="section-title">Driver Information</div>

  	  	    <div class="driver-row">
  	  	    <div><strong>Name:</strong> ${escReport(driverName)}</div>
  	  	    <div><strong>Phone:</strong> ${escReport(driverPhone)}</div>
  	  	    <div><strong>Email:</strong> ${escReport(driverEmail)}</div>
  	  	    </div>

  	  	    <div class="bottom-grid">
  	  	    <div>
  	  	    <div class="section-title">Events At This Point</div>

  	  	    <table>
  	  	    <thead>
  	  	    <tr>
  	  	    <th>Event</th>
  	  	    </tr>
  	  	    </thead>

  	  	    <tbody>
  	  	    ${eventRows}
  	  	    </tbody>
  	  	    </table>
  	  	    </div>

  	  	    <div>
  	  	    <div class="section-title">Marker Context</div>

  	  	    <table>
  	  	    <thead>
  	  	    <tr>
  	  	    <th>Marker</th>
  	  	    <th>Details</th>
  	  	    </tr>
  	  	    </thead>

  	  	    <tbody>
  	  	    ${markerRows}
  	  	    </tbody>
  	  	    </table>
  	  	    </div>
  	  	    </div>
  	  	    </div>
  	  	    </body>
  	  	    </html>
  	  	    `;
  	  	  }

  	  	  async function openSinglePointPrintReport(point) {
  	  	    const w = window.open("", "_blank", "width=1100,height=800");

  	  	    if (!w) {
  	  	      alert("Print window was blocked by the browser. Allow popups for this site and try again.");
  	  	      return;
  	  	    }

  	  	    w.document.open();
  	  	    w.document.write(buildTrackitPrintLoadingHtml("Point Report"));
  	  	    w.document.close();

  	  	    const mapSnapshotHtml = await trackitPrepareSinglePointMapSnapshot(point);
  	  	    const html = buildSinglePointPrintReport(point, mapSnapshotHtml);

  	  	    if (!html) {
  	  	      alert("No valid point data is available to print.");
  	  	      try {
  	  	        w.close();
  	  	      } catch (_) {}
  	  	      return;
  	  	    }

  	  	    w.document.open();
  	  	    w.document.write(html);
  	  	    w.document.close();

  	  	    setTimeout(() => {
  	  	      try {
  	  	        w.focus();
  	  	        w.print();
  	  	      } catch (e) {
  	  	        console.warn("[TrackIT Print] Single point print failed:", e);
  	  	      }
  	  	    }, 350);
  	  	  }

  	  	  // --- Clear overlays when popup closes or new compare starts ---
  	  	  const clearCompareOverlays = () => {
  	  	    if (window._fineTrackCompareOverlay) {
  	  	      window._fineTrackCompareOverlay.setMap(null); window._fineTrackCompareOverlay = null;
  	  	    }
  	  	    if (window._fineTrackCompareOverlayPulse) {
  	  	      window._fineTrackCompareOverlayPulse.setMap(null); window._fineTrackCompareOverlayPulse = null;
  	  	    }
  	  	    if (window._fineTrackComparePulseTimer) {
  	  	      clearInterval(window._fineTrackComparePulseTimer); window._fineTrackComparePulseTimer = null;
  	  	    }
  	  	  };


  	  	  // ---------- Segments + Draw ----------
  	  	  const segments = []; let currentSegment = [],
  	  	  currentColor = path[0].raw.color || "#FFFF00",
  	  	  prevTail = null;
  	  	  for (let i = 0; i < path.length; i++) {
  	  	    const p = path[i],
  	  	    c = p.raw.color || "#FFFF00",
  	  	    prev = path[i-1];
  	  	    if (prev && haversineM(prev, p) < 3)continue;
  	  	    if (c !== currentColor) {
  	  	      if (currentSegment.length >= 2)segments.push({
  	  	        color: currentColor, points: currentSegment
  	  	      });
  	  	      if (prevTail && p) {
  	  	        const blend = mixColors(currentColor, c, 0.5); segments.push({
  	  	          color: blend, points: [prevTail, p]});
  	  	      }
  	  	      currentColor = c; currentSegment = [p];
  	  	    } else {
  	  	      currentSegment.push(p);
  	  	    }
  	  	    prevTail = p;
  	  	  }
  	  	  if (currentSegment.length >= 2)segments.push({
  	  	    color: currentColor, points: currentSegment
  	  	  });

  	  	  function trackitDarkenRouteColor(hex, factor) {
  	  	    const clean = String(hex || "#FFFF00").replace("#", "");

  	  	    if (!/^[0-9a-f]{6}$/i.test(clean)) {
  	  	      return "#006600";
  	  	    }

  	  	    const safeFactor = Math.max(0, Math.min(1, Number(factor) || 0.55));

  	  	    const r = Math.round(parseInt(clean.slice(0, 2), 16) * safeFactor);
  	  	    const g = Math.round(parseInt(clean.slice(2, 4), 16) * safeFactor);
  	  	    const b = Math.round(parseInt(clean.slice(4, 6), 16) * safeFactor);

  	  	    return "#" + [r,
  	  	      g,
  	  	      b]
  	  	    .map(v => v.toString(16).padStart(2, "0"))
  	  	    .join("");
  	  	  }

  	  	  function trackitRouteChevronIcon(baseColor) {
  	  	    return {
  	  	      // Corrected +90° because Google was rendering the custom symbol 90° anti-clockwise.
  	  	      path: "M -10 -7 L -4 -7 L 6 0 L -4 7 L -10 7 L 0 0 Z",
  	  	      fillColor: trackitDarkenRouteColor(baseColor, 0.55),
  	  	      fillOpacity: 0.20,
  	  	      strokeColor: trackitDarkenRouteColor(baseColor, 0.34),
  	  	      strokeOpacity: 0.25,
  	  	      strokeWeight: 1,
  	  	      scale: 0.72,
  	  	      rotation: 270
  	  	    };
  	  	  }

  	  	  segments.forEach(seg => {
  	  	    const routePath = seg.points.map(p => ({
  	  	      lat: p.lat,
  	  	      lng: p.lng
  	  	    }));

  	  	    const poly = new google.maps.Polyline({
  	  	      path: routePath,
  	  	      strokeColor: seg.color,
  	  	      strokeOpacity: 0.9,
  	  	      strokeWeight: 10,
  	  	      geodesic: true,
  	  	      map,
  	  	      zIndex: 50
  	  	    });
  	  	    registerFineTrackOverlay(map, poly);

  	  	    const directionPolyline = new google.maps.Polyline({
  	  	      path: routePath,
  	  	      strokeOpacity: 0,
  	  	      strokeWeight: 10,
  	  	      geodesic: true,
  	  	      clickable: false,
  	  	      icons: [{
  	  	        icon: trackitRouteChevronIcon(seg.color),
  	  	        offset: "0px",
  	  	        repeat: "22px"
  	  	      }],
  	  	      map,
  	  	      zIndex: 51
  	  	    });
  	  	    registerFineTrackOverlay(map, directionPolyline);

  	  	    poly.addListener("mouseover", e=> {
  	  	      // Respect TripReplay lock: when active, hover should not fire
  	  	      if (isClickLocked || hoverPaused || App._tripReplayActive || map.__fineTrackRoutePanelMapLocked) return;
  	  	      const m = {
  	  	        lat: e.latLng.lat(),
  	  	        lng: e.latLng.lng()}; let nearest = seg.points[0],
  	  	      dMin = 1e9;
  	  	      for (const p of seg.points) {
  	  	        const d = haversineM(m, p); if (d < dMin) {
  	  	          nearest = p; dMin = d;
  	  	        }}
  	  	      if (nearest)showPopup(nearest, false);
  	  	    });

  	  	    poly.addListener("mouseout",
  	  	      ()=> {
  	  	        if (!isClickLocked&&!hoverPaused&&!App._tripReplayActive)clearPopup();
  	  	      });

  	  	    poly.addListener("click",
  	  	      e => {
  	  	        if (App._tripReplayActive) return; // Disable during replay

  	  	        // While the side panel is open, block normal route clicks.
  	  	        // Allow clicks only when selecting the second compare point.
  	  	        if (map.__fineTrackRoutePanelMapLocked && !(compareState.active && compareState.pointA)) {
  	  	          return;
  	  	        }

  	  	        const m = {
  	  	          lat: e.latLng.lat(),
  	  	          lng: e.latLng.lng()
  	  	        };
  	  	        let nearest = seg.points[0],
  	  	        dMin = 1e9;
  	  	        for (const p of seg.points) {
  	  	          const d = haversineM(m, p);
  	  	          if (d < dMin) {
  	  	            nearest = p; dMin = d;
  	  	          }
  	  	        }
  	  	        if (!nearest) return;

  	  	        // --- If in Compare Mode ---
  	  	        if (compareState.active && compareState.pointA) {
  	  	          if (compareState.markerB?.setMap) compareState.markerB.setMap(null);
  	  	          const heading = +nearest.raw["position.direction"] || 0;
  	  	          const fill = tractor.color || "#2196F3";
  	  	          compareState.markerB = new google.maps.Marker({
  	  	            position: {
  	  	              lat: nearest.lat,
  	  	              lng: nearest.lng
  	  	            },
  	  	            map,
  	  	            icon: {
  	  	              path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	  	              fillColor: fill,
  	  	              fillOpacity: 1,
  	  	              strokeWeight: 2,
  	  	              strokeColor: "#fff",
  	  	              rotation: heading,
  	  	              scale: 1.6,
  	  	              anchor: new google.maps.Point(0, 0),
  	  	              labelOrigin: new google.maps.Point(18, -26)
  	  	            },
  	  	            label: {
  	  	              text: "B",
  	  	              color: "#fff",
  	  	              fontSize: "26px",
  	  	              fontWeight: "950",
  	  	              className: "trackit-compare-marker-label"
  	  	            },
  	  	            zIndex: 2200
  	  	          });
  	  	          registerFineTrackOverlay(map, compareState.markerB);

  	  	          compareState.pointB = nearest;

  	  	          const baseInfo = buildSnapshotBlock(compareState.pointA.raw, "Point A");
  	  	          const afterInfo = buildSnapshotBlock(nearest.raw, "Point B");
  	  	          const compareHtml = buildInlineReport(compareState.pointA, nearest);

  	  	          const html = `
  	  	          <div style="padding:8px 0;">
  	  	          ${baseInfo}
  	  	          ${afterInfo}
  	  	          <div style="margin-top:10px;border-top:1px solid #333;padding-top:10px;">
  	  	          ${compareHtml}
  	  	          </div>
  	  	          </div>
  	  	          `;

  	  	          document.getElementById("fineTrackDetachedPopup")?.remove();
  	  	          attachLeftComparePanel(nearest, Hub);

  	  	          lockRouteMapForPanel();

  	  	          const panel = document.getElementById("fineTrackDetachedPopup");
  	  	          if (panel) {
  	  	            const body = panel.querySelector("#panelBody");
  	  	            if (body) {
  	  	              body.innerHTML = html;
  	  	            }
  	  	          }

  	  	          return;
  	  	        }

  	  	        // --- NORMAL CLICK: Keep marker, open left info panel ---
  	  	        hoverPaused = true;
  	  	        isClickLocked = true;

  	  	        const heading = +nearest.raw["position.direction"] || 0;
  	  	        const fill = tractor.color || "#2196F3";

  	  	        // ✅ Ensure marker stays (no recreation)
  	  	        if (!App.FineTrackSelectedMarker) {
  	  	          App.FineTrackSelectedMarker = new google.maps.Marker({
  	  	            position: {
  	  	              lat: nearest.lat, lng: nearest.lng
  	  	            },
  	  	            map,
  	  	            icon: {
  	  	              path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	  	              fillColor: fill,
  	  	              fillOpacity: 1,
  	  	              strokeWeight: 2,
  	  	              strokeColor: "#fff",
  	  	              rotation: heading,
  	  	              scale: 1.6,
  	  	              anchor: new google.maps.Point(0, 0)
  	  	            },
  	  	            zIndex: 2000
  	  	          });
  	  	          registerFineTrackOverlay(map, App.FineTrackSelectedMarker);
  	  	        } else {
  	  	          App.FineTrackSelectedMarker.setPosition({
  	  	            lat: nearest.lat, lng: nearest.lng
  	  	          });
  	  	          App.FineTrackSelectedMarker.setIcon({
  	  	            path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	  	            fillColor: fill,
  	  	            fillOpacity: 1,
  	  	            strokeWeight: 2,
  	  	            strokeColor: "#fff",
  	  	            rotation: heading,
  	  	            scale: 1.6,
  	  	            anchor: new google.maps.Point(0, 0)
  	  	          });
  	  	          App.FineTrackSelectedMarker.setMap(map); // ✅ force rebind to map
  	  	        }

  	  	        const markerContextHtml = routeMarkerContextHtml(nearest);
  	  	        // Build same info content, but now for panel
  	  	        const html = `
  	  	        <div style="font-size:13px;color:#fff;background:#0b0f14;padding:10px;border-radius:8px;">
  	  	        <div style="font-weight:600;margin-bottom:6px;">Driver Info</div>
  	  	        <div><b>Driver:</b> ${App?.SelectedTractor?.FVC?.Driver1?.name || "—"}</div>
  	  	        <div><b>Mobile:</b> ${App?.SelectedTractor?.FVC?.Driver1?.Data_Details?.employee_details?.contact_details?.phone_number || "—"}</div>
  	  	        <div><b>Email:</b> ${App?.SelectedTractor?.FVC?.Driver1?.email || "—"}</div>
  	  	        <div style="margin-top:10px;"><b>Time:</b> ${fmtTime(nearest.raw.timestamp)}</div>
  	  	        <div style="margin-top:6px;"><b>Engine Temp:</b> ${fmt(+nearest.raw["can.engine.temperature"], "°C")}</div>
  	  	        <div><b>Speed:</b> ${fmt(+nearest.raw["position.speed"], " km/h")}</div>
  	  	        <div><b>RPM:</b> ${fmt(+nearest.raw["can.engine.rpm"], " RPM")}</div>
  	  	        <div style="margin-top:6px;"><b>Altitude:</b> ${fmt(+nearest.raw["position.altitude"], " m")}</div>
  	  	        <div><b>Direction:</b> ${degToCompass(+nearest.raw["position.direction"])}</div>
  	  	        <div style="margin-top:8px;border-top:1px solid #333;padding-top:6px;">
  	  	        <b>Fuel Stats:</b><br>
  	  	        ${(() => {
  	  	          const tankCap = +tractor?.CAN?.Tank || 0;
  	  	          const fuelPct = smartFuelPct(nearest.raw, tankCap);
  	  	          const fuelLitres =
  	  	          (Number.isFinite(fuelPct) && Number.isFinite(tankCap) && tankCap > 0)
  	  	          ? (fuelPct / 100) * tankCap: null;

  	  	          const baselineKmPerL = getBaselineKmPerL();
  	  	          const fuelRange =
  	  	          (baselineKmPerL != null && fuelLitres != null)
  	  	          ? (fuelLitres * baselineKmPerL): null;

  	  	          return `
  	  	          Fuel Level: ${fmt(fuelPct, "%", 0)}<br>
  	  	          Fuel Litres: ${fmt(fuelLitres, " L", 1)}<br>
  	  	          Range: ${fmt(fuelRange, " km", 1)} <span style="opacity:.55;font-size:12px;">(CAN Avg)</span>
  	  	          `;
  	  	        })()}
  	  	        </div>

  	  	        <div style="margin-top:10px;border-top:1px solid #333;padding-top:6px;">
  	  	        <b>Events at this point:</b>
  	  	        ${(nearest.raw.events || []).length
  	  	        ? `<ul style="margin:4px 0;padding-left:16px;">${nearest.raw.events.map(e => `<li>${e}</li>`).join("")}</ul>`: `<div style="color:#999;font-size:12px;">No events</div>`}
  	  	        </div>
  	  	        </div>`;

  	  	        document.getElementById("fineTrackDetachedPopup")?.remove();
  	  	        attachLeftComparePanel(nearest, Hub);
  	  	        const panel = document.getElementById("fineTrackDetachedPopup");
  	  	        if (panel) {
  	  	          const body = panel.querySelector("#panelBody");
  	  	          if (body) body.innerHTML = html;
  	  	        }
  	  	      });



  	  	  });

  	  	  // ---------- START/END/STOP/IDLE ----------
  	  	  const makeMarker = (pos, color, label = "", scale = 1.5, z = 999) => {
  	  	    const marker = new google.maps.Marker({
  	  	      position: {
  	  	        lat: pos.lat,
  	  	        lng: pos.lng
  	  	      },
  	  	      map,
  	  	      icon: {
  	  	        path: "M0,0 m-6,0 a6,6 0 1,0 12,0 a6,6 0 1,0 -12,0",
  	  	        fillColor: color,
  	  	        fillOpacity: 1,
  	  	        strokeColor: "#fff",
  	  	        strokeWeight: 1.5,
  	  	        scale,
  	  	        anchor: new google.maps.Point(0,
  	  	          0),
  	  	        labelOrigin: new google.maps.Point(0,
  	  	          -14)
  	  	      },
  	  	      label: label
  	  	      ? {
  	  	        text: label,
  	  	        color: "#fff",
  	  	        fontSize: "11px",
  	  	        fontWeight: "bold"
  	  	      }: null,
  	  	      zIndex: z
  	  	    });
  	  	    registerFineTrackOverlay(map, marker);

  	  	    trackMarkers.push(marker);
  	  	    return marker;
  	  	  };

  	  	  // ---------- Marker report helpers ----------
  	  	  function markerReportNumber(v) {
  	  	    const n = Number(v);
  	  	    return Number.isFinite(n) ? n: null;
  	  	  }

  	  	  function markerReportTimestampMs(v) {
  	  	    if (v == null) return null;

  	  	    if (typeof v === "number") {
  	  	      return Number.isFinite(v) ? (v < 1e12 ? v * 1000: v): null;
  	  	    }

  	  	    if (typeof v === "string") {
  	  	      const n = Number(v);

  	  	      if (Number.isFinite(n)) {
  	  	        return n < 1e12 ? n * 1000: n;
  	  	      }

  	  	      const d = Date.parse(v);
  	  	      return Number.isFinite(d) ? d: null;
  	  	    }

  	  	    return null;
  	  	  }

  	  	  function markerReportFormatTime(v) {
  	  	    const ms = markerReportTimestampMs(v);

  	  	    if (!Number.isFinite(ms)) return "—";

  	  	    const d = new Date(ms);
  	  	    if (isNaN(d)) return "—";

  	  	    const pad = n => String(n).padStart(2, "0");

  	  	    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  	  	  }

  	  	  function markerReportFormatDuration(seconds) {
  	  	    const s = Number(seconds);

  	  	    if (!Number.isFinite(s) || s < 1) return "0s";

  	  	    const h = Math.floor(s / 3600);
  	  	    const m = Math.floor((s % 3600) / 60);
  	  	    const sec = Math.floor(s % 60);

  	  	    if (h) return `${h}h ${m}m ${sec}s`;
  	  	    if (m) return `${m}m ${sec}s`;
  	  	    return `${sec}s`;
  	  	  }

  	  	  function markerPointTime(point) {
  	  	    return markerReportFormatTime(point?.raw?.timestamp ?? point?.timestamp);
  	  	  }

  	  	  function closeRouteMarkerInfoWindow() {
  	  	    if (activeInfo?.close) {
  	  	      activeInfo.close();
  	  	      activeInfo = null;
  	  	    }

  	  	    try {
  	  	      if (window._fineTrackWarnHubInfo?.close) {
  	  	        window._fineTrackWarnHubInfo.close();
  	  	        window._fineTrackWarnHubInfo = null;
  	  	      }
  	  	    } catch (_) {}
  	  	  }

  	  	  function openMarkerReport(marker, title, lines) {
  	  	    if (!marker || !map) return;

  	  	    closeRouteMarkerInfoWindow();

  	  	    const safeLines = Array.isArray(lines) ? lines.filter(Boolean): [];

  	  	    const html = `
  	  	    <div style="
  	  	    font:14px system-ui,sans-serif;
  	  	    background:#111;
  	  	    border-radius:10px;
  	  	    padding:12px;
  	  	    min-width:240px;
  	  	    color:#fff;
  	  	    ">
  	  	    <div style="
  	  	    font-weight:600;
  	  	    font-size:15px;
  	  	    color:#CC6633;
  	  	    ">${title}</div>

  	  	    <div style="
  	  	    margin-top:6px;
  	  	    line-height:1.4em;
  	  	    ">
  	  	    ${safeLines.join("<br>")}
  	  	    </div>
  	  	    </div>
  	  	    `;

  	  	    window._fineTrackWarnHubInfo = new google.maps.InfoWindow({
  	  	      content: html
  	  	    });
  	  	    registerFineTrackOverlay(map, window._fineTrackWarnHubInfo);

  	  	    window._fineTrackWarnHubInfo.open(map, marker);
  	  	  }

  	  	  // ---------- Idle report helpers ----------
  	  	  const idleSegments = Array.isArray(tractor?.Events?.["Idle Event"])
  	  	  ? tractor.Events["Idle Event"]: [];

  	  	  function getIdleSegmentWindowMs(seg) {
  	  	    if (!seg || typeof seg !== "object") return null;

  	  	    const firstPoint = Array.isArray(seg.Points) && seg.Points.length
  	  	    ? seg.Points[0]: null;

  	  	    const lastPoint = Array.isArray(seg.Points) && seg.Points.length
  	  	    ? seg.Points[seg.Points.length - 1]: null;

  	  	    const startMs =
  	  	    markerReportTimestampMs(seg.start_iso) ||
  	  	    markerReportTimestampMs(seg.start) ||
  	  	    markerReportTimestampMs(firstPoint?.timestamp);

  	  	    let endMs = markerReportTimestampMs(lastPoint?.timestamp);

  	  	    if (!Number.isFinite(endMs) && Number.isFinite(startMs) && Number.isFinite(Number(seg.idle_seconds))) {
  	  	      endMs = startMs + Number(seg.idle_seconds) * 1000;
  	  	    }

  	  	    if (!Number.isFinite(startMs)) return null;

  	  	    if (!Number.isFinite(endMs)) {
  	  	      endMs = startMs;
  	  	    }

  	  	    return {
  	  	      startMs,
  	  	      endMs
  	  	    };
  	  	  }

  	  	  function getIdleSegmentPosition(seg) {
  	  	    if (!seg || typeof seg !== "object") return null;

  	  	    let lat = markerReportNumber(seg.lat ?? seg.latitude);
  	  	    let lng = markerReportNumber(seg.lon ?? seg.lng ?? seg.longitude);

  	  	    if ((!Number.isFinite(lat) || !Number.isFinite(lng)) && Array.isArray(seg.Points) && seg.Points.length) {
  	  	      const p = seg.Points[0];

  	  	      lat = markerReportNumber(
  	  	        p.lat ??
  	  	        p.latitude ??
  	  	        p.point?.["position.latitude"]
  	  	      );

  	  	      lng = markerReportNumber(
  	  	        p.lon ??
  	  	        p.lng ??
  	  	        p.longitude ??
  	  	        p.point?.["position.longitude"]
  	  	      );
  	  	    }

  	  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  	  	    return {
  	  	      lat,
  	  	      lng
  	  	    };
  	  	  }

  	  	  function findIdleSegmentForPoint(point) {
  	  	    if (!point || !idleSegments.length) return null;

  	  	    const pointMs = markerReportTimestampMs(point.raw?.timestamp ?? point.timestamp);
  	  	    const pointLat = markerReportNumber(point.lat ?? point.raw?.["position.latitude"]);
  	  	    const pointLng = markerReportNumber(point.lng ?? point.lon ?? point.raw?.["position.longitude"]);

  	  	    // Best match: timestamp inside idle segment.
  	  	    if (Number.isFinite(pointMs)) {
  	  	      for (const seg of idleSegments) {
  	  	        const win = getIdleSegmentWindowMs(seg);
  	  	        if (!win) continue;

  	  	        const padMs = 15000;

  	  	        if (pointMs >= win.startMs - padMs && pointMs <= win.endMs + padMs) {
  	  	          return seg;
  	  	        }
  	  	      }
  	  	    }

  	  	    // Fallback: nearby idle segment position.
  	  	    if (Number.isFinite(pointLat) && Number.isFinite(pointLng)) {
  	  	      for (const seg of idleSegments) {
  	  	        const pos = getIdleSegmentPosition(seg);
  	  	        if (!pos) continue;

  	  	        const d = haversineM(
  	  	          {
  	  	            lat: pointLat, lng: pointLng
  	  	          },
  	  	          {
  	  	            lat: pos.lat, lng: pos.lng
  	  	          }
  	  	        );

  	  	        if (d <= 60) {
  	  	          return seg;
  	  	        }
  	  	      }
  	  	    }

  	  	    return null;
  	  	  }

  	  	  function buildIdleMarkerReportLines(idleSeg) {
  	  	    const startText =
  	  	    markerReportFormatTime(idleSeg?.start_iso) ||
  	  	    markerReportFormatTime(idleSeg?.start) ||
  	  	    markerReportFormatTime(idleSeg?.Points?.[0]?.timestamp) ||
  	  	    "—";

  	  	    const idleText =
  	  	    idleSeg?.idle_human ||
  	  	    markerReportFormatDuration(idleSeg?.idle_seconds || 0);

  	  	    return [
  	  	      `Start: ${startText}`,
  	  	      `Idle: ${idleText}`
  	  	    ];
  	  	  }

  	  	  function openIdleMarkerReport(marker, point, idleSeg) {
  	  	    if (!marker || !idleSeg) return;

  	  	    openMarkerReport(
  	  	      marker,
  	  	      "Idle Event",
  	  	      buildIdleMarkerReportLines(idleSeg)
  	  	    );
  	  	  }

  	  	  // ---------- Stop report helpers ----------
  	  	  function isStoppedPoint(point) {
  	  	    const spd = Number(point?.raw?.["position.speed"]);
  	  	    return Number.isFinite(spd) && spd < 1;
  	  	  }

  	  	  function hasRawIdleEvent(point) {
  	  	    const evs = (point?.raw?.events || []).map(e => String(e || "").toLowerCase());
  	  	    return evs.some(e => e.includes("idle"));
  	  	  }

  	  	  function isConfirmedIdlePoint(point) {
  	  	    return !!findIdleSegmentForPoint(point) || hasRawIdleEvent(point);
  	  	  }

  	  	  function buildStopSegments(points) {
  	  	    const segments = [];
  	  	    let current = null;

  	  	    function flushCurrent() {
  	  	      if (current && current.points.length) {
  	  	        segments.push(current);
  	  	      }

  	  	      current = null;
  	  	    }

  	  	    points.forEach(point => {
  	  	      const stopped = isStoppedPoint(point);
  	  	      const idle = isConfirmedIdlePoint(point);

  	  	      // Red stop markers should be stopped-only.
  	  	      // Real idle gets yellow instead.
  	  	      if (stopped && !idle) {
  	  	        if (!current) {
  	  	          current = {
  	  	            points: []
  	  	          };
  	  	        }

  	  	        current.points.push(point);
  	  	      } else {
  	  	        flushCurrent();
  	  	      }
  	  	    });

  	  	    flushCurrent();

  	  	    return segments;
  	  	  }

  	  	  function getStopSegmentDurationSeconds(seg) {
  	  	    if (!seg || !Array.isArray(seg.points) || !seg.points.length) return 0;

  	  	    const first = seg.points[0];
  	  	    const last = seg.points[seg.points.length - 1];

  	  	    const startMs = markerReportTimestampMs(first.raw?.timestamp ?? first.timestamp);
  	  	    const endMs = markerReportTimestampMs(last.raw?.timestamp ?? last.timestamp);

  	  	    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return 0;

  	  	    return Math.max(0, Math.round((endMs - startMs) / 1000));
  	  	  }

  	  	  function buildStopMarkerReportLines(stopSeg) {
  	  	    const first = stopSeg?.points?.[0];
  	  	    const stoppedTime = markerPointTime(first);
  	  	    const duration = markerReportFormatDuration(getStopSegmentDurationSeconds(stopSeg));

  	  	    return [
  	  	      `Stopped Time: ${stoppedTime}`,
  	  	      `Duration: ${duration}`
  	  	    ];
  	  	  }

  	  	  // ---------- Start marker: green, time only ----------
  	  	  if (path.length) {
  	  	    const startMarker = makeMarker(path[0], "#00cc44", "START", 1.5, 1001);

  	  	    startMarker.addListener("click", () => {
  	  	      openMarkerReport(startMarker, "Start", [
  	  	        `Time: ${markerPointTime(path[0])}`
  	  	      ]);
  	  	    });
  	  	  }

  	  	  // ---------- End marker ----------
  	  	  if (path.length > 1) {
  	  	    const endPoint = path[path.length - 1];
  	  	    const endMarker = makeMarker(endPoint, "#cc0000", "END", 1.5, 1001);

  	  	    endMarker.addListener("click", () => {
  	  	      openMarkerReport(endMarker, "End", [
  	  	        `Time: ${markerPointTime(endPoint)}`
  	  	      ]);
  	  	    });
  	  	  }

  	  	  // ---------- Yellow idle markers: ONE marker per Idle Event ----------
  	  	  // Idle Event segments are authoritative. Plot the first tracking point in each
  	  	  // event only. Do not loop over every path point and do not combine segment
  	  	  // markers with raw idle markers, because that creates duplicate yellow dots.

  	  	  const idleMarkerBool = value => {
  	  	    if (value === true || value === 1) return true;
  	  	    if (value === false || value === 0 || value == null) return false;
  	  	    return String(value).trim().toLowerCase() === "true";
  	  	  };

  	  	  const idleMarkerPointMs = point =>
  	  	  markerReportTimestampMs(point?.raw?.timestamp ?? point?.timestamp);

  	  	  const idleMarkerTotal = point => {
  	  	    const raw = point?.raw || {};
  	  	    const n = Number(raw["idle.total"] ?? raw.totalidle);
  	  	    return Number.isFinite(n) && n >= 0 ? n: null;
  	  	  };

  	  	  const idleMarkerExplicitActive = point => {
  	  	    const raw = point?.raw || {};

  	  	    if (raw["idle.status"] !== undefined) {
  	  	      return idleMarkerBool(raw["idle.status"]);
  	  	    }

  	  	    if (raw.idle !== undefined) {
  	  	      return idleMarkerBool(raw.idle);
  	  	    }

  	  	    return hasRawIdleEvent(point);
  	  	  };

  	  	  // Use the widest reliable event window. Some event-engine versions return
  	  	  // only one Point, so idle_seconds must still extend the event end time.
  	  	  const idleMarkerSegmentWindow = seg => {
  	  	    if (!seg || typeof seg !== "object") return null;

  	  	    const firstSegPoint = Array.isArray(seg.Points) && seg.Points.length
  	  	    ? seg.Points[0]: null;

  	  	    const lastSegPoint = Array.isArray(seg.Points) && seg.Points.length
  	  	    ? seg.Points[seg.Points.length - 1]: null;

  	  	    const startMs =
  	  	    markerReportTimestampMs(seg.start_iso) ||
  	  	    markerReportTimestampMs(seg.start) ||
  	  	    markerReportTimestampMs(firstSegPoint?.timestamp);

  	  	    if (!Number.isFinite(startMs)) return null;

  	  	    const pointEndMs = markerReportTimestampMs(lastSegPoint?.timestamp);
  	  	    const idleSeconds = Number(seg.idle_seconds);
  	  	    const durationEndMs = Number.isFinite(idleSeconds) && idleSeconds >= 0
  	  	    ? startMs + idleSeconds * 1000: null;

  	  	    let endMs = startMs;
  	  	    if (Number.isFinite(pointEndMs)) endMs = Math.max(endMs, pointEndMs);
  	  	    if (Number.isFinite(durationEndMs)) endMs = Math.max(endMs, durationEndMs);

  	  	    return {
  	  	      startMs,
  	  	      endMs
  	  	    };
  	  	  };

  	  	  const idleMarkerDistanceM = (a, b) => {
  	  	    if (!a || !b) return Infinity;

  	  	    const aLat = Number(a.lat);
  	  	    const aLng = Number(a.lng);
  	  	    const bLat = Number(b.lat);
  	  	    const bLng = Number(b.lng);

  	  	    if (![aLat, aLng, bLat, bLng].every(Number.isFinite)) return Infinity;

  	  	    return haversineM(
  	  	      {
  	  	        lat: aLat, lng: aLng
  	  	      },
  	  	      {
  	  	        lat: bLat, lng: bLng
  	  	      }
  	  	    );
  	  	  };

  	  	  // Find the true first route point for the event. Prefer an explicitly active
  	  	  // idle point at/near the event start. Fall back to the closest route point,
  	  	  // then to the first coordinate stored in the event itself.
  	  	  const firstPathPointForIdleSegment = seg => {
  	  	    const win = idleMarkerSegmentWindow(seg);
  	  	    if (!win) return null;

  	  	    const earlyToleranceMs = 5000;
  	  	    const lateToleranceMs = 15000;

  	  	    for (const point of path) {
  	  	      const pointMs = idleMarkerPointMs(point);
  	  	      if (!Number.isFinite(pointMs)) continue;
  	  	      if (pointMs < win.startMs - earlyToleranceMs) continue;
  	  	      if (pointMs > win.endMs + lateToleranceMs) break;

  	  	      if (idleMarkerExplicitActive(point)) {
  	  	        return point;
  	  	      }
  	  	    }

  	  	    let nearest = null;
  	  	    let nearestDiff = Infinity;

  	  	    for (const point of path) {
  	  	      const pointMs = idleMarkerPointMs(point);
  	  	      if (!Number.isFinite(pointMs)) continue;

  	  	      const diff = Math.abs(pointMs - win.startMs);
  	  	      if (diff < nearestDiff) {
  	  	        nearest = point;
  	  	        nearestDiff = diff;
  	  	      }
  	  	    }

  	  	    if (nearest && nearestDiff <= 120000) {
  	  	      return nearest;
  	  	    }

  	  	    const segPoint = Array.isArray(seg.Points) && seg.Points.length
  	  	    ? seg.Points[0]: null;

  	  	    const lat = Number(
  	  	      segPoint?.lat ??
  	  	      segPoint?.latitude ??
  	  	      segPoint?.point?.["position.latitude"] ??
  	  	      seg.lat ??
  	  	      seg.latitude
  	  	    );

  	  	    const lng = Number(
  	  	      segPoint?.lon ??
  	  	      segPoint?.lng ??
  	  	      segPoint?.longitude ??
  	  	      segPoint?.point?.["position.longitude"] ??
  	  	      seg.lon ??
  	  	      seg.lng ??
  	  	      seg.longitude
  	  	    );

  	  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  	  	    return {
  	  	      lat,
  	  	      lng,
  	  	      timestamp: win.startMs / 1000,
  	  	      raw: segPoint?.point || {
  	  	        timestamp: win.startMs / 1000,
  	  	        "position.latitude": lat,
  	  	        "position.longitude": lng,
  	  	        "idle.status": true,
  	  	        "idle.total": Number(seg.idle_seconds) || 0
  	  	      }
  	  	    };
  	  	  };

  	  	  const idleMarkerRecords = [];

  	  	  if (idleSegments.length) {
  	  	    // Primary path: exactly one candidate for each generated Idle Event.
  	  	    const sortedIdleSegments = idleSegments
  	  	    .map(seg => ({
  	  	      seg,
  	  	      win: idleMarkerSegmentWindow(seg)
  	  	    }))
  	  	    .filter(item => item.win)
  	  	    .sort((a, b) => a.win.startMs - b.win.startMs);

  	  	    sortedIdleSegments.forEach(item => {
  	  	      const point = firstPathPointForIdleSegment(item.seg);
  	  	      if (!point) return;

  	  	      // Defensive dedupe for duplicate/overlapping event objects. Two records
  	  	      // are considered the same idle event only when their time windows overlap
  	  	      // and their first positions are close. Consecutive genuine idle events
  	  	      // therefore remain separate.
  	  	      const duplicate = idleMarkerRecords.find(existing => {
  	  	        const windowsOverlap =
  	  	        item.win.startMs <= existing.win.endMs + 2000 &&
  	  	        existing.win.startMs <= item.win.endMs + 2000;

  	  	        const sameStart =
  	  	        Math.abs(item.win.startMs - existing.win.startMs) <= 2000;

  	  	        const closePosition = idleMarkerDistanceM(point, existing.point) <= 30;

  	  	        return sameStart || (windowsOverlap && closePosition);
  	  	      });

  	  	      if (duplicate) {
  	  	        // Keep the earliest marker position, but retain the event with the
  	  	        // longest reported duration for the click report.
  	  	        const existingSeconds = Number(duplicate.seg?.idle_seconds) || 0;
  	  	        const candidateSeconds = Number(item.seg?.idle_seconds) || 0;

  	  	        if (candidateSeconds > existingSeconds) {
  	  	          duplicate.seg = item.seg;
  	  	          duplicate.win.endMs = Math.max(duplicate.win.endMs, item.win.endMs);
  	  	        }

  	  	        return;
  	  	      }

  	  	      idleMarkerRecords.push({
  	  	        point,
  	  	        seg: item.seg,
  	  	        win: item.win
  	  	      });
  	  	    });
  	  	  } else {
  	  	    // Historical fallback only when no generated Idle Event segments exist.
  	  	    // Ignore isolated false packets and use the increasing Flespi counter to
  	  	    // keep one continuous raw sequence together.
  	  	    let rawSequence = null;

  	  	    const flushRawSequence = () => {
  	  	      if (rawSequence?.point) {
  	  	        idleMarkerRecords.push(rawSequence);
  	  	      }
  	  	      rawSequence = null;
  	  	    };

  	  	    path.forEach(point => {
  	  	      if (!idleMarkerExplicitActive(point)) return;

  	  	      const pointMs = idleMarkerPointMs(point);
  	  	      const total = idleMarkerTotal(point);

  	  	      const counterReset =
  	  	      rawSequence &&
  	  	      total != null &&
  	  	      rawSequence.lastTotal != null &&
  	  	      total + 0.001 < rawSequence.lastTotal;

  	  	      const staleGap =
  	  	      rawSequence &&
  	  	      Number.isFinite(pointMs) &&
  	  	      Number.isFinite(rawSequence.lastMs) &&
  	  	      pointMs - rawSequence.lastMs > 185000;

  	  	      if (!rawSequence || counterReset || staleGap) {
  	  	        flushRawSequence();
  	  	        rawSequence = {
  	  	          point,
  	  	          seg: null,
  	  	          win: {
  	  	            startMs: pointMs,
  	  	            endMs: pointMs
  	  	          },
  	  	          lastMs: pointMs,
  	  	          lastTotal: total,
  	  	          maxIdleTotal: total ?? 0
  	  	        };
  	  	        return;
  	  	      }

  	  	      rawSequence.lastMs = pointMs;
  	  	      rawSequence.lastTotal = total;
  	  	      rawSequence.win.endMs = Number.isFinite(pointMs)
  	  	      ? pointMs: rawSequence.win.endMs;

  	  	      if (total != null && total > rawSequence.maxIdleTotal) {
  	  	        rawSequence.maxIdleTotal = total;
  	  	      }
  	  	    });

  	  	    flushRawSequence();
  	  	  }

  	  	  idleMarkerRecords.forEach(record => {
  	  	    const firstPoint = record.point;
  	  	    if (!firstPoint) return;

  	  	    const marker = makeMarker(firstPoint, "#ffcc00", "", 1.5, 999);

  	  	    marker.addListener("click", () => {
  	  	      if (record.seg) {
  	  	        openIdleMarkerReport(marker, firstPoint, record.seg);
  	  	        return;
  	  	      }

  	  	      openMarkerReport(marker, "Idle Event", [
  	  	        `Start: ${markerPointTime(firstPoint)}`,
  	  	        `Idle: ${markerReportFormatDuration(record.maxIdleTotal || 0)}`
  	  	      ]);
  	  	    });
  	  	  });

  	  	  // ---------- Red stopped markers ----------
  	  	  const stopSegments = buildStopSegments(path);

  	  	  stopSegments.forEach(stopSeg => {
  	  	    const first = stopSeg.points[0];
  	  	    if (!first) return;

  	  	    const marker = makeMarker(first, "#cc0000", "", 1.25, 998);

  	  	    marker.addListener("click", () => {
  	  	      openMarkerReport(marker, "Stopped", buildStopMarkerReportLines(stopSeg));
  	  	    });
  	  	  });
  	  	  // ---------- ESC ----------
  	  	  window.removeEventListener("keydown",
  	  	    window._fineTrackKeyHandler);
  	  	  window._fineTrackKeyHandler = e=> {
  	  	    if (e.key === "Escape") {
  	  	      clearPopup();
  	  	    }};
  	  	  window.addEventListener("keydown", window._fineTrackKeyHandler);

  	  	  // ---------- Center Map ----------
  	  	  if (path.length) {
  	  	    const bounds = new google.maps.LatLngBounds();
  	  	    path.forEach(p => bounds.extend(p));
  	  	    map.fitBounds(bounds, {
  	  	      top: 80, right: 80, bottom: 80, left: 80
  	  	    });
  	  	    const currentZoom = map.getZoom();
  	  	    if (currentZoom > 18) map.setZoom(18); // optional upper limit
  	  	  }

  	  	  // === Add Event Markers (Fuel Gain / Fuel Loss) ===
  	  	  try {
  	  	    const events = App?.SelectedTractor?.Events || {};
  	  	    const gainEvents =
  	  	    Array.isArray(events["Fuel Gain (Refuel)"])
  	  	    ? events["Fuel Gain (Refuel)"]: Array.isArray(events["Fuel Gain"])
  	  	    ? events["Fuel Gain"]: [];

  	  	    const lossEvents = Array.isArray(events["Fuel Loss"]) ? events["Fuel Loss"]: [];

  	  	    const makeSVGMarker = (svgText, position, label, infoHtml, z = 1600) => {
  	  	      if (!svgText || !position) return;
  	  	      const iconUrl = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgText)}`;

  	  	      const marker = new google.maps.Marker({
  	  	        position,
  	  	        map,
  	  	        title: label || "",
  	  	        zIndex: z,
  	  	        icon: {
  	  	          url: iconUrl,
  	  	          scaledSize: new google.maps.Size(56, 56), // 48–64px looks good
  	  	          anchor: new google.maps.Point(28, 28) // centers it
  	  	        }
  	  	      });
  	  	      registerFineTrackOverlay(map, marker);

  	  	      if (infoHtml) {
  	  	        const info = new google.maps.InfoWindow({
  	  	          content: infoHtml
  	  	        });
  	  	        registerFineTrackOverlay(map, info);
  	  	        marker.addListener("click", () => info.open(map, marker));
  	  	      }
  	  	      return marker;
  	  	    };


  	  	    const makeInfo = (ev) => {
  	  	      const startTs = new Date((ev.Points?.[0]?.timestamp ?? 0) * 1000);
  	  	      return `
  	  	      <div style="font:13px system-ui;color:#fff;background:#111;padding:8px;border-radius:8px;min-width:200px;">
  	  	      <b>${ev.eventType || "Fuel Loss"}</b><br>
  	  	      <div style="opacity:.8">Time:</div>${startTs.toLocaleString("en-ZA")}<br>
  	  	      <div style="opacity:.8">Distance:</div>${ev.distance ?? "—"} m<br>
  	  	      <div style="opacity:.8">Avg:</div>${ev.AVG ?? "—"} km/h<br>
  	  	      <div style="opacity:.8">Max:</div>${ev.Max ?? "—"} km/h
  	  	      </div>`;
  	  	    };

  	  	    const addMarkers = (list, svg, labelPrefix) => {
  	  	      list.forEach((ev, i) => {
  	  	        const pt = ev.Points?.[0];
  	  	        if (!pt) return;

  	  	        const lat = Number(pt.lat ?? pt.point?.["position.latitude"]);
  	  	        const lng = Number(pt.lon ?? pt.point?.["position.longitude"]);
  	  	        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;


  	  	        makeSVGMarker(
  	  	          svg,
  	  	          {
  	  	            lat, lng
  	  	          },
  	  	          `${labelPrefix} #${i + 1}`,
  	  	          makeInfo(ev)
  	  	        );
  	  	      });
  	  	    };

  	  	    addMarkers(gainEvents,
  	  	      Images?.FuelGain,
  	  	      "Fuel Gain");
  	  	    addMarkers(lossEvents,
  	  	      Images?.FuelLoss,
  	  	      "Fuel Loss");

  	  	  } catch (err) {
  	  	    console.warn("Fuel Event marker error:",
  	  	      err);
  	  	  }

  	  	  // === Add Location Polygons & Entrance Markers === (Backendless structure)
  	  	  try {
  	  	    const locations = Locations; // already destructured from args
  	  	    if (Array.isArray(locations) && locations.length) {
  	  	      locations.forEach(loc => {
  	  	        const color = loc.Color || "#00BCD4";
  	  	        const name = loc.Name || loc.REF || "Unnamed";

  	  	        // Backendless polygon + entrance point
  	  	        const polyData = loc.Polygon?.boundary?.points; // [{x, y}, ...]
  	  	        const entry = loc.EntrancePoint
  	  	        ? {
  	  	          lat: Number(loc.EntrancePoint.y), lng: Number(loc.EntrancePoint.x)
  	  	        }: null;

  	  	        // --- Draw Polygon ---
  	  	        if (Array.isArray(polyData) && polyData.length) {
  	  	          const path = polyData.map(p => ({
  	  	            lat: Number(p.y), lng: Number(p.x)
  	  	          }));
  	  	          const polygon = new google.maps.Polygon({
  	  	            paths: path,
  	  	            strokeColor: color,
  	  	            strokeOpacity: 0.9,
  	  	            strokeWeight: 2,
  	  	            fillColor: color,
  	  	            fillOpacity: 0.25,
  	  	            map,
  	  	            zIndex: 1
  	  	          });
  	  	          registerFineTrackOverlay(map, polygon);

  	  	          const info = new google.maps.InfoWindow({
  	  	            content: `
  	  	            <div style="font:14px system-ui,sans-serif;">
  	  	            <b>${name}</b><br>
  	  	            <div style="color:#666;margin-top:4px;">${loc.Type || ""}</div>
  	  	            </div>`
  	  	          });
  	  	          registerFineTrackOverlay(map, info);

  	  	          polygon.addListener("click", e => info.open(map, {
  	  	            position: e.latLng
  	  	          }));
  	  	          polygon.addListener("mouseover", () => polygon.setOptions({
  	  	            fillOpacity: 0.45
  	  	          }));
  	  	          polygon.addListener("mouseout", () => polygon.setOptions({
  	  	            fillOpacity: 0.25
  	  	          }));
  	  	        }

  	  	        // --- Entrance Marker ---
  	  	        if (entry) {
  	  	          const marker = new google.maps.Marker({
  	  	            position: entry,
  	  	            map,
  	  	            title: `${name} Entrance`,
  	  	            icon: {
  	  	              path: google.maps.SymbolPath.CIRCLE,
  	  	              scale: 4,
  	  	              fillColor: color,
  	  	              fillOpacity: 1,
  	  	              strokeColor: "#fff",
  	  	              strokeWeight: 1.5
  	  	            },
  	  	            zIndex: 2
  	  	          });
  	  	          registerFineTrackOverlay(map, marker);

  	  	          const info = new google.maps.InfoWindow({
  	  	            content: `
  	  	            <div style="font:13px system-ui,sans-serif;color:#333;">
  	  	            🚪 <b>${name}</b><br>
  	  	            <div style="color:#666;margin-top:3px;">Entrance Point</div>
  	  	            </div>`
  	  	          });
  	  	          registerFineTrackOverlay(map, info);

  	  	          marker.addListener("click", () => info.open(map, marker));
  	  	        }
  	  	      });
  	  	    }
  	  	  } catch (err) {
  	  	    console.warn("Location render error:",
  	  	      err);
  	  	  }

  	  	  // ======================================================================
  	  	  // ============ TripReplay (Centered Launcher + Extended Speed) ==========
  	  	  // ======================================================================
  	  	  (function tripReplayController() {
  	  	    if (!map || !tractor || !Array.isArray(tractor.Tracking) || !tractor.Tracking.length) return;
  	  	    const replayPath = path;
  	  	    const tractorColor = tractor.color || "#2196F3";

  	  	    // Clean previous instances
  	  	    ["fineTrackReplayPanel",
  	  	      "fineTrackReplayLauncher",
  	  	      "fineTrackReplayPulseStyle"].forEach(id => {
  	  	        const el = document.getElementById(id);
  	  	        if (el)el.remove();
  	  	      });

  	  	    // --- Inject pulse keyframes ---
  	  	    const pulseStyle = document.createElement("style");
  	  	    registerFineTrackElement(map, pulseStyle);

  	  	    pulseStyle.id = "fineTrackReplayPulseStyle";
  	  	    pulseStyle.textContent = `
  	  	    @keyframes pulse {
  	  	    0% { box-shadow: 0 0 0 0 rgba(204,102,51,0.7); }
  	  	    70% { box-shadow: 0 0 0 8px rgba(204,102,51,0); }
  	  	    100% { box-shadow: 0 0 0 0 rgba(204,102,51,0); }
  	  	    }
  	  	    `;
  	  	    document.head.appendChild(pulseStyle);

  	  	    // --- Square Launcher Button ---
  	  	    const launcher = document.createElement("div");
  	  	    registerFineTrackElement(map, launcher);

  	  	    launcher.id = "fineTrackReplayLauncher";
  	  	    Object.assign(launcher.style,
  	  	      {
  	  	        position: "absolute",
  	  	        bottom: "14px",
  	  	        left: "14px",
  	  	        width: "48px",
  	  	        height: "48px",
  	  	        borderRadius: "10px",
  	  	        background: "rgba(0,0,0,0.6)",
  	  	        display: "flex",
  	  	        alignItems: "center",
  	  	        justifyContent: "center",
  	  	        color: "#CC6633",
  	  	        cursor: "pointer",
  	  	        zIndex: 9998,
  	  	        userSelect: "none",
  	  	        fontSize: "24px",
  	  	        fontWeight: "bold",
  	  	        transition: "transform 0.2s ease, box-shadow 0.2s ease"
  	  	      });
  	  	    launcher.innerHTML = "▶";
  	  	    map.getDiv().appendChild(launcher);

  	  	    // Hover pulse
  	  	    launcher.addEventListener("mouseenter",
  	  	      ()=> {
  	  	        launcher.style.animation = "pulse 1.6s infinite";
  	  	        launcher.style.transform = "scale(1.1)";
  	  	      });
  	  	    launcher.addEventListener("mouseleave",
  	  	      ()=> {
  	  	        launcher.style.animation = "none";
  	  	        launcher.style.transform = "scale(1.0)";
  	  	      });

  	  	    // --- Replay Panel ---
  	  	    const panel = document.createElement("div");
  	  	    registerFineTrackElement(map, panel);

  	  	    panel.id = "fineTrackReplayPanel";
  	  	    Object.assign(panel.style,
  	  	      {
  	  	        position: "absolute",
  	  	        bottom: "70px",
  	  	        left: "12px",
  	  	        background: "rgba(20,20,20,0.6)",
  	  	        color: "#fff",
  	  	        padding: "12px 14px",
  	  	        borderRadius: "10px",
  	  	        font: "13px system-ui",
  	  	        zIndex: 9999,
  	  	        width: "340px",
  	  	        boxShadow: "0 0 10px rgba(0,0,0,0.4)",
  	  	        userSelect: "none",
  	  	        display: "none"
  	  	      });
  	  	    panel.innerHTML = `
  	  	    <div style="display:flex;align-items:center;justify-content:space-between;">
  	  	    <div style="display:flex;gap:6px;">
  	  	    <button id="replayPlay"  style="width:38px;height:34px;border:none;border-radius:6px;background:#CC6633;color:#fff;cursor:pointer;font-weight:900;">▶</button>
  	  	    <button id="replayPause" style="width:38px;height:34px;border:none;border-radius:6px;background:#555;color:#fff;cursor:pointer;font-weight:900;">⏸</button>
  	  	    </div>
  	  	    <div id="replayClose" style="cursor:pointer;font-size:16px;font-weight:bold;">✕</div>
  	  	    </div>
  	  	    <div style="margin-top:10px;">Speed:
  	  	    <input id="replaySpeed" type="range" min="0.01" max="0.16" step="0.01" value="0.08" style="vertical-align:middle;width:180px;">
  	  	    <span id="replaySpeedVal">1×</span>
  	  	    </div>
  	  	    <div style="height:10px;background:#333;border-radius:4px;overflow:hidden;margin-top:6px;cursor:pointer;">
  	  	    <div id="replayProgress" style="height:100%;width:0%;background:${tractorColor};transition:width 0.1s;"></div>
  	  	    </div>
  	  	    `;
  	  	    map.getDiv().appendChild(panel);

  	  	    // --- Show / Hide Logic ---
  	  	    launcher.onclick = ()=> {
  	  	      panel.style.display = "block"; launcher.style.display = "none";
  	  	    };
  	  	    const closePanel = ()=> {
  	  	      stop(); panel.style.display = "none"; launcher.style.display = "flex";
  	  	    };
  	  	    panel.querySelector("#replayClose").onclick = closePanel;

  	  	    // --- State ---
  	  	    let idx = 0, playing = false, paused = false, timer = null;
  	  	    let replayMarker = null;
  	  	    const btnPlay = panel.querySelector("#replayPlay");
  	  	    const btnPause = panel.querySelector("#replayPause");
  	  	    const speedInput = panel.querySelector("#replaySpeed");
  	  	    const speedVal = panel.querySelector("#replaySpeedVal");
  	  	    const progBar = panel.querySelector("#replayProgress");
  	  	    const barContainer = progBar.parentElement;

  	  	    const BTN_ORANGE = "#CC6633";
  	  	    const BTN_GREY = "#555";

  	  	    function paintReplayButtons() {
  	  	      const isRunning = playing && !paused;

  	  	      // Play: orange when not playing, grey when playing.
  	  	      btnPlay.style.background = isRunning ? BTN_GREY: BTN_ORANGE;
  	  	      btnPlay.style.opacity = isRunning ? "0.82": "1";

  	  	      // Pause: opposite.
  	  	      btnPause.style.background = isRunning ? BTN_ORANGE: BTN_GREY;
  	  	      btnPause.style.opacity = isRunning ? "1": "0.82";
  	  	    }

  	  	    function formatReplaySpeedLabel(actualSpeed) {
  	  	      const displaySpeed = Number(actualSpeed) / 0.08;

  	  	      if (!Number.isFinite(displaySpeed)) {
  	  	        return "1×";
  	  	      }

  	  	      const rounded = Math.round(displaySpeed * 10) / 10;

  	  	      if (Math.abs(rounded - Math.round(rounded)) < 0.001) {
  	  	        return `${Math.round(rounded)}×`;
  	  	      }

  	  	      return `${rounded.toFixed(1)}×`;
  	  	    }

  	  	    speedInput.oninput = () => {
  	  	      speedVal.textContent = formatReplaySpeedLabel(speedInput.value);
  	  	    };

  	  	    // Force correct starting label.
  	  	    speedVal.textContent = formatReplaySpeedLabel(speedInput.value);
  	  	    const setReplayActive = on=> {
  	  	      App._tripReplayActive=!!on;
  	  	    };

  	  	    // --- Marker Helpers ---
  	  	    const initMarker = ()=> {
  	  	      if (replayMarker)replayMarker.setMap(null);
  	  	      const f = replayPath[0];
  	  	      replayMarker = new google.maps.Marker({
  	  	        position: f, map,
  	  	        icon: {
  	  	          path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	  	          fillColor: tractorColor, fillOpacity: 1,
  	  	          strokeWeight: 2, strokeColor: "#fff",
  	  	          rotation: +f.raw["position.direction"] || 0,
  	  	          scale: 1.8, anchor: new google.maps.Point(0, 0)
  	  	        },
  	  	        zIndex: 2000
  	  	      });
  	  	      registerFineTrackOverlay(map, replayMarker);
  	  	    };
  	  	    const updateMarker = p=> {
  	  	      if (!replayMarker)return;
  	  	      replayMarker.setPosition(p);
  	  	      replayMarker.setIcon({
  	  	        path: "M -4,-12 L 0,-20 L 4,-12 A 10,10 0 1,1 -4,-12 Z",
  	  	        fillColor: tractorColor, fillOpacity: 1,
  	  	        strokeWeight: 2, strokeColor: "#fff",
  	  	        rotation: +p.raw["position.direction"] || 0,
  	  	        scale: 1.8, anchor: new google.maps.Point(0, 0)
  	  	      });
  	  	    };
  	  	    const setProgress = ()=> {
  	  	      const pct = Math.max(0, Math.min(100, (idx/(replayPath.length-1))*100));
  	  	      progBar.style.width = `${pct}%`;
  	  	    };

  	  	    // --- Seek ---
  	  	    const seekTo = fraction=> {
  	  	      idx = Math.max(0, Math.min(replayPath.length-1, Math.round(fraction*(replayPath.length-1))));
  	  	      const p = replayPath[idx];
  	  	      updateMarker(p); setProgress(); map.panTo(p);
  	  	    };
  	  	    barContainer.addEventListener("click", e=> {
  	  	      const rect = barContainer.getBoundingClientRect();
  	  	      const frac = (e.clientX-rect.left)/rect.width;
  	  	      seekTo(frac);
  	  	    });

  	  	    // --- Timestamp Playback ---
  	  	    const resetReplayToBeginning = (keepMarker) => {
  	  	      playing = false;
  	  	      paused = false;
  	  	      clearTimeout(timer);
  	  	      timer = null;
  	  	      setReplayActive(false);

  	  	      idx = 0;
  	  	      setProgress();

  	  	      if (keepMarker) {
  	  	        if (!replayMarker) {
  	  	          initMarker();
  	  	        } else {
  	  	          updateMarker(replayPath[0]);
  	  	        }

  	  	        map.panTo(replayPath[0]);
  	  	      } else if (replayMarker) {
  	  	        replayMarker.setMap(null);
  	  	        replayMarker = null;
  	  	      }

  	  	      paintReplayButtons();
  	  	    };

  	  	    const advance = () => {
  	  	      if (!playing || paused) return;

  	  	      idx++;

  	  	      // End of route:
  	  	      // reset to the beginning, stop playback, and reset button colours.
  	  	      if (idx >= replayPath.length) {
  	  	        resetReplayToBeginning(true);
  	  	        return;
  	  	      }

  	  	      const cur = replayPath[idx];
  	  	      const prev = replayPath[idx - 1];

  	  	      updateMarker(cur);
  	  	      setProgress();
  	  	      map.panTo(cur);

  	  	      const t1 = +prev.raw.timestamp;
  	  	      const t2 = +cur.raw.timestamp;

  	  	      let delta = (Number.isFinite(t1) && Number.isFinite(t2)) ? t2 - t1: 1000;
  	  	      if (delta <= 0) delta = 1000;

  	  	      const speed = parseFloat(speedInput.value || "0.08");
  	  	      timer = setTimeout(advance, delta / speed);
  	  	    };

  	  	    const play = () => {
  	  	      if (playing && !paused) return;

  	  	      // If user presses play after route ended or after reset, start cleanly.
  	  	      if (idx >= replayPath.length - 1) {
  	  	        idx = 0;
  	  	        setProgress();
  	  	      }

  	  	      if (!replayMarker) {
  	  	        initMarker();
  	  	      }

  	  	      playing = true;
  	  	      paused = false;
  	  	      setReplayActive(true);
  	  	      clearTimeout(timer);

  	  	      paintReplayButtons();
  	  	      advance();
  	  	    };

  	  	    const pause = () => {
  	  	      if (!playing) return;

  	  	      paused = true;
  	  	      playing = false;
  	  	      clearTimeout(timer);
  	  	      timer = null;
  	  	      setReplayActive(false);

  	  	      paintReplayButtons();
  	  	    };

  	  	    const stop = () => {
  	  	      resetReplayToBeginning(false);
  	  	    };

  	  	    map.__fineTrackReplayCleanup = () => {
  	  	      try {
  	  	        stop();
  	  	      } catch (_) {}

  	  	      try {
  	  	        panel.remove();
  	  	      } catch (_) {}

  	  	      try {
  	  	        launcher.remove();
  	  	      } catch (_) {}
  	  	    };

  	  	    btnPlay.onclick = play;
  	  	    btnPause.onclick = pause;

  	  	    paintReplayButtons();

  	  	    const replayEscapeHandler = e => {
  	  	      if (e.key === "Escape") closePanel();
  	  	    };

  	  	    window.addEventListener("keydown", replayEscapeHandler);
  	  	    map.__fineTrackDomControlListeners.push({
  	  	      target: window,
  	  	      event: "keydown",
  	  	      handler: replayEscapeHandler
  	  	    });
  	  	  })();

  	  	})({
  	  	  googleMapComponent, App, Locations, Images, Hub
  	  	});
  	  })(Map, AppData, Locations, ({ [`FuelLoss`]: '<svg xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" id="svg22349" inkscape:version="0.48.3.1 r9886" viewBox="0 0 430.2 440" sodipodi:version="0.32" version="1.0" sodipodi:docname="_svgclean2.svg">   <sodipodi:namedview id="base" bordercolor="#666666" inkscape:pageshadow="2" guidetolerance="10.0" pagecolor="#ffffff" gridtolerance="10.0" inkscape:window-maximized="0" inkscape:window-width="743" inkscape:zoom="1" objecttolerance="10.0" showgrid="false" borderopacity="1.0" inkscape:current-layer="layer1" inkscape:cx="215.02547" inkscape:cy="218.71371" inkscape:window-y="0" inkscape:window-x="0" inkscape:window-height="484" showborder="false" inkscape:pageopacity="0.0"/>   <sodipodi:namedview id="namedview4" bordercolor="#666666" inkscape:pageshadow="2" inkscape:window-y="25" pagecolor="#ffffff" inkscape:window-width="1280" inkscape:zoom="1.4" inkscape:window-x="0" borderopacity="1.0" inkscape:current-layer="layer1" inkscape:cx="330.58005" inkscape:cy="240.69922" inkscape:window-height="949" inkscape:pageopacity="0.0" inkscape:document-units="px"/>   <g id="layer1" inkscape:label="Calque 1" inkscape:groupmode="layer" transform="translate(-5.5995 -3.6428)">     <path id="path22357" inkscape:connector-curvature="0" sodipodi:nodetypes="ccssssccccccc" style="fill-rule:evenodd;fill:#e43434" d="m60.709 3.6428c-11.428 8.5712-52.98 53.709-52.98 53.709 0.0005 0-5.5895 220.45 1.3424 232.17 12.594 21.27 157.02 106.64 170.92 106.98 5.23 0.12 97.26-54.56 98.79-59.63 5.63-18.77 4.73-186.19 0.88-205.16-3.51-17.32-81.07-91.603-81.07-91.603l-137.88-36.465zm10.359 32.265c30.002 6.429 68.922 17.021 71.072 29.163-1.79 5-4.51 7.048-8.41 10.649-5.81 0.469-35.581-15.019-49.08-19.911-3.499-4.892-13.582-19.187-13.582-19.901z"/>     <path id="path22359" inkscape:connector-curvature="0" sodipodi:nodetypes="ccccccccccccssscccccccsc" style="opacity:.25;fill-rule:evenodd;fill:#4a4a4a" d="m196.11 38.852c-8.7-4.751-35.53-6.651-40 5.714-4.27 11.806 8.23 75.614 25.65 108.58 32.32-3.16 66.92-4.78 95.05-23.45-6.75-13.78-71.26-85.699-80.7-90.848zm-127.72-2.929c-15.714 11.429-14.026 36.219-14.026 36.219s71.313 15.524 80.723 5.2c-21.3-3.895-33.14-13.076-50.809-20.649-7.552-6.83-6.71-15.301-15.888-20.77zm-37.806 72.677c-2.857 10 33.643 96.87 33.643 96.87s-32.806 65.3-34.235 71.02c-1.429 5.71 35.735-37.64 37.164-50.5 1.428-12.86 2.143-31.95-0.714-37.66-2.858-5.72-37.287-81.16-35.858-79.73zm90.833 35.04c-17.14 25.72-38.568 52.86-38.568 52.86s42.858-38.57 45.718-44.29c2.85-5.71-8.58-10-7.15-8.57zm-40.711 82.15c0 12.85 36.431 87.14 36.431 87.14s12.14 15.71 12.14 8.57-47.142-84.29-48.571-95.71z"/>     <path id="path22361" inkscape:connector-curvature="0" sodipodi:nodetypes="cssccccssccssccccccc" style="opacity:.25;fill-rule:evenodd;fill:#000000" d="m353.73 324.55c-6.06 10.6-2.02 11.11 9.09 20.71 11.11 9.59 25.25 13.13 18.69 3.53-6.57-9.59-27.28-24.75-27.78-24.24zm-83.07-191.2c2.21-1.02 4.02-3.33 7.91-2.82 6.17 46.97 5.78 90.83 1.44 161.21 32.31 3.87 42.13 5.12 48.56 6.19 25.71 4.28 100.71 52.86 107.14 80.71 0.91 3.94-5.36 13.4-10.56 18.75 10.51 13.93-2.7 25.72-22.36 13.93-9.67 6.07-56.08 32.32-63.51 32.32-15.71 0-150.71-37.14-179.29-45.71-28.57-8.57-163.1-103.02-148.81-108.73-0.593 11.82 157.92 103.78 167.12 105.93-1.43-43.25 1.31-167.85 4.55-237.2 18.9-7.73 38.49-4.92 33.61-11.34-4.87-6.42-16.28-38.72-16.28-38.72l53.54 3.03c7.07 7.07 13.46 12.61 16.94 22.45z"/>     <path id="path22363" inkscape:connector-curvature="0" sodipodi:nodetypes="ccsscsc" style="fill-rule:evenodd;fill:#474747" d="m201.93 73.888c21.43-11.429 21.08-10.332 21.08-10.332s23.54-9.25 32.11 13.607 0.23 30.447-8.05 36.217c-4.95 3.45-20.49 9.51-20.49 9.51s-26.59-3.53-28.01-20.68c-1.43-17.139 2.94-32.868 3.36-28.322z"/>     <path id="path22365" inkscape:connector-curvature="0" sodipodi:nodetypes="css" style="fill-rule:evenodd;fill:#000000" d="m232.94 66.413c-11.77 1.992-13.64 40.217 10.68 38.567 23.58-1.59 6.32-41.444-10.68-38.567z"/>     <path id="path29389" inkscape:connector-curvature="0" sodipodi:nodetypes="cscsccccccccccccccccsccssccccscccccc" style="opacity:.5;fill-rule:evenodd;fill:#ffffff" d="m130.71 52.571s16.78 7.143 12.5 13.215c-4.29 6.071-25.72 19.285-25.72 19.285s31.79-10.714 32.5-17.5c0.72-6.785-18.92-15.357-19.28-15zm-95.358 58.929 37.143 67.86-3.929 13.21-33.214-81.07zm27.5 116.79h9.286l-38.929 48.92 29.643-48.92zm65.718-73.93-49.646 49.64-1.072 18.93 56.788 102.86-52.502-111.08 46.432-60.35zm116.31-91.189s-15.4-2.02-18.69-0.758c-3.28 1.263-25 11.87-25 11.87l20.46-7.071s-2.78 11.616-2.02 15.657 2.27-14.142 5.3-16.162c3.03-2.021 20.21-3.536 19.95-3.536zm-185.96-57.028-51.429 51.428 0.3571 231.43s2.1428-223.57 3.5719-227.86c1.428-4.283 48.214-55.354 47.5-54.997zm3.647-0.694 130.38 33.933-34.19 6.566 12.09-6.819-108.28-33.68z"/>   </g>   <metadata id="metadata13">     <rdf:RDF>       <cc:Work>         <dc:format>image/svg+xml</dc:format>         <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>         <cc:license rdf:resource="http://creativecommons.org/licenses/publicdomain/"/>         <dc:publisher>           <cc:Agent rdf:about="http://openclipart.org/">             <dc:title>Openclipart</dc:title>           </cc:Agent>         </dc:publisher>       </cc:Work>       <cc:License rdf:about="http://creativecommons.org/licenses/publicdomain/">         <cc:permits rdf:resource="http://creativecommons.org/ns#Reproduction"/>         <cc:permits rdf:resource="http://creativecommons.org/ns#Distribution"/>         <cc:permits rdf:resource="http://creativecommons.org/ns#DerivativeWorks"/>       </cc:License>     </rdf:RDF>   </metadata> </svg>',[`FuelGain`]: '<svg xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" id="svg22349" inkscape:version="0.48.3.1 r9886" viewBox="0 0 430.2 440" sodipodi:version="0.32" version="1.0" sodipodi:docname="_svgclean2.svg">   <g id="layer1" inkscape:label="Calque 1" inkscape:groupmode="layer" transform="translate(-5.5995 -3.6428)">     <path id="path22357" inkscape:connector-curvature="0" sodipodi:nodetypes="ccssssccccccc" style="fill-rule:evenodd;fill:#1e6de3" d="m60.709 3.6428c-11.428 8.5712-52.98 53.709-52.98 53.709 0.0005 0-5.5895 220.45 1.3424 232.17 12.594 21.27 157.02 106.64 170.92 106.98 5.23 0.12 97.26-54.56 98.79-59.63 5.63-18.77 4.73-186.19 0.88-205.16-3.51-17.32-81.07-91.603-81.07-91.603l-137.88-36.465zm10.359 32.265c30.002 6.429 68.922 17.021 71.072 29.163-1.79 5-4.51 7.048-8.41 10.649-5.81 0.469-35.581-15.019-49.08-19.911-3.499-4.892-13.582-19.187-13.582-19.901z"/>     <path id="path22359" style="opacity:.25;fill-rule:evenodd;fill:#4a4a4a" d="m196.11 38.852c-8.7-4.751-35.53-6.651-40 5.714-4.27 11.806 8.23 75.614 25.65 108.58 32.32-3.16 66.92-4.78 95.05-23.45-6.75-13.78-71.26-85.699-80.7-90.848zm-127.72-2.929c-15.714 11.429-14.026 36.219-14.026 36.219s71.313 15.524 80.723 5.2c-21.3-3.895-33.14-13.076-50.809-20.649-7.552-6.83-6.71-15.301-15.888-20.77zm-37.806 72.677c-2.857 10 33.643 96.87 33.643 96.87s-32.806 65.3-34.235 71.02c-1.429 5.71 35.735-37.64 37.164-50.5 1.428-12.86 2.143-31.95-0.714-37.66-2.858-5.72-37.287-81.16-35.858-79.73zm90.833 35.04c-17.14 25.72-38.568 52.86-38.568 52.86s42.858-38.57 45.718-44.29c2.85-5.71-8.58-10-7.15-8.57zm-40.711 82.15c0 12.85 36.431 87.14 36.431 87.14s12.14 15.71 12.14 8.57-47.142-84.29-48.571-95.71z"/>     <path id="path22361" style="opacity:.25;fill-rule:evenodd;fill:#000000" d="m353.73 324.55c-6.06 10.6-2.02 11.11 9.09 20.71 11.11 9.59 25.25 13.13 18.69 3.53-6.57-9.59-27.28-24.75-27.78-24.24zm-83.07-191.2c2.21-1.02 4.02-3.33 7.91-2.82 6.17 46.97 5.78 90.83 1.44 161.21 32.31 3.87 42.13 5.12 48.56 6.19 25.71 4.28 100.71 52.86 107.14 80.71 0.91 3.94-5.36 13.4-10.56 18.75 10.51 13.93-2.7 25.72-22.36 13.93-9.67 6.07-56.08 32.32-63.51 32.32-15.71 0-150.71-37.14-179.29-45.71-28.57-8.57-163.1-103.02-148.81-108.73-0.593 11.82 157.92 103.78 167.12 105.93-1.43-43.25 1.31-167.85 4.55-237.2 18.9-7.73 38.49-4.92 33.61-11.34-4.87-6.42-16.28-38.72-16.28-38.72l53.54 3.03c7.07 7.07 13.46 12.61 16.94 22.45z"/>     <path id="path22363" style="fill-rule:evenodd;fill:#474747" d="m201.93 73.888c21.43-11.429 21.08-10.332 21.08-10.332s23.54-9.25 32.11 13.607 0.23 30.447-8.05 36.217c-4.95 3.45-20.49 9.51-20.49 9.51s-26.59-3.53-28.01-20.68c-1.43-17.139 2.94-32.868 3.36-28.322z"/>     <path id="path22365" style="fill-rule:evenodd;fill:#000000" d="m232.94 66.413c-11.77 1.992-13.64 40.217 10.68 38.567 23.58-1.59 6.32-41.444-10.68-38.567z"/>     <path id="path29389" style="opacity:.5;fill-rule:evenodd;fill:#ffffff" d="m130.71 52.571s16.78 7.143 12.5 13.215c-4.29 6.071-25.72 19.285-25.72 19.285s31.79-10.714 32.5-17.5c0.72-6.785-18.92-15.357-19.28-15zm-95.358 58.929 37.143 67.86-3.929 13.21-33.214-81.07zm27.5 116.79h9.286l-38.929 48.92 29.643-48.92zm65.718-73.93-49.646 49.64-1.072 18.93 56.788 102.86-52.502-111.08 46.432-60.35zm116.31-91.189s-15.4-2.02-18.69-0.758c-3.28 1.263-25 11.87-25 11.87l20.46-7.071s-2.78 11.616-2.02 15.657 2.27-14.142 5.3-16.162c3.03-2.021 20.21-3.536 19.95-3.536zm-185.96-57.028-51.429 51.428 0.3571 231.43s2.1428-223.57 3.5719-227.86c1.428-4.283 48.214-55.354 47.5-54.997zm3.647-0.694 130.38 33.933-34.19 6.566 12.09-6.819-108.28-33.68z"/>   </g> </svg>' }), Hub, 'data:image/png;base64,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');
  	  AppData['SpinnerDone'] = true;
  	}

  	/**
  	 * Describe this function...
  	 */
  	async function Clocking2() {
  	  if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097'](From)) || (await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097'](To))) {
  	    Clocking_Function = null;
  	  } else {
  	    Clocking_Function = (await Backendless.Data.of('Clocking').find(Backendless.DataQueryBuilder.create().setWhereClause((await (async function(TimeIn, TimeOut, IDTractor) {
  	    	// Build a WHERE clause to find clockings that overlap [TimeIn, TimeOut]
  	    	// for the given truck (IDTractor). Assumes IDTractor is a STRING column.
  	    	// If it's a RELATION, change idField to 'IDTractor.objectId' below.

  	    	function toMs(v){
  	    	  if (v == null) throw new Error('Missing date/timestamp');
  	    	  if (v instanceof Date) return v.getTime();
  	    	  if (typeof v === 'number' && !Number.isNaN(v)) return Math.round(v < 1e12 ? v*1000 : v);
  	    	  if (typeof v === 'string'){
  	    	    const s = v.trim();
  	    	    if (s === '') throw new Error('Empty date string');
  	    	    if (/^-?\d+$/.test(s)) { const n = Number(s); return Math.round(n < 1e12 ? n*1000 : n); }
  	    	    const t = Date.parse(s); if (!Number.isNaN(t)) return t;
  	    	  }
  	    	  throw new Error('Invalid date/timestamp: ' + v);
  	    	}

  	    	// pull inputs (works in Codeless runtime)
  	    	const startMs = toMs((typeof inputs !== 'undefined' ? inputs.TimeIn  : TimeIn));
  	    	const endMs   = toMs((typeof inputs !== 'undefined' ? inputs.TimeOut : TimeOut));
  	    	let   truckId =        (typeof inputs !== 'undefined' ? inputs.IDTractor : IDTractor);

  	    	if (!truckId) throw new Error('IDTractor is required');

  	    	// swap if user supplied reversed window
  	    	let a = startMs, b = endMs;
  	    	if (a > b) { const t = a; a = b; b = t; }

  	    	// escape single quotes in id
  	    	truckId = String(truckId).replace(/'/g, "''");

  	    	// ---- choose the field name ----
  	    	// STRING column:
  	    	const idField = 'IDTractor';
  	    	// If it's a RELATION, use this instead:
  	    	// const idField = 'IDTractor.objectId';

  	    	// final WHERE (inclusive edges)
  	    	const where =
  	    	  `(${idField} = '${truckId}') AND (TimeIn <= ${b}) AND (TimeOut IS NULL OR TimeOut >= ${a})`;

  	    	// optional debug
  	    	// console.log('WHERE:', where);

  	    	return where;

  	    })(((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty((From[0]), 'timestamp')))) ? null : (getObjectProperty((From[0]), 'timestamp'))), ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty((To.slice(-1)[0]), 'timestamp')))) ? null : (getObjectProperty((To.slice(-1)[0]), 'timestamp'))), (getObjectProperty(Tractor, 'objectId'))))).setPageSize(100)));
  	  }
  	  return Clocking_Function
  	}

  	/**
  	 * Describe this function...
  	 */
  	async function Stations2() {
  	  try {
  	    Stations = [];
  	    var j_list2 = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
  	    for (var j_index2 in j_list2) {
  	      j = j_list2[j_index2];
  	      var k_list2 = (getObjectProperty(j, 'Stations'));
  	      for (var k_index2 in k_list2) {
  	        k = k_list2[k_index2];
  	        addItemToList(Stations, k);
  	      }
  	    }

  	  } catch (error) {
  	    console.log(error);

  	  }
  	  return Stations
  	}

  	async function asyncListFind(sourceList, callback) {
  	  const list = await Promise.all(sourceList.map(async source => ({
  	    source,
  	    value: await callback(source),
  	  })));

  	  return list.find(item => item.value)?.source || null
  	}

  	/**
  	 * Describe this function...
  	 */
  	async function Markers2() {
  	  Markers = (await Promise.all(From.map(async item => {  Clock = (await asyncListFind(Clocking, async (Clock) => {


  	     return (await (async function(Timestamp, In, Out) {
  	    	return (In <= Timestamp) && (
  	    	    (Out == null && Timestamp >= In) ||
  	    	    (Out != null && Timestamp <= Out)
  	    	);

  	    })(((getObjectProperty(item, 'timestamp')) * 1000), (getObjectProperty(Clock, 'TimeIn')), (getObjectProperty(Clock, 'TimeOut'))));
  	    }));
  	  ; return ({ [`lat`]: false ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: false ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: undefined,[`color`]: undefined,[`Speed`]: false ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: false ? null : (getObjectProperty(item, 'position.direction')) });})));
  	  return Markers.concat((Refuel_List.concat((Fuel_Loss_List.concat((Over_Rev_Markers.concat((Over_Speed_Markers.concat((Over_Temp_Markers.concat((Max_Markers.concat(Idle_Markers)))))))))))))
  	}

  	/**
  	 * Describe this function...
  	 */
  	async function Locations2() {
  	  try {
  	    Locations = [];
  	    var j_list3 = (getObjectProperty((getObjectProperty(AppData, 'User')), 'Companies'));
  	    for (var j_index3 in j_list3) {
  	      j = j_list3[j_index3];
  	      var k_list3 = (getObjectProperty(j, 'Locations'));
  	      for (var k_index3 in k_list3) {
  	        k = k_list3[k_index3];
  	        addItemToList(Locations, k);
  	      }
  	    }

  	  } catch (error) {
  	    console.log(error);

  	  }
  	  return Locations
  	}


  	  // ---------------------------------------------------------------------------
  	  // MASTER STARTUP
  	  // ---------------------------------------------------------------------------
  	  if (!__trackitAlive()) return;

  	  try {
  	    Locations = await Locations2();
  	  } catch (error) {
  	    __trackitLog("warn", "Could not build Locations list.", error);
  	    Locations = [];
  	  }

  	  if (!__trackitAlive()) return;

  	  // Preserve the existing 40-second default without depending on a Codeless
  	  // Null/Undefined helper.
  	  if (
  	    Wait === null ||
  	    Wait === undefined ||
  	    Wait === "" ||
  	    !Number.isFinite(Number(Wait)) ||
  	    Number(Wait) <= 0
  	  ) {
  	    Wait = 40000;
  	  } else {
  	    Wait = Number(Wait);
  	  }

  	  try {
  	    if (Tractors.length > 1 || Live === true) {
  	      await Multi_Track();
  	    } else if (Tractors.length === 1) {
  	      await Single_Track();
  	    } else {
  	      __trackitLog(
  	        "warn",
  	        "No tractors supplied. Nothing to render; exiting safely."
  	      );
  	    }
  	  } catch (error) {
  	    // Nothing in this controller is allowed to escape into Backendless onOpen.
  	    __trackitLog("error", "TrackIT controller caught a fatal child error.", error);

  	    try {
  	      if (AppData && typeof AppData === "object") {
  	        AppData.SpinnerMsg = "TrackIT could not complete";
  	        AppData.SpinnerDone = true;
  	      }
  	    } catch (_) {}
  	  } finally {
  	    if (!Live) {
  	      __trackitRuntime.cancelled = true;
  	      __trackitRuntime.reason = "completed";
  	    }

  	    __trackitLog(
  	      "log",
  	      "Finished/parked",
  	      {
  	        runId: __trackitRuntime.id,
  	        live: Live,
  	        cancelled: __trackitRuntime.cancelled,
  	        reason: __trackitRuntime.reason
  	      }
  	    );
  	  }


  	/*
  	===============================================================================
  	END TRACKIT MASTER CONTROLLER
  	===============================================================================
  	*/

  })(Map, AppData, Tractors, From, To, Live, Repeater, Track, Hub);

}

})
define('./functions/afe6ec398aae1809c98d61f4839bb155/code.js', () => { 

BackendlessUI.Functions.Custom['fn_afe6ec398aae1809c98d61f4839bb155'] = async function fn_afe6ec398aae1809c98d61f4839bb155(Warnings, HUB, Exclusions, Map, Tractor, Button, Only, AppData, Max) {
  await (async function(Warnings, HUB, Exclusions, Map, Tractor, Button, Only, AppData, Max) {
  	// ===== Warning Hub Popup (v9.0.0 — live anchored rewrite) =====
  	(function warningHubPopupRewrite() {
  	  if (!HUB?.el || !Map?.map?.map) return;

  	  const map = Map.map.map;
  	  const hubEl = HUB.el;
  	  const themeOrange = "#CC6633";
  	  const themeOrangeOpaque = "rgba(204,102,51,0.35)";
  	  const onlyKey = typeof Only === "string" && Only.trim() ? Only.trim(): null;

  	  const excluded = Array.isArray(Exclusions) ? [...Exclusions]: [];
  	  if (onlyKey !== "Location Events" && !excluded.includes("Location Events")) {
  	    excluded.push("Location Events");
  	  }

  	  document.getElementById("warnings-popup")?.remove();

  	  // ----------------------------------------------------------
  	  // Hide opener button
  	  // ----------------------------------------------------------
  	  try {
  	    if (Button) {
  	      if (typeof Button.setVisible === "function") Button.setVisible(false);
  	      else if ("visible" in Button) Button.visible = false;
  	    }
  	  } catch (e) {}

  	  // ----------------------------------------------------------
  	  // Helpers
  	  // ----------------------------------------------------------
  	  function formatDuration(s) {
  	    if (!s || s < 1) return "0s";
  	    const h = Math.floor(s / 3600);
  	    const m = Math.floor((s % 3600) / 60);
  	    const sec = Math.floor(s % 60);
  	    if (h) return `${h}h ${m}m ${sec}s`;
  	    if (m) return `${m}m ${sec}s`;
  	    return `${sec}s`;
  	  }

  	  function formatTime(ts) {
  	    if (!ts) return "";
  	    const d = new Date(Number(ts) * 1000);
  	    if (isNaN(d)) return "";
  	    const pad = n => n.toString().padStart(2, "0");
  	    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  	  }

  	  function formatAnyTime(v) {
  	    if (!v) return "";
  	    if (typeof v === "number") return formatTime(v);
  	    const d = new Date(v);
  	    if (isNaN(d)) return "";
  	    const pad = n => n.toString().padStart(2, "0");
  	    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  	  }

  	  function extractStartTime(entry) {
  	    let ts = null;
  	    if (entry.timestamp) ts = entry.timestamp;
  	    else if (Array.isArray(entry.Points)) {
  	      const t = entry.Points.find(p => p.timestamp != null);
  	      if (t) ts = t.timestamp;
  	    }
  	    return ts ? formatTime(ts): "";
  	  }
  	  function getMaxUnit(maxName) {
  	    const k = String(maxName || "").toLowerCase();

  	    if (k.includes("speed")) return "km/h";
  	    if (k.includes("rpm")) return "RPM";
  	    if (k.includes("temp")) return "°C";
  	    if (k.includes("throttle")) return "%";
  	    if (k.includes("fuel")) return "L";
  	    if (k.includes("idle")) return "";

  	    return "";
  	  }

  	  function formatValueWithUnit(value, unit) {
  	    const n = Number(value);

  	    if (!Number.isFinite(n)) {
  	      return value == null ? "—": String(value);
  	    }

  	    return `${n.toLocaleString()}${unit ? " " + unit: ""}`;
  	  }
  	  function guessUnit(v, key = "") {
  	    if (typeof v !== "number" || !Number.isFinite(v)) return "";
  	    const k = String(key).toLowerCase();
  	    if (k.includes("speed")) return "km/h";
  	    if (k.includes("rpm")) return "RPM";
  	    if (k.includes("temp")) return "°C";
  	    if (k.includes("fuel")) return "L";
  	    if (v > 900 && v < 9000) return "RPM";
  	    if (v >= 0 && v <= 150) return "km/h";
  	    if (v > 150 && v < 400) return "°C";
  	    return "";
  	  }

  	  function getTrailerText(entry) {
  	    if (!entry || typeof entry !== "object") return "";

  	    if (Array.isArray(entry.TrailerLabels) && entry.TrailerLabels.length) {
  	      return entry.TrailerLabels.join(", ");
  	    }

  	    if (Array.isArray(entry.Trailers) && entry.Trailers.length) {
  	      return entry.Trailers.map(function (t) {
  	        var app = (t && t.Application != null) ? String(t.Application): "";
  	        var reg = (t && t.Registration != null) ? String(t.Registration): "";
  	        var eye = (t && t.EYEID != null) ? String(t.EYEID): "";
  	        var id = (t && t.ID != null) ? String(t.ID): "";
  	        return (app && reg) ? (app + " - " + reg): (app || reg || id || eye);
  	      }).filter(Boolean).join(", ");
  	    }

  	    return "";
  	  }

  	  function isFarmLocation(entry) {
  	    const loc = entry?.Location || {};
  	    const type = String(loc.Type || loc.Category || loc.Kind || "").toLowerCase();
  	    const ref = String(loc.REF || "").toLowerCase();
  	    const name = String(loc.Name || entry.Name || "").toLowerCase();

  	    if (type === "farm") return true;
  	    if (type.includes("farm")) return true;
  	    if (ref.includes("farm")) return true;
  	    if (name.includes("farm")) return true;

  	    return false;
  	  }

  	  function normalizeEventType(v) {
  	    return String(v || "")
  	    .toLowerCase()
  	    .replace(/\s+/g, " ")
  	    .trim();
  	  }

  	  function isStillInLocation(entry) {
  	    const t = normalizeEventType(entry.type);
  	    const to = normalizeEventType(entry.type_out);
  	    return t === "started in location" && to === "in location";
  	  }

  	  function isStartedThenLeft(entry) {
  	    const t = normalizeEventType(entry.type);
  	    const to = normalizeEventType(entry.type_out);
  	    return t === "started in location" && to === "left location";
  	  }

  	  function isEnteredThenIn(entry) {
  	    const t = normalizeEventType(entry.type);
  	    const to = normalizeEventType(entry.type_out);
  	    return t === "entered location" && to === "in location";
  	  }

  	  function closeInfoWindow() {
  	    try {
  	      if (window._warnHubInfo) {
  	        window._warnHubInfo.close();
  	        window._warnHubInfo = null;
  	      }
  	    } catch (e) {}
  	  }

  	  // ----------------------------------------------------------
  	  // Popup root
  	  // ----------------------------------------------------------
  	  const popup = document.createElement("div");
  	  popup.id = "warnings-popup";
  	  Object.assign(popup.style, {
  	    position: "fixed",
  	    background: "rgba(25,25,25,0.96)",
  	    color: "#fff",
  	    zIndex: "9999",
  	    overflow: "hidden",
  	    borderTop: `2px solid ${themeOrange}`,
  	    fontFamily: "Segoe UI, sans-serif",
  	    boxShadow: "0 -4px 12px rgba(0,0,0,0.5)",
  	    display: "flex",
  	    flexDirection: "column",
  	    bottom: "0"
  	  });

  	  // ----------------------------------------------------------
  	  // Live anchor positioning
  	  // ----------------------------------------------------------
  	  let lastHubRect = null;
  	  let resizeObserver = null;
  	  let mutationObserver = null;
  	  let rafId = null;
  	  let rafFramesRemaining = 0;
  	  let isDestroyed = false;

  	  function positionPopup(force) {
  	    if (isDestroyed) return;

  	    try {
  	      const rect = hubEl.getBoundingClientRect();

  	      const nextRect = {
  	        left: rect.left,
  	        top: rect.top,
  	        bottom: rect.bottom,
  	        width: rect.width,
  	        height: rect.height
  	      };

  	      const changed =
  	      !lastHubRect ||
  	      !!force ||
  	      lastHubRect.left !== nextRect.left ||
  	      lastHubRect.top !== nextRect.top ||
  	      lastHubRect.bottom !== nextRect.bottom ||
  	      lastHubRect.width !== nextRect.width ||
  	      lastHubRect.height !== nextRect.height;

  	      if (!changed) return;

  	      popup.style.left = `${rect.left}px`;
  	      popup.style.top = `${rect.bottom}px`;
  	      popup.style.width = `${rect.width}px`;
  	      popup.style.maxHeight = `${Math.max(120, window.innerHeight - rect.bottom)}px`;

  	      lastHubRect = nextRect;
  	    } catch (e) {}
  	  }

  	  function kickPositionWatch(frameCount) {
  	    if (isDestroyed) return;

  	    rafFramesRemaining = Math.max(rafFramesRemaining, frameCount || 16);

  	    if (rafId) return;

  	    function tick() {
  	      if (isDestroyed) return;
  	      positionPopup();
  	      rafFramesRemaining--;

  	      if (rafFramesRemaining > 0) {
  	        rafId = requestAnimationFrame(tick);
  	      } else {
  	        cancelAnimationFrame(rafId);
  	        rafId = null;
  	      }
  	    }

  	    rafId = requestAnimationFrame(tick);
  	  }

  	  function setupLiveAnchoring() {
  	    try {
  	      if (typeof ResizeObserver !== "undefined") {
  	        resizeObserver = new ResizeObserver(function () {
  	          positionPopup(true);
  	          kickPositionWatch(24);
  	        });
  	        resizeObserver.observe(hubEl);
  	      }
  	    } catch (e) {}

  	    try {
  	      if (typeof MutationObserver !== "undefined") {
  	        mutationObserver = new MutationObserver(function () {
  	          positionPopup(true);
  	          kickPositionWatch(24);
  	        });

  	        if (hubEl.parentElement) {
  	          mutationObserver.observe(hubEl.parentElement, {
  	            childList: true,
  	            subtree: true,
  	            attributes: true
  	          });
  	        }
  	      }
  	    } catch (e) {}
  	  }

  	  // ----------------------------------------------------------
  	  // Header
  	  // ----------------------------------------------------------
  	  const header = document.createElement("div");
  	  Object.assign(header.style, {
  	    position: "sticky",
  	    top: "0",
  	    background: "rgba(30,30,30,0.98)",
  	    display: "flex",
  	    justifyContent: "space-between",
  	    alignItems: "center",
  	    padding: "8px 12px",
  	    borderBottom: "1px solid #555",
  	    zIndex: "10000",
  	    flex: "0 0 auto"
  	  });

  	  const title = document.createElement("span");
  	  title.innerText = onlyKey ? `⚠ Notifications Hub — ${onlyKey}`: "⚠ Notifications Hub";
  	  title.style.fontWeight = "600";
  	  title.style.fontSize = "16px";

  	  const closeBtn = document.createElement("button");
  	  closeBtn.innerText = "✕ Close";
  	  Object.assign(closeBtn.style, {
  	    background: themeOrange,
  	    color: "#000",
  	    border: "none",
  	    padding: "4px 10px",
  	    cursor: "pointer",
  	    borderRadius: "4px"
  	  });

  	  // ----------------------------------------------------------
  	  // Content container
  	  // ----------------------------------------------------------
  	  const container = document.createElement("div");
  	  Object.assign(container.style, {
  	    padding: "10px",
  	    overflowY: "auto",
  	    flex: "1 1 auto",
  	    minHeight: "0"
  	  });

  	  // ----------------------------------------------------------
  	  // Max trigger integration
  	  // ----------------------------------------------------------
  	  if (typeof Max === "string" && Max.trim()) {
  	    const maxKey = Max.trim().toLowerCase();

  	    try {
  	      const tractorEvents = Tractor?.Events || {};
  	      const maxData = tractorEvents?.MaxData || {};
  	      const entry = (() => {
  	        if (maxKey.includes("speed")) return maxData.Speed;
  	        if (maxKey.includes("rpm")) return maxData.RPM;
  	        if (maxKey.includes("temp")) return maxData.Temp;
  	        if (maxKey.includes("throttle")) return maxData.Throttle;
  	        return null;
  	      })();

  	      if (entry && Array.isArray(entry.Points) && entry.Points.length) {
  	        const p = entry.Points[0];
  	        const lat =
  	        +p.__lat ??
  	        +p["position.latitude"] ??
  	        +p.lat ??
  	        +p.latitude;
  	        const lon =
  	        +p.__lon ??
  	        +p["position.longitude"] ??
  	        +p.lon ??
  	        +p.longitude;

  	        if (Number.isFinite(lat) && Number.isFinite(lon)) {
  	          map.setCenter({
  	            lat, lng: lon
  	          });
  	          map.setZoom(16);

  	          const maxUnit = getMaxUnit(Max);
  	          const maxValueText = formatValueWithUnit(entry.value, maxUnit);

  	          const html = `
  	          <div style="font:14px system-ui,sans-serif;background:#111;border-radius:10px;padding:12px;min-width:260px;color:#fff;">
  	          <div style="font-weight:600;font-size:15px;color:#CC6633;">Max ${Max}</div>
  	          <div style="margin-top:6px;line-height:1.4em;">
  	          Value: ${maxValueText}<br>
  	          Lat: ${lat.toFixed(5)}<br>
  	          Lon: ${lon.toFixed(5)}<br>
  	          Timestamp: ${new Date(p.__ts ?? p.timestamp).toLocaleString()}
  	          </div>
  	          </div>
  	          `;

  	          closeInfoWindow();
  	          window._warnHubInfo = new google.maps.InfoWindow({
  	            content: html,
  	            position: {
  	              lat, lng: lon
  	            }
  	          });
  	          window._warnHubInfo.open(map);
  	        } else {
  	          console.warn("⚠ No coordinates found for MaxData:", Max);
  	        }
  	      } else {
  	        if (maxKey !== "idle") {
  	          console.warn("⚠ MaxData not found or empty for:", Max);
  	        }
  	      }
  	    } catch (err) {
  	      console.error("🔥 Max jump failed:", err);
  	    }
  	  }

  	  // ----------------------------------------------------------
  	  // Idle trigger integration
  	  // ----------------------------------------------------------
  	  if (typeof Max === "string" && Max.trim().toLowerCase() === "idle") {
  	    try {
  	      const tractorEvents = Tractor?.Events || {};
  	      const idleArr = Array.isArray(tractorEvents["Idle Event"]) ? tractorEvents["Idle Event"]: [];

  	      if (!idleArr.length) {
  	        console.warn("⚠ No Idle Event data found.");
  	      } else {
  	        const longest = idleArr.reduce((a, b) =>
  	          ((a && a.idle_seconds) || 0) > ((b && b.idle_seconds) || 0) ? a: b
  	        );

  	        let lat = +longest.lat || +longest.latitude;
  	        let lon = +longest.lon || +longest.longitude;

  	        if ((!lat || !lon) && Array.isArray(longest.Points) && longest.Points.length) {
  	          const p = longest.Points[0];
  	          lat = +p.lat ?? +p.latitude ?? +p["position.latitude"];
  	          lon = +p.lon ?? +p.longitude ?? +p["position.longitude"];
  	        }

  	        if (Number.isFinite(lat) && Number.isFinite(lon)) {
  	          map.setCenter({
  	            lat, lng: lon
  	          });
  	          map.setZoom(16);

  	          const startStr =
  	          formatAnyTime(longest.start_iso) ||
  	          formatTime(longest.start) ||
  	          formatTime(longest?.Points?.[0]?.timestamp);

  	          const idleStr =
  	          longest.idle_human ||
  	          formatDuration(longest.idle_seconds || 0);

  	          const html = `
  	          <div style="font:14px system-ui,sans-serif;background:#111;border-radius:10px;padding:12px;min-width:260px;color:#fff;">
  	          <div style="font-weight:600;font-size:15px;color:#CC6633;">Longest Idle Segment</div>
  	          <div style="margin-top:6px;line-height:1.4em;">
  	          Start: ${startStr}<br>
  	          Idle: ${idleStr}<br>
  	          Lat: ${lat.toFixed(5)}<br>
  	          Lon: ${lon.toFixed(5)}
  	          </div>
  	          </div>
  	          `;

  	          closeInfoWindow();
  	          window._warnHubInfo = new google.maps.InfoWindow({
  	            content: html,
  	            position: {
  	              lat, lng: lon
  	            }
  	          });
  	          window._warnHubInfo.open(map);
  	        } else {
  	          console.warn("⚠ No valid coordinates found for longest idle segment.");
  	        }
  	      }
  	    } catch (err) {
  	      console.error("🔥 Idle jump failed:", err);
  	    }
  	  }

  	  // ----------------------------------------------------------
  	  // Location popup
  	  // ----------------------------------------------------------
  	  function showLocationPopup(entry) {
  	    const loc = entry.Location || {};
  	    const title = loc.REF || loc.Name || entry.Name || "Location";
  	    const inStr = formatAnyTime(entry.time_in);
  	    const outStr = formatAnyTime(entry.time_out);
  	    const distance = entry.distance_m != null ? `${entry.distance_m.toLocaleString()} m`: "";
  	    const duration = entry.duration_sec != null ? formatDuration(entry.duration_sec): "";
  	    const hasFuelUsed = Object.prototype.hasOwnProperty.call(entry, "fuel_used");
  	    const consumption = Object.prototype.hasOwnProperty.call(entry, "km_per_litre");
  	    const litresHour = Object.prototype.hasOwnProperty.call(entry, "litres_per_hour");

  	    const isFarm = isFarmLocation(entry);
  	    const trailerText = !isFarm ? getTrailerText(entry): "";

  	    const stillIn = isStillInLocation(entry);
  	    const startedThenLeft = isStartedThenLeft(entry);
  	    const enteredThenIn = isEnteredThenIn(entry);
  	    const typeOutNorm = normalizeEventType(entry.type_out);

  	    let timeLine = "";
  	    if (stillIn) {
  	      timeLine = `Time: ${outStr || inStr || "-"}`;
  	    } else if (startedThenLeft) {
  	      timeLine = `Time Out: ${outStr || "-"}`;
  	    } else if (enteredThenIn) {
  	      timeLine = `Time In: ${inStr || "-"}`;
  	    } else if (typeOutNorm === "in location") {
  	      timeLine = `Time In: ${inStr || outStr || "-"}`;
  	    } else {
  	      timeLine = `Time In: ${inStr || "-"}<br>Time Out: ${outStr || "-"}`;
  	    }

  	    let lat = +entry.lat_in || +entry.latitude_in || +entry.lat || +entry.latitude;
  	    let lng = +entry.lon_in || +entry.longitude_in || +entry.lng || +entry.longitude;

  	    if ((!lat || !lng) && Array.isArray(entry.points)) {
  	      const p0 = entry.points[0];
  	      if (p0 && p0.lat != null && p0.lon != null) {
  	        lat = +p0.lat;
  	        lng = +p0.lon;
  	      }
  	    }

  	    if (lat && lng) {
  	      map.setCenter({
  	        lat, lng
  	      });
  	      map.setZoom(16);
  	    }

  	    let html = `
  	    <div style="font:14px system-ui,sans-serif;background:#111;border-radius:10px;padding:12px;min-width:260px;color:#fff;">
  	    <div style="font-weight:600;font-size:15px;color:${themeOrange};">${title}</div>
  	    <div style="margin-top:6px;line-height:1.5em;">
  	    ${timeLine}<br>
  	    ${trailerText ? `Trailers: ${trailerText}<br>`: ""}
  	    ${distance ? `Distance: ${distance}<br>`: ""}
  	    ${duration ? `Duration: ${duration}<br>`: ""}
  	    `;

  	    if (hasFuelUsed) html += `Fuel Used: ${Number(entry.fuel_used).toFixed(3)} L<br>`;
  	    if (consumption) html += `Km/Litre: ${Number(entry.km_per_litre).toFixed(3)}<br>`;
  	    if (litresHour) html += `Litres/Hour: ${Number(entry.litres_per_hour).toFixed(3)}<br>`;

  	    html += `</div></div>`;

  	    closeInfoWindow();
  	    window._warnHubInfo = new google.maps.InfoWindow({
  	      content: html,
  	      position: lat && lng ? {
  	        lat, lng
  	      }: undefined
  	    });
  	    window._warnHubInfo.open(map);
  	  }

  	  // ----------------------------------------------------------const isFarm = isFarmLocation(entry);
  	  // Entry formatter
  	  // ----------------------------------------------------------
  	  function formatEntry(entry, label) {
  	    if (label === "Location Events") {
  	      const loc = entry.Location || {};
  	      const ref = loc.REF || "";
  	      const name = loc.Name || entry.Name || "Location";
  	      const inStr = formatAnyTime(entry.time_in);
  	      const outStr = formatAnyTime(entry.time_out);

  	      const isFarm = isFarmLocation(entry);
  	      const trailerText = !isFarm ? getTrailerText(entry): "";
  	      const trailerLine = trailerText
  	      ? `<div style="margin-top:2px;font-size:12px;color:#ccc;">Trailers: ${trailerText}</div>`: "";
  	      const typeOutNorm = normalizeEventType(entry.type_out);

  	      if (isStillInLocation(entry)) {
  	        const ts = outStr || inStr || "-";
  	        return `
  	        <div style="font-weight:600;color:#fff;">${ref || name}</div>
  	        <div style="color:#fff;">In Location</div>
  	        ${trailerLine}
  	        <div style="margin-top:2px;font-size:12px;color:#ccc;">Time: ${ts}</div>
  	        `;
  	      }

  	      if (isStartedThenLeft(entry)) {
  	        return `
  	        <div style="font-weight:600;color:#fff;">${ref || name}</div>
  	        <div style="color:#fff;">Started In Location → Left Location</div>
  	        ${trailerLine}
  	        <div style="margin-top:2px;font-size:12px;color:#ccc;">OUT: ${outStr || "-"}</div>
  	        `;
  	      }

  	      if (isEnteredThenIn(entry)) {
  	        return `
  	        <div style="font-weight:600;color:#fff;">${ref || name}</div>
  	        <div style="color:#fff;">Entered Location → In Location</div>
  	        ${trailerLine}
  	        <div style="margin-top:2px;font-size:12px;color:#ccc;">IN: ${inStr || "-"}</div>
  	        `;
  	      }

  	      const typeIn = entry.type || "";
  	      const typeOut = entry.type_out || "";

  	      if (typeOutNorm === "in location") {
  	        return `
  	        <div style="font-weight:600;color:#fff;">${ref || name}</div>
  	        <div style="color:#fff;">${typeIn}${typeOut ? " → " + typeOut: ""}</div>
  	        ${trailerLine}
  	        <div style="margin-top:2px;font-size:12px;color:#ccc;">IN: ${inStr || outStr || "-"}</div>
  	        `;
  	      }

  	      return `
  	      <div style="font-weight:600;color:#fff;">${ref || name}</div>
  	      <div style="color:#fff;">${typeIn}${typeOut ? " → " + typeOut: ""}</div>
  	      ${trailerLine}
  	      <div style="margin-top:2px;font-size:12px;color:#ccc;">
  	      IN: ${inStr || "-"}<br>
  	      OUT: ${outStr || "-"}
  	      </div>
  	      `;
  	    }

  	    const lines = [];

  	    if (label === "Idle Event") {
  	      const start =
  	      formatAnyTime(entry.start_iso) ||
  	      formatTime(entry.start) ||
  	      extractStartTime(entry);

  	      if (start) lines.push(`Start: ${start}`);
  	      if (entry.idle_human) lines.push(`Idle: ${entry.idle_human}`);
  	      else if (entry.idle_seconds != null) lines.push(`Idle: ${formatDuration(entry.idle_seconds)}`);

  	      return lines.join("<br>");
  	    }

  	    const start = extractStartTime(entry);
  	    if (start) lines.push(`Start: ${start}`);
  	    if (entry.distance != null) lines.push(`Distance: ${entry.distance.toLocaleString()} m`);
  	    if (entry.duration != null) {
  	      const dur = formatDuration(entry.duration);
  	      if (dur !== "0s") lines.push(`Duration: ${dur}`);
  	    }
  	    if (entry.Max != null) lines.push(`Max: ${entry.Max.toLocaleString()} ${guessUnit(entry.Max, "Max")}`);
  	    if (entry.AVG != null) lines.push(`Avg: ${entry.AVG.toLocaleString()} ${guessUnit(entry.AVG, "AVG")}`);

  	    return lines.join("<br>");
  	  }

  	  // ----------------------------------------------------------
  	  // Section builder
  	  // ----------------------------------------------------------
  	  function createSection(label, entries, autoOpen) {
  	    const section = document.createElement("div");
  	    Object.assign(section.style, {
  	      marginBottom: "10px",
  	      border: "1px solid #444",
  	      borderRadius: "6px",
  	      overflow: "hidden"
  	    });

  	    const head = document.createElement("div");
  	    Object.assign(head.style, {
  	      background: "#333",
  	      padding: "8px 12px",
  	      cursor: "pointer",
  	      fontWeight: "500",
  	      transition: "background 0.2s, color 0.2s"
  	    });
  	    head.innerText = label;

  	    const body = document.createElement("div");
  	    Object.assign(body.style, {
  	      display: autoOpen ? "block": "none",
  	      background: "#222",
  	      padding: "10px",
  	      fontSize: "13px",
  	      lineHeight: "1.5em"
  	    });

  	    if (autoOpen) head.style.background = themeOrangeOpaque;

  	    head.onclick = () => {
  	      const open = body.style.display === "block";
  	      body.style.display = open ? "none": "block";
  	      head.style.background = open ? "#333": themeOrangeOpaque;
  	      kickPositionWatch(20);
  	    };

  	    entries.forEach(e => {
  	      const card = document.createElement("div");
  	      card.innerHTML = formatEntry(e, label);

  	      Object.assign(card.style, {
  	        background: "#2b2b2b",
  	        borderRadius: "6px",
  	        padding: "8px 10px",
  	        marginBottom: "6px",
  	        boxShadow: "0 1px 4px rgba(0,0,0,0.4)",
  	        transition: "background 0.15s, transform 0.15s",
  	        cursor: "pointer"
  	      });

  	      card.onmouseover = () => {
  	        card.style.background = themeOrangeOpaque;
  	        card.style.transform = "translateY(-2px)";
  	      };

  	      card.onmouseout = () => {
  	        card.style.background = "#2b2b2b";
  	        card.style.transform = "translateY(0)";
  	      };

  	      card.onclick = () => {
  	        console.log("🟡 Warning Hub card clicked:", e);

  	        let lat = +e.lat_in || +e.latitude_in || +e.lat || +e.latitude;
  	        let lng = +e.lon_in || +e.longitude_in || +e.lng || +e.longitude;

  	        if ((!lat || !lng) && Array.isArray(e.Points) && e.Points.length) {
  	          const p = e.Points[0];
  	          if (p.lat != null && (p.lon != null || p.lng != null)) {
  	            lat = +p.lat;
  	            lng = +p.lon ?? +p.lng;
  	          }
  	        }

  	        if ((!lat || !lng) && Array.isArray(e.points) && e.points.length) {
  	          const p = e.points[0];
  	          if (p.lat != null && (p.lon != null || p.lng != null)) {
  	            lat = +p.lat;
  	            lng = +p.lon ?? +p.lng;
  	          }
  	        }

  	        if ((!lat || !lng) && e.coordinates && Array.isArray(e.coordinates)) {
  	          lng = +e.coordinates[0];
  	          lat = +e.coordinates[1];
  	        }

  	        if (label === "Location Events") {
  	          showLocationPopup(e);
  	          return;
  	        }

  	        if (lat && lng && map) {
  	          map.setCenter({
  	            lat, lng
  	          });
  	          map.setZoom(16);

  	          const html = `
  	          <div style="font:14px system-ui,sans-serif;background:#111;border-radius:10px;padding:12px;min-width:240px;color:#fff;">
  	          <div style="font-weight:600;font-size:15px;color:${themeOrange};">${label || "Event"}</div>
  	          <div style="margin-top:6px;line-height:1.4em;">${formatEntry(e, label)}</div>
  	          </div>
  	          `;

  	          closeInfoWindow();
  	          window._warnHubInfo = new google.maps.InfoWindow({
  	            content: html,
  	            position: {
  	              lat, lng
  	            }
  	          });
  	          window._warnHubInfo.open(map);
  	        } else {
  	          console.warn("⚠ No coordinates found for event:", e);
  	        }
  	      };

  	      body.appendChild(card);
  	    });

  	    section.appendChild(head);
  	    section.appendChild(body);
  	    return section;
  	  }

  	  // ----------------------------------------------------------
  	  // Build accordion
  	  // ----------------------------------------------------------
  	  const W = Warnings || {};

  	  if (onlyKey === "Location Events") {
  	    const locArr = Array.isArray(W["Location Events"]) ? W["Location Events"]: [];
  	    if (locArr.length) {
  	      container.appendChild(createSection("Location Events", locArr, true));
  	    } else {
  	      const empty = document.createElement("div");
  	      empty.innerText = `⚠ No events found for "Location Events".`;
  	      empty.style.textAlign = "center";
  	      empty.style.padding = "20px";
  	      container.appendChild(empty);
  	    }
  	  } else {
  	    const sortedEntries = Object.entries(W)
  	    .filter(([key, value]) => Array.isArray(value) && value.length && !excluded.includes(key))
  	    .sort(([a], [b]) => a.localeCompare(b, undefined, {
  	      numeric: true,
  	      sensitivity: "base"
  	    }));

  	    for (const [key, value] of sortedEntries) {
  	      if (onlyKey && key !== onlyKey) continue;
  	      container.appendChild(createSection(key, value, onlyKey && key === onlyKey));
  	    }

  	    if (!container.hasChildNodes()) {
  	      const empty = document.createElement("div");
  	      empty.innerText = onlyKey
  	      ? `⚠ No events found for "${onlyKey}".`: "✅ No active warnings with events.";
  	      empty.style.textAlign = "center";
  	      empty.style.padding = "20px";
  	      container.appendChild(empty);
  	    }
  	  }

  	  // ----------------------------------------------------------
  	  // Close / cleanup
  	  // ----------------------------------------------------------
  	  function resizeHandler() {
  	    positionPopup(true);
  	    kickPositionWatch(12);
  	  }

  	  function escHandler(e) {
  	    if (e.key === "Escape" && window._warnHubInfo) {
  	      closeInfoWindow();
  	    }
  	  }

  	  function destroyPopup() {
  	    if (isDestroyed) return;
  	    isDestroyed = true;

  	    try {
  	      if (Button) {
  	        if (typeof Button.setVisible === "function") Button.setVisible(true);
  	        else if ("visible" in Button) Button.visible = true;
  	      }
  	    } catch (e) {}

  	    try {
  	      if (resizeObserver) resizeObserver.disconnect();
  	    } catch (e) {}

  	    try {
  	      if (mutationObserver) mutationObserver.disconnect();
  	    } catch (e) {}

  	    try {
  	      if (rafId) cancelAnimationFrame(rafId);
  	    } catch (e) {}

  	    window.removeEventListener("resize", resizeHandler);
  	    window.removeEventListener("orientationchange", resizeHandler);
  	    window.removeEventListener("keydown", escHandler);

  	    closeInfoWindow();
  	    popup.remove();
  	  }

  	  closeBtn.onclick = destroyPopup;

  	  // ----------------------------------------------------------
  	  // Mount
  	  // ----------------------------------------------------------
  	  header.appendChild(title);
  	  header.appendChild(closeBtn);
  	  popup.appendChild(header);
  	  popup.appendChild(container);
  	  document.body.appendChild(popup);

  	  window.addEventListener("resize", resizeHandler);
  	  window.addEventListener("orientationchange", resizeHandler);
  	  window.addEventListener("keydown", escHandler);

  	  setupLiveAnchoring();
  	  positionPopup(true);
  	  kickPositionWatch(24);
  	})();
  })(Warnings, HUB, Exclusions, Map, Tractor, Button, Only, AppData, Max);

}

})
define('./functions/b0b7ca9c018bcb74c0961fa7d1b9a96e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b0b7ca9c018bcb74c0961fa7d1b9a96e'] = function fn_b0b7ca9c018bcb74c0961fa7d1b9a96e(Leader, Input, Trailer) {
return ([Leader,Input,Trailer].join(''))
}

})
define('./functions/b10683b89d3a8232328807d905aa7ecc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b10683b89d3a8232328807d905aa7ecc'] = async function fn_b10683b89d3a8232328807d905aa7ecc(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/b55a0b2dad43d733ad63285e237240c8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b55a0b2dad43d733ad63285e237240c8'] = async function fn_b55a0b2dad43d733ad63285e237240c8(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropRightWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b6427597f75470ed2afb6096298baa03/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b6427597f75470ed2afb6096298baa03'] = async function fn_b6427597f75470ed2afb6096298baa03(Hub, Locations, AppData, Map) {
  await (async function(Hub, Locations, Map, AppData) {
  	// ============================================================
  	// MODULE: Location Editor
  	// AUTHOR: Raymond + Rog
  	// PURPOSE: Full-featured Google Maps-based location editor for Backendless UI
  	// CREATED: <insert date>
  	// NOTES: Do not modify logic; headers and documentation only
  	// ============================================================

  	(function locationEditor(args) {

  	  // ============================================================
  	  // SECTION: ARGUMENT EXTRACTION + MAP + HUB VALIDATION
  	  // ============================================================
  	  const {
  	    Map: googleMapComponent, Locations, Hub, AppData, Backendless
  	  } = args || {};

  	  const map = googleMapComponent?.map?.map;
  	  if (!map) return console.warn("Map not ready for Editor.");

  	  const hubEl = Hub?.el || Hub;
  	  if (!hubEl) return console.warn("Hub element not found");

  	  const companies =
  	  AppData &&
  	  AppData.User &&
  	  Array.isArray(AppData.User.Companies)
  	  ? AppData.User.Companies: [];

  	  // ============================================================
  	  // SECTION: TYPE + FUEL CONFIGURATION
  	  // ============================================================

  	  const TYPE_GROUPS = [{
  	    label: "Agricultural",
  	    options: ["Farm",
  	      "Field",
  	      "Gate",
  	      "Load/Offload Point"],
  	  },
  	    {
  	      label: "Commercial",
  	      options: ["Depot",
  	        "Service Centre",
  	        "Gate",
  	        "Load/Offload Point"],
  	    },
  	    {
  	      label: "Fuel",
  	      options: ["Fuel Station",
  	        "Fuel Bowser"],
  	    },
  	  ];

  	  const FUEL_TYPES = TYPE_GROUPS.find(g => g.label === "Fuel").options;
  	  const FUEL_GRADES = [
  	    "ULP 95",
  	    "ULP 93",
  	    "Diesel 500ppm",
  	    "Diesel 50ppm",
  	    "Diesel 10ppm",
  	    "Paraffin",
  	  ];

  	  // ------------------------------------------------------------
  	  // FUNCTION: isFuelType(type)
  	  // PURPOSE: Check if a location type belongs to the fuel category
  	  // INPUT: type (string)
  	  // OUTPUT: boolean
  	  // ------------------------------------------------------------
  	  function isFuelType(type) {
  	    return FUEL_TYPES.includes(type);
  	  }

  	  // ============================================================
  	  // SECTION: LOCATION HELPERS (EntrancePoint + Polygon Normalisation)
  	  // ============================================================

  	  // ------------------------------------------------------------
  	  // FUNCTION: getEntranceLatLng(loc)
  	  // PURPOSE: Normalize EntrancePoint into {lat,lng}
  	  // INPUT: loc (object)
  	  // OUTPUT: {lat,lng} or null
  	  // ------------------------------------------------------------
  	  function getEntranceLatLng(loc) {
  	    const ep = loc.EntrancePoint;
  	    if (!ep) return null;

  	    // legacy {x,y}
  	    if (typeof ep.x === "number" && typeof ep.y === "number") {
  	      return {
  	        lat: ep.y,
  	        lng: ep.x
  	      };
  	    }

  	    // GeoJSON Point
  	    if (ep.type === "Point" && Array.isArray(ep.coordinates)) {
  	      return {
  	        lat: Number(ep.coordinates[1]),
  	        lng: Number(ep.coordinates[0])
  	      };
  	    }

  	    return null;
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: setEntranceLatLng(loc, latLng)
  	  // PURPOSE: Assign new EntrancePoint in GeoJSON format
  	  // INPUT: loc (object), latLng ({lat,lng})
  	  // OUTPUT: none (mutates loc)
  	  // ------------------------------------------------------------
  	  function setEntranceLatLng(loc, latLng) {
  	    if (!latLng) {
  	      loc.EntrancePoint = null;
  	      return;
  	    }
  	    loc.EntrancePoint = {
  	      type: "Point",
  	      coordinates: [latLng.lng,
  	        latLng.lat],
  	    };
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: getPolygonLatLngs(loc)
  	  // PURPOSE: Normalize Polygon data from legacy or GeoJSON formats
  	  // INPUT: loc (object)
  	  // OUTPUT: Array<{lat,lng}> or null
  	  // ------------------------------------------------------------
  	  function getPolygonLatLngs(loc) {
  	    const poly = loc.Polygon;
  	    if (!poly) return null;

  	    // legacy boundary.points
  	    if (poly.boundary?.points && Array.isArray(poly.boundary.points)) {
  	      return poly.boundary.points.map(p => ({
  	        lat: Number(p.y),
  	        lng: Number(p.x),
  	      }));
  	    }

  	    // GeoJSON polygon
  	    if (Array.isArray(poly.coordinates) && Array.isArray(poly.coordinates[0])) {
  	      return poly.coordinates[0].map(coord => ({
  	        lat: Number(coord[1]),
  	        lng: Number(coord[0]),
  	      }));
  	    }

  	    return null;
  	  }

  	  // ============================================================
  	  // SECTION: AREA UTILITIES
  	  // PURPOSE: Compute polygon areas and update location metadata
  	  // ============================================================

  	  const AREA_R = 6378137;
  	  const toRad = d => d * Math.PI / 180;
  	  const round2 = n => Math.round(n * 100) / 100;

  	  // [ADDED SECTION] - Geometry helper bridge (Golden Global Rule)
  	  // PURPOSE:
  	  //   • Resolve WizardGeometry safely if present.
  	  //   • Allow future geometry engine to override area calculations
  	  //     without breaking existing legacy behaviour.
  	  //
  	  // CONTRACT:
  	  //   If WizardGeometry.overrideAreaForLocation is defined, it may return:
  	  //     { areaM2: <number> }
  	  //   and we will honour that instead of the legacy computeAreaFromRing().
  	  //
  	  //   This keeps Legacy fully functional today, and lets the new
  	  //   geometry layer plug in cleanly later.
  	  var WizardGeometry = (typeof WizardGeometry !== "undefined" ? WizardGeometry: null);

  	  if (WizardGeometry && typeof WizardGeometry.overrideAreaForLocation === "function") {
  	    console.log("[LocationWizard] (Globals) :: Geometry override available", {
  	      hasOverrideAreaForLocation: true
  	    });
  	  } else {
  	    console.log("[LocationWizard] (Globals) :: Geometry override not attached", {
  	      hasWizardGeometry: !!WizardGeometry
  	    });
  	  }
  	  // [END ADDITION]

  	  // ------------------------------------------------------------
  	  // FUNCTION: computeCentroid(points)
  	  // PURPOSE: Compute centroid of polygon from lat/lng points
  	  // INPUT: Array of {lat,lng} OR google.maps.LatLng
  	  // OUTPUT: {lat,lng} or null
  	  // ------------------------------------------------------------
  	  function computeCentroid(points) {

  	    if (!Array.isArray(points) || points.length === 0) return null;

  	    let sumLat = 0;
  	    let sumLng = 0;
  	    let count = 0;

  	    for (const p of points) {
  	      if (!p) continue;

  	      const lat = typeof p.lat === "function" ? p.lat(): p.lat;
  	      const lng = typeof p.lng === "function" ? p.lng(): p.lng;

  	      if (typeof lat !== "number" || typeof lng !== "number" ||
  	        isNaN(lat) || isNaN(lng)) continue;

  	      sumLat += lat;
  	      sumLng += lng;
  	      count++;
  	    }

  	    if (!count) return null;

  	    return {
  	      lat: sumLat / count,
  	      lng: sumLng / count,
  	    };
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: computeAreaFromRing(ring)
  	  // PURPOSE: Compute polygon area (square meters) using spherical excess
  	  // INPUT: ring (Array of [lng,lat])
  	  // OUTPUT: area (number)
  	  // ------------------------------------------------------------
  	  function computeAreaFromRing(ring) {
  	    if (!ring || ring.length < 4) return 0;
  	    let total = 0;
  	    for (let i = 0; i < ring.length - 1; i++) {
  	      const [lng1,
  	        lat1] = ring[i];
  	      const [lng2,
  	        lat2] = ring[i + 1];

  	      const φ1 = toRad(lat1),
  	      φ2 = toRad(lat2);
  	      const λ1 = toRad(lng1),
  	      λ2 = toRad(lng2);
  	      const dλ = λ2 - λ1;

  	      const t = Math.tan(φ2 / 2 + Math.PI / 4);
  	      const b = Math.tan(φ1 / 2 + Math.PI / 4);

  	      total += Math.atan2(Math.sin(dλ) * b * t, 1 + b * t * Math.cos(dλ));
  	    }
  	    return Math.abs(total * 2 * AREA_R * AREA_R);
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: extractRingFromLoc(loc)
  	  // PURPOSE: Extract ring coordinates [[lng,lat],…] from loc.Polygon
  	  // INPUT: loc (object)
  	  // OUTPUT: Array<[lng,lat]> or null
  	  // ------------------------------------------------------------
  	  function extractRingFromLoc(loc) {
  	    const poly = loc.Polygon;
  	    if (!poly || !Array.isArray(poly.coordinates)) return null;
  	    const ring = poly.coordinates[0]?.map(c => [Number(c[0]), Number(c[1])]);
  	    return ring?.length >= 3 ? ring: null;
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: applyAreaToLocation(loc)
  	  // PURPOSE: Compute and assign Area data (m², hectares, acres + centroid)
  	  // INPUT: loc (object)
  	  // OUTPUT: none (mutates loc.LocationData.Area)
  	  // ------------------------------------------------------------
  	  function applyAreaToLocation(loc) {
  	    const ring = extractRingFromLoc(loc);
  	    if (!ring) return;

  	    // [REPLACED] - area calculation with optional geometry override
  	    // OLD:
  	    // const areaM2 = computeAreaFromRing(ring);
  	    //
  	    // NEW:
  	    //   • Compute legacy area as baseline.
  	    //   • If WizardGeometry.overrideAreaForLocation exists and returns a
  	    //     numeric areaM2, we honour that instead.
  	    let areaM2 = computeAreaFromRing(ring);

  	    if (WizardGeometry && typeof WizardGeometry.overrideAreaForLocation === "function") {
  	      try {
  	        const overrideResult = WizardGeometry.overrideAreaForLocation({
  	          loc,
  	          ring,
  	          legacyAreaM2: areaM2
  	        });

  	        if (overrideResult && typeof overrideResult.areaM2 === "number" && !isNaN(overrideResult.areaM2)) {
  	          console.log("[LocationWizard] (Geometry) :: Area overridden by WizardGeometry", {
  	            legacyAreaM2: areaM2,
  	            overrideAreaM2: overrideResult.areaM2
  	          });
  	          areaM2 = overrideResult.areaM2;
  	        } else {
  	          console.log("[LocationWizard] (Geometry) :: Override skipped - invalid result", {
  	            legacyAreaM2: areaM2
  	          });
  	        }
  	      } catch (err) {
  	        console.log("[LocationWizard] (Error) :: Geometry override failed, using legacy area", {
  	          error: (err && err.message) || String(err)
  	        });
  	      }
  	    }
  	    // [END REPLACED]

  	    // Build lat/lng list for centroid
  	    const centroid = computeCentroid(
  	      ring.map(([lng, lat]) => ({
  	        lat, lng
  	      }))
  	    );

  	    loc.LocationData = loc.LocationData || {};
  	    loc.LocationData.Area = {
  	      m2: round2(areaM2),
  	      Hectares: round2(areaM2 / 10000),
  	      Acres: round2(areaM2 * 0.000247105),
  	    };


  	    if (centroid) {
  	      // Stored for later use (e.g. focus, labels, analytics)
  	      loc.LocationData.Area.Center = centroid;
  	    }
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: setPolygonFromLatLngs(loc, latLngs)
  	  // PURPOSE: Build and assign GeoJSON polygon from array of lat/lng points
  	  // INPUT: loc (object), latLngs (Array<{lat,lng}>)
  	  // OUTPUT: none (mutates loc)
  	  // ------------------------------------------------------------
  	  function setPolygonFromLatLngs(loc, latLngs) {
  	    if (!latLngs || !latLngs.length) {
  	      loc.Polygon = null;
  	      return;
  	    }
  	    const ring = latLngs.map(p => [p.lng, p.lat]);
  	    const first = ring[0];
  	    const last = ring[ring.length - 1];
  	    // close ring if needed
  	    if (first[0] !== last[0] || first[1] !== last[1]) {
  	      ring.push([first[0], first[1]]);
  	    }
  	    loc.Polygon = {
  	      type: "Polygon",
  	      coordinates: [ring]
  	    };
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: syncLocationIntoAppDataCompanies(loc)
  	  // PURPOSE: Sync a changed location object into all matching AppData companies
  	  // INPUT: loc (object)
  	  // OUTPUT: none
  	  // ------------------------------------------------------------
  	  function syncLocationIntoAppDataCompanies(loc) {
  	    if (!loc || !loc.objectId || !companies.length) return;
  	    const oid = loc.objectId;
  	    companies.forEach(co => {
  	      if (!Array.isArray(co.Locations)) return;
  	      const idx = co.Locations.findIndex(l => l && l.objectId === oid);
  	      if (idx >= 0) {
  	        co.Locations[idx] = loc;
  	      }
  	    });
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: addLocationToCompanyInAppData(companyId, loc)
  	  // PURPOSE: Add new location reference to company inside AppData
  	  // INPUT: companyId (string), loc (object)
  	  // OUTPUT: none
  	  // ------------------------------------------------------------
  	  function addLocationToCompanyInAppData(companyId,
  	    loc) {
  	    if (!companies.length || !companyId || !loc) return;
  	    const co = companies.find(c => c && c.objectId === companyId);
  	    if (!co) return;
  	    if (!Array.isArray(co.Locations)) co.Locations = [];
  	    const exists = co.Locations.some(l => l && l.objectId === loc.objectId);
  	    if (!exists) co.Locations.push(loc);
  	  }

  	  // ============================================================
  	  // SECTION: UI RESET — Remove Existing Panels
  	  // PURPOSE: Ensure clean state before new panels are created
  	  // ============================================================
  	  hubEl.querySelector("#locationEditorPanel")?.remove();
  	  hubEl.querySelector("#polygonEditorPanel")?.remove();
  	  hubEl.querySelector("#addLocationWizard")?.remove();

  	  // ============================================================
  	  // SECTION: MAIN LOCATIONS SIDE PANEL
  	  // ============================================================

  	  const panel = document.createElement("div");
  	  panel.id = "locationEditorPanel";
  	  Object.assign(panel.style, {
  	    position: "absolute",
  	    top: "50px",
  	    right: "0",
  	    width: "200px",
  	    bottom: "0",
  	    background: "rgba(20,20,20,0.96)",
  	    color: "#fff",
  	    zIndex: 900,
  	    overflowY: "auto",
  	    borderLeft: "2px solid #CC6633",
  	    boxShadow: "-2px 0 10px rgba(0,0,0,0.4)",
  	    fontFamily: "system-ui, sans-serif",
  	    transition: "transform 0.35s ease, opacity 0.35s ease",
  	    transform: "translateX(100%)",
  	    opacity: "0",
  	  });

  	  hubEl.appendChild(panel);
  	  requestAnimationFrame(() => {
  	    panel.style.transform = "translateX(0)";
  	    panel.style.opacity = "1";
  	  });

  	  // ------------------------------------------------------------
  	  // SUBSECTION: Top Bar (Title + Close Button)
  	  // ------------------------------------------------------------
  	  const topBar = document.createElement("div");
  	  Object.assign(topBar.style, {
  	    display: "flex",
  	    justifyContent: "space-between",
  	    alignItems: "center",
  	    padding: "8px 10px",
  	    borderBottom: "1px solid rgba(204,102,51,0.4)",
  	    background: "rgba(30,30,30,0.9)",
  	    position: "sticky",
  	    top: "0",
  	    zIndex: 10,
  	  });

  	  const title = document.createElement("div");
  	  title.textContent = "Locations";
  	  Object.assign(title.style, {
  	    fontWeight: "600",
  	    color: "#CC6633",
  	    fontSize: "13px",
  	  });

  	  const closeBtn = document.createElement("div");
  	  closeBtn.textContent = "✕";
  	  Object.assign(closeBtn.style, {
  	    cursor: "pointer",
  	    color: "#fff",
  	    fontSize: "14px",
  	    fontWeight: "600",
  	    padding: "2px 6px",
  	    borderRadius: "4px",
  	  });

  	  closeBtn.onmouseenter = () =>
  	  (closeBtn.style.background = "rgba(255,255,255,0.1)");
  	  closeBtn.onmouseleave = () =>
  	  (closeBtn.style.background = "transparent");

  	  // ------------------------------------------------------------
  	  // EVENT: Close Button Click — Close Main Panel
  	  // ------------------------------------------------------------
  	  closeBtn.onclick = () => {

  	    panel.style.transform = "translateX(100%)";
  	    panel.style.opacity = "0";
  	    hubEl.querySelector("#polygonEditorPanel")?.remove();
  	    hubEl.querySelector("#addLocationWizard")?.remove();
  	    setTimeout(() => panel.remove(), 400);
  	  };


  	  // ------------------------------------------------------------
  	  // SUBSECTION: Search + Filter Controls
  	  // ------------------------------------------------------------
  	  const search = document.createElement("input");
  	  Object.assign(search, {
  	    type: "text",
  	    placeholder: "🔍 Search...",
  	  });
  	  Object.assign(search.style, {
  	    width: "100%",
  	    padding: "6px 8px",
  	    borderRadius: "6px",
  	    border: "none",
  	    margin: "8px 0",
  	    fontSize: "13px",
  	    background: "#222",
  	    color: "#fff",
  	    outline: "none",
  	  });
  	  panel.appendChild(search);

  	  // ------------------------------------------------------------
  	  // CONTROL: Secondary Area-Type Filter Dropdown
  	  // ------------------------------------------------------------
  	  const typeFilter = document.createElement("select");
  	  Object.assign(typeFilter.style, {
  	    width: "100%",
  	    padding: "6px 8px",
  	    borderRadius: "6px",
  	    border: "none",
  	    margin: "0 0 8px 0",
  	    fontSize: "13px",
  	    background: "#222",
  	    color: "#fff",
  	    outline: "none",
  	  });

  	  const optAll = document.createElement("option");
  	  optAll.value = "";
  	  optAll.textContent = "Filter by Type (All)";
  	  typeFilter.appendChild(optAll);

  	  TYPE_GROUPS.forEach(g => {
  	    g.options.forEach(o => {
  	      const opt = document.createElement("option");
  	      opt.value = o;
  	      opt.textContent = o;
  	      typeFilter.appendChild(opt);
  	    });
  	  });

  	  // ------------------------------------------------------------
  	  // EVENT: Filter Change — Re-render list and polygons
  	  // ------------------------------------------------------------
  	  typeFilter.onchange = () => {
  	    renderList(search.value);
  	    renderPolygons();
  	    fitMapToLocations(currentFilteredLocations);
  	  };

  	  panel.appendChild(typeFilter);

  	  // ============================================================
  	  // STICKY HEADER CONTAINER (TopBar + Search + Filter + Add Button)
  	  // Keeps title bar, search, filter, and add button fixed on scroll
  	  // ============================================================
  	  const stickyContainer = document.createElement("div");
  	  Object.assign(stickyContainer.style, {
  	    position: "sticky",
  	    top: "0",
  	    zIndex: 50,
  	    background: "rgba(20,20,20,0.96)",
  	    backdropFilter: "blur(4px)",
  	    borderBottom: "1px solid rgba(204,102,51,0.3)",
  	    boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
  	    paddingBottom: "6px",
  	  });

  	  // move top bar, search, and filter inside sticky container
  	  topBar.append(title, closeBtn);
  	  stickyContainer.appendChild(topBar);
  	  stickyContainer.appendChild(search);
  	  stickyContainer.appendChild(typeFilter);
  	  panel.appendChild(stickyContainer);

  	  // ------------------------------------------------------------
  	  // CONTROL: Add Location Button (inside same sticky group)
  	  // ------------------------------------------------------------
  	  const addBtn = document.createElement("button");
  	  addBtn.textContent = "+ Add Location";
  	  Object.assign(addBtn.style, {
  	    width: "calc(100% - 16px)",
  	    margin: "4px 8px 10px",
  	    padding: "6px 0",
  	    border: "1px solid rgba(255,255,255,0.15)",
  	    borderRadius: "6px",
  	    background: "#3a3a3a",
  	    color: "#fff",
  	    fontWeight: "500",
  	    cursor: "pointer",
  	    fontSize: "12px",
  	    transition: "background 0.2s, border-color 0.2s",
  	  });
  	  addBtn.onmouseenter = () => {
  	    addBtn.style.background = "#4a4a4a";
  	    addBtn.style.borderColor = "rgba(255,255,255,0.25)";
  	  };
  	  addBtn.onmouseleave = () => {
  	    addBtn.style.background = "#3a3a3a";
  	    addBtn.style.borderColor = "rgba(255,255,255,0.15)";
  	  };
  	  stickyContainer.appendChild(addBtn);



  	  // ------------------------------------------------------------
  	  // EVENT: Add Location Click — Launch Wizard
  	  // ------------------------------------------------------------
  	  addBtn.onclick = () => {
  	    wizardModeActive = true;
  	    clearPolygons();
  	    disablePolygonHitboxes();
  	    openAddLocationWizard();
  	  };

  	  const list = document.createElement("div");
  	  panel.appendChild(list);

  	  const activePolys = [];

  	  // ============================================================
  	  // SECTION: STATE VARIABLES
  	  // ============================================================
  	  let currentFilteredLocations = Array.isArray(Locations) ? Locations: [];
  	  let editingPolygon = null;
  	  let polygonEditModeActive = false;
  	  let wizardModeActive = false;
  	  let editingPolygonLoc = null;

  	  // ------------------------------------------------------------
  	  // FUNCTION: polygonAreaLatLngs(latLngs)
  	  // PURPOSE: Approximate polygon area (for z-index ordering)
  	  // ------------------------------------------------------------
  	  function polygonAreaLatLngs(latLngs) {
  	    let area = 0;
  	    for (let i = 0, j = latLngs.length - 1; i < latLngs.length; j = i++) {
  	      const xi = latLngs[i].lng,
  	      yi = latLngs[i].lat;
  	      const xj = latLngs[j].lng,
  	      yj = latLngs[j].lat;
  	      area += (xj + xi) * (yj - yi);
  	    }
  	    return Math.abs(area);
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: disablePolygonHitboxes()
  	  // PURPOSE: Disable click interaction on all polygons
  	  // ------------------------------------------------------------
  	  function disablePolygonHitboxes() {
  	    activePolys.forEach(poly => poly.setOptions({
  	      clickable: false
  	    }));
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: enablePolygonHitboxes()
  	  // PURPOSE: Enable click interaction on all polygons
  	  // ------------------------------------------------------------
  	  function enablePolygonHitboxes() {
  	    activePolys.forEach(poly => poly.setOptions({
  	      clickable: true
  	    }));
  	  }

  	  // ------------------------------------------------------------
  	  // FUNCTION: clearPolygons()
  	  // PURPOSE: Remove all active polygons from the map
  	  // ------------------------------------------------------------
  	  function clearPolygons() {
  	    activePolys.forEach(p => p.setMap(null));
  	    activePolys.length = 0;
  	  }


  	  // ============================================================
  	  // SECTION: POLYGON RENDERING
  	  // PURPOSE: Render location polygons with overlap priority logic
  	  // ============================================================
  	  function renderPolygons() {
  	    clearPolygons();

  	    let polyRenderList = editingPolygonLoc
  	    ? [editingPolygonLoc]: (Array.isArray(currentFilteredLocations)
  	      ? currentFilteredLocations: Locations);

  	    let filteredList = polyRenderList.filter(loc => {
  	      if (!wizardModeActive && polygonEditModeActive && loc.__forceHoldHidden === true)
  	        return false;
  	      return loc.__isRemoved !== true;
  	    });

  	    if (wizardModeActive) filteredList = polyRenderList.slice();
  	    if (polygonEditModeActive && editingPolygonLoc && !filteredList.includes(editingPolygonLoc))
  	      filteredList.push(editingPolygonLoc);

  	    filteredList.forEach(loc => {
  	      const pathLatLngs = getPolygonLatLngs(loc);
  	      if (!pathLatLngs || pathLatLngs.length < 3) return;

  	      const storedArea = Math.max(1, Number(loc.LocationData?.Area?.m2 || 1));
  	      const zIndex = 10000000 - storedArea;

  	      const polygon = new google.maps.Polygon({
  	        paths: pathLatLngs,
  	        strokeColor: loc.Color || "#00BCD4",
  	        strokeOpacity: 0.9,
  	        strokeWeight: 2,
  	        fillColor: loc.Color || "#00BCD4",
  	        fillOpacity: 0.25,
  	        map,
  	        clickable: true,
  	        zIndex
  	      });
  	      polygon.__loc = loc;

  	      // ------------------------------------------------------------
  	      // EVENT: Right-Click — Temporarily Remove Polygon
  	      // ------------------------------------------------------------
  	      let rcRemoved = false;
  	      let rcRestoreTimer = null;

  	      function rcRemovePolygon() {
  	        if (rcRemoved) return;
  	        rcRemoved = true;
  	        polygon.__isRemoved = true;
  	        loc.__isRemoved = true;
  	        polygon.setMap(null);
  	        if (!polygonEditModeActive && !wizardModeActive) {
  	          rcRestoreTimer = setTimeout(() => {
  	            rcRestorePolygon();
  	          }, 5000);
  	        }
  	      }

  	      function rcRestorePolygon() {
  	        if (loc.__forceHoldHidden === true) return;
  	        if (polygonEditModeActive || wizardModeActive) return;
  	        if (!rcRemoved) return;
  	        rcRemoved = false;
  	        delete polygon.__isRemoved;
  	        delete loc.__isRemoved;
  	        const storedArea = Math.max(1, Number(loc.LocationData?.Area?.m2 || 1));
  	        polygon.setOptions({
  	          zIndex: 10000000 - storedArea
  	        });
  	        polygon.setMap(map);
  	      }

  	      polygon.addListener("rightclick", (e) => {
  	        if (e?.domEvent) {
  	          e.domEvent.preventDefault();
  	          e.domEvent.stopPropagation();
  	        }
  	        if (!rcRemoved) rcRemovePolygon(); else rcRestorePolygon();
  	      });

  	      // ------------------------------------------------------------
  	      // FIREWALL: Stop Map Interference when Polygon Active
  	      // ------------------------------------------------------------
  	      [
  	        "mousedown", "mousemove", "mouseover", "mouseout",
  	        "touchstart", "touchmove", "pointerdown", "pointermove"
  	      ].forEach(evtName => {
  	          polygon.addListener(evtName, e => {
  	            if (polygon.__isRemoved === true || polygon.getEditable() === true) return;
  	            if (e?.domEvent) {
  	              e.domEvent.stopImmediatePropagation?.();
  	              e.domEvent.stopPropagation?.();
  	            }
  	          });
  	        });

  	      // ------------------------------------------------------------
  	      // EVENT: Hover Effect
  	      // ------------------------------------------------------------
  	      polygon.addListener("mouseover", () => polygon.setOptions({
  	        fillOpacity: 0.45
  	      }));
  	      polygon.addListener("mouseout", () => polygon.setOptions({
  	        fillOpacity: 0.25
  	      }));

  	      // ------------------------------------------------------------
  	      // EVENT: Click — Open Polygon Editor (Overlap Priority)
  	      // ------------------------------------------------------------
  	      polygon.addListener("click", e => {
  	        if (polygon.clickable === false) {
  	          google.maps.event.trigger(map, "click", {
  	            latLng: e.latLng, domEvent: e.domEvent
  	          });
  	          return;
  	        }
  	        const clickLatLng = e.latLng;
  	        let winner = polygon;
  	        activePolys.forEach(p => {
  	          if (p === polygon) return;
  	          const inside = google.maps.geometry.poly.containsLocation(clickLatLng, p);
  	          if (inside && p.zIndex > winner.zIndex) winner = p;
  	        });
  	        openPolygonEditor(winner.__loc);
  	      });

  	      // ------------------------------------------------------------
  	      // DRAWING MODE LISTENER — Event-driven auto-disable (Sacred Law)
  	      // ------------------------------------------------------------
  	      if (!polygon.__drawModeMonitorAttached) {
  	        polygon.__drawModeMonitorAttached = true;

  	        const applyDrawState = isDrawing => {
  	          polygon.setOptions({
  	            clickable: !isDrawing,
  	            fillOpacity: isDrawing ? 0.15: 0.25
  	          });
  	        };

  	        const handler = e => applyDrawState(e.detail.active);

  	        // Listen globally for WizardDrawingModeChange events
  	        window.addEventListener("WizardDrawingModeChange", handler);

  	        // Clean up when polygon removed from map
  	        google.maps.event.addListenerOnce(polygon, "map_changed", () => {
  	          if (!polygon.getMap()) {
  	            window.removeEventListener("WizardDrawingModeChange", handler);
  	          }
  	        });
  	      }

  	      activePolys.push(polygon);


  	      activePolys.push(polygon);
  	    });
  	  }

  	  // ============================================================
  	  // SECTION: POLYGON EDITOR
  	  // PURPOSE: Handles edit mode for polygons on click
  	  // ============================================================
  	  function openPolygonEditor(loc) {
  	    polygonEditModeActive = true;
  	    var lockFields;
  	    Locations.forEach(l => {
  	      if (l.__isRemoved === true) l.__forceHoldHidden = true;
  	    });

  	    const targetPoly = activePolys.find(p => p.__loc === loc);
  	    if (targetPoly) {
  	      activePolys.forEach(p => {
  	        if (p !== targetPoly && !p.__isRemoved && p.__loc.__isRemoved !== true)
  	          p.setMap(null);
  	      });
  	      targetPoly.setEditable(false);
  	      targetPoly.setDraggable(false);
  	      editingPolygon = targetPoly;
  	      editingPolygonLoc = loc;
  	    }

  	    hubEl.querySelector("#polygonEditorPanel")?.remove();

  	    hubEl.querySelector("#polygonEditorPanel")?.remove();

  	    // ============================================================
  	    // SUBSECTION: POLYGON EDITOR UI CONTAINER
  	    // PURPOSE: Side-panel for editing selected polygon/location
  	    // ============================================================
  	    const editor = document.createElement("div");
  	    editor.id = "polygonEditorPanel";
  	    Object.assign(editor.style,
  	      {
  	        position: "absolute",
  	        top: "50px",
  	        right: "200px",
  	        width: "280px",
  	        bottom: "0",
  	        background: "rgba(25,25,25,0.96)",
  	        color: "#fff",
  	        padding: "12px",
  	        zIndex: 1000,
  	        borderLeft: "2px solid #CC6633",
  	        boxShadow: "-2px 0 10px rgba(0,0,0,0.4)",
  	        fontFamily: "system-ui, sans-serif",
  	        transform: "translateX(120%)",
  	        transition: "transform 0.35s ease, opacity 0.35s ease",
  	        opacity: "0",
  	        overflowY: "auto",
  	      });

  	    hubEl.appendChild(editor);
  	    requestAnimationFrame(() => {
  	      editor.style.transform = "translateX(0)";
  	      editor.style.opacity = "1";
  	    });

  	    // ============================================================
  	    // SUBSECTION: HEADER (Edit / Save / Close)
  	    // ============================================================
  	    const header = document.createElement("div");
  	    Object.assign(header.style,
  	      {
  	        display: "flex",
  	        justifyContent: "space-between",
  	        alignItems: "center",
  	        marginBottom: "12px",
  	      });

  	    const headerLeft = document.createElement("div");
  	    Object.assign(headerLeft.style,
  	      {
  	        display: "flex",
  	        alignItems: "center",
  	        gap: "10px",
  	      });

  	    const editIcon = document.createElement("div");
  	    editIcon.textContent = "✎";
  	    Object.assign(editIcon.style,
  	      {
  	        cursor: "pointer",
  	        color: "#fff",
  	        fontSize: "16px",
  	        padding: "2px 6px",
  	      });

  	    const saveIcon = document.createElement("div");
  	    saveIcon.textContent = "🖫";
  	    Object.assign(saveIcon.style,
  	      {
  	        cursor: "pointer",
  	        color: "#00ff99",
  	        fontSize: "16px",
  	        padding: "2px 6px",
  	        display: "none",
  	      });

  	    const closeIcon = document.createElement("div");
  	    closeIcon.textContent = "✕";
  	    Object.assign(closeIcon.style,
  	      {
  	        cursor: "pointer",
  	        color: "#fff",
  	        fontSize: "16px",
  	        padding: "2px 6px",
  	      });

  	    // ------------------------------------------------------------
  	    // EVENT: Close Polygon Editor Panel
  	    // PURPOSE: Exit edit mode, restore polygons, cleanup listeners
  	    // ------------------------------------------------------------
  	    closeIcon.onclick = () => {

  	      polygonEditModeActive = false;

  	      Locations.forEach(l => {
  	        if (l.__isRemoved) delete l.__isRemoved;
  	      });
  	      renderPolygons();

  	      if (editingPolygon) {
  	        if (editingPolygon.__listenerHandles) {
  	          editingPolygon.__listenerHandles.forEach(h => google.maps.event.removeListener(h));
  	          editingPolygon.__listenerHandles = [];
  	        }

  	        editingPolygon.setEditable(false);

  	        if (editingPolygon && editingPolygon.__listenerHandles) {
  	          editingPolygon.__listenerHandles.forEach(h => google.maps.event.removeListener(h));
  	          editingPolygon.__listenerHandles = [];
  	        }

  	        editingPolygon = null;
  	        editingPolygonLoc = null;
  	        renderPolygons();
  	      }

  	      enablePolygonHitboxes();
  	      editor.remove();
  	    };

  	    headerLeft.append(editIcon,
  	      saveIcon);
  	    header.append(headerLeft,
  	      closeIcon);
  	    editor.appendChild(header);

  	    // ============================================================
  	    // DELETE ICON → opens confirm popup
  	    // ============================================================

  	    const deleteIcon = document.createElement("div");
  	    deleteIcon.textContent = "🗑";
  	    Object.assign(deleteIcon.style, {
  	      cursor: "pointer",
  	      color: "#ff6666",
  	      fontSize: "16px",
  	      padding: "2px 6px",
  	    });
  	    deleteIcon.onclick = openDeletePopup;
  	    headerLeft.appendChild(deleteIcon);

  	    // ------------------------------------------------------------
  	    // FUNCTION: openDeletePopup()
  	    // PURPOSE: Show confirmation dialog for location delete
  	    // ------------------------------------------------------------
  	    function openDeletePopup() {
  	      document.querySelector("#deleteConfirmPopup")?.remove();

  	      const popup = document.createElement("div");
  	      popup.id = "deleteConfirmPopup";
  	      Object.assign(popup.style, {
  	        position: "absolute",
  	        top: "120px",
  	        right: "220px",
  	        width: "260px",
  	        background: "#1e1e1e",
  	        border: "1px solid #aa4444",
  	        borderRadius: "8px",
  	        padding: "12px",
  	        zIndex: 2000,
  	        color: "#fff",
  	        boxShadow: "0 4px 14px rgba(0,0,0,0.7)",
  	        fontFamily: "system-ui,sans-serif"
  	      });

  	      popup.innerHTML = `
  	      <div style="font-weight:600;font-size:13px;color:#ff7777;margin-bottom:6px;">
  	      Delete Location
  	      </div>

  	      <div style="font-size:12px;color:#ccc;margin-bottom:10px;line-height:1.4;">
  	      Are you sure you want to permanently delete this location?
  	      </div>
  	      `;

  	      const btnRow = document.createElement("div");
  	      Object.assign(btnRow.style, {
  	        display: "flex",
  	        justifyContent: "space-between",
  	        gap: "6px",
  	      });

  	      const cancelBtn = document.createElement("button");
  	      cancelBtn.textContent = "Cancel";
  	      Object.assign(cancelBtn.style, {
  	        flex: "1",
  	        padding: "6px",
  	        background: "#444",
  	        border: "none",
  	        borderRadius: "5px",
  	        color: "#fff",
  	        cursor: "pointer",
  	      });

  	      cancelBtn.onclick = () => {
  	        enablePolygonHitboxes();
  	        popup.remove();
  	      };

  	      const confirmBtn = document.createElement("button");
  	      confirmBtn.textContent = "Delete";
  	      Object.assign(confirmBtn.style, {
  	        flex: "1",
  	        padding: "6px",
  	        background: "#cc3333",
  	        border: "none",
  	        borderRadius: "5px",
  	        color: "#fff",
  	        cursor: "pointer",
  	        fontWeight: "600",
  	      });

  	      // ------------------------------------------------------------
  	      // EVENT: Confirm Delete — full delete pipeline
  	      // ------------------------------------------------------------
  	      confirmBtn.onclick = async () => {
  	        try {
  	          activePolys.forEach(p => {
  	            if (p.__loc === loc) {
  	              p.setMap(null);
  	            }
  	          });

  	          for (let i = activePolys.length - 1; i >= 0; i--) {
  	            if (activePolys[i].__loc === loc) {
  	              activePolys.splice(i, 1);
  	            }
  	          }

  	          delete loc.__isRemoved;
  	          delete loc.__forceHoldHidden;

  	          polygonEditModeActive = false;

  	          const idx = Locations.findIndex(l => l.objectId === loc.objectId);
  	          if (idx >= 0) Locations.splice(idx, 1);

  	          if (Backendless?.Data?.of && loc.objectId) {
  	            await Backendless.Data.of("Locations").remove(loc);
  	          }

  	          companies.forEach(co => {
  	            if (!Array.isArray(co.Locations)) return;
  	            const ci = co.Locations.findIndex(l => l.objectId === loc.objectId);
  	            if (ci >= 0) co.Locations.splice(ci, 1);
  	          });

  	          popup.remove();
  	          editor.remove();

  	          editingPolygon = null;
  	          editingPolygonLoc = null;
  	          polygonEditModeActive = false;

  	          delete loc.__isRemoved;
  	          delete loc.__forceHoldHidden;

  	          renderList(search.value);
  	          renderPolygons();

  	          alert("Location deleted successfully.");

  	        } catch (err) {
  	          console.warn("Delete failed:",
  	            err);
  	          alert("Delete failed — check console.");
  	        }
  	      };

  	      btnRow.append(cancelBtn,
  	        confirmBtn);
  	      popup.appendChild(btnRow);

  	      hubEl.appendChild(popup);
  	    }

  	    // ============================================================
  	    // SUBSECTION: FIELDS (Name, Type, Color, Contact, Description)
  	    // ============================================================
  	    let dirty = false;
  	    let isLocked = true;

  	    const markDirty = () => {
  	      if (!dirty) {
  	        dirty = true;
  	        if (!isLocked) {
  	          saveIcon.style.display = "block";
  	          editIcon.style.display = "none";
  	        }
  	      }
  	    };

  	    const nameInput = document.createElement("input");
  	    Object.assign(nameInput, {
  	      type: "text",
  	      value: loc.Name || "",
  	    });
  	    Object.assign(nameInput.style, {
  	      width: "100%",
  	      padding: "6px",
  	      background: "#222",
  	      color: "#fff",
  	      border: "none",
  	      borderRadius: "5px",
  	      marginBottom: "8px",
  	    });
  	    nameInput.oninput = () => {
  	      loc.Name = nameInput.value;
  	      markDirty();
  	    };
  	    editor.appendChild(nameInput);

  	    const typeLabel = document.createElement("div");
  	    typeLabel.textContent = "Location Type";
  	    Object.assign(typeLabel.style, {
  	      fontSize: "11px",
  	      margin: "4px 0 2px",
  	      color: "#ddd",
  	    });
  	    editor.appendChild(typeLabel);

  	    const typeSelect = document.createElement("select");
  	    Object.assign(typeSelect.style, {
  	      width: "100%",
  	      padding: "6px",
  	      borderRadius: "5px",
  	      border: "none",
  	      marginBottom: "8px",
  	      background: "#2a2a2a",
  	      color: "#fff",
  	      fontSize: "12px",
  	    });

  	    TYPE_GROUPS.forEach(group => {
  	      const og = document.createElement("optgroup");
  	      og.label = group.label;
  	      group.options.forEach(opt => {
  	        const o = document.createElement("option");
  	        o.value = opt;
  	        o.textContent = opt;
  	        og.appendChild(o);
  	      });
  	      typeSelect.appendChild(og);
  	    });

  	    typeSelect.value = loc.Type || TYPE_GROUPS[0].options[0];
  	    typeSelect.onchange = () => {
  	      loc.Type = typeSelect.value;
  	      markDirty();
  	      renderFuelEditorFields();

  	    };
  	    editor.appendChild(typeSelect);

  	    const colorInput = document.createElement("input");
  	    colorInput.type = "color";
  	    colorInput.value = loc.Color || "#00BCD4";
  	    Object.assign(colorInput.style, {
  	      width: "100%",
  	      height: "32px",
  	      background: "transparent",
  	      border: "none",
  	      marginBottom: "12px",
  	    });
  	    colorInput.oninput = () => {
  	      loc.Color = colorInput.value;
  	      renderPolygons();
  	      markDirty();
  	    };
  	    editor.appendChild(colorInput);

  	    const ld = (loc.LocationData = loc.LocationData || {});

  	    const contactNameInput = document.createElement("input");
  	    contactNameInput.type = "text";
  	    contactNameInput.value = ld.ContactName || "";
  	    contactNameInput.placeholder = "Contact Name";
  	    Object.assign(contactNameInput.style, {
  	      width: "100%",
  	      padding: "6px",
  	      borderRadius: "5px",
  	      border: "none",
  	      marginBottom: "4px",
  	      background: "#2a2a2a",
  	      color: "#fff",
  	    });
  	    contactNameInput.oninput = () => {
  	      ld.ContactName = contactNameInput.value;
  	      markDirty();
  	    };
  	    editor.appendChild(contactNameInput);

  	    const contactNumberInput = document.createElement("input");
  	    contactNumberInput.type = "text";
  	    contactNumberInput.value = ld.ContactNumber || "";
  	    contactNumberInput.placeholder = "Contact Number";
  	    Object.assign(contactNumberInput.style, {
  	      width: "100%",
  	      padding: "6px",
  	      borderRadius: "5px",
  	      border: "none",
  	      marginBottom: "4px",
  	      background: "#2a2a2a",
  	      color: "#fff",
  	    });
  	    contactNumberInput.oninput = () => {
  	      ld.ContactNumber = contactNumberInput.value;
  	      markDirty();
  	    };
  	    editor.appendChild(contactNumberInput);

  	    const descInput = document.createElement("textarea");
  	    descInput.placeholder = "Description";
  	    descInput.value = ld.Description || "";
  	    Object.assign(descInput.style, {
  	      width: "100%",
  	      minHeight: "52px",
  	      padding: "6px",
  	      borderRadius: "5px",
  	      border: "none",
  	      background: "#2a2a2a",
  	      color: "#fff",
  	      resize: "vertical",
  	      marginBottom: "6px",
  	    });
  	    descInput.oninput = () => {
  	      ld.Description = descInput.value;
  	      markDirty();
  	    };
  	    editor.appendChild(descInput);

  	    // ------------------------------------------------------------
  	    // SUBSECTION: Area Live Display (for Farm / Field)
  	    // ------------------------------------------------------------
  	    let areaLiveDisplay = document.createElement("div");
  	    Object.assign(areaLiveDisplay.style, {
  	      margin: "6px 0 10px",
  	      padding: "6px",
  	      background: "#333",
  	      borderRadius: "6px",
  	      fontSize: "12px",
  	      fontWeight: "600",
  	      color: "#00ff99",
  	      display: (loc.Type === "Farm" || loc.Type === "Field") ? "block": "none"
  	    });

  	    if (loc.LocationData?.Area?.Hectares) {
  	      areaLiveDisplay.textContent = `${loc.LocationData.Area.Hectares} ha`;
  	    }

  	    editor.appendChild(areaLiveDisplay);

  	    // ------------------------------------------------------------
  	    // SUBSECTION: Polygon Vertex Movement → Area Recalc Hook
  	    // ------------------------------------------------------------
  	    if (editingPolygon) {
  	      const path = editingPolygon.getPath();
  	      if (!editingPolygon.__listenerHandles) editingPolygon.__listenerHandles = [];

  	      function updateAreaDuringEdit() {
  	        if (!editingPolygon || !editingPolygonLoc) return;
  	        if (!path || path.getLength() === 0) return;

  	        const latLngs = [];
  	        for (let i = 0; i < path.getLength(); i++) {
  	          const p = path.getAt(i);
  	          latLngs.push([p.lng(), p.lat()]);
  	        }
  	        if (latLngs.length >= 3) {
  	          const first = latLngs[0];
  	          const last = latLngs[latLngs.length - 1];
  	          if (first[0] !== last[0] || first[1] !== last[1]) {
  	            latLngs.push([first[0], first[1]]);
  	          }

  	          const areaM2 = computeAreaFromRing(latLngs);

  	          loc.LocationData = loc.LocationData || {};
  	          loc.LocationData.Area = {
  	            m2: round2(areaM2),
  	            Hectares: round2(areaM2 / 10000),
  	            Acres: round2(areaM2 * 0.000247105),
  	          };

  	          if (loc.Type === "Field" || loc.Type === "Farm") {
  	            areaLiveDisplay.textContent =
  	            `${loc.LocationData.Area.Hectares} ha`;
  	          }
  	        }

  	        markDirty();
  	      }

  	      editingPolygon.__listenerHandles.push(
  	        google.maps.event.addListener(path, "set_at", updateAreaDuringEdit)
  	      );
  	      editingPolygon.__listenerHandles.push(
  	        google.maps.event.addListener(path, "insert_at", updateAreaDuringEdit)
  	      );
  	    }

  	    // ============================================================
  	    // SUBSECTION: FUEL EDITOR (Polygon Edit)
  	    // ============================================================
  	    const fuelEditorContainer = document.createElement("div");
  	    editor.appendChild(fuelEditorContainer);

  	    // ------------------------------------------------------------
  	    // FUNCTION: renderFuelEditorFields()
  	    // PURPOSE: Build dynamic fuel grade + price list for fuel locations
  	    // ------------------------------------------------------------
  	    function renderFuelEditorFields() {
  	      fuelEditorContainer.innerHTML = "";

  	      if (!isFuelType(typeSelect.value)) return;

  	      const ld2 = (loc.LocationData = loc.LocationData || {});
  	      if (!Array.isArray(ld2.FuelItems)) ld2.FuelItems = [];

  	      const title = document.createElement("div");
  	      title.textContent = "Fuel Items (Grade + Price)";
  	      Object.assign(title.style, {
  	        fontSize: "11px",
  	        color: "#ffb36b",
  	        margin: "6px 0 4px",
  	      });
  	      fuelEditorContainer.appendChild(title);

  	      const addFuelBtn = document.createElement("button");
  	      addFuelBtn.textContent = "+ Add Fuel Grade";
  	      Object.assign(addFuelBtn.style, {
  	        width: "100%",
  	        padding: "4px",
  	        background: "#444",
  	        border: "none",
  	        borderRadius: "4px",
  	        color: "#fff",
  	        cursor: "pointer",
  	        fontSize: "11px",
  	        marginBottom: "4px",
  	      });
  	      addFuelBtn.disabled = isLocked;
  	      addFuelBtn.onclick = () => {
  	        ld2.FuelItems.push({
  	          Grade: "", Price: null
  	        });
  	        markDirty();
  	        renderFuelEditorFields();
  	      };
  	      fuelEditorContainer.appendChild(addFuelBtn);

  	      ld2.FuelItems.forEach((item, index) => {
  	        const row = document.createElement("div");
  	        Object.assign(row.style, {
  	          display: "flex",
  	          gap: "4px",
  	          alignItems: "center",
  	          marginTop: "4px",
  	        });

  	        const gradeSelect = document.createElement("select");
  	        Object.assign(gradeSelect.style, {
  	          flex: "1.3",
  	          padding: "4px",
  	          borderRadius: "4px",
  	          border: "none",
  	          background: "#2a2a2a",
  	          color: "#fff",
  	          fontSize: "11px",
  	        });

  	        const emptyOpt = document.createElement("option");
  	        emptyOpt.value = "";
  	        emptyOpt.textContent = "Grade…";
  	        gradeSelect.appendChild(emptyOpt);

  	        FUEL_GRADES.forEach(g => {
  	          const o = document.createElement("option");
  	          o.value = g;
  	          o.textContent = g;
  	          gradeSelect.appendChild(o);
  	        });

  	        gradeSelect.value = item.Grade || "";
  	        gradeSelect.disabled = isLocked;
  	        gradeSelect.onchange = () => {
  	          item.Grade = gradeSelect.value;
  	          markDirty();
  	        };

  	        const priceInput = document.createElement("input");
  	        priceInput.type = "number";
  	        priceInput.step = "0.01";
  	        priceInput.placeholder = "Price";
  	        priceInput.value =
  	        item.Price !== null && item.Price !== undefined ? item.Price: "";
  	        Object.assign(priceInput.style, {
  	          flex: "1",
  	          padding: "4px",
  	          borderRadius: "4px",
  	          border: "none",
  	          background: "#2a2a2a",
  	          color: "#fff",
  	          fontSize: "11px",
  	        });
  	        priceInput.disabled = isLocked;
  	        priceInput.oninput = () => {
  	          const v = parseFloat(priceInput.value);
  	          item.Price = isNaN(v) ? null: v;
  	          markDirty();
  	        };

  	        const removeBtn = document.createElement("button");
  	        removeBtn.textContent = "×";
  	        Object.assign(removeBtn.style, {
  	          width: "22px",
  	          height: "22px",
  	          borderRadius: "50%",
  	          border: "none",
  	          background: "#663333",
  	          color: "#fff",
  	          cursor: "pointer",
  	          fontSize: "12px",
  	          lineHeight: "20px",
  	          textAlign: "center",
  	        });
  	        removeBtn.disabled = isLocked;
  	        removeBtn.onclick = () => {
  	          ld2.FuelItems.splice(index, 1);
  	          markDirty();
  	          renderFuelEditorFields();
  	        };

  	        row.append(gradeSelect, priceInput, removeBtn);
  	        fuelEditorContainer.appendChild(row);
  	      });
  	    }

  	    renderFuelEditorFields();

  	    // ============================================================
  	    // SECTION: FARM FIELDS RELATION EDITOR (Drag & Drop + Lock)
  	    // ============================================================
  	    if (loc.Type === "Farm") {
  	      // [REPLACED SECTION]
  	      // PURPOSE:
  	      //   • Show a simple, read-only list of linked Fields.
  	      //   • Provide an always-visible "+ Add Field" button.
  	      //   • Redirect "+ Add Field" to the global Add Location Wizard.
  	      //   • Remove all legacy drag/drop + browse panel behaviour.

  	      const fieldsSection = document.createElement("div");
  	      Object.assign(fieldsSection.style, {
  	        marginTop: "12px",
  	        padding: "10px",
  	        background: "#2a2a2a",
  	        borderRadius: "10px",
  	        boxShadow: "inset 0 0 10px rgba(0,0,0,0.3)"
  	      });

  	      const title = document.createElement("div");
  	      title.textContent = "Linked Fields";
  	      Object.assign(title.style, {
  	        fontSize: "12px",
  	        color: "#ffb36b",
  	        marginBottom: "8px",
  	        fontWeight: "600",
  	      });
  	      fieldsSection.appendChild(title);

  	      // Read-only list container
  	      const fieldsList = document.createElement("div");
  	      Object.assign(fieldsList.style, {
  	        minHeight: "40px",
  	        padding: "6px",
  	        background: "#1f1f1f",
  	        border: "1px solid #555",
  	        borderRadius: "6px",
  	      });
  	      fieldsSection.appendChild(fieldsList);

  	      // Small helper text (no drag/drop anymore)
  	      const hint = document.createElement("div");
  	      hint.textContent = "Existing linked Fields are shown below.";
  	      Object.assign(hint.style, {
  	        color: "#777",
  	        fontSize: "11px",
  	        textAlign: "center",
  	        marginTop: "4px"
  	      });
  	      fieldsSection.appendChild(hint);

  	      // Render current linked fields as read-only rows
  	      const renderLinkedFields = () => {
  	        fieldsList.innerHTML = "";
  	        const currentFields = Array.isArray(loc.Fields) ? loc.Fields: [];

  	        if (!currentFields.length) {
  	          fieldsList.innerHTML =
  	          `<div style="color:#777;font-size:11px;text-align:center;">No fields linked yet. Use "+ Add Field".</div>`;
  	          return;
  	        }

  	        currentFields.forEach(f => {
  	          const row = document.createElement("div");
  	          Object.assign(row.style, {
  	            display: "flex",
  	            justifyContent: "space-between",
  	            alignItems: "center",
  	            background: "#333",
  	            borderRadius: "5px",
  	            padding: "5px 6px",
  	            marginBottom: "4px",
  	            fontSize: "12px",
  	          });

  	          row.innerHTML = `
  	          <div>
  	          ${f.Name || "(Unnamed Field)"}
  	          <span style="color:#888;font-size:11px;">${f.Type || ""}</span>
  	          </div>
  	          `;

  	          fieldsList.appendChild(row);
  	        });
  	      };

  	      renderLinkedFields();

  	      // Always-visible "+ Add Field" button → opens Add Location Wizard
  	      const addFieldBtn = document.createElement("button");
  	      addFieldBtn.textContent = "+ Add Field";
  	      Object.assign(addFieldBtn.style, {
  	        width: "100%",
  	        padding: "6px",
  	        background: "#444",
  	        border: "none",
  	        borderRadius: "5px",
  	        color: "#fff",
  	        cursor: "pointer",
  	        fontSize: "12px",
  	        marginTop: "8px",
  	      });

  	      addFieldBtn.onclick = () => {
  	        console.log("[LocationWizard] (UI) :: Add Field → Add Field Wizard (Farm editor)");
  	        try {
  	          if (typeof openAddFieldWizard === "function") {
  	            openAddFieldWizard(loc);
  	          } else {
  	            alert("Add Field Wizard not loaded.");
  	          }
  	        } catch (err) {
  	          console.log("[LocationWizard] (Error) :: Field Wizard redirect failed", {
  	            err
  	          });
  	        }
  	      };

  	      fieldsSection.appendChild(addFieldBtn);

  	      // Attach the section to the editor
  	      editor.appendChild(fieldsSection);
  	      // [END REPLACED]
  	    }


  	    // ------------------------------------------------------------
  	    // FUNCTION: lockFields(locked)
  	    // PURPOSE: Lock/unlock all editor inputs including fuel fields
  	    // ------------------------------------------------------------
  	    lockFields = function(locked) {
  	      isLocked = locked;

  	      [
  	        nameInput,
  	        typeSelect,
  	        colorInput,
  	        contactNameInput,
  	        contactNumberInput,
  	        descInput,
  	      ].forEach(el => {
  	          el.disabled = locked;
  	        });

  	      [...fuelEditorContainer.querySelectorAll("select,input,button")]
  	      .forEach(el => {
  	        el.disabled = locked;
  	      });
  	    };

  	    lockFields(true);

  	    // ============================================================
  	    // SUBSECTION: Edit / Save Handlers
  	    // ============================================================
  	    editIcon.onclick = () => {
  	      dirty = false;
  	      lockFields(false);

  	      if (editingPolygon) {
  	        editingPolygon.setEditable(true);
  	        editingPolygon.setDraggable(false);
  	      }

  	      saveIcon.style.display = "block";
  	      editIcon.style.display = "none";
  	    };

  	    saveIcon.onclick = async () => {
  	      if (editingPolygon) {
  	        const path = editingPolygon.getPath();
  	        const latLngs = [];

  	        for (let i = 0; i < path.getLength(); i++) {
  	          const p = path.getAt(i);
  	          latLngs.push({
  	            lat: p.lat(), lng: p.lng()
  	          });
  	        }

  	        if (latLngs.length >= 3) {
  	          const ring = latLngs.map(p => [p.lng, p.lat]);
  	          const first = ring[0];
  	          const last = ring[ring.length - 1];
  	          if (first[0] !== last[0] || first[1] !== last[1]) ring.push([first[0], first[1]]);
  	          editingPolygonLoc.Polygon = {
  	            type: "Polygon",
  	            coordinates: [ring]
  	          };
  	        }

  	        if (editingPolygon.__listenerHandles) {
  	          editingPolygon.__listenerHandles.forEach(h => google.maps.event.removeListener(h));
  	          editingPolygon.__listenerHandles = [];
  	        }

  	        Locations.forEach(l => {
  	          if (l.__isRemoved) delete l.__isRemoved;
  	        });

  	        editingPolygon.setEditable(false);
  	        editingPolygon = null;
  	        editingPolygonLoc = null;

  	        renderPolygons();
  	        enablePolygonHitboxes();
  	      }

  	      lockFields(true);
  	      saveIcon.style.display = "none";
  	      editIcon.style.display = "block";
  	      dirty = false;

  	      applyAreaToLocation(loc);

  	      // ------------------------------------------------------------
  	      // Ensure CreationType stays consistent after edit/save
  	      // ------------------------------------------------------------
  	      if (!loc.CreationType) {
  	        // Fallback detection: preserve existing or default to Polygon
  	        if (loc?.Polygon?.coordinates?.length) {
  	          loc.CreationType = "Polygon";
  	        } else {
  	          loc.CreationType = "Polygon";
  	        }
  	      }


  	      // ------------------------------------------------------------
  	      // Persist computed Centre (WGS84) for Backendless
  	      // ------------------------------------------------------------
  	      if (loc.LocationData?.Area?.Center) {
  	        loc.Centre = {
  	          type: "Point",
  	          coordinates: [
  	            loc.LocationData.Area.Center.lng,
  	            loc.LocationData.Area.Center.lat
  	          ],
  	        };
  	      }


  	      try {
  	        const saved = await Backendless.Data.of("Locations").save(loc);
  	        Object.assign(loc,
  	          saved);
  	        renderList(search.value);
  	        renderPolygons();
  	      } catch (e) {
  	        console.warn("Save failed:",
  	          e);
  	        alert("Save failed.");
  	      }
  	    };

  	  } // END FUNCTION: openPolygonEditor

  	  // ============================================================
  	  // FUNCTION: focusLocation(loc)
  	  // PURPOSE: Center the map on a location (entrance or polygon)
  	  // ============================================================
  	  function focusLocation(loc) {
  	    const ep = getEntranceLatLng(loc);
  	    if (ep) {
  	      map.panTo({
  	        lat: ep.lat, lng: ep.lng
  	      });
  	      map.setZoom(17);
  	      return;
  	    }

  	    const poly = getPolygonLatLngs(loc);
  	    if (poly && poly.length) {
  	      const bounds = new google.maps.LatLngBounds();
  	      poly.forEach(p => bounds.extend(p));
  	      map.fitBounds(bounds);
  	    }
  	  }

  	  // ============================================================
  	  // FUNCTION: renderList(filter = "")
  	  // PURPOSE: Render Locations list panel with search + type filter
  	  // ============================================================
  	  function renderList(filter = "") {
  	    list.innerHTML = "";

  	    const q = filter.toLowerCase();
  	    const selectedType = typeFilter ? typeFilter.value: "";

  	    const filtered = (Array.isArray(Locations) ? Locations: []).filter(l => {
  	      const matchText = Object.values(l).some(
  	        v => typeof v === "string" && v.toLowerCase().includes(q)
  	      );

  	      const matchType = !selectedType || l.Type === selectedType;

  	      return matchText && matchType;
  	    });

  	    currentFilteredLocations = filtered;
  	    fitMapToLocations(currentFilteredLocations);

  	    filtered.sort((a, b) => {
  	      const aa = (a.Name || "").toLowerCase();
  	      const bb = (b.Name || "").toLowerCase();
  	      return aa.localeCompare(bb, undefined, {
  	        numeric: true
  	      });
  	    });

  	    filtered.forEach(loc => {

  	      const card = document.createElement("div");
  	      Object.assign(card.style, {
  	        background: "#1b1b1b",
  	        borderRadius: "8px",
  	        padding: "8px",
  	        margin: "0 8px 8px",
  	        fontSize: "12px",
  	        boxShadow: "0 0 4px rgba(0,0,0,0.3)",
  	        cursor: "pointer",
  	      });

  	      const fuelBadge =
  	      loc.LocationData &&
  	      Array.isArray(loc.LocationData.FuelItems) &&
  	      loc.LocationData.FuelItems.length
  	      ? `<span style="background:#335533;padding:1px 4px;border-radius:4px;font-size:10px;margin-left:4px;">Fuel (${loc.LocationData.FuelItems.length})</span>`: "";

  	      card.innerHTML = `
  	      <div style="display:flex;align-items:center;font-weight:600;">
  	      <div style="
  	      width:10px;
  	      height:10px;
  	      border-radius:50%;
  	      background:${loc.Color || "#00BCD4"};
  	      margin-right:6px;
  	      box-shadow:0 0 2px rgba(0,0,0,0.6);
  	      "></div>
  	      ${loc.Name || "Unnamed"} ${fuelBadge}
  	      </div>
  	      <div style="color:#888;font-size:11px;">${loc.Type || ""}</div>
  	      `;

  	      card.onclick = () => focusLocation(loc);

  	      list.appendChild(card);
  	    });

  	    if (!filtered.length) {
  	      list.innerHTML =
  	      `<div style="color:#777;text-align:center;margin-top:20px;">No matches</div>`;
  	    }
  	  }

  	  // ============================================================
  	  // FUNCTION: openAddLocationWizard()
  	  // PURPOSE: Multi-step wizard for creating a new location
  	  // ============================================================
  	  function openAddLocationWizard() {
  	    hubEl.querySelector("#addLocationWizard")?.remove();

  	    const modal = document.createElement("div");
  	    modal.id = "addLocationWizard";
  	    Object.assign(modal.style, {
  	      position: "absolute",
  	      top: "50px",
  	      right: "200px",
  	      width: "280px",
  	      background: "#202020",
  	      color: "#fff",
  	      borderRadius: "10px",
  	      boxShadow: "0 4px 14px rgba(0,0,0,0.55)",
  	      padding: "14px 16px 12px",
  	      fontFamily: "system-ui, sans-serif",
  	      border: "1px solid rgba(204,102,51,0.7)",
  	      zIndex: 901,
  	      pointerEvents: "auto",
  	    });

  	    hubEl.appendChild(modal);

  	    // ------------------------------------------------------------
  	    // SUBSECTION: Wizard Draft State
  	    // ------------------------------------------------------------
  	    let step = 0;
  	    const draft = {
  	      name: "",
  	      type: "Load/Offload Point",
  	      color: "#00ffff",
  	      contactName: "",
  	      contactNumber: "",
  	      description: "",
  	      fuelItems: [],
  	      epLatLng: null,
  	      companyId: companies[0]?.objectId || "",
  	    };

  	    let epMarker = null;
  	    let shapePolygon = null;
  	    let drawing = false;
  	    let mapClickListener = null;

  	    let pivotMode = false;
  	    let pivotCenter = null;

  	    let wedgeMode = false;
  	    let wedgeCenter = null;
  	    let wedgeRadius = null;
  	    let wedgeBaseHeading = null;

  	    function setDraftMode(mode) {
  	      drawing = false;
  	      pivotMode = false;
  	      wedgeMode = false;

  	      pivotCenter = null;
  	      wedgeCenter = null;
  	      wedgeRadius = null;
  	      wedgeBaseHeading = null;

  	      if (pivotCenterMarker) {
  	        pivotCenterMarker.setMap(null); pivotCenterMarker = null;
  	      }
  	      if (wedgeCenterMarker) {
  	        wedgeCenterMarker.setMap(null); wedgeCenterMarker = null;
  	      }

  	      if (shapePolygon) {
  	        shapePolygon.setMap(null);
  	        shapePolygon = null;
  	      }

  	      if (mode === "polygon") drawing = true;
  	      if (mode === "pivot") pivotMode = true;
  	      if (mode === "wedge") wedgeMode = true;
  	    }

  	    let pivotCenterMarker = null;
  	    let wedgeCenterMarker = null;

  	    function resetShape() {
  	      if (shapePolygon) {
  	        shapePolygon.setMap(null);
  	        shapePolygon = null;
  	      }

  	      if (pivotCenterMarker) {
  	        pivotCenterMarker.setMap(null);
  	        pivotCenterMarker = null;
  	      }

  	      if (wedgeCenterMarker) {
  	        wedgeCenterMarker.setMap(null);
  	        wedgeCenterMarker = null;
  	      }

  	      drawing = false;
  	      pivotMode = false;
  	      wedgeMode = false;

  	      pivotCenter = null;
  	      wedgeCenter = null;
  	      wedgeRadius = null;
  	      wedgeBaseHeading = null;
  	    }

  	    // ------------------------------------------------------------
  	    // SUBSECTION: Wizard Header (Reset + Close)
  	    // ------------------------------------------------------------
  	    const header = document.createElement("div");
  	    Object.assign(header.style, {
  	      display: "flex",
  	      justifyContent: "flex-end",
  	      alignItems: "center",
  	      marginBottom: "8px",
  	    });

  	    const resetWizard = document.createElement("div");
  	    resetWizard.textContent = "⟳";
  	    Object.assign(resetWizard.style, {
  	      cursor: "pointer",
  	      color: "#fff",
  	      fontSize: "16px",
  	      padding: "2px 6px",
  	      marginRight: "8px",
  	    });
  	    resetWizard.onclick = () => {
  	      resetShape();
  	      if (step === 2) {
  	        renderStep();
  	      }
  	    };

  	    const closeWizard = document.createElement("div");
  	    closeWizard.textContent = "✕";
  	    Object.assign(closeWizard.style, {
  	      cursor: "pointer",
  	      color: "#fff",
  	      fontSize: "16px",
  	      padding: "2px 6px",
  	    });
  	    closeWizard.onclick = destroyWizard;

  	    header.append(resetWizard, closeWizard);
  	    modal.appendChild(header);

  	    const content = document.createElement("div");
  	    Object.assign(content.style, {
  	      fontSize: "12px",
  	      marginBottom: "10px",
  	    });
  	    modal.appendChild(content);

  	    const footer = document.createElement("div");
  	    Object.assign(footer.style, {
  	      display: "flex",
  	      justifyContent: "space-between",
  	      gap: "6px",
  	    });
  	    modal.appendChild(footer);

  	    function cleanupMapGraphics() {
  	      if (epMarker) {
  	        epMarker.setMap(null);
  	        epMarker = null;
  	      }
  	      if (shapePolygon) {
  	        shapePolygon.setMap(null);
  	        shapePolygon = null;
  	      }
  	      drawing = false;
  	    }

  	    function destroyWizard() {
  	      cleanupMapGraphics();

  	      if (mapClickListener) {
  	        google.maps.event.removeListener(mapClickListener);
  	        mapClickListener = null;
  	      }

  	      wizardModeActive = false;

  	      enablePolygonHitboxes();
  	      renderPolygons();

  	      if (pivotCenterMarker) {
  	        pivotCenterMarker.setMap(null); pivotCenterMarker = null;
  	      }
  	      if (wedgeCenterMarker) {
  	        wedgeCenterMarker.setMap(null); wedgeCenterMarker = null;
  	      }

  	      delete draft.__step2InitComplete;

  	      modal.remove();
  	    }

  	    if (mapClickListener) {
  	      google.maps.event.removeListener(mapClickListener);
  	      mapClickListener = null;
  	    }

  	    // ------------------------------------------------------------
  	    // SUBSECTION: Map Click Listener (Wizard Steps)
  	    // ------------------------------------------------------------
  	    mapClickListener = map.addListener("click", (e) => {
  	      if (e?.domEvent) {
  	        e.domEvent.stopPropagation();
  	        e.domEvent.preventDefault();
  	      }
  	      if (step === 1) {
  	        draft.epLatLng = {
  	          lat: e.latLng.lat(),
  	          lng: e.latLng.lng()
  	        };

  	        if (!epMarker) {
  	          epMarker = new google.maps.Marker({
  	            position: e.latLng,
  	            map,
  	            icon: {
  	              path: google.maps.SymbolPath.CIRCLE,
  	              scale: 7,
  	              fillColor: "#00ffff",
  	              fillOpacity: 1,
  	              strokeColor: "#000",
  	              strokeWeight: 1.5,
  	            },
  	            zIndex: 9999,
  	          });
  	        } else {
  	          epMarker.setPosition(e.latLng);
  	        }

  	        return;
  	      }

  	      if (step === 2) {

  	        // WEDGE MODE
  	        if (wedgeMode) {

  	          if (!wedgeCenter) {
  	            wedgeCenter = {
  	              lat: e.latLng.lat(),
  	              lng: e.latLng.lng()
  	            };

  	            if (shapePolygon) {
  	              shapePolygon.setMap(null);
  	              shapePolygon = null;
  	            }

  	            if (wedgeCenterMarker) wedgeCenterMarker.setMap(null);
  	            wedgeCenterMarker = new google.maps.Marker({
  	              position: wedgeCenter,
  	              map,
  	              icon: {
  	                path: google.maps.SymbolPath.CIRCLE,
  	                scale: 5,
  	                fillColor: draft.color,
  	                fillOpacity: 1,
  	                strokeColor: "#000",
  	                strokeWeight: 1,
  	              },
  	              zIndex: 9999,
  	            });

  	            return;
  	          }

  	          if (!wedgeRadius) {
  	            const center = new google.maps.LatLng(wedgeCenter.lat, wedgeCenter.lng);

  	            wedgeRadius = google.maps.geometry.spherical.computeDistanceBetween(
  	              center,
  	              e.latLng
  	            );

  	            wedgeBaseHeading =
  	            google.maps.geometry.spherical.computeHeading(center, e.latLng);

  	            if (window.__wedgeRadiusMarker) {
  	              window.__wedgeRadiusMarker.setMap(null);
  	            }

  	            window.__wedgeRadiusMarker = new google.maps.Marker({
  	              position: e.latLng,
  	              map,
  	              icon: {
  	                path: google.maps.SymbolPath.CIRCLE,
  	                scale: 4,
  	                fillColor: draft.color,
  	                fillOpacity: 1,
  	                strokeColor: "#000",
  	                strokeWeight: 1,
  	              },
  	              zIndex: 9999,
  	            });

  	            return;
  	          }

  	          const center = new google.maps.LatLng(wedgeCenter.lat, wedgeCenter.lng);

  	          const endHeading =
  	          google.maps.geometry.spherical.computeHeading(center, e.latLng);

  	          let sweep = endHeading - wedgeBaseHeading;
  	          if (sweep < 0) sweep += 360;

  	          const STEPS = 72;
  	          const arc = [];

  	          for (let i = 0; i <= STEPS; i++) {
  	            const h = wedgeBaseHeading + (sweep * (i / STEPS));
  	            arc.push(
  	              google.maps.geometry.spherical.computeOffset(center, wedgeRadius, h)
  	            );
  	          }

  	          if (shapePolygon) shapePolygon.setMap(null);

  	          if (window.__wedgeRadiusMarker) {
  	            window.__wedgeRadiusMarker.setMap(null);
  	            window.__wedgeRadiusMarker = null;
  	          }

  	          shapePolygon = new google.maps.Polygon({
  	            paths: [
  	              new google.maps.LatLng(wedgeCenter.lat, wedgeCenter.lng),
  	              ...arc,
  	              new google.maps.LatLng(wedgeCenter.lat, wedgeCenter.lng)
  	            ],
  	            strokeColor: draft.color,
  	            strokeOpacity: 0.9,
  	            strokeWeight: 2,
  	            fillColor: draft.color,
  	            fillOpacity: 0.25,
  	            map,
  	            editable: true,
  	            zIndex: 500,
  	          });

  	          wedgeCenter = null;
  	          wedgeRadius = null;
  	          wedgeBaseHeading = null;

  	          return;

  	        }

  	        // PIVOT MODE
  	        if (pivotMode) {

  	          if (!pivotCenter) {
  	            pivotCenter = {
  	              lat: e.latLng.lat(),
  	              lng: e.latLng.lng()
  	            };

  	            if (shapePolygon) {
  	              shapePolygon.setMap(null);
  	              shapePolygon = null;
  	            }

  	            if (pivotCenterMarker) pivotCenterMarker.setMap(null);
  	            pivotCenterMarker = new google.maps.Marker({
  	              position: pivotCenter,
  	              map,
  	              icon: {
  	                path: google.maps.SymbolPath.CIRCLE,
  	                scale: 5,
  	                fillColor: draft.color,
  	                fillOpacity: 1,
  	                strokeColor: "#000",
  	                strokeWeight: 1,
  	              },
  	              zIndex: 9999,
  	            });

  	            return;
  	          }

  	          const centerLatLng = new google.maps.LatLng(
  	            pivotCenter.lat,
  	            pivotCenter.lng
  	          );

  	          const radiusMeters =
  	          google.maps.geometry.spherical.computeDistanceBetween(
  	            centerLatLng,
  	            e.latLng
  	          );

  	          const CIRCLE_POINTS = 72;
  	          const pts = [];

  	          for (let i = 0; i < CIRCLE_POINTS; i++) {
  	            const heading = (i / CIRCLE_POINTS) * 360;
  	            pts.push(
  	              google.maps.geometry.spherical.computeOffset(
  	                centerLatLng,
  	                radiusMeters,
  	                heading
  	              )
  	            );
  	          }

  	          if (pts.length) pts.push(pts[0]);

  	          if (shapePolygon) shapePolygon.setMap(null);

  	          shapePolygon = new google.maps.Polygon({
  	            paths: pts,
  	            strokeColor: draft.color,
  	            strokeOpacity: 0.9,
  	            strokeWeight: 2,
  	            fillColor: draft.color,
  	            fillOpacity: 0.25,
  	            map,
  	            editable: true,
  	            zIndex: 500,
  	          });

  	          return;
  	        }

  	        // POINT MODE
  	        if (drawing && !pivotMode) {

  	          if (!shapePolygon) {
  	            shapePolygon = new google.maps.Polygon({
  	              paths: [e.latLng],
  	              strokeColor: draft.color,
  	              strokeOpacity: 0.9,
  	              strokeWeight: 2,
  	              fillColor: draft.color,
  	              fillOpacity: 0.25,
  	              map,
  	              editable: true,
  	              zIndex: 500,
  	            });
  	          } else {
  	            shapePolygon.getPath().push(e.latLng);
  	          }

  	          return;
  	        }

  	      }

  	    });

  	    // ============================================================
  	    // SUBSECTION: renderStep()
  	    // PURPOSE: Render wizard step UI based on `step`
  	    // ============================================================
  	    function renderStep() {
  	      content.innerHTML = "";
  	      footer.innerHTML = "";

  	      // STEP 0 — Basic Info
  	      if (step === 0) {
  	        const nameLabel = document.createElement("div");
  	        nameLabel.textContent = "Location Name";
  	        nameLabel.style.marginBottom = "2px";
  	        content.appendChild(nameLabel);

  	        const nameInput = document.createElement("input");
  	        Object.assign(nameInput, {
  	          type: "text",
  	          value: draft.name,
  	          placeholder: "Misty Vale",
  	        });
  	        Object.assign(nameInput.style, {
  	          width: "100%",
  	          padding: "6px",
  	          borderRadius: "5px",
  	          border: "none",
  	          marginBottom: "6px",
  	          background: "#2a2a2a",
  	          color: "#fff",
  	        });
  	        nameInput.oninput = () => (draft.name = nameInput.value);
  	        content.appendChild(nameInput);

  	        const typeLabel = document.createElement("div");
  	        typeLabel.textContent = "Location Type";
  	        typeLabel.style.marginBottom = "2px";
  	        typeLabel.style.fontSize = "11px";
  	        content.appendChild(typeLabel);

  	        const typeSelect = document.createElement("select");
  	        Object.assign(typeSelect.style, {
  	          width: "100%",
  	          padding: "6px",
  	          borderRadius: "5px",
  	          border: "none",
  	          marginBottom: "6px",
  	          background: "#2a2a2a",
  	          color: "#fff",
  	          fontSize: "12px",
  	        });

  	        TYPE_GROUPS.forEach(group => {
  	          const og = document.createElement("optgroup");
  	          og.label = group.label;
  	          group.options.forEach(opt => {
  	            const o = document.createElement("option");
  	            o.value = opt;
  	            o.textContent = opt;
  	            og.appendChild(o);
  	          });
  	          typeSelect.appendChild(og);
  	        });

  	        typeSelect.value = draft.type;
  	        typeSelect.onchange = () => {
  	          draft.type = typeSelect.value;
  	          if (!isFuelType(draft.type)) draft.fuelItems = [];
  	          renderStep();
  	        };
  	        content.appendChild(typeSelect);

  	        const companyLabel = document.createElement("div");
  	        companyLabel.textContent = "Company";
  	        companyLabel.style.fontSize = "11px";
  	        content.appendChild(companyLabel);

  	        if (companies.length) {
  	          const companySelect = document.createElement("select");
  	          Object.assign(companySelect.style, {
  	            width: "100%",
  	            padding: "6px",
  	            borderRadius: "5px",
  	            border: "none",
  	            marginBottom: "6px",
  	            background: "#2a2a2a",
  	            color: "#fff",
  	            fontSize: "12px",
  	          });

  	          companies.forEach(co => {
  	            const o = document.createElement("option");
  	            o.value = co.objectId;
  	            o.textContent = co.Name || co.ID || co.objectId;
  	            companySelect.appendChild(o);
  	          });

  	          companySelect.value = draft.companyId;
  	          companySelect.onchange = () => {
  	            draft.companyId = companySelect.value;
  	          };

  	          content.appendChild(companySelect);
  	        } else {
  	          const noCo = document.createElement("div");
  	          noCo.textContent = "No companies found";
  	          noCo.style.fontSize = "11px";
  	          noCo.style.color = "#ffb36b";
  	          content.appendChild(noCo);
  	        }

  	        const colorLabel = document.createElement("div");
  	        colorLabel.textContent = "Color";
  	        content.appendChild(colorLabel);

  	        const colorInput = document.createElement("input");
  	        colorInput.type = "color";
  	        colorInput.value = draft.color;
  	        Object.assign(colorInput.style, {
  	          width: "100%",
  	          height: "30px",
  	          border: "none",
  	          background: "transparent",
  	          marginBottom: "8px",
  	        });
  	        colorInput.oninput = () => (draft.color = colorInput.value);
  	        content.appendChild(colorInput);

  	        const ldTitle = document.createElement("div");
  	        ldTitle.textContent = "LocationData (Contact)";
  	        Object.assign(ldTitle.style, {
  	          fontSize: "11px",
  	          color: "#ffb36b",
  	          marginBottom: "4px",
  	        });
  	        content.appendChild(ldTitle);

  	        const contactName = document.createElement("input");
  	        Object.assign(contactName, {
  	          type: "text",
  	          value: draft.contactName,
  	          placeholder: "Contact Name",
  	        });
  	        Object.assign(contactName.style, {
  	          width: "100%",
  	          padding: "6px",
  	          borderRadius: "5px",
  	          border: "none",
  	          marginBottom: "4px",
  	          background: "#2a2a2a",
  	          color: "#fff",
  	        });
  	        contactName.oninput = () =>
  	        (draft.contactName = contactName.value);
  	        content.appendChild(contactName);

  	        const contactNumber = document.createElement("input");
  	        Object.assign(contactNumber, {
  	          type: "text",
  	          value: draft.contactNumber,
  	          placeholder: "Contact Number",
  	        });
  	        Object.assign(contactNumber.style, {
  	          width: "100%",
  	          padding: "6px",
  	          borderRadius: "5px",
  	          border: "none",
  	          marginBottom: "4px",
  	          background: "#2a2a2a",
  	          color: "#fff",
  	        });
  	        contactNumber.oninput = () =>
  	        (draft.contactNumber = contactNumber.value);
  	        content.appendChild(contactNumber);

  	        const desc = document.createElement("textarea");
  	        desc.placeholder = "Description";
  	        desc.value = draft.description;
  	        Object.assign(desc.style, {
  	          width: "100%",
  	          minHeight: "52px",
  	          padding: "6px",
  	          borderRadius: "5px",
  	          border: "none",
  	          background: "#2a2a2a",
  	          color: "#fff",
  	          resize: "vertical",
  	          marginTop: "2px",
  	        });
  	        desc.oninput = () => (draft.description = desc.value);
  	        content.appendChild(desc);

  	        const fuelContainer = document.createElement("div");
  	        content.appendChild(fuelContainer);

  	        function renderFuelFields() {
  	          fuelContainer.innerHTML = "";
  	          if (!isFuelType(draft.type)) return;

  	          const fuelTitle = document.createElement("div");
  	          fuelTitle.textContent = "Fuel Items (Grade + Price)";
  	          Object.assign(fuelTitle.style, {
  	            fontSize: "11px",
  	            color: "#ffb36b",
  	            margin: "6px 0 4px",
  	          });
  	          fuelContainer.appendChild(fuelTitle);

  	          const addBtn = document.createElement("button");
  	          addBtn.textContent = "+ Add Fuel Grade";
  	          Object.assign(addBtn.style, {
  	            width: "100%",
  	            padding: "4px",
  	            background: "#444",
  	            border: "none",
  	            borderRadius: "4px",
  	            color: "#fff",
  	            cursor: "pointer",
  	            fontSize: "11px",
  	            marginBottom: "4px",
  	          });
  	          addBtn.onclick = () => {
  	            draft.fuelItems.push({
  	              Grade: "", Price: ""
  	            });
  	            renderFuelFields();
  	          };
  	          fuelContainer.appendChild(addBtn);

  	          draft.fuelItems.forEach((item, index) => {
  	            const row = document.createElement("div");
  	            Object.assign(row.style, {
  	              display: "flex",
  	              gap: "4px",
  	              alignItems: "center",
  	              marginTop: "4px",
  	            });

  	            const gradeSelect = document.createElement("select");
  	            Object.assign(gradeSelect.style, {
  	              flex: "1.3",
  	              padding: "4px",
  	              borderRadius: "4px",
  	              border: "none",
  	              background: "#2a2a2a",
  	              color: "#fff",
  	              fontSize: "11px",
  	            });

  	            const emptyOpt = document.createElement("option");
  	            emptyOpt.value = "";
  	            emptyOpt.textContent = "Grade…";
  	            gradeSelect.appendChild(emptyOpt);

  	            FUEL_GRADES.forEach(g => {
  	              const o = document.createElement("option");
  	              o.value = g;
  	              o.textContent = g;
  	              gradeSelect.appendChild(o);
  	            });

  	            gradeSelect.value = item.Grade || "";
  	            gradeSelect.onchange = () => {
  	              item.Grade = gradeSelect.value;
  	            };

  	            const priceInput = document.createElement("input");
  	            priceInput.type = "number";
  	            priceInput.step = "0.01";
  	            priceInput.placeholder = "Price";
  	            priceInput.value = item.Price || "";
  	            Object.assign(priceInput.style, {
  	              flex: "1",
  	              padding: "4px",
  	              borderRadius: "4px",
  	              border: "none",
  	              background: "#2a2a2a",
  	              color: "#fff",
  	              fontSize: "11px",
  	            });
  	            priceInput.oninput = () => {
  	              item.Price = priceInput.value;
  	            };

  	            const removeBtn = document.createElement("button");
  	            removeBtn.textContent = "×";
  	            Object.assign(removeBtn.style, {
  	              width: "22px",
  	              height: "22px",
  	              borderRadius: "50%",
  	              border: "none",
  	              background: "#663333",
  	              color: "#fff",
  	              cursor: "pointer",
  	              fontSize: "12px",
  	              lineHeight: "20px",
  	              textAlign: "center",
  	            });
  	            removeBtn.onclick = () => {
  	              draft.fuelItems.splice(index, 1);
  	              renderFuelFields();
  	            };

  	            row.append(gradeSelect, priceInput, removeBtn);
  	            fuelContainer.appendChild(row);
  	          });
  	        }

  	        renderFuelFields();

  	        const cancelBtn = document.createElement("button");
  	        cancelBtn.textContent = "Cancel";
  	        Object.assign(cancelBtn.style, {
  	          flex: "1",
  	          padding: "6px",
  	          background: "#444",
  	          border: "none",
  	          borderRadius: "5px",
  	          color: "#fff",
  	          cursor: "pointer",
  	        });
  	        cancelBtn.onclick = destroyWizard;

  	        const nextBtn = document.createElement("button");
  	        nextBtn.textContent = "Next ▸";
  	        Object.assign(nextBtn.style, {
  	          flex: "1",
  	          padding: "6px",
  	          background: "#2196F3",
  	          border: "none",
  	          borderRadius: "5px",
  	          color: "#fff",
  	          cursor: "pointer",
  	          fontWeight: "600",
  	        });
  	        nextBtn.onclick = () => {
  	          if (!draft.name.trim()) {
  	            alert("Please enter a Location Name.");
  	            return;
  	          }
  	          if (!draft.companyId && companies.length) {
  	            alert("Please select a Company.");
  	            return;
  	          }
  	          step = 1;
  	          renderStep();
  	        };

  	        footer.append(cancelBtn, nextBtn);
  	      }

  	      // STEP 1 — Entrance Point
  	      else if (step === 1) {
  	        const info = document.createElement("div");
  	        info.innerHTML = "Click on the map to place the entrance point (location dot).";
  	        Object.assign(info.style, {
  	          marginBottom: "8px",
  	          fontSize: "12px",
  	          color: "#ddd",
  	        });
  	        content.appendChild(info);

  	        const coords = document.createElement("div");
  	        coords.style.fontSize = "11px";
  	        coords.style.color = "#aaa";
  	        coords.textContent = draft.epLatLng
  	        ? `Current: ${draft.epLatLng.lat.toFixed(6)}, ${draft.epLatLng.lng.toFixed(6)}`: "No entrance point set yet.";
  	        content.appendChild(coords);

  	        const backBtn = document.createElement("button");
  	        backBtn.textContent = "◂ Back";
  	        Object.assign(backBtn.style, {
  	          flex: "1",
  	          padding: "6px",
  	          background: "#444",
  	          border: "none",
  	          borderRadius: "5px",
  	          color: "#fff",
  	          cursor: "pointer",
  	        });
  	        backBtn.onclick = () => {
  	          step = 0;
  	          renderStep();
  	        };

  	        const nextBtn = document.createElement("button");
  	        nextBtn.textContent = "Next ▸";
  	        Object.assign(nextBtn.style, {
  	          flex: "1",
  	          padding: "6px",
  	          background: "#2196F3",
  	          border: "none",
  	          borderRadius: "5px",
  	          color: "#fff",
  	          cursor: "pointer",
  	          fontWeight: "600",
  	        });
  	        nextBtn.onclick = () => {
  	          if (!draft.epLatLng) {
  	            alert("Please click on the map to set an entrance point.");
  	            return;
  	          }
  	          step = 2;
  	          renderStep();
  	        };

  	        footer.append(backBtn, nextBtn);
  	      }

  	      // STEP 2 — Polygon Editor & Create
  	      else if (step === 2) {

  	        if (!draft.__step2InitComplete) {
  	          drawing = true;
  	          pivotMode = false;
  	          pivotCenter = null;
  	          wedgeMode = false;
  	          wedgeCenter = null;
  	          wedgeRadius = null;
  	          wedgeBaseHeading = null;

  	          if (shapePolygon) {
  	            shapePolygon.setMap(null);
  	            shapePolygon = null;
  	          }

  	          draft.__step2InitComplete = true;
  	        }

  	        const info = document.createElement("div");
  	        info.innerHTML =
  	        draft.type === "Field"
  	        ? "Use <b>Polygon Mode</b> to click polygon vertices, <b>Pivot Mode</b> for a circle (centre → radius), or <b>Wedge Mode</b> for a radial field wedge. When done, click <b>Create Location</b>.": "With <b>Polygon Mode</b> ON, click on the map to add polygon points. When done, click <b>Create Location</b>.";

  	        Object.assign(info.style, {
  	          marginBottom: "8px",
  	          fontSize: "12px",
  	          color: "#ddd",
  	        });
  	        content.appendChild(info);

  	        if (draft.type !== "Field" && pivotMode) {
  	          pivotMode = false;
  	          pivotCenter = null;
  	        }

  	        const wedgeToggle = document.createElement("button");
  	        wedgeToggle.textContent = wedgeMode ? "Wedge Mode (ON)": "Wedge Mode (OFF)";
  	        Object.assign(wedgeToggle.style, {
  	          width: "100%",
  	          padding: "6px",
  	          background: wedgeMode ? "#8844AA": "#555",
  	          border: "none",
  	          borderRadius: "5px",
  	          color: "#fff",
  	          cursor: "pointer",
  	          marginBottom: "6px",
  	          fontWeight: "600",
  	        });

  	        wedgeToggle.onclick = () => {
  	          const newState = !wedgeMode;
  	          setDraftMode(newState ? "wedge": null);
  	          renderStep();
  	        };

  	        if (draft.type === "Field") {
  	          content.appendChild(wedgeToggle);
  	        }

  	        if (draft.type === "Field") {
  	          const pivotToggle = document.createElement("button");
  	          pivotToggle.textContent = pivotMode ? "Pivot Mode (ON)": "Pivot Mode (OFF)";
  	          Object.assign(pivotToggle.style, {
  	            width: "100%",
  	            padding: "6px",
  	            background: pivotMode ? "#AA5500": "#555",
  	            border: "none",
  	            borderRadius: "5px",
  	            color: "#fff",
  	            cursor: "pointer",
  	            marginBottom: "6px",
  	            fontWeight: "600",
  	          });

  	          pivotToggle.onclick = () => {
  	            const newState = !pivotMode;
  	            setDraftMode(newState ? "pivot": null);
  	            renderStep();
  	          };

  	          content.appendChild(pivotToggle);
  	        }

  	        const polygonBtn = document.createElement("button");

  	        const setPolygonBtnState = () => {
  	          polygonBtn.textContent = drawing
  	          ? "Polygon Mode (ON)": "Polygon Mode (OFF)";
  	          polygonBtn.style.background = drawing ? "#00A65A": "#555";
  	        };

  	        Object.assign(polygonBtn.style, {
  	          width: "100%",
  	          padding: "6px",
  	          background: "#555",
  	          border: "none",
  	          borderRadius: "5px",
  	          color: "#fff",
  	          cursor: "pointer",
  	          marginBottom: "6px",
  	          fontWeight: "600",
  	        });

  	        setPolygonBtnState();

  	        polygonBtn.onclick = () => {
  	          if (pivotMode) {
  	            alert(
  	              "Polygon Mode is only for Point Mode.\n" +
  	              "In Pivot Mode: click centre, then click radius."
  	            );
  	            return;
  	          }

  	          if (wedgeMode) {
  	            alert(
  	              "Polygon Mode is only for Point Mode.\n" +
  	              "In Wedge Mode: click centre, then click radius, then click wedge end."
  	            );
  	            return;
  	          }

  	          const newState = !drawing;
  	          setDraftMode(newState ? "polygon": null);
  	          setPolygonBtnState();
  	        };

  	        content.appendChild(polygonBtn);

  	        const backBtn = document.createElement("button");
  	        backBtn.textContent = "◂ Back";
  	        Object.assign(backBtn.style, {
  	          flex: "1",
  	          padding: "6px",
  	          background: "#444",
  	          border: "none",
  	          borderRadius: "5px",
  	          color: "#fff",
  	          cursor: "pointer",
  	        });
  	        backBtn.onclick = () => {
  	          delete draft.__step2InitComplete;
  	          step = 1;
  	          renderStep();
  	        };

  	        const createBtn = document.createElement("button");
  	        createBtn.textContent = "✔ Create Location";
  	        Object.assign(createBtn.style, {
  	          flex: "1",
  	          padding: "6px",
  	          background: "#00A65A",
  	          border: "none",
  	          borderRadius: "5px",
  	          color: "#fff",
  	          cursor: "pointer",
  	          fontWeight: "600",
  	        });

  	        createBtn.onclick = async () => {
  	          if (!draft.epLatLng) {
  	            alert("Entrance point missing.");
  	            return;
  	          }
  	          if (!shapePolygon || shapePolygon.getPath().getLength() < 3) {
  	            alert("Polygon must have at least 3 points.");
  	            return;
  	          }

  	          const path = shapePolygon.getPath();
  	          const ring = [];
  	          for (let i = 0; i < path.getLength(); i++) {
  	            const p = path.getAt(i);
  	            ring.push([p.lng(), p.lat()]);
  	          }

  	          if (ring.length > 0) {
  	            const first = ring[0];
  	            const last = ring[ring.length - 1];
  	            if (first[0] !== last[0] || first[1] !== last[1]) {
  	              ring.push([first[0], first[1]]);
  	            }
  	          }

  	          const now = Date.now();

  	          const locationData = {
  	            ContactName: draft.contactName,
  	            ContactNumber: draft.contactNumber,
  	            Description: draft.description,
  	          };

  	          if (isFuelType(draft.type) && draft.fuelItems.length) {
  	            const items = draft.fuelItems
  	            .map(i => {
  	              const validPrice = parseFloat(i.Price);
  	              return {
  	                Grade: i.Grade || "",
  	                Price: isNaN(validPrice) ? null: validPrice,
  	              };
  	            })
  	            .filter(i => i.Grade || i.Price !== null);

  	            if (items.length) locationData.FuelItems = items;
  	          }

  	          const newLoc = {
  	            created: now,
  	            updated: now,
  	            Color: draft.color,
  	            Name: draft.name,
  	            Type: draft.type,
  	            LocationData: locationData,
  	            EntrancePoint: {
  	              type: "Point",
  	              coordinates: [draft.epLatLng.lng,
  	                draft.epLatLng.lat],
  	            },
  	            Polygon: {
  	              type: "Polygon",
  	              coordinates: [ring],
  	            },
  	            ___class: "Locations",
  	          };

  	          applyAreaToLocation(newLoc);

  	          // ------------------------------------------------------------
  	          // Persist computed Centre (WGS84) for Backendless
  	          // ------------------------------------------------------------
  	          if (newLoc.LocationData?.Area?.Center) {
  	            newLoc.Centre = {
  	              type: "Point",
  	              coordinates: [
  	                newLoc.LocationData.Area.Center.lng,
  	                newLoc.LocationData.Area.Center.lat,
  	              ],
  	            };
  	          }

  	          // ------------------------------------------------------------
  	          // Assign CreationType based on drawing mode used
  	          // ------------------------------------------------------------
  	          if (wedgeMode) {
  	            newLoc.CreationType = "Wedge";
  	          } else if (pivotMode) {
  	            newLoc.CreationType = "Pivot";
  	          } else {
  	            newLoc.CreationType = "Polygon";
  	          }


  	          Locations.push(newLoc);

  	          try {
  	            if (Backendless?.Data?.of) {
  	              const saved = await Backendless.Data.of("Locations").save(newLoc);
  	              if (saved) Object.assign(newLoc, saved);

  	              if (draft.companyId) {
  	                try {
  	                  await Backendless.Data.of("Companies").addRelation(
  	                    draft.companyId,
  	                    "Locations",
  	                    [newLoc.objectId]
  	                  );
  	                } catch (re) {
  	                  console.warn("Relation error:", re);
  	                }
  	              }
  	            }

  	            if (draft.companyId) {
  	              addLocationToCompanyInAppData(draft.companyId, newLoc);
  	            }

  	            renderList(search.value);
  	            renderPolygons();
  	            map.panTo({
  	              lat: draft.epLatLng.lat, lng: draft.epLatLng.lng
  	            });
  	            map.setZoom(17);

  	            if (pivotCenterMarker) {
  	              pivotCenterMarker.setMap(null); pivotCenterMarker = null;
  	            }
  	            if (wedgeCenterMarker) {
  	              wedgeCenterMarker.setMap(null); wedgeCenterMarker = null;
  	            }

  	            destroyWizard();

  	          } catch (e) {
  	            console.warn("Create Location failed:", e);
  	            alert("Create Location failed — see console.");
  	          }
  	        };

  	        footer.append(backBtn, createBtn);
  	      }

  	    }

  	    renderStep();
  	  }

  	  // ============================================================
  	  // FUNCTION: fitMapToLocations(locs)
  	  // PURPOSE: Fit map bounds to a set of locations
  	  // ============================================================
  	  function fitMapToLocations(locs) {
  	    if (!Array.isArray(locs) || !locs.length) return;

  	    const bounds = new google.maps.LatLngBounds();
  	    let added = false;

  	    locs.forEach(loc => {
  	      const ep = getEntranceLatLng(loc);
  	      if (ep) {
  	        bounds.extend(new google.maps.LatLng(ep.lat, ep.lng));
  	        added = true;
  	      }

  	      const poly = getPolygonLatLngs(loc);
  	      if (poly && poly.length) {
  	        poly.forEach(p => bounds.extend(new google.maps.LatLng(p.lat, p.lng)));
  	        added = true;
  	      }
  	    });

  	    if (!added) return;

  	    map.fitBounds(bounds);

  	    const listener = google.maps.event.addListenerOnce(map, "idle", () => {
  	      const maxZoom = 18;
  	      if (map.getZoom() > maxZoom) {
  	        map.setZoom(maxZoom);
  	      }
  	    });
  	  }

  	  // ============================================================
  	  // SECTION: INIT
  	  // PURPOSE: Initial render of list + polygons and wiring search
  	  // ============================================================
  	  renderList();
  	  renderPolygons();

  	  search.addEventListener("input",
  	    e => {
  	      renderList(e.target.value);
  	      renderPolygons();
  	      fitMapToLocations(currentFilteredLocations);
  	    });

  	  // ============================================================================
  	  // GLOBAL BRIDGE — EXPOSE CORE HELPERS FOR FIELD WIZARD
  	  // PURPOSE:
  	  //   • Allow the Add Field Wizard (outside IIFE) to access core geometry helpers.
  	  //   • Follows Golden Global Rule: single lawful export under window.WizardGlobals.
  	  // ============================================================================

  	  window.WizardGlobals = window.WizardGlobals || {};

  	  Object.assign(window.WizardGlobals,
  	    {
  	      getPolygonLatLngs:
  	      typeof getPolygonLatLngs !== "undefined" ? getPolygonLatLngs: null,
  	      setPolygonFromLatLngs:
  	      typeof setPolygonFromLatLngs !== "undefined" ? setPolygonFromLatLngs: null,
  	      computeAreaFromRing:
  	      typeof computeAreaFromRing !== "undefined" ? computeAreaFromRing: null,
  	      applyAreaToLocation:
  	      typeof applyAreaToLocation !== "undefined" ? applyAreaToLocation: null
  	    });

  	  console.log("[LocationWizard] (Globals) :: Core geometry helpers bridged",
  	    {
  	      exported: Object.keys(window.WizardGlobals)
  	    });


  	})({
  	  Map,
  	  Locations,
  	  Hub,
  	  AppData,
  	  Backendless
  	});

  	// ============================================================================
  	// FIELD WIZARD (Add Field to Farm)
  	// PURPOSE:
  	//   Guided polygon-draw workflow for creating Fields inside an existing Farm.
  	//   Uses GeometryHelperV2.buildGeometry({mode:"FIELD"}) for clipping/validation.
  	// ============================================================================

  	function openAddFieldWizard(farm) {
  	  // Retrieve lawful helper references
  	  const {
  	    getPolygonLatLngs,
  	    setPolygonFromLatLngs,
  	    computeAreaFromRing,
  	    applyAreaToLocation
  	  } =
  	  (typeof window !== "undefined" && window.WizardGlobals)
  	  ? window.WizardGlobals: {};

  	  if (!farm || !farm.Polygon) {
  	    alert("Farm geometry missing — cannot add Field.");
  	    return;
  	  }

  	  // ============================================================
  	  // GEOMETRY HELPER V2 — RUNTIME SAFETY BRIDGE
  	  // PURPOSE:
  	  //   Ensure WizardGeometryV2 exists even if defined in another Backendless block.
  	  //   This allows cross-file isolation to share a minimal geometry engine.
  	  // ============================================================

  	  if (typeof window !== "undefined") {
  	    if (!window.WizardGeometry || typeof window.WizardGeometry.buildGeometry !== "function") {
  	      console.warn("[LocationWizard] (Wizard) :: GeometryHelperV2 not found — bridging now");

  	      window.WizardGeometry = window.WizardGeometry || {};

  	      window.WizardGeometry.buildGeometry = function(config = {}) {
  	        console.log("[LocationWizard] (WizardBridge) :: Fallback GeometryHelper active");
  	        const draft = config.draftPoints || [];
  	        return {
  	          status: draft.length ? "valid": "invalid",
  	          finalPolygon: draft,
  	          message: draft.length ? "Geometry accepted (fallback)": "No draft points",
  	        };
  	      };

  	      window.WizardGeometry.version = "2.0-bridge";
  	    } else {
  	      console.log("[LocationWizard] (Wizard) :: GeometryHelperV2 detected in scope", {
  	        version: window.WizardGeometry.version
  	      });
  	    }
  	  }


  	  console.log("[LocationWizard] (Wizard) :: Launching Add Field Wizard for Farm", farm.Name);

  	  const map = (typeof google !== "undefined" && google.maps) ? google.maps: null;
  	  if (!map || !window.google?.maps) {
  	    alert("Google Maps not available.");
  	    return;
  	  }

  	  // ============================================================
  	  // GEOMETRY HELPER RESOLUTION (Final Law-Compliant Form)
  	  // PURPOSE:
  	  //   • Ensure Add Field Wizard reads the helper from the global namespace.
  	  //   • Eliminate false negatives when helper is present.
  	  // ============================================================

  	  var WizardGeometry = (typeof window !== "undefined" && window.WizardGeometry)
  	  ? window.WizardGeometry: null;

  	  if (!WizardGeometry || typeof WizardGeometry.buildGeometry !== "function") {
  	    console.warn("[LocationWizard] (Wizard) :: GeometryHelperV2 not found", {
  	      hasGlobal: !!window.WizardGeometry,
  	      type: typeof window.WizardGeometry?.buildGeometry
  	    });
  	    alert("Geometry helper missing.");
  	    return;
  	  }

  	  console.log("[LocationWizard] (Wizard) :: GeometryHelperV2 ready", {
  	    version: WizardGeometry.version,
  	    hasBuild: typeof WizardGeometry.buildGeometry === "function"
  	  });


  	  // Prepare farm polygon
  	  const farmPolygon = getPolygonLatLngs(farm);
  	  if (!farmPolygon || farmPolygon.length < 3) {
  	    alert("Farm boundary invalid.");
  	    return;
  	  }

  	  // Create wizard panel
  	  const wizard = document.createElement("div");
  	  wizard.id = "addFieldWizard";
  	  Object.assign(wizard.style, {
  	    position: "absolute",
  	    top: "50px",
  	    right: "200px",
  	    width: "300px",
  	    bottom: "0",
  	    background: "rgba(25,25,25,0.95)",
  	    color: "#fff",
  	    borderLeft: "2px solid #00AAFF",
  	    zIndex: 1500,
  	    padding: "12px",
  	    overflowY: "auto",
  	    fontFamily: "system-ui,sans-serif",
  	    boxShadow: "-2px 0 10px rgba(0,0,0,0.4)"
  	  });
  	  wizard.innerHTML = `
  	  <div style="font-weight:600;color:#00AAFF;font-size:13px;margin-bottom:6px;">
  	  Add New Field inside ${farm.Name}
  	  </div>
  	  <div style="font-size:12px;color:#ccc;margin-bottom:8px;">
  	  Draw the field polygon on the map. It will be clipped to the farm automatically.
  	  </div>
  	  <button id="startDrawBtn" style="width:100%;padding:6px;background:#444;border:none;border-radius:6px;color:#fff;cursor:pointer;">Start Drawing</button>
  	  <div id="wizardStatus" style="margin-top:10px;font-size:11px;color:#999;"></div>
  	  `;
  	  Hub.el.appendChild(wizard);

  	  const startBtn = wizard.querySelector("#startDrawBtn");
  	  const statusEl = wizard.querySelector("#wizardStatus");

  	  let drawingManager,
  	  drawnPolygon;

  	  startBtn.onclick = () => {
  	    statusEl.textContent = "Drawing mode active — click on map to define field boundary.";
  	    // ============================================================
  	    // INTERNAL DRAWING MODE — No external Drawing library required
  	    // ============================================================
  	    let drawing = false;
  	    let tempPath = [];
  	    let tempPolygon = null;

  	    startBtn.onclick = () => {
  	      const mapOk =
  	      typeof window.Map !== "undefined" &&
  	      window.Map instanceof google.maps.Map;

  	      if (!mapOk) {
  	        console.warn("[LocationWizard] (Wizard) :: Map not ready for manual draw");
  	        alert("Map not ready yet.");
  	        return;
  	      }

  	      const map = window.Map;

  	      if (drawing) return; // already active
  	      drawing = true;

  	      window.WizardDrawingMode = true;
  	      window.dispatchEvent(
  	        new CustomEvent("WizardDrawingModeChange", {
  	          detail: {
  	            active: true
  	          }
  	        })
  	      );


  	      statusEl.textContent =
  	      "Drawing mode active — click points to define field boundary.";

  	      // ------------------------------------------------------------
  	      // STEP 1 — Immediately lock down all polygon hitboxes
  	      // ------------------------------------------------------------
  	      try {
  	        if (typeof disablePolygonHitboxes === "function") {
  	          disablePolygonHitboxes();
  	          console.log("[LocationWizard] (Wizard) :: Farm polygons LOCKED for drawing");
  	        } else {
  	          console.warn("[LocationWizard] (Wizard) :: disablePolygonHitboxes missing");
  	        }
  	      } catch (err) {
  	        console.warn("[LocationWizard] (Wizard) :: disablePolygonHitboxes failed", err);
  	      }

  	      // ------------------------------------------------------------
  	      // STEP 2 — Prepare temporary polygon safely
  	      // ------------------------------------------------------------
  	      if (
  	        typeof tempPolygon !== "undefined" &&
  	        tempPolygon &&
  	        typeof tempPolygon.setMap === "function"
  	      ) {
  	        tempPolygon.setMap(null);
  	      }
  	      tempPolygon = null;
  	      tempPath = [];

  	      // ------------------------------------------------------------
  	      // STEP 3 — Build polygon interactively by map clicks
  	      // ------------------------------------------------------------
  	      const clickListener = map.addListener("click", e => {
  	        // ignore invalid click events
  	        if (!e || !e.latLng) return;

  	        tempPath.push(e.latLng);

  	        if (tempPolygon && typeof tempPolygon.setPath === "function") {
  	          tempPolygon.setPath(tempPath);
  	        } else {
  	          tempPolygon = new google.maps.Polygon({
  	            paths: tempPath,
  	            strokeColor: "#00AAFF",
  	            fillColor: "#00AAFF",
  	            strokeOpacity: 0.9,
  	            fillOpacity: 0.25,
  	            strokeWeight: 2,
  	            editable: true,
  	            map,
  	          });
  	        }
  	      });

  	      // ------------------------------------------------------------
  	      // STEP 4 — Right-click or ESC to finish
  	      // ------------------------------------------------------------
  	      const finishDrawing = () => {
  	        google.maps.event.removeListener(clickListener);
  	        google.maps.event.removeListener(rightClickListener);
  	        document.removeEventListener("keydown",
  	          escListener);

  	        drawing = false;

  	        // Re-enable polygons AFTER draw mode ends
  	        try {
  	          if (typeof enablePolygonHitboxes === "function") {
  	            enablePolygonHitboxes();
  	            console.log("[LocationWizard] (Wizard) :: Farm polygons UNLOCKED after drawing");
  	          } else {
  	            console.warn("[LocationWizard] (Wizard) :: enablePolygonHitboxes missing");
  	          }
  	        } catch (err) {
  	          console.warn("[LocationWizard] (Wizard) :: enablePolygonHitboxes failed", err);
  	        }

  	        if (!tempPolygon || tempPath.length < 3) {
  	          alert("Polygon must have at least three points.");
  	          if (tempPolygon && typeof tempPolygon.setMap === "function") {
  	            tempPolygon.setMap(null);
  	          }
  	          tempPolygon = null;
  	          return;
  	        }

  	        statusEl.textContent = "Processing geometry...";
  	        window.WizardDrawingMode = false;
  	        window.dispatchEvent(
  	          new CustomEvent("WizardDrawingModeChange", {
  	            detail: {
  	              active: false
  	            }
  	          })
  	        );

  	        handlePolygon(tempPolygon);
  	      };

  	      const rightClickListener = map.addListener("rightclick", finishDrawing);

  	      // ESC cancels drawing safely
  	      const escListener = evt => {
  	        if (evt.key === "Escape") {
  	          console.log("[LocationWizard] (Wizard) :: Drawing cancelled via ESC");
  	          if (tempPolygon && typeof tempPolygon.setMap === "function") {
  	            tempPolygon.setMap(null);
  	          }
  	          tempPolygon = null;
  	          finishDrawing();
  	        }
  	      };
  	      document.addEventListener("keydown", escListener);

  	      console.log("[LocationWizard] (Wizard) :: Manual drawing mode engaged");
  	    };

  	  };

  	  async function handlePolygon(polygon) {
  	    const draftPoints = polygon.getPath().getArray().map(p => ({
  	      lat: p.lat(),
  	      lng: p.lng()
  	    }));

  	    const siblings = (farm.Fields || []).map(f => ({
  	      id: f.objectId,
  	      polygon: getPolygonLatLngs(f)
  	    }));

  	    const result = buildGeometry({
  	      mode: "FIELD",
  	      parentPolygon: farmPolygon,
  	      siblings,
  	      draftPoints
  	    });

  	    if (result.status !== "valid" && result.status !== "corrected") {
  	      statusEl.style.color = "#ff6666";
  	      statusEl.textContent = "Invalid: " + result.message;
  	      polygon.setOptions({
  	        strokeColor: "#ff6666", fillColor: "#ff6666"
  	      });
  	      return;
  	    }

  	    statusEl.style.color = "#00ff99";
  	    statusEl.textContent = `Field geometry ${result.status}. Ready to save.`;

  	    // Replace polygon with final geometry
  	    polygon.setMap(null);
  	    const finalPoly = new google.maps.Polygon({
  	      paths: result.finalPolygon,
  	      strokeColor: "#00ff99",
  	      fillColor: "#00ff99",
  	      strokeOpacity: 0.9,
  	      fillOpacity: 0.25,
  	      strokeWeight: 2,
  	      editable: false,
  	      draggable: false,
  	      map
  	    });

  	    const saveBtn = document.createElement("button");
  	    saveBtn.textContent = "Save Field";
  	    Object.assign(saveBtn.style, {
  	      width: "100%",
  	      marginTop: "10px",
  	      padding: "6px",
  	      background: "#00AA88",
  	      border: "none",
  	      borderRadius: "6px",
  	      color: "#fff",
  	      cursor: "pointer"
  	    });
  	    wizard.appendChild(saveBtn);

  	    saveBtn.onclick = async () => {
  	      statusEl.textContent = "Saving field...";
  	      const field = {
  	        Name: "New Field",
  	        Type: "Field",
  	        Color: "#00AAFF",
  	        Polygon: {
  	          type: "Polygon",
  	          coordinates: [result.finalPolygon.map(p => [p.lng, p.lat])]
  	        },
  	        ParentFarm: {
  	          objectId: farm.objectId
  	        }
  	      };

  	      try {
  	        const saved = await Backendless.Data.of("Locations").save(field);
  	        if (!farm.Fields) farm.Fields = [];
  	        farm.Fields.push(saved);
  	        statusEl.textContent = "Field saved successfully.";
  	        console.log("[LocationWizard] (Wizard) :: Field created", saved);
  	      } catch (err) {
  	        console.warn("Failed to save field", err);
  	        statusEl.textContent = "Error saving field.";
  	      }
  	    };
  	  }
  	}

  	// ============================================================================
  	// GEOMETRY HELPER V2 — INLINE REGISTRATION UNDER SACRED LAW
  	// PURPOSE:
  	//   • Expose GeometryHelperV2 in Backendless runtime under window.WizardGeometry.
  	//   • Provides full geometry validation, clipping, containment and overlap checks.
  	//   • No scope pollution, uniform console format.
  	// ============================================================================

  	if (typeof window !== "undefined" && window.WizardGeometry?.buildGeometry) {
  	  console.log("[LocationWizard] (Globals) :: GeometryHelperV2 already registered");
  	} else {
  	  window.WizardGeometry = window.WizardGeometry || {};

  	  // ============================================================
  	  // FUNCTION: buildGeometry(config)
  	  // PURPOSE:
  	  //   Build, validate and correct polygon geometry for different modes.
  	  //   Supported modes: FIELD (default), SEGMENT.
  	  // ============================================================
  	  function buildGeometry(config = {}) {
  	    const mode = config.mode || "FIELD";
  	    const draft = Array.isArray(config.draftPoints) ? config.draftPoints: [];
  	    const parentPoly = Array.isArray(config.parentPolygon)
  	    ? config.parentPolygon: [];
  	    const siblings = Array.isArray(config.siblings) ? config.siblings: [];

  	    if (!draft.length)
  	      return {
  	      status: "invalid",
  	      message: "No draft points supplied"
  	    };
  	    if (!parentPoly.length)
  	      return {
  	      status: "invalid",
  	      message: "Missing parent polygon"
  	    };

  	    // ---------- UTILITIES ----------
  	    const toRad = d => (d * Math.PI) / 180;
  	    const cross = (o, a, b) =>
  	    (a.lng - o.lng) * (b.lat - o.lat) - (a.lat - o.lat) * (b.lng - o.lng);

  	    // point-in-polygon (ray-casting)
  	    function pointInPolygon(pt, polygon) {
  	      let inside = false;
  	      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
  	        const xi = polygon[i].lng,
  	        yi = polygon[i].lat;
  	        const xj = polygon[j].lng,
  	        yj = polygon[j].lat;
  	        const intersect =
  	        yi > pt.lat !== yj > pt.lat &&
  	        pt.lng < ((xj - xi) * (pt.lat - yi)) / (yj - yi) + xi;
  	        if (intersect) inside = !inside;
  	      }
  	      return inside;
  	    }

  	    // polygon area (m²) via haversine shoelace
  	    function polygonArea(polygon) {
  	      const R = 6378137;
  	      let sum = 0;
  	      for (let i = 0; i < polygon.length; i++) {
  	        const p1 = polygon[i];
  	        const p2 = polygon[(i + 1) % polygon.length];
  	        sum += toRad(p2.lng - p1.lng) *
  	        (2 + Math.sin(toRad(p1.lat)) + Math.sin(toRad(p2.lat)));
  	      }
  	      return Math.abs((sum * R * R) / 2.0);
  	    }

  	    // detect self-intersection
  	    function selfIntersects(polygon) {
  	      for (let i = 0; i < polygon.length; i++) {
  	        const a1 = polygon[i],
  	        a2 = polygon[(i + 1) % polygon.length];
  	        for (let j = i + 1; j < polygon.length; j++) {
  	          const b1 = polygon[j],
  	          b2 = polygon[(j + 1) % polygon.length];
  	          if (
  	            a1 !== b1 &&
  	            a1 !== b2 &&
  	            a2 !== b1 &&
  	            a2 !== b2 &&
  	            intersects(a1, a2, b1, b2)
  	          )
  	            return true;
  	        }
  	      }
  	      return false;
  	    }

  	    // segment intersection check
  	    function intersects(a, b, c, d) {
  	      function ccw(p1, p2, p3) {
  	        return (p3.lat - p1.lat) * (p2.lng - p1.lng) >
  	        (p2.lat - p1.lat) * (p3.lng - p1.lng);
  	      }
  	      return ccw(a, c, d) !== ccw(b, c, d) && ccw(a, b, c) !== ccw(a, b, d);
  	    }

  	    // ensure polygon clockwise
  	    function makeClockwise(poly) {
  	      const area =
  	      poly.reduce(
  	        (s, p, i) => {
  	          const q = poly[(i + 1) % poly.length];
  	          return s + (q.lng - p.lng) * (q.lat + p.lat);
  	        },
  	        0
  	      );
  	      if (area > 0) return poly.slice().reverse();
  	      return poly;
  	    }

  	    // clip polygon to parent (simple containment check)
  	    function clipToParent(poly, parent) {
  	      const allInside = poly.every(pt => pointInPolygon(pt, parent));
  	      if (allInside) return {
  	        clipped: poly,
  	        corrected: false
  	      };
  	      // naive correction: remove outside points
  	      const clipped = poly.filter(pt => pointInPolygon(pt, parent));
  	      return {
  	        clipped,
  	        corrected: clipped.length >= 3
  	      };
  	    }

  	    // overlap test against siblings
  	    function overlapsAny(poly, sibs) {
  	      for (const s of sibs) {
  	        const sibPoly = s.polygon || [];
  	        if (!sibPoly.length) continue;
  	        for (const pt of poly) {
  	          if (pointInPolygon(pt, sibPoly)) return true;
  	        }
  	      }
  	      return false;
  	    }

  	    // ---------- VALIDATION FLOW ----------
  	    let finalPolygon = makeClockwise(draft);

  	    if (selfIntersects(finalPolygon))
  	      return {
  	      status: "invalid",
  	      message: "Polygon self-intersects"
  	    };

  	    // clip to parent
  	    const clipResult = clipToParent(finalPolygon, parentPoly);
  	    finalPolygon = clipResult.clipped;

  	    if (!finalPolygon.length)
  	      return {
  	      status: "invalid",
  	      message: "Polygon outside parent"
  	    };

  	    // sibling overlap check
  	    if (overlapsAny(finalPolygon, siblings))
  	      return {
  	      status: "invalid",
  	      message: "Overlaps existing sibling field"
  	    };

  	    const area = polygonArea(finalPolygon);
  	    if (area < 100)
  	      return {
  	      status: "invalid",
  	      message: "Area too small (<100 m²)"
  	    };

  	    const status = clipResult.corrected ? "corrected": "valid";
  	    return {
  	      status,
  	      finalPolygon,
  	      area
  	    };
  	  }

  	  // lawful export
  	  window.WizardGeometry.buildGeometry = buildGeometry;
  	  window.WizardGeometry.version = "2.0";

  	  console.log("[LocationWizard] (Globals) :: GeometryHelperV2 attached", {
  	    version: window.WizardGeometry.version,
  	  });
  	}
  })(Hub, Locations, Map, AppData);

}

})
define('./functions/b665c075565aa28862ac1e9374ca2b96/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b665c075565aa28862ac1e9374ca2b96'] = async function fn_b665c075565aa28862ac1e9374ca2b96(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b8d6305d8b24558eb58f8fe7c0212833/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b8d6305d8b24558eb58f8fe7c0212833'] = async function fn_b8d6305d8b24558eb58f8fe7c0212833(listToFlatten, maxRecursionDepth) {
return (await (async function(array, depth) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (depth == null) {
	  depth = 1
	}

	return _.flattenDepth(array, depth)
})(listToFlatten, maxRecursionDepth))
}

})
define('./functions/b93bcd5de56aa56928854fbb554683b1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b93bcd5de56aa56928854fbb554683b1'] = async function fn_b93bcd5de56aa56928854fbb554683b1(listToQuery, elementIndex) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 0
	}

	return _.nth(array, n)
})(listToQuery, elementIndex))
}

})
define('./functions/c1083dfc958bfce9f511282469f18202/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c1083dfc958bfce9f511282469f18202'] = async function fn_c1083dfc958bfce9f511282469f18202(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.union(...arrays)
})(listsToInspect))
}

})
define('./functions/c58e08966457701101ab34279f33af6d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c58e08966457701101ab34279f33af6d'] = async function fn_c58e08966457701101ab34279f33af6d(keyValuePairsList) {
return (await (async function(pairs) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.fromPairs(pairs)
})(keyValuePairsList))
}

})
define('./functions/c762727fdec3289419fcb8c4fccb511d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c762727fdec3289419fcb8c4fccb511d'] = async function fn_c762727fdec3289419fcb8c4fccb511d(Min, Max, Input, Target) {
return (await (async function(Input) {
	function interpolateColor(value) {
	    // Ensure the input value is within the range [0, 100]
	    value = Math.min(100, Math.max(0, value));
	
	    let red, green, blue;
	
	    if (value <= 50) {
	        // Formula for the green value from 0 to 50
	        green = Math.round((255 / 50) * value);
	        red = 255;
	        blue = 0;
	    } else {
	        // Formula for the red value from 50 to 100
	        red = Math.round((255 / 50) * (100 - value));
	        green = 255;
	        blue = 0;
	    }
	
	    return `rgb(${red}, ${green}, ${blue})`;
	}
	
	// Example usage:
	const inputValue = Input; // Replace this with your input value
	const resultColor = interpolateColor(inputValue);
	
	return resultColor
})((await (async function(Min, Max, Input, Target) {
	function calculateScore(min, target, max, input) {
	  if (input < min || input > max) {
	    return 0;
	  } else if (target === input) {
	    return 100;
	  } else if (input >= min && input <= target) {
	    return ((input - min) / (target - min)) * 100;
	  } else {
	    return ((max - input) / (max - target)) * 100;
	  }
	}
	
	// Example usage with your provided values
	const min = Min;
	const target = Target;
	const max = Max;
	const input = Input;
	
	const result = calculateScore(min, target, max, input);
	
	return result
})(Min, Max, Input, Target))))
}

})
define('./functions/cab97651610a7df89b05dbc568adb257/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cab97651610a7df89b05dbc568adb257'] = async function fn_cab97651610a7df89b05dbc568adb257(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = array.length - 1
	}

	return _.lastIndexOf(array, value, fromIndex);
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./functions/cf0cee815db7c56daa3d4a3f0704a8ac/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cf0cee815db7c56daa3d4a3f0704a8ac'] = async function fn_cf0cee815db7c56daa3d4a3f0704a8ac(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersection(...arrays)
})(listsToInspect))
}

})
define('./functions/d535622b38bb7a25aa31ae757fe6869c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d535622b38bb7a25aa31ae757fe6869c'] = async function fn_d535622b38bb7a25aa31ae757fe6869c(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.takeRight(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/d813cd0b8767bda332b7d73f1ea8155b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d813cd0b8767bda332b7d73f1ea8155b'] = async function fn_d813cd0b8767bda332b7d73f1ea8155b(listToConvert, elementSeparator) {
return (await (async function(array, separator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.join(array, separator)
})(listToConvert, elementSeparator))
}

})
define('./functions/d91c5dbed1a614198a69238eaf0de643/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d91c5dbed1a614198a69238eaf0de643'] = async function fn_d91c5dbed1a614198a69238eaf0de643(Table, Clause, Relations) {
var Result_List, j, Table_List, Offset, Pages, i, Object_Number;


  Result_List = [];
  Object_Number = (await Backendless.Data.of(Table).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(Clause)));
  Pages = Math.ceil(Object_Number / 100);
  Offset = 0;
  var i_inc = 1;
  if (1 > Pages) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= Pages : i >= Pages; i += i_inc) {
    Table_List = (await Backendless.Data.of(Table).find(Backendless.DataQueryBuilder.create().setWhereClause(Clause).setRelated(Relations).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(100).setOffset(Offset)));
    Offset = Offset + 100;
    for (var j_index in Table_List) {
      j = Table_List[j_index];
      Result_List.push(j);
    }
  }

return Result_List
}

})
define('./functions/dfe6f4741626a11429b6777d44ba18e7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfe6f4741626a11429b6777d44ba18e7'] = async function fn_dfe6f4741626a11429b6777d44ba18e7(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.difference(array, values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/dfef9391c409b8519db2242d696ca08c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfef9391c409b8519db2242d696ca08c'] = async function fn_dfef9391c409b8519db2242d696ca08c(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniq(array)
})(listToInspect))
}

})
define('./functions/e04783eefccc55279cd3ffc580231f28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e04783eefccc55279cd3ffc580231f28'] = async function fn_e04783eefccc55279cd3ffc580231f28(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/eab6964cdd451a9c2dbbbeb2cbcc36de/code.js', () => { 

BackendlessUI.Functions.Custom['fn_eab6964cdd451a9c2dbbbeb2cbcc36de'] = async function fn_eab6964cdd451a9c2dbbbeb2cbcc36de(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pull(array, ...values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/ec97791f4918eb07b6dff2a5bfec059a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ec97791f4918eb07b6dff2a5bfec059a'] = async function fn_ec97791f4918eb07b6dff2a5bfec059a(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xor(...arrays)
})(listsToInspect))
}

})
define('./functions/f1c97833e26b0995f236b863812bfed2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f1c97833e26b0995f236b863812bfed2'] = async function fn_f1c97833e26b0995f236b863812bfed2(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.indexOf(array, value, fromIndex)
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./functions/f3979dfa9c737a1d3495e9a9fe75af93/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f3979dfa9c737a1d3495e9a9fe75af93'] = async function fn_f3979dfa9c737a1d3495e9a9fe75af93(Tractor, Map) {
  await (async function(Tractor, Map, SVG) {
  	// === Rog Configurator v8.3 — Event-Driven Report Builder (A4 Landscape, Async Map) =====
  	// - Keeps ALL v8.2 functionality
  	// - Duration always HH:MM:SS
  	// - Adds Distance + % of Trip Distance + % of Trip Time
  	// - Removes Lat/Lon from itemized
  	// - Unifies columns and left-justifies
  	// - Adds @page A4 landscape for print
  	// - NEW: Async Map Snapshot with spinner + fade-in
  	// === Rog Configurator v8.3 — Event-Driven Report Builder (A4 Landscape, Async Map) =====
  	(function () {
  	  const tractor = typeof Tractor !== "undefined" ? Tractor: window.Tractor || null;
  	  if (!tractor) {
  	    console.warn("❌ Rog v8.3: Tractor object not found.");
  	    return;
  	  }

  	  const svg = typeof SVG !== "undefined" ? SVG: window.SVG || null;
  	  if (!svg) {
  	    console.warn("⚠️ SVG object not found.");
  	    return;
  	  }

  	  const REPORT_Z_INDEX = 2147483640;
  	  const REPORT_MODAL_Z_INDEX = 2147483647;

  	  // === HELPERS ==============================================================
  	  const byId = (id) => document.getElementById(id);
  	  const el = (tag, cls, html) => {
  	    const e = document.createElement(tag);
  	    if (cls) e.className = cls;
  	    if (html != null) e.innerHTML = html;
  	    return e;
  	  };

  	  document.getElementById("rog-event-overlay")?.remove();

  	  const can = tractor.CAN || tractor.can || {};
  	  const canEvents = Array.isArray(can.Events) ? can.Events: [];

  	  const runEvents = tractor.Events || {};
  	  const runEventsMax = (tractor.Events && tractor.Events.Max) ? tractor.Events.Max: {};

  	  const categoryMap = {};
  	  canEvents.forEach((ev) => {
  	    const cat = ev.category || "Other";
  	    if (!categoryMap[cat]) categoryMap[cat] = [];
  	    categoryMap[cat].push(ev);
  	  });

  	  // === SORT CATEGORIES & EVENTS ALPHABETICALLY ===============================
  	  Object.keys(categoryMap)
  	  .sort((a, b) => a.localeCompare(b))
  	  .forEach((key) => {
  	    // sort the event names within each category
  	    categoryMap[key].sort((a, b) =>
  	      (a.name || "").localeCompare(b.name || "")
  	    );
  	  });


  	  // === Detect Location / Geo Events =========================================
  	  let locEvents = [];

  	  // ✅ Exact match for your structure: Tractor.Events["Location Events"]
  	  if (Array.isArray(tractor.Events?.["Location Events"])) {
  	    locEvents = tractor.Events["Location Events"];
  	  }
  	  // fallback paths for safety
  	  else if (Array.isArray(tractor.Events?.Location?.Events)) {
  	    locEvents = tractor.Events.Location.Events;
  	  } else if (Array.isArray(tractor.Events?.Locations)) {
  	    locEvents = tractor.Events.Locations;
  	  } else if (Array.isArray(tractor.Locations)) {
  	    locEvents = tractor.Locations;
  	  } else if (Array.isArray(tractor.Geo)) {
  	    locEvents = tractor.Geo;
  	  }

  	  if (locEvents.length) {
  	    categoryMap["Locations"] = locEvents.map((loc, i) => {
  	      const points = Array.isArray(loc.points) ? loc.points[0]: null;
  	      const tsIn = points?.ts_in || loc.ts_in || null;
  	      const tsOut = points?.ts_out || loc.ts_out || null;
  	      const timeIn = points?.time_in || loc.time_in || null;
  	      const timeOut = points?.time_out || loc.time_out || null;

  	      return {
  	        name: loc.Name || loc.name || `Location ${i + 1}`,
  	        _special: "LocationEvent",
  	        lat: Number(loc.lat_in || loc.latitude || loc.Location?.Latitude || 0),
  	        lng: Number(loc.lon_in || loc.longitude || loc.Location?.Longitude || 0),
  	        timestamp: loc.timestamp || loc.ts_in || null,
  	        duration: loc.duration_sec || 0,
  	        fuel_used: round2(loc.fuel_used),
  	        km_per_litre: round2(loc.km_per_litre),
  	        litres_per_hour: round2(loc.litres_per_hour),
  	        time_in: timeIn,
  	        time_out: timeOut,
  	        type_in: loc.type || points?.type || "—",
  	        type_out: loc.type_out || points?.type_out || "—",
  	      };
  	    });
  	  }

  	  // === TRIP CONTEXT & HELPERS ==============================================
  	  function formatDuration(sec) {
  	    if (!sec || isNaN(sec) || sec < 0) return "00:00:00";
  	    const s = Math.floor(sec);
  	    const h = Math.floor(s / 3600);
  	    const m = Math.floor((s % 3600) / 60);
  	    const ss = s % 60;
  	    return [h,
  	      m,
  	      ss].map(x => String(x).padStart(2, "0")).join(":");
  	  }

  	  function formatMinutesSeconds(sec) {
  	  if (!sec || isNaN(sec) || sec < 0) return "0m 00s";

  	  const s = Math.floor(sec);
  	  const m = Math.floor(s / 60);
  	  const ss = s % 60;

  	  return `${m}m ${String(ss).padStart(2, "0")}s`;
  	}

  	  function round2(val) {
  	    if (val == null || isNaN(val)) return "—";
  	    return Number(val).toFixed(2);
  	  }

  	  function formatDistanceMeters(m) {
  	    if (m == null || isNaN(m)) return "0";
  	    if (m < 1000) return `${Math.round(m)} m`;
  	    return `${(m / 1000).toFixed(2)} km`;
  	  }

  	  function getTripContext() {
  	    const track = Array.isArray(tractor.Tracking) ? tractor.Tracking: [];
  	    const firstPoint = track[0] || null;
  	    const lastPoint = track.length ? track[track.length - 1]: null;

  	    const startTs = firstPoint?.point?.timestamp || firstPoint?.timestamp || null;
  	    const endTs = lastPoint?.point?.timestamp || lastPoint?.timestamp || null;

  	    const tripDurationSec =
  	    startTs && endTs && endTs > startTs ? endTs - startTs: 0;

  	    const distKm =
  	    (tractor.Events?.Max?.DistKm ||
  	      tractor.Events?.Max?.distKm ||
  	      tractor.Events?.Max?.DistKM ||
  	      0);

  	    return {
  	      startTs,
  	      endTs,
  	      tripDurationSec,
  	      tripDistanceMeters: distKm ? distKm * 1000: 0,
  	    };
  	  }

  	  const pct = (part, total) =>
  	  !total || total <= 0 ? "0.00%": ((part / total) * 100).toFixed(2) + "%";

  	  // ✅ create once, globally visible to builder functions
  	  const tripCtx = getTripContext();

  	  // === MAP SNAPSHOT CACHE =====================================================
  	  let cachedMapSnapshot = null;
  	  // === COMPARE GRAPH STATE (persist across renderPreview rebuilds) ===========
  	  let rogCompareIndexes = null;


  	  // === EVENT STATE ==========================================================
  	  const selectedEventNames = new Set();
  	  const itemizedEvents = new Set();


  	  // === OVERLAY ==============================================================
  	  const overlay = el("div");
  	  overlay.id = "rog-event-overlay";
  	  overlay.style.cssText = `
  	  position:fixed;inset:0;background:rgba(0,0,0,0.55);
  	  display:flex;align-items:center;justify-content:center;
  	  z-index:${REPORT_Z_INDEX};font-family:'Segoe UI',sans-serif;
  	  `;

  	  const popup = el("div");
  	  popup.style.cssText = `
  	  background:#141414;color:#eee;width:82vw;height:85vh;
  	  display:grid;grid-template-columns:310px 1fr;
  	  border-radius:10px;overflow:hidden;
  	  box-shadow:0 0 25px rgba(0,0,0,0.8);
  	  `;

  	  // === LEFT PANEL ===========================================================
  	  const left = el("div");
  	  left.style.cssText = `
  	  background:#0f0f0f;
  	  padding:16px 14px;
  	  border-right:1px solid #222;
  	  display:flex;
  	  flex-direction:column;
  	  gap:14px;
  	  overflow-y:auto;
  	  max-height:85vh;
  	  `;

  	  left.innerHTML = `
  	  <div style="display:flex;justify-content:space-between;align-items:center;">
  	  <div style="font-weight:600;font-size:15px;">Event Report Builder</div>
  	  <div style="display:flex;align-items:center;gap:10px;">
  	  <!-- 🖨️ Print Icon -->
  	  <button id="rog-print" title="Print"
  	  style="all:unset;cursor:pointer;display:flex;align-items:center;justify-content:center;width:22px;height:22px;">
  	  <svg width="18" height="18" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
  	  <path d="M6 9V2h12v7h2a2 2 0 0 1 2 2v8h-4v3H6v-3H2v-8a2 2 0 0 1 2-2h2zm2 0h8V4H8v5zm0 9h8v-5H8v5z"/>
  	  </svg>
  	  </button>

  	  <!-- ✕ Close Button -->
  	  <button id="rog-close"
  	  style="all:unset;cursor:pointer;color:#ccc;font-size:18px;line-height:1;">✕</button>
  	  </div>
  	  </div>


  	  <div style="font-size:11px;color:#999;">Vehicle: ${tractor.FID || "—"}</div>

  	  <div id="rog-section-checkboxes" style="display:none;">
  	  <label><input id="sec-header" type="checkbox" checked style="accent-color:#0099ff;"> Header</label><br>
  	  <label><input id="sec-trip" type="checkbox" checked style="accent-color:#0099ff;"> Trip Summary</label><br>
  	  <label><input id="sec-map" type="checkbox" checked style="accent-color:#0099ff;"> Map Snapshot</label><br>
  	  <label><input id="sec-driver" type="checkbox" checked style="accent-color:#0099ff;"> Driver Info</label><br>
  	  <label><input id="sec-events" type="checkbox" checked style="accent-color:#0099ff;"> Event Summary</label><br>
  	  <label><input id="sec-footer" type="checkbox" checked style="accent-color:#0099ff;"> Footer</label>
  	  </div>
  	  `;

  	  const paramWrap = el("div");
  	  paramWrap.style.cssText = `
  	  background:#101010;border:1px solid #222;border-radius:6px;
  	  padding:8px 6px;overflow-y:auto;max-height:38vh;
  	  `;
  	  paramWrap.innerHTML = `<div style="font-size:12px;font-weight:600;margin-bottom:6px;">Parameters: select events to display</div>`;

  	  const sortedEntries = Object.entries(categoryMap).sort(([a], [b]) => {
  	    if (a === "Locations") return 1; // keep Locations last
  	    if (b === "Locations") return -1;
  	    return a.localeCompare(b);
  	  });

  	  sortedEntries.forEach(([catName, events]) => {

  	    const cat = el("div");
  	    cat.style.cssText = `
  	    margin-bottom:4px;border:1px solid #1f1f1f;border-radius:4px;overflow:hidden;
  	    `;
  	    const catHeader = el(
  	      "div",
  	      null,
  	      `<input type="checkbox" data-cat="${catName}" style="margin-right:6px; accent-color:#0099ff;">
  	      <span>${catName}</span>
  	      <span style="margin-left:auto;font-size:14px;cursor:pointer;">▸</span>`
  	    );
  	    catHeader.style.cssText = `
  	    display:flex;align-items:center;gap:4px;padding:4px 6px;
  	    background:#141414;cursor:pointer;
  	    `;
  	    const catBody = el("div");
  	    catBody.style.cssText = `display:none;padding:4px 6px 6px 16px;background:#121212;`;
  	    events.forEach((ev) => {
  	      const line = el("div");
  	      line.style.cssText = `display:flex;align-items:center;gap:4px;justify-content:space-between;margin-bottom:3px;`;
  	      const leftPart = el("label");
  	      leftPart.style.cssText = `display:flex;align-items:center;gap:4px;font-size:11px;flex:1;`;
  	      leftPart.innerHTML = `<input type="checkbox" data-ev="${ev.name}" / style="accent-color:#0099ff;"> ${ev.name}`;
  	      const rightPart = el("label");
  	      rightPart.style.cssText = `font-size:10px;white-space:nowrap;cursor:pointer;`;
  	      rightPart.innerHTML = `<input type="checkbox" data-ev-itemize="${ev.name}" / style="accent-color:#0099ff;"> itemize`;
  	      line.append(leftPart, rightPart);
  	      catBody.appendChild(line);
  	    });
  	    catHeader.addEventListener("click", (e) => {
  	      if (e.target.matches('input[type="checkbox"]')) return;
  	      catBody.style.display = catBody.style.display === "none" ? "block": "none";
  	    });
  	    const catCheckbox = catHeader.querySelector('input[type="checkbox"]');
  	    catCheckbox.addEventListener("change",
  	      (e) => {
  	        const checked = e.target.checked;
  	        catBody.querySelectorAll('input[data-ev]').forEach((inp) => {
  	          inp.checked = checked;
  	          if (checked) selectedEventNames.add(inp.dataset.ev);
  	          else selectedEventNames.delete(inp.dataset.ev);
  	        });
  	      });
  	    catBody.addEventListener("change", (e) => {
  	      const t = e.target;
  	      if (t.matches('input[data-ev]')) {
  	        if (t.checked) selectedEventNames.add(t.dataset.ev);
  	        else selectedEventNames.delete(t.dataset.ev);
  	      }
  	      if (t.matches('input[data-ev-itemize]')) {
  	        const evName = t.dataset.evItemize;
  	        if (t.checked) itemizedEvents.add(evName);
  	        else itemizedEvents.delete(evName);
  	      }
  	    });
  	    cat.append(catHeader,
  	      catBody);
  	    paramWrap.appendChild(cat);
  	  });
  	  left.appendChild(paramWrap);

  	  // 🔒 Hide Parameters section completely
  	  paramWrap.style.display = "none";

  	  // === GRAPH BUILDER ==========================================================
  	  const graphWrap = el("div");
  	  graphWrap.style.cssText = `
  	  background:#101010;
  	  border:1px solid #222;
  	  border-radius:6px;
  	  padding:8px 6px;
  	  margin-top:10px;
  	  flex:1 1 100%;
  	  min-height:0;
  	  display:flex;
  	  flex-direction:column;
  	  `;

  	  graphWrap.innerHTML = `
  	  <div style="font-size:12px;font-weight:600;margin-bottom:6px;">Graphs</div>

  	  <!-- 🟢 Add Graph -->
  	  <button id="rog-add-graph" style="
  	  display:flex;
  	  align-items:center;
  	  gap:6px;
  	  background:#222;
  	  border:1px solid #555;
  	  color:#eee;
  	  font-size:12px;
  	  padding:6px 10px;
  	  border-radius:4px;
  	  margin-bottom:6px;
  	  cursor:pointer;
  	  ">
  	  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 64 64" style="fill:#fff;">
  	  <path d="M32,6C17.641,6,6,17.641,6,32s11.641,26,26,26s26-11.641,26-26S46.359,6,32,6z M49,34l-14,1l-1,14h-4l-1-14l-14-1v-4l14-1	l1-14h4l1,14l14,1V34z"></path>
  	  </svg>
  	  <span>Add Graph</span>
  	  </button>

  	  <!-- 🟣 Compare Graphs -->
  	  <button id="rog-compare-graphs" style="
  	  display:none;
  	  align-items:center;
  	  gap:6px;
  	  background:#333;
  	  border:1px solid #666;
  	  color:#eee;
  	  font-size:12px;
  	  padding:6px 10px;
  	  border-radius:4px;
  	  cursor:pointer;
  	  ">
  	  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 64 64" style="fill:#fff;">
  	  <path d="M32 6A26 26 0 1 0 32 58A26 26 0 1 0 32 6ZM28 20H36V28H44V36H36V44H28V36H20V28H28V20Z"></path>
  	  </svg>
  	  <span>Compare Graphs</span>
  	  </button>

  	  <div id="rog-graph-list" style="
  	  display:flex;
  	  flex-direction:column;
  	  gap:6px;
  	  overflow-y:auto;
  	  overflow-x:hidden;
  	  flex:1 1 auto;
  	  min-height:0;
  	  max-height:none;
  	  padding-right:6px;
  	  scrollbar-width:thin;
  	  scrollbar-color:#cc6b33 #181818;
  	  "></div>
  	  `;

  	  function updateCompareGraphsButtonVisibility() {
  	    const cmpBtn = document.getElementById("rog-compare-graphs");
  	    if (!cmpBtn) return;

  	    const graphCount = document.querySelectorAll(".rog-graph-block").length;
  	    cmpBtn.style.display = graphCount >= 2 ? "flex": "none";
  	  }

  	  const graphableParams = [{
  	    key: "can.engine.rpm",
  	    label: "Engine RPM"
  	  },
  	    {
  	      key: "can.vehicle.speed",
  	      label: "Vehicle Speed"
  	    },
  	    {
  	      key: "gps.fuel.used",
  	      label: "Fuel Used"
  	    },
  	    {
  	      key: "can.engine.temperature",
  	      label: "Engine Temp"
  	    },
  	    {
  	      key: "position.altitude",
  	      label: "Altitude"
  	    },
  	    {
  	      key: "battery.voltage",
  	      label: "Battery Voltage"
  	    },
  	    {
  	      key: "x.acceleration",
  	      label: "Accel X"
  	    },
  	    {
  	      key: "y.acceleration",
  	      label: "Accel Y"
  	    },
  	    {
  	      key: "z.acceleration",
  	      label: "Accel Z"
  	    },
  	  ];

  	  // === 🟣 GRAPH COMPARISON MODAL + OVERLAY CHART ===============================

  	  function openCompareGraphsModal() {
  	    const graphs = Array.from(document.querySelectorAll(".rog-graph-block"));
  	    if (!graphs.length) {
  	      alert("No graphs available to compare.");
  	      return;
  	    }

  	    function getGraphCompareName(graph, index) {
  	      const selectedKeys = Array.from(graph.querySelectorAll(".param-list select"))
  	      .map(select => select.value)
  	      .filter(Boolean);

  	      const selectedLabels = selectedKeys.map(key => {
  	        const found = graphableParams.find(p => p.key === key);
  	        return found?.label || key;
  	      });

  	      return selectedLabels.length
  	      ? selectedLabels.join(" + "): `Graph ${index + 1}`;
  	    }

  	    const modal = document.createElement("div");
  	    modal.style.cssText = `
  	    position:fixed;inset:0;background:rgba(0,0,0,0.6);
  	    display:flex;align-items:center;justify-content:center;z-index:${REPORT_MODAL_Z_INDEX};
  	    `;

  	    const box = document.createElement("div");
  	    box.style.cssText = `
  	    background:#111;color:#eee;border-radius:8px;padding:16px;
  	    min-width:300px;max-width:380px;box-shadow:0 0 15px rgba(0,0,0,0.7);
  	    `;
  	    box.innerHTML = `
  	    <div style="font-size:14px;font-weight:600;margin-bottom:8px;">Select Graphs to Compare</div>
  	    <div id="rog-compare-list" style="max-height:200px;overflow:auto;margin-bottom:10px;">
  	    ${graphs.map((g, i) => `
  	      <label style="display:block;margin:4px 0;font-size:12px;">
  	      <input type="checkbox" value="${i}" style="accent-color:#cc6b33;"> ${getGraphCompareName(g, i)}
  	      </label>`).join("")}
  	    </div>
  	    <div style="display:flex;gap:10px;justify-content:flex-end;">
  	    <button id="rog-cmp-cancel" style="background:#333;border:none;color:#ccc;padding:4px 10px;border-radius:4px;">Cancel</button>
  	    <button id="rog-cmp-ok" style="background:#cc6633;border:none;color:#fff;padding:4px 10px;border-radius:4px;">Compare</button>
  	    </div>
  	    `;
  	    modal.appendChild(box);
  	    document.body.appendChild(modal);

  	    box.querySelector("#rog-cmp-cancel").onclick = () => modal.remove();

  	    box.querySelector("#rog-cmp-ok").onclick = () => {
  	      const sel = Array.from(box.querySelectorAll("input:checked")).map(x => parseInt(x.value));
  	      if (sel.length < 2) {
  	        alert("Select at least two graphs to compare.");
  	        return;
  	      }
  	      modal.remove();
  	      rogCompareIndexes = sel; // ✅ persist selection
  	      createOverlayGraph(sel); // still render live preview immediately
  	    };
  	  }


  	  function createOverlayGraph(selectedIndexes) {
  	    const graphs = Array.from(document.querySelectorAll(".rog-graph-block"));
  	    const selected = graphs.filter((_, i) => selectedIndexes.includes(i));

  	    // collect all chosen params from the selected graph blocks
  	    const chosenParams = [];
  	    selected.forEach((graph) => {
  	      const params = Array.from(graph.querySelectorAll(".param-list div"))
  	      .map((row) => ({
  	        key: row.querySelector("select")?.value,
  	        color: row.querySelector("input[type='color']")?.value || "#ccc",
  	      }))
  	      .filter((p) => p.key);
  	      chosenParams.push(...params);
  	    });
  	    if (!chosenParams.length) return;

  	    // 1️⃣ use consistent tractor reference
  	    const track = Array.isArray(tractor.Tracking) ? tractor.Tracking: [];

  	    // Normalize timestamps → always milliseconds for Chart.js
  	    const timeAxis = track.map((p) => {
  	      const t = p.timestamp || p.point?.timestamp || 0;
  	      return t < 1e12 ? t * 1000: t;
  	    });

  	    // 2️⃣ helper to reach nested value like "can.engine.rpm"
  	    const getPath = (obj, path) => {
  	      if (!obj) return undefined;
  	      if (path in obj) return obj[path];
  	      return path.split(".").reduce((a, c) => (a ? a[c]: undefined), obj);
  	    };

  	    // 3️⃣ normalize safely (0–100%)
  	    const normalize = (vals) => {
  	      const clean = vals.filter((v) => !isNaN(v));
  	      if (!clean.length) return vals.map(() => 0);
  	      const min = Math.min(...clean);
  	      const max = Math.max(...clean);
  	      if (max - min === 0) return vals.map(() => 0);
  	      return vals.map((v) => (isNaN(v) ? 0: ((v - min) / (max - min)) * 100));
  	    };

  	    // 4️⃣ build datasets using same timeAxis
  	    const dataByParam = chosenParams.map(({
  	      key, color
  	    }) => {
  	      const rawY = track.map((p) => {
  	        const v = getPath(p, key);
  	        return typeof v === "number" ? v: Number(v);
  	      });
  	      const normY = normalize(rawY);
  	      const points = timeAxis.map((t, i) => ({
  	        x: t, y: normY[i] ?? 0
  	      }));
  	      return {
  	        label: key, color, data: points
  	      };
  	    });

  	    // 5️⃣ render overlay chart
  	    const wrap = document.createElement("div");
  	    wrap.className = "rog-graph rog-compare-graph";
  	    wrap.style.cssText =
  	    "background:#fafafa;border:1px solid #ddd;border-radius:6px;padding:8px;margin-top:14px;";
  	    wrap.innerHTML = `
  	    <h4 style="margin:4px 0;color:#333;font-size:13px;">
  	    Correlation Graph (Normalized 0–100%)
  	    </h4>
  	    <canvas height="180"></canvas>
  	    `;
  	    const graphHost =
  	    document.getElementById("rog-graphs-section") ||
  	    document.getElementById("rog-preview");

  	    graphHost?.appendChild(wrap);

  	    const ctx = wrap.querySelector("canvas").getContext("2d");

  	    new Chart(ctx, {
  	      type: "line",
  	      data: {
  	        datasets: dataByParam.map((d) => ({
  	          label: d.label,
  	          data: d.data,
  	          borderColor: d.color,
  	          borderWidth: 1.8,
  	          pointRadius: 0,
  	          tension: 0.25,
  	        })),
  	      },
  	      options: {
  	        scales: {
  	          x: {
  	            type: "time",
  	            min: Math.min(...timeAxis),
  	            max: Math.max(...timeAxis),
  	            time: {
  	              tooltipFormat: "HH:mm:ss",
  	              displayFormats: {
  	                minute: "HH:mm",
  	                second: "HH:mm:ss",
  	              },
  	            },
  	            title: {
  	              display: true, text: "Time"
  	            },
  	            ticks: {
  	              autoSkip: true,
  	              maxTicksLimit: 8,
  	              callback: (val) => {
  	                const d = new Date(val);
  	                return d.toLocaleTimeString([], {
  	                  hour: "2-digit",
  	                  minute: "2-digit",
  	                  second: "2-digit",
  	                });
  	              },
  	            },
  	          },
  	          y: {
  	            min: 0,
  	            max: 100,
  	            title: {
  	              display: true, text: "Normalized %"
  	            },
  	          },
  	        },
  	        plugins: {
  	          legend: {
  	            position: "top"
  	          },
  	        },
  	      },
  	    });
  	  }

  	  function addGraphSelector() {
  	    const container = byId("rog-graph-list");

  	    // Create graph block wrapper
  	    const graphDiv = el("div");
  	    graphDiv.className = "rog-graph-block";
  	    graphDiv.style.cssText = `
  	    background:#181818;
  	    padding:8px;
  	    border-radius:6px;
  	    border:1px solid #333;
  	    display:flex;
  	    flex-direction:column;
  	    gap:6px;
  	    `;


  	    // === Header Row (Add + Remove)
  	    const headerRow = el("div");
  	    headerRow.style.cssText = `
  	    display:flex;
  	    align-items:center;
  	    justify-content:flex-end;
  	    margin-bottom:4px;
  	    `;

  	    const addParamBtn = el("button");
  	    addParamBtn.style.cssText = `
  	    display:none;
  	    align-items:center;
  	    gap:6px;
  	    background:#222;
  	    border:1px solid #555;
  	    color:#fff;
  	    font-size:12px;
  	    padding:5px 8px;
  	    border-radius:4px;
  	    cursor:pointer;
  	    `;
  	    addParamBtn.innerHTML = `
  	    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 64 64" style="fill:#fff;">
  	    <path d="M32,6C17.641,6,6,17.641,6,32s11.641,26,26,26s26-11.641,26-26S46.359,6,32,6z M49,34l-14,1l-1,14h-4l-1-14l-14-1v-4l14-1	l1-14h4l1,14l14,1V34z"></path>
  	    </svg>
  	    <span>Add Parameter</span>
  	    `;

  	    const removeGraphBtn = el("button");
  	    removeGraphBtn.textContent = "✖";
  	    removeGraphBtn.style.cssText = `
  	    background:none;
  	    border:none;
  	    color:#fff;
  	    font-size:16px;
  	    cursor:pointer;
  	    line-height:1;
  	    `;

  	    headerRow.append(addParamBtn, removeGraphBtn);

  	    // === Parameter List
  	    const paramList = el("div");
  	    paramList.className = "param-list";
  	    paramList.style.cssText = `
  	    display:flex;
  	    flex-direction:column;
  	    gap:4px;
  	    `;


  	    // === Add Row Helper
  	    function addParamRow(selectedKey = "", color) {
  	      // 🎨 Generate a random vivid HSL color if none specified
  	      if (!color) {
  	        const hue = Math.floor(Math.random() * 360); // 0–359°
  	        const sat = 70 + Math.random() * 20; // 70–90%
  	        const light = 45 + Math.random() * 10; // 45–55%
  	        color = hslToHex(hue, sat, light); // Convert to HEX for color input
  	      }

  	      const row = el("div");
  	      row.style.cssText = `
  	      display:flex;
  	      align-items:center;
  	      gap:6px;
  	      justify-content:space-between;
  	      `;

  	      const select = el("select");
  	      select.style.cssText = `
  	      flex:1;
  	      background:#181818;
  	      color:#eee;
  	      border:1px solid #333;
  	      padding:4px 6px;
  	      border-radius:4px;
  	      font-size:12px;
  	      `;
  	      select.innerHTML =
  	      '<option value="">Select parameter…</option>' +
  	      graphableParams
  	      .map(
  	        (p) =>
  	        `<option value="${p.key}" ${
  	        p.key === selectedKey ? "selected": ""
  	        }>${p.label}</option>`
  	      )
  	      .join("");

  	      const colorInput = el("input");
  	      colorInput.type = "color";
  	      colorInput.value = color;
  	      colorInput.style.cssText = `
  	      width:28px;
  	      height:24px;
  	      cursor:pointer;
  	      `;

  	      const removeBtn = el("button");
  	      removeBtn.textContent = "✖";
  	      removeBtn.style.cssText = `
  	      display:none;
  	      background:#222;
  	      border:1px solid #444;
  	      color:#ccc;
  	      font-size:12px;
  	      padding:3px 6px;
  	      border-radius:4px;
  	      cursor:pointer;
  	      `;
  	      removeBtn.onclick = () => row.remove();

  	      row.append(select, colorInput, removeBtn);
  	      paramList.appendChild(row);
  	    }

  	    // === Color Conversion Helper (for random vivid graph colors)
  	    function hslToHex(h, s, l) {
  	      s /= 100;
  	      l /= 100;
  	      const k = n => (n + h / 30) % 12;
  	      const a = s * Math.min(l, 1 - l);
  	      const f = n =>
  	      l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  	      const toHex = x => Math.round(x * 255).toString(16).padStart(2, "0");
  	      return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
  	    }

  	    // Add first parameter by default
  	    addParamRow();

  	    // Wire up header buttons
  	    addParamBtn.onclick = () => addParamRow();
  	    removeGraphBtn.onclick = () => {
  	      graphDiv.remove();
  	      updateCompareGraphsButtonVisibility();
  	    };

  	    // Build block
  	    graphDiv.append(headerRow, paramList);
  	    container.appendChild(graphDiv);

  	    updateCompareGraphsButtonVisibility();
  	  }

  	  left.appendChild(graphWrap);

  	  // ✅ defer binding until the overlay actually exists in the live DOM
  	  setTimeout(() => {
  	    const addBtn = document.getElementById("rog-add-graph");
  	    const cmpBtn = document.getElementById("rog-compare-graphs");

  	    if (addBtn) addBtn.onclick = addGraphSelector;
  	    if (cmpBtn) cmpBtn.onclick = openCompareGraphsModal;
  	  },
  	    0);


  	  // === RIGHT PANEL ==========================================================
  	  const right = el("div");
  	  right.style.cssText = `background:#dcdcdc;overflow:auto;padding:20px;`;
  	  const preview = el("div");
  	  preview.id = "rog-preview";
  	  preview.style.cssText = `
  	  background:#fff;border-radius:8px;padding:24px;min-height:100%;
  	  color:#222;font-size:13px;max-width:1100px;margin:0 auto;
  	  `;
  	  right.appendChild(preview);

  	  popup.append(left,
  	    right);
  	  overlay.appendChild(popup);
  	  document.body.appendChild(overlay);


  	  // === STYLE ================================================================
  	  const styleTag = document.createElement("style");
  	  styleTag.textContent = `
  	  @page { size: A4 landscape; margin: 10mm; }

  	  /* 🧱 Smart page control per category */
  	  .category-block {
  	  page-break-inside: avoid;
  	  break-inside: avoid;
  	  margin-bottom: 8px;
  	  }

  	  @media print {
  	  #rog-preview table.event-summary-table col {
  	  min-width: inherit;
  	  }
  	  }

  	  /* === 🧱 v8.3.6b: Hard Group Lock Fix === */
  	  .category-block {
  	  page-break-before: auto !important;
  	  page-break-after: auto !important;
  	  page-break-inside: avoid !important;
  	  break-inside: avoid !important;
  	  transform: translateZ(0);
  	  display: block;
  	  overflow: visible !important;
  	  position: relative;
  	  }

  	  /* Stronger print lock for smaller tables like Motion */
  	  @media print {
  	  .category-block {
  	  display: block !important;
  	  float: none !important;
  	  overflow: visible !important;
  	  }
  	  .category-block h3 { page-break-after: avoid !important; }
  	  .category-group {
  	  page-break-inside: avoid !important;
  	  break-inside: avoid !important;
  	  display: block !important;
  	  }
  	  }

  	  /* Allow certain blocks to split */
  	  .category-block.split-ok {
  	  page-break-inside: auto;
  	  break-inside: auto;
  	  }
  	  .category-block h3 { margin-top: 6px; page-break-after: avoid; }

  	  /* === 🌀 Spinner Animation === */
  	  @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

  	  /* === Table Base Styles === */
  	  /* === 🧱 Table Base Styles (Alignment Fix) === */
  	  #rog-preview table {
  	  width:100%;
  	  border-collapse:collapse;
  	  table-layout:fixed;
  	  border-spacing:0;
  	  }

  	  #rog-preview table th,
  	  #rog-preview table td {
  	  text-align:left !important;
  	  padding:4px 6px;
  	  border-bottom:1px solid #eee;
  	  font-size:12px;
  	  vertical-align:top;
  	  word-break:break-word;
  	  }

  	  /* === 🧭 LOCATION TABLE — FLEET IN FORM LAYOUT === */
  	  #rog-preview table.loc-table {
  	  table-layout: fixed !important;
  	  width: 100% !important;
  	  border-collapse: collapse !important;
  	  }

  	  #rog-preview table.loc-table thead tr {
  	  background: #f7f0ea !important;
  	  border-top: 2px solid #cc6b33;
  	  border-bottom: 1px solid #d8b9a3;
  	  }

  	  #rog-preview table.loc-table th {
  	  color: #5a2a14;
  	  font-weight: 700;
  	  }

  	  #rog-preview table.loc-table th,
  	  #rog-preview table.loc-table td {
  	  white-space: normal !important;
  	  overflow: visible !important;
  	  text-overflow: unset !important;
  	  word-break: normal !important;
  	  overflow-wrap: anywhere !important;
  	  line-height: 1.18;
  	  font-size: 10.5px;
  	  padding: 3px 4px;
  	  vertical-align: top;
  	  }

  	  #rog-preview table.loc-table th:nth-child(1),
  	  #rog-preview table.loc-table td:nth-child(1) {
  	  width: 16%;
  	  }

  	  #rog-preview table.loc-table th:nth-child(2),
  	  #rog-preview table.loc-table td:nth-child(2),
  	  #rog-preview table.loc-table th:nth-child(3),
  	  #rog-preview table.loc-table td:nth-child(3) {
  	  width: 18%;
  	  }

  	  #rog-preview table.loc-table th:nth-child(4),
  	  #rog-preview table.loc-table td:nth-child(4) {
  	  width: 10%;
  	  text-align: center !important;
  	  }

  	  #rog-preview table.loc-table th:nth-child(5),
  	  #rog-preview table.loc-table td:nth-child(5),
  	  #rog-preview table.loc-table th:nth-child(6),
  	  #rog-preview table.loc-table td:nth-child(6),
  	  #rog-preview table.loc-table th:nth-child(7),
  	  #rog-preview table.loc-table td:nth-child(7) {
  	  width: 7%;
  	  text-align: center !important;
  	  font-size: 10px;
  	  }

  	  #rog-preview table.loc-table th:nth-child(8),
  	  #rog-preview table.loc-table td:nth-child(8) {
  	  width: 17%;
  	  font-size: 10px;
  	  }

  	  #rog-preview table.loc-table tr.loc-row {
  	  background: #fff4ec !important;
  	  }

  	  #rog-preview table.loc-table tr.loc-row:nth-child(even) {
  	  background: #fffaf6 !important;
  	  }

  	  #rog-preview table.loc-table tr.loc-row td:first-child {
  	  border-left: 4px solid #cc6b33;
  	  font-weight: 600;
  	  color: #3b1b0d;
  	  }

  	  #rog-preview table.loc-table .loc-type {
  	  color: #3b1b0d;
  	  font-weight: 600;
  	  }
  	  #rog-preview table thead tr { background:#f7f0ea; }

  	  /* === 🧾 Print Visibility Rules === */
  	  @media print {
  	  html, body { margin:0; padding:0; background:#fff; }
  	  #rog-event-overlay, #rog-event-overlay * { visibility:hidden; }
  	  #rog-preview, #rog-preview * { visibility:visible; }
  	  #rog-preview {
  	  position:absolute; left:0; top:0; width:100%;
  	  background:#fff; color:#000;
  	  }

  	  /* ✅ Keep all <details> expanded and visible */
  	  details[open] summary::before {
  	  content: "▼ ";
  	  }
  	  details {
  	  display: block !important;
  	  }
  	  details[open] > summary::before {
  	  content: "▼ ";
  	  }
  	  details > summary {
  	  list-style: none;
  	  }
  	  details[open] > * {
  	  display: block !important;
  	  visibility: visible !important;
  	  }
  	  }

  	  /* === 🧱 PAGE-BREAK CONTROL — Fix B === */
  	  #rog-preview > div,
  	  .print-section,
  	  #rog-preview section,
  	  #rog-preview table,
  	  #rog-preview details {
  	  page-break-inside: avoid;
  	  break-inside: avoid;
  	  }

  	  /* Tables may break *between* rows if they’re huge */
  	  #rog-preview table {
  	  break-inside: avoid;
  	  page-break-inside: avoid;
  	  }

  	  /* === 🧱 PRINT SECTION COMPRESSION FIX === */
  	  .print-section {
  	  margin-top: 4px !important;
  	  margin-bottom: 6px !important;
  	  page-break-before: auto !important;
  	  page-break-after: auto !important;
  	  page-break-inside: avoid !important;
  	  break-inside: avoid !important;
  	  }

  	  /* ✅ Allow Event Summary to sit under Driver Info if room allows */
  	  .print-section.driver-info {
  	  page-break-after: auto !important;   /* allow flow-through */
  	  page-break-inside: avoid !important; /* keep driver block itself intact */
  	  break-inside: avoid !important;
  	  margin-bottom: 4px !important;       /* give a tiny cushion */
  	  }


  	  /* ✅ Allow Event Summary to flow under Driver Info on same page */
  	  .print-section.event-summary {
  	  page-break-before: auto !important;
  	  page-break-inside: auto !important;
  	  break-inside: auto !important;
  	  margin-top: 4px !important;
  	  }

  	  /* 🧩 Hide invisible baseline tables but keep structure for Chrome width caching */
  	  #rog-preview table.baseline-grid {
  	  display: none !important;
  	  visibility: collapse !important;
  	  height: 0 !important;
  	  margin: 0 !important;
  	  padding: 0 !important;
  	  border: 0 !important;
  	  }


  	  /* lock category blocks harder */
  	  .category-block {
  	  page-break-inside: avoid !important;
  	  break-inside: avoid !important;
  	  margin-bottom: 6px !important;
  	  }
  	  .category-block.split-ok {
  	  page-break-inside: auto !important;
  	  break-inside: auto !important;
  	  }

  	  /* === 🧱 PAGE FIT CONTROL — Prevent graph/map cutoff (Works in html2pdf too) === */
  	  .rog-graph,
  	  #rog-map-snapshot {
  	  page-break-inside: avoid !important;
  	  break-inside: avoid !important;
  	  margin-top: 12px;
  	  margin-bottom: 12px;
  	  }

  	  /* 💡 html2pdf-specific hack: wrap each heavy element in a block with page-break-before if needed */
  	  .rog-graph,
  	  #rog-map-snapshot {
  	  display: block;
  	  overflow: hidden;
  	  }
  	  .rog-graph::after,
  	  #rog-map-snapshot::after {
  	  content: "";
  	  display: block;
  	  height: 0;
  	  page-break-after: always !important;
  	  break-after: always !important;
  	  }

  	  /* === 🧾 v8.3.9 — Fixed 7-Column Grid (Main Event Summary Tables Only) === */
  	  #rog-preview table.main-summary-table:not(.loc-table) {
  	  table-layout: fixed !important;
  	  width: 100% !important;
  	  border-collapse: collapse !important;
  	  border-spacing: 0;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th,
  	  #rog-preview table.main-summary-table:not(.loc-table) td {
  	  padding: 4px 6px;
  	  font-size: 12px;
  	  vertical-align: top;
  	  border-bottom: 1px solid #eee;
  	  overflow: hidden;
  	  white-space: nowrap;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(1),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(1) {
  	  width: 20%;
  	  text-align: left;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(2),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(2) {
  	  width: 15%;
  	  text-align: center;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(3),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(3) {
  	  width: 15%;
  	  text-align: center;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(4),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(4) {
  	  width: 10%;
  	  text-align: center;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(5),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(5) {
  	  width: 15%;
  	  text-align: center;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(6),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(6) {
  	  width: 12.5%;
  	  text-align: center;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(7),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(7) {
  	  width: 12.5%;
  	  text-align: center;
  	  }
  	  #rog-preview table.event-summary-table thead {
  	  display: table-header-group !important;
  	  }
  	  #rog-preview table.event-summary-table tbody {
  	  page-break-inside: avoid !important;
  	  break-inside: avoid !important;
  	  }

  	  /* === PRINT ONLY: Event Summary alignment lock === */
  	  @media print {
  	  #rog-preview table.main-summary-table:not(.loc-table) {
  	  width: 100% !important;
  	  table-layout: fixed !important;
  	  border-collapse: collapse !important;
  	  border-spacing: 0 !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) col:nth-child(1) { width: 20% !important; }
  	  #rog-preview table.main-summary-table:not(.loc-table) col:nth-child(2) { width: 15% !important; }
  	  #rog-preview table.main-summary-table:not(.loc-table) col:nth-child(3) { width: 15% !important; }
  	  #rog-preview table.main-summary-table:not(.loc-table) col:nth-child(4) { width: 10% !important; }
  	  #rog-preview table.main-summary-table:not(.loc-table) col:nth-child(5) { width: 15% !important; }
  	  #rog-preview table.main-summary-table:not(.loc-table) col:nth-child(6) { width: 12.5% !important; }
  	  #rog-preview table.main-summary-table:not(.loc-table) col:nth-child(7) { width: 12.5% !important; }

  	  #rog-preview table.main-summary-table:not(.loc-table) th,
  	  #rog-preview table.main-summary-table:not(.loc-table) td {
  	  display: table-cell !important;
  	  box-sizing: border-box !important;
  	  padding: 2.5px 4px !important;
  	  font-size: 10px !important;
  	  line-height: 1.15 !important;
  	  vertical-align: top !important;
  	  overflow: hidden !important;
  	  text-overflow: ellipsis !important;
  	  white-space: nowrap !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(1),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(1) {
  	  width: 20% !important;
  	  text-align: left !important;
  	  white-space: normal !important;
  	  overflow-wrap: anywhere !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(2),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(2) {
  	  width: 15% !important;
  	  text-align: center !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(3),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(3) {
  	  width: 15% !important;
  	  text-align: center !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(4),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(4) {
  	  width: 10% !important;
  	  text-align: center !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(5),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(5) {
  	  width: 15% !important;
  	  text-align: center !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(6),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(6) {
  	  width: 12.5% !important;
  	  text-align: center !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(7),
  	  #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(7) {
  	  width: 12.5% !important;
  	  text-align: center !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) thead {
  	  display: table-header-group !important;
  	  }

  	  #rog-preview table.main-summary-table:not(.loc-table) tr {
  	  page-break-inside: avoid !important;
  	  break-inside: avoid !important;
  	  }
  	  }

  	  `;

  	  document.head.appendChild(styleTag);


  	  // === SECTION BUILDERS =====================================================
  	  const sectionHeader = (title) => `
  	  <div style="margin-top:20px;margin-bottom:8px;display:flex;align-items:center;gap:10px;">
  	  <div style="width:32px;height:4px;background:#cc6b33;border-radius:4px;"></div>
  	  <h2 style="margin:0;color:#cc6b33;font-size:15px;">${title}</h2>
  	  </div>
  	  `;

  	  const sectionFooter = (note) => `
  	  <div style="margin-top:6px;font-size:10px;color:#999;">${note || ""}</div>
  	  `;

  	  /* 🧾 HEADER SECTION — now with print-header class so it repeats on every page */
  	  const buildHeaderSection = () => {
  	    // 🧩 Detect inline vs data-url form
  	    let iconHTML = "";
  	    if (svg) {
  	      if (svg.trim().startsWith("<svg")) {
  	        // Inject scaling and aspect ratio handling
  	        const cleaned = svg
  	        // add preserveAspectRatio if missing
  	        .replace(
  	          /<svg(?![^>]*preserveAspectRatio)/i,
  	          '<svg preserveAspectRatio="xMidYMid meet"'
  	        )
  	        // inject responsive sizing style
  	        .replace(
  	          /<svg([^>]*?)>/i,
  	          '<svg$1 style="height:1.8em;width:auto;max-width:2.4em;display:block;" >'
  	        );
  	        iconHTML = cleaned;
  	      } else if (svg.startsWith("data:image")) {
  	        iconHTML = `<img src="${svg}" style="height:1.8em;width:auto;display:block;">`;
  	      }
  	    }

  	    const name = tractor.FID || "Tractor Report";
  	    const sub = tractor.Registration || tractor.FVC?.ID || "";

  	    return `
  	    <div class="print-header" style="
  	    display:flex;
  	    justify-content:space-between;
  	    align-items:center;
  	    margin-bottom:6px;
  	    ">
  	    <div style="display:flex;align-items:center;gap:8px;">
  	    ${iconHTML
  	    ? `<div style="display:flex;align-items:center;justify-content:center;line-height:0;">${iconHTML}</div>`: ""}
  	    <div>
  	    <div style="font-size:16px;font-weight:600;color:#cc6b33;">${name}</div>
  	    <div style="font-size:11px;color:#777;">${sub}</div>
  	    </div>
  	    </div>
  	    <div style="
  	    width:48px;
  	    height:8px;
  	    background:${tractor.color || "#ffa347"};
  	    border-radius:4px;
  	    "></div>
  	    </div>
  	    <hr style="border:none;border-top:2px solid #cc6b33;margin:4px 0 10px 0;" />
  	    `;
  	  };

  	  /* 🧮 TRIP SUMMARY */
  	const buildTripSummary = () => {
  	  const track = Array.isArray(tractor.Tracking) ? tractor.Tracking: [];
  	  const {
  	    startTs,
  	    endTs,
  	    tripDurationSec
  	  } = tripCtx;

  	  const points = track.length;
  	  const max = runEventsMax;

  	  // Fuel Used: calculate the trip consumption from the cumulative CAN counter.
  	  // Formula: last valid can.tracker.counted.fuel.consumed value minus first valid value.
  	  // Supports both flattened and nested tracking payloads, including point wrappers.
  	  const countedFuelPath = "can.tracker.counted.fuel.consumed";
  	  const readPath = (obj, path) => {
  	    if (!obj) return undefined;
  	    if (Object.prototype.hasOwnProperty.call(obj, path)) return obj[path];
  	    return path.split(".").reduce((value, key) => value?.[key], obj);
  	  };

  	  const toFiniteNumber = (raw) => {
  	    if (raw == null || raw === "") return null;
  	    const value = Number(raw);
  	    return Number.isFinite(value) ? value: null;
  	  };

  	  const readCountedFuel = (entry) => {
  	    const raw =
  	    readPath(entry, countedFuelPath) ??
  	    readPath(entry?.point, countedFuelPath);
  	    return toFiniteNumber(raw);
  	  };

  	  const countedFuelValues = track
  	  .map(readCountedFuel)
  	  .filter((value) => value !== null);

  	  const firstCountedFuel = countedFuelValues.length
  	  ? countedFuelValues[0]: null;
  	  const lastCountedFuel = countedFuelValues.length
  	  ? countedFuelValues[countedFuelValues.length - 1]: null;

  	  const countedFuelDifference =
  	  firstCountedFuel !== null && lastCountedFuel !== null
  	  ? lastCountedFuel - firstCountedFuel: null;

  	  const fuelUsed = countedFuelDifference !== null
  	  ? Number(countedFuelDifference.toFixed(2))
  	  : (max.FuelL ?? "—");

  	  return `
  	  ${sectionHeader("Trip Summary")}

  	  <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:12px;">
  	  <div><b>Start</b><br>${startTs ? new Date(startTs * 1000).toLocaleString(): "—"}</div>
  	  <div><b>End</b><br>${endTs ? new Date(endTs * 1000).toLocaleString(): "—"}</div>
  	  <div><b>Duration</b><br>${formatMinutesSeconds(tripDurationSec)}</div>
  	  <div><b>Points</b><br>${points}</div>
  	  </div>

  	  <div style="margin-top:12px;display:grid;grid-template-columns:repeat(3,1fr);gap:10px;font-size:12px;">
  	  <div><b>Max Speed</b><br>${max.Speed ?? "—"} km/h</div>
  	  <div><b>Max RPM</b><br>${max.RPM ?? "—"}</div>
  	  <div><b>Max Temp</b><br>${max.Temp ?? "—"}°</div>
  	  <div><b>Idle</b><br>${max.IdleFmt || (max.IdleSec ? formatDuration(max.IdleSec): "—")}</div>
  	  <div><b>Distance</b><br>${max.DistKm ?? "—"} km</div>
  	  <div><b>Fuel Used</b><br>${fuelUsed} L</div>
  	  </div>

  	  ${sectionFooter("Trip summary uses tracking timestamps and Events.Max snapshot")}
  	  `;
  	};

  	  /* 👤 DRIVER INFORMATION */
  	  const buildDriverInfo = () => {
  	    const fvc = tractor.FVC || tractor.fvc || {};
  	    const d1 = fvc.Driver1 || fvc.Driver || {};
  	    const dd = d1.Data_Details || d1.data_details || {};
  	    const emp = dd.employee_details || {};
  	    const contact = emp.contact_details || {};
  	    const name =
  	    d1.name ||
  	    d1.Name ||
  	    `${emp.first_name || ""} ${emp.last_name || ""}`.trim() ||
  	    "—";

  	    return `
  	    ${sectionHeader("Driver Information")}
  	    <div>
  	    <b>Name:</b> ${name}<br>
  	    <b>Phone:</b> ${contact.phone_number || "—"}<br>
  	    <b>Email:</b> ${contact.email || "—"}
  	    </div>
  	    ${sectionFooter(
  	      "Driver pulled from FVC → Driver1 → Data_Details → employee_details → contact_details"
  	    )}
  	    `;
  	  };

  	  async function captureMapImage(mapComp) {
  	    try {
  	      // Prefer native snapshot if available
  	      if (mapComp?.takeSnapshot) {
  	        return await mapComp.takeSnapshot({
  	          format: "image/png",
  	          quality: 0.92,
  	        });
  	      }

  	      const map = mapComp?.map || mapComp;
  	      if (!map) {
  	        console.warn("⚠️ captureMapImage: no map object found");
  	        return null;
  	      }

  	      const mapDiv =
  	      map.getDiv?.() ||
  	      document.querySelector(".gm-style") ||
  	      document.querySelector(".mapboxgl-map");
  	      if (!mapDiv) {
  	        console.warn("⚠️ captureMapImage: no map div found");
  	        return null;
  	      }

  	      // 🧹 Step 0: clean up any previous clones
  	      mapDiv.querySelectorAll("[data-temp-iw]").forEach(el => el.remove());

  	      // 🧠 Step 1: search *only within this map* for its InfoWindows
  	      const gmContainer = mapDiv.closest(".gm-style") || mapDiv;
  	      const visibleIWs = Array.from(gmContainer.querySelectorAll(".gm-style-iw")).filter(
  	        iw => {
  	          const style = window.getComputedStyle(iw);
  	          const visible =
  	          style.display !== "none" &&
  	          style.visibility !== "hidden" &&
  	          iw.offsetWidth > 20 &&
  	          iw.offsetHeight > 20;
  	          return visible;
  	        }
  	      );

  	      const mapRect = mapDiv.getBoundingClientRect();
  	      const clones = [];

  	      // 🧩 Step 2: clone only visible InfoWindows belonging to this map
  	      visibleIWs.forEach(iw => {
  	        const rect = iw.getBoundingClientRect();
  	        const clone = iw.cloneNode(true);
  	        clone.dataset.tempIw = "true";
  	        clone.style.position = "absolute";
  	        clone.style.pointerEvents = "none";
  	        clone.style.zIndex = "9999";
  	        clone.style.left = rect.left - mapRect.left + "px";
  	        clone.style.top = rect.top - mapRect.top + "px";
  	        clone.style.transform = "scale(0.95)";
  	        clone.style.transformOrigin = "top left";
  	        clone.style.opacity = "0.95";
  	        mapDiv.appendChild(clone);
  	        clones.push(clone);
  	      });

  	      // 🖼️ Step 3: capture tiles + overlay
  	      const canvas = await html2canvas(mapDiv, {
  	        useCORS: true,
  	        backgroundColor: "#fff",
  	        scale: 2,
  	        logging: false,
  	        foreignObjectRendering: false,
  	        removeContainer: true,
  	      });

  	      // 🧹 Step 4: remove cloned overlays
  	      clones.forEach(c => c.remove());

  	      return canvas.toDataURL("image/png");
  	    } catch (err) {
  	      console.error("❌ captureMapImage failed:", err);
  	      return null;
  	    }
  	  }


  	  // === MAP SNAPSHOT BUILDER (with caching) ====================================
  	  async function buildMapSnapshot(mapComp) {
  	    try {
  	      // ✅ If we already have a cached snapshot, reuse it
  	      if (cachedMapSnapshot) {
  	        return cachedMapSnapshot;
  	      }

  	      // Otherwise capture a fresh image
  	      const img = await captureMapImage(mapComp);
  	      if (!img) {
  	        console.warn("⚠️ buildMapSnapshot: captureMapImage returned null");
  	        return null;
  	      }

  	      // Cache it for later use
  	      cachedMapSnapshot = img;
  	      return img;

  	    } catch (err) {
  	      return null;
  	    }
  	  }

  	  // === ITEMIZED LIST BUILDER =================================================
  	  function buildItemizedList(eventName, rows) {
  	    if (!Array.isArray(rows) || !rows.length) return "";

  	    // --- Idle Event special renderer ---
  	    if (eventName === "Idle Event") {
  	      return buildIdleItemizedList(eventName, rows);
  	    }

  	    const limited = rows.slice(0, 100); // safety cap
  	    const totalTripMeters = tripCtx.tripDistanceMeters;
  	    const tripDurSec = tripCtx.tripDurationSec;

  	    let inner = `
  	    <details ${itemizedEvents.has(eventName) ? "open": ""} style="margin:4px 0 10px 0;">
  	    <summary style="cursor:pointer;font-size:12px;color:#cc6b33;">
  	    Itemized: ${eventName} (${rows.length} ${rows.length === 1 ? "entry": "entries"})
  	    </summary>
  	    <div style="overflow-x:auto;margin-top:6px;">
  	    <table class="event-summary-table" style="width:100%;border-collapse:collapse;font-size:12px;margin-bottom:4px;">
  	    <thead>
  	    <tr style="background:#f3f3f3;">
  	    <th>#</th>
  	    <th>Time</th>
  	    <th>Duration</th>
  	    <th>Max</th>
  	    <th>Value</th>
  	    <th>Distance</th>
  	    <th>% of Trip</th>
  	    <th>% of Time</th>
  	    </tr>
  	    </thead>
  	    <tbody>
  	    `;

  	    limited.forEach((row, idx) => {
  	      const p = Array.isArray(row.Points) ? row.Points[0]: null;
  	      const ts = p?.timestamp || row.timestamp || row.Time || row.time || null;
  	      const durSec = row.duration != null ? row.duration: 0;
  	      const dur = formatDuration(durSec);
  	      const mx = row.Max ?? row.max ?? "—";
  	      const value = p?.value ?? row.value ?? "—";
  	      const distMeters = row.distance || row.Distance || row.dist || row.distance_m || 0;
  	      const distStr = formatDistanceMeters(distMeters);
  	      const pctTrip = totalTripMeters ? pct(distMeters, totalTripMeters): "0.00%";
  	      const pctTime = tripDurSec ? pct(durSec, tripDurSec): "0.00%";

  	      inner += `
  	      <tr>
  	      <td>${idx + 1}</td>
  	      <td>${ts ? new Date(ts * 1000).toLocaleString(): "—"}</td>
  	      <td>${dur}</td>
  	      <td>${mx}</td>
  	      <td>${value}</td>
  	      <td>${distStr}</td>
  	      <td>${pctTrip}</td>
  	      <td>${pctTime}</td>
  	      </tr>
  	      `;
  	    });

  	    inner += `
  	    </tbody>
  	    </table>
  	    ${rows.length > 100 ? '<div style="font-size:10px;color:#999;margin-top:4px;">Showing first 100 entries…</div>': ""}
  	    </div>
  	    </details>
  	    `;

  	    return inner;
  	  }

  	  function buildIdleItemizedList(eventName, rows) {
  	    if (!Array.isArray(rows) || !rows.length) return "";

  	    const limited = rows.slice(0, 100);
  	    const tripDurSec = tripCtx.tripDurationSec;

  	    let inner = `
  	    <details ${itemizedEvents.has(eventName) ? "open": ""} style="margin:4px 0 10px 0;">
  	    <summary style="cursor:pointer;font-size:12px;color:#cc6b33;">
  	    Itemized: ${eventName} (${rows.length} ${rows.length === 1 ? "entry": "entries"})
  	    </summary>
  	    <div style="overflow-x:auto;margin-top:6px;">
  	    <table class="event-summary-table" style="width:100%;border-collapse:collapse;font-size:12px;margin-bottom:4px;">
  	    <thead>
  	    <tr style="background:#f3f3f3;">
  	    <th>#</th>
  	    <th>Start</th>
  	    <th>Idle</th>
  	    <th>% of Time</th>
  	    <th>Lat</th>
  	    <th>Lon</th>
  	    </tr>
  	    </thead>
  	    <tbody>
  	    `;

  	    limited.forEach((row, idx) => {
  	      const p = Array.isArray(row.Points) ? row.Points[0]: null;

  	      const ts =
  	      row.start ||
  	      (row.start_iso ? Math.floor(new Date(row.start_iso).getTime() / 1000): null) ||
  	      p?.timestamp ||
  	      row.timestamp ||
  	      null;

  	      const idleSec = Number(row.idle_seconds) || 0;
  	      const idleText = row.idle_human || formatDuration(idleSec);
  	      const pctTime = tripDurSec ? pct(idleSec, tripDurSec): "0.00%";

  	      const lat =
  	      p?.lat ??
  	      p?.latitude ??
  	      p?.["position.latitude"] ??
  	      row.lat ??
  	      row.latitude ??
  	      null;

  	      const lon =
  	      p?.lon ??
  	      p?.lng ??
  	      p?.longitude ??
  	      p?.["position.longitude"] ??
  	      row.lon ??
  	      row.lng ??
  	      row.longitude ??
  	      null;

  	      inner += `
  	      <tr>
  	      <td>${idx + 1}</td>
  	      <td>${ts ? new Date(ts * 1000).toLocaleString(): "—"}</td>
  	      <td>${idleText}</td>
  	      <td>${pctTime}</td>
  	      <td>${lat != null && !isNaN(lat) ? Number(lat).toFixed(5): "—"}</td>
  	      <td>${lon != null && !isNaN(lon) ? Number(lon).toFixed(5): "—"}</td>
  	      </tr>
  	      `;
  	    });

  	    inner += `
  	    </tbody>
  	    </table>
  	    ${rows.length > 100 ? '<div style="font-size:10px;color:#999;margin-top:4px;">Showing first 100 entries…</div>': ""}
  	    </div>
  	    </details>
  	    `;

  	    return inner;
  	  }


  	  function buildIdleInlineTable(rows) {
  	    if (!Array.isArray(rows) || !rows.length) return "";

  	    const limited = rows.slice(0, 100);
  	    const tripDurSec = tripCtx.tripDurationSec;

  	    let html = `
  	    <div style="margin:6px 0 10px 0;">
  	    <div style="font-weight:700;font-size:16px;margin:0 0 6px 0;color:#222;">Idle Events</div>
  	    <table class="event-summary-table idle-table" style="width:100%;border-collapse:collapse;font-size:12px;margin-bottom:4px;">
  	    <colgroup>
  	    <col style="width:28%;">
  	    <col style="width:28%;">
  	    <col style="width:22%;">
  	    <col style="width:22%;">
  	    </colgroup>
  	    <thead>
  	    <tr style="background:#f7f0ea;">
  	    <th>Start</th>
  	    <th>End</th>
  	    <th>Duration</th>
  	    <th>% of Time</th>
  	    </tr>
  	    </thead>
  	    <tbody>
  	    `;

  	    limited.forEach((row) => {
  	      const pts = Array.isArray(row.Points) ? row.Points: [];
  	      const first = pts[0] || null;

  	      const startTs =
  	      row.start ||
  	      (row.start_iso ? Math.floor(new Date(row.start_iso).getTime() / 1000): null) ||
  	      first?.timestamp ||
  	      null;

  	      const idleSec = Number(row.idle_seconds) || 0;
  	      const endTs = startTs != null ? startTs + idleSec: null;
  	      const pctTime = tripDurSec ? pct(idleSec, tripDurSec): "0.00%";

  	      html += `
  	      <tr style="background:#fff7ea;">
  	      <td>${startTs ? new Date(startTs * 1000).toLocaleString(): "—"}</td>
  	      <td>${endTs ? new Date(endTs * 1000).toLocaleString(): "—"}</td>
  	      <td>${row.idle_human || formatDuration(idleSec)}</td>
  	      <td>${pctTime}</td>
  	      </tr>
  	      `;
  	    });

  	    html += `
  	    </tbody>
  	    </table>
  	    ${rows.length > 100 ? '<div style="font-size:10px;color:#999;margin-top:4px;">Showing first 100 idle entries…</div>': ""}
  	    </div>
  	    `;

  	    return html;
  	  }

  	  function buildEventSummary() {
  	    const totalTripMeters = tripCtx.tripDistanceMeters;
  	    const tripDurSec = tripCtx.tripDurationSec;

  	    // 1) ONE grid for normal event tables (7 columns)
  	    const colGroupEvents = `
  	    <colgroup>
  	    <col style="width:20%;">   <!-- Event -->
  	    <col style="width:15%;">   <!-- Occurrences -->
  	    <col style="width:15%;">   <!-- Duration -->
  	    <col style="width:10%;">   <!-- Max -->
  	    <col style="width:15%;">   <!-- Distance -->
  	    <col style="width:12.5%;"> <!-- % of Trip -->
  	    <col style="width:12.5%;"> <!-- % of Time -->
  	    </colgroup>
  	    `;

  	    // 2) ONE grid for location tables (8 columns)
  	    const colGroupLocations = `
  	    <colgroup>
  	    <col style="width:16%;">  <!-- Location -->
  	    <col style="width:18%;">  <!-- Start -->
  	    <col style="width:18%;">  <!-- End -->
  	    <col style="width:10%;">  <!-- Duration -->
  	    <col style="width:7%;">   <!-- Fuel Used -->
  	    <col style="width:7%;">   <!-- km/l -->
  	    <col style="width:7%;">   <!-- l/h -->
  	    <col style="width:17%;">  <!-- Type -->
  	    </colgroup>
  	    `;

  	    // 3) start building HTML
  	    let html = `
  	    ${sectionHeader("Event Summary")}

  	    <!-- invisible baseline table for normal events -->
  	    <table class="event-summary-table baseline-grid" style="display:none;">

  	    ${colGroupEvents}
  	    <thead>
  	    <tr>
  	    <th>Event</th>
  	    <th>Occurrences</th>
  	    <th>Duration</th>
  	    <th>Max</th>
  	    <th>Distance</th>
  	    <th>% of Trip</th>
  	    <th>% of Time</th>
  	    </tr>
  	    </thead>
  	    </table>

  	    <!-- invisible baseline table for LOCATION events -->
  	    <table class="event-summary-table loc-table baseline-grid" style="display:none;">
  	    ${colGroupLocations}
  	    <thead>
  	    <tr>
  	    <th>Location</th>
  	    <th>Start</th>
  	    <th>End</th>
  	    <th>Duration</th>
  	    <th>Fuel Used</th>
  	    <th>km/l</th>
  	    <th>l/h</th>
  	    <th>Type</th>
  	    </tr>
  	    </thead>
  	    </table>
  	    `;

  	    // sort categories so Locations stay last
  	    const sortedEntries = Object.entries(categoryMap).sort(([a], [b]) => {
  	      if (a === "Locations") return 1;
  	      if (b === "Locations") return -1;
  	      return a.localeCompare(b);
  	    });

  	    sortedEntries.forEach(([catName, events]) => {
  	      // filter by what user selected
  	      const filtered = events.filter((ev) => {
  	        if (selectedEventNames.size === 0) return true;
  	        return selectedEventNames.has(ev.name);
  	      });
  	      if (!filtered.length) return;

  	      const isLocations = catName === "Locations";

  	      html += `
  	      <div class="category-group">
  	      <div class="category-block ${isLocations ? "split-ok": ""}">
  	      <h3 style="margin:6px 0 4px 0;color:#333;font-size:13px;">${catName}</h3>
  	      <table class="event-summary-table main-summary-table ${isLocations ? "loc-table": ""}" style="width:100%;border-collapse:collapse;font-size:12px;margin-bottom:4px;">
  	      ${isLocations ? colGroupLocations: colGroupEvents}
  	      <thead>
  	      <tr style="background:#f7f0ea;">
  	      ${
  	      isLocations
  	      ? `
  	      <th>Location</th>
  	      <th>Start</th>
  	      <th>End</th>
  	      <th>Duration</th>
  	      <th>Fuel Used</th>
  	      <th>km/l</th>
  	      <th>l/h</th>
  	      <th>Type</th>
  	      `: `
  	      <th>Event</th>
  	      <th>Occurrences</th>
  	      <th>Duration</th>
  	      <th>Max</th>
  	      <th>Distance</th>
  	      <th>% of Trip</th>
  	      <th>% of Time</th>
  	      `
  	      }
  	      </tr>
  	      </thead>
  	      <tbody>
  	      `;

  	      // we will collect itemized HTML under the table
  	      let itemizedHtml = "";

  	      filtered.forEach((ev) => {
  	        // 4a) LOCATION ROWS
  	        if (ev._special === "LocationEvent") {
  	          html += `
  	          <tr class="loc-row">
  	          <td class="loc-name">${ev.name}</td>
  	          <td class="loc-date">${ev.time_in ? new Date(ev.time_in).toLocaleString(): "—"}</td>
  	          <td class="loc-date">${ev.time_out ? new Date(ev.time_out).toLocaleString(): "—"}</td>
  	          <td>${formatDuration(ev.duration || 0)}</td>
  	          <td>${ev.fuel_used ?? 0}</td>
  	          <td>${ev.km_per_litre ?? "—"}</td>
  	          <td>${ev.litres_per_hour ?? "—"}</td>
  	          <td class="loc-type">${ev.type_in} → ${ev.type_out}</td>
  	          </tr>
  	          `;
  	          return;
  	        }

  	        // 4b) NORMAL EVENT ROWS
  	        const r = runEvents[ev.name];
  	        let occ = "—",
  	        dur = "—",
  	        max = "—",
  	        distStr = "0",
  	        pctTrip = "0.00%",
  	        pctTime = "0.00%";

  	        if (Array.isArray(r) && r.length) {
  	          occ = r.length;

  	          const totalDurSec = r.reduce((a, b) => {
  	            if (ev.name === "Idle Event") {
  	              return a + (Number(b.idle_seconds) || 0);
  	            }
  	            return a + (Number(b.duration) || 0);
  	          },
  	            0);
  	          dur = formatDuration(totalDurSec);

  	          const maxList = r
  	          .map((x) => {
  	            if (ev.name === "Idle Event") {
  	              return x.idle_seconds ?? null;
  	            }
  	            return x.Max ?? x.max ?? null;
  	          })
  	          .filter((x) => x != null)
  	          .map((x) => (typeof x === "number" ? x: parseFloat(x)))
  	          .filter((x) => !isNaN(x));
  	          if (maxList.length) {
  	            max = ev.name === "Idle Event"
  	            ? formatDuration(Math.max(...maxList)): Math.max(...maxList).toFixed(2);
  	          }

  	          const totalDistMeters = r.reduce((a, b) => {
  	            const d = b.distance || b.Distance || b.dist || b.distance_m || 0;
  	            return a + d;
  	          }, 0);

  	          distStr = formatDistanceMeters(totalDistMeters);
  	          pctTrip = totalTripMeters ? pct(totalDistMeters, totalTripMeters): "0.00%";
  	          pctTime = tripDurSec ? pct(totalDurSec, tripDurSec): "0.00%";

  	          if (ev.name === "Idle Event") {
  	            itemizedHtml += buildIdleInlineTable(r);
  	          } else if (itemizedEvents.has(ev.name)) {
  	            itemizedHtml += buildItemizedList(ev.name, r);
  	          }
  	        }

  	        html += `
  	        <tr>
  	        <td>${ev.name}</td>
  	        <td>${occ}</td>
  	        <td>${dur}</td>
  	        <td>${max}</td>
  	        <td>${distStr}</td>
  	        <td>${pctTrip}</td>
  	        <td>${pctTime}</td>
  	        </tr>
  	        `;
  	      });

  	      html += `
  	      </tbody>
  	      </table>
  	      ${itemizedHtml}
  	      </div>
  	      </div>
  	      `;
  	    });

  	    return html;
  	  }


  	  // === FOOTER SECTION =========================================================
  	  function buildFooter() {
  	    const now = new Date();
  	    const dateStr = now.toLocaleString();

  	    return `
  	    <div class="print-footer" style="border-top:none !important;">
  	      <div style="
  	        width:100%;
  	        height:2px;
  	        background:#cc6b33;
  	        margin:0 0 6px 0;
  	      "></div>

  	      <div>
  	        Generated by <b>Fleet <span style="color:#cc6b33;font-weight:900;">In</span> Form Reporter</b> on ${dateStr}
  	      </div>
  	    </div>
  	    `;
  	  }

  	  // === RENDER PREVIEW (with async map spinner + page-break control) ============
  	  async function renderPreview() {
  	    const sec = {
  	      header: byId("sec-header").checked,
  	      trip: byId("sec-trip").checked,
  	      map: byId("sec-map").checked,
  	      driver: byId("sec-driver").checked,
  	      events: byId("sec-events").checked,
  	      footer: byId("sec-footer").checked,
  	    };

  	    let html = "";


  	    // --- HEADER ---------------------------------------------------------------
  	    if (sec.header)
  	      html += `<div class="print-section">${buildHeaderSection()}</div>`;

  	    // --- TRIP + DRIVER MERGED SECTION ----------------------------------------
  	    if (sec.trip || sec.driver) {
  	      html += `
  	      <div class="print-section trip-driver-combo">
  	      ${sec.trip ? buildTripSummary(): ""}
  	      ${sec.driver ? buildDriverInfo(): ""}
  	      </div>`;
  	    }

  	    // --- EVENT SUMMARY --------------------------------------------------------
  	    if (sec.events)
  	      html += `<div class="print-section event-summary">${buildEventSummary()}</div>`;

  	    // --- GRAPHS ---------------------------------------------------------------
  	    const graphBlocks = Array.from(
  	      document.querySelectorAll(".rog-graph-block")
  	    )
  	    .map((block) => {
  	      const params = Array.from(block.querySelectorAll(".param-list div"))
  	      .map((row) => {
  	        const key = row.querySelector("select")?.value;
  	        const color =
  	        row.querySelector('input[type="color"]')?.value || "#cc6b33";
  	        return key ? {
  	          key, color
  	        }: null;
  	      })
  	      .filter(Boolean);
  	      return params.length ? params: null;
  	    })
  	    .filter(Boolean);

  	    if (graphBlocks.length) {
  	      html += `
  	      <div class="print-section" id="rog-graphs-section">
  	      ${sectionHeader("Graphs")}
  	      ${graphBlocks
  	      .map(
  	        (params, idx) => `
  	        <div class="rog-graph" data-params='${JSON.stringify(params)}' style="
  	        margin-bottom:18px;
  	        background:#f9f9f9;
  	        border:1px solid #ddd;
  	        border-radius:6px;
  	        padding:8px;
  	        ">
  	        <canvas id="rog-chart-${idx}" height="140"></canvas>
  	        <div style="font-size:11px;color:#666;margin-top:4px;">
  	        Parameters: ${params.map((p) => p.key).join(", ")} | X: time
  	        </div>
  	        </div>`
  	      )
  	      .join("")}
  	      </div>`;
  	    }

  	    // --- MAP SNAPSHOT (spinner placeholder) -----------------------------------
  	    if (sec.map) {
  	      html += `
  	      <div class="print-section">
  	      ${sectionHeader("Map Snapshot")}
  	      <div id="rog-map-snapshot" style="
  	      text-align:center;
  	      margin-top:10px;
  	      height:80vh;
  	      max-height:80vh;
  	      display:flex;
  	      align-items:center;
  	      justify-content:center;
  	      color:#777;
  	      font-size:13px;
  	      overflow:hidden;">
  	      <div class="spinner" style="
  	      width:28px;height:28px;
  	      border:3px solid #ccc;
  	      border-top-color:#cc6b33;
  	      border-radius:50%;
  	      animation: spin 0.8s linear infinite;
  	      "></div>
  	      <span style="margin-left:10px;">Capturing map snapshot…</span>
  	      </div>
  	      ${sectionFooter("Static image captured from Fine Track Map")}
  	      </div>`;
  	    }


  	    // --- FOOTER ---------------------------------------------------------------
  	    if (sec.footer)
  	      html += `<div class="print-section">${buildFooter()}</div>`;

  	    // ✅ Render everything instantly
  	    preview.innerHTML = html;

  	    // 🧹 Remove any previously rendered graph canvases or images before new charts draw
  	    document.querySelectorAll(".rog-graph img").forEach(el => el.remove());

  	    // 🔁 Load the map image asynchronously (only if map is enabled)
  	    if (sec.map) {
  	      buildMapSnapshot(Map.map || Map).then((imgHTML) => {
  	        const container = byId("rog-map-snapshot");
  	        if (!container) return;

  	        if (!imgHTML) {
  	          container.innerHTML = "⚠️ Map image unavailable.";
  	          return;
  	        }

  	        container.innerHTML = `
  	        <img src="${imgHTML}" style="
  	        width:auto;
  	        max-width:95%;
  	        max-height:80vh;
  	        border:1px solid #ccc;
  	        border-radius:6px;
  	        opacity:0;
  	        transition:opacity .5s ease;
  	        " onload="this.style.opacity=1;" />
  	        `;
  	      });
  	    }

  	    // === Render selected graphs asynchronously ================================
  	    const selectedGraphs = Array.from(document.querySelectorAll(".rog-graph"));
  	    if (selectedGraphs.length) {

  	      // 🧹 Clear any old graph images *only* (leave new canvases intact)
  	      document.querySelectorAll(".rog-graph img").forEach(el => el.remove());

  	      // 🕐 Wait one frame so canvases exist in DOM
  	      await new Promise(requestAnimationFrame);

  	      // helper: resolves dot-paths like can.engine.rpm
  	      function resolveParam(obj, path) {

  	        if (obj && path in obj) return obj[path];
  	        return path.split(".").reduce((a, c) => (a ? a[c]: undefined), obj);
  	      }

  	      selectedGraphs.forEach((graphDiv) => {
  	        const paramSet = JSON.parse(graphDiv.dataset.params || "[]");
  	        const canvas = graphDiv.querySelector("canvas");

  	        if (!canvas) {
  	          console.warn("⚠️ No canvas found for graphDiv:", graphDiv);
  	          return;
  	        }
  	        const ctx = canvas.getContext("2d");


  	        const datasets = paramSet.map(({
  	          key, color
  	        }) => {
  	          const data = Array.isArray(tractor.Tracking)
  	          ? tractor.Tracking.filter((p) => p && typeof p.timestamp === "number")
  	          .map((p) => {
  	            const ts =
  	            typeof p.timestamp === "number"
  	            ? p.timestamp: Number(p.timestamp || p.point?.timestamp || 0);
  	            let val = resolveParam(p, key);

  	            // 🔁 fallback for vehicle speed
  	            if ((key === "can.vehicle.speed") && (val == null || isNaN(val))) {
  	              val = p.position?.speed ?? p["position.speed"] ?? null;
  	            }

  	            return ts && isFinite(ts) && val != null && isFinite(val)
  	            ? {
  	              t: ts,
  	              y: Number(val)
  	            }: null;
  	          })
  	          .filter(Boolean): [];

  	          return {
  	            label: key,
  	            data,
  	            parsing: {
  	              xAxisKey: "t", yAxisKey: "y"
  	            },
  	            borderColor: color,
  	            borderWidth: 1.5,
  	            pointRadius: 0,
  	            tension: 0.2,
  	          };
  	        });

  	        // === Create Chart ===
  	        new Chart(ctx, {
  	          type: "line",
  	          data: {
  	            datasets
  	          },
  	          options: {
  	            scales: {
  	              x: {
  	                type: "linear",
  	                title: {
  	                  display: true, text: "Time"
  	                },
  	                min: tripCtx.startTs || undefined,
  	                max: tripCtx.endTs || undefined,
  	                ticks: {
  	                  autoSkip: true,
  	                  maxTicksLimit: 8,
  	                  callback: (val) => {
  	                    const d = new Date(val * 1000);
  	                    return d.toLocaleTimeString([],
  	                      {
  	                        hour: "2-digit",
  	                        minute: "2-digit",
  	                        second: "2-digit",
  	                      });
  	                  },
  	                },
  	              },
  	              y: {
  	                beginAtZero: false,
  	                title: {
  	                  display: true, text: "Values"
  	                },
  	              },
  	            },
  	            plugins: {
  	              legend: {
  	                display: true, position: "top"
  	              },
  	            },
  	          },
  	        });

  	      });
  	    }
  	    // === Rebuild Compare Graph after preview rebuild =======================
  	    if (rogCompareIndexes && Array.isArray(rogCompareIndexes) && rogCompareIndexes.length >= 2) {
  	      // remove any old compare blocks (safety)
  	      document.querySelectorAll(".rog-compare-graph").forEach(n => n.remove());

  	      // re-create compare graph into the rebuilt DOM
  	      createOverlayGraph(rogCompareIndexes);
  	    }
  	  } // 👈 End of renderPreview()

  	  // === CLOSE HANDLERS =======================================================
  	  byId("rog-close").onclick = () => {
  	    document.getElementById("rog-event-overlay")?.remove();
  	  };

  	  document.addEventListener("keydown",
  	    (e) => {
  	      if (e.key === "Escape") document.getElementById("rog-event-overlay")?.remove();
  	    });

  	  // === BUTTON HANDLERS ======================================================

  	  /* 🖨️ PRINT ICON HANDLER — True A4 Landscape Print/PDF ===================== */
  	  byId("rog-print").onclick = async () => {
  	    await renderPreview();

  	    // 🖼️ Convert all live canvases to static images before printing
  	    const canvases = byId("rog-preview").querySelectorAll("canvas");
  	    canvases.forEach((canvas) => {
  	      try {
  	        const imgData = canvas.toDataURL("image/png", 1.0);
  	        const img = document.createElement("img");
  	        img.src = imgData;
  	        img.style.cssText = `
  	        width:100%;
  	        max-height:260px;
  	        border:1px solid #ccc;
  	        border-radius:4px;
  	        margin-top:4px;
  	        `;
  	        canvas.replaceWith(img);
  	      } catch (err) {
  	        console.warn("⚠️ Failed to convert canvas for print:", err);
  	      }
  	    });

  	    // Grab just the preview HTML (the white report pane)
  	    const html = byId("rog-preview").innerHTML;

  	    // Create an invisible iframe to handle printing cleanly
  	    const frame = document.createElement("iframe");
  	    Object.assign(frame.style,
  	      {
  	        position: "fixed",
  	        width: 0,
  	        height: 0,
  	        border: 0,
  	      });
  	    document.body.appendChild(frame);

  	    const doc = frame.contentWindow.document;
  	    doc.open();
  	    doc.write(`
  	      <html>
  	      <head>
  	      <title>Fleet In Form - Event Report</title>
  	      <style>
  	      @page { size: A4 landscape; margin: 10mm; }
  	      html, body {
  	      margin: 0;
  	      padding: 0;
  	      background: #fff;
  	      font-family: 'Segoe UI', sans-serif;
  	      color: #000;
  	      }

  	      /* === 🧾 Fixed 7-Column Grid — Main Event Summary Tables Only === */
  	      #rog-preview table.main-summary-table:not(.loc-table) {
  	      table-layout: fixed !important;
  	      width: 100% !important;
  	      border-collapse: collapse !important;
  	      border-spacing: 0 !important;
  	      }

  	      #rog-preview table.main-summary-table:not(.loc-table) th,
  	      #rog-preview table.main-summary-table:not(.loc-table) td {
  	      display: table-cell !important;
  	      box-sizing: border-box !important;
  	      padding: 2.5px 4px !important;
  	      font-size: 10px !important;
  	      line-height: 1.15 !important;
  	      vertical-align: top !important;
  	      overflow: hidden !important;
  	      text-overflow: ellipsis !important;
  	      white-space: nowrap !important;
  	      border-bottom: 1px solid #eee;
  	      }

  	      #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(1),
  	      #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(1) {
  	      width: 20% !important;
  	      text-align: left !important;
  	      white-space: normal !important;
  	      overflow-wrap: anywhere !important;
  	      }

  	      #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(2),
  	      #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(2) {
  	      width: 15% !important;
  	      text-align: center !important;
  	      }

  	      #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(3),
  	      #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(3) {
  	      width: 15% !important;
  	      text-align: center !important;
  	      }

  	      #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(4),
  	      #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(4) {
  	      width: 10% !important;
  	      text-align: center !important;
  	      }

  	      #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(5),
  	      #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(5) {
  	      width: 15% !important;
  	      text-align: center !important;
  	      }

  	      #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(6),
  	      #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(6) {
  	      width: 12.5% !important;
  	      text-align: center !important;
  	      }

  	      #rog-preview table.main-summary-table:not(.loc-table) th:nth-child(7),
  	      #rog-preview table.main-summary-table:not(.loc-table) td:nth-child(7) {
  	      width: 12.5% !important;
  	      text-align: center !important;
  	      }

  	      #rog-preview table.main-summary-table:not(.loc-table) thead,
  	      #rog-preview table.loc-table thead {
  	      display: table-header-group !important;
  	      }

  	      /* === 🧭 Location tables — Fleet In Form 8-column print grid === */
  	      #rog-preview table.loc-table {
  	      table-layout: fixed !important;
  	      width: 100% !important;
  	      border-collapse: collapse !important;
  	      }

  	      #rog-preview table.loc-table thead tr {
  	      background: #f7f0ea !important;
  	      border-top: 2px solid #cc6b33;
  	      border-bottom: 1px solid #d8b9a3;
  	      }

  	      #rog-preview table.loc-table th {
  	      color: #5a2a14;
  	      font-weight: 700;
  	      }

  	      #rog-preview table.loc-table th,
  	      #rog-preview table.loc-table td {
  	      display: table-cell !important;
  	      box-sizing: border-box !important;
  	      white-space: normal !important;
  	      overflow: visible !important;
  	      text-overflow: unset !important;
  	      word-break: normal !important;
  	      overflow-wrap: anywhere !important;
  	      line-height: 1.15 !important;
  	      font-size: 9.5px !important;
  	      padding: 2.5px 3px !important;
  	      vertical-align: top !important;
  	      }

  	      #rog-preview table.loc-table th:nth-child(1),
  	      #rog-preview table.loc-table td:nth-child(1) {
  	      width: 16% !important;
  	      }

  	      #rog-preview table.loc-table th:nth-child(2),
  	      #rog-preview table.loc-table td:nth-child(2),
  	      #rog-preview table.loc-table th:nth-child(3),
  	      #rog-preview table.loc-table td:nth-child(3) {
  	      width: 18% !important;
  	      }

  	      #rog-preview table.loc-table th:nth-child(4),
  	      #rog-preview table.loc-table td:nth-child(4) {
  	      width: 10% !important;
  	      text-align: center !important;
  	      }

  	      #rog-preview table.loc-table th:nth-child(5),
  	      #rog-preview table.loc-table td:nth-child(5),
  	      #rog-preview table.loc-table th:nth-child(6),
  	      #rog-preview table.loc-table td:nth-child(6),
  	      #rog-preview table.loc-table th:nth-child(7),
  	      #rog-preview table.loc-table td:nth-child(7) {
  	      width: 7% !important;
  	      text-align: center !important;
  	      }

  	      #rog-preview table.loc-table th:nth-child(8),
  	      #rog-preview table.loc-table td:nth-child(8) {
  	      width: 17% !important;
  	      }

  	      #rog-preview table.loc-table tr.loc-row {
  	      background: #fff4ec !important;
  	      }

  	      #rog-preview table.loc-table tr.loc-row:nth-child(even) {
  	      background: #fffaf6 !important;
  	      }

  	      #rog-preview table.loc-table tr.loc-row td:first-child {
  	      border-left: 4px solid #cc6b33;
  	      font-weight: 600;
  	      color: #3b1b0d;
  	      }

  	      #rog-preview table.loc-table .loc-type {
  	      color: #3b1b0d;
  	      font-weight: 600;
  	      }

  	      /* === Print layout structure === */
  	      #rog-preview > div,
  	      .print-section,
  	      #rog-preview section,
  	      #rog-preview table,
  	      #rog-preview details {
  	      page-break-inside: avoid;
  	      break-inside: avoid;
  	      }
  	      .print-section { margin-bottom: 18px; }
  	      .print-header {
  	      display: flex;
  	      align-items: center;
  	      justify-content: space-between;
  	      padding-bottom: 6px;
  	      margin-bottom: 0;
  	      }

  	      #rog-preview {
  	      padding-bottom: 16mm;
  	      }

  	      .print-footer {
  	      position: static !important;
  	      text-align: right;
  	      font-size: 10px;
  	      color: #777;
  	      border-top: 1px solid #ddd;
  	      padding-top: 6px;
  	      margin-top: 14px;
  	      background: #fff;
  	      page-break-inside: avoid;
  	      break-inside: avoid;
  	      }
  	      .page { page-break-after: always; }
  	      </style>
  	      </head>
  	      <body>
  	      <div id="rog-preview">
  	      ${html}
  	      </div>
  	      </body>
  	      </html>
  	      `);
  	    doc.close();

  	    // Wait for the frame to load, then trigger print dialog
  	    frame.onload = () => {
  	      frame.contentWindow.focus();
  	      frame.contentWindow.print(); // system dialog → Save as PDF or printer
  	      setTimeout(() => frame.remove(),
  	        4000);
  	    };
  	  };

  	  // === INITIAL ==============================================================
  	  renderPreview();

  	  // === AUTO LIVE PREVIEW REFRESH ============================================
  	  let rogPreviewTimer = null;
  	  function scheduleLivePreview() {
  	    clearTimeout(rogPreviewTimer);
  	    // debounce: wait 400ms after last change
  	    rogPreviewTimer = setTimeout(() => renderPreview(),
  	      400);
  	  }

  	  // Observe changes in event/graph/section controls
  	  document.addEventListener("change",
  	    (e) => {
  	      const t = e.target;
  	      if (
  	        t.matches("#sec-header, #sec-trip, #sec-map, #sec-driver, #sec-events, #sec-footer") ||
  	        t.matches("input[data-ev], input[data-ev-itemize]") ||
  	        t.closest(".rog-graph-block")
  	      ) {
  	        scheduleLivePreview();
  	      }
  	    });

  	  // Also refresh when a graph parameter or color changes
  	  document.addEventListener("input",
  	    (e) => {
  	      const t = e.target;
  	      if (t.matches(".rog-graph-block select, .rog-graph-block input[type='color']")) {
  	        scheduleLivePreview();
  	      }
  	    });

  	  // Refresh when adding or removing a graph block
  	  document.addEventListener("click",
  	    (e) => {
  	      const t = e.target;
  	      if (t.matches("#rog-add-graph, .rog-graph-block button")) {
  	        scheduleLivePreview();
  	      }
  	    });

  	})();
  })(Tractor, Map, 'data:image/png;base64,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');

}

})
define('./functions/f916759a51c43a42ab0bb3fb84384b1e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f916759a51c43a42ab0bb3fb84384b1e'] = async function fn_f916759a51c43a42ab0bb3fb84384b1e(Page, App, Button) {
var Caught_Error, User, Timer, item, j, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function my_1__Login___Button_Handler_and_Error_Clear() {
  Button['label'] = 'Please Wait...';
  Button['disabled'] = true;
  if (getObjectProperty(Page, 'Error')) {
    delete Page['Error'];
  }
}

/**
 * Describe this function...
 */
async function my_2__Login___Error_Handler(Caught_Error) {
  Page['Error'] = (getObjectProperty(Caught_Error, 'message'));
  Button['label'] = 'Login';
  Button['disabled'] = false;
}


  await my_1__Login___Button_Handler_and_Error_Clear();
  try {
    User = (await Backendless.UserService.login( (getObjectProperty(Page, 'Username')), (getObjectProperty(Page, 'Password')), ((typeof (getObjectProperty(Page, 'Remember')) === 'undefined') ? false : true)  ));

  } catch (error) {
    await my_2__Login___Error_Handler(error);

  }
  App['User'] = ((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(User, 'objectId')),'\''].join(''))).setRelated((((['Companies.Locations.Jobs', 'Companies.Locations.Fields.Segments', 'Companies.Locations.Fields.Rings', 'Companies.Routes', 'Companies.Trailers', 'Companies.Contractors', 'Companies.Customers', 'Companies.Customers.Locations.Fields', 'Companies.Customers.Locations.Segments', 'Companies.Customers.Locations.Rings', 'Companies.Contractors.Tractors'].concat(undefined)).concat(['Companies.Tractors.ViewC.Conductor1', 'Companies.Tractors.ViewC.Conductor2', 'Companies.Tractors.ViewC.Driver1', 'Companies.Tractors.ViewC.Driver2', 'Companies.Tractors.ViewC.Fuel', 'Companies.Tractors.ViewC.Loads', 'Companies.Tractors.ViewC.Trailer1', 'Companies.Tractors.ViewC.Trailer2', 'Companies.Tractors.ViewC.Trailer3', 'Companies.Tractors.ViewC.Maintenance', 'Companies.Tractors.ViewH.Conductor1', 'Companies.Tractors.ViewH.Conductor2', 'Companies.Tractors.ViewH.Driver1', 'Companies.Tractors.ViewH.Driver2', 'Companies.Tractors.ViewH.Fuel', 'Companies.Tractors.ViewH.Loads', 'Companies.Tractors.ViewH.Trailer1', 'Companies.Tractors.ViewH.Trailer2', 'Companies.Tractors.ViewH.Trailer3', 'Companies.Tractors.ViewH.Maintenance', 'Companies.Tractors.Maintenance', 'Companies.Tractors.Tyres'])).concat((['Tractor', 'Wages_Payslip_Current', 'Wages_Payslip_Historical'].concat(['Companies.Tanks.ATG', 'Companies.Tanks.Location', 'Companies.Tanks.FuelIn', 'Companies.Tanks.Bowsers.ViewC.FuelOut', 'Companies.Tanks.Bowsers.ViewH.FuelOut', 'Companies.Tanks.ViewC.FuelIn', 'Companies.Tanks.ViewH.FuelIn', 'Companies.Employees']))))).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(1)))[0]);
  var j_list = (getObjectProperty((getObjectProperty(App, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['Tyres'] = (await BackendlessUI.Functions.Custom['fn_d91c5dbed1a614198a69238eaf0de643']('Tyres', (String('') + String(['Company_ID = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))), null));
  }
  if ((getObjectProperty(User, 'APP')).indexOf(',') !== -1) {
    if ((getObjectProperty(User, 'Office')).indexOf('LiveTrack') !== -1) {
      if ((getObjectProperty(User, 'Settings')).indexOf('Overview') !== -1) {
        Page['App Select Options'] = (await Promise.all((((getObjectProperty(User, 'APP')).split(',')).concat(['Mobile Tracking', 'Snapshot'])).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
      } else {
        Page['App Select Options'] = (await Promise.all((((getObjectProperty(User, 'APP')).split(',')).concat(['Mobile Tracking'])).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
      }
    } else {
      if ((getObjectProperty(User, 'Settings')).indexOf('Overview') !== -1) {
        Page['App Select Options'] = (await Promise.all((((getObjectProperty(User, 'APP')).split(',')).concat(['Snapshot'])).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
      } else {
        Page['App Select Options'] = (await Promise.all(((getObjectProperty(User, 'APP')).split(',')).map(async item => {; return ({ [`value`]: item,[`label`]: item });})));
      }
    }
    Timer = 0;
    while ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(Page, 'Selected App'))))) {
      await new Promise(r => setTimeout(r, 500 || 0));
      Timer = Timer + 500;
      if (Timer == 10000) {
        Page['Error'] = 'Please Select App To View';
      }
    }
  } else {
    await BackendlessUI.Functions.Custom['fn_302f8a0eaf0351f7bd6ef7c44ea2db0e']((getObjectProperty(User, 'APP')), User, Page, App);
  }

}

})
define('./functions/fc9582288a86cc06b9574b62748e2a12/code.js', () => { 

BackendlessUI.Functions.Custom['fn_fc9582288a86cc06b9574b62748e2a12'] = async function fn_fc9582288a86cc06b9574b62748e2a12(App) {
  await (async function(AppData, SVGLogo) {
  	/*
  	===============================================================================
  	FLEET IN FORM - TANK & BOWSER MANAGER v9.9.2
  	===============================================================================
  	
  	ONE Custom Code block for the On Click event.
  	
  	Inputs:
  	  AppData  -> App Data
  	  SVGLogo  -> optional logo image, data URL, URL or raw SVG
  	
  	FuelOut fields used by v9.8.11:
  	  CapturedByName      STRING
  	  CapturedByEmail     STRING
  	  CapturedByObjectId  STRING
  	  ReadingUnit         STRING  ("km" or "h")
  	  ReadingDelta        DOUBLE
  	  Efficiency          DOUBLE
  	  EfficiencyUnit      STRING  ("km/L" or "L/H"; legacy hour entries use "h/L")
  	
  	Tractor.CounterType is the canonical vehicle operating unit.
  	Data.FuelAndEnergy.FuelGrade.value is the canonical vehicle fuel grade.
  	Data.Vehicle.Identity and Data.Vehicle.Classification are the canonical simplified vehicle descriptors.
  	Legacy vehicle Data paths remain read-only fallbacks for older records.
  	
  	The manager:
  	  - creates every element itself under document.body
  	  - starts 50px below the top of the screen
  	  - uses the maximum practical browser z-index
  	  - has no search, refresh counters or built-in close button
  	  - closes itself when another visible drawer / mini-app opens
  	  - keeps Level, Volume and Capacity in one horizontal row
  	  - opens the existing Fuel Delivery and Fuel Dispensing workflows
  	  - sorts companies alphanumerically and allows each company to collapse
  	  - stores three tank stock thresholds: Warning Level 1, Warning Level 2 and Minimum / Order Level
  	  - Warning Level 1 and Warning Level 2 each trigger a once-per-crossing stock warning email to both the Primary Supplier and the tank company
  	  - the Minimum / Order Level remains the actual order threshold and emails the fuel order to both the Primary Supplier and the tank company
  	  - uses Supplier Order Email first and falls back to the normal Supplier Email
  	  - stores a tank CompanyNotificationEmail override while also resolving common company email fields as fallback
  	  - orders the configured Default Volume Order and records warning/order notification audits against the triggering FuelOut where possible
  	  - uses fully themed custom dropdowns across all fuel workflows
  	  - sorts tank deliveries by newest delivery date by default
  	  - reads monthly TankView ViewC / ViewH data directly from AppData
  	  - adds the same current / historical month selector used by BowserView
  	  - links each newly saved FuelIn row only to its correct monthly TankView
  	  - uses a blended burnt-orange accent instead of solid bright orange
  	  - uses compact circular close controls throughout the mini-apps
  	  - closes the manager and all child mini-apps when the user logs out
  	  - closes the manager on Fleet In Form SPA application changes, including Snapshot, so overlays cannot survive an app switch
  	  - deletes suppliers only after an exact typed DELETE confirmation
  	  - uses the Location-program delete button and confirmation styling
  	  - labels the tank and bowser workflow buttons as managers
  	  - Fuel Capture uses Save and New and remains ready for another entry
  	  - advances every fitted vehicle tyre by the positive vehicle mileage differential
  	  - updates the active tyre History stage Mileage_Done and End_Mileage in one bulk save pass
  	  - refreshes calculated tyre Current_Life in live AppData without writing it to Backendless
  	  - filters company and contractor vehicles by the selected tank fuel grade
  	  - restricts Paraffin tanks to Other transactions only
  	  - loads the selected vehicle Tyres relation before calculating tyre mileage
  	  - supports Backendless proxy/array-like relation collections without silently skipping tyres
  	  - removes FuelOut editing and replaces it with typed-delete safety
  	  - allows append-only additions to an existing FuelOut Description without exposing Description editing
  	  - reloads the authoritative FuelOut row before every Description append and stamps the addition with user and time
  	  - permits deletion only for the highest current-month bowser meter transaction
  	  - confirms that delivery data is correct before an irreversible FuelIn save
  	  - keeps Fuel Delivery open when the save confirmation is cancelled
  	  - locks saved delivery date, litres, reference and notes against later editing
  	  - removes FuelIn deletion and tank-delivery rollback from the manager
  	  - permits supplier and invoice-cost corrections on saved FuelIn records
  	  - allows one primary optional authenticated PDF or image document on each FuelIn record
  	  - stores the primary FuelIn DocumentURL, DocumentKey and DocumentName after a successful Cloudflare R2 upload
  	  - allows two additional optional authenticated PDF or image attachments per FuelIn record
  	  - stores the two additional attachments in the FuelIn Docs JSON property without changing the primary document fields
  	  - supports add, replace, remove, download, preview and print for the additional Docs attachments
  	  - keeps the fuel delivery saved when an optional document upload fails and allows a later retry
  	  - supports authenticated download, replacement and removal from the delivery detail screen
  	  - previews authenticated FuelIn images and PDFs directly inside the transaction viewer
  	  - includes an attached FuelIn image as a full document page when printing the individual transaction
  	  - presets new FuelIn entries from the latest tank price per litre
  	  - calculates the initial invoice cost from litres and the latest price per litre
  	  - keeps Cost Per Litre and Total Cost editable with two-way recalculation
  	  - gives Cost Per Litre priority whenever litres are changed
  	  - pushes the newly saved FuelIn price into live AppData for immediate FuelOut use
  	  - values each TankView at total litres multiplied by its latest delivery price
  	  - fully reverses bowser, vehicle, tyre, view and intertank effects before FuelOut deletion
  	  - uses exact inverse values stored on FuelOut instead of rebuilding rollback from stale relations
  	  - updates BowserView and Tractorview relations before saving their rolled-back totals
  	  - writes narrow rollback patches for Bowser, Tractor, views and tyres
  	  - stores explicit vehicle, tank, bowser and mileage rollback identifiers on new FuelOut rows
  	  - hides tank DeviceId values from all user-facing manager screens and reports
  	  - naturally sorts entity dropdown options alphanumerically
  	  - uses the exact Select Registration placeholder capitalisation
  	  - keeps Other pinned ahead of naturally sorted dropdown options
  	  - shows a gently fading branded loading screen for every database save, relation update and delete
  	  - displays humanised live save/delete progress beneath the throbbing Fleet In Form logo
  	  - recalculates every TankView Cost as latest delivery price multiplied by related litres
  	  - opens one operation screen immediately on Save/Delete confirmation and keeps it open for the whole workflow
  	  - changes progress text in place instead of reopening the loading screen for every database request
  	  - shows a final styled success message and closes automatically
  	  - locks the operation screen on errors until the user acknowledges the message
  	  - replaces native save/delete completion alerts with the Fleet In Form operation screen
  	  - stores the capturing user name, email and objectId on every new FuelOut row
  	  - records each vehicle transaction reading unit, reading difference and fuel efficiency
  	  - routes one shared vehicle reading into Odometer or Hobbs Meter according to CounterType
  	  - routes one shared period movement into Distance or Hours according to CounterType
  	  - writes every vehicle fuel reading to canonical Data.Vehicle.Usage.CurrentReading while retaining legacy Mileage compatibility
  	  - safely reads and writes Data.OperationalTargets.Fuel_Counter whether stored as a raw number or a descriptor object
  	  - advances fitted tyre usage by the positive vehicle reading differential for both kilometre- and hour-based vehicles, using the position wear rate
  	  - reviews Service and Preventive Maintenance thresholds after every vehicle FuelOut save
  	  - sends an OVERDUE Service / Preventive Maintenance provider email after every vehicle FuelOut while the vehicle remains overdue; DUE_SOON remains one-time and ProviderEmailHistory is retained for audit
  	  - shows separate Km/L and L/H columns in mixed-vehicle transaction ledgers
  	  - distinguishes Bowser Meter readings from vehicle operating readings everywhere
  	  - uses stable shared grid tracks so transaction headings and row values remain perfectly aligned
  	  - resolves each tank's live ATG reading by matching Tanks.ATG_NUMBER to ATGPolls.Readings[].TankNumber
  	  - keeps book stock and physical ATG stock as two completely independent systems
  	  - displays actual litres beneath the percentage in both BOOK STOCK and ATG CHECK gauges instead of the fuel grade
  	  - keeps purchases and sales as the only source for the book gauge, volume, level, order indication and stock value
  	  - adds a separate ATG check gauge driven only by the matched physical ATG reading
  	  - shows ATG temperature, water height, ullage, product, captured time and LIVE / STALE / UNAVAILABLE status
  	  - refreshes linked ATGPolls records in the background every 60 seconds without writing to the tank or ATG tables
  	  - reads canonical Tractor.CounterType before legacy reading-unit fields
  	  - resolves hour-based vehicles from the active company and robust CounterType descriptor shapes
  	  - hydrates the complete Tractor row before routing historical and new fuel readings
  	  - recognises the Tanks.Trailer boolean and marks mobile trailer tanks in the manager
  	  - records every intertank destination receipt as valued FuelIn stock without changing a fixed tank issue price
  	  - lets trailer tanks inherit the source issue price so they can dispense to vehicles
  	  - removes the paired intertank FuelIn receipt when the source FuelOut transaction is deleted
  	  - reads vehicle fuel grade from Data.FuelAndEnergy.FuelGrade.value
  	  - maps Diesel 10/50 ppm and Petrol 93/95 descriptors to the exact tank grades
  	  - reads simplified Vehicle.Identity and Vehicle.Classification descriptors before legacy paths
  	  - reads SARSCompliance and SARSRate from their canonical Tractor columns
  	  - ALWAYS uses the selected/live Tractor SARSRate for rebate calculation and display
  	  - stamps SARSRebateRate on every new vehicle FuelOut for audit while display remains vehicle-rate authoritative
  	  - ignores blank canonical SARS descriptors during migration and prefers a real positive legacy rate over placeholder zero
  	  - adds a Printables menu beside every Tank edit button
  	  - lets QR Code open an attached-Bowser selector instead of printing the Tank
  	  - prints the selected Bowser QR whose payload is the exact Bowser.objectId, with the Fleet In Form SVG above and a large Bowser name below
  	  - prints a clean A3 Fuel Capture Sheet with exactly 20 blank capture lines
  	  - pages FuelOut ledgers at 10 transactions per screen while retaining the full selected month in memory
  	  - loads every FuelOut relation row for the selected BowserView instead of relying on Backendless' default related-row limit
  	  - locks FuelOut transaction order to FuelDate/created newest-first so page order, filtering and print order are deterministic
  	  - uses BowserView month totals on the left when no search is active and switches the summary to filtered-row totals while searching
  	  - prints the entire selected month when unfiltered and only the complete filtered result set when search is active, independent of the current page
  	  - treats the Bowser QR selector as an internal Fuel Manager overlay so it never closes the manager
  	  - uses slightly more compact blank-form rows while retaining exactly 20 lines per page
  	===============================================================================
  	*/
  	
  	return (function () {
  	  "use strict";
  	
  	  var FIF_MAX_Z_INDEX = 2147483647;
  	  var MANAGER_OVERLAY_ID = "fif-tank-manager-overlay";
  	  var MANAGER_HOST_ID = "fif-tank-manager-host";
  	  var MANAGER_ROOT_ID = "fif-fuel-manager-root";
  	  var MANAGER_EDIT_OVERLAY_ID = "fif-manager-asset-edit-overlay";
  	  var MANAGER_SUPPLIER_OVERLAY_ID = "fif-manager-supplier-overlay";
  	  var MANAGER_RECORD_DELETE_OVERLAY_ID = "fif-record-delete-overlay";
  	  var MANAGER_BOWSER_QR_OVERLAY_ID = "fif-manager-bowser-qr-overlay";
  	  var MANAGER_BOWSER_QR_STYLE_ID = "fif-manager-bowser-qr-style";
  	  var MANAGER_LOADING_OVERLAY_ID = "fif-database-loading-overlay";
  	  var MANAGER_DELIVERY_CONFIRM_OVERLAY_ID =
  	    "fuel-delivery-save-confirmation";
  	  var MANAGER_PROVIDER_EMAIL_OVERLAY_ID =
  	    "fif-service-provider-email-overlay";
  	  var MANAGER_ORDER_EMAIL_OVERLAY_ID =
  	    "fif-tank-order-email-overlay";
  	
  	  // Must exactly match the Backendless Grade MULTIPLE CHOICE values.
  	  var MANAGER_FUEL_GRADES = [
  	    "ULP 95",
  	    "ULP 93",
  	    "Diesel 500ppm",
  	    "Diesel 50ppm",
  	    "Diesel 10ppm",
  	    "Paraffin"
  	  ];
  	
  	  var rootAppData =
  	    typeof AppData !== "undefined" && AppData
  	      ? AppData
  	      : null;
  	
  	  var rootBackendless =
  	    typeof Backendless !== "undefined" && Backendless
  	      ? Backendless
  	      : null;
  	
  	  var rootCurrentUser =
  	    typeof CurrentUser !== "undefined" && CurrentUser
  	      ? CurrentUser
  	      : rootAppData && rootAppData.User
  	        ? rootAppData.User
  	        : null;
  	
  	  var rootSvgLogo =
  	    typeof SVGLogo !== "undefined"
  	      ? SVGLogo
  	      : null;
  	
  	  var destroyed = false;
  	  var companiesCache = [];
  	  var managerOtherDrawerObserver = null;
  	  var managerDrawerCheckQueued = false;
  	  var managerOpenExternalPanels = new Set();
  	  var managerLogoutWatchTimer = null;
  	  var managerLogoutClickHandler = null;
  	  var managerLogoutEventHandler = null;
  	  var managerStorageHandler = null;
  	  var managerInitialLocationHref = String(window.location.href || "");
  	  var managerInitialPageName = "";
  	  var managerInitialUserFingerprint = "";
  	  var managerInitialAuthTokenSignature = "";
  	  var managerHadAuthenticatedContext = false;
  	  var managerLoadingOperationCount = 0;
  	  var managerLoadingHideTimer = null;
  	  var managerLoadingShownAt = 0;
  	  var managerLoadingLastStatus = "";
  	  var managerLoadingErrorLocked = false;
  	  var managerLoadingSuccessTimer = null;
  	  var managerAtgRefreshTimer = null;
  	  var managerAtgRefreshInFlight = false;
  	  var MANAGER_ATG_STALE_AFTER_MS = 15 * 60 * 1000;
  	  var MANAGER_COMPANY_COLLAPSE_STORAGE_KEY =
  	    "fif-fuel-manager-company-collapse-v1";
  	  var managerCompanyCollapsed = managerLoadCompanyCollapseState();
  	
  	  function managerLoadCompanyCollapseState() {
  	    try {
  	      var raw = window.localStorage.getItem(
  	        MANAGER_COMPANY_COLLAPSE_STORAGE_KEY
  	      );
  	
  	      if (!raw) return {};
  	
  	      var parsed = JSON.parse(raw);
  	      return parsed && typeof parsed === "object"
  	        ? parsed
  	        : {};
  	    } catch (_) {
  	      return {};
  	    }
  	  }
  	
  	  function managerSaveCompanyCollapseState() {
  	    try {
  	      window.localStorage.setItem(
  	        MANAGER_COMPANY_COLLAPSE_STORAGE_KEY,
  	        JSON.stringify(managerCompanyCollapsed || {})
  	      );
  	    } catch (_) {}
  	  }
  	
  	  function managerCompanyKey(company, index) {
  	    return String(
  	      managerFirst(
  	        managerGet(company, ["objectId"], null),
  	        managerGet(company, ["CompanyId"], null),
  	        managerGet(company, ["CompanyName"], null),
  	        managerGet(company, ["Name"], null),
  	        "company_" + String(index)
  	      )
  	    );
  	  }
  	
  	  function managerCompanyIsCollapsed(company, index) {
  	    return !!managerCompanyCollapsed[
  	      managerCompanyKey(company, index)
  	    ];
  	  }
  	
  	  function managerToArray(value) {
  	    if (Array.isArray(value)) return value;
  	    if (value === null || value === undefined) return [];
  	    return [value];
  	  }
  	
  	  function managerNumber(value, fallback) {
  	    if (value === null || value === undefined || value === "") {
  	      return fallback;
  	    }
  	
  	    var cleaned = String(value)
  	      .trim()
  	      .replace(/\s/g, "")
  	      .replace(",", ".");
  	
  	    var number = Number(cleaned);
  	    return Number.isFinite(number) ? number : fallback;
  	  }
  	
  	  function managerText(value, fallback) {
  	    if (value === null || value === undefined || value === "") {
  	      return fallback;
  	    }
  	
  	    return String(value);
  	  }
  	
  	  function managerEscape(value) {
  	    return String(value === null || value === undefined ? "" : value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/"/g, "&quot;")
  	      .replace(/'/g, "&#39;");
  	  }
  	
  	  function managerGet(object, path, fallback) {
  	    try {
  	      var current = object;
  	
  	      for (var index = 0; index < path.length; index++) {
  	        if (current === null || current === undefined) {
  	          return fallback;
  	        }
  	
  	        current = current[path[index]];
  	      }
  	
  	      return current === null || current === undefined
  	        ? fallback
  	        : current;
  	    } catch (_) {
  	      return fallback;
  	    }
  	  }
  	
  	  function managerFirst() {
  	    for (var index = 0; index < arguments.length; index++) {
  	      var value = arguments[index];
  	
  	      if (value !== null && value !== undefined && value !== "") {
  	        return value;
  	      }
  	    }
  	
  	    return null;
  	  }
  	
  	  function managerBoolean(value, fallback) {
  	    if (
  	      value &&
  	      typeof value === "object" &&
  	      Object.prototype.hasOwnProperty.call(value, "value")
  	    ) {
  	      value = value.value;
  	    }
  	
  	    if (value === true || value === 1) return true;
  	    if (value === false || value === 0) return false;
  	    if (value === null || value === undefined || value === "") {
  	      return !!fallback;
  	    }
  	
  	    var normalized = String(value).trim().toLowerCase();
  	    if (["true", "yes", "y", "1", "on"].indexOf(normalized) >= 0) {
  	      return true;
  	    }
  	    if (["false", "no", "n", "0", "off"].indexOf(normalized) >= 0) {
  	      return false;
  	    }
  	
  	    return !!fallback;
  	  }
  	
  	  function managerIsTrailerTank(tank) {
  	    return managerBoolean(
  	      managerFirst(
  	        managerGet(tank, ["Trailer"], null),
  	        managerGet(tank, ["IsTrailer"], null)
  	      ),
  	      false
  	    );
  	  }
  	
  	  function managerIsIntertankFuelIn(delivery) {
  	    var entryType = managerText(
  	      managerFirst(
  	        managerGet(delivery, ["EntryType"], null),
  	        managerGet(delivery, ["CaptureType"], null)
  	      ),
  	      ""
  	    ).trim().toLowerCase();
  	
  	    if (entryType === "intertank") return true;
  	
  	    var reference = managerText(
  	      managerGet(delivery, ["ReferenceNo"], ""),
  	      ""
  	    ).trim();
  	
  	    return /^INTERTANK:/i.test(reference);
  	  }
  	
  	  // Shared fallback helper used by Fuel Out and Tank Deliveries.
  	  // Kept as an alias because older sections still call firstDefined().
  	  function firstDefined() {
  	    return managerFirst.apply(null, arguments);
  	  }
  	
  	  function managerDescriptorValue(value) {
  	    if (value === null || value === undefined) return value;
  	    if (Array.isArray(value)) {
  	      return value.length ? managerDescriptorValue(value[0]) : null;
  	    }
  	    if (typeof value === "object") {
  	      var keys = ["value", "Value", "current", "Current"];
  	      for (var index = 0; index < keys.length; index++) {
  	        if (
  	          Object.prototype.hasOwnProperty.call(value, keys[index]) &&
  	          value[keys[index]] !== null &&
  	          value[keys[index]] !== undefined &&
  	          value[keys[index]] !== ""
  	        ) {
  	          return managerDescriptorValue(value[keys[index]]);
  	        }
  	      }
  	    }
  	    return value;
  	  }
  	
  	  function managerVehicleCurrentReading(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") return 0;
  	
  	    var canonical = managerNumber(
  	      managerDescriptorValue(
  	        managerGet(vehicle, ["Data", "Vehicle", "Usage", "CurrentReading"], null)
  	      ),
  	      NaN
  	    );
  	
  	    if (Number.isFinite(canonical)) return canonical;
  	
  	    return managerNumber(
  	      managerFirst(
  	        managerGet(vehicle, ["Mileage"], null),
  	        managerGet(vehicle, ["CurrentReading"], null),
  	        0
  	      ),
  	      0
  	    );
  	  }
  	
  	  function managerVehicleRangeValue(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") return 0;
  	
  	    var canonical = managerNumber(
  	      managerDescriptorValue(
  	        managerGet(vehicle, ["Data", "Vehicle", "Usage", "Range"], null)
  	      ),
  	      NaN
  	    );
  	
  	    if (Number.isFinite(canonical) && canonical >= 0) return canonical;
  	
  	    return Math.max(
  	      0,
  	      managerNumber(
  	        managerFirst(managerGet(vehicle, ["Range"], null), 0),
  	        0
  	      )
  	    );
  	  }
  	
  	  function managerEnsureVehicleUsage(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") return null;
  	
  	    if (!vehicle.Data || typeof vehicle.Data !== "object" || Array.isArray(vehicle.Data)) {
  	      vehicle.Data = {};
  	    }
  	    if (!vehicle.Data.Vehicle || typeof vehicle.Data.Vehicle !== "object" || Array.isArray(vehicle.Data.Vehicle)) {
  	      vehicle.Data.Vehicle = {};
  	    }
  	    if (!vehicle.Data.Vehicle.Usage || typeof vehicle.Data.Vehicle.Usage !== "object" || Array.isArray(vehicle.Data.Vehicle.Usage)) {
  	      vehicle.Data.Vehicle.Usage = {};
  	    }
  	    return vehicle.Data.Vehicle.Usage;
  	  }
  	
  	  function managerSetVehicleCurrentReading(vehicle, reading, readingUnit) {
  	    if (!vehicle || typeof vehicle !== "object") return;
  	
  	    var numeric = managerNumber(reading, NaN);
  	    if (!Number.isFinite(numeric) || numeric < 0) return;
  	
  	    var usage = managerEnsureVehicleUsage(vehicle);
  	    if (!usage) return;
  	
  	    var unitType = readingUnit === "h" ? "Time" : "Distance";
  	    var existing = usage.CurrentReading;
  	
  	    if (existing && typeof existing === "object" && !Array.isArray(existing)) {
  	      existing.value = numeric;
  	      existing.editable = false;
  	      existing.selector = "number";
  	      existing.unitType = unitType;
  	    } else {
  	      usage.CurrentReading = {
  	        value: numeric,
  	        editable: false,
  	        selector: "number",
  	        unitType: unitType
  	      };
  	    }
  	
  	    vehicle.Mileage = numeric;
  	  }
  	
  	  function managerFuelCounterValue(vehicle, fallback) {
  	    if (!vehicle || typeof vehicle !== "object") return fallback;
  	
  	    var raw = managerGet(
  	      vehicle,
  	      ["Data", "OperationalTargets", "Fuel_Counter"],
  	      null
  	    );
  	
  	    return managerNumber(managerDescriptorValue(raw), fallback);
  	  }
  	
  	  function managerHasFuelCounter(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") return false;
  	
  	    var raw = managerGet(
  	      vehicle,
  	      ["Data", "OperationalTargets", "Fuel_Counter"],
  	      undefined
  	    );
  	
  	    return raw !== null && raw !== undefined && raw !== "";
  	  }
  	
  	  function managerSetFuelCounter(vehicle, value) {
  	    if (!vehicle || typeof vehicle !== "object") return false;
  	
  	    var numeric = managerNumber(value, NaN);
  	    if (!Number.isFinite(numeric)) return false;
  	    numeric = Math.max(0, numeric);
  	
  	    if (
  	      !vehicle.Data ||
  	      typeof vehicle.Data !== "object" ||
  	      Array.isArray(vehicle.Data)
  	    ) {
  	      return false;
  	    }
  	
  	    if (
  	      !vehicle.Data.OperationalTargets ||
  	      typeof vehicle.Data.OperationalTargets !== "object" ||
  	      Array.isArray(vehicle.Data.OperationalTargets)
  	    ) {
  	      return false;
  	    }
  	
  	    var current = vehicle.Data.OperationalTargets.Fuel_Counter;
  	
  	    if (current && typeof current === "object" && !Array.isArray(current)) {
  	      current.value = numeric;
  	    } else {
  	      vehicle.Data.OperationalTargets.Fuel_Counter = numeric;
  	    }
  	
  	    return true;
  	  }
  	
  	  function managerCurrentUserFingerprint() {
  	    var candidates = [
  	      managerGet(rootAppData, ["User"], null),
  	      managerGet(rootAppData, ["CurrentUser"], null),
  	      managerGet(rootAppData, ["Current_User"], null),
  	      typeof window !== "undefined" ? window.CurrentUser : null,
  	      typeof window !== "undefined" ? window.currentUser : null
  	    ];
  	
  	    for (var index = 0; index < candidates.length; index++) {
  	      var user = candidates[index];
  	      if (!user || typeof user !== "object") continue;
  	
  	      var fingerprint = managerFirst(
  	        managerGet(user, ["objectId"], null),
  	        managerGet(user, ["email"], null),
  	        managerGet(user, ["Email"], null),
  	        managerGet(user, ["userId"], null),
  	        managerGet(user, ["UserId"], null),
  	        managerGet(user, ["name"], null),
  	        managerGet(user, ["Name"], null)
  	      );
  	
  	      if (fingerprint) return String(fingerprint);
  	    }
  	
  	    return "";
  	  }
  	
  	  function managerAuthTokenSignature() {
  	    var fragments = [];
  	    var stores = [];
  	
  	    try {
  	      if (window.localStorage) stores.push(window.localStorage);
  	    } catch (_) {}
  	
  	    try {
  	      if (window.sessionStorage) stores.push(window.sessionStorage);
  	    } catch (_) {}
  	
  	    for (var storeIndex = 0; storeIndex < stores.length; storeIndex++) {
  	      var store = stores[storeIndex];
  	
  	      try {
  	        for (var keyIndex = 0; keyIndex < store.length; keyIndex++) {
  	          var key = String(store.key(keyIndex) || "");
  	
  	          if (!/(backendless|user[-_. ]?token|auth[-_. ]?token|session[-_. ]?token)/i.test(key)) {
  	            continue;
  	          }
  	
  	          var value = String(store.getItem(key) || "");
  	          if (!value) continue;
  	
  	          fragments.push(key + "=" + value.slice(0, 80));
  	        }
  	      } catch (_) {}
  	    }
  	
  	    fragments.sort();
  	    return fragments.join("|");
  	  }
  	
  	  function managerPageNameFromHref(href) {
  	    try {
  	      var parsed = new URL(
  	        String(href || ""),
  	        String(window.location.href || "")
  	      );
  	      return String(parsed.searchParams.get("page") || "")
  	        .trim()
  	        .toLowerCase();
  	    } catch (_) {
  	      return "";
  	    }
  	  }
  	
  	  function managerLooksLikeLogoutControl(startElement) {
  	    var element = startElement;
  	    var depth = 0;
  	
  	    while (element && element !== document.body && depth < 9) {
  	      if (element instanceof HTMLElement) {
  	        var identity = [
  	          element.id,
  	          element.className,
  	          element.getAttribute("title"),
  	          element.getAttribute("aria-label"),
  	          element.getAttribute("data-testid"),
  	          element.getAttribute("data-action"),
  	          element.getAttribute("data-role"),
  	          element.getAttribute("name"),
  	          element.textContent
  	        ].map(function (value) {
  	          return String(value || "");
  	        }).join(" ");
  	
  	        if (/(^|\s|[-_])(log\s*out|logout|sign\s*out|signout)(\s|$|[-_])/i.test(identity)) {
  	          return true;
  	        }
  	      }
  	
  	      element = element.parentElement;
  	      depth++;
  	    }
  	
  	    return false;
  	  }
  	
  	  function managerCloseForLogout() {
  	    if (destroyed) return;
  	    managerDestroyRoot();
  	  }
  	
  	  function managerCheckLogoutState() {
  	    if (destroyed) return;
  	
  	    var currentHref = String(window.location.href || "");
  	    var routeChanged = currentHref !== managerInitialLocationHref;
  	
  	    if (routeChanged) {
  	      var currentPageName = managerPageNameFromHref(currentHref);
  	
  	      if (
  	        managerInitialPageName &&
  	        currentPageName &&
  	        currentPageName !== managerInitialPageName
  	      ) {
  	        managerCloseForLogout();
  	        return;
  	      }
  	
  	      if (
  	        /(?:^|[\/#?])(login|logout|sign-in|signin|authentication|auth)(?:[\/#?]|$)/i.test(currentHref)
  	      ) {
  	        managerCloseForLogout();
  	        return;
  	      }
  	    }
  	
  	    if (!managerHadAuthenticatedContext) return;
  	
  	    var currentUserFingerprint = managerCurrentUserFingerprint();
  	    var currentTokenSignature = managerAuthTokenSignature();
  	
  	    if (
  	      (managerInitialUserFingerprint && !currentUserFingerprint) ||
  	      (managerInitialAuthTokenSignature && !currentTokenSignature)
  	    ) {
  	      managerCloseForLogout();
  	    }
  	  }
  	
  	  managerInitialPageName = managerPageNameFromHref(
  	    managerInitialLocationHref
  	  );
  	  managerInitialUserFingerprint = managerCurrentUserFingerprint();
  	  managerInitialAuthTokenSignature = managerAuthTokenSignature();
  	  managerHadAuthenticatedContext = !!(
  	    managerInitialUserFingerprint ||
  	    managerInitialAuthTokenSignature
  	  );
  	
  	  managerLogoutClickHandler = function (event) {
  	    if (managerLooksLikeLogoutControl(event && event.target)) {
  	      managerCloseForLogout();
  	    }
  	  };
  	
  	  managerLogoutEventHandler = function () {
  	    managerCloseForLogout();
  	  };
  	
  	  managerStorageHandler = function () {
  	    managerCheckLogoutState();
  	  };
  	
  	  document.addEventListener("click", managerLogoutClickHandler, true);
  	  window.addEventListener("logout", managerLogoutEventHandler, true);
  	  window.addEventListener("fif:logout", managerLogoutEventHandler, true);
  	  window.addEventListener("user:logout", managerLogoutEventHandler, true);
  	  window.addEventListener("storage", managerStorageHandler, true);
  	
  	  managerLogoutWatchTimer = window.setInterval(
  	    managerCheckLogoutState,
  	    650
  	  );
  	
  	  var MANAGER_SELECT_THEME_STYLE_ID =
  	    "fif-global-themed-select-style";
  	  var managerOpenThemedSelect = null;
  	
  	  function managerEnsureThemedSelectTheme() {
  	    if (document.getElementById(MANAGER_SELECT_THEME_STYLE_ID)) {
  	      return;
  	    }
  	
  	    var style = document.createElement("style");
  	    style.id = MANAGER_SELECT_THEME_STYLE_ID;
  	    style.textContent = `
  	      .fif-miniapp-close {
  	        width: 28px !important;
  	        height: 28px !important;
  	        min-width: 28px !important;
  	        flex: 0 0 28px !important;
  	        display: inline-grid !important;
  	        place-items: center !important;
  	        box-sizing: border-box !important;
  	        padding: 0 0 1px 0 !important;
  	        border: 1px solid rgba(204, 102, 51, 0.52) !important;
  	        border-radius: 999px !important;
  	        outline: none !important;
  	        cursor: pointer !important;
  	        color: #f4d7c5 !important;
  	        background:
  	          radial-gradient(circle at 30% 18%, rgba(255, 143, 74, 0.10), transparent 44%),
  	          linear-gradient(145deg, rgba(29, 24, 22, 0.98), rgba(8, 11, 14, 0.98)) !important;
  	        box-shadow:
  	          inset 0 1px 0 rgba(255, 255, 255, 0.035),
  	          0 5px 12px rgba(0, 0, 0, 0.30) !important;
  	        font-family: Arial, sans-serif !important;
  	        font-size: 18px !important;
  	        font-weight: 850 !important;
  	        line-height: 1 !important;
  	        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.55) !important;
  	        transition: border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease !important;
  	      }
  	
  	      .fif-miniapp-close:hover,
  	      .fif-miniapp-close:focus-visible {
  	        color: #ffffff !important;
  	        border-color: rgba(255, 139, 72, 0.84) !important;
  	        box-shadow:
  	          0 0 0 2px rgba(204, 102, 51, 0.14),
  	          0 0 13px rgba(204, 102, 51, 0.30),
  	          inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;
  	        transform: translateY(-1px) !important;
  	      }
  	
  	      .fif-miniapp-close:active {
  	        transform: translateY(0) scale(0.96) !important;
  	      }
  	
  	      .fif-miniapp-tab {
  	        flex: 1 !important;
  	        height: 38px !important;
  	        box-sizing: border-box !important;
  	        border: 1px solid rgba(255, 255, 255, 0.11) !important;
  	        border-radius: 10px !important;
  	        cursor: pointer !important;
  	        color: #dbe4ee !important;
  	        background:
  	          linear-gradient(145deg, rgba(255, 255, 255, 0.052), rgba(255, 255, 255, 0.022)) !important;
  	        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025) !important;
  	        font-size: 13px !important;
  	        font-weight: 800 !important;
  	        transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease !important;
  	      }
  	
  	      .fif-miniapp-tab:hover {
  	        color: #fff !important;
  	        border-color: rgba(204, 102, 51, 0.42) !important;
  	        background:
  	          linear-gradient(145deg, rgba(204, 102, 51, 0.11), rgba(255, 255, 255, 0.025)) !important;
  	      }
  	
  	      .fif-miniapp-tab.is-active {
  	        color: #fff !important;
  	        border: 1px solid rgba(232, 115, 57, 0.52) !important;
  	        background:
  	          radial-gradient(circle at 18% 0%, rgba(255, 145, 77, 0.16), transparent 38%),
  	          linear-gradient(145deg, rgba(164, 74, 31, 0.74), rgba(77, 31, 14, 0.92)) !important;
  	        box-shadow:
  	          inset 0 1px 0 rgba(255, 255, 255, 0.08),
  	          0 8px 18px rgba(0, 0, 0, 0.22),
  	          0 0 12px rgba(204, 102, 51, 0.10) !important;
  	      }
  	
  	      .fif-miniapp-primary {
  	        border: 1px solid rgba(232, 115, 57, 0.48) !important;
  	        color: #fff !important;
  	        background:
  	          radial-gradient(circle at 18% 0%, rgba(255, 145, 77, 0.14), transparent 40%),
  	          linear-gradient(145deg, #9c4822, #5e2914) !important;
  	        box-shadow:
  	          inset 0 1px 0 rgba(255, 255, 255, 0.07),
  	          0 9px 20px rgba(0, 0, 0, 0.23),
  	          0 0 12px rgba(204, 102, 51, 0.10) !important;
  	      }
  	
  	      .fif-miniapp-primary:hover,
  	      .fif-miniapp-primary:focus-visible {
  	        border-color: rgba(255, 139, 72, 0.72) !important;
  	        background:
  	          radial-gradient(circle at 18% 0%, rgba(255, 160, 95, 0.18), transparent 40%),
  	          linear-gradient(145deg, #aa5128, #673019) !important;
  	      }
  	
  	      .fif-themed-select {
  	        position: relative !important;
  	        width: 100% !important;
  	        min-width: 0 !important;
  	        box-sizing: border-box !important;
  	      }
  	
  	      .fif-themed-select-native {
  	        position: absolute !important;
  	        width: 1px !important;
  	        height: 1px !important;
  	        min-width: 1px !important;
  	        min-height: 1px !important;
  	        margin: 0 !important;
  	        padding: 0 !important;
  	        opacity: 0 !important;
  	        pointer-events: none !important;
  	        overflow: hidden !important;
  	        clip: rect(0 0 0 0) !important;
  	        clip-path: inset(50%) !important;
  	      }
  	
  	      .fif-themed-select-trigger {
  	        width: 100% !important;
  	        min-width: 0 !important;
  	        height: 46px !important;
  	        display: grid !important;
  	        grid-template-columns: minmax(0, 1fr) 18px !important;
  	        align-items: center !important;
  	        gap: 10px !important;
  	        padding: 0 13px !important;
  	        box-sizing: border-box !important;
  	        border: 1px solid rgba(255, 122, 36, 0.62) !important;
  	        border-radius: 13px !important;
  	        outline: none !important;
  	        cursor: pointer !important;
  	        text-align: left !important;
  	        color: #fff !important;
  	        background:
  	          radial-gradient(
  	            circle at 18% 0%,
  	            rgba(255, 133, 49, 0.10),
  	            transparent 34%
  	          ),
  	          linear-gradient(
  	            145deg,
  	            rgba(16, 17, 16, 0.78),
  	            rgba(3, 7, 7, 0.88)
  	          ) !important;
  	        box-shadow:
  	          inset 0 0 0 1px rgba(255, 255, 255, 0.025),
  	          0 7px 14px rgba(0, 0, 0, 0.18) !important;
  	        font-family:
  	          Inter,
  	          system-ui,
  	          -apple-system,
  	          BlinkMacSystemFont,
  	          "Segoe UI",
  	          Arial,
  	          sans-serif !important;
  	        font-size: 14px !important;
  	        font-weight: 800 !important;
  	        text-shadow: 0 2px 5px rgba(0, 0, 0, 0.45) !important;
  	      }
  	
  	      .fif-themed-select-trigger:hover {
  	        border-color: rgba(255, 138, 61, 0.82) !important;
  	      }
  	
  	      .fif-themed-select-trigger:focus-visible,
  	      .fif-themed-select-trigger[aria-expanded="true"] {
  	        border-color: rgba(255, 138, 61, 0.95) !important;
  	        box-shadow:
  	          0 0 0 1px rgba(255, 138, 61, 0.24),
  	          0 0 16px rgba(255, 105, 25, 0.16),
  	          inset 0 0 0 1px rgba(255, 255, 255, 0.025) !important;
  	      }
  	
  	      .fif-themed-select-trigger:disabled {
  	        opacity: 0.45 !important;
  	        cursor: default !important;
  	      }
  	
  	      .fif-themed-select-value {
  	        min-width: 0 !important;
  	        overflow: hidden !important;
  	        text-overflow: ellipsis !important;
  	        white-space: nowrap !important;
  	      }
  	
  	      .fif-themed-select-trigger.is-placeholder
  	      .fif-themed-select-value {
  	        color: rgba(255, 255, 255, 0.48) !important;
  	      }
  	
  	      .fif-themed-select-chevron {
  	        width: 9px !important;
  	        height: 9px !important;
  	        justify-self: end !important;
  	        border-right: 2px solid #ff8a3c !important;
  	        border-bottom: 2px solid #ff8a3c !important;
  	        transform: rotate(45deg) translateY(-2px) !important;
  	        transition: transform 140ms ease !important;
  	        box-sizing: border-box !important;
  	      }
  	
  	      .fif-themed-select-trigger[aria-expanded="true"]
  	      .fif-themed-select-chevron {
  	        transform: rotate(225deg) translate(-2px, -2px) !important;
  	      }
  	
  	      .fif-themed-select-menu {
  	        position: fixed !important;
  	        z-index: 2147483647 !important;
  	        display: none;
  	        padding: 5px !important;
  	        margin: 0 !important;
  	        box-sizing: border-box !important;
  	        overflow-x: hidden !important;
  	        overflow-y: auto !important;
  	        color: #fff !important;
  	        background:
  	          radial-gradient(
  	            circle at 18% 0%,
  	            rgba(255, 133, 49, 0.14),
  	            transparent 35%
  	          ),
  	          repeating-radial-gradient(
  	            ellipse at 34% 118%,
  	            transparent 0,
  	            transparent 9px,
  	            rgba(255, 116, 34, 0.12) 10px,
  	            transparent 12px
  	          ),
  	          linear-gradient(
  	            145deg,
  	            rgba(16, 17, 16, 0.985),
  	            rgba(3, 7, 7, 0.99)
  	          ) !important;
  	        border: 1px solid rgba(255, 122, 36, 0.52) !important;
  	        border-radius: 13px !important;
  	        box-shadow:
  	          0 18px 34px rgba(0, 0, 0, 0.48),
  	          inset 0 1px 0 rgba(255, 255, 255, 0.055),
  	          inset 0 -18px 38px rgba(0, 0, 0, 0.24) !important;
  	        font-family:
  	          Inter,
  	          system-ui,
  	          -apple-system,
  	          BlinkMacSystemFont,
  	          "Segoe UI",
  	          Arial,
  	          sans-serif !important;
  	      }
  	
  	      .fif-themed-select-menu.is-open {
  	        display: block !important;
  	      }
  	
  	      .fif-themed-select-option {
  	        width: 100% !important;
  	        min-height: 38px !important;
  	        display: flex !important;
  	        align-items: center !important;
  	        padding: 8px 11px !important;
  	        margin: 2px 0 !important;
  	        box-sizing: border-box !important;
  	        border: 0 !important;
  	        border-radius: 9px !important;
  	        outline: none !important;
  	        cursor: pointer !important;
  	        text-align: left !important;
  	        color: rgba(255, 255, 255, 0.88) !important;
  	        background: transparent !important;
  	        font-size: 13px !important;
  	        font-weight: 800 !important;
  	      }
  	
  	      .fif-themed-select-option:hover,
  	      .fif-themed-select-option:focus-visible {
  	        color: #fff !important;
  	        background: rgba(255, 138, 61, 0.14) !important;
  	      }
  	
  	      .fif-themed-select-option.is-selected {
  	        color: #fff !important;
  	        background:
  	          linear-gradient(
  	            145deg,
  	            rgba(255, 122, 36, 0.28),
  	            rgba(95, 42, 17, 0.32)
  	          ) !important;
  	        box-shadow:
  	          inset 0 0 0 1px rgba(255, 138, 61, 0.34),
  	          inset 0 0 18px rgba(255, 105, 25, 0.12) !important;
  	      }
  	
  	      .fif-themed-select-option:disabled {
  	        opacity: 0.35 !important;
  	        cursor: default !important;
  	      }
  	
  	      .fif-themed-select-menu::-webkit-scrollbar {
  	        width: 5px !important;
  	        height: 5px !important;
  	      }
  	
  	      .fif-themed-select-menu::-webkit-scrollbar-thumb {
  	        background: rgba(255, 122, 36, 0.42) !important;
  	        border-radius: 999px !important;
  	      }
  	
  	      .fif-themed-select-menu::-webkit-scrollbar-track {
  	        background: rgba(0, 0, 0, 0.20) !important;
  	      }
  	
  	      .fif-record-delete-icon-button {
  	        width: 34px !important;
  	        height: 34px !important;
  	        min-width: 34px !important;
  	        flex: 0 0 34px !important;
  	        display: inline-grid !important;
  	        place-items: center !important;
  	        padding: 0 !important;
  	        border: 1px solid rgba(177, 76, 36, 0.72) !important;
  	        border-radius: 10px !important;
  	        outline: none !important;
  	        cursor: pointer !important;
  	        color: #f3c6b2 !important;
  	        background:
  	          radial-gradient(circle at 28% 18%, rgba(255, 124, 68, 0.12), transparent 44%),
  	          linear-gradient(145deg, rgba(35, 18, 14, 0.98), rgba(11, 10, 11, 0.98)) !important;
  	        box-shadow:
  	          inset 0 1px 0 rgba(255, 255, 255, 0.035),
  	          0 7px 16px rgba(0, 0, 0, 0.28) !important;
  	        transition: transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease !important;
  	      }
  	
  	      .fif-record-delete-icon-button svg {
  	        width: 15px !important;
  	        height: 15px !important;
  	        display: block !important;
  	        fill: none !important;
  	        stroke: currentColor !important;
  	        stroke-width: 1.9 !important;
  	        stroke-linecap: round !important;
  	        stroke-linejoin: round !important;
  	        pointer-events: none !important;
  	      }
  	
  	      .fif-record-delete-icon-button:hover,
  	      .fif-record-delete-icon-button:focus-visible {
  	        color: #fff !important;
  	        border-color: rgba(232, 91, 48, 0.94) !important;
  	        box-shadow:
  	          0 0 0 2px rgba(202, 61, 31, 0.13),
  	          0 0 16px rgba(202, 61, 31, 0.24),
  	          inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;
  	        transform: translateY(-1px) !important;
  	      }
  	
  	      .fif-record-delete-icon-button:active {
  	        transform: translateY(0) scale(0.96) !important;
  	      }
  	
  	      .fif-record-delete-icon-button:disabled {
  	        opacity: 0.35 !important;
  	        cursor: default !important;
  	        transform: none !important;
  	        box-shadow: none !important;
  	      }
  	
  	      .fif-record-delete-overlay {
  	        position: fixed !important;
  	        inset: 0 !important;
  	        z-index: 2147483647 !important;
  	        display: flex !important;
  	        align-items: center !important;
  	        justify-content: center !important;
  	        padding: 18px !important;
  	        box-sizing: border-box !important;
  	        background:
  	          radial-gradient(circle at 50% 38%, rgba(111, 33, 19, 0.16), transparent 38%),
  	          rgba(0, 0, 0, 0.78) !important;
  	        backdrop-filter: blur(7px) !important;
  	      }
  	
  	      .fif-record-delete-card {
  	        width: min(480px, calc(100vw - 36px)) !important;
  	        overflow: hidden !important;
  	        border: 1px solid rgba(221, 70, 40, 0.82) !important;
  	        border-radius: 26px !important;
  	        color: #f8fafc !important;
  	        background:
  	          radial-gradient(circle at 16% 0%, rgba(184, 58, 31, 0.10), transparent 36%),
  	          linear-gradient(145deg, rgba(24, 13, 12, 0.995), rgba(7, 10, 13, 0.995)) !important;
  	        box-shadow:
  	          0 28px 70px rgba(0, 0, 0, 0.60),
  	          0 0 30px rgba(153, 43, 24, 0.17),
  	          inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
  	        font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	      }
  	
  	      .fif-record-delete-head {
  	        display: grid !important;
  	        grid-template-columns: 42px minmax(0, 1fr) 34px !important;
  	        align-items: center !important;
  	        gap: 13px !important;
  	        padding: 18px 18px 15px !important;
  	        border-bottom: 1px solid rgba(214, 62, 35, 0.32) !important;
  	      }
  	
  	      .fif-record-delete-alert {
  	        width: 40px !important;
  	        height: 40px !important;
  	        display: grid !important;
  	        place-items: center !important;
  	        border: 1px solid rgba(233, 71, 40, 0.72) !important;
  	        border-radius: 50% !important;
  	        color: #fff !important;
  	        background: radial-gradient(circle, rgba(179, 49, 27, 0.72), rgba(90, 24, 17, 0.68)) !important;
  	        box-shadow: 0 0 18px rgba(202, 54, 31, 0.25) !important;
  	        font-size: 20px !important;
  	        font-weight: 900 !important;
  	      }
  	
  	      .fif-record-delete-title {
  	        font-size: 17px !important;
  	        font-weight: 900 !important;
  	        color: #f8fafc !important;
  	      }
  	
  	      .fif-record-delete-subtitle {
  	        margin-top: 3px !important;
  	        color: #db704d !important;
  	        font-size: 9px !important;
  	        font-weight: 900 !important;
  	        letter-spacing: 0.14em !important;
  	        text-transform: uppercase !important;
  	      }
  	
  	      .fif-record-delete-close {
  	        width: 34px !important;
  	        height: 34px !important;
  	        display: grid !important;
  	        place-items: center !important;
  	        padding: 0 !important;
  	        border: 1px solid rgba(255, 255, 255, 0.10) !important;
  	        border-radius: 12px !important;
  	        cursor: pointer !important;
  	        color: #c7c7c7 !important;
  	        background: rgba(255, 255, 255, 0.045) !important;
  	        font-size: 20px !important;
  	        font-weight: 900 !important;
  	      }
  	
  	      .fif-record-delete-body {
  	        padding: 17px 18px 16px !important;
  	      }
  	
  	      .fif-record-delete-name {
  	        padding: 11px 13px !important;
  	        border: 1px solid rgba(255, 255, 255, 0.09) !important;
  	        border-radius: 14px !important;
  	        color: #fff !important;
  	        background: linear-gradient(145deg, rgba(114, 42, 29, 0.28), rgba(255, 255, 255, 0.035)) !important;
  	        font-size: 14px !important;
  	        font-weight: 900 !important;
  	      }
  	
  	      .fif-record-delete-copy,
  	      .fif-record-delete-warning {
  	        margin-top: 13px !important;
  	        color: #c6b8b3 !important;
  	        font-size: 11px !important;
  	        font-weight: 650 !important;
  	        line-height: 1.5 !important;
  	      }
  	
  	      .fif-record-delete-warning {
  	        padding: 10px 12px !important;
  	        border: 1px solid rgba(211, 94, 45, 0.38) !important;
  	        border-radius: 13px !important;
  	        color: #e8c0ae !important;
  	        background: rgba(97, 36, 21, 0.22) !important;
  	      }
  	
  	      .fif-record-delete-label {
  	        display: block !important;
  	        margin-top: 15px !important;
  	        color: #b9aaa5 !important;
  	        font-size: 10px !important;
  	        font-weight: 900 !important;
  	        text-transform: uppercase !important;
  	      }
  	
  	      .fif-record-delete-input {
  	        width: 100% !important;
  	        height: 46px !important;
  	        margin-top: 7px !important;
  	        padding: 0 13px !important;
  	        box-sizing: border-box !important;
  	        border: 1px solid rgba(214, 91, 42, 0.78) !important;
  	        border-radius: 14px !important;
  	        outline: none !important;
  	        color: #fff !important;
  	        background: linear-gradient(180deg, rgba(19, 19, 20, 0.99), rgba(8, 10, 12, 0.99)) !important;
  	        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
  	        font-size: 16px !important;
  	        font-weight: 850 !important;
  	        letter-spacing: 0.08em !important;
  	      }
  	
  	      .fif-record-delete-input:focus {
  	        border-color: rgba(239, 110, 49, 0.96) !important;
  	        box-shadow: 0 0 0 3px rgba(202, 67, 31, 0.14) !important;
  	      }
  	
  	      .fif-record-delete-error {
  	        min-height: 16px !important;
  	        margin-top: 6px !important;
  	        color: #df7664 !important;
  	        font-size: 10px !important;
  	        font-weight: 750 !important;
  	        opacity: 0 !important;
  	      }
  	
  	      .fif-record-delete-error.visible {
  	        opacity: 1 !important;
  	      }
  	
  	      .fif-record-delete-actions {
  	        display: grid !important;
  	        grid-template-columns: 1fr 1fr !important;
  	        gap: 10px !important;
  	        padding: 0 18px 18px !important;
  	      }
  	
  	      .fif-record-delete-action {
  	        height: 42px !important;
  	        border-radius: 13px !important;
  	        cursor: pointer !important;
  	        font-size: 12px !important;
  	        font-weight: 900 !important;
  	        text-transform: uppercase !important;
  	      }
  	
  	      .fif-record-delete-confirm {
  	        border: 1px solid rgba(216, 57, 37, 0.72) !important;
  	        color: #fff !important;
  	        background: linear-gradient(145deg, rgba(132, 37, 25, 0.92), rgba(72, 19, 16, 0.94)) !important;
  	      }
  	
  	      .fif-record-delete-cancel {
  	        border: 1px solid rgba(255, 255, 255, 0.11) !important;
  	        color: #f4f4f5 !important;
  	        background: linear-gradient(145deg, rgba(255, 255, 255, 0.075), rgba(77, 42, 27, 0.34)) !important;
  	      }
  	
  	      .fif-record-delete-action:disabled {
  	        opacity: 0.34 !important;
  	        cursor: default !important;
  	      }
  	
  	      .fif-database-loading-overlay {
  	        position: fixed !important;
  	        inset: 0 !important;
  	        z-index: 2147483647 !important;
  	        display: grid !important;
  	        place-items: center !important;
  	        box-sizing: border-box !important;
  	        padding: 24px !important;
  	        opacity: 0 !important;
  	        visibility: hidden !important;
  	        pointer-events: none !important;
  	        background:
  	          radial-gradient(
  	            circle at 50% 45%,
  	            rgba(113, 47, 17, 0.16),
  	            transparent 34%
  	          ),
  	          rgba(0, 0, 0, 0.94) !important;
  	        backdrop-filter: blur(8px) !important;
  	        transition:
  	          opacity 320ms ease,
  	          visibility 320ms ease !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-visible {
  	        opacity: 1 !important;
  	        visibility: visible !important;
  	        pointer-events: auto !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-leaving {
  	        opacity: 0 !important;
  	        pointer-events: none !important;
  	      }
  	
  	      .fif-database-loading-content {
  	        width: min(420px, calc(100vw - 48px)) !important;
  	        display: flex !important;
  	        flex-direction: column !important;
  	        align-items: center !important;
  	        justify-content: center !important;
  	        gap: 18px !important;
  	        padding: 30px 26px !important;
  	        box-sizing: border-box !important;
  	        border: 1px solid rgba(198, 92, 40, 0.30) !important;
  	        border-radius: 26px !important;
  	        color: #fff !important;
  	        background:
  	          radial-gradient(
  	            circle at 50% 0%,
  	            rgba(225, 109, 48, 0.09),
  	            transparent 44%
  	          ),
  	          linear-gradient(
  	            145deg,
  	            rgba(16, 17, 19, 0.92),
  	            rgba(3, 6, 9, 0.96)
  	          ) !important;
  	        box-shadow:
  	          0 30px 80px rgba(0, 0, 0, 0.66),
  	          inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
  	        transform: translateY(8px) scale(0.985) !important;
  	        transition: transform 320ms ease !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-visible
  	      .fif-database-loading-content {
  	        transform: translateY(0) scale(1) !important;
  	      }
  	
  	      .fif-database-loading-logo {
  	        width: 150px !important;
  	        min-height: 62px !important;
  	        display: grid !important;
  	        place-items: center !important;
  	        animation:
  	          fifDatabaseLogoThrob 1.45s ease-in-out infinite !important;
  	        filter:
  	          drop-shadow(0 0 16px rgba(219, 102, 43, 0.22)) !important;
  	      }
  	
  	      .fif-database-loading-logo
  	      .fif-manager-logo-img {
  	        width: 150px !important;
  	        max-height: 70px !important;
  	        object-fit: contain !important;
  	      }
  	
  	      .fif-database-loading-logo
  	      .fif-manager-logo-svg,
  	      .fif-database-loading-logo
  	      .fif-manager-logo-svg svg {
  	        width: 150px !important;
  	        max-height: 70px !important;
  	      }
  	
  	      .fif-database-loading-logo
  	      .fif-manager-logo-fallback {
  	        width: 76px !important;
  	        height: 52px !important;
  	        display: grid !important;
  	        place-items: center !important;
  	        border: 1px solid rgba(224, 111, 55, 0.54) !important;
  	        border-radius: 16px !important;
  	        color: #ffb083 !important;
  	        background: rgba(100, 42, 18, 0.24) !important;
  	        font-size: 20px !important;
  	        font-weight: 950 !important;
  	      }
  	
  	      .fif-database-loading-status {
  	        min-height: 22px !important;
  	        color: #f0d7c8 !important;
  	        font-family:
  	          Inter,
  	          system-ui,
  	          -apple-system,
  	          BlinkMacSystemFont,
  	          "Segoe UI",
  	          Arial,
  	          sans-serif !important;
  	        font-size: 14px !important;
  	        font-weight: 800 !important;
  	        line-height: 1.45 !important;
  	        text-align: center !important;
  	        letter-spacing: 0.01em !important;
  	        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.70) !important;
  	        transition: opacity 160ms ease !important;
  	      }
  	
  	      .fif-database-loading-note {
  	        margin-top: -8px !important;
  	        color: rgba(203, 213, 225, 0.62) !important;
  	        font-size: 10px !important;
  	        font-weight: 650 !important;
  	        line-height: 1.45 !important;
  	        text-align: center !important;
  	      }
  	
  	      .fif-database-loading-ok {
  	        min-width: 118px !important;
  	        height: 42px !important;
  	        display: none !important;
  	        align-items: center !important;
  	        justify-content: center !important;
  	        margin-top: 2px !important;
  	        padding: 0 22px !important;
  	        border: 1px solid rgba(232, 115, 57, 0.56) !important;
  	        border-radius: 13px !important;
  	        outline: none !important;
  	        cursor: pointer !important;
  	        color: #fff !important;
  	        background:
  	          radial-gradient(circle at 18% 0%, rgba(255, 145, 77, 0.15), transparent 40%),
  	          linear-gradient(145deg, #9c4822, #5e2914) !important;
  	        box-shadow:
  	          inset 0 1px 0 rgba(255, 255, 255, 0.07),
  	          0 9px 20px rgba(0, 0, 0, 0.28) !important;
  	        font-size: 12px !important;
  	        font-weight: 900 !important;
  	        text-transform: uppercase !important;
  	      }
  	
  	      .fif-database-loading-ok:hover,
  	      .fif-database-loading-ok:focus-visible {
  	        border-color: rgba(255, 139, 72, 0.78) !important;
  	        background:
  	          radial-gradient(circle at 18% 0%, rgba(255, 160, 95, 0.19), transparent 40%),
  	          linear-gradient(145deg, #aa5128, #673019) !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-error .fif-database-loading-content {
  	        border-color: rgba(214, 65, 43, 0.72) !important;
  	        background:
  	          radial-gradient(circle at 50% 0%, rgba(185, 46, 30, 0.15), transparent 46%),
  	          linear-gradient(145deg, rgba(25, 12, 12, 0.97), rgba(6, 8, 11, 0.985)) !important;
  	        box-shadow:
  	          0 30px 80px rgba(0, 0, 0, 0.70),
  	          0 0 28px rgba(175, 43, 28, 0.16),
  	          inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-error .fif-database-loading-logo {
  	        animation-play-state: paused !important;
  	        filter: drop-shadow(0 0 17px rgba(211, 64, 38, 0.28)) !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-error .fif-database-loading-status {
  	        color: #ffd9cf !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-error .fif-database-loading-note {
  	        color: rgba(255, 190, 174, 0.72) !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-error .fif-database-loading-ok {
  	        display: inline-flex !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-success .fif-database-loading-content {
  	        border-color: rgba(191, 98, 45, 0.46) !important;
  	        box-shadow:
  	          0 30px 80px rgba(0, 0, 0, 0.66),
  	          0 0 26px rgba(203, 95, 40, 0.14),
  	          inset 0 1px 0 rgba(255, 255, 255, 0.035) !important;
  	      }
  	
  	      .fif-database-loading-overlay.is-success .fif-database-loading-logo {
  	        animation: fifDatabaseLogoComplete 620ms ease-in-out 1 !important;
  	      }
  	
  	      @keyframes fifDatabaseLogoComplete {
  	        0% { transform: scale(0.98); opacity: 0.82; }
  	        52% { transform: scale(1.075); opacity: 1; }
  	        100% { transform: scale(1); opacity: 1; }
  	      }
  	
  	      @keyframes fifDatabaseLogoThrob {
  	        0%,
  	        100% {
  	          transform: scale(0.97);
  	          opacity: 0.78;
  	        }
  	
  	        50% {
  	          transform: scale(1.045);
  	          opacity: 1;
  	        }
  	      }
  	
  	      @media (prefers-reduced-motion: reduce) {
  	        .fif-database-loading-overlay,
  	        .fif-database-loading-content,
  	        .fif-database-loading-logo {
  	          transition-duration: 0.01ms !important;
  	          animation-duration: 0.01ms !important;
  	          animation-iteration-count: 1 !important;
  	        }
  	      }
  	    `;
  	
  	    document.head.appendChild(style);
  	  }
  	
  	  function managerIsOtherSelectOption(option) {
  	    if (!option) return false;
  	
  	    var value = String(option.value || "")
  	      .trim()
  	      .toLowerCase();
  	    var label = String(
  	      option.textContent ||
  	      option.label ||
  	      ""
  	    )
  	      .trim()
  	      .toLowerCase();
  	
  	    return value === "other" || label === "other";
  	  }
  	
  	  function managerSortSelectOptionsNatural(select) {
  	    if (
  	      !select ||
  	      !(select instanceof HTMLSelectElement) ||
  	      select.__fifSortingOptions
  	    ) {
  	      return;
  	    }
  	
  	    var options = Array.prototype.slice.call(
  	      select.options || []
  	    );
  	
  	    if (options.length < 2) return;
  	
  	    var selectedValue = String(select.value || "");
  	    var selectedText = select.selectedIndex >= 0
  	      ? String(
  	          select.options[select.selectedIndex].textContent ||
  	          ""
  	        )
  	      : "";
  	
  	    var sorted = options.slice().sort(function (left, right) {
  	      var leftPlaceholder =
  	        String(left.value || "") === "" ||
  	        left.disabled;
  	      var rightPlaceholder =
  	        String(right.value || "") === "" ||
  	        right.disabled;
  	
  	      if (leftPlaceholder !== rightPlaceholder) {
  	        return leftPlaceholder ? -1 : 1;
  	      }
  	
  	      var leftOther =
  	        managerIsOtherSelectOption(left);
  	      var rightOther =
  	        managerIsOtherSelectOption(right);
  	
  	      if (leftOther !== rightOther) {
  	        return leftOther ? -1 : 1;
  	      }
  	
  	      return String(
  	        left.textContent ||
  	        left.label ||
  	        left.value ||
  	        ""
  	      ).localeCompare(
  	        String(
  	          right.textContent ||
  	          right.label ||
  	          right.value ||
  	          ""
  	        ),
  	        undefined,
  	        {
  	          numeric: true,
  	          sensitivity: "base"
  	        }
  	      );
  	    });
  	
  	    var changed = false;
  	
  	    for (var index = 0; index < options.length; index++) {
  	      if (options[index] !== sorted[index]) {
  	        changed = true;
  	        break;
  	      }
  	    }
  	
  	    if (!changed) return;
  	
  	    select.__fifSortingOptions = true;
  	
  	    try {
  	      for (
  	        var sortedIndex = 0;
  	        sortedIndex < sorted.length;
  	        sortedIndex++
  	      ) {
  	        select.appendChild(sorted[sortedIndex]);
  	      }
  	
  	      var restored = false;
  	
  	      for (
  	        var optionIndex = 0;
  	        optionIndex < select.options.length;
  	        optionIndex++
  	      ) {
  	        var option = select.options[optionIndex];
  	
  	        if (
  	          String(option.value || "") ===
  	          selectedValue
  	        ) {
  	          option.selected = true;
  	          restored = true;
  	          break;
  	        }
  	      }
  	
  	      if (!restored && selectedText) {
  	        for (
  	          var textIndex = 0;
  	          textIndex < select.options.length;
  	          textIndex++
  	        ) {
  	          if (
  	            String(
  	              select.options[textIndex].textContent ||
  	              ""
  	            ) === selectedText
  	          ) {
  	            select.options[textIndex].selected = true;
  	            break;
  	          }
  	        }
  	      }
  	    } finally {
  	      select.__fifSortingOptions = false;
  	    }
  	  }
  	
  	  function managerDispatchSelectEvent(select, eventName) {
  	    try {
  	      select.dispatchEvent(
  	        new Event(eventName, {
  	          bubbles: true
  	        })
  	      );
  	      return;
  	    } catch (_) {}
  	
  	    try {
  	      var event = document.createEvent("Event");
  	      event.initEvent(eventName, true, false);
  	      select.dispatchEvent(event);
  	    } catch (_) {}
  	  }
  	
  	  function managerCloseThemedSelect(instance) {
  	    var target = instance || managerOpenThemedSelect;
  	    if (!target) return;
  	
  	    try {
  	      target.menu.classList.remove("is-open");
  	      target.menu.setAttribute("aria-hidden", "true");
  	      target.trigger.setAttribute("aria-expanded", "false");
  	    } catch (_) {}
  	
  	    try {
  	      document.removeEventListener(
  	        "mousedown",
  	        target.onOutsidePointer,
  	        true
  	      );
  	      document.removeEventListener(
  	        "keydown",
  	        target.onKeyDown,
  	        true
  	      );
  	      window.removeEventListener(
  	        "resize",
  	        target.onPositionChange
  	      );
  	      window.removeEventListener(
  	        "scroll",
  	        target.onPositionChange,
  	        true
  	      );
  	    } catch (_) {}
  	
  	    if (managerOpenThemedSelect === target) {
  	      managerOpenThemedSelect = null;
  	    }
  	  }
  	
  	  function managerPositionThemedSelect(instance) {
  	    if (
  	      !instance ||
  	      !instance.trigger ||
  	      !instance.menu ||
  	      !instance.trigger.isConnected
  	    ) {
  	      return;
  	    }
  	
  	    var rect = instance.trigger.getBoundingClientRect();
  	    var viewportWidth =
  	      window.innerWidth ||
  	      document.documentElement.clientWidth ||
  	      1280;
  	    var viewportHeight =
  	      window.innerHeight ||
  	      document.documentElement.clientHeight ||
  	      800;
  	    var edge = 8;
  	    var desiredMaxHeight = 280;
  	    var spaceBelow = viewportHeight - rect.bottom - edge;
  	    var spaceAbove = rect.top - edge;
  	    var openAbove =
  	      spaceBelow < 180 &&
  	      spaceAbove > spaceBelow;
  	    var usableHeight = Math.max(
  	      90,
  	      Math.min(
  	        desiredMaxHeight,
  	        openAbove ? spaceAbove - 6 : spaceBelow - 6
  	      )
  	    );
  	    var left = Math.max(
  	      edge,
  	      Math.min(
  	        rect.left,
  	        viewportWidth - rect.width - edge
  	      )
  	    );
  	
  	    instance.menu.style.left = left + "px";
  	    instance.menu.style.width =
  	      Math.max(160, rect.width) + "px";
  	    instance.menu.style.maxHeight =
  	      usableHeight + "px";
  	
  	    if (openAbove) {
  	      instance.menu.style.top = "auto";
  	      instance.menu.style.bottom =
  	        Math.max(edge, viewportHeight - rect.top + 6) +
  	        "px";
  	    } else {
  	      instance.menu.style.bottom = "auto";
  	      instance.menu.style.top =
  	        Math.max(edge, rect.bottom + 6) + "px";
  	    }
  	  }
  	
  	  function managerBuildThemedSelectMenu(instance) {
  	    if (!instance || !instance.select || !instance.menu) {
  	      return;
  	    }
  	
  	    var select = instance.select;
  	    var menu = instance.menu;
  	    var html = "";
  	
  	    for (var index = 0; index < select.options.length; index++) {
  	      var option = select.options[index];
  	      var selected = index === select.selectedIndex;
  	
  	      html +=
  	        '<button type="button" ' +
  	        'class="fif-themed-select-option' +
  	        (selected ? " is-selected" : "") +
  	        '" data-fif-select-index="' +
  	        index +
  	        '"' +
  	        (option.disabled ? " disabled" : "") +
  	        ' role="option" aria-selected="' +
  	        (selected ? "true" : "false") +
  	        '">' +
  	        managerEscape(
  	          String(option.textContent || option.label || option.value || "")
  	        ) +
  	        "</button>";
  	    }
  	
  	    menu.innerHTML = html;
  	
  	    var buttons = menu.querySelectorAll(
  	      "[data-fif-select-index]"
  	    );
  	
  	    for (var buttonIndex = 0;
  	      buttonIndex < buttons.length;
  	      buttonIndex++
  	    ) {
  	      buttons[buttonIndex].onclick = function (event) {
  	        event.preventDefault();
  	        event.stopPropagation();
  	
  	        if (this.disabled) return;
  	
  	        var nextIndex = Number(
  	          this.getAttribute("data-fif-select-index")
  	        );
  	
  	        if (
  	          !Number.isFinite(nextIndex) ||
  	          nextIndex < 0 ||
  	          nextIndex >= select.options.length
  	        ) {
  	          return;
  	        }
  	
  	        select.selectedIndex = nextIndex;
  	        select.value = select.options[nextIndex].value;
  	
  	        managerDispatchSelectEvent(select, "input");
  	        managerDispatchSelectEvent(select, "change");
  	        managerRefreshThemedSelect(select);
  	        managerCloseThemedSelect(instance);
  	
  	        try {
  	          instance.trigger.focus();
  	        } catch (_) {}
  	      };
  	    }
  	  }
  	
  	  function managerRefreshThemedSelect(select) {
  	    managerSortSelectOptionsNatural(select);
  	
  	    var instance = select && select.__fifThemedSelect;
  	    if (!instance) return;
  	
  	    var option =
  	      select.selectedIndex >= 0
  	        ? select.options[select.selectedIndex]
  	        : null;
  	    var label = option
  	      ? String(option.textContent || option.label || option.value || "")
  	      : "Select";
  	    var placeholder =
  	      !option ||
  	      option.disabled ||
  	      String(option.value || "") === "";
  	
  	    instance.valueNode.textContent = label;
  	    instance.trigger.disabled = !!select.disabled;
  	    instance.trigger.classList.toggle(
  	      "is-placeholder",
  	      placeholder
  	    );
  	
  	    if (
  	      instance.menu &&
  	      instance.menu.classList.contains("is-open")
  	    ) {
  	      managerBuildThemedSelectMenu(instance);
  	      managerPositionThemedSelect(instance);
  	    }
  	  }
  	
  	  function managerInstallThemedSelect(select) {
  	    if (
  	      !select ||
  	      !(select instanceof HTMLSelectElement) ||
  	      select.__fifThemedSelect
  	    ) {
  	      return select && select.__fifThemedSelect
  	        ? select.__fifThemedSelect
  	        : null;
  	    }
  	
  	    managerEnsureThemedSelectTheme();
  	    managerSortSelectOptionsNatural(select);
  	
  	    var parent = select.parentNode;
  	    if (!parent) return null;
  	
  	    var wrapper = document.createElement("div");
  	    wrapper.className = "fif-themed-select";
  	
  	    parent.insertBefore(wrapper, select);
  	    wrapper.appendChild(select);
  	
  	    var trigger = document.createElement("button");
  	    trigger.type = "button";
  	    trigger.className = "fif-themed-select-trigger";
  	    trigger.setAttribute("aria-haspopup", "listbox");
  	    trigger.setAttribute("aria-expanded", "false");
  	
  	    var valueNode = document.createElement("span");
  	    valueNode.className = "fif-themed-select-value";
  	
  	    var chevron = document.createElement("span");
  	    chevron.className = "fif-themed-select-chevron";
  	    chevron.setAttribute("aria-hidden", "true");
  	
  	    trigger.appendChild(valueNode);
  	    trigger.appendChild(chevron);
  	    wrapper.appendChild(trigger);
  	
  	    var menu = document.createElement("div");
  	    menu.className = "fif-themed-select-menu";
  	    menu.setAttribute("role", "listbox");
  	    menu.setAttribute("aria-hidden", "true");
  	    document.body.appendChild(menu);
  	
  	    var previousTabIndex = select.getAttribute("tabindex");
  	    var previousAriaHidden =
  	      select.getAttribute("aria-hidden");
  	
  	    select.classList.add("fif-themed-select-native");
  	    select.setAttribute("aria-hidden", "true");
  	    select.tabIndex = -1;
  	
  	    var instance = {
  	      select: select,
  	      wrapper: wrapper,
  	      trigger: trigger,
  	      valueNode: valueNode,
  	      menu: menu,
  	      previousTabIndex: previousTabIndex,
  	      previousAriaHidden: previousAriaHidden,
  	      observer: null,
  	      onSelectChange: null,
  	      onOutsidePointer: null,
  	      onKeyDown: null,
  	      onPositionChange: null
  	    };
  	
  	    instance.onSelectChange = function () {
  	      managerRefreshThemedSelect(select);
  	    };
  	
  	    instance.onOutsidePointer = function (event) {
  	      if (
  	        wrapper.contains(event.target) ||
  	        menu.contains(event.target)
  	      ) {
  	        return;
  	      }
  	
  	      managerCloseThemedSelect(instance);
  	    };
  	
  	    instance.onKeyDown = function (event) {
  	      if (event.key === "Escape") {
  	        managerCloseThemedSelect(instance);
  	
  	        try {
  	          trigger.focus();
  	        } catch (_) {}
  	      }
  	    };
  	
  	    instance.onPositionChange = function () {
  	      if (menu.classList.contains("is-open")) {
  	        managerPositionThemedSelect(instance);
  	      }
  	    };
  	
  	    trigger.onclick = function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	
  	      if (select.disabled) return;
  	
  	      if (
  	        managerOpenThemedSelect === instance &&
  	        menu.classList.contains("is-open")
  	      ) {
  	        managerCloseThemedSelect(instance);
  	        return;
  	      }
  	
  	      managerCloseThemedSelect();
  	
  	      managerBuildThemedSelectMenu(instance);
  	      menu.classList.add("is-open");
  	      menu.setAttribute("aria-hidden", "false");
  	      trigger.setAttribute("aria-expanded", "true");
  	      managerOpenThemedSelect = instance;
  	
  	      managerPositionThemedSelect(instance);
  	
  	      document.addEventListener(
  	        "mousedown",
  	        instance.onOutsidePointer,
  	        true
  	      );
  	      document.addEventListener(
  	        "keydown",
  	        instance.onKeyDown,
  	        true
  	      );
  	      window.addEventListener(
  	        "resize",
  	        instance.onPositionChange
  	      );
  	      window.addEventListener(
  	        "scroll",
  	        instance.onPositionChange,
  	        true
  	      );
  	
  	      requestAnimationFrame(function () {
  	        var selectedButton = menu.querySelector(
  	          ".fif-themed-select-option.is-selected"
  	        );
  	
  	        if (selectedButton) {
  	          try {
  	            selectedButton.scrollIntoView({
  	              block: "nearest"
  	            });
  	            selectedButton.focus();
  	          } catch (_) {}
  	        }
  	      });
  	    };
  	
  	    select.addEventListener(
  	      "change",
  	      instance.onSelectChange
  	    );
  	
  	    instance.observer = new MutationObserver(function () {
  	      managerRefreshThemedSelect(select);
  	    });
  	
  	    instance.observer.observe(select, {
  	      childList: true,
  	      subtree: true,
  	      characterData: true,
  	      attributes: true
  	    });
  	
  	    select.__fifThemedSelect = instance;
  	    managerRefreshThemedSelect(select);
  	
  	    return instance;
  	  }
  	
  	  function managerThemeSelects(root) {
  	    if (!root) return;
  	
  	    if (root instanceof HTMLSelectElement) {
  	      managerInstallThemedSelect(root);
  	      return;
  	    }
  	
  	    var selects = root.querySelectorAll
  	      ? root.querySelectorAll("select")
  	      : [];
  	
  	    for (var index = 0; index < selects.length; index++) {
  	      managerInstallThemedSelect(selects[index]);
  	    }
  	  }
  	
  	  function managerDestroyThemedSelect(select) {
  	    var instance = select && select.__fifThemedSelect;
  	    if (!instance) return;
  	
  	    managerCloseThemedSelect(instance);
  	
  	    try {
  	      if (instance.observer) {
  	        instance.observer.disconnect();
  	      }
  	    } catch (_) {}
  	
  	    try {
  	      select.removeEventListener(
  	        "change",
  	        instance.onSelectChange
  	      );
  	    } catch (_) {}
  	
  	    try {
  	      if (instance.menu && instance.menu.parentNode) {
  	        instance.menu.parentNode.removeChild(instance.menu);
  	      }
  	    } catch (_) {}
  	
  	    try {
  	      select.classList.remove("fif-themed-select-native");
  	
  	      if (instance.previousAriaHidden === null) {
  	        select.removeAttribute("aria-hidden");
  	      } else {
  	        select.setAttribute(
  	          "aria-hidden",
  	          instance.previousAriaHidden
  	        );
  	      }
  	
  	      if (instance.previousTabIndex === null) {
  	        select.removeAttribute("tabindex");
  	      } else {
  	        select.setAttribute(
  	          "tabindex",
  	          instance.previousTabIndex
  	        );
  	      }
  	
  	      if (
  	        instance.wrapper &&
  	        instance.wrapper.parentNode
  	      ) {
  	        instance.wrapper.parentNode.insertBefore(
  	          select,
  	          instance.wrapper
  	        );
  	        instance.wrapper.parentNode.removeChild(
  	          instance.wrapper
  	        );
  	      }
  	    } catch (_) {}
  	
  	    try {
  	      delete select.__fifThemedSelect;
  	    } catch (_) {
  	      select.__fifThemedSelect = null;
  	    }
  	  }
  	
  	  function managerDestroyThemedSelectsWithin(root) {
  	    if (!root) return;
  	
  	    var selects = [];
  	
  	    if (root instanceof HTMLSelectElement) {
  	      selects = [root];
  	    } else if (root.querySelectorAll) {
  	      selects = Array.prototype.slice.call(
  	        root.querySelectorAll("select")
  	      );
  	    }
  	
  	    for (var index = 0; index < selects.length; index++) {
  	      managerDestroyThemedSelect(selects[index]);
  	    }
  	  }
  	
  	  function managerTrashIconSvg() {
  	    return (
  	      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
  	        '<path d="M4 7h16"></path>' +
  	        '<path d="M9 7V4h6v3"></path>' +
  	        '<path d="M7 7l1 13h8l1-13"></path>' +
  	        '<path d="M10 11v5"></path>' +
  	        '<path d="M14 11v5"></path>' +
  	      '</svg>'
  	    );
  	  }
  	
  	  function managerCloseTypedDeleteSafety(result) {
  	    var overlay = document.getElementById(
  	      MANAGER_RECORD_DELETE_OVERLAY_ID
  	    );
  	
  	    if (!overlay) return;
  	
  	    var resolver = overlay.__fifDeleteResolver;
  	    overlay.__fifDeleteResolver = null;
  	
  	    try {
  	      overlay.remove();
  	    } catch (_) {}
  	
  	    if (typeof resolver === "function") {
  	      resolver(result === true);
  	    }
  	  }
  	
  	  function managerOpenTypedDeleteSafety(options) {
  	    var config = options || {};
  	
  	    managerCloseTypedDeleteSafety(false);
  	    managerEnsureThemedSelectTheme();
  	
  	    return new Promise(function (resolve) {
  	      var overlay = document.createElement("div");
  	      overlay.id = MANAGER_RECORD_DELETE_OVERLAY_ID;
  	      overlay.className = "fif-record-delete-overlay";
  	      overlay.setAttribute("role", "dialog");
  	      overlay.setAttribute("aria-modal", "true");
  	      overlay.setAttribute(
  	        "aria-label",
  	        managerText(config.title, "Delete Record")
  	      );
  	      overlay.__fifDeleteResolver = resolve;
  	
  	      overlay.innerHTML =
  	        '<form class="fif-record-delete-card" novalidate>' +
  	          '<div class="fif-record-delete-head">' +
  	            '<div class="fif-record-delete-alert" aria-hidden="true">!</div>' +
  	            '<div>' +
  	              '<div class="fif-record-delete-title">' +
  	                managerEscape(managerText(config.title, "Delete Record")) +
  	              '</div>' +
  	              '<div class="fif-record-delete-subtitle">' +
  	                managerEscape(managerText(config.subtitle, "Permanent Action")) +
  	              '</div>' +
  	            '</div>' +
  	            '<button type="button" class="fif-record-delete-close" aria-label="Cancel delete">×</button>' +
  	          '</div>' +
  	
  	          '<div class="fif-record-delete-body">' +
  	            '<div class="fif-record-delete-name">' +
  	              managerEscape(managerText(config.name, "Selected record")) +
  	            '</div>' +
  	            '<div class="fif-record-delete-copy">' +
  	              managerEscape(
  	                managerText(
  	                  config.copy,
  	                  "This action permanently deletes the selected record and cannot be undone."
  	                )
  	              ) +
  	            '</div>' +
  	            (config.warning
  	              ? '<div class="fif-record-delete-warning">' +
  	                  managerEscape(managerText(config.warning, "")) +
  	                '</div>'
  	              : '') +
  	            '<label class="fif-record-delete-label">Type DELETE to confirm' +
  	              '<input class="fif-record-delete-input" name="deleteConfirmation" type="text" ' +
  	              'autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="DELETE">' +
  	            '</label>' +
  	            '<div class="fif-record-delete-error">Exact confirmation required.</div>' +
  	          '</div>' +
  	
  	          '<div class="fif-record-delete-actions">' +
  	            '<button type="submit" disabled class="fif-record-delete-action fif-record-delete-confirm">' +
  	              managerEscape(managerText(config.confirmLabel, "Delete")) +
  	            '</button>' +
  	            '<button type="button" class="fif-record-delete-action fif-record-delete-cancel">Cancel</button>' +
  	          '</div>' +
  	        '</form>';
  	
  	      document.body.appendChild(overlay);
  	
  	      var form = overlay.querySelector("form");
  	      var input = overlay.querySelector('[name="deleteConfirmation"]');
  	      var confirmButton = overlay.querySelector(".fif-record-delete-confirm");
  	      var cancelButton = overlay.querySelector(".fif-record-delete-cancel");
  	      var closeButton = overlay.querySelector(".fif-record-delete-close");
  	      var errorBox = overlay.querySelector(".fif-record-delete-error");
  	
  	      function refreshState() {
  	        var value = String(input.value || "").trim();
  	        var valid = value === "DELETE";
  	        confirmButton.disabled = !valid;
  	        errorBox.classList.toggle("visible", !!value && !valid);
  	      }
  	
  	      function cancel() {
  	        managerCloseTypedDeleteSafety(false);
  	      }
  	
  	      input.addEventListener("input", refreshState);
  	      input.addEventListener("keydown", function (event) {
  	        if (event.key === "Escape") {
  	          event.preventDefault();
  	          cancel();
  	        }
  	      });
  	
  	      cancelButton.onclick = cancel;
  	      closeButton.onclick = cancel;
  	
  	      overlay.addEventListener("click", function (event) {
  	        if (event.target === overlay) cancel();
  	      });
  	
  	      form.onsubmit = function (event) {
  	        event.preventDefault();
  	        if (String(input.value || "").trim() !== "DELETE") {
  	          refreshState();
  	          return;
  	        }
  	        managerCloseTypedDeleteSafety(true);
  	      };
  	
  	      refreshState();
  	
  	      setTimeout(function () {
  	        try {
  	          input.focus();
  	        } catch (_) {}
  	      }, 25);
  	    });
  	  }
  	
  	  function managerUnwrapCompany(item) {
  	    if (!item || typeof item !== "object") return item;
  	
  	    if (
  	      item.objectId ||
  	      item.CompanyId ||
  	      item.CompanyName ||
  	      item.Tanks ||
  	      item.tanks
  	    ) {
  	      return item;
  	    }
  	
  	    return item.Company || item.company || item.data || item;
  	  }
  	
  	  function managerUnwrapTank(item) {
  	    if (!item || typeof item !== "object") return item;
  	
  	    if (
  	      item.objectId ||
  	      item.Grade ||
  	      item.FuelGrade ||
  	      item.DeviceId ||
  	      item.Bowsers ||
  	      item.bowsers
  	    ) {
  	      return item;
  	    }
  	
  	    return item.Tank || item.tank || item.data || item;
  	  }
  	
  	  function managerUnwrapBowser(item) {
  	    if (!item || typeof item !== "object") return item;
  	
  	    if (
  	      item.objectId ||
  	      item.Name ||
  	      item.Pump ||
  	      item.DeviceId ||
  	      item.FID
  	    ) {
  	      return item;
  	    }
  	
  	    return item.Bowser || item.bowser || item.data || item;
  	  }
  	
  	  function managerCompanies() {
  	    var source = managerFirst(
  	      managerGet(rootAppData, ["User", "Companies"], null),
  	      managerGet(rootAppData, ["Companies"], null),
  	      managerGet(rootCurrentUser, ["Companies"], null),
  	      []
  	    );
  	
  	    var rawCompanies = managerToArray(source);
  	    var result = [];
  	
  	    for (var index = 0; index < rawCompanies.length; index++) {
  	      var company = managerUnwrapCompany(rawCompanies[index]);
  	      if (company) result.push(company);
  	    }
  	
  	    result.sort(function (left, right) {
  	      return managerCompanyLabel(left, 0).localeCompare(
  	        managerCompanyLabel(right, 0),
  	        undefined,
  	        { numeric: true, sensitivity: "base" }
  	      );
  	    });
  	
  	    return result;
  	  }
  	
  	  function managerTanks(company) {
  	    var source = managerFirst(
  	      managerGet(company, ["Tanks"], null),
  	      managerGet(company, ["tanks"], null),
  	      []
  	    );
  	
  	    var rawTanks = managerToArray(source);
  	    var result = [];
  	
  	    for (var index = 0; index < rawTanks.length; index++) {
  	      var tank = managerUnwrapTank(rawTanks[index]);
  	      if (tank) result.push(tank);
  	    }
  	
  	    return result;
  	  }
  	
  	  function managerBowsers(tank) {
  	    var source = managerFirst(
  	      managerGet(tank, ["Bowsers"], null),
  	      managerGet(tank, ["bowsers"], null),
  	      managerGet(tank, ["Pumps"], null),
  	      managerGet(tank, ["pumps"], null),
  	      []
  	    );
  	
  	    var rawBowsers = managerToArray(source);
  	    var result = [];
  	
  	    for (var index = 0; index < rawBowsers.length; index++) {
  	      var bowser = managerUnwrapBowser(rawBowsers[index]);
  	      if (bowser) result.push(bowser);
  	    }
  	
  	    return result;
  	  }
  	
  	  function managerPlainObject(value) {
  	    if (!value || typeof value !== "object" || Array.isArray(value)) {
  	      return {};
  	    }
  	
  	    return value;
  	  }
  	
  	  function managerCloneObject(value) {
  	    try {
  	      return JSON.parse(JSON.stringify(value || {}));
  	    } catch (_) {
  	      return Object.assign({}, managerPlainObject(value));
  	    }
  	  }
  	
  	  function managerCompanyManifest(company) {
  	    var raw = managerGet(company, ["Manifest"], {});
  	
  	    if (typeof raw === "string") {
  	      try {
  	        raw = JSON.parse(raw);
  	      } catch (_) {
  	        raw = {};
  	      }
  	    }
  	
  	    return managerCloneObject(managerPlainObject(raw));
  	  }
  	
  	  function managerSupplierId(supplier, index) {
  	    return managerText(
  	      managerFirst(
  	        managerGet(supplier, ["SupplierId"], null),
  	        managerGet(supplier, ["supplierId"], null),
  	        managerGet(supplier, ["Id"], null),
  	        managerGet(supplier, ["id"], null)
  	      ),
  	      "supplier_" + String(index + 1)
  	    );
  	  }
  	
  	  function managerSupplierName(supplier, index) {
  	    return managerText(
  	      managerFirst(
  	        managerGet(supplier, ["Name"], null),
  	        managerGet(supplier, ["SupplierName"], null),
  	        managerGet(supplier, ["name"], null)
  	      ),
  	      "Supplier " + String(index + 1)
  	    );
  	  }
  	
  	  function managerNormaliseSupplier(supplier, index) {
  	    var source = managerPlainObject(supplier);
  	
  	    return {
  	      SupplierId: managerSupplierId(source, index),
  	      Name: managerSupplierName(source, index),
  	      Representative: managerText(
  	        managerFirst(
  	          managerGet(source, ["Representative"], null),
  	          managerGet(source, ["Rep"], null),
  	          managerGet(source, ["ContactPerson"], null)
  	        ),
  	        ""
  	      ),
  	      ContactNumber: managerText(
  	        managerFirst(
  	          managerGet(source, ["ContactNumber"], null),
  	          managerGet(source, ["Phone"], null),
  	          managerGet(source, ["Telephone"], null)
  	        ),
  	        ""
  	      ),
  	      Email: managerText(
  	        managerFirst(
  	          managerGet(source, ["Email"], null),
  	          managerGet(source, ["email"], null)
  	        ),
  	        ""
  	      ),
  	      OrderEmail: managerText(
  	        managerFirst(
  	          managerGet(source, ["OrderEmail"], null),
  	          managerGet(source, ["OrdersEmail"], null),
  	          managerGet(source, ["OrderingEmail"], null)
  	        ),
  	        ""
  	      )
  	    };
  	  }
  	
  	  function managerSuppliers(company) {
  	    var manifest = managerCompanyManifest(company);
  	    var source = managerToArray(
  	      managerFirst(
  	        managerGet(manifest, ["Suppliers"], null),
  	        managerGet(manifest, ["suppliers"], null),
  	        []
  	      )
  	    );
  	    var result = [];
  	
  	    for (var index = 0; index < source.length; index++) {
  	      var supplier = managerNormaliseSupplier(source[index], index);
  	      if (supplier.Name) result.push(supplier);
  	    }
  	
  	    result.sort(function (left, right) {
  	      return managerSupplierName(left, 0).localeCompare(
  	        managerSupplierName(right, 0),
  	        undefined,
  	        {
  	          numeric: true,
  	          sensitivity: "base"
  	        }
  	      );
  	    });
  	
  	    return result;
  	  }
  	
  	  function managerTankPrimarySupplierId(tank) {
  	    return managerText(
  	      managerFirst(
  	        managerGet(tank, ["PrimarySupplierId"], null),
  	        managerGet(tank, ["primarySupplierId"], null),
  	        managerGet(tank, ["PrimarySupplier", "SupplierId"], null),
  	        managerGet(tank, ["PrimarySupplier", "Id"], null),
  	        managerGet(tank, ["Manifest", "PrimarySupplierId"], null)
  	      ),
  	      ""
  	    );
  	  }
  	
  	  function managerTankPrimarySupplierName(tank) {
  	    var value = managerFirst(
  	      managerGet(tank, ["PrimarySupplier"], null),
  	      managerGet(tank, ["PrimarySupplierName"], null),
  	      managerGet(tank, ["Manifest", "PrimarySupplier"], null)
  	    );
  	
  	    if (value && typeof value === "object") {
  	      return managerSupplierName(value, 0);
  	    }
  	
  	    return managerText(value, "");
  	  }
  	
  	  function managerFindSupplier(company, supplierId, supplierName) {
  	    var suppliers = managerSuppliers(company);
  	    var wantedId = String(supplierId || "").trim().toLowerCase();
  	    var wantedName = String(supplierName || "").trim().toLowerCase();
  	
  	    for (var index = 0; index < suppliers.length; index++) {
  	      var supplier = suppliers[index];
  	
  	      if (
  	        wantedId &&
  	        String(supplier.SupplierId || "").trim().toLowerCase() === wantedId
  	      ) {
  	        return supplier;
  	      }
  	    }
  	
  	    for (var nameIndex = 0; nameIndex < suppliers.length; nameIndex++) {
  	      var namedSupplier = suppliers[nameIndex];
  	
  	      if (
  	        wantedName &&
  	        String(namedSupplier.Name || "").trim().toLowerCase() === wantedName
  	      ) {
  	        return namedSupplier;
  	      }
  	    }
  	
  	    return null;
  	  }
  	
  	  function managerTankPrimarySupplier(company, tank) {
  	    return managerFindSupplier(
  	      company,
  	      managerTankPrimarySupplierId(tank),
  	      managerTankPrimarySupplierName(tank)
  	    );
  	  }
  	
  	  function managerSupplierOptionsHtml(company, tank, allowBlank) {
  	    var suppliers = managerSuppliers(company);
  	    var selected = managerTankPrimarySupplier(company, tank);
  	    var selectedId = selected ? selected.SupplierId : "";
  	    var html = "";
  	
  	    if (allowBlank || !suppliers.length) {
  	      html +=
  	        '<option value=""' +
  	        (selectedId ? "" : " selected") +
  	        '>' +
  	        (suppliers.length ? "No primary supplier" : "No suppliers configured") +
  	        "</option>";
  	    }
  	
  	    for (var index = 0; index < suppliers.length; index++) {
  	      var supplier = suppliers[index];
  	
  	      html +=
  	        '<option value="' + managerEscape(supplier.SupplierId) + '"' +
  	        ' data-supplier-name="' + managerEscape(supplier.Name) + '"' +
  	        (supplier.SupplierId === selectedId ? " selected" : "") +
  	        '>' + managerEscape(supplier.Name) + "</option>";
  	    }
  	
  	    return html;
  	  }
  	
  	  function managerTankOrderThreshold(tank) {
  	    return Math.max(
  	      0,
  	      managerNumber(
  	        managerFirst(
  	          managerGet(tank, ["OrderThreshold"], null),
  	          managerGet(tank, ["MinimumAllowedQuantity"], null),
  	          managerGet(tank, ["MinAllowedQuantity"], null),
  	          managerGet(tank, ["Manifest", "OrderThreshold"], null)
  	        ),
  	        0
  	      )
  	    );
  	  }
  	
  	  function managerTankWarningThreshold1(tank) {
  	    return Math.max(
  	      0,
  	      managerNumber(
  	        managerFirst(
  	          managerGet(tank, ["FuelWarningThreshold1"], null),
  	          managerGet(tank, ["WarningThreshold1"], null),
  	          managerGet(tank, ["StockWarningThreshold1"], null),
  	          managerGet(tank, ["Manifest", "FuelWarningThreshold1"], null),
  	          managerGet(tank, ["Manifest", "WarningThreshold1"], null)
  	        ),
  	        0
  	      )
  	    );
  	  }
  	
  	  function managerTankWarningThreshold2(tank) {
  	    return Math.max(
  	      0,
  	      managerNumber(
  	        managerFirst(
  	          managerGet(tank, ["FuelWarningThreshold2"], null),
  	          managerGet(tank, ["WarningThreshold2"], null),
  	          managerGet(tank, ["StockWarningThreshold2"], null),
  	          managerGet(tank, ["Manifest", "FuelWarningThreshold2"], null),
  	          managerGet(tank, ["Manifest", "WarningThreshold2"], null)
  	        ),
  	        0
  	      )
  	    );
  	  }
  	
  	  function managerUniqueEmailRecipients(values) {
  	    var result = [];
  	    var seen = Object.create(null);
  	
  	    managerToArray(values).forEach(function (value) {
  	      String(value === null || value === undefined ? "" : value)
  	        .split(/[;,\n]+/)
  	        .map(function (item) { return item.trim(); })
  	        .filter(Boolean)
  	        .forEach(function (email) {
  	          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
  	          var key = email.toLowerCase();
  	          if (seen[key]) return;
  	          seen[key] = true;
  	          result.push(email);
  	        });
  	    });
  	
  	    return result;
  	  }
  	
  	  function managerTankCompanyNotificationEmails(company, tank) {
  	    var values = [
  	      managerGet(tank, ["CompanyNotificationEmail"], null),
  	      managerGet(tank, ["CompanyNotificationEmails"], null),
  	      managerGet(tank, ["NotificationEmail"], null),
  	      managerGet(tank, ["Manifest", "CompanyNotificationEmail"], null),
  	      managerGet(company, ["OrderEmail"], null),
  	      managerGet(company, ["NotificationEmail"], null),
  	      managerGet(company, ["CompanyNotificationEmail"], null),
  	      managerGet(company, ["CompanyEmail"], null),
  	      managerGet(company, ["ContactEmail"], null),
  	      managerGet(company, ["Email"], null),
  	      managerGet(company, ["email"], null),
  	      managerGet(company, ["Contact", "Email"], null),
  	      managerGet(company, ["CompanyContact", "Email"], null),
  	      managerGet(company, ["Data", "Contact", "Email"], null),
  	      managerGet(company, ["Data", "Contacts", "Email"], null),
  	      managerGet(company, ["Data", "Company", "Email"], null),
  	      managerGet(company, ["Data", "Company", "Contact", "Email"], null),
  	      managerGet(company, ["Data", "CompanyDetails", "Email"], null),
  	      managerGet(company, ["Data", "Profile", "Email"], null),
  	      managerGet(company, ["Manifest", "NotificationEmail"], null),
  	      managerGet(company, ["Manifest", "OrderEmail"], null),
  	      managerGet(company, ["Manifest", "Email"], null),
  	      managerGet(company, ["Manifest", "Contact", "Email"], null),
  	      managerGet(company, ["Manifest", "Company", "Email"], null)
  	    ].map(managerDescriptorValue);
  	
  	    return managerUniqueEmailRecipients(values);
  	  }
  	
  	  function managerTankCompanyNotificationEmailSetting(company, tank) {
  	    var direct = managerUniqueEmailRecipients([
  	      managerDescriptorValue(managerGet(tank, ["CompanyNotificationEmail"], null)),
  	      managerDescriptorValue(managerGet(tank, ["CompanyNotificationEmails"], null))
  	    ]);
  	    if (direct.length) return direct.join(", ");
  	    var fallback = managerTankCompanyNotificationEmails(company, tank);
  	    return fallback.length ? fallback.join(", ") : "";
  	  }
  	
  	  function managerTankDefaultOrderVolume(tank) {
  	    return Math.max(
  	      0,
  	      managerNumber(
  	        managerFirst(
  	          managerGet(tank, ["DefaultOrderVolume"], null),
  	          managerGet(tank, ["DefaultVolumeOrder"], null),
  	          managerGet(tank, ["OrderVolume"], null),
  	          managerGet(tank, ["Manifest", "DefaultOrderVolume"], null)
  	        ),
  	        0
  	      )
  	    );
  	  }
  	
  	
  	  function managerTankOrderRecipient(supplier) {
  	    if (!supplier) return "";
  	    return managerText(
  	      managerFirst(
  	        managerGet(supplier, ["OrderEmail"], null),
  	        managerGet(supplier, ["Email"], null)
  	      ),
  	      ""
  	    ).trim();
  	  }
  	
  	  function managerTankFuelNotificationRecipients(companyObj, tank, supplier) {
  	    var supplierRecipient = managerTankOrderRecipient(supplier);
  	    var companyRecipients = managerTankCompanyNotificationEmails(companyObj, tank);
  	    var allRecipients = managerUniqueEmailRecipients([supplierRecipient].concat(companyRecipients));
  	    return {
  	      supplierRecipient: supplierRecipient,
  	      companyRecipients: companyRecipients,
  	      allRecipients: allRecipients
  	    };
  	  }
  	
  	  function managerTankWarningEmailBody(companyObj, tank, supplier, currentVolume, threshold, warningLevel, transaction) {
  	    var companyLabel = managerCompanyLabel(companyObj);
  	    var tankLabel = managerTankLabel(tank, 0);
  	    var grade = managerText(managerFirst(managerGet(tank, ["Grade"], null), managerGet(tank, ["FuelGrade"], null)), "Fuel");
  	    var capacity = Math.max(0, managerNumber(managerFirst(managerGet(tank, ["Capacity"], null), managerGet(tank, ["capacity"], null)), 0));
  	    var level = capacity > 0 ? Math.max(0, Math.min(100, currentVolume / capacity * 100)) : managerNumber(managerGet(tank, ["Level"], 0), 0);
  	    var orderThreshold = managerTankOrderThreshold(tank);
  	    var orderVolume = managerTankDefaultOrderVolume(tank);
  	    var supplierName = supplier ? supplier.Name : "Supplier";
  	    var transactionId = managerText(managerGet(transaction, ["objectId"], ""), "");
  	    var severity = warningLevel === 2 ? "Critical Stock Warning" : "Early Stock Warning";
  	    var explanation = warningLevel === 2
  	      ? "Fuel stock has crossed the second warning threshold and is approaching the automatic order level."
  	      : "Fuel stock has crossed the first warning threshold and should be monitored for replenishment planning.";
  	
  	    var textBody = [
  	      "Fleet In Form - Fuel " + severity,
  	      "",
  	      "Supplier: " + supplierName,
  	      "Company: " + companyLabel,
  	      "Tank: " + tankLabel,
  	      "Fuel Grade: " + grade,
  	      "Warning Level: " + warningLevel,
  	      "",
  	      "Current Stock: " + managerFormat(currentVolume, 2) + " L",
  	      "Warning Threshold: " + managerFormat(threshold, 2) + " L",
  	      "Current Level: " + managerFormat(level, 2) + "%",
  	      orderThreshold > 0 ? "Minimum / Order Level: " + managerFormat(orderThreshold, 2) + " L" : "",
  	      orderVolume > 0 ? "Configured Order Volume: " + managerFormat(orderVolume, 2) + " L" : "",
  	      capacity > 0 ? "Tank Capacity: " + managerFormat(capacity, 2) + " L" : "",
  	      transactionId ? "Triggered by Fuel Transaction: " + transactionId : "",
  	      "",
  	      explanation,
  	      "",
  	      "This warning was generated automatically by Fleet In Form."
  	    ].filter(Boolean).join("\n");
  	
  	    var htmlBody =
  	      '<div style="font-family:Arial,sans-serif;color:#202420;line-height:1.45">' +
  	      '<h2 style="margin:0 0 4px;color:#a34f29">Fleet In Form</h2>' +
  	      '<h3 style="margin:0 0 18px">Fuel ' + managerEscape(severity) + '</h3>' +
  	      '<table style="border-collapse:collapse;width:100%;max-width:720px">' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Company</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(companyLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Tank</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(tankLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Fuel Grade</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(grade) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Warning Level</td><td style="padding:7px;border:1px solid #d9dedb">' + warningLevel + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Stock</td><td style="padding:7px;border:1px solid #d9dedb"><strong>' + managerEscape(managerFormat(currentVolume, 2) + " L") + '</strong></td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Warning Threshold</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(managerFormat(threshold, 2) + " L") + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Level</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(managerFormat(level, 2) + "%") + '</td></tr>' +
  	      (orderThreshold > 0 ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Minimum / Order Level</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(managerFormat(orderThreshold, 2) + " L") + '</td></tr>' : "") +
  	      (orderVolume > 0 ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Configured Order Volume</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(managerFormat(orderVolume, 2) + " L") + '</td></tr>' : "") +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Primary Supplier</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(supplierName) + '</td></tr>' +
  	      '</table>' +
  	      '<p style="margin-top:18px;font-weight:700">' + managerEscape(explanation) + '</p>' +
  	      '</div>';
  	
  	    return { text: textBody, html: htmlBody };
  	  }
  	
  	  async function managerSendTankWarningNotification(companyObj, tank, supplier, currentVolume, threshold, warningLevel, transaction) {
  	    if (!rootBackendless || !rootBackendless.Messaging || typeof rootBackendless.Messaging.sendEmail !== "function") {
  	      throw new Error("Backendless Messaging.sendEmail is unavailable.");
  	    }
  	    var recipients = managerTankFuelNotificationRecipients(companyObj, tank, supplier);
  	    if (!recipients.supplierRecipient) throw new Error("The Primary Supplier does not have an Order Email or Email address.");
  	    if (!recipients.companyRecipients.length) throw new Error("The tank company does not have a Company Notification Email configured.");
  	    var body = managerTankWarningEmailBody(companyObj, tank, supplier, currentVolume, threshold, warningLevel, transaction);
  	    var bodyParts = typeof rootBackendless.Bodyparts === "function" ? new rootBackendless.Bodyparts() : {};
  	    bodyParts.textmessage = body.text;
  	    bodyParts.htmlmessage = body.html;
  	    await rootBackendless.Messaging.sendEmail(
  	      "Fleet In Form - Fuel Warning Level " + warningLevel + " - " + managerTankLabel(tank, 0),
  	      bodyParts,
  	      recipients.allRecipients,
  	      []
  	    );
  	    return recipients;
  	  }
  	
  	  async function managerAuditTankWarningNotification(transaction, tank, warningLevel, recipients, currentVolume, threshold) {
  	    if (!transaction || !transaction.objectId) return false;
  	    if (!rootBackendless || !rootBackendless.Data || !rootBackendless.Data.of) return false;
  	    try {
  	      var prefix = warningLevel === 2 ? "FuelWarning2" : "FuelWarning1";
  	      var patch = { objectId: transaction.objectId };
  	      patch[prefix + "NotificationTriggered"] = true;
  	      patch[prefix + "NotificationSentAt"] = new Date().toISOString();
  	      patch[prefix + "NotificationTankId"] = managerText(managerGet(tank, ["objectId"], ""), "");
  	      patch[prefix + "NotificationTankName"] = managerTankLabel(tank, 0);
  	      patch[prefix + "NotificationVolume"] = currentVolume;
  	      patch[prefix + "NotificationThreshold"] = threshold;
  	      patch[prefix + "NotificationRecipients"] = recipients && recipients.allRecipients ? recipients.allRecipients.join(", ") : "";
  	      await rootBackendless.Data.of("FuelOut").save(patch);
  	      Object.keys(patch).forEach(function (key) { if (key !== "objectId") transaction[key] = patch[key]; });
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  }
  	
  	  async function managerReviewTankWarningNotificationsAfterFuel(companyObj, tank, previousVolume, currentVolume, transaction) {
  	    var oldVolume = managerNumber(previousVolume, 0);
  	    var newVolume = managerNumber(currentVolume, 0);
  	    var supplier = managerTankPrimarySupplier(companyObj, tank);
  	    var warnings = [
  	      { level: 1, threshold: managerTankWarningThreshold1(tank) },
  	      { level: 2, threshold: managerTankWarningThreshold2(tank) }
  	    ];
  	    var sentCount = 0;
  	    var messages = [];
  	
  	    for (var index = 0; index < warnings.length; index++) {
  	      var warning = warnings[index];
  	      if (!(warning.threshold > 0)) continue;
  	      if (!(oldVolume > warning.threshold && newVolume <= warning.threshold)) continue;
  	      if (!supplier) {
  	        await managerTankOrderNotice(
  	          "Fuel Warning Notification Required",
  	          managerTankLabel(tank, 0) + " crossed Fuel Warning Level " + warning.level + ", but no Primary Supplier is configured.",
  	          "The warning must be sent to both the Primary Supplier and the tank company."
  	        );
  	        messages.push(" Warning Level " + warning.level + " could not be emailed: Primary Supplier missing.");
  	        continue;
  	      }
  	      try {
  	        managerUpdateLoadingStatus("Sending Fuel Warning Level " + warning.level + "…");
  	        var recipients = await managerSendTankWarningNotification(companyObj, tank, supplier, newVolume, warning.threshold, warning.level, transaction);
  	        await managerAuditTankWarningNotification(transaction, tank, warning.level, recipients, newVolume, warning.threshold);
  	        sentCount++;
  	        messages.push(" Fuel Warning Level " + warning.level + " emailed to Supplier and Company.");
  	      } catch (error) {
  	        var errorMessage = managerText(managerFirst(error && error.message, error && error.faultString, error, "Backendless rejected the fuel warning email."), "Backendless rejected the fuel warning email.");
  	        await managerTankOrderNotice(
  	          "Fuel Warning Email Failed",
  	          managerTankLabel(tank, 0) + " crossed Fuel Warning Level " + warning.level + ", but the warning email could not be sent to both Supplier and Company.",
  	          errorMessage
  	        );
  	        messages.push(" Warning Level " + warning.level + " email failed: " + errorMessage);
  	      }
  	    }
  	
  	    return { status: sentCount ? "sent" : "not-triggered", sentCount: sentCount, message: messages.join("") };
  	  }
  	
  	  function managerTankOrderNotice(title, message, detail) {
  	    return new Promise(function (resolve) {
  	      var existing = document.getElementById(MANAGER_ORDER_EMAIL_OVERLAY_ID);
  	      if (existing) existing.remove();
  	
  	      var overlay = document.createElement("div");
  	      overlay.id = MANAGER_ORDER_EMAIL_OVERLAY_ID;
  	      overlay.style.position = "fixed";
  	      overlay.style.inset = "0";
  	      overlay.style.zIndex = String(FIF_MAX_Z_INDEX);
  	      overlay.style.display = "grid";
  	      overlay.style.placeItems = "start center";
  	      overlay.style.padding = "78px 20px 20px";
  	      overlay.style.boxSizing = "border-box";
  	      overlay.style.background = "rgba(0,0,0,0.84)";
  	      overlay.style.backdropFilter = "blur(8px)";
  	
  	      overlay.innerHTML =
  	        '<div role="alertdialog" aria-modal="true" style="width:min(620px,calc(100vw - 40px));padding:22px;box-sizing:border-box;border:1px solid rgba(232,115,57,.56);border-radius:22px;color:#f8fafc;background:linear-gradient(145deg,rgba(24,18,15,.995),rgba(7,10,13,.995));box-shadow:0 28px 70px rgba(0,0,0,.62);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Arial,sans-serif;">' +
  	        '<div style="font-size:19px;font-weight:900;">' + managerEscape(title) + '</div>' +
  	        '<div style="margin-top:10px;font-size:13px;font-weight:750;line-height:1.55;color:#e6d5ca;">' + managerEscape(message) + '</div>' +
  	        (detail
  	          ? '<div style="margin-top:12px;padding:11px 13px;border:1px solid rgba(232,115,57,.32);border-radius:13px;background:rgba(156,72,34,.16);font-size:12px;font-weight:750;line-height:1.5;white-space:pre-line;">' + managerEscape(detail) + '</div>'
  	          : "") +
  	        '<button type="button" data-order-notice-close class="fif-miniapp-primary" style="width:100%;height:44px;margin-top:18px;border-radius:13px;font-size:12px;font-weight:900;cursor:pointer;">Continue</button>' +
  	        '</div>';
  	
  	      document.body.appendChild(overlay);
  	
  	      var close = overlay.querySelector("[data-order-notice-close]");
  	      close.onclick = function () {
  	        try { overlay.remove(); } catch (_) {}
  	        resolve(true);
  	      };
  	
  	      setTimeout(function () {
  	        try { close.focus(); } catch (_) {}
  	      }, 20);
  	    });
  	  }
  	
  	  function managerTankOrderEmailBody(companyObj, tank, supplier, currentVolume, threshold, orderVolume, transaction) {
  	    var companyLabel = managerCompanyLabel(companyObj);
  	    var tankLabel = managerTankLabel(tank, 0);
  	    var grade = managerText(
  	      managerFirst(
  	        managerGet(tank, ["Grade"], null),
  	        managerGet(tank, ["FuelGrade"], null)
  	      ),
  	      "Fuel"
  	    );
  	    var capacity = Math.max(
  	      0,
  	      managerNumber(
  	        managerFirst(
  	          managerGet(tank, ["Capacity"], null),
  	          managerGet(tank, ["capacity"], null)
  	        ),
  	        0
  	      )
  	    );
  	    var level =
  	      capacity > 0
  	        ? Math.max(0, Math.min(100, currentVolume / capacity * 100))
  	        : managerNumber(managerGet(tank, ["Level"], 0), 0);
  	
  	    var supplierName = supplier ? supplier.Name : "Supplier";
  	    var representative = supplier ? supplier.Representative : "";
  	    var transactionId = managerText(
  	      managerGet(transaction, ["objectId"], ""),
  	      ""
  	    );
  	
  	    var textBody = [
  	      "Fleet In Form - Fuel Order Notification",
  	      "",
  	      "Supplier: " + supplierName,
  	      representative ? "Attention: " + representative : "",
  	      "Company: " + companyLabel,
  	      "Tank: " + tankLabel,
  	      "Fuel Grade: " + grade,
  	      "",
  	      "Current Stock: " + managerFormat(currentVolume, 2) + " L",
  	      "Minimum Allowed Quantity: " + managerFormat(threshold, 2) + " L",
  	      "Current Level: " + managerFormat(level, 2) + "%",
  	      "Requested Order Volume: " + managerFormat(orderVolume, 2) + " L",
  	      capacity > 0 ? "Tank Capacity: " + managerFormat(capacity, 2) + " L" : "",
  	      transactionId ? "Triggered by Fuel Transaction: " + transactionId : "",
  	      "",
  	      "Please arrange supply of the requested fuel volume and confirm delivery availability.",
  	      "",
  	      "This notification was generated automatically by Fleet In Form because the tank stock crossed below its configured Minimum Allowed Quantity."
  	    ].filter(Boolean).join("\n");
  	
  	    var htmlBody =
  	      '<div style="font-family:Arial,sans-serif;color:#202420;line-height:1.45">' +
  	      '<h2 style="margin:0 0 4px;color:#a34f29">Fleet In Form</h2>' +
  	      '<h3 style="margin:0 0 18px">Fuel Order Notification</h3>' +
  	      '<table style="border-collapse:collapse;width:100%;max-width:720px">' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Supplier</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(supplierName) + '</td></tr>' +
  	      (representative
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Attention</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(representative) + '</td></tr>'
  	        : "") +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Company</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(companyLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Tank</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(tankLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Fuel Grade</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(grade) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Stock</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(managerFormat(currentVolume, 2) + " L") + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Minimum Quantity</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(managerFormat(threshold, 2) + " L") + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Tank Level</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(managerFormat(level, 2) + "%") + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Order Volume</td><td style="padding:7px;border:1px solid #d9dedb"><strong>' + managerEscape(managerFormat(orderVolume, 2) + " L") + '</strong></td></tr>' +
  	      (capacity > 0
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Tank Capacity</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(managerFormat(capacity, 2) + " L") + '</td></tr>'
  	        : "") +
  	      (transactionId
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Trigger Transaction</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(transactionId) + '</td></tr>'
  	        : "") +
  	      '</table>' +
  	      '<p style="margin-top:18px;font-weight:700">Please arrange supply of the requested fuel volume and confirm delivery availability.</p>' +
  	      '<p style="margin-top:12px;color:#657069;font-size:12px">Generated automatically because the tank crossed below its configured Minimum Allowed Quantity.</p>' +
  	      '</div>';
  	
  	    return {
  	      text: textBody,
  	      html: htmlBody
  	    };
  	  }
  	
  	  async function managerSendTankOrderNotification(companyObj, tank, supplier, currentVolume, threshold, orderVolume, transaction) {
  	    if (
  	      !rootBackendless ||
  	      !rootBackendless.Messaging ||
  	      typeof rootBackendless.Messaging.sendEmail !== "function"
  	    ) {
  	      throw new Error("Backendless Messaging.sendEmail is unavailable.");
  	    }
  	
  	    var recipients = managerTankFuelNotificationRecipients(companyObj, tank, supplier);
  	    if (!recipients.supplierRecipient) {
  	      throw new Error("The Primary Supplier does not have an Order Email or Email address.");
  	    }
  	    if (!recipients.companyRecipients.length) {
  	      throw new Error("The tank company does not have a Company Notification Email configured.");
  	    }
  	
  	    var body = managerTankOrderEmailBody(companyObj, tank, supplier, currentVolume, threshold, orderVolume, transaction);
  	    var bodyParts = typeof rootBackendless.Bodyparts === "function" ? new rootBackendless.Bodyparts() : {};
  	    bodyParts.textmessage = body.text;
  	    bodyParts.htmlmessage = body.html;
  	
  	    await rootBackendless.Messaging.sendEmail(
  	      "Fleet In Form - Fuel Order Notification - " + managerTankLabel(tank, 0),
  	      bodyParts,
  	      recipients.allRecipients,
  	      []
  	    );
  	
  	    return recipients;
  	  }
  	
  	  async function managerAuditTankOrderNotification(transaction, tank, supplier, recipients, currentVolume, threshold, orderVolume) {
  	    if (!transaction || !transaction.objectId) return false;
  	    if (!rootBackendless || !rootBackendless.Data || !rootBackendless.Data.of) return false;
  	
  	    try {
  	      var sentAt = new Date().toISOString();
  	      var patch = {
  	        objectId: transaction.objectId,
  	        OrderNotificationTriggered: true,
  	        OrderNotificationSentAt: sentAt,
  	        OrderNotificationTankId: managerText(managerGet(tank, ["objectId"], ""), ""),
  	        OrderNotificationTankName: managerTankLabel(tank, 0),
  	        OrderNotificationSupplierId: supplier ? supplier.SupplierId : "",
  	        OrderNotificationSupplier: supplier ? supplier.Name : "",
  	        OrderNotificationSupplierEmail: recipients && recipients.supplierRecipient ? recipients.supplierRecipient : "",
  	        OrderNotificationCompanyEmail: recipients && recipients.companyRecipients ? recipients.companyRecipients.join(", ") : "",
  	        OrderNotificationEmail: recipients && recipients.allRecipients ? recipients.allRecipients.join(", ") : "",
  	        OrderNotificationRecipients: recipients && recipients.allRecipients ? recipients.allRecipients.join(", ") : "",
  	        OrderNotificationVolume: currentVolume,
  	        OrderNotificationThreshold: threshold,
  	        OrderNotificationOrderVolume: orderVolume
  	      };
  	
  	      await rootBackendless.Data.of("FuelOut").save(patch);
  	
  	      Object.keys(patch).forEach(function (key) {
  	        if (key !== "objectId") transaction[key] = patch[key];
  	      });
  	
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  }
  	
  	  async function managerReviewTankOrderNotificationAfterFuel(companyObj, tank, previousVolume, currentVolume, transaction) {
  	    var threshold = managerTankOrderThreshold(tank);
  	
  	    if (!(threshold > 0)) {
  	      return { status: "disabled", message: "" };
  	    }
  	
  	    var oldVolume = managerNumber(previousVolume, 0);
  	    var newVolume = managerNumber(currentVolume, 0);
  	
  	    /*
  	     * Trigger once per stock cycle: the order notification fires only when
  	     * the tank crosses from above the configured minimum to at-or-below it.
  	     * A later delivery naturally rearms the trigger by taking stock back
  	     * above the minimum.
  	     */
  	    if (!(oldVolume > threshold && newVolume <= threshold)) {
  	      return { status: "not-triggered", message: "" };
  	    }
  	
  	    var orderVolume = managerTankDefaultOrderVolume(tank);
  	    var supplier = managerTankPrimarySupplier(companyObj, tank);
  	    var recipient = managerTankOrderRecipient(supplier);
  	    var companyRecipients = managerTankCompanyNotificationEmails(companyObj, tank);
  	
  	    if (!(orderVolume > 0)) {
  	      await managerTankOrderNotice(
  	        "Fuel Order Notification Required",
  	        managerTankLabel(tank, 0) + " has crossed below its Minimum Allowed Quantity, but no Default Volume Order is configured.",
  	        "Current stock: " + managerFormat(newVolume, 2) + " L\nMinimum: " + managerFormat(threshold, 2) + " L"
  	      );
  	      return {
  	        status: "order-volume-required",
  	        message: " Tank order notification requires a Default Volume Order."
  	      };
  	    }
  	
  	    if (!supplier) {
  	      await managerTankOrderNotice(
  	        "Fuel Order Notification Required",
  	        managerTankLabel(tank, 0) + " has crossed below its Minimum Allowed Quantity, but no Primary Supplier is configured.",
  	        "Set the tank Primary Supplier in the Tank Manager before the next order cycle."
  	      );
  	      return {
  	        status: "supplier-required",
  	        message: " Tank order notification requires a Primary Supplier."
  	      };
  	    }
  	
  	    if (!recipient) {
  	      await managerTankOrderNotice(
  	        "Fuel Order Notification Required",
  	        managerTankLabel(tank, 0) + " has crossed below its Minimum Allowed Quantity, but " + supplier.Name + " has no Order Email or Email address.",
  	        "Add an Order Email in Suppliers. Fleet In Form uses Order Email first and falls back to the normal Email."
  	      );
  	      return {
  	        status: "email-required",
  	        message: " Tank order notification requires a Supplier Order Email."
  	      };
  	    }
  	
  	    if (!companyRecipients.length) {
  	      await managerTankOrderNotice(
  	        "Fuel Order Notification Required",
  	        managerTankLabel(tank, 0) + " has crossed below its Minimum Allowed Quantity, but the tank company has no notification email configured.",
  	        "Set Company Notification Email in the Tank settings. The fuel order must be sent to both the Supplier and the tank company."
  	      );
  	      return {
  	        status: "company-email-required",
  	        message: " Tank order notification requires the tank company email."
  	      };
  	    }
  	
  	    managerUpdateLoadingStatus("Sending tank order notification to Supplier and Company…");
  	
  	    var orderRecipients = null;
  	    try {
  	      orderRecipients = await managerSendTankOrderNotification(
  	        companyObj,
  	        tank,
  	        supplier,
  	        newVolume,
  	        threshold,
  	        orderVolume,
  	        transaction
  	      );
  	    } catch (error) {
  	      var errorMessage = managerText(
  	        managerFirst(
  	          error && error.message,
  	          error && error.faultString,
  	          error,
  	          "Backendless rejected the order email."
  	        ),
  	        "Backendless rejected the order email."
  	      );
  	
  	      await managerTankOrderNotice(
  	        "Tank Order Email Failed",
  	        "The fuel transaction was saved and the tank is below its Minimum Allowed Quantity, but the order notification could not be sent.",
  	        errorMessage
  	      );
  	
  	      return {
  	        status: "failed",
  	        message: " Tank order email failed: " + errorMessage
  	      };
  	    }
  	
  	    var auditSaved = await managerAuditTankOrderNotification(
  	      transaction,
  	      tank,
  	      supplier,
  	      orderRecipients,
  	      newVolume,
  	      threshold,
  	      orderVolume
  	    );
  	
  	    return {
  	      status: auditSaved ? "sent" : "sent-audit-failed",
  	      message:
  	        " Fuel order notification emailed to " +
  	        supplier.Name +
  	        " and " +
  	        managerCompanyLabel(companyObj) +
  	        " for " +
  	        managerFormat(orderVolume, 2) +
  	        " L" +
  	        (auditSaved ? "." : " (email sent; FuelOut audit could not be saved).")
  	    };
  	  }
  	
  	  function managerDeliveryTimestamp(delivery) {
  	    var raw = managerFirst(
  	      managerGet(delivery, ["FuelDate"], null),
  	      managerGet(delivery, ["DeliveryDate"], null),
  	      managerGet(delivery, ["created"], null),
  	      managerGet(delivery, ["updated"], null)
  	    );
  	    var parsed = new Date(raw || 0).getTime();
  	    return Number.isFinite(parsed) ? parsed : 0;
  	  }
  	
  	  function managerDeliveryCaptureTimestamp(delivery) {
  	    var raw = managerFirst(
  	      managerGet(delivery, ["created"], null),
  	      managerGet(delivery, ["updated"], null),
  	      managerGet(delivery, ["FuelDate"], null),
  	      managerGet(delivery, ["DeliveryDate"], null)
  	    );
  	    var parsed = new Date(raw || 0).getTime();
  	    return Number.isFinite(parsed) ? parsed : 0;
  	  }
  	
  	  function managerLatestDelivery(tank) {
  	    var deliveries = managerToArray(
  	      managerGet(tank, ["FuelIn"], [])
  	    ).slice();
  	
  	    var currentView = managerFirst(
  	      managerGet(tank, ["ViewC"], null),
  	      managerGet(tank, ["TankView", "ViewC"], null)
  	    );
  	    var historyViews = managerToArray(managerFirst(
  	      managerGet(tank, ["ViewH"], null),
  	      managerGet(tank, ["TankView", "ViewH"], null),
  	      []
  	    ));
  	
  	    if (currentView) {
  	      deliveries = deliveries.concat(
  	        managerToArray(managerGet(currentView, ["FuelIn"], []))
  	      );
  	    }
  	
  	    historyViews.forEach(function (view) {
  	      deliveries = deliveries.concat(
  	        managerToArray(managerGet(view, ["FuelIn"], []))
  	      );
  	    });
  	
  	    var includeIntertankPrice = managerIsTrailerTank(tank);
  	    deliveries = deliveries.filter(function (delivery) {
  	      return includeIntertankPrice || !managerIsIntertankFuelIn(delivery);
  	    });
  	
  	    var seen = {};
  	    deliveries = deliveries.filter(function (item) {
  	      if (!item) return false;
  	      var id = managerText(managerGet(item, ["objectId"], ""), "");
  	      var key = id || [
  	        managerGet(item, ["FuelDate"], ""),
  	        managerGet(item, ["ReferenceNo"], ""),
  	        managerGet(item, ["Supplier"], ""),
  	        managerGet(item, ["Litres"], ""),
  	        managerGet(item, ["Cost"], "")
  	      ].join("::");
  	      if (!key || seen[key]) return false;
  	      seen[key] = true;
  	      return true;
  	    });
  	
  	    deliveries.sort(function (a, b) {
  	      var deliveryDateDifference =
  	        managerDeliveryTimestamp(b) -
  	        managerDeliveryTimestamp(a);
  	
  	      if (deliveryDateDifference !== 0) {
  	        return deliveryDateDifference;
  	      }
  	
  	      var captureDifference =
  	        managerDeliveryCaptureTimestamp(b) -
  	        managerDeliveryCaptureTimestamp(a);
  	
  	      if (captureDifference !== 0) {
  	        return captureDifference;
  	      }
  	
  	      return managerText(
  	        managerGet(b, ["objectId"], ""),
  	        ""
  	      ).localeCompare(
  	        managerText(
  	          managerGet(a, ["objectId"], ""),
  	          ""
  	        ),
  	        undefined,
  	        { numeric: true, sensitivity: "base" }
  	      );
  	    });
  	
  	    return deliveries.length ? deliveries[0] : null;
  	  }
  	
  	  function managerLatestCostPerLitre(tank) {
  	    var latest = managerLatestDelivery(tank);
  	    if (!latest) return 0;
  	
  	    var explicit = managerNumber(
  	      managerGet(latest, ["CostPerLitre"], null),
  	      NaN
  	    );
  	
  	    if (Number.isFinite(explicit) && explicit >= 0) {
  	      return explicit;
  	    }
  	
  	    var litres = managerNumber(
  	      managerGet(latest, ["Litres"], 0),
  	      0
  	    );
  	    var cost = managerNumber(
  	      managerGet(latest, ["Cost"], 0),
  	      0
  	    );
  	
  	    return litres > 0 ? cost / litres : 0;
  	  }
  	
  	  function managerFormatCurrency(value) {
  	    return "R " + managerFormat(value, 2);
  	  }
  	
  	  function managerJsonArray(value) {
  	    if (Array.isArray(value)) return value;
  	
  	    if (typeof value === "string") {
  	      try {
  	        var parsed = JSON.parse(value);
  	        return Array.isArray(parsed) ? parsed : [];
  	      } catch (_) {
  	        return [];
  	      }
  	    }
  	
  	    if (value && typeof value === "object") {
  	      if (Array.isArray(value.data)) return value.data;
  	      if (Array.isArray(value.items)) return value.items;
  	
  	      var length = Number(value.length);
  	      if (Number.isFinite(length) && length >= 0) {
  	        var rows = [];
  	        for (var index = 0; index < length; index++) {
  	          if (value[index] !== undefined) rows.push(value[index]);
  	        }
  	        return rows;
  	      }
  	    }
  	
  	    return [];
  	  }
  	
  	  function managerTankAtgRelation(tank) {
  	    var relation = managerFirst(
  	      managerGet(tank, ["ATG"], null),
  	      managerGet(tank, ["ATGPoll"], null),
  	      managerGet(tank, ["ATGPolls"], null)
  	    );
  	
  	    if (Array.isArray(relation)) {
  	      return relation.length ? relation[0] : null;
  	    }
  	
  	    if (
  	      relation &&
  	      typeof relation === "object" &&
  	      Array.isArray(relation.data)
  	    ) {
  	      return relation.data.length ? relation.data[0] : null;
  	    }
  	
  	    return relation && typeof relation === "object"
  	      ? relation
  	      : null;
  	  }
  	
  	  function managerTankAtgNumber(tank) {
  	    return managerText(
  	      managerFirst(
  	        managerGet(tank, ["ATG_NUMBER"], null),
  	        managerGet(tank, ["ATGNumber"], null),
  	        managerGet(tank, ["AtgNumber"], null)
  	      ),
  	      ""
  	    ).trim();
  	  }
  	
  	  function managerTankAtgReading(tank) {
  	    var atg = managerTankAtgRelation(tank);
  	    var wanted = managerTankAtgNumber(tank);
  	
  	    if (!atg || !wanted) return null;
  	
  	    var readings = managerJsonArray(
  	      managerGet(atg, ["Readings"], [])
  	    );
  	
  	    for (var index = 0; index < readings.length; index++) {
  	      var readingNumber = managerText(
  	        managerFirst(
  	          managerGet(readings[index], ["TankNumber"], null),
  	          managerGet(readings[index], ["ATGNumber"], null),
  	          managerGet(readings[index], ["TankNo"], null)
  	        ),
  	        ""
  	      ).trim();
  	
  	      if (readingNumber === wanted) return readings[index];
  	    }
  	
  	    return null;
  	  }
  	
  	  function managerAtgTimestamp(atg) {
  	    if (!atg) return 0;
  	
  	    var raw = managerFirst(
  	      managerGet(atg, ["CapturedAt"], null),
  	      managerGet(atg, ["CapturedAtIso"], null),
  	      managerGet(atg, ["updated"], null),
  	      managerGet(atg, ["created"], null)
  	    );
  	
  	    if (raw === null || raw === undefined || raw === "") return 0;
  	
  	    var numeric = Number(raw);
  	    var parsed = Number.isFinite(numeric) && numeric > 0
  	      ? numeric
  	      : new Date(raw).getTime();
  	
  	    return Number.isFinite(parsed) ? parsed : 0;
  	  }
  	
  	  function managerTankAtgSnapshot(tank) {
  	    var atg = managerTankAtgRelation(tank);
  	    var reading = managerTankAtgReading(tank);
  	    var capturedAt = managerAtgTimestamp(atg);
  	    var ageMs = capturedAt
  	      ? Math.max(0, Date.now() - capturedAt)
  	      : Infinity;
  	
  	    var volume = managerNumber(
  	      managerGet(reading, ["VolumeL"], null),
  	      NaN
  	    );
  	
  	    var available = !!reading && Number.isFinite(volume);
  	    var stale = available && (
  	      !capturedAt ||
  	      ageMs > MANAGER_ATG_STALE_AFTER_MS
  	    );
  	
  	    return {
  	      linked: !!atg,
  	      available: available,
  	      stale: stale,
  	      state: !available ? "unavailable" : stale ? "stale" : "live",
  	      atg: atg,
  	      reading: reading,
  	      tankNumber: managerTankAtgNumber(tank),
  	      capturedAt: capturedAt,
  	      ageMs: ageMs,
  	      volume: volume,
  	      height: managerNumber(managerGet(reading, ["Height"], null), NaN),
  	      water: managerNumber(managerGet(reading, ["Water"], null), NaN),
  	      ullage: managerNumber(managerGet(reading, ["UllageL"], null), NaN),
  	      temperature: managerNumber(managerGet(reading, ["TemperatureC"], null), NaN),
  	      product: managerText(managerGet(reading, ["Product"], null), ""),
  	      consoleStatus: managerText(managerGet(atg, ["Status"], null), "")
  	    };
  	  }
  	
  	  function managerTankBookVolume(tank) {
  	    return managerNumber(
  	      managerFirst(
  	        managerGet(tank, ["Volume"], null),
  	        managerGet(tank, ["volume"], null)
  	      ),
  	      0
  	    );
  	  }
  	
  	  function managerTankAtgLevel(tank) {
  	    var snapshot = managerTankAtgSnapshot(tank);
  	    var capacity = managerNumber(
  	      managerFirst(
  	        managerGet(tank, ["Capacity"], null),
  	        managerGet(tank, ["capacity"], null)
  	      ),
  	      0
  	    );
  	
  	    if (!snapshot.available || capacity <= 0) return 0;
  	
  	    return Math.max(
  	      0,
  	      Math.min(100, (snapshot.volume / capacity) * 100)
  	    );
  	  }
  	
  	  function managerAtgAgeLabel(timestamp) {
  	    if (!timestamp) return "No capture time";
  	
  	    var seconds = Math.max(0, Math.floor((Date.now() - timestamp) / 1000));
  	    if (seconds < 60) return "Updated just now";
  	
  	    var minutes = Math.floor(seconds / 60);
  	    if (minutes < 60) return "Updated " + minutes + " min ago";
  	
  	    var hours = Math.floor(minutes / 60);
  	    var remainder = minutes % 60;
  	    return "Updated " + hours + " h" + (remainder ? " " + remainder + " min" : "") + " ago";
  	  }
  	
  	  function managerAtgValue(value, decimals, suffix) {
  	    return Number.isFinite(value)
  	      ? managerFormat(value, decimals) + suffix
  	      : "—";
  	  }
  	
  	  function managerBuildAtgStrip(tank) {
  	    var snapshot = managerTankAtgSnapshot(tank);
  	    var bookVolume = managerTankBookVolume(tank);
  	    var difference = snapshot.available
  	      ? snapshot.volume - bookVolume
  	      : NaN;
  	    var differenceText = Number.isFinite(difference)
  	      ? (difference > 0 ? "+" : "") + managerFormat(difference, 2) + " L"
  	      : "—";
  	    var stateLabel = snapshot.state === "live"
  	      ? "ATG LIVE"
  	      : snapshot.state === "stale"
  	        ? "ATG STALE"
  	        : "ATG UNAVAILABLE";
  	
  	    var capturedTitle = snapshot.capturedAt
  	      ? new Date(snapshot.capturedAt).toLocaleString("en-ZA")
  	      : "No ATG capture time available";
  	
  	    return (
  	      '<div class="fif-manager-atg-strip is-' + snapshot.state + '" data-atg-strip>' +
  	        '<span class="fif-manager-atg-status">' + managerEscape(stateLabel) + '</span>' +
  	        '<span><small>ATG Tank</small><strong>' + managerEscape(snapshot.tankNumber || "—") + '</strong></span>' +
  	        '<span><small>Product</small><strong>' + managerEscape(snapshot.product || "—") + '</strong></span>' +
  	        '<span><small>ATG Volume</small><strong>' + managerEscape(managerAtgValue(snapshot.volume, 2, " L")) + '</strong></span>' +
  	        '<span><small>Difference</small><strong>' + managerEscape(differenceText) + '</strong></span>' +
  	        '<span><small>Temperature</small><strong>' + managerEscape(managerAtgValue(snapshot.temperature, 2, " °C")) + '</strong></span>' +
  	        '<span><small>Water</small><strong>' + managerEscape(managerAtgValue(snapshot.water, 2, " mm")) + '</strong></span>' +
  	        '<span><small>Ullage</small><strong>' + managerEscape(managerAtgValue(snapshot.ullage, 2, " L")) + '</strong></span>' +
  	        '<span><small>Fuel Height</small><strong>' + managerEscape(managerAtgValue(snapshot.height, 2, " mm")) + '</strong></span>' +
  	        '<span class="fif-manager-atg-updated" title="' + managerEscape(capturedTitle) + '">' +
  	          managerEscape(managerAtgAgeLabel(snapshot.capturedAt)) +
  	        '</span>' +
  	      '</div>'
  	    );
  	  }
  	
  	  function managerTankStockValue(tank) {
  	    var volume = managerTankBookVolume(tank);
  	
  	    return volume * managerLatestCostPerLitre(tank);
  	  }
  	
  	  function managerAllTanks() {
  	    var result = [];
  	    var companies = managerCompanies();
  	
  	    for (var companyIndex = 0; companyIndex < companies.length; companyIndex++) {
  	      var tanks = managerTanks(companies[companyIndex]);
  	
  	      for (var tankIndex = 0; tankIndex < tanks.length; tankIndex++) {
  	        result.push(tanks[tankIndex]);
  	      }
  	    }
  	
  	    return result;
  	  }
  	
  	  function managerCompanyLabel(company, index) {
  	    return managerText(
  	      managerFirst(
  	        managerGet(company, ["Name"], null),
  	        managerGet(company, ["CompanyName"], null),
  	        managerGet(company, ["CompanyId"], null),
  	        managerGet(company, ["FID"], null)
  	      ),
  	      "Company " + (index + 1)
  	    );
  	  }
  	
  	  function managerTankLabel(tank, index) {
  	    return managerText(
  	      managerFirst(
  	        managerGet(tank, ["Name"], null),
  	        managerGet(tank, ["TankName"], null),
  	        managerGet(tank, ["FID"], null),
  	        managerGet(tank, ["Grade"], null)
  	      ),
  	      "Tank " + (index + 1)
  	    );
  	  }
  	
  	  function managerBowserLabel(bowser, index) {
  	    return managerText(
  	      managerFirst(
  	        managerGet(bowser, ["Name"], null),
  	        managerGet(bowser, ["Pump"], null),
  	        managerGet(bowser, ["FID"], null),
  	        managerGet(bowser, ["DeviceId"], null)
  	      ),
  	      "Nozzle " + (index + 1)
  	    );
  	  }
  	
  	  function managerTankLevel(tank) {
  	    var level = managerNumber(
  	      managerFirst(
  	        managerGet(tank, ["Level"], null),
  	        managerGet(tank, ["level"], null)
  	      ),
  	      NaN
  	    );
  	
  	    var volume = managerNumber(
  	      managerFirst(
  	        managerGet(tank, ["Volume"], null),
  	        managerGet(tank, ["volume"], null)
  	      ),
  	      NaN
  	    );
  	
  	    var capacity = managerNumber(
  	      managerFirst(
  	        managerGet(tank, ["Capacity"], null),
  	        managerGet(tank, ["capacity"], null)
  	      ),
  	      NaN
  	    );
  	
  	    if (!Number.isFinite(level) && Number.isFinite(volume) && Number.isFinite(capacity) && capacity > 0) {
  	      level = (volume / capacity) * 100;
  	    }
  	
  	    if (!Number.isFinite(level)) level = 0;
  	
  	    return Math.max(0, Math.min(100, level));
  	  }
  	
  	  function managerFormat(value, decimals) {
  	    var number = managerNumber(value, 0);
  	
  	    return number.toLocaleString("en-ZA", {
  	      minimumFractionDigits: decimals,
  	      maximumFractionDigits: decimals
  	    });
  	  }
  	
  	  function managerFuelLevelColor(level) {
  	    var percent = Math.max(0, Math.min(100, managerNumber(level, 0)));
  	
  	    var red = { r: 239, g: 68, b: 68 };
  	    var yellow = { r: 234, g: 179, b: 8 };
  	    var green = { r: 34, g: 197, b: 94 };
  	
  	    var from = percent <= 50 ? red : yellow;
  	    var to = percent <= 50 ? yellow : green;
  	    var ratio = percent <= 50
  	      ? percent / 50
  	      : (percent - 50) / 50;
  	
  	    return {
  	      r: Math.round(from.r + ((to.r - from.r) * ratio)),
  	      g: Math.round(from.g + ((to.g - from.g) * ratio)),
  	      b: Math.round(from.b + ((to.b - from.b) * ratio))
  	    };
  	  }
  	
  	  function managerFuelButtonStyle(level) {
  	    var percent = Math.max(0, Math.min(100, managerNumber(level, 0)));
  	    var colour = managerFuelLevelColor(percent);
  	
  	    return [
  	      "--fuel-r:" + colour.r,
  	      "--fuel-g:" + colour.g,
  	      "--fuel-b:" + colour.b,
  	      "--fuel-level:" + percent.toFixed(1) + "%"
  	    ].join(";");
  	  }
  	
  	  function managerPaintFuelButton(button, level) {
  	    if (!button) return;
  	
  	    var percent = Math.max(0, Math.min(100, managerNumber(level, 0)));
  	    var colour = managerFuelLevelColor(percent);
  	
  	    button.style.setProperty("--fuel-r", String(colour.r));
  	    button.style.setProperty("--fuel-g", String(colour.g));
  	    button.style.setProperty("--fuel-b", String(colour.b));
  	    button.style.setProperty("--fuel-level", percent.toFixed(1) + "%");
  	    button.setAttribute("data-fuel-level", percent.toFixed(1));
  	
  	    var label = button.querySelector("[data-add-fuel-label]");
  	
  	    if (label) {
  	      label.textContent = "Tank Manager";
  	    }
  	  }
  	
  	  function managerLogoHtml() {
  	    var logo = rootSvgLogo;
  	
  	    if (logo && typeof logo === "object") {
  	      logo =
  	        logo.url ||
  	        logo.src ||
  	        logo.data ||
  	        logo.value ||
  	        logo.fileURL ||
  	        logo.fileUrl ||
  	        "";
  	    }
  	
  	    logo = String(logo || "").trim();
  	
  	    if (!logo) {
  	      return '<div class="fif-manager-logo-fallback">FIF</div>';
  	    }
  	
  	    if (logo.indexOf("<svg") !== -1) {
  	      return '<div class="fif-manager-logo-svg">' + logo + "</div>";
  	    }
  	
  	    if (logo.indexOf("iVBORw0KGgo") === 0) {
  	      logo = "data:image/png;base64," + logo;
  	    } else if (logo.indexOf("/9j/") === 0) {
  	      logo = "data:image/jpeg;base64," + logo;
  	    }
  	
  	    return (
  	      '<img class="fif-manager-logo-img" ' +
  	      'src="' + managerEscape(logo) + '" ' +
  	      'alt="Fleet In Form">'
  	    );
  	  }
  	
  	
  	
  	  /*
  	   * Local QR encoder used only for Bowser printable labels.
  	   * QRCode for JavaScript, Copyright (c) 2009 Kazuhiko Arase, MIT License.
  	   * The QR payload is the exact Bowsers.objectId and never a URL or rewritten value.
  	   */
  	  var managerQrLibrary = (function () {
  	var QRMode = {
  	    MODE_NUMBER :       1 << 0,
  	    MODE_ALPHA_NUM :    1 << 1,
  	    MODE_8BIT_BYTE :    1 << 2,
  	    MODE_KANJI :        1 << 3
  	};
  	
  	var QRErrorCorrectLevel = {
  		L : 1,
  		M : 0,
  		Q : 3,
  		H : 2
  	};
  	
  	var QRMaskPattern = {
  		PATTERN000 : 0,
  		PATTERN001 : 1,
  		PATTERN010 : 2,
  		PATTERN011 : 3,
  		PATTERN100 : 4,
  		PATTERN101 : 5,
  		PATTERN110 : 6,
  		PATTERN111 : 7
  	};
  	
  	var QRMath = {
  	
  		glog : function(n) {
  		
  			if (n < 1) {
  				throw new Error("glog(" + n + ")");
  			}
  			
  			return QRMath.LOG_TABLE[n];
  		},
  		
  		gexp : function(n) {
  		
  			while (n < 0) {
  				n += 255;
  			}
  		
  			while (n >= 256) {
  				n -= 255;
  			}
  		
  			return QRMath.EXP_TABLE[n];
  		},
  		
  		EXP_TABLE : new Array(256),
  		
  		LOG_TABLE : new Array(256)
  	
  	};
  		
  	for (var i = 0; i < 8; i++) {
  		QRMath.EXP_TABLE[i] = 1 << i;
  	}
  	for (var i = 8; i < 256; i++) {
  		QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
  			^ QRMath.EXP_TABLE[i - 5]
  			^ QRMath.EXP_TABLE[i - 6]
  			^ QRMath.EXP_TABLE[i - 8];
  	}
  	for (var i = 0; i < 255; i++) {
  		QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
  	}
  	
  	function QRPolynomial(num, shift) {
  		if (num.length === undefined) {
  			throw new Error(num.length + "/" + shift);
  		}
  	
  		var offset = 0;
  	
  		while (offset < num.length && num[offset] === 0) {
  			offset++;
  		}
  	
  		this.num = new Array(num.length - offset + shift);
  		for (var i = 0; i < num.length - offset; i++) {
  			this.num[i] = num[i + offset];
  		}
  	}
  	
  	QRPolynomial.prototype = {
  	
  		get : function(index) {
  			return this.num[index];
  		},
  		
  		getLength : function() {
  			return this.num.length;
  		},
  		
  		multiply : function(e) {
  		
  			var num = new Array(this.getLength() + e.getLength() - 1);
  		
  			for (var i = 0; i < this.getLength(); i++) {
  				for (var j = 0; j < e.getLength(); j++) {
  					num[i + j] ^= QRMath.gexp(QRMath.glog(this.get(i) ) + QRMath.glog(e.get(j) ) );
  				}
  			}
  		
  			return new QRPolynomial(num, 0);
  		},
  		
  		mod : function(e) {
  		
  			if (this.getLength() - e.getLength() < 0) {
  				return this;
  			}
  		
  			var ratio = QRMath.glog(this.get(0) ) - QRMath.glog(e.get(0) );
  		
  			var num = new Array(this.getLength() );
  			
  			for (var i = 0; i < this.getLength(); i++) {
  				num[i] = this.get(i);
  			}
  			
  			for (var x = 0; x < e.getLength(); x++) {
  				num[x] ^= QRMath.gexp(QRMath.glog(e.get(x) ) + ratio);
  			}
  		
  			// recursive call
  			return new QRPolynomial(num, 0).mod(e);
  		}
  	};
  	
  	function QRBitBuffer() {
  		this.buffer = [];
  		this.length = 0;
  	}
  	
  	QRBitBuffer.prototype = {
  	
  		get : function(index) {
  			var bufIndex = Math.floor(index / 8);
  			return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
  		},
  		
  		put : function(num, length) {
  			for (var i = 0; i < length; i++) {
  				this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
  			}
  		},
  		
  		getLengthInBits : function() {
  			return this.length;
  		},
  		
  		putBit : function(bit) {
  		
  			var bufIndex = Math.floor(this.length / 8);
  			if (this.buffer.length <= bufIndex) {
  				this.buffer.push(0);
  			}
  		
  			if (bit) {
  				this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
  			}
  		
  			this.length++;
  		}
  	};
  	
  	function QR8bitByte(data) {
  		this.mode = QRMode.MODE_8BIT_BYTE;
  		this.data = data;
  	}
  	
  	QR8bitByte.prototype = {
  	
  		getLength : function() {
  			return this.data.length;
  		},
  		
  		write : function(buffer) {
  			for (var i = 0; i < this.data.length; i++) {
  				// not JIS ...
  				buffer.put(this.data.charCodeAt(i), 8);
  			}
  		}
  	};
  	
  	function QRRSBlock(totalCount, dataCount) {
  		this.totalCount = totalCount;
  		this.dataCount  = dataCount;
  	}
  	
  	QRRSBlock.RS_BLOCK_TABLE = [
  	
  		// L
  		// M
  		// Q
  		// H
  	
  		// 1
  		[1, 26, 19],
  		[1, 26, 16],
  		[1, 26, 13],
  		[1, 26, 9],
  		
  		// 2
  		[1, 44, 34],
  		[1, 44, 28],
  		[1, 44, 22],
  		[1, 44, 16],
  	
  		// 3
  		[1, 70, 55],
  		[1, 70, 44],
  		[2, 35, 17],
  		[2, 35, 13],
  	
  		// 4		
  		[1, 100, 80],
  		[2, 50, 32],
  		[2, 50, 24],
  		[4, 25, 9],
  		
  		// 5
  		[1, 134, 108],
  		[2, 67, 43],
  		[2, 33, 15, 2, 34, 16],
  		[2, 33, 11, 2, 34, 12],
  		
  		// 6
  		[2, 86, 68],
  		[4, 43, 27],
  		[4, 43, 19],
  		[4, 43, 15],
  		
  		// 7		
  		[2, 98, 78],
  		[4, 49, 31],
  		[2, 32, 14, 4, 33, 15],
  		[4, 39, 13, 1, 40, 14],
  		
  		// 8
  		[2, 121, 97],
  		[2, 60, 38, 2, 61, 39],
  		[4, 40, 18, 2, 41, 19],
  		[4, 40, 14, 2, 41, 15],
  		
  		// 9
  		[2, 146, 116],
  		[3, 58, 36, 2, 59, 37],
  		[4, 36, 16, 4, 37, 17],
  		[4, 36, 12, 4, 37, 13],
  		
  		// 10		
  		[2, 86, 68, 2, 87, 69],
  		[4, 69, 43, 1, 70, 44],
  		[6, 43, 19, 2, 44, 20],
  		[6, 43, 15, 2, 44, 16],
  	
  		// 11
  		[4, 101, 81],
  		[1, 80, 50, 4, 81, 51],
  		[4, 50, 22, 4, 51, 23],
  		[3, 36, 12, 8, 37, 13],
  	
  		// 12
  		[2, 116, 92, 2, 117, 93],
  		[6, 58, 36, 2, 59, 37],
  		[4, 46, 20, 6, 47, 21],
  		[7, 42, 14, 4, 43, 15],
  	
  		// 13
  		[4, 133, 107],
  		[8, 59, 37, 1, 60, 38],
  		[8, 44, 20, 4, 45, 21],
  		[12, 33, 11, 4, 34, 12],
  	
  		// 14
  		[3, 145, 115, 1, 146, 116],
  		[4, 64, 40, 5, 65, 41],
  		[11, 36, 16, 5, 37, 17],
  		[11, 36, 12, 5, 37, 13],
  	
  		// 15
  		[5, 109, 87, 1, 110, 88],
  		[5, 65, 41, 5, 66, 42],
  		[5, 54, 24, 7, 55, 25],
  		[11, 36, 12],
  	
  		// 16
  		[5, 122, 98, 1, 123, 99],
  		[7, 73, 45, 3, 74, 46],
  		[15, 43, 19, 2, 44, 20],
  		[3, 45, 15, 13, 46, 16],
  	
  		// 17
  		[1, 135, 107, 5, 136, 108],
  		[10, 74, 46, 1, 75, 47],
  		[1, 50, 22, 15, 51, 23],
  		[2, 42, 14, 17, 43, 15],
  	
  		// 18
  		[5, 150, 120, 1, 151, 121],
  		[9, 69, 43, 4, 70, 44],
  		[17, 50, 22, 1, 51, 23],
  		[2, 42, 14, 19, 43, 15],
  	
  		// 19
  		[3, 141, 113, 4, 142, 114],
  		[3, 70, 44, 11, 71, 45],
  		[17, 47, 21, 4, 48, 22],
  		[9, 39, 13, 16, 40, 14],
  	
  		// 20
  		[3, 135, 107, 5, 136, 108],
  		[3, 67, 41, 13, 68, 42],
  		[15, 54, 24, 5, 55, 25],
  		[15, 43, 15, 10, 44, 16],
  	
  		// 21
  		[4, 144, 116, 4, 145, 117],
  		[17, 68, 42],
  		[17, 50, 22, 6, 51, 23],
  		[19, 46, 16, 6, 47, 17],
  	
  		// 22
  		[2, 139, 111, 7, 140, 112],
  		[17, 74, 46],
  		[7, 54, 24, 16, 55, 25],
  		[34, 37, 13],
  	
  		// 23
  		[4, 151, 121, 5, 152, 122],
  		[4, 75, 47, 14, 76, 48],
  		[11, 54, 24, 14, 55, 25],
  		[16, 45, 15, 14, 46, 16],
  	
  		// 24
  		[6, 147, 117, 4, 148, 118],
  		[6, 73, 45, 14, 74, 46],
  		[11, 54, 24, 16, 55, 25],
  		[30, 46, 16, 2, 47, 17],
  	
  		// 25
  		[8, 132, 106, 4, 133, 107],
  		[8, 75, 47, 13, 76, 48],
  		[7, 54, 24, 22, 55, 25],
  		[22, 45, 15, 13, 46, 16],
  	
  		// 26
  		[10, 142, 114, 2, 143, 115],
  		[19, 74, 46, 4, 75, 47],
  		[28, 50, 22, 6, 51, 23],
  		[33, 46, 16, 4, 47, 17],
  	
  		// 27
  		[8, 152, 122, 4, 153, 123],
  		[22, 73, 45, 3, 74, 46],
  		[8, 53, 23, 26, 54, 24],
  		[12, 45, 15, 28, 46, 16],
  	
  		// 28
  		[3, 147, 117, 10, 148, 118],
  		[3, 73, 45, 23, 74, 46],
  		[4, 54, 24, 31, 55, 25],
  		[11, 45, 15, 31, 46, 16],
  	
  		// 29
  		[7, 146, 116, 7, 147, 117],
  		[21, 73, 45, 7, 74, 46],
  		[1, 53, 23, 37, 54, 24],
  		[19, 45, 15, 26, 46, 16],
  	
  		// 30
  		[5, 145, 115, 10, 146, 116],
  		[19, 75, 47, 10, 76, 48],
  		[15, 54, 24, 25, 55, 25],
  		[23, 45, 15, 25, 46, 16],
  	
  		// 31
  		[13, 145, 115, 3, 146, 116],
  		[2, 74, 46, 29, 75, 47],
  		[42, 54, 24, 1, 55, 25],
  		[23, 45, 15, 28, 46, 16],
  	
  		// 32
  		[17, 145, 115],
  		[10, 74, 46, 23, 75, 47],
  		[10, 54, 24, 35, 55, 25],
  		[19, 45, 15, 35, 46, 16],
  	
  		// 33
  		[17, 145, 115, 1, 146, 116],
  		[14, 74, 46, 21, 75, 47],
  		[29, 54, 24, 19, 55, 25],
  		[11, 45, 15, 46, 46, 16],
  	
  		// 34
  		[13, 145, 115, 6, 146, 116],
  		[14, 74, 46, 23, 75, 47],
  		[44, 54, 24, 7, 55, 25],
  		[59, 46, 16, 1, 47, 17],
  	
  		// 35
  		[12, 151, 121, 7, 152, 122],
  		[12, 75, 47, 26, 76, 48],
  		[39, 54, 24, 14, 55, 25],
  		[22, 45, 15, 41, 46, 16],
  	
  		// 36
  		[6, 151, 121, 14, 152, 122],
  		[6, 75, 47, 34, 76, 48],
  		[46, 54, 24, 10, 55, 25],
  		[2, 45, 15, 64, 46, 16],
  	
  		// 37
  		[17, 152, 122, 4, 153, 123],
  		[29, 74, 46, 14, 75, 47],
  		[49, 54, 24, 10, 55, 25],
  		[24, 45, 15, 46, 46, 16],
  	
  		// 38
  		[4, 152, 122, 18, 153, 123],
  		[13, 74, 46, 32, 75, 47],
  		[48, 54, 24, 14, 55, 25],
  		[42, 45, 15, 32, 46, 16],
  	
  		// 39
  		[20, 147, 117, 4, 148, 118],
  		[40, 75, 47, 7, 76, 48],
  		[43, 54, 24, 22, 55, 25],
  		[10, 45, 15, 67, 46, 16],
  	
  		// 40
  		[19, 148, 118, 6, 149, 119],
  		[18, 75, 47, 31, 76, 48],
  		[34, 54, 24, 34, 55, 25],
  		[20, 45, 15, 61, 46, 16]
  	];
  	
  	QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
  		
  		var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
  		
  		if (rsBlock === undefined) {
  			throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
  		}
  	
  		var length = rsBlock.length / 3;
  		
  		var list = [];
  		
  		for (var i = 0; i < length; i++) {
  	
  			var count = rsBlock[i * 3 + 0];
  			var totalCount = rsBlock[i * 3 + 1];
  			var dataCount  = rsBlock[i * 3 + 2];
  	
  			for (var j = 0; j < count; j++) {
  				list.push(new QRRSBlock(totalCount, dataCount) );	
  			}
  		}
  		
  		return list;
  	};
  	
  	QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
  	
  		switch(errorCorrectLevel) {
  		case QRErrorCorrectLevel.L :
  			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
  		case QRErrorCorrectLevel.M :
  			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
  		case QRErrorCorrectLevel.Q :
  			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
  		case QRErrorCorrectLevel.H :
  			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
  		default :
  			return undefined;
  		}
  	};
  	
  	var QRUtil = {
  	
  	    PATTERN_POSITION_TABLE : [
  	        [],
  	        [6, 18],
  	        [6, 22],
  	        [6, 26],
  	        [6, 30],
  	        [6, 34],
  	        [6, 22, 38],
  	        [6, 24, 42],
  	        [6, 26, 46],
  	        [6, 28, 50],
  	        [6, 30, 54],        
  	        [6, 32, 58],
  	        [6, 34, 62],
  	        [6, 26, 46, 66],
  	        [6, 26, 48, 70],
  	        [6, 26, 50, 74],
  	        [6, 30, 54, 78],
  	        [6, 30, 56, 82],
  	        [6, 30, 58, 86],
  	        [6, 34, 62, 90],
  	        [6, 28, 50, 72, 94],
  	        [6, 26, 50, 74, 98],
  	        [6, 30, 54, 78, 102],
  	        [6, 28, 54, 80, 106],
  	        [6, 32, 58, 84, 110],
  	        [6, 30, 58, 86, 114],
  	        [6, 34, 62, 90, 118],
  	        [6, 26, 50, 74, 98, 122],
  	        [6, 30, 54, 78, 102, 126],
  	        [6, 26, 52, 78, 104, 130],
  	        [6, 30, 56, 82, 108, 134],
  	        [6, 34, 60, 86, 112, 138],
  	        [6, 30, 58, 86, 114, 142],
  	        [6, 34, 62, 90, 118, 146],
  	        [6, 30, 54, 78, 102, 126, 150],
  	        [6, 24, 50, 76, 102, 128, 154],
  	        [6, 28, 54, 80, 106, 132, 158],
  	        [6, 32, 58, 84, 110, 136, 162],
  	        [6, 26, 54, 82, 110, 138, 166],
  	        [6, 30, 58, 86, 114, 142, 170]
  	    ],
  	
  	    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
  	    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
  	    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)    | (1 << 4) | (1 << 1),
  	
  	    getBCHTypeInfo : function(data) {
  	        var d = data << 10;
  	        while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
  	            d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) );    
  	        }
  	        return ( (data << 10) | d) ^ QRUtil.G15_MASK;
  	    },
  	
  	    getBCHTypeNumber : function(data) {
  	        var d = data << 12;
  	        while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
  	            d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) );    
  	        }
  	        return (data << 12) | d;
  	    },
  	
  	    getBCHDigit : function(data) {
  	
  	        var digit = 0;
  	
  	        while (data !== 0) {
  	            digit++;
  	            data >>>= 1;
  	        }
  	
  	        return digit;
  	    },
  	
  	    getPatternPosition : function(typeNumber) {
  	        return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
  	    },
  	
  	    getMask : function(maskPattern, i, j) {
  	        
  	        switch (maskPattern) {
  	            
  	        case QRMaskPattern.PATTERN000 : return (i + j) % 2 === 0;
  	        case QRMaskPattern.PATTERN001 : return i % 2 === 0;
  	        case QRMaskPattern.PATTERN010 : return j % 3 === 0;
  	        case QRMaskPattern.PATTERN011 : return (i + j) % 3 === 0;
  	        case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 === 0;
  	        case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 === 0;
  	        case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 === 0;
  	        case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 === 0;
  	
  	        default :
  	            throw new Error("bad maskPattern:" + maskPattern);
  	        }
  	    },
  	
  	    getErrorCorrectPolynomial : function(errorCorrectLength) {
  	
  	        var a = new QRPolynomial([1], 0);
  	
  	        for (var i = 0; i < errorCorrectLength; i++) {
  	            a = a.multiply(new QRPolynomial([1, QRMath.gexp(i)], 0) );
  	        }
  	
  	        return a;
  	    },
  	
  	    getLengthInBits : function(mode, type) {
  	
  	        if (1 <= type && type < 10) {
  	
  	            // 1 - 9
  	
  	            switch(mode) {
  	            case QRMode.MODE_NUMBER     : return 10;
  	            case QRMode.MODE_ALPHA_NUM  : return 9;
  	            case QRMode.MODE_8BIT_BYTE  : return 8;
  	            case QRMode.MODE_KANJI      : return 8;
  	            default :
  	                throw new Error("mode:" + mode);
  	            }
  	
  	        } else if (type < 27) {
  	
  	            // 10 - 26
  	
  	            switch(mode) {
  	            case QRMode.MODE_NUMBER     : return 12;
  	            case QRMode.MODE_ALPHA_NUM  : return 11;
  	            case QRMode.MODE_8BIT_BYTE  : return 16;
  	            case QRMode.MODE_KANJI      : return 10;
  	            default :
  	                throw new Error("mode:" + mode);
  	            }
  	
  	        } else if (type < 41) {
  	
  	            // 27 - 40
  	
  	            switch(mode) {
  	            case QRMode.MODE_NUMBER     : return 14;
  	            case QRMode.MODE_ALPHA_NUM  : return 13;
  	            case QRMode.MODE_8BIT_BYTE  : return 16;
  	            case QRMode.MODE_KANJI      : return 12;
  	            default :
  	                throw new Error("mode:" + mode);
  	            }
  	
  	        } else {
  	            throw new Error("type:" + type);
  	        }
  	    },
  	
  	    getLostPoint : function(qrCode) {
  	        
  	        var moduleCount = qrCode.getModuleCount();
  	        var lostPoint = 0;
  	        var row = 0; 
  	        var col = 0;
  	
  	        
  	        // LEVEL1
  	        
  	        for (row = 0; row < moduleCount; row++) {
  	
  	            for (col = 0; col < moduleCount; col++) {
  	
  	                var sameCount = 0;
  	                var dark = qrCode.isDark(row, col);
  	
  	                for (var r = -1; r <= 1; r++) {
  	
  	                    if (row + r < 0 || moduleCount <= row + r) {
  	                        continue;
  	                    }
  	
  	                    for (var c = -1; c <= 1; c++) {
  	
  	                        if (col + c < 0 || moduleCount <= col + c) {
  	                            continue;
  	                        }
  	
  	                        if (r === 0 && c === 0) {
  	                            continue;
  	                        }
  	
  	                        if (dark === qrCode.isDark(row + r, col + c) ) {
  	                            sameCount++;
  	                        }
  	                    }
  	                }
  	
  	                if (sameCount > 5) {
  	                    lostPoint += (3 + sameCount - 5);
  	                }
  	            }
  	        }
  	
  	        // LEVEL2
  	
  	        for (row = 0; row < moduleCount - 1; row++) {
  	            for (col = 0; col < moduleCount - 1; col++) {
  	                var count = 0;
  	                if (qrCode.isDark(row,     col    ) ) count++;
  	                if (qrCode.isDark(row + 1, col    ) ) count++;
  	                if (qrCode.isDark(row,     col + 1) ) count++;
  	                if (qrCode.isDark(row + 1, col + 1) ) count++;
  	                if (count === 0 || count === 4) {
  	                    lostPoint += 3;
  	                }
  	            }
  	        }
  	
  	        // LEVEL3
  	
  	        for (row = 0; row < moduleCount; row++) {
  	            for (col = 0; col < moduleCount - 6; col++) {
  	                if (qrCode.isDark(row, col) && 
  	                        !qrCode.isDark(row, col + 1) && 
  	                         qrCode.isDark(row, col + 2) && 
  	                         qrCode.isDark(row, col + 3) && 
  	                         qrCode.isDark(row, col + 4) && 
  	                        !qrCode.isDark(row, col + 5) && 
  	                         qrCode.isDark(row, col + 6) ) {
  	                    lostPoint += 40;
  	                }
  	            }
  	        }
  	
  	        for (col = 0; col < moduleCount; col++) {
  	            for (row = 0; row < moduleCount - 6; row++) {
  	                if (qrCode.isDark(row, col) &&
  	                        !qrCode.isDark(row + 1, col) &&
  	                         qrCode.isDark(row + 2, col) &&
  	                         qrCode.isDark(row + 3, col) &&
  	                         qrCode.isDark(row + 4, col) &&
  	                        !qrCode.isDark(row + 5, col) &&
  	                         qrCode.isDark(row + 6, col) ) {
  	                    lostPoint += 40;
  	                }
  	            }
  	        }
  	
  	        // LEVEL4
  	        
  	        var darkCount = 0;
  	
  	        for (col = 0; col < moduleCount; col++) {
  	            for (row = 0; row < moduleCount; row++) {
  	                if (qrCode.isDark(row, col) ) {
  	                    darkCount++;
  	                }
  	            }
  	        }
  	        
  	        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
  	        lostPoint += ratio * 10;
  	
  	        return lostPoint;       
  	    }
  	
  	};
  	
  	//---------------------------------------------------------------------
  	// QRCode for JavaScript
  	//
  	// Copyright (c) 2009 Kazuhiko Arase
  	//
  	// URL: http://www.d-project.com/
  	//
  	// Licensed under the MIT license:
  	//   http://www.opensource.org/licenses/mit-license.php
  	//
  	// The word "QR Code" is registered trademark of 
  	// DENSO WAVE INCORPORATED
  	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
  	//
  	//---------------------------------------------------------------------
  	// Modified to work in node for this project (and some refactoring)
  	//---------------------------------------------------------------------
  	
  	function QRCode(typeNumber, errorCorrectLevel) {
  		this.typeNumber = typeNumber;
  		this.errorCorrectLevel = errorCorrectLevel;
  		this.modules = null;
  		this.moduleCount = 0;
  		this.dataCache = null;
  		this.dataList = [];
  	}
  	
  	QRCode.prototype = {
  		
  		addData : function(data) {
  			var newData = new QR8bitByte(data);
  			this.dataList.push(newData);
  			this.dataCache = null;
  		},
  		
  		isDark : function(row, col) {
  			if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
  				throw new Error(row + "," + col);
  			}
  			return this.modules[row][col];
  		},
  	
  		getModuleCount : function() {
  			return this.moduleCount;
  		},
  		
  		make : function() {
  			// Calculate automatically typeNumber if provided is < 1
  			if (this.typeNumber < 1 ){
  				var typeNumber = 1;
  				for (typeNumber = 1; typeNumber < 40; typeNumber++) {
  					var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
  	
  					var buffer = new QRBitBuffer();
  					var totalDataCount = 0;
  					for (var i = 0; i < rsBlocks.length; i++) {
  						totalDataCount += rsBlocks[i].dataCount;
  					}
  	
  					for (var x = 0; x < this.dataList.length; x++) {
  						var data = this.dataList[x];
  						buffer.put(data.mode, 4);
  						buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber) );
  						data.write(buffer);
  					}
  					if (buffer.getLengthInBits() <= totalDataCount * 8)
  						break;
  				}
  				this.typeNumber = typeNumber;
  			}
  			this.makeImpl(false, this.getBestMaskPattern() );
  		},
  		
  		makeImpl : function(test, maskPattern) {
  			
  			this.moduleCount = this.typeNumber * 4 + 17;
  			this.modules = new Array(this.moduleCount);
  			
  			for (var row = 0; row < this.moduleCount; row++) {
  				
  				this.modules[row] = new Array(this.moduleCount);
  				
  				for (var col = 0; col < this.moduleCount; col++) {
  					this.modules[row][col] = null;//(col + row) % 3;
  				}
  			}
  		
  			this.setupPositionProbePattern(0, 0);
  			this.setupPositionProbePattern(this.moduleCount - 7, 0);
  			this.setupPositionProbePattern(0, this.moduleCount - 7);
  			this.setupPositionAdjustPattern();
  			this.setupTimingPattern();
  			this.setupTypeInfo(test, maskPattern);
  			
  			if (this.typeNumber >= 7) {
  				this.setupTypeNumber(test);
  			}
  		
  			if (this.dataCache === null) {
  				this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
  			}
  		
  			this.mapData(this.dataCache, maskPattern);
  		},
  	
  		setupPositionProbePattern : function(row, col)  {
  			
  			for (var r = -1; r <= 7; r++) {
  				
  				if (row + r <= -1 || this.moduleCount <= row + r) continue;
  				
  				for (var c = -1; c <= 7; c++) {
  					
  					if (col + c <= -1 || this.moduleCount <= col + c) continue;
  					
  					if ( (0 <= r && r <= 6 && (c === 0 || c === 6) ) || 
  	                     (0 <= c && c <= 6 && (r === 0 || r === 6) ) || 
  	                     (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
  						this.modules[row + r][col + c] = true;
  					} else {
  						this.modules[row + r][col + c] = false;
  					}
  				}		
  			}		
  		},
  		
  		getBestMaskPattern : function() {
  		
  			var minLostPoint = 0;
  			var pattern = 0;
  		
  			for (var i = 0; i < 8; i++) {
  				
  				this.makeImpl(true, i);
  		
  				var lostPoint = QRUtil.getLostPoint(this);
  		
  				if (i === 0 || minLostPoint >  lostPoint) {
  					minLostPoint = lostPoint;
  					pattern = i;
  				}
  			}
  		
  			return pattern;
  		},
  		
  		createMovieClip : function(target_mc, instance_name, depth) {
  		
  			var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
  			var cs = 1;
  		
  			this.make();
  	
  			for (var row = 0; row < this.modules.length; row++) {
  				
  				var y = row * cs;
  				
  				for (var col = 0; col < this.modules[row].length; col++) {
  		
  					var x = col * cs;
  					var dark = this.modules[row][col];
  				
  					if (dark) {
  						qr_mc.beginFill(0, 100);
  						qr_mc.moveTo(x, y);
  						qr_mc.lineTo(x + cs, y);
  						qr_mc.lineTo(x + cs, y + cs);
  						qr_mc.lineTo(x, y + cs);
  						qr_mc.endFill();
  					}
  				}
  			}
  			
  			return qr_mc;
  		},
  	
  		setupTimingPattern : function() {
  			
  			for (var r = 8; r < this.moduleCount - 8; r++) {
  				if (this.modules[r][6] !== null) {
  					continue;
  				}
  				this.modules[r][6] = (r % 2 === 0);
  			}
  		
  			for (var c = 8; c < this.moduleCount - 8; c++) {
  				if (this.modules[6][c] !== null) {
  					continue;
  				}
  				this.modules[6][c] = (c % 2 === 0);
  			}
  		},
  		
  		setupPositionAdjustPattern : function() {
  		
  			var pos = QRUtil.getPatternPosition(this.typeNumber);
  			
  			for (var i = 0; i < pos.length; i++) {
  			
  				for (var j = 0; j < pos.length; j++) {
  				
  					var row = pos[i];
  					var col = pos[j];
  					
  					if (this.modules[row][col] !== null) {
  						continue;
  					}
  					
  					for (var r = -2; r <= 2; r++) {
  					
  						for (var c = -2; c <= 2; c++) {
  						
  							if (Math.abs(r) === 2 || 
  	                            Math.abs(c) === 2 ||
  	                            (r === 0 && c === 0) ) {
  								this.modules[row + r][col + c] = true;
  							} else {
  								this.modules[row + r][col + c] = false;
  							}
  						}
  					}
  				}
  			}
  		},
  		
  		setupTypeNumber : function(test) {
  		
  			var bits = QRUtil.getBCHTypeNumber(this.typeNumber);
  	        var mod;
  		
  			for (var i = 0; i < 18; i++) {
  				mod = (!test && ( (bits >> i) & 1) === 1);
  				this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
  			}
  		
  			for (var x = 0; x < 18; x++) {
  				mod = (!test && ( (bits >> x) & 1) === 1);
  				this.modules[x % 3 + this.moduleCount - 8 - 3][Math.floor(x / 3)] = mod;
  			}
  		},
  		
  		setupTypeInfo : function(test, maskPattern) {
  		
  			var data = (this.errorCorrectLevel << 3) | maskPattern;
  			var bits = QRUtil.getBCHTypeInfo(data);
  	        var mod;
  		
  			// vertical		
  			for (var v = 0; v < 15; v++) {
  		
  				mod = (!test && ( (bits >> v) & 1) === 1);
  		
  				if (v < 6) {
  					this.modules[v][8] = mod;
  				} else if (v < 8) {
  					this.modules[v + 1][8] = mod;
  				} else {
  					this.modules[this.moduleCount - 15 + v][8] = mod;
  				}
  			}
  		
  			// horizontal
  			for (var h = 0; h < 15; h++) {
  		
  				mod = (!test && ( (bits >> h) & 1) === 1);
  				
  				if (h < 8) {
  					this.modules[8][this.moduleCount - h - 1] = mod;
  				} else if (h < 9) {
  					this.modules[8][15 - h - 1 + 1] = mod;
  				} else {
  					this.modules[8][15 - h - 1] = mod;
  				}
  			}
  		
  			// fixed module
  			this.modules[this.moduleCount - 8][8] = (!test);
  		
  		},
  		
  		mapData : function(data, maskPattern) {
  			
  			var inc = -1;
  			var row = this.moduleCount - 1;
  			var bitIndex = 7;
  			var byteIndex = 0;
  			
  			for (var col = this.moduleCount - 1; col > 0; col -= 2) {
  		
  				if (col === 6) col--;
  		
  				while (true) {
  		
  					for (var c = 0; c < 2; c++) {
  						
  						if (this.modules[row][col - c] === null) {
  							
  							var dark = false;
  		
  							if (byteIndex < data.length) {
  								dark = ( ( (data[byteIndex] >>> bitIndex) & 1) === 1);
  							}
  		
  							var mask = QRUtil.getMask(maskPattern, row, col - c);
  		
  							if (mask) {
  								dark = !dark;
  							}
  							
  							this.modules[row][col - c] = dark;
  							bitIndex--;
  		
  							if (bitIndex === -1) {
  								byteIndex++;
  								bitIndex = 7;
  							}
  						}
  					}
  									
  					row += inc;
  		
  					if (row < 0 || this.moduleCount <= row) {
  						row -= inc;
  						inc = -inc;
  						break;
  					}
  				}
  			}
  			
  		}
  	
  	};
  	
  	QRCode.PAD0 = 0xEC;
  	QRCode.PAD1 = 0x11;
  	
  	QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
  		
  		var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
  		
  		var buffer = new QRBitBuffer();
  		
  		for (var i = 0; i < dataList.length; i++) {
  			var data = dataList[i];
  			buffer.put(data.mode, 4);
  			buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber) );
  			data.write(buffer);
  		}
  	
  		// calc num max data.
  		var totalDataCount = 0;
  		for (var x = 0; x < rsBlocks.length; x++) {
  			totalDataCount += rsBlocks[x].dataCount;
  		}
  	
  		if (buffer.getLengthInBits() > totalDataCount * 8) {
  			throw new Error("code length overflow. (" + 
  	            buffer.getLengthInBits() + 
  	            ">" +  
  	            totalDataCount * 8 + 
  	            ")");
  		}
  	
  		// end code
  		if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
  			buffer.put(0, 4);
  		}
  	
  		// padding
  		while (buffer.getLengthInBits() % 8 !== 0) {
  			buffer.putBit(false);
  		}
  	
  		// padding
  		while (true) {
  			
  			if (buffer.getLengthInBits() >= totalDataCount * 8) {
  				break;
  			}
  			buffer.put(QRCode.PAD0, 8);
  			
  			if (buffer.getLengthInBits() >= totalDataCount * 8) {
  				break;
  			}
  			buffer.put(QRCode.PAD1, 8);
  		}
  	
  		return QRCode.createBytes(buffer, rsBlocks);
  	};
  	
  	QRCode.createBytes = function(buffer, rsBlocks) {
  	
  		var offset = 0;
  		
  		var maxDcCount = 0;
  		var maxEcCount = 0;
  		
  		var dcdata = new Array(rsBlocks.length);
  		var ecdata = new Array(rsBlocks.length);
  		
  		for (var r = 0; r < rsBlocks.length; r++) {
  	
  			var dcCount = rsBlocks[r].dataCount;
  			var ecCount = rsBlocks[r].totalCount - dcCount;
  	
  			maxDcCount = Math.max(maxDcCount, dcCount);
  			maxEcCount = Math.max(maxEcCount, ecCount);
  			
  			dcdata[r] = new Array(dcCount);
  			
  			for (var i = 0; i < dcdata[r].length; i++) {
  				dcdata[r][i] = 0xff & buffer.buffer[i + offset];
  			}
  			offset += dcCount;
  			
  			var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
  			var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1);
  	
  			var modPoly = rawPoly.mod(rsPoly);
  			ecdata[r] = new Array(rsPoly.getLength() - 1);
  			for (var x = 0; x < ecdata[r].length; x++) {
  	            var modIndex = x + modPoly.getLength() - ecdata[r].length;
  				ecdata[r][x] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
  			}
  	
  		}
  		
  		var totalCodeCount = 0;
  		for (var y = 0; y < rsBlocks.length; y++) {
  			totalCodeCount += rsBlocks[y].totalCount;
  		}
  	
  		var data = new Array(totalCodeCount);
  		var index = 0;
  	
  		for (var z = 0; z < maxDcCount; z++) {
  			for (var s = 0; s < rsBlocks.length; s++) {
  				if (z < dcdata[s].length) {
  					data[index++] = dcdata[s][z];
  				}
  			}
  		}
  	
  		for (var xx = 0; xx < maxEcCount; xx++) {
  			for (var t = 0; t < rsBlocks.length; t++) {
  				if (xx < ecdata[t].length) {
  					data[index++] = ecdata[t][xx];
  				}
  			}
  		}
  	
  		return data;
  	
  	};
  	
  	    return {
  	      QRCode: QRCode,
  	      QRErrorCorrectLevel: QRErrorCorrectLevel
  	    };
  	  })();
  	
  	  function managerBuildQrSvg(value) {
  	    var payload = managerText(value, "").trim();
  	    if (!payload) return "";
  	
  	    var qr = new managerQrLibrary.QRCode(
  	      -1,
  	      managerQrLibrary.QRErrorCorrectLevel.M
  	    );
  	
  	    qr.addData(payload);
  	    qr.make();
  	
  	    var moduleCount = qr.getModuleCount();
  	    var quietZone = 4;
  	    var imageSize = moduleCount + quietZone * 2;
  	    var path = [];
  	
  	    for (var row = 0; row < moduleCount; row++) {
  	      for (var column = 0; column < moduleCount; column++) {
  	        if (!qr.isDark(row, column)) continue;
  	
  	        path.push(
  	          "M" + (column + quietZone) + " " + (row + quietZone) +
  	          "h1v1h-1z"
  	        );
  	      }
  	    }
  	
  	    return (
  	      '<svg xmlns="http://www.w3.org/2000/svg" ' +
  	      'viewBox="0 0 ' + imageSize + " " + imageSize + '" ' +
  	      'role="img" aria-label="Bowser QR Code" ' +
  	      'shape-rendering="crispEdges">' +
  	        '<rect width="100%" height="100%" fill="#ffffff"/>' +
  	        '<path d="' + path.join("") + '" fill="#000000"/>' +
  	      '</svg>'
  	    );
  	  }
  	
  	  function managerPrintableDate(value) {
  	    var date = value instanceof Date ? value : new Date(value || Date.now());
  	    if (Number.isNaN(date.getTime())) date = new Date();
  	
  	    function pad(number) {
  	      return String(number).padStart(2, "0");
  	    }
  	
  	    return (
  	      date.getFullYear() + "-" +
  	      pad(date.getMonth() + 1) + "-" +
  	      pad(date.getDate()) + " " +
  	      pad(date.getHours()) + ":" +
  	      pad(date.getMinutes()) + ":" +
  	      pad(date.getSeconds())
  	    );
  	  }
  	
  	  function managerPrintLogoCss() {
  	    return (
  	      ".fif-manager-logo-img{display:block;max-width:220px;max-height:72px;object-fit:contain;}" +
  	      ".fif-manager-logo-svg{display:block;max-width:220px;max-height:72px;}" +
  	      ".fif-manager-logo-svg svg{display:block;width:100%;max-width:220px;max-height:72px;}" +
  	      ".fif-manager-logo-fallback{width:84px;height:48px;display:grid;place-items:center;border:2px solid #c65f28;border-radius:10px;color:#8f3c18;font-size:20px;font-weight:900;}"
  	    );
  	  }
  	
  	  function managerEnsureBowserQrSelectorStyle() {
  	    if (document.getElementById(MANAGER_BOWSER_QR_STYLE_ID)) return;
  	
  	    var style = document.createElement("style");
  	    style.id = MANAGER_BOWSER_QR_STYLE_ID;
  	    style.textContent = `
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} {
  	        position: fixed !important;
  	        inset: 0 !important;
  	        z-index: 2147483647 !important;
  	        display: grid !important;
  	        place-items: center !important;
  	        padding: 18px !important;
  	        box-sizing: border-box !important;
  	        background:
  	          radial-gradient(circle at 50% 35%, rgba(180, 78, 31, 0.13), transparent 40%),
  	          rgba(0, 0, 0, 0.78) !important;
  	        backdrop-filter: blur(7px) !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-card {
  	        width: min(520px, calc(100vw - 36px)) !important;
  	        max-height: min(680px, calc(100vh - 36px)) !important;
  	        display: flex !important;
  	        flex-direction: column !important;
  	        overflow: hidden !important;
  	        box-sizing: border-box !important;
  	        border: 1px solid rgba(251, 146, 60, 0.52) !important;
  	        border-radius: 22px !important;
  	        color: #f8fafc !important;
  	        background:
  	          radial-gradient(circle at 16% 0%, rgba(249, 115, 22, 0.11), transparent 36%),
  	          linear-gradient(145deg, rgba(22, 23, 25, 0.995), rgba(5, 8, 11, 0.995)) !important;
  	        box-shadow:
  	          0 28px 70px rgba(0, 0, 0, 0.64),
  	          inset 0 1px 0 rgba(255, 255, 255, 0.045) !important;
  	        font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-head {
  	        display: grid !important;
  	        grid-template-columns: minmax(0, 1fr) 34px !important;
  	        align-items: center !important;
  	        gap: 12px !important;
  	        padding: 18px !important;
  	        border-bottom: 1px solid rgba(251, 146, 60, 0.24) !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-title {
  	        margin: 0 !important;
  	        color: #ffffff !important;
  	        font-size: 18px !important;
  	        font-weight: 950 !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-subtitle {
  	        margin-top: 4px !important;
  	        color: #aab5c3 !important;
  	        font-size: 10px !important;
  	        font-weight: 700 !important;
  	        line-height: 1.4 !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-close {
  	        width: 34px !important;
  	        height: 34px !important;
  	        display: grid !important;
  	        place-items: center !important;
  	        padding: 0 !important;
  	        border: 1px solid rgba(255, 255, 255, 0.11) !important;
  	        border-radius: 11px !important;
  	        outline: none !important;
  	        cursor: pointer !important;
  	        color: #f2f4f7 !important;
  	        background: rgba(255, 255, 255, 0.045) !important;
  	        font-size: 19px !important;
  	        font-weight: 900 !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-list {
  	        display: grid !important;
  	        grid-template-columns: 1fr !important;
  	        gap: 8px !important;
  	        padding: 14px 16px 18px !important;
  	        overflow-y: auto !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-option {
  	        width: 100% !important;
  	        min-height: 58px !important;
  	        display: grid !important;
  	        grid-template-columns: 38px minmax(0, 1fr) auto !important;
  	        align-items: center !important;
  	        gap: 11px !important;
  	        padding: 10px 12px !important;
  	        box-sizing: border-box !important;
  	        border: 1px solid rgba(255, 255, 255, 0.08) !important;
  	        border-radius: 13px !important;
  	        outline: none !important;
  	        cursor: pointer !important;
  	        color: #eef2f6 !important;
  	        background: rgba(255, 255, 255, 0.028) !important;
  	        text-align: left !important;
  	        font: inherit !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-option:hover,
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-option:focus-visible {
  	        border-color: rgba(251, 146, 60, 0.48) !important;
  	        background: rgba(249, 115, 22, 0.12) !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-icon {
  	        width: 36px !important;
  	        height: 36px !important;
  	        display: grid !important;
  	        place-items: center !important;
  	        border: 1px solid rgba(251, 146, 60, 0.38) !important;
  	        border-radius: 10px !important;
  	        color: #ffad70 !important;
  	        background: rgba(249, 115, 22, 0.09) !important;
  	        font-size: 18px !important;
  	        font-weight: 900 !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-name {
  	        display: block !important;
  	        overflow: hidden !important;
  	        color: #ffffff !important;
  	        font-size: 13px !important;
  	        font-weight: 900 !important;
  	        text-overflow: ellipsis !important;
  	        white-space: nowrap !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-id {
  	        display: block !important;
  	        margin-top: 3px !important;
  	        overflow: hidden !important;
  	        color: #8694a6 !important;
  	        font-size: 8.5px !important;
  	        font-weight: 650 !important;
  	        text-overflow: ellipsis !important;
  	        white-space: nowrap !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-action {
  	        color: #fb923c !important;
  	        font-size: 10px !important;
  	        font-weight: 900 !important;
  	        white-space: nowrap !important;
  	      }
  	
  	      #${MANAGER_BOWSER_QR_OVERLAY_ID} .fif-bowser-qr-empty {
  	        padding: 18px !important;
  	        border: 1px dashed rgba(255, 255, 255, 0.12) !important;
  	        border-radius: 13px !important;
  	        color: #aab5c3 !important;
  	        font-size: 11px !important;
  	        font-weight: 700 !important;
  	        line-height: 1.5 !important;
  	        text-align: center !important;
  	      }
  	    `;
  	
  	    document.head.appendChild(style);
  	  }
  	
  	  function managerCloseBowserQrSelector() {
  	    var overlay = document.getElementById(MANAGER_BOWSER_QR_OVERLAY_ID);
  	    if (overlay) {
  	      try {
  	        overlay.remove();
  	      } catch (_) {}
  	    }
  	  }
  	
  	  function managerOpenBowserQrPrint(company, tank, bowser, companyIndex, tankIndex, bowserIndex) {
  	    var objectId = managerText(managerGet(bowser, ["objectId"], ""), "").trim();
  	    var bowserName = managerBowserLabel(bowser, bowserIndex);
  	
  	    if (!objectId) {
  	      alert("This Bowser does not have an objectId, so a QR Code cannot be created.");
  	      return;
  	    }
  	
  	    var printWindow = window.open("", "_blank", "width=900,height=900");
  	    if (!printWindow) {
  	      alert("The Bowser QR Code print window was blocked by the browser.");
  	      return;
  	    }
  	
  	    var qrSvg = managerBuildQrSvg(objectId);
  	    var html = ""
  	      + "<!doctype html><html><head><meta charset=\"utf-8\">"
  	      + "<title>Bowser QR Code - " + managerEscape(bowserName) + "</title>"
  	      + "<style>"
  	      + "html,body{margin:0;padding:0;background:#fff;color:#111827;font-family:Arial,sans-serif;}"
  	      + "body{min-height:100vh;display:grid;place-items:center;box-sizing:border-box;padding:4vh 5vw;}"
  	      + managerPrintLogoCss()
  	      + ".sheet{width:min(90vw,189mm);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4mm;box-sizing:border-box;}"
  	      + ".logo{width:100%;height:34mm;display:flex;align-items:center;justify-content:center;overflow:hidden;}"
  	      + ".logo .fif-manager-logo-img{display:block;width:100%;height:100%;max-width:none;max-height:none;object-fit:contain;}"
  	      + ".logo .fif-manager-logo-svg{display:block;width:100%;height:100%;max-width:none;max-height:none;}"
  	      + ".logo .fif-manager-logo-svg svg{display:block;width:100%;height:100%;max-width:none;max-height:none;}"
  	      + ".logo .fif-manager-logo-fallback{width:100%;height:100%;box-sizing:border-box;}"
  	      + ".qr{width:100%;aspect-ratio:1 / 1;display:block;break-inside:avoid;}"
  	      + ".qr svg{display:block;width:100%;height:100%;}"
  	      + ".name{width:100%;box-sizing:border-box;font-size:36pt;font-weight:950;line-height:1.02;text-align:center;letter-spacing:-.025em;word-break:break-word;}"
  	      + ".print-button{position:fixed;right:18px;bottom:18px;height:42px;padding:0 20px;border:1px solid #9a431e;border-radius:10px;background:#a84f25;color:#fff;font-size:13px;font-weight:800;cursor:pointer;}"
  	      + "@page{size:A4 portrait;margin:6mm 10.5mm;}"
  	      + "@media print{html,body{width:189mm;height:285mm;min-height:285mm;}body{padding:0;}.sheet{width:189mm;height:285mm;gap:4mm;}.logo{width:189mm;height:34mm;}.qr{width:189mm;height:189mm;aspect-ratio:auto;}.name{width:189mm;font-size:36pt;}.print-button{display:none!important;}}"
  	      + "</style></head><body>"
  	      + "<main class=\"sheet\"><div class=\"logo\">" + managerLogoHtml() + "</div>"
  	      + "<div class=\"qr\">" + qrSvg + "</div>"
  	      + "<div class=\"name\">" + managerEscape(bowserName) + "</div></main>"
  	      + "<button class=\"print-button\" type=\"button\" onclick=\"window.print()\">Print QR</button>"
  	      + "<script>window.onload=function(){setTimeout(function(){try{window.focus();window.print();}catch(_){ }},500);};<\/script>"
  	      + "</body></html>";
  	
  	    printWindow.document.open();
  	    printWindow.document.write(html);
  	    printWindow.document.close();
  	  }
  	
  	  function managerOpenBowserQrSelector(company, tank, companyIndex, tankIndex) {
  	    managerCloseBowserQrSelector();
  	    managerEnsureBowserQrSelectorStyle();
  	
  	    var bowsers = managerBowsers(tank);
  	    var tankName = managerTankLabel(tank, tankIndex);
  	    var overlay = document.createElement("div");
  	    overlay.id = MANAGER_BOWSER_QR_OVERLAY_ID;
  	
  	    var optionsHtml = bowsers.length
  	      ? bowsers.map(function (bowser, bowserIndex) {
  	          var objectId = managerText(managerGet(bowser, ["objectId"], ""), "").trim();
  	          var bowserName = managerBowserLabel(bowser, bowserIndex);
  	
  	          return (
  	            '<button type="button" class="fif-bowser-qr-option" data-bowser-qr-index="' + bowserIndex + '">' +
  	              '<span class="fif-bowser-qr-icon" aria-hidden="true">▦</span>' +
  	              '<span><strong class="fif-bowser-qr-name">' + managerEscape(bowserName) + '</strong>' +
  	              '<small class="fif-bowser-qr-id">' + managerEscape(objectId || "No objectId available") + '</small></span>' +
  	              '<span class="fif-bowser-qr-action">' + (objectId ? "Print QR" : "Unavailable") + '</span>' +
  	            '</button>'
  	          );
  	        }).join("")
  	      : '<div class="fif-bowser-qr-empty">No Bowsers are attached to this Tank.</div>';
  	
  	    overlay.innerHTML =
  	      '<section class="fif-bowser-qr-card" role="dialog" aria-modal="true" aria-labelledby="fif-bowser-qr-title">' +
  	        '<header class="fif-bowser-qr-head">' +
  	          '<div><h2 class="fif-bowser-qr-title" id="fif-bowser-qr-title">Select Bowser QR Code</h2>' +
  	          '<div class="fif-bowser-qr-subtitle">' + managerEscape(tankName) + ' · Choose the Bowser whose objectId must be printed.</div></div>' +
  	          '<button type="button" class="fif-bowser-qr-close" data-bowser-qr-close aria-label="Close">×</button>' +
  	        '</header>' +
  	        '<div class="fif-bowser-qr-list">' + optionsHtml + '</div>' +
  	      '</section>';
  	
  	    overlay.addEventListener("click", function (event) {
  	      if (event.target === overlay || event.target.closest("[data-bowser-qr-close]")) {
  	        managerCloseBowserQrSelector();
  	        return;
  	      }
  	
  	      var option = event.target.closest("[data-bowser-qr-index]");
  	      if (!option) return;
  	
  	      var bowserIndex = Number(option.getAttribute("data-bowser-qr-index"));
  	      var bowser = bowsers[bowserIndex];
  	      if (!bowser) return;
  	
  	      var objectId = managerText(managerGet(bowser, ["objectId"], ""), "").trim();
  	      if (!objectId) {
  	        alert("This Bowser does not have an objectId, so a QR Code cannot be created.");
  	        return;
  	      }
  	
  	      managerCloseBowserQrSelector();
  	      managerOpenBowserQrPrint(
  	        company,
  	        tank,
  	        bowser,
  	        companyIndex,
  	        tankIndex,
  	        bowserIndex
  	      );
  	    });
  	
  	    document.body.appendChild(overlay);
  	
  	    var closeButton = overlay.querySelector("[data-bowser-qr-close]");
  	    if (closeButton) {
  	      try {
  	        closeButton.focus();
  	      } catch (_) {}
  	    }
  	  }
  	
  	  function managerOpenTankBlankForm(company, tank, companyIndex, tankIndex) {
  	    var printWindow = window.open("", "_blank", "width=1500,height=950");
  	    if (!printWindow) {
  	      alert("The blank Fuel Capture Sheet print window was blocked by the browser.");
  	      return;
  	    }
  	
  	    var blankRows = "";
  	    for (var rowIndex = 0; rowIndex < 20; rowIndex++) {
  	      blankRows += "<tr>" + "<td>&nbsp;</td>".repeat(10) + "</tr>";
  	    }
  	
  	    var html = ""
  	      + "<!doctype html><html><head><meta charset=\"utf-8\">"
  	      + "<title>Fuel Capture Sheet</title>"
  	      + "<style>"
  	      + "html,body{margin:0;padding:0;background:#fff;color:#111827;font-family:Arial,sans-serif;}"
  	      + "body{padding:8mm 9mm;box-sizing:border-box;}"
  	      + managerPrintLogoCss()
  	      + ".header{height:30mm;display:flex;align-items:flex-start;justify-content:space-between;gap:12mm;padding-bottom:5mm;box-sizing:border-box;border-bottom:1.5px solid #111827;}"
  	      + ".title{margin:0;padding-top:2mm;font-size:30pt;font-weight:900;line-height:1;letter-spacing:-.02em;}"
  	      + ".logo{width:68mm;display:flex;justify-content:flex-end;align-items:flex-start;}"
  	      + ".logo .fif-manager-logo-img{max-width:68mm;max-height:24mm;}"
  	      + ".logo .fif-manager-logo-svg,.logo .fif-manager-logo-svg svg{max-width:68mm;max-height:24mm;}"
  	      + ".table-wrap{margin-top:5mm;width:100%;}"
  	      + "table{width:100%;border-collapse:collapse;table-layout:fixed;}"
  	      + "thead th{height:13mm;padding:1.5mm 1.2mm;border:1px solid #111827;background:#111827;color:#fff;font-size:10pt;font-weight:900;line-height:1.1;text-align:left;vertical-align:middle;}"
  	      + "tbody td{height:9.8mm;padding:.8mm 1.2mm;border:.75px solid #8c97a5;font-size:9pt;vertical-align:middle;}"
  	      + ".print-button{position:fixed;right:18px;bottom:18px;height:42px;padding:0 20px;border:1px solid #9a431e;border-radius:10px;background:#a84f25;color:#fff;font-size:13px;font-weight:800;cursor:pointer;}"
  	      + "@page{size:A3 landscape;margin:7mm;}"
  	      + "@media print{body{padding:0;}thead{display:table-header-group;}tr{break-inside:avoid;}.print-button{display:none!important;}}"
  	      + "</style></head><body>"
  	      + "<header class=\"header\"><h1 class=\"title\">Fuel Capture Sheet</h1><div class=\"logo\">" + managerLogoHtml() + "</div></header>"
  	      + "<div class=\"table-wrap\"><table><colgroup>"
  	      + "<col style=\"width:9%\"><col style=\"width:15%\"><col style=\"width:12%\"><col style=\"width:11%\"><col style=\"width:12%\">"
  	      + "<col style=\"width:9%\"><col style=\"width:7%\"><col style=\"width:7%\"><col style=\"width:10%\"><col style=\"width:8%\">"
  	      + "</colgroup><thead><tr>"
  	      + "<th>Date</th><th>Company / Contractor</th><th>Application</th><th>Registration</th><th>Driver</th>"
  	      + "<th>Odometer</th><th>Litres</th><th>Meter</th><th>Attendant</th><th>Sign</th>"
  	      + "</tr></thead><tbody>" + blankRows + "</tbody></table></div>"
  	      + "<button class=\"print-button\" type=\"button\" onclick=\"window.print()\">Print Sheet</button>"
  	      + "<script>window.onload=function(){setTimeout(function(){try{window.focus();window.print();}catch(_){ }},500);};<\/script>"
  	      + "</body></html>";
  	
  	    printWindow.document.open();
  	    printWindow.document.write(html);
  	    printWindow.document.close();
  	  }
  	
  	  function managerClosePrintablesMenus(exceptWrap) {
  	    if (!hostEl) return;
  	
  	    var wraps = hostEl.querySelectorAll(".fif-manager-printables-wrap");
  	    for (var index = 0; index < wraps.length; index++) {
  	      var wrap = wraps[index];
  	      if (exceptWrap && wrap === exceptWrap) continue;
  	
  	      wrap.classList.remove("is-open");
  	      var button = wrap.querySelector('[data-fuel-action="toggle-printables"]');
  	      if (button) button.setAttribute("aria-expanded", "false");
  	    }
  	  }
  	
  	  function managerTogglePrintablesMenu(button) {
  	    var wrap = button ? button.closest(".fif-manager-printables-wrap") : null;
  	    if (!wrap) return;
  	
  	    var willOpen = !wrap.classList.contains("is-open");
  	    managerClosePrintablesMenus(wrap);
  	    wrap.classList.toggle("is-open", willOpen);
  	    button.setAttribute("aria-expanded", willOpen ? "true" : "false");
  	  }
  	
  	
  	  function managerDatabaseStatus(
  	    action,
  	    tableName,
  	    relationName
  	  ) {
  	    var verb = String(action || "save").toLowerCase();
  	    var table = String(tableName || "").toLowerCase();
  	    var relation = String(relationName || "");
  	
  	    if (verb === "relation") {
  	      if (/fuelout/i.test(relation)) {
  	        return "Updating fuel transaction links…";
  	      }
  	
  	      if (/fuelin/i.test(relation)) {
  	        return "Updating delivery links…";
  	      }
  	
  	      if (/viewc|viewh/i.test(relation)) {
  	        return "Updating monthly view links…";
  	      }
  	
  	      if (/tyres/i.test(relation)) {
  	        return "Updating tyre links…";
  	      }
  	
  	      return "Updating database relationships…";
  	    }
  	
  	    if (verb === "delete") {
  	      if (table === "fuelout") {
  	        return "Deleting fuel transaction…";
  	      }
  	
  	      if (table === "fuelin") {
  	      }
  	
  	      if (table === "companies") {
  	        return "Deleting supplier…";
  	      }
  	
  	      return "Deleting from database…";
  	    }
  	
  	    if (table === "tyres") {
  	      return "Updating tyres…";
  	    }
  	
  	    if (table === "tractors") {
  	      return "Updating vehicle mileage…";
  	    }
  	
  	    if (table === "tractorview") {
  	      return "Updating current vehicle view…";
  	    }
  	
  	    if (table === "bowserview") {
  	      return "Updating bowser view…";
  	    }
  	
  	    if (table === "bowsers") {
  	      return "Updating bowser meter…";
  	    }
  	
  	    if (table === "tankview") {
  	      return "Updating tank view…";
  	    }
  	
  	    if (table === "tanks") {
  	      return "Updating tank stock…";
  	    }
  	
  	    if (table === "fuelout") {
  	      return "Saving fuel transaction…";
  	    }
  	
  	    if (table === "fuelin") {
  	      return "Saving tank delivery…";
  	    }
  	
  	    if (table === "companies") {
  	      return "Saving supplier changes…";
  	    }
  	
  	    return "Saving to database…";
  	  }
  	
  	  function managerEnsureLoadingOverlay(status) {
  	    managerEnsureThemedSelectTheme();
  	
  	    var overlay = document.getElementById(
  	      MANAGER_LOADING_OVERLAY_ID
  	    );
  	
  	    if (!overlay) {
  	      overlay = document.createElement("div");
  	      overlay.id = MANAGER_LOADING_OVERLAY_ID;
  	      overlay.className =
  	        "fif-database-loading-overlay";
  	      overlay.setAttribute("role", "status");
  	      overlay.setAttribute("aria-live", "polite");
  	      overlay.setAttribute("aria-busy", "true");
  	
  	      overlay.innerHTML =
  	        '<div class="fif-database-loading-content">' +
  	          '<div class="fif-database-loading-logo">' +
  	            managerLogoHtml() +
  	          '</div>' +
  	          '<div class="fif-database-loading-status"></div>' +
  	          '<div class="fif-database-loading-note"></div>' +
  	          '<button type="button" class="fif-database-loading-ok">OK</button>' +
  	        '</div>';
  	
  	      document.body.appendChild(overlay);
  	
  	      var okButton = overlay.querySelector(
  	        ".fif-database-loading-ok"
  	      );
  	
  	      if (okButton) {
  	        okButton.onclick = function () {
  	          managerAcknowledgeLoadingError();
  	        };
  	      }
  	    }
  	
  	    managerLoadingLastStatus = managerText(
  	      status,
  	      managerLoadingLastStatus ||
  	      "Preparing operation…"
  	    );
  	
  	    var statusNode = overlay.querySelector(
  	      ".fif-database-loading-status"
  	    );
  	    var noteNode = overlay.querySelector(
  	      ".fif-database-loading-note"
  	    );
  	
  	    if (statusNode) {
  	      statusNode.textContent =
  	        managerLoadingLastStatus;
  	      statusNode.style.opacity = "1";
  	    }
  	
  	    if (noteNode && !managerLoadingErrorLocked) {
  	      noteNode.textContent =
  	        "Please keep this window open while Fleet In Form completes the operation.";
  	    }
  	
  	    overlay.classList.remove(
  	      "is-leaving",
  	      "is-error",
  	      "is-success"
  	    );
  	
  	    requestAnimationFrame(function () {
  	      if (overlay && overlay.isConnected) {
  	        overlay.classList.add("is-visible");
  	      }
  	    });
  	
  	    return overlay;
  	  }
  	
  	  function managerUpdateLoadingStatus(status) {
  	    managerLoadingLastStatus = managerText(
  	      status,
  	      "Working…"
  	    );
  	
  	    var overlay = document.getElementById(
  	      MANAGER_LOADING_OVERLAY_ID
  	    );
  	
  	    if (!overlay) {
  	      if (managerLoadingOperationCount > 0) {
  	        managerEnsureLoadingOverlay(
  	          managerLoadingLastStatus
  	        );
  	      }
  	      return;
  	    }
  	
  	    var statusNode = overlay.querySelector(
  	      ".fif-database-loading-status"
  	    );
  	
  	    if (statusNode) {
  	      statusNode.style.opacity = "0.34";
  	      window.setTimeout(function () {
  	        if (
  	          statusNode &&
  	          statusNode.isConnected &&
  	          !managerLoadingErrorLocked &&
  	          managerLoadingOperationCount > 0 &&
  	          overlay &&
  	          !overlay.classList.contains("is-success") &&
  	          !overlay.classList.contains("is-error")
  	        ) {
  	          statusNode.textContent =
  	            managerLoadingLastStatus;
  	          statusNode.style.opacity = "1";
  	        }
  	      }, 80);
  	    }
  	  }
  	
  	  function managerCancelLoadingTimers() {
  	    if (managerLoadingHideTimer !== null) {
  	      window.clearTimeout(managerLoadingHideTimer);
  	      managerLoadingHideTimer = null;
  	    }
  	
  	    if (managerLoadingSuccessTimer !== null) {
  	      window.clearTimeout(managerLoadingSuccessTimer);
  	      managerLoadingSuccessTimer = null;
  	    }
  	  }
  	
  	  function managerBeginLoading(status) {
  	    managerCancelLoadingTimers();
  	
  	    if (managerLoadingOperationCount <= 0) {
  	      managerLoadingOperationCount = 1;
  	      managerLoadingShownAt = Date.now();
  	    }
  	
  	    managerLoadingErrorLocked = false;
  	
  	    var overlay = managerEnsureLoadingOverlay(status);
  	
  	    if (overlay) {
  	      overlay.classList.remove(
  	        "is-error",
  	        "is-success",
  	        "is-leaving"
  	      );
  	      overlay.setAttribute("aria-busy", "true");
  	      overlay.setAttribute("role", "status");
  	      overlay.removeAttribute("aria-modal");
  	
  	      var noteNode = overlay.querySelector(
  	        ".fif-database-loading-note"
  	      );
  	      if (noteNode) {
  	        noteNode.textContent =
  	          "Please keep this window open while Fleet In Form completes the operation.";
  	      }
  	    }
  	
  	    managerUpdateLoadingStatus(status);
  	  }
  	
  	  function managerFadeOutLoadingOverlay() {
  	    var overlay = document.getElementById(
  	      MANAGER_LOADING_OVERLAY_ID
  	    );
  	    if (!overlay) return;
  	
  	    overlay.classList.add("is-leaving");
  	    overlay.classList.remove("is-visible");
  	
  	    window.setTimeout(function () {
  	      if (
  	        !managerLoadingErrorLocked &&
  	        managerLoadingOperationCount === 0 &&
  	        overlay &&
  	        overlay.parentNode
  	      ) {
  	        overlay.parentNode.removeChild(overlay);
  	      }
  	    }, 380);
  	  }
  	
  	  function managerCompleteLoading(message) {
  	    managerCancelLoadingTimers();
  	    managerLoadingOperationCount = 0;
  	    managerLoadingErrorLocked = false;
  	
  	    var finalMessage = managerText(
  	      message,
  	      "Operation completed successfully."
  	    );
  	    var overlay = managerEnsureLoadingOverlay(finalMessage);
  	
  	    overlay.classList.remove("is-error", "is-leaving");
  	    overlay.classList.add("is-success");
  	    overlay.setAttribute("aria-busy", "false");
  	
  	    var statusNode = overlay.querySelector(
  	      ".fif-database-loading-status"
  	    );
  	    var noteNode = overlay.querySelector(
  	      ".fif-database-loading-note"
  	    );
  	
  	    if (statusNode) {
  	      statusNode.textContent = finalMessage;
  	      statusNode.style.opacity = "1";
  	    }
  	    if (noteNode) {
  	      noteNode.textContent =
  	        "The update has been completed successfully.";
  	    }
  	
  	    var visibleFor = Date.now() - managerLoadingShownAt;
  	    var minimumVisibleRemaining = Math.max(0, 620 - visibleFor);
  	
  	    managerLoadingSuccessTimer = window.setTimeout(function () {
  	      managerLoadingSuccessTimer = null;
  	      managerFadeOutLoadingOverlay();
  	    }, Math.max(780, minimumVisibleRemaining));
  	  }
  	
  	  function managerFailLoading(message) {
  	    managerCancelLoadingTimers();
  	    managerLoadingOperationCount = 0;
  	    managerLoadingErrorLocked = true;
  	
  	    var errorMessage = managerText(
  	      message,
  	      "The operation could not be completed."
  	    );
  	    var overlay = managerEnsureLoadingOverlay(errorMessage);
  	
  	    overlay.classList.remove("is-success", "is-leaving");
  	    overlay.classList.add("is-error", "is-visible");
  	    overlay.setAttribute("aria-busy", "false");
  	    overlay.setAttribute("role", "alertdialog");
  	    overlay.setAttribute("aria-modal", "true");
  	
  	    var statusNode = overlay.querySelector(
  	      ".fif-database-loading-status"
  	    );
  	    var noteNode = overlay.querySelector(
  	      ".fif-database-loading-note"
  	    );
  	    var okButton = overlay.querySelector(
  	      ".fif-database-loading-ok"
  	    );
  	
  	    if (statusNode) {
  	      statusNode.textContent = errorMessage;
  	      statusNode.style.opacity = "1";
  	    }
  	    if (noteNode) {
  	      noteNode.textContent =
  	        "Nothing further will happen until this message is acknowledged.";
  	    }
  	    if (okButton) {
  	      window.setTimeout(function () {
  	        try { okButton.focus(); } catch (_) {}
  	      }, 40);
  	    }
  	  }
  	
  	  function managerAcknowledgeLoadingError() {
  	    if (!managerLoadingErrorLocked) return;
  	    managerLoadingErrorLocked = false;
  	    managerLoadingOperationCount = 0;
  	    managerFadeOutLoadingOverlay();
  	  }
  	
  	  function managerFinishLoading() {
  	    managerCompleteLoading(
  	      "Operation completed successfully."
  	    );
  	  }
  	
  	  function managerTrackDatabasePromise(status, promiseFactory) {
  	    var ownsImplicitOperation =
  	      managerLoadingOperationCount <= 0 &&
  	      !managerLoadingErrorLocked;
  	
  	    if (ownsImplicitOperation) {
  	      managerBeginLoading(status);
  	    } else {
  	      managerUpdateLoadingStatus(status);
  	    }
  	
  	    var operation;
  	    try {
  	      operation = promiseFactory();
  	    } catch (error) {
  	      if (ownsImplicitOperation) {
  	        managerFailLoading(
  	          error && error.message ? error.message : String(error)
  	        );
  	      }
  	      throw error;
  	    }
  	
  	    return Promise.resolve(operation).then(
  	      function (result) {
  	        if (ownsImplicitOperation) {
  	          managerCompleteLoading("Database update completed.");
  	        }
  	        return result;
  	      },
  	      function (error) {
  	        if (ownsImplicitOperation) {
  	          managerFailLoading(
  	            error && error.message
  	              ? error.message
  	              : "The database update could not be completed."
  	          );
  	        }
  	        throw error;
  	      }
  	    );
  	  }
  	
  	  function managerRemoveLoadingOverlay() {
  	    managerLoadingOperationCount = 0;
  	    managerLoadingErrorLocked = false;
  	    managerCancelLoadingTimers();
  	
  	    var overlay = document.getElementById(
  	      MANAGER_LOADING_OVERLAY_ID
  	    );
  	
  	    if (overlay) {
  	      try { overlay.remove(); } catch (_) {}
  	    }
  	  }
  	
  	  function managerSafeColour(value, fallback) {
  	    var colour = managerText(value, fallback);
  	
  	    if (
  	      /^#[0-9a-f]{3,8}$/i.test(colour) ||
  	      /^rgb(a)?\(/i.test(colour) ||
  	      /^hsl(a)?\(/i.test(colour) ||
  	      /^[a-z]+$/i.test(colour)
  	    ) {
  	      return colour;
  	    }
  	
  	    return fallback;
  	  }
  	
  	  // Gauge figures are presentation-only: book litres come from Tank.Volume,
  	  // and physical ATG litres come exclusively from ATGPolls.Readings[].VolumeL.
  	  function managerGaugeLitresText(value) {
  	    var litres = managerNumber(value, NaN);
  	    if (!Number.isFinite(litres)) return "NO DATA";
  	
  	    // Show thousands separated by spaces with a decimal point: 12 220.00L.
  	    return litres.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "L";
  	  }
  	
  	  function managerRenderGauge(host, tank, seed, overrideLevel, overrideVolume) {
  	    if (!host || !tank) return;
  	
  	    var level = Number.isFinite(overrideLevel)
  	      ? Math.max(0, Math.min(100, overrideLevel))
  	      : managerTankLevel(tank);
  	
  	    // No override: book stock. Explicit override: independent ATG reading.
  	    var isAtg = overrideVolume !== undefined;
  	    var volume = isAtg
  	      ? managerNumber(overrideVolume, NaN)
  	      : managerTankBookVolume(tank);
  	    var volumeText = managerGaugeLitresText(volume);
  	    var sourceLabel = isAtg ? "ATG stock" : "Book stock";
  	
  	    var liquidColour = managerSafeColour(
  	      managerGet(tank, ["Color"], null),
  	      "#3b82f6"
  	    );
  	
  	    var uid = (
  	      "fif_gauge_" +
  	      String(seed || Math.random().toString(36).slice(2))
  	    ).replace(/[^a-zA-Z0-9_-]/g, "_");
  	
  	    var centreX = 50;
  	    var centreY = 50;
  	    var outerRadius = 46;
  	    var innerRadius = 37;
  	    var liquidTop =
  	      centreY +
  	      innerRadius -
  	      ((level / 100) * (innerRadius * 2));
  	
  	    var liquidHeight =
  	      centreY +
  	      innerRadius -
  	      liquidTop;
  	
  	    host.innerHTML =
  	      '<svg class="fif-manager-gauge-svg" ' +
  	      'viewBox="0 0 100 100" ' +
  	      'xmlns="http://www.w3.org/2000/svg" ' +
  	      'aria-label="' + managerEscape(
  	        sourceLabel + ": " + Math.round(level) + " percent, " + volumeText
  	      ) + '">' +
  	        "<defs>" +
  	          '<radialGradient id="' + uid + '_shell" cx="34%" cy="28%" r="78%">' +
  	            '<stop offset="0%" stop-color="#ffffff"></stop>' +
  	            '<stop offset="44%" stop-color="#dce1e8"></stop>' +
  	            '<stop offset="76%" stop-color="#9aa3af"></stop>' +
  	            '<stop offset="100%" stop-color="#59616d"></stop>' +
  	          "</radialGradient>" +
  	          '<radialGradient id="' + uid + '_well" cx="35%" cy="28%" r="82%">' +
  	            '<stop offset="0%" stop-color="#f8fafc"></stop>' +
  	            '<stop offset="100%" stop-color="#cbd5e1"></stop>' +
  	          "</radialGradient>" +
  	          '<linearGradient id="' + uid + '_glass" x1="0" y1="0" x2="1" y2="1">' +
  	            '<stop offset="0%" stop-color="#ffffff" stop-opacity=".28"></stop>' +
  	            '<stop offset="100%" stop-color="#ffffff" stop-opacity=".04"></stop>' +
  	          "</linearGradient>" +
  	          '<clipPath id="' + uid + '_clip">' +
  	            '<circle cx="' + centreX + '" cy="' + centreY + '" r="' + innerRadius + '"></circle>' +
  	          "</clipPath>" +
  	        "</defs>" +
  	
  	        '<circle cx="' + centreX + '" cy="' + centreY + '" r="' + outerRadius + '" fill="url(#' + uid + '_shell)"></circle>' +
  	        '<circle cx="' + centreX + '" cy="' + centreY + '" r="' + innerRadius + '" fill="url(#' + uid + '_well)"></circle>' +
  	
  	        '<g clip-path="url(#' + uid + '_clip)">' +
  	          '<rect x="' + (centreX - innerRadius) + '" ' +
  	          'y="' + liquidTop + '" ' +
  	          'width="' + (innerRadius * 2) + '" ' +
  	          'height="' + liquidHeight + '" ' +
  	          'fill="' + managerEscape(liquidColour) + '"></rect>' +
  	
  	          '<rect x="' + (centreX - innerRadius + 4) + '" ' +
  	          'y="' + liquidTop + '" ' +
  	          'width="' + ((innerRadius * 2) - 8) + '" ' +
  	          'height="2.4" rx="1.2" fill="#fff" opacity=".28"></rect>' +
  	        "</g>" +
  	
  	        '<circle cx="' + centreX + '" cy="' + centreY + '" r="' + innerRadius + '" fill="url(#' + uid + '_glass)"></circle>' +
  	        '<ellipse cx="38" cy="37" rx="10" ry="20" fill="#fff" opacity=".13"></ellipse>' +
  	
  	        '<text class="fif-manager-gauge-level" x="50" y="51" text-anchor="middle">' +
  	          Math.round(level) + "%" +
  	        "</text>" +
  	
  	        '<text class="fif-manager-gauge-volume" x="50" y="64" text-anchor="middle">' +
  	          managerEscape(volumeText) +
  	        "</text>" +
  	      "</svg>";
  	  }
  	
  	  function managerCloseOverlays() {
  	    managerCloseTypedDeleteSafety(false);
  	
  	    var ids = [
  	      "fuel-capture-overlay",
  	      "fuel-delivery-overlay",
  	      MANAGER_DELIVERY_CONFIRM_OVERLAY_ID,
  	      MANAGER_RECORD_DELETE_OVERLAY_ID,
  	      MANAGER_BOWSER_QR_OVERLAY_ID,
  	      MANAGER_LOADING_OVERLAY_ID,
  	      MANAGER_EDIT_OVERLAY_ID,
  	      MANAGER_SUPPLIER_OVERLAY_ID
  	    ];
  	
  	    for (var index = 0; index < ids.length; index++) {
  	      var node = document.getElementById(ids[index]);
  	
  	      if (node) {
  	        try {
  	          managerDestroyThemedSelectsWithin(node);
  	        } catch (_) {}
  	
  	        try {
  	          node.remove();
  	        } catch (_) {}
  	      }
  	    }
  	  }
  	
  	  function managerCleanupPreviousInstance() {
  	    var previous = document.getElementById(MANAGER_OVERLAY_ID);
  	
  	    if (!previous) return;
  	
  	    try {
  	      if (typeof previous.__fifFuelManagerCleanup === "function") {
  	        previous.__fifFuelManagerCleanup();
  	        return;
  	      }
  	
  	      var previousHost = previous.querySelector("[data-fif-manager-host]");
  	
  	      if (
  	        previousHost &&
  	        typeof previousHost.__fifFuelManagerCleanup === "function"
  	      ) {
  	        previousHost.__fifFuelManagerCleanup();
  	        return;
  	      }
  	    } catch (_) {}
  	
  	    try {
  	      previous.remove();
  	    } catch (_) {}
  	  }
  	
  	  managerCleanupPreviousInstance();
  	  managerCloseOverlays();
  	
  	  var managerOverlay = document.createElement("div");
  	  managerOverlay.id = MANAGER_OVERLAY_ID;
  	  managerOverlay.setAttribute("role", "dialog");
  	  managerOverlay.setAttribute("aria-modal", "true");
  	  managerOverlay.setAttribute(
  	    "aria-label",
  	    "Tank and Bowser Management"
  	  );
  	
  	  Object.assign(managerOverlay.style, {
  	    position: "fixed",
  	    top: "50px",
  	    right: "0",
  	    bottom: "0",
  	    left: "0",
  	    width: "100vw",
  	    height: "calc(100vh - 50px)",
  	    margin: "0",
  	    padding: "0",
  	    overflow: "hidden",
  	    background: "#070b11",
  	    zIndex: String(FIF_MAX_Z_INDEX),
  	    pointerEvents: "auto",
  	    display: "block",
  	    opacity: "1",
  	    visibility: "visible",
  	    isolation: "isolate"
  	  });
  	
  	  var hostEl = document.createElement("div");
  	  hostEl.id = MANAGER_HOST_ID;
  	  hostEl.setAttribute("data-fif-manager-host", "true");
  	
  	  Object.assign(hostEl.style, {
  	    position: "absolute",
  	    inset: "0",
  	    width: "100%",
  	    height: "100%",
  	    minWidth: "0",
  	    minHeight: "0",
  	    overflow: "hidden",
  	    zIndex: String(FIF_MAX_Z_INDEX),
  	    pointerEvents: "auto"
  	  });
  	
  	  managerOverlay.appendChild(hostEl);
  	  document.body.appendChild(managerOverlay);
  	
  	  function managerIsFuelElement(element) {
  	    if (!element || !(element instanceof HTMLElement)) {
  	      return false;
  	    }
  	
  	    if (
  	      element === managerOverlay ||
  	      managerOverlay.contains(element)
  	    ) {
  	      return true;
  	    }
  	
  	    if (
  	      element.classList.contains("fif-themed-select-menu") ||
  	      element.closest(".fif-themed-select-menu")
  	    ) {
  	      return true;
  	    }
  	
  	    return Boolean(
  	      element.closest(
  	        "#" + MANAGER_OVERLAY_ID + "," +
  	        "#fuel-capture-overlay," +
  	        "#fuel-delivery-overlay," +
  	        "#" + MANAGER_DELIVERY_CONFIRM_OVERLAY_ID + "," +
  	        "#" + MANAGER_RECORD_DELETE_OVERLAY_ID + "," +
  	        "#" + MANAGER_BOWSER_QR_OVERLAY_ID + "," +
  	        "#" + MANAGER_LOADING_OVERLAY_ID + "," +
  	        "#" + MANAGER_EDIT_OVERLAY_ID + "," +
  	        "#" + MANAGER_SUPPLIER_OVERLAY_ID
  	      )
  	    );
  	  }
  	
  	  function managerIsVisible(element) {
  	    if (!element || !(element instanceof HTMLElement)) {
  	      return false;
  	    }
  	
  	    if (
  	      element.hidden ||
  	      element.getAttribute("aria-hidden") === "true"
  	    ) {
  	      return false;
  	    }
  	
  	    var style;
  	
  	    try {
  	      style = window.getComputedStyle(element);
  	    } catch (_) {
  	      return false;
  	    }
  	
  	    if (
  	      style.display === "none" ||
  	      style.visibility === "hidden" ||
  	      Number(style.opacity) <= 0.01
  	    ) {
  	      return false;
  	    }
  	
  	    var rect = element.getBoundingClientRect();
  	
  	    return (
  	      rect.width >= 80 &&
  	      rect.height >= 80 &&
  	      rect.bottom > 0 &&
  	      rect.right > 0 &&
  	      rect.top < window.innerHeight &&
  	      rect.left < window.innerWidth
  	    );
  	  }
  	
  	  function managerLooksLikeExternalPanel(element) {
  	    if (
  	      !element ||
  	      !(element instanceof HTMLElement) ||
  	      managerIsFuelElement(element) ||
  	      !managerIsVisible(element)
  	    ) {
  	      return false;
  	    }
  	
  	    if (
  	      element.matches(
  	        '[role="dialog"],' +
  	        '[aria-modal="true"],' +
  	        '[class*="drawer" i],' +
  	        '[id*="drawer" i],' +
  	        '[data-component*="drawer" i],' +
  	        '[data-testid*="drawer" i],' +
  	        '[data-role*="drawer" i]'
  	      )
  	    ) {
  	      return true;
  	    }
  	
  	    var style;
  	    var rect;
  	
  	    try {
  	      style = window.getComputedStyle(element);
  	      rect = element.getBoundingClientRect();
  	    } catch (_) {
  	      return false;
  	    }
  	
  	    var zIndex = Number.parseInt(style.zIndex, 10);
  	    var positioned =
  	      style.position === "fixed" ||
  	      style.position === "absolute";
  	
  	    var largeEnough =
  	      rect.width >= Math.min(320, window.innerWidth * 0.28) &&
  	      rect.height >= Math.min(220, window.innerHeight * 0.30);
  	
  	    return positioned && largeEnough && Number.isFinite(zIndex) && zIndex >= 1000;
  	  }
  	
  	  function managerFindOpenExternalPanels() {
  	    var candidates = new Set();
  	    var selector =
  	      '[role="dialog"],' +
  	      '[aria-modal="true"],' +
  	      '[class*="drawer" i],' +
  	      '[id*="drawer" i],' +
  	      '[data-component*="drawer" i],' +
  	      '[data-testid*="drawer" i],' +
  	      '[data-role*="drawer" i]';
  	
  	    var matched = document.querySelectorAll(selector);
  	
  	    for (var index = 0; index < matched.length; index++) {
  	      candidates.add(matched[index]);
  	    }
  	
  	    var bodyChildren = document.body
  	      ? document.body.children
  	      : [];
  	
  	    for (var childIndex = 0; childIndex < bodyChildren.length; childIndex++) {
  	      candidates.add(bodyChildren[childIndex]);
  	    }
  	
  	    var result = [];
  	
  	    candidates.forEach(function (candidate) {
  	      if (managerLooksLikeExternalPanel(candidate)) {
  	        result.push(candidate);
  	      }
  	    });
  	
  	    return result;
  	  }
  	
  	  function managerCheckForOtherPanel() {
  	    managerDrawerCheckQueued = false;
  	
  	    if (
  	      destroyed ||
  	      !managerOverlay ||
  	      !managerOverlay.isConnected
  	    ) {
  	      return;
  	    }
  	
  	    var currentPanels = managerFindOpenExternalPanels();
  	
  	    for (var index = 0; index < currentPanels.length; index++) {
  	      if (!managerOpenExternalPanels.has(currentPanels[index])) {
  	        managerDestroyRoot();
  	        return;
  	      }
  	    }
  	
  	    managerOpenExternalPanels = new Set(currentPanels);
  	  }
  	
  	  function managerQueueDrawerCheck() {
  	    if (managerDrawerCheckQueued || destroyed) return;
  	
  	    managerDrawerCheckQueued = true;
  	    requestAnimationFrame(managerCheckForOtherPanel);
  	  }
  	
  	  managerOpenExternalPanels = new Set(
  	    managerFindOpenExternalPanels()
  	  );
  	
  	  managerOtherDrawerObserver = new MutationObserver(
  	    managerQueueDrawerCheck
  	  );
  	
  	  managerOtherDrawerObserver.observe(document.body, {
  	    subtree: true,
  	    childList: true,
  	    attributes: true,
  	    attributeFilter: [
  	      "class",
  	      "style",
  	      "hidden",
  	      "open",
  	      "aria-hidden",
  	      "aria-expanded",
  	      "aria-modal"
  	    ]
  	  });
  	
  	  function managerBuildBowserRows(companyIndex, tankIndex, tank) {
  	    var bowsers = managerBowsers(tank);
  	
  	    if (!bowsers.length) {
  	      return (
  	        '<div class="fif-manager-empty-bowsers">' +
  	          '<span class="fif-manager-empty-icon" aria-hidden="true">⛽︎/span>' +
  	          "<span>No fuel dispensers linked to this tank.</span>" +
  	        "</div>"
  	      );
  	    }
  	
  	    var html = "";
  	
  	    for (
  	      var bowserIndex = 0;
  	      bowserIndex < bowsers.length;
  	      bowserIndex++
  	    ) {
  	      var bowserName = managerBowserLabel(
  	        bowsers[bowserIndex],
  	        bowserIndex
  	      );
  	
  	      html +=
  	        '<div class="fif-manager-bowser-row">' +
  	
  	          '<button type="button" ' +
  	          'class="fif-manager-bowser-action" ' +
  	          'data-fuel-action="capture" ' +
  	          'data-company-index="' + companyIndex + '" ' +
  	          'data-tank-index="' + tankIndex + '" ' +
  	          'data-bowser-index="' + bowserIndex + '" ' +
  	          'aria-label="Open Bowser Manager for ' + managerEscape(bowserName) + '">' +
  	
  	            '<span class="fif-manager-bowser-centre">' +
  	              '<span class="fif-manager-pump-icon" aria-hidden="true">⛽︎</span>' +
  	              '<span class="fif-manager-bowser-name">' +
  	                managerEscape(bowserName) +
  	              "</span>" +
  	              '<span class="fif-manager-bowser-divider" aria-hidden="true"></span>' +
  	              '<span class="fif-manager-dispense-copy">Bowser Manager</span>' +
  	            "</span>" +
  	
  	          "</button>" +
  	
  	          '<button type="button" ' +
  	          'class="fif-manager-edit-btn fif-manager-bowser-edit-btn" ' +
  	          'data-fuel-action="edit-bowser" ' +
  	          'data-company-index="' + companyIndex + '" ' +
  	          'data-tank-index="' + tankIndex + '" ' +
  	          'data-bowser-index="' + bowserIndex + '" ' +
  	          'title="Edit bowser name and grade" ' +
  	          'aria-label="Edit ' + managerEscape(bowserName) + '">' +
  	            '<span aria-hidden="true">✎</span>' +
  	          "</button>" +
  	
  	        "</div>";
  	    }
  	
  	    return html;
  	  }
  	
  	  function managerBuildTankCard(
  	    companyIndex,
  	    tankIndex,
  	    tank
  	  ) {
  	    var level = managerTankLevel(tank);
  	    var atgSnapshot = managerTankAtgSnapshot(tank);
  	
  	    var volume = managerTankBookVolume(tank);
  	
  	    var capacity = managerNumber(
  	      managerFirst(
  	        managerGet(tank, ["Capacity"], null),
  	        managerGet(tank, ["capacity"], null)
  	      ),
  	      0
  	    );
  	
  	    var tankName = managerTankLabel(tank, tankIndex);
  	
  	    var grade = managerText(
  	      managerFirst(
  	        managerGet(tank, ["Grade"], null),
  	        managerGet(tank, ["FuelGrade"], null)
  	      ),
  	      "Unspecified"
  	    );
  	
  	    var objectId = managerText(
  	      managerGet(tank, ["objectId"], null),
  	      ""
  	    );
  	
  	    var primarySupplier = managerTankPrimarySupplier(
  	      companiesCache[companyIndex],
  	      tank
  	    );
  	
  	    var primarySupplierName = primarySupplier
  	      ? primarySupplier.Name
  	      : managerTankPrimarySupplierName(tank);
  	
  	    var latestCostPerLitre = managerLatestCostPerLitre(tank);
  	    var stockValue = managerTankStockValue(tank);
  	    var warningThreshold1 = managerTankWarningThreshold1(tank);
  	    var warningThreshold2 = managerTankWarningThreshold2(tank);
  	    var orderThreshold = managerTankOrderThreshold(tank);
  	    var defaultOrderVolume = managerTankDefaultOrderVolume(tank);
  	    var orderDue = orderThreshold > 0 && volume <= orderThreshold;
  	
  	    return (
  	      '<article class="fif-manager-tank-card" ' +
  	      'data-company-index="' + companyIndex + '" ' +
  	      'data-tank-index="' + tankIndex + '" ' +
  	      'data-tank-id="' + managerEscape(objectId) + '">' +
  	
  	        '<div class="fif-manager-tank-main">' +
  	
  	          '<div class="fif-manager-gauge-pair">' +
  	            '<div class="fif-manager-gauge-unit is-book">' +
  	              '<span class="fif-manager-gauge-source">BOOK STOCK</span>' +
  	              '<div class="fif-manager-gauge" data-tank-gauge></div>' +
  	            '</div>' +
  	            '<div class="fif-manager-gauge-unit is-atg">' +
  	              '<span class="fif-manager-gauge-source">ATG CHECK</span>' +
  	              '<div class="fif-manager-gauge" data-atg-gauge ' +
  	              'title="ATG volume ' + managerEscape(
  	                atgSnapshot.available
  	                  ? managerFormat(atgSnapshot.volume, 2) + ' L'
  	                  : 'unavailable'
  	              ) + '"></div>' +
  	            '</div>' +
  	          '</div>' +
  	
  	          '<div class="fif-manager-tank-content">' +
  	
  	            '<div class="fif-manager-identity-row">' +
  	
  	              '<div class="fif-manager-identity">' +
  	                '<div class="fif-manager-tank-name">' +
  	                  managerEscape(tankName) +
  	                "</div>" +
  	
  	                '<div class="fif-manager-grade">' +
  	                  managerEscape(grade) +
  	                  (managerIsTrailerTank(tank)
  	                    ? '<span class="fif-manager-trailer-badge">Trailer</span>'
  	                    : '') +
  	                "</div>" +
  	
  	                '<div class="fif-manager-primary-supplier">' +
  	                  '<span>Primary Supplier</span>' +
  	                  '<strong>' + managerEscape(primarySupplierName || "Not selected") + '</strong>' +
  	                '</div>' +
  	
  	                '<div class="fif-manager-order-config' +
  	                (orderDue ? ' order-due' : '') + '">' +
  	                  '<span>' +
  	                    (orderDue ? 'Order Due' : 'Order Settings') +
  	                  '</span>' +
  	                  '<strong>' +
  	                    (warningThreshold1 > 0
  	                      ? 'Warn 1 ' + managerEscape(managerFormat(warningThreshold1, 2)) + ' L'
  	                      : 'Warn 1 off') +
  	                    ' · ' +
  	                    (warningThreshold2 > 0
  	                      ? 'Warn 2 ' + managerEscape(managerFormat(warningThreshold2, 2)) + ' L'
  	                      : 'Warn 2 off') +
  	                    ' · ' +
  	                    (orderThreshold > 0
  	                      ? 'Order ' + managerEscape(managerFormat(orderThreshold, 2)) + ' L'
  	                      : 'Order off') +
  	                    ' · ' +
  	                    (defaultOrderVolume > 0
  	                      ? 'Qty ' + managerEscape(managerFormat(defaultOrderVolume, 2)) + ' L'
  	                      : 'Qty not set') +
  	                  '</strong>' +
  	                '</div>' +
  	              "</div>" +
  	
  	              '<div class="fif-manager-tank-actions">' +
  	                '<div class="fif-manager-printables-wrap">' +
  	                  '<button type="button" ' +
  	                  'class="fif-manager-edit-btn fif-manager-printables-button" ' +
  	                  'data-fuel-action="toggle-printables" ' +
  	                  'data-company-index="' + companyIndex + '" ' +
  	                  'data-tank-index="' + tankIndex + '" ' +
  	                  'aria-haspopup="menu" aria-expanded="false" ' +
  	                  'title="Open printables" ' +
  	                  'aria-label="Open printables for ' + managerEscape(tankName) + '">' +
  	                    '<span aria-hidden="true">▣</span>' +
  	                    '<span>Printables</span>' +
  	                  "</button>" +
  	                  '<div class="fif-manager-printables-popover" role="menu" ' +
  	                  'aria-label="Fuel printables">' +
  	                    '<button type="button" role="menuitem" ' +
  	                    'data-fuel-action="select-bowser-qr" ' +
  	                    'data-company-index="' + companyIndex + '" ' +
  	                    'data-tank-index="' + tankIndex + '">' +
  	                      '<span class="fif-manager-printables-option-icon" aria-hidden="true">▦</span>' +
  	                      '<span><strong>Bowser QR Code</strong><small>Select attached Bowser</small></span>' +
  	                    '</button>' +
  	                    '<button type="button" role="menuitem" ' +
  	                    'data-fuel-action="print-tank-blank-form" ' +
  	                    'data-company-index="' + companyIndex + '" ' +
  	                    'data-tank-index="' + tankIndex + '">' +
  	                      '<span class="fif-manager-printables-option-icon" aria-hidden="true">▤</span>' +
  	                      '<span><strong>Blank Form</strong><small>Fuel Capture Sheet</small></span>' +
  	                    '</button>' +
  	                  '</div>' +
  	                '</div>' +
  	                '<button type="button" ' +
  	                'class="fif-manager-edit-btn fif-manager-tank-edit-btn" ' +
  	                'data-fuel-action="edit-tank" ' +
  	                'data-company-index="' + companyIndex + '" ' +
  	                'data-tank-index="' + tankIndex + '" ' +
  	                'title="Edit tank name and grade" ' +
  	                'aria-label="Edit ' + managerEscape(tankName) + '">' +
  	                  '<span aria-hidden="true">✎</span>' +
  	                "</button>" +
  	              '</div>' +
  	
  	            "</div>" +
  	
  	            '<div class="fif-manager-stat-grid">' +
  	
  	              '<div class="fif-manager-stat">' +
  	                "<span>Book Level</span>" +
  	                '<strong data-tank-level>' +
  	                  managerEscape(managerFormat(level, 1)) +
  	                  "%" +
  	                "</strong>" +
  	              "</div>" +
  	
  	              '<div class="fif-manager-stat">' +
  	                "<span>Book Volume</span>" +
  	                '<strong data-tank-volume>' +
  	                  managerEscape(managerFormat(volume, 2)) +
  	                  " L" +
  	                "</strong>" +
  	              "</div>" +
  	
  	              '<div class="fif-manager-stat">' +
  	                "<span>Capacity</span>" +
  	                '<strong data-tank-capacity>' +
  	                  managerEscape(managerFormat(capacity, 2)) +
  	                  " L" +
  	                "</strong>" +
  	              "</div>" +
  	
  	              '<div class="fif-manager-stat fif-manager-stock-stat" ' +
  	              'title="Latest cost: ' + managerEscape(managerFormatCurrency(latestCostPerLitre)) + ' / L">' +
  	                "<span>Book Stock Value</span>" +
  	                '<strong data-tank-stock-value>' +
  	                  managerEscape(managerFormatCurrency(stockValue)) +
  	                "</strong>" +
  	              "</div>" +
  	
  	            "</div>" +
  	
  	            managerBuildAtgStrip(tank) +
  	
  	          "</div>" +
  	        "</div>" +
  	
  	        '<button type="button" ' +
  	        'class="fif-manager-delivery-btn" ' +
  	        'data-fuel-action="delivery" ' +
  	        'data-company-index="' + companyIndex + '" ' +
  	        'data-tank-index="' + tankIndex + '" ' +
  	        'data-fuel-level="' + level.toFixed(1) + '" ' +
  	        'style="' + managerFuelButtonStyle(level) + '" ' +
  	        'aria-label="Open Tank Manager for ' + managerEscape(tankName) + '">' +
  	
  	          '<span class="fif-manager-delivery-icon" aria-hidden="true"></span>' +
  	          '<span data-add-fuel-label>' +
  	            "Tank Manager" +
  	          "</span>" +
  	
  	        "</button>" +
  	
  	        '<div class="fif-manager-bowser-title">Fuel Dispensers</div>' +
  	
  	        '<div class="fif-manager-bowser-list">' +
  	          managerBuildBowserRows(
  	            companyIndex,
  	            tankIndex,
  	            tank
  	          ) +
  	        "</div>" +
  	
  	      "</article>"
  	    );
  	  }
  	
  	  function managerBuildCompanySections() {
  	    var sections = "";
  	
  	    if (!companiesCache.length) {
  	      return (
  	        '<div class="fif-manager-no-data">' +
  	          '<div class="fif-manager-no-data-icon" aria-hidden="true">⛽︎</div>' +
  	          '<div class="fif-manager-no-data-title">No companies found</div>' +
  	          '<div class="fif-manager-no-data-copy">' +
  	            "No company records are currently available in AppData." +
  	          "</div>" +
  	        "</div>"
  	      );
  	    }
  	
  	    for (
  	      var companyIndex = 0;
  	      companyIndex < companiesCache.length;
  	      companyIndex++
  	    ) {
  	      var company = companiesCache[companyIndex];
  	      var tanks = managerTanks(company);
  	      var suppliers = managerSuppliers(company);
  	      var cards = "";
  	
  	      for (
  	        var tankIndex = 0;
  	        tankIndex < tanks.length;
  	        tankIndex++
  	      ) {
  	        cards += managerBuildTankCard(
  	          companyIndex,
  	          tankIndex,
  	          tanks[tankIndex]
  	        );
  	      }
  	
  	      if (!cards) {
  	        cards =
  	          '<div class="fif-manager-company-empty">' +
  	            '<strong>No tanks linked</strong>' +
  	            '<span>Suppliers can still be created and maintained for this company.</span>' +
  	          '</div>';
  	      }
  	
  	      var isCollapsed = managerCompanyIsCollapsed(
  	        company,
  	        companyIndex
  	      );
  	
  	      sections +=
  	        '<section class="fif-manager-company' +
  	        (isCollapsed ? ' is-collapsed' : '') + '" ' +
  	        'data-company-section="' + companyIndex + '">' +
  	
  	          '<div class="fif-manager-company-head">' +
  	            '<button type="button" ' +
  	            'class="fif-manager-company-toggle" ' +
  	            'data-fuel-action="toggle-company" ' +
  	            'data-company-index="' + companyIndex + '" ' +
  	            'aria-expanded="' + (isCollapsed ? 'false' : 'true') + '">' +
  	              '<span class="fif-manager-company-caret" aria-hidden="true">' +
  	                (isCollapsed ? '›' : '⌄') +
  	              '</span>' +
  	              '<span class="fif-manager-company-title">' +
  	                managerEscape(
  	                  managerCompanyLabel(company, companyIndex)
  	                ) +
  	              '</span>' +
  	            '</button>' +
  	
  	            '<div class="fif-manager-company-actions">' +
  	              '<div class="fif-manager-company-sub">' +
  	                tanks.length +
  	                " tank" +
  	                (tanks.length === 1 ? "" : "s") +
  	                ' · ' + suppliers.length +
  	                " supplier" +
  	                (suppliers.length === 1 ? "" : "s") +
  	              "</div>" +
  	
  	              '<button type="button" ' +
  	              'class="fif-manager-supplier-btn" ' +
  	              'data-fuel-action="manage-suppliers" ' +
  	              'data-company-index="' + companyIndex + '">' +
  	                '<span aria-hidden="true">＋</span>' +
  	                '<span>Suppliers</span>' +
  	              '</button>' +
  	            '</div>' +
  	          "</div>" +
  	
  	          '<div class="fif-manager-company-body">' +
  	            '<div class="fif-manager-grid">' +
  	              cards +
  	            "</div>" +
  	          "</div>" +
  	
  	        "</section>";
  	    }
  	
  	    return sections;
  	  }
  	
  	  function managerBuildStyles() {
  	    return `
  	      <style id="fif-fuel-manager-styles">
  	        #${MANAGER_ROOT_ID},
  	        #${MANAGER_ROOT_ID} * {
  	          box-sizing: border-box;
  	        }
  	
  	        #${MANAGER_ROOT_ID} {
  	          width: 100%;
  	          height: 100%;
  	          min-width: 0;
  	          min-height: 0;
  	          overflow-x: hidden;
  	          overflow-y: auto;
  	          padding: 16px;
  	          color: #f8fafc;
  	          background:
  	            radial-gradient(
  	              circle at 12% 0%,
  	              rgba(249, 115, 22, 0.08),
  	              transparent 30%
  	            ),
  	            linear-gradient(180deg, #070b11 0%, #0a1119 100%);
  	          font-family:
  	            Inter,
  	            system-ui,
  	            -apple-system,
  	            BlinkMacSystemFont,
  	            "Segoe UI",
  	            Arial,
  	            sans-serif;
  	          scrollbar-color:
  	            rgba(249, 115, 22, 0.45)
  	            rgba(255, 255, 255, 0.03);
  	        }
  	
  	        #${MANAGER_ROOT_ID} button {
  	          font: inherit;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-header {
  	          position: sticky;
  	          top: 0;
  	          z-index: 10;
  	          display: flex;
  	          align-items: center;
  	          min-height: 58px;
  	          margin: 0 0 16px;
  	          padding: 10px 14px;
  	          border: 1px solid rgba(255, 255, 255, 0.08);
  	          border-radius: 15px;
  	          background: rgba(7, 12, 18, 0.96);
  	          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.28);
  	          backdrop-filter: blur(12px);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-brand {
  	          display: flex;
  	          align-items: center;
  	          gap: 12px;
  	          min-width: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-logo-img,
  	        #${MANAGER_ROOT_ID} .fif-manager-logo-svg svg {
  	          display: block;
  	          width: auto;
  	          max-width: 76px;
  	          max-height: 34px;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-logo-svg {
  	          display: flex;
  	          align-items: center;
  	          width: 76px;
  	          max-height: 34px;
  	          overflow: hidden;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-logo-fallback {
  	          display: flex;
  	          align-items: center;
  	          justify-content: center;
  	          width: 40px;
  	          height: 40px;
  	          border: 1px solid rgba(251, 146, 60, 0.45);
  	          border-radius: 12px;
  	          background:
  	            linear-gradient(
  	              145deg,
  	              rgba(249, 115, 22, 0.95),
  	              rgba(154, 52, 18, 0.88)
  	            );
  	          color: #fff;
  	          font-size: 13px;
  	          font-weight: 950;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-title {
  	          min-width: 0;
  	          overflow: hidden;
  	          color: #f8fafc;
  	          font-size: clamp(16px, 1.25vw, 21px);
  	          font-weight: 950;
  	          line-height: 1.1;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-subtitle {
  	          margin-top: 4px;
  	          overflow: hidden;
  	          color: #94a3b8;
  	          font-size: 10px;
  	          font-weight: 600;
  	          line-height: 1.15;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company {
  	          margin-top: 18px;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company:first-of-type {
  	          margin-top: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-head {
  	          display: flex;
  	          align-items: flex-end;
  	          justify-content: space-between;
  	          gap: 12px;
  	          margin: 0 2px 10px;
  	          padding: 0 2px 8px;
  	          border-bottom: 1px solid rgba(249, 115, 22, 0.40);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-toggle {
  	          min-width: 0;
  	          display: inline-flex;
  	          align-items: center;
  	          justify-content: flex-start;
  	          gap: 8px;
  	          padding: 3px 4px;
  	          border: 0;
  	          background: transparent;
  	          color: inherit;
  	          cursor: pointer;
  	          text-align: left;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-caret {
  	          width: 18px;
  	          flex: 0 0 18px;
  	          color: #fb923c;
  	          font-size: 19px;
  	          font-weight: 950;
  	          line-height: 1;
  	          text-align: center;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-title {
  	          min-width: 0;
  	          overflow: hidden;
  	          color: #fed7aa;
  	          font-size: 15px;
  	          font-weight: 950;
  	          line-height: 1.15;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-toggle:hover
  	        .fif-manager-company-title {
  	          color: #fff;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-body {
  	          display: block;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company.is-collapsed
  	        .fif-manager-company-body {
  	          display: none;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company.is-collapsed
  	        .fif-manager-company-head {
  	          margin-bottom: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-actions {
  	          display: flex;
  	          align-items: center;
  	          justify-content: flex-end;
  	          gap: 10px;
  	          flex: 0 0 auto;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-sub {
  	          flex: 0 0 auto;
  	          color: #64748b;
  	          font-size: 10px;
  	          font-weight: 700;
  	          white-space: nowrap;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-supplier-btn {
  	          display: inline-flex;
  	          align-items: center;
  	          justify-content: center;
  	          gap: 6px;
  	          height: 34px;
  	          padding: 0 12px;
  	          border: 1px solid rgba(251, 146, 60, 0.48);
  	          border-radius: 10px;
  	          background: rgba(249, 115, 22, 0.12);
  	          color: #fb923c;
  	          font-size: 11px;
  	          font-weight: 900;
  	          cursor: pointer;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-supplier-btn:hover {
  	          background: rgba(249, 115, 22, 0.23);
  	          color: #fff;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-empty {
  	          display: flex;
  	          flex-direction: column;
  	          align-items: center;
  	          justify-content: center;
  	          min-height: 120px;
  	          padding: 20px;
  	          border: 1px dashed rgba(255, 255, 255, 0.13);
  	          border-radius: 16px;
  	          background: rgba(255, 255, 255, 0.025);
  	          color: #718198;
  	          text-align: center;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-empty strong {
  	          color: #dce5ef;
  	          font-size: 13px;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-company-empty span {
  	          margin-top: 5px;
  	          font-size: 10px;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-grid {
  	          display: grid;
  	          grid-template-columns:
  	            repeat(auto-fit, minmax(min(100%, 640px), 1fr));
  	          gap: 14px;
  	          align-items: stretch;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-tank-card {
  	          display: flex;
  	          flex-direction: column;
  	          min-width: 0;
  	          padding: 14px;
  	          overflow: hidden;
  	          border: 1px solid rgba(255, 255, 255, 0.10);
  	          border-top-color: rgba(249, 115, 22, 0.52);
  	          border-radius: 18px;
  	          background:
  	            radial-gradient(
  	              circle at 8% 0%,
  	              rgba(255, 255, 255, 0.07),
  	              transparent 30%
  	            ),
  	            linear-gradient(
  	              145deg,
  	              rgba(255, 255, 255, 0.055),
  	              rgba(255, 255, 255, 0.018)
  	            );
  	          box-shadow:
  	            0 15px 34px rgba(0, 0, 0, 0.24),
  	            inset 0 1px 0 rgba(255, 255, 255, 0.025);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-tank-main {
  	          display: grid;
  	          grid-template-columns: 250px minmax(0, 1fr);
  	          gap: 14px;
  	          align-items: center;
  	          min-width: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-gauge-pair {
  	          display: grid;
  	          grid-template-columns: repeat(2, minmax(0, 1fr));
  	          gap: 10px;
  	          width: 250px;
  	          min-width: 250px;
  	          align-items: start;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-gauge-unit {
  	          display: grid;
  	          justify-items: center;
  	          gap: 6px;
  	          min-width: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-gauge-source {
  	          display: inline-flex;
  	          align-items: center;
  	          justify-content: center;
  	          min-height: 20px;
  	          padding: 0 7px;
  	          border: 1px solid rgba(251, 146, 60, 0.36);
  	          border-radius: 999px;
  	          color: #fdba74;
  	          background: rgba(154, 52, 18, 0.18);
  	          font-size: 8px;
  	          font-weight: 950;
  	          letter-spacing: 0.07em;
  	          white-space: nowrap;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-gauge-unit.is-atg .fif-manager-gauge-source {
  	          border-color: rgba(56, 189, 248, 0.38);
  	          color: #bae6fd;
  	          background: rgba(3, 105, 161, 0.18);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-gauge {
  	          width: 112px;
  	          height: 112px;
  	          min-width: 112px;
  	          align-self: center;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-gauge-svg {
  	          display: block;
  	          width: 100%;
  	          height: 100%;
  	          overflow: visible;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-gauge-level {
  	          fill: #0f172a;
  	          font-size: 17px;
  	          font-weight: 950;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-gauge-volume {
  	          fill: #263447;
  	          font-size: 8.4px;
  	          font-weight: 900;
  	          font-variant-numeric: tabular-nums;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-tank-content {
  	          display: grid;
  	          grid-template-rows: auto auto;
  	          gap: 13px;
  	          min-width: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-identity-row {
  	          display: flex;
  	          align-items: flex-start;
  	          justify-content: space-between;
  	          gap: 12px;
  	          min-width: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-identity {
  	          flex: 1 1 auto;
  	          min-width: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-edit-btn {
  	          display: inline-flex;
  	          align-items: center;
  	          justify-content: center;
  	          gap: 6px;
  	          flex: 0 0 auto;
  	          height: 34px;
  	          padding: 0 11px;
  	          border: 1px solid rgba(251, 146, 60, 0.44);
  	          border-radius: 10px;
  	          outline: none;
  	          background: rgba(249, 115, 22, 0.10);
  	          color: #fb923c;
  	          font-family: inherit;
  	          font-size: 11px;
  	          font-weight: 900;
  	          line-height: 1;
  	          cursor: pointer;
  	          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  	          transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-edit-btn:hover {
  	          border-color: rgba(251, 146, 60, 0.78);
  	          background: rgba(249, 115, 22, 0.22);
  	          color: #fff;
  	        }
  	
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-tank-actions {
  	          position: relative;
  	          z-index: 15;
  	          display: flex;
  	          align-items: flex-start;
  	          justify-content: flex-end;
  	          gap: 7px;
  	          flex: 0 0 auto;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-wrap {
  	          position: relative;
  	          flex: 0 0 auto;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-button {
  	          min-width: 104px;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-popover {
  	          position: absolute;
  	          top: calc(100% + 7px);
  	          right: 0;
  	          z-index: 60;
  	          width: 196px;
  	          display: none;
  	          grid-template-columns: 1fr;
  	          gap: 4px;
  	          padding: 6px;
  	          box-sizing: border-box;
  	          border: 1px solid rgba(251, 146, 60, 0.42);
  	          border-radius: 13px;
  	          background:
  	            radial-gradient(circle at 82% 0%, rgba(251, 146, 60, 0.12), transparent 36%),
  	            linear-gradient(145deg, rgba(22, 23, 25, 0.99), rgba(5, 8, 11, 0.995));
  	          box-shadow:
  	            0 18px 38px rgba(0, 0, 0, 0.58),
  	            inset 0 1px 0 rgba(255, 255, 255, 0.045);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-wrap.is-open
  	        .fif-manager-printables-popover {
  	          display: grid;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-popover > button {
  	          width: 100%;
  	          min-height: 47px;
  	          display: grid;
  	          grid-template-columns: 30px minmax(0, 1fr);
  	          align-items: center;
  	          gap: 9px;
  	          padding: 7px 9px;
  	          box-sizing: border-box;
  	          border: 1px solid transparent;
  	          border-radius: 9px;
  	          outline: none;
  	          cursor: pointer;
  	          color: #edf2f7;
  	          background: rgba(255, 255, 255, 0.025);
  	          text-align: left;
  	          font-family: inherit;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-popover > button:hover,
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-popover > button:focus-visible {
  	          border-color: rgba(251, 146, 60, 0.38);
  	          background: rgba(249, 115, 22, 0.12);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-option-icon {
  	          width: 28px;
  	          height: 28px;
  	          display: grid;
  	          place-items: center;
  	          border: 1px solid rgba(251, 146, 60, 0.34);
  	          border-radius: 8px;
  	          color: #ffad70;
  	          background: rgba(249, 115, 22, 0.09);
  	          font-size: 15px;
  	          font-weight: 900;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-popover strong,
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-popover small {
  	          display: block;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-popover strong {
  	          font-size: 11px;
  	          font-weight: 900;
  	          color: #fff;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-printables-popover small {
  	          margin-top: 3px;
  	          font-size: 8.5px;
  	          font-weight: 700;
  	          color: #8796aa;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-tank-name {
  	          overflow: hidden;
  	          color: #fff;
  	          font-size: clamp(20px, 1.4vw, 25px);
  	          font-weight: 950;
  	          line-height: 1.05;
  	          letter-spacing: 0.01em;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-grade {
  	          margin-top: 5px;
  	          overflow: hidden;
  	          color: #fb923c;
  	          font-size: clamp(14px, 1vw, 17px);
  	          font-weight: 900;
  	          line-height: 1.15;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-trailer-badge {
  	          display: inline-flex;
  	          align-items: center;
  	          margin-left: 8px;
  	          padding: 3px 7px;
  	          border: 1px solid rgba(74, 222, 128, 0.42);
  	          border-radius: 999px;
  	          color: #bbf7d0;
  	          background: rgba(22, 101, 52, 0.22);
  	          font-size: 9px;
  	          font-weight: 950;
  	          line-height: 1;
  	          letter-spacing: 0.08em;
  	          text-transform: uppercase;
  	          vertical-align: middle;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-device {
  	          margin-top: 5px;
  	          overflow: hidden;
  	          color: #7da1d4;
  	          font-size: 12px;
  	          font-weight: 700;
  	          line-height: 1.1;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-primary-supplier {
  	          display: flex;
  	          align-items: baseline;
  	          gap: 7px;
  	          margin-top: 7px;
  	          min-width: 0;
  	          color: #7f91a9;
  	          font-size: 10px;
  	          line-height: 1.15;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-primary-supplier span {
  	          flex: 0 0 auto;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-primary-supplier strong {
  	          min-width: 0;
  	          overflow: hidden;
  	          color: #dce5ef;
  	          font-size: 11px;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-order-config {
  	          display: flex;
  	          align-items: baseline;
  	          gap: 7px;
  	          margin-top: 5px;
  	          color: #64748b;
  	          font-size: 9px;
  	          line-height: 1.2;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-order-config span {
  	          color: #7f8da1;
  	          font-weight: 700;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-order-config strong {
  	          color: #b8c3d1;
  	          font-size: 9px;
  	          font-weight: 800;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-order-config.order-due span,
  	        #${MANAGER_ROOT_ID} .fif-manager-order-config.order-due strong {
  	          color: #fb923c;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-stat-grid {
  	          display: grid;
  	          grid-template-columns: repeat(4, minmax(0, 1fr));
  	          gap: 9px;
  	          width: 100%;
  	          min-width: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-stat {
  	          display: flex;
  	          flex-direction: column;
  	          align-items: flex-start;
  	          justify-content: center;
  	          min-width: 0;
  	          min-height: 58px;
  	          padding: 10px 12px;
  	          overflow: hidden;
  	          border: 1px solid rgba(255, 255, 255, 0.045);
  	          border-radius: 11px;
  	          background:
  	            linear-gradient(
  	              145deg,
  	              rgba(0, 0, 0, 0.40),
  	              rgba(0, 0, 0, 0.22)
  	            );
  	          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.02);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-stat span {
  	          display: block;
  	          width: 100%;
  	          min-width: 0;
  	          overflow: hidden;
  	          color: #91a7c6;
  	          font-size: 11px;
  	          font-weight: 800;
  	          line-height: 1;
  	          letter-spacing: 0.04em;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-stat strong {
  	          display: block;
  	          width: 100%;
  	          min-width: 0;
  	          margin-top: 7px;
  	          overflow: hidden;
  	          color: #fff;
  	          font-size: clamp(14px, 1.05vw, 17px);
  	          font-weight: 950;
  	          line-height: 1.05;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-atg-strip {
  	          display: flex;
  	          align-items: center;
  	          flex-wrap: wrap;
  	          gap: 7px 13px;
  	          width: 100%;
  	          min-width: 0;
  	          padding: 8px 10px;
  	          box-sizing: border-box;
  	          border: 1px solid rgba(74, 222, 128, 0.22);
  	          border-radius: 11px;
  	          background: rgba(22, 101, 52, 0.10);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-atg-strip.is-stale {
  	          border-color: rgba(250, 204, 21, 0.30);
  	          background: rgba(133, 77, 14, 0.13);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-atg-strip.is-unavailable {
  	          border-color: rgba(248, 113, 113, 0.28);
  	          background: rgba(127, 29, 29, 0.12);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-atg-status {
  	          display: inline-flex;
  	          align-items: center;
  	          min-height: 22px;
  	          padding: 0 8px;
  	          border: 1px solid rgba(74, 222, 128, 0.38);
  	          border-radius: 999px;
  	          color: #bbf7d0;
  	          background: rgba(22, 101, 52, 0.28);
  	          font-size: 8px;
  	          font-weight: 950;
  	          letter-spacing: 0.08em;
  	          white-space: nowrap;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .is-stale .fif-manager-atg-status {
  	          border-color: rgba(250, 204, 21, 0.45);
  	          color: #fef08a;
  	          background: rgba(133, 77, 14, 0.30);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .is-unavailable .fif-manager-atg-status {
  	          border-color: rgba(248, 113, 113, 0.42);
  	          color: #fecaca;
  	          background: rgba(127, 29, 29, 0.30);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-atg-strip > span:not(.fif-manager-atg-status):not(.fif-manager-atg-updated) {
  	          display: inline-flex;
  	          align-items: baseline;
  	          gap: 5px;
  	          min-width: 0;
  	          white-space: nowrap;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-atg-strip small {
  	          color: #7690a7;
  	          font-size: 8px;
  	          font-weight: 750;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-atg-strip strong {
  	          color: #e8eef5;
  	          font-size: 9px;
  	          font-weight: 900;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-atg-updated {
  	          margin-left: auto;
  	          color: #86efac;
  	          font-size: 8px;
  	          font-weight: 850;
  	          white-space: nowrap;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .is-stale .fif-manager-atg-updated {
  	          color: #fde047;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .is-unavailable .fif-manager-atg-updated {
  	          color: #fca5a5;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-delivery-btn {
  	          position: relative;
  	          display: flex;
  	          align-items: center;
  	          justify-content: center;
  	          gap: 7px;
  	          width: 100%;
  	          height: 47px;
  	          margin-top: 14px;
  	          padding: 0 14px;
  	          overflow: hidden;
  	          border:
  	            1px solid
  	            rgba(
  	              var(--fuel-r),
  	              var(--fuel-g),
  	              var(--fuel-b),
  	              0.96
  	            );
  	          border-radius: 13px;
  	          outline: none;
  	          background:
  	            linear-gradient(
  	              145deg,
  	              rgba(
  	                var(--fuel-r),
  	                var(--fuel-g),
  	                var(--fuel-b),
  	                0.84
  	              ),
  	              rgba(
  	                var(--fuel-r),
  	                var(--fuel-g),
  	                var(--fuel-b),
  	                0.42
  	              )
  	            );
  	          color: #fff;
  	          font-size: 13px;
  	          font-weight: 950;
  	          line-height: 1;
  	          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.70);
  	          cursor: pointer;
  	          box-shadow:
  	            inset 0 1px 0 rgba(255, 255, 255, 0.20),
  	            0 8px 20px
  	            rgba(
  	              var(--fuel-r),
  	              var(--fuel-g),
  	              var(--fuel-b),
  	              0.19
  	            );
  	          transition:
  	            filter 0.16s ease,
  	            transform 0.16s ease,
  	            box-shadow 0.16s ease;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-delivery-btn::after {
  	          content: "";
  	          position: absolute;
  	          right: auto;
  	          bottom: 0;
  	          left: 0;
  	          width: var(--fuel-level);
  	          height: 4px;
  	          background: rgba(255, 255, 255, 0.90);
  	          box-shadow: 0 0 8px rgba(255, 255, 255, 0.34);
  	          transition: width 0.25s ease;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-delivery-btn:hover {
  	          filter: brightness(1.10);
  	          transform: translateY(-1px);
  	          box-shadow:
  	            inset 0 1px 0 rgba(255, 255, 255, 0.24),
  	            0 10px 25px
  	            rgba(
  	              var(--fuel-r),
  	              var(--fuel-g),
  	              var(--fuel-b),
  	              0.30
  	            );
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-delivery-btn:active {
  	          transform: translateY(0);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-delivery-icon {
  	          font-size: 15px;
  	          font-weight: 950;
  	          line-height: 1;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-bowser-title {
  	          margin: 16px 2px 8px;
  	          color: #91a7c6;
  	          font-size: 10px;
  	          font-weight: 900;
  	          line-height: 1;
  	          letter-spacing: 0.11em;
  	          text-transform: uppercase;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-bowser-list {
  	          display: grid;
  	          gap: 9px;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-bowser-row {
  	          position: relative;
  	          display: flex;
  	          align-items: center;
  	          justify-content: center;
  	          width: 100%;
  	          min-width: 0;
  	          min-height: 62px;
  	          padding: 9px 15px;
  	          border: 1px solid rgba(255, 255, 255, 0.20);
  	          border-radius: 14px;
  	          outline: none;
  	          background:
  	            linear-gradient(
  	              145deg,
  	              rgba(255, 255, 255, 0.155),
  	              rgba(255, 255, 255, 0.080)
  	            );
  	          color: #fff;
  	          cursor: default;
  	          box-shadow:
  	            inset 0 1px 0 rgba(255, 255, 255, 0.10),
  	            0 8px 20px rgba(0, 0, 0, 0.16);
  	          transition:
  	            background 0.16s ease,
  	            border-color 0.16s ease,
  	            box-shadow 0.16s ease,
  	            transform 0.16s ease;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-bowser-row:hover {
  	          border-color: rgba(251, 146, 60, 0.70);
  	          background:
  	            linear-gradient(
  	              145deg,
  	              rgba(255, 255, 255, 0.20),
  	              rgba(249, 115, 22, 0.13)
  	            );
  	          box-shadow:
  	            inset 0 1px 0 rgba(255, 255, 255, 0.13),
  	            0 10px 24px rgba(0, 0, 0, 0.22),
  	            0 0 18px rgba(249, 115, 22, 0.11);
  	          transform: translateY(-1px);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-bowser-action {
  	          display: flex;
  	          align-items: center;
  	          justify-content: center;
  	          width: 100%;
  	          min-width: 0;
  	          min-height: 42px;
  	          padding: 0 52px;
  	          border: none;
  	          outline: none;
  	          background: transparent;
  	          color: inherit;
  	          font-family: inherit;
  	          cursor: pointer;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-bowser-edit-btn {
  	          position: absolute;
  	          top: 50%;
  	          right: 10px;
  	          width: 34px;
  	          min-width: 34px;
  	          padding: 0;
  	          transform: translateY(-50%);
  	          z-index: 2;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-bowser-centre {
  	          display: inline-flex;
  	          align-items: center;
  	          justify-content: center;
  	          gap: 13px;
  	          max-width: 100%;
  	          min-width: 0;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-pump-icon {
  	          display: flex;
  	          flex: 0 0 40px;
  	          align-items: center;
  	          justify-content: center;
  	          width: 40px;
  	          height: 40px;
  	          border: 1px solid rgba(251, 146, 60, 0.34);
  	          border-radius: 11px;
  	          background: rgba(249, 115, 22, 0.18);
  	          font-size: 17px;
  	          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-bowser-name {
  	          min-width: 0;
  	          overflow: hidden;
  	          color: #fff;
  	          font-size: 14px;
  	          font-weight: 950;
  	          line-height: 1;
  	          white-space: nowrap;
  	          text-overflow: ellipsis;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-bowser-divider {
  	          flex: 0 0 1px;
  	          width: 1px;
  	          height: 24px;
  	          background: rgba(255, 255, 255, 0.25);
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-dispense-copy {
  	          flex: 0 0 auto;
  	          color: #fb923c;
  	          font-size: 14px;
  	          font-weight: 900;
  	          line-height: 1;
  	          white-space: nowrap;
  	        }
  	
  	        #${MANAGER_ROOT_ID}
  	        .fif-manager-bowser-row:hover
  	        .fif-manager-dispense-copy {
  	          color: #fff;
  	        }
  	
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} {
  	          position: fixed;
  	          top: 50px;
  	          right: 0;
  	          bottom: 0;
  	          left: 0;
  	          z-index: 2147483647;
  	          display: flex;
  	          align-items: center;
  	          justify-content: center;
  	          padding: 20px;
  	          background: rgba(2, 6, 12, 0.82);
  	          backdrop-filter: blur(11px);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-card {
  	          display: grid;
  	          grid-template-rows: auto minmax(0, 1fr);
  	          width: min(980px, 100%);
  	          max-height: calc(100vh - 90px);
  	          overflow: hidden;
  	          border: 1px solid rgba(251, 146, 60, 0.40);
  	          border-radius: 19px;
  	          background:
  	            radial-gradient(circle at 10% 0%, rgba(204,102,51,.13), transparent 35%),
  	            linear-gradient(145deg, #151b24, #080d14);
  	          color: #fff;
  	          box-shadow: 0 28px 75px rgba(0,0,0,.60);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-head {
  	          display: flex;
  	          align-items: center;
  	          justify-content: space-between;
  	          gap: 14px;
  	          padding: 16px 18px;
  	          border-bottom: 1px solid rgba(255,255,255,.08);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-title {
  	          font-size: 18px;
  	          font-weight: 950;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-subtitle {
  	          margin-top: 4px;
  	          color: #91a7c6;
  	          font-size: 10px;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-close {
  	          width: 38px;
  	          height: 38px;
  	          border: 1px solid rgba(255,255,255,.10);
  	          border-radius: 11px;
  	          background: rgba(255,255,255,.05);
  	          color: #ff8a7f;
  	          font-size: 21px;
  	          font-weight: 900;
  	          cursor: pointer;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-layout {
  	          display: grid;
  	          grid-template-columns: minmax(270px, .85fr) minmax(0, 1.15fr);
  	          min-height: 0;
  	          overflow: hidden;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list-panel,
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-form-panel {
  	          min-height: 0;
  	          overflow: auto;
  	          padding: 16px;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list-panel {
  	          border-right: 1px solid rgba(255,255,255,.08);
  	          background: rgba(0,0,0,.14);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-new {
  	          width: 100%;
  	          height: 42px;
  	          border: 1px solid rgba(251,146,60,.58);
  	          border-radius: 11px;
  	          background: rgba(204,102,51,.15);
  	          color: #fff;
  	          font-weight: 900;
  	          cursor: pointer;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list {
  	          display: grid;
  	          gap: 8px;
  	          margin-top: 12px;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list-row {
  	          display: grid;
  	          grid-template-columns: minmax(0, 1fr) 30px;
  	          align-items: center;
  	          gap: 8px;
  	          min-width: 0;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list-item {
  	          width: 100%;
  	          min-width: 0;
  	          height: 100%;
  	          padding: 11px 12px;
  	          border: 1px solid rgba(255,255,255,.09);
  	          border-radius: 12px;
  	          background: rgba(255,255,255,.04);
  	          color: #fff;
  	          text-align: left;
  	          cursor: pointer;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete {
  	          width: 30px;
  	          height: 30px;
  	          min-width: 30px;
  	          padding: 0;
  	          display: inline-flex;
  	          align-items: center;
  	          justify-content: center;
  	          border: 1px solid rgba(120,49,15,.42);
  	          border-radius: 11px;
  	          outline: none;
  	          cursor: pointer;
  	          color: rgba(255,216,191,.84);
  	          background: rgba(0,0,0,.46);
  	          box-shadow: inset 0 1px 0 rgba(255,255,255,.025);
  	          font-family: "Segoe UI Symbol", "Noto Sans Symbols 2", Arial, sans-serif;
  	          font-size: 13px;
  	          font-weight: 950;
  	          line-height: 1;
  	          transition:
  	            color 140ms ease,
  	            border-color 140ms ease,
  	            background 140ms ease,
  	            box-shadow 140ms ease,
  	            transform 140ms ease;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete:hover,
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete:focus-visible {
  	          color: #ffb0a3;
  	          border-color: rgba(255,90,60,.62);
  	          background: rgba(120,24,15,.32);
  	          box-shadow: 0 0 10px rgba(120,24,15,.22);
  	          transform: translateY(-1px);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete:active {
  	          transform: translateY(0) scale(.96);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete svg {
  	          width: 15px;
  	          height: 15px;
  	          display: block;
  	          fill: none;
  	          stroke: currentColor;
  	          stroke-width: 1.9;
  	          stroke-linecap: round;
  	          stroke-linejoin: round;
  	          pointer-events: none;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list-item.active {
  	          border-color: rgba(251,146,60,.68);
  	          background: rgba(204,102,51,.14);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list-name {
  	          font-size: 13px;
  	          font-weight: 900;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list-meta {
  	          margin-top: 4px;
  	          color: #91a7c6;
  	          font-size: 10px;
  	          line-height: 1.35;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-form {
  	          display: grid;
  	          grid-template-columns: repeat(2, minmax(0, 1fr));
  	          gap: 13px;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-form-title {
  	          grid-column: 1 / -1;
  	          margin-bottom: 2px;
  	          font-size: 16px;
  	          font-weight: 950;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-field {
  	          display: grid;
  	          gap: 7px;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-field-wide {
  	          grid-column: 1 / -1;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-field span {
  	          color: #c9d4e3;
  	          font-size: 10px;
  	          font-weight: 900;
  	          letter-spacing: .05em;
  	          text-transform: uppercase;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-input {
  	          width: 100%;
  	          height: 44px;
  	          padding: 0 12px;
  	          border: 1px solid rgba(255,255,255,.12);
  	          border-radius: 11px;
  	          outline: none;
  	          background: rgba(0,0,0,.28);
  	          color: #fff;
  	          font: 750 13px Inter, Arial, sans-serif;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-input:focus {
  	          border-color: rgba(251,146,60,.78);
  	          box-shadow: 0 0 0 3px rgba(204,102,51,.13);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-error {
  	          display: none;
  	          grid-column: 1 / -1;
  	          padding: 10px 12px;
  	          border: 1px solid rgba(248,113,113,.42);
  	          border-radius: 10px;
  	          background: rgba(127,29,29,.20);
  	          color: #fecaca;
  	          font-size: 11px;
  	          font-weight: 750;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-actions {
  	          display: flex;
  	          justify-content: flex-end;
  	          gap: 10px;
  	          grid-column: 1 / -1;
  	          margin-top: 4px;
  	          padding-top: 13px;
  	          border-top: 1px solid rgba(255,255,255,.08);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-action {
  	          height: 42px;
  	          padding: 0 15px;
  	          border-radius: 11px;
  	          font-weight: 900;
  	          cursor: pointer;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-cancel {
  	          border: 1px solid rgba(255,255,255,.12);
  	          background: rgba(255,255,255,.05);
  	          color: #d7e0eb;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-save {
  	          border: 1px solid rgba(251,146,60,.70);
  	          background: linear-gradient(145deg,#c6632e,#8f3f1e);
  	          color: #fff;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-backdrop {
  	          position: absolute;
  	          inset: 0;
  	          z-index: 2147483646;
  	          display: flex;
  	          align-items: center;
  	          justify-content: center;
  	          padding: 18px;
  	          background:
  	            radial-gradient(circle at 70% 18%, rgba(255,147,52,.13), transparent 34%),
  	            radial-gradient(circle at 20% 78%, rgba(255,78,54,.10), transparent 42%),
  	            rgba(0,0,0,.46);
  	          backdrop-filter: grayscale(.92) brightness(.50) contrast(.92) blur(1.5px);
  	          -webkit-backdrop-filter: grayscale(.92) brightness(.50) contrast(.92) blur(1.5px);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-card {
  	          width: min(420px, calc(100vw - 34px));
  	          overflow: hidden;
  	          border: 1px solid rgba(255,78,54,.58);
  	          border-radius: 24px;
  	          color: #fff;
  	          background:
  	            radial-gradient(circle at 16% 8%, rgba(255,78,54,.24), transparent 34%),
  	            radial-gradient(circle at 88% 120%, rgba(255,132,48,.13), transparent 42%),
  	            linear-gradient(145deg, rgba(18,15,14,.985), rgba(4,5,5,.985));
  	          box-shadow:
  	            0 0 0 1px rgba(255,255,255,.04),
  	            0 28px 70px rgba(0,0,0,.62),
  	            0 0 38px rgba(255,70,40,.18);
  	          backdrop-filter: blur(18px) saturate(1.15);
  	          -webkit-backdrop-filter: blur(18px) saturate(1.15);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-head {
  	          display: grid;
  	          grid-template-columns: 38px minmax(0, 1fr) 30px;
  	          align-items: center;
  	          gap: 11px;
  	          padding: 16px 16px 13px;
  	          border-bottom: 1px solid rgba(255,78,54,.28);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-icon {
  	          width: 36px;
  	          height: 36px;
  	          display: flex;
  	          align-items: center;
  	          justify-content: center;
  	          border: 1px solid rgba(255,78,54,.78);
  	          border-radius: 15px;
  	          color: #ffd6cc;
  	          background:
  	            radial-gradient(circle at 38% 24%, rgba(255,182,98,.26), transparent 38%),
  	            linear-gradient(145deg, rgba(255,78,54,.38), rgba(82,14,8,.76));
  	          box-shadow:
  	            0 0 18px rgba(255,70,40,.26),
  	            inset 0 1px 0 rgba(255,255,255,.13);
  	          font-size: 20px;
  	          font-weight: 950;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-title {
  	          color: #ffe3d9;
  	          font-size: 15px;
  	          font-weight: 950;
  	          letter-spacing: .03em;
  	          line-height: 1.05;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-subtitle {
  	          margin-top: 5px;
  	          color: rgba(255,120,90,.88);
  	          font-size: 8px;
  	          font-weight: 950;
  	          letter-spacing: .16em;
  	          line-height: 1;
  	          text-transform: uppercase;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-close {
  	          width: 30px;
  	          height: 30px;
  	          padding: 0;
  	          border: 1px solid rgba(255,255,255,.09);
  	          border-radius: 12px;
  	          outline: none;
  	          cursor: pointer;
  	          color: rgba(255,235,226,.76);
  	          background: rgba(255,255,255,.045);
  	          font-size: 18px;
  	          font-weight: 800;
  	          line-height: 1;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-close:hover,
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-close:focus-visible {
  	          color: #fff;
  	          border-color: rgba(255,78,54,.58);
  	          background: rgba(255,78,54,.16);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-body {
  	          display: grid;
  	          gap: 10px;
  	          padding: 15px 16px 14px;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-name {
  	          min-width: 0;
  	          padding: 9px 10px;
  	          border: 1px solid rgba(255,255,255,.08);
  	          border-radius: 14px;
  	          color: #fff0e8;
  	          background: rgba(255,255,255,.045);
  	          font-size: 13px;
  	          font-weight: 950;
  	          line-height: 1.25;
  	          word-break: break-word;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-copy,
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-warning {
  	          color: rgba(255,232,220,.72);
  	          font-size: 10px;
  	          font-weight: 800;
  	          line-height: 1.42;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-warning {
  	          padding: 9px 10px;
  	          border: 1px solid rgba(255,132,48,.24);
  	          border-radius: 13px;
  	          color: rgba(255,220,190,.84);
  	          background: rgba(255,132,48,.08);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-warning strong {
  	          color: #ffb36c;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-field {
  	          display: grid;
  	          gap: 8px;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-field > span {
  	          color: rgba(255,235,226,.80);
  	          font-size: 9px;
  	          font-weight: 950;
  	          letter-spacing: .055em;
  	          text-transform: uppercase;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-field > span strong {
  	          color: #ff9a72;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-input {
  	          width: 100%;
  	          height: 40px;
  	          padding: 0 12px;
  	          box-sizing: border-box;
  	          border: 1px solid rgba(255,255,255,.12);
  	          border-radius: 14px;
  	          outline: none;
  	          color: #fff;
  	          background: linear-gradient(145deg, rgba(255,255,255,.065), rgba(255,255,255,.022));
  	          font: 950 14px Inter, Arial, sans-serif;
  	          letter-spacing: .11em;
  	          text-transform: uppercase;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-input:focus {
  	          border-color: rgba(255,132,48,.76);
  	          box-shadow:
  	            0 0 0 1px rgba(255,132,48,.20),
  	            0 0 18px rgba(255,100,54,.16);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-input.is-valid {
  	          border-color: rgba(88,220,126,.74);
  	          box-shadow:
  	            0 0 0 1px rgba(88,220,126,.18),
  	            0 0 18px rgba(88,220,126,.14);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-input.is-invalid {
  	          border-color: rgba(255,78,54,.66);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-error {
  	          display: none;
  	          color: #ffd0c8;
  	          font-size: 8px;
  	          font-weight: 850;
  	          line-height: 1.2;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-error.visible {
  	          display: block;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-actions {
  	          display: grid;
  	          grid-template-columns: repeat(2, minmax(0, 1fr));
  	          gap: 9px;
  	          padding: 0 16px 16px;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-action {
  	          height: 36px;
  	          padding: 0 8px;
  	          border: 1px solid rgba(255,255,255,.10);
  	          border-radius: 13px;
  	          outline: none;
  	          cursor: pointer;
  	          color: rgba(255,255,255,.82);
  	          background:
  	            radial-gradient(circle at 100% 0%, rgba(255,132,48,.10), transparent 44%),
  	            linear-gradient(145deg, rgba(255,255,255,.060), rgba(255,255,255,.020));
  	          font-size: 9px;
  	          font-weight: 950;
  	          letter-spacing: .06em;
  	          text-transform: uppercase;
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-action:hover:not(:disabled) {
  	          color: #fff;
  	          border-color: rgba(255,137,56,.60);
  	          background: rgba(255,111,29,.15);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-confirm {
  	          color: #ffe1d8;
  	          border-color: rgba(255,78,54,.84);
  	          background:
  	            radial-gradient(circle at 50% 12%, rgba(255,177,92,.18), transparent 46%),
  	            linear-gradient(145deg, rgba(255,78,54,.48), rgba(88,12,8,.76));
  	          box-shadow: 0 0 16px rgba(255,70,40,.18);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-confirm:hover:not(:disabled),
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-confirm:focus-visible:not(:disabled) {
  	          border-color: rgba(255,116,86,.96);
  	          box-shadow:
  	            0 0 0 1px rgba(255,78,54,.20),
  	            0 0 20px rgba(255,70,40,.26);
  	        }
  	
  	        #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete-action:disabled {
  	          opacity: .52;
  	          pointer-events: none;
  	        }
  	
  	        @media (max-width: 760px) {
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} {
  	            padding: 10px;
  	          }
  	
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-card {
  	            max-height: calc(100vh - 70px);
  	          }
  	
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-layout {
  	            grid-template-columns: 1fr;
  	            overflow: auto;
  	          }
  	
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list-panel {
  	            border-right: 0;
  	            border-bottom: 1px solid rgba(255,255,255,.08);
  	          }
  	
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-form {
  	            grid-template-columns: 1fr;
  	          }
  	
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-list-row {
  	            grid-template-columns: minmax(0, 1fr) 30px;
  	          }
  	
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-delete {
  	            width: 30px;
  	            min-width: 30px;
  	          }
  	
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-field-wide,
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-form-title,
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-error,
  	          #${MANAGER_SUPPLIER_OVERLAY_ID} .fif-supplier-actions {
  	            grid-column: 1;
  	          }
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} {
  	          position: fixed;
  	          top: 50px;
  	          right: 0;
  	          bottom: 0;
  	          left: 0;
  	          z-index: 2147483647;
  	          display: flex;
  	          align-items: center;
  	          justify-content: center;
  	          padding: 20px;
  	          background: rgba(2, 6, 12, 0.78);
  	          backdrop-filter: blur(10px);
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-card {
  	          width: min(520px, 100%);
  	          overflow: hidden;
  	          border: 1px solid rgba(251, 146, 60, 0.38);
  	          border-radius: 18px;
  	          background:
  	            radial-gradient(circle at 12% 0%, rgba(249, 115, 22, 0.13), transparent 38%),
  	            linear-gradient(145deg, #151a22, #090e15);
  	          color: #fff;
  	          font-family: Inter, Arial, sans-serif;
  	          box-shadow: 0 26px 70px rgba(0, 0, 0, 0.56);
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-head {
  	          padding: 18px 20px 15px;
  	          border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-title {
  	          color: #fff;
  	          font-size: 18px;
  	          font-weight: 950;
  	          line-height: 1.15;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-subtitle {
  	          margin-top: 6px;
  	          color: #91a7c6;
  	          font-size: 11px;
  	          font-weight: 650;
  	          line-height: 1.45;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-body {
  	          display: grid;
  	          gap: 14px;
  	          padding: 18px 20px;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-field {
  	          display: grid;
  	          gap: 7px;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-label {
  	          color: #c9d4e3;
  	          font-size: 11px;
  	          font-weight: 900;
  	          letter-spacing: 0.05em;
  	          text-transform: uppercase;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-input {
  	          width: 100%;
  	          height: 46px;
  	          padding: 0 13px;
  	          border: 1px solid rgba(255, 255, 255, 0.12);
  	          border-radius: 12px;
  	          outline: none;
  	          background: rgba(0, 0, 0, 0.30);
  	          color: #fff;
  	          font-family: inherit;
  	          font-size: 14px;
  	          font-weight: 800;
  	          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-input:focus {
  	          border-color: rgba(251, 146, 60, 0.78);
  	          box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.13);
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-select {
  	          appearance: none;
  	          -webkit-appearance: none;
  	          -moz-appearance: none;
  	          padding-right: 44px;
  	          cursor: pointer;
  	          background-color: rgba(0, 0, 0, 0.30);
  	          background-image:
  	            linear-gradient(45deg, transparent 50%, #fb923c 50%),
  	            linear-gradient(135deg, #fb923c 50%, transparent 50%);
  	          background-position:
  	            calc(100% - 19px) 19px,
  	            calc(100% - 13px) 19px;
  	          background-size: 6px 6px, 6px 6px;
  	          background-repeat: no-repeat;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-select option {
  	          background: #0b1119;
  	          color: #fff;
  	          font-weight: 750;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-edit-two-column {
  	          display: grid;
  	          grid-template-columns: repeat(2, minmax(0, 1fr));
  	          gap: 12px;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-edit-help {
  	          display: block;
  	          margin-top: 5px;
  	          color: #74849a;
  	          font-size: 9px;
  	          font-weight: 650;
  	          line-height: 1.25;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-note {
  	          padding: 10px 12px;
  	          border: 1px solid rgba(255, 255, 255, 0.07);
  	          border-radius: 11px;
  	          background: rgba(255, 255, 255, 0.035);
  	          color: #8798af;
  	          font-size: 10px;
  	          font-weight: 650;
  	          line-height: 1.45;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-error {
  	          display: none;
  	          padding: 10px 12px;
  	          border: 1px solid rgba(248, 113, 113, 0.42);
  	          border-radius: 11px;
  	          background: rgba(127, 29, 29, 0.20);
  	          color: #fecaca;
  	          font-size: 11px;
  	          font-weight: 750;
  	          line-height: 1.4;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-actions {
  	          display: flex;
  	          justify-content: flex-end;
  	          gap: 10px;
  	          padding: 14px 20px 18px;
  	          border-top: 1px solid rgba(255, 255, 255, 0.08);
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-action {
  	          height: 42px;
  	          padding: 0 15px;
  	          border-radius: 11px;
  	          font-family: inherit;
  	          font-size: 12px;
  	          font-weight: 900;
  	          cursor: pointer;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-cancel {
  	          border: 1px solid rgba(255, 255, 255, 0.12);
  	          background: rgba(255, 255, 255, 0.055);
  	          color: #d7e0eb;
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-save {
  	          border: 1px solid rgba(251, 146, 60, 0.72);
  	          background: linear-gradient(145deg, #c6632e, #8f3f1e);
  	          color: #fff;
  	          box-shadow: 0 8px 18px rgba(204, 102, 51, 0.24);
  	        }
  	
  	        #${MANAGER_EDIT_OVERLAY_ID} .fif-manager-edit-action:disabled {
  	          cursor: wait;
  	          opacity: 0.62;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-empty-bowsers {
  	          display: flex;
  	          align-items: center;
  	          justify-content: center;
  	          gap: 8px;
  	          min-height: 56px;
  	          padding: 12px;
  	          border: 1px dashed rgba(255, 255, 255, 0.13);
  	          border-radius: 13px;
  	          color: #718198;
  	          font-size: 11px;
  	          font-weight: 650;
  	          text-align: center;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-empty-icon {
  	          opacity: 0.75;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-no-data {
  	          display: flex;
  	          flex-direction: column;
  	          align-items: center;
  	          justify-content: center;
  	          min-height: 240px;
  	          padding: 34px;
  	          border: 1px dashed rgba(255, 255, 255, 0.14);
  	          border-radius: 18px;
  	          background: rgba(255, 255, 255, 0.025);
  	          text-align: center;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-no-data-icon {
  	          font-size: 28px;
  	          opacity: 0.75;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-no-data-title {
  	          margin-top: 10px;
  	          color: #fff;
  	          font-size: 16px;
  	          font-weight: 950;
  	        }
  	
  	        #${MANAGER_ROOT_ID} .fif-manager-no-data-copy {
  	          margin-top: 6px;
  	          color: #718198;
  	          font-size: 11px;
  	        }
  	
  	        @media (max-width: 760px) {
  	          #${MANAGER_ROOT_ID} {
  	            padding: 10px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-header {
  	            position: relative;
  	            min-height: 54px;
  	            margin-bottom: 12px;
  	            padding: 9px 11px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-logo-img,
  	          #${MANAGER_ROOT_ID} .fif-manager-logo-svg svg {
  	            max-width: 66px;
  	            max-height: 30px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-logo-svg {
  	            width: 66px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-grid {
  	            grid-template-columns: 1fr;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-tank-card {
  	            padding: 11px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-tank-main {
  	            grid-template-columns: 1fr;
  	            gap: 10px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-gauge-pair {
  	            width: 202px;
  	            min-width: 202px;
  	            justify-self: center;
  	            gap: 10px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-gauge {
  	            width: 96px;
  	            height: 96px;
  	            min-width: 96px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-tank-content {
  	            gap: 10px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-stat-grid {
  	            grid-template-columns: repeat(4, minmax(0, 1fr));
  	            gap: 6px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-stat {
  	            min-height: 52px;
  	            padding: 8px 8px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-stat span {
  	            font-size: 9px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-stat strong {
  	            margin-top: 5px;
  	            font-size: 12px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-delivery-btn {
  	            height: 44px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-bowser-row {
  	            min-height: 56px;
  	            padding: 8px 10px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-bowser-centre {
  	            gap: 9px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-pump-icon {
  	            flex-basis: 35px;
  	            width: 35px;
  	            height: 35px;
  	            font-size: 15px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-bowser-name,
  	          #${MANAGER_ROOT_ID} .fif-manager-dispense-copy {
  	            font-size: 12px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-bowser-divider {
  	            height: 20px;
  	          }
  	        }
  	
  	        @media (max-width: 720px) {
  	          #${MANAGER_ROOT_ID} .fif-manager-tank-actions {
  	            gap: 5px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-printables-button {
  	            min-width: 92px;
  	            padding: 0 8px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-tank-edit-btn span:last-child {
  	            display: none;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-tank-edit-btn {
  	            width: 34px;
  	            min-width: 34px;
  	            padding: 0;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-bowser-action {
  	            padding-right: 46px;
  	            padding-left: 46px;
  	          }
  	        }
  	
  	        @media (max-width: 480px) {
  	          #${MANAGER_ROOT_ID} .fif-manager-title {
  	            font-size: 15px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-subtitle {
  	            font-size: 9px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-tank-main {
  	            grid-template-columns: 1fr;
  	            gap: 8px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-gauge-pair {
  	            width: 164px;
  	            min-width: 164px;
  	            gap: 8px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-gauge {
  	            width: 78px;
  	            height: 78px;
  	            min-width: 78px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-gauge-level {
  	            font-size: 15px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-gauge-volume {
  	            font-size: 8.1px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-tank-name {
  	            font-size: 17px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-grade {
  	            font-size: 12px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-device {
  	            font-size: 10px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-stat-grid {
  	            grid-template-columns: repeat(2, minmax(0, 1fr));
  	            gap: 4px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-stat {
  	            min-height: 47px;
  	            padding: 7px 5px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-stat span {
  	            font-size: 7.5px;
  	            letter-spacing: 0.02em;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-stat strong {
  	            margin-top: 5px;
  	            font-size: 10px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-bowser-centre {
  	            gap: 7px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-pump-icon {
  	            flex-basis: 32px;
  	            width: 32px;
  	            height: 32px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-bowser-name,
  	          #${MANAGER_ROOT_ID} .fif-manager-dispense-copy {
  	            font-size: 11px;
  	          }
  	        }
  	
  	        @media (max-width: 720px) {
  	          #${MANAGER_ROOT_ID} .fif-manager-company-head {
  	            align-items: center;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-company-actions {
  	            gap: 6px;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-company-sub {
  	            display: none;
  	          }
  	
  	          #${MANAGER_ROOT_ID} .fif-manager-edit-two-column {
  	            grid-template-columns: 1fr;
  	          }
  	        }
  	      </style>
  	    `;
  	  }
  	
  	  function managerBuildDashboardHtml() {
  	    return (
  	      managerBuildStyles() +
  	
  	      '<div id="' + MANAGER_ROOT_ID + '">' +
  	
  	        '<header class="fif-manager-header">' +
  	          '<div class="fif-manager-brand">' +
  	            managerLogoHtml() +
  	
  	            '<div style="min-width:0">' +
  	              '<div class="fif-manager-title">' +
  	                "Tank &amp; Bowser Management" +
  	              "</div>" +
  	
  	              '<div class="fif-manager-subtitle">' +
  	                "Book stock management with independent ATG verification" +
  	              "</div>" +
  	            "</div>" +
  	          "</div>" +
  	        "</header>" +
  	
  	        '<main id="fif-manager-companies">' +
  	          managerBuildCompanySections() +
  	        "</main>" +
  	
  	      "</div>"
  	    );
  	  }
  	
  	  function managerRefreshTankCards() {
  	    if (destroyed) return;
  	
  	    companiesCache = managerCompanies();
  	
  	    var cards = hostEl.querySelectorAll(
  	      ".fif-manager-tank-card"
  	    );
  	
  	    for (
  	      var cardIndex = 0;
  	      cardIndex < cards.length;
  	      cardIndex++
  	    ) {
  	      var card = cards[cardIndex];
  	
  	      var companyIndex = Number(
  	        card.getAttribute("data-company-index")
  	      );
  	
  	      var tankIndex = Number(
  	        card.getAttribute("data-tank-index")
  	      );
  	
  	      var company = companiesCache[companyIndex];
  	      var tanks = managerTanks(company);
  	      var tank = tanks[tankIndex];
  	
  	      if (!tank) continue;
  	
  	      managerRenderGauge(
  	        card.querySelector("[data-tank-gauge]"),
  	        tank,
  	        companyIndex +
  	          "_" +
  	          tankIndex +
  	          "_" +
  	          managerGet(tank, ["objectId"], "")
  	      );
  	
  	      var atgSnapshot = managerTankAtgSnapshot(tank);
  	
  	      managerRenderGauge(
  	        card.querySelector("[data-atg-gauge]"),
  	        tank,
  	        companyIndex +
  	          "_" +
  	          tankIndex +
  	          "_atg_" +
  	          managerGet(tank, ["objectId"], ""),
  	        managerTankAtgLevel(tank),
  	        atgSnapshot.available ? atgSnapshot.volume : null
  	      );
  	
  	      var currentLevel = managerTankLevel(tank);
  	
  	      var levelNode = card.querySelector(
  	        "[data-tank-level]"
  	      );
  	
  	      var volumeNode = card.querySelector(
  	        "[data-tank-volume]"
  	      );
  	
  	      var capacityNode = card.querySelector(
  	        "[data-tank-capacity]"
  	      );
  	
  	      var stockValueNode = card.querySelector(
  	        "[data-tank-stock-value]"
  	      );
  	
  	      var atgStripNode = card.querySelector(
  	        "[data-atg-strip]"
  	      );
  	
  	      if (levelNode) {
  	        levelNode.textContent =
  	          managerFormat(currentLevel, 1) + "%";
  	      }
  	
  	      if (volumeNode) {
  	        volumeNode.textContent =
  	          managerFormat(
  	            managerTankBookVolume(tank),
  	            2
  	          ) + " L";
  	      }
  	
  	      if (capacityNode) {
  	        capacityNode.textContent =
  	          managerFormat(
  	            managerFirst(
  	              managerGet(tank, ["Capacity"], null),
  	              managerGet(tank, ["capacity"], 0)
  	            ),
  	            2
  	          ) + " L";
  	      }
  	
  	      if (stockValueNode) {
  	        stockValueNode.textContent = managerFormatCurrency(
  	          managerTankStockValue(tank)
  	        );
  	      }
  	
  	      if (atgStripNode) {
  	        atgStripNode.outerHTML = managerBuildAtgStrip(tank);
  	      }
  	
  	      managerPaintFuelButton(
  	        card.querySelector(
  	          ".fif-manager-delivery-btn"
  	        ),
  	        currentLevel
  	      );
  	    }
  	  }
  	
  	  function managerReplaceTankAtgRelation(tank, freshAtg) {
  	    if (!tank || !freshAtg) return;
  	
  	    if (Array.isArray(tank.ATG)) {
  	      if (tank.ATG.length) {
  	        tank.ATG[0] = freshAtg;
  	      } else {
  	        tank.ATG.push(freshAtg);
  	      }
  	      return;
  	    }
  	
  	    if (
  	      tank.ATG &&
  	      typeof tank.ATG === "object" &&
  	      Array.isArray(tank.ATG.data)
  	    ) {
  	      if (tank.ATG.data.length) {
  	        tank.ATG.data[0] = freshAtg;
  	      } else {
  	        tank.ATG.data.push(freshAtg);
  	      }
  	      return;
  	    }
  	
  	    tank.ATG = freshAtg;
  	  }
  	
  	  async function managerRefreshAtgRelations() {
  	    if (
  	      destroyed ||
  	      managerAtgRefreshInFlight ||
  	      !rootBackendless ||
  	      !rootBackendless.Data ||
  	      typeof rootBackendless.Data.of !== "function"
  	    ) {
  	      return;
  	    }
  	
  	    var tanks = managerAllTanks();
  	    var relationIds = {};
  	
  	    for (var index = 0; index < tanks.length; index++) {
  	      var relation = managerTankAtgRelation(tanks[index]);
  	      var relationId = managerText(
  	        managerGet(relation, ["objectId"], null),
  	        ""
  	      );
  	
  	      if (relationId) relationIds[relationId] = true;
  	    }
  	
  	    var ids = Object.keys(relationIds);
  	    if (!ids.length) return;
  	
  	    managerAtgRefreshInFlight = true;
  	
  	    try {
  	      var api = rootBackendless.Data.of("ATGPolls");
  	      var rows = await Promise.all(
  	        ids.map(function (objectId) {
  	          return api.findById(objectId).catch(function (error) {
  	            console.warn(
  	              "[Fuel Manager] ATG refresh failed for " + objectId + ":",
  	              error
  	            );
  	            return null;
  	          });
  	        })
  	      );
  	
  	      var byId = {};
  	      rows.forEach(function (row) {
  	        var rowId = managerText(
  	          managerGet(row, ["objectId"], null),
  	          ""
  	        );
  	        if (rowId) byId[rowId] = row;
  	      });
  	
  	      tanks.forEach(function (tank) {
  	        var current = managerTankAtgRelation(tank);
  	        var currentId = managerText(
  	          managerGet(current, ["objectId"], null),
  	          ""
  	        );
  	
  	        if (currentId && byId[currentId]) {
  	          managerReplaceTankAtgRelation(tank, byId[currentId]);
  	        }
  	      });
  	
  	      if (!destroyed) managerRefreshTankCards();
  	    } catch (error) {
  	      console.warn("[Fuel Manager] ATG background refresh failed:", error);
  	    } finally {
  	      managerAtgRefreshInFlight = false;
  	    }
  	  }
  	
  	  function managerRenderDashboard() {
  	    companiesCache = managerCompanies();
  	    hostEl.innerHTML = managerBuildDashboardHtml();
  	    managerRefreshTankCards();
  	  }
  	
  	  function managerOpenDelivery(
  	    company,
  	    tank,
  	    gaugeElement
  	  ) {
  	    managerCloseOverlays();
  	
  	    openFuelDelivery({
  	      AppData: rootAppData,
  	      Company: company,
  	      Tank: tank,
  	      TankBlock: {
  	        el: gaugeElement
  	      },
  	      Backendless: rootBackendless,
  	      CurrentUser: rootCurrentUser,
  	      SVGLogo: rootSvgLogo,
  	      onChanged: managerRefreshTankCards
  	    });
  	  }
  	
  	  function managerOpenCapture(
  	    company,
  	    tank,
  	    bowser,
  	    gaugeElement
  	  ) {
  	    managerCloseOverlays();
  	
  	    openFuelCapture({
  	      AppData: rootAppData,
  	      Company: company,
  	      Tank: tank,
  	      Bowser: bowser,
  	      Contractors: managerToArray(
  	        managerGet(company, ["Contractors"], [])
  	      ),
  	      TankBlock: {
  	        el: gaugeElement
  	      },
  	      Backendless: rootBackendless,
  	      CurrentUser: rootCurrentUser,
  	      SVGLogo: rootSvgLogo,
  	      Tanks: managerAllTanks(),
  	      onChanged: managerRefreshTankCards
  	    });
  	  }
  	
  	  function managerCloseAssetEditor() {
  	    var existing = document.getElementById(
  	      MANAGER_EDIT_OVERLAY_ID
  	    );
  	
  	    if (existing) {
  	      try {
  	        managerDestroyThemedSelectsWithin(existing);
  	      } catch (_) {}
  	
  	      try {
  	        existing.remove();
  	      } catch (_) {}
  	    }
  	  }
  	
  	  function managerSaveEditableAsset(
  	    tableName,
  	    asset,
  	    changes
  	  ) {
  	    if (
  	      !rootBackendless ||
  	      !rootBackendless.Data ||
  	      !rootBackendless.Data.of
  	    ) {
  	      return Promise.reject(
  	        new Error("Backendless SDK is not available")
  	      );
  	    }
  	
  	    var objectId = managerText(
  	      managerGet(asset, ["objectId"], null),
  	      ""
  	    );
  	
  	    if (!objectId) {
  	      return Promise.reject(
  	        new Error(
  	          "This record has no objectId and cannot be edited."
  	        )
  	      );
  	    }
  	
  	    var payload = Object.assign(
  	      { objectId: objectId },
  	      managerPlainObject(changes)
  	    );
  	
  	    return managerTrackDatabasePromise(
  	      managerDatabaseStatus("save", tableName),
  	      function () {
  	        return rootBackendless.Data
  	          .of(tableName)
  	          .save(payload);
  	      }
  	    );
  	  }
  	
  	  function managerSynchronizeBowserGrades(tank, grade) {
  	    var bowsers = managerBowsers(tank);
  	    var saves = [];
  	
  	    for (var index = 0; index < bowsers.length; index++) {
  	      var bowser = bowsers[index];
  	      bowser.Grade = grade;
  	
  	      if (bowser.objectId) {
  	        saves.push(
  	          managerSaveEditableAsset(
  	            "Bowsers",
  	            bowser,
  	            { Grade: grade }
  	          ).catch(function (error) {
  	            console.warn(
  	              "[Fuel Manager] Bowser grade synchronisation failed:",
  	              error
  	            );
  	            return null;
  	          })
  	        );
  	      }
  	    }
  	
  	    return Promise.all(saves);
  	  }
  	
  	  function managerCanonicalFuelGrade(value) {
  	    var wanted = String(value || "").trim().toLowerCase();
  	
  	    for (var index = 0; index < MANAGER_FUEL_GRADES.length; index++) {
  	      if (MANAGER_FUEL_GRADES[index].toLowerCase() === wanted) {
  	        return MANAGER_FUEL_GRADES[index];
  	      }
  	    }
  	
  	    return "";
  	  }
  	
  	  function managerFuelGradeOptionsHtml(currentGrade) {
  	    var selectedGrade = managerCanonicalFuelGrade(currentGrade);
  	    var html =
  	      '<option value=""' +
  	      (selectedGrade ? "" : " selected") +
  	      ' disabled>Select fuel grade</option>';
  	
  	    var sortedGrades = MANAGER_FUEL_GRADES
  	      .slice()
  	      .sort(function (left, right) {
  	        return String(left).localeCompare(
  	          String(right),
  	          undefined,
  	          {
  	            numeric: true,
  	            sensitivity: "base"
  	          }
  	        );
  	      });
  	
  	    for (var index = 0; index < sortedGrades.length; index++) {
  	      var grade = sortedGrades[index];
  	
  	      html +=
  	        '<option value="' + managerEscape(grade) + '"' +
  	        (grade === selectedGrade ? " selected" : "") +
  	        '>' + managerEscape(grade) + '</option>';
  	    }
  	
  	    return html;
  	  }
  	
  	  function managerCloseSupplierManager() {
  	    var existing = document.getElementById(
  	      MANAGER_SUPPLIER_OVERLAY_ID
  	    );
  	
  	    if (existing) {
  	      try {
  	        managerDestroyThemedSelectsWithin(existing);
  	      } catch (_) {}
  	
  	      try {
  	        existing.remove();
  	      } catch (_) {}
  	    }
  	  }
  	
  	  function managerSaveCompanySuppliers(company, suppliers) {
  	    if (
  	      !rootBackendless ||
  	      !rootBackendless.Data ||
  	      !rootBackendless.Data.of
  	    ) {
  	      return Promise.reject(
  	        new Error("Backendless SDK is not available")
  	      );
  	    }
  	
  	    var objectId = managerText(
  	      managerGet(company, ["objectId"], null),
  	      ""
  	    );
  	
  	    if (!objectId) {
  	      return Promise.reject(
  	        new Error(
  	          "This company has no objectId and its Manifest cannot be saved."
  	        )
  	      );
  	    }
  	
  	    var manifest = managerCompanyManifest(company);
  	    manifest.Suppliers = suppliers.map(function (supplier, index) {
  	      return managerNormaliseSupplier(supplier, index);
  	    });
  	
  	    return managerTrackDatabasePromise(
  	      managerDatabaseStatus("save", "Companies"),
  	      function () {
  	        return rootBackendless.Data.of("Companies").save({
  	          objectId: objectId,
  	          Manifest: manifest
  	        });
  	      }
  	    ).then(function (savedCompany) {
  	      company.Manifest = manifest;
  	
  	      if (savedCompany && typeof savedCompany === "object") {
  	        Object.keys(savedCompany).forEach(function (key) {
  	          company[key] = savedCompany[key];
  	        });
  	      }
  	
  	      return manifest.Suppliers;
  	    });
  	  }
  	
  	  function managerMakeSupplierId() {
  	    return (
  	      "supplier_" +
  	      Date.now().toString(36) +
  	      "_" +
  	      Math.random().toString(36).slice(2, 8)
  	    );
  	  }
  	
  	  function managerOpenSupplierManager(companyIndex) {
  	    managerCloseSupplierManager();
  	
  	    var company = companiesCache[companyIndex];
  	    if (!company) {
  	      alert("The selected company is no longer available.");
  	      return;
  	    }
  	
  	    var suppliers = managerSuppliers(company);
  	    var selectedIndex = suppliers.length ? 0 : -1;
  	    var deleteBackdrop = null;
  	
  	    var overlay = document.createElement("div");
  	    overlay.id = MANAGER_SUPPLIER_OVERLAY_ID;
  	    overlay.setAttribute("role", "dialog");
  	    overlay.setAttribute("aria-modal", "true");
  	    overlay.setAttribute("aria-label", "Supplier Management");
  	
  	    overlay.innerHTML =
  	      '<div class="fif-supplier-card">' +
  	        '<div class="fif-supplier-head">' +
  	          '<div>' +
  	            '<div class="fif-supplier-title">Supplier Management</div>' +
  	            '<div class="fif-supplier-subtitle">' +
  	              managerEscape(managerCompanyLabel(company, companyIndex)) +
  	              ' · stored in Company.Manifest.Suppliers' +
  	            '</div>' +
  	          '</div>' +
  	          '<button type="button" class="fif-supplier-close" aria-label="Close">×</button>' +
  	        '</div>' +
  	
  	        '<div class="fif-supplier-layout">' +
  	          '<div class="fif-supplier-list-panel">' +
  	            '<button type="button" class="fif-supplier-new">＋ Create Supplier</button>' +
  	            '<div class="fif-supplier-list"></div>' +
  	          '</div>' +
  	
  	          '<div class="fif-supplier-form-panel">' +
  	            '<form class="fif-supplier-form" novalidate>' +
  	              '<div class="fif-supplier-form-title">Supplier Details</div>' +
  	
  	              '<label class="fif-supplier-field fif-supplier-field-wide">' +
  	                '<span>Supplier Name</span>' +
  	                '<input class="fif-supplier-input" name="supplierName" type="text" maxlength="160" autocomplete="organization" required>' +
  	              '</label>' +
  	
  	              '<label class="fif-supplier-field">' +
  	                '<span>Representative</span>' +
  	                '<input class="fif-supplier-input" name="representative" type="text" maxlength="160" autocomplete="name">' +
  	              '</label>' +
  	
  	              '<label class="fif-supplier-field">' +
  	                '<span>Contact Number</span>' +
  	                '<input class="fif-supplier-input" name="contactNumber" type="tel" maxlength="80" autocomplete="tel">' +
  	              '</label>' +
  	
  	              '<label class="fif-supplier-field">' +
  	                '<span>Email</span>' +
  	                '<input class="fif-supplier-input" name="email" type="email" maxlength="200" autocomplete="email">' +
  	              '</label>' +
  	
  	              '<label class="fif-supplier-field">' +
  	                '<span>Order Email</span>' +
  	                '<input class="fif-supplier-input" name="orderEmail" type="email" maxlength="200" autocomplete="email">' +
  	              '</label>' +
  	
  	              '<div class="fif-supplier-error" role="alert"></div>' +
  	
  	              '<div class="fif-supplier-actions">' +
  	                '<button type="button" class="fif-supplier-action fif-supplier-cancel">Clear</button>' +
  	                '<button type="submit" class="fif-supplier-action fif-supplier-save">Save Supplier</button>' +
  	              '</div>' +
  	            '</form>' +
  	          '</div>' +
  	        '</div>' +
  	      '</div>';
  	
  	    managerOverlay.appendChild(overlay);
  	
  	    var listNode = overlay.querySelector(".fif-supplier-list");
  	    var form = overlay.querySelector(".fif-supplier-form");
  	    var nameInput = overlay.querySelector('[name="supplierName"]');
  	    var representativeInput = overlay.querySelector('[name="representative"]');
  	    var contactInput = overlay.querySelector('[name="contactNumber"]');
  	    var emailInput = overlay.querySelector('[name="email"]');
  	    var orderEmailInput = overlay.querySelector('[name="orderEmail"]');
  	    var errorBox = overlay.querySelector(".fif-supplier-error");
  	    var saveButton = overlay.querySelector(".fif-supplier-save");
  	
  	    function showError(message) {
  	      errorBox.textContent = String(message || "Supplier save failed.");
  	      errorBox.style.display = "block";
  	    }
  	
  	    function clearError() {
  	      errorBox.textContent = "";
  	      errorBox.style.display = "none";
  	    }
  	
  	    function clearForm() {
  	      selectedIndex = -1;
  	      form.reset();
  	      clearError();
  	      renderList();
  	      saveButton.textContent = "Save Supplier";
  	      setTimeout(function () {
  	        try { nameInput.focus(); } catch (_) {}
  	      }, 0);
  	    }
  	
  	    function loadSupplier(index) {
  	      if (index < 0 || index >= suppliers.length) {
  	        clearForm();
  	        return;
  	      }
  	
  	      selectedIndex = index;
  	      var supplier = suppliers[index];
  	      nameInput.value = supplier.Name || "";
  	      representativeInput.value = supplier.Representative || "";
  	      contactInput.value = supplier.ContactNumber || "";
  	      emailInput.value = supplier.Email || "";
  	      orderEmailInput.value = supplier.OrderEmail || "";
  	      saveButton.textContent = "Save Changes";
  	      clearError();
  	      renderList();
  	    }
  	
  	    function closeDeleteSafety() {
  	      if (!deleteBackdrop) return;
  	
  	      try {
  	        if (deleteBackdrop.parentNode) {
  	          deleteBackdrop.parentNode.removeChild(deleteBackdrop);
  	        }
  	      } catch (_) {}
  	
  	      deleteBackdrop = null;
  	    }
  	
  	    function supplierMatchesTank(supplier, tank) {
  	      var supplierId = String(
  	        managerGet(supplier, ["SupplierId"], "") || ""
  	      ).trim().toLowerCase();
  	
  	      var supplierName = String(
  	        managerGet(supplier, ["Name"], "") || ""
  	      ).trim().toLowerCase();
  	
  	      var tankSupplierId = String(
  	        managerTankPrimarySupplierId(tank) || ""
  	      ).trim().toLowerCase();
  	
  	      var tankSupplierName = String(
  	        managerTankPrimarySupplierName(tank) || ""
  	      ).trim().toLowerCase();
  	
  	      if (supplierId && tankSupplierId) {
  	        return supplierId === tankSupplierId;
  	      }
  	
  	      return Boolean(
  	        supplierName &&
  	        tankSupplierName &&
  	        supplierName === tankSupplierName
  	      );
  	    }
  	
  	    function clearSupplierFromTank(tank) {
  	      return managerSaveEditableAsset(
  	        "Tanks",
  	        tank,
  	        {
  	          PrimarySupplierId: "",
  	          PrimarySupplier: ""
  	        }
  	      ).then(function (savedTank) {
  	        tank.PrimarySupplierId = "";
  	        tank.PrimarySupplier = "";
  	
  	        if (savedTank && typeof savedTank === "object") {
  	          Object.keys(savedTank).forEach(function (key) {
  	            tank[key] = savedTank[key];
  	          });
  	        }
  	
  	        tank.PrimarySupplierId = "";
  	        tank.PrimarySupplier = "";
  	
  	        return tank;
  	      });
  	    }
  	
  	    function openDeleteSafety(index) {
  	      if (index < 0 || index >= suppliers.length) return;
  	
  	      closeDeleteSafety();
  	
  	      var supplier = suppliers[index];
  	      var supplierName = managerText(
  	        managerGet(supplier, ["Name"], null),
  	        "this supplier"
  	      );
  	      var supplierId = managerText(
  	        managerGet(supplier, ["SupplierId"], null),
  	        ""
  	      );
  	      var selectedSupplierId = selectedIndex >= 0
  	        ? managerText(
  	            managerGet(suppliers[selectedIndex], ["SupplierId"], null),
  	            ""
  	          )
  	        : "";
  	
  	      var companyTanks = managerTanks(company);
  	      var affectedTanks = companyTanks.filter(function (tank) {
  	        return supplierMatchesTank(supplier, tank);
  	      });
  	
  	      var affectedNames = affectedTanks.map(function (tank, tankIndex) {
  	        return managerTankLabel(tank, tankIndex);
  	      });
  	
  	      var affectedWarning = affectedNames.length
  	        ? (
  	            '<div class="fif-supplier-delete-warning">' +
  	              'This will also clear <strong>Primary Supplier</strong> on ' +
  	              '<strong>' + affectedNames.length + '</strong> tank' +
  	              (affectedNames.length === 1 ? '' : 's') + ': ' +
  	              managerEscape(
  	                affectedNames.slice(0, 4).join(', ') +
  	                (affectedNames.length > 4
  	                  ? ' and ' + (affectedNames.length - 4) + ' more'
  	                  : '')
  	              ) +
  	              '.' +
  	            '</div>'
  	          )
  	        : '';
  	
  	      deleteBackdrop = document.createElement("div");
  	      deleteBackdrop.className = "fif-supplier-delete-backdrop";
  	      deleteBackdrop.setAttribute("role", "dialog");
  	      deleteBackdrop.setAttribute("aria-modal", "true");
  	      deleteBackdrop.setAttribute(
  	        "aria-label",
  	        "Delete supplier " + supplierName
  	      );
  	
  	      deleteBackdrop.innerHTML =
  	        '<form class="fif-supplier-delete-card" novalidate>' +
  	          '<div class="fif-supplier-delete-head">' +
  	            '<div class="fif-supplier-delete-icon" aria-hidden="true">!</div>' +
  	            '<div class="fif-supplier-delete-title-block">' +
  	              '<div class="fif-supplier-delete-title">Delete Supplier</div>' +
  	              '<div class="fif-supplier-delete-subtitle">Permanent Action</div>' +
  	            '</div>' +
  	            '<button type="button" class="fif-supplier-delete-close" ' +
  	            'aria-label="Cancel delete">×</button>' +
  	          '</div>' +
  	
  	          '<div class="fif-supplier-delete-body">' +
  	            '<div class="fif-supplier-delete-name">' +
  	              managerEscape(supplierName) +
  	            '</div>' +
  	
  	            '<div class="fif-supplier-delete-copy">' +
  	              'This will permanently remove this supplier from ' +
  	              'Company.Manifest.Suppliers. This action cannot be undone.' +
  	            '</div>' +
  	
  	            affectedWarning +
  	
  	            '<label class="fif-supplier-delete-field">' +
  	              '<span>Type <strong>DELETE</strong> to confirm</span>' +
  	              '<input class="fif-supplier-delete-input" ' +
  	              'name="deleteConfirmation" type="text" ' +
  	              'autocomplete="off" autocapitalize="characters" spellcheck="false" ' +
  	              'placeholder="DELETE">' +
  	            '</label>' +
  	
  	            '<div class="fif-supplier-delete-error" role="alert">' +
  	              'Exact confirmation required.' +
  	            '</div>' +
  	          '</div>' +
  	
  	          '<div class="fif-supplier-delete-actions">' +
  	            '<button type="submit" disabled ' +
  	            'class="fif-supplier-delete-action fif-supplier-delete-confirm">' +
  	              'Delete' +
  	            '</button>' +
  	            '<button type="button" ' +
  	            'class="fif-supplier-delete-action fif-supplier-delete-cancel">' +
  	              'Cancel' +
  	            '</button>' +
  	          '</div>' +
  	        '</form>';
  	
  	      overlay.appendChild(deleteBackdrop);
  	
  	      var deleteForm = deleteBackdrop.querySelector("form");
  	      var confirmationInput = deleteBackdrop.querySelector(
  	        '[name="deleteConfirmation"]'
  	      );
  	      var cancelDeleteButton = deleteBackdrop.querySelector(
  	        ".fif-supplier-delete-cancel"
  	      );
  	      var closeDeleteButton = deleteBackdrop.querySelector(
  	        ".fif-supplier-delete-close"
  	      );
  	      var confirmDeleteButton = deleteBackdrop.querySelector(
  	        ".fif-supplier-delete-confirm"
  	      );
  	      var deleteErrorBox = deleteBackdrop.querySelector(
  	        ".fif-supplier-delete-error"
  	      );
  	
  	      function showDeleteError(message) {
  	        deleteErrorBox.textContent = String(
  	          message || "Supplier could not be deleted."
  	        );
  	        deleteErrorBox.classList.add("visible");
  	      }
  	
  	      function refreshDeleteState() {
  	        var value = String(confirmationInput.value || "").trim();
  	        var isValid = value === "DELETE";
  	
  	        confirmDeleteButton.disabled = !isValid;
  	        confirmationInput.classList.toggle("is-valid", isValid);
  	        confirmationInput.classList.toggle(
  	          "is-invalid",
  	          Boolean(value) && !isValid
  	        );
  	        deleteErrorBox.classList.toggle(
  	          "visible",
  	          Boolean(value) && !isValid
  	        );
  	
  	        if (Boolean(value) && !isValid) {
  	          deleteErrorBox.textContent = "Exact confirmation required.";
  	        }
  	      }
  	
  	      confirmationInput.addEventListener(
  	        "input",
  	        refreshDeleteState
  	      );
  	
  	      cancelDeleteButton.onclick = closeDeleteSafety;
  	      closeDeleteButton.onclick = closeDeleteSafety;
  	
  	      deleteBackdrop.addEventListener("click", function (event) {
  	        if (event.target === deleteBackdrop) {
  	          closeDeleteSafety();
  	        }
  	      });
  	
  	      deleteBackdrop.addEventListener("keydown", function (event) {
  	        if (event.key === "Escape") {
  	          event.preventDefault();
  	          closeDeleteSafety();
  	        }
  	      });
  	
  	      deleteForm.onsubmit = function (event) {
  	        event.preventDefault();
  	
  	        managerBeginLoading(
  	          "Preparing supplier deletion…"
  	        );
  	
  	        if (
  	          String(confirmationInput.value || "").trim() !== "DELETE"
  	        ) {
  	          showDeleteError("Exact confirmation required.");
  	          managerFailLoading(
  	            "Type DELETE exactly to confirm the supplier deletion."
  	          );
  	          confirmationInput.focus();
  	          return;
  	        }
  	
  	        deleteErrorBox.classList.remove("visible");
  	        confirmationInput.disabled = true;
  	        cancelDeleteButton.disabled = true;
  	        closeDeleteButton.disabled = true;
  	        confirmDeleteButton.disabled = true;
  	        confirmDeleteButton.textContent = "Deleting…";
  	
  	        var nextSuppliers = suppliers.filter(function (item, itemIndex) {
  	          return itemIndex !== index;
  	        });
  	
  	        var clearTankPromise = Promise.all(
  	          affectedTanks.map(function (tank) {
  	            return clearSupplierFromTank(tank);
  	          })
  	        );
  	
  	        clearTankPromise
  	          .then(function () {
  	            return managerSaveCompanySuppliers(
  	              company,
  	              nextSuppliers
  	            );
  	          })
  	          .then(function (savedSuppliers) {
  	            suppliers = savedSuppliers;
  	
  	            var nextSelectedIndex = -1;
  	
  	            if (selectedSupplierId && selectedSupplierId !== supplierId) {
  	              nextSelectedIndex = suppliers.findIndex(function (item) {
  	                return managerText(
  	                  managerGet(item, ["SupplierId"], null),
  	                  ""
  	                ) === selectedSupplierId;
  	              });
  	            }
  	
  	            if (nextSelectedIndex < 0 && suppliers.length) {
  	              nextSelectedIndex = Math.min(
  	                index,
  	                suppliers.length - 1
  	              );
  	            }
  	
  	            selectedIndex = nextSelectedIndex;
  	            closeDeleteSafety();
  	            managerRenderDashboard();
  	
  	            if (selectedIndex >= 0) {
  	              loadSupplier(selectedIndex);
  	            } else {
  	              clearForm();
  	            }
  	
  	            managerCompleteLoading(
  	              "Supplier deleted successfully."
  	            );
  	          })
  	          .catch(function (error) {
  	            confirmationInput.disabled = false;
  	            cancelDeleteButton.disabled = false;
  	            closeDeleteButton.disabled = false;
  	            confirmDeleteButton.textContent = "Delete";
  	            refreshDeleteState();
  	
  	            var deleteMessage =
  	              error && error.message
  	                ? error.message
  	                : "Supplier could not be deleted.";
  	
  	            showDeleteError(deleteMessage);
  	            managerFailLoading(deleteMessage);
  	          });
  	      };
  	
  	      setTimeout(function () {
  	        try {
  	          confirmationInput.focus();
  	          confirmationInput.select();
  	        } catch (_) {}
  	      }, 30);
  	    }
  	
  	    function renderList() {
  	      if (!suppliers.length) {
  	        listNode.innerHTML =
  	          '<div style="padding:14px;border:1px dashed rgba(255,255,255,.13);border-radius:12px;color:#718198;font-size:11px;text-align:center;">No suppliers have been created for this company.</div>';
  	        return;
  	      }
  	
  	      var html = "";
  	
  	      for (var index = 0; index < suppliers.length; index++) {
  	        var supplier = suppliers[index];
  	        var meta = [
  	          supplier.Representative,
  	          supplier.ContactNumber,
  	          supplier.OrderEmail || supplier.Email
  	        ].filter(Boolean).join(" · ");
  	
  	        html +=
  	          '<div class="fif-supplier-list-row">' +
  	            '<button type="button" class="fif-supplier-list-item' +
  	            (index === selectedIndex ? " active" : "") +
  	            '" data-supplier-select-index="' + index + '">' +
  	              '<div class="fif-supplier-list-name">' +
  	                managerEscape(supplier.Name) +
  	              '</div>' +
  	              '<div class="fif-supplier-list-meta">' +
  	                managerEscape(
  	                  meta || "No representative or contact details"
  	                ) +
  	              '</div>' +
  	            '</button>' +
  	
  	            '<button type="button" class="fif-supplier-delete" ' +
  	            'data-supplier-delete-index="' + index + '" ' +
  	            'title="Delete" aria-label="Delete ' +
  	            managerEscape(supplier.Name) +
  	            '">' +
  	              managerTrashIconSvg() +
  	            '</button>' +
  	          '</div>';
  	      }
  	
  	      listNode.innerHTML = html;
  	
  	      var selectButtons = listNode.querySelectorAll(
  	        "[data-supplier-select-index]"
  	      );
  	
  	      for (
  	        var selectButtonIndex = 0;
  	        selectButtonIndex < selectButtons.length;
  	        selectButtonIndex++
  	      ) {
  	        selectButtons[selectButtonIndex].onclick = function () {
  	          loadSupplier(
  	            Number(
  	              this.getAttribute("data-supplier-select-index")
  	            )
  	          );
  	        };
  	      }
  	
  	      var deleteButtons = listNode.querySelectorAll(
  	        "[data-supplier-delete-index]"
  	      );
  	
  	      for (
  	        var deleteButtonIndex = 0;
  	        deleteButtonIndex < deleteButtons.length;
  	        deleteButtonIndex++
  	      ) {
  	        deleteButtons[deleteButtonIndex].onclick = function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();
  	
  	          openDeleteSafety(
  	            Number(
  	              this.getAttribute("data-supplier-delete-index")
  	            )
  	          );
  	        };
  	      }
  	    }
  	
  	    overlay.querySelector(".fif-supplier-close").onclick = managerCloseSupplierManager;
  	    overlay.querySelector(".fif-supplier-new").onclick = clearForm;
  	    overlay.querySelector(".fif-supplier-cancel").onclick = clearForm;
  	
  	    overlay.addEventListener("click", function (event) {
  	      if (event.target === overlay) managerCloseSupplierManager();
  	    });
  	
  	    form.onsubmit = function (event) {
  	      event.preventDefault();
  	      clearError();
  	
  	      managerBeginLoading(
  	        selectedIndex >= 0
  	          ? "Saving supplier changes…"
  	          : "Creating supplier…"
  	      );
  	
  	      var name = String(nameInput.value || "").trim();
  	      var representative = String(representativeInput.value || "").trim();
  	      var contactNumber = String(contactInput.value || "").trim();
  	      var email = String(emailInput.value || "").trim();
  	      var orderEmail = String(orderEmailInput.value || "").trim();
  	
  	      if (!name) {
  	        showError("Supplier Name is required.");
  	        managerFailLoading("Supplier Name is required.");
  	        nameInput.focus();
  	        return;
  	      }
  	
  	      if (email && !emailInput.checkValidity()) {
  	        showError("Email is not valid.");
  	        managerFailLoading("The supplier email address is not valid.");
  	        emailInput.focus();
  	        return;
  	      }
  	
  	      if (orderEmail && !orderEmailInput.checkValidity()) {
  	        showError("Order Email is not valid.");
  	        managerFailLoading("The supplier order email address is not valid.");
  	        orderEmailInput.focus();
  	        return;
  	      }
  	
  	      var supplierId = selectedIndex >= 0
  	        ? suppliers[selectedIndex].SupplierId
  	        : managerMakeSupplierId();
  	
  	      var nextSupplier = {
  	        SupplierId: supplierId,
  	        Name: name,
  	        Representative: representative,
  	        ContactNumber: contactNumber,
  	        Email: email,
  	        OrderEmail: orderEmail
  	      };
  	
  	      var duplicate = suppliers.some(function (supplier, index) {
  	        return (
  	          index !== selectedIndex &&
  	          String(supplier.Name || "").trim().toLowerCase() ===
  	          name.toLowerCase()
  	        );
  	      });
  	
  	      if (duplicate) {
  	        showError("A supplier with this name already exists.");
  	        managerFailLoading("A supplier with this name already exists.");
  	        return;
  	      }
  	
  	      var nextSuppliers = suppliers.slice();
  	      if (selectedIndex >= 0) nextSuppliers[selectedIndex] = nextSupplier;
  	      else nextSuppliers.push(nextSupplier);
  	
  	      saveButton.disabled = true;
  	      saveButton.textContent = "Saving…";
  	
  	      managerSaveCompanySuppliers(company, nextSuppliers)
  	        .then(function (savedSuppliers) {
  	          suppliers = savedSuppliers;
  	          selectedIndex = suppliers.findIndex(function (supplier) {
  	            return supplier.SupplierId === supplierId;
  	          });
  	
  	          managerRenderDashboard();
  	          renderList();
  	          loadSupplier(selectedIndex);
  	
  	          managerCompleteLoading(
  	            "Supplier saved successfully."
  	          );
  	        })
  	        .catch(function (error) {
  	          var supplierSaveMessage =
  	            error && error.message
  	              ? error.message
  	              : "Supplier could not be saved.";
  	
  	          showError(supplierSaveMessage);
  	          managerFailLoading(supplierSaveMessage);
  	        })
  	        .then(function () {
  	          saveButton.disabled = false;
  	          saveButton.textContent = selectedIndex >= 0
  	            ? "Save Changes"
  	            : "Save Supplier";
  	        });
  	    };
  	
  	    renderList();
  	    if (suppliers.length) loadSupplier(0);
  	    else clearForm();
  	  }
  	
  	  function managerOpenAssetEditor(
  	    kind,
  	    companyIndex,
  	    tankIndex,
  	    bowserIndex
  	  ) {
  	    managerCloseAssetEditor();
  	
  	    var company = companiesCache[companyIndex];
  	    var tanks = managerTanks(company);
  	    var tank = tanks[tankIndex];
  	    var bowser = null;
  	    var asset = null;
  	    var tableName = "";
  	    var title = "";
  	    var contextName = "";
  	    var isBowser = kind === "bowser";
  	
  	    if (!company || !tank) {
  	      alert("The selected tank is no longer available.");
  	      return;
  	    }
  	
  	    if (isBowser) {
  	      var bowsers = managerBowsers(tank);
  	      bowser = bowsers[bowserIndex];
  	
  	      if (!bowser) {
  	        alert("The selected bowser is no longer available.");
  	        return;
  	      }
  	
  	      asset = bowser;
  	      tableName = "Bowsers";
  	      title = "Edit Bowser";
  	      contextName = managerBowserLabel(bowser, bowserIndex);
  	    } else {
  	      asset = tank;
  	      tableName = "Tanks";
  	      title = "Edit Tank";
  	      contextName = managerTankLabel(tank, tankIndex);
  	    }
  	
  	    var currentName = managerText(
  	      managerFirst(
  	        managerGet(asset, ["Name"], null),
  	        isBowser
  	          ? managerGet(asset, ["Pump"], null)
  	          : managerGet(asset, ["TankName"], null),
  	        contextName
  	      ),
  	      contextName
  	    );
  	
  	    var currentGrade = managerText(
  	      managerFirst(
  	        managerGet(tank, ["Grade"], null),
  	        managerGet(tank, ["FuelGrade"], null)
  	      ),
  	      ""
  	    );
  	
  	    var suppliers = managerSuppliers(company);
  	    var primarySupplier = managerTankPrimarySupplier(company, tank);
  	    var currentWarningThreshold1 = managerTankWarningThreshold1(tank);
  	    var currentWarningThreshold2 = managerTankWarningThreshold2(tank);
  	    var currentOrderThreshold = managerTankOrderThreshold(tank);
  	    var currentDefaultOrderVolume = managerTankDefaultOrderVolume(tank);
  	    var currentCompanyNotificationEmail = managerTankCompanyNotificationEmailSetting(company, tank);
  	    var currentTrailer = managerIsTrailerTank(tank);
  	
  	    var tankFieldsHtml = isBowser
  	      ? ""
  	      :
  	          '<label class="fif-manager-edit-field">' +
  	            '<span class="fif-manager-edit-label">Grade</span>' +
  	            '<select class="fif-manager-edit-input fif-manager-edit-select" ' +
  	            'name="assetGrade" required>' +
  	              managerFuelGradeOptionsHtml(currentGrade) +
  	            "</select>" +
  	          "</label>" +
  	
  	          '<label class="fif-manager-edit-field">' +
  	            '<span class="fif-manager-edit-label">Primary Supplier</span>' +
  	            '<select class="fif-manager-edit-input fif-manager-edit-select" ' +
  	            'name="primarySupplierId"' +
  	            (suppliers.length ? "" : " disabled") +
  	            '>' +
  	              managerSupplierOptionsHtml(company, tank, true) +
  	            "</select>" +
  	          "</label>" +
  	
  	          '<label class="fif-manager-edit-field">' +
  	            '<span class="fif-manager-edit-label">Trailer Tank</span>' +
  	            '<span style="min-height:46px;display:flex;align-items:center;gap:10px;padding:0 13px;border:1px solid rgba(255,255,255,.10);border-radius:13px;background:rgba(255,255,255,.035);box-sizing:border-box;">' +
  	              '<input name="tankTrailer" type="checkbox" ' +
  	              (currentTrailer ? "checked" : "") +
  	              ' style="width:18px;height:18px;accent-color:#d66f35;">' +
  	              '<span style="color:#dbe4ee;font-size:11px;font-weight:750;line-height:1.35;">Mobile tank that may inherit an intertank price and dispense to vehicles.</span>' +
  	            "</span>" +
  	          "</label>" +
  	
  	          '<div class="fif-manager-edit-two-column">' +
  	            '<label class="fif-manager-edit-field">' +
  	              '<span class="fif-manager-edit-label">Fuel Warning Level 1</span>' +
  	              '<input class="fif-manager-edit-input" ' +
  	              'name="warningThreshold1" type="number" min="0" step="0.01" ' +
  	              'value="' + managerEscape(currentWarningThreshold1) + '">' +
  	              '<small class="fif-manager-edit-help">Early warning litres. Emails Supplier and Company when crossed.</small>' +
  	            "</label>" +
  	
  	            '<label class="fif-manager-edit-field">' +
  	              '<span class="fif-manager-edit-label">Fuel Warning Level 2</span>' +
  	              '<input class="fif-manager-edit-input" ' +
  	              'name="warningThreshold2" type="number" min="0" step="0.01" ' +
  	              'value="' + managerEscape(currentWarningThreshold2) + '">' +
  	              '<small class="fif-manager-edit-help">Critical warning litres. Lower than Warning 1 and above the Order Level.</small>' +
  	            "</label>" +
  	          "</div>" +
  	
  	          '<div class="fif-manager-edit-two-column">' +
  	            '<label class="fif-manager-edit-field">' +
  	              '<span class="fif-manager-edit-label">Minimum / Order Level</span>' +
  	              '<input class="fif-manager-edit-input" ' +
  	              'name="orderThreshold" type="number" min="0" step="0.01" ' +
  	              'value="' + managerEscape(currentOrderThreshold) + '">' +
  	              '<small class="fif-manager-edit-help">Actual automatic order threshold in litres.</small>' +
  	            "</label>" +
  	
  	            '<label class="fif-manager-edit-field">' +
  	              '<span class="fif-manager-edit-label">Default Volume Order</span>' +
  	              '<input class="fif-manager-edit-input" ' +
  	              'name="defaultOrderVolume" type="number" min="0" step="0.01" ' +
  	              'value="' + managerEscape(currentDefaultOrderVolume) + '">' +
  	              '<small class="fif-manager-edit-help">Litres ordered when the Minimum / Order Level is crossed.</small>' +
  	            "</label>" +
  	          "</div>" +
  	
  	          '<label class="fif-manager-edit-field">' +
  	            '<span class="fif-manager-edit-label">Company Notification Email(s)</span>' +
  	            '<input class="fif-manager-edit-input" ' +
  	            'name="companyNotificationEmail" type="text" maxlength="500" ' +
  	            'value="' + managerEscape(currentCompanyNotificationEmail) + '" autocomplete="off">' +
  	            '<small class="fif-manager-edit-help">Warnings and orders are emailed to the Primary Supplier and these company address(es). Separate multiple addresses with commas.</small>' +
  	          "</label>";
  	
  	    var overlay = document.createElement("div");
  	    overlay.id = MANAGER_EDIT_OVERLAY_ID;
  	    overlay.setAttribute("role", "dialog");
  	    overlay.setAttribute("aria-modal", "true");
  	    overlay.setAttribute("aria-label", title);
  	
  	    overlay.innerHTML =
  	      '<form class="fif-manager-edit-card" novalidate>' +
  	        '<div class="fif-manager-edit-head">' +
  	          '<div class="fif-manager-edit-title">' +
  	            managerEscape(title) +
  	          "</div>" +
  	          '<div class="fif-manager-edit-subtitle">' +
  	            managerEscape(contextName) +
  	            (isBowser
  	              ? " — the bowser grade is inherited from its parent tank."
  	              : " — edit the tank identity, supplier and stock ordering settings.") +
  	          "</div>" +
  	        "</div>" +
  	
  	        '<div class="fif-manager-edit-body">' +
  	          '<label class="fif-manager-edit-field">' +
  	            '<span class="fif-manager-edit-label">Name</span>' +
  	            '<input class="fif-manager-edit-input" ' +
  	            'name="assetName" type="text" maxlength="120" ' +
  	            'value="' + managerEscape(currentName) + '" autocomplete="off">' +
  	          "</label>" +
  	
  	          tankFieldsHtml +
  	
  	          '<div class="fif-manager-edit-note">' +
  	            (isBowser
  	              ? "Only the bowser Name can be allocated here. Its Grade always follows the parent tank automatically."
  	              : (suppliers.length
  	                  ? "The supplier becomes Primary. Warning 1, Warning 2 and the Minimum / Order Level form the tank's three-stage fuel stock notification ladder."
  	                  : "Create a company supplier before enabling stock warning or order thresholds.")) +
  	          "</div>" +
  	
  	          '<div class="fif-manager-edit-error" role="alert"></div>' +
  	        "</div>" +
  	
  	        '<div class="fif-manager-edit-actions">' +
  	          '<button type="button" class="fif-manager-edit-action fif-manager-edit-cancel">Cancel</button>' +
  	          '<button type="submit" class="fif-manager-edit-action fif-manager-edit-save">Save Changes</button>' +
  	        "</div>" +
  	      "</form>";
  	
  	    managerOverlay.appendChild(overlay);
  	    managerThemeSelects(overlay);
  	
  	    var form = overlay.querySelector("form");
  	    var nameInput = overlay.querySelector('[name="assetName"]');
  	    var gradeInput = overlay.querySelector('[name="assetGrade"]');
  	    var primarySupplierInput = overlay.querySelector('[name="primarySupplierId"]');
  	    var warningThreshold1Input = overlay.querySelector('[name="warningThreshold1"]');
  	    var warningThreshold2Input = overlay.querySelector('[name="warningThreshold2"]');
  	    var orderThresholdInput = overlay.querySelector('[name="orderThreshold"]');
  	    var defaultOrderVolumeInput = overlay.querySelector('[name="defaultOrderVolume"]');
  	    var companyNotificationEmailInput = overlay.querySelector('[name="companyNotificationEmail"]');
  	    var tankTrailerInput = overlay.querySelector('[name="tankTrailer"]');
  	    var errorBox = overlay.querySelector(".fif-manager-edit-error");
  	    var saveButton = overlay.querySelector(".fif-manager-edit-save");
  	    var cancelButton = overlay.querySelector(".fif-manager-edit-cancel");
  	
  	    function showError(message) {
  	      if (!errorBox) return;
  	      errorBox.textContent = String(message || "Save failed.");
  	      errorBox.style.display = "block";
  	    }
  	
  	    if (cancelButton) cancelButton.onclick = managerCloseAssetEditor;
  	
  	    overlay.addEventListener("click", function (event) {
  	      if (event.target === overlay) managerCloseAssetEditor();
  	    });
  	
  	    form.onsubmit = function (event) {
  	      event.preventDefault();
  	
  	      managerBeginLoading(
  	        isBowser
  	          ? "Saving bowser changes…"
  	          : "Saving tank changes…"
  	      );
  	
  	      var nextName = String(nameInput.value || "").trim();
  	      if (!nextName) {
  	        showError("Name is required.");
  	        managerFailLoading("Name is required.");
  	        nameInput.focus();
  	        return;
  	      }
  	
  	      var nextGrade = currentGrade;
  	      var nextPrimarySupplierId = "";
  	      var nextPrimarySupplierName = "";
  	      var nextWarningThreshold1 = currentWarningThreshold1;
  	      var nextWarningThreshold2 = currentWarningThreshold2;
  	      var nextOrderThreshold = currentOrderThreshold;
  	      var nextDefaultOrderVolume = currentDefaultOrderVolume;
  	      var nextCompanyNotificationEmail = currentCompanyNotificationEmail;
  	      var nextTrailer = currentTrailer;
  	
  	      if (!isBowser) {
  	        nextGrade = managerCanonicalFuelGrade(
  	          String(gradeInput.value || "").trim()
  	        );
  	
  	        if (!nextGrade) {
  	          showError("Please select one of the approved fuel grades.");
  	        managerFailLoading("Please select one of the approved fuel grades.");
  	          gradeInput.focus();
  	          return;
  	        }
  	
  	        nextPrimarySupplierId = primarySupplierInput
  	          ? String(primarySupplierInput.value || "").trim()
  	          : "";
  	
  	        var selectedSupplier = managerFindSupplier(
  	          company,
  	          nextPrimarySupplierId,
  	          ""
  	        );
  	
  	        nextPrimarySupplierName = selectedSupplier
  	          ? selectedSupplier.Name
  	          : "";
  	
  	        nextWarningThreshold1 = managerNumber(
  	          warningThreshold1Input ? warningThreshold1Input.value : 0,
  	          NaN
  	        );
  	
  	        nextWarningThreshold2 = managerNumber(
  	          warningThreshold2Input ? warningThreshold2Input.value : 0,
  	          NaN
  	        );
  	
  	        nextOrderThreshold = managerNumber(
  	          orderThresholdInput ? orderThresholdInput.value : 0,
  	          NaN
  	        );
  	
  	        nextDefaultOrderVolume = managerNumber(
  	          defaultOrderVolumeInput ? defaultOrderVolumeInput.value : 0,
  	          NaN
  	        );
  	        nextCompanyNotificationEmail = companyNotificationEmailInput
  	          ? String(companyNotificationEmailInput.value || "").trim()
  	          : "";
  	
  	        nextTrailer = !!(
  	          tankTrailerInput &&
  	          tankTrailerInput.checked
  	        );
  	
  	        if (!Number.isFinite(nextWarningThreshold1) || nextWarningThreshold1 < 0) {
  	          showError("Fuel Warning Level 1 must be zero or a positive number.");
  	          managerFailLoading("Fuel Warning Level 1 must be zero or a positive number.");
  	          warningThreshold1Input.focus();
  	          return;
  	        }
  	
  	        if (!Number.isFinite(nextWarningThreshold2) || nextWarningThreshold2 < 0) {
  	          showError("Fuel Warning Level 2 must be zero or a positive number.");
  	          managerFailLoading("Fuel Warning Level 2 must be zero or a positive number.");
  	          warningThreshold2Input.focus();
  	          return;
  	        }
  	
  	        if (!Number.isFinite(nextOrderThreshold) || nextOrderThreshold < 0) {
  	          showError("Minimum Allowed Quantity must be zero or a positive number.");
  	        managerFailLoading("Minimum Allowed Quantity must be zero or a positive number.");
  	          orderThresholdInput.focus();
  	          return;
  	        }
  	
  	        if (!Number.isFinite(nextDefaultOrderVolume) || nextDefaultOrderVolume < 0) {
  	          showError("Default Volume Order must be zero or a positive number.");
  	        managerFailLoading("Default Volume Order must be zero or a positive number.");
  	          defaultOrderVolumeInput.focus();
  	          return;
  	        }
  	
  	        var tankCapacity = managerNumber(
  	          managerFirst(
  	            managerGet(tank, ["Capacity"], null),
  	            managerGet(tank, ["capacity"], null)
  	          ),
  	          0
  	        );
  	
  	        if (tankCapacity > 0 && nextWarningThreshold1 > tankCapacity) {
  	          showError("Fuel Warning Level 1 cannot exceed the tank capacity.");
  	          managerFailLoading("Fuel Warning Level 1 cannot exceed the tank capacity.");
  	          warningThreshold1Input.focus();
  	          return;
  	        }
  	
  	        if (tankCapacity > 0 && nextWarningThreshold2 > tankCapacity) {
  	          showError("Fuel Warning Level 2 cannot exceed the tank capacity.");
  	          managerFailLoading("Fuel Warning Level 2 cannot exceed the tank capacity.");
  	          warningThreshold2Input.focus();
  	          return;
  	        }
  	
  	        if (tankCapacity > 0 && nextOrderThreshold > tankCapacity) {
  	          showError("Minimum / Order Level cannot exceed the tank capacity.");
  	        managerFailLoading("Minimum / Order Level cannot exceed the tank capacity.");
  	          orderThresholdInput.focus();
  	          return;
  	        }
  	
  	        if (tankCapacity > 0 && nextDefaultOrderVolume > tankCapacity) {
  	          showError("Default Volume Order cannot exceed the tank capacity.");
  	        managerFailLoading("Default Volume Order cannot exceed the tank capacity.");
  	          defaultOrderVolumeInput.focus();
  	          return;
  	        }
  	
  	        if (nextOrderThreshold > 0 && nextDefaultOrderVolume <= 0) {
  	          showError("Set a Default Volume Order when the Minimum / Order Level is enabled.");
  	          managerFailLoading("Set a Default Volume Order when the Minimum / Order Level is enabled.");
  	          defaultOrderVolumeInput.focus();
  	          return;
  	        }
  	
  	        if (nextWarningThreshold1 > 0 && nextWarningThreshold2 > 0 && nextWarningThreshold1 <= nextWarningThreshold2) {
  	          showError("Fuel Warning Level 1 must be higher than Fuel Warning Level 2.");
  	          managerFailLoading("Fuel Warning Level 1 must be higher than Fuel Warning Level 2.");
  	          warningThreshold1Input.focus();
  	          return;
  	        }
  	
  	        if (nextWarningThreshold2 > 0 && nextOrderThreshold > 0 && nextWarningThreshold2 <= nextOrderThreshold) {
  	          showError("Fuel Warning Level 2 must be higher than the Minimum / Order Level.");
  	          managerFailLoading("Fuel Warning Level 2 must be higher than the Minimum / Order Level.");
  	          warningThreshold2Input.focus();
  	          return;
  	        }
  	
  	        if (nextWarningThreshold1 > 0 && nextWarningThreshold2 <= 0 && nextOrderThreshold > 0 && nextWarningThreshold1 <= nextOrderThreshold) {
  	          showError("Fuel Warning Level 1 must be higher than the Minimum / Order Level.");
  	          managerFailLoading("Fuel Warning Level 1 must be higher than the Minimum / Order Level.");
  	          warningThreshold1Input.focus();
  	          return;
  	        }
  	
  	        var anyFuelThresholdEnabled = nextWarningThreshold1 > 0 || nextWarningThreshold2 > 0 || nextOrderThreshold > 0;
  	
  	        if (anyFuelThresholdEnabled && !selectedSupplier) {
  	          showError("Select a Primary Supplier before enabling fuel warning or order thresholds.");
  	          managerFailLoading("A Primary Supplier is required for fuel stock notifications.");
  	          if (primarySupplierInput) primarySupplierInput.focus();
  	          return;
  	        }
  	
  	        if (anyFuelThresholdEnabled && !managerTankOrderRecipient(selectedSupplier)) {
  	          showError("The Primary Supplier needs an Order Email or Email address before fuel thresholds can be enabled.");
  	          managerFailLoading("The Primary Supplier has no email address for fuel notifications.");
  	          if (primarySupplierInput) primarySupplierInput.focus();
  	          return;
  	        }
  	
  	        var companyEmailList = managerUniqueEmailRecipients([nextCompanyNotificationEmail]);
  	        if (anyFuelThresholdEnabled && !companyEmailList.length) {
  	          showError("Company Notification Email is required because fuel warnings and orders are sent to both Supplier and Company.");
  	          managerFailLoading("Company Notification Email is required for fuel stock notifications.");
  	          if (companyNotificationEmailInput) companyNotificationEmailInput.focus();
  	          return;
  	        }
  	
  	        nextCompanyNotificationEmail = companyEmailList.join(", ");
  	      }
  	
  	      if (errorBox) {
  	        errorBox.style.display = "none";
  	        errorBox.textContent = "";
  	      }
  	
  	      saveButton.disabled = true;
  	      saveButton.textContent = "Saving…";
  	
  	      var changes = isBowser
  	        ? {
  	            Name: nextName,
  	            Grade: currentGrade
  	          }
  	        : {
  	            Name: nextName,
  	            Grade: nextGrade,
  	            PrimarySupplierId: nextPrimarySupplierId,
  	            PrimarySupplier: nextPrimarySupplierName,
  	            FuelWarningThreshold1: nextWarningThreshold1,
  	            FuelWarningThreshold2: nextWarningThreshold2,
  	            OrderThreshold: nextOrderThreshold,
  	            DefaultOrderVolume: nextDefaultOrderVolume,
  	            CompanyNotificationEmail: nextCompanyNotificationEmail,
  	            Trailer: nextTrailer
  	          };
  	
  	      managerSaveEditableAsset(tableName, asset, changes)
  	        .then(function (saved) {
  	          asset.Name = nextName;
  	
  	          if (isBowser) {
  	            asset.Grade = currentGrade;
  	          } else {
  	            asset.Grade = nextGrade;
  	            asset.PrimarySupplierId = nextPrimarySupplierId;
  	            asset.PrimarySupplier = nextPrimarySupplierName;
  	            asset.FuelWarningThreshold1 = nextWarningThreshold1;
  	            asset.FuelWarningThreshold2 = nextWarningThreshold2;
  	            asset.OrderThreshold = nextOrderThreshold;
  	            asset.DefaultOrderVolume = nextDefaultOrderVolume;
  	            asset.CompanyNotificationEmail = nextCompanyNotificationEmail;
  	            asset.Trailer = nextTrailer;
  	
  	            var bowserRows = managerBowsers(tank);
  	            for (var index = 0; index < bowserRows.length; index++) {
  	              bowserRows[index].Grade = nextGrade;
  	            }
  	          }
  	
  	          if (Object.prototype.hasOwnProperty.call(asset, "TankName")) {
  	            asset.TankName = nextName;
  	          }
  	
  	          if (!isBowser && Object.prototype.hasOwnProperty.call(asset, "FuelGrade")) {
  	            asset.FuelGrade = nextGrade;
  	          }
  	
  	          if (saved && typeof saved === "object") {
  	            Object.keys(saved).forEach(function (key) {
  	              asset[key] = saved[key];
  	            });
  	          }
  	
  	          return isBowser
  	            ? Promise.resolve()
  	            : managerSynchronizeBowserGrades(tank, nextGrade);
  	        })
  	        .then(function () {
  	          managerCloseAssetEditor();
  	          managerRenderDashboard();
  	
  	          managerCompleteLoading(
  	            isBowser
  	              ? "Bowser changes saved successfully."
  	              : "Tank changes saved successfully."
  	          );
  	        })
  	        .catch(function (error) {
  	          var assetSaveMessage =
  	            error && error.message
  	              ? error.message
  	              : "The record could not be saved.";
  	
  	          showError(assetSaveMessage);
  	          managerFailLoading(assetSaveMessage);
  	
  	          saveButton.disabled = false;
  	          saveButton.textContent = "Save Changes";
  	        });
  	    };
  	
  	    setTimeout(function () {
  	      try {
  	        nameInput.focus();
  	        nameInput.select();
  	      } catch (_) {}
  	    }, 0);
  	  }
  	
  	  function managerClickHandler(event) {
  	    var actionNode =
  	      event.target && event.target.closest
  	        ? event.target.closest("[data-fuel-action]")
  	        : null;
  	
  	    if (!actionNode || !hostEl.contains(actionNode)) {
  	      managerClosePrintablesMenus();
  	      return;
  	    }
  	
  	    event.preventDefault();
  	    event.stopPropagation();
  	
  	    var companyIndex = Number(
  	      actionNode.getAttribute("data-company-index")
  	    );
  	
  	    var tankIndex = Number(
  	      actionNode.getAttribute("data-tank-index")
  	    );
  	
  	    var bowserIndex = Number(
  	      actionNode.getAttribute("data-bowser-index")
  	    );
  	
  	    var action = actionNode.getAttribute(
  	      "data-fuel-action"
  	    );
  	
  	    var company = companiesCache[companyIndex];
  	
  	    if (action === "toggle-company") {
  	      if (!company) return;
  	
  	      var companyKey = managerCompanyKey(company, companyIndex);
  	      var section = actionNode.closest(".fif-manager-company");
  	      var collapsed = !(section && section.classList.contains("is-collapsed"));
  	
  	      managerCompanyCollapsed[companyKey] = collapsed;
  	      managerSaveCompanyCollapseState();
  	
  	      if (section) {
  	        section.classList.toggle("is-collapsed", collapsed);
  	      }
  	
  	      actionNode.setAttribute(
  	        "aria-expanded",
  	        collapsed ? "false" : "true"
  	      );
  	
  	      var caret = actionNode.querySelector(".fif-manager-company-caret");
  	      if (caret) caret.textContent = collapsed ? "›" : "⌄";
  	      return;
  	    }
  	
  	    if (action === "manage-suppliers") {
  	      if (!company) {
  	        alert("The selected company is no longer available.");
  	        return;
  	      }
  	
  	      managerOpenSupplierManager(companyIndex);
  	      return;
  	    }
  	
  	    var tanks = managerTanks(company);
  	    var tank = tanks[tankIndex];
  	
  	    if (!company || !tank) {
  	      alert(
  	        "The selected company or tank is no longer available. " +
  	        "Close and reopen Fuel Management."
  	      );
  	      return;
  	    }
  	
  	    var card = actionNode.closest(
  	      ".fif-manager-tank-card"
  	    );
  	
  	    var gaugeElement = card
  	      ? card.querySelector("[data-tank-gauge]")
  	      : null;
  	
  	    if (action === "toggle-printables") {
  	      managerTogglePrintablesMenu(actionNode);
  	      return;
  	    }
  	
  	    managerClosePrintablesMenus();
  	
  	    if (action === "select-bowser-qr") {
  	      managerOpenBowserQrSelector(
  	        company,
  	        tank,
  	        companyIndex,
  	        tankIndex
  	      );
  	      return;
  	    }
  	
  	    if (action === "print-tank-blank-form") {
  	      managerOpenTankBlankForm(
  	        company,
  	        tank,
  	        companyIndex,
  	        tankIndex
  	      );
  	      return;
  	    }
  	
  	    if (action === "edit-tank") {
  	      managerOpenAssetEditor(
  	        "tank",
  	        companyIndex,
  	        tankIndex,
  	        bowserIndex
  	      );
  	      return;
  	    }
  	
  	    if (action === "edit-bowser") {
  	      managerOpenAssetEditor(
  	        "bowser",
  	        companyIndex,
  	        tankIndex,
  	        bowserIndex
  	      );
  	      return;
  	    }
  	
  	    if (action === "delivery") {
  	      managerOpenDelivery(
  	        company,
  	        tank,
  	        gaugeElement
  	      );
  	      return;
  	    }
  	
  	    if (action === "capture") {
  	      var bowsers = managerBowsers(tank);
  	      var bowser = bowsers[bowserIndex];
  	
  	      if (!bowser) {
  	        alert(
  	          "The selected fuel dispenser is no longer available. " +
  	          "Close and reopen Fuel Management."
  	        );
  	        return;
  	      }
  	
  	      managerOpenCapture(
  	        company,
  	        tank,
  	        bowser,
  	        gaugeElement
  	      );
  	    }
  	  }
  	
  	  function managerDestroyRoot() {
  	    if (destroyed) return;
  	
  	    destroyed = true;
  	
  	    try {
  	      if (managerOtherDrawerObserver) {
  	        managerOtherDrawerObserver.disconnect();
  	        managerOtherDrawerObserver = null;
  	      }
  	    } catch (_) {}
  	
  	    try {
  	      if (managerLogoutWatchTimer !== null) {
  	        window.clearInterval(managerLogoutWatchTimer);
  	        managerLogoutWatchTimer = null;
  	      }
  	    } catch (_) {}
  	
  	    try {
  	      if (managerAtgRefreshTimer !== null) {
  	        window.clearInterval(managerAtgRefreshTimer);
  	        managerAtgRefreshTimer = null;
  	      }
  	    } catch (_) {}
  	
  	    try {
  	      if (managerLogoutClickHandler) {
  	        document.removeEventListener(
  	          "click",
  	          managerLogoutClickHandler,
  	          true
  	        );
  	      }
  	
  	      if (managerLogoutEventHandler) {
  	        window.removeEventListener(
  	          "logout",
  	          managerLogoutEventHandler,
  	          true
  	        );
  	        window.removeEventListener(
  	          "fif:logout",
  	          managerLogoutEventHandler,
  	          true
  	        );
  	        window.removeEventListener(
  	          "user:logout",
  	          managerLogoutEventHandler,
  	          true
  	        );
  	      }
  	
  	      if (managerStorageHandler) {
  	        window.removeEventListener(
  	          "storage",
  	          managerStorageHandler,
  	          true
  	        );
  	      }
  	    } catch (_) {}
  	
  	    try {
  	      hostEl.removeEventListener(
  	        "click",
  	        managerClickHandler
  	      );
  	    } catch (_) {}
  	
  	    managerRemoveLoadingOverlay();
  	    managerCloseOverlays();
  	
  	    try {
  	      if (
  	        managerOverlay &&
  	        managerOverlay.parentNode
  	      ) {
  	        managerOverlay.parentNode.removeChild(
  	          managerOverlay
  	        );
  	      }
  	    } catch (_) {}
  	
  	    try {
  	      hostEl.__fifFuelManagerCleanup = null;
  	      managerOverlay.__fifFuelManagerCleanup = null;
  	    } catch (_) {}
  	
  	    try {
  	      if (
  	        window.__FIF_CLOSE_FUEL_MANAGER__ ===
  	        managerDestroyRoot
  	      ) {
  	        window.__FIF_CLOSE_FUEL_MANAGER__ = null;
  	      }
  	    } catch (_) {}
  	  }
  	
  	  hostEl.addEventListener(
  	    "click",
  	    managerClickHandler
  	  );
  	
  	  hostEl.__fifFuelManagerCleanup =
  	    managerDestroyRoot;
  	
  	  managerOverlay.__fifFuelManagerCleanup =
  	    managerDestroyRoot;
  	
  	  window.__FIF_CLOSE_FUEL_MANAGER__ =
  	    managerDestroyRoot;
  	
  	  managerRenderDashboard();
  	
  	  managerRefreshAtgRelations();
  	  managerAtgRefreshTimer = window.setInterval(
  	    managerRefreshAtgRelations,
  	    60 * 1000
  	  );
  	
  	
  	
  	/*
  	 * Manager-scope utility helpers used by Service / Maintenance email
  	 * notification processing.
  	 *
  	 * These deliberately live outside openFuelCapture(). The Fuel Capture
  	 * workflow has its own local helpers with similar names, but the
  	 * notification functions below execute in the manager scope.
  	 */
  	function toArray(value) {
  	  if (Array.isArray(value)) return value.slice();
  	  if (value === null || value === undefined || value === "") return [];
  	
  	  if (value && typeof value === "object") {
  	    if (Array.isArray(value.data)) return value.data.slice();
  	    if (Array.isArray(value.items)) return value.items.slice();
  	
  	    var length = Number(value.length);
  	    if (Number.isFinite(length) && length >= 0) {
  	      var rows = [];
  	      for (var index = 0; index < length; index++) {
  	        if (value[index] !== undefined) rows.push(value[index]);
  	      }
  	      return rows;
  	    }
  	
  	    try {
  	      if (
  	        typeof Symbol !== "undefined" &&
  	        typeof value[Symbol.iterator] === "function"
  	      ) {
  	        return Array.from(value);
  	      }
  	    } catch (_) {}
  	
  	    return [value];
  	  }
  	
  	  return [value];
  	}
  	
  	function relationCollectionToArray(value) {
  	  return toArray(value);
  	}
  	
  	function toNumber(value, fallback) {
  	  var raw = managerDescriptorValue(value);
  	
  	  if (raw === null || raw === undefined || raw === "") {
  	    return fallback;
  	  }
  	
  	  var parsed = Number(
  	    String(raw)
  	      .trim()
  	      .replace(/\s/g, "")
  	      .replace(/,/g, ".")
  	  );
  	
  	  return Number.isFinite(parsed) ? parsed : fallback;
  	}
  	
  	function displayNumber(value, decimals) {
  	  var parsed = toNumber(value, 0);
  	  var precision = Math.max(0, Math.round(toNumber(decimals, 0)));
  	  return Number(parsed).toFixed(precision);
  	}
  	
  	function deepClone(value) {
  	  try {
  	    return JSON.parse(JSON.stringify(value));
  	  } catch (_) {
  	    if (Array.isArray(value)) return value.slice();
  	    if (value && typeof value === "object") return Object.assign({}, value);
  	    return value;
  	  }
  	}
  	
  	function getVehicleReadingUnit(vehicle) {
  	  if (!vehicle || typeof vehicle !== "object") return "km";
  	
  	  /*
  	   * Tractor.CounterType is canonical. Descriptor and legacy fallbacks
  	   * are retained because relation rows can be partial.
  	   */
  	  var counterType = managerText(
  	    managerDescriptorValue(
  	      managerFirst(
  	        managerGet(vehicle, ["CounterType"], null),
  	        managerGet(vehicle, ["Data", "Vehicle", "Usage", "CounterType"], null),
  	        managerGet(vehicle, ["Data", "Vehicle", "CounterType"], null),
  	        managerGet(vehicle, ["MeterUnit"], null),
  	        managerGet(vehicle, ["OdometerUnit"], null),
  	        managerGet(vehicle, ["Data", "Vehicle", "MeterUnit"], null),
  	        managerGet(vehicle, ["Data", "Vehicle", "OdometerUnit"], null)
  	      )
  	    ),
  	    ""
  	  ).trim().toLowerCase();
  	
  	  var compact = counterType.replace(/[^a-z0-9]/g, "");
  	
  	  if (
  	    compact === "h" ||
  	    compact === "hr" ||
  	    compact === "hrs" ||
  	    compact.indexOf("hour") >= 0 ||
  	    compact.indexOf("hobbs") >= 0 ||
  	    compact === "time"
  	  ) {
  	    return "h";
  	  }
  	
  	  if (
  	    compact === "km" ||
  	    compact.indexOf("kilomet") >= 0 ||
  	    compact.indexOf("distance") >= 0 ||
  	    compact.indexOf("odometer") >= 0
  	  ) {
  	    return "km";
  	  }
  	
  	  var usesHours = managerDescriptorValue(
  	    managerFirst(
  	      managerGet(vehicle, ["UsesHours"], null),
  	      managerGet(vehicle, ["Uses_Hours"], null),
  	      managerGet(vehicle, ["HourBased"], null),
  	      managerGet(vehicle, ["Hour_Based"], null),
  	      managerGet(vehicle, ["Data", "Vehicle", "UsesHours"], null),
  	      managerGet(vehicle, ["Data", "Vehicle", "Uses_Hours"], null),
  	      managerGet(vehicle, ["Data", "Vehicle", "HourBased"], null),
  	      managerGet(vehicle, ["Data", "Vehicle", "Hour_Based"], null)
  	    )
  	  );
  	
  	  if (
  	    usesHours === true ||
  	    String(usesHours || "").toLowerCase() === "true" ||
  	    String(usesHours || "") === "1"
  	  ) {
  	    return "h";
  	  }
  	
  	  /*
  	   * Final compatibility fallback for old machinery records which did
  	   * not yet have CounterType populated.
  	   */
  	  var identity = [
  	    managerGet(vehicle, ["Name"], ""),
  	    managerGet(vehicle, ["ID"], ""),
  	    managerGet(vehicle, ["FID"], ""),
  	    managerGet(vehicle, ["TractorID"], ""),
  	    managerGet(vehicle, ["Type"], ""),
  	    managerGet(vehicle, ["Category"], ""),
  	    managerGet(vehicle, ["Class"], ""),
  	    managerDescriptorValue(
  	      managerGet(
  	        vehicle,
  	        ["Data", "Vehicle", "Classification", "VehicleType"],
  	        ""
  	      )
  	    ),
  	    managerDescriptorValue(
  	      managerGet(vehicle, ["Data", "Vehicle", "Identity", "Make"], "")
  	    ),
  	    managerDescriptorValue(
  	      managerGet(vehicle, ["Data", "Vehicle", "Identity", "Model"], "")
  	    )
  	  ].map(function (item) {
  	    return managerText(managerDescriptorValue(item), "");
  	  }).join(" ").toLowerCase();
  	
  	  if (
  	    /\b(tractor|loader|excavator|forklift|generator|dozer|grader|harvester|combine|sprayer|telehandler|backhoe|compressor|plant|machine)\b/.test(identity)
  	  ) {
  	    return "h";
  	  }
  	
  	  return "km";
  	}
  	
  	
  	function managerServiceCollectionValue(value) {
  	  if (value === null || value === undefined) return value;
  	
  	  if (Array.isArray(value)) {
  	    return value;
  	  }
  	
  	  if (typeof value === "object") {
  	    var keys = ["value", "Value", "current", "Current"];
  	
  	    for (var index = 0; index < keys.length; index++) {
  	      var key = keys[index];
  	
  	      if (
  	        Object.prototype.hasOwnProperty.call(value, key) &&
  	        value[key] !== null &&
  	        value[key] !== undefined
  	      ) {
  	        return managerServiceCollectionValue(value[key]);
  	      }
  	    }
  	  }
  	
  	  return value;
  	}
  	
  	function managerServiceArray(value) {
  	  value = managerServiceCollectionValue(value);
  	
  	  if (Array.isArray(value)) return value.slice();
  	
  	  if (value && typeof value === "object") {
  	    if (Array.isArray(value.data)) return value.data.slice();
  	    if (Array.isArray(value.items)) return value.items.slice();
  	  }
  	
  	  return [];
  	}
  	
  	function managerServiceProviders(companyObj) {
  	  var rows = managerServiceArray(
  	    managerFirst(
  	      managerGet(companyObj, ["Manifest", "ServiceProviders"], null),
  	      managerGet(companyObj, ["Data", "Manifest", "ServiceProviders"], null)
  	    )
  	  );
  	
  	  return rows.map(function (provider) {
  	    provider = provider && typeof provider === "object" ? provider : {};
  	    return {
  	      ProviderId: managerText(
  	        managerFirst(
  	          provider.ProviderId,
  	          provider.Id,
  	          provider.objectId,
  	          provider.Name,
  	          provider.CompanyName
  	        ),
  	        ""
  	      ).trim(),
  	      Name: managerText(
  	        managerFirst(provider.Name, provider.Company, provider.CompanyName, "Service Provider"),
  	        "Service Provider"
  	      ).trim(),
  	      TradingName: managerText(provider.TradingName, "").trim(),
  	      Status: managerText(provider.Status, "Active").trim(),
  	      Preferred: managerBoolean(provider.Preferred, false),
  	      Contact: {
  	        Email: managerText(
  	          managerFirst(
  	            managerGet(provider, ["Contact", "Email"], null),
  	            provider.Email
  	          ),
  	          ""
  	        ).trim()
  	      }
  	    };
  	  });
  	}
  	
  	function managerServiceProviderLabel(provider) {
  	  return managerText(
  	    managerFirst(
  	      provider && provider.TradingName,
  	      provider && provider.Name,
  	      "Service Provider"
  	    ),
  	    "Service Provider"
  	  ).trim();
  	}
  	
  	function managerServiceProviderById(companyObj, providerId) {
  	  var wanted = managerText(providerId, "").trim();
  	  if (!wanted) return null;
  	  var wantedLower = wanted.toLowerCase();
  	  var providers = managerServiceProviders(companyObj);
  	
  	  for (var index = 0; index < providers.length; index++) {
  	    var provider = providers[index];
  	    if (
  	      managerText(provider.ProviderId, "").trim() === wanted ||
  	      managerServiceProviderLabel(provider).toLowerCase() === wantedLower ||
  	      managerText(provider.Name, "").trim().toLowerCase() === wantedLower
  	    ) {
  	      return provider;
  	    }
  	  }
  	  return null;
  	}
  	
  	function managerVehicleRegistration(vehicle) {
  	  return managerText(
  	    managerFirst(
  	      managerDescriptorValue(
  	        managerGet(vehicle, ["Data", "Vehicle", "Identity", "Registration"], null)
  	      ),
  	      managerGet(vehicle, ["Registration"], null),
  	      managerGet(vehicle, ["ID"], null),
  	      managerGet(vehicle, ["FID"], null),
  	      "Vehicle"
  	    ),
  	    "Vehicle"
  	  ).trim();
  	}
  	
  	function managerVehicleIdentityDetails(vehicle) {
  	  function identityValue(paths, fallback) {
  	    for (var index = 0; index < paths.length; index++) {
  	      var raw = managerDescriptorValue(managerGet(vehicle, paths[index], null));
  	      if (raw === null || raw === undefined) continue;
  	      var value = managerText(raw, "").trim();
  	      if (value) return value;
  	    }
  	    return fallback || "Not captured";
  	  }
  	
  	  return {
  	    make: identityValue([
  	      ["Data", "Vehicle", "Identity", "Make"],
  	      ["Data", "Vehicle", "Make"],
  	      ["Make"]
  	    ]),
  	    model: identityValue([
  	      ["Data", "Vehicle", "Identity", "Model"],
  	      ["Data", "Vehicle", "Model"],
  	      ["Model"]
  	    ]),
  	    year: identityValue([
  	      ["Data", "Vehicle", "Identity", "Year"],
  	      ["Data", "Vehicle", "Year"],
  	      ["Year"]
  	    ]),
  	    vin: identityValue([
  	      ["Data", "Vehicle", "Identity", "VIN"],
  	      ["Data", "Vehicle", "VIN"],
  	      ["VIN"]
  	    ]),
  	    engineNumber: identityValue([
  	      ["Data", "Vehicle", "Identity", "EngineNumber"],
  	      ["Data", "Vehicle", "EngineNumber"],
  	      ["Data", "Vehicle", "Engine_Number"],
  	      ["EngineNumber"],
  	      ["Engine_Number"]
  	    ])
  	  };
  	}
  	
  	function managerVehicleLabel(vehicle) {
  	  return managerText(
  	    managerFirst(
  	      managerGet(vehicle, ["VehicleName"], null),
  	      managerGet(vehicle, ["Name"], null),
  	      managerGet(vehicle, ["ID"], null),
  	      managerVehicleRegistration(vehicle)
  	    ),
  	    "Vehicle"
  	  ).trim();
  	}
  	
  	function managerCompanyLabel(companyObj) {
  	  return managerText(
  	    managerFirst(
  	      managerGet(companyObj, ["CompanyName"], null),
  	      managerGet(companyObj, ["Name"], null),
  	      managerGet(companyObj, ["ID"], null),
  	      "Company"
  	    ),
  	    "Company"
  	  ).trim();
  	}
  	
  	function managerServiceSetup(vehicle) {
  	  var service = managerGet(vehicle, ["Data", "Service"], {}) || {};
  	  var schedule = managerGet(service, ["Schedule"], {}) || {};
  	  var notifications = managerGet(service, ["Notifications"], {}) || {};
  	  var current = managerGet(service, ["Current"], {}) || {};
  	  var history = managerGet(service, ["History"], {}) || {};
  	  var unit = getVehicleReadingUnit(vehicle);
  	  var hours = unit === "h";
  	
  	  return {
  	    unit: unit,
  	    notifyProvider: managerBoolean(
  	      managerDescriptorValue(notifications.NotifyServiceProvider),
  	      false
  	    ),
  	    notifyCompany: managerBoolean(
  	      managerDescriptorValue(notifications.NotifyCompany),
  	      false
  	    ),
  	    providerId: managerText(
  	      managerDescriptorValue(
  	        managerFirst(notifications.ServiceProviderId, notifications.ProviderId)
  	      ),
  	      ""
  	    ).trim(),
  	    providerName: managerText(
  	      managerDescriptorValue(
  	        managerFirst(notifications.ServiceProviderName, notifications.ProviderName)
  	      ),
  	      ""
  	    ).trim(),
  	    interval: Math.max(
  	      0,
  	      managerNumber(
  	        managerDescriptorValue(
  	          managerFirst(
  	            hours ? schedule.ServiceIntervalHours : schedule.ServiceIntervalKM,
  	            hours ? schedule.Service_Interval_Hours : schedule.Service_Interval_KM,
  	            !hours ? service.Service_Interval : null
  	          )
  	        ),
  	        0
  	      )
  	    ),
  	    intervalDays: Math.max(
  	      0,
  	      managerNumber(
  	        managerDescriptorValue(
  	          managerFirst(schedule.ServiceIntervalDays, schedule.Service_Interval_Days)
  	        ),
  	        0
  	      )
  	    ),
  	    warning: Math.max(
  	      0,
  	      managerNumber(
  	        managerDescriptorValue(
  	          managerFirst(
  	            hours ? schedule.ServiceWarningHours : schedule.ServiceWarningKM,
  	            !hours ? service.Service_Warning_Duration_in_KM : null
  	          )
  	        ),
  	        0
  	      )
  	    ),
  	    warningDays: Math.max(
  	      0,
  	      managerNumber(
  	        managerDescriptorValue(schedule.ServiceWarningDays),
  	        0
  	      )
  	    ),
  	    lastReading: managerNumber(
  	      managerDescriptorValue(
  	        managerFirst(
  	          hours ? current.LastServiceHours : current.LastServiceMileage,
  	          hours ? current.Last_Service_Hours : current.Last_Service_KM,
  	          hours ? history.Last_Service_Hours : history.Last_Service_KM
  	        )
  	      ),
  	      NaN
  	    ),
  	    storedNextReading: managerNumber(
  	      managerDescriptorValue(
  	        managerFirst(
  	          hours ? current.NextServiceHours : current.NextServiceMileage,
  	          hours ? current.Next_Service_Hours : current.Next_Service_KM,
  	          !hours ? current.NextServiceKM : null,
  	          hours ? history.Next_Service_Hours : history.Next_Service_KM
  	        )
  	      ),
  	      NaN
  	    ),
  	    lastDate: managerText(
  	      managerDescriptorValue(
  	        managerFirst(
  	          current.LastServiceDate,
  	          current.Last_Service_Date,
  	          history.Last_Service_Date
  	        )
  	      ),
  	      ""
  	    ).trim(),
  	    storedNextDate: managerText(
  	      managerDescriptorValue(
  	        managerFirst(
  	          current.NextServiceDate,
  	          current.Next_Service_Date_Estimate,
  	          current.Next_Service_Date,
  	          history.Next_Service_Date_Estimate,
  	          history.Next_Service_Date
  	        )
  	      ),
  	      ""
  	    ).trim()
  	  };
  	}
  	
  	function managerDatePlusDays(value, days) {
  	  var date = new Date(value);
  	  var count = Math.round(managerNumber(days, 0));
  	  if (!count || Number.isNaN(date.getTime())) return "";
  	  date.setUTCDate(date.getUTCDate() + count);
  	  return date.toISOString().slice(0, 10);
  	}
  	
  	function managerDaysUntil(value) {
  	  if (!value) return null;
  	  var date = new Date(value);
  	  if (Number.isNaN(date.getTime())) return null;
  	  var today = new Date();
  	  today.setHours(0, 0, 0, 0);
  	  date.setHours(0, 0, 0, 0);
  	  return Math.ceil((date.getTime() - today.getTime()) / 86400000);
  	}
  	
  	
  	function managerProviderSnapshotFromVehicle(vehicle, requestedId) {
  	  var notifications =
  	    managerGet(vehicle, ["Data", "Service", "Notifications"], {}) || {};
  	
  	  var selectedId = managerText(
  	    managerDescriptorValue(
  	      managerFirst(
  	        managerGet(notifications, ["ServiceProviderId"], null),
  	        managerGet(notifications, ["ProviderId"], null)
  	      )
  	    ),
  	    ""
  	  ).trim();
  	
  	  var selectedName = managerText(
  	    managerDescriptorValue(
  	      managerFirst(
  	        managerGet(notifications, ["ServiceProviderName"], null),
  	        managerGet(notifications, ["ProviderName"], null)
  	      )
  	    ),
  	    ""
  	  ).trim();
  	
  	  var selectedEmail = managerText(
  	    managerDescriptorValue(
  	      managerFirst(
  	        managerGet(notifications, ["ServiceProviderEmail"], null),
  	        managerGet(notifications, ["ProviderEmail"], null)
  	      )
  	    ),
  	    ""
  	  ).trim();
  	
  	  var wanted = managerText(
  	    managerFirst(requestedId, selectedId, selectedName),
  	    ""
  	  ).trim();
  	
  	  var wantedLower = wanted.toLowerCase();
  	  var history = managerProviderNotificationHistory(vehicle);
  	
  	  for (var index = history.length - 1; index >= 0; index--) {
  	    var entry = history[index] || {};
  	    var historyId = managerText(managerGet(entry, ["ProviderId"], ""), "").trim();
  	    var historyName = managerText(managerGet(entry, ["ProviderName"], ""), "").trim();
  	    var historyEmail = managerText(managerGet(entry, ["ProviderEmail"], ""), "").trim();
  	
  	    var matches =
  	      !wanted ||
  	      historyId === wanted ||
  	      historyName.toLowerCase() === wantedLower ||
  	      (
  	        selectedId &&
  	        historyId === selectedId
  	      ) ||
  	      (
  	        selectedName &&
  	        historyName.toLowerCase() === selectedName.toLowerCase()
  	      );
  	
  	    if (!matches) continue;
  	
  	    if (!selectedId && historyId) selectedId = historyId;
  	    if (!selectedName && historyName) selectedName = historyName;
  	    if (!selectedEmail && historyEmail) selectedEmail = historyEmail;
  	
  	    if (selectedEmail) break;
  	  }
  	
  	  if (!selectedEmail) return null;
  	
  	  return {
  	    ProviderId: selectedId || wanted || selectedName,
  	    Name: selectedName || wanted || "Service Provider",
  	    TradingName: "",
  	    Status: "Active",
  	    Preferred: false,
  	    Contact: {
  	      Email: selectedEmail
  	    },
  	    Source: "Vehicle Service Notification Snapshot"
  	  };
  	}
  	
  	function managerResolveNotificationProvider(companyObj, vehicle, requestedId) {
  	  var setup = managerServiceSetup(vehicle);
  	  var wanted = managerFirst(
  	    requestedId,
  	    setup.providerId,
  	    setup.providerName
  	  );
  	
  	  var provider = managerServiceProviderById(
  	    companyObj,
  	    wanted
  	  );
  	
  	  if (provider && provider.Status.toLowerCase() === "active") return provider;
  	
  	  var active = managerServiceProviders(companyObj).filter(function (item) {
  	    return item.Status.toLowerCase() === "active";
  	  });
  	  var preferred = active.filter(function (item) {
  	    return item.Preferred === true;
  	  });
  	
  	  if (preferred.length === 1) return preferred[0];
  	  if (active.length === 1) return active[0];
  	
  	  /*
  	   * The fuel workflow can receive a partial Company relation without the
  	   * Manifest.ServiceProviders array. In that case use the provider snapshot
  	   * persisted by Service Setup / ProviderEmailHistory on the vehicle.
  	   */
  	  return managerProviderSnapshotFromVehicle(
  	    vehicle,
  	    wanted
  	  );
  	}
  	
  	function managerServiceNotificationCandidate(companyObj, vehicle) {
  	  var setup = managerServiceSetup(vehicle);
  	  if (!setup.notifyProvider && !setup.notifyCompany) return null;
  	
  	  var reading = managerVehicleCurrentReading(vehicle);
  	  var nextReading =
  	    Number.isFinite(setup.lastReading) && setup.interval > 0
  	      ? setup.lastReading + setup.interval
  	      : Number.isFinite(setup.storedNextReading) && setup.storedNextReading > 0
  	        ? setup.storedNextReading
  	        : null;
  	  var nextDate =
  	    setup.lastDate && setup.intervalDays > 0
  	      ? managerDatePlusDays(setup.lastDate, setup.intervalDays)
  	      : setup.storedNextDate;
  	
  	  var remaining = nextReading === null ? null : nextReading - reading;
  	  var remainingDays = managerDaysUntil(nextDate);
  	  var overdue =
  	    (remaining !== null && remaining <= 0) ||
  	    (remainingDays !== null && remainingDays < 0);
  	  var dueSoon =
  	    (remaining !== null && setup.warning > 0 && remaining <= setup.warning) ||
  	    (remainingDays !== null && setup.warningDays > 0 && remainingDays <= setup.warningDays);
  	
  	  if (!overdue && !dueSoon) return null;
  	
  	  var provider = managerResolveNotificationProvider(companyObj, vehicle, "");
  	  var unitLabel = setup.unit === "h" ? "h" : "km";
  	  var summary = [];
  	  var due = [];
  	
  	  if (remaining !== null) {
  	    summary.push(
  	      remaining <= 0
  	        ? displayNumber(Math.abs(remaining), 0) + " " + unitLabel + " overdue"
  	        : displayNumber(remaining, 0) + " " + unitLabel + " remaining"
  	    );
  	  }
  	  if (remainingDays !== null) {
  	    summary.push(
  	      remainingDays < 0
  	        ? Math.abs(remainingDays) + " day" + (Math.abs(remainingDays) === 1 ? "" : "s") + " overdue"
  	        : remainingDays === 0
  	          ? "due today"
  	          : remainingDays + " day" + (remainingDays === 1 ? "" : "s") + " remaining"
  	    );
  	  }
  	  if (nextReading !== null) due.push(displayNumber(nextReading, 0) + " " + unitLabel);
  	  if (nextDate) due.push(nextDate);
  	
  	  var stage = overdue ? "OVERDUE" : "DUE_SOON";
  	  return {
  	    key: [
  	      "SERVICE",
  	      managerGet(vehicle, ["objectId"], ""),
  	      provider ? provider.ProviderId : setup.providerId,
  	      stage,
  	      nextReading === null ? "" : String(nextReading),
  	      nextDate || ""
  	    ].join("|"),
  	    kind: "Service",
  	    stage: stage,
  	    provider: provider,
  	    title: overdue ? "Service Overdue" : "Service Due Soon",
  	    summary: summary.join(" · ") || (overdue ? "The scheduled service is overdue." : "The scheduled service is approaching."),
  	    duePosition: due.join(" · ") || "Configured service interval",
  	    scope: "Scheduled vehicle service",
  	    reference: ""
  	  };
  	}
  	
  	function managerMaintenanceStatus(value) {
  	  var key = managerText(value, "")
  	    .trim()
  	    .toLowerCase()
  	    .replace(/[_-]+/g, " ")
  	    .replace(/\s+/g, " ");
  	
  	  if (key === "completed" || key === "complete" || key === "closed") return "Completed";
  	  if (key === "cancelled" || key === "canceled" || key === "abandoned") return "Cancelled";
  	  return "Open";
  	}
  	
  	function managerPreventivePlanRecords(vehicle, planId) {
  	  var wanted = managerText(planId, "").trim();
  	  return relationCollectionToArray(
  	    managerGet(vehicle, ["Maintenance"], [])
  	  ).filter(function (row) {
  	    return managerText(
  	      managerFirst(
  	        managerGet(row, ["PreventivePlanId"], null),
  	        managerGet(row, ["Data", "PreventivePlanId"], null)
  	      ),
  	      ""
  	    ).trim() === wanted;
  	  });
  	}
  	
  	function managerPreventiveMaintenanceCandidates(companyObj, vehicle) {
  	  var setup = managerServiceSetup(vehicle);
  	  if (!setup.notifyProvider && !setup.notifyCompany) return [];
  	
  	  var plans = managerServiceArray(
  	    managerGet(vehicle, ["Data", "Maintenance", "PreventivePlans"], [])
  	  );
  	  var reading = setup.unit === "km" ? managerVehicleCurrentReading(vehicle) : null;
  	
  	  return plans.map(function (plan) {
  	    if (!plan || typeof plan !== "object" || plan.Active === false) return null;
  	
  	    var planId = managerText(plan.PlanId, "").trim();
  	    var records = managerPreventivePlanRecords(vehicle, planId);
  	    var hasOpen = records.some(function (row) {
  	      return managerMaintenanceStatus(
  	        managerFirst(
  	          managerGet(row, ["Status"], null),
  	          managerGet(row, ["Data", "Status"], null)
  	        )
  	      ) === "Open";
  	    });
  	    if (hasOpen) return null;
  	
  	    var completed = records.filter(function (row) {
  	      return managerMaintenanceStatus(
  	        managerFirst(
  	          managerGet(row, ["Status"], null),
  	          managerGet(row, ["Data", "Status"], null)
  	        )
  	      ) === "Completed";
  	    }).sort(function (left, right) {
  	      var rt = new Date(
  	        managerFirst(
  	          managerGet(right, ["CompletedDate"], null),
  	          managerGet(right, ["ReportedDate"], null),
  	          0
  	        )
  	      ).getTime();
  	      var lt = new Date(
  	        managerFirst(
  	          managerGet(left, ["CompletedDate"], null),
  	          managerGet(left, ["ReportedDate"], null),
  	          0
  	        )
  	      ).getTime();
  	      return rt - lt;
  	    })[0];
  	
  	    var triggerMode = managerText(plan.TriggerMode, "First Due").trim();
  	    var intervalKm = Math.max(0, managerNumber(plan.IntervalKM, 0));
  	    var intervalDays = Math.max(0, managerNumber(plan.IntervalDays, 0));
  	    var warningKm = Math.max(0, managerNumber(plan.WarningKM, 0));
  	    var warningDays = Math.max(0, managerNumber(plan.WarningDays, 0));
  	
  	    var baselineKm = completed
  	      ? managerNumber(
  	          managerFirst(
  	            managerGet(completed, ["Odometer"], null),
  	            managerGet(completed, ["Data", "Odometer"], null)
  	          ),
  	          NaN
  	        )
  	      : managerNumber(plan.BaselineKM, NaN);
  	    var baselineDate = managerText(
  	      completed
  	        ? managerFirst(
  	            managerGet(completed, ["CompletedDate"], null),
  	            managerGet(completed, ["ReportedDate"], null)
  	          )
  	        : plan.BaselineDate,
  	      ""
  	    ).trim();
  	
  	    var useKm = setup.unit === "km" && triggerMode !== "Time Only" && intervalKm > 0;
  	    var useTime = triggerMode !== "Kilometers Only" && intervalDays > 0;
  	    var nextKm = useKm && Number.isFinite(baselineKm) ? baselineKm + intervalKm : null;
  	    var nextDate = useTime && baselineDate ? managerDatePlusDays(baselineDate, intervalDays) : "";
  	    var remainingKm = nextKm !== null && reading !== null ? nextKm - reading : null;
  	    var remainingDays = managerDaysUntil(nextDate);
  	
  	    var overdue =
  	      (remainingKm !== null && remainingKm <= 0) ||
  	      (remainingDays !== null && remainingDays <= 0);
  	    var dueSoon =
  	      !overdue &&
  	      (
  	        (remainingKm !== null && warningKm > 0 && remainingKm <= warningKm) ||
  	        (remainingDays !== null && warningDays > 0 && remainingDays <= warningDays)
  	      );
  	
  	    if (!overdue && !dueSoon) return null;
  	
  	    var provider = managerResolveNotificationProvider(
  	      companyObj,
  	      vehicle,
  	      managerFirst(plan.ProviderId, plan.ProviderName)
  	    );
  	    var stage = overdue ? "OVERDUE" : "DUE_SOON";
  	    var summary = [];
  	    var due = [];
  	
  	    if (remainingKm !== null) {
  	      summary.push(
  	        remainingKm <= 0
  	          ? displayNumber(Math.abs(remainingKm), 0) + " km overdue"
  	          : displayNumber(remainingKm, 0) + " km remaining"
  	      );
  	    }
  	    if (remainingDays !== null) {
  	      summary.push(
  	        remainingDays <= 0
  	          ? Math.abs(remainingDays) + " day" + (Math.abs(remainingDays) === 1 ? "" : "s") + " overdue"
  	          : remainingDays + " day" + (remainingDays === 1 ? "" : "s") + " remaining"
  	      );
  	    }
  	    if (nextKm !== null) due.push(displayNumber(nextKm, 0) + " km");
  	    if (nextDate) due.push(nextDate);
  	
  	    return {
  	      key: [
  	        "MAINTENANCE",
  	        managerGet(vehicle, ["objectId"], ""),
  	        planId,
  	        provider ? provider.ProviderId : managerFirst(plan.ProviderId, setup.providerId),
  	        stage,
  	        nextKm === null ? "" : String(nextKm),
  	        nextDate || ""
  	      ].join("|"),
  	      kind: "Maintenance",
  	      stage: stage,
  	      provider: provider,
  	      title: overdue ? "Preventive Maintenance Overdue" : "Preventive Maintenance Due Soon",
  	      summary: summary.join(" · "),
  	      duePosition: due.join(" · "),
  	      scope: managerText(managerFirst(plan.Scope, plan.Name, "Preventive Maintenance"), "Preventive Maintenance"),
  	      reference: planId
  	    };
  	  }).filter(Boolean);
  	}
  	
  	function managerProviderNotificationHistory(vehicle) {
  	  var raw = managerServiceCollectionValue(
  	    managerGet(
  	      vehicle,
  	      ["Data", "Service", "Notifications", "ProviderEmailHistory"],
  	      []
  	    )
  	  );
  	
  	  return Array.isArray(raw) ? deepClone(raw) : [];
  	}
  	
  	function managerSetProviderNotificationHistory(vehicle, history) {
  	  if (!vehicle.Data || typeof vehicle.Data !== "object" || Array.isArray(vehicle.Data)) {
  	    vehicle.Data = {};
  	  }
  	  if (!vehicle.Data.Service || typeof vehicle.Data.Service !== "object" || Array.isArray(vehicle.Data.Service)) {
  	    vehicle.Data.Service = {};
  	  }
  	  if (
  	    !vehicle.Data.Service.Notifications ||
  	    typeof vehicle.Data.Service.Notifications !== "object" ||
  	    Array.isArray(vehicle.Data.Service.Notifications)
  	  ) {
  	    vehicle.Data.Service.Notifications = {};
  	  }
  	
  	  var rows = toArray(history).slice(-100);
  	  vehicle.Data.Service.Notifications.ProviderEmailHistory = rows;
  	  vehicle.Data.Service.Notifications.LastProviderEmailAt =
  	    rows.length ? managerText(managerGet(rows[rows.length - 1], ["SentAt"], ""), "") : "";
  	}
  	
  	function managerProviderNotificationCandidates(companyObj, vehicle) {
  	  var serviceCandidate = managerServiceNotificationCandidate(companyObj, vehicle);
  	  return (serviceCandidate ? [serviceCandidate] : []).concat(
  	    managerPreventiveMaintenanceCandidates(companyObj, vehicle)
  	  );
  	}
  	
  	function managerProviderEmailDialog(vehicle, candidates, companyEmails, setup) {
  	  return new Promise(function (resolve) {
  	    var existing = document.getElementById(MANAGER_PROVIDER_EMAIL_OVERLAY_ID);
  	    if (existing) existing.remove();
  	
  	    var providers = [];
  	    var emails = [];
  	    var conditions = [];
  	
  	    toArray(candidates).forEach(function (candidate) {
  	      var provider = candidate && candidate.provider;
  	      var providerLabel = provider ? managerServiceProviderLabel(provider) : "Not resolved";
  	      var email = managerText(managerGet(provider, ["Contact", "Email"], ""), "").trim();
  	
  	      if (providers.indexOf(providerLabel) < 0) providers.push(providerLabel);
  	      if (email && emails.indexOf(email) < 0) emails.push(email);
  	      conditions.push(
  	        candidate.title + (candidate.summary ? " · " + candidate.summary : "")
  	      );
  	    });
  	
  	    var unit = getVehicleReadingUnit(vehicle) === "h" ? "h" : "km";
  	    var overlay = document.createElement("div");
  	    overlay.id = MANAGER_PROVIDER_EMAIL_OVERLAY_ID;
  	    overlay.style.position = "fixed";
  	    overlay.style.inset = "0";
  	    overlay.style.zIndex = String(FIF_MAX_Z_INDEX);
  	    overlay.style.display = "grid";
  	    overlay.style.placeItems = "start center";
  	    overlay.style.padding = "78px 20px 20px";
  	    overlay.style.boxSizing = "border-box";
  	    overlay.style.background = "rgba(0,0,0,0.84)";
  	    overlay.style.backdropFilter = "blur(8px)";
  	
  	    overlay.innerHTML =
  	      '<div role="dialog" aria-modal="true" style="width:min(650px,calc(100vw - 40px));padding:22px;box-sizing:border-box;border:1px solid rgba(232,115,57,.56);border-radius:22px;color:#f8fafc;background:linear-gradient(145deg,rgba(24,18,15,.995),rgba(7,10,13,.995));box-shadow:0 28px 70px rgba(0,0,0,.62);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Arial,sans-serif;">' +
  	      '<div style="font-size:19px;font-weight:900;">Send Service Notification?</div>' +
  	      '<div style="margin-top:7px;color:#b9c1bd;font-size:11px;font-weight:750;">The Bowser fuel transaction updated the vehicle reading and a Service / Maintenance notification is active.</div>' +
  	      '<div style="display:grid;grid-template-columns:150px minmax(0,1fr);gap:7px 12px;margin-top:16px;padding:13px;border:1px solid rgba(255,255,255,.10);border-radius:14px;background:rgba(255,255,255,.035);font-size:12px;line-height:1.45;">' +
  	      '<strong>Vehicle</strong><span>' + managerEscape(managerVehicleLabel(vehicle)) + '</span>' +
  	      '<strong>Current Reading</strong><span>' + managerEscape(displayNumber(managerVehicleCurrentReading(vehicle), 0) + " " + unit) + '</span>' +
  	      '<strong>Condition</strong><span>' + managerEscape(conditions.join(" | ")) + '</span>' +
  	      '<strong>Provider</strong><span>' + managerEscape(providers.join(", ")) + '</span>' +
  	      '<strong>Provider Email</strong><span>' + managerEscape(emails.length ? emails.join(", ") : "Not enabled / unavailable") + '</span>' +
  	      '<strong>Company Email</strong><span>' + managerEscape(managerToArray(companyEmails).length ? managerToArray(companyEmails).join(", ") : "Not enabled / unavailable") + '</span>' +
  	      '</div>' +
  	      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:18px;">' +
  	      '<button type="button" data-provider-email="send" class="fif-miniapp-primary" style="height:44px;border-radius:13px;font-size:12px;font-weight:900;cursor:pointer;">Send Email</button>' +
  	      '<button type="button" data-provider-email="skip" style="height:44px;border:1px solid rgba(255,255,255,.13);border-radius:13px;color:#f8fafc;background:linear-gradient(145deg,rgba(255,255,255,.08),rgba(255,255,255,.035));font-size:12px;font-weight:900;cursor:pointer;">Not Now</button>' +
  	      '</div></div>';
  	
  	    document.body.appendChild(overlay);
  	
  	    function finish(value) {
  	      try { overlay.remove(); } catch (_) {}
  	      resolve(value === true);
  	    }
  	
  	    overlay.querySelector('[data-provider-email="send"]').onclick = function () {
  	      finish(true);
  	    };
  	    overlay.querySelector('[data-provider-email="skip"]').onclick = function () {
  	      finish(false);
  	    };
  	    overlay.onclick = function (event) {
  	      if (event.target === overlay) finish(false);
  	    };
  	
  	    setTimeout(function () {
  	      try {
  	        overlay.querySelector('[data-provider-email="skip"]').focus();
  	      } catch (_) {}
  	    }, 20);
  	  });
  	}
  	
  	function managerProviderEmailNotice(title, message, detail) {
  	  return new Promise(function (resolve) {
  	    var existing = document.getElementById(MANAGER_PROVIDER_EMAIL_OVERLAY_ID);
  	    if (existing) existing.remove();
  	
  	    var overlay = document.createElement("div");
  	    overlay.id = MANAGER_PROVIDER_EMAIL_OVERLAY_ID;
  	    overlay.style.position = "fixed";
  	    overlay.style.inset = "0";
  	    overlay.style.zIndex = String(FIF_MAX_Z_INDEX);
  	    overlay.style.display = "grid";
  	    overlay.style.placeItems = "start center";
  	    overlay.style.padding = "78px 20px 20px";
  	    overlay.style.boxSizing = "border-box";
  	    overlay.style.background = "rgba(0,0,0,0.84)";
  	    overlay.style.backdropFilter = "blur(8px)";
  	
  	    overlay.innerHTML =
  	      '<div role="alertdialog" aria-modal="true" style="width:min(600px,calc(100vw - 40px));padding:22px;box-sizing:border-box;border:1px solid rgba(232,115,57,.56);border-radius:22px;color:#f8fafc;background:linear-gradient(145deg,rgba(24,18,15,.995),rgba(7,10,13,.995));box-shadow:0 28px 70px rgba(0,0,0,.62);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Arial,sans-serif;">' +
  	      '<div style="font-size:19px;font-weight:900;">' + managerEscape(title) + '</div>' +
  	      '<div style="margin-top:10px;font-size:13px;font-weight:750;line-height:1.55;color:#e6d5ca;">' + managerEscape(message) + '</div>' +
  	      (detail
  	        ? '<div style="margin-top:12px;padding:11px 13px;border:1px solid rgba(232,115,57,.32);border-radius:13px;background:rgba(156,72,34,.16);font-size:12px;font-weight:750;line-height:1.45;">' + managerEscape(detail) + '</div>'
  	        : "") +
  	      '<button type="button" data-provider-notice-close class="fif-miniapp-primary" style="width:100%;height:44px;margin-top:18px;border-radius:13px;font-size:12px;font-weight:900;cursor:pointer;">Continue</button>' +
  	      '</div>';
  	
  	    document.body.appendChild(overlay);
  	    var close = overlay.querySelector("[data-provider-notice-close]");
  	    close.onclick = function () {
  	      try { overlay.remove(); } catch (_) {}
  	      resolve(true);
  	    };
  	    setTimeout(function () {
  	      try { close.focus(); } catch (_) {}
  	    }, 20);
  	  });
  	}
  	
  	function managerAppDataCompanies() {
  	  var rows = managerToArray(
  	    managerGet(rootAppData, ["User", "Companies"], [])
  	  );
  	
  	  return rows.length ? rows : managerToArray(companiesCache);
  	}
  	
  	function managerCompanyIdentityValues(company) {
  	  if (!company || typeof company !== "object") return [];
  	
  	  return [
  	    managerGet(company, ["objectId"], null),
  	    managerGet(company, ["CompanyId"], null),
  	    managerGet(company, ["CompanyID"], null),
  	    managerGet(company, ["Name"], null),
  	    managerGet(company, ["CompanyName"], null),
  	    managerGet(company, ["Manifest", "Profile", "CompanyId"], null),
  	    managerGet(company, ["Manifest", "Profile", "Company_Name"], null),
  	    managerGet(company, ["Manifest", "Profile", "TradingName"], null)
  	  ].map(function (value) {
  	    return managerText(managerDescriptorValue(value), "").trim().toLowerCase();
  	  }).filter(Boolean);
  	}
  	
  	function managerCompanyContainsVehicle(company, vehicle) {
  	  var vehicleId = managerText(managerGet(vehicle, ["objectId"], null), "").trim();
  	  var vehicleName = managerText(
  	    managerFirst(
  	      managerGet(vehicle, ["ID"], null),
  	      managerGet(vehicle, ["FID"], null),
  	      managerGet(vehicle, ["Registration"], null)
  	    ),
  	    ""
  	  ).trim().toLowerCase();
  	
  	  return managerToArray(managerGet(company, ["Tractors"], [])).some(function (item) {
  	    if (!item || typeof item !== "object") return false;
  	
  	    var itemId = managerText(managerGet(item, ["objectId"], null), "").trim();
  	    if (vehicleId && itemId && vehicleId === itemId) return true;
  	
  	    var itemName = managerText(
  	      managerFirst(
  	        managerGet(item, ["ID"], null),
  	        managerGet(item, ["FID"], null),
  	        managerGet(item, ["Registration"], null)
  	      ),
  	      ""
  	    ).trim().toLowerCase();
  	
  	    return !!(vehicleName && itemName && vehicleName === itemName);
  	  });
  	}
  	
  	function managerResolveVehicleCompanyFromAppData(companyObj, vehicle) {
  	  var companies = managerAppDataCompanies();
  	
  	  if (!companies.length) return companyObj || null;
  	
  	  /* First prefer the actual company that contains this Tractor relation. */
  	  var containing = companies.find(function (candidate) {
  	    return managerCompanyContainsVehicle(candidate, vehicle);
  	  });
  	  if (containing) return containing;
  	
  	  /* Then reconcile the supplied Company against AppData.User.Companies. */
  	  var suppliedKeys = managerCompanyIdentityValues(companyObj);
  	  if (suppliedKeys.length) {
  	    var matching = companies.find(function (candidate) {
  	      var candidateKeys = managerCompanyIdentityValues(candidate);
  	      return candidateKeys.some(function (key) {
  	        return suppliedKeys.indexOf(key) >= 0;
  	      });
  	    });
  	    if (matching) return matching;
  	  }
  	
  	  return companyObj || (companies.length === 1 ? companies[0] : null);
  	}
  	
  	function managerUniqueServiceEmails(values) {
  	  var seen = Object.create(null);
  	  var emails = [];
  	
  	  managerToArray(values).forEach(function (value) {
  	    String(managerDescriptorValue(value) || "")
  	      .split(/[;,\n]+/)
  	      .map(function (item) { return item.trim(); })
  	      .filter(Boolean)
  	      .forEach(function (email) {
  	        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
  	        var key = email.toLowerCase();
  	        if (seen[key]) return;
  	        seen[key] = true;
  	        emails.push(email);
  	      });
  	  });
  	
  	  return emails;
  	}
  	
  	function managerCompanyServiceNotificationEmails(company) {
  	  if (!company || typeof company !== "object") return [];
  	
  	  return managerUniqueServiceEmails([
  	    /* Company master in AppData.User.Companies */
  	    managerGet(company, ["Manifest", "Profile", "PrimaryEmail"], null),
  	    managerGet(company, ["Manifest", "Contacts", "Primary", "Email"], null),
  	    managerGet(company, ["Manifest", "Profile", "Email"], null),
  	
  	    /* Billing fallbacks are useful when the profile email is not populated. */
  	    managerGet(company, ["Manifest", "Billing", "Account", "InvoiceEmail"], null),
  	    managerGet(company, ["Manifest", "Billing", "Account", "StatementEmail"], null),
  	
  	    /* Legacy / partial Company rows. */
  	    managerGet(company, ["PrimaryEmail"], null),
  	    managerGet(company, ["CompanyEmail"], null),
  	    managerGet(company, ["Email"], null),
  	    managerGet(company, ["email"], null)
  	  ]);
  	}
  	
  	function managerNotificationHistoryRecipientState(history, candidateKey) {
  	  var providerSent = false;
  	  var companySent = false;
  	
  	  managerToArray(history).forEach(function (entry) {
  	    if (managerText(managerGet(entry, ["Key"], ""), "") !== candidateKey) return;
  	
  	    if (
  	      managerGet(entry, ["ProviderEmailSent"], null) === true ||
  	      managerText(managerGet(entry, ["ProviderEmail"], ""), "").trim()
  	    ) {
  	      providerSent = true;
  	    }
  	
  	    if (
  	      managerGet(entry, ["CompanyEmailSent"], null) === true ||
  	      managerText(managerGet(entry, ["CompanyEmail"], ""), "").trim() ||
  	      managerText(managerGet(entry, ["CompanyEmails"], ""), "").trim()
  	    ) {
  	      companySent = true;
  	    }
  	  });
  	
  	  return {
  	    providerSent: providerSent,
  	    companySent: companySent
  	  };
  	}
  	
  	function managerProviderEmailBody(companyObj, vehicle, candidate, transaction) {
  	  var providerName = managerServiceProviderLabel(candidate.provider);
  	  var companyLabel = managerCompanyLabel(companyObj);
  	  var vehicleLabel = managerVehicleLabel(vehicle);
  	  var registration = managerVehicleRegistration(vehicle);
  	  var identity = managerVehicleIdentityDetails(vehicle);
  	  var litres = toNumber(managerGet(transaction, ["Litres"], 0), 0);
  	  var unit = getVehicleReadingUnit(vehicle) === "h" ? "h" : "km";
  	  var reading = managerVehicleCurrentReading(vehicle);
  	
  	  var textBody = [
  	    "Fleet In Form - " + candidate.title,
  	    "",
  	    "Service Provider: " + providerName,
  	    "Company: " + companyLabel,
  	    "Vehicle: " + vehicleLabel,
  	    "Registration: " + registration,
  	    "Make: " + identity.make,
  	    "Model: " + identity.model,
  	    "Year: " + identity.year,
  	    "VIN: " + identity.vin,
  	    "Engine Number: " + identity.engineNumber,
  	    "Type: " + candidate.kind,
  	    "Status: " + candidate.title,
  	    "Current Position: " + candidate.summary,
  	    "Due Position: " + candidate.duePosition,
  	    "Work Scope: " + candidate.scope,
  	    candidate.reference ? "Reference: " + candidate.reference : "",
  	    "Fuel Transaction: " + displayNumber(litres, 2) + " L",
  	    "Vehicle Reading: " + displayNumber(reading, 0) + " " + unit,
  	    "",
  	    "This notification was generated by Fleet In Form after a Bowser fuel transaction because Service notification recipients are enabled for this vehicle."
  	  ].filter(Boolean).join("\n");
  	
  	  var htmlBody =
  	    '<div style="font-family:Arial,sans-serif;color:#202420;line-height:1.45">' +
  	    '<h2 style="margin:0 0 4px;color:#a34f29">Fleet In Form</h2>' +
  	    '<h3 style="margin:0 0 18px">' + managerEscape(candidate.title) + '</h3>' +
  	    '<table style="border-collapse:collapse;width:100%;max-width:720px">' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Service Provider</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(providerName) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Company</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(companyLabel) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Vehicle</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(vehicleLabel) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Registration</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(registration) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Make</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(identity.make) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Model</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(identity.model) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Year</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(identity.year) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">VIN</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(identity.vin) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Engine Number</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(identity.engineNumber) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Notification</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(candidate.kind + " · " + candidate.title) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Position</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(candidate.summary) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Due Position</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(candidate.duePosition) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Work Scope</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(candidate.scope) + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Fuel Transaction</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(displayNumber(litres, 2) + " L") + '</td></tr>' +
  	    '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Vehicle Reading</td><td style="padding:7px;border:1px solid #d9dedb">' + managerEscape(displayNumber(reading, 0) + " " + unit) + '</td></tr>' +
  	    '</table>' +
  	    '<p style="margin-top:18px;color:#657069;font-size:12px">Generated after a Bowser fuel transaction because Service notification recipients are enabled for this vehicle.</p>' +
  	    '</div>';
  	
  	  return { text: textBody, html: htmlBody };
  	}
  	
  	async function managerSendProviderEmail(companyObj, vehicle, candidate, transaction) {
  	  if (
  	    !rootBackendless ||
  	    !rootBackendless.Messaging ||
  	    typeof rootBackendless.Messaging.sendEmail !== "function"
  	  ) {
  	    throw new Error("Backendless Messaging.sendEmail is unavailable.");
  	  }
  	
  	  var email = managerText(
  	    managerGet(candidate.provider, ["Contact", "Email"], ""),
  	    ""
  	  ).trim();
  	  if (!email) throw new Error("The Service Provider has no email address.");
  	
  	  var body = managerProviderEmailBody(companyObj, vehicle, candidate, transaction);
  	  var bodyParts =
  	    typeof rootBackendless.Bodyparts === "function"
  	      ? new rootBackendless.Bodyparts()
  	      : {};
  	
  	  bodyParts.textmessage = body.text;
  	  bodyParts.htmlmessage = body.html;
  	
  	  await rootBackendless.Messaging.sendEmail(
  	    "Fleet In Form - " + candidate.title + " - " + managerVehicleRegistration(vehicle),
  	    bodyParts,
  	    [email],
  	    []
  	  );
  	}
  	
  	async function managerSendCompanyServiceEmail(companyObj, vehicle, candidate, transaction, companyEmails) {
  	  if (
  	    !rootBackendless ||
  	    !rootBackendless.Messaging ||
  	    typeof rootBackendless.Messaging.sendEmail !== "function"
  	  ) {
  	    throw new Error("Backendless Messaging.sendEmail is unavailable.");
  	  }
  	
  	  var recipients = managerUniqueServiceEmails(companyEmails);
  	  if (!recipients.length) {
  	    throw new Error("The vehicle company does not have a notification email address in AppData.User.Companies.");
  	  }
  	
  	  var body = managerProviderEmailBody(companyObj, vehicle, candidate, transaction);
  	  var bodyParts =
  	    typeof rootBackendless.Bodyparts === "function"
  	      ? new rootBackendless.Bodyparts()
  	      : {};
  	
  	  bodyParts.textmessage = body.text;
  	  bodyParts.htmlmessage = body.html;
  	
  	  await rootBackendless.Messaging.sendEmail(
  	    "Fleet In Form - " + candidate.title + " - " + managerVehicleRegistration(vehicle),
  	    bodyParts,
  	    recipients,
  	    []
  	  );
  	}
  	
  	async function managerReviewProviderNotificationsAfterFuel(companyObj, vehicle, transaction) {
  	  var setup = managerServiceSetup(vehicle);
  	  if (!setup.notifyProvider && !setup.notifyCompany) {
  	    return { status: "disabled", message: "" };
  	  }
  	
  	  var resolvedCompany = managerResolveVehicleCompanyFromAppData(companyObj, vehicle);
  	  var companyEmails = setup.notifyCompany
  	    ? managerCompanyServiceNotificationEmails(resolvedCompany)
  	    : [];
  	
  	  var candidates = managerProviderNotificationCandidates(resolvedCompany || companyObj, vehicle);
  	  if (!candidates.length) return { status: "not-required", message: "" };
  	
  	  var history = managerProviderNotificationHistory(vehicle);
  	
  	  var pending = candidates.map(function (candidate) {
  	    if (!candidate || !candidate.key) return null;
  	
  	    var recipientState = managerNotificationHistoryRecipientState(history, candidate.key);
  	    var repeat = candidate.stage === "OVERDUE";
  	
  	    candidate._sendProvider = !!(
  	      setup.notifyProvider &&
  	      (repeat || !recipientState.providerSent)
  	    );
  	
  	    candidate._sendCompany = !!(
  	      setup.notifyCompany &&
  	      (repeat || !recipientState.companySent)
  	    );
  	
  	    candidate._companyEmails = companyEmails.slice();
  	    return candidate._sendProvider || candidate._sendCompany ? candidate : null;
  	  }).filter(Boolean);
  	
  	  if (!pending.length) {
  	    return {
  	      status: "already-notified",
  	      message: " Service Due Soon notification was already sent to all enabled recipients for the current warning stage."
  	    };
  	  }
  	
  	  var hasOverdue = pending.some(function (candidate) {
  	    return candidate && candidate.stage === "OVERDUE";
  	  });
  	
  	  /*
  	   * Overdue/unserviced vehicles send on every FuelOut. Due Soon remains an
  	   * interactive one-time notification. The same confirmation covers both
  	   * enabled recipient classes: Service Provider and Company.
  	   */
  	  var approved = hasOverdue
  	    ? true
  	    : await managerProviderEmailDialog(
  	        vehicle,
  	        pending,
  	        companyEmails,
  	        setup
  	      );
  	
  	  if (!approved) {
  	    return {
  	      status: "deferred",
  	      message: " Service Due Soon email was not sent."
  	    };
  	  }
  	
  	  managerUpdateLoadingStatus("Sending Service notification…");
  	
  	  var successfulSends = 0;
  	  var failedSends = [];
  	
  	  for (var index = 0; index < pending.length; index++) {
  	    var candidate = pending[index];
  	    var providerSent = false;
  	    var companySent = false;
  	    var providerEmail = managerText(
  	      managerGet(candidate.provider, ["Contact", "Email"], ""),
  	      ""
  	    ).trim();
  	
  	    if (candidate._sendProvider) {
  	      if (!candidate.provider || !providerEmail) {
  	        failedSends.push("Service Provider email is not configured.");
  	      } else {
  	        try {
  	          await managerSendProviderEmail(
  	            resolvedCompany || companyObj,
  	            vehicle,
  	            candidate,
  	            transaction
  	          );
  	          providerSent = true;
  	          successfulSends++;
  	        } catch (providerError) {
  	          failedSends.push(
  	            "Service Provider: " + managerText(
  	              managerFirst(
  	                providerError && providerError.message,
  	                providerError && providerError.faultString,
  	                providerError
  	              ),
  	              "Email failed."
  	            )
  	          );
  	        }
  	      }
  	    }
  	
  	    if (candidate._sendCompany) {
  	      if (!companyEmails.length) {
  	        failedSends.push(
  	          "Company: no email found in AppData.User.Companies for " +
  	          managerCompanyLabel(resolvedCompany || companyObj) + "."
  	        );
  	      } else {
  	        try {
  	          await managerSendCompanyServiceEmail(
  	            resolvedCompany || companyObj,
  	            vehicle,
  	            candidate,
  	            transaction,
  	            companyEmails
  	          );
  	          companySent = true;
  	          successfulSends++;
  	        } catch (companyError) {
  	          failedSends.push(
  	            "Company: " + managerText(
  	              managerFirst(
  	                companyError && companyError.message,
  	                companyError && companyError.faultString,
  	                companyError
  	              ),
  	              "Email failed."
  	            )
  	          );
  	        }
  	      }
  	    }
  	
  	    /*
  	     * Only record the recipients that really received this occurrence. Old
  	     * provider-only entries therefore do not suppress the first Company copy.
  	     */
  	    if (providerSent || companySent) {
  	      history.push({
  	        Key: candidate.key,
  	        Kind: candidate.kind,
  	        Stage: candidate.stage,
  	        ProviderId: candidate.provider ? candidate.provider.ProviderId : "",
  	        ProviderName: candidate.provider ? managerServiceProviderLabel(candidate.provider) : "",
  	        ProviderEmail: providerSent ? providerEmail : "",
  	        ProviderEmailSent: providerSent,
  	        CompanyId: managerText(
  	          managerFirst(
  	            managerGet(resolvedCompany, ["objectId"], null),
  	            managerGet(resolvedCompany, ["CompanyId"], null),
  	            managerGet(resolvedCompany, ["Name"], null)
  	          ),
  	          ""
  	        ),
  	        CompanyName: managerCompanyLabel(resolvedCompany || companyObj),
  	        CompanyEmail: companySent ? companyEmails.join(", ") : "",
  	        CompanyEmails: companySent ? companyEmails.join(", ") : "",
  	        CompanyEmailSent: companySent,
  	        Subject: "Fleet In Form - " + candidate.title + " - " + managerVehicleRegistration(vehicle),
  	        SentAt: new Date().toISOString(),
  	        Trigger: "Bowser Fuel Transaction",
  	        RepeatOverdue: candidate.stage === "OVERDUE",
  	        FuelOutObjectId: managerText(managerGet(transaction, ["objectId"], ""), ""),
  	        OccurrenceKey:
  	          candidate.key +
  	          "|FUELOUT|" +
  	          managerText(managerGet(transaction, ["objectId"], ""), "")
  	      });
  	    }
  	  }
  	
  	  managerSetProviderNotificationHistory(vehicle, history);
  	
  	  /* Audit persistence is internal and must never interrupt fuel capture. */
  	  try {
  	    if (
  	      rootBackendless &&
  	      rootBackendless.Data &&
  	      typeof rootBackendless.Data.of === "function" &&
  	      managerGet(vehicle, ["objectId"], null)
  	    ) {
  	      var savedAuditVehicle = await rootBackendless.Data.of("Tractors").save({
  	        objectId: managerGet(vehicle, ["objectId"], null),
  	        Data: deepClone(vehicle.Data)
  	      });
  	
  	      if (savedAuditVehicle && savedAuditVehicle.Data) {
  	        vehicle.Data = deepClone(savedAuditVehicle.Data);
  	      }
  	    }
  	  } catch (_) {
  	    /* deliberately silent */
  	  }
  	
  	  /*
  	   * Successful Service notification delivery is deliberately silent.
  	   * A successful email is background work and must not add another modal
  	   * to the fuel workflow. Only delivery failures/partial failures remain
  	   * visible because they require management attention.
  	   */
  	  if (failedSends.length) {
  	    await managerProviderEmailNotice(
  	      successfulSends ? "Service Notification Partially Sent" : "Service Notification Email Failed",
  	      successfulSends
  	        ? "At least one configured Service notification recipient received the email, but another recipient could not be reached."
  	        : "The fuel transaction was saved, but the configured Service notification email could not be delivered.",
  	      failedSends.join(" | ")
  	    );
  	  }
  	
  	  return {
  	    status: failedSends.length
  	      ? (successfulSends ? "partially-sent" : "failed")
  	      : "sent",
  	    message:
  	      " Service notification email processing completed for " +
  	      String(successfulSends) +
  	      " recipient delivery" +
  	      (successfulSends === 1 ? "." : "s.")
  	  };
  	}
  	
  	function openFuelCapture(context) {
  	    var AppData = context.AppData;
  	    var Company = context.Company;
  	    var Tank = context.Tank;
  	    var Bowser = context.Bowser;
  	    var Contractors = context.Contractors;
  	    var TankBlock = context.TankBlock;
  	    var Backendless = context.Backendless;
  	    var CurrentUser = context.CurrentUser;
  	    var SVGLogo = context.SVGLogo;
  	    var Tanks = context.Tanks;
  	    try {
  	      var appData = (typeof AppData !== "undefined" ? AppData: null);
  	      var company = (typeof Company !== "undefined" ? Company: null);
  	      var tank = (typeof Tank !== "undefined" ? Tank: null);
  	      var bowser = (typeof Bowser !== "undefined" ? Bowser: null);
  	      var contractorsInput = (typeof Contractors !== "undefined" ? Contractors: []);
  	      var tankBlock = (typeof TankBlock !== "undefined" ? TankBlock: null);
  	      var backendless = (typeof Backendless !== "undefined" ? Backendless: null);
  	      var currentUser = (typeof CurrentUser !== "undefined" ? CurrentUser: null);
  	      var svgLogo = (typeof SVGLogo !== "undefined" ? SVGLogo: null);
  	      var tanks = (typeof Tanks !== "undefined" ? Tanks: []);
  	
  	      var BUSINESS_TIMEZONE_OFFSET_MINUTES = 120;
  	
  	      function toArray(value) {
  	        if (Array.isArray(value)) return value;
  	        if (value === null || value === undefined) return [];
  	        return [value];
  	      }
  	
  	      function toNumber(value, fallback) {
  	        var n = Number(String(value).replace(",", "."));
  	        return isNaN(n) ? fallback: n;
  	      }
  	
  	      function roundMoney2(value) {
  	        var amount = toNumber(value, 0);
  	
  	        return Math.round(
  	          (amount + Number.EPSILON) * 100
  	        ) / 100;
  	      }
  	
  	      function text(value, fallback) {
  	        if (value === null || value === undefined || value === "") return fallback;
  	        return String(value);
  	      }
  	
  	      function escapeHtml(value) {
  	        return String(value)
  	        .replace(/&/g, "&amp;")
  	        .replace(/</g, "&lt;")
  	        .replace(/>/g, "&gt;")
  	        .replace(/"/g, "&quot;")
  	        .replace(/'/g, "&#39;");
  	      }
  	
  	      function firstDefined() {
  	        for (var i = 0; i < arguments.length; i++) {
  	          if (arguments[i] !== null && arguments[i] !== undefined && arguments[i] !== "") {
  	            return arguments[i];
  	          }
  	        }
  	        return null;
  	      }
  	
  	      function getDeep(obj, path, fallback) {
  	        try {
  	          var current = obj;
  	          for (var i = 0; i < path.length; i++) {
  	            if (current == null) return fallback;
  	            current = current[path[i]];
  	          }
  	          return current == null ? fallback: current;
  	        } catch (e) {
  	          return fallback;
  	        }
  	      }
  	
  	      function deepClone(value) {
  	        try {
  	          return JSON.parse(JSON.stringify(value));
  	        } catch (e) {
  	          return value;
  	        }
  	      }
  	
  	      function uniqueByValue(list) {
  	        var seen = {};
  	        var out = [];
  	
  	        for (var i = 0; i < list.length; i++) {
  	          var item = list[i];
  	          var key = String(
  	            getDeep(item, ["value"], "") || ""
  	          ).trim().toLowerCase();
  	
  	          if (!key) continue;
  	
  	          if (!seen[key]) {
  	            seen[key] = true;
  	            out.push(item);
  	          }
  	        }
  	
  	        out.sort(function (left, right) {
  	          var leftLabel = text(
  	            getDeep(left, ["label"], ""),
  	            ""
  	          );
  	          var rightLabel = text(
  	            getDeep(right, ["label"], ""),
  	            ""
  	          );
  	          var leftValue = text(
  	            getDeep(left, ["value"], ""),
  	            ""
  	          );
  	          var rightValue = text(
  	            getDeep(right, ["value"], ""),
  	            ""
  	          );
  	          var leftOther =
  	            leftLabel.trim().toLowerCase() === "other" ||
  	            leftValue.trim().toLowerCase() === "other";
  	          var rightOther =
  	            rightLabel.trim().toLowerCase() === "other" ||
  	            rightValue.trim().toLowerCase() === "other";
  	
  	          if (leftOther !== rightOther) {
  	            return leftOther ? -1 : 1;
  	          }
  	
  	          return leftLabel.localeCompare(
  	            rightLabel,
  	            undefined,
  	            {
  	              numeric: true,
  	              sensitivity: "base"
  	            }
  	          );
  	        });
  	
  	        return out;
  	      }
  	
  	      function normalizeOption(value, label, raw) {
  	        return {
  	          value: text(value, ""),
  	          label: text(label || value, ""),
  	          raw: raw || null
  	        };
  	      }
  	
  	      function buildOptionsHtml(options, placeholder, selectedValue) {
  	        var html = "";
  	
  	        if (placeholder) {
  	          html += '<option value="">' + escapeHtml(placeholder) + "</option>";
  	        }
  	
  	        for (var i = 0; i < options.length; i++) {
  	          var opt = options[i];
  	          var selected = String(opt.value) === String(selectedValue || "") ? ' selected="selected"': "";
  	          html += '<option value="' + escapeHtml(opt.value) + '"' + selected + ">" + escapeHtml(opt.label) + "</option>";
  	        }
  	
  	        return html;
  	      }
  	
  	      function optionWithOtherFirst(options, otherLabel) {
  	        var out = [normalizeOption("OTHER", otherLabel || "Other", {
  	          type: "other"
  	        })];
  	        for (var i = 0; i < options.length; i++) {
  	          out.push(options[i]);
  	        }
  	        return uniqueByValue(out);
  	      }
  	
  	      function pickVehicleLabel(item, fallbackPrefix, index) {
  	        var identityMake = text(
  	          unwrapFuelDescriptor(
  	            getDeep(item, ["Data", "Vehicle", "Identity", "Make"], "")
  	          ),
  	          ""
  	        ).trim();
  	        var identityModel = text(
  	          unwrapFuelDescriptor(
  	            getDeep(item, ["Data", "Vehicle", "Identity", "Model"], "")
  	          ),
  	          ""
  	        ).trim();
  	        var identityYear = text(
  	          unwrapFuelDescriptor(
  	            getDeep(item, ["Data", "Vehicle", "Identity", "Year"], "")
  	          ),
  	          ""
  	        ).trim();
  	        var identitySummary = [
  	          identityMake,
  	          identityModel,
  	          identityYear
  	        ].filter(Boolean).join(" ");
  	
  	        var tractorId = firstDefined(
  	          getDeep(item, ["ID"], null),
  	          getDeep(item, ["FID"], null),
  	          getDeep(item, ["Name"], null),
  	          identitySummary || null
  	        );
  	
  	        var registration = firstDefined(
  	          getDeep(item, ["Registration"], null),
  	          // Read-only compatibility for records created before the simplified
  	          // vehicle Data JSON was introduced.
  	          getDeep(item, ["Data", "Vehicle", "Registration", "value"], null)
  	        );
  	
  	        var label = firstDefined(
  	          tractorId && registration ? tractorId + " | " + registration: null,
  	          tractorId,
  	          registration,
  	          identitySummary || null
  	        );
  	
  	        return text(label, fallbackPrefix + " " + (index + 1));
  	      }
  	
  	      function pickVehicleValue(item, fallbackPrefix, index) {
  	        return text(
  	          firstDefined(
  	            getDeep(item, ["objectId"], null),
  	            getDeep(item, ["FID"], null),
  	            getDeep(item, ["Registration"], null)
  	          ),
  	          fallbackPrefix + "_" + (index + 1)
  	        );
  	      }
  	
  	      function buildVehicleOptions(items, prefix) {
  	        var arr = toArray(items);
  	        var out = [];
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          out.push(
  	            normalizeOption(
  	              pickVehicleValue(arr[i], prefix, i),
  	              pickVehicleLabel(arr[i], prefix, i),
  	              arr[i]
  	            )
  	          );
  	        }
  	
  	        return uniqueByValue(out);
  	      }
  	
  	      function normalizeTankGradeValue(value) {
  	        return String(unwrapFuelDescriptor(value) == null
  	          ? ""
  	          : unwrapFuelDescriptor(value))
  	          .trim()
  	          .toLowerCase()
  	          .replace(/[._-]+/g, " ")
  	          .replace(/\s+/g, " ")
  	          .replace(/\s*ppm\b/g, "ppm");
  	      }
  	
  	      function normalizeVehicleFuelGrade(value) {
  	        var normalized = normalizeTankGradeValue(value);
  	
  	        if (!normalized) return "";
  	
  	        if (
  	          normalized === "petrol 95" ||
  	          normalized === "unleaded 95" ||
  	          normalized === "ulp95"
  	        ) {
  	          return "ulp 95";
  	        }
  	
  	        if (
  	          normalized === "petrol 93" ||
  	          normalized === "unleaded 93" ||
  	          normalized === "ulp93"
  	        ) {
  	          return "ulp 93";
  	        }
  	
  	        if (normalized === "diesel 10 ppm") return "diesel 10ppm";
  	        if (normalized === "diesel 50 ppm") return "diesel 50ppm";
  	        if (normalized === "diesel 500 ppm") return "diesel 500ppm";
  	
  	        return normalized;
  	      }
  	
  	      function getVehicleFuelGrade(vehicleObj) {
  	        return text(
  	          unwrapFuelDescriptor(
  	            firstDefined(
  	              // Canonical simplified Data JSON.
  	              getDeep(
  	                vehicleObj,
  	                ["Data", "FuelAndEnergy", "FuelGrade", "value"],
  	                null
  	              ),
  	              getDeep(
  	                vehicleObj,
  	                ["Data", "FuelAndEnergy", "FuelGrade"],
  	                null
  	              ),
  	              // Read-only compatibility for older vehicle records.
  	              getDeep(vehicleObj, ["Data", "Vehicle", "Fuel_Type", "value"], null),
  	              getDeep(vehicleObj, ["Data", "Vehicle", "FuelType", "value"], null),
  	              getDeep(vehicleObj, ["FuelGrade"], null),
  	              getDeep(vehicleObj, ["Fuel_Type"], null),
  	              getDeep(vehicleObj, ["FuelType"], null),
  	              getDeep(vehicleObj, ["Fuel"], null)
  	            )
  	          ),
  	          ""
  	        );
  	      }
  	
  	      function isDieselTankGrade(grade) {
  	        var value = normalizeVehicleFuelGrade(grade);
  	
  	        return (
  	          value === "diesel 500ppm" ||
  	          value === "diesel 50ppm" ||
  	          value === "diesel 10ppm"
  	        );
  	      }
  	
  	      function isPetrolTankGrade(grade) {
  	        var value = normalizeVehicleFuelGrade(grade);
  	
  	        return (
  	          value === "ulp 95" ||
  	          value === "ulp 93"
  	        );
  	      }
  	
  	      function isParaffinTankGrade(grade) {
  	        return normalizeVehicleFuelGrade(grade) === "paraffin";
  	      }
  	
  	      function vehicleMatchesTankGrade(vehicleObj, grade) {
  	        if (!vehicleObj || isParaffinTankGrade(grade)) {
  	          return false;
  	        }
  	
  	        var vehicleGrade = normalizeVehicleFuelGrade(
  	          getVehicleFuelGrade(vehicleObj)
  	        );
  	        var tankGrade = normalizeVehicleFuelGrade(grade);
  	
  	        if (!vehicleGrade || !tankGrade || vehicleGrade === "electric") {
  	          return false;
  	        }
  	
  	        // Retain support for older broad fuel-type descriptors while the new
  	        // simplified FuelGrade descriptor uses exact grades.
  	        if (vehicleGrade === "hybrid") return true;
  	        if (vehicleGrade === tankGrade) return true;
  	        if (vehicleGrade === "diesel") return isDieselTankGrade(tankGrade);
  	        if (vehicleGrade === "petrol") return isPetrolTankGrade(tankGrade);
  	
  	        return false;
  	      }
  	
  	      function filterVehiclesForTankGrade(items, grade) {
  	        return toArray(items).filter(function (vehicleObj) {
  	          return vehicleMatchesTankGrade(vehicleObj, grade);
  	        });
  	      }
  	
  	      function buildCaptureTypeOptionsHtml(grade) {
  	        if (isParaffinTankGrade(grade)) {
  	          return '<option value="other" selected="selected">Other</option>';
  	        }
  	
  	        return ""
  	          + '<option value="company">Company Vehicles</option>'
  	          + '<option value="contractor">Contractor Vehicles</option>'
  	          + '<option value="intertank">Intertank Fill</option>'
  	          + '<option value="other">Other</option>';
  	      }
  	
  	      function buildContractorOptions(items) {
  	        var arr = toArray(items);
  	        var out = [];
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          var item = arr[i];
  	          out.push(
  	            normalizeOption(
  	              text(firstDefined(item.objectId, item.CompanyId, item.Name), "CONTRACTOR_" + (i + 1)),
  	              text(firstDefined(item.Name, item.CompanyId), "Contractor " + (i + 1)),
  	              item
  	            )
  	          );
  	        }
  	
  	        return uniqueByValue(out);
  	      }
  	
  	      function buildEmployeeOptions(items) {
  	        var arr = toArray(items);
  	        var out = [];
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          var item = arr[i];
  	
  	          var label = firstDefined(
  	            getDeep(item, ["name"], null),
  	            getDeep(item, ["Name"], null),
  	            [
  	              getDeep(item, ["Data_Details", "employee_details", "first_name"], ""),
  	              getDeep(item, ["Data_Details", "employee_details", "last_name"], "")
  	            ].join(" ").trim(),
  	            getDeep(item, ["email"], null)
  	          );
  	
  	          var value = firstDefined(
  	            getDeep(item, ["ID"], null),
  	            getDeep(item, ["objectId"], null),
  	            getDeep(item, ["email"], null),
  	            label
  	          );
  	
  	          if (label) {
  	            out.push(normalizeOption(value, label, item));
  	          }
  	        }
  	
  	        return uniqueByValue(out);
  	      }
  	
  	      function normalizeGrade(value) {
  	        return String(value || "")
  	        .trim()
  	        .toLowerCase()
  	        .replace(/\s+/g, " ");
  	      }
  	
  	      function pickTankLabel(item, fallbackPrefix, index) {
  	        var tankName = firstDefined(
  	          getDeep(item, ["Name"], null),
  	          getDeep(item, ["TankName"], null),
  	          getDeep(item, ["FID"], null)
  	        );
  	
  	        var grade = firstDefined(
  	          getDeep(item, ["Grade"], null),
  	          getDeep(item, ["FuelGrade"], null)
  	        );
  	
  	        var label = firstDefined(
  	          tankName && grade
  	            ? tankName + " | " + grade
  	            : null,
  	          tankName,
  	          grade
  	        );
  	
  	        return text(
  	          label,
  	          fallbackPrefix + " " + (index + 1)
  	        );
  	      }
  	
  	      function pickTankValue(item, fallbackPrefix, index) {
  	        return text(
  	          firstDefined(
  	            getDeep(item, ["objectId"], null),
  	            getDeep(item, ["DeviceId"], null),
  	            getDeep(item, ["FID"], null),
  	            getDeep(item, ["Name"], null)
  	          ),
  	          fallbackPrefix + "_" + (index + 1)
  	        );
  	      }
  	
  	      function getAvailableTanks() {
  	        var allFromAppData = [];
  	        var companies = getUserCompaniesFromAppData();
  	
  	        for (var c = 0; c < companies.length; c++) {
  	          var companyTanks = toArray(getDeep(companies[c], ["Tanks"], []));
  	          for (var i = 0; i < companyTanks.length; i++) {
  	            allFromAppData.push(companyTanks[i]);
  	          }
  	        }
  	
  	        if (allFromAppData.length) {
  	          console.log("[Intertank] Using AppData.User.Companies[*].Tanks:", allFromAppData);
  	          return allFromAppData;
  	        }
  	
  	        if (Array.isArray(tanks) && tanks.length) {
  	          console.log("[Intertank] Using Tanks argument fallback:", tanks);
  	          return tanks;
  	        }
  	
  	        var companyTanksFallback = getDeep(company, ["Tanks"], null);
  	        if (Array.isArray(companyTanksFallback) && companyTanksFallback.length) {
  	          console.log("[Intertank] Using company.Tanks fallback:", companyTanksFallback);
  	          return companyTanksFallback;
  	        }
  	
  	        console.log("[Intertank] No tanks available.");
  	        return [];
  	      }
  	
  	      function unwrapTankItem(item) {
  	        if (!item) return null;
  	
  	        if (getDeep(item, ["objectId"], null) || getDeep(item, ["Grade"], null) || getDeep(item, ["DeviceId"], null)) {
  	          return item;
  	        }
  	
  	        if (getDeep(item, ["Tank"], null)) {
  	          return getDeep(item, ["Tank"], null);
  	        }
  	
  	        if (getDeep(item, ["data"], null)) {
  	          return getDeep(item, ["data"], null);
  	        }
  	
  	        return item;
  	      }
  	
  	      function buildIntertankOptions(currentTankObj) {
  	        var availableTanks = getAvailableTanks();
  	        var out = [];
  	        var currentTankId = text(getDeep(currentTankObj, ["objectId"], null), "");
  	        var currentGrade = normalizeGrade(getDeep(currentTankObj, ["Grade"], ""));
  	
  	        console.log("[Intertank] current tank:", currentTankObj);
  	        console.log("[Intertank] raw available tanks:", availableTanks);
  	
  	        for (var i = 0; i < availableTanks.length; i++) {
  	          var rawItem = availableTanks[i];
  	          var item = unwrapTankItem(rawItem);
  	
  	          var itemId = text(getDeep(item, ["objectId"], null), "");
  	          var itemGrade = normalizeGrade(getDeep(item, ["Grade"], ""));
  	          var itemLabel = pickTankLabel(item, "Tank", i);
  	          if (managerIsTrailerTank(item)) {
  	            itemLabel += " | Trailer";
  	          }
  	
  	          console.log("[Intertank] candidate:", {
  	            rawItem: rawItem,
  	            item: item,
  	            itemId: itemId,
  	            itemGrade: itemGrade,
  	            itemLabel: itemLabel
  	          });
  	
  	          if (!itemId) continue;
  	          if (itemId === currentTankId) continue;
  	          if (currentGrade && itemGrade !== currentGrade) continue;
  	
  	          out.push(
  	            normalizeOption(
  	              pickTankValue(item, "TANK", i),
  	              itemLabel,
  	              item
  	            )
  	          );
  	        }
  	
  	        console.log("[Intertank] final options:", out);
  	        return uniqueByValue(out);
  	      }
  	
  	      function getSelectedIntertankTarget() {
  	        var selectedId = valueOf("fuel-intertank-target");
  	        var availableTanks = getAvailableTanks();
  	
  	        for (var i = 0; i < availableTanks.length; i++) {
  	          var item = unwrapTankItem(availableTanks[i]);
  	          if (String(getDeep(item, ["objectId"], "")) === String(selectedId || "")) {
  	            return item;
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function validateIntertankTarget() {
  	        var mode = valueOf("fuel-capture-type");
  	
  	        if (mode !== "intertank") {
  	          showError("fuel-intertank-target-error", "");
  	          showHelp("fuel-intertank-target-help", "");
  	          return {
  	            ok: true
  	          };
  	        }
  	
  	        var targetTank = getSelectedIntertankTarget();
  	
  	        if (!targetTank) {
  	          showError("fuel-intertank-target-error", "Please select a destination tank.");
  	          showHelp("fuel-intertank-target-help", "");
  	          return {
  	            ok: false
  	          };
  	        }
  	
  	        var sourceTankId = text(getDeep(tank, ["objectId"], null), "");
  	        var targetTankId = text(getDeep(targetTank, ["objectId"], null), "");
  	
  	        if (sourceTankId && targetTankId && sourceTankId === targetTankId) {
  	          showError("fuel-intertank-target-error", "Destination tank cannot be the same as the source tank.");
  	          return {
  	            ok: false
  	          };
  	        }
  	
  	        var sourceGrade = normalizeGrade(getDeep(tank, ["Grade"], ""));
  	        var targetGrade = normalizeGrade(getDeep(targetTank, ["Grade"], ""));
  	
  	        if (sourceGrade !== targetGrade) {
  	          showError(
  	            "fuel-intertank-target-error",
  	            "Grade mismatch. Cannot transfer " +
  	            text(getDeep(tank, ["Grade"], "source grade"), "source grade") +
  	            " into " +
  	            text(getDeep(targetTank, ["Grade"], "destination grade"), "destination grade") +
  	            "."
  	          );
  	          return {
  	            ok: false
  	          };
  	        }
  	
  	        showError("fuel-intertank-target-error", "");
  	        showHelp(
  	          "fuel-intertank-target-help",
  	          managerIsTrailerTank(targetTank)
  	            ? "Trailer destination: litres and stock value transfer, and the trailer inherits the source price per litre for vehicle dispensing."
  	            : "Fixed tank destination: litres and stock value transfer, while the destination tank price per litre remains unchanged."
  	        );
  	        return {
  	          ok: true,
  	          targetTank: targetTank
  	        };
  	      }
  	
  	      function sanitizeNumeric(value) {
  	        return String(value || "").replace(/[^0-9.,]/g, "");
  	      }
  	
  	      function displayNumber(value, decimals) {
  	        var n = toNumber(value, 0);
  	        return n.toFixed(decimals);
  	      }
  	
  	      function formatCurrency(value) {
  	        return "R " + displayNumber(value, 2);
  	      }
  	
  	      function pad2(v) {
  	        return String(v).padStart(2, "0");
  	      }
  	
  	      function getUtcDate(value) {
  	        var d = value ? new Date(value): new Date();
  	        if (isNaN(d.getTime())) d = new Date();
  	        return d;
  	      }
  	
  	      function getBusinessDate(value) {
  	        var utcDate = getUtcDate(value);
  	        return new Date(utcDate.getTime() + (BUSINESS_TIMEZONE_OFFSET_MINUTES * 60000));
  	      }
  	
  	      function ensureBusinessDate(value) {
  	        if (value instanceof Date) {
  	          return new Date(value.getTime());
  	        }
  	        return getBusinessDate(value);
  	      }
  	
  	      function getBusinessNowDate() {
  	        return getBusinessDate(new Date().toISOString());
  	      }
  	
  	      function getNowDate() {
  	        return getBusinessNowDate();
  	      }
  	
  	      function getNowIso() {
  	        return new Date().toISOString();
  	      }
  	
  	      function getMYear(dateObj) {
  	        var d = dateObj ? ensureBusinessDate(dateObj): getBusinessNowDate();
  	        return d.getUTCFullYear() + "-" + pad2(d.getUTCMonth() + 1);
  	      }
  	
  	      function getMonthLabel(dateObj) {
  	        var d = dateObj ? ensureBusinessDate(dateObj): getBusinessNowDate();
  	        var names = [
  	          "January",
  	          "February",
  	          "March",
  	          "April",
  	          "May",
  	          "June",
  	          "July",
  	          "August",
  	          "September",
  	          "October",
  	          "November",
  	          "December"
  	        ];
  	        return names[d.getUTCMonth()] + " " + d.getUTCFullYear();
  	      }
  	
  	      function getMonthStartMs(dateObj) {
  	        var d = dateObj ? ensureBusinessDate(dateObj): getBusinessNowDate();
  	        return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1, 0, 0, 0, 0);
  	      }
  	
  	      function getMonthEndMs(dateObj) {
  	        var d = dateObj ? ensureBusinessDate(dateObj): getBusinessNowDate();
  	        return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 1, 0, 0, 0, 0) - 1;
  	      }
  	
  	      function sameKey(a, b) {
  	        var left = String(a === null || a === undefined ? "": a).trim();
  	        var right = String(b === null || b === undefined ? "": b).trim();
  	
  	        if (!left || !right) return false;
  	
  	        return left === right;
  	      }
  	
  	      function sameObjectId(a, b) {
  	        return sameKey(a, b);
  	      }
  	
  	      function findIndexByKeys(items, candidate) {
  	        var arr = toArray(items);
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          var row = arr[i];
  	
  	          if (
  	            sameKey(getDeep(row, ["objectId"], null), getDeep(candidate, ["objectId"], null)) ||
  	            sameKey(getDeep(row, ["FID"], null), getDeep(candidate, ["FID"], null)) ||
  	            sameKey(getDeep(row, ["Registration"], null), getDeep(candidate, ["Registration"], null)) ||
  	            sameKey(getDeep(row, ["Name"], null), getDeep(candidate, ["Name"], null)) ||
  	            sameKey(getDeep(row, ["DeviceId"], null), getDeep(candidate, ["DeviceId"], null))
  	          ) {
  	            return i;
  	          }
  	        }
  	
  	        return -1;
  	      }
  	
  	      function saveTableRow(tableName, row) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          return Promise.reject(new Error("Backendless SDK is not available"));
  	        }
  	
  	        return managerTrackDatabasePromise(
  	          managerDatabaseStatus("save", tableName),
  	          function () {
  	            return backendless.Data
  	              .of(tableName)
  	              .save(row);
  	          }
  	        );
  	      }
  	
  	      function loadTableRow(tableName, objectId, relations) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          return Promise.reject(new Error("Backendless SDK is not available"));
  	        }
  	
  	        var builder = backendless.DataQueryBuilder ? backendless.DataQueryBuilder.create(): null;
  	        if (builder && relations && relations.length) {
  	          builder.setRelated(relations);
  	        }
  	        if (builder && typeof builder.setRelationsPageSize === "function") {
  	          builder.setRelationsPageSize(100);
  	        }
  	
  	        if (backendless.Data.of(tableName).findById.length >= 2) {
  	          return backendless.Data.of(tableName).findById(objectId, builder || undefined);
  	        }
  	
  	        return backendless.Data.of(tableName).findById(objectId);
  	      }
  	
  	      async function loadAllRelationRows(parentTable, parentObjectId, relationName) {
  	        if (!parentObjectId || !relationName) return [];
  	
  	        if (
  	          !backendless ||
  	          !backendless.Data ||
  	          !backendless.Data.of ||
  	          !backendless.LoadRelationsQueryBuilder
  	        ) {
  	          return [];
  	        }
  	
  	        var api = backendless.Data.of(parentTable);
  	        if (!api || typeof api.loadRelations !== "function") return [];
  	
  	        var builder = backendless.LoadRelationsQueryBuilder.create();
  	        builder.setRelationName(relationName);
  	
  	        var pageSize = 100;
  	        if (typeof builder.setPageSize === "function") {
  	          builder.setPageSize(pageSize);
  	        }
  	
  	        var result = [];
  	        var safety = 0;
  	
  	        while (safety < 100) {
  	          safety++;
  	
  	          var page = await api.loadRelations(parentObjectId, builder);
  	          var rows = Array.isArray(page)
  	            ? page
  	            : toArray(page && page.data ? page.data : []);
  	
  	          result = result.concat(rows);
  	
  	          if (rows.length < pageSize) break;
  	
  	          if (typeof builder.prepareNextPage === "function") {
  	            builder.prepareNextPage();
  	          } else if (typeof builder.setOffset === "function") {
  	            builder.setOffset(result.length);
  	          } else {
  	            break;
  	          }
  	        }
  	
  	        return result;
  	      }
  	
  	      function deleteTableRow(tableName, objectId) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          return Promise.reject(new Error("Backendless SDK is not available"));
  	        }
  	
  	        if (!objectId) {
  	          return Promise.resolve(null);
  	        }
  	
  	        return managerTrackDatabasePromise(
  	          managerDatabaseStatus(
  	            "delete",
  	            tableName
  	          ),
  	          function () {
  	            return backendless.Data
  	              .of(tableName)
  	              .remove({
  	                objectId: objectId
  	              });
  	          }
  	        );
  	      }
  	
  	      function setRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          return Promise.reject(new Error("Backendless SDK is not available"));
  	        }
  	
  	        if (!parentObjectId) {
  	          return Promise.resolve(null);
  	        }
  	
  	        var ids = toArray(childObjectIds).filter(function (id) {
  	          return !!id;
  	        });
  	
  	        var tableApi = backendless.Data.of(tableName);
  	
  	        if (typeof tableApi.setRelation !== "function") {
  	          return Promise.reject(
  	            new Error("Backendless setRelation is not available for " + tableName + "." + relationName)
  	          );
  	        }
  	
  	        return tableApi.setRelation(
  	          {
  	            objectId: parentObjectId
  	          },
  	          relationName,
  	          ids
  	        );
  	      }
  	
  	
  	      function addRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          return Promise.reject(new Error("Backendless SDK is not available"));
  	        }
  	
  	        if (!parentObjectId) {
  	          return Promise.resolve(null);
  	        }
  	
  	        var ids = toArray(childObjectIds).filter(function (id) {
  	          return !!id;
  	        });
  	
  	        return backendless.Data.of(tableName).addRelation(
  	          {
  	            objectId: parentObjectId
  	          },
  	          relationName,
  	          ids
  	        );
  	      }
  	
  	
  	      function relationCollectionToArray(value) {
  	        if (value === null || value === undefined) {
  	          return [];
  	        }
  	
  	        if (Array.isArray(value)) {
  	          return Array.prototype.slice.call(value);
  	        }
  	
  	        /*
  	         * Backendless UI may expose relation collections through a reactive
  	         * proxy which is array-like but does not always pass Array.isArray().
  	         */
  	        if (
  	          typeof value === "object" &&
  	          Number.isFinite(Number(value.length)) &&
  	          Number(value.length) >= 0
  	        ) {
  	          var arrayLike = [];
  	
  	          for (
  	            var arrayIndex = 0;
  	            arrayIndex < Number(value.length);
  	            arrayIndex++
  	          ) {
  	            if (value[arrayIndex] !== undefined) {
  	              arrayLike.push(value[arrayIndex]);
  	            }
  	          }
  	
  	          if (arrayLike.length || Number(value.length) === 0) {
  	            return arrayLike;
  	          }
  	        }
  	
  	        try {
  	          if (
  	            typeof Symbol !== "undefined" &&
  	            value &&
  	            typeof value[Symbol.iterator] === "function"
  	          ) {
  	            return Array.from(value);
  	          }
  	        } catch (_) {}
  	
  	        return [value];
  	      }
  	
  	      function normalizeTyreStageKey(value) {
  	        return String(value || "")
  	        .trim()
  	        .toLowerCase()
  	        .replace(/[^a-z0-9]/g, "");
  	      }
  	
  	      function resolveTyreHistoryStageKey(history, currentStage) {
  	        if (!history || typeof history !== "object") {
  	          return "";
  	        }
  	
  	        var direct = String(currentStage || "").trim();
  	
  	        if (
  	          direct &&
  	          history[direct] &&
  	          typeof history[direct] === "object"
  	        ) {
  	          return direct;
  	        }
  	
  	        var wanted = normalizeTyreStageKey(direct);
  	        if (!wanted) return "";
  	
  	        var keys = Object.keys(history);
  	
  	        for (var index = 0; index < keys.length; index++) {
  	          var key = keys[index];
  	
  	          if (
  	            normalizeTyreStageKey(key) === wanted &&
  	            history[key] &&
  	            typeof history[key] === "object"
  	          ) {
  	            return key;
  	          }
  	        }
  	
  	        return "";
  	      }
  	
  	      function isTyreCurrentlyFittedToVehicle(tyreRow, vehicleObj) {
  	        if (!tyreRow || typeof tyreRow !== "object") {
  	          return false;
  	        }
  	
  	        var tyreObjectId = text(
  	          getDeep(tyreRow, ["objectId"], ""),
  	          ""
  	        );
  	
  	        if (!tyreObjectId) {
  	          return false;
  	        }
  	
  	        var fittedValue = getDeep(tyreRow, ["Is_Fitted"], true);
  	
  	        if (
  	          fittedValue === false ||
  	          String(fittedValue).trim().toLowerCase() === "false"
  	        ) {
  	          return false;
  	        }
  	
  	        var holderType = text(
  	          getDeep(tyreRow, ["Current_Holder_Type"], ""),
  	          ""
  	        ).trim().toLowerCase();
  	
  	        if (holderType && holderType !== "vehicle") {
  	          return false;
  	        }
  	
  	        var vehicleObjectId = text(
  	          getDeep(vehicleObj, ["objectId"], ""),
  	          ""
  	        );
  	
  	        var tyreVehicleObjectId = text(
  	          firstDefined(
  	            getDeep(tyreRow, ["Current_Holder_ObjectId"], null),
  	            getDeep(tyreRow, ["Vehicle_ObjectId"], null),
  	            getDeep(
  	              tyreRow,
  	              ["History", "Current", "Vehicle_ObjectId"],
  	              null
  	            )
  	          ),
  	          ""
  	        );
  	
  	        if (
  	          vehicleObjectId &&
  	          tyreVehicleObjectId &&
  	          !sameObjectId(vehicleObjectId, tyreVehicleObjectId)
  	        ) {
  	          return false;
  	        }
  	
  	        return true;
  	      }
  	
  	      function getFittedVehicleTyres(vehicleObj) {
  	        var source = relationCollectionToArray(
  	          getDeep(vehicleObj, ["Tyres"], [])
  	        );
  	        var seen = {};
  	        var result = [];
  	
  	        for (var index = 0; index < source.length; index++) {
  	          var tyreRow = source[index];
  	
  	          if (!isTyreCurrentlyFittedToVehicle(tyreRow, vehicleObj)) {
  	            continue;
  	          }
  	
  	          var objectId = text(
  	            getDeep(tyreRow, ["objectId"], ""),
  	            ""
  	          );
  	
  	          if (!objectId || seen[objectId]) {
  	            continue;
  	          }
  	
  	          seen[objectId] = true;
  	          result.push(tyreRow);
  	        }
  	
  	        return result;
  	      }
  	      
  	            function isSpareTyreMileageRow(tyreRow) {
  	        var position = text(
  	          firstDefined(
  	            getDeep(tyreRow, ["Current_Position"], null),
  	            getDeep(
  	              tyreRow,
  	              ["History", "Current", "Position"],
  	              null
  	            )
  	          ),
  	          ""
  	        )
  	          .replace(/[\s_-]+/g, "")
  	          .toUpperCase();
  	
  	        var axleType = text(
  	          firstDefined(
  	            getDeep(tyreRow, ["Current_Axle_Type"], null),
  	            getDeep(
  	              tyreRow,
  	              ["History", "Current", "Axle_Type"],
  	              null
  	            )
  	          ),
  	          ""
  	        )
  	          .trim()
  	          .toUpperCase();
  	
  	        return (
  	          /^SP(?:ARE)?\d*$/.test(position) ||
  	          axleType === "SPARE"
  	        );
  	      }
  	
  	      function resolveVehicleTyreWearRate(vehicleObj, tyreRow) {
  	        if (isSpareTyreMileageRow(tyreRow)) return 0;
  	
  	        var position = text(
  	          firstDefined(
  	            getDeep(tyreRow, ["Current_Position"], null),
  	            getDeep(tyreRow, ["History", "Current", "Position"], null)
  	          ),
  	          ""
  	        );
  	
  	        var tPositions = firstDefined(
  	          getDeep(vehicleObj, ["TPositions"], null),
  	          getDeep(vehicleObj, ["TyrePositions"], null),
  	          getDeep(vehicleObj, ["Data", "TPositions"], null),
  	          getDeep(vehicleObj, ["Data", "TyrePositions"], null)
  	        );
  	
  	        if (typeof tPositions === "string") {
  	          try {
  	            tPositions = JSON.parse(tPositions);
  	          } catch (_) {
  	            tPositions = null;
  	          }
  	        }
  	
  	        var positions =
  	          tPositions && typeof tPositions === "object" && !Array.isArray(tPositions)
  	            ? getDeep(tPositions, ["Positions"], {})
  	            : {};
  	
  	        var slot = position && positions ? positions[position] : null;
  	
  	        if (!slot && position && positions) {
  	          var wanted = String(position).replace(/[\s_-]+/g, "").toUpperCase();
  	          var keys = Object.keys(positions);
  	          for (var keyIndex = 0; keyIndex < keys.length; keyIndex++) {
  	            if (
  	              String(keys[keyIndex]).replace(/[\s_-]+/g, "").toUpperCase() ===
  	              wanted
  	            ) {
  	              slot = positions[keys[keyIndex]];
  	              break;
  	            }
  	          }
  	        }
  	
  	        var axleType = text(
  	          firstDefined(
  	            slot && slot.AxleType,
  	            getDeep(tyreRow, ["Current_Axle_Type"], null),
  	            getDeep(tyreRow, ["History", "Current", "Axle_Type"], null)
  	          ),
  	          ""
  	        ).trim().toLowerCase();
  	
  	        if (axleType === "spare") return 0;
  	
  	        if (axleType === "tag") {
  	          var tagRate = toNumber(
  	            firstDefined(
  	              slot && slot.WearRate,
  	              getDeep(tyreRow, ["Current_Wear_Rate"], null),
  	              1
  	            ),
  	            1
  	          );
  	          return Math.max(0, Math.min(1, tagRate));
  	        }
  	
  	        return 1;
  	      }
  	
  	      function buildTyreMileageUpdate(
  	        vehicleObj,
  	        tyreRow,
  	        mileageDifferential,
  	        newVehicleMileage
  	      ) {
  	        var fallbackDifferential = Math.max(
  	          0,
  	          toNumber(mileageDifferential, 0)
  	        );
  	
  	        var tyreLastVehicleOdometer = toNumber(
  	          getDeep(
  	            tyreRow,
  	            ["Last_Vehicle_Odometer"],
  	            null
  	          ),
  	          NaN
  	        );
  	
  	        var vehicleMileage = toNumber(
  	          newVehicleMileage,
  	          NaN
  	        );
  	
  	        var differential = fallbackDifferential;
  	
  	        /*
  	         * Prefer the tyre's own last vehicle reading. Despite the legacy
  	         * Last_Vehicle_Odometer field name, the stored baseline follows the
  	         * vehicle's canonical operating counter: kilometres for odometer
  	         * vehicles and hours for Hobbs/hour vehicles. This keeps tyre usage
  	         * self-healing across both counter types.
  	         */
  	        if (
  	          Number.isFinite(tyreLastVehicleOdometer) &&
  	          tyreLastVehicleOdometer > 0 &&
  	          Number.isFinite(vehicleMileage)
  	        ) {
  	          differential =
  	            vehicleMileage >= tyreLastVehicleOdometer
  	              ? vehicleMileage - tyreLastVehicleOdometer
  	              : 0;
  	        }
  	
  	        var wearRate =
  	          resolveVehicleTyreWearRate(
  	            vehicleObj,
  	            tyreRow
  	          );
  	
  	        differential =
  	          Math.round(
  	            differential *
  	            wearRate *
  	            1000
  	          ) / 1000;
  	
  	        var objectId = text(
  	          getDeep(tyreRow, ["objectId"], ""),
  	          ""
  	        );
  	
  	        if (!objectId) {
  	          return null;
  	        }
  	
  	        /*
  	         * Spare tyres remain mileage-neutral. Their vehicle-odometer
  	         * baseline is still moved forward so that they cannot inherit
  	         * distance travelled while stored as a spare when later fitted
  	         * to a rolling position.
  	         */
  	        if (isSpareTyreMileageRow(tyreRow)) {
  	          var unchangedCurrentMileage = Math.max(
  	            0,
  	            toNumber(
  	              getDeep(tyreRow, ["Current_Mileage"], 0),
  	              0
  	            )
  	          );
  	
  	          return {
  	            source: tyreRow,
  	            patch: {
  	              objectId: objectId,
  	              Last_Vehicle_Odometer: newVehicleMileage
  	            },
  	            objectId: objectId,
  	            stageKey: "",
  	            oldCurrentMileage: unchangedCurrentMileage,
  	            newCurrentMileage: unchangedCurrentMileage,
  	            oldStageMileage: 0,
  	            newStageMileage: 0,
  	            spareBaselineOnly: true
  	          };
  	        }
  	
  	        if (!(differential > 0)) {
  	          return null;
  	        }
  	
  	        var currentStage = text(
  	          firstDefined(
  	            getDeep(tyreRow, ["Current_Stage"], null),
  	            getDeep(tyreRow, ["History", "Current", "Stage"], null)
  	          ),
  	          ""
  	        );
  	
  	        var history = deepClone(
  	          getDeep(tyreRow, ["History"], {})
  	        );
  	
  	        if (!history || typeof history !== "object") {
  	          history = {};
  	        }
  	
  	        var stageKey = resolveTyreHistoryStageKey(
  	          history,
  	          currentStage
  	        );
  	
  	        if (!stageKey) {
  	          throw new Error(
  	            "Tyre " +
  	            text(
  	              firstDefined(
  	                getDeep(tyreRow, ["Tyre_Number"], null),
  	                getDeep(tyreRow, ["FID"], null),
  	                objectId
  	              ),
  	              objectId
  	            ) +
  	            " has Current_Stage '" +
  	            currentStage +
  	            "' but no matching History stage."
  	          );
  	        }
  	
  	        var stage = deepClone(history[stageKey] || {});
  	        var oldCurrentMileage = Math.max(
  	          0,
  	          toNumber(
  	            getDeep(tyreRow, ["Current_Mileage"], 0),
  	            0
  	          )
  	        );
  	
  	        var oldTotalMileage = Math.max(
  	          0,
  	          toNumber(
  	            firstDefined(
  	              getDeep(tyreRow, ["Total_Mileage"], null),
  	              oldCurrentMileage
  	            ),
  	            oldCurrentMileage
  	          )
  	        );
  	
  	        var oldStageMileage = Math.max(
  	          0,
  	          toNumber(
  	            getDeep(stage, ["Mileage_Done"], 0),
  	            0
  	          )
  	        );
  	
  	        var newCurrentMileage =
  	          oldCurrentMileage + differential;
  	        var newTotalMileage =
  	          oldTotalMileage + differential;
  	        var newStageMileage =
  	          oldStageMileage + differential;
  	
  	        stage.Mileage_Done = newStageMileage;
  	        stage.End_Mileage = newCurrentMileage;
  	        history[stageKey] = stage;
  	
  	        if (
  	          !history.Totals ||
  	          typeof history.Totals !== "object" ||
  	          Array.isArray(history.Totals)
  	        ) {
  	          history.Totals = {};
  	        }
  	
  	        history.Totals.Mileage_Total =
  	          Math.max(
  	            0,
  	            toNumber(
  	              getDeep(
  	                history,
  	                ["Totals", "Mileage_Total"],
  	                0
  	              ),
  	              0
  	            )
  	          ) + differential;
  	
  	        var patch = {
  	          objectId: objectId,
  	          Current_Mileage: newCurrentMileage,
  	          Total_Mileage: newTotalMileage,
  	          Last_Vehicle_Odometer: newVehicleMileage,
  	          Current_Wear_Rate: wearRate,
  	          History: history
  	        };
  	
  	        var expectedMileage = toNumber(
  	          getDeep(tyreRow, ["Expected_Mileage"], null),
  	          NaN
  	        );
  	
  	        if (
  	          Number.isFinite(expectedMileage) &&
  	          expectedMileage >= 0
  	        ) {
  	          patch.Remaining_Mileage = Math.max(
  	            0,
  	            expectedMileage - newCurrentMileage
  	          );
  	        }
  	
  	        return {
  	          source: tyreRow,
  	          patch: patch,
  	          objectId: objectId,
  	          stageKey: stageKey,
  	          oldCurrentMileage: oldCurrentMileage,
  	          newCurrentMileage: newCurrentMileage,
  	          oldStageMileage: oldStageMileage,
  	          newStageMileage: newStageMileage
  	        };
  	      }
  	
  	      function calculateLiveTyreCurrentLife(
  	        liveTyre,
  	        source
  	      ) {
  	        var expectedMileage = toNumber(
  	          firstDefined(
  	            getDeep(source, ["Expected_Mileage"], null),
  	            getDeep(liveTyre, ["Expected_Mileage"], null)
  	          ),
  	          NaN
  	        );
  	
  	        var currentMileage = Math.max(
  	          0,
  	          toNumber(
  	            firstDefined(
  	              getDeep(source, ["Current_Mileage"], null),
  	              getDeep(liveTyre, ["Current_Mileage"], null)
  	            ),
  	            0
  	          )
  	        );
  	
  	        if (
  	          !Number.isFinite(expectedMileage) ||
  	          expectedMileage <= 0
  	        ) {
  	          return toNumber(
  	            getDeep(liveTyre, ["Current_Life"], 0),
  	            0
  	          );
  	        }
  	
  	        var remainingMileage = toNumber(
  	          firstDefined(
  	            getDeep(source, ["Remaining_Mileage"], null),
  	            expectedMileage - currentMileage
  	          ),
  	          expectedMileage - currentMileage
  	        );
  	
  	        var currentLife = Math.max(
  	          0,
  	          Math.min(
  	            100,
  	            (remainingMileage / expectedMileage) * 100
  	          )
  	        );
  	
  	        return Math.round(currentLife * 100) / 100;
  	      }
  	
  	      function applySavedTyreMileageToLiveRow(
  	        liveTyre,
  	        savedTyre,
  	        fallbackPatch
  	      ) {
  	        if (!liveTyre || typeof liveTyre !== "object") {
  	          return;
  	        }
  	
  	        var source =
  	          savedTyre && typeof savedTyre === "object"
  	            ? savedTyre
  	            : fallbackPatch;
  	
  	        if (!source || typeof source !== "object") {
  	          return;
  	        }
  	
  	        var fields = [
  	          "Current_Mileage",
  	          "Total_Mileage",
  	          "Last_Vehicle_Odometer",
  	          "Remaining_Mileage"
  	        ];
  	
  	        for (var index = 0; index < fields.length; index++) {
  	          var field = fields[index];
  	
  	          if (
  	            Object.prototype.hasOwnProperty.call(
  	              source,
  	              field
  	            )
  	          ) {
  	            liveTyre[field] = source[field];
  	          }
  	        }
  	
  	        if (
  	          Object.prototype.hasOwnProperty.call(
  	            source,
  	            "History"
  	          )
  	        ) {
  	          liveTyre.History = deepClone(source.History);
  	        }
  	
  	        if (
  	          Object.prototype.hasOwnProperty.call(
  	            source,
  	            "updated"
  	          )
  	        ) {
  	          liveTyre.updated = source.updated;
  	        }
  	
  	        /*
  	         * Current_Life is a calculated Backendless field. Do not include it
  	         * in the database patch. Recalculate it only on the live AppData row
  	         * so every tyre UI sees the fresh percentage without a new login.
  	         */
  	        liveTyre.Current_Life =
  	          calculateLiveTyreCurrentLife(
  	            liveTyre,
  	            source
  	          );
  	
  	        if (
  	          savedTyre &&
  	          typeof savedTyre === "object"
  	        ) {
  	          savedTyre.Current_Life =
  	            liveTyre.Current_Life;
  	        }
  	      }
  	
  	      function mergeVehicleTyresIntoLiveAppData(
  	        liveVehicle,
  	        sourceVehicle
  	      ) {
  	        if (
  	          !liveVehicle ||
  	          typeof liveVehicle !== "object" ||
  	          !sourceVehicle ||
  	          typeof sourceVehicle !== "object"
  	        ) {
  	          return;
  	        }
  	
  	        var liveTyres = relationCollectionToArray(
  	          getDeep(liveVehicle, ["Tyres"], [])
  	        );
  	        var sourceTyres = relationCollectionToArray(
  	          getDeep(sourceVehicle, ["Tyres"], [])
  	        );
  	
  	        for (
  	          var sourceIndex = 0;
  	          sourceIndex < sourceTyres.length;
  	          sourceIndex++
  	        ) {
  	          var sourceTyre = sourceTyres[sourceIndex];
  	          var sourceId = getDeep(
  	            sourceTyre,
  	            ["objectId"],
  	            null
  	          );
  	
  	          if (!sourceId) continue;
  	
  	          var liveIndex = -1;
  	
  	          for (
  	            var liveIndexSearch = 0;
  	            liveIndexSearch < liveTyres.length;
  	            liveIndexSearch++
  	          ) {
  	            if (
  	              sameObjectId(
  	                getDeep(
  	                  liveTyres[liveIndexSearch],
  	                  ["objectId"],
  	                  null
  	                ),
  	                sourceId
  	              )
  	            ) {
  	              liveIndex = liveIndexSearch;
  	              break;
  	            }
  	          }
  	
  	          if (liveIndex >= 0) {
  	            applySavedTyreMileageToLiveRow(
  	              liveTyres[liveIndex],
  	              sourceTyre,
  	              sourceTyre
  	            );
  	          } else {
  	            liveTyres.push(deepClone(sourceTyre));
  	          }
  	        }
  	
  	        liveVehicle.Tyres = liveTyres;
  	      }
  	
  	      function buildTyreMileageRollback(
  	        vehicleObj,
  	        tyreRow,
  	        mileageDifferential,
  	        newVehicleMileage
  	      ) {
  	        var differential = Math.max(
  	          0,
  	          toNumber(mileageDifferential, 0)
  	        );
  	
  	        if (!(differential > 0)) return null;
  	
  	        var objectId = text(
  	          getDeep(tyreRow, ["objectId"], ""),
  	          ""
  	        );
  	
  	        if (!objectId) return null;
  	
  	        var currentStage = text(
  	          firstDefined(
  	            getDeep(tyreRow, ["Current_Stage"], null),
  	            getDeep(tyreRow, ["History", "Current", "Stage"], null)
  	          ),
  	          ""
  	        );
  	
  	        var history = deepClone(
  	          getDeep(tyreRow, ["History"], {})
  	        );
  	
  	        if (!history || typeof history !== "object") {
  	          history = {};
  	        }
  	
  	        var stageKey = resolveTyreHistoryStageKey(
  	          history,
  	          currentStage
  	        );
  	
  	        if (!stageKey) {
  	          throw new Error(
  	            "Tyre " + objectId +
  	            " has no History stage matching Current_Stage '" +
  	            currentStage + "'."
  	          );
  	        }
  	
  	        var stage = deepClone(history[stageKey] || {});
  	        var oldCurrentMileage = Math.max(
  	          0,
  	          toNumber(getDeep(tyreRow, ["Current_Mileage"], 0), 0)
  	        );
  	        var oldTotalMileage = Math.max(
  	          0,
  	          toNumber(
  	            firstDefined(
  	              getDeep(tyreRow, ["Total_Mileage"], null),
  	              oldCurrentMileage
  	            ),
  	            oldCurrentMileage
  	          )
  	        );
  	        var oldStageMileage = Math.max(
  	          0,
  	          toNumber(getDeep(stage, ["Mileage_Done"], 0), 0)
  	        );
  	
  	        var rollbackWearRate =
  	          resolveVehicleTyreWearRate(
  	            vehicleObj,
  	            tyreRow
  	          );
  	
  	        if (rollbackWearRate <= 0) {
  	          return {
  	            source: tyreRow,
  	            patch: {
  	              objectId: objectId,
  	              Last_Vehicle_Odometer: newVehicleMileage,
  	              Current_Wear_Rate: rollbackWearRate
  	            },
  	            objectId: objectId,
  	            appliedDifferential: 0,
  	            spareBaselineOnly: true
  	          };
  	        }
  	
  	        var appliedDifferential = Math.min(
  	          Math.round(
  	            differential *
  	            rollbackWearRate *
  	            1000
  	          ) / 1000,
  	          oldCurrentMileage
  	        );
  	
  	        if (!(appliedDifferential > 0)) return null;
  	
  	        var newCurrentMileage = Math.max(
  	          0,
  	          oldCurrentMileage - appliedDifferential
  	        );
  	        var newTotalMileage = Math.max(
  	          0,
  	          oldTotalMileage - appliedDifferential
  	        );
  	        var newStageMileage = Math.max(
  	          0,
  	          oldStageMileage - appliedDifferential
  	        );
  	
  	        stage.Mileage_Done = newStageMileage;
  	        stage.End_Mileage = newCurrentMileage;
  	        history[stageKey] = stage;
  	
  	        if (
  	          !history.Totals ||
  	          typeof history.Totals !== "object" ||
  	          Array.isArray(history.Totals)
  	        ) {
  	          history.Totals = {};
  	        }
  	
  	        history.Totals.Mileage_Total = Math.max(
  	          0,
  	          toNumber(
  	            getDeep(history, ["Totals", "Mileage_Total"], 0),
  	            0
  	          ) - appliedDifferential
  	        );
  	
  	        var patch = {
  	          objectId: objectId,
  	          Current_Mileage: newCurrentMileage,
  	          Total_Mileage: newTotalMileage,
  	          Last_Vehicle_Odometer: newVehicleMileage,
  	          Current_Wear_Rate: rollbackWearRate,
  	          History: history
  	        };
  	
  	        var expectedMileage = toNumber(
  	          getDeep(tyreRow, ["Expected_Mileage"], null),
  	          NaN
  	        );
  	
  	        if (Number.isFinite(expectedMileage) && expectedMileage >= 0) {
  	          patch.Remaining_Mileage = Math.max(
  	            0,
  	            expectedMileage - newCurrentMileage
  	          );
  	        }
  	
  	        return {
  	          source: tyreRow,
  	          patch: patch,
  	          objectId: objectId,
  	          appliedDifferential: appliedDifferential
  	        };
  	      }
  	
  	      async function bulkRollbackVehicleTyreMileage(
  	        vehicleObj,
  	        mileageDifferential,
  	        newVehicleMileage
  	      ) {
  	        var differential = Math.max(
  	          0,
  	          toNumber(mileageDifferential, 0)
  	        );
  	        var fittedTyres = getFittedVehicleTyres(vehicleObj);
  	        var updates = [];
  	
  	        for (var index = 0; index < fittedTyres.length; index++) {
  	          var update = buildTyreMileageRollback(
  	            vehicleObj,
  	            fittedTyres[index],
  	            differential,
  	            newVehicleMileage
  	          );
  	          if (update) updates.push(update);
  	        }
  	
  	        if (!updates.length) {
  	          console.warn(
  	            "[Tyre Mileage Rollback] No tyre patches were produced.",
  	            {
  	              vehicleObjectId: getDeep(
  	                vehicleObj,
  	                ["objectId"],
  	                null
  	              ),
  	              differential: differential,
  	              newVehicleMileage: newVehicleMileage,
  	              fittedTyreCount: fittedTyres.length,
  	              tyreRelationCount:
  	                relationCollectionToArray(
  	                  getDeep(vehicleObj, ["Tyres"], [])
  	                ).length
  	            }
  	          );
  	
  	          return {
  	            updatedCount: 0,
  	            differential: differential,
  	            updatedTyres: []
  	          };
  	        }
  	
  	        var savedRows = await Promise.all(
  	          updates.map(function (update) {
  	            return saveTableRow("Tyres", update.patch);
  	          })
  	        );
  	
  	        var liveVehicleTyres = relationCollectionToArray(
  	          getDeep(vehicleObj, ["Tyres"], [])
  	        );
  	
  	        for (var savedIndex = 0; savedIndex < updates.length; savedIndex++) {
  	          var currentUpdate = updates[savedIndex];
  	          var savedRow = savedRows[savedIndex] || currentUpdate.patch;
  	
  	          for (var liveIndex = 0; liveIndex < liveVehicleTyres.length; liveIndex++) {
  	            if (
  	              sameObjectId(
  	                getDeep(liveVehicleTyres[liveIndex], ["objectId"], null),
  	                currentUpdate.objectId
  	              )
  	            ) {
  	              applySavedTyreMileageToLiveRow(
  	                liveVehicleTyres[liveIndex],
  	                savedRow,
  	                currentUpdate.patch
  	              );
  	              break;
  	            }
  	          }
  	
  	          applySavedTyreMileageToLiveRow(
  	            currentUpdate.source,
  	            savedRow,
  	            currentUpdate.patch
  	          );
  	        }
  	
  	        vehicleObj.Tyres = liveVehicleTyres;
  	
  	        return {
  	          updatedCount: updates.length,
  	          differential: differential,
  	          updatedTyres: savedRows
  	        };
  	      }
  	
  	      async function bulkUpdateVehicleTyreMileage(
  	        vehicleObj,
  	        mileageDifferential,
  	        newVehicleMileage
  	      ) {
  	        var differential = toNumber(
  	          mileageDifferential,
  	          0
  	        );
  	
  	        var emptyResult = {
  	          updatedCount: 0,
  	          differential: differential,
  	          vehicleMileage: newVehicleMileage,
  	          updatedTyres: []
  	        };
  	
  	        if (!vehicleObj) {
  	          console.warn(
  	            "[Tyre Mileage Sync] Skipped because no vehicle object was supplied."
  	          );
  	          return emptyResult;
  	        }
  	
  	        var fittedTyres = getFittedVehicleTyres(
  	          vehicleObj
  	        );
  	
  	        if (!fittedTyres.length) {
  	          console.warn(
  	            "[Tyre Mileage Sync] No fitted tyre rows were resolved.",
  	            {
  	              vehicleObjectId: getDeep(
  	                vehicleObj,
  	                ["objectId"],
  	                null
  	              ),
  	              vehicleMileage: newVehicleMileage,
  	              mileageDifferential: differential,
  	              tyreRelationValue: getDeep(
  	                vehicleObj,
  	                ["Tyres"],
  	                null
  	              ),
  	              tyreRelationCount:
  	                relationCollectionToArray(
  	                  getDeep(vehicleObj, ["Tyres"], [])
  	                ).length,
  	              tyreReferenceCount:
  	                relationCollectionToArray(
  	                  getDeep(
  	                    vehicleObj,
  	                    ["Data", "Tyres", "TyreRecords"],
  	                    []
  	                  )
  	                ).length
  	            }
  	          );
  	
  	          return emptyResult;
  	        }
  	
  	        var updates = [];
  	
  	        for (
  	          var tyreIndex = 0;
  	          tyreIndex < fittedTyres.length;
  	          tyreIndex++
  	        ) {
  	          var update = buildTyreMileageUpdate(
  	            vehicleObj,
  	            fittedTyres[tyreIndex],
  	            differential,
  	            newVehicleMileage
  	          );
  	
  	          if (update) {
  	            updates.push(update);
  	          }
  	        }
  	
  	        if (!updates.length) {
  	          console.warn(
  	            "[Tyre Mileage Sync] Fitted tyres were found but no positive tyre mileage update was required.",
  	            {
  	              vehicleObjectId: getDeep(
  	                vehicleObj,
  	                ["objectId"],
  	                null
  	              ),
  	              vehicleMileage: newVehicleMileage,
  	              mileageDifferential: differential,
  	              tyreStates: fittedTyres.map(function (tyreRow) {
  	                return {
  	                  objectId: getDeep(
  	                    tyreRow,
  	                    ["objectId"],
  	                    null
  	                  ),
  	                  currentMileage: getDeep(
  	                    tyreRow,
  	                    ["Current_Mileage"],
  	                    null
  	                  ),
  	                  lastVehicleOdometer: getDeep(
  	                    tyreRow,
  	                    ["Last_Vehicle_Odometer"],
  	                    null
  	                  )
  	                };
  	              })
  	            }
  	          );
  	
  	          return emptyResult;
  	        }
  	
  	        /*
  	         * Every tyre needs its own History JSON patch, so Backendless'
  	         * same-value bulkUpdate cannot safely be used here. All individual
  	         * Tyres saves are dispatched together and awaited as one bulk pass.
  	         */
  	        var savedRows = await Promise.all(
  	          updates.map(function (update) {
  	            return saveTableRow(
  	              "Tyres",
  	              update.patch
  	            );
  	          })
  	        );
  	
  	        var liveVehicleTyres = relationCollectionToArray(
  	          getDeep(vehicleObj, ["Tyres"], [])
  	        );
  	
  	        for (
  	          var savedIndex = 0;
  	          savedIndex < updates.length;
  	          savedIndex++
  	        ) {
  	          var currentUpdate = updates[savedIndex];
  	          var savedRow =
  	            savedRows[savedIndex] ||
  	            currentUpdate.patch;
  	
  	          var liveIndex = -1;
  	
  	          for (
  	            var liveTyreIndex = 0;
  	            liveTyreIndex < liveVehicleTyres.length;
  	            liveTyreIndex++
  	          ) {
  	            if (
  	              sameObjectId(
  	                getDeep(
  	                  liveVehicleTyres[liveTyreIndex],
  	                  ["objectId"],
  	                  null
  	                ),
  	                currentUpdate.objectId
  	              )
  	            ) {
  	              liveIndex = liveTyreIndex;
  	              break;
  	            }
  	          }
  	
  	          if (liveIndex >= 0) {
  	            applySavedTyreMileageToLiveRow(
  	              liveVehicleTyres[liveIndex],
  	              savedRow,
  	              currentUpdate.patch
  	            );
  	          }
  	
  	          applySavedTyreMileageToLiveRow(
  	            currentUpdate.source,
  	            savedRow,
  	            currentUpdate.patch
  	          );
  	        }
  	
  	        vehicleObj.Tyres = liveVehicleTyres;
  	
  	        console.log(
  	          "[Tyre Mileage Sync] Updated fitted tyres.",
  	          {
  	            vehicleObjectId: getDeep(
  	              vehicleObj,
  	              ["objectId"],
  	              null
  	            ),
  	            vehicleMileage: newVehicleMileage,
  	            mileageDifferential: differential,
  	            updatedCount: updates.length,
  	            tyreObjectIds: updates.map(function (update) {
  	              return update.objectId;
  	            })
  	          }
  	        );
  	
  	        var mileageUpdates = updates.filter(
  	          function (update) {
  	            return !update.spareBaselineOnly;
  	          }
  	        );
  	
  	        var tyreDifferentials = mileageUpdates.map(
  	          function (update) {
  	            return (
  	              update.newCurrentMileage -
  	              update.oldCurrentMileage
  	            );
  	          }
  	        );
  	
  	        return {
  	          updatedCount: mileageUpdates.length,
  	          spareBaselineCount:
  	            updates.length - mileageUpdates.length,
  	          differential: differential,
  	          minimumDifferential:
  	            tyreDifferentials.length
  	              ? Math.min.apply(Math, tyreDifferentials)
  	              : 0,
  	          maximumDifferential:
  	            tyreDifferentials.length
  	              ? Math.max.apply(Math, tyreDifferentials)
  	              : 0,
  	          vehicleMileage: newVehicleMileage,
  	          updatedTyres: savedRows
  	        };
  	      }
  	
  	      function buildBowserHistoryRelationIds(targetBowser) {
  	        var ids = [];
  	        var seen = {};
  	        var historyViews = toArray(getDeep(targetBowser, ["ViewH"], []));
  	
  	        for (var i = 0; i < historyViews.length; i++) {
  	          var historyId = getDeep(historyViews[i], ["objectId"], null);
  	          if (!historyId) continue;
  	
  	          if (!seen[historyId]) {
  	            seen[historyId] = true;
  	            ids.push(historyId);
  	          }
  	        }
  	
  	        return ids;
  	      }
  	
  	      async function syncBowserViewRelations(targetBowser, savedCurrentView) {
  	        var bowserObjectId = getDeep(targetBowser, ["objectId"], null);
  	        var currentViewObjectId = getDeep(savedCurrentView, ["objectId"], null);
  	
  	        if (!bowserObjectId) {
  	          throw new Error("Cannot sync bowser view relations without bowser objectId.");
  	        }
  	
  	        if (!currentViewObjectId) {
  	          throw new Error("Cannot sync bowser ViewC relation without current view objectId.");
  	        }
  	
  	        await setRelation("Bowsers", bowserObjectId, "ViewC", [currentViewObjectId]);
  	
  	        var historyRelationIds = buildBowserHistoryRelationIds(targetBowser);
  	        await setRelation("Bowsers", bowserObjectId, "ViewH", historyRelationIds);
  	
  	        targetBowser.ViewC = savedCurrentView;
  	      }
  	
  	      function setButtonBusy(button, isBusy, label) {
  	        if (!button) return;
  	        button.disabled = !!isBusy;
  	        button.style.opacity = isBusy ? "0.7": "1";
  	        button.style.cursor = isBusy ? "wait": "pointer";
  	        if (label) button.textContent = label;
  	      }
  	
  	      function renderTankGauge(gaugeHost, targetTank) {
  	        try {
  	          if (!gaugeHost || !targetTank) return;
  	
  	          var hostEl = null;
  	
  	          if (gaugeHost.el) {
  	            hostEl = gaugeHost.el;
  	          } else if (typeof HTMLElement !== "undefined" && gaugeHost instanceof HTMLElement) {
  	            hostEl = gaugeHost;
  	          }
  	
  	          if (!hostEl) {
  	            console.log("TankBlock does not contain a usable DOM element");
  	            console.log(gaugeHost);
  	            return;
  	          }
  	
  	          var level = Number(targetTank.Level);
  	          if (isNaN(level)) level = 0;
  	          if (level < 0) level = 0;
  	          if (level > 100) level = 100;
  	
  	          var grade = targetTank.Grade || "Tank";
  	          var liquidColor = targetTank.Color || "#22c55e";
  	
  	          var uid = "tank_" + (targetTank.objectId || Math.random().toString(36).slice(2));
  	
  	          var cx = 50;
  	          var cy = 50;
  	          var outerR = 45;
  	          var innerR = 37;
  	
  	          var liquidTopY = cy + innerR - ((level / 100) * (innerR * 2));
  	          var liquidHeight = (cy + innerR) - liquidTopY;
  	
  	          var levelText = Math.round(level) + "%";
  	
  	          hostEl.innerHTML = ""
  	          + '<svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" style="display:block;overflow:visible;">'
  	          + "  <defs>"
  	          + '    <radialGradient id="' + uid + '_shell" cx="35%" cy="30%" r="75%">'
  	          + '      <stop offset="0%" stop-color="#f8fafc"></stop>'
  	          + '      <stop offset="45%" stop-color="#d1d5db"></stop>'
  	          + '      <stop offset="75%" stop-color="#9ca3af"></stop>'
  	          + '      <stop offset="100%" stop-color="#6b7280"></stop>'
  	          + "    </radialGradient>"
  	          + '    <radialGradient id="' + uid + '_inner" cx="35%" cy="30%" r="80%">'
  	          + '      <stop offset="0%" stop-color="#f3f4f6"></stop>'
  	          + '      <stop offset="100%" stop-color="#d1d5db"></stop>'
  	          + "    </radialGradient>"
  	          + '    <linearGradient id="' + uid + '_glass" x1="0" y1="0" x2="1" y2="1">'
  	          + '      <stop offset="0%" stop-color="#ffffff" stop-opacity="0.24"></stop>'
  	          + '      <stop offset="100%" stop-color="#ffffff" stop-opacity="0.05"></stop>'
  	          + "    </linearGradient>"
  	          + '    <clipPath id="' + uid + '_liquidClip">'
  	          + '      <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '"></circle>'
  	          + "    </clipPath>"
  	          + "  </defs>"
  	          + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + outerR + '" fill="url(#' + uid + '_shell)"></circle>'
  	          + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_inner)"></circle>'
  	          + '  <g clip-path="url(#' + uid + '_liquidClip)">'
  	          + '    <rect x="' + (cx - innerR) + '" y="' + liquidTopY + '" width="' + (innerR * 2) + '" height="' + liquidHeight + '" fill="' + liquidColor + '"></rect>'
  	          + '    <rect x="' + (cx - innerR + 5) + '" y="' + liquidTopY + '" width="' + ((innerR * 2) - 10) + '" height="2.4" rx="1.2" fill="#ffffff" opacity="0.18"></rect>'
  	          + "  </g>"
  	          + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_glass)"></circle>'
  	          + '  <ellipse cx="' + (cx - 10) + '" cy="' + (cy - 9) + '" rx="10" ry="20" fill="#ffffff" opacity="0.12"></ellipse>'
  	          + '  <text x="' + cx + '" y="' + (cy + 1) + '" text-anchor="middle" font-size="15" font-weight="700" fill="#0f172a">' + levelText + "</text>"
  	          + '  <text x="' + cx + '" y="' + (cy + 13) + '" text-anchor="middle" font-size="6.5" font-weight="600" fill="#334155">' + escapeHtml(grade) + "</text>"
  	          + "</svg>";
  	        } catch (gaugeErr) {
  	          console.log("Tank gauge render error:", gaugeErr);
  	        }
  	      }
  	
  	      function mergeVehicleForLiveUi(existingVehicleObj, updatedVehicleObj) {
  	        var mergedVehicle = deepClone(existingVehicleObj || {});
  	        var updatedVehicle = updatedVehicleObj || {};
  	
  	        if (getDeep(updatedVehicle, ["Mileage"], null) !== null) {
  	          mergedVehicle.Mileage = updatedVehicle.Mileage;
  	        }
  	
  	        if (getDeep(updatedVehicle, ["ViewC"], null) !== null) {
  	          mergedVehicle.ViewC = deepClone(updatedVehicle.ViewC);
  	        }
  	
  	        if (getDeep(updatedVehicle, ["ViewH"], null) !== null) {
  	          mergedVehicle.ViewH = deepClone(updatedVehicle.ViewH);
  	        }
  	
  	        if (
  	          managerHasFuelCounter(updatedVehicle) &&
  	          managerHasFuelCounter(mergedVehicle)
  	        ) {
  	          managerSetFuelCounter(
  	            mergedVehicle,
  	            managerFuelCounterValue(updatedVehicle, 0)
  	          );
  	        }
  	
  	        if (
  	          relationCollectionToArray(
  	            getDeep(updatedVehicle, ["Tyres"], [])
  	          ).length
  	        ) {
  	          mergeVehicleTyresIntoLiveAppData(
  	            mergedVehicle,
  	            updatedVehicle
  	          );
  	        }
  	
  	        // Preserve all existing UI fields and nested relations.
  	        // Do not replace the whole tractor object with a partial backend-loaded row.
  	
  	        return mergedVehicle;
  	      }
  	
  	      function replaceNestedCompanyVehicle(companyObj, vehicleObj) {
  	        var tractors = toArray(getDeep(companyObj, ["Tractors"], []));
  	        var vIndex = findIndexByKeys(tractors, vehicleObj);
  	
  	        if (vIndex >= 0) {
  	          tractors[vIndex] = mergeVehicleForLiveUi(tractors[vIndex], vehicleObj);
  	          companyObj.Tractors = tractors;
  	        }
  	      }
  	
  	      function appendFuelInOnce(targetObj, savedFuelIn) {
  	        if (!targetObj || !savedFuelIn || !getDeep(savedFuelIn, ["objectId"], null)) return;
  	
  	        targetObj.FuelIn = toArray(getDeep(targetObj, ["FuelIn"], []));
  	        var savedId = String(getDeep(savedFuelIn, ["objectId"], ""));
  	
  	        for (var index = 0; index < targetObj.FuelIn.length; index++) {
  	          if (String(getDeep(targetObj.FuelIn[index], ["objectId"], "")) === savedId) {
  	            targetObj.FuelIn[index] = deepClone(savedFuelIn);
  	            return;
  	          }
  	        }
  	
  	        targetObj.FuelIn.unshift(deepClone(savedFuelIn));
  	      }
  	
  	      function mergeTankForLiveUi(existingTankObj, updatedTankObj) {
  	        var mergedTank = deepClone(existingTankObj || {});
  	        var updatedTank = updatedTankObj || {};
  	
  	        if (getDeep(updatedTank, ["Volume"], null) !== null) {
  	          mergedTank.Volume = updatedTank.Volume;
  	        }
  	
  	        if (getDeep(updatedTank, ["Level"], null) !== null) {
  	          mergedTank.Level = updatedTank.Level;
  	        }
  	
  	        if (getDeep(updatedTank, ["Trailer"], null) !== null) {
  	          mergedTank.Trailer = updatedTank.Trailer;
  	        }
  	
  	        if (Array.isArray(getDeep(updatedTank, ["FuelIn"], null))) {
  	          mergedTank.FuelIn = deepClone(updatedTank.FuelIn);
  	        }
  	
  	        var latestCostPerLitre = toNumber(
  	          getDeep(updatedTank, ["LatestCostPerLitre"], NaN),
  	          NaN
  	        );
  	        if (!isNaN(latestCostPerLitre) && latestCostPerLitre >= 0) {
  	          mergedTank.LatestCostPerLitre = latestCostPerLitre;
  	        }
  	
  	        if (getDeep(updatedTank, ["Meter"], null) !== null) {
  	          mergedTank.Meter = updatedTank.Meter;
  	        }
  	
  	        if (getDeep(updatedTank, ["ViewC"], null) !== null) {
  	          mergedTank.ViewC = deepClone(updatedTank.ViewC);
  	        }
  	
  	        if (getDeep(updatedTank, ["ViewH"], null) !== null) {
  	          mergedTank.ViewH = deepClone(updatedTank.ViewH);
  	        }
  	
  	        // Preserve the existing Bowsers array for the repeater.
  	        // Only update matching bowsers inside it; never replace the whole list with a partial backend relation.
  	        var existingBowsers = toArray(getDeep(mergedTank, ["Bowsers"], []));
  	        var updatedBowsers = toArray(getDeep(updatedTank, ["Bowsers"], []));
  	
  	        for (var i = 0; i < updatedBowsers.length; i++) {
  	          var updatedBowser = updatedBowsers[i];
  	          var bowserIndex = findIndexByKeys(existingBowsers, updatedBowser);
  	
  	          if (bowserIndex >= 0) {
  	            existingBowsers[bowserIndex] = Object.assign(
  	              {},
  	              deepClone(existingBowsers[bowserIndex]),
  	              deepClone(updatedBowser)
  	            );
  	          }
  	        }
  	
  	        mergedTank.Bowsers = existingBowsers;
  	
  	        return mergedTank;
  	      }
  	
  	      function replaceNestedCompanyTank(companyObj, tankObj) {
  	        var tanks = toArray(getDeep(companyObj, ["Tanks"], []));
  	        var tIndex = findIndexByKeys(tanks, tankObj);
  	
  	        if (tIndex >= 0) {
  	          // Only update tank scalar values.
  	          // Do not replace the tank object, because the replacement may not contain full Bowsers relation data.
  	          if (getDeep(tankObj, ["Volume"], null) !== null) tanks[tIndex].Volume = tankObj.Volume;
  	          if (getDeep(tankObj, ["Level"], null) !== null) tanks[tIndex].Level = tankObj.Level;
  	          if (getDeep(tankObj, ["Trailer"], null) !== null) tanks[tIndex].Trailer = tankObj.Trailer;
  	          if (Array.isArray(getDeep(tankObj, ["FuelIn"], null))) {
  	            tanks[tIndex].FuelIn = deepClone(tankObj.FuelIn);
  	          }
  	
  	          var latestCostPerLitre = toNumber(
  	            getDeep(tankObj, ["LatestCostPerLitre"], NaN),
  	            NaN
  	          );
  	          if (!isNaN(latestCostPerLitre) && latestCostPerLitre >= 0) {
  	            tanks[tIndex].LatestCostPerLitre = latestCostPerLitre;
  	          }
  	
  	          companyObj.Tanks = tanks;
  	        }
  	      }
  	
  	      function getAppDataRoot() {
  	        if (appData && typeof appData === "object") return appData;
  	        if (typeof AppData !== "undefined" && AppData && typeof AppData === "object") return AppData;
  	        return null;
  	      }
  	
  	      function getUserCompaniesFromAppData() {
  	        return toArray(getDeep(getAppDataRoot(), ["User", "Companies"], []));
  	      }
  	
  	      function findTankInAppDataByObjectId(tankObjectId) {
  	        var companies = getUserCompaniesFromAppData();
  	
  	        for (var c = 0; c < companies.length; c++) {
  	          var companyItem = companies[c];
  	          var companyTanks = toArray(getDeep(companyItem, ["Tanks"], []));
  	
  	          for (var i = 0; i < companyTanks.length; i++) {
  	            var candidate = companyTanks[i];
  	            if (String(getDeep(candidate, ["objectId"], "")) === String(tankObjectId || "")) {
  	              return {
  	                companyIndex: c,
  	                tankIndex: i,
  	                company: companyItem,
  	                tank: candidate
  	              };
  	            }
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function syncTankIntoLiveAppData(updatedTankObj) {
  	        if (!updatedTankObj || !getDeep(updatedTankObj, ["objectId"], null)) return false;
  	
  	        var match = findTankInAppDataByObjectId(getDeep(updatedTankObj, ["objectId"], null));
  	        if (!match) return false;
  	
  	        var companies = getUserCompaniesFromAppData();
  	        if (!companies[match.companyIndex]) return false;
  	
  	        var liveTank = companies[match.companyIndex].Tanks[match.tankIndex];
  	        if (!liveTank) return false;
  	
  	        // Only update safe scalar values and the FuelIn pricing relation.
  	        // Never replace the whole tank object here, because that can remove nested Bowsers from the repeater.
  	        if (getDeep(updatedTankObj, ["Volume"], null) !== null) liveTank.Volume = updatedTankObj.Volume;
  	        if (getDeep(updatedTankObj, ["Level"], null) !== null) liveTank.Level = updatedTankObj.Level;
  	        if (getDeep(updatedTankObj, ["Trailer"], null) !== null) liveTank.Trailer = updatedTankObj.Trailer;
  	        if (getDeep(updatedTankObj, ["FuelWarningThreshold1"], null) !== null) liveTank.FuelWarningThreshold1 = updatedTankObj.FuelWarningThreshold1;
  	        if (getDeep(updatedTankObj, ["FuelWarningThreshold2"], null) !== null) liveTank.FuelWarningThreshold2 = updatedTankObj.FuelWarningThreshold2;
  	        if (getDeep(updatedTankObj, ["OrderThreshold"], null) !== null) liveTank.OrderThreshold = updatedTankObj.OrderThreshold;
  	        if (getDeep(updatedTankObj, ["DefaultOrderVolume"], null) !== null) liveTank.DefaultOrderVolume = updatedTankObj.DefaultOrderVolume;
  	        if (getDeep(updatedTankObj, ["CompanyNotificationEmail"], null) !== null) liveTank.CompanyNotificationEmail = updatedTankObj.CompanyNotificationEmail;
  	        if (Array.isArray(getDeep(updatedTankObj, ["FuelIn"], null))) {
  	          liveTank.FuelIn = deepClone(updatedTankObj.FuelIn);
  	        }
  	
  	        var latestCostPerLitre = toNumber(
  	          getDeep(updatedTankObj, ["LatestCostPerLitre"], NaN),
  	          NaN
  	        );
  	        if (!isNaN(latestCostPerLitre) && latestCostPerLitre >= 0) {
  	          liveTank.LatestCostPerLitre = latestCostPerLitre;
  	        }
  	
  	        companies[match.companyIndex].Tanks[match.tankIndex] = liveTank;
  	        return true;
  	      }
  	
  	      function syncCompanyIntoLiveAppData(updatedCompanyObj) {
  	        if (!updatedCompanyObj) return false;
  	
  	        var companies = getUserCompaniesFromAppData();
  	
  	        for (var i = 0; i < companies.length; i++) {
  	          var candidate = companies[i];
  	
  	          if (
  	            sameKey(getDeep(candidate, ["objectId"], null), getDeep(updatedCompanyObj, ["objectId"], null)) ||
  	            sameKey(getDeep(candidate, ["CompanyId"], null), getDeep(updatedCompanyObj, ["CompanyId"], null))
  	          ) {
  	            // Never replace candidate.Tractors or candidate.Tanks wholesale.
  	            // Backendless-loaded company rows can contain partial relation arrays.
  	
  	            var updatedTractors = toArray(getDeep(updatedCompanyObj, ["Tractors"], []));
  	            for (var t = 0; t < updatedTractors.length; t++) {
  	              replaceNestedCompanyVehicle(candidate, updatedTractors[t]);
  	            }
  	
  	            var updatedTanks = toArray(getDeep(updatedCompanyObj, ["Tanks"], []));
  	            for (var k = 0; k < updatedTanks.length; k++) {
  	              replaceNestedCompanyTank(candidate, updatedTanks[k]);
  	            }
  	
  	            return true;
  	          }
  	        }
  	
  	        return false;
  	      }
  	
  	      function syncVehicleIntoLiveAppData(updatedVehicleObj) {
  	        if (
  	          !updatedVehicleObj ||
  	          !getDeep(updatedVehicleObj, ["objectId"], null)
  	        ) {
  	          return false;
  	        }
  	
  	        var changed = false;
  	        var companyGroups = getUserCompaniesFromAppData()
  	          .concat(toArray(contractorsInput));
  	
  	        for (var groupIndex = 0; groupIndex < companyGroups.length; groupIndex++) {
  	          var group = companyGroups[groupIndex];
  	          var tractors = toArray(getDeep(group, ["Tractors"], []));
  	          var tractorIndex = findIndexByKeys(
  	            tractors,
  	            updatedVehicleObj
  	          );
  	
  	          if (tractorIndex < 0) continue;
  	
  	          tractors[tractorIndex] = mergeVehicleForLiveUi(
  	            tractors[tractorIndex],
  	            updatedVehicleObj
  	          );
  	          group.Tractors = tractors;
  	          changed = true;
  	        }
  	
  	        return changed;
  	      }
  	
  	      function forceAppDataRefresh() {
  	        // Disabled for fuel capture.
  	        // Full AppData refresh rebuilds the Backendless repeater and can drop nested bowser/pump relations.
  	        return;
  	      }
  	
  	
  	      function isTransactionReversed(item) {
  	        return !!(
  	          getDeep(item, ["IsReversed"], false) ||
  	          getDeep(item, ["Reversed"], false) ||
  	          getDeep(item, ["RollbackStatus"], "") === "reversed"
  	        );
  	      }
  	
  	      function getTransactionTimeMs(item) {
  	        var raw = firstDefined(
  	          getDeep(item, ["FuelDate"], null),
  	          getDeep(item, ["created"], null),
  	          "1970-01-01T00:00:00.000Z"
  	        );
  	        var ms = new Date(raw).getTime();
  	        return isNaN(ms) ? 0: ms;
  	      }
  	
  	      function sortTransactionsAsc(items) {
  	        return toArray(items).slice().sort(function (a, b) {
  	          var aMs = getTransactionTimeMs(a);
  	          var bMs = getTransactionTimeMs(b);
  	
  	          if (aMs !== bMs) return aMs - bMs;
  	
  	          var aMeter = toNumber(getDeep(a, ["Meter"], 0), 0);
  	          var bMeter = toNumber(getDeep(b, ["Meter"], 0), 0);
  	          if (aMeter !== bMeter) return aMeter - bMeter;
  	
  	          var aId = text(getDeep(a, ["objectId"], ""), "");
  	          var bId = text(getDeep(b, ["objectId"], ""), "");
  	          return aId.localeCompare(bId);
  	        });
  	      }
  	
  	      function sortTransactionsDesc(items) {
  	        return sortTransactionsAsc(items).reverse();
  	      }
  	
  	      function getActiveTransactionsOnly(items) {
  	        return toArray(items).filter(function (item) {
  	          return !isTransactionReversed(item);
  	        });
  	      }
  	
  	      function sumTransactionLitres(items) {
  	        var arr = toArray(items);
  	        var total = 0;
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          total += toNumber(getDeep(arr[i], ["Litres"], 0), 0);
  	        }
  	
  	        return total;
  	      }
  	
  	      function sumTransactionCost(items) {
  	        var arr = toArray(items);
  	        var total = 0;
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          total += toNumber(
  	            getDeep(arr[i], ["Cost"], 0),
  	            0
  	          );
  	        }
  	
  	        return roundMoney2(total);
  	      }
  	
  	      function getLatestTankFuelIn(targetTank) {
  	        return managerLatestDelivery(targetTank);
  	      }
  	
  	      function getTankCostPerLitre(targetTank) {
  	        var liveLatestPrice = toNumber(
  	          getDeep(targetTank, ["LatestCostPerLitre"], NaN),
  	          NaN
  	        );
  	
  	        if (!isNaN(liveLatestPrice) && liveLatestPrice > 0) {
  	          return liveLatestPrice;
  	        }
  	
  	        var latestFuelIn = getLatestTankFuelIn(targetTank);
  	        if (!latestFuelIn) return 0;
  	
  	        var stamped = toNumber(getDeep(latestFuelIn, ["CostPerLitre"], NaN), NaN);
  	        if (!isNaN(stamped) && stamped > 0) return stamped;
  	
  	        var totalCost = toNumber(getDeep(latestFuelIn, ["Cost"], 0), 0);
  	        var totalLitres = toNumber(getDeep(latestFuelIn, ["Litres"], 0), 0);
  	
  	        if (totalCost > 0 && totalLitres > 0) {
  	          return totalCost / totalLitres;
  	        }
  	
  	        return 0;
  	      }
  	
  	      function unwrapFuelDescriptor(value) {
  	        if (Array.isArray(value)) {
  	          return value.length
  	            ? unwrapFuelDescriptor(value[0])
  	            : "";
  	        }
  	
  	        if (value && typeof value === "object") {
  	          var descriptorKeys = [
  	            "value",
  	            "Value",
  	            "name",
  	            "Name",
  	            "label",
  	            "Label",
  	            "text",
  	            "Text",
  	            "title",
  	            "Title"
  	          ];
  	
  	          for (
  	            var descriptorIndex = 0;
  	            descriptorIndex < descriptorKeys.length;
  	            descriptorIndex++
  	          ) {
  	            var descriptorKey = descriptorKeys[descriptorIndex];
  	
  	            if (
  	              Object.prototype.hasOwnProperty.call(value, descriptorKey) &&
  	              value[descriptorKey] !== null &&
  	              value[descriptorKey] !== undefined &&
  	              value[descriptorKey] !== ""
  	            ) {
  	              return unwrapFuelDescriptor(value[descriptorKey]);
  	            }
  	          }
  	        }
  	
  	        return value;
  	      }
  	
  	      function parseFuelBoolean(value) {
  	        value = unwrapFuelDescriptor(value);
  	        if (value === true || value === 1) return true;
  	        if (value === false || value === 0) return false;
  	        if (value === null || value === undefined || value === "") return null;
  	        var normalized = String(value).trim().toLowerCase();
  	        if (normalized === "true" || normalized === "yes" || normalized === "y" || normalized === "1" || normalized === "compliant" || normalized === "approved") return true;
  	        if (normalized === "false" || normalized === "no" || normalized === "n" || normalized === "0" || normalized === "not compliant") return false;
  	        return null;
  	      }
  	
  	      function getVehicleSarsMigrationVersion(vehicle) {
  	        var value = toNumber(
  	          unwrapFuelDescriptor(
  	            getDeep(vehicle, ["Data", "Schema", "SARSMigrationVersion"], null)
  	          ),
  	          NaN
  	        );
  	        return Number.isFinite(value) ? value : 0;
  	      }
  	
  	      function isVehicleSarsCompliant(vehicle) {
  	        // SARSCompliance is a canonical Tractor column and is intentionally
  	        // outside the simplified Data JSON.
  	        var canonical = parseFuelBoolean(
  	          firstDefined(
  	            getDeep(vehicle, ["SARSCompliance"], undefined),
  	            getDeep(vehicle, ["SARSCompliant"], undefined)
  	          )
  	        );
  	
  	        if (canonical !== null) return canonical;
  	
  	        var compatibilityCandidates = [
  	          getDeep(vehicle, ["Data", "SARS", "Compliant", "value"], undefined),
  	          getDeep(vehicle, ["Data", "SARS", "Compliant"], undefined),
  	          getDeep(vehicle, ["Data", "Vehicle", "SARS_Compliant", "value"], undefined),
  	          getDeep(vehicle, ["Data", "Vehicle", "SARS_Compliant"], undefined),
  	          getDeep(vehicle, ["Data", "Financials", "SARS", "Eligible", "value"], undefined),
  	          getDeep(vehicle, ["Data", "Financials", "SARS", "Eligible"], undefined),
  	          getDeep(vehicle, ["Data", "FuelAndEnergy", "SARS", "Eligible", "value"], undefined),
  	          getDeep(vehicle, ["Data", "FuelAndEnergy", "SARS", "Eligible"], undefined)
  	        ];
  	
  	        for (var index = 0; index < compatibilityCandidates.length; index++) {
  	          var parsed = parseFuelBoolean(compatibilityCandidates[index]);
  	          if (parsed !== null) return parsed;
  	        }
  	
  	        return false;
  	      }
  	
  	      function getVehicleSarsRebateRate(vehicle) {
  	        // SARSRate is the canonical Tractor column and is intentionally
  	        // outside the simplified Data JSON.
  	        var canonicalRaw = firstDefined(
  	          getDeep(vehicle, ["SARSRate"], null),
  	          getDeep(vehicle, ["SARSRebateRate"], null)
  	        );
  	        var canonical = toNumber(
  	          unwrapFuelDescriptor(canonicalRaw),
  	          NaN
  	        );
  	
  	        if (Number.isFinite(canonical) && canonical >= 0) {
  	          return canonical;
  	        }
  	
  	        var compatibilityCandidates = [
  	          getDeep(vehicle, ["Data", "SARS", "RebateRate", "value"], null),
  	          getDeep(vehicle, ["Data", "SARS", "RebateRate"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "SARS_Rebate_Rate", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "SARS_Rebate_Rate"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Sars_Rebate_Rate", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Sars_Rebate_Rate"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "SARSRebateRate", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "SARSRebateRate"], null),
  	          getDeep(vehicle, ["Data", "Financials", "SARS", "RebateRate", "value"], null),
  	          getDeep(vehicle, ["Data", "Financials", "SARS", "RebateRate"], null),
  	          getDeep(vehicle, ["Data", "FuelAndEnergy", "SARS", "RebateRate", "value"], null),
  	          getDeep(vehicle, ["Data", "FuelAndEnergy", "SARS", "RebateRate"], null)
  	        ];
  	
  	        for (var index = 0; index < compatibilityCandidates.length; index++) {
  	          var candidate = toNumber(
  	            unwrapFuelDescriptor(compatibilityCandidates[index]),
  	            NaN
  	          );
  	
  	          if (Number.isFinite(candidate) && candidate >= 0) {
  	            return candidate;
  	          }
  	        }
  	
  	        return 0;
  	      }
  	
  	      function getTransactionUnitCost(item) {
  	        var stamped = toNumber(getDeep(item, ["CostPerLitre"], NaN), NaN);
  	        if (!isNaN(stamped) && stamped > 0) return stamped;
  	
  	        var litres = toNumber(getDeep(item, ["Litres"], 0), 0);
  	        var cost = toNumber(getDeep(item, ["Cost"], 0), 0);
  	
  	        if (litres > 0 && cost > 0) return cost / litres;
  	
  	        return 0;
  	      }
  	
  	      function getTransactionSarsVehicle(item) {
  	        if (!item || typeof item !== "object") return null;
  	
  	        var related = getDeep(item, ["Tractor"], null);
  	
  	        // Prefer the live Tractor row because SARSRate belongs to the vehicle
  	        // and may be newer/more complete than the relation embedded in FuelOut.
  	        var objectId = getTransactionVehicleObjectId(item);
  	        var live = objectId ? findLiveVehicleByObjectId(objectId) : null;
  	
  	        if (live) return live;
  	
  	        if (related && typeof related === "object") {
  	          return related;
  	        }
  	
  	        return null;
  	      }
  	
  	      function getTransactionVehicleSarsRate(item) {
  	        var vehicle = getTransactionSarsVehicle(item);
  	
  	        if (vehicle) {
  	          return Math.max(0, getVehicleSarsRebateRate(vehicle));
  	        }
  	
  	        // Audit fallback only when the vehicle cannot be resolved at all.
  	        // New FuelOut rows stamp this value, but live Tractor SARSRate remains
  	        // authoritative whenever the vehicle is available.
  	        return Math.max(
  	          0,
  	          toNumber(
  	            firstDefined(
  	              getDeep(item, ["SARSRebateRate"], null),
  	              getDeep(item, ["VehicleSARSRate"], null),
  	              0
  	            ),
  	            0
  	          )
  	        );
  	      }
  	
  	      function getTransactionSarsRebate(item) {
  	        var litres = Math.max(
  	          0,
  	          toNumber(getDeep(item, ["Litres"], 0), 0)
  	        );
  	
  	        var compliant = firstDefined(
  	          getDeep(item, ["SARSCompliance"], null),
  	          false
  	        ) === true;
  	
  	        var vehicleRate = getTransactionVehicleSarsRate(item);
  	
  	        // IMPORTANT:
  	        // Rebate VALUE is always recalculated from the vehicle's SARS rate.
  	        // Never trust an old PotentialSARSRebate value for display/totals.
  	        return compliant && vehicleRate > 0
  	          ? litres * vehicleRate
  	          : 0;
  	      }
  	
  	      function getTransactionRebateLitres(item) {
  	        var litres = Math.max(
  	          0,
  	          toNumber(getDeep(item, ["Litres"], 0), 0)
  	        );
  	
  	        var compliant = firstDefined(
  	          getDeep(item, ["SARSCompliance"], null),
  	          false
  	        ) === true;
  	
  	        var vehicleRate = getTransactionVehicleSarsRate(item);
  	
  	        // Rebate litres only exist when the transaction is compliant AND the
  	        // vehicle actually carries a positive SARS rebate rate.
  	        return compliant && vehicleRate > 0
  	          ? litres
  	          : 0;
  	      }
  	
  	      function getTransactionSortName(item) {
  	        return String(
  	          firstDefined(
  	            getTransactionRegistration(item),
  	            getTransactionTractorHeading(item),
  	            getTransactionDriver(item),
  	            getDeep(item, ["Description"], ""),
  	            ""
  	          ) || ""
  	        ).toLowerCase();
  	      }
  	
  	      function getTransactionSortDate(item) {
  	        var raw = text(getDeep(item, ["FuelDate"], ""), "");
  	        var parsed = new Date(raw).getTime();
  	        return isNaN(parsed) ? 0: parsed;
  	      }
  	
  	      function getTransactionSortValue(item, key) {
  	        if (key === "name") {
  	          return getTransactionSortName(item);
  	        }
  	
  	        if (key === "efficiency") {
  	          return getTransactionEfficiencyValue(item);
  	        }
  	
  	        if (key === "kmEfficiency") {
  	          return getTransactionReadingUnit(item) === "km"
  	            ? getTransactionEfficiencyValue(item)
  	            : null;
  	        }
  	
  	        if (key === "hourEfficiency") {
  	          return getTransactionReadingUnit(item) === "h"
  	            ? getTransactionEfficiencyValue(item)
  	            : null;
  	        }
  	
  	        if (key === "capturedBy") {
  	          return getTransactionCapturedBy(item).toLowerCase();
  	        }
  	
  	        if (key === "litres") {
  	          return toNumber(getDeep(item, ["Litres"], 0), 0);
  	        }
  	
  	        if (key === "cost") {
  	          return toNumber(getDeep(item, ["Cost"], 0), 0);
  	        }
  	
  	        if (key === "rebateCost") {
  	          return toNumber(getTransactionSarsRebate(item), 0);
  	        }
  	
  	        if (key === "rebateLitres") {
  	          return toNumber(getTransactionRebateLitres(item), 0);
  	        }
  	
  	        if (key === "meterStart" || key === "bowserStart") {
  	          return toNumber(getDeep(item, ["MeterLast"], 0), 0);
  	        }
  	
  	        if (key === "meterEnd" || key === "bowserEnd") {
  	          return toNumber(getDeep(item, ["Meter"], 0), 0);
  	        }
  	
  	        if (key === "odometer") {
  	          return getTransactionReadingUnit(item) === "km"
  	            ? toNumber(getDeep(item, ["Mileage"], null), null)
  	            : null;
  	        }
  	
  	        if (key === "hobbs") {
  	          return getTransactionReadingUnit(item) === "h"
  	            ? toNumber(getDeep(item, ["Mileage"], null), null)
  	            : null;
  	        }
  	
  	        if (key === "distance") {
  	          return getTransactionReadingUnit(item) === "km"
  	            ? getTransactionReadingDelta(item)
  	            : null;
  	        }
  	
  	        if (key === "hours") {
  	          return getTransactionReadingUnit(item) === "h"
  	            ? getTransactionReadingDelta(item)
  	            : null;
  	        }
  	
  	        return getTransactionSortDate(item);
  	      }
  	
  	      function sortTransactionRows(items) {
  	        var rows = toArray(items).slice();
  	
  	        rows.sort(function (a, b) {
  	          var dateDifference =
  	            getTransactionSortDate(b) -
  	            getTransactionSortDate(a);
  	
  	          if (dateDifference !== 0) {
  	            return dateDifference;
  	          }
  	
  	          var createdA = new Date(
  	            firstDefined(
  	              getDeep(a, ["created"], null),
  	              getDeep(a, ["updated"], null),
  	              0
  	            )
  	          ).getTime();
  	          var createdB = new Date(
  	            firstDefined(
  	              getDeep(b, ["created"], null),
  	              getDeep(b, ["updated"], null),
  	              0
  	            )
  	          ).getTime();
  	
  	          createdA = Number.isFinite(createdA) ? createdA : 0;
  	          createdB = Number.isFinite(createdB) ? createdB : 0;
  	
  	          if (createdA !== createdB) {
  	            return createdB - createdA;
  	          }
  	
  	          return String(
  	            firstDefined(
  	              getDeep(b, ["objectId"], null),
  	              getTransactionSortName(b),
  	              ""
  	            )
  	          ).localeCompare(
  	            String(
  	              firstDefined(
  	                getDeep(a, ["objectId"], null),
  	                getTransactionSortName(a),
  	                ""
  	              )
  	            ),
  	            undefined,
  	            { numeric: true, sensitivity: "base" }
  	          );
  	        });
  	
  	        return rows;
  	      }
  	
  	      function getTransactionRegistration(item) {
  	        return text(
  	          firstDefined(
  	            getDeep(item, ["Registration"], null),
  	            getDeep(item, ["Tractor", "Registration"], null),
  	            getDeep(item, ["Tractor", "Data", "Vehicle", "Registration", "value"], null)
  	          ),
  	          "Unspecified Registration"
  	        );
  	      }
  	
  	      function getTransactionTractorHeading(item) {
  	        var tractorId = text(
  	          firstDefined(
  	            getDeep(item, ["TractorID"], null),
  	            getDeep(item, ["Tractor", "ID"], null),
  	            getDeep(item, ["ID"], null),
  	            getDeep(item, ["Tractor", "FID"], null)
  	          ),
  	          ""
  	        );
  	
  	        var registration = text(
  	          firstDefined(
  	            getDeep(item, ["Registration"], null),
  	            getDeep(item, ["Tractor", "Registration"], null),
  	            getDeep(item, ["Tractor", "Data", "Vehicle", "Registration", "value"], null)
  	          ),
  	          ""
  	        );
  	
  	        return tractorId && registration
  	        ? tractorId + " | " + registration: (tractorId || registration || "Unspecified Tractor");
  	      }
  	
  	      function getTransactionDriver(item) {
  	        return text(
  	          firstDefined(
  	            getDeep(item, ["DriverName"], null),
  	            getDeep(item, ["DriverUser", "name"], null),
  	            getDeep(item, ["DriverUser", "Name"], null),
  	            getDeep(item, ["DriverLabel"], null),
  	            getDeep(item, ["DriverUser", "email"], null)
  	          ),
  	          "No driver"
  	        );
  	      }
  	
  	      // Full Tractor hydration is required because FuelOut.Tractor and
  	      // Company.Tractors can be partial Backendless relation objects. The Vehicle
  	      // Manager may show CounterType correctly while the fuel ledger only has the
  	      // Tractor objectId, registration and mileage.
  	      var transactionReadingUnitCache = new WeakMap();
  	      var vehicleReadingUnitCache = Object.create(null);
  	      var vehicleReadingUnitPromiseCache = Object.create(null);
  	
  	      function getVehicleReadingUnitCacheKey(vehicleOrObjectId) {
  	        if (
  	          vehicleOrObjectId === null ||
  	          vehicleOrObjectId === undefined ||
  	          vehicleOrObjectId === ""
  	        ) {
  	          return "";
  	        }
  	
  	        if (typeof vehicleOrObjectId === "string" || typeof vehicleOrObjectId === "number") {
  	          return String(vehicleOrObjectId).trim().toLowerCase();
  	        }
  	
  	        return text(
  	          firstDefined(
  	            getDeep(vehicleOrObjectId, ["objectId"], null),
  	            getDeep(vehicleOrObjectId, ["ObjectId"], null),
  	            getDeep(vehicleOrObjectId, ["ID"], null),
  	            getDeep(vehicleOrObjectId, ["FID"], null),
  	            getDeep(vehicleOrObjectId, ["Registration"], null),
  	            getDeep(
  	              vehicleOrObjectId,
  	              ["Data", "Vehicle", "Registration", "value"],
  	              null
  	            )
  	          ),
  	          ""
  	        ).trim().toLowerCase();
  	      }
  	
  	      function getCachedVehicleReadingUnit(vehicleOrObjectId) {
  	        var key = getVehicleReadingUnitCacheKey(vehicleOrObjectId);
  	        return key && vehicleReadingUnitCache[key]
  	          ? vehicleReadingUnitCache[key]
  	          : "";
  	      }
  	
  	      function setCachedVehicleReadingUnit(vehicleOrObjectId, unit) {
  	        var normalized = normalizeFuelReadingUnit(unit);
  	        var key = getVehicleReadingUnitCacheKey(vehicleOrObjectId);
  	
  	        if (key && normalized) {
  	          vehicleReadingUnitCache[key] = normalized;
  	        }
  	
  	        return normalized;
  	      }
  	
  	      async function resolveVehicleReadingUnitForVehicle(vehicle) {
  	        if (!vehicle || typeof vehicle !== "object") {
  	          return "km";
  	        }
  	
  	        var explicitUnit = getVehicleExplicitReadingUnit(vehicle);
  	        if (explicitUnit) {
  	          setCachedVehicleReadingUnit(vehicle, explicitUnit);
  	          return explicitUnit;
  	        }
  	
  	        var cachedUnit = getCachedVehicleReadingUnit(vehicle);
  	        if (cachedUnit) return cachedUnit;
  	
  	        var vehicleObjectId = firstDefined(
  	          getDeep(vehicle, ["objectId"], null),
  	          getDeep(vehicle, ["ObjectId"], null)
  	        );
  	
  	        if (!vehicleObjectId) {
  	          return getVehicleReadingUnit(vehicle);
  	        }
  	
  	        var cacheKey = getVehicleReadingUnitCacheKey(vehicleObjectId);
  	
  	        if (!vehicleReadingUnitPromiseCache[cacheKey]) {
  	          vehicleReadingUnitPromiseCache[cacheKey] = loadTableRow(
  	            "Tractors",
  	            vehicleObjectId,
  	            []
  	          ).then(function (fullVehicle) {
  	            var fullUnit =
  	              getVehicleExplicitReadingUnit(fullVehicle) ||
  	              getVehicleReadingUnit(fullVehicle);
  	
  	            setCachedVehicleReadingUnit(vehicleObjectId, fullUnit);
  	            setCachedVehicleReadingUnit(fullVehicle, fullUnit);
  	            setCachedVehicleReadingUnit(vehicle, fullUnit);
  	
  	            // Merge the full row into the live AppData copy where possible so
  	            // capture labels and later transactions use the same canonical unit.
  	            try {
  	              syncVehicleIntoLiveAppData(fullVehicle);
  	            } catch (_) {}
  	
  	            return fullUnit;
  	          }).catch(function (error) {
  	            console.warn(
  	              "[Fuel Counter Routing] Could not hydrate Tractor " +
  	              String(vehicleObjectId) +
  	              ". Falling back to the available relation data.",
  	              error
  	            );
  	
  	            var fallbackUnit = getVehicleReadingUnit(vehicle);
  	            setCachedVehicleReadingUnit(vehicleObjectId, fallbackUnit);
  	            return fallbackUnit;
  	          });
  	        }
  	
  	        return vehicleReadingUnitPromiseCache[cacheKey];
  	      }
  	
  	      async function resolveTransactionVehicleReadingUnit(item) {
  	        if (!item || typeof item !== "object") return "";
  	
  	        var captureType = text(
  	          getDeep(item, ["CaptureType"], ""),
  	          ""
  	        ).toLowerCase();
  	
  	        if (captureType === "other" || captureType === "intertank") {
  	          return "";
  	        }
  	
  	        var vehicleObjectId = getTransactionVehicleObjectId(item);
  	        var relatedVehicle = getDeep(item, ["Tractor"], null);
  	        var liveVehicle = vehicleObjectId
  	          ? findLiveVehicleByObjectId(vehicleObjectId)
  	          : null;
  	        var sourceVehicle = liveVehicle || relatedVehicle;
  	        var unit = "";
  	
  	        if (vehicleObjectId) {
  	          unit = getCachedVehicleReadingUnit(vehicleObjectId);
  	        }
  	
  	        if (!unit && sourceVehicle) {
  	          unit = await resolveVehicleReadingUnitForVehicle(sourceVehicle);
  	        }
  	
  	        // A transaction may contain only Tractor.objectId. Load that full row
  	        // directly even when no live AppData vehicle could be matched.
  	        if (!unit && vehicleObjectId) {
  	          unit = await resolveVehicleReadingUnitForVehicle({
  	            objectId: vehicleObjectId
  	          });
  	        }
  	
  	        if (!unit) {
  	          unit = normalizeFuelReadingUnit(
  	            firstDefined(
  	              getDeep(item, ["ReadingUnit"], null),
  	              getDeep(item, ["EfficiencyUnit"], null)
  	            )
  	          );
  	        }
  	
  	        if (unit) {
  	          transactionReadingUnitCache.set(item, unit);
  	        }
  	
  	        return unit;
  	      }
  	
  	      async function hydrateTransactionVehicleReadingUnits(items) {
  	        var arr = toArray(items);
  	        var jobs = [];
  	
  	        for (var index = 0; index < arr.length; index++) {
  	          jobs.push(resolveTransactionVehicleReadingUnit(arr[index]));
  	        }
  	
  	        await Promise.all(jobs);
  	        return arr;
  	      }
  	
  	      function normalizeFuelReadingUnit(value) {
  	        value = unwrapFuelDescriptor(value);
  	
  	        var raw = text(value, "")
  	          .trim()
  	          .toLowerCase()
  	          .replace(/[._-]+/g, " ")
  	          .replace(/\s+/g, " ");
  	
  	        if (!raw) return "";
  	
  	        if (
  	          raw === "h" ||
  	          raw === "hr" ||
  	          raw === "hrs" ||
  	          raw === "h/l" ||
  	          raw === "l/h" ||
  	          raw.indexOf("hour") >= 0 ||
  	          raw.indexOf("engine time") >= 0 ||
  	          raw.indexOf("motor time") >= 0
  	        ) {
  	          return "h";
  	        }
  	
  	        if (
  	          raw === "km" ||
  	          raw === "kms" ||
  	          raw === "km/l" ||
  	          raw.indexOf("kilomet") >= 0 ||
  	          raw.indexOf("odometer") >= 0 ||
  	          raw.indexOf("distance") >= 0
  	        ) {
  	          return "km";
  	        }
  	
  	        return "";
  	      }
  	
  	      function getVehicleExplicitReadingUnit(vehicle) {
  	        if (!vehicle || typeof vehicle !== "object") {
  	          return "";
  	        }
  	
  	        // Backendless / page data can expose the same field with different
  	        // casing or descriptor wrappers. Scan the canonical containers first
  	        // so CounterType remains the authority regardless of object shape.
  	        var canonicalContainers = [
  	          vehicle,
  	          getDeep(vehicle, ["Data"], null),
  	          getDeep(vehicle, ["Data", "Vehicle"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Usage"], null),
  	          getDeep(vehicle, ["Data", "UIUnits"], null)
  	        ];
  	        var canonicalKeys = {
  	          countertype: true,
  	          readingunit: true,
  	          usageunit: true,
  	          meterunit: true,
  	          mileageunit: true,
  	          odometerunit: true,
  	          operationalreading: true
  	        };
  	
  	        for (
  	          var containerIndex = 0;
  	          containerIndex < canonicalContainers.length;
  	          containerIndex++
  	        ) {
  	          var container = canonicalContainers[containerIndex];
  	          if (!container || typeof container !== "object" || Array.isArray(container)) {
  	            continue;
  	          }
  	
  	          var containerKeys = Object.keys(container);
  	
  	          for (
  	            var containerKeyIndex = 0;
  	            containerKeyIndex < containerKeys.length;
  	            containerKeyIndex++
  	          ) {
  	            var actualKey = containerKeys[containerKeyIndex];
  	            var normalizedKey = String(actualKey)
  	              .toLowerCase()
  	              .replace(/[^a-z0-9]/g, "");
  	
  	            if (!canonicalKeys[normalizedKey]) continue;
  	
  	            var canonicalUnit = normalizeFuelReadingUnit(container[actualKey]);
  	            if (canonicalUnit) return canonicalUnit;
  	          }
  	        }
  	
  	        var explicitCandidates = [
  	          // Tractor.CounterType is the canonical authority. The reading still
  	          // comes from Tractor.Mileage; CounterType only routes presentation.
  	          getDeep(vehicle, ["CounterType"], null),
  	          getDeep(vehicle, ["Counter_Type"], null),
  	          getDeep(vehicle, ["Data", "CounterType"], null),
  	          getDeep(vehicle, ["Data", "Counter_Type"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "CounterType", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "CounterType"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Counter_Type", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "ReadingUnit", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "ReadingUnit"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Reading_Unit", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "UsageUnit", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Usage_Unit", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "MeterUnit", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Meter_Unit", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "MileageUnit", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Mileage_Unit", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "OdometerUnit", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Odometer_Unit", "value"], null),
  	          getDeep(vehicle, ["ReadingUnit"], null),
  	          getDeep(vehicle, ["Reading_Unit"], null),
  	          getDeep(vehicle, ["UsageUnit"], null),
  	          getDeep(vehicle, ["Usage_Unit"], null),
  	          getDeep(vehicle, ["MeterUnit"], null),
  	          getDeep(vehicle, ["Meter_Unit"], null),
  	          getDeep(vehicle, ["MileageUnit"], null),
  	          getDeep(vehicle, ["Mileage_Unit"], null),
  	          getDeep(vehicle, ["OdometerUnit"], null),
  	          getDeep(vehicle, ["Odometer_Unit"], null),
  	          getDeep(vehicle, ["Data", "UIUnits", "OperationalReading", "value"], null),
  	          getDeep(vehicle, ["Data", "UIUnits", "OperationalReading"], null)
  	        ];
  	
  	        for (
  	          var candidateIndex = 0;
  	          candidateIndex < explicitCandidates.length;
  	          candidateIndex++
  	        ) {
  	          var normalized = normalizeFuelReadingUnit(
  	            explicitCandidates[candidateIndex]
  	          );
  	
  	          if (normalized) return normalized;
  	        }
  	
  	        return "";
  	      }
  	
  	      function getVehicleReadingUnit(vehicle) {
  	        if (!vehicle || typeof vehicle !== "object") {
  	          return "km";
  	        }
  	
  	        var cachedUnit = getCachedVehicleReadingUnit(vehicle);
  	        if (cachedUnit) return cachedUnit;
  	
  	        var explicitUnit = getVehicleExplicitReadingUnit(vehicle);
  	        if (explicitUnit) {
  	          setCachedVehicleReadingUnit(vehicle, explicitUnit);
  	          return explicitUnit;
  	        }
  	
  	        var usesHours = unwrapFuelDescriptor(firstDefined(
  	          getDeep(vehicle, ["UsesHours"], null),
  	          getDeep(vehicle, ["Uses_Hours"], null),
  	          getDeep(vehicle, ["HourBased"], null),
  	          getDeep(vehicle, ["Hour_Based"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "UsesHours", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Uses_Hours", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "HourBased", "value"], null),
  	          getDeep(vehicle, ["Data", "Vehicle", "Hour_Based", "value"], null)
  	        ));
  	
  	        if (
  	          usesHours === true ||
  	          String(usesHours || "").toLowerCase() === "true" ||
  	          String(usesHours || "") === "1"
  	        ) {
  	          return "h";
  	        }
  	
  	        var identity = [
  	          getDeep(vehicle, ["Name"], ""),
  	          getDeep(vehicle, ["ID"], ""),
  	          getDeep(vehicle, ["FID"], ""),
  	          getDeep(vehicle, ["TractorID"], ""),
  	          getDeep(vehicle, ["Type"], ""),
  	          getDeep(vehicle, ["Category"], ""),
  	          getDeep(vehicle, ["Class"], ""),
  	          getDeep(
  	            vehicle,
  	            ["Data", "Vehicle", "Classification", "VehicleType", "value"],
  	            ""
  	          ),
  	          getDeep(
  	            vehicle,
  	            ["Data", "Vehicle", "Identity", "Make", "value"],
  	            ""
  	          ),
  	          getDeep(
  	            vehicle,
  	            ["Data", "Vehicle", "Identity", "Model", "value"],
  	            ""
  	          ),
  	          getDeep(vehicle, ["Data", "Vehicle", "Type", "value"], ""),
  	          getDeep(vehicle, ["Data", "Vehicle", "Category", "value"], ""),
  	          getDeep(vehicle, ["Data", "Vehicle", "Class", "value"], "")
  	        ].map(unwrapFuelDescriptor).join(" ").toLowerCase();
  	
  	        if (
  	          /\b(tractor|loader|excavator|forklift|generator|dozer|grader|harvester|combine|sprayer|telehandler|backhoe|compressor|plant|machine)\b/.test(identity)
  	        ) {
  	          return "h";
  	        }
  	
  	        return "km";
  	      }
  	
  	      function getTransactionReadingUnit(item) {
  	        var captureType = text(
  	          getDeep(item, ["CaptureType"], ""),
  	          ""
  	        ).toLowerCase();
  	
  	        if (
  	          captureType === "other" ||
  	          captureType === "intertank"
  	        ) {
  	          return "";
  	        }
  	
  	        var hydratedUnit = transactionReadingUnitCache.get(item);
  	        if (hydratedUnit) return hydratedUnit;
  	
  	        // The current vehicle CounterType controls the display column for all
  	        // of its transactions. Stored transaction values are never moved or
  	        // converted; only their visual destination changes.
  	        var vehicleObjectId = getTransactionVehicleObjectId(item);
  	        var liveVehicle = vehicleObjectId
  	          ? findLiveVehicleByObjectId(vehicleObjectId)
  	          : null;
  	        var relatedVehicle = getDeep(item, ["Tractor"], null);
  	        var vehicleUnit =
  	          getVehicleExplicitReadingUnit(liveVehicle) ||
  	          getVehicleExplicitReadingUnit(relatedVehicle);
  	
  	        if (vehicleUnit) return vehicleUnit;
  	
  	        // Historical rows without an available vehicle retain the unit stamped
  	        // onto the transaction when it was captured.
  	        var direct = normalizeFuelReadingUnit(
  	          firstDefined(
  	            getDeep(item, ["ReadingUnit"], null),
  	            getDeep(item, ["EfficiencyUnit"], null)
  	          )
  	        );
  	
  	        if (direct) return direct;
  	
  	        return getVehicleReadingUnit(liveVehicle || relatedVehicle);
  	      }
  	
  	      function getTransactionReadingDelta(item) {
  	        var storedDelta = toNumber(
  	          getDeep(item, ["ReadingDelta"], null),
  	          NaN
  	        );
  	
  	        if (Number.isFinite(storedDelta)) {
  	          return Math.max(0, storedDelta);
  	        }
  	
  	        var distance = toNumber(
  	          getDeep(item, ["Distance"], null),
  	          NaN
  	        );
  	
  	        if (Number.isFinite(distance)) {
  	          return Math.max(0, distance);
  	        }
  	
  	        var currentReading = toNumber(
  	          getDeep(item, ["Mileage"], null),
  	          NaN
  	        );
  	        var previousReading = toNumber(
  	          getDeep(item, ["MileageLast"], null),
  	          NaN
  	        );
  	
  	        if (
  	          Number.isFinite(currentReading) &&
  	          Number.isFinite(previousReading)
  	        ) {
  	          return Math.max(0, currentReading - previousReading);
  	        }
  	
  	        return 0;
  	      }
  	
  	      function getTransactionEfficiencyValue(item) {
  	        var unit = getTransactionReadingUnit(item);
  	        var storedEfficiency = toNumber(
  	          getDeep(item, ["Efficiency"], null),
  	          NaN
  	        );
  	        var litres = toNumber(
  	          getDeep(item, ["Litres"], 0),
  	          0
  	        );
  	        var readingDelta = getTransactionReadingDelta(item);
  	
  	        if (unit === "h") {
  	          // L/H = litres consumed per engine hour. Recalculate historical
  	          // transactions from their original figures, without changing them.
  	          if (litres > 0 && readingDelta > 0) {
  	            return litres / readingDelta;
  	          }
  	
  	          // Older FuelOut entries store h/L. If original readings are absent,
  	          // invert that legacy value; new L/H values are already correct.
  	          if (Number.isFinite(storedEfficiency) && storedEfficiency > 0) {
  	            var savedUnit = text(
  	              getDeep(item, ["EfficiencyUnit"], ""),
  	              ""
  	            ).trim().toLowerCase().replace(/\s+/g, "");
  	
  	            if (savedUnit === "l/h" || savedUnit === "l/hr" ||
  	                savedUnit === "litres/hour" || savedUnit === "liters/hour") {
  	              return storedEfficiency;
  	            }
  	
  	            return 1 / storedEfficiency;
  	          }
  	
  	          return 0;
  	        }
  	
  	        // Distance vehicles continue using km/L, unchanged.
  	        if (Number.isFinite(storedEfficiency) && storedEfficiency > 0) {
  	          return storedEfficiency;
  	        }
  	
  	        if (!(litres > 0) || !(readingDelta > 0)) {
  	          return 0;
  	        }
  	
  	        return readingDelta / litres;
  	      }
  	
  	      function getTransactionEfficiencyText(item) {
  	        var efficiency = getTransactionEfficiencyValue(item);
  	
  	        if (!(efficiency > 0)) return "—";
  	
  	        var unit = getTransactionReadingUnit(item);
  	
  	        return (
  	          displayNumber(efficiency, 2) +
  	          (unit === "h" ? " L/H": " km/L")
  	        );
  	      }
  	
  	      function getTransactionReadingLabel(item) {
  	        var unit = getTransactionReadingUnit(item);
  	
  	        if (unit === "h") return "Hours";
  	        if (unit === "km") return "Distance";
  	        return "Reading Difference";
  	      }
  	
  	      function getTransactionReadingLabels(item) {
  	        var unit = getTransactionReadingUnit(item);
  	
  	        if (unit === "h") {
  	          return {
  	            current: "Hobbs Meter",
  	            previous: "Previous Hobbs Meter",
  	            delta: "Hours",
  	            suffix: " h"
  	          };
  	        }
  	
  	        if (unit === "km") {
  	          return {
  	            current: "Odometer",
  	            previous: "Previous Odometer",
  	            delta: "Distance",
  	            suffix: " km"
  	          };
  	        }
  	
  	        return {
  	          current: "Current Reading",
  	          previous: "Previous Reading",
  	          delta: "Reading Difference",
  	          suffix: ""
  	        };
  	      }
  	
  	      function formatTransactionReading(item, value) {
  	        var number = toNumber(value, NaN);
  	        if (!Number.isFinite(number)) return text(value, "") || "—";
  	        var labels = getTransactionReadingLabels(item);
  	        return displayNumber(number, 2) + labels.suffix;
  	      }
  	
  	      function formatFuelCounterColumn(value, suffix) {
  	        var number = toNumber(value, NaN);
  	        if (!Number.isFinite(number)) return "—";
  	        return displayNumber(number, 2) + suffix;
  	      }
  	
  	      function getTransactionCounterColumns(item) {
  	        var unit = getTransactionReadingUnit(item);
  	        var current = getDeep(item, ["Mileage"], null);
  	        var previous = getDeep(item, ["MileageLast"], null);
  	        var delta = getTransactionReadingDelta(item);
  	        var efficiency = getTransactionEfficiencyValue(item);
  	
  	        return {
  	          unit: unit,
  	          odometer: unit === "km" ? formatFuelCounterColumn(current, " km") : "—",
  	          previousOdometer: unit === "km" ? formatFuelCounterColumn(previous, " km") : "—",
  	          hobbs: unit === "h" ? formatFuelCounterColumn(current, " h") : "—",
  	          previousHobbs: unit === "h" ? formatFuelCounterColumn(previous, " h") : "—",
  	          distance: unit === "km" ? formatFuelCounterColumn(delta, " km") : "—",
  	          hours: unit === "h" ? formatFuelCounterColumn(delta, " h") : "—",
  	          kmPerL: unit === "km" && efficiency > 0 ? displayNumber(efficiency, 2) + " km/L" : "—",
  	          litresPerHour: unit === "h" && efficiency > 0 ? displayNumber(efficiency, 2) + " L/H" : "—"
  	        };
  	      }
  	
  	      function getTransactionEfficiencyLabel(item) {
  	        var unit = getTransactionReadingUnit(item);
  	        if (unit === "h") return "Efficiency (L/H)";
  	        if (unit === "km") return "Efficiency (km/L)";
  	        return "Efficiency";
  	      }
  	
  	      function getCaptureUserName(user) {
  	        if (!user || typeof user !== "object") return "";
  	
  	        var firstName = text(
  	          firstDefined(
  	            getDeep(user, ["firstName"], null),
  	            getDeep(user, ["FirstName"], null),
  	            getDeep(user, ["first_name"], null)
  	          ),
  	          ""
  	        ).trim();
  	
  	        var lastName = text(
  	          firstDefined(
  	            getDeep(user, ["lastName"], null),
  	            getDeep(user, ["LastName"], null),
  	            getDeep(user, ["last_name"], null)
  	          ),
  	          ""
  	        ).trim();
  	
  	        var combinedName = (firstName + " " + lastName).trim();
  	
  	        return text(
  	          firstDefined(
  	            getDeep(user, ["name"], null),
  	            getDeep(user, ["Name"], null),
  	            getDeep(user, ["displayName"], null),
  	            getDeep(user, ["DisplayName"], null),
  	            getDeep(user, ["fullName"], null),
  	            getDeep(user, ["FullName"], null),
  	            combinedName,
  	            getDeep(user, ["email"], null),
  	            getDeep(user, ["Email"], null)
  	          ),
  	          ""
  	        ).trim();
  	      }
  	
  	      function getCaptureUserEmail(user) {
  	        return text(
  	          firstDefined(
  	            getDeep(user, ["email"], null),
  	            getDeep(user, ["Email"], null)
  	          ),
  	          ""
  	        ).trim();
  	      }
  	
  	      function getTransactionCapturedBy(item) {
  	        return text(
  	          firstDefined(
  	            getDeep(item, ["CapturedByName"], null),
  	            getDeep(item, ["CapturedBy", "name"], null),
  	            getDeep(item, ["CapturedBy", "Name"], null),
  	            getDeep(item, ["CapturedBy", "displayName"], null),
  	            getDeep(item, ["CapturedByEmail"], null),
  	            getDeep(item, ["CapturedBy", "email"], null),
  	            getDeep(item, ["CapturedByObjectId"], null),
  	            getDeep(item, ["ownerId"], null)
  	          ),
  	          "Not recorded"
  	        );
  	      }
  	
  	      function refreshVehicleReadingLabel() {
  	        var labelNode = el("label-mileage");
  	        var inputNode = el("fuel-mileage");
  	        var activeVehicle = getActiveVehicle();
  	
  	        if (!labelNode && !inputNode) return;
  	
  	        if (!activeVehicle) {
  	          if (labelNode) labelNode.textContent = "Odometer / Hobbs Meter";
  	          if (inputNode) inputNode.placeholder = "Odometer / Hobbs Meter";
  	          return;
  	        }
  	
  	        var unit = getVehicleReadingUnit(activeVehicle);
  	        var labelText = unit === "h"
  	          ? "Hobbs Meter Reading (h)"
  	          : "Odometer Reading (km)";
  	
  	        if (labelNode) labelNode.textContent = labelText;
  	        if (inputNode) inputNode.placeholder = labelText;
  	
  	        // Relation rows used by the dropdown can omit CounterType. Hydrate the
  	        // complete Tractor once, then refresh the label if its unit changes.
  	        resolveVehicleReadingUnitForVehicle(activeVehicle).then(function (resolvedUnit) {
  	          if (resolvedUnit && resolvedUnit !== unit) {
  	            var currentVehicle = getActiveVehicle();
  	            if (
  	              currentVehicle &&
  	              getVehicleReadingUnitCacheKey(currentVehicle) ===
  	              getVehicleReadingUnitCacheKey(activeVehicle)
  	            ) {
  	              refreshVehicleReadingLabel();
  	            }
  	          }
  	        }).catch(function () {});
  	      }
  	
  	      function getTransactionsForVehicle(items, vehicleObjectId) {
  	        var arr = sortTransactionsAsc(
  	          getActiveTransactionsOnly(items)
  	        );
  	        var out = [];
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          if (
  	            sameObjectId(
  	              getTransactionVehicleObjectId(arr[i]),
  	              vehicleObjectId
  	            )
  	          ) {
  	            out.push(arr[i]);
  	          }
  	        }
  	
  	        return out;
  	      }
  	
  	      function getLatestTransactionForVehicle(items, vehicleObjectId) {
  	        var arr = getTransactionsForVehicle(items, vehicleObjectId);
  	        return arr.length ? arr[arr.length - 1]: null;
  	      }
  	
  	      function getLatestTransactionForBowser(items) {
  	        var arr = getActiveTransactionsOnly(items).slice();
  	
  	        arr.sort(function (a, b) {
  	          var meterDifference =
  	            toNumber(getDeep(a, ["Meter"], 0), 0) -
  	            toNumber(getDeep(b, ["Meter"], 0), 0);
  	
  	          if (meterDifference !== 0) {
  	            return meterDifference;
  	          }
  	
  	          var timeDifference =
  	            getTransactionTimeMs(a) -
  	            getTransactionTimeMs(b);
  	
  	          if (timeDifference !== 0) {
  	            return timeDifference;
  	          }
  	
  	          return text(
  	            getDeep(a, ["objectId"], ""),
  	            ""
  	          ).localeCompare(
  	            text(getDeep(b, ["objectId"], ""), "")
  	          );
  	        });
  	
  	        return arr.length ? arr[arr.length - 1]: null;
  	      }
  	
  	      function getTransactionVehicleObjectId(item) {
  	        if (!item || typeof item !== "object") {
  	          return null;
  	        }
  	
  	        var direct = firstDefined(
  	          getDeep(item, ["Tractor", "objectId"], null),
  	          getDeep(item, ["TractorObjectId"], null),
  	          getDeep(item, ["VehicleObjectId"], null),
  	          getDeep(item, ["Vehicle", "objectId"], null),
  	          getDeep(item, ["Tractor"], null) &&
  	          typeof getDeep(item, ["Tractor"], null) === "string"
  	            ? getDeep(item, ["Tractor"], null)
  	            : null
  	        );
  	
  	        if (direct) {
  	          return direct;
  	        }
  	
  	        var transactionKeys = [
  	          getDeep(item, ["Registration"], null),
  	          getDeep(item, ["TractorID"], null),
  	          getDeep(item, ["ID"], null),
  	          getDeep(item, ["Tractor", "FID"], null),
  	          getDeep(item, ["Tractor", "ID"], null),
  	          getDeep(
  	            item,
  	            ["Tractor", "Data", "Vehicle", "Registration", "value"],
  	            null
  	          )
  	        ].map(function (value) {
  	          return String(
  	            value === null || value === undefined
  	              ? ""
  	              : value
  	          ).trim().toLowerCase();
  	        }).filter(Boolean);
  	
  	        if (!transactionKeys.length) {
  	          return null;
  	        }
  	
  	        var groups = [];
  	
  	        // Include the active company directly. This keeps historical rows tied
  	        // to the live Tractor record even when AppData has only a partial copy.
  	        if (company && typeof company === "object") {
  	          groups.push(company);
  	        }
  	
  	        groups = groups
  	          .concat(getUserCompaniesFromAppData())
  	          .concat(toArray(contractorsInput));
  	
  	        for (
  	          var groupIndex = 0;
  	          groupIndex < groups.length;
  	          groupIndex++
  	        ) {
  	          var tractors = relationCollectionToArray(
  	            getDeep(groups[groupIndex], ["Tractors"], [])
  	          );
  	
  	          for (
  	            var tractorIndex = 0;
  	            tractorIndex < tractors.length;
  	            tractorIndex++
  	          ) {
  	            var candidate = tractors[tractorIndex];
  	            var candidateObjectId = getDeep(
  	              candidate,
  	              ["objectId"],
  	              null
  	            );
  	
  	            if (!candidateObjectId) continue;
  	
  	            var candidateKeys = [
  	              getDeep(candidate, ["FID"], null),
  	              getDeep(candidate, ["ID"], null),
  	              getDeep(candidate, ["Registration"], null),
  	              getDeep(
  	                candidate,
  	                ["Data", "Vehicle", "Registration", "value"],
  	                null
  	              )
  	            ].map(function (value) {
  	              return String(
  	                value === null || value === undefined
  	                  ? ""
  	                  : value
  	              ).trim().toLowerCase();
  	            }).filter(Boolean);
  	
  	            for (
  	              var keyIndex = 0;
  	              keyIndex < transactionKeys.length;
  	              keyIndex++
  	            ) {
  	              if (
  	                candidateKeys.indexOf(
  	                  transactionKeys[keyIndex]
  	                ) >= 0
  	              ) {
  	                return candidateObjectId;
  	              }
  	            }
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function isLatestTransactionForBowser(targetItem, items) {
  	        var latest = getLatestTransactionForBowser(items);
  	        return !!(
  	          latest &&
  	          sameObjectId(
  	            getDeep(latest, ["objectId"], null),
  	            getDeep(targetItem, ["objectId"], null)
  	          )
  	        );
  	      }
  	
  	      function isLatestTransactionForVehicle(targetItem, items) {
  	        var vehicleId = getTransactionVehicleObjectId(targetItem);
  	        if (!vehicleId) return false;
  	
  	        var latest = getLatestTransactionForVehicle(items, vehicleId);
  	        return !!(
  	          latest &&
  	          sameObjectId(
  	            getDeep(latest, ["objectId"], null),
  	            getDeep(targetItem, ["objectId"], null)
  	          )
  	        );
  	      }
  	
  	      function getEarliestTransactionForVehicle(items, vehicleObjectId) {
  	        var arr = getTransactionsForVehicle(items, vehicleObjectId);
  	        return arr.length ? arr[0]: null;
  	      }
  	
  	      function buildVehicleViewSeed(dateObj) {
  	        return {
  	          ___class: "Tractorview",
  	          MYear: getMonthLabel(dateObj),
  	          MYearKey: getMYear(dateObj),
  	          DateStart: getMonthStartMs(dateObj),
  	          DateEnd: getMonthEndMs(dateObj),
  	          TransactionCount: 0,
  	          MeterStart: 0,
  	          MeterEnd: 0,
  	          Distance: 0,
  	          Hours: 0,
  	          Litres: 0,
  	          Cost: 0,
  	          PotentialSARSRebate: 0
  	        };
  	      }
  	
  	      function ensureBowserViewRow(targetBowser, openingMeter, dateObj) {
  	        var businessDate = dateObj ? getBusinessDate(dateObj): getBusinessNowDate();
  	        var mYear = getMYear(businessDate);
  	        var mYearLabel = getMonthLabel(businessDate);
  	        var oldView = getDeep(targetBowser, ["ViewC"], null);
  	
  	        if (!oldView || getDeep(oldView, ["MYearKey"], "") !== mYear) {
  	          if (oldView && (getDeep(oldView, ["objectId"], null) || getDeep(oldView, ["MYear"], ""))) {
  	            targetBowser.ViewH = toArray(targetBowser.ViewH);
  	            targetBowser.ViewH.push(deepClone(oldView));
  	          }
  	
  	          targetBowser.ViewC = {
  	            ___class: "BowserView",
  	            MYear: mYearLabel,
  	            MYearKey: mYear,
  	            DateStart: getMonthStartMs(businessDate),
  	            DateEnd: getMonthEndMs(businessDate),
  	            Litres: 0,
  	            MeterStart: toNumber(openingMeter, 0),
  	            MeterEnd: toNumber(openingMeter, 0)
  	          };
  	        } else {
  	          targetBowser.ViewC.Litres = toNumber(getDeep(targetBowser, ["ViewC", "Litres"], 0), 0);
  	          if (getDeep(targetBowser, ["ViewC", "MeterStart"], null) == null) targetBowser.ViewC.MeterStart = toNumber(openingMeter, 0);
  	          if (getDeep(targetBowser, ["ViewC", "MeterEnd"], null) == null) targetBowser.ViewC.MeterEnd = toNumber(openingMeter, 0);
  	          if (getDeep(targetBowser, ["ViewC", "DateStart"], null) == null) targetBowser.ViewC.DateStart = getMonthStartMs(businessDate);
  	          if (getDeep(targetBowser, ["ViewC", "DateEnd"], null) == null) targetBowser.ViewC.DateEnd = getMonthEndMs(businessDate);
  	          if (getDeep(targetBowser, ["ViewC", "MYearKey"], null) == null) targetBowser.ViewC.MYearKey = mYear;
  	          if (getDeep(targetBowser, ["ViewC", "MYear"], null) == null) targetBowser.ViewC.MYear = mYearLabel;
  	        }
  	
  	        return targetBowser.ViewC;
  	      }
  	
  	      function ensureVehicleViewRow(targetVehicle, dateObj) {
  	        var businessDate = dateObj ? getBusinessDate(dateObj): getBusinessNowDate();
  	        var mYear = getMYear(businessDate);
  	        var mYearLabel = getMonthLabel(businessDate);
  	        var currentView = getDeep(targetVehicle, ["ViewC"], null);
  	        var currentViewMonthKey = getDeep(currentView, ["MYearKey"], "");
  	
  	        if (!currentView || currentViewMonthKey !== mYear) {
  	          if (currentView && (getDeep(currentView, ["objectId"], null) || getDeep(currentView, ["MYear"], ""))) {
  	            targetVehicle.ViewH = toArray(getDeep(targetVehicle, ["ViewH"], []));
  	            targetVehicle.ViewH.push(deepClone(currentView));
  	          }
  	
  	          targetVehicle.ViewC = buildVehicleViewSeed(businessDate);
  	        } else {
  	          if (getDeep(currentView, ["MYearKey"], null) == null) currentView.MYearKey = mYear;
  	          if (getDeep(currentView, ["MYear"], null) == null) currentView.MYear = mYearLabel;
  	          if (getDeep(currentView, ["DateStart"], null) == null) currentView.DateStart = getMonthStartMs(businessDate);
  	          if (getDeep(currentView, ["DateEnd"], null) == null) currentView.DateEnd = getMonthEndMs(businessDate);
  	          if (getDeep(currentView, ["TransactionCount"], null) == null) currentView.TransactionCount = 0;
  	          if (getDeep(currentView, ["MeterStart"], null) == null) currentView.MeterStart = 0;
  	          if (getDeep(currentView, ["MeterEnd"], null) == null) currentView.MeterEnd = 0;
  	          if (getDeep(currentView, ["Distance"], null) == null) currentView.Distance = 0;
  	          if (getDeep(currentView, ["Hours"], null) == null) currentView.Hours = 0;
  	          if (getDeep(currentView, ["Litres"], null) == null) currentView.Litres = 0;
  	          if (getDeep(currentView, ["Cost"], null) == null) currentView.Cost = 0;
  	          if (getDeep(currentView, ["PotentialSARSRebate"], null) == null) currentView.PotentialSARSRebate = 0;
  	        }
  	
  	        return targetVehicle.ViewC;
  	      }
  	
  	      function recalcBowserViewFromTransactions(targetView, activeTransactions) {
  	        var arr = getActiveTransactionsOnly(activeTransactions);
  	        var meterStart = toNumber(getDeep(targetView, ["MeterStart"], 0), 0);
  	        var litres = sumTransactionLitres(arr);
  	        var cost = sumTransactionCost(arr);
  	        var meterEnd = meterStart;
  	        var highest = getLatestTransactionForBowser(arr);
  	
  	        if (highest) {
  	          meterEnd = toNumber(
  	            getDeep(highest, ["Meter"], meterStart),
  	            meterStart
  	          );
  	        }
  	
  	        targetView.Litres = litres;
  	        targetView.Cost = roundMoney2(cost);
  	        targetView.MeterEnd = meterEnd;
  	
  	        return targetView;
  	      }
  	
  	      function recalcVehicleViewFromTransactions(targetVehicle, activeTransactions, dateObj, baselineMileage) {
  	        var arr = getTransactionsForVehicle(activeTransactions, getDeep(targetVehicle, ["objectId"], null));
  	        var effectiveDate = dateObj || getNowDate();
  	        var currentView = ensureVehicleViewRow(targetVehicle, effectiveDate);
  	        var baseline = toNumber(baselineMileage, 0);
  	
  	        currentView.TransactionCount = arr.length;
  	        currentView.Litres = 0;
  	        currentView.Cost = 0;
  	        currentView.PotentialSARSRebate = 0;
  	
  	        if (arr.length) {
  	          var firstTx = arr[0];
  	          var lastTx = arr[arr.length - 1];
  	
  	          currentView.MeterStart = toNumber(
  	            firstDefined(
  	              getDeep(firstTx, ["MileageLast"], null),
  	              baseline,
  	              0
  	            ),
  	            0
  	          );
  	
  	          currentView.MeterEnd = toNumber(
  	            firstDefined(
  	              getDeep(lastTx, ["Mileage"], null),
  	              getDeep(lastTx, ["MileageLast"], null),
  	              currentView.MeterStart
  	            ),
  	            currentView.MeterStart
  	          );
  	
  	          var periodMovement = currentView.MeterEnd - currentView.MeterStart;
  	          if (periodMovement < 0) periodMovement = 0;
  	
  	          var periodUnit = getVehicleReadingUnit(targetVehicle);
  	          if (periodUnit === "h") {
  	            currentView.Hours = periodMovement;
  	            currentView.Distance = 0;
  	          } else {
  	            currentView.Distance = periodMovement;
  	            currentView.Hours = 0;
  	          }
  	
  	          for (var i = 0; i < arr.length; i++) {
  	            currentView.Litres += toNumber(getDeep(arr[i], ["Litres"], 0), 0);
  	            currentView.Cost += toNumber(getDeep(arr[i], ["Cost"], 0), 0);
  	            currentView.PotentialSARSRebate += toNumber(getDeep(arr[i], ["PotentialSARSRebate"], 0), 0);
  	          }
  	
  	          currentView.Cost = roundMoney2(
  	            currentView.Cost
  	          );
  	        } else {
  	          currentView.MeterStart = baseline;
  	          currentView.MeterEnd = baseline;
  	          currentView.Distance = 0;
  	          currentView.Hours = 0;
  	        }
  	
  	        targetVehicle.ViewC = currentView;
  	        return currentView;
  	      }
  	
  	      async function syncVehicleViewFuelRelations(vehicleViewObjectId, transactions) {
  	        if (!vehicleViewObjectId) return;
  	
  	        var ids = [];
  	        var arr = getActiveTransactionsOnly(transactions);
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          var txId = getDeep(arr[i], ["objectId"], null);
  	          if (txId) ids.push(txId);
  	        }
  	
  	        await setRelation("Tractorview", vehicleViewObjectId, "Fuel", ids);
  	      }
  	
  	      function buildVehicleHistoryRelationIds(targetVehicle, currentViewObjectId) {
  	        var ids = [];
  	        var seen = {};
  	        var historyViews = toArray(getDeep(targetVehicle, ["ViewH"], []));
  	
  	        for (var i = 0; i < historyViews.length; i++) {
  	          var historyId = getDeep(historyViews[i], ["objectId"], null);
  	          if (!historyId) continue;
  	
  	          // Do not include the current ViewC in ViewH.
  	          if (currentViewObjectId && sameObjectId(historyId, currentViewObjectId)) continue;
  	
  	          if (!seen[historyId]) {
  	            seen[historyId] = true;
  	            ids.push(historyId);
  	          }
  	        }
  	
  	        return ids;
  	      }
  	
  	      async function syncVehicleViewRelations(targetVehicle, savedCurrentView) {
  	        var vehicleObjectId = getDeep(targetVehicle, ["objectId"], null);
  	        var currentViewObjectId = getDeep(savedCurrentView, ["objectId"], null);
  	
  	        if (!vehicleObjectId) {
  	          throw new Error("Cannot sync tractor view relations without tractor objectId.");
  	        }
  	
  	        if (!currentViewObjectId) {
  	          throw new Error("Cannot sync tractor view relations without current view objectId.");
  	        }
  	
  	        await setRelation("Tractors", vehicleObjectId, "ViewC", [currentViewObjectId]);
  	
  	        var historyRelationIds = buildVehicleHistoryRelationIds(targetVehicle, currentViewObjectId);
  	        await setRelation("Tractors", vehicleObjectId, "ViewH", historyRelationIds);
  	
  	        targetVehicle.ViewC = savedCurrentView;
  	      }
  	
  	      async function loadFreshCurrentBowserView() {
  	        var currentViewId = getDeep(bowser, ["ViewC", "objectId"], null);
  	        if (!currentViewId) {
  	          throw new Error("Bowser current view is missing.");
  	        }
  	
  	        return await loadTableRow("BowserView", currentViewId, [
  	          "FuelOut",
  	          "FuelOut.Tractor",
  	          "FuelOut.DriverUser",
  	          "FuelOut.Company",
  	          "FuelOut.Bowser",
  	          "FuelOut.Tank",
  	          "FuelOut.Contractor"
  	        ]);
  	      }
  	
  	      async function rebuildBowserViewFromActiveTransactions(workingBowser, activeTransactions) {
  	        var workingBowserView = deepClone(getDeep(workingBowser, ["ViewC"], null));
  	
  	        if (!workingBowserView || !getDeep(workingBowserView, ["objectId"], null)) {
  	          throw new Error("Bowser current view is missing.");
  	        }
  	
  	        recalcBowserViewFromTransactions(workingBowserView, activeTransactions);
  	
  	        var savedBowserViewRow = await saveTableRow(
  	          "BowserView",
  	          {
  	            objectId: getDeep(workingBowserView, ["objectId"], null),
  	            MYear: getDeep(workingBowserView, ["MYear"], null),
  	            MYearKey: getDeep(workingBowserView, ["MYearKey"], null),
  	            DateStart: getDeep(workingBowserView, ["DateStart"], null),
  	            DateEnd: getDeep(workingBowserView, ["DateEnd"], null),
  	            Litres: getDeep(workingBowserView, ["Litres"], 0),
  	            Cost: roundMoney2(
  	              getDeep(
  	                workingBowserView,
  	                ["Cost"],
  	                0
  	              )
  	            ),
  	            MeterStart: getDeep(workingBowserView, ["MeterStart"], 0),
  	            MeterEnd: getDeep(workingBowserView, ["MeterEnd"], 0)
  	          }
  	        );
  	        var savedBowserView = Object.assign(
  	          workingBowserView,
  	          savedBowserViewRow || {}
  	        );
  	
  	        workingBowser.ViewC = savedBowserView;
  	        workingBowser.Meter = toNumber(getDeep(savedBowserView, ["MeterEnd"], 0), 0);
  	
  	        return savedBowserView;
  	      }
  	
  	      async function rebuildVehicleViewForVehicle(vehicleId, activeTransactions, workingCompany) {
  	        var freshVehicle = deepClone(await loadTableRow("Tractors", vehicleId, ["ViewC", "ViewH"]));
  	        var vehicleChain = getTransactionsForVehicle(activeTransactions, vehicleId);
  	        var baselineMileage = vehicleChain.length
  	        ? toNumber(getDeep(vehicleChain[0], ["MileageLast"], 0), 0): managerVehicleCurrentReading(freshVehicle);
  	
  	        var viewDate = vehicleChain.length
  	        ? firstDefined(
  	          getDeep(vehicleChain[vehicleChain.length - 1], ["FuelDate"], null),
  	          getDeep(vehicleChain[vehicleChain.length - 1], ["created"], null),
  	          getNowIso()
  	        ): getNowIso();
  	
  	        if (vehicleChain.length) {
  	          freshVehicle.Mileage = toNumber(
  	            firstDefined(
  	              getDeep(vehicleChain[vehicleChain.length - 1], ["Mileage"], null),
  	              getDeep(vehicleChain[vehicleChain.length - 1], ["MileageLast"], null),
  	              managerVehicleCurrentReading(freshVehicle),
  	              0
  	            ),
  	            0
  	          );
  	          managerSetVehicleCurrentReading(
  	            freshVehicle,
  	            freshVehicle.Mileage,
  	            getVehicleReadingUnit(freshVehicle)
  	          );
  	        }
  	
  	        if (managerHasFuelCounter(freshVehicle)) {
  	          managerSetFuelCounter(freshVehicle, vehicleChain.length);
  	        }
  	
  	        recalcVehicleViewFromTransactions(
  	          freshVehicle,
  	          activeTransactions,
  	          viewDate,
  	          baselineMileage
  	        );
  	
  	        if (getDeep(freshVehicle, ["ViewC"], null)) {
  	          freshVehicle.ViewC = await saveTableRow("Tractorview", freshVehicle.ViewC);
  	
  	          await syncVehicleViewFuelRelations(
  	            getDeep(freshVehicle, ["ViewC", "objectId"], null),
  	            vehicleChain
  	          );
  	        }
  	
  	        await saveTableRow("Tractors", freshVehicle);
  	
  	        if (getDeep(freshVehicle, ["ViewC", "objectId"], null)) {
  	          await syncVehicleViewRelations(freshVehicle, freshVehicle.ViewC);
  	        }
  	
  	        if (workingCompany) {
  	          replaceNestedCompanyVehicle(workingCompany, freshVehicle);
  	        }
  	
  	        return freshVehicle;
  	      }
  	
  	      async function rebuildAffectedVehicleViews(vehicleIds, activeTransactions, workingCompany) {
  	        var ids = toArray(vehicleIds);
  	        var refreshedVehicleRows = {};
  	
  	        for (var i = 0; i < ids.length; i++) {
  	          if (!ids[i]) continue;
  	          refreshedVehicleRows[ids[i]] = await rebuildVehicleViewForVehicle(ids[i], activeTransactions, workingCompany);
  	        }
  	
  	        return refreshedVehicleRows;
  	      }
  	
  	      function getVehicleTransactionChain(items, vehicleObjectId) {
  	        return getTransactionsForVehicle(items, vehicleObjectId);
  	      }
  	
  	      function buildVehicleChainFromTransactions(items, vehicleObjectId) {
  	        var chain = getVehicleTransactionChain(items, vehicleObjectId);
  	        var repaired = [];
  	
  	        for (var i = 0; i < chain.length; i++) {
  	          var prev = i > 0 ? chain[i - 1]: null;
  	          var row = deepClone(chain[i]);
  	
  	          var prevMileage = toNumber(
  	            firstDefined(
  	              prev ? getDeep(prev, ["Mileage"], null): null,
  	              getDeep(row, ["MileageLast"], null),
  	              0
  	            ),
  	            0
  	          );
  	
  	          var currentMileage = toNumber(
  	            firstDefined(
  	              getDeep(row, ["Mileage"], null),
  	              prevMileage
  	            ),
  	            prevMileage
  	          );
  	
  	          row.MileageLast = prevMileage;
  	          row.Distance = currentMileage - prevMileage;
  	          if (row.Distance < 0) row.Distance = 0;
  	
  	          repaired.push(row);
  	        }
  	
  	        return repaired;
  	      }
  	
  	      async function persistFuelOutChain(chainRows) {
  	        var arr = toArray(chainRows);
  	        var out = [];
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          out.push(await saveTableRow("FuelOut", arr[i]));
  	        }
  	
  	        return out;
  	      }
  	
  	      async function repairVehicleTransactionChain(vehicleObjectId, allTransactions) {
  	        if (!vehicleObjectId) return [];
  	
  	        var repaired = buildVehicleChainFromTransactions(allTransactions, vehicleObjectId);
  	        return await persistFuelOutChain(repaired);
  	      }
  	
  	      function getPreviousAndNextVehicleTransactions(items, targetItem, vehicleObjectId) {
  	        var chain = getVehicleTransactionChain(items, vehicleObjectId);
  	        var prev = null;
  	        var next = null;
  	
  	        for (var i = 0; i < chain.length; i++) {
  	          if (sameObjectId(getDeep(chain[i], ["objectId"], null), getDeep(targetItem, ["objectId"], null))) {
  	            prev = i > 0 ? chain[i - 1]: null;
  	            next = i < chain.length - 1 ? chain[i + 1]: null;
  	            break;
  	          }
  	        }
  	
  	        return {
  	          previous: prev,
  	          next: next
  	        };
  	      }
  	
  	      function getBowserViewMonthKey(view) {
  	        var explicit = text(
  	          getDeep(view, ["MYearKey"], ""),
  	          ""
  	        ).trim();
  	
  	        if (/^\d{4}-\d{2}$/.test(explicit)) {
  	          return explicit;
  	        }
  	
  	        var startDate = getDeep(view, ["DateStart"], null);
  	        if (startDate !== null && startDate !== undefined && startDate !== "") {
  	          return getMYear(getBusinessDate(startDate));
  	        }
  	
  	        var label = text(getDeep(view, ["MYear"], ""), "").trim();
  	        if (label) {
  	          var parsed = new Date("1 " + label + " 12:00:00");
  	          if (!isNaN(parsed.getTime())) {
  	            return getMYear(getBusinessDate(parsed));
  	          }
  	        }
  	
  	        return "";
  	      }
  	
  	      function getCurrentFuelMonthKey() {
  	        return getMYear(getBusinessNowDate());
  	      }
  	
  	      function findTransactionByObjectId(items, objectId) {
  	        var rows = toArray(items);
  	
  	        for (var index = 0; index < rows.length; index++) {
  	          if (
  	            sameObjectId(
  	              getDeep(rows[index], ["objectId"], null),
  	              objectId
  	            )
  	          ) {
  	            return rows[index];
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function removeTransactionByObjectId(items, objectId) {
  	        return toArray(items).filter(function (item) {
  	          return !sameObjectId(
  	            getDeep(item, ["objectId"], null),
  	            objectId
  	          );
  	        });
  	      }
  	
  	      function findLiveVehicleByObjectId(vehicleObjectId) {
  	        if (!vehicleObjectId) return null;
  	
  	        var groups = [];
  	
  	        // Include the active company directly. This keeps historical rows tied
  	        // to the live Tractor record even when AppData has only a partial copy.
  	        if (company && typeof company === "object") {
  	          groups.push(company);
  	        }
  	
  	        groups = groups
  	          .concat(getUserCompaniesFromAppData())
  	          .concat(toArray(contractorsInput));
  	
  	        for (
  	          var groupIndex = 0;
  	          groupIndex < groups.length;
  	          groupIndex++
  	        ) {
  	          var tractors = relationCollectionToArray(
  	            getDeep(groups[groupIndex], ["Tractors"], [])
  	          );
  	
  	          for (
  	            var tractorIndex = 0;
  	            tractorIndex < tractors.length;
  	            tractorIndex++
  	          ) {
  	            if (
  	              sameObjectId(
  	                getDeep(
  	                  tractors[tractorIndex],
  	                  ["objectId"],
  	                  null
  	                ),
  	                vehicleObjectId
  	              )
  	            ) {
  	              return tractors[tractorIndex];
  	            }
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function getFuelOutMileageDifferential(item) {
  	        var explicit = toNumber(
  	          firstDefined(
  	            getDeep(
  	              item,
  	              ["RollbackMileageDifferential"],
  	              null
  	            ),
  	            getDeep(item, ["Distance"], null)
  	          ),
  	          NaN
  	        );
  	
  	        if (Number.isFinite(explicit) && explicit >= 0) {
  	          return explicit;
  	        }
  	
  	        var mileageBefore = toNumber(
  	          firstDefined(
  	            getDeep(
  	              item,
  	              ["RollbackVehicleMileageBefore"],
  	              null
  	            ),
  	            getDeep(item, ["MileageLast"], null)
  	          ),
  	          0
  	        );
  	        var mileageAfter = toNumber(
  	          getDeep(item, ["Mileage"], mileageBefore),
  	          mileageBefore
  	        );
  	
  	        return Math.max(
  	          0,
  	          mileageAfter - mileageBefore
  	        );
  	      }
  	
  	      function getFuelOutBowserMeterBefore(item, fallback) {
  	        return toNumber(
  	          firstDefined(
  	            getDeep(
  	              item,
  	              ["RollbackBowserMeterBefore"],
  	              null
  	            ),
  	            getDeep(item, ["MeterLast"], null),
  	            fallback
  	          ),
  	          toNumber(fallback, 0)
  	        );
  	      }
  	
  	      function buildAdjustedVehicleTransactionsAfterDelete(
  	        transactionRows,
  	        targetItem,
  	        vehicleObjectId,
  	        deletedDistance
  	      ) {
  	        var rows = sortTransactionsAsc(
  	          getTransactionsForVehicle(
  	            transactionRows,
  	            vehicleObjectId
  	          )
  	        );
  	        var targetObjectId = getDeep(
  	          targetItem,
  	          ["objectId"],
  	          null
  	        );
  	        var targetFound = false;
  	        var adjusted = [];
  	
  	        for (
  	          var rowIndex = 0;
  	          rowIndex < rows.length;
  	          rowIndex++
  	        ) {
  	          var row = rows[rowIndex];
  	
  	          if (
  	            sameObjectId(
  	              getDeep(row, ["objectId"], null),
  	              targetObjectId
  	            )
  	          ) {
  	            targetFound = true;
  	            continue;
  	          }
  	
  	          var copy = deepClone(row);
  	
  	          if (targetFound && deletedDistance > 0) {
  	            var oldMileageLast = toNumber(
  	              getDeep(copy, ["MileageLast"], 0),
  	              0
  	            );
  	            var oldMileage = toNumber(
  	              getDeep(copy, ["Mileage"], oldMileageLast),
  	              oldMileageLast
  	            );
  	
  	            copy.MileageLast = Math.max(
  	              0,
  	              oldMileageLast - deletedDistance
  	            );
  	            copy.Mileage = Math.max(
  	              copy.MileageLast,
  	              oldMileage - deletedDistance
  	            );
  	            copy.Distance = Math.max(
  	              0,
  	              copy.Mileage - copy.MileageLast
  	            );
  	          }
  	
  	          adjusted.push(copy);
  	        }
  	
  	        return {
  	          targetFound: targetFound,
  	          rows: adjusted
  	        };
  	      }
  	
  	      async function saveAdjustedVehicleFuelOutRows(rows) {
  	        var source = toArray(rows);
  	        var saved = [];
  	
  	        for (
  	          var rowIndex = 0;
  	          rowIndex < source.length;
  	          rowIndex++
  	        ) {
  	          var row = source[rowIndex];
  	          var rowObjectId = getDeep(
  	            row,
  	            ["objectId"],
  	            null
  	          );
  	
  	          if (!rowObjectId) continue;
  	
  	          saved.push(
  	            await saveTableRow(
  	              "FuelOut",
  	              {
  	                objectId: rowObjectId,
  	                MileageLast: getDeep(
  	                  row,
  	                  ["MileageLast"],
  	                  null
  	                ),
  	                Mileage: getDeep(
  	                  row,
  	                  ["Mileage"],
  	                  null
  	                ),
  	                Distance: getDeep(
  	                  row,
  	                  ["Distance"],
  	                  0
  	                )
  	              }
  	            )
  	          );
  	        }
  	
  	        return saved;
  	      }
  	
  	      function mergeAdjustedTransactionsIntoRows(
  	        baseRows,
  	        adjustedRows
  	      ) {
  	        var base = toArray(baseRows).slice();
  	        var adjusted = toArray(adjustedRows);
  	        var byId = {};
  	
  	        for (
  	          var adjustedIndex = 0;
  	          adjustedIndex < adjusted.length;
  	          adjustedIndex++
  	        ) {
  	          var adjustedId = getDeep(
  	            adjusted[adjustedIndex],
  	            ["objectId"],
  	            null
  	          );
  	
  	          if (adjustedId) {
  	            byId[String(adjustedId)] =
  	              adjusted[adjustedIndex];
  	          }
  	        }
  	
  	        for (
  	          var baseIndex = 0;
  	          baseIndex < base.length;
  	          baseIndex++
  	        ) {
  	          var baseId = getDeep(
  	            base[baseIndex],
  	            ["objectId"],
  	            null
  	          );
  	
  	          if (
  	            baseId &&
  	            byId[String(baseId)]
  	          ) {
  	            base[baseIndex] = Object.assign(
  	              {},
  	              base[baseIndex],
  	              byId[String(baseId)]
  	            );
  	          }
  	        }
  	
  	        return base;
  	      }
  	
  	      function getFuelTransactionDeleteEligibility(item, transactionRows) {
  	        if (!item || !getDeep(item, ["objectId"], null)) {
  	          return {
  	            ok: false,
  	            message: "No transaction is selected."
  	          };
  	        }
  	
  	        var meta = getSelectedBowserViewMeta();
  	
  	        if (!meta || meta.kind !== "current") {
  	          return {
  	            ok: false,
  	            message: "Historical FuelOut months are locked and cannot be deleted."
  	          };
  	        }
  	
  	        if (getBowserViewMonthKey(meta.view) !== getCurrentFuelMonthKey()) {
  	          return {
  	            ok: false,
  	            message: "Only the live current-month BowserView allows deletion."
  	          };
  	        }
  	
  	        if (isTransactionReversed(item)) {
  	          return {
  	            ok: false,
  	            message: "This transaction is already reversed."
  	          };
  	        }
  	
  	        var rows = transactionRows || getDeep(
  	          state,
  	          ["selectedHydratedView", "FuelOut"],
  	          []
  	        );
  	        var highest = getLatestTransactionForBowser(rows);
  	
  	        if (
  	          !highest ||
  	          !sameObjectId(
  	            getDeep(highest, ["objectId"], null),
  	            getDeep(item, ["objectId"], null)
  	          )
  	        ) {
  	          return {
  	            ok: false,
  	            message: "Only the transaction with the highest Bowser meter reading can be deleted."
  	          };
  	        }
  	
  	        return {
  	          ok: true,
  	          message: ""
  	        };
  	      }
  	
  	      function getIntertankDestinationObjectId(item) {
  	        var direct = firstDefined(
  	          getDeep(item, ["DestinationTankObjectId"], null),
  	          getDeep(item, ["DestinationTankId"], null),
  	          getDeep(item, ["IntertankTargetId"], null),
  	          getDeep(item, ["DestinationTank", "objectId"], null)
  	        );
  	
  	        if (direct) return text(direct, "");
  	
  	        var rollbackKey = text(
  	          getDeep(item, ["RollbackGroupId"], ""),
  	          ""
  	        );
  	        var match = rollbackKey.match(/^INTERTANK:([^|]+)/i);
  	        return match ? String(match[1] || "").trim() : "";
  	      }
  	
  	      function getIntertankFuelInObjectId(item) {
  	        var direct = firstDefined(
  	          getDeep(item, ["DestinationFuelInObjectId"], null),
  	          getDeep(item, ["IntertankFuelInObjectId"], null)
  	        );
  	
  	        if (direct) return text(direct, "");
  	
  	        var rollbackKey = text(
  	          getDeep(item, ["RollbackGroupId"], ""),
  	          ""
  	        );
  	        var match = rollbackKey.match(/(?:^|\|)FUELIN:([^|]+)/i);
  	        return match ? String(match[1] || "").trim() : "";
  	      }
  	
  	      async function rollbackVehicleAfterFuelOutDelete(targetItem) {
  	        var vehicleObjectId =
  	          getTransactionVehicleObjectId(targetItem);
  	
  	        if (!vehicleObjectId) {
  	          throw new Error(
  	            "The FuelOut transaction cannot be matched to its vehicle."
  	          );
  	        }
  	
  	        var deletedDistance =
  	          getFuelOutMileageDifferential(targetItem);
  	
  	        if (!(deletedDistance > 0)) {
  	          throw new Error(
  	            "The FuelOut transaction has no positive vehicle mileage differential to reverse."
  	          );
  	        }
  	
  	        var workingVehicle = deepClone(
  	          await loadTableRow(
  	            "Tractors",
  	            vehicleObjectId,
  	            ["ViewC", "ViewH", "Tyres"]
  	          )
  	        );
  	        var liveVehicle =
  	          findLiveVehicleByObjectId(vehicleObjectId);
  	
  	        if (
  	          !relationCollectionToArray(
  	            getDeep(workingVehicle, ["Tyres"], [])
  	          ).length &&
  	          liveVehicle
  	        ) {
  	          workingVehicle.Tyres = deepClone(
  	            relationCollectionToArray(
  	              getDeep(liveVehicle, ["Tyres"], [])
  	            )
  	          );
  	        }
  	
  	        var vehicleViewId = firstDefined(
  	          getDeep(
  	            workingVehicle,
  	            ["ViewC", "objectId"],
  	            null
  	          ),
  	          getDeep(
  	            liveVehicle,
  	            ["ViewC", "objectId"],
  	            null
  	          )
  	        );
  	
  	        if (!vehicleViewId) {
  	          throw new Error(
  	            "The vehicle current Tractorview is missing."
  	          );
  	        }
  	
  	        var freshVehicleView = deepClone(
  	          await loadTableRow(
  	            "Tractorview",
  	            vehicleViewId,
  	            ["Fuel", "Fuel.Tractor"]
  	          )
  	        );
  	        var targetObjectId = getDeep(
  	          targetItem,
  	          ["objectId"],
  	          null
  	        );
  	        var vehicleTransactions =
  	          getActiveTransactionsOnly(
  	            relationCollectionToArray(
  	              getDeep(
  	                freshVehicleView,
  	                ["Fuel"],
  	                []
  	              )
  	            )
  	          );
  	
  	        /*
  	         * Keep the rollback deterministic even if an older Tractorview.Fuel
  	         * relation was incomplete. The target FuelOut itself contains the
  	         * mileage-before, mileage-after and differential values required to
  	         * reverse the forward operation exactly.
  	         */
  	        var adjustmentPlan =
  	          buildAdjustedVehicleTransactionsAfterDelete(
  	            vehicleTransactions,
  	            targetItem,
  	            vehicleObjectId,
  	            deletedDistance
  	          );
  	        var remainingVehicleTransactions =
  	          removeTransactionByObjectId(
  	            adjustmentPlan.rows,
  	            targetObjectId
  	          );
  	
  	        await saveAdjustedVehicleFuelOutRows(
  	          remainingVehicleTransactions
  	        );
  	
  	        var rollbackReadingUnit =
  	          getTransactionReadingUnit(targetItem);
  	
  	        var oldVehicleMileage =
  	          managerVehicleCurrentReading(
  	            workingVehicle
  	          );
  	        var newVehicleMileage = Math.max(
  	          0,
  	          oldVehicleMileage - deletedDistance
  	        );
  	
  	        var oldViewLitres = toNumber(
  	          getDeep(freshVehicleView, ["Litres"], 0),
  	          0
  	        );
  	        var oldViewCost = toNumber(
  	          getDeep(freshVehicleView, ["Cost"], 0),
  	          0
  	        );
  	        var oldViewRebate = toNumber(
  	          getDeep(
  	            freshVehicleView,
  	            ["PotentialSARSRebate"],
  	            0
  	          ),
  	          0
  	        );
  	        var oldViewDistance = toNumber(
  	          getDeep(freshVehicleView, ["Distance"], 0),
  	          0
  	        );
  	        var oldViewHours = toNumber(
  	          getDeep(freshVehicleView, ["Hours"], 0),
  	          0
  	        );
  	        var oldViewMeterEnd = toNumber(
  	          firstDefined(
  	            getDeep(
  	              freshVehicleView,
  	              ["MeterEnd"],
  	              null
  	            ),
  	            oldVehicleMileage
  	          ),
  	          oldVehicleMileage
  	        );
  	        var oldTransactionCount = toNumber(
  	          getDeep(
  	            freshVehicleView,
  	            ["TransactionCount"],
  	            0
  	          ),
  	          0
  	        );
  	
  	        var vehicleViewPatch = {
  	          objectId: vehicleViewId,
  	          TransactionCount: Math.max(
  	            0,
  	            oldTransactionCount - 1
  	          ),
  	          MeterStart: toNumber(
  	            getDeep(
  	              freshVehicleView,
  	              ["MeterStart"],
  	              newVehicleMileage
  	            ),
  	            newVehicleMileage
  	          ),
  	          MeterEnd: Math.max(
  	            0,
  	            oldViewMeterEnd - deletedDistance
  	          ),
  	          Distance:
  	            rollbackReadingUnit === "h"
  	              ? oldViewDistance
  	              : Math.max(
  	                  0,
  	                  oldViewDistance - deletedDistance
  	                ),
  	          Hours:
  	            rollbackReadingUnit === "h"
  	              ? Math.max(
  	                  0,
  	                  oldViewHours - deletedDistance
  	                )
  	              : oldViewHours,
  	          Litres: Math.max(
  	            0,
  	            oldViewLitres -
  	            toNumber(
  	              getDeep(targetItem, ["Litres"], 0),
  	              0
  	            )
  	          ),
  	          Cost: roundMoney2(
  	            Math.max(
  	              0,
  	              oldViewCost -
  	              toNumber(
  	                getDeep(targetItem, ["Cost"], 0),
  	                0
  	              )
  	            )
  	          ),
  	          PotentialSARSRebate: Math.max(
  	            0,
  	            oldViewRebate -
  	            toNumber(
  	              getDeep(
  	                targetItem,
  	                ["PotentialSARSRebate"],
  	                0
  	              ),
  	              0
  	            )
  	          )
  	        };
  	
  	        /*
  	         * If this was the only current-month vehicle transaction, restore the
  	         * view end meter to the transaction's exact mileage-before value.
  	         */
  	        if (
  	          vehicleViewPatch.TransactionCount === 0
  	        ) {
  	          vehicleViewPatch.MeterEnd = toNumber(
  	            firstDefined(
  	              getDeep(
  	                targetItem,
  	                ["RollbackVehicleMileageBefore"],
  	                null
  	              ),
  	              getDeep(
  	                targetItem,
  	                ["MileageLast"],
  	                null
  	              ),
  	              newVehicleMileage
  	            ),
  	            newVehicleMileage
  	          );
  	          if (rollbackReadingUnit === "h") {
  	            vehicleViewPatch.Hours = 0;
  	          } else {
  	            vehicleViewPatch.Distance = 0;
  	          }
  	        }
  	
  	        await setRelation(
  	          "Tractorview",
  	          vehicleViewId,
  	          "Fuel",
  	          remainingVehicleTransactions
  	            .map(function (row) {
  	              return getDeep(
  	                row,
  	                ["objectId"],
  	                null
  	              );
  	            })
  	            .filter(Boolean)
  	        );
  	
  	        var tyreRollback = {
  	          updatedCount: 0,
  	          differential: deletedDistance,
  	          updatedTyres: []
  	        };
  	
  	        tyreRollback =
  	          await bulkRollbackVehicleTyreMileage(
  	            workingVehicle,
  	            deletedDistance,
  	            newVehicleMileage
  	          );
  	
  	        workingVehicle.Mileage =
  	          newVehicleMileage;
  	        managerSetVehicleCurrentReading(
  	          workingVehicle,
  	          newVehicleMileage,
  	          rollbackReadingUnit
  	        );
  	
  	        if (managerHasFuelCounter(workingVehicle)) {
  	          managerSetFuelCounter(
  	            workingVehicle,
  	            Math.max(
  	              0,
  	              managerFuelCounterValue(workingVehicle, 0) - 1
  	            )
  	          );
  	        }
  	
  	        var savedVehicleViewRow =
  	          await saveTableRow(
  	            "Tractorview",
  	            vehicleViewPatch
  	          );
  	        var savedVehicleView = Object.assign(
  	          {},
  	          freshVehicleView,
  	          savedVehicleViewRow || {},
  	          vehicleViewPatch,
  	          {
  	            Fuel:
  	              remainingVehicleTransactions.slice()
  	          }
  	        );
  	
  	        workingVehicle.ViewC =
  	          savedVehicleView;
  	
  	        var tractorPatch = {
  	          objectId: vehicleObjectId,
  	          Mileage: newVehicleMileage
  	        };
  	
  	        if (
  	          getDeep(workingVehicle, ["Data"], null)
  	        ) {
  	          tractorPatch.Data =
  	            workingVehicle.Data;
  	        }
  	
  	        var savedTractor = await saveTableRow(
  	          "Tractors",
  	          tractorPatch
  	        );
  	
  	        if (
  	          savedTractor &&
  	          getDeep(savedTractor, ["updated"], null)
  	        ) {
  	          workingVehicle.updated =
  	            savedTractor.updated;
  	        }
  	
  	        syncVehicleIntoLiveAppData(
  	          workingVehicle
  	        );
  	
  	        console.info(
  	          "[FuelOut Delete] Vehicle rollback applied.",
  	          {
  	            vehicleObjectId: vehicleObjectId,
  	            deletedTransactionId:
  	              targetObjectId,
  	            deletedDistance:
  	              deletedDistance,
  	            oldVehicleMileage:
  	              oldVehicleMileage,
  	            newVehicleMileage:
  	              newVehicleMileage,
  	            oldViewLitres:
  	              oldViewLitres,
  	            newViewLitres:
  	              vehicleViewPatch.Litres,
  	            oldViewMeterEnd:
  	              oldViewMeterEnd,
  	            newViewMeterEnd:
  	              vehicleViewPatch.MeterEnd,
  	            tyreUpdatedCount:
  	              tyreRollback.updatedCount
  	          }
  	        );
  	
  	        return {
  	          vehicle: workingVehicle,
  	          vehicleView:
  	            savedVehicleView,
  	          tyreRollback:
  	            tyreRollback,
  	          oldMileage:
  	            oldVehicleMileage,
  	          newMileage:
  	            newVehicleMileage,
  	          deletedDistance:
  	            deletedDistance,
  	          adjustedTransactions:
  	            remainingVehicleTransactions
  	        };
  	      }
  	
  	      async function deleteLatestFuelTransaction(targetItem) {
  	        if (
  	          !targetItem ||
  	          !getDeep(targetItem, ["objectId"], null)
  	        ) {
  	          throw new Error(
  	            "No transaction is selected for deletion."
  	          );
  	        }
  	
  	        var initialEligibility =
  	          getFuelTransactionDeleteEligibility(
  	            targetItem
  	          );
  	
  	        if (!initialEligibility.ok) {
  	          throw new Error(
  	            initialEligibility.message
  	          );
  	        }
  	
  	        if (
  	          !bowser ||
  	          !getDeep(bowser, ["objectId"], null)
  	        ) {
  	          throw new Error(
  	            "Bowser object is missing."
  	          );
  	        }
  	
  	        if (
  	          !tank ||
  	          !getDeep(tank, ["objectId"], null)
  	        ) {
  	          throw new Error(
  	            "Tank object is missing."
  	          );
  	        }
  	
  	        var freshBowserView =
  	          await loadFreshCurrentBowserView();
  	
  	        if (
  	          getBowserViewMonthKey(
  	            freshBowserView
  	          ) !== getCurrentFuelMonthKey()
  	        ) {
  	          throw new Error(
  	            "The Bowser current view is not the live calendar month."
  	          );
  	        }
  	
  	        var activeTransactions =
  	          getActiveTransactionsOnly(
  	            relationCollectionToArray(
  	              getDeep(
  	                freshBowserView,
  	                ["FuelOut"],
  	                []
  	              )
  	            )
  	          );
  	        var targetObjectId = getDeep(
  	          targetItem,
  	          ["objectId"],
  	          null
  	        );
  	        var freshTarget =
  	          findTransactionByObjectId(
  	            activeTransactions,
  	            targetObjectId
  	          );
  	
  	        if (!freshTarget) {
  	          throw new Error(
  	            "The transaction is no longer present in the live BowserView."
  	          );
  	        }
  	
  	        var highestTransaction =
  	          getLatestTransactionForBowser(
  	            activeTransactions
  	          );
  	
  	        if (
  	          !highestTransaction ||
  	          !sameObjectId(
  	            getDeep(
  	              highestTransaction,
  	              ["objectId"],
  	              null
  	            ),
  	            targetObjectId
  	          )
  	        ) {
  	          throw new Error(
  	            "Deletion blocked. Another transaction now has the highest Bowser meter reading."
  	          );
  	        }
  	
  	        var litres = Math.max(
  	          0,
  	          toNumber(
  	            getDeep(freshTarget, ["Litres"], 0),
  	            0
  	          )
  	        );
  	        var captureType = text(
  	          getDeep(
  	            freshTarget,
  	            ["CaptureType"],
  	            ""
  	          ),
  	          ""
  	        ).trim().toLowerCase();
  	        var remainingTransactions =
  	          removeTransactionByObjectId(
  	            activeTransactions,
  	            targetObjectId
  	          );
  	
  	        var workingTank = deepClone(
  	          await loadTableRow(
  	            "Tanks",
  	            tank.objectId,
  	            ["Bowsers"]
  	          )
  	        );
  	        var workingBowser = deepClone(
  	          await loadTableRow(
  	            "Bowsers",
  	            bowser.objectId,
  	            ["ViewC", "ViewH"]
  	          )
  	        );
  	
  	        var restoredSourceVolume =
  	          toNumber(
  	            getDeep(workingTank, ["Volume"], 0),
  	            0
  	          ) + litres;
  	        var sourceCapacity = toNumber(
  	          getDeep(workingTank, ["Capacity"], 0),
  	          0
  	        );
  	
  	        if (
  	          sourceCapacity > 0 &&
  	          restoredSourceVolume >
  	            sourceCapacity + 0.0001
  	        ) {
  	          throw new Error(
  	            "Deletion would restore the source tank above its capacity."
  	          );
  	        }
  	
  	        workingTank.Volume =
  	          restoredSourceVolume;
  	
  	        if (sourceCapacity > 0) {
  	          workingTank.Level = Math.max(
  	            0,
  	            Math.min(
  	              100,
  	              (
  	                restoredSourceVolume /
  	                sourceCapacity
  	              ) * 100
  	            )
  	          );
  	        }
  	
  	        var destinationTank = null;
  	
  	        if (captureType === "intertank") {
  	          var destinationTankObjectId =
  	            getIntertankDestinationObjectId(
  	              freshTarget
  	            );
  	
  	          if (!destinationTankObjectId) {
  	            throw new Error(
  	              "This legacy intertank transaction has no stored destination tank identifier and cannot be safely deleted."
  	            );
  	          }
  	
  	          destinationTank = deepClone(
  	            await loadTableRow(
  	              "Tanks",
  	              destinationTankObjectId,
  	              ["Bowsers", "FuelIn", "ViewC", "ViewH"]
  	            )
  	          );
  	
  	          var destinationIntertankFuelInObjectId =
  	            getIntertankFuelInObjectId(freshTarget);
  	
  	          if (destinationIntertankFuelInObjectId) {
  	            destinationTank.FuelIn = relationCollectionToArray(
  	              getDeep(destinationTank, ["FuelIn"], [])
  	            ).filter(function (fuelInRow) {
  	              return !sameObjectId(
  	                getDeep(fuelInRow, ["objectId"], null),
  	                destinationIntertankFuelInObjectId
  	              );
  	            });
  	          }
  	
  	          var destinationVolume =
  	            toNumber(
  	              getDeep(
  	                destinationTank,
  	                ["Volume"],
  	                0
  	              ),
  	              0
  	            ) - litres;
  	
  	          if (destinationVolume < -0.0001) {
  	            throw new Error(
  	              "Deletion would reduce the destination tank below zero litres."
  	            );
  	          }
  	
  	          destinationTank.Volume =
  	            Math.max(0, destinationVolume);
  	
  	          var destinationCapacity =
  	            toNumber(
  	              getDeep(
  	                destinationTank,
  	                ["Capacity"],
  	                0
  	              ),
  	              0
  	            );
  	
  	          if (destinationCapacity > 0) {
  	            destinationTank.Level =
  	              Math.max(
  	                0,
  	                Math.min(
  	                  100,
  	                  (
  	                    destinationTank.Volume /
  	                    destinationCapacity
  	                  ) * 100
  	                )
  	              );
  	          }
  	
  	          if (managerIsTrailerTank(destinationTank)) {
  	            destinationTank.LatestCostPerLitre =
  	              managerLatestCostPerLitre(destinationTank);
  	          }
  	        }
  	
  	        var vehicleRollback = null;
  	        var vehicleObjectId =
  	          getTransactionVehicleObjectId(
  	            freshTarget
  	          );
  	
  	        if (
  	          captureType === "company" ||
  	          captureType === "contractor"
  	        ) {
  	          if (!vehicleObjectId) {
  	            throw new Error(
  	              "The transaction cannot be matched to its vehicle, so mileage rollback was blocked."
  	            );
  	          }
  	
  	          vehicleRollback =
  	            await rollbackVehicleAfterFuelOutDelete(
  	              freshTarget
  	            );
  	        }
  	
  	        var oldBowserLitres = toNumber(
  	          getDeep(
  	            freshBowserView,
  	            ["Litres"],
  	            0
  	          ),
  	          0
  	        );
  	        var oldBowserMeterEnd = toNumber(
  	          getDeep(
  	            freshBowserView,
  	            ["MeterEnd"],
  	            0
  	          ),
  	          0
  	        );
  	        var previousBowserTransaction =
  	          getLatestTransactionForBowser(
  	            remainingTransactions
  	          );
  	        var exactMeterBefore =
  	          getFuelOutBowserMeterBefore(
  	            freshTarget,
  	            previousBowserTransaction
  	              ? getDeep(
  	                  previousBowserTransaction,
  	                  ["Meter"],
  	                  null
  	                )
  	              : getDeep(
  	                  freshBowserView,
  	                  ["MeterStart"],
  	                  0
  	                )
  	          );
  	
  	        var bowserViewPatch = {
  	          objectId: getDeep(
  	            freshBowserView,
  	            ["objectId"],
  	            null
  	          ),
  	          Litres: Math.max(
  	            0,
  	            oldBowserLitres - litres
  	          ),
  	          Cost: roundMoney2(
  	            sumTransactionCost(
  	              remainingTransactions
  	            )
  	          ),
  	          MeterStart: toNumber(
  	            getDeep(
  	              freshBowserView,
  	              ["MeterStart"],
  	              exactMeterBefore
  	            ),
  	            exactMeterBefore
  	          ),
  	          MeterEnd: Math.max(
  	            0,
  	            exactMeterBefore
  	          )
  	        };
  	
  	        /*
  	         * Remove the FuelOut relationship first. The totals are then saved
  	         * after the relation no longer contains the deleted row, preventing
  	         * relation-driven server logic from restoring the old values.
  	         */
  	        await setRelation(
  	          "BowserView",
  	          bowserViewPatch.objectId,
  	          "FuelOut",
  	          remainingTransactions
  	            .map(function (row) {
  	              return getDeep(
  	                row,
  	                ["objectId"],
  	                null
  	              );
  	            })
  	            .filter(Boolean)
  	        );
  	
  	        var savedBowserViewRow =
  	          await saveTableRow(
  	            "BowserView",
  	            bowserViewPatch
  	          );
  	        var savedBowserView = Object.assign(
  	          {},
  	          freshBowserView,
  	          savedBowserViewRow || {},
  	          bowserViewPatch,
  	          {
  	            FuelOut:
  	              remainingTransactions.slice()
  	          }
  	        );
  	
  	        workingBowser.Meter =
  	          bowserViewPatch.MeterEnd;
  	        workingBowser.ViewC =
  	          savedBowserView;
  	
  	        var saveJobs = [
  	          saveTableRow(
  	            "Tanks",
  	            {
  	              objectId: getDeep(
  	                workingTank,
  	                ["objectId"],
  	                null
  	              ),
  	              Volume: workingTank.Volume,
  	              Level: workingTank.Level
  	            }
  	          ),
  	          saveTableRow(
  	            "Bowsers",
  	            {
  	              objectId: getDeep(
  	                workingBowser,
  	                ["objectId"],
  	                null
  	              ),
  	              Meter: workingBowser.Meter
  	            }
  	          )
  	        ];
  	
  	        if (destinationTank) {
  	          saveJobs.push(
  	            saveTableRow(
  	              "Tanks",
  	              {
  	                objectId: getDeep(
  	                  destinationTank,
  	                  ["objectId"],
  	                  null
  	                ),
  	                Volume:
  	                  destinationTank.Volume,
  	                Level:
  	                  destinationTank.Level
  	              }
  	            )
  	          );
  	        }
  	
  	        await Promise.all(saveJobs);
  	
  	        var pairedIntertankFuelInObjectId =
  	          captureType === "intertank"
  	            ? getIntertankFuelInObjectId(freshTarget)
  	            : "";
  	
  	        if (pairedIntertankFuelInObjectId) {
  	          await deleteTableRow(
  	            "FuelIn",
  	            pairedIntertankFuelInObjectId
  	          );
  	        }
  	
  	        await deleteTableRow(
  	          "FuelOut",
  	          targetObjectId
  	        );
  	
  	        tank.Volume =
  	          workingTank.Volume;
  	        tank.Level =
  	          workingTank.Level;
  	        bowser.Meter =
  	          workingBowser.Meter;
  	        bowser.ViewC =
  	          savedBowserView;
  	
  	        syncTankIntoLiveAppData(
  	          workingTank
  	        );
  	
  	        if (destinationTank) {
  	          syncTankIntoLiveAppData(
  	            destinationTank
  	          );
  	        }
  	
  	        state.transactionCache =
  	          sortTransactionRows(remainingTransactions);
  	        state.filteredTransactions =
  	          sortTransactionRows(remainingTransactions);
  	        state.currentPage = 1;
  	        state.selectedHydratedView =
  	          savedBowserView;
  	        state.selectedTransaction = null;
  	
  	        renderTankGauge(
  	          tankBlock,
  	          tank
  	        );
  	
  	        try {
  	          if (
  	            context &&
  	            typeof context.onChanged === "function"
  	          ) {
  	            context.onChanged();
  	          }
  	        } catch (_) {}
  	
  	        try {
  	          managerRenderDashboard();
  	        } catch (_) {}
  	
  	        console.info(
  	          "[FuelOut Delete] Complete inverse rollback applied.",
  	          {
  	            deletedTransactionId:
  	              targetObjectId,
  	            captureType:
  	              captureType,
  	            litresRemoved:
  	              litres,
  	            oldBowserViewLitres:
  	              oldBowserLitres,
  	            newBowserViewLitres:
  	              bowserViewPatch.Litres,
  	            oldBowserMeterEnd:
  	              oldBowserMeterEnd,
  	            newBowserMeterEnd:
  	              bowserViewPatch.MeterEnd,
  	            vehicleRollback:
  	              vehicleRollback
  	                ? {
  	                    oldMileage:
  	                      vehicleRollback.oldMileage,
  	                    newMileage:
  	                      vehicleRollback.newMileage,
  	                    deletedDistance:
  	                      vehicleRollback.deletedDistance,
  	                    tyreUpdatedCount:
  	                      getDeep(
  	                        vehicleRollback,
  	                        [
  	                          "tyreRollback",
  	                          "updatedCount"
  	                        ],
  	                        0
  	                      )
  	                  }
  	                : null
  	          }
  	        );
  	
  	        return {
  	          deletedTransactionId:
  	            targetObjectId,
  	          litres:
  	            litres,
  	          vehicleRollback:
  	            vehicleRollback,
  	          destinationTankObjectId:
  	            destinationTank
  	              ? getDeep(
  	                  destinationTank,
  	                  ["objectId"],
  	                  null
  	                )
  	              : null,
  	          destinationFuelInObjectId:
  	            captureType === "intertank"
  	              ? getIntertankFuelInObjectId(freshTarget)
  	              : null
  	        };
  	      }
  	
  	      function formatDatePretty(dateValue) {
  	        if (dateValue === null || dateValue === undefined || dateValue === "") return "";
  	
  	        var rawValue = dateValue;
  	        var parsedDate = null;
  	
  	        if (dateValue instanceof Date) {
  	          parsedDate = new Date(dateValue.getTime());
  	        } else if (typeof dateValue === "number") {
  	          parsedDate = new Date(dateValue);
  	        } else if (typeof dateValue === "string") {
  	          var trimmedValue = dateValue.trim();
  	
  	          if (/^\d+$/.test(trimmedValue)) {
  	            parsedDate = new Date(Number(trimmedValue));
  	          } else {
  	            parsedDate = new Date(trimmedValue);
  	          }
  	        } else {
  	          parsedDate = new Date(dateValue);
  	        }
  	
  	        if (!parsedDate || isNaN(parsedDate.getTime())) {
  	          return String(rawValue);
  	        }
  	
  	        return parsedDate.getFullYear()
  	        + "-" + pad2(parsedDate.getMonth() + 1)
  	        + "-" + pad2(parsedDate.getDate())
  	        + " " + pad2(parsedDate.getHours())
  	        + ":" + pad2(parsedDate.getMinutes())
  	        + ":" + pad2(parsedDate.getSeconds());
  	      }
  	
  	      function buildTransactionSearchIndex(item) {
  	        var parts = [
  	          getDeep(item, ["FuelDate"], ""),
  	          getDeep(item, ["Registration"], ""),
  	          getDeep(item, ["Application"], ""),
  	          getDeep(item, ["CaptureType"], ""),
  	          getDeep(item, ["Description"], ""),
  	          getDeep(item, ["ContractorName"], ""),
  	          getDeep(item, ["DriverName"], ""),
  	          getTransactionCapturedBy(item),
  	          getDeep(item, ["CapturedByEmail"], ""),
  	          getDeep(item, ["CapturedByObjectId"], ""),
  	          getTransactionEfficiencyText(item),
  	          getDeep(item, ["ReadingUnit"], ""),
  	          getDeep(item, ["ReadingDelta"], ""),
  	          getDeep(item, ["Litres"], ""),
  	          getDeep(item, ["Cost"], ""),
  	          getDeep(item, ["CostPerLitre"], ""),
  	          getDeep(item, ["PotentialSARSRebate"], ""),
  	          getTransactionRebateLitres(item),
  	          getDeep(item, ["Meter"], ""),
  	          getDeep(item, ["MeterLast"], ""),
  	          getDeep(item, ["Mileage"], ""),
  	          getDeep(item, ["MileageLast"], ""),
  	          getDeep(item, ["Distance"], ""),
  	          isTransactionReversed(item) ? "reversed": "active",
  	          getDeep(item, ["TractorID"], ""),
  	          getDeep(item, ["Tractor", "ID"], ""),
  	          getDeep(item, ["Tractor", "FID"], ""),
  	          getDeep(item, ["Tractor", "Registration"], ""),
  	          getDeep(item, ["DriverUser", "name"], ""),
  	          getDeep(item, ["DriverUser", "Name"], ""),
  	          getDeep(item, ["DriverUser", "email"], "")
  	        ];
  	
  	        return parts.join(" ").toLowerCase();
  	      }
  	
  	      function buildDetailRow(label, value) {
  	        return ""
  	        + '<div style="display:grid;grid-template-columns:160px 1fr;gap:10px;padding:7px 0;border-bottom:1px solid rgba(255,255,255,0.06);">'
  	        + '<div style="font-size:11px;color:#94a3b8;">' + escapeHtml(label) + "</div>"
  	        + '<div style="font-size:12px;color:#f8fafc;word-break:break-word;white-space:pre-wrap;">' + escapeHtml(text(value, "")) + "</div>"
  	        + "</div>";
  	      }
  	
  	      function getFilteredTotals(transactions) {
  	        var arr = toArray(transactions);
  	        var litres = 0;
  	        var cost = 0;
  	        var rebateCost = 0;
  	        var rebateLitres = 0;
  	        var meterMin = null;
  	        var meterMax = null;
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          var item = arr[i];
  	          var rowLitres = toNumber(getDeep(item, ["Litres"], 0), 0);
  	          var rowCost = toNumber(getDeep(item, ["Cost"], 0), 0);
  	          var rowRebateCost = getTransactionSarsRebate(item);
  	          var rowRebateLitres = getTransactionRebateLitres(item);
  	          var meterLast = toNumber(getDeep(item, ["MeterLast"], NaN), NaN);
  	          var meter = toNumber(getDeep(item, ["Meter"], NaN), NaN);
  	
  	          litres += rowLitres;
  	          cost += rowCost;
  	          rebateCost += rowRebateCost;
  	          rebateLitres += rowRebateLitres;
  	
  	          if (!isNaN(meterLast) && (meterMin === null || meterLast < meterMin)) meterMin = meterLast;
  	          if (!isNaN(meter) && (meterMax === null || meter > meterMax)) meterMax = meter;
  	        }
  	
  	        return {
  	          count: arr.length,
  	          litres: litres,
  	          cost: cost,
  	          rebateCost: rebateCost,
  	          rebateLitres: rebateLitres,
  	          meterStart: meterMin === null ? 0: meterMin,
  	          meterEnd: meterMax === null ? 0: meterMax
  	        };
  	      }
  	
  	      function getWholeMonthTotals() {
  	        var rows = sortTransactionRows(state.transactionCache);
  	        var calculated = getFilteredTotals(rows);
  	        var view = state.selectedHydratedView || (getSelectedBowserViewMeta() || {}).view || null;
  	
  	        if (!view) return calculated;
  	
  	        var viewCount = toNumber(getDeep(view, ["TransactionCount"], NaN), NaN);
  	        var viewLitres = toNumber(getDeep(view, ["Litres"], NaN), NaN);
  	        var viewCost = toNumber(getDeep(view, ["Cost"], NaN), NaN);
  	        var viewMeterStart = toNumber(getDeep(view, ["MeterStart"], NaN), NaN);
  	        var viewMeterEnd = toNumber(getDeep(view, ["MeterEnd"], NaN), NaN);
  	
  	        return {
  	          count: calculated.count,
  	          litres: Number.isFinite(viewLitres) && viewLitres >= 0 ? viewLitres : calculated.litres,
  	          cost: Number.isFinite(viewCost) && viewCost >= 0 ? viewCost : calculated.cost,
  	          rebateCost: calculated.rebateCost,
  	          rebateLitres: calculated.rebateLitres,
  	          meterStart: Number.isFinite(viewMeterStart) ? viewMeterStart : calculated.meterStart,
  	          meterEnd: Number.isFinite(viewMeterEnd) ? viewMeterEnd : calculated.meterEnd
  	        };
  	      }
  	
  	      function openPrintWindow() {
  	        try {
  	          var searchTerm = String(state.searchTerm || "").trim();
  	          var filteredMode = !!searchTerm;
  	          var selectedTransactions = filteredMode
  	            ? sortTransactionRows(state.filteredTransactions)
  	            : sortTransactionRows(state.transactionCache);
  	          var selectedViewMeta = getSelectedBowserViewMeta();
  	          var selectedViewName = selectedViewMeta && selectedViewMeta.view
  	          ? text(getDeep(selectedViewMeta.view, ["MYear"], ""), ""): "";
  	          var totals = filteredMode
  	            ? getFilteredTotals(selectedTransactions)
  	            : getWholeMonthTotals();
  	
  	          if (!selectedTransactions.length) {
  	            alert("There are no visible transactions to print.");
  	            return;
  	          }
  	
  	          var printWin = window.open("", "_blank", "width=1280,height=900");
  	          if (!printWin) {
  	            alert("Print window was blocked by the browser.");
  	            return;
  	          }
  	
  	          var logoHtml = "";
  	          if (svgLogo) {
  	            logoHtml = '<img src="' + escapeHtml(svgLogo) + '" alt="Logo" style="max-height:68px;max-width:240px;object-fit:contain;display:block;">';
  	          }
  	
  	          var rowsHtml = "";
  	          for (var i = 0; i < selectedTransactions.length; i++) {
  	            var item = selectedTransactions[i];
  	            var counters = getTransactionCounterColumns(item);
  	            rowsHtml += ""
  	            + "<tr>"
  	            + "<td>" + escapeHtml(formatDatePretty(getDeep(item, ["FuelDate"], ""))) + "</td>"
  	            + "<td>" + escapeHtml(getTransactionRegistration(item)) + "</td>"
  	            + "<td>" + escapeHtml(getTransactionDriver(item)) + "</td>"
  	            + "<td>" + escapeHtml(text(getDeep(item, ["Application"], ""), "")) + "</td>"
  	            + "<td>" + escapeHtml(text(getDeep(item, ["CaptureType"], ""), "")) + "</td>"
  	            + "<td>" + escapeHtml(isTransactionReversed(item) ? "Reversed": "Active") + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["Litres"], 0), 2)) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["CostPerLitre"], getTransactionUnitCost(item)), 2)) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["Cost"], 0), 2)) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getTransactionSarsRebate(item), 2)) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getTransactionRebateLitres(item), 2)) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["MeterLast"], 0), 2)) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["Meter"], 0), 2)) + "</td>"
  	            + "<td class='num'>" + escapeHtml(counters.odometer) + "</td>"
  	            + "<td class='num'>" + escapeHtml(counters.hobbs) + "</td>"
  	            + "<td class='num'>" + escapeHtml(counters.distance) + "</td>"
  	            + "<td class='num'>" + escapeHtml(counters.hours) + "</td>"
  	            + "<td class='num'>" + escapeHtml(counters.kmPerL) + "</td>"
  	            + "<td class='num'>" + escapeHtml(counters.litresPerHour) + "</td>"
  	            + "<td>" + escapeHtml(text(getDeep(item, ["Description"], ""), "")) + "</td>"
  	            + "<td class='fit'>" + escapeHtml(getTransactionCapturedBy(item)) + "</td>"
  	            + "</tr>";
  	          }
  	
  	          var reportTitle = "Fuel Transactions Report";
  	          var reportSubTitle = selectedViewName ? ("View: " + selectedViewName): "View: Not specified";
  	          var filterLabel = searchTerm ? ('Filtered by: "' + searchTerm + '"') : "Scope: Whole Month";
  	          var generatedAt = formatDatePretty(new Date().toISOString());
  	          var companyLabel = text(getDeep(company, ["CompanyId"], ""), "");
  	          var bowserLabel = text(firstDefined(getDeep(bowser, ["Name"], null), getDeep(bowser, ["Pump"], null)), "Bowser");
  	          var tankLabel = text(getDeep(tank, ["Grade"], ""), "");
  	          var meterStartText = displayNumber(totals.meterStart, 2);
  	          var meterEndText = displayNumber(totals.meterEnd, 2);
  	          var litresText = displayNumber(totals.litres, 2);
  	          var costText = formatCurrency(totals.cost);
  	          var rebateText = formatCurrency(totals.rebateCost);
  	          var rebateLitresText = displayNumber(totals.rebateLitres, 2) + " L";
  	
  	          var html = ""
  	          + "<!doctype html>"
  	          + "<html>"
  	          + "<head>"
  	          + '<meta charset="utf-8">'
  	          + "<title>" + escapeHtml(reportTitle) + "</title>"
  	          + "<style>"
  	          + "html,body{margin:0;padding:0;background:#ffffff;color:#111827;font-family:Arial,sans-serif;}"
  	          + "body{padding:28px 30px 36px 30px;}"
  	          + ".header{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;border-bottom:2px solid #111827;padding-bottom:14px;margin-bottom:18px;}"
  	          + ".title{font-size:24px;font-weight:700;line-height:1.1;margin:0;}"
  	          + ".subtitle{font-size:12px;color:#4b5563;margin-top:6px;}"
  	          + ".meta{font-size:12px;color:#374151;line-height:1.6;margin-top:10px;}"
  	          + ".summary-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin:18px 0 18px 0;}"
  	          + ".summary-card{border:1px solid #d1d5db;border-radius:8px;padding:12px;background:#f9fafb;}"
  	          + ".summary-label{font-size:11px;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;}"
  	          + ".summary-value{font-size:18px;font-weight:700;color:#111827;margin-top:6px;}"
  	          + ".section-title{font-size:14px;font-weight:700;color:#111827;margin:18px 0 10px 0;}"
  	          + "table{width:100%;border-collapse:collapse;table-layout:fixed;}"
  	          + "thead th{background:#111827;color:#ffffff;font-size:9px;text-transform:uppercase;letter-spacing:.04em;padding:10px 8px;border:1px solid #0f172a;text-align:left;}"
  	          + "tbody td{font-size:9px;color:#111827;padding:8px;border:1px solid #d1d5db;vertical-align:top;word-wrap:break-word;}"
  	          + ".num{text-align:right;font-variant-numeric:tabular-nums;}"
  	          + ".fit{width:1%;white-space:nowrap;}"
  	          + ".footer{margin-top:18px;font-size:10px;color:#6b7280;border-top:1px solid #d1d5db;padding-top:10px;}"
  	          + "@page{size:A3 landscape;margin:8mm;}"
  	          + "@media print{"
  	          + "  body{padding:10px 12px 14px 12px;}"
  	          + "  .summary-card{break-inside:avoid;}"
  	          + "  tr, td, th{page-break-inside:avoid;}"
  	          + "}"
  	          + "</style>"
  	          + "</head>"
  	          + "<body>"
  	          + '<div class="header">'
  	          + '  <div style="flex:1;min-width:0;">'
  	          + '    <h1 class="title">' + escapeHtml(reportTitle) + "</h1>"
  	          + '    <div class="subtitle">' + escapeHtml(reportSubTitle) + "</div>"
  	          + '    <div class="meta">'
  	          + "      <div><strong>Company:</strong> " + escapeHtml(companyLabel || "-") + "</div>"
  	          + "      <div><strong>Bowser:</strong> " + escapeHtml(bowserLabel || "-") + "</div>"
  	          + "      <div><strong>Tank:</strong> " + escapeHtml(tankLabel || "-") + "</div>"
  	          + "      <div><strong>Generated:</strong> " + escapeHtml(generatedAt) + "</div>"
  	          + "      <div><strong>" + escapeHtml(filterLabel) + "</strong></div>"
  	          + "    </div>"
  	          + "  </div>"
  	          + '  <div style="width:260px;display:flex;justify-content:flex-end;align-items:flex-start;">'
  	          + logoHtml
  	          + "  </div>"
  	          + "</div>"
  	
  	          + '<div class="summary-grid">'
  	          + '  <div class="summary-card"><div class="summary-label">Bowser</div><div class="summary-value" style="font-size:16px;">' + escapeHtml(bowserLabel) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Bowser Meter Start</div><div class="summary-value">' + escapeHtml(meterStartText) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Bowser Meter End</div><div class="summary-value">' + escapeHtml(meterEndText) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Transactions</div><div class="summary-value">' + escapeHtml(String(totals.count)) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Litres</div><div class="summary-value">' + escapeHtml(litresText) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Cost</div><div class="summary-value">' + escapeHtml(costText) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Potential Rebate (Value)</div><div class="summary-value">' + escapeHtml(rebateText) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Potential Rebate (Litres)</div><div class="summary-value">' + escapeHtml(rebateLitresText) + "</div></div>"
  	          + "</div>"
  	
  	          + '<div class="section-title">Transactions</div>'
  	          + "<table>"
  	          + "<thead>"
  	          + "<tr>"
  	          + "<th style='width:120px;'>Date</th>"
  	          + "<th style='width:120px;'>Registration</th>"
  	          + "<th style='width:120px;'>Driver</th>"
  	          + "<th style='width:110px;'>Application</th>"
  	          + "<th style='width:90px;'>Type</th>"
  	          + "<th style='width:80px;'>Status</th>"
  	          + "<th style='width:70px;text-align:right;'>Litres</th>"
  	          + "<th style='width:70px;text-align:right;'>R/L</th>"
  	          + "<th style='width:85px;text-align:right;'>Cost</th>"
  	          + "<th style='width:100px;text-align:right;'>Rebate Value</th>"
  	          + "<th style='width:100px;text-align:right;'>Rebate Litres</th>"
  	          + "<th style='width:78px;text-align:right;'>Bowser Start</th>"
  	          + "<th style='width:78px;text-align:right;'>Bowser End</th>"
  	          + "<th style='width:86px;text-align:right;'>Odometer</th>"
  	          + "<th style='width:86px;text-align:right;'>Hobbs Meter</th>"
  	          + "<th style='width:76px;text-align:right;'>Distance</th>"
  	          + "<th style='width:76px;text-align:right;'>Hours</th>"
  	          + "<th style='width:68px;text-align:right;'>Km/L</th>"
  	          + "<th style='width:68px;text-align:right;'>L/H</th>"
  	          + "<th>Description</th>"
  	          + "<th class='fit'>Captured By</th>"
  	          + "</tr>"
  	          + "</thead>"
  	          + "<tbody>"
  	          + rowsHtml
  	          + "</tbody>"
  	          + "</table>"
  	
  	          + '<div class="footer">'
  	          + "This report reflects the transactions currently visible on screen at the time of printing. "
  	          + "If a search filter is active, totals and rows are limited to the filtered result set."
  	          + "</div>"
  	
  	          + '<script>'
  	          + "window.onload=function(){setTimeout(function(){window.print();},250);};"
  	          + "</script>"
  	          + "</body>"
  	          + "</html>";
  	
  	          printWin.document.open();
  	          printWin.document.write(html);
  	          printWin.document.close();
  	        } catch (printErr) {
  	          console.log("Print / PDF error:", printErr);
  	          alert("Print failed: " + (printErr && printErr.message ? printErr.message: printErr));
  	        }
  	      }
  	
  	      function openSingleTransactionPrintWindow(item) {
  	        try {
  	          if (!item) {
  	            alert("No transaction selected.");
  	            return;
  	          }
  	
  	          var printWin = window.open("", "_blank", "width=1100,height=850");
  	          if (!printWin) {
  	            alert("Print window was blocked by the browser.");
  	            return;
  	          }
  	
  	          var logoHtml = "";
  	          if (svgLogo) {
  	            logoHtml = '<img src="' + escapeHtml(svgLogo) + '" alt="Logo" style="max-height:68px;max-width:240px;object-fit:contain;display:block;">';
  	          }
  	
  	          var fuelDate = formatDatePretty(getDeep(item, ["FuelDate"], ""));
  	          var tractorHeading = getTransactionTractorHeading(item);
  	          var registration = getTransactionRegistration(item);
  	          var driver = getTransactionDriver(item);
  	          var capturedBy = getTransactionCapturedBy(item);
  	          var efficiencyText = getTransactionEfficiencyText(item);
  	          var readingDelta = getTransactionReadingDelta(item);
  	          var readingUnit = getTransactionReadingUnit(item);
  	          var captureType = text(getDeep(item, ["CaptureType"], ""), "");
  	          var application = text(getDeep(item, ["Application"], ""), "");
  	          var description = text(getDeep(item, ["Description"], ""), "");
  	          var contractorName = text(getDeep(item, ["ContractorName"], ""), "");
  	          var litres = toNumber(getDeep(item, ["Litres"], 0), 0);
  	          var cost = toNumber(getDeep(item, ["Cost"], 0), 0);
  	          var costPerLitre = getTransactionUnitCost(item);
  	          var sarsRebate = getTransactionSarsRebate(item);
  	          var sarsRebateLitres = getTransactionRebateLitres(item);
  	          var sarsCompliance = firstDefined(getDeep(item, ["SARSCompliance"], null), false) ? "Yes": "No";
  	          var mileage = text(getDeep(item, ["Mileage"], ""), "");
  	          var mileageLast = text(getDeep(item, ["MileageLast"], ""), "");
  	          var distance = text(getDeep(item, ["Distance"], ""), "");
  	          var meter = displayNumber(getDeep(item, ["Meter"], 0), 2);
  	          var meterLast = displayNumber(getDeep(item, ["MeterLast"], 0), 2);
  	          var tolerance = displayNumber(getDeep(item, ["Tolerance"], 0), 2);
  	          var rollbackStatus = isTransactionReversed(item) ? "Reversed": "Active";
  	          var companyLabel = text(getDeep(company, ["CompanyId"], ""), "");
  	          var bowserLabel = text(firstDefined(getDeep(bowser, ["Name"], null), getDeep(bowser, ["Pump"], null)), "Bowser");
  	          var tankLabel = text(getDeep(tank, ["Grade"], ""), "");
  	          var generatedAt = formatDatePretty(new Date().toISOString());
  	
  	          var html = ""
  	          + "<!doctype html>"
  	          + "<html>"
  	          + "<head>"
  	          + '<meta charset="utf-8">'
  	          + "<title>Fuel Transaction</title>"
  	          + "<style>"
  	          + "html,body{margin:0;padding:0;background:#ffffff;color:#111827;font-family:Arial,sans-serif;}"
  	          + "body{padding:28px 30px 36px 30px;}"
  	          + ".header{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;border-bottom:2px solid #111827;padding-bottom:14px;margin-bottom:18px;}"
  	          + ".title{font-size:24px;font-weight:700;line-height:1.1;margin:0;}"
  	          + ".subtitle{font-size:12px;color:#4b5563;margin-top:6px;}"
  	          + ".meta{font-size:12px;color:#374151;line-height:1.6;margin-top:10px;}"
  	          + ".grid{display:grid;grid-template-columns:repeat(2,1fr);gap:16px;margin-top:18px;}"
  	          + ".card{border:1px solid #d1d5db;border-radius:10px;padding:14px;background:#f9fafb;break-inside:avoid;}"
  	          + ".card-title{font-size:13px;font-weight:700;color:#111827;margin-bottom:8px;}"
  	          + ".row{display:grid;grid-template-columns:160px 1fr;gap:12px;padding:7px 0;border-bottom:1px solid #e5e7eb;}"
  	          + ".label{font-size:11px;color:#6b7280;}"
  	          + ".value{font-size:12px;color:#111827;font-weight:600;word-break:break-word;}"
  	          + ".footer{margin-top:18px;font-size:10px;color:#6b7280;border-top:1px solid #d1d5db;padding-top:10px;}"
  	          + "@media print{body{padding:18px 20px 22px 20px;}}"
  	          + "</style>"
  	          + "</head>"
  	          + "<body>"
  	          + '<div class="header">'
  	          + '  <div style="flex:1;min-width:0;">'
  	          + '    <h1 class="title">Fuel Transaction</h1>'
  	          + '    <div class="subtitle">' + escapeHtml(registration) + "</div>"
  	          + '    <div class="meta">'
  	          + "      <div><strong>Company:</strong> " + escapeHtml(companyLabel || "-") + "</div>"
  	          + "      <div><strong>Bowser:</strong> " + escapeHtml(bowserLabel || "-") + "</div>"
  	          + "      <div><strong>Tank:</strong> " + escapeHtml(tankLabel || "-") + "</div>"
  	          + "      <div><strong>Generated:</strong> " + escapeHtml(generatedAt) + "</div>"
  	          + "    </div>"
  	          + "  </div>"
  	          + '  <div style="width:260px;display:flex;justify-content:flex-end;align-items:flex-start;">'
  	          + logoHtml
  	          + "  </div>"
  	          + "</div>"
  	
  	          + '<div class="grid">'
  	          + '  <div class="card">'
  	          + '    <div class="card-title">Capture</div>'
  	          + '    <div class="row"><div class="label">Fuel Date</div><div class="value">' + escapeHtml(fuelDate) + "</div></div>"
  	          + '    <div class="row"><div class="label">Tractor</div><div class="value">' + escapeHtml(tractorHeading) + "</div></div>"
  	          + '    <div class="row"><div class="label">Capture Type</div><div class="value">' + escapeHtml(captureType) + "</div></div>"
  	          + '    <div class="row"><div class="label">Application</div><div class="value">' + escapeHtml(application) + "</div></div>"
  	          + '    <div class="row"><div class="label">Registration</div><div class="value">' + escapeHtml(registration) + "</div></div>"
  	          + '    <div class="row"><div class="label">Driver</div><div class="value">' + escapeHtml(driver) + "</div></div>"
  	          + '    <div class="row"><div class="label">Captured By</div><div class="value">' + escapeHtml(capturedBy) + "</div></div>"
  	          + '    <div class="row"><div class="label">Contractor</div><div class="value">' + escapeHtml(contractorName) + "</div></div>"
  	          + '    <div class="row"><div class="label">Description</div><div class="value" style="white-space:pre-wrap;">' + escapeHtml(description) + "</div></div>"
  	          + '    <div class="row"><div class="label">Status</div><div class="value">' + escapeHtml(rollbackStatus) + "</div></div>"
  	          + "  </div>"
  	
  	          + '  <div class="card">'
  	          + '    <div class="card-title">Figures</div>'
  	          + '    <div class="row"><div class="label">Litres</div><div class="value">' + escapeHtml(displayNumber(litres, 2)) + "</div></div>"
  	          + '    <div class="row"><div class="label">Cost Per Litre</div><div class="value">' + escapeHtml(formatCurrency(costPerLitre)) + "</div></div>"
  	          + '    <div class="row"><div class="label">Cost</div><div class="value">' + escapeHtml(formatCurrency(cost)) + "</div></div>"
  	          + '    <div class="row"><div class="label">SARS Compliant</div><div class="value">' + escapeHtml(sarsCompliance) + "</div></div>"
  	          + '    <div class="row"><div class="label">Vehicle SARS Rate</div><div class="value">' + escapeHtml(formatCurrency(getTransactionVehicleSarsRate(item)) + " / L") + "</div></div>"
  	          + '    <div class="row"><div class="label">Potential Rebate (Value)</div><div class="value">' + escapeHtml(formatCurrency(sarsRebate)) + "</div></div>"
  	          + '    <div class="row"><div class="label">Potential Rebate (Litres)</div><div class="value">' + escapeHtml(displayNumber(sarsRebateLitres, 2) + " L") + "</div></div>"
  	          + '    <div class="row"><div class="label">' + escapeHtml(getTransactionEfficiencyLabel(item)) + '</div><div class="value">' + escapeHtml(efficiencyText) + "</div></div>"
  	          + '    <div class="row"><div class="label">' + escapeHtml(getTransactionReadingLabels(item).previous) + '</div><div class="value">' + escapeHtml(formatTransactionReading(item, mileageLast)) + "</div></div>"
  	          + '    <div class="row"><div class="label">' + escapeHtml(getTransactionReadingLabels(item).current) + '</div><div class="value">' + escapeHtml(formatTransactionReading(item, mileage)) + "</div></div>"
  	          + '    <div class="row"><div class="label">' + escapeHtml(getTransactionReadingLabels(item).delta) + '</div><div class="value">' + escapeHtml(formatTransactionReading(item, readingDelta)) + "</div></div>"
  	          + '    <div class="row"><div class="label">Bowser Meter Start</div><div class="value">' + escapeHtml(meterLast) + "</div></div>"
  	          + '    <div class="row"><div class="label">Bowser Meter End</div><div class="value">' + escapeHtml(meter) + "</div></div>"
  	          + '    <div class="row"><div class="label">Tolerance</div><div class="value">' + escapeHtml(tolerance) + "</div></div>"
  	          + "  </div>"
  	          + "</div>"
  	
  	          + '<div class="footer">This printout reflects the selected transaction only.</div>'
  	          + '<script>window.onload=function(){setTimeout(function(){window.print();},250);};</script>'
  	          + "</body>"
  	          + "</html>";
  	
  	          printWin.document.open();
  	          printWin.document.write(html);
  	          printWin.document.close();
  	        } catch (printErr) {
  	          console.log("Single transaction print error:", printErr);
  	          alert("Single transaction print failed: " + (printErr && printErr.message ? printErr.message: printErr));
  	        }
  	      }
  	
  	      var state = {
  	        transactionCache: [],
  	        filteredTransactions: [],
  	        selectedTransaction: null,
  	        selectedHydratedView: null,
  	        searchTerm: "",
  	        sortKey: "date",
  	        sortDirection: "desc",
  	        pageSize: 10,
  	        currentPage: 1
  	      };
  	
  	      var companyId = text(getDeep(company, ["CompanyId"], ""), "");
  	      var bowserName = text(firstDefined(getDeep(bowser, ["Name"], null), getDeep(bowser, ["Pump"], null)), "Bowser");
  	      var tankGrade = text(getDeep(tank, ["Grade"], ""), "");
  	
  	      var subtitleParts = [];
  	      if (bowserName) subtitleParts.push(bowserName);
  	      if (tankGrade) subtitleParts.push(tankGrade);
  	      if (companyId) subtitleParts.push(companyId);
  	      var subtitle = subtitleParts.join(" | ");
  	
  	      var companyApplications = toArray(getDeep(company, ["Manifest", "Applications"], []));
  	      var companyTractors = toArray(getDeep(company, ["Tractors"], []));
  	      var companyEmployees = toArray(getDeep(company, ["Employees"], []));
  	      var contractors = toArray(contractorsInput);
  	
  	      var applicationOptions = optionWithOtherFirst(
  	        uniqueByValue(
  	          companyApplications.map(function (app, index) {
  	            return normalizeOption(text(app, "APP_" + (index + 1)), text(app, "Application " + (index + 1)), app);
  	          })
  	        ),
  	        "Other"
  	      );
  	
  	      var compatibleCompanyTractors =
  	        filterVehiclesForTankGrade(
  	          companyTractors,
  	          tankGrade
  	        );
  	
  	      var companyVehicleOptions = optionWithOtherFirst(
  	        buildVehicleOptions(
  	          compatibleCompanyTractors,
  	          "COMPANY_VEHICLE"
  	        ),
  	        "Other"
  	      );
  	
  	      var driverOptions = optionWithOtherFirst(
  	        buildEmployeeOptions(companyEmployees),
  	        "Other"
  	      );
  	
  	      var contractorOptions = optionWithOtherFirst(
  	        buildContractorOptions(contractors),
  	        "Other"
  	      );
  	
  	      var captureTypeOptionsHtml =
  	        buildCaptureTypeOptionsHtml(tankGrade);
  	
  	      var existing = document.getElementById("fuel-capture-overlay");
  	      if (existing) existing.remove();
  	
  	      var overlay = document.createElement("div");
  	      overlay.id = "fuel-capture-overlay";
  	      overlay.style.position = "fixed";
  	      overlay.style.inset = "0";
  	      overlay.style.zIndex = String(FIF_MAX_Z_INDEX);
  	      overlay.style.display = "flex";
  	      overlay.style.alignItems = "center";
  	      overlay.style.justifyContent = "center";
  	      overlay.style.background = "rgba(0,0,0,0.40)";
  	      overlay.style.backdropFilter = "blur(2px)";
  	      overlay.style.padding = "14px";
  	      overlay.style.boxSizing = "border-box";
  	
  	      var modal = document.createElement("div");
  	      modal.id = "fuel-capture-modal";
  	      modal.style.width = "calc(100vw - 28px)";
  	      modal.style.height = "calc(100vh - 28px)";
  	      modal.style.maxWidth = "none";
  	      modal.style.maxHeight = "none";
  	      modal.style.background = "linear-gradient(180deg, rgba(5,10,18,0.96) 0%, rgba(10,16,24,0.94) 100%)";
  	      modal.style.borderRadius = "18px";
  	      modal.style.overflow = "hidden";
  	      modal.style.boxShadow = "0 18px 50px rgba(0,0,0,0.38)";
  	      modal.style.display = "flex";
  	      modal.style.flexDirection = "column";
  	      modal.style.color = "#f8fafc";
  	      modal.style.fontFamily = "Arial, sans-serif";
  	      modal.style.border = "1px solid rgba(255,255,255,0.06)";
  	
  	      modal.innerHTML = ""
  	      + "<style>"
  	      + "#fuel-capture-modal{font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif!important;}"
  	      + ".fuel-dark-select{appearance:none;-webkit-appearance:none;-moz-appearance:none;}"
  	      + ".fuel-dark-select option{background:#0b1119;color:#f8fafc;}"
  	      + ".fuel-soft-input,.fuel-dark-select{width:100%!important;height:46px!important;border-radius:12px!important;border:1px solid rgba(255,255,255,.12)!important;background:linear-gradient(180deg,#121923,#0c121a)!important;color:#f8fafc!important;padding:0 13px!important;font-size:14px!important;font-weight:650!important;box-sizing:border-box!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.035),0 8px 18px rgba(0,0,0,.12)!important;outline:none!important;}"
  	      + ".fuel-soft-input::placeholder{color:#64748b!important;}"
  	      + ".fuel-soft-input:focus,.fuel-dark-select:focus{border-color:rgba(204,102,51,.82)!important;box-shadow:0 0 0 3px rgba(204,102,51,.13),inset 0 1px 0 rgba(255,255,255,.04)!important;}"
  	      + ".fuel-error-text{display:none;margin-top:5px;font-size:11px;color:#ff8c8c;font-weight:700;}"
  	      + ".fuel-help-text{display:none;margin-top:5px;font-size:11px;color:#94a3b8;}"
  	      + "#fuel-capture-panel{background:radial-gradient(circle at 18% 0%,rgba(204,102,51,.06),transparent 36%);}"
  	      + "#fuel-capture-panel>div:not(.fuel-form-intro){padding:18px!important;border:1px solid rgba(255,255,255,.075);border-top-color:rgba(204,102,51,.34);border-radius:18px;background:linear-gradient(145deg,rgba(255,255,255,.045),rgba(255,255,255,.018));box-shadow:0 16px 34px rgba(0,0,0,.18);}"
  	      + "#fuel-capture-panel label{font-size:12px!important;font-weight:800!important;color:#cbd5e1!important;letter-spacing:.01em!important;margin:0 0 7px 2px!important;}"
  	      + ".fuel-form-intro{width:100%;max-width:none;box-sizing:border-box;margin:0 0 12px;padding:14px 16px;border:1px solid rgba(204,102,51,.28);border-radius:16px;background:linear-gradient(145deg,rgba(204,102,51,.12),rgba(255,255,255,.025));}"
  	      + ".fuel-form-intro-title{font-size:18px;font-weight:900;color:#fff;}"
  	      + ".fuel-form-intro-copy{margin-top:4px;font-size:11px;color:#94a3b8;}@media(max-width:760px){.fuel-capture-form-grid,.fuel-delivery-form-grid{grid-template-columns:1fr!important;}.fuel-capture-form-grid>[style*='grid-column'],.fuel-delivery-form-grid>[style*='grid-column']{grid-column:1!important;}.fuel-capture-form-actions,.fuel-delivery-form-actions{flex-direction:column!important;}.fuel-capture-form-actions button,.fuel-delivery-form-actions button{width:100%!important;flex:none!important;}}"
  	      + ".fuel-summary-stack{display:grid;grid-template-columns:1fr;gap:8px;}"
  	      + ".fuel-summary-card{background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,255,255,.035));border:1px solid rgba(255,255,255,.055);border-radius:12px;padding:10px 12px;min-width:0;}"
  	      + ".fuel-summary-card .label{font-size:10px;color:#94a3b8;}"
  	      + ".fuel-summary-card .value{margin-top:3px;font-size:17px;font-weight:850;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-sort-select{width:128px!important;height:40px!important;}"
  	      + ".fuel-sort-direction{height:40px;min-width:58px;padding:0 12px;border:1px solid rgba(255,255,255,.10);border-radius:11px;background:rgba(255,255,255,.06);color:#f8fafc;font-size:12px;font-weight:850;cursor:pointer;}"
  	      + ".fuel-tx-item:hover{background:rgba(255,255,255,.10)!important;border-color:rgba(204,102,51,.35)!important;transform:translateY(-1px);}"
  	      + ".fuel-tx-item{transition:all 140ms ease;border:1px solid rgba(255,255,255,.055)!important;}"
  	      + ".fuel-detail-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.58);display:none;align-items:center;justify-content:center;padding:18px;box-sizing:border-box;z-index:20;backdrop-filter:blur(4px);}"
  	      + ".fuel-detail-card{width:min(900px,100%);max-height:100%;overflow:auto;background:linear-gradient(180deg,rgba(12,18,28,.99),rgba(9,14,22,.99));border:1px solid rgba(204,102,51,.24);border-radius:18px;box-shadow:0 24px 70px rgba(0,0,0,.52);}"
  	      + "#fuel-save-btn{background:linear-gradient(145deg,#9c4822,#5e2914)!important;box-shadow:0 10px 24px rgba(204,102,51,.22)!important;}"
  	      + "#fuel-cancel-btn{background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,255,255,.035))!important;border-color:rgba(255,255,255,.12)!important;}"
  	      + ".fuel-ledger-layout{display:grid;grid-template-columns:280px minmax(0,1fr);gap:14px;height:100%;min-height:0;}"
  	      + ".fuel-ledger-sidebar{display:flex;flex-direction:column;gap:10px;min-height:0;padding:12px;border:1px solid rgba(255,255,255,.07);border-top-color:rgba(204,102,51,.34);border-radius:18px;background:linear-gradient(145deg,rgba(255,255,255,.045),rgba(255,255,255,.018));box-shadow:0 16px 34px rgba(0,0,0,.18);overflow:auto;}"
  	      + ".fuel-ledger-selector{background:linear-gradient(145deg,rgba(255,255,255,.07),rgba(255,255,255,.03));border:1px solid rgba(255,255,255,.07);border-radius:13px;padding:12px;}"
  	      + ".fuel-ledger-main{display:flex;flex-direction:column;min-height:0;position:relative;padding:12px;border:1px solid rgba(255,255,255,.07);border-top-color:rgba(204,102,51,.34);border-radius:18px;background:linear-gradient(145deg,rgba(255,255,255,.045),rgba(255,255,255,.018));box-shadow:0 16px 34px rgba(0,0,0,.18);}"
  	      + ".fuel-ledger-toolbar{display:flex;gap:8px;align-items:center;margin-bottom:10px;flex-wrap:wrap;}"
  	      + ".fuel-ledger-search{flex:1 1 260px;height:40px!important;}"
  	      + ".fuel-ledger-action{height:40px;padding:0 14px;border:1px solid rgba(255,255,255,.11);border-radius:11px;background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,255,255,.035));color:#e2e8f0;font-size:12px;font-weight:850;cursor:pointer;white-space:nowrap;}"
  	      + ".fuel-ledger-action:hover{border-color:rgba(204,102,51,.50);background:rgba(204,102,51,.12);color:#fff;}"
  	      + ".fuel-ledger-action-primary{border-color:rgba(204,102,51,.55);background:linear-gradient(145deg,#9c4822,#5e2914);color:#fff;box-shadow:0 8px 20px rgba(204,102,51,.20);}"
  	      + ".fuel-ledger-table{flex:1;min-height:0;overflow:auto;box-sizing:border-box;border:1px solid rgba(255,255,255,.075);border-radius:14px;background:rgba(5,10,16,.52);box-shadow:inset 0 1px 0 rgba(255,255,255,.025);}"
  	      + ".fuel-ledger-head{position:sticky;top:0;z-index:5;padding:0 17px;box-sizing:border-box;background:linear-gradient(180deg,#171e28,#111821);border-bottom:1px solid rgba(204,102,51,.30);box-shadow:0 8px 16px rgba(0,0,0,.22);}"
  	      + ".fuel-ledger-head-cell{height:44px;display:flex;align-items:center;gap:5px;min-width:0;padding:0 2px;color:#aebdcc;font-size:9px;font-weight:900;text-transform:uppercase;letter-spacing:.035em;white-space:nowrap;overflow:hidden;}"
  	      + ".fuel-ledger-sort{width:100%;height:44px;display:flex;align-items:center;justify-content:flex-start;gap:4px;padding:0 2px;min-width:0;box-sizing:border-box;border:none;background:transparent;color:#aebdcc;font-size:9px;font-weight:900;text-transform:uppercase;letter-spacing:.025em;cursor:default;text-align:left;white-space:nowrap;overflow:hidden;}.fuel-ledger-sort>span:first-child{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}"
  	      + ".fuel-ledger-sort:hover{color:#fff;}"
  	      + ".fuel-ledger-sort.active{color:#ff9a3d;}"
  	      + ".fuel-sort-arrow{font-size:11px;line-height:1;color:#64748b;}"
  	      + ".fuel-ledger-sort.active .fuel-sort-arrow{color:#ff9a3d;}.fuel-ledger-head.fuel-tx-grid>.fuel-ledger-sort{justify-content:flex-end;text-align:right;}.fuel-ledger-head.fuel-tx-grid>.fuel-ledger-sort.fuel-ledger-sort-left,.fuel-ledger-head.fuel-delivery-row-grid>.fuel-ledger-sort:first-child,.fuel-ledger-head.fuel-delivery-row-grid>.fuel-ledger-sort:nth-child(2){justify-content:flex-start;text-align:left;}.fuel-ledger-head.fuel-delivery-row-grid>.fuel-ledger-sort:nth-child(n+3){justify-content:flex-end;text-align:right;}"
  	      + ".fuel-ledger-body{display:flex;flex-direction:column;gap:6px;padding:7px;min-height:120px;box-sizing:border-box;}"
  	      + ".fuel-ledger-pagination{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:9px 8px 0 8px;min-height:40px;box-sizing:border-box;}"
  	      + ".fuel-page-status{flex:1;min-width:0;text-align:center;color:#aebdcc;font-size:11px;font-weight:800;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-page-btn{height:34px;min-width:82px;padding:0 12px;border:1px solid rgba(255,255,255,.11);border-radius:10px;background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,255,255,.035));color:#e2e8f0;font-size:11px;font-weight:850;cursor:pointer;}"
  	      + ".fuel-page-btn:hover:not(:disabled){border-color:rgba(204,102,51,.50);background:rgba(204,102,51,.12);color:#fff;}"
  	      + ".fuel-page-btn:disabled{opacity:.35;cursor:default;}"
  	      + ".fuel-tx-grid{display:grid;grid-template-columns:minmax(190px,1fr) 64px 72px 78px 78px 70px 70px 84px 84px 72px 72px 68px 68px 100px 110px;column-gap:6px;align-items:center;min-width:1364px;}"
  	      + ".fuel-ledger-row-grid{width:100%;padding:0;box-sizing:border-box;}"
  	      + ".fuel-ledger-primary{min-width:0;}"
  	      + ".fuel-ledger-primary-name{font-size:13px;font-weight:900;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-ledger-primary-meta{margin-top:3px;font-size:10px;color:#94a3b8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-ledger-primary-desc{margin-top:2px;font-size:10px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-ledger-cell{min-width:0;}"
  	      + ".fuel-ledger-cell strong{display:block;width:100%;font-size:11px;font-weight:850;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:right;font-variant-numeric:tabular-nums;}"
  	      + ".fuel-ledger-cell-date{text-align:left;}.fuel-ledger-cell-date strong{text-align:left;}.fuel-ledger-cell-efficiency,.fuel-ledger-cell-captured{min-width:0;white-space:nowrap;}.fuel-ledger-cell-efficiency strong{text-align:right;overflow:hidden;text-overflow:ellipsis;}.fuel-ledger-cell-captured strong{text-align:left;overflow:hidden;text-overflow:ellipsis;}.fuel-delivery-row-grid>.fuel-ledger-cell:nth-child(2) strong{text-align:left;}"
  	      + ".fuel-tx-item{width:100%;box-sizing:border-box;text-align:left;background:linear-gradient(145deg,rgba(255,255,255,.065),rgba(255,255,255,.025));border:1px solid rgba(255,255,255,.07)!important;border-radius:12px;padding:11px 10px;cursor:pointer;color:#fff;transition:all 140ms ease;}"
  	      + ".fuel-tx-item:hover{background:linear-gradient(145deg,rgba(255,255,255,.11),rgba(204,102,51,.07))!important;border-color:rgba(204,102,51,.42)!important;transform:translateY(-1px);box-shadow:0 9px 20px rgba(0,0,0,.18);}"
  	      + "@media(max-width:1100px){.fuel-ledger-layout{grid-template-columns:240px minmax(0,1fr);}}"
  	      + "@media(max-width:820px){.fuel-ledger-layout{grid-template-columns:1fr;overflow:auto;}.fuel-ledger-sidebar{overflow:visible;}.fuel-summary-stack{grid-template-columns:repeat(2,minmax(0,1fr));}.fuel-ledger-main{min-height:560px;}}"
  	      + "</style>"
  	
  	      + '<div style="padding:16px 16px 10px 16px;border-bottom:1px solid rgba(255,255,255,0.06);display:flex;justify-content:space-between;align-items:flex-start;gap:10px;">'
  	      + '<div style="min-width:0;">'
  	      + '<div style="font-size:16px;font-weight:700;line-height:1.1;">Fuel Capture</div>'
  	      + '<div style="margin-top:4px;font-size:11px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(subtitle) + "</div>"
  	      + "</div>"
  	      + '<button id="fuel-capture-close" type="button" class="fif-miniapp-close" aria-label="Close Fuel Capture">×</button>'
  	      + "</div>"
  	
  	      + '<div style="display:flex;gap:8px;padding:10px 14px 0 14px;">'
  	      + '<button id="fuel-tab-capture" type="button" class="fif-miniapp-tab">Capture</button>'
  	      + '<button id="fuel-tab-transactions" type="button" class="fif-miniapp-tab is-active">Transactions</button>'
  	      + "</div>"
  	
  	      + '<div style="position:relative;flex:1;min-height:0;">'
  	
  	      + '<div id="fuel-capture-panel" style="display:none;position:absolute;inset:0;padding:18px;overflow:auto;">'
  	      + '<div class="fuel-form-intro"><div class="fuel-form-intro-title">Dispense Fuel</div><div class="fuel-form-intro-copy">Capture the vehicle, driver, quantity and verified bowser meter reading.</div></div>'
  	      + '<div class="fuel-capture-form-grid" style="width:100%;max-width:none;box-sizing:border-box;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;">'
  	
  	      + '<div id="row-capture-type" style="grid-column:1 / span 2;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Capture Type</label>'
  	      + '<select id="fuel-capture-type" class="fuel-dark-select" style="width:100%;height:46px;border-radius:10px;border:1px solid #9c4822;padding:0 12px;font-size:14px;box-sizing:border-box;">'
  	      + captureTypeOptionsHtml
  	      + "</select>"
  	      + "</div>"
  	
  	      + '<div id="row-company-application" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Application</label>'
  	      + '<select id="fuel-company-application" class="fuel-dark-select fuel-soft-input">'
  	      + buildOptionsHtml(applicationOptions, "Select application", "")
  	      + "</select>"
  	      + "</div>"
  	
  	      + '<div id="row-company-application-other" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Application (Other)</label>'
  	      + '<input id="fuel-company-application-other" type="text" placeholder="Type application" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-company-registration" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Registration</label>'
  	      + '<select id="fuel-company-registration" class="fuel-dark-select fuel-soft-input">'
  	      + buildOptionsHtml(companyVehicleOptions, "Select Registration", "")
  	      + "</select>"
  	      + "</div>"
  	
  	      + '<div id="row-company-registration-other" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Registration (Other)</label>'
  	      + '<input id="fuel-company-registration-other" type="text" placeholder="Type registration" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-company-driver" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Driver</label>'
  	      + '<select id="fuel-company-driver" class="fuel-dark-select fuel-soft-input">'
  	      + buildOptionsHtml(driverOptions, "Select driver", "")
  	      + "</select>"
  	      + "</div>"
  	
  	      + '<div id="row-company-driver-other" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Driver (Other)</label>'
  	      + '<input id="fuel-company-driver-other" type="text" placeholder="Type driver" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-contractor-name" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Contractor</label>'
  	      + '<select id="fuel-contractor-name" class="fuel-dark-select fuel-soft-input">'
  	      + buildOptionsHtml(contractorOptions, "Select contractor", "")
  	      + "</select>"
  	      + "</div>"
  	
  	      + '<div id="row-contractor-name-other" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Contractor (Other)</label>'
  	      + '<input id="fuel-contractor-name-other" type="text" placeholder="Type contractor" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-contractor-application" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Application</label>'
  	      + '<select id="fuel-contractor-application" class="fuel-dark-select fuel-soft-input">'
  	      + buildOptionsHtml(applicationOptions, "Select application", "")
  	      + "</select>"
  	      + "</div>"
  	
  	      + '<div id="row-contractor-application-other" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Application (Other)</label>'
  	      + '<input id="fuel-contractor-application-other" type="text" placeholder="Type application" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-contractor-registration" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Registration</label>'
  	      + '<select id="fuel-contractor-registration" class="fuel-dark-select fuel-soft-input">'
  	      + '<option value="">Select Registration</option>'
  	      + "</select>"
  	      + "</div>"
  	
  	      + '<div id="row-contractor-registration-other" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Registration (Other)</label>'
  	      + '<input id="fuel-contractor-registration-other" type="text" placeholder="Type registration" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-contractor-driver" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Driver</label>'
  	      + '<input id="fuel-contractor-driver" type="text" placeholder="Type driver" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-mileage" style="display:none;">'
  	      + '<label id="label-mileage" style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Odometer / Hobbs Meter</label>'
  	      + '<input id="fuel-mileage" type="text" inputmode="decimal" placeholder="Odometer / Hobbs Meter" class="fuel-soft-input">'
  	      + '<div id="fuel-mileage-help" class="fuel-help-text"></div>'
  	      + '<div id="fuel-mileage-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-litres" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Litres</label>'
  	      + '<input id="fuel-litres" type="text" inputmode="decimal" placeholder="Litres" class="fuel-soft-input">'
  	      + '<div id="fuel-litres-help" class="fuel-help-text"></div>'
  	      + '<div id="fuel-litres-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-meter" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Meter</label>'
  	      + '<input id="fuel-meter" type="text" inputmode="decimal" placeholder="Meter" value="" class="fuel-soft-input">'
  	      + '<div id="fuel-meter-help" class="fuel-help-text"></div>'
  	      + '<div id="fuel-meter-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-intertank-target" style="display:none;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Destination Tank</label>'
  	      + '<select id="fuel-intertank-target" class="fuel-dark-select fuel-soft-input">'
  	      + buildOptionsHtml(buildIntertankOptions(tank), "Select destination tank", "")
  	      + "</select>"
  	      + '<div id="fuel-intertank-target-help" class="fuel-help-text"></div>'
  	      + '<div id="fuel-intertank-target-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-description" style="display:none;grid-column:1 / span 2;">'
  	      + '<label id="label-description" style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Description</label>'
  	      + '<input id="fuel-description" type="text" placeholder="Description" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-cost-preview" style="display:none;grid-column:1 / span 2;">'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:12px;padding:12px 14px;">'
  	      + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:8px;">Cost Preview</div>'
  	      + '<div style="display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px;">'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;">'
  	      + '<div style="font-size:10px;color:#94a3b8;">Tank Price Per Litre</div>'
  	      + '<div id="fuel-preview-cpl" style="margin-top:4px;font-size:16px;font-weight:700;color:#f8fafc;">R 0.00</div>'
  	      + "</div>"
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;">'
  	      + '<div style="font-size:10px;color:#94a3b8;">Transaction Cost</div>'
  	      + '<div id="fuel-preview-cost" style="margin-top:4px;font-size:16px;font-weight:700;color:#f8fafc;">R 0.00</div>'
  	      + "</div>"
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;">'
  	      + '<div style="font-size:10px;color:#94a3b8;">SARS Compliant</div>'
  	      + '<div id="fuel-preview-sars" style="margin-top:4px;font-size:16px;font-weight:700;color:#f8fafc;">No</div>'
  	      + "</div>"
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;">'
  	      + '<div style="font-size:10px;color:#94a3b8;">Potential Rebate</div>'
  	      + '<div id="fuel-preview-rebate" style="margin-top:4px;font-size:16px;font-weight:700;color:#f8fafc;">R 0.00</div>'
  	      + "</div>"
  	      + "</div>"
  	      + "</div>"
  	      + "</div>"
  	
  	      + "</div>"
  	
  	      + '<div class="fuel-capture-form-actions" style="width:100%;max-width:none;box-sizing:border-box;display:flex;gap:10px;margin-top:18px;">'
  	      + '<button id="fuel-save-btn" type="button" class="fif-miniapp-primary" style="display:none;flex:1;height:46px;border-radius:10px;font-size:15px;font-weight:700;cursor:pointer;">Save and New</button>'
  	      + '<button id="fuel-cancel-btn" type="button" style="width:140px;height:46px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.05);color:#e2e8f0;font-size:15px;font-weight:700;cursor:pointer;">Cancel</button>'
  	      + "</div>"
  	      + "</div>"
  	
  	      + '<div id="fuel-transactions-panel" style="display:block;position:absolute;inset:0;padding:14px;overflow:hidden;">'
  	      + '<div class="fuel-ledger-layout">'
  	
  	      + '<div class="fuel-ledger-sidebar">'
  	      + '<div class="fuel-ledger-selector">'
  	      + '<div style="font-size:11px;color:#94a3b8;margin-bottom:7px;font-weight:800;">View Selector</div>'
  	      + '<select id="fuel-view-selector" class="fuel-dark-select fuel-soft-input">'
  	      + '<option value="">Select view</option>'
  	      + "</select>"
  	      + "</div>"
  	
  	      + '<div class="fuel-summary-stack">'
  	      + '<div class="fuel-summary-card"><div class="label">Bowser</div><div id="fuel-summary-bowser" class="value">' + escapeHtml(bowserName) + "</div></div>"
  	      + '<div class="fuel-summary-card"><div class="label">Bowser Meter Start</div><div id="fuel-summary-meter-start" class="value">0.00</div></div>'
  	      + '<div class="fuel-summary-card"><div class="label">Bowser Meter End</div><div id="fuel-summary-meter-end" class="value">0.00</div></div>'
  	      + '<div class="fuel-summary-card"><div class="label">Transactions</div><div id="fuel-summary-count" class="value">0</div></div>'
  	      + '<div class="fuel-summary-card"><div class="label">Litres</div><div id="fuel-summary-litres" class="value">0.00</div></div>'
  	      + '<div class="fuel-summary-card"><div class="label">Cost</div><div id="fuel-summary-cost" class="value">R 0.00</div></div>'
  	      + '<div class="fuel-summary-card"><div class="label">Potential Rebate (Value)</div><div id="fuel-summary-rebate" class="value">R 0.00</div></div>'
  	      + '<div class="fuel-summary-card"><div class="label">Potential Rebate (Litres)</div><div id="fuel-summary-rebate-litres" class="value">0.00 L</div></div>'
  	      + "</div>"
  	      + "</div>"
  	
  	      + '<div class="fuel-ledger-main">'
  	      + '<div class="fuel-ledger-toolbar">'
  	      + '<input id="fuel-transactions-search" type="text" placeholder="Search transactions..." class="fuel-soft-input fuel-ledger-search">'
  	      + '<button id="fuel-search-clear" type="button" class="fuel-ledger-action">Clear</button>'
  	      + '<button id="fuel-print-btn" type="button" class="fuel-ledger-action fuel-ledger-action-primary">Print / PDF</button>'
  	      + "</div>"
  	
  	      + '<div class="fuel-ledger-table">'
  	      + '<div class="fuel-ledger-head fuel-tx-grid">'
  	      + '<button type="button" class="fuel-ledger-sort fuel-ledger-sort-left" data-tx-sort-key="name"><span>Name</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="litres"><span>Litres</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="cost"><span>Cost</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="rebateCost"><span>Rebate Value</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="rebateLitres"><span>Rebate Litres</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="bowserStart"><span>Bowser Start</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort active" data-tx-sort-key="bowserEnd" aria-sort="descending"><span>Bowser End</span><span class="fuel-sort-arrow">▼</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="odometer"><span>Odometer</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="hobbs"><span>Hobbs Meter</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="distance"><span>Distance</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="hours"><span>Hours</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="kmEfficiency"><span>Km/L</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-tx-sort-key="hourEfficiency"><span>L/H</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort fuel-ledger-sort-left" data-tx-sort-key="date"><span>Date</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort fuel-ledger-sort-left" data-tx-sort-key="capturedBy"><span>Captured By</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + "</div>"
  	
  	      + '<div id="fuel-transactions-list" class="fuel-ledger-body">'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	      + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No view selected</div>'
  	      + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Select ViewC or a historical view to see every transaction for that month.</div>'
  	      + "</div>"
  	      + "</div>"
  	      + "</div>"
  	      + '<div id="fuel-ledger-pagination" class="fuel-ledger-pagination">'
  	      + '<button id="fuel-page-prev" type="button" class="fuel-page-btn">Previous</button>'
  	      + '<div id="fuel-page-status" class="fuel-page-status">Page 1 of 1</div>'
  	      + '<button id="fuel-page-next" type="button" class="fuel-page-btn">Next</button>'
  	      + "</div>"
  	
  	      + '<div id="fuel-transaction-detail-backdrop" class="fuel-detail-backdrop">'
  	      + '  <div class="fuel-detail-card">'
  	      + '    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;padding:16px 16px 12px 16px;border-bottom:1px solid rgba(255,255,255,0.08);">'
  	      + '      <div>'
  	      + '        <div id="fuel-detail-title" style="font-size:16px;font-weight:700;color:#f8fafc;">Transaction Detail</div>'
  	      + '        <div id="fuel-detail-subtitle" style="margin-top:4px;font-size:11px;color:#94a3b8;"></div>'
  	      + "      </div>"
  	      + '<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;justify-content:flex-end;">'
  	      + '  <button id="fuel-detail-delete" type="button" class="fif-record-delete-icon-button" style="display:none;" title="Delete latest transaction" aria-label="Delete latest transaction">' + managerTrashIconSvg() + '</button>'
  	      + '  <button id="fuel-detail-add-description" type="button" class="fif-miniapp-primary" style="height:34px;padding:0 14px;border-radius:10px;font-size:12px;font-weight:800;cursor:pointer;white-space:nowrap;">Add Description</button>'
  	      + '  <button id="fuel-detail-print" type="button" class="fif-miniapp-primary" style="height:34px;padding:0 14px;border-radius:10px;font-size:12px;font-weight:800;cursor:pointer;">Print / PDF</button>'
  	      + '  <button id="fuel-detail-close" type="button" class="fif-miniapp-close" aria-label="Close transaction details">×</button>'
  	      + "</div>"
  	      + "    </div>"
  	      + '    <div id="fuel-detail-body" style="padding:14px 16px 18px 16px;"></div>'
  	      + "  </div>"
  	      + "</div>"
  	
  	      + "</div>"
  	      + "</div>"
  	      + "</div>"
  	      + "</div>";
  	
  	      overlay.appendChild(modal);
  	      document.body.appendChild(overlay);
  	      managerThemeSelects(overlay);
  	
  	      function el(id) {
  	        return document.getElementById(id);
  	      }
  	
  	      function setDisplay(id, visible) {
  	        var node = el(id);
  	        if (node) node.style.display = visible ? "block": "none";
  	      }
  	
  	      function valueOf(id) {
  	        var node = el(id);
  	        return node ? node.value: "";
  	      }
  	
  	      function setValue(id, value) {
  	        var node = el(id);
  	
  	        if (node) {
  	          node.value = value;
  	          managerRefreshThemedSelect(node);
  	        }
  	      }
  	
  	      function setText(id, value) {
  	        var node = el(id);
  	        if (node) node.textContent = value;
  	      }
  	
  	      function showError(id, message) {
  	        var node = el(id);
  	        if (!node) return;
  	        node.style.display = message ? "block": "none";
  	        node.textContent = message || "";
  	      }
  	
  	      function showHelp(id, message) {
  	        var node = el(id);
  	        if (!node) return;
  	        node.style.display = message ? "block": "none";
  	        node.textContent = message || "";
  	      }
  	
  	
  	      function clearValidationMessages() {
  	        showError("fuel-mileage-error", "");
  	        showError("fuel-litres-error", "");
  	        showError("fuel-meter-error", "");
  	        showError("fuel-intertank-target-error", "");
  	        showHelp("fuel-mileage-help", "");
  	        showHelp("fuel-litres-help", "");
  	        showHelp("fuel-meter-help", "");
  	        showHelp("fuel-intertank-target-help", "");
  	      }
  	
  	      function updateCostPreview() {
  	        var litres = toNumber(valueOf("fuel-litres"), 0);
  	        var activeVehicle = getActiveVehicle();
  	        var cpl = getTankCostPerLitre(tank);
  	        var cost = litres * cpl;
  	        var compliant = activeVehicle ? isVehicleSarsCompliant(activeVehicle): false;
  	        var vehicleSarsRate = activeVehicle
  	          ? Math.max(0, getVehicleSarsRebateRate(activeVehicle))
  	          : 0;
  	        var rebate = compliant && vehicleSarsRate > 0
  	          ? litres * vehicleSarsRate
  	          : 0;
  	
  	        setText("fuel-preview-cpl", formatCurrency(cpl));
  	        setText("fuel-preview-cost", formatCurrency(cost));
  	        setText("fuel-preview-sars", compliant ? "Yes": "No");
  	        setText("fuel-preview-rebate", formatCurrency(rebate));
  	
  	        var rateNode = el("fuel-preview-sars-rate");
  	        if (rateNode) {
  	          rateNode.textContent = formatCurrency(vehicleSarsRate) + " / L";
  	        }
  	      }
  	
  	      function closeModal() {
  	        managerCloseTypedDeleteSafety(false);
  	        var node = el("fuel-capture-overlay");
  	
  	        if (node) {
  	          managerDestroyThemedSelectsWithin(node);
  	          node.remove();
  	        }
  	      }
  	
  	      function closeTransactionDetail() {
  	        var backdrop = el("fuel-transaction-detail-backdrop");
  	        if (backdrop) backdrop.style.display = "none";
  	        state.selectedTransaction = null;
  	      }
  	
  	      function patchTransactionDescription(rows, objectId, description) {
  	        var list = toArray(rows);
  	
  	        for (var index = 0; index < list.length; index++) {
  	          if (
  	            String(getDeep(list[index], ["objectId"], "")) ===
  	            String(objectId || "")
  	          ) {
  	            list[index].Description = description;
  	          }
  	        }
  	      }
  	
  	      function getDescriptionAppendUser() {
  	        return firstDefined(
  	          currentUser,
  	          getDeep(appData, ["User"], null),
  	          getDeep(appData, ["CurrentUser"], null),
  	          getDeep(appData, ["Current_User"], null)
  	        );
  	      }
  	
  	      async function appendFuelTransactionDescription(item, addition) {
  	        if (!item) {
  	          throw new Error("No fuel transaction is selected.");
  	        }
  	
  	        var objectId = text(
  	          getDeep(item, ["objectId"], ""),
  	          ""
  	        ).trim();
  	
  	        if (!objectId) {
  	          throw new Error(
  	            "This transaction has no Backendless objectId, so its description cannot be updated safely."
  	          );
  	        }
  	
  	        var addedText = text(addition, "").trim();
  	
  	        if (!addedText) {
  	          throw new Error("Enter the description text you want to add.");
  	        }
  	
  	        // Always reload first so another user's append cannot be overwritten.
  	        var freshTransaction = await loadTableRow(
  	          "FuelOut",
  	          objectId,
  	          []
  	        );
  	
  	        if (!freshTransaction) {
  	          throw new Error("The latest FuelOut record could not be loaded.");
  	        }
  	
  	        var existingDescription = text(
  	          getDeep(freshTransaction, ["Description"], ""),
  	          ""
  	        ).trim();
  	
  	        var appendUser = getDescriptionAppendUser();
  	        var appendUserName = getCaptureUserName(appendUser);
  	        var appendUserEmail = getCaptureUserEmail(appendUser);
  	        var appendAuthor = appendUserName || appendUserEmail || "User";
  	        var appendTime = formatDatePretty(getNowIso());
  	
  	        var appendedEntry =
  	          "[" +
  	          appendTime +
  	          " · " +
  	          appendAuthor +
  	          "] " +
  	          addedText;
  	
  	        var combinedDescription = existingDescription
  	          ? existingDescription + "\n" + appendedEntry
  	          : appendedEntry;
  	
  	        // Narrow patch only. No other FuelOut field becomes editable.
  	        var saved = await saveTableRow("FuelOut", {
  	          objectId: objectId,
  	          Description: combinedDescription
  	        });
  	
  	        var finalDescription = text(
  	          getDeep(saved, ["Description"], combinedDescription),
  	          combinedDescription
  	        );
  	
  	        item.Description = finalDescription;
  	
  	        patchTransactionDescription(
  	          state.transactionCache,
  	          objectId,
  	          finalDescription
  	        );
  	        patchTransactionDescription(
  	          state.filteredTransactions,
  	          objectId,
  	          finalDescription
  	        );
  	
  	        if (state.selectedHydratedView) {
  	          patchTransactionDescription(
  	            getDeep(state.selectedHydratedView, ["FuelOut"], []),
  	            objectId,
  	            finalDescription
  	          );
  	        }
  	
  	        if (
  	          state.selectedTransaction &&
  	          String(getDeep(state.selectedTransaction, ["objectId"], "")) ===
  	            String(objectId)
  	        ) {
  	          state.selectedTransaction.Description = finalDescription;
  	        }
  	
  	        return finalDescription;
  	      }
  	
  	      function openTransactionDetail(item) {
  	        state.selectedTransaction = item || null;
  	
  	        var backdrop = el("fuel-transaction-detail-backdrop");
  	        var title = el("fuel-detail-title");
  	        var subtitleNode = el("fuel-detail-subtitle");
  	        var body = el("fuel-detail-body");
  	
  	        if (!backdrop || !body || !item) return;
  	
  	        var tractorHeading = getTransactionTractorHeading(item);
  	        var registration = getTransactionRegistration(item);
  	        var formattedDate = formatDatePretty(getDeep(item, ["FuelDate"], ""));
  	
  	        if (title) title.textContent = tractorHeading;
  	        if (subtitleNode) subtitleNode.textContent = formattedDate;
  	
  	        var driver = getTransactionDriver(item);
  	        var capturedBy = getTransactionCapturedBy(item);
  	        var efficiencyText = getTransactionEfficiencyText(item);
  	        var readingDelta = getTransactionReadingDelta(item);
  	        var readingUnit = getTransactionReadingUnit(item);
  	        var unitCost = getTransactionUnitCost(item);
  	        var sarsRebate = getTransactionSarsRebate(item);
  	        var sarsRebateLitres = getTransactionRebateLitres(item);
  	        var sarsCompliance = firstDefined(getDeep(item, ["SARSCompliance"], null), false) ? "Yes": "No";
  	        var rollbackStatus = isTransactionReversed(item) ? "Reversed": "Active";
  	
  	        body.innerHTML = ""
  	        + '<div style="display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;">'
  	        + '<div style="background:rgba(255,255,255,0.04);border-radius:12px;padding:12px 14px;">'
  	        + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:6px;">Capture</div>'
  	        + buildDetailRow("Fuel Date", formattedDate)
  	        + buildDetailRow("Tractor", tractorHeading)
  	        + buildDetailRow("Capture Type", getDeep(item, ["CaptureType"], ""))
  	        + buildDetailRow("Application", getDeep(item, ["Application"], ""))
  	        + buildDetailRow("Registration", registration)
  	        + buildDetailRow("Driver", driver)
  	        + buildDetailRow("Captured By", capturedBy)
  	        + buildDetailRow("Contractor Name", getDeep(item, ["ContractorName"], ""))
  	        + buildDetailRow("Description", getDeep(item, ["Description"], ""))
  	        + buildDetailRow("Status", rollbackStatus)
  	        + "</div>"
  	
  	        + '<div style="background:rgba(255,255,255,0.04);border-radius:12px;padding:12px 14px;">'
  	        + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:6px;">Figures</div>'
  	        + buildDetailRow("Litres", displayNumber(getDeep(item, ["Litres"], 0), 2))
  	        + buildDetailRow("Cost Per Litre", formatCurrency(unitCost))
  	        + buildDetailRow("Cost", formatCurrency(getDeep(item, ["Cost"], 0)))
  	        + buildDetailRow("SARS Compliant", sarsCompliance)
  	        + buildDetailRow("Vehicle SARS Rate", formatCurrency(getTransactionVehicleSarsRate(item)) + " / L")
  	        + buildDetailRow("Potential Rebate (Value)", formatCurrency(sarsRebate))
  	        + buildDetailRow("Potential Rebate (Litres)", displayNumber(sarsRebateLitres, 2) + " L")
  	        + buildDetailRow(getTransactionEfficiencyLabel(item), efficiencyText)
  	        + buildDetailRow(getTransactionReadingLabels(item).previous, formatTransactionReading(item, getDeep(item, ["MileageLast"], "")))
  	        + buildDetailRow(getTransactionReadingLabels(item).current, formatTransactionReading(item, getDeep(item, ["Mileage"], "")))
  	        + buildDetailRow(getTransactionReadingLabels(item).delta, formatTransactionReading(item, readingDelta))
  	        + buildDetailRow("Bowser Meter Start", displayNumber(getDeep(item, ["MeterLast"], 0), 2))
  	        + buildDetailRow("Bowser Meter End", displayNumber(getDeep(item, ["Meter"], 0), 2))
  	        + buildDetailRow("Tolerance", displayNumber(getDeep(item, ["Tolerance"], 0), 2))
  	        + "</div>"
  	        + "</div>"
  	        + '<div id="fuel-description-append-panel" style="display:none;margin-top:14px;padding:14px;border:1px solid rgba(232,115,57,0.34);border-radius:14px;background:linear-gradient(145deg,rgba(123,52,22,0.13),rgba(255,255,255,0.025));">'
  	        + '  <div style="font-size:13px;font-weight:850;color:#f8fafc;">Add to Description</div>'
  	        + '  <div style="margin-top:4px;font-size:10px;line-height:1.45;color:#94a3b8;">The existing description is locked. Your text will be appended to it with your name and the current date/time.</div>'
  	        + '  <textarea id="fuel-description-append-input" maxlength="1500" placeholder="Enter additional description..." style="width:100%;min-height:88px;margin-top:11px;padding:11px 12px;box-sizing:border-box;resize:vertical;border:1px solid rgba(255,122,36,0.54);border-radius:12px;outline:none;color:#fff;background:rgba(3,7,9,0.78);font:700 12px Inter,system-ui,-apple-system,BlinkMacSystemFont,&quot;Segoe UI&quot;,Arial,sans-serif;line-height:1.45;"></textarea>'
  	        + '  <div id="fuel-description-append-error" style="display:none;margin-top:6px;color:#ff8c7c;font-size:10px;font-weight:750;"></div>'
  	        + '  <div style="display:flex;justify-content:flex-end;gap:9px;margin-top:10px;">'
  	        + '    <button id="fuel-description-append-cancel" type="button" style="height:34px;padding:0 13px;border:1px solid rgba(255,255,255,0.11);border-radius:10px;cursor:pointer;color:#e5e7eb;background:rgba(255,255,255,0.045);font-size:11px;font-weight:800;">Cancel</button>'
  	        + '    <button id="fuel-description-append-save" type="button" class="fif-miniapp-primary" style="height:34px;padding:0 14px;border-radius:10px;font-size:11px;font-weight:850;cursor:pointer;">Append</button>'
  	        + "  </div>"
  	        + "</div>";
  	
  	        var addDescriptionButton = backdrop.querySelector(
  	          "#fuel-detail-add-description"
  	        );
  	        var appendPanel = body.querySelector(
  	          "#fuel-description-append-panel"
  	        );
  	        var appendInput = body.querySelector(
  	          "#fuel-description-append-input"
  	        );
  	        var appendError = body.querySelector(
  	          "#fuel-description-append-error"
  	        );
  	        var appendSaveButton = body.querySelector(
  	          "#fuel-description-append-save"
  	        );
  	        var appendCancelButton = body.querySelector(
  	          "#fuel-description-append-cancel"
  	        );
  	
  	        function hideDescriptionAppendPanel() {
  	          if (appendPanel) appendPanel.style.display = "none";
  	          if (appendInput) appendInput.value = "";
  	          if (appendError) {
  	            appendError.textContent = "";
  	            appendError.style.display = "none";
  	          }
  	        }
  	
  	        if (addDescriptionButton) {
  	          addDescriptionButton.onclick = function () {
  	            if (!appendPanel) return;
  	
  	            appendPanel.style.display =
  	              appendPanel.style.display === "none"
  	                ? "block"
  	                : "none";
  	
  	            if (
  	              appendPanel.style.display === "block" &&
  	              appendInput
  	            ) {
  	              window.setTimeout(function () {
  	                appendInput.focus();
  	              }, 30);
  	            }
  	          };
  	        }
  	
  	        if (appendCancelButton) {
  	          appendCancelButton.onclick = hideDescriptionAppendPanel;
  	        }
  	
  	        if (appendSaveButton) {
  	          appendSaveButton.onclick = async function () {
  	            var addition = appendInput
  	              ? text(appendInput.value, "").trim()
  	              : "";
  	
  	            if (!addition) {
  	              if (appendError) {
  	                appendError.textContent =
  	                  "Enter the description text you want to add.";
  	                appendError.style.display = "block";
  	              }
  	              if (appendInput) appendInput.focus();
  	              return;
  	            }
  	
  	            if (appendError) {
  	              appendError.textContent = "";
  	              appendError.style.display = "none";
  	            }
  	
  	            managerBeginLoading(
  	              "Adding to transaction description…"
  	            );
  	
  	            try {
  	              setButtonBusy(
  	                appendSaveButton,
  	                true,
  	                "Appending…"
  	              );
  	
  	              await appendFuelTransactionDescription(
  	                item,
  	                addition
  	              );
  	
  	              // Description participates in transaction search.
  	              applyTransactionSearch({
  	                resetPage: false
  	              });
  	
  	              managerCompleteLoading(
  	                "Description addition saved. The original description was preserved."
  	              );
  	
  	              openTransactionDetail(item);
  	            } catch (error) {
  	              managerFailLoading(
  	                error && error.message
  	                  ? error.message
  	                  : "The description could not be updated."
  	              );
  	            } finally {
  	              setButtonBusy(
  	                appendSaveButton,
  	                false,
  	                "Append"
  	              );
  	            }
  	          };
  	        }
  	
  	        var deleteButton = backdrop.querySelector(
  	          "#fuel-detail-delete"
  	        );
  	
  	        if (deleteButton) {
  	          var eligibility = getFuelTransactionDeleteEligibility(item);
  	          deleteButton.style.display = eligibility.ok
  	            ? "inline-grid"
  	            : "none";
  	          deleteButton.title = eligibility.ok
  	            ? "Delete latest transaction"
  	            : eligibility.message;
  	
  	          deleteButton.onclick = async function () {
  	            var currentEligibility =
  	              getFuelTransactionDeleteEligibility(item);
  	
  	            if (!currentEligibility.ok) {
  	              managerBeginLoading(
  	                "Checking deletion rules…"
  	              );
  	              managerFailLoading(
  	                currentEligibility.message
  	              );
  	              return;
  	            }
  	
  	            var confirmed = await managerOpenTypedDeleteSafety({
  	              title: "Delete Fuel Transaction",
  	              subtitle: "Permanent Rollback",
  	              name:
  	                getTransactionRegistration(item) +
  	                " | Meter " +
  	                displayNumber(getDeep(item, ["Meter"], 0), 2),
  	              copy:
  	                "This permanently deletes the latest FuelOut record and reverses every value written by it.",
  	              warning:
  	                "Tank volume, Bowser meter, monthly views, vehicle mileage, fitted tyre mileage, fuel counters and intertank stock will be restored before deletion.",
  	              confirmLabel: "Delete"
  	            });
  	
  	            if (!confirmed) return;
  	
  	            managerBeginLoading(
  	              "Deleting fuel transaction…"
  	            );
  	
  	            try {
  	              setButtonBusy(deleteButton, true, "");
  	              await deleteLatestFuelTransaction(item);
  	              closeTransactionDetail();
  	              refreshViewSelector();
  	              await renderTransactionsForSelectedView();
  	
  	              managerCompleteLoading(
  	                "Fuel transaction deleted and all linked values were rolled back successfully."
  	              );
  	            } catch (error) {
  	              managerFailLoading(
  	                error && error.message
  	                  ? error.message
  	                  : "The fuel transaction could not be deleted."
  	              );
  	            } finally {
  	              setButtonBusy(deleteButton, false, "");
  	              deleteButton.innerHTML = managerTrashIconSvg();
  	            }
  	          };
  	        }
  	
  	        backdrop.style.display = "flex";
  	      }
  	
  	      var captureBtn = el("fuel-tab-capture");
  	      var transactionsBtn = el("fuel-tab-transactions");
  	      var capturePanel = el("fuel-capture-panel");
  	      var transactionsPanel = el("fuel-transactions-panel");
  	      var saveBtn = el("fuel-save-btn");
  	
  	      function showCapture() {
  	        capturePanel.style.display = "block";
  	        transactionsPanel.style.display = "none";
  	        captureBtn.classList.add("is-active");
  	        transactionsBtn.classList.remove("is-active");
  	      }
  	
  	      function showTransactions() {
  	        capturePanel.style.display = "none";
  	        transactionsPanel.style.display = "block";
  	        transactionsBtn.classList.add("is-active");
  	        captureBtn.classList.remove("is-active");
  	      }
  	
  	      function getSelectedCompanyVehicle() {
  	        var selected = valueOf("fuel-company-registration");
  	        if (!selected || selected === "OTHER") return null;
  	
  	        for (var i = 0; i < companyVehicleOptions.length; i++) {
  	          if (String(companyVehicleOptions[i].value) === String(selected)) {
  	            var selectedVehicle =
  	              companyVehicleOptions[i].raw || null;
  	
  	            return vehicleMatchesTankGrade(
  	              selectedVehicle,
  	              tankGrade
  	            )
  	              ? selectedVehicle
  	              : null;
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function getSelectedContractorObject() {
  	        var selected = valueOf("fuel-contractor-name");
  	        if (!selected || selected === "OTHER") return null;
  	
  	        for (var i = 0; i < contractorOptions.length; i++) {
  	          if (String(contractorOptions[i].value) === String(selected)) {
  	            return contractorOptions[i].raw || null;
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function getSelectedContractorVehicle() {
  	        var contractorObj = getSelectedContractorObject();
  	        var selected = valueOf("fuel-contractor-registration");
  	
  	        if (!contractorObj || !selected || selected === "OTHER") return null;
  	
  	        var vehicles = filterVehiclesForTankGrade(
  	          getDeep(contractorObj, ["Tractors"], []),
  	          tankGrade
  	        );
  	
  	        for (var i = 0; i < vehicles.length; i++) {
  	          if (String(pickVehicleValue(vehicles[i], "CONTRACTOR_VEHICLE", i)) === String(selected)) {
  	            return vehicleMatchesTankGrade(
  	              vehicles[i],
  	              tankGrade
  	            )
  	              ? vehicles[i]
  	              : null;
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function getSelectedDriverOption() {
  	        var selected = valueOf("fuel-company-driver");
  	        if (!selected || selected === "OTHER") return null;
  	
  	        for (var i = 0; i < driverOptions.length; i++) {
  	          if (String(driverOptions[i].value) === String(selected)) {
  	            return driverOptions[i].raw || null;
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function getActiveVehicle() {
  	        var mode = valueOf("fuel-capture-type");
  	        if (mode === "company") return getSelectedCompanyVehicle();
  	        if (mode === "contractor") return getSelectedContractorVehicle();
  	        return null;
  	      }
  	
  	      function getVehicleOldReading(vehicle) {
  	        return managerVehicleCurrentReading(vehicle);
  	      }
  	
  	      function getVehicleRange(vehicle) {
  	        return managerVehicleRangeValue(vehicle);
  	      }
  	
  	      function getVehicleTankCapacity(vehicle) {
  	        return toNumber(getDeep(vehicle, ["CAN", "Tank"], 0), 0);
  	      }
  	
  	      function rebuildContractorRegistrations() {
  	        var contractorObj = getSelectedContractorObject();
  	        var regSelect = el("fuel-contractor-registration");
  	        if (!regSelect) return;
  	
  	        var contractorVehicles = contractorObj
  	          ? filterVehiclesForTankGrade(
  	              getDeep(contractorObj, ["Tractors"], []),
  	              tankGrade
  	            )
  	          : [];
  	
  	        var options = optionWithOtherFirst(
  	          buildVehicleOptions(
  	            contractorVehicles,
  	            "CONTRACTOR_VEHICLE"
  	          ),
  	          "Other"
  	        );
  	
  	        regSelect.innerHTML = buildOptionsHtml(options, "Select Registration", "");
  	      }
  	
  	      function applyNumericSanitizer(id) {
  	        var node = el(id);
  	        if (!node) return;
  	
  	        node.addEventListener("input", function () {
  	          node.value = sanitizeNumeric(node.value);
  	          refreshCaptureVisibility();
  	        });
  	      }
  	
  	      function clearCaptureValues() {
  	        var ids = [
  	          "fuel-company-application",
  	          "fuel-company-application-other",
  	          "fuel-company-registration",
  	          "fuel-company-registration-other",
  	          "fuel-company-driver",
  	          "fuel-company-driver-other",
  	          "fuel-contractor-name",
  	          "fuel-contractor-name-other",
  	          "fuel-contractor-application",
  	          "fuel-contractor-application-other",
  	          "fuel-contractor-registration",
  	          "fuel-contractor-registration-other",
  	          "fuel-contractor-driver",
  	          "fuel-mileage",
  	          "fuel-litres",
  	          "fuel-meter",
  	          "fuel-description"
  	        ];
  	
  	        for (var i = 0; i < ids.length; i++) {
  	          setValue(ids[i], "");
  	        }
  	
  	        rebuildContractorRegistrations();
  	        clearValidationMessages();
  	        updateCostPreview();
  	      }
  	
  	      function validateReading() {
  	        var mode = valueOf("fuel-capture-type");
  	        if (mode === "other") {
  	          showHelp("fuel-mileage-help", "");
  	          showError("fuel-mileage-error", "");
  	          return {
  	            ok: true
  	          };
  	        }
  	
  	        var vehicle = getActiveVehicle();
  	        var entered = toNumber(valueOf("fuel-mileage"), NaN);
  	
  	        if (!vehicle || isNaN(entered)) {
  	          showHelp("fuel-mileage-help", "");
  	          showError("fuel-mileage-error", "");
  	          return {
  	            ok: false
  	          };
  	        }
  	
  	        var oldReading = getVehicleOldReading(vehicle);
  	        var range = getVehicleRange(vehicle);
  	        var maxReading = oldReading + range;
  	
  	        showHelp("fuel-mileage-help", "Allowed range: " + oldReading + " to " + maxReading);
  	
  	        if (entered < oldReading) {
  	          showError("fuel-mileage-error", "Reading cannot be lower than " + oldReading);
  	          return {
  	            ok: false,
  	            oldReading: oldReading,
  	            maxReading: maxReading
  	          };
  	        }
  	
  	        if (entered > maxReading) {
  	          showError("fuel-mileage-error", "Reading cannot be higher than " + maxReading);
  	          return {
  	            ok: false,
  	            oldReading: oldReading,
  	            maxReading: maxReading
  	          };
  	        }
  	
  	        showError("fuel-mileage-error", "");
  	        return {
  	          ok: true,
  	          oldReading: oldReading,
  	          maxReading: maxReading
  	        };
  	      }
  	
  	      function validateLitres() {
  	        var mode = valueOf("fuel-capture-type");
  	        var litres = toNumber(valueOf("fuel-litres"), NaN);
  	
  	        if (isNaN(litres)) {
  	          showHelp("fuel-litres-help", "");
  	          showError("fuel-litres-error", "");
  	          return {
  	            ok: false
  	          };
  	        }
  	
  	        if (litres <= 0) {
  	          showError("fuel-litres-error", "Litres must be greater than 0");
  	          return {
  	            ok: false
  	          };
  	        }
  	
  	        if (mode === "company" || mode === "contractor") {
  	          var vehicle = getActiveVehicle();
  	
  	          if (!vehicle) {
  	            showHelp("fuel-litres-help", "");
  	            showError("fuel-litres-error", "");
  	            return {
  	              ok: false
  	            };
  	          }
  	
  	          var capacity = getVehicleTankCapacity(vehicle);
  	          showHelp("fuel-litres-help", "Vehicle tank capacity: " + capacity + " L");
  	
  	          if (capacity > 0 && litres > capacity) {
  	            showError("fuel-litres-error", "Litres cannot exceed tank capacity of " + capacity + " L");
  	            return {
  	              ok: false,
  	              capacity: capacity
  	            };
  	          }
  	        } else {
  	          showHelp("fuel-litres-help", "");
  	        }
  	
  	        showError("fuel-litres-error", "");
  	        return {
  	          ok: true
  	        };
  	      }
  	
  	      function validateMeter() {
  	        var litres = toNumber(valueOf("fuel-litres"), NaN);
  	        var enteredMeter = toNumber(valueOf("fuel-meter"), NaN);
  	        var tolerance = 0.5;
  	
  	        if (isNaN(litres) || isNaN(enteredMeter)) {
  	          showHelp("fuel-meter-help", "");
  	          showError("fuel-meter-error", "");
  	          return {
  	            ok: false
  	          };
  	        }
  	
  	        var liveBowserMeter = toNumber(getDeep(bowser, ["Meter"], 0), 0);
  	        var expected = liveBowserMeter + litres;
  	        var minAllowed = expected - tolerance;
  	        var maxAllowed = expected + tolerance;
  	
  	        showHelp("fuel-meter-help", "Expected meter: " + displayNumber(expected, 2) + " (tolerance +/-" + displayNumber(tolerance, 2) + ")");
  	
  	        if (enteredMeter < liveBowserMeter) {
  	          showError("fuel-meter-error", "Meter cannot be lower than current meter of " + displayNumber(liveBowserMeter, 2));
  	          return {
  	            ok: false,
  	            expected: expected
  	          };
  	        }
  	
  	        if (enteredMeter < minAllowed || enteredMeter > maxAllowed) {
  	          showError("fuel-meter-error", "Meter must be between " + displayNumber(minAllowed, 2) + " and " + displayNumber(maxAllowed, 2));
  	          return {
  	            ok: false,
  	            expected: expected
  	          };
  	        }
  	
  	        showError("fuel-meter-error", "");
  	        return {
  	          ok: true,
  	          expected: expected
  	        };
  	      }
  	
  	      function isComplete() {
  	        var mode = valueOf("fuel-capture-type");
  	
  	        if (!mode) return false;
  	
  	        if (
  	          isParaffinTankGrade(tankGrade) &&
  	          mode !== "other"
  	        ) {
  	          return false;
  	        }
  	
  	        if (mode === "company") {
  	          if (!valueOf("fuel-company-application")) return false;
  	          if (valueOf("fuel-company-application") === "OTHER" && !valueOf("fuel-company-application-other")) return false;
  	
  	          if (!valueOf("fuel-company-registration")) return false;
  	          if (valueOf("fuel-company-registration") === "OTHER" && !valueOf("fuel-company-registration-other")) return false;
  	
  	          if (!valueOf("fuel-company-driver")) return false;
  	          if (valueOf("fuel-company-driver") === "OTHER" && !valueOf("fuel-company-driver-other")) return false;
  	
  	          if (!validateReading().ok) return false;
  	          if (!validateLitres().ok) return false;
  	          if (!validateMeter().ok) return false;
  	
  	          return true;
  	        }
  	
  	        if (mode === "contractor") {
  	          if (!valueOf("fuel-contractor-name")) return false;
  	          if (valueOf("fuel-contractor-name") === "OTHER" && !valueOf("fuel-contractor-name-other")) return false;
  	
  	          if (!valueOf("fuel-contractor-application")) return false;
  	          if (valueOf("fuel-contractor-application") === "OTHER" && !valueOf("fuel-contractor-application-other")) return false;
  	
  	          if (!valueOf("fuel-contractor-registration")) return false;
  	          if (valueOf("fuel-contractor-registration") === "OTHER" && !valueOf("fuel-contractor-registration-other")) return false;
  	
  	          if (!valueOf("fuel-contractor-driver")) return false;
  	
  	          if (!validateReading().ok) return false;
  	          if (!validateLitres().ok) return false;
  	          if (!validateMeter().ok) return false;
  	
  	          return true;
  	        }
  	
  	        if (mode === "intertank") {
  	          if (!validateIntertankTarget().ok) return false;
  	          if (!validateLitres().ok) return false;
  	          if (!validateMeter().ok) return false;
  	          return true;
  	        }
  	
  	        if (mode === "other") {
  	          if (!validateLitres().ok) return false;
  	          if (!validateMeter().ok) return false;
  	          return true;
  	        }
  	
  	        return false;
  	      }
  	      function updateSaveVisibility() {
  	        if (!saveBtn) return;
  	        saveBtn.style.display = isComplete() ? "block": "none";
  	      }
  	
  	      function refreshCaptureVisibility() {
  	        var mode = valueOf("fuel-capture-type");
  	
  	        refreshVehicleReadingLabel();
  	
  	        var companyApplication = valueOf("fuel-company-application");
  	        var companyRegistration = valueOf("fuel-company-registration");
  	        var companyDriver = valueOf("fuel-company-driver");
  	
  	        var contractorName = valueOf("fuel-contractor-name");
  	        var contractorApplication = valueOf("fuel-contractor-application");
  	        var contractorRegistration = valueOf("fuel-contractor-registration");
  	
  	        var descriptionLabel = el("label-description");
  	
  	        if (descriptionLabel) descriptionLabel.textContent = "Description";
  	
  	        setDisplay("row-company-application", false);
  	        setDisplay("row-company-application-other", false);
  	        setDisplay("row-company-registration", false);
  	        setDisplay("row-company-registration-other", false);
  	        setDisplay("row-company-driver", false);
  	        setDisplay("row-company-driver-other", false);
  	
  	        setDisplay("row-contractor-name", false);
  	        setDisplay("row-contractor-name-other", false);
  	        setDisplay("row-contractor-application", false);
  	        setDisplay("row-contractor-application-other", false);
  	        setDisplay("row-contractor-registration", false);
  	        setDisplay("row-intertank-target", false);
  	        setDisplay("row-contractor-registration-other", false);
  	        setDisplay("row-contractor-driver", false);
  	
  	        setDisplay("row-mileage", false);
  	        setDisplay("row-litres", false);
  	        setDisplay("row-meter", false);
  	        setDisplay("row-description", false);
  	        setDisplay("row-cost-preview", false);
  	
  	        clearValidationMessages();
  	
  	        if (!mode) {
  	          updateCostPreview();
  	          updateSaveVisibility();
  	          return;
  	        }
  	
  	        if (mode === "company") {
  	          setDisplay("row-company-application", true);
  	
  	          if (companyApplication) {
  	            if (companyApplication === "OTHER") setDisplay("row-company-application-other", true);
  	            if (companyApplication !== "OTHER" || valueOf("fuel-company-application-other")) {
  	              setDisplay("row-company-registration", true);
  	            }
  	          }
  	
  	          if (companyRegistration) {
  	            if (companyRegistration === "OTHER") setDisplay("row-company-registration-other", true);
  	            if (companyRegistration !== "OTHER" || valueOf("fuel-company-registration-other")) {
  	              setDisplay("row-company-driver", true);
  	            }
  	          }
  	
  	          if (companyDriver) {
  	            if (companyDriver === "OTHER") setDisplay("row-company-driver-other", true);
  	            if (companyDriver !== "OTHER" || valueOf("fuel-company-driver-other")) {
  	              setDisplay("row-mileage", true);
  	            }
  	          }
  	
  	          if (valueOf("fuel-mileage") && validateReading().ok) setDisplay("row-litres", true);
  	          if (valueOf("fuel-litres") && validateLitres().ok) setDisplay("row-meter", true);
  	          if (valueOf("fuel-meter") && validateMeter().ok) {
  	            setDisplay("row-description", true);
  	            setDisplay("row-cost-preview", true);
  	          }
  	
  	          if (descriptionLabel) descriptionLabel.textContent = "Client / Description";
  	        }
  	
  	        if (mode === "contractor") {
  	          setDisplay("row-contractor-name", true);
  	          setDisplay("row-contractor-application", true);
  	          setDisplay("row-contractor-registration", true);
  	          setDisplay("row-contractor-driver", true);
  	          setDisplay("row-mileage", true);
  	          setDisplay("row-litres", true);
  	          setDisplay("row-meter", true);
  	          setDisplay("row-description", true);
  	
  	          if (contractorName === "OTHER") {
  	            setDisplay("row-contractor-name-other", true);
  	          }
  	
  	          if (contractorApplication === "OTHER") {
  	            setDisplay("row-contractor-application-other", true);
  	          }
  	
  	          if (contractorRegistration === "OTHER") {
  	            setDisplay("row-contractor-registration-other", true);
  	          }
  	
  	          if (isComplete() || valueOf("fuel-description")) {
  	            setDisplay("row-cost-preview", true);
  	          }
  	        }
  	
  	        if (mode === "intertank") {
  	          setDisplay("row-litres", true);
  	          setDisplay("row-meter", true);
  	          setDisplay("row-intertank-target", true);
  	          setDisplay("row-description", true);
  	
  	          var intertankOptions = buildIntertankOptions(tank);
  	          var intertankNode = el("fuel-intertank-target");
  	
  	          if (intertankNode) {
  	            intertankNode.innerHTML = buildOptionsHtml(
  	              intertankOptions,
  	              "Select destination tank",
  	              valueOf("fuel-intertank-target")
  	            );
  	          }
  	
  	          if (!intertankOptions.length) {
  	            showError(
  	              "fuel-intertank-target-error",
  	              "No same-grade destination tanks are available for this tank."
  	            );
  	          } else {
  	            validateIntertankTarget();
  	          }
  	
  	          if (isComplete() || valueOf("fuel-description")) {
  	            setDisplay("row-cost-preview", true);
  	          }
  	        }
  	
  	        if (mode === "other") {
  	          setDisplay("row-litres", true);
  	          setDisplay("row-meter", true);
  	          setDisplay("row-description", true);
  	
  	          if (isComplete() || valueOf("fuel-description")) {
  	            setDisplay("row-cost-preview", true);
  	          }
  	        }
  	
  	        updateCostPreview();
  	        updateSaveVisibility();
  	      }
  	
  	      function bindChangeRefresh(id, extraFn) {
  	        var node = el(id);
  	        if (!node) return;
  	
  	        node.addEventListener("change", function () {
  	          if (typeof extraFn === "function") extraFn();
  	          refreshCaptureVisibility();
  	        });
  	
  	        node.addEventListener("input",
  	          function () {
  	            refreshCaptureVisibility();
  	          });
  	      }
  	
  	      function buildViewOptionsHtmlFromBowser(sourceBowser) {
  	        var html = '<option value="">Select view</option>';
  	        var currentView = getDeep(sourceBowser,
  	          ["ViewC"],
  	          null);
  	        var historyViews = toArray(getDeep(sourceBowser, ["ViewH"], []));
  	
  	        if (currentView && getDeep(currentView, ["objectId"], null)) {
  	          html += '<option value="VIEWC::' + escapeHtml(text(currentView.objectId, "")) + '">Current | ' + escapeHtml(text(getDeep(currentView, ["MYear"], "Current"), "Current")) + "</option>";
  	        } else if (currentView && getDeep(currentView, ["MYear"], "")) {
  	          html += '<option value="VIEWC">Current | ' + escapeHtml(text(getDeep(currentView, ["MYear"], "Current"), "Current")) + "</option>";
  	        }
  	
  	        for (var i = 0; i < historyViews.length; i++) {
  	          var hv = historyViews[i];
  	          var hvId = text(getDeep(hv, ["objectId"], ""), "");
  	          var hvValue = hvId ? ("VIEWH::" + hvId): ("VIEWHIDX::" + i);
  	          html += '<option value="' + escapeHtml(hvValue) + '">History | ' + escapeHtml(text(getDeep(hv, ["MYear"], "History " + (i + 1)), "History " + (i + 1))) + "</option>";
  	        }
  	
  	        return html;
  	      }
  	
  	      function getSelectedBowserViewMeta() {
  	        var selected = valueOf("fuel-view-selector");
  	        var currentView = getDeep(bowser, ["ViewC"], null);
  	        var historyViews = toArray(getDeep(bowser, ["ViewH"], []));
  	
  	        if (!selected) return null;
  	
  	        if (selected.indexOf("VIEWC::") === 0) {
  	          return {
  	            kind: "current",
  	            objectId: selected.split("::")[1],
  	            view: currentView
  	          };
  	        }
  	
  	        if (selected === "VIEWC") {
  	          return {
  	            kind: "current",
  	            objectId: getDeep(currentView, ["objectId"], null),
  	            view: currentView
  	          };
  	        }
  	
  	        if (selected.indexOf("VIEWH::") === 0) {
  	          var hId = selected.split("::")[1];
  	          for (var i = 0; i < historyViews.length; i++) {
  	            if (String(getDeep(historyViews[i], ["objectId"], "")) === String(hId)) {
  	              return {
  	                kind: "history",
  	                objectId: hId,
  	                view: historyViews[i]
  	              };
  	            }
  	          }
  	        }
  	
  	        if (selected.indexOf("VIEWHIDX::") === 0) {
  	          var idx = toNumber(selected.split("::")[1], -1);
  	          if (idx >= 0 && idx < historyViews.length) {
  	            return {
  	              kind: "history",
  	              objectId: getDeep(historyViews[idx], ["objectId"], null),
  	              view: historyViews[idx]
  	            };
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function buildTransactionRow(item, index) {
  	        var fuelDate = formatDatePretty(text(getDeep(item, ["FuelDate"], ""), ""));
  	        var litres = displayNumber(getDeep(item, ["Litres"], 0), 2) + " L";
  	        var cost = formatCurrency(getDeep(item, ["Cost"], 0));
  	        var rebateCost = formatCurrency(getTransactionSarsRebate(item));
  	        var rebateLitres = displayNumber(getTransactionRebateLitres(item), 2) + " L";
  	        var meterEnd = displayNumber(getDeep(item, ["Meter"], 0), 2);
  	        var meterStart = displayNumber(getDeep(item, ["MeterLast"], 0), 2);
  	        var counters = getTransactionCounterColumns(item);
  	        var registration = getTransactionRegistration(item);
  	        var capturedBy = getTransactionCapturedBy(item);
  	        var driver = getTransactionDriver(item);
  	        var application = text(getDeep(item, ["Application"], ""), "");
  	        var captureType = text(getDeep(item, ["CaptureType"], ""), "");
  	        var description = text(getDeep(item, ["Description"], ""), "");
  	        var rollbackStatus = isTransactionReversed(item) ? "Reversed": "Active";
  	        var metaLine = driver + (application ? " | " + application: "") + (captureType ? " | " + captureType: "") + " | " + rollbackStatus;
  	
  	        return ""
  	        + '<button type="button" class="fuel-tx-item" data-tx-index="' + index + '">'
  	        + '  <div class="fuel-tx-grid fuel-ledger-row-grid">'
  	        + '    <div class="fuel-ledger-primary">'
  	        + '      <div class="fuel-ledger-primary-name">' + escapeHtml(registration) + "</div>"
  	        + '      <div class="fuel-ledger-primary-meta">' + escapeHtml(metaLine) + "</div>"
  	        + (description ? '      <div class="fuel-ledger-primary-desc">' + escapeHtml(description) + "</div>": "")
  	        + "    </div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(litres) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(cost) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(rebateCost) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(rebateLitres) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(meterStart) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(meterEnd) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(counters.odometer) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(counters.hobbs) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(counters.distance) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(counters.hours) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell fuel-ledger-cell-efficiency"><strong>' + escapeHtml(counters.kmPerL) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell fuel-ledger-cell-efficiency"><strong>' + escapeHtml(counters.litresPerHour) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell fuel-ledger-cell-date"><strong>' + escapeHtml(fuelDate || ("Transaction " + (index + 1))) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell fuel-ledger-cell-captured"><strong>' + escapeHtml(capturedBy) + "</strong></div>"
  	        + "  </div>"
  	        + "</button>";
  	      }
  	
  	      function bindTransactionRowClicks() {
  	        var listNode = el("fuel-transactions-list");
  	        if (!listNode) return;
  	
  	        var buttons = listNode.querySelectorAll("[data-tx-index]");
  	        for (var i = 0; i < buttons.length; i++) {
  	          buttons[i].onclick = function () {
  	            var idx = toNumber(this.getAttribute("data-tx-index"), -1);
  	            if (idx < 0 || idx >= state.filteredTransactions.length) return;
  	            openTransactionDetail(state.filteredTransactions[idx]);
  	          };
  	        }
  	      }
  	
  	      function updateTransactionPagination(totalRows) {
  	        var total = Math.max(0, toNumber(totalRows, 0));
  	        var pageSize = Math.max(1, toNumber(state.pageSize, 10));
  	        var totalPages = Math.max(1, Math.ceil(total / pageSize));
  	
  	        if (state.currentPage < 1) state.currentPage = 1;
  	        if (state.currentPage > totalPages) state.currentPage = totalPages;
  	
  	        var start = total ? ((state.currentPage - 1) * pageSize) + 1 : 0;
  	        var end = total ? Math.min(total, state.currentPage * pageSize) : 0;
  	
  	        setText(
  	          "fuel-page-status",
  	          total
  	            ? "Page " + state.currentPage + " of " + totalPages + " · " + start + "–" + end + " of " + total
  	            : "Page 1 of 1 · 0 transactions"
  	        );
  	
  	        var prev = el("fuel-page-prev");
  	        var next = el("fuel-page-next");
  	
  	        if (prev) prev.disabled = state.currentPage <= 1 || total === 0;
  	        if (next) next.disabled = state.currentPage >= totalPages || total === 0;
  	      }
  	
  	      function renderTransactionListFromState() {
  	        var listNode = el("fuel-transactions-list");
  	        if (!listNode) return;
  	
  	        var transactions = toArray(state.filteredTransactions);
  	        updateTransactionPagination(transactions.length);
  	
  	        if (!transactions.length) {
  	          listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No matching transactions</div>'
  	          + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Try a different search term or clear the filter.</div>'
  	          + "</div>";
  	          return;
  	        }
  	
  	        var pageSize = Math.max(1, toNumber(state.pageSize, 10));
  	        var offset = (state.currentPage - 1) * pageSize;
  	        var pageRows = transactions.slice(offset, offset + pageSize);
  	
  	        var html = "";
  	        for (var i = 0; i < pageRows.length; i++) {
  	          html += buildTransactionRow(pageRows[i], offset + i);
  	        }
  	
  	        listNode.innerHTML = html;
  	        bindTransactionRowClicks();
  	      }
  	
  	      function updateTransactionSortUi() {
  	        state.sortKey = "date";
  	        state.sortDirection = "desc";
  	
  	        var buttons = modal.querySelectorAll("[data-tx-sort-key]");
  	
  	        for (var i = 0; i < buttons.length; i++) {
  	          var button = buttons[i];
  	          var key = String(button.getAttribute("data-tx-sort-key") || "");
  	          var active = key === "date";
  	          var arrow = button.querySelector(".fuel-sort-arrow");
  	
  	          button.classList.toggle("active", active);
  	          button.setAttribute("aria-sort", active ? "descending" : "none");
  	          button.setAttribute("title", "Transactions are locked to newest date/time first");
  	
  	          if (arrow) {
  	            arrow.textContent = active ? "▼" : "";
  	          }
  	        }
  	      }
  	
  	      function applyTransactionSearch(options) {
  	        options = options || {};
  	
  	        var raw = valueOf("fuel-transactions-search");
  	        var term = String(raw || "").trim().toLowerCase();
  	        var termChanged = term !== state.searchTerm;
  	        state.searchTerm = term;
  	
  	        var source = toArray(state.transactionCache);
  	        var filtered = !term ? source.slice(): source.filter(function (item) {
  	          return buildTransactionSearchIndex(item).indexOf(term) >= 0;
  	        });
  	
  	        state.filteredTransactions = sortTransactionRows(filtered);
  	
  	        if (termChanged || options.resetPage) {
  	          state.currentPage = 1;
  	        }
  	
  	        var totals = term
  	          ? getFilteredTotals(state.filteredTransactions)
  	          : getWholeMonthTotals();
  	
  	        setText("fuel-summary-count", String(totals.count));
  	        setText("fuel-summary-litres", displayNumber(totals.litres, 2));
  	        setText("fuel-summary-cost", formatCurrency(totals.cost));
  	        setText("fuel-summary-rebate", formatCurrency(totals.rebateCost));
  	        setText("fuel-summary-rebate-litres", displayNumber(totals.rebateLitres, 2) + " L");
  	        setText("fuel-summary-meter-start", displayNumber(totals.meterStart, 2));
  	        setText("fuel-summary-meter-end", displayNumber(totals.meterEnd, 2));
  	
  	        updateTransactionSortUi();
  	        renderTransactionListFromState();
  	      }
  	
  	      async function renderTransactionsForSelectedView() {
  	        var listNode = el("fuel-transactions-list");
  	        if (!listNode) return;
  	
  	        closeTransactionDetail();
  	
  	        var meta = getSelectedBowserViewMeta();
  	
  	        if (!meta) {
  	          state.transactionCache = [];
  	          state.filteredTransactions = [];
  	          state.selectedHydratedView = null;
  	          state.currentPage = 1;
  	          updateTransactionPagination(0);
  	          setText("fuel-summary-count", "0");
  	          setText("fuel-summary-litres", "0.00");
  	          setText("fuel-summary-cost", "R 0.00");
  	          setText("fuel-summary-rebate", "R 0.00");
  	          setText("fuel-summary-rebate-litres", "0.00 L");
  	          setText("fuel-summary-meter-start", "0.00");
  	          setText("fuel-summary-meter-end", "0.00");
  	          listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No view selected</div>'
  	          + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Select ViewC or a historical view to see every transaction for that month.</div>'
  	          + "</div>";
  	          return;
  	        }
  	
  	        try {
  	          listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">Loading transactions...</div>'
  	          + "</div>";
  	
  	          var hydratedView = meta.view;
  	          var transactions = [];
  	
  	          if (meta.objectId) {
  	            hydratedView = await loadTableRow("BowserView", meta.objectId, []);
  	
  	            var allRelationTransactions = await loadAllRelationRows(
  	              "BowserView",
  	              meta.objectId,
  	              "FuelOut"
  	            );
  	
  	            if (allRelationTransactions.length) {
  	              transactions = getActiveTransactionsOnly(allRelationTransactions);
  	              hydratedView.FuelOut = allRelationTransactions.slice();
  	            } else {
  	              var relatedFallbackView = await loadTableRow("BowserView", meta.objectId, [
  	                "FuelOut",
  	                "FuelOut.Tractor",
  	                "FuelOut.DriverUser",
  	                "FuelOut.Company",
  	                "FuelOut.Bowser",
  	                "FuelOut.Tank",
  	                "FuelOut.Contractor"
  	              ]);
  	              hydratedView = Object.assign({}, hydratedView || {}, relatedFallbackView || {});
  	              transactions = getActiveTransactionsOnly(toArray(getDeep(hydratedView, ["FuelOut"], [])));
  	            }
  	          } else {
  	            transactions = getActiveTransactionsOnly(toArray(getDeep(hydratedView, ["FuelOut"], [])));
  	          }
  	
  	          state.selectedHydratedView = hydratedView;
  	
  	          // FuelOut.Tractor is commonly a partial relation containing only an
  	          // objectId. Hydrate every unique Tractor before rendering so the
  	          // canonical CounterType decides Odometer vs Hobbs and Distance vs Hours.
  	          await hydrateTransactionVehicleReadingUnits(transactions);
  	
  	          state.transactionCache = transactions.slice();
  	
  	          if (!transactions.length) {
  	            state.filteredTransactions = [];
  	            state.currentPage = 1;
  	            updateTransactionPagination(0);
  	
  	            var wholeMonthTotals = getWholeMonthTotals();
  	            setText("fuel-summary-count", String(wholeMonthTotals.count));
  	            setText("fuel-summary-litres", displayNumber(wholeMonthTotals.litres, 2));
  	            setText("fuel-summary-cost", formatCurrency(wholeMonthTotals.cost));
  	            setText("fuel-summary-rebate", formatCurrency(wholeMonthTotals.rebateCost));
  	            setText("fuel-summary-rebate-litres", displayNumber(wholeMonthTotals.rebateLitres, 2) + " L");
  	            setText("fuel-summary-meter-start", displayNumber(wholeMonthTotals.meterStart, 2));
  	            setText("fuel-summary-meter-end", displayNumber(wholeMonthTotals.meterEnd, 2));
  	            listNode.innerHTML = ""
  	            + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	            + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No transactions in this view</div>'
  	            + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">This selected monthly view contains no active FuelOut relations.</div>'
  	            + "</div>";
  	            return;
  	          }
  	
  	          applyTransactionSearch({ resetPage: true });
  	        } catch (err) {
  	          console.log("Render transactions error:", err);
  	          state.transactionCache = [];
  	          state.filteredTransactions = [];
  	          state.selectedHydratedView = null;
  	          state.currentPage = 1;
  	          updateTransactionPagination(0);
  	          setText("fuel-summary-count", "0");
  	          setText("fuel-summary-litres", "0.00");
  	          setText("fuel-summary-cost", "R 0.00");
  	          setText("fuel-summary-rebate", "R 0.00");
  	          setText("fuel-summary-rebate-litres", "0.00 L");
  	          setText("fuel-summary-meter-start", "0.00");
  	          setText("fuel-summary-meter-end", "0.00");
  	          listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">Failed to load transactions</div>'
  	          + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">' + escapeHtml(text(err && err.message ? err.message: err, "Unknown error")) + "</div>"
  	          + "</div>";
  	        }
  	      }
  	
  	      function refreshViewSelector() {
  	        var selector = el("fuel-view-selector");
  	        if (!selector) return;
  	
  	        var previous = selector.value;
  	        selector.innerHTML = buildViewOptionsHtmlFromBowser(bowser);
  	
  	        if (previous) selector.value = previous;
  	        if (!selector.value) {
  	          if (getDeep(bowser, ["ViewC", "objectId"], null)) {
  	            selector.value = "VIEWC::" + getDeep(bowser, ["ViewC", "objectId"], "");
  	          } else if (getDeep(bowser, ["ViewC", "MYear"], "")) {
  	            selector.value = "VIEWC";
  	          }
  	        }
  	
  	        renderTransactionsForSelectedView();
  	      }
  	
  	      if (el("fuel-capture-close")) el("fuel-capture-close").onclick = closeModal;
  	      if (el("fuel-cancel-btn")) el("fuel-cancel-btn").onclick = closeModal;
  	
  	      overlay.onclick = function (e) {
  	        if (e.target === overlay) closeModal();
  	      };
  	
  	      if (captureBtn) captureBtn.onclick = showCapture;
  	      if (transactionsBtn) transactionsBtn.onclick = showTransactions;
  	
  	      var detailBackdrop = el("fuel-transaction-detail-backdrop");
  	      if (detailBackdrop) {
  	        detailBackdrop.onclick = function (e) {
  	          if (e.target === detailBackdrop) closeTransactionDetail();
  	        };
  	      }
  	
  	      if (el("fuel-detail-close")) {
  	        el("fuel-detail-close").onclick = closeTransactionDetail;
  	      }
  	
  	      if (el("fuel-detail-print")) {
  	        el("fuel-detail-print").onclick = function () {
  	          if (!state.selectedTransaction) {
  	            alert("No transaction selected.");
  	            return;
  	          }
  	          openSingleTransactionPrintWindow(state.selectedTransaction);
  	        };
  	      }
  	
  	      var captureTypeNode = el("fuel-capture-type");
  	      if (captureTypeNode) {
  	        captureTypeNode.addEventListener("change", function () {
  	          clearCaptureValues();
  	          refreshCaptureVisibility();
  	        });
  	      }
  	
  	      bindChangeRefresh("fuel-company-application");
  	      bindChangeRefresh("fuel-company-application-other");
  	      bindChangeRefresh("fuel-company-registration");
  	      bindChangeRefresh("fuel-company-registration-other");
  	      bindChangeRefresh("fuel-company-driver");
  	      bindChangeRefresh("fuel-company-driver-other");
  	      bindChangeRefresh("fuel-contractor-name", rebuildContractorRegistrations);
  	      bindChangeRefresh("fuel-contractor-name-other");
  	      bindChangeRefresh("fuel-contractor-application");
  	      bindChangeRefresh("fuel-contractor-application-other");
  	      bindChangeRefresh("fuel-contractor-registration");
  	      bindChangeRefresh("fuel-contractor-registration-other");
  	      bindChangeRefresh("fuel-contractor-driver");
  	      bindChangeRefresh("fuel-intertank-target");
  	      bindChangeRefresh("fuel-description");
  	
  	      applyNumericSanitizer("fuel-mileage");
  	      applyNumericSanitizer("fuel-litres");
  	      applyNumericSanitizer("fuel-meter");
  	
  	      if (el("fuel-view-selector")) {
  	        el("fuel-view-selector").addEventListener("change", function () {
  	          state.currentPage = 1;
  	          renderTransactionsForSelectedView();
  	        });
  	      }
  	
  	      if (el("fuel-transactions-search")) {
  	        el("fuel-transactions-search").addEventListener("input", function () {
  	          applyTransactionSearch();
  	        });
  	      }
  	
  	      if (el("fuel-search-clear")) {
  	        el("fuel-search-clear").onclick = function () {
  	          setValue("fuel-transactions-search", "");
  	          applyTransactionSearch({ resetPage: true });
  	        };
  	      }
  	
  	      var transactionSortButtons = modal.querySelectorAll("[data-tx-sort-key]");
  	      for (var transactionSortIndex = 0; transactionSortIndex < transactionSortButtons.length; transactionSortIndex++) {
  	        transactionSortButtons[transactionSortIndex].onclick = function (event) {
  	          if (event) event.preventDefault();
  	          state.sortKey = "date";
  	          state.sortDirection = "desc";
  	          updateTransactionSortUi();
  	        };
  	      }
  	      updateTransactionSortUi();
  	
  	      if (el("fuel-page-prev")) {
  	        el("fuel-page-prev").onclick = function () {
  	          if (state.currentPage > 1) {
  	            state.currentPage -= 1;
  	            renderTransactionListFromState();
  	          }
  	        };
  	      }
  	
  	      if (el("fuel-page-next")) {
  	        el("fuel-page-next").onclick = function () {
  	          var totalPages = Math.max(
  	            1,
  	            Math.ceil(
  	              toArray(state.filteredTransactions).length /
  	              Math.max(1, toNumber(state.pageSize, 10))
  	            )
  	          );
  	
  	          if (state.currentPage < totalPages) {
  	            state.currentPage += 1;
  	            renderTransactionListFromState();
  	          }
  	        };
  	      }
  	
  	      if (el("fuel-print-btn")) {
  	        el("fuel-print-btn").onclick = function () {
  	          openPrintWindow();
  	        };
  	      }
  	
  	      renderTankGauge(tankBlock, tank);
  	      try {
  	        if (context && typeof context.onChanged === "function") {
  	          context.onChanged();
  	        }
  	      } catch (_) {}
  	      rebuildContractorRegistrations();
  	      refreshCaptureVisibility();
  	      refreshViewSelector();
  	      showTransactions();
  	
  	      if (el("fuel-save-btn")) {
  	        el("fuel-save-btn").onclick = async function () {
  	          managerBeginLoading(
  	            "Preparing fuel transaction…"
  	          );
  	
  	          try {
  	            if (!isComplete()) {
  	              managerFailLoading(
  	                "Cannot save because the capture figures are not valid yet."
  	              );
  	              return;
  	            }
  	
  	            var saveButton = el("fuel-save-btn");
  	            setButtonBusy(saveButton, true, "Saving...");
  	
  	            var mode = valueOf("fuel-capture-type");
  	            var tolerance = 0.5;
  	            var now = getNowDate();
  	
  	            if (
  	              isParaffinTankGrade(tankGrade) &&
  	              mode !== "other"
  	            ) {
  	              throw new Error(
  	                "Paraffin tanks only allow Other transactions."
  	              );
  	            }
  	
  	            var activeVehicle = getActiveVehicle();
  	
  	            if (
  	              (mode === "company" || mode === "contractor") &&
  	              (
  	                !activeVehicle ||
  	                !vehicleMatchesTankGrade(
  	                  activeVehicle,
  	                  tankGrade
  	                )
  	              )
  	            ) {
  	              throw new Error(
  	                "The selected vehicle fuel type is not compatible with " +
  	                tankGrade +
  	                "."
  	              );
  	            }
  	            var activeContractor = getSelectedContractorObject();
  	            var selectedDriverObj = getSelectedDriverOption();
  	            var intertankValidation = validateIntertankTarget();
  	            var selectedIntertankTank = intertankValidation.targetTank || null;
  	
  	            if (mode === "intertank" && !intertankValidation.ok) {
  	              managerFailLoading(
  	                "Cannot save because the intertank destination is not valid."
  	              );
  	              return;
  	            }
  	
  	            var applicationValue = mode === "company"
  	            ? (valueOf("fuel-company-application") === "OTHER" ? valueOf("fuel-company-application-other"): valueOf("fuel-company-application")): mode === "contractor"
  	            ? (valueOf("fuel-contractor-application") === "OTHER" ? valueOf("fuel-contractor-application-other"): valueOf("fuel-contractor-application")): "";
  	
  	            var registrationValue = "";
  	
  	            if (mode === "company") {
  	              if (valueOf("fuel-company-registration") === "OTHER") {
  	                registrationValue = valueOf("fuel-company-registration-other");
  	              } else if (activeVehicle) {
  	                registrationValue = text(
  	                  firstDefined(
  	                    getDeep(activeVehicle, ["ID"], null),
  	                    getDeep(activeVehicle, ["TractorID"], null),
  	                    getDeep(activeVehicle, ["FID"], null)
  	                  ),
  	                  ""
  	                );
  	              }
  	            } else if (mode === "contractor") {
  	              if (valueOf("fuel-contractor-registration") === "OTHER") {
  	                registrationValue = valueOf("fuel-contractor-registration-other");
  	              } else if (activeVehicle) {
  	                registrationValue = text(
  	                  firstDefined(
  	                    getDeep(activeVehicle, ["ID"], null),
  	                    getDeep(activeVehicle, ["TractorID"], null),
  	                    getDeep(activeVehicle, ["FID"], null)
  	                  ),
  	                  ""
  	                );
  	              }
  	            }
  	
  	            var driverValue = mode === "company"
  	            ? (valueOf("fuel-company-driver") === "OTHER" ? valueOf("fuel-company-driver-other"): valueOf("fuel-company-driver")): mode === "contractor"
  	            ? valueOf("fuel-contractor-driver"): "";
  	
  	            var contractorValue = mode === "contractor"
  	            ? (valueOf("fuel-contractor-name") === "OTHER" ? valueOf("fuel-contractor-name-other"): valueOf("fuel-contractor-name")): "";
  	
  	            var mileageNew = toNumber(valueOf("fuel-mileage"), 0);
  	            var litres = toNumber(valueOf("fuel-litres"), 0);
  	            var meterNew = toNumber(valueOf("fuel-meter"), 0);
  	            var meterLast = toNumber(getDeep(bowser, ["Meter"], 0), 0);
  	            var mileageLast = activeVehicle ? managerVehicleCurrentReading(activeVehicle): 0;
  	            var distance = activeVehicle ? (mileageNew - mileageLast): 0;
  	            var intertankTargetId = selectedIntertankTank ? getDeep(selectedIntertankTank, ["objectId"], null): null;
  	            var intertankTargetName = selectedIntertankTank
  	            ? text(
  	                firstDefined(
  	                  getDeep(
  	                    selectedIntertankTank,
  	                    ["Name"],
  	                    null
  	                  ),
  	                  getDeep(
  	                    selectedIntertankTank,
  	                    ["TankName"],
  	                    null
  	                  ),
  	                  getDeep(
  	                    selectedIntertankTank,
  	                    ["Grade"],
  	                    null
  	                  )
  	                ),
  	                ""
  	              )
  	            : "";
  	
  	            var costPerLitre = getTankCostPerLitre(tank);
  	            var transactionCost = litres * costPerLitre;
  	            var sarsCompliant = activeVehicle ? isVehicleSarsCompliant(activeVehicle): false;
  	            var vehicleSarsRate = activeVehicle
  	              ? Math.max(0, getVehicleSarsRebateRate(activeVehicle))
  	              : 0;
  	            var potentialSarsRebate =
  	              sarsCompliant && vehicleSarsRate > 0
  	                ? litres * vehicleSarsRate
  	                : 0;
  	            var potentialSarsRebateLitres =
  	              sarsCompliant && vehicleSarsRate > 0
  	                ? litres
  	                : 0;
  	
  	            var driverDisplayName = mode === "company"
  	            ? text(
  	              firstDefined(
  	                getDeep(selectedDriverObj, ["name"], null),
  	                getDeep(selectedDriverObj, ["Name"], null),
  	                driverValue
  	              ),
  	              ""
  	            ): driverValue;
  	
  	            var captureUser = firstDefined(
  	              currentUser,
  	              getDeep(appData, ["User"], null),
  	              getDeep(appData, ["CurrentUser"], null),
  	              getDeep(appData, ["Current_User"], null)
  	            );
  	
  	            var capturedByName = getCaptureUserName(captureUser);
  	            var capturedByEmail = getCaptureUserEmail(captureUser);
  	            var capturedByObjectId = text(
  	              getDeep(captureUser, ["objectId"], ""),
  	              ""
  	            );
  	
  	            var readingUnit =
  	              mode === "other" || mode === "intertank" || !activeVehicle
  	                ? ""
  	                : await resolveVehicleReadingUnitForVehicle(activeVehicle);
  	
  	            var readingDelta =
  	              mode === "other" || mode === "intertank"
  	                ? 0
  	                : Math.max(0, distance);
  	
  	            var efficiency =
  	              litres > 0 && readingDelta > 0
  	                ? (readingUnit === "h"
  	                    ? litres / readingDelta
  	                    : readingDelta / litres)
  	                : 0;
  	
  	            var fuelOutRow = {
  	              FuelDate: now,
  	              CaptureType: mode,
  	              Application:
  	                mode === "intertank"
  	                  ? intertankTargetName
  	                  : applicationValue,
  	              Registration: registrationValue,
  	              Driver: driverValue,
  	              DriverName: driverDisplayName,
  	              CapturedByName: capturedByName,
  	              CapturedByEmail: capturedByEmail,
  	              CapturedByObjectId: capturedByObjectId,
  	              ReadingUnit: readingUnit,
  	              ReadingDelta: readingDelta,
  	              Efficiency: efficiency,
  	              EfficiencyUnit:
  	                readingUnit === "h"
  	                  ? "L/H"
  	                  : readingUnit === "km"
  	                    ? "km/L"
  	                    : "",
  	              Litres: litres,
  	              CostPerLitre: costPerLitre,
  	              Cost: transactionCost,
  	              SARSCompliance: sarsCompliant,
  	              SARSRebateRate: vehicleSarsRate,
  	              PotentialSARSRebate: potentialSarsRebate,
  	              PotentialSARSRebateLitres: potentialSarsRebateLitres,
  	              Mileage: mode === "other" ? null: mileageNew,
  	              MileageLast: mode === "other" ? null: mileageLast,
  	              Distance: mode === "other" ? 0: distance,
  	              Meter: meterNew,
  	              MeterLast: meterLast,
  	              Tolerance: tolerance,
  	              Description: valueOf("fuel-description") || "",
  	              IsReversed: false,
  	              Reversed: false,
  	              RollbackStatus: "active",
  	              RollbackGroupId:
  	                mode === "intertank" && intertankTargetId
  	                  ? "INTERTANK:" + String(intertankTargetId)
  	                  : "",
  	              RollbackProtected: false,
  	              RollbackProtectionType: "none",
  	              TankObjectId:
  	                tank && tank.objectId
  	                  ? tank.objectId
  	                  : "",
  	              BowserObjectId:
  	                bowser && bowser.objectId
  	                  ? bowser.objectId
  	                  : "",
  	              TractorObjectId:
  	                mode !== "other" &&
  	                activeVehicle &&
  	                activeVehicle.objectId
  	                  ? activeVehicle.objectId
  	                  : "",
  	              VehicleObjectId:
  	                mode !== "other" &&
  	                activeVehicle &&
  	                activeVehicle.objectId
  	                  ? activeVehicle.objectId
  	                  : "",
  	              RollbackMileageDifferential:
  	                mode === "other"
  	                  ? 0
  	                  : Math.max(0, distance),
  	              RollbackVehicleMileageBefore:
  	                mode === "other"
  	                  ? null
  	                  : mileageLast,
  	              RollbackBowserMeterBefore:
  	                meterLast
  	            };
  	
  	            if (company && company.objectId) fuelOutRow.Company = {
  	              objectId: company.objectId
  	            };
  	            if (tank && tank.objectId) fuelOutRow.Tank = {
  	              objectId: tank.objectId
  	            };
  	            if (bowser && bowser.objectId) fuelOutRow.Bowser = {
  	              objectId: bowser.objectId
  	            };
  	            if (mode !== "other" && activeVehicle && activeVehicle.objectId) fuelOutRow.Tractor = {
  	              objectId: activeVehicle.objectId
  	            };
  	            if (mode === "contractor" && activeContractor && activeContractor.objectId) fuelOutRow.Contractor = {
  	              objectId: activeContractor.objectId
  	            };
  	            if (mode === "company" && selectedDriverObj && selectedDriverObj.objectId) fuelOutRow.DriverUser = {
  	              objectId: selectedDriverObj.objectId
  	            };
  	
  	            var savedTransaction = await saveTableRow("FuelOut", fuelOutRow);
  	
  	            var workingTank = deepClone(await loadTableRow("Tanks", tank.objectId, ["Bowsers"]));
  	            var workingBowser = deepClone(await loadTableRow("Bowsers", bowser.objectId, ["ViewC", "ViewH"]));
  	            var workingCompany = deepClone(await loadTableRow("Companies", company.objectId, ["Tanks", "Tractors"]));
  	            var workingVehicle =
  	              mode === "other" || !activeVehicle
  	                ? null
  	                : deepClone(
  	                    await loadTableRow(
  	                      "Tractors",
  	                      activeVehicle.objectId,
  	                      ["ViewC", "ViewH", "Tyres", "Maintenance"]
  	                    )
  	                  );
  	
  	            /*
  	             * The Backendless row is the authoritative tyre source for this
  	             * save. Fall back to the already-loaded AppData relation only when
  	             * the related Tyres were not returned.
  	             */
  	            if (
  	              workingVehicle &&
  	              !relationCollectionToArray(
  	                getDeep(workingVehicle, ["Tyres"], [])
  	              ).length
  	            ) {
  	              workingVehicle.Tyres = deepClone(
  	                relationCollectionToArray(
  	                  getDeep(activeVehicle, ["Tyres"], [])
  	                )
  	              );
  	            }
  	            var workingContractor = mode === "contractor" && activeContractor && activeContractor.objectId
  	            ? deepClone(await loadTableRow("Companies", activeContractor.objectId, ["Tractors"])): null;
  	            var workingDestinationTank = mode === "intertank" && selectedIntertankTank && selectedIntertankTank.objectId
  	            ? deepClone(await loadTableRow("Tanks", selectedIntertankTank.objectId, ["Bowsers"])): null;
  	            var intertankReceiptMeta = null;
  	            var savedIntertankFuelIn = null;
  	
  	            var tankVolumeOld = toNumber(getDeep(workingTank, ["Volume"], 0), 0);
  	            var tankCapacity = toNumber(getDeep(workingTank, ["Capacity"], 0), 0);
  	            var tankVolumeNew = tankVolumeOld - litres;
  	
  	            if (tankVolumeNew < 0) {
  	              throw new Error("Tank volume cannot go below 0. Available volume is " + displayNumber(tankVolumeOld, 2));
  	            }
  	
  	            workingTank.Volume = tankVolumeNew;
  	            if (tankCapacity > 0) {
  	              workingTank.Level = (tankVolumeNew / tankCapacity) * 100;
  	            }
  	
  	            workingBowser.Meter = meterNew;
  	
  	            var bowserView = ensureBowserViewRow(workingBowser, meterLast, now);
  	            bowserView.Litres =
  	              toNumber(
  	                getDeep(bowserView, ["Litres"], 0),
  	                0
  	              ) + litres;
  	            bowserView.Cost = roundMoney2(
  	              toNumber(
  	                getDeep(bowserView, ["Cost"], 0),
  	                0
  	              ) + transactionCost
  	            );
  	            bowserView.MeterEnd = meterNew;
  	
  	            var savedBowserView = await saveTableRow("BowserView", bowserView);
  	            workingBowser.ViewC = savedBowserView;
  	
  	            await syncBowserViewRelations(workingBowser, savedBowserView);
  	
  	            var savedVehicleView = null;
  	            var tyreMileageSync = {
  	              updatedCount: 0,
  	              differential: 0,
  	              vehicleMileage: mileageNew,
  	              updatedTyres: []
  	            };
  	
  	            if (mode !== "other" && workingVehicle) {
  	              workingVehicle.Mileage = mileageNew;
  	              managerSetVehicleCurrentReading(
  	                workingVehicle,
  	                mileageNew,
  	                readingUnit
  	              );
  	
  	              if (managerHasFuelCounter(workingVehicle)) {
  	                managerSetFuelCounter(
  	                  workingVehicle,
  	                  managerFuelCounterValue(workingVehicle, 0) + 1
  	                );
  	              }
  	
  	              var vehicleView = ensureVehicleViewRow(workingVehicle, now);
  	
  	              var transactionDistance = mileageNew - mileageLast;
  	              if (transactionDistance < 0) transactionDistance = 0;
  	
  	              /*
  	               * Tyres advance from the vehicle's positive operating-reading
  	               * differential regardless of whether CounterType is kilometres
  	               * or hours. Current_Mileage / History.Mileage_Done are the tyre
  	               * usage counters in the existing schema.
  	               */
  	              tyreMileageSync =
  	                await bulkUpdateVehicleTyreMileage(
  	                  workingVehicle,
  	                  transactionDistance,
  	                  mileageNew
  	                );
  	
  	              /*
  	               * Copy the freshly saved tyre mileage, History and Current_Life
  	               * values back into the long-lived AppData vehicle immediately.
  	               */
  	              mergeVehicleTyresIntoLiveAppData(
  	                activeVehicle,
  	                workingVehicle
  	              );
  	
  	              vehicleView.TransactionCount = toNumber(getDeep(vehicleView, ["TransactionCount"], 0), 0) + 1;
  	
  	              // Tractorview meter fields must use tractor mileage, not bowser meter.
  	              if (
  	                getDeep(vehicleView, ["MeterStart"], null) === null ||
  	                getDeep(vehicleView, ["MeterStart"], null) === undefined ||
  	                getDeep(vehicleView, ["MeterStart"], null) === "" ||
  	                toNumber(getDeep(vehicleView, ["MeterStart"], 0), 0) <= 0
  	              ) {
  	                vehicleView.MeterStart = mileageLast;
  	              } else {
  	                vehicleView.MeterStart = toNumber(getDeep(vehicleView, ["MeterStart"], mileageLast), mileageLast);
  	              }
  	
  	              vehicleView.MeterEnd = mileageNew;
  	
  	              // Route the shared vehicle movement to Distance or Hours.
  	              if (readingUnit === "h") {
  	                vehicleView.Hours =
  	                  toNumber(getDeep(vehicleView, ["Hours"], 0), 0) +
  	                  transactionDistance;
  	                vehicleView.Distance =
  	                  toNumber(getDeep(vehicleView, ["Distance"], 0), 0);
  	              } else {
  	                vehicleView.Distance =
  	                  toNumber(getDeep(vehicleView, ["Distance"], 0), 0) +
  	                  transactionDistance;
  	                vehicleView.Hours =
  	                  toNumber(getDeep(vehicleView, ["Hours"], 0), 0);
  	              }
  	
  	              vehicleView.Litres = toNumber(getDeep(vehicleView, ["Litres"], 0), 0) + litres;
  	              vehicleView.Cost = roundMoney2(
  	                toNumber(
  	                  getDeep(vehicleView, ["Cost"], 0),
  	                  0
  	                ) + transactionCost
  	              );
  	              vehicleView.PotentialSARSRebate = toNumber(getDeep(vehicleView, ["PotentialSARSRebate"], 0), 0) + potentialSarsRebate;
  	
  	              savedVehicleView = await saveTableRow("Tractorview", vehicleView);
  	              workingVehicle.ViewC = savedVehicleView;
  	
  	              await saveTableRow("Tractors", workingVehicle);
  	              await syncVehicleViewRelations(workingVehicle, savedVehicleView);
  	
  	              if (mode === "company") {
  	                replaceNestedCompanyVehicle(workingCompany, workingVehicle);
  	              }
  	
  	              if (mode === "contractor" && workingContractor) {
  	                replaceNestedCompanyVehicle(workingContractor, workingVehicle);
  	              }
  	            }
  	
  	            var tankBowsers = toArray(getDeep(workingTank, ["Bowsers"], []));
  	            var tankBowserIndex = findIndexByKeys(tankBowsers, workingBowser);
  	            if (tankBowserIndex >= 0) {
  	              tankBowsers[tankBowserIndex] = deepClone(workingBowser);
  	              workingTank.Bowsers = tankBowsers;
  	            }
  	
  	            if (mode === "intertank" && workingDestinationTank) {
  	              var destinationVolumeOld = toNumber(getDeep(workingDestinationTank, ["Volume"], 0), 0);
  	              var destinationCapacity = toNumber(getDeep(workingDestinationTank, ["Capacity"], 0), 0);
  	              var destinationVolumeNew = destinationVolumeOld + litres;
  	              var destinationLevelOld = toNumber(getDeep(workingDestinationTank, ["Level"], 0), 0);
  	
  	              if (destinationCapacity > 0 && destinationVolumeNew > destinationCapacity) {
  	                throw new Error("Destination tank cannot exceed capacity.");
  	              }
  	
  	              workingDestinationTank.Volume = destinationVolumeNew;
  	              if (destinationCapacity > 0) {
  	                workingDestinationTank.Level = (destinationVolumeNew / destinationCapacity) * 100;
  	              }
  	
  	              intertankReceiptMeta = {
  	                volumeBefore: destinationVolumeOld,
  	                volumeAfter: destinationVolumeNew,
  	                levelBefore: destinationLevelOld,
  	                levelAfter: toNumber(getDeep(workingDestinationTank, ["Level"], destinationLevelOld), destinationLevelOld)
  	              };
  	
  	              replaceNestedCompanyTank(workingCompany, workingDestinationTank);
  	            }
  	
  	            replaceNestedCompanyTank(workingCompany, workingTank);
  	
  	            if (mode === "intertank") {
  	              var sourceTankIdForSync = getDeep(workingTank, ["objectId"], null);
  	              var destinationTankIdForSync = getDeep(workingDestinationTank, ["objectId"], null);
  	
  	              if (sourceTankIdForSync) {
  	                syncTankIntoLiveAppData(workingTank);
  	              }
  	
  	              if (destinationTankIdForSync) {
  	                syncTankIntoLiveAppData(workingDestinationTank);
  	              }
  	
  	              syncCompanyIntoLiveAppData(workingCompany);
  	
  	              if (tank && sameObjectId(getDeep(tank, ["objectId"], null), sourceTankIdForSync)) {
  	                tank.Volume = workingTank.Volume;
  	                tank.Level = workingTank.Level;
  	              }
  	
  	              if (
  	                company &&
  	                (
  	                  sameKey(getDeep(company, ["objectId"], null), getDeep(workingCompany, ["objectId"], null)) ||
  	                  sameKey(getDeep(company, ["CompanyId"], null), getDeep(workingCompany, ["CompanyId"], null))
  	                )
  	              ) {
  	                // Intertank does not touch tractors.
  	                // Never assign company.Tractors from workingCompany here.
  	              }
  	
  	              // Do not assign tank.Bowsers.
  	              // Do not assign company.Tanks.
  	              // Do not force refresh the repeater.
  	            }
  	
  	            var saveJobs = [];
  	            saveJobs.push(saveTableRow("Tanks", workingTank));
  	            saveJobs.push(saveTableRow("Bowsers", workingBowser));
  	
  	            if (mode === "intertank" && workingDestinationTank && workingDestinationTank.objectId) {
  	              saveJobs.push(saveTableRow("Tanks", workingDestinationTank));
  	            }
  	
  	            if (mode !== "other" && mode !== "intertank" && workingVehicle && workingVehicle.objectId) {
  	              saveJobs.push(saveTableRow("Tractors", workingVehicle));
  	            }
  	            if (workingCompany && workingCompany.objectId) {
  	              // Do not save Companies during fuel capture.
  	              // Tanks, Bowsers, Tractor views, and FuelOut are saved directly.
  	              // Saving Companies with partial nested Tanks can damage repeater relation snapshots.
  	              // saveJobs.push(saveTableRow("Companies", workingCompany));
  	            }
  	
  	            if (mode === "contractor" && workingContractor && workingContractor.objectId) {
  	              // Do not save the whole contractor company row during fuel capture.
  	              // The tractor itself has already been saved directly.
  	              // Saving a company row with partial Tractors can damage relation snapshots.
  	              // saveJobs.push(saveTableRow("Companies", workingContractor));
  	            }
  	
  	            await Promise.all(saveJobs);
  	
  	            if (
  	              mode === "intertank" &&
  	              workingDestinationTank &&
  	              savedTransaction &&
  	              savedTransaction.objectId &&
  	              intertankReceiptMeta
  	            ) {
  	              var destinationOwnerMatch = findTankInAppDataByObjectId(
  	                getDeep(workingDestinationTank, ["objectId"], null)
  	              );
  	              var destinationOwnerCompany = destinationOwnerMatch
  	                ? destinationOwnerMatch.company
  	                : null;
  	              var sourceTankName = text(
  	                firstDefined(
  	                  getDeep(tank, ["Name"], null),
  	                  getDeep(tank, ["TankName"], null),
  	                  getDeep(tank, ["Grade"], null)
  	                ),
  	                "Source tank"
  	              );
  	              var destinationTankName = text(
  	                firstDefined(
  	                  getDeep(workingDestinationTank, ["Name"], null),
  	                  getDeep(workingDestinationTank, ["TankName"], null),
  	                  getDeep(workingDestinationTank, ["Grade"], null)
  	                ),
  	                "Destination tank"
  	              );
  	              var intertankReference =
  	                "INTERTANK:" + String(savedTransaction.objectId);
  	              var intertankDescription =
  	                "Intertank stock transfer from " + sourceTankName;
  	              var enteredDescription = String(
  	                valueOf("fuel-description") || ""
  	              ).trim();
  	
  	              if (enteredDescription) {
  	                intertankDescription += " | " + enteredDescription;
  	              }
  	
  	              var intertankFuelInRow = {
  	                FuelDate: now,
  	                EntryType: "intertank",
  	                TankName: destinationTankName,
  	                TankGrade: text(getDeep(workingDestinationTank, ["Grade"], ""), ""),
  	                TankDeviceId: text(getDeep(workingDestinationTank, ["DeviceId"], ""), ""),
  	                Supplier: "Intertank Transfer",
  	                SupplierId: "",
  	                Litres: litres,
  	                Cost: roundMoney2(transactionCost),
  	                CostPerLitre: costPerLitre,
  	                ReferenceNo: intertankReference,
  	                Description: intertankDescription,
  	                VolumeBefore: intertankReceiptMeta.volumeBefore,
  	                VolumeAfter: intertankReceiptMeta.volumeAfter,
  	                LevelBefore: intertankReceiptMeta.levelBefore,
  	                LevelAfter: intertankReceiptMeta.levelAfter
  	              };
  	
  	              if (destinationOwnerCompany && destinationOwnerCompany.objectId) {
  	                intertankFuelInRow.Company = {
  	                  objectId: destinationOwnerCompany.objectId
  	                };
  	              }
  	              if (workingDestinationTank.objectId) {
  	                intertankFuelInRow.Tank = {
  	                  objectId: workingDestinationTank.objectId
  	                };
  	              }
  	              if (captureUser && captureUser.objectId) {
  	                intertankFuelInRow.CapturedBy = {
  	                  objectId: captureUser.objectId
  	                };
  	              }
  	
  	              var savedIntertankFuelInResult = await saveTableRow(
  	                "FuelIn",
  	                intertankFuelInRow
  	              );
  	              savedIntertankFuelIn = Object.assign(
  	                {},
  	                intertankFuelInRow,
  	                savedIntertankFuelInResult || {}
  	              );
  	
  	              if (
  	                workingDestinationTank.objectId &&
  	                getDeep(savedIntertankFuelIn, ["objectId"], null)
  	              ) {
  	                await addRelation(
  	                  "Tanks",
  	                  workingDestinationTank.objectId,
  	                  "FuelIn",
  	                  [savedIntertankFuelIn.objectId]
  	                );
  	              }
  	
  	              workingDestinationTank.FuelIn = deepClone(
  	                toArray(getDeep(selectedIntertankTank, ["FuelIn"], []))
  	              );
  	              appendFuelInOnce(
  	                workingDestinationTank,
  	                savedIntertankFuelIn
  	              );
  	
  	              if (managerIsTrailerTank(workingDestinationTank)) {
  	                workingDestinationTank.LatestCostPerLitre = costPerLitre;
  	              }
  	
  	              var pairedRollbackGroupId =
  	                "INTERTANK:" +
  	                String(workingDestinationTank.objectId) +
  	                "|FUELIN:" +
  	                String(getDeep(savedIntertankFuelIn, ["objectId"], ""));
  	              var savedTransactionPatch = await saveTableRow(
  	                "FuelOut",
  	                {
  	                  objectId: savedTransaction.objectId,
  	                  RollbackGroupId: pairedRollbackGroupId
  	                }
  	              );
  	              savedTransaction = Object.assign(
  	                {},
  	                savedTransaction,
  	                savedTransactionPatch || {},
  	                {
  	                  RollbackGroupId: pairedRollbackGroupId
  	                }
  	              );
  	            }
  	
  	            // Do not force a full AppData/repeater refresh here.
  	            // Backendless repeater redraw causes visible layout shifts on the tank/nozzle rows.
  	            // We update the live objects and the current tank gauge manually below.
  	
  	            if (savedTransaction && savedTransaction.objectId && savedBowserView && savedBowserView.objectId) {
  	              await addRelation("BowserView", savedBowserView.objectId, "FuelOut", [savedTransaction.objectId]);
  	            }
  	
  	            if (mode !== "other" && mode !== "intertank" && savedTransaction && savedTransaction.objectId && savedVehicleView && savedVehicleView.objectId) {
  	              await addRelation("Tractorview", savedVehicleView.objectId, "Fuel", [savedTransaction.objectId]);
  	            }
  	
  	            tank.Volume = workingTank.Volume;
  	            tank.Level = workingTank.Level;
  	
  	            // Do not overwrite tank.Bowsers here.
  	            // The working tank may contain only the currently loaded bowser relation,
  	            // which causes the other bowser/nozzle to vanish from the repeater UI.
  	
  	            bowser.Meter = workingBowser.Meter;
  	            bowser.ViewC = savedBowserView;
  	            bowser.ViewH = workingBowser.ViewH;
  	
  	            if (company && mode === "company" && workingVehicle) {
  	              // Merge only the active tractor into the live company object.
  	              // Never replace the whole company.Tractors array.
  	              replaceNestedCompanyVehicle(company, workingVehicle);
  	            }
  	
  	            if (mode === "contractor" && activeContractor && workingVehicle) {
  	              // If the selected contractor object is live in the UI, merge only the active tractor.
  	              replaceNestedCompanyVehicle(activeContractor, workingVehicle);
  	            }
  	
  	            if (mode === "intertank" && workingDestinationTank) {
  	              syncTankIntoLiveAppData(workingDestinationTank);
  	              syncTankIntoLiveAppData(workingTank);
  	              syncCompanyIntoLiveAppData(workingCompany);
  	
  	              if (selectedIntertankTank) {
  	                selectedIntertankTank.Volume = workingDestinationTank.Volume;
  	                selectedIntertankTank.Level = workingDestinationTank.Level;
  	                selectedIntertankTank.Trailer = workingDestinationTank.Trailer;
  	                if (Array.isArray(getDeep(workingDestinationTank, ["FuelIn"], null))) {
  	                  selectedIntertankTank.FuelIn = deepClone(workingDestinationTank.FuelIn);
  	                }
  	                if (managerIsTrailerTank(workingDestinationTank)) {
  	                  selectedIntertankTank.LatestCostPerLitre = costPerLitre;
  	                }
  	              }
  	
  	              // Do not call forceAppDataRefresh() here.
  	              // The repeater must not be rebuilt during the save flow.
  	            }
  	
  	            if (mode !== "other" && mode !== "intertank" && activeVehicle && workingVehicle) {
  	              activeVehicle.Mileage = workingVehicle.Mileage;
  	              if (getDeep(workingVehicle, ["Data"], null)) {
  	                activeVehicle.Data = deepClone(workingVehicle.Data);
  	              }
  	              managerSetVehicleCurrentReading(
  	                activeVehicle,
  	                workingVehicle.Mileage,
  	                readingUnit
  	              );
  	              activeVehicle.ViewC = savedVehicleView;
  	              activeVehicle.ViewH = workingVehicle.ViewH;
  	
  	              mergeVehicleTyresIntoLiveAppData(
  	                activeVehicle,
  	                workingVehicle
  	              );
  	
  	              if (
  	                managerHasFuelCounter(activeVehicle) &&
  	                managerHasFuelCounter(workingVehicle)
  	              ) {
  	                managerSetFuelCounter(
  	                  activeVehicle,
  	                  managerFuelCounterValue(workingVehicle, 0)
  	                );
  	              }
  	            }
  	
  	            renderTankGauge(tankBlock, tank);
  	            try {
  	              if (context && typeof context.onChanged === "function") {
  	                context.onChanged();
  	              }
  	            } catch (_) {}
  	
  	            var fuelWarningNotificationResult =
  	              await managerReviewTankWarningNotificationsAfterFuel(
  	                company,
  	                workingTank,
  	                tankVolumeOld,
  	                tankVolumeNew,
  	                savedTransaction
  	              );
  	
  	            var orderNotificationResult =
  	              await managerReviewTankOrderNotificationAfterFuel(
  	                company,
  	                workingTank,
  	                tankVolumeOld,
  	                tankVolumeNew,
  	                savedTransaction
  	              );
  	
  	            var providerNotificationResult = {
  	              status: "not-required",
  	              message: ""
  	            };
  	
  	            if (
  	              mode !== "other" &&
  	              mode !== "intertank" &&
  	              workingVehicle
  	            ) {
  	              managerUpdateLoadingStatus(
  	                "Checking Service and Maintenance notifications…"
  	              );
  	
  	              var notificationCompany =
  	                mode === "contractor" && activeContractor
  	                  ? activeContractor
  	                  : company;
  	
  	              providerNotificationResult =
  	                await managerReviewProviderNotificationsAfterFuel(
  	                  notificationCompany,
  	                  workingVehicle,
  	                  savedTransaction
  	                );
  	
  	              if (activeVehicle && getDeep(workingVehicle, ["Data"], null)) {
  	                activeVehicle.Data = deepClone(workingVehicle.Data);
  	              }
  	            }
  	
  	            clearCaptureValues();
  	            refreshCaptureVisibility();
  	            refreshViewSelector();
  	            showCapture();
  	            setTimeout(function () {
  	              try {
  	                var firstField = el("fuel-capture-type");
  	                if (firstField && firstField.__fifThemedSelect) {
  	                  firstField.__fifThemedSelect.trigger.focus();
  	                } else if (firstField) {
  	                  firstField.focus();
  	                }
  	              } catch (_) {}
  	            }, 0);
  	            var tyreSyncMessage =
  	              tyreMileageSync.updatedCount > 0
  	                ? (
  	                    " " +
  	                    tyreMileageSync.updatedCount +
  	                    " fitted tyre" +
  	                    (
  	                      tyreMileageSync.updatedCount === 1
  	                        ? ""
  	                        : "s"
  	                    ) +
  	                    " synchronized to the vehicle " +
  	                    (readingUnit === "h" ? "hour reading." : "odometer reading.")
  	                  )
  	                : "";
  	
  	            var completionMessage =
  	              "Fuel transaction saved." +
  	              tyreSyncMessage +
  	              (
  	                fuelWarningNotificationResult &&
  	                fuelWarningNotificationResult.message
  	                  ? fuelWarningNotificationResult.message
  	                  : ""
  	              ) +
  	              (
  	                orderNotificationResult &&
  	                orderNotificationResult.message
  	                  ? orderNotificationResult.message
  	                  : ""
  	              ) +
  	              (
  	                providerNotificationResult &&
  	                providerNotificationResult.message
  	                  ? providerNotificationResult.message
  	                  : ""
  	              ) +
  	              " The form is ready for a new capture.";
  	
  	            if (mode === "intertank" && workingDestinationTank) {
  	              completionMessage = managerIsTrailerTank(workingDestinationTank)
  	                ? (
  	                    "Intertank transfer saved. The trailer received " +
  	                    displayNumber(litres, 2) +
  	                    " L of valued stock and now dispenses at " +
  	                    formatCurrency(costPerLitre) +
  	                    " per litre."
  	                  )
  	                : (
  	                    "Intertank transfer saved. The destination received " +
  	                    displayNumber(litres, 2) +
  	                    " L and its existing price per litre was not changed."
  	                  );
  	            }
  	
  	            managerCompleteLoading(completionMessage);
  	          } catch (saveErr) {
  	            console.log("Fuel save error:", saveErr);
  	            managerFailLoading(
  	              saveErr && saveErr.message
  	                ? saveErr.message
  	                : "The fuel transaction could not be saved."
  	            );
  	          } finally {
  	            setButtonBusy(el("fuel-save-btn"), false, "Save and New");
  	          }
  	        };
  	      }
  	
  	      return null;
  	    } catch (err) {
  	      console.log("Fuel capture full rewrite error:", err);
  	      return null;
  	    }
  	  }
  	
  	  function openFuelDelivery(context) {
  	    var AppData = context.AppData;
  	    var Company = context.Company;
  	    var Tank = context.Tank;
  	    var TankBlock = context.TankBlock;
  	    var Backendless = context.Backendless;
  	    var CurrentUser = context.CurrentUser;
  	    var SVGLogo = context.SVGLogo;
  	    try {
  	      var appData = (typeof AppData !== "undefined" ? AppData: null);
  	      var company = (typeof Company !== "undefined" ? Company: null);
  	      var tank = (typeof Tank !== "undefined" ? Tank: null);
  	      var tankBlock = (typeof TankBlock !== "undefined" ? TankBlock: null);
  	      var backendless = (typeof Backendless !== "undefined" ? Backendless: null);
  	      var currentUser = (typeof CurrentUser !== "undefined" ? CurrentUser: null);
  	      var svgLogo = (typeof SVGLogo !== "undefined" ? SVGLogo: null);
  	      var FUEL_DOCUMENT_API_BASE = "https://files-api.fiffiles.com";
  	      var FUEL_DOCUMENT_MAX_BYTES = 10 * 1024 * 1024;
  	      var FUEL_DOCUMENT_ALLOWED_TYPES = {
  	        "application/pdf": "pdf",
  	        "image/jpeg": "jpg",
  	        "image/png": "png",
  	        "image/webp": "webp"
  	      };
  	
  	      function toArray(value) {
  	        if (Array.isArray(value)) return value;
  	        if (value === null || value === undefined) return [];
  	        return [value];
  	      }
  	
  	      function toNumber(value, fallback) {
  	        var n = Number(String(value).replace(",", "."));
  	        return isNaN(n) ? fallback: n;
  	      }
  	
  	      function roundMoney2(value) {
  	        var amount = toNumber(value, 0);
  	
  	        return Math.round(
  	          (amount + Number.EPSILON) * 100
  	        ) / 100;
  	      }
  	
  	      function text(value, fallback) {
  	        if (value === null || value === undefined || value === "") return fallback;
  	        return String(value);
  	      }
  	
  	      function escapeHtml(value) {
  	        return String(value)
  	        .replace(/&/g, "&amp;")
  	        .replace(/</g, "&lt;")
  	        .replace(/>/g, "&gt;")
  	        .replace(/"/g, "&quot;")
  	        .replace(/'/g, "&#39;");
  	      }
  	
  	      function getDeep(obj, path, fallback) {
  	        try {
  	          var current = obj;
  	          for (var i = 0; i < path.length; i++) {
  	            if (current == null) return fallback;
  	            current = current[path[i]];
  	          }
  	          return current == null ? fallback: current;
  	        } catch (e) {
  	          return fallback;
  	        }
  	      }
  	
  	      function deepClone(value) {
  	        try {
  	          return JSON.parse(JSON.stringify(value));
  	        } catch (e) {
  	          return value;
  	        }
  	      }
  	
  	      function sanitizeNumeric(value) {
  	        return String(value || "").replace(/[^0-9.,]/g, "");
  	      }
  	
  	      function displayNumber(value, decimals) {
  	        var n = toNumber(value, 0);
  	        return n.toFixed(decimals);
  	      }
  	
  	      function formatCurrency(value) {
  	        return "R " + displayNumber(value, 2);
  	      }
  	
  	      function pad2(v) {
  	        v = String(v);
  	        return v.length < 2 ? ("0" + v): v;
  	      }
  	
  	      function getNowIso() {
  	        return new Date().toISOString();
  	      }
  	
  	      function formatDatePretty(isoValue) {
  	        if (!isoValue) return "";
  	        var d = new Date(isoValue);
  	        if (isNaN(d.getTime())) return String(isoValue);
  	        return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate()) + " " + pad2(d.getHours()) + ":" + pad2(d.getMinutes()) + ":" + pad2(d.getSeconds());
  	      }
  	
  	      function formatDateInput(value) {
  	        var d = value ? new Date(value): new Date();
  	        if (isNaN(d.getTime())) d = new Date();
  	        return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate());
  	      }
  	
  	      function sameKey(a, b) {
  	        var left = String(a === null || a === undefined ? "": a).trim();
  	        var right = String(b === null || b === undefined ? "": b).trim();
  	
  	        if (!left || !right) return false;
  	
  	        return left === right;
  	      }
  	
  	      function findIndexByKeys(items, candidate) {
  	        var arr = toArray(items);
  	
  	        for (var i = 0; i < arr.length; i++) {
  	          var row = arr[i];
  	
  	          if (
  	            sameKey(getDeep(row, ["objectId"], null), getDeep(candidate, ["objectId"], null)) ||
  	            sameKey(getDeep(row, ["FID"], null), getDeep(candidate, ["FID"], null)) ||
  	            sameKey(getDeep(row, ["DeviceId"], null), getDeep(candidate, ["DeviceId"], null)) ||
  	            sameKey(getDeep(row, ["Name"], null), getDeep(candidate, ["Name"], null))
  	          ) {
  	            return i;
  	          }
  	        }
  	
  	        return -1;
  	      }
  	
  	      function saveTableRow(tableName, row) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          return Promise.reject(new Error("Backendless SDK is not available"));
  	        }
  	
  	        return managerTrackDatabasePromise(
  	          managerDatabaseStatus("save", tableName),
  	          function () {
  	            return backendless.Data
  	              .of(tableName)
  	              .save(row);
  	          }
  	        );
  	      }
  	
  	      async function getFuelDocumentUserToken() {
  	        var token = "";
  	
  	        if (
  	          backendless &&
  	          backendless.UserService &&
  	          typeof backendless.UserService.getCurrentUserToken === "function"
  	        ) {
  	          token = backendless.UserService.getCurrentUserToken();
  	          if (token && typeof token.then === "function") {
  	            token = await token;
  	          }
  	        }
  	
  	        if (!token) {
  	          token = firstDefined(
  	            getDeep(currentUser, ["user-token"], ""),
  	            getDeep(currentUser, ["userToken"], ""),
  	            ""
  	          );
  	        }
  	
  	        token = String(token || "").trim();
  	        if (!token) {
  	          throw new Error(
  	            "Your login session is unavailable. Please log in again before accessing a document."
  	          );
  	        }
  	
  	        return token;
  	      }
  	
  	      function fuelDocumentMimeType(file) {
  	        var suppliedType = String(file && file.type ? file.type : "")
  	          .split(";", 1)[0]
  	          .trim()
  	          .toLowerCase();
  	
  	        if (FUEL_DOCUMENT_ALLOWED_TYPES[suppliedType]) {
  	          return suppliedType;
  	        }
  	
  	        var name = String(file && file.name ? file.name : "").toLowerCase();
  	        var extensionMatch = name.match(/\.([a-z0-9]+)$/);
  	        var extension = extensionMatch ? extensionMatch[1] : "";
  	
  	        if (extension === "pdf") return "application/pdf";
  	        if (extension === "jpg" || extension === "jpeg") return "image/jpeg";
  	        if (extension === "png") return "image/png";
  	        if (extension === "webp") return "image/webp";
  	        return "";
  	      }
  	
  	      function validateFuelDocument(file) {
  	        if (!file) {
  	          throw new Error("Select a document first.");
  	        }
  	
  	        if (!fuelDocumentMimeType(file)) {
  	          throw new Error("Only PDF, JPG, PNG and WEBP documents are allowed.");
  	        }
  	
  	        if (!(toNumber(file.size, 0) > 0)) {
  	          throw new Error("The selected document is empty.");
  	        }
  	
  	        if (toNumber(file.size, 0) > FUEL_DOCUMENT_MAX_BYTES) {
  	          throw new Error("The selected document exceeds the 10 MB limit.");
  	        }
  	
  	        return true;
  	      }
  	
  	      async function readFuelDocumentJson(response) {
  	        var responseText = await response.text();
  	        var payload = null;
  	
  	        try {
  	          payload = responseText ? JSON.parse(responseText) : {};
  	        } catch (_) {
  	          payload = {};
  	        }
  	
  	        if (!response.ok || payload.ok === false) {
  	          throw new Error(
  	            payload && payload.error
  	              ? payload.error
  	              : "The document service could not complete the request."
  	          );
  	        }
  	
  	        return payload || {};
  	      }
  	
  	      function safeFuelDocumentUrl(value) {
  	        var rawUrl = String(value || "").trim();
  	        if (!rawUrl) {
  	          throw new Error("This delivery has no saved document URL.");
  	        }
  	
  	        var parsed;
  	        try {
  	          parsed = new URL(rawUrl);
  	        } catch (_) {
  	          throw new Error("The saved document URL is invalid.");
  	        }
  	
  	        if (
  	          parsed.origin !== FUEL_DOCUMENT_API_BASE ||
  	          !/^\/fuel-in\/[A-Za-z0-9_-]{1,64}\/document\/[0-9a-f-]{36}\.(pdf|jpg|png|webp)$/i.test(parsed.pathname)
  	        ) {
  	          throw new Error("The saved document URL is not trusted.");
  	        }
  	
  	        return parsed.href;
  	      }
  	
  	      function fuelInDocsFromValue(value) {
  	        var raw = value;
  	
  	        if (typeof raw === "string") {
  	          var trimmed = raw.trim();
  	          if (!trimmed) return [];
  	          try {
  	            raw = JSON.parse(trimmed);
  	          } catch (_) {
  	            return [];
  	          }
  	        }
  	
  	        var items = Array.isArray(raw)
  	          ? raw
  	          : raw && Array.isArray(raw.Items)
  	            ? raw.Items
  	            : raw && Array.isArray(raw.Documents)
  	              ? raw.Documents
  	              : [];
  	
  	        var bySlot = {};
  	
  	        items.forEach(function (entry, index) {
  	          if (!entry || typeof entry !== "object") return;
  	
  	          var slot = Math.round(
  	            toNumber(
  	              firstDefined(
  	                getDeep(entry, ["Slot"], null),
  	                getDeep(entry, ["slot"], null),
  	                index + 1
  	              ),
  	              index + 1
  	            )
  	          );
  	
  	          if (slot < 1 || slot > 2) return;
  	
  	          var url = text(
  	            firstDefined(
  	              getDeep(entry, ["URL"], null),
  	              getDeep(entry, ["Url"], null),
  	              getDeep(entry, ["url"], null),
  	              getDeep(entry, ["DocumentURL"], null)
  	            ),
  	            ""
  	          ).trim();
  	
  	          if (!url) return;
  	
  	          bySlot[slot] = {
  	            Slot: slot,
  	            Name: text(
  	              firstDefined(
  	                getDeep(entry, ["Name"], null),
  	                getDeep(entry, ["name"], null),
  	                getDeep(entry, ["DocumentName"], null)
  	              ),
  	              "Additional delivery document " + slot
  	            ),
  	            URL: url,
  	            Key: text(
  	              firstDefined(
  	                getDeep(entry, ["Key"], null),
  	                getDeep(entry, ["key"], null),
  	                getDeep(entry, ["DocumentKey"], null)
  	              ),
  	              ""
  	            ),
  	            ContentType: text(
  	              firstDefined(
  	                getDeep(entry, ["ContentType"], null),
  	                getDeep(entry, ["contentType"], null),
  	                getDeep(entry, ["MimeType"], null)
  	              ),
  	              ""
  	            ),
  	            Size: Math.max(
  	              0,
  	              toNumber(
  	                firstDefined(
  	                  getDeep(entry, ["Size"], null),
  	                  getDeep(entry, ["size"], null),
  	                  0
  	                ),
  	                0
  	              )
  	            ),
  	            UploadedAt: text(
  	              firstDefined(
  	                getDeep(entry, ["UploadedAt"], null),
  	                getDeep(entry, ["uploadedAt"], null),
  	                ""
  	              ),
  	              ""
  	            )
  	          };
  	        });
  	
  	        return [1, 2].map(function (slot) {
  	          return bySlot[slot] || null;
  	        }).filter(Boolean);
  	      }
  	
  	      function fuelInAdditionalDocs(item) {
  	        return fuelInDocsFromValue(
  	          getDeep(item, ["Docs"], null)
  	        );
  	      }
  	
  	      function fuelInAdditionalDocAt(item, slot) {
  	        var wanted = Math.round(toNumber(slot, 0));
  	        var docs = fuelInAdditionalDocs(item);
  	
  	        for (var index = 0; index < docs.length; index++) {
  	          if (toNumber(getDeep(docs[index], ["Slot"], 0), 0) === wanted) {
  	            return docs[index];
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function fuelInDocsPayload(docs) {
  	        return {
  	          Version: 1,
  	          Items: fuelInDocsFromValue(docs)
  	        };
  	      }
  	
  	      function fuelInAdditionalDocDescriptor(uploaded, file, slot) {
  	        return {
  	          Slot: Math.round(toNumber(slot, 0)),
  	          Name: text(
  	            getDeep(uploaded, ["documentName"], ""),
  	            String(file && file.name ? file.name : "document")
  	          ),
  	          URL: text(getDeep(uploaded, ["documentUrl"], ""), ""),
  	          Key: text(getDeep(uploaded, ["documentKey"], ""), ""),
  	          ContentType: text(
  	            getDeep(uploaded, ["contentType"], ""),
  	            fuelDocumentMimeType(file)
  	          ),
  	          Size: Math.max(
  	            0,
  	            toNumber(
  	              getDeep(uploaded, ["size"], file && file.size ? file.size : 0),
  	              0
  	            )
  	          ),
  	          UploadedAt: getNowIso()
  	        };
  	      }
  	
  	      function fuelInAdditionalDocAsLegacyItem(doc) {
  	        return {
  	          DocumentURL: text(getDeep(doc, ["URL"], ""), ""),
  	          DocumentKey: text(getDeep(doc, ["Key"], ""), ""),
  	          DocumentName: text(getDeep(doc, ["Name"], ""), "Additional delivery document")
  	        };
  	      }
  	
  	      async function fetchFuelInDocumentBlobByUrl(documentUrl) {
  	        var trustedUrl = safeFuelDocumentUrl(documentUrl);
  	        var token = await getFuelDocumentUserToken();
  	        var response = await fetch(trustedUrl, {
  	          method: "GET",
  	          headers: {
  	            "X-Backendless-User-Token": token
  	          }
  	        });
  	
  	        if (!response.ok) {
  	          await readFuelDocumentJson(response);
  	        }
  	
  	        return await response.blob();
  	      }
  	
  	      async function fetchFuelInDocumentBlob(item) {
  	        return fetchFuelInDocumentBlobByUrl(
  	          getDeep(item, ["DocumentURL"], "")
  	        );
  	      }
  	
  	      function fuelDocumentBlobToDataUrl(blob) {
  	        return new Promise(function (resolve, reject) {
  	          try {
  	            var reader = new FileReader();
  	            reader.onload = function () {
  	              resolve(String(reader.result || ""));
  	            };
  	            reader.onerror = function () {
  	              reject(new Error("The attached image could not be prepared for printing."));
  	            };
  	            reader.readAsDataURL(blob);
  	          } catch (error) {
  	            reject(error);
  	          }
  	        });
  	      }
  	
  	      function fuelDocumentMimeFromItem(item, blob) {
  	        var blobType = String(blob && blob.type ? blob.type : "")
  	          .split(";", 1)[0]
  	          .trim()
  	          .toLowerCase();
  	
  	        if (blobType) return blobType;
  	
  	        var name = String(
  	          firstDefined(
  	            getDeep(item, ["DocumentName"], ""),
  	            getDeep(item, ["DocumentURL"], ""),
  	            ""
  	          )
  	        ).toLowerCase();
  	
  	        if (/\.pdf(?:$|\?)/i.test(name)) return "application/pdf";
  	        if (/\.jpe?g(?:$|\?)/i.test(name)) return "image/jpeg";
  	        if (/\.png(?:$|\?)/i.test(name)) return "image/png";
  	        if (/\.webp(?:$|\?)/i.test(name)) return "image/webp";
  	        return "";
  	      }
  	
  	      function revokeDeliveryDocumentPreviewUrl() {
  	        if (
  	          state &&
  	          state.documentPreviewObjectUrl
  	        ) {
  	          try {
  	            URL.revokeObjectURL(state.documentPreviewObjectUrl);
  	          } catch (_) {}
  	
  	          state.documentPreviewObjectUrl = "";
  	        }
  	
  	        if (state && Array.isArray(state.additionalDocumentPreviewObjectUrls)) {
  	          state.additionalDocumentPreviewObjectUrls.forEach(function (objectUrl) {
  	            if (!objectUrl) return;
  	            try {
  	              URL.revokeObjectURL(objectUrl);
  	            } catch (_) {}
  	          });
  	          state.additionalDocumentPreviewObjectUrls = [];
  	        }
  	      }
  	
  	      async function renderFuelInDocumentPreview(item) {
  	        var previewHost = el("fuel-delivery-document-preview");
  	        if (!previewHost || !item) return;
  	
  	        var requestedDocumentUrl = text(
  	          getDeep(item, ["DocumentURL"], ""),
  	          ""
  	        );
  	
  	        if (!requestedDocumentUrl) {
  	          previewHost.innerHTML = "";
  	          return;
  	        }
  	
  	        revokeDeliveryDocumentPreviewUrl();
  	
  	        previewHost.innerHTML =
  	          '<div style="min-height:110px;display:grid;place-items:center;padding:18px;border:1px solid rgba(255,255,255,.08);border-radius:12px;background:rgba(0,0,0,.18);color:#94a3b8;font-size:11px;font-weight:750;">Loading document preview…</div>';
  	
  	        try {
  	          var blob = await fetchFuelInDocumentBlob(item);
  	          var liveHost = el("fuel-delivery-document-preview");
  	          var liveDocumentUrl = state.selectedDelivery
  	            ? text(getDeep(state.selectedDelivery, ["DocumentURL"], ""), "")
  	            : "";
  	
  	          if (
  	            !liveHost ||
  	            liveDocumentUrl !== requestedDocumentUrl
  	          ) {
  	            return;
  	          }
  	
  	          var objectUrl = URL.createObjectURL(blob);
  	          state.documentPreviewObjectUrl = objectUrl;
  	
  	          var mimeType = fuelDocumentMimeFromItem(item, blob);
  	          var documentName = text(
  	            getDeep(item, ["DocumentName"], ""),
  	            "Fuel delivery document"
  	          );
  	
  	          if (/^image\//i.test(mimeType)) {
  	            liveHost.innerHTML = ""
  	            + '<div style="margin-top:12px;padding:10px;border:1px solid rgba(255,255,255,.08);border-radius:13px;background:rgba(0,0,0,.20);">'
  	            + '<img alt="' + escapeHtml(documentName) + '" src="' + escapeHtml(objectUrl) + '" style="display:block;width:auto;max-width:100%;max-height:520px;margin:0 auto;border-radius:9px;object-fit:contain;background:#fff;box-shadow:0 10px 30px rgba(0,0,0,.32);">'
  	            + '</div>';
  	            return;
  	          }
  	
  	          if (mimeType === "application/pdf") {
  	            liveHost.innerHTML = ""
  	            + '<div style="margin-top:12px;overflow:hidden;border:1px solid rgba(255,255,255,.08);border-radius:13px;background:#fff;">'
  	            + '<iframe title="' + escapeHtml(documentName) + '" src="' + escapeHtml(objectUrl) + '#toolbar=1&navpanes=0" style="display:block;width:100%;height:560px;border:0;background:#fff;"></iframe>'
  	            + '</div>';
  	            return;
  	          }
  	
  	          liveHost.innerHTML =
  	            '<div style="margin-top:12px;padding:14px;border:1px solid rgba(255,255,255,.08);border-radius:12px;background:rgba(0,0,0,.18);color:#cbd5e1;font-size:11px;font-weight:700;">Preview is not available for this file type. Use Download to open the document.</div>';
  	        } catch (documentError) {
  	          var failedHost = el("fuel-delivery-document-preview");
  	          if (!failedHost) return;
  	
  	          failedHost.innerHTML =
  	            '<div style="margin-top:12px;padding:14px;border:1px solid rgba(239,68,68,.24);border-radius:12px;background:rgba(127,29,29,.12);color:#f0c7c0;font-size:11px;font-weight:700;line-height:1.45;">Document preview could not be loaded. ' +
  	            escapeHtml(
  	              documentError && documentError.message
  	                ? documentError.message
  	                : "Use Download to access the document."
  	            ) +
  	            '</div>';
  	        }
  	      }
  	
  	
  	      async function renderFuelInAdditionalDocumentPreview(item, doc, slot) {
  	        var hostId = "fuel-delivery-extra-document-preview-" + String(slot);
  	        var previewHost = el(hostId);
  	        if (!previewHost || !item || !doc) return;
  	
  	        var requestedDocumentUrl = text(getDeep(doc, ["URL"], ""), "");
  	        if (!requestedDocumentUrl) {
  	          previewHost.innerHTML = "";
  	          return;
  	        }
  	
  	        previewHost.innerHTML =
  	          '<div style="min-height:95px;display:grid;place-items:center;padding:16px;border:1px solid rgba(255,255,255,.08);border-radius:12px;background:rgba(0,0,0,.18);color:#94a3b8;font-size:11px;font-weight:750;">Loading additional document preview…</div>';
  	
  	        try {
  	          var blob = await fetchFuelInDocumentBlobByUrl(requestedDocumentUrl);
  	          var liveHost = el(hostId);
  	          var liveDoc = state.selectedDelivery
  	            ? fuelInAdditionalDocAt(state.selectedDelivery, slot)
  	            : null;
  	          var liveUrl = liveDoc
  	            ? text(getDeep(liveDoc, ["URL"], ""), "")
  	            : "";
  	
  	          if (!liveHost || liveUrl !== requestedDocumentUrl) {
  	            return;
  	          }
  	
  	          var objectUrl = URL.createObjectURL(blob);
  	          if (!Array.isArray(state.additionalDocumentPreviewObjectUrls)) {
  	            state.additionalDocumentPreviewObjectUrls = [];
  	          }
  	          state.additionalDocumentPreviewObjectUrls.push(objectUrl);
  	
  	          var pseudoItem = fuelInAdditionalDocAsLegacyItem(doc);
  	          var mimeType = fuelDocumentMimeFromItem(pseudoItem, blob);
  	          var documentName = text(
  	            getDeep(doc, ["Name"], ""),
  	            "Additional delivery document " + String(slot)
  	          );
  	
  	          if (/^image\//i.test(mimeType)) {
  	            liveHost.innerHTML = ""
  	            + '<div style="margin-top:10px;padding:10px;border:1px solid rgba(255,255,255,.08);border-radius:13px;background:rgba(0,0,0,.20);">'
  	            + '<img alt="' + escapeHtml(documentName) + '" src="' + escapeHtml(objectUrl) + '" style="display:block;width:auto;max-width:100%;max-height:420px;margin:0 auto;border-radius:9px;object-fit:contain;background:#fff;box-shadow:0 10px 30px rgba(0,0,0,.32);">'
  	            + '</div>';
  	            return;
  	          }
  	
  	          if (mimeType === "application/pdf") {
  	            liveHost.innerHTML = ""
  	            + '<div style="margin-top:10px;overflow:hidden;border:1px solid rgba(255,255,255,.08);border-radius:13px;background:#fff;">'
  	            + '<iframe title="' + escapeHtml(documentName) + '" src="' + escapeHtml(objectUrl) + '#toolbar=1&navpanes=0" style="display:block;width:100%;height:480px;border:0;background:#fff;"></iframe>'
  	            + '</div>';
  	            return;
  	          }
  	
  	          liveHost.innerHTML =
  	            '<div style="margin-top:10px;padding:14px;border:1px solid rgba(255,255,255,.08);border-radius:12px;background:rgba(0,0,0,.18);color:#cbd5e1;font-size:11px;font-weight:700;">Preview is not available for this file type. Use Download to open the document.</div>';
  	        } catch (documentError) {
  	          var failedHost = el(hostId);
  	          if (!failedHost) return;
  	
  	          failedHost.innerHTML =
  	            '<div style="margin-top:10px;padding:14px;border:1px solid rgba(239,68,68,.24);border-radius:12px;background:rgba(127,29,29,.12);color:#f0c7c0;font-size:11px;font-weight:700;line-height:1.45;">Additional document preview could not be loaded. ' +
  	            escapeHtml(
  	              documentError && documentError.message
  	                ? documentError.message
  	                : "Use Download to access the document."
  	            ) +
  	            '</div>';
  	        }
  	      }
  	
  	      async function uploadFuelInDocument(file, fuelInObjectId) {
  	        validateFuelDocument(file);
  	
  	        var objectId = String(fuelInObjectId || "").trim();
  	        if (!objectId) {
  	          throw new Error("The FuelIn record must be saved before its document can be uploaded.");
  	        }
  	
  	        var token = await getFuelDocumentUserToken();
  	        var response = await fetch(
  	          FUEL_DOCUMENT_API_BASE +
  	            "/fuel-in/" +
  	            encodeURIComponent(objectId) +
  	            "/document",
  	          {
  	            method: "PUT",
  	            headers: {
  	              "Content-Type": fuelDocumentMimeType(file),
  	              "X-Backendless-User-Token": token,
  	              "X-File-Name": encodeURIComponent(String(file.name || "document"))
  	            },
  	            body: file
  	          }
  	        );
  	
  	        return readFuelDocumentJson(response);
  	      }
  	
  	      async function deleteFuelInDocumentUrl(documentUrl) {
  	        var trustedUrl = safeFuelDocumentUrl(documentUrl);
  	        var token = await getFuelDocumentUserToken();
  	        var response = await fetch(trustedUrl, {
  	          method: "DELETE",
  	          headers: {
  	            "X-Backendless-User-Token": token
  	          }
  	        });
  	
  	        return readFuelDocumentJson(response);
  	      }
  	
  	      async function downloadFuelInDocument(item) {
  	        var blob = await fetchFuelInDocumentBlob(item);
  	        var objectUrl = URL.createObjectURL(blob);
  	        var downloadName = text(
  	          getDeep(item, ["DocumentName"], ""),
  	          "fuel-delivery-document"
  	        );
  	        var link = document.createElement("a");
  	
  	        link.href = objectUrl;
  	        link.download = downloadName;
  	        link.style.display = "none";
  	        document.body.appendChild(link);
  	        link.click();
  	        link.remove();
  	
  	        setTimeout(function () {
  	          try {
  	            URL.revokeObjectURL(objectUrl);
  	          } catch (_) {}
  	        }, 30000);
  	      }
  	
  	      async function downloadFuelInAdditionalDocument(doc) {
  	        var url = text(getDeep(doc, ["URL"], ""), "");
  	        var blob = await fetchFuelInDocumentBlobByUrl(url);
  	        var objectUrl = URL.createObjectURL(blob);
  	        var downloadName = text(
  	          getDeep(doc, ["Name"], ""),
  	          "fuel-delivery-additional-document"
  	        );
  	        var link = document.createElement("a");
  	
  	        link.href = objectUrl;
  	        link.download = downloadName;
  	        link.style.display = "none";
  	        document.body.appendChild(link);
  	        link.click();
  	        link.remove();
  	
  	        setTimeout(function () {
  	          try {
  	            URL.revokeObjectURL(objectUrl);
  	          } catch (_) {}
  	        }, 30000);
  	      }
  	
  	      function replaceFuelInAdditionalDoc(docs, slot, replacement) {
  	        var wanted = Math.round(toNumber(slot, 0));
  	        var result = fuelInDocsFromValue(docs).filter(function (doc) {
  	          return toNumber(getDeep(doc, ["Slot"], 0), 0) !== wanted;
  	        });
  	
  	        if (replacement) result.push(replacement);
  	
  	        result.sort(function (left, right) {
  	          return toNumber(getDeep(left, ["Slot"], 0), 0) -
  	            toNumber(getDeep(right, ["Slot"], 0), 0);
  	        });
  	
  	        return result.slice(0, 2);
  	      }
  	
  	      async function attachFuelAdditionalDocumentToSavedDelivery(item, file, slot) {
  	        validateFuelDocument(file);
  	
  	        var objectId = getDeep(item, ["objectId"], null);
  	        if (!objectId) {
  	          throw new Error("This delivery has no objectId and cannot accept an additional document.");
  	        }
  	
  	        var wantedSlot = Math.round(toNumber(slot, 0));
  	        if (wantedSlot < 1 || wantedSlot > 2) {
  	          throw new Error("The additional document slot is invalid.");
  	        }
  	
  	        var previousDoc = fuelInAdditionalDocAt(item, wantedSlot);
  	        var previousUrl = previousDoc
  	          ? text(getDeep(previousDoc, ["URL"], ""), "")
  	          : "";
  	
  	        var uploaded = await uploadFuelInDocument(file, objectId);
  	        var newDoc = fuelInAdditionalDocDescriptor(
  	          uploaded,
  	          file,
  	          wantedSlot
  	        );
  	        var nextDocs = replaceFuelInAdditionalDoc(
  	          fuelInAdditionalDocs(item),
  	          wantedSlot,
  	          newDoc
  	        );
  	        var patch = {
  	          objectId: objectId,
  	          Docs: fuelInDocsPayload(nextDocs)
  	        };
  	        var savedPatch;
  	
  	        try {
  	          savedPatch = await saveTableRow("FuelIn", patch);
  	        } catch (patchError) {
  	          try {
  	            if (newDoc.URL) {
  	              await deleteFuelInDocumentUrl(newDoc.URL);
  	            }
  	          } catch (cleanupError) {
  	            console.error("New additional FuelIn document cleanup failed:", cleanupError);
  	          }
  	          throw patchError;
  	        }
  	
  	        var updated = Object.assign({}, item, patch, savedPatch || {});
  	        updateCorrectedDeliveryLocally(
  	          updated,
  	          findViewContainingDelivery(item)
  	        );
  	
  	        if (previousUrl && previousUrl !== newDoc.URL) {
  	          try {
  	            await deleteFuelInDocumentUrl(previousUrl);
  	          } catch (oldDeleteError) {
  	            console.error("Previous additional FuelIn document cleanup failed:", oldDeleteError);
  	          }
  	        }
  	
  	        return updated;
  	      }
  	
  	      async function removeFuelAdditionalDocumentFromSavedDelivery(item, slot) {
  	        var objectId = getDeep(item, ["objectId"], null);
  	        if (!objectId) {
  	          throw new Error("This delivery has no objectId and cannot be updated.");
  	        }
  	
  	        var wantedSlot = Math.round(toNumber(slot, 0));
  	        var previousDoc = fuelInAdditionalDocAt(item, wantedSlot);
  	        if (!previousDoc) return item;
  	
  	        var previousUrl = text(getDeep(previousDoc, ["URL"], ""), "");
  	        var nextDocs = replaceFuelInAdditionalDoc(
  	          fuelInAdditionalDocs(item),
  	          wantedSlot,
  	          null
  	        );
  	        var patch = {
  	          objectId: objectId,
  	          Docs: fuelInDocsPayload(nextDocs)
  	        };
  	        var savedPatch = await saveTableRow("FuelIn", patch);
  	        var updated = Object.assign({}, item, patch, savedPatch || {});
  	
  	        updateCorrectedDeliveryLocally(
  	          updated,
  	          findViewContainingDelivery(item)
  	        );
  	
  	        if (previousUrl) {
  	          try {
  	            await deleteFuelInDocumentUrl(previousUrl);
  	          } catch (deleteError) {
  	            console.error("Removed additional FuelIn document cleanup failed:", deleteError);
  	          }
  	        }
  	
  	        return updated;
  	      }
  	
  	      async function uploadInitialFuelInAdditionalDocuments(item, files) {
  	        var selectedFiles = Array.isArray(files) ? files.slice(0, 2) : [];
  	        var uploadedDocs = [];
  	        var uploadedUrls = [];
  	        var warnings = [];
  	
  	        for (var slot = 1; slot <= 2; slot++) {
  	          var file = selectedFiles[slot - 1] || null;
  	          if (!file) continue;
  	
  	          try {
  	            validateFuelDocument(file);
  	            var uploaded = await uploadFuelInDocument(
  	              file,
  	              getDeep(item, ["objectId"], null)
  	            );
  	            var doc = fuelInAdditionalDocDescriptor(uploaded, file, slot);
  	            uploadedDocs.push(doc);
  	            if (doc.URL) uploadedUrls.push(doc.URL);
  	          } catch (uploadError) {
  	            warnings.push(
  	              "Additional document " + slot + ": " +
  	              (uploadError && uploadError.message
  	                ? uploadError.message
  	                : "upload failed")
  	            );
  	          }
  	        }
  	
  	        if (!uploadedDocs.length) {
  	          return {
  	            item: item,
  	            uploadedCount: 0,
  	            warnings: warnings
  	          };
  	        }
  	
  	        var nextDocs = fuelInAdditionalDocs(item);
  	        uploadedDocs.forEach(function (doc) {
  	          nextDocs = replaceFuelInAdditionalDoc(
  	            nextDocs,
  	            getDeep(doc, ["Slot"], 0),
  	            doc
  	          );
  	        });
  	
  	        var patch = {
  	          objectId: getDeep(item, ["objectId"], null),
  	          Docs: fuelInDocsPayload(nextDocs)
  	        };
  	
  	        try {
  	          var savedPatch = await saveTableRow("FuelIn", patch);
  	          return {
  	            item: Object.assign({}, item, patch, savedPatch || {}),
  	            uploadedCount: uploadedDocs.length,
  	            warnings: warnings
  	          };
  	        } catch (patchError) {
  	          for (var cleanupIndex = 0; cleanupIndex < uploadedUrls.length; cleanupIndex++) {
  	            try {
  	              await deleteFuelInDocumentUrl(uploadedUrls[cleanupIndex]);
  	            } catch (cleanupError) {
  	              console.error("Initial additional FuelIn document cleanup failed:", cleanupError);
  	            }
  	          }
  	
  	          warnings.push(
  	            "Additional documents could not be linked to FuelIn.Docs: " +
  	            (patchError && patchError.message
  	              ? patchError.message
  	              : "Docs save failed")
  	          );
  	
  	          return {
  	            item: item,
  	            uploadedCount: 0,
  	            warnings: warnings
  	          };
  	        }
  	      }
  	
  	      async function attachFuelDocumentToSavedDelivery(item, file) {
  	        validateFuelDocument(file);
  	
  	        var objectId = getDeep(item, ["objectId"], null);
  	        if (!objectId) {
  	          throw new Error("This delivery has no objectId and cannot accept a document.");
  	        }
  	
  	        var previousUrl = text(getDeep(item, ["DocumentURL"], ""), "");
  	        var uploaded = await uploadFuelInDocument(file, objectId);
  	        var patch = {
  	          objectId: objectId,
  	          DocumentURL: text(uploaded.documentUrl, ""),
  	          DocumentKey: text(uploaded.documentKey, ""),
  	          DocumentName: text(uploaded.documentName, String(file.name || "document"))
  	        };
  	        var savedPatch;
  	
  	        try {
  	          savedPatch = await saveTableRow("FuelIn", patch);
  	        } catch (patchError) {
  	          try {
  	            if (uploaded.documentUrl) {
  	              await deleteFuelInDocumentUrl(uploaded.documentUrl);
  	            }
  	          } catch (cleanupError) {
  	            console.error("New FuelIn document cleanup failed:", cleanupError);
  	          }
  	          throw patchError;
  	        }
  	
  	        var updated = Object.assign({}, item, patch, savedPatch || {});
  	        updateCorrectedDeliveryLocally(
  	          updated,
  	          findViewContainingDelivery(item)
  	        );
  	
  	        if (previousUrl && previousUrl !== patch.DocumentURL) {
  	          try {
  	            await deleteFuelInDocumentUrl(previousUrl);
  	          } catch (oldDeleteError) {
  	            console.error("Previous FuelIn document cleanup failed:", oldDeleteError);
  	          }
  	        }
  	
  	        return updated;
  	      }
  	
  	      async function removeFuelDocumentFromSavedDelivery(item) {
  	        var objectId = getDeep(item, ["objectId"], null);
  	        if (!objectId) {
  	          throw new Error("This delivery has no objectId and cannot be updated.");
  	        }
  	
  	        var previousUrl = text(getDeep(item, ["DocumentURL"], ""), "");
  	        var patch = {
  	          objectId: objectId,
  	          DocumentURL: null,
  	          DocumentKey: null,
  	          DocumentName: null
  	        };
  	        var savedPatch = await saveTableRow("FuelIn", patch);
  	        var updated = Object.assign({}, item, patch, savedPatch || {});
  	
  	        updateCorrectedDeliveryLocally(
  	          updated,
  	          findViewContainingDelivery(item)
  	        );
  	
  	        if (previousUrl) {
  	          try {
  	            await deleteFuelInDocumentUrl(previousUrl);
  	          } catch (deleteError) {
  	            console.error("Removed FuelIn document cleanup failed:", deleteError);
  	          }
  	        }
  	
  	        return updated;
  	      }
  	
  	      function addRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          return Promise.reject(new Error("Backendless SDK is not available"));
  	        }
  	
  	        if (!parentObjectId) return Promise.resolve(null);
  	
  	        var ids = toArray(childObjectIds).filter(function (id) {
  	          return !!id;
  	        });
  	
  	        return backendless.Data.of(tableName).addRelation(
  	          { objectId: parentObjectId },
  	          relationName,
  	          ids
  	        );
  	      }
  	
  	      function setRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          return Promise.reject(new Error("Backendless SDK is not available"));
  	        }
  	
  	        if (!parentObjectId) return Promise.resolve(null);
  	
  	        var ids = toArray(childObjectIds).filter(function (id) {
  	          return !!id;
  	        });
  	        var api = backendless.Data.of(tableName);
  	
  	        if (!api || typeof api.setRelation !== "function") {
  	          return Promise.reject(
  	            new Error("Backendless setRelation is unavailable for " + tableName + "." + relationName)
  	          );
  	        }
  	
  	        return api.setRelation(
  	          { objectId: parentObjectId },
  	          relationName,
  	          ids
  	        );
  	      }
  	
  	      function loadTableRow(tableName, objectId, relations) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          return Promise.reject(new Error("Backendless SDK is not available"));
  	        }
  	
  	        if (!objectId) return Promise.resolve(null);
  	
  	        var builder = backendless.DataQueryBuilder
  	          ? backendless.DataQueryBuilder.create()
  	          : null;
  	
  	        if (builder && relations && relations.length && typeof builder.setRelated === "function") {
  	          builder.setRelated(relations);
  	        }
  	        if (builder && typeof builder.setRelationsPageSize === "function") {
  	          builder.setRelationsPageSize(100);
  	        }
  	
  	        return backendless.Data.of(tableName).findById(
  	          objectId,
  	          builder || undefined
  	        );
  	      }
  	
  	      /*
  	       * Load a relation through Backendless' relation paging API.
  	       *
  	       * This is deliberately used instead of a FuelIn where-clause such as
  	       * `Tank.objectId = ...`. The current FuelIn schema does not expose that
  	       * related property, so those queries return HTTP 400.
  	       */
  	      async function loadRelationRows(parentTable, parentObjectId, relationName) {
  	        if (!parentObjectId || !relationName) return [];
  	
  	        if (
  	          !backendless ||
  	          !backendless.Data ||
  	          !backendless.Data.of ||
  	          !backendless.LoadRelationsQueryBuilder
  	        ) {
  	          return [];
  	        }
  	
  	        var api = backendless.Data.of(parentTable);
  	        if (!api || typeof api.loadRelations !== "function") return [];
  	
  	        var builder = backendless.LoadRelationsQueryBuilder.create();
  	        builder.setRelationName(relationName);
  	
  	        if (typeof builder.setPageSize === "function") {
  	          builder.setPageSize(100);
  	        }
  	
  	        var result = [];
  	        var safety = 0;
  	
  	        while (safety < 100) {
  	          safety++;
  	
  	          var page = await api.loadRelations(parentObjectId, builder);
  	          var rows = Array.isArray(page)
  	            ? page
  	            : toArray(page && page.data ? page.data : []);
  	
  	          result = result.concat(rows);
  	
  	          if (rows.length < 100) break;
  	
  	          if (typeof builder.prepareNextPage === "function") {
  	            builder.prepareNextPage();
  	          } else if (typeof builder.setOffset === "function") {
  	            builder.setOffset(result.length);
  	          } else {
  	            break;
  	          }
  	        }
  	
  	        return result;
  	      }
  	
  	      function deliveryEscapeWhere(value) {
  	        return String(value === null || value === undefined ? "" : value)
  	          .replace(/\\/g, "\\\\")
  	          .replace(/'/g, "\\'");
  	      }
  	
  	      async function findTableRows(tableName, whereClause, relations) {
  	        if (!backendless || !backendless.Data || !backendless.Data.of) {
  	          throw new Error("Backendless SDK is not available");
  	        }
  	
  	        var allRows = [];
  	        var offset = 0;
  	        var pageSize = 100;
  	        var safety = 0;
  	
  	        while (safety < 100) {
  	          safety++;
  	
  	          var builder = backendless.DataQueryBuilder
  	            ? backendless.DataQueryBuilder.create()
  	            : null;
  	
  	          if (builder) {
  	            if (whereClause && typeof builder.setWhereClause === "function") {
  	              builder.setWhereClause(whereClause);
  	            }
  	            if (relations && relations.length && typeof builder.setRelated === "function") {
  	              builder.setRelated(relations);
  	            }
  	            if (typeof builder.setPageSize === "function") {
  	              builder.setPageSize(pageSize);
  	            }
  	            if (typeof builder.setOffset === "function") {
  	              builder.setOffset(offset);
  	            }
  	            if (typeof builder.setSortBy === "function") {
  	              builder.setSortBy(["FuelDate DESC", "created DESC"]);
  	            }
  	          }
  	
  	          var response = await backendless.Data.of(tableName).find(builder || undefined);
  	          var rows = Array.isArray(response)
  	            ? response
  	            : toArray(response && response.data ? response.data : []);
  	
  	          allRows = allRows.concat(rows);
  	
  	          if (rows.length < pageSize) break;
  	          offset += pageSize;
  	        }
  	
  	        return allRows;
  	      }
  	
  	      function deliveryBusinessDate(value) {
  	        var date = value ? new Date(value) : new Date();
  	        if (isNaN(date.getTime())) date = new Date();
  	
  	        // The application operates in South Africa (UTC+02:00).
  	        return new Date(date.getTime() + (120 * 60000));
  	      }
  	
  	      function deliveryMonthKey(value) {
  	        var date = deliveryBusinessDate(value);
  	        return date.getUTCFullYear() + "-" + pad2(date.getUTCMonth() + 1);
  	      }
  	
  	      function deliveryMonthLabelFromKey(key) {
  	        var match = String(key || "").match(/^(\d{4})-(\d{2})$/);
  	        if (!match) return String(key || "Unknown month");
  	
  	        var names = [
  	          "January", "February", "March", "April", "May", "June",
  	          "July", "August", "September", "October", "November", "December"
  	        ];
  	        var monthIndex = Math.max(0, Math.min(11, Number(match[2]) - 1));
  	        return names[monthIndex] + " " + match[1];
  	      }
  	
  	      function deliveryMonthStartMs(key) {
  	        var match = String(key || "").match(/^(\d{4})-(\d{2})$/);
  	        if (!match) return Date.now();
  	        return Date.UTC(Number(match[1]), Number(match[2]) - 1, 1, 0, 0, 0, 0);
  	      }
  	
  	      function deliveryMonthEndMs(key) {
  	        var match = String(key || "").match(/^(\d{4})-(\d{2})$/);
  	        if (!match) return Date.now();
  	        return Date.UTC(Number(match[1]), Number(match[2]), 1, 0, 0, 0, 0) - 1;
  	      }
  	
  	      function getFuelInMonthKey(item) {
  	        return deliveryMonthKey(
  	          firstDefined(
  	            getDeep(item, ["FuelDate"], null),
  	            getDeep(item, ["created"], null),
  	            getDeep(item, ["updated"], null),
  	            getNowIso()
  	          )
  	        );
  	      }
  	
  	      function getTankViewMonthKey(view) {
  	        var explicit = text(getDeep(view, ["MYearKey"], ""), "").trim();
  	        if (/^\d{4}-\d{2}$/.test(explicit)) return explicit;
  	
  	        var dateStart = getDeep(view, ["DateStart"], null);
  	        if (dateStart !== null && dateStart !== undefined && dateStart !== "") {
  	          return deliveryMonthKey(dateStart);
  	        }
  	
  	        var label = text(getDeep(view, ["MYear"], ""), "").trim();
  	        if (label) {
  	          var parsed = new Date("1 " + label + " 12:00:00");
  	          if (!isNaN(parsed.getTime())) return deliveryMonthKey(parsed);
  	        }
  	
  	        return "";
  	      }
  	
  	      function getTankCurrentView(targetTank) {
  	        return firstDefined(
  	          getDeep(targetTank, ["ViewC"], null),
  	          getDeep(targetTank, ["TankView", "ViewC"], null),
  	          null
  	        );
  	      }
  	
  	      function getTankHistoryViews(targetTank) {
  	        return toArray(firstDefined(
  	          getDeep(targetTank, ["ViewH"], null),
  	          getDeep(targetTank, ["TankView", "ViewH"], null),
  	          []
  	        ));
  	      }
  	
  	      function getAllTankViewCandidates(targetTank) {
  	        var rows = [];
  	        var current = getTankCurrentView(targetTank);
  	        if (current) rows.push(current);
  	        rows = rows.concat(getTankHistoryViews(targetTank));
  	
  	        var legacyTankView = getDeep(targetTank, ["TankView"], null);
  	        if (Array.isArray(legacyTankView)) {
  	          rows = rows.concat(legacyTankView);
  	        }
  	
  	        var seen = {};
  	        return rows.filter(function (view) {
  	          if (!view) return false;
  	          var id = text(getDeep(view, ["objectId"], ""), "");
  	          var key = id || (getTankViewMonthKey(view) + "::" + rows.indexOf(view));
  	          if (seen[key]) return false;
  	          seen[key] = true;
  	          return true;
  	        });
  	      }
  	
  	      function applyTankViewState(targetTank, currentView, historyViews) {
  	        if (!targetTank) return;
  	
  	        targetTank.ViewC = currentView || null;
  	        targetTank.ViewH = toArray(historyViews);
  	
  	        var nested = getDeep(targetTank, ["TankView"], null);
  	        if (!nested || (!Array.isArray(nested) && typeof nested === "object")) {
  	          if (!nested || Array.isArray(nested)) nested = {};
  	          nested.ViewC = currentView || null;
  	          nested.ViewH = toArray(historyViews);
  	          targetTank.TankView = nested;
  	        }
  	      }
  	
  	      function uniqueRowsByObjectId(rows) {
  	        var result = [];
  	        var seen = {};
  	
  	        toArray(rows).forEach(function (row) {
  	          if (!row) return;
  	          var id = text(getDeep(row, ["objectId"], ""), "");
  	          var fallback = [
  	            getDeep(row, ["FuelDate"], ""),
  	            getDeep(row, ["ReferenceNo"], ""),
  	            getDeep(row, ["Supplier"], ""),
  	            getDeep(row, ["Litres"], ""),
  	            getDeep(row, ["Cost"], "")
  	          ].join("::");
  	          var key = id || fallback;
  	          if (!key || seen[key]) return;
  	          seen[key] = true;
  	          result.push(row);
  	        });
  	
  	        return result;
  	      }
  	
  	      function buildTankViewTotals(deliveries) {
  	        var rows = toArray(deliveries);
  	        var litres = 0;
  	
  	        rows.forEach(function (item) {
  	          litres += toNumber(getDeep(item, ["Litres"], 0), 0);
  	        });
  	
  	        var latestCostPerLitre = Math.max(
  	          0,
  	          managerLatestCostPerLitre({ FuelIn: rows })
  	        );
  	
  	        return {
  	          litres: litres,
  	          latestCostPerLitre: latestCostPerLitre,
  	          cost: roundMoney2(litres * latestCostPerLitre)
  	        };
  	      }
  	
  	      function findTankViewByMonth(currentView, historyViews, monthKey) {
  	        if (
  	          currentView &&
  	          getTankViewMonthKey(currentView) === monthKey
  	        ) {
  	          return currentView;
  	        }
  	
  	        var history = toArray(historyViews);
  	
  	        for (var index = 0; index < history.length; index++) {
  	          if (getTankViewMonthKey(history[index]) === monthKey) {
  	            return history[index];
  	          }
  	        }
  	
  	        return null;
  	      }
  	
  	      function mergeSavedDeliveryIntoLocalView(view, savedFuelIn) {
  	        if (!view || !savedFuelIn) return view;
  	
  	        view.FuelIn = uniqueRowsByObjectId(
  	          toArray(getDeep(view, ["FuelIn"], [])).concat([savedFuelIn])
  	        );
  	
  	        var totals = buildTankViewTotals(view.FuelIn);
  	        view.Litres = totals.litres;
  	        view.Cost = roundMoney2(
  	          totals.cost
  	        );
  	
  	        return view;
  	      }
  	
  	      async function linkSavedDeliveryToTankView(savedFuelIn) {
  	        var savedFuelInId = getDeep(savedFuelIn, ["objectId"], null);
  	        var tankId = getDeep(tank, ["objectId"], null);
  	
  	        if (!savedFuelInId) {
  	          throw new Error("The saved FuelIn record has no objectId.");
  	        }
  	
  	        if (!tankId) {
  	          throw new Error("The selected tank has no objectId.");
  	        }
  	
  	        var deliveryViewMonthKey = getFuelInMonthKey(savedFuelIn);
  	        var currentCalendarMonthKey = deliveryMonthKey(getNowIso());
  	        var currentView = getTankCurrentView(tank);
  	        var historyViews = getTankHistoryViews(tank);
  	        var targetView = findTankViewByMonth(
  	          currentView,
  	          historyViews,
  	          deliveryViewMonthKey
  	        );
  	        var createdNewView = false;
  	
  	        if (!targetView) {
  	          var newViewRows = [savedFuelIn];
  	          var newViewTotals = buildTankViewTotals(newViewRows);
  	
  	          targetView = await saveTableRow("TankView", {
  	            ___class: "TankView",
  	            MYearKey: deliveryViewMonthKey,
  	            DateStart: deliveryMonthStartMs(deliveryViewMonthKey),
  	            DateEnd: deliveryMonthEndMs(deliveryViewMonthKey),
  	            Litres: newViewTotals.litres,
  	            Cost: newViewTotals.cost
  	          });
  	
  	          if (!getDeep(targetView, ["objectId"], null)) {
  	            throw new Error(
  	              "Backendless did not return an objectId for the new TankView."
  	            );
  	          }
  	
  	          targetView.MYearKey = deliveryViewMonthKey;
  	          targetView.MYear = text(
  	            getDeep(targetView, ["MYear"], ""),
  	            deliveryMonthLabelFromKey(deliveryViewMonthKey)
  	          );
  	          targetView.DateStart = deliveryMonthStartMs(deliveryViewMonthKey);
  	          targetView.DateEnd = deliveryMonthEndMs(deliveryViewMonthKey);
  	          targetView.FuelIn = newViewRows;
  	          targetView.Litres = newViewTotals.litres;
  	          targetView.Cost = roundMoney2(
  	            newViewTotals.cost
  	          );
  	          createdNewView = true;
  	        } else {
  	          mergeSavedDeliveryIntoLocalView(targetView, savedFuelIn);
  	
  	          targetView = Object.assign(
  	            targetView,
  	            await saveTableRow("TankView", {
  	              objectId: getDeep(targetView, ["objectId"], null),
  	              Litres: toNumber(getDeep(targetView, ["Litres"], 0), 0),
  	              Cost: roundMoney2(
  	                toNumber(
  	                  getDeep(targetView, ["Cost"], 0),
  	                  0
  	                )
  	              )
  	            })
  	          );
  	
  	          targetView.MYearKey = deliveryViewMonthKey;
  	          targetView.MYear = text(
  	            getDeep(targetView, ["MYear"], ""),
  	            deliveryMonthLabelFromKey(deliveryViewMonthKey)
  	          );
  	          mergeSavedDeliveryIntoLocalView(targetView, savedFuelIn);
  	        }
  	
  	        await addRelation(
  	          "TankView",
  	          getDeep(targetView, ["objectId"], null),
  	          "FuelIn",
  	          [savedFuelInId]
  	        );
  	
  	        if (createdNewView) {
  	          if (deliveryViewMonthKey === currentCalendarMonthKey) {
  	            var oldCurrentId = getDeep(currentView, ["objectId"], null);
  	            var targetViewId = getDeep(targetView, ["objectId"], null);
  	
  	            if (oldCurrentId && oldCurrentId !== targetViewId) {
  	              var alreadyHistorical = historyViews.some(function (view) {
  	                return getDeep(view, ["objectId"], null) === oldCurrentId;
  	              });
  	
  	              if (!alreadyHistorical) {
  	                await addRelation(
  	                  "Tanks",
  	                  tankId,
  	                  "ViewH",
  	                  [oldCurrentId]
  	                );
  	                historyViews.unshift(currentView);
  	              }
  	            }
  	
  	            await setRelation(
  	              "Tanks",
  	              tankId,
  	              "ViewC",
  	              [targetViewId]
  	            );
  	
  	            currentView = targetView;
  	          } else {
  	            await addRelation(
  	              "Tanks",
  	              tankId,
  	              "ViewH",
  	              [getDeep(targetView, ["objectId"], null)]
  	            );
  	
  	            historyViews.push(targetView);
  	          }
  	        }
  	
  	        historyViews = uniqueRowsByObjectId(historyViews)
  	          .filter(function (view) {
  	            return getDeep(view, ["objectId"], null) !==
  	              getDeep(currentView, ["objectId"], null);
  	          })
  	          .sort(function (a, b) {
  	            return getTankViewMonthKey(b).localeCompare(
  	              getTankViewMonthKey(a)
  	            );
  	          });
  	
  	        tank.FuelIn = uniqueRowsByObjectId(
  	          toArray(getDeep(tank, ["FuelIn"], [])).concat([savedFuelIn])
  	        );
  	
  	        applyTankViewState(tank, currentView, historyViews);
  	
  	        return {
  	          currentView: currentView,
  	          historyViews: historyViews,
  	          targetView: targetView,
  	          allDeliveries: uniqueRowsByObjectId(
  	            toArray(getDeep(tank, ["FuelIn"], []))
  	              .concat(
  	                currentView
  	                  ? toArray(getDeep(currentView, ["FuelIn"], []))
  	                  : []
  	              )
  	              .concat(
  	                historyViews.reduce(function (rows, view) {
  	                  return rows.concat(
  	                    toArray(getDeep(view, ["FuelIn"], []))
  	                  );
  	                }, [])
  	              )
  	          ),
  	          monthKey: deliveryViewMonthKey
  	        };
  	      }
  	
  	      function setButtonBusy(button, isBusy, label) {
  	        if (!button) return;
  	        button.disabled = !!isBusy;
  	        button.style.opacity = isBusy ? "0.7": "1";
  	        button.style.cursor = isBusy ? "wait": "pointer";
  	        if (label) button.textContent = label;
  	      }
  	
  	      function renderTankGauge(gaugeHost, targetTank) {
  	        try {
  	          if (!gaugeHost || !targetTank) return;
  	
  	          var hostEl = null;
  	
  	          if (gaugeHost.el) {
  	            hostEl = gaugeHost.el;
  	          } else if (typeof HTMLElement !== "undefined" && gaugeHost instanceof HTMLElement) {
  	            hostEl = gaugeHost;
  	          }
  	
  	          if (!hostEl) {
  	            console.log("TankBlock does not contain a usable DOM element");
  	            console.log(gaugeHost);
  	            return;
  	          }
  	
  	          var level = Number(targetTank.Level);
  	          if (isNaN(level)) level = 0;
  	          if (level < 0) level = 0;
  	          if (level > 100) level = 100;
  	
  	          var grade = targetTank.Grade || "Tank";
  	          var liquidColor = targetTank.Color || "#22c55e";
  	
  	          var uid = "tank_" + (targetTank.objectId || Math.random().toString(36).slice(2));
  	
  	          var cx = 50;
  	          var cy = 50;
  	          var outerR = 45;
  	          var innerR = 37;
  	
  	          var liquidTopY = cy + innerR - ((level / 100) * (innerR * 2));
  	          var liquidHeight = (cy + innerR) - liquidTopY;
  	
  	          var levelText = Math.round(level) + "%";
  	
  	          hostEl.innerHTML = ""
  	          + '<svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" style="display:block;overflow:visible;">'
  	          + "  <defs>"
  	          + '    <radialGradient id="' + uid + '_shell" cx="35%" cy="30%" r="75%">'
  	          + '      <stop offset="0%" stop-color="#f8fafc"></stop>'
  	          + '      <stop offset="45%" stop-color="#d1d5db"></stop>'
  	          + '      <stop offset="75%" stop-color="#9ca3af"></stop>'
  	          + '      <stop offset="100%" stop-color="#6b7280"></stop>'
  	          + "    </radialGradient>"
  	          + '    <radialGradient id="' + uid + '_inner" cx="35%" cy="30%" r="80%">'
  	          + '      <stop offset="0%" stop-color="#f3f4f6"></stop>'
  	          + '      <stop offset="100%" stop-color="#d1d5db"></stop>'
  	          + "    </radialGradient>"
  	          + '    <linearGradient id="' + uid + '_glass" x1="0" y1="0" x2="1" y2="1">'
  	          + '      <stop offset="0%" stop-color="#ffffff" stop-opacity="0.24"></stop>'
  	          + '      <stop offset="100%" stop-color="#ffffff" stop-opacity="0.05"></stop>'
  	          + "    </linearGradient>"
  	          + '    <clipPath id="' + uid + '_liquidClip">'
  	          + '      <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '"></circle>'
  	          + "    </clipPath>"
  	          + "  </defs>"
  	          + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + outerR + '" fill="url(#' + uid + '_shell)"></circle>'
  	          + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_inner)"></circle>'
  	          + '  <g clip-path="url(#' + uid + '_liquidClip)">'
  	          + '    <rect x="' + (cx - innerR) + '" y="' + liquidTopY + '" width="' + (innerR * 2) + '" height="' + liquidHeight + '" fill="' + liquidColor + '"></rect>'
  	          + '    <rect x="' + (cx - innerR + 5) + '" y="' + liquidTopY + '" width="' + ((innerR * 2) - 10) + '" height="2.4" rx="1.2" fill="#ffffff" opacity="0.18"></rect>'
  	          + "  </g>"
  	          + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_glass)"></circle>'
  	          + '  <ellipse cx="' + (cx - 10) + '" cy="' + (cy - 9) + '" rx="10" ry="20" fill="#ffffff" opacity="0.12"></ellipse>'
  	          + '  <text x="' + cx + '" y="' + (cy + 1) + '" text-anchor="middle" font-size="15" font-weight="700" fill="#0f172a">' + levelText + "</text>"
  	          + '  <text x="' + cx + '" y="' + (cy + 13) + '" text-anchor="middle" font-size="6.5" font-weight="600" fill="#334155">' + escapeHtml(grade) + "</text>"
  	          + "</svg>";
  	        } catch (gaugeErr) {
  	          console.log("Tank gauge render error:", gaugeErr);
  	        }
  	      }
  	
  	      function appendFuelInOnce(targetObj, savedFuelIn) {
  	        if (!targetObj || !savedFuelIn || !getDeep(savedFuelIn, ["objectId"], null)) return;
  	
  	        targetObj.FuelIn = toArray(targetObj.FuelIn);
  	
  	        var savedFuelInId = String(getDeep(savedFuelIn, ["objectId"], ""));
  	        var alreadyExists = false;
  	
  	        for (var i = 0; i < targetObj.FuelIn.length; i++) {
  	          if (String(getDeep(targetObj.FuelIn[i], ["objectId"], "")) === savedFuelInId) {
  	            alreadyExists = true;
  	            break;
  	          }
  	        }
  	
  	        if (!alreadyExists) {
  	          targetObj.FuelIn.unshift(savedFuelIn);
  	        }
  	      }
  	
  	      function updateTankForLiveUi(existingTankObj, updatedTankObj, savedFuelIn) {
  	        if (!existingTankObj || !updatedTankObj) return existingTankObj;
  	
  	        if (getDeep(updatedTankObj, ["Volume"], null) !== null) {
  	          existingTankObj.Volume = updatedTankObj.Volume;
  	        }
  	
  	        if (getDeep(updatedTankObj, ["Level"], null) !== null) {
  	          existingTankObj.Level = updatedTankObj.Level;
  	        }
  	
  	        if (getDeep(updatedTankObj, ["ViewC"], null) !== null) {
  	          existingTankObj.ViewC = deepClone(updatedTankObj.ViewC);
  	        }
  	
  	        if (getDeep(updatedTankObj, ["ViewH"], null) !== null) {
  	          existingTankObj.ViewH = deepClone(updatedTankObj.ViewH);
  	        }
  	
  	        if (getDeep(updatedTankObj, ["TankView"], null) !== null) {
  	          existingTankObj.TankView = deepClone(updatedTankObj.TankView);
  	        }
  	
  	        if (Array.isArray(getDeep(updatedTankObj, ["FuelIn"], null))) {
  	          existingTankObj.FuelIn = deepClone(updatedTankObj.FuelIn);
  	        }
  	
  	        var latestCostPerLitre = toNumber(
  	          getDeep(updatedTankObj, ["LatestCostPerLitre"], NaN),
  	          NaN
  	        );
  	
  	        if (!isNaN(latestCostPerLitre) && latestCostPerLitre >= 0) {
  	          existingTankObj.LatestCostPerLitre = latestCostPerLitre;
  	        }
  	
  	        appendFuelInOnce(existingTankObj, savedFuelIn);
  	
  	        // Do not touch existingTankObj.Bowsers.
  	        // The repeater needs the original nested bowser/pump list preserved.
  	
  	        return existingTankObj;
  	      }
  	
  	      function replaceNestedCompanyTank(companyObj, tankObj, savedFuelIn) {
  	        var tanks = toArray(getDeep(companyObj, ["Tanks"], []));
  	        var tIndex = findIndexByKeys(tanks, tankObj);
  	
  	        if (tIndex >= 0) {
  	          updateTankForLiveUi(tanks[tIndex], tankObj, savedFuelIn);
  	          companyObj.Tanks = tanks;
  	        }
  	      }
  	
  	      function getAppDataRoot() {
  	        if (appData && typeof appData === "object") return appData;
  	        if (typeof AppData !== "undefined" && AppData && typeof AppData === "object") return AppData;
  	        return null;
  	      }
  	
  	      function getUserCompaniesFromAppData() {
  	        return toArray(getDeep(getAppDataRoot(), ["User", "Companies"], []));
  	      }
  	
  	      function syncTankIntoLiveAppData(updatedTankObj, savedFuelIn) {
  	        if (!updatedTankObj || !getDeep(updatedTankObj, ["objectId"], null)) return false;
  	
  	        var companies = getUserCompaniesFromAppData();
  	        var tankObjectId = String(getDeep(updatedTankObj, ["objectId"], ""));
  	
  	        for (var c = 0; c < companies.length; c++) {
  	          var companyTanks = toArray(getDeep(companies[c], ["Tanks"], []));
  	
  	          for (var i = 0; i < companyTanks.length; i++) {
  	            if (String(getDeep(companyTanks[i], ["objectId"], "")) === tankObjectId) {
  	              updateTankForLiveUi(companyTanks[i], updatedTankObj, savedFuelIn);
  	              companies[c].Tanks = companyTanks;
  	              return true;
  	            }
  	          }
  	        }
  	
  	        return false;
  	      }
  	
  	      function tankViewToken(kind, view) {
  	        var id = text(getDeep(view, ["objectId"], ""), "");
  	        var key = getTankViewMonthKey(view);
  	        return String(kind || "VIEW") + "::" + (id || key || "UNKNOWN");
  	      }
  	
  	      function tankViewDisplayLabel(view) {
  	        var key = getTankViewMonthKey(view);
  	        return text(
  	          getDeep(view, ["MYear"], ""),
  	          deliveryMonthLabelFromKey(key)
  	        );
  	      }
  	
  	      function getTankViewOptions() {
  	        var options = [];
  	
  	        if (state.currentView) {
  	          options.push({
  	            token: tankViewToken("VIEWC", state.currentView),
  	            kind: "current",
  	            view: state.currentView,
  	            label: "Current | " + tankViewDisplayLabel(state.currentView)
  	          });
  	        }
  	
  	        toArray(state.historyViews)
  	          .slice()
  	          .sort(function (a, b) {
  	            return getTankViewMonthKey(b).localeCompare(getTankViewMonthKey(a));
  	          })
  	          .forEach(function (view) {
  	            options.push({
  	              token: tankViewToken("VIEWH", view),
  	              kind: "history",
  	              view: view,
  	              label: "History | " + tankViewDisplayLabel(view)
  	            });
  	          });
  	
  	        return options;
  	      }
  	
  	      function getSelectedTankViewMeta() {
  	        var options = getTankViewOptions();
  	        var token = String(state.selectedViewToken || "");
  	
  	        for (var index = 0; index < options.length; index++) {
  	          if (options[index].token === token) return options[index];
  	        }
  	
  	        return options.length ? options[0] : null;
  	      }
  	
  	      function refreshTankViewSelector(preferredMonthKey) {
  	        var selector = document.getElementById("fuel-delivery-view-selector");
  	        if (!selector) return;
  	
  	        var options = getTankViewOptions();
  	        var preferredToken = "";
  	
  	        if (preferredMonthKey) {
  	          for (var preferredIndex = 0; preferredIndex < options.length; preferredIndex++) {
  	            if (getTankViewMonthKey(options[preferredIndex].view) === preferredMonthKey) {
  	              preferredToken = options[preferredIndex].token;
  	              break;
  	            }
  	          }
  	        }
  	
  	        var wanted = preferredToken || state.selectedViewToken;
  	        var html = "";
  	
  	        for (var index = 0; index < options.length; index++) {
  	          html += '<option value="' + escapeHtml(options[index].token) + '">' +
  	            escapeHtml(options[index].label) + '</option>';
  	        }
  	
  	        if (!html) {
  	          html = '<option value="">No monthly views</option>';
  	        }
  	
  	        selector.innerHTML = html;
  	
  	        var validWanted = options.some(function (option) {
  	          return option.token === wanted;
  	        });
  	
  	        if (!validWanted && options.length) wanted = options[0].token;
  	
  	        selector.value = wanted || "";
  	        state.selectedViewToken = selector.value;
  	        managerRefreshThemedSelect(selector);
  	      }
  	
  	      function setTankViewStatus(message, isError) {
  	        var node = document.getElementById("fuel-delivery-view-status");
  	        if (!node) return;
  	        node.textContent = message || "";
  	        node.style.color = isError ? "#ff8c8c" : "#94a3b8";
  	      }
  	
  	      function renderSelectedTankView() {
  	        var meta = getSelectedTankViewMeta();
  	        var deliveries = meta
  	          ? toArray(getDeep(meta.view, ["FuelIn"], []))
  	          : [];
  	
  	        state.deliveryCache = deliveries.slice();
  	        state.selectedViewToken = meta ? meta.token : "";
  	
  	        var selector = document.getElementById("fuel-delivery-view-selector");
  	        if (selector && selector.value !== state.selectedViewToken) {
  	          selector.value = state.selectedViewToken;
  	          managerRefreshThemedSelect(selector);
  	        }
  	
  	        applyDeliverySearch();
  	      }
  	
  	      function getDeliveryTankName(item) {
  	        var relatedTank = getDeep(item, ["Tank"], null);
  	
  	        return text(
  	          getDeep(relatedTank, ["Name"], null) ||
  	          getDeep(relatedTank, ["TankName"], null) ||
  	          getDeep(relatedTank, ["Grade"], null) ||
  	          getDeep(item, ["TankName"], null) ||
  	          getDeep(item, ["TankGrade"], null) ||
  	          getDeep(tank, ["Name"], null) ||
  	          getDeep(tank, ["TankName"], null) ||
  	          getDeep(tank, ["Grade"], null),
  	          "Tank"
  	        );
  	      }
  	
  	      function getDeliverySortDate(item) {
  	        var raw = firstDefined(
  	          getDeep(item, ["FuelDate"], null),
  	          getDeep(item, ["created"], null),
  	          getDeep(item, ["updated"], null)
  	        );
  	        var parsed = new Date(raw || 0).getTime();
  	        return isNaN(parsed) ? 0: parsed;
  	      }
  	
  	      function getDeliverySortName(item) {
  	        return String(
  	          getDeep(item, ["Supplier"], "") ||
  	          getDeliveryTankName(item) ||
  	          getDeep(item, ["ReferenceNo"], "") ||
  	          ""
  	        ).toLowerCase();
  	      }
  	
  	      function getDeliverySortValue(item, key) {
  	        if (key === "name") {
  	          return getDeliverySortName(item);
  	        }
  	
  	        if (key === "tank") {
  	          return String(getDeliveryTankName(item) || "").toLowerCase();
  	        }
  	
  	        if (key === "litres") {
  	          return toNumber(getDeep(item, ["Litres"], 0), 0);
  	        }
  	
  	        if (key === "cost") {
  	          return toNumber(getDeep(item, ["Cost"], 0), 0);
  	        }
  	
  	        if (key === "costPerLitre") {
  	          var explicitCostPerLitre = toNumber(
  	            getDeep(item, ["CostPerLitre"], NaN),
  	            NaN
  	          );
  	
  	          if (!isNaN(explicitCostPerLitre)) {
  	            return explicitCostPerLitre;
  	          }
  	
  	          var litres = toNumber(getDeep(item, ["Litres"], 0), 0);
  	          var cost = toNumber(getDeep(item, ["Cost"], 0), 0);
  	          return litres > 0 ? cost / litres: 0;
  	        }
  	
  	        return getDeliverySortDate(item);
  	      }
  	
  	      function sortDeliveryRows(items) {
  	        var key = state && state.sortKey ? state.sortKey: "date";
  	        var direction = state && state.sortDirection === "asc" ? 1: -1;
  	        var rows = toArray(items).slice();
  	
  	        rows.sort(function (a, b) {
  	          var left = getDeliverySortValue(a, key);
  	          var right = getDeliverySortValue(b, key);
  	
  	          if (key === "name" || key === "tank") {
  	            return String(left).localeCompare(
  	              String(right),
  	              undefined,
  	              { numeric: true, sensitivity: "base" }
  	            ) * direction;
  	          }
  	
  	          if (left === right) {
  	            var dateDifference = getDeliverySortDate(a) - getDeliverySortDate(b);
  	            if (dateDifference !== 0) return dateDifference * direction;
  	
  	            return getDeliverySortName(a).localeCompare(
  	              getDeliverySortName(b),
  	              undefined,
  	              { numeric: true, sensitivity: "base" }
  	            );
  	          }
  	
  	          return (left < right ? -1: 1) * direction;
  	        });
  	
  	        return rows;
  	      }
  	
  	      function buildDeliverySearchIndex(item) {
  	        var parts = [
  	          getDeep(item, ["FuelDate"], ""),
  	          getDeliveryTankName(item),
  	          getDeep(item, ["Supplier"], ""),
  	          getDeep(item, ["ReferenceNo"], ""),
  	          getDeep(item, ["Description"], ""),
  	          getDeep(item, ["DocumentName"], ""),
  	          fuelInAdditionalDocs(item).map(function (doc) {
  	            return getDeep(doc, ["Name"], "");
  	          }).join(" "),
  	          getDeep(item, ["Litres"], ""),
  	          getDeep(item, ["Cost"], ""),
  	          getDeep(item, ["CostPerLitre"], ""),
  	          getDeep(item, ["VolumeBefore"], ""),
  	          getDeep(item, ["VolumeAfter"], ""),
  	          getDeep(item, ["objectId"], "")
  	        ];
  	        return parts.join(" ").toLowerCase();
  	      }
  	
  	      function buildDetailRow(label, value) {
  	        return ""
  	        + '<div style="display:grid;grid-template-columns:150px 1fr;gap:10px;padding:7px 0;border-bottom:1px solid rgba(255,255,255,0.06);">'
  	        + '<div style="font-size:11px;color:#94a3b8;">' + escapeHtml(label) + "</div>"
  	        + '<div style="font-size:12px;color:#f8fafc;word-break:break-word;">' + escapeHtml(text(value, "")) + "</div>"
  	        + "</div>";
  	      }
  	
  	      function getVisibleTotals(deliveries) {
  	        var arr = toArray(deliveries);
  	        var viewTotals = buildTankViewTotals(arr);
  	
  	        return {
  	          count: arr.length,
  	          litres: viewTotals.litres,
  	          cost: viewTotals.cost,
  	          latestCostPerLitre: viewTotals.latestCostPerLitre
  	        };
  	      }
  	
  	      function openPrintWindow() {
  	        try {
  	          var visibleRows = toArray(state.filteredDeliveries);
  	          var searchTerm = String(state.searchTerm || "").trim();
  	          var totals = getVisibleTotals(visibleRows);
  	
  	          if (!visibleRows.length) {
  	            alert("There are no visible deliveries to print.");
  	            return;
  	          }
  	
  	          var printWin = window.open("", "_blank", "width=1280,height=900");
  	          if (!printWin) {
  	            alert("Print window was blocked by the browser.");
  	            return;
  	          }
  	
  	          var logoHtml = "";
  	          if (svgLogo) {
  	            logoHtml = '<img src="' + escapeHtml(svgLogo) + '" alt="Logo" style="max-height:68px;max-width:240px;object-fit:contain;display:block;">';
  	          }
  	
  	          var rowsHtml = "";
  	          for (var i = 0; i < visibleRows.length; i++) {
  	            var item = visibleRows[i];
  	            rowsHtml += ""
  	            + "<tr>"
  	            + "<td>" + escapeHtml(formatDatePretty(getDeep(item, ["FuelDate"], ""))) + "</td>"
  	            + "<td>" + escapeHtml(getDeliveryTankName(item)) + "</td>"
  	            + "<td>" + escapeHtml(text(getDeep(item, ["Supplier"], ""), "")) + "</td>"
  	            + "<td>" + escapeHtml(text(getDeep(item, ["ReferenceNo"], ""), "")) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["Litres"], 0), 2)) + " L</td>"
  	            + "<td class='num'>" + escapeHtml(formatCurrency(getDeep(item, ["Cost"], 0))) + "</td>"
  	            + "<td class='num'>R " + escapeHtml(displayNumber(getDeep(item, ["CostPerLitre"], 0), 4)) + "</td>"
  	            + "<td>" + escapeHtml(text(getDeep(item, ["Description"], ""), "")) + "</td>"
  	            + "</tr>";
  	          }
  	
  	          var reportTitle = "Tank Delivery Report";
  	          var reportTankName = getDeliveryTankName(visibleRows[0] || null);
  	          var selectedViewMeta = getSelectedTankViewMeta();
  	          var selectedViewLabel = selectedViewMeta
  	            ? tankViewDisplayLabel(selectedViewMeta.view)
  	            : "All loaded deliveries";
  	          var reportSubTitle = "Tank: " + reportTankName + " | View: " + selectedViewLabel;
  	          var filterLabel = searchTerm ? ('Filtered by: "' + searchTerm + '"'): "Filter: None";
  	          var generatedAt = formatDatePretty(new Date().toISOString());
  	          var companyLabel = text(getDeep(company, ["CompanyId"], ""), "");
  	          var tankLabel = text(getDeep(tank, ["Grade"], ""), "");
  	
  	          var html = ""
  	          + "<!doctype html>"
  	          + "<html>"
  	          + "<head>"
  	          + '<meta charset="utf-8">'
  	          + "<title>" + escapeHtml(reportTitle) + "</title>"
  	          + "<style>"
  	          + "html,body{margin:0;padding:0;background:#fff;color:#111827;font-family:Arial,sans-serif;}"
  	          + "body{padding:26px 28px 34px;}"
  	          + ".header{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;border-bottom:3px double #374151;padding-bottom:14px;margin-bottom:18px;}"
  	          + ".title{font-size:24px;font-weight:800;line-height:1.1;margin:0;}"
  	          + ".subtitle{font-size:12px;color:#4b5563;margin-top:6px;}"
  	          + ".meta{font-size:11px;color:#374151;line-height:1.55;margin-top:10px;}"
  	          + ".summary-grid{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:10px;margin:18px 0;}"
  	          + ".summary-card{border:1px solid #d1d5db;border-top:3px solid #9c4822;border-radius:8px;padding:11px;background:#f9fafb;min-width:0;}"
  	          + ".summary-label{font-size:10px;color:#6b7280;text-transform:uppercase;letter-spacing:.05em;}"
  	          + ".summary-value{font-size:19px;font-weight:800;color:#111827;margin-top:6px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	          + ".section-title{font-size:14px;font-weight:800;color:#111827;margin:18px 0 10px;}"
  	          + "table{width:100%;border-collapse:collapse;table-layout:fixed;}"
  	          + "thead th{background:#111827;color:#fff;font-size:10px;text-transform:uppercase;letter-spacing:.04em;padding:9px 7px;border:1px solid #0f172a;text-align:left;}"
  	          + "tbody td{font-size:10px;color:#111827;padding:7px;border:1px solid #d1d5db;vertical-align:top;word-wrap:break-word;}"
  	          + ".num{text-align:right;font-variant-numeric:tabular-nums;}"
  	          + ".footer{margin-top:18px;font-size:9px;color:#6b7280;border-top:1px solid #d1d5db;padding-top:10px;}"
  	          + "@media print{body{padding:16px 18px 20px;}tr,td,th{page-break-inside:avoid;}}"
  	          + "</style>"
  	          + "</head>"
  	          + "<body>"
  	          + '<div class="header">'
  	          + '  <div style="flex:1;min-width:0;">'
  	          + '    <h1 class="title">' + escapeHtml(reportTitle) + "</h1>"
  	          + '    <div class="subtitle">' + escapeHtml(reportSubTitle) + "</div>"
  	          + '    <div class="meta">'
  	          + "      <div><strong>Company:</strong> " + escapeHtml(companyLabel || "-") + "</div>"
  	          + "      <div><strong>Tank Grade:</strong> " + escapeHtml(tankLabel || "-") + "</div>"
  	          + "      <div><strong>Sort:</strong> " + escapeHtml((state.sortKey || "date") + " / " + (state.sortDirection || "desc")) + "</div>"
  	          + "      <div><strong>Generated:</strong> " + escapeHtml(generatedAt) + "</div>"
  	          + "      <div><strong>" + escapeHtml(filterLabel) + "</strong></div>"
  	          + "    </div>"
  	          + "  </div>"
  	          + '  <div style="width:260px;display:flex;justify-content:flex-end;align-items:flex-start;">' + logoHtml + "</div>"
  	          + "</div>"
  	          + '<div class="summary-grid">'
  	          + '  <div class="summary-card"><div class="summary-label">Tank</div><div class="summary-value" style="font-size:15px;">' + escapeHtml(reportTankName) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Deliveries</div><div class="summary-value">' + escapeHtml(String(totals.count)) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Litres</div><div class="summary-value">' + escapeHtml(displayNumber(totals.litres, 2)) + " L</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Cost</div><div class="summary-value">' + escapeHtml(formatCurrency(totals.cost)) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Latest Cost / Litre</div><div class="summary-value">R ' + escapeHtml(displayNumber(totals.latestCostPerLitre, 4)) + "</div></div>"
  	          + "</div>"
  	          + '<div class="section-title">Tank Deliveries</div>'
  	          + "<table>"
  	          + "<thead><tr><th style='width:112px;'>Date</th><th style='width:110px;'>Tank</th><th style='width:120px;'>Supplier</th><th style='width:100px;'>Reference</th><th style='width:76px;text-align:right;'>Litres</th><th style='width:88px;text-align:right;'>Cost</th><th style='width:82px;text-align:right;'>Cost/L</th><th>Description</th></tr></thead>"
  	          + "<tbody>" + rowsHtml + "</tbody>"
  	          + "</table>"
  	          + '<div class="footer">This report reflects the deliveries currently visible on screen, in the selected sort order. An active search limits both the rows and totals.</div>'
  	          + '<script>window.onload=function(){setTimeout(function(){window.print();},250);};</script>'
  	          + "</body>"
  	          + "</html>";
  	
  	          printWin.document.open();
  	          printWin.document.write(html);
  	          printWin.document.close();
  	        } catch (printErr) {
  	          console.log("Print / PDF error:", printErr);
  	          alert("Print failed: " + (printErr && printErr.message ? printErr.message: printErr));
  	        }
  	      }
  	
  	      async function openSingleDeliveryPrintWindow(item) {
  	        var printWin = null;
  	
  	        try {
  	          if (!item) {
  	            alert("No delivery is selected.");
  	            return;
  	          }
  	
  	          printWin = window.open("", "_blank", "width=1100,height=850");
  	          if (!printWin) {
  	            alert("Print window was blocked by the browser.");
  	            return;
  	          }
  	
  	          printWin.document.open();
  	          printWin.document.write(
  	            "<!doctype html><html><head><meta charset=\"utf-8\"><title>Tank Delivery Transaction</title></head>" +
  	            "<body style=\"margin:0;display:grid;place-items:center;min-height:100vh;background:#fff;color:#374151;font-family:Arial,sans-serif;\">" +
  	            "<div style=\"font-size:14px;font-weight:700;\">Preparing transaction and attached document…</div>" +
  	            "</body></html>"
  	          );
  	          printWin.document.close();
  	
  	          var logoHtml = "";
  	          if (svgLogo) {
  	            logoHtml = '<img src="' + escapeHtml(svgLogo) + '" alt="Logo" style="max-height:68px;max-width:240px;object-fit:contain;display:block;">';
  	          }
  	
  	          var deliveryTankName = getDeliveryTankName(item);
  	          var supplier = text(getDeep(item, ["Supplier"], ""), "Unknown Supplier");
  	          var fuelDate = formatDatePretty(getDeep(item, ["FuelDate"], ""));
  	          var referenceNo = text(getDeep(item, ["ReferenceNo"], ""), "");
  	          var description = text(getDeep(item, ["Description"], ""), "");
  	          var litres = displayNumber(getDeep(item, ["Litres"], 0), 2) + " L";
  	          var cost = formatCurrency(getDeep(item, ["Cost"], 0));
  	          var costPerLitre = "R " + displayNumber(getDeep(item, ["CostPerLitre"], 0), 4);
  	          var volumeBefore = displayNumber(getDeep(item, ["VolumeBefore"], 0), 2) + " L";
  	          var volumeAfter = displayNumber(getDeep(item, ["VolumeAfter"], 0), 2) + " L";
  	          var levelBefore = displayNumber(getDeep(item, ["LevelBefore"], 0), 2) + "%";
  	          var levelAfter = displayNumber(getDeep(item, ["LevelAfter"], 0), 2) + "%";
  	          var objectId = text(getDeep(item, ["objectId"], ""), "");
  	          var generatedAt = formatDatePretty(new Date().toISOString());
  	          var companyLabel = text(getDeep(company, ["CompanyId"], ""), "");
  	          var tankLabel = text(getDeep(tank, ["Grade"], ""), "");
  	          var documentUrl = text(getDeep(item, ["DocumentURL"], ""), "");
  	          var documentName = text(
  	            getDeep(item, ["DocumentName"], ""),
  	            "Fuel delivery document"
  	          );
  	          var documentPrintHtml = "";
  	
  	          if (documentUrl) {
  	            try {
  	              var documentBlob = await fetchFuelInDocumentBlob(item);
  	              var documentMime = fuelDocumentMimeFromItem(item, documentBlob);
  	
  	              if (/^image\//i.test(documentMime)) {
  	                var documentDataUrl = await fuelDocumentBlobToDataUrl(documentBlob);
  	
  	                documentPrintHtml = ""
  	                + '<section class="document-page">'
  	                + '<div class="document-heading">Attached Delivery Document</div>'
  	                + '<div class="document-name">' + escapeHtml(documentName) + '</div>'
  	                + '<div class="document-image-wrap">'
  	                + '<img class="document-image" src="' + escapeHtml(documentDataUrl) + '" alt="' + escapeHtml(documentName) + '">'
  	                + '</div>'
  	                + '</section>';
  	              } else if (documentMime === "application/pdf") {
  	                documentPrintHtml = ""
  	                + '<section class="document-reference">'
  	                + '<div class="document-heading">Attached Delivery Document</div>'
  	                + '<div class="document-name">' + escapeHtml(documentName) + '</div>'
  	                + '<div class="document-note">The attached file is a PDF. It can be viewed or downloaded from the transaction viewer.</div>'
  	                + '</section>';
  	              }
  	            } catch (documentError) {
  	              documentPrintHtml = ""
  	              + '<section class="document-reference">'
  	              + '<div class="document-heading">Attached Delivery Document</div>'
  	              + '<div class="document-name">' + escapeHtml(documentName) + '</div>'
  	              + '<div class="document-note">The attached document could not be loaded into this printout.</div>'
  	              + '</section>';
  	            }
  	          }
  	
  	          var additionalDocs = fuelInAdditionalDocs(item);
  	          var additionalDocumentPrintHtml = "";
  	
  	          for (var additionalIndex = 0; additionalIndex < additionalDocs.length; additionalIndex++) {
  	            var additionalDoc = additionalDocs[additionalIndex];
  	            var additionalSlot = toNumber(
  	              getDeep(additionalDoc, ["Slot"], additionalIndex + 1),
  	              additionalIndex + 1
  	            );
  	            var additionalName = text(
  	              getDeep(additionalDoc, ["Name"], ""),
  	              "Additional delivery document " + additionalSlot
  	            );
  	
  	            try {
  	              var additionalBlob = await fetchFuelInDocumentBlobByUrl(
  	                getDeep(additionalDoc, ["URL"], "")
  	              );
  	              var additionalMime = fuelDocumentMimeFromItem(
  	                fuelInAdditionalDocAsLegacyItem(additionalDoc),
  	                additionalBlob
  	              );
  	
  	              if (/^image\//i.test(additionalMime)) {
  	                var additionalDataUrl = await fuelDocumentBlobToDataUrl(additionalBlob);
  	                additionalDocumentPrintHtml += ""
  	                + '<section class="document-page">'
  	                + '<div class="document-heading">Additional Delivery Document ' + escapeHtml(String(additionalSlot)) + '</div>'
  	                + '<div class="document-name">' + escapeHtml(additionalName) + '</div>'
  	                + '<div class="document-image-wrap">'
  	                + '<img class="document-image" src="' + escapeHtml(additionalDataUrl) + '" alt="' + escapeHtml(additionalName) + '">'
  	                + '</div>'
  	                + '</section>';
  	              } else if (additionalMime === "application/pdf") {
  	                additionalDocumentPrintHtml += ""
  	                + '<section class="document-reference">'
  	                + '<div class="document-heading">Additional Delivery Document ' + escapeHtml(String(additionalSlot)) + '</div>'
  	                + '<div class="document-name">' + escapeHtml(additionalName) + '</div>'
  	                + '<div class="document-note">The attached file is a PDF. It can be viewed or downloaded from the transaction viewer.</div>'
  	                + '</section>';
  	              }
  	            } catch (additionalDocumentError) {
  	              additionalDocumentPrintHtml += ""
  	              + '<section class="document-reference">'
  	              + '<div class="document-heading">Additional Delivery Document ' + escapeHtml(String(additionalSlot)) + '</div>'
  	              + '<div class="document-name">' + escapeHtml(additionalName) + '</div>'
  	              + '<div class="document-note">The attached additional document could not be loaded into this printout.</div>'
  	              + '</section>';
  	            }
  	          }
  	
  	          var html = ""
  	          + "<!doctype html>"
  	          + "<html>"
  	          + "<head>"
  	          + '<meta charset="utf-8">'
  	          + "<title>Tank Delivery Transaction</title>"
  	          + "<style>"
  	          + "html,body{margin:0;padding:0;background:#fff;color:#111827;font-family:Arial,sans-serif;}"
  	          + "body{padding:28px 30px 36px;}"
  	          + ".header{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;border-bottom:3px double #374151;padding-bottom:14px;margin-bottom:18px;}"
  	          + ".title{font-size:24px;font-weight:800;line-height:1.1;margin:0;}"
  	          + ".subtitle{font-size:12px;color:#4b5563;margin-top:6px;}"
  	          + ".meta{font-size:11px;color:#374151;line-height:1.55;margin-top:10px;}"
  	          + ".summary-grid{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:10px;margin:18px 0;}"
  	          + ".summary-card{border:1px solid #d1d5db;border-top:3px solid #9c4822;border-radius:8px;padding:11px;background:#f9fafb;min-width:0;}"
  	          + ".summary-label{font-size:10px;color:#6b7280;text-transform:uppercase;letter-spacing:.05em;}"
  	          + ".summary-value{font-size:19px;font-weight:800;color:#111827;margin-top:6px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	          + ".detail-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;}"
  	          + ".detail-card{border:1px solid #d1d5db;border-radius:10px;padding:14px;background:#f9fafb;}"
  	          + ".detail-card-title{font-size:13px;font-weight:800;color:#111827;margin-bottom:8px;}"
  	          + ".detail-row{display:grid;grid-template-columns:140px 1fr;gap:10px;padding:7px 0;border-bottom:1px solid #e5e7eb;}"
  	          + ".detail-label{font-size:11px;color:#6b7280;}"
  	          + ".detail-value{font-size:12px;color:#111827;word-break:break-word;}"
  	          + ".document-reference{margin-top:18px;border:1px solid #d1d5db;border-radius:10px;padding:14px;background:#f9fafb;}"
  	          + ".document-page{page-break-before:always;break-before:page;padding-top:6px;}"
  	          + ".document-heading{font-size:16px;font-weight:800;color:#111827;border-bottom:2px solid #9c4822;padding-bottom:8px;}"
  	          + ".document-name{margin-top:7px;font-size:11px;color:#4b5563;word-break:break-word;}"
  	          + ".document-note{margin-top:10px;font-size:11px;color:#6b7280;line-height:1.5;}"
  	          + ".document-image-wrap{margin-top:16px;text-align:center;}"
  	          + ".document-image{display:block;max-width:100%;height:auto;margin:0 auto;object-fit:contain;}"
  	          + ".footer{margin-top:18px;font-size:9px;color:#6b7280;border-top:1px solid #d1d5db;padding-top:10px;}"
  	          + "@media print{body{padding:18px 20px 22px;}.document-page{page-break-before:always;break-before:page;}.document-image{max-width:100%;max-height:250mm;}}"
  	          + "</style>"
  	          + "</head>"
  	          + "<body>"
  	          + '<div class="header">'
  	          + '  <div style="flex:1;min-width:0;">'
  	          + '    <h1 class="title">Tank Delivery Transaction</h1>'
  	          + '    <div class="subtitle">' + escapeHtml(deliveryTankName) + (fuelDate ? (" | " + escapeHtml(fuelDate)): "") + "</div>"
  	          + '    <div class="meta">'
  	          + "      <div><strong>Company:</strong> " + escapeHtml(companyLabel || "-") + "</div>"
  	          + "      <div><strong>Tank Grade:</strong> " + escapeHtml(tankLabel || "-") + "</div>"
  	          + "      <div><strong>Transaction ID:</strong> " + escapeHtml(objectId || "-") + "</div>"
  	          + "      <div><strong>Generated:</strong> " + escapeHtml(generatedAt) + "</div>"
  	          + "    </div>"
  	          + "  </div>"
  	          + '  <div style="width:260px;display:flex;justify-content:flex-end;align-items:flex-start;">' + logoHtml + "</div>"
  	          + "</div>"
  	          + '<div class="summary-grid">'
  	          + '  <div class="summary-card"><div class="summary-label">Tank</div><div class="summary-value" style="font-size:15px;">' + escapeHtml(deliveryTankName) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Supplier</div><div class="summary-value" style="font-size:15px;">' + escapeHtml(supplier) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Litres</div><div class="summary-value">' + escapeHtml(litres) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Cost</div><div class="summary-value">' + escapeHtml(cost) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Cost / L</div><div class="summary-value">' + escapeHtml(costPerLitre) + "</div></div>"
  	          + "</div>"
  	          + '<div class="detail-grid">'
  	          + '  <div class="detail-card">'
  	          + '    <div class="detail-card-title">Delivery</div>'
  	          + '    <div class="detail-row"><div class="detail-label">Tank</div><div class="detail-value">' + escapeHtml(deliveryTankName) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Fuel Date</div><div class="detail-value">' + escapeHtml(fuelDate || "") + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Entry Type</div><div class="detail-value">' + escapeHtml(text(getDeep(item, ["EntryType"], "delivery"), "delivery")) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Supplier</div><div class="detail-value">' + escapeHtml(supplier) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Reference No</div><div class="detail-value">' + escapeHtml(referenceNo) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Description</div><div class="detail-value">' + escapeHtml(description) + "</div></div>"
  	          + "  </div>"
  	          + '  <div class="detail-card">'
  	          + '    <div class="detail-card-title">Figures</div>'
  	          + '    <div class="detail-row"><div class="detail-label">Litres</div><div class="detail-value">' + escapeHtml(litres) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Cost</div><div class="detail-value">' + escapeHtml(cost) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Cost Per Litre</div><div class="detail-value">' + escapeHtml(costPerLitre) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Volume Before</div><div class="detail-value">' + escapeHtml(volumeBefore) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Volume After</div><div class="detail-value">' + escapeHtml(volumeAfter) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Level Before</div><div class="detail-value">' + escapeHtml(levelBefore) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Level After</div><div class="detail-value">' + escapeHtml(levelAfter) + "</div></div>"
  	          + "  </div>"
  	          + "</div>"
  	          + documentPrintHtml
  	          + additionalDocumentPrintHtml
  	          + '<div class="footer">This report reflects the selected individual tank delivery transaction only.</div>'
  	          + '<script>(function(){function doPrint(){setTimeout(function(){window.print();},180);}window.onload=function(){var imgs=Array.prototype.slice.call(document.images||[]);var pending=imgs.filter(function(img){return !img.complete;});if(!pending.length){doPrint();return;}var left=pending.length;var finished=false;function done(){if(finished)return;left--;if(left<=0){finished=true;doPrint();}}pending.forEach(function(img){img.addEventListener("load",done,{once:true});img.addEventListener("error",done,{once:true});});setTimeout(function(){if(!finished){finished=true;doPrint();}},2500);};})();</script>'
  	          + "</body>"
  	          + "</html>";
  	
  	          printWin.document.open();
  	          printWin.document.write(html);
  	          printWin.document.close();
  	        } catch (printErr) {
  	          console.log("Single delivery print / PDF error:", printErr);
  	
  	          if (printWin && !printWin.closed) {
  	            try {
  	              printWin.close();
  	            } catch (_) {}
  	          }
  	
  	          alert("Print failed: " + (printErr && printErr.message ? printErr.message: printErr));
  	        }
  	      }
  	
  	      var state = {
  	        deliveryCache: [],
  	        filteredDeliveries: [],
  	        allDeliveries: [],
  	        selectedDelivery: null,
  	        searchTerm: "",
  	        sortKey: "date",
  	        sortDirection: "desc",
  	        currentView: null,
  	        historyViews: [],
  	        selectedViewToken: "",
  	        latestPricePerLitre: Math.max(0, managerLatestCostPerLitre(tank)),
  	        pricingSource: "latest",
  	        editingDelivery: false,
  	        selectedDocument: null,
  	        selectedAdditionalDocuments: [null, null],
  	        documentPreviewObjectUrl: "",
  	        additionalDocumentPreviewObjectUrls: []
  	      };
  	
  	      var companyId = text(getDeep(company, ["CompanyId"], ""), "");
  	      var tankGrade = text(getDeep(tank, ["Grade"], ""), "");
  	
  	      var subtitleParts = [];
  	      if (tankGrade) subtitleParts.push(tankGrade);
  	      if (companyId) subtitleParts.push(companyId);
  	      var subtitle = subtitleParts.join(" | ");
  	
  	      var deliverySuppliers = managerSuppliers(company);
  	      var deliveryPrimarySupplier = managerTankPrimarySupplier(company, tank);
  	      var deliveryPrimarySupplierId = deliveryPrimarySupplier
  	        ? deliveryPrimarySupplier.SupplierId
  	        : "";
  	      var deliveryPrimarySupplierName = deliveryPrimarySupplier
  	        ? deliveryPrimarySupplier.Name
  	        : "";
  	
  	      function deliverySupplierOptionsHtml() {
  	        var html = '<option value="" disabled>Select supplier</option>';
  	
  	        for (var supplierIndex = 0; supplierIndex < deliverySuppliers.length; supplierIndex++) {
  	          var supplier = deliverySuppliers[supplierIndex];
  	          html +=
  	            '<option value="' + escapeHtml(supplier.Name) + '" ' +
  	            'data-supplier-id="' + escapeHtml(supplier.SupplierId) + '"' +
  	            (supplier.SupplierId === deliveryPrimarySupplierId ? " selected" : "") +
  	            '>' + escapeHtml(supplier.Name) + '</option>';
  	        }
  	
  	        return html;
  	      }
  	
  	      function deliverySupplierOptionsForItem(item) {
  	        var selectedId = text(getDeep(item, ["SupplierId"], ""), "").trim();
  	        var selectedName = text(getDeep(item, ["Supplier"], ""), "").trim();
  	        var matched = false;
  	        var html = '<option value="">Select supplier</option>';
  	
  	        for (var supplierIndex = 0; supplierIndex < deliverySuppliers.length; supplierIndex++) {
  	          var supplier = deliverySuppliers[supplierIndex];
  	          var isSelected = selectedId
  	            ? String(supplier.SupplierId || "") === selectedId
  	            : String(supplier.Name || "").trim().toLowerCase() === selectedName.toLowerCase();
  	
  	          if (isSelected) matched = true;
  	
  	          html +=
  	            '<option value="' + escapeHtml(supplier.Name) + '" ' +
  	            'data-supplier-id="' + escapeHtml(supplier.SupplierId) + '"' +
  	            (isSelected ? " selected" : "") +
  	            '>' + escapeHtml(supplier.Name) + '</option>';
  	        }
  	
  	        if (!matched && selectedName) {
  	          html +=
  	            '<option value="' + escapeHtml(selectedName) + '" ' +
  	            'data-supplier-id="' + escapeHtml(selectedId) + '" selected>' +
  	            escapeHtml(selectedName) + '</option>';
  	        }
  	
  	        return html;
  	      }
  	
  	      var existing = document.getElementById("fuel-delivery-overlay");
  	      if (existing) existing.remove();
  	
  	      var overlay = document.createElement("div");
  	      overlay.id = "fuel-delivery-overlay";
  	      overlay.style.position = "fixed";
  	      overlay.style.inset = "0";
  	      overlay.style.zIndex = String(FIF_MAX_Z_INDEX);
  	      overlay.style.display = "flex";
  	      overlay.style.alignItems = "center";
  	      overlay.style.justifyContent = "center";
  	      overlay.style.background = "rgba(0,0,0,0.40)";
  	      overlay.style.backdropFilter = "blur(2px)";
  	      overlay.style.padding = "14px";
  	      overlay.style.boxSizing = "border-box";
  	
  	      var modal = document.createElement("div");
  	      modal.id = "fuel-delivery-modal";
  	      modal.style.width = "calc(100vw - 28px)";
  	      modal.style.height = "calc(100vh - 28px)";
  	      modal.style.maxWidth = "none";
  	      modal.style.maxHeight = "none";
  	      modal.style.background = "linear-gradient(180deg, rgba(5,10,18,0.96) 0%, rgba(10,16,24,0.94) 100%)";
  	      modal.style.borderRadius = "18px";
  	      modal.style.overflow = "hidden";
  	      modal.style.boxShadow = "0 18px 50px rgba(0,0,0,0.38)";
  	      modal.style.display = "flex";
  	      modal.style.flexDirection = "column";
  	      modal.style.color = "#f8fafc";
  	      modal.style.fontFamily = "Arial, sans-serif";
  	      modal.style.border = "1px solid rgba(255,255,255,0.06)";
  	
  	      modal.innerHTML = ""
  	      + "<style>"
  	      + "#fuel-delivery-modal{font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif!important;}"
  	      + ".fuel-soft-input{width:100%!important;height:46px!important;border-radius:12px!important;border:1px solid rgba(255,255,255,.12)!important;background:linear-gradient(180deg,#121923,#0c121a)!important;color:#f8fafc!important;padding:0 13px!important;font-size:14px!important;font-weight:650!important;box-sizing:border-box!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.035),0 8px 18px rgba(0,0,0,.12)!important;outline:none!important;}"
  	      + ".fuel-soft-input::placeholder{color:#64748b!important;}"
  	      + ".fuel-soft-input:focus{border-color:rgba(204,102,51,.82)!important;box-shadow:0 0 0 3px rgba(204,102,51,.13),inset 0 1px 0 rgba(255,255,255,.04)!important;}"
  	      + ".fuel-error-text{display:none;margin-top:5px;font-size:11px;color:#ff8c8c;font-weight:700;}"
  	      + ".fuel-help-text{display:none;margin-top:5px;font-size:11px;color:#94a3b8;}"
  	      + "#fuel-delivery-capture-panel{background:radial-gradient(circle at 18% 0%,rgba(204,102,51,.06),transparent 36%);}"
  	      + "#fuel-delivery-capture-panel>div:not(.fuel-form-intro){padding:18px!important;border:1px solid rgba(255,255,255,.075);border-top-color:rgba(204,102,51,.34);border-radius:18px;background:linear-gradient(145deg,rgba(255,255,255,.045),rgba(255,255,255,.018));box-shadow:0 16px 34px rgba(0,0,0,.18);}"
  	      + "#fuel-delivery-capture-panel label{font-size:12px!important;font-weight:800!important;color:#cbd5e1!important;letter-spacing:.01em!important;margin:0 0 7px 2px!important;}"
  	      + ".fuel-form-intro{width:100%;max-width:none;box-sizing:border-box;margin:0 0 12px;padding:14px 16px;border:1px solid rgba(204,102,51,.28);border-radius:16px;background:linear-gradient(145deg,rgba(204,102,51,.12),rgba(255,255,255,.025));}"
  	      + ".fuel-form-intro-title{font-size:18px;font-weight:900;color:#fff;}"
  	      + ".fuel-form-intro-copy{margin-top:4px;font-size:11px;color:#94a3b8;}@media(max-width:760px){.fuel-capture-form-grid,.fuel-delivery-form-grid{grid-template-columns:1fr!important;}.fuel-capture-form-grid>[style*='grid-column'],.fuel-delivery-form-grid>[style*='grid-column']{grid-column:1!important;}.fuel-capture-form-actions,.fuel-delivery-form-actions{flex-direction:column!important;}.fuel-capture-form-actions button,.fuel-delivery-form-actions button{width:100%!important;flex:none!important;}}"
  	      + ".fuel-summary-stack{display:grid;grid-template-columns:1fr;gap:8px;}"
  	      + ".fuel-summary-card{background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,255,255,.035));border:1px solid rgba(255,255,255,.055);border-radius:12px;padding:10px 12px;min-width:0;}"
  	      + ".fuel-summary-card .label{font-size:10px;color:#94a3b8;}"
  	      + ".fuel-summary-card .value{margin-top:3px;font-size:17px;font-weight:850;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-sort-select{width:128px!important;height:40px!important;appearance:none;}"
  	      + ".fuel-sort-select option{background:#0b1119;color:#fff;}"
  	      + ".fuel-sort-direction{height:40px;min-width:58px;padding:0 12px;border:1px solid rgba(255,255,255,.10);border-radius:11px;background:rgba(255,255,255,.06);color:#f8fafc;font-size:12px;font-weight:850;cursor:pointer;}"
  	      + ".fuel-delivery-item:hover{background:rgba(255,255,255,.10)!important;border-color:rgba(204,102,51,.35)!important;transform:translateY(-1px);}"
  	      + ".fuel-delivery-item{transition:all 140ms ease;border:1px solid rgba(255,255,255,.055)!important;}"
  	      + ".fuel-delivery-row-grid{display:grid;grid-template-columns:minmax(190px,1.45fr) minmax(120px,.9fr) 100px 116px 108px 138px;gap:10px;align-items:center;}"
  	      + ".fuel-delivery-primary{min-width:0;}"
  	      + ".fuel-delivery-primary-name{font-size:13px;font-weight:850;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-delivery-primary-meta{margin-top:3px;font-size:10px;color:#94a3b8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-delivery-cell{min-width:0;}"
  	      + ".fuel-delivery-cell span{display:block;font-size:9px;color:#94a3b8;text-transform:uppercase;letter-spacing:.04em;}"
  	      + ".fuel-delivery-cell strong{display:block;margin-top:3px;font-size:12px;font-weight:850;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-delivery-date-cell{text-align:right;}"
  	      + "@media(max-width:1280px){.fuel-delivery-row-grid{grid-template-columns:minmax(170px,1.35fr) minmax(105px,.8fr) 88px 104px 94px 122px;gap:8px;}}"
  	      + "@media(max-width:900px){.fuel-delivery-row-grid{grid-template-columns:repeat(2,minmax(0,1fr));}.fuel-delivery-primary{grid-column:1/-1;}.fuel-delivery-date-cell{text-align:left;}}"
  	      + ".fuel-detail-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.58);display:none;align-items:center;justify-content:center;padding:18px;box-sizing:border-box;z-index:20;backdrop-filter:blur(4px);}"
  	      + ".fuel-detail-card{width:min(860px,100%);max-height:100%;overflow:auto;background:linear-gradient(180deg,rgba(12,18,28,.99),rgba(9,14,22,.99));border:1px solid rgba(204,102,51,.24);border-radius:18px;box-shadow:0 24px 70px rgba(0,0,0,.52);}"
  	      + ".fuel-document-box{display:flex;align-items:center;gap:10px;min-height:48px;padding:9px 10px;box-sizing:border-box;border:1px solid rgba(204,102,51,.26);border-radius:12px;background:linear-gradient(145deg,rgba(156,72,34,.10),rgba(255,255,255,.025));}"
  	      + ".fuel-document-name{flex:1;min-width:0;color:#e2e8f0;font-size:11px;font-weight:750;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-document-button{height:34px;padding:0 12px;border:1px solid rgba(204,102,51,.42);border-radius:10px;background:linear-gradient(145deg,rgba(156,72,34,.30),rgba(94,41,20,.22));color:#fff;font-size:11px;font-weight:850;cursor:pointer;white-space:nowrap;}"
  	      + ".fuel-document-button:hover{border-color:rgba(255,154,61,.72);background:rgba(156,72,34,.38);}"
  	      + ".fuel-document-button.danger{border-color:rgba(239,68,68,.38);background:rgba(127,29,29,.20);color:#fecaca;}.fuel-additional-doc-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}.fuel-additional-doc-card{min-width:0;padding:10px;border:1px solid rgba(204,102,51,.20);border-radius:12px;background:rgba(255,255,255,.025)}@media(max-width:760px){.fuel-additional-doc-grid{grid-template-columns:1fr}}"
  	      + "#fuel-delivery-save-btn{background:linear-gradient(145deg,#9c4822,#5e2914)!important;box-shadow:0 10px 24px rgba(204,102,51,.22)!important;}"
  	      + "#fuel-delivery-cancel-btn{background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,255,255,.035))!important;border-color:rgba(255,255,255,.12)!important;}"
  	      + ".fuel-ledger-layout{display:grid;grid-template-columns:280px minmax(0,1fr);gap:14px;height:100%;min-height:0;}"
  	      + ".fuel-ledger-sidebar{display:flex;flex-direction:column;gap:10px;min-height:0;padding:12px;border:1px solid rgba(255,255,255,.07);border-top-color:rgba(204,102,51,.34);border-radius:18px;background:linear-gradient(145deg,rgba(255,255,255,.045),rgba(255,255,255,.018));box-shadow:0 16px 34px rgba(0,0,0,.18);overflow:auto;}"
  	      + ".fuel-ledger-selector{background:linear-gradient(145deg,rgba(255,255,255,.07),rgba(255,255,255,.03));border:1px solid rgba(255,255,255,.07);border-radius:13px;padding:12px;}"
  	      + ".fuel-ledger-main{display:flex;flex-direction:column;min-height:0;position:relative;padding:12px;border:1px solid rgba(255,255,255,.07);border-top-color:rgba(204,102,51,.34);border-radius:18px;background:linear-gradient(145deg,rgba(255,255,255,.045),rgba(255,255,255,.018));box-shadow:0 16px 34px rgba(0,0,0,.18);}"
  	      + ".fuel-ledger-toolbar{display:flex;gap:8px;align-items:center;margin-bottom:10px;flex-wrap:wrap;}"
  	      + ".fuel-ledger-search{flex:1 1 260px;height:40px!important;}"
  	      + ".fuel-ledger-action{height:40px;padding:0 14px;border:1px solid rgba(255,255,255,.11);border-radius:11px;background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,255,255,.035));color:#e2e8f0;font-size:12px;font-weight:850;cursor:pointer;white-space:nowrap;}"
  	      + ".fuel-ledger-action:hover{border-color:rgba(204,102,51,.50);background:rgba(204,102,51,.12);color:#fff;}"
  	      + ".fuel-ledger-action-primary{border-color:rgba(204,102,51,.55);background:linear-gradient(145deg,#9c4822,#5e2914);color:#fff;box-shadow:0 8px 20px rgba(204,102,51,.20);}"
  	      + ".fuel-ledger-table{flex:1;min-height:0;overflow:auto;box-sizing:border-box;border:1px solid rgba(255,255,255,.075);border-radius:14px;background:rgba(5,10,16,.52);box-shadow:inset 0 1px 0 rgba(255,255,255,.025);}"
  	      + ".fuel-ledger-head{position:sticky;top:0;z-index:5;padding:0 18px;box-sizing:border-box;background:linear-gradient(180deg,#171e28,#111821);border-bottom:1px solid rgba(204,102,51,.30);box-shadow:0 8px 16px rgba(0,0,0,.22);}"
  	      + ".fuel-ledger-head-cell{height:44px;display:flex;align-items:center;gap:7px;min-width:0;padding:0 4px;color:#aebdcc;font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.055em;}"
  	      + ".fuel-ledger-sort{width:100%;height:44px;display:flex;align-items:center;justify-content:flex-start;gap:6px;padding:0;min-width:0;border:none;background:transparent;color:#aebdcc;font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.055em;cursor:pointer;text-align:left;}"
  	      + ".fuel-ledger-sort:hover{color:#fff;}"
  	      + ".fuel-ledger-sort.active{color:#ff9a3d;}"
  	      + ".fuel-sort-arrow{font-size:11px;line-height:1;color:#64748b;}"
  	      + ".fuel-ledger-sort.active .fuel-sort-arrow{color:#ff9a3d;}.fuel-ledger-head.fuel-tx-grid>.fuel-ledger-sort:not(:first-child),.fuel-ledger-head.fuel-delivery-row-grid>.fuel-ledger-sort:nth-child(n+3){justify-content:flex-end;text-align:right;}.fuel-ledger-head.fuel-tx-grid>.fuel-ledger-sort:first-child,.fuel-ledger-head.fuel-delivery-row-grid>.fuel-ledger-sort:first-child,.fuel-ledger-head.fuel-delivery-row-grid>.fuel-ledger-sort:nth-child(2){justify-content:flex-start;text-align:left;}"
  	      + ".fuel-ledger-body{display:flex;flex-direction:column;gap:6px;padding:7px;min-height:120px;box-sizing:border-box;}"
  	      + ".fuel-delivery-row-grid{display:grid;grid-template-columns:minmax(180px,1.35fr) minmax(115px,.85fr) 92px 110px 102px 138px;gap:10px;align-items:center;min-width:920px;}"
  	      + ".fuel-ledger-row-grid{width:100%;padding:0;box-sizing:border-box;}"
  	      + ".fuel-ledger-primary{min-width:0;}"
  	      + ".fuel-ledger-primary-name{font-size:13px;font-weight:900;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-ledger-primary-meta{margin-top:3px;font-size:10px;color:#94a3b8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
  	      + ".fuel-ledger-cell{min-width:0;}"
  	      + ".fuel-ledger-cell strong{display:block;width:100%;font-size:12px;font-weight:850;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:right;}"
  	      + ".fuel-ledger-cell-date{text-align:right;}.fuel-delivery-row-grid>.fuel-ledger-cell:nth-child(2) strong{text-align:left;}"
  	      + ".fuel-delivery-item{width:100%;box-sizing:border-box;text-align:left;background:linear-gradient(145deg,rgba(255,255,255,.065),rgba(255,255,255,.025));border:1px solid rgba(255,255,255,.07)!important;border-radius:12px;padding:11px 10px;cursor:pointer;color:#fff;transition:all 140ms ease;}"
  	      + ".fuel-delivery-item:hover{background:linear-gradient(145deg,rgba(255,255,255,.11),rgba(204,102,51,.07))!important;border-color:rgba(204,102,51,.42)!important;transform:translateY(-1px);box-shadow:0 9px 20px rgba(0,0,0,.18);}"
  	      + "@media(max-width:1100px){.fuel-ledger-layout{grid-template-columns:240px minmax(0,1fr);}}"
  	      + "@media(max-width:820px){.fuel-ledger-layout{grid-template-columns:1fr;overflow:auto;}.fuel-ledger-sidebar{overflow:visible;}.fuel-summary-stack{grid-template-columns:repeat(2,minmax(0,1fr));}.fuel-ledger-main{min-height:560px;}}"
  	      + "</style>"
  	
  	      + '<div style="padding:16px 16px 10px 16px;border-bottom:1px solid rgba(255,255,255,0.06);display:flex;justify-content:space-between;align-items:flex-start;gap:10px;">'
  	      + '<div style="min-width:0;">'
  	      + '<div style="font-size:18px;font-weight:900;line-height:1.1;">Tank Fuel Delivery</div>'
  	      + '<div style="margin-top:4px;font-size:11px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(subtitle) + "</div>"
  	      + "</div>"
  	      + '<button id="fuel-delivery-close" type="button" class="fif-miniapp-close" aria-label="Close Tank Fuel Delivery">×</button>'
  	      + "</div>"
  	
  	      + '<div style="display:flex;gap:8px;padding:10px 14px 0 14px;">'
  	      + '<button id="fuel-delivery-tab-capture" type="button" class="fif-miniapp-tab">Capture</button>'
  	      + '<button id="fuel-delivery-tab-list" type="button" class="fif-miniapp-tab is-active">Deliveries</button>'
  	      + "</div>"
  	
  	      + '<div style="position:relative;flex:1;min-height:0;">'
  	
  	      + '<div id="fuel-delivery-capture-panel" style="display:none;position:absolute;inset:0;padding:18px;overflow:auto;">'
  	      + '<div class="fuel-form-intro"><div class="fuel-form-intro-title">Record Tank Delivery</div><div class="fuel-form-intro-copy">The latest tank price is applied automatically. Cost Per Litre and Total Cost are both editable and recalculate each other.</div></div>'
  	      + '<div class="fuel-delivery-form-grid" style="width:100%;max-width:none;box-sizing:border-box;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;">'
  	
  	      + '<div id="row-delivery-date">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Delivery Date</label>'
  	      + '<input id="fuel-delivery-date" type="date" class="fuel-soft-input">'
  	      + '<div id="fuel-delivery-date-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-supplier">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Supplier</label>'
  	      + '<select id="fuel-delivery-supplier" class="fuel-soft-input"' + (deliverySuppliers.length ? "": " disabled") + '>'
  	      + deliverySupplierOptionsHtml()
  	      + '</select>'
  	      + '<div id="fuel-delivery-supplier-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-litres">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Litres</label>'
  	      + '<input id="fuel-delivery-litres" type="text" inputmode="decimal" placeholder="Litres" class="fuel-soft-input">'
  	      + '<div id="fuel-delivery-litres-help" class="fuel-help-text"></div>'
  	      + '<div id="fuel-delivery-litres-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-cost">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Total Cost</label>'
  	      + '<input id="fuel-delivery-cost" type="text" inputmode="decimal" placeholder="Total cost" class="fuel-soft-input">'
  	      + '<div id="fuel-delivery-cost-help" class="fuel-help-text"></div>'
  	      + '<div id="fuel-delivery-cost-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-cost-per-litre">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Cost Per Litre</label>'
  	      + '<input id="fuel-delivery-cost-per-litre" type="text" inputmode="decimal" placeholder="Cost per litre" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-reference">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Reference No</label>'
  	      + '<input id="fuel-delivery-reference" type="text" placeholder="Reference No" class="fuel-soft-input">'
  	      + '<div id="fuel-delivery-reference-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-description" style="grid-column:1 / span 2;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Description / Notes</label>'
  	      + '<input id="fuel-delivery-description" type="text" placeholder="Description / Notes" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div id="row-delivery-document" style="grid-column:1 / span 2;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Delivery Document <span style="color:#94a3b8;font-weight:650;">(Optional)</span></label>'
  	      + '<input id="fuel-delivery-document-input" type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp" style="display:none;">'
  	      + '<div class="fuel-document-box">'
  	      + '<button id="fuel-delivery-document-choose" type="button" class="fuel-document-button">Choose Document</button>'
  	      + '<div id="fuel-delivery-document-name" class="fuel-document-name">No document selected</div>'
  	      + '<button id="fuel-delivery-document-clear" type="button" class="fuel-document-button danger" style="display:none;">Remove</button>'
  	      + '</div>'
  	      + '<div style="margin:6px 3px 0;color:#94a3b8;font-size:10px;line-height:1.45;">PDF, JPG, PNG or WEBP · Maximum 10 MB. The fuel delivery will still save if the optional upload fails.</div>'
  	      + '<div id="fuel-delivery-document-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-delivery-additional-documents" style="grid-column:1 / span 2;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Additional Documents / Images <span style="color:#94a3b8;font-weight:650;">(Optional · Maximum 2)</span></label>'
  	      + '<div class="fuel-additional-doc-grid">'
  	      + '  <div class="fuel-additional-doc-card">'
  	      + '    <input id="fuel-delivery-extra-document-input-1" type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp" style="display:none;">'
  	      + '    <div style="font-size:10px;font-weight:850;color:#cbd5e1;margin-bottom:7px;">Additional Document 1</div>'
  	      + '    <div class="fuel-document-box">'
  	      + '      <button id="fuel-delivery-extra-document-choose-1" type="button" class="fuel-document-button">Choose</button>'
  	      + '      <div id="fuel-delivery-extra-document-name-1" class="fuel-document-name">No document selected</div>'
  	      + '      <button id="fuel-delivery-extra-document-clear-1" type="button" class="fuel-document-button danger" style="display:none;">Remove</button>'
  	      + '    </div>'
  	      + '    <div id="fuel-delivery-extra-document-error-1" class="fuel-error-text"></div>'
  	      + '  </div>'
  	      + '  <div class="fuel-additional-doc-card">'
  	      + '    <input id="fuel-delivery-extra-document-input-2" type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp" style="display:none;">'
  	      + '    <div style="font-size:10px;font-weight:850;color:#cbd5e1;margin-bottom:7px;">Additional Document 2</div>'
  	      + '    <div class="fuel-document-box">'
  	      + '      <button id="fuel-delivery-extra-document-choose-2" type="button" class="fuel-document-button">Choose</button>'
  	      + '      <div id="fuel-delivery-extra-document-name-2" class="fuel-document-name">No document selected</div>'
  	      + '      <button id="fuel-delivery-extra-document-clear-2" type="button" class="fuel-document-button danger" style="display:none;">Remove</button>'
  	      + '    </div>'
  	      + '    <div id="fuel-delivery-extra-document-error-2" class="fuel-error-text"></div>'
  	      + '  </div>'
  	      + '</div>'
  	      + '<div style="margin:6px 3px 0;color:#94a3b8;font-size:10px;line-height:1.45;">These two supporting files are stored in the FuelIn <strong>Docs</strong> JSON property. PDF, JPG, PNG or WEBP · Maximum 10 MB each.</div>'
  	      + "</div>"
  	
  	      + '<div style="grid-column:1 / span 2;background:rgba(255,255,255,0.05);border-radius:14px;padding:14px;">'
  	      + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:10px;">Live Tank Delivery Summary</div>'
  	      + '<div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;">'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Capacity</div><div id="fuel-delivery-capacity" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Volume Before</div><div id="fuel-delivery-volume-before" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Volume After</div><div id="fuel-delivery-volume-after" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Level Before</div><div id="fuel-delivery-level-before" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00%</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Level After</div><div id="fuel-delivery-level-after" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00%</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Remaining Capacity</div><div id="fuel-delivery-remaining-capacity" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + "</div>"
  	      + '<div id="fuel-delivery-overflow-error" style="display:none;margin-top:10px;font-size:12px;color:#ff7b7b;font-weight:700;"></div>'
  	      + "</div>"
  	
  	      + "</div>"
  	
  	      + '<div class="fuel-delivery-form-actions" style="width:100%;max-width:none;box-sizing:border-box;display:flex;gap:10px;margin-top:18px;">'
  	      + '<button id="fuel-delivery-save-btn" type="button" class="fif-miniapp-primary" style="display:none;flex:1;height:46px;border-radius:10px;font-size:15px;font-weight:700;cursor:pointer;">Save Delivery</button>'
  	      + '<button id="fuel-delivery-cancel-btn" type="button" style="width:160px;height:46px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.05);color:#e2e8f0;font-size:15px;font-weight:700;cursor:pointer;">Cancel</button>'
  	      + "</div>"
  	      + "</div>"
  	
  	      + '<div id="fuel-delivery-list-panel" style="display:block;position:absolute;inset:0;padding:14px;overflow:hidden;">'
  	      + '<div class="fuel-ledger-layout">'
  	
  	      + '<div class="fuel-ledger-sidebar">'
  	      + '<div class="fuel-ledger-selector">'
  	      + '<div style="font-size:11px;color:#94a3b8;margin-bottom:6px;font-weight:800;">Tank Delivery View</div>'
  	      + '<div style="font-size:14px;font-weight:850;color:#f8fafc;margin-bottom:9px;">' + escapeHtml(tankGrade || "Tank") + "</div>"
  	      + '<select id="fuel-delivery-view-selector" class="fuel-soft-input" aria-label="Tank delivery month">'
  	      + '<option value="">Loading monthly views...</option>'
  	      + '</select>'
  	      + '<div id="fuel-delivery-view-status" style="margin-top:7px;font-size:10px;line-height:1.35;color:#94a3b8;">Checking and repairing TankView relationships.</div>'
  	      + "</div>"
  	
  	      + '<div class="fuel-summary-stack">'
  	      + '<div class="fuel-summary-card"><div class="label">Tank</div><div id="fuel-delivery-summary-tank" class="value">' + escapeHtml(getDeliveryTankName(null)) + "</div></div>"
  	      + '<div class="fuel-summary-card"><div class="label">Deliveries</div><div id="fuel-delivery-summary-count" class="value">0</div></div>'
  	      + '<div class="fuel-summary-card"><div class="label">Litres</div><div id="fuel-delivery-summary-litres" class="value">0.00</div></div>'
  	      + '<div class="fuel-summary-card"><div class="label">Cost</div><div id="fuel-delivery-summary-cost" class="value">R 0.00</div></div>'
  	      + '<div class="fuel-summary-card"><div class="label">Latest Cost / Litre</div><div id="fuel-delivery-summary-cpl" class="value">R 0.0000</div></div>'
  	      + "</div>"
  	      + "</div>"
  	
  	      + '<div class="fuel-ledger-main">'
  	      + '<div class="fuel-ledger-toolbar">'
  	      + '<input id="fuel-delivery-search" type="text" placeholder="Search deliveries..." class="fuel-soft-input fuel-ledger-search">'
  	      + '<button id="fuel-delivery-search-clear" type="button" class="fuel-ledger-action">Clear</button>'
  	      + '<button id="fuel-delivery-refresh-btn" type="button" class="fuel-ledger-action">Refresh</button>'
  	      + '<button id="fuel-delivery-print-btn" type="button" class="fuel-ledger-action fuel-ledger-action-primary">Print / PDF</button>'
  	      + "</div>"
  	
  	      + '<div class="fuel-ledger-table">'
  	      + '<div class="fuel-ledger-head fuel-delivery-row-grid">'
  	      + '<button type="button" class="fuel-ledger-sort" data-delivery-sort-key="name"><span>Name</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-delivery-sort-key="tank"><span>Tank</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-delivery-sort-key="litres"><span>Litres</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-delivery-sort-key="cost"><span>Cost</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort" data-delivery-sort-key="costPerLitre"><span>Cost / L</span><span class="fuel-sort-arrow">↕</span></button>'
  	      + '<button type="button" class="fuel-ledger-sort active" data-delivery-sort-key="date" aria-sort="descending" style="justify-content:flex-end;"><span>Date</span><span class="fuel-sort-arrow">▼</span></button>'
  	      + "</div>"
  	
  	      + '<div id="fuel-delivery-list" class="fuel-ledger-body">'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	      + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">Loading deliveries...</div>'
  	      + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Deliveries are loaded from the selected tank object.</div>'
  	      + "</div>"
  	      + "</div>"
  	      + "</div>"
  	
  	      + '<div id="fuel-delivery-detail-backdrop" class="fuel-detail-backdrop">'
  	      + '  <div class="fuel-detail-card">'
  	      + '    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;padding:16px 16px 12px 16px;border-bottom:1px solid rgba(255,255,255,0.08);">'
  	      + '      <div>'
  	      + '        <div id="fuel-delivery-detail-title" style="font-size:16px;font-weight:700;color:#f8fafc;">Delivery Detail</div>'
  	      + '        <div id="fuel-delivery-detail-subtitle" style="margin-top:4px;font-size:11px;color:#94a3b8;"></div>'
  	      + "      </div>"
  	      + '      <div style="display:flex;align-items:center;gap:10px;">'
  	      + '        <button id="fuel-delivery-detail-edit" type="button" class="fif-miniapp-primary" style="height:36px;padding:0 14px;border-radius:10px;font-size:12px;font-weight:800;cursor:pointer;white-space:nowrap;">Edit Supplier / Cost</button>'
  	      + '        <button id="fuel-delivery-detail-print" type="button" class="fif-miniapp-primary" style="height:36px;padding:0 14px;border-radius:10px;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;">Print / PDF</button>'
  	      + '        <button id="fuel-delivery-detail-close" type="button" class="fif-miniapp-close" aria-label="Close delivery details">×</button>'
  	      + "      </div>"
  	      + "    </div>"
  	      + '    <div id="fuel-delivery-detail-body" style="padding:14px 16px 18px 16px;"></div>'
  	      + "  </div>"
  	      + "</div>"
  	
  	      + "</div>"
  	      + "</div>"
  	      + "</div>"
  	
  	      + "</div>";
  	
  	      overlay.appendChild(modal);
  	      document.body.appendChild(overlay);
  	      managerThemeSelects(overlay);
  	
  	      function el(id) {
  	        return document.getElementById(id);
  	      }
  	
  	      function valueOf(id) {
  	        var node = el(id);
  	        return node ? node.value: "";
  	      }
  	
  	      function setValue(id, value) {
  	        var node = el(id);
  	
  	        if (node) {
  	          node.value = value;
  	          managerRefreshThemedSelect(node);
  	        }
  	      }
  	
  	      function setText(id, value) {
  	        var node = el(id);
  	        if (node) node.textContent = value;
  	      }
  	
  	      function showError(id, message) {
  	        var node = el(id);
  	        if (!node) return;
  	        node.style.display = message ? "block": "none";
  	        node.textContent = message || "";
  	      }
  	
  	      function showHelp(id, message) {
  	        var node = el(id);
  	        if (!node) return;
  	        node.style.display = message ? "block": "none";
  	        node.textContent = message || "";
  	      }
  	
  	      function refreshCaptureDocumentUi() {
  	        var nameNode = el("fuel-delivery-document-name");
  	        var clearButton = el("fuel-delivery-document-clear");
  	        var selected = state.selectedDocument;
  	
  	        if (nameNode) {
  	          nameNode.textContent = selected
  	            ? String(selected.name || "Selected document")
  	            : "No document selected";
  	        }
  	
  	        if (clearButton) {
  	          clearButton.style.display = selected ? "inline-flex" : "none";
  	        }
  	      }
  	
  	      function setCaptureDocument(file) {
  	        if (!file) {
  	          state.selectedDocument = null;
  	          showError("fuel-delivery-document-error", "");
  	          refreshCaptureDocumentUi();
  	          return;
  	        }
  	
  	        try {
  	          validateFuelDocument(file);
  	          state.selectedDocument = file;
  	          showError("fuel-delivery-document-error", "");
  	        } catch (documentError) {
  	          state.selectedDocument = null;
  	          showError(
  	            "fuel-delivery-document-error",
  	            documentError && documentError.message
  	              ? documentError.message
  	              : "The selected document is not valid."
  	          );
  	        }
  	
  	        refreshCaptureDocumentUi();
  	      }
  	
  	      function refreshCaptureAdditionalDocumentUi(slot) {
  	        var wanted = Math.round(toNumber(slot, 0));
  	        if (wanted < 1 || wanted > 2) return;
  	
  	        var selected = state.selectedAdditionalDocuments
  	          ? state.selectedAdditionalDocuments[wanted - 1]
  	          : null;
  	        var nameNode = el("fuel-delivery-extra-document-name-" + wanted);
  	        var clearButton = el("fuel-delivery-extra-document-clear-" + wanted);
  	
  	        if (nameNode) {
  	          nameNode.textContent = selected
  	            ? String(selected.name || ("Selected additional document " + wanted))
  	            : "No document selected";
  	        }
  	
  	        if (clearButton) {
  	          clearButton.style.display = selected ? "inline-flex" : "none";
  	        }
  	      }
  	
  	      function refreshCaptureAdditionalDocumentsUi() {
  	        refreshCaptureAdditionalDocumentUi(1);
  	        refreshCaptureAdditionalDocumentUi(2);
  	      }
  	
  	      function setCaptureAdditionalDocument(slot, file) {
  	        var wanted = Math.round(toNumber(slot, 0));
  	        if (wanted < 1 || wanted > 2) return;
  	
  	        if (!Array.isArray(state.selectedAdditionalDocuments)) {
  	          state.selectedAdditionalDocuments = [null, null];
  	        }
  	
  	        if (!file) {
  	          state.selectedAdditionalDocuments[wanted - 1] = null;
  	          showError("fuel-delivery-extra-document-error-" + wanted, "");
  	          refreshCaptureAdditionalDocumentUi(wanted);
  	          return;
  	        }
  	
  	        try {
  	          validateFuelDocument(file);
  	          state.selectedAdditionalDocuments[wanted - 1] = file;
  	          showError("fuel-delivery-extra-document-error-" + wanted, "");
  	        } catch (documentError) {
  	          state.selectedAdditionalDocuments[wanted - 1] = null;
  	          showError(
  	            "fuel-delivery-extra-document-error-" + wanted,
  	            documentError && documentError.message
  	              ? documentError.message
  	              : "The selected additional document is not valid."
  	          );
  	        }
  	
  	        refreshCaptureAdditionalDocumentUi(wanted);
  	      }
  	
  	      function clearValidationMessages() {
  	        showError("fuel-delivery-date-error", "");
  	        showError("fuel-delivery-supplier-error", "");
  	        showError("fuel-delivery-litres-error", "");
  	        showError("fuel-delivery-cost-error", "");
  	        showError("fuel-delivery-reference-error", "");
  	        showHelp("fuel-delivery-litres-help", "");
  	        showError("fuel-delivery-overflow-error", "");
  	      }
  	
  	      function closeModal() {
  	        managerCloseTypedDeleteSafety(false);
  	        revokeDeliveryDocumentPreviewUrl();
  	        var node = el("fuel-delivery-overlay");
  	
  	        if (node) {
  	          managerDestroyThemedSelectsWithin(node);
  	          node.remove();
  	        }
  	      }
  	
  	      function closeDeliveryDetail() {
  	        var backdrop = el("fuel-delivery-detail-backdrop");
  	        var body = el("fuel-delivery-detail-body");
  	
  	        revokeDeliveryDocumentPreviewUrl();
  	
  	        if (body) managerDestroyThemedSelectsWithin(body);
  	        if (backdrop) backdrop.style.display = "none";
  	
  	        state.selectedDelivery = null;
  	        state.editingDelivery = false;
  	      }
  	
  	      function latestCapturePricePerLitre() {
  	        return Math.max(0, toNumber(state.latestPricePerLitre, 0));
  	      }
  	
  	      function currentCaptureCostPerLitre() {
  	        var entered = toNumber(
  	          valueOf("fuel-delivery-cost-per-litre"),
  	          NaN
  	        );
  	
  	        if (!isNaN(entered) && entered >= 0) {
  	          return entered;
  	        }
  	
  	        return latestCapturePricePerLitre();
  	      }
  	
  	      function setCaptureTotalCost(value) {
  	        if (!Number.isFinite(value)) return;
  	        setValue(
  	          "fuel-delivery-cost",
  	          displayNumber(roundMoney2(value), 2)
  	        );
  	      }
  	
  	      function setCaptureCostPerLitre(value) {
  	        if (!Number.isFinite(value)) return;
  	        setValue(
  	          "fuel-delivery-cost-per-litre",
  	          displayNumber(Math.max(0, value), 4)
  	        );
  	      }
  	
  	      function syncPricingAfterLitresChange() {
  	        var litres = toNumber(valueOf("fuel-delivery-litres"), 0);
  	        if (!(litres > 0)) return;
  	
  	        /*
  	         * Litres changes always preserve Cost Per Litre and recalculate the
  	         * invoice total as Litres × Cost Per Litre. If Total Cost was edited
  	         * previously, that edit has already recalculated Cost Per Litre; the
  	         * resulting unit price is then the value preserved here.
  	         */
  	        var costPerLitre = currentCaptureCostPerLitre();
  	        if (costPerLitre >= 0) {
  	          setCaptureTotalCost(litres * costPerLitre);
  	          state.pricingSource = costPerLitre === latestCapturePricePerLitre()
  	            ? "latest"
  	            : "costPerLitre";
  	        }
  	      }
  	
  	      function syncPricingAfterCostPerLitreChange() {
  	        state.pricingSource = "costPerLitre";
  	
  	        var litres = toNumber(valueOf("fuel-delivery-litres"), 0);
  	        var rawCostPerLitre = String(
  	          valueOf("fuel-delivery-cost-per-litre") || ""
  	        ).trim();
  	        var costPerLitre = toNumber(rawCostPerLitre, NaN);
  	
  	        if (
  	          litres > 0 &&
  	          rawCostPerLitre !== "" &&
  	          !isNaN(costPerLitre)
  	        ) {
  	          setCaptureTotalCost(litres * costPerLitre);
  	        }
  	      }
  	
  	      function syncPricingAfterTotalCostChange() {
  	        state.pricingSource = "totalCost";
  	
  	        var litres = toNumber(valueOf("fuel-delivery-litres"), 0);
  	        var rawCost = String(valueOf("fuel-delivery-cost") || "").trim();
  	        var totalCost = toNumber(rawCost, NaN);
  	
  	        if (litres > 0 && rawCost !== "" && !isNaN(totalCost)) {
  	          setCaptureCostPerLitre(totalCost / litres);
  	        }
  	      }
  	
  	      function getLiveDeliveryComputed() {
  	        var capacity = toNumber(getDeep(tank, ["Capacity"], 0), 0);
  	        var volumeBefore = toNumber(getDeep(tank, ["Volume"], 0), 0);
  	        var litres = toNumber(valueOf("fuel-delivery-litres"), 0);
  	        var rawCost = String(valueOf("fuel-delivery-cost") || "").trim();
  	        var cost = toNumber(rawCost, 0);
  	        var enteredCostPerLitre = currentCaptureCostPerLitre();
  	
  	        var levelBefore = capacity > 0 ? ((volumeBefore / capacity) * 100): 0;
  	        var volumeAfter = volumeBefore + litres;
  	        var levelAfter = capacity > 0 ? ((volumeAfter / capacity) * 100): 0;
  	        var remainingCapacity = capacity - volumeAfter;
  	        var costPerLitre = litres > 0 && rawCost !== ""
  	          ? (cost / litres)
  	          : enteredCostPerLitre;
  	        var overflow = remainingCapacity < 0 ? Math.abs(remainingCapacity): 0;
  	
  	        return {
  	          capacity: capacity,
  	          volumeBefore: volumeBefore,
  	          levelBefore: levelBefore,
  	          litres: litres,
  	          cost: cost,
  	          volumeAfter: volumeAfter,
  	          levelAfter: levelAfter,
  	          remainingCapacity: remainingCapacity,
  	          costPerLitre: costPerLitre,
  	          overflow: overflow
  	        };
  	      }
  	
  	      function openDeliverySaveConfirmation() {
  	        return new Promise(function (resolve) {
  	          var existingConfirmation = document.getElementById(
  	            MANAGER_DELIVERY_CONFIRM_OVERLAY_ID
  	          );
  	
  	          if (existingConfirmation) existingConfirmation.remove();
  	
  	          var confirmation = document.createElement("div");
  	          confirmation.id = MANAGER_DELIVERY_CONFIRM_OVERLAY_ID;
  	          confirmation.style.position = "fixed";
  	          confirmation.style.inset = "0";
  	          confirmation.style.zIndex = String(FIF_MAX_Z_INDEX);
  	          confirmation.style.display = "grid";
  	          confirmation.style.placeItems = "center";
  	          confirmation.style.padding = "20px";
  	          confirmation.style.boxSizing = "border-box";
  	          confirmation.style.background = "rgba(0,0,0,0.82)";
  	          confirmation.style.backdropFilter = "blur(7px)";
  	
  	          confirmation.innerHTML = ""
  	          + '<div role="dialog" aria-modal="true" aria-label="Confirm tank delivery" style="width:min(500px,calc(100vw - 40px));padding:22px;box-sizing:border-box;border:1px solid rgba(232,115,57,.56);border-radius:22px;color:#f8fafc;background:linear-gradient(145deg,rgba(24,18,15,.995),rgba(7,10,13,.995));box-shadow:0 28px 70px rgba(0,0,0,.62);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Arial,sans-serif;">'
  	          + '<div style="font-size:19px;font-weight:900;">Save Tank Delivery?</div>'
  	          + '<div style="margin-top:10px;font-size:13px;font-weight:750;line-height:1.55;color:#e6d5ca;">Once saved, the delivery date, litres, reference number and notes are locked. Only the supplier and invoice cost can be corrected later.</div>'
  	          + '<div style="margin-top:12px;padding:11px 13px;border:1px solid rgba(232,115,57,.32);border-radius:13px;background:rgba(156,72,34,.16);font-size:13px;font-weight:850;line-height:1.45;">Are you sure all submitted data is correct?</div>'
  	          + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:18px;">'
  	          + '<button type="button" data-confirm-save="yes" class="fif-miniapp-primary" style="height:44px;border-radius:13px;font-size:12px;font-weight:900;cursor:pointer;">Okay, Save Delivery</button>'
  	          + '<button type="button" data-confirm-save="no" style="height:44px;border:1px solid rgba(255,255,255,.13);border-radius:13px;color:#f8fafc;background:linear-gradient(145deg,rgba(255,255,255,.08),rgba(255,255,255,.035));font-size:12px;font-weight:900;cursor:pointer;">Oops, Let Me Check</button>'
  	          + '</div>'
  	          + '</div>';
  	
  	          document.body.appendChild(confirmation);
  	
  	          function finish(result) {
  	            try { confirmation.remove(); } catch (_) {}
  	            resolve(result === true);
  	          }
  	
  	          confirmation.querySelector('[data-confirm-save="yes"]').onclick = function () {
  	            finish(true);
  	          };
  	
  	          confirmation.querySelector('[data-confirm-save="no"]').onclick = function () {
  	            finish(false);
  	          };
  	
  	          confirmation.onclick = function (event) {
  	            if (event.target === confirmation) finish(false);
  	          };
  	
  	          confirmation.addEventListener("keydown", function (event) {
  	            if (event.key === "Escape") {
  	              event.preventDefault();
  	              finish(false);
  	            }
  	          });
  	
  	          setTimeout(function () {
  	            try {
  	              confirmation.querySelector('[data-confirm-save="no"]').focus();
  	            } catch (_) {}
  	          }, 20);
  	        });
  	      }
  	
  	      function refreshLiveSummary() {
  	        var c = getLiveDeliveryComputed();
  	
  	        setText("fuel-delivery-capacity", displayNumber(c.capacity, 2));
  	        setText("fuel-delivery-volume-before", displayNumber(c.volumeBefore, 2));
  	        setText("fuel-delivery-volume-after", displayNumber(c.volumeAfter, 2));
  	        setText("fuel-delivery-level-before", displayNumber(c.levelBefore, 2) + "%");
  	        setText("fuel-delivery-level-after", displayNumber(c.levelAfter, 2) + "%");
  	        setText("fuel-delivery-remaining-capacity", displayNumber(c.remainingCapacity, 2));
  	
  	        var latestPrice = latestCapturePricePerLitre();
  	        if (state.pricingSource === "totalCost") {
  	          showHelp(
  	            "fuel-delivery-cost-help",
  	            "Total Cost was edited, so Cost Per Litre was recalculated as Total Cost ÷ Litres. A later Litres change will keep that Cost Per Litre and recalculate Total Cost."
  	          );
  	        } else if (state.pricingSource === "costPerLitre") {
  	          showHelp(
  	            "fuel-delivery-cost-help",
  	            "Cost Per Litre controls the invoice total whenever Litres changes: Litres × Cost Per Litre."
  	          );
  	        } else if (latestPrice > 0) {
  	          showHelp(
  	            "fuel-delivery-cost-help",
  	            "Using the latest tank price: R " +
  	              displayNumber(latestPrice, 4) +
  	              " / L. Changing Litres recalculates Total Cost from this price."
  	          );
  	        } else {
  	          showHelp(
  	            "fuel-delivery-cost-help",
  	            "No previous tank price was found. Enter either Cost Per Litre or Total Cost."
  	          );
  	        }
  	
  	        if (c.overflow > 0) {
  	          showError("fuel-delivery-overflow-error", "Delivery exceeds tank capacity by " + displayNumber(c.overflow, 2) + " L");
  	        } else {
  	          showError("fuel-delivery-overflow-error", "");
  	        }
  	
  	        if (c.capacity > 0) {
  	          showHelp("fuel-delivery-litres-help", "Tank capacity " + displayNumber(c.capacity, 2) + " L | Current volume " + displayNumber(c.volumeBefore, 2) + " L");
  	        } else {
  	          showHelp("fuel-delivery-litres-help", "");
  	        }
  	      }
  	
  	      function validateDeliveryDate() {
  	        var v = valueOf("fuel-delivery-date");
  	        if (!v) {
  	          showError("fuel-delivery-date-error", "Delivery date is required");
  	          return false;
  	        }
  	        showError("fuel-delivery-date-error", "");
  	        return true;
  	      }
  	
  	      function validateSupplier() {
  	        var v = String(valueOf("fuel-delivery-supplier") || "").trim();
  	        if (!v) {
  	          showError("fuel-delivery-supplier-error", "Supplier is required");
  	          return false;
  	        }
  	        showError("fuel-delivery-supplier-error", "");
  	        return true;
  	      }
  	
  	      function validateLitres() {
  	        var c = getLiveDeliveryComputed();
  	        if (!(c.litres > 0)) {
  	          showError("fuel-delivery-litres-error", "Litres must be greater than 0");
  	          return false;
  	        }
  	        if (c.overflow > 0) {
  	          showError("fuel-delivery-litres-error", "Litres would overfill the tank");
  	          return false;
  	        }
  	        showError("fuel-delivery-litres-error", "");
  	        return true;
  	      }
  	
  	      function validateCost() {
  	        var cost = toNumber(valueOf("fuel-delivery-cost"), NaN);
  	        if (isNaN(cost)) {
  	          showError("fuel-delivery-cost-error", "Total cost is required");
  	          return false;
  	        }
  	        if (cost < 0) {
  	          showError("fuel-delivery-cost-error", "Total cost cannot be negative");
  	          return false;
  	        }
  	        showError("fuel-delivery-cost-error", "");
  	        return true;
  	      }
  	
  	      function validateReference() {
  	        var v = String(valueOf("fuel-delivery-reference") || "").trim();
  	        if (!v) {
  	          showError("fuel-delivery-reference-error", "Reference No is required");
  	          return false;
  	        }
  	        showError("fuel-delivery-reference-error", "");
  	        return true;
  	      }
  	
  	      function isComplete() {
  	        refreshLiveSummary();
  	        if (!validateDeliveryDate()) return false;
  	        if (!validateSupplier()) return false;
  	        if (!validateLitres()) return false;
  	        if (!validateCost()) return false;
  	        if (!validateReference()) return false;
  	        return true;
  	      }
  	
  	      function updateSaveVisibility() {
  	        var btn = el("fuel-delivery-save-btn");
  	        if (!btn) return;
  	        btn.style.display = isComplete() ? "block": "none";
  	      }
  	
  	      function bindInputRefresh(id, numeric) {
  	        var node = el(id);
  	        if (!node) return;
  	
  	        node.addEventListener("input", function () {
  	          if (numeric) node.value = sanitizeNumeric(node.value);
  	
  	          if (id === "fuel-delivery-cost") {
  	            syncPricingAfterTotalCostChange();
  	          } else if (id === "fuel-delivery-cost-per-litre") {
  	            syncPricingAfterCostPerLitreChange();
  	          } else if (id === "fuel-delivery-litres") {
  	            syncPricingAfterLitresChange();
  	          }
  	
  	          clearValidationMessages();
  	          refreshLiveSummary();
  	          updateSaveVisibility();
  	        });
  	
  	        node.addEventListener("change", function () {
  	          if (id === "fuel-delivery-cost") {
  	            syncPricingAfterTotalCostChange();
  	          } else if (id === "fuel-delivery-cost-per-litre") {
  	            syncPricingAfterCostPerLitreChange();
  	          } else if (id === "fuel-delivery-litres") {
  	            syncPricingAfterLitresChange();
  	          }
  	
  	          clearValidationMessages();
  	          refreshLiveSummary();
  	          updateSaveVisibility();
  	        });
  	      }
  	
  	      function buildDeliveryRow(item, index) {
  	        var fuelDate = formatDatePretty(getDeep(item, ["FuelDate"], ""));
  	        var supplier = text(getDeep(item, ["Supplier"], ""), "Unknown Supplier");
  	        var tankName = getDeliveryTankName(item);
  	        var referenceNo = text(getDeep(item, ["ReferenceNo"], ""), "");
  	        var litres = displayNumber(getDeep(item, ["Litres"], 0), 2) + " L";
  	        var cost = formatCurrency(getDeep(item, ["Cost"], 0));
  	        var cpl = "R " + displayNumber(getDeep(item, ["CostPerLitre"], 0), 4);
  	        var description = text(getDeep(item, ["Description"], ""), "");
  	
  	        return ""
  	        + '<button type="button" class="fuel-delivery-item" data-delivery-index="' + index + '">'
  	        + '  <div class="fuel-delivery-row-grid fuel-ledger-row-grid">'
  	        + '    <div class="fuel-ledger-primary">'
  	        + '      <div class="fuel-ledger-primary-name">' + escapeHtml(supplier) + "</div>"
  	        + '      <div class="fuel-ledger-primary-meta">' + escapeHtml(referenceNo || "No reference") + (description ? " · " + escapeHtml(description): "") + "</div>"
  	        + "    </div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(tankName) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(litres) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(cost) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell"><strong>' + escapeHtml(cpl) + "</strong></div>"
  	        + '    <div class="fuel-ledger-cell fuel-ledger-cell-date"><strong>' + escapeHtml(fuelDate || ("Delivery " + (index + 1))) + "</strong></div>"
  	        + "  </div>"
  	        + "</button>";
  	      }
  	
  	      function bindDeliveryRowClicks() {
  	        var listNode = el("fuel-delivery-list");
  	        if (!listNode) return;
  	
  	        var buttons = listNode.querySelectorAll("[data-delivery-index]");
  	        for (var i = 0; i < buttons.length; i++) {
  	          buttons[i].onclick = function () {
  	            var idx = toNumber(this.getAttribute("data-delivery-index"), -1);
  	            if (idx < 0 || idx >= state.filteredDeliveries.length) return;
  	            openDeliveryDetail(state.filteredDeliveries[idx]);
  	          };
  	        }
  	      }
  	
  	      function replaceDeliveryByObjectId(items, savedDelivery) {
  	        var rows = toArray(items);
  	        var savedId = getDeep(savedDelivery, ["objectId"], null);
  	        var found = false;
  	        var result = rows.map(function (row) {
  	          if (
  	            savedId &&
  	            sameKey(getDeep(row, ["objectId"], null), savedId)
  	          ) {
  	            found = true;
  	            return Object.assign({}, row, savedDelivery);
  	          }
  	
  	          return row;
  	        });
  	
  	        if (!found && savedDelivery) result.unshift(savedDelivery);
  	        return uniqueRowsByObjectId(result);
  	      }
  	
  	      function viewContainsDelivery(view, objectId) {
  	        return toArray(getDeep(view, ["FuelIn"], [])).some(function (row) {
  	          return sameKey(getDeep(row, ["objectId"], null), objectId);
  	        });
  	      }
  	
  	      function findViewContainingDelivery(item) {
  	        var objectId = getDeep(item, ["objectId"], null);
  	
  	        if (objectId && viewContainsDelivery(state.currentView, objectId)) {
  	          return state.currentView;
  	        }
  	
  	        for (var index = 0; index < state.historyViews.length; index++) {
  	          if (objectId && viewContainsDelivery(state.historyViews[index], objectId)) {
  	            return state.historyViews[index];
  	          }
  	        }
  	
  	        return findTankViewByMonth(
  	          state.currentView,
  	          state.historyViews,
  	          getFuelInMonthKey(item)
  	        );
  	      }
  	
  	      function updateCorrectedDeliveryLocally(savedDelivery, targetView) {
  	        var savedId = getDeep(savedDelivery, ["objectId"], null);
  	
  	        tank.FuelIn = replaceDeliveryByObjectId(
  	          getDeep(tank, ["FuelIn"], []),
  	          savedDelivery
  	        );
  	        state.allDeliveries = replaceDeliveryByObjectId(
  	          state.allDeliveries,
  	          savedDelivery
  	        );
  	        state.deliveryCache = replaceDeliveryByObjectId(
  	          state.deliveryCache,
  	          savedDelivery
  	        );
  	        state.filteredDeliveries = replaceDeliveryByObjectId(
  	          state.filteredDeliveries,
  	          savedDelivery
  	        );
  	
  	        function updateView(view) {
  	          if (!view || !savedId || !viewContainsDelivery(view, savedId)) return;
  	
  	          view.FuelIn = replaceDeliveryByObjectId(
  	            getDeep(view, ["FuelIn"], []),
  	            savedDelivery
  	          );
  	
  	          var totals = buildTankViewTotals(view.FuelIn);
  	          view.Litres = totals.litres;
  	          view.Cost = totals.cost;
  	        }
  	
  	        updateView(state.currentView);
  	        for (var index = 0; index < state.historyViews.length; index++) {
  	          updateView(state.historyViews[index]);
  	        }
  	
  	        if (targetView) updateView(targetView);
  	
  	        applyTankViewState(tank, state.currentView, state.historyViews);
  	        state.latestPricePerLitre = Math.max(
  	          0,
  	          managerLatestCostPerLitre(tank)
  	        );
  	        tank.LatestCostPerLitre = state.latestPricePerLitre;
  	        syncTankIntoLiveAppData(tank);
  	        state.selectedDelivery = savedDelivery;
  	
  	        try {
  	          if (context && typeof context.onChanged === "function") {
  	            context.onChanged();
  	          }
  	        } catch (_) {}
  	
  	        try {
  	          managerRenderDashboard();
  	        } catch (_) {}
  	      }
  	
  	      async function saveDeliveryCorrection(item, supplier, supplierId, cost) {
  	        var objectId = getDeep(item, ["objectId"], null);
  	        var litres = toNumber(getDeep(item, ["Litres"], 0), 0);
  	        var roundedCost = roundMoney2(cost);
  	        var costPerLitre = litres > 0 ? roundedCost / litres : 0;
  	        var originalCost = roundMoney2(
  	          toNumber(getDeep(item, ["Cost"], 0), 0)
  	        );
  	        var costChanged = Math.abs(roundedCost - originalCost) >= 0.005;
  	        var targetView = findViewContainingDelivery(item);
  	        var targetViewId = getDeep(targetView, ["objectId"], null);
  	
  	        if (!objectId) {
  	          throw new Error("This delivery has no objectId and cannot be corrected.");
  	        }
  	
  	        if (!(litres > 0)) {
  	          throw new Error("The saved delivery litres are invalid, so its price cannot be recalculated.");
  	        }
  	
  	        if (costChanged && !targetViewId) {
  	          throw new Error(
  	            "The monthly TankView for this delivery is missing. The invoice cost was not changed."
  	          );
  	        }
  	
  	        var patch = {
  	          objectId: objectId,
  	          Supplier: supplier,
  	          SupplierId: supplierId,
  	          Cost: roundedCost,
  	          CostPerLitre: costPerLitre
  	        };
  	        var originalPatch = {
  	          objectId: objectId,
  	          Supplier: text(getDeep(item, ["Supplier"], ""), ""),
  	          SupplierId: text(getDeep(item, ["SupplierId"], ""), ""),
  	          Cost: originalCost,
  	          CostPerLitre: toNumber(
  	            getDeep(item, ["CostPerLitre"], litres > 0 ? originalCost / litres : 0),
  	            0
  	          )
  	        };
  	        var savedFuelIn = await saveTableRow("FuelIn", patch);
  	        var correctedDelivery = Object.assign({}, item, patch, savedFuelIn || {});
  	
  	        if (costChanged) {
  	          var correctedRows = replaceDeliveryByObjectId(
  	            getDeep(targetView, ["FuelIn"], []),
  	            correctedDelivery
  	          );
  	          var totals = buildTankViewTotals(correctedRows);
  	
  	          try {
  	            var savedViewPatch = await saveTableRow("TankView", {
  	              objectId: targetViewId,
  	              Litres: totals.litres,
  	              Cost: totals.cost
  	            });
  	
  	            Object.assign(targetView, savedViewPatch || {});
  	            targetView.FuelIn = correctedRows;
  	            targetView.Litres = totals.litres;
  	            targetView.Cost = totals.cost;
  	          } catch (viewError) {
  	            try {
  	              await saveTableRow("FuelIn", originalPatch);
  	            } catch (rollbackError) {
  	              console.error(
  	                "FuelIn correction rollback failed:",
  	                rollbackError
  	              );
  	            }
  	
  	            throw new Error(
  	              "The delivery correction could not update its monthly totals, so the FuelIn change was rolled back. " +
  	              (viewError && viewError.message ? viewError.message : "")
  	            );
  	          }
  	        }
  	
  	        updateCorrectedDeliveryLocally(correctedDelivery, targetView);
  	        return correctedDelivery;
  	      }
  	
  	      function confirmRemoveDeliveryDocument(documentName) {
  	        return new Promise(function (resolve) {
  	          var confirmationId = "fif-fuel-document-remove-confirmation";
  	          var existing = document.getElementById(confirmationId);
  	          if (existing) existing.remove();
  	
  	          var confirmation = document.createElement("div");
  	          confirmation.id = confirmationId;
  	          confirmation.style.position = "fixed";
  	          confirmation.style.inset = "0";
  	          confirmation.style.zIndex = String(FIF_MAX_Z_INDEX);
  	          confirmation.style.display = "grid";
  	          confirmation.style.placeItems = "center";
  	          confirmation.style.padding = "20px";
  	          confirmation.style.boxSizing = "border-box";
  	          confirmation.style.background = "rgba(0,0,0,0.82)";
  	          confirmation.style.backdropFilter = "blur(7px)";
  	
  	          confirmation.innerHTML = ""
  	          + '<div role="dialog" aria-modal="true" aria-label="Remove delivery document" style="width:min(480px,calc(100vw - 40px));padding:22px;box-sizing:border-box;border:1px solid rgba(232,115,57,.56);border-radius:22px;color:#f8fafc;background:linear-gradient(145deg,rgba(24,18,15,.995),rgba(7,10,13,.995));box-shadow:0 28px 70px rgba(0,0,0,.62);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Arial,sans-serif;">'
  	          + '<div style="font-size:19px;font-weight:900;">Remove Delivery Document?</div>'
  	          + '<div style="margin-top:10px;font-size:13px;font-weight:700;line-height:1.55;color:#e6d5ca;">This removes <strong>' + escapeHtml(text(documentName, "the attached document")) + '</strong> from this FuelIn transaction. The fuel delivery itself will not be changed.</div>'
  	          + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:18px;">'
  	          + '<button type="button" data-document-remove="yes" style="height:44px;border:1px solid rgba(239,68,68,.50);border-radius:13px;color:#fff;background:linear-gradient(145deg,#9f2f26,#5e1c18);font-size:12px;font-weight:900;cursor:pointer;">Remove Document</button>'
  	          + '<button type="button" data-document-remove="no" style="height:44px;border:1px solid rgba(255,255,255,.13);border-radius:13px;color:#f8fafc;background:linear-gradient(145deg,rgba(255,255,255,.08),rgba(255,255,255,.035));font-size:12px;font-weight:900;cursor:pointer;">Keep Document</button>'
  	          + '</div>'
  	          + '</div>';
  	
  	          document.body.appendChild(confirmation);
  	
  	          function finish(result) {
  	            try { confirmation.remove(); } catch (_) {}
  	            resolve(result === true);
  	          }
  	
  	          confirmation.querySelector('[data-document-remove="yes"]').onclick = function () {
  	            finish(true);
  	          };
  	          confirmation.querySelector('[data-document-remove="no"]').onclick = function () {
  	            finish(false);
  	          };
  	          confirmation.onclick = function (event) {
  	            if (event.target === confirmation) finish(false);
  	          };
  	          confirmation.addEventListener("keydown", function (event) {
  	            if (event.key === "Escape") {
  	              event.preventDefault();
  	              finish(false);
  	            }
  	          });
  	
  	          setTimeout(function () {
  	            try {
  	              confirmation.querySelector('[data-document-remove="no"]').focus();
  	            } catch (_) {}
  	          }, 20);
  	        });
  	      }
  	
  	
  	      function fuelAdditionalDocumentsPanelHtml(item) {
  	        var html = ""
  	        + '<div style="margin-top:10px;padding:13px 14px;border:1px solid rgba(204,102,51,.20);border-radius:14px;background:linear-gradient(145deg,rgba(156,72,34,.07),rgba(255,255,255,.02));">'
  	        + '<div style="font-size:12px;font-weight:850;color:#f8fafc;">Additional Documents / Images <span style="color:#94a3b8;font-weight:650;">(Optional · FuelIn.Docs JSON)</span></div>'
  	        + '<div class="fuel-additional-doc-grid" style="margin-top:10px;">';
  	
  	        for (var slot = 1; slot <= 2; slot++) {
  	          var doc = fuelInAdditionalDocAt(item, slot);
  	          var url = doc ? text(getDeep(doc, ["URL"], ""), "") : "";
  	          var name = doc
  	            ? text(getDeep(doc, ["Name"], ""), "Additional delivery document " + slot)
  	            : "No document attached";
  	
  	          html += ""
  	          + '<div class="fuel-additional-doc-card">'
  	          + '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;flex-wrap:wrap;">'
  	          + '<div style="min-width:0;flex:1;">'
  	          + '<div style="font-size:10px;font-weight:850;color:#cbd5e1;">Additional Document ' + escapeHtml(String(slot)) + '</div>'
  	          + '<div style="margin-top:5px;font-size:11px;color:' + (url ? '#e2e8f0' : '#94a3b8') + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(name) + '</div>'
  	          + '</div>'
  	          + '<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;">'
  	          + (url
  	            ? '<button id="fuel-delivery-extra-document-download-' + slot + '" type="button" class="fuel-document-button">Download</button><button id="fuel-delivery-extra-document-replace-' + slot + '" type="button" class="fuel-document-button">Replace</button><button id="fuel-delivery-extra-document-remove-' + slot + '" type="button" class="fuel-document-button danger">Remove</button>'
  	            : '<button id="fuel-delivery-extra-document-add-' + slot + '" type="button" class="fuel-document-button">Add Document</button>')
  	          + '</div>'
  	          + '</div>'
  	          + '<input id="fuel-delivery-extra-document-detail-input-' + slot + '" type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp" style="display:none;">'
  	          + (url ? '<div id="fuel-delivery-extra-document-preview-' + slot + '" style="margin-top:8px;"></div>' : '')
  	          + '</div>';
  	        }
  	
  	        html += ""
  	        + '</div>'
  	        + '<div style="margin-top:7px;color:#94a3b8;font-size:10px;line-height:1.4;">Maximum two supporting files. PDF, JPG, PNG or WEBP · Maximum 10 MB each.</div>'
  	        + '</div>';
  	
  	        return html;
  	      }
  	
  	      function bindFuelAdditionalDocumentActions(item) {
  	        for (var slot = 1; slot <= 2; slot++) {
  	          (function (wantedSlot) {
  	            var input = el("fuel-delivery-extra-document-detail-input-" + wantedSlot);
  	            var addButton = el("fuel-delivery-extra-document-add-" + wantedSlot);
  	            var replaceButton = el("fuel-delivery-extra-document-replace-" + wantedSlot);
  	            var downloadButton = el("fuel-delivery-extra-document-download-" + wantedSlot);
  	            var removeButton = el("fuel-delivery-extra-document-remove-" + wantedSlot);
  	
  	            function openPicker() {
  	              if (input) input.click();
  	            }
  	
  	            if (addButton) addButton.onclick = openPicker;
  	            if (replaceButton) replaceButton.onclick = openPicker;
  	
  	            if (input) {
  	              input.onchange = async function () {
  	                var file = this.files && this.files.length ? this.files[0] : null;
  	                if (!file) return;
  	
  	                var existingDoc = fuelInAdditionalDocAt(item, wantedSlot);
  	                managerBeginLoading(
  	                  existingDoc
  	                    ? "Replacing additional delivery document " + wantedSlot + "…"
  	                    : "Uploading additional delivery document " + wantedSlot + "…"
  	                );
  	
  	                try {
  	                  validateFuelDocument(file);
  	                  var updated = await attachFuelAdditionalDocumentToSavedDelivery(
  	                    item,
  	                    file,
  	                    wantedSlot
  	                  );
  	                  state.selectedDelivery = updated;
  	                  applyDeliverySearch();
  	                  renderDeliveryDetailBody(updated);
  	                  managerCompleteLoading(
  	                    "Additional delivery document " + wantedSlot + " was uploaded successfully."
  	                  );
  	                } catch (documentError) {
  	                  managerFailLoading(
  	                    documentError && documentError.message
  	                      ? documentError.message
  	                      : "The additional delivery document could not be uploaded."
  	                  );
  	                } finally {
  	                  if (input) input.value = "";
  	                }
  	              };
  	            }
  	
  	            if (downloadButton) {
  	              downloadButton.onclick = async function () {
  	                var doc = fuelInAdditionalDocAt(item, wantedSlot);
  	                if (!doc) return;
  	
  	                managerBeginLoading(
  	                  "Preparing additional delivery document " + wantedSlot + "…"
  	                );
  	
  	                try {
  	                  await downloadFuelInAdditionalDocument(doc);
  	                  managerCompleteLoading("The additional document download has started.");
  	                } catch (documentError) {
  	                  managerFailLoading(
  	                    documentError && documentError.message
  	                      ? documentError.message
  	                      : "The additional delivery document could not be downloaded."
  	                  );
  	                }
  	              };
  	            }
  	
  	            if (removeButton) {
  	              removeButton.onclick = async function () {
  	                var doc = fuelInAdditionalDocAt(item, wantedSlot);
  	                if (!doc) return;
  	
  	                var confirmed = await confirmRemoveDeliveryDocument(
  	                  getDeep(doc, ["Name"], "the attached additional document")
  	                );
  	                if (!confirmed) return;
  	
  	                managerBeginLoading(
  	                  "Removing additional delivery document " + wantedSlot + "…"
  	                );
  	
  	                try {
  	                  var updated = await removeFuelAdditionalDocumentFromSavedDelivery(
  	                    item,
  	                    wantedSlot
  	                  );
  	                  state.selectedDelivery = updated;
  	                  applyDeliverySearch();
  	                  renderDeliveryDetailBody(updated);
  	                  managerCompleteLoading(
  	                    "Additional document " + wantedSlot + " was removed. The fuel delivery was not changed."
  	                  );
  	                } catch (documentError) {
  	                  managerFailLoading(
  	                    documentError && documentError.message
  	                      ? documentError.message
  	                      : "The additional delivery document could not be removed."
  	                  );
  	                }
  	              };
  	            }
  	          })(slot);
  	        }
  	      }
  	
  	      function bindDeliveryDocumentActions(item) {
  	        var input = el("fuel-delivery-detail-document-input");
  	        var addButton = el("fuel-delivery-document-add");
  	        var replaceButton = el("fuel-delivery-document-replace");
  	        var downloadButton = el("fuel-delivery-document-download");
  	        var removeButton = el("fuel-delivery-document-remove");
  	
  	        function openPicker() {
  	          if (input) input.click();
  	        }
  	
  	        if (addButton) addButton.onclick = openPicker;
  	        if (replaceButton) replaceButton.onclick = openPicker;
  	
  	        if (input) {
  	          input.onchange = async function () {
  	            var file = this.files && this.files.length ? this.files[0] : null;
  	            if (!file) return;
  	
  	            managerBeginLoading(
  	              getDeep(item, ["DocumentURL"], null)
  	                ? "Replacing delivery document…"
  	                : "Uploading delivery document…"
  	            );
  	
  	            try {
  	              validateFuelDocument(file);
  	              var updated = await attachFuelDocumentToSavedDelivery(item, file);
  	              state.selectedDelivery = updated;
  	              applyDeliverySearch();
  	              renderDeliveryDetailBody(updated);
  	              managerCompleteLoading(
  	                "The delivery document was uploaded successfully."
  	              );
  	            } catch (documentError) {
  	              managerFailLoading(
  	                documentError && documentError.message
  	                  ? documentError.message
  	                  : "The delivery document could not be uploaded."
  	              );
  	            } finally {
  	              if (input) input.value = "";
  	            }
  	          };
  	        }
  	
  	        if (downloadButton) {
  	          downloadButton.onclick = async function () {
  	            managerBeginLoading("Preparing delivery document…");
  	
  	            try {
  	              await downloadFuelInDocument(item);
  	              managerCompleteLoading("The document download has started.");
  	            } catch (documentError) {
  	              managerFailLoading(
  	                documentError && documentError.message
  	                  ? documentError.message
  	                  : "The delivery document could not be downloaded."
  	              );
  	            }
  	          };
  	        }
  	
  	        if (removeButton) {
  	          removeButton.onclick = async function () {
  	            var confirmed = await confirmRemoveDeliveryDocument(
  	              getDeep(item, ["DocumentName"], "the attached document")
  	            );
  	            if (!confirmed) return;
  	
  	            managerBeginLoading("Removing delivery document…");
  	
  	            try {
  	              var updated = await removeFuelDocumentFromSavedDelivery(item);
  	              state.selectedDelivery = updated;
  	              applyDeliverySearch();
  	              renderDeliveryDetailBody(updated);
  	              managerCompleteLoading(
  	                "The document was removed. The fuel delivery was not changed."
  	              );
  	            } catch (documentError) {
  	              managerFailLoading(
  	                documentError && documentError.message
  	                  ? documentError.message
  	                  : "The delivery document could not be removed."
  	              );
  	            }
  	          };
  	        }
  	      }
  	
  	      function renderDeliveryDetailBody(item) {
  	        var body = el("fuel-delivery-detail-body");
  	        var editButton = el("fuel-delivery-detail-edit");
  	
  	        if (!body || !item) return;
  	
  	        managerDestroyThemedSelectsWithin(body);
  	        revokeDeliveryDocumentPreviewUrl();
  	        state.editingDelivery = false;
  	
  	        var documentUrl = text(getDeep(item, ["DocumentURL"], ""), "");
  	        var documentName = text(
  	          getDeep(item, ["DocumentName"], ""),
  	          "Fuel delivery document"
  	        );
  	        var documentPanelHtml = ""
  	        + '<div style="margin-top:14px;padding:13px 14px;border:1px solid rgba(204,102,51,.24);border-radius:14px;background:linear-gradient(145deg,rgba(156,72,34,.10),rgba(255,255,255,.025));">'
  	        + '<div style="display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;">'
  	        + '<div style="min-width:0;flex:1;">'
  	        + '<div style="font-size:12px;font-weight:850;color:#f8fafc;">Delivery Document <span style="color:#94a3b8;font-weight:650;">(Optional)</span></div>'
  	        + '<div style="margin-top:5px;font-size:11px;color:' + (documentUrl ? '#e2e8f0' : '#94a3b8') + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(documentUrl ? documentName : "No document attached") + '</div>'
  	        + '</div>'
  	        + '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">'
  	        + (documentUrl
  	          ? '<button id="fuel-delivery-document-download" type="button" class="fuel-document-button">Download</button><button id="fuel-delivery-document-replace" type="button" class="fuel-document-button">Replace</button><button id="fuel-delivery-document-remove" type="button" class="fuel-document-button danger">Remove</button>'
  	          : '<button id="fuel-delivery-document-add" type="button" class="fuel-document-button">Add Document</button>')
  	        + '</div>'
  	        + '</div>'
  	        + '<input id="fuel-delivery-detail-document-input" type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp" style="display:none;">'
  	        + '<div style="margin-top:7px;color:#94a3b8;font-size:10px;line-height:1.4;">PDF, JPG, PNG or WEBP · Maximum 10 MB</div>'
  	        + (documentUrl ? '<div id="fuel-delivery-document-preview" style="margin-top:10px;"></div>' : '')
  	        + '</div>';
  	
  	        body.innerHTML = ""
  	        + '<div style="margin-bottom:12px;padding:10px 12px;border:1px solid rgba(204,102,51,.25);border-radius:12px;background:rgba(156,72,34,.10);font-size:11px;font-weight:750;line-height:1.5;color:#d9c7bb;">Saved delivery quantities and dates are locked. Only the supplier and invoice cost may be corrected.</div>'
  	        + '<div style="display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;">'
  	        + '<div style="background:rgba(255,255,255,0.04);border-radius:12px;padding:12px 14px;">'
  	        + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:6px;">Delivery</div>'
  	        + buildDetailRow("Tank", getDeliveryTankName(item))
  	        + buildDetailRow("Fuel Date", formatDatePretty(getDeep(item, ["FuelDate"], "")))
  	        + buildDetailRow("Entry Type", getDeep(item, ["EntryType"], "delivery"))
  	        + buildDetailRow("Supplier", getDeep(item, ["Supplier"], ""))
  	        + buildDetailRow("Reference No", getDeep(item, ["ReferenceNo"], ""))
  	        + buildDetailRow("Description", getDeep(item, ["Description"], ""))
  	        + "</div>"
  	        + '<div style="background:rgba(255,255,255,0.04);border-radius:12px;padding:12px 14px;">'
  	        + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:6px;">Figures</div>'
  	        + buildDetailRow("Litres", displayNumber(getDeep(item, ["Litres"], 0), 2))
  	        + buildDetailRow("Cost", formatCurrency(getDeep(item, ["Cost"], 0)))
  	        + buildDetailRow("Cost Per Litre", "R " + displayNumber(getDeep(item, ["CostPerLitre"], 0), 4))
  	        + buildDetailRow("Volume Before", displayNumber(getDeep(item, ["VolumeBefore"], 0), 2))
  	        + buildDetailRow("Volume After", displayNumber(getDeep(item, ["VolumeAfter"], 0), 2))
  	        + buildDetailRow("Level Before", displayNumber(getDeep(item, ["LevelBefore"], 0), 2) + "%")
  	        + buildDetailRow("Level After", displayNumber(getDeep(item, ["LevelAfter"], 0), 2) + "%")
  	        + "</div>"
  	        + "</div>"
  	        + documentPanelHtml
  	        + fuelAdditionalDocumentsPanelHtml(item);
  	
  	        if (editButton) {
  	          editButton.disabled = !getDeep(item, ["objectId"], null);
  	          editButton.style.opacity = editButton.disabled ? "0.42" : "1";
  	          editButton.textContent = "Edit Supplier / Cost";
  	          editButton.onclick = function () {
  	            openDeliveryCorrectionEditor(item);
  	          };
  	        }
  	
  	        bindDeliveryDocumentActions(item);
  	        bindFuelAdditionalDocumentActions(item);
  	
  	        if (documentUrl) {
  	          renderFuelInDocumentPreview(item);
  	        }
  	
  	        for (var additionalSlot = 1; additionalSlot <= 2; additionalSlot++) {
  	          var additionalDoc = fuelInAdditionalDocAt(item, additionalSlot);
  	          if (additionalDoc) {
  	            renderFuelInAdditionalDocumentPreview(
  	              item,
  	              additionalDoc,
  	              additionalSlot
  	            );
  	          }
  	        }
  	      }
  	
  	      function openDeliveryCorrectionEditor(item) {
  	        var body = el("fuel-delivery-detail-body");
  	        var editButton = el("fuel-delivery-detail-edit");
  	        if (!body || !item) return;
  	
  	        managerDestroyThemedSelectsWithin(body);
  	        state.editingDelivery = true;
  	
  	        var currentCost = roundMoney2(
  	          toNumber(getDeep(item, ["Cost"], 0), 0)
  	        );
  	        var litres = toNumber(getDeep(item, ["Litres"], 0), 0);
  	
  	        body.innerHTML = ""
  	        + '<div style="padding:12px 14px;border:1px solid rgba(204,102,51,.30);border-radius:14px;background:rgba(156,72,34,.11);font-size:11px;font-weight:750;line-height:1.5;color:#e1d0c5;">This correction does not alter tank volume, litres, date, reference or notes. Changing the invoice cost recalculates Cost Per Litre and the related monthly TankView cost.</div>'
  	        + '<div style="display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;margin-top:14px;">'
  	        + '<div><label style="display:block;margin:0 0 7px 2px;font-size:12px;font-weight:800;color:#cbd5e1;">Supplier</label>'
  	        + '<select id="fuel-delivery-edit-supplier" class="fuel-soft-input">'
  	        + deliverySupplierOptionsForItem(item)
  	        + '</select></div>'
  	        + '<div><label style="display:block;margin:0 0 7px 2px;font-size:12px;font-weight:800;color:#cbd5e1;">Invoice Cost</label>'
  	        + '<input id="fuel-delivery-edit-cost" type="text" inputmode="decimal" class="fuel-soft-input" value="' + escapeHtml(displayNumber(currentCost, 2)) + '">'
  	        + '<div id="fuel-delivery-edit-cost-error" class="fuel-error-text"></div></div>'
  	        + '<div style="grid-column:1/-1;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;">'
  	        + '<div style="padding:11px 13px;border-radius:12px;background:rgba(255,255,255,.04);"><div style="font-size:9px;color:#94a3b8;text-transform:uppercase;">Locked Litres</div><div style="margin-top:4px;font-size:15px;font-weight:900;">' + escapeHtml(displayNumber(litres, 2)) + ' L</div></div>'
  	        + '<div style="padding:11px 13px;border-radius:12px;background:rgba(255,255,255,.04);"><div style="font-size:9px;color:#94a3b8;text-transform:uppercase;">Recalculated Cost / Litre</div><div id="fuel-delivery-edit-cpl" style="margin-top:4px;font-size:15px;font-weight:900;">R 0.0000</div></div>'
  	        + '</div>'
  	        + '</div>'
  	        + '<div style="display:flex;justify-content:flex-end;gap:10px;margin-top:16px;">'
  	        + '<button id="fuel-delivery-edit-cancel" type="button" style="height:42px;padding:0 18px;border:1px solid rgba(255,255,255,.12);border-radius:12px;color:#f8fafc;background:rgba(255,255,255,.05);font-size:12px;font-weight:850;cursor:pointer;">Cancel</button>'
  	        + '<button id="fuel-delivery-edit-save" type="button" class="fif-miniapp-primary" style="height:42px;padding:0 20px;border-radius:12px;font-size:12px;font-weight:900;cursor:pointer;">Save Correction</button>'
  	        + '</div>';
  	
  	        managerThemeSelects(body);
  	
  	        if (editButton) {
  	          editButton.disabled = true;
  	          editButton.style.opacity = "0.42";
  	          editButton.textContent = "Editing";
  	        }
  	
  	        var supplierSelect = el("fuel-delivery-edit-supplier");
  	        var costInput = el("fuel-delivery-edit-cost");
  	        var costError = el("fuel-delivery-edit-cost-error");
  	        var preview = el("fuel-delivery-edit-cpl");
  	        var saveButton = el("fuel-delivery-edit-save");
  	        var cancelButton = el("fuel-delivery-edit-cancel");
  	
  	        function refreshCorrectionPreview() {
  	          if (costInput) costInput.value = sanitizeNumeric(costInput.value);
  	          var cost = toNumber(costInput ? costInput.value : 0, NaN);
  	          var valid = !isNaN(cost) && cost >= 0;
  	
  	          if (preview) {
  	            preview.textContent = valid && litres > 0
  	              ? "R " + displayNumber(cost / litres, 4)
  	              : "R 0.0000";
  	          }
  	
  	          if (costError) {
  	            costError.style.display = valid ? "none" : "block";
  	            costError.textContent = valid
  	              ? ""
  	              : "Invoice cost must be zero or greater.";
  	          }
  	
  	          if (saveButton) saveButton.disabled = !valid;
  	        }
  	
  	        if (costInput) costInput.addEventListener("input", refreshCorrectionPreview);
  	        refreshCorrectionPreview();
  	
  	        if (cancelButton) {
  	          cancelButton.onclick = function () {
  	            renderDeliveryDetailBody(item);
  	          };
  	        }
  	
  	        if (saveButton) {
  	          saveButton.onclick = async function () {
  	            var cost = toNumber(costInput ? costInput.value : 0, NaN);
  	            if (isNaN(cost) || cost < 0) {
  	              refreshCorrectionPreview();
  	              return;
  	            }
  	
  	            var existingSupplier = text(
  	              getDeep(item, ["Supplier"], ""),
  	              ""
  	            );
  	            var existingSupplierId = text(
  	              getDeep(item, ["SupplierId"], ""),
  	              ""
  	            );
  	            var supplier = supplierSelect
  	              ? String(supplierSelect.value || "").trim()
  	              : existingSupplier;
  	            var selectedOption = supplierSelect && supplierSelect.selectedIndex >= 0
  	              ? supplierSelect.options[supplierSelect.selectedIndex]
  	              : null;
  	            var supplierId = selectedOption
  	              ? String(selectedOption.getAttribute("data-supplier-id") || "").trim()
  	              : existingSupplierId;
  	
  	            if (!supplier) {
  	              supplier = existingSupplier;
  	              supplierId = existingSupplierId;
  	            }
  	
  	            managerBeginLoading("Saving delivery correction…");
  	
  	            try {
  	              setButtonBusy(saveButton, true, "Saving...");
  	              var corrected = await saveDeliveryCorrection(
  	                item,
  	                supplier,
  	                supplierId,
  	                cost
  	              );
  	
  	              state.selectedDelivery = corrected;
  	              applyDeliverySearch();
  	              renderDeliveryDetailBody(corrected);
  	
  	              var title = el("fuel-delivery-detail-title");
  	              if (title) {
  	                title.textContent = text(
  	                  getDeep(corrected, ["Supplier"], ""),
  	                  "Unknown Supplier"
  	                );
  	              }
  	
  	              managerCompleteLoading(
  	                "Supplier and invoice cost correction saved successfully."
  	              );
  	            } catch (error) {
  	              managerFailLoading(
  	                error && error.message
  	                  ? error.message
  	                  : "The delivery correction could not be saved."
  	              );
  	            } finally {
  	              setButtonBusy(saveButton, false, "Save Correction");
  	            }
  	          };
  	        }
  	      }
  	
  	      function openDeliveryDetail(item) {
  	        state.selectedDelivery = item || null;
  	
  	        var backdrop = el("fuel-delivery-detail-backdrop");
  	        var title = el("fuel-delivery-detail-title");
  	        var subtitleNode = el("fuel-delivery-detail-subtitle");
  	
  	        if (!backdrop || !item) return;
  	
  	        var supplier = text(getDeep(item, ["Supplier"], ""), "Unknown Supplier");
  	        var formattedDate = formatDatePretty(getDeep(item, ["FuelDate"], ""));
  	        var objectId = text(getDeep(item, ["objectId"], ""), "");
  	
  	        if (title) title.textContent = supplier;
  	        if (subtitleNode) {
  	          subtitleNode.textContent = formattedDate + (objectId ? " | " + objectId : "");
  	        }
  	
  	        renderDeliveryDetailBody(item);
  	        backdrop.style.display = "flex";
  	      }
  	
  	      function renderDeliveryListFromState() {
  	        var listNode = el("fuel-delivery-list");
  	        if (!listNode) return;
  	
  	        var deliveries = toArray(state.filteredDeliveries);
  	
  	        if (!deliveries.length) {
  	          listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No matching deliveries</div>'
  	          + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Try a different search term or clear the filter.</div>'
  	          + "</div>";
  	          return;
  	        }
  	
  	        var html = "";
  	        for (var i = 0; i < deliveries.length; i++) {
  	          html += buildDeliveryRow(deliveries[i], i);
  	        }
  	        listNode.innerHTML = html;
  	        bindDeliveryRowClicks();
  	      }
  	
  	      function updateDeliverySortUi() {
  	        var buttons = modal.querySelectorAll("[data-delivery-sort-key]");
  	
  	        for (var i = 0; i < buttons.length; i++) {
  	          var button = buttons[i];
  	          var key = String(button.getAttribute("data-delivery-sort-key") || "");
  	          var active = key === state.sortKey;
  	          var arrow = button.querySelector(".fuel-sort-arrow");
  	
  	          button.classList.toggle("active", active);
  	          button.setAttribute("aria-sort", active
  	            ? (state.sortDirection === "asc" ? "ascending": "descending")
  	            : "none");
  	
  	          if (arrow) {
  	            arrow.textContent = active
  	              ? (state.sortDirection === "asc" ? "▲": "▼")
  	              : "↕";
  	          }
  	        }
  	      }
  	
  	      function applyDeliverySearch() {
  	        var raw = valueOf("fuel-delivery-search");
  	        var term = String(raw || "").trim().toLowerCase();
  	        state.searchTerm = term;
  	
  	        var source = toArray(state.deliveryCache);
  	        var filtered = !term ? source.slice(): source.filter(function (item) {
  	          return buildDeliverySearchIndex(item).indexOf(term) >= 0;
  	        });
  	
  	        state.filteredDeliveries = sortDeliveryRows(filtered);
  	
  	        var totals = getVisibleTotals(state.filteredDeliveries);
  	        setText("fuel-delivery-summary-tank", getDeliveryTankName(state.filteredDeliveries[0] || null));
  	        setText("fuel-delivery-summary-count", String(totals.count));
  	        setText("fuel-delivery-summary-litres", displayNumber(totals.litres, 2) + " L");
  	        setText("fuel-delivery-summary-cost", formatCurrency(totals.cost));
  	        setText("fuel-delivery-summary-cpl", "R " + displayNumber(totals.latestCostPerLitre, 4));
  	
  	        updateDeliverySortUi();
  	        renderDeliveryListFromState();
  	      }
  	
  	      async function renderDeliveriesForTank(preferredMonthKey, extraRows) {
  	        var listNode = el("fuel-delivery-list");
  	        if (!listNode) return;
  	
  	        closeDeliveryDetail();
  	
  	        if (!tank) {
  	          state.deliveryCache = [];
  	          state.filteredDeliveries = [];
  	          state.allDeliveries = [];
  	          setText("fuel-delivery-summary-tank", getDeliveryTankName(null));
  	          setText("fuel-delivery-summary-count", "0");
  	          setText("fuel-delivery-summary-litres", "0.00 L");
  	          setText("fuel-delivery-summary-cost", "R 0.00");
  	          setText("fuel-delivery-summary-cpl", "R 0.0000");
  	          setTankViewStatus("Tank not available.", true);
  	          listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">Tank not available</div>'
  	          + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Cannot load deliveries because the Tank object is missing.</div>'
  	          + "</div>";
  	          return;
  	        }
  	
  	        /*
  	         * FAST APPDATA PATH
  	         * -----------------
  	         * Viewing deliveries must never query Backendless or rewrite relations.
  	         * ViewC, ViewH and FuelIn are already loaded under the selected tank.
  	         */
  	        state.currentView = getTankCurrentView(tank);
  	        state.historyViews = getTankHistoryViews(tank);
  	
  	        var incomingRows = uniqueRowsByObjectId(toArray(extraRows));
  	
  	        if (incomingRows.length) {
  	          tank.FuelIn = uniqueRowsByObjectId(
  	            toArray(getDeep(tank, ["FuelIn"], [])).concat(incomingRows)
  	          );
  	
  	          for (var extraIndex = 0; extraIndex < incomingRows.length; extraIndex++) {
  	            var incoming = incomingRows[extraIndex];
  	            var incomingMonthKey = getFuelInMonthKey(incoming);
  	            var localTargetView = findTankViewByMonth(
  	              state.currentView,
  	              state.historyViews,
  	              incomingMonthKey
  	            );
  	
  	            if (localTargetView) {
  	              mergeSavedDeliveryIntoLocalView(localTargetView, incoming);
  	            }
  	          }
  	        }
  	
  	        var combined = toArray(getDeep(tank, ["FuelIn"], [])).slice();
  	
  	        if (state.currentView) {
  	          combined = combined.concat(
  	            toArray(getDeep(state.currentView, ["FuelIn"], []))
  	          );
  	        }
  	
  	        for (
  	          var historyIndex = 0;
  	          historyIndex < state.historyViews.length;
  	          historyIndex++
  	        ) {
  	          combined = combined.concat(
  	            toArray(
  	              getDeep(state.historyViews[historyIndex], ["FuelIn"], [])
  	            )
  	          );
  	        }
  	
  	        state.allDeliveries = uniqueRowsByObjectId(combined);
  	
  	        refreshTankViewSelector(preferredMonthKey || "");
  	
  	        var selectedMeta = getSelectedTankViewMeta();
  	
  	        if (selectedMeta) {
  	          renderSelectedTankView();
  	        } else {
  	          state.deliveryCache = state.allDeliveries.slice();
  	          state.filteredDeliveries = sortDeliveryRows(
  	            state.deliveryCache
  	          );
  	          applyDeliverySearch();
  	        }
  	
  	        var currentLabel = state.currentView
  	          ? tankViewDisplayLabel(state.currentView)
  	          : "Not available";
  	
  	        setTankViewStatus(
  	          "Current: " + currentLabel + " | " +
  	          String(state.historyViews.length) + " historical view" +
  	          (state.historyViews.length === 1 ? "" : "s") +
  	          ". Loaded instantly from AppData.",
  	          false
  	        );
  	      }
  	
  	      var captureBtn = el("fuel-delivery-tab-capture");
  	      var listBtn = el("fuel-delivery-tab-list");
  	      var capturePanel = el("fuel-delivery-capture-panel");
  	      var listPanel = el("fuel-delivery-list-panel");
  	
  	      function showCapture() {
  	        capturePanel.style.display = "block";
  	        listPanel.style.display = "none";
  	        captureBtn.classList.add("is-active");
  	        listBtn.classList.remove("is-active");
  	      }
  	
  	      function showList() {
  	        capturePanel.style.display = "none";
  	        listPanel.style.display = "block";
  	        listBtn.classList.add("is-active");
  	        captureBtn.classList.remove("is-active");
  	      }
  	
  	      if (el("fuel-delivery-close")) el("fuel-delivery-close").onclick = closeModal;
  	      if (el("fuel-delivery-cancel-btn")) el("fuel-delivery-cancel-btn").onclick = closeModal;
  	
  	      overlay.onclick = function (e) {
  	        if (e.target === overlay) closeModal();
  	      };
  	
  	      if (captureBtn) captureBtn.onclick = showCapture;
  	      if (listBtn) {
  	        listBtn.onclick = function () {
  	          showList();
  	          renderDeliveriesForTank();
  	        };
  	      }
  	
  	      var detailBackdrop = el("fuel-delivery-detail-backdrop");
  	      if (detailBackdrop) {
  	        detailBackdrop.onclick = function (e) {
  	          if (e.target === detailBackdrop) closeDeliveryDetail();
  	        };
  	      }
  	
  	      if (el("fuel-delivery-detail-close")) {
  	        el("fuel-delivery-detail-close").onclick = closeDeliveryDetail;
  	      }
  	
  	      if (el("fuel-delivery-detail-print")) {
  	        el("fuel-delivery-detail-print").onclick = function () {
  	          openSingleDeliveryPrintWindow(state.selectedDelivery);
  	        };
  	      }
  	
  	      setValue("fuel-delivery-date", formatDateInput(getNowIso()));
  	      setValue("fuel-delivery-supplier", deliveryPrimarySupplierName);
  	      setValue(
  	        "fuel-delivery-cost-per-litre",
  	        displayNumber(state.latestPricePerLitre, 4)
  	      );
  	
  	      bindInputRefresh("fuel-delivery-date", false);
  	      bindInputRefresh("fuel-delivery-supplier", false);
  	      bindInputRefresh("fuel-delivery-litres", true);
  	      bindInputRefresh("fuel-delivery-cost", true);
  	      bindInputRefresh("fuel-delivery-cost-per-litre", true);
  	      bindInputRefresh("fuel-delivery-reference", false);
  	      bindInputRefresh("fuel-delivery-description", false);
  	
  	      if (el("fuel-delivery-document-choose")) {
  	        el("fuel-delivery-document-choose").onclick = function () {
  	          var input = el("fuel-delivery-document-input");
  	          if (input) input.click();
  	        };
  	      }
  	
  	      if (el("fuel-delivery-document-input")) {
  	        el("fuel-delivery-document-input").onchange = function () {
  	          setCaptureDocument(
  	            this.files && this.files.length ? this.files[0] : null
  	          );
  	        };
  	      }
  	
  	      if (el("fuel-delivery-document-clear")) {
  	        el("fuel-delivery-document-clear").onclick = function () {
  	          var input = el("fuel-delivery-document-input");
  	          if (input) input.value = "";
  	          setCaptureDocument(null);
  	        };
  	      }
  	
  	      refreshCaptureDocumentUi();
  	
  	      for (var captureAdditionalSlot = 1; captureAdditionalSlot <= 2; captureAdditionalSlot++) {
  	        (function (wantedSlot) {
  	          var chooseButton = el("fuel-delivery-extra-document-choose-" + wantedSlot);
  	          var input = el("fuel-delivery-extra-document-input-" + wantedSlot);
  	          var clearButton = el("fuel-delivery-extra-document-clear-" + wantedSlot);
  	
  	          if (chooseButton) {
  	            chooseButton.onclick = function () {
  	              if (input) input.click();
  	            };
  	          }
  	
  	          if (input) {
  	            input.onchange = function () {
  	              setCaptureAdditionalDocument(
  	                wantedSlot,
  	                this.files && this.files.length ? this.files[0] : null
  	              );
  	            };
  	          }
  	
  	          if (clearButton) {
  	            clearButton.onclick = function () {
  	              if (input) input.value = "";
  	              setCaptureAdditionalDocument(wantedSlot, null);
  	            };
  	          }
  	        })(captureAdditionalSlot);
  	      }
  	
  	      refreshCaptureAdditionalDocumentsUi();
  	
  	      if (el("fuel-delivery-search")) {
  	        el("fuel-delivery-search").addEventListener("input", function () {
  	          applyDeliverySearch();
  	        });
  	      }
  	
  	      if (el("fuel-delivery-view-selector")) {
  	        el("fuel-delivery-view-selector").addEventListener("change", function () {
  	          state.selectedViewToken = String(this.value || "");
  	          renderSelectedTankView();
  	        });
  	      }
  	
  	      if (el("fuel-delivery-search-clear")) {
  	        el("fuel-delivery-search-clear").onclick = function () {
  	          setValue("fuel-delivery-search", "");
  	          applyDeliverySearch();
  	        };
  	      }
  	
  	      var deliverySortButtons = modal.querySelectorAll("[data-delivery-sort-key]");
  	      for (var deliverySortIndex = 0; deliverySortIndex < deliverySortButtons.length; deliverySortIndex++) {
  	        deliverySortButtons[deliverySortIndex].onclick = function () {
  	          var nextKey = String(this.getAttribute("data-delivery-sort-key") || "date");
  	
  	          if (state.sortKey === nextKey) {
  	            state.sortDirection = state.sortDirection === "asc" ? "desc": "asc";
  	          } else {
  	            state.sortKey = nextKey;
  	            state.sortDirection = nextKey === "date" ? "desc": "asc";
  	          }
  	
  	          applyDeliverySearch();
  	        };
  	      }
  	      updateDeliverySortUi();
  	
  	      if (el("fuel-delivery-refresh-btn")) {
  	        el("fuel-delivery-refresh-btn").onclick = function () {
  	          renderDeliveriesForTank();
  	        };
  	      }
  	
  	      if (el("fuel-delivery-print-btn")) {
  	        el("fuel-delivery-print-btn").onclick = function () {
  	          openPrintWindow();
  	        };
  	      }
  	
  	      refreshLiveSummary();
  	      updateSaveVisibility();
  	      renderTankGauge(tankBlock, tank);
  	      try {
  	        if (context && typeof context.onChanged === "function") {
  	          context.onChanged();
  	        }
  	      } catch (_) {}
  	      showList();
  	      renderDeliveriesForTank();
  	
  	      if (el("fuel-delivery-save-btn")) {
  	        el("fuel-delivery-save-btn").onclick = async function () {
  	          var saveButton = el("fuel-delivery-save-btn");
  	          var savedFuelIn = null;
  	          var selectedDocumentForSave = state.selectedDocument;
  	          var selectedAdditionalDocumentsForSave = Array.isArray(state.selectedAdditionalDocuments)
  	            ? state.selectedAdditionalDocuments.slice(0, 2)
  	            : [null, null];
  	          var documentUploadWarning = "";
  	          var documentWasUploaded = false;
  	          var additionalDocumentWarnings = [];
  	          var additionalDocumentsUploaded = 0;
  	
  	          try {
  	            if (!isComplete()) {
  	              managerBeginLoading(
  	                "Checking tank delivery…"
  	              );
  	              managerFailLoading(
  	                "Cannot save because the delivery figures are not valid yet."
  	              );
  	              return;
  	            }
  	
  	            var confirmed = await openDeliverySaveConfirmation();
  	            if (!confirmed) return;
  	
  	            managerBeginLoading(
  	              "Saving tank delivery…"
  	            );
  	            setButtonBusy(saveButton, true, "Saving...");
  	
  	            var fuelDateInput = valueOf("fuel-delivery-date");
  	            var supplier = String(valueOf("fuel-delivery-supplier") || "").trim();
  	            var supplierSelect = el("fuel-delivery-supplier");
  	            var supplierOption = supplierSelect && supplierSelect.selectedIndex >= 0
  	              ? supplierSelect.options[supplierSelect.selectedIndex]
  	              : null;
  	            var supplierId = supplierOption
  	              ? String(supplierOption.getAttribute("data-supplier-id") || "").trim()
  	              : "";
  	            var referenceNo = String(valueOf("fuel-delivery-reference") || "").trim();
  	            var description = String(valueOf("fuel-delivery-description") || "").trim();
  	
  	            var computed = getLiveDeliveryComputed();
  	            var volumeBefore = computed.volumeBefore;
  	            var volumeAfter = computed.volumeAfter;
  	            var levelBefore = computed.levelBefore;
  	            var levelAfter = computed.levelAfter;
  	            var litres = computed.litres;
  	            var cost = computed.cost;
  	            var costPerLitre = computed.costPerLitre;
  	
  	            var fuelDateIso = fuelDateInput
  	              ? new Date(fuelDateInput + "T12:00:00").toISOString()
  	              : getNowIso();
  	            var deliveryViewMonthKey = getFuelInMonthKey({ FuelDate: fuelDateIso });
  	
  	            var fuelInRow = {
  	              FuelDate: fuelDateIso,
  	              EntryType: "delivery",
  	              TankName: getDeliveryTankName(null),
  	              TankGrade: text(getDeep(tank, ["Grade"], ""), ""),
  	              TankDeviceId: text(getDeep(tank, ["DeviceId"], ""), ""),
  	              Supplier: supplier,
  	              SupplierId: supplierId,
  	              Litres: litres,
  	              Cost: cost,
  	              CostPerLitre: costPerLitre,
  	              ReferenceNo: referenceNo,
  	              Description: description,
  	              VolumeBefore: volumeBefore,
  	              VolumeAfter: volumeAfter,
  	              LevelBefore: levelBefore,
  	              LevelAfter: levelAfter
  	            };
  	
  	            if (company && company.objectId) {
  	              fuelInRow.Company = { objectId: company.objectId };
  	            }
  	            if (tank && tank.objectId) {
  	              fuelInRow.Tank = { objectId: tank.objectId };
  	            }
  	            if (currentUser && currentUser.objectId) {
  	              fuelInRow.CapturedBy = { objectId: currentUser.objectId };
  	            }
  	
  	            var savedFuelInResult = await saveTableRow("FuelIn", fuelInRow);
  	            savedFuelIn = Object.assign(
  	              {},
  	              fuelInRow,
  	              savedFuelInResult || {}
  	            );
  	
  	            if (!getDeep(savedFuelIn, ["created"], null)) {
  	              savedFuelIn.created = getNowIso();
  	            }
  	
  	            if (selectedDocumentForSave) {
  	              var uploadedDocument = null;
  	
  	              try {
  	                uploadedDocument = await uploadFuelInDocument(
  	                  selectedDocumentForSave,
  	                  getDeep(savedFuelIn, ["objectId"], null)
  	                );
  	
  	                var documentPatch = {
  	                  objectId: getDeep(savedFuelIn, ["objectId"], null),
  	                  DocumentURL: text(uploadedDocument.documentUrl, ""),
  	                  DocumentKey: text(uploadedDocument.documentKey, ""),
  	                  DocumentName: text(
  	                    uploadedDocument.documentName,
  	                    String(selectedDocumentForSave.name || "document")
  	                  )
  	                };
  	                var savedDocumentPatch = await saveTableRow(
  	                  "FuelIn",
  	                  documentPatch
  	                );
  	
  	                savedFuelIn = Object.assign(
  	                  {},
  	                  savedFuelIn,
  	                  documentPatch,
  	                  savedDocumentPatch || {}
  	                );
  	                documentWasUploaded = true;
  	              } catch (documentError) {
  	                documentUploadWarning = documentError && documentError.message
  	                  ? documentError.message
  	                  : "The optional document could not be uploaded.";
  	
  	                console.error(
  	                  "Optional FuelIn document upload failed:",
  	                  documentError
  	                );
  	
  	                if (uploadedDocument && uploadedDocument.documentUrl) {
  	                  try {
  	                    await deleteFuelInDocumentUrl(uploadedDocument.documentUrl);
  	                  } catch (documentCleanupError) {
  	                    console.error(
  	                      "Failed optional FuelIn document cleanup:",
  	                      documentCleanupError
  	                    );
  	                  }
  	                }
  	              }
  	            }
  	
  	
  	            if (
  	              selectedAdditionalDocumentsForSave[0] ||
  	              selectedAdditionalDocumentsForSave[1]
  	            ) {
  	              managerUpdateLoadingStatus("Uploading additional delivery documents…");
  	
  	              var additionalUploadResult = await uploadInitialFuelInAdditionalDocuments(
  	                savedFuelIn,
  	                selectedAdditionalDocumentsForSave
  	              );
  	
  	              savedFuelIn = additionalUploadResult.item || savedFuelIn;
  	              additionalDocumentsUploaded = toNumber(
  	                additionalUploadResult.uploadedCount,
  	                0
  	              );
  	              additionalDocumentWarnings = toArray(
  	                additionalUploadResult.warnings
  	              );
  	            }
  	
  	            await saveTableRow("Tanks", {
  	              objectId: getDeep(tank, ["objectId"], null),
  	              Volume: volumeAfter,
  	              Level: levelAfter
  	            });
  	
  	            if (
  	              getDeep(tank, ["objectId"], null) &&
  	              getDeep(savedFuelIn, ["objectId"], null)
  	            ) {
  	              await addRelation(
  	                "Tanks",
  	                tank.objectId,
  	                "FuelIn",
  	                [savedFuelIn.objectId]
  	              );
  	            }
  	
  	            /*
  	             * Update only the affected monthly TankView. The delivery ledger
  	             * itself reads from AppData and performs no repair or reload.
  	             */
  	            var viewResult = await linkSavedDeliveryToTankView(savedFuelIn);
  	            var visualTank = deepClone(tank || {});
  	            visualTank.Volume = volumeAfter;
  	            visualTank.Level = levelAfter;
  	            visualTank.LatestCostPerLitre = costPerLitre;
  	            visualTank.FuelIn = uniqueRowsByObjectId(
  	              toArray(getDeep(tank, ["FuelIn"], [])).concat([savedFuelIn])
  	            );
  	
  	            applyTankViewState(
  	              visualTank,
  	              viewResult.currentView,
  	              viewResult.historyViews
  	            );
  	
  	            if (tank) {
  	              tank.Volume = volumeAfter;
  	              tank.Level = levelAfter;
  	              tank.LatestCostPerLitre = costPerLitre;
  	              tank.FuelIn = visualTank.FuelIn;
  	
  	              applyTankViewState(
  	                tank,
  	                viewResult.currentView,
  	                viewResult.historyViews
  	              );
  	            }
  	
  	            if (company) {
  	              replaceNestedCompanyTank(company, visualTank, savedFuelIn);
  	            }
  	
  	            syncTankIntoLiveAppData(visualTank, savedFuelIn);
  	
  	            renderTankGauge(tankBlock, tank);
  	            try {
  	              if (context && typeof context.onChanged === "function") {
  	                context.onChanged();
  	              }
  	            } catch (_) {}
  	
  	            state.latestPricePerLitre = Math.max(0, costPerLitre);
  	            state.pricingSource = "latest";
  	
  	            setValue("fuel-delivery-supplier", deliveryPrimarySupplierName);
  	            setValue("fuel-delivery-litres", "");
  	            setValue("fuel-delivery-cost", "");
  	            setValue(
  	              "fuel-delivery-cost-per-litre",
  	              displayNumber(state.latestPricePerLitre, 4)
  	            );
  	            setValue("fuel-delivery-reference", "");
  	            setValue("fuel-delivery-description", "");
  	            setValue("fuel-delivery-date", formatDateInput(getNowIso()));
  	            state.selectedDocument = null;
  	            state.selectedAdditionalDocuments = [null, null];
  	            if (el("fuel-delivery-document-input")) {
  	              el("fuel-delivery-document-input").value = "";
  	            }
  	            for (var resetAdditionalSlot = 1; resetAdditionalSlot <= 2; resetAdditionalSlot++) {
  	              var resetAdditionalInput = el(
  	                "fuel-delivery-extra-document-input-" + resetAdditionalSlot
  	              );
  	              if (resetAdditionalInput) resetAdditionalInput.value = "";
  	            }
  	            refreshCaptureDocumentUi();
  	            refreshCaptureAdditionalDocumentsUi();
  	
  	            clearValidationMessages();
  	            refreshLiveSummary();
  	            updateSaveVisibility();
  	
  	            showList();
  	            await renderDeliveriesForTank(
  	              viewResult.monthKey,
  	              [savedFuelIn]
  	            );
  	
  	            var completedMessage =
  	              "Fuel delivery saved and linked to " +
  	              deliveryMonthLabelFromKey(viewResult.monthKey) +
  	              ".";
  	
  	            if (documentWasUploaded) {
  	              completedMessage += " The primary optional document was uploaded successfully.";
  	            } else if (documentUploadWarning) {
  	              completedMessage +=
  	                " The delivery is safe, but its primary optional document was not uploaded. " +
  	                "Open this delivery and use Add Document to retry. " +
  	                documentUploadWarning;
  	            }
  	
  	            if (additionalDocumentsUploaded > 0) {
  	              completedMessage +=
  	                " " + additionalDocumentsUploaded +
  	                " additional document" +
  	                (additionalDocumentsUploaded === 1 ? " was" : "s were") +
  	                " uploaded to FuelIn.Docs.";
  	            }
  	
  	            if (additionalDocumentWarnings.length) {
  	              completedMessage +=
  	                " The delivery is safe, but some additional document uploads need review: " +
  	                additionalDocumentWarnings.join(" ");
  	            }
  	
  	            managerCompleteLoading(completedMessage);
  	          } catch (saveError) {
  	            console.error("Fuel delivery save error:", saveError);
  	
  	            if (savedFuelIn && getDeep(savedFuelIn, ["objectId"], null)) {
  	              managerFailLoading(
  	                "The delivery was saved, but the TankView update failed: " +
  	                (saveError && saveError.message ? saveError.message : String(saveError))
  	              );
  	            } else {
  	              managerFailLoading(
  	                saveError && saveError.message
  	                  ? saveError.message
  	                  : "The fuel delivery could not be saved."
  	              );
  	            }
  	          } finally {
  	            setButtonBusy(saveButton, false, "Save Delivery");
  	          }
  	        };
  	      }
  	
  	
  	      return null;
  	    } catch (err) {
  	      console.log("Fuel delivery full rewrite error:", err);
  	      return null;
  	    }
  	  }
  	
  	
  	  return null;
  	})();

  })(App, 'data:image/png;base64,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');

}

})
define('./functions/fd477fdb222518d192722d810bc2fc8a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_fd477fdb222518d192722d810bc2fc8a'] = async function fn_fd477fdb222518d192722d810bc2fc8a(App) {
  await (async function(App, SVG) {
  	/*
  	 * Fleet In Form - Customer & Asset Manager V1.9.12
  	 * Backendless UI Builder Custom Code
  	 *
  	 * Inputs:
  	 *   App - Backendless UI Builder App / App Data input
  	 *   SVG - Fleet In Form logo as inline SVG, data URI or image URL
  	 *   GoogleMapsApiKey - optional browser-restricted Google Maps JavaScript API key.
  	 *                      Used only when Google Maps is not already loaded by the page.
  	 *
  	 * Scope:
  	 *   - FIFM-only customer/debtor administration
  	 *   - Create and edit lean legal, debtor, address and contact information
  	 *   - Create and edit Directors / Super Users and their company relationships
  	 *   - Store Users.Role strictly as Director or Employee; employee operational roles live in Data_Details.employee_details.operational_roles
  	 *   - Create tracked and non-tracked Tractors in separate areas
  	 *   - Allow a safe manual Tractor mileage / hour correction from both linked and available Tractor lists
  	 *   - Keep Tractor.Mileage, Data.Vehicle.Usage.CurrentReading and the current Tractorview.MeterEnd synchronised during a correction
  	 *   - Create tracked Trailers with Flespi devices and Companies.Trailers
  	 *   - Create Beacon-enabled normal Trailers without Flespi; EYEID is the only additional Trailer identity field
  	 *   - Three workspaces only: Directors, Companies and Employees
  	 *   - Close this Manager when another top-bar application icon is selected
  	 *   - Secure FIFM-only Login as User hand-off for Directors and Employees
  	 *   - Create, link and unlink Company assets without deleting them
  	 *   - Link Companies to client Companies as directional Contractors (one client can link many Companies)
  	 *   - Create, link and unlink Backendless-only Bowsers under Tanks
  	 *   - Allow a new Tank to be created with or without an optional polygon Location
  	 *   - Save the Tanks.Trailer Boolean from a correctly isolated Trailer Tank toggle during Tank creation
  	 *   - Create tracked and non-tracked Tractors from the standard blank Service / Vehicle / Compliance / Maintenance / FuelAndEnergy Data JSON template
  	 *   - Show a visible draggable point for every polygon vertex without legacy google.maps.Marker
  	 *   - Add or edit a polygon Location for an existing Tank
  	 *   - Create and relate the matching Backendless Locations record; polygon only
  	 *   - Permanently delete tracked Tractors and tracked Trailers from Flespi and Backendless
  	 *   - Delete non-tracked Tractors from Backendless without calling Flespi
  	 *   - Remove Companies.Tractors, ViewC, ViewH and Tractorview records during Tractor deletion
  	 *
  	 * Company rule:
  	 *   Companies.Manifest stores debtor/legal master data. Name, CompanyId and Status
  	 *   remain top-level searchable mirrors. Operational setup, pricing plans, technical
  	 *   contacts, bank mandates and application configuration are not captured here.
  	 *
  	 * Tracked-asset deletion rule:
  	 *   Flespi is deleted first. The Backendless service deletion is idempotent, allowing
  	 *   the Manager to be retried safely if a later Backendless cleanup step fails.
  	 */

  	return await (async function FleetInFormCustomerAssetManagerV1_9_12() {
  	  "use strict";

  	  const VERSION = "1.9.12";
  	  const ROOT_ID = "fif-customer-creation-portal";
  	  const STYLE_ID = "fif-customer-creation-portal-style";
  	  const TOP_OFFSET = 50;
  	  const TOP_BAR_HIT_PADDING = 8;
  	  const APPLICATION_ID = "fif-customer-asset-manager";
  	  const APPLICATION_OPEN_EVENT = "fif:topbar-application-open";
  	  // Backendless Role is the account classification and is schema-validated; case must match exactly.
  	  const DIRECTOR_ROLE_VALUE = "Director";
  	  const EMPLOYEE_ROLE_VALUE = "Employee";

  	  const TABLES = Object.freeze({
  	    USERS: "Users",
  	    COMPANIES: "Companies",
  	    TRACTORS: "Tractors",
  	    TRACTOR_VIEW: "Tractorview",
  	    TRAILERS: "Trailers",
  	    TANKS: "Tanks",
  	    BOWSERS: "Bowsers",
  	    LOCATIONS: "Locations",
  	    TANK_VIEW: "TankView",
  	    BOWSER_VIEW: "BowserView"
  	  });

  	  const RELATIONS = Object.freeze({
  	    USER_COMPANIES: "Companies",
  	    COMPANY_EMPLOYEES: "Employees",
  	    COMPANY_CONTRACTORS: "Contractors",
  	    COMPANY_TRACTORS: "Tractors",
  	    COMPANY_TRAILERS: "Trailers",
  	    COMPANY_TANKS: "Tanks",
  	    COMPANY_LOCATIONS: "Locations",
  	    TANK_BOWSERS: "Bowsers",
  	    TANK_LOCATION: "Location",
  	    TRACTOR_VIEW_CURRENT: "ViewC",
  	    TRACTOR_VIEW_HISTORY: "ViewH",
  	    TANK_VIEW_CURRENT: "ViewC",
  	    TANK_VIEW_HISTORY: "ViewH",
  	    BOWSER_VIEW_CURRENT: "ViewC",
  	    BOWSER_VIEW_HISTORY: "ViewH"
  	  });

  	  const FLESPI_SERVICE = "FIFTrackedAssetProvisioning";
  	  const IMPERSONATION_SERVICE = "FIFUserImpersonation";
  	  const IMPERSONATION_METHOD = "createSession";
  	  const IMPERSONATION_READY_MESSAGE = "FIFM_IMPERSONATION_READY";
  	  const IMPERSONATION_PAYLOAD_MESSAGE = "FIFM_IMPERSONATION_PAYLOAD";
  	  const IMPERSONATION_COMPLETE_MESSAGE = "FIFM_IMPERSONATION_COMPLETE";
  	  const IMPERSONATION_ERROR_MESSAGE = "FIFM_IMPERSONATION_ERROR";
  	  const DEFAULT_TRACTOR_RANGE = 800;
  	  const DEFAULT_TRACTOR_COLOR = "#cc6633";
  	  const DEFAULT_TRAILER_DATA_TEMPLATE = {"Audit":{"ChangeLog":[],"CreatedAt":{"value":"","editable":false,"selector":"date"},"CreatedBy":{"value":"","editable":false,"selector":"text"},"LastValidatedAt":{"value":"","editable":false,"selector":"date"},"LastValidatedBy":{"value":"","editable":false,"selector":"text"},"ValidationIssues":[],"ValidationStatus":{"value":"Incomplete","options":["Not Validated","Incomplete","Valid","Suspended"],"editable":false,"selector":"select"},"CreatedFromSchemaVersion":{"value":"1.0.0","editable":false,"selector":"text"}},"Media":{"Image_PTO":{"value":null,"editable":true,"selector":"image"},"Image_Left":{"value":null,"editable":true,"selector":"image"},"Image_Rear":{"value":null,"editable":true,"selector":"image"},"Image_Front":{"value":null,"editable":true,"selector":"image"},"Image_Right":{"value":null,"editable":true,"selector":"image"},"Image_Engine":{"value":null,"editable":true,"selector":"image"},"Image_Coupling":{"value":null,"editable":true,"selector":"image"},"Image_Interior":{"value":null,"editable":true,"selector":"image"},"Image_Dashboard":{"value":null,"editable":true,"selector":"image"},"Image_Data_Plate":{"value":null,"editable":true,"selector":"image"}},"Tyres":{"Policy":{"SpareWearRate":{"value":0,"editable":true,"selector":"number"},"MinimumTreadMM":{"value":1.6,"editable":true,"selector":"number","unitType":"Dimension"},"DefaultWearRate":{"value":1,"editable":true,"selector":"number"},"MileageAuthority":{"value":"Tractor.Mileage","editable":false,"selector":"text"},"MixedTyresAllowed":{"value":false,"editable":true,"selector":"boolean"},"RotationIntervalKM":{"value":10000,"editable":true,"selector":"number","unitType":"Distance"},"MaximumTyreAgeYears":{"value":6,"editable":true,"selector":"number","unitType":"Time"},"UsePositionWearRate":{"value":true,"editable":false,"selector":"boolean"},"InspectionIntervalDays":{"value":30,"editable":true,"selector":"number","unitType":"Time"},"TagAxleDefaultWearRate":{"value":0.5,"editable":true,"selector":"number"}},"Pressure":{"TagColdKPA":{"value":0,"editable":true,"selector":"number","unitType":"Pressure"},"RearColdKPA":{"value":0,"editable":true,"selector":"number","unitType":"Pressure"},"FrontColdKPA":{"value":0,"editable":true,"selector":"number","unitType":"Pressure"},"SpareColdKPA":{"value":0,"editable":true,"selector":"number","unitType":"Pressure"},"WarningVariancePercent":{"value":10,"editable":true,"selector":"number"},"CriticalVariancePercent":{"value":20,"editable":true,"selector":"number"}},"TyreRecords":[],"MileageAlerts":{"CriticalAtZero":{"value":true,"editable":true,"selector":"boolean"},"HighRemainingKM":{"value":5000,"editable":true,"selector":"number","unitType":"Distance"},"WarningRemainingKM":{"value":10000,"editable":true,"selector":"number","unitType":"Distance"},"InformationRemainingKM":{"value":15000,"editable":true,"selector":"number","unitType":"Distance"}},"PositionTemplate":{"value":"Light Commercial 4 Wheel","options":["","Passenger 4 Wheel","Light Commercial 4 Wheel","Rigid 2 Axle","Rigid 3 Axle","Rigid 4 Axle","Truck Tractor 2 Axle","Truck Tractor 3 Axle","Agricultural 2 Axle","Tracked","Custom"],"editable":true,"selector":"select"}},"Alerts":{"Rig":{"ComplianceBlocksActivation":{"value":true,"editable":true,"selector":"boolean"},"TyreCriticalBlocksActivation":{"value":true,"editable":true,"selector":"boolean"},"IncompleteProfileBlocksActivation":{"value":true,"editable":true,"selector":"boolean"},"UnverifiedProfileBlocksActivation":{"value":true,"editable":true,"selector":"boolean"}},"Fuel":{"SpikeHighPercent":{"value":25,"editable":true,"selector":"number"},"MinimumDistanceKM":{"value":300,"editable":true,"selector":"number","unitType":"Distance"},"SpikeWarningPercent":{"value":15,"editable":true,"selector":"number"},"SpikeCriticalPercent":{"value":40,"editable":true,"selector":"number"}},"Enabled":{"value":true,"editable":true,"selector":"boolean"},"Routing":{"Driver":{"value":false,"editable":true,"selector":"boolean"},"Director":{"value":true,"editable":true,"selector":"boolean"},"Mechanic":{"value":true,"editable":true,"selector":"boolean"},"Financial":{"value":true,"editable":true,"selector":"boolean"},"FleetManager":{"value":true,"editable":true,"selector":"boolean"}},"Service":{"DueSoonKM":{"value":5000,"editable":true,"selector":"number","unitType":"Distance"},"DueSoonDays":{"value":30,"editable":true,"selector":"number","unitType":"Time"},"CriticalOverdueKM":{"value":5000,"editable":true,"selector":"number","unitType":"Distance"},"CriticalOverdueDays":{"value":30,"editable":true,"selector":"number","unitType":"Time"}},"Compliance":{"WarningDays":{"value":[90,60,30,14,7,1],"editable":true,"selector":"multiselect"},"ExpiredCritical":{"value":true,"editable":true,"selector":"boolean"}},"Maintenance":{"OpenJobWarningDays":{"value":7,"editable":true,"selector":"number","unitType":"Time"},"DowntimeWarningHours":{"value":24,"editable":true,"selector":"number","unitType":"Time"},"WaitingPartsWarningDays":{"value":7,"editable":true,"selector":"number","unitType":"Time"}}},"Safety":{"Security":{"Alarm":{"value":false,"editable":true,"selector":"boolean"},"FuelCapLock":{"value":false,"editable":true,"selector":"boolean"},"Immobiliser":{"value":false,"editable":true,"selector":"boolean"},"PanicButton":{"value":false,"editable":true,"selector":"boolean"},"TrackingDevice":{"value":true,"editable":true,"selector":"boolean"},"LoadCompartmentLock":{"value":false,"editable":true,"selector":"boolean"}},"VehicleSafety":{"ABS":{"value":false,"editable":true,"selector":"boolean"},"EBS":{"value":false,"editable":true,"selector":"boolean"},"ESC":{"value":false,"editable":true,"selector":"boolean"},"AmberBeacon":{"value":false,"editable":true,"selector":"boolean"},"WheelChocks":{"value":false,"editable":true,"selector":"boolean"},"ReverseAlarm":{"value":false,"editable":true,"selector":"boolean"},"ReverseCamera":{"value":false,"editable":true,"selector":"boolean"},"TractionControl":{"value":false,"editable":true,"selector":"boolean"},"CollisionWarning":{"value":false,"editable":true,"selector":"boolean"},"ReflectiveMarkings":{"value":false,"editable":true,"selector":"boolean"},"LaneDepartureWarning":{"value":false,"editable":true,"selector":"boolean"},"AutomaticEmergencyBraking":{"value":false,"editable":true,"selector":"boolean"}},"OccupantSafety":{"Airbags":{"value":[],"options":["Driver","Passenger","Side","Curtain","Knee"],"editable":true,"selector":"multiselect"},"SeatCount":{"value":0,"editable":true,"selector":"number"},"EmergencyExit":{"value":false,"editable":true,"selector":"boolean"},"ChildSeatAnchors":{"value":false,"editable":true,"selector":"boolean"},"SeatBeltsAllSeats":{"value":false,"editable":true,"selector":"boolean"}},"EmergencyEquipment":{"SpillKit":{"value":false,"editable":true,"selector":"boolean"},"FirstAidKit":{"value":false,"editable":true,"selector":"boolean"},"TowRopeOrBar":{"value":false,"editable":true,"selector":"boolean"},"WarningTriangles":{"value":0,"editable":true,"selector":"number"},"JackAndWheelTools":{"value":false,"editable":true,"selector":"boolean"},"EmergencyVestCount":{"value":0,"editable":true,"selector":"number"},"FireExtinguisherCount":{"value":0,"editable":true,"selector":"number"},"FireExtinguisherSizeKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"}}},"Schema":{"Runtime":{},"SchemaName":{"value":"Fleet In Form Powered Asset Data","editable":false,"selector":"text"},"TypeMirror":{"value":"PoweredAsset","options":["PoweredAsset","PrivateVehicle","LightCommercial","MediumCommercial","HeavyCommercial","TruckTractor","AgriculturalTractor","SelfPropelledAgriculturalMachine","SpecialPurposeVehicle"],"editable":false,"selector":"select"},"FieldMirrors":{"Vehicle.Identity.VIN":["Vehicle.VIN"],"Vehicle.Identity.Make":["Vehicle.Make"],"Vehicle.Identity.Year":["Vehicle.Year"],"Vehicle.Identity.Model":["Vehicle.Model"],"Vehicle.Identity.Status":["Vehicle.Status"],"Vehicle.Dimensions.Width":["Vehicle.Width"],"Vehicle.SARS_Rebate_Rate":["Vehicle.SARSRebateRate","Vehicle.Sars_Rebate_Rate","SARS_Rebate_Rate","Financials.SARS.RebateRate"],"Vehicle.Usage.HaulLength":["Vehicle.Haul_Length"],"TowSystem.PrimaryCoupling":["Vehicle.Trailer_Configuration"],"Vehicle.Dimensions.Height":["Vehicle.Height"],"Vehicle.Dimensions.Length":["Vehicle.Length"],"Vehicle.MassAndCapacity.GVM":["Vehicle.GVM"],"Vehicle.MassAndCapacity.Tare":["Vehicle.Tare"],"Vehicle.Identity.EngineNumber":["Vehicle.Engine_Number"],"Vehicle.Identity.Registration":["Vehicle.Registration"],"Service.Current.LastServiceDate":["Service.History.Last_Service_Date"],"Service.Current.NextServiceDate":["Service.History.Next_Service_Date_Estimate"],"Vehicle.MassAndCapacity.Payload":["Vehicle.Payload"],"Compliance.Testing.LoadTestExpiry":["Compliance.Load_Test_Expiry"],"Service.Schedule.ServiceWarningKM":["Service.Service_Warning_Duration_in_KM"],"Service.Current.LastServiceMileage":["Service.History.Last_Service_KM"],"Service.Current.NextServiceMileage":["Service.History.Next_Service_KM"],"Service.Schedule.ServiceIntervalKM":["Service.Service_Interval"],"Compliance.Roadworthiness.COFExpiry":["Compliance.COF_Expiry"],"Compliance.Testing.CalibrationExpiry":["Compliance.Calibration_Expiry"],"Compliance.RegistrationAndLicensing.LicenceExpiry":["Compliance.License_Expiry_Date"],"Compliance.SafetyEquipment.FireExtinguisherExpiry":["Compliance.Fire_Extinguisher_Expiry"]},"ProfileRules":{"Truck Tractor":{"Commercial":true,"Agricultural":false,"TowProfileRequired":true,"DefaultMaxTrailerCount":3},"Heavy Commercial":{"Commercial":true,"Agricultural":false,"DefaultMaxTrailerCount":2,"TowProfileRequiredWhenTowing":true},"Light Commercial":{"Commercial":true,"Agricultural":false,"TowProfileOptional":true,"DefaultMaxTrailerCount":1},"Medium Commercial":{"Commercial":true,"Agricultural":false,"TowProfileOptional":true,"DefaultMaxTrailerCount":1},"Agricultural Tractor":{"Commercial":false,"Agricultural":true,"TowProfileRequired":true,"DefaultMaxTrailerCount":3},"Private Utility / SUV":{"Commercial":false,"Agricultural":false,"TowProfileOptional":true,"DefaultMaxTrailerCount":1},"Special Purpose Vehicle":{"Commercial":true,"Agricultural":false,"TowProfileOptional":true,"DefaultMaxTrailerCount":1},"Private Passenger Vehicle":{"Commercial":false,"Agricultural":false,"TowProfileOptional":true,"DefaultMaxTrailerCount":1},"Self-Propelled Agricultural Machine":{"Commercial":false,"Agricultural":true,"TowProfileOptional":true,"DefaultMaxTrailerCount":1}},"SchemaVersion":{"value":"1.0.0","editable":false,"selector":"text"},"MileageAuthority":{"value":"Tractor.Mileage","editable":false,"selector":"text"},"RigRelationPaths":{"Driver1":"ViewC.Driver1","Driver2":"ViewC.Driver2","Trailer1":"ViewC.Trailer1","Trailer2":"ViewC.Trailer2","Trailer3":"ViewC.Trailer3","Conductor1":"ViewC.Conductor1","Conductor2":"ViewC.Conductor2"},"LegacyPathsPreserved":{"value":true,"editable":false,"selector":"boolean"},"UnknownNumericPolicy":{"value":"Block when required for compliance or rig validation","editable":false,"selector":"text"},"SARSRebateRateDefault":{"value":3,"editable":false,"selector":"currency"},"CurrentPeriodAuthority":{"value":"Tractor.ViewC","editable":false,"selector":"text"},"DashboardCompatibility":{"value":"21.3.0+","editable":false,"selector":"text"}},"Profile":{"Notes":{"value":"","editable":true,"selector":"textarea"},"Verified":{"value":false,"editable":true,"selector":"boolean"},"VerifiedAt":{"value":"","editable":true,"selector":"date"},"VerifiedBy":{"value":"","editable":true,"selector":"text"},"VehicleClass":{"value":"","options":["","Private Passenger Vehicle","Private Utility / SUV","Light Commercial","Medium Commercial","Heavy Commercial","Truck Tractor","Agricultural Tractor","Self-Propelled Agricultural Machine","Special Purpose Vehicle"],"editable":true,"selector":"select"},"ProfileStatus":{"value":"Incomplete","options":["Incomplete","Complete","Verified","Suspended"],"editable":true,"selector":"select"},"VehicleFamily":{"value":"Powered Vehicle","options":["Powered Vehicle","Passenger Vehicle","Goods Vehicle","Truck Tractor","Agricultural Tractor","Self-Propelled Agricultural Machine","Special Purpose Vehicle"],"editable":true,"selector":"select"},"OperatingDomain":{"value":[],"options":["Private","Commercial","Agricultural","Public Road","Farm / Field","Construction","Mining","Municipal","Emergency","Cross-Border"],"editable":true,"selector":"multiselect"},"TemplateProfile":{"value":"Unconfigured","options":["Unconfigured","Private Passenger Vehicle","Private Utility / SUV","Light Commercial","Medium Commercial","Heavy Commercial","Truck Tractor","Agricultural Tractor","Self-Propelled Agricultural Machine","Special Purpose Vehicle"],"editable":true,"selector":"select"},"PrimaryApplication":{"value":"","options":["","Personal Transport","Staff Transport","Courier / Delivery","General Freight","Long-Haul Freight","Construction","Towing","Agricultural Haulage","Tillage","Planting","Spraying","Fertilising","Harvesting","Material Handling","Special Purpose"],"editable":true,"selector":"select"},"SecondaryApplications":{"value":[],"options":["Personal Transport","Staff Transport","Courier / Delivery","General Freight","Long-Haul Freight","Construction","Towing","Agricultural Haulage","Tillage","Planting","Spraying","Fertilising","Harvesting","Material Handling","Special Purpose"],"editable":true,"selector":"multiselect"}},"Service":{"SLA":{"Notes":{"value":"","editable":true,"selector":"textarea"},"Priority_Service":{"value":false,"editable":true,"selector":"boolean"},"Max_Downtime_Hours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"Response_Time_Hours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"Loan_Vehicle_Available":{"value":false,"editable":true,"selector":"boolean"}},"Parts":{"Oil_Type":{"value":"","editable":true,"selector":"text"},"Tyre_Spec":{"value":"","editable":true,"selector":"text"},"Preferred_Oil_Supplier":{"value":"","editable":true,"selector":"text"},"Preferred_Tyre_Supplier":{"value":"","editable":true,"selector":"text"},"Preferred_Filter_Supplier":{"value":"","editable":true,"selector":"text"},"Preferred_Battery_Supplier":{"value":"","editable":true,"selector":"text"}},"Current":{"LastServiceDate":{"value":"","editable":true,"selector":"date"},"NextServiceDate":{"value":"","editable":true,"selector":"date"},"LastServiceHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"NextServiceHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"LastServiceMileage":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"NextServiceMileage":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"ServiceCentreLastUsed":{"value":"","editable":true,"selector":"text"}},"History":{"Last_Service_KM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"Next_Service_KM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"Last_Service_Date":{"value":"","editable":true,"selector":"date"},"Service_Centre_Last_Used":{"value":"","editable":true,"selector":"text"},"Next_Service_Date_Estimate":{"value":"","editable":true,"selector":"date"}},"Mechanic":{"Email":{"value":"","editable":true,"selector":"email"},"Phone":{"value":"","editable":true,"selector":"phone"},"Is_In_House":{"value":false,"editable":true,"selector":"boolean"},"Company_Name":{"value":"","editable":true,"selector":"text"},"Contact_Name":{"value":"","editable":true,"selector":"text"},"Selected_UserId":{"value":"","editable":true,"selector":"user_picker"}},"Schedule":{"TriggerPolicy":{"value":"","options":["First Due","Mileage Only","Date Only","Hours Only","Manual"],"editable":true,"selector":"select"},"ServiceWarningKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"ServiceIntervalKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"ServiceWarningDays":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"ServiceIntervalDays":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"ServiceWarningHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"ServiceIntervalHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"}},"Warranty":{"Notes":{"value":"","editable":true,"selector":"textarea"},"Is_Under_Warranty":{"value":false,"editable":true,"selector":"boolean"},"Warranty_Provider":{"value":"","editable":true,"selector":"text"},"Warranty_Expiry_Date":{"value":"","editable":true,"selector":"date"},"Warranty_Contact_Name":{"value":"","editable":true,"selector":"text"},"Warranty_Contact_Email":{"value":"","editable":true,"selector":"email"},"Warranty_Contact_Phone":{"value":"","editable":true,"selector":"phone"}},"Diagnostics":{"Supports_OBD":{"value":false,"editable":true,"selector":"boolean"},"OBD_Device_ID":{"value":"","editable":true,"selector":"text"},"Last_Fault_Code":{"value":"","editable":true,"selector":"text"},"Fault_Warning_Light":{"value":false,"editable":true,"selector":"boolean"},"Last_Diagnostic_Report_Date":{"value":"","editable":true,"selector":"date"}},"ServiceRecords":[],"Service_Status":{"value":"","options":["All In Order","Attention Needed","Out of Service"],"editable":true,"selector":"select"},"Roadside_Assist":{"24_Hour":{"value":false,"editable":true,"selector":"boolean"},"OEM_Number":{"value":"","editable":true,"selector":"phone"},"Third_Party_Number":{"value":"","editable":true,"selector":"phone"}},"Service_Interval":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"ComponentIntervals":{"EngineOilKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"CoolantMonths":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"DPFCleaningKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"DifferentialKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"EngineOilHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"TransmissionKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"BrakeInspectionKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"HydraulicOilHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"PTOInspectionHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"}},"InspectionSchedule":{"Daily":{"value":false,"editable":true,"selector":"boolean"},"Annual":{"value":false,"editable":true,"selector":"boolean"},"Weekly":{"value":false,"editable":true,"selector":"boolean"},"Monthly":{"value":false,"editable":true,"selector":"boolean"},"PreTrip":{"value":false,"editable":true,"selector":"boolean"},"PostTrip":{"value":false,"editable":true,"selector":"boolean"}},"MaintenanceRecords":[],"Specialist_Providers":[{"Email":{"value":"","editable":true,"selector":"email"},"Phone":{"value":"","editable":true,"selector":"phone"},"Company":{"value":"","editable":true,"selector":"text"},"Contact":{"value":"","editable":true,"selector":"text"},"Category":{"value":"","options":["Towing","Repairs","Diagnostics","Tyres","Fuel","Electrics","Bodywork"],"editable":true,"selector":"select"}}],"Unscheduled_Services":{"value":false,"editable":true,"selector":"boolean"},"Primary_Service_Provider":{"Name":{"value":"","editable":true,"selector":"text"},"Email":{"value":"","editable":true,"selector":"email"},"Phone":{"value":"","editable":true,"selector":"phone"},"Address":{"value":"","editable":true,"selector":"textarea"},"After_Hours_Number":{"value":"","editable":true,"selector":"phone"}},"Service_Warning_Duration_in_KM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"}},"UIUnits":{"Area":{"value":"ha","options":["ha","m²","acre"],"editable":true,"selector":"select"},"Flow":{"value":"L/min","options":["L/min","L/s","m³/h"],"editable":true,"selector":"select"},"Time":{"value":"hours","options":["minutes","hours"],"editable":true,"selector":"select"},"Power":{"value":"kW","options":["kW","bhp"],"editable":true,"selector":"select"},"Speed":{"value":"km/h","options":["km/h","mph"],"editable":true,"selector":"select"},"Energy":{"value":"kWh","options":["kWh","MJ"],"editable":true,"selector":"select"},"Torque":{"value":"Nm","options":["Nm","lb-ft"],"editable":true,"selector":"select"},"Volume":{"value":"l","options":["l","m³"],"editable":true,"selector":"select"},"Weight":{"value":"kg","options":["kg","ton"],"editable":true,"selector":"select"},"Voltage":{"value":"V","options":["V","kV"],"editable":true,"selector":"select"},"Distance":{"value":"km","options":["km","m"],"editable":true,"selector":"select"},"Pressure":{"value":"kPa","options":["kPa","bar","psi"],"editable":true,"selector":"select"},"Dimension":{"value":"mm","options":["mm","cm","m"],"editable":true,"selector":"select"},"FuelEconomy":{"value":"L/100km","options":["L/100km","km/L","mpg"],"editable":true,"selector":"select"},"Temperature":{"value":"°C","options":["°C","°F"],"editable":true,"selector":"select"},"EngineCapacity":{"value":"cc","options":["cc","L"],"editable":true,"selector":"select"},"EconomyDistance":{"value":"km","options":["km","m"],"editable":true,"selector":"select"},"CurrencyDistance":{"value":"km","options":["km","m"],"editable":true,"selector":"select"}},"Vehicle":{"GVM":{"value":0,"editable":false,"selector":"number","unitType":"Weight"},"VIN":{"value":"","editable":true,"selector":"text"},"Make":{"value":"","editable":true,"selector":"text"},"Tare":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"Year":{"value":0,"editable":true,"selector":"number"},"Model":{"value":"","editable":true,"selector":"text"},"Usage":{"OffRoad":{"value":false,"editable":true,"selector":"boolean"},"FarmField":{"value":false,"editable":true,"selector":"boolean"},"HaulLength":{"value":"","options":["","Short Haul (0–300km)","Medium Haul (300–825km)","Long Haul (825km+)"],"editable":true,"selector":"select"},"PrimaryUse":{"value":"","editable":true,"selector":"text"},"PublicRoad":{"value":false,"editable":true,"selector":"boolean"},"CrossBorder":{"value":false,"editable":true,"selector":"boolean"},"AbnormalLoad":{"value":false,"editable":true,"selector":"boolean"},"DangerousGoods":{"value":false,"editable":true,"selector":"boolean"},"OperatingModes":{"value":[],"options":["Private","Commercial","Public Road","Farm / Field","Workshop / Controlled Movement"],"editable":true,"selector":"multiselect"}},"Width":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"},"Height":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"},"Length":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"},"Payload":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"Abnormal":{"value":"","options":["Yes","No"],"editable":true,"selector":"select"},"Identity":{"ID":{"value":"","editable":true,"selector":"text"},"VIN":{"value":"","editable":true,"selector":"text"},"Make":{"value":"","editable":true,"selector":"text"},"Year":{"value":0,"editable":true,"selector":"number"},"Model":{"value":"","editable":true,"selector":"text"},"FleetNumber":{"value":"","editable":true,"selector":"text"},"EngineNumber":{"value":"","editable":true,"selector":"text"},"Registration":{"value":"","editable":true,"selector":"text"},"ChassisNumber":{"value":"","editable":true,"selector":"text"}},"Fuel_Type":{"value":"","options":["Diesel","Petrol","Electric","Hybrid"],"editable":true,"selector":"select"},"Dimensions":{"Width":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"},"Height":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"},"Length":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"},"Wheelbase":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"},"TurningCircle":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"},"GroundClearance":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"}},"Haul_Length":{"value":"","options":["Short Haul (0–300km)","Medium Haul (300–825km)","Long Haul (825km+)"],"editable":true,"selector":"select"},"Engine_Power":{"value":0,"editable":true,"selector":"number","unitType":"Power"},"Registration":{"value":"","editable":true,"selector":"text"},"Engine_Number":{"value":"","editable":true,"selector":"text"},"Tank_Capacity":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"Tractor_Range":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"Classification":{"BodyType":{"value":"","editable":true,"selector":"text"},"PoweredAsset":{"value":false,"editable":false,"selector":"boolean"},"VehicleClass":{"value":"","options":["","Private Passenger Vehicle","Private Utility / SUV","Light Commercial","Medium Commercial","Heavy Commercial","Truck Tractor","Agricultural Tractor","Self-Propelled Agricultural Machine","Special Purpose Vehicle"],"editable":true,"selector":"select"},"PowerUnitClass":{"value":"","options":["","Passenger Vehicle","Light Goods Vehicle","Medium Goods Vehicle","Heavy Rigid Truck","Truck Tractor","Agricultural Tractor","Self-Propelled Agricultural Machine","Special Purpose Vehicle"],"editable":true,"selector":"select"},"RegulatoryClass":{"value":"","editable":true,"selector":"text"}},"SARSRebateRate":{"value":0,"editable":true,"selector":"currency"},"MassAndCapacity":{"GCM":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"GVM":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"Tare":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"Payload":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"DrawbarLoad":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"LoadVolumeM3":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"SeatCapacity":{"value":0,"editable":true,"selector":"number"},"RearAxleLimit":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"FrontAxleLimit":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"PayloadOverride":{"value":0,"editable":true,"selector":"number","unitType":"Weight"}},"Payload_Override":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"SARS_Rebate_Rate":{"value":0,"editable":true,"selector":"currency"},"Sars_Rebate_Rate":{"value":0,"editable":true,"selector":"currency"},"Trailer_Configuration":{"value":"","options":["None","Gooseneck","Eye Link","Ball Link"],"editable":true,"selector":"select"}},"Documents":{"Manuals":[],"COFDocuments":[],"OtherDocuments":[],"PermitDocuments":[],"LicenceDocuments":[],"ServiceDocuments":[],"LoadTestDocuments":[],"WarrantyDocuments":[],"InsuranceDocuments":[],"TowRatingDocuments":[],"RoadworthyDocuments":[],"CalibrationDocuments":[],"RegistrationDocuments":[],"AgriculturalCertificates":[]},"Ownership":{"Finance":{"EndDate":{"value":"","editable":true,"selector":"date"},"Provider":{"value":"","editable":true,"selector":"text"},"StartDate":{"value":"","editable":true,"selector":"date"},"BalloonAmount":{"value":0,"editable":true,"selector":"currency"},"AgreementNumber":{"value":"","editable":true,"selector":"text"}},"Insurance":{"CoverType":{"value":"","options":["","Comprehensive","Third Party Fire and Theft","Third Party","Agricultural","Fleet","Other"],"editable":true,"selector":"select"},"Broker_Name":{"value":"","editable":true,"selector":"text"},"Broker_Email":{"value":"","editable":true,"selector":"email"},"Broker_Phone":{"value":"","editable":true,"selector":"phone"},"ExcessAmount":{"value":0,"editable":true,"selector":"currency"},"InsuredValue":{"value":0,"editable":true,"selector":"currency"},"Policy_Number":{"value":"","editable":true,"selector":"text"},"PolicyStartDate":{"value":"","editable":true,"selector":"date"},"PolicyExpiryDate":{"value":"","editable":true,"selector":"date"},"Insurance_Company":{"value":"","editable":true,"selector":"text"},"Roadside_Assist_Number":{"value":"","editable":true,"selector":"phone"}},"OwnerName":{"value":"","editable":true,"selector":"text"},"OwnerType":{"value":"","options":["","Company Owned","Financed","Leased","Rented","Employee Owned","Third Party"],"editable":true,"selector":"select"},"PurchaseDate":{"value":"","editable":true,"selector":"date"},"PurchasePrice":{"value":0,"editable":true,"selector":"currency"}},"TowSystem":{"PTO":{"Speeds":{"value":[],"options":["540","540E","1000","1000E","Ground Speed","Front PTO"],"editable":true,"selector":"multiselect"},"Available":{"value":false,"editable":true,"selector":"boolean"},"ShaftSize":{"value":"","options":["","1 3/8 6 Spline","1 3/8 21 Spline","1 3/4 20 Spline","Other"],"editable":true,"selector":"select"},"GuardFitted":{"value":false,"editable":true,"selector":"boolean"},"MaximumPowerKW":{"value":0,"editable":true,"selector":"number","unitType":"Power"}},"Brakes":{"Air":{"value":false,"editable":true,"selector":"boolean"},"Electric":{"value":false,"editable":true,"selector":"boolean"},"Hydraulic":{"value":false,"editable":true,"selector":"boolean"},"Mechanical":{"value":false,"editable":true,"selector":"boolean"}},"Safety":{"RearCamera":{"value":false,"editable":true,"selector":"boolean"},"SafetyChainMounts":{"value":false,"editable":true,"selector":"boolean"},"BreakawayConnection":{"value":false,"editable":true,"selector":"boolean"},"TrailerStabilityControl":{"value":false,"editable":true,"selector":"boolean"},"CouplingInspectionIntervalDays":{"value":0,"editable":true,"selector":"number","unitType":"Time"}},"Enabled":{"value":false,"editable":true,"selector":"boolean"},"History":[],"Runtime":{},"Verified":{"value":false,"editable":true,"selector":"boolean"},"Electrical":{"CANBUS":{"value":false,"editable":true,"selector":"boolean"},"ISOBUS":{"value":false,"editable":true,"selector":"boolean"},"Voltage":{"value":"","options":["","12V","24V","48V"],"editable":true,"selector":"select"},"Connectors":{"value":[],"options":["7 Pin","13 Pin","N-Type","S-Type","ABS / EBS","ISOBUS","CANBUS","Anderson","Other"],"editable":true,"selector":"multiselect"},"TrailerABS":{"value":false,"editable":true,"selector":"boolean"},"TrailerEBS":{"value":false,"editable":true,"selector":"boolean"}},"Hydraulics":{"Available":{"value":false,"editable":true,"selector":"boolean"},"RemoteCount":{"value":0,"editable":true,"selector":"number"},"MaximumFlowLPM":{"value":0,"editable":true,"selector":"number","unitType":"Flow"},"ReturnAvailable":{"value":false,"editable":true,"selector":"boolean"},"CaseDrainAvailable":{"value":false,"editable":true,"selector":"boolean"},"MaximumPressureBar":{"value":0,"editable":true,"selector":"number","unitType":"Pressure"},"LoadSensingAvailable":{"value":false,"editable":true,"selector":"boolean"},"PowerBeyondAvailable":{"value":false,"editable":true,"selector":"boolean"}},"ThreePoint":{"Available":{"value":false,"editable":true,"selector":"boolean"},"Categories":{"value":[],"options":["Category 0","Category 1","Category 2","Category 3","Category 3N","Category 4","Category 4N"],"editable":true,"selector":"multiselect"},"MaximumLiftKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"FrontLinkageAvailable":{"value":false,"editable":true,"selector":"boolean"},"FrontLinkageMaximumLiftKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"}},"VerifiedAt":{"value":"","editable":true,"selector":"date"},"VerifiedBy":{"value":"","editable":true,"selector":"text"},"AllowedModes":{"value":[],"options":["Public Road","Farm / Field","Workshop / Controlled Movement"],"editable":true,"selector":"multiselect"},"DrawbarRating":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"EnginePowerKW":{"value":0,"editable":true,"selector":"number","unitType":"Power"},"PowerUnitClass":{"value":"","options":["","Private Passenger Vehicle","Light Goods Vehicle","Medium Goods Vehicle","Heavy Rigid Truck","Truck Tractor","Agricultural Tractor","Self-Propelled Agricultural Machine","Special Purpose Vehicle"],"editable":true,"selector":"select"},"GooseneckRating":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"ManufacturerGCM":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"MaxTrailerCount":{"value":0,"editable":true,"selector":"number"},"PrDPRequirement":{"value":"","options":["Auto","Not Required","Required","Required for Public Road"],"editable":true,"selector":"select"},"PrimaryCoupling":{"value":"","options":["None","Ball Link","Eye Link","Drawbar","Fifth Wheel","Gooseneck","Three-Point","Fixed"],"editable":true,"selector":"select"},"FifthWheelRating":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"BallCouplingRating":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"AdditionalCouplings":{"value":[],"options":["Ball Link","Eye Link","Drawbar","Fifth Wheel","Gooseneck","Three-Point","Fixed"],"editable":true,"selector":"multiselect"},"VerificationDocument":{"value":"","editable":true,"selector":"text"},"MaximumBrakedTrailerMass":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"MaximumUnbrakedTrailerMass":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"MaximumVerticalCouplingLoad":{"value":0,"editable":true,"selector":"number","unitType":"Weight"}},"Commercial":{"Enabled":{"value":false,"editable":true,"selector":"boolean"},"ForReward":{"value":false,"editable":true,"selector":"boolean"},"HomeDepot":{"value":"","editable":true,"selector":"text"},"CostCentre":{"value":"","editable":true,"selector":"text"},"Operations":{"DayShiftAllowed":{"value":false,"editable":true,"selector":"boolean"},"GeofenceRequired":{"value":false,"editable":true,"selector":"boolean"},"NightShiftAllowed":{"value":false,"editable":true,"selector":"boolean"},"ApprovedRoutesOnly":{"value":false,"editable":true,"selector":"boolean"},"TwoDriverOperation":{"value":false,"editable":true,"selector":"boolean"},"MaximumDailyDistanceKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"MaximumDailyDrivingHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"}},"FleetNumber":{"value":"","editable":true,"selector":"text"},"RequiresCOF":{"value":false,"editable":true,"selector":"boolean"},"GoodsVehicle":{"value":false,"editable":true,"selector":"boolean"},"RequiresPrDP":{"value":false,"editable":true,"selector":"boolean"},"OperationType":{"value":[],"options":["Own Goods","For Reward","Courier","General Freight","Bulk","Construction","Passenger","Dangerous Goods","Abnormal Load","Cross-Border"],"editable":true,"selector":"multiselect"},"LoadManagement":{"BodyType":{"value":"","options":["","Panel Van","Dropside","Flat Deck","Curtain Side","Box Body","Tipper","Tanker","Refrigerated","Lowbed","Mixer","Compactor","Other"],"editable":true,"selector":"select"},"BodyTareKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"BodyCapacityM3":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"BodySerialNumber":{"value":"","editable":true,"selector":"text"},"MaximumPayloadKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"TemperatureMaximumC":{"value":0,"editable":true,"selector":"number","unitType":"Temperature"},"TemperatureMinimumC":{"value":0,"editable":true,"selector":"number","unitType":"Temperature"},"LoadSecuringRequired":{"value":false,"editable":true,"selector":"boolean"},"RefrigerationRequired":{"value":false,"editable":true,"selector":"boolean"},"LoadDistributionRequired":{"value":false,"editable":true,"selector":"boolean"}},"OperatorNumber":{"value":"","editable":true,"selector":"text"},"CommercialClass":{"value":"","options":["","Light Commercial","Medium Commercial","Heavy Rigid","Truck Tractor","Bus / Passenger","Specialised"],"editable":true,"selector":"select"},"PublicTransport":{"value":false,"editable":true,"selector":"boolean"},"PassengerVehicle":{"value":false,"editable":true,"selector":"boolean"},"CrossBorderEnabled":{"value":false,"editable":true,"selector":"boolean"},"AbnormalLoadEnabled":{"value":false,"editable":true,"selector":"boolean"},"RequiresOperatorCard":{"value":false,"editable":true,"selector":"boolean"},"DangerousGoodsEnabled":{"value":false,"editable":true,"selector":"boolean"}},"Compliance":{"Permits":{"CrossBorderExpiry":{"value":"","editable":true,"selector":"date"},"AbnormalLoadExpiry":{"value":"","editable":true,"selector":"date"},"CrossBorderRequired":{"value":false,"editable":true,"selector":"boolean"},"AbnormalLoadRequired":{"value":false,"editable":true,"selector":"boolean"},"DangerousGoodsExpiry":{"value":"","editable":true,"selector":"date"},"OperatingPermitExpiry":{"value":"","editable":true,"selector":"date"},"DangerousGoodsRequired":{"value":false,"editable":true,"selector":"boolean"},"OperatingPermitRequired":{"value":false,"editable":true,"selector":"boolean"}},"Testing":{"LoadTestExpiry":{"value":"","editable":true,"selector":"date"},"LoadTestRequired":{"value":false,"editable":true,"selector":"boolean"},"CalibrationExpiry":{"value":"","editable":true,"selector":"date"},"CalibrationRequired":{"value":false,"editable":true,"selector":"boolean"},"LoadTestCertificate":{"value":"","editable":true,"selector":"text"},"CalibrationCertificate":{"value":"","editable":true,"selector":"text"}},"COF_Expiry":{"value":"","editable":true,"selector":"date"},"Agricultural":{"ROPSInspectionExpiry":{"value":"","editable":true,"selector":"date"},"ROPSInspectionRequired":{"value":false,"editable":true,"selector":"boolean"},"PTOGuardInspectionExpiry":{"value":"","editable":true,"selector":"date"},"RoadTransferPermitExpiry":{"value":"","editable":true,"selector":"date"},"SprayerCalibrationExpiry":{"value":"","editable":true,"selector":"date"},"PTOGuardInspectionRequired":{"value":false,"editable":true,"selector":"boolean"},"RoadTransferPermitRequired":{"value":false,"editable":true,"selector":"boolean"},"SprayerCalibrationRequired":{"value":false,"editable":true,"selector":"boolean"}},"OverallStatus":{"value":"","options":["Incomplete","Compliant","Due Soon","Non-Compliant","Not Required"],"editable":true,"selector":"select"},"Roadworthiness":{"Expiry":{"value":"","editable":true,"selector":"date"},"Status":{"value":"","options":["","Valid","Due Soon","Expired","Failed","Not Required"],"editable":true,"selector":"select"},"Required":{"value":false,"editable":true,"selector":"boolean"},"COFExpiry":{"value":"","editable":true,"selector":"date"},"COFNumber":{"value":"","editable":true,"selector":"text"},"COFRequired":{"value":false,"editable":true,"selector":"boolean"},"CertificateNumber":{"value":"","editable":true,"selector":"text"}},"SafetyEquipment":{"FirstAidKitExpiry":{"value":"","editable":true,"selector":"date"},"FirstAidKitRequired":{"value":false,"editable":true,"selector":"boolean"},"FireExtinguisherExpiry":{"value":"","editable":true,"selector":"date"},"FireExtinguisherRequired":{"value":false,"editable":true,"selector":"boolean"},"WarningTrianglesRequired":{"value":false,"editable":true,"selector":"boolean"},"ReflectiveMarkingsRequired":{"value":false,"editable":true,"selector":"boolean"}},"Load_Test_Expiry":{"value":"","editable":true,"selector":"date"},"ComplianceRecords":[],"Roadworthy_Status":{"value":"","editable":true,"selector":"text"},"Calibration_Expiry":{"value":"","editable":true,"selector":"date"},"License_Expiry_Date":{"value":"","editable":true,"selector":"date"},"Fire_Extinguisher_Expiry":{"value":"","editable":true,"selector":"date"},"RegistrationAndLicensing":{"LicenceExpiry":{"value":"","editable":true,"selector":"date"},"LicenceNumber":{"value":"","editable":true,"selector":"text"},"LicenceRequired":{"value":false,"editable":true,"selector":"boolean"},"OperatorCardExpiry":{"value":"","editable":true,"selector":"date"},"OperatorCardNumber":{"value":"","editable":true,"selector":"text"},"OperatorCardRequired":{"value":false,"editable":true,"selector":"boolean"}}},"Financials":{"SARS":{"Eligible":{"value":false,"editable":true,"selector":"boolean"},"RebateRate":{"value":0,"editable":true,"selector":"currency"},"LastClaimDate":{"value":"","editable":true,"selector":"date"},"ClaimedRebateCurrentPeriod":{"value":0,"editable":true,"selector":"currency"},"PotentialRebateCurrentPeriod":{"value":0,"editable":false,"selector":"currency"}},"Costs":{"Instalment":{"value":0,"editable":true,"selector":"currency"},"Insurance_Premium":{"value":0,"editable":true,"selector":"currency"},"Annual_License_Fee":{"value":0,"editable":true,"selector":"currency"},"Fixed_Monthly_Sundry_Cost":{"value":0,"editable":true,"selector":"currency"},"Fixed_Maintenance_Plan_Cost":{"value":0,"editable":true,"selector":"currency"},"Maintenance_Plan_Rate_per_Km":{"value":0,"editable":true,"selector":"currency","unitType":"CurrencyDistance"}},"Budget":{"AnnualTyreBudget":{"value":0,"editable":true,"selector":"currency"},"MonthlyFuelBudget":{"value":0,"editable":true,"selector":"currency"},"AnnualComplianceBudget":{"value":0,"editable":true,"selector":"currency"},"MonthlyMaintenanceBudget":{"value":0,"editable":true,"selector":"currency"}},"Accounting":{"Price":{"value":0,"editable":true,"selector":"currency"},"Rig_CPK":{"value":0,"editable":true,"selector":"number","unitType":"CurrencyDistance"},"Depreciation":{"value":0,"editable":true,"selector":"currency"}},"Allocation":{"Farm":{"value":"","editable":true,"selector":"text"},"Field":{"value":"","editable":true,"selector":"text"},"Project":{"value":"","editable":true,"selector":"text"},"CostCentre":{"value":"","editable":true,"selector":"text"},"Department":{"value":"","editable":true,"selector":"text"}}},"Powertrain":{"Engine":{"Model":{"value":"","editable":true,"selector":"text"},"IdleRPM":{"value":0,"editable":true,"selector":"number"},"Aspiration":{"value":"","options":["","Naturally Aspirated","Turbocharged","Twin Turbo","Supercharged","Electric"],"editable":true,"selector":"select"},"EngineType":{"value":"","options":["","Petrol","Diesel","Electric","Hybrid","LPG","CNG","Hydrogen","Other"],"editable":true,"selector":"select"},"CoolingType":{"value":"","options":["","Air Cooled","Liquid Cooled","Oil Cooled"],"editable":true,"selector":"select"},"EngineHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"GovernorRPM":{"value":0,"editable":true,"selector":"number"},"Manufacturer":{"value":"","editable":true,"selector":"text"},"OilCapacityL":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"RatedPowerKW":{"value":0,"editable":true,"selector":"number","unitType":"Power"},"SerialNumber":{"value":"","editable":true,"selector":"text"},"CylinderCount":{"value":0,"editable":true,"selector":"number"},"RatedPowerRPM":{"value":0,"editable":true,"selector":"number"},"RatedTorqueNM":{"value":0,"editable":true,"selector":"number","unitType":"Torque"},"AfterTreatment":{"value":[],"options":["Catalytic Converter","DPF","SCR / AdBlue","EGR","None"],"editable":true,"selector":"multiselect"},"DisplacementCC":{"value":0,"editable":true,"selector":"number"},"RatedTorqueRPM":{"value":0,"editable":true,"selector":"number"},"CoolantCapacityL":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"EmissionStandard":{"value":"","options":["","Pre-Euro","Euro 1","Euro 2","Euro 3","Euro 4","Euro 5","Euro 6","Tier 2","Tier 3","Tier 4","Stage V","Other"],"editable":true,"selector":"select"},"EngineHoursSupported":{"value":false,"editable":true,"selector":"boolean"}},"Driveline":{"DrivenAxles":{"value":0,"editable":true,"selector":"number"},"TransferCase":{"value":false,"editable":true,"selector":"boolean"},"FinalDriveType":{"value":"","options":["","Shaft","Hub Reduction","Chain","Belt","Hydrostatic","Electric"],"editable":true,"selector":"select"},"DifferentialLocks":{"value":[],"options":["Front","Centre","Rear","Inter-Axle"],"editable":true,"selector":"multiselect"},"DriveConfiguration":{"value":"","options":["","4x2","4x4","6x2","6x4","6x6","8x2","8x4","8x8","2WD","MFWD","Tracked","Other"],"editable":true,"selector":"select"},"MaximumDesignSpeedKPH":{"value":0,"editable":true,"selector":"number","unitType":"Speed"}},"Electrical":{"BatteryType":{"value":"","options":["","Lead Acid","AGM","EFB","Lithium Ion","Other"],"editable":true,"selector":"select"},"BatteryCount":{"value":0,"editable":true,"selector":"number"},"SystemVoltage":{"value":"","options":["","12V","24V","48V","High Voltage EV"],"editable":true,"selector":"select"},"StarterMotorKW":{"value":0,"editable":true,"selector":"number","unitType":"Power"},"AlternatorRatingA":{"value":0,"editable":true,"selector":"number"},"BatteryCapacityAH":{"value":0,"editable":true,"selector":"number"},"ExternalPowerConnection":{"value":false,"editable":true,"selector":"boolean"}},"Transmission":{"Type":{"value":"","options":["","Manual","Automatic","AMT","CVT","Hydrostatic","Powershift","Direct Drive","Electric"],"editable":true,"selector":"select"},"Model":{"value":"","editable":true,"selector":"text"},"LowRange":{"value":false,"editable":true,"selector":"boolean"},"Retarder":{"value":"","options":["","None","Engine Brake","Exhaust Brake","Hydraulic Retarder","Electric Retarder"],"editable":true,"selector":"select"},"ForwardGears":{"value":0,"editable":true,"selector":"number"},"Manufacturer":{"value":"","editable":true,"selector":"text"},"ReverseGears":{"value":0,"editable":true,"selector":"number"},"HighLowSplitter":{"value":false,"editable":true,"selector":"boolean"},"PTOOutputAvailable":{"value":false,"editable":true,"selector":"boolean"}}},"TPositions":{"Axles":[],"Spare":null},"Telematics":{"Events":{"FuelGain":{"value":false,"editable":true,"selector":"boolean"},"FuelLoss":{"value":false,"editable":true,"selector":"boolean"},"Speeding":{"value":false,"editable":true,"selector":"boolean"},"LowBattery":{"value":false,"editable":true,"selector":"boolean"},"HarshBraking":{"value":false,"editable":true,"selector":"boolean"},"ExcessiveIdle":{"value":false,"editable":true,"selector":"boolean"},"HarshCornering":{"value":false,"editable":true,"selector":"boolean"},"LowOilPressure":{"value":false,"editable":true,"selector":"boolean"},"HarshAcceleration":{"value":false,"editable":true,"selector":"boolean"},"EngineOverTemperature":{"value":false,"editable":true,"selector":"boolean"}},"Enabled":{"value":true,"editable":true,"selector":"boolean"},"DeviceId":{"value":"","editable":true,"selector":"text"},"Provider":{"value":"Flespi","editable":true,"selector":"text"},"SIMNumber":{"value":"","editable":true,"selector":"text"},"CANEnabled":{"value":true,"editable":true,"selector":"boolean"},"GPSEnabled":{"value":true,"editable":true,"selector":"boolean"},"Geofencing":{"Enabled":{"value":false,"editable":true,"selector":"boolean"},"ApprovedLocationsOnly":{"value":false,"editable":true,"selector":"boolean"},"AfterHoursMovementAlert":{"value":false,"editable":true,"selector":"boolean"}},"LastDataAt":{"value":"","editable":false,"selector":"date"},"FuelLevelEnabled":{"value":false,"editable":true,"selector":"boolean"},"MileageAuthority":{"value":"","editable":false,"selector":"text"},"StaleAfterMinutes":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"EngineHoursEnabled":{"value":false,"editable":true,"selector":"boolean"},"DriverIdentificationEnabled":{"value":false,"editable":true,"selector":"boolean"},"TelematicsOdometerIsAdvisory":{"value":false,"editable":false,"selector":"boolean"},"Provisioning":{"Mode":"Tracked","Provider":"Flespi","TrackerType":"","IMEI":"","FlespiDeviceId":"","ProvisionedAt":"","ProvisionedBy":""}},"Application":{"value":[],"options":["Private","Staff Transport","Courier / Delivery","General Freight","Long-Haul Freight","Construction","Towing","Agricultural Haulage","Tillage","Planting","Spraying","Fertilising","Harvesting","Material Handling","Special Purpose"],"editable":true,"selector":"multiselect"},"Maintenance":{"Policy":{"MaximumOpenJobDays":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"RepeatRepairWindowKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"DefectCloseoutRequired":{"value":false,"editable":true,"selector":"boolean"},"RepeatRepairWindowDays":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"DailyInspectionRequired":{"value":false,"editable":true,"selector":"boolean"},"WeeklyInspectionRequired":{"value":false,"editable":true,"selector":"boolean"},"PreTripInspectionRequired":{"value":false,"editable":true,"selector":"boolean"},"PostTripInspectionRequired":{"value":false,"editable":true,"selector":"boolean"},"CriticalDefectsBlockOperation":{"value":false,"editable":true,"selector":"boolean"}},"Breakdowns":[],"OpenDefects":[],"CurrentStatus":{"Status":{"value":"","options":["All In Order","Attention Needed","Out of Service"],"editable":true,"selector":"select"},"OpenHighJobs":{"value":0,"editable":false,"selector":"number"},"DowntimeStart":{"value":"","editable":true,"selector":"date"},"ExpectedReturn":{"value":"","editable":true,"selector":"date"},"OpenCriticalJobs":{"value":0,"editable":false,"selector":"number"}},"WarrantyClaims":[],"InspectionRecords":[],"MaintenanceRecords":[]},"RunningGear":{"Axles":{"AxleCount":{"value":0,"editable":true,"selector":"number"},"TagAxleCount":{"value":0,"editable":true,"selector":"number"},"LiftAxleCount":{"value":0,"editable":true,"selector":"number"},"SteerAxleCount":{"value":0,"editable":true,"selector":"number"},"DrivenAxleCount":{"value":0,"editable":true,"selector":"number"},"RearAxleRatingKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"AxleConfiguration":{"value":"","editable":true,"selector":"text"},"FrontAxleRatingKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"CombinedAxleRatingKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"}},"Brakes":{"ABS":{"value":false,"editable":true,"selector":"boolean"},"EBS":{"value":false,"editable":true,"selector":"boolean"},"ESC":{"value":false,"editable":true,"selector":"boolean"},"BrakeSystem":{"value":"","options":["","Hydraulic","Air","Air Over Hydraulic","Electric","Mechanical","Regenerative","Mixed"],"editable":true,"selector":"select"},"TractionControl":{"value":false,"editable":true,"selector":"boolean"},"ParkingBrakeType":{"value":"","options":["","Mechanical","Spring Brake","Electric","Hydraulic"],"editable":true,"selector":"select"},"AirBrakeConnection":{"value":false,"editable":true,"selector":"boolean"},"MechanicalOverrunBrake":{"value":false,"editable":true,"selector":"boolean"},"ElectricBrakeConnection":{"value":false,"editable":true,"selector":"boolean"},"HydraulicBrakeConnection":{"value":false,"editable":true,"selector":"boolean"},"BrakeInspectionIntervalKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"BrakeInspectionIntervalHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"}},"Steering":{"Type":{"value":"","options":["","Manual","Hydraulic Power","Electric Power","Hydrostatic","Articulated"],"editable":true,"selector":"select"},"RearSteer":{"value":false,"editable":true,"selector":"boolean"},"SteeredAxles":{"value":0,"editable":true,"selector":"number"}},"Suspension":{"RearType":{"value":"","options":["","Coil","Leaf","Air","Hydraulic","Torsion","Independent","Solid Axle","Tracked"],"editable":true,"selector":"select"},"FrontType":{"value":"","options":["","Coil","Leaf","Air","Hydraulic","Torsion","Independent","Solid Axle","Tracked"],"editable":true,"selector":"select"},"LoadLevelling":{"value":false,"editable":true,"selector":"boolean"},"RideHeightControl":{"value":false,"editable":true,"selector":"boolean"}}},"Agricultural":{"FOPS":{"value":false,"editable":true,"selector":"boolean"},"ROPS":{"value":false,"editable":true,"selector":"boolean"},"Hours":{"HourMeter":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"LastServiceHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"NextServiceHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"ServiceWarningHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"ServiceIntervalHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"}},"Safety":{"SMVSignFitted":{"value":false,"editable":true,"selector":"boolean"},"PTOGuardFitted":{"value":false,"editable":true,"selector":"boolean"},"AmberBeaconFitted":{"value":false,"editable":true,"selector":"boolean"},"ChemicalCabFilter":{"value":false,"editable":true,"selector":"boolean"},"FirstAidKitFitted":{"value":false,"editable":true,"selector":"boolean"},"FireExtinguisherFitted":{"value":false,"editable":true,"selector":"boolean"},"OperatorTrainingRequired":{"value":false,"editable":true,"selector":"boolean"}},"Ballast":{"LiquidBallast":{"value":false,"editable":true,"selector":"boolean"},"RearBallastKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"FrontBallastKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"WheelWeightsKG":{"value":0,"editable":true,"selector":"number","unitType":"Weight"}},"Enabled":{"value":false,"editable":true,"selector":"boolean"},"FieldOnly":{"value":false,"editable":true,"selector":"boolean"},"WorkClasses":{"value":[],"options":["Tillage","Planting","Spraying","Fertilising","Harvesting","Haulage","Mowing","Baling","Loader Work","Forestry","Municipal","Other"],"editable":true,"selector":"multiselect"},"MachineClass":{"value":"","options":["","Agricultural Tractor","Orchard Tractor","Vineyard Tractor","Utility Tractor","Row Crop Tractor","Articulated Tractor","Crawler Tractor","Self-Propelled Sprayer","Combine Harvester","Forage Harvester","Other"],"editable":true,"selector":"select"},"HydraulicSystem":{"PumpType":{"value":"","options":["","Open Centre","Closed Centre","Load Sensing","Pressure Compensated","Other"],"editable":true,"selector":"select"},"CaseDrain":{"value":false,"editable":true,"selector":"boolean"},"PowerBeyond":{"value":false,"editable":true,"selector":"boolean"},"MaximumFlowLPM":{"value":0,"editable":true,"selector":"number","unitType":"Flow"},"RearRemoteCount":{"value":0,"editable":true,"selector":"number"},"FrontRemoteCount":{"value":0,"editable":true,"selector":"number"},"MaximumPressureBar":{"value":0,"editable":true,"selector":"number","unitType":"Pressure"}},"FieldPerformance":{"AdBlueCapacityL":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"RatedPTOPowerKW":{"value":0,"editable":true,"selector":"number","unitType":"Power"},"FuelTankCapacityL":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"RatedDraftPowerKW":{"value":0,"editable":true,"selector":"number","unitType":"Power"},"MaximumFieldSpeedKPH":{"value":0,"editable":true,"selector":"number","unitType":"Speed"},"MinimumFieldSpeedKPH":{"value":0,"editable":true,"selector":"number","unitType":"Speed"},"TypicalWorkingWidthM":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"},"TargetHectaresPerHour":{"value":0,"editable":true,"selector":"number","unitType":"Area"},"TargetFuelLitresPerHour":{"value":0,"editable":true,"selector":"number"},"TargetFuelLitresPerHectare":{"value":0,"editable":true,"selector":"number"}},"ImplementControl":{"ISOBUS":{"value":false,"editable":true,"selector":"boolean"},"FrontPTO":{"value":false,"editable":true,"selector":"boolean"},"AutoSteer":{"value":false,"editable":true,"selector":"boolean"},"FrontLinkage":{"value":false,"editable":true,"selector":"boolean"},"VariableRate":{"value":false,"editable":true,"selector":"boolean"},"SectionControl":{"value":false,"editable":true,"selector":"boolean"},"TaskController":{"value":false,"editable":true,"selector":"boolean"},"GuidanceAccuracyCM":{"value":0,"editable":true,"selector":"number","unitType":"Dimension"}},"CabPressurisation":{"value":false,"editable":true,"selector":"boolean"},"RoadTransferAllowed":{"value":false,"editable":true,"selector":"boolean"}},"FuelAndEnergy":{"SARS":{"Eligible":{"value":false,"editable":true,"selector":"boolean"},"RebateRate":{"value":0,"editable":true,"selector":"currency"},"ClaimCategory":{"value":"","options":["","On-Road","Off-Road","Agricultural","Mining","Forestry","Other"],"editable":true,"selector":"select"},"ComplianceRequired":{"value":false,"editable":true,"selector":"boolean"}},"Electric":{"RangeKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"UsableBatteryKWH":{"value":0,"editable":true,"selector":"number","unitType":"Energy"},"ChargingConnector":{"value":"","options":["","Type 1","Type 2","CCS1","CCS2","CHAdeMO","GB/T","Industrial","Other"],"editable":true,"selector":"select"},"MaximumACChargeKW":{"value":0,"editable":true,"selector":"number","unitType":"Power"},"MaximumDCChargeKW":{"value":0,"editable":true,"selector":"number","unitType":"Power"},"BatteryCapacityKWH":{"value":0,"editable":true,"selector":"number","unitType":"Energy"}},"FuelGrade":{"value":"","options":["","Diesel 10 ppm","Diesel 50 ppm","Petrol 93","Petrol 95","LPG","CNG","Other"],"editable":true,"selector":"select"},"Consumption":{"BaselineKML":{"value":0,"editable":true,"selector":"number"},"BaselineL100KM":{"value":0,"editable":true,"selector":"number"},"HighVariancePercent":{"value":0,"editable":true,"selector":"number"},"BaselineLitresPerHour":{"value":0,"editable":true,"selector":"number"},"WarningVariancePercent":{"value":0,"editable":true,"selector":"number"},"CriticalVariancePercent":{"value":0,"editable":true,"selector":"number"},"BaselineLitresPerHectare":{"value":0,"editable":true,"selector":"number"},"MinimumAnalysisDistanceKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"}},"TankCapacityL":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"UsableRangeKM":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"AdBlueCapacityL":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"PrimaryEnergyType":{"value":"","options":["","Diesel","Petrol","Electric","Hybrid","LPG","CNG","Hydrogen","Other"],"editable":true,"selector":"select"},"AuxiliaryTankCapacityL":{"value":0,"editable":true,"selector":"number","unitType":"Volume"}},"TyrePositions":{"Axles":[],"Spare":null},"FinancialTargets":{"Ideal_Turnover":{"value":0,"editable":true,"selector":"currency"},"Load_Tolerance":{"value":0,"editable":true,"selector":"number","unitType":"Weight"},"Commission_Rate":{"value":0,"editable":true,"selector":"number"},"Ideal_Rate_Per_Km":{"value":0,"editable":true,"selector":"currency","unitType":"CurrencyDistance"},"TargetFuelCostPerKM":{"value":0,"editable":true,"selector":"currency","unitType":"CurrencyDistance"},"TargetTyreCostPerKM":{"value":0,"editable":true,"selector":"currency","unitType":"CurrencyDistance"},"Ideal_Rate_Per_Tonne":{"value":0,"editable":true,"selector":"currency","unitType":"Weight"},"TargetTotalCostPerKM":{"value":0,"editable":true,"selector":"currency","unitType":"CurrencyDistance"},"Target_Driving_Hours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"Monthly_Profit_Target":{"value":0,"editable":true,"selector":"currency"},"TargetUtilisationPercent":{"value":0,"editable":true,"selector":"number"},"TargetMaintenanceCostPerKM":{"value":0,"editable":true,"selector":"currency","unitType":"CurrencyDistance"},"Ideal_Rate_Per_Km_Off_Tonne":{"value":0,"editable":true,"selector":"currency","unitType":"CurrencyDistance"}},"DriverRequirements":{"Notes":{"value":"","editable":true,"selector":"textarea"},"PrDPRequired":{"value":false,"editable":true,"selector":"boolean"},"PrDPCategories":{"value":[],"options":["P","D","G"],"editable":true,"selector":"multiselect"},"CalculationMode":{"value":"","options":["Auto","Manual"],"editable":true,"selector":"select"},"ConductorRequired":{"value":false,"editable":true,"selector":"boolean"},"MinimumLicenceCode":{"value":"","options":["","A1","A","B","C1","C","EB","EC1","EC"],"editable":true,"selector":"select"},"AdvancedDrivingRequired":{"value":false,"editable":true,"selector":"boolean"},"BaseVehicleLicenceCodes":{"value":[],"options":["A1","A","B","C1","C"],"editable":true,"selector":"multiselect"},"CombinationLicenceCodes":{"value":[],"options":["EB","EC1","EC"],"editable":true,"selector":"multiselect"},"DefensiveDrivingRequired":{"value":false,"editable":true,"selector":"boolean"},"CrossBorderPermitRequired":{"value":false,"editable":true,"selector":"boolean"},"AbnormalLoadPermitRequired":{"value":false,"editable":true,"selector":"boolean"},"TwoDriverOperationRequired":{"value":false,"editable":true,"selector":"boolean"},"DangerousGoodsTrainingRequired":{"value":false,"editable":true,"selector":"boolean"},"ImplementSpecificTrainingRequired":{"value":false,"editable":true,"selector":"boolean"},"AgriculturalOperatorTrainingRequired":{"value":false,"editable":true,"selector":"boolean"}},"OperationalTargets":{"Fuel_Counter":{"value":0,"editable":true,"selector":"number","unitType":"Volume"},"MaximumIdlePercent":{"value":0,"editable":true,"selector":"number"},"MonthlyLoadsTarget":{"value":0,"editable":true,"selector":"number"},"Fuel_Check_Frequency":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"MaximumDowntimeHours":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"MonthlyHectaresTarget":{"value":0,"editable":true,"selector":"number","unitType":"Area"},"Monthly_Mileage_Target":{"value":0,"editable":true,"selector":"number","unitType":"Distance"},"Monthly_Tonnage_Target":{"value":0,"editable":false,"selector":"number","unitType":"Weight"},"MonthlyEngineHoursTarget":{"value":0,"editable":true,"selector":"number","unitType":"Time"},"FuelConsumptionHighPercent":{"value":0,"editable":true,"selector":"number"},"FuelConsumptionWarningPercent":{"value":0,"editable":true,"selector":"number"},"FuelConsumptionCriticalPercent":{"value":0,"editable":true,"selector":"number"}}};

  	  const DEFAULT_TRACTOR_DATA_TEMPLATE = {
  	  "Service": {
  	    "Setup": {
  	      "UpdatedAt": {
  	        "value": "",
  	        "editable": false,
  	        "selector": "text"
  	      },
  	      "UpdatedBy": {
  	        "value": "",
  	        "editable": false,
  	        "selector": "text"
  	      },
  	      "InitialLastServiceDate": {
  	        "value": "",
  	        "editable": false,
  	        "selector": "date"
  	      },
  	      "InitialLastServiceUnit": {
  	        "value": "",
  	        "editable": false,
  	        "selector": "text"
  	      },
  	      "InitialLastServiceReading": {
  	        "value": 0,
  	        "editable": false,
  	        "selector": "number",
  	        "unitType": "Distance"
  	      },
  	      "InitialLastServiceCaptured": {
  	        "value": false,
  	        "editable": false,
  	        "selector": "boolean"
  	      },
  	      "InitialLastServiceCapturedAt": {
  	        "value": "",
  	        "editable": false,
  	        "selector": "text"
  	      },
  	      "InitialLastServiceCapturedBy": {
  	        "value": "",
  	        "editable": false,
  	        "selector": "text"
  	      },
  	      "InitialLastServiceCapturedByEmail": {
  	        "value": "",
  	        "editable": false,
  	        "selector": "text"
  	      },
  	      "InitialLastServiceCapturedByObjectId": {
  	        "value": "",
  	        "editable": false,
  	        "selector": "text"
  	      }
  	    },
  	    "Current": {
  	      "ServiceStatus": {
  	        "value": "",
  	        "options": [
  	          "All In Order",
  	          "Attention Needed",
  	          "Out of Service"
  	        ],
  	        "editable": true,
  	        "selector": "select"
  	      },
  	      "WarningResetAt": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "text"
  	      },
  	      "LastServiceDate": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "date"
  	      },
  	      "NextServiceDate": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "date"
  	      },
  	      "LastServiceHours": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Time"
  	      },
  	      "NextServiceHours": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Time"
  	      },
  	      "LastServiceMileage": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Distance"
  	      },
  	      "NextServiceMileage": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Distance"
  	      },
  	      "ServiceWarningActive": {
  	        "value": false,
  	        "editable": true,
  	        "selector": "boolean"
  	      },
  	      "ServiceCentreLastUsed": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "text"
  	      }
  	    },
  	    "History": {
  	      "Last_Service_KM": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Distance"
  	      },
  	      "Next_Service_KM": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Distance"
  	      },
  	      "Last_Service_Date": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "date"
  	      },
  	      "Last_Service_Hours": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Time"
  	      },
  	      "Next_Service_Hours": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Time"
  	      },
  	      "Service_Centre_Last_Used": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "text"
  	      },
  	      "Next_Service_Date_Estimate": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "date"
  	      }
  	    },
  	    "Schedule": {
  	      "ServiceWarningKM": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Distance"
  	      },
  	      "ServiceIntervalKM": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Distance"
  	      },
  	      "ServiceWarningDays": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Time"
  	      },
  	      "ServiceIntervalDays": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Time"
  	      },
  	      "ServiceWarningHours": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Time"
  	      },
  	      "ServiceIntervalHours": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Time"
  	      }
  	    },
  	    "Notifications": {
  	      "NotifyCompany": {
  	        "value": false,
  	        "editable": true,
  	        "selector": "boolean"
  	      },
  	      "NotifyServiceProvider": {
  	        "value": false,
  	        "editable": true,
  	        "selector": "boolean"
  	      }
  	    },
  	    "Service_Status": {
  	      "value": "",
  	      "options": [
  	        "All In Order",
  	        "Attention Needed",
  	        "Out of Service"
  	      ],
  	      "editable": true,
  	      "selector": "select"
  	    }
  	  },
  	  "Vehicle": {
  	    "Usage": {
  	      "Range": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number",
  	        "unitType": "Distance"
  	      },
  	      "CounterType": {
  	        "value": "",
  	        "options": [
  	          "Kilometers",
  	          "Hours"
  	        ],
  	        "editable": true,
  	        "selector": "select"
  	      },
  	      "CurrentReading": {
  	        "value": 0,
  	        "editable": false,
  	        "selector": "number",
  	        "unitType": "Distance"
  	      }
  	    },
  	    "Identity": {
  	      "FID": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "text"
  	      },
  	      "VIN": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "text"
  	      },
  	      "Make": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "text"
  	      },
  	      "Year": {
  	        "value": 0,
  	        "editable": true,
  	        "selector": "number"
  	      },
  	      "Model": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "text"
  	      },
  	      "EngineNumber": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "text"
  	      },
  	      "Registration": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "text"
  	      }
  	    },
  	    "Appearance": {
  	      "Color": {
  	        "value": "",
  	        "editable": true,
  	        "selector": "color"
  	      }
  	    },
  	    "Classification": {
  	      "VehicleType": {
  	        "value": "",
  	        "options": [
  	          "",
  	          "LDV",
  	          "Commercial",
  	          "Agricultural",
  	          "Plant",
  	          "Personal"
  	        ],
  	        "editable": true,
  	        "selector": "select"
  	      }
  	    }
  	  },
  	  "Compliance": {
  	    "Setup": {
  	      "Configured": false,
  	      "WarningDays": 0,
  	      "Requirements": {
  	        "LoadTest": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "Insurance": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "Calibration": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "DangerousGoods": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "ROPSInspection": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "Roadworthiness": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "VehicleLicence": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "OperatingPermit": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "FireExtinguisher": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "CrossBorderPermit": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "PTOGuardInspection": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        },
  	        "TrackingCertificate": {
  	          "Required": false,
  	          "ExpiryDate": ""
  	        }
  	      }
  	    }
  	  },
  	  "Maintenance": {
  	    "PreventivePlans": []
  	  },
  	  "FuelAndEnergy": {
  	    "SARSRate": {
  	      "value": 0,
  	      "editable": true,
  	      "selector": "number"
  	    },
  	    "FuelGrade": {
  	      "value": "",
  	      "options": [
  	        "",
  	        "Diesel 10 ppm",
  	        "Diesel 50 ppm",
  	        "Petrol 93",
  	        "Petrol 95",
  	        "LPG",
  	        "CNG",
  	        "Other"
  	      ],
  	      "editable": true,
  	      "selector": "select"
  	    },
  	    "SARSCompliance": {
  	      "value": false,
  	      "editable": true,
  	      "selector": "boolean"
  	    }
  	  }
  	};

  	  const DEFAULT_TRACTOR_CAN_TEMPLATE = {"RPM":2500,"Idle":120,"Tank":80,"Temp":90,"RPMGH":1900,"RPMGL":1300,"Speed":80,"Units":{"rpm":"rpm","speed":"km/h","fuel_l":"L","fuel_pct":"%"},"AccelG":0.2,"BrakeG":-0.28,"Engine":{"points":{"include_full_point":true},"distance":{"mode":"auto","lat_path":"#/Stream/lat","lon_path":"#/Stream/lon","odometer_path":"#/Stream/odometer_km"},"gates_defaults":{"requireAll":[{"op":"truthy","field":"position.valid"}]},"stability_defaults":{"dwell_ms":500,"hysteresis":0}},"Events":[{"calc":{"test":{"op":"truthy"},"signal":{"fn":"any","fields":["can.abs.failure.indicator.status","can.esp.indicator.status","can.eps.indicator.status"]}},"name":"ABS/ESP Fault","enabled":{"$ref":"#/EventsBoolean/ABS/ESP Fault"},"category":"Engine","description":"Triggers when the vehicle reports an active ABS, ESP, or EPS fault indicator.","segmentation":{"exit_when":"immediate","enter_when":"immediate"}},{"calc":{"test":{"op":"truthy"},"signal":{"a":{"field":"engine.ignition.status"},"b":{"field":"can.vehicle.battery.charging.status"},"fn":"both","op":"and_not_b"}},"name":"Alternator Not Charging","enabled":{"$ref":"#/EventsBoolean/Alternator Not Charging"},"category":"Engine","description":"Triggers when ignition is on but the vehicle battery is not reporting a charging state for the configured duration.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":10000}},{"calc":{"test":{"op":"<","threshold":{"$ref":"#/Voltage"}},"signal":{"fn":"value","field":"external.powersource.voltage"}},"name":"Battery Low Voltage","enabled":{"$ref":"#/EventsBoolean/Battery Low Voltage"},"category":"Engine","description":"Triggers when external power voltage falls below the configured Voltage threshold.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":5000}},{"calc":{"test":{"op":"truthy"},"signal":{"fn":"value","field":"can.check.engine.indicator.status"}},"name":"Check Engine Light","enabled":{"$ref":"#/EventsBoolean/Check Engine Light"},"category":"Engine","description":"Triggers when the vehicle reports an active check-engine warning from CAN.","segmentation":{"exit_when":"immediate","enter_when":"immediate"}},{"calc":{"test":{"op":"truthy"},"signal":{"fn":"value","field":"can.coolant.level.low.indicator.status"}},"name":"Coolant Level Low","gates":{"requireAll":[{"op":"truthy","field":"engine.ignition.status"}]},"enabled":{"$ref":"#/EventsBoolean/Coolant Level Low"},"category":"Engine","description":"Triggers when the coolant level low warning is active while ignition is on.","segmentation":{"exit_when":"immediate","enter_when":"immediate"}},{"calc":{"test":{"op":"truthy"},"signal":{"fn":"value","field":"can.cruise.control.status"}},"name":"Cruise Control Active","enabled":{"$ref":"#/EventsBoolean/Cruise Control Active"},"category":"Motion","description":"Tracks periods where the vehicle reports cruise control as active.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes"}},{"calc":{"test":{"op":">","threshold":{"$ref":"#/RPM"}},"signal":{"fn":"value","field":"can.engine.rpm"}},"name":"Engine Over-Rev","enabled":{"$ref":"#/EventsBoolean/Engine Over-Rev"},"category":"Motion","aggregation":{"metrics":["avg","max"],"value_from":"calc.signal"},"description":"Triggers when engine RPM rises above the configured RPM threshold.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","max_gap_ms":30000}},{"calc":{"test":{"op":">","threshold":{"$ref":"#/Temp"}},"signal":{"fn":"value","field":"can.engine.temperature"}},"name":"Engine Over-Temperature","enabled":{"$ref":"#/EventsBoolean/Engine Over-Temperature"},"category":"Engine","description":"Triggers when engine temperature rises above the configured Temp threshold for the configured duration.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":10000}},{"calc":{"test":{"op":"truthy"},"signal":{"fn":"value","field":"can.neutral.gear.status"}},"name":"Excessive Coasting (Neutral)","gates":{"requireAll":[{"op":">","field":"position.speed","trigger":20}]},"enabled":{"$ref":"#/EventsBoolean/Excessive Coasting (Neutral)"},"category":"Motion","description":"Triggers when neutral gear is active while the vehicle is moving above the configured speed gate.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","max_gap_ms":30000}},{"calc":{"test":{"op":"truthy"},"signal":{"fn":"value","field":"factory.alarm.actuated.status"}},"name":"Factory Alarm Triggered","enabled":{"$ref":"#/EventsBoolean/Factory Alarm Triggered"},"category":"Security","description":"Triggers when the factory alarm reports an actuated state.","segmentation":{"exit_when":"immediate","enter_when":"immediate"}},{"calc":{"test":{"op":">=","threshold":2},"signal":{"fn":"delta","field":"can.fuel.level","lookback":{"samples":5},"direction":"rise","transform":{"to":"liters","capacityRef":"#/Tank"}}},"name":"Fuel Gain (Refuel)","gates":{"requireAny":[{"op":"<=","field":"position.speed","trigger":5},{"op":"falsy","field":"engine.ignition.status"}]},"enabled":{"$ref":"#/EventsBoolean/Fuel Gain (Refuel)"},"category":"Fuel","aggregation":{"metrics":["sum","max"],"value_from":"calc.signal"},"description":"Detects a significant fuel level increase, usually indicating refuelling while stopped or with ignition off.","segmentation":{"exit_when":"immediate","enter_when":"test_passes","max_gap_ms":900000}},{"calc":{"test":{"op":">=","threshold":{"$ref":"#/FuelLossStepL"}},"signal":{"fn":"delta","field":"can.fuel.level","lookback":{"samples":5},"direction":"drop","transform":{"to":"liters","capacityRef":"#/Tank"}},"stability":{"no_rebound":{"window_s":360,"tolerance_pct":10}}},"name":"Fuel Loss","gates":{"requireAll":[{"op":"<=","field":"position.hdop","trigger":{"$ref":"#/PoorHdop"}},{"op":"<=","field":"position.speed","trigger":2},{"op":"<=","field":"grade.pct","trigger":2},{"op":">=","field":"grade.pct","trigger":-2}]},"enabled":{"$ref":"#/EventsBoolean/Fuel Loss"},"category":"Fuel","aggregation":{"metrics":["avg","max"]},"description":"Detects a significant fuel level drop while the vehicle is stationary and GPS and grade conditions are acceptable.","segmentation":{"exit_when":"no_rebound_failed_or_test_fails","enter_when":"test_passes","max_gap_ms":30000}},{"calc":{"test":{"op":"truthy"},"signal":{"fn":"value","field":"can.fuel.sensor.fault.status"}},"name":"Fuel Sensor Fault","enabled":{"$ref":"#/EventsBoolean/Fuel Sensor Fault"},"category":"Fuel","description":"Triggers when the vehicle reports a CAN fuel sensor fault.","segmentation":{"exit_when":"immediate","enter_when":"immediate"}},{"calc":{"test":{"op":"truthy"},"signal":{"fn":"edge","field":"gnss.state.enum"}},"name":"GNSS Mode Drop","enabled":{"$ref":"#/EventsBoolean/GNSS Mode Drop"},"category":"GNSS","description":"Triggers when the GNSS mode changes or drops unexpectedly.","segmentation":{"exit_when":"immediate","enter_when":"immediate"}},{"calc":{"test":{"op":">","threshold":50},"signal":{"fn":"drift","lat":"position.latitude","lon":"position.longitude","speed":"position.speed"}},"name":"GPS Drift Detected","gates":{"requireAll":[{"op":"falsy","field":"engine.ignition.status"},{"op":"<=","field":"position.speed","trigger":1}]},"enabled":{"$ref":"#/EventsBoolean/GPS Drift Detected"},"category":"GNSS","description":"Detects possible GPS drift while the vehicle is stationary and ignition is off.","segmentation":{"exit_when":"stabilized","enter_when":"test_passes"}},{"calc":{"test":{"hi":{"$ref":"#/RPMGH"},"lo":{"$ref":"#/RPMGL"},"op":"between"},"signal":{"fn":"value","field":"can.engine.rpm"}},"name":"Green Band Driving","gates":{},"enabled":{"$ref":"#/EventsBoolean/Green Band Driving"},"category":"Fuel","description":"Tracks driving while engine RPM stays inside the configured efficient RPM band.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":3000}},{"calc":{"test":{"op":">=","threshold":{"$ref":"#/AccelG"}},"signal":{"fn":"value","field":"x.acceleration"}},"name":"Harsh Acceleration","enabled":{"$ref":"#/EventsBoolean/Harsh Acceleration"},"category":"Motion","description":"Triggers when acceleration exceeds the configured AccelG threshold.","segmentation":{"exit_when":"immediate","enter_when":"immediate","max_gap_ms":5000}},{"calc":{"test":{"op":"<=","threshold":{"$ref":"#/BrakeG"}},"signal":{"fn":"value","field":"x.acceleration"}},"name":"Harsh Braking","enabled":{"$ref":"#/EventsBoolean/Harsh Braking"},"category":"Motion","description":"Triggers when braking force exceeds the configured BrakeG threshold.","segmentation":{"exit_when":"immediate","enter_when":"immediate","max_gap_ms":5000}},{"calc":{"test":{"op":">=","threshold":{"$ref":"#/CornerG"}},"signal":{"fn":"value","field":"x.cornering"}},"name":"Harsh Cornering","enabled":{"$ref":"#/EventsBoolean/Harsh Cornering"},"category":"Motion","description":"Triggers when lateral cornering force exceeds the configured CornerG threshold.","segmentation":{"exit_when":"immediate","enter_when":"immediate","max_gap_ms":5000}},{"calc":{"test":{"op":">","threshold":{"$ref":"#/Idle"}},"signal":{"fn":"value","field":"idle.total"}},"name":"Idle Event","enabled":{"$ref":"#/EventsBoolean/Idle Event"},"category":"Motion","aggregation":{"metrics":["duration","avg","max"],"value_from":"calc.signal"},"description":"Tracks idle time once the calculated idle total rises above the configured Idle threshold.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","max_gap_ms":300000,"min_duration_ms":0}},{"calc":{"test":{"op":"truthy"},"signal":{"a":{"field":"can.low.beam.status"},"b":{"field":"can.high.beam.status"},"fn":"both","op":"both_false"}},"name":"Lights Off at Night","gates":{"requireAll":[{"hi":{"$ref":"#/NightHoursEnd"},"lo":{"$ref":"#/NightHoursStart"},"op":"time_between","field":"localtime"},{"op":">=","field":"position.speed","trigger":{"$ref":"#/Speed"}}]},"enabled":{"$ref":"#/EventsBoolean/Lights Off at Night"},"category":"Environment","description":"Triggers when the vehicle is moving at night above the configured speed threshold while headlights are off.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":10000}},{"calc":{"test":{"op":"<=","threshold":{"$ref":"#/LowFuel"}},"signal":{"fn":"value","field":"can.fuel.level"}},"name":"Low Fuel","enabled":{"$ref":"#/EventsBoolean/Low Fuel"},"category":"Fuel","description":"Triggers when fuel level falls below the configured LowFuel threshold.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","max_gap_ms":60000}},{"calc":{"test":{"op":"truthy"},"signal":{"fn":"value","field":"can.oil.pressure.indicator.status"}},"name":"Oil Pressure Warning","gates":{"requireAll":[{"op":"truthy","field":"engine.ignition.status"}]},"enabled":{"$ref":"#/EventsBoolean/Oil Pressure Warning"},"category":"Engine","description":"Triggers when the oil pressure warning is active while ignition is on.","segmentation":{"exit_when":"immediate","enter_when":"immediate"}},{"calc":{"test":{"op":">","threshold":{"$ref":"#/PoorHdop"}},"signal":{"fn":"value","field":"position.hdop"}},"name":"Poor GNSS Quality","enabled":{"$ref":"#/EventsBoolean/Poor GNSS Quality"},"category":"GNSS","description":"Triggers when HDOP rises above the configured PoorHdop threshold.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes"}},{"calc":{"test":{"op":"falsy"},"signal":{"fn":"value","field":"position.valid"}},"name":"Position Invalid","enabled":{"$ref":"#/EventsBoolean/Position Invalid"},"category":"GNSS","description":"Triggers when the GPS position validity flag reports false.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes"}},{"calc":{"test":{"op":"truthy"},"signal":{"fn":"value","field":"din.1"}},"name":"PTO Active (DIN)","enabled":{"$ref":"#/EventsBoolean/PTO Active (DIN)"},"category":"Environment","description":"Triggers when the configured digital input for PTO activity is active.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes"}},{"calc":{"test":{"hi":{"$ref":"#/RetarderRpmHigh"},"lo":{"$ref":"#/RetarderRpmLow"},"op":"between"},"signal":{"fn":"value","field":"can.engine.rpm"}},"name":"Retarder Effective","gates":{"requireAll":[{"op":"truthy","field":"position.valid"},{"op":"<=","field":"position.hdop","trigger":{"$ref":"#/PoorHdop"}},{"op":"truthy_any","fields":["can.manual.retarder.status","can.automatic.retarder.status"]},{"op":"<=","field":"grade.pct","trigger":-2}]},"enabled":{"$ref":"#/EventsBoolean/Retarder Effective"},"category":"Braking","description":"Tracks retarder use while engine RPM stays inside the configured retarder operating range on a descent.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":3000}},{"calc":{"test":{"op":">","threshold":{"$ref":"#/RetarderRpmHigh"}},"signal":{"fn":"value","field":"can.engine.rpm"}},"name":"Retarder RPM High","gates":{"requireAll":[{"op":"truthy","field":"position.valid"},{"op":"<=","field":"position.hdop","trigger":{"$ref":"#/PoorHdop"}},{"op":"truthy_any","fields":["can.manual.retarder.status","can.automatic.retarder.status"]},{"op":"<=","field":"grade.pct","trigger":-2}]},"enabled":{"$ref":"#/EventsBoolean/Retarder RPM High"},"category":"Braking","description":"Warns when the retarder is active but engine RPM is above the retarder’s effective operating range.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":3000}},{"calc":{"test":{"op":"<","threshold":{"$ref":"#/RetarderRpmLow"}},"signal":{"fn":"value","field":"can.engine.rpm"}},"name":"Retarder RPM Low","gates":{"requireAll":[{"op":"truthy","field":"position.valid"},{"op":"<=","field":"position.hdop","trigger":{"$ref":"#/PoorHdop"}},{"op":"truthy_any","fields":["can.manual.retarder.status","can.automatic.retarder.status"]},{"op":"<=","field":"grade.pct","trigger":-2}]},"enabled":{"$ref":"#/EventsBoolean/Retarder RPM Low"},"category":"Braking","description":"Warns when the retarder is active but engine RPM is below the retarder’s effective operating range.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":3000}},{"calc":{"test":{"op":">","threshold":8},"signal":{"fn":"drift","speed":"position.speed"}},"name":"Retarder Expected Off","gates":{"requireAll":[{"op":"<=","field":"grade.pct","trigger":-2},{"op":"falsy_any","fields":["can.manual.retarder.status","can.automatic.retarder.status"]}]},"enabled":{"$ref":"#/EventsBoolean/Retarder Expected Off"},"category":"Braking","description":"Triggers on downhill speed drift when the retarder is expected but not active.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":3000}},{"calc":{"test":{"op":">=","threshold":{"$ref":"#/RetarderRpmHigh"}},"signal":{"fn":"value","field":"can.engine.rpm"}},"name":"Retarder Ineffective","gates":{"requireAll":[{"op":"truthy_any","fields":["can.manual.retarder.status","can.automatic.retarder.status"]},{"op":">","field":"drift.kph_10s","trigger":8}]},"enabled":{"$ref":"#/EventsBoolean/Retarder Ineffective"},"category":"Braking","description":"Triggers when the retarder is active but vehicle speed continues drifting upward on descent.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","min_duration_ms":3000}},{"calc":{"test":{"op":"truthy"},"signal":{"a":{"field":"can.reverse.gear.status"},"b":{"field":"position.speed"},"fn":"both","op":"b_gt","trigger":5}},"name":"Reverse While Moving Fast","enabled":{"$ref":"#/EventsBoolean/Reverse While Moving Fast"},"category":"Motion","description":"Triggers when reverse gear is active while the vehicle is moving above the safe speed threshold.","segmentation":{"exit_when":"immediate","enter_when":"immediate"}},{"calc":{"test":{"op":"falsy"},"signal":{"fn":"value","field":"engine.ignition.status"}},"name":"Rolling With Ignition Off","gates":{"requireAll":[{"op":">","field":"position.speed","trigger":5}]},"enabled":{"$ref":"#/EventsBoolean/Rolling With Ignition Off"},"category":"Motion","description":"Triggers when the vehicle is moving while ignition is off.","segmentation":{"exit_when":"either","enter_when":"both","max_gap_ms":20000}},{"calc":{"test":{"op":">=","threshold":3},"signal":{"fn":"edge_count","field":"can.pedal.brake.status","lookback":{"ms":10000}}},"name":"Service Brake Overuse on Descent","gates":{"requireAll":[{"op":"<=","field":"grade.pct","trigger":-2},{"op":"falsy_any","fields":["can.manual.retarder.status","can.automatic.retarder.status"]}]},"enabled":{"$ref":"#/EventsBoolean/Service Brake Overuse on Descent"},"category":"Braking","description":"Triggers when repeated service-brake use is detected on a descent without retarder assistance.","segmentation":{"exit_when":"immediate","enter_when":"immediate"}},{"calc":{"test":{"op":">","threshold":{"$ref":"#/Speed"}},"signal":{"fn":"value","field":"position.speed"}},"name":"Speeding","gates":{"requireAll":[{"op":"<=","field":"position.hdop","trigger":{"$ref":"#/PoorHdop"}}]},"enabled":{"$ref":"#/EventsBoolean/Speeding"},"category":"Motion","aggregation":{"metrics":["avg","max"],"value_from":"calc.signal"},"description":"Triggers when vehicle speed rises above the configured Speed threshold.","segmentation":{"exit_when":"test_fails","enter_when":"test_passes","max_gap_ms":30000}},{"calc":{"test":{"op":"truthy"},"signal":{"a":{"field":"engine.ignition.status"},"b":{"field":"position.speed"},"fn":"both","op":"not_a_and_b_gt","trigger":{"$ref":"#/Speed"}}},"name":"Tow Detection","enabled":{"$ref":"#/EventsBoolean/Tow Detection"},"category":"Security","description":"Triggers when the vehicle appears to be moving above the configured speed threshold while ignition is off.","segmentation":{"exit_when":"test_fails","enter_when":"immediate"}}],"Stream":{"lat":"position.latitude","lon":"position.longitude","speed":"position.speed","timestamp":"timestamp","odometer_km":"vehicle.mileage","fallback_speed":"can.vehicle.speed"},"CornerG":-0.01,"LowFuel":15,"SpeedGL":1,"Voltage":11,"PoorHdop":2.5,"Exclusions":["GNSS Mode Drop","GPS Drift Detected","Poor GNSS Quality","Position Invalid"],"GradePctMax":5,"EventsBoolean":{"Low Fuel":false,"Speeding":true,"Fuel Loss":false,"Idle Event":true,"ABS/ESP Fault":true,"Harsh Braking":true,"Tow Detection":true,"GNSS Mode Drop":true,"Engine Over-Rev":true,"Harsh Cornering":true,"PTO Active (DIN)":true,"Position Invalid":true,"Retarder RPM Low":true,"Coolant Level Low":true,"Fuel Sensor Fault":true,"Poor GNSS Quality":true,"Retarder RPM High":true,"Check Engine Light":true,"Fuel Gain (Refuel)":false,"GPS Drift Detected":true,"Green Band Driving":true,"Harsh Acceleration":true,"Retarder Effective":true,"Battery Low Voltage":true,"Lights Off at Night":true,"Oil Pressure Warning":true,"Retarder Ineffective":true,"Cruise Control Active":true,"Retarder Expected Off":true,"Alternator Not Charging":true,"Engine Over-Temperature":true,"Factory Alarm Triggered":true,"Reverse While Moving Fast":true,"Rolling With Ignition Off":true,"Excessive Coasting (Neutral)":true,"Service Brake Overuse on Descent":true},"FuelLossStepL":14,"NightHoursEnd":"05:30","RetarderRpmLow":1300,"NightHoursStart":"18:00","RetarderRpmHigh":2200,"ParameterDescriptions":{"RPM":"Engine over-rev threshold. Engine Over-Rev triggers when engine RPM rises above this value.","Idle":"Idle threshold in seconds. Idle Event triggers when idle time rises above this value.","Tank":"Fuel tank capacity in litres. Used to convert fuel percentage changes into litre-based fuel gain or fuel loss amounts.","Temp":"Engine temperature threshold, usually in °C. Engine Over-Temperature triggers when temperature rises above this value.","RPMGH":"Green band high RPM. Used as the upper limit of the efficient driving RPM band.","RPMGL":"Green band low RPM. Used as the lower limit of the efficient driving RPM band.","Speed":"Speed threshold in km/h. Used by Speeding, Lights Off at Night, and Tow Detection.","AccelG":"Harsh acceleration threshold measured in G-force. Harsh Acceleration triggers when acceleration is greater than or equal to this value.","BrakeG":"Harsh braking threshold measured in G-force. Harsh Braking triggers when deceleration is less than or equal to this negative value.","CornerG":"Harsh cornering threshold measured in lateral G-force.","LowFuel":"Low fuel threshold, usually as a percentage. Low Fuel triggers when fuel level falls to or below this value.","SpeedGL":"Low speed gate value used where very slow movement needs to be distinguished from stationary behaviour.","Voltage":"Low voltage threshold. Battery Low Voltage triggers when external power voltage falls below this value.","PoorHdop":"Maximum acceptable HDOP value before GNSS quality is treated as poor.","GradePctMax":"Maximum grade percentage used by grade-sensitive detection logic.","FuelLossStepL":"Minimum sudden fuel drop, in litres, required before Fuel Loss can trigger.","NightHoursEnd":"End time for night-driving checks used by Lights Off at Night.","RetarderRpmLow":"Truck retarder lower RPM limit. Warns when engine RPM is below the retarder’s effective operating range.","NightHoursStart":"Start time for night-driving checks used by Lights Off at Night.","RetarderRpmHigh":"Truck retarder upper RPM limit. Warns when engine RPM is above the retarder’s effective operating range."}};

  	  const OPTIONS = Object.freeze({
  	    APP: Object.freeze(["Office", "Road", "Bowser"]),
  	    Office: Object.freeze(["LiveTrack", "Bowser", "Dash", "Locations"]),
  	    Settings: Object.freeze([
  	      "Applications",
  	      "Users",
  	      "Vehicles",
  	      "Trailers",
  	      "Fuel",
  	      "Tyres",
  	      "Finances",
  	      "Maintenance",
  	      "Service",
  	      "Compliance",
  	      "Overview",
  	      "VehicleData",
  	      "Alerts",
  	      "Rig"
  	    ]),
  	    OperationalRole: Object.freeze(["Financial", "Admin", "Driver", "Load Planner", "Mechanic", "Bowser"]),
  	    CompanyStatus: Object.freeze(["ACTIVE", "SUSPENDED", "INACTIVE"]),
  	    UserStatus: Object.freeze(["ENABLED", "DISABLED"]),
  	    AccountType: Object.freeze(["Director / Super User"]),
  	    EntityType: Object.freeze(["", "Sole Proprietor", "Partnership", "Private Company", "Public Company", "Close Corporation", "Trust", "Non-Profit Company", "Government", "Other"]),
  	    BillingStatus: Object.freeze(["TRIAL", "ACTIVE", "ON_HOLD", "SUSPENDED", "CANCELLED"]),
  	    SubscriptionStatus: Object.freeze(["TRIAL", "ACTIVE", "PAUSED", "SUSPENDED", "CANCELLED", "EXPIRED"]),
  	    BillingCycle: Object.freeze(["MONTHLY", "QUARTERLY", "ANNUALLY", "CUSTOM"]),
  	    InvoiceFrequency: Object.freeze(["MONTHLY", "QUARTERLY", "ANNUALLY", "ON_DEMAND"]),
  	    BillingModel: Object.freeze(["FLAT_RATE", "PER_USER", "PER_ASSET", "HYBRID", "CUSTOM"]),
  	    Currency: Object.freeze(["ZAR", "USD", "EUR", "GBP"]),
  	    PaymentMethod: Object.freeze(["", "EFT", "DEBIT_ORDER", "CARD", "CASH", "OTHER"]),
  	    DebitOrderStatus: Object.freeze(["NOT_APPLICABLE", "PENDING", "ACTIVE", "SUSPENDED", "CANCELLED"]),
  	    FuelGrade: Object.freeze(["Diesel 10ppm", "Diesel 50ppm", "Diesel 500ppm", "ULP 93", "ULP 95", "Other"]),
  	    YesNo: Object.freeze(["No", "Yes"])
  	  });

  	  function readArgument(name, lowerName, index) {
  	    try {
  	      if (typeof ___arguments !== "undefined" && ___arguments) {
  	        if (___arguments[name] !== undefined) return ___arguments[name];
  	        if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	        if (___arguments[index] !== undefined) return ___arguments[index];
  	      }
  	    } catch (_) {}
  	    return undefined;
  	  }

  	  const APP_INPUT =
  	    (typeof App !== "undefined" ? App : undefined) ||
  	    readArgument("App", "app", 0) ||
  	    null;

  	  const SVG_INPUT =
  	    (typeof SVG !== "undefined" ? SVG : undefined) ||
  	    readArgument("SVG", "svg", 1) ||
  	    "";

  	  const GOOGLE_MAPS_API_KEY_INPUT =
  	    (typeof GoogleMapsApiKey !== "undefined" ? GoogleMapsApiKey : undefined) ||
  	    readArgument("GoogleMapsApiKey", "googleMapsApiKey", 2) ||
  	    readArgument("GoogleMapApiKey", "googleMapApiKey", 2) ||
  	    "";

  	  const BackendlessApi =
  	    (typeof Backendless !== "undefined" ? Backendless : null) ||
  	    (typeof window !== "undefined" ? window.Backendless : null);

  	  function resolveAppData(input) {
  	    try {
  	      if (input && input.data && typeof input.data === "object") return input.data;
  	      if (input && input.User && typeof input === "object") return input;
  	    } catch (_) {}
  	    try {
  	      if (typeof BackendlessUI !== "undefined" && BackendlessUI.App && BackendlessUI.App.data) {
  	        return BackendlessUI.App.data;
  	      }
  	    } catch (_) {}
  	    try {
  	      if (typeof window !== "undefined" && window.AppData) {
  	        return window.AppData.data || window.AppData;
  	      }
  	    } catch (_) {}
  	    return null;
  	  }

  	  const APP_DATA = resolveAppData(APP_INPUT);

  	  function googleMapsApiKey() {
  	    const value = GOOGLE_MAPS_API_KEY_INPUT;
  	    if (value && typeof value === "object") {
  	      return clean(value.value || value.key || value.apiKey || value.GoogleMapsApiKey || "");
  	    }
  	    return clean(value);
  	  }

  	  function text(value) {
  	    return value === undefined || value === null ? "" : String(value);
  	  }

  	  function clean(value) {
  	    return text(value).trim();
  	  }

  	  function lower(value) {
  	    return clean(value).toLowerCase();
  	  }

  	  function arr(value) {
  	    return Array.isArray(value) ? value : [];
  	  }

  	  function isObject(value) {
  	    return !!value && typeof value === "object" && !Array.isArray(value);
  	  }

  	  function clone(value) {
  	    if (value === undefined) return undefined;
  	    try {
  	      return JSON.parse(JSON.stringify(value));
  	    } catch (_) {
  	      return value;
  	    }
  	  }

  	  function merge(target, source) {
  	    const output = isObject(target) ? target : {};
  	    if (!isObject(source)) return output;
  	    Object.keys(source).forEach(function (key) {
  	      const value = source[key];
  	      if (Array.isArray(value)) output[key] = clone(value);
  	      else if (isObject(value)) output[key] = merge(isObject(output[key]) ? output[key] : {}, value);
  	      else output[key] = value;
  	    });
  	    return output;
  	  }

  	  function parseJsonLoose(value, fallback) {
  	    if (isObject(value) || Array.isArray(value)) return clone(value);
  	    const source = clean(value);
  	    if (!source) return clone(fallback);
  	    try {
  	      return JSON.parse(source);
  	    } catch (_) {
  	      return clone(fallback);
  	    }
  	  }

  	  function escapeHtml(value) {
  	    return text(value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/\"/g, "&quot;")
  	      .replace(/'/g, "&#39;");
  	  }

  	  function escapeAttr(value) {
  	    return escapeHtml(value).replace(/`/g, "&#96;");
  	  }

  	  function nowIso() {
  	    return new Date().toISOString();
  	  }

  	  function unique(values) {
  	    const result = [];
  	    const seen = Object.create(null);
  	    arr(values).forEach(function (value) {
  	      const item = clean(value);
  	      const key = lower(item);
  	      if (!item || seen[key]) return;
  	      seen[key] = true;
  	      result.push(item);
  	    });
  	    return result;
  	  }

  	  function tokens(value) {
  	    if (Array.isArray(value)) {
  	      return unique(value.reduce(function (output, item) {
  	        return output.concat(tokens(item));
  	      }, []));
  	    }
  	    return unique(text(value).split(/[,;|]/));
  	  }

  	  function hasToken(value, wanted) {
  	    const normal = lower(wanted).replace(/\s+/g, "");
  	    return tokens(value).some(function (item) {
  	      return lower(item).replace(/\s+/g, "") === normal;
  	    });
  	  }

  	  function storageValue(previous, values) {
  	    const cleaned = unique(values);
  	    return Array.isArray(previous) ? cleaned : cleaned.join(",");
  	  }

  	  function unmanagedValues(previous, supported) {
  	    return tokens(previous).filter(function (item) {
  	      return !supported.some(function (option) {
  	        return lower(option).replace(/\s+/g, "") === lower(item).replace(/\s+/g, "");
  	      });
  	    });
  	  }

  	  function objectId(record) {
  	    return clean(record && (record.objectId || record.ObjectId || record.objectID));
  	  }

  	  function currentUserName() {
  	    const user = APP_DATA && APP_DATA.User ? APP_DATA.User : {};
  	    const details = userDetails(user);
  	    return clean(user.name) ||
  	      clean([details.first_name, details.last_name].filter(Boolean).join(" ")) ||
  	      clean(user.email) ||
  	      "FIFM User";
  	  }

  	  function blankCompanyAddress() {
  	    return {
  	      Line1: "",
  	      Line2: "",
  	      Suburb: "",
  	      City: "",
  	      Province: "",
  	      PostalCode: "",
  	      Country: "South Africa"
  	    };
  	  }

  	  function blankCompanyContact() {
  	    return {
  	      Name: "",
  	      Role: "",
  	      Email: "",
  	      Phone: "",
  	      AlternatePhone: ""
  	    };
  	  }

  	  function defaultLocationTypes() {
  	    const updatedAt = nowIso();
  	    return [
  	      { Name: "Farm", Color: "#3d64ff", Label: "Farm", Value: "farm", Source: "company-manifest", IsActive: true, TypeName: "Farm", UpdatedAt: updatedAt },
  	      { Name: "Field", Color: "#49d37d", Label: "Field", Value: "field", Source: "company-manifest", IsActive: true, TypeName: "Field", UpdatedAt: updatedAt },
  	      { Name: "Pivot", Color: "#7ee35f", Label: "Pivot", Value: "pivot", Source: "company-manifest", IsActive: true, TypeName: "Pivot", UpdatedAt: updatedAt },
  	      { Name: "Ring", Color: "#3a78c2", Label: "Ring", Value: "ring", Source: "company-manifest", IsActive: true, TypeName: "Ring", UpdatedAt: updatedAt },
  	      { Name: "Load Point", Color: "#4fd0e8", Label: "Load Point", Value: "load-point", Source: "company-manifest", IsActive: true, TypeName: "Load Point", UpdatedAt: updatedAt },
  	      { Name: "Fuel", Color: "#d8a21b", Label: "Fuel", Value: "fuel", Source: "company-manifest", IsActive: true, TypeName: "Fuel", UpdatedAt: updatedAt },
  	      { Name: "Water Tank", Color: "#3dfffc", Label: "Water Tank", Value: "water-tank", Source: "company-manifest", IsActive: true, TypeName: "Water Tank", CreatedAt: updatedAt, UpdatedAt: updatedAt }
  	    ];
  	  }

  	  function defaultCompanyManifest() {
  	    return {
  	      SchemaVersion: "FIF-COMPANY-DEBTOR-1.0",
  	      Meta: {
  	        CreatedAt: "",
  	        CreatedBy: "",
  	        UpdatedAt: "",
  	        UpdatedBy: ""
  	      },
  	      Profile: {
  	        RegisteredName: "",
  	        Company_Name: "",
  	        TradingName: "",
  	        Trading_As: "",
  	        CompanyId: "",
  	        RegistrationNumber: "",
  	        EntityType: "",
  	        Industry: "",
  	        TaxNumber: "",
  	        VATRegistered: false,
  	        VATNumber: "",
  	        Website: "",
  	        Status: "ACTIVE",
  	        PrimaryEmail: "",
  	        Email: "",
  	        Telephone: "",
  	        AlternateTelephone: ""
  	      },
  	      Contacts: {
  	        Primary: blankCompanyContact(),
  	        Billing: blankCompanyContact(),
  	        Technical: blankCompanyContact(),
  	        Emergency: blankCompanyContact()
  	      },
  	      Addresses: {
  	        Registered: blankCompanyAddress(),
  	        Physical: blankCompanyAddress(),
  	        Postal: blankCompanyAddress(),
  	        Billing: blankCompanyAddress()
  	      },
  	      Billing: {
  	        Account: {
  	          AccountNumber: "",
  	          CustomerNumber: "",
  	          Status: "ACTIVE",
  	          Currency: "ZAR",
  	          TaxRate: 15,
  	          PaymentTermsDays: 30,
  	          CreditLimit: 0,
  	          PurchaseOrderRequired: false,
  	          DefaultPurchaseOrder: "",
  	          InvoiceEmail: "",
  	          StatementEmail: "",
  	          Reference: "",
  	          Notes: ""
  	        },
  	        // Kept only so older Manifest readers do not break. This Manager does not edit them.
  	        Pricing: {
  	          Model: "",
  	          BaseMonthlyFee: 0,
  	          MinimumMonthlyFee: 0,
  	          DiscountPercent: 0,
  	          DiscountAmount: 0,
  	          Rates: {},
  	          Included: {},
  	          CustomLineItems: []
  	        },
  	        Payment: {
  	          Method: "",
  	          DebitOrderStatus: "NOT_APPLICABLE",
  	          AccountHolder: "",
  	          BankName: "",
  	          BranchCode: "",
  	          AccountNumber: "",
  	          AccountType: "",
  	          MandateReference: "",
  	          MandateDate: ""
  	        }
  	      },
  	      Compliance: {
  	        CompanyRegistrationVerified: false,
  	        VATVerified: false,
  	        BillingApproved: false,
  	        TermsAccepted: false,
  	        TermsAcceptedAt: "",
  	        TermsAcceptedBy: "",
  	        POPIAContactName: "",
  	        POPIAContactEmail: "",
  	        Notes: ""
  	      },
  	      // Existing records are preserved. New debtors start with empty operational collections.
  	      Suppliers: [],
  	      Applications: [],
  	      LocationTypes: [],
  	      PointLocations: [],
  	      ServiceProviders: [],
  	      Audit: []
  	    };
  	  }

  	  function firstMeaningfulAddress(address) {
  	    const candidate = merge(blankCompanyAddress(), address || {});
  	    return candidate;
  	  }

  	  function normalizeCompanyManifest(value) {
  	    const source = parseJsonLoose(value, {});
  	    const defaults = defaultCompanyManifest();
  	    const result = merge(defaults, source);

  	    ["Suppliers", "Applications", "LocationTypes", "PointLocations", "ServiceProviders", "Audit"].forEach(function (key) {
  	      result[key] = Array.isArray(source[key]) ? clone(source[key]) : clone(defaults[key]);
  	    });

  	    result.Profile = merge(defaults.Profile, isObject(source.Profile) ? source.Profile : {});
  	    result.Contacts = merge(defaults.Contacts, isObject(source.Contacts) ? source.Contacts : {});
  	    result.Addresses = merge(defaults.Addresses, isObject(source.Addresses) ? source.Addresses : {});
  	    result.Billing = merge(defaults.Billing, isObject(source.Billing) ? source.Billing : {});
  	    result.Compliance = merge(defaults.Compliance, isObject(source.Compliance) ? source.Compliance : {});
  	    result.Meta = merge(defaults.Meta, isObject(source.Meta) ? source.Meta : {});

  	    const legacyProfile = result.Profile;
  	    if (isObject(legacyProfile.Address)) {
  	      const registered = result.Addresses.Registered || {};
  	      const hasRegistered = [registered.Line1, registered.Line2, registered.Suburb, registered.City, registered.Province, registered.PostalCode].some(Boolean);
  	      if (!hasRegistered) {
  	        result.Addresses.Registered = firstMeaningfulAddress({
  	          Line1: legacyProfile.Address.Line1 || legacyProfile.Address.Street || "",
  	          Line2: legacyProfile.Address.Line2 || "",
  	          Suburb: legacyProfile.Address.Suburb || "",
  	          City: legacyProfile.Address.City || "",
  	          Province: legacyProfile.Address.Province || "",
  	          PostalCode: legacyProfile.Address.PostalCode || "",
  	          Country: legacyProfile.Address.Country || "South Africa"
  	        });
  	      }
  	    }

  	    const primary = result.Contacts.Primary;
  	    primary.Email = lower(primary.Email || legacyProfile.PrimaryEmail || legacyProfile.Email);
  	    primary.Phone = clean(primary.Phone || legacyProfile.Telephone);
  	    legacyProfile.PrimaryEmail = lower(legacyProfile.PrimaryEmail || legacyProfile.Email || primary.Email);
  	    legacyProfile.Email = legacyProfile.PrimaryEmail;
  	    legacyProfile.Telephone = clean(legacyProfile.Telephone || primary.Phone);

  	    result.Billing.Account = merge(defaults.Billing.Account, result.Billing.Account || {});
  	    result.Billing.Account.CreditLimit = Number(result.Billing.Account.CreditLimit || 0);
  	    result.Billing.Pricing = merge(defaults.Billing.Pricing, result.Billing.Pricing || {});
  	    result.Billing.Pricing.Rates = merge(defaults.Billing.Pricing.Rates || {}, result.Billing.Pricing.Rates || {});
  	    result.Billing.Pricing.Included = merge(defaults.Billing.Pricing.Included || {}, result.Billing.Pricing.Included || {});
  	    result.Billing.Pricing.CustomLineItems = Array.isArray(result.Billing.Pricing.CustomLineItems) ? result.Billing.Pricing.CustomLineItems : [];
  	    result.Billing.Payment = merge(defaults.Billing.Payment, result.Billing.Payment || {});
  	    return result;
  	  }

  	  function companyName(company) {
  	    const manifest = companyManifest(company);
  	    const profile = isObject(manifest.Profile) ? manifest.Profile : {};
  	    return clean(company && company.Name) ||
  	      clean(company && company.CompanyName) ||
  	      clean(profile.RegisteredName) ||
  	      clean(profile.Company_Name) ||
  	      clean(profile.TradingName) ||
  	      clean(profile.Trading_As) ||
  	      clean(company && company.CompanyId) ||
  	      objectId(company) ||
  	      "Company";
  	  }

  	  function companyBusinessId(company) {
  	    const profile = companyProfile(company);
  	    return clean(company && (company.CompanyId || company.ID || company.Company_ID)) || clean(profile.CompanyId);
  	  }

  	  function companyIsActive(company) {
  	    const raw = company && company.Status;
  	    if (typeof raw === "boolean") return raw;
  	    const profile = companyProfile(company);
  	    const value = clean(raw !== undefined && raw !== null ? raw : profile.Status).toUpperCase();
  	    return !(value === "FALSE" || value === "0" || value === "INACTIVE" || value === "SUSPENDED" || value === "DISABLED");
  	  }

  	  function companyStatus(company) {
  	    return companyIsActive(company) ? "ACTIVE" : "INACTIVE";
  	  }

  	  const COMPANY_OBJECT_ID_MAX_LENGTH = 36;

  	  function companyObjectIdPart(value) {
  	    let part = clean(value);
  	    if (part && typeof part.normalize === "function") part = part.normalize("NFKD");
  	    return part
  	      .replace(/[\u0300-\u036f]/g, "")
  	      .replace(/\b(?:proprietary|pty|limited|ltd|close\s+corporation|cc|incorporated|inc|llc)\b/gi, "")
  	      .replace(/&/g, " and ")
  	      .replace(/[^A-Za-z0-9]+/g, "-")
  	      .replace(/-+/g, "-")
  	      .replace(/^-+|-+$/g, "");
  	  }

  	  function companyObjectIdHash(value) {
  	    let hash = 2166136261;
  	    const source = text(value);
  	    for (let index = 0; index < source.length; index += 1) {
  	      hash ^= source.charCodeAt(index);
  	      hash = Math.imul(hash, 16777619);
  	    }
  	    return (hash >>> 0).toString(36).padStart(6, "0").slice(-6);
  	  }

  	  function companyObjectIdFromNames(registeredName, tradingName) {
  	    const registered = companyObjectIdPart(registeredName) || "Company";
  	    const trading = companyObjectIdPart(tradingName) || "Trading";
  	    const readable = registered + "-" + trading;

  	    if (readable.length <= COMPANY_OBJECT_ID_MAX_LENGTH) return readable;

  	    const suffix = "-" + companyObjectIdHash(registered + "|" + trading);
  	    const bodyBudget = COMPANY_OBJECT_ID_MAX_LENGTH - suffix.length;
  	    const separatorBudget = 1;
  	    const availableForNames = bodyBudget - separatorBudget;
  	    const registeredBudget = Math.ceil(availableForNames / 2);
  	    const tradingBudget = Math.floor(availableForNames / 2);
  	    const registeredSplice = registered.slice(0, registeredBudget).replace(/-+$/g, "") || "Company";
  	    const tradingSplice = trading.slice(0, tradingBudget).replace(/-+$/g, "") || "Trading";

  	    return (registeredSplice + "-" + tradingSplice + suffix).slice(0, COMPANY_OBJECT_ID_MAX_LENGTH);
  	  }

  	  function companyManifest(company) {
  	    return normalizeCompanyManifest(company && company.Manifest);
  	  }

  	  function companyProfile(company) {
  	    const manifest = companyManifest(company);
  	    return isObject(manifest.Profile) ? manifest.Profile : {};
  	  }

  	  function companyBilling(company) {
  	    const manifest = companyManifest(company);
  	    return isObject(manifest.Billing) ? manifest.Billing : defaultCompanyManifest().Billing;
  	  }

  	  function companyAddresses(company) {
  	    const manifest = companyManifest(company);
  	    return isObject(manifest.Addresses) ? manifest.Addresses : defaultCompanyManifest().Addresses;
  	  }

  	  function companyContacts(company) {
  	    const manifest = companyManifest(company);
  	    return isObject(manifest.Contacts) ? manifest.Contacts : defaultCompanyManifest().Contacts;
  	  }

  	  function defaultEmployeeDetails() {
  	    return {
  	      audit: [],
  	      account_type: "",
  	      operational_roles: [],
  	      access_control: {},
  	      gender: "",
  	      address: {
  	        city: "",
  	        street: "",
  	        suburb: "",
  	        province: "",
  	        postal_code: ""
  	      },
  	      passport: {
  	        issue_date: "",
  	        expiry_date: "",
  	        passport_number: "",
  	        country_of_issue: ""
  	      },
  	      id_number: "",
  	      last_name: "",
  	      first_name: "",
  	      tax_number: "",
  	      employee_id: "",
  	      nationality: "",
  	      next_of_kin: {
  	        email: "",
  	        address: {
  	          city: "",
  	          street: "",
  	          suburb: "",
  	          province: "",
  	          postal_code: ""
  	        },
  	        last_name: "",
  	        first_name: "",
  	        phone_number: "",
  	        relationship: ""
  	      },
  	      date_of_birth: "",
  	      marital_status: "",
  	      contact_details: {
  	        email: "",
  	        phone_number: ""
  	      },
  	      drivers_license: {
  	        pdp: {
  	          category: [],
  	          categories: [],
  	          pdp_number: "",
  	          expiry_date: "",
  	          prdp_number: ""
  	        },
  	        prdp: {
  	          category: [],
  	          categories: [],
  	          pdp_number: "",
  	          expiry_date: "",
  	          prdp_number: ""
  	        },
  	        enabled: false,
  	        permits: [],
  	        training: [],
  	        issue_date: "",
  	        expiry_date: "",
  	        endorsements: [],
  	        licence_code: "",
  	        license_code: "",
  	        licence_codes: [],
  	        license_codes: [],
  	        licence_number: "",
  	        license_number: "",
  	        available_license_codes: ["A1", "A", "B", "C1", "C", "EB", "EC1", "EC"]
  	      },
  	      emergency_contacts: [
  	        {
  	          email: "",
  	          last_name: "",
  	          first_name: "",
  	          phone_number: "",
  	          relationship: "",
  	          alternate_phone_number: ""
  	        }
  	      ],
  	      employment_details: {
  	        status: "Active",
  	        job_title: "",
  	        department: "",
  	        start_date: "",
  	        bank_details: {
  	          bank_name: "",
  	          branch_code: "",
  	          account_number: ""
  	        },
  	        pay_frequency: "Monthly",
  	        employment_type: "Permanent",
  	        work_hours_per_week: "",
  	        employment_start_date: ""
  	      }
  	    };
  	  }

  	  function defaultWages() {
  	    return {
  	      wage_rates: {
  	        deductions: {
  	          income_tax: { amount: 0, tax_bracket: "Specify tax bracket" },
  	          union_fees: { amount: 0, conditions: "Applicable to employees in unions" },
  	          medical_aid: {
  	            amount: 0,
  	            scheme_name: "",
  	            scheme_option: "",
  	            employee_contribution: 0,
  	            employer_contribution: 0
  	          },
  	          garnishments: { amount: 0, reason: "Reason for garnishment" },
  	          pension_fund: { amount: 0, conditions: "Percentage of gross salary", percentage: 0 },
  	          life_insurance: { amount: 0, provider: "", conditions: "Optional employee benefit" },
  	          loan_repayment: {
  	            amount: 0,
  	            conditions: "Company-issued or third-party loan deduction",
  	            loan_provider: ""
  	          },
  	          provident_fund: { amount: 0, conditions: "Optional employee contribution", percentage: 0 },
  	          other_deductions: [
  	            { amount: 0, deduction_type: "Example: Additional voluntary contributions" }
  	          ],
  	          retirement_annuity_fund: { amount: 0, conditions: "Optional employee contribution", percentage: 0 },
  	          skills_development_levy: { amount: 0, conditions: "Applicable to certain payroll structures", percentage: 0 },
  	          unemployment_insurance_fund: { amount: 0, conditions: "Percentage of salary", percentage: 0 }
  	        },
  	        employee_id: "",
  	        other_earnings: {
  	          bonus: { amount: 0, bonus_type: "Performance / Holiday / Project" },
  	          allowances: [
  	            { amount: 0, allowance_type: "Travel" },
  	            { amount: 0, allowance_type: "Housing" },
  	            { amount: 0, allowance_type: "Meal" },
  	            { amount: 0, allowance_type: "Cellphone" }
  	          ]
  	        },
  	        pay_components: {
  	          overtime: { conditions: "Earned when employee works overtime hours", rate_per_hour: 0, hours_threshold: 0 },
  	          commission: { conditions: "Percentage of total revenue or profit generated", commission_percentage: 0 },
  	          per_km_pay: {
  	            rate_per_km: 0,
  	            threshold_km: 8000,
  	            bonus_rate_per_km: 0,
  	            bonus_threshold_km: 8000,
  	            max_bonus_per_month: 0
  	          },
  	          base_salary: { amount: 0, pay_frequency: "Monthly / Weekly / Bi-weekly" },
  	          per_unit_pay: {
  	            rate_per_unit: 0,
  	            threshold_unit: 100,
  	            bonus_rate_per_unit: 0,
  	            max_bonus_per_month: 0,
  	            bonus_threshold_units: 100
  	          },
  	          shift_allowance: { conditions: "Additional earnings per shift worked", rate_per_shift: 0 },
  	          standby_allowance: { conditions: "Paid when employee is on standby duty", rate_per_standby: 0 },
  	          unit_target_bonus: { bonus_amount: 0, threshold_units: 100, bonus_conditions: "Driver must complete 100 units" },
  	          good_driving_bonus: { rate_per_km: 0, bonus_conditions: "Must have no incidents or accidents in the month" },
  	          sleep_out_allowance: {
  	            conditions: "Driver must sleep out at a location on the road",
  	            rate_per_night: 0,
  	            max_allowance_per_month: 0
  	          },
  	          mileage_target_bonus: { bonus_amount: 0, threshold_km: 8000, bonus_conditions: "Driver must complete 8000 km" },
  	          load_planner_profitability_bonus: {
  	            bonus_amount: 0,
  	            target_profit: 0,
  	            bonus_conditions: "Load planners earn bonus if profitability target is met"
  	          }
  	        }
  	      }
  	    };
  	  }

  	  function userDataDetails(user) {
  	    return parseJsonLoose(user && user.Data_Details, { employee_details: defaultEmployeeDetails() });
  	  }

  	  function userDetails(user) {
  	    const wrapper = userDataDetails(user);
  	    return merge(defaultEmployeeDetails(), wrapper.employee_details || {});
  	  }

  	  function userOperationalRoles(user) {
  	    const details = userDetails(user);
  	    const stored = arr(details.operational_roles);
  	    const legacy = tokens(user && user.Role).filter(function (role) {
  	      return OPTIONS.OperationalRole.some(function (option) {
  	        return lower(option) === lower(role);
  	      });
  	    });
  	    return unique(stored.concat(legacy)).filter(function (role) {
  	      return OPTIONS.OperationalRole.some(function (option) {
  	        return lower(option) === lower(role);
  	      });
  	    });
  	  }

  	  function accountType(user) {
  	    if (hasToken(user && user.Role, "Director")) return "Director";
  	    const details = userDetails(user);
  	    return clean(details.account_type) || "Employee";
  	  }

  	  function userName(user) {
  	    const details = userDetails(user);
  	    return clean([details.first_name, details.last_name].filter(Boolean).join(" ")) ||
  	      clean(user && user.name) ||
  	      clean(user && user.email) ||
  	      objectId(user) ||
  	      "User";
  	  }

  	  function normalizeCompany(company) {
  	    const result = clone(company || {});
  	    result.Name = companyName(result);
  	    result.CompanyId = companyBusinessId(result);
  	    result.Status = companyIsActive(result);
  	    result.Manifest = normalizeCompanyManifest(result.Manifest);
  	    result.Manifest.Profile.Status = result.Status ? "ACTIVE" : "INACTIVE";
  	    if (Array.isArray(company && company.Employees)) result.Employees = clone(company.Employees);
  	    if (Array.isArray(company && company.Contractors)) result.Contractors = clone(company.Contractors);
  	    if (Array.isArray(company && company.Tractors)) result.Tractors = clone(company.Tractors).map(normalizeTractor);
  	    if (Array.isArray(company && company.Trailers)) result.Trailers = clone(company.Trailers).map(normalizeTrailer);
  	    if (Array.isArray(company && company.Tanks)) result.Tanks = clone(company.Tanks).map(normalizeTank);
  	    if (Array.isArray(company && company.Locations)) result.Locations = clone(company.Locations);
  	    return result;
  	  }

  	  function normalizeUser(user) {
  	    const result = clone(user || {});
  	    const wrapper = userDataDetails(result);
  	    const details = merge(defaultEmployeeDetails(), wrapper.employee_details || {});
  	    details.contact_details = merge(defaultEmployeeDetails().contact_details, details.contact_details || {});
  	    details.contact_details.email = lower(result.email || details.contact_details.email);
  	    details.id_number = clean(details.id_number || result.ID || result.objectId).replace(/\D/g, "");
  	    result.email = details.contact_details.email;
  	    result.name = clean(result.name) || clean([details.first_name, details.last_name].filter(Boolean).join(" ")) || result.email;
  	    result.Data_Details = merge(isObject(wrapper) ? wrapper : {}, { employee_details: details });
  	    result.Data_Wages = parseJsonLoose(result.Data_Wages, defaultWages());
  	    result.userStatus = clean(result.userStatus).toUpperCase() === "DISABLED" ? "DISABLED" : "ENABLED";
  	    result.Companies = arr(user && user.Companies).map(normalizeCompany);
  	    return result;
  	  }


  	  function normalizeTractor(tractor) {
  	    const result = clone(tractor || {});
  	    result.objectId = clean(result.objectId || result.Registration);
  	    result.Registration = clean(result.Registration || result.objectId);
  	    result.Tracker = clean(result.Tracker);
  	    result.Mileage = Number(result.Mileage || 0);
  	    result.Range = Number(result.Range || DEFAULT_TRACTOR_RANGE);
  	    result.color = clean(result.color) || DEFAULT_TRACTOR_COLOR;
  	    result.Data = parseJsonLoose(result.Data, {});
  	    result.CAN = parseJsonLoose(result.CAN, {});
  	    return result;
  	  }

  	  function normalizeTrailer(trailer) {
  	    const result = clone(trailer || {});
  	    result.objectId = clean(result.objectId || result.Registration || result.ID);
  	    result.Registration = clean(result.Registration || result.ID || result.objectId);
  	    result.ID = clean(result.ID || result.Registration);
  	    result.Tracker = clean(result.Tracker);
  	    result.Mileage = Number(result.Mileage || 0);
  	    result.Application = clean(result.Application);
  	    result.EYEID = clean(result.EYEID);
  	    result.Type = clean(result.Type || "Trailer");
  	    result.AssetClass = clean(result.AssetClass || "Trailer");
  	    result.Status = clean(result.Status || "Active");
  	    result.color = clean(result.color) || DEFAULT_TRACTOR_COLOR;
  	    result.Data = parseJsonLoose(result.Data, {});
  	    result.CAN = parseJsonLoose(result.CAN, {});
  	    return result;
  	  }

  	  function normalizeBowser(bowser) {
  	    const result = clone(bowser || {});
  	    result.objectId = objectId(result);
  	    result.Name = clean(result.Name || result.ID || result.objectId || "Bowser");
  	    result.Meter = Number(result.Meter || 0);
  	    result.Grade = clean(result.Grade);
  	    return result;
  	  }

  	  function normalizeTank(tank) {
  	    const result = clone(tank || {});
  	    result.objectId = objectId(result);
  	    result.Name = clean(result.Name || result.DeviceId || result.objectId || "Tank");
  	    result.DeviceId = clean(result.DeviceId);
  	    result.Grade = clean(result.Grade);
  	    result.Capacity = Number(result.Capacity || 0);
  	    result.Volume = Number(result.Volume || 0);
  	    result.Level = Number(result.Level || (result.Capacity > 0 ? (result.Volume / result.Capacity) * 100 : 0));
  	    result.Color = clean(result.Color || "#4caf50");
  	    result.Trailer = result.Trailer === true || lower(result.Trailer) === "true" || lower(result.Trailer) === "yes" || clean(result.Trailer) === "1";
  	    result.Bowsers = arr(result.Bowsers).map(normalizeBowser);
  	    if (result.Location && typeof result.Location === "object") result.Location = clone(result.Location);
  	    return result;
  	  }

  	  function trailerLabel(trailer) {
  	    return clean(trailer && (trailer.Registration || trailer.ID || trailer.objectId)) || "Trailer";
  	  }

  	  function tankLabel(tank) {
  	    return clean(tank && (tank.Name || tank.DeviceId || tank.objectId)) || "Tank";
  	  }

  	  function tractorRegistration(tractor) {
  	    return clean(tractor && (tractor.Registration || tractor.objectId));
  	  }

  	  function tractorTrackerDetails(tractor) {
  	    const data = parseJsonLoose(tractor && tractor.Data, {});
  	    const provisioning = data && data.Telematics && data.Telematics.Provisioning;
  	    return isObject(provisioning) ? provisioning : {};
  	  }

  	  function trailerTrackerDetails(trailer) {
  	    const data = parseJsonLoose(trailer && trailer.Data, {});
  	    const provisioning = data && data.Telematics && data.Telematics.Provisioning;
  	    return isObject(provisioning) ? provisioning : {};
  	  }

  	  function isTrackedTractor(tractor) {
  	    return !!clean(tractor && tractor.Tracker);
  	  }

  	  function isNonTrackedTractor(tractor) {
  	    return !isTrackedTractor(tractor);
  	  }

  	  function isTrackedTrailer(trailer) {
  	    return !!clean(trailer && trailer.Tracker);
  	  }

  	  function isBeaconTrailer(trailer) {
  	    return !isTrackedTrailer(trailer) && !!clean(trailer && trailer.EYEID);
  	  }

  	  function isNormalTrailer(trailer) {
  	    return !isTrackedTrailer(trailer) && !clean(trailer && trailer.EYEID);
  	  }

  	  function companyForTractor(tractor) {
  	    const tractorId = objectId(tractor);
  	    const relationMatch = state.companies.find(function (company) {
  	      return companyAssets(company).some(function (row) { return objectId(row) === tractorId; });
  	    });
  	    if (relationMatch) return relationMatch;
  	    const owner = clean(tractor && tractor.ownerId);
  	    return state.companies.find(function (company) {
  	      return owner && clean(company && company.ownerId) === owner;
  	    }) || null;
  	  }

  	  function companyForTrailer(trailer) {
  	    const trailerId = objectId(trailer);
  	    const relationMatch = state.companies.find(function (company) {
  	      return companyTrailers(company).some(function (row) { return objectId(row) === trailerId; });
  	    });
  	    if (relationMatch) return relationMatch;
  	    const owner = clean(trailer && trailer.ownerId);
  	    return state.companies.find(function (company) {
  	      return owner && clean(company && company.ownerId) === owner;
  	    }) || null;
  	  }

  	  function removeTractorFromCompanyAliases(tractorId) {
  	    state.companies.forEach(function (company) {
  	      if (Array.isArray(company.Tractors)) company.Tractors = company.Tractors.filter(function (row) { return objectId(row) !== tractorId; });
  	    });
  	    arr(APP_DATA && APP_DATA.Companies).forEach(function (company) {
  	      if (Array.isArray(company.Tractors)) company.Tractors = company.Tractors.filter(function (row) { return objectId(row) !== tractorId; });
  	    });
  	    arr(APP_DATA && APP_DATA.User && APP_DATA.User.Companies).forEach(function (company) {
  	      if (Array.isArray(company.Tractors)) company.Tractors = company.Tractors.filter(function (row) { return objectId(row) !== tractorId; });
  	    });
  	  }

  	  function removeTractorFromState(tractorId) {
  	    state.tractors = state.tractors.filter(function (row) { return objectId(row) !== tractorId; });
  	    if (Array.isArray(APP_DATA.Tractors)) APP_DATA.Tractors = APP_DATA.Tractors.filter(function (row) { return objectId(row) !== tractorId; });
  	    removeTractorFromCompanyAliases(tractorId);
  	  }

  	  function removeTrailerFromCompanyAliases(trailerId) {
  	    state.companies.forEach(function (company) {
  	      if (Array.isArray(company.Trailers)) company.Trailers = company.Trailers.filter(function (row) { return objectId(row) !== trailerId; });
  	    });
  	    arr(APP_DATA && APP_DATA.Companies).forEach(function (company) {
  	      if (Array.isArray(company.Trailers)) company.Trailers = company.Trailers.filter(function (row) { return objectId(row) !== trailerId; });
  	    });
  	    arr(APP_DATA && APP_DATA.User && APP_DATA.User.Companies).forEach(function (company) {
  	      if (Array.isArray(company.Trailers)) company.Trailers = company.Trailers.filter(function (row) { return objectId(row) !== trailerId; });
  	    });
  	  }

  	  function removeTrailerFromState(trailerId) {
  	    state.trailers = state.trailers.filter(function (row) { return objectId(row) !== trailerId; });
  	    if (Array.isArray(APP_DATA.Trailers)) APP_DATA.Trailers = APP_DATA.Trailers.filter(function (row) { return objectId(row) !== trailerId; });
  	    removeTrailerFromCompanyAliases(trailerId);
  	  }

  	  function addTractorToCompanyAliases(tractor, companyId) {
  	    findCompanyEverywhere(companyId).forEach(function (company) {
  	      if (!Array.isArray(company.Tractors)) company.Tractors = [];
  	      company.Tractors = upsertById(company.Tractors, tractor, normalizeTractor);
  	    });
  	  }

  	  function addTrailerToCompanyAliases(trailer, companyId) {
  	    findCompanyEverywhere(companyId).forEach(function (company) {
  	      if (!Array.isArray(company.Trailers)) company.Trailers = [];
  	      company.Trailers = upsertById(company.Trailers, trailer, normalizeTrailer);
  	    });
  	  }

  	  function reconcileTractor(saved, company, view) {
  	    const normalized = normalizeTractor(saved);
  	    if (view) {
  	      normalized.ViewC = clone(view);
  	      normalized.ViewH = [clone(view)];
  	    }
  	    state.tractors = upsertById(state.tractors, normalized, normalizeTractor);
  	    if (!Array.isArray(APP_DATA.Tractors)) APP_DATA.Tractors = [];
  	    APP_DATA.Tractors = upsertById(APP_DATA.Tractors, normalized, normalizeTractor);
  	    if (company) addTractorToCompanyAliases(normalized, objectId(company));
  	    return normalized;
  	  }

  	  function reconcileTrailer(saved, company) {
  	    const normalized = normalizeTrailer(saved);
  	    state.trailers = upsertById(state.trailers, normalized, normalizeTrailer);
  	    if (!Array.isArray(APP_DATA.Trailers)) APP_DATA.Trailers = [];
  	    APP_DATA.Trailers = upsertById(APP_DATA.Trailers, normalized, normalizeTrailer);
  	    if (company) addTrailerToCompanyAliases(normalized, objectId(company));
  	    return normalized;
  	  }

  	  function tractorById(id) {
  	    return state.tractors.find(function (tractor) { return objectId(tractor) === clean(id); }) || null;
  	  }

  	  function trailerById(id) {
  	    return state.trailers.find(function (trailer) { return objectId(trailer) === clean(id); }) || null;
  	  }

  	  function normalizeRegistration(value) {
  	    return clean(value).toUpperCase().replace(/\s+/g, " ");
  	  }

  	  function normalizeImei(value) {
  	    return clean(value).replace(/\D/g, "");
  	  }

  	  function tractorReadingUnit(tractor) {
  	    const data = parseJsonLoose(tractor && tractor.Data, {});
  	    const usage = isObject(data && data.Vehicle && data.Vehicle.Usage)
  	      ? data.Vehicle.Usage
  	      : {};
  	    const candidates = [
  	      tractor && tractor.CounterType,
  	      usage.CounterType,
  	      data && data.Vehicle && data.Vehicle.CounterType
  	    ];

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      let value = candidates[index];
  	      if (isObject(value) && Object.prototype.hasOwnProperty.call(value, "value")) value = value.value;
  	      const normalized = lower(value).replace(/[^a-z0-9]/g, "");
  	      if (!normalized) continue;
  	      if (normalized === "h" || normalized === "hr" || normalized === "hrs" || normalized.indexOf("hour") !== -1 || normalized.indexOf("hobbs") !== -1 || normalized === "time") return "h";
  	      if (normalized === "km" || normalized.indexOf("kilomet") !== -1 || normalized.indexOf("distance") !== -1 || normalized.indexOf("odometer") !== -1) return "km";
  	    }

  	    return "km";
  	  }

  	  function tractorCurrentReading(tractor) {
  	    const data = parseJsonLoose(tractor && tractor.Data, {});
  	    const usage = isObject(data && data.Vehicle && data.Vehicle.Usage)
  	      ? data.Vehicle.Usage
  	      : {};
  	    let current = usage.CurrentReading;
  	    if (isObject(current) && Object.prototype.hasOwnProperty.call(current, "value")) current = current.value;
  	    const canonical = Number(current);
  	    if (Number.isFinite(canonical) && canonical >= 0) return canonical;
  	    const legacy = Number(tractor && tractor.Mileage);
  	    return Number.isFinite(legacy) && legacy >= 0 ? legacy : 0;
  	  }

  	  function setTractorCanonicalReading(data, reading, unit) {
  	    const output = isObject(data) ? data : {};
  	    if (!isObject(output.Vehicle)) output.Vehicle = {};
  	    if (!isObject(output.Vehicle.Usage)) output.Vehicle.Usage = {};

  	    const usage = output.Vehicle.Usage;
  	    const unitType = unit === "h" ? "Time" : "Distance";
  	    const current = usage.CurrentReading;

  	    if (isObject(current)) {
  	      current.value = reading;
  	      if (!Object.prototype.hasOwnProperty.call(current, "editable")) current.editable = false;
  	      if (!Object.prototype.hasOwnProperty.call(current, "selector")) current.selector = "number";
  	      current.unitType = unitType;
  	    } else {
  	      usage.CurrentReading = {
  	        value: reading,
  	        editable: false,
  	        selector: "number",
  	        unitType: unitType
  	      };
  	    }

  	    return output;
  	  }

  	  function tractorReadingSummary(tractor) {
  	    const unit = tractorReadingUnit(tractor);
  	    const reading = tractorCurrentReading(tractor);
  	    return (unit === "h" ? "Hours " : "Mileage ") + String(reading);
  	  }

  	  async function loadCurrentTractorViewForMileage(tractor) {
  	    const tractorId = objectId(tractor);
  	    if (!tractorId) return null;

  	    try {
  	      const rows = await loadRelation(TABLES.TRACTORS, tractorId, RELATIONS.TRACTOR_VIEW_CURRENT);
  	      if (rows.length) return rows[0];
  	    } catch (error) {
  	      console.warn("FIF Customer & Asset Manager: current Tractor ViewC relation could not be loaded for mileage edit.", error);
  	    }

  	    const embedded = tractor && tractor.ViewC;
  	    const embeddedId = objectId(embedded);
  	    if (embeddedId) {
  	      try {
  	        return (await findById(TABLES.TRACTOR_VIEW, embeddedId)) || embedded;
  	      } catch (_) {
  	        return embedded;
  	      }
  	    }

  	    return null;
  	  }

  	  async function updateTractorMileage(tractorId, newReading) {
  	    const id = clean(tractorId);
  	    const requested = Number(newReading);
  	    if (!id) throw new Error("The Tractor does not have an objectId.");
  	    if (!Number.isFinite(requested) || requested < 0) throw new Error("Mileage / hours must be zero or greater.");

  	    const liveTractor = tractorById(id);
  	    if (!liveTractor) throw new Error("The selected Tractor is unavailable.");

  	    const freshRow = await findById(TABLES.TRACTORS, id);
  	    const workingTractor = normalizeTractor(merge(clone(liveTractor), freshRow || {}));
  	    const currentView = await loadCurrentTractorViewForMileage(workingTractor);
  	    const viewId = objectId(currentView);

  	    if (!currentView || !viewId) {
  	      throw new Error("The Tractor current ViewC could not be loaded. The odometer was not changed.");
  	    }

  	    const unit = tractorReadingUnit(workingTractor);
  	    const oldReading = tractorCurrentReading(workingTractor);
  	    const oldMeterEnd = currentView.MeterEnd === undefined ? oldReading : currentView.MeterEnd;
  	    const data = setTractorCanonicalReading(parseJsonLoose(workingTractor.Data, {}), requested, unit);

  	    updateOperation("Updating current ViewC...");
  	    const savedViewPatch = await saveRecord(TABLES.TRACTOR_VIEW, {
  	      objectId: viewId,
  	      MeterEnd: requested
  	    });

  	    let savedTractor;
  	    try {
  	      updateOperation("Updating vehicle odometer...");
  	      savedTractor = await saveRecord(TABLES.TRACTORS, {
  	        objectId: id,
  	        Mileage: requested,
  	        Data: data
  	      });
  	    } catch (error) {
  	      try {
  	        await saveRecord(TABLES.TRACTOR_VIEW, {
  	          objectId: viewId,
  	          MeterEnd: oldMeterEnd
  	        });
  	      } catch (rollbackError) {
  	        console.error("FIF Customer & Asset Manager: ViewC mileage rollback failed.", rollbackError);
  	      }
  	      throw error;
  	    }

  	    const merged = merge(clone(liveTractor), savedTractor || {});
  	    merged.Mileage = requested;
  	    merged.Data = data;
  	    merged.ViewC = merge(clone(currentView), savedViewPatch || {});
  	    merged.ViewC.MeterEnd = requested;

  	    if (Array.isArray(merged.ViewH)) {
  	      merged.ViewH = merged.ViewH.map(function (view) {
  	        if (objectId(view) !== viewId) return view;
  	        const updated = merge(clone(view), merged.ViewC);
  	        updated.MeterEnd = requested;
  	        return updated;
  	      });
  	    }

  	    const company = companyForTractor(liveTractor);
  	    return reconcileTractor(merged, company);
  	  }

  	  function southAfricanMonthWindow(value) {
  	    const date = value instanceof Date ? new Date(value.getTime()) : new Date(value || Date.now());
  	    const safeDate = isNaN(date.getTime()) ? new Date() : date;
  	    const offsetMs = 120 * 60000;
  	    const local = new Date(safeDate.getTime() + offsetMs);
  	    const year = local.getUTCFullYear();
  	    const monthIndex = local.getUTCMonth();
  	    const month = String(monthIndex + 1).padStart(2, "0");
  	    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  	    return {
  	      DateStart: Date.UTC(year, monthIndex, 1, 0, 0, 0, 0) - offsetMs,
  	      DateEnd: Date.UTC(year, monthIndex + 1, 1, 0, 0, 0, 0) - offsetMs - 1,
  	      MYearKey: year + "-" + month,
  	      MYear: monthNames[monthIndex] + " " + year
  	    };
  	  }

  	  function buildInitialTractorView() {
  	    const period = southAfricanMonthWindow(new Date());
  	    return {
  	      Cost: 0,
  	      DateStart: period.DateStart,
  	      DateEnd: period.DateEnd,
  	      Distance: 0,
  	      Litres: 0,
  	      MeterEnd: 0,
  	      MeterStart: 0,
  	      MYearKey: period.MYearKey,
  	      PotentialSARSRebate: 0,
  	      TransactionCount: 0
  	    };
  	  }

  	  function setDataValue(root, path, value) {
  	    const parts = path.split(".");
  	    let cursor = root;
  	    for (let index = 0; index < parts.length - 1; index += 1) {
  	      if (!isObject(cursor[parts[index]])) cursor[parts[index]] = {};
  	      cursor = cursor[parts[index]];
  	    }
  	    const leaf = parts[parts.length - 1];
  	    if (isObject(cursor[leaf]) && Object.prototype.hasOwnProperty.call(cursor[leaf], "value")) {
  	      cursor[leaf].value = value;
  	    } else {
  	      cursor[leaf] = value;
  	    }
  	  }


  	  function buildCanonicalTractorData(registration, reading) {
  	    /*
  	     * Every newly-created Tractor starts from the approved blank canonical
  	     * Data JSON. Only facts already known in the creation form are written
  	     * into that new instance; all other Service / Vehicle / Compliance /
  	     * Maintenance / FuelAndEnergy values remain at the template defaults.
  	     */
  	    const data = clone(DEFAULT_TRACTOR_DATA_TEMPLATE);
  	    const currentReading = Number(reading || 0);

  	    setDataValue(data, "Vehicle.Identity.FID", registration);
  	    setDataValue(data, "Vehicle.Identity.Registration", registration);
  	    setDataValue(data, "Vehicle.Usage.CurrentReading", currentReading);

  	    return data;
  	  }

  	  function buildTrackedAssetData(assetClass, registration, mileage, trackerType, imei, flespiDeviceId) {
  	    if (assetClass === "Tractor") {
  	      return buildCanonicalTractorData(registration, mileage);
  	    }

  	    const data = clone(DEFAULT_TRAILER_DATA_TEMPLATE);
  	    const today = nowIso().slice(0, 10);
  	    setDataValue(data, "Audit.CreatedAt", today);
  	    setDataValue(data, "Audit.CreatedBy", currentUserName());
  	    if (data.Audit) {
  	      data.Audit.ChangeLog = [];
  	      data.Audit.ValidationIssues = [];
  	    }
  	    if (data.Tyres) data.Tyres.TyreRecords = [];
  	    setDataValue(data, "Vehicle.Registration", registration);
  	    setDataValue(data, "Vehicle.Identity.Registration", registration);
  	    setDataValue(data, "Safety.Security.TrackingDevice", true);
  	    setDataValue(data, "Telematics.Enabled", true);
  	    setDataValue(data, "Telematics.DeviceId", String(flespiDeviceId));
  	    setDataValue(data, "Telematics.Provider", "Flespi");
  	    setDataValue(data, "Telematics.CANEnabled", true);
  	    setDataValue(data, "Telematics.GPSEnabled", true);
  	    data.Telematics = isObject(data.Telematics) ? data.Telematics : {};
  	    data.Telematics.Provisioning = {
  	      Mode: "Tracked",
  	      AssetClass: assetClass,
  	      Provider: "Flespi",
  	      TrackerType: clean(trackerType),
  	      IMEI: clean(imei),
  	      FlespiDeviceId: String(flespiDeviceId),
  	      ProvisionedAt: nowIso(),
  	      ProvisionedBy: currentUserName()
  	    };
  	    data.Schema = isObject(data.Schema) ? data.Schema : {};
  	    data.Schema.Runtime = merge(isObject(data.Schema.Runtime) ? data.Schema.Runtime : {}, {
  	      AssetClass: assetClass,
  	      Registration: registration,
  	      MileageAtCreation: Number(mileage || 0),
  	      TrackerType: clean(trackerType),
  	      IMEI: clean(imei),
  	      FlespiDeviceId: String(flespiDeviceId)
  	    });
  	    return data;
  	  }

  	  function buildNonTrackedTractorData(registration, mileage) {
  	    return buildCanonicalTractorData(registration, mileage);
  	  }

  	  function buildDefaultTractorData(registration, mileage, trackerType, imei, flespiDeviceId) {
  	    return buildTrackedAssetData("Tractor", registration, mileage, trackerType, imei, flespiDeviceId);
  	  }

  	  function buildDefaultTrailerData(registration, mileage, trackerType, imei, flespiDeviceId) {
  	    return buildTrackedAssetData("Trailer", registration, mileage, trackerType, imei, flespiDeviceId);
  	  }

  	  function buildNormalTrailerData(registration, mileage) {
  	    const data = clone(DEFAULT_TRAILER_DATA_TEMPLATE);
  	    const today = nowIso().slice(0, 10);
  	    setDataValue(data, "Audit.CreatedAt", today);
  	    setDataValue(data, "Audit.CreatedBy", currentUserName());
  	    if (data.Audit) {
  	      data.Audit.ChangeLog = [];
  	      data.Audit.ValidationIssues = [];
  	    }
  	    if (data.Tyres) data.Tyres.TyreRecords = [];
  	    setDataValue(data, "Vehicle.Registration", registration);
  	    setDataValue(data, "Vehicle.Identity.Registration", registration);

  	    // A Beacon Trailer is a normal Trailer. Do not create or claim a Flespi device.
  	    setDataValue(data, "Telematics.DeviceId", "");
  	    setDataValue(data, "Telematics.Provider", "");
  	    setDataValue(data, "Telematics.CANEnabled", false);
  	    setDataValue(data, "Telematics.GPSEnabled", false);
  	    data.Telematics = isObject(data.Telematics) ? data.Telematics : {};
  	    data.Telematics.Provisioning = {
  	      Mode: "",
  	      Provider: "",
  	      TrackerType: "",
  	      IMEI: "",
  	      FlespiDeviceId: "",
  	      ProvisionedAt: "",
  	      ProvisionedBy: ""
  	    };
  	    data.Schema = isObject(data.Schema) ? data.Schema : {};
  	    data.Schema.Runtime = merge(isObject(data.Schema.Runtime) ? data.Schema.Runtime : {}, {
  	      AssetClass: "Trailer",
  	      Registration: registration,
  	      MileageAtCreation: Number(mileage || 0)
  	    });
  	    return data;
  	  }

  	  function buildDefaultTractorCan() {
  	    return clone(DEFAULT_TRACTOR_CAN_TEMPLATE);
  	  }

  	  async function invokeFlespiService(method, payload) {
  	    const api = ensureDatabase();
  	    try {
  	      if (api.APIServices && typeof api.APIServices.invoke === "function") {
  	        return await api.APIServices.invoke(FLESPI_SERVICE, method, payload || {});
  	      }
  	      if (api.CustomServices && typeof api.CustomServices.invoke === "function") {
  	        return await api.CustomServices.invoke(FLESPI_SERVICE, method, payload || {});
  	      }
  	      throw new Error("The secure " + FLESPI_SERVICE + " Backendless API Service is unavailable.");
  	    } catch (error) {
  	      const message = clean(error && (error.message || error.faultString || error.details));
  	      throw new Error("Flespi service call failed. " + (message || "The secure Flespi service could not be called."));
  	    }
  	  }


  	  async function invokeImpersonationService(payload) {
  	    const api = ensureDatabase();
  	    try {
  	      if (api.APIServices && typeof api.APIServices.invoke === "function") {
  	        return await api.APIServices.invoke(IMPERSONATION_SERVICE, IMPERSONATION_METHOD, payload || {});
  	      }
  	      if (api.CustomServices && typeof api.CustomServices.invoke === "function") {
  	        return await api.CustomServices.invoke(IMPERSONATION_SERVICE, IMPERSONATION_METHOD, payload || {});
  	      }
  	      throw new Error("The secure " + IMPERSONATION_SERVICE + " Backendless API Service is unavailable.");
  	    } catch (error) {
  	      const message = clean(error && (error.message || error.faultString || error.details));
  	      throw new Error(message || "The secure Login as User service could not be called.");
  	    }
  	  }

  	  function secureImpersonationNonce() {
  	    try {
  	      if (typeof crypto !== "undefined" && crypto && typeof crypto.getRandomValues === "function") {
  	        const bytes = new Uint8Array(18);
  	        crypto.getRandomValues(bytes);
  	        return Array.from(bytes).map(function (value) {
  	          return value.toString(16).padStart(2, "0");
  	        }).join("");
  	      }
  	    } catch (_) {}
  	    return Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  	  }

  	  function preferredUserApp(user) {
  	    const available = tokens(user && user.APP);
  	    const supported = ["Office", "Road", "Bowser"];
  	    for (let index = 0; index < supported.length; index += 1) {
  	      if (available.some(function (item) { return lower(item) === lower(supported[index]); })) {
  	        return supported[index];
  	      }
  	    }
  	    return "";
  	  }

  	  function loginPageUrl(nonce) {
  	    const url = new URL(window.location.href);
  	    url.searchParams.set("page", "Login");
  	    url.searchParams.set("fifmImpersonation", nonce);
  	    url.hash = "";
  	    return url.toString();
  	  }

  	  function waitForImpersonationMessage(targetWindow, nonce, acceptedTypes, timeoutMs) {
  	    return new Promise(function (resolve, reject) {
  	      let finished = false;
  	      const timeout = window.setTimeout(function () {
  	        finish();
  	        reject(new Error("The Login page did not respond to the secure FIFM hand-off."));
  	      }, timeoutMs || 15000);

  	      function finish() {
  	        if (finished) return;
  	        finished = true;
  	        window.clearTimeout(timeout);
  	        window.removeEventListener("message", onMessage);
  	      }

  	      function onMessage(event) {
  	        if (event.origin !== window.location.origin) return;
  	        if (event.source !== targetWindow) return;
  	        const data = event.data || {};
  	        if (clean(data.nonce) !== clean(nonce)) return;
  	        if (acceptedTypes.indexOf(clean(data.type)) === -1) return;
  	        finish();
  	        if (clean(data.type) === IMPERSONATION_ERROR_MESSAGE) {
  	          reject(new Error(clean(data.message) || "The target-user login failed."));
  	        } else {
  	          resolve(data);
  	        }
  	      }

  	      window.addEventListener("message", onMessage);
  	    });
  	  }

  	  function loginAsUserIcon(user) {
  	    const enabled = clean(user && user.userStatus).toUpperCase() !== "DISABLED";
  	    const label = "Login as " + userName(user);
  	    return '<button type="button" class="fif-login-user-button" data-action="login-as-user" data-id="' +
  	      escapeAttr(objectId(user)) + '" title="' + escapeAttr(enabled ? label : label + " (user disabled)") +
  	      '" aria-label="' + escapeAttr(label) + '"' + (enabled ? "" : " disabled") + '>' +
  	      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><path d="M10 17l5-5-5-5"></path><path d="M15 12H3"></path></svg></button>';
  	  }

  	  async function openLoginAsUser(user) {
  	    if (!user || !objectId(user)) throw new Error("The selected user is unavailable.");
  	    if (clean(user.userStatus).toUpperCase() === "DISABLED") {
  	      throw new Error(userName(user) + " is disabled and cannot be logged in.");
  	    }
  	    if (hasToken(user.APP, "FIFM")) {
  	      throw new Error("Login as User is limited to customer Directors and Employees, not another FIFM account.");
  	    }

  	    const nonce = secureImpersonationNonce();
  	    const popup = window.open(loginPageUrl(nonce), "_blank");

  	    if (!popup) {
  	      throw new Error("The browser blocked the Login as User tab. Allow pop-ups for Fleet In Form and try again.");
  	    }

  	    state.impersonationWindow = popup;
  	    beginOperation("Opening secure session for " + userName(user) + "...");

  	    try {
  	      const readyPromise = waitForImpersonationMessage(
  	        popup,
  	        nonce,
  	        [IMPERSONATION_READY_MESSAGE, IMPERSONATION_ERROR_MESSAGE],
  	        20000
  	      );

  	      const sessionPromise = invokeImpersonationService({
  	        targetUserId: objectId(user),
  	        nonce: nonce
  	      });

  	      const results = await Promise.all([readyPromise, sessionPromise]);
  	      const session = results[1] || {};
  	      const targetUserId = clean(session.objectId || session.userId);
  	      const userToken = clean(session.userToken || session["user-token"]);

  	      if (!targetUserId || !userToken) {
  	        throw new Error("The secure service did not return a complete target-user session.");
  	      }

  	      const completionPromise = waitForImpersonationMessage(
  	        popup,
  	        nonce,
  	        [IMPERSONATION_COMPLETE_MESSAGE, IMPERSONATION_ERROR_MESSAGE],
  	        25000
  	      );

  	      popup.postMessage({
  	        type: IMPERSONATION_PAYLOAD_MESSAGE,
  	        nonce: nonce,
  	        session: {
  	          objectId: targetUserId,
  	          userToken: userToken,
  	          identity: clean(session.identity || user.email || user.name),
  	          name: clean(session.name || userName(user)),
  	          APP: clean(session.APP || user.APP),
  	          launchApp: clean(session.launchApp || preferredUserApp(user))
  	        }
  	      }, window.location.origin);

  	      await completionPromise;
  	      showToast("Opened a separate session as " + userName(user) + ".", "success", 6500);
  	    } catch (error) {
  	      try {
  	        if (popup && !popup.closed) {
  	          popup.postMessage({
  	            type: IMPERSONATION_ERROR_MESSAGE,
  	            nonce: nonce,
  	            message: clean(error && error.message) || "Login as User failed."
  	          }, window.location.origin);
  	        }
  	      } catch (_) {}
  	      throw error;
  	    } finally {
  	      endOperation();
  	      state.impersonationWindow = null;
  	    }
  	  }

  	  async function loadTrackerTypes(force) {
  	    if (state.trackerTypesLoaded && !force) return state.trackerTypes;
  	    const response = await invokeFlespiService("getTrackerTypes", {});
  	    const rows = arr(response && (response.trackerTypes || response.result || response));
  	    state.trackerTypes = rows.map(function (row) {
  	      return {
  	        id: clean(row && (row.id || row.deviceTypeId || row.value)),
  	        name: clean(row && (row.name || row.label || row.deviceTypeName)),
  	        protocol: clean(row && (row.protocol_name || row.protocolName || row.protocol))
  	      };
  	    }).filter(function (row) {
  	      return row.id && row.name;
  	    }).sort(function (left, right) {
  	      return left.name.localeCompare(right.name, undefined, { sensitivity: "base", numeric: true });
  	    });
  	    state.trackerTypesLoaded = true;
  	    return state.trackerTypes;
  	  }

  	  async function findTrackerOwner(deviceId) {
  	    const value = escapeWhere(String(deviceId));
  	    const results = await Promise.all([
  	      findOne(TABLES.TRACTORS, "Tracker = '" + value + "'"),
  	      findOne(TABLES.TRAILERS, "Tracker = '" + value + "'")
  	    ]);
  	    if (results[0]) return { table: TABLES.TRACTORS, record: normalizeTractor(results[0]), label: tractorRegistration(results[0]) };
  	    if (results[1]) return { table: TABLES.TRAILERS, record: normalizeTrailer(results[1]), label: trailerLabel(results[1]) };
  	    return null;
  	  }

  	  async function createTrackedTractor(form) {
  	    const data = new FormData(form);
  	    const company = companyById(clean(data.get("CompanyId")));
  	    const registration = normalizeRegistration(data.get("Registration"));
  	    const mileage = formNumber(data, "Mileage", 0);
  	    const deviceTypeId = clean(data.get("TrackerTypeId"));
  	    const trackerType = clean(data.get("TrackerTypeName"));
  	    const imei = normalizeImei(data.get("IMEI"));

  	    if (!company || !clean(company.ownerId)) throw new Error("Select a Company with an ownerId.");
  	    if (!registration) throw new Error("Vehicle Registration is required.");
  	    if (!Number.isFinite(mileage) || mileage < 0) throw new Error("Mileage must be zero or greater.");
  	    if (!deviceTypeId) throw new Error("Select the tracker type.");
  	    if (!/^\d{15}$/.test(imei)) throw new Error("IMEI must contain exactly 15 digits.");
  	    if (await findById(TABLES.TRACTORS, registration)) throw new Error("A Tractor already exists with objectId " + registration + ".");
  	    if (await findOne(TABLES.TRACTORS, "Registration = '" + escapeWhere(registration) + "'")) throw new Error("A Tractor already exists with Registration " + registration + ".");

  	    let flespiDeviceId = "";
  	    let flespiDeviceCreated = false;
  	    let flespiDeviceReused = false;
  	    let savedTractor = null;
  	    let savedView = null;
  	    try {
  	      updateOperation("Provisioning Flespi device...");
  	      const provisioned = await invokeFlespiService("provisionTrackedDevice", {
  	        registration: registration,
  	        companyName: companyName(company),
  	        deviceTypeId: deviceTypeId,
  	        trackerType: trackerType,
  	        imei: imei,
  	        allowExactRecovery: true
  	      });
  	      flespiDeviceId = clean(provisioned && (provisioned.deviceId || provisioned.flespiDeviceId || provisioned.id));
  	      flespiDeviceCreated = Boolean(provisioned && provisioned.created === true);
  	      flespiDeviceReused = Boolean(provisioned && provisioned.reused === true);
  	      if (!flespiDeviceId) throw new Error("Flespi did not return a device ID.");
  	      const trackerOwner = await findTrackerOwner(flespiDeviceId);
  	      if (trackerOwner) throw new Error("Flespi device " + flespiDeviceId + " is already linked to " + trackerOwner.table + " " + trackerOwner.label + ".");

  	      updateOperation("Creating Backendless Tractor...");
  	      savedTractor = normalizeTractor(await upsertRecord(TABLES.TRACTORS, {
  	        objectId: registration,
  	        ownerId: clean(company.ownerId),
  	        Tracker: String(flespiDeviceId),
  	        Registration: registration,
  	        Range: DEFAULT_TRACTOR_RANGE,
  	        Mileage: mileage,
  	        Data: buildDefaultTractorData(registration, mileage, trackerType, imei, flespiDeviceId),
  	        color: DEFAULT_TRACTOR_COLOR,
  	        CAN: buildDefaultTractorCan()
  	      }));

  	      updateOperation("Creating Tractor period...");
  	      savedView = await saveRecord(TABLES.TRACTOR_VIEW, buildInitialTractorView());
  	      await setRelation(TABLES.TRACTORS, registration, RELATIONS.TRACTOR_VIEW_CURRENT, objectId(savedView));
  	      await addRelation(TABLES.TRACTORS, registration, RELATIONS.TRACTOR_VIEW_HISTORY, objectId(savedView));
  	      await addRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TRACTORS, registration);
  	      savedTractor.ViewC = savedView;
  	      savedTractor.ViewH = [savedView];
  	      return reconcileTractor(savedTractor, company, savedView);
  	    } catch (error) {
  	      updateOperation("Rolling back incomplete Tractor creation...");
  	      if (savedTractor) await removeRecord(TABLES.TRACTORS, registration);
  	      if (savedView) await removeRecord(TABLES.TRACTOR_VIEW, objectId(savedView));
  	      if (flespiDeviceCreated && !flespiDeviceReused && flespiDeviceId) {
  	        try { await invokeFlespiService("deleteProvisionedDevice", { deviceId: flespiDeviceId }); } catch (cleanupError) { console.warn("Could not remove new Flespi device.", cleanupError); }
  	      }
  	      throw error;
  	    }
  	  }

  	  async function createNonTrackedTractor(form) {
  	    const data = new FormData(form);
  	    const company = companyById(clean(data.get("CompanyId")));
  	    const registration = normalizeRegistration(data.get("Registration"));
  	    const mileage = formNumber(data, "Mileage", 0);
  	    if (!company || !clean(company.ownerId)) throw new Error("Select a Company with an ownerId.");
  	    if (!registration) throw new Error("Vehicle Registration is required.");
  	    if (!Number.isFinite(mileage) || mileage < 0) throw new Error("Mileage must be zero or greater.");
  	    if (await findById(TABLES.TRACTORS, registration)) throw new Error("A Tractor already exists with objectId " + registration + ".");
  	    if (await findOne(TABLES.TRACTORS, "Registration = '" + escapeWhere(registration) + "'")) throw new Error("A Tractor already exists with Registration " + registration + ".");

  	    let savedTractor = null;
  	    let savedView = null;
  	    try {
  	      updateOperation("Creating Backendless Tractor...");
  	      savedTractor = normalizeTractor(await upsertRecord(TABLES.TRACTORS, {
  	        objectId: registration,
  	        ownerId: clean(company.ownerId),
  	        Registration: registration,
  	        Range: DEFAULT_TRACTOR_RANGE,
  	        Mileage: mileage,
  	        Data: buildNonTrackedTractorData(registration, mileage),
  	        color: DEFAULT_TRACTOR_COLOR,
  	        CAN: buildDefaultTractorCan()
  	      }));
  	      updateOperation("Creating Tractor period...");
  	      savedView = await saveRecord(TABLES.TRACTOR_VIEW, buildInitialTractorView());
  	      await setRelation(TABLES.TRACTORS, registration, RELATIONS.TRACTOR_VIEW_CURRENT, objectId(savedView));
  	      await addRelation(TABLES.TRACTORS, registration, RELATIONS.TRACTOR_VIEW_HISTORY, objectId(savedView));
  	      await addRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TRACTORS, registration);
  	      savedTractor.ViewC = savedView;
  	      savedTractor.ViewH = [savedView];
  	      return reconcileTractor(savedTractor, company, savedView);
  	    } catch (error) {
  	      updateOperation("Rolling back incomplete Tractor creation...");
  	      if (savedTractor) await removeRecord(TABLES.TRACTORS, registration);
  	      if (savedView) await removeRecord(TABLES.TRACTOR_VIEW, objectId(savedView));
  	      throw error;
  	    }
  	  }

  	  async function createTrackedTrailer(form) {
  	    const data = new FormData(form);
  	    const company = companyById(clean(data.get("CompanyId")));
  	    const registration = normalizeRegistration(data.get("Registration"));
  	    const mileage = formNumber(data, "Mileage", 0);
  	    const deviceTypeId = clean(data.get("TrackerTypeId"));
  	    const trackerType = clean(data.get("TrackerTypeName"));
  	    const imei = normalizeImei(data.get("IMEI"));
  	    if (!company || !clean(company.ownerId)) throw new Error("Select a Company with an ownerId.");
  	    if (!registration) throw new Error("Trailer Registration is required.");
  	    if (!Number.isFinite(mileage) || mileage < 0) throw new Error("Mileage must be zero or greater.");
  	    if (!deviceTypeId) throw new Error("Select the tracker type.");
  	    if (!/^\d{15}$/.test(imei)) throw new Error("IMEI must contain exactly 15 digits.");
  	    if (await findById(TABLES.TRAILERS, registration)) throw new Error("A Trailer already exists with objectId " + registration + ".");
  	    if (await findOne(TABLES.TRAILERS, "Registration = '" + escapeWhere(registration) + "'")) throw new Error("A Trailer already exists with Registration " + registration + ".");

  	    let flespiDeviceId = "";
  	    let flespiDeviceCreated = false;
  	    let flespiDeviceReused = false;
  	    let savedTrailer = null;
  	    try {
  	      updateOperation("Provisioning Flespi device...");
  	      const provisioned = await invokeFlespiService("provisionTrackedDevice", {
  	        registration: registration,
  	        companyName: companyName(company),
  	        deviceTypeId: deviceTypeId,
  	        trackerType: trackerType,
  	        imei: imei,
  	        allowExactRecovery: true
  	      });
  	      flespiDeviceId = clean(provisioned && (provisioned.deviceId || provisioned.flespiDeviceId || provisioned.id));
  	      flespiDeviceCreated = Boolean(provisioned && provisioned.created === true);
  	      flespiDeviceReused = Boolean(provisioned && provisioned.reused === true);
  	      if (!flespiDeviceId) throw new Error("Flespi did not return a device ID.");
  	      const trackerOwner = await findTrackerOwner(flespiDeviceId);
  	      if (trackerOwner) throw new Error("Flespi device " + flespiDeviceId + " is already linked to " + trackerOwner.table + " " + trackerOwner.label + ".");

  	      updateOperation("Creating Backendless Trailer...");
  	      savedTrailer = normalizeTrailer(await upsertRecord(TABLES.TRAILERS, {
  	        objectId: registration,
  	        ownerId: clean(company.ownerId),
  	        Tracker: String(flespiDeviceId),
  	        Registration: registration,
  	        ID: registration,
  	        Mileage: mileage,
  	        Type: "Trailer",
  	        AssetClass: "Trailer",
  	        Status: "Active",
  	        Data: buildDefaultTrailerData(registration, mileage, trackerType, imei, flespiDeviceId),
  	        color: DEFAULT_TRACTOR_COLOR,
  	        CAN: buildDefaultTractorCan()
  	      }));
  	      await addRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TRAILERS, registration);
  	      return reconcileTrailer(savedTrailer, company);
  	    } catch (error) {
  	      updateOperation("Rolling back incomplete Trailer creation...");
  	      if (savedTrailer) await removeRecord(TABLES.TRAILERS, registration);
  	      if (flespiDeviceCreated && !flespiDeviceReused && flespiDeviceId) {
  	        try { await invokeFlespiService("deleteProvisionedDevice", { deviceId: flespiDeviceId }); } catch (cleanupError) { console.warn("Could not remove new Flespi device.", cleanupError); }
  	      }
  	      throw error;
  	    }
  	  }

  	  async function createBeaconTrailer(form) {
  	    const data = new FormData(form);
  	    const company = companyById(clean(data.get("CompanyId")));
  	    const registration = normalizeRegistration(data.get("Registration"));
  	    const mileage = formNumber(data, "Mileage", 0);
  	    const eyeId = clean(data.get("EYEID"));

  	    if (!company || !clean(company.ownerId)) throw new Error("Select a Company with an ownerId.");
  	    if (!registration) throw new Error("Trailer Registration is required.");
  	    if (!Number.isFinite(mileage) || mileage < 0) throw new Error("Mileage must be zero or greater.");
  	    if (!eyeId) throw new Error("EYEID is required for a Beacon Trailer.");
  	    if (await findById(TABLES.TRAILERS, registration)) throw new Error("A Trailer already exists with objectId " + registration + ".");
  	    if (await findOne(TABLES.TRAILERS, "Registration = '" + escapeWhere(registration) + "'")) throw new Error("A Trailer already exists with Registration " + registration + ".");

  	    let savedTrailer = null;
  	    try {
  	      updateOperation("Creating Beacon-enabled Backendless Trailer...");
  	      savedTrailer = normalizeTrailer(await upsertRecord(TABLES.TRAILERS, {
  	        objectId: registration,
  	        ownerId: clean(company.ownerId),
  	        Tracker: "",
  	        Registration: registration,
  	        ID: registration,
  	        Mileage: mileage,
  	        EYEID: eyeId,
  	        Type: "Trailer",
  	        AssetClass: "Trailer",
  	        Status: "Active",
  	        Data: buildNormalTrailerData(registration, mileage),
  	        color: DEFAULT_TRACTOR_COLOR,
  	        CAN: buildDefaultTractorCan()
  	      }));
  	      await addRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TRAILERS, registration);
  	      return reconcileTrailer(savedTrailer, company);
  	    } catch (error) {
  	      updateOperation("Rolling back incomplete Beacon Trailer creation...");
  	      if (savedTrailer) await removeRecord(TABLES.TRAILERS, registration);
  	      throw error;
  	    }
  	  }

  	  async function tractorViewIds(tractorId) {
  	    const results = await Promise.all([
  	      loadRelation(TABLES.TRACTORS, tractorId, RELATIONS.TRACTOR_VIEW_CURRENT).catch(function () { return []; }),
  	      loadRelation(TABLES.TRACTORS, tractorId, RELATIONS.TRACTOR_VIEW_HISTORY).catch(function () { return []; })
  	    ]);
  	    return unique(results[0].concat(results[1]).map(objectId).filter(Boolean));
  	  }

  	  function linkedCompaniesForTractor(tractor) {
  	    const tractorId = objectId(tractor);
  	    const rows = state.companies.filter(function (company) { return companyAssets(company).some(function (asset) { return objectId(asset) === tractorId; }); });
  	    if (!rows.length) {
  	      const inferred = companyForTractor(tractor);
  	      if (inferred) rows.push(inferred);
  	    }
  	    return rows;
  	  }

  	  function linkedCompaniesForTrailer(trailer) {
  	    const trailerId = objectId(trailer);
  	    const rows = state.companies.filter(function (company) { return companyTrailers(company).some(function (asset) { return objectId(asset) === trailerId; }); });
  	    if (!rows.length) {
  	      const inferred = companyForTrailer(trailer);
  	      if (inferred) rows.push(inferred);
  	    }
  	    return rows;
  	  }

  	  async function deleteTrackedTractor(tractor) {
  	    const tractorId = objectId(tractor);
  	    const deviceId = clean(tractor && tractor.Tracker);
  	    if (!tractorId || !deviceId) throw new Error("Tracked Tractor identity is incomplete.");
  	    const viewIds = await tractorViewIds(tractorId);
  	    const companies = linkedCompaniesForTractor(tractor);
  	    await invokeFlespiService("deleteProvisionedDevice", { deviceId: deviceId });
  	    for (const company of companies) await deleteRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TRACTORS, tractorId);
  	    for (const viewId of viewIds) await deleteRecordStrict(TABLES.TRACTOR_VIEW, viewId);
  	    await deleteRecordStrict(TABLES.TRACTORS, tractorId);
  	    removeTractorFromState(tractorId);
  	    return { ok: true, tractorId: tractorId, deviceId: deviceId, deletedViewIds: viewIds };
  	  }

  	  async function deleteNonTrackedTractor(tractor) {
  	    const tractorId = objectId(tractor);
  	    if (!tractorId) throw new Error("The Tractor does not have an objectId.");
  	    if (isTrackedTractor(tractor)) throw new Error("This Tractor is tracked and must use tracked deletion.");
  	    const viewIds = await tractorViewIds(tractorId);
  	    const companies = linkedCompaniesForTractor(tractor);
  	    for (const company of companies) await deleteRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TRACTORS, tractorId);
  	    for (const viewId of viewIds) await deleteRecordStrict(TABLES.TRACTOR_VIEW, viewId);
  	    await deleteRecordStrict(TABLES.TRACTORS, tractorId);
  	    removeTractorFromState(tractorId);
  	    return { ok: true, tractorId: tractorId, deletedViewIds: viewIds };
  	  }

  	  async function deleteTrackedTrailer(trailer) {
  	    const trailerId = objectId(trailer);
  	    const deviceId = clean(trailer && trailer.Tracker);
  	    if (!trailerId || !deviceId) throw new Error("Tracked Trailer identity is incomplete.");
  	    const companies = linkedCompaniesForTrailer(trailer);
  	    await invokeFlespiService("deleteProvisionedDevice", { deviceId: deviceId });
  	    for (const company of companies) await deleteRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TRAILERS, trailerId);
  	    await deleteRecordStrict(TABLES.TRAILERS, trailerId);
  	    removeTrailerFromState(trailerId);
  	    return { ok: true, trailerId: trailerId, deviceId: deviceId };
  	  }

  	  function isAdminProfile(user) {
  	    return hasToken(user && user.Role, "Director");
  	  }

  	  function isEmployeeProfile(user) {
  	    return !isAdminProfile(user);
  	  }

  	  function userCompanyIds(user) {
  	    return unique(arr(user && user.Companies).map(objectId).filter(Boolean));
  	  }

  	  function safeTopLevelPayload(record, options) {
  	    const payload = clone(record || {});
  	    const keepOwner = options && options.keepOwner;
  	    [
  	      "created",
  	      "updated",
  	      "___class",
  	      "Companies",
  	      "Employees",
  	      "Tractors",
  	      "Trailers",
  	      "Tanks",
  	      "Bowsers",
  	      "Tyres",
  	      "Locations",
  	      "Routes",
  	      "Customers",
  	      "Contractors",
  	      "Maintenance",
  	      "ViewC",
  	      "ViewH",
  	      "FuelIn",
  	      "FuelOut"
  	    ].forEach(function (field) {
  	      delete payload[field];
  	    });
  	    if (!keepOwner) delete payload.ownerId;
  	    delete payload.password;
  	    return payload;
  	  }

  	  function escapeWhere(value) {
  	    return text(value).replace(/\\/g, "\\\\").replace(/'/g, "\\'");
  	  }

  	  function ensureDatabase() {
  	    if (!BackendlessApi || !BackendlessApi.Data || typeof BackendlessApi.Data.of !== "function") {
  	      throw new Error("The Database API is unavailable. Confirm that Backendless is available globally on this page.");
  	    }
  	    return BackendlessApi;
  	  }

  	  function dataStore(table) {
  	    return ensureDatabase().Data.of(table);
  	  }

  	  function rowsFromResponse(response) {
  	    if (Array.isArray(response)) return response;
  	    if (response && Array.isArray(response.data)) return response.data;
  	    return [];
  	  }

  	  function createQuery(pageSize, offset, where) {
  	    const api = ensureDatabase();
  	    if (!api.DataQueryBuilder || typeof api.DataQueryBuilder.create !== "function") {
  	      return { pageSize: pageSize, offset: offset, where: where || undefined };
  	    }
  	    const builder = api.DataQueryBuilder.create();
  	    if (typeof builder.setPageSize === "function") builder.setPageSize(pageSize);
  	    if (typeof builder.setOffset === "function") builder.setOffset(offset);
  	    if (where && typeof builder.setWhereClause === "function") builder.setWhereClause(where);
  	    return builder;
  	  }

  	  async function findAll(table, where) {
  	    const store = dataStore(table);
  	    const pageSize = 100;
  	    let offset = 0;
  	    const output = [];
  	    while (true) {
  	      const response = await store.find(createQuery(pageSize, offset, where));
  	      const rows = rowsFromResponse(response);
  	      output.push.apply(output, rows);
  	      if (rows.length < pageSize) break;
  	      offset += rows.length;
  	      if (offset > 100000) throw new Error("Database pagination exceeded the safety limit for " + table + ".");
  	    }
  	    return output;
  	  }

  	  async function findOne(table, where) {
  	    const store = dataStore(table);
  	    const response = await store.find(createQuery(1, 0, where));
  	    return rowsFromResponse(response)[0] || null;
  	  }

  	  async function saveRecord(table, payload) {
  	    return dataStore(table).save(payload);
  	  }

  	  async function upsertRecord(table, payload) {
  	    const api = ensureDatabase();
  	    if (!payload || !clean(payload.objectId)) {
  	      throw new Error("Upsert requires a non-empty objectId for " + table + ".");
  	    }
  	    if (typeof api.UnitOfWork !== "function") {
  	      throw new Error("Backendless UnitOfWork is unavailable; custom objectId creation cannot continue.");
  	    }

  	    const transaction = new api.UnitOfWork("REPEATABLE_READ");
  	    if (typeof transaction.upsert !== "function") {
  	      throw new Error("Backendless UnitOfWork.upsert is unavailable.");
  	    }

  	    transaction.upsert(table, payload);
  	    const result = await transaction.execute();
  	    if (result && typeof result.isSuccess === "function" && !result.isSuccess()) {
  	      const transactionError = typeof result.getError === "function" ? result.getError() : null;
  	      throw new Error(clean(transactionError && (transactionError.message || transactionError.error)) || (table + " upsert failed."));
  	    }

  	    const saved = await findById(table, payload.objectId);
  	    if (!saved) {
  	      throw new Error(table + " upsert completed but objectId " + payload.objectId + " could not be read back.");
  	    }
  	    return saved;
  	  }

  	  async function findById(table, id) {
  	    const store = dataStore(table);
  	    if (typeof store.findById !== "function") {
  	      return findOne(table, "objectId = '" + escapeWhere(id) + "'");
  	    }
  	    try {
  	      return await store.findById(id);
  	    } catch (error) {
  	      const message = lower(error && (error.message || error.faultString || error.details));
  	      if (/not found|does not exist|unable to find/.test(message)) return null;
  	      throw error;
  	    }
  	  }

  	  async function removeRecord(table, id) {
  	    const store = dataStore(table);
  	    if (!id || typeof store.remove !== "function") return false;
  	    try {
  	      await store.remove({ objectId: id });
  	      return true;
  	    } catch (error) {
  	      console.warn("FIF Customer & Asset Manager cleanup could not remove " + table + " " + id, error);
  	      return false;
  	    }
  	  }

  	  async function deleteRecordStrict(table, id) {
  	    const store = dataStore(table);
  	    if (!clean(id) || typeof store.remove !== "function") {
  	      throw new Error("The Database record remover is unavailable for " + table + ".");
  	    }
  	    try {
  	      await store.remove({ objectId: clean(id) });
  	      return true;
  	    } catch (error) {
  	      const message = lower(error && (error.message || error.faultString || error.details));
  	      if (/not found|does not exist|unable to find/.test(message)) return false;
  	      throw error;
  	    }
  	  }

  	  async function setRelation(parentTable, parentId, relationName, childId) {
  	    const store = dataStore(parentTable);
  	    if (typeof store.setRelation !== "function") {
  	      throw new Error("The Database relation writer cannot set " + parentTable + "." + relationName + ".");
  	    }
  	    await store.setRelation({ objectId: parentId }, relationName, [{ objectId: childId }]);
  	  }

  	  async function loadRelation(parentTable, parentId, relationName) {
  	    const api = ensureDatabase();
  	    const store = dataStore(parentTable);
  	    if (typeof store.loadRelations !== "function") {
  	      throw new Error("The Database relation reader is unavailable for " + parentTable + "." + relationName + ".");
  	    }
  	    if (!api.LoadRelationsQueryBuilder || typeof api.LoadRelationsQueryBuilder.create !== "function") {
  	      throw new Error("Backendless LoadRelationsQueryBuilder is unavailable.");
  	    }

  	    const pageSize = 100;
  	    let offset = 0;
  	    const output = [];
  	    while (true) {
  	      const query = api.LoadRelationsQueryBuilder.create();
  	      query.setRelationName(String(relationName));
  	      if (typeof query.setPageSize === "function") query.setPageSize(pageSize);
  	      if (typeof query.setOffset === "function") query.setOffset(offset);

  	      const response = await store.loadRelations(String(parentId), query);
  	      const rows = rowsFromResponse(response);
  	      output.push.apply(output, rows);
  	      if (rows.length < pageSize) break;
  	      offset += rows.length;
  	      if (offset > 100000) throw new Error("Relation pagination exceeded the safety limit for " + parentTable + "." + relationName + ".");
  	    }
  	    return output;
  	  }

  	  function relationAlreadyExists(error) {
  	    const message = lower(error && (error.message || error.faultString || error.details));
  	    return /already|duplicate|exists|is related/.test(message);
  	  }

  	  function relationAlreadyMissing(error) {
  	    const message = lower(error && (error.message || error.faultString || error.details));
  	    return /not related|not found|does not exist|no relation|is not related/.test(message);
  	  }

  	  async function addRelation(parentTable, parentId, relationName, childId) {
  	    const store = dataStore(parentTable);
  	    if (typeof store.addRelation !== "function") {
  	      throw new Error("The Database relation writer cannot add " + parentTable + "." + relationName + ".");
  	    }
  	    try {
  	      await store.addRelation({ objectId: parentId }, relationName, [{ objectId: childId }]);
  	    } catch (error) {
  	      if (!relationAlreadyExists(error)) throw error;
  	    }
  	  }

  	  async function deleteRelation(parentTable, parentId, relationName, childId) {
  	    const store = dataStore(parentTable);
  	    if (typeof store.deleteRelation !== "function") {
  	      throw new Error("The Database relation writer cannot remove " + parentTable + "." + relationName + ".");
  	    }
  	    try {
  	      await store.deleteRelation({ objectId: parentId }, relationName, [{ objectId: childId }]);
  	    } catch (error) {
  	      if (!relationAlreadyMissing(error)) throw error;
  	    }
  	  }

  	  const state = {
  	    root: null,
  	    priorBodyOverflow: "",
  	    activeSection: "directors",
  	    search: "",
  	    companies: [],
  	    users: [],
  	    tractors: [],
  	    trailers: [],
  	    tanks: [],
  	    bowsers: [],
  	    trackerTypes: [],
  	    trackerTypesLoaded: false,
  	    modal: null,
  	    busy: false,
  	    mounted: false,
  	    toastTimer: null,
  	    tankLocationDraft: null,
  	    topBarBindTimer: null,
  	    topBarPointerHandler: null,
  	    topBarClickHandler: null,
  	    applicationOpenHandler: null,
  	    ownTopBarLauncher: null,
  	    ownTopBarLauncherKey: "",
  	    destroying: false,
  	    impersonationWindow: null,
  	    pendingCompanyDirectorId: ""
  	  };

  	  function upsertById(list, record, normalizer) {
  	    const output = arr(list);
  	    const id = objectId(record);
  	    const normalized = normalizer(record);
  	    const index = output.findIndex(function (item) {
  	      return objectId(item) === id;
  	    });
  	    if (index >= 0) {
  	      if (isObject(output[index])) {
  	        Object.assign(output[index], clone(normalized));
  	      } else {
  	        output[index] = normalized;
  	      }
  	    } else {
  	      output.push(normalized);
  	    }
  	    return output;
  	  }

  	  function findCompanyEverywhere(companyId) {
  	    const matches = [];
  	    const seen = new Set();
  	    function add(company) {
  	      if (!company || objectId(company) !== companyId || seen.has(company)) return;
  	      seen.add(company);
  	      matches.push(company);
  	    }
  	    state.companies.forEach(add);
  	    arr(APP_DATA && APP_DATA.Companies).forEach(add);
  	    arr(APP_DATA && APP_DATA.User && APP_DATA.User.Companies).forEach(add);
  	    state.users.forEach(function (user) {
  	      arr(user.Companies).forEach(add);
  	    });
  	    return matches;
  	  }

  	  function reconcileCompany(saved) {
  	    const savedId = objectId(saved);
  	    const prior = state.companies.find(function (company) { return objectId(company) === savedId; }) || null;
  	    const normalized = normalizeCompany(saved);
  	    ["Employees", "Contractors", "Tractors", "Trailers", "Tanks", "Locations"].forEach(function (field) {
  	      if (!Array.isArray(normalized[field]) && prior && Array.isArray(prior[field])) normalized[field] = clone(prior[field]);
  	    });
  	    if (Array.isArray(normalized.Tractors)) normalized.Tractors = normalized.Tractors.map(normalizeTractor);
  	    if (Array.isArray(normalized.Trailers)) normalized.Trailers = normalized.Trailers.map(normalizeTrailer);
  	    if (Array.isArray(normalized.Tanks)) normalized.Tanks = normalized.Tanks.map(normalizeTank);
  	    state.companies = upsertById(state.companies, normalized, normalizeCompany);
  	    if (!Array.isArray(APP_DATA.Companies)) APP_DATA.Companies = [];
  	    APP_DATA.Companies = upsertById(APP_DATA.Companies, normalized, normalizeCompany);
  	    findCompanyEverywhere(objectId(normalized)).forEach(function (alias) {
  	      const kept = {};
  	      ["Employees", "Contractors", "Tractors", "Trailers", "Tanks", "Locations"].forEach(function (field) {
  	        if (Array.isArray(alias[field])) kept[field] = alias[field];
  	        else if (Array.isArray(normalized[field])) kept[field] = normalized[field];
  	      });
  	      Object.assign(alias, clone(normalized));
  	      Object.keys(kept).forEach(function (field) { alias[field] = kept[field]; });
  	    });
  	    return normalized;
  	  }

  	  function removeUserFromCompanyAliases(userId, companyId) {
  	    findCompanyEverywhere(companyId).forEach(function (company) {
  	      if (Array.isArray(company.Employees)) {
  	        company.Employees = company.Employees.filter(function (user) {
  	          return objectId(user) !== userId;
  	        });
  	      }
  	    });
  	  }

  	  function addUserToCompanyAliases(user, companyId) {
  	    findCompanyEverywhere(companyId).forEach(function (company) {
  	      if (!Array.isArray(company.Employees)) company.Employees = [];
  	      company.Employees = upsertById(company.Employees, user, normalizeUser);
  	    });
  	  }

  	  function reconcileUser(saved, desiredCompanies, removedCompanyIds) {
  	    const normalized = normalizeUser(saved);
  	    normalized.Companies = arr(desiredCompanies).map(normalizeCompany);
  	    state.users = upsertById(state.users, normalized, normalizeUser);

  	    if (!Array.isArray(APP_DATA.Users)) APP_DATA.Users = [];
  	    APP_DATA.Users = upsertById(APP_DATA.Users, normalized, normalizeUser);
  	    if (Array.isArray(APP_DATA.Employees)) {
  	      APP_DATA.Employees = upsertById(APP_DATA.Employees, normalized, normalizeUser);
  	    }

  	    arr(removedCompanyIds).forEach(function (companyId) {
  	      removeUserFromCompanyAliases(objectId(normalized), companyId);
  	    });
  	    normalized.Companies.forEach(function (company) {
  	      addUserToCompanyAliases(normalized, objectId(company));
  	    });

  	    if (APP_DATA.User && objectId(APP_DATA.User) === objectId(normalized)) {
  	      Object.assign(APP_DATA.User, clone(normalized));
  	    }
  	    return normalized;
  	  }

  	  function companyById(id) {
  	    return state.companies.find(function (company) {
  	      return objectId(company) === clean(id);
  	    }) || null;
  	  }

  	  function userById(id) {
  	    return state.users.find(function (user) {
  	      return objectId(user) === clean(id);
  	    }) || null;
  	  }

  	  function adminUsers() {
  	    return state.users.filter(isAdminProfile).sort(function (left, right) {
  	      return userName(left).localeCompare(userName(right), undefined, { sensitivity: "base", numeric: true });
  	    });
  	  }

  	  function employeeUsers() {
  	    return state.users.filter(isEmployeeProfile).sort(function (left, right) {
  	      return userName(left).localeCompare(userName(right), undefined, { sensitivity: "base", numeric: true });
  	    });
  	  }

  	  function companyAssets(company) {
  	    return arr(company && company.Tractors).map(normalizeTractor).sort(function (left, right) {
  	      return tractorRegistration(left).localeCompare(tractorRegistration(right), undefined, { sensitivity: "base", numeric: true });
  	    });
  	  }

  	  function companyTrackedTractors(company) {
  	    return companyAssets(company).filter(isTrackedTractor);
  	  }

  	  function companyNonTrackedTractors(company) {
  	    return companyAssets(company).filter(isNonTrackedTractor);
  	  }

  	  function companyTrailers(company) {
  	    return arr(company && company.Trailers).map(normalizeTrailer).sort(function (left, right) {
  	      return trailerLabel(left).localeCompare(trailerLabel(right), undefined, { sensitivity: "base", numeric: true });
  	    });
  	  }

  	  function companyTrackedTrailers(company) {
  	    return companyTrailers(company).filter(isTrackedTrailer);
  	  }

  	  function companyTanks(company) {
  	    return arr(company && company.Tanks).map(normalizeTank).sort(function (left, right) {
  	      return tankLabel(left).localeCompare(tankLabel(right), undefined, { sensitivity: "base", numeric: true });
  	    });
  	  }

  	  function companyBowserCount(company) {
  	    return companyTanks(company).reduce(function (count, tank) { return count + arr(tank.Bowsers).length; }, 0);
  	  }

  	  function baseAssetKind(kind) {
  	    if (kind === "tracked-tractor" || kind === "nontracked-tractor" || kind === "tractor") return "tractor";
  	    if (kind === "tracked-trailer" || kind === "beacon-trailer" || kind === "trailer") return "trailer";
  	    return kind;
  	  }

  	  function relationFieldForKind(kind) {
  	    const base = baseAssetKind(kind);
  	    if (base === "tractor") return RELATIONS.COMPANY_TRACTORS;
  	    if (base === "trailer") return RELATIONS.COMPANY_TRAILERS;
  	    if (base === "tank") return RELATIONS.COMPANY_TANKS;
  	    throw new Error("Unsupported asset kind: " + kind);
  	  }

  	  function tableForKind(kind) {
  	    const base = baseAssetKind(kind);
  	    if (base === "tractor") return TABLES.TRACTORS;
  	    if (base === "trailer") return TABLES.TRAILERS;
  	    if (base === "tank") return TABLES.TANKS;
  	    throw new Error("Unsupported asset kind: " + kind);
  	  }

  	  function globalAssetsForKind(kind) {
  	    if (kind === "tracked-tractor") return state.tractors.filter(isTrackedTractor);
  	    if (kind === "nontracked-tractor") return state.tractors.filter(isNonTrackedTractor);
  	    if (kind === "tracked-trailer") return state.trailers.filter(isTrackedTrailer);
  	    if (kind === "beacon-trailer") return state.trailers.filter(isBeaconTrailer);
  	    if (kind === "tractor") return state.tractors;
  	    if (kind === "trailer") return state.trailers;
  	    if (kind === "tank") return state.tanks;
  	    return [];
  	  }

  	  function companyAssetsForKind(company, kind) {
  	    if (kind === "tracked-tractor") return companyTrackedTractors(company);
  	    if (kind === "nontracked-tractor") return companyNonTrackedTractors(company);
  	    if (kind === "tracked-trailer") return companyTrackedTrailers(company);
  	    if (kind === "beacon-trailer") return companyTrailers(company).filter(isBeaconTrailer);
  	    if (kind === "tractor") return companyAssets(company);
  	    if (kind === "trailer") return companyTrailers(company);
  	    if (kind === "tank") return companyTanks(company);
  	    return [];
  	  }

  	  function assetLabel(asset, kind) {
  	    const base = baseAssetKind(kind);
  	    if (base === "tractor") return tractorRegistration(asset);
  	    if (base === "trailer") return trailerLabel(asset);
  	    if (base === "tank") return tankLabel(asset);
  	    return objectId(asset);
  	  }

  	  function normalizeAsset(asset, kind) {
  	    const base = baseAssetKind(kind);
  	    if (base === "tractor") return normalizeTractor(asset);
  	    if (base === "trailer") return normalizeTrailer(asset);
  	    if (base === "tank") return normalizeTank(asset);
  	    return clone(asset);
  	  }

  	  function linkedAssetIds(kind) {
  	    const ids = new Set();
  	    state.companies.forEach(function (company) {
  	      companyAssetsForKind(company, kind).forEach(function (asset) { if (objectId(asset)) ids.add(objectId(asset)); });
  	    });
  	    return ids;
  	  }

  	  function availableAssetsForCompany(company, kind) {
  	    const linked = linkedAssetIds(kind);
  	    return globalAssetsForKind(kind).filter(function (asset) { return objectId(asset) && !linked.has(objectId(asset)); }).sort(function (a, b) {
  	      return assetLabel(a, kind).localeCompare(assetLabel(b, kind), undefined, { sensitivity: "base", numeric: true });
  	    });
  	  }

  	  async function hydrateTankBowsers(tank) {
  	    if (!objectId(tank)) return normalizeTank(tank);
  	    const normalized = normalizeTank(tank);
  	    const results = await Promise.all([
  	      loadRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_BOWSERS).catch(function (error) {
  	        console.warn("FIF Manager: Tanks.Bowsers load failed for", tankLabel(tank), error);
  	        return arr(tank && tank.Bowsers);
  	      }),
  	      loadRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_LOCATION).catch(function (error) {
  	        console.warn("FIF Manager: Tanks.Location load failed for", tankLabel(tank), error);
  	        return tank && tank.Location ? [tank.Location] : [];
  	      })
  	    ]);
  	    normalized.Bowsers = results[0].map(normalizeBowser);
  	    normalized.Location = results[1][0] || null;
  	    return normalized;
  	  }

  	  async function loadCompanyAssets(company) {
  	    if (!objectId(company)) return company;
  	    const companyId = objectId(company);
  	    const results = await Promise.all([
  	      loadRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_TRACTORS).catch(function (error) {
  	        console.warn("Companies.Tractors load failed for", companyName(company), error); return arr(company.Tractors);
  	      }),
  	      loadRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_TRAILERS).catch(function (error) {
  	        console.warn("Companies.Trailers load failed for", companyName(company), error); return arr(company.Trailers);
  	      }),
  	      loadRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_TANKS).catch(function (error) {
  	        console.warn("Companies.Tanks load failed for", companyName(company), error); return arr(company.Tanks);
  	      }),
  	      loadRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_LOCATIONS).catch(function (error) {
  	        console.warn("Companies.Locations load failed for", companyName(company), error); return arr(company.Locations);
  	      }),
  	      loadRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_CONTRACTORS).catch(function (error) {
  	        console.warn("Companies.Contractors load failed for", companyName(company), error);
  	        return arr(company.Contractors);
  	      })
  	    ]);
  	    company.Tractors = results[0].map(normalizeTractor);
  	    company.Trailers = results[1].map(normalizeTrailer);
  	    company.Tanks = await Promise.all(results[2].map(hydrateTankBowsers));
  	    company.Locations = results[3].map(function (location) { return clone(location); });
  	    // Relation records contain the linked company's identity, not guaranteed Tractors.
  	    // Hydrate from the already loaded Companies set after all company workers finish.
  	    company.Contractors = results[4].map(function (contractor) { return clone(contractor); });
  	    return company;
  	  }

  	  async function hydrateCompanyAssetRelations(companies) {
  	    const queue = arr(companies).slice();
  	    const workerCount = Math.min(4, queue.length);
  	    const workers = [];
  	    async function worker() {
  	      while (queue.length) await loadCompanyAssets(queue.shift());
  	    }
  	    for (let index = 0; index < workerCount; index += 1) workers.push(worker());
  	    await Promise.all(workers);
  	  }

  	  function companyContractors(company) {
  	    return arr(company && company.Contractors);
  	  }

  	  // Contractor is a directional role: company A may have company B as its
  	  // contractor without company B automatically acquiring company A.
  	  // Keep the objects shallow to avoid recursive Companies.Contractors cycles.
  	  function contractorSnapshot(company) {
  	    const id = objectId(company);
  	    if (!id) return null;
  	    const resolved = state.companies.find(function (row) { return objectId(row) === id; }) || company;
  	    return {
  	      objectId: id,
  	      Name: companyName(resolved),
  	      CompanyId: companyBusinessId(resolved),
  	      Status: companyIsActive(resolved),
  	      Tractors: arr(resolved.Tractors).map(normalizeTractor)
  	    };
  	  }

  	  function refreshCompanyContractorSnapshots(company) {
  	    if (!company || !objectId(company) || !Array.isArray(company.Contractors)) return;
  	    const contractorIds = unique(company.Contractors.map(objectId).filter(function (id) {
  	      return id && id !== objectId(company);
  	    }));
  	    const fresh = contractorIds.map(function (id) {
  	      const source = state.companies.find(function (row) { return objectId(row) === id; }) ||
  	        company.Contractors.find(function (row) { return objectId(row) === id; });
  	      return contractorSnapshot(source);
  	    }).filter(Boolean).sort(function (left, right) {
  	      return companyName(left).localeCompare(companyName(right), undefined, { sensitivity: "base", numeric: true });
  	    });
  	    findCompanyEverywhere(objectId(company)).forEach(function (alias) {
  	      alias.Contractors = clone(fresh);
  	    });
  	  }

  	  function refreshAllCompanyContractorSnapshots() {
  	    state.companies.forEach(refreshCompanyContractorSnapshots);
  	  }

  	  async function changeCompanyContractorRelation(clientId, contractorId, shouldLink) {
  	    const client = companyById(clientId);
  	    const contractor = companyById(contractorId);
  	    if (!client || !contractor) throw new Error("Both Companies must already exist in Backendless.");
  	    if (objectId(client) === objectId(contractor)) throw new Error("A Company cannot be its own Contractor.");
  	    try {
  	      // The database is the authority; stale AppData must never decide the link.
  	      const existing = await loadRelation(TABLES.COMPANIES, clientId, RELATIONS.COMPANY_CONTRACTORS);
  	      const linked = existing.some(function (row) { return objectId(row) === contractorId; });
  	      if (shouldLink && !linked) {
  	        await addRelation(TABLES.COMPANIES, clientId, RELATIONS.COMPANY_CONTRACTORS, contractorId);
  	      } else if (!shouldLink && linked) {
  	        await deleteRelation(TABLES.COMPANIES, clientId, RELATIONS.COMPANY_CONTRACTORS, contractorId);
  	      }
  	      // Confirm authoritative saved state before updating the UI/AppData mirrors.
  	      const updated = await loadRelation(TABLES.COMPANIES, clientId, RELATIONS.COMPANY_CONTRACTORS);
  	      client.Contractors = updated;
  	      refreshCompanyContractorSnapshots(client);
  	      return contractor;
  	    } catch (error) {
  	      const detail = clean(error && (error.message || error.faultString || error.details)) || String(error);
  	      throw new Error("Cannot update Companies.Contractors. Confirm Backendless Companies has a Contractors Data Object Relationship to Companies with one-to-many cardinality, and that this user can read/write it. " + detail);
  	    }
  	  }

  	  async function linkCompanyContractor(clientId, contractorId) {
  	    return changeCompanyContractorRelation(clean(clientId), clean(contractorId), true);
  	  }

  	  async function unlinkCompanyContractor(clientId, contractorId) {
  	    return changeCompanyContractorRelation(clean(clientId), clean(contractorId), false);
  	  }

  	  function companyAdminUsers(company) {
  	    const companyId = objectId(company);
  	    return adminUsers().filter(function (user) {
  	      return userCompanyIds(user).indexOf(companyId) !== -1;
  	    });
  	  }

  	  function auditEntry(action) {
  	    return {
  	      At: nowIso(),
  	      By: currentUserName(),
  	      Action: action
  	    };
  	  }

  	  async function loadUserCompanies(user) {
  	    if (!objectId(user)) return user;
  	    try {
  	      user.Companies = (await loadRelation(TABLES.USERS, objectId(user), RELATIONS.USER_COMPANIES)).map(normalizeCompany);
  	    } catch (error) {
  	      console.warn("FIF Customer & Asset Manager: Users.Companies load failed for", userName(user), error);
  	      user.Companies = arr(user.Companies).map(normalizeCompany);
  	    }
  	    return user;
  	  }

  	  async function hydrateUserRelations(users) {
  	    const queue = arr(users).slice();
  	    const workerCount = Math.min(4, queue.length);
  	    const workers = [];
  	    async function worker() {
  	      while (queue.length) {
  	        const user = queue.shift();
  	        await loadUserCompanies(user);

  	        // Enforce the Employee login invariant against existing data as well:
  	        // zero Company links = DISABLED; an automatically locked Employee is
  	        // restored only after a Company relation exists again.
  	        if (isEmployeeProfile(user)) {
  	          const corrected = await applyEmployeeCompanyLoginState(user, arr(user.Companies).length > 0);
  	          Object.assign(user, corrected);
  	        }
  	      }
  	    }
  	    for (let index = 0; index < workerCount; index += 1) workers.push(worker());
  	    await Promise.all(workers);
  	  }

  	  async function reloadData() {
  	    beginOperation("Loading Directors, Companies, Employees and assets...");
  	    try {
  	      const results = await Promise.all([
  	        findAll(TABLES.COMPANIES),
  	        findAll(TABLES.USERS),
  	        findAll(TABLES.TRACTORS),
  	        findAll(TABLES.TRAILERS),
  	        findAll(TABLES.TANKS),
  	        findAll(TABLES.BOWSERS)
  	      ]);
  	      state.companies = results[0].map(normalizeCompany).sort(function (a, b) {
  	        return companyName(a).localeCompare(companyName(b), undefined, { sensitivity: "base", numeric: true });
  	      });
  	      state.users = results[1].map(normalizeUser);
  	      state.tractors = results[2].map(normalizeTractor).sort(function (a, b) { return tractorRegistration(a).localeCompare(tractorRegistration(b), undefined, { sensitivity: "base", numeric: true }); });
  	      state.trailers = results[3].map(normalizeTrailer).sort(function (a, b) { return trailerLabel(a).localeCompare(trailerLabel(b), undefined, { sensitivity: "base", numeric: true }); });
  	      state.tanks = results[4].map(normalizeTank).sort(function (a, b) { return tankLabel(a).localeCompare(tankLabel(b), undefined, { sensitivity: "base", numeric: true }); });
  	      state.bowsers = results[5].map(normalizeBowser).sort(function (a, b) { return clean(a.Name).localeCompare(clean(b.Name), undefined, { sensitivity: "base", numeric: true }); });
  	      APP_DATA.Tractors = state.tractors.slice();
  	      APP_DATA.Trailers = state.trailers.slice();
  	      APP_DATA.Tanks = state.tanks.slice();
  	      APP_DATA.Bowsers = state.bowsers.slice();
  	      updateOperation("Loading user and company relations...");
  	      await Promise.all([hydrateUserRelations(state.users), hydrateCompanyAssetRelations(state.companies)]);
  	      state.companies.forEach(reconcileCompany);
  	      refreshAllCompanyContractorSnapshots();
  	      endOperation();
  	      render();
  	      showToast("Management data loaded.", "success");
  	    } catch (error) {
  	      failOperation(error);
  	      throw error;
  	    }
  	  }

  	  async function assertCompanyUnique(name, businessId, requestedObjectId, excludeId) {
  	    const duplicateId = await findOne(TABLES.COMPANIES, "CompanyId = '" + escapeWhere(businessId) + "'");
  	    if (duplicateId && objectId(duplicateId) !== excludeId) throw new Error("A company with this debtor identifier already exists.");
  	    const duplicateName = await findOne(TABLES.COMPANIES, "Name = '" + escapeWhere(name) + "'");
  	    if (duplicateName && objectId(duplicateName) !== excludeId) throw new Error("A company with this registered name already exists.");
  	    if (!excludeId && requestedObjectId) {
  	      const duplicateObjectId = await findById(TABLES.COMPANIES, requestedObjectId);
  	      if (duplicateObjectId) throw new Error("A Company already exists with objectId " + requestedObjectId + ".");
  	    }
  	  }

  	  function formNumber(data, name, fallback) {
  	    const raw = clean(data.get(name));
  	    if (raw === "") return fallback === undefined ? 0 : fallback;
  	    const number = Number(raw);
  	    if (!Number.isFinite(number)) throw new Error(name + " must be a valid number.");
  	    return number;
  	  }

  	  function formBoolean(data, name, fallback) {
  	    const value = lower(data.get(name));
  	    if (!value) return !!fallback;
  	    return value === "yes" || value === "true" || value === "1";
  	  }

  	  function parseListInput(value) {
  	    return unique(text(value).split(/[\n,;|]+/).map(clean).filter(Boolean));
  	  }

  	  function addressFromForm(data, prefix, existing) {
  	    const prior = merge(blankCompanyAddress(), existing || {});
  	    return {
  	      Line1: clean(data.get(prefix + "Line1")),
  	      Line2: clean(data.get(prefix + "Line2")),
  	      Suburb: clean(data.get(prefix + "Suburb")),
  	      City: clean(data.get(prefix + "City")),
  	      Province: clean(data.get(prefix + "Province")),
  	      PostalCode: clean(data.get(prefix + "PostalCode")),
  	      Country: clean(data.get(prefix + "Country")) || prior.Country || "South Africa"
  	    };
  	  }

  	  function contactFromForm(data, prefix, existing) {
  	    const prior = merge(blankCompanyContact(), existing || {});
  	    return {
  	      Name: clean(data.get(prefix + "Name")),
  	      Role: clean(data.get(prefix + "Role")),
  	      Email: lower(data.get(prefix + "Email")),
  	      Phone: clean(data.get(prefix + "Phone")),
  	      AlternatePhone: clean(data.get(prefix + "AlternatePhone")) || prior.AlternatePhone || ""
  	    };
  	  }

  	  function buildCompanyPayload(form, existing) {
  	    const data = new FormData(form);
  	    const name = clean(data.get("Name"));
  	    const tradingName = clean(data.get("TradingName"));
  	    const businessId = clean(data.get("CompanyId"));
  	    const active = existing ? companyIsActive(existing) : true;
  	    if (!name) throw new Error("Registered company name is required.");
  	    if (!tradingName) throw new Error("Trading name is required so the Company objectId can combine both names.");
  	    if (!businessId) throw new Error("Debtor / customer identifier is required.");

  	    const manifest = normalizeCompanyManifest(existing && existing.Manifest);
  	    const profile = manifest.Profile;
  	    const now = nowIso();
  	    profile.RegisteredName = name;
  	    profile.Company_Name = name;
  	    profile.TradingName = tradingName;
  	    profile.Trading_As = tradingName;
  	    profile.CompanyId = businessId;
  	    profile.RegistrationNumber = clean(data.get("RegistrationNumber"));
  	    profile.EntityType = clean(data.get("EntityType"));
  	    profile.TaxNumber = clean(data.get("TaxNumber"));
  	    profile.VATRegistered = formBoolean(data, "VATRegistered", profile.VATRegistered);
  	    profile.VATNumber = clean(data.get("VATNumber"));
  	    if (profile.VATRegistered && !profile.VATNumber) throw new Error("A VAT number is required when VAT Registered is Yes.");
  	    profile.Status = active ? "ACTIVE" : "INACTIVE";
  	    profile.PrimaryEmail = lower(data.get("PrimaryEmail"));
  	    profile.Email = profile.PrimaryEmail;
  	    profile.Telephone = clean(data.get("Telephone"));

  	    manifest.Contacts.Primary = contactFromForm(data, "PrimaryContact", manifest.Contacts.Primary);
  	    if (!manifest.Contacts.Primary.Email) manifest.Contacts.Primary.Email = profile.PrimaryEmail;
  	    if (!manifest.Contacts.Primary.Phone) manifest.Contacts.Primary.Phone = profile.Telephone;
  	    manifest.Contacts.Billing = contactFromForm(data, "BillingContact", manifest.Contacts.Billing);
  	    manifest.Addresses.Registered = addressFromForm(data, "Registered", manifest.Addresses.Registered);
  	    manifest.Addresses.Billing = addressFromForm(data, "Billing", manifest.Addresses.Billing);
  	    profile.Address = clone(manifest.Addresses.Registered);

  	    const account = manifest.Billing.Account;
  	    account.AccountNumber = clean(data.get("BillingAccountNumber")) || account.AccountNumber || businessId;
  	    account.CustomerNumber = clean(data.get("CustomerNumber")) || account.CustomerNumber || businessId;
  	    account.Status = clean(data.get("BillingStatus")).toUpperCase() || "ACTIVE";
  	    account.Currency = clean(data.get("Currency")).toUpperCase() || "ZAR";
  	    account.TaxRate = Math.max(0, formNumber(data, "TaxRate", 15));
  	    account.PaymentTermsDays = Math.max(0, Math.floor(formNumber(data, "PaymentTermsDays", 30)));
  	    account.CreditLimit = Math.max(0, formNumber(data, "CreditLimit", 0));
  	    account.PurchaseOrderRequired = formBoolean(data, "PurchaseOrderRequired", false);
  	    account.DefaultPurchaseOrder = clean(data.get("DefaultPurchaseOrder"));
  	    account.InvoiceEmail = lower(data.get("InvoiceEmail")) || manifest.Contacts.Billing.Email || profile.PrimaryEmail;
  	    account.StatementEmail = lower(data.get("StatementEmail")) || account.InvoiceEmail;
  	    account.Reference = clean(data.get("BillingReference"));
  	    account.Notes = clean(data.get("BillingNotes"));

  	    const compliance = manifest.Compliance;
  	    compliance.CompanyRegistrationVerified = formBoolean(data, "CompanyRegistrationVerified", false);
  	    compliance.VATVerified = formBoolean(data, "VATVerified", false);
  	    compliance.BillingApproved = formBoolean(data, "BillingApproved", false);
  	    manifest.Meta.CreatedAt = manifest.Meta.CreatedAt || now;
  	    manifest.Meta.CreatedBy = manifest.Meta.CreatedBy || currentUserName();
  	    manifest.Meta.UpdatedAt = now;
  	    manifest.Meta.UpdatedBy = currentUserName();
  	    manifest.SchemaVersion = "FIF-COMPANY-DEBTOR-1.1";
  	    manifest.Audit = arr(manifest.Audit);
  	    manifest.Audit.push(auditEntry(existing ? "Debtor/legal master updated" : "Debtor/legal master created"));
  	    if (manifest.Audit.length > 500) manifest.Audit = manifest.Audit.slice(-500);

  	    const payload = { Name: name, CompanyId: businessId, Status: active, Manifest: manifest };
  	    payload.objectId = existing && objectId(existing) ? objectId(existing) : companyObjectIdFromNames(name, tradingName);
  	    if (!existing) payload.Refrences = {};
  	    return payload;
  	  }

  	  async function saveCompanyFromModal() {
  	    const form = state.root.querySelector('[data-form="company"]');
  	    if (!form) throw new Error("The company form is unavailable.");
  	    const existingId = clean(form.elements.namedItem("ObjectId") && form.elements.namedItem("ObjectId").value);
  	    const existing = existingId ? companyById(existingId) : null;
  	    const payload = buildCompanyPayload(form, existing);
  	    const pendingDirectorId = existing ? "" : clean(state.pendingCompanyDirectorId);
  	    beginOperation(existing ? "Saving debtor changes..." : "Creating debtor company...");
  	    let saved = null;
  	    try {
  	      await assertCompanyUnique(payload.Name, payload.CompanyId, payload.objectId, existingId);
  	      const savedRaw = existing
  	        ? await saveRecord(TABLES.COMPANIES, safeTopLevelPayload(payload))
  	        : await upsertRecord(TABLES.COMPANIES, safeTopLevelPayload(payload));
  	      saved = normalizeCompany(savedRaw);
  	      if (!existing && objectId(saved) !== payload.objectId) throw new Error("The Company did not retain the registered/trading-name objectId.");
  	      reconcileCompany(saved);

  	      if (pendingDirectorId) {
  	        const director = userById(pendingDirectorId);
  	        if (!director) throw new Error("The saved Director is no longer available for Company linking.");
  	        updateOperation("Linking the new Company to " + userName(director) + "...");
  	        const currentCompanies = (await loadRelation(TABLES.USERS, pendingDirectorId, RELATIONS.USER_COMPANIES)).map(normalizeCompany);
  	        const desiredCompanies = upsertById(currentCompanies, saved, normalizeCompany);
  	        const relationResult = await syncUserCompanies(director, desiredCompanies);
  	        reconcileUser(relationResult.user, relationResult.companies, relationResult.removedCompanyIds);
  	      }

  	      state.pendingCompanyDirectorId = "";
  	      endOperation();
  	      closeModal();
  	      render();
  	      showToast(companyName(saved) + " was saved" + (pendingDirectorId ? " and linked to the Director" : " with objectId " + objectId(saved)) + ".", "success", 6500);
  	      return saved;
  	    } catch (error) {
  	      failOperation(error);
  	      state.pendingCompanyDirectorId = "";
  	      if (saved) {
  	        closeModal();
  	        render();
  	        showToast(companyName(saved) + " was saved, but it could not be linked to the Director. Open the Director and link the Company manually. " + clean(error.message || error), "error", 9000);
  	        return saved;
  	      }
  	      throw error;
  	    }
  	  }

  	  function normalizeIdNumber(value) {
  	    return clean(value).replace(/\D/g, "");
  	  }

  	  async function findUserByIdentity(idNumber) {
  	    const identity = normalizeIdNumber(idNumber);
  	    if (!/^\d{13}$/.test(identity)) return null;
  	    return findOne(TABLES.USERS, "objectId = '" + escapeWhere(identity) + "'");
  	  }

  	  async function assertUserUnique(email, idNumber, excludeId) {
  	    // Fleet In Form permanent identity rule:
  	    // only the South African ID / Users objectId is unique.
  	    // Names, email addresses and employee numbers may legitimately repeat.
  	    const byObjectId = await findUserByIdentity(idNumber);
  	    if (byObjectId && objectId(byObjectId) !== excludeId) throw new Error("This South African ID already belongs to another user.");
  	  }

  	  function generateUserLocalKey() {
  	    try {
  	      if (typeof crypto !== "undefined" && crypto && typeof crypto.randomUUID === "function") {
  	        return "FIF-" + crypto.randomUUID();
  	      }
  	    } catch (_) {}
  	    return "FIF-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2) + "-" + Math.random().toString(36).slice(2);
  	  }

  	  function selectedFormValues(form, name) {
  	    return unique(new FormData(form).getAll(name).map(clean).filter(Boolean));
  	  }

  	  function selectedCompanyIdsFromForm(form) {
  	    return unique(new FormData(form).getAll("CompanyIds").map(clean).filter(Boolean));
  	  }

  	  function buildEssentialEmployeePayload(form) {
  	    const data = new FormData(form);
  	    const firstName = clean(data.get("FirstName"));
  	    const lastName = clean(data.get("LastName"));
  	    const email = lower(data.get("Email"));
  	    const idNumber = normalizeIdNumber(data.get("IdNumber"));
  	    const password = clean(data.get("Password"));
  	    const confirmPassword = clean(data.get("ConfirmPassword"));
  	    const apps = selectedFormValues(form, "APP");
  	    const office = selectedFormValues(form, "Office");
  	    const hasOffice = apps.indexOf("Office") !== -1;
  	    const home = hasOffice ? clean(data.get("Home")) : "";
  	    const companyIds = selectedCompanyIdsFromForm(form);

  	    const details = {
  	      first_name: firstName,
  	      last_name: lastName,
  	      id_number: idNumber,
  	      account_type: "Employee",
  	      operational_roles: [],
  	      access_control: {
  	        // A new Employee is registered disabled until at least one Company
  	        // relationship is successfully written and verified.
  	        company_membership_login_disabled: true,
  	        status_before_company_unlink: "ENABLED",
  	        company_membership_login_disabled_at: new Date().toISOString()
  	      },
  	      contact_details: {
  	        email: email,
  	        phone_number: ""
  	      },
  	      audit: [auditEntry("Employee created")]
  	    };

  	    const payload = {
  	      objectId: idNumber,
  	      ownerId: idNumber,
  	      ID: idNumber,
  	      email: email,
  	      name: [firstName, lastName].filter(Boolean).join(" ").trim(),
  	      APP: apps.join(","),
  	      Office: hasOffice ? office.join(",") : "",
  	      Settings: "",
  	      Role: EMPLOYEE_ROLE_VALUE,
  	      // Security invariant: registration is staged DISABLED. syncUserCompanies()
  	      // enables the Employee only after a real Company relation is verified.
  	      userStatus: "DISABLED",
  	      Local_Key: generateUserLocalKey(),
  	      Data_Details: { employee_details: details }
  	    };

  	    // Home is schema validated. Never send an empty string.
  	    if (hasOffice && home) payload.Home = home;

  	    return {
  	      creating: true,
  	      payload: payload,
  	      password: password,
  	      confirmPassword: confirmPassword,
  	      companyIds: companyIds,
  	      accountType: "Employee",
  	      essentialEmployeeCreate: true
  	    };
  	  }

  	  function validateEssentialEmployeeCreate(data) {
  	    const payload = data && data.payload ? data.payload : {};
  	    const details = userDetails(payload);
  	    const apps = tokens(payload.APP);
  	    const office = tokens(payload.Office);
  	    const home = clean(payload.Home);

  	    if (!clean(details.first_name)) throw new Error("First name is required.");
  	    if (!clean(details.last_name)) throw new Error("Last name is required.");
  	    if (!clean(payload.email)) throw new Error("Email is required.");
  	    if (!/^\d{13}$/.test(normalizeIdNumber(payload.objectId))) throw new Error("South African ID must contain exactly 13 digits.");
  	    if (String(data.password || "").length < 8) throw new Error("The temporary password must contain at least 8 characters.");
  	    if (String(data.password || "") !== String(data.confirmPassword || "")) throw new Error("Password and Confirm password must match exactly.");
  	    if (!data.companyIds.length) throw new Error("A new Employee must belong to at least one Company before the login can be enabled.");
  	    if (!apps.length) throw new Error("Select at least one application for the Employee.");
  	    if (apps.indexOf("Office") !== -1) {
  	      if (!office.length) throw new Error("Select at least one Office module when Office application access is assigned.");
  	      if (!home || office.indexOf(home) === -1) throw new Error("Choose one assigned Office module as the Home screen.");
  	    }
  	  }

  	  function buildUserPayload(form, existing) {
  	    const requestedTypeNode = form && form.elements && form.elements.namedItem("AccountType");
  	    const requestedType = clean(requestedTypeNode && requestedTypeNode.value) === "Employee" ? "Employee" : "Director";
  	    if (!existing && requestedType === "Employee") return buildEssentialEmployeePayload(form);

  	    const data = new FormData(form);
  	    const type = clean(data.get("AccountType")) === "Employee" ? "Employee" : "Director";
  	    const firstName = clean(data.get("FirstName"));
  	    const lastName = clean(data.get("LastName"));
  	    const email = lower(data.get("Email"));
  	    const phone = clean(data.get("Phone"));
  	    const idNumber = normalizeIdNumber(data.get("IdNumber"));
  	    const userStatus = clean(data.get("UserStatus")).toUpperCase() || "ENABLED";
  	    const password = clean(data.get("Password"));
  	    const confirmPassword = clean(data.get("ConfirmPassword"));
  	    const creating = !existing;

  	    if (!firstName) throw new Error("First name is required.");
  	    if (!lastName) throw new Error("Last name is required.");
  	    if (!email) throw new Error("Email is required.");
  	    if (!/^\d{13}$/.test(idNumber)) throw new Error("South African ID must contain exactly 13 digits.");
  	    if (existing && objectId(existing) !== idNumber) throw new Error("The South African ID cannot be changed because it is the permanent Users objectId.");
  	    if (creating) {
  	      if (password.length < 8) throw new Error("The temporary password must contain at least 8 characters.");
  	      if (password !== confirmPassword) throw new Error("Password and Confirm password must match exactly.");
  	    }
  	    if (OPTIONS.UserStatus.indexOf(userStatus) === -1) throw new Error("Select a valid login status.");

  	    let apps = selectedFormValues(form, "APP");
  	    let office = selectedFormValues(form, "Office");
  	    let settings = selectedFormValues(form, "Settings");
  	    let operationalRoles = type === "Employee" ? selectedFormValues(form, "OperationalRole") : [];
  	    let home = clean(data.get("Home"));

  	    const existingUser = existing || {};
  	    apps = unique(unmanagedValues(existingUser.APP, OPTIONS.APP).concat(apps));
  	    office = unique(unmanagedValues(existingUser.Office, OPTIONS.Office).concat(office));
  	    settings = unique(unmanagedValues(existingUser.Settings, OPTIONS.Settings).concat(settings));
  	    if (type === "Employee") {
  	      operationalRoles = unique(operationalRoles).filter(function (role) {
  	        return OPTIONS.OperationalRole.some(function (option) {
  	          return lower(option) === lower(role);
  	        });
  	      });
  	    } else {
  	      operationalRoles = [];
  	    }

  	    if (apps.indexOf("Office") === -1) {
  	      office = [];
  	      settings = [];
  	      home = "";
  	    } else {
  	      if (office.indexOf("Dash") === -1) settings = [];
  	      if (office.indexOf(home) === -1) {
  	        if (office.length) throw new Error("Choose one assigned Office module as the Home screen.");
  	        home = "";
  	      }
  	    }

  	    const wrapper = userDataDetails(existingUser);
  	    const details = merge(defaultEmployeeDetails(), wrapper.employee_details || {});
  	    details.first_name = firstName;
  	    details.last_name = lastName;
  	    details.id_number = idNumber;
  	    details.account_type = type;
  	    details.operational_roles = type === "Employee" ? operationalRoles : [];
  	    details.contact_details = merge(defaultEmployeeDetails().contact_details, details.contact_details || {});
  	    details.contact_details.email = email;
  	    details.contact_details.phone_number = phone;
  	    details.audit = arr(details.audit);
  	    details.audit.push(auditEntry(existing ? type + " updated" : type + " created"));
  	    if (details.audit.length > 200) details.audit = details.audit.slice(-200);

  	    const wages = parseJsonLoose(existingUser.Data_Wages, defaultWages());
  	    if (wages && wages.wage_rates) wages.wage_rates.employee_id = clean(details.employee_id);

  	    const payload = {
  	      objectId: idNumber,
  	      ownerId: idNumber,
  	      ID: idNumber,
  	      email: email,
  	      name: [firstName, lastName].join(" ").trim(),
  	      APP: storageValue(existingUser.APP, apps),
  	      Office: storageValue(existingUser.Office, office),
  	      Settings: storageValue(existingUser.Settings, settings),
  	      Role: type === "Director" ? DIRECTOR_ROLE_VALUE : EMPLOYEE_ROLE_VALUE,
  	      userStatus: userStatus,
  	      Data_Details: merge(isObject(wrapper) ? wrapper : {}, { employee_details: details }),
  	      Data_Wages: wages
  	    };
  	    if (home) payload.Home = home;
  	    else if (existing) payload.Home = null;
  	    if (!existing) payload.Local_Key = clean(existingUser.Local_Key) || generateUserLocalKey();

  	    return {
  	      creating: creating,
  	      payload: payload,
  	      password: password,
  	      companyIds: selectedCompanyIdsFromForm(form),
  	      accountType: type
  	    };
  	  }

  	  async function registerUser(payload, password) {
  	    const api = ensureDatabase();
  	    if (!api.UserService || typeof api.UserService.register !== "function" || typeof api.User !== "function") {
  	      throw new Error("Login-user registration is unavailable in the current Database session.");
  	    }
  	    const cleanPayload = safeTopLevelPayload(payload, { keepOwner: true });
  	    const backendUser = new api.User();
  	    Object.keys(cleanPayload).forEach(function (key) {
  	      if (typeof backendUser.setProperty === "function") backendUser.setProperty(key, cleanPayload[key]);
  	      else backendUser[key] = cleanPayload[key];
  	    });
  	    if (typeof backendUser.setProperty === "function") backendUser.setProperty("password", password);
  	    backendUser.password = password;
  	    const registered = await api.UserService.register(backendUser);
  	    const saved = normalizeUser(Object.assign({}, cleanPayload, registered || {}));
  	    if (objectId(saved) !== payload.objectId) {
  	      throw new Error("The Users record was created with an unexpected objectId. Expected " + payload.objectId + " but received " + (objectId(saved) || "no objectId") + ".");
  	    }
  	    if (clean(saved.ownerId) !== payload.ownerId) {
  	      throw new Error("The Users record was created with an unexpected ownerId.");
  	    }
  	    if (clean(saved.ID) !== payload.ID) {
  	      throw new Error("The Users record was created with an unexpected ID value.");
  	    }
  	    return saved;
  	  }

  	  async function updateUser(payload) {
  	    const cleanPayload = safeTopLevelPayload(payload, { keepOwner: true });
  	    const saved = normalizeUser(Object.assign({}, cleanPayload, await saveRecord(TABLES.USERS, cleanPayload)));
  	    if (objectId(saved) !== payload.objectId || clean(saved.ownerId) !== payload.ownerId || clean(saved.ID) !== payload.ID) {
  	      throw new Error("The Users record did not retain objectId, ownerId and ID equal to the South African ID.");
  	    }
  	    return saved;
  	  }

  	  function employeeCompanyLoginGuardFromUser(user) {
  	    const wrapper = userDataDetails(user);
  	    const details = merge(defaultEmployeeDetails(), wrapper.employee_details || {});
  	    if (!isObject(details.access_control)) details.access_control = {};
  	    return { wrapper: wrapper, details: details, guard: details.access_control };
  	  }

  	  function prepareEmployeeNoCompanyLoginLock(payload, existing) {
  	    if (!payload || !existing || !isEmployeeProfile(existing)) return payload;
  	    const prepared = employeeCompanyLoginGuardFromUser(payload);
  	    const sourceStatus = clean(existing.userStatus).toUpperCase() === "DISABLED" ? "DISABLED" : "ENABLED";

  	    if (sourceStatus !== "DISABLED") {
  	      prepared.guard.company_membership_login_disabled = true;
  	      prepared.guard.status_before_company_unlink = sourceStatus;
  	      prepared.guard.company_membership_login_disabled_at = new Date().toISOString();
  	    }

  	    payload.userStatus = "DISABLED";
  	    payload.Data_Details = merge(isObject(prepared.wrapper) ? prepared.wrapper : {}, { employee_details: prepared.details });
  	    return payload;
  	  }

  	  async function applyEmployeeCompanyLoginState(user, hasCompanies) {
  	    if (!user || !objectId(user) || !isEmployeeProfile(user)) return normalizeUser(user || {});

  	    let normalized = normalizeUser(user);
  	    const prepared = employeeCompanyLoginGuardFromUser(normalized);
  	    const guard = prepared.guard;
  	    const currentStatus = clean(normalized.userStatus).toUpperCase() === "DISABLED" ? "DISABLED" : "ENABLED";
  	    let nextStatus = currentStatus;
  	    let mustSave = false;

  	    if (!hasCompanies) {
  	      if (currentStatus !== "DISABLED") {
  	        guard.company_membership_login_disabled = true;
  	        guard.status_before_company_unlink = currentStatus;
  	        guard.company_membership_login_disabled_at = new Date().toISOString();
  	        mustSave = true;
  	      }
  	      nextStatus = "DISABLED";
  	      if (currentStatus !== nextStatus) mustSave = true;
  	    } else if (guard.company_membership_login_disabled === true) {
  	      nextStatus = clean(guard.status_before_company_unlink).toUpperCase() === "DISABLED" ? "ENABLED" : (clean(guard.status_before_company_unlink).toUpperCase() || "ENABLED");
  	      guard.company_membership_login_disabled = false;
  	      guard.company_membership_login_restored_at = new Date().toISOString();
  	      delete guard.status_before_company_unlink;
  	      mustSave = true;
  	    }

  	    normalized.userStatus = nextStatus;
  	    normalized.Data_Details = merge(isObject(prepared.wrapper) ? prepared.wrapper : {}, { employee_details: prepared.details });
  	    if (!mustSave) return normalized;

  	    const patch = {
  	      objectId: objectId(normalized),
  	      userStatus: nextStatus,
  	      Data_Details: normalized.Data_Details
  	    };
  	    const savedPatch = await saveRecord(TABLES.USERS, patch);
  	    normalized = normalizeUser(Object.assign({}, normalized, savedPatch || patch));
  	    applyUserStatusLocally(objectId(normalized), nextStatus);
  	    return normalized;
  	  }

  	  async function syncUserCompanies(user, desiredCompanies) {
  	    const userId = objectId(user);
  	    if (!userId) throw new Error("The saved user has no Database objectId.");

  	    const currentRows = (await loadRelation(TABLES.USERS, userId, RELATIONS.USER_COMPANIES)).map(normalizeCompany);
  	    const currentIds = new Set(currentRows.map(objectId).filter(Boolean));
  	    const desired = arr(desiredCompanies).map(normalizeCompany);
  	    const desiredIds = new Set(desired.map(objectId).filter(Boolean));
  	    const removedIds = [];
  	    let workingUser = normalizeUser(user);

  	    // Employee Company membership is a hard login prerequisite.
  	    // Disable first, before the final Company relationship can be removed.
  	    if (isEmployeeProfile(workingUser) && desired.length === 0) {
  	      updateOperation("Disabling Employee login before removing the final Company...");
  	      workingUser = await applyEmployeeCompanyLoginState(workingUser, false);
  	    }

  	    for (const company of desired) {
  	      const companyId = objectId(company);
  	      if (!companyId) throw new Error(companyName(company) + " has no Database objectId.");
  	      if (!currentIds.has(companyId)) {
  	        await addRelation(TABLES.USERS, userId, RELATIONS.USER_COMPANIES, companyId);
  	      }
  	      await addRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_EMPLOYEES, userId);
  	    }

  	    for (const company of currentRows) {
  	      const companyId = objectId(company);
  	      if (!desiredIds.has(companyId)) {
  	        await deleteRelation(TABLES.USERS, userId, RELATIONS.USER_COMPANIES, companyId);
  	        await deleteRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_EMPLOYEES, userId);
  	        removedIds.push(companyId);
  	      }
  	    }

  	    updateOperation("Verifying Users.Companies and Companies.Employees...");
  	    const verifiedUserCompanies = await loadRelation(TABLES.USERS, userId, RELATIONS.USER_COMPANIES);
  	    const verifiedIds = new Set(verifiedUserCompanies.map(objectId).filter(Boolean));
  	    const missing = desired.filter(function (company) { return !verifiedIds.has(objectId(company)); });
  	    const extra = verifiedUserCompanies.filter(function (company) { return !desiredIds.has(objectId(company)); });
  	    if (missing.length) throw new Error("Users.Companies verification failed for: " + missing.map(companyName).join(", ") + ".");
  	    if (extra.length) throw new Error("Users.Companies still contains removed companies: " + extra.map(companyName).join(", ") + ".");

  	    for (const company of desired) {
  	      const employeeRows = await loadRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_EMPLOYEES);
  	      if (!employeeRows.some(function (row) { return objectId(row) === userId; })) {
  	        throw new Error("Companies.Employees verification failed for " + companyName(company) + ".");
  	      }
  	    }

  	    for (const companyId of removedIds) {
  	      const employeeRows = await loadRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_EMPLOYEES);
  	      if (employeeRows.some(function (row) { return objectId(row) === userId; })) {
  	        throw new Error("Companies.Employees still contains the user after removal from " + companyName(companyById(companyId)) + ".");
  	      }
  	    }

  	    workingUser.Companies = desired;

  	    // Restore only after a real Company link has been written and verified,
  	    // and only when the account was automatically disabled by this rule.
  	    if (isEmployeeProfile(workingUser) && desired.length > 0) {
  	      updateOperation("Applying Employee Company login state...");
  	      workingUser = await applyEmployeeCompanyLoginState(workingUser, true);
  	      workingUser.Companies = desired;
  	    }

  	    return { user: workingUser, companies: desired, removedCompanyIds: removedIds };
  	  }

  	  async function saveUserFromModal(options) {
  	    const settings = options || {};
  	    const form = state.root.querySelector('[data-form="user"]');
  	    if (!form) throw new Error("The user form is unavailable.");
  	    const existingId = clean(form.elements.namedItem("ExistingObjectId") && form.elements.namedItem("ExistingObjectId").value);
  	    const existing = existingId ? userById(existingId) : null;
  	    const data = buildUserPayload(form, existing);
  	    let companies = data.companyIds.map(companyById);
  	    if (companies.some(function (company) { return !company; })) throw new Error("One or more selected companies are no longer available.");
  	    if (settings.createCompanyAfterSave && data.accountType !== "Director") {
  	      throw new Error("The Create Company workflow is available only while saving a Director.");
  	    }

  	    // New Employee: identity-first recovery. An existing Employee Users record is
  	    // retained exactly as-is and only the requested Company links are added.
  	    if (!existing && data.accountType === "Employee") {
  	      const identity = normalizeIdNumber(data.payload.objectId);
  	      if (!/^\d{13}$/.test(identity)) throw new Error("South African ID must contain exactly 13 digits.");
  	      const recoveredRaw = await findUserByIdentity(identity);

  	      if (recoveredRaw) {
  	        let recovered = normalizeUser(recoveredRaw);
  	        if (isAdminProfile(recovered)) {
  	          throw new Error("That South African ID already belongs to a Director account and cannot be re-created as an Employee.");
  	        }
  	        if (!companies.length) throw new Error("Select at least one Company before re-linking the existing Employee.");

  	        const currentCompanies = (await loadRelation(TABLES.USERS, objectId(recovered), RELATIONS.USER_COMPANIES)).map(normalizeCompany);
  	        const combined = currentCompanies.slice();
  	        companies.forEach(function (company) {
  	          if (!combined.some(function (item) { return objectId(item) === objectId(company); })) combined.push(company);
  	        });

  	        if (typeof window !== "undefined" && typeof window.confirm === "function") {
  	          const confirmed = window.confirm(
  	            "Existing Employee Found\n\n" +
  	            userName(recovered) + " already exists with South African ID " + identity + ".\n\n" +
  	            "Fleet In Form will keep the existing login, password, permissions, HR, payroll, leave and historical data and add only the selected Company link(s).\n\nContinue?"
  	          );
  	          if (!confirmed) return null;
  	        }

  	        beginOperation("Linking existing Employee...");
  	        try {
  	          updateOperation("Creating Company relationship and restoring login access...");
  	          const relationResult = await syncUserCompanies(recovered, combined);
  	          recovered = reconcileUser(relationResult.user, relationResult.companies, relationResult.removedCompanyIds);
  	          endOperation();
  	          closeModal();
  	          render();
  	          showToast(userName(recovered) + " was found by South African ID and linked without replacing existing Employee data.", "success", 7000);
  	          return recovered;
  	        } catch (error) {
  	          failOperation(error);
  	          throw error;
  	        }
  	      }

  	      validateEssentialEmployeeCreate(data);
  	    }

  	    // Existing Employee may be deliberately unlinked from every Company. Preserve
  	    // the Users record and force the login disabled in the same save that stores
  	    // any profile edits, before relationship deletion begins.
  	    if (existing && data.accountType === "Employee" && companies.length === 0) {
  	      prepareEmployeeNoCompanyLoginLock(data.payload, existing);
  	    }

  	    beginOperation(data.creating ? "Registering " + data.accountType + "..." : "Saving " + data.accountType + "...");
  	    let saved = null;
  	    try {
  	      await assertUserUnique(data.payload.email, data.payload.objectId, existingId);
  	      saved = data.creating ? await registerUser(data.payload, data.password) : await updateUser(data.payload);
  	      reconcileUser(saved, existing ? existing.Companies : [], []);
  	      updateOperation("Synchronising company relationships...");
  	      const relationResult = await syncUserCompanies(saved, companies);
  	      saved = reconcileUser(relationResult.user, relationResult.companies, relationResult.removedCompanyIds);
  	      endOperation();

  	      if (settings.createCompanyAfterSave) {
  	        openCompanyModal(null, objectId(saved));
  	        showToast(userName(saved) + " was saved. Create the Company to link it to this Director.", "success", 6500);
  	      } else {
  	        closeModal();
  	        render();
  	        const noCompanyNote = data.accountType === "Employee" && !relationResult.companies.length
  	          ? " Login disabled because the Employee has no Company links; the Users record and all historical data were retained."
  	          : "";
  	        showToast(userName(saved) + (data.creating ? " was created." : " was updated.") + noCompanyNote, "success", noCompanyNote ? 7500 : 4500);
  	      }
  	      return saved;
  	    } catch (error) {
  	      failOperation(error);
  	      if (saved) {
  	        reconcileUser(saved, existing ? existing.Companies : [], []);
  	        render();
  	        showToast("The user record was saved, but one or more company relationships were not completed. Reopen the user and retry. " + clean(error.message || error), "error", 9000);
  	        return saved;
  	      }
  	      throw error;
  	    }
  	  }

  	  function applyUserStatusLocally(userId, status) {
  	    const id = clean(userId);
  	    const value = clean(status).toUpperCase() === "DISABLED" ? "DISABLED" : "ENABLED";
  	    function apply(record) {
  	      if (record && objectId(record) === id) record.userStatus = value;
  	    }
  	    state.users.forEach(apply);
  	    arr(APP_DATA && APP_DATA.Users).forEach(apply);
  	    arr(APP_DATA && APP_DATA.Employees).forEach(apply);
  	    state.companies.forEach(function (company) { arr(company.Employees).forEach(apply); });
  	    arr(APP_DATA && APP_DATA.Companies).forEach(function (company) { arr(company.Employees).forEach(apply); });
  	    arr(APP_DATA && APP_DATA.User && APP_DATA.User.Companies).forEach(function (company) { arr(company.Employees).forEach(apply); });
  	    apply(APP_DATA && APP_DATA.User);
  	  }

  	  async function saveUserStatusOnly(user, status) {
  	    if (!user || !objectId(user)) throw new Error("The selected user is unavailable.");
  	    const value = clean(status).toUpperCase() === "DISABLED" ? "DISABLED" : "ENABLED";
  	    const saved = await saveRecord(TABLES.USERS, { objectId: objectId(user), userStatus: value });
  	    applyUserStatusLocally(objectId(user), value);
  	    return normalizeUser(Object.assign({}, user, saved || {}, { userStatus: value }));
  	  }

  	  async function toggleEmployeeStatus(user) {
  	    if (!user || !objectId(user)) throw new Error("The selected Employee is unavailable.");
  	    const next = clean(user.userStatus).toUpperCase() === "DISABLED" ? "ENABLED" : "DISABLED";

  	    if (next === "ENABLED") {
  	      const linkedCompanies = await loadRelation(TABLES.USERS, objectId(user), RELATIONS.USER_COMPANIES);
  	      if (!linkedCompanies.length) {
  	        throw new Error("This Employee cannot be enabled because they are not linked to any Company. Link the Employee to a Company first.");
  	      }
  	    }

  	    if (typeof window !== "undefined" && typeof window.confirm === "function") {
  	      if (!window.confirm((next === "DISABLED" ? "Disable " : "Enable ") + userName(user) + "?")) return null;
  	    }
  	    beginOperation("Updating Employee status...");
  	    try {
  	      let saved = await saveUserStatusOnly(user, next);
  	      if (next === "DISABLED") {
  	        // A manual disable must never be mistaken for the automatic no-Company lock.
  	        const prepared = employeeCompanyLoginGuardFromUser(saved);
  	        if (prepared.guard.company_membership_login_disabled !== true) {
  	          delete prepared.guard.status_before_company_unlink;
  	        }
  	        saved.Data_Details = merge(isObject(prepared.wrapper) ? prepared.wrapper : {}, { employee_details: prepared.details });
  	      }
  	      endOperation();
  	      render();
  	      showToast(userName(saved) + " is now " + (next === "DISABLED" ? "Disabled" : "Enabled") + ".", "success");
  	      return saved;
  	    } catch (error) {
  	      failOperation(error);
  	      throw error;
  	    }
  	  }

  	  async function toggleDirectorStatus(user) {
  	    if (!user || !objectId(user)) throw new Error("The selected Director is unavailable.");
  	    const next = clean(user.userStatus).toUpperCase() === "DISABLED" ? "ENABLED" : "DISABLED";
  	    const linkedCompanies = arr(user.Companies).map(normalizeCompany);
  	    const actionWord = next === "DISABLED" ? "disable" : "enable";
  	    if (typeof window !== "undefined" && typeof window.confirm === "function") {
  	      const message = "This will " + actionWord + " the Director and every user linked to " + linkedCompanies.length + " controlled compan" + (linkedCompanies.length === 1 ? "y" : "ies") + ". Continue?";
  	      if (!window.confirm(message)) return null;
  	    }

  	    beginOperation("Loading controlled Company users...");
  	    try {
  	      const byId = new Map();
  	      byId.set(objectId(user), user);
  	      for (const company of linkedCompanies) {
  	        updateOperation("Loading users for " + companyName(company) + "...");
  	        const employees = await loadRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_EMPLOYEES);
  	        employees.forEach(function (employee) {
  	          const id = objectId(employee);
  	          if (id) byId.set(id, employee);
  	        });
  	      }

  	      const queue = Array.from(byId.values());
  	      const total = queue.length;
  	      let completed = 0;
  	      const workers = [];
  	      const workerCount = Math.min(4, queue.length);
  	      async function worker() {
  	        while (queue.length) {
  	          const current = queue.shift();
  	          await saveUserStatusOnly(current, next);
  	          completed += 1;
  	          updateOperation((next === "DISABLED" ? "Disabling" : "Enabling") + " users " + completed + " of " + total + "...");
  	        }
  	      }
  	      for (let index = 0; index < workerCount; index += 1) workers.push(worker());
  	      await Promise.all(workers);
  	      endOperation();
  	      render();
  	      showToast(total + " user" + (total === 1 ? "" : "s") + " " + (next === "DISABLED" ? "disabled" : "enabled") + " across the Director's Companies.", "success", 7000);
  	      return { status: next, usersUpdated: total, companies: linkedCompanies.length };
  	    } catch (error) {
  	      failOperation(error);
  	      throw error;
  	    }
  	  }

  	  function relationArrayName(kind) {
  	    const base = baseAssetKind(kind);
  	    return base === "tractor" ? "Tractors" : base === "trailer" ? "Trailers" : "Tanks";
  	  }

  	  function addAssetToCompanyAliases(asset, companyId, kind) {
  	    const field = relationArrayName(kind);
  	    findCompanyEverywhere(companyId).forEach(function (company) {
  	      if (!Array.isArray(company[field])) company[field] = [];
  	      company[field] = upsertById(company[field], asset, function (row) { return normalizeAsset(row, kind); });
  	    });
  	  }

  	  function addLocationToCompanyAliases(location, companyId) {
  	    if (!location || !objectId(location)) return;
  	    findCompanyEverywhere(companyId).forEach(function (company) {
  	      if (!Array.isArray(company.Locations)) company.Locations = [];
  	      company.Locations = upsertById(company.Locations, location, function (row) { return clone(row); });
  	    });
  	  }

  	  function removeAssetFromCompanyAliases(assetId, companyId, kind) {
  	    const field = relationArrayName(kind);
  	    findCompanyEverywhere(companyId).forEach(function (company) {
  	      if (Array.isArray(company[field])) {
  	        company[field] = company[field].filter(function (row) { return objectId(row) !== assetId; });
  	      }
  	    });
  	  }

  	  function removeLocationFromCompanyAliases(locationId, companyId) {
  	    if (!locationId) return;
  	    findCompanyEverywhere(companyId).forEach(function (company) {
  	      if (Array.isArray(company.Locations)) {
  	        company.Locations = company.Locations.filter(function (row) { return objectId(row) !== locationId; });
  	      }
  	    });
  	  }

  	  async function loadTankLocationForLink(tank) {
  	    if (!tank || !objectId(tank)) return null;
  	    if (tank.Location && objectId(tank.Location)) return tank.Location;
  	    const rows = await loadRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_LOCATION).catch(function () { return []; });
  	    tank.Location = rows[0] || null;
  	    return tank.Location;
  	  }

  	  async function linkExistingAsset(companyId, kind, assetId) {
  	    const company = companyById(companyId);
  	    const asset = globalAssetsForKind(kind).find(function (row) { return objectId(row) === assetId; });
  	    if (!company || !asset) throw new Error("The Company or asset is no longer available.");
  	    if (linkedAssetIds(kind).has(assetId)) throw new Error(assetLabel(asset, kind) + " is already linked to a Company.");
  	    updateOperation("Linking " + assetLabel(asset, kind) + "...");
  	    await addRelation(TABLES.COMPANIES, companyId, relationFieldForKind(kind), assetId);
  	    if (baseAssetKind(kind) === "tank") {
  	      const location = await loadTankLocationForLink(asset);
  	      if (location && objectId(location)) {
  	        await addRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_LOCATIONS, objectId(location));
  	        addLocationToCompanyAliases(location, companyId);
  	      }
  	    }
  	    addAssetToCompanyAliases(normalizeAsset(asset, kind), companyId, kind);
  	    return asset;
  	  }

  	  async function unlinkExistingAsset(companyId, kind, assetId) {
  	    const company = companyById(companyId);
  	    const asset = company && companyAssetsForKind(company, kind).find(function (row) { return objectId(row) === assetId; });
  	    if (!company || !asset) throw new Error("The Company or linked asset is no longer available.");
  	    updateOperation("Unlinking " + assetLabel(asset, kind) + "...");
  	    await deleteRelation(TABLES.COMPANIES, companyId, relationFieldForKind(kind), assetId);
  	    if (baseAssetKind(kind) === "tank") {
  	      const location = await loadTankLocationForLink(asset);
  	      if (location && objectId(location)) {
  	        await deleteRelation(TABLES.COMPANIES, companyId, RELATIONS.COMPANY_LOCATIONS, objectId(location));
  	        removeLocationFromCompanyAliases(objectId(location), companyId);
  	      }
  	    }
  	    removeAssetFromCompanyAliases(assetId, companyId, kind);
  	    return asset;
  	  }

  	  async function toggleCompanyStatus(company) {
  	    if (!company || !objectId(company)) throw new Error("The selected Company is unavailable.");
  	    const next = !companyIsActive(company);
  	    const manifest = normalizeCompanyManifest(company.Manifest);
  	    manifest.Profile.Status = next ? "ACTIVE" : "INACTIVE";
  	    manifest.Meta.UpdatedAt = nowIso();
  	    manifest.Meta.UpdatedBy = currentUserName();
  	    manifest.Audit = arr(manifest.Audit);
  	    manifest.Audit.push(auditEntry(next ? "Company activated" : "Company deactivated"));
  	    const saved = await saveRecord(TABLES.COMPANIES, { objectId: objectId(company), Status: next, Manifest: manifest });
  	    return reconcileCompany(saved);
  	  }

  	  function buildInitialTankView(ownerId) {
  	    const period = southAfricanMonthWindow(new Date());
  	    return {
  	      ownerId: clean(ownerId),
  	      DateStart: period.DateStart,
  	      DateEnd: period.DateEnd,
  	      MYearKey: period.MYearKey,
  	      MYear: period.MYear,
  	      Litres: 0,
  	      Cost: 0
  	    };
  	  }

  	  function buildInitialBowserView(ownerId, meter) {
  	    const period = southAfricanMonthWindow(new Date());
  	    const opening = Number(meter || 0);
  	    return {
  	      ownerId: clean(ownerId),
  	      DateStart: period.DateStart,
  	      DateEnd: period.DateEnd,
  	      MYearKey: period.MYearKey,
  	      MYear: period.MYear,
  	      Litres: 0,
  	      Cost: 0,
  	      MeterStart: opening,
  	      MeterEnd: opening
  	    };
  	  }

  	  function tankForCompany(companyId, tankId) {
  	    const company = companyById(companyId);
  	    if (!company) return null;
  	    return companyTanks(company).find(function (tank) {
  	      return objectId(tank) === clean(tankId);
  	    }) || state.tanks.find(function (tank) {
  	      return objectId(tank) === clean(tankId);
  	    }) || null;
  	  }

  	  function bowserNameExists(tank, name) {
  	    const wanted = lower(name);
  	    return arr(tank && tank.Bowsers).some(function (bowser) {
  	      return lower(bowser && bowser.Name) === wanted;
  	    });
  	  }

  	  function locationPolygonPoints(location) {
  	    if (!location || typeof location !== "object") return [];

  	    const polygon = location.Polygon || location.polygon;
  	    const ring = polygon && Array.isArray(polygon.coordinates) && polygon.coordinates[0];
  	    let points = [];

  	    if (Array.isArray(ring)) {
  	      points = ring.map(function (coordinate) {
  	        if (!Array.isArray(coordinate) || coordinate.length < 2) return null;
  	        const lng = Number(coordinate[0]);
  	        const lat = Number(coordinate[1]);
  	        return Number.isFinite(lat) && Number.isFinite(lng) ? { lat: lat, lng: lng } : null;
  	      }).filter(Boolean);
  	    }

  	    if (!points.length) {
  	      const geometry = location.LocationData && location.LocationData.Geometry;
  	      const source = geometry && (geometry.resolvedPoints || geometry.rawPoints);
  	      points = arr(source).map(function (point) {
  	        const lat = Number(point && (point.lat !== undefined ? point.lat : point.latitude));
  	        const lng = Number(point && (
  	          point.lng !== undefined ? point.lng :
  	          point.lon !== undefined ? point.lon :
  	          point.longitude
  	        ));
  	        return Number.isFinite(lat) && Number.isFinite(lng) ? { lat: lat, lng: lng } : null;
  	      }).filter(Boolean);
  	    }

  	    if (points.length > 1) {
  	      const first = points[0];
  	      const last = points[points.length - 1];
  	      if (Math.abs(first.lat - last.lat) < 1e-12 && Math.abs(first.lng - last.lng) < 1e-12) {
  	        points.pop();
  	      }
  	    }

  	    return points;
  	  }

  	  function createEmptyTankLocationDraft() {
  	    return {
  	      map: null,
  	      polygon: null,
  	      vertexMarkers: [],
  	      mapClickListener: null,
  	      pathListeners: [],
  	      points: [],
  	      areaM2: 0,
  	      mounted: false,
  	      companyId: "",
  	      tankId: "",
  	      mode: "create",
  	      existingLocation: null,
  	      host: null
  	    };
  	  }

  	  function googleMapsIsReady() {
  	    return typeof window !== "undefined" &&
  	      window.google &&
  	      window.google.maps &&
  	      typeof window.google.maps.Map === "function" &&
  	      typeof window.google.maps.Polygon === "function";
  	  }

  	  function clearGoogleListener(listener) {
  	    try {
  	      if (listener && typeof listener.remove === "function") listener.remove();
  	      else if (listener && window.google && window.google.maps && window.google.maps.event) {
  	        window.google.maps.event.removeListener(listener);
  	      }
  	    } catch (_) {}
  	  }

  	  function clearTankVertexMarkers(draft) {
  	    arr(draft && draft.vertexMarkers).forEach(function (marker) {
  	      try { marker.setMap(null); } catch (_) {}
  	    });
  	    if (draft) draft.vertexMarkers = [];
  	  }

  	  function destroyTankLocationDraft() {
  	    const draft = state.tankLocationDraft;
  	    if (!draft) return;
  	    clearGoogleListener(draft.mapClickListener);
  	    arr(draft.pathListeners).forEach(clearGoogleListener);
  	    clearTankVertexMarkers(draft);
  	    try {
  	      if (draft.polygon) draft.polygon.setMap(null);
  	    } catch (_) {}
  	    state.tankLocationDraft = null;
  	  }

  	  function resetTankLocationDraft(companyId, options) {
  	    destroyTankLocationDraft();
  	    const settings = options || {};
  	    state.tankLocationDraft = createEmptyTankLocationDraft();
  	    state.tankLocationDraft.companyId = clean(companyId);
  	    state.tankLocationDraft.tankId = clean(settings.tankId);
  	    state.tankLocationDraft.mode = clean(settings.mode) || "create";
  	    state.tankLocationDraft.existingLocation = settings.location && typeof settings.location === "object"
  	      ? clone(settings.location)
  	      : null;
  	    state.tankLocationDraft.points = locationPolygonPoints(state.tankLocationDraft.existingLocation);
  	    return state.tankLocationDraft;
  	  }

  	  async function ensureGoogleMapsForTank() {
  	    if (googleMapsIsReady()) return window.google.maps;

  	    if (typeof window === "undefined") {
  	      throw new Error("Google Maps requires a browser window.");
  	    }

  	    if (window.__fifManagerGoogleMapsPromise) {
  	      await window.__fifManagerGoogleMapsPromise;
  	      if (!googleMapsIsReady()) throw new Error("Google Maps did not finish loading.");
  	      return window.google.maps;
  	    }

  	    const key = googleMapsApiKey();
  	    if (!key) {
  	      throw new Error(
  	        "Google Maps is not loaded. Add a browser-restricted GoogleMapsApiKey input to this Custom Code block."
  	      );
  	    }

  	    window.__fifManagerGoogleMapsPromise = new Promise(function (resolve, reject) {
  	      const callbackName = "__fifManagerGoogleMapsReady_" + Date.now().toString(36);
  	      const timeout = window.setTimeout(function () {
  	        cleanup();
  	        reject(new Error("Google Maps loading timed out."));
  	      }, 20000);

  	      function cleanup() {
  	        window.clearTimeout(timeout);
  	        try { delete window[callbackName]; } catch (_) { window[callbackName] = undefined; }
  	      }

  	      window[callbackName] = function () {
  	        cleanup();
  	        resolve(window.google && window.google.maps);
  	      };

  	      const script = document.createElement("script");
  	      script.async = true;
  	      script.defer = true;
  	      script.src =
  	        "https://maps.googleapis.com/maps/api/js?key=" +
  	        encodeURIComponent(key) +
  	        "&libraries=geometry&loading=async&callback=" +
  	        encodeURIComponent(callbackName);
  	      script.onerror = function () {
  	        cleanup();
  	        reject(new Error("Google Maps could not be loaded. Check the browser key and its website restrictions."));
  	      };
  	      document.head.appendChild(script);
  	    });

  	    try {
  	      await window.__fifManagerGoogleMapsPromise;
  	    } catch (error) {
  	      window.__fifManagerGoogleMapsPromise = null;
  	      throw error;
  	    }

  	    if (!googleMapsIsReady()) throw new Error("Google Maps loaded without the Map and Polygon libraries.");
  	    return window.google.maps;
  	  }

  	  function locationPlainPoint(location) {
  	    if (!location || typeof location !== "object") return null;

  	    const candidates = [
  	      location.Centre,
  	      location.Center,
  	      location.centre,
  	      location.center,
  	      location.LocationData && location.LocationData.Area && location.LocationData.Area.Center
  	    ];

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const value = candidates[index];
  	      if (!value) continue;

  	      if (Array.isArray(value.coordinates) && value.coordinates.length >= 2) {
  	        const lng = Number(value.coordinates[0]);
  	        const lat = Number(value.coordinates[1]);
  	        if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat: lat, lng: lng };
  	      }

  	      const lat = Number(value.lat !== undefined ? value.lat : value.latitude);
  	      const lng = Number(
  	        value.lng !== undefined ? value.lng :
  	        value.lon !== undefined ? value.lon :
  	        value.longitude
  	      );
  	      if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat: lat, lng: lng };
  	    }

  	    const polygon = location.Polygon || location.polygon;
  	    const ring = polygon && Array.isArray(polygon.coordinates) && polygon.coordinates[0];
  	    if (Array.isArray(ring) && ring.length) {
  	      let latTotal = 0;
  	      let lngTotal = 0;
  	      let count = 0;
  	      ring.forEach(function (point) {
  	        if (!Array.isArray(point) || point.length < 2) return;
  	        const lng = Number(point[0]);
  	        const lat = Number(point[1]);
  	        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
  	        latTotal += lat;
  	        lngTotal += lng;
  	        count += 1;
  	      });
  	      if (count) return { lat: latTotal / count, lng: lngTotal / count };
  	    }

  	    return null;
  	  }

  	  function initialTankMapPosition(company) {
  	    const candidates = [];
  	    arr(company && company.Locations).forEach(function (location) { candidates.push(location); });
  	    companyTanks(company).forEach(function (tank) {
  	      if (tank && tank.Location) candidates.push(tank.Location);
  	    });

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const point = locationPlainPoint(candidates[index]);
  	      if (point) return { center: point, zoom: 18 };
  	    }

  	    return {
  	      center: { lat: -30.5595, lng: 22.9375 },
  	      zoom: 5
  	    };
  	  }

  	  function tankDraftPoints() {
  	    const draft = state.tankLocationDraft;
  	    if (!draft || !draft.polygon) return arr(draft && draft.points).map(function (point) { return clone(point); });

  	    const path = typeof draft.polygon.getPath === "function" ? draft.polygon.getPath() : null;
  	    if (!path || typeof path.getLength !== "function" || typeof path.getAt !== "function") {
  	      return arr(draft.points).map(function (point) { return clone(point); });
  	    }

  	    const points = [];
  	    for (let index = 0; index < path.getLength(); index += 1) {
  	      const point = path.getAt(index);
  	      const lat = Number(point.lat());
  	      const lng = Number(point.lng());
  	      if (Number.isFinite(lat) && Number.isFinite(lng)) points.push({ lat: lat, lng: lng });
  	    }
  	    return points;
  	  }

  	  function sphericalPolygonAreaM2(points) {
  	    const cleanPoints = arr(points).filter(function (point) {
  	      return point && Number.isFinite(Number(point.lat)) && Number.isFinite(Number(point.lng));
  	    });
  	    if (cleanPoints.length < 3) return 0;

  	    try {
  	      if (
  	        window.google &&
  	        window.google.maps &&
  	        window.google.maps.geometry &&
  	        window.google.maps.geometry.spherical &&
  	        typeof window.google.maps.geometry.spherical.computeArea === "function"
  	      ) {
  	        return Math.abs(window.google.maps.geometry.spherical.computeArea(cleanPoints));
  	      }
  	    } catch (_) {}

  	    const radius = 6378137;
  	    const toRad = function (degrees) { return Number(degrees) * Math.PI / 180; };
  	    let sum = 0;
  	    for (let index = 0; index < cleanPoints.length; index += 1) {
  	      const first = cleanPoints[index];
  	      const second = cleanPoints[(index + 1) % cleanPoints.length];
  	      sum +=
  	        toRad(second.lng - first.lng) *
  	        (2 + Math.sin(toRad(first.lat)) + Math.sin(toRad(second.lat)));
  	    }
  	    return Math.abs(sum * radius * radius / 2);
  	  }

  	  function polygonCentre(points) {
  	    const cleanPoints = arr(points);
  	    if (!cleanPoints.length) return null;
  	    let lat = 0;
  	    let lng = 0;
  	    cleanPoints.forEach(function (point) {
  	      lat += Number(point.lat);
  	      lng += Number(point.lng);
  	    });
  	    return { lat: lat / cleanPoints.length, lng: lng / cleanPoints.length };
  	  }

  	  function removeTankDraftPoint(draft, index) {
  	    if (!draft || !draft.polygon) return;
  	    const points = tankDraftPoints();
  	    if (index < 0 || index >= points.length) return;
  	    points.splice(index, 1);
  	    draft.points = points;
  	    draft.polygon.setPath(points);
  	    bindTankPolygonPath(draft);
  	    updateTankLocationMapUi();
  	  }

  	  function syncTankVertexMarkers(draft) {
  	    if (!draft || !draft.map || !draft.polygon || !googleMapsIsReady()) return;
  	    clearTankVertexMarkers(draft);

  	    const points = tankDraftPoints();
  	    points.forEach(function (point, index) {
  	      const marker = new window.google.maps.Circle({
  	        map: draft.map,
  	        center: point,
  	        radius: 1.35,
  	        draggable: true,
  	        clickable: true,
  	        strokeColor: "#ffffff",
  	        strokeOpacity: 1,
  	        strokeWeight: 2,
  	        fillColor: "#c36b36",
  	        fillOpacity: 1,
  	        zIndex: 30
  	      });

  	      marker.addListener("dragend", function () {
  	        const center = marker.getCenter && marker.getCenter();
  	        if (!center) return;
  	        const path = draft.polygon.getPath && draft.polygon.getPath();
  	        if (!path || typeof path.setAt !== "function") return;
  	        path.setAt(index, center);
  	      });

  	      marker.addListener("rightclick", function () {
  	        removeTankDraftPoint(draft, index);
  	      });

  	      draft.vertexMarkers.push(marker);
  	    });
  	  }

  	  function updateTankLocationMapUi() {
  	    const draft = state.tankLocationDraft;
  	    if (!draft) return;

  	    draft.points = tankDraftPoints();
  	    draft.areaM2 = sphericalPolygonAreaM2(draft.points);
  	    syncTankVertexMarkers(draft);

  	    const root = state.root;
  	    const pointNode = root && root.querySelector("[data-tank-map-points]");
  	    const areaNode = root && root.querySelector("[data-tank-map-area]");
  	    const statusNode = root && root.querySelector("[data-tank-map-status]");
  	    const saveButton = root && root.querySelector('[data-action="save-tank"], [data-action="save-tank-location"]');

  	    if (pointNode) pointNode.textContent = String(draft.points.length);
  	    if (areaNode) {
  	      areaNode.textContent = draft.areaM2 > 0
  	        ? draft.areaM2.toFixed(2) + " m² · " + (draft.areaM2 / 10000).toFixed(4) + " ha"
  	        : "0 m²";
  	    }

  	    const ready = draft.points.length >= 3 && draft.areaM2 > 0;
  	    const optionalCreateLocation = draft.mode === "create" && state.modal && state.modal.kind === "tank";
  	    const partialPolygon = draft.points.length > 0 && !ready;
  	    if (statusNode) {
  	      if (ready) {
  	        statusNode.textContent = draft.mode === "edit"
  	          ? "Location ready. Drag an orange point to edit it, or save the Location."
  	          : "Optional polygon ready. Drag an orange point to refine it, or create the Tank.";
  	      } else if (optionalCreateLocation && !draft.points.length) {
  	        statusNode.textContent = "Location is optional. Leave the map blank to create the Tank without a Location, or click the map to draw one.";
  	      } else if (optionalCreateLocation && partialPolygon) {
  	        statusNode.textContent = "Finish the polygon with at least three points, or Clear it to create the Tank without a Location.";
  	      } else {
  	        statusNode.textContent = "Click the map to add points. Drag an orange point to move it; right-click a point to remove it.";
  	      }
  	      statusNode.classList.toggle("ready", ready || (optionalCreateLocation && !draft.points.length));
  	    }
  	    if (saveButton) saveButton.disabled = optionalCreateLocation ? partialPolygon : !ready;
  	  }

  	  function fitTankDraftPolygon() {
  	    const draft = state.tankLocationDraft;
  	    if (!draft || !draft.map || !draft.polygon) return;
  	    const points = tankDraftPoints();
  	    if (!points.length) return;
  	    const bounds = new window.google.maps.LatLngBounds();
  	    points.forEach(function (point) { bounds.extend(point); });
  	    draft.map.fitBounds(bounds, 60);
  	  }

  	  function bindTankPolygonPath(draft) {
  	    arr(draft && draft.pathListeners).forEach(clearGoogleListener);
  	    if (!draft) return;
  	    draft.pathListeners = [];
  	    const path = draft.polygon && typeof draft.polygon.getPath === "function" ? draft.polygon.getPath() : null;
  	    if (!path || typeof path.addListener !== "function") return;
  	    ["insert_at", "set_at", "remove_at"].forEach(function (eventName) {
  	      draft.pathListeners.push(path.addListener(eventName, updateTankLocationMapUi));
  	    });
  	  }

  	  function handleTankMapControl(action) {
  	    const draft = state.tankLocationDraft;
  	    if (!draft || !draft.map || !draft.polygon) return;

  	    if (action === "undo") {
  	      const points = tankDraftPoints();
  	      if (points.length) points.pop();
  	      draft.points = points;
  	      draft.polygon.setPath(points);
  	      bindTankPolygonPath(draft);
  	      updateTankLocationMapUi();
  	      return;
  	    }

  	    if (action === "clear") {
  	      draft.points = [];
  	      draft.polygon.setPath([]);
  	      bindTankPolygonPath(draft);
  	      updateTankLocationMapUi();
  	      return;
  	    }

  	    if (action === "fit") {
  	      fitTankDraftPolygon();
  	      return;
  	    }

  	    if (action === "locate") {
  	      if (!navigator.geolocation) {
  	        showToast("Browser location is unavailable.", "error", 5000);
  	        return;
  	      }
  	      navigator.geolocation.getCurrentPosition(function (position) {
  	        const point = {
  	          lat: Number(position.coords.latitude),
  	          lng: Number(position.coords.longitude)
  	        };
  	        draft.map.panTo(point);
  	        draft.map.setZoom(19);
  	      }, function (error) {
  	        showToast(clean(error && error.message) || "Your position could not be read.", "error", 6000);
  	      }, {
  	        enableHighAccuracy: true,
  	        timeout: 12000,
  	        maximumAge: 30000
  	      });
  	    }
  	  }

  	  async function mountTankLocationMap() {
  	    if (!state.modal || (state.modal.kind !== "tank" && state.modal.kind !== "tank-location")) return;

  	    const host = state.root && state.root.querySelector("[data-tank-location-map]");
  	    if (!host) return;

  	    let draft = state.tankLocationDraft;
  	    if (!draft || draft.companyId !== clean(state.modal.companyId)) {
  	      const selectedTank = state.modal.kind === "tank-location"
  	        ? tankForCompany(state.modal.companyId, state.modal.tankId)
  	        : null;
  	      draft = resetTankLocationDraft(state.modal.companyId, {
  	        mode: selectedTank && selectedTank.Location ? "edit" : state.modal.kind === "tank-location" ? "add" : "create",
  	        tankId: selectedTank ? objectId(selectedTank) : "",
  	        location: selectedTank && selectedTank.Location ? selectedTank.Location : null
  	      });
  	    }

  	    if (draft.mounted && draft.host === host && draft.map) return;

  	    const status = state.root.querySelector("[data-tank-map-status]");
  	    try {
  	      if (status) status.textContent = "Loading Google Map...";
  	      await ensureGoogleMapsForTank();

  	      if (!state.modal || (state.modal.kind !== "tank" && state.modal.kind !== "tank-location") || !document.body.contains(host)) return;

  	      const company = companyById(state.modal.companyId);
  	      const initial = draft.points.length
  	        ? { center: polygonCentre(draft.points), zoom: 19 }
  	        : initialTankMapPosition(company);

  	      draft.host = host;
  	      draft.map = new window.google.maps.Map(host, {
  	        center: initial.center,
  	        zoom: initial.zoom,
  	        mapTypeId: "hybrid",
  	        clickableIcons: false,
  	        streetViewControl: false,
  	        rotateControl: false,
  	        mapTypeControl: true,
  	        fullscreenControl: true,
  	        gestureHandling: "greedy"
  	      });

  	      draft.polygon = new window.google.maps.Polygon({
  	        map: draft.map,
  	        paths: draft.points,
  	        editable: false,
  	        draggable: false,
  	        geodesic: true,
  	        strokeColor: "#c36b36",
  	        strokeOpacity: 1,
  	        strokeWeight: 3,
  	        fillColor: "#c36b36",
  	        fillOpacity: 0.24,
  	        zIndex: 10
  	      });

  	      draft.mapClickListener = draft.map.addListener("click", function (event) {
  	        if (!event || !event.latLng || !draft.polygon) return;
  	        const lat = Number(event.latLng.lat());
  	        const lng = Number(event.latLng.lng());
  	        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

  	        const points = tankDraftPoints();
  	        points.push({ lat: lat, lng: lng });
  	        draft.points = points;
  	        draft.polygon.setPath(points);
  	        bindTankPolygonPath(draft);
  	        updateTankLocationMapUi();
  	      });

  	      bindTankPolygonPath(draft);

  	      state.root.querySelectorAll("[data-tank-map-control]").forEach(function (button) {
  	        button.addEventListener("click", function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();
  	          handleTankMapControl(button.getAttribute("data-tank-map-control"));
  	        });
  	      });

  	      draft.mounted = true;
  	      updateTankLocationMapUi();
  	      if (draft.points.length) fitTankDraftPolygon();

  	      if (initial.zoom <= 5 && navigator.geolocation) {
  	        navigator.geolocation.getCurrentPosition(function (position) {
  	          if (!draft.map || draft.points.length) return;
  	          draft.map.panTo({
  	            lat: Number(position.coords.latitude),
  	            lng: Number(position.coords.longitude)
  	          });
  	          draft.map.setZoom(19);
  	        }, function () {}, {
  	          enableHighAccuracy: false,
  	          timeout: 5000,
  	          maximumAge: 120000
  	        });
  	      }
  	    } catch (error) {
  	      if (status) status.textContent = clean(error && error.message) || "Google Map could not be created.";
  	      showToast(clean(error && error.message) || "Google Map could not be created.", "error", 8000);
  	    }
  	  }

  	  function tankLocationSaveContext(name, color, ownerId, existingLocation) {
  	    const points = tankDraftPoints();
  	    if (points.length < 3) throw new Error("Draw the Tank location polygon with at least three points.");

  	    const areaM2 = sphericalPolygonAreaM2(points);
  	    if (!(areaM2 > 0)) throw new Error("The Tank location polygon has no measurable area.");

  	    const centre = polygonCentre(points);
  	    if (!centre) throw new Error("The Tank location polygon centre could not be calculated.");

  	    const ring = points.map(function (point) {
  	      return [Number(point.lng), Number(point.lat)];
  	    });
  	    ring.push(ring[0].slice());

  	    const existing = existingLocation && typeof existingLocation === "object" ? existingLocation : null;
  	    const id = clean(existing && existing.ID) || ("POL-" + Date.now().toString(36).toUpperCase());
  	    const locationName = clean(existing && existing.Name) || (clean(name) + " Fuel Location");
  	    const areaHa = areaM2 / 10000;
  	    const acres = areaM2 * 0.000247105;

  	    const payload = {
  	      ownerId: clean(ownerId) || clean(existing && existing.ownerId) || null,
  	      ID: id,
  	      Name: locationName,
  	      Type: "Fuel",
  	      REF: clean(existing && existing.REF) || (id + " (" + locationName + ")"),
  	      Color: clean(color) || clean(existing && existing.Color) || "#c36b36",
  	      CreationType: "Polygon",
  	      Polygon: {
  	        type: "Polygon",
  	        coordinates: [ring]
  	      },
  	      Centre: {
  	        type: "Point",
  	        coordinates: [Number(centre.lng), Number(centre.lat)]
  	      },
  	      AreaHa: Number(areaHa.toFixed(4)),
  	      ParentId: null,
  	      EntrancePoint: null,
  	      LocationData: {
  	        CreationType: "Polygon",
  	        creationMode: "polygon",
  	        Area: {
  	          m2: Number(areaM2.toFixed(2)),
  	          Acres: Number(acres.toFixed(2)),
  	          Hectares: Number(areaHa.toFixed(4)),
  	          Center: {
  	            lat: Number(centre.lat),
  	            lng: Number(centre.lng)
  	          },
  	          Functionality: {
  	            FuelLogic: true,
  	            FuelMode: "depot",
  	            GateLogic: false,
  	            LoadLogic: false,
  	            EventsCapture: false
  	          }
  	        },
  	        Geometry: {
  	          rawPoints: clone(points),
  	          resolvedPoints: clone(points),
  	          holeRings: [],
  	          snapSegments: []
  	        },
  	        Functionality: {
  	          EventsCapture: false,
  	          FuelLogic: true,
  	          FuelMode: "depot",
  	          PublicFuelStation: false,
  	          FuelDepot: true,
  	          LoadLogic: false,
  	          GateLogic: false,
  	          GatePhone: ""
  	        },
  	        FuelItems: [],
  	        Description: "",
  	        ContactName: "",
  	        ContactNumber: ""
  	      }
  	    };

  	    if (existing && objectId(existing)) payload.objectId = objectId(existing);

  	    return {
  	      payload: payload,
  	      localPolygon: clone(payload.Polygon),
  	      localCentre: clone(payload.Centre),
  	      isUpdate: !!(existing && objectId(existing))
  	    };
  	  }

  	  async function createTankFromModal() {
  	    const form = state.root.querySelector('[data-form="tank"]');
  	    if (!form) throw new Error("The Tank form is unavailable.");

  	    const data = new FormData(form);
  	    const company = companyById(clean(data.get("CompanyId")));
  	    const name = clean(data.get("Name"));
  	    const deviceId = clean(data.get("DeviceId"));
  	    const grade = clean(data.get("Grade"));
  	    const capacity = formNumber(data, "Capacity", 0);
  	    const volume = formNumber(data, "Volume", 0);
  	    const orderThreshold = formNumber(data, "OrderThreshold", 0);
  	    const defaultOrderVolume = formNumber(data, "DefaultOrderVolume", 0);
  	    const supplier = clean(data.get("PrimarySupplier"));
  	    const supplierId = clean(data.get("PrimarySupplierId"));
  	    const trailer = formBoolean(data, "Trailer", false);
  	    const ownerId = clean(company && company.ownerId);
  	    const color = clean(data.get("Color")) || "#4caf50";

  	    if (!company || !ownerId) throw new Error("Select a Company with an ownerId.");
  	    if (!name) throw new Error("Tank name is required.");
  	    if (!deviceId) throw new Error("Internal Tank code / DeviceId is required.");
  	    if (!grade) throw new Error("Fuel grade is required.");
  	    if (!(capacity > 0)) throw new Error("Tank capacity must be greater than zero.");
  	    if (volume < 0 || volume > capacity) throw new Error("Opening volume must be between zero and capacity.");
  	    if (orderThreshold < 0 || orderThreshold > capacity) throw new Error("Order threshold must be between zero and Tank capacity.");
  	    if (defaultOrderVolume < 0 || defaultOrderVolume > capacity) throw new Error("Default order volume must be between zero and Tank capacity.");

  	    const duplicateDevice = await findOne(TABLES.TANKS, "DeviceId = '" + escapeWhere(deviceId) + "'");
  	    if (duplicateDevice) throw new Error("A Tank already uses internal DeviceId " + deviceId + ".");

  	    const duplicateName = companyTanks(company).some(function (tank) {
  	      return lower(tank.Name) === lower(name);
  	    });
  	    if (duplicateName) throw new Error(companyName(company) + " already has a Tank named " + name + ".");

  	    const locationPoints = tankDraftPoints();
  	    const locationRequested = locationPoints.length > 0;
  	    const locationContext = locationRequested
  	      ? tankLocationSaveContext(name, color, ownerId)
  	      : null;

  	    let location = null;
  	    let companyLocationLinked = false;
  	    let tank = null;
  	    let tankView = null;

  	    try {
  	      if (locationContext) {
  	        updateOperation("Creating optional Tank polygon Location...");
  	        location = await saveRecord(TABLES.LOCATIONS, locationContext.payload);
  	        location = Object.assign({}, locationContext.payload, location || {});
  	        location.Polygon = locationContext.localPolygon;
  	        location.Centre = locationContext.localCentre;

  	        updateOperation("Linking Company.Locations...");
  	        await addRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_LOCATIONS, objectId(location));
  	        companyLocationLinked = true;
  	      }

  	      updateOperation("Creating Backendless Tank...");
  	      tank = normalizeTank(await saveRecord(TABLES.TANKS, {
  	        ownerId: ownerId,
  	        Name: name,
  	        DeviceId: deviceId,
  	        Grade: grade,
  	        Capacity: capacity,
  	        Volume: volume,
  	        Level: Number(((volume / capacity) * 100).toFixed(2)),
  	        Color: color,
  	        Trailer: trailer,
  	        OrderThreshold: orderThreshold,
  	        DefaultOrderVolume: defaultOrderVolume,
  	        PrimarySupplier: supplier,
  	        PrimarySupplierId: supplierId
  	      }));

  	      updateOperation("Creating current TankView...");
  	      tankView = await saveRecord(TABLES.TANK_VIEW, buildInitialTankView(ownerId));

  	      updateOperation(location
  	        ? "Linking Tank ViewC, optional Location and Company.Tanks..."
  	        : "Linking Tank ViewC and Company.Tanks...");
  	      await setRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_VIEW_CURRENT, objectId(tankView));
  	      if (location) {
  	        await setRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_LOCATION, objectId(location));
  	      }
  	      await addRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TANKS, objectId(tank));

  	      const results = await Promise.all([
  	        loadRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_VIEW_CURRENT),
  	        location ? loadRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_LOCATION) : Promise.resolve([]),
  	        loadRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TANKS),
  	        location ? loadRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_LOCATIONS) : Promise.resolve([])
  	      ]);

  	      const currentViews = results[0];
  	      const tankLocations = results[1];
  	      const companyTanksNow = results[2];
  	      const companyLocationsNow = results[3];

  	      if (!currentViews.some(function (row) { return objectId(row) === objectId(tankView); })) {
  	        throw new Error("Tanks.ViewC verification failed.");
  	      }
  	      if (location && !tankLocations.some(function (row) { return objectId(row) === objectId(location); })) {
  	        throw new Error("Tanks.Location verification failed.");
  	      }
  	      if (!companyTanksNow.some(function (row) { return objectId(row) === objectId(tank); })) {
  	        throw new Error("Companies.Tanks verification failed.");
  	      }
  	      if (location && !companyLocationsNow.some(function (row) { return objectId(row) === objectId(location); })) {
  	        throw new Error("Companies.Locations verification failed.");
  	      }

  	      tank.ViewC = currentViews[0] || tankView;
  	      tank.ViewH = [];
  	      tank.Bowsers = [];
  	      tank.Location = location
  	        ? Object.assign({}, location, tankLocations[0] || {})
  	        : null;

  	      state.tanks = upsertById(state.tanks, tank, normalizeTank);
  	      APP_DATA.Tanks = upsertById(APP_DATA.Tanks, tank, normalizeTank);
  	      if (tank.Location) addLocationToCompanyAliases(tank.Location, objectId(company));
  	      addAssetToCompanyAliases(tank, objectId(company), "tank");
  	      return tank;
  	    } catch (error) {
  	      if (tank) {
  	        try { await deleteRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_TANKS, objectId(tank)); } catch (_) {}
  	        if (location) {
  	          try { await deleteRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_LOCATION, objectId(location)); } catch (_) {}
  	        }
  	        try { await removeRecord(TABLES.TANKS, objectId(tank)); } catch (_) {}
  	      }
  	      if (tankView) {
  	        try { await removeRecord(TABLES.TANK_VIEW, objectId(tankView)); } catch (_) {}
  	      }
  	      if (location) {
  	        if (companyLocationLinked) {
  	          try { await deleteRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_LOCATIONS, objectId(location)); } catch (_) {}
  	        }
  	        try { await removeRecord(TABLES.LOCATIONS, objectId(location)); } catch (_) {}
  	      }
  	      throw error;
  	    }
  	  }

  	  async function saveTankLocationFromModal() {
  	    const form = state.root.querySelector('[data-form="tank-location"]');
  	    if (!form) throw new Error("The Tank Location form is unavailable.");

  	    const data = new FormData(form);
  	    const companyId = clean(data.get("CompanyId"));
  	    const tankId = clean(data.get("TankId"));
  	    const company = companyById(companyId);
  	    const tank = tankForCompany(companyId, tankId);
  	    const ownerId = clean(company && company.ownerId) || clean(tank && tank.ownerId);

  	    if (!company || !tank || !objectId(tank)) throw new Error("The selected Company or Tank is unavailable.");
  	    if (!ownerId) throw new Error("The selected Company does not have an ownerId.");

  	    let existingLocation = tank.Location && typeof tank.Location === "object" ? tank.Location : null;
  	    if (!existingLocation) {
  	      const loaded = await loadRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_LOCATION).catch(function () { return []; });
  	      existingLocation = loaded[0] || null;
  	    }

  	    const context = tankLocationSaveContext(tankLabel(tank), tank.Color, ownerId, existingLocation);
  	    let savedLocation = null;
  	    let createdNew = false;

  	    try {
  	      updateOperation(context.isUpdate ? "Updating Tank polygon Location..." : "Creating Tank polygon Location...");
  	      savedLocation = await saveRecord(TABLES.LOCATIONS, context.payload);
  	      createdNew = !context.isUpdate;
  	      savedLocation = Object.assign({}, context.payload, savedLocation || {});
  	      savedLocation.Polygon = context.localPolygon;
  	      savedLocation.Centre = context.localCentre;

  	      updateOperation("Linking Company.Locations and Tank.Location...");
  	      await addRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_LOCATIONS, objectId(savedLocation));
  	      await setRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_LOCATION, objectId(savedLocation));

  	      const verification = await Promise.all([
  	        loadRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_LOCATION),
  	        loadRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_LOCATIONS)
  	      ]);

  	      const tankLocations = verification[0];
  	      const companyLocations = verification[1];
  	      if (!tankLocations.some(function (row) { return objectId(row) === objectId(savedLocation); })) {
  	        throw new Error("Tanks.Location verification failed.");
  	      }
  	      if (!companyLocations.some(function (row) { return objectId(row) === objectId(savedLocation); })) {
  	        throw new Error("Companies.Locations verification failed.");
  	      }

  	      const hydratedLocation = Object.assign({}, savedLocation, tankLocations[0] || {});
  	      tank.Location = hydratedLocation;
  	      state.tanks = upsertById(state.tanks, tank, normalizeTank);
  	      APP_DATA.Tanks = upsertById(APP_DATA.Tanks, tank, normalizeTank);
  	      addLocationToCompanyAliases(hydratedLocation, companyId);
  	      addAssetToCompanyAliases(tank, companyId, "tank");
  	      return hydratedLocation;
  	    } catch (error) {
  	      if (createdNew && savedLocation) {
  	        try { await deleteRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_LOCATION, objectId(savedLocation)); } catch (_) {}
  	        try { await deleteRelation(TABLES.COMPANIES, objectId(company), RELATIONS.COMPANY_LOCATIONS, objectId(savedLocation)); } catch (_) {}
  	        try { await removeRecord(TABLES.LOCATIONS, objectId(savedLocation)); } catch (_) {}
  	      }
  	      throw error;
  	    }
  	  }

  	  async function createBowserFromModal() {
  	    const form = state.root.querySelector('[data-form="bowser"]');
  	    if (!form) throw new Error("The Bowser form is unavailable.");

  	    const data = new FormData(form);
  	    const companyId = clean(data.get("CompanyId"));
  	    const tankId = clean(data.get("TankId"));
  	    const company = companyById(companyId);
  	    const tank = tankForCompany(companyId, tankId);
  	    const name = clean(data.get("Name"));
  	    const openingMeter = formNumber(data, "Meter", 0);
  	    const ownerId = clean(company && company.ownerId) || clean(tank && tank.ownerId);
  	    const grade = clean(tank && tank.Grade);

  	    if (!company || !tank || !objectId(tank)) throw new Error("The selected Company or Tank is unavailable.");
  	    if (!ownerId) throw new Error("The selected Company does not have an ownerId.");
  	    if (!name) throw new Error("Bowser name is required.");
  	    if (!Number.isFinite(openingMeter) || openingMeter < 0) throw new Error("Opening Bowser meter must be zero or greater.");
  	    if (bowserNameExists(tank, name)) throw new Error(tankLabel(tank) + " already has a Bowser named " + name + ".");

  	    let bowser = null;
  	    let bowserView = null;

  	    try {
  	      updateOperation("Creating Backendless Bowser...");
  	      bowser = normalizeBowser(await saveRecord(TABLES.BOWSERS, {
  	        ownerId: ownerId,
  	        Name: name,
  	        Meter: openingMeter,
  	        Grade: grade,
  	        RollbackLastGroupId: null,
  	        RollbackLastAt: null
  	      }));

  	      updateOperation("Creating current BowserView...");
  	      bowserView = await saveRecord(TABLES.BOWSER_VIEW, buildInitialBowserView(ownerId, openingMeter));

  	      updateOperation("Linking Bowser ViewC and Tanks.Bowsers...");
  	      await setRelation(TABLES.BOWSERS, objectId(bowser), RELATIONS.BOWSER_VIEW_CURRENT, objectId(bowserView));
  	      await addRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_BOWSERS, objectId(bowser));

  	      const currentViews = await loadRelation(TABLES.BOWSERS, objectId(bowser), RELATIONS.BOWSER_VIEW_CURRENT);
  	      const tankBowsers = await loadRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_BOWSERS);
  	      if (!currentViews.some(function (row) { return objectId(row) === objectId(bowserView); })) {
  	        throw new Error("Bowsers.ViewC verification failed.");
  	      }
  	      if (!tankBowsers.some(function (row) { return objectId(row) === objectId(bowser); })) {
  	        throw new Error("Tanks.Bowsers verification failed.");
  	      }

  	      bowser.ViewC = currentViews[0] || bowserView;
  	      bowser.ViewH = [];

  	      tank.Bowsers = tankBowsers.map(normalizeBowser);
  	      state.bowsers = upsertById(state.bowsers, bowser, normalizeBowser);
  	      if (!Array.isArray(APP_DATA.Bowsers)) APP_DATA.Bowsers = [];
  	      APP_DATA.Bowsers = upsertById(APP_DATA.Bowsers, bowser, normalizeBowser);
  	      syncTankBowsersLocally(companyId, tank);
  	      return bowser;
  	    } catch (error) {
  	      if (bowser) {
  	        try { await deleteRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_BOWSERS, objectId(bowser)); } catch (_) {}
  	        try { await removeRecord(TABLES.BOWSERS, objectId(bowser)); } catch (_) {}
  	      }
  	      if (bowserView) {
  	        try { await removeRecord(TABLES.BOWSER_VIEW, objectId(bowserView)); } catch (_) {}
  	      }
  	      throw error;
  	    }
  	  }

  	  function linkedBowserIds() {
  	    const ids = new Set();
  	    state.companies.forEach(function (company) {
  	      companyTanks(company).forEach(function (tank) {
  	        arr(tank.Bowsers).forEach(function (bowser) {
  	          const id = objectId(bowser);
  	          if (id) ids.add(id);
  	        });
  	      });
  	    });
  	    return ids;
  	  }

  	  function availableBowsers() {
  	    const linked = linkedBowserIds();
  	    return state.bowsers.filter(function (bowser) { return objectId(bowser) && !linked.has(objectId(bowser)); }).sort(function (a, b) {
  	      return clean(a.Name).localeCompare(clean(b.Name), undefined, { sensitivity: "base", numeric: true });
  	    });
  	  }

  	  function syncTankBowsersLocally(companyId, tank) {
  	    state.tanks = upsertById(state.tanks, tank, normalizeTank);
  	    APP_DATA.Tanks = upsertById(APP_DATA.Tanks, tank, normalizeTank);
  	    addAssetToCompanyAliases(tank, companyId, "tank");
  	  }

  	  async function linkExistingBowser(companyId, tankId, bowserId) {
  	    const tank = tankForCompany(companyId, tankId);
  	    const bowser = state.bowsers.find(function (row) { return objectId(row) === bowserId; });
  	    if (!tank || !bowser) throw new Error("The Tank or Bowser is no longer available.");
  	    if (linkedBowserIds().has(bowserId)) throw new Error(clean(bowser.Name) + " is already linked to a Tank.");
  	    await addRelation(TABLES.TANKS, tankId, RELATIONS.TANK_BOWSERS, bowserId);
  	    tank.Bowsers = upsertById(tank.Bowsers, bowser, normalizeBowser);
  	    syncTankBowsersLocally(companyId, tank);
  	    return bowser;
  	  }

  	  async function unlinkBowser(companyId, tankId, bowserId) {
  	    const tank = tankForCompany(companyId, tankId);
  	    const bowser = tank && arr(tank.Bowsers).find(function (row) { return objectId(row) === bowserId; });
  	    if (!tank || !bowser) throw new Error("The Tank or linked Bowser is no longer available.");
  	    await deleteRelation(TABLES.TANKS, tankId, RELATIONS.TANK_BOWSERS, bowserId);
  	    tank.Bowsers = arr(tank.Bowsers).filter(function (row) { return objectId(row) !== bowserId; });
  	    syncTankBowsersLocally(companyId, tank);
  	    return bowser;
  	  }

  	  function logoHtml() {
  	    let source = SVG_INPUT;
  	    if (source && typeof source === "object") source = source.value || source.src || source.url || "";
  	    source = clean(source);
  	    if (!source) return '<div class="fif-brand-fallback">FIF</div>';
  	    if (/^data:image\//i.test(source) || /^https?:\/\//i.test(source)) {
  	      return '<img class="fif-brand-logo" src="' + escapeAttr(source) + '" alt="Fleet In Form">';
  	    }
  	    if (/^<svg[\s>]/i.test(source)) {
  	      const safe = source.replace(/<script[\s\S]*?<\/script>/gi, "");
  	      return '<div class="fif-brand-svg">' + safe + "</div>";
  	    }
  	    return '<div class="fif-brand-fallback">FIF</div>';
  	  }

  	  function installStyles() {
  	    document.getElementById(STYLE_ID) && document.getElementById(STYLE_ID).remove();
  	    const style = document.createElement("style");
  	    style.id = STYLE_ID;
  	    style.textContent = `
  	      #${ROOT_ID}, #${ROOT_ID} * { box-sizing: border-box; }
  	      #${ROOT_ID} {
  	        --nav:#17222c; --nav2:#202f3b; --accent:#c36b36; --accent2:#a75427;
  	        --ink:#17212b; --muted:#65727d; --line:#dce3e8; --panel:#ffffff;
  	        --page:#f3f5f7; --good:#19764a; --warn:#9b5a08; --bad:#a3353a;
  	        position:fixed; top:${TOP_OFFSET}px; right:0; bottom:0; left:0;
  	        z-index:80; background:var(--page); color:var(--ink);
  	        font-family:Arial,Helvetica,sans-serif; overflow:hidden;
  	      }
  	      #${ROOT_ID} button, #${ROOT_ID} input, #${ROOT_ID} select, #${ROOT_ID} textarea { font:inherit; }
  	      #${ROOT_ID} button { cursor:pointer; }
  	      #${ROOT_ID} .fif-layout { display:grid; grid-template-columns:250px minmax(0,1fr); height:100%; }
  	      #${ROOT_ID} .fif-side { background:linear-gradient(180deg,var(--nav),var(--nav2)); color:white; display:flex; flex-direction:column; min-width:0; }
  	      #${ROOT_ID} .fif-brand { min-height:78px; display:flex; align-items:center; gap:12px; padding:14px 17px; border-bottom:1px solid rgba(255,255,255,.1); }
  	      #${ROOT_ID} .fif-brand-logo, #${ROOT_ID} .fif-brand-svg svg { width:46px; height:46px; object-fit:contain; display:block; }
  	      #${ROOT_ID} .fif-brand-fallback { width:44px; height:44px; border-radius:12px; background:var(--accent); display:grid; place-items:center; font-weight:900; }
  	      #${ROOT_ID} .fif-brand strong { display:block; font-size:14px; }
  	      #${ROOT_ID} .fif-brand span { display:block; color:#b9c7d0; font-size:10px; margin-top:4px; }
  	      #${ROOT_ID} .fif-nav { padding:12px 10px; flex:1; overflow:auto; }
  	      #${ROOT_ID} .fif-nav button { width:100%; border:0; background:transparent; color:#cbd6de; padding:11px 12px; border-radius:9px; text-align:left; display:flex; gap:10px; align-items:center; margin:2px 0; }
  	      #${ROOT_ID} .fif-nav button:hover { background:rgba(255,255,255,.07); color:white; }
  	      #${ROOT_ID} .fif-nav button.active { background:var(--accent); color:white; }
  	      #${ROOT_ID} .fif-side-foot { padding:14px 16px; border-top:1px solid rgba(255,255,255,.1); color:#b9c7d0; font-size:11px; }
  	      #${ROOT_ID} .fif-main { min-width:0; height:100%; overflow:auto; }
  	      #${ROOT_ID} .fif-top { min-height:78px; background:white; border-bottom:1px solid var(--line); padding:13px 22px; display:flex; align-items:center; gap:16px; position:sticky; top:0; z-index:15; }
  	      #${ROOT_ID} .fif-top-copy { min-width:0; flex:1; }
  	      #${ROOT_ID} .fif-top-copy h1 { margin:0; font-size:20px; }
  	      #${ROOT_ID} .fif-top-copy p { margin:4px 0 0; color:var(--muted); font-size:12px; }
  	      #${ROOT_ID} .fif-user-chip { display:flex; align-items:center; gap:9px; padding:7px 10px; border-radius:10px; background:#f0f3f5; max-width:260px; }
  	      #${ROOT_ID} .fif-avatar { width:34px; height:34px; border-radius:50%; display:grid; place-items:center; background:var(--nav); color:white; font-weight:800; }
  	      #${ROOT_ID} .fif-user-chip strong { display:block; font-size:12px; }
  	      #${ROOT_ID} .fif-user-chip span { display:block; color:var(--muted); font-size:10px; }
  	      #${ROOT_ID} .fif-content { padding:22px; max-width:1600px; margin:0 auto; }
  	      #${ROOT_ID} .fif-heading { display:flex; justify-content:space-between; align-items:flex-end; gap:16px; margin-bottom:16px; }
  	      #${ROOT_ID} .fif-heading h2 { margin:0; font-size:23px; }
  	      #${ROOT_ID} .fif-heading p { margin:5px 0 0; color:var(--muted); font-size:12px; }
  	      #${ROOT_ID} .fif-actions { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
  	      #${ROOT_ID} .fif-button { border:1px solid var(--line); background:white; color:var(--ink); border-radius:9px; padding:9px 13px; font-weight:700; display:inline-flex; align-items:center; gap:7px; }
  	      #${ROOT_ID} .fif-button:hover { transform:translateY(-1px); box-shadow:0 5px 12px rgba(23,33,43,.09); }
  	      #${ROOT_ID} .fif-button.primary { background:var(--accent); color:white; border-color:var(--accent); }
  	      #${ROOT_ID} .fif-button.primary:hover { background:var(--accent2); }
  	      #${ROOT_ID} .fif-button.danger { background:var(--bad); color:white; border-color:var(--bad); }
  	      #${ROOT_ID} .fif-button:disabled { opacity:.55; cursor:not-allowed; transform:none; box-shadow:none; }
  	      #${ROOT_ID} .fif-search { width:min(390px,100%); border:1px solid var(--line); border-radius:9px; padding:9px 11px; background:white; }
  	      #${ROOT_ID} .fif-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(220px,1fr)); gap:14px; }
  	      #${ROOT_ID} .fif-card { background:white; border:1px solid var(--line); border-radius:13px; padding:16px; box-shadow:0 3px 12px rgba(23,33,43,.04); }
  	      #${ROOT_ID} .fif-card h3 { margin:0 0 7px; font-size:14px; }
  	      #${ROOT_ID} .fif-card p { margin:0; color:var(--muted); font-size:12px; line-height:1.5; }
  	      #${ROOT_ID} .fif-stat { font-size:31px; font-weight:900; margin:8px 0 2px; }
  	      #${ROOT_ID} .fif-table-shell { background:white; border:1px solid var(--line); border-radius:13px; overflow:auto; }
  	      #${ROOT_ID} table { width:100%; border-collapse:collapse; min-width:920px; }
  	      #${ROOT_ID} th { text-align:left; padding:11px 13px; background:#f7f9fa; color:var(--muted); text-transform:uppercase; letter-spacing:.04em; font-size:10px; border-bottom:1px solid var(--line); position:sticky; top:0; }
  	      #${ROOT_ID} td { padding:11px 13px; border-bottom:1px solid #edf1f4; font-size:12px; vertical-align:middle; }
  	      #${ROOT_ID} tr:last-child td { border-bottom:0; }
  	      #${ROOT_ID} .fif-row-title { font-weight:800; display:block; }
  	      #${ROOT_ID} .fif-row-sub { color:var(--muted); font-size:10px; display:block; margin-top:3px; }
  	      #${ROOT_ID} .fif-badge { display:inline-flex; border-radius:999px; padding:4px 8px; font-size:10px; font-weight:800; background:#e9eef2; color:#40505c; margin:2px 3px 2px 0; }
  	      #${ROOT_ID} .fif-badge.good { background:#e5f4eb; color:var(--good); }
  	      #${ROOT_ID} .fif-badge.warn { background:#fff0dc; color:var(--warn); }
  	      #${ROOT_ID} .fif-badge.bad { background:#f9e6e7; color:var(--bad); }
  	      #${ROOT_ID} .fif-badge.director { background:#e6eefc; color:#2f579a; }
  	      #${ROOT_ID} .fif-badge.super { background:#efe7fb; color:#6c3e99; }
  	      #${ROOT_ID} .fif-mini { border:1px solid var(--line); background:white; border-radius:7px; padding:6px 9px; font-size:11px; font-weight:700; }
  	      #${ROOT_ID} .fif-mini.danger { border-color:#e2b9bc; color:var(--bad); background:#fff7f7; }
  	      #${ROOT_ID} .fif-mini.danger:hover { background:var(--bad); color:white; border-color:var(--bad); }
  	      #${ROOT_ID} .fif-login-user-cell, #${ROOT_ID} .fif-login-user-head { width:52px; min-width:52px; text-align:right; padding-left:4px; }
  	      #${ROOT_ID} .fif-login-user-button { width:32px; height:32px; padding:0; border:1px solid var(--line); border-radius:8px; background:white; color:var(--nav); display:inline-grid; place-items:center; cursor:pointer; }
  	      #${ROOT_ID} .fif-login-user-button:hover { color:white; background:var(--accent); border-color:var(--accent); transform:translateY(-1px); box-shadow:0 5px 12px rgba(23,33,43,.12); }
  	      #${ROOT_ID} .fif-login-user-button:disabled { opacity:.35; cursor:not-allowed; transform:none; box-shadow:none; background:#f5f6f7; color:#7b8790; }
  	      #${ROOT_ID} .fif-login-user-button svg { width:17px; height:17px; display:block; fill:none; stroke:currentColor; stroke-width:1.8; stroke-linecap:round; stroke-linejoin:round; }
  	      #${ROOT_ID} .fif-sr-only { position:absolute !important; width:1px !important; height:1px !important; padding:0 !important; margin:-1px !important; overflow:hidden !important; clip:rect(0,0,0,0) !important; white-space:nowrap !important; border:0 !important; }
  	      #${ROOT_ID} .fif-empty { background:white; border:1px dashed #c7d1d8; border-radius:13px; padding:42px 22px; text-align:center; color:var(--muted); }
  	      #${ROOT_ID} .fif-note { border-left:4px solid var(--accent); border-radius:8px; padding:11px 13px; background:#fff8f2; color:#66452f; font-size:12px; line-height:1.5; }
  	      #${ROOT_ID} .fif-note.full { grid-column:1/-1; }
  	      #${ROOT_ID} .fif-modal-layer { position:fixed; inset:${TOP_OFFSET}px 0 0 0; z-index:100; display:none; align-items:center; justify-content:center; padding:22px; background:rgba(12,19,25,.62); }
  	      #${ROOT_ID} .fif-modal-layer.open { display:flex; }
  	      #${ROOT_ID} .fif-modal { width:min(1050px,96vw); max-height:92vh; background:white; border-radius:15px; overflow:hidden; display:flex; flex-direction:column; box-shadow:0 28px 80px rgba(0,0,0,.35); }
  	      #${ROOT_ID} .fif-modal.small { width:min(560px,96vw); }
  	      #${ROOT_ID} .fif-modal-head { padding:16px 19px; border-bottom:1px solid var(--line); display:flex; align-items:center; justify-content:space-between; gap:12px; }
  	      #${ROOT_ID} .fif-modal-head h2 { margin:0; font-size:18px; }
  	      #${ROOT_ID} .fif-close { width:34px; height:34px; border:0; border-radius:50%; background:#eef2f4; font-size:20px; }
  	      #${ROOT_ID} .fif-modal-body { padding:18px 19px; overflow:auto; }
  	      #${ROOT_ID} .fif-modal-foot { padding:13px 19px; border-top:1px solid var(--line); display:flex; justify-content:flex-end; gap:9px; background:#fafbfc; }
  	      #${ROOT_ID} .fif-form-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:14px; }
  	      #${ROOT_ID} .fif-field.full { grid-column:1/-1; }
  	      #${ROOT_ID} .fif-field label { display:block; color:#44525e; font-size:11px; font-weight:800; margin-bottom:6px; }
  	      #${ROOT_ID} .fif-input, #${ROOT_ID} .fif-select, #${ROOT_ID} .fif-textarea { width:100%; border:1px solid var(--line); border-radius:9px; padding:9px 11px; color:var(--ink); background:white; outline:none; }
  	      #${ROOT_ID} .fif-input:focus, #${ROOT_ID} .fif-select:focus, #${ROOT_ID} .fif-textarea:focus { border-color:var(--accent); box-shadow:0 0 0 3px rgba(195,107,54,.12); }
  	      #${ROOT_ID} .fif-help { color:var(--muted); font-size:10px; margin-top:5px; line-height:1.4; }
  	      #${ROOT_ID} .fif-subsection { grid-column:1/-1; border-top:1px solid var(--line); padding-top:15px; margin-top:3px; }
  	      #${ROOT_ID} .fif-subsection h3 { margin:0 0 10px; font-size:14px; }
  	      #${ROOT_ID} .fif-check-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(170px,1fr)); gap:8px; }
  	      #${ROOT_ID} .fif-check { display:flex; align-items:flex-start; gap:8px; border:1px solid var(--line); background:#fafbfc; border-radius:8px; padding:9px; font-size:12px; }
  	      #${ROOT_ID} .fif-check input { margin-top:2px; }
  	      #${ROOT_ID} .fif-field label.fif-form-toggle { position:relative; display:grid; grid-template-columns:44px minmax(0,1fr); align-items:center; gap:11px; width:100%; min-height:58px; margin:0; padding:10px 12px; box-sizing:border-box; border:1px solid var(--line); border-radius:9px; background:#fafbfc; cursor:pointer; overflow:visible; }
  	      #${ROOT_ID} .fif-field label.fif-form-toggle:hover { border-color:#b8c3cb; background:#f7f9fa; }
  	      #${ROOT_ID} .fif-field label.fif-form-toggle input { position:absolute; width:1px; height:1px; margin:0; padding:0; opacity:0; pointer-events:none; overflow:hidden; clip:rect(0 0 0 0); }
  	      #${ROOT_ID} .fif-form-toggle-track { position:relative; display:block; width:42px; height:23px; min-width:42px; border-radius:999px; background:#cfd6dd; box-shadow:inset 0 0 0 1px rgba(0,0,0,.08); transition:background .18s ease, box-shadow .18s ease; }
  	      #${ROOT_ID} .fif-form-toggle-track:after { content:""; position:absolute; top:3px; left:3px; width:17px; height:17px; border-radius:50%; background:#fff; box-shadow:0 1px 4px rgba(0,0,0,.28); transition:transform .18s ease; }
  	      #${ROOT_ID} .fif-form-toggle input:checked + .fif-form-toggle-track { background:var(--good); box-shadow:inset 0 0 0 1px rgba(0,0,0,.06),0 0 0 3px rgba(41,132,81,.08); }
  	      #${ROOT_ID} .fif-form-toggle input:checked + .fif-form-toggle-track:after { transform:translateX(19px); }
  	      #${ROOT_ID} .fif-form-toggle input:focus-visible + .fif-form-toggle-track { outline:3px solid rgba(204,102,51,.22); outline-offset:2px; }
  	      #${ROOT_ID} .fif-form-toggle-copy { display:block; min-width:0; overflow:visible; }
  	      #${ROOT_ID} .fif-form-toggle-copy strong { display:block; margin:0; color:var(--ink); font-size:12px; line-height:1.25; }
  	      #${ROOT_ID} .fif-form-toggle-copy small { display:block; margin-top:3px; color:var(--muted); font-size:10px; line-height:1.4; white-space:normal; overflow-wrap:anywhere; }
  	      #${ROOT_ID} .fif-operation { position:fixed; inset:${TOP_OFFSET}px 0 0 0; z-index:300; display:none; place-items:center; background:rgba(13,20,27,.72); }
  	      #${ROOT_ID} .fif-operation.open { display:grid; }
  	      #${ROOT_ID} .fif-operation-card { width:min(450px,90vw); background:white; border-radius:15px; padding:24px; text-align:center; box-shadow:0 28px 80px rgba(0,0,0,.35); }
  	      #${ROOT_ID} .fif-spinner { width:31px; height:31px; border:4px solid #dfe5e9; border-top-color:var(--accent); border-radius:50%; animation:fifspin .8s linear infinite; margin:0 auto 14px; }
  	      #${ROOT_ID} .fif-operation-card h3 { margin:0 0 7px; }
  	      #${ROOT_ID} .fif-operation-card p { margin:0; color:var(--muted); font-size:12px; }
  	      #${ROOT_ID} .fif-toast { position:fixed; right:22px; bottom:22px; z-index:400; min-width:280px; max-width:560px; display:none; padding:13px 16px; border-radius:10px; background:#17212b; color:white; box-shadow:0 18px 45px rgba(0,0,0,.25); font-size:12px; line-height:1.4; }
  	      #${ROOT_ID} .fif-toast.show { display:block; }
  	      #${ROOT_ID} .fif-toast.error { background:var(--bad); }
  	      #${ROOT_ID} .fif-toast.success { background:var(--good); }
  	      #${ROOT_ID} .fif-status-toggle { border:0; background:transparent; display:inline-flex; align-items:center; gap:7px; cursor:pointer; font:inherit; font-size:11px; font-weight:800; color:var(--muted); }
  	      #${ROOT_ID} .fif-status-toggle span { width:38px; height:21px; border-radius:999px; background:#cfd6dd; position:relative; transition:.18s ease; }
  	      #${ROOT_ID} .fif-status-toggle span:after { content:""; width:15px; height:15px; border-radius:50%; background:white; position:absolute; top:3px; left:3px; box-shadow:0 1px 4px rgba(0,0,0,.25); transition:.18s ease; }
  	      #${ROOT_ID} .fif-status-toggle.on span { background:var(--good); }
  	      #${ROOT_ID} .fif-status-toggle.on span:after { transform:translateX(17px); }
  	      #${ROOT_ID} .fif-status-toggle.on strong { color:var(--good); }
  	      #${ROOT_ID} .fif-asset-counts { display:flex; flex-wrap:wrap; gap:5px; margin-bottom:4px; }
  	      #${ROOT_ID} .fif-asset-counts span { padding:3px 7px; border-radius:999px; background:#edf1f4; font-size:10px; font-weight:800; white-space:nowrap; }
  	      #${ROOT_ID} .fif-manage-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px; }
  	      #${ROOT_ID} .fif-manage-card { text-align:left; border:1px solid var(--border); background:white; padding:17px; border-radius:12px; cursor:pointer; display:flex; flex-direction:column; gap:5px; }
  	      #${ROOT_ID} .fif-manage-card:hover { border-color:var(--accent); box-shadow:0 8px 24px rgba(0,0,0,.08); }
  	      #${ROOT_ID} .fif-manage-card strong { font-size:14px; }
  	      #${ROOT_ID} .fif-manage-card span { color:var(--muted); font-size:11px; line-height:1.45; }
  	      #${ROOT_ID} .fif-tank-map-shell { grid-column:1/-1; border:1px solid var(--line); border-radius:12px; overflow:hidden; background:#fff; }
  	      #${ROOT_ID} .fif-tank-map-head { display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; padding:11px 13px; border-bottom:1px solid var(--line); background:#f8fafb; }
  	      #${ROOT_ID} .fif-tank-map-head strong { display:block; font-size:13px; }
  	      #${ROOT_ID} .fif-tank-map-head small { display:block; color:var(--muted); font-size:10px; margin-top:3px; }
  	      #${ROOT_ID} .fif-tank-map-actions { display:flex; align-items:center; gap:7px; flex-wrap:wrap; }
  	      #${ROOT_ID} .fif-tank-map-actions button { border:1px solid var(--line); background:white; border-radius:7px; padding:6px 9px; font-size:10px; font-weight:800; }
  	      #${ROOT_ID} .fif-tank-map { width:100%; height:430px; background:#dfe5e9; }
  	      #${ROOT_ID} .fif-tank-map-foot { display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; padding:10px 13px; border-top:1px solid var(--line); font-size:11px; }
  	      #${ROOT_ID} .fif-tank-map-status { color:var(--muted); }
  	      #${ROOT_ID} .fif-tank-map-status.ready { color:var(--good); font-weight:800; }
  	      #${ROOT_ID} .fif-tank-map-stats { display:flex; gap:12px; font-weight:800; }
  	      @keyframes fifspin { to { transform:rotate(360deg); } }
  	      @media (max-width:980px) {
  	        #${ROOT_ID} .fif-layout { grid-template-columns:80px minmax(0,1fr); }
  	        #${ROOT_ID} .fif-brand-copy, #${ROOT_ID} .fif-nav-label, #${ROOT_ID} .fif-side-foot { display:none; }
  	        #${ROOT_ID} .fif-brand { justify-content:center; padding:10px; }
  	        #${ROOT_ID} .fif-nav button { justify-content:center; padding:11px 7px; }
  	      }
  	      @media (max-width:700px) {
  	        #${ROOT_ID} .fif-layout { grid-template-columns:1fr; grid-template-rows:auto 1fr; }
  	        #${ROOT_ID} .fif-side { display:block; }
  	        #${ROOT_ID} .fif-brand { min-height:58px; }
  	        #${ROOT_ID} .fif-nav { display:flex; overflow:auto; padding:7px; }
  	        #${ROOT_ID} .fif-nav button { width:auto; white-space:nowrap; }
  	        #${ROOT_ID} .fif-main { height:auto; }
  	        #${ROOT_ID} .fif-form-grid { grid-template-columns:1fr; }
  	        #${ROOT_ID} .fif-field.full, #${ROOT_ID} .fif-subsection { grid-column:1; }
  	        #${ROOT_ID} .fif-top { padding:10px 13px; }
  	        #${ROOT_ID} .fif-content { padding:14px; }
  	      }
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function pageTitle() {
  	    if (state.activeSection === "companies") return "Companies";
  	    if (state.activeSection === "employees") return "Employees";
  	    return "Director";
  	  }

  	  function pageDescription() {
  	    if (state.activeSection === "companies") return "Company details and all asset links.";
  	    if (state.activeSection === "employees") return "Create Employees and manage Company links.";
  	    return "Director access and Company control.";
  	  }


  	  function topBarElementFromTarget(target) {
  	    if (!target) return null;
  	    if (target.nodeType === 1) return target;
  	    return target.parentElement || null;
  	  }

  	  function isElementInsideTopBar(element, event) {
  	    if (!element || typeof element.getBoundingClientRect !== "function") return false;

  	    if (event && Number.isFinite(Number(event.clientY))) {
  	      const y = Number(event.clientY);
  	      if (y < 0 || y > TOP_OFFSET + TOP_BAR_HIT_PADDING) return false;
  	    }

  	    const rect = element.getBoundingClientRect();

  	    return (
  	      rect.bottom >= 0 &&
  	      rect.top <= TOP_OFFSET + TOP_BAR_HIT_PADDING
  	    );
  	  }

  	  function isLikelyTopBarLauncher(element) {
  	    if (!element || element === document.body || element === document.documentElement) {
  	      return false;
  	    }

  	    if (!isElementInsideTopBar(element)) return false;

  	    const rect = element.getBoundingClientRect();

  	    // Do not treat the entire top bar or a wide layout container as one icon.
  	    if (rect.width > 220 || rect.height > TOP_OFFSET + 24) return false;

  	    const tag = clean(element.tagName).toUpperCase();
  	    const role = clean(element.getAttribute && element.getAttribute("role")).toLowerCase();
  	    const tabindex = clean(element.getAttribute && element.getAttribute("tabindex"));
  	    const dataAction = clean(element.getAttribute && element.getAttribute("data-action"));
  	    const dataPage = clean(element.getAttribute && element.getAttribute("data-page"));
  	    const dataRoute = clean(element.getAttribute && element.getAttribute("data-route"));
  	    const dataUid = clean(
  	      element.getAttribute && (
  	        element.getAttribute("data-uid") ||
  	        element.getAttribute("data-component-uid") ||
  	        element.getAttribute("data-component-id")
  	      )
  	    );

  	    let cursor = "";
  	    try {
  	      cursor = clean(window.getComputedStyle(element).cursor).toLowerCase();
  	    } catch (_) {}

  	    return (
  	      tag === "BUTTON" ||
  	      tag === "A" ||
  	      role === "button" ||
  	      tabindex === "0" ||
  	      !!dataAction ||
  	      !!dataPage ||
  	      !!dataRoute ||
  	      !!dataUid ||
  	      typeof element.onclick === "function" ||
  	      cursor === "pointer"
  	    );
  	  }

  	  function findTopBarLauncher(target, event) {
  	    let element = topBarElementFromTarget(target);

  	    while (element && element !== document.body && element !== document.documentElement) {
  	      if (!isElementInsideTopBar(element, event)) return null;
  	      if (isLikelyTopBarLauncher(element)) return element;
  	      element = element.parentElement;
  	    }

  	    return null;
  	  }

  	  function topBarLauncherKey(element) {
  	    if (!element) return "";

  	    const parts = [
  	      clean(element.id),
  	      clean(element.getAttribute && element.getAttribute("data-uid")),
  	      clean(element.getAttribute && element.getAttribute("data-component-uid")),
  	      clean(element.getAttribute && element.getAttribute("data-component-id")),
  	      clean(element.getAttribute && element.getAttribute("data-action")),
  	      clean(element.getAttribute && element.getAttribute("data-page")),
  	      clean(element.getAttribute && element.getAttribute("data-route")),
  	      clean(element.getAttribute && element.getAttribute("aria-label")),
  	      clean(element.getAttribute && element.getAttribute("title")),
  	      clean(element.getAttribute && element.getAttribute("href"))
  	    ].filter(Boolean);

  	    return parts.join("|").toLowerCase();
  	  }

  	  function rememberOwnTopBarLauncher() {
  	    const candidates = [];

  	    try {
  	      if (window.event && window.event.target) candidates.push(window.event.target);
  	    } catch (_) {}

  	    try {
  	      if (document.activeElement && document.activeElement !== document.body) {
  	        candidates.push(document.activeElement);
  	      }
  	    } catch (_) {}

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const launcher = findTopBarLauncher(candidates[index], window.event || null);
  	      if (!launcher) continue;

  	      state.ownTopBarLauncher = launcher;
  	      state.ownTopBarLauncherKey = topBarLauncherKey(launcher);

  	      try {
  	        launcher.setAttribute("data-fif-application-id", APPLICATION_ID);
  	      } catch (_) {}

  	      return launcher;
  	    }

  	    return null;
  	  }

  	  function isOwnTopBarLauncher(launcher) {
  	    if (!launcher) return false;

  	    try {
  	      if (launcher.getAttribute("data-fif-application-id") === APPLICATION_ID) {
  	        return true;
  	      }
  	    } catch (_) {}

  	    const own = state.ownTopBarLauncher;

  	    if (
  	      own &&
  	      (
  	        launcher === own ||
  	        launcher.contains(own) ||
  	        own.contains(launcher)
  	      )
  	    ) {
  	      return true;
  	    }

  	    const launcherKey = topBarLauncherKey(launcher);

  	    return !!(
  	      launcherKey &&
  	      state.ownTopBarLauncherKey &&
  	      launcherKey === state.ownTopBarLauncherKey
  	    );
  	  }

  	  function removeTopBarCloseBehaviour() {
  	    if (state.topBarBindTimer) {
  	      window.clearTimeout(state.topBarBindTimer);
  	      state.topBarBindTimer = null;
  	    }

  	    if (state.topBarPointerHandler) {
  	      document.removeEventListener("pointerdown", state.topBarPointerHandler, true);
  	      state.topBarPointerHandler = null;
  	    }

  	    if (state.topBarClickHandler) {
  	      document.removeEventListener("click", state.topBarClickHandler, true);
  	      state.topBarClickHandler = null;
  	    }

  	    if (state.applicationOpenHandler) {
  	      window.removeEventListener(APPLICATION_OPEN_EVENT, state.applicationOpenHandler);
  	      state.applicationOpenHandler = null;
  	    }
  	  }

  	  function destroyManager() {
  	    if (state.destroying || !state.mounted) return;

  	    state.destroying = true;
  	    removeTopBarCloseBehaviour();
  	    clearTimeout(state.toastTimer);

  	    if (state.root) {
  	      try { state.root.removeEventListener("click", handleClick); } catch (_) {}
  	      try { state.root.removeEventListener("change", handleChange); } catch (_) {}
  	      try { state.root.removeEventListener("input", handleInput); } catch (_) {}
  	      try { state.root.remove(); } catch (_) {}
  	    }

  	    const style = document.getElementById(STYLE_ID);
  	    if (style) style.remove();

  	    document.body.style.overflow = state.priorBodyOverflow;
  	    state.root = null;
  	    state.modal = null;
  	    state.mounted = false;

  	    try {
  	      if (window.FIFCustomerCreationPortal && window.FIFCustomerCreationPortal.state === state) {
  	        delete window.FIFCustomerCreationPortal;
  	      }
  	    } catch (_) {}

  	    try {
  	      if (window.FIFCustomerAssetManager && window.FIFCustomerAssetManager.state === state) {
  	        delete window.FIFCustomerAssetManager;
  	      }
  	    } catch (_) {}
  	  }

  	  function bindTopBarCloseBehaviour() {
  	    rememberOwnTopBarLauncher();

  	    function handleTopBarActivation(event) {
  	      if (!state.mounted || state.destroying) return;

  	      const launcher = findTopBarLauncher(event.target, event);
  	      if (!launcher || isOwnTopBarLauncher(launcher)) return;

  	      // Do not prevent or stop the event. The selected application icon must
  	      // continue opening normally after this Manager has removed itself.
  	      destroyManager();
  	    }

  	    state.topBarPointerHandler = handleTopBarActivation;
  	    state.topBarClickHandler = handleTopBarActivation;

  	    state.applicationOpenHandler = function (event) {
  	      if (!state.mounted || state.destroying) return;

  	      const openedApplicationId = clean(
  	        event && event.detail && (
  	          event.detail.applicationId ||
  	          event.detail.id
  	        )
  	      );

  	      if (openedApplicationId && openedApplicationId !== APPLICATION_ID) {
  	        destroyManager();
  	      }
  	    };

  	    window.addEventListener(APPLICATION_OPEN_EVENT, state.applicationOpenHandler);

  	    // Delay registration so the click which launched this Manager cannot close it.
  	    state.topBarBindTimer = window.setTimeout(function () {
  	      state.topBarBindTimer = null;

  	      if (!state.mounted || state.destroying) return;

  	      document.addEventListener("pointerdown", state.topBarPointerHandler, true);
  	      document.addEventListener("click", state.topBarClickHandler, true);
  	    }, 0);

  	    try {
  	      window.dispatchEvent(new CustomEvent(APPLICATION_OPEN_EVENT, {
  	        detail: {
  	          applicationId: APPLICATION_ID,
  	          rootId: ROOT_ID
  	        }
  	      }));
  	    } catch (_) {}
  	  }

  	  function mount() {
  	    const previousApi =
  	      typeof window !== "undefined"
  	      ? window.FIFCustomerAssetManager || window.FIFCustomerCreationPortal
  	      : null;

  	    if (
  	      previousApi &&
  	      previousApi.state !== state &&
  	      typeof previousApi.destroy === "function"
  	    ) {
  	      try { previousApi.destroy(); } catch (_) {}
  	    }

  	    installStyles();
  	    const old = document.getElementById(ROOT_ID);
  	    if (old) old.remove();
  	    const root = document.createElement("div");
  	    root.id = ROOT_ID;
  	    root.innerHTML = `
  	      <div class="fif-layout">
  	        <aside class="fif-side">
  	          <div class="fif-brand">${logoHtml()}<div class="fif-brand-copy"><strong>Fleet In Form</strong><span>Customer & Asset Manager ${escapeHtml(VERSION)}</span></div></div>
  	          <nav class="fif-nav" data-region="nav"></nav>
  	          <div class="fif-side-foot">FIFM Platform Management</div>
  	        </aside>
  	        <section class="fif-main">
  	          <header class="fif-top" data-region="top"></header>
  	          <main class="fif-content" data-region="content"></main>
  	        </section>
  	      </div>
  	      <div class="fif-modal-layer" data-region="modal"></div>
  	      <div class="fif-operation" data-region="operation"><div class="fif-operation-card"><div class="fif-spinner"></div><h3>Working</h3><p data-operation-message>Please wait...</p></div></div>
  	      <div class="fif-toast"></div>
  	    `;
  	    state.priorBodyOverflow = document.body.style.overflow;
  	    document.body.style.overflow = "hidden";
  	    document.body.appendChild(root);
  	    state.root = root;
  	    state.mounted = true;
  	    root.addEventListener("click", handleClick);
  	    root.addEventListener("change", handleChange);
  	    root.addEventListener("input", handleInput);
  	    bindTopBarCloseBehaviour();
  	  }

  	  function renderNavigation() {
  	    const nav = state.root.querySelector('[data-region="nav"]');
  	    const items = [
  	      ["directors", "Director", "D"],
  	      ["companies", "Companies", "C"],
  	      ["employees", "Employees", "E"]
  	    ];
  	    nav.innerHTML = items.map(function (item) {
  	      return '<button type="button" class="' + (state.activeSection === item[0] ? "active" : "") + '" data-action="navigate" data-section="' + escapeAttr(item[0]) + '"><strong>' + escapeHtml(item[2]) + '</strong><span class="fif-nav-label">' + escapeHtml(item[1]) + "</span></button>";
  	    }).join("");
  	  }

  	  function renderTop() {
  	    const top = state.root.querySelector('[data-region="top"]');
  	    const initials = currentUserName().split(/\s+/).slice(0, 2).map(function (part) { return part.charAt(0); }).join("").toUpperCase() || "F";
  	    top.innerHTML = `
  	      <div class="fif-top-copy"><h1>${escapeHtml(pageTitle())}</h1><p>${escapeHtml(pageDescription())}</p></div>
  	      <button type="button" class="fif-button" data-action="reload">Reload Data</button>
  	      <div class="fif-user-chip"><div class="fif-avatar">${escapeHtml(initials)}</div><div><strong>${escapeHtml(currentUserName())}</strong><span>FIFM</span></div></div>
  	    `;
  	  }

  	  function manifestContactSearch(company) {
  	    const contacts = companyContacts(company);
  	    return [
  	      contacts.Primary && contacts.Primary.Name,
  	      contacts.Primary && contacts.Primary.Email,
  	      contacts.Primary && contacts.Primary.Phone,
  	      contacts.Billing && contacts.Billing.Name,
  	      contacts.Billing && contacts.Billing.Email,
  	      contacts.Billing && contacts.Billing.Phone
  	    ].filter(Boolean).join(" ");
  	  }

  	  function filteredCompanies() {
  	    const query = lower(state.search);
  	    if (!query) return state.companies;
  	    return state.companies.filter(function (company) {
  	      const profile = companyProfile(company);
  	      const account = companyBilling(company).Account;
  	      return [
  	        companyName(company),
  	        companyBusinessId(company),
  	        companyStatus(company),
  	        profile.TradingName,
  	        profile.RegistrationNumber,
  	        profile.VATNumber,
  	        profile.PrimaryEmail,
  	        profile.Email,
  	        account.AccountNumber,
  	        account.CustomerNumber,
  	        account.Status,
  	        account.InvoiceEmail,
  	        account.StatementEmail,
  	        account.PaymentTermsDays,
  	        account.CreditLimit,
  	        manifestContactSearch(company)
  	      ].some(function (value) { return lower(value).indexOf(query) !== -1; });
  	    });
  	  }

  	  function filteredUsers() {
  	    const query = lower(state.search);
  	    const rows = adminUsers();
  	    if (!query) return rows;
  	    return rows.filter(function (user) {
  	      const companyNames = arr(user.Companies).map(companyName).join(" ");
  	      return [userName(user), user.email, user.userStatus, companyNames, user.APP, user.Office, user.Settings, user.Role]
  	        .some(function (value) { return lower(value).indexOf(query) !== -1; });
  	    });
  	  }

  	  function filteredEmployees() {
  	    const query = lower(state.search);
  	    const rows = employeeUsers();
  	    if (!query) return rows;
  	    return rows.filter(function (user) {
  	      const companyNames = arr(user.Companies).map(companyName).join(" ");
  	      return [userName(user), user.email, user.userStatus, companyNames, user.APP, user.Office, user.Settings, user.Role, userOperationalRoles(user).join(" ")]
  	        .some(function (value) { return lower(value).indexOf(query) !== -1; });
  	    });
  	  }

  	  function filteredTrackedTractors() {
  	    const query = lower(state.search);
  	    return state.tractors.filter(isTrackedTractor).filter(function (tractor) {
  	      if (!query) return true;
  	      const tracking = tractorTrackerDetails(tractor);
  	      const company = companyForTractor(tractor);
  	      return [tractorRegistration(tractor), tractor.Tracker, tractor.Mileage, tracking.TrackerType, tracking.IMEI, company && companyName(company)]
  	        .some(function (value) { return lower(value).indexOf(query) !== -1; });
  	    });
  	  }

  	  function filteredNonTrackedTractors() {
  	    const query = lower(state.search);
  	    return state.tractors.filter(isNonTrackedTractor).filter(function (tractor) {
  	      if (!query) return true;
  	      const company = companyForTractor(tractor);
  	      return [tractorRegistration(tractor), tractor.Mileage, company && companyName(company)]
  	        .some(function (value) { return lower(value).indexOf(query) !== -1; });
  	    });
  	  }

  	  function filteredTrackedTrailers() {
  	    const query = lower(state.search);
  	    return state.trailers.filter(isTrackedTrailer).filter(function (trailer) {
  	      if (!query) return true;
  	      const tracking = trailerTrackerDetails(trailer);
  	      const company = companyForTrailer(trailer);
  	      return [trailerLabel(trailer), trailer.Tracker, trailer.Mileage, tracking.TrackerType, tracking.IMEI, company && companyName(company)]
  	        .some(function (value) { return lower(value).indexOf(query) !== -1; });
  	    });
  	  }

  	  function statusBadge(status) {
  	    const value = clean(status).toUpperCase();
  	    const cls = value === "ACTIVE" || value === "ENABLED" ? "good" : value === "SUSPENDED" ? "warn" : "bad";
  	    return '<span class="fif-badge ' + cls + '">' + escapeHtml(value) + "</span>";
  	  }

  	  function userStatusToggle(user, action) {
  	    const enabled = clean(user && user.userStatus).toUpperCase() !== "DISABLED";
  	    return '<button type="button" class="fif-status-toggle ' + (enabled ? "on" : "off") + '" data-action="' + escapeAttr(action) + '" data-id="' + escapeAttr(objectId(user)) + '" role="switch" aria-checked="' + (enabled ? "true" : "false") + '"><span></span><strong>' + (enabled ? "Enabled" : "Disabled") + '</strong></button>';
  	  }

  	  function renderCompanies() {
  	    const rows = filteredCompanies();
  	    const body = rows.length ? rows.map(function (company) {
  	      const profile = companyProfile(company);
  	      const active = companyIsActive(company);
  	      const trackedTractors = companyTrackedTractors(company).length;
  	      const nonTrackedTractors = companyNonTrackedTractors(company).length;
  	      const trackedTrailers = companyTrackedTrailers(company).length;
  	      const tanks = companyTanks(company).length;
  	      const bowsers = companyBowserCount(company);
  	      return `
  	        <tr>
  	          <td><span class="fif-row-title">${escapeHtml(companyName(company))}</span><span class="fif-row-sub">${escapeHtml(profile.TradingName || "No trading name")}</span></td>
  	          <td><span class="fif-row-title">${escapeHtml(profile.RegistrationNumber || "No registration number")}</span><span class="fif-row-sub">${profile.VATRegistered ? "VAT " + escapeHtml(profile.VATNumber || "number missing") : "Not VAT registered"}</span></td>
  	          <td><div class="fif-asset-counts"><span>TT ${trackedTractors}</span><span>NT ${nonTrackedTractors}</span><span>TR ${trackedTrailers}</span><span>Tank ${tanks}</span><span>Bow ${bowsers}</span><span>Contractors ${companyContractors(company).length}</span></div></td>
  	          <td><button type="button" class="fif-status-toggle ${active ? "on" : "off"}" data-action="toggle-company-status" data-id="${escapeAttr(objectId(company))}" role="switch" aria-checked="${active ? "true" : "false"}"><span></span><strong>${active ? "ON" : "OFF"}</strong></button></td>
  	          <td><button class="fif-button" data-action="manage-company" data-id="${escapeAttr(objectId(company))}">Manage</button></td>
  	        </tr>`;
  	    }).join("") : '<tr><td colspan="5"><div class="fif-empty">No Companies match the search.</div></td></tr>';
  	    return `
  	      <section class="fif-heading"><div><h2>Companies</h2><p>${rows.length} of ${state.companies.length}</p></div><div class="fif-actions"><input class="fif-search" type="search" value="${escapeAttr(state.search)}" data-action="search" placeholder="Search Companies"><button class="fif-button primary" data-action="new-company">New Company</button></div></section>
  	      <section class="fif-table-shell"><table><thead><tr><th>Company</th><th>Legal / VAT</th><th>Assets</th><th>Status</th><th>Action</th></tr></thead><tbody>${body}</tbody></table></section>`;
  	  }

  	  function renderUsers() {
  	    const rows = filteredUsers();
  	    const body = rows.length ? rows.map(function (user) {
  	      const companies = arr(user.Companies);
  	      return `
  	        <tr>
  	          <td><span class="fif-row-title">${escapeHtml(userName(user))}</span><span class="fif-row-sub">${escapeHtml(user.email || "No email")}</span></td>
  	          <td>${companies.length ? companies.map(function (company) { return '<span class="fif-badge">' + escapeHtml(companyName(company)) + "</span>"; }).join("") : '<span class="fif-badge bad">Unlinked</span>'}</td>
  	          <td><span class="fif-row-title">${escapeHtml(tokens(user.APP).join(", ") || "No APP")}</span><span class="fif-row-sub">${escapeHtml(tokens(user.Office).join(", ") || "No Office")}</span></td>
  	          <td>${userStatusToggle(user, "toggle-director-status")}</td>
  	          <td><button class="fif-mini" data-action="edit-user" data-id="${escapeAttr(objectId(user))}">Edit</button></td>
  	          <td class="fif-login-user-cell">${loginAsUserIcon(user)}</td>
  	        </tr>`;
  	    }).join("") : '<tr><td colspan="6"><div class="fif-empty">No Directors match the search.</div></td></tr>';
  	    return `
  	      <section class="fif-heading"><div><h2>Directors</h2><p>${rows.length} of ${adminUsers().length}</p></div><div class="fif-actions"><input class="fif-search" type="search" value="${escapeAttr(state.search)}" data-action="search" placeholder="Search Directors"><button class="fif-button primary" data-action="new-director">New Director</button></div></section>
  	      <section class="fif-table-shell"><table><thead><tr><th>Director</th><th>Companies</th><th>Access</th><th>Status</th><th>Action</th><th class="fif-login-user-head"><span class="fif-sr-only">Login as User</span></th></tr></thead><tbody>${body}</tbody></table></section>`;
  	  }

  	  function renderEmployees() {
  	    const rows = filteredEmployees();
  	    const body = rows.length ? rows.map(function (user) {
  	      const companies = arr(user.Companies);
  	      const roles = userOperationalRoles(user);
  	      return `
  	        <tr>
  	          <td><span class="fif-row-title">${escapeHtml(userName(user))}</span><span class="fif-row-sub">${escapeHtml(user.email || "No email")}</span></td>
  	          <td>${companies.length ? companies.map(function (company) { return '<span class="fif-badge">' + escapeHtml(companyName(company)) + "</span>"; }).join("") : '<span class="fif-badge bad">Unlinked</span>'}</td>
  	          <td><span class="fif-row-title">${escapeHtml(roles.join(", ") || "No role")}</span><span class="fif-row-sub">${escapeHtml(tokens(user.APP).join(", ") || "No APP")}</span></td>
  	          <td>${userStatusToggle(user, "toggle-employee-status")}</td>
  	          <td><button class="fif-mini" data-action="edit-user" data-id="${escapeAttr(objectId(user))}">Edit</button></td>
  	          <td class="fif-login-user-cell">${loginAsUserIcon(user)}</td>
  	        </tr>`;
  	    }).join("") : '<tr><td colspan="6"><div class="fif-empty">No Employees match the search.</div></td></tr>';
  	    return `
  	      <section class="fif-heading"><div><h2>Employees</h2><p>${rows.length} of ${employeeUsers().length}</p></div><div class="fif-actions"><input class="fif-search" type="search" value="${escapeAttr(state.search)}" data-action="search" placeholder="Search Employees"><button class="fif-button primary" data-action="new-employee">New Employee</button></div></section>
  	      <section class="fif-table-shell"><table><thead><tr><th>Employee</th><th>Companies</th><th>Role / Access</th><th>Status</th><th>Action</th><th class="fif-login-user-head"><span class="fif-sr-only">Login as User</span></th></tr></thead><tbody>${body}</tbody></table></section>`;
  	  }

  	  function renderContent() {
  	    const content = state.root.querySelector('[data-region="content"]');
  	    if (state.activeSection === "companies") content.innerHTML = renderCompanies();
  	    else if (state.activeSection === "employees") content.innerHTML = renderEmployees();
  	    else content.innerHTML = renderUsers();
  	  }

  	  function render() {
  	    if (!state.root) return;
  	    refreshAllCompanyContractorSnapshots();
  	    renderNavigation();
  	    renderTop();
  	    renderContent();
  	    renderModal();
  	  }

  	  function field(name, label, value, type, options) {
  	    options = options || {};
  	    const full = options.full ? " full" : "";
  	    const required = options.required ? " required" : "";
  	    const disabled = options.disabled ? " disabled" : "";
  	    let control = "";
  	    if (type === "select") {
  	      control = '<select class="fif-select" name="' + escapeAttr(name) + '"' + required + disabled + '>' + arr(options.values).map(function (option) {
  	        const optionValue = isObject(option) ? option.value : option;
  	        const optionLabel = isObject(option) ? option.label : option;
  	        return '<option value="' + escapeAttr(optionValue) + '"' + (clean(optionValue) === clean(value) ? " selected" : "") + '>' + escapeHtml(optionLabel) + "</option>";
  	      }).join("") + "</select>";
  	    } else if (type === "textarea") {
  	      control = '<textarea class="fif-textarea" name="' + escapeAttr(name) + '"' + required + disabled + '>' + escapeHtml(value) + "</textarea>";
  	    } else {
  	      control = '<input class="fif-input" type="' + escapeAttr(type || "text") + '" name="' + escapeAttr(name) + '" value="' + escapeAttr(value) + '"' + required + disabled + (options.placeholder ? ' placeholder="' + escapeAttr(options.placeholder) + '"' : "") + (options.min !== undefined ? ' min="' + escapeAttr(options.min) + '"' : "") + (options.max !== undefined ? ' max="' + escapeAttr(options.max) + '"' : "") + (options.step !== undefined ? ' step="' + escapeAttr(options.step) + '"' : "") + (options.autocomplete ? ' autocomplete="' + escapeAttr(options.autocomplete) + '"' : "") + ">";
  	    }
  	    return '<div class="fif-field' + full + '"><label>' + escapeHtml(label) + (options.required ? " *" : "") + "</label>" + control + (options.help ? '<div class="fif-help">' + escapeHtml(options.help) + "</div>" : "") + "</div>";
  	  }

  	  function checkGroup(name, label, values, selected, options) {
  	    options = options || {};
  	    const selectedValues = tokens(selected);
  	    return '<div class="fif-subsection" data-permission-section="' + escapeAttr(name) + '"><h3>' + escapeHtml(label) + '</h3><div class="fif-check-grid">' + arr(values).map(function (value) {
  	      return '<label class="fif-check"><input type="checkbox" name="' + escapeAttr(name) + '" value="' + escapeAttr(value) + '"' + (selectedValues.indexOf(value) !== -1 ? " checked" : "") + '><span><strong>' + escapeHtml(value) + "</strong></span></label>";
  	    }).join("") + "</div>" + (options.help ? '<div class="fif-help">' + escapeHtml(options.help) + "</div>" : "") + "</div>";
  	  }

  	  function modalFrame(title, body, footer, small) {
  	    return '<div class="fif-modal' + (small ? " small" : "") + '"><header class="fif-modal-head"><h2>' + escapeHtml(title) + '</h2><button type="button" class="fif-close" data-action="close-modal" aria-label="Close">X</button></header><main class="fif-modal-body">' + body + '</main><footer class="fif-modal-foot">' + footer + "</footer></div>";
  	  }

  	  function yesNo(value) {
  	    return value === true || lower(value) === "yes" || lower(value) === "true" ? "Yes" : "No";
  	  }

  	  function companyModal(existing) {
  	    const company = existing ? normalizeCompany(existing) : normalizeCompany({ Name: "", CompanyId: "", Status: "ACTIVE", Manifest: defaultCompanyManifest() });
  	    const manifest = companyManifest(company);
  	    const profile = manifest.Profile;
  	    const contacts = companyContacts(company);
  	    const addresses = companyAddresses(company);
  	    const account = companyBilling(company).Account;
  	    const compliance = manifest.Compliance;
  	    const body = `
  	      <form data-form="company" class="fif-form-grid">
  	        <input type="hidden" name="ObjectId" value="${escapeAttr(objectId(existing))}">
  	        <div class="fif-note full"><strong>Debtor master only.</strong> A new Company objectId is built from readable splices of the Registered Name and Trading Name, with legal suffixes removed and a strict 36-character maximum. Existing Company objectIds remain unchanged when names are edited.</div>

  	        <div class="fif-subsection"><h3>Legal identity</h3></div>
  	        ${field("Name", "Registered company name", existing ? companyName(company) : profile.RegisteredName || "", "text", { required: true })}
  	        ${field("TradingName", "Trading name", profile.TradingName || profile.Trading_As || "", "text", { required: true, help: existing ? "The existing objectId is retained when names change." : "The objectId splices both names. Example: Caldecott-Farming-The-Plains." })}
  	        ${field("CompanyId", "Debtor / customer identifier", companyBusinessId(company), "text", { required: true, help: "Your customer code or debtor account reference. This is not the Backendless objectId." })}
  	        <input type="hidden" name="Status" value="${companyIsActive(company) ? "ACTIVE" : "INACTIVE"}">
  	        ${field("RegistrationNumber", "Company registration number", profile.RegistrationNumber || "", "text")}
  	        ${field("EntityType", "Legal entity type", profile.EntityType || "", "select", { values: OPTIONS.EntityType })}
  	        ${field("TaxNumber", "Income tax number", profile.TaxNumber || "", "text")}
  	        ${field("VATRegistered", "VAT registered", yesNo(profile.VATRegistered), "select", { values: OPTIONS.YesNo })}
  	        ${field("VATNumber", "VAT number", profile.VATNumber || "", "text", { help: "Required when VAT Registered is Yes." })}

  	        <div class="fif-subsection"><h3>Company and primary contact</h3></div>
  	        ${field("PrimaryEmail", "General company email", profile.PrimaryEmail || profile.Email || "", "email")}
  	        ${field("Telephone", "General company telephone", profile.Telephone || "", "tel")}
  	        ${field("PrimaryContactName", "Primary contact name", contacts.Primary.Name || "", "text")}
  	        ${field("PrimaryContactRole", "Primary contact role", contacts.Primary.Role || "", "text")}
  	        ${field("PrimaryContactEmail", "Primary contact email", contacts.Primary.Email || profile.PrimaryEmail || "", "email")}
  	        ${field("PrimaryContactPhone", "Primary contact phone", contacts.Primary.Phone || profile.Telephone || "", "tel")}
  	        <input type="hidden" name="PrimaryContactAlternatePhone" value="${escapeAttr(contacts.Primary.AlternatePhone || "")}">

  	        <div class="fif-subsection"><h3>Accounts contact</h3></div>
  	        ${field("BillingContactName", "Accounts contact name", contacts.Billing.Name || "", "text")}
  	        ${field("BillingContactRole", "Accounts contact role", contacts.Billing.Role || "Accounts", "text")}
  	        ${field("BillingContactEmail", "Accounts contact email", contacts.Billing.Email || account.InvoiceEmail || "", "email")}
  	        ${field("BillingContactPhone", "Accounts contact phone", contacts.Billing.Phone || "", "tel")}
  	        <input type="hidden" name="BillingContactAlternatePhone" value="${escapeAttr(contacts.Billing.AlternatePhone || "")}">

  	        <div class="fif-subsection"><h3>Registered address</h3></div>
  	        ${field("RegisteredLine1", "Address line 1", addresses.Registered.Line1 || "", "text")}
  	        ${field("RegisteredLine2", "Address line 2", addresses.Registered.Line2 || "", "text")}
  	        ${field("RegisteredSuburb", "Suburb", addresses.Registered.Suburb || "", "text")}
  	        ${field("RegisteredCity", "City / town", addresses.Registered.City || "", "text")}
  	        ${field("RegisteredProvince", "Province", addresses.Registered.Province || "", "text")}
  	        ${field("RegisteredPostalCode", "Postal code", addresses.Registered.PostalCode || "", "text")}
  	        ${field("RegisteredCountry", "Country", addresses.Registered.Country || "South Africa", "text")}

  	        <div class="fif-subsection"><h3>Billing address</h3></div>
  	        ${field("BillingLine1", "Address line 1", addresses.Billing.Line1 || "", "text")}
  	        ${field("BillingLine2", "Address line 2", addresses.Billing.Line2 || "", "text")}
  	        ${field("BillingSuburb", "Suburb", addresses.Billing.Suburb || "", "text")}
  	        ${field("BillingCity", "City / town", addresses.Billing.City || "", "text")}
  	        ${field("BillingProvince", "Province", addresses.Billing.Province || "", "text")}
  	        ${field("BillingPostalCode", "Postal code", addresses.Billing.PostalCode || "", "text")}
  	        ${field("BillingCountry", "Country", addresses.Billing.Country || "South Africa", "text")}

  	        <div class="fif-subsection"><h3>Debtor account</h3></div>
  	        ${field("BillingAccountNumber", "Debtor account number", account.AccountNumber || companyBusinessId(company), "text")}
  	        ${field("CustomerNumber", "Customer number", account.CustomerNumber || companyBusinessId(company), "text")}
  	        ${field("BillingStatus", "Account status", account.Status || "ACTIVE", "select", { values: OPTIONS.BillingStatus })}
  	        ${field("Currency", "Currency", account.Currency || "ZAR", "select", { values: OPTIONS.Currency })}
  	        ${field("TaxRate", "VAT / tax rate %", account.TaxRate === undefined ? 15 : account.TaxRate, "number", { min: 0, step: 0.01 })}
  	        ${field("PaymentTermsDays", "Payment terms in days", account.PaymentTermsDays === undefined ? 30 : account.PaymentTermsDays, "number", { min: 0, step: 1 })}
  	        ${field("CreditLimit", "Credit limit", account.CreditLimit || 0, "number", { min: 0, step: 0.01 })}
  	        ${field("InvoiceEmail", "Invoice email", account.InvoiceEmail || contacts.Billing.Email || profile.PrimaryEmail || "", "email")}
  	        ${field("StatementEmail", "Statement email", account.StatementEmail || account.InvoiceEmail || contacts.Billing.Email || "", "email")}
  	        ${field("PurchaseOrderRequired", "Purchase order required", yesNo(account.PurchaseOrderRequired), "select", { values: OPTIONS.YesNo })}
  	        ${field("DefaultPurchaseOrder", "Default purchase order / reference", account.DefaultPurchaseOrder || "", "text")}
  	        ${field("BillingReference", "Internal debtor reference", account.Reference || "", "text")}
  	        ${field("BillingNotes", "Debtor notes", account.Notes || "", "textarea", { full: true })}

  	        <div class="fif-subsection"><h3>Verification</h3></div>
  	        ${field("CompanyRegistrationVerified", "Company registration verified", yesNo(compliance.CompanyRegistrationVerified), "select", { values: OPTIONS.YesNo })}
  	        ${field("VATVerified", "VAT details verified", yesNo(compliance.VATVerified), "select", { values: OPTIONS.YesNo })}
  	        ${field("BillingApproved", "Debtor account approved", yesNo(compliance.BillingApproved), "select", { values: OPTIONS.YesNo })}


  	      </form>
  	    `;
  	    const footer = '<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-company">' + (existing ? "Save Debtor" : "Create Debtor Company") + '</button>';
  	    return modalFrame(existing ? "Edit Debtor Company" : "New Debtor Company", body, footer, false);
  	  }

  	  function companyManagerModal(company) {
  	    const body = `
  	      <div class="fif-manage-grid">
  	        <button class="fif-manage-card" data-action="edit-company" data-id="${escapeAttr(objectId(company))}"><strong>Edit Company</strong></button>
  	        <button class="fif-manage-card" data-action="manage-contractors" data-company-id="${escapeAttr(objectId(company))}"><strong>Contractors</strong><span>${companyContractors(company).length} linked Companies</span></button>
  	        <button class="fif-manage-card" data-action="manage-assets" data-kind="tracked-tractor" data-company-id="${escapeAttr(objectId(company))}"><strong>Tracked Tractors</strong></button>
  	        <button class="fif-manage-card" data-action="manage-assets" data-kind="nontracked-tractor" data-company-id="${escapeAttr(objectId(company))}"><strong>Non-Tracked Tractors</strong></button>
  	        <button class="fif-manage-card" data-action="manage-assets" data-kind="tracked-trailer" data-company-id="${escapeAttr(objectId(company))}"><strong>Tracked Trailers</strong></button>
  	        <button class="fif-manage-card" data-action="manage-assets" data-kind="beacon-trailer" data-company-id="${escapeAttr(objectId(company))}"><strong>Beacon Trailers</strong></button>
  	        <button class="fif-manage-card" data-action="manage-assets" data-kind="tank" data-company-id="${escapeAttr(objectId(company))}"><strong>Tanks & Bowsers</strong></button>
  	      </div>`;
  	    return modalFrame("Manage — " + companyName(company), body, '<button class="fif-button" data-action="close-modal">Close</button>', false);
  	  }

  	  function companyContractorsModal(company) {
  	    const clientId = objectId(company);
  	    const linkedIds = new Set(companyContractors(company).map(objectId));
  	    const linked = companyContractors(company).slice().sort(function (a, b) {
  	      return companyName(a).localeCompare(companyName(b), undefined, { sensitivity: "base", numeric: true });
  	    });
  	    const available = state.companies.filter(function (candidate) {
  	      return objectId(candidate) !== clientId && !linkedIds.has(objectId(candidate));
  	    }).sort(function (a, b) {
  	      return companyName(a).localeCompare(companyName(b), undefined, { sensitivity: "base", numeric: true });
  	    });
  	    const linkedRows = linked.map(function (candidate) {
  	      return '<tr><td><strong>' + escapeHtml(companyName(candidate)) + '</strong><span class="fif-row-sub">' +
  	        escapeHtml(companyBusinessId(candidate) || objectId(candidate)) +
  	        ' · ' + (companyIsActive(candidate) ? 'ACTIVE' : 'INACTIVE') +
  	        '</span></td><td><div class="fif-actions"><button class="fif-mini" data-action="unlink-contractor" data-company-id="' +
  	        escapeAttr(clientId) + '" data-id="' + escapeAttr(objectId(candidate)) + '">Unlink</button></div></td></tr>';
  	    }).join('') || '<tr><td colspan="2"><div class="fif-empty">No contractor Companies linked.</div></td></tr>';
  	    const availableRows = available.map(function (candidate) {
  	      return '<tr data-contractor-option="' + escapeAttr(lower(companyName(candidate) + ' ' + companyBusinessId(candidate))) +
  	        '"><td><strong>' + escapeHtml(companyName(candidate)) + '</strong><span class="fif-row-sub">' +
  	        escapeHtml(companyBusinessId(candidate) || objectId(candidate)) +
  	        ' · ' + (companyIsActive(candidate) ? 'ACTIVE' : 'INACTIVE') +
  	        '</span></td><td><div class="fif-actions"><button class="fif-mini" data-action="link-contractor" data-company-id="' +
  	        escapeAttr(clientId) + '" data-id="' + escapeAttr(objectId(candidate)) + '">Link</button></div></td></tr>';
  	    }).join('') || '<tr><td colspan="2"><div class="fif-empty">No other Companies available.</div></td></tr>';
  	    const body = '<div class="fif-note"><strong>Directional contractor link:</strong> ' +
  	      escapeHtml(companyName(company)) +
  	      ' is the client. Linked Companies keep their own identity, Tractors, Employees and assets. The link does not grant user access or transfer ownership.</div>' +
  	      '<div class="fif-subsection"><h3>Linked Contractors (' + linked.length + ')</h3></div>' +
  	      '<section class="fif-table-shell"><table><thead><tr><th>Company</th><th>Action</th></tr></thead><tbody>' + linkedRows + '</tbody></table></section>' +
  	      '<div class="fif-subsection"><h3>Available Companies (' + available.length + ')</h3>' +
  	      '<input class="fif-search" type="search" data-action="contractor-filter" placeholder="Filter Companies" aria-label="Filter available Companies"></div>' +
  	      '<section class="fif-table-shell"><table><thead><tr><th>Company</th><th>Action</th></tr></thead><tbody>' + availableRows + '</tbody></table></section>';
  	    return modalFrame('Contractors — ' + companyName(company), body,
  	      '<button class="fif-button" data-action="manage-company" data-id="' + escapeAttr(clientId) + '">Back</button>', false);
  	  }

  	  function assetManagerModal(company, kind) {
  	    const linked = companyAssetsForKind(company, kind);
  	    const available = availableAssetsForCompany(company, kind);
  	    const title = kind === "tracked-tractor" ? "Tracked Tractors" : kind === "nontracked-tractor" ? "Non-Tracked Tractors" : kind === "tracked-trailer" ? "Tracked Trailers" : kind === "beacon-trailer" ? "Beacon Trailers" : "Tanks & Bowsers";
  	    const linkedRows = linked.length ? linked.map(function (asset) {
  	      let detail = "";
  	      let actions = '<button class="fif-mini" data-action="unlink-asset" data-kind="' + escapeAttr(kind) + '" data-company-id="' + escapeAttr(objectId(company)) + '" data-id="' + escapeAttr(objectId(asset)) + '">Unlink</button>';
  	      if (kind === "tracked-tractor") {
  	        detail = "Flespi " + clean(asset.Tracker) + " · " + tractorReadingSummary(asset);
  	        actions = '<button class="fif-mini" data-action="edit-tractor-mileage" data-kind="' + escapeAttr(kind) + '" data-company-id="' + escapeAttr(objectId(company)) + '" data-id="' + escapeAttr(objectId(asset)) + '">Mileage</button>' + actions;
  	        actions += '<button class="fif-mini danger" data-action="delete-tracked-tractor" data-id="' + escapeAttr(objectId(asset)) + '">Delete</button>';
  	      } else if (kind === "nontracked-tractor") {
  	        detail = tractorReadingSummary(asset);
  	        actions = '<button class="fif-mini" data-action="edit-tractor-mileage" data-kind="' + escapeAttr(kind) + '" data-company-id="' + escapeAttr(objectId(company)) + '" data-id="' + escapeAttr(objectId(asset)) + '">Mileage</button>' + actions;
  	        actions += '<button class="fif-mini danger" data-action="delete-nontracked-tractor" data-id="' + escapeAttr(objectId(asset)) + '">Delete</button>';
  	      } else if (kind === "tracked-trailer") {
  	        detail = "Flespi " + clean(asset.Tracker);
  	        actions += '<button class="fif-mini danger" data-action="delete-tracked-trailer" data-id="' + escapeAttr(objectId(asset)) + '">Delete</button>';
  	      } else if (kind === "beacon-trailer") {
  	        detail = "EYEID " + clean(asset.EYEID);
  	      } else if (kind === "tank") {
  	        detail = clean(asset.Grade) + " · " + Number(asset.Volume || 0) + " / " + Number(asset.Capacity || 0) + " L" + (asset.Trailer ? " · Trailer Tank" : "");
  	        actions = '<button class="fif-mini" data-action="edit-tank-location" data-company-id="' + escapeAttr(objectId(company)) + '" data-tank-id="' + escapeAttr(objectId(asset)) + '">' + (asset.Location && objectId(asset.Location) ? "Edit Location" : "Add Location") + '</button><button class="fif-mini" data-action="manage-bowsers" data-company-id="' + escapeAttr(objectId(company)) + '" data-tank-id="' + escapeAttr(objectId(asset)) + '">Bowsers</button>' + actions;
  	      }
  	      return '<tr><td><strong>' + escapeHtml(assetLabel(asset, kind)) + '</strong><span class="fif-row-sub">' + escapeHtml(detail) + '</span></td><td><div class="fif-actions">' + actions + '</div></td></tr>';
  	    }).join("") : '<tr><td colspan="2"><div class="fif-empty">None linked.</div></td></tr>';
  	    const availableRows = available.length ? available.map(function (asset) {
  	      let availableActions = '<button class="fif-mini" data-action="link-asset" data-kind="' + escapeAttr(kind) + '" data-company-id="' + escapeAttr(objectId(company)) + '" data-id="' + escapeAttr(objectId(asset)) + '">Link</button>';
  	      let availableDetail = "";
  	      if (kind === "tracked-tractor" || kind === "nontracked-tractor") {
  	        availableDetail = tractorReadingSummary(asset);
  	        availableActions = '<button class="fif-mini" data-action="edit-tractor-mileage" data-kind="' + escapeAttr(kind) + '" data-company-id="' + escapeAttr(objectId(company)) + '" data-id="' + escapeAttr(objectId(asset)) + '">Mileage</button>' + availableActions;
  	      }
  	      return '<tr><td><strong>' + escapeHtml(assetLabel(asset, kind)) + '</strong>' + (availableDetail ? '<span class="fif-row-sub">' + escapeHtml(availableDetail) + '</span>' : '') + '</td><td><div class="fif-actions">' + availableActions + '</div></td></tr>';
  	    }).join("") : '<tr><td colspan="2"><div class="fif-empty">Nothing available.</div></td></tr>';
  	    const createAction = kind === "tracked-tractor" ? "new-tracked-tractor" : kind === "nontracked-tractor" ? "new-nontracked-tractor" : kind === "tracked-trailer" ? "new-tracked-trailer" : kind === "beacon-trailer" ? "new-beacon-trailer" : "new-tank";
  	    const body = '<section class="fif-table-shell"><table><thead><tr><th>Linked</th><th>Actions</th></tr></thead><tbody>' + linkedRows + '</tbody></table></section><div class="fif-subsection"><h3>Available to link</h3></div><section class="fif-table-shell"><table><tbody>' + availableRows + '</tbody></table></section>';
  	    const footer = '<button class="fif-button" data-action="manage-company" data-id="' + escapeAttr(objectId(company)) + '">Back</button><button class="fif-button primary" data-action="' + createAction + '" data-company-id="' + escapeAttr(objectId(company)) + '">Create</button>';
  	    return modalFrame(title + " — " + companyName(company), body, footer, false);
  	  }

  	  function companySelectOptions() {
  	    return [{ value: "", label: "Select Company" }].concat(state.companies.map(function (company) {
  	      return { value: objectId(company), label: companyName(company) };
  	    }));
  	  }

  	  function tractorMileageModal(tractor, companyId, assetKind) {
  	    const unit = tractorReadingUnit(tractor);
  	    const reading = tractorCurrentReading(tractor);
  	    const label = unit === "h" ? "Current hours" : "Current mileage";
  	    const suffix = unit === "h" ? " h" : " km";
  	    const body = '<form data-form="tractor-mileage" class="fif-form-grid">' +
  	      '<input type="hidden" name="TractorId" value="' + escapeAttr(objectId(tractor)) + '">' +
  	      '<input type="hidden" name="CompanyId" value="' + escapeAttr(companyId || "") + '">' +
  	      '<input type="hidden" name="AssetKind" value="' + escapeAttr(assetKind || (isTrackedTractor(tractor) ? "tracked-tractor" : "nontracked-tractor")) + '">' +
  	      field("Reading", label, String(reading), "number", { required: true, min: 0, step: 0.1, full: true }) +
  	      '<div class="fif-help" style="grid-column:1/-1">Current stored reading: <strong>' + escapeHtml(String(reading) + suffix) + '</strong>. Saving changes Tractor.Mileage, Data.Vehicle.Usage.CurrentReading and the current ViewC MeterEnd only. Fuel transactions, tyre mileage and historical ViewH records are not rewritten.</div>' +
  	      '</form>';
  	    const footer = '<button class="fif-button" data-action="manage-assets" data-kind="' + escapeAttr(assetKind || (isTrackedTractor(tractor) ? "tracked-tractor" : "nontracked-tractor")) + '" data-company-id="' + escapeAttr(companyId || "") + '">Cancel</button><button class="fif-button primary" data-action="save-tractor-mileage">Save Mileage</button>';
  	    return modalFrame("Edit Mileage — " + tractorRegistration(tractor), body, footer, true);
  	  }

  	  function trackedTractorModal(companyId) {
  	    const body = '<form data-form="tracked-tractor" class="fif-form-grid">' +
  	      field("CompanyId", "Company", companyId || "", "select", { values: companySelectOptions(), required: true, full: true }) +
  	      field("Registration", "Registration", "", "text", { required: true }) +
  	      field("Mileage", "Mileage", "0", "number", { required: true, min: 0, step: 1 }) +
  	      field("TrackerTypeId", "Tracker type", "", "select", { values: trackerTypeOptions(""), required: true }) +
  	      '<input type="hidden" name="TrackerTypeName" value="">' +
  	      field("IMEI", "IMEI", "", "text", { required: true, placeholder: "15 digits" }) +
  	      '</form>';
  	    return modalFrame("Create Tracked Tractor", body, '<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-tracked-tractor">Create</button>', false);
  	  }

  	  function nonTrackedTractorModal(companyId) {
  	    const body = '<form data-form="nontracked-tractor" class="fif-form-grid">' +
  	      field("CompanyId", "Company", companyId || "", "select", { values: companySelectOptions(), required: true, full: true }) +
  	      field("Registration", "Registration", "", "text", { required: true }) +
  	      field("Mileage", "Mileage", "0", "number", { required: true, min: 0, step: 1 }) +
  	      '</form>';
  	    return modalFrame("Create Non-Tracked Tractor", body, '<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-nontracked-tractor">Create</button>', false);
  	  }

  	  function trackedTrailerModal(companyId) {
  	    const body = '<form data-form="tracked-trailer" class="fif-form-grid">' +
  	      field("CompanyId", "Company", companyId || "", "select", { values: companySelectOptions(), required: true, full: true }) +
  	      field("Registration", "Registration", "", "text", { required: true }) +
  	      field("Mileage", "Mileage", "0", "number", { required: true, min: 0, step: 1 }) +
  	      field("TrackerTypeId", "Tracker type", "", "select", { values: trackerTypeOptions(""), required: true }) +
  	      '<input type="hidden" name="TrackerTypeName" value="">' +
  	      field("IMEI", "IMEI", "", "text", { required: true, placeholder: "15 digits" }) +
  	      '</form>';
  	    return modalFrame("Create Tracked Trailer", body, '<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-tracked-trailer">Create</button>', false);
  	  }

  	  function beaconTrailerModal(companyId) {
  	    const body = '<form data-form="beacon-trailer" class="fif-form-grid">' +
  	      field("CompanyId", "Company", companyId || "", "select", { values: companySelectOptions(), required: true, full: true }) +
  	      field("Registration", "Registration", "", "text", { required: true }) +
  	      field("Mileage", "Mileage", "0", "number", { required: true, min: 0, step: 1 }) +
  	      field("EYEID", "EYEID", "", "text", { required: true, full: true, placeholder: "Beacon EYEID" }) +
  	      '</form>';
  	    return modalFrame("Create Beacon Trailer", body, '<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-beacon-trailer">Create</button>', false);
  	  }

  	  async function openTrackedVehicleModal(kind, companyId) {
  	    beginOperation("Loading tracker types...");
  	    try {
  	      await loadTrackerTypes(false);
  	      endOperation();
  	      state.modal = { kind: kind, companyId: clean(companyId) };
  	      renderModal();
  	    } catch (error) {
  	      failOperation(error);
  	      throw error;
  	    }
  	  }

  	  function populateTrackerTypeName(form) {
  	    const select = form && form.elements.namedItem("TrackerTypeId");
  	    const hidden = form && form.elements.namedItem("TrackerTypeName");
  	    if (!select || !hidden) return;
  	    const selected = state.trackerTypes.find(function (row) { return row.id === clean(select.value); });
  	    hidden.value = selected ? selected.name : "";
  	  }

  	  async function saveTrackedTractorFromModal() {
  	    const form = state.root.querySelector('[data-form="tracked-tractor"]');
  	    if (!form) throw new Error("The form is unavailable.");
  	    populateTrackerTypeName(form);
  	    const companyId = clean(form.elements.namedItem("CompanyId").value);
  	    beginOperation("Creating tracked Tractor...");
  	    try {
  	      const saved = await createTrackedTractor(form);
  	      endOperation();
  	      state.activeSection = "companies";
  	      state.modal = companyId ? { kind: "asset-manager", assetKind: "tracked-tractor", companyId: companyId } : null;
  	      render();
  	      showToast(tractorRegistration(saved) + " created.", "success");
  	    } catch (error) { failOperation(error); throw error; }
  	  }

  	  async function saveTractorMileageFromModal() {
  	    const form = state.root.querySelector('[data-form="tractor-mileage"]');
  	    if (!form) throw new Error("The mileage form is unavailable.");

  	    const data = new FormData(form);
  	    const tractorId = clean(data.get("TractorId"));
  	    const companyId = clean(data.get("CompanyId"));
  	    const assetKind = clean(data.get("AssetKind")) || "tracked-tractor";
  	    const reading = formNumber(data, "Reading", NaN);

  	    beginOperation("Updating vehicle mileage...");
  	    try {
  	      const saved = await updateTractorMileage(tractorId, reading);
  	      endOperation();
  	      state.modal = companyId
  	        ? { kind: "asset-manager", assetKind: assetKind, companyId: companyId }
  	        : null;
  	      render();
  	      showToast(tractorRegistration(saved) + " mileage updated to " + String(tractorCurrentReading(saved)) + (tractorReadingUnit(saved) === "h" ? " h." : " km."), "success", 6500);
  	    } catch (error) {
  	      failOperation(error);
  	      throw error;
  	    }
  	  }

  	  async function saveNonTrackedTractorFromModal() {
  	    const form = state.root.querySelector('[data-form="nontracked-tractor"]');
  	    if (!form) throw new Error("The form is unavailable.");
  	    const companyId = clean(form.elements.namedItem("CompanyId").value);
  	    beginOperation("Creating non-tracked Tractor...");
  	    try {
  	      const saved = await createNonTrackedTractor(form);
  	      endOperation();
  	      state.activeSection = "companies";
  	      state.modal = companyId ? { kind: "asset-manager", assetKind: "nontracked-tractor", companyId: companyId } : null;
  	      render();
  	      showToast(tractorRegistration(saved) + " created.", "success");
  	    } catch (error) { failOperation(error); throw error; }
  	  }

  	  async function saveTrackedTrailerFromModal() {
  	    const form = state.root.querySelector('[data-form="tracked-trailer"]');
  	    if (!form) throw new Error("The form is unavailable.");
  	    populateTrackerTypeName(form);
  	    const companyId = clean(form.elements.namedItem("CompanyId").value);
  	    beginOperation("Creating tracked Trailer...");
  	    try {
  	      const saved = await createTrackedTrailer(form);
  	      endOperation();
  	      state.activeSection = "companies";
  	      state.modal = companyId ? { kind: "asset-manager", assetKind: "tracked-trailer", companyId: companyId } : null;
  	      render();
  	      showToast(trailerLabel(saved) + " created.", "success");
  	    } catch (error) { failOperation(error); throw error; }
  	  }

  	  async function saveBeaconTrailerFromModal() {
  	    const form = state.root.querySelector('[data-form="beacon-trailer"]');
  	    if (!form) throw new Error("The form is unavailable.");
  	    const companyId = clean(form.elements.namedItem("CompanyId").value);
  	    beginOperation("Creating Beacon Trailer...");
  	    try {
  	      const saved = await createBeaconTrailer(form);
  	      endOperation();
  	      state.activeSection = "companies";
  	      state.modal = companyId ? { kind: "asset-manager", assetKind: "beacon-trailer", companyId: companyId } : null;
  	      render();
  	      showToast(trailerLabel(saved) + " Beacon Trailer created.", "success");
  	    } catch (error) { failOperation(error); throw error; }
  	  }

  	  function tankModal(companyId) {
  	    const company = companyById(companyId);
  	    const body = '<form data-form="tank" class="fif-form-grid">' +
  	      '<input type="hidden" name="CompanyId" value="' + escapeAttr(companyId) + '">' +
  	      field("Name", "Tank name", "", "text", { required: true }) +
  	      field("DeviceId", "Internal Tank code / DeviceId", "", "text", { required: true, help: "Internal fuel-system identifier only; this is not a tracker." }) +
  	      field("Grade", "Fuel grade", "Diesel 50ppm", "select", { required: true, values: OPTIONS.FuelGrade }) +
  	      field("Color", "Display colour", "#4caf50", "color") +
  	      field("Capacity", "Capacity litres", "23000", "number", { required: true, min: 1, step: 1 }) +
  	      field("Volume", "Opening volume litres", "0", "number", { required: true, min: 0, step: 0.01 }) +
  	      field("OrderThreshold", "Order threshold litres", "3000", "number", { min: 0, step: 1 }) +
  	      field("DefaultOrderVolume", "Default order volume litres", "10000", "number", { min: 0, step: 1 }) +
  	      field("PrimarySupplier", "Primary supplier", "", "text") +
  	      field("PrimarySupplierId", "Primary supplier ID", "", "text") +
  	      '<div class="fif-field full fif-trailer-toggle-field">' +
  	        '<label class="fif-form-toggle">' +
  	          '<input type="checkbox" name="Trailer" value="true" aria-label="Trailer Tank">' +
  	          '<span class="fif-form-toggle-track" aria-hidden="true"></span>' +
  	          '<span class="fif-form-toggle-copy"><strong>Trailer Tank</strong><small>Turn on when this mobile Tank is mounted on a trailer. Saves directly to Tanks.Trailer.</small></span>' +
  	        '</label>' +
  	      '</div>' +
  	      '<section class="fif-tank-map-shell">' +
  	        '<div class="fif-tank-map-head">' +
  	          '<div><strong>Tank polygon location (optional)</strong><small>Leave the map blank when this Tank does not need a Location. Draw at least three points only when a polygon Location is required.</small></div>' +
  	          '<div class="fif-tank-map-actions">' +
  	            '<button type="button" data-tank-map-control="locate">My Location</button>' +
  	            '<button type="button" data-tank-map-control="fit">Fit Polygon</button>' +
  	            '<button type="button" data-tank-map-control="undo">Undo Point</button>' +
  	            '<button type="button" data-tank-map-control="clear">Clear</button>' +
  	          '</div>' +
  	        '</div>' +
  	        '<div class="fif-tank-map" data-tank-location-map></div>' +
  	        '<div class="fif-tank-map-foot">' +
  	          '<span class="fif-tank-map-status ready" data-tank-map-status>Location is optional. Leave the map blank to create the Tank without a Location.</span>' +
  	          '<span class="fif-tank-map-stats"><span>Points: <span data-tank-map-points>0</span></span><span>Area: <span data-tank-map-area>0 m²</span></span></span>' +
  	        '</div>' +
  	      '</section>' +
  	      '</form>';
  	    return modalFrame(
  	      "Create Backendless Tank",
  	      body,
  	      '<button class="fif-button" data-action="manage-assets" data-kind="tank" data-company-id="' + escapeAttr(companyId) + '">Back</button><button class="fif-button primary" data-action="save-tank">Create Tank</button>',
  	      false
  	    );
  	  }

  	  function tankLocationModal(companyId, tankId) {
  	    const company = companyById(companyId);
  	    const tank = tankForCompany(companyId, tankId);
  	    if (!company || !tank) {
  	      return modalFrame("Tank unavailable", '<div class="fif-empty">The selected Tank is unavailable.</div>', '<button class="fif-button" data-action="manage-assets" data-kind="tank" data-company-id="' + escapeAttr(companyId) + '">Back</button>', true);
  	    }

  	    const hasLocation = !!(tank.Location && objectId(tank.Location));
  	    const body = '<form data-form="tank-location" class="fif-form-grid">' +
  	      '<input type="hidden" name="CompanyId" value="' + escapeAttr(companyId) + '">' +
  	      '<input type="hidden" name="TankId" value="' + escapeAttr(tankId) + '">' +
  	      '<div class="fif-note full"><strong>' + escapeHtml(companyName(company)) + ' — ' + escapeHtml(tankLabel(tank)) + '</strong> · ' + (hasLocation ? 'Edit the existing polygon Location.' : 'Add a polygon Location to this existing Tank.') + ' This is Backendless-only and creates no tracker or Flespi record.</div>' +
  	      '<section class="fif-tank-map-shell">' +
  	        '<div class="fif-tank-map-head">' +
  	          '<div><strong>Tank polygon Location *</strong><small>Click to add orange points. Drag a point to move it; right-click a point to remove it.</small></div>' +
  	          '<div class="fif-tank-map-actions">' +
  	            '<button type="button" data-tank-map-control="locate">My Location</button>' +
  	            '<button type="button" data-tank-map-control="fit">Fit Polygon</button>' +
  	            '<button type="button" data-tank-map-control="undo">Undo Point</button>' +
  	            '<button type="button" data-tank-map-control="clear">Clear</button>' +
  	          '</div>' +
  	        '</div>' +
  	        '<div class="fif-tank-map" data-tank-location-map></div>' +
  	        '<div class="fif-tank-map-foot">' +
  	          '<span class="fif-tank-map-status" data-tank-map-status>Loading Google Map...</span>' +
  	          '<span class="fif-tank-map-stats"><span>Points: <span data-tank-map-points>0</span></span><span>Area: <span data-tank-map-area>0 m²</span></span></span>' +
  	        '</div>' +
  	      '</section>' +
  	      '</form>';

  	    return modalFrame(
  	      (hasLocation ? "Edit" : "Add") + " Tank Polygon Location",
  	      body,
  	      '<button class="fif-button" data-action="manage-assets" data-kind="tank" data-company-id="' + escapeAttr(companyId) + '">Back</button><button class="fif-button primary" data-action="save-tank-location" disabled>' + (hasLocation ? "Save Location" : "Create & Link Location") + '</button>',
  	      false
  	    );
  	  }

  	  function bowserManagerModal(companyId, tankId) {
  	    const company = companyById(companyId);
  	    const tank = tankForCompany(companyId, tankId);
  	    if (!company || !tank) {
  	      return modalFrame("Tank unavailable", '<div class="fif-empty">The selected Tank is unavailable.</div>', '<button class="fif-button" data-action="manage-assets" data-kind="tank" data-company-id="' + escapeAttr(companyId) + '">Back</button>', true);
  	    }

  	    const bowsers = arr(tank.Bowsers).map(normalizeBowser);
  	    const rows = bowsers.length ? bowsers.map(function (bowser) {
  	      return '<tr><td><span class="fif-row-title">' + escapeHtml(bowser.Name) + '</span><span class="fif-row-sub">' + escapeHtml(clean(bowser.Grade || tank.Grade || "-")) + '</span></td><td>' + escapeHtml(String(Number(bowser.Meter || 0))) + '</td><td><button class="fif-mini" data-action="unlink-bowser" data-company-id="' + escapeAttr(companyId) + '" data-tank-id="' + escapeAttr(tankId) + '" data-id="' + escapeAttr(objectId(bowser)) + '">Unlink</button></td></tr>';
  	    }).join("") : '<tr><td colspan="3"><div class="fif-empty">No Bowsers linked.</div></td></tr>';

  	    const available = availableBowsers();
  	    const availableRows = available.length ? available.map(function (bowser) {
  	      return '<tr><td><span class="fif-row-title">' + escapeHtml(bowser.Name) + '</span><span class="fif-row-sub">' + escapeHtml(clean(bowser.Grade || "-")) + '</span></td><td>' + escapeHtml(String(Number(bowser.Meter || 0))) + '</td><td><button class="fif-mini" data-action="link-bowser" data-company-id="' + escapeAttr(companyId) + '" data-tank-id="' + escapeAttr(tankId) + '" data-id="' + escapeAttr(objectId(bowser)) + '">Link</button></td></tr>';
  	    }).join("") : '<tr><td colspan="3"><div class="fif-empty">No unlinked Bowsers available.</div></td></tr>';

  	    const body = '<section class="fif-table-shell"><table><thead><tr><th>Linked Bowser</th><th>Meter</th><th>Action</th></tr></thead><tbody>' + rows + '</tbody></table></section>' +
  	      '<div class="fif-subsection"><h3>Available to link</h3></div><section class="fif-table-shell"><table><tbody>' + availableRows + '</tbody></table></section>';

  	    const footer = '<button class="fif-button" data-action="manage-assets" data-kind="tank" data-company-id="' + escapeAttr(companyId) + '">Back to Tanks</button>' +
  	      '<button class="fif-button primary" data-action="new-bowser" data-company-id="' + escapeAttr(companyId) + '" data-tank-id="' + escapeAttr(objectId(tank)) + '">Create Bowser</button>';

  	    return modalFrame("Bowsers — " + tankLabel(tank), body, footer, false);
  	  }

  	  function bowserModal(companyId, tankId) {
  	    const company = companyById(companyId);
  	    const tank = tankForCompany(companyId, tankId);
  	    const body = '<form data-form="bowser" class="fif-form-grid">' +
  	      '<input type="hidden" name="CompanyId" value="' + escapeAttr(companyId) + '">' +
  	      '<input type="hidden" name="TankId" value="' + escapeAttr(tankId) + '">' +
  	      field("Name", "Bowser / nozzle name", "", "text", { required: true }) +
  	      field("Meter", "Opening meter litres", "0", "number", { required: true, min: 0, step: 0.01 }) +
  	      field("GradeDisplay", "Fuel grade", clean(tank && tank.Grade), "text", { disabled: true }) +
  	      '</form>';
  	    return modalFrame("Create Backendless Bowser", body, '<button class="fif-button" data-action="manage-bowsers" data-company-id="' + escapeAttr(companyId) + '" data-tank-id="' + escapeAttr(tankId) + '">Back</button><button class="fif-button primary" data-action="save-bowser">Create & Link Bowser</button>', false);
  	  }

  	  function companyCheckboxes(selectedIds) {
  	    const selected = new Set(arr(selectedIds));
  	    return '<div class="fif-check-grid" data-company-check-list>' + state.companies.map(function (company) {
  	      return '<label class="fif-check" data-company-option="' + escapeAttr(lower(companyName(company) + " " + companyBusinessId(company))) + '"><input type="checkbox" name="CompanyIds" value="' + escapeAttr(objectId(company)) + '"' + (selected.has(objectId(company)) ? " checked" : "") + '><span><strong>' + escapeHtml(companyName(company)) + '</strong><span class="fif-row-sub">' + escapeHtml(companyBusinessId(company)) + "</span></span></label>";
  	    }).join("") + "</div>";
  	  }

  	  function userModal(existing, requestedType, preselectedCompanyId) {
  	    const type = existing ? (isAdminProfile(existing) ? "Director" : "Employee") : (requestedType === "Employee" ? "Employee" : "Director");
  	    const creatingEmployee = !existing && type === "Employee";
  	    const user = existing ? normalizeUser(existing) : normalizeUser({
  	      APP: "Office",
  	      Office: "Dash",
  	      Settings: type === "Director" ? "Users" : "",
  	      Role: type === "Director" ? DIRECTOR_ROLE_VALUE : EMPLOYEE_ROLE_VALUE,
  	      Home: "Dash",
  	      userStatus: "ENABLED",
  	      Data_Details: { employee_details: defaultEmployeeDetails() },
  	      Data_Wages: defaultWages()
  	    });
  	    const details = userDetails(user);
  	    const selectedCompanies = existing ? userCompanyIds(user) : preselectedCompanyId ? [preselectedCompanyId] : [];

  	    const employeeEssentialNote = creatingEmployee
  	      ? '<div class="fif-note full"><strong>Essential Employee login.</strong> Create only the permanent identity, login access and Company membership here. If this South African ID already exists, FIFM will retain all existing Employee data and create only the new Company link.</div>'
  	      : '';

  	    const body = `
  	      <form data-form="user" class="fif-form-grid">
  	        <input type="hidden" name="ExistingObjectId" value="${escapeAttr(objectId(existing))}">
  	        <input type="hidden" name="AccountType" value="${escapeAttr(type)}">
  	        ${employeeEssentialNote}
  	        ${creatingEmployee ? '<input type="hidden" name="UserStatus" value="ENABLED">' : field("UserStatus", "Status", user.userStatus || "ENABLED", "select", { values: OPTIONS.UserStatus })}
  	        ${field("FirstName", "First name", details.first_name || "", "text", { required: true })}
  	        ${field("LastName", "Last name", details.last_name || "", "text", { required: true })}
  	        ${field("Email", "Email", user.email || "", "email", { required: true })}
  	        ${creatingEmployee ? '' : field("Phone", "Phone number", details.contact_details && details.contact_details.phone_number || "", "tel")}
  	        ${existing ? '<input type="hidden" name="IdNumber" value="' + escapeAttr(details.id_number || user.ID || objectId(user)) + '">' : ""}
  	        ${field(existing ? "IdNumberDisplay" : "IdNumber", "South African ID", details.id_number || user.ID || objectId(user), "text", { required: true, disabled: !!existing })}
  	        ${existing ? '' : field("Password", "Temporary password", "", "password", { required: true, placeholder: "Minimum 8 characters" }) + field("ConfirmPassword", "Confirm password", "", "password", { required: true, placeholder: "Repeat password" })}
  	        ${checkGroup("APP", "Application access", OPTIONS.APP, user.APP)}
  	        ${checkGroup("Office", "Office modules", OPTIONS.Office, user.Office)}
  	        ${creatingEmployee ? '' : checkGroup("Settings", "Dashboard privileges", OPTIONS.Settings, user.Settings)}
  	        ${type === "Employee" && !creatingEmployee ? checkGroup("OperationalRole", "Operational roles", OPTIONS.OperationalRole, userOperationalRoles(user)) : ""}
  	        <div class="fif-subsection" data-home-section><h3>Home screen</h3>${field("Home", "Home", user.Home || "", "select", { values: [""].concat(OPTIONS.Office), full: true })}</div>
  	        <div class="fif-subsection"><h3>Companies</h3>${type === "Director" ? '<p class="fif-help">Optional. A Director can be saved without being attached to a Company.</p>' : creatingEmployee ? '<p class="fif-help">Required for a new Employee login. An Employee with no Company links is retained in Users but cannot log in.</p>' : '<p class="fif-help">An Employee may be unlinked from every Company. Their Users record is retained and their login is automatically disabled until a Company is linked again.</p>'}<div class="fif-field full"><label>Filter Companies</label><input class="fif-input" type="search" data-action="company-filter" placeholder="Search"></div>${companyCheckboxes(selectedCompanies)}${type === "Director" ? '<div class="fif-actions" style="margin-top:12px"><button type="button" class="fif-button" data-action="save-user-create-company">Create Company</button></div>' : ''}</div>
  	      </form>`;
  	    const footer = '<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-user">' + (existing ? "Save " : "Create ") + type + "</button>";
  	    return modalFrame((existing ? "Edit " : "New ") + type, body, footer, false);
  	  }

  	  function trackerTypeOptions(selectedId) {
  	    const options = [{ value: "", label: "Select Flespi tracker type" }].concat(state.trackerTypes.map(function (row) {
  	      return {
  	        value: row.id,
  	        label: row.name + (row.protocol ? " — " + row.protocol : "")
  	      };
  	    }));
  	    return options;
  	  }

  	  async function deleteTractorFromUi(tractor, mode) {
  	    if (!tractor) throw new Error("The selected Tractor is unavailable.");
  	    const tracked = mode === "tracked";
  	    const label = tractorRegistration(tractor);
  	    if (typeof window !== "undefined" && typeof window.confirm === "function" && !window.confirm("Delete " + label + " permanently?")) return;
  	    beginOperation("Deleting Tractor...");
  	    try {
  	      if (tracked) await deleteTrackedTractor(tractor); else await deleteNonTrackedTractor(tractor);
  	      endOperation();
  	      if (state.modal && state.modal.kind === "asset-manager") {
  	        state.modal = { kind: "asset-manager", assetKind: tracked ? "tracked-tractor" : "nontracked-tractor", companyId: state.modal.companyId };
  	      }
  	      render();
  	      showToast(label + " deleted.", "success");
  	    } catch (error) { failOperation(error); throw error; }
  	  }

  	  async function deleteTrailerFromUi(trailer) {
  	    if (!trailer) throw new Error("The selected Trailer is unavailable.");
  	    const label = trailerLabel(trailer);
  	    if (typeof window !== "undefined" && typeof window.confirm === "function" && !window.confirm("Delete " + label + " from Flespi and Backendless permanently?")) return;
  	    beginOperation("Deleting tracked Trailer...");
  	    try {
  	      await deleteTrackedTrailer(trailer);
  	      endOperation();
  	      if (state.modal && state.modal.kind === "asset-manager") state.modal = { kind: "asset-manager", assetKind: "tracked-trailer", companyId: state.modal.companyId };
  	      render();
  	      showToast(label + " deleted.", "success");
  	    } catch (error) { failOperation(error); throw error; }
  	  }

  	  function renderModal() {
  	    const layer = state.root.querySelector('[data-region="modal"]');
  	    if (!state.modal || (state.modal.kind !== "tank" && state.modal.kind !== "tank-location")) destroyTankLocationDraft();
  	    if (!state.modal) { layer.classList.remove("open"); layer.innerHTML = ""; return; }
  	    if (state.modal.kind === "company") layer.innerHTML = companyModal(state.modal.existing);
  	    else if (state.modal.kind === "user") layer.innerHTML = userModal(state.modal.existing, state.modal.accountType, state.modal.companyId);
  	    else if (state.modal.kind === "tracked-tractor") layer.innerHTML = trackedTractorModal(state.modal.companyId);
  	    else if (state.modal.kind === "nontracked-tractor") layer.innerHTML = nonTrackedTractorModal(state.modal.companyId);
  	    else if (state.modal.kind === "tracked-trailer") layer.innerHTML = trackedTrailerModal(state.modal.companyId);
  	    else if (state.modal.kind === "beacon-trailer") layer.innerHTML = beaconTrailerModal(state.modal.companyId);
  	    else if (state.modal.kind === "tractor-mileage") {
  	      const tractor = tractorById(state.modal.tractorId);
  	      layer.innerHTML = tractor
  	        ? tractorMileageModal(tractor, state.modal.companyId, state.modal.assetKind)
  	        : modalFrame("Tractor unavailable", '<div class="fif-empty">The selected Tractor is unavailable.</div>', '<button class="fif-button" data-action="close-modal">Close</button>', true);
  	    }
  	    else if (state.modal.kind === "company-manager") {
  	      const company = companyById(state.modal.companyId);
  	      layer.innerHTML = company ? companyManagerModal(company) : modalFrame("Company unavailable", '<div class="fif-empty">The selected Company is unavailable.</div>', '<button class="fif-button" data-action="close-modal">Close</button>', true);
  	    } else if (state.modal.kind === "company-contractors") {
  	      const company = companyById(state.modal.companyId);
  	      layer.innerHTML = company ? companyContractorsModal(company) : modalFrame("Company unavailable", '<div class="fif-empty">The selected Company is unavailable.</div>', '<button class="fif-button" data-action="close-modal">Close</button>', true);
  	    } else if (state.modal.kind === "asset-manager") {
  	      const company = companyById(state.modal.companyId);
  	      layer.innerHTML = company ? assetManagerModal(company, state.modal.assetKind) : modalFrame("Company unavailable", '<div class="fif-empty">The selected Company is unavailable.</div>', '<button class="fif-button" data-action="close-modal">Close</button>', true);
  	    } else if (state.modal.kind === "tank") layer.innerHTML = tankModal(state.modal.companyId);
  	    else if (state.modal.kind === "tank-location") layer.innerHTML = tankLocationModal(state.modal.companyId, state.modal.tankId);
  	    else if (state.modal.kind === "bowser-manager") layer.innerHTML = bowserManagerModal(state.modal.companyId, state.modal.tankId);
  	    else if (state.modal.kind === "bowser") layer.innerHTML = bowserModal(state.modal.companyId, state.modal.tankId);
  	    else layer.innerHTML = "";
  	    layer.classList.add("open");
  	    if (state.modal.kind === "user") refreshPermissionDependencies(layer.querySelector('[data-form="user"]'));
  	    if (state.modal.kind === "tank" || state.modal.kind === "tank-location") {
  	      window.setTimeout(function () {
  	        mountTankLocationMap().catch(function (error) {
  	          console.error("FIF Manager Tank Map failed.", error);
  	        });
  	      }, 0);
  	    }
  	  }

  	  function openCompanyModal(company, pendingDirectorId) {
  	    state.pendingCompanyDirectorId = company ? "" : clean(pendingDirectorId);
  	    state.modal = { kind: "company", existing: company || null };
  	    renderModal();
  	  }

  	  async function openUserModal(user, requestedType, companyId) {
  	    let existing = user || null;
  	    if (existing) {
  	      beginOperation("Loading Company links...");
  	      try {
  	        existing = await loadUserCompanies(existing);
  	        endOperation();
  	      } catch (error) {
  	        failOperation(error);
  	        throw error;
  	      }
  	    }
  	    const type = existing ? (isAdminProfile(existing) ? "Director" : "Employee") : (requestedType === "Employee" ? "Employee" : "Director");
  	    state.modal = { kind: "user", existing: existing, accountType: type, companyId: companyId || "" };
  	    renderModal();
  	  }

  	  function closeModal() {
  	    state.pendingCompanyDirectorId = "";
  	    state.modal = null;
  	    renderModal();
  	  }

  	  function refreshPermissionDependencies(form) {
  	    if (!form) return;
  	    const appValues = selectedFormValues(form, "APP");
  	    const officeValues = selectedFormValues(form, "Office");
  	    const hasOffice = appValues.indexOf("Office") !== -1;
  	    const hasDash = hasOffice && officeValues.indexOf("Dash") !== -1;
  	    const officeSection = form.querySelector('[data-permission-section="Office"]');
  	    const settingsSection = form.querySelector('[data-permission-section="Settings"]');
  	    const homeSection = form.querySelector("[data-home-section]");
  	    const homeSelect = form.elements.namedItem("Home");

  	    if (officeSection) officeSection.style.display = hasOffice ? "" : "none";
  	    if (settingsSection) settingsSection.style.display = hasDash ? "" : "none";
  	    if (homeSection) homeSection.style.display = hasOffice && officeValues.length ? "" : "none";

  	    if (!hasOffice) {
  	      form.querySelectorAll('input[name="Office"],input[name="Settings"]').forEach(function (input) { input.checked = false; });
  	      if (homeSelect) homeSelect.value = "";
  	      return;
  	    }
  	    if (!hasDash) {
  	      form.querySelectorAll('input[name="Settings"]').forEach(function (input) { input.checked = false; });
  	    }
  	    if (homeSelect) {
  	      const previous = clean(homeSelect.value);
  	      homeSelect.innerHTML = '<option value="">Select home screen</option>' + officeValues.map(function (option) {
  	        return '<option value="' + escapeAttr(option) + '">' + escapeHtml(option) + "</option>";
  	      }).join("");
  	      homeSelect.value = officeValues.indexOf(previous) !== -1 ? previous : "";
  	    }
  	  }

  	  function beginOperation(message) {
  	    state.busy = true;
  	    const overlay = state.root && state.root.querySelector('[data-region="operation"]');
  	    if (!overlay) return;
  	    overlay.classList.add("open");
  	    const node = overlay.querySelector("[data-operation-message]");
  	    if (node) node.textContent = message || "Working...";
  	  }

  	  function updateOperation(message) {
  	    const node = state.root && state.root.querySelector("[data-operation-message]");
  	    if (node) node.textContent = message || "Working...";
  	  }

  	  function endOperation() {
  	    state.busy = false;
  	    const overlay = state.root && state.root.querySelector('[data-region="operation"]');
  	    if (overlay) overlay.classList.remove("open");
  	  }

  	  function failOperation(error) {
  	    endOperation();
  	    console.error("FIF Customer & Asset Manager operation failed", error);
  	  }

  	  function showToast(message, type, duration) {
  	    const toast = state.root && state.root.querySelector(".fif-toast");
  	    if (!toast) return;
  	    clearTimeout(state.toastTimer);
  	    toast.textContent = clean(message);
  	    toast.className = "fif-toast show" + (type ? " " + type : "");
  	    state.toastTimer = setTimeout(function () {
  	      toast.className = "fif-toast";
  	    }, duration || 4500);
  	  }

  	  async function handleClick(event) {
  	    const button = event.target.closest("[data-action]");
  	    if (!button || state.busy) return;
  	    const action = button.getAttribute("data-action");
  	    try {
  	      if (action === "navigate") { state.activeSection = button.getAttribute("data-section") || "directors"; state.search = ""; render(); }
  	      else if (action === "reload") await reloadData();
  	      else if (action === "new-company") openCompanyModal(null);
  	      else if (action === "edit-company") openCompanyModal(companyById(button.getAttribute("data-id")));
  	      else if (action === "save-company") await saveCompanyFromModal();
  	      else if (action === "toggle-company-status") {
  	        beginOperation("Changing Company status...");
  	        const saved = await toggleCompanyStatus(companyById(button.getAttribute("data-id")));
  	        endOperation(); render(); showToast(companyName(saved) + " is now " + companyStatus(saved) + ".", "success");
  	      }
  	      else if (action === "manage-company") { state.modal = { kind: "company-manager", companyId: button.getAttribute("data-id") }; renderModal(); }
  	      else if (action === "manage-contractors") {
  	        state.modal = { kind: "company-contractors", companyId: button.getAttribute("data-company-id") };
  	        renderModal();
  	      }
  	      else if (action === "link-contractor") {
  	        beginOperation("Linking Contractor Company...");
  	        const contractor = await linkCompanyContractor(button.getAttribute("data-company-id"), button.getAttribute("data-id"));
  	        endOperation(); render(); showToast(companyName(contractor) + " linked as Contractor.", "success");
  	      }
  	      else if (action === "unlink-contractor") {
  	        beginOperation("Unlinking Contractor Company...");
  	        const contractor = await unlinkCompanyContractor(button.getAttribute("data-company-id"), button.getAttribute("data-id"));
  	        endOperation(); render(); showToast(companyName(contractor) + " unlinked. Its Company and assets were retained.", "success");
  	      }
  	      else if (action === "manage-assets") { state.modal = { kind: "asset-manager", assetKind: button.getAttribute("data-kind"), companyId: button.getAttribute("data-company-id") }; renderModal(); }
  	      else if (action === "edit-tractor-mileage") {
  	        const tractor = tractorById(button.getAttribute("data-id"));
  	        if (!tractor) throw new Error("The selected Tractor is unavailable.");
  	        state.modal = {
  	          kind: "tractor-mileage",
  	          tractorId: objectId(tractor),
  	          companyId: button.getAttribute("data-company-id") || "",
  	          assetKind: button.getAttribute("data-kind") || (isTrackedTractor(tractor) ? "tracked-tractor" : "nontracked-tractor")
  	        };
  	        renderModal();
  	      }
  	      else if (action === "save-tractor-mileage") await saveTractorMileageFromModal();
  	      else if (action === "link-asset") {
  	        beginOperation("Linking asset...");
  	        const asset = await linkExistingAsset(button.getAttribute("data-company-id"), button.getAttribute("data-kind"), button.getAttribute("data-id"));
  	        endOperation(); render(); showToast(assetLabel(asset, button.getAttribute("data-kind")) + " was linked.", "success");
  	      }
  	      else if (action === "unlink-asset") {
  	        beginOperation("Unlinking asset...");
  	        const asset = await unlinkExistingAsset(button.getAttribute("data-company-id"), button.getAttribute("data-kind"), button.getAttribute("data-id"));
  	        endOperation(); render(); showToast(assetLabel(asset, button.getAttribute("data-kind")) + " was unlinked and retained in Backendless.", "success");
  	      }
  	      else if (action === "new-director") await openUserModal(null, "Director", "");
  	      else if (action === "new-employee") await openUserModal(null, "Employee", "");
  	      else if (action === "edit-user") await openUserModal(userById(button.getAttribute("data-id")), "", "");
  	      else if (action === "login-as-user") await openLoginAsUser(userById(button.getAttribute("data-id")));
  	      else if (action === "save-user") await saveUserFromModal();
  	      else if (action === "save-user-create-company") await saveUserFromModal({ createCompanyAfterSave: true });
  	      else if (action === "toggle-director-status") await toggleDirectorStatus(userById(button.getAttribute("data-id")));
  	      else if (action === "toggle-employee-status") await toggleEmployeeStatus(userById(button.getAttribute("data-id")));
  	      else if (action === "new-tracked-tractor") await openTrackedVehicleModal("tracked-tractor", button.getAttribute("data-company-id") || "");
  	      else if (action === "save-tracked-tractor") await saveTrackedTractorFromModal();
  	      else if (action === "new-nontracked-tractor") { state.modal = { kind: "nontracked-tractor", companyId: button.getAttribute("data-company-id") || "" }; renderModal(); }
  	      else if (action === "save-nontracked-tractor") await saveNonTrackedTractorFromModal();
  	      else if (action === "new-tracked-trailer") await openTrackedVehicleModal("tracked-trailer", button.getAttribute("data-company-id") || "");
  	      else if (action === "save-tracked-trailer") await saveTrackedTrailerFromModal();
  	      else if (action === "new-beacon-trailer") { state.modal = { kind: "beacon-trailer", companyId: button.getAttribute("data-company-id") || "" }; renderModal(); }
  	      else if (action === "save-beacon-trailer") await saveBeaconTrailerFromModal();
  	      else if (action === "new-tank") {
  	        const companyId = button.getAttribute("data-company-id");
  	        resetTankLocationDraft(companyId);
  	        state.modal = { kind: "tank", companyId: companyId };
  	        renderModal();
  	      }
  	      else if (action === "save-tank") {
  	        const form = state.root.querySelector('[data-form="tank"]'); const companyId = clean(form && form.elements.namedItem("CompanyId") && form.elements.namedItem("CompanyId").value);
  	        beginOperation("Creating Tank and current TankView..."); const saved = await createTankFromModal(); endOperation();
  	        state.modal = { kind: "bowser-manager", companyId: companyId, tankId: objectId(saved) }; render(); renderModal();
  	        showToast(
  	          tankLabel(saved) +
  	          (saved.Location && objectId(saved.Location)
  	            ? " and its optional polygon Location were created and linked."
  	            : " was created and linked without a Location.") +
  	          (saved.Trailer ? " Trailer Tank is enabled." : "") +
  	          " Add its Bowsers now.",
  	          "success",
  	          7500
  	        );
  	      }
  	      else if (action === "edit-tank-location") {
  	        const companyId = button.getAttribute("data-company-id");
  	        const tankId = button.getAttribute("data-tank-id");
  	        const tank = tankForCompany(companyId, tankId);
  	        if (!tank) throw new Error("The selected Tank is unavailable.");
  	        resetTankLocationDraft(companyId, {
  	          mode: tank.Location && objectId(tank.Location) ? "edit" : "add",
  	          tankId: tankId,
  	          location: tank.Location || null
  	        });
  	        state.modal = { kind: "tank-location", companyId: companyId, tankId: tankId };
  	        renderModal();
  	      }
  	      else if (action === "save-tank-location") {
  	        const form = state.root.querySelector('[data-form="tank-location"]');
  	        const companyId = clean(form && form.elements.namedItem("CompanyId") && form.elements.namedItem("CompanyId").value);
  	        const tankId = clean(form && form.elements.namedItem("TankId") && form.elements.namedItem("TankId").value);
  	        beginOperation("Saving Tank polygon Location...");
  	        const savedLocation = await saveTankLocationFromModal();
  	        endOperation();
  	        state.modal = { kind: "asset-manager", assetKind: "tank", companyId: companyId };
  	        render();
  	        renderModal();
  	        showToast("The polygon Location was saved and linked to " + tankLabel(tankForCompany(companyId, tankId)) + ".", "success", 7000);
  	      }
  	      else if (action === "manage-bowsers") {
  	        state.modal = { kind: "bowser-manager", companyId: button.getAttribute("data-company-id"), tankId: button.getAttribute("data-tank-id") };
  	        renderModal();
  	      }
  	      else if (action === "link-bowser") {
  	        beginOperation("Linking Bowser...");
  	        const saved = await linkExistingBowser(button.getAttribute("data-company-id"), button.getAttribute("data-tank-id"), button.getAttribute("data-id"));
  	        endOperation(); render(); showToast(clean(saved.Name) + " was linked to the Tank.", "success");
  	      }
  	      else if (action === "unlink-bowser") {
  	        beginOperation("Unlinking Bowser...");
  	        const saved = await unlinkBowser(button.getAttribute("data-company-id"), button.getAttribute("data-tank-id"), button.getAttribute("data-id"));
  	        endOperation(); render(); showToast(clean(saved.Name) + " was unlinked and retained in Backendless.", "success");
  	      }
  	      else if (action === "new-bowser") {
  	        state.modal = { kind: "bowser", companyId: button.getAttribute("data-company-id"), tankId: button.getAttribute("data-tank-id") };
  	        renderModal();
  	      }
  	      else if (action === "save-bowser") {
  	        const form = state.root.querySelector('[data-form="bowser"]');
  	        const companyId = clean(form && form.elements.namedItem("CompanyId") && form.elements.namedItem("CompanyId").value);
  	        const tankId = clean(form && form.elements.namedItem("TankId") && form.elements.namedItem("TankId").value);
  	        beginOperation("Creating Backendless Bowser and current BowserView..."); const saved = await createBowserFromModal(); endOperation();
  	        state.modal = { kind: "bowser-manager", companyId: companyId, tankId: tankId }; render(); renderModal(); showToast(saved.Name + " was created and linked to the Tank.", "success", 7000);
  	      }
  	      else if (action === "delete-tracked-tractor") await deleteTractorFromUi(tractorById(button.getAttribute("data-id")), "tracked");
  	      else if (action === "delete-nontracked-tractor") await deleteTractorFromUi(tractorById(button.getAttribute("data-id")), "nontracked");
  	      else if (action === "delete-tracked-trailer") await deleteTrailerFromUi(trailerById(button.getAttribute("data-id")));
  	      else if (action === "close-modal") closeModal();
  	    } catch (error) {
  	      failOperation(error);
  	      showToast(clean(error && (error.message || error.faultString || error.details)) || "The operation failed.", "error", 8000);
  	    }
  	  }

  	  function handleChange(event) {
  	    const userForm = event.target.closest('[data-form="user"]');
  	    if (userForm && (event.target.name === "APP" || event.target.name === "Office" || event.target.name === "Settings")) {
  	      refreshPermissionDependencies(userForm);
  	      return;
  	    }
  	    const trackerForm = event.target.closest('[data-form="tracked-tractor"],[data-form="tracked-trailer"]');
  	    if (trackerForm && event.target.name === "TrackerTypeId") populateTrackerTypeName(trackerForm);
  	  }

  	  function handleInput(event) {
  	    if (event.target.matches('[data-action="search"]')) {
  	      const value = event.target.value;
  	      const caret = event.target.selectionStart;
  	      state.search = value;
  	      renderContent();
  	      const replacement = state.root.querySelector('[data-action="search"]');
  	      if (replacement) {
  	        replacement.focus();
  	        try { replacement.setSelectionRange(caret, caret); } catch (_) {}
  	      }
  	      return;
  	    }
  	    if (event.target.matches('[data-action="contractor-filter"]')) {
  	      const query = lower(event.target.value);
  	      state.root.querySelectorAll('[data-contractor-option]').forEach(function (option) {
  	        option.style.display = !query || option.getAttribute('data-contractor-option').indexOf(query) !== -1 ? '' : 'none';
  	      });
  	      return;
  	    }
  	    if (event.target.matches('[data-action="company-filter"]')) {
  	      const query = lower(event.target.value);
  	      state.root.querySelectorAll("[data-company-option]").forEach(function (option) {
  	        option.style.display = !query || option.getAttribute("data-company-option").indexOf(query) !== -1 ? "" : "none";
  	      });
  	    }
  	  }

  	  function renderDenied(message) {
  	    const content = state.root.querySelector('[data-region="content"]');
  	    renderNavigation();
  	    renderTop();
  	    content.innerHTML = '<div class="fif-empty"><h2>FIFM Access Required</h2><p>' + escapeHtml(message) + "</p></div>";
  	  }

  	  async function bootstrap() {
  	    if (!APP_DATA || !APP_DATA.User) {
  	      return { ok: false, version: VERSION, reason: "App Data.User was not supplied to the FIFM Custom Code block." };
  	    }
  	    mount();
  	    if (!hasToken(APP_DATA.User.APP, "FIFM")) {
  	      renderDenied("The logged-in user APP property does not contain FIFM. This portal is restricted to Fleet In Form platform managers.");
  	      return { ok: false, version: VERSION, reason: "FIFM authority required." };
  	    }

  	    render();
  	    const content = state.root.querySelector('[data-region="content"]');
  	    content.innerHTML = '<div class="fif-empty"><div class="fif-spinner"></div><h3>Loading management data</h3><p>Please wait while Directors, Companies, Employees and relations are loaded.</p></div>';
  	    try {
  	      await reloadData();
  	      const api = {
  	        ok: true,
  	        version: VERSION,
  	        state: state,
  	        reload: reloadData,
  	        openCompany: openCompanyModal,
  	        openUser: openUserModal,
  	        openTrackedTractor: function (companyId) { return openTrackedVehicleModal("tracked-tractor", companyId); },
  	        openNonTrackedTractor: function (companyId) { state.modal = { kind: "nontracked-tractor", companyId: clean(companyId) }; renderModal(); },
  	        openTrackedTrailer: function (companyId) { return openTrackedVehicleModal("tracked-trailer", companyId); },
  	        loadTrackerTypes: loadTrackerTypes,
  	        deleteTrackedTractor: deleteTrackedTractor,
  	        deleteNonTrackedTractor: deleteNonTrackedTractor,
  	        deleteTrackedTrailer: deleteTrackedTrailer,
  	        linkExistingAsset: linkExistingAsset,
  	        linkCompanyContractor: linkCompanyContractor,
  	        unlinkCompanyContractor: unlinkCompanyContractor,
  	        unlinkExistingAsset: unlinkExistingAsset,
  	        linkExistingBowser: linkExistingBowser,
  	        unlinkBowser: unlinkBowser,
  	        toggleDirectorStatus: toggleDirectorStatus,
  	        toggleEmployeeStatus: toggleEmployeeStatus,
  	        loginAsUser: openLoginAsUser,
  	        toggleCompanyStatus: toggleCompanyStatus,
  	        createTrackedTrailer: createTrackedTrailer,
  	        createBeaconTrailer: createBeaconTrailer,
  	        createNonTrackedTractor: createNonTrackedTractor,
  	        createTankFromModal: createTankFromModal,
  	        createBowserFromModal: createBowserFromModal,
  	        destroy: destroyManager
  	      };
  	      if (typeof window !== "undefined") window.FIFCustomerCreationPortal = api;
  	      if (typeof window !== "undefined") window.FIFCustomerAssetManager = api;
  	      return api;
  	    } catch (error) {
  	      const message = clean(error && (error.message || error.faultString || error.details)) || "The portal could not load.";
  	      content.innerHTML = '<div class="fif-empty"><h2>Customer & Asset Manager Could Not Start</h2><p>' + escapeHtml(message) + '</p><div style="margin-top:14px"><button class="fif-button primary" data-action="reload">Retry</button></div></div>';
  	      showToast(message, "error", 9000);
  	      return { ok: false, version: VERSION, reason: message, state: state };
  	    }
  	  }

  	  return await bootstrap();
  	})();

  })(App, 'data:image/png;base64,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');

}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Bowser/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await (async function(App, SVG) {
  	/*
  	===============================================================================
  	FLEET IN FORM — MOBILE FUEL CAPTURE v1.4.8
  	===============================================================================
  	
  	One Custom Code block for the mobile Fuel Capture page/button.
  	
  	Expected inputs
  	- App or AppData with AppData.User and related Companies.
  	- Companies.Tanks
  	- Tanks.Bowsers
  	- Tanks.Location (single relation; optional)
  	- Companies.Tractors
  	- Companies.Contractors and contractor Tractors when contractors are used
  	- Companies.Employees
  	- Backendless
  	- SVG or SVGLogo is optional.
  	
  	Rules implemented
  	- Every authorised tank is always visible.
  	- A linked tank location is enforced with the same geofence/20 m rule as Driver Mobile.
  	- A tank without a Location relation is unrestricted.
  	- No mobile location override. Office capture must be used when the attendant is away.
  	- Company and contractor vehicles require a QR scan.
  	- Other remains the simple office-style FuelOut capture.
  	- No intertank transfer.
  	- No transaction/history view.
  	- Final bowser meter must equal fresh bowser meter + litres within +/- 0.05 L.
  	- Vehicle fuel grade must match the tank grade.
  	- GPS and bowser meter are rechecked immediately before save.
  	- The normal FuelOut, Tank, BowserView, Tractorview, vehicle and tyre updates are retained.
  	- Vehicle operating readings are written to Data.Vehicle.Usage.CurrentReading as the canonical reading while legacy Mileage remains synchronized.
  	- Tractorview routes movement into Distance for kilometre vehicles and Hours for hour/Hobbs vehicles.
  	- Fitted tyres advance from the positive operating-reading differential for both kilometre and hour/Hobbs vehicles.
  	- Spare tyres do not consume tyre life, but their Last_Vehicle_Odometer baseline follows the vehicle operating reading.
  	- Service and Preventive Maintenance notification conditions use the same Due Soon / Overdue rules and persistent duplicate keys as Dashboard fuel capture.
  	- Notify Service Provider and Notify Company are honoured independently.
  	- Company Service notifications resolve the owning company from AppData.User.Companies and use Manifest.Profile.PrimaryEmail first.
  	- DUE_SOON is one-time per enabled recipient; OVERDUE / UNSERVICED emails repeat after every vehicle FuelOut until the service cycle is reset.
  	- Service emails include Make, Model, Year, VIN and Engine Number as well as registration, service status, due position and the triggering FuelOut.
  	- Service email delivery, failures and audit persistence remain completely invisible to the Bowser operator.
  	- Fuel stock uses three stages: Warning Level 1, Warning Level 2 and Minimum / Order Level.
  	- Warning 1 and Warning 2 emails are sent silently to the Primary Supplier and tank company when crossed.
  	- The Minimum / Order Level silently sends the configured Default Volume Order to the Supplier and copies the tank company.
  	- Service Provider notification emails are completely silent to the Bowser operator: no prompts, success notices or email failures are exposed.
  	- When a tank crosses from above its Minimum Allowed Quantity to at-or-below it, the Primary Supplier order notification is sent silently using Order Email first and Email as fallback.
  	- v1.1.0 uses the Visual Viewport API so the active field remains visible above the phone keyboard.
  	- Enter/Next advances through the visible form controls; Shift+Enter retains a textarea newline.
  	- Native white dropdowns are replaced by fully themed in-page dropdown menus.
  	- The capture layout is a plain, guided three-step flow with large controls and simple wording.
  	- Logout opens the protected, permission-aware Fleet In Form application menu.
  	- Users without another application privilege keep the confirmed direct logout flow.
  	- The explicit Log Out menu action closes the Backendless session and opens Login.
  	- Leaving this page for another Fleet In Form application preserves the session.
  	- Background logout calls left alive by an outgoing SPA page are blocked.
  	- v1.4.8 adds Snapshot to the protected app switcher when Users.Settings contains Overview.
  	- Fitted non-spare tyres advance by the vehicle operating-reading differential multiplied by Current_Wear_Rate.
  	- Example: a 100-unit vehicle movement at a 0.35 wear rate advances tyre usage by 35 units.
  	- Spare positions and Spare axle types never advance.
  	- Tyre saves use only writable fields; calculated tyre fields remain out of Backendless save patches.
  	- Capture asks one question at a time and advances only after the current answer is valid.
  	- No capture value is prefilled; vehicle mileage/hours always starts blank.
  	- Save is shown only on the final review screen after all required answers are present.
  	- The dashboard Bowser QR button scans an exact Bowsers.objectId and opens that Bowser immediately.
  	- Dashboard GPS refreshes update location labels in place instead of rebuilding the whole screen, so scrolling is never reset by GPS.
  	- Same-screen renders preserve the .fm-main scroll position; genuine screen changes still open at the top.
  	- Vehicle fuel grades are read from Data.FuelAndEnergy.FuelGrade and normalised
  	  so values such as "Diesel 50 ppm" and "Diesel 50ppm" compare correctly.
  	===============================================================================
  	*/
  	
  	return (async function FleetInFormMobileFuelCaptureV1_4_8() {
  	  "use strict";
  	
  	  const VERSION = "1.4.8";
  	  const ROOT_ID = "fif-mobile-fuel-capture-root";
  	  const STYLE_ID = "fif-mobile-fuel-capture-style-v148";
  	  const OPERATION_ID = "fif-mobile-fuel-operation";
  	  const DIALOG_ID = "fif-mobile-fuel-dialog";
  	  const APP_MENU_ID = "fif-mobile-fuel-app-switcher";
  	  const LOGOUT_GUARD_KEY = "__FIF_LOGOUT_GUARD_V1__";
  	  const GPS_TARGET_ACCURACY_M = 25;
  	  const GPS_ACCEPTABLE_ACCURACY_M = 80;
  	  const GPS_HARD_LIMIT_ACCURACY_M = 250;
  	  const GPS_GATE_METRES = 20;
  	  const GPS_FIX_MAX_AGE_MS = 10 * 60 * 1000;
  	  const GPS_FINAL_MAX_AGE_MS = 15 * 1000;
  	  const GPS_TIMEOUT_MS = 30000;
  	  const METER_TOLERANCE = 0.05;
  	  const BUSINESS_TIMEZONE_OFFSET_MINUTES = 120;
  	
  	  const APP_INPUT = typeof App !== "undefined" ? App : null;
  	  const SVG_INPUT = typeof SVG !== "undefined"
  	    ? SVG
  	    : (typeof SVGLogo !== "undefined" ? SVGLogo : null);
  	
  	  function clean(value) {
  	    if (value === null || value === undefined) return "";
  	    return String(value).trim();
  	  }
  	
  	  function lower(value) {
  	    return clean(value).toLowerCase();
  	  }
  	
  	  function arr(value) {
  	    if (Array.isArray(value)) return value;
  	    if (value === null || value === undefined || value === "") return [];
  	    if (
  	      value &&
  	      typeof value === "object" &&
  	      Number.isFinite(Number(value.length)) &&
  	      Number(value.length) >= 0
  	    ) {
  	      const out = [];
  	      for (let i = 0; i < Number(value.length); i += 1) {
  	        if (value[i] !== undefined) out.push(value[i]);
  	      }
  	      if (out.length || Number(value.length) === 0) return out;
  	    }
  	    try {
  	      if (
  	        typeof Symbol !== "undefined" &&
  	        value &&
  	        typeof value[Symbol.iterator] === "function"
  	      ) return Array.from(value);
  	    } catch (_) {}
  	    return [value];
  	  }
  	
  	  function relationCollectionToArray(value) {
  	    return arr(value);
  	  }
  	
  	  function toArray(value) {
  	    return arr(value);
  	  }
  	
  	  function firstDefined() {
  	    for (let i = 0; i < arguments.length; i += 1) {
  	      const value = arguments[i];
  	      if (value !== null && value !== undefined && value !== "") return value;
  	    }
  	    return null;
  	  }
  	
  	  function firstValue(values, fallback) {
  	    for (let i = 0; i < values.length; i += 1) {
  	      const value = values[i];
  	      if (value !== null && value !== undefined && value !== "") return value;
  	    }
  	    return fallback;
  	  }
  	
  	  function getDeep(object, path, fallback) {
  	    try {
  	      let current = object;
  	      for (let i = 0; i < path.length; i += 1) {
  	        if (current === null || current === undefined) return fallback;
  	        current = current[path[i]];
  	      }
  	      return current === null || current === undefined ? fallback : current;
  	    } catch (_) {
  	      return fallback;
  	    }
  	  }
  	
  	  function descriptorValue(value) {
  	    if (!value || typeof value !== "object" || Array.isArray(value)) return value;
  	    return firstValue([
  	      value.value,
  	      value.Value,
  	      value.current,
  	      value.Current,
  	      value.selected,
  	      value.Selected,
  	      value.label,
  	      value.Label
  	    ], value);
  	  }
  	
  	  function toNumber(value, fallback) {
  	    const raw = descriptorValue(value);
  	    if (raw === null || raw === undefined || raw === "") return fallback;
  	    const number = Number(String(raw).replace(/\s/g, "").replace(/,/g, "."));
  	    return Number.isFinite(number) ? number : fallback;
  	  }
  	
  	  function numberValue(value) {
  	    return toNumber(value, null);
  	  }
  	
  	  function numberOr(value, fallback) {
  	    const parsed = toNumber(value, NaN);
  	    return Number.isFinite(parsed) ? parsed : fallback;
  	  }
  	
  	  function roundMoney2(value) {
  	    return Math.round((toNumber(value, 0) + Number.EPSILON) * 100) / 100;
  	  }
  	
  	  function deepClone(value) {
  	    try {
  	      return JSON.parse(JSON.stringify(value));
  	    } catch (_) {
  	      if (Array.isArray(value)) return value.slice();
  	      if (value && typeof value === "object") return Object.assign({}, value);
  	      return value;
  	    }
  	  }
  	
  	  function text(value, fallback) {
  	    return value === null || value === undefined || value === "" ? fallback : String(value);
  	  }
  	
  	  function objectIdOf(value) {
  	    if (!value) return "";
  	    if (typeof value === "string" || typeof value === "number") return clean(value);
  	    return clean(firstValue([
  	      value.objectId,
  	      value.ObjectId,
  	      value.objectID,
  	      value.ID,
  	      value.id
  	    ], ""));
  	  }
  	
  	  function sameObjectId(left, right) {
  	    const a = clean(left);
  	    const b = clean(right);
  	    return !!a && !!b && a === b;
  	  }
  	
  	  function uniqueObjects(rows) {
  	    const seen = Object.create(null);
  	    const out = [];
  	    arr(rows).forEach(function (row, index) {
  	      if (!row) return;
  	      const key = objectIdOf(row) || clean(firstValue([
  	        row.ID,
  	        row.FID,
  	        row.Name,
  	        "row-" + index
  	      ], "row-" + index));
  	      if (!key || seen[key]) return;
  	      seen[key] = true;
  	      out.push(row);
  	    });
  	    return out;
  	  }
  	
  	  function escapeHtml(value) {
  	    return String(value === null || value === undefined ? "" : value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/"/g, "&quot;")
  	      .replace(/'/g, "&#039;");
  	  }
  	
  	  function escapeAttr(value) {
  	    return escapeHtml(value).replace(/`/g, "&#096;");
  	  }
  	
  	  function formatNumber(value, decimals) {
  	    const parsed = toNumber(value, null);
  	    if (parsed === null) return "—";
  	    return new Intl.NumberFormat("en-ZA", {
  	      minimumFractionDigits: decimals || 0,
  	      maximumFractionDigits: decimals || 0
  	    }).format(parsed);
  	  }
  	
  	  function formatMoney(value) {
  	    const parsed = toNumber(value, 0);
  	    return new Intl.NumberFormat("en-ZA", {
  	      style: "currency",
  	      currency: "ZAR",
  	      minimumFractionDigits: 2,
  	      maximumFractionDigits: 2
  	    }).format(parsed);
  	  }
  	
  	  function resolveAppData(input) {
  	    const candidates = [
  	      input && input.data,
  	      input,
  	      typeof AppData !== "undefined" ? AppData : null,
  	      typeof window !== "undefined" && window.AppData
  	        ? (window.AppData.data || window.AppData)
  	        : null,
  	      typeof window !== "undefined" ? window.APP_DATA : null
  	    ];
  	    for (let i = 0; i < candidates.length; i += 1) {
  	      if (candidates[i] && candidates[i].User) return candidates[i];
  	    }
  	    return null;
  	  }
  	
  	  function resolveBackendless() {
  	    const candidates = [
  	      typeof Backendless !== "undefined" ? Backendless : null,
  	      typeof window !== "undefined" ? window.Backendless : null,
  	      APP_INPUT && APP_INPUT.Backendless,
  	      APP_INPUT && APP_INPUT.backendless
  	    ];
  	    return candidates.find(function (item) {
  	      return item && item.Data && typeof item.Data.of === "function";
  	    }) || null;
  	  }
  	
  	  const APP_DATA = resolveAppData(APP_INPUT);
  	  const DB = resolveBackendless();
  	
  	  function userRecord() {
  	    return APP_DATA && APP_DATA.User ? APP_DATA.User : null;
  	  }
  	
  	  const APPLICATION_PAGES = Object.freeze({
  	    FIFM: "FIFM",
  	    Office: "Office",
  	    Road: "Road",
  	    Bowser: "Bowser",
  	    "Mobile Tracking": "MobileTracking",
  	    Snapshot: "Snapshot"
  	  });
  	
  	  function normaliseApplicationName(value) {
  	    switch (lower(value).replace(/[\s_-]+/g, "")) {
  	      case "fifm":
  	        return "FIFM";
  	      case "office":
  	        return "Office";
  	      case "road":
  	        return "Road";
  	      case "bowser":
  	      case "mobilefuelcapture":
  	      case "fuelcapture":
  	        return "Bowser";
  	      case "mobiletracking":
  	        return "Mobile Tracking";
  	      case "snapshot":
  	        return "Snapshot";
  	      default:
  	        return clean(value);
  	    }
  	  }
  	
  	  function currentApplication() {
  	    try {
  	      const page = new URL(window.location.href).searchParams.get("page");
  	      const fromPage = normaliseApplicationName(page);
  	      if (APPLICATION_PAGES[fromPage]) return fromPage;
  	    } catch (_) {}
  	
  	    const fromData = normaliseApplicationName(APP_DATA && APP_DATA.APP);
  	    return APPLICATION_PAGES[fromData] ? fromData : "Bowser";
  	  }
  	
  	  function allowedApplicationsFor(user) {
  	    const raw = Array.isArray(user && user.APP)
  	      ? user.APP
  	      : clean(user && user.APP).split(",");
  	
  	    const allowed = raw
  	      .map(normaliseApplicationName)
  	      .filter(function (name) {
  	        return !!APPLICATION_PAGES[name];
  	      });
  	
  	    if (lower(user && user.Office).indexOf("livetrack") !== -1) {
  	      allowed.push("Mobile Tracking");
  	    }
  	
  	    if (lower(user && user.Settings).indexOf("overview") !== -1) {
  	      allowed.push("Snapshot");
  	    }
  	
  	    return allowed.filter(function (name, index, list) {
  	      return list.indexOf(name) === index;
  	    });
  	  }
  	
  	  function installLogoutGuard() {
  	    try {
  	      if (
  	        !DB ||
  	        !DB.UserService ||
  	        typeof DB.UserService.logout !== "function"
  	      ) {
  	        return null;
  	      }
  	
  	      const service = DB.UserService;
  	      const existing = window[LOGOUT_GUARD_KEY];
  	
  	      if (
  	        existing &&
  	        existing.service === service &&
  	        service.logout === existing.wrapper
  	      ) {
  	        return existing;
  	      }
  	
  	      const original =
  	        existing &&
  	        existing.service === service &&
  	        typeof existing.original === "function"
  	          ? existing.original
  	          : service.logout;
  	
  	      const guard = {
  	        version: "1.0",
  	        service: service,
  	        original: original,
  	        wrapper: null,
  	        explicitBusy: false,
  	        blockedCount: existing && existing.blockedCount
  	          ? existing.blockedCount
  	          : 0,
  	        async explicitLogout() {
  	          if (guard.explicitBusy) return false;
  	          guard.explicitBusy = true;
  	          try {
  	            return await guard.original.apply(guard.service, arguments);
  	          } finally {
  	            guard.explicitBusy = false;
  	          }
  	        }
  	      };
  	
  	      guard.wrapper = function protectedBackendlessLogout() {
  	        guard.blockedCount += 1;
  	        console.warn(
  	          "[FIF Logout Guard] Blocked a background logout during app switching.",
  	          { blockedCount: guard.blockedCount }
  	        );
  	        return Promise.resolve(false);
  	      };
  	
  	      try {
  	        service.logout = guard.wrapper;
  	      } catch (_) {
  	        Object.defineProperty(service, "logout", {
  	          configurable: true,
  	          writable: true,
  	          value: guard.wrapper
  	        });
  	      }
  	
  	      if (service.logout !== guard.wrapper) return null;
  	      window[LOGOUT_GUARD_KEY] = guard;
  	      return guard;
  	    } catch (error) {
  	      console.error("[FIF Logout Guard] Could not install.", error);
  	      return null;
  	    }
  	  }
  	
  	  const logoutGuard = installLogoutGuard();
  	
  	  function userName(user) {
  	    const details = getDeep(user, ["Data_Details", "employee_details"], {}) || {};
  	    return clean(firstValue([
  	      user && user.name,
  	      user && user.Name,
  	      [details.first_name, details.last_name].filter(Boolean).join(" "),
  	      user && user.email,
  	      "Bowser Attendant"
  	    ], "Bowser Attendant"));
  	  }
  	
  	  function companyName(company) {
  	    return clean(firstValue([
  	      descriptorValue(company && company.Name),
  	      descriptorValue(company && company.CompanyName),
  	      descriptorValue(company && company.CompanyId),
  	      descriptorValue(company && company.FID),
  	      "Company"
  	    ], "Company"));
  	  }
  	
  	  function tankName(tank, index) {
  	    return clean(firstValue([
  	      descriptorValue(tank && tank.Name),
  	      descriptorValue(tank && tank.TankName),
  	      descriptorValue(tank && tank.FID),
  	      descriptorValue(tank && tank.Grade),
  	      "Tank " + (index + 1)
  	    ], "Tank " + (index + 1)));
  	  }
  	
  	  function tankGrade(tank) {
  	    return clean(firstValue([
  	      descriptorValue(tank && tank.Grade),
  	      descriptorValue(tank && tank.FuelGrade),
  	      "Fuel"
  	    ], "Fuel"));
  	  }
  	
  	  function bowserName(bowser, index) {
  	    return clean(firstValue([
  	      descriptorValue(bowser && bowser.Name),
  	      descriptorValue(bowser && bowser.Pump),
  	      descriptorValue(bowser && bowser.FID),
  	      "Dispenser " + (index + 1)
  	    ], "Dispenser " + (index + 1)));
  	  }
  	
  	  function vehicleName(vehicle) {
  	    return clean(firstValue([
  	      descriptorValue(vehicle && vehicle.ID),
  	      descriptorValue(vehicle && vehicle.FID),
  	      descriptorValue(vehicle && vehicle.Name),
  	      descriptorValue(vehicle && vehicle.VehicleName),
  	      descriptorValue(vehicle && vehicle.Registration),
  	      "Vehicle"
  	    ], "Vehicle"));
  	  }
  	
  	  function vehicleRegistration(vehicle) {
  	    return clean(firstValue([
  	      descriptorValue(vehicle && vehicle.Registration),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Registration"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Identity", "Registration"], "")),
  	      descriptorValue(vehicle && vehicle.ID),
  	      descriptorValue(vehicle && vehicle.FID),
  	      ""
  	    ], ""));
  	  }
  	
  	  function vehicleFuelRecordRegistration(vehicle) {
  	    return clean(firstValue([
  	      descriptorValue(vehicle && vehicle.ID),
  	      descriptorValue(vehicle && vehicle.TractorID),
  	      descriptorValue(vehicle && vehicle.FID),
  	      descriptorValue(vehicle && vehicle.Registration),
  	      ""
  	    ], ""));
  	  }
  	
  	  function vehicleSubtitle(vehicle) {
  	    const make = clean(firstValue([
  	      descriptorValue(vehicle && vehicle.Make),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Make"], ""))
  	    ], ""));
  	    const model = clean(firstValue([
  	      descriptorValue(vehicle && vehicle.Model),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Model"], ""))
  	    ], ""));
  	    return [make, model, vehicleRegistration(vehicle)].filter(Boolean).join(" · ");
  	  }
  	
  	  function companyRows() {
  	    if (!APP_DATA) return [];
  	    return uniqueObjects(
  	      arr(getDeep(APP_DATA, ["User", "Companies"], []))
  	        .concat(arr(APP_DATA.Companies))
  	    ).sort(function (left, right) {
  	      return companyName(left).localeCompare(companyName(right), undefined, {
  	        numeric: true,
  	        sensitivity: "base"
  	      });
  	    });
  	  }
  	
  	  function unwrapTank(item) {
  	    if (!item || typeof item !== "object") return item;
  	    if (
  	      item.objectId ||
  	      item.Grade ||
  	      item.FuelGrade ||
  	      item.Bowsers ||
  	      item.Pumps
  	    ) return item;
  	    return item.Tank || item.tank || item.data || item;
  	  }
  	
  	  function unwrapBowser(item) {
  	    if (!item || typeof item !== "object") return item;
  	    if (item.objectId || item.Name || item.Pump || item.FID) return item;
  	    return item.Bowser || item.bowser || item.data || item;
  	  }
  	
  	  function companyTanks(company) {
  	    return arr(firstValue([
  	      company && company.Tanks,
  	      company && company.tanks,
  	      getDeep(company, ["Data", "Tanks"], [])
  	    ], [])).map(unwrapTank).filter(Boolean);
  	  }
  	
  	  function tankBowsers(tank) {
  	    return arr(firstValue([
  	      tank && tank.Bowsers,
  	      tank && tank.bowsers,
  	      tank && tank.Pumps,
  	      tank && tank.pumps,
  	      []
  	    ], [])).map(unwrapBowser).filter(Boolean);
  	  }
  	
  	  function companyBowserRows() {
  	    const rows = [];
  	    companyRows().forEach(function (company) {
  	      companyTanks(company).forEach(function (tank) {
  	        tankBowsers(tank).forEach(function (bowser) {
  	          rows.push({
  	            company: company,
  	            tank: tank,
  	            bowser: bowser
  	          });
  	        });
  	      });
  	    });
  	    return rows;
  	  }
  	
  	  function companyVehicles(company) {
  	    return uniqueObjects(arr(firstValue([
  	      company && company.Tractors,
  	      company && company.Vehicles,
  	      getDeep(company, ["Data", "Tractors"], [])
  	    ], []))).filter(function (vehicle) {
  	      const type = lower(firstValue([
  	        vehicle && vehicle.Type,
  	        vehicle && vehicle.AssetType,
  	        getDeep(vehicle, ["Data", "Vehicle", "Type"], "")
  	      ], ""));
  	      return !/trailer|implement|bowser|tank/.test(type);
  	    });
  	  }
  	
  	  function companyContractors(company) {
  	    return uniqueObjects(arr(firstValue([
  	      company && company.Contractors,
  	      getDeep(company, ["Data", "Contractors"], []),
  	      []
  	    ], []))).sort(function (left, right) {
  	      return companyName(left).localeCompare(companyName(right), undefined, {
  	        numeric: true,
  	        sensitivity: "base"
  	      });
  	    });
  	  }
  	
  	  function companyEmployees(company) {
  	    const rows = uniqueObjects(arr(firstValue([
  	      company && company.Employees,
  	      company && company.Drivers,
  	      getDeep(company, ["Data", "Employees"], []),
  	      []
  	    ], [])));
  	    return rows.sort(function (left, right) {
  	      return userName(left).localeCompare(userName(right), undefined, {
  	        numeric: true,
  	        sensitivity: "base"
  	      });
  	    });
  	  }
  	
  	  function selectedCompany() {
  	    return companyRows().find(function (company) {
  	      return objectIdOf(company) === state.selectedCompanyId;
  	    }) || null;
  	  }
  	
  	  function selectedTank() {
  	    const company = selectedCompany();
  	    if (!company) return null;
  	    return companyTanks(company).find(function (tank) {
  	      return objectIdOf(tank) === state.selectedTankId;
  	    }) || null;
  	  }
  	
  	  function selectedBowser() {
  	    const tank = selectedTank();
  	    if (!tank) return null;
  	    return tankBowsers(tank).find(function (bowser) {
  	      return objectIdOf(bowser) === state.selectedBowserId;
  	    }) || null;
  	  }
  	
  	  function selectedContractor() {
  	    const company = selectedCompany();
  	    if (!company) return null;
  	    return companyContractors(company).find(function (contractor) {
  	      return objectIdOf(contractor) === state.contractorId;
  	    }) || null;
  	  }
  	
  	  function selectedDriver() {
  	    const company = selectedCompany();
  	    if (!company || !state.driverId || state.driverId === "__other__") return null;
  	    return companyEmployees(company).find(function (driver) {
  	      return driverOptionValue(driver) === state.driverId;
  	    }) || null;
  	  }
  	
  	  function driverOptionValue(driver) {
  	    return clean(firstValue([
  	      driver && driver.ID,
  	      objectIdOf(driver),
  	      driver && driver.email,
  	      userName(driver)
  	    ], userName(driver)));
  	  }
  	
  	  function companyApplications(company) {
  	    const raw = arr(firstValue([
  	      getDeep(company, ["Manifest", "Applications"], []),
  	      company && company.Applications,
  	      []
  	    ], []));
  	    const seen = Object.create(null);
  	    return raw.map(function (value) {
  	      return clean(descriptorValue(value));
  	    }).filter(function (value) {
  	      const key = lower(value);
  	      if (!key || seen[key]) return false;
  	      seen[key] = true;
  	      return true;
  	    }).sort(function (a, b) {
  	      return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
  	    });
  	  }
  	
  	  function getVehicleFuelGrade(vehicle) {
  	    return clean(firstValue([
  	      descriptorValue(getDeep(vehicle, ["Data", "FuelAndEnergy", "FuelGrade"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "FuelGrade"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Fuel_Grade"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Fuel_Type"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "FuelType"], "")),
  	      descriptorValue(vehicle && vehicle.FuelGrade),
  	      descriptorValue(vehicle && vehicle.Fuel_Grade),
  	      descriptorValue(vehicle && vehicle.Fuel_Type),
  	      descriptorValue(vehicle && vehicle.FuelType),
  	      descriptorValue(vehicle && vehicle.Fuel),
  	      ""
  	    ], ""));
  	  }
  	
  	  function canonicalFuelGrade(value) {
  	    const grade = clean(descriptorValue(value))
  	      .toLowerCase()
  	      .replace(/[^a-z0-9]/g, "");
  	
  	    const aliases = {
  	      diesel500ppm: "diesel500ppm",
  	      diesel50ppm: "diesel50ppm",
  	      diesel10ppm: "diesel10ppm",
  	      ulp95: "petrol95",
  	      petrol95: "petrol95",
  	      ulp93: "petrol93",
  	      petrol93: "petrol93",
  	      paraffin: "paraffin",
  	      diesel: "diesel",
  	      petrol: "petrol",
  	      electric: "electric",
  	      hybrid: "hybrid",
  	      lpg: "lpg",
  	      cng: "cng",
  	      other: "other"
  	    };
  	
  	    return aliases[grade] || grade;
  	  }
  	
  	  function isDieselTankGrade(grade) {
  	    return canonicalFuelGrade(grade).indexOf("diesel") === 0;
  	  }
  	
  	  function isPetrolTankGrade(grade) {
  	    return canonicalFuelGrade(grade).indexOf("petrol") === 0;
  	  }
  	
  	  function isParaffinTankGrade(grade) {
  	    return canonicalFuelGrade(grade) === "paraffin";
  	  }
  	
  	  function vehicleMatchesTankGrade(vehicle, grade) {
  	    if (!vehicle) return false;
  	
  	    const vehicleGrade = canonicalFuelGrade(getVehicleFuelGrade(vehicle));
  	    const tankFuelGrade = canonicalFuelGrade(grade);
  	
  	    if (!vehicleGrade || !tankFuelGrade) return false;
  	    if (vehicleGrade === "electric" || tankFuelGrade === "paraffin") return false;
  	    if (vehicleGrade === "hybrid") return true;
  	
  	    if (vehicleGrade === tankFuelGrade) return true;
  	
  	    if (vehicleGrade === "diesel") return tankFuelGrade.indexOf("diesel") === 0;
  	    if (vehicleGrade === "petrol") return tankFuelGrade.indexOf("petrol") === 0;
  	
  	    return false;
  	  }
  	
  	  function currentMileage(vehicle) {
  	    return toNumber(firstValue([
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Usage", "CurrentReading"], null)),
  	      vehicle && vehicle.Mileage
  	    ], null), null);
  	  }
  	
  	  function maximumMileage(vehicle) {
  	    const current = currentMileage(vehicle);
  	    const range = toNumber(descriptorValue(firstValue([
  	      getDeep(vehicle, ["Data", "Vehicle", "Usage", "Range"], null),
  	      vehicle && vehicle.Range
  	    ], null)), null);
  	    if (current === null || range === null || range <= 0) return null;
  	    return current + range;
  	  }
  	
  	  function vehicleTankCapacity(vehicle) {
  	    return toNumber(descriptorValue(getDeep(vehicle, ["CAN", "Tank"], null)), 0);
  	  }
  	
  	  function booleanValue(value) {
  	    const raw = descriptorValue(value);
  	    if (raw === true || raw === false) return raw;
  	    if (raw === 1 || raw === 0) return raw === 1;
  	    const normal = lower(raw);
  	    if (["true", "yes", "y", "1", "enabled", "active", "compliant", "approved", "on"].indexOf(normal) !== -1) return true;
  	    if (["false", "no", "n", "0", "disabled", "inactive", "not compliant", "off"].indexOf(normal) !== -1) return false;
  	    return false;
  	  }
  	
  	  function vehicleMeterProfile(vehicle) {
  	    const canonicalCounterType = lower(descriptorValue(firstValue([
  	      vehicle && vehicle.CounterType,
  	      getDeep(vehicle, ["Data", "Vehicle", "Usage", "CounterType"], null),
  	      getDeep(vehicle, ["Data", "Vehicle", "CounterType"], null)
  	    ], "")));
  	
  	    if (/hour|hobbs|time/.test(canonicalCounterType)) {
  	      return {
  	        kind: "hours",
  	        unit: "h",
  	        decimals: 1
  	      };
  	    }
  	
  	    if (/km|kilomet|distance|odometer/.test(canonicalCounterType)) {
  	      return {
  	        kind: "distance",
  	        unit: "km",
  	        decimals: 0
  	      };
  	    }
  	
  	    const explicitUnit = lower(firstValue([
  	      descriptorValue(vehicle && vehicle.MeterUnit),
  	      descriptorValue(vehicle && vehicle.OdometerUnit),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "MeterUnit"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "OdometerUnit"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "OperatingMeterUnit"], ""))
  	    ], ""));
  	
  	    const triggerPolicy = lower(
  	      descriptorValue(getDeep(vehicle, ["Data", "Service", "Schedule", "TriggerPolicy"], ""))
  	    );
  	
  	    const vehicleClass = lower(firstValue([
  	      descriptorValue(getDeep(vehicle, ["Data", "Profile", "VehicleClass"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Classification", "VehicleClass"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "TowSystem", "PowerUnitClass"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Agricultural", "MachineClass"], ""))
  	    ], ""));
  	
  	    const hourMeterNode =
  	      getDeep(vehicle, ["Data", "Agricultural", "Hours", "HourMeter"], null);
  	
  	    const explicitHours = /hour|hobbs/.test(explicitUnit) || /hour|hobbs/.test(triggerPolicy);
  	    const explicitDistance = /km|kilomet|distance|odometer/.test(explicitUnit);
  	    const agriculturalHours =
  	      !explicitDistance &&
  	      /agricultural tractor|self-propelled agricultural machine|tractor/.test(vehicleClass) &&
  	      hourMeterNode !== null &&
  	      hourMeterNode !== undefined;
  	
  	    return explicitHours || agriculturalHours
  	      ? { kind: "hours", unit: "h", decimals: 1 }
  	      : { kind: "distance", unit: "km", decimals: 0 };
  	  }
  	
  	  function mobileEnsureVehicleUsage(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") return null;
  	    if (!vehicle.Data || typeof vehicle.Data !== "object" || Array.isArray(vehicle.Data)) vehicle.Data = {};
  	    if (!vehicle.Data.Vehicle || typeof vehicle.Data.Vehicle !== "object" || Array.isArray(vehicle.Data.Vehicle)) {
  	      vehicle.Data.Vehicle = {};
  	    }
  	    if (!vehicle.Data.Vehicle.Usage || typeof vehicle.Data.Vehicle.Usage !== "object" || Array.isArray(vehicle.Data.Vehicle.Usage)) {
  	      vehicle.Data.Vehicle.Usage = {};
  	    }
  	    return vehicle.Data.Vehicle.Usage;
  	  }
  	
  	  function mobileSetVehicleCurrentReading(vehicle, reading, profile) {
  	    const numeric = toNumber(reading, null);
  	    if (!vehicle || numeric === null || numeric < 0) return;
  	
  	    const usage = mobileEnsureVehicleUsage(vehicle);
  	    const unitType = profile && profile.kind === "hours" ? "Time" : "Distance";
  	    const existing = usage.CurrentReading;
  	
  	    if (existing && typeof existing === "object" && !Array.isArray(existing)) {
  	      existing.value = numeric;
  	      existing.editable = false;
  	      existing.selector = "number";
  	      existing.unitType = unitType;
  	    } else {
  	      usage.CurrentReading = {
  	        value: numeric,
  	        editable: false,
  	        selector: "number",
  	        unitType: unitType
  	      };
  	    }
  	
  	    vehicle.Mileage = numeric;
  	  }
  	
  	  function mobileIncrementFuelCounter(vehicle) {
  	    const node = getDeep(vehicle, ["Data", "OperationalTargets", "Fuel_Counter"], null);
  	    if (node === null || node === undefined) return;
  	
  	    const next = numberOr(descriptorValue(node), 0) + 1;
  	    if (node && typeof node === "object" && !Array.isArray(node)) {
  	      node.value = next;
  	    } else if (vehicle.Data && vehicle.Data.OperationalTargets) {
  	      vehicle.Data.OperationalTargets.Fuel_Counter = next;
  	    }
  	  }
  	
  	  function isVehicleSarsCompliant(vehicle) {
  	    return booleanValue(firstValue([
  	      vehicle && vehicle.SARSCompliance,
  	      getDeep(vehicle, ["Data", "SARSCompliance"], null),
  	      getDeep(vehicle, ["Data", "Vehicle", "SARSCompliance"], null),
  	      false
  	    ], false));
  	  }
  	
  	  function deliveryTimestamp(delivery) {
  	    const raw = firstValue([
  	      delivery && delivery.FuelDate,
  	      delivery && delivery.DeliveryDate,
  	      delivery && delivery.created,
  	      delivery && delivery.updated
  	    ], 0);
  	    const parsed = new Date(raw || 0).getTime();
  	    return Number.isFinite(parsed) ? parsed : 0;
  	  }
  	
  	  function latestTankDelivery(tank) {
  	    let deliveries = arr(tank && tank.FuelIn).slice();
  	    const currentView = firstValue([
  	      tank && tank.ViewC,
  	      getDeep(tank, ["TankView", "ViewC"], null)
  	    ], null);
  	    const history = arr(firstValue([
  	      tank && tank.ViewH,
  	      getDeep(tank, ["TankView", "ViewH"], [])
  	    ], []));
  	    if (currentView) deliveries = deliveries.concat(arr(currentView.FuelIn));
  	    history.forEach(function (view) {
  	      deliveries = deliveries.concat(arr(view && view.FuelIn));
  	    });
  	    const seen = Object.create(null);
  	    deliveries = deliveries.filter(function (item, index) {
  	      if (!item) return false;
  	      const key = objectIdOf(item) || [
  	        item.FuelDate,
  	        item.ReferenceNo,
  	        item.Supplier,
  	        item.Litres,
  	        item.Cost,
  	        index
  	      ].join("::");
  	      if (seen[key]) return false;
  	      seen[key] = true;
  	      return true;
  	    });
  	    deliveries.sort(function (a, b) {
  	      return deliveryTimestamp(b) - deliveryTimestamp(a);
  	    });
  	    return deliveries[0] || null;
  	  }
  	
  	  function getTankCostPerLitre(tank) {
  	    const live = toNumber(tank && tank.LatestCostPerLitre, NaN);
  	    if (!Number.isNaN(live) && live > 0) return live;
  	    const latest = latestTankDelivery(tank);
  	    if (!latest) return 0;
  	    const explicit = toNumber(latest.CostPerLitre, NaN);
  	    if (!Number.isNaN(explicit) && explicit > 0) return explicit;
  	    const cost = toNumber(latest.Cost, 0);
  	    const litres = toNumber(latest.Litres, 0);
  	    return cost > 0 && litres > 0 ? cost / litres : 0;
  	  }
  	
  	  function unwrapLocation(value) {
  	    const items = arr(value);
  	    let location = items.length ? items[0] : null;
  	    if (
  	      location &&
  	      typeof location === "object" &&
  	      !objectIdOf(location) &&
  	      !location.Name &&
  	      !location.LocationData
  	    ) {
  	      location = location.Location || location.location || location.data || location;
  	    }
  	    return location || null;
  	  }
  	
  	  function tankLocationLoaded(tank) {
  	    if (!tank || typeof tank !== "object") return false;
  	    if (tank.__fifLocationLoaded === true) return true;
  	    if (Object.prototype.hasOwnProperty.call(tank, "Location")) return true;
  	    if (Object.prototype.hasOwnProperty.call(tank, "location")) return true;
  	    const data = getDeep(tank, ["Data"], null);
  	    return !!(
  	      data &&
  	      typeof data === "object" &&
  	      Object.prototype.hasOwnProperty.call(data, "Location")
  	    );
  	  }
  	
  	  function tankLocation(tank) {
  	    return unwrapLocation(firstValue([
  	      tank && tank.Location,
  	      tank && tank.location,
  	      getDeep(tank, ["Data", "Location"], null),
  	      null
  	    ], null));
  	  }
  	
  	  function locationName(location) {
  	    return clean(firstValue([
  	      location && location.Name,
  	      location && location.LocationName,
  	      location && location.Title,
  	      location && location.FID,
  	      location && location.ID,
  	      getDeep(location, ["Data", "Name"], ""),
  	      "Linked tank location"
  	    ], "Linked tank location"));
  	  }
  	
  	  function coordinatesFromObject(source) {
  	    if (!source) return null;
  	    if (Array.isArray(source) && source.length >= 2) {
  	      const longitude = toNumber(source[0], null);
  	      const latitude = toNumber(source[1], null);
  	      if (
  	        latitude !== null &&
  	        longitude !== null &&
  	        latitude >= -90 &&
  	        latitude <= 90 &&
  	        longitude >= -180 &&
  	        longitude <= 180
  	      ) return { latitude: latitude, longitude: longitude };
  	      return null;
  	    }
  	    if (Array.isArray(source.coordinates)) {
  	      const point = coordinatesFromObject(source.coordinates);
  	      if (point) return point;
  	    }
  	    const latitude = toNumber(firstValue([
  	      source.latitude,
  	      source.Latitude,
  	      source.lat,
  	      source.Lat,
  	      source.y,
  	      source.Y,
  	      source["position.latitude"],
  	      getDeep(source, ["position", "latitude"], null),
  	      getDeep(source, ["Position", "Latitude"], null),
  	      getDeep(source, ["coordinates", "latitude"], null),
  	      getDeep(source, ["Coordinates", "Latitude"], null)
  	    ], null), null);
  	    const longitude = toNumber(firstValue([
  	      source.longitude,
  	      source.Longitude,
  	      source.lng,
  	      source.Lng,
  	      source.lon,
  	      source.Lon,
  	      source.x,
  	      source.X,
  	      source["position.longitude"],
  	      getDeep(source, ["position", "longitude"], null),
  	      getDeep(source, ["Position", "Longitude"], null),
  	      getDeep(source, ["coordinates", "longitude"], null),
  	      getDeep(source, ["Coordinates", "Longitude"], null)
  	    ], null), null);
  	    if (latitude === null || longitude === null) return null;
  	    if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) return null;
  	    return { latitude: latitude, longitude: longitude };
  	  }
  	
  	  function locationCoordinates(location) {
  	    const candidates = [
  	      location && location.EntrancePoint,
  	      getDeep(location, ["LocationData", "Shape", "EntrancePoint"], null),
  	      getDeep(location, ["Data", "LocationData", "Shape", "EntrancePoint"], null),
  	      location && location.Centre,
  	      location && location.Center,
  	      getDeep(location, ["LocationData", "Area", "Center"], null),
  	      getDeep(location, ["LocationData", "Area", "Centre"], null),
  	      getDeep(location, ["Data", "LocationData", "Area", "Center"], null),
  	      location,
  	      location && location.GeoPoint,
  	      location && location.Point,
  	      location && location.Coordinates,
  	      location && location.Position,
  	      getDeep(location, ["LocationData"], null),
  	      getDeep(location, ["Data"], null)
  	    ];
  	    for (let i = 0; i < candidates.length; i += 1) {
  	      const point = coordinatesFromObject(candidates[i]);
  	      if (point) return point;
  	    }
  	    return null;
  	  }
  	
  	  function radians(value) {
  	    return value * Math.PI / 180;
  	  }
  	
  	  function distanceKm(a, b) {
  	    if (!a || !b) return null;
  	    const earthRadius = 6371;
  	    const latitudeDistance = radians(b.latitude - a.latitude);
  	    const longitudeDistance = radians(b.longitude - a.longitude);
  	    const firstLatitude = radians(a.latitude);
  	    const secondLatitude = radians(b.latitude);
  	    const haversine =
  	      Math.sin(latitudeDistance / 2) * Math.sin(latitudeDistance / 2) +
  	      Math.sin(longitudeDistance / 2) * Math.sin(longitudeDistance / 2) *
  	      Math.cos(firstLatitude) * Math.cos(secondLatitude);
  	    return earthRadius * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
  	  }
  	
  	  function pointInRing(point, ring) {
  	    if (!point || !Array.isArray(ring) || ring.length < 3) return false;
  	    let inside = false;
  	    const x = point.longitude;
  	    const y = point.latitude;
  	    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
  	      const current = ring[i];
  	      const previous = ring[j];
  	      if (!current || !previous) continue;
  	      const xi = current.longitude;
  	      const yi = current.latitude;
  	      const xj = previous.longitude;
  	      const yj = previous.latitude;
  	      const intersects =
  	        ((yi > y) !== (yj > y)) &&
  	        (x < (xj - xi) * (y - yi) / ((yj - yi) || Number.EPSILON) + xi);
  	      if (intersects) inside = !inside;
  	    }
  	    return inside;
  	  }
  	
  	  function normaliseRing(points) {
  	    return arr(points).map(coordinatesFromObject).filter(Boolean);
  	  }
  	
  	  function locationPolygonRings(location) {
  	    const rings = [];
  	    const addCoordinates = function (coordinates) {
  	      if (!Array.isArray(coordinates) || !coordinates.length) return;
  	      if (
  	        Array.isArray(coordinates[0]) &&
  	        Array.isArray(coordinates[0][0]) &&
  	        typeof coordinates[0][0][0] !== "object"
  	      ) {
  	        coordinates.forEach(function (ring) {
  	          const normalised = normaliseRing(ring);
  	          if (normalised.length >= 3) rings.push(normalised);
  	        });
  	        return;
  	      }
  	      if (
  	        Array.isArray(coordinates[0]) &&
  	        Array.isArray(coordinates[0][0]) &&
  	        Array.isArray(coordinates[0][0][0])
  	      ) coordinates.forEach(addCoordinates);
  	    };
  	    [
  	      location && location.Polygon,
  	      getDeep(location, ["LocationData", "Polygon"], null),
  	      getDeep(location, ["Data", "Polygon"], null),
  	      getDeep(location, ["Data", "LocationData", "Polygon"], null)
  	    ].forEach(function (polygon) {
  	      if (polygon && Array.isArray(polygon.coordinates)) addCoordinates(polygon.coordinates);
  	    });
  	    [
  	      getDeep(location, ["Geometry", "rawPoints"], null),
  	      getDeep(location, ["LocationData", "Geometry", "rawPoints"], null),
  	      getDeep(location, ["Data", "Geometry", "rawPoints"], null),
  	      getDeep(location, ["Data", "LocationData", "Geometry", "rawPoints"], null)
  	    ].forEach(function (points) {
  	      const normalised = normaliseRing(points);
  	      if (normalised.length >= 3) rings.push(normalised);
  	    });
  	    return rings;
  	  }
  	
  	  function distanceMetersToSegment(point, start, end) {
  	    if (!point || !start || !end) return Infinity;
  	    const latitudeReference = radians(point.latitude);
  	    const metresPerDegreeLatitude = 111320;
  	    const metresPerDegreeLongitude = Math.max(1, 111320 * Math.cos(latitudeReference));
  	    const ax = (start.longitude - point.longitude) * metresPerDegreeLongitude;
  	    const ay = (start.latitude - point.latitude) * metresPerDegreeLatitude;
  	    const bx = (end.longitude - point.longitude) * metresPerDegreeLongitude;
  	    const by = (end.latitude - point.latitude) * metresPerDegreeLatitude;
  	    const dx = bx - ax;
  	    const dy = by - ay;
  	    const lengthSquared = dx * dx + dy * dy;
  	    let t = lengthSquared ? ((-ax) * dx + (-ay) * dy) / lengthSquared : 0;
  	    t = Math.max(0, Math.min(1, t));
  	    const closestX = ax + t * dx;
  	    const closestY = ay + t * dy;
  	    return Math.sqrt(closestX * closestX + closestY * closestY);
  	  }
  	
  	  function distanceMetersToRing(point, ring) {
  	    if (!Array.isArray(ring) || ring.length < 2) return Infinity;
  	    let shortest = Infinity;
  	    for (let i = 0; i < ring.length; i += 1) {
  	      shortest = Math.min(
  	        shortest,
  	        distanceMetersToSegment(point, ring[i], ring[(i + 1) % ring.length])
  	      );
  	    }
  	    return shortest;
  	  }
  	
  	  function locationProximity(location, position) {
  	    if (!position) {
  	      return {
  	        inside: false,
  	        distanceMeters: null,
  	        eligible: false,
  	        method: "No GPS",
  	        hasGeometry: !!(locationCoordinates(location) || locationPolygonRings(location).length)
  	      };
  	    }
  	    const rings = locationPolygonRings(location);
  	    let inside = false;
  	    let boundaryDistance = Infinity;
  	    rings.forEach(function (ring, index) {
  	      if (index === 0 && pointInRing(position, ring)) inside = true;
  	      boundaryDistance = Math.min(boundaryDistance, distanceMetersToRing(position, ring));
  	    });
  	    const reference = locationCoordinates(location);
  	    const referenceDistance = reference ? distanceKm(position, reference) * 1000 : Infinity;
  	    const distanceMeters = inside
  	      ? 0
  	      : (Number.isFinite(boundaryDistance) ? boundaryDistance : referenceDistance);
  	    return {
  	      inside: inside,
  	      distanceMeters: Number.isFinite(distanceMeters) ? distanceMeters : null,
  	      eligible: inside || (Number.isFinite(distanceMeters) && distanceMeters <= GPS_GATE_METRES),
  	      method: rings.length ? "Geofence" : "Location point",
  	      hasGeometry: !!(rings.length || reference)
  	    };
  	  }
  	
  	  function gpsFixFresh(position, maxAge) {
  	    if (!position || !position.capturedAt) return false;
  	    const captured = Date.parse(position.capturedAt);
  	    return Number.isFinite(captured) && Date.now() - captured <= (maxAge || GPS_FIX_MAX_AGE_MS);
  	  }
  	
  	  function gpsAccuracyQuality(accuracy) {
  	    const value = toNumber(accuracy, Infinity);
  	    if (value <= GPS_TARGET_ACCURACY_M) return { key: "excellent", label: "Excellent" };
  	    if (value <= GPS_ACCEPTABLE_ACCURACY_M) return { key: "acceptable", label: "Acceptable" };
  	    if (value <= GPS_HARD_LIMIT_ACCURACY_M) return { key: "poor", label: "Poor" };
  	    return { key: "unusable", label: "Unusable" };
  	  }
  	
  	  function tankGate(tank, position) {
  	    if (!tankLocationLoaded(tank)) {
  	      return {
  	        linked: true,
  	        eligible: false,
  	        status: "checking",
  	        title: "Checking location",
  	        message: state.locationHydrationError ||
  	          "Please wait while the tank location loads.",
  	        location: null,
  	        proximity: null
  	      };
  	    }
  	    const location = tankLocation(tank);
  	    if (!location) {
  	      return {
  	        linked: false,
  	        eligible: true,
  	        status: "unrestricted",
  	        title: "Ready to use",
  	        message: "This tank does not need a GPS location check.",
  	        location: null,
  	        proximity: null
  	      };
  	    }
  	    const proximity = locationProximity(location, position);
  	    if (!proximity.hasGeometry) {
  	      return {
  	        linked: true,
  	        eligible: false,
  	        status: "locked",
  	        title: "Tank location not set up",
  	        message: locationName(location) + " has no usable boundary or location point. Use the office capture after correcting the location.",
  	        location: location,
  	        proximity: proximity
  	      };
  	    }
  	    if (!position) {
  	      return {
  	        linked: true,
  	        eligible: false,
  	        status: state.gpsBusy ? "checking" : "locked",
  	        title: state.gpsBusy ? "Checking your location" : "Turn on GPS",
  	        message: state.gpsBusy
  	          ? "Waiting for an accurate phone position."
  	          : (state.gpsError || "This tank needs your phone location before fuel can be saved."),
  	        location: location,
  	        proximity: proximity
  	      };
  	    }
  	    if (!gpsFixFresh(position, GPS_FIX_MAX_AGE_MS)) {
  	      return {
  	        linked: true,
  	        eligible: false,
  	        status: "locked",
  	        title: "Refresh your location",
  	        message: "Refresh GPS before dispensing from " + locationName(location) + ".",
  	        location: location,
  	        proximity: proximity
  	      };
  	    }
  	    const accuracy = toNumber(position.accuracy, Infinity);
  	    if (accuracy > GPS_ACCEPTABLE_ACCURACY_M) {
  	      return {
  	        linked: true,
  	        eligible: false,
  	        status: "locked",
  	        title: "GPS signal is weak",
  	        message: "Accuracy is about " + formatNumber(accuracy, 0) + " m. Move outside, keep the phone still and retry.",
  	        location: location,
  	        proximity: proximity
  	      };
  	    }
  	    if (!proximity.eligible) {
  	      return {
  	        linked: true,
  	        eligible: false,
  	        status: "locked",
  	        title: "Go to " + locationName(location),
  	        message: proximity.distanceMeters === null
  	          ? "You must be at the linked tank location."
  	          : "You are about " + formatNumber(proximity.distanceMeters, 0) + " m from the allowed area. You must be inside it or within " + GPS_GATE_METRES + " m.",
  	        location: location,
  	        proximity: proximity
  	      };
  	    }
  	    return {
  	      linked: true,
  	      eligible: true,
  	      status: "ready",
  	      title: "You are at the tank",
  	      message: proximity.inside
  	        ? "You are inside " + locationName(location) + "."
  	        : "You are " + formatNumber(proximity.distanceMeters, 0) + " m from " + locationName(location) + ".",
  	      location: location,
  	      proximity: proximity
  	    };
  	  }
  	
  	  function gpsSnapshot(position) {
  	    if (!position || !position.coords) return null;
  	    return {
  	      latitude: Number(position.coords.latitude),
  	      longitude: Number(position.coords.longitude),
  	      accuracy: Number(position.coords.accuracy),
  	      altitude: position.coords.altitude === null ? null : Number(position.coords.altitude),
  	      speed: position.coords.speed === null ? null : Number(position.coords.speed),
  	      heading: position.coords.heading === null ? null : Number(position.coords.heading),
  	      capturedAt: new Date(position.timestamp || Date.now()).toISOString(),
  	      samples: gpsRuntime.samples,
  	      source: "watchPosition"
  	    };
  	  }
  	
  	  const gpsRuntime = {
  	    watchId: null,
  	    requestTimer: 0,
  	    waiters: [],
  	    samples: 0
  	  };
  	
  	  function notifyGpsWaiters() {
  	    const fix = state.gps;
  	    gpsRuntime.waiters = gpsRuntime.waiters.filter(function (waiter) {
  	      if (
  	        fix &&
  	        gpsFixFresh(fix, waiter.maxAge) &&
  	        toNumber(fix.accuracy, Infinity) <= waiter.accuracy
  	      ) {
  	        clearTimeout(waiter.timer);
  	        waiter.resolve(fix);
  	        return false;
  	      }
  	      return true;
  	    });
  	  }
  	
  	  function startGpsWatch() {
  	    if (gpsRuntime.watchId !== null) return;
  	    if (!navigator.geolocation) {
  	      state.gpsBusy = false;
  	      state.gpsError = "This device does not provide browser GPS.";
  	      refreshLocationUi();
  	      return;
  	    }
  	    state.gpsBusy = true;
  	    state.gpsError = "";
  	    state.gpsStatus = "Finding an accurate position…";
  	    refreshLocationUi();
  	    gpsRuntime.watchId = navigator.geolocation.watchPosition(
  	      function (position) {
  	        gpsRuntime.samples += 1;
  	        const fix = gpsSnapshot(position);
  	        if (!fix) return;
  	        const captured = Date.parse(fix.capturedAt);
  	        if (Number.isFinite(captured) && Date.now() - captured > 10000) return;
  	        state.gps = fix;
  	        state.gpsBusy = false;
  	        state.gpsError = "";
  	        state.gpsStatus = gpsAccuracyQuality(fix.accuracy).label + " GPS fix";
  	        notifyGpsWaiters();
  	        refreshLocationUi();
  	      },
  	      function (error) {
  	        const messages = {
  	          1: "Location permission was not allowed. Enable precise location for this site.",
  	          2: "The phone could not determine its location. Move outside and retry.",
  	          3: "GPS is still searching. Move outside and retry."
  	        };
  	        state.gpsBusy = false;
  	        state.gpsError = messages[error && error.code] || "GPS is unavailable.";
  	        state.gpsStatus = "";
  	        refreshLocationUi();
  	      },
  	      {
  	        enableHighAccuracy: true,
  	        timeout: 15000,
  	        maximumAge: 0
  	      }
  	    );
  	  }
  	
  	  function stopGpsWatch() {
  	    if (gpsRuntime.watchId !== null && navigator.geolocation) {
  	      try { navigator.geolocation.clearWatch(gpsRuntime.watchId); } catch (_) {}
  	    }
  	    gpsRuntime.watchId = null;
  	    gpsRuntime.waiters.forEach(function (waiter) {
  	      clearTimeout(waiter.timer);
  	      waiter.resolve(null);
  	    });
  	    gpsRuntime.waiters = [];
  	  }
  	
  	  function waitForGpsFix(options) {
  	    const settings = options || {};
  	    const maxAge = settings.maxAge || GPS_FINAL_MAX_AGE_MS;
  	    const accuracy = settings.accuracy || GPS_ACCEPTABLE_ACCURACY_M;
  	    const timeout = settings.timeout || GPS_TIMEOUT_MS;
  	    if (
  	      state.gps &&
  	      gpsFixFresh(state.gps, maxAge) &&
  	      toNumber(state.gps.accuracy, Infinity) <= accuracy
  	    ) return Promise.resolve(state.gps);
  	    startGpsWatch();
  	    return new Promise(function (resolve) {
  	      const waiter = {
  	        maxAge: maxAge,
  	        accuracy: accuracy,
  	        resolve: resolve,
  	        timer: 0
  	      };
  	      waiter.timer = window.setTimeout(function () {
  	        const index = gpsRuntime.waiters.indexOf(waiter);
  	        if (index !== -1) gpsRuntime.waiters.splice(index, 1);
  	        resolve(state.gps && gpsFixFresh(state.gps, maxAge) ? state.gps : null);
  	      }, timeout);
  	      gpsRuntime.waiters.push(waiter);
  	    });
  	  }
  	
  	  function refreshGps() {
  	    state.gps = null;
  	    state.gpsBusy = true;
  	    state.gpsError = "";
  	    state.gpsStatus = "Refreshing GPS…";
  	    if (gpsRuntime.watchId !== null && navigator.geolocation) {
  	      try { navigator.geolocation.clearWatch(gpsRuntime.watchId); } catch (_) {}
  	      gpsRuntime.watchId = null;
  	    }
  	    startGpsWatch();
  	  }
  	
  	  function vehicleQrCandidates(rawValue) {
  	    const rows = [];
  	    const push = function (value) {
  	      const token = clean(value);
  	      if (token && rows.indexOf(token) === -1) rows.push(token);
  	    };
  	    const raw = clean(rawValue);
  	    push(raw);
  	    try { push(decodeURIComponent(raw)); } catch (_) {}
  	    try {
  	      const parsed = JSON.parse(raw);
  	      if (parsed && typeof parsed === "object") {
  	        push(parsed.objectId);
  	        push(parsed.ObjectId);
  	        push(parsed.vehicleObjectId);
  	        push(parsed.VehicleObjectId);
  	        push(parsed.id);
  	      }
  	    } catch (_) {}
  	    try {
  	      const url = new URL(raw, window.location.href);
  	      ["objectId", "vehicleObjectId", "vehicle", "id"].forEach(function (key) {
  	        push(url.searchParams.get(key));
  	      });
  	      const parts = url.pathname.split("/").filter(Boolean);
  	      if (parts.length) push(parts[parts.length - 1]);
  	    } catch (_) {}
  	    ["FIF:", "VEHICLE:", "TRACTOR:", "OBJECTID:"].forEach(function (prefix) {
  	      if (raw.toUpperCase().indexOf(prefix) === 0) push(raw.slice(prefix.length));
  	    });
  	    const pair = raw.match(/(?:objectId|vehicleObjectId|vehicle|tractor)\s*[:=]\s*(.+)$/i);
  	    if (pair) push(pair[1]);
  	    return rows;
  	  }
  	
  	  function findBowserByQr(rawValue) {
  	    const candidates = vehicleQrCandidates(rawValue);
  	    const rows = companyBowserRows();
  	    for (let pass = 0; pass < 2; pass += 1) {
  	      for (let candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
  	        const candidate = pass === 0
  	          ? candidates[candidateIndex]
  	          : lower(candidates[candidateIndex]);
  	        for (let rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
  	          const id = objectIdOf(rows[rowIndex].bowser);
  	          const compare = pass === 0 ? id : lower(id);
  	          if (compare === candidate) {
  	            return Object.assign({}, rows[rowIndex], {
  	              scannedCode: clean(rawValue),
  	              matchedObjectId: id
  	            });
  	          }
  	        }
  	      }
  	    }
  	    return null;
  	  }
  	
  	  function scannerVehicleRows() {
  	    const company = selectedCompany();
  	    if (!company) return [];
  	    if (state.scannerContext === "contractor") {
  	      const contractor = selectedContractor();
  	      if (!contractor) return [];
  	      return companyVehicles(contractor).map(function (vehicle) {
  	        return { company: company, contractor: contractor, vehicle: vehicle, mode: "contractor" };
  	      });
  	    }
  	    return companyVehicles(company).map(function (vehicle) {
  	      return { company: company, contractor: null, vehicle: vehicle, mode: "vehicle" };
  	    });
  	  }
  	
  	  function findVehicleByQr(rawValue) {
  	    const candidates = vehicleQrCandidates(rawValue);
  	    const rows = scannerVehicleRows();
  	    for (let pass = 0; pass < 2; pass += 1) {
  	      for (let candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
  	        const candidate = pass === 0 ? candidates[candidateIndex] : lower(candidates[candidateIndex]);
  	        for (let rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
  	          const id = objectIdOf(rows[rowIndex].vehicle);
  	          const compare = pass === 0 ? id : lower(id);
  	          if (compare === candidate) {
  	            return Object.assign({}, rows[rowIndex], {
  	              scannedCode: clean(rawValue),
  	              matchedObjectId: id
  	            });
  	          }
  	        }
  	      }
  	    }
  	    return null;
  	  }
  	
  	  const qrRuntime = {
  	    stream: null,
  	    detector: null,
  	    frameRequest: 0,
  	    active: false,
  	    detecting: false,
  	    processing: false,
  	    lastDetectionAt: 0,
  	    track: null
  	  };
  	
  	  function stopQrScanner() {
  	    qrRuntime.active = false;
  	    qrRuntime.processing = false;
  	    qrRuntime.detecting = false;
  	    if (qrRuntime.frameRequest) {
  	      cancelAnimationFrame(qrRuntime.frameRequest);
  	      qrRuntime.frameRequest = 0;
  	    }
  	    if (qrRuntime.stream) {
  	      qrRuntime.stream.getTracks().forEach(function (track) {
  	        try { track.stop(); } catch (_) {}
  	      });
  	    }
  	    qrRuntime.stream = null;
  	    qrRuntime.detector = null;
  	    qrRuntime.track = null;
  	    state.scannerTorchAvailable = false;
  	    state.scannerTorchOn = false;
  	  }
  	
  	  function scannerPromptText() {
  	    return state.scannerContext === "bowser"
  	      ? "Point the camera at the Bowser QR code."
  	      : "Point the camera at the vehicle QR code.";
  	  }
  	
  	  function scannerUiStatus(status, error) {
  	    state.scannerStatus = clean(status);
  	    state.scannerError = clean(error);
  	    const statusNode = document.querySelector("#" + ROOT_ID + " [data-scanner-status]");
  	    const errorNode = document.querySelector("#" + ROOT_ID + " [data-scanner-error]");
  	    if (statusNode) statusNode.textContent = state.scannerStatus || scannerPromptText();
  	    if (errorNode) {
  	      errorNode.textContent = state.scannerError;
  	      errorNode.classList.toggle("visible", !!state.scannerError);
  	    }
  	  }
  	
  	  async function toggleScannerTorch() {
  	    const track = qrRuntime.track;
  	    if (!track || !state.scannerTorchAvailable || typeof track.applyConstraints !== "function") return;
  	    const next = !state.scannerTorchOn;
  	    try {
  	      await track.applyConstraints({ advanced: [{ torch: next }] });
  	      state.scannerTorchOn = next;
  	      const button = document.querySelector("#" + ROOT_ID + " [data-action='scanner-torch']");
  	      if (button) {
  	        button.classList.toggle("is-on", next);
  	        button.setAttribute("aria-pressed", next ? "true" : "false");
  	        button.querySelector("span").textContent = next ? "Light On" : "Light";
  	      }
  	    } catch (_) {
  	      scannerUiStatus(state.scannerStatus, "The camera light is not available on this device.");
  	    }
  	  }
  	
  	  async function acceptScannedBowser(rawValue) {
  	    if (qrRuntime.processing) return;
  	    qrRuntime.processing = true;
  	    const match = findBowserByQr(rawValue);
  	    if (!match) {
  	      scannerUiStatus(
  	        "Keep the QR code inside the square.",
  	        "This QR code does not match a Bowser loaded for this user."
  	      );
  	      if (navigator.vibrate) navigator.vibrate([70, 40, 70]);
  	      window.setTimeout(function () { qrRuntime.processing = false; }, 1200);
  	      return;
  	    }
  	
  	    if (navigator.vibrate) navigator.vibrate([45, 35, 90]);
  	    stopQrScanner();
  	    openCapture(
  	      objectIdOf(match.company),
  	      objectIdOf(match.tank),
  	      objectIdOf(match.bowser)
  	    );
  	  }
  	
  	  async function acceptScannedVehicle(rawValue) {
  	    if (state.scannerContext === "bowser") {
  	      return acceptScannedBowser(rawValue);
  	    }
  	    if (qrRuntime.processing) return;
  	    qrRuntime.processing = true;
  	    const match = findVehicleByQr(rawValue);
  	    if (!match) {
  	      scannerUiStatus(
  	        "Keep the QR code inside the square.",
  	        state.scannerContext === "contractor"
  	          ? "This QR code does not match a vehicle linked to the selected contractor."
  	          : "This QR code does not match a company vehicle loaded for this company."
  	      );
  	      if (navigator.vibrate) navigator.vibrate([70, 40, 70]);
  	      window.setTimeout(function () { qrRuntime.processing = false; }, 1200);
  	      return;
  	    }
  	    const tank = selectedTank();
  	    if (!vehicleMatchesTankGrade(match.vehicle, tankGrade(tank))) {
  	      scannerUiStatus(
  	        "Vehicle found, but fuel is not allowed.",
  	        vehicleName(match.vehicle) + " is not compatible with " + tankGrade(tank) + "."
  	      );
  	      if (navigator.vibrate) navigator.vibrate([90, 50, 90]);
  	      window.setTimeout(function () { qrRuntime.processing = false; }, 1600);
  	      return;
  	    }
  	    if (navigator.vibrate) navigator.vibrate([45, 35, 90]);
  	    stopQrScanner();
  	    state.vehicle = match.vehicle;
  	    state.vehicleObjectId = objectIdOf(match.vehicle);
  	    state.vehicleSource = match.mode;
  	    state.mode = match.mode;
  	    state.application = "";
  	    state.applicationOther = "";
  	    state.driverId = "";
  	    state.driverOther = "";
  	    state.mileage = "";
  	    state.litres = "";
  	    state.meter = "";
  	    state.description = "";
  	    state.captureQuestion = "application";
  	    state.questionError = "";
  	    state.screen = "capture";
  	    render();
  	    window.setTimeout(focusCurrentQuestionControl, 40);
  	  }
  	
  	  async function startQrScanner() {
  	    stopQrScanner();
  	    scannerUiStatus("Starting the rear camera…", "");
  	    if (!window.isSecureContext) {
  	      scannerUiStatus("Camera unavailable", "QR scanning requires the secure HTTPS page.");
  	      return;
  	    }
  	    if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== "function") {
  	      scannerUiStatus("Camera unavailable", "This browser cannot open the device camera.");
  	      return;
  	    }
  	    if (!("BarcodeDetector" in window)) {
  	      scannerUiStatus("QR reader unavailable", "This browser does not provide QR detection.");
  	      return;
  	    }
  	    try {
  	      if (typeof window.BarcodeDetector.getSupportedFormats === "function") {
  	        const formats = await window.BarcodeDetector.getSupportedFormats();
  	        if (Array.isArray(formats) && formats.indexOf("qr_code") === -1) {
  	          scannerUiStatus("QR reader unavailable", "This device does not support QR-code detection.");
  	          return;
  	        }
  	      }
  	      qrRuntime.detector = new window.BarcodeDetector({ formats: ["qr_code"] });
  	      qrRuntime.stream = await navigator.mediaDevices.getUserMedia({
  	        audio: false,
  	        video: {
  	          facingMode: { ideal: "environment" },
  	          width: { ideal: 1280 },
  	          height: { ideal: 1280 }
  	        }
  	      });
  	      qrRuntime.track = qrRuntime.stream.getVideoTracks()[0] || null;
  	      const capabilities = qrRuntime.track && typeof qrRuntime.track.getCapabilities === "function"
  	        ? qrRuntime.track.getCapabilities()
  	        : {};
  	      state.scannerTorchAvailable = !!(capabilities && capabilities.torch);
  	      const video = document.querySelector("#" + ROOT_ID + " [data-qr-video]");
  	      if (!video || state.screen !== "scanner") {
  	        stopQrScanner();
  	        return;
  	      }
  	      video.srcObject = qrRuntime.stream;
  	      video.setAttribute("playsinline", "");
  	      video.muted = true;
  	      await video.play();
  	      qrRuntime.active = true;
  	      scannerUiStatus("Camera ready — hold still over the QR code.", "");
  	      const torchButton = document.querySelector("#" + ROOT_ID + " [data-action='scanner-torch']");
  	      if (torchButton) torchButton.hidden = !state.scannerTorchAvailable;
  	      const scanFrame = async function (timestamp) {
  	        if (!qrRuntime.active || state.screen !== "scanner") return;
  	        const activeVideo = document.querySelector("#" + ROOT_ID + " [data-qr-video]");
  	        if (
  	          activeVideo &&
  	          activeVideo.readyState >= 2 &&
  	          !qrRuntime.detecting &&
  	          timestamp - qrRuntime.lastDetectionAt > 170
  	        ) {
  	          qrRuntime.lastDetectionAt = timestamp;
  	          qrRuntime.detecting = true;
  	          try {
  	            const codes = await qrRuntime.detector.detect(activeVideo);
  	            const qr = arr(codes).find(function (code) {
  	              return code && (!code.format || code.format === "qr_code") && clean(code.rawValue);
  	            });
  	            if (qr) await acceptScannedVehicle(qr.rawValue);
  	          } catch (error) {
  	            if (qrRuntime.active) console.warn("Mobile Fuel QR detection failed", error);
  	          } finally {
  	            qrRuntime.detecting = false;
  	          }
  	        }
  	        if (qrRuntime.active) qrRuntime.frameRequest = requestAnimationFrame(scanFrame);
  	      };
  	      qrRuntime.frameRequest = requestAnimationFrame(scanFrame);
  	    } catch (error) {
  	      stopQrScanner();
  	      const name = clean(error && error.name);
  	      const message = name === "NotAllowedError"
  	        ? "Camera permission was not allowed. Permit camera access and retry."
  	        : name === "NotFoundError"
  	          ? "No rear camera was found on this device."
  	          : "The camera could not start.";
  	      scannerUiStatus("Camera did not open", message);
  	    }
  	  }
  	
  	  function openScanner(context) {
  	    if (context === "contractor" && !selectedContractor()) {
  	      showOperationError("Select a contractor before scanning a contractor vehicle.");
  	      return;
  	    }
  	    state.scannerContext = context;
  	    state.scannerReturnScreen = context === "bowser" ? "dashboard" : "capture";
  	    state.scannerStatus = context === "bowser"
  	      ? "Starting the rear camera for the Bowser QR…"
  	      : "Starting the rear camera…";
  	    state.scannerError = "";
  	    state.screen = "scanner";
  	    render();
  	    startQrScanner();
  	  }
  	
  	  function pad2(value) {
  	    return String(value).padStart(2, "0");
  	  }
  	
  	  function getUtcDate(value) {
  	    const date = value ? new Date(value) : new Date();
  	    return Number.isNaN(date.getTime()) ? new Date() : date;
  	  }
  	
  	  function getBusinessDate(value) {
  	    const utcDate = getUtcDate(value);
  	    return new Date(utcDate.getTime() + BUSINESS_TIMEZONE_OFFSET_MINUTES * 60000);
  	  }
  	
  	  function getBusinessNowDate() {
  	    return getBusinessDate(new Date().toISOString());
  	  }
  	
  	  function getMYear(dateObj) {
  	    const date = dateObj ? getBusinessDate(dateObj) : getBusinessNowDate();
  	    return date.getUTCFullYear() + "-" + pad2(date.getUTCMonth() + 1);
  	  }
  	
  	  function getMonthLabel(dateObj) {
  	    const date = dateObj ? getBusinessDate(dateObj) : getBusinessNowDate();
  	    const names = [
  	      "January","February","March","April","May","June",
  	      "July","August","September","October","November","December"
  	    ];
  	    return names[date.getUTCMonth()] + " " + date.getUTCFullYear();
  	  }
  	
  	  function getMonthStartMs(dateObj) {
  	    const date = dateObj ? getBusinessDate(dateObj) : getBusinessNowDate();
  	    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1, 0, 0, 0, 0);
  	  }
  	
  	  function getMonthEndMs(dateObj) {
  	    const date = dateObj ? getBusinessDate(dateObj) : getBusinessNowDate();
  	    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1, 0, 0, 0, 0) - 1;
  	  }
  	
  	  async function saveTableRow(tableName, row) {
  	    if (!DB || !DB.Data || typeof DB.Data.of !== "function") {
  	      throw new Error("Backendless SDK is not available.");
  	    }
  	    updateOperation("Saving " + tableName + "…");
  	    return DB.Data.of(tableName).save(row);
  	  }
  	
  	  async function loadTableRow(tableName, objectId, relations, strictRelations) {
  	    if (!DB || !DB.Data || typeof DB.Data.of !== "function") {
  	      throw new Error("Backendless SDK is not available.");
  	    }
  	    if (!objectId) throw new Error(tableName + " objectId is missing.");
  	    const builder = DB.DataQueryBuilder ? DB.DataQueryBuilder.create() : null;
  	    if (builder && relations && relations.length) builder.setRelated(relations);
  	    if (!builder && strictRelations && relations && relations.length) {
  	      throw new Error(
  	        "Related data cannot be verified for " + tableName + "."
  	      );
  	    }
  	    const api = DB.Data.of(tableName);
  	    if (builder) {
  	      try {
  	        return await api.findById(objectId, builder);
  	      } catch (error) {
  	        if (strictRelations) throw error;
  	        if (relations && relations.length) {
  	          console.warn(
  	            "Related load failed for " + tableName + "; retrying the base row.",
  	            error
  	          );
  	        }
  	      }
  	    }
  	    return api.findById(objectId);
  	  }
  	
  	  async function setRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	    if (!parentObjectId) return null;
  	    const ids = arr(childObjectIds).filter(Boolean);
  	    const api = DB.Data.of(tableName);
  	    if (typeof api.setRelation !== "function") {
  	      throw new Error("Backendless setRelation is unavailable for " + tableName + "." + relationName);
  	    }
  	    updateOperation("Updating " + tableName + " " + relationName + "…");
  	    return api.setRelation({ objectId: parentObjectId }, relationName, ids);
  	  }
  	
  	  async function addRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	    if (!parentObjectId) return null;
  	    const ids = arr(childObjectIds).filter(Boolean);
  	    const api = DB.Data.of(tableName);
  	    if (typeof api.addRelation !== "function") {
  	      throw new Error("Backendless addRelation is unavailable for " + tableName + "." + relationName);
  	    }
  	    updateOperation("Linking " + relationName + "…");
  	    return api.addRelation({ objectId: parentObjectId }, relationName, ids);
  	  }
  	
  	  async function addRelationOptional(tableName, parentObjectId, relationName, childObjectIds) {
  	    try {
  	      return await addRelation(tableName, parentObjectId, relationName, childObjectIds);
  	    } catch (error) {
  	      console.warn("Optional relation failed:", tableName, relationName, error);
  	      return null;
  	    }
  	  }
  	
  	  function mobileRelationRows(value) {
  	    value = descriptorValue(value);
  	    if (Array.isArray(value)) return value.slice();
  	    if (value === null || value === undefined || value === "") return [];
  	    if (value && typeof value === "object") {
  	      if (Array.isArray(value.data)) return value.data.slice();
  	      if (Array.isArray(value.items)) return value.items.slice();
  	
  	      const length = Number(value.length);
  	      if (Number.isFinite(length) && length >= 0) {
  	        const rows = [];
  	        for (let index = 0; index < length; index += 1) {
  	          if (value[index] !== undefined) rows.push(value[index]);
  	        }
  	        return rows;
  	      }
  	
  	      try {
  	        if (typeof Symbol !== "undefined" && typeof value[Symbol.iterator] === "function") {
  	          return Array.from(value);
  	        }
  	      } catch (_) {}
  	
  	      return [value];
  	    }
  	    return [];
  	  }
  	
  	  async function mobileLoadRelation(tableName, parentId, relationName) {
  	    if (!DB || !parentId || !relationName || !DB.Data || typeof DB.Data.of !== "function") return [];
  	    if (!DB.LoadRelationsQueryBuilder || typeof DB.LoadRelationsQueryBuilder.create !== "function") return [];
  	
  	    const store = DB.Data.of(tableName);
  	    if (!store || typeof store.loadRelations !== "function") return [];
  	
  	    const all = [];
  	    const pageSize = 100;
  	
  	    for (let offset = 0; offset < 1000; offset += pageSize) {
  	      try {
  	        const query = DB.LoadRelationsQueryBuilder.create();
  	        query.setRelationName(relationName);
  	        if (typeof query.setPageSize === "function") query.setPageSize(pageSize);
  	        if (typeof query.setOffset === "function") query.setOffset(offset);
  	
  	        const batch = mobileRelationRows(await store.loadRelations(String(parentId), query));
  	        all.push.apply(all, batch);
  	
  	        if (batch.length < pageSize || typeof query.setOffset !== "function") break;
  	      } catch (_) {
  	        break;
  	      }
  	    }
  	
  	    return all;
  	  }
  	
  	  function mobileServiceArray(value) {
  	    value = mobileCollectionValue(value);
  	    if (Array.isArray(value)) return value.slice();
  	    if (value && typeof value === "object") {
  	      if (Array.isArray(value.data)) return value.data.slice();
  	      if (Array.isArray(value.items)) return value.items.slice();
  	    }
  	    return [];
  	  }
  	
  	  function mobileCollectionValue(value) {
  	    if (value === null || value === undefined) return value;
  	    if (Array.isArray(value)) return value;
  	
  	    if (value && typeof value === "object") {
  	      const keys = ["value", "Value", "current", "Current"];
  	      for (let index = 0; index < keys.length; index += 1) {
  	        const key = keys[index];
  	        if (
  	          Object.prototype.hasOwnProperty.call(value, key) &&
  	          value[key] !== null &&
  	          value[key] !== undefined
  	        ) {
  	          return mobileCollectionValue(value[key]);
  	        }
  	      }
  	    }
  	
  	    return value;
  	  }
  	
  	  function mobileAppCompanies() {
  	    return uniqueObjects(
  	      arr(getDeep(APP_DATA, ["User", "Companies"], []))
  	        .concat(arr(APP_DATA && APP_DATA.Companies))
  	    );
  	  }
  	
  	  function mobileCompanyIdentityKeys(company) {
  	    if (!company || typeof company !== "object") return [];
  	
  	    return [
  	      objectIdOf(company),
  	      descriptorValue(company.CompanyId),
  	      descriptorValue(company.CompanyID),
  	      descriptorValue(company.Name),
  	      descriptorValue(company.CompanyName),
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "CompanyId"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "Company_Name"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "TradingName"], ""))
  	    ].map(function (value) {
  	      return lower(value);
  	    }).filter(Boolean);
  	  }
  	
  	  function mobileCompanyContainsVehicle(company, vehicle) {
  	    const vehicleId = objectIdOf(vehicle);
  	    const registration = lower(vehicleRegistration(vehicle));
  	    const code = lower(firstValue([
  	      descriptorValue(vehicle && vehicle.ID),
  	      descriptorValue(vehicle && vehicle.FID),
  	      descriptorValue(vehicle && vehicle.Name)
  	    ], ""));
  	
  	    return arr(company && company.Tractors)
  	      .concat(arr(company && company.Vehicles))
  	      .some(function (item) {
  	        if (!item || typeof item !== "object") return false;
  	        if (vehicleId && objectIdOf(item) === vehicleId) return true;
  	
  	        const itemRegistration = lower(vehicleRegistration(item));
  	        if (registration && itemRegistration && registration === itemRegistration) return true;
  	
  	        const itemCode = lower(firstValue([
  	          descriptorValue(item.ID),
  	          descriptorValue(item.FID),
  	          descriptorValue(item.Name)
  	        ], ""));
  	
  	        return !!(code && itemCode && code === itemCode);
  	      });
  	  }
  	
  	  function mobileResolveCompanyFromAppData(company, vehicle) {
  	    const companies = mobileAppCompanies();
  	    if (!companies.length) return company || null;
  	
  	    const containing = companies.find(function (candidate) {
  	      return mobileCompanyContainsVehicle(candidate, vehicle);
  	    });
  	    if (containing) return containing;
  	
  	    const suppliedKeys = mobileCompanyIdentityKeys(company);
  	    if (suppliedKeys.length) {
  	      const matching = companies.find(function (candidate) {
  	        return mobileCompanyIdentityKeys(candidate).some(function (key) {
  	          return suppliedKeys.indexOf(key) !== -1;
  	        });
  	      });
  	      if (matching) return matching;
  	    }
  	
  	    return companies.length === 1 ? companies[0] : (company || null);
  	  }
  	
  	  function mobileUniqueEmails(values) {
  	    const result = [];
  	    const seen = Object.create(null);
  	
  	    arr(values).forEach(function (value) {
  	      String(descriptorValue(value) || "")
  	        .split(/[;,\n]+/)
  	        .map(function (item) { return clean(item); })
  	        .filter(Boolean)
  	        .forEach(function (email) {
  	          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
  	          const key = lower(email);
  	          if (seen[key]) return;
  	          seen[key] = true;
  	          result.push(email);
  	        });
  	    });
  	
  	    return result;
  	  }
  	
  	  function mobileCompanyServiceEmails(company) {
  	    if (!company || typeof company !== "object") return [];
  	
  	    return mobileUniqueEmails([
  	      getDeep(company, ["Manifest", "Profile", "PrimaryEmail"], null),
  	      getDeep(company, ["Manifest", "Contacts", "Primary", "Email"], null),
  	      getDeep(company, ["Manifest", "Profile", "Email"], null),
  	      getDeep(company, ["Manifest", "Billing", "Account", "InvoiceEmail"], null),
  	      getDeep(company, ["Manifest", "Billing", "Account", "StatementEmail"], null),
  	      company.PrimaryEmail,
  	      company.CompanyEmail,
  	      company.Email,
  	      company.email
  	    ]);
  	  }
  	
  	  function mobileVehicleIdentityDetails(vehicle) {
  	    function read(paths) {
  	      for (let index = 0; index < paths.length; index += 1) {
  	        const value = clean(descriptorValue(getDeep(vehicle, paths[index], "")));
  	        if (value) return value;
  	      }
  	      return "Not captured";
  	    }
  	
  	    return {
  	      make: read([
  	        ["Data", "Vehicle", "Identity", "Make"],
  	        ["Data", "Vehicle", "Make"],
  	        ["Make"]
  	      ]),
  	      model: read([
  	        ["Data", "Vehicle", "Identity", "Model"],
  	        ["Data", "Vehicle", "Model"],
  	        ["Model"]
  	      ]),
  	      year: read([
  	        ["Data", "Vehicle", "Identity", "Year"],
  	        ["Data", "Vehicle", "Year"],
  	        ["Year"]
  	      ]),
  	      vin: read([
  	        ["Data", "Vehicle", "Identity", "VIN"],
  	        ["Data", "Vehicle", "VIN"],
  	        ["VIN"]
  	      ]),
  	      engineNumber: read([
  	        ["Data", "Vehicle", "Identity", "EngineNumber"],
  	        ["Data", "Vehicle", "EngineNumber"],
  	        ["Data", "Vehicle", "Engine_Number"],
  	        ["EngineNumber"],
  	        ["Engine_Number"]
  	      ])
  	    };
  	  }
  	
  	  function mobileServiceProviders(company) {
  	    const rows = mobileServiceArray(firstValue([
  	      getDeep(company, ["Manifest", "ServiceProviders"], null),
  	      getDeep(company, ["Data", "Manifest", "ServiceProviders"], null)
  	    ], []));
  	    return rows.map(function (provider) {
  	      provider = provider && typeof provider === "object" ? provider : {};
  	      return {
  	        ProviderId: clean(firstValue([
  	          provider.ProviderId,
  	          provider.Id,
  	          provider.objectId,
  	          provider.Name,
  	          provider.CompanyName
  	        ], "")),
  	        Name: clean(firstValue([provider.Name, provider.Company, provider.CompanyName, "Service Provider"], "Service Provider")),
  	        TradingName: clean(provider.TradingName),
  	        Status: clean(provider.Status || "Active"),
  	        Preferred: booleanValue(provider.Preferred),
  	        Contact: {
  	          Email: clean(firstValue([
  	            getDeep(provider, ["Contact", "Email"], null),
  	            provider.Email
  	          ], ""))
  	        }
  	      };
  	    });
  	  }
  	
  	  function mobileServiceProviderLabel(provider) {
  	    return clean(firstValue([
  	      provider && provider.TradingName,
  	      provider && provider.Name,
  	      "Service Provider"
  	    ], "Service Provider"));
  	  }
  	
  	  function mobileServiceProviderByIdOrName(company, value) {
  	    const wanted = clean(value);
  	    if (!wanted) return null;
  	    const key = lower(wanted);
  	    return mobileServiceProviders(company).find(function (provider) {
  	      return clean(provider.ProviderId) === wanted ||
  	        lower(mobileServiceProviderLabel(provider)) === key ||
  	        lower(provider.Name) === key;
  	    }) || null;
  	  }
  	
  	  function mobileServiceSetup(vehicle) {
  	    const service = getDeep(vehicle, ["Data", "Service"], {}) || {};
  	    const schedule = getDeep(service, ["Schedule"], {}) || {};
  	    const notifications = getDeep(service, ["Notifications"], {}) || {};
  	    const current = getDeep(service, ["Current"], {}) || {};
  	    const history = getDeep(service, ["History"], {}) || {};
  	    const profile = vehicleMeterProfile(vehicle);
  	    const hours = profile.kind === "hours";
  	
  	    return {
  	      unit: hours ? "h" : "km",
  	      notifyProvider: booleanValue(descriptorValue(notifications.NotifyServiceProvider)),
  	      notifyCompany: booleanValue(descriptorValue(notifications.NotifyCompany)),
  	      providerId: clean(descriptorValue(firstValue([
  	        notifications.ServiceProviderId,
  	        notifications.ProviderId
  	      ], ""))),
  	      providerName: clean(descriptorValue(firstValue([
  	        notifications.ServiceProviderName,
  	        notifications.ProviderName
  	      ], ""))),
  	      interval: Math.max(0, numberOr(descriptorValue(firstValue(hours ? [
  	        schedule.ServiceIntervalHours,
  	        schedule.Service_Interval_Hours
  	      ] : [
  	        schedule.ServiceIntervalKM,
  	        schedule.Service_Interval_KM,
  	        service.Service_Interval
  	      ], 0)), 0)),
  	      intervalDays: Math.max(0, numberOr(descriptorValue(firstValue([
  	        schedule.ServiceIntervalDays,
  	        schedule.Service_Interval_Days
  	      ], 0)), 0)),
  	      warning: Math.max(0, numberOr(descriptorValue(firstValue(hours ? [
  	        schedule.ServiceWarningHours
  	      ] : [
  	        schedule.ServiceWarningKM,
  	        service.Service_Warning_Duration_in_KM
  	      ], 0)), 0)),
  	      warningDays: Math.max(0, numberOr(descriptorValue(schedule.ServiceWarningDays), 0)),
  	      lastReading: numberValue(descriptorValue(firstValue(hours ? [
  	        current.LastServiceHours,
  	        current.Last_Service_Hours,
  	        history.Last_Service_Hours
  	      ] : [
  	        current.LastServiceMileage,
  	        current.Last_Service_KM,
  	        current.LastServiceKM,
  	        history.Last_Service_KM
  	      ], null))),
  	      storedNextReading: numberValue(descriptorValue(firstValue(hours ? [
  	        current.NextServiceHours,
  	        current.Next_Service_Hours,
  	        history.Next_Service_Hours
  	      ] : [
  	        current.NextServiceMileage,
  	        current.Next_Service_KM,
  	        current.NextServiceKM,
  	        history.Next_Service_KM
  	      ], null))),
  	      lastDate: clean(descriptorValue(firstValue([
  	        current.LastServiceDate,
  	        current.Last_Service_Date,
  	        history.Last_Service_Date
  	      ], ""))),
  	      storedNextDate: clean(descriptorValue(firstValue([
  	        current.NextServiceDate,
  	        current.Next_Service_Date_Estimate,
  	        current.Next_Service_Date,
  	        history.Next_Service_Date_Estimate,
  	        history.Next_Service_Date
  	      ], "")))
  	    };
  	  }
  	
  	  function mobileDatePlusDays(value, days) {
  	    const date = new Date(value);
  	    const count = Math.round(numberOr(days, 0));
  	    if (!count || Number.isNaN(date.getTime())) return "";
  	    date.setUTCDate(date.getUTCDate() + count);
  	    return date.toISOString().slice(0, 10);
  	  }
  	
  	  function mobileDaysUntil(value) {
  	    const date = new Date(value);
  	    if (!value || Number.isNaN(date.getTime())) return null;
  	    const today = new Date();
  	    today.setHours(0, 0, 0, 0);
  	    date.setHours(0, 0, 0, 0);
  	    return Math.ceil((date.getTime() - today.getTime()) / 86400000);
  	  }
  	
  	  function mobileServiceWorkOrders(company, vehicle) {
  	    const vehicleId = objectIdOf(vehicle);
  	    const vehicleCode = clean(firstValue([vehicle && vehicle.ID, vehicle && vehicle.FID, vehicleName(vehicle)], ""));
  	    const manifestRows = mobileServiceArray(firstValue([
  	      getDeep(company, ["Manifest", "ServiceWorkOrders"], null),
  	      getDeep(company, ["Data", "Manifest", "ServiceWorkOrders"], null)
  	    ], []));
  	    return uniqueObjects(manifestRows.concat(mobileRelationRows(vehicle && vehicle.Maintenance))).filter(function (order) {
  	      const linkedId = clean(firstValue([
  	        order && order.VehicleObjectId,
  	        order && order.TractorObjectId,
  	        getDeep(order, ["Data", "VehicleObjectId"], "")
  	      ], ""));
  	      const linkedCode = clean(firstValue([
  	        order && order.VehicleId,
  	        order && order.TractorId,
  	        order && order.Registration,
  	        getDeep(order, ["Data", "VehicleId"], "")
  	      ], ""));
  	      return !linkedId && !linkedCode ? true :
  	        (vehicleId && linkedId === vehicleId) ||
  	        (vehicleCode && linkedCode === vehicleCode) ||
  	        (vehicleRegistration(vehicle) && linkedCode === vehicleRegistration(vehicle));
  	    });
  	  }
  	
  	  function mobileCanonicalMaintenanceStatus(value) {
  	    const key = lower(value).replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  	    if (!key || key === "new" || key === "scheduled" || key === "planned") return "Scheduled";
  	    if (key === "booked" || key === "confirmed" || key === "booking confirmed") return "Booked";
  	    if (key === "in progress" || key === "at provider" || key === "workshop" || key === "started") return "In Progress";
  	    if (key === "waiting parts" || key === "waiting for parts" || key === "delayed" || key === "on hold") return "Waiting Parts";
  	    if (key === "ready" || key === "ready for collection" || key === "awaiting collection") return "Ready";
  	    if (key === "completed" || key === "complete" || key === "closed") return "Completed";
  	    if (key === "cancelled" || key === "canceled" || key === "abandoned") return "Cancelled";
  	    return clean(value) || "Scheduled";
  	  }
  	
  	  function mobileServiceHealth(company, vehicle) {
  	    const setup = mobileServiceSetup(vehicle);
  	    const reading = currentMileage(vehicle);
  	    const nextReading = setup.lastReading !== null && setup.interval > 0
  	      ? setup.lastReading + setup.interval
  	      : setup.storedNextReading !== null && setup.storedNextReading > 0
  	        ? setup.storedNextReading
  	        : null;
  	    const nextDate = setup.lastDate && setup.intervalDays > 0
  	      ? mobileDatePlusDays(setup.lastDate, setup.intervalDays)
  	      : setup.storedNextDate;
  	    const calculationReading = reading === null
  	      ? setup.lastReading
  	      : setup.lastReading === null
  	        ? reading
  	        : Math.max(reading, setup.lastReading);
  	    const remaining = nextReading === null || calculationReading === null ? null : nextReading - calculationReading;
  	    const remainingDays = nextDate ? mobileDaysUntil(nextDate) : null;
  	    const counterConflict = nextReading !== null && setup.lastReading !== null && nextReading <= setup.lastReading;
  	    const lastDateValue = setup.lastDate ? new Date(setup.lastDate) : null;
  	    const nextDateValue = nextDate ? new Date(nextDate) : null;
  	    const dateConflict = !!(
  	      lastDateValue && nextDateValue &&
  	      !Number.isNaN(lastDateValue.getTime()) &&
  	      !Number.isNaN(nextDateValue.getTime()) &&
  	      nextDateValue.getTime() <= lastDateValue.getTime()
  	    );
  	    const openOrders = mobileServiceWorkOrders(company, vehicle).filter(function (order) {
  	      const category = lower(firstValue([order && order.Category, getDeep(order, ["Data", "Category"], "")], ""));
  	      const status = mobileCanonicalMaintenanceStatus(firstValue([order && order.Status, getDeep(order, ["Data", "Status"], "")], ""));
  	      return (category === "service" || /service/.test(category)) &&
  	        ["Scheduled", "Booked", "In Progress", "Waiting Parts", "Ready"].indexOf(status) !== -1;
  	    });
  	
  	    return {
  	      unit: setup.unit,
  	      nextCounter: nextReading,
  	      lastCounter: setup.lastReading,
  	      remainingCounter: remaining,
  	      nextDate: nextDate,
  	      remainingDays: remainingDays,
  	      warningCounter: setup.warning,
  	      warningDays: setup.warningDays,
  	      dataConflict: counterConflict || dateConflict,
  	      openOrders: openOrders
  	    };
  	  }
  	
  	  function mobileProviderSnapshotFromVehicle(vehicle, requested) {
  	    const notifications = getDeep(vehicle, ["Data", "Service", "Notifications"], {}) || {};
  	    let providerId = clean(descriptorValue(firstValue([
  	      notifications.ServiceProviderId,
  	      notifications.ProviderId,
  	      requested
  	    ], "")));
  	    let providerName = clean(descriptorValue(firstValue([
  	      notifications.ServiceProviderName,
  	      notifications.ProviderName
  	    ], "")));
  	    let providerEmail = clean(descriptorValue(firstValue([
  	      notifications.ServiceProviderEmail,
  	      notifications.ProviderEmail
  	    ], "")));
  	
  	    const wanted = lower(firstValue([requested, providerId, providerName], ""));
  	    const history = mobileProviderHistory(vehicle);
  	
  	    for (let index = history.length - 1; index >= 0; index -= 1) {
  	      const entry = history[index] || {};
  	      const historyId = clean(entry.ProviderId);
  	      const historyName = clean(entry.ProviderName);
  	      const historyEmail = clean(entry.ProviderEmail);
  	
  	      const matches =
  	        !wanted ||
  	        lower(historyId) === wanted ||
  	        lower(historyName) === wanted ||
  	        (providerId && historyId === providerId) ||
  	        (providerName && lower(historyName) === lower(providerName));
  	
  	      if (!matches) continue;
  	
  	      if (!providerId && historyId) providerId = historyId;
  	      if (!providerName && historyName) providerName = historyName;
  	      if (!providerEmail && historyEmail) providerEmail = historyEmail;
  	
  	      if (providerEmail) break;
  	    }
  	
  	    if (!providerEmail) return null;
  	
  	    return {
  	      ProviderId: providerId || clean(requested) || providerName || "vehicle-provider",
  	      Name: providerName || clean(requested) || "Service Provider",
  	      TradingName: "",
  	      Status: "Active",
  	      Preferred: false,
  	      Contact: {
  	        Email: providerEmail
  	      },
  	      Source: "Vehicle Service Notification Snapshot"
  	    };
  	  }
  	
  	  function mobileResolveNotificationProvider(company, vehicle, requested, health) {
  	    let provider = mobileServiceProviderByIdOrName(company, requested);
  	    if (provider && lower(provider.Status) === "active") return provider;
  	
  	    const setup = mobileServiceSetup(vehicle);
  	    provider = mobileServiceProviderByIdOrName(company, setup.providerId || setup.providerName);
  	    if (provider && lower(provider.Status) === "active") return provider;
  	
  	    const openOrders = health && Array.isArray(health.openOrders) ? health.openOrders : [];
  	    for (let index = 0; index < openOrders.length; index += 1) {
  	      provider = mobileServiceProviderByIdOrName(
  	        company,
  	        firstValue([openOrders[index].ProviderId, openOrders[index].ProviderName], "")
  	      );
  	      if (provider && lower(provider.Status) === "active") return provider;
  	    }
  	
  	    const lastUsed = clean(descriptorValue(firstValue([
  	      getDeep(vehicle, ["Data", "Service", "Current", "ServiceCentreLastUsed"], ""),
  	      getDeep(vehicle, ["Data", "Service", "History", "Service_Centre_Last_Used"], "")
  	    ], "")));
  	    provider = mobileServiceProviderByIdOrName(company, lastUsed);
  	    if (provider && lower(provider.Status) === "active") return provider;
  	
  	    const active = mobileServiceProviders(company).filter(function (candidate) {
  	      return lower(candidate.Status) === "active";
  	    });
  	    const preferred = active.filter(function (candidate) { return candidate.Preferred === true; });
  	    if (preferred.length === 1) return preferred[0];
  	    if (active.length === 1) return active[0];
  	
  	    return mobileProviderSnapshotFromVehicle(
  	      vehicle,
  	      firstValue([requested, setup.providerId, setup.providerName], "")
  	    );
  	  }
  	
  	  function mobileServiceNotificationCandidate(company, vehicle) {
  	    const setup = mobileServiceSetup(vehicle);
  	    if (!setup.notifyProvider && !setup.notifyCompany) return null;
  	    const health = mobileServiceHealth(company, vehicle);
  	    if (health.dataConflict || (health.nextCounter === null && !health.nextDate)) return null;
  	
  	    const overdue =
  	      (health.remainingCounter !== null && health.remainingCounter <= 0) ||
  	      (health.remainingDays !== null && health.remainingDays < 0);
  	    const dueSoon =
  	      (health.remainingCounter !== null && health.warningCounter > 0 && health.remainingCounter <= health.warningCounter) ||
  	      (health.remainingDays !== null && health.warningDays > 0 && health.remainingDays <= health.warningDays);
  	    if (!overdue && !dueSoon) return null;
  	
  	    const provider = mobileResolveNotificationProvider(company, vehicle, "", health);
  	    const stage = overdue ? "OVERDUE" : "DUE_SOON";
  	    const remaining = [];
  	    const due = [];
  	    if (health.remainingCounter !== null) {
  	      remaining.push(
  	        health.remainingCounter <= 0
  	          ? formatNumber(Math.abs(health.remainingCounter), 0) + " " + health.unit + " overdue"
  	          : formatNumber(health.remainingCounter, 0) + " " + health.unit + " remaining"
  	      );
  	    }
  	    if (health.remainingDays !== null) {
  	      remaining.push(
  	        health.remainingDays < 0
  	          ? Math.abs(health.remainingDays) + " day" + (Math.abs(health.remainingDays) === 1 ? "" : "s") + " overdue"
  	          : health.remainingDays === 0
  	            ? "due today"
  	            : health.remainingDays + " day" + (health.remainingDays === 1 ? "" : "s") + " remaining"
  	      );
  	    }
  	    if (health.nextCounter !== null) due.push(formatNumber(health.nextCounter, 0) + " " + health.unit);
  	    if (health.nextDate) due.push(health.nextDate);
  	
  	    const cycle = [
  	      health.nextCounter === null ? "" : String(Math.round(health.nextCounter * 100) / 100),
  	      clean(health.nextDate)
  	    ].join("|");
  	
  	    return {
  	      key: [
  	        "SERVICE",
  	        objectIdOf(vehicle),
  	        provider ? provider.ProviderId : (setup.providerId || setup.providerName || "NO_PROVIDER"),
  	        stage,
  	        cycle
  	      ].join("|"),
  	      kind: "Service",
  	      stage: stage,
  	      provider: provider,
  	      title: overdue ? "Service Overdue" : "Service Due Soon",
  	      summary: remaining.join(" · ") || (overdue ? "The scheduled service is overdue." : "The scheduled service is approaching."),
  	      duePosition: due.join(" · ") || "Configured service interval",
  	      scope: "Scheduled vehicle service",
  	      reference: ""
  	    };
  	  }
  	
  	  function mobilePreventivePlans(vehicle) {
  	    return mobileServiceArray(getDeep(vehicle, ["Data", "Maintenance", "PreventivePlans"], []))
  	      .filter(function (plan) { return plan && typeof plan === "object" && !Array.isArray(plan); })
  	      .map(function (plan) {
  	        return {
  	          PlanId: clean(plan.PlanId),
  	          Name: clean(plan.Name),
  	          Scope: clean(plan.Scope),
  	          TriggerMode: clean(plan.TriggerMode || "First Due"),
  	          IntervalKM: Math.max(0, numberOr(plan.IntervalKM, 0)),
  	          IntervalDays: Math.max(0, numberOr(plan.IntervalDays, 0)),
  	          WarningKM: Math.max(0, numberOr(plan.WarningKM, 0)),
  	          WarningDays: Math.max(0, numberOr(plan.WarningDays, 0)),
  	          BaselineKM: numberValue(plan.BaselineKM),
  	          BaselineDate: clean(plan.BaselineDate),
  	          ProviderId: clean(plan.ProviderId),
  	          ProviderName: clean(plan.ProviderName),
  	          Active: plan.Active !== false
  	        };
  	      });
  	  }
  	
  	  function mobilePreventiveRecords(vehicle, planId) {
  	    const wanted = clean(planId);
  	    return mobileRelationRows(vehicle && vehicle.Maintenance).filter(function (record) {
  	      return clean(firstValue([
  	        record && record.PreventivePlanId,
  	        getDeep(record, ["Data", "PreventivePlanId"], "")
  	      ], "")) === wanted;
  	    });
  	  }
  	
  	  function mobilePreventiveCandidate(company, vehicle, plan) {
  	    if (!plan || !plan.Active) return null;
  	    const records = mobilePreventiveRecords(vehicle, plan.PlanId);
  	    const openJob = records.find(function (record) {
  	      const status = mobileCanonicalMaintenanceStatus(firstValue([record && record.Status, getDeep(record, ["Data", "Status"], "")], ""));
  	      return ["Scheduled", "Booked", "In Progress", "Waiting Parts", "Ready"].indexOf(status) !== -1;
  	    });
  	    if (openJob) return null;
  	
  	    const completed = records.filter(function (record) {
  	      return mobileCanonicalMaintenanceStatus(firstValue([record && record.Status, getDeep(record, ["Data", "Status"], "")], "")) === "Completed";
  	    }).sort(function (left, right) {
  	      const rightTime = new Date(firstValue([right && right.CompletedDate, right && right.ReportedDate, 0], 0)).getTime();
  	      const leftTime = new Date(firstValue([left && left.CompletedDate, left && left.ReportedDate, 0], 0)).getTime();
  	      return rightTime - leftTime;
  	    })[0] || null;
  	
  	    const currentCounter = currentMileage(vehicle);
  	    const baselineCounter = completed
  	      ? numberValue(firstValue([completed.Odometer, getDeep(completed, ["Data", "Odometer"], null)], null))
  	      : plan.BaselineKM;
  	    const baselineDate = clean(
  	      completed
  	        ? firstValue([completed.CompletedDate, completed.ReportedDate], "")
  	        : plan.BaselineDate
  	    );
  	    const useCounter = plan.TriggerMode !== "Time Only" && plan.IntervalKM > 0;
  	    const useTime = plan.TriggerMode !== "Kilometers Only" && plan.IntervalDays > 0;
  	    const nextCounter = useCounter && baselineCounter !== null ? baselineCounter + plan.IntervalKM : null;
  	    const nextDate = useTime && baselineDate ? mobileDatePlusDays(baselineDate, plan.IntervalDays) : "";
  	    const calculationCounter = currentCounter === null
  	      ? baselineCounter
  	      : baselineCounter === null
  	        ? currentCounter
  	        : Math.max(currentCounter, baselineCounter);
  	    const remainingCounter = nextCounter !== null && calculationCounter !== null ? nextCounter - calculationCounter : null;
  	    const remainingDays = nextDate ? mobileDaysUntil(nextDate) : null;
  	    const overdue =
  	      (useCounter && remainingCounter !== null && remainingCounter <= 0) ||
  	      (useTime && remainingDays !== null && remainingDays <= 0);
  	    const dueSoon = !overdue && (
  	      (useCounter && remainingCounter !== null && plan.WarningKM > 0 && remainingCounter <= plan.WarningKM) ||
  	      (useTime && remainingDays !== null && plan.WarningDays > 0 && remainingDays <= plan.WarningDays)
  	    );
  	    if (!overdue && !dueSoon) return null;
  	
  	    const provider = mobileResolveNotificationProvider(
  	      company,
  	      vehicle,
  	      plan.ProviderId || plan.ProviderName,
  	      null
  	    );
  	
  	    const stage = overdue ? "OVERDUE" : "DUE_SOON";
  	    const remaining = [];
  	    const due = [];
  	    if (remainingCounter !== null) {
  	      remaining.push(
  	        remainingCounter <= 0
  	          ? formatNumber(Math.abs(remainingCounter), 0) + " km overdue"
  	          : formatNumber(remainingCounter, 0) + " km remaining"
  	      );
  	    }
  	    if (remainingDays !== null) {
  	      remaining.push(
  	        remainingDays <= 0
  	          ? Math.abs(remainingDays) + " day" + (Math.abs(remainingDays) === 1 ? "" : "s") + " overdue"
  	          : remainingDays + " day" + (remainingDays === 1 ? "" : "s") + " remaining"
  	      );
  	    }
  	    if (nextCounter !== null) due.push(formatNumber(nextCounter, 0) + " km");
  	    if (nextDate) due.push(nextDate);
  	
  	    return {
  	      key: [
  	        "MAINTENANCE",
  	        objectIdOf(vehicle),
  	        plan.PlanId,
  	        provider ? provider.ProviderId : (plan.ProviderId || plan.ProviderName || "NO_PROVIDER"),
  	        stage,
  	        nextCounter === null ? "" : String(Math.round(nextCounter * 100) / 100),
  	        clean(nextDate)
  	      ].join("|"),
  	      kind: "Maintenance",
  	      stage: stage,
  	      provider: provider,
  	      title: overdue ? "Preventive Maintenance Overdue" : "Preventive Maintenance Due Soon",
  	      summary: remaining.join(" · ") || (overdue ? "Maintenance overdue" : "Maintenance due soon"),
  	      duePosition: due.join(" · ") || "Preventive maintenance interval",
  	      scope: plan.Scope || plan.Name || "Preventive maintenance",
  	      reference: plan.PlanId
  	    };
  	  }
  	
  	  function mobileNotificationCandidates(company, vehicle) {
  	    const setup = mobileServiceSetup(vehicle);
  	    if (!setup.notifyProvider && !setup.notifyCompany) return [];
  	    const service = mobileServiceNotificationCandidate(company, vehicle);
  	    return (service ? [service] : []).concat(
  	      mobilePreventivePlans(vehicle).map(function (plan) {
  	        return mobilePreventiveCandidate(company, vehicle, plan);
  	      }).filter(Boolean)
  	    );
  	  }
  	
  	  function mobileProviderHistory(vehicle) {
  	    const raw = mobileCollectionValue(
  	      getDeep(vehicle, ["Data", "Service", "Notifications", "ProviderEmailHistory"], [])
  	    );
  	    return Array.isArray(raw)
  	      ? raw.filter(function (entry) { return entry && typeof entry === "object" && !Array.isArray(entry); }).map(deepClone)
  	      : [];
  	  }
  	
  	  function mobileSetDescriptor(container, key, value) {
  	    if (!container || typeof container !== "object") return;
  	    const existing = container[key];
  	    if (existing && typeof existing === "object" && !Array.isArray(existing) && Object.prototype.hasOwnProperty.call(existing, "value")) {
  	      existing.value = deepClone(value);
  	    } else {
  	      container[key] = deepClone(value);
  	    }
  	  }
  	
  	  function mobileSetProviderHistory(vehicle, history) {
  	    if (!vehicle.Data || typeof vehicle.Data !== "object" || Array.isArray(vehicle.Data)) vehicle.Data = {};
  	    if (!vehicle.Data.Service || typeof vehicle.Data.Service !== "object" || Array.isArray(vehicle.Data.Service)) vehicle.Data.Service = {};
  	    if (!vehicle.Data.Service.Notifications || typeof vehicle.Data.Service.Notifications !== "object" || Array.isArray(vehicle.Data.Service.Notifications)) {
  	      vehicle.Data.Service.Notifications = {};
  	    }
  	    const rows = arr(history).slice(-100);
  	    mobileSetDescriptor(vehicle.Data.Service.Notifications, "ProviderEmailHistory", rows);
  	    mobileSetDescriptor(
  	      vehicle.Data.Service.Notifications,
  	      "LastProviderEmailAt",
  	      rows.length ? clean(rows[rows.length - 1].SentAt) : ""
  	    );
  	  }
  	
  	  function mobileNotificationHistoryRecipientState(history, candidateKey) {
  	    let providerSent = false;
  	    let companySent = false;
  	
  	    arr(history).forEach(function (entry) {
  	      if (!entry || clean(entry.Key) !== clean(candidateKey)) return;
  	
  	      if (
  	        entry.ProviderEmailSent === true ||
  	        clean(entry.ProviderEmail)
  	      ) providerSent = true;
  	
  	      if (
  	        entry.CompanyEmailSent === true ||
  	        clean(entry.CompanyEmail) ||
  	        clean(entry.CompanyEmails)
  	      ) companySent = true;
  	    });
  	
  	    return {
  	      providerSent: providerSent,
  	      companySent: companySent
  	    };
  	  }
  	
  	  function mobileProviderEmailBody(company, vehicle, candidate, fuel) {
  	    const providerName = candidate.provider
  	      ? mobileServiceProviderLabel(candidate.provider)
  	      : "Not configured";
  	    const companyLabel = companyName(company);
  	    const vehicleLabel = vehicleName(vehicle);
  	    const registration = vehicleRegistration(vehicle) || "Not captured";
  	    const identity = mobileVehicleIdentityDetails(vehicle);
  	    const litres = numberOr(fuel && fuel.Litres, 0);
  	    const profile = vehicleMeterProfile(vehicle);
  	    const reading = currentMileage(vehicle);
  	    const fuelOutId = objectIdOf(fuel);
  	
  	    const textBody = [
  	      "Fleet In Form - " + candidate.title,
  	      "",
  	      "Service Provider: " + providerName,
  	      "Company: " + companyLabel,
  	      "Vehicle: " + vehicleLabel,
  	      "Registration: " + registration,
  	      "Make: " + identity.make,
  	      "Model: " + identity.model,
  	      "Year: " + identity.year,
  	      "VIN: " + identity.vin,
  	      "Engine Number: " + identity.engineNumber,
  	      "Type: " + candidate.kind,
  	      "Status: " + candidate.title,
  	      "Current Position: " + candidate.summary,
  	      "Due Position: " + candidate.duePosition,
  	      "Work Scope: " + candidate.scope,
  	      candidate.reference ? "Reference: " + candidate.reference : "",
  	      "Fuel Transaction: " + formatNumber(litres, 2) + " L",
  	      fuelOutId ? "FuelOut ID: " + fuelOutId : "",
  	      "Vehicle Reading: " + formatNumber(reading, profile.decimals) + " " + profile.unit,
  	      "",
  	      "This notification was generated automatically by Fleet In Form after a Mobile Bowser fuel transaction."
  	    ].filter(Boolean).join("\n");
  	
  	    const htmlBody =
  	      '<div style="font-family:Arial,sans-serif;color:#202420;line-height:1.45">' +
  	      '<h2 style="margin:0 0 4px;color:#a34f29">Fleet In Form</h2>' +
  	      '<h3 style="margin:0 0 18px">' + escapeHtml(candidate.title) + '</h3>' +
  	      '<table style="border-collapse:collapse;width:100%;max-width:720px">' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Service Provider</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(providerName) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Company</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(companyLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Vehicle</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(vehicleLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Registration</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(registration) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Make</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.make) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Model</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.model) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Year</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.year) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">VIN</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.vin) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Engine Number</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.engineNumber) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Notification</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.kind + " · " + candidate.title) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Position</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.summary) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Due Position</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.duePosition) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Work Scope</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.scope) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Fuel Transaction</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(litres, 2) + " L") + '</td></tr>' +
  	      (fuelOutId
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">FuelOut ID</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(fuelOutId) + '</td></tr>'
  	        : "") +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Vehicle Reading</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(reading, profile.decimals) + " " + profile.unit) + '</td></tr>' +
  	      '</table>' +
  	      '<p style="margin-top:18px;color:#657069;font-size:12px">Generated automatically after a Mobile Bowser fuel transaction.</p>' +
  	      '</div>';
  	
  	    return { text: textBody, html: htmlBody };
  	  }
  	
  	  async function mobileSendProviderEmail(company, vehicle, candidate, fuel) {
  	    if (!DB || !DB.Messaging || typeof DB.Messaging.sendEmail !== "function") {
  	      throw new Error("Backendless Messaging.sendEmail is unavailable.");
  	    }
  	
  	    const email = clean(getDeep(candidate.provider, ["Contact", "Email"], ""));
  	    if (!email) throw new Error("The Service Provider has no email address.");
  	
  	    const body = mobileProviderEmailBody(company, vehicle, candidate, fuel);
  	    const bodyParts = typeof DB.Bodyparts === "function" ? new DB.Bodyparts() : {};
  	    bodyParts.textmessage = body.text;
  	    bodyParts.htmlmessage = body.html;
  	
  	    await DB.Messaging.sendEmail(
  	      "Fleet In Form - " + candidate.title + " - " + (vehicleRegistration(vehicle) || vehicleName(vehicle)),
  	      bodyParts,
  	      [email],
  	      []
  	    );
  	  }
  	
  	  async function mobileSendCompanyServiceEmail(company, vehicle, candidate, fuel, recipients) {
  	    if (!DB || !DB.Messaging || typeof DB.Messaging.sendEmail !== "function") {
  	      throw new Error("Backendless Messaging.sendEmail is unavailable.");
  	    }
  	
  	    const emails = mobileUniqueEmails(recipients);
  	    if (!emails.length) throw new Error("The Company has no Service notification email.");
  	
  	    const body = mobileProviderEmailBody(company, vehicle, candidate, fuel);
  	    const bodyParts = typeof DB.Bodyparts === "function" ? new DB.Bodyparts() : {};
  	    bodyParts.textmessage = body.text;
  	    bodyParts.htmlmessage = body.html;
  	
  	    await DB.Messaging.sendEmail(
  	      "Fleet In Form - " + candidate.title + " - " + (vehicleRegistration(vehicle) || vehicleName(vehicle)),
  	      bodyParts,
  	      emails,
  	      []
  	    );
  	  }
  	
  	  async function mobileProcessProviderNotificationsSilently(serviceCompany, ownerCompany, vehicle, fuel) {
  	    /*
  	     * Bowser operators must never see email state. Delivery success, delivery
  	     * failure and audit persistence all remain silent.
  	     */
  	    try {
  	      const setup = mobileServiceSetup(vehicle);
  	      if (!setup.notifyProvider && !setup.notifyCompany) return false;
  	
  	      const company = mobileResolveCompanyFromAppData(ownerCompany, vehicle) || ownerCompany || serviceCompany;
  	      const companyEmails = setup.notifyCompany
  	        ? mobileCompanyServiceEmails(company)
  	        : [];
  	
  	      const candidates = mobileNotificationCandidates(serviceCompany || company, vehicle);
  	      if (!candidates.length) return false;
  	
  	      const history = mobileProviderHistory(vehicle);
  	      let changed = false;
  	
  	      for (let index = 0; index < candidates.length; index += 1) {
  	        const candidate = candidates[index];
  	        if (!candidate || !candidate.key) continue;
  	
  	        const recipientState = mobileNotificationHistoryRecipientState(history, candidate.key);
  	        const repeat = candidate.stage === "OVERDUE";
  	
  	        const providerEmail = candidate.provider
  	          ? clean(getDeep(candidate.provider, ["Contact", "Email"], ""))
  	          : "";
  	
  	        const sendProvider = !!(
  	          setup.notifyProvider &&
  	          providerEmail &&
  	          (repeat || !recipientState.providerSent)
  	        );
  	
  	        const sendCompany = !!(
  	          setup.notifyCompany &&
  	          companyEmails.length &&
  	          (repeat || !recipientState.companySent)
  	        );
  	
  	        if (!sendProvider && !sendCompany) continue;
  	
  	        let providerSent = false;
  	        let companySent = false;
  	
  	        if (sendProvider) {
  	          try {
  	            await mobileSendProviderEmail(company, vehicle, candidate, fuel);
  	            providerSent = true;
  	          } catch (_) {}
  	        }
  	
  	        if (sendCompany) {
  	          try {
  	            await mobileSendCompanyServiceEmail(
  	              company,
  	              vehicle,
  	              candidate,
  	              fuel,
  	              companyEmails
  	            );
  	            companySent = true;
  	          } catch (_) {}
  	        }
  	
  	        if (!providerSent && !companySent) continue;
  	
  	        history.push({
  	          Key: candidate.key,
  	          Kind: candidate.kind,
  	          Stage: candidate.stage,
  	          ProviderId: candidate.provider ? candidate.provider.ProviderId : "",
  	          ProviderName: candidate.provider ? mobileServiceProviderLabel(candidate.provider) : "",
  	          ProviderEmail: providerSent ? providerEmail : "",
  	          ProviderEmailSent: providerSent,
  	          CompanyId: objectIdOf(company) || clean(firstValue([
  	            company && company.CompanyId,
  	            company && company.Name
  	          ], "")),
  	          CompanyName: companyName(company),
  	          CompanyEmail: companySent ? companyEmails.join(", ") : "",
  	          CompanyEmails: companySent ? companyEmails.join(", ") : "",
  	          CompanyEmailSent: companySent,
  	          Subject: "Fleet In Form - " + candidate.title + " - " + (vehicleRegistration(vehicle) || vehicleName(vehicle)),
  	          SentAt: new Date().toISOString(),
  	          Trigger: "Mobile Bowser Fuel Transaction",
  	          RepeatOverdue: repeat,
  	          FuelOutObjectId: objectIdOf(fuel),
  	          OccurrenceKey: candidate.key + "|FUELOUT|" + objectIdOf(fuel)
  	        });
  	
  	        changed = true;
  	      }
  	
  	      if (changed) {
  	        mobileSetProviderHistory(vehicle, history);
  	
  	        try {
  	          await DB.Data.of("Tractors").save({
  	            objectId: objectIdOf(vehicle),
  	            Data: deepClone(vehicle.Data)
  	          });
  	        } catch (_) {}
  	      }
  	
  	      return changed;
  	    } catch (_) {
  	      return false;
  	    }
  	  }
  	
  	  function mobileCompanySuppliers(company) {
  	    let source = descriptorValue(firstValue([
  	      getDeep(company, ["Manifest", "Suppliers"], null),
  	      getDeep(company, ["Data", "Manifest", "Suppliers"], null),
  	      []
  	    ], []));
  	
  	    source = mobileRelationRows(source);
  	
  	    return source.map(function (supplier, index) {
  	      supplier = supplier && typeof supplier === "object" ? supplier : {};
  	      return {
  	        SupplierId: clean(firstValue([
  	          supplier.SupplierId,
  	          supplier.supplierId,
  	          supplier.Id,
  	          supplier.id,
  	          supplier.objectId,
  	          "supplier_" + String(index + 1)
  	        ], "supplier_" + String(index + 1))),
  	        Name: clean(firstValue([
  	          supplier.Name,
  	          supplier.SupplierName,
  	          supplier.name,
  	          "Supplier " + String(index + 1)
  	        ], "Supplier " + String(index + 1))),
  	        Representative: clean(firstValue([
  	          supplier.Representative,
  	          supplier.Rep,
  	          supplier.ContactPerson
  	        ], "")),
  	        Email: clean(firstValue([
  	          supplier.Email,
  	          supplier.email
  	        ], "")),
  	        OrderEmail: clean(firstValue([
  	          supplier.OrderEmail,
  	          supplier.OrdersEmail,
  	          supplier.OrderingEmail
  	        ], ""))
  	      };
  	    });
  	  }
  	
  	  function mobileTankPrimarySupplierId(tank) {
  	    return clean(firstValue([
  	      tank && tank.PrimarySupplierId,
  	      tank && tank.primarySupplierId,
  	      getDeep(tank, ["PrimarySupplier", "SupplierId"], null),
  	      getDeep(tank, ["PrimarySupplier", "Id"], null),
  	      getDeep(tank, ["Manifest", "PrimarySupplierId"], null)
  	    ], ""));
  	  }
  	
  	  function mobileTankPrimarySupplierName(tank) {
  	    const raw = firstValue([
  	      tank && tank.PrimarySupplier,
  	      tank && tank.PrimarySupplierName,
  	      getDeep(tank, ["Manifest", "PrimarySupplier"], null)
  	    ], "");
  	
  	    if (raw && typeof raw === "object") {
  	      return clean(firstValue([
  	        raw.Name,
  	        raw.SupplierName,
  	        raw.TradingName
  	      ], ""));
  	    }
  	
  	    return clean(raw);
  	  }
  	
  	  function mobileTankPrimarySupplier(company, tank) {
  	    const suppliers = mobileCompanySuppliers(company);
  	    const wantedId = lower(mobileTankPrimarySupplierId(tank));
  	    const wantedName = lower(mobileTankPrimarySupplierName(tank));
  	
  	    return suppliers.find(function (supplier) {
  	      return wantedId && lower(supplier.SupplierId) === wantedId;
  	    }) || suppliers.find(function (supplier) {
  	      return wantedName && lower(supplier.Name) === wantedName;
  	    }) || null;
  	  }
  	
  	  function mobileTankWarningThreshold1(tank) {
  	    return Math.max(0, numberOr(firstValue([
  	      tank && tank.FuelWarningThreshold1,
  	      tank && tank.WarningThreshold1,
  	      tank && tank.StockWarningThreshold1,
  	      getDeep(tank, ["Manifest", "FuelWarningThreshold1"], null),
  	      getDeep(tank, ["Manifest", "WarningThreshold1"], null)
  	    ], 0), 0));
  	  }
  	
  	  function mobileTankWarningThreshold2(tank) {
  	    return Math.max(0, numberOr(firstValue([
  	      tank && tank.FuelWarningThreshold2,
  	      tank && tank.WarningThreshold2,
  	      tank && tank.StockWarningThreshold2,
  	      getDeep(tank, ["Manifest", "FuelWarningThreshold2"], null),
  	      getDeep(tank, ["Manifest", "WarningThreshold2"], null)
  	    ], 0), 0));
  	  }
  	
  	  function mobileTankOrderThreshold(tank) {
  	    return Math.max(0, numberOr(firstValue([
  	      tank && tank.OrderThreshold,
  	      tank && tank.MinimumAllowedQuantity,
  	      tank && tank.MinAllowedQuantity,
  	      getDeep(tank, ["Manifest", "OrderThreshold"], null)
  	    ], 0), 0));
  	  }
  	
  	  function mobileTankDefaultOrderVolume(tank) {
  	    return Math.max(0, numberOr(firstValue([
  	      tank && tank.DefaultOrderVolume,
  	      tank && tank.DefaultVolumeOrder,
  	      tank && tank.OrderVolume,
  	      getDeep(tank, ["Manifest", "DefaultOrderVolume"], null)
  	    ], 0), 0));
  	  }
  	
  	  function mobileTankOrderRecipient(supplier) {
  	    return supplier
  	      ? clean(firstValue([supplier.OrderEmail, supplier.Email], ""))
  	      : "";
  	  }
  	
  	  function mobileTankCompanyEmails(company, tank) {
  	    return mobileUniqueEmails([
  	      tank && tank.CompanyNotificationEmail,
  	      tank && tank.CompanyNotificationEmails,
  	      tank && tank.NotificationEmail,
  	      getDeep(tank, ["Manifest", "CompanyNotificationEmail"], null),
  	
  	      getDeep(company, ["Manifest", "Profile", "PrimaryEmail"], null),
  	      getDeep(company, ["Manifest", "Contacts", "Primary", "Email"], null),
  	      getDeep(company, ["Manifest", "Profile", "Email"], null),
  	      getDeep(company, ["Manifest", "Billing", "Account", "InvoiceEmail"], null),
  	      getDeep(company, ["Manifest", "Billing", "Account", "StatementEmail"], null),
  	
  	      company && company.PrimaryEmail,
  	      company && company.CompanyEmail,
  	      company && company.Email,
  	      company && company.email
  	    ]);
  	  }
  	
  	  function mobileTankNotificationRecipients(company, tank, supplier) {
  	    const supplierEmail = mobileTankOrderRecipient(supplier);
  	    const companyEmails = mobileTankCompanyEmails(company, tank);
  	
  	    return {
  	      supplierEmail: supplierEmail,
  	      companyEmails: companyEmails,
  	      all: mobileUniqueEmails(
  	        (supplierEmail ? [supplierEmail] : []).concat(companyEmails)
  	      )
  	    };
  	  }
  	
  	  function mobileTankWarningBody(company, tank, supplier, currentVolume, threshold, level, fuel) {
  	    const capacity = Math.max(0, numberOr(firstValue([
  	      tank && tank.Capacity,
  	      tank && tank.capacity
  	    ], 0), 0));
  	    const currentLevel = capacity > 0
  	      ? Math.max(0, Math.min(100, currentVolume / capacity * 100))
  	      : numberOr(tank && tank.Level, 0);
  	    const orderThreshold = mobileTankOrderThreshold(tank);
  	    const orderVolume = mobileTankDefaultOrderVolume(tank);
  	    const supplierName = supplier ? supplier.Name : "Primary Supplier";
  	    const fuelOutId = objectIdOf(fuel);
  	    const severity = level === 2 ? "Critical Stock Warning" : "Early Stock Warning";
  	    const explanation = level === 2
  	      ? "Fuel stock has crossed Warning Level 2 and is approaching the automatic order level."
  	      : "Fuel stock has crossed Warning Level 1 and should be monitored for replenishment planning.";
  	
  	    const textBody = [
  	      "Fleet In Form - Fuel " + severity,
  	      "",
  	      "Supplier: " + supplierName,
  	      "Company: " + companyName(company),
  	      "Tank: " + tankName(tank, 0),
  	      "Fuel Grade: " + tankGrade(tank),
  	      "Warning Level: " + level,
  	      "",
  	      "Current Stock: " + formatNumber(currentVolume, 2) + " L",
  	      "Warning Threshold: " + formatNumber(threshold, 2) + " L",
  	      "Current Level: " + formatNumber(currentLevel, 2) + "%",
  	      orderThreshold > 0 ? "Minimum / Order Level: " + formatNumber(orderThreshold, 2) + " L" : "",
  	      orderVolume > 0 ? "Configured Order Volume: " + formatNumber(orderVolume, 2) + " L" : "",
  	      capacity > 0 ? "Tank Capacity: " + formatNumber(capacity, 2) + " L" : "",
  	      fuelOutId ? "Triggered by FuelOut: " + fuelOutId : "",
  	      "",
  	      explanation,
  	      "",
  	      "This warning was generated automatically by Fleet In Form."
  	    ].filter(Boolean).join("\n");
  	
  	    const htmlBody =
  	      '<div style="font-family:Arial,sans-serif;color:#202420;line-height:1.45">' +
  	      '<h2 style="margin:0 0 4px;color:#a34f29">Fleet In Form</h2>' +
  	      '<h3 style="margin:0 0 18px">Fuel ' + escapeHtml(severity) + '</h3>' +
  	      '<table style="border-collapse:collapse;width:100%;max-width:720px">' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Company</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(companyName(company)) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Tank</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(tankName(tank, 0)) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Fuel Grade</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(tankGrade(tank)) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Warning Level</td><td style="padding:7px;border:1px solid #d9dedb">' + level + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Stock</td><td style="padding:7px;border:1px solid #d9dedb"><strong>' + escapeHtml(formatNumber(currentVolume, 2) + " L") + '</strong></td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Warning Threshold</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(threshold, 2) + " L") + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Level</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(currentLevel, 2) + "%") + '</td></tr>' +
  	      (orderThreshold > 0
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Minimum / Order Level</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(orderThreshold, 2) + " L") + '</td></tr>'
  	        : "") +
  	      (orderVolume > 0
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Configured Order Volume</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(orderVolume, 2) + " L") + '</td></tr>'
  	        : "") +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Primary Supplier</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(supplierName) + '</td></tr>' +
  	      '</table>' +
  	      '<p style="margin-top:18px;font-weight:700">' + escapeHtml(explanation) + '</p>' +
  	      '</div>';
  	
  	    return { text: textBody, html: htmlBody };
  	  }
  	
  	  function mobileTankOrderBody(company, tank, supplier, currentVolume, threshold, orderVolume, fuel) {
  	    const capacity = Math.max(0, numberOr(firstValue([
  	      tank && tank.Capacity,
  	      tank && tank.capacity
  	    ], 0), 0));
  	
  	    const level = capacity > 0
  	      ? Math.max(0, Math.min(100, currentVolume / capacity * 100))
  	      : numberOr(tank && tank.Level, 0);
  	
  	    const transactionId = objectIdOf(fuel);
  	    const supplierName = supplier ? supplier.Name : "Primary Supplier";
  	
  	    const textBody = [
  	      "Fleet In Form - Fuel Order Notification",
  	      "",
  	      "Supplier: " + supplierName,
  	      supplier && supplier.Representative ? "Attention: " + supplier.Representative : "",
  	      "Company: " + companyName(company),
  	      "Tank: " + tankName(tank, 0),
  	      "Fuel Grade: " + tankGrade(tank),
  	      "",
  	      "Current Stock: " + formatNumber(currentVolume, 2) + " L",
  	      "Minimum / Order Level: " + formatNumber(threshold, 2) + " L",
  	      "Current Level: " + formatNumber(level, 2) + "%",
  	      "Requested Order Volume: " + formatNumber(orderVolume, 2) + " L",
  	      capacity > 0 ? "Tank Capacity: " + formatNumber(capacity, 2) + " L" : "",
  	      transactionId ? "Triggered by FuelOut: " + transactionId : "",
  	      "",
  	      "Please arrange supply of the requested fuel volume and confirm delivery availability.",
  	      "",
  	      "This notification was generated automatically by Fleet In Form after the tank crossed its configured Minimum / Order Level."
  	    ].filter(Boolean).join("\n");
  	
  	    const htmlBody =
  	      '<div style="font-family:Arial,sans-serif;color:#202420;line-height:1.45">' +
  	      '<h2 style="margin:0 0 4px;color:#a34f29">Fleet In Form</h2>' +
  	      '<h3 style="margin:0 0 18px">Fuel Order Notification</h3>' +
  	      '<table style="border-collapse:collapse;width:100%;max-width:720px">' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Supplier</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(supplierName) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Company</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(companyName(company)) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Tank</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(tankName(tank, 0)) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Fuel Grade</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(tankGrade(tank)) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Stock</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(currentVolume, 2) + " L") + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Minimum / Order Level</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(threshold, 2) + " L") + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Tank Level</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(level, 2) + "%") + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Order Volume</td><td style="padding:7px;border:1px solid #d9dedb"><strong>' + escapeHtml(formatNumber(orderVolume, 2) + " L") + '</strong></td></tr>' +
  	      '</table>' +
  	      '<p style="margin-top:18px;font-weight:700">Please arrange supply of the requested fuel volume and confirm delivery availability.</p>' +
  	      '<p style="margin-top:12px;color:#657069;font-size:12px">Generated automatically after the tank crossed its configured Minimum / Order Level.</p>' +
  	      '</div>';
  	
  	    return { text: textBody, html: htmlBody };
  	  }
  	
  	  async function mobileSendTankEmail(subject, body, recipients) {
  	    if (!DB || !DB.Messaging || typeof DB.Messaging.sendEmail !== "function") return false;
  	
  	    const emails = mobileUniqueEmails(recipients);
  	    if (!emails.length) return false;
  	
  	    const bodyParts = typeof DB.Bodyparts === "function" ? new DB.Bodyparts() : {};
  	    bodyParts.textmessage = body.text;
  	    bodyParts.htmlmessage = body.html;
  	
  	    await DB.Messaging.sendEmail(subject, bodyParts, emails, []);
  	    return true;
  	  }
  	
  	  async function mobileAuditFuelNotification(fuel, patch) {
  	    if (!fuel || !objectIdOf(fuel) || !DB || !DB.Data || typeof DB.Data.of !== "function") return false;
  	
  	    try {
  	      const payload = Object.assign({ objectId: objectIdOf(fuel) }, patch || {});
  	      await DB.Data.of("FuelOut").save(payload);
  	      Object.keys(payload).forEach(function (key) {
  	        if (key !== "objectId") fuel[key] = payload[key];
  	      });
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  }
  	
  	  async function mobileProcessTankNotificationsSilently(company, tank, previousVolume, currentVolume, fuel) {
  	    /*
  	     * All stock email activity is deliberately invisible to the Bowser
  	     * operator. Threshold crossings are based on the stock before and after
  	     * this FuelOut, so each stage fires once per stock cycle.
  	     */
  	    try {
  	      const before = numberOr(previousVolume, 0);
  	      const after = numberOr(currentVolume, 0);
  	      const supplier = mobileTankPrimarySupplier(company, tank);
  	      const recipients = mobileTankNotificationRecipients(company, tank, supplier);
  	
  	      const warnings = [
  	        { level: 1, threshold: mobileTankWarningThreshold1(tank) },
  	        { level: 2, threshold: mobileTankWarningThreshold2(tank) }
  	      ];
  	
  	      for (let index = 0; index < warnings.length; index += 1) {
  	        const warning = warnings[index];
  	        if (!(warning.threshold > 0 && before > warning.threshold && after <= warning.threshold)) continue;
  	        if (!recipients.all.length) continue;
  	
  	        try {
  	          const body = mobileTankWarningBody(
  	            company,
  	            tank,
  	            supplier,
  	            after,
  	            warning.threshold,
  	            warning.level,
  	            fuel
  	          );
  	
  	          const sent = await mobileSendTankEmail(
  	            "Fleet In Form - Fuel Warning Level " + warning.level + " - " + tankName(tank, 0),
  	            body,
  	            recipients.all
  	          );
  	
  	          if (sent) {
  	            const prefix = warning.level === 2 ? "FuelWarning2" : "FuelWarning1";
  	            const patch = {};
  	            patch[prefix + "NotificationTriggered"] = true;
  	            patch[prefix + "NotificationSentAt"] = new Date().toISOString();
  	            patch[prefix + "NotificationTankId"] = objectIdOf(tank);
  	            patch[prefix + "NotificationTankName"] = tankName(tank, 0);
  	            patch[prefix + "NotificationVolume"] = after;
  	            patch[prefix + "NotificationThreshold"] = warning.threshold;
  	            patch[prefix + "NotificationSupplierEmail"] = recipients.supplierEmail || "";
  	            patch[prefix + "NotificationCompanyEmail"] = recipients.companyEmails.join(", ");
  	            patch[prefix + "NotificationRecipients"] = recipients.all.join(", ");
  	            await mobileAuditFuelNotification(fuel, patch);
  	          }
  	        } catch (_) {}
  	      }
  	
  	      const orderThreshold = mobileTankOrderThreshold(tank);
  	      if (!(orderThreshold > 0 && before > orderThreshold && after <= orderThreshold)) return true;
  	
  	      const orderVolume = mobileTankDefaultOrderVolume(tank);
  	      if (!(orderVolume > 0)) return true;
  	
  	      /*
  	       * An actual order needs a Supplier recipient. The Company copy is added
  	       * whenever available from the tank/company configuration.
  	       */
  	      if (!supplier || !recipients.supplierEmail) return true;
  	
  	      const orderRecipients = mobileUniqueEmails(
  	        [recipients.supplierEmail].concat(recipients.companyEmails)
  	      );
  	
  	      try {
  	        const body = mobileTankOrderBody(
  	          company,
  	          tank,
  	          supplier,
  	          after,
  	          orderThreshold,
  	          orderVolume,
  	          fuel
  	        );
  	
  	        const sent = await mobileSendTankEmail(
  	          "Fleet In Form - Fuel Order Notification - " + tankName(tank, 0),
  	          body,
  	          orderRecipients
  	        );
  	
  	        if (sent) {
  	          await mobileAuditFuelNotification(fuel, {
  	            OrderNotificationTriggered: true,
  	            OrderNotificationSentAt: new Date().toISOString(),
  	            OrderNotificationTankId: objectIdOf(tank),
  	            OrderNotificationTankName: tankName(tank, 0),
  	            OrderNotificationSupplierId: supplier.SupplierId,
  	            OrderNotificationSupplier: supplier.Name,
  	            OrderNotificationSupplierEmail: recipients.supplierEmail,
  	            OrderNotificationCompanyEmail: recipients.companyEmails.join(", "),
  	            OrderNotificationEmail: orderRecipients.join(", "),
  	            OrderNotificationRecipients: orderRecipients.join(", "),
  	            OrderNotificationVolume: after,
  	            OrderNotificationThreshold: orderThreshold,
  	            OrderNotificationOrderVolume: orderVolume
  	          });
  	        }
  	      } catch (_) {}
  	
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  }
  	
  	
  	function normalizeTyreStageKey(value) {
  	  return String(value || "")
  	  .trim()
  	  .toLowerCase()
  	  .replace(/[^a-z0-9]/g, "");
  	}
  	
  	function roundTyreMileage(value) {
  	  var number = toNumber(value, 0);
  	  return Math.round((number + Number.EPSILON) * 100) / 100;
  	}
  	
  	function resolveTyreHistoryStageKey(history, currentStage) {
  	  if (!history || typeof history !== "object") {
  	    return "";
  	  }
  	
  	  var direct = String(currentStage || "").trim();
  	
  	  if (
  	    direct &&
  	    history[direct] &&
  	    typeof history[direct] === "object" &&
  	    !Array.isArray(history[direct])
  	  ) {
  	    return direct;
  	  }
  	
  	  var wanted = normalizeTyreStageKey(direct);
  	  if (!wanted) return "";
  	
  	  var keys = Object.keys(history);
  	
  	  for (var index = 0; index < keys.length; index++) {
  	    var key = keys[index];
  	
  	    if (
  	      normalizeTyreStageKey(key) === wanted &&
  	      history[key] &&
  	      typeof history[key] === "object" &&
  	      !Array.isArray(history[key])
  	    ) {
  	      return key;
  	    }
  	  }
  	
  	  return "";
  	}
  	
  	function tyrePosition(tyreRow) {
  	  return text(
  	    firstDefined(
  	      getDeep(tyreRow, ["Current_Position"], null),
  	      getDeep(tyreRow, ["History", "Current", "Position"], null)
  	    ),
  	    ""
  	  ).trim();
  	}
  	
  	function tyreAxleType(tyreRow) {
  	  return text(
  	    firstDefined(
  	      getDeep(tyreRow, ["Current_Axle_Type"], null),
  	      getDeep(tyreRow, ["History", "Current", "Axle_Type"], null)
  	    ),
  	    ""
  	  ).trim();
  	}
  	
  	function isSpareTyre(tyreRow) {
  	  var axleType = tyreAxleType(tyreRow).toLowerCase();
  	  var position = tyrePosition(tyreRow).toUpperCase();
  	
  	  if (axleType === "spare" || /(^|\s)spare(\s|$)/i.test(axleType)) {
  	    return true;
  	  }
  	
  	  /* Fleet In Form spare positions are stored as SP1, SP2, and so on. */
  	  if (/^SP(?:ARE)?(?:[\s_-]*\d+)?$/i.test(position)) {
  	    return true;
  	  }
  	
  	  return false;
  	}
  	
  	function tyreWearRate(tyreRow, history, stageKey) {
  	  var raw = firstDefined(
  	    getDeep(tyreRow, ["Current_Wear_Rate"], null),
  	    getDeep(tyreRow, ["History", "Current", "Wear_Rate"], null),
  	    history && stageKey
  	      ? getDeep(history, [stageKey, "Wear_Rate"], null)
  	      : null
  	  );
  	
  	  var rate = toNumber(raw, NaN);
  	
  	  /*
  	   * Wear rate is a direct multiplier, not a percentage number.
  	   * Example: 100 vehicle kilometres x 0.35 = 35 tyre kilometres.
  	   * Missing legacy rates retain the old 1.00 behaviour; an explicit
  	   * rate of 0 remains 0 and advances no tyre mileage.
  	   */
  	  if (!Number.isFinite(rate)) {
  	    rate = 1;
  	  }
  	
  	  return Math.max(0, rate);
  	}
  	
  	function isTyreCurrentlyFittedToVehicle(tyreRow, vehicleObj) {
  	  if (!tyreRow || typeof tyreRow !== "object") {
  	    return false;
  	  }
  	
  	  var tyreObjectId = text(
  	    getDeep(tyreRow, ["objectId"], ""),
  	    ""
  	  );
  	
  	  if (!tyreObjectId) {
  	    return false;
  	  }
  	
  	  var fittedValue = getDeep(tyreRow, ["Is_Fitted"], null);
  	
  	  if (
  	    fittedValue === false ||
  	    String(fittedValue).trim().toLowerCase() === "false"
  	  ) {
  	    return false;
  	  }
  	
  	  var warehouse = text(
  	    getDeep(tyreRow, ["Warehouse"], ""),
  	    ""
  	  ).trim().toUpperCase();
  	
  	  if (warehouse === "IN") {
  	    return false;
  	  }
  	
  	  var holderType = text(
  	    getDeep(tyreRow, ["Current_Holder_Type"], ""),
  	    ""
  	  ).trim().toLowerCase();
  	
  	  if (holderType && holderType !== "vehicle") {
  	    return false;
  	  }
  	
  	  var vehicleObjectId = text(
  	    getDeep(vehicleObj, ["objectId"], ""),
  	    ""
  	  );
  	
  	  var tyreVehicleObjectId = text(
  	    firstDefined(
  	      getDeep(tyreRow, ["Current_Holder_ObjectId"], null),
  	      getDeep(tyreRow, ["Vehicle_ObjectId"], null),
  	      getDeep(
  	        tyreRow,
  	        ["History", "Current", "Vehicle_ObjectId"],
  	        null
  	      )
  	    ),
  	    ""
  	  );
  	
  	  if (
  	    vehicleObjectId &&
  	    tyreVehicleObjectId &&
  	    !sameObjectId(vehicleObjectId, tyreVehicleObjectId)
  	  ) {
  	    return false;
  	  }
  	
  	  return true;
  	}
  	
  	function getFittedVehicleTyres(vehicleObj) {
  	  var source = relationCollectionToArray(
  	    getDeep(vehicleObj, ["Tyres"], [])
  	  );
  	  var seen = {};
  	  var result = [];
  	
  	  for (var index = 0; index < source.length; index++) {
  	    var tyreRow = source[index];
  	
  	    if (!isTyreCurrentlyFittedToVehicle(tyreRow, vehicleObj)) {
  	      continue;
  	    }
  	
  	    var objectId = text(
  	      getDeep(tyreRow, ["objectId"], ""),
  	      ""
  	    );
  	
  	    if (!objectId || seen[objectId]) {
  	      continue;
  	    }
  	
  	    seen[objectId] = true;
  	    result.push(tyreRow);
  	  }
  	
  	  return result;
  	}
  	
  	function ensureTyreHistoryStage(
  	  history,
  	  currentStage,
  	  oldCurrentMileage
  	) {
  	  var stageKey = resolveTyreHistoryStageKey(
  	    history,
  	    currentStage
  	  );
  	
  	  if (!stageKey) {
  	    stageKey = String(currentStage || "New").trim() || "New";
  	
  	    if (
  	      normalizeTyreStageKey(stageKey) === "current" ||
  	      normalizeTyreStageKey(stageKey) === "totals"
  	    ) {
  	      stageKey = "New";
  	    }
  	
  	    history[stageKey] = {
  	      Active: true,
  	      Status: "Active",
  	      Started: "",
  	      Ended: "",
  	      Start_Mileage: oldCurrentMileage,
  	      End_Mileage: oldCurrentMileage,
  	      Mileage_Done: 0,
  	      Mileage_Expected: 0,
  	      Events: []
  	    };
  	  }
  	
  	  if (
  	    !history[stageKey] ||
  	    typeof history[stageKey] !== "object" ||
  	    Array.isArray(history[stageKey])
  	  ) {
  	    history[stageKey] = {};
  	  }
  	
  	  if (
  	    !history.Current ||
  	    typeof history.Current !== "object" ||
  	    Array.isArray(history.Current)
  	  ) {
  	    history.Current = {};
  	  }
  	
  	  if (!text(history.Current.Stage, "").trim()) {
  	    history.Current.Stage = stageKey;
  	  }
  	
  	  return stageKey;
  	}
  	
  	function buildTyreMileageUpdate(
  	  tyreRow,
  	  mileageDifferential,
  	  newVehicleMileage
  	) {
  	  var objectId = text(
  	    getDeep(tyreRow, ["objectId"], ""),
  	    ""
  	  );
  	
  	  var vehicleMileage = toNumber(
  	    newVehicleMileage,
  	    NaN
  	  );
  	
  	  if (isSpareTyre(tyreRow)) {
  	    if (!objectId || !Number.isFinite(vehicleMileage)) return null;
  	
  	    return {
  	      source: tyreRow,
  	      patch: {
  	        objectId: objectId,
  	        Last_Vehicle_Odometer: vehicleMileage,
  	        Current_Wear_Rate: 0
  	      },
  	      objectId: objectId,
  	      tyreNumber: text(
  	        firstDefined(
  	          getDeep(tyreRow, ["Tyre_Number"], null),
  	          getDeep(tyreRow, ["FID"], null),
  	          objectId
  	        ),
  	        objectId
  	      ),
  	      stageKey: "",
  	      wearRate: 0,
  	      vehicleDifferential: Math.max(0, toNumber(mileageDifferential, 0)),
  	      tyreDifferential: 0,
  	      oldCurrentMileage: Math.max(0, toNumber(getDeep(tyreRow, ["Current_Mileage"], 0), 0)),
  	      newCurrentMileage: Math.max(0, toNumber(getDeep(tyreRow, ["Current_Mileage"], 0), 0)),
  	      oldStageMileage: 0,
  	      newStageMileage: 0,
  	      newTotalMileage: Math.max(0, toNumber(getDeep(tyreRow, ["Total_Mileage"], 0), 0)),
  	      spare: true
  	    };
  	  }
  	
  	  var fallbackVehicleDifferential = Math.max(
  	    0,
  	    toNumber(mileageDifferential, 0)
  	  );
  	
  	  var tyreLastVehicleOdometer = toNumber(
  	    getDeep(
  	      tyreRow,
  	      ["Last_Vehicle_Odometer"],
  	      null
  	    ),
  	    NaN
  	  );
  	
  	  var vehicleDifferential = fallbackVehicleDifferential;
  	
  	  /*
  	   * Prefer each tyre's own last vehicle odometer. This catches up a
  	   * tyre that missed a previous fuel capture without advancing a spare.
  	   */
  	  if (
  	    Number.isFinite(tyreLastVehicleOdometer) &&
  	    tyreLastVehicleOdometer > 0 &&
  	    Number.isFinite(vehicleMileage)
  	  ) {
  	    vehicleDifferential =
  	      vehicleMileage >= tyreLastVehicleOdometer
  	        ? vehicleMileage - tyreLastVehicleOdometer
  	        : 0;
  	  }
  	
  	  if (!(vehicleDifferential > 0)) {
  	    return null;
  	  }
  	
  	  if (!objectId) {
  	    return null;
  	  }
  	
  	  var oldCurrentMileage = Math.max(
  	    0,
  	    toNumber(
  	      getDeep(tyreRow, ["Current_Mileage"], 0),
  	      0
  	    )
  	  );
  	
  	  var currentStage = text(
  	    firstDefined(
  	      getDeep(tyreRow, ["Current_Stage"], null),
  	      getDeep(tyreRow, ["History", "Current", "Stage"], null),
  	      "New"
  	    ),
  	    "New"
  	  );
  	
  	  var history = deepClone(
  	    getDeep(tyreRow, ["History"], {})
  	  );
  	
  	  if (
  	    !history ||
  	    typeof history !== "object" ||
  	    Array.isArray(history)
  	  ) {
  	    history = {};
  	  }
  	
  	  var stageKey = ensureTyreHistoryStage(
  	    history,
  	    currentStage,
  	    oldCurrentMileage
  	  );
  	
  	  var wearRate = tyreWearRate(
  	    tyreRow,
  	    history,
  	    stageKey
  	  );
  	
  	  var tyreDifferential = roundTyreMileage(
  	    vehicleDifferential * wearRate
  	  );
  	
  	  var stage = deepClone(history[stageKey] || {});
  	  var oldStageMileage = Math.max(
  	    0,
  	    toNumber(
  	      getDeep(stage, ["Mileage_Done"], 0),
  	      0
  	    )
  	  );
  	
  	  var newCurrentMileage = roundTyreMileage(
  	    oldCurrentMileage + tyreDifferential
  	  );
  	  var newStageMileage = roundTyreMileage(
  	    oldStageMileage + tyreDifferential
  	  );
  	
  	  stage.Mileage_Done = newStageMileage;
  	  stage.End_Mileage = newCurrentMileage;
  	
  	  if (
  	    stage.Start_Mileage === null ||
  	    stage.Start_Mileage === undefined ||
  	    stage.Start_Mileage === ""
  	  ) {
  	    stage.Start_Mileage = oldCurrentMileage;
  	  }
  	
  	  history[stageKey] = stage;
  	  history.Current.Wear_Rate = wearRate;
  	
  	  if (
  	    !history.Totals ||
  	    typeof history.Totals !== "object" ||
  	    Array.isArray(history.Totals)
  	  ) {
  	    history.Totals = {};
  	  }
  	
  	  var oldTotalMileage = Math.max(
  	    0,
  	    toNumber(
  	      firstDefined(
  	        getDeep(history, ["Totals", "Mileage_Total"], null),
  	        getDeep(tyreRow, ["Total_Mileage"], null),
  	        oldCurrentMileage
  	      ),
  	      oldCurrentMileage
  	    )
  	  );
  	
  	  var newTotalMileage = roundTyreMileage(
  	    oldTotalMileage + tyreDifferential
  	  );
  	  history.Totals.Mileage_Total = newTotalMileage;
  	
  	  /*
  	   * Only writable Tyres fields are sent to Backendless. Total_Mileage,
  	   * Remaining_Mileage and Current_Life are calculated values and must
  	   * never be included in the save patch.
  	   */
  	  var patch = {
  	    objectId: objectId,
  	    Current_Mileage: newCurrentMileage,
  	    Last_Vehicle_Odometer:
  	      Number.isFinite(vehicleMileage)
  	        ? vehicleMileage
  	        : tyreLastVehicleOdometer + vehicleDifferential,
  	    Current_Wear_Rate: wearRate,
  	    History: history
  	  };
  	
  	  return {
  	    source: tyreRow,
  	    patch: patch,
  	    objectId: objectId,
  	    tyreNumber: text(
  	      firstDefined(
  	        getDeep(tyreRow, ["Tyre_Number"], null),
  	        getDeep(tyreRow, ["FID"], null),
  	        objectId
  	      ),
  	      objectId
  	    ),
  	    stageKey: stageKey,
  	    wearRate: wearRate,
  	    vehicleDifferential: vehicleDifferential,
  	    tyreDifferential: tyreDifferential,
  	    oldCurrentMileage: oldCurrentMileage,
  	    newCurrentMileage: newCurrentMileage,
  	    oldStageMileage: oldStageMileage,
  	    newStageMileage: newStageMileage,
  	    newTotalMileage: newTotalMileage
  	  };
  	}
  	
  	function calculateLiveTyreCurrentLife(
  	  liveTyre,
  	  source
  	) {
  	  var expectedMileage = toNumber(
  	    firstDefined(
  	      getDeep(source, ["Expected_Mileage"], null),
  	      getDeep(liveTyre, ["Expected_Mileage"], null)
  	    ),
  	    NaN
  	  );
  	
  	  var currentMileage = Math.max(
  	    0,
  	    toNumber(
  	      firstDefined(
  	        getDeep(source, ["Current_Mileage"], null),
  	        getDeep(liveTyre, ["Current_Mileage"], null)
  	      ),
  	      0
  	    )
  	  );
  	
  	  if (
  	    !Number.isFinite(expectedMileage) ||
  	    expectedMileage <= 0
  	  ) {
  	    return toNumber(
  	      getDeep(liveTyre, ["Current_Life"], 0),
  	      0
  	    );
  	  }
  	
  	  var remainingMileage = Math.max(
  	    0,
  	    expectedMileage - currentMileage
  	  );
  	
  	  var currentLife = Math.max(
  	    0,
  	    Math.min(
  	      100,
  	      (remainingMileage / expectedMileage) * 100
  	    )
  	  );
  	
  	  return Math.round(currentLife * 100) / 100;
  	}
  	
  	function applySavedTyreMileageToLiveRow(
  	  liveTyre,
  	  savedTyre,
  	  fallbackPatch
  	) {
  	  if (!liveTyre || typeof liveTyre !== "object") {
  	    return;
  	  }
  	
  	  var source = Object.assign(
  	    {},
  	    fallbackPatch && typeof fallbackPatch === "object"
  	      ? fallbackPatch
  	      : {},
  	    savedTyre && typeof savedTyre === "object"
  	      ? savedTyre
  	      : {}
  	  );
  	
  	  if (!Object.keys(source).length) {
  	    return;
  	  }
  	
  	  var fields = [
  	    "Current_Mileage",
  	    "Last_Vehicle_Odometer",
  	    "Current_Wear_Rate"
  	  ];
  	
  	  for (var index = 0; index < fields.length; index++) {
  	    var field = fields[index];
  	
  	    if (
  	      Object.prototype.hasOwnProperty.call(
  	        source,
  	        field
  	      )
  	    ) {
  	      liveTyre[field] = source[field];
  	    }
  	  }
  	
  	  if (
  	    Object.prototype.hasOwnProperty.call(
  	      source,
  	      "History"
  	    )
  	  ) {
  	    liveTyre.History = deepClone(source.History);
  	  }
  	
  	  if (
  	    Object.prototype.hasOwnProperty.call(
  	      source,
  	      "updated"
  	    )
  	  ) {
  	    liveTyre.updated = source.updated;
  	  }
  	
  	  var historyTotal = toNumber(
  	    getDeep(
  	      liveTyre,
  	      ["History", "Totals", "Mileage_Total"],
  	      null
  	    ),
  	    NaN
  	  );
  	
  	  if (Number.isFinite(historyTotal)) {
  	    liveTyre.Total_Mileage = historyTotal;
  	  }
  	
  	  var expectedMileage = toNumber(
  	    getDeep(liveTyre, ["Expected_Mileage"], null),
  	    NaN
  	  );
  	
  	  if (Number.isFinite(expectedMileage) && expectedMileage >= 0) {
  	    liveTyre.Remaining_Mileage = Math.max(
  	      0,
  	      roundTyreMileage(
  	        expectedMileage -
  	        toNumber(liveTyre.Current_Mileage, 0)
  	      )
  	    );
  	  }
  	
  	  /* Calculated fields are refreshed only in live AppData. */
  	  liveTyre.Current_Life =
  	    calculateLiveTyreCurrentLife(
  	      liveTyre,
  	      source
  	    );
  	
  	  if (
  	    savedTyre &&
  	    typeof savedTyre === "object"
  	  ) {
  	    savedTyre.Total_Mileage = liveTyre.Total_Mileage;
  	    savedTyre.Remaining_Mileage = liveTyre.Remaining_Mileage;
  	    savedTyre.Current_Life = liveTyre.Current_Life;
  	  }
  	}
  	
  	function mergeVehicleTyresIntoLiveAppData(
  	  liveVehicle,
  	  sourceVehicle
  	) {
  	  if (
  	    !liveVehicle ||
  	    typeof liveVehicle !== "object" ||
  	    !sourceVehicle ||
  	    typeof sourceVehicle !== "object"
  	  ) {
  	    return;
  	  }
  	
  	  var liveTyres = relationCollectionToArray(
  	    getDeep(liveVehicle, ["Tyres"], [])
  	  );
  	  var sourceTyres = relationCollectionToArray(
  	    getDeep(sourceVehicle, ["Tyres"], [])
  	  );
  	
  	  for (
  	    var sourceIndex = 0;
  	    sourceIndex < sourceTyres.length;
  	    sourceIndex++
  	  ) {
  	    var sourceTyre = sourceTyres[sourceIndex];
  	    var sourceId = getDeep(
  	      sourceTyre,
  	      ["objectId"],
  	      null
  	    );
  	
  	    if (!sourceId) continue;
  	
  	    var liveIndex = -1;
  	
  	    for (
  	      var liveIndexSearch = 0;
  	      liveIndexSearch < liveTyres.length;
  	      liveIndexSearch++
  	    ) {
  	      if (
  	        sameObjectId(
  	          getDeep(
  	            liveTyres[liveIndexSearch],
  	            ["objectId"],
  	            null
  	          ),
  	          sourceId
  	        )
  	      ) {
  	        liveIndex = liveIndexSearch;
  	        break;
  	      }
  	    }
  	
  	    if (liveIndex >= 0) {
  	      applySavedTyreMileageToLiveRow(
  	        liveTyres[liveIndex],
  	        sourceTyre,
  	        sourceTyre
  	      );
  	    } else {
  	      liveTyres.push(deepClone(sourceTyre));
  	    }
  	  }
  	
  	  liveVehicle.Tyres = liveTyres;
  	}
  	
  	async function saveTyreMileagePatchWithRetry(update) {
  	  var firstError = null;
  	
  	  for (var attempt = 1; attempt <= 2; attempt++) {
  	    try {
  	      updateOperation(
  	        "Updating tyre " + update.tyreNumber +
  	        " (" +
  	        formatNumber(update.vehicleDifferential, 1) +
  	        " × " +
  	        formatNumber(update.wearRate, 2) +
  	        ")…"
  	      );
  	
  	      return await saveTableRow(
  	        "Tyres",
  	        update.patch
  	      );
  	    } catch (error) {
  	      if (!firstError) firstError = error;
  	      console.warn(
  	        "[Tyre Mileage Sync] Tyre save attempt " +
  	        attempt + " failed.",
  	        {
  	          tyreObjectId: update.objectId,
  	          tyreNumber: update.tyreNumber,
  	          patch: update.patch,
  	          error: error
  	        }
  	      );
  	    }
  	  }
  	
  	  throw new Error(
  	    "Tyre " + update.tyreNumber +
  	    " could not be advanced. " +
  	    (
  	      firstError && firstError.message
  	        ? firstError.message
  	        : "The Tyres record could not be saved."
  	    )
  	  );
  	}
  	
  	async function bulkUpdateVehicleTyreMileage(
  	  vehicleObj,
  	  mileageDifferential,
  	  newVehicleMileage
  	) {
  	  var differential = toNumber(
  	    mileageDifferential,
  	    0
  	  );
  	
  	  var emptyResult = {
  	    updatedCount: 0,
  	    synchronisedCount: 0,
  	    spareCount: 0,
  	    differential: differential,
  	    vehicleMileage: newVehicleMileage,
  	    updatedTyres: [],
  	    updates: []
  	  };
  	
  	  if (!vehicleObj) {
  	    console.warn(
  	      "[Tyre Mileage Sync] Skipped because no vehicle object was supplied."
  	    );
  	    return emptyResult;
  	  }
  	
  	  var allVehicleTyres = relationCollectionToArray(
  	    getDeep(vehicleObj, ["Tyres"], [])
  	  );
  	  var spareCount = allVehicleTyres.filter(isSpareTyre).length;
  	  var fittedTyres = getFittedVehicleTyres(
  	    vehicleObj
  	  );
  	
  	  if (!fittedTyres.length) {
  	    console.warn(
  	      "[Tyre Mileage Sync] No non-spare fitted tyre rows were resolved.",
  	      {
  	        vehicleObjectId: getDeep(
  	          vehicleObj,
  	          ["objectId"],
  	          null
  	        ),
  	        vehicleMileage: newVehicleMileage,
  	        mileageDifferential: differential,
  	        tyreRelationCount: allVehicleTyres.length,
  	        spareCount: spareCount,
  	        tyreReferenceCount:
  	          relationCollectionToArray(
  	            getDeep(
  	              vehicleObj,
  	              ["Data", "Tyres", "TyreRecords"],
  	              []
  	            )
  	          ).length
  	      }
  	    );
  	
  	    emptyResult.spareCount = spareCount;
  	    return emptyResult;
  	  }
  	
  	  var updates = [];
  	
  	  for (
  	    var tyreIndex = 0;
  	    tyreIndex < fittedTyres.length;
  	    tyreIndex++
  	  ) {
  	    var update = buildTyreMileageUpdate(
  	      fittedTyres[tyreIndex],
  	      differential,
  	      newVehicleMileage
  	    );
  	
  	    if (update) {
  	      updates.push(update);
  	    }
  	  }
  	
  	  if (!updates.length) {
  	    console.warn(
  	      "[Tyre Mileage Sync] Fitted tyres were found but the vehicle distance did not require a tyre update.",
  	      {
  	        vehicleObjectId: getDeep(
  	          vehicleObj,
  	          ["objectId"],
  	          null
  	        ),
  	        vehicleMileage: newVehicleMileage,
  	        mileageDifferential: differential,
  	        spareCount: spareCount,
  	        tyreStates: fittedTyres.map(function (tyreRow) {
  	          return {
  	            objectId: getDeep(
  	              tyreRow,
  	              ["objectId"],
  	              null
  	            ),
  	            currentMileage: getDeep(
  	              tyreRow,
  	              ["Current_Mileage"],
  	              null
  	            ),
  	            currentWearRate: getDeep(
  	              tyreRow,
  	              ["Current_Wear_Rate"],
  	              null
  	            ),
  	            lastVehicleOdometer: getDeep(
  	              tyreRow,
  	              ["Last_Vehicle_Odometer"],
  	              null
  	            )
  	          };
  	        })
  	      }
  	    );
  	
  	    emptyResult.spareCount = spareCount;
  	    return emptyResult;
  	  }
  	
  	  var savedRows = [];
  	
  	  /*
  	   * Each tyre has unique History JSON. Save narrow patches one by one,
  	   * retry each once, and never submit calculated tyre columns.
  	   */
  	  for (
  	    var saveIndex = 0;
  	    saveIndex < updates.length;
  	    saveIndex++
  	  ) {
  	    savedRows.push(
  	      await saveTyreMileagePatchWithRetry(
  	        updates[saveIndex]
  	      )
  	    );
  	  }
  	
  	  var liveVehicleTyres = relationCollectionToArray(
  	    getDeep(vehicleObj, ["Tyres"], [])
  	  );
  	
  	  for (
  	    var savedIndex = 0;
  	    savedIndex < updates.length;
  	    savedIndex++
  	  ) {
  	    var currentUpdate = updates[savedIndex];
  	    var savedRow =
  	      savedRows[savedIndex] ||
  	      currentUpdate.patch;
  	
  	    var liveIndex = -1;
  	
  	    for (
  	      var liveTyreIndex = 0;
  	      liveTyreIndex < liveVehicleTyres.length;
  	      liveTyreIndex++
  	    ) {
  	      if (
  	        sameObjectId(
  	          getDeep(
  	            liveVehicleTyres[liveTyreIndex],
  	            ["objectId"],
  	            null
  	          ),
  	          currentUpdate.objectId
  	        )
  	      ) {
  	        liveIndex = liveTyreIndex;
  	        break;
  	      }
  	    }
  	
  	    if (liveIndex >= 0) {
  	      applySavedTyreMileageToLiveRow(
  	        liveVehicleTyres[liveIndex],
  	        savedRow,
  	        currentUpdate.patch
  	      );
  	    }
  	
  	    applySavedTyreMileageToLiveRow(
  	      currentUpdate.source,
  	      savedRow,
  	      currentUpdate.patch
  	    );
  	  }
  	
  	  vehicleObj.Tyres = liveVehicleTyres;
  	
  	  var mileageAdvancingUpdates = updates.filter(
  	    function (update) {
  	      return update.tyreDifferential > 0;
  	    }
  	  );
  	
  	  console.log(
  	    "[Tyre Mileage Sync] Updated fitted tyres by wear rate.",
  	    {
  	      vehicleObjectId: getDeep(
  	        vehicleObj,
  	        ["objectId"],
  	        null
  	      ),
  	      vehicleMileage: newVehicleMileage,
  	      mileageDifferential: differential,
  	      updatedCount: mileageAdvancingUpdates.length,
  	      synchronisedCount: updates.length,
  	      spareCount: spareCount,
  	      tyreUpdates: updates.map(function (update) {
  	        return {
  	          tyreObjectId: update.objectId,
  	          tyreNumber: update.tyreNumber,
  	          wearRate: update.wearRate,
  	          vehicleDifferential: update.vehicleDifferential,
  	          tyreDifferential: update.tyreDifferential,
  	          oldCurrentMileage: update.oldCurrentMileage,
  	          newCurrentMileage: update.newCurrentMileage
  	        };
  	      })
  	    }
  	  );
  	
  	  var tyreDifferentials = mileageAdvancingUpdates.map(
  	    function (update) {
  	      return update.tyreDifferential;
  	    }
  	  );
  	
  	  return {
  	    updatedCount: mileageAdvancingUpdates.length,
  	    synchronisedCount: updates.length,
  	    spareCount: spareCount,
  	    differential: differential,
  	    minimumDifferential:
  	      tyreDifferentials.length
  	        ? Math.min.apply(Math, tyreDifferentials)
  	        : 0,
  	    maximumDifferential:
  	      tyreDifferentials.length
  	        ? Math.max.apply(Math, tyreDifferentials)
  	        : 0,
  	    vehicleMileage: newVehicleMileage,
  	    updatedTyres: savedRows,
  	    updates: updates.map(function (update) {
  	      return {
  	        tyreObjectId: update.objectId,
  	        tyreNumber: update.tyreNumber,
  	        wearRate: update.wearRate,
  	        vehicleDifferential: update.vehicleDifferential,
  	        tyreDifferential: update.tyreDifferential,
  	        oldCurrentMileage: update.oldCurrentMileage,
  	        newCurrentMileage: update.newCurrentMileage
  	      };
  	    })
  	  };
  	}
  	
  	function buildBowserHistoryRelationIds(targetBowser) {
  	  var ids = [];
  	  var seen = {};
  	  var historyViews = toArray(getDeep(targetBowser, ["ViewH"], []));
  	
  	  for (var i = 0; i < historyViews.length; i++) {
  	    var historyId = getDeep(historyViews[i], ["objectId"], null);
  	    if (!historyId) continue;
  	
  	    if (!seen[historyId]) {
  	      seen[historyId] = true;
  	      ids.push(historyId);
  	    }
  	  }
  	
  	  return ids;
  	}
  	
  	async function syncBowserViewRelations(targetBowser, savedCurrentView) {
  	  var bowserObjectId = getDeep(targetBowser, ["objectId"], null);
  	  var currentViewObjectId = getDeep(savedCurrentView, ["objectId"], null);
  	
  	  if (!bowserObjectId) {
  	    throw new Error("Cannot sync bowser view relations without bowser objectId.");
  	  }
  	
  	  if (!currentViewObjectId) {
  	    throw new Error("Cannot sync bowser ViewC relation without current view objectId.");
  	  }
  	
  	  await setRelation("Bowsers", bowserObjectId, "ViewC", [currentViewObjectId]);
  	
  	  var historyRelationIds = buildBowserHistoryRelationIds(targetBowser);
  	  await setRelation("Bowsers", bowserObjectId, "ViewH", historyRelationIds);
  	
  	  targetBowser.ViewC = savedCurrentView;
  	}
  	
  	function buildVehicleViewSeed(dateObj) {
  	  return {
  	    ___class: "Tractorview",
  	    MYear: getMonthLabel(dateObj),
  	    MYearKey: getMYear(dateObj),
  	    DateStart: getMonthStartMs(dateObj),
  	    DateEnd: getMonthEndMs(dateObj),
  	    TransactionCount: 0,
  	    MeterStart: 0,
  	    MeterEnd: 0,
  	    Distance: 0,
  	    Hours: 0,
  	    Litres: 0,
  	    Cost: 0,
  	    PotentialSARSRebate: 0
  	  };
  	}
  	
  	function ensureBowserViewRow(targetBowser, openingMeter, dateObj) {
  	  var businessDate = dateObj ? getBusinessDate(dateObj): getBusinessNowDate();
  	  var mYear = getMYear(businessDate);
  	  var mYearLabel = getMonthLabel(businessDate);
  	  var oldView = getDeep(targetBowser, ["ViewC"], null);
  	
  	  if (!oldView || getDeep(oldView, ["MYearKey"], "") !== mYear) {
  	    if (oldView && (getDeep(oldView, ["objectId"], null) || getDeep(oldView, ["MYear"], ""))) {
  	      targetBowser.ViewH = toArray(targetBowser.ViewH);
  	      targetBowser.ViewH.push(deepClone(oldView));
  	    }
  	
  	    targetBowser.ViewC = {
  	      ___class: "BowserView",
  	      MYear: mYearLabel,
  	      MYearKey: mYear,
  	      DateStart: getMonthStartMs(businessDate),
  	      DateEnd: getMonthEndMs(businessDate),
  	      Litres: 0,
  	      MeterStart: toNumber(openingMeter, 0),
  	      MeterEnd: toNumber(openingMeter, 0)
  	    };
  	  } else {
  	    targetBowser.ViewC.Litres = toNumber(getDeep(targetBowser, ["ViewC", "Litres"], 0), 0);
  	    if (getDeep(targetBowser, ["ViewC", "MeterStart"], null) == null) targetBowser.ViewC.MeterStart = toNumber(openingMeter, 0);
  	    if (getDeep(targetBowser, ["ViewC", "MeterEnd"], null) == null) targetBowser.ViewC.MeterEnd = toNumber(openingMeter, 0);
  	    if (getDeep(targetBowser, ["ViewC", "DateStart"], null) == null) targetBowser.ViewC.DateStart = getMonthStartMs(businessDate);
  	    if (getDeep(targetBowser, ["ViewC", "DateEnd"], null) == null) targetBowser.ViewC.DateEnd = getMonthEndMs(businessDate);
  	    if (getDeep(targetBowser, ["ViewC", "MYearKey"], null) == null) targetBowser.ViewC.MYearKey = mYear;
  	    if (getDeep(targetBowser, ["ViewC", "MYear"], null) == null) targetBowser.ViewC.MYear = mYearLabel;
  	  }
  	
  	  return targetBowser.ViewC;
  	}
  	
  	function ensureVehicleViewRow(targetVehicle, dateObj) {
  	  var businessDate = dateObj ? getBusinessDate(dateObj): getBusinessNowDate();
  	  var mYear = getMYear(businessDate);
  	  var mYearLabel = getMonthLabel(businessDate);
  	  var currentView = getDeep(targetVehicle, ["ViewC"], null);
  	  var currentViewMonthKey = getDeep(currentView, ["MYearKey"], "");
  	
  	  if (!currentView || currentViewMonthKey !== mYear) {
  	    if (currentView && (getDeep(currentView, ["objectId"], null) || getDeep(currentView, ["MYear"], ""))) {
  	      targetVehicle.ViewH = toArray(getDeep(targetVehicle, ["ViewH"], []));
  	      targetVehicle.ViewH.push(deepClone(currentView));
  	    }
  	
  	    targetVehicle.ViewC = buildVehicleViewSeed(businessDate);
  	  } else {
  	    if (getDeep(currentView, ["MYearKey"], null) == null) currentView.MYearKey = mYear;
  	    if (getDeep(currentView, ["MYear"], null) == null) currentView.MYear = mYearLabel;
  	    if (getDeep(currentView, ["DateStart"], null) == null) currentView.DateStart = getMonthStartMs(businessDate);
  	    if (getDeep(currentView, ["DateEnd"], null) == null) currentView.DateEnd = getMonthEndMs(businessDate);
  	    if (getDeep(currentView, ["TransactionCount"], null) == null) currentView.TransactionCount = 0;
  	    if (getDeep(currentView, ["MeterStart"], null) == null) currentView.MeterStart = 0;
  	    if (getDeep(currentView, ["MeterEnd"], null) == null) currentView.MeterEnd = 0;
  	    if (getDeep(currentView, ["Distance"], null) == null) currentView.Distance = 0;
  	    if (getDeep(currentView, ["Hours"], null) == null) currentView.Hours = 0;
  	    if (getDeep(currentView, ["Litres"], null) == null) currentView.Litres = 0;
  	    if (getDeep(currentView, ["Cost"], null) == null) currentView.Cost = 0;
  	    if (getDeep(currentView, ["PotentialSARSRebate"], null) == null) currentView.PotentialSARSRebate = 0;
  	  }
  	
  	  return targetVehicle.ViewC;
  	}
  	
  	function buildVehicleHistoryRelationIds(targetVehicle, currentViewObjectId) {
  	  var ids = [];
  	  var seen = {};
  	  var historyViews = toArray(getDeep(targetVehicle, ["ViewH"], []));
  	
  	  for (var i = 0; i < historyViews.length; i++) {
  	    var historyId = getDeep(historyViews[i], ["objectId"], null);
  	    if (!historyId) continue;
  	
  	    // Do not include the current ViewC in ViewH.
  	    if (currentViewObjectId && sameObjectId(historyId, currentViewObjectId)) continue;
  	
  	    if (!seen[historyId]) {
  	      seen[historyId] = true;
  	      ids.push(historyId);
  	    }
  	  }
  	
  	  return ids;
  	}
  	
  	async function syncVehicleViewRelations(targetVehicle, savedCurrentView) {
  	  var vehicleObjectId = getDeep(targetVehicle, ["objectId"], null);
  	  var currentViewObjectId = getDeep(savedCurrentView, ["objectId"], null);
  	
  	  if (!vehicleObjectId) {
  	    throw new Error("Cannot sync tractor view relations without tractor objectId.");
  	  }
  	
  	  if (!currentViewObjectId) {
  	    throw new Error("Cannot sync tractor view relations without current view objectId.");
  	  }
  	
  	  await setRelation("Tractors", vehicleObjectId, "ViewC", [currentViewObjectId]);
  	
  	  var historyRelationIds = buildVehicleHistoryRelationIds(targetVehicle, currentViewObjectId);
  	  await setRelation("Tractors", vehicleObjectId, "ViewH", historyRelationIds);
  	
  	  targetVehicle.ViewC = savedCurrentView;
  	}
  	
  	  function replaceNestedVehicle(container, vehicle) {
  	    if (!container || !vehicle) return;
  	    const lists = ["Tractors", "Vehicles"];
  	    for (let listIndex = 0; listIndex < lists.length; listIndex += 1) {
  	      const key = lists[listIndex];
  	      const rows = arr(container[key]);
  	      const index = rows.findIndex(function (row) {
  	        return sameObjectId(objectIdOf(row), objectIdOf(vehicle));
  	      });
  	      if (index !== -1) {
  	        rows[index] = Object.assign(rows[index] || {}, deepClone(vehicle));
  	        container[key] = rows;
  	        return;
  	      }
  	    }
  	  }
  	
  	  function replaceNestedTank(company, tank) {
  	    if (!company || !tank) return;
  	    const rows = arr(company.Tanks);
  	    const index = rows.findIndex(function (row) {
  	      return sameObjectId(objectIdOf(unwrapTank(row)), objectIdOf(tank));
  	    });
  	    if (index !== -1) {
  	      const unwrapped = unwrapTank(rows[index]);
  	      Object.assign(unwrapped, deepClone(tank));
  	    }
  	  }
  	
  	  function findIndexByKeys(items, candidate) {
  	    const rows = arr(items);
  	    for (let i = 0; i < rows.length; i += 1) {
  	      if (
  	        sameObjectId(objectIdOf(rows[i]), objectIdOf(candidate)) ||
  	        clean(rows[i] && rows[i].FID) === clean(candidate && candidate.FID) ||
  	        clean(rows[i] && rows[i].Name) === clean(candidate && candidate.Name) ||
  	        clean(rows[i] && rows[i].DeviceId) === clean(candidate && candidate.DeviceId)
  	      ) return i;
  	    }
  	    return -1;
  	  }
  	
  	  function captureModeValue() {
  	    return state.mode === "vehicle" ? "company" : state.mode;
  	  }
  	
  	  function applicationValue() {
  	    return state.application === "__other__" ? clean(state.applicationOther) : clean(state.application);
  	  }
  	
  	  function driverValue() {
  	    return state.driverId === "__other__" ? clean(state.driverOther) : clean(state.driverId);
  	  }
  	
  	  function driverDisplayName() {
  	    if (state.driverId === "__other__") return clean(state.driverOther);
  	    const driver = selectedDriver();
  	    return driver ? userName(driver) : clean(state.driverId);
  	  }
  	
  	  function validationError(options) {
  	    const settings = options || {};
  	    const tank = selectedTank();
  	    const bowser = selectedBowser();
  	    const company = selectedCompany();
  	    if (!company || !tank || !bowser) return "Select a tank and fuel dispenser.";
  	    const gate = tankGate(tank, state.gps);
  	    if (settings.includeLocation !== false && !gate.eligible) return gate.message;
  	    if (!state.mode) return "Choose Company Vehicle, Contractor Vehicle or Other.";
  	    if (isParaffinTankGrade(tankGrade(tank)) && state.mode !== "other") {
  	      return "Paraffin tanks only allow Other transactions.";
  	    }
  	    if (state.mode === "vehicle" || state.mode === "contractor") {
  	      if (state.mode === "contractor" && !selectedContractor()) return "Select a contractor.";
  	      if (!state.vehicle || !state.vehicleObjectId) return "Scan the vehicle QR code.";
  	      if (!vehicleMatchesTankGrade(state.vehicle, tankGrade(tank))) {
  	        return "The scanned vehicle fuel type is not compatible with " + tankGrade(tank) + ".";
  	      }
  	      if (!applicationValue()) return "Choose what the fuel is used for.";
  	      if (!driverValue()) return "Choose the driver receiving the fuel.";
  	      const reading = toNumber(state.mileage, NaN);
  	      const oldReading = currentMileage(state.vehicle);
  	      const maxReading = maximumMileage(state.vehicle);
  	      if (Number.isNaN(reading)) return "Enter the vehicle mileage or operating hours.";
  	      if (oldReading !== null && reading < oldReading) {
  	        return "Reading cannot be lower than " + formatNumber(oldReading, 1) + ".";
  	      }
  	      if (maxReading !== null && reading > maxReading) {
  	        return "Reading cannot be higher than " + formatNumber(maxReading, 1) + ".";
  	      }
  	    }
  	    const litres = toNumber(state.litres, NaN);
  	    if (Number.isNaN(litres) || litres <= 0) return "Enter the litres pumped.";
  	    if ((state.mode === "vehicle" || state.mode === "contractor") && state.vehicle) {
  	      const capacity = vehicleTankCapacity(state.vehicle);
  	      if (capacity > 0 && litres > capacity) {
  	        return "Litres cannot exceed the vehicle tank capacity of " + formatNumber(capacity, 1) + " L.";
  	      }
  	    }
  	    const meter = toNumber(state.meter, NaN);
  	    if (Number.isNaN(meter)) return "Enter the bowser meter after pumping.";
  	    const meterLast = toNumber(state.baseBowserMeter, toNumber(bowser.Meter, 0));
  	    const expected = meterLast + litres;
  	    if (meter < meterLast) {
  	      return "Meter cannot be lower than the current meter of " + formatNumber(meterLast, 2) + ".";
  	    }
  	    if (meter < expected - METER_TOLERANCE || meter > expected + METER_TOLERANCE) {
  	      return "Final meter must be between " +
  	        formatNumber(expected - METER_TOLERANCE, 2) + " and " +
  	        formatNumber(expected + METER_TOLERANCE, 2) + ".";
  	    }
  	    const available = toNumber(tank.Volume, 0);
  	    if (litres > available) {
  	      return "The tank only has " + formatNumber(available, 2) + " L available.";
  	    }
  	    return "";
  	  }
  	
  	  async function assertFreshLocation(tank) {
  	    const location = tankLocation(tank);
  	    if (!location) return tankGate(tank, state.gps);
  	    updateOperation("Verifying tank location…");
  	    let fix = state.gps;
  	    if (
  	      !fix ||
  	      !gpsFixFresh(fix, GPS_FINAL_MAX_AGE_MS) ||
  	      toNumber(fix.accuracy, Infinity) > GPS_ACCEPTABLE_ACCURACY_M
  	    ) {
  	      fix = await waitForGpsFix({
  	        maxAge: GPS_FINAL_MAX_AGE_MS,
  	        accuracy: GPS_ACCEPTABLE_ACCURACY_M,
  	        timeout: GPS_TIMEOUT_MS
  	      });
  	    }
  	    state.gps = fix || state.gps;
  	    const gate = tankGate(tank, state.gps);
  	    refreshLocationUi();
  	    if (!gate.eligible) {
  	      throw new Error(gate.message || "You must be at the linked tank location.");
  	    }
  	    return gate;
  	  }
  	
  	  async function hydrateTankLocation(tank) {
  	    if (!tank || tankLocationLoaded(tank) || state.locationHydrating) {
  	      if (tank && tankLocation(tank)) startGpsWatch();
  	      return tank;
  	    }
  	    state.locationHydrating = true;
  	    state.locationHydrationError = "";
  	    refreshLocationUi();
  	    try {
  	      const fresh = await loadTableRow("Tanks", objectIdOf(tank), ["Location"], true);
  	      if (
  	        fresh &&
  	        Object.prototype.hasOwnProperty.call(fresh, "Location")
  	      ) {
  	        tank.Location = fresh.Location;
  	      } else if (
  	        fresh &&
  	        Object.prototype.hasOwnProperty.call(fresh, "location")
  	      ) {
  	        tank.location = fresh.location;
  	      } else {
  	        tank.Location = null;
  	      }
  	      tank.__fifLocationLoaded = true;
  	      if (tankLocation(tank)) startGpsWatch();
  	      return tank;
  	    } catch (error) {
  	      state.locationHydrationError =
  	        "The tank Location relation could not be loaded. Close and retry or use the office capture.";
  	      console.error("Mobile Fuel tank location load failed", error);
  	      return tank;
  	    } finally {
  	      state.locationHydrating = false;
  	      refreshLocationUi();
  	    }
  	  }
  	
  	  function resetTransactionDraft(keepMode) {
  	    const previousMode = keepMode ? state.mode : "";
  	    const previousContractor = keepMode && previousMode === "contractor" ? state.contractorId : "";
  	    state.mode = previousMode;
  	    state.contractorId = previousContractor;
  	    state.vehicle = null;
  	    state.vehicleObjectId = "";
  	    state.vehicleSource = "";
  	    state.application = "";
  	    state.applicationOther = "";
  	    state.driverId = "";
  	    state.driverOther = "";
  	    state.mileage = "";
  	    state.litres = "";
  	    state.meter = "";
  	    state.description = "";
  	    state.captureQuestion = previousMode === "contractor"
  	      ? "contractor"
  	      : previousMode === "vehicle"
  	        ? "vehicle"
  	        : previousMode === "other"
  	          ? "litres"
  	          : "mode";
  	    state.questionError = "";
  	    state.success = null;
  	    const bowser = selectedBowser();
  	    state.baseBowserMeter = bowser ? toNumber(bowser.Meter, 0) : 0;
  	  }
  	
  	  async function saveCapture() {
  	    if (state.saving) return;
  	    const initialError = validationError({ includeLocation: false });
  	    if (initialError) {
  	      showOperationError(initialError);
  	      return;
  	    }
  	    const company = selectedCompany();
  	    const tank = selectedTank();
  	    const bowser = selectedBowser();
  	    const contractor = selectedContractor();
  	    const liveVehicle = state.vehicle;
  	    const user = userRecord();
  	    state.saving = true;
  	    showOperation("Preparing fuel transaction…");
  	    refreshCaptureControls();
  	
  	    try {
  	      updateOperation("Loading fresh tank and dispenser readings…");
  	      const workingTank = deepClone(await loadTableRow(
  	        "Tanks",
  	        objectIdOf(tank),
  	        ["Bowsers", "FuelIn", "ViewC", "ViewH", "Location"],
  	        true
  	      ));
  	      workingTank.__fifLocationLoaded = true;
  	      if (Object.prototype.hasOwnProperty.call(workingTank, "Location")) {
  	        tank.Location = workingTank.Location;
  	      } else if (Object.prototype.hasOwnProperty.call(workingTank, "location")) {
  	        tank.location = workingTank.location;
  	      } else {
  	        tank.Location = null;
  	      }
  	      tank.__fifLocationLoaded = true;
  	
  	      const gate = await assertFreshLocation(workingTank);
  	      const errorAfterLocation = validationError({ includeLocation: true });
  	      if (errorAfterLocation) throw new Error(errorAfterLocation);
  	
  	      const workingBowser = deepClone(await loadTableRow(
  	        "Bowsers",
  	        objectIdOf(bowser),
  	        ["ViewC", "ViewH"]
  	      ));
  	      const mode = captureModeValue();
  	      const workingVehicle = mode === "other"
  	        ? null
  	        : deepClone(await loadTableRow(
  	            "Tractors",
  	            objectIdOf(liveVehicle),
  	            ["ViewC", "ViewH", "Tyres"]
  	          ));
  	
  	      if (workingVehicle) {
  	        const maintenanceRows = await mobileLoadRelation(
  	          "Tractors",
  	          objectIdOf(workingVehicle),
  	          "Maintenance"
  	        );
  	        if (maintenanceRows.length) {
  	          workingVehicle.Maintenance = maintenanceRows;
  	        } else if (!mobileRelationRows(workingVehicle.Maintenance).length) {
  	          workingVehicle.Maintenance = mobileRelationRows(liveVehicle && liveVehicle.Maintenance);
  	        }
  	      }
  	
  	      if (
  	        workingVehicle &&
  	        !relationCollectionToArray(getDeep(workingVehicle, ["Tyres"], [])).length
  	      ) {
  	        workingVehicle.Tyres = deepClone(
  	          relationCollectionToArray(getDeep(liveVehicle, ["Tyres"], []))
  	        );
  	      }
  	
  	      const litres = toNumber(state.litres, 0);
  	      const enteredMeter = toNumber(state.meter, 0);
  	      const freshMeter = toNumber(workingBowser.Meter, 0);
  	      const originalMeter = toNumber(state.baseBowserMeter, freshMeter);
  	
  	      if (Math.abs(freshMeter - originalMeter) > 0.001) {
  	        bowser.Meter = freshMeter;
  	        state.baseBowserMeter = freshMeter;
  	        throw new Error(
  	          "The bowser meter changed from " + formatNumber(originalMeter, 2) +
  	          " to " + formatNumber(freshMeter, 2) +
  	          " while this capture was open. The live meter has been refreshed; confirm the actual final meter and save again."
  	        );
  	      }
  	
  	      const expectedMeter = freshMeter + litres;
  	      if (
  	        enteredMeter < expectedMeter - METER_TOLERANCE ||
  	        enteredMeter > expectedMeter + METER_TOLERANCE
  	      ) {
  	        throw new Error(
  	          "The fresh bowser meter requires a final reading between " +
  	          formatNumber(expectedMeter - METER_TOLERANCE, 2) + " and " +
  	          formatNumber(expectedMeter + METER_TOLERANCE, 2) + "."
  	        );
  	      }
  	
  	      const tankVolumeOld = toNumber(workingTank.Volume, 0);
  	      const tankCapacity = toNumber(workingTank.Capacity, 0);
  	      const tankVolumeNew = tankVolumeOld - litres;
  	      if (tankVolumeNew < 0) {
  	        throw new Error("Tank volume cannot go below 0. Available volume is " + formatNumber(tankVolumeOld, 2) + " L.");
  	      }
  	
  	      let mileageNew = 0;
  	      let mileageLast = 0;
  	      let readingDifferential = 0;
  	      let distance = 0;
  	      let hours = 0;
  	      let meterProfile = null;
  	
  	      if (workingVehicle) {
  	        if (!vehicleMatchesTankGrade(workingVehicle, tankGrade(workingTank))) {
  	          throw new Error("The scanned vehicle is no longer compatible with " + tankGrade(workingTank) + ".");
  	        }
  	
  	        meterProfile = vehicleMeterProfile(workingVehicle);
  	        mileageNew = toNumber(state.mileage, NaN);
  	        mileageLast = currentMileage(workingVehicle);
  	        if (mileageLast === null) mileageLast = 0;
  	
  	        if (Number.isNaN(mileageNew)) {
  	          throw new Error("Vehicle mileage or operating hours is required.");
  	        }
  	
  	        if (mileageNew < mileageLast) {
  	          throw new Error(
  	            "Reading cannot be lower than the current saved reading of " +
  	            formatNumber(mileageLast, meterProfile.decimals) + " " +
  	            meterProfile.unit + "."
  	          );
  	        }
  	
  	        const maxReading = maximumMileage(workingVehicle);
  	        if (maxReading !== null && mileageNew > maxReading) {
  	          throw new Error(
  	            "Reading cannot be higher than " +
  	            formatNumber(maxReading, meterProfile.decimals) + " " +
  	            meterProfile.unit + "."
  	          );
  	        }
  	
  	        readingDifferential = Math.max(0, mileageNew - mileageLast);
  	        distance = meterProfile.kind === "distance" ? readingDifferential : 0;
  	        hours = meterProfile.kind === "hours" ? readingDifferential : 0;
  	
  	        const capacity = vehicleTankCapacity(workingVehicle);
  	        if (capacity > 0 && litres > capacity) {
  	          throw new Error(
  	            "Litres cannot exceed the vehicle tank capacity of " +
  	            formatNumber(capacity, 1) + " L."
  	          );
  	        }
  	      }
  	
  	      const now = getBusinessNowDate();
  	      const costPerLitre = getTankCostPerLitre(tank);
  	      const transactionCost = roundMoney2(litres * costPerLitre);
  	      const sarsCompliant = workingVehicle ? isVehicleSarsCompliant(workingVehicle) : false;
  	      const potentialSarsRebate = sarsCompliant ? roundMoney2(litres * 3.00) : 0;
  	      const driverObject = selectedDriver();
  	      const location = gate.location;
  	      const proximity = gate.proximity;
  	      const capturedBy = userName(user);
  	      const ownerId = clean(firstValue([
  	        company && company.ownerId,
  	        user && user.ownerId,
  	        ""
  	      ], ""));
  	
  	      const fuelOutRow = {
  	        FuelDate: now,
  	        CaptureType: mode,
  	        EntryType: "Mobile Bowser Fuel",
  	        Application: mode === "other" ? "" : applicationValue(),
  	        Registration: mode === "other" ? "" : vehicleFuelRecordRegistration(workingVehicle),
  	        Driver: mode === "other" ? "" : driverValue(),
  	        DriverName: mode === "other" ? "" : driverDisplayName(),
  	        ContractorName: mode === "contractor" && contractor ? companyName(contractor) : "",
  	        Litres: litres,
  	        CostPerLitre: costPerLitre,
  	        Cost: transactionCost,
  	        SARSCompliance: sarsCompliant,
  	        PotentialSARSRebate: potentialSarsRebate,
  	        Mileage: mode === "other" ? null : mileageNew,
  	        MileageLast: mode === "other" ? null : mileageLast,
  	        ReadingUnit: mode === "other" || !meterProfile ? "" : meterProfile.unit,
  	        ReadingDelta: mode === "other" ? 0 : readingDifferential,
  	        Distance: mode === "other" ? 0 : distance,
  	        Hours: mode === "other" ? 0 : hours,
  	        Efficiency:
  	          mode === "other" || !(litres > 0)
  	            ? 0
  	            : readingDifferential / litres,
  	        EfficiencyUnit:
  	          mode === "other" || !meterProfile
  	            ? ""
  	            : (meterProfile.kind === "hours" ? "h/L" : "km/L"),
  	        Meter: enteredMeter,
  	        MeterLast: freshMeter,
  	        Tolerance: METER_TOLERANCE,
  	        Description: clean(state.description),
  	        IsReversed: false,
  	        Reversed: false,
  	        RollbackStatus: "active",
  	        RollbackGroupId: "",
  	        RollbackProtected: false,
  	        RollbackProtectionType: "none",
  	        TankObjectId: objectIdOf(workingTank),
  	        BowserObjectId: objectIdOf(workingBowser),
  	        TractorObjectId: mode === "other" ? "" : objectIdOf(workingVehicle),
  	        VehicleObjectId: mode === "other" ? "" : objectIdOf(workingVehicle),
  	        RollbackMileageDifferential: mode === "other" ? 0 : readingDifferential,
  	        RollbackVehicleMileageBefore: mode === "other" ? null : mileageLast,
  	        RollbackBowserMeterBefore: freshMeter,
  	        CapturedByObjectId: objectIdOf(user),
  	        CapturedByName: capturedBy,
  	        FuelLocationObjectId: location ? objectIdOf(location) : "",
  	        FuelLocationName: location ? locationName(location) : "",
  	        FuelLocationDistanceKM:
  	          proximity && proximity.distanceMeters !== null
  	            ? Math.round((proximity.distanceMeters / 1000) * 1000) / 1000
  	            : null,
  	        FuelLocationDistanceM:
  	          proximity && proximity.distanceMeters !== null
  	            ? Math.round(proximity.distanceMeters * 10) / 10
  	            : null,
  	        FuelLocationInside: proximity ? !!proximity.inside : false,
  	        FuelLocationGateMetres: GPS_GATE_METRES,
  	        FuelLocationProximityMethod: proximity ? proximity.method : "Unrestricted",
  	        LocationSource: location ? "GPS verified tank location" : "Tank has no location restriction",
  	        Latitude: state.gps ? state.gps.latitude : null,
  	        Longitude: state.gps ? state.gps.longitude : null,
  	        GPSAccuracy: state.gps ? state.gps.accuracy : null,
  	        GPSCapturedAt: state.gps ? state.gps.capturedAt : null,
  	        GPSFixSamples: state.gps ? toNumber(state.gps.samples, gpsRuntime.samples) : 0,
  	        GPSQuality: state.gps ? gpsAccuracyQuality(state.gps.accuracy).label : "Not required",
  	        GPSAcquisitionMethod: state.gps ? clean(state.gps.source || "watchPosition") : ""
  	      };
  	
  	      if (ownerId) fuelOutRow.ownerId = ownerId;
  	      if (objectIdOf(company)) fuelOutRow.Company = { objectId: objectIdOf(company) };
  	      if (objectIdOf(workingTank)) fuelOutRow.Tank = { objectId: objectIdOf(workingTank) };
  	      if (objectIdOf(workingBowser)) fuelOutRow.Bowser = { objectId: objectIdOf(workingBowser) };
  	      if (workingVehicle && objectIdOf(workingVehicle)) {
  	        fuelOutRow.Tractor = { objectId: objectIdOf(workingVehicle) };
  	      }
  	      if (mode === "contractor" && contractor && objectIdOf(contractor)) {
  	        fuelOutRow.Contractor = { objectId: objectIdOf(contractor) };
  	      }
  	      if (driverObject && objectIdOf(driverObject)) {
  	        fuelOutRow.DriverUser = { objectId: objectIdOf(driverObject) };
  	      }
  	      if (location && objectIdOf(location)) {
  	        fuelOutRow.Location = { objectId: objectIdOf(location) };
  	      }
  	
  	      updateOperation("Saving fuel transaction…");
  	      const savedRaw = await saveTableRow("FuelOut", fuelOutRow);
  	      const savedTransaction = Object.assign({}, fuelOutRow, savedRaw || {});
  	      const fuelOutId = objectIdOf(savedTransaction);
  	      if (!fuelOutId) throw new Error("FuelOut saved without an objectId.");
  	
  	      workingTank.Volume = tankVolumeNew;
  	      if (tankCapacity > 0) workingTank.Level = tankVolumeNew / tankCapacity * 100;
  	      workingBowser.Meter = enteredMeter;
  	
  	      const bowserView = ensureBowserViewRow(workingBowser, freshMeter, now);
  	      bowserView.Litres = toNumber(bowserView.Litres, 0) + litres;
  	      bowserView.Cost = roundMoney2(toNumber(bowserView.Cost, 0) + transactionCost);
  	      bowserView.MeterEnd = enteredMeter;
  	      const savedBowserView = Object.assign(
  	        bowserView,
  	        await saveTableRow("BowserView", bowserView)
  	      );
  	      workingBowser.ViewC = savedBowserView;
  	      await syncBowserViewRelations(workingBowser, savedBowserView);
  	
  	      let savedVehicleView = null;
  	      let tyreMileageSync = {
  	        updatedCount: 0,
  	        synchronisedCount: 0,
  	        spareCount: 0,
  	        differential: 0,
  	        vehicleMileage: mileageNew,
  	        updatedTyres: [],
  	        updates: []
  	      };
  	
  	      if (workingVehicle) {
  	        mobileSetVehicleCurrentReading(
  	          workingVehicle,
  	          mileageNew,
  	          meterProfile
  	        );
  	        mobileIncrementFuelCounter(workingVehicle);
  	
  	        /*
  	         * Save a narrow Tractor patch before tyre synchronisation. Never send
  	         * the hydrated Tyres relation back inside the Tractor save.
  	         */
  	        const vehiclePatch = {
  	          objectId: objectIdOf(workingVehicle),
  	          Mileage: mileageNew
  	        };
  	
  	        if (getDeep(workingVehicle, ["Data"], null)) {
  	          vehiclePatch.Data = deepClone(workingVehicle.Data);
  	        }
  	
  	        const savedVehicleRow = await saveTableRow(
  	          "Tractors",
  	          vehiclePatch
  	        );
  	        Object.assign(
  	          workingVehicle,
  	          vehiclePatch,
  	          savedVehicleRow || {}
  	        );
  	
  	        const vehicleView = ensureVehicleViewRow(workingVehicle, now);
  	        tyreMileageSync = await bulkUpdateVehicleTyreMileage(
  	          workingVehicle,
  	          readingDifferential,
  	          mileageNew
  	        );
  	        mergeVehicleTyresIntoLiveAppData(liveVehicle, workingVehicle);
  	
  	        vehicleView.TransactionCount = toNumber(vehicleView.TransactionCount, 0) + 1;
  	        if (
  	          vehicleView.MeterStart === null ||
  	          vehicleView.MeterStart === undefined ||
  	          vehicleView.MeterStart === "" ||
  	          toNumber(vehicleView.MeterStart, 0) <= 0
  	        ) vehicleView.MeterStart = mileageLast;
  	        vehicleView.MeterEnd = mileageNew;
  	        vehicleView.Distance = toNumber(vehicleView.Distance, 0) + distance;
  	        vehicleView.Hours = toNumber(vehicleView.Hours, 0) + hours;
  	        vehicleView.Litres = toNumber(vehicleView.Litres, 0) + litres;
  	        vehicleView.Cost = roundMoney2(toNumber(vehicleView.Cost, 0) + transactionCost);
  	        vehicleView.PotentialSARSRebate =
  	          toNumber(vehicleView.PotentialSARSRebate, 0) + potentialSarsRebate;
  	
  	        savedVehicleView = Object.assign(
  	          vehicleView,
  	          await saveTableRow("Tractorview", vehicleView)
  	        );
  	        workingVehicle.ViewC = savedVehicleView;
  	        await syncVehicleViewRelations(workingVehicle, savedVehicleView);
  	      }
  	
  	      const bowserRows = arr(workingTank.Bowsers);
  	      const bowserIndex = findIndexByKeys(bowserRows, workingBowser);
  	      if (bowserIndex >= 0) {
  	        bowserRows[bowserIndex] = deepClone(workingBowser);
  	        workingTank.Bowsers = bowserRows;
  	      }
  	
  	      await Promise.all([
  	        saveTableRow("Tanks", workingTank),
  	        saveTableRow("Bowsers", workingBowser)
  	      ]);
  	
  	      await addRelation("BowserView", objectIdOf(savedBowserView), "FuelOut", [fuelOutId]);
  	      if (workingVehicle && savedVehicleView) {
  	        await addRelationOptional(
  	          "Tractorview",
  	          objectIdOf(savedVehicleView),
  	          "Fuel",
  	          [fuelOutId]
  	        );
  	      }
  	
  	      await addRelationOptional("Companies", objectIdOf(company), "FuelOut", [fuelOutId]);
  	      await addRelationOptional("Tanks", objectIdOf(workingTank), "FuelOut", [fuelOutId]);
  	      await addRelationOptional("Bowsers", objectIdOf(workingBowser), "FuelOut", [fuelOutId]);
  	      if (workingVehicle) {
  	        await addRelationOptional("Tractors", objectIdOf(workingVehicle), "FuelOut", [fuelOutId]);
  	      }
  	      if (user && objectIdOf(user)) {
  	        await addRelationOptional("Users", objectIdOf(user), "FuelOut", [fuelOutId]);
  	      }
  	
  	      Object.assign(tank, {
  	        Volume: workingTank.Volume,
  	        Level: workingTank.Level
  	      });
  	      Object.assign(bowser, {
  	        Meter: workingBowser.Meter,
  	        ViewC: savedBowserView,
  	        ViewH: workingBowser.ViewH
  	      });
  	      replaceNestedTank(company, workingTank);
  	
  	      if (workingVehicle && liveVehicle) {
  	        Object.assign(liveVehicle, {
  	          Mileage: workingVehicle.Mileage,
  	          ViewC: savedVehicleView,
  	          ViewH: workingVehicle.ViewH
  	        });
  	        mergeVehicleTyresIntoLiveAppData(liveVehicle, workingVehicle);
  	        if (mode === "company") replaceNestedVehicle(company, workingVehicle);
  	        if (mode === "contractor" && contractor) replaceNestedVehicle(contractor, workingVehicle);
  	      }
  	
  	      /*
  	       * System-side notifications are deliberately silent here. A Bowser
  	       * operator sees only the fuel result, never whether an order/service
  	       * email was required, attempted, sent or rejected.
  	       */
  	      await mobileProcessTankNotificationsSilently(
  	        mobileResolveCompanyFromAppData(company, workingVehicle) || company,
  	        workingTank,
  	        tankVolumeOld,
  	        tankVolumeNew,
  	        savedTransaction
  	      );
  	
  	      if (workingVehicle) {
  	        const serviceContext =
  	          mode === "contractor" && contractor
  	            ? contractor
  	            : company;
  	
  	        await mobileProcessProviderNotificationsSilently(
  	          serviceContext,
  	          company,
  	          workingVehicle,
  	          savedTransaction
  	        );
  	
  	        if (liveVehicle && getDeep(workingVehicle, ["Data"], null)) {
  	          liveVehicle.Data = deepClone(workingVehicle.Data);
  	        }
  	      }
  	
  	      if (!Array.isArray(company.FuelOut)) company.FuelOut = [];
  	      company.FuelOut.push(savedTransaction);
  	      if (!Array.isArray(bowser.FuelOut)) bowser.FuelOut = [];
  	      bowser.FuelOut.push(savedTransaction);
  	      if (!Array.isArray(tank.FuelOut)) tank.FuelOut = [];
  	      tank.FuelOut.push(savedTransaction);
  	
  	      state.success = {
  	        transaction: savedTransaction,
  	        litres: litres,
  	        cost: transactionCost,
  	        vehicle: workingVehicle,
  	        contractor: contractor,
  	        tyreCount: tyreMileageSync.updatedCount,
  	        gate: gate
  	      };
  	      state.baseBowserMeter = enteredMeter;
  	      state.screen = "success";
  	      completeOperation("Fuel transaction saved.");
  	      window.setTimeout(function () {
  	        closeOperation();
  	        render();
  	      }, 900);
  	    } catch (error) {
  	      console.error("Mobile Fuel Capture save failed", error);
  	      failOperation(error && error.message ? error.message : "The fuel transaction could not be saved.");
  	    } finally {
  	      state.saving = false;
  	      refreshCaptureControls();
  	    }
  	  }
  	
  	  function fallbackLogo() {
  	    return '<svg viewBox="0 0 80 80" aria-hidden="true"><path d="M10 42 54 10l16 8-44 32-16-8Z" fill="#d96c32"/><path d="m19 48 15 7 29-21 7 4-38 28-22-10 9-8Z" fill="#f0b18e"/></svg>';
  	  }
  	
  	  function suppliedLogo() {
  	    let logo = SVG_INPUT;
  	    if (logo && typeof logo === "object") {
  	      logo = logo.url || logo.src || logo.data || logo.value || logo.fileURL || "";
  	    }
  	    logo = clean(logo);
  	    if (!logo) return fallbackLogo();
  	    if (logo.indexOf("<svg") !== -1) return logo;
  	    if (logo.indexOf("iVBORw0KGgo") === 0) logo = "data:image/png;base64," + logo;
  	    if (logo.indexOf("/9j/") === 0) logo = "data:image/jpeg;base64," + logo;
  	    return '<img src="' + escapeAttr(logo) + '" alt="Fleet In Form">';
  	  }
  	
  	  function icon(name) {
  	    const icons = {
  	      fuel: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h8a2 2 0 0 1 2 2v14H4V5a2 2 0 0 1 2-2Zm0 2v5h8V5H6Zm1 9v3h6v-3H7Zm10-8h2l2 3v8a2 2 0 1 1-4 0v-5h2v5a.5.5 0 1 0 1 0V10l-3-4Z" fill="currentColor"/></svg>',
  	      location: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a8 8 0 0 1 8 8c0 5.5-8 12-8 12S4 15.5 4 10a8 8 0 0 1 8-8Zm0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" fill="currentColor"/></svg>',
  	      qr: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3h8v8H3V3Zm2 2v4h4V5H5Zm8-2h8v8h-8V3Zm2 2v4h4V5h-4ZM3 13h8v8H3v-8Zm2 2v4h4v-4H5Zm8-2h3v3h-3v-3Zm5 0h3v3h-3v-3Zm-5 5h3v3h-3v-3Zm4-1h2v2h2v2h-4v-4Z" fill="currentColor"/></svg>',
  	      camera: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.2 4 6.8 6H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2.8l-1.4-2H8.2ZM12 9a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z" fill="currentColor"/></svg>',
  	      vehicle: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 11l2-5h10l2 5 2 2v6h-2a2 2 0 0 1-4 0H9a2 2 0 0 1-4 0H3v-6l2-2Zm3.4-3-1.2 3h9.6l-1.2-3H8.4Z" fill="currentColor"/></svg>',
  	      contractor: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 21V8l9-5 9 5v13h-7v-7h-4v7H3Zm3-9h2V9H6v3Zm10 0h2V9h-2v3Z" fill="currentColor"/></svg>',
  	      other: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16v16H4V4Zm3 4v2h10V8H7Zm0 4v2h10v-2H7Zm0 4v2h6v-2H7Z" fill="currentColor"/></svg>',
  	      back: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14.7 5.3-1.4-1.4L5.2 12l8.1 8.1 1.4-1.4L8 12l6.7-6.7Z" fill="currentColor"/></svg>',
  	      close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6.4 5 5.6 5.6L17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19 5 17.6l5.6-5.6L5 6.4 6.4 5Z" fill="currentColor"/></svg>',
  	      retry: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4a8 8 0 1 1-7.45 10.9l1.86-.72A6 6 0 1 0 7.1 8H10v2H3V3h2v3.2A7.96 7.96 0 0 1 12 4Z" fill="currentColor"/></svg>',
  	      check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9.2 16.6-4.8-4.8L3 13.2l6.2 6.2L21 7.6 19.6 6.2 9.2 16.6Z" fill="currentColor"/></svg>',
  	      torch: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 2h8l-1 6 3 3-4 11h-4L6 11l3-3-1-6Z" fill="currentColor"/></svg>',
  	      logout: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 3h9a2 2 0 0 1 2 2v3h-2V5H4v14h9v-3h2v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm13.6 5.4L19 7l5 5-5 5-1.4-1.4 2.6-2.6H9v-2h11.2l-2.6-2.6Z" fill="currentColor"/></svg>'
  	    };
  	    return icons[name] || icons.fuel;
  	  }
  	
  	  function appMenuNode() {
  	    return document.getElementById(APP_MENU_ID);
  	  }
  	
  	  function logoutButtonNode() {
  	    return document.querySelector(
  	      "#" + ROOT_ID + " [data-action='logout']"
  	    );
  	  }
  	
  	  function positionAppMenu() {
  	    const menu = appMenuNode();
  	    if (!menu) return;
  	
  	    const button = logoutButtonNode();
  	    const width = Math.min(220, Math.max(176, window.innerWidth - 16));
  	    const viewportPadding = 8;
  	    const gap = 6;
  	    let left = window.innerWidth - width - viewportPadding;
  	    let top = viewportPadding;
  	
  	    if (button && button.getBoundingClientRect) {
  	      const rect = button.getBoundingClientRect();
  	      left = Math.min(
  	        window.innerWidth - width - viewportPadding,
  	        Math.max(viewportPadding, rect.right - width)
  	      );
  	      top = rect.bottom + gap;
  	
  	      const height = menu.offsetHeight || 210;
  	      if (top + height > window.innerHeight - viewportPadding) {
  	        top = Math.max(viewportPadding, rect.top - height - gap);
  	      }
  	    }
  	
  	    menu.style.width = width + "px";
  	    menu.style.left = Math.round(left) + "px";
  	    menu.style.top = Math.round(top) + "px";
  	  }
  	
  	  function onAppMenuOutside(event) {
  	    const menu = appMenuNode();
  	    const button = logoutButtonNode();
  	    if (!menu) return;
  	    if (menu.contains(event.target)) return;
  	    if (button && button.contains(event.target)) return;
  	    closeAppMenu();
  	  }
  	
  	  function onAppMenuKeyDown(event) {
  	    if (event.key !== "Escape") return;
  	    event.preventDefault();
  	    closeAppMenu();
  	  }
  	
  	  function closeAppMenu() {
  	    const menu = appMenuNode();
  	    if (menu) menu.remove();
  	
  	    document.removeEventListener("pointerdown", onAppMenuOutside, true);
  	    document.removeEventListener("keydown", onAppMenuKeyDown, true);
  	    window.removeEventListener("resize", positionAppMenu);
  	    window.removeEventListener("scroll", positionAppMenu, true);
  	
  	    const button = logoutButtonNode();
  	    if (button) button.setAttribute("aria-expanded", "false");
  	  }
  	
  	  function setAppMenuStatus(message, error) {
  	    const menu = appMenuNode();
  	    if (!menu) return;
  	    const status = menu.querySelector("[data-app-menu-status]");
  	    if (!status) return;
  	    status.textContent = clean(message);
  	    status.hidden = !clean(message);
  	    status.classList.toggle("error", !!error);
  	  }
  	
  	  function disableAppMenuOptions(disabled) {
  	    const menu = appMenuNode();
  	    if (!menu) return;
  	    menu.querySelectorAll("button").forEach(function (button) {
  	      button.disabled = !!disabled;
  	    });
  	  }
  	
  	  async function isBackendlessSessionValid() {
  	    try {
  	      if (
  	        DB &&
  	        DB.UserService &&
  	        typeof DB.UserService.isValidLogin === "function"
  	      ) {
  	        return !!(await DB.UserService.isValidLogin());
  	      }
  	    } catch (_) {
  	      return false;
  	    }
  	    return true;
  	  }
  	
  	  function applicationNavigator() {
  	    const candidates = [];
  	    try {
  	      if (typeof BackendlessUI !== "undefined") candidates.push(BackendlessUI);
  	    } catch (_) {}
  	    try {
  	      if (window.BackendlessUI) candidates.push(window.BackendlessUI);
  	    } catch (_) {}
  	    try {
  	      if (window.parent && window.parent !== window && window.parent.BackendlessUI) {
  	        candidates.push(window.parent.BackendlessUI);
  	      }
  	    } catch (_) {}
  	    try {
  	      if (window.top && window.top !== window && window.top.BackendlessUI) {
  	        candidates.push(window.top.BackendlessUI);
  	      }
  	    } catch (_) {}
  	
  	    for (let i = 0; i < candidates.length; i += 1) {
  	      if (
  	        candidates[i] &&
  	        candidates[i].Navigator &&
  	        typeof candidates[i].Navigator.goToPage === "function"
  	      ) {
  	        return candidates[i].Navigator;
  	      }
  	    }
  	
  	    return null;
  	  }
  	
  	  async function navigateToApplicationPage(pageName) {
  	    const navigator = applicationNavigator();
  	    if (!navigator) throw new Error("Application navigation is unavailable.");
  	    await Promise.resolve(navigator.goToPage(pageName, undefined));
  	  }
  	
  	  async function switchApplication(appName) {
  	    if (state.appSwitchInProgress || state.logoutInProgress) return false;
  	
  	    const user = userRecord();
  	    const target = normaliseApplicationName(appName);
  	    const allowed = allowedApplicationsFor(user);
  	
  	    if (!APPLICATION_PAGES[target] || allowed.indexOf(target) === -1) {
  	      setAppMenuStatus(
  	        "You do not have permission to open this application.",
  	        true
  	      );
  	      return false;
  	    }
  	
  	    state.appSwitchInProgress = true;
  	    disableAppMenuOptions(true);
  	    setAppMenuStatus("Opening " + target + "…", false);
  	
  	    try {
  	      const sessionValid = await isBackendlessSessionValid();
  	      const activeGuard = installLogoutGuard() || logoutGuard;
  	
  	      console.info("[Fuel Capture App Switcher]", {
  	        version: VERSION,
  	        from: currentApplication(),
  	        to: target,
  	        sessionValid: sessionValid,
  	        logoutGuardActive: !!activeGuard
  	      });
  	
  	      if (!sessionValid) {
  	        throw new Error("Your session has ended. Please log in again.");
  	      }
  	
  	      stopQrScanner();
  	      stopGpsWatch();
  	
  	      if (APP_DATA && typeof APP_DATA === "object") {
  	        APP_DATA.APP = target;
  	      }
  	
  	      const pageName = APPLICATION_PAGES[target];
  	      closeAppMenu();
  	      await navigateToApplicationPage(pageName);
  	
  	      window.setTimeout(function () {
  	        try {
  	          if (document.getElementById(ROOT_ID)) closeApp();
  	        } catch (_) {}
  	      }, 500);
  	
  	      return true;
  	    } catch (error) {
  	      state.appSwitchInProgress = false;
  	      disableAppMenuOptions(false);
  	      setAppMenuStatus(
  	        clean(error && error.message) ||
  	          "The selected application could not be opened.",
  	        true
  	      );
  	      return false;
  	    }
  	  }
  	
  	  function openAppMenu(applications) {
  	    closeAppMenu();
  	
  	    const menu = document.createElement("div");
  	    menu.id = APP_MENU_ID;
  	    menu.setAttribute("role", "menu");
  	    menu.setAttribute("aria-label", "Switch application or log out");
  	
  	    applications.forEach(function (name) {
  	      const option = document.createElement("button");
  	      option.type = "button";
  	      option.className = "fm-app-option";
  	      option.setAttribute("role", "menuitem");
  	      option.textContent = name;
  	      option.addEventListener("click", function (event) {
  	        event.preventDefault();
  	        event.stopPropagation();
  	        switchApplication(name);
  	      });
  	      menu.appendChild(option);
  	    });
  	
  	    const logout = document.createElement("button");
  	    logout.type = "button";
  	    logout.className = "fm-app-option logout";
  	    logout.setAttribute("role", "menuitem");
  	    logout.textContent = "Log Out";
  	    logout.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      closeAppMenu();
  	      requestLogout();
  	    });
  	    menu.appendChild(logout);
  	
  	    const status = document.createElement("div");
  	    status.className = "fm-app-status";
  	    status.setAttribute("data-app-menu-status", "");
  	    status.setAttribute("aria-live", "polite");
  	    status.hidden = true;
  	    menu.appendChild(status);
  	
  	    document.body.appendChild(menu);
  	    positionAppMenu();
  	
  	    const button = logoutButtonNode();
  	    if (button) button.setAttribute("aria-expanded", "true");
  	
  	    document.addEventListener("pointerdown", onAppMenuOutside, true);
  	    document.addEventListener("keydown", onAppMenuKeyDown, true);
  	    window.addEventListener("resize", positionAppMenu);
  	    window.addEventListener("scroll", positionAppMenu, true);
  	
  	    window.setTimeout(function () {
  	      positionAppMenu();
  	      const first = menu.querySelector("button");
  	      if (first && typeof first.focus === "function") first.focus();
  	    }, 0);
  	  }
  	
  	  function handleLogoutButton() {
  	    if (appMenuNode()) {
  	      closeAppMenu();
  	      return;
  	    }
  	
  	    const user = userRecord();
  	    const current = currentApplication();
  	    const alternatives = allowedApplicationsFor(user).filter(function (name) {
  	      return name !== current;
  	    });
  	
  	    console.info("[Fuel Capture App Switcher Ready]", {
  	      version: VERSION,
  	      currentApp: current,
  	      availableApps: alternatives,
  	      logoutGuardActive: !!(installLogoutGuard() || logoutGuard)
  	    });
  	
  	    if (!user || !alternatives.length) {
  	      requestLogout();
  	      return;
  	    }
  	
  	    openAppMenu(alternatives);
  	  }
  	
  	
  	  function loginPageUrl(targetWindow) {
  	    try {
  	      const current = new URL(targetWindow.location.href);
  	      current.searchParams.set("page", "Login");
  	      current.hash = "";
  	      return current.toString();
  	    } catch (_) {
  	      return "index.html?page=Login";
  	    }
  	  }
  	
  	  function navigateToLogin() {
  	    const navigatorScopes = [];
  	    const addNavigator = function (scope) {
  	      if (!scope || !scope.Navigator || typeof scope.Navigator.goToPage !== "function") return;
  	      if (navigatorScopes.indexOf(scope) === -1) navigatorScopes.push(scope);
  	    };
  	
  	    try { if (typeof BackendlessUI !== "undefined") addNavigator(BackendlessUI); } catch (_) {}
  	    try { if (typeof window !== "undefined") addNavigator(window.BackendlessUI); } catch (_) {}
  	    try { if (typeof window !== "undefined" && window.parent && window.parent !== window) addNavigator(window.parent.BackendlessUI); } catch (_) {}
  	    try { if (typeof window !== "undefined" && window.top && window.top !== window) addNavigator(window.top.BackendlessUI); } catch (_) {}
  	
  	    for (let i = 0; i < navigatorScopes.length; i += 1) {
  	      try {
  	        const result = navigatorScopes[i].Navigator.goToPage("Login", undefined);
  	        if (result && typeof result.catch === "function") result.catch(function () {});
  	        break;
  	      } catch (_) {}
  	    }
  	
  	    window.setTimeout(function () {
  	      let targetWindow = typeof window !== "undefined" ? window : null;
  	      try {
  	        if (window.top && window.top.location && window.top.location.href) targetWindow = window.top;
  	      } catch (_) {}
  	      if (!targetWindow) return;
  	      const targetUrl = loginPageUrl(targetWindow);
  	      try {
  	        targetWindow.location.replace(targetUrl);
  	      } catch (_) {
  	        try {
  	          window.location.replace(targetUrl);
  	        } catch (_) {
  	          window.location.href = targetUrl;
  	        }
  	      }
  	    }, 200);
  	  }
  	
  	  function authStorageKey(key) {
  	    const value = clean(key).toLowerCase();
  	    if (!value) return false;
  	    return value === "user-token" ||
  	      value === "auth-token" ||
  	      value === "session-token" ||
  	      value === "current-user" ||
  	      value === "current-user-id" ||
  	      /backendless.*token|token.*backendless/.test(value) ||
  	      /(^|[-_. ])(user|auth|session)[-_. ]?token($|[-_. ])/.test(value);
  	  }
  	
  	  function clearBackendlessAuthArtifacts() {
  	    const stores = [];
  	    try { if (window.localStorage) stores.push(window.localStorage); } catch (_) {}
  	    try { if (window.sessionStorage) stores.push(window.sessionStorage); } catch (_) {}
  	
  	    stores.forEach(function (store) {
  	      const keys = [];
  	      try {
  	        for (let i = 0; i < store.length; i += 1) keys.push(store.key(i));
  	      } catch (_) {}
  	      keys.forEach(function (key) {
  	        if (!authStorageKey(key)) return;
  	        try { store.removeItem(key); } catch (_) {}
  	      });
  	    });
  	
  	    try {
  	      document.cookie.split(";").forEach(function (part) {
  	        const name = clean(part.split("=")[0]);
  	        if (!authStorageKey(name)) return;
  	        document.cookie = name + "=; Max-Age=0; path=/; SameSite=Lax";
  	      });
  	    } catch (_) {}
  	
  	    try {
  	      if (APP_DATA && Object.prototype.hasOwnProperty.call(APP_DATA, "User")) {
  	        APP_DATA.User = null;
  	      }
  	    } catch (_) {}
  	  }
  	
  	  function closeDialog(result) {
  	    const overlay = document.getElementById(DIALOG_ID);
  	    if (!overlay) return;
  	    const resolver = overlay.__fifResolve;
  	    overlay.__fifResolve = null;
  	    overlay.remove();
  	    if (typeof resolver === "function") resolver(!!result);
  	  }
  	
  	  function confirmLogout() {
  	    closeDialog(false);
  	    return new Promise(function (resolve) {
  	      const overlay = document.createElement("div");
  	      overlay.id = DIALOG_ID;
  	      overlay.__fifResolve = resolve;
  	      overlay.innerHTML =
  	        '<div class="fm-dialog" role="dialog" aria-modal="true" aria-labelledby="fm-logout-title">' +
  	          '<div class="fm-dialog-icon">' + icon("logout") + '</div>' +
  	          '<h2 id="fm-logout-title">Log out now?</h2>' +
  	          '<p>Any fuel details not saved will be lost.</p>' +
  	          '<button type="button" class="fm-dialog-danger" data-dialog-result="yes">YES, LOG OUT</button>' +
  	          '<button type="button" class="fm-dialog-stay" data-dialog-result="no">NO, STAY HERE</button>' +
  	        '</div>';
  	      document.body.appendChild(overlay);
  	      overlay.addEventListener("click", function (event) {
  	        const button = event.target.closest("[data-dialog-result]");
  	        if (!button) return;
  	        closeDialog(button.getAttribute("data-dialog-result") === "yes");
  	      });
  	      window.setTimeout(function () {
  	        const stay = overlay.querySelector(".fm-dialog-stay");
  	        if (stay) stay.focus();
  	      }, 20);
  	    });
  	  }
  	
  	  async function logoutUser() {
  	    if (state.logoutInProgress) return true;
  	    state.logoutInProgress = true;
  	    stopQrScanner();
  	    stopGpsWatch();
  	
  	    let logoutError = null;
  	    try {
  	      if (DB && DB.UserService && typeof DB.UserService.logout === "function") {
  	        const activeGuard = installLogoutGuard() || logoutGuard;
  	        if (
  	          activeGuard &&
  	          typeof activeGuard.explicitLogout === "function"
  	        ) {
  	          await activeGuard.explicitLogout();
  	        } else {
  	          await DB.UserService.logout();
  	        }
  	      }
  	    } catch (error) {
  	      logoutError = error;
  	      console.warn("Mobile Fuel Capture remote logout failed; local session will still be cleared.", error);
  	    }
  	
  	    clearBackendlessAuthArtifacts();
  	    closeDialog(false);
  	    closeOperation();
  	    navigateToLogin();
  	
  	    if (logoutError) return false;
  	    return true;
  	  }
  	
  	  async function requestLogout() {
  	    if (state.logoutInProgress) return;
  	    const approved = await confirmLogout();
  	    if (!approved) return;
  	    showOperation("Closing your secure session…");
  	    const overlay = document.getElementById(OPERATION_ID);
  	    const title = overlay && overlay.querySelector("[data-op-title]");
  	    if (title) title.textContent = "Logging out";
  	    await logoutUser();
  	  }
  	
  	  function injectStyles() {
  	    const legacyStyle = document.getElementById("fif-mobile-fuel-capture-style");
  	    if (legacyStyle) legacyStyle.remove();
  	    const existingStyle = document.getElementById(STYLE_ID);
  	    if (existingStyle) existingStyle.remove();
  	    const style = document.createElement("style");
  	    style.id = STYLE_ID;
  	    style.textContent = `
  	      :root{--fif-orange:#cc6633;--fif-orange-bright:#ed8a50;--fif-bg:#070d12;--fif-card:#12181f;--fif-card2:#0c1218;--fif-line:rgba(255,255,255,.10);--fif-muted:#91a2b6;--fif-good:#35bd79;--fif-danger:#df5b5b;--fif-warn:#e2a43e;--fif-vv-height:100dvh;--fif-vv-width:100vw;--fif-vv-top:0px;--fif-vv-left:0px}
  	      #${ROOT_ID}{position:fixed;left:var(--fif-vv-left);top:var(--fif-vv-top);right:auto;bottom:auto;width:var(--fif-vv-width);height:var(--fif-vv-height);z-index:2147482000;background:radial-gradient(circle at 50% -15%,rgba(204,102,51,.20),transparent 38%),linear-gradient(180deg,#0b1016,#050a0f);color:#f8fafc;font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;overflow:hidden;-webkit-font-smoothing:antialiased;overscroll-behavior:none}
  	      #${ROOT_ID} *{box-sizing:border-box}
  	      #${ROOT_ID} button,#${ROOT_ID} input,#${ROOT_ID} textarea{font:inherit}
  	      #${ROOT_ID} button{touch-action:manipulation;-webkit-tap-highlight-color:transparent}
  	      #${ROOT_ID} .fm-shell{position:relative;width:100%;height:100%;min-height:0;max-width:680px;margin:0 auto;display:flex;flex-direction:column;background:rgba(5,10,15,.84);border-left:1px solid rgba(255,255,255,.055);border-right:1px solid rgba(255,255,255,.055);overflow:hidden}
  	      #${ROOT_ID} .fm-header{position:relative;z-index:8;flex:0 0 auto;display:flex;align-items:center;gap:11px;padding:calc(10px + env(safe-area-inset-top)) 13px 10px;border-bottom:1px solid var(--fif-line);background:rgba(7,12,17,.96);backdrop-filter:blur(18px);box-shadow:0 8px 24px rgba(0,0,0,.18)}
  	      #${ROOT_ID} .fm-logo{width:44px;height:44px;flex:0 0 44px;border-radius:13px;display:grid;place-items:center;overflow:hidden;border:1px solid rgba(204,102,51,.44);background:linear-gradient(145deg,rgba(204,102,51,.25),rgba(204,102,51,.06))}
  	      #${ROOT_ID} .fm-logo svg{width:34px;height:34px}#${ROOT_ID} .fm-logo img{width:100%;height:100%;object-fit:contain;padding:4px}
  	      #${ROOT_ID} .fm-title{min-width:0;flex:1}#${ROOT_ID} .fm-title small{display:block;color:#df8758;font-size:9px;font-weight:950;letter-spacing:.12em;text-transform:uppercase}#${ROOT_ID} .fm-title strong{display:block;margin-top:2px;font-size:18px;line-height:1.15;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#${ROOT_ID} .fm-title span{display:block;margin-top:3px;color:var(--fif-muted);font-size:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fm-icon-btn{width:42px;height:42px;flex:0 0 42px;border-radius:13px;border:1px solid rgba(255,255,255,.11);background:linear-gradient(145deg,#171e26,#0b1016);color:#edf2f7;display:grid;place-items:center;cursor:pointer;box-shadow:inset 0 1px 0 rgba(255,255,255,.035)}#${ROOT_ID} .fm-icon-btn svg{width:21px;height:21px}
  	      #${ROOT_ID} .fm-main{position:relative;flex:1 1 auto;min-height:0;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:15px 13px calc(92px + env(safe-area-inset-bottom));scroll-padding-top:14px;scroll-padding-bottom:110px;overscroll-behavior-y:contain}
  	      #${ROOT_ID}.is-keyboard-open .fm-main{padding-bottom:26px;scroll-padding-bottom:72px}
  	      #${ROOT_ID}.is-keyboard-open .fm-footer{display:none}
  	      #${ROOT_ID}.is-keyboard-open .fm-header{padding-top:7px;padding-bottom:7px}
  	      #${ROOT_ID}.is-keyboard-open .fm-title small,#${ROOT_ID}.is-keyboard-open .fm-title span{display:none}
  	      #${ROOT_ID} h1,#${ROOT_ID} h2,#${ROOT_ID} h3,#${ROOT_ID} p{margin:0}#${ROOT_ID} .fm-kicker{color:#df8758;font-size:9px;font-weight:950;letter-spacing:.11em;text-transform:uppercase}#${ROOT_ID} h1{margin-top:5px;font-size:27px;line-height:1.08}#${ROOT_ID} p{margin-top:7px;color:var(--fif-muted);font-size:13px;line-height:1.45}
  	      #${ROOT_ID} .fm-company{margin-top:18px}#${ROOT_ID} .fm-company-head{display:flex;align-items:center;justify-content:space-between;padding:0 3px 8px;border-bottom:1px solid rgba(204,102,51,.34)}#${ROOT_ID} .fm-company-head strong{font-size:15px}#${ROOT_ID} .fm-company-head span{color:var(--fif-muted);font-size:11px}
  	      #${ROOT_ID} .fm-stack{display:flex;flex-direction:column;gap:12px;margin-top:12px}
  	      #${ROOT_ID} .fm-tank{border:1px solid var(--fif-line);border-top-color:rgba(204,102,51,.48);border-radius:18px;background:radial-gradient(circle at 10% 0,rgba(204,102,51,.07),transparent 30%),linear-gradient(145deg,rgba(255,255,255,.055),rgba(255,255,255,.016));box-shadow:0 16px 34px rgba(0,0,0,.25);padding:14px}
  	      #${ROOT_ID} .fm-tank-top{display:grid;grid-template-columns:68px minmax(0,1fr);gap:12px;align-items:center}#${ROOT_ID} .fm-gauge{--level:0%;width:68px;height:68px;border-radius:50%;display:grid;place-items:center;background:conic-gradient(var(--fif-orange-bright) var(--level),#dfe4ea var(--level));box-shadow:inset 0 0 0 8px rgba(8,13,19,.22),0 8px 20px rgba(0,0,0,.25)}#${ROOT_ID} .fm-gauge-inner{width:50px;height:50px;border-radius:50%;display:grid;place-items:center;text-align:center;background:linear-gradient(145deg,#f8fafc,#cbd3dd);color:#0a1118;font-size:13px;font-weight:950;line-height:1}#${ROOT_ID} .fm-gauge-inner small{display:block;font-size:8px;margin-top:3px;color:#39434e}
  	      #${ROOT_ID} .fm-tank-name{font-size:19px;font-weight:950;line-height:1.1}#${ROOT_ID} .fm-grade{margin-top:3px;color:#ef8b50;font-size:13px;font-weight:900}#${ROOT_ID} .fm-location-mini{margin-top:7px;display:flex;align-items:center;gap:6px;color:var(--fif-muted);font-size:10px}#${ROOT_ID} .fm-location-mini svg{width:15px;height:15px;color:#d47a48}
  	      #${ROOT_ID} .fm-stats{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:7px;margin-top:12px}#${ROOT_ID} .fm-stat{min-width:0;padding:9px 8px;border-radius:11px;background:rgba(0,0,0,.24);border:1px solid rgba(255,255,255,.045)}#${ROOT_ID} .fm-stat span{display:block;color:#8da0b5;font-size:8px;font-weight:950;text-transform:uppercase;letter-spacing:.055em}#${ROOT_ID} .fm-stat strong{display:block;margin-top:4px;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fm-dispensers{margin-top:13px}#${ROOT_ID} .fm-section-label{font-size:9px;color:#a8bad0;font-weight:950;letter-spacing:.1em;text-transform:uppercase}#${ROOT_ID} .fm-dispenser{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px;align-items:center;margin-top:8px;padding:11px;border:1px solid rgba(255,255,255,.09);border-radius:13px;background:linear-gradient(145deg,rgba(255,255,255,.05),rgba(255,255,255,.018))}#${ROOT_ID} .fm-dispenser strong{display:block;font-size:14px}#${ROOT_ID} .fm-dispenser span{display:block;margin-top:3px;color:var(--fif-muted);font-size:10px}#${ROOT_ID} .fm-open{min-height:43px;padding:8px 12px;border-radius:11px;border:1px solid rgba(232,115,57,.5);color:#fff;background:linear-gradient(145deg,#a04a23,#5e2914);font-size:12px;font-weight:950;cursor:pointer}
  	      #${ROOT_ID} .fm-card{border:1px solid rgba(255,255,255,.10);border-top-color:rgba(204,102,51,.42);border-radius:17px;background:radial-gradient(circle at 12% 0,rgba(204,102,51,.055),transparent 32%),linear-gradient(145deg,rgba(255,255,255,.052),rgba(255,255,255,.016));padding:14px;box-shadow:0 14px 30px rgba(0,0,0,.22)}#${ROOT_ID} .fm-card+.fm-card{margin-top:11px}#${ROOT_ID} .fm-form-card{padding:15px 14px 17px}
  	      #${ROOT_ID} .fm-summary-top{display:flex;align-items:flex-start;gap:11px}#${ROOT_ID} .fm-summary-icon{width:46px;height:46px;flex:0 0 46px;border-radius:13px;display:grid;place-items:center;background:rgba(204,102,51,.13);border:1px solid rgba(204,102,51,.29);color:#e99061}#${ROOT_ID} .fm-summary-icon svg{width:27px;height:27px}#${ROOT_ID} .fm-summary-copy{min-width:0;flex:1}#${ROOT_ID} .fm-summary-copy strong{display:block;font-size:17px}#${ROOT_ID} .fm-summary-copy span{display:block;margin-top:4px;color:var(--fif-muted);font-size:11px}#${ROOT_ID} .fm-summary-meter{margin-top:10px;padding:10px 11px;border-radius:11px;background:rgba(0,0,0,.25);font-size:11px;line-height:1.45;color:#c8d2de}#${ROOT_ID} .fm-summary-meter b{color:#fff}
  	      #${ROOT_ID} .fm-gate{display:grid;grid-template-columns:38px minmax(0,1fr) auto;gap:10px;align-items:center}#${ROOT_ID} .fm-gate-icon{width:38px;height:38px;border-radius:12px;display:grid;place-items:center}#${ROOT_ID} .fm-gate-icon svg{width:21px;height:21px}#${ROOT_ID} .fm-gate.ready .fm-gate-icon,#${ROOT_ID} .fm-gate.unrestricted .fm-gate-icon{background:rgba(53,189,121,.14);color:#79e4aa}#${ROOT_ID} .fm-gate.locked .fm-gate-icon{background:rgba(223,91,91,.14);color:#ff9c9c}#${ROOT_ID} .fm-gate.checking .fm-gate-icon{background:rgba(226,164,62,.14);color:#f1c66f}#${ROOT_ID} .fm-gate strong{display:block;font-size:13px}#${ROOT_ID} .fm-gate span{display:block;margin-top:3px;color:var(--fif-muted);font-size:10px;line-height:1.35}#${ROOT_ID} .fm-retry{width:40px;height:40px;border-radius:12px;border:1px solid var(--fif-line);background:#10171e;color:#fff;display:grid;place-items:center;cursor:pointer}#${ROOT_ID} .fm-retry svg{width:20px;height:20px}
  	      #${ROOT_ID} .fm-mode-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin-top:10px}#${ROOT_ID} .fm-mode{min-height:86px;padding:9px 7px;border-radius:14px;border:1px solid rgba(255,255,255,.105);background:linear-gradient(145deg,#151c24,#0a1016);color:#eef3f8;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:7px;text-align:center;font-size:10px;font-weight:950;cursor:pointer;box-shadow:inset 0 1px 0 rgba(255,255,255,.025)}#${ROOT_ID} .fm-mode svg{width:24px;height:24px;color:#e18453}#${ROOT_ID} .fm-mode.is-active{border-color:rgba(232,115,57,.72);background:radial-gradient(circle at 50% 0,rgba(255,145,77,.18),transparent 48%),linear-gradient(145deg,#7e3518,#351608);box-shadow:0 0 0 1px rgba(232,115,57,.14),0 10px 22px rgba(0,0,0,.18)}#${ROOT_ID} .fm-mode:disabled{opacity:.34;cursor:default}
  	      #${ROOT_ID} .fm-field{display:block;margin-top:13px}#${ROOT_ID} .fm-field>span{display:flex;align-items:center;min-height:16px;margin:0 0 6px 3px;color:#edf2f7;font-size:10px;font-weight:900;letter-spacing:.025em}#${ROOT_ID} .fm-input{display:block;width:100%;height:54px;border-radius:14px;border:1px solid rgba(255,122,36,.52);background:radial-gradient(circle at 12% 0,rgba(255,133,49,.06),transparent 38%),linear-gradient(145deg,rgba(17,22,28,.98),rgba(3,7,11,.99));color:#fff;padding:0 14px;outline:none;font-size:16px;font-weight:760;line-height:1.2;box-shadow:inset 0 1px 0 rgba(255,255,255,.035),0 7px 15px rgba(0,0,0,.13);caret-color:#ff9a60;-webkit-appearance:none;appearance:none}#${ROOT_ID} .fm-input::placeholder{color:rgba(214,224,235,.37);font-weight:650}#${ROOT_ID} .fm-input:focus{border-color:#ff914f;box-shadow:0 0 0 3px rgba(255,138,60,.14),0 10px 22px rgba(0,0,0,.18)}#${ROOT_ID} textarea.fm-input{height:96px;min-height:96px;resize:vertical;padding-top:14px;padding-bottom:12px;line-height:1.4}#${ROOT_ID} .fm-grid2{display:grid;grid-template-columns:1fr;gap:0}
  	      #${ROOT_ID} .fm-select{position:relative;width:100%}#${ROOT_ID} .fm-select-trigger{width:100%;min-height:54px;display:grid;grid-template-columns:minmax(0,1fr) 18px;align-items:center;gap:10px;padding:0 14px;border:1px solid rgba(255,122,36,.52);border-radius:14px;outline:none;text-align:left;color:#fff;background:radial-gradient(circle at 12% 0,rgba(255,133,49,.06),transparent 38%),linear-gradient(145deg,rgba(17,22,28,.98),rgba(3,7,11,.99));box-shadow:inset 0 1px 0 rgba(255,255,255,.035),0 7px 15px rgba(0,0,0,.13);cursor:pointer}#${ROOT_ID} .fm-select-trigger:focus-visible,#${ROOT_ID} .fm-select.is-open .fm-select-trigger{border-color:#ff914f;box-shadow:0 0 0 3px rgba(255,138,60,.14),0 10px 22px rgba(0,0,0,.18)}#${ROOT_ID} .fm-select-value{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:15px;font-weight:800}#${ROOT_ID} .fm-select-value.is-placeholder{color:rgba(214,224,235,.40);font-weight:680}#${ROOT_ID} .fm-select-chevron{width:10px;height:10px;justify-self:end;border-right:2px solid #ff8d49;border-bottom:2px solid #ff8d49;transform:rotate(45deg) translateY(-2px);transition:transform .16s ease}#${ROOT_ID} .fm-select.is-open .fm-select-chevron{transform:rotate(225deg) translate(-2px,-2px)}#${ROOT_ID} .fm-select-menu{display:none;margin-top:7px;padding:6px;border:1px solid rgba(255,122,36,.48);border-radius:14px;background:radial-gradient(circle at 15% 0,rgba(255,133,49,.12),transparent 36%),linear-gradient(145deg,rgba(17,22,28,.995),rgba(3,7,11,.998));box-shadow:0 20px 38px rgba(0,0,0,.48),inset 0 1px 0 rgba(255,255,255,.04);max-height:248px;overflow-y:auto;overscroll-behavior:contain}#${ROOT_ID} .fm-select.is-open .fm-select-menu{display:block}#${ROOT_ID} .fm-select-option{width:100%;min-height:46px;display:flex;align-items:center;padding:9px 11px;margin:2px 0;border:0;border-radius:10px;text-align:left;color:#eaf0f6;background:transparent;font-size:13px;font-weight:800;cursor:pointer}#${ROOT_ID} .fm-select-option:hover,#${ROOT_ID} .fm-select-option:focus-visible{outline:none;background:rgba(255,138,61,.13)}#${ROOT_ID} .fm-select-option.is-selected{background:linear-gradient(145deg,rgba(255,122,36,.28),rgba(95,42,17,.34));box-shadow:inset 0 0 0 1px rgba(255,138,61,.32)}#${ROOT_ID} .fm-select-menu::-webkit-scrollbar{width:5px}#${ROOT_ID} .fm-select-menu::-webkit-scrollbar-thumb{background:rgba(255,122,36,.42);border-radius:999px}
  	      #${ROOT_ID} .fm-scan-box{margin-top:13px;padding:13px;border-radius:14px;border:1px dashed rgba(232,115,57,.52);background:linear-gradient(145deg,rgba(204,102,51,.075),rgba(204,102,51,.025))}#${ROOT_ID} .fm-scan-btn{width:100%;min-height:54px;border-radius:13px;border:1px solid rgba(232,115,57,.61);background:radial-gradient(circle at 20% 0,rgba(255,160,95,.14),transparent 42%),linear-gradient(145deg,#a34c25,#602913);color:#fff;font-size:14px;font-weight:950;display:flex;align-items:center;justify-content:center;gap:9px;cursor:pointer;box-shadow:0 11px 22px rgba(80,31,12,.24)}#${ROOT_ID} .fm-scan-btn svg{width:23px;height:23px}#${ROOT_ID} .fm-scan-btn:disabled{opacity:.35}#${ROOT_ID} .fm-vehicle-picked{display:grid;grid-template-columns:46px minmax(0,1fr) auto;gap:10px;align-items:center}#${ROOT_ID} .fm-vehicle-picked .icon{width:46px;height:46px;border-radius:13px;display:grid;place-items:center;background:rgba(53,189,121,.13);color:#74dfa5}#${ROOT_ID} .fm-vehicle-picked .icon svg{width:25px;height:25px}#${ROOT_ID} .fm-vehicle-picked strong{display:block;font-size:14px}#${ROOT_ID} .fm-vehicle-picked span{display:block;margin-top:3px;color:var(--fif-muted);font-size:10px}#${ROOT_ID} .fm-change{border:0;background:none;color:#ef8b50;font-size:11px;font-weight:950;cursor:pointer}
  	      #${ROOT_ID} .fm-help{margin-top:6px;color:#91a2b6;font-size:10px;line-height:1.4}#${ROOT_ID} .fm-error{margin-top:13px;padding:11px 12px;border-radius:12px;border:1px solid rgba(223,91,91,.38);background:rgba(223,91,91,.10);color:#ffb4b4;font-size:11px;line-height:1.4}#${ROOT_ID} .fm-cost{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin-top:14px}#${ROOT_ID} .fm-cost div{padding:11px;border-radius:11px;background:rgba(0,0,0,.24);border:1px solid rgba(255,255,255,.04)}#${ROOT_ID} .fm-cost span{display:block;color:var(--fif-muted);font-size:8px;text-transform:uppercase;font-weight:950;letter-spacing:.05em}#${ROOT_ID} .fm-cost strong{display:block;margin-top:4px;font-size:14px}
  	      #${ROOT_ID} .fm-footer{position:absolute;z-index:9;left:0;right:0;bottom:0;padding:10px 13px calc(10px + env(safe-area-inset-bottom));border-top:1px solid var(--fif-line);background:rgba(7,12,17,.96);backdrop-filter:blur(18px);box-shadow:0 -12px 28px rgba(0,0,0,.20)}#${ROOT_ID} .fm-primary{width:100%;min-height:56px;border-radius:15px;border:1px solid rgba(232,115,57,.62);background:radial-gradient(circle at 22% 0,rgba(255,160,95,.15),transparent 42%),linear-gradient(145deg,#a64b23,#632a13);color:#fff;font-size:16px;font-weight:950;cursor:pointer;box-shadow:0 12px 24px rgba(106,43,17,.26)}#${ROOT_ID} .fm-primary:disabled{opacity:.38;cursor:default;filter:saturate(.55)}#${ROOT_ID} .fm-secondary{width:100%;min-height:50px;border-radius:14px;border:1px solid var(--fif-line);background:linear-gradient(145deg,#171e26,#0c1218);color:#fff;font-size:14px;font-weight:900;cursor:pointer}
  	      #${ROOT_ID} .fm-scanner{height:100%;display:flex;flex-direction:column;background:#020406}#${ROOT_ID} .fm-scanner-head{display:flex;align-items:center;gap:10px;padding:calc(12px + env(safe-area-inset-top)) 14px 12px;background:#070b10;border-bottom:1px solid rgba(255,255,255,.1)}#${ROOT_ID} .fm-scanner-head strong{flex:1;font-size:16px}#${ROOT_ID} .fm-video-wrap{position:relative;flex:1;min-height:0;background:#000;overflow:hidden}#${ROOT_ID} .fm-video{width:100%;height:100%;object-fit:cover}#${ROOT_ID} .fm-scan-frame{position:absolute;left:50%;top:50%;width:min(74vw,330px);height:min(74vw,330px);transform:translate(-50%,-50%);border:3px solid rgba(255,255,255,.9);border-radius:26px;box-shadow:0 0 0 999px rgba(0,0,0,.46),0 0 28px rgba(232,115,57,.38)}#${ROOT_ID} .fm-scanner-info{padding:12px 14px calc(14px + env(safe-area-inset-bottom));background:#070b10;text-align:center}#${ROOT_ID} .fm-scanner-info p{margin:0;color:#c4cfda}#${ROOT_ID} .fm-scanner-error{display:none;margin-top:8px;color:#ff9d9d;font-size:12px}#${ROOT_ID} .fm-scanner-error.visible{display:block}#${ROOT_ID} .fm-scanner-actions{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:10px}#${ROOT_ID} .fm-torch.is-on{border-color:#e89260;color:#ffd0b6}
  	      #${ROOT_ID} .fm-success{text-align:center;padding-top:24px}#${ROOT_ID} .fm-success-mark{width:86px;height:86px;margin:0 auto;border-radius:50%;display:grid;place-items:center;background:rgba(53,189,121,.14);border:1px solid rgba(53,189,121,.38);color:#82e8ad;box-shadow:0 0 35px rgba(53,189,121,.16)}#${ROOT_ID} .fm-success-mark svg{width:46px;height:46px}#${ROOT_ID} .fm-success h1{margin-top:17px}#${ROOT_ID} .fm-receipt{margin-top:17px;text-align:left}#${ROOT_ID} .fm-receipt-row{display:flex;justify-content:space-between;gap:14px;padding:10px 0;border-bottom:1px solid rgba(255,255,255,.07)}#${ROOT_ID} .fm-receipt-row span{color:var(--fif-muted);font-size:12px}#${ROOT_ID} .fm-receipt-row strong{text-align:right;font-size:13px}
  	      #${OPERATION_ID}{position:fixed;inset:0;z-index:2147483647;display:grid;place-items:center;padding:20px;background:rgba(0,0,0,.68);backdrop-filter:blur(7px)}#${OPERATION_ID} .fm-op{width:min(410px,100%);padding:24px;border-radius:20px;border:1px solid rgba(232,115,57,.42);background:radial-gradient(circle at 50% 0,rgba(232,115,57,.14),transparent 36%),linear-gradient(145deg,#151b22,#080d12);text-align:center;box-shadow:0 24px 70px rgba(0,0,0,.55)}#${OPERATION_ID} .fm-spinner{width:54px;height:54px;margin:0 auto;border-radius:50%;border:5px solid rgba(255,255,255,.12);border-top-color:#e7834f;animation:fmspin .85s linear infinite}#${OPERATION_ID} strong{display:block;margin-top:16px;font-size:17px}#${OPERATION_ID} p{margin-top:7px;color:#9cadbe;font-size:12px;line-height:1.45}#${OPERATION_ID}.is-error .fm-spinner{animation:none;border:0;background:rgba(223,91,91,.14);position:relative}#${OPERATION_ID}.is-error .fm-spinner:after{content:"!";position:absolute;inset:0;display:grid;place-items:center;color:#ff9c9c;font-size:30px;font-weight:950}#${OPERATION_ID}.is-success .fm-spinner{animation:none;border:0;background:rgba(53,189,121,.14);position:relative}#${OPERATION_ID}.is-success .fm-spinner:after{content:"✓";position:absolute;inset:0;display:grid;place-items:center;color:#82e8ad;font-size:30px;font-weight:950}#${OPERATION_ID} button{display:none;width:100%;min-height:48px;margin-top:16px;border-radius:13px;border:1px solid rgba(223,91,91,.42);background:#3b1717;color:#fff;font-weight:900;cursor:pointer}#${OPERATION_ID}.is-error button{display:block}
  	
  	      /* v1.2.0 simplified attendant layout */
  	      #${ROOT_ID} .fm-header{gap:9px;padding:calc(9px + env(safe-area-inset-top)) 11px 9px;background:#080d12}
  	      #${ROOT_ID} .fm-logo{width:40px;height:40px;flex-basis:40px;border-radius:10px}
  	      #${ROOT_ID} .fm-title small{display:none}
  	      #${ROOT_ID} .fm-title strong{margin:0;font-size:17px}
  	      #${ROOT_ID} .fm-title span{margin-top:2px;font-size:11px}
  	      #${ROOT_ID} .fm-logout{min-width:48px;height:42px;padding:0 11px;border:1px solid rgba(223,91,91,.45);border-radius:11px;background:#321515;color:#ffd0d0;display:flex;align-items:center;justify-content:center;gap:7px;font-size:11px;font-weight:950;cursor:pointer}
  	      #${ROOT_ID} .fm-logout svg{width:20px;height:20px;flex:0 0 20px}
  	      #${ROOT_ID} .fm-main{padding:13px 11px calc(90px + env(safe-area-inset-bottom))}
  	      #${ROOT_ID} .fm-intro{padding:3px 2px 5px}
  	      #${ROOT_ID} .fm-intro-row{display:grid;grid-template-columns:minmax(0,1fr) 92px;gap:11px;align-items:center}
  	      #${ROOT_ID} .fm-intro-copy{min-width:0}
  	      #${ROOT_ID} .fm-intro h1{margin:0;font-size:25px;line-height:1.1}
  	      #${ROOT_ID} .fm-intro p{margin-top:6px;font-size:13px}
  	      #${ROOT_ID} .fm-bowser-qr-button{width:92px;min-height:56px;padding:7px 6px;border:2px solid #ed7d38;border-radius:12px;background:linear-gradient(145deg,#171e26,#0a0f14);color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;cursor:pointer;box-shadow:0 9px 20px rgba(0,0,0,.28),inset 0 1px 0 rgba(255,255,255,.04)}
  	      #${ROOT_ID} .fm-bowser-qr-button svg{width:25px;height:25px;color:#ff9b5f}
  	      #${ROOT_ID} .fm-bowser-qr-button span{font-size:9px;font-weight:950;line-height:1;letter-spacing:.055em;white-space:nowrap}
  	      #${ROOT_ID} .fm-bowser-qr-button:active{transform:scale(.97)}
  	      #${ROOT_ID} .fm-company{margin-top:16px}
  	      #${ROOT_ID} .fm-company-head{padding:0 2px 7px}
  	      #${ROOT_ID} .fm-company-head strong{font-size:16px}
  	      #${ROOT_ID} .fm-tank{padding:12px;border-radius:14px;box-shadow:0 8px 20px rgba(0,0,0,.20)}
  	      #${ROOT_ID} .fm-tank-simple{display:grid;grid-template-columns:72px minmax(0,1fr);gap:11px;align-items:center}
  	      #${ROOT_ID} .fm-level-badge{height:72px;border-radius:13px;display:flex;flex-direction:column;align-items:center;justify-content:center;background:linear-gradient(145deg,#f4f7fa,#cbd3dc);color:#091118;border:5px solid rgba(204,102,51,.25)}
  	      #${ROOT_ID} .fm-level-badge strong{font-size:22px;line-height:1}
  	      #${ROOT_ID} .fm-level-badge span{margin-top:4px;font-size:9px;font-weight:950;letter-spacing:.08em}
  	      #${ROOT_ID} .fm-tank-copy{min-width:0}
  	      #${ROOT_ID} .fm-tank-name{font-size:20px}
  	      #${ROOT_ID} .fm-grade{font-size:14px}
  	      #${ROOT_ID} .fm-location-mini{font-size:11px;line-height:1.3}
  	      #${ROOT_ID} .fm-simple-stats{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:11px}
  	      #${ROOT_ID} .fm-simple-stat{padding:10px;border-radius:10px;background:#090f15;border:1px solid rgba(255,255,255,.07)}
  	      #${ROOT_ID} .fm-simple-stat span{display:block;color:#9aabba;font-size:10px;font-weight:850}
  	      #${ROOT_ID} .fm-simple-stat strong{display:block;margin-top:3px;font-size:16px}
  	      #${ROOT_ID} .fm-dispensers{margin-top:12px}
  	      #${ROOT_ID} .fm-section-label{font-size:11px;letter-spacing:.05em;color:#d7e0e9}
  	      #${ROOT_ID} .fm-dispenser-action{width:100%;min-height:67px;margin-top:8px;padding:9px 10px;border:1px solid rgba(232,115,57,.55);border-radius:12px;background:linear-gradient(145deg,#3c1d10,#1b110c);color:#fff;display:grid;grid-template-columns:42px minmax(0,1fr) auto;gap:10px;align-items:center;text-align:left;cursor:pointer}
  	      #${ROOT_ID} .fm-dispenser-icon{width:42px;height:42px;border-radius:10px;display:grid;place-items:center;background:rgba(232,115,57,.17);color:#f2a073}
  	      #${ROOT_ID} .fm-dispenser-icon svg{width:24px;height:24px}
  	      #${ROOT_ID} .fm-dispenser-copy{min-width:0}
  	      #${ROOT_ID} .fm-dispenser-copy strong{display:block;font-size:16px}
  	      #${ROOT_ID} .fm-dispenser-copy span{display:block;margin-top:3px;color:#c2ccd6;font-size:11px}
  	      #${ROOT_ID} .fm-dispenser-go{padding:8px 9px;border-radius:9px;background:#a54a22;font-size:11px;font-weight:950}
  	      #${ROOT_ID} .fm-card{padding:12px;border-radius:14px;box-shadow:0 8px 20px rgba(0,0,0,.18)}
  	      #${ROOT_ID} .fm-summary-top{align-items:center}
  	      #${ROOT_ID} .fm-summary-copy strong{font-size:19px}
  	      #${ROOT_ID} .fm-summary-copy span{font-size:12px}
  	      #${ROOT_ID} .fm-summary-numbers{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:10px}
  	      #${ROOT_ID} .fm-summary-number{padding:10px;border-radius:10px;background:#090f15;border:1px solid rgba(255,255,255,.07)}
  	      #${ROOT_ID} .fm-summary-number span{display:block;color:#9aabba;font-size:10px;font-weight:850}
  	      #${ROOT_ID} .fm-summary-number strong{display:block;margin-top:3px;font-size:16px}
  	      #${ROOT_ID} .fm-gate{grid-template-columns:44px minmax(0,1fr) auto;gap:10px}
  	      #${ROOT_ID} .fm-gate-icon{width:44px;height:44px}
  	      #${ROOT_ID} .fm-gate strong{font-size:15px}
  	      #${ROOT_ID} .fm-gate span{font-size:11px}
  	      #${ROOT_ID} .fm-step-title{display:flex;align-items:center;gap:9px;margin:4px 0 9px}
  	      #${ROOT_ID} .fm-step-number{width:30px;height:30px;flex:0 0 30px;border-radius:50%;display:grid;place-items:center;background:#a64b23;color:#fff;font-size:14px;font-weight:950}
  	      #${ROOT_ID} .fm-step-title strong{font-size:15px;line-height:1.2}
  	      #${ROOT_ID} .fm-step-block{margin-top:17px;padding-top:15px;border-top:1px solid rgba(255,255,255,.09)}
  	      #${ROOT_ID} .fm-mode-grid{grid-template-columns:1fr;gap:8px;margin-top:7px}
  	      #${ROOT_ID} .fm-mode{min-height:67px;padding:9px 12px;display:grid;grid-template-columns:42px minmax(0,1fr) 18px;gap:10px;align-items:center;justify-items:start;text-align:left;border-radius:12px}
  	      #${ROOT_ID} .fm-mode svg{width:27px;height:27px;justify-self:center}
  	      #${ROOT_ID} .fm-mode-copy{min-width:0}
  	      #${ROOT_ID} .fm-mode-copy strong{display:block;font-size:15px}
  	      #${ROOT_ID} .fm-mode-copy small{display:block;margin-top:3px;color:#9fadb9;font-size:11px;font-weight:700}
  	      #${ROOT_ID} .fm-mode-tick{width:15px;height:15px;border:2px solid rgba(255,255,255,.26);border-radius:50%}
  	      #${ROOT_ID} .fm-mode.is-active .fm-mode-tick{border:5px solid #ff9a60;background:#fff}
  	      #${ROOT_ID} .fm-simple-note{margin-top:11px;padding:11px;border-radius:10px;background:rgba(53,189,121,.09);border:1px solid rgba(53,189,121,.24);color:#bcebd1;font-size:12px;line-height:1.4}
  	      #${ROOT_ID} .fm-scan-box{margin-top:9px;padding:10px;border-radius:11px}
  	      #${ROOT_ID} .fm-scan-btn{min-height:60px;font-size:15px}
  	      #${ROOT_ID} .fm-field{margin-top:11px}
  	      #${ROOT_ID} .fm-field>span{margin:0 0 6px 1px;font-size:14px;font-weight:900}
  	      #${ROOT_ID} .fm-input{height:60px;border-radius:12px;font-size:18px;font-weight:800}
  	      #${ROOT_ID} textarea.fm-input{height:84px;min-height:84px}
  	      #${ROOT_ID} .fm-select-trigger{min-height:60px;border-radius:12px}
  	      #${ROOT_ID} .fm-select-value{font-size:17px}
  	      #${ROOT_ID} .fm-select-menu{max-height:290px}
  	      #${ROOT_ID} .fm-select-option{min-height:55px;font-size:15px}
  	      #${ROOT_ID} .fm-help{font-size:12px}
  	      #${ROOT_ID} .fm-error{font-size:13px;font-weight:750}
  	      #${ROOT_ID} .fm-footer{padding:9px 11px calc(9px + env(safe-area-inset-bottom))}
  	      #${ROOT_ID} .fm-primary{min-height:61px;border-radius:13px;font-size:18px}
  	      #${ROOT_ID} .fm-secondary{min-height:55px;font-size:15px}
  	      #${ROOT_ID} .fm-success{padding-top:14px}
  	      #${ROOT_ID} .fm-success h1{font-size:25px}
  	
  	      /* v1.4.0 one-question-at-a-time capture */
  	      #${ROOT_ID} .fm-wizard-main{padding-bottom:calc(96px + env(safe-area-inset-bottom))}
  	      #${ROOT_ID} .fm-capture-summary{padding:10px 12px}
  	      #${ROOT_ID} .fm-location-card{padding:9px 11px}
  	      #${ROOT_ID} .fm-wizard-card{margin-top:11px;padding:18px 14px 16px;min-height:310px;display:flex;flex-direction:column;justify-content:flex-start}
  	      #${ROOT_ID} .fm-question-kicker{display:inline-flex;align-self:flex-start;padding:6px 9px;border-radius:999px;background:rgba(232,115,57,.14);border:1px solid rgba(232,115,57,.32);color:#ffb082;font-size:11px;font-weight:950;letter-spacing:.08em}
  	      #${ROOT_ID} .fm-question-title{margin:15px 0 0;font-size:26px;line-height:1.12;letter-spacing:-.025em}
  	      #${ROOT_ID} .fm-question-copy{margin:8px 0 0;color:#aebbc8;font-size:14px;line-height:1.45}
  	      #${ROOT_ID} .fm-question-answer{margin-top:18px}
  	      #${ROOT_ID} .fm-question-answer>.fm-input{width:100%}
  	      #${ROOT_ID} .fm-answer-input{height:68px;font-size:24px;text-align:center;font-variant-numeric:tabular-nums}
  	      #${ROOT_ID} .fm-answer-textarea{height:122px;min-height:122px;text-align:left;font-size:17px}
  	      #${ROOT_ID} .fm-answer-help{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:9px;padding:10px 11px;border-radius:10px;background:#090f15;border:1px solid rgba(255,255,255,.07)}
  	      #${ROOT_ID} .fm-answer-help span{color:#93a4b3;font-size:12px;font-weight:800}
  	      #${ROOT_ID} .fm-answer-help strong{font-size:15px;text-align:right}
  	      #${ROOT_ID} .fm-question-error{margin-top:14px;padding:10px 11px;border-radius:10px;background:rgba(223,91,91,.10);border:1px solid rgba(223,91,91,.28)}
  	      #${ROOT_ID} .fm-review-list{overflow:hidden;border-radius:12px;border:1px solid rgba(255,255,255,.09);background:#090f15}
  	      #${ROOT_ID} .fm-review-row{display:grid;grid-template-columns:minmax(0,.8fr) minmax(0,1.2fr);gap:12px;padding:12px;border-bottom:1px solid rgba(255,255,255,.07)}
  	      #${ROOT_ID} .fm-review-row:last-child{border-bottom:0}
  	      #${ROOT_ID} .fm-review-row span{color:#96a6b5;font-size:12px;font-weight:800}
  	      #${ROOT_ID} .fm-review-row strong{text-align:right;font-size:14px;overflow-wrap:anywhere}
  	      #${ROOT_ID} .fm-footer-actions{display:grid;grid-template-columns:minmax(0,.42fr) minmax(0,1fr);gap:9px}
  	      #${ROOT_ID} .fm-footer-actions.single-back{grid-template-columns:1fr}
  	      #${ROOT_ID} .fm-footer-actions .fm-secondary,#${ROOT_ID} .fm-footer-actions .fm-primary{min-height:58px}
  	      #${ROOT_ID}.is-keyboard-open .fm-wizard-main{padding-bottom:18px}
  	      @media(max-height:620px){#${ROOT_ID} .fm-capture-summary{display:none}#${ROOT_ID} .fm-wizard-card{min-height:250px}#${ROOT_ID} .fm-location-card{margin-top:0}}
  	
  	      #${APP_MENU_ID}{position:fixed;z-index:2147483647;box-sizing:border-box;width:210px;overflow:hidden;padding:5px;color:#fff;border:1px solid rgba(204,102,51,.72);border-radius:13px;background:radial-gradient(circle at 16% -10%,rgba(204,102,51,.25),transparent 42%),repeating-radial-gradient(circle at 80% 118%,transparent 0 13px,rgba(204,102,51,.13) 14px 16px),linear-gradient(145deg,#1b1714 0%,#0b0d0d 58%,#050707 100%);box-shadow:0 18px 42px rgba(0,0,0,.58),0 0 0 1px rgba(0,0,0,.65) inset,0 0 18px rgba(204,102,51,.12);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;transform-origin:top right;animation:fmAppMenuIn 130ms ease-out both}
  	      #${APP_MENU_ID} .fm-app-option{display:flex;align-items:center;width:100%;min-height:38px;margin:0;padding:9px 11px;border:0;border-radius:8px;outline:0;color:#f5f5f5;background:transparent;cursor:pointer;text-align:left;font-size:13px;font-weight:900;letter-spacing:.01em;transition:color 120ms ease,background 120ms ease,box-shadow 120ms ease}
  	      #${APP_MENU_ID} .fm-app-option:hover,#${APP_MENU_ID} .fm-app-option:focus-visible{color:#fff;background:rgba(204,102,51,.22);box-shadow:inset 2px 0 0 #cc6633}
  	      #${APP_MENU_ID} .fm-app-option:disabled{cursor:wait;opacity:.55}
  	      #${APP_MENU_ID} .fm-app-option.logout{margin-top:4px;border-top:1px solid rgba(204,102,51,.26);border-radius:0 0 8px 8px;color:#ff8a3d}
  	      #${APP_MENU_ID} .fm-app-status{padding:6px 10px 7px;color:#ff8a3d;font-size:11px;font-weight:800;line-height:1.3}
  	      #${APP_MENU_ID} .fm-app-status.error{color:#ff5b45}
  	      @keyframes fmAppMenuIn{from{opacity:0;transform:translateY(-4px) scale(.98)}to{opacity:1;transform:translateY(0) scale(1)}}
  	
  	      #${DIALOG_ID}{position:fixed;inset:0;z-index:2147483647;display:grid;place-items:center;padding:18px;background:rgba(0,0,0,.76);backdrop-filter:blur(7px);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif}
  	      #${DIALOG_ID} .fm-dialog{width:min(390px,100%);padding:22px;border-radius:18px;border:1px solid rgba(223,91,91,.42);background:linear-gradient(145deg,#171c22,#080c10);color:#fff;text-align:center;box-shadow:0 26px 70px rgba(0,0,0,.58)}
  	      #${DIALOG_ID} .fm-dialog-icon{width:64px;height:64px;margin:0 auto;border-radius:50%;display:grid;place-items:center;background:rgba(223,91,91,.14);color:#ff9b9b}
  	      #${DIALOG_ID} .fm-dialog-icon svg{width:32px;height:32px}
  	      #${DIALOG_ID} h2{margin:14px 0 0;font-size:23px}
  	      #${DIALOG_ID} p{margin:8px 0 17px;color:#b8c3ce;font-size:14px;line-height:1.45}
  	      #${DIALOG_ID} button{width:100%;min-height:58px;border-radius:13px;font-size:15px;font-weight:950;cursor:pointer}
  	      #${DIALOG_ID} .fm-dialog-danger{border:1px solid rgba(223,91,91,.6);background:#7e2424;color:#fff}
  	      #${DIALOG_ID} .fm-dialog-stay{margin-top:9px;border:1px solid rgba(255,255,255,.13);background:#151c23;color:#fff}
  	      #${ROOT_ID}.is-keyboard-open .fm-logout span{display:none}
  	      @media(max-width:390px){#${ROOT_ID} .fm-logout{width:44px;min-width:44px;padding:0}#${ROOT_ID} .fm-logout span{display:none}}
  	      @keyframes fmspin{to{transform:rotate(360deg)}}
  	      @media(min-width:560px){#${ROOT_ID} .fm-grid2{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}}
  	      @media(max-width:380px){#${ROOT_ID} .fm-intro-row{grid-template-columns:minmax(0,1fr) 82px;gap:8px}#${ROOT_ID} .fm-bowser-qr-button{width:82px;min-height:54px}#${ROOT_ID} .fm-bowser-qr-button span{font-size:8px}#${ROOT_ID} .fm-mode-grid{grid-template-columns:1fr;gap:7px}#${ROOT_ID} .fm-mode{min-height:58px;flex-direction:row;justify-content:flex-start;padding:0 14px;font-size:11px}#${ROOT_ID} .fm-mode svg{width:22px;height:22px}#${ROOT_ID} .fm-cost{grid-template-columns:1fr}#${ROOT_ID} .fm-stats{grid-template-columns:1fr 1fr}#${ROOT_ID} .fm-stat:last-child{grid-column:1 / -1}}
  	    `;
  	    document.head.appendChild(style);
  	  }
  	
  	  const state = {
  	    screen: "dashboard",
  	    selectedCompanyId: "",
  	    selectedTankId: "",
  	    selectedBowserId: "",
  	    mode: "",
  	    contractorId: "",
  	    vehicle: null,
  	    vehicleObjectId: "",
  	    vehicleSource: "",
  	    application: "",
  	    applicationOther: "",
  	    driverId: "",
  	    driverOther: "",
  	    mileage: "",
  	    litres: "",
  	    meter: "",
  	    description: "",
  	    captureQuestion: "mode",
  	    questionError: "",
  	    baseBowserMeter: 0,
  	    gps: null,
  	    gpsBusy: false,
  	    gpsError: "",
  	    gpsStatus: "",
  	    locationHydrating: false,
  	    locationHydrationError: "",
  	    saving: false,
  	    success: null,
  	    scannerContext: "company",
  	    scannerReturnScreen: "capture",
  	    scannerStatus: "",
  	    scannerError: "",
  	    scannerTorchAvailable: false,
  	    scannerTorchOn: false,
  	    previousBodyOverflow: "",
  	    viewportBaselineHeight: 0,
  	    keyboardOpen: false,
  	    logoutInProgress: false,
  	    appSwitchInProgress: false,
  	    destroyed: false
  	  };
  	
  	  function gateHtml(tank) {
  	    const gate = tankGate(tank, state.gps);
  	    return '<div class="fm-gate ' + escapeAttr(gate.status) + '">' +
  	      '<div class="fm-gate-icon">' + icon("location") + '</div>' +
  	      '<div><strong>' + escapeHtml(gate.title) + '</strong><span>' +
  	      escapeHtml(gate.message) + '</span></div>' +
  	      (gate.linked
  	        ? '<button type="button" class="fm-retry" data-action="retry-gps" aria-label="Retry GPS">' + icon("retry") + '</button>'
  	        : '<span></span>') +
  	      '</div>';
  	  }
  	
  	
  	function renderHeader(title, subtitle, backAction) {
  	  return '<header class="fm-header">' +
  	    (backAction
  	      ? '<button type="button" class="fm-icon-btn" data-action="' + escapeAttr(backAction) + '" aria-label="Back">' + icon("back") + '</button>'
  	      : '<div class="fm-logo">' + suppliedLogo() + '</div>') +
  	    '<div class="fm-title"><strong>' + escapeHtml(title) +
  	    '</strong><span>' + escapeHtml(subtitle) + '</span></div>' +
  	    '<button type="button" class="fm-logout" data-action="logout" aria-label="Switch application or log out" aria-haspopup="menu" aria-expanded="false">' +
  	    icon("logout") + '<span>LOG OUT</span></button>' +
  	    '</header>';
  	}
  	
  	
  	function renderDashboard() {
  	  const companies = companyRows();
  	  const content = companies.map(function (company) {
  	    const tanks = companyTanks(company);
  	    const tankCards = tanks.map(function (tank, tankIndex) {
  	      const level = Math.max(0, Math.min(100, toNumber(tank.Level, 0)));
  	      const volume = toNumber(tank.Volume, 0);
  	      const capacity = toNumber(tank.Capacity, 0);
  	      const location = tankLocation(tank);
  	      const bowsers = tankBowsers(tank);
  	      const dispenserHtml = bowsers.length
  	        ? bowsers.map(function (bowser, bowserIndex) {
  	            return '<button type="button" class="fm-dispenser-action" data-action="open-capture" data-company="' +
  	              escapeAttr(objectIdOf(company)) + '" data-tank="' +
  	              escapeAttr(objectIdOf(tank)) + '" data-bowser="' +
  	              escapeAttr(objectIdOf(bowser)) + '">' +
  	              '<span class="fm-dispenser-icon">' + icon("fuel") + '</span>' +
  	              '<span class="fm-dispenser-copy"><strong>' +
  	              escapeHtml(bowserName(bowser, bowserIndex)) +
  	              '</strong><span>Meter ' + escapeHtml(formatNumber(bowser.Meter, 2)) +
  	              ' L</span></span><span class="fm-dispenser-go">START</span></button>';
  	          }).join("")
  	        : '<div class="fm-help">No pump is linked to this tank.</div>';
  	
  	      return '<article class="fm-tank" data-dashboard-tank-id="' +
  	        escapeAttr(objectIdOf(tank)) + '">' +
  	        '<div class="fm-tank-simple"><div class="fm-level-badge"><strong>' +
  	        escapeHtml(formatNumber(level, 0)) + '%</strong><span>FULL</span></div>' +
  	        '<div class="fm-tank-copy"><div class="fm-tank-name">' +
  	        escapeHtml(tankName(tank, tankIndex)) + '</div><div class="fm-grade">' +
  	        escapeHtml(tankGrade(tank)) + '</div><div class="fm-location-mini">' +
  	        icon("location") + '<span>' +
  	        escapeHtml(location ? locationName(location) : "No GPS restriction") +
  	        '</span></div></div></div>' +
  	        '<div class="fm-simple-stats"><div class="fm-simple-stat"><span>Fuel in tank</span><strong>' +
  	        escapeHtml(formatNumber(volume, 2)) + ' L</strong></div>' +
  	        '<div class="fm-simple-stat"><span>Tank size</span><strong>' +
  	        escapeHtml(formatNumber(capacity, 2)) + ' L</strong></div></div>' +
  	        '<div class="fm-dispensers"><div class="fm-section-label">CHOOSE PUMP</div>' +
  	        dispenserHtml + '</div></article>';
  	    }).join("");
  	
  	    return '<section class="fm-company"><div class="fm-company-head"><strong>' +
  	      escapeHtml(companyName(company)) + '</strong><span>' +
  	      tanks.length + ' tank' + (tanks.length === 1 ? '' : 's') +
  	      '</span></div><div class="fm-stack">' +
  	      (tankCards || '<div class="fm-card"><p>No tanks are linked to this company.</p></div>') +
  	      '</div></section>';
  	  }).join("");
  	
  	  return '<div class="fm-shell">' +
  	    renderHeader("Fuel Capture", userName(userRecord()), "") +
  	    '<main class="fm-main"><div class="fm-intro fm-intro-row"><div class="fm-intro-copy"><h1>Choose a tank</h1>' +
  	    '<p>Tap the pump you are using, or scan its Bowser QR.</p></div>' +
  	    '<button type="button" class="fm-bowser-qr-button" data-action="scan-bowser" aria-label="Scan Bowser QR">' +
  	    icon("qr") + '<span>SCAN BOWSER</span></button></div>' +
  	    (content || '<div class="fm-card" style="margin-top:14px"><p>No tanks are available for this user.</p></div>') +
  	    '</main></div>';
  	}
  	
  	
  	function modeButton(mode, label, iconName, disabled) {
  	  const help = mode === "vehicle"
  	    ? "Scan a company vehicle QR"
  	    : mode === "contractor"
  	      ? "Choose contractor, then scan QR"
  	      : "No vehicle needed";
  	  return '<button type="button" class="fm-mode ' +
  	    (state.mode === mode ? 'is-active' : '') +
  	    '" data-action="choose-mode" data-mode="' + escapeAttr(mode) + '"' +
  	    (disabled ? ' disabled' : '') + '>' + icon(iconName) +
  	    '<span class="fm-mode-copy"><strong>' + escapeHtml(label) +
  	    '</strong><small>' + escapeHtml(help) + '</small></span>' +
  	    '<span class="fm-mode-tick" aria-hidden="true"></span></button>';
  	}
  	
  	  function selectedOptionLabel(options, selected, placeholder) {
  	    for (let i = 0; i < options.length; i += 1) {
  	      if (String(options[i].value) === String(selected || "")) {
  	        return clean(options[i].label);
  	      }
  	    }
  	    return clean(placeholder || "Select");
  	  }
  	
  	  function themedSelectHtml(field, options, selected, placeholder) {
  	    const hasSelection = clean(selected) !== "";
  	    const label = selectedOptionLabel(options, selected, placeholder);
  	    const optionHtml = options.map(function (option) {
  	      const isSelected = String(option.value) === String(selected || "");
  	      return '<button type="button" class="fm-select-option' +
  	        (isSelected ? ' is-selected' : '') + '" role="option" aria-selected="' +
  	        (isSelected ? 'true' : 'false') + '" data-action="select-option" data-select-field="' +
  	        escapeAttr(field) + '" data-select-value="' + escapeAttr(option.value) + '">' +
  	        escapeHtml(option.label) + '</button>';
  	    }).join("");
  	
  	    return '<div class="fm-select" data-select-root="' + escapeAttr(field) + '">' +
  	      '<button type="button" class="fm-select-trigger" data-action="toggle-select" data-select-field="' +
  	      escapeAttr(field) + '" data-form-control aria-haspopup="listbox" aria-expanded="false">' +
  	      '<span class="fm-select-value' + (hasSelection ? '' : ' is-placeholder') + '">' +
  	      escapeHtml(label) + '</span><span class="fm-select-chevron" aria-hidden="true"></span></button>' +
  	      '<div class="fm-select-menu" role="listbox">' + optionHtml + '</div></div>';
  	  }
  	
  	
  	function captureQuestionSequence() {
  	  const questions = ["mode"];
  	
  	  if (state.mode === "contractor") questions.push("contractor");
  	
  	  if (state.mode === "vehicle" || state.mode === "contractor") {
  	    questions.push("vehicle", "application");
  	    if (state.application === "__other__") questions.push("applicationOther");
  	    questions.push("driver");
  	    if (state.driverId === "__other__") questions.push("driverOther");
  	    questions.push("mileage");
  	  }
  	
  	  if (state.mode) {
  	    questions.push("litres", "meter", "description", "review");
  	  }
  	
  	  return questions;
  	}
  	
  	
  	function captureQuestionNumber(question) {
  	  const sequence = captureQuestionSequence();
  	  const index = sequence.indexOf(question || state.captureQuestion);
  	  return index >= 0 ? index + 1 : 1;
  	}
  	
  	
  	function captureQuestionError(question) {
  	  const current = question || state.captureQuestion;
  	  const tank = selectedTank();
  	
  	  if (current === "mode") {
  	    const gate = tankGate(tank, state.gps);
  	    if (!gate.eligible) return gate.message;
  	    if (!state.mode) return "Choose who is getting the fuel.";
  	    return "";
  	  }
  	
  	  if (current === "contractor") {
  	    return selectedContractor() ? "" : "Choose the contractor.";
  	  }
  	
  	  if (current === "vehicle") {
  	    if (!state.vehicle || !state.vehicleObjectId) return "Scan the vehicle QR code.";
  	    if (!vehicleMatchesTankGrade(state.vehicle, tankGrade(tank))) {
  	      return "This vehicle cannot use " + tankGrade(tank) + ".";
  	    }
  	    return "";
  	  }
  	
  	  if (current === "application") {
  	    return state.application ? "" : "Choose what the fuel is being used for.";
  	  }
  	
  	  if (current === "applicationOther") {
  	    return clean(state.applicationOther) ? "" : "Type what the fuel is being used for.";
  	  }
  	
  	  if (current === "driver") {
  	    return state.driverId ? "" : "Choose the driver receiving the fuel.";
  	  }
  	
  	  if (current === "driverOther") {
  	    return clean(state.driverOther) ? "" : "Type the driver name.";
  	  }
  	
  	  if (current === "mileage") {
  	    const reading = toNumber(state.mileage, NaN);
  	    const oldReading = currentMileage(state.vehicle);
  	    const maxReading = maximumMileage(state.vehicle);
  	    if (Number.isNaN(reading)) return "Enter the vehicle mileage or operating hours.";
  	    if (oldReading !== null && reading < oldReading) {
  	      return "Reading cannot be lower than " + formatNumber(oldReading, 1) + ".";
  	    }
  	    if (maxReading !== null && reading > maxReading) {
  	      return "Reading cannot be higher than " + formatNumber(maxReading, 1) + ".";
  	    }
  	    return "";
  	  }
  	
  	  if (current === "litres") {
  	    const litres = toNumber(state.litres, NaN);
  	    if (Number.isNaN(litres) || litres <= 0) return "Enter the litres pumped.";
  	
  	    if ((state.mode === "vehicle" || state.mode === "contractor") && state.vehicle) {
  	      const capacity = vehicleTankCapacity(state.vehicle);
  	      if (capacity > 0 && litres > capacity) {
  	        return "Litres cannot exceed the vehicle tank size of " + formatNumber(capacity, 1) + " L.";
  	      }
  	    }
  	
  	    const available = toNumber(tank && tank.Volume, 0);
  	    if (litres > available) {
  	      return "The tank only has " + formatNumber(available, 2) + " L available.";
  	    }
  	    return "";
  	  }
  	
  	  if (current === "meter") {
  	    const litres = toNumber(state.litres, NaN);
  	    const meter = toNumber(state.meter, NaN);
  	    const meterLast = toNumber(state.baseBowserMeter, 0);
  	    if (Number.isNaN(meter)) return "Enter the bowser meter after pumping.";
  	    if (Number.isNaN(litres) || litres <= 0) return "Enter the litres first.";
  	    const expected = meterLast + litres;
  	    if (meter < meterLast) {
  	      return "Meter cannot be lower than " + formatNumber(meterLast, 2) + ".";
  	    }
  	    if (meter < expected - METER_TOLERANCE || meter > expected + METER_TOLERANCE) {
  	      return "Meter must be between " +
  	        formatNumber(expected - METER_TOLERANCE, 2) + " and " +
  	        formatNumber(expected + METER_TOLERANCE, 2) + ".";
  	    }
  	    return "";
  	  }
  	
  	  if (current === "review") {
  	    return validationError({ includeLocation: true });
  	  }
  	
  	  return "";
  	}
  	
  	
  	function nextCaptureQuestion(question) {
  	  const current = question || state.captureQuestion;
  	
  	  if (current === "mode") {
  	    if (state.mode === "contractor") return "contractor";
  	    if (state.mode === "vehicle") return "vehicle";
  	    return "litres";
  	  }
  	  if (current === "contractor") return "vehicle";
  	  if (current === "vehicle") return "application";
  	  if (current === "application") {
  	    return state.application === "__other__" ? "applicationOther" : "driver";
  	  }
  	  if (current === "applicationOther") return "driver";
  	  if (current === "driver") {
  	    return state.driverId === "__other__" ? "driverOther" : "mileage";
  	  }
  	  if (current === "driverOther") return "mileage";
  	  if (current === "mileage") return "litres";
  	  if (current === "litres") return "meter";
  	  if (current === "meter") return "description";
  	  if (current === "description") return "review";
  	  return "review";
  	}
  	
  	
  	function previousCaptureQuestion(question) {
  	  const current = question || state.captureQuestion;
  	  if (current === "contractor") return "mode";
  	  if (current === "vehicle") return state.mode === "contractor" ? "contractor" : "mode";
  	  if (current === "application") return "vehicle";
  	  if (current === "applicationOther") return "application";
  	  if (current === "driver") return state.application === "__other__" ? "applicationOther" : "application";
  	  if (current === "driverOther") return "driver";
  	  if (current === "mileage") return state.driverId === "__other__" ? "driverOther" : "driver";
  	  if (current === "litres") return state.mode === "other" ? "mode" : "mileage";
  	  if (current === "meter") return "litres";
  	  if (current === "description") return "meter";
  	  if (current === "review") return "description";
  	  return "mode";
  	}
  	
  	
  	function focusCurrentQuestionControl() {
  	  const root = document.getElementById(ROOT_ID);
  	  if (!root || state.screen !== "capture") return;
  	  const control = root.querySelector(".fm-wizard-card [data-form-control]");
  	  if (!control) return;
  	  const action = control.getAttribute("data-action");
  	  if (action === "toggle-select") {
  	    try { control.focus({ preventScroll: true }); } catch (_) {}
  	    keepControlVisible(control);
  	    return;
  	  }
  	  focusControl(control, false);
  	}
  	
  	
  	function moveToCaptureQuestion(question, focusControlAfter) {
  	  state.captureQuestion = question;
  	  state.questionError = "";
  	  render();
  	  if (focusControlAfter) {
  	    window.setTimeout(focusCurrentQuestionControl, 45);
  	  }
  	}
  	
  	
  	function advanceCaptureQuestion() {
  	  const error = captureQuestionError(state.captureQuestion);
  	  if (error) {
  	    state.questionError = error;
  	    refreshCaptureControls();
  	    return false;
  	  }
  	  moveToCaptureQuestion(nextCaptureQuestion(state.captureQuestion), true);
  	  return true;
  	}
  	
  	
  	function backCaptureQuestion() {
  	  state.questionError = "";
  	  moveToCaptureQuestion(previousCaptureQuestion(state.captureQuestion), false);
  	}
  	
  	
  	function renderPickedVehicle(context) {
  	  return '<div class="fm-scan-box"><div class="fm-vehicle-picked"><div class="icon">' +
  	    icon("check") + '</div><div><strong>' + escapeHtml(vehicleName(state.vehicle)) +
  	    '</strong><span>Vehicle QR accepted</span></div><button type="button" class="fm-change" data-action="' +
  	    (context === "contractor" ? "scan-contractor" : "scan-company") +
  	    '">SCAN AGAIN</button></div></div>';
  	}
  	
  	
  	function renderReviewSummary() {
  	  const contractor = selectedContractor();
  	  const vehicle = state.vehicle;
  	  const rows = [];
  	
  	  rows.push(["Transaction", state.mode === "other"
  	    ? "Other"
  	    : state.mode === "contractor"
  	      ? "Contractor Vehicle"
  	      : "Company Vehicle"]);
  	
  	  if (contractor) rows.push(["Contractor", companyName(contractor)]);
  	  if (vehicle) rows.push(["Vehicle", vehicleName(vehicle)]);
  	  if (state.mode !== "other") {
  	    rows.push(["Fuel used for", applicationValue()]);
  	    rows.push(["Driver", driverDisplayName()]);
  	    rows.push(["Mileage / Hours", clean(state.mileage)]);
  	  }
  	  rows.push(["Litres", formatNumber(state.litres, 2) + " L"]);
  	  rows.push(["Final bowser meter", formatNumber(state.meter, 2) + " L"]);
  	  if (clean(state.description)) rows.push(["Note", clean(state.description)]);
  	
  	  return '<div class="fm-review-list">' + rows.map(function (row) {
  	    return '<div class="fm-review-row"><span>' + escapeHtml(row[0]) +
  	      '</span><strong>' + escapeHtml(row[1]) + '</strong></div>';
  	  }).join("") + '</div>';
  	}
  	
  	
  	function renderCaptureQuestion() {
  	  const question = state.captureQuestion || "mode";
  	  const company = selectedCompany();
  	  const tank = selectedTank();
  	  const paraffin = isParaffinTankGrade(tankGrade(tank));
  	  const contractors = companyContractors(company);
  	  const questionNumber = captureQuestionNumber(question);
  	  let title = "";
  	  let copy = "";
  	  let body = "";
  	
  	  if (question === "mode") {
  	    title = "Who is getting the fuel?";
  	    copy = "Tap one choice.";
  	    body = '<div class="fm-mode-grid">' +
  	      modeButton("vehicle", "Company Vehicle", "qr", paraffin) +
  	      modeButton("contractor", "Contractor Vehicle", "contractor", paraffin || !contractors.length) +
  	      modeButton("other", "Other", "other", false) +
  	      '</div>' +
  	      (paraffin ? '<div class="fm-help">Paraffin is captured as Other.</div>' : '');
  	  }
  	
  	  if (question === "contractor") {
  	    title = "Which contractor?";
  	    copy = "Tap the contractor name.";
  	    const options = contractors.map(function (contractor) {
  	      return { value: objectIdOf(contractor), label: companyName(contractor) };
  	    });
  	    body = themedSelectHtml("contractorId", options, state.contractorId, "Tap to choose contractor");
  	  }
  	
  	  if (question === "vehicle") {
  	    title = "Scan the vehicle QR code";
  	    copy = "Use the QR tag fixed to the vehicle.";
  	    if (state.vehicle) {
  	      body = renderPickedVehicle(state.mode === "contractor" ? "contractor" : "company");
  	    } else {
  	      const contractorVehicleCount = state.mode === "contractor" && selectedContractor()
  	        ? companyVehicles(selectedContractor()).length
  	        : 1;
  	      body = '<div class="fm-scan-box"><button type="button" class="fm-scan-btn" data-action="' +
  	        (state.mode === "contractor" ? "scan-contractor" : "scan-company") + '"' +
  	        (contractorVehicleCount ? '' : ' disabled') + '>' +
  	        icon("camera") + ' SCAN VEHICLE QR</button>' +
  	        '<div class="fm-help">' +
  	        (contractorVehicleCount
  	          ? 'Point the rear camera at the QR tag.'
  	          : 'No vehicles are linked to this contractor. Go back and choose Other.') +
  	        '</div></div>';
  	    }
  	  }
  	
  	  if (question === "application") {
  	    title = "What is the fuel being used for?";
  	    copy = "Tap one answer.";
  	    const applications = [{ value: "__other__", label: "Other" }].concat(
  	      companyApplications(company).map(function (application) {
  	        return { value: application, label: application };
  	      })
  	    );
  	    body = themedSelectHtml("application", applications, state.application, "Tap to choose");
  	  }
  	
  	  if (question === "applicationOther") {
  	    title = "What is the fuel being used for?";
  	    copy = "Type the answer.";
  	    body = '<input class="fm-input" data-field="applicationOther" data-form-control ' +
  	      'enterkeyhint="next" autocomplete="off" value="' +
  	      escapeAttr(state.applicationOther) + '" placeholder="Type here">';
  	  }
  	
  	  if (question === "driver") {
  	    title = "Who is receiving the fuel?";
  	    copy = "Tap the driver name.";
  	    const drivers = companyEmployees(company).map(function (driver) {
  	      return { value: driverOptionValue(driver), label: userName(driver) };
  	    });
  	    drivers.unshift({ value: "__other__", label: "Other" });
  	    body = themedSelectHtml("driverId", drivers, state.driverId, "Tap to choose driver");
  	  }
  	
  	  if (question === "driverOther") {
  	    title = "What is the driver name?";
  	    copy = "Type the person receiving the fuel.";
  	    body = '<input class="fm-input" data-field="driverOther" data-form-control ' +
  	      'enterkeyhint="next" autocomplete="off" value="' +
  	      escapeAttr(state.driverOther) + '" placeholder="Driver name">';
  	  }
  	
  	  if (question === "mileage") {
  	    title = "What does the vehicle meter show now?";
  	    copy = "Enter the exact mileage or operating hours. Do not estimate.";
  	    const reading = currentMileage(state.vehicle);
  	    const max = maximumMileage(state.vehicle);
  	    body = '<input class="fm-input fm-answer-input" data-field="mileage" data-form-control ' +
  	      'type="number" inputmode="decimal" enterkeyhint="next" autocomplete="off" min="0" step="0.1" ' +
  	      'value="' + escapeAttr(state.mileage) + '" placeholder="Enter current reading">' +
  	      '<div class="fm-answer-help"><span>Last saved</span><strong>' +
  	      escapeHtml(reading === null ? "None" : formatNumber(reading, 1)) +
  	      '</strong></div>' +
  	      (max === null ? '' : '<div class="fm-answer-help"><span>Highest allowed</span><strong>' +
  	        escapeHtml(formatNumber(max, 1)) + '</strong></div>');
  	  }
  	
  	  if (question === "litres") {
  	    title = "How many litres were pumped?";
  	    copy = "Enter the litres shown on the pump.";
  	    body = '<input class="fm-input fm-answer-input" data-field="litres" data-form-control ' +
  	      'type="number" inputmode="decimal" enterkeyhint="next" autocomplete="off" min="0" step="0.01" ' +
  	      'value="' + escapeAttr(state.litres) + '" placeholder="0.00">' +
  	      (state.vehicle
  	        ? '<div class="fm-answer-help"><span>Vehicle tank size</span><strong>' +
  	          escapeHtml(formatNumber(vehicleTankCapacity(state.vehicle), 1)) + ' L</strong></div>'
  	        : '');
  	  }
  	
  	  if (question === "meter") {
  	    title = "What does the bowser meter show now?";
  	    copy = "Enter the full meter reading after pumping.";
  	    body = '<input class="fm-input fm-answer-input" data-field="meter" data-form-control ' +
  	      'type="number" inputmode="decimal" enterkeyhint="next" autocomplete="off" min="0" step="0.01" ' +
  	      'value="' + escapeAttr(state.meter) + '" placeholder="0.00">' +
  	      '<div class="fm-answer-help"><span>Meter before</span><strong>' +
  	      escapeHtml(formatNumber(state.baseBowserMeter, 2)) + ' L</strong></div>' +
  	      '<div class="fm-answer-help"><span>Expected meter</span><strong data-meter-help>—</strong></div>';
  	  }
  	
  	  if (question === "description") {
  	    title = "Add a note?";
  	    copy = "This is optional. Leave it blank when no note is needed.";
  	    body = '<textarea class="fm-input fm-answer-textarea" data-field="description" data-form-control ' +
  	      'enterkeyhint="done" autocomplete="off" placeholder="Optional note">' +
  	      escapeHtml(state.description) + '</textarea>';
  	  }
  	
  	  if (question === "review") {
  	    title = "Check the fuel details";
  	    copy = "Make sure everything is correct before saving.";
  	    body = renderReviewSummary();
  	  }
  	
  	  return '<section class="fm-card fm-wizard-card">' +
  	    '<div class="fm-question-kicker">QUESTION ' + escapeHtml(questionNumber) + '</div>' +
  	    '<h1 class="fm-question-title">' + escapeHtml(title) + '</h1>' +
  	    '<p class="fm-question-copy">' + escapeHtml(copy) + '</p>' +
  	    '<div class="fm-question-answer">' + body + '</div>' +
  	    '<div class="fm-error fm-question-error" data-question-error' +
  	    (state.questionError ? '' : ' style="display:none"') + '>' +
  	    escapeHtml(state.questionError) + '</div></section>';
  	}
  	
  	
  	function renderWizardFooter() {
  	  const question = state.captureQuestion || "mode";
  	  if (question === "mode") return "";
  	
  	  const back = '<button type="button" class="fm-secondary" data-action="wizard-back">BACK</button>';
  	
  	  if (question === "review") {
  	    const error = validationError({ includeLocation: true });
  	    return '<footer class="fm-footer"><div class="fm-footer-actions">' + back +
  	      '<button type="button" class="fm-primary" data-action="save-capture"' +
  	      (error || state.saving ? ' disabled' : '') + '>SAVE FUEL</button></div></footer>';
  	  }
  	
  	  const choiceOnly = question === "contractor" || question === "application" || question === "driver";
  	  if (question === "vehicle" && !state.vehicle) {
  	    return '<footer class="fm-footer"><div class="fm-footer-actions single-back">' + back + '</div></footer>';
  	  }
  	
  	  if (choiceOnly && !captureQuestionError(question)) {
  	    return '<footer class="fm-footer"><div class="fm-footer-actions">' + back +
  	      '<button type="button" class="fm-primary" data-action="wizard-next">CONTINUE</button></div></footer>';
  	  }
  	
  	  if (choiceOnly) {
  	    return '<footer class="fm-footer"><div class="fm-footer-actions single-back">' + back + '</div></footer>';
  	  }
  	
  	  return '<footer class="fm-footer"><div class="fm-footer-actions">' + back +
  	    '<button type="button" class="fm-primary" data-action="wizard-next">' +
  	    (question === "description" ? "REVIEW" : "NEXT") +
  	    '</button></div></footer>';
  	}
  	
  	
  	function renderCapture() {
  	  const company = selectedCompany();
  	  const tank = selectedTank();
  	  const bowser = selectedBowser();
  	  if (!company || !tank || !bowser) {
  	    state.screen = "dashboard";
  	    return renderDashboard();
  	  }
  	
  	  const paraffin = isParaffinTankGrade(tankGrade(tank));
  	  if (paraffin && state.mode !== "other") {
  	    state.mode = "other";
  	    state.captureQuestion = "litres";
  	    state.questionError = "";
  	  }
  	
  	  return '<div class="fm-shell">' +
  	    renderHeader("Capture Fuel", companyName(company), "back-dashboard") +
  	    '<main class="fm-main fm-wizard-main">' +
  	    '<section class="fm-card fm-capture-summary"><div class="fm-summary-top"><div class="fm-summary-icon">' +
  	    icon("fuel") + '</div><div class="fm-summary-copy"><strong>' +
  	    escapeHtml(tankName(tank, 0)) + '</strong><span>' +
  	    escapeHtml(tankGrade(tank) + " · " + bowserName(bowser, 0)) +
  	    '</span></div></div><div class="fm-summary-numbers">' +
  	    '<div class="fm-summary-number"><span>Bowser meter</span><strong>' +
  	    escapeHtml(formatNumber(state.baseBowserMeter, 2)) + ' L</strong></div>' +
  	    '<div class="fm-summary-number"><span>Fuel in tank</span><strong>' +
  	    escapeHtml(formatNumber(tank.Volume, 2)) + ' L</strong></div></div></section>' +
  	    '<section class="fm-card fm-location-card" data-location-card>' + gateHtml(tank) + '</section>' +
  	    renderCaptureQuestion() +
  	    '</main>' +
  	    renderWizardFooter() +
  	    '</div>';
  	}
  	
  	  function renderScanner() {
  	    const title = state.scannerContext === "bowser"
  	      ? "Scan Bowser QR"
  	      : state.scannerContext === "contractor"
  	        ? "Scan Contractor Vehicle"
  	        : "Scan Company Vehicle";
  	    return '<div class="fm-scanner"><div class="fm-scanner-head"><button type="button" class="fm-icon-btn" data-action="cancel-scanner">' +
  	      icon("back") + '</button><strong>' + escapeHtml(title) +
  	      '</strong><button type="button" class="fm-icon-btn fm-torch" data-action="scanner-torch" aria-pressed="false" hidden>' +
  	      icon("torch") + '<span style="display:none">Light</span></button></div>' +
  	      '<div class="fm-video-wrap"><video class="fm-video" data-qr-video autoplay muted playsinline></video><div class="fm-scan-frame"></div></div>' +
  	      '<div class="fm-scanner-info"><p data-scanner-status>' +
  	      escapeHtml(state.scannerStatus || scannerPromptText()) +
  	      '</p><div class="fm-scanner-error ' + (state.scannerError ? "visible" : "") +
  	      '" data-scanner-error>' + escapeHtml(state.scannerError) +
  	      '</div><div class="fm-scanner-actions"><button type="button" class="fm-secondary" data-action="retry-camera">Try Camera Again</button><button type="button" class="fm-secondary" data-action="cancel-scanner">Cancel</button></div></div></div>';
  	  }
  	
  	
  	function renderSuccess() {
  	  const success = state.success;
  	  const transaction = success && success.transaction;
  	  const vehicle = success && success.vehicle;
  	  return '<div class="fm-shell">' +
  	    renderHeader("Fuel Saved", companyName(selectedCompany()), "back-dashboard") +
  	    '<main class="fm-main"><div class="fm-success"><div class="fm-success-mark">' +
  	    icon("check") + '</div><h1>Fuel saved</h1><p>The tank and bowser meter are updated.</p></div>' +
  	    '<section class="fm-card fm-receipt"><div class="fm-receipt-row"><span>Tank</span><strong>' +
  	    escapeHtml(tankName(selectedTank(), 0)) + '</strong></div><div class="fm-receipt-row"><span>Pump</span><strong>' +
  	    escapeHtml(bowserName(selectedBowser(), 0)) + '</strong></div><div class="fm-receipt-row"><span>Vehicle / Other</span><strong>' +
  	    escapeHtml(vehicle ? vehicleName(vehicle) : "Other") + '</strong></div><div class="fm-receipt-row"><span>Litres</span><strong>' +
  	    escapeHtml(formatNumber(success ? success.litres : transaction && transaction.Litres, 2)) + ' L</strong></div>' +
  	    '<div class="fm-receipt-row"><span>Final meter</span><strong>' +
  	    escapeHtml(formatNumber(transaction && transaction.Meter, 2)) + ' L</strong></div>' +
  	    '</section><div class="fm-stack"><button type="button" class="fm-primary" data-action="save-another">CAPTURE NEXT VEHICLE</button>' +
  	    '<button type="button" class="fm-secondary" data-action="back-dashboard">CHANGE TANK</button></div></main></div>';
  	}
  	
  	  function render() {
  	    if (state.destroyed) return;
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return;
  	
  	    /*
  	     * root.innerHTML rebuilds .fm-main. A rebuilt scroll container starts at
  	     * scrollTop 0, which was the reason GPS updates and same-screen renders
  	     * appeared to throw the operator back to the top of the page.
  	     *
  	     * Preserve scroll only when we are rendering the SAME screen. A genuine
  	     * dashboard -> capture / scanner / success transition should still start
  	     * naturally at the top of its new screen.
  	     */
  	    const previousMain = root.querySelector(".fm-main");
  	    const previousScrollTop = previousMain ? previousMain.scrollTop : 0;
  	    const previousScreen = clean(root.getAttribute("data-fif-screen"));
  	    const preserveScroll = previousScreen === state.screen;
  	
  	    if (state.screen !== "scanner") stopQrScanner();
  	
  	    root.innerHTML = state.screen === "dashboard"
  	      ? renderDashboard()
  	      : state.screen === "capture"
  	        ? renderCapture()
  	        : state.screen === "scanner"
  	          ? renderScanner()
  	          : renderSuccess();
  	
  	    root.setAttribute("data-fif-screen", state.screen);
  	
  	    if (state.screen === "capture") refreshCaptureControls();
  	
  	    window.requestAnimationFrame(function () {
  	      if (preserveScroll) {
  	        const nextMain = root.querySelector(".fm-main");
  	        if (nextMain) {
  	          const maxScroll = Math.max(0, nextMain.scrollHeight - nextMain.clientHeight);
  	          nextMain.scrollTop = Math.max(0, Math.min(previousScrollTop, maxScroll));
  	        }
  	      }
  	      syncVisualViewport();
  	    });
  	  }
  	
  	  function refreshDashboardLocationLabels() {
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root || state.screen !== "dashboard") return;
  	
  	    companyRows().forEach(function (company) {
  	      companyTanks(company).forEach(function (tank) {
  	        const tankId = objectIdOf(tank);
  	        if (!tankId) return;
  	
  	        const card = root.querySelector(
  	          '[data-dashboard-tank-id="' + String(tankId).replace(/"/g, '\"') + '"]'
  	        );
  	        if (!card) return;
  	
  	        const locationText = card.querySelector(".fm-location-mini span");
  	        if (!locationText) return;
  	
  	        const location = tankLocation(tank);
  	        locationText.textContent = location
  	          ? locationName(location)
  	          : "No GPS restriction";
  	      });
  	    });
  	  }
  	
  	  function refreshLocationUi() {
  	    if (state.destroyed) return;
  	
  	    if (state.screen === "dashboard") {
  	      /*
  	       * GPS watchPosition can fire repeatedly. The old code called render()
  	       * here on every GPS sample, replacing the entire root and resetting the
  	       * dashboard .fm-main scroll position to zero. Dashboard GPS changes do
  	       * not require a full render, so update only the location labels.
  	       */
  	      refreshDashboardLocationLabels();
  	      return;
  	    }
  	
  	    if (state.screen !== "capture") return;
  	    const card = document.querySelector("#" + ROOT_ID + " [data-location-card]");
  	    const tank = selectedTank();
  	    if (card && tank) card.innerHTML = gateHtml(tank);
  	    refreshCaptureControls();
  	  }
  	
  	  function refreshCaptureControls() {
  	    if (state.screen !== "capture") return;
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return;
  	
  	    const questionErrorNode = root.querySelector("[data-question-error]");
  	    if (questionErrorNode) {
  	      questionErrorNode.textContent = state.questionError || "";
  	      questionErrorNode.style.display = state.questionError ? "block" : "none";
  	    }
  	
  	    const save = root.querySelector("[data-action='save-capture']");
  	    if (save) {
  	      const finalError = validationError({ includeLocation: true });
  	      save.disabled = !!finalError || state.saving;
  	      if (state.captureQuestion === "review" && finalError && !state.questionError) {
  	        state.questionError = finalError;
  	        if (questionErrorNode) {
  	          questionErrorNode.textContent = finalError;
  	          questionErrorNode.style.display = "block";
  	        }
  	      }
  	    }
  	
  	    const litres = toNumber(state.litres, 0);
  	    const meterHelp = root.querySelector("[data-meter-help]");
  	    if (meterHelp) {
  	      const expected = toNumber(state.baseBowserMeter, 0) + litres;
  	      meterHelp.textContent = litres > 0
  	        ? formatNumber(expected, 2) + " L"
  	        : "Enter litres first";
  	    }
  	  }
  	
  	  function closeThemedSelects(exceptField) {
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return;
  	    root.querySelectorAll("[data-select-root]").forEach(function (selectRoot) {
  	      const field = selectRoot.getAttribute("data-select-root");
  	      if (exceptField && field === exceptField) return;
  	      selectRoot.classList.remove("is-open");
  	      const trigger = selectRoot.querySelector(".fm-select-trigger");
  	      if (trigger) trigger.setAttribute("aria-expanded", "false");
  	    });
  	  }
  	
  	  function toggleThemedSelect(field) {
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return;
  	    const selectRoot = root.querySelector('[data-select-root="' + String(field).replace(/"/g, '\"') + '"]');
  	    if (!selectRoot) return;
  	    const willOpen = !selectRoot.classList.contains("is-open");
  	    closeThemedSelects(field);
  	    selectRoot.classList.toggle("is-open", willOpen);
  	    const trigger = selectRoot.querySelector(".fm-select-trigger");
  	    if (trigger) trigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
  	    if (willOpen) {
  	      window.setTimeout(function () {
  	        keepControlVisible(trigger || selectRoot);
  	      }, 30);
  	    }
  	  }
  	
  	  function visibleFormControls() {
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return [];
  	    return Array.from(root.querySelectorAll("[data-form-control]")).filter(function (control) {
  	      if (!control || control.disabled) return false;
  	      const style = window.getComputedStyle(control);
  	      if (style.display === "none" || style.visibility === "hidden") return false;
  	      return !!(control.offsetWidth || control.offsetHeight || control.getClientRects().length);
  	    });
  	  }
  	
  	  function controlField(control) {
  	    if (!control) return "";
  	    return clean(control.getAttribute("data-field") || control.getAttribute("data-select-field"));
  	  }
  	
  	  function keepControlVisible(control) {
  	    if (!control || !control.closest) return;
  	    const main = control.closest(".fm-main");
  	    if (!main) return;
  	    window.setTimeout(function () {
  	      if (!document.body.contains(control)) return;
  	      const mainRect = main.getBoundingClientRect();
  	      const controlRect = control.getBoundingClientRect();
  	      const topLimit = mainRect.top + 14;
  	      const bottomLimit = mainRect.bottom - 18;
  	      let delta = 0;
  	      if (controlRect.bottom > bottomLimit) delta = controlRect.bottom - bottomLimit + 18;
  	      else if (controlRect.top < topLimit) delta = controlRect.top - topLimit - 14;
  	      if (Math.abs(delta) > 1) {
  	        try { main.scrollBy({ top: delta, behavior: "smooth" }); }
  	        catch (_) { main.scrollTop += delta; }
  	      }
  	    }, 80);
  	  }
  	
  	  function focusControl(control, openSelect) {
  	    if (!control) return false;
  	    try { control.focus({ preventScroll: true }); }
  	    catch (_) { try { control.focus(); } catch (_) {} }
  	    keepControlVisible(control);
  	    if (openSelect && control.getAttribute("data-action") === "toggle-select") {
  	      toggleThemedSelect(control.getAttribute("data-select-field"));
  	    }
  	    return true;
  	  }
  	
  	  function focusFollowingControl(field) {
  	    const controls = visibleFormControls();
  	    let index = -1;
  	    for (let i = 0; i < controls.length; i += 1) {
  	      if (controlField(controls[i]) === field) {
  	        index = i;
  	        break;
  	      }
  	    }
  	    if (index >= 0 && controls[index + 1]) {
  	      return focusControl(controls[index + 1], true);
  	    }
  	    const active = document.activeElement;
  	    if (active && active.blur) active.blur();
  	    const main = document.querySelector("#" + ROOT_ID + " .fm-main");
  	    if (main) {
  	      try { main.scrollTo({ top: main.scrollHeight, behavior: "smooth" }); }
  	      catch (_) { main.scrollTop = main.scrollHeight; }
  	    }
  	    return false;
  	  }
  	
  	  function focusField(field, openSelect) {
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return false;
  	    const escaped = String(field || "").replace(/"/g, '\"');
  	    const control = root.querySelector('[data-field="' + escaped + '"]') ||
  	      root.querySelector('[data-select-field="' + escaped + '"][data-form-control]');
  	    return focusControl(control, !!openSelect);
  	  }
  	
  	  function syncVisualViewport() {
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root || state.destroyed) return;
  	    const viewport = window.visualViewport;
  	    const height = Math.max(240, Math.round(viewport ? viewport.height : window.innerHeight || document.documentElement.clientHeight || 600));
  	    const width = Math.max(240, Math.round(viewport ? viewport.width : window.innerWidth || document.documentElement.clientWidth || 360));
  	    const top = Math.max(0, Math.round(viewport ? viewport.offsetTop : 0));
  	    const left = Math.max(0, Math.round(viewport ? viewport.offsetLeft : 0));
  	    const active = document.activeElement;
  	    const activeIsFormControl = !!(active && root.contains(active) && active.hasAttribute && active.hasAttribute("data-form-control"));
  	
  	    if (!state.viewportBaselineHeight || !activeIsFormControl) {
  	      state.viewportBaselineHeight = Math.max(state.viewportBaselineHeight || 0, height);
  	      if (!activeIsFormControl && height > state.viewportBaselineHeight - 40) {
  	        state.viewportBaselineHeight = height;
  	      }
  	    }
  	
  	    const keyboardOpen = state.screen === "capture" && activeIsFormControl &&
  	      state.viewportBaselineHeight - height > 110;
  	    state.keyboardOpen = keyboardOpen;
  	    root.classList.toggle("is-keyboard-open", keyboardOpen);
  	    root.style.setProperty("--fif-vv-height", height + "px");
  	    root.style.setProperty("--fif-vv-width", width + "px");
  	    root.style.setProperty("--fif-vv-top", top + "px");
  	    root.style.setProperty("--fif-vv-left", left + "px");
  	    if (activeIsFormControl) keepControlVisible(active);
  	  }
  	
  	  function handleFocusIn(event) {
  	    const control = event.target && event.target.closest ? event.target.closest("[data-form-control]") : null;
  	    if (!control) return;
  	    closeThemedSelects(control.getAttribute("data-select-field") || "");
  	    window.setTimeout(function () {
  	      syncVisualViewport();
  	      keepControlVisible(control);
  	    }, 40);
  	  }
  	
  	  function handleFocusOut() {
  	    window.setTimeout(syncVisualViewport, 180);
  	  }
  	
  	  function handleKeyDown(event) {
  	    if (event.key !== "Enter") return;
  	    const control = event.target && event.target.closest ? event.target.closest("[data-form-control]") : null;
  	    if (!control) return;
  	    if (control.getAttribute("data-action") === "toggle-select") return;
  	    if (control.tagName === "TEXTAREA" && event.shiftKey) return;
  	    event.preventDefault();
  	    try { control.blur(); } catch (_) {}
  	    advanceCaptureQuestion();
  	    window.setTimeout(syncVisualViewport, 80);
  	  }
  	
  	  function selectThemedOption(field, value) {
  	    state[field] = value;
  	    state.questionError = "";
  	
  	    if (field === "contractorId") {
  	      state.vehicle = null;
  	      state.vehicleObjectId = "";
  	      state.vehicleSource = "";
  	      state.application = "";
  	      state.applicationOther = "";
  	      state.driverId = "";
  	      state.driverOther = "";
  	      state.mileage = "";
  	      state.litres = "";
  	      state.meter = "";
  	      state.description = "";
  	      moveToCaptureQuestion("vehicle", false);
  	      return;
  	    }
  	
  	    if (field === "application") {
  	      if (value !== "__other__") state.applicationOther = "";
  	      moveToCaptureQuestion(
  	        value === "__other__" ? "applicationOther" : "driver",
  	        value === "__other__"
  	      );
  	      return;
  	    }
  	
  	    if (field === "driverId") {
  	      if (value !== "__other__") state.driverOther = "";
  	      moveToCaptureQuestion(
  	        value === "__other__" ? "driverOther" : "mileage",
  	        true
  	      );
  	      return;
  	    }
  	
  	    render();
  	  }
  	
  	  function showOperation(message) {
  	    closeOperation();
  	    const overlay = document.createElement("div");
  	    overlay.id = OPERATION_ID;
  	    overlay.innerHTML = '<div class="fm-op"><div class="fm-spinner"></div><strong data-op-title>Working</strong><p data-op-message>' +
  	      escapeHtml(message || "Please wait…") + '</p><button type="button" data-op-close>Close</button></div>';
  	    document.body.appendChild(overlay);
  	    overlay.querySelector("[data-op-close]").onclick = closeOperation;
  	  }
  	
  	  function updateOperation(message) {
  	    const overlay = document.getElementById(OPERATION_ID);
  	    if (!overlay) return;
  	    const node = overlay.querySelector("[data-op-message]");
  	    if (node) node.textContent = message || "Working…";
  	  }
  	
  	  function completeOperation(message) {
  	    const overlay = document.getElementById(OPERATION_ID);
  	    if (!overlay) return;
  	    overlay.classList.add("is-success");
  	    const title = overlay.querySelector("[data-op-title]");
  	    const node = overlay.querySelector("[data-op-message]");
  	    if (title) title.textContent = "Saved";
  	    if (node) node.textContent = message || "Complete.";
  	  }
  	
  	  function failOperation(message) {
  	    let overlay = document.getElementById(OPERATION_ID);
  	    if (!overlay) {
  	      showOperation(message);
  	      overlay = document.getElementById(OPERATION_ID);
  	    }
  	    overlay.classList.add("is-error");
  	    const title = overlay.querySelector("[data-op-title]");
  	    const node = overlay.querySelector("[data-op-message]");
  	    if (title) title.textContent = "Cannot Save";
  	    if (node) node.textContent = message || "The operation failed.";
  	  }
  	
  	  function showOperationError(message) {
  	    showOperation(message);
  	    failOperation(message);
  	  }
  	
  	  function closeOperation() {
  	    const overlay = document.getElementById(OPERATION_ID);
  	    if (overlay) overlay.remove();
  	  }
  	
  	  function openCapture(companyId, tankId, bowserId) {
  	    state.selectedCompanyId = companyId;
  	    state.selectedTankId = tankId;
  	    state.selectedBowserId = bowserId;
  	    state.screen = "capture";
  	    state.locationHydrationError = "";
  	    resetTransactionDraft(false);
  	    const tank = selectedTank();
  	    render();
  	    hydrateTankLocation(tank);
  	  }
  	
  	
  	function closeApp() {
  	  if (state.destroyed) return;
  	  state.destroyed = true;
  	  stopQrScanner();
  	  stopGpsWatch();
  	  closeAppMenu();
  	  closeDialog(false);
  	  closeOperation();
  	  window.removeEventListener("resize", syncVisualViewport);
  	  window.removeEventListener("orientationchange", syncVisualViewport);
  	  if (window.visualViewport) {
  	    window.visualViewport.removeEventListener("resize", syncVisualViewport);
  	    window.visualViewport.removeEventListener("scroll", syncVisualViewport);
  	  }
  	  const root = document.getElementById(ROOT_ID);
  	  if (root) root.remove();
  	  document.body.style.overflow = state.previousBodyOverflow;
  	  if (window.__FIF_CLOSE_MOBILE_FUEL_CAPTURE__ === closeApp) {
  	    window.__FIF_CLOSE_MOBILE_FUEL_CAPTURE__ = null;
  	  }
  	}
  	
  	  function chooseMode(mode) {
  	    const tank = selectedTank();
  	    const gate = tankGate(tank, state.gps);
  	
  	    if (!gate.eligible) {
  	      state.questionError = gate.message;
  	      refreshCaptureControls();
  	      return;
  	    }
  	
  	    if (isParaffinTankGrade(tankGrade(tank)) && mode !== "other") return;
  	
  	    state.mode = mode;
  	    state.contractorId = "";
  	    state.vehicle = null;
  	    state.vehicleObjectId = "";
  	    state.vehicleSource = "";
  	    state.application = "";
  	    state.applicationOther = "";
  	    state.driverId = "";
  	    state.driverOther = "";
  	    state.mileage = "";
  	    state.litres = "";
  	    state.meter = "";
  	    state.description = "";
  	    state.questionError = "";
  	
  	    state.captureQuestion = mode === "contractor"
  	      ? "contractor"
  	      : mode === "vehicle"
  	        ? "vehicle"
  	        : "litres";
  	
  	    render();
  	    window.setTimeout(focusCurrentQuestionControl, 45);
  	  }
  	
  	  function handleClick(event) {
  	    const root = document.getElementById(ROOT_ID);
  	    const button = event.target.closest("[data-action]");
  	    if (!root || !root.contains(event.target)) return;
  	    if (!button) {
  	      closeThemedSelects("");
  	      return;
  	    }
  	    const action = button.getAttribute("data-action");
  	    if (action === "toggle-select") {
  	      event.preventDefault();
  	      toggleThemedSelect(button.getAttribute("data-select-field"));
  	      return;
  	    }
  	    if (action === "select-option") {
  	      event.preventDefault();
  	      selectThemedOption(
  	        button.getAttribute("data-select-field"),
  	        button.getAttribute("data-select-value")
  	      );
  	      return;
  	    }
  	    closeThemedSelects("");
  	    if (action === "logout") {
  	      handleLogoutButton();
  	      return;
  	    }
  	    if (action === "close-app") return closeApp();
  	    if (action === "back-dashboard") {
  	      stopQrScanner();
  	      state.screen = "dashboard";
  	      state.success = null;
  	      render();
  	      return;
  	    }
  	    if (action === "open-capture") {
  	      openCapture(
  	        button.getAttribute("data-company"),
  	        button.getAttribute("data-tank"),
  	        button.getAttribute("data-bowser")
  	      );
  	      return;
  	    }
  	    if (action === "choose-mode") return chooseMode(button.getAttribute("data-mode"));
  	    if (action === "scan-bowser") return openScanner("bowser");
  	    if (action === "scan-company") return openScanner("company");
  	    if (action === "scan-contractor") return openScanner("contractor");
  	    if (action === "cancel-scanner") {
  	      stopQrScanner();
  	      state.screen = state.scannerReturnScreen ||
  	        (state.scannerContext === "bowser" ? "dashboard" : "capture");
  	      render();
  	      return;
  	    }
  	    if (action === "retry-camera") return startQrScanner();
  	    if (action === "scanner-torch") return toggleScannerTorch();
  	    if (action === "retry-gps") return refreshGps();
  	    if (action === "wizard-next") return advanceCaptureQuestion();
  	    if (action === "wizard-back") return backCaptureQuestion();
  	    if (action === "save-capture") {
  	      if (state.captureQuestion !== "review") return;
  	      return saveCapture();
  	    }
  	    if (action === "save-another") {
  	      resetTransactionDraft(false);
  	      state.screen = "capture";
  	      render();
  	    }
  	  }
  	
  	  function handleInput(event) {
  	    const field = event.target.getAttribute("data-field");
  	    if (!field) return;
  	    state[field] = event.target.value;
  	    state.questionError = "";
  	    refreshCaptureControls();
  	  }
  	
  	  if (!APP_DATA || !userRecord()) {
  	    throw new Error("App Data with AppData.User is required.");
  	  }
  	  if (!DB) {
  	    throw new Error("Backendless is not available.");
  	  }
  	
  	  const existing = document.getElementById(ROOT_ID);
  	  if (existing && typeof existing.__fifCleanup === "function") {
  	    try { existing.__fifCleanup(); } catch (_) {}
  	  } else if (existing) {
  	    existing.remove();
  	  }
  	
  	  injectStyles();
  	  const root = document.createElement("div");
  	  root.id = ROOT_ID;
  	  root.__fifCleanup = closeApp;
  	  state.previousBodyOverflow = document.body.style.overflow;
  	  document.body.style.overflow = "hidden";
  	  document.body.appendChild(root);
  	  root.addEventListener("click", handleClick);
  	  root.addEventListener("input", handleInput);
  	  root.addEventListener("change", handleInput);
  	  root.addEventListener("keydown", handleKeyDown);
  	  root.addEventListener("focusin", handleFocusIn);
  	  root.addEventListener("focusout", handleFocusOut);
  	  window.addEventListener("resize", syncVisualViewport);
  	  window.addEventListener("orientationchange", syncVisualViewport);
  	  if (window.visualViewport) {
  	    window.visualViewport.addEventListener("resize", syncVisualViewport);
  	    window.visualViewport.addEventListener("scroll", syncVisualViewport);
  	  }
  	  window.__FIF_CLOSE_MOBILE_FUEL_CAPTURE__ = closeApp;
  	
  	  state.viewportBaselineHeight = Math.max(
  	    window.visualViewport ? window.visualViewport.height : 0,
  	    window.innerHeight || 0,
  	    document.documentElement.clientHeight || 0
  	  );
  	  render();
  	  syncVisualViewport();
  	  if (companyRows().some(function (company) {
  	    return companyTanks(company).some(function (tank) {
  	      return tankLocationLoaded(tank) && !!tankLocation(tank);
  	    });
  	  })) startGpsWatch();
  	
  	  return {
  	    version: VERSION,
  	    close: closeApp,
  	    refreshGps: refreshGps,
  	    openCapture: openCapture,
  	    saveCapture: saveCapture,
  	    logout: logoutUser,
  	    render: render,
  	    state: state
  	  };
  	})();

  })(___arguments.context.appData, 'data:image/png;base64,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');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Login/components/56086b77a5086448baf8c505540ecd04/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_f916759a51c43a42ab0bb3fb84384b1e'](___arguments.context.pageData, ___arguments.context.appData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56086b77a5086448baf8c505540ecd04')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/0ecafbb363187e182e7af0e8371d6231/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(___arguments.context.pageData, 'Error'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Login/components/7a58564860983ff88e51ddbbbda86998/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 13) {
    await BackendlessUI.Functions.Custom['fn_f916759a51c43a42ab0bb3fb84384b1e'](___arguments.context.pageData, ___arguments.context.appData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56086b77a5086448baf8c505540ecd04')));
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/Login/components/9bbc3a5845f156287b584f387b686633/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 13) {
    await BackendlessUI.Functions.Custom['fn_f916759a51c43a42ab0bb3fb84384b1e'](___arguments.context.pageData, ___arguments.context.appData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56086b77a5086448baf8c505540ecd04')));
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/Login/components/c4f5db4b79ab386d38bf99882412b878/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_302f8a0eaf0351f7bd6ef7c44ea2db0e'](___arguments.value, (getObjectProperty(___arguments.context.appData, 'User')), ___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Login/components/2068e77427bc18482ac90c1881f8a6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((new Date()).valueOf());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/ef080cb8d42cb83876181b35e6774d88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var User, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(___arguments.context.pageData, 'Username')))) || (getObjectProperty(___arguments.context.pageData, 'Username')) == '') {
    ___arguments.context.pageData['Error'] = 'Please Enter a valid Username';
  } else {
    try {
      User = (
          await Backendless.Data.of( Backendless.User ).findById((getObjectProperty(___arguments.context.pageData, 'Username')))
      );

    } catch (error) {
      console.log(error);

    } finally {
      ___arguments.context.pageData['Error'] = 'Please Enter a valid Username';

    }
    if (User) {
      ___arguments.context.pageData['User'] = User;
      try {
        delete ___arguments.context.pageData['Error'];

      } catch (error) {
        console.log(error);

      }
      ___arguments.context.pageData['Code'] = (mathRandomInt(10000, 99999));
      await Backendless.Messaging.sendEmail('FIF Forgot Password', new Backendless.Bodyparts({ textmessage: (String('Your Code is ') + String(getObjectProperty(___arguments.context.pageData, 'Code'))) }), ensureArray([(getObjectProperty(User, 'email'))]), undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c33eee78bc480578af283429554eb9a6', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/a2e2bb68285859e42968e988fcbd3126/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value > 9999) {
    if (___arguments.value < 100000) {
      if (___arguments.value == (getObjectProperty(___arguments.context.pageData, 'Code'))) {
        try {
          delete ___arguments.context.pageData['Error'];

        } catch (error) {

        }
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('20c46e1d40c88b714a18534856c8cf28', true);
      } else {
        ___arguments.context.pageData['Error'] = 'Incorrect Pin';
      }
    } else {
      ___arguments.context.pageData['Error'] = 'Incorrect Pin';
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Login/components/20c46e1d40c88b714a18534856c8cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.UserService.restorePassword((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ID')));
  ___arguments.context.pageData['Error'] = 'Your New Password has been Emailed to you';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c33eee78bc480578af283429554eb9a6', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await (async function(App, Page) {
  	/*
  	 * Fleet In Form - Login As User Receiver V1.1.0
  	 * Backendless UI Builder Custom Code
  	 *
  	 * Install:
  	 *   Run this code when the Login page opens.
  	 *
  	 * Inputs:
  	 *   Page - Login Page Data
  	 *   App  - App Data
  	 *
  	 * Normal username/password login remains unchanged. This receiver activates only when
  	 * the Login URL contains the fifmImpersonation nonce created by the FIFM Manager.
  	 *
  	 * Important:
  	 *   The target session is deliberately not persisted with stayLoggedIn=true.
  	 *   Browser persistent storage is shared across tabs; persisting the target session
  	 *   would overwrite the FIFM Manager's saved login. The new tab keeps its own live
  	 *   Backendless session until it is closed or reloaded.
  	 */

  	return await (async function FIFLoginAsUserReceiverV1_1_0() {
  	  "use strict";

  	  const READY_MESSAGE = "FIFM_IMPERSONATION_READY";
  	  const PAYLOAD_MESSAGE = "FIFM_IMPERSONATION_PAYLOAD";
  	  const COMPLETE_MESSAGE = "FIFM_IMPERSONATION_COMPLETE";
  	  const ERROR_MESSAGE = "FIFM_IMPERSONATION_ERROR";

  	  const TYRES_FUNCTION_ID = "fn_d91c5dbed1a614198a69238eaf0de643";
  	  const ROUTE_FUNCTION_ID = "fn_302f8a0eaf0351f7bd6ef7c44ea2db0e";

  	  function readArgument(name, lowerName, index) {
  	    try {
  	      if (typeof ___arguments !== "undefined" && ___arguments) {
  	        if (___arguments[name] !== undefined) return ___arguments[name];
  	        if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	        if (___arguments[index] !== undefined) return ___arguments[index];
  	      }
  	    } catch (_) {}

  	    return undefined;
  	  }

  	  const PAGE_DATA =
  	    (typeof Page !== "undefined" ? Page : undefined) ||
  	    readArgument("Page", "page", 0) ||
  	    {};

  	  const APP_INPUT =
  	    (typeof App !== "undefined" ? App : undefined) ||
  	    readArgument("App", "app", 1) ||
  	    {};

  	  const CONTEXT = (() => {
  	    try {
  	      return typeof ___arguments !== "undefined" && ___arguments
  	        ? ___arguments.context || null
  	        : null;
  	    } catch (_) {
  	      return null;
  	    }
  	  })();

  	  function isDataObject(value) {
  	    return !!value && typeof value === "object";
  	  }

  	  function collectAppDataTargets() {
  	    const targets = [];

  	    function add(value) {
  	      if (!isDataObject(value)) return;
  	      if (targets.indexOf(value) === -1) targets.push(value);
  	    }

  	    try { add(CONTEXT && CONTEXT.appData); } catch (_) {}
  	    try { add(APP_INPUT && APP_INPUT.data); } catch (_) {}
  	    try { add(APP_INPUT); } catch (_) {}
  	    try { add(BackendlessUI && BackendlessUI.App && BackendlessUI.App.data); } catch (_) {}
  	    try {
  	      if (typeof window !== "undefined" && window.AppData) {
  	        add(window.AppData.data);
  	        add(window.AppData);
  	      }
  	    } catch (_) {}

  	    return targets;
  	  }

  	  function getPrimaryAppData() {
  	    const targets = collectAppDataTargets();
  	    return targets.length ? targets[0] : {};
  	  }

  	  function writeAppDataProperty(name, value) {
  	    const targets = collectAppDataTargets();

  	    targets.forEach(target => {
  	      try { target[name] = value; } catch (_) {}
  	    });

  	    return getPrimaryAppData();
  	  }

  	  function refreshAppData() {
  	    try {
  	      if (typeof BackendlessUI !== "undefined" && BackendlessUI.App) {
  	        if (typeof BackendlessUI.App.refresh === "function") {
  	          BackendlessUI.App.refresh();
  	        }
  	      }
  	    } catch (_) {}
  	  }

  	  async function flushAppData() {
  	    refreshAppData();
  	    await Promise.resolve();
  	    await new Promise(resolve => setTimeout(resolve, 80));

  	    if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
  	      await new Promise(resolve => window.requestAnimationFrame(() => resolve()));
  	      await new Promise(resolve => window.requestAnimationFrame(() => resolve()));
  	    }

  	    refreshAppData();
  	  }

  	  async function waitForAppUser(userId, timeoutMs) {
  	    const expected = clean(userId);
  	    const started = Date.now();
  	    const timeout = Number(timeoutMs) || 5000;

  	    while (Date.now() - started < timeout) {
  	      const targets = collectAppDataTargets();
  	      const ready = targets.some(target => {
  	        const user = target && target.User;
  	        return !!user && (!expected || clean(user.objectId) === expected);
  	      });

  	      if (ready) return getPrimaryAppData();
  	      await new Promise(resolve => setTimeout(resolve, 50));
  	    }

  	    throw new Error("App Data did not accept the impersonated User before routing.");
  	  }

  	  function clean(value) {
  	    return value === undefined || value === null ? "" : String(value).trim();
  	  }

  	  function splitApps(value) {
  	    if (Array.isArray(value)) {
  	      return value.map(clean).filter(Boolean);
  	    }

  	    return clean(value)
  	      .split(/[;,|]/)
  	      .map(item => item.trim())
  	      .filter(Boolean);
  	  }

  	  function chooseLaunchApp(value, requested) {
  	    const apps = splitApps(value);
  	    const supported = ["Office", "Road", "Bowser"];
  	    const requestedClean = clean(requested);

  	    if (
  	      requestedClean &&
  	      supported.some(item => item.toLowerCase() === requestedClean.toLowerCase()) &&
  	      apps.some(item => item.toLowerCase() === requestedClean.toLowerCase())
  	    ) {
  	      return supported.find(
  	        item => item.toLowerCase() === requestedClean.toLowerCase()
  	      );
  	    }

  	    for (let index = 0; index < supported.length; index += 1) {
  	      if (
  	        apps.some(
  	          item => item.toLowerCase() === supported[index].toLowerCase()
  	        )
  	      ) {
  	        return supported[index];
  	      }
  	    }

  	    return "";
  	  }

  	  function safePost(type, nonce, extra) {
  	    try {
  	      if (!window.opener || window.opener.closed) return;

  	      window.opener.postMessage(
  	        Object.assign(
  	          {
  	            type,
  	            nonce
  	          },
  	          extra || {}
  	        ),
  	        window.location.origin
  	      );
  	    } catch (_) {}
  	  }

  	  function clearNonceFromUrl() {
  	    try {
  	      const url = new URL(window.location.href);
  	      url.searchParams.delete("fifmImpersonation");
  	      window.history.replaceState({}, document.title, url.toString());
  	    } catch (_) {}
  	  }

  	  function setLoginPageState(session, message) {
  	    try {
  	      PAGE_DATA.Username = clean(session && session.identity);
  	      PAGE_DATA.Password = "";
  	      PAGE_DATA.Remember = false;
  	      PAGE_DATA.Error = "";
  	      PAGE_DATA["Login Message"] = clean(message);
  	    } catch (_) {}

  	    try {
  	      if (typeof BackendlessUI !== "undefined" && BackendlessUI.App) {
  	        BackendlessUI.App.refresh();
  	      }
  	    } catch (_) {}
  	  }

  	  function relationPaths() {
  	    return [
  	      "Companies.Locations.Jobs",
  	      "Companies.Locations.Fields.Segments",
  	      "Companies.Locations.Fields.Rings",
  	      "Companies.Routes",
  	      "Companies.Trailers",
  	      "Companies.Contractors",
  	      "Companies.Customers",
  	      "Companies.Customers.Locations.Fields",
  	      "Companies.Customers.Locations.Segments",
  	      "Companies.Customers.Locations.Rings",
  	      "Companies.Contractors.Tractors",
  	      "Companies.Tractors.ViewC.Conductor1",
  	      "Companies.Tractors.ViewC.Conductor2",
  	      "Companies.Tractors.ViewC.Driver1",
  	      "Companies.Tractors.ViewC.Driver2",
  	      "Companies.Tractors.ViewC.Fuel",
  	      "Companies.Tractors.ViewC.Loads",
  	      "Companies.Tractors.ViewC.Trailer1",
  	      "Companies.Tractors.ViewC.Trailer2",
  	      "Companies.Tractors.ViewC.Trailer3",
  	      "Companies.Tractors.ViewC.Maintenance",
  	      "Companies.Tractors.Maintenance",
  	      "Companies.Tractors.Tyres",
  	      "Tractor",
  	      "Wages_Payslip_Current",
  	      "Wages_Payslip_Historical",
  	      "Companies.Tanks.Location",
  	      "Companies.Tanks.FuelIn",
  	      "Companies.Tanks.Bowsers.ViewC.FuelOut",
  	      "Companies.Tanks.Bowsers.ViewH.FuelOut",
  	      "Companies.Tanks.ViewC.FuelIn",
  	      "Companies.Tanks.ViewH.FuelIn",
  	      "Companies.Employees"
  	    ];
  	  }

  	  async function hydrateAppUser(userId) {
  	    const query = Backendless.DataQueryBuilder.create()
  	      .setWhereClause("objectId = '" + clean(userId).replace(/'/g, "''") + "'")
  	      .setRelated(relationPaths())
  	      .setRelationsDepth(10)
  	      .setRelationsPageSize(100)
  	      .setPageSize(1);

  	    const rows = await Backendless.Data.of("Users").find(query);
  	    const fullUser = Array.isArray(rows) ? rows[0] : null;

  	    if (!fullUser) {
  	      throw new Error("The target user could not be loaded after authentication.");
  	    }

  	    writeAppDataProperty("User", fullUser);
  	    await flushAppData();

  	    const tyreLoader =
  	      typeof BackendlessUI !== "undefined" &&
  	      BackendlessUI.Functions &&
  	      BackendlessUI.Functions.Custom &&
  	      BackendlessUI.Functions.Custom[TYRES_FUNCTION_ID];

  	    if (typeof tyreLoader === "function") {
  	      const companies = Array.isArray(fullUser.Companies)
  	        ? fullUser.Companies
  	        : [];

  	      for (let index = 0; index < companies.length; index += 1) {
  	        const company = companies[index];

  	        try {
  	          company.Tyres = await tyreLoader(
  	            "Tyres",
  	            "Company_ID = '" + clean(company.objectId).replace(/'/g, "''") + "'",
  	            null
  	          );
  	        } catch (tyreError) {
  	          console.warn(
  	            "[FIF Login As User] Tyres could not be loaded for Company.",
  	            {
  	              companyId: clean(company && company.objectId),
  	              error: tyreError
  	            }
  	          );
  	        }
  	      }
  	    }

  	    // Tyres are added after the first assignment, so reassign the completed object
  	    // to every known App Data target before any page navigation begins.
  	    writeAppDataProperty("User", fullUser);
  	    await flushAppData();
  	    await waitForAppUser(userId, 5000);

  	    return fullUser;
  	  }

  	  async function waitForCustomFunction(functionId, timeoutMs) {
  	    const started = Date.now();
  	    const timeout = Number(timeoutMs) || 5000;

  	    while (Date.now() - started < timeout) {
  	      try {
  	        const fn =
  	          typeof BackendlessUI !== "undefined" &&
  	          BackendlessUI.Functions &&
  	          BackendlessUI.Functions.Custom &&
  	          BackendlessUI.Functions.Custom[functionId];

  	        if (typeof fn === "function") return fn;
  	      } catch (_) {}

  	      await new Promise(resolve => setTimeout(resolve, 50));
  	    }

  	    return null;
  	  }

  	  async function routeUser(fullUser, launchApp) {
  	    const selectedApp = chooseLaunchApp(
  	      fullUser && fullUser.APP,
  	      launchApp
  	    );

  	    if (!selectedApp) {
  	      throw new Error(
  	        "The target user has no supported Office, Road or Bowser application."
  	      );
  	    }

  	    PAGE_DATA["App Select Options"] = splitApps(fullUser.APP)
  	      .filter(item =>
  	        ["office", "road", "bowser"].indexOf(item.toLowerCase()) !== -1
  	      )
  	      .map(item => ({
  	        value: item,
  	        label: item
  	      }));

  	    PAGE_DATA["Selected App"] = selectedApp;
  	    writeAppDataProperty("User", fullUser);
  	    writeAppDataProperty("APP", selectedApp);

  	    await flushAppData();
  	    const liveAppData = await waitForAppUser(fullUser && fullUser.objectId, 5000);

  	    if (!liveAppData || !liveAppData.User) {
  	      throw new Error("Login Procedure 1 did not commit App Data.User.");
  	    }

  	    const routeFunction = await waitForCustomFunction(ROUTE_FUNCTION_ID, 5000);

  	    if (typeof routeFunction !== "function") {
  	      // Do not bypass Login Procedure 2 with a direct page navigation. Doing that
  	      // opens Office/Road/Bowser before the required App Data setup has completed.
  	      throw new Error("Login Procedure 2 is unavailable; routing was stopped.");
  	    }

  	    console.log("[FIF Login As User] App Data committed before routing.", {
  	      userObjectId: clean(liveAppData.User && liveAppData.User.objectId),
  	      selectedApp,
  	      companies: Array.isArray(liveAppData.User && liveAppData.User.Companies)
  	        ? liveAppData.User.Companies.length
  	        : 0
  	    });

  	    await routeFunction(selectedApp, fullUser, PAGE_DATA, liveAppData);
  	  }

  	  const url = new URL(window.location.href);
  	  const nonce = clean(url.searchParams.get("fifmImpersonation"));

  	  if (!nonce) {
  	    return {
  	      ok: true,
  	      active: false,
  	      reason: "Normal Login page"
  	    };
  	  }

  	  if (typeof window.__FIFMImpersonationReceiverCleanup === "function") {
  	    try {
  	      window.__FIFMImpersonationReceiverCleanup();
  	    } catch (_) {}
  	  }

  	  let processing = false;
  	  let readyTimer = null;

  	  async function handlePayload(event) {
  	    if (event.origin !== window.location.origin) return;
  	    if (event.source !== window.opener) return;

  	    const data = event.data || {};
  	    if (clean(data.nonce) !== nonce) return;

  	    if (clean(data.type) === ERROR_MESSAGE) {
  	      setLoginPageState({}, clean(data.message) || "Login as User failed.");
  	      return;
  	    }

  	    if (clean(data.type) !== PAYLOAD_MESSAGE || processing) return;

  	    processing = true;

  	    if (readyTimer) {
  	      window.clearInterval(readyTimer);
  	      readyTimer = null;
  	    }

  	    const session = data.session || {};
  	    const userId = clean(session.objectId);
  	    const userToken = clean(session.userToken);

  	    try {
  	      if (!userId || !userToken) {
  	        throw new Error("The secure FIFM hand-off did not contain a complete session.");
  	      }

  	      setLoginPageState(
  	        session,
  	        "Signing in securely as " + (clean(session.name) || clean(session.identity)) + "..."
  	      );

  	      /*
  	       * Do not pass stayLoggedIn=true here.
  	       * Persistent Backendless storage is shared by all same-origin tabs and would
  	       * replace the FIFM Manager login. setCurrentUser without persistence creates
  	       * the authenticated target session in this new tab.
  	       */
  	      await Promise.resolve(
  	        Backendless.UserService.setCurrentUser(
  	          {
  	            objectId: userId,
  	            "user-token": userToken
  	          },
  	          false
  	        )
  	      );

  	      // Force the SDK to refresh its in-memory current-user object before the
  	      // Users-table hydration and UI Builder App Data assignment.
  	      if (typeof Backendless.UserService.getCurrentUser === "function") {
  	        await Backendless.UserService.getCurrentUser(true);
  	      }

  	      const valid = await Backendless.UserService.isValidLogin();

  	      if (!valid) {
  	        throw new Error("Backendless rejected the target-user session.");
  	      }

  	      const fullUser = await hydrateAppUser(userId);

  	      clearNonceFromUrl();

  	      await routeUser(fullUser, session.launchApp);

  	      safePost(COMPLETE_MESSAGE, nonce, {
  	        objectId: userId,
  	        name: clean(session.name) || clean(fullUser.name)
  	      });
  	    } catch (error) {
  	      const message = clean(
  	        error && (
  	          error.message ||
  	          error.faultString ||
  	          error.details
  	        )
  	      ) || "Login as User failed.";

  	      setLoginPageState(session, message);
  	      safePost(ERROR_MESSAGE, nonce, { message });
  	      processing = false;
  	    }
  	  }

  	  window.addEventListener("message", handlePayload);

  	  function announceReady() {
  	    safePost(READY_MESSAGE, nonce, {
  	      page: "Login"
  	    });
  	  }

  	  announceReady();
  	  readyTimer = window.setInterval(announceReady, 400);

  	  window.__FIFMImpersonationReceiverCleanup = function () {
  	    window.removeEventListener("message", handlePayload);

  	    if (readyTimer) {
  	      window.clearInterval(readyTimer);
  	      readyTimer = null;
  	    }
  	  };

  	  return {
  	    ok: true,
  	    active: true,
  	    nonce
  	  };
  	})();

  })(___arguments.context.appData, ___arguments.context.pageData);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/MobileTracking/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_a66c80cfedbfbaf191e559e77438ebe9'](___arguments.context.appData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2154aaa8fa99d78d83d30e7ca7c87b18')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Office/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_99baf5867ace567d1f12784621d9f6dc']();

  },
  /* handler:onBeforeEnter */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
      await Backendless.UserService.logout();

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/Office/components/a459c768a65852f84a3282a1d548a208/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Drawer')) == 'Dashboard') {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/cba825083f48a23842c528554b88f698/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      ___arguments.context.pageData['Drawer'] = 'Dashboard';

  },
  /* handler:onOpen */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Drawer'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/Office/components/9bd23fc5ddf80eb8c268c4153e78fd78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/c35d9a684e99d158eb18cc92781b9196/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var Data;


  console.log(___arguments.context.appData);
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/f708c088d4c8b308ecb61bd365b89388/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('Dash') !== -1) {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72'))]);
      await BackendlessUI.Functions.Custom['fn_2a3bf3cde9c8d10f742f3579cbb2a766'](___arguments.context.appData);
    } else {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e'))]);
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e'))]);
    }

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('Dash') !== -1) {
      View = true;
    } else {
      View = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      View = false;
    }

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/4ff8a678483197e1a35871c85c58cbf8/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var Locations, k, j, item, Tractors;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Locations2() {
  Locations = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Locations'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Locations, k);
    }
  }
  return Locations
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Tractors2() {
  Tractors = [];
  var j_list2 = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    var k_list2 = (getObjectProperty(j, 'Tractors'));
    for (var k_index2 in k_list2) {
      k = k_list2[k_index2];
      addItemToList(Tractors, k);
    }
  }
  return await asyncListFilter(Tractors, async (item) => {


 return (!(await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(item, 'Tracker')))));
})
}


  await BackendlessUI.Functions.Custom['fn_ab413a982236a49bcc125023ef64d39b'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c5c1158d7432af8a60840f7e4d8f854')), ___arguments.context.appData, (await Tractors2()), null, null, true, null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2618a6389cc7540b72d822a8ebf898b8')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), null, null);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Office/components/6c788686090312d9aa15b1483018fbb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.dataModel);
  ___arguments.context.appData['SelectedTractorMarker'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('1c5c1158d7432af8a60840f7e4d8f854', (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'Location')), 'position.latitude')), (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'Location')), 'position.longitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('1c5c1158d7432af8a60840f7e4d8f854', 20);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/e27a8f38dcc8bede5ab8e0844c583e5e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'FID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/af38ba18013863a85098a0ca3e1af84e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function(App, Button) {
  	/*
  	 * Fleet In Form — SHARED LOGOUT BUTTON / APP SWITCHER V2.3
  	 * Backendless UI Builder Custom Code
  	 *
  	 * Custom Code inputs (names must match exactly):
  	 *   App    - App Data
  	 *   Button - Get component by id: Menu - Logout Block
  	 *
  	 * IMPORTANT COMPONENT SETUP:
  	 *   This Custom Code must be the ONLY block inside the button's On Click Event.
  	 *   Remove any separate "Logout Current User", "Go To Page Login", old APP
  	 *   selector, and fn_302f8a0eaf0351f7bd6ef7c44ea2db0e blocks from that event.
  	 *   This script performs both app switching and real logout itself.
  	 *
  	 * Behaviour:
  	 *   - If another permitted application exists, opens the Fleet In Form themed
  	 *     mini menu immediately below the clicked logout button.
  	 *   - If no other application is permitted, logs out immediately.
  	 *   - "Log Out" always destroys the Backendless session and opens Login.
  	 *   - Application choices preserve the current Backendless session.
  	 *   - Does NOT change AppData.APP while the Office page is still mounted. The
  	 *     old Office APP-bound workflow treats that change as a completed legacy
  	 *     selection and logs the user out in the background.
  	 *   - Installs a session guard while the user is inside Fleet In Form. Any
  	 *     background/legacy logout is blocked; only this menu's explicit Log Out
  	 *     action is allowed to destroy the Backendless session.
  	 *   - A previous menu/runtime is destroyed before a new one is created. This
  	 *     prevents old document listeners surviving Office <-> Mobile cycles.
  	 *   - Current application is read from the URL first, so a stale AppData.APP
  	 *     value cannot hide or select the wrong application.
  	 *   - Snapshot is available when Users.Settings contains Overview and navigates
  	 *     to the Snapshot page without weakening the protected session-switch contract.
  	 */

  	return await (async function FIFSharedLogoutButtonV2_3(App, Button) {
  	  "use strict";

  	  const VERSION = "2.3";
  	  const RUNTIME_KEY = "__FIF_SHARED_APP_SWITCHER_V2__";
  	  const LOGOUT_GUARD_KEY = "__FIF_LOGOUT_GUARD_V1__";
  	  const MENU_ID = "fif-shared-app-switcher-v2";
  	  const STYLE_ID = "fif-shared-app-switcher-v2-style";

  	  const APPLICATION_PAGES = Object.freeze({
  	    FIFM: "FIFM",
  	    Office: "Office",
  	    Road: "Road",
  	    Bowser: "Bowser",
  	    "Mobile Tracking": "MobileTracking",
  	    Snapshot: "Snapshot"
  	  });

  	  function clean(value) {
  	    return value === null || value === undefined
  	      ? ""
  	      : String(value).trim();
  	  }

  	  function lower(value) {
  	    return clean(value).toLowerCase();
  	  }

  	  function normaliseApplicationName(value) {
  	    switch (lower(value).replace(/[\s_-]+/g, "")) {
  	      case "fifm":
  	        return "FIFM";
  	      case "office":
  	        return "Office";
  	      case "road":
  	        return "Road";
  	      case "bowser":
  	        return "Bowser";
  	      case "mobiletracking":
  	        return "Mobile Tracking";
  	      case "snapshot":
  	        return "Snapshot";
  	      default:
  	        return clean(value);
  	    }
  	  }

  	  function appBag() {
  	    if (App && App.data && typeof App.data === "object") return App.data;
  	    if (App && typeof App === "object" && !("data" in App)) return App;

  	    try {
  	      if (
  	        typeof BackendlessUI !== "undefined" &&
  	        BackendlessUI.App &&
  	        BackendlessUI.App.data
  	      ) {
  	        return BackendlessUI.App.data;
  	      }
  	    } catch (_) {}

  	    try {
  	      if (typeof AppData !== "undefined" && AppData) {
  	        return AppData.data || AppData;
  	      }
  	    } catch (_) {}

  	    try {
  	      if (typeof window !== "undefined" && window.AppData) {
  	        return window.AppData.data || window.AppData;
  	      }
  	    } catch (_) {}

  	    return {};
  	  }

  	  function currentApplication() {
  	    try {
  	      const page = new URL(window.location.href).searchParams.get("page");
  	      const fromPage = normaliseApplicationName(page);
  	      if (APPLICATION_PAGES[fromPage]) return fromPage;
  	    } catch (_) {}

  	    const data = appBag();
  	    return normaliseApplicationName(data && data.APP);
  	  }

  	  function allowedApplicationsFor(user) {
  	    const raw = Array.isArray(user && user.APP)
  	      ? user.APP
  	      : clean(user && user.APP).split(",");

  	    const allowed = raw
  	      .map(normaliseApplicationName)
  	      .filter(function (name) {
  	        return !!APPLICATION_PAGES[name];
  	      });

  	    if (lower(user && user.Office).indexOf("livetrack") !== -1) {
  	      allowed.push("Mobile Tracking");
  	    }

  	    if (lower(user && user.Settings).indexOf("overview") !== -1) {
  	      allowed.push("Snapshot");
  	    }

  	    return allowed.filter(function (name, index, list) {
  	      return list.indexOf(name) === index;
  	    });
  	  }

  	  async function resolveUser() {
  	    const data = appBag();
  	    let user = data && data.User ? data.User : null;

  	    if (
  	      !user &&
  	      typeof Backendless !== "undefined" &&
  	      Backendless.UserService &&
  	      typeof Backendless.UserService.getCurrentUser === "function"
  	    ) {
  	      user = await Backendless.UserService.getCurrentUser(true);
  	    }

  	    if (user && data && typeof data === "object") data.User = user;
  	    return user;
  	  }

  	  async function isSessionValid() {
  	    try {
  	      if (
  	        typeof Backendless !== "undefined" &&
  	        Backendless.UserService &&
  	        typeof Backendless.UserService.isValidLogin === "function"
  	      ) {
  	        return !!(await Backendless.UserService.isValidLogin());
  	      }
  	    } catch (_) {
  	      return false;
  	    }

  	    /* Older Backendless SDKs do not expose isValidLogin(). */
  	    return true;
  	  }

  	  /*
  	   * Backendless UI Builder can leave an outgoing page's asynchronous event
  	   * workflow alive after SPA navigation. If that old workflow reaches a
  	   * trailing Backendless.UserService.logout(), it destroys the new page's
  	   * session. Keep the SDK method protected and expose one explicit path for
  	   * the real Log Out option below.
  	   */
  	  function installLogoutGuard() {
  	    try {
  	      if (
  	        typeof Backendless === "undefined" ||
  	        !Backendless.UserService ||
  	        typeof Backendless.UserService.logout !== "function"
  	      ) {
  	        return null;
  	      }

  	      const service = Backendless.UserService;
  	      const existing = window[LOGOUT_GUARD_KEY];

  	      if (
  	        existing &&
  	        existing.service === service &&
  	        service.logout === existing.wrapper
  	      ) {
  	        return existing;
  	      }

  	      const original =
  	        existing &&
  	        existing.service === service &&
  	        typeof existing.original === "function"
  	          ? existing.original
  	          : service.logout;

  	      const guard = {
  	        version: "1.0",
  	        service: service,
  	        original: original,
  	        wrapper: null,
  	        explicitBusy: false,
  	        blockedCount: existing && existing.blockedCount
  	          ? existing.blockedCount
  	          : 0,
  	        async explicitLogout() {
  	          if (guard.explicitBusy) return false;
  	          guard.explicitBusy = true;

  	          try {
  	            return await guard.original.apply(guard.service, arguments);
  	          } finally {
  	            guard.explicitBusy = false;
  	          }
  	        }
  	      };

  	      guard.wrapper = function protectedBackendlessLogout() {
  	        guard.blockedCount += 1;
  	        console.warn(
  	          "[FIF Logout Guard] Blocked a background logout during app switching.",
  	          { blockedCount: guard.blockedCount }
  	        );
  	        return Promise.resolve(false);
  	      };

  	      try {
  	        service.logout = guard.wrapper;
  	      } catch (_) {
  	        Object.defineProperty(service, "logout", {
  	          configurable: true,
  	          writable: true,
  	          value: guard.wrapper
  	        });
  	      }

  	      if (service.logout !== guard.wrapper) return null;

  	      window[LOGOUT_GUARD_KEY] = guard;
  	      return guard;
  	    } catch (error) {
  	      console.error("[FIF Logout Guard] Could not install.", error);
  	      return null;
  	    }
  	  }

  	  function cssEscape(value) {
  	    try {
  	      if (window.CSS && typeof window.CSS.escape === "function") {
  	        return window.CSS.escape(clean(value));
  	      }
  	    } catch (_) {}

  	    return clean(value).replace(/(["'\\.#:[\]()])/g, "\\$1");
  	  }

  	  function elementFromComponent(component) {
  	    if (!component) return null;

  	    if (component.nodeType === 1) return component;

  	    const directKeys = [
  	      "el",
  	      "$el",
  	      "element",
  	      "_element",
  	      "node",
  	      "domNode",
  	      "current",
  	      "root"
  	    ];

  	    for (let i = 0; i < directKeys.length; i += 1) {
  	      const candidate = component[directKeys[i]];
  	      if (candidate && candidate.nodeType === 1) return candidate;
  	    }

  	    const possibleIds = [
  	      component.id,
  	      component.ID,
  	      component.componentId,
  	      component.objectId,
  	      "Menu - Logout Block"
  	    ].filter(Boolean);

  	    for (let i = 0; i < possibleIds.length; i += 1) {
  	      const id = clean(possibleIds[i]);
  	      const byId = document.getElementById(id);
  	      if (byId) return byId;

  	      try {
  	        const escaped = cssEscape(id);
  	        const byDataId = document.querySelector(
  	          '[data-component-id="' + escaped + '"], ' +
  	          '[data-id="' + escaped + '"]'
  	        );
  	        if (byDataId) return byDataId;
  	      } catch (_) {}
  	    }

  	    return null;
  	  }

  	  function buttonElement() {
  	    const root = elementFromComponent(Button);
  	    if (!root) return null;

  	    if (
  	      root.matches &&
  	      root.matches("button, [role='button'], a, input[type='button']")
  	    ) {
  	      return root;
  	    }

  	    return root.querySelector
  	      ? root.querySelector("button, [role='button'], a, input[type='button']") || root
  	      : root;
  	  }

  	  function removeExistingRuntime() {
  	    try {
  	      const previous = window[RUNTIME_KEY];
  	      if (previous && typeof previous.cleanup === "function") {
  	        previous.cleanup();
  	      }
  	      delete window[RUNTIME_KEY];
  	    } catch (_) {}

  	    const oldMenu = document.getElementById(MENU_ID);
  	    if (oldMenu) oldMenu.remove();
  	  }

  	  const logoutGuard = installLogoutGuard();
  	  removeExistingRuntime();

  	  let menu = null;
  	  let style = null;
  	  let anchor = null;
  	  let busy = false;
  	  let destroyed = false;

  	  function cleanup() {
  	    if (destroyed) return;
  	    destroyed = true;

  	    document.removeEventListener("pointerdown", onOutsidePointer, true);
  	    document.removeEventListener("keydown", onKeyDown, true);
  	    window.removeEventListener("resize", positionMenu);
  	    window.removeEventListener("scroll", positionMenu, true);

  	    if (menu && menu.parentNode) menu.parentNode.removeChild(menu);
  	    if (style && style.parentNode) style.parentNode.removeChild(style);

  	    try {
  	      if (window[RUNTIME_KEY] && window[RUNTIME_KEY].cleanup === cleanup) {
  	        delete window[RUNTIME_KEY];
  	      }
  	    } catch (_) {}
  	  }

  	  function positionMenu() {
  	    if (!menu || destroyed) return;

  	    const viewportPadding = 8;
  	    const gap = 6;
  	    const width = Math.min(220, Math.max(176, window.innerWidth - 16));
  	    let left = window.innerWidth - width - viewportPadding;
  	    let top = viewportPadding;

  	    if (anchor && anchor.getBoundingClientRect) {
  	      const rect = anchor.getBoundingClientRect();
  	      left = Math.min(
  	        window.innerWidth - width - viewportPadding,
  	        Math.max(viewportPadding, rect.right - width)
  	      );
  	      top = rect.bottom + gap;

  	      const menuHeight = menu.offsetHeight || 210;
  	      if (top + menuHeight > window.innerHeight - viewportPadding) {
  	        top = Math.max(viewportPadding, rect.top - menuHeight - gap);
  	      }
  	    }

  	    menu.style.width = width + "px";
  	    menu.style.left = Math.round(left) + "px";
  	    menu.style.top = Math.round(top) + "px";
  	  }

  	  function onOutsidePointer(event) {
  	    if (destroyed || !menu) return;
  	    if (menu.contains(event.target)) return;
  	    if (anchor && anchor.contains && anchor.contains(event.target)) return;
  	    cleanup();
  	  }

  	  function onKeyDown(event) {
  	    if (event.key === "Escape") {
  	      event.preventDefault();
  	      cleanup();
  	    }
  	  }

  	  function setStatus(message, error) {
  	    if (!menu) return;
  	    const status = menu.querySelector("[data-fif-switcher-status]");
  	    if (!status) return;

  	    status.textContent = clean(message);
  	    status.hidden = !clean(message);
  	    status.classList.toggle("error", !!error);
  	  }

  	  function disableOptions(disabled) {
  	    if (!menu) return;
  	    menu.querySelectorAll("button").forEach(function (item) {
  	      item.disabled = !!disabled;
  	    });
  	  }

  	  async function goToPage(pageName) {
  	    if (
  	      typeof BackendlessUI === "undefined" ||
  	      !BackendlessUI.Navigator ||
  	      typeof BackendlessUI.Navigator.goToPage !== "function"
  	    ) {
  	      throw new Error("Backendless application navigation is unavailable.");
  	    }

  	    await Promise.resolve(
  	      BackendlessUI.Navigator.goToPage(pageName, undefined)
  	    );
  	  }

  	  async function logoutUser() {
  	    if (busy) return false;
  	    busy = true;
  	    disableOptions(true);
  	    setStatus("Logging out…", false);

  	    try {
  	      if (
  	        typeof Backendless === "undefined" ||
  	        !Backendless.UserService ||
  	        typeof Backendless.UserService.logout !== "function"
  	      ) {
  	        throw new Error("Backendless logout is unavailable.");
  	      }

  	      const data = appBag();
  	      if (data && typeof data === "object") data.APP = null;

  	      const activeGuard = installLogoutGuard() || logoutGuard;

  	      if (
  	        activeGuard &&
  	        typeof activeGuard.explicitLogout === "function"
  	      ) {
  	        await activeGuard.explicitLogout();
  	      } else {
  	        await Backendless.UserService.logout();
  	      }
  	      cleanup();
  	      await goToPage("Login");
  	      return true;
  	    } catch (error) {
  	      busy = false;
  	      disableOptions(false);
  	      setStatus(
  	        clean(error && error.message) || "Logout could not be completed.",
  	        true
  	      );
  	      return false;
  	    }
  	  }

  	  async function switchApplication(name, user) {
  	    if (busy) return false;

  	    const target = normaliseApplicationName(name);
  	    const allowed = allowedApplicationsFor(user);

  	    if (!APPLICATION_PAGES[target] || allowed.indexOf(target) === -1) {
  	      setStatus("You do not have permission to open this application.", true);
  	      return false;
  	    }

  	    busy = true;
  	    disableOptions(true);
  	    setStatus("Opening " + target + "…", false);

  	    try {
  	      const sessionValid = await isSessionValid();

  	      console.info("[FIF App Switcher]", {
  	        version: VERSION,
  	        from: currentApplication(),
  	        to: target,
  	        sessionValid: sessionValid
  	      });

  	      if (!sessionValid) {
  	        throw new Error("Your session has ended. Please log in again.");
  	      }

  	      /*
  	       * Preserve AppData.User, but deliberately do not assign AppData.APP here.
  	       * The outgoing Office page still has the old APP-bound selection workflow
  	       * mounted. Changing APP before Office is destroyed wakes that workflow;
  	       * it then reaches its trailing Backendless logout after this navigation.
  	       *
  	       * Mobile Tracking and Snapshot read the active app from the URL first.
  	       * Their own destination-page switchers can assign APP later, after Office
  	       * has gone, without waking the outgoing Office APP-bound workflow.
  	       */
  	      const data = appBag();
  	      if (data && typeof data === "object") {
  	        data.User = data.User || user;
  	      }

  	      const pageName = APPLICATION_PAGES[target];
  	      cleanup();
  	      await goToPage(pageName);
  	      return true;
  	    } catch (error) {
  	      busy = false;
  	      disableOptions(false);
  	      setStatus(
  	        clean(error && error.message) ||
  	          "The selected application could not be opened.",
  	        true
  	      );
  	      return false;
  	    }
  	  }

  	  function installStyle() {
  	    style = document.createElement("style");
  	    style.id = STYLE_ID;
  	    style.textContent = `
  	      #${MENU_ID} {
  	        position: fixed;
  	        z-index: 2147483647;
  	        box-sizing: border-box;
  	        overflow: hidden;
  	        padding: 5px;
  	        color: #ffffff;
  	        border: 1px solid rgba(204, 102, 51, 0.72);
  	        border-radius: 13px;
  	        background:
  	          radial-gradient(circle at 16% -10%, rgba(204, 102, 51, 0.25), transparent 42%),
  	          repeating-radial-gradient(circle at 80% 118%, transparent 0 13px, rgba(204, 102, 51, 0.13) 14px 16px),
  	          linear-gradient(145deg, #1b1714 0%, #0b0d0d 58%, #050707 100%);
  	        box-shadow:
  	          0 18px 42px rgba(0, 0, 0, 0.58),
  	          0 0 0 1px rgba(0, 0, 0, 0.65) inset,
  	          0 0 18px rgba(204, 102, 51, 0.12);
  	        font-family: Inter, Roboto, Arial, sans-serif;
  	        transform-origin: top right;
  	        animation: fifSwitcherIn 130ms ease-out both;
  	      }

  	      #${MENU_ID} .fif-switcher-option {
  	        display: flex;
  	        align-items: center;
  	        width: 100%;
  	        min-height: 36px;
  	        margin: 0;
  	        padding: 8px 11px;
  	        border: 0;
  	        border-radius: 8px;
  	        outline: 0;
  	        color: #f5f5f5;
  	        background: transparent;
  	        cursor: pointer;
  	        text-align: left;
  	        font: 800 13px/1.2 Inter, Roboto, Arial, sans-serif;
  	        letter-spacing: 0.01em;
  	        transition: color 120ms ease, background 120ms ease, box-shadow 120ms ease;
  	      }

  	      #${MENU_ID} .fif-switcher-option:hover,
  	      #${MENU_ID} .fif-switcher-option:focus-visible {
  	        color: #ffffff;
  	        background: rgba(204, 102, 51, 0.22);
  	        box-shadow: inset 2px 0 0 #cc6633;
  	      }

  	      #${MENU_ID} .fif-switcher-option:disabled {
  	        cursor: wait;
  	        opacity: 0.55;
  	      }

  	      #${MENU_ID} .fif-switcher-option.logout {
  	        margin-top: 4px;
  	        border-top: 1px solid rgba(204, 102, 51, 0.26);
  	        border-radius: 0 0 8px 8px;
  	        color: #ff8a3d;
  	      }

  	      #${MENU_ID} .fif-switcher-status {
  	        padding: 6px 10px 7px;
  	        color: #ff8a3d;
  	        font-size: 11px;
  	        font-weight: 700;
  	        line-height: 1.3;
  	      }

  	      #${MENU_ID} .fif-switcher-status.error {
  	        color: #ff5b45;
  	      }

  	      @keyframes fifSwitcherIn {
  	        from { opacity: 0; transform: translateY(-4px) scale(0.98); }
  	        to { opacity: 1; transform: translateY(0) scale(1); }
  	      }
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function renderMenu(applications, user) {
  	    installStyle();

  	    menu = document.createElement("div");
  	    menu.id = MENU_ID;
  	    menu.setAttribute("role", "menu");
  	    menu.setAttribute("aria-label", "Switch application or log out");

  	    applications.forEach(function (name) {
  	      const option = document.createElement("button");
  	      option.type = "button";
  	      option.className = "fif-switcher-option";
  	      option.setAttribute("role", "menuitem");
  	      option.textContent = name;
  	      option.addEventListener("click", function (event) {
  	        event.preventDefault();
  	        event.stopPropagation();
  	        switchApplication(name, user);
  	      });
  	      menu.appendChild(option);
  	    });

  	    const logout = document.createElement("button");
  	    logout.type = "button";
  	    logout.className = "fif-switcher-option logout";
  	    logout.setAttribute("role", "menuitem");
  	    logout.textContent = "Log Out";
  	    logout.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      logoutUser();
  	    });
  	    menu.appendChild(logout);

  	    const status = document.createElement("div");
  	    status.className = "fif-switcher-status";
  	    status.setAttribute("data-fif-switcher-status", "");
  	    status.setAttribute("aria-live", "polite");
  	    status.hidden = true;
  	    menu.appendChild(status);

  	    document.body.appendChild(menu);
  	    positionMenu();

  	    document.addEventListener("pointerdown", onOutsidePointer, true);
  	    document.addEventListener("keydown", onKeyDown, true);
  	    window.addEventListener("resize", positionMenu);
  	    window.addEventListener("scroll", positionMenu, true);

  	    setTimeout(function () {
  	      positionMenu();
  	      const first = menu && menu.querySelector("button");
  	      if (first && typeof first.focus === "function") first.focus();
  	    }, 0);
  	  }

  	  try {
  	    const user = await resolveUser();
  	    const current = currentApplication();
  	    const allowed = allowedApplicationsFor(user);
  	    const alternatives = allowed.filter(function (name) {
  	      return name !== current;
  	    });

  	    console.info("[FIF App Switcher Ready]", {
  	      version: VERSION,
  	      currentApp: current,
  	      allowedApps: allowed,
  	      availableApps: alternatives,
  	      logoutGuardActive: !!logoutGuard
  	    });

  	    /* No user or no other app privilege means this button is a direct logout. */
  	    if (!user || !alternatives.length) {
  	      await logoutUser();
  	      return;
  	    }

  	    anchor = buttonElement();
  	    renderMenu(alternatives, user);

  	    window[RUNTIME_KEY] = {
  	      version: VERSION,
  	      cleanup: cleanup,
  	      menu: menu
  	    };
  	  } catch (error) {
  	    console.error("[FIF App Switcher]", error);

  	    /* A broken menu must never trap a single-app user on the current page. */
  	    try {
  	      await logoutUser();
  	    } catch (_) {}
  	  }
  	})(App, Button);

  })(___arguments.context.appData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af38ba18013863a85098a0ca3e1af84e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/e9adf1fcacd6503875c83f5890ad7e58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21f8596888d7d1c83f5dd85847cd71c8')), 'icon')) == 'arrow_drop_up') {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21f8596888d7d1c83f5dd85847cd71c8'))['icon'] = 'arrow_drop_down';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cffe092adbaa20b8c59d3988e9a881ef', false);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21f8596888d7d1c83f5dd85847cd71c8'))['icon'] = 'arrow_drop_up';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cffe092adbaa20b8c59d3988e9a881ef', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/f508fc684af87fa8f4986b185f5dd83a/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var Sort, Tractors, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}



  return (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies')).map(async item => {; return ({ [`groupLabel`]: (getObjectProperty(item, 'Name')),[`children`]: (await asyncListSort((await Promise.all((getObjectProperty(item, 'Tractors')).map(async Tractors => {; return ({ [`label`]: (getObjectProperty(Tractors, 'ID')),[`value`]: (getObjectProperty(Tractors, 'objectId')) });}))), 1, async (Sort) => {


 return (getObjectProperty(Sort, 'label'));
})) });})))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Tractor, item, Tractors, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Tractors, k);
    }
  }
  Tractor = (await asyncListFilter(Tractors, async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ___arguments['inputValue']);
  }))[0];
  ___arguments.context.appData['SelectedTractorMarker'] = (getObjectProperty(Tractor, 'objectId'));
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('1c5c1158d7432af8a60840f7e4d8f854', (getObjectProperty((getObjectProperty(Tractor, 'Location')), 'position.latitude')), (getObjectProperty((getObjectProperty(Tractor, 'Location')), 'position.longitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('1c5c1158d7432af8a60840f7e4d8f854', 20);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Office/components/332c7b6dd01a3d7e91a5a418524866cd/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  async ['onOpen'](___arguments) {
    var Locations, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Locations2() {
  Locations = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Locations'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Locations, k);
    }
  }
  return Locations
}


  await BackendlessUI.Functions.Custom['fn_ab413a982236a49bcc125023ef64d39b'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), ___arguments.context.appData, [(getObjectProperty(___arguments.context.appData, 'SelectedTractor'))], (new Date((new Date()).getTime() - (900 * 1000))), (new Date()), null, null, null, null, null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')));

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/Office/components/98b8d80d9588af68977d33bf5a885958/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Engine Temp:  ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'Location')), 'can.engine.temperature')),'°'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/3308f64f8e28a0f8b468def8fc44cc58/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Speed: ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'Location')), 'position.speed')),' kph'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/d4884e69cf08d2887c78f26865df0218/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('RPM: ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'Location')), 'can.engine.rpm')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/af68d77370785b78d6333ba87e98ea89/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), 'Max')), 'Speed')) + String(' km/h');

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/8108cec8e158dffcb65cd718cdf874d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), 'Max')), 'RPM'));

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/5c44f58f0f279778af785ad8c653bbb8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), 'Max')), 'Temp')) + String('°');

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/a75814483a654e88df7886b2ad786e48/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), 'Max')), 'IdleFmt'));

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/f968a9e823e853e8ce8825538d08cb28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), 'Max')), 'DistKm')) + String(' km');

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/ba5bf436447b2a98ce63b2a840880d61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Time, Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Time_Function() {
  if (___arguments.value == '30 Minutes') {
    Value = 1800;
  } else if (___arguments.value == '1 Hour') {
    Value = 3600;
  } else if (___arguments.value == '3 Hours') {
    Value = 10800;
  } else if (___arguments.value == '6 Hours') {
    Value = 21600;
  } else if (___arguments.value == '24 Hours') {
    Value = 86400;
  }
  return Value
}


  if (___arguments.value == 'Historical') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd88a9028ef82068369106ed5478c73b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd88a9028ef82068369106ed5478c73b', false);
    Time = await Time_Function();
    await BackendlessUI.Functions.Custom['fn_ab413a982236a49bcc125023ef64d39b'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), ___arguments.context.appData, [(getObjectProperty(___arguments.context.appData, 'SelectedTractor'))], (___arguments.value == 'Whole Day' ? (await (async function(timestamp) {
    	function getStartOfDayTimestamp(timestamp) {
    	  const startDate = new Date(timestamp);
    	  startDate.setHours(0, 0, 0, 0); // Set to the start of the day
    	
    	  return startDate.getTime();
    	}
    	
    	// Directly execute and return the result
    	return getStartOfDayTimestamp(timestamp);

    })((new Date()))) : (new Date((new Date()).getTime() - (Time * 1000)))), (new Date()), null, null, null, null, null, null);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Office/components/7633c782dff8bf1398042488ec48c71e/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d8dfdfcc1f4a5c1cbbdab8a5ae8751', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Office/components/364898667078f249cb68f4a950f7f59c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), 'Location Events')).length;

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/89c8b1a3f4584b78d9ccfd9889786a58/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'ID'));

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/7ca82095f05f36f82678380871e101f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_afe6ec398aae1809c98d61f4839bb155']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'CAN')), 'Exclusions')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), (getObjectProperty(___arguments.context.appData, 'SelectedTractor')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca82095f05f36f82678380871e101f6')), null, ___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/c498d4c899d9c7185d68c1e94d4a6ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Locations;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_afe6ec398aae1809c98d61f4839bb155']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'CAN')), 'Exclusions')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), (getObjectProperty(___arguments.context.appData, 'SelectedTractor')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca82095f05f36f82678380871e101f6')), 'Speeding', ___arguments.context.appData, 'Speed');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/ce05186c8e2881a84b2f64954d48ab0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_afe6ec398aae1809c98d61f4839bb155']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'CAN')), 'Exclusions')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), (getObjectProperty(___arguments.context.appData, 'SelectedTractor')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca82095f05f36f82678380871e101f6')), 'Engine Over-Rev', ___arguments.context.appData, 'RPM');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/6b1810e87176d3d8d528f9987d1e9e63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_afe6ec398aae1809c98d61f4839bb155']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'CAN')), 'Exclusions')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), (getObjectProperty(___arguments.context.appData, 'SelectedTractor')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca82095f05f36f82678380871e101f6')), 'Engine Over-Temperature', ___arguments.context.appData, 'Temp');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/e7571a38434897284f44f473723a8768/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_afe6ec398aae1809c98d61f4839bb155']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'CAN')), 'Exclusions')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), (getObjectProperty(___arguments.context.appData, 'SelectedTractor')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca82095f05f36f82678380871e101f6')), 'Idle Event', ___arguments.context.appData, 'Idle');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/90990468fbd1c996f528a2d85a885083/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_afe6ec398aae1809c98d61f4839bb155']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'CAN')), 'Exclusions')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), (getObjectProperty(___arguments.context.appData, 'SelectedTractor')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca82095f05f36f82678380871e101f6')), 'Location Events', ___arguments.context.appData, null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/44387122e19bb30875f8c238f8e81e08/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Value, Time;

/**
 * Describe this function...
 */
async function Time_Function() {
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ba5bf436447b2a98ce63b2a840880d61')) == '30 Minutes') {
    Value = 1800;
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ba5bf436447b2a98ce63b2a840880d61')) == '1 Hour') {
    Value = 3600;
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ba5bf436447b2a98ce63b2a840880d61')) == '3 Hours') {
    Value = 10800;
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ba5bf436447b2a98ce63b2a840880d61')) == '6 Hours') {
    Value = 21600;
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ba5bf436447b2a98ce63b2a840880d61')) == '24 Hours') {
    Value = 86400;
  }
  return Value
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Time_Function_Historical() {
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fine Track Historical')), 'Period')) == '30 Minutes') {
    Value = 1800;
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fine Track Historical')), 'Period')) == '1 Hour') {
    Value = 3600;
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fine Track Historical')), 'Period')) == '3 Hours') {
    Value = 10800;
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fine Track Historical')), 'Period')) == '6 Hours') {
    Value = 21600;
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fine Track Historical')), 'Period')) == '24 Hours') {
    Value = 86400;
  }
  return Value
}


  if ((getObjectProperty(___arguments.context.pageData, 'FIF')) == true) {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ba5bf436447b2a98ce63b2a840880d61')) == 'Historical') {
      Time = await Time_Function_Historical();
      await BackendlessUI.Functions.Custom['fn_ab413a982236a49bcc125023ef64d39b'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), ___arguments.context.appData, [(getObjectProperty(___arguments.context.appData, 'SelectedTractor'))], (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fine Track Historical')), 'Date')))), (new Date((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fine Track Historical')), 'Date')))).getTime() + (Time * 1000))), null, null, null, null, null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')));
      delete ___arguments.context.pageData['FIF'];
    } else {
      Time = await Time_Function();
      await BackendlessUI.Functions.Custom['fn_ab413a982236a49bcc125023ef64d39b'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), ___arguments.context.appData, [(getObjectProperty(___arguments.context.appData, 'SelectedTractor'))], (new Date((new Date()).getTime() - (Time * 1000))), (new Date()), null, null, null, null, null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')));
      delete ___arguments.context.pageData['FIF'];
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Office/components/81f82418e45f7418db4af558d6278ca8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_f3979dfa9c737a1d3495e9a9fe75af93']((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/f018cc68c2edbab33d28112fa6e8a0ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function(Map) {
  	// === Close All Divs (Map & Detached Panel Safe Cleanup) ===
  	return (async function (input) {
  	  const Map = input?.Map || null;
  	  const map = Map?.map?.map;
  	
  	  // --- Close Google Map InfoWindows safely ---
  	  try {
  	    if (window._warnHubInfo) {
  	      window._warnHubInfo.close();
  	      window._warnHubInfo = null;
  	    }
  	    if (Array.isArray(window._allInfoWindows)) {
  	      window._allInfoWindows.forEach(iw => {
  	        try { iw.close(); } catch {}
  	      });
  	      window._allInfoWindows = [];
  	    }
  	  } catch (err) {
  	    console.warn("⚠ InfoWindow close failed:", err);
  	  }
  	
  	  // --- Close the detached left panel if open ---
  	  const detached = document.getElementById("detachedPopup");
  	  if (detached) {
  	    detached.style.transition = "opacity 0.25s ease";
  	    detached.style.opacity = "0";
  	    setTimeout(() => {
  	      try { detached.remove(); } catch {}
  	      // Also clear marker and reset compare state if needed
  	      try {
  	        if (window.App?.SelectedTractorMarker?.setMap) {
  	          window.App.SelectedTractorMarker.setMap(null);
  	          window.App.SelectedTractorMarker = null;
  	        }
  	        if (window.compareState) {
  	          Object.assign(window.compareState, {
  	            active: false,
  	            pointA: null,
  	            markerB: null,
  	            sectionId: null
  	          });
  	        }
  	      } catch (err) {
  	        console.warn("⚠ Cleanup marker/compare failed:", err);
  	      }
  	    }, 250);
  	  }
  	
  	  // --- Remove only known transient popups (not React/Backendless nodes) ---
  	  const safeIds = [
  	    "warnings-popup",
  	    "fuel-popup",
  	    "event-popup",
  	    "track-popup",
  	  ];
  	  safeIds.forEach(id => {
  	    const el = document.getElementById(id);
  	    if (el) try { el.remove(); } catch {}
  	  });
  	
  	  const safeClasses = [
  	    "hub-popup",
  	    "custom-popup"
  	  ];
  	  safeClasses.forEach(cls => {
  	    document.querySelectorAll(`.${cls}`).forEach(el => {
  	      el.style.transition = "opacity 0.2s";
  	      el.style.opacity = "0";
  	      setTimeout(() => { try { el.remove(); } catch {} }, 200);
  	    });
  	  });
  	
  	  console.log("✅ Closed map info windows, detached panel, and custom popups.");
  	})();

  })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')));
  await (async function() {
  	(function () {
  	  // Target the popup by its known ID
  	  const popup = document.getElementById("telematics-popup");
  	  if (!popup) return;
  	
  	  // Restore HUB visibility
  	  try {
  	    if (typeof HUB?.setVisible === "function") HUB.setVisible(true);
  	    else if (HUB && "visible" in HUB) HUB.visible = true;
  	  } catch (_) {}
  	
  	  // Remove listeners if they exist
  	  try {
  	    window.removeEventListener("resize", resizeHandler);
  	    window.removeEventListener("orientationchange", resizeHandler);
  	    window.removeEventListener("keydown", escHandler);
  	  } catch (_) {}
  	
  	  // Remove popup safely
  	  popup.remove();
  	})();

  })();
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('332c7b6dd01a3d7e91a5a418524866cd', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/51a84cb8124643fec7e889670f9462e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21f8596888d7d1c83f5dd85847cd71c8'))['icon'] = 'arrow_drop_down';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cffe092adbaa20b8c59d3988e9a881ef', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  await BackendlessUI.Functions.Custom['fn_1a53e926aaf153363e427601c3443e71'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')), (getObjectProperty(___arguments.context.appData, 'SelectedTractor')), ___arguments.context.appData, ___arguments.context.pageData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21f8596888d7d1c83f5dd85847cd71c8')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cffe092adbaa20b8c59d3988e9a881ef')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/11a8c02f42382808dfb24ac832980038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function(App) {

  })(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/2de8c93dc1c8c24893f821c3bd28089a/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var error, Tractors, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Tractors2() {
  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if ((getObjectProperty(k, 'Type')) == 'Commercial') {
        addItemToList(Tractors, k);
      }
    }
  }
  return Tractors
}


  try {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2de8c93dc1c8c24893f821c3bd28089a', (await Tractors2()));

  } catch (error) {

  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Office/components/71d2633827c8a1477271dfd80c4855ef/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    var j_list = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2de8c93dc1c8c24893f821c3bd28089a')), 'el')), 'children'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      ((getObjectProperty(j, 'children'))[1])['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('71d2633827c8a1477271dfd80c4855ef')), 'el')), 'scrollLeft'));
    }

  } catch (error) {

  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/Office/components/bea85192d1489ad2d542a47b5decd7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('71d2633827c8a1477271dfd80c4855ef')), 'el'))['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bea85192d1489ad2d542a47b5decd7d1')), 'el')), 'scrollLeft'));

  } catch (error) {

  }
  try {
    var j_list = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2de8c93dc1c8c24893f821c3bd28089a')), 'el')), 'children'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      ((getObjectProperty(j, 'children'))[2])['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('71d2633827c8a1477271dfd80c4855ef')), 'el')), 'scrollLeft'));
    }

  } catch (error) {

  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/Office/components/7b0fbc41ffd89688b608405cae68bdc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Error_Data;

/**
 * Describe this function...
 */
async function New() {
  await (async function(SVG, App) {
  	/*
  	 * Fleet In Form Settings Manager — Ground-Up Rebuild v1.0.0
  	 *
  	 * One Backendless UI Custom Code application with three runtime shells:
  	 *   - FIFM Platform Management
  	 *   - FIFC Support & Correction
  	 *   - Customer Company Management
  	 *
  	 * Authoritative access model:
  	 *   Users.APP, Users.Role, Users.Office, Users.Settings, Users.Home,
  	 *   and the Users.Companies relation.
  	 *
  	 * This code intentionally does NOT use CompanyAccess, role templates,
  	 * capability overrides, or any second persisted permission system.
  	 */

  	return await (async function FleetInFormSettingsManager() {
  	  "use strict";

  	  /* ========================================================================
  	   * 1. BOOTSTRAP CONSTANTS
  	   * ====================================================================== */

  	  const VERSION = "1.0.0";
  	  const ROOT_ID = "fif-settings-rebuild-root";
  	  const STYLE_ID = "fif-settings-rebuild-style";
  	  const TOP_OFFSET_PX = 50;
  	  const DEVELOPMENT = true;

  	  const TABLES = Object.freeze({
  	    USERS: "Users",
  	    COMPANIES: "Companies",
  	    TRACTORS: "Tractors",
  	    TRAILERS: "Trailers",
  	    TANKS: "Tanks",
  	    BOWSERS: "Bowsers",
  	    TYRES: "Tyres",
  	    LOCATIONS: "Locations",
  	    ROUTES: "Routes",
  	    FUEL_IN: "FuelIn",
  	    FUEL_OUT: "FuelOut",
  	    LOADS: "Loads",
  	    TRIPS: "Trips",
  	    JOBS: "Jobs",
  	    JOB_ENTRIES: "JobEntries",
  	    AUDIT: "AuditLog"
  	  });

  	  const RELATIONS = Object.freeze({
  	    USER_COMPANIES: {
  	      parentTable: TABLES.USERS,
  	      name: "Companies",
  	      definition: "Companies:Companies:n",
  	      relatedTable: TABLES.COMPANIES
  	    },
  	    COMPANY_EMPLOYEES: {
  	      parentTable: TABLES.COMPANIES,
  	      name: "Employees",
  	      definition: "Employees:Users:n",
  	      relatedTable: TABLES.USERS
  	    },
  	    COMPANY_TRACTORS: {
  	      parentTable: TABLES.COMPANIES,
  	      name: "Tractors",
  	      definition: "Tractors:Tractors:n",
  	      relatedTable: TABLES.TRACTORS
  	    },
  	    COMPANY_TRAILERS: {
  	      parentTable: TABLES.COMPANIES,
  	      name: "Trailers",
  	      definition: "Trailers:Trailers:n",
  	      relatedTable: TABLES.TRAILERS
  	    },
  	    COMPANY_TANKS: {
  	      parentTable: TABLES.COMPANIES,
  	      name: "Tanks",
  	      definition: "Tanks:Tanks:n",
  	      relatedTable: TABLES.TANKS
  	    },
  	    COMPANY_LOCATIONS: {
  	      parentTable: TABLES.COMPANIES,
  	      name: "Locations",
  	      definition: "Locations:Locations:n",
  	      relatedTable: TABLES.LOCATIONS
  	    },
  	    COMPANY_ROUTES: {
  	      parentTable: TABLES.COMPANIES,
  	      name: "Routes",
  	      definition: "Routes:Routes:n",
  	      relatedTable: TABLES.ROUTES
  	    },
  	    TANK_BOWSERS: {
  	      parentTable: TABLES.TANKS,
  	      name: "Bowsers",
  	      definition: "Bowsers:Bowsers:n",
  	      relatedTable: TABLES.BOWSERS
  	    },
  	    TRACTOR_TYRES: {
  	      parentTable: TABLES.TRACTORS,
  	      name: "Tyres",
  	      definition: "Tyres:Tyres:n",
  	      relatedTable: TABLES.TYRES
  	    },
  	    LOCATION_JOBS: {
  	      parentTable: TABLES.LOCATIONS,
  	      name: "Jobs",
  	      definition: "Jobs:JobEntries:n",
  	      relatedTable: TABLES.JOB_ENTRIES
  	    }
  	  });

  	  const ACCESS_SCHEMA = Object.freeze({
  	    apps: Object.freeze(["Office", "Road", "FIFC", "FIFM", "Bowser"]),
  	    office: Object.freeze(["LiveTrack", "Bowser", "Agri", "Dash", "Locations", "Settings"]),
  	    settings: Object.freeze(["Applications", "Locations", "Users", "Vehicles"]),
  	    roles: Object.freeze(["Director", "Financial", "Admin", "Driver", "Load Planner", "Mechanic", "Bowser"]),
  	    homes: Object.freeze(["LiveTrack", "Bowser", "Agri", "Dash", "Locations", "Settings"]),
  	    ordinaryApps: Object.freeze(["Office", "Road", "Bowser"]),
  	    ordinaryRoles: Object.freeze(["Financial", "Admin", "Driver", "Load Planner", "Mechanic", "Bowser"])
  	  });

  	  const ACTIONS = Object.freeze({
  	    PLATFORM_VIEW: "platform.view",
  	    COMPANIES_VIEW_ALL: "companies.view_all",
  	    COMPANIES_VIEW_ASSIGNED: "companies.view_assigned",
  	    COMPANIES_CREATE: "companies.create",
  	    COMPANIES_EDIT: "companies.edit",
  	    COMPANIES_STATUS: "companies.status",
  	    COMPANIES_ASSIGN: "companies.assign",
  	    COMPANIES_MANAGE_PORTFOLIO: "companies.manage_portfolio",

  	    USERS_VIEW: "users.view",
  	    USERS_CREATE: "users.create",
  	    USERS_EDIT_PROFILE: "users.edit_profile",
  	    USERS_EDIT_EMPLOYMENT: "users.edit_employment",
  	    USERS_EDIT_PAYROLL: "users.edit_payroll",
  	    USERS_EDIT_PERMISSIONS: "users.edit_permissions",
  	    USERS_DISABLE: "users.disable",
  	    USERS_ASSIGN_COMPANIES: "users.assign_companies",
  	    USERS_ASSIGN_FIFM: "users.assign_fifm",
  	    USERS_ASSIGN_FIFC: "users.assign_fifc",
  	    USERS_ASSIGN_DIRECTOR: "users.assign_director",

  	    APPLICATIONS_VIEW: "applications.view",
  	    APPLICATIONS_EDIT: "applications.edit",
  	    LOCATIONS_VIEW: "locations.view",
  	    LOCATIONS_CREATE: "locations.create",
  	    LOCATIONS_EDIT: "locations.edit",
  	    LOCATIONS_DELETE: "locations.delete",

  	    VEHICLES_VIEW: "vehicles.view",
  	    VEHICLES_CREATE: "vehicles.create",
  	    VEHICLES_EDIT: "vehicles.edit",
  	    VEHICLES_DELETE: "vehicles.delete",
  	    VEHICLES_TECHNICAL: "vehicles.edit_technical",
  	    VEHICLES_SERVICE: "vehicles.edit_service",
  	    VEHICLES_COMPLIANCE: "vehicles.edit_compliance",
  	    VEHICLES_FINANCIAL: "vehicles.edit_financial",

  	    TANKS_VIEW: "tanks.view",
  	    TANKS_CREATE: "tanks.create",
  	    TANKS_EDIT: "tanks.edit",
  	    TANKS_DELETE: "tanks.delete",

  	    BOWSERS_VIEW: "bowsers.view",
  	    BOWSERS_CREATE: "bowsers.create",
  	    BOWSERS_EDIT: "bowsers.edit",
  	    BOWSERS_DELETE: "bowsers.delete",

  	    TRAILERS_VIEW: "trailers.view",
  	    TRAILERS_CREATE: "trailers.create",
  	    TRAILERS_EDIT: "trailers.edit",
  	    TRAILERS_DELETE: "trailers.delete",

  	    IMPLEMENTS_VIEW: "implements.view",
  	    IMPLEMENTS_CREATE: "implements.create",
  	    IMPLEMENTS_EDIT: "implements.edit",
  	    IMPLEMENTS_DELETE: "implements.delete",

  	    TYRES_VIEW: "tyres.view",
  	    TYRES_CREATE: "tyres.create",
  	    TYRES_EDIT: "tyres.edit",
  	    TYRES_DELETE: "tyres.delete",
  	    TYRES_FIT: "tyres.fit",

  	    FUEL_VIEW: "fuel.view",
  	    FUEL_CAPTURE: "fuel.capture",
  	    FUEL_CORRECT: "fuel.correct",
  	    FUEL_REVERSE: "fuel.reverse",

  	    LOADS_VIEW: "loads.view",
  	    LOADS_CREATE: "loads.create",
  	    LOADS_EDIT: "loads.edit",
  	    LOADS_CORRECT: "loads.correct",

  	    TRIPS_VIEW: "trips.view",
  	    TRIPS_CORRECT: "trips.correct",
  	    JOBS_VIEW: "jobs.view",
  	    JOBS_CORRECT: "jobs.correct",
  	    ROUTES_VIEW: "routes.view",
  	    ROUTES_EDIT: "routes.edit",

  	    AUDIT_VIEW: "audit.view"
  	  });

  	  const RELATION_FIELDS = new Set([
  	    "Companies", "Employees", "Tractors", "Trailers", "Tanks", "Bowsers",
  	    "Tyres", "Locations", "Routes", "Customers", "Contractors", "PointLocations",
  	    "Maintenance", "ViewC", "ViewH", "FuelIn", "FuelOut", "Jobs", "Tractor",
  	    "Location_Load", "Location_Deliver", "Location_Return", "Wages_Payslip_Current",
  	    "Wages_Payslip_Historical"
  	  ]);

  	  /* ========================================================================
  	   * 2. INPUT RESOLUTION
  	   * ====================================================================== */

  	  function readArg(name, lowerName, index) {
  	    try {
  	      if (typeof ___arguments !== "undefined" && ___arguments) {
  	        if (___arguments[name] !== undefined) return ___arguments[name];
  	        if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	        if (___arguments[index] !== undefined) return ___arguments[index];
  	      }
  	    } catch (_) {}
  	    return undefined;
  	  }

  	  const APP_INPUT =
  	    (typeof App !== "undefined" ? App : undefined) ||
  	    readArg("App", "app", 0) ||
  	    null;

  	  const SVG_INPUT =
  	    (typeof SVG !== "undefined" ? SVG : undefined) ||
  	    readArg("SVG", "svg", 1) ||
  	    "";

  	  const BackendlessApi = typeof Backendless !== "undefined" ? Backendless : null;

  	  function resolveAppData(input) {
  	    try {
  	      if (input?.data && typeof input.data === "object") return input.data;
  	      if (input?.User && typeof input === "object") return input;
  	    } catch (_) {}
  	    try {
  	      if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	        return BackendlessUI.App.data;
  	      }
  	    } catch (_) {}
  	    try {
  	      if (window.AppData) return window.AppData.data || window.AppData;
  	    } catch (_) {}
  	    return null;
  	  }

  	  const APP_DATA = resolveAppData(APP_INPUT);

  	  if (!APP_DATA?.User) {
  	    const message = "Fleet In Form Settings Manager could not find App Data.User.";
  	    try { window.alert(message); } catch (_) {}
  	    return { ok: false, reason: message, version: VERSION };
  	  }

  	  /* ========================================================================
  	   * 3. GENERIC UTILITIES
  	   * ====================================================================== */

  	  function text(value) {
  	    return value === undefined || value === null ? "" : String(value);
  	  }

  	  function clean(value) {
  	    return text(value).trim();
  	  }

  	  function lower(value) {
  	    return clean(value).toLowerCase();
  	  }

  	  function nowIso() {
  	    return new Date().toISOString();
  	  }

  	  function isObject(value) {
  	    return !!value && typeof value === "object" && !Array.isArray(value);
  	  }

  	  function clone(value) {
  	    if (value === undefined) return undefined;
  	    try { return JSON.parse(JSON.stringify(value)); }
  	    catch (_) { return value; }
  	  }

  	  function merge(target, source) {
  	    const out = isObject(target) ? target : {};
  	    if (!isObject(source)) return out;
  	    Object.keys(source).forEach(key => {
  	      const value = source[key];
  	      if (Array.isArray(value)) out[key] = clone(value);
  	      else if (isObject(value)) out[key] = merge(isObject(out[key]) ? out[key] : {}, value);
  	      else out[key] = value;
  	    });
  	    return out;
  	  }

  	  function escapeHtml(value) {
  	    return text(value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/\"/g, "&quot;")
  	      .replace(/'/g, "&#039;");
  	  }

  	  function escapeAttr(value) {
  	    return escapeHtml(value).replace(/`/g, "&#096;");
  	  }

  	  function uniqueValues(values) {
  	    const output = [];
  	    const seen = new Set();
  	    (Array.isArray(values) ? values : []).forEach(value => {
  	      const item = clean(value);
  	      const key = item.toLowerCase();
  	      if (!item || seen.has(key)) return;
  	      seen.add(key);
  	      output.push(item);
  	    });
  	    return output;
  	  }

  	  function splitCsv(value) {
  	    if (Array.isArray(value)) return uniqueValues(value.flatMap(splitCsv));
  	    return uniqueValues(text(value).split(/[,;|]/));
  	  }

  	  function joinCsv(values) {
  	    return uniqueValues(values).join(",");
  	  }

  	  function intersect(left, right) {
  	    const allowed = new Set(right);
  	    return uniqueValues(left).filter(value => allowed.has(value));
  	  }

  	  function difference(left, right) {
  	    const blocked = new Set(right);
  	    return uniqueValues(left).filter(value => !blocked.has(value));
  	  }

  	  function equalsSet(a, b) {
  	    const left = uniqueValues(a).sort();
  	    const right = uniqueValues(b).sort();
  	    return left.length === right.length && left.every((value, index) => value === right[index]);
  	  }

  	  function parseNumber(value, fallback = 0) {
  	    if (value === "" || value === undefined || value === null) return fallback;
  	    const number = Number(value);
  	    return Number.isFinite(number) ? number : fallback;
  	  }

  	  function parseBoolean(value) {
  	    if (typeof value === "boolean") return value;
  	    return ["true", "1", "yes", "on"].includes(lower(value));
  	  }

  	  function getDeep(object, path, fallback) {
  	    let current = object;
  	    for (const key of path) {
  	      if (current === undefined || current === null) return fallback;
  	      current = current[key];
  	    }
  	    return current === undefined || current === null ? fallback : current;
  	  }

  	  function setDeep(object, path, value) {
  	    let current = object;
  	    path.forEach((key, index) => {
  	      if (index === path.length - 1) {
  	        current[key] = value;
  	        return;
  	      }
  	      const next = path[index + 1];
  	      if (typeof next === "number") {
  	        if (!Array.isArray(current[key])) current[key] = [];
  	      } else if (!isObject(current[key])) {
  	        current[key] = {};
  	      }
  	      current = current[key];
  	    });
  	  }

  	  function parseJson(value, fallback = {}) {
  	    if (isObject(value) || Array.isArray(value)) return clone(value);
  	    const source = clean(value);
  	    if (!source) return clone(fallback);
  	    try { return JSON.parse(source); }
  	    catch (error) { throw new Error(`Invalid JSON: ${error.message}`); }
  	  }

  	  function prettyJson(value) {
  	    try { return JSON.stringify(value ?? {}, null, 2); }
  	    catch (_) { return "{}"; }
  	  }

  	  function randomId(prefix = "id") {
  	    try {
  	      if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
  	        return `${prefix}-${crypto.randomUUID()}`;
  	      }
  	    } catch (_) {}
  	    return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  	  }

  	  function encodeSnapshot(value) {
  	    const json = JSON.stringify(value);
  	    try { return `FIFSM1:${btoa(unescape(encodeURIComponent(json)))}`; }
  	    catch (_) { return `FIFSM1:${json}`; }
  	  }

  	  function decodeSnapshot(value) {
  	    const source = clean(value);
  	    if (!source.startsWith("FIFSM1:")) return null;
  	    const body = source.slice(7);
  	    try { return JSON.parse(decodeURIComponent(escape(atob(body)))); }
  	    catch (_) {
  	      try { return JSON.parse(body); }
  	      catch (_) { return null; }
  	    }
  	  }

  	  function safeForSave(value, options = {}) {
  	    const relationFields = options.relationFields || RELATION_FIELDS;

  	    function walk(node, keyName, depth = 0) {
  	      if (node === undefined) return undefined;
  	      if (node === null || typeof node === "string" || typeof node === "number" || typeof node === "boolean") {
  	        return node;
  	      }
  	      if (node instanceof Date) return node.toISOString();
  	      if (Array.isArray(node)) return node.map(item => walk(item, "", depth + 1)).filter(item => item !== undefined);
  	      if (!isObject(node)) return undefined;

  	      const out = {};
  	      Object.keys(node).forEach(key => {
  	        if (key.startsWith("__") || key === "___class") return;
  	        if (depth === 0 && relationFields.has(key)) return;
  	        if (key === "password" && options.removePassword !== false) return;
  	        const child = walk(node[key], key, depth + 1);
  	        if (child !== undefined) out[key] = child;
  	      });
  	      return out;
  	    }

  	    return walk(clone(value), "", 0);
  	  }

  	  function log(...args) {
  	    if (DEVELOPMENT) console.log(`[FIF Settings ${VERSION}]`, ...args);
  	  }

  	  function warn(...args) {
  	    console.warn(`[FIF Settings ${VERSION}]`, ...args);
  	  }

  	  function refreshBindings() {
  	    try { BackendlessUI?.App?.refresh?.(); } catch (_) {}
  	  }

  	  /* ========================================================================
  	   * 4. IDENTITY AND NORMALIZATION
  	   * ====================================================================== */

  	  function canonicalApp(value) {
  	    const token = clean(value).replace(/[\s_-]+/g, "").toUpperCase();
  	    if (token === "BOWSEER" || token === "BOWSER" || token === "FUEL") return "Bowser";
  	    if (token === "OFFICE") return "Office";
  	    if (token === "ROAD") return "Road";
  	    if (token === "FIFC") return "FIFC";
  	    if (token === "FIFM") return "FIFM";
  	    return "";
  	  }

  	  function canonicalOffice(value) {
  	    const token = clean(value).replace(/[\s_-]+/g, "").toUpperCase();
  	    const map = {
  	      LIVETRACK: "LiveTrack",
  	      BOWSER: "Bowser",
  	      BOWSEER: "Bowser",
  	      AGRI: "Agri",
  	      DASH: "Dash",
  	      DASHBOARD: "Dash",
  	      LOCATIONS: "Locations",
  	      SETTINGS: "Settings"
  	    };
  	    return map[token] || "";
  	  }

  	  function canonicalSetting(value) {
  	    const token = clean(value).replace(/[\s_-]+/g, "").toUpperCase();
  	    const map = {
  	      APPLICATIONS: "Applications",
  	      LOCATIONS: "Locations",
  	      USERS: "Users",
  	      VEHICLES: "Vehicles"
  	    };
  	    return map[token] || "";
  	  }

  	  function canonicalRole(value) {
  	    const token = clean(value).replace(/[\s_-]+/g, "").toUpperCase();
  	    const map = {
  	      DIRECTOR: "Director",
  	      FINANCIAL: "Financial",
  	      ADMIN: "Admin",
  	      DRIVER: "Driver",
  	      LOADPLANNER: "Load Planner",
  	      MECHANIC: "Mechanic",
  	      BOWSER: "Bowser",
  	      BOWSEER: "Bowser"
  	    };
  	    return map[token] || "";
  	  }

  	  function normalizeAppValues(value) {
  	    return uniqueValues(splitCsv(value).map(canonicalApp).filter(Boolean))
  	      .filter(item => ACCESS_SCHEMA.apps.includes(item));
  	  }

  	  function normalizeOfficeValues(value) {
  	    return uniqueValues(splitCsv(value).map(canonicalOffice).filter(Boolean))
  	      .filter(item => ACCESS_SCHEMA.office.includes(item));
  	  }

  	  function normalizeSettingsValues(value) {
  	    return uniqueValues(splitCsv(value).map(canonicalSetting).filter(Boolean))
  	      .filter(item => ACCESS_SCHEMA.settings.includes(item));
  	  }

  	  function normalizeRoleValues(value) {
  	    return uniqueValues(splitCsv(value).map(canonicalRole).filter(Boolean))
  	      .filter(item => ACCESS_SCHEMA.roles.includes(item));
  	  }

  	  function normalizeHome(value, officeValues) {
  	    const home = canonicalOffice(value);
  	    const office = normalizeOfficeValues(officeValues);
  	    if (home && office.includes(home)) return home;
  	    return office[0] || "";
  	  }

  	  function objectId(record) {
  	    return clean(record?.objectId || record?.ObjectId || record?.objectID);
  	  }

  	  function userObjectId(user) {
  	    return objectId(user);
  	  }

  	  function companyObjectId(company) {
  	    return objectId(company);
  	  }

  	  function companyBusinessId(company) {
  	    return clean(company?.CompanyId);
  	  }

  	  function companyName(company) {
  	    return clean(
  	      company?.Name ||
  	      getDeep(company, ["Data", "Profile", "Company_Name", "value"], "") ||
  	      getDeep(company, ["Data", "Profile", "Trading_As", "value"], "") ||
  	      companyBusinessId(company) ||
  	      companyObjectId(company) ||
  	      "Company"
  	    );
  	  }

  	  function companyStatus(company) {
  	    return clean(company?.Status || "ACTIVE").toUpperCase();
  	  }

  	  function userNationalId(user) {
  	    return clean(user?.ID || user?.Local_Key || getDeep(user, ["Data_Details", "employee_details", "id_number"], ""));
  	  }

  	  function employeeDetails(user) {
  	    return getDeep(user, ["Data_Details", "employee_details"], {});
  	  }

  	  function userDisplayName(user) {
  	    const details = employeeDetails(user);
  	    const combined = [clean(details.first_name), clean(details.last_name)].filter(Boolean).join(" ");
  	    return combined || clean(user?.name || user?.email || userNationalId(user) || userObjectId(user) || "User");
  	  }

  	  function defaultEmployeeDetails() {
  	    return {
  	      gender: "",
  	      address: { city: "", street: "", suburb: "", province: "", postal_code: "" },
  	      passport: { issue_date: "", expiry_date: "", passport_number: "", country_of_issue: "" },
  	      id_number: "",
  	      last_name: "",
  	      first_name: "",
  	      tax_number: "",
  	      employee_id: "",
  	      nationality: "",
  	      next_of_kin: {
  	        email: "",
  	        address: { city: "", street: "", suburb: "", province: "", postal_code: "" },
  	        last_name: "",
  	        first_name: "",
  	        phone_number: "",
  	        relationship: ""
  	      },
  	      date_of_birth: "",
  	      marital_status: "",
  	      contact_details: { email: "", phone_number: "" },
  	      drivers_license: {
  	        pdp: { pdp_number: "", expiry_date: "" },
  	        permits: [],
  	        issue_date: "",
  	        expiry_date: "",
  	        endorsements: [],
  	        license_code: "",
  	        license_number: "",
  	        available_license_codes: ["A1", "A", "B", "C1", "C", "EB", "EC1", "EC"]
  	      },
  	      emergency_contacts: [],
  	      employment_details: {
  	        job_title: "",
  	        department: "",
  	        start_date: "",
  	        bank_details: { bank_name: "", branch_code: "", account_number: "" },
  	        pay_frequency: "Monthly",
  	        employment_type: "Permanent",
  	        work_hours_per_week: "",
  	        employment_start_date: ""
  	      }
  	    };
  	  }

  	  function defaultUser() {
  	    return {
  	      email: "",
  	      name: "",
  	      ID: "",
  	      Local_Key: "",
  	      APP: "",
  	      Office: "",
  	      Settings: "",
  	      Role: "",
  	      Home: "",
  	      userStatus: "ENABLED",
  	      loginEnabled: true,
  	      Data_Details: { employee_details: defaultEmployeeDetails() },
  	      Data_Wages: {}
  	    };
  	  }

  	  function normalizeUser(source) {
  	    const user = merge(defaultUser(), clone(source || {}));
  	    const apps = normalizeAppValues(user.APP);
  	    const office = normalizeOfficeValues(user.Office);
  	    const settings = normalizeSettingsValues(user.Settings);
  	    const roles = normalizeRoleValues(user.Role);

  	    user.APP = joinCsv(apps);
  	    user.Office = joinCsv(office);
  	    user.Settings = joinCsv(settings);
  	    user.Role = joinCsv(roles);
  	    user.Home = normalizeHome(user.Home, office);
  	    user.email = lower(user.email || getDeep(user, ["Data_Details", "employee_details", "contact_details", "email"], ""));

  	    const details = merge(defaultEmployeeDetails(), employeeDetails(user));
  	    details.contact_details = merge(defaultEmployeeDetails().contact_details, details.contact_details || {});
  	    details.address = merge(defaultEmployeeDetails().address, details.address || {});
  	    details.next_of_kin = merge(defaultEmployeeDetails().next_of_kin, details.next_of_kin || {});
  	    details.next_of_kin.address = merge(defaultEmployeeDetails().next_of_kin.address, details.next_of_kin.address || {});
  	    details.drivers_license = merge(defaultEmployeeDetails().drivers_license, details.drivers_license || {});
  	    details.drivers_license.pdp = merge(defaultEmployeeDetails().drivers_license.pdp, details.drivers_license.pdp || {});
  	    details.employment_details = merge(defaultEmployeeDetails().employment_details, details.employment_details || {});
  	    details.employment_details.bank_details = merge(defaultEmployeeDetails().employment_details.bank_details, details.employment_details.bank_details || {});
  	    details.contact_details.email = user.email;
  	    details.id_number = clean(details.id_number || user.ID || user.Local_Key);

  	    user.Data_Details = { ...(isObject(user.Data_Details) ? user.Data_Details : {}), employee_details: details };
  	    user.ID = clean(user.ID || details.id_number);
  	    user.Local_Key = clean(user.Local_Key || user.ID);
  	    user.name = userDisplayName(user);
  	    user.Companies = Array.isArray(source?.Companies) ? source.Companies.map(normalizeCompany) : [];
  	    return user;
  	  }

  	  function normalizeCompany(source) {
  	    const company = clone(source || {});
  	    company.Name = companyName(company);
  	    company.CompanyId = companyBusinessId(company);
  	    company.Status = companyStatus(company);
  	    return company;
  	  }

  	  /* ========================================================================
  	   * 5. AUTHORITY, COMPANY SCOPE, AND POLICY
  	   * ====================================================================== */

  	  function resolveAuthority(sourceUser) {
  	    const user = normalizeUser(sourceUser);
  	    const apps = normalizeAppValues(user.APP);
  	    const office = normalizeOfficeValues(user.Office);
  	    const settings = normalizeSettingsValues(user.Settings);
  	    const roles = normalizeRoleValues(user.Role);
  	    const home = normalizeHome(user.Home, office);

  	    let platform = "CUSTOMER";
  	    let level = "USER";

  	    if (apps.includes("FIFM")) {
  	      platform = "FIFM";
  	      level = "FIFM";
  	    } else if (apps.includes("FIFC")) {
  	      platform = "FIFC";
  	      level = "FIFC";
  	    } else if (roles.includes("Director")) {
  	      platform = "CUSTOMER";
  	      level = "DIRECTOR";
  	    }

  	    return Object.freeze({
  	      platform,
  	      level,
  	      isFIFM: level === "FIFM",
  	      isFIFC: level === "FIFC",
  	      isDirector: level === "DIRECTOR",
  	      isCustomerUser: level === "DIRECTOR" || level === "USER",
  	      unrestricted: level === "FIFM",
  	      apps: Object.freeze(apps),
  	      office: Object.freeze(office),
  	      settings: Object.freeze(settings),
  	      roles: Object.freeze(roles),
  	      home
  	    });
  	  }

  	  function getUserPermissionsForCompany(user, company) {
  	    const authority = resolveAuthority(user);
  	    return {
  	      companyObjectId: companyObjectId(company),
  	      apps: authority.apps.slice(),
  	      office: authority.office.slice(),
  	      settings: authority.settings.slice(),
  	      roles: authority.roles.slice(),
  	      home: authority.home,
  	      source: "GLOBAL_USERS_FIELDS"
  	    };
  	  }

  	  function relationList(source, name) {
  	    return Array.isArray(source?.[name]) ? source[name] : [];
  	  }

  	  function resolveCompanyScope(user, authority, allCompanies) {
  	    const all = uniqueRecords(allCompanies.map(normalizeCompany));
  	    const assigned = uniqueRecords(relationList(user, "Companies").map(normalizeCompany));
  	    const assignedIds = new Set(assigned.map(companyObjectId).filter(Boolean));

  	    if (authority.isFIFM) {
  	      return {
  	        unrestricted: true,
  	        allCompanies: all,
  	        assignedCompanies: assigned,
  	        managedCompanies: assigned,
  	        selectableCompanies: all
  	      };
  	    }

  	    const selectable = all.filter(company => assignedIds.has(companyObjectId(company)));
  	    const fallback = selectable.length ? selectable : assigned;
  	    return {
  	      unrestricted: false,
  	      allCompanies: all,
  	      assignedCompanies: assigned,
  	      managedCompanies: [],
  	      selectableCompanies: fallback
  	    };
  	  }

  	  function uniqueRecords(records) {
  	    const output = [];
  	    const seen = new Set();
  	    records.forEach(record => {
  	      const key = objectId(record) || `${companyBusinessId(record)}|${companyName(record)}`;
  	      if (!key || seen.has(key)) return;
  	      seen.add(key);
  	      output.push(record);
  	    });
  	    return output;
  	  }

  	  function canAccessCompany(authority, companyScope, company) {
  	    if (!company || !companyObjectId(company)) return false;
  	    if (authority.isFIFM) return true;
  	    const allowed = new Set(companyScope.selectableCompanies.map(companyObjectId));
  	    return allowed.has(companyObjectId(company));
  	  }

  	  function dependencies(userOrAuthority) {
  	    const source = userOrAuthority?.apps ? userOrAuthority : resolveAuthority(userOrAuthority);
  	    return {
  	      hasOffice: source.apps.includes("Office"),
  	      hasRoad: source.apps.includes("Road"),
  	      hasBowserApp: source.apps.includes("Bowser"),
  	      hasOfficeSettings: source.apps.includes("Office") && source.office.includes("Settings"),
  	      hasUsersSettings: source.apps.includes("Office") && source.office.includes("Settings") && source.settings.includes("Users"),
  	      hasVehicleSettings: source.apps.includes("Office") && source.office.includes("Settings") && source.settings.includes("Vehicles"),
  	      hasLocationSettings: source.apps.includes("Office") && source.office.includes("Settings") && source.settings.includes("Locations"),
  	      hasApplicationSettings: source.apps.includes("Office") && source.office.includes("Settings") && source.settings.includes("Applications")
  	    };
  	  }

  	  function createPolicyEngine(authority, currentUser) {
  	    const deps = dependencies(authority);
  	    const roles = new Set(authority.roles);
  	    const apps = new Set(authority.apps);
  	    const office = new Set(authority.office);
  	    const isAdmin = roles.has("Admin");
  	    const isMechanic = roles.has("Mechanic");
  	    const isBowser = roles.has("Bowser") || apps.has("Bowser") || office.has("Bowser");
  	    const isPlanner = roles.has("Load Planner");
  	    const isDriver = roles.has("Driver");
  	    const isFinancial = roles.has("Financial");

  	    function can(action, context = {}) {
  	      if (authority.isFIFM) return true;

  	      if (context.company && state.companyScope && !canAccessCompany(authority, state.companyScope, context.company)) {
  	        return false;
  	      }

  	      if (authority.isFIFC) {
  	        switch (action) {
  	          case ACTIONS.COMPANIES_VIEW_ASSIGNED:
  	          case ACTIONS.PLATFORM_VIEW:
  	            return true;
  	          case ACTIONS.FUEL_VIEW:
  	          case ACTIONS.FUEL_CORRECT:
  	          case ACTIONS.FUEL_REVERSE:
  	          case ACTIONS.TANKS_VIEW:
  	          case ACTIONS.BOWSERS_VIEW:
  	            return isBowser || isAdmin;
  	          case ACTIONS.LOADS_VIEW:
  	          case ACTIONS.LOADS_CORRECT:
  	          case ACTIONS.TRIPS_VIEW:
  	          case ACTIONS.TRIPS_CORRECT:
  	          case ACTIONS.JOBS_VIEW:
  	          case ACTIONS.JOBS_CORRECT:
  	          case ACTIONS.ROUTES_VIEW:
  	            return isPlanner || isAdmin;
  	          case ACTIONS.VEHICLES_VIEW:
  	          case ACTIONS.VEHICLES_EDIT:
  	          case ACTIONS.VEHICLES_TECHNICAL:
  	          case ACTIONS.VEHICLES_SERVICE:
  	          case ACTIONS.VEHICLES_COMPLIANCE:
  	          case ACTIONS.TRAILERS_VIEW:
  	          case ACTIONS.TRAILERS_EDIT:
  	          case ACTIONS.IMPLEMENTS_VIEW:
  	          case ACTIONS.IMPLEMENTS_EDIT:
  	          case ACTIONS.TYRES_VIEW:
  	          case ACTIONS.TYRES_EDIT:
  	          case ACTIONS.TYRES_FIT:
  	            return isMechanic || isAdmin;
  	          case ACTIONS.LOCATIONS_VIEW:
  	            return isPlanner || isDriver || isAdmin;
  	          case ACTIONS.AUDIT_VIEW:
  	            return true;
  	          default:
  	            return false;
  	        }
  	      }

  	      const director = authority.isDirector;
  	      switch (action) {
  	        case ACTIONS.PLATFORM_VIEW:
  	        case ACTIONS.COMPANIES_VIEW_ASSIGNED:
  	          return true;
  	        case ACTIONS.COMPANIES_EDIT:
  	          return director && (isAdmin || deps.hasOfficeSettings);
  	        case ACTIONS.USERS_VIEW:
  	          return deps.hasUsersSettings && (director || isAdmin);
  	        case ACTIONS.USERS_CREATE:
  	        case ACTIONS.USERS_EDIT_PERMISSIONS:
  	          return director && deps.hasUsersSettings;
  	        case ACTIONS.USERS_EDIT_PROFILE:
  	        case ACTIONS.USERS_EDIT_EMPLOYMENT:
  	        case ACTIONS.USERS_DISABLE:
  	          return deps.hasUsersSettings && (director || isAdmin);
  	        case ACTIONS.USERS_EDIT_PAYROLL:
  	          return isFinancial && deps.hasUsersSettings;
  	        case ACTIONS.APPLICATIONS_VIEW:
  	          return deps.hasApplicationSettings;
  	        case ACTIONS.APPLICATIONS_EDIT:
  	          return director && deps.hasApplicationSettings;
  	        case ACTIONS.LOCATIONS_VIEW:
  	          return office.has("Locations") || deps.hasLocationSettings || isPlanner || isDriver || isAdmin;
  	        case ACTIONS.LOCATIONS_CREATE:
  	        case ACTIONS.LOCATIONS_EDIT:
  	          return deps.hasLocationSettings && (director || isAdmin || isPlanner);
  	        case ACTIONS.LOCATIONS_DELETE:
  	          return director && deps.hasLocationSettings;
  	        case ACTIONS.VEHICLES_VIEW:
  	        case ACTIONS.TRAILERS_VIEW:
  	        case ACTIONS.IMPLEMENTS_VIEW:
  	        case ACTIONS.TYRES_VIEW:
  	          return deps.hasVehicleSettings || isMechanic || isPlanner || isDriver;
  	        case ACTIONS.VEHICLES_CREATE:
  	        case ACTIONS.VEHICLES_EDIT:
  	        case ACTIONS.TRAILERS_CREATE:
  	        case ACTIONS.TRAILERS_EDIT:
  	        case ACTIONS.IMPLEMENTS_CREATE:
  	        case ACTIONS.IMPLEMENTS_EDIT:
  	        case ACTIONS.TYRES_CREATE:
  	        case ACTIONS.TYRES_EDIT:
  	        case ACTIONS.TYRES_FIT:
  	          return (director || isMechanic || isAdmin) && (deps.hasVehicleSettings || isMechanic);
  	        case ACTIONS.VEHICLES_TECHNICAL:
  	        case ACTIONS.VEHICLES_SERVICE:
  	        case ACTIONS.VEHICLES_COMPLIANCE:
  	          return isMechanic || (director && deps.hasVehicleSettings);
  	        case ACTIONS.VEHICLES_FINANCIAL:
  	          return isFinancial || (director && deps.hasVehicleSettings);
  	        case ACTIONS.VEHICLES_DELETE:
  	        case ACTIONS.TRAILERS_DELETE:
  	        case ACTIONS.IMPLEMENTS_DELETE:
  	        case ACTIONS.TYRES_DELETE:
  	          return director && deps.hasVehicleSettings;
  	        case ACTIONS.TANKS_VIEW:
  	        case ACTIONS.BOWSERS_VIEW:
  	        case ACTIONS.FUEL_VIEW:
  	          return isBowser;
  	        case ACTIONS.TANKS_CREATE:
  	        case ACTIONS.TANKS_EDIT:
  	        case ACTIONS.BOWSERS_CREATE:
  	        case ACTIONS.BOWSERS_EDIT:
  	        case ACTIONS.FUEL_CAPTURE:
  	          return isBowser && (director || isAdmin || roles.has("Bowser"));
  	        case ACTIONS.TANKS_DELETE:
  	        case ACTIONS.BOWSERS_DELETE:
  	          return director && isBowser;
  	        case ACTIONS.FUEL_CORRECT:
  	        case ACTIONS.FUEL_REVERSE:
  	          return director && isBowser;
  	        case ACTIONS.LOADS_VIEW:
  	        case ACTIONS.TRIPS_VIEW:
  	        case ACTIONS.JOBS_VIEW:
  	        case ACTIONS.ROUTES_VIEW:
  	          return apps.has("Road") || isPlanner || isDriver;
  	        case ACTIONS.LOADS_CREATE:
  	        case ACTIONS.LOADS_EDIT:
  	        case ACTIONS.ROUTES_EDIT:
  	          return isPlanner || (director && apps.has("Road"));
  	        case ACTIONS.LOADS_CORRECT:
  	        case ACTIONS.TRIPS_CORRECT:
  	        case ACTIONS.JOBS_CORRECT:
  	          return director && (isPlanner || isAdmin);
  	        case ACTIONS.AUDIT_VIEW:
  	          return director || isAdmin;
  	        default:
  	          return false;
  	      }
  	    }

  	    return Object.freeze({
  	      can,
  	      authority,
  	      currentUser,
  	      grantEnvelope() {
  	        if (authority.isFIFM) {
  	          return {
  	            apps: ACCESS_SCHEMA.apps.slice(),
  	            office: ACCESS_SCHEMA.office.slice(),
  	            settings: ACCESS_SCHEMA.settings.slice(),
  	            roles: ACCESS_SCHEMA.roles.slice(),
  	            homes: ACCESS_SCHEMA.homes.slice()
  	          };
  	        }
  	        if (authority.isDirector) {
  	          return {
  	            apps: intersect(authority.apps, ACCESS_SCHEMA.ordinaryApps),
  	            office: authority.office.slice(),
  	            settings: authority.settings.slice(),
  	            roles: difference(authority.roles, ["Director"]),
  	            homes: authority.office.slice()
  	          };
  	        }
  	        return { apps: [], office: [], settings: [], roles: [], homes: [] };
  	      }
  	    });
  	  }

  	  function validateDelegation(actorAuthority, targetUser, selectedCompanies) {
  	    const target = normalizeUser(targetUser);
  	    const targetAuthority = resolveAuthority(target);

  	    if (actorAuthority.isFIFM) return target;
  	    if (!actorAuthority.isDirector) throw new Error("This user may not delegate permissions.");
  	    if (targetAuthority.isFIFM || targetAuthority.isFIFC || targetAuthority.isDirector) {
  	      throw new Error("A Director may not assign FIFM, FIFC, or Director authority.");
  	    }

  	    const envelope = state.access.grantEnvelope();
  	    const targetApps = normalizeAppValues(target.APP);
  	    const targetOffice = normalizeOfficeValues(target.Office);
  	    const targetSettings = normalizeSettingsValues(target.Settings);
  	    const targetRoles = normalizeRoleValues(target.Role);

  	    if (!targetApps.every(value => envelope.apps.includes(value))) throw new Error("The selected APP permissions exceed the Director's authority.");
  	    if (!targetOffice.every(value => envelope.office.includes(value))) throw new Error("The selected Office permissions exceed the Director's authority.");
  	    if (!targetSettings.every(value => envelope.settings.includes(value))) throw new Error("The selected Settings permissions exceed the Director's authority.");
  	    if (!targetRoles.every(value => envelope.roles.includes(value))) throw new Error("The selected Roles exceed the Director's authority.");
  	    if (selectedCompanies?.length && selectedCompanies.some(company => companyObjectId(company) !== state.selectedCompanyObjectId)) {
  	      throw new Error("A Director may create or edit users only in the selected company.");
  	    }
  	    return target;
  	  }

  	  function validatePermissionDependencies(user) {
  	    const normal = normalizeUser(user);
  	    const apps = normalizeAppValues(normal.APP);
  	    const office = normalizeOfficeValues(normal.Office);
  	    const settings = normalizeSettingsValues(normal.Settings);

  	    if (settings.length && (!apps.includes("Office") || !office.includes("Settings"))) {
  	      throw new Error("Settings permissions require APP: Office and Office: Settings.");
  	    }
  	    if (normal.Home && !office.includes(normal.Home)) {
  	      throw new Error("Home must be one of the user's Office permissions.");
  	    }
  	    return normal;
  	  }

  	  /* ========================================================================
  	   * 6. APPLICATION STATE
  	   * ====================================================================== */

  	  const state = {
  	    mounted: false,
  	    loading: false,
  	    saving: false,
  	    currentUser: normalizeUser(APP_DATA.User),
  	    authority: null,
  	    access: null,
  	    companyScope: null,
  	    allCompanies: [],
  	    managedCompanies: [],
  	    selectableCompanies: [],
  	    selectedCompanyObjectId: "",
  	    activeSection: "",
  	    activeRecord: null,
  	    modal: null,
  	    filters: Object.create(null),
  	    drafts: Object.create(null),
  	    dirty: Object.create(null),
  	    caches: {
  	      usersAll: null,
  	      employees: Object.create(null),
  	      tractors: Object.create(null),
  	      trailers: Object.create(null),
  	      tanks: Object.create(null),
  	      bowsers: Object.create(null),
  	      tyres: Object.create(null),
  	      locations: Object.create(null),
  	      routes: Object.create(null),
  	      fuelOut: Object.create(null),
  	      loads: Object.create(null),
  	      trips: Object.create(null),
  	      jobs: Object.create(null),
  	      audit: []
  	    },
  	    errors: [],
  	    toastTimer: null,
  	    root: null,
  	    priorBodyOverflow: document.body.style.overflow || ""
  	  };

  	  state.authority = resolveAuthority(state.currentUser);
  	  state.access = createPolicyEngine(state.authority, state.currentUser);

  	  function selectedCompany() {
  	    return state.selectableCompanies.find(company => companyObjectId(company) === state.selectedCompanyObjectId) || null;
  	  }

  	  function requireSelectedCompany(action) {
  	    const company = selectedCompany();
  	    if (!company) throw new Error("Select a company before continuing.");
  	    if (!canAccessCompany(state.authority, state.companyScope, company)) throw new Error("You do not have access to this company.");
  	    if (action && !state.access.can(action, { company })) throw new Error("You are not authorised to perform this action.");
  	    return company;
  	  }

  	  function assertAction(action, context = {}) {
  	    if (!state.access.can(action, context)) throw new Error("You are not authorised to perform this action.");
  	  }

  	  /* ========================================================================
  	   * 7. BACKENDLESS DATA ACCESS
  	   * ====================================================================== */

  	  function hasBackendlessData() {
  	    return !!(BackendlessApi?.Data && typeof BackendlessApi.Data.of === "function");
  	  }

  	  function store(table) {
  	    if (!hasBackendlessData()) throw new Error("Backendless Data is unavailable.");
  	    return BackendlessApi.Data.of(table);
  	  }

  	  function queryBuilder() {
  	    try { return BackendlessApi?.DataQueryBuilder?.create?.() || null; }
  	    catch (_) { return null; }
  	  }

  	  function escapeWhere(value) {
  	    return text(value).replace(/'/g, "''");
  	  }

  	  async function findAll(table, options = {}) {
  	    const fallback = Array.isArray(options.fallback) ? options.fallback.map(clone) : [];
  	    if (!hasBackendlessData()) return fallback;

  	    const builder = queryBuilder();
  	    if (!builder) return fallback;
  	    const pageSize = Math.max(1, Math.min(100, options.pageSize || 100));
  	    const maxRows = Math.max(pageSize, options.maxRows || 2000);
  	    const output = [];
  	    let offset = 0;

  	    while (offset < maxRows) {
  	      if (options.where) builder.setWhereClause(options.where);
  	      if (options.sortBy && builder.setSortBy) builder.setSortBy(options.sortBy);
  	      if (options.properties && builder.setProperties) builder.setProperties(options.properties);
  	      if (options.relations && builder.setRelated) builder.setRelated(options.relations);
  	      builder.setPageSize(pageSize);
  	      if (builder.setOffset) builder.setOffset(offset);

  	      const result = await store(table).find(builder);
  	      const rows = Array.isArray(result) ? result : Array.isArray(result?.data) ? result.data : [];
  	      output.push(...rows);
  	      if (rows.length < pageSize) break;
  	      offset += rows.length;
  	    }
  	    return output;
  	  }

  	  async function findOne(table, where, tolerateMissingField = false) {
  	    try {
  	      const rows = await findAll(table, { where, maxRows: 10, pageSize: 10 });
  	      return rows[0] || null;
  	    } catch (error) {
  	      if (tolerateMissingField) {
  	        warn(`Lookup skipped for ${table}:`, error?.message || error);
  	        return null;
  	      }
  	      throw error;
  	    }
  	  }

  	  async function findByObjectId(table, id) {
  	    const key = clean(id);
  	    if (!key) return null;
  	    const dataStore = store(table);
  	    if (typeof dataStore.findById === "function") {
  	      try { return await dataStore.findById(key); }
  	      catch (_) {}
  	    }
  	    return findOne(table, `objectId = '${escapeWhere(key)}'`);
  	  }

  	  async function saveRecord(table, payload, options = {}) {
  	    const cleanPayload = options.alreadySafe ? clone(payload) : safeForSave(payload, options);
  	    if (options.newRecord) delete cleanPayload.objectId;
  	    const saved = await store(table).save(cleanPayload);
  	    if (!objectId(saved)) throw new Error(`Backendless did not confirm the ${table} save.`);
  	    return saved;
  	  }

  	  async function deleteRecord(table, record) {
  	    const id = objectId(record);
  	    if (!id) throw new Error(`Cannot delete ${table}: missing objectId.`);
  	    const dataStore = store(table);
  	    if (typeof dataStore.remove !== "function") throw new Error(`Backendless remove is unavailable for ${table}.`);
  	    return dataStore.remove({ objectId: id });
  	  }

  	  async function loadRelation(parentTable, parentId, relation, fallback = []) {
  	    const id = clean(parentId);
  	    if (!id || !hasBackendlessData()) return clone(fallback);
  	    const dataStore = store(parentTable);
  	    if (typeof dataStore.loadRelations !== "function") return clone(fallback);

  	    try {
  	      if (BackendlessApi?.LoadRelationsQueryBuilder?.create) {
  	        const builder = BackendlessApi.LoadRelationsQueryBuilder.create();
  	        builder.setRelationName(relation.name || relation);
  	        builder.setPageSize?.(100);
  	        const result = await dataStore.loadRelations(id, builder);
  	        return Array.isArray(result) ? result : Array.isArray(result?.data) ? result.data : [];
  	      }
  	    } catch (error) {
  	      warn(`Relation builder load failed: ${parentTable}.${relation.name || relation}`, error?.message || error);
  	    }

  	    const result = await dataStore.loadRelations(id, relation.name || relation, { pageSize: 100, offset: 0 });
  	    return Array.isArray(result) ? result : Array.isArray(result?.data) ? result.data : [];
  	  }

  	  async function addRelation(parentRecord, relation, childRecords) {
  	    const parentId = objectId(parentRecord);
  	    const children = (Array.isArray(childRecords) ? childRecords : [childRecords])
  	      .map(record => ({ objectId: objectId(record) }))
  	      .filter(record => record.objectId);
  	    if (!parentId || !children.length) return;

  	    const dataStore = store(relation.parentTable);
  	    if (typeof dataStore.addRelation !== "function") throw new Error("Backendless addRelation is unavailable.");
  	    try {
  	      return await dataStore.addRelation({ objectId: parentId }, relation.definition, children);
  	    } catch (firstError) {
  	      try {
  	        return await dataStore.addRelation({ objectId: parentId }, relation.name, children);
  	      } catch (secondError) {
  	        throw new Error(`Could not add ${relation.name} relation: ${secondError.message || firstError.message}`);
  	      }
  	    }
  	  }

  	  async function removeRelation(parentRecord, relation, childRecords) {
  	    const parentId = objectId(parentRecord);
  	    const children = (Array.isArray(childRecords) ? childRecords : [childRecords])
  	      .map(record => ({ objectId: objectId(record) }))
  	      .filter(record => record.objectId);
  	    if (!parentId || !children.length) return;

  	    const dataStore = store(relation.parentTable);
  	    if (typeof dataStore.deleteRelation !== "function") throw new Error("Backendless deleteRelation is unavailable.");
  	    return dataStore.deleteRelation({ objectId: parentId }, relation.name, children);
  	  }

  	  function replaceInArray(array, record, normalizer = clone) {
  	    const list = Array.isArray(array) ? array : [];
  	    const id = objectId(record);
  	    const index = list.findIndex(item => objectId(item) === id);
  	    const value = normalizer(record);
  	    if (index >= 0) list[index] = value;
  	    else list.push(value);
  	    return list;
  	  }

  	  function removeFromArray(array, record) {
  	    const id = objectId(record);
  	    return (Array.isArray(array) ? array : []).filter(item => objectId(item) !== id);
  	  }

  	  function updateAppUser(user) {
  	    const normal = normalizeUser(user);
  	    if (userObjectId(normal) === userObjectId(state.currentUser)) {
  	      Object.assign(state.currentUser, normal);
  	      Object.assign(APP_DATA.User, clone(normal));
  	      state.authority = resolveAuthority(state.currentUser);
  	      state.access = createPolicyEngine(state.authority, state.currentUser);
  	    }
  	  }

  	  /* ========================================================================
  	   * 8. AUDIT SERVICE
  	   * ====================================================================== */

  	  const AuditService = Object.freeze({
  	    async record({ action, company, targetTable, target, before, after, reason, result = "SUCCESS", error = "" }) {
  	      const entry = {
  	        Timestamp: nowIso(),
  	        ActorObjectId: userObjectId(state.currentUser),
  	        ActorName: userDisplayName(state.currentUser),
  	        ActorAuthority: state.authority.level,
  	        CompanyObjectId: companyObjectId(company),
  	        CompanyName: company ? companyName(company) : "",
  	        Action: action,
  	        TargetTable: targetTable || "",
  	        TargetObjectId: objectId(target),
  	        BeforeValues: clone(before ?? null),
  	        AfterValues: clone(after ?? null),
  	        Reason: clean(reason),
  	        Result: result,
  	        Error: clean(error)
  	      };

  	      state.caches.audit.unshift(entry);
  	      state.caches.audit = state.caches.audit.slice(0, 500);

  	      // AuditLog is deliberately isolated. The current schema does not yet
  	      // contain this table, so a failed write must not hide the main result.
  	      if (hasBackendlessData()) {
  	        try {
  	          await saveRecord(TABLES.AUDIT, entry, { newRecord: true });
  	        } catch (auditError) {
  	          warn("AuditLog table is unavailable; audit retained in application memory.", auditError?.message || auditError);
  	        }
  	      }
  	      return entry;
  	    }
  	  });

  	  /* ========================================================================
  	   * 9. COMPANY SERVICE
  	   * ====================================================================== */

  	  const CompanyService = Object.freeze({
  	    async loadInitial() {
  	      let all = uniqueRecords([
  	        ...(Array.isArray(APP_DATA.Companies) ? APP_DATA.Companies : []),
  	        ...(Array.isArray(state.currentUser.Companies) ? state.currentUser.Companies : [])
  	      ].map(normalizeCompany));

  	      if (state.authority.isFIFM) {
  	        try {
  	          all = uniqueRecords((await findAll(TABLES.COMPANIES, { fallback: all })).map(normalizeCompany));
  	        } catch (error) {
  	          warn("All-company load failed; using App Data companies.", error?.message || error);
  	        }
  	      }

  	      if (userObjectId(state.currentUser)) {
  	        try {
  	          const assigned = await loadRelation(TABLES.USERS, userObjectId(state.currentUser), RELATIONS.USER_COMPANIES, state.currentUser.Companies);
  	          state.currentUser.Companies = assigned.map(normalizeCompany);
  	          APP_DATA.User.Companies = clone(state.currentUser.Companies);
  	          all = uniqueRecords([...all, ...state.currentUser.Companies]);
  	        } catch (error) {
  	          warn("User company relation load failed; using App Data relation.", error?.message || error);
  	        }
  	      }

  	      state.allCompanies = all.sort((a, b) => companyName(a).localeCompare(companyName(b), undefined, { sensitivity: "base", numeric: true }));
  	      state.companyScope = resolveCompanyScope(state.currentUser, state.authority, state.allCompanies);
  	      state.managedCompanies = state.companyScope.managedCompanies;
  	      state.selectableCompanies = state.companyScope.selectableCompanies;

  	      const previous = state.selectedCompanyObjectId;
  	      const valid = state.selectableCompanies.some(company => companyObjectId(company) === previous);
  	      state.selectedCompanyObjectId = valid ? previous : companyObjectId(state.selectableCompanies[0]);
  	      return state.companyScope;
  	    },

  	    async create(input) {
  	      assertAction(ACTIONS.COMPANIES_CREATE);
  	      const payload = normalizeCompany(input);
  	      payload.Name = clean(payload.Name);
  	      payload.CompanyId = clean(payload.CompanyId);
  	      payload.Status = clean(payload.Status || "ACTIVE").toUpperCase();
  	      delete payload.reason;
  	      if (!payload.Name) throw new Error("Company name is required.");
  	      if (!payload.CompanyId) throw new Error("Company business identifier is required.");

  	      const duplicateId = await findOne(TABLES.COMPANIES, `CompanyId = '${escapeWhere(payload.CompanyId)}'`);
  	      if (duplicateId) throw new Error("A company with this business identifier already exists.");
  	      const duplicateName = await findOne(TABLES.COMPANIES, `Name = '${escapeWhere(payload.Name)}'`);
  	      if (duplicateName) throw new Error("A company with this name already exists.");

  	      const saved = normalizeCompany(await saveRecord(TABLES.COMPANIES, payload, { newRecord: true }));
  	      state.allCompanies = replaceInArray(state.allCompanies, saved, normalizeCompany);
  	      APP_DATA.Companies = replaceInArray(APP_DATA.Companies || [], saved, clone);
  	      state.companyScope = resolveCompanyScope(state.currentUser, state.authority, state.allCompanies);
  	      state.selectableCompanies = state.companyScope.selectableCompanies;
  	      await AuditService.record({ action: ACTIONS.COMPANIES_CREATE, company: saved, targetTable: TABLES.COMPANIES, target: saved, before: null, after: saved, reason: input.reason || "Company created" });
  	      refreshBindings();
  	      return saved;
  	    },

  	    async update(company, changes, reason = "Company updated") {
  	      const original = normalizeCompany(company);
  	      assertAction(ACTIONS.COMPANIES_EDIT, { company: original });
  	      if (!canAccessCompany(state.authority, state.companyScope, original)) throw new Error("Company access denied.");
  	      const payload = { ...clone(original), ...clone(changes), objectId: companyObjectId(original) };
  	      if (!payload.Name) throw new Error("Company name is required.");
  	      const saved = normalizeCompany(await saveRecord(TABLES.COMPANIES, payload));
  	      state.allCompanies = replaceInArray(state.allCompanies, saved, normalizeCompany);
  	      state.selectableCompanies = replaceInArray(state.selectableCompanies, saved, normalizeCompany);
  	      APP_DATA.Companies = replaceInArray(APP_DATA.Companies || [], saved, clone);
  	      await AuditService.record({ action: ACTIONS.COMPANIES_EDIT, company: saved, targetTable: TABLES.COMPANIES, target: saved, before: original, after: saved, reason });
  	      refreshBindings();
  	      return saved;
  	    },

  	    async setStatus(company, status, reason) {
  	      assertAction(ACTIONS.COMPANIES_STATUS, { company });
  	      return this.update(company, { Status: clean(status).toUpperCase() }, reason || `Company status set to ${status}`);
  	    },

  	    async toggleManaged(company, shouldManage) {
  	      assertAction(ACTIONS.COMPANIES_MANAGE_PORTFOLIO, { company });
  	      if (!state.authority.isFIFM) throw new Error("Only FIFM may manage a personal company portfolio.");
  	      const already = state.currentUser.Companies.some(item => companyObjectId(item) === companyObjectId(company));
  	      if (shouldManage && !already) {
  	        await addRelation(state.currentUser, RELATIONS.USER_COMPANIES, company);
  	        state.currentUser.Companies.push(normalizeCompany(company));
  	      } else if (!shouldManage && already) {
  	        await removeRelation(state.currentUser, RELATIONS.USER_COMPANIES, company);
  	        state.currentUser.Companies = removeFromArray(state.currentUser.Companies, company);
  	      }
  	      APP_DATA.User.Companies = clone(state.currentUser.Companies);
  	      state.companyScope = resolveCompanyScope(state.currentUser, state.authority, state.allCompanies);
  	      state.managedCompanies = state.companyScope.managedCompanies;
  	      await AuditService.record({ action: ACTIONS.COMPANIES_MANAGE_PORTFOLIO, company, targetTable: TABLES.COMPANIES, target: company, before: { managed: already }, after: { managed: !!shouldManage }, reason: shouldManage ? "Added to managed portfolio" : "Removed from managed portfolio" });
  	      refreshBindings();
  	    }
  	  });

  	  /* ========================================================================
  	   * 10. USER AND RELATION SERVICES
  	   * ====================================================================== */

  	  function targetIsInternalStaff(user) {
  	    const authority = resolveAuthority(user);
  	    return authority.isFIFM || authority.isFIFC;
  	  }

  	  async function findDuplicateUser(user, excludeId = "") {
  	    const email = lower(user.email);
  	    const idNumber = clean(user.ID || user.Local_Key);
  	    if (email) {
  	      const found = await findOne(TABLES.USERS, `email = '${escapeWhere(email)}'`);
  	      if (found && userObjectId(found) !== excludeId) return { field: "email", user: found };
  	    }
  	    if (idNumber) {
  	      const byId = await findOne(TABLES.USERS, `ID = '${escapeWhere(idNumber)}'`, true);
  	      if (byId && userObjectId(byId) !== excludeId) return { field: "ID", user: byId };
  	      const byLocal = await findOne(TABLES.USERS, `Local_Key = '${escapeWhere(idNumber)}'`, true);
  	      if (byLocal && userObjectId(byLocal) !== excludeId) return { field: "Local_Key", user: byLocal };
  	    }
  	    return null;
  	  }

  	  async function registerBackendlessUser(user, password) {
  	    if (!BackendlessApi?.UserService?.register) throw new Error("Backendless UserService.register is unavailable.");
  	    const payload = safeForSave(user);
  	    delete payload.objectId;
  	    delete payload.password;
  	    let backendUser = {};
  	    try {
  	      if (typeof BackendlessApi.User === "function") backendUser = new BackendlessApi.User();
  	    } catch (_) {}
  	    Object.keys(payload).forEach(key => {
  	      if (typeof backendUser.setProperty === "function") backendUser.setProperty(key, payload[key]);
  	      else backendUser[key] = payload[key];
  	    });
  	    backendUser.email = payload.email;
  	    backendUser.password = password;
  	    const saved = await BackendlessApi.UserService.register(backendUser, password);
  	    if (!userObjectId(saved)) throw new Error("Backendless did not return the created user.");
  	    return normalizeUser(saved);
  	  }

  	  const RelationService = Object.freeze({
  	    async assignUserToCompany(user, company, options = {}) {
  	      const directorFixed = state.authority.isDirector && options.fixedByDirector === true && companyObjectId(company) === state.selectedCompanyObjectId;
  	      if (!state.authority.isFIFM && !directorFixed) throw new Error("Only FIFM may change company scope. Directors may only assign a newly created ordinary user to the selected company.");
  	      if (state.authority.isFIFM) assertAction(ACTIONS.COMPANIES_ASSIGN, { company });
  	      else assertAction(ACTIONS.USERS_CREATE, { company });
  	      if (!userObjectId(user) || !companyObjectId(company)) throw new Error("User and company objectIds are required.");
  	      const internal = options.internalStaff ?? targetIsInternalStaff(user);
  	      const userHas = relationList(user, "Companies").some(item => companyObjectId(item) === companyObjectId(company));
  	      if (!userHas) {
  	        await addRelation(user, RELATIONS.USER_COMPANIES, company);
  	        user.Companies = [...relationList(user, "Companies"), normalizeCompany(company)];
  	      }
  	      if (!internal) {
  	        const employees = await UserService.loadCompanyEmployees(company, { force: true });
  	        if (!employees.some(item => userObjectId(item) === userObjectId(user))) {
  	          await addRelation(company, RELATIONS.COMPANY_EMPLOYEES, user);
  	          state.caches.employees[companyObjectId(company)] = [...employees, normalizeUser(user)];
  	        }
  	      }
  	      return user;
  	    },

  	    async removeUserFromCompany(user, company, options = {}) {
  	      assertAction(ACTIONS.COMPANIES_ASSIGN, { company });
  	      const internal = options.internalStaff ?? targetIsInternalStaff(user);
  	      if (relationList(user, "Companies").some(item => companyObjectId(item) === companyObjectId(company))) {
  	        await removeRelation(user, RELATIONS.USER_COMPANIES, company);
  	        user.Companies = removeFromArray(user.Companies, company);
  	      }
  	      if (!internal) {
  	        try { await removeRelation(company, RELATIONS.COMPANY_EMPLOYEES, user); }
  	        catch (error) { warn("Employee relation removal failed.", error?.message || error); }
  	        const key = companyObjectId(company);
  	        state.caches.employees[key] = removeFromArray(state.caches.employees[key] || [], user);
  	      }
  	      return user;
  	    },

  	    async syncUserCompanies(user, desiredCompanies) {
  	      assertAction(ACTIONS.USERS_ASSIGN_COMPANIES);
  	      if (!state.authority.isFIFM) throw new Error("Only FIFM may change user company scope.");
  	      const desired = uniqueRecords((desiredCompanies || []).map(normalizeCompany));
  	      const current = uniqueRecords(relationList(user, "Companies").map(normalizeCompany));
  	      const desiredIds = new Set(desired.map(companyObjectId));
  	      const currentIds = new Set(current.map(companyObjectId));
  	      for (const company of desired) {
  	        if (!currentIds.has(companyObjectId(company))) await this.assignUserToCompany(user, company, { internalStaff: targetIsInternalStaff(user) });
  	      }
  	      for (const company of current) {
  	        if (!desiredIds.has(companyObjectId(company))) await this.removeUserFromCompany(user, company, { internalStaff: targetIsInternalStaff(user) });
  	      }
  	      user.Companies = desired;
  	      return user;
  	    }
  	  });

  	  const UserService = Object.freeze({
  	    async loadAll(options = {}) {
  	      assertAction(ACTIONS.USERS_VIEW);
  	      if (state.caches.usersAll && !options.force) return state.caches.usersAll;
  	      const rows = await findAll(TABLES.USERS, { fallback: [] });
  	      state.caches.usersAll = rows.map(normalizeUser).sort((a, b) => userDisplayName(a).localeCompare(userDisplayName(b), undefined, { sensitivity: "base", numeric: true }));
  	      return state.caches.usersAll;
  	    },

  	    async loadCompanyEmployees(company, options = {}) {
  	      assertAction(ACTIONS.USERS_VIEW, { company });
  	      const key = companyObjectId(company);
  	      if (state.caches.employees[key] && !options.force) return state.caches.employees[key];
  	      const fallback = relationList(company, "Employees");
  	      const rows = await loadRelation(TABLES.COMPANIES, key, RELATIONS.COMPANY_EMPLOYEES, fallback);
  	      state.caches.employees[key] = rows.map(normalizeUser).sort((a, b) => userDisplayName(a).localeCompare(userDisplayName(b), undefined, { sensitivity: "base", numeric: true }));
  	      return state.caches.employees[key];
  	    },

  	    async create(input, password, companies) {
  	      assertAction(ACTIONS.USERS_CREATE, { company: selectedCompany() });
  	      let user = validatePermissionDependencies(normalizeUser(input));
  	      validateDelegation(state.authority, user, companies);
  	      if (!user.email) throw new Error("Email is required.");
  	      if (!user.ID) throw new Error("National ID is required.");
  	      if (!clean(password) || clean(password).length < 8) throw new Error("A temporary password of at least 8 characters is required.");
  	      const duplicate = await findDuplicateUser(user);
  	      if (duplicate) throw new Error(`A user with this ${duplicate.field} already exists.`);

  	      const saved = await registerBackendlessUser(user, password);
  	      let desiredCompanies = uniqueRecords((companies || []).map(normalizeCompany));
  	      if (state.authority.isDirector) desiredCompanies = [requireSelectedCompany(ACTIONS.USERS_CREATE)];

  	      const completed = [];
  	      try {
  	        for (const company of desiredCompanies) {
  	          await RelationService.assignUserToCompany(saved, company, { internalStaff: targetIsInternalStaff(saved), fixedByDirector: state.authority.isDirector });
  	          completed.push(companyName(company));
  	        }
  	      } catch (error) {
  	        error.message = `User created, but company assignment failed after [${completed.join(", ")}]: ${error.message}`;
  	        throw error;
  	      }

  	      saved.Companies = desiredCompanies;
  	      if (state.caches.usersAll) state.caches.usersAll = replaceInArray(state.caches.usersAll, saved, normalizeUser);
  	      for (const company of desiredCompanies) {
  	        if (!targetIsInternalStaff(saved)) {
  	          const key = companyObjectId(company);
  	          state.caches.employees[key] = replaceInArray(state.caches.employees[key] || [], saved, normalizeUser);
  	        }
  	      }
  	      await AuditService.record({ action: ACTIONS.USERS_CREATE, company: desiredCompanies[0] || null, targetTable: TABLES.USERS, target: saved, before: null, after: saved, reason: "User created" });
  	      refreshBindings();
  	      return saved;
  	    },

  	    async update(existing, input, companies, reason = "User updated") {
  	      assertAction(ACTIONS.USERS_EDIT_PROFILE, { company: selectedCompany() });
  	      const before = normalizeUser(existing);
  	      let user = validatePermissionDependencies(normalizeUser({ ...clone(before), ...clone(input), objectId: userObjectId(before) }));
  	      validateDelegation(state.authority, user, companies);

  	      const permissionsChanged = !equalsSet(normalizeAppValues(before.APP), normalizeAppValues(user.APP)) ||
  	        !equalsSet(normalizeOfficeValues(before.Office), normalizeOfficeValues(user.Office)) ||
  	        !equalsSet(normalizeSettingsValues(before.Settings), normalizeSettingsValues(user.Settings)) ||
  	        !equalsSet(normalizeRoleValues(before.Role), normalizeRoleValues(user.Role)) || before.Home !== user.Home;
  	      if (permissionsChanged) assertAction(ACTIONS.USERS_EDIT_PERMISSIONS, { company: selectedCompany() });

  	      const duplicate = await findDuplicateUser(user, userObjectId(before));
  	      if (duplicate) throw new Error(`Another user already uses this ${duplicate.field}.`);

  	      const beforeInternal = targetIsInternalStaff(before);
  	      const saved = normalizeUser(await saveRecord(TABLES.USERS, user));
  	      saved.Companies = relationList(before, "Companies");
  	      if (state.authority.isFIFM && Array.isArray(companies)) {
  	        await RelationService.syncUserCompanies(saved, companies);
  	        const afterInternal = targetIsInternalStaff(saved);
  	        if (beforeInternal !== afterInternal) {
  	          const affectedCompanies = uniqueRecords([...relationList(before, "Companies"), ...relationList(saved, "Companies")]);
  	          for (const company of affectedCompanies) {
  	            if (afterInternal) {
  	              try { await removeRelation(company, RELATIONS.COMPANY_EMPLOYEES, saved); } catch (error) { warn("Could not remove internal staff from company employees.", error?.message || error); }
  	              state.caches.employees[companyObjectId(company)] = removeFromArray(state.caches.employees[companyObjectId(company)] || [], saved);
  	            } else if (relationList(saved, "Companies").some(item => companyObjectId(item) === companyObjectId(company))) {
  	              try { await addRelation(company, RELATIONS.COMPANY_EMPLOYEES, saved); } catch (error) { warn("Could not add customer user to company employees.", error?.message || error); }
  	              state.caches.employees[companyObjectId(company)] = replaceInArray(state.caches.employees[companyObjectId(company)] || [], saved, normalizeUser);
  	            }
  	          }
  	        }
  	      }
  	      if (state.caches.usersAll) state.caches.usersAll = replaceInArray(state.caches.usersAll, saved, normalizeUser);
  	      Object.keys(state.caches.employees).forEach(key => {
  	        if ((state.caches.employees[key] || []).some(item => userObjectId(item) === userObjectId(saved))) {
  	          state.caches.employees[key] = replaceInArray(state.caches.employees[key], saved, normalizeUser);
  	        }
  	      });
  	      updateAppUser(saved);
  	      await AuditService.record({ action: permissionsChanged ? ACTIONS.USERS_EDIT_PERMISSIONS : ACTIONS.USERS_EDIT_PROFILE, company: selectedCompany(), targetTable: TABLES.USERS, target: saved, before, after: saved, reason });
  	      refreshBindings();
  	      return saved;
  	    },

  	    async disable(user, disabled, reason) {
  	      assertAction(ACTIONS.USERS_DISABLE, { company: selectedCompany() });
  	      const before = normalizeUser(user);
  	      const saved = normalizeUser(await saveRecord(TABLES.USERS, {
  	        ...safeForSave(before),
  	        objectId: userObjectId(before),
  	        userStatus: disabled ? "DISABLED" : "ENABLED",
  	        loginEnabled: !disabled
  	      }, { alreadySafe: true }));
  	      saved.Companies = relationList(before, "Companies");
  	      if (state.caches.usersAll) state.caches.usersAll = replaceInArray(state.caches.usersAll, saved, normalizeUser);
  	      Object.keys(state.caches.employees).forEach(key => {
  	        state.caches.employees[key] = replaceInArray(state.caches.employees[key] || [], saved, normalizeUser);
  	      });
  	      await AuditService.record({ action: ACTIONS.USERS_DISABLE, company: selectedCompany(), targetTable: TABLES.USERS, target: saved, before, after: saved, reason: reason || (disabled ? "User disabled" : "User enabled") });
  	      return saved;
  	    }
  	  });

  	  /* ========================================================================
  	   * 11. SHARED RESOURCE DEFINITIONS AND SERVICE
  	   * ====================================================================== */

  	  const RESOURCE_DEFINITIONS = Object.freeze({
  	    tractors: {
  	      id: "tractors",
  	      label: "Vehicles",
  	      singular: "Vehicle",
  	      table: TABLES.TRACTORS,
  	      relation: RELATIONS.COMPANY_TRACTORS,
  	      cache: "tractors",
  	      viewAction: ACTIONS.VEHICLES_VIEW,
  	      createAction: ACTIONS.VEHICLES_CREATE,
  	      editAction: ACTIONS.VEHICLES_EDIT,
  	      deleteAction: ACTIONS.VEHICLES_DELETE,
  	      fields: [
  	        ["FID", "Fleet ID", "text"],
  	        ["Registration", "Registration", "text"],
  	        ["Type", "Vehicle type", "text"],
  	        ["Mileage", "Mileage", "number"],
  	        ["Range", "Range", "number"],
  	        ["Tracker", "Tracker", "text"],
  	        ["CurrentLocation", "Current location", "text"],
  	        ["LicenseExpiry", "Licence expiry", "number"],
  	        ["SARSCompliance", "SARS compliant", "boolean"],
  	        ["color", "Colour", "text"],
  	        ["Data", "Complete vehicle data", "json"],
  	        ["TPositions", "Tyre positions", "json"],
  	        ["CAN", "CAN data", "json"]
  	      ]
  	    },
  	    trailers: {
  	      id: "trailers",
  	      label: "Trailers",
  	      singular: "Trailer",
  	      table: TABLES.TRAILERS,
  	      relation: RELATIONS.COMPANY_TRAILERS,
  	      cache: "trailers",
  	      discriminator: record => lower(record?.Type) !== "implement",
  	      defaults: { Type: "Trailer", Data: {} },
  	      viewAction: ACTIONS.TRAILERS_VIEW,
  	      createAction: ACTIONS.TRAILERS_CREATE,
  	      editAction: ACTIONS.TRAILERS_EDIT,
  	      deleteAction: ACTIONS.TRAILERS_DELETE,
  	      fields: [
  	        ["FID", "Fleet ID", "text"],
  	        ["Registration", "Registration", "text"],
  	        ["Type", "Type", "select", ["Trailer"]],
  	        ["Mileage", "Mileage", "number"],
  	        ["EYEID", "EYE ID", "text"],
  	        ["Tracker", "Tracker", "text"],
  	        ["CurrentLocation", "Current location", "text"],
  	        ["Application", "Application", "text"],
  	        ["Swath", "Swath", "boolean"],
  	        ["SwathWidth", "Swath width", "number"],
  	        ["LicenseExpiry", "Licence expiry", "number"],
  	        ["color", "Colour", "text"],
  	        ["Data", "Complete trailer data", "json"],
  	        ["CAN", "CAN data", "json"]
  	      ]
  	    },
  	    implements: {
  	      id: "implements",
  	      label: "Implements",
  	      singular: "Implement",
  	      table: TABLES.TRAILERS,
  	      relation: RELATIONS.COMPANY_TRAILERS,
  	      cache: "trailers",
  	      discriminator: record => lower(record?.Type) === "implement",
  	      defaults: { Type: "Implement", Data: {} },
  	      viewAction: ACTIONS.IMPLEMENTS_VIEW,
  	      createAction: ACTIONS.IMPLEMENTS_CREATE,
  	      editAction: ACTIONS.IMPLEMENTS_EDIT,
  	      deleteAction: ACTIONS.IMPLEMENTS_DELETE,
  	      fields: [
  	        ["FID", "Fleet ID", "text"],
  	        ["Registration", "Registration / identifier", "text"],
  	        ["Type", "Type", "select", ["Implement"]],
  	        ["Mileage", "Operating distance", "number"],
  	        ["Application", "Application", "text"],
  	        ["Swath", "Swath", "boolean"],
  	        ["SwathWidth", "Swath width", "number"],
  	        ["Tracker", "Tracker", "text"],
  	        ["CurrentLocation", "Current location", "text"],
  	        ["color", "Colour", "text"],
  	        ["Data", "Complete implement data", "json"],
  	        ["CAN", "CAN data", "json"]
  	      ]
  	    },
  	    tanks: {
  	      id: "tanks",
  	      label: "Tanks",
  	      singular: "Tank",
  	      table: TABLES.TANKS,
  	      relation: RELATIONS.COMPANY_TANKS,
  	      cache: "tanks",
  	      defaults: { Grade: "Diesel", Volume: 0, Capacity: 0, Status: "ACTIVE" },
  	      viewAction: ACTIONS.TANKS_VIEW,
  	      createAction: ACTIONS.TANKS_CREATE,
  	      editAction: ACTIONS.TANKS_EDIT,
  	      deleteAction: ACTIONS.TANKS_DELETE,
  	      fields: [
  	        ["Name", "Name", "text"],
  	        ["Grade", "Fuel grade", "text"],
  	        ["Capacity", "Capacity", "number"],
  	        ["Volume", "Current volume", "number"],
  	        ["OrderThreshold", "Order threshold", "number"],
  	        ["DefaultOrderVolume", "Default order volume", "number"],
  	        ["PrimarySupplier", "Primary supplier", "text"],
  	        ["PrimarySupplierId", "Supplier ID", "text"],
  	        ["DeviceId", "Device ID", "text"],
  	        ["Color", "Colour", "text"]
  	      ]
  	    },
  	    bowsers: {
  	      id: "bowsers",
  	      label: "Bowsers",
  	      singular: "Bowser",
  	      table: TABLES.BOWSERS,
  	      relation: RELATIONS.TANK_BOWSERS,
  	      cache: "bowsers",
  	      parentType: "tank",
  	      defaults: { Grade: "Diesel", Meter: 0 },
  	      viewAction: ACTIONS.BOWSERS_VIEW,
  	      createAction: ACTIONS.BOWSERS_CREATE,
  	      editAction: ACTIONS.BOWSERS_EDIT,
  	      deleteAction: ACTIONS.BOWSERS_DELETE,
  	      fields: [
  	        ["Name", "Name", "text"],
  	        ["Grade", "Fuel grade", "text"],
  	        ["Meter", "Meter", "number"],
  	        ["RollbackLastAt", "Last rollback time", "text", null, true],
  	        ["RollbackLastGroupId", "Last rollback group", "text", null, true]
  	      ]
  	    },
  	    tyres: {
  	      id: "tyres",
  	      label: "Tyres",
  	      singular: "Tyre",
  	      table: TABLES.TYRES,
  	      cache: "tyres",
  	      defaults: { Status: "All In Order", Is_Fitted: false, History: {}, Checks: {} },
  	      viewAction: ACTIONS.TYRES_VIEW,
  	      createAction: ACTIONS.TYRES_CREATE,
  	      editAction: ACTIONS.TYRES_EDIT,
  	      deleteAction: ACTIONS.TYRES_DELETE,
  	      fields: [
  	        ["Tyre_Number", "Tyre number", "text"],
  	        ["Serial_Number", "Serial number", "text"],
  	        ["Tyre_Brand", "Brand", "text"],
  	        ["Make", "Make", "text"],
  	        ["Model", "Model", "text"],
  	        ["Size", "Size", "text"],
  	        ["Type", "Type", "text"],
  	        ["Status", "Status", "text"],
  	        ["Expected_Mileage", "Expected mileage", "number"],
  	        ["Current_Cost", "Current cost", "number"],
  	        ["Current_Mileage", "Current mileage", "number"],
  	        ["Vehicle_ID", "Vehicle ID", "text"],
  	        ["Vehicle_ObjectId", "Vehicle objectId", "text"],
  	        ["Vehicle_Type", "Vehicle type", "text"],
  	        ["Current_Position", "Current position", "text"],
  	        ["Current_Axle_Type", "Axle type", "text"],
  	        ["Is_Fitted", "Fitted", "boolean"],
  	        ["Fitted_Odometer", "Fitted odometer", "number"],
  	        ["Fitted_Date", "Fitted date", "datetime"],
  	        ["Notes", "Notes", "textarea"],
  	        ["History", "Complete history", "json"],
  	        ["Checks", "Checks", "json"]
  	      ]
  	    },
  	    locations: {
  	      id: "locations",
  	      label: "Locations",
  	      singular: "Location",
  	      table: TABLES.LOCATIONS,
  	      relation: RELATIONS.COMPANY_LOCATIONS,
  	      cache: "locations",
  	      defaults: { Type: "Location", CreationType: "Manual", LocationData: {} },
  	      viewAction: ACTIONS.LOCATIONS_VIEW,
  	      createAction: ACTIONS.LOCATIONS_CREATE,
  	      editAction: ACTIONS.LOCATIONS_EDIT,
  	      deleteAction: ACTIONS.LOCATIONS_DELETE,
  	      fields: [
  	        ["ID", "Location ID", "text"],
  	        ["Name", "Name", "text"],
  	        ["Type", "Type", "text"],
  	        ["Description", "Description", "textarea"],
  	        ["ContactName", "Contact name", "text"],
  	        ["ContactNumber", "Contact number", "text"],
  	        ["AreaHa", "Area (ha)", "number"],
  	        ["Color", "Colour", "text"],
  	        ["ParentId", "Parent ID", "text"],
  	        ["CreationType", "Creation type", "text"],
  	        ["LocationData", "Location data", "json"]
  	      ]
  	    },
  	    routes: {
  	      id: "routes",
  	      label: "Routes",
  	      singular: "Route",
  	      table: TABLES.ROUTES,
  	      relation: RELATIONS.COMPANY_ROUTES,
  	      cache: "routes",
  	      viewAction: ACTIONS.ROUTES_VIEW,
  	      createAction: ACTIONS.ROUTES_EDIT,
  	      editAction: ACTIONS.ROUTES_EDIT,
  	      deleteAction: ACTIONS.ROUTES_EDIT,
  	      fields: []
  	    }
  	  });

  	  function resourceDefinition(id) {
  	    const definition = RESOURCE_DEFINITIONS[id];
  	    if (!definition) throw new Error(`Unknown resource manager: ${id}`);
  	    return definition;
  	  }

  	  function resourceTitle(record, definition) {
  	    const candidates = [
  	      record?.Name,
  	      record?.Registration,
  	      record?.FID,
  	      record?.Tyre_Number,
  	      record?.ID,
  	      record?.Serial_Number,
  	      objectId(record)
  	    ];
  	    return clean(candidates.find(Boolean) || definition.singular);
  	  }

  	  async function loadCompanyRelationResource(company, definition, options = {}) {
  	    const key = companyObjectId(company);
  	    const cache = state.caches[definition.cache];
  	    if (cache[key] && !options.force) {
  	      const cached = cache[key];
  	      return definition.discriminator ? cached.filter(definition.discriminator) : cached;
  	    }
  	    const fallback = relationList(company, definition.relation.name);
  	    const rows = await loadRelation(definition.relation.parentTable, key, definition.relation, fallback);
  	    cache[key] = rows.map(clone);
  	    return definition.discriminator ? cache[key].filter(definition.discriminator) : cache[key];
  	  }

  	  async function loadCompanyBowsers(company, options = {}) {
  	    const key = companyObjectId(company);
  	    if (state.caches.bowsers[key] && !options.force) return state.caches.bowsers[key];
  	    const tanks = await ResourceService.load("tanks", company, options);
  	    const rows = [];
  	    for (const tank of tanks) {
  	      const loaded = await loadRelation(TABLES.TANKS, objectId(tank), RELATIONS.TANK_BOWSERS, relationList(tank, "Bowsers"));
  	      loaded.forEach(bowser => rows.push({ ...clone(bowser), __parentTankObjectId: objectId(tank), __parentTankName: clean(tank.Name) }));
  	    }
  	    state.caches.bowsers[key] = uniqueRecords(rows);
  	    return state.caches.bowsers[key];
  	  }

  	  async function loadCompanyTyres(company, options = {}) {
  	    const key = companyObjectId(company);
  	    if (state.caches.tyres[key] && !options.force) return state.caches.tyres[key];
  	    const businessId = companyBusinessId(company);
  	    let rows = [];
  	    if (businessId) {
  	      try { rows = await findAll(TABLES.TYRES, { where: `Company_ID = '${escapeWhere(businessId)}'` }); }
  	      catch (error) { warn("Tyre company query failed.", error?.message || error); }
  	    }
  	    if (!rows.length) {
  	      const tractors = await ResourceService.load("tractors", company, options);
  	      for (const tractor of tractors) {
  	        const related = await loadRelation(TABLES.TRACTORS, objectId(tractor), RELATIONS.TRACTOR_TYRES, relationList(tractor, "Tyres"));
  	        rows.push(...related);
  	      }
  	    }
  	    state.caches.tyres[key] = uniqueRecords(rows);
  	    return state.caches.tyres[key];
  	  }

  	  const ResourceService = Object.freeze({
  	    async load(resourceId, company, options = {}) {
  	      const definition = resourceDefinition(resourceId);
  	      assertAction(definition.viewAction, { company });
  	      if (!canAccessCompany(state.authority, state.companyScope, company)) throw new Error("Company access denied.");
  	      if (resourceId === "bowsers") return loadCompanyBowsers(company, options);
  	      if (resourceId === "tyres") return loadCompanyTyres(company, options);
  	      return loadCompanyRelationResource(company, definition, options);
  	    },

  	    async save(resourceId, company, input, options = {}) {
  	      const definition = resourceDefinition(resourceId);
  	      const existing = options.existing || null;
  	      assertAction(existing ? definition.editAction : definition.createAction, { company });
  	      if (!canAccessCompany(state.authority, state.companyScope, company)) throw new Error("Company access denied.");

  	      const before = existing ? clone(existing) : null;
  	      const payload = { ...(definition.defaults || {}), ...clone(existing || {}), ...clone(input || {}) };
  	      if (resourceId === "trailers") payload.Type = "Trailer";
  	      if (resourceId === "implements") payload.Type = "Implement";
  	      if (resourceId === "tyres") payload.Company_ID = companyBusinessId(company);
  	      if (existing) payload.objectId = objectId(existing);
  	      else delete payload.objectId;

  	      const saved = await saveRecord(definition.table, payload, { newRecord: !existing });
  	      const normalSaved = { ...clone(payload), ...clone(saved) };

  	      if (!existing && definition.relation) {
  	        let parent = company;
  	        if (definition.parentType === "tank") {
  	          const parentTankId = clean(options.parentTankObjectId || input.__parentTankObjectId);
  	          const tanks = await this.load("tanks", company);
  	          parent = tanks.find(tank => objectId(tank) === parentTankId);
  	          if (!parent) throw new Error("Select the tank that owns this bowser.");
  	        }
  	        await addRelation(parent, definition.relation, normalSaved);
  	      }

  	      const cache = state.caches[definition.cache];
  	      const key = companyObjectId(company);
  	      cache[key] = replaceInArray(cache[key] || [], normalSaved, clone);
  	      if (definition.relation && definition.parentType !== "tank") {
  	        const companyRef = state.allCompanies.find(item => companyObjectId(item) === key);
  	        if (companyRef) companyRef[definition.relation.name] = replaceInArray(companyRef[definition.relation.name] || [], normalSaved, clone);
  	      }
  	      await AuditService.record({ action: existing ? definition.editAction : definition.createAction, company, targetTable: definition.table, target: normalSaved, before, after: normalSaved, reason: options.reason || `${definition.singular} saved` });
  	      refreshBindings();
  	      return normalSaved;
  	    },

  	    async remove(resourceId, company, record, reason) {
  	      const definition = resourceDefinition(resourceId);
  	      assertAction(definition.deleteAction, { company });
  	      if (!canAccessCompany(state.authority, state.companyScope, company)) throw new Error("Company access denied.");

  	      if (definition.relation) {
  	        let parent = company;
  	        if (definition.parentType === "tank") {
  	          const tanks = await this.load("tanks", company);
  	          parent = tanks.find(tank => objectId(tank) === clean(record.__parentTankObjectId));
  	          if (!parent) throw new Error("The bowser's parent tank could not be resolved.");
  	        }
  	        await removeRelation(parent, definition.relation, record);
  	      }
  	      await deleteRecord(definition.table, record);
  	      const key = companyObjectId(company);
  	      state.caches[definition.cache][key] = removeFromArray(state.caches[definition.cache][key] || [], record);
  	      await AuditService.record({ action: definition.deleteAction, company, targetTable: definition.table, target: record, before: record, after: null, reason: reason || `${definition.singular} deleted` });
  	      refreshBindings();
  	    }
  	  });

  	  /* ========================================================================
  	   * 12. FUEL AND LOAD CORRECTION SERVICES
  	   * ====================================================================== */

  	  async function loadCompanyFuelOut(company, options = {}) {
  	    const key = companyObjectId(company);
  	    if (state.caches.fuelOut[key] && !options.force) return state.caches.fuelOut[key];
  	    assertAction(ACTIONS.FUEL_VIEW, { company });

  	    const tractors = state.access.can(ACTIONS.VEHICLES_VIEW, { company }) ? await ResourceService.load("tractors", company).catch(() => []) : relationList(company, "Tractors");
  	    const trailers = state.access.can(ACTIONS.TRAILERS_VIEW, { company }) ? await ResourceService.load("trailers", company).catch(() => []) : relationList(company, "Trailers");
  	    const tanks = await ResourceService.load("tanks", company).catch(() => relationList(company, "Tanks"));
  	    const bowsers = await loadCompanyBowsers(company).catch(() => []);
  	    const vehicleIds = uniqueValues([...tractors, ...trailers].map(objectId));
  	    const tankIds = uniqueValues(tanks.map(objectId));
  	    const bowserIds = uniqueValues(bowsers.map(objectId));
  	    const clauses = [];
  	    vehicleIds.forEach(id => clauses.push(`VehicleObjectId = '${escapeWhere(id)}'`, `TractorObjectId = '${escapeWhere(id)}'`));
  	    tankIds.forEach(id => clauses.push(`TankObjectId = '${escapeWhere(id)}'`));
  	    bowserIds.forEach(id => clauses.push(`BowserObjectId = '${escapeWhere(id)}'`));

  	    let rows = [];
  	    if (clauses.length) {
  	      try { rows = await findAll(TABLES.FUEL_OUT, { where: `(${clauses.join(" OR ")})`, sortBy: ["created DESC"], maxRows: 3000 }); }
  	      catch (error) { warn("FuelOut scoped query failed.", error?.message || error); }
  	    }

  	    if (!rows.length && Array.isArray(APP_DATA.FuelOut)) {
  	      const allIds = new Set([...vehicleIds, ...tankIds, ...bowserIds]);
  	      rows = APP_DATA.FuelOut.filter(item => [item.VehicleObjectId, item.TractorObjectId, item.TankObjectId, item.BowserObjectId].some(id => allIds.has(clean(id))));
  	    }
  	    state.caches.fuelOut[key] = rows.map(clone);
  	    return state.caches.fuelOut[key];
  	  }

  	  async function loadCompanyLoads(company, options = {}) {
  	    const key = companyObjectId(company);
  	    if (state.caches.loads[key] && !options.force) return state.caches.loads[key];
  	    assertAction(ACTIONS.LOADS_VIEW, { company });
  	    const locations = await ResourceService.load("locations", company).catch(() => relationList(company, "Locations"));
  	    const locationIds = uniqueValues(locations.map(objectId));
  	    if (!locationIds.length) return (state.caches.loads[key] = []);

  	    const clauses = [];
  	    locationIds.forEach(id => {
  	      const safe = escapeWhere(id);
  	      clauses.push(`Location_Load.objectId = '${safe}'`, `Location_Deliver.objectId = '${safe}'`, `Location_Return.objectId = '${safe}'`);
  	    });
  	    let rows = [];
  	    try { rows = await findAll(TABLES.LOADS, { where: `(${clauses.join(" OR ")})`, sortBy: ["created DESC"], maxRows: 3000 }); }
  	    catch (error) { warn("Loads scoped query failed.", error?.message || error); }

  	    if (!rows.length && Array.isArray(APP_DATA.Loads)) {
  	      const ids = new Set(locationIds);
  	      rows = APP_DATA.Loads.filter(load => [load.Location_Load, load.Location_Deliver, load.Location_Return].some(location => ids.has(objectId(location))));
  	    }
  	    state.caches.loads[key] = rows.map(clone);
  	    return state.caches.loads[key];
  	  }

  	  async function loadCompanyTrips(company, options = {}) {
  	    const key = companyObjectId(company);
  	    if (state.caches.trips[key] && !options.force) return state.caches.trips[key];
  	    assertAction(ACTIONS.TRIPS_VIEW, { company });
  	    const tractors = await ResourceService.load("tractors", company).catch(() => relationList(company, "Tractors"));
  	    const ids = uniqueValues(tractors.map(objectId));
  	    if (!ids.length) return (state.caches.trips[key] = []);
  	    const where = `(${ids.map(id => `Tractor.objectId = '${escapeWhere(id)}'`).join(" OR ")})`;
  	    let rows = [];
  	    try { rows = await findAll(TABLES.TRIPS, { where, sortBy: ["created DESC"], maxRows: 3000 }); }
  	    catch (error) { warn("Trips scoped query failed.", error?.message || error); }
  	    if (!rows.length && Array.isArray(APP_DATA.Trips)) {
  	      const allowed = new Set(ids);
  	      rows = APP_DATA.Trips.filter(trip => allowed.has(objectId(trip.Tractor)));
  	    }
  	    state.caches.trips[key] = rows.map(clone);
  	    return state.caches.trips[key];
  	  }

  	  async function loadCompanyJobs(company, options = {}) {
  	    const key = companyObjectId(company);
  	    if (state.caches.jobs[key] && !options.force) return state.caches.jobs[key];
  	    assertAction(ACTIONS.JOBS_VIEW, { company });
  	    const locations = await ResourceService.load("locations", company).catch(() => relationList(company, "Locations"));
  	    const rows = [];
  	    for (const location of locations) {
  	      const jobs = await loadRelation(TABLES.LOCATIONS, objectId(location), RELATIONS.LOCATION_JOBS, relationList(location, "Jobs"));
  	      jobs.forEach(job => rows.push({ ...clone(job), __locationObjectId: objectId(location), __locationName: clean(location.Name) }));
  	    }
  	    state.caches.jobs[key] = uniqueRecords(rows);
  	    return state.caches.jobs[key];
  	  }

  	  const OperationalService = Object.freeze({
  	    loadTrips: loadCompanyTrips,
  	    loadJobs: loadCompanyJobs,
  	    async correctJob(company, existing, changes, reason) {
  	      assertAction(ACTIONS.JOBS_CORRECT, { company });
  	      if (!clean(reason)) throw new Error("A correction reason is required.");
  	      const before = clone(existing);
  	      const payload = { ...clone(existing), ...clone(changes), objectId: objectId(existing) };
  	      const saved = await saveRecord(TABLES.JOB_ENTRIES, payload);
  	      state.caches.jobs[companyObjectId(company)] = replaceInArray(state.caches.jobs[companyObjectId(company)] || [], { ...clone(existing), ...clone(saved) }, clone);
  	      await AuditService.record({ action: ACTIONS.JOBS_CORRECT, company, targetTable: TABLES.JOB_ENTRIES, target: saved, before, after: saved, reason });
  	      return saved;
  	    }
  	  });

  	  async function updateLinkedFuelState(company, beforeTransaction, afterTransaction, snapshot) {
  	    const result = { vehicle: null, bowser: null, tank: null };
  	    const vehicleId = clean(afterTransaction.VehicleObjectId || afterTransaction.TractorObjectId);
  	    if (vehicleId && Number(afterTransaction.Mileage) !== Number(beforeTransaction.Mileage)) {
  	      const tractors = await ResourceService.load("tractors", company, { force: true }).catch(() => []);
  	      const trailers = await ResourceService.load("trailers", company, { force: true }).catch(() => []);
  	      const implementRows = await ResourceService.load("implements", company, { force: true }).catch(() => []);
  	      const vehicle = [...tractors, ...trailers, ...implementRows].find(item => objectId(item) === vehicleId);
  	      if (vehicle) {
  	        const currentMileage = Number(vehicle.Mileage || 0);
  	        const originalTransactionMileage = Number(beforeTransaction.Mileage || 0);
  	        if (currentMileage !== originalTransactionMileage && currentMileage !== Number(afterTransaction.Mileage || 0)) {
  	          throw new Error("Vehicle mileage has moved beyond this transaction. Automatic correction was stopped to prevent overwriting newer data.");
  	        }
  	        snapshot.vehicle = { table: tractors.some(item => objectId(item) === vehicleId) ? TABLES.TRACTORS : TABLES.TRAILERS, objectId: vehicleId, beforeMileage: currentMileage };
  	        result.vehicle = await saveRecord(snapshot.vehicle.table, { objectId: vehicleId, Mileage: Number(afterTransaction.Mileage || 0) });
  	      }
  	    }

  	    const bowserId = clean(afterTransaction.BowserObjectId);
  	    if (bowserId && Number(afterTransaction.Meter) !== Number(beforeTransaction.Meter)) {
  	      const bowsers = await loadCompanyBowsers(company, { force: true });
  	      const bowser = bowsers.find(item => objectId(item) === bowserId);
  	      if (bowser) {
  	        const currentMeter = Number(bowser.Meter || 0);
  	        const originalMeter = Number(beforeTransaction.Meter || 0);
  	        if (currentMeter !== originalMeter && currentMeter !== Number(afterTransaction.Meter || 0)) {
  	          throw new Error("Bowser meter has moved beyond this transaction. Automatic correction was stopped to prevent overwriting newer data.");
  	        }
  	        snapshot.bowser = { objectId: bowserId, beforeMeter: currentMeter };
  	        result.bowser = await saveRecord(TABLES.BOWSERS, { objectId: bowserId, Meter: Number(afterTransaction.Meter || 0) });
  	      }
  	    }

  	    const tankId = clean(afterTransaction.TankObjectId);
  	    const litreDelta = Number(afterTransaction.Litres || 0) - Number(beforeTransaction.Litres || 0);
  	    if (tankId && litreDelta !== 0) {
  	      const tanks = await ResourceService.load("tanks", company, { force: true });
  	      const tank = tanks.find(item => objectId(item) === tankId);
  	      if (tank) {
  	        const currentVolume = Number(tank.Volume || 0);
  	        const nextVolume = currentVolume - litreDelta;
  	        const capacity = Number(tank.Capacity || 0);
  	        if (nextVolume < 0 || (capacity > 0 && nextVolume > capacity)) {
  	          throw new Error("The corrected litres would make the tank balance invalid.");
  	        }
  	        snapshot.tank = { objectId: tankId, beforeVolume: currentVolume };
  	        result.tank = await saveRecord(TABLES.TANKS, { objectId: tankId, Volume: nextVolume });
  	      }
  	    }
  	    return result;
  	  }

  	  async function restoreLinkedFuelState(company, transaction, snapshot) {
  	    if (snapshot?.vehicle?.objectId) {
  	      const current = await findByObjectId(snapshot.vehicle.table, snapshot.vehicle.objectId);
  	      if (current && Number(current.Mileage || 0) !== Number(transaction.Mileage || 0)) {
  	        throw new Error("Vehicle mileage changed after the correction. Reversal was stopped for manual review.");
  	      }
  	      await saveRecord(snapshot.vehicle.table, { objectId: snapshot.vehicle.objectId, Mileage: snapshot.vehicle.beforeMileage });
  	    }
  	    if (snapshot?.bowser?.objectId) {
  	      const current = await findByObjectId(TABLES.BOWSERS, snapshot.bowser.objectId);
  	      if (current && Number(current.Meter || 0) !== Number(transaction.Meter || 0)) {
  	        throw new Error("Bowser meter changed after the correction. Reversal was stopped for manual review.");
  	      }
  	      await saveRecord(TABLES.BOWSERS, { objectId: snapshot.bowser.objectId, Meter: snapshot.bowser.beforeMeter });
  	    }
  	    if (snapshot?.tank?.objectId) {
  	      await saveRecord(TABLES.TANKS, { objectId: snapshot.tank.objectId, Volume: snapshot.tank.beforeVolume });
  	    }
  	  }

  	  const FuelService = Object.freeze({
  	    load: loadCompanyFuelOut,

  	    async correct(company, existing, changes, reason) {
  	      assertAction(ACTIONS.FUEL_CORRECT, { company });
  	      if (!clean(reason)) throw new Error("A correction reason is required.");
  	      const before = clone(existing);
  	      if (parseBoolean(before.IsReversed) || parseBoolean(before.Reversed)) throw new Error("A reversed transaction cannot be corrected.");
  	      if (parseBoolean(before.RollbackProtected) && !parseBoolean(before.IsReversed)) throw new Error("This transaction already has an active protected correction.");

  	      const corrected = { ...clone(before), ...clone(changes), objectId: objectId(before) };
  	      const groupId = randomId("fuel-correction");
  	      const snapshot = { version: 1, transaction: clone(before), vehicle: null, bowser: null, tank: null, correctedAt: nowIso(), correctedBy: userObjectId(state.currentUser) };

  	      await saveRecord(TABLES.FUEL_OUT, {
  	        objectId: objectId(before),
  	        RollbackProtected: true,
  	        RollbackGroupId: groupId,
  	        RollbackStatus: "CORRECTION_PENDING",
  	        RollbackProtectionType: encodeSnapshot(snapshot),
  	        RollbackVehicleMileageBefore: Number(before.Mileage || 0),
  	        RollbackBowserMeterBefore: Number(before.Meter || 0),
  	        RollbackMileageDifferential: Number(corrected.Mileage || 0) - Number(before.Mileage || 0)
  	      });

  	      try {
  	        await updateLinkedFuelState(company, before, corrected, snapshot);
  	        corrected.RollbackProtected = true;
  	        corrected.RollbackGroupId = groupId;
  	        corrected.RollbackStatus = "CORRECTED";
  	        corrected.RollbackProtectionType = encodeSnapshot(snapshot);
  	        corrected.RollbackVehicleMileageBefore = Number(before.Mileage || 0);
  	        corrected.RollbackBowserMeterBefore = Number(before.Meter || 0);
  	        corrected.RollbackMileageDifferential = Number(corrected.Mileage || 0) - Number(before.Mileage || 0);
  	        corrected.IsReversed = false;
  	        corrected.Reversed = false;
  	        corrected.Description = clean(corrected.Description || before.Description);
  	        const saved = await saveRecord(TABLES.FUEL_OUT, corrected);
  	        state.caches.fuelOut[companyObjectId(company)] = replaceInArray(state.caches.fuelOut[companyObjectId(company)] || [], saved, clone);
  	        await AuditService.record({ action: ACTIONS.FUEL_CORRECT, company, targetTable: TABLES.FUEL_OUT, target: saved, before, after: saved, reason });
  	        return saved;
  	      } catch (error) {
  	        try { await restoreLinkedFuelState(company, corrected, snapshot); } catch (rollbackError) { warn("Automatic correction rollback also failed.", rollbackError?.message || rollbackError); }
  	        try { await saveRecord(TABLES.FUEL_OUT, { objectId: objectId(before), RollbackStatus: "CORRECTION_FAILED", RollbackProtectionType: encodeSnapshot(snapshot) }); }
  	        catch (_) {}
  	        await AuditService.record({ action: ACTIONS.FUEL_CORRECT, company, targetTable: TABLES.FUEL_OUT, target: before, before, after: corrected, reason, result: "FAILED", error: error.message });
  	        throw error;
  	      }
  	    },

  	    async reverse(company, transaction, reason) {
  	      assertAction(ACTIONS.FUEL_REVERSE, { company });
  	      if (!clean(reason)) throw new Error("A reversal reason is required.");
  	      if (parseBoolean(transaction.IsReversed) || parseBoolean(transaction.Reversed)) throw new Error("This transaction has already been reversed.");
  	      const snapshot = decodeSnapshot(transaction.RollbackProtectionType);
  	      if (!snapshot?.transaction) throw new Error("The protected correction snapshot is missing. Manual review is required.");

  	      await saveRecord(TABLES.FUEL_OUT, { objectId: objectId(transaction), RollbackStatus: "REVERSAL_PENDING" });
  	      try {
  	        await restoreLinkedFuelState(company, transaction, snapshot);
  	        const restored = {
  	          ...clone(snapshot.transaction),
  	          objectId: objectId(transaction),
  	          RollbackProtected: true,
  	          RollbackGroupId: transaction.RollbackGroupId,
  	          RollbackStatus: "REVERSED",
  	          RollbackProtectionType: transaction.RollbackProtectionType,
  	          IsReversed: true,
  	          Reversed: true,
  	          ReversedAt: nowIso()
  	        };
  	        const saved = await saveRecord(TABLES.FUEL_OUT, restored);
  	        state.caches.fuelOut[companyObjectId(company)] = replaceInArray(state.caches.fuelOut[companyObjectId(company)] || [], saved, clone);
  	        await AuditService.record({ action: ACTIONS.FUEL_REVERSE, company, targetTable: TABLES.FUEL_OUT, target: saved, before: transaction, after: saved, reason });
  	        return saved;
  	      } catch (error) {
  	        try { await saveRecord(TABLES.FUEL_OUT, { objectId: objectId(transaction), RollbackStatus: "REVERSAL_FAILED" }); }
  	        catch (_) {}
  	        await AuditService.record({ action: ACTIONS.FUEL_REVERSE, company, targetTable: TABLES.FUEL_OUT, target: transaction, before: transaction, after: null, reason, result: "FAILED", error: error.message });
  	        throw error;
  	      }
  	    }
  	  });

  	  const LoadService = Object.freeze({
  	    load: loadCompanyLoads,
  	    async correct(company, existing, changes, reason) {
  	      assertAction(ACTIONS.LOADS_CORRECT, { company });
  	      if (!clean(reason)) throw new Error("A correction reason is required.");
  	      const before = clone(existing);
  	      const payload = { ...clone(existing), ...clone(changes), objectId: objectId(existing) };
  	      // safeForSave strips loaded relations while preserving Documents, Images,
  	      // Signatures, Transfers and all other JSON fields.
  	      const saved = await saveRecord(TABLES.LOADS, payload);
  	      state.caches.loads[companyObjectId(company)] = replaceInArray(state.caches.loads[companyObjectId(company)] || [], saved, clone);
  	      await AuditService.record({ action: ACTIONS.LOADS_CORRECT, company, targetTable: TABLES.LOADS, target: saved, before, after: saved, reason });
  	      return saved;
  	    }
  	  });

  	  /* ========================================================================
  	   * 13. NAVIGATION METADATA
  	   * ====================================================================== */

  	  const NAV_ITEMS = Object.freeze([
  	    { id: "overview", label: "Overview", icon: "⌂", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.PLATFORM_VIEW },
  	    { id: "companies", label: "Companies", icon: "▦", platforms: ["FIFM", "FIFC"], action: ACTIONS.COMPANIES_VIEW_ASSIGNED },
  	    { id: "company-profile", label: "Company Profile", icon: "▤", platforms: ["FIFM", "CUSTOMER"], action: ACTIONS.COMPANIES_VIEW_ASSIGNED, companyRequired: true },
  	    { id: "applications", label: "Applications", icon: "◫", platforms: ["FIFM", "CUSTOMER"], action: ACTIONS.APPLICATIONS_VIEW, companyRequired: true },
  	    { id: "users", label: "Users", icon: "♙", platforms: ["FIFM", "CUSTOMER"], action: ACTIONS.USERS_VIEW, companyRequiredForCustomer: true },
  	    { id: "tractors", label: "Vehicles", icon: "▰", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.VEHICLES_VIEW, companyRequired: true },
  	    { id: "trailers", label: "Trailers", icon: "▱", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.TRAILERS_VIEW, companyRequired: true },
  	    { id: "implements", label: "Implements", icon: "⌁", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.IMPLEMENTS_VIEW, companyRequired: true },
  	    { id: "tyres", label: "Tyres", icon: "◉", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.TYRES_VIEW, companyRequired: true },
  	    { id: "tanks", label: "Tanks", icon: "◧", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.TANKS_VIEW, companyRequired: true },
  	    { id: "bowsers", label: "Bowsers", icon: "◨", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.BOWSERS_VIEW, companyRequired: true },
  	    { id: "locations", label: "Locations", icon: "⌖", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.LOCATIONS_VIEW, companyRequired: true },
  	    { id: "routes", label: "Routes", icon: "↝", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.ROUTES_VIEW, companyRequired: true },
  	    { id: "fuel", label: "Fuel Corrections", icon: "◒", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.FUEL_VIEW, companyRequired: true },
  	    { id: "loads", label: "Loads", icon: "▣", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.LOADS_VIEW, companyRequired: true },
  	    { id: "trips", label: "Trips", icon: "⇄", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.TRIPS_VIEW, companyRequired: true },
  	    { id: "jobs", label: "Jobs", icon: "✓", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.JOBS_VIEW, companyRequired: true },
  	    { id: "audit", label: "Audit", icon: "≣", platforms: ["FIFM", "FIFC", "CUSTOMER"], action: ACTIONS.AUDIT_VIEW }
  	  ]);

  	  function availableNavigation() {
  	    return NAV_ITEMS.filter(item => {
  	      if (!item.platforms.includes(state.authority.platform)) return false;
  	      if (!state.access.can(item.action, { company: selectedCompany() })) return false;
  	      if (item.companyRequired && !selectedCompany()) return false;
  	      if (item.companyRequiredForCustomer && state.authority.platform === "CUSTOMER" && !selectedCompany()) return false;
  	      return true;
  	    });
  	  }

  	  function defaultSection() {
  	    const nav = availableNavigation();
  	    if (nav.some(item => item.id === state.activeSection)) return state.activeSection;
  	    return nav[0]?.id || "overview";
  	  }

  	  /* ========================================================================
  	   * 14. UI PRIMITIVES AND STYLES
  	   * ====================================================================== */

  	  function logoHtml() {
  	    let svg = SVG_INPUT;
  	    if (isObject(svg)) svg = svg.value || svg.Value || svg.src || svg.url || "";
  	    svg = clean(svg);
  	    if (!svg) return '<div class="fif-logo-fallback">FIF</div>';
  	    if (/^<svg[\s>]/i.test(svg)) {
  	      return svg
  	        .replace(/<script[\s\S]*?<\/script>/gi, "")
  	        .replace(/<svg(?![^>]*preserveAspectRatio)/i, '<svg preserveAspectRatio="xMidYMid meet"')
  	        .replace(/<svg([^>]*?)>/i, '<svg$1 class="fif-logo-svg">');
  	    }
  	    if (/^(data:image\/|https?:\/\/|\/)/i.test(svg)) {
  	      return `<img class="fif-logo-img" src="${escapeAttr(svg)}" alt="Fleet In Form">`;
  	    }
  	    return '<div class="fif-logo-fallback">FIF</div>';
  	  }

  	  function installStyles() {
  	    let style = document.getElementById(STYLE_ID);
  	    if (style) return;
  	    style = document.createElement("style");
  	    style.id = STYLE_ID;
  	    style.textContent = `
  	      #${ROOT_ID}, #${ROOT_ID} * { box-sizing: border-box; }
  	      #${ROOT_ID} {
  	        --bg: #f4f6f8; --panel: #ffffff; --ink: #17212b; --muted: #667585;
  	        --line: #dce3e9; --accent: #bd6f38; --accent-dark: #8d4d24;
  	        --success: #277a4d; --warning: #a26613; --danger: #a63d42;
  	        --nav: #1e2a35; --nav-2: #263644; --shadow: 0 12px 32px rgba(24,36,48,.12);
  	        position: fixed; left: 0; right: 0; top: ${TOP_OFFSET_PX}px; bottom: 0;
  	        z-index: 2147483000; background: var(--bg); color: var(--ink);
  	        font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  	        overflow: hidden;
  	      }
  	      #${ROOT_ID} button, #${ROOT_ID} input, #${ROOT_ID} select, #${ROOT_ID} textarea { font: inherit; }
  	      #${ROOT_ID} button { cursor: pointer; }
  	      #${ROOT_ID} .fif-app { display: grid; grid-template-columns: 250px minmax(0,1fr); height: 100%; }
  	      #${ROOT_ID} .fif-rail { background: linear-gradient(180deg,var(--nav),#17212b); color: #edf3f7; display:flex; flex-direction:column; min-width:0; }
  	      #${ROOT_ID} .fif-brand { min-height: 78px; padding: 15px 18px; display:flex; align-items:center; gap:12px; border-bottom:1px solid rgba(255,255,255,.1); }
  	      #${ROOT_ID} .fif-logo-fallback { width:42px;height:42px;border-radius:12px;background:var(--accent);display:grid;place-items:center;font-weight:900;letter-spacing:.04em; }
  	      #${ROOT_ID} .fif-logo-svg, #${ROOT_ID} .fif-logo-img { width:46px;height:46px;object-fit:contain; }
  	      #${ROOT_ID} .fif-brand-title { font-weight:800; line-height:1.1; }
  	      #${ROOT_ID} .fif-brand-sub { color:#aebdca; font-size:11px; margin-top:4px; }
  	      #${ROOT_ID} .fif-nav { padding:12px 10px; overflow:auto; flex:1; }
  	      #${ROOT_ID} .fif-nav-button { width:100%; border:0; color:#cbd7e0; background:transparent; padding:10px 12px; border-radius:9px; display:flex; align-items:center; gap:11px; text-align:left; margin:2px 0; }
  	      #${ROOT_ID} .fif-nav-button:hover { background:rgba(255,255,255,.07); color:white; }
  	      #${ROOT_ID} .fif-nav-button.active { background:var(--accent); color:white; box-shadow:0 7px 18px rgba(0,0,0,.18); }
  	      #${ROOT_ID} .fif-nav-icon { width:24px; text-align:center; font-weight:900; }
  	      #${ROOT_ID} .fif-rail-footer { padding:14px 16px; border-top:1px solid rgba(255,255,255,.1); color:#b9c5ce; font-size:12px; }
  	      #${ROOT_ID} .fif-main { min-width:0; height:100%; overflow:auto; }
  	      #${ROOT_ID} .fif-top { min-height:78px; background:var(--panel); border-bottom:1px solid var(--line); padding:13px 22px; display:flex; align-items:center; gap:16px; position:sticky; top:0; z-index:20; }
  	      #${ROOT_ID} .fif-context { min-width:0; flex:1; }
  	      #${ROOT_ID} .fif-context h1 { margin:0; font-size:20px; }
  	      #${ROOT_ID} .fif-context p { margin:4px 0 0; color:var(--muted); font-size:12px; }
  	      #${ROOT_ID} .fif-company-select { min-width:240px; max-width:360px; border:1px solid var(--line); border-radius:9px; padding:9px 11px; background:white; }
  	      #${ROOT_ID} .fif-user-chip { display:flex; align-items:center; gap:9px; padding:7px 10px; border-radius:10px; background:#f1f4f6; max-width:260px; }
  	      #${ROOT_ID} .fif-avatar { width:34px;height:34px;border-radius:50%;background:var(--nav);color:white;display:grid;place-items:center;font-weight:800; }
  	      #${ROOT_ID} .fif-user-chip strong { display:block; font-size:12px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  	      #${ROOT_ID} .fif-user-chip span { display:block; color:var(--muted); font-size:10px; }
  	      #${ROOT_ID} .fif-content { padding:22px; max-width:1600px; margin:0 auto; }
  	      #${ROOT_ID} .fif-toolbar { display:flex; gap:10px; align-items:center; flex-wrap:wrap; margin-bottom:16px; }
  	      #${ROOT_ID} .fif-toolbar .grow { flex:1; }
  	      #${ROOT_ID} .fif-input, #${ROOT_ID} .fif-select, #${ROOT_ID} .fif-textarea { width:100%; border:1px solid var(--line); border-radius:9px; padding:9px 11px; background:white; color:var(--ink); outline:none; }
  	      #${ROOT_ID} .fif-input:focus, #${ROOT_ID} .fif-select:focus, #${ROOT_ID} .fif-textarea:focus { border-color:var(--accent); box-shadow:0 0 0 3px rgba(189,111,56,.12); }
  	      #${ROOT_ID} .fif-search { max-width:420px; }
  	      #${ROOT_ID} .fif-button { border:1px solid var(--line); background:white; color:var(--ink); border-radius:9px; padding:9px 13px; font-weight:700; display:inline-flex; align-items:center; gap:7px; }
  	      #${ROOT_ID} .fif-button:hover { transform:translateY(-1px); box-shadow:0 5px 12px rgba(24,36,48,.09); }
  	      #${ROOT_ID} .fif-button.primary { background:var(--accent); border-color:var(--accent); color:white; }
  	      #${ROOT_ID} .fif-button.danger { background:#fff5f5; border-color:#e5b9bb; color:var(--danger); }
  	      #${ROOT_ID} .fif-button:disabled { opacity:.55; cursor:not-allowed; transform:none; box-shadow:none; }
  	      #${ROOT_ID} .fif-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(220px,1fr)); gap:14px; }
  	      #${ROOT_ID} .fif-card { background:var(--panel); border:1px solid var(--line); border-radius:13px; padding:16px; box-shadow:0 3px 12px rgba(24,36,48,.04); }
  	      #${ROOT_ID} .fif-card.clickable { cursor:pointer; transition:.15s ease; }
  	      #${ROOT_ID} .fif-card.clickable:hover { transform:translateY(-2px); box-shadow:var(--shadow); border-color:#c8d1d8; }
  	      #${ROOT_ID} .fif-card h3 { margin:0 0 7px; font-size:15px; }
  	      #${ROOT_ID} .fif-card p { margin:0; color:var(--muted); font-size:12px; line-height:1.5; }
  	      #${ROOT_ID} .fif-stat { font-size:30px; font-weight:900; margin:8px 0 2px; }
  	      #${ROOT_ID} .fif-section-title { display:flex; justify-content:space-between; gap:14px; align-items:flex-end; margin-bottom:15px; }
  	      #${ROOT_ID} .fif-section-title h2 { margin:0; font-size:22px; }
  	      #${ROOT_ID} .fif-section-title p { margin:4px 0 0; color:var(--muted); }
  	      #${ROOT_ID} .fif-table-wrap { background:white; border:1px solid var(--line); border-radius:13px; overflow:auto; }
  	      #${ROOT_ID} table { width:100%; border-collapse:collapse; min-width:760px; }
  	      #${ROOT_ID} th { text-align:left; font-size:11px; text-transform:uppercase; letter-spacing:.04em; color:var(--muted); background:#f7f9fa; padding:11px 13px; border-bottom:1px solid var(--line); position:sticky; top:0; }
  	      #${ROOT_ID} td { padding:11px 13px; border-bottom:1px solid #edf1f4; font-size:12px; vertical-align:middle; }
  	      #${ROOT_ID} tr:last-child td { border-bottom:0; }
  	      #${ROOT_ID} .fif-actions { display:flex; gap:6px; justify-content:flex-end; }
  	      #${ROOT_ID} .fif-mini { border:1px solid var(--line); background:white; border-radius:7px; padding:6px 9px; font-size:11px; font-weight:700; }
  	      #${ROOT_ID} .fif-mini.danger { color:var(--danger); background:#fff6f6; }
  	      #${ROOT_ID} .fif-badge { display:inline-flex; align-items:center; border-radius:999px; padding:4px 8px; font-size:10px; font-weight:800; background:#e9eef2; color:#3a4a57; margin:2px 3px 2px 0; }
  	      #${ROOT_ID} .fif-badge.fifm { background:#e8f7ed; color:#17613a; }
  	      #${ROOT_ID} .fif-badge.fifc { background:#fff1df; color:#8b4d04; }
  	      #${ROOT_ID} .fif-badge.director { background:#e7efff; color:#284f9a; }
  	      #${ROOT_ID} .fif-badge.disabled { background:#fae7e8; color:#8e3035; }
  	      #${ROOT_ID} .fif-empty, #${ROOT_ID} .fif-denied, #${ROOT_ID} .fif-loading { background:white; border:1px dashed #c9d2d9; border-radius:13px; padding:42px 22px; text-align:center; color:var(--muted); }
  	      #${ROOT_ID} .fif-spinner { width:26px;height:26px;border:3px solid #d9e0e5;border-top-color:var(--accent);border-radius:50%;animation:fifspin .8s linear infinite;margin:0 auto 12px; }
  	      @keyframes fifspin { to { transform:rotate(360deg); } }
  	      #${ROOT_ID} .fif-modal-layer { position:fixed; inset:0; background:rgba(13,20,27,.58); display:none; align-items:center; justify-content:center; padding:24px; z-index:1000; }
  	      #${ROOT_ID} .fif-modal-layer.open { display:flex; }
  	      #${ROOT_ID} .fif-modal { width:min(980px,96vw); max-height:92vh; background:white; border-radius:15px; box-shadow:0 28px 80px rgba(0,0,0,.34); display:flex; flex-direction:column; overflow:hidden; }
  	      #${ROOT_ID} .fif-modal.small { width:min(560px,96vw); }
  	      #${ROOT_ID} .fif-modal-header { padding:16px 19px; border-bottom:1px solid var(--line); display:flex; justify-content:space-between; gap:12px; align-items:center; }
  	      #${ROOT_ID} .fif-modal-header h2 { margin:0; font-size:18px; }
  	      #${ROOT_ID} .fif-close { border:0;background:#eef2f4;width:34px;height:34px;border-radius:50%;font-size:20px; }
  	      #${ROOT_ID} .fif-modal-body { padding:18px 19px; overflow:auto; }
  	      #${ROOT_ID} .fif-modal-footer { padding:13px 19px; border-top:1px solid var(--line); display:flex; justify-content:flex-end; gap:9px; background:#fafbfc; }
  	      #${ROOT_ID} .fif-form-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:14px; }
  	      #${ROOT_ID} .fif-field.full { grid-column:1/-1; }
  	      #${ROOT_ID} .fif-field label { display:block; font-size:11px; font-weight:800; color:#445260; margin-bottom:6px; }
  	      #${ROOT_ID} .fif-help { color:var(--muted); font-size:10px; margin-top:5px; line-height:1.4; }
  	      #${ROOT_ID} .fif-check-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(150px,1fr)); gap:8px; }
  	      #${ROOT_ID} .fif-check { display:flex; gap:8px; align-items:center; border:1px solid var(--line); border-radius:8px; padding:8px 9px; background:#fafbfc; font-size:12px; }
  	      #${ROOT_ID} .fif-subsection { margin:18px 0; padding-top:16px; border-top:1px solid var(--line); }
  	      #${ROOT_ID} .fif-subsection h3 { margin:0 0 11px; font-size:14px; }
  	      #${ROOT_ID} .fif-code { font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace; min-height:180px; font-size:11px; line-height:1.45; }
  	      #${ROOT_ID} .fif-toast { position:fixed; right:22px; bottom:22px; min-width:280px; max-width:520px; background:#17212b; color:white; padding:13px 16px; border-radius:10px; box-shadow:var(--shadow); display:none; z-index:2000; font-size:12px; }
  	      #${ROOT_ID} .fif-toast.show { display:block; }
  	      #${ROOT_ID} .fif-toast.error { background:var(--danger); }
  	      #${ROOT_ID} .fif-toast.success { background:var(--success); }
  	      #${ROOT_ID} .fif-wizard-steps { display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:18px; }
  	      #${ROOT_ID} .fif-step { padding:8px;text-align:center;border-radius:8px;background:#eef2f4;color:var(--muted);font-size:10px;font-weight:800; }
  	      #${ROOT_ID} .fif-step.active { background:var(--accent);color:white; }
  	      #${ROOT_ID} .fif-note { border-left:4px solid var(--accent); background:#fff8f2; padding:11px 13px; border-radius:8px; font-size:12px; line-height:1.5; }
  	      #${ROOT_ID} .fif-danger-note { border-left-color:var(--danger); background:#fff5f5; }
  	      @media (max-width: 900px) {
  	        #${ROOT_ID} .fif-app { grid-template-columns:78px minmax(0,1fr); }
  	        #${ROOT_ID} .fif-brand-title, #${ROOT_ID} .fif-brand-sub, #${ROOT_ID} .fif-nav-label, #${ROOT_ID} .fif-rail-footer { display:none; }
  	        #${ROOT_ID} .fif-brand { justify-content:center;padding:10px; }
  	        #${ROOT_ID} .fif-nav-button { justify-content:center;padding:11px 6px; }
  	        #${ROOT_ID} .fif-company-select { min-width:160px; }
  	      }
  	      @media (max-width: 650px) {
  	        #${ROOT_ID} .fif-app { grid-template-columns:1fr; grid-template-rows:auto 1fr; }
  	        #${ROOT_ID} .fif-rail { height:auto; }
  	        #${ROOT_ID} .fif-brand, #${ROOT_ID} .fif-rail-footer { display:none; }
  	        #${ROOT_ID} .fif-nav { display:flex; overflow:auto; padding:6px; }
  	        #${ROOT_ID} .fif-nav-button { min-width:54px; width:auto; margin:0 2px; }
  	        #${ROOT_ID} .fif-main { min-height:0; }
  	        #${ROOT_ID} .fif-top { flex-wrap:wrap; padding:10px 13px; }
  	        #${ROOT_ID} .fif-company-select { width:100%; max-width:none; }
  	        #${ROOT_ID} .fif-user-chip { display:none; }
  	        #${ROOT_ID} .fif-content { padding:14px; }
  	        #${ROOT_ID} .fif-form-grid { grid-template-columns:1fr; }
  	        #${ROOT_ID} .fif-field.full { grid-column:auto; }
  	      }
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function showToast(message, type = "success") {
  	    const toast = state.root?.querySelector(".fif-toast");
  	    if (!toast) return;
  	    clearTimeout(state.toastTimer);
  	    toast.textContent = clean(message);
  	    toast.className = `fif-toast show ${type}`;
  	    state.toastTimer = setTimeout(() => { toast.className = "fif-toast"; }, 4500);
  	  }

  	  function loadingHtml(message = "Loading…") {
  	    return `<div class="fif-loading"><div class="fif-spinner"></div>${escapeHtml(message)}</div>`;
  	  }

  	  function emptyHtml(title, message, actionHtml = "") {
  	    return `<div class="fif-empty"><h3>${escapeHtml(title)}</h3><p>${escapeHtml(message)}</p>${actionHtml ? `<div style="margin-top:14px">${actionHtml}</div>` : ""}</div>`;
  	  }

  	  function deniedHtml(message = "You do not have permission to open this section.") {
  	    return `<div class="fif-denied"><h3>Access denied</h3><p>${escapeHtml(message)}</p></div>`;
  	  }

  	  function authorityBadge(user) {
  	    const authority = resolveAuthority(user);
  	    const cls = authority.level.toLowerCase();
  	    return `<span class="fif-badge ${cls}">${escapeHtml(authority.level)}</span>`;
  	  }

  	  function valuesBadges(value, normalizer) {
  	    return normalizer(value).map(item => `<span class="fif-badge">${escapeHtml(item)}</span>`).join("");
  	  }

  	  /* ========================================================================
  	   * 15. SHELL RENDERING
  	   * ====================================================================== */

  	  function platformLabel() {
  	    if (state.authority.isFIFM) return "FIFM Platform Management";
  	    if (state.authority.isFIFC) return "FIFC Support & Correction";
  	    return state.authority.isDirector ? "Customer Director" : "Customer User";
  	  }

  	  function platformDescription() {
  	    if (state.authority.isFIFM) return "Unrestricted platform authority";
  	    if (state.authority.isFIFC) return "Assigned-company support access";
  	    return selectedCompany() ? companyName(selectedCompany()) : "No company selected";
  	  }

  	  function mountShell() {
  	    installStyles();
  	    document.getElementById(ROOT_ID)?.remove();
  	    const root = document.createElement("div");
  	    root.id = ROOT_ID;
  	    root.innerHTML = `
  	      <div class="fif-app">
  	        <aside class="fif-rail">
  	          <div class="fif-brand">
  	            ${logoHtml()}
  	            <div><div class="fif-brand-title">Fleet In Form</div><div class="fif-brand-sub">Settings Manager ${escapeHtml(VERSION)}</div></div>
  	          </div>
  	          <nav class="fif-nav" data-region="nav"></nav>
  	          <div class="fif-rail-footer">${escapeHtml(platformLabel())}</div>
  	        </aside>
  	        <section class="fif-main">
  	          <header class="fif-top" data-region="top"></header>
  	          <main class="fif-content" data-region="content"></main>
  	        </section>
  	      </div>
  	      <div class="fif-modal-layer" data-region="modal"></div>
  	      <div class="fif-toast"></div>
  	    `;
  	    document.body.appendChild(root);
  	    state.root = root;
  	    state.mounted = true;
  	    document.body.style.overflow = "hidden";
  	    bindEvents();
  	  }

  	  function renderNavigation() {
  	    const region = state.root?.querySelector('[data-region="nav"]');
  	    if (!region) return;
  	    const items = availableNavigation();
  	    state.activeSection = defaultSection();
  	    region.innerHTML = items.map(item => `
  	      <button class="fif-nav-button ${item.id === state.activeSection ? "active" : ""}" data-action="navigate" data-section="${escapeAttr(item.id)}" title="${escapeAttr(item.label)}">
  	        <span class="fif-nav-icon">${item.icon}</span><span class="fif-nav-label">${escapeHtml(item.label)}</span>
  	      </button>
  	    `).join("");
  	  }

  	  function renderTop() {
  	    const region = state.root?.querySelector('[data-region="top"]');
  	    if (!region) return;
  	    const companyOptions = state.selectableCompanies.map(company => `<option value="${escapeAttr(companyObjectId(company))}" ${companyObjectId(company) === state.selectedCompanyObjectId ? "selected" : ""}>${escapeHtml(companyName(company))}</option>`).join("");
  	    const initials = userDisplayName(state.currentUser).split(/\s+/).slice(0, 2).map(part => part[0] || "").join("").toUpperCase() || "U";
  	    region.innerHTML = `
  	      <div class="fif-context">
  	        <h1>${escapeHtml(platformLabel())}</h1>
  	        <p>${escapeHtml(platformDescription())}</p>
  	      </div>
  	      ${state.selectableCompanies.length ? `
  	        <select class="fif-company-select" data-action="select-company" aria-label="Selected company">
  	          ${companyOptions}
  	        </select>
  	      ` : ""}
  	      <div class="fif-user-chip">
  	        <div class="fif-avatar">${escapeHtml(initials)}</div>
  	        <div><strong>${escapeHtml(userDisplayName(state.currentUser))}</strong><span>${escapeHtml(state.authority.level)}</span></div>
  	      </div>
  	    `;
  	  }

  	  async function renderMain() {
  	    const region = state.root?.querySelector('[data-region="content"]');
  	    if (!region) return;
  	    state.activeSection = defaultSection();
  	    renderNavigation();
  	    renderTop();
  	    region.innerHTML = loadingHtml();
  	    try {
  	      const html = await renderSection(state.activeSection);
  	      region.innerHTML = html;
  	    } catch (error) {
  	      warn("Section render failed.", error);
  	      region.innerHTML = `<div class="fif-denied"><h3>Unable to load this section</h3><p>${escapeHtml(error.message || error)}</p></div>`;
  	    }
  	  }

  	  async function renderSection(section) {
  	    switch (section) {
  	      case "overview": return renderOverview();
  	      case "companies": return renderCompanies();
  	      case "company-profile": return renderCompanyProfile();
  	      case "applications": return renderApplications();
  	      case "users": return renderUsers();
  	      case "fuel": return renderFuel();
  	      case "loads": return renderLoads();
  	      case "trips": return renderTrips();
  	      case "jobs": return renderJobs();
  	      case "audit": return renderAudit();
  	      case "tractors":
  	      case "trailers":
  	      case "implements":
  	      case "tanks":
  	      case "bowsers":
  	      case "tyres":
  	      case "locations":
  	      case "routes":
  	        return renderResource(section);
  	      default:
  	        return emptyHtml("Section unavailable", "The requested section is not registered.");
  	    }
  	  }

  	  function sectionHeading(title, description, actions = "") {
  	    return `<div class="fif-section-title"><div><h2>${escapeHtml(title)}</h2><p>${escapeHtml(description)}</p></div><div>${actions}</div></div>`;
  	  }

  	  function routeButton(section, label) {
  	    return `<button class="fif-button" data-action="navigate" data-section="${escapeAttr(section)}">${escapeHtml(label)}</button>`;
  	  }

  	  async function renderOverview() {
  	    if (state.authority.isFIFM) {
  	      const managedCount = state.managedCompanies.length;
  	      return `
  	        ${sectionHeading("Platform Overview", "Manage the entire Fleet In Form platform from one authority-aware application.", `<button class="fif-button primary" data-action="open-onboarding">Create Customer</button>`)}
  	        <div class="fif-grid">
  	          <div class="fif-card clickable" data-action="navigate" data-section="companies"><h3>All Companies</h3><div class="fif-stat">${state.allCompanies.length}</div><p>Every active, suspended and managed customer company.</p></div>
  	          <div class="fif-card clickable" data-action="navigate" data-section="companies"><h3>My Managed Companies</h3><div class="fif-stat">${managedCount}</div><p>Your personal working portfolio. It does not limit global authority.</p></div>
  	          <div class="fif-card clickable" data-action="navigate" data-section="users"><h3>Platform Users</h3><div class="fif-stat">${state.caches.usersAll?.length ?? "—"}</div><p>FIFM staff, FIFC support, Directors and ordinary customer users.</p></div>
  	          <div class="fif-card"><h3>Authority</h3><div class="fif-stat">FIFM</div><p>Office, Settings, Role and Home cannot restrict this account.</p></div>
  	        </div>
  	        <div class="fif-subsection">
  	          <h3>Managed Portfolio</h3>
  	          ${state.managedCompanies.length ? `<div class="fif-grid">${state.managedCompanies.slice(0, 8).map(company => companyCard(company, true)).join("")}</div>` : emptyHtml("No managed companies", "Add companies to your working portfolio from All Companies.", routeButton("companies", "Open Companies"))}
  	        </div>
  	      `;
  	    }

  	    if (state.authority.isFIFC) {
  	      const cards = [];
  	      if (state.access.can(ACTIONS.FUEL_VIEW, { company: selectedCompany() })) cards.push(["Fuel Corrections", "fuel", "Correct fuel, mileage and bowser meter records safely."]);
  	      if (state.access.can(ACTIONS.LOADS_VIEW, { company: selectedCompany() })) cards.push(["Load Corrections", "loads", "Correct assigned-company loads while preserving documents and signatures."]);
  	      if (state.access.can(ACTIONS.VEHICLES_VIEW, { company: selectedCompany() })) cards.push(["Fleet Support", "tractors", "Inspect and correct vehicles, trailers, implements and tyres."]);
  	      return `
  	        ${sectionHeading("Support Overview", "Only companies assigned through Users.Companies are available.")}
  	        <div class="fif-grid">
  	          <div class="fif-card clickable" data-action="navigate" data-section="companies"><h3>Assigned Companies</h3><div class="fif-stat">${state.selectableCompanies.length}</div><p>Your strict support scope.</p></div>
  	          ${cards.map(([title, section, description]) => `<div class="fif-card clickable" data-action="navigate" data-section="${section}"><h3>${escapeHtml(title)}</h3><p>${escapeHtml(description)}</p></div>`).join("")}
  	        </div>
  	        ${!state.selectableCompanies.length ? `<div style="margin-top:16px">${emptyHtml("No assigned companies", "FIFM must assign at least one company through Users.Companies before support work is available.")}</div>` : ""}
  	      `;
  	    }

  	    const company = selectedCompany();
  	    if (!company) return emptyHtml("No company access", "This account has no company in Users.Companies. No platform company was selected automatically.");
  	    const cards = [
  	      ["Vehicles", "tractors", relationList(company, "Tractors").length, ACTIONS.VEHICLES_VIEW],
  	      ["Trailers", "trailers", relationList(company, "Trailers").filter(item => lower(item.Type) !== "implement").length, ACTIONS.TRAILERS_VIEW],
  	      ["Implements", "implements", relationList(company, "Trailers").filter(item => lower(item.Type) === "implement").length, ACTIONS.IMPLEMENTS_VIEW],
  	      ["Tanks", "tanks", relationList(company, "Tanks").length, ACTIONS.TANKS_VIEW],
  	      ["Locations", "locations", relationList(company, "Locations").length, ACTIONS.LOCATIONS_VIEW],
  	      ["Users", "users", relationList(company, "Employees").length, ACTIONS.USERS_VIEW]
  	    ].filter(item => state.access.can(item[3], { company }));
  	    return `
  	      ${sectionHeading(companyName(company), `${companyBusinessId(company) || "No business ID"} · ${companyStatus(company)}`)}
  	      <div class="fif-grid">
  	        ${cards.map(([title, section, count]) => `<div class="fif-card clickable" data-action="navigate" data-section="${section}"><h3>${escapeHtml(title)}</h3><div class="fif-stat">${count}</div><p>Open ${escapeHtml(text(title).toLowerCase())} for the selected company.</p></div>`).join("")}
  	      </div>
  	    `;
  	  }

  	  function companyCard(company, managed) {
  	    return `<div class="fif-card clickable" data-action="open-company" data-id="${escapeAttr(companyObjectId(company))}">
  	      <div style="display:flex;justify-content:space-between;gap:9px;align-items:start"><h3>${escapeHtml(companyName(company))}</h3><span class="fif-badge ${companyStatus(company) === "ACTIVE" ? "fifm" : "disabled"}">${escapeHtml(companyStatus(company))}</span></div>
  	      <p>${escapeHtml(companyBusinessId(company) || "No company business identifier")}</p>
  	      ${managed ? '<div style="margin-top:9px"><span class="fif-badge fifm">Managed</span></div>' : ""}
  	    </div>`;
  	  }

  	  async function renderCompanies() {
  	    if (!state.access.can(state.authority.isFIFM ? ACTIONS.COMPANIES_VIEW_ALL : ACTIONS.COMPANIES_VIEW_ASSIGNED)) return deniedHtml();
  	    const search = lower(state.filters.companySearch || "");
  	    const list = (state.authority.isFIFM ? state.allCompanies : state.selectableCompanies)
  	      .filter(company => !search || lower(`${companyName(company)} ${companyBusinessId(company)} ${companyStatus(company)}`).includes(search));
  	    const managed = new Set(state.managedCompanies.map(companyObjectId));
  	    const create = state.access.can(ACTIONS.COMPANIES_CREATE) ? `<button class="fif-button primary" data-action="open-onboarding">Create Customer</button>` : "";
  	    return `
  	      ${sectionHeading(state.authority.isFIFM ? "All Companies" : "Assigned Companies", state.authority.isFIFM ? "Open any company or maintain your personal managed portfolio." : "Your access is strictly limited to these assigned companies.", create)}
  	      <div class="fif-toolbar"><input class="fif-input fif-search grow" data-filter="companySearch" value="${escapeAttr(state.filters.companySearch || "")}" placeholder="Search company name, business ID or status"></div>
  	      ${list.length ? `<div class="fif-table-wrap"><table><thead><tr><th>Company</th><th>Business ID</th><th>Status</th>${state.authority.isFIFM ? "<th>Managed</th>" : ""}<th></th></tr></thead><tbody>
  	        ${list.map(company => `<tr>
  	          <td><strong>${escapeHtml(companyName(company))}</strong></td>
  	          <td>${escapeHtml(companyBusinessId(company) || "—")}</td>
  	          <td><span class="fif-badge ${companyStatus(company) === "ACTIVE" ? "fifm" : "disabled"}">${escapeHtml(companyStatus(company))}</span></td>
  	          ${state.authority.isFIFM ? `<td>${managed.has(companyObjectId(company)) ? '<span class="fif-badge fifm">Yes</span>' : "—"}</td>` : ""}
  	          <td><div class="fif-actions">
  	            <button class="fif-mini" data-action="open-company" data-id="${escapeAttr(companyObjectId(company))}">Open</button>
  	            ${state.access.can(ACTIONS.COMPANIES_EDIT, { company }) ? `<button class="fif-mini" data-action="edit-company" data-id="${escapeAttr(companyObjectId(company))}">Edit</button>` : ""}
  	            ${state.authority.isFIFM ? `<button class="fif-mini" data-action="toggle-managed" data-id="${escapeAttr(companyObjectId(company))}" data-managed="${managed.has(companyObjectId(company)) ? "1" : "0"}">${managed.has(companyObjectId(company)) ? "Remove from Mine" : "Add to Mine"}</button>` : ""}
  	          </div></td>
  	        </tr>`).join("")}
  	      </tbody></table></div>` : emptyHtml("No companies found", search ? "No company matches the current search." : "No companies are available in this scope.")}
  	    `;
  	  }

  	  async function renderCompanyProfile() {
  	    const company = requireSelectedCompany(ACTIONS.COMPANIES_VIEW_ASSIGNED);
  	    return `
  	      ${sectionHeading("Company Profile", "The selected company's authoritative Backendless record.", state.access.can(ACTIONS.COMPANIES_EDIT, { company }) ? `<button class="fif-button primary" data-action="edit-company" data-id="${escapeAttr(companyObjectId(company))}">Edit Company</button>` : "")}
  	      <div class="fif-grid">
  	        <div class="fif-card"><h3>Registered Name</h3><p>${escapeHtml(companyName(company))}</p></div>
  	        <div class="fif-card"><h3>Business Identifier</h3><p>${escapeHtml(companyBusinessId(company) || "Not set")}</p></div>
  	        <div class="fif-card"><h3>Status</h3><p>${escapeHtml(companyStatus(company))}</p></div>
  	        <div class="fif-card"><h3>Backendless objectId</h3><p>${escapeHtml(companyObjectId(company))}</p></div>
  	      </div>
  	      <div class="fif-subsection"><h3>Manifest</h3><textarea class="fif-textarea fif-code" readonly>${escapeHtml(prettyJson(company.Manifest || {}))}</textarea></div>
  	      <div class="fif-subsection"><h3>References</h3><textarea class="fif-textarea fif-code" readonly>${escapeHtml(prettyJson(company.Refrences || {}))}</textarea></div>
  	    `;
  	  }

  	  async function renderApplications() {
  	    const company = requireSelectedCompany(ACTIONS.APPLICATIONS_VIEW);
  	    const applications = uniqueValues(company?.Manifest?.Applications || company?.Manifest?.Products || []);
  	    return `
  	      ${sectionHeading("Applications", "Operational applications enabled for the selected company.", state.access.can(ACTIONS.APPLICATIONS_EDIT, { company }) ? `<button class="fif-button primary" data-action="edit-applications">Edit Applications</button>` : "")}
  	      <div class="fif-grid">
  	        ${["Office", "Road", "Bowser"].map(app => `<div class="fif-card"><h3>${escapeHtml(app)}</h3><p>${applications.includes(app) ? "Enabled" : "Not enabled"}</p><div style="margin-top:10px"><span class="fif-badge ${applications.includes(app) ? "fifm" : "disabled"}">${applications.includes(app) ? "ACTIVE" : "OFF"}</span></div></div>`).join("")}
  	      </div>
  	    `;
  	  }

  	  async function renderUsers() {
  	    const company = selectedCompany();
  	    if (!state.access.can(ACTIONS.USERS_VIEW, { company })) return deniedHtml();
  	    const users = state.authority.isFIFM ? await UserService.loadAll() : await UserService.loadCompanyEmployees(requireSelectedCompany(ACTIONS.USERS_VIEW));
  	    const search = lower(state.filters.userSearch || "");
  	    const authorityFilter = clean(state.filters.userAuthority || "ALL");
  	    const roleFilter = clean(state.filters.userRole || "ALL");
  	    const appFilter = clean(state.filters.userApp || "ALL");
  	    const statusFilter = clean(state.filters.userStatus || "ALL");
  	    const list = users.filter(user => {
  	      const authority = resolveAuthority(user);
  	      const haystack = lower(`${userDisplayName(user)} ${user.email} ${userNationalId(user)} ${user.Role} ${user.APP} ${(user.Companies || []).map(companyName).join(" ")}`);
  	      if (search && !haystack.includes(search)) return false;
  	      if (authorityFilter !== "ALL" && authority.level !== authorityFilter) return false;
  	      if (roleFilter !== "ALL" && !normalizeRoleValues(user.Role).includes(roleFilter)) return false;
  	      if (appFilter !== "ALL" && !normalizeAppValues(user.APP).includes(appFilter)) return false;
  	      const status = clean(user.userStatus || (user.loginEnabled === false ? "DISABLED" : "ENABLED")).toUpperCase();
  	      if (statusFilter !== "ALL" && status !== statusFilter) return false;
  	      return true;
  	    });
  	    const create = state.access.can(ACTIONS.USERS_CREATE, { company }) ? `<button class="fif-button primary" data-action="create-user">Create User</button>` : "";
  	    return `
  	      ${sectionHeading(state.authority.isFIFM ? "All Users" : "Company Users", state.authority.isFIFM ? "Search and manage all platform, support and customer users." : "Customer employees belonging to the selected company.", create)}
  	      <div class="fif-toolbar">
  	        <input class="fif-input fif-search grow" data-filter="userSearch" value="${escapeAttr(state.filters.userSearch || "")}" placeholder="Search name, email, ID, role, APP or company">
  	        <select class="fif-select" style="width:auto" data-filter="userAuthority"><option value="ALL">All authority</option>${["FIFM","FIFC","DIRECTOR","USER"].map(value => `<option ${authorityFilter===value?"selected":""}>${value}</option>`).join("")}</select>
  	        <select class="fif-select" style="width:auto" data-filter="userRole"><option value="ALL">All roles</option>${ACCESS_SCHEMA.roles.map(value => `<option value="${escapeAttr(value)}" ${roleFilter===value?"selected":""}>${escapeHtml(value)}</option>`).join("")}</select>
  	        <select class="fif-select" style="width:auto" data-filter="userApp"><option value="ALL">All APP</option>${ACCESS_SCHEMA.apps.map(value => `<option value="${escapeAttr(value)}" ${appFilter===value?"selected":""}>${escapeHtml(value)}</option>`).join("")}</select>
  	        <select class="fif-select" style="width:auto" data-filter="userStatus"><option value="ALL">All status</option><option ${statusFilter==="ENABLED"?"selected":""}>ENABLED</option><option ${statusFilter==="DISABLED"?"selected":""}>DISABLED</option></select>
  	      </div>
  	      ${list.length ? `<div class="fif-table-wrap"><table><thead><tr><th>User</th><th>Authority</th><th>APP</th><th>Roles</th><th>Companies</th><th>Status</th><th></th></tr></thead><tbody>
  	        ${list.map(user => {
  	          const status = clean(user.userStatus || (user.loginEnabled === false ? "DISABLED" : "ENABLED")).toUpperCase();
  	          return `<tr>
  	            <td><strong>${escapeHtml(userDisplayName(user))}</strong><br><span style="color:var(--muted)">${escapeHtml(user.email || "No email")} · ${escapeHtml(userNationalId(user) || "No ID")}</span></td>
  	            <td>${authorityBadge(user)}</td>
  	            <td>${valuesBadges(user.APP, normalizeAppValues) || "—"}</td>
  	            <td>${valuesBadges(user.Role, normalizeRoleValues) || "—"}</td>
  	            <td>${(user.Companies || []).length ? `<span class="fif-badge">${user.Companies.length}</span> ${escapeHtml((user.Companies || []).slice(0,2).map(companyName).join(", "))}` : "—"}</td>
  	            <td><span class="fif-badge ${status === "DISABLED" ? "disabled" : "fifm"}">${escapeHtml(status)}</span></td>
  	            <td><div class="fif-actions">
  	              ${state.access.can(ACTIONS.USERS_EDIT_PROFILE, { company }) ? `<button class="fif-mini" data-action="edit-user" data-id="${escapeAttr(userObjectId(user))}">Edit</button>` : ""}
  	              ${state.access.can(ACTIONS.USERS_DISABLE, { company }) && userObjectId(user) !== userObjectId(state.currentUser) ? `<button class="fif-mini ${status === "DISABLED" ? "" : "danger"}" data-action="toggle-user-status" data-id="${escapeAttr(userObjectId(user))}" data-disabled="${status === "DISABLED" ? "1" : "0"}">${status === "DISABLED" ? "Enable" : "Disable"}</button>` : ""}
  	            </div></td>
  	          </tr>`;
  	        }).join("")}
  	      </tbody></table></div>` : emptyHtml("No users found", search ? "No user matches the current filters." : "No users are available in this scope.")}
  	    `;
  	  }

  	  async function renderResource(resourceId) {
  	    const definition = resourceDefinition(resourceId);
  	    const company = requireSelectedCompany(definition.viewAction);
  	    const records = await ResourceService.load(resourceId, company);
  	    const filterKey = `${resourceId}Search`;
  	    const search = lower(state.filters[filterKey] || "");
  	    const list = records.filter(record => !search || lower(`${resourceTitle(record, definition)} ${prettyJson(record)}`).includes(search));
  	    const create = state.access.can(definition.createAction, { company }) ? `<button class="fif-button primary" data-action="create-resource" data-resource="${escapeAttr(resourceId)}">Create ${escapeHtml(definition.singular)}</button>` : "";
  	    return `
  	      ${sectionHeading(definition.label, `${definition.label} belonging to ${companyName(company)}.`, create)}
  	      <div class="fif-toolbar"><input class="fif-input fif-search grow" data-filter="${escapeAttr(filterKey)}" value="${escapeAttr(state.filters[filterKey] || "")}" placeholder="Search ${escapeAttr(definition.label.toLowerCase())}"><button class="fif-button" data-action="refresh-resource" data-resource="${escapeAttr(resourceId)}">Refresh</button></div>
  	      ${list.length ? `<div class="fif-table-wrap"><table><thead><tr><th>${escapeHtml(definition.singular)}</th><th>Details</th><th>Updated</th><th></th></tr></thead><tbody>
  	        ${list.map(record => `<tr>
  	          <td><strong>${escapeHtml(resourceTitle(record, definition))}</strong><br><span style="color:var(--muted)">${escapeHtml(objectId(record))}</span></td>
  	          <td>${resourceSummary(record, resourceId)}</td>
  	          <td>${escapeHtml(clean(record.updated || record.created || "—"))}</td>
  	          <td><div class="fif-actions">
  	            ${state.access.can(definition.editAction, { company }) ? `<button class="fif-mini" data-action="edit-resource" data-resource="${escapeAttr(resourceId)}" data-id="${escapeAttr(objectId(record))}">Edit</button>` : ""}
  	            ${state.access.can(definition.deleteAction, { company }) ? `<button class="fif-mini danger" data-action="delete-resource" data-resource="${escapeAttr(resourceId)}" data-id="${escapeAttr(objectId(record))}">Delete</button>` : ""}
  	          </div></td>
  	        </tr>`).join("")}
  	      </tbody></table></div>` : emptyHtml(`No ${definition.label.toLowerCase()}`, search ? "No record matches the current search." : `No ${definition.label.toLowerCase()} are related to this company.`, create)}
  	    `;
  	  }

  	  function resourceSummary(record, resourceId) {
  	    if (resourceId === "tractors" || resourceId === "trailers" || resourceId === "implements") return `${escapeHtml(clean(record.Registration || "No registration"))} · ${escapeHtml(clean(record.Type || ""))} · ${escapeHtml(text(record.Mileage || 0))} km`;
  	    if (resourceId === "tanks") return `${escapeHtml(clean(record.Grade || ""))} · ${escapeHtml(text(record.Volume || 0))}/${escapeHtml(text(record.Capacity || 0))} L`;
  	    if (resourceId === "bowsers") return `${escapeHtml(clean(record.Grade || ""))} · Meter ${escapeHtml(text(record.Meter || 0))} · ${escapeHtml(clean(record.__parentTankName || ""))}`;
  	    if (resourceId === "tyres") return `${escapeHtml(clean(record.Tyre_Brand || record.Make || ""))} ${escapeHtml(clean(record.Size || ""))} · ${escapeHtml(clean(record.Status || ""))}`;
  	    if (resourceId === "locations") return `${escapeHtml(clean(record.Type || ""))} · ${escapeHtml(clean(record.ContactName || ""))}`;
  	    return escapeHtml(clean(record.Description || "—"));
  	  }

  	  async function renderFuel() {
  	    const company = requireSelectedCompany(ACTIONS.FUEL_VIEW);
  	    const rows = await FuelService.load(company);
  	    const search = lower(state.filters.fuelSearch || "");
  	    const list = rows.filter(record => !search || lower(`${record.Registration} ${record.DriverName} ${record.Driver} ${record.Description} ${record.FuelDate} ${record.Litres}`).includes(search));
  	    return `
  	      ${sectionHeading("Fuel Corrections", "Protected corrections preserve original values and block unsafe meter or mileage overwrites.")}
  	      <div class="fif-note">Fuel reversals use a protected snapshot stored in the existing rollback fields. A correction is stopped when a linked vehicle, bowser or tank has moved beyond the transaction state.</div>
  	      <div class="fif-toolbar" style="margin-top:14px"><input class="fif-input fif-search grow" data-filter="fuelSearch" value="${escapeAttr(state.filters.fuelSearch || "")}" placeholder="Search registration, driver, date or description"><button class="fif-button" data-action="refresh-fuel">Refresh</button></div>
  	      ${list.length ? `<div class="fif-table-wrap"><table><thead><tr><th>Date</th><th>Vehicle</th><th>Driver</th><th>Litres</th><th>Mileage</th><th>Meter</th><th>Status</th><th></th></tr></thead><tbody>
  	        ${list.map(record => {
  	          const reversed = parseBoolean(record.IsReversed) || parseBoolean(record.Reversed);
  	          return `<tr>
  	            <td>${escapeHtml(clean(record.FuelDate || record.created || "—"))}</td>
  	            <td><strong>${escapeHtml(clean(record.Registration || record.TractorObjectId || record.VehicleObjectId || "—"))}</strong></td>
  	            <td>${escapeHtml(clean(record.DriverName || record.Driver || "—"))}</td>
  	            <td>${escapeHtml(text(record.Litres || 0))}</td>
  	            <td>${escapeHtml(text(record.Mileage || 0))}</td>
  	            <td>${escapeHtml(text(record.Meter || 0))}</td>
  	            <td><span class="fif-badge ${reversed ? "disabled" : record.RollbackProtected ? "fifc" : ""}">${escapeHtml(reversed ? "REVERSED" : record.RollbackStatus || "NORMAL")}</span></td>
  	            <td><div class="fif-actions">
  	              ${state.access.can(ACTIONS.FUEL_CORRECT, { company }) && !reversed && !record.RollbackProtected ? `<button class="fif-mini" data-action="correct-fuel" data-id="${escapeAttr(objectId(record))}">Correct</button>` : ""}
  	              ${state.access.can(ACTIONS.FUEL_REVERSE, { company }) && record.RollbackProtected && !reversed ? `<button class="fif-mini danger" data-action="reverse-fuel" data-id="${escapeAttr(objectId(record))}">Reverse</button>` : ""}
  	            </div></td>
  	          </tr>`;
  	        }).join("")}
  	      </tbody></table></div>` : emptyHtml("No scoped fuel transactions", "No FuelOut record could be safely linked to this company's vehicles, tanks or bowsers.")}
  	    `;
  	  }

  	  async function renderLoads() {
  	    const company = requireSelectedCompany(ACTIONS.LOADS_VIEW);
  	    const rows = await LoadService.load(company);
  	    const search = lower(state.filters.loadSearch || "");
  	    const list = rows.filter(record => !search || lower(`${record.Customer} ${record.Action} ${record.Date_Loading_Planned} ${record.Date_Delivery_Planned}`).includes(search));
  	    return `
  	      ${sectionHeading("Loads", "Company scope is resolved through the company's related locations. Documents, images, signatures and transfer JSON are preserved.")}
  	      <div class="fif-toolbar"><input class="fif-input fif-search grow" data-filter="loadSearch" value="${escapeAttr(state.filters.loadSearch || "")}" placeholder="Search customer, action or date"><button class="fif-button" data-action="refresh-loads">Refresh</button></div>
  	      ${list.length ? `<div class="fif-table-wrap"><table><thead><tr><th>Customer</th><th>Action</th><th>Planned Loading</th><th>Planned Delivery</th><th>Mass</th><th></th></tr></thead><tbody>
  	        ${list.map(record => `<tr>
  	          <td><strong>${escapeHtml(clean(record.Customer || "—"))}</strong></td>
  	          <td>${escapeHtml(clean(record.Action || "—"))}</td>
  	          <td>${escapeHtml(clean(record.Date_Loading_Planned || "—"))}</td>
  	          <td>${escapeHtml(clean(record.Date_Delivery_Planned || "—"))}</td>
  	          <td>${escapeHtml(text(record.Mass_Loaded || record.Mass_Planned || 0))}</td>
  	          <td><div class="fif-actions">${state.access.can(ACTIONS.LOADS_CORRECT, { company }) ? `<button class="fif-mini" data-action="correct-load" data-id="${escapeAttr(objectId(record))}">Correct</button>` : ""}</div></td>
  	        </tr>`).join("")}
  	      </tbody></table></div>` : emptyHtml("No scoped loads", "No load could be safely linked to one of this company's locations.")}
  	    `;
  	  }

  	  async function renderTrips() {
  	    const company = requireSelectedCompany(ACTIONS.TRIPS_VIEW);
  	    const rows = await OperationalService.loadTrips(company);
  	    return `
  	      ${sectionHeading("Trips", "Trips are scoped through tractors related to the selected company.")}
  	      <div class="fif-toolbar"><button class="fif-button" data-action="refresh-trips">Refresh</button></div>
  	      ${rows.length ? `<div class="fif-table-wrap"><table><thead><tr><th>Trip</th><th>Tractor</th><th>Created</th><th>Updated</th></tr></thead><tbody>
  	        ${rows.map(record => `<tr><td><strong>${escapeHtml(objectId(record))}</strong></td><td>${escapeHtml(clean(record.Tractor?.Registration || record.Tractor?.FID || objectId(record.Tractor) || "—"))}</td><td>${escapeHtml(clean(record.created || "—"))}</td><td>${escapeHtml(clean(record.updated || "—"))}</td></tr>`).join("")}
  	      </tbody></table></div>` : emptyHtml("No scoped trips", "No trip is related to one of this company's tractors.")}
  	    `;
  	  }

  	  async function renderJobs() {
  	    const company = requireSelectedCompany(ACTIONS.JOBS_VIEW);
  	    const rows = await OperationalService.loadJobs(company);
  	    const search = lower(state.filters.jobSearch || "");
  	    const list = rows.filter(record => !search || lower(`${record.LocationLabel} ${record.VehicleLabel} ${record.ContractorLabel} ${record.Status} ${record.DateISO}`).includes(search));
  	    return `
  	      ${sectionHeading("Jobs", "Job entries are scoped through Locations.Jobs for the selected company.")}
  	      <div class="fif-toolbar"><input class="fif-input fif-search grow" data-filter="jobSearch" value="${escapeAttr(state.filters.jobSearch || "")}" placeholder="Search location, vehicle, contractor, status or date"><button class="fif-button" data-action="refresh-jobs">Refresh</button></div>
  	      ${list.length ? `<div class="fif-table-wrap"><table><thead><tr><th>Date</th><th>Location</th><th>Vehicle</th><th>Contractor</th><th>Status</th><th>Area</th><th>Fuel</th><th></th></tr></thead><tbody>
  	        ${list.map(record => `<tr><td>${escapeHtml(clean(record.DateISO || record.Time || record.created || "—"))}</td><td>${escapeHtml(clean(record.LocationLabel || record.__locationName || "—"))}</td><td>${escapeHtml(clean(record.VehicleLabel || record.VehicleId || "—"))}</td><td>${escapeHtml(clean(record.ContractorLabel || record.ContractorId || "—"))}</td><td><span class="fif-badge">${escapeHtml(clean(record.Status || "—"))}</span></td><td>${escapeHtml(text(record.Area || 0))}</td><td>${escapeHtml(text(record.Fuel || 0))}</td><td><div class="fif-actions">${state.access.can(ACTIONS.JOBS_CORRECT, { company }) ? `<button class="fif-mini" data-action="correct-job" data-id="${escapeAttr(objectId(record))}">Correct</button>` : ""}</div></td></tr>`).join("")}
  	      </tbody></table></div>` : emptyHtml("No scoped jobs", "No job entry is related to one of this company's locations.")}
  	    `;
  	  }

  	  async function renderAudit() {
  	    if (!state.access.can(ACTIONS.AUDIT_VIEW, { company: selectedCompany() })) return deniedHtml();
  	    const company = selectedCompany();
  	    const rows = state.caches.audit.filter(entry => state.authority.isFIFM || !company || entry.CompanyObjectId === companyObjectId(company));
  	    return `
  	      ${sectionHeading("Audit", "Sensitive actions recorded during this application session. A dedicated AuditLog table can be added without changing managers.")}
  	      ${rows.length ? `<div class="fif-table-wrap"><table><thead><tr><th>Time</th><th>Actor</th><th>Company</th><th>Action</th><th>Target</th><th>Result</th><th>Reason</th></tr></thead><tbody>
  	        ${rows.map(entry => `<tr><td>${escapeHtml(entry.Timestamp)}</td><td>${escapeHtml(entry.ActorName)}<br><span class="fif-badge">${escapeHtml(entry.ActorAuthority)}</span></td><td>${escapeHtml(entry.CompanyName || "Platform")}</td><td>${escapeHtml(entry.Action)}</td><td>${escapeHtml(`${entry.TargetTable}:${entry.TargetObjectId}`)}</td><td><span class="fif-badge ${entry.Result === "SUCCESS" ? "fifm" : "disabled"}">${escapeHtml(entry.Result)}</span></td><td>${escapeHtml(entry.Reason || entry.Error || "—")}</td></tr>`).join("")}
  	      </tbody></table></div>` : emptyHtml("No audit entries yet", "Sensitive actions performed through this manager will appear here.")}
  	    `;
  	  }

  	  /* ========================================================================
  	   * 16. MODALS AND EDITORS
  	   * ====================================================================== */

  	  function fieldHtml(name, label, value, type = "text", options = {}) {
  	    const full = options.full ? " full" : "";
  	    const readonly = options.readonly ? "readonly" : "";
  	    const disabled = options.disabled ? "disabled" : "";
  	    const required = options.required ? "required" : "";
  	    const help = options.help ? `<div class="fif-help">${escapeHtml(options.help)}</div>` : "";
  	    if (type === "textarea" || type === "json") {
  	      return `<div class="fif-field${full}"><label>${escapeHtml(label)}</label><textarea class="fif-textarea ${type === "json" ? "fif-code" : ""}" name="${escapeAttr(name)}" ${readonly} ${disabled} ${required}>${escapeHtml(type === "json" ? prettyJson(value) : text(value))}</textarea>${help}</div>`;
  	    }
  	    if (type === "select") {
  	      return `<div class="fif-field${full}"><label>${escapeHtml(label)}</label><select class="fif-select" name="${escapeAttr(name)}" ${disabled} ${required}>${(options.values || []).map(option => `<option value="${escapeAttr(option)}" ${clean(option) === clean(value) ? "selected" : ""}>${escapeHtml(option || "None")}</option>`).join("")}</select>${help}</div>`;
  	    }
  	    if (type === "boolean") {
  	      return `<div class="fif-field${full}"><label>${escapeHtml(label)}</label><label class="fif-check"><input type="checkbox" name="${escapeAttr(name)}" value="1" ${parseBoolean(value) ? "checked" : ""} ${disabled}> Yes</label>${help}</div>`;
  	    }
  	    return `<div class="fif-field${full}"><label>${escapeHtml(label)}</label><input class="fif-input" type="${escapeAttr(type)}" name="${escapeAttr(name)}" value="${escapeAttr(value)}" ${readonly} ${disabled} ${required}>${help}</div>`;
  	  }

  	  function checkboxGroupHtml(name, label, values, selected, options = {}) {
  	    const selectedSet = new Set(selected || []);
  	    return `<div class="fif-field full"><label>${escapeHtml(label)}</label><div class="fif-check-grid">${values.map(value => `<label class="fif-check"><input type="checkbox" name="${escapeAttr(name)}" value="${escapeAttr(value)}" ${selectedSet.has(value) ? "checked" : ""} ${options.disabled ? "disabled" : ""}> ${escapeHtml(value)}</label>`).join("")}</div>${options.help ? `<div class="fif-help">${escapeHtml(options.help)}</div>` : ""}</div>`;
  	  }

  	  function openModal(kind, data = {}) {
  	    state.modal = { kind, data };
  	    renderModal();
  	  }

  	  function closeModal() {
  	    state.modal = null;
  	    renderModal();
  	  }

  	  function modalFrame(title, body, footer, small = false) {
  	    return `<div class="fif-modal ${small ? "small" : ""}">
  	      <div class="fif-modal-header"><h2>${escapeHtml(title)}</h2><button class="fif-close" data-action="close-modal" aria-label="Close">×</button></div>
  	      <div class="fif-modal-body">${body}</div>
  	      <div class="fif-modal-footer">${footer}</div>
  	    </div>`;
  	  }

  	  function renderModal() {
  	    const layer = state.root?.querySelector('[data-region="modal"]');
  	    if (!layer) return;
  	    if (!state.modal) {
  	      layer.className = "fif-modal-layer";
  	      layer.innerHTML = "";
  	      return;
  	    }
  	    const { kind, data } = state.modal;
  	    let html = "";
  	    if (kind === "company-editor") html = renderCompanyEditor(data);
  	    else if (kind === "applications-editor") html = renderApplicationsEditor(data);
  	    else if (kind === "user-editor") html = renderUserEditor(data);
  	    else if (kind === "resource-editor") html = renderResourceEditor(data);
  	    else if (kind === "fuel-correction") html = renderFuelCorrection(data);
  	    else if (kind === "load-correction") html = renderLoadCorrection(data);
  	    else if (kind === "job-correction") html = renderJobCorrection(data);
  	    else if (kind === "onboarding") html = renderOnboarding(data);
  	    else if (kind === "confirm") html = renderConfirm(data);
  	    else html = modalFrame("Unavailable", `<p>Unknown modal: ${escapeHtml(kind)}</p>`, `<button class="fif-button" data-action="close-modal">Close</button>`, true);
  	    layer.innerHTML = html;
  	    layer.className = "fif-modal-layer open";
  	  }

  	  function renderCompanyEditor(data) {
  	    const company = normalizeCompany(data.company || selectedCompany() || {});
  	    const isNew = !companyObjectId(company);
  	    const body = `<form data-form="company" class="fif-form-grid">
  	      ${fieldHtml("Name", "Registered company name", company.Name, "text", { required: true })}
  	      ${fieldHtml("CompanyId", "Company business identifier", company.CompanyId, "text", { required: true, readonly: !state.authority.isFIFM })}
  	      ${fieldHtml("Status", "Status", company.Status || "ACTIVE", "select", { values: ["ACTIVE", "SUSPENDED", "INACTIVE"] })}
  	      ${fieldHtml("Manifest", "Manifest JSON", company.Manifest || {}, "json", { full: true })}
  	      ${fieldHtml("Refrences", "References JSON", company.Refrences || {}, "json", { full: true })}
  	      ${fieldHtml("reason", "Change reason", data.reason || "", "textarea", { full: true, required: true })}
  	    </form>`;
  	    const footer = `<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-company" ${state.saving ? "disabled" : ""}>${isNew ? "Create Company" : "Save Company"}</button>`;
  	    return modalFrame(isNew ? "Create Company" : "Edit Company", body, footer);
  	  }

  	  function renderApplicationsEditor(data) {
  	    const company = data.company || selectedCompany();
  	    const selected = uniqueValues(company?.Manifest?.Applications || company?.Manifest?.Products || []);
  	    const body = `<form data-form="applications" class="fif-form-grid">
  	      ${checkboxGroupHtml("Applications", "Enabled applications", ["Office", "Road", "Bowser"], selected)}
  	      ${fieldHtml("reason", "Change reason", "", "textarea", { full: true, required: true })}
  	    </form>`;
  	    return modalFrame("Edit Applications", body, `<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-applications">Save Applications</button>`, true);
  	  }

  	  function userEditorEnvelope(existing) {
  	    if (state.authority.isFIFM) return state.access.grantEnvelope();
  	    if (state.authority.isDirector) return state.access.grantEnvelope();
  	    return {
  	      apps: normalizeAppValues(existing.APP), office: normalizeOfficeValues(existing.Office),
  	      settings: normalizeSettingsValues(existing.Settings), roles: normalizeRoleValues(existing.Role),
  	      homes: normalizeOfficeValues(existing.Office)
  	    };
  	  }

  	  function renderUserEditor(data) {
  	    const user = normalizeUser(data.user || defaultUser());
  	    const isNew = !userObjectId(user);
  	    const details = employeeDetails(user);
  	    const envelope = userEditorEnvelope(user);
  	    const canPermissions = state.access.can(ACTIONS.USERS_EDIT_PERMISSIONS, { company: selectedCompany() });
  	    const canPayroll = state.access.can(ACTIONS.USERS_EDIT_PAYROLL, { company: selectedCompany() });
  	    const companies = Array.isArray(data.companies) ? data.companies : relationList(user, "Companies");
  	    const selectedCompanyIds = new Set(companies.map(companyObjectId));
  	    const companyAssignment = state.authority.isFIFM ? `
  	      <div class="fif-field full"><label>Company scope</label><div class="fif-check-grid">${state.allCompanies.map(company => `<label class="fif-check"><input type="checkbox" name="Companies" value="${escapeAttr(companyObjectId(company))}" ${selectedCompanyIds.has(companyObjectId(company)) ? "checked" : ""}> ${escapeHtml(companyName(company))}</label>`).join("")}</div><div class="fif-help">For FIFM and FIFC this relation controls managed/support scope only. Customer users are also maintained in Companies.Employees.</div></div>
  	    ` : `<div class="fif-note">Company is fixed to <strong>${escapeHtml(companyName(selectedCompany()))}</strong>. Directors cannot select arbitrary companies.</div>`;

  	    const body = `<form data-form="user">
  	      <div class="fif-form-grid">
  	        ${fieldHtml("first_name", "First name", details.first_name, "text", { required: true })}
  	        ${fieldHtml("last_name", "Last name", details.last_name, "text", { required: true })}
  	        ${fieldHtml("ID", "National ID", user.ID, "text", { required: true })}
  	        ${fieldHtml("email", "Email / login", user.email, "email", { required: true })}
  	        ${fieldHtml("phone_number", "Phone number", details.contact_details?.phone_number || "", "text")}
  	        ${fieldHtml("employee_id", "Employee ID", details.employee_id || "", "text")}
  	        ${isNew ? fieldHtml("password", "Temporary password", "", "password", { required: true, help: "Minimum 8 characters. Backendless generates the technical objectId." }) : ""}
  	        ${fieldHtml("userStatus", "Status", user.userStatus || "ENABLED", "select", { values: ["ENABLED", "DISABLED"] })}
  	      </div>
  	      ${canPermissions ? `<div class="fif-subsection"><h3>Authority and Permissions</h3><div class="fif-form-grid">
  	        ${checkboxGroupHtml("APP", "APP", envelope.apps, normalizeAppValues(user.APP), { help: state.authority.isDirector ? "Only ordinary APP values the Director already holds are available." : "FIFM can assign every valid APP value." })}
  	        ${checkboxGroupHtml("Office", "Office modules", envelope.office, normalizeOfficeValues(user.Office))}
  	        ${checkboxGroupHtml("Settings", "Settings sections", envelope.settings, normalizeSettingsValues(user.Settings), { help: "Requires APP: Office and Office: Settings." })}
  	        ${checkboxGroupHtml("Role", "Roles", envelope.roles, normalizeRoleValues(user.Role))}
  	        ${fieldHtml("Home", "Home", user.Home, "select", { values: ["", ...envelope.homes] })}
  	      </div></div>` : `<div class="fif-note">This editor may change identity and employment information only. Authority fields remain unchanged.</div>`}
  	      <div class="fif-subsection"><h3>Company Scope</h3>${companyAssignment}</div>
  	      <div class="fif-subsection"><h3>Complete Employee Details</h3><div class="fif-form-grid">${fieldHtml("Data_Details", "Data_Details JSON", user.Data_Details || {}, "json", { full: true, help: "The entire existing employee-details structure is preserved." })}</div></div>
  	      ${canPayroll ? `<div class="fif-subsection"><h3>Payroll</h3><div class="fif-form-grid">${fieldHtml("Data_Wages", "Data_Wages JSON", user.Data_Wages || {}, "json", { full: true })}</div></div>` : ""}
  	      <div class="fif-form-grid">${fieldHtml("reason", "Change reason", "", "textarea", { full: true, required: !isNew })}</div>
  	    </form>`;
  	    const footer = `<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-user" ${state.saving ? "disabled" : ""}>${isNew ? "Create User" : "Save User"}</button>`;
  	    return modalFrame(isNew ? "Create User" : `Edit ${userDisplayName(user)}`, body, footer);
  	  }

  	  function renderResourceEditor(data) {
  	    const definition = resourceDefinition(data.resourceId);
  	    const record = { ...(definition.defaults || {}), ...clone(data.record || {}) };
  	    const isNew = !objectId(record);
  	    const fields = definition.fields.map(([name, label, type, values, readonly]) => {
  	      const value = record[name];
  	      const options = { values: values || [], readonly: !!readonly, full: type === "json" || type === "textarea" };
  	      return fieldHtml(name, label, value, type, options);
  	    }).join("");
  	    let parentTank = "";
  	    if (data.resourceId === "bowsers" && isNew) {
  	      const tanks = state.caches.tanks[state.selectedCompanyObjectId] || [];
  	      parentTank = fieldHtml("__parentTankObjectId", "Parent tank", record.__parentTankObjectId || "", "select", { values: ["", ...tanks.map(objectId)], required: true, help: "The selected tank receives the Tanks.Bowsers relation." });
  	    }
  	    const body = `<form data-form="resource" class="fif-form-grid">${parentTank}${fields}${fieldHtml("reason", "Change reason", "", "textarea", { full: true, required: true })}</form>`;
  	    const footer = `<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-resource">${isNew ? "Create" : "Save"} ${escapeHtml(definition.singular)}</button>`;
  	    return modalFrame(`${isNew ? "Create" : "Edit"} ${definition.singular}`, body, footer);
  	  }

  	  function renderFuelCorrection(data) {
  	    const record = clone(data.record || {});
  	    const reverse = data.mode === "reverse";
  	    const body = reverse ? `
  	      <div class="fif-note fif-danger-note">This will restore the protected transaction snapshot and linked vehicle, bowser and tank values only when their current state still matches the corrected transaction.</div>
  	      <form data-form="fuel" class="fif-form-grid" style="margin-top:14px">${fieldHtml("reason", "Reversal reason", "", "textarea", { full: true, required: true })}</form>
  	    ` : `<form data-form="fuel" class="fif-form-grid">
  	      ${fieldHtml("Litres", "Litres", record.Litres || 0, "number")}
  	      ${fieldHtml("Mileage", "Vehicle mileage", record.Mileage || 0, "number")}
  	      ${fieldHtml("Meter", "Bowser meter", record.Meter || 0, "number")}
  	      ${fieldHtml("CostPerLitre", "Cost per litre", record.CostPerLitre || 0, "number")}
  	      ${fieldHtml("DriverName", "Driver name", record.DriverName || record.Driver || "", "text")}
  	      ${fieldHtml("Registration", "Registration", record.Registration || "", "text")}
  	      ${fieldHtml("Description", "Description", record.Description || "", "textarea", { full: true })}
  	      ${fieldHtml("reason", "Correction reason", "", "textarea", { full: true, required: true })}
  	    </form>`;
  	    return modalFrame(reverse ? "Reverse Fuel Correction" : "Correct Fuel Transaction", body, `<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button ${reverse ? "danger" : "primary"}" data-action="save-fuel-correction">${reverse ? "Reverse Correction" : "Save Protected Correction"}</button>`, true);
  	  }

  	  function renderLoadCorrection(data) {
  	    const record = clone(data.record || {});
  	    const body = `<form data-form="load" class="fif-form-grid">
  	      ${fieldHtml("Customer", "Customer", record.Customer || "", "text")}
  	      ${fieldHtml("Action", "Action", record.Action || "", "text")}
  	      ${fieldHtml("Date_Loading_Planned", "Loading planned", record.Date_Loading_Planned || "", "datetime-local")}
  	      ${fieldHtml("Date_Loading_Actual", "Loading actual", record.Date_Loading_Actual || "", "datetime-local")}
  	      ${fieldHtml("Date_Delivery_Planned", "Delivery planned", record.Date_Delivery_Planned || "", "datetime-local")}
  	      ${fieldHtml("Date_Delivery_Actual", "Delivery actual", record.Date_Delivery_Actual || "", "datetime-local")}
  	      ${fieldHtml("Mass_Planned", "Mass planned", record.Mass_Planned || 0, "number")}
  	      ${fieldHtml("Mass_Loaded", "Mass loaded", record.Mass_Loaded || 0, "number")}
  	      ${fieldHtml("Mass_Delivered", "Mass delivered", record.Mass_Delivered || 0, "number")}
  	      ${fieldHtml("Mileage_Data_Loaded", "Mileage loaded", record.Mileage_Data_Loaded || 0, "number")}
  	      ${fieldHtml("Mileage_Data_Delivered", "Mileage delivered", record.Mileage_Data_Delivered || 0, "number")}
  	      ${fieldHtml("reason", "Correction reason", "", "textarea", { full: true, required: true })}
  	    </form>`;
  	    return modalFrame("Correct Load", body, `<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-load-correction">Save Correction</button>`);
  	  }

  	  function renderJobCorrection(data) {
  	    const record = clone(data.record || {});
  	    const body = `<form data-form="job" class="fif-form-grid">
  	      ${fieldHtml("Status", "Status", record.Status || "", "text")}
  	      ${fieldHtml("DateISO", "Date ISO", record.DateISO || "", "text")}
  	      ${fieldHtml("LocationLabel", "Location", record.LocationLabel || record.__locationName || "", "text")}
  	      ${fieldHtml("VehicleLabel", "Vehicle", record.VehicleLabel || "", "text")}
  	      ${fieldHtml("ContractorLabel", "Contractor", record.ContractorLabel || "", "text")}
  	      ${fieldHtml("Area", "Area", record.Area || 0, "number")}
  	      ${fieldHtml("Fuel", "Fuel", record.Fuel || 0, "number")}
  	      ${fieldHtml("VehMileageIn", "Vehicle mileage in", record.VehMileageIn || 0, "number")}
  	      ${fieldHtml("VehMileageOut", "Vehicle mileage out", record.VehMileageOut || 0, "number")}
  	      ${fieldHtml("FuelVolumeIn", "Fuel volume in", record.FuelVolumeIn || 0, "number")}
  	      ${fieldHtml("FuelVolumeOut", "Fuel volume out", record.FuelVolumeOut || 0, "number")}
  	      ${fieldHtml("Applications", "Applications JSON", record.Applications || {}, "json", { full: true })}
  	      ${fieldHtml("reason", "Correction reason", "", "textarea", { full: true, required: true })}
  	    </form>`;
  	    return modalFrame("Correct Job Entry", body, `<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button primary" data-action="save-job-correction">Save Correction</button>`);
  	  }

  	  function renderConfirm(data) {
  	    return modalFrame(data.title || "Confirm", `<div class="fif-note ${data.danger ? "fif-danger-note" : ""}">${escapeHtml(data.message || "Are you sure?")}</div>${data.requireReason ? `<form data-form="confirm" style="margin-top:14px">${fieldHtml("reason", "Reason", "", "textarea", { full: true, required: true })}</form>` : ""}`, `<button class="fif-button" data-action="close-modal">Cancel</button><button class="fif-button ${data.danger ? "danger" : "primary"}" data-action="confirm-modal">${escapeHtml(data.confirmLabel || "Confirm")}</button>`, true);
  	  }

  	  function defaultOnboardingDraft() {
  	    return {
  	      step: 1,
  	      company: { Name: "", CompanyId: "", TradingName: "", Email: "", Telephone: "", Status: "ACTIVE", Manifest: { Applications: [] } },
  	      director: { first_name: "", last_name: "", ID: "", email: "", phone_number: "", password: "" },
  	      permissions: { APP: ["Office"], Office: ["Dash", "Settings"], Settings: ["Users"], Role: ["Director", "Admin"], Home: "Dash" },
  	      result: null
  	    };
  	  }

  	  function renderOnboarding(data) {
  	    const draft = merge(defaultOnboardingDraft(), data.draft || {});
  	    state.modal.data.draft = draft;
  	    const step = Number(draft.step || 1);
  	    const steps = ["Company", "Director", "Permissions", "Review"];
  	    let body = `<div class="fif-wizard-steps">${steps.map((label, index) => `<div class="fif-step ${step === index + 1 ? "active" : ""}">${index + 1}. ${escapeHtml(label)}</div>`).join("")}</div>`;
  	    if (step === 1) {
  	      body += `<form data-form="onboarding" class="fif-form-grid">
  	        ${fieldHtml("company_Name", "Registered company name", draft.company.Name, "text", { required: true })}
  	        ${fieldHtml("company_CompanyId", "Company business identifier", draft.company.CompanyId, "text", { required: true })}
  	        ${fieldHtml("company_TradingName", "Trading name", draft.company.TradingName, "text")}
  	        ${fieldHtml("company_Email", "Company email", draft.company.Email, "email")}
  	        ${fieldHtml("company_Telephone", "Telephone", draft.company.Telephone, "text")}
  	        ${fieldHtml("company_Status", "Status", draft.company.Status, "select", { values: ["ACTIVE", "SUSPENDED", "INACTIVE"] })}
  	      </form>`;
  	    } else if (step === 2) {
  	      body += `<form data-form="onboarding" class="fif-form-grid">
  	        ${fieldHtml("director_first_name", "First name", draft.director.first_name, "text", { required: true })}
  	        ${fieldHtml("director_last_name", "Last name", draft.director.last_name, "text", { required: true })}
  	        ${fieldHtml("director_ID", "National ID", draft.director.ID, "text", { required: true })}
  	        ${fieldHtml("director_email", "Email", draft.director.email, "email", { required: true })}
  	        ${fieldHtml("director_phone_number", "Telephone", draft.director.phone_number, "text")}
  	        ${fieldHtml("director_password", "Temporary password", draft.director.password, "password", { required: true, help: "Minimum 8 characters." })}
  	      </form>`;
  	    } else if (step === 3) {
  	      body += `<form data-form="onboarding" class="fif-form-grid">
  	        ${checkboxGroupHtml("permissions_APP", "APP", ACCESS_SCHEMA.ordinaryApps, draft.permissions.APP)}
  	        ${checkboxGroupHtml("permissions_Office", "Office", ACCESS_SCHEMA.office, draft.permissions.Office)}
  	        ${checkboxGroupHtml("permissions_Settings", "Settings", ACCESS_SCHEMA.settings, draft.permissions.Settings)}
  	        ${checkboxGroupHtml("permissions_Role", "Roles", ACCESS_SCHEMA.roles, draft.permissions.Role, { help: "Director is mandatory for the customer primary user." })}
  	        ${fieldHtml("permissions_Home", "Home", draft.permissions.Home, "select", { values: ["", ...ACCESS_SCHEMA.homes] })}
  	      </form>`;
  	    } else {
  	      body += `<div class="fif-grid">
  	        <div class="fif-card"><h3>Company</h3><p><strong>${escapeHtml(draft.company.Name)}</strong><br>${escapeHtml(draft.company.CompanyId)}<br>${escapeHtml(draft.company.Status)}</p></div>
  	        <div class="fif-card"><h3>Director</h3><p><strong>${escapeHtml(`${draft.director.first_name} ${draft.director.last_name}`)}</strong><br>${escapeHtml(draft.director.email)}<br>${escapeHtml(draft.director.ID)}</p></div>
  	        <div class="fif-card"><h3>Permissions</h3><p>APP: ${escapeHtml(joinCsv(draft.permissions.APP))}<br>Office: ${escapeHtml(joinCsv(draft.permissions.Office))}<br>Settings: ${escapeHtml(joinCsv(draft.permissions.Settings))}<br>Roles: ${escapeHtml(joinCsv(draft.permissions.Role))}<br>Home: ${escapeHtml(draft.permissions.Home)}</p></div>
  	        <div class="fif-card"><h3>Relations</h3><p>Users.Companies<br>Companies.Employees</p></div>
  	      </div>
  	      <div class="fif-note" style="margin-top:14px">The company and user are created without custom objectIds. The Director is then related to the company in both directions required by the current schema.</div>`;
  	    }
  	    const footer = `<button class="fif-button" data-action="close-modal">Cancel</button>${step > 1 ? '<button class="fif-button" data-action="onboarding-back">Back</button>' : ""}${step < 4 ? '<button class="fif-button primary" data-action="onboarding-next">Next</button>' : '<button class="fif-button primary" data-action="onboarding-commit">Create Customer</button>'}`;
  	    return modalFrame("New Customer Onboarding", body, footer);
  	  }

  	  /* ========================================================================
  	   * 17. EVENT HANDLING AND SAVE WORKFLOWS
  	   * ====================================================================== */

  	  function formData(name) {
  	    const form = state.root?.querySelector(`[data-form="${name}"]`);
  	    if (!form) throw new Error(`Form ${name} is unavailable.`);
  	    return { form, data: new FormData(form) };
  	  }

  	  function findCompany(id) {
  	    return state.allCompanies.find(company => companyObjectId(company) === clean(id)) ||
  	      state.selectableCompanies.find(company => companyObjectId(company) === clean(id)) || null;
  	  }

  	  function allVisibleUsers() {
  	    if (state.authority.isFIFM) return state.caches.usersAll || [];
  	    return state.caches.employees[state.selectedCompanyObjectId] || [];
  	  }

  	  function findUser(id) {
  	    return allVisibleUsers().find(user => userObjectId(user) === clean(id)) || null;
  	  }

  	  function findResourceRecord(resourceId, id) {
  	    const definition = resourceDefinition(resourceId);
  	    const list = state.caches[definition.cache][state.selectedCompanyObjectId] || [];
  	    return list.find(record => objectId(record) === clean(id) && (!definition.discriminator || definition.discriminator(record))) || null;
  	  }

  	  function findFuelRecord(id) {
  	    return (state.caches.fuelOut[state.selectedCompanyObjectId] || []).find(record => objectId(record) === clean(id)) || null;
  	  }

  	  function findLoadRecord(id) {
  	    return (state.caches.loads[state.selectedCompanyObjectId] || []).find(record => objectId(record) === clean(id)) || null;
  	  }

  	  function findJobRecord(id) {
  	    return (state.caches.jobs[state.selectedCompanyObjectId] || []).find(record => objectId(record) === clean(id)) || null;
  	  }

  	  async function withSaving(task) {
  	    if (state.saving) return;
  	    state.saving = true;
  	    const buttons = Array.from(state.root?.querySelectorAll?.('.fif-modal button') || []);
  	    buttons.forEach(button => { button.disabled = true; });
  	    try { return await task(); }
  	    finally {
  	      state.saving = false;
  	      buttons.forEach(button => { if (button?.isConnected !== false) button.disabled = false; });
  	    }
  	  }

  	  let filterTimer = null;

  	  function bindEvents() {
  	    state.root.addEventListener("click", async event => {
  	      const target = event.target.closest("[data-action]");
  	      if (!target || !state.root.contains(target)) return;
  	      const action = target.dataset.action;
  	      try {
  	        await handleAction(action, target);
  	      } catch (error) {
  	        warn(`Action ${action} failed.`, error);
  	        showToast(error.message || error, "error");
  	      }
  	    });

  	    state.root.addEventListener("change", async event => {
  	      const target = event.target;
  	      if (target.matches('[data-action="select-company"]')) {
  	        await handleCompanySelection(target.value);
  	      }
  	      if (target.dataset.filter) {
  	        state.filters[target.dataset.filter] = target.value;
  	        await renderMain();
  	      }
  	    });

  	    state.root.addEventListener("input", event => {
  	      const target = event.target;
  	      if (!target.dataset.filter) return;
  	      state.filters[target.dataset.filter] = target.value;
  	      clearTimeout(filterTimer);
  	      filterTimer = setTimeout(() => renderMain(), 220);
  	    });

  	    state.root.querySelector('[data-region="modal"]')?.addEventListener("click", event => {
  	      if (event.target.matches('[data-region="modal"]')) closeModal();
  	    });
  	  }

  	  async function handleCompanySelection(id) {
  	    const company = findCompany(id);
  	    if (!company || !canAccessCompany(state.authority, state.companyScope, company)) throw new Error("Company access denied.");
  	    state.selectedCompanyObjectId = companyObjectId(company);
  	    state.activeRecord = null;
  	    state.activeSection = defaultSection();
  	    renderNavigation();
  	    renderTop();
  	    await renderMain();
  	  }

  	  async function handleAction(action, target) {
  	    switch (action) {
  	      case "navigate":
  	        state.activeSection = target.dataset.section;
  	        await renderMain();
  	        return;
  	      case "close-modal": closeModal(); return;
  	      case "open-company": {
  	        const company = findCompany(target.dataset.id);
  	        if (!company || !canAccessCompany(state.authority, state.companyScope, company)) throw new Error("Company access denied.");
  	        state.selectedCompanyObjectId = companyObjectId(company);
  	        state.activeSection = state.authority.isFIFM ? "company-profile" : "overview";
  	        await renderMain();
  	        return;
  	      }
  	      case "edit-company": openModal("company-editor", { company: findCompany(target.dataset.id) }); return;
  	      case "save-company": await saveCompanyFromModal(); return;
  	      case "toggle-managed": {
  	        const company = findCompany(target.dataset.id);
  	        await withSaving(() => CompanyService.toggleManaged(company, target.dataset.managed !== "1"));
  	        showToast(target.dataset.managed === "1" ? "Removed from My Managed Companies." : "Added to My Managed Companies.");
  	        await renderMain();
  	        return;
  	      }
  	      case "open-onboarding": openModal("onboarding", { draft: defaultOnboardingDraft() }); return;
  	      case "onboarding-next": collectOnboardingStep(1); return;
  	      case "onboarding-back": collectOnboardingStep(-1); return;
  	      case "onboarding-commit": await commitOnboarding(); return;
  	      case "edit-applications": openModal("applications-editor", { company: selectedCompany() }); return;
  	      case "save-applications": await saveApplicationsFromModal(); return;
  	      case "create-user": openModal("user-editor", { user: defaultUser(), companies: state.authority.isDirector ? [selectedCompany()] : [] }); return;
  	      case "edit-user": await openUserEditor(target.dataset.id); return;
  	      case "save-user": await saveUserFromModal(); return;
  	      case "toggle-user-status": await confirmUserStatus(target.dataset.id, target.dataset.disabled !== "1"); return;
  	      case "create-resource": await openResourceEditor(target.dataset.resource, null); return;
  	      case "edit-resource": await openResourceEditor(target.dataset.resource, findResourceRecord(target.dataset.resource, target.dataset.id)); return;
  	      case "save-resource": await saveResourceFromModal(); return;
  	      case "delete-resource": confirmResourceDelete(target.dataset.resource, target.dataset.id); return;
  	      case "refresh-resource": {
  	        const definition = resourceDefinition(target.dataset.resource);
  	        delete state.caches[definition.cache][state.selectedCompanyObjectId];
  	        await renderMain();
  	        showToast(`${definition.label} refreshed.`);
  	        return;
  	      }
  	      case "correct-fuel": openModal("fuel-correction", { mode: "correct", record: findFuelRecord(target.dataset.id) }); return;
  	      case "reverse-fuel": openModal("fuel-correction", { mode: "reverse", record: findFuelRecord(target.dataset.id) }); return;
  	      case "save-fuel-correction": await saveFuelCorrectionFromModal(); return;
  	      case "refresh-fuel": delete state.caches.fuelOut[state.selectedCompanyObjectId]; await renderMain(); return;
  	      case "correct-load": openModal("load-correction", { record: findLoadRecord(target.dataset.id) }); return;
  	      case "save-load-correction": await saveLoadCorrectionFromModal(); return;
  	      case "refresh-loads": delete state.caches.loads[state.selectedCompanyObjectId]; await renderMain(); return;
  	      case "refresh-trips": delete state.caches.trips[state.selectedCompanyObjectId]; await renderMain(); return;
  	      case "refresh-jobs": delete state.caches.jobs[state.selectedCompanyObjectId]; await renderMain(); return;
  	      case "correct-job": openModal("job-correction", { record: findJobRecord(target.dataset.id) }); return;
  	      case "save-job-correction": await saveJobCorrectionFromModal(); return;
  	      case "confirm-modal": await executeConfirmation(); return;
  	      default: throw new Error(`Unhandled action: ${action}`);
  	    }
  	  }

  	  async function saveCompanyFromModal() {
  	    await withSaving(async () => {
  	      const { data } = formData("company");
  	      const existing = state.modal.data.company;
  	      const payload = {
  	        Name: clean(data.get("Name")),
  	        CompanyId: clean(data.get("CompanyId")),
  	        Status: clean(data.get("Status")),
  	        Manifest: parseJson(data.get("Manifest"), {}),
  	        Refrences: parseJson(data.get("Refrences"), {})
  	      };
  	      const reason = clean(data.get("reason"));
  	      if (!reason) throw new Error("A change reason is required.");
  	      const saved = companyObjectId(existing) ? await CompanyService.update(existing, payload, reason) : await CompanyService.create({ ...payload, reason });
  	      state.selectedCompanyObjectId = companyObjectId(saved);
  	      closeModal();
  	      showToast(companyObjectId(existing) ? "Company saved." : "Company created.");
  	      await renderMain();
  	    });
  	  }

  	  async function saveApplicationsFromModal() {
  	    await withSaving(async () => {
  	      const company = requireSelectedCompany(ACTIONS.APPLICATIONS_EDIT);
  	      const { data } = formData("applications");
  	      const applications = uniqueValues(data.getAll("Applications")).filter(value => ["Office", "Road", "Bowser"].includes(value));
  	      const reason = clean(data.get("reason"));
  	      if (!reason) throw new Error("A change reason is required.");
  	      const manifest = clone(company.Manifest || {});
  	      manifest.Applications = applications;
  	      await CompanyService.update(company, { Manifest: manifest }, reason);
  	      closeModal();
  	      showToast("Applications saved.");
  	      await renderMain();
  	    });
  	  }

  	  async function openUserEditor(id) {
  	    const user = findUser(id);
  	    if (!user) throw new Error("User not found.");
  	    let companies = relationList(user, "Companies");
  	    if (state.authority.isFIFM && userObjectId(user)) {
  	      try {
  	        companies = (await loadRelation(TABLES.USERS, userObjectId(user), RELATIONS.USER_COMPANIES, companies)).map(normalizeCompany);
  	        user.Companies = companies;
  	      } catch (error) {
  	        warn("User company relation load failed.", error?.message || error);
  	      }
  	    }
  	    openModal("user-editor", { user, companies });
  	  }

  	  async function saveUserFromModal() {
  	    await withSaving(async () => {
  	      const { data } = formData("user");
  	      const existing = state.modal.data.user;
  	      const isNew = !userObjectId(existing);
  	      const current = normalizeUser(existing || defaultUser());
  	      const canPermissions = state.access.can(ACTIONS.USERS_EDIT_PERMISSIONS, { company: selectedCompany() });
  	      const detailsRoot = parseJson(data.get("Data_Details"), current.Data_Details || { employee_details: defaultEmployeeDetails() });
  	      if (!isObject(detailsRoot.employee_details)) detailsRoot.employee_details = defaultEmployeeDetails();
  	      const details = detailsRoot.employee_details;
  	      details.first_name = clean(data.get("first_name"));
  	      details.last_name = clean(data.get("last_name"));
  	      details.id_number = clean(data.get("ID"));
  	      if (!isObject(details.contact_details)) details.contact_details = {};
  	      details.contact_details.email = lower(data.get("email"));
  	      details.contact_details.phone_number = clean(data.get("phone_number"));
  	      details.employee_id = clean(data.get("employee_id"));

  	      const payload = {
  	        ...clone(current),
  	        email: lower(data.get("email")),
  	        name: [details.first_name, details.last_name].filter(Boolean).join(" "),
  	        ID: clean(data.get("ID")),
  	        Local_Key: clean(data.get("ID")),
  	        userStatus: clean(data.get("userStatus") || "ENABLED").toUpperCase(),
  	        loginEnabled: clean(data.get("userStatus") || "ENABLED").toUpperCase() !== "DISABLED",
  	        Data_Details: detailsRoot
  	      };
  	      if (canPermissions) {
  	        payload.APP = joinCsv(data.getAll("APP"));
  	        payload.Office = joinCsv(data.getAll("Office"));
  	        payload.Settings = joinCsv(data.getAll("Settings"));
  	        payload.Role = joinCsv(data.getAll("Role"));
  	        payload.Home = clean(data.get("Home"));
  	      }
  	      if (data.has("Data_Wages")) payload.Data_Wages = parseJson(data.get("Data_Wages"), current.Data_Wages || {});

  	      let companies;
  	      if (state.authority.isFIFM) {
  	        const ids = new Set(data.getAll("Companies").map(clean));
  	        companies = state.allCompanies.filter(company => ids.has(companyObjectId(company)));
  	      } else {
  	        companies = [requireSelectedCompany(ACTIONS.USERS_EDIT_PROFILE)];
  	      }

  	      const reason = clean(data.get("reason"));
  	      if (!isNew && !reason) throw new Error("A change reason is required.");
  	      const saved = isNew
  	        ? await UserService.create(payload, clean(data.get("password")), companies)
  	        : await UserService.update(existing, payload, companies, reason);
  	      closeModal();
  	      showToast(isNew ? `User ${userDisplayName(saved)} created.` : `User ${userDisplayName(saved)} saved.`);
  	      await renderMain();
  	    });
  	  }

  	  async function confirmUserStatus(id, disable) {
  	    const user = findUser(id);
  	    if (!user) throw new Error("User not found.");
  	    openModal("confirm", {
  	      title: disable ? "Disable User" : "Enable User",
  	      message: `${disable ? "Disable" : "Enable"} ${userDisplayName(user)}?`,
  	      confirmLabel: disable ? "Disable" : "Enable",
  	      danger: disable,
  	      requireReason: true,
  	      execute: async reason => {
  	        await UserService.disable(user, disable, reason);
  	        showToast(disable ? "User disabled." : "User enabled.");
  	        await renderMain();
  	      }
  	    });
  	  }

  	  async function openResourceEditor(resourceId, record) {
  	    const definition = resourceDefinition(resourceId);
  	    const company = requireSelectedCompany(record ? definition.editAction : definition.createAction);
  	    if (resourceId === "bowsers" && !record) await ResourceService.load("tanks", company);
  	    openModal("resource-editor", { resourceId, record: record || { ...(definition.defaults || {}) } });
  	  }

  	  function readResourceForm(definition, data) {
  	    const output = {};
  	    definition.fields.forEach(([name, , type]) => {
  	      if (type === "boolean") output[name] = data.has(name);
  	      else if (type === "number") output[name] = parseNumber(data.get(name), 0);
  	      else if (type === "json") output[name] = parseJson(data.get(name), {});
  	      else output[name] = clean(data.get(name));
  	    });
  	    if (data.has("__parentTankObjectId")) output.__parentTankObjectId = clean(data.get("__parentTankObjectId"));
  	    return output;
  	  }

  	  async function saveResourceFromModal() {
  	    await withSaving(async () => {
  	      const resourceId = state.modal.data.resourceId;
  	      const definition = resourceDefinition(resourceId);
  	      const existing = state.modal.data.record;
  	      const { data } = formData("resource");
  	      const payload = readResourceForm(definition, data);
  	      const reason = clean(data.get("reason"));
  	      if (!reason) throw new Error("A change reason is required.");
  	      const company = requireSelectedCompany(objectId(existing) ? definition.editAction : definition.createAction);
  	      await ResourceService.save(resourceId, company, payload, {
  	        existing: objectId(existing) ? existing : null,
  	        parentTankObjectId: payload.__parentTankObjectId,
  	        reason
  	      });
  	      closeModal();
  	      showToast(`${definition.singular} saved.`);
  	      await renderMain();
  	    });
  	  }

  	  function confirmResourceDelete(resourceId, id) {
  	    const definition = resourceDefinition(resourceId);
  	    const record = findResourceRecord(resourceId, id);
  	    if (!record) throw new Error(`${definition.singular} not found.`);
  	    openModal("confirm", {
  	      title: `Delete ${definition.singular}`,
  	      message: `Delete ${resourceTitle(record, definition)}? This removes the relation and the Backendless record.`,
  	      confirmLabel: "Delete",
  	      danger: true,
  	      requireReason: true,
  	      execute: async reason => {
  	        await ResourceService.remove(resourceId, requireSelectedCompany(definition.deleteAction), record, reason);
  	        showToast(`${definition.singular} deleted.`);
  	        await renderMain();
  	      }
  	    });
  	  }

  	  async function saveFuelCorrectionFromModal() {
  	    await withSaving(async () => {
  	      const { data } = formData("fuel");
  	      const company = requireSelectedCompany(state.modal.data.mode === "reverse" ? ACTIONS.FUEL_REVERSE : ACTIONS.FUEL_CORRECT);
  	      const record = state.modal.data.record;
  	      const reason = clean(data.get("reason"));
  	      if (state.modal.data.mode === "reverse") {
  	        await FuelService.reverse(company, record, reason);
  	        showToast("Fuel correction reversed.");
  	      } else {
  	        const changes = {
  	          Litres: parseNumber(data.get("Litres"), Number(record.Litres || 0)),
  	          Mileage: parseNumber(data.get("Mileage"), Number(record.Mileage || 0)),
  	          Meter: parseNumber(data.get("Meter"), Number(record.Meter || 0)),
  	          CostPerLitre: parseNumber(data.get("CostPerLitre"), Number(record.CostPerLitre || 0)),
  	          DriverName: clean(data.get("DriverName")),
  	          Registration: clean(data.get("Registration")),
  	          Description: clean(data.get("Description"))
  	        };
  	        changes.Cost = changes.Litres * changes.CostPerLitre;
  	        await FuelService.correct(company, record, changes, reason);
  	        showToast("Protected fuel correction saved.");
  	      }
  	      closeModal();
  	      await renderMain();
  	    });
  	  }

  	  async function saveLoadCorrectionFromModal() {
  	    await withSaving(async () => {
  	      const { data } = formData("load");
  	      const company = requireSelectedCompany(ACTIONS.LOADS_CORRECT);
  	      const record = state.modal.data.record;
  	      const reason = clean(data.get("reason"));
  	      const changes = {
  	        Customer: clean(data.get("Customer")),
  	        Action: clean(data.get("Action")),
  	        Date_Loading_Planned: clean(data.get("Date_Loading_Planned")),
  	        Date_Loading_Actual: clean(data.get("Date_Loading_Actual")),
  	        Date_Delivery_Planned: clean(data.get("Date_Delivery_Planned")),
  	        Date_Delivery_Actual: clean(data.get("Date_Delivery_Actual")),
  	        Mass_Planned: parseNumber(data.get("Mass_Planned"), 0),
  	        Mass_Loaded: parseNumber(data.get("Mass_Loaded"), 0),
  	        Mass_Delivered: parseNumber(data.get("Mass_Delivered"), 0),
  	        Mileage_Data_Loaded: parseNumber(data.get("Mileage_Data_Loaded"), 0),
  	        Mileage_Data_Delivered: parseNumber(data.get("Mileage_Data_Delivered"), 0)
  	      };
  	      await LoadService.correct(company, record, changes, reason);
  	      closeModal();
  	      showToast("Load correction saved.");
  	      await renderMain();
  	    });
  	  }

  	  async function saveJobCorrectionFromModal() {
  	    await withSaving(async () => {
  	      const { data } = formData("job");
  	      const company = requireSelectedCompany(ACTIONS.JOBS_CORRECT);
  	      const record = state.modal.data.record;
  	      const reason = clean(data.get("reason"));
  	      const changes = {
  	        Status: clean(data.get("Status")),
  	        DateISO: clean(data.get("DateISO")),
  	        LocationLabel: clean(data.get("LocationLabel")),
  	        VehicleLabel: clean(data.get("VehicleLabel")),
  	        ContractorLabel: clean(data.get("ContractorLabel")),
  	        Area: parseNumber(data.get("Area"), 0),
  	        Fuel: parseNumber(data.get("Fuel"), 0),
  	        VehMileageIn: parseNumber(data.get("VehMileageIn"), 0),
  	        VehMileageOut: parseNumber(data.get("VehMileageOut"), 0),
  	        FuelVolumeIn: parseNumber(data.get("FuelVolumeIn"), 0),
  	        FuelVolumeOut: parseNumber(data.get("FuelVolumeOut"), 0),
  	        Applications: parseJson(data.get("Applications"), record.Applications || {})
  	      };
  	      await OperationalService.correctJob(company, record, changes, reason);
  	      closeModal();
  	      showToast("Job correction saved.");
  	      await renderMain();
  	    });
  	  }

  	  async function executeConfirmation() {
  	    const confirmation = state.modal?.data;
  	    if (!confirmation?.execute) throw new Error("Confirmation action is unavailable.");
  	    let reason = "";
  	    if (confirmation.requireReason) {
  	      const { data } = formData("confirm");
  	      reason = clean(data.get("reason"));
  	      if (!reason) throw new Error("A reason is required.");
  	    }
  	    await withSaving(async () => {
  	      await confirmation.execute(reason);
  	      closeModal();
  	    });
  	  }

  	  function readOnboardingForm(draft) {
  	    const form = state.root?.querySelector('[data-form="onboarding"]');
  	    if (!form) return draft;
  	    const data = new FormData(form);
  	    if (draft.step === 1) {
  	      draft.company.Name = clean(data.get("company_Name"));
  	      draft.company.CompanyId = clean(data.get("company_CompanyId"));
  	      draft.company.TradingName = clean(data.get("company_TradingName"));
  	      draft.company.Email = lower(data.get("company_Email"));
  	      draft.company.Telephone = clean(data.get("company_Telephone"));
  	      draft.company.Status = clean(data.get("company_Status") || "ACTIVE");
  	    } else if (draft.step === 2) {
  	      draft.director.first_name = clean(data.get("director_first_name"));
  	      draft.director.last_name = clean(data.get("director_last_name"));
  	      draft.director.ID = clean(data.get("director_ID"));
  	      draft.director.email = lower(data.get("director_email"));
  	      draft.director.phone_number = clean(data.get("director_phone_number"));
  	      draft.director.password = clean(data.get("director_password"));
  	    } else if (draft.step === 3) {
  	      draft.permissions.APP = uniqueValues(data.getAll("permissions_APP"));
  	      draft.permissions.Office = uniqueValues(data.getAll("permissions_Office"));
  	      draft.permissions.Settings = uniqueValues(data.getAll("permissions_Settings"));
  	      draft.permissions.Role = uniqueValues(data.getAll("permissions_Role"));
  	      if (!draft.permissions.Role.includes("Director")) draft.permissions.Role.unshift("Director");
  	      draft.permissions.Home = clean(data.get("permissions_Home"));
  	    }
  	    return draft;
  	  }

  	  function validateOnboardingStep(draft) {
  	    if (draft.step === 1) {
  	      if (!draft.company.Name || !draft.company.CompanyId) throw new Error("Company name and business identifier are required.");
  	    } else if (draft.step === 2) {
  	      if (!draft.director.first_name || !draft.director.last_name || !draft.director.ID || !draft.director.email) throw new Error("Director name, national ID and email are required.");
  	      if (draft.director.password.length < 8) throw new Error("The temporary password must contain at least 8 characters.");
  	    } else if (draft.step === 3) {
  	      const testUser = normalizeUser({ APP: joinCsv(draft.permissions.APP), Office: joinCsv(draft.permissions.Office), Settings: joinCsv(draft.permissions.Settings), Role: joinCsv(draft.permissions.Role), Home: draft.permissions.Home });
  	      if (!normalizeRoleValues(testUser.Role).includes("Director")) throw new Error("The customer primary user must have the Director role.");
  	      validatePermissionDependencies(testUser);
  	    }
  	  }

  	  function collectOnboardingStep(delta) {
  	    const draft = readOnboardingForm(state.modal.data.draft);
  	    if (delta > 0) validateOnboardingStep(draft);
  	    draft.step = Math.max(1, Math.min(4, draft.step + delta));
  	    state.modal.data.draft = draft;
  	    renderModal();
  	  }

  	  async function commitOnboarding() {
  	    await withSaving(async () => {
  	      assertAction(ACTIONS.COMPANIES_CREATE);
  	      const draft = state.modal.data.draft;
  	      if (draft.step !== 4) throw new Error("Complete all onboarding steps first.");
  	      const result = { company: null, director: null, relations: [], errors: [] };
  	      try {
  	        const companyManifest = {
  	          Applications: uniqueValues(draft.permissions.APP.filter(value => ["Office", "Road", "Bowser"].includes(value))),
  	          Profile: {
  	            TradingName: draft.company.TradingName,
  	            Email: draft.company.Email,
  	            Telephone: draft.company.Telephone
  	          }
  	        };
  	        result.company = await CompanyService.create({
  	          Name: draft.company.Name,
  	          CompanyId: draft.company.CompanyId,
  	          Status: draft.company.Status,
  	          Manifest: companyManifest,
  	          Refrences: {},
  	          reason: "New customer onboarding"
  	        });
  	      } catch (error) {
  	        result.errors.push(`Company: ${error.message}`);
  	        draft.result = result;
  	        throw new Error(`Customer onboarding stopped before company creation: ${error.message}`);
  	      }

  	      try {
  	        const details = defaultEmployeeDetails();
  	        details.first_name = draft.director.first_name;
  	        details.last_name = draft.director.last_name;
  	        details.id_number = draft.director.ID;
  	        details.contact_details.email = draft.director.email;
  	        details.contact_details.phone_number = draft.director.phone_number;
  	        const directorPayload = {
  	          email: draft.director.email,
  	          name: `${draft.director.first_name} ${draft.director.last_name}`,
  	          ID: draft.director.ID,
  	          Local_Key: draft.director.ID,
  	          APP: joinCsv(draft.permissions.APP),
  	          Office: joinCsv(draft.permissions.Office),
  	          Settings: joinCsv(draft.permissions.Settings),
  	          Role: joinCsv(uniqueValues(["Director", ...draft.permissions.Role])),
  	          Home: draft.permissions.Home,
  	          userStatus: "ENABLED",
  	          loginEnabled: true,
  	          Data_Details: { employee_details: details },
  	          Data_Wages: {}
  	        };
  	        result.director = await UserService.create(directorPayload, draft.director.password, [result.company]);
  	        result.relations = ["Users.Companies", "Companies.Employees"];
  	      } catch (error) {
  	        result.errors.push(`Director: ${error.message}`);
  	        draft.result = result;
  	        throw new Error(`Company ${companyName(result.company)} was created, but Director onboarding failed: ${error.message}`);
  	      }

  	      state.selectedCompanyObjectId = companyObjectId(result.company);
  	      closeModal();
  	      showToast(`Customer ${companyName(result.company)} and Director ${userDisplayName(result.director)} created.`);
  	      await renderMain();
  	    });
  	  }

  	  /* ========================================================================
  	   * 18. AUTHORITY SELF-TESTS
  	   * ====================================================================== */

  	  function runAuthoritySelfTests() {
  	    const fixtures = [
  	      {
  	        name: "FIFM owner",
  	        user: { APP: "FIFM", Office: "", Settings: "", Role: "", Home: "" },
  	        expect: { level: "FIFM", unrestricted: true }
  	      },
  	      {
  	        name: "FIFC Bowser support",
  	        user: { APP: "FIFC", Role: "Bowser", Companies: [{ objectId: "A", Name: "A" }] },
  	        expect: { level: "FIFC", unrestricted: false }
  	      },
  	      {
  	        name: "FIFC Load Planner",
  	        user: { APP: "FIFC", Role: "Load Planner" },
  	        expect: { level: "FIFC", unrestricted: false }
  	      },
  	      {
  	        name: "Director",
  	        user: { APP: "Office,Road,Bowser", Role: "Director,Admin,Driver,Load Planner,Bowser", Office: "LiveTrack,Bowser,Dash,Locations,Settings", Settings: "Applications,Locations,Users,Vehicles", Home: "Dash" },
  	        expect: { level: "DIRECTOR", unrestricted: false }
  	      },
  	      {
  	        name: "Ordinary Admin",
  	        user: { APP: "Office", Role: "Admin", Office: "Dash,Settings", Settings: "Users", Home: "Dash" },
  	        expect: { level: "USER", unrestricted: false }
  	      },
  	      {
  	        name: "Mechanic",
  	        user: { APP: "Office", Role: "Mechanic", Office: "Settings", Settings: "Vehicles", Home: "Settings" },
  	        expect: { level: "USER", unrestricted: false }
  	      },
  	      {
  	        name: "Legacy Bowseer",
  	        user: { APP: "Bowseer", Role: "Bowseer", Office: "Bowseer", Home: "Bowseer" },
  	        expect: { level: "USER", app: "Bowser", home: "Bowser" }
  	      },
  	      {
  	        name: "Invalid Home",
  	        user: { APP: "Office", Office: "LiveTrack,Locations", Home: "Dash" },
  	        expect: { level: "USER", home: "LiveTrack" }
  	      }
  	    ];

  	    const results = fixtures.map(fixture => {
  	      const normal = normalizeUser(fixture.user);
  	      const authority = resolveAuthority(normal);
  	      const pass = authority.level === fixture.expect.level &&
  	        (fixture.expect.unrestricted === undefined || authority.unrestricted === fixture.expect.unrestricted) &&
  	        (fixture.expect.app === undefined || authority.apps.includes(fixture.expect.app)) &&
  	        (fixture.expect.home === undefined || authority.home === fixture.expect.home);
  	      return { name: fixture.name, pass, authority };
  	    });

  	    if (DEVELOPMENT) {
  	      console.groupCollapsed(`[FIF Settings ${VERSION}] Authority self-tests`);
  	      results.forEach(result => console[result.pass ? "log" : "error"](`${result.pass ? "PASS" : "FAIL"}: ${result.name}`, result.authority));
  	      console.groupEnd();
  	    }
  	    return results;
  	  }

  	  /* ========================================================================
  	   * 19. BOOTSTRAP AND PUBLIC API
  	   * ====================================================================== */

  	  async function bootstrap() {
  	    mountShell();
  	    const content = state.root.querySelector('[data-region="content"]');
  	    if (content) content.innerHTML = loadingHtml("Resolving authority and company scope…");

  	    try {
  	      await CompanyService.loadInitial();
  	      state.activeSection = defaultSection();
  	      runAuthoritySelfTests();
  	      await renderMain();
  	      log("Mounted", {
  	        authority: state.authority,
  	        companies: state.selectableCompanies.length,
  	        allCompanies: state.allCompanies.length
  	      });
  	      return {
  	        ok: true,
  	        version: VERSION,
  	        state,
  	        authority: state.authority,
  	        access: state.access,
  	        services: {
  	          CompanyService,
  	          UserService,
  	          RelationService,
  	          ResourceService,
  	          FuelService,
  	          LoadService,
  	          OperationalService,
  	          AuditService
  	        },
  	        navigate: async section => {
  	          state.activeSection = clean(section);
  	          await renderMain();
  	        },
  	        selectCompany: handleCompanySelection,
  	        refresh: renderMain,
  	        destroy() {
  	          clearTimeout(state.toastTimer);
  	          clearTimeout(filterTimer);
  	          state.root?.remove();
  	          document.body.style.overflow = state.priorBodyOverflow;
  	          state.mounted = false;
  	        }
  	      };
  	    } catch (error) {
  	      warn("Bootstrap failed.", error);
  	      if (content) content.innerHTML = `<div class="fif-denied"><h3>Settings Manager could not start</h3><p>${escapeHtml(error.message || error)}</p></div>`;
  	      return { ok: false, version: VERSION, reason: error.message || text(error), state };
  	    }
  	  }

  	  return await bootstrap();
  	})();

  })('data:image/png;base64,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', ___arguments.context.appData);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Old() {
  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('Settings') !== -1) {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cba825083f48a23842c528554b88f698')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb'))]);
    } else {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), null]);
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), null]);
    }

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e517ec0e29819ef91cfda218a0f846b6', true);

  } catch (error) {
    console.log(error);
    Error_Data = error;

  }
}


  await BackendlessUI.Functions.Custom['fn_fd477fdb222518d192722d810bc2fc8a'](___arguments.context.appData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, View;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'APP')).indexOf('FIFM') !== -1) {
      View = true;
    } else {
      View = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      View = false;
    }

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/4e38ee78429a6c26ca8bbe8c8448a228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('e0d6ffa8cce8268cb89e0e3734c86b72', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/2ad8bb58a5582ce86f1346e8eb78cc68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tractors, k, j, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Tractors2() {
  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Tractors, k);
    }
  }
  return Tractors
}

/**
 * Describe this function...
 */
async function Menu_Closers() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fc90fe85fb3fdb851e842383a2cbe6d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb589f58823489b55d73a8c86512ba2a', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fd81dee1f1852b56f34b68de1d3d46e', false);

  } catch (error) {
    console.log(error);

  }
}


  await Menu_Closers();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b20f5d284a885938a0bdfa782448dee8', true);
  await (async function(App, Tractors, Hub, SVG) {
  	(function tractorManager(args) {
  	  console.log("TRAC-MAN: INIT T3 tyre drag/drop operations rewrite", args);

  	  args = args || {};

  	  // --- SAFE INPUTS --------------------------------------------------------
  	  var AppSafe = args.App || null;
  	  var TractorsSafe = Array.isArray(args.Tractors) ? args.Tractors: [];
  	  var TyresSafe = Array.isArray(args.Tyres) ? args.Tyres: [];
  	  var HubSafe = args.Hub || null;
  	  var BackendlessSafe = args.Backendless || null;
  	  var SvgSafe =
  	  args.SVG ||
  	  args.svg ||
  	  args.Svg ||
  	  (typeof SVG !== "undefined" ? SVG: "") ||
  	  (typeof window !== "undefined" && window.SVG ? window.SVG: "");
  	  var WindowSafe = (typeof window !== "undefined" ? window: null);
  	  var DocumentSafe = (typeof document !== "undefined" ? document: null);
  	  // --- INPUTS -------------------------------------------------------------
  	  var App = AppSafe;
  	  var Tractors = TractorsSafe;
  	  var TyresArg = TyresSafe;
  	  var Hub = HubSafe;
  	  var BackendlessApi = BackendlessSafe;

  	  // --- CONFIG -------------------------------------------------------------
  	  var TABLE_TRACTORS = "Tractors";
  	  var TABLE_TYRES = "Tyres";

  	  var TPOSITIONS_PRIMARY = "TPositions";
  	  var TPOSITIONS_SECONDARY = "TyrePositions";
  	  var TYRES_RELATION = "Tyres";

  	  var SCHEMA_VERSION = "T3.0";
  	  var VEHICLE_TYPE = "Tractor";

  	  var TYRE_STATUS = {
  	    OK: "All In Order",
  	    RETREAD: "In For Retread",
  	    SCRAPPED: "Scrapped",
  	    STOLEN: "Stolen"
  	  };

  	  var AXLE_TYPES = {
  	    Tractor: ["Steer", "Tag", "Drive", "Spare"],
  	    Trailer: ["Trailer", "Spare"]
  	  };

  	  var hubEl = Hub && Hub.el ? Hub.el: Hub;

  	  if (!hubEl || !DocumentSafe) {
  	    console.warn("TRAC-MAN: Hub/document missing");
  	    return false;
  	  }

  	  // ===============================================================
  	  // UTILITIES
  	  // ===============================================================
  	  function escapeHtml(value) {
  	    return String(value == null ? "": value)
  	    .replace(/&/g, "&amp;")
  	    .replace(/</g, "&lt;")
  	    .replace(/>/g, "&gt;")
  	    .replace(/\"/g, "&quot;")
  	    .replace(/'/g, "&#39;");
  	  }

  	  function clean(value) {
  	    return String(value == null ? "": value).trim();
  	  }

  	  function reportLogoHtml() {
  	    var svg = SvgSafe;
  	    var cleaned;

  	    if (svg && typeof svg === "object") {
  	      svg = svg.value || svg.Value || svg.src || svg.url || "";
  	    }

  	    svg = clean(svg);

  	    if (
  	      svg.length >= 2 &&
  	      (
  	        (svg.charAt(0) === "\"" && svg.charAt(svg.length - 1) === "\"") ||
  	        (svg.charAt(0) === "'" && svg.charAt(svg.length - 1) === "'")
  	      )
  	    ) {
  	      svg = svg.substring(1, svg.length - 1);
  	    }

  	    if (!svg) {
  	      return "";
  	    }

  	    if (/^data:image\//i.test(svg)) {
  	      return "<img src=\"" + escapeHtml(svg) + "\" alt=\"Report Logo\" style=\"height:48px;width:auto;max-width:190px;object-fit:contain;display:block;\">";
  	    }

  	    if (/^<svg[\s>]/i.test(svg)) {
  	      cleaned = svg
  	      .replace(/<script[\s\S]*?<\/script>/gi, "")
  	      .replace(/<svg(?![^>]*preserveAspectRatio)/i, "<svg preserveAspectRatio=\"xMidYMid meet\"")
  	      .replace(/<svg([^>]*?)>/i, "<svg$1 style=\"height:48px;width:auto;max-width:190px;display:block;\">");

  	      return cleaned;
  	    }

  	    console.warn("TRAC-MAN: SVG argument was supplied but was not recognised as data:image or inline svg.", svg.substring(0, 50));

  	    return "";
  	  }

  	  function isFiniteNumber(value) {
  	    return typeof value === "number" && isFinite(value);
  	  }

  	  function arr(value) {
  	    return Array.isArray(value) ? value: [];
  	  }

  	  function clone(value) {
  	    return JSON.parse(JSON.stringify(value || {}));
  	  }

  	  function clamp(value, min, max, fallback) {
  	    var number = Number(value);

  	    if (!Number.isFinite(number)) {
  	      number = fallback;
  	    }

  	    return Math.max(min, Math.min(max, number));
  	  }

  	  function numberOrNull(value) {
  	    if (value === null || value === undefined || value === "") {
  	      return null;
  	    }

  	    var number = Number(value);

  	    return Number.isFinite(number) ? number: null;
  	  }

  	  function alertSafe(message) {
  	    if (WindowSafe && typeof WindowSafe.alert === "function") {
  	      WindowSafe.alert(message);
  	      return;
  	    }

  	    console.warn(message);
  	  }

  	  function confirmSafe(message) {
  	    if (WindowSafe && typeof WindowSafe.confirm === "function") {
  	      return WindowSafe.confirm(message);
  	    }

  	    return true;
  	  }

  	  function parseJson(raw, fallback) {
  	    if (raw === null || raw === undefined || raw === "") {
  	      return clone(fallback);
  	    }

  	    if (typeof raw === "object") {
  	      return clone(raw);
  	    }

  	    try {
  	      return JSON.parse(raw);
  	    } catch (error) {
  	      console.warn("TRAC-MAN: JSON parse failed", error, raw);
  	      return clone(fallback);
  	    }
  	  }

  	  function prettyName(value) {
  	    return String(value || "")
  	    .replace(/_/g, " ")
  	    .replace(/([a-z])([A-Z])/g, "$1 $2")
  	    .trim()
  	    .replace(/\b\w/g, function (char) {
  	      return char.toUpperCase();
  	    });
  	  }

  	  function isWrapped(value) {
  	    return !!(
  	      value &&
  	      typeof value === "object" &&
  	      !Array.isArray(value) &&
  	      Object.prototype.hasOwnProperty.call(value, "value")
  	    );
  	  }

  	  function unwrap(value) {
  	    return isWrapped(value) ? value.value: value;
  	  }

  	  function getFirst(source, names) {
  	    if (!source || typeof source !== "object") {
  	      return "";
  	    }

  	    for (var i = 0; i < names.length; i++) {
  	      if (
  	        Object.prototype.hasOwnProperty.call(source, names[i]) &&
  	        source[names[i]] !== null &&
  	        source[names[i]] !== undefined
  	      ) {
  	        return source[names[i]];
  	      }
  	    }

  	    return "";
  	  }

  	  function ensureObjectPath(root, path) {
  	    var ref = root;

  	    path.forEach(function (key) {
  	      if (!ref[key] || typeof ref[key] !== "object" || Array.isArray(ref[key])) {
  	        ref[key] = {};
  	      }

  	      ref = ref[key];
  	    });

  	    return ref;
  	  }

  	  function ensureArrayPath(root,
  	    path) {
  	    var parent = ensureObjectPath(root,
  	      path.slice(0, -1));
  	    var key = path[path.length - 1];

  	    if (!Array.isArray(parent[key])) {
  	      parent[key] = [];
  	    }

  	    return parent[key];
  	  }

  	  function tokenizePath(path) {
  	    var tokens = [];

  	    String(path || "").split(".").forEach(function (part) {
  	      var re = /([^\[\]]+)|\[(\d+)\]/g;
  	      var match;

  	      while ((match = re.exec(part)) !== null) {
  	        if (match[1] !== null && match[1] !== undefined) {
  	          tokens.push(match[1]);
  	        } else if (match[2] !== null && match[2] !== undefined) {
  	          tokens.push(Number(match[2]));
  	        }
  	      }
  	    });

  	    return tokens;
  	  }

  	  function setByTokens(root,
  	    tokens,
  	    value) {
  	    var ref = root;

  	    if (!root || !tokens.length) {
  	      return;
  	    }

  	    for (var i = 0; i < tokens.length - 1; i++) {
  	      var key = tokens[i];
  	      var next = tokens[i + 1];

  	      if (typeof key === "number") {
  	        if (!Array.isArray(ref)) {
  	          return;
  	        }

  	        if (!ref[key]) {
  	          ref[key] = typeof next === "number" ? []: {};
  	        }

  	        ref = ref[key];
  	      } else {
  	        if (typeof next === "number") {
  	          if (!Array.isArray(ref[key])) {
  	            ref[key] = [];
  	          }
  	        } else if (!ref[key] || typeof ref[key] !== "object") {
  	          ref[key] = {};
  	        }

  	        ref = ref[key];
  	      }
  	    }

  	    ref[tokens[tokens.length - 1]] = value;
  	  }

  	  function readInputValue(element) {
  	    if (!element) {
  	      return null;
  	    }

  	    if (element.type === "checkbox") {
  	      return !!element.checked;
  	    }

  	    if (element.type === "number") {
  	      if (element.value === "") {
  	        return "";
  	      }

  	      var number = Number(element.value);

  	      return Number.isFinite(number) ? number: element.value;
  	    }

  	    return element.value;
  	  }

  	  function getUiValue(id) {
  	    var element = DocumentSafe.getElementById(id);

  	    if (!element) {
  	      return "";
  	    }

  	    return clean(element.value);
  	  }

  	  function setText(node, text) {
  	    if (node) {
  	      node.textContent = text || "";
  	    }
  	  }

  	  // ===============================================================
  	  // VEHICLE HELPERS
  	  // ===============================================================
  	  function vehicleObjectId(vehicle) {
  	    return clean(getFirst(vehicle, ["objectId", "ObjectId", "OBJECTID", "objectID"]));
  	  }

  	  function vehicleId(vehicle) {
  	    return clean(getFirst(vehicle, ["ID", "Id", "id", "FID", "fid"]));
  	  }

  	  function vehicleMake(vehicle) {
  	    var value = "";

  	    if (vehicle && vehicle.Data && vehicle.Data.Vehicle) {
  	      value = vehicle.Data.Vehicle.Make;
  	      value = isWrapped(value) ? value.value: value;
  	    }

  	    return clean(value);
  	  }

  	  function vehicleModel(vehicle) {
  	    var value = "";

  	    if (vehicle && vehicle.Data && vehicle.Data.Vehicle) {
  	      value = vehicle.Data.Vehicle.Model;
  	      value = isWrapped(value) ? value.value: value;
  	    }

  	    return clean(value);
  	  }

  	  function vehicleReg(vehicle) {
  	    var value = "";

  	    if (vehicle) {
  	      value = vehicle.Registration;
  	    }

  	    if (!value && vehicle && vehicle.Data && vehicle.Data.Vehicle) {
  	      value = vehicle.Data.Vehicle.Registration;
  	      value = isWrapped(value) ? value.value: value;
  	    }

  	    return clean(value);
  	  }

  	  function vehicleTitle(vehicle) {
  	    var title = clean(vehicleMake(vehicle) + " " + vehicleModel(vehicle));

  	    if (!title) {
  	      title = vehicleId(vehicle) || vehicleObjectId(vehicle) || "Vehicle";
  	    }

  	    if (vehicleReg(vehicle)) {
  	      title += " (" + vehicleReg(vehicle) + ")";
  	    }

  	    return title;
  	  }

  	  function vehicleOdometerBaseline(vehicle) {
  	    var names = [
  	      "Odometer",
  	      "Current_Odometer",
  	      "CurrentOdometer",
  	      "Mileage",
  	      "Current_Mileage",
  	      "Last_Odometer",
  	      "LastOdometer"
  	    ];
  	    var value;
  	    var i;

  	    if (!vehicle) {
  	      return 0;
  	    }

  	    for (i = 0; i < names.length; i++) {
  	      value = numberOrNull(vehicle[names[i]]);

  	      if (value !== null) {
  	        return value;
  	      }
  	    }

  	    if (vehicle.Data && vehicle.Data.Vehicle) {
  	      for (i = 0; i < names.length; i++) {
  	        value = unwrap(vehicle.Data.Vehicle[names[i]]);
  	        value = numberOrNull(value);

  	        if (value !== null) {
  	          return value;
  	        }
  	      }
  	    }

  	    return 0;
  	  }

  	  function cardColor(vehicle) {
  	    var color = "";

  	    if (vehicle) {
  	      color = vehicle.color || "";
  	    }

  	    if (!color && vehicle && vehicle.Data && vehicle.Data.Vehicle) {
  	      color = vehicle.Data.Vehicle.Color;
  	      color = isWrapped(color) ? color.value: color;
  	    }

  	    return clean(color) || "#CC6633";
  	  }

  	  // ===============================================================
  	  // TYRE HELPERS - UPDATED TYRES SCHEMA
  	  // ===============================================================
  	  function tyreObjectId(tyre) {
  	    return clean(getFirst(tyre, ["objectId", "ObjectId", "objectID", "id"]));
  	  }

  	  function tyreNumber(tyre) {
  	    return clean(getFirst(tyre, [
  	      "ID",
  	      "FID",
  	      "Tyre_Number",
  	      "TyreNumber",
  	      "Serial_Number",
  	      "SerialNumber"
  	    ]));
  	  }

  	  function tyreSerial(tyre) {
  	    return clean(getFirst(tyre, ["Serial_Number", "SerialNumber", "Serial"]));
  	  }

  	  function tyreMake(tyre) {
  	    return clean(getFirst(tyre, ["Make", "Tyre_Brand", "Brand"]));
  	  }

  	  function tyreModel(tyre) {
  	    return clean(getFirst(tyre, ["Model", "Pattern"]));
  	  }

  	  function tyreSize(tyre) {
  	    return clean(getFirst(tyre, ["Size"]));
  	  }

  	  function tyreType(tyre) {
  	    return clean(getFirst(tyre, ["Type"]));
  	  }

  	  function tyreStatus(tyre) {
  	    return clean(getFirst(tyre, ["Status"])) || TYRE_STATUS.OK;
  	  }

  	  function tyreName(tyre) {
  	    if (!tyre) {
  	      return "";
  	    }

  	    return [
  	      tyreNumber(tyre),
  	      tyreSerial(tyre),
  	      tyreMake(tyre),
  	      tyreModel(tyre),
  	      tyreSize(tyre)
  	    ].filter(Boolean).join(" - ") || tyreObjectId(tyre);
  	  }

  	  function tyreLife(tyre) {
  	    var direct;
  	    var currentMileage;
  	    var expectedMileage;

  	    if (!tyre) {
  	      return null;
  	    }

  	    direct = numberOrNull(tyre.Current_Life);

  	    if (direct !== null) {
  	      return clamp(direct, 0, 100, 0);
  	    }

  	    currentMileage = numberOrNull(tyre.Current_Mileage);
  	    expectedMileage = numberOrNull(tyre.Expected_Mileage);

  	    if (currentMileage !== null && expectedMileage !== null && expectedMileage > 0) {
  	      return clamp(100 - ((currentMileage / expectedMileage) * 100), 0, 100, 0);
  	    }

  	    return null;
  	  }

  	  function tyreColor(tyre) {
  	    var life = tyreLife(tyre);

  	    if (life === null) return "#6b7280";
  	    if (life <= 0) return "#111827";
  	    if (life < 20) return "#ff2b1a";
  	    if (life < 40) return "#ff8a00";
  	    if (life < 60) return "#ffd633";
  	    if (life < 80) return "#a6ff33";

  	    return "#39ff14";
  	  }

  	  function requiredTyreTypeForSlot(slot) {
  	    if (!slot) return "Drive";
  	    if (slot.AxleType === "Tag") return "Drive";
  	    if (slot.AxleType === "Spare") return "Spare";
  	    if (slot.AxleType === "Trailer") return "Trailer";
  	    if (slot.AxleType === "Steer") return "Steer";

  	    return "Drive";
  	  }

  	  function tyreMatchesSlot(tyre, slot) {
  	    var type = tyreType(tyre);
  	    var required = requiredTyreTypeForSlot(slot);

  	    if (!type) {
  	      return true;
  	    }

  	    return type === required;
  	  }

  	  function tyreMismatchInfo(tyre, slot) {
  	    var actual = tyreType(tyre) || "No Type";
  	    var required = requiredTyreTypeForSlot(slot);

  	    return {
  	      HasMismatch: !!(actual && required && actual !== required && actual !== "No Type"),
  	      ActualType: actual,
  	      RequiredType: required,
  	      Message: "Tyre type mismatch. Required: " + required + ". Actual: " + actual + "."
  	    };
  	  }

  	  function mismatchKey(tyreId, positionKey) {
  	    return clean(tyreId) + "::" + clean(positionKey);
  	  }

  	  function mismatchAlreadyApproved(tyreId, positionKey) {
  	    return !!state.mismatchApprovals[mismatchKey(tyreId, positionKey)];
  	  }

  	  function approveMismatch(tyre, slot, reason) {
  	    var info = tyreMismatchInfo(tyre, slot);
  	    var key = mismatchKey(tyreObjectId(tyre), slot.PositionKey);

  	    state.mismatchApprovals[key] = {
  	      Accepted: true,
  	      Date: new Date().toISOString(),
  	      Required_Type: info.RequiredType,
  	      Actual_Type: info.ActualType,
  	      Position: slot.PositionKey,
  	      Reason: reason || "User accepted tyre type mismatch."
  	    };

  	    return state.mismatchApprovals[key];
  	  }

  	  function getMismatchApproval(tyreId, positionKey) {
  	    return state.mismatchApprovals[mismatchKey(tyreId, positionKey)] || null;
  	  }

  	  function confirmMismatchIfNeeded(tyre, slot) {
  	    var info = tyreMismatchInfo(tyre, slot);
  	    var message;

  	    if (!info.HasMismatch) {
  	      return true;
  	    }

  	    if (mismatchAlreadyApproved(tyreObjectId(tyre), slot.PositionKey)) {
  	      return true;
  	    }

  	    message = ""
  	    + "Approve tyre type mismatch?\n\n"
  	    + "Position: " + slot.PositionKey + "\n"
  	    + "Position requires: " + info.RequiredType + "\n"
  	    + "Selected tyre type: " + info.ActualType + "\n\n"
  	    + "This is allowed, but it must be approved.\n"
  	    + "The approval will be recorded in the tyre history.\n\n"
  	    + "Approve this fitment?";

  	    if (!confirmSafe(message)) {
  	      return false;
  	    }

  	    approveMismatch(tyre, slot, "Mismatch approved during tyre operation.");

  	    return true;
  	  }

  	  function mismatchSummaryForHistory(tyre, slot) {
  	    var info = tyreMismatchInfo(tyre, slot);

  	    if (!info.HasMismatch) {
  	      return "";
  	    }

  	    return "Mismatch accepted. Required Type: " + info.RequiredType + ". Actual Type: " + info.ActualType + ".";
  	  }

  	  function isTyreAvailable(tyre) {
  	    return !!tyreObjectId(tyre) &&
  	    !clean(tyre.Vehicle_ObjectId) &&
  	    tyreStatus(tyre) === TYRE_STATUS.OK;
  	  }

  	  function addTyreToMap(map, tyre) {
  	    var id = tyreObjectId(tyre);

  	    if (id) {
  	      map[id] = tyre;
  	    }
  	  }

  	  function collectTyres() {
  	    var map = {};

  	    TyresArg.forEach(function (tyre) {
  	      addTyreToMap(map, tyre);
  	    });

  	    arr(TyresSafe).forEach(function (tyre) {
  	      addTyreToMap(map, tyre);
  	    });

  	    try {
  	      arr(App && App.User && App.User.Companies).forEach(function (company) {
  	        arr(company.Tyres).forEach(function (tyre) {
  	          addTyreToMap(map, tyre);
  	        });

  	        arr(company.Tractors).forEach(function (vehicle) {
  	          arr(vehicle.Tyres).forEach(function (tyre) {
  	            addTyreToMap(map, tyre);
  	          });
  	        });

  	        arr(company.Trailers).forEach(function (vehicle) {
  	          arr(vehicle.Tyres).forEach(function (tyre) {
  	            addTyreToMap(map, tyre);
  	          });
  	        });
  	      });
  	    } catch (error) {
  	      console.warn("TRAC-MAN: collectTyres failed", error);
  	    }

  	    Tractors.forEach(function (vehicle) {
  	      arr(vehicle.Tyres).forEach(function (tyre) {
  	        addTyreToMap(map, tyre);
  	      });
  	    });

  	    return Object.keys(map).map(function (id) {
  	      return map[id];
  	    });
  	  }

  	  function findTyre(id) {
  	    var cleanId = clean(id);

  	    if (!cleanId) {
  	      return null;
  	    }

  	    for (var i = 0; i < state.tyreArray.length; i++) {
  	      if (tyreObjectId(state.tyreArray[i]) === cleanId) {
  	        return state.tyreArray[i];
  	      }
  	    }

  	    return null;
  	  }

  	  function upsertTyre(tyre) {
  	    var id = tyreObjectId(tyre);
  	    var i;

  	    if (!id) {
  	      return;
  	    }

  	    for (i = 0; i < state.tyreArray.length; i++) {
  	      if (tyreObjectId(state.tyreArray[i]) === id) {
  	        state.tyreArray[i] = tyre;
  	        return;
  	      }
  	    }

  	    state.tyreArray.push(tyre);
  	  }

  	  function loadTyres() {
  	    var store;
  	    var query = null;

  	    if (state.tyresLoaded) {
  	      return Promise.resolve(state.tyreArray);
  	    }

  	    if (state.tyresLoading) {
  	      return state.tyresLoading;
  	    }

  	    if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	      return Promise.resolve(state.tyreArray);
  	    }

  	    store = BackendlessApi.Data.of(TABLE_TYRES);

  	    try {
  	      if (BackendlessApi.DataQueryBuilder && BackendlessApi.DataQueryBuilder.create) {
  	        query = BackendlessApi.DataQueryBuilder.create();

  	        if (typeof query.setPageSize === "function") {
  	          query.setPageSize(100);
  	        }
  	      } else {
  	        query = {
  	          pageSize: 100
  	        };
  	      }
  	    } catch (error) {
  	      query = {
  	        pageSize: 100
  	      };
  	    }

  	    state.tyresLoading = store.find(query)
  	    .then(function (rows) {
  	      rows = Array.isArray(rows)
  	      ? rows: rows && Array.isArray(rows.data)
  	      ? rows.data: [];

  	      rows.forEach(function (tyre) {
  	        upsertTyre(tyre);
  	      });

  	      state.tyresLoaded = true;
  	      state.tyresLoading = null;

  	      return state.tyreArray;
  	    })
  	    .catch(function (error) {
  	      console.warn("TRAC-MAN: failed loading Tyres table", error);
  	      state.tyresLoading = null;

  	      return state.tyreArray;
  	    });

  	    return state.tyresLoading;
  	  }

  	  // ===============================================================
  	  // AXLE RULES
  	  // ===============================================================
  	  function allowedAxleTypes(vehicleType) {
  	    return AXLE_TYPES[vehicleType] || AXLE_TYPES.Tractor;
  	  }

  	  function defaultAxleType(vehicleType) {
  	    return vehicleType === "Trailer" ? "Trailer": "Drive";
  	  }

  	  function normaliseAxle(axle, fallbackAxleNo, vehicleType) {
  	    var cleanVehicleType = vehicleType || VEHICLE_TYPE;
  	    var allowed = allowedAxleTypes(cleanVehicleType);
  	    var axleNo = Math.max(1, Number((axle && (axle.Axle || axle.AxleNo)) || fallbackAxleNo || 1));
  	    var type = axle && allowed.indexOf(axle.Type) !== -1 ? axle.Type: defaultAxleType(cleanVehicleType);
  	    var tyresPerSide = Number(axle && (
  	      axle.TyresPerSide ||
  	      axle.TyreCountPerSide ||
  	      axle.Tyres ||
  	      axle.LeftCount ||
  	      axle.Left
  	    ));
  	    var wearRate = Number(axle && (axle.WearRate || axle.TagWearRate));

  	    if (!Number.isFinite(tyresPerSide)) {
  	      tyresPerSide = 1;
  	    }

  	    tyresPerSide = Math.round(clamp(tyresPerSide, 1, 2, 1));

  	    if (type === "Steer" || type === "Spare") {
  	      tyresPerSide = 1;
  	    }

  	    if (!Number.isFinite(wearRate)) {
  	      wearRate = 1;
  	    }

  	    wearRate = clamp(wearRate, 0, 1, 1);

  	    if (type !== "Tag") {
  	      wearRate = 1;
  	    }

  	    return {
  	      Axle: axleNo,
  	      Type: type,
  	      TyresPerSide: tyresPerSide,
  	      WearRate: wearRate,
  	      Enabled: axle && axle.Enabled === false ? false: true
  	    };
  	  }

  	  function applyAxleRules(tPositions, showAlerts) {
  	    var vehicleType;
  	    var allowed;
  	    var steerCount = 0;
  	    var unsupportedChanged = false;
  	    var steerLimitChanged = false;
  	    var lockedChanged = false;

  	    if (!tPositions || typeof tPositions !== "object") {
  	      return tPositions;
  	    }

  	    vehicleType = tPositions.VehicleType || VEHICLE_TYPE;
  	    allowed = allowedAxleTypes(vehicleType);

  	    tPositions.Axles = arr(tPositions.Axles).map(function (axle, index) {
  	      var cleanAxle = normaliseAxle(axle, index + 1, vehicleType);

  	      if (allowed.indexOf(cleanAxle.Type) === -1) {
  	        cleanAxle.Type = defaultAxleType(vehicleType);
  	        unsupportedChanged = true;
  	      }

  	      if (vehicleType === "Tractor" && cleanAxle.Type === "Trailer") {
  	        cleanAxle.Type = "Drive";
  	        unsupportedChanged = true;
  	      }

  	      if (
  	        vehicleType === "Trailer" &&
  	        ["Steer", "Drive", "Tag"].indexOf(cleanAxle.Type) !== -1
  	      ) {
  	        cleanAxle.Type = "Trailer";
  	        unsupportedChanged = true;
  	      }

  	      if (cleanAxle.Type === "Steer") {
  	        steerCount += 1;

  	        if (steerCount > 2) {
  	          cleanAxle.Type = "Tag";
  	          cleanAxle.WearRate = 1;
  	          steerLimitChanged = true;
  	        }
  	      }

  	      if (
  	        (cleanAxle.Type === "Steer" || cleanAxle.Type === "Spare") &&
  	        cleanAxle.TyresPerSide !== 1
  	      ) {
  	        cleanAxle.TyresPerSide = 1;
  	        lockedChanged = true;
  	      }

  	      if (cleanAxle.Type === "Tag") {
  	        cleanAxle.WearRate = clamp(cleanAxle.WearRate, 0, 1, 1);
  	      } else {
  	        cleanAxle.WearRate = 1;
  	      }

  	      return cleanAxle;
  	    });

  	    if (showAlerts && unsupportedChanged) {
  	      alertSafe("Invalid axle type removed. Tractors cannot use Trailer axles.");
  	    }

  	    if (showAlerts && steerLimitChanged) {
  	      alertSafe("A tractor cannot have more than 2 Steer axles. Extra Steer axles were changed to Tag.");
  	    }

  	    if (showAlerts && lockedChanged) {
  	      alertSafe("Steer and Spare axles are locked to 1 tyre.");
  	    }

  	    return tPositions;
  	  }

  	  // ===============================================================
  	  // TPOSITIONS ENGINE
  	  // ===============================================================
  	  function emptyTPositions() {
  	    return {
  	      SchemaVersion: SCHEMA_VERSION,
  	      VehicleType: VEHICLE_TYPE,
  	      Axles: [],
  	      Positions: {},
  	      Summary: {
  	        TotalAxles: 0,
  	        TotalPositions: 0,
  	        AssignedTyres: 0,
  	        EmptyPositions: 0
  	      },
  	      UpdatedAt: "",
  	      UpdatedBy: ""
  	    };
  	  }

  	  function tPositionsFieldName(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") {
  	      return TPOSITIONS_PRIMARY;
  	    }

  	    if (Object.prototype.hasOwnProperty.call(vehicle, TPOSITIONS_PRIMARY)) {
  	      return TPOSITIONS_PRIMARY;
  	    }

  	    if (Object.prototype.hasOwnProperty.call(vehicle, TPOSITIONS_SECONDARY)) {
  	      return TPOSITIONS_SECONDARY;
  	    }

  	    if (
  	      vehicle.Data &&
  	      Object.prototype.hasOwnProperty.call(vehicle.Data, TPOSITIONS_PRIMARY)
  	    ) {
  	      return TPOSITIONS_PRIMARY;
  	    }

  	    if (
  	      vehicle.Data &&
  	      Object.prototype.hasOwnProperty.call(vehicle.Data, TPOSITIONS_SECONDARY)
  	    ) {
  	      return TPOSITIONS_SECONDARY;
  	    }

  	    return TPOSITIONS_PRIMARY;
  	  }

  	  function readTPositionsRaw(vehicle) {
  	    if (!vehicle) {
  	      return null;
  	    }

  	    if (vehicle[TPOSITIONS_PRIMARY] !== null && vehicle[TPOSITIONS_PRIMARY] !== undefined) {
  	      return vehicle[TPOSITIONS_PRIMARY];
  	    }

  	    if (vehicle[TPOSITIONS_SECONDARY] !== null && vehicle[TPOSITIONS_SECONDARY] !== undefined) {
  	      return vehicle[TPOSITIONS_SECONDARY];
  	    }

  	    if (
  	      vehicle.Data &&
  	      vehicle.Data[TPOSITIONS_PRIMARY] !== null &&
  	      vehicle.Data[TPOSITIONS_PRIMARY] !== undefined
  	    ) {
  	      return unwrap(vehicle.Data[TPOSITIONS_PRIMARY]);
  	    }

  	    if (
  	      vehicle.Data &&
  	      vehicle.Data[TPOSITIONS_SECONDARY] !== null &&
  	      vehicle.Data[TPOSITIONS_SECONDARY] !== undefined
  	    ) {
  	      return unwrap(vehicle.Data[TPOSITIONS_SECONDARY]);
  	    }

  	    return null;
  	  }

  	  function positionKey(axleNo, sideCode, tyreIndex) {
  	    return "A" + Number(axleNo || 0) + String(sideCode || "").toUpperCase() + Number(tyreIndex || 1);
  	  }

  	  function spareKey(index) {
  	    return "SP" + Number(index || 1);
  	  }

  	  function createSlot(key, axle, side, sideCode, tyreIndex, existing) {
  	    var old = existing && typeof existing === "object" ? existing: {};
  	    var tyreId = old.TyreObjectId || old.tyreObjectId || "";

  	    return {
  	      PositionKey: key,
  	      Axle: axle.Axle,
  	      AxleType: axle.Type,
  	      Side: side,
  	      SideCode: sideCode,
  	      TyreIndex: tyreIndex,
  	      TyresPerSide: axle.TyresPerSide,
  	      WearRate: axle.Type === "Tag" ? axle.WearRate: 1,

  	      TyreObjectId: tyreId,
  	      TyreNumber: old.TyreNumber || old.Tyre_Number || "",
  	      SerialNumber: old.SerialNumber || old.Serial_Number || "",

  	      Status: tyreId ? "Fitted": "Empty",
  	      UpdatedAt: old.UpdatedAt || "",
  	      Notes: old.Notes || ""
  	    };
  	  }

  	  function summaryForTPositions(tPositions) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    var keys = Object.keys(positions);
  	    var assigned = keys.filter(function (key) {
  	      return !!(positions[key] && positions[key].TyreObjectId);
  	    }).length;

  	    return {
  	      TotalAxles: arr(tPositions && tPositions.Axles).filter(function (axle) {
  	        return axle && axle.Enabled !== false;
  	      }).length,
  	      TotalPositions: keys.length,
  	      AssignedTyres: assigned,
  	      EmptyPositions: keys.length - assigned
  	    };
  	  }

  	  function rebuildSlots(tPositions) {
  	    var oldPositions;
  	    var newPositions = {};
  	    var spareCounter = 1;

  	    if (!tPositions || typeof tPositions !== "object") {
  	      return tPositions;
  	    }

  	    applyAxleRules(tPositions, false);

  	    oldPositions =
  	    tPositions.Positions && typeof tPositions.Positions === "object"
  	    ? tPositions.Positions: {};

  	    tPositions.Axles = arr(tPositions.Axles)
  	    .filter(function (axle) {
  	      return axle && axle.Enabled !== false;
  	    })
  	    .map(function (axle, index) {
  	      return normaliseAxle(axle, index + 1, tPositions.VehicleType || VEHICLE_TYPE);
  	    })
  	    .sort(function (a, b) {
  	      return Number(a.Axle) - Number(b.Axle);
  	    });

  	    applyAxleRules(tPositions, false);

  	    tPositions.Axles.forEach(function (axle) {
  	      var i;
  	      var key;

  	      if (axle.Type === "Spare") {
  	        key = spareKey(spareCounter);
  	        spareCounter += 1;

  	        newPositions[key] = createSlot(key, axle, "Spare", "SP", 1, oldPositions[key]);
  	        return;
  	      }

  	      for (i = 1; i <= axle.TyresPerSide; i++) {
  	        key = positionKey(axle.Axle, "L", i);
  	        newPositions[key] = createSlot(key, axle, "Left", "L", i, oldPositions[key]);
  	      }

  	      for (i = 1; i <= axle.TyresPerSide; i++) {
  	        key = positionKey(axle.Axle, "R", i);
  	        newPositions[key] = createSlot(key, axle, "Right", "R", i, oldPositions[key]);
  	      }
  	    });

  	    tPositions.Positions = newPositions;
  	    tPositions.Summary = summaryForTPositions(tPositions);

  	    return tPositions;
  	  }

  	  function normaliseTPositions(raw) {
  	    var base = emptyTPositions();
  	    var parsed = parseJson(raw,
  	      base);
  	    var tPositions = {
  	      SchemaVersion: parsed.SchemaVersion || SCHEMA_VERSION,
  	      VehicleType: VEHICLE_TYPE,
  	      Axles: [],
  	      Positions:
  	      parsed.Positions && typeof parsed.Positions === "object"
  	      ? clone(parsed.Positions): {},
  	      Summary:
  	      parsed.Summary && typeof parsed.Summary === "object"
  	      ? clone(parsed.Summary): clone(base.Summary),
  	      UpdatedAt: parsed.UpdatedAt || "",
  	      UpdatedBy: parsed.UpdatedBy || ""
  	    };

  	    if (Array.isArray(parsed.Axles)) {
  	      tPositions.Axles = parsed.Axles.map(function (axle, index) {
  	        return normaliseAxle(axle, index + 1, tPositions.VehicleType);
  	      });
  	    }

  	    applyAxleRules(tPositions, false);
  	    rebuildSlots(tPositions);

  	    return tPositions;
  	  }

  	  function sortedPositionKeys(tPositions) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	    return Object.keys(positions).sort(function (a, b) {
  	      var pa = positions[a] || {};
  	      var pb = positions[b] || {};
  	      var aSpare = String(a).indexOf("SP") === 0;
  	      var bSpare = String(b).indexOf("SP") === 0;
  	      var sideOrder = {
  	        L: 1, R: 2, SP: 3
  	      };
  	      var sideA;
  	      var sideB;

  	      if (aSpare && !bSpare) return 1;
  	      if (!aSpare && bSpare) return -1;

  	      if (Number(pa.Axle || 999) !== Number(pb.Axle || 999)) {
  	        return Number(pa.Axle || 999) - Number(pb.Axle || 999);
  	      }

  	      sideA = sideOrder[pa.SideCode] || 99;
  	      sideB = sideOrder[pb.SideCode] || 99;

  	      if (sideA !== sideB) {
  	        return sideA - sideB;
  	      }

  	      return Number(pa.TyreIndex || 0) - Number(pb.TyreIndex || 0);
  	    });
  	  }

  	  function assignedTyreIds(tPositions) {
  	    var ids = [];
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	    Object.keys(positions).forEach(function (key) {
  	      var id = clean(positions[key] && positions[key].TyreObjectId);

  	      if (id && ids.indexOf(id) === -1) {
  	        ids.push(id);
  	      }
  	    });

  	    return ids;
  	  }

  	  function assignedTyreObjects(tPositions) {
  	    return assignedTyreIds(tPositions)
  	    .map(function (id) {
  	      return findTyre(id);
  	    })
  	    .filter(Boolean);
  	  }

  	  function cleanTPositionsForSave(tPositions) {
  	    var cleaned = clone(tPositions);

  	    cleaned.SchemaVersion = SCHEMA_VERSION;
  	    cleaned.VehicleType = VEHICLE_TYPE;
  	    cleaned.UpdatedAt = new Date().toISOString();

  	    applyAxleRules(cleaned,
  	      false);
  	    rebuildSlots(cleaned);

  	    cleaned.Summary = summaryForTPositions(cleaned);

  	    return cleaned;
  	  }

  	  function writeTPositionsToVehicle(vehicle,
  	    tPositions) {
  	    var cleaned = cleanTPositionsForSave(tPositions);
  	    var field = tPositionsFieldName(vehicle);
  	    var other = field === TPOSITIONS_PRIMARY ? TPOSITIONS_SECONDARY: TPOSITIONS_PRIMARY;

  	    vehicle[field] = cleaned;

  	    if (Object.prototype.hasOwnProperty.call(vehicle, other)) {
  	      vehicle[other] = cleaned;
  	    }

  	    vehicle[TYRES_RELATION] = assignedTyreObjects(cleaned);

  	    return vehicle;
  	  }

  	  function getSlot(tPositions, key) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    var cleanKey = clean(key);
  	    var keys;
  	    var i;

  	    if (!cleanKey) {
  	      return null;
  	    }

  	    if (positions[cleanKey]) {
  	      return positions[cleanKey];
  	    }

  	    keys = Object.keys(positions);

  	    for (i = 0; i < keys.length; i++) {
  	      if (positions[keys[i]] && positions[keys[i]].PositionKey === cleanKey) {
  	        return positions[keys[i]];
  	      }
  	    }

  	    return null;
  	  }

  	  function clearSlot(slot) {
  	    if (!slot) {
  	      return;
  	    }

  	    slot.TyreObjectId = "";
  	    slot.TyreNumber = "";
  	    slot.SerialNumber = "";
  	    slot.Status = "Empty";
  	    slot.UpdatedAt = new Date().toISOString();
  	  }

  	  function fitSlot(slot, tyre) {
  	    if (!slot || !tyre) {
  	      return;
  	    }

  	    slot.TyreObjectId = tyreObjectId(tyre);
  	    slot.TyreNumber = tyreNumber(tyre);
  	    slot.SerialNumber = tyreSerial(tyre);
  	    slot.Status = "Fitted";
  	    slot.UpdatedAt = new Date().toISOString();
  	  }

  	  function copySlotTyre(fromSlot, toSlot) {
  	    if (!fromSlot || !toSlot) {
  	      return;
  	    }

  	    toSlot.TyreObjectId = fromSlot.TyreObjectId || "";
  	    toSlot.TyreNumber = fromSlot.TyreNumber || "";
  	    toSlot.SerialNumber = fromSlot.SerialNumber || "";
  	    toSlot.Status = toSlot.TyreObjectId ? "Fitted": "Empty";
  	    toSlot.UpdatedAt = new Date().toISOString();
  	  }

  	  function slotsForAxle(tPositions, axleNo, sideCode) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	    return Object.keys(positions)
  	    .map(function (key) {
  	      var slot = clone(positions[key]);
  	      slot.PositionKey = slot.PositionKey || key;
  	      return slot;
  	    })
  	    .filter(function (slot) {
  	      return Number(slot.Axle || 0) === Number(axleNo) &&
  	      String(slot.SideCode || "").toUpperCase() === String(sideCode).toUpperCase();
  	    })
  	    .sort(function (a, b) {
  	      return Number(a.TyreIndex || 0) - Number(b.TyreIndex || 0);
  	    });
  	  }

  	  function spareSlots(tPositions) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	    return Object.keys(positions)
  	    .map(function (key) {
  	      var slot = clone(positions[key]);
  	      slot.PositionKey = slot.PositionKey || key;
  	      return slot;
  	    })
  	    .filter(function (slot) {
  	      return String(slot.SideCode || "").toUpperCase() === "SP" ||
  	      String(slot.PositionKey || "").indexOf("SP") === 0;
  	    });
  	  }

  	  // ===============================================================
  	  // HISTORY JSON ENGINE - UPDATED TYRES SCHEMA
  	  // ===============================================================
  	  function blankHistoryStage(active) {
  	    return {
  	      CPK: 0,
  	      Cost: 0,
  	      Ended: "",
  	      Notes: "",
  	      Active: !!active,
  	      Events: [],
  	      Status: active ? "Active": "Not Started",
  	      Started: active ? new Date().toISOString(): "",
  	      End_Mileage: 0,
  	      Mileage_Done: 0,
  	      Start_Mileage: 0,
  	      Mileage_Expected: 0
  	    };
  	  }

  	  function defaultHistory(tyre) {
  	    var stage = clean(tyre && tyre.Current_Stage) || "New";

  	    return {
  	      New: blankHistoryStage(stage === "New"),
  	      Cap1: blankHistoryStage(stage === "Cap1"),
  	      Cap2: blankHistoryStage(stage === "Cap2"),
  	      Cap3: blankHistoryStage(stage === "Cap3"),
  	      Totals: {
  	        Cost_Total: numberOrNull(tyre && tyre.Total_Cost) || 0,
  	        Average_CPK: numberOrNull(tyre && tyre.Total_CPK) || 0,
  	        Mileage_Total: numberOrNull(tyre && tyre.Total_Mileage) || 0,
  	        Total_Life_Stages_Used: 1
  	      },
  	      Current: {
  	        Stage: stage
  	      }
  	    };
  	  }

  	  function normaliseHistory(tyre) {
  	    var fallback = defaultHistory(tyre);
  	    var history = parseJson(tyre && tyre.History, fallback);

  	    ["New",
  	      "Cap1",
  	      "Cap2",
  	      "Cap3"].forEach(function (stage) {
  	        if (!history[stage] || typeof history[stage] !== "object") {
  	          history[stage] = clone(fallback[stage]);
  	        }

  	        if (!Array.isArray(history[stage].Events)) {
  	          history[stage].Events = [];
  	        }
  	      });

  	    if (!history.Totals || typeof history.Totals !== "object") {
  	      history.Totals = clone(fallback.Totals);
  	    }

  	    if (!history.Current || typeof history.Current !== "object") {
  	      history.Current = {
  	        Stage: clean(tyre && tyre.Current_Stage) || "New"
  	      };
  	    }

  	    return history;
  	  }

  	  function appendHistoryEvent(tyre, event) {
  	    var updated = clone(tyre);
  	    var history = normaliseHistory(updated);
  	    var stage = clean(updated.Current_Stage) || clean(history.Current.Stage) || "New";

  	    if (!history[stage] || typeof history[stage] !== "object") {
  	      history[stage] = blankHistoryStage(true);
  	    }

  	    if (!Array.isArray(history[stage].Events)) {
  	      history[stage].Events = [];
  	    }

  	    history[stage].Events.push(event);

  	    history.Current.Stage = stage;
  	    history.Current.Last_Event_Type = event.Type || "";
  	    history.Current.Last_Event_Date = event.Date || "";
  	    history.Current.Vehicle_ObjectId = updated.Vehicle_ObjectId || "";
  	    history.Current.Vehicle_ID = updated.Vehicle_ID || "";
  	    history.Current.Position = updated.Current_Position || "";
  	    history.Current.Axle_Type = updated.Current_Axle_Type || "";
  	    history.Current.Wear_Rate = updated.Current_Wear_Rate || "";

  	    history.Totals.Cost_Total = numberOrNull(updated.Total_Cost) || history.Totals.Cost_Total || 0;
  	    history.Totals.Average_CPK = numberOrNull(updated.Total_CPK) || history.Totals.Average_CPK || 0;
  	    history.Totals.Mileage_Total = numberOrNull(updated.Total_Mileage) || history.Totals.Mileage_Total || 0;

  	    updated.History = history;

  	    return updated;
  	  }

  	  function createTyreEvent(type, options) {
  	    options = options || {};

  	    return {
  	      Date: new Date().toISOString(),
  	      Type: type,
  	      Vehicle_ObjectId: vehicleObjectId(state.activeTractor),
  	      Vehicle_ID: vehicleId(state.activeTractor),
  	      FromPosition: options.FromPosition || "",
  	      ToPosition: options.ToPosition || "",
  	      Odometer: options.Odometer || "",
  	      Destination: options.Destination || "",
  	      WearRate: options.WearRate === null || options.WearRate === undefined ? "": options.WearRate,
  	      CapturedBy: "Tractor Manager",
  	      Notes: options.Notes || "",

  	      Mismatch_Accepted: !!options.Mismatch_Accepted,
  	      Required_Type: options.Required_Type || "",
  	      Actual_Type: options.Actual_Type || "",
  	      Mismatch_Approved_Date: options.Mismatch_Approved_Date || "",
  	      Mismatch_Reason: options.Mismatch_Reason || ""
  	    };
  	  }

  	  // ===============================================================
  	  // TYRE SAVE PAYLOAD CLEANER
  	  // Generated fields must not be written directly.
  	  // ===============================================================
  	  var TYRE_EXPRESSION_FIELDS = [
  	    "Warehouse",
  	    "Current_CPK",
  	    "Total_CPK",
  	    "Current_Life",
  	    "Total_Mileage",
  	    "Mileage_Warning",
  	    "Total_Cost",
  	    "Expected_CPK",
  	    "Remaining_Mileage"
  	  ];

  	  var TYRE_READ_ONLY_FIELDS = [
  	    "created",
  	    "updated",
  	    "ownerId",
  	    "___class"
  	  ];

  	  function cleanTyreForSave(tyre) {
  	    var payload = clone(tyre);

  	    TYRE_EXPRESSION_FIELDS.concat(TYRE_READ_ONLY_FIELDS).forEach(function (field) {
  	      if (Object.prototype.hasOwnProperty.call(payload, field)) {
  	        delete payload[field];
  	      }
  	    });

  	    return payload;
  	  }

  	  function makeTyreFitted(tyre,
  	    slot,
  	    odometer,
  	    notes,
  	    eventType,
  	    fromPosition) {
  	    var updated = clone(tyre);
  	    var event;

  	    updated.Vehicle_ObjectId = vehicleObjectId(state.activeTractor) || null;
  	    updated.Vehicle_ID = vehicleId(state.activeTractor) || null;
  	    updated.Vehicle_Type = VEHICLE_TYPE;

  	    updated.Current_Position = slot.PositionKey;
  	    updated.Current_Axle_Type = slot.AxleType;
  	    updated.Current_Wear_Rate = slot.WearRate === null || slot.WearRate === undefined ? 1: slot.WearRate;

  	    updated.Status = TYRE_STATUS.OK;

  	    if (eventType === "Installed" || !updated.Fitted_Date) {
  	      updated.Fitted_Date = new Date().toISOString();
  	    }

  	    if (odometer !== "") {
  	      updated.Fitted_Odometer = odometer;
  	      updated.Last_Vehicle_Odometer = odometer;
  	    }

  	    var mismatchApproval = getMismatchApproval(tyreObjectId(updated), slot.PositionKey);
  	    var finalNotes = notes || "";

  	    if (mismatchApproval) {
  	      finalNotes = clean(finalNotes + " " + mismatchSummaryForHistory(updated, slot));
  	    }

  	    event = createTyreEvent(eventType || "Installed", {
  	      FromPosition: fromPosition || "",
  	      ToPosition: slot.PositionKey,
  	      Odometer: odometer,
  	      WearRate: slot.WearRate,
  	      Notes: finalNotes,

  	      Mismatch_Accepted: !!mismatchApproval,
  	      Required_Type: mismatchApproval ? mismatchApproval.Required_Type: "",
  	      Actual_Type: mismatchApproval ? mismatchApproval.Actual_Type: "",
  	      Mismatch_Approved_Date: mismatchApproval ? mismatchApproval.Date: "",
  	      Mismatch_Reason: mismatchApproval ? mismatchApproval.Reason: ""
  	    });

  	    updated = appendHistoryEvent(updated, event);

  	    return updated;
  	  }

  	  function makeTyreRemoved(tyre, slot, destination, odometer, notes) {
  	    var updated = clone(tyre);
  	    var status = TYRE_STATUS.OK;
  	    var destinationLabel = destination || "Warehouse";

  	    if (destination === "Retread") {
  	      status = TYRE_STATUS.RETREAD;
  	      destinationLabel = "In For Retread";
  	    }

  	    if (destination === "Scrap") {
  	      status = TYRE_STATUS.SCRAPPED;
  	      destinationLabel = "Scrapped";
  	    }

  	    if (destination === "Stolen") {
  	      status = TYRE_STATUS.STOLEN;
  	      destinationLabel = "Stolen";
  	    }

  	    updated.Vehicle_ObjectId = null;
  	    updated.Vehicle_ID = null;
  	    updated.Vehicle_Type = null;

  	    updated.Current_Position = null;
  	    updated.Current_Axle_Type = null;
  	    updated.Current_Wear_Rate = null;

  	    updated.Fitted_Date = null;
  	    updated.Fitted_Odometer = null;

  	    updated.Status = status;

  	    if (odometer !== "") {
  	      updated.Last_Vehicle_Odometer = odometer;
  	    }

  	    updated = appendHistoryEvent(updated, createTyreEvent("Removed", {
  	      FromPosition: slot.PositionKey,
  	      ToPosition: "",
  	      Odometer: odometer,
  	      Destination: destinationLabel,
  	      WearRate: slot.WearRate,
  	      Notes: notes
  	    }));

  	    return updated;
  	  }

  	  function makeTyreMoved(tyre, fromSlot, toSlot, odometer, notes, eventType) {
  	    var updated = clone(tyre);

  	    updated.Vehicle_ObjectId = vehicleObjectId(state.activeTractor) || null;
  	    updated.Vehicle_ID = vehicleId(state.activeTractor) || null;
  	    updated.Vehicle_Type = VEHICLE_TYPE;

  	    updated.Current_Position = toSlot.PositionKey;
  	    updated.Current_Axle_Type = toSlot.AxleType;
  	    updated.Current_Wear_Rate = toSlot.WearRate === null || toSlot.WearRate === undefined ? 1: toSlot.WearRate;

  	    updated.Status = TYRE_STATUS.OK;

  	    if (odometer !== "") {
  	      updated.Last_Vehicle_Odometer = odometer;
  	    }

  	    var mismatchApproval = getMismatchApproval(tyreObjectId(updated), toSlot.PositionKey);
  	    var finalNotes = notes || "";

  	    if (mismatchApproval) {
  	      finalNotes = clean(finalNotes + " " + mismatchSummaryForHistory(updated, toSlot));
  	    }

  	    updated = appendHistoryEvent(updated, createTyreEvent(eventType || "Rotation", {
  	      FromPosition: fromSlot.PositionKey,
  	      ToPosition: toSlot.PositionKey,
  	      Odometer: odometer,
  	      WearRate: toSlot.WearRate,
  	      Notes: finalNotes,

  	      Mismatch_Accepted: !!mismatchApproval,
  	      Required_Type: mismatchApproval ? mismatchApproval.Required_Type: "",
  	      Actual_Type: mismatchApproval ? mismatchApproval.Actual_Type: "",
  	      Mismatch_Approved_Date: mismatchApproval ? mismatchApproval.Date: "",
  	      Mismatch_Reason: mismatchApproval ? mismatchApproval.Reason: ""
  	    }));

  	    return updated;
  	  }

  	  // ===============================================================
  	  // SAVE ENGINE
  	  // ===============================================================
  	  function saveTyresSequentially(tyres) {
  	    var saved = [];
  	    var store;

  	    tyres = arr(tyres).filter(function (tyre) {
  	      return tyre && tyreObjectId(tyre);
  	    });

  	    if (!tyres.length) {
  	      return Promise.resolve([]);
  	    }

  	    if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	      return Promise.reject(new Error("Backendless is unavailable. Cannot save tyre records."));
  	    }

  	    store = BackendlessApi.Data.of(TABLE_TYRES);

  	    return tyres.reduce(function (chain, tyre) {
  	      return chain.then(function () {
  	        var payload = cleanTyreForSave(tyre);

  	        return store.save(payload).then(function (row) {
  	          row = row && typeof row === "object" ? row: tyre;

  	          saved.push(row);
  	          upsertTyre(row);

  	          return row;
  	        });
  	      });
  	    }, Promise.resolve()).then(function () {
  	      return saved;
  	    });
  	  }

  	  function removeTyreRelationForSave(vehicle) {
  	    var payload = clone(vehicle);

  	    delete payload[TYRES_RELATION];

  	    return payload;
  	  }

  	  function syncTyreRelation(vehicle, tPositions) {
  	    var store;
  	    var refs;

  	    if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	      return Promise.resolve({
  	        skipped: true,
  	        reason: "Backendless unavailable"
  	      });
  	    }

  	    store = BackendlessApi.Data.of(TABLE_TRACTORS);

  	    if (!store || typeof store.setRelation !== "function") {
  	      return Promise.resolve({
  	        skipped: true,
  	        reason: "setRelation unavailable"
  	      });
  	    }

  	    refs = assignedTyreIds(tPositions).map(function (id) {
  	      return {
  	        objectId: id
  	      };
  	    });

  	    return store.setRelation(vehicle, TYRES_RELATION, refs).catch(function (firstError) {
  	      var objectId = vehicleObjectId(vehicle);

  	      console.warn("TRAC-MAN: setRelation with object failed. Trying objectId.", firstError);

  	      if (!objectId) {
  	        throw firstError;
  	      }

  	      return store.setRelation(objectId, TYRES_RELATION, refs);
  	    });
  	  }

  	  function syncTractorIntoAppData(updated) {
  	    var updatedObjectId = vehicleObjectId(updated);
  	    var updatedId = vehicleId(updated);
  	    var i;

  	    for (i = 0; i < state.tractorArray.length; i++) {
  	      if (
  	        vehicleObjectId(state.tractorArray[i]) === updatedObjectId ||
  	        (updatedId && vehicleId(state.tractorArray[i]) === updatedId)
  	      ) {
  	        state.tractorArray[i] = updated;
  	        break;
  	      }
  	    }

  	    try {
  	      arr(App && App.User && App.User.Companies).forEach(function (company) {
  	        var tractors = arr(company.Tractors);

  	        for (var j = 0; j < tractors.length; j++) {
  	          if (
  	            vehicleObjectId(tractors[j]) === updatedObjectId ||
  	            (updatedId && vehicleId(tractors[j]) === updatedId)
  	          ) {
  	            company.Tractors[j] = updated;
  	            break;
  	          }
  	        }
  	      });
  	    } catch (error) {
  	      console.warn("TRAC-MAN: AppData tractor sync failed",
  	        error);
  	    }
  	  }

  	  function saveVehicleWithTPositions(vehicle,
  	    tPositions) {
  	    var payload;

  	    if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	      return Promise.reject(new Error("Backendless is unavailable. Cannot save tractor."));
  	    }

  	    payload = removeTyreRelationForSave(vehicle);

  	    return BackendlessApi.Data.of(TABLE_TRACTORS).save(payload).then(function (saved) {
  	      saved = saved && typeof saved === "object" ? saved: payload;

  	      return syncTyreRelation(saved, tPositions).then(function () {
  	        saved[TYRES_RELATION] = assignedTyreObjects(tPositions);

  	        Object.assign(vehicle, saved);

  	        if (
  	          state.activeTractor &&
  	          (
  	            vehicleObjectId(state.activeTractor) === vehicleObjectId(saved) ||
  	            vehicleId(state.activeTractor) === vehicleId(saved)
  	          )
  	        ) {
  	          Object.assign(state.activeTractor, saved);
  	        }

  	        syncTractorIntoAppData(saved);

  	        return saved;
  	      });
  	    });
  	  }

  	  function saveVehicleOnly(vehicle) {
  	    var payload;

  	    if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	      return Promise.reject(new Error("Backendless is unavailable. Cannot save tractor."));
  	    }

  	    payload = removeTyreRelationForSave(vehicle);

  	    return BackendlessApi.Data.of(TABLE_TRACTORS).save(payload).then(function (saved) {
  	      saved = saved && typeof saved === "object" ? saved: payload;

  	      Object.assign(vehicle, saved);

  	      if (
  	        state.activeTractor &&
  	        (
  	          vehicleObjectId(state.activeTractor) === vehicleObjectId(saved) ||
  	          vehicleId(state.activeTractor) === vehicleId(saved)
  	        )
  	      ) {
  	        Object.assign(state.activeTractor, saved);
  	      }

  	      syncTractorIntoAppData(saved);

  	      return saved;
  	    });
  	  }

  	  function appendTyreMovementRecord(vehicle,
  	    record) {
  	    if (!vehicle.Data) {
  	      vehicle.Data = {};
  	    }

  	    ensureArrayPath(vehicle, ["Data", "Tyres", "TyreRecords"]).push(record);
  	  }

  	  function tyreMovementRecord(type, fromPosition, toPosition, tyre, odometer, notes) {
  	    return {
  	      date: new Date().toISOString(),
  	      type: type,
  	      fromPosition: fromPosition || "",
  	      toPosition: toPosition || "",
  	      tyre: tyreName(tyre),
  	      tyreObjectId: tyreObjectId(tyre),
  	      odometer: odometer || "",
  	      notes: notes || ""
  	    };
  	  }

  	  // ===============================================================
  	  // FLEET DUPLICATE FITMENT CHECKS
  	  // ===============================================================
  	  function scanVehicleForTyre(vehicle, tyreId, currentVehicleObjectId) {
  	    var tPositions;
  	    var positions;
  	    var keys;
  	    var vehicleObjId;
  	    var slot;
  	    var i;

  	    tyreId = clean(tyreId);

  	    if (!vehicle || !tyreId) {
  	      return null;
  	    }

  	    vehicleObjId = vehicleObjectId(vehicle);

  	    if (
  	      currentVehicleObjectId &&
  	      vehicleObjId &&
  	      String(vehicleObjId) === String(currentVehicleObjectId)
  	    ) {
  	      return null;
  	    }

  	    tPositions = normaliseTPositions(readTPositionsRaw(vehicle));
  	    positions = tPositions.Positions || {};
  	    keys = Object.keys(positions);

  	    for (i = 0; i < keys.length; i++) {
  	      slot = positions[keys[i]];

  	      if (slot && String(slot.TyreObjectId || "") === tyreId) {
  	        return {
  	          vehicle: vehicle,
  	          vehicleObjectId: vehicleObjId,
  	          vehicleLabel: vehicleTitle(vehicle),
  	          positionKey: slot.PositionKey || keys[i]
  	        };
  	      }
  	    }

  	    return null;
  	  }

  	  function findTyreFleetAssignment(tyreId) {
  	    var currentVehicleObjectId = vehicleObjectId(state.activeTractor);
  	    var found = null;

  	    try {
  	      arr(App && App.User && App.User.Companies).some(function (company) {
  	        var stop = false;

  	        arr(company.Tractors).some(function (tractor) {
  	          found = scanVehicleForTyre(tractor, tyreId, currentVehicleObjectId);
  	          stop = !!found;
  	          return stop;
  	        });

  	        if (stop) {
  	          return true;
  	        }

  	        arr(company.Trailers).some(function (trailer) {
  	          found = scanVehicleForTyre(trailer, tyreId, currentVehicleObjectId);
  	          stop = !!found;
  	          return stop;
  	        });

  	        return stop;
  	      });
  	    } catch (error) {
  	      console.warn("TRAC-MAN: fleet assignment scan failed",
  	        error);
  	    }

  	    return found;
  	  }

  	  // ===============================================================
  	  // TYRE LIST FILTERS
  	  // ===============================================================
  	  function availableTyresForSlot(tPositions,
  	    slot) {
  	    var assignedHere = assignedTyreIds(tPositions);

  	    return state.tyreArray.filter(function (tyre) {
  	      var id = tyreObjectId(tyre);

  	      if (!id) {
  	        return false;
  	      }

  	      if (assignedHere.indexOf(id) !== -1) {
  	        return false;
  	      }

  	      if (!isTyreAvailable(tyre)) {
  	        return false;
  	      }

  	      if (findTyreFleetAssignment(id)) {
  	        return false;
  	      }

  	      if (
  	        (state.actionMode === "Allocate" || state.actionMode === "RotateSwap") &&
  	        warehouseTyreAlreadyInDraft(id)
  	      ) {
  	        return false;
  	      }

  	      return true;
  	    });
  	  }

  	  function allAvailableWarehouseTyres() {
  	    return state.tyreArray.filter(function (tyre) {
  	      var id = tyreObjectId(tyre);

  	      if (!id) {
  	        return false;
  	      }

  	      if (!isTyreAvailable(tyre)) {
  	        return false;
  	      }

  	      if (findTyreFleetAssignment(id)) {
  	        return false;
  	      }

  	      return true;
  	    });
  	  }

  	  function fittedTyresForVehicle(tPositions) {
  	    var rows = [];
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	    sortedPositionKeys(tPositions).forEach(function (positionKey) {
  	      var slot = positions[positionKey];
  	      var tyre;

  	      if (!slot || !slot.TyreObjectId) {
  	        return;
  	      }

  	      tyre = findTyre(slot.TyreObjectId);

  	      if (!tyre) {
  	        return;
  	      }

  	      rows.push({
  	        tyre: tyre,
  	        slot: slot,
  	        positionKey: slot.PositionKey || positionKey
  	      });
  	    });

  	    return rows;
  	  }

  	  function tyreIsFittedOnCurrentVehicle(tPositions,
  	    tyreId) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    var keys = Object.keys(positions);
  	    var cleanTyreId = clean(tyreId);
  	    var i;

  	    for (i = 0; i < keys.length; i++) {
  	      if (clean(positions[keys[i]] && positions[keys[i]].TyreObjectId) === cleanTyreId) {
  	        return positions[keys[i]];
  	      }
  	    }

  	    return null;
  	  }

  	  // ===============================================================
  	  // PENDING DRAG / TAP ACTION ENGINE
  	  // ===============================================================
  	  function clearPendingTyreAction() {
  	    state.pendingTyreAction = null;
  	    state.dragSource = null;
  	    state.tapSource = null;
  	    state.actionMessage = "";
  	    state.actionError = false;
  	  }

  	  function closeFloatingPopup(id) {
  	    var popup;

  	    if (!DocumentSafe || !id) {
  	      return;
  	    }

  	    popup = DocumentSafe.getElementById(id);

  	    if (popup && popup.parentNode) {
  	      popup.parentNode.removeChild(popup);
  	    }
  	  }

  	  function rerenderTyreTabSafely() {
  	    try {
  	      if (typeof renderVisualTyreOperations === "function") {
  	        renderVisualTyreOperations();
  	        return true;
  	      }
  	    } catch (error) {
  	      console.warn("TRAC-MAN: renderVisualTyreOperations failed", error);
  	    }

  	    try {
  	      if (typeof renderTab === "function") {
  	        renderTab("Tyres");
  	        return true;
  	      }
  	    } catch (error2) {
  	      console.warn("TRAC-MAN: renderTab Tyres failed", error2);
  	    }

  	    return false;
  	  }

  	    function lockTyreMovementState(message) {
  	    var allocateMount;

  	    clearPendingTyreAction();
  	    resetRotationPlan();

  	    state.actionMode = "";
  	    state.allocatePopupOpen = false;
  	    state.allocateSelectedTyreId = "";
  	    state.allocateSearch = "";
  	    state.allocateTypeFilter = "";
  	    state.rotationPopupOpen = false;
  	    state.pendingTyreAction = null;
  	    state.dragSource = null;
  	    state.tapSource = null;
  	    state.selectedPosition = "";
  	    state.mismatchApprovals = {};

  	    closeAllTyrePopups();

  	    allocateMount = DocumentSafe.getElementById("allocateTyreInlineMount");

  	    if (allocateMount) {
  	      allocateMount.innerHTML = "";
  	    }

  	    state.actionMessage = message || "";
  	    state.actionError = false;

  	    if (typeof state.__rerenderTyreEditor === "function") {
  	      state.__rerenderTyreEditor();
  	      return;
  	    }

  	    requestTyreTabRerender();
  	  }

  	  function closeAllTyrePopups() {
  	    closeFloatingPopup("allocateTyrePopup");
  	    closeFloatingPopup("allocationPlanPopup");
  	    closeFloatingPopup("rotationSavePopup");
  	    closeFloatingPopup("removeTyrePopup");
  	  }

  	  function requestTyreTabRerender() {
  	    try {
  	      if (typeof renderVisualTyreOperations === "function") {
  	        renderVisualTyreOperations();
  	        return true;
  	      }
  	    } catch (error) {
  	      console.warn("TRAC-MAN: renderVisualTyreOperations failed", error);
  	    }

  	    try {
  	      if (typeof renderTab === "function") {
  	        renderTab("Tyres");
  	        return true;
  	      }
  	    } catch (error2) {
  	      console.warn("TRAC-MAN: renderTab('Tyres') failed", error2);
  	    }

  	    try {
  	      if (
  	        state &&
  	        state.allocatePopupOpen &&
  	        typeof renderAllocatePopup === "function"
  	      ) {
  	        renderAllocatePopup();
  	        return true;
  	      }
  	    } catch (error3) {
  	      console.warn("TRAC-MAN: renderAllocatePopup fallback failed", error3);
  	    }

  	    return false;
  	  }

  	  function enterRotateSwapAfterAllocate(message) {
  	    state.allocatePopupOpen = false;
  	    state.allocateSelectedTyreId = "";
  	    state.pendingTyreAction = null;
  	    state.dragSource = null;
  	    state.tapSource = null;

  	    closeFloatingPopup("allocateTyrePopup");

  	    state.actionMode = "RotateSwap";
  	    state.rotationPopupOpen = false;
  	    closeFloatingPopup("rotationSavePopup");

  	    beginRotationPlan();

  	    state.actionMessage = message || "Allocate finished. Rotate / Swap unlocked. Drag fitted tyres directly on the vehicle layout.";
  	    state.actionError = false;

  	    requestTyreTabRerender();
  	  }

  	  function cancelAllocationPlan(message) {
  	    lockTyreMovementState(message || "Allocation cancelled. Tyre layout reset.");
  	  }

  	  function clearAllocationPendingInsidePopup() {
  	    state.pendingTyreAction = null;
  	    state.dragSource = null;
  	    state.tapSource = null;
  	    state.allocateSelectedTyreId = "";
  	    state.actionMessage = "Pending allocation cleared. Select another warehouse tyre.";
  	    state.actionError = false;

  	    renderVisualTyreOperations();
  	    renderAllocatePopup();
  	  }

  	  function confirmAllocationFromPopup(button) {
  	    var validation = validatePendingStillPossible();

  	    if (!state.pendingTyreAction) {
  	      state.actionMessage = "Select a tyre and target position before confirming allocation.";
  	      state.actionError = true;
  	      renderAllocatePopup();
  	      return;
  	    }

  	    if (!validation.ok) {
  	      state.actionMessage = validation.message;
  	      state.actionError = true;
  	      renderAllocatePopup();
  	      return;
  	    }

  	    if (!confirmSafe("Confirm allocation?\n\n" + pendingActionLabel())) {
  	      return;
  	    }

  	    if (button) {
  	      button.disabled = true;
  	      button.textContent = "Saving...";
  	    }

  	    executePendingTyreAction()
  	    .then(function (message) {
  	      state.pendingTyreAction = null;
  	      state.dragSource = null;
  	      state.tapSource = null;
  	      state.allocateSelectedTyreId = "";

  	      state.actionMode = "Allocate";
  	      state.allocatePopupOpen = true;

  	      state.actionMessage = (message || "Tyre allocated.") + " Continue allocating tyres, or click Done / Rotate-Swap.";
  	      state.actionError = false;

  	      resetDraftTPositions();

  	      renderVisualTyreOperations();
  	      renderList(search.value || "");
  	      renderAllocatePopup();
  	    })
  	    .catch(function (error) {
  	      state.actionMessage = error && error.message ? error.message: "Tyre allocation failed.";
  	      state.actionError = true;

  	      if (button) {
  	        button.disabled = false;
  	        button.textContent = "Confirm Allocation";
  	      }

  	      renderAllocatePopup();
  	    });
  	  }

  	  function setActionMessage(message,
  	    isError) {
  	    state.actionMessage = message || "";
  	    state.actionError = !!isError;
  	  }

  	  function createPendingAction(sourceType,
  	    tyreId,
  	    sourcePosition,
  	    targetPosition) {
  	    var tPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	    var sourceSlot = sourcePosition ? getSlot(tPositions,
  	      sourcePosition): null;
  	    var targetSlot = targetPosition ? getSlot(tPositions,
  	      targetPosition): null;
  	    var tyre = findTyre(tyreId);
  	    var targetTyre = null;
  	    var actionType = "";
  	    var preview = "";
  	    var existingAssignment;

  	    tyreId = clean(tyreId);
  	    sourcePosition = clean(sourcePosition);
  	    targetPosition = clean(targetPosition);

  	    if (!state.activeTractor) {
  	      throw new Error("No tractor selected.");
  	    }

  	    if (!tyreId) {
  	      throw new Error("No tyre selected.");
  	    }

  	    if (!targetPosition || !targetSlot) {
  	      throw new Error("Drop the tyre onto a valid position.");
  	    }

  	    if (!tyre) {
  	      throw new Error("The selected tyre record could not be found.");
  	    }

  	    if (sourceType === "fitted") {
  	      if (!sourcePosition || !sourceSlot) {
  	        throw new Error("The fitted tyre source position could not be found.");
  	      }

  	      if (sourcePosition === targetPosition) {
  	        throw new Error("Source and target positions are the same.");
  	      }

  	      if (!sourceSlot.TyreObjectId || clean(sourceSlot.TyreObjectId) !== tyreId) {
  	        throw new Error("The source position no longer contains this tyre.");
  	      }


  	      if (targetSlot.TyreObjectId) {
  	        targetTyre = findTyre(targetSlot.TyreObjectId);

  	        if (!targetTyre) {
  	          throw new Error("The target position has a tyre ID, but the tyre record could not be found.");
  	        }

  	        actionType = "Swap";
  	        preview = "Swap " + sourcePosition + " with " + targetPosition + ".";
  	      } else {
  	        actionType = "Move";
  	        preview = "Move tyre from " + sourcePosition + " to " + targetPosition + ".";
  	      }

  	      return {
  	        Type: actionType,
  	        SourceType: "fitted",
  	        TyreObjectId: tyreId,
  	        SourcePosition: sourcePosition,
  	        TargetPosition: targetPosition,
  	        Preview: preview,
  	        TyreLabel: tyreName(tyre),
  	        TargetTyreLabel: targetTyre ? tyreName(targetTyre): ""
  	      };
  	    }

  	    if (sourceType === "warehouse") {
  	      if (!isTyreAvailable(tyre)) {
  	        throw new Error("This tyre is not available in warehouse.");
  	      }

  	      existingAssignment = findTyreFleetAssignment(tyreId);

  	      if (existingAssignment) {
  	        throw new Error("This tyre is already allocated to " + existingAssignment.vehicleLabel + " at " + existingAssignment.positionKey + ".");
  	      }

  	      if (targetSlot.TyreObjectId) {
  	        targetTyre = findTyre(targetSlot.TyreObjectId);

  	        if (!targetTyre) {
  	          throw new Error("The target position has a tyre ID, but the tyre record could not be found.");
  	        }

  	        return {
  	          Type: "WarehouseSwap",
  	          SourceType: "warehouse",
  	          TyreObjectId: tyreId,
  	          SourcePosition: "",
  	          TargetPosition: targetPosition,
  	          Preview: "Fit warehouse tyre to " + targetPosition + " and move fitted tyre back to warehouse.",
  	          TyreLabel: tyreName(tyre),
  	          TargetTyreLabel: tyreName(targetTyre)
  	        };
  	      }

  	      return {
  	        Type: "Allocate",
  	        SourceType: "warehouse",
  	        TyreObjectId: tyreId,
  	        SourcePosition: "",
  	        TargetPosition: targetPosition,
  	        Preview: "Allocate warehouse tyre to " + targetPosition + ".",
  	        TyreLabel: tyreName(tyre),
  	        TargetTyreLabel: ""
  	      };
  	    }

  	    throw new Error("Invalid tyre source.");
  	  }

  	  function setPendingActionFromSourceAndTarget(sourceType, tyreId, sourcePosition, targetPosition) {
  	    var tPositions;
  	    var sourceSlot;
  	    var targetSlot;
  	    var sourceTyre;
  	    var targetTyre;
  	    var pending;

  	    try {
  	      tPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	      sourceSlot = sourcePosition ? getSlot(tPositions, sourcePosition): null;
  	      targetSlot = targetPosition ? getSlot(tPositions, targetPosition): null;
  	      sourceTyre = findTyre(tyreId);
  	      targetTyre = targetSlot && targetSlot.TyreObjectId ? findTyre(targetSlot.TyreObjectId): null;

  	      pending = createPendingAction(
  	        sourceType,
  	        tyreId,
  	        sourcePosition,
  	        targetPosition
  	      );

  	      if (sourceTyre && targetSlot && !confirmMismatchIfNeeded(sourceTyre, targetSlot)) {
  	        throw new Error("Tyre mismatch was not approved.");
  	      }

  	      if (
  	        sourceType === "fitted" &&
  	        targetTyre &&
  	        sourceSlot &&
  	        !confirmMismatchIfNeeded(targetTyre, sourceSlot)
  	      ) {
  	        throw new Error("Target tyre mismatch was not approved.");
  	      }

  	      state.pendingTyreAction = pending;
  	      state.selectedPosition = clean(targetPosition);
  	      state.actionMessage = pending.Preview;
  	      state.actionError = false;

  	      return pending;
  	    } catch (error) {
  	      state.pendingTyreAction = null;
  	      state.actionMessage = error && error.message ? error.message: "Tyre action could not be prepared.";
  	      state.actionError = true;

  	      return null;
  	    }
  	  }

  	  function setDragSource(sourceType, tyreId, sourcePosition) {
  	    state.dragSource = {
  	      SourceType: sourceType,
  	      TyreObjectId: clean(tyreId),
  	      SourcePosition: clean(sourcePosition)
  	    };
  	  }

  	  function setTapSource(sourceType, tyreId, sourcePosition) {
  	    state.tapSource = {
  	      SourceType: sourceType,
  	      TyreObjectId: clean(tyreId),
  	      SourcePosition: clean(sourcePosition)
  	    };

  	    state.actionMessage = "Now tap the target tyre position.";
  	    state.actionError = false;
  	  }

  	  function clearTapSource() {
  	    state.tapSource = null;
  	  }

  	  function sourceAllowedForCurrentMode(source) {
  	    if (!source) {
  	      return false;
  	    }

  	    if (state.actionMode === "Allocate") {
  	      return source.SourceType === "warehouse" || source.SourceType === "fitted";
  	    }

  	    if (state.actionMode === "RotateSwap") {
  	      return source.SourceType === "fitted";
  	    }

  	    return false;
  	  }

  	  function handleSlotTarget(positionKey) {
  	    var source = state.tapSource || state.dragSource;
  	    var tPositions = state.actionMode === "RotateSwap"
  	    ? getRotationDraftTPositions(): normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	    var slot = getSlot(tPositions, positionKey);

  	    state.selectedPosition = clean(positionKey);

  	    if (!slot) {
  	      state.actionMessage = "Target position could not be found.";
  	      state.actionError = true;
  	      return null;
  	    }

  	    if (!source) {
  	      if (state.actionMode === "RotateSwap") {
  	        if (!slot.TyreObjectId) {
  	          state.actionMessage = "Tap or drag a fitted tyre first, then choose a target position.";
  	          state.actionError = false;
  	          return null;
  	        }

  	        setTapSource("fitted", slot.TyreObjectId, slot.PositionKey);
  	        state.actionMessage = "Selected " + slot.PositionKey + ". Now tap the target position to move or swap.";
  	        state.actionError = false;
  	        return null;
  	      }

  	      if (state.actionMode === "Allocate") {
  	        if (slot.TyreObjectId) {
  	          setTapSource("fitted", slot.TyreObjectId, slot.PositionKey);
  	          state.actionMessage = "Selected " + slot.PositionKey + ". Now tap another position to move or swap, or select a warehouse tyre.";
  	          state.actionError = false;
  	          return null;
  	        }

  	        state.actionMessage = "Tap or drag a warehouse tyre first, or tap a fitted tyre to move or swap it.";
  	        state.actionError = false;
  	        return null;
  	      }

  	      state.actionMessage = "Select Rotate / Swap or Allocate first.";
  	      state.actionError = false;
  	      return null;
  	    }

  	    if (!sourceAllowedForCurrentMode(source)) {
  	      state.actionMessage = "This tyre action is locked. Select the correct mode first.";
  	      state.actionError = true;
  	      return null;
  	    }

  	    if (state.actionMode === "Allocate") {
  	      applyDraftTyreMove(source, positionKey);

  	      state.pendingTyreAction = null;
  	      state.dragSource = null;
  	      state.tapSource = null;
  	      state.allocatePopupOpen = true;
  	      state.selectedPosition = positionKey;

  	      renderVisualTyreOperations();
  	      renderAllocatePopup();
  	      return;
  	    }

  	    setPendingActionFromSourceAndTarget(
  	      source.SourceType,
  	      source.TyreObjectId,
  	      source.SourcePosition,
  	      positionKey
  	    );

  	    state.dragSource = null;
  	    renderVisualTyreOperations();
  	  }

  	  // ===============================================================
  	  // TYRE OPERATION EXECUTION
  	  // ===============================================================
  	  function allocateWarehouseTyreToPosition(tyreId, targetPosition, odometer, notes) {
  	    var updatedVehicle;
  	    var tPositions;
  	    var targetSlot;
  	    var tyre;
  	    var updatedTyre;
  	    var existingAssignment;

  	    tyreId = clean(tyreId);
  	    targetPosition = clean(targetPosition);
  	    odometer = clean(odometer);
  	    notes = clean(notes);

  	    if (!state.activeTractor) {
  	      return Promise.reject(new Error("No tractor selected."));
  	    }

  	    updatedVehicle = clone(state.activeTractor);
  	    tPositions = normaliseTPositions(readTPositionsRaw(updatedVehicle));
  	    targetSlot = getSlot(tPositions, targetPosition);
  	    tyre = findTyre(tyreId);

  	    if (!targetSlot) {
  	      return Promise.reject(new Error("Target position could not be found."));
  	    }

  	    if (targetSlot.TyreObjectId) {
  	      return Promise.reject(new Error("Target position already has a tyre fitted."));
  	    }

  	    if (!tyre) {
  	      return Promise.reject(new Error("Selected tyre could not be found."));
  	    }

  	    if (!isTyreAvailable(tyre)) {
  	      return Promise.reject(new Error("Selected tyre is not available for allocation."));
  	    }

  	    if (!confirmMismatchIfNeeded(tyre, targetSlot)) {
  	      return Promise.reject(new Error("Tyre mismatch was not approved."));
  	    }

  	    existingAssignment = findTyreFleetAssignment(tyreId);

  	    if (existingAssignment) {
  	      return Promise.reject(new Error("This tyre is already allocated to " + existingAssignment.vehicleLabel + " at " + existingAssignment.positionKey + "."));
  	    }

  	    fitSlot(targetSlot, tyre);
  	    writeTPositionsToVehicle(updatedVehicle, tPositions);

  	    updatedTyre = makeTyreFitted(tyre, targetSlot, odometer, notes, "Installed", "");

  	    appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	      "Installed",
  	      "",
  	      targetSlot.PositionKey,
  	      updatedTyre,
  	      odometer,
  	      notes
  	    ));

  	    return saveTyresSequentially([updatedTyre])
  	    .then(function () {
  	      return saveVehicleWithTPositions(updatedVehicle, tPositions);
  	    })
  	    .then(function () {
  	      state.selectedPosition = targetSlot.PositionKey;
  	      return "Tyre allocated to " + targetSlot.PositionKey + ".";
  	    });
  	  }

  	  function swapWarehouseTyreWithFittedPosition(warehouseTyreId, targetPosition, odometer, notes) {
  	    var updatedVehicle;
  	    var tPositions;
  	    var targetSlot;
  	    var warehouseTyre;
  	    var fittedTyre;
  	    var updatedWarehouseTyre;
  	    var updatedFittedTyre;
  	    var tyresToSave = [];

  	    warehouseTyreId = clean(warehouseTyreId);
  	    targetPosition = clean(targetPosition);
  	    odometer = clean(odometer);
  	    notes = clean(notes);

  	    if (!state.activeTractor) {
  	      return Promise.reject(new Error("No tractor selected."));
  	    }

  	    updatedVehicle = clone(state.activeTractor);
  	    tPositions = normaliseTPositions(readTPositionsRaw(updatedVehicle));
  	    targetSlot = getSlot(tPositions, targetPosition);
  	    warehouseTyre = findTyre(warehouseTyreId);

  	    if (!targetSlot) {
  	      return Promise.reject(new Error("Target position could not be found."));
  	    }

  	    if (!targetSlot.TyreObjectId) {
  	      return allocateWarehouseTyreToPosition(
  	        warehouseTyreId,
  	        targetPosition,
  	        odometer,
  	        notes
  	      );
  	    }

  	    fittedTyre = findTyre(targetSlot.TyreObjectId);

  	    if (!warehouseTyre) {
  	      return Promise.reject(new Error("Warehouse tyre could not be found."));
  	    }

  	    if (!fittedTyre) {
  	      return Promise.reject(new Error("Fitted tyre record could not be found."));
  	    }

  	    if (!isTyreAvailable(warehouseTyre)) {
  	      return Promise.reject(new Error("Selected warehouse tyre is not available."));
  	    }

  	    if (!confirmMismatchIfNeeded(warehouseTyre, targetSlot)) {
  	      return Promise.reject(new Error("Warehouse tyre mismatch was not approved."));
  	    }

  	    updatedFittedTyre = makeTyreRemoved(
  	      fittedTyre,
  	      targetSlot,
  	      "Warehouse",
  	      odometer,
  	      clean(notes + " Swapped out to warehouse.")
  	    );

  	    fitSlot(targetSlot, warehouseTyre);
  	    writeTPositionsToVehicle(updatedVehicle, tPositions);

  	    updatedWarehouseTyre = makeTyreFitted(
  	      warehouseTyre,
  	      targetSlot,
  	      odometer,
  	      clean(notes + " Fitted from warehouse by allocation swap."),
  	      "Installed",
  	      "Warehouse"
  	    );

  	    tyresToSave.push(updatedWarehouseTyre);
  	    tyresToSave.push(updatedFittedTyre);

  	    appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	      "Warehouse Swap",
  	      "Warehouse",
  	      targetSlot.PositionKey,
  	      updatedWarehouseTyre,
  	      odometer,
  	      notes
  	    ));

  	    appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	      "Removed To Warehouse",
  	      targetSlot.PositionKey,
  	      "Warehouse",
  	      updatedFittedTyre,
  	      odometer,
  	      notes
  	    ));

  	    return saveTyresSequentially(tyresToSave)
  	    .then(function () {
  	      return saveVehicleWithTPositions(updatedVehicle, tPositions);
  	    })
  	    .then(function () {
  	      state.selectedPosition = targetSlot.PositionKey;
  	      return "Warehouse tyre fitted to " + targetSlot.PositionKey + ". Fitted tyre moved to warehouse.";
  	    });
  	  }

  	  function moveOrSwapFittedTyre(sourcePosition, targetPosition, odometer, notes) {
  	    var updatedVehicle;
  	    var tPositions;
  	    var sourceSlot;
  	    var targetSlot;
  	    var sourceTyre;
  	    var targetTyre;
  	    var sourceSnapshot;
  	    var targetSnapshot;
  	    var updatedSourceTyre;
  	    var updatedTargetTyre;
  	    var tyresToSave = [];
  	    var movementType;

  	    sourcePosition = clean(sourcePosition);
  	    targetPosition = clean(targetPosition);
  	    odometer = clean(odometer);
  	    notes = clean(notes);

  	    if (!state.activeTractor) {
  	      return Promise.reject(new Error("No tractor selected."));
  	    }

  	    if (!sourcePosition || !targetPosition) {
  	      return Promise.reject(new Error("Source and target positions are required."));
  	    }

  	    if (sourcePosition === targetPosition) {
  	      return Promise.reject(new Error("Source and target positions cannot be the same."));
  	    }

  	    updatedVehicle = clone(state.activeTractor);
  	    tPositions = normaliseTPositions(readTPositionsRaw(updatedVehicle));

  	    sourceSlot = getSlot(tPositions, sourcePosition);
  	    targetSlot = getSlot(tPositions, targetPosition);

  	    if (!sourceSlot || !sourceSlot.TyreObjectId) {
  	      return Promise.reject(new Error("Source position does not have a tyre fitted."));
  	    }

  	    if (!targetSlot) {
  	      return Promise.reject(new Error("Target position could not be found."));
  	    }

  	    sourceTyre = findTyre(sourceSlot.TyreObjectId);
  	    targetTyre = targetSlot.TyreObjectId ? findTyre(targetSlot.TyreObjectId): null;

  	    if (!sourceTyre) {
  	      return Promise.reject(new Error("Source tyre record could not be found."));
  	    }

  	    if (!confirmMismatchIfNeeded(sourceTyre, targetSlot)) {
  	      return Promise.reject(new Error("Source tyre mismatch was not approved."));
  	    }

  	    if (targetTyre && !confirmMismatchIfNeeded(targetTyre, sourceSlot)) {
  	      return Promise.reject(new Error("Target tyre mismatch was not approved."));
  	    }

  	    movementType = targetTyre ? "Swap": "Rotation";

  	    sourceSnapshot = {
  	      TyreObjectId: sourceSlot.TyreObjectId || "",
  	      TyreNumber: sourceSlot.TyreNumber || "",
  	      SerialNumber: sourceSlot.SerialNumber || ""
  	    };

  	    targetSnapshot = {
  	      TyreObjectId: targetSlot.TyreObjectId || "",
  	      TyreNumber: targetSlot.TyreNumber || "",
  	      SerialNumber: targetSlot.SerialNumber || ""
  	    };

  	    copySlotTyre(targetSnapshot, sourceSlot);
  	    copySlotTyre(sourceSnapshot, targetSlot);

  	    updatedSourceTyre = makeTyreMoved(
  	      sourceTyre,
  	      {
  	        PositionKey: sourcePosition, AxleType: sourceSlot.AxleType, WearRate: sourceSlot.WearRate
  	      },
  	      targetSlot,
  	      odometer,
  	      notes,
  	      movementType
  	    );

  	    tyresToSave.push(updatedSourceTyre);

  	    appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	      movementType,
  	      sourcePosition,
  	      targetPosition,
  	      updatedSourceTyre,
  	      odometer,
  	      notes
  	    ));

  	    if (targetTyre) {
  	      updatedTargetTyre = makeTyreMoved(
  	        targetTyre,
  	        {
  	          PositionKey: targetPosition, AxleType: targetSlot.AxleType, WearRate: targetSlot.WearRate
  	        },
  	        sourceSlot,
  	        odometer,
  	        notes,
  	        movementType
  	      );

  	      tyresToSave.push(updatedTargetTyre);

  	      appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	        movementType,
  	        targetPosition,
  	        sourcePosition,
  	        updatedTargetTyre,
  	        odometer,
  	        notes
  	      ));
  	    }

  	    writeTPositionsToVehicle(updatedVehicle, tPositions);

  	    return saveTyresSequentially(tyresToSave)
  	    .then(function () {
  	      return saveVehicleWithTPositions(updatedVehicle, tPositions);
  	    })
  	    .then(function () {
  	      state.selectedPosition = targetPosition;
  	      return targetTyre ? "Tyres swapped.": "Tyre moved to " + targetPosition + ".";
  	    });
  	  }

  	  function removeTyreFromPosition(positionKey, destination, odometer, notes) {
  	    var updatedVehicle;
  	    var tPositions;
  	    var slot;
  	    var tyre;
  	    var updatedTyre;
  	    var fromPosition;

  	    positionKey = clean(positionKey);
  	    destination = clean(destination) || "Warehouse";
  	    odometer = clean(odometer);
  	    notes = clean(notes);

  	    if (!state.activeTractor) {
  	      return Promise.reject(new Error("No tractor selected."));
  	    }

  	    if (!positionKey) {
  	      return Promise.reject(new Error("Select a fitted tyre first."));
  	    }

  	    updatedVehicle = clone(state.activeTractor);
  	    tPositions = normaliseTPositions(readTPositionsRaw(updatedVehicle));
  	    slot = getSlot(tPositions, positionKey);

  	    if (!slot || !slot.TyreObjectId) {
  	      return Promise.reject(new Error("Selected position does not have a tyre fitted."));
  	    }

  	    tyre = findTyre(slot.TyreObjectId);

  	    if (!tyre) {
  	      return Promise.reject(new Error("The fitted tyre record could not be found."));
  	    }

  	    fromPosition = slot.PositionKey;
  	    updatedTyre = makeTyreRemoved(tyre, slot, destination, odometer, notes);

  	    clearSlot(slot);
  	    writeTPositionsToVehicle(updatedVehicle, tPositions);

  	    appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	      "Removed",
  	      fromPosition,
  	      destination,
  	      updatedTyre,
  	      odometer,
  	      notes
  	    ));

  	    return saveTyresSequentially([updatedTyre])
  	    .then(function () {
  	      return saveVehicleWithTPositions(updatedVehicle, tPositions);
  	    })
  	    .then(function () {
  	      state.selectedPosition = fromPosition;
  	      return "Tyre removed.";
  	    });
  	  }

  	  function executePendingTyreAction() {
  	    var pending = state.pendingTyreAction;
  	    var odometer = getUiValue("tyreActionOdometer");
  	    var notes = getUiValue("tyreActionNotes");

  	    if (!pending) {
  	      return Promise.reject(new Error("No pending tyre action to save."));
  	    }

  	    if (pending.Type === "Allocate") {
  	      return allocateWarehouseTyreToPosition(
  	        pending.TyreObjectId,
  	        pending.TargetPosition,
  	        odometer,
  	        notes
  	      );
  	    }

  	    if (pending.Type === "WarehouseSwap") {
  	      return swapWarehouseTyreWithFittedPosition(
  	        pending.TyreObjectId,
  	        pending.TargetPosition,
  	        odometer,
  	        notes
  	      );
  	    }

  	    if (pending.Type === "Move" || pending.Type === "Swap") {
  	      return moveOrSwapFittedTyre(
  	        pending.SourcePosition,
  	        pending.TargetPosition,
  	        odometer,
  	        notes
  	      );
  	    }

  	    return Promise.reject(new Error("Unknown tyre action type."));
  	  }

  	  function executeRemoveFromUi() {
  	    var positionKey = clean(state.selectedPosition);
  	    var destination = getUiValue("tyreActionDestination");
  	    var odometer = getUiValue("tyreActionOdometer");
  	    var notes = getUiValue("tyreActionNotes");

  	    return removeTyreFromPosition(positionKey, destination, odometer, notes);
  	  }

  	  function pendingActionLabel() {
  	    var pending = state.pendingTyreAction;

  	    if (!pending) {
  	      return "";
  	    }

  	    if (pending.Type === "Allocate") {
  	      return "Allocate: " + pending.TyreLabel + " → " + pending.TargetPosition;
  	    }

  	    if (pending.Type === "WarehouseSwap") {
  	      return "Swap From Warehouse: " + pending.TyreLabel + " → " + pending.TargetPosition + " | " + pending.TargetTyreLabel + " → Warehouse";
  	    }

  	    if (pending.Type === "Move") {
  	      return "Move: " + pending.TyreLabel + " from " + pending.SourcePosition + " → " + pending.TargetPosition;
  	    }

  	    if (pending.Type === "Swap") {
  	      return "Swap: " + pending.SourcePosition + " ↔ " + pending.TargetPosition;
  	    }

  	    return pending.Preview || "";
  	  }

  	  function validatePendingStillPossible() {
  	    var pending = state.pendingTyreAction;

  	    if (!pending) {
  	      return {
  	        ok: false,
  	        message: "No pending tyre action."
  	      };
  	    }

  	    try {
  	      createPendingAction(
  	        pending.SourceType,
  	        pending.TyreObjectId,
  	        pending.SourcePosition,
  	        pending.TargetPosition
  	      );

  	      return {
  	        ok: true,
  	        message: ""
  	      };
  	    } catch (error) {
  	      return {
  	        ok: false,
  	        message: error && error.message ? error.message: "Pending action is no longer valid."
  	      };
  	    }
  	  }

  	  function findSlotByTyreId(tPositions, tyreId) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    var keys = Object.keys(positions);
  	    var cleanTyreId = clean(tyreId);
  	    var i;

  	    if (!cleanTyreId) {
  	      return null;
  	    }

  	    for (i = 0; i < keys.length; i++) {
  	      if (clean(positions[keys[i]] && positions[keys[i]].TyreObjectId) === cleanTyreId) {
  	        return positions[keys[i]];
  	      }
  	    }

  	    return null;
  	  }

  	  function resetRotationPlan() {
  	    state.rotationDraftTPositions = null;
  	    state.rotationPlanStartedVehicleId = "";
  	    state.rotationMessage = "";
  	  }

  	  function beginRotationPlan() {
  	    state.rotationDraftTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	    state.rotationPlanStartedVehicleId = vehicleObjectId(state.activeTractor);
  	    state.pendingTyreAction = null;
  	    state.dragSource = null;
  	    state.tapSource = null;
  	    state.rotationMessage = "Rotation planning started. Drag all required tyres, then save once.";

  	    return state.rotationDraftTPositions;
  	  }

  	  function getRotationDraftTPositions() {
  	    var activeVehicleId = vehicleObjectId(state.activeTractor);

  	    if (
  	      state.rotationDraftTPositions &&
  	      state.rotationPlanStartedVehicleId === activeVehicleId
  	    ) {
  	      return state.rotationDraftTPositions;
  	    }

  	    return beginRotationPlan();
  	  }

  	  function getVisualTPositionsForTyreTab(currentVehicle) {
  	    if (state.actionMode === "RotateSwap" || state.actionMode === "Allocate") {
  	      return getRotationDraftTPositions();
  	    }

  	    return normaliseTPositions(readTPositionsRaw(currentVehicle));
  	  }

  	  function getRotationArrows() {
  	    var originalTPositions;
  	    var draftTPositions;
  	    var finalPositions;
  	    var keys;
  	    var arrows = [];

  	    if (!state.activeTractor || state.actionMode !== "RotateSwap") {
  	      return [];
  	    }

  	    originalTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	    draftTPositions = getRotationDraftTPositions();
  	    finalPositions = draftTPositions && draftTPositions.Positions ? draftTPositions.Positions: {};
  	    keys = Object.keys(finalPositions);

  	    keys.forEach(function (key) {
  	      var finalSlot = finalPositions[key];
  	      var tyreId = clean(finalSlot && finalSlot.TyreObjectId);
  	      var originalSlot;
  	      var fromPosition;
  	      var toPosition;
  	      var tyre;

  	      if (!tyreId) {
  	        return;
  	      }

  	      originalSlot = findSlotByTyreId(originalTPositions, tyreId);

  	      if (!originalSlot) {
  	        return;
  	      }

  	      fromPosition = clean(originalSlot.PositionKey);
  	      toPosition = clean(finalSlot.PositionKey || key);

  	      if (!fromPosition || !toPosition || fromPosition === toPosition) {
  	        return;
  	      }

  	      tyre = findTyre(tyreId);

  	      arrows.push({
  	        TyreObjectId: tyreId,
  	        TyreLabel: tyre ? tyreName(tyre): tyreId,
  	        FromPosition: fromPosition,
  	        ToPosition: toPosition
  	      });
  	    });

  	    return arrows;
  	  }

  	  function moveTyreInRotationDraft(sourcePosition,
  	    targetPosition) {
  	    var draft = getRotationDraftTPositions();
  	    var sourceSlot = getSlot(draft,
  	      sourcePosition);
  	    var targetSlot = getSlot(draft,
  	      targetPosition);
  	    var sourceTyre;
  	    var targetTyre;
  	    var sourceSnapshot;
  	    var targetSnapshot;

  	    sourcePosition = clean(sourcePosition);
  	    targetPosition = clean(targetPosition);

  	    if (!sourcePosition || !targetPosition) {
  	      state.actionMessage = "Source and target positions are required.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (sourcePosition === targetPosition) {
  	      state.actionMessage = "Source and target positions are the same.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (!sourceSlot || !sourceSlot.TyreObjectId) {
  	      state.actionMessage = "Source position does not have a fitted tyre.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (!targetSlot) {
  	      state.actionMessage = "Target position could not be found.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    sourceTyre = findTyre(sourceSlot.TyreObjectId);
  	    targetTyre = targetSlot.TyreObjectId ? findTyre(targetSlot.TyreObjectId): null;

  	    if (!sourceTyre) {
  	      state.actionMessage = "Source tyre record could not be found.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (!confirmMismatchIfNeeded(sourceTyre, targetSlot)) {
  	      state.actionMessage = "Source tyre mismatch was not approved.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (targetTyre && !confirmMismatchIfNeeded(targetTyre, sourceSlot)) {
  	      state.actionMessage = "Target tyre mismatch was not approved.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    sourceSnapshot = {
  	      TyreObjectId: sourceSlot.TyreObjectId || "",
  	      TyreNumber: sourceSlot.TyreNumber || "",
  	      SerialNumber: sourceSlot.SerialNumber || ""
  	    };

  	    targetSnapshot = {
  	      TyreObjectId: targetSlot.TyreObjectId || "",
  	      TyreNumber: targetSlot.TyreNumber || "",
  	      SerialNumber: targetSlot.SerialNumber || ""
  	    };

  	    copySlotTyre(targetSnapshot, sourceSlot);
  	    copySlotTyre(sourceSnapshot, targetSlot);

  	    draft.Summary = summaryForTPositions(draft);

  	    state.selectedPosition = targetPosition;
  	    state.actionMessage = targetTyre
  	    ? "Planned swap: " + sourcePosition + " ↔ " + targetPosition + ".": "Planned rotation: " + sourcePosition + " → " + targetPosition + ".";
  	    state.actionError = false;

  	    return true;
  	  }

  	  function draftAssignedTyreIds() {
  	    var draft = getRotationDraftTPositions();

  	    return assignedTyreIds(draft);
  	  }

  	  function warehouseTyreAlreadyInDraft(tyreId) {
  	    return draftAssignedTyreIds().indexOf(clean(tyreId)) !== -1;
  	  }

  	  function planWarehouseTyreIntoDraft(tyreId, targetPosition) {
  	    var draft = getRotationDraftTPositions();
  	    var targetSlot = getSlot(draft, targetPosition);
  	    var tyre = findTyre(tyreId);

  	    tyreId = clean(tyreId);
  	    targetPosition = clean(targetPosition);

  	    if (!tyreId || !tyre) {
  	      state.actionMessage = "Warehouse tyre could not be found.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (!targetSlot) {
  	      state.actionMessage = "Target position could not be found.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (!isTyreAvailable(tyre)) {
  	      state.actionMessage = "Selected warehouse tyre is not available.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (warehouseTyreAlreadyInDraft(tyreId)) {
  	      state.actionMessage = "This warehouse tyre is already in the current plan.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (!confirmMismatchIfNeeded(tyre, targetSlot)) {
  	      state.actionMessage = "Tyre mismatch was not approved.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    fitSlot(targetSlot, tyre);

  	    draft.Summary = summaryForTPositions(draft);

  	    state.selectedPosition = targetPosition;
  	    state.actionMessage = "Planned allocation: " + tyreName(tyre) + " → " + targetPosition + ".";
  	    state.actionError = false;

  	    return true;
  	  }

  	  function applyDraftTyreMove(source, targetPosition) {
  	    if (!source) {
  	      state.actionMessage = "No tyre source found.";
  	      state.actionError = true;
  	      return false;
  	    }

  	    if (source.SourceType === "warehouse") {
  	      return planWarehouseTyreIntoDraft(
  	        source.TyreObjectId,
  	        targetPosition
  	      );
  	    }

  	    if (source.SourceType === "fitted") {
  	      return moveTyreInRotationDraft(
  	        source.SourcePosition,
  	        targetPosition
  	      );
  	    }

  	    state.actionMessage = "Invalid tyre source.";
  	    state.actionError = true;
  	    return false;
  	  }

  	  function getAllocationPlanRows() {
  	    var originalTPositions;
  	    var draftTPositions;
  	    var originalPositions;
  	    var finalPositions;
  	    var rows = [];
  	    var seenOriginalTyres = {};
  	    var finalKeys;
  	    var originalKeys;

  	    if (!state.activeTractor) {
  	      return [];
  	    }

  	    originalTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	    draftTPositions = getRotationDraftTPositions();

  	    originalPositions = originalTPositions && originalTPositions.Positions ? originalTPositions.Positions: {};
  	    finalPositions = draftTPositions && draftTPositions.Positions ? draftTPositions.Positions: {};

  	    finalKeys = Object.keys(finalPositions);
  	    originalKeys = Object.keys(originalPositions);

  	    finalKeys.forEach(function (key) {
  	      var finalSlot = finalPositions[key];
  	      var tyreId = clean(finalSlot && finalSlot.TyreObjectId);
  	      var originalSlot;
  	      var tyre;

  	      if (!tyreId) {
  	        return;
  	      }

  	      tyre = findTyre(tyreId);
  	      originalSlot = findSlotByTyreId(originalTPositions, tyreId);

  	      if (originalSlot) {
  	        seenOriginalTyres[tyreId] = true;

  	        if (clean(originalSlot.PositionKey) !== clean(finalSlot.PositionKey || key)) {
  	          rows.push({
  	            Type: "Move",
  	            TyreObjectId: tyreId,
  	            TyreLabel: tyre ? tyreName(tyre): tyreId,
  	            FromPosition: clean(originalSlot.PositionKey),
  	            ToPosition: clean(finalSlot.PositionKey || key),
  	            FromLabel: clean(originalSlot.PositionKey),
  	            ToLabel: clean(finalSlot.PositionKey || key)
  	          });
  	        }

  	        return;
  	      }

  	      rows.push({
  	        Type: "Allocate",
  	        TyreObjectId: tyreId,
  	        TyreLabel: tyre ? tyreName(tyre): tyreId,
  	        FromPosition: "",
  	        ToPosition: clean(finalSlot.PositionKey || key),
  	        FromLabel: "Warehouse",
  	        ToLabel: clean(finalSlot.PositionKey || key)
  	      });
  	    });

  	    originalKeys.forEach(function (key) {
  	      var originalSlot = originalPositions[key];
  	      var tyreId = clean(originalSlot && originalSlot.TyreObjectId);
  	      var finalSlot;
  	      var tyre;

  	      if (!tyreId || seenOriginalTyres[tyreId]) {
  	        return;
  	      }

  	      finalSlot = findSlotByTyreId(draftTPositions, tyreId);

  	      if (finalSlot) {
  	        return;
  	      }

  	      tyre = findTyre(tyreId);

  	      rows.push({
  	        Type: "RemoveToWarehouse",
  	        TyreObjectId: tyreId,
  	        TyreLabel: tyre ? tyreName(tyre): tyreId,
  	        FromPosition: clean(originalSlot.PositionKey || key),
  	        ToPosition: "",
  	        FromLabel: clean(originalSlot.PositionKey || key),
  	        ToLabel: "Warehouse"
  	      });
  	    });

  	    return rows;
  	  }

  	  function allocationPlanHtml() {
  	    var rows = getAllocationPlanRows();

  	    if (!rows.length) {
  	      return ""
  	      + "<div style=\"border:1px solid #333;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	      + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Planned Tyre Changes</div>"
  	      + "  <div style=\"padding:11px 12px;color:#777;font-size:12px;line-height:1.45;\">"
  	      + "Drag tyres around the vehicle or drag warehouse tyres onto positions. Changes will appear here and will only be saved when you press Save All Changes."
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    return ""
  	    + "<div style=\"border:1px solid #2a8f3a;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	    + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Planned Tyre Changes</div>"
  	    + "  <div style=\"padding:10px 12px;max-height:170px;overflow:auto;\">"
  	    + rows.map(function (row, index) {
  	      return ""
  	      + "    <div style=\"display:grid;grid-template-columns:28px 1fr;gap:8px;align-items:start;border-bottom:1px solid #242424;padding:7px 0;\">"
  	      + "      <div style=\"color:#777;font-weight:900;\">" + escapeHtml(index + 1) + "</div>"
  	      + "      <div>"
  	      + "        <div style=\"color:#fff;font-weight:900;font-size:12px;\">" + escapeHtml(row.TyreLabel) + "</div>"
  	      + "        <div style=\"color:#aaa;font-size:12px;\">" + escapeHtml(row.Type) + ": " + escapeHtml(row.FromLabel) + " → " + escapeHtml(row.ToLabel) + "</div>"
  	      + "      </div>"
  	      + "    </div>";
  	    }).join("")
  	    + "  </div>"
  	    + "  <div style=\"padding:11px 12px;border-top:1px solid #242424;\">"
  	    + "    <div style=\"margin-bottom:10px;\">"
  	    + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	    + "      <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	    + "    </div>"
  	    + "    <div style=\"margin-bottom:12px;\">"
  	    + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	    + "      <textarea id=\"tyreActionNotes\" placeholder=\"Notes for all planned tyre changes\" style=\"width:100%;box-sizing:border-box;min-height:58px;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	    + "    </div>"
  	    + "    <div style=\"display:flex;gap:8px;flex-wrap:wrap;\">"
  	    + "      <button id=\"allocateSavePlanBtn\" type=\"button\" style=\"background:#2a8f3a;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Save All Changes</button>"
  	    + "      <button id=\"allocateClearPlanBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Clear Plan</button>"
  	    + "      <button id=\"allocateDoneRotateBtn\" type=\"button\" style=\"background:#CC6633;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;margin-left:auto;\">Done / Rotate-Swap</button>"
  	    + "    </div>"
  	    + "  </div>"
  	    + "</div>";
  	  }

  	  function allocationPlanInlineStatusHtml() {
  	    var rows = getAllocationPlanRows();

  	    if (!rows.length) {
  	      return ""
  	      + "<div style=\"border:1px solid #333;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	      + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Allocation Plan</div>"
  	      + "  <div style=\"padding:11px 12px;color:#777;font-size:12px;line-height:1.45;\">"
  	      + "Drag warehouse tyres onto positions, or move fitted tyres around the vehicle. Press Complete Allocation when the plan is ready."
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    return ""
  	    + "<div style=\"border:1px solid #2a8f3a;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	    + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Allocation Plan</div>"
  	    + "  <div style=\"padding:11px 12px;color:#ddd;font-size:12px;line-height:1.45;\">"
  	    + "    <b style=\"color:#fff;\">" + escapeHtml(rows.length) + "</b> unsaved tyre change" + (rows.length === 1 ? "": "s") + " planned. Press <b style=\"color:#a7d8aa;\">Complete Allocation</b> to review and save."
  	    + "  </div>"
  	    + "</div>";
  	  }

  	  function allocationPlanPopupRowsHtml(rows) {
  	    if (!rows.length) {
  	      return "<div style=\"color:#777;border:1px dashed #444;border-radius:8px;padding:12px;\">No planned tyre changes.</div>";
  	    }

  	    return rows.map(function (row, index) {
  	      return ""
  	      + "<div style=\"display:grid;grid-template-columns:34px 1fr;gap:10px;align-items:start;border-bottom:1px solid #252525;padding:9px 0;\">"
  	      + "  <div style=\"color:#aaa;font-weight:900;font-size:16px;text-align:center;\">" + escapeHtml(index + 1) + "</div>"
  	      + "  <div>"
  	      + "    <div style=\"color:#fff;font-weight:900;font-size:13px;line-height:1.3;\">" + escapeHtml(row.TyreLabel) + "</div>"
  	      + "    <div style=\"color:#aaa;font-size:12px;line-height:1.4;margin-top:2px;\">" + escapeHtml(row.Type) + ": " + escapeHtml(row.FromLabel) + " → " + escapeHtml(row.ToLabel) + "</div>"
  	      + "  </div>"
  	      + "</div>";
  	    }).join("");
  	  }

  	  function floatingPopupShellHtml(id, title, innerHtml, width) {
  	    return ""
  	    + "<div id=\"" + escapeHtml(id) + "\" style=\""
  	    + "position:fixed;"
  	    + "top:50%;"
  	    + "left:50%;"
  	    + "transform:translate(-50%,-50%);"
  	    + "width:" + escapeHtml(width || "720px") + ";"
  	    + "max-width:calc(100vw - 40px);"
  	    + "max-height:calc(100vh - 80px);"
  	    + "z-index:3000;"
  	    + "background:#101010;"
  	    + "border:1px solid #333;"
  	    + "border-radius:10px;"
  	    + "box-shadow:0 20px 60px rgba(0,0,0,0.78);"
  	    + "overflow:hidden;"
  	    + "font-family:system-ui,sans-serif;"
  	    + "color:#fff;"
  	    + "\">"
  	    + "  <div style=\"display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;border-bottom:1px solid #333;background:#181818;\">"
  	    + "    <div style=\"color:#CC6633;font-size:15px;font-weight:900;\">" + escapeHtml(title) + "</div>"
  	    + "    <button type=\"button\" data-popup-close=\"" + escapeHtml(id) + "\" style=\"background:#555;color:#fff;border:none;border-radius:7px;padding:6px 10px;cursor:pointer;font-weight:900;\">✕</button>"
  	    + "  </div>"
  	    + "  <div style=\"padding:12px;overflow:auto;max-height:calc(100vh - 145px);\">"
  	    + innerHtml
  	    + "  </div>"
  	    + "</div>";
  	  }

  	  function allocationReportRowsHtml(rows) {
  	    if (!rows.length) {
  	      return "<tr><td colspan=\"6\">No planned tyre changes.</td></tr>";
  	    }

  	    return rows.map(function (row) {
  	      var tyre = findTyre(row.TyreObjectId);
  	      var toSlot = null;
  	      var requiredType = "—";
  	      var actualType = tyre ? tyreType(tyre) || "—": "—";
  	      var mismatch = "No";

  	      try {
  	        if (row.ToPosition) {
  	          toSlot = getSlot(getRotationDraftTPositions(), row.ToPosition);
  	        }

  	        if (toSlot) {
  	          requiredType = requiredTyreTypeForSlot(toSlot);

  	          if (actualType !== "—" && requiredType && actualType !== requiredType) {
  	            mismatch = "Accepted / To be recorded";
  	          }
  	        }
  	      } catch (error) {
  	        console.warn("TRAC-MAN: allocation report mismatch check failed", error);
  	      }

  	      return ""
  	      + "<tr>"
  	      + "  <td>" + escapeHtml(row.Type || "Change") + "</td>"
  	      + "  <td>" + escapeHtml(row.FromLabel || row.FromPosition || "Warehouse") + "</td>"
  	      + "  <td>" + escapeHtml(row.ToLabel || row.ToPosition || "Warehouse") + "</td>"
  	      + "  <td>" + escapeHtml(row.TyreLabel || (tyre ? tyreName(tyre): "Tyre")) + "</td>"
  	      + "  <td>" + escapeHtml(actualType) + " / " + escapeHtml(requiredType) + "</td>"
  	      + "  <td>" + escapeHtml(mismatch) + "</td>"
  	      + "</tr>";
  	    }).join("");
  	  }

  	  function allocationReportHtml(rows,
  	    odometer,
  	    notes) {
  	    var currentVehicle = state.activeTractor || {};
  	    var generatedAt = new Date().toLocaleString();
  	    var logoHtml = reportLogoHtml();

  	    return ""
  	    + "<div style=\"font-family:Arial,sans-serif;color:#111;padding:20px 22px;\">"
  	    + "  <div style=\"display:flex;justify-content:space-between;align-items:flex-start;gap:18px;border-bottom:2px solid #CC6633;padding-bottom:10px;margin-bottom:14px;\">"
  	    + "    <div>"
  	    + "      <h2 style=\"margin:0 0 5px;font-size:22px;color:#111;\">Tyre Allocation Report</h2>"
  	    + "      <div style=\"font-size:12px;color:#555;\">Generated: " + escapeHtml(generatedAt) + "</div>"
  	    + "      <div style=\"font-size:12px;color:#777;margin-top:2px;\">Allocation Plan Report</div>"
  	    + "    </div>"
  	    + "    <div style=\"min-width:160px;text-align:right;display:flex;justify-content:flex-end;align-items:flex-start;\">"
  	    + (logoHtml || "<div style=\"font-size:12px;color:#555;\">Tractor Manager</div>")
  	    + "    </div>"
  	    + "  </div>"

  	    + "  <table style=\"width:100%;border-collapse:collapse;margin-bottom:14px;font-size:12px;\">"
  	    + "    <tbody>"
  	    + "      <tr><th style=\"width:170px;text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Vehicle</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(vehicleTitle(currentVehicle)) + "</td></tr>"
  	    + "      <tr><th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Vehicle ID</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(vehicleId(currentVehicle) || "—") + "</td></tr>"
  	    + "      <tr><th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Registration</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(vehicleReg(currentVehicle) || "—") + "</td></tr>"
  	    + "      <tr><th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Odometer</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(odometer || "—") + " km</td></tr>"
  	    + "      <tr><th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Notes</th><td style=\"border:1px solid #bbb;padding:6px;\">" + escapeHtml(notes || "") + "</td></tr>"
  	    + "    </tbody>"
  	    + "  </table>"

  	    + "  <h3 style=\"margin:12px 0 7px;font-size:15px;\">Planned Tyre Changes</h3>"
  	    + "  <table style=\"width:100%;border-collapse:collapse;font-size:12px;\">"
  	    + "    <thead>"
  	    + "      <tr>"
  	    + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Action</th>"
  	    + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">From</th>"
  	    + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">To</th>"
  	    + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Tyre</th>"
  	    + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Actual / Required Type</th>"
  	    + "        <th style=\"text-align:left;border:1px solid #bbb;background:#eee;padding:6px;\">Mismatch</th>"
  	    + "      </tr>"
  	    + "    </thead>"
  	    + "    <tbody>"
  	    + allocationReportRowsHtml(rows)
  	    + "    </tbody>"
  	    + "  </table>"

  	    + "  <div style=\"display:flex;justify-content:space-between;margin-top:28px;font-size:12px;color:#444;\">"
  	    + "    <div>Captured By: ______________________________</div>"
  	    + "    <div>Checked By: ______________________________</div>"
  	    + "  </div>"
  	    + "</div>";
  	  }

  	  function printHtmlInHiddenFrame(title,
  	    html) {
  	    var frame;
  	    var doc;

  	    if (!DocumentSafe || !DocumentSafe.body) {
  	      alertSafe("Printing is unavailable in this browser.");
  	      return;
  	    }

  	    frame = DocumentSafe.createElement("iframe");

  	    frame.style.position = "fixed";
  	    frame.style.right = "0";
  	    frame.style.bottom = "0";
  	    frame.style.width = "0";
  	    frame.style.height = "0";
  	    frame.style.border = "0";
  	    frame.style.opacity = "0";
  	    frame.style.pointerEvents = "none";

  	    DocumentSafe.body.appendChild(frame);

  	    doc = frame.contentWindow.document;
  	    doc.open();
  	    doc.write("<!doctype html>");
  	    doc.write("<html><head><meta charset=\"utf-8\"><title>" + escapeHtml(title) + "</title>");
  	    doc.write("<style>");
  	    doc.write("@page{size:A4 landscape;margin:10mm;}");
  	    doc.write("html,body{margin:0;padding:0;background:#fff;color:#000;font-family:Arial,sans-serif;}");
  	    doc.write("*{box-sizing:border-box;}");
  	    doc.write("table{width:100%;border-collapse:collapse;page-break-inside:auto;}");
  	    doc.write("tr{page-break-inside:avoid;page-break-after:auto;}");
  	    doc.write("th,td{vertical-align:top;}");
  	    doc.write("h2,h3{page-break-after:avoid;}");
  	    doc.write("</style>");
  	    doc.write("</head><body>");
  	    doc.write(html);
  	    doc.write("</body></html>");
  	    doc.close();

  	    setTimeout(function () {
  	      try {
  	        frame.contentWindow.focus();
  	        frame.contentWindow.print();

  	        setTimeout(function () {
  	          if (frame && frame.parentNode) {
  	            frame.parentNode.removeChild(frame);
  	          }
  	        },
  	          1000);
  	      } catch (error) {
  	        console.warn("TRAC-MAN: allocation report print failed",
  	          error);
  	        alertSafe("Could not print the allocation report.");
  	      }
  	    }, 250);
  	  }

  	  function printAllocationPlanReportFromPopup() {
  	    var rows = getAllocationPlanRows();
  	    var odometerInput = DocumentSafe.getElementById("tyreActionOdometer");
  	    var notesInput = DocumentSafe.getElementById("tyreActionNotes");
  	    var odometer = odometerInput ? clean(odometerInput.value): "";
  	    var notes = notesInput ? notesInput.value: "";

  	    if (!rows.length) {
  	      alertSafe("No allocation changes to print.");
  	      return;
  	    }

  	    printHtmlInHiddenFrame(
  	      "Tyre Allocation Report",
  	      allocationReportHtml(rows, odometer, notes)
  	    );
  	  }

  	  function updateAllocationPlanSaveVisibility(popup) {
  	    var saveBtn = popup ? popup.querySelector("#allocationPlanSaveBtn"): null;
  	    var odometerInput = popup ? popup.querySelector("#tyreActionOdometer"): null;
  	    var odometer = odometerInput ? numberOrNull(odometerInput.value): null;

  	    if (!saveBtn) {
  	      return;
  	    }

  	    saveBtn.style.display = odometer !== null ? "inline-flex": "none";
  	  }

  	  function popupMileageHasValue(popup) {
  	    var input = popup ? popup.querySelector("#tyreActionOdometer"): null;
  	    var value = input ? numberOrNull(input.value): null;

  	    return value !== null;
  	  }

  	  function updatePopupSaveVisibility(popup, saveButtonId) {
  	    var saveBtn = popup ? popup.querySelector("#" + saveButtonId): null;

  	    if (!saveBtn) {
  	      return;
  	    }

  	    saveBtn.style.display = popupMileageHasValue(popup) ? "inline-flex": "none";
  	  }

  	  function renderAllocationPlanPopup() {
  	    var rows = getAllocationPlanRows();
  	    var html;
  	    var popup;

  	    closeFloatingPopup("allocationPlanPopup");

  	    if (!rows.length) {
  	      alertSafe("No tyre changes have been planned yet.");
  	      return;
  	    }

  	    html = ""
  	    + "<div style=\"display:flex;flex-direction:column;gap:12px;\">"

  	    + "  <div style=\"border:1px solid #2a8f3a;background:#101010;border-radius:8px;overflow:hidden;\">"
  	    + "    <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Planned Tyre Changes</div>"
  	    + "    <div style=\"padding:10px 12px;max-height:240px;overflow:auto;\">"
  	    + allocationPlanPopupRowsHtml(rows)
  	    + "    </div>"
  	    + "  </div>"

  	    + "  <div style=\"border:1px solid #333;background:#101010;border-radius:8px;padding:12px;\">"
  	    + "    <div style=\"margin-bottom:10px;\">"
  	    + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	    + "      <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	    + "    </div>"
  	    + "    <div style=\"margin-bottom:12px;\">"
  	    + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	    + "      <textarea id=\"tyreActionNotes\" placeholder=\"Notes for all planned tyre changes\" style=\"width:100%;box-sizing:border-box;min-height:72px;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	    + "    </div>"
  	    + "    <div style=\"display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;align-items:center;\">"
  	    + "      <button id=\"allocationPlanPrintBtn\" type=\"button\" style=\"background:#374151;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;margin-right:auto;display:inline-flex;align-items:center;gap:6px;\">🖨 Print Report</button>"
  	    + "      <button id=\"allocationPlanSaveBtn\" type=\"button\" style=\"display:none;background:#2a8f3a;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Save All Changes</button>"
  	    + "      <button id=\"allocationPlanCancelBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Cancel</button>"
  	    + "    </div>"
  	    + "  </div>"

  	    + "</div>";

  	    if (!DocumentSafe || !DocumentSafe.body) {
  	      return;
  	    }

  	    DocumentSafe.body.insertAdjacentHTML(
  	      "beforeend",
  	      floatingPopupShellHtml("allocationPlanPopup", "Complete Allocation", html, "720px")
  	    );

  	    popup = DocumentSafe.getElementById("allocationPlanPopup");

  	    if (!popup) {
  	      return;
  	    }

  	    wireAllocationPlanPopupEvents(popup);
  	  }

  	  function wireAllocationPlanPopupEvents(popup) {
  	    var saveBtn = popup.querySelector("#allocationPlanSaveBtn");
  	    var printBtn = popup.querySelector("#allocationPlanPrintBtn");
  	    var cancelBtn = popup.querySelector("#allocationPlanCancelBtn");
  	    var odometerInput = popup.querySelector("#tyreActionOdometer");
  	    var closeButtons = popup.querySelectorAll("[data-popup-close=\"allocationPlanPopup\"]");

  	    function refreshSaveButton() {
  	      var value = odometerInput ? numberOrNull(odometerInput.value): null;

  	      if (!saveBtn) {
  	        return;
  	      }

  	      saveBtn.style.display = value !== null ? "inline-flex": "none";
  	    }

  	    refreshSaveButton();

  	    if (odometerInput) {
  	      odometerInput.oninput = refreshSaveButton;
  	      odometerInput.onchange = refreshSaveButton;
  	    }

  	    if (printBtn) {
  	      printBtn.onclick = function () {
  	        if (typeof printAllocationPlanReportFromPopup === "function") {
  	          printAllocationPlanReportFromPopup();
  	          return;
  	        }

  	        alertSafe("Allocation report print function is not installed yet.");
  	      };
  	    }

  	    if (saveBtn) {
  	      saveBtn.onclick = function () {
  	        saveAllocationPlanFromUi(saveBtn)
  	        .then(function () {
  	          closeFloatingPopup("allocationPlanPopup");
  	          lockTyreMovementState(state.actionMessage || "Allocation complete. Tyre movement locked.");
  	        })
  	        .catch(function (error) {
  	          state.actionMessage = error && error.message ? error.message: "Could not save allocation plan.";
  	          state.actionError = true;

  	          if (saveBtn) {
  	            saveBtn.disabled = false;
  	            saveBtn.textContent = "Save All Changes";
  	            refreshSaveButton();
  	          }

  	          requestTyreTabRerender();
  	        });
  	      };
  	    }

  	        if (cancelBtn) {
  	      cancelBtn.onclick = function (event) {
  	        if (event && event.preventDefault) {
  	          event.preventDefault();
  	        }

  	        if (event && event.stopPropagation) {
  	          event.stopPropagation();
  	        }

  	        if (!confirmSafe("Cancel this allocation plan and reset the tyre layout?")) {
  	          return;
  	        }

  	        lockTyreMovementState("Allocation cancelled. Tyre layout reset.");
  	      };
  	    }

  	        Array.prototype.forEach.call(closeButtons, function (button) {
  	      button.onclick = function (event) {
  	        if (event && event.preventDefault) {
  	          event.preventDefault();
  	        }

  	        if (event && event.stopPropagation) {
  	          event.stopPropagation();
  	        }

  	        if (!confirmSafe("Cancel this allocation plan and reset the tyre layout?")) {
  	          return;
  	        }

  	        lockTyreMovementState("Allocation cancelled. Tyre layout reset.");
  	      };
  	    });
  	  }

  	  function saveRotationPlanFromUi() {
  	    var odometer = getUiValue("tyreActionOdometer");
  	    var notes = getUiValue("tyreActionNotes");
  	    var arrows = getRotationArrows();
  	    var updatedVehicle;
  	    var originalTPositions;
  	    var finalTPositions;
  	    var tyresToSave = [];

  	    if (!arrows.length) {
  	      return Promise.reject(new Error("No tyre rotation changes to save."));
  	    }

  	    updatedVehicle = clone(state.activeTractor);
  	    originalTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	    finalTPositions = clone(getRotationDraftTPositions());

  	    arrows.forEach(function (arrow) {
  	      var tyre = findTyre(arrow.TyreObjectId);
  	      var originalSlot = getSlot(originalTPositions, arrow.FromPosition);
  	      var finalSlot = getSlot(finalTPositions, arrow.ToPosition);
  	      var updatedTyre;

  	      if (!tyre || !originalSlot || !finalSlot) {
  	        throw new Error("Rotation plan contains a tyre or position that could not be found.");
  	      }

  	      if (!confirmMismatchIfNeeded(tyre, finalSlot)) {
  	        throw new Error("Tyre mismatch was not approved for " + arrow.FromPosition + " to " + arrow.ToPosition + ".");
  	      }

  	      updatedTyre = makeTyreMoved(
  	        tyre,
  	        originalSlot,
  	        finalSlot,
  	        odometer,
  	        notes,
  	        "Rotation"
  	      );

  	      tyresToSave.push(updatedTyre);

  	      appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	        "Rotation",
  	        arrow.FromPosition,
  	        arrow.ToPosition,
  	        updatedTyre,
  	        odometer,
  	        notes
  	      ));
  	    });

  	    writeTPositionsToVehicle(updatedVehicle,
  	      finalTPositions);

  	    return saveTyresSequentially(tyresToSave)
  	    .then(function () {
  	      return saveVehicleWithTPositions(updatedVehicle, finalTPositions);
  	    })
  	    .then(function () {
  	      state.selectedPosition = arrows[arrows.length - 1].ToPosition;
  	      resetRotationPlan();

  	      return "Rotation plan saved for " + arrows.length + " tyre movement" + (arrows.length === 1 ? ".": "s.");
  	    });
  	  }

  	  function saveAllocationPlanFromUi(button) {
  	    var odometer = getUiValue("tyreActionOdometer");
  	    var notes = getUiValue("tyreActionNotes");
  	    var rows = getAllocationPlanRows();
  	    var updatedVehicle;
  	    var originalTPositions;
  	    var finalTPositions;
  	    var tyresToSave = [];
  	    var savedTyreIds = {};

  	    if (!rows.length) {
  	      return Promise.reject(new Error("No tyre changes to save."));
  	    }

  	    if (odometer === "") {
  	      return Promise.reject(new Error("Enter the vehicle odometer before saving tyre changes."));
  	    }

  	    updatedVehicle = clone(state.activeTractor);
  	    originalTPositions = normaliseTPositions(readTPositionsRaw(state.activeTractor));
  	    finalTPositions = clone(getRotationDraftTPositions());

  	    rows.forEach(function (row) {
  	      var tyre = findTyre(row.TyreObjectId);
  	      var fromSlot = row.FromPosition ? getSlot(originalTPositions, row.FromPosition): null;
  	      var toSlot = row.ToPosition ? getSlot(finalTPositions, row.ToPosition): null;
  	      var updatedTyre;

  	      if (!tyre || savedTyreIds[row.TyreObjectId]) {
  	        return;
  	      }

  	      if (row.Type === "Allocate") {
  	        if (!toSlot) {
  	          throw new Error("Target slot could not be found for " + row.TyreLabel + ".");
  	        }

  	        updatedTyre = makeTyreFitted(
  	          tyre,
  	          toSlot,
  	          odometer,
  	          notes,
  	          "Installed",
  	          "Warehouse"
  	        );

  	        appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	          "Installed",
  	          "Warehouse",
  	          toSlot.PositionKey,
  	          updatedTyre,
  	          odometer,
  	          notes
  	        ));
  	      }

  	      if (row.Type === "Move") {
  	        if (!fromSlot || !toSlot) {
  	          throw new Error("Move slot could not be found for " + row.TyreLabel + ".");
  	        }

  	        updatedTyre = makeTyreMoved(
  	          tyre,
  	          fromSlot,
  	          toSlot,
  	          odometer,
  	          notes,
  	          "Rotation"
  	        );

  	        appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	          "Rotation",
  	          fromSlot.PositionKey,
  	          toSlot.PositionKey,
  	          updatedTyre,
  	          odometer,
  	          notes
  	        ));
  	      }

  	      if (row.Type === "RemoveToWarehouse") {
  	        if (!fromSlot) {
  	          throw new Error("Remove slot could not be found for " + row.TyreLabel + ".");
  	        }

  	        updatedTyre = makeTyreRemoved(
  	          tyre,
  	          fromSlot,
  	          "Warehouse",
  	          odometer,
  	          notes
  	        );

  	        appendTyreMovementRecord(updatedVehicle, tyreMovementRecord(
  	          "Removed To Warehouse",
  	          fromSlot.PositionKey,
  	          "Warehouse",
  	          updatedTyre,
  	          odometer,
  	          notes
  	        ));
  	      }

  	      if (updatedTyre) {
  	        tyresToSave.push(updatedTyre);
  	        savedTyreIds[row.TyreObjectId] = true;
  	      }
  	    });

  	    writeTPositionsToVehicle(updatedVehicle,
  	      finalTPositions);

  	    if (button) {
  	      button.disabled = true;
  	      button.textContent = "Saving...";
  	    }

  	    return saveTyresSequentially(tyresToSave)
  	    .then(function () {
  	      return saveVehicleWithTPositions(updatedVehicle, finalTPositions);
  	    })
  	    .then(function () {
  	      state.selectedPosition = rows[rows.length - 1].ToPosition || rows[rows.length - 1].FromPosition || state.selectedPosition;

  	      lockTyreMovementState(
  	        "Saved " + rows.length + " tyre change" + (rows.length === 1 ? ".": "s.") + " Tyre movement locked."
  	      );

  	      if (typeof renderList === "function") {
  	        renderList(search && search.value ? search.value: "");
  	      }

  	      return state.actionMessage;
  	    });
  	  }

  	  // ===============================================================
  	  // CLEAN EXISTING PANELS
  	  // ===============================================================
  	  function removeExistingPanels() {
  	    var oldList = hubEl.querySelector("#tractorListPanel");
  	    var oldEditor = hubEl.querySelector("#tractorEditorPanel");

  	    if (oldList) {
  	      oldList.remove();
  	    }

  	    if (oldEditor) {
  	      oldEditor.remove();
  	    }
  	  }

  	  removeExistingPanels();

  	  // ===============================================================
  	  // STATE
  	  // ===============================================================
  	  var state = {
  	    tractorArray: Tractors,
  	    tyreArray: collectTyres(),
  	    tyresLoaded: false,
  	    tyresLoading: null,

  	    editMode: false,
  	    activeTab: "Vehicle",
  	    activeTractor: null,

  	    tyrePositionsDraft: null,
  	    tyrePositionsDraftTractorId: "",

  	    selectedPosition: "",
  	    actionMode: "",
  	    actionMessage: "",
  	    actionError: false,

  	    pendingTyreAction: null,
  	    dragSource: null,
  	    tapSource: null,

  	    rotationDraftTPositions: null,
  	    rotationPlanStartedVehicleId: "",
  	    rotationMessage: "",

  	    allocatePopupOpen: false,
  	    allocateSearch: "",
  	    allocateTypeFilter: "",
  	    allocateSelectedTyreId: "",

  	    mismatchApprovals: {},
  	    rotationPopupOpen: false
  	  };

  	  // ===============================================================
  	  // LIST PANEL
  	  // ===============================================================
  	  var listPanel = DocumentSafe.createElement("div");
  	  listPanel.id = "tractorListPanel";

  	  Object.assign(listPanel.style, {
  	    position: "absolute",
  	    top: "50px",
  	    right: "0",
  	    width: "240px",
  	    bottom: "0",
  	    background: "rgba(20,20,20,0.96)",
  	    color: "#fff",
  	    zIndex: 900,
  	    overflowY: "auto",
  	    borderLeft: "2px solid #CC6633",
  	    boxShadow: "-2px 0 10px rgba(0,0,0,0.4)",
  	    fontFamily: "system-ui, sans-serif",
  	    transform: "translateX(100%)",
  	    opacity: "0",
  	    transition: "transform 0.35s ease, opacity 0.35s ease"
  	  });

  	  hubEl.appendChild(listPanel);

  	  setTimeout(function () {
  	    listPanel.style.transform = "translateX(0)";
  	    listPanel.style.opacity = "1";
  	  }, 0);

  	  var listTopBar = DocumentSafe.createElement("div");

  	  Object.assign(listTopBar.style, {
  	    display: "flex",
  	    justifyContent: "space-between",
  	    alignItems: "center",
  	    padding: "8px 10px",
  	    borderBottom: "1px solid rgba(204,102,51,0.4)",
  	    background: "rgba(30,30,30,0.9)",
  	    position: "sticky",
  	    top: "0",
  	    zIndex: 10
  	  });

  	  var listTitle = DocumentSafe.createElement("div");
  	  listTitle.textContent = "Tractors";

  	  Object.assign(listTitle.style, {
  	    fontWeight: "600",
  	    color: "#CC6633",
  	    fontSize: "13px"
  	  });

  	  var listCloseBtn = DocumentSafe.createElement("div");
  	  listCloseBtn.textContent = "✕";

  	  Object.assign(listCloseBtn.style, {
  	    cursor: "pointer",
  	    fontSize: "14px",
  	    padding: "2px 6px",
  	    borderRadius: "4px"
  	  });

  	  listCloseBtn.onclick = function () {
  	    var editor = hubEl.querySelector("#tractorEditorPanel");

  	    listPanel.style.transform = "translateX(100%)";
  	    listPanel.style.opacity = "0";

  	    if (editor) {
  	      editor.remove();
  	    }

  	    setTimeout(function () {
  	      if (listPanel && listPanel.parentNode) {
  	        listPanel.remove();
  	      }
  	    },
  	      400);
  	  };

  	  listTopBar.appendChild(listTitle);
  	  listTopBar.appendChild(listCloseBtn);
  	  listPanel.appendChild(listTopBar);

  	  var search = DocumentSafe.createElement("input");
  	  search.type = "text";
  	  search.placeholder = "🔍 Search tractor...";

  	  Object.assign(search.style,
  	    {
  	      width: "calc(100% - 16px)",
  	      padding: "6px 8px",
  	      margin: "6px 8px",
  	      border: "none",
  	      borderRadius: "6px",
  	      background: "#222",
  	      color: "#fff",
  	      outline: "none",
  	      fontSize: "13px",
  	      boxSizing: "border-box"
  	    });

  	  listPanel.appendChild(search);

  	  var listBody = DocumentSafe.createElement("div");
  	  listPanel.appendChild(listBody);

  	  function renderList(filter) {
  	    var query = clean(filter).toLowerCase();

  	    listBody.innerHTML = "";

  	    state.tractorArray
  	    .filter(function (tractor) {
  	      var id = clean(vehicleId(tractor) || vehicleObjectId(tractor)).toLowerCase();
  	      var make = clean(vehicleMake(tractor)).toLowerCase();
  	      var model = clean(vehicleModel(tractor)).toLowerCase();
  	      var reg = clean(vehicleReg(tractor)).toLowerCase();

  	      return (
  	        id.indexOf(query) !== -1 ||
  	        make.indexOf(query) !== -1 ||
  	        model.indexOf(query) !== -1 ||
  	        reg.indexOf(query) !== -1
  	      );
  	    })
  	    .forEach(function (tractor) {
  	      var card = DocumentSafe.createElement("div");
  	      var color = cardColor(tractor);
  	      var id = vehicleId(tractor) || vehicleObjectId(tractor);
  	      var make = vehicleMake(tractor);
  	      var model = vehicleModel(tractor);
  	      var reg = vehicleReg(tractor);

  	      Object.assign(card.style, {
  	        background: "#1b1b1b",
  	        padding: "8px",
  	        margin: "6px 8px",
  	        borderRadius: "8px",
  	        cursor: "pointer",
  	        boxShadow: "0 0 4px rgba(0,0,0,0.3)",
  	        fontSize: "12px"
  	      });

  	      card.innerHTML = ""
  	      + "<div style=\"display:flex;align-items:center;font-size:14px;font-weight:600;margin-bottom:4px;\">"
  	      + "  <div style=\"width:12px;height:12px;border-radius:50%;background:" + escapeHtml(color) + ";margin-right:6px;\"></div>"
  	      + "  " + escapeHtml(id)
  	      + "</div>"
  	      + "<div style=\"color:#aaa;font-size:12px;\">" + escapeHtml(clean(make + " " + model)) + "</div>"
  	      + (reg ? "<div style=\"color:#777;font-size:11px;margin-top:2px;\">" + escapeHtml(reg) + "</div>": "");

  	      card.onclick = function () {
  	        openEditor(tractor);
  	      };

  	      listBody.appendChild(card);
  	    });
  	  }

  	  search.addEventListener("input",
  	    function (event) {
  	      renderList(event.target.value);
  	    });

  	  renderList("");

  	  // ===============================================================
  	  // GENERIC FIELD RENDERERS
  	  // ===============================================================
  	  function getOptionsForWrappedNode(node) {
  	    if (node && Array.isArray(node.options)) {
  	      return node.options;
  	    }

  	    return [];
  	  }

  	  function renderField(selector, path, node, editMode) {
  	    var value = node && Object.prototype.hasOwnProperty.call(node, "value")
  	    ? node.value: node;

  	    var editable = !!(node && node.editable);
  	    var disabled = !editMode || !editable ? "disabled": "";
  	    var dim = !editable ? "opacity:0.6;": "";
  	    var label = prettyName(String(path || "").split(".").pop());
  	    var bind = path + ".value";
  	    var options;
  	    var html;

  	    if (selector === "boolean") {
  	      return ""
  	      + "<label style=\"display:flex;align-items:center;margin:6px 0;" + dim + "\">"
  	      + "  <span style=\"margin-right:6px\">" + escapeHtml(label) + "</span>"
  	      + "  <input type=\"checkbox\" data-bind=\"" + escapeHtml(bind) + "\" " + (value ? "checked": "") + " " + disabled + ">"
  	      + "</label>";
  	    }

  	    if (selector === "textarea") {
  	      return ""
  	      + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	      + "<textarea data-bind=\"" + escapeHtml(bind) + "\" " + disabled + " style=\"width:100%;min-height:80px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">"
  	      + escapeHtml(value || "")
  	      + "</textarea>";
  	    }

  	    if (selector === "number" || selector === "currency") {
  	      return ""
  	      + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	      + "<input type=\"number\" step=\"" + (selector === "currency" ? "0.01": "any") + "\" data-bind=\"" + escapeHtml(bind) + "\" value=\"" + escapeHtml(value == null ? "": value) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";
  	    }

  	    if (selector === "date" || selector === "time" || selector === "datetime") {
  	      return ""
  	      + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	      + "<input type=\"" + (selector === "datetime" ? "datetime-local": selector) + "\" data-bind=\"" + escapeHtml(bind) + "\" value=\"" + escapeHtml(value == null ? "": value) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";
  	    }

  	    if (selector === "select") {
  	      options = getOptionsForWrappedNode(node);
  	      html = ""
  	      + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	      + "<select data-bind=\"" + escapeHtml(bind) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";

  	      options.forEach(function (option) {
  	        html += "<option value=\"" + escapeHtml(option) + "\" " + (value === option ? "selected": "") + ">" + escapeHtml(option) + "</option>";
  	      });

  	      html += "</select>";

  	      return html;
  	    }

  	    if (selector === "image") {
  	      return ""
  	      + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	      + "<div style=\"margin:8px 0;\">"
  	      + (
  	        value
  	        ? "<img src=\"" + escapeHtml(value) + "\" style=\"max-width:100%;max-height:200px;border-radius:8px;background:#000;padding:6px;\">": "<div style=\"height:160px;border:1px dashed #666;border-radius:8px;background:#111;display:flex;align-items:center;justify-content:center;color:#666;\">No Image</div>"
  	      )
  	      + "</div>"
  	      + "<button " + disabled + " data-bind=\"" + escapeHtml(bind) + "\" data-media-action=\"choose\" style=\"width:100%;padding:6px;background:#444;color:#fff;border:none;border-radius:6px;" + dim + "\">"
  	      + (value ? "Replace Image": "Add Image")
  	      + "</button>";
  	    }

  	    if (selector === "email" || selector === "phone" || selector === "password") {
  	      return ""
  	      + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	      + "<input type=\"" + (selector === "phone" ? "tel": selector) + "\" data-bind=\"" + escapeHtml(bind) + "\" value=\"" + escapeHtml(value == null ? "": value) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";
  	    }

  	    return ""
  	    + "<label style=\"display:block;margin-top:10px;" + dim + "\">" + escapeHtml(label) + "</label>"
  	    + "<input type=\"text\" data-bind=\"" + escapeHtml(bind) + "\" value=\"" + escapeHtml(value == null ? "": value) + "\" " + disabled + " style=\"width:100%;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + dim + "\">";
  	  }

  	  function buildForm(obj, basePath) {
  	    var html = "";

  	    if (!obj || typeof obj !== "object") {
  	      return "<div style=\"color:#777;\">No Data</div>";
  	    }

  	    Object.keys(obj).forEach(function (key) {
  	      var raw = obj[key];
  	      var fullPath = basePath ? basePath + "." + key: key;
  	      var selector;

  	      if (isWrapped(raw)) {
  	        selector = raw.selector || "text";
  	        html += renderField(selector, fullPath, raw, state.editMode);
  	        return;
  	      }

  	      if (Array.isArray(raw)) {
  	        html += ""
  	        + "<div style=\"margin-top:12px;font-weight:600;color:#CC6633;\">" + escapeHtml(prettyName(key)) + "</div>"
  	        + "<div style=\"margin-left:10px;border-left:2px solid #333;padding-left:10px;\">";

  	        if (!raw.length) {
  	          html += "<div style=\"color:#777;\">(empty)</div>";
  	        } else {
  	          raw.forEach(function (item, index) {
  	            html += ""
  	            + "<div style=\"margin-top:8px;\">"
  	            + "  <div style=\"color:#999;font-size:11px;\">[" + index + "]</div>"
  	            + buildForm(item, fullPath + "[" + index + "]")
  	            + "</div>";
  	          });
  	        }

  	        html += "</div>";
  	        return;
  	      }

  	      if (raw && typeof raw === "object") {
  	        html += ""
  	        + "<div style=\"margin-top:12px;font-weight:600;color:#CC6633;\">" + escapeHtml(prettyName(key)) + "</div>"
  	        + "<div style=\"margin-left:10px;border-left:2px solid #333;padding-left:10px;\">"
  	        + buildForm(raw, fullPath)
  	        + "</div>";
  	        return;
  	      }

  	      html += renderField("text", fullPath, {
  	        value: raw,
  	        editable: true,
  	        selector: "text"
  	      }, state.editMode);
  	    });

  	    return html;
  	  }

  	  function applyBoundInputsToVehicle(vehicle,
  	    panel) {
  	    var inputs = panel.querySelectorAll("[data-bind]");
  	    var i;
  	    var input;
  	    var bind;
  	    var tokens;
  	    var value;

  	    if (!vehicle.Data) {
  	      vehicle.Data = {};
  	    }

  	    for (i = 0; i < inputs.length; i++) {
  	      input = inputs[i];

  	      if (input.disabled) {
  	        continue;
  	      }

  	      bind = input.getAttribute("data-bind");

  	      if (!bind) {
  	        continue;
  	      }

  	      value = readInputValue(input);

  	      if (bind === "__ROOT__.FID") {
  	        vehicle.FID = value;
  	        continue;
  	      }

  	      tokens = tokenizePath(bind);
  	      setByTokens(vehicle.Data, tokens, value);
  	    }
  	  }

  	  // ===============================================================
  	  // EDITOR SHELL
  	  // ===============================================================
  	  function openEditor(tractor) {
  	    var existingEditor;
  	    var editorPanel;
  	    var header;
  	    var titleWrap;
  	    var headTitle;
  	    var fidRow;
  	    var fidLabel;
  	    var fidInput;
  	    var editBtn;
  	    var tabBar;
  	    var body;
  	    var controlBar;
  	    var cancelBtn;
  	    var saveBtn;

  	    state.activeTractor = tractor;
  	    state.editMode = false;
  	    state.activeTab = "Vehicle";

  	    state.tyrePositionsDraft = null;
  	    state.tyrePositionsDraftTractorId = "";

  	    state.selectedPosition = "";
  	    state.actionMode = "";
  	    state.actionMessage = "";
  	    state.actionError = false;

  	    state.pendingTyreAction = null;
  	    state.dragSource = null;
  	    state.tapSource = null;

  	    state.rotationDraftTPositions = null;
  	    state.rotationPlanStartedVehicleId = "";
  	    state.rotationMessage = "";

  	    state.allocatePopupOpen = false;
  	    state.allocateSearch = "";
  	    state.allocateTypeFilter = "";
  	    state.allocateSelectedTyreId = "";

  	    state.mismatchApprovals = {};
  	    state.rotationPopupOpen = false;

  	    existingEditor = hubEl.querySelector("#tractorEditorPanel");

  	    if (existingEditor) {
  	      existingEditor.remove();
  	    }

  	    loadTyres().then(function () {
  	      if (
  	        state.activeTractor &&
  	        vehicleObjectId(state.activeTractor) === vehicleObjectId(tractor) &&
  	        state.activeTab === "Tyres"
  	      ) {
  	        renderTab("Tyres");
  	      }
  	    });

  	    editorPanel = DocumentSafe.createElement("div");
  	    editorPanel.id = "tractorEditorPanel";

  	    Object.assign(editorPanel.style,
  	      {
  	        position: "absolute",
  	        top: "50px",
  	        left: "0",
  	        right: "240px",
  	        bottom: "0",
  	        background: "rgba(20,20,20,0.96)",
  	        color: "#fff",
  	        zIndex: 901,
  	        borderRight: "2px solid #CC6633",
  	        boxShadow: "2px 0 10px rgba(0,0,0,0.4)",
  	        fontFamily: "system-ui, sans-serif",
  	        transform: "translateX(-100%)",
  	        opacity: "0",
  	        transition: "transform 0.35s ease, opacity 0.35s ease",
  	        display: "flex",
  	        flexDirection: "column",
  	        overflow: "hidden"
  	      });

  	    hubEl.appendChild(editorPanel);

  	    setTimeout(function () {
  	      editorPanel.style.transform = "translateX(0)";
  	      editorPanel.style.opacity = "1";
  	    },
  	      0);

  	    header = DocumentSafe.createElement("div");

  	    Object.assign(header.style,
  	      {
  	        display: "flex",
  	        justifyContent: "space-between",
  	        alignItems: "flex-start",
  	        padding: "10px 12px",
  	        borderBottom: "1px solid #333",
  	        background: "#1a1a1a",
  	        flex: "0 0 auto",
  	        gap: "10px"
  	      });

  	    titleWrap = DocumentSafe.createElement("div");

  	    Object.assign(titleWrap.style,
  	      {
  	        display: "flex",
  	        flexDirection: "column",
  	        minWidth: "0"
  	      });

  	    headTitle = DocumentSafe.createElement("div");
  	    headTitle.textContent = vehicleTitle(tractor);

  	    Object.assign(headTitle.style,
  	      {
  	        fontSize: "16px",
  	        fontWeight: "600",
  	        color: "#CC6633",
  	        lineHeight: "1.2",
  	        whiteSpace: "nowrap",
  	        overflow: "hidden",
  	        textOverflow: "ellipsis",
  	        maxWidth: "520px"
  	      });

  	    fidRow = DocumentSafe.createElement("div");

  	    Object.assign(fidRow.style,
  	      {
  	        display: "flex",
  	        alignItems: "center",
  	        gap: "8px",
  	        marginTop: "8px"
  	      });

  	    fidLabel = DocumentSafe.createElement("div");
  	    fidLabel.textContent = "FID";

  	    Object.assign(fidLabel.style,
  	      {
  	        fontSize: "12px",
  	        color: "#aaa",
  	        minWidth: "34px"
  	      });

  	    fidInput = DocumentSafe.createElement("input");
  	    fidInput.type = "text";
  	    fidInput.value = tractor.FID || "";
  	    fidInput.dataset.bind = "__ROOT__.FID";
  	    fidInput.disabled = true;

  	    Object.assign(fidInput.style,
  	      {
  	        width: "200px",
  	        padding: "6px 8px",
  	        border: "1px solid #555",
  	        borderRadius: "6px",
  	        background: "#111",
  	        color: "#fff",
  	        outline: "none",
  	        fontSize: "13px"
  	      });

  	    fidRow.appendChild(fidLabel);
  	    fidRow.appendChild(fidInput);

  	    titleWrap.appendChild(headTitle);
  	    titleWrap.appendChild(fidRow);

  	    editBtn = DocumentSafe.createElement("button");
  	    editBtn.id = "tractorEditBtn";
  	    editBtn.textContent = "Edit";

  	    Object.assign(editBtn.style,
  	      {
  	        background: "#CC6633",
  	        color: "#fff",
  	        border: "none",
  	        padding: "6px 12px",
  	        borderRadius: "6px",
  	        cursor: "pointer",
  	        fontSize: "13px",
  	        flex: "0 0 auto"
  	      });

  	    header.appendChild(titleWrap);
  	    header.appendChild(editBtn);
  	    editorPanel.appendChild(header);

  	    tabBar = DocumentSafe.createElement("div");

  	    Object.assign(tabBar.style,
  	      {
  	        display: "flex",
  	        borderBottom: "1px solid #333",
  	        background: "#1a1a1a",
  	        flex: "0 0 auto",
  	        padding: "0 5px",
  	        overflowX: "auto"
  	      });

  	    editorPanel.appendChild(tabBar);

  	    body = DocumentSafe.createElement("div");

  	    Object.assign(body.style,
  	      {
  	        flex: "1 1 auto",
  	        overflowY: "auto",
  	        padding: "12px 15px 20px",
  	        position: "relative"
  	      });

  	    editorPanel.appendChild(body);

  	    controlBar = DocumentSafe.createElement("div");

  	    Object.assign(controlBar.style,
  	      {
  	        display: "none",
  	        justifyContent: "flex-end",
  	        gap: "10px",
  	        padding: "10px 15px",
  	        borderTop: "1px solid #333",
  	        background: "#1a1a1a",
  	        flex: "0 0 auto"
  	      });

  	    cancelBtn = DocumentSafe.createElement("button");
  	    cancelBtn.textContent = "Cancel";

  	    Object.assign(cancelBtn.style,
  	      {
  	        background: "#555",
  	        color: "#fff",
  	        border: "none",
  	        padding: "6px 14px",
  	        borderRadius: "6px",
  	        cursor: "pointer",
  	        fontSize: "14px"
  	      });

  	    saveBtn = DocumentSafe.createElement("button");
  	    saveBtn.textContent = "Save";

  	    Object.assign(saveBtn.style,
  	      {
  	        background: "#2a8f3a",
  	        color: "#fff",
  	        border: "none",
  	        padding: "6px 14px",
  	        borderRadius: "6px",
  	        cursor: "pointer",
  	        fontSize: "14px"
  	      });

  	    controlBar.appendChild(cancelBtn);
  	    controlBar.appendChild(saveBtn);
  	    editorPanel.appendChild(controlBar);

  	    // =========================================================
  	    // TABS
  	    // =========================================================
  	    var TAB_DEFS = [{
  	      label: "Vehicle", key: "Vehicle"
  	    },
  	      {
  	        label: "Tyres", key: "__TYRES__"
  	      },
  	      {
  	        label: "Compliance", key: "Compliance"
  	      },
  	      {
  	        label: "Ownership", key: "Ownership"
  	      },
  	      {
  	        label: "Service", key: "Service"
  	      },
  	      {
  	        label: "Financials", key: "Financials"
  	      },
  	      {
  	        label: "Operational Targets", key: "OperationalTargets"
  	      },
  	      {
  	        label: "Financial Targets", key: "FinancialTargets"
  	      },
  	      {
  	        label: "Media", key: "Media"
  	      }];

  	    function renderTabButtons() {
  	      tabBar.innerHTML = "";

  	      TAB_DEFS.forEach(function (def) {
  	        var tab = DocumentSafe.createElement("div");
  	        var active = state.activeTab === def.label;

  	        tab.textContent = def.label;
  	        tab.dataset.tabName = def.label;

  	        Object.assign(tab.style, {
  	          padding: "10px 20px",
  	          cursor: "pointer",
  	          fontSize: "13px",
  	          color: active ? "#fff": "#ccc",
  	          background: active ? "#242424": "#1a1a1a",
  	          borderBottom: active ? "2px solid #CC6633": "2px solid transparent",
  	          whiteSpace: "nowrap"
  	        });

  	        tab.onclick = function () {
  	          setActiveTab(def.label);
  	        };

  	        tabBar.appendChild(tab);
  	      });
  	    }

  	    // =========================================================
  	    // TYRE DRAFT
  	    // =========================================================
  	    function getDraftTPositions() {
  	      if (
  	        state.tyrePositionsDraft &&
  	        state.tyrePositionsDraftTractorId === vehicleObjectId(tractor)
  	      ) {
  	        return state.tyrePositionsDraft;
  	      }

  	      state.tyrePositionsDraft = normaliseTPositions(readTPositionsRaw(tractor));
  	      state.tyrePositionsDraftTractorId = vehicleObjectId(tractor);

  	      return state.tyrePositionsDraft;
  	    }

  	    function resetDraftTPositions() {
  	      state.tyrePositionsDraft = null;
  	      state.tyrePositionsDraftTractorId = "";
  	    }

  	    // =========================================================
  	    // AXLE PRESETS
  	    // =========================================================
  	    function setPreset4x2(draft) {
  	      draft.Axles = [{
  	        Axle: 1,
  	        Type: "Steer",
  	        TyresPerSide: 1,
  	        WearRate: 1,
  	        Enabled: true
  	      },
  	        {
  	          Axle: 2,
  	          Type: "Drive",
  	          TyresPerSide: 2,
  	          WearRate: 1,
  	          Enabled: true
  	        }];

  	      applyAxleRules(draft, false);
  	      rebuildSlots(draft);
  	    }

  	    function setPreset6x2Tag(draft) {
  	      draft.Axles = [{
  	        Axle: 1,
  	        Type: "Steer",
  	        TyresPerSide: 1,
  	        WearRate: 1,
  	        Enabled: true
  	      },
  	        {
  	          Axle: 2,
  	          Type: "Tag",
  	          TyresPerSide: 1,
  	          WearRate: 0.35,
  	          Enabled: true
  	        },
  	        {
  	          Axle: 3,
  	          Type: "Drive",
  	          TyresPerSide: 2,
  	          WearRate: 1,
  	          Enabled: true
  	        }];

  	      applyAxleRules(draft, false);
  	      rebuildSlots(draft);
  	    }

  	    function setPreset6x4(draft) {
  	      draft.Axles = [{
  	        Axle: 1,
  	        Type: "Steer",
  	        TyresPerSide: 1,
  	        WearRate: 1,
  	        Enabled: true
  	      },
  	        {
  	          Axle: 2,
  	          Type: "Drive",
  	          TyresPerSide: 2,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	        {
  	          Axle: 3,
  	          Type: "Drive",
  	          TyresPerSide: 2,
  	          WearRate: 1,
  	          Enabled: true
  	        }];

  	      applyAxleRules(draft, false);
  	      rebuildSlots(draft);
  	    }

  	    function setPreset8x4(draft) {
  	      draft.Axles = [{
  	        Axle: 1,
  	        Type: "Steer",
  	        TyresPerSide: 1,
  	        WearRate: 1,
  	        Enabled: true
  	      },
  	        {
  	          Axle: 2,
  	          Type: "Steer",
  	          TyresPerSide: 1,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	        {
  	          Axle: 3,
  	          Type: "Drive",
  	          TyresPerSide: 2,
  	          WearRate: 1,
  	          Enabled: true
  	        },
  	        {
  	          Axle: 4,
  	          Type: "Drive",
  	          TyresPerSide: 2,
  	          WearRate: 1,
  	          Enabled: true
  	        }];

  	      applyAxleRules(draft, false);
  	      rebuildSlots(draft);
  	    }

  	    // =========================================================
  	    // TYRE VISUAL HELPERS
  	    // =========================================================
  	    function tyreTreadHtml(color, selected, dropReady) {
  	      return ""
  	      + "<div style=\""
  	      + "width:100%;"
  	      + "height:34px;"
  	      + "border-radius:4px;"
  	      + "background:" + escapeHtml(color) + ";"
  	      + "border:" + (selected ? "2px solid #ffffff": dropReady ? "2px solid #CC6633": "1px solid rgba(0,0,0,0.85)") + ";"
  	      + "box-shadow:inset 0 0 0 1px rgba(255,255,255,0.18),0 1px 2px rgba(0,0,0,0.45);"
  	      + "background-image:"
  	      + "repeating-linear-gradient(135deg,rgba(0,0,0,0.72) 0px,rgba(0,0,0,0.72) 3px,transparent 3px,transparent 7px),"
  	      + "repeating-linear-gradient(45deg,rgba(0,0,0,0.55) 0px,rgba(0,0,0,0.55) 2px,transparent 2px,transparent 6px);"
  	      + "\"></div>";
  	    }

  	    function tyreSlotHtml(slot) {
  	      var tyreId = clean(slot && slot.TyreObjectId);
  	      var tyre = tyreId ? findTyre(tyreId): null;
  	      var selectedPosition = state.selectedPosition === slot.PositionKey;
  	      var selectedTapSource =
  	      state.tapSource &&
  	      state.tapSource.SourceType === "fitted" &&
  	      state.tapSource.SourcePosition === slot.PositionKey;

  	      var selectedDragSource =
  	      state.dragSource &&
  	      state.dragSource.SourceType === "fitted" &&
  	      state.dragSource.SourcePosition === slot.PositionKey;

  	      var selected = selectedPosition || selectedTapSource || selectedDragSource;
  	      var dropReady = (state.actionMode === "RotateSwap" || state.actionMode === "Allocate") && (state.tapSource || state.dragSource);
  	      var canDragFitted = (state.actionMode === "RotateSwap" || state.actionMode === "Allocate") && !!tyreId;
  	      var color = tyre ? tyreColor(tyre): tyreId ? "#6b7280": "#263044";
  	      var label = tyre ? tyreName(tyre): tyreId ? tyreId: "Empty";
  	      var life = tyre ? tyreLife(tyre): null;
  	      var lifeLabel = life === null ? "No data": life.toFixed(1) + "%";
  	      var selectedStyle = selected
  	      ? "background:rgba(204,102,51,0.22);outline:3px solid #CC6633;box-shadow:0 0 0 2px rgba(255,255,255,0.18),0 0 18px rgba(204,102,51,0.7);": "background:transparent;outline:1px solid transparent;box-shadow:none;";

  	      return ""
  	      + "<div class=\"trac-tyre-slot\" "
  	      + "draggable=\"" + (canDragFitted ? "true": "false") + "\" "
  	      + "data-source-type=\"fitted\" "
  	      + "data-position-key=\"" + escapeHtml(slot.PositionKey) + "\" "
  	      + "data-source-position=\"" + escapeHtml(slot.PositionKey) + "\" "
  	      + "data-tyre-object-id=\"" + escapeHtml(tyreId) + "\" "
  	      + "title=\"" + escapeHtml(slot.PositionKey + " • " + label + " • " + lifeLabel) + "\" "
  	      + "style=\"cursor:" + (canDragFitted ? "grab": "pointer") + ";padding:5px;border-radius:8px;transition:background .12s,outline .12s,box-shadow .12s,transform .12s;" + selectedStyle + "\">"
  	      + tyreTreadHtml(color, selected, !!dropReady)
  	      + "<div style=\"margin-top:4px;color:" + (selected ? "#fff": "#9ca3af") + ";font-size:10px;font-weight:" + (selected ? "900": "600") + ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;\">"
  	      + escapeHtml(slot.PositionKey)
  	      + "</div>"
  	      + "</div>";
  	    }

  	    function renderSmallTyreDisplay(slot) {
  	      var tyreId = clean(slot && slot.TyreObjectId);
  	      var tyre = tyreId ? findTyre(tyreId): null;
  	      var label = tyre ? tyreName(tyre): tyreId ? tyreId: "No tyre assigned";

  	      return ""
  	      + "<div style=\"width:100%;padding:7px 8px;border:1px solid #333;border-radius:6px;background:#111;color:#bbb;font-size:12px;min-height:18px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\">"
  	      + escapeHtml(label)
  	      + "</div>";
  	    }

  	    function renderWearLegend() {
  	      var items = [{
  	        label: "80-100%",
  	        color: "#39ff14"
  	      },
  	        {
  	          label: "60-79%",
  	          color: "#a6ff33"
  	        },
  	        {
  	          label: "40-59%",
  	          color: "#ffd633"
  	        },
  	        {
  	          label: "20-39%",
  	          color: "#ff8a00"
  	        },
  	        {
  	          label: "1-19%",
  	          color: "#ff2b1a"
  	        },
  	        {
  	          label: "0%",
  	          color: "#111827"
  	        },
  	        {
  	          label: "No data",
  	          color: "#6b7280"
  	        }];

  	      return ""
  	      + "<div style=\"display:flex;flex-wrap:wrap;gap:8px;margin-bottom:10px;\">"
  	      + items.map(function (item) {
  	        return ""
  	        + "<div style=\"display:flex;align-items:center;gap:5px;color:#aaa;font-size:11px;\">"
  	        + "  <div style=\"width:22px;height:12px;border-radius:3px;background:" + escapeHtml(item.color) + ";border:1px solid rgba(0,0,0,0.8);\"></div>"
  	        + "  " + escapeHtml(item.label)
  	        + "</div>";
  	      }).join("")
  	      + "</div>";
  	    }

  	    function axleVisualHtml(tPositions, axle) {
  	      var leftSlots = slotsForAxle(tPositions, axle.Axle, "L");
  	      var rightSlots = slotsForAxle(tPositions, axle.Axle, "R");

  	      return ""
  	      + "<div style=\""
  	      + "width:190px;min-height:370px;background:#253044;"
  	      + "border-left:6px solid #6b7280;border-right:6px solid #6b7280;"
  	      + "position:relative;box-shadow:0 0 0 1px rgba(255,255,255,0.04);"
  	      + "display:flex;flex-direction:column;justify-content:space-between;"
  	      + "padding:10px 8px;"
  	      + "\">"
  	      + "  <div style=\"position:absolute;top:8px;left:8px;right:8px;display:flex;gap:5px;flex-direction:column;\">"
  	      + (
  	        leftSlots.length
  	        ? leftSlots.map(tyreSlotHtml).join(""): "<div style=\"height:38px;color:#64748b;font-size:11px;text-align:center;\">No left tyres</div>"
  	      )
  	      + "  </div>"
  	      + "  <div style=\"position:absolute;top:50%;left:0;right:0;transform:translateY(-50%);text-align:center;color:#cbd5e1;font-size:12px;font-weight:800;opacity:0.75;\">"
  	      + "    A" + escapeHtml(axle.Axle) + "<br>"
  	      + "    <span style=\"font-size:10px;font-weight:600;\">" + escapeHtml(axle.Type) + "</span>"
  	      + (
  	        axle.Type === "Tag"
  	        ? "<br><span style=\"font-size:10px;color:#facc15;\">Wear " + escapeHtml(axle.WearRate) + "</span>": ""
  	      )
  	      + "  </div>"
  	      + "  <div style=\"position:absolute;bottom:8px;left:8px;right:8px;display:flex;gap:5px;flex-direction:column;\">"
  	      + (
  	        rightSlots.length
  	        ? rightSlots.map(tyreSlotHtml).join(""): "<div style=\"height:38px;color:#64748b;font-size:11px;text-align:center;\">No right tyres</div>"
  	      )
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function selectedTyreDetailHtml(tPositions) {
  	      var slot = getSlot(tPositions, state.selectedPosition);
  	      var tyreId = slot ? clean(slot.TyreObjectId): "";
  	      var tyre = tyreId ? findTyre(tyreId): null;
  	      var life = tyre ? tyreLife(tyre): null;

  	      if (!slot) {
  	        return ""
  	        + "<div style=\"border:1px solid #333;border-radius:8px;background:#101010;padding:12px;color:#777;font-size:13px;\">"
  	        + "Tap a tyre position, or drag a tyre card onto the layout."
  	        + "</div>";
  	      }

  	      return ""
  	      + "<div style=\"border:1px solid #333;border-radius:8px;background:#101010;overflow:hidden;margin-bottom:10px;\">"
  	      + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Selected Position</div>"
  	      + "  <div style=\"padding:12px;\">"
  	      + "    <div style=\"margin-bottom:10px;\">" + tyreTreadHtml(tyre ? tyreColor(tyre): tyreId ? "#6b7280": "#263044", true, false) + "</div>"
  	      + "    <div style=\"display:grid;grid-template-columns:130px 1fr;gap:6px 10px;font-size:12px;\">"
  	      + "      <div style=\"color:#888;\">Position</div><div style=\"color:#fff;font-weight:700;\">" + escapeHtml(slot.PositionKey) + "</div>"
  	      + "      <div style=\"color:#888;\">Axle Type</div><div style=\"color:#fff;\">" + escapeHtml(slot.AxleType || "") + "</div>"
  	      + "      <div style=\"color:#888;\">Wear Rate</div><div style=\"color:#fff;\">" + escapeHtml(slot.WearRate == null ? "": slot.WearRate) + "</div>"
  	      + "      <div style=\"color:#888;\">Tyre</div><div style=\"color:#fff;\">" + escapeHtml(tyre ? tyreName(tyre): tyreId ? tyreId: "Empty") + "</div>"
  	      + "      <div style=\"color:#888;\">Type Required</div><div style=\"color:#fff;\">" + escapeHtml(requiredTyreTypeForSlot(slot)) + "</div>"
  	      + "      <div style=\"color:#888;\">Tyre Status</div><div style=\"color:#fff;\">" + escapeHtml(tyre ? tyreStatus(tyre): "") + "</div>"
  	      + "      <div style=\"color:#888;\">Current Life</div><div style=\"color:#fff;\">" + escapeHtml(life == null ? "": life.toFixed(1) + "%") + "</div>"
  	      + "      <div style=\"color:#888;\">Current Mileage</div><div style=\"color:#fff;\">" + escapeHtml(tyre && tyre.Current_Mileage != null ? tyre.Current_Mileage: "") + "</div>"
  	      + "      <div style=\"color:#888;\">Expected Mileage</div><div style=\"color:#fff;\">" + escapeHtml(tyre && tyre.Expected_Mileage != null ? tyre.Expected_Mileage: "") + "</div>"
  	      + "    </div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function actionInputsHtml(notePlaceholder) {
  	      return ""
  	      + "<div style=\"padding:8px 0;border-top:1px solid #252525;\">"
  	      + "  <label style=\"display:block;color:#9c9c9c;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	      + "  <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:7px;border:1px solid #343434;border-radius:6px;background:#151515;color:#fff;\">"
  	      + "</div>"
  	      + "<div style=\"padding:8px 0;\">"
  	      + "  <label style=\"display:block;color:#9c9c9c;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	      + "  <textarea id=\"tyreActionNotes\" placeholder=\"" + escapeHtml(notePlaceholder || "Notes") + "\" style=\"width:100%;box-sizing:border-box;min-height:52px;padding:7px;border:1px solid #343434;border-radius:6px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	      + "</div>";
  	    }


  	    function pendingPreviewHtml() {
  	      var pending = state.pendingTyreAction;
  	      var validation = pending ? validatePendingStillPossible(): null;

  	      if (!pending) {
  	        return ""
  	        + "<div style=\"border:1px solid #333;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	        + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Pending Allocation</div>"
  	        + "  <div style=\"padding:11px 12px;color:#777;font-size:12px;\">"
  	        + "Select a tyre from the Allocate popup, then click or drag it to the target position."
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      return ""
  	      + "<div style=\"border:1px solid " + (validation && validation.ok ? "#2a8f3a": "#7f1d1d") + ";background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	      + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Pending Allocation</div>"
  	      + "  <div style=\"padding:11px 12px;\">"
  	      + "    <div style=\"color:#fff;font-size:13px;font-weight:800;margin-bottom:6px;\">" + escapeHtml(pendingActionLabel()) + "</div>"
  	      + "    <div style=\"color:" + (validation && validation.ok ? "#9ca3af": "#ff4d4f") + ";font-size:12px;margin-bottom:8px;\">"
  	      + escapeHtml(validation && validation.ok ? pending.Preview: validation.message)
  	      + "    </div>"
  	      + actionInputsHtml("Allocation notes")
  	      + "    <div style=\"display:flex;gap:8px;padding:10px 0 0;\">"
  	      + "      <button id=\"tyreConfirmPendingBtn\" type=\"button\" " + (validation && validation.ok ? "": "disabled") + " style=\"background:#2a8f3a;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:800;opacity:" + (validation && validation.ok ? "1": "0.5") + ";\">Confirm Allocation</button>"
  	      + "      <button id=\"tyreClearPendingBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:800;\">Clear</button>"
  	      + "    </div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function selectedRemovableTyreSlot() {
  	      var currentVehicle;
  	      var tPositions;
  	      var slot;

  	      if (state.actionMode === "Allocate" || state.actionMode === "RotateSwap") {
  	        return null;
  	      }

  	      if (!state.selectedPosition) {
  	        return null;
  	      }

  	      currentVehicle = state.activeTractor || tractor;
  	      tPositions = normaliseTPositions(readTPositionsRaw(currentVehicle));
  	      slot = getSlot(tPositions, state.selectedPosition);

  	      if (!slot || !slot.TyreObjectId) {
  	        return null;
  	      }

  	      return slot;
  	    }

  	    function tyreModeButtonHtml(mode, label) {
  	      var active = state.actionMode === mode;

  	      return ""
  	      + "<button type=\"button\" class=\"trac-tyre-mode-btn\" data-mode=\"" + escapeHtml(mode) + "\" style=\""
  	      + "background:" + (active ? "#CC6633": "#333") + ";"
  	      + "color:#fff;border:none;padding:7px 10px;border-radius:7px;cursor:pointer;font-size:12px;font-weight:800;"
  	      + "\">" + escapeHtml(label) + "</button>";
  	    }

  	    function tyreActionTopBarHtml() {
  	      var removeSlot = selectedRemovableTyreSlot();

  	      return ""
  	      + "<div style=\""
  	      + "position:sticky;"
  	      + "top:0;"
  	      + "z-index:30;"
  	      + "display:flex;"
  	      + "align-items:center;"
  	      + "justify-content:space-between;"
  	      + "gap:12px;"
  	      + "border:1px solid #333;"
  	      + "background:#101010;"
  	      + "border-radius:8px;"
  	      + "padding:10px 12px;"
  	      + "margin-bottom:12px;"
  	      + "box-shadow:0 8px 18px rgba(0,0,0,0.45);"
  	      + "\">"
  	      + "  <div>"
  	      + "    <div style=\"color:#CC6633;font-size:14px;font-weight:900;margin-bottom:3px;\">Tyre Actions</div>"
  	      + "    <div style=\"color:#888;font-size:11px;\">"
  	      + (
  	        state.actionMode === "Allocate"
  	        ? "Build the allocation plan, then complete or cancel it.": state.actionMode === "RotateSwap"
  	        ? "Rotate / Swap is active. Save or clear the rotation plan when ready.": "Tyre movement is locked until you choose an action."
  	      )
  	      + "    </div>"
  	      + "  </div>"
  	      + "  <div style=\"display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;\">"
  	      + (
  	        removeSlot
  	        ? "    <button type=\"button\" id=\"tyreOpenRemovePopupBtn\" style=\"background:#8a2d2d;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-size:13px;font-weight:900;\">Remove Tyre</button>": ""
  	      )
  	      + (
  	        state.actionMode === "Allocate"
  	        ? ""
  	        + "    <button type=\"button\" id=\"tyreCompleteAllocationBtn\" style=\"background:#2a8f3a;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-size:13px;font-weight:900;\">Complete Allocation</button>"
  	        + "    <button type=\"button\" id=\"tyreCancelAllocationBtn\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-size:13px;font-weight:900;\">Cancel Allocation</button>": ""
  	        + tyreModeButtonHtml("RotateSwap", "Rotate / Swap")
  	        + tyreModeButtonHtml("Allocate", "Allocate")
  	      )
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function compactRotationArrowsHtml() {
  	      var arrows;

  	      if (state.actionMode !== "RotateSwap") {
  	        return "";
  	      }

  	      arrows = getRotationArrows();

  	      if (!arrows.length) {
  	        return ""
  	        + "<div style=\"border:1px solid #333;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	        + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Rotation Summary</div>"
  	        + "  <div style=\"padding:11px 12px;color:#777;font-size:12px;line-height:1.45;\">"
  	        + "Drag fitted tyres directly on the vehicle layout. Planned movement arrows will appear here."
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      return ""
  	      + "<div style=\"border:1px solid #2a8f3a;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	      + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Rotation Summary</div>"
  	      + "  <div style=\"padding:10px 12px;\">"
  	      + arrows.map(function (arrow) {
  	        return ""
  	        + "<div style=\"display:grid;grid-template-columns:64px 22px 64px minmax(0,1fr);gap:6px;align-items:center;padding:5px 0;border-bottom:1px solid #252525;font-size:12px;\">"
  	        + "  <div style=\"color:#fff;font-weight:900;text-align:center;background:#1f2937;border:1px solid #374151;border-radius:6px;padding:4px;\">" + escapeHtml(arrow.FromPosition) + "</div>"
  	        + "  <div style=\"color:#CC6633;font-size:16px;text-align:center;font-weight:900;\">→</div>"
  	        + "  <div style=\"color:#fff;font-weight:900;text-align:center;background:#1f2937;border:1px solid #374151;border-radius:6px;padding:4px;\">" + escapeHtml(arrow.ToPosition) + "</div>"
  	        + "  <div style=\"color:#aaa;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\" title=\"" + escapeHtml(arrow.TyreLabel) + "\">" + escapeHtml(arrow.TyreLabel) + "</div>"
  	        + "</div>";
  	      }).join("")
  	      + "    <div style=\"display:flex;gap:8px;padding-top:10px;\">"
  	      + "      <button id=\"tyreOpenRotationSavePopupBtn\" type=\"button\" style=\"background:#2a8f3a;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:900;\">Save Rotation</button>"
  	      + "      <button id=\"tyreClearRotationPlanBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:900;\">Clear Plan</button>"
  	      + "    </div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function tyreCardHtml(tyre, sourceType, sourcePosition, targetSlot) {
  	      var id = tyreObjectId(tyre);
  	      var life = tyreLife(tyre);
  	      var lifeLabel = life === null ? "No data": life.toFixed(1) + "%";
  	      var enabled =
  	      (sourceType === "fitted" && state.actionMode === "RotateSwap") ||
  	      (sourceType === "warehouse" && state.actionMode === "Allocate");

  	      var validForTarget = true;
  	      var selectedByTap =
  	      state.tapSource &&
  	      state.tapSource.TyreObjectId === id &&
  	      state.tapSource.SourceType === sourceType &&
  	      clean(state.tapSource.SourcePosition) === clean(sourcePosition);

  	      if (targetSlot) {
  	        validForTarget = tyreMatchesSlot(tyre, targetSlot);
  	      }

  	      return ""
  	      + "<div class=\"trac-tyre-card\" draggable=\"" + (enabled ? "true": "false") + "\" "
  	      + "data-source-type=\"" + escapeHtml(sourceType) + "\" "
  	      + "data-tyre-object-id=\"" + escapeHtml(id) + "\" "
  	      + "data-source-position=\"" + escapeHtml(sourcePosition || "") + "\" "
  	      + "style=\""
  	      + "border:1px solid " + (selectedByTap ? "#ffffff": validForTarget ? "#333": "#7f1d1d") + ";"
  	      + "background:" + (selectedByTap ? "#263044": "#151515") + ";"
  	      + "border-radius:8px;"
  	      + "padding:8px;"
  	      + "margin-bottom:7px;"
  	      + "cursor:" + (enabled ? "grab": "not-allowed") + ";"
  	      + "opacity:" + (enabled ? "1": "0.45") + ";"
  	      + "box-shadow:0 1px 3px rgba(0,0,0,0.35);"
  	      + "\">"
  	      + "  <div style=\"display:flex;gap:8px;align-items:center;\">"
  	      + "    <div style=\"width:34px;flex:0 0 34px;\">" + tyreTreadHtml(tyreColor(tyre), false, false) + "</div>"
  	      + "    <div style=\"min-width:0;flex:1;\">"
  	      + "      <div style=\"color:#fff;font-size:12px;font-weight:800;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\">" + escapeHtml(tyreName(tyre)) + "</div>"
  	      + "      <div style=\"color:#999;font-size:11px;margin-top:2px;\">"
  	      + escapeHtml(sourcePosition ? sourcePosition + " • ": "")
  	      + escapeHtml(tyreType(tyre) || "No Type")
  	      + " • Life " + escapeHtml(lifeLabel)
  	      + "      </div>"
  	      + "    </div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function fittedTyreListHtml(tPositions) {
  	      var rows = fittedTyresForVehicle(tPositions);

  	      if (!rows.length) {
  	        return "<div style=\"color:#777;font-size:12px;padding:8px;\">No tyres fitted to this vehicle.</div>";
  	      }

  	      return rows.map(function (row) {
  	        return tyreCardHtml(row.tyre, "fitted", row.positionKey, null);
  	      }).join("");
  	    }

  	    function warehouseTyreListHtml(tPositions) {
  	      var selectedSlot = getSlot(tPositions, state.selectedPosition);
  	      var tyres = allAvailableWarehouseTyres();

  	      if (!tyres.length) {
  	        return "<div style=\"color:#777;font-size:12px;padding:8px;\">No available warehouse tyres found.</div>";
  	      }

  	      return tyres.map(function (tyre) {
  	        return tyreCardHtml(tyre, "warehouse", "", selectedSlot);
  	      }).join("");
  	    }

  	    function closeFloatingPopup(id) {
  	      var el = DocumentSafe.getElementById(id);

  	      if (el && el.parentNode) {
  	        el.parentNode.removeChild(el);
  	      }
  	    }


  	    function floatingPopupShellHtml(id, title, innerHtml, width) {
  	      var defaultLeft = id === "allocateTyrePopup" ? "420px": "50%";
  	      var defaultTop = id === "allocateTyrePopup" ? "92px": "92px";
  	      var defaultTransform = id === "allocateTyrePopup" ? "none": "translateX(-50%)";

  	      return ""
  	      + "<div id=\"" + escapeHtml(id) + "\" style=\""
  	      + "position:fixed;"
  	      + "top:" + defaultTop + ";"
  	      + "left:" + defaultLeft + ";"
  	      + "transform:" + defaultTransform + ";"
  	      + "width:" + escapeHtml(width || "760px") + ";"
  	      + "max-width:calc(100vw - 40px);"
  	      + "max-height:calc(100vh - 110px);"
  	      + "z-index:1500;"
  	      + "background:#101010;"
  	      + "border:1px solid #333;"
  	      + "border-radius:10px;"
  	      + "box-shadow:0 18px 50px rgba(0,0,0,0.72);"
  	      + "overflow:hidden;"
  	      + "font-family:system-ui,sans-serif;"
  	      + "color:#fff;"
  	      + "\">"
  	      + "  <div data-popup-drag-handle=\"" + escapeHtml(id) + "\" style=\"display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;border-bottom:1px solid #333;background:#181818;cursor:move;user-select:none;\">"
  	      + "    <div style=\"color:#CC6633;font-size:15px;font-weight:900;\">" + escapeHtml(title) + "</div>"
  	      + "    <button type=\"button\" data-popup-close=\"" + escapeHtml(id) + "\" style=\"background:#555;color:#fff;border:none;border-radius:7px;padding:6px 10px;cursor:pointer;font-weight:900;\">✕</button>"
  	      + "  </div>"
  	      + "  <div style=\"padding:12px;overflow:auto;max-height:calc(100vh - 175px);\">"
  	      + innerHtml
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function wirePopupCloseButtons(container) {
  	      var buttons = container.querySelectorAll("[data-popup-close]");

  	      Array.prototype.forEach.call(buttons, function (button) {
  	        button.onclick = function () {
  	          var id = button.getAttribute("data-popup-close");

  	          if (id === "allocateTyrePopup") {
  	            state.allocatePopupOpen = false;
  	          }

  	          if (id === "rotationSavePopup") {
  	            state.rotationPopupOpen = false;
  	          }

  	          closeFloatingPopup(id);
  	        };
  	      });

  	      container.onclick = function (event) {
  	        if (event.target === container) {
  	          if (container.id === "allocateTyrePopup") {
  	            state.allocatePopupOpen = false;
  	          }

  	          if (container.id === "rotationSavePopup") {
  	            state.rotationPopupOpen = false;
  	          }

  	          closeFloatingPopup(container.id);
  	        }
  	      };
  	    }

  	    function makeFloatingPopupDraggable(popup) {
  	      var handle;
  	      var startX = 0;
  	      var startY = 0;
  	      var startLeft = 0;
  	      var startTop = 0;
  	      var dragging = false;

  	      if (!popup) {
  	        return;
  	      }

  	      handle = popup.querySelector("[data-popup-drag-handle]");

  	      if (!handle) {
  	        return;
  	      }

  	      handle.onmousedown = function (event) {
  	        var rect;

  	        if (event.target && event.target.getAttribute && event.target.getAttribute("data-popup-close")) {
  	          return;
  	        }

  	        rect = popup.getBoundingClientRect();

  	        dragging = true;
  	        startX = event.clientX;
  	        startY = event.clientY;
  	        startLeft = rect.left;
  	        startTop = rect.top;

  	        popup.style.transform = "none";
  	        popup.style.left = startLeft + "px";
  	        popup.style.top = startTop + "px";

  	        event.preventDefault();
  	      };

  	      DocumentSafe.addEventListener("mousemove", function (event) {
  	        var nextLeft;
  	        var nextTop;
  	        var maxLeft;
  	        var maxTop;

  	        if (!dragging) {
  	          return;
  	        }

  	        maxLeft = Math.max(0, WindowSafe.innerWidth - popup.offsetWidth - 8);
  	        maxTop = Math.max(0, WindowSafe.innerHeight - popup.offsetHeight - 8);

  	        nextLeft = startLeft + (event.clientX - startX);
  	        nextTop = startTop + (event.clientY - startY);

  	        nextLeft = Math.max(8, Math.min(maxLeft, nextLeft));
  	        nextTop = Math.max(44, Math.min(maxTop, nextTop));

  	        popup.style.left = nextLeft + "px";
  	        popup.style.top = nextTop + "px";
  	      });

  	      DocumentSafe.addEventListener("mouseup",
  	        function () {
  	          dragging = false;
  	        });
  	    }

  	    function tyreSearchBlob(tyre) {
  	      return [
  	        tyreObjectId(tyre),
  	        tyreNumber(tyre),
  	        tyreSerial(tyre),
  	        tyreMake(tyre),
  	        tyreModel(tyre),
  	        tyreSize(tyre),
  	        tyreType(tyre),
  	        tyreStatus(tyre),
  	        tyre.Current_Stage,
  	        tyre.Current_Mileage,
  	        tyre.Expected_Mileage,
  	        tyre.Current_Life
  	      ].join(" ").toLowerCase();
  	    }

  	    function filteredAllocateTyres() {
  	      var searchText = clean(state.allocateSearch).toLowerCase();
  	      var typeFilter = clean(state.allocateTypeFilter);

  	      return allAvailableWarehouseTyres().filter(function (tyre) {
  	        if (typeFilter && tyreType(tyre) !== typeFilter) {
  	          return false;
  	        }

  	        if (searchText && tyreSearchBlob(tyre).indexOf(searchText) === -1) {
  	          return false;
  	        }

  	        return true;
  	      });
  	    }

  	    function allocateTyreCardHtml(tyre) {
  	      var id = tyreObjectId(tyre);
  	      var life = tyreLife(tyre);
  	      var lifeLabel = life === null ? "No data": life.toFixed(1) + "%";
  	      var selected = state.allocateSelectedTyreId === id;

  	      return ""
  	      + "<div class=\"allocate-tyre-popup-card\" draggable=\"true\" "
  	      + "data-source-type=\"warehouse\" "
  	      + "data-tyre-object-id=\"" + escapeHtml(id) + "\" "
  	      + "data-source-position=\"\" "
  	      + "style=\""
  	      + "border:1px solid " + (selected ? "#fff": "#333") + ";"
  	      + "background:" + (selected ? "#263044": "#151515") + ";"
  	      + "border-radius:8px;"
  	      + "padding:9px;"
  	      + "margin-bottom:8px;"
  	      + "cursor:grab;"
  	      + "box-shadow:0 1px 3px rgba(0,0,0,0.35);"
  	      + "\">"
  	      + "  <div style=\"display:flex;gap:9px;align-items:center;\">"
  	      + "    <div style=\"width:38px;flex:0 0 38px;\">" + tyreTreadHtml(tyreColor(tyre),
  	        false,
  	        false) + "</div>"
  	      + "    <div style=\"min-width:0;flex:1;\">"
  	      + "      <div style=\"color:#fff;font-size:13px;font-weight:900;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\">" + escapeHtml(tyreName(tyre)) + "</div>"
  	      + "      <div style=\"color:#999;font-size:11px;margin-top:3px;\">"
  	      + "        Type: " + escapeHtml(tyreType(tyre) || "No Type")
  	      + " • Stage: " + escapeHtml(tyre.Current_Stage || "")
  	      + " • Life: " + escapeHtml(lifeLabel)
  	      + "      </div>"
  	      + "      <div style=\"color:#777;font-size:11px;margin-top:2px;\">"
  	      + "        Status: " + escapeHtml(tyreStatus(tyre))
  	      + " • Size: " + escapeHtml(tyreSize(tyre) || "")
  	      + "      </div>"
  	      + "    </div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function allocateTypeOptionsHtml() {
  	      var types = ["", "Steer", "Drive", "Trailer", "Spare"];

  	      return types.map(function (type) {
  	        return "<option value=\"" + escapeHtml(type) + "\" " + (state.allocateTypeFilter === type ? "selected": "") + ">"
  	        + escapeHtml(type || "All Types")
  	        + "</option>";
  	      }).join("");
  	    }

  	    function allocatePendingPopupHtml() {
  	      var pending = state.pendingTyreAction;
  	      var validation = pending ? validatePendingStillPossible(): null;

  	      if (!pending) {
  	        return ""
  	        + "<div style=\"border:1px solid #333;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	        + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Pending Allocation</div>"
  	        + "  <div style=\"padding:11px 12px;color:#777;font-size:12px;line-height:1.45;\">"
  	        + "Select or drag a warehouse tyre, then click or drop onto a target position. The confirmation will appear here."
  	        + "  </div>"
  	        + "  <div style=\"display:flex;justify-content:flex-end;gap:8px;padding:0 12px 12px;\">"
  	        + "    <button id=\"allocateDoneRotateBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:900;\">Done / Rotate-Swap</button>"
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      return ""
  	      + "<div style=\"border:1px solid " + (validation && !validation.ok ? "#8a2d2d": "#2a8f3a") + ";background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	      + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Pending Allocation</div>"
  	      + "  <div style=\"padding:11px 12px;\">"
  	      + "    <div style=\"color:#fff;font-size:15px;font-weight:900;margin-bottom:5px;\">" + escapeHtml(pendingActionLabel()) + "</div>"
  	      + "    <div style=\"color:#aaa;font-size:12px;margin-bottom:10px;\">" + escapeHtml(pending.Preview || "") + "</div>"
  	      + (
  	        validation && !validation.ok
  	        ? "<div style=\"color:#ff8a8a;font-size:12px;margin-bottom:10px;\">" + escapeHtml(validation.message) + "</div>": ""
  	      )
  	      + "    <div style=\"height:1px;background:#252525;margin:10px 0;\"></div>"
  	      + "    <div style=\"margin-bottom:10px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	      + "      <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	      + "    </div>"
  	      + "    <div style=\"margin-bottom:12px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	      + "      <textarea id=\"tyreActionNotes\" placeholder=\"Allocation notes\" style=\"width:100%;box-sizing:border-box;min-height:58px;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	      + "    </div>"
  	      + "    <div style=\"display:flex;gap:8px;flex-wrap:wrap;\">"
  	      + "      <button id=\"allocatePopupConfirmBtn\" type=\"button\" style=\"background:#2a8f3a;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Confirm Allocation</button>"
  	      + "      <button id=\"allocatePopupClearPendingBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Clear</button>"
  	      + "      <button id=\"allocateDoneRotateBtn\" type=\"button\" style=\"background:#CC6633;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;margin-left:auto;\">Done / Rotate-Swap</button>"
  	      + "    </div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function closeFloatingPopup(id) {
  	      var popup;

  	      if (!DocumentSafe || !id) {
  	        return;
  	      }

  	      popup = DocumentSafe.getElementById(id);

  	      if (popup && popup.parentNode) {
  	        popup.parentNode.removeChild(popup);
  	      }
  	    }

  	    function renderAllocatePopup() {
  	      var mount = DocumentSafe.getElementById("allocateTyreInlineMount");
  	      var popup;
  	      var tyres;
  	      var html;

  	      closeFloatingPopup("allocateTyrePopup");

  	      if (!mount) {
  	        return;
  	      }

  	      if (!state.allocatePopupOpen || state.actionMode !== "Allocate") {
  	        mount.innerHTML = "";
  	        return;
  	      }

  	      tyres = filteredAllocateTyres();

  	      html = ""
  	      + "<div id=\"allocateTyrePopup\" style=\""
  	      + "border:1px solid #333;"
  	      + "background:#101010;"
  	      + "border-radius:8px;"
  	      + "box-shadow:0 10px 28px rgba(0,0,0,0.42);"
  	      + "overflow:hidden;"
  	      + "display:flex;"
  	      + "flex-direction:column;"
  	      + "max-height:calc(100vh - 430px);"
  	      + "min-height:260px;"
  	      + "\">"

  	      + "  <div style=\"display:flex;align-items:center;justify-content:space-between;gap:10px;padding:9px 10px;border-bottom:1px solid #333;background:#181818;flex:0 0 auto;\">"
  	      + "    <div style=\"color:#CC6633;font-size:13px;font-weight:900;\">Allocate Tyre</div>"
  	      + "    <button type=\"button\" data-popup-close=\"allocateTyrePopup\" style=\"background:#555;color:#fff;border:none;border-radius:6px;padding:4px 8px;cursor:pointer;font-weight:900;line-height:1;\">✕</button>"
  	      + "  </div>"

  	      + "  <div style=\"padding:10px;display:flex;flex-direction:column;gap:9px;min-height:0;flex:1 1 auto;\">"

  	      + "    <div style=\"display:grid;grid-template-columns:1fr 118px;gap:8px;flex:0 0 auto;\">"
  	      + "      <div>"
  	      + "        <label style=\"display:block;color:#aaa;font-size:11px;margin-bottom:4px;\">Search available tyres</label>"
  	      + "        <input id=\"allocateTyreSearchInput\" type=\"text\" value=\"" + escapeHtml(state.allocateSearch || "") + "\" placeholder=\"Search ID, serial, make, model, size...\" style=\"width:100%;box-sizing:border-box;padding:7px;border:1px solid #343434;border-radius:6px;background:#151515;color:#fff;font-size:12px;\">"
  	      + "      </div>"
  	      + "      <div>"
  	      + "        <label style=\"display:block;color:#aaa;font-size:11px;margin-bottom:4px;\">Type</label>"
  	      + "        <select id=\"allocateTyreTypeFilter\" style=\"width:100%;box-sizing:border-box;padding:7px;border:1px solid #343434;border-radius:6px;background:#151515;color:#fff;font-size:12px;\">"
  	      + allocateTypeOptionsHtml()
  	      + "        </select>"
  	      + "      </div>"
  	      + "    </div>"

  	      + "    <div style=\"color:#888;font-size:11px;line-height:1.35;flex:0 0 auto;\">"
  	      + "Drag a warehouse tyre onto the vehicle layout, or click a tyre here and then click the target position."
  	      + "    </div>"

  	      + "    <div style=\"flex:0 0 auto;\">"
  	      + allocationPlanInlineStatusHtml()
  	      + "    </div>"

  	      + "    <div style=\"display:flex;justify-content:space-between;align-items:center;flex:0 0 auto;\">"
  	      + "      <div style=\"color:#fff;font-size:13px;font-weight:900;\">Available Tyres</div>"
  	      + "      <div style=\"color:#777;font-size:12px;\">" + escapeHtml(tyres.length) + " found</div>"
  	      + "    </div>"

  	      + "    <div id=\"allocateTyrePopupList\" style=\"flex:1 1 auto;min-height:170px;overflow:auto;padding-right:5px;\">"
  	      + (
  	        tyres.length
  	        ? tyres.map(allocateTyreCardHtml).join(""): "<div style=\"color:#777;border:1px dashed #444;border-radius:8px;padding:12px;\">No available tyres match this search.</div>"
  	      )
  	      + "    </div>"

  	      + "  </div>"
  	      + "</div>";

  	      mount.innerHTML = html;

  	      popup = DocumentSafe.getElementById("allocateTyrePopup");

  	      if (!popup) {
  	        return;
  	      }

  	      wireAllocatePopupEvents(popup);
  	    }

  	    function wireAllocatePopupEvents(popup) {
  	      var searchInput = popup.querySelector("#allocateTyreSearchInput");
  	      var typeFilter = popup.querySelector("#allocateTyreTypeFilter");
  	      var cards = popup.querySelectorAll(".allocate-tyre-popup-card");
  	      var saveAllocatePlanBtn = popup.querySelector("#allocateSavePlanBtn");
  	      var clearAllocatePlanBtn = popup.querySelector("#allocateClearPlanBtn");
  	      var doneRotateBtn = popup.querySelector("#allocateDoneRotateBtn");
  	      var closeButtons = popup.querySelectorAll("[data-popup-close=\"allocateTyrePopup\"]");
  	      if (saveAllocatePlanBtn) {
  	        saveAllocatePlanBtn.onclick = function () {
  	          saveAllocationPlanFromUi(saveAllocatePlanBtn)
  	          .catch(function (error) {
  	            state.actionMessage = error && error.message ? error.message: "Could not save tyre changes.";
  	            state.actionError = true;
  	            renderAllocatePopup();
  	            renderVisualTyreOperations();
  	          });
  	        };
  	      }

  	      if (clearAllocatePlanBtn) {
  	        clearAllocatePlanBtn.onclick = function () {
  	          beginRotationPlan();

  	          state.pendingTyreAction = null;
  	          state.dragSource = null;
  	          state.tapSource = null;
  	          state.allocateSelectedTyreId = "";
  	          state.actionMessage = "Allocation plan cleared.";
  	          state.actionError = false;

  	          renderVisualTyreOperations();
  	          renderAllocatePopup();
  	        };
  	      }

  	      if (doneRotateBtn) {
  	        doneRotateBtn.onclick = function () {
  	          enterRotateSwapAfterAllocate("Allocate finished. Rotate / Swap unlocked. Drag fitted tyres directly on the vehicle layout.");
  	        };
  	      }

  	      Array.prototype.forEach.call(closeButtons, function (button) {
  	        button.onclick = function (event) {
  	          if (event && event.preventDefault) {
  	            event.preventDefault();
  	          }

  	          if (event && event.stopPropagation) {
  	            event.stopPropagation();
  	          }

  	          lockTyreMovementState("Allocation cancelled. Tyre layout reset.");
  	        };
  	      });

  	      if (searchInput) {
  	        searchInput.oninput = function () {
  	          state.allocateSearch = searchInput.value || "";
  	          renderAllocatePopup();
  	        };
  	      }

  	      if (typeFilter) {
  	        typeFilter.onchange = function () {
  	          state.allocateTypeFilter = typeFilter.value || "";
  	          renderAllocatePopup();
  	        };
  	      }

  	      Array.prototype.forEach.call(cards, function (card) {
  	        card.addEventListener("dragstart", function (event) {
  	          var tyreId = card.getAttribute("data-tyre-object-id") || "";
  	          var source = {
  	            SourceType: "warehouse",
  	            TyreObjectId: tyreId,
  	            SourcePosition: ""
  	          };

  	          state.actionMode = "Allocate";
  	          setDragSource("warehouse", tyreId, "");

  	          if (event.dataTransfer) {
  	            event.dataTransfer.effectAllowed = "move";
  	            event.dataTransfer.setData("text/plain", JSON.stringify(source));
  	          }

  	          card.style.opacity = "0.55";
  	        });

  	        card.addEventListener("dragend",
  	          function () {
  	            card.style.opacity = "1";
  	            state.dragSource = null;
  	          });

  	        card.onclick = function () {
  	          var tyreId = card.getAttribute("data-tyre-object-id") || "";

  	          state.actionMode = "Allocate";
  	          state.allocatePopupOpen = true;
  	          state.allocateSelectedTyreId = tyreId;

  	          setTapSource("warehouse",
  	            tyreId,
  	            "");

  	          state.actionMessage = "Tyre selected. Click the target position on the vehicle layout. Type mismatches will warn before continuing.";
  	          state.actionError = false;

  	          renderVisualTyreOperations();
  	          renderAllocatePopup();
  	        };
  	      });
  	    }

  	    function getRotationBaselineOdometer(arrows) {
  	      var best = vehicleOdometerBaseline(state.activeTractor || tractor);

  	      arr(arrows).forEach(function (arrow) {
  	        var tyre = findTyre(arrow.TyreObjectId);
  	        var a = numberOrNull(tyre && tyre.Last_Vehicle_Odometer);
  	        var b = numberOrNull(tyre && tyre.Fitted_Odometer);

  	        if (a !== null && a > best) {
  	          best = a;
  	        }

  	        if (b !== null && b > best) {
  	          best = b;
  	        }
  	      });

  	      return best;
  	    }

  	    function validateRotationMileage(value,
  	      baseline) {
  	      var mileage = numberOrNull(value);
  	      var maxJump = 25000;
  	      var minAllowed = baseline || 0;

  	      if (mileage === null) {
  	        return {
  	          ok: false,
  	          mileage: null,
  	          message: "Enter the vehicle odometer before saving the rotation."
  	        };
  	      }

  	      if (mileage <= 0) {
  	        return {
  	          ok: false,
  	          mileage: mileage,
  	          message: "Vehicle odometer must be greater than zero."
  	        };
  	      }

  	      if (minAllowed > 0 && mileage < minAllowed) {
  	        return {
  	          ok: false,
  	          mileage: mileage,
  	          message: "Odometer is lower than the last known reading of " + minAllowed + " km."
  	        };
  	      }

  	      if (minAllowed >= 1000 && mileage > minAllowed + maxJump) {
  	        return {
  	          ok: false,
  	          mileage: mileage,
  	          message: "Odometer jump is too high. Last known: " + minAllowed + " km. Entered: " + mileage + " km."
  	        };
  	      }

  	      return {
  	        ok: true,
  	        mileage: mileage,
  	        message: ""
  	      };
  	    }

  	    function rotationReportHtml(arrows, odometer, notes) {
  	      var currentVehicle = state.activeTractor || tractor;
  	      var finalTPositions = state.rotationDraftTPositions || normaliseTPositions(readTPositionsRaw(currentVehicle));
  	      var generatedAt = new Date().toLocaleString();
  	      var logoHtml = reportLogoHtml();

  	      return ""
  	      + "<div style=\"font-family:Arial,sans-serif;color:#111;padding:20px 22px;\">"
  	      + "  <div style=\"display:flex;justify-content:space-between;align-items:flex-start;gap:18px;border-bottom:2px solid #CC6633;padding-bottom:10px;margin-bottom:14px;\">"
  	      + "    <div>"
  	      + "      <h2 style=\"margin:0 0 5px;font-size:22px;color:#111;\">Tyre Rotation Report</h2>"
  	      + "      <div style=\"font-size:12px;color:#555;\">Generated: " + escapeHtml(generatedAt) + "</div>"
  	      + "      <div style=\"font-size:12px;color:#777;margin-top:2px;\">Rotation / Swap Report</div>"
  	      + "    </div>"
  	      + "    <div style=\"min-width:160px;text-align:right;display:flex;justify-content:flex-end;align-items:flex-start;\">"
  	      + (logoHtml || "<div style=\"font-size:12px;color:#b44;\">No SVG logo received</div>")
  	      + "    </div>"
  	      + "  </div>"

  	      + "  <table style=\"width:100%;border-collapse:collapse;margin-bottom:16px;font-size:13px;\">"
  	      + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;width:170px;background:#f3f3f3;\">Vehicle</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(vehicleTitle(currentVehicle)) + "</td></tr>"
  	      + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;background:#f3f3f3;\">Vehicle ID</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(vehicleId(currentVehicle)) + "</td></tr>"
  	      + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;background:#f3f3f3;\">Registration</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(vehicleReg(currentVehicle)) + "</td></tr>"
  	      + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;background:#f3f3f3;\">Odometer</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(odometer || "") + " km</td></tr>"
  	      + "    <tr><td style=\"font-weight:bold;padding:6px;border:1px solid #ccc;background:#f3f3f3;\">Notes</td><td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(notes || "") + "</td></tr>"
  	      + "  </table>"

  	      + "  <h3 style=\"margin:12px 0 8px;font-size:16px;\">Planned Tyre Movements</h3>"
  	      + "  <table style=\"width:100%;border-collapse:collapse;font-size:12px;\">"
  	      + "    <thead>"
  	      + "      <tr>"
  	      + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">From</th>"
  	      + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">To</th>"
  	      + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">Tyre</th>"
  	      + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">Actual Type</th>"
  	      + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">Required Type</th>"
  	      + "        <th style=\"text-align:left;padding:6px;border:1px solid #ccc;background:#eee;\">Mismatch</th>"
  	      + "      </tr>"
  	      + "    </thead>"
  	      + "    <tbody>"
  	      + arrows.map(function (arrow) {
  	        var tyre = findTyre(arrow.TyreObjectId);
  	        var finalSlot = getSlot(finalTPositions, arrow.ToPosition);
  	        var mismatch = tyre && finalSlot ? tyreMismatchInfo(tyre, finalSlot): null;

  	        return ""
  	        + "<tr>"
  	        + "  <td style=\"padding:6px;border:1px solid #ccc;font-weight:bold;\">" + escapeHtml(arrow.FromPosition) + "</td>"
  	        + "  <td style=\"padding:6px;border:1px solid #ccc;font-weight:bold;\">" + escapeHtml(arrow.ToPosition) + "</td>"
  	        + "  <td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(arrow.TyreLabel) + "</td>"
  	        + "  <td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(mismatch ? mismatch.ActualType: "") + "</td>"
  	        + "  <td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(mismatch ? mismatch.RequiredType: "") + "</td>"
  	        + "  <td style=\"padding:6px;border:1px solid #ccc;\">" + escapeHtml(mismatch && mismatch.HasMismatch ? "Accepted / To be recorded": "No") + "</td>"
  	        + "</tr>";
  	      }).join("")
  	      + "    </tbody>"
  	      + "  </table>"

  	      + "  <div style=\"margin-top:28px;display:grid;grid-template-columns:1fr 1fr;gap:28px;font-size:12px;color:#555;\">"
  	      + "    <div>Captured By: ________________________________</div>"
  	      + "    <div>Checked By: ________________________________</div>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function printRotationReportFromPopup() {
  	      var arrows = getRotationArrows();
  	      var odometerInput = DocumentSafe.getElementById("tyreActionOdometer");
  	      var notesInput = DocumentSafe.getElementById("tyreActionNotes");
  	      var odometer = odometerInput ? odometerInput.value: "";
  	      var notes = notesInput ? notesInput.value: "";
  	      var frame;
  	      var doc;
  	      var html;

  	      if (!arrows.length) {
  	        alertSafe("No rotation movements to print.");
  	        return;
  	      }

  	      if (!DocumentSafe || !DocumentSafe.body) {
  	        alertSafe("Printing is unavailable in this browser.");
  	        return;
  	      }

  	      html = rotationReportHtml(arrows, odometer, notes);

  	      frame = DocumentSafe.createElement("iframe");

  	      frame.style.position = "fixed";
  	      frame.style.right = "0";
  	      frame.style.bottom = "0";
  	      frame.style.width = "0";
  	      frame.style.height = "0";
  	      frame.style.border = "0";
  	      frame.style.opacity = "0";
  	      frame.style.pointerEvents = "none";

  	      DocumentSafe.body.appendChild(frame);

  	      doc = frame.contentWindow.document;
  	      doc.open();
  	      doc.write("")
  	      doc.write("<!doctype html>");
  	      doc.write("<html>");
  	      doc.write("<head>");
  	      doc.write("  <meta charset=\"utf-8\">");
  	      doc.write("  <title>Tyre Rotation Report</title>");
  	      doc.write("  <style>");
  	      doc.write("    @page{size:A4 landscape;margin:10mm;}");
  	      doc.write("    html,body{margin:0;padding:0;background:#fff;color:#000;font-family:Arial,sans-serif;}");
  	      doc.write("    *{box-sizing:border-box;}");
  	      doc.write("    table{width:100%;border-collapse:collapse;page-break-inside:auto;}");
  	      doc.write("    th,td{page-break-inside:avoid;}");
  	      doc.write("    tr{page-break-inside:avoid;page-break-after:auto;}");
  	      doc.write("    h2{page-break-after:avoid;}");
  	      doc.write("    @media print{body{margin:0;}button{display:none!important;}}");
  	      doc.write("  </style>");
  	      doc.write("</head>");
  	      doc.write("<body>");
  	      doc.write(html);
  	      doc.write("</body>");
  	      doc.write("</html>");
  	      doc.close();

  	      setTimeout(function () {
  	        try {
  	          frame.contentWindow.focus();
  	          frame.contentWindow.print();

  	          setTimeout(function () {
  	            if (frame && frame.parentNode) {
  	              frame.parentNode.removeChild(frame);
  	            }
  	          },
  	            1000);
  	        } catch (error) {
  	          console.warn("TRAC-MAN: rotation report print failed",
  	            error);
  	          alertSafe("Could not print the rotation report.");
  	        }
  	      }, 250);
  	    }

  	    function renderRotationSavePopup() {
  	      var arrows = getRotationArrows();
  	      var baseline = getRotationBaselineOdometer(arrows);
  	      var html;
  	      var popup;

  	      closeFloatingPopup("rotationSavePopup");

  	      if (!state.rotationPopupOpen) {
  	        return;
  	      }

  	      if (!arrows.length) {
  	        state.rotationPopupOpen = false;
  	        state.actionMessage = "No rotation changes to save.";
  	        state.actionError = true;
  	        renderVisualTyreOperations();
  	        return;
  	      }

  	      html = ""
  	      + "<div style=\"color:#aaa;font-size:12px;line-height:1.45;margin-bottom:10px;\">"
  	      + "Review the full rotation breakdown, enter one believable vehicle odometer reading, then save. The same odometer and notes will be written to every tyre movement."
  	      + "</div>"
  	      + "<div style=\"border:1px solid #333;border-radius:8px;overflow:hidden;margin-bottom:12px;\">"
  	      + "  <div style=\"padding:9px 12px;background:#181818;border-bottom:1px solid #333;color:#fff;font-weight:900;\">Planned tyre movements</div>"
  	      + "  <div style=\"padding:10px 12px;\">"
  	      + arrows.map(function (arrow) {
  	        return ""
  	        + "<div style=\"display:grid;grid-template-columns:70px 24px 70px minmax(0,1fr);gap:7px;align-items:center;padding:6px 0;border-bottom:1px solid #252525;font-size:12px;\">"
  	        + "  <div style=\"color:#fff;font-weight:900;text-align:center;background:#1f2937;border:1px solid #374151;border-radius:6px;padding:5px;\">" + escapeHtml(arrow.FromPosition) + "</div>"
  	        + "  <div style=\"color:#CC6633;font-size:18px;text-align:center;font-weight:900;\">→</div>"
  	        + "  <div style=\"color:#fff;font-weight:900;text-align:center;background:#1f2937;border:1px solid #374151;border-radius:6px;padding:5px;\">" + escapeHtml(arrow.ToPosition) + "</div>"
  	        + "  <div style=\"color:#aaa;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\" title=\"" + escapeHtml(arrow.TyreLabel) + "\">" + escapeHtml(arrow.TyreLabel) + "</div>"
  	        + "</div>";
  	      }).join("")
  	      + "  </div>"
  	      + "</div>"
  	      + "<div style=\"color:#999;font-size:12px;margin-bottom:8px;\">Last known tyre odometer baseline: " + escapeHtml(baseline || "No reliable baseline") + "</div>"
  	      + "<div style=\"margin-bottom:10px;\">"
  	      + "  <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	      + "  <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	      + "  <div id=\"rotationMileageError\" style=\"color:#ff4d4f;font-size:12px;margin-top:5px;min-height:16px;\"></div>"
  	      + "</div>"
  	      + "<div style=\"margin-bottom:12px;\">"
  	      + "  <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	      + "  <textarea id=\"tyreActionNotes\" placeholder=\"Rotation notes\" style=\"width:100%;box-sizing:border-box;min-height:70px;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	      + "</div>"
  	      + "<div style=\"display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;align-items:center;\">"
  	      + "  <button id=\"tyrePrintRotationReportBtn\" type=\"button\" style=\"background:#374151;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;margin-right:auto;display:inline-flex;align-items:center;gap:6px;\">🖨 Print Report</button>"
  	      + "  <button id=\"tyrePopupSaveRotationBtn\" type=\"button\" style=\"display:none;background:#2a8f3a;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Save Rotation Plan</button>"
  	      + "  <button data-popup-close=\"rotationSavePopup\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Cancel</button>"
  	      + "</div>";

  	      body.insertAdjacentHTML(
  	        "beforeend",
  	        floatingPopupShellHtml("rotationSavePopup", "Save Rotation Plan", html, "820px")
  	      );

  	      popup = DocumentSafe.getElementById("rotationSavePopup");

  	      if (!popup) {
  	        return;
  	      }

  	      wireRotationSavePopupEvents(popup, baseline);
  	    }

  	    function wireRotationSavePopupEvents(popup, baseline) {
  	      var saveBtn = popup.querySelector("#tyrePopupSaveRotationBtn");
  	      var printBtn = popup.querySelector("#tyrePrintRotationReportBtn");
  	      var odometerInput = popup.querySelector("#tyreActionOdometer");
  	      var errorEl = popup.querySelector("#rotationMileageError");

  	      wirePopupCloseButtons(popup);

  	      function refreshRotationSaveButton() {
  	        var validation = odometerInput ? validateRotationMileage(odometerInput.value, baseline): {
  	          ok: false,
  	          message: ""
  	        };

  	        if (errorEl) {
  	          errorEl.textContent = validation.ok || !odometerInput || !odometerInput.value ? "": validation.message;
  	        }

  	        if (saveBtn) {
  	          saveBtn.style.display = validation.ok ? "inline-flex": "none";
  	        }
  	      }

  	      refreshRotationSaveButton();

  	      if (odometerInput) {
  	        odometerInput.oninput = refreshRotationSaveButton;
  	        odometerInput.onchange = refreshRotationSaveButton;
  	      }

  	      if (printBtn) {
  	        printBtn.onclick = function () {
  	          printRotationReportFromPopup();
  	        };
  	      }

  	      if (saveBtn) {
  	        saveBtn.onclick = function () {
  	          var validation = validateRotationMileage(odometerInput ? odometerInput.value: "", baseline);

  	          if (!validation.ok) {
  	            if (errorEl) {
  	              errorEl.textContent = validation.message;
  	            }

  	            return;
  	          }

  	          saveBtn.disabled = true;
  	          saveBtn.textContent = "Saving...";

  	          saveRotationPlanFromUi()
  	          .then(function (message) {
  	            state.rotationPopupOpen = false;
  	            closeFloatingPopup("rotationSavePopup");

  	            state.actionMode = "";
  	            state.pendingTyreAction = null;
  	            state.dragSource = null;
  	            state.tapSource = null;

  	            state.actionMessage = message || "Rotation plan saved.";
  	            state.actionError = false;

  	            renderVisualTyreOperations();
  	            renderList(search.value || "");
  	          })
  	          .catch(function (error) {
  	            saveBtn.disabled = false;
  	            saveBtn.textContent = "Save Rotation Plan";
  	            refreshRotationSaveButton();

  	            if (errorEl) {
  	              errorEl.textContent = error && error.message ? error.message: "Rotation plan failed.";
  	            }
  	          });
  	        };
  	      }
  	    }

  	    function tyreDrawerHtml(tPositions) {
  	      return "";
  	    }
  	    // =========================================================
  	    // AXLE CONFIGURATOR RENDER
  	    // =========================================================
  	    function renderAxleConfigurator() {
  	      var draft = getDraftTPositions();
  	      var summary;
  	      var allowed;

  	      applyAxleRules(draft,
  	        false);
  	      rebuildSlots(draft);

  	      summary = summaryForTPositions(draft);
  	      allowed = allowedAxleTypes(VEHICLE_TYPE);

  	      body.innerHTML = ""
  	      + "<div style=\"display:flex;justify-content:space-between;align-items:flex-start;gap:12px;margin-bottom:12px;\">"
  	      + "  <div>"
  	      + "    <div style=\"font-size:16px;font-weight:700;color:#CC6633;\">Tyre Axle Configurator</div>"
  	      + "    <div style=\"font-size:12px;color:#aaa;margin-top:4px;\">TPositions defines the tractor axle layout. Tyre fitment is handled in view mode.</div>"
  	      + "    <div style=\"font-size:11px;color:#777;margin-top:4px;\">Rules: Steer = 1 per side. Spare = 1 total. Max 2 Steer axles. Tractor cannot use Trailer axles.</div>"
  	      + "  </div>"
  	      + "  <div style=\"font-size:12px;color:#ddd;text-align:right;background:#181818;border:1px solid #333;border-radius:8px;padding:8px 10px;\">"
  	      + "    <div>Axles: " + escapeHtml(summary.TotalAxles) + "</div>"
  	      + "    <div>Positions: " + escapeHtml(summary.TotalPositions) + "</div>"
  	      + "    <div>Assigned: " + escapeHtml(summary.AssignedTyres) + "</div>"
  	      + "    <div>Empty: " + escapeHtml(summary.EmptyPositions) + "</div>"
  	      + "  </div>"
  	      + "</div>"
  	      + "<div style=\"display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px;\">"
  	      + "  <button data-action=\"add-axle\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#CC6633;color:#fff;cursor:pointer;\">Add Axle</button>"
  	      + "  <button data-action=\"add-spare\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#555;color:#fff;cursor:pointer;\">Add Spare</button>"
  	      + "  <button data-action=\"preset-4x2\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#333;color:#fff;cursor:pointer;\">Preset 4x2</button>"
  	      + "  <button data-action=\"preset-6x2-tag\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#333;color:#fff;cursor:pointer;\">Preset 6x2 Tag</button>"
  	      + "  <button data-action=\"preset-6x4\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#333;color:#fff;cursor:pointer;\">Preset 6x4</button>"
  	      + "  <button data-action=\"preset-8x4\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#333;color:#fff;cursor:pointer;\">Preset 8x4</button>"
  	      + "  <button data-action=\"clear-config\" style=\"padding:7px 12px;border:none;border-radius:6px;background:#7f1d1d;color:#fff;cursor:pointer;\">Clear Config</button>"
  	      + "</div>"
  	      + "<div style=\"font-weight:700;color:#CC6633;margin:10px 0 6px;\">Axles</div>"
  	      + "<div id=\"tyreAxleRows\"></div>"
  	      + "<div style=\"font-weight:700;color:#CC6633;margin:16px 0 6px;\">Generated Tyre Positions</div>"
  	      + "<div id=\"tyrePositionGrid\" style=\"display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:10px;\"></div>";

  	      renderAxleRows(draft,
  	        allowed);
  	      renderGeneratedPositionGrid(draft);
  	      wireAxleConfiguratorActions(draft);
  	    }

  	    function renderAxleRows(draft,
  	      allowed) {
  	      var axleRows = DocumentSafe.getElementById("tyreAxleRows");

  	      if (!axleRows) {
  	        return;
  	      }

  	      axleRows.innerHTML = "";

  	      if (!draft.Axles.length) {
  	        axleRows.innerHTML = ""
  	        + "<div style=\"color:#777;border:1px dashed #444;border-radius:8px;padding:12px;\">"
  	        + "No axle configuration yet. Click Add Axle or use a preset."
  	        + "</div>";
  	        return;
  	      }

  	      draft.Axles
  	      .sort(function (a, b) {
  	        return Number(a.Axle) - Number(b.Axle);
  	      })
  	      .forEach(function (axle, index) {
  	        var row = DocumentSafe.createElement("div");
  	        var tyreCountLocked = axle.Type === "Steer" || axle.Type === "Spare";
  	        var tyreCountDisabled = tyreCountLocked ? "disabled": "";
  	        var wearDisabled = axle.Type !== "Tag" ? "disabled": "";
  	        var typeOptions = "";

  	        allowed.forEach(function (type) {
  	          typeOptions += ""
  	          + "<option value=\"" + escapeHtml(type) + "\" " + (axle.Type === type ? "selected": "") + ">"
  	          + escapeHtml(type)
  	          + "</option>";
  	        });

  	        row.dataset.axleIndex = String(index);

  	        Object.assign(row.style, {
  	          display: "grid",
  	          gridTemplateColumns: "80px 150px 120px 120px 90px",
  	          gap: "8px",
  	          alignItems: "end",
  	          background: "#181818",
  	          border: "1px solid #333",
  	          borderRadius: "8px",
  	          padding: "10px",
  	          marginBottom: "8px"
  	        });

  	        row.innerHTML = ""
  	        + "<label style=\"font-size:12px;color:#aaa;\">Axle"
  	        + "  <input type=\"number\" min=\"1\" value=\"" + escapeHtml(axle.Axle) + "\" data-axle-field=\"Axle\" style=\"width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;\">"
  	        + "</label>"
  	        + "<label style=\"font-size:12px;color:#aaa;\">Type"
  	        + "  <select data-axle-field=\"Type\" style=\"width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;\">"
  	        + typeOptions
  	        + "  </select>"
  	        + "</label>"
  	        + "<label style=\"font-size:12px;color:#aaa;\">Tyres Per Side"
  	        + "  <input type=\"number\" min=\"1\" max=\"2\" step=\"1\" value=\"" + escapeHtml(axle.TyresPerSide) + "\" data-axle-field=\"TyresPerSide\" " + tyreCountDisabled + " style=\"width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + (tyreCountLocked ? "opacity:0.6;": "") + "\">"
  	        + "</label>"
  	        + "<label style=\"font-size:12px;color:#aaa;\">Wear Rate"
  	        + "  <input type=\"number\" min=\"0\" max=\"1\" step=\"0.01\" value=\"" + escapeHtml(axle.WearRate) + "\" data-axle-field=\"WearRate\" " + wearDisabled + " style=\"width:100%;margin-top:4px;padding:6px;border:1px solid #555;border-radius:6px;background:#111;color:#fff;" + (axle.Type !== "Tag" ? "opacity:0.6;": "") + "\">"
  	        + "</label>"
  	        + "<button data-action=\"remove-axle\" style=\"padding:7px 10px;border:none;border-radius:6px;background:#7f1d1d;color:#fff;cursor:pointer;\">Remove</button>";

  	        axleRows.appendChild(row);
  	      });
  	    }

  	    function renderGeneratedPositionGrid(draft) {
  	      var positionGrid = DocumentSafe.getElementById("tyrePositionGrid");
  	      var keys;

  	      if (!positionGrid) {
  	        return;
  	      }

  	      positionGrid.innerHTML = "";
  	      keys = sortedPositionKeys(draft);

  	      if (!keys.length) {
  	        positionGrid.innerHTML = ""
  	        + "<div style=\"color:#777;border:1px dashed #444;border-radius:8px;padding:12px;\">"
  	        + "No tyre positions generated yet."
  	        + "</div>";
  	        return;
  	      }

  	      keys.forEach(function (key) {
  	        var slot = draft.Positions[key];
  	        var card = DocumentSafe.createElement("div");

  	        Object.assign(card.style, {
  	          background: "#181818",
  	          border: "1px solid #333",
  	          borderRadius: "8px",
  	          padding: "10px"
  	        });

  	        card.innerHTML = ""
  	        + "<div style=\"display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;\">"
  	        + "  <div style=\"font-weight:700;color:#fff;\">" + escapeHtml(slot.PositionKey) + "</div>"
  	        + "  <div style=\"font-size:11px;color:#aaa;\">" + escapeHtml(slot.AxleType) + " / " + escapeHtml(slot.Side) + "</div>"
  	        + "</div>"
  	        + "<div style=\"font-size:11px;color:#777;margin-bottom:6px;\">"
  	        + (slot.AxleType === "Tag" ? "Wear allocation: " + escapeHtml(slot.WearRate): "Position generated from axle layout.")
  	        + "</div>"
  	        + renderSmallTyreDisplay(slot);

  	        positionGrid.appendChild(card);
  	      });
  	    }

  	    function wireAxleConfiguratorActions(draft) {
  	      var buttons = body.querySelectorAll("[data-action]");
  	      var inputs = body.querySelectorAll("[data-axle-field]");

  	      Array.prototype.forEach.call(buttons, function (button) {
  	        button.onclick = function () {
  	          var action = button.getAttribute("data-action");
  	          var maxAxle;
  	          var row;
  	          var index;

  	          if (action === "add-axle") {
  	            maxAxle = draft.Axles.reduce(function (max, axle) {
  	              return Math.max(max, Number(axle.Axle || 0));
  	            }, 0);

  	            draft.Axles.push({
  	              Axle: maxAxle + 1,
  	              Type: "Drive",
  	              TyresPerSide: 2,
  	              WearRate: 1,
  	              Enabled: true
  	            });

  	            applyAxleRules(draft, true);
  	            rebuildSlots(draft);
  	            renderAxleConfigurator();
  	            return;
  	          }

  	          if (action === "add-spare") {
  	            maxAxle = draft.Axles.reduce(function (max, axle) {
  	              return Math.max(max, Number(axle.Axle || 0));
  	            }, 0);

  	            draft.Axles.push({
  	              Axle: maxAxle + 1,
  	              Type: "Spare",
  	              TyresPerSide: 1,
  	              WearRate: 1,
  	              Enabled: true
  	            });

  	            applyAxleRules(draft, true);
  	            rebuildSlots(draft);
  	            renderAxleConfigurator();
  	            return;
  	          }

  	          if (action === "preset-4x2") {
  	            setPreset4x2(draft);
  	            renderAxleConfigurator();
  	            return;
  	          }

  	          if (action === "preset-6x2-tag") {
  	            setPreset6x2Tag(draft);
  	            renderAxleConfigurator();
  	            return;
  	          }

  	          if (action === "preset-6x4") {
  	            setPreset6x4(draft);
  	            renderAxleConfigurator();
  	            return;
  	          }

  	          if (action === "preset-8x4") {
  	            setPreset8x4(draft);
  	            renderAxleConfigurator();
  	            return;
  	          }

  	          if (action === "clear-config") {
  	            if (!confirmSafe("Clear the full tyre axle configuration?")) {
  	              return;
  	            }

  	            draft.Axles = [];
  	            draft.Positions = {};
  	            draft.Summary = summaryForTPositions(draft);
  	            renderAxleConfigurator();
  	            return;
  	          }

  	          if (action === "remove-axle") {
  	            row = button.closest("[data-axle-index]");
  	            index = Number(row && row.dataset ? row.dataset.axleIndex: null);

  	            if (!Number.isFinite(index)) {
  	              return;
  	            }

  	            draft.Axles.splice(index, 1);
  	            applyAxleRules(draft, true);
  	            rebuildSlots(draft);
  	            renderAxleConfigurator();
  	          }
  	        };
  	      });

  	      Array.prototype.forEach.call(inputs,
  	        function (input) {
  	          input.onchange = function () {
  	            var row = input.closest("[data-axle-index]");
  	            var index = Number(row && row.dataset ? row.dataset.axleIndex: null);
  	            var field = input.getAttribute("data-axle-field");
  	            var newType;

  	            if (!Number.isFinite(index) || !draft.Axles[index]) {
  	              return;
  	            }

  	            if (field === "Type") {
  	              newType = input.value;

  	              if (allowedAxleTypes(VEHICLE_TYPE).indexOf(newType) === -1) {
  	                alertSafe("This axle type is not allowed on this vehicle.");
  	                renderAxleConfigurator();
  	                return;
  	              }

  	              draft.Axles[index].Type = newType;

  	              if (newType === "Steer" || newType === "Spare") {
  	                draft.Axles[index].TyresPerSide = 1;
  	                draft.Axles[index].WearRate = 1;
  	              }

  	              if (newType === "Tag") {
  	                draft.Axles[index].WearRate = clamp(draft.Axles[index].WearRate, 0, 1, 1);
  	              }

  	              if (newType === "Drive") {
  	                draft.Axles[index].WearRate = 1;
  	              }
  	            }

  	            if (field === "Axle") {
  	              draft.Axles[index].Axle = Math.max(1, Number(input.value || 1));
  	            }

  	            if (field === "TyresPerSide") {
  	              draft.Axles[index].TyresPerSide = Math.round(clamp(input.value, 1, 2, 1));
  	            }

  	            if (field === "WearRate") {
  	              draft.Axles[index].WearRate = clamp(input.value, 0, 1, 1);
  	            }

  	            applyAxleRules(draft, true);
  	            rebuildSlots(draft);
  	            renderAxleConfigurator();
  	          };
  	        });
  	    }


  	    function removePanelHtml(tPositions) {
  	      var positionKey = clean(state.selectedPosition);
  	      var slot = positionKey ? getSlot(tPositions,
  	        positionKey): null;
  	      var tyre = slot && slot.TyreObjectId ? findTyre(slot.TyreObjectId): null;

  	      if (!slot || !slot.TyreObjectId || !tyre) {
  	        return ""
  	        + "<div style=\"border:1px solid #333;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	        + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Remove Tyre</div>"
  	        + "  <div style=\"padding:11px 12px;color:#777;font-size:12px;line-height:1.45;\">"
  	        + "Select a fitted tyre position to remove a tyre from this vehicle."
  	        + "  </div>"
  	        + "</div>";
  	      }

  	      return ""
  	      + "<div style=\"border:1px solid #333;background:#101010;border-radius:8px;overflow:hidden;margin-bottom:10px;\">"
  	      + "  <div style=\"padding:9px 12px;border-bottom:1px solid #333;background:#181818;color:#CC6633;font-size:13px;font-weight:800;\">Remove Tyre</div>"
  	      + "  <div style=\"padding:11px 12px;\">"
  	      + "    <div style=\"color:#fff;font-size:13px;font-weight:800;margin-bottom:6px;\">"
  	      + escapeHtml(slot.PositionKey) + " — " + escapeHtml(tyreName(tyre))
  	      + "    </div>"
  	      + "    <div style=\"margin-bottom:9px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Destination</label>"
  	      + "      <select id=\"tyreActionDestination\" style=\"width:100%;box-sizing:border-box;padding:8px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	      + "        <option value=\"Warehouse\">Warehouse</option>"
  	      + "        <option value=\"Retread\">In For Retread</option>"
  	      + "        <option value=\"Scrap\">Scrapped</option>"
  	      + "        <option value=\"Stolen\">Stolen</option>"
  	      + "      </select>"
  	      + "    </div>"
  	      + "    <div style=\"margin-bottom:9px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	      + "      <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:8px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	      + "    </div>"
  	      + "    <div style=\"margin-bottom:10px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	      + "      <textarea id=\"tyreActionNotes\" placeholder=\"Removal notes\" style=\"width:100%;box-sizing:border-box;min-height:62px;padding:8px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	      + "    </div>"
  	      + "    <button id=\"tyreRemoveSelectedBtn\" type=\"button\" style=\"background:#8a2d2d;color:#fff;border:none;padding:8px 12px;border-radius:7px;cursor:pointer;font-weight:800;\">Remove Selected Tyre</button>"
  	      + "  </div>"
  	      + "</div>";
  	    }

  	    function renderRemoveTyrePopup() {
  	      var slot = selectedRemovableTyreSlot();
  	      var tyre;
  	      var html;
  	      var popup;

  	      closeFloatingPopup("removeTyrePopup");

  	      if (!slot) {
  	        alertSafe("Select a fitted tyre first.");
  	        return;
  	      }

  	      tyre = findTyre(slot.TyreObjectId);

  	      if (!tyre) {
  	        alertSafe("The selected tyre record could not be found.");
  	        return;
  	      }

  	      html = ""
  	      + "<div id=\"removeTyrePopup\" style=\""
  	      + "position:fixed;"
  	      + "top:50%;"
  	      + "left:50%;"
  	      + "transform:translate(-50%,-50%);"
  	      + "width:560px;"
  	      + "max-width:calc(100vw - 40px);"
  	      + "max-height:calc(100vh - 80px);"
  	      + "z-index:3200;"
  	      + "background:#101010;"
  	      + "border:1px solid #333;"
  	      + "border-radius:10px;"
  	      + "box-shadow:0 20px 60px rgba(0,0,0,0.78);"
  	      + "overflow:hidden;"
  	      + "font-family:system-ui,sans-serif;"
  	      + "color:#fff;"
  	      + "\">"

  	      + "  <div style=\"display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;border-bottom:1px solid #333;background:#181818;\">"
  	      + "    <div style=\"color:#CC6633;font-size:15px;font-weight:900;\">Remove Tyre</div>"
  	      + "    <button type=\"button\" id=\"removeTyrePopupCloseBtn\" style=\"background:#555;color:#fff;border:none;border-radius:7px;padding:6px 10px;cursor:pointer;font-weight:900;\">✕</button>"
  	      + "  </div>"

  	      + "  <div style=\"padding:14px;\">"
  	      + "    <div style=\"border:1px solid #333;background:#151515;border-radius:8px;padding:12px;margin-bottom:12px;\">"
  	      + "      <div style=\"color:#fff;font-size:15px;font-weight:900;margin-bottom:5px;\">" + escapeHtml(tyreName(tyre)) + "</div>"
  	      + "      <div style=\"color:#aaa;font-size:12px;line-height:1.5;\">"
  	      + "        <div><b>Position:</b> " + escapeHtml(slot.PositionKey) + "</div>"
  	      + "        <div><b>Axle Type:</b> " + escapeHtml(slot.AxleType || "") + "</div>"
  	      + "        <div><b>Destination:</b> Select below</div>"
  	      + "      </div>"
  	      + "    </div>"

  	      + "    <div style=\"margin-bottom:10px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Send Tyre To</label>"
  	      + "      <select id=\"tyreActionDestination\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	      + "        <option value=\"Warehouse\">Warehouse</option>"
  	      + "        <option value=\"Retread\">Retread</option>"
  	      + "        <option value=\"Scrap\">Scrap</option>"
  	      + "        <option value=\"Stolen\">Stolen</option>"
  	      + "      </select>"
  	      + "    </div>"
  	      + "    <div style=\"margin-bottom:10px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Vehicle Odometer</label>"
  	      + "      <input id=\"tyreActionOdometer\" type=\"number\" placeholder=\"km\" style=\"width:100%;box-sizing:border-box;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;\">"
  	      + "    </div>"

  	      + "    <div style=\"margin-bottom:13px;\">"
  	      + "      <label style=\"display:block;color:#aaa;font-size:12px;margin-bottom:5px;\">Notes</label>"
  	      + "      <textarea id=\"tyreActionNotes\" placeholder=\"Removal notes\" style=\"width:100%;box-sizing:border-box;min-height:80px;padding:9px;border:1px solid #343434;border-radius:7px;background:#151515;color:#fff;resize:vertical;\"></textarea>"
  	      + "    </div>"

  	      + "    <div style=\"display:flex;justify-content:flex-end;gap:8px;\">"
  	      + "      <button id=\"removeTyreCancelBtn\" type=\"button\" style=\"background:#555;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Cancel</button>"
  	      + "      <button id=\"tyreRemoveSelectedBtn\" type=\"button\" style=\"background:#8a2d2d;color:#fff;border:none;padding:9px 13px;border-radius:8px;cursor:pointer;font-weight:900;\">Remove Tyre</button>"
  	      + "    </div>"
  	      + "  </div>"
  	      + "</div>";

  	      DocumentSafe.body.insertAdjacentHTML("beforeend", html);

  	      popup = DocumentSafe.getElementById("removeTyrePopup");

  	      if (!popup) {
  	        return;
  	      }

  	      wireRemoveTyrePopupEvents(popup);
  	    }

  	    function wireRemoveTyrePopupEvents(popup) {
  	      var closeBtn = popup.querySelector("#removeTyrePopupCloseBtn");
  	      var cancelBtn = popup.querySelector("#removeTyreCancelBtn");
  	      var removeBtn = popup.querySelector("#tyreRemoveSelectedBtn");

  	      function closeRemovePopup() {
  	        closeFloatingPopup("removeTyrePopup");
  	      }

  	      if (closeBtn) {
  	        closeBtn.onclick = closeRemovePopup;
  	      }

  	      if (cancelBtn) {
  	        cancelBtn.onclick = closeRemovePopup;
  	      }

  	      if (removeBtn) {
  	        removeBtn.onclick = function () {
  	          if (!confirmSafe("Remove selected tyre from this vehicle and send it to " + getUiValue("tyreActionDestination") + "?")) {
  	            return;
  	          }

  	          removeBtn.disabled = true;
  	          removeBtn.textContent = "Removing...";

  	          executeRemoveFromUi()
  	          .then(function (message) {
  	            state.pendingTyreAction = null;
  	            state.dragSource = null;
  	            state.tapSource = null;
  	            state.actionMessage = message || "Tyre removed.";
  	            state.actionError = false;

  	            closeFloatingPopup("removeTyrePopup");

  	            if (typeof resetDraftTPositions === "function") {
  	              resetDraftTPositions();
  	            } else {
  	              resetRotationPlan();
  	            }

  	            renderVisualTyreOperations();

  	            if (typeof renderList === "function") {
  	              try {
  	                renderList(typeof search !== "undefined" && search && search.value ? search.value: "");
  	              } catch (error) {
  	                renderList("");
  	              }
  	            }
  	          })
  	          .catch(function (error) {
  	            state.actionMessage = error && error.message ? error.message: "Tyre removal failed.";
  	            state.actionError = true;

  	            removeBtn.disabled = false;
  	            removeBtn.textContent = "Remove Tyre";

  	            renderVisualTyreOperations();
  	          });
  	        };
  	      }
  	    }

  	    // =========================================================
  	    // VISUAL TYRE OPERATIONS RENDER
  	    // =========================================================
  	    function renderVisualTyreOperations() {
  	      if (state.actionMode !== "Allocate") {
  	        state.allocatePopupOpen = false;
  	        state.allocateSelectedTyreId = "";
  	        state.allocateSearch = "";
  	        state.allocateTypeFilter = "";
  	      }

  	      if (state.actionMode !== "RotateSwap") {
  	        state.rotationPopupOpen = false;
  	      }

  	      var currentVehicle = state.activeTractor || tractor;
  	      var tPositions = getVisualTPositionsForTyreTab(currentVehicle);
  	      var keys = sortedPositionKeys(tPositions);
  	      var normalAxles = arr(tPositions.Axles).filter(function (axle) {
  	        return axle && axle.Type !== "Spare";
  	      });
  	      var spares = spareSlots(tPositions);
  	      var spareHtml = "";
  	      var sideHtml = "";

  	      if (!state.selectedPosition && keys.length) {
  	        state.selectedPosition = tPositions.Positions[keys[0]].PositionKey || keys[0];
  	      }

  	      spares.forEach(function (slot) {
  	        spareHtml += ""
  	        + "<div style=\"border:1px solid #3b3b3b;background:#1f2937;border-radius:9px;padding:9px;min-width:180px;\">"
  	        + "  <div style=\"color:#CC6633;font-size:12px;font-weight:800;margin-bottom:7px;\">" + escapeHtml(slot.PositionKey) + "</div>"
  	        + tyreSlotHtml(slot)
  	        + "</div>";
  	      });

  	      sideHtml = ""
  	      + selectedTyreDetailHtml(tPositions)
  	      + (state.actionMode === "Allocate" ? "<div id=\"allocateTyreInlineMount\" style=\"margin-top:10px;\"></div>": "")
  	      + compactRotationArrowsHtml()
  	      + (state.actionMode === "RotateSwap" ? pendingPreviewHtml(): "")
  	      + ""
  	      + "<div id=\"tyreActionStatus\" style=\"min-height:17px;margin-top:10px;color:" + (state.actionError ? "#ff4d4f": "#aaa") + ";font-size:12px;\">"
  	      + escapeHtml(state.actionMessage || "")
  	      + "</div>";

  	      body.innerHTML = ""
  	      + tyreActionTopBarHtml()
  	      + renderWearLegend()
  	      + "<div style=\"display:grid;grid-template-columns:minmax(0,1fr) 430px;gap:12px;align-items:start;\">"
  	      + "  <div style=\"overflow-x:auto;border:1px solid #252525;border-radius:8px;background:#0b0f18;padding:12px;\">"
  	      + "    <div id=\"vehicleTyreLayoutDropZone\" style=\"display:flex;gap:14px;align-items:stretch;min-height:390px;\">"
  	      + (
  	        normalAxles.length
  	        ? normalAxles.map(function (axle) {
  	          return axleVisualHtml(tPositions, axle);
  	        }).join(""): "<div style=\"color:#777;border:1px dashed #444;border-radius:8px;padding:12px;\">No axle configuration found. Use Edit mode to create the axle layout.</div>"
  	      )
  	      + "    </div>"
  	      + (
  	        spareHtml
  	        ? "<div style=\"display:flex;gap:10px;flex-wrap:wrap;margin-top:12px;padding-top:12px;border-top:1px solid #252525;\">" + spareHtml + "</div>": ""
  	      )
  	      + "  </div>"
  	      + "  <div>"
  	      + sideHtml
  	      + "  </div>"
  	      + "</div>";

  	      wireVisualTyreEvents();

  	      if (state.allocatePopupOpen) {
  	        renderAllocatePopup();
  	      }

  	      if (state.rotationPopupOpen) {
  	        renderRotationSavePopup();
  	      }
  	    }

  	    function wireVisualTyreEvents() {
  	      var slotEls = body.querySelectorAll(".trac-tyre-slot");
  	      var tyreCards = body.querySelectorAll(".trac-tyre-card");
  	      var modeButtons = body.querySelectorAll(".trac-tyre-mode-btn");
  	      var openRemovePopupBtn = DocumentSafe.getElementById("tyreOpenRemovePopupBtn");
  	      var modeClearBtn = null;
  	      var completeAllocationBtn = DocumentSafe.getElementById("tyreCompleteAllocationBtn");
  	      var cancelAllocationBtn = DocumentSafe.getElementById("tyreCancelAllocationBtn");
  	      var confirmPendingBtn = DocumentSafe.getElementById("tyreConfirmPendingBtn");
  	      var clearPendingBtn = DocumentSafe.getElementById("tyreClearPendingBtn");
  	      var openRotationSavePopupBtn = DocumentSafe.getElementById("tyreOpenRotationSavePopupBtn");
  	      var clearRotationPlanBtn = DocumentSafe.getElementById("tyreClearRotationPlanBtn");
  	      var removeSelectedBtn = DocumentSafe.getElementById("tyreRemoveSelectedBtn");

  	      Array.prototype.forEach.call(modeButtons, function (button) {
  	        button.onclick = function () {
  	          state.actionMode = button.getAttribute("data-mode") || "";
  	          state.pendingTyreAction = null;
  	          state.dragSource = null;
  	          state.tapSource = null;

  	          if (state.actionMode === "RotateSwap") {
  	            state.allocatePopupOpen = false;
  	            state.allocateSelectedTyreId = "";
  	            closeFloatingPopup("allocateTyrePopup");

  	            state.rotationPopupOpen = false;
  	            closeFloatingPopup("rotationSavePopup");

  	            beginRotationPlan();
  	            state.actionMessage = "Rotate / Swap unlocked. Drag fitted tyres directly on the vehicle layout.";
  	          } else if (state.actionMode === "Allocate") {
  	            beginRotationPlan();

  	            state.rotationPopupOpen = false;
  	            closeFloatingPopup("rotationSavePopup");
  	            closeFloatingPopup("allocationPlanPopup");

  	            state.allocatePopupOpen = true;
  	            state.allocateSelectedTyreId = "";
  	            state.pendingTyreAction = null;
  	            state.dragSource = null;
  	            state.tapSource = null;
  	            state.actionMessage = "Allocate opened. Build a tyre-change plan, then press Complete Allocation.";
  	          }

  	          state.actionError = false;
  	          renderVisualTyreOperations();

  	          if (state.actionMode === "Allocate") {
  	            renderAllocatePopup();
  	          }
  	        };
  	      });

  	      if (completeAllocationBtn) {
  	        completeAllocationBtn.onclick = function () {
  	          renderAllocationPlanPopup();
  	        };
  	      }

  	      if (cancelAllocationBtn) {
  	        cancelAllocationBtn.onclick = function (event) {
  	          if (event && event.preventDefault) {
  	            event.preventDefault();
  	          }

  	          if (event && event.stopPropagation) {
  	            event.stopPropagation();
  	          }

  	          if (!confirmSafe("Cancel this allocation plan and reset the tyre layout?")) {
  	            return;
  	          }

  	          lockTyreMovementState("Allocation cancelled. Tyre layout reset.");
  	        };
  	      }

  	      if (openRemovePopupBtn) {
  	        openRemovePopupBtn.onclick = function () {
  	          renderRemoveTyrePopup();
  	        };
  	      }

  	      if (modeClearBtn) {
  	        modeClearBtn.onclick = function () {
  	          lockTyreMovementState("Tyre movement locked.");
  	        };
  	      }

  	      Array.prototype.forEach.call(tyreCards, function (card) {
  	        card.addEventListener("dragstart", function (event) {
  	          var sourceType = card.getAttribute("data-source-type") || "";
  	          var tyreId = card.getAttribute("data-tyre-object-id") || "";
  	          var sourcePosition = card.getAttribute("data-source-position") || "";
  	          var source = {
  	            SourceType: sourceType,
  	            TyreObjectId: tyreId,
  	            SourcePosition: sourcePosition
  	          };

  	          if (!sourceAllowedForCurrentMode(source)) {
  	            event.preventDefault();
  	            state.actionMessage = "Select the correct tyre action first.";
  	            state.actionError = true;
  	            renderVisualTyreOperations();
  	            return;
  	          }

  	          setDragSource(sourceType, tyreId, sourcePosition);

  	          if (event.dataTransfer) {
  	            event.dataTransfer.effectAllowed = "move";
  	            event.dataTransfer.setData("text/plain", JSON.stringify(source));
  	          }

  	          card.style.opacity = "0.55";
  	        });

  	        card.addEventListener("dragend",
  	          function () {
  	            card.style.opacity = "1";
  	            state.dragSource = null;
  	          });

  	        card.onclick = function () {
  	          var sourceType = card.getAttribute("data-source-type") || "";
  	          var tyreId = card.getAttribute("data-tyre-object-id") || "";
  	          var sourcePosition = card.getAttribute("data-source-position") || "";
  	          var source = {
  	            SourceType: sourceType,
  	            TyreObjectId: tyreId,
  	            SourcePosition: sourcePosition
  	          };

  	          if (!sourceAllowedForCurrentMode(source)) {
  	            state.actionMessage = "Select the correct tyre action first.";
  	            state.actionError = true;
  	            renderVisualTyreOperations();
  	            return;
  	          }

  	          setTapSource(sourceType, tyreId, sourcePosition);
  	          renderVisualTyreOperations();
  	        };
  	      });

  	      Array.prototype.forEach.call(slotEls,
  	        function (slotEl) {
  	          slotEl.addEventListener("dragstart", function (event) {
  	            var positionKey = slotEl.getAttribute("data-position-key") || "";
  	            var tyreId = slotEl.getAttribute("data-tyre-object-id") || "";

  	            if (
  	              (state.actionMode !== "RotateSwap" && state.actionMode !== "Allocate") ||
  	              !tyreId
  	            ) {
  	              event.preventDefault();
  	              return;
  	            }

  	            state.selectedPosition = positionKey;
  	            setDragSource("fitted", tyreId, positionKey);

  	            if (event.dataTransfer) {
  	              event.dataTransfer.effectAllowed = "move";
  	              event.dataTransfer.setData("text/plain", JSON.stringify({
  	                SourceType: "fitted",
  	                TyreObjectId: tyreId,
  	                SourcePosition: positionKey
  	              }));
  	            }

  	            slotEl.style.opacity = "0.72";
  	            slotEl.style.outline = "3px solid #CC6633";
  	            slotEl.style.boxShadow = "0 0 18px rgba(204,102,51,0.75)";
  	          });

  	          slotEl.addEventListener("dragend",
  	            function () {
  	              slotEl.style.opacity = "1";
  	              state.dragSource = null;
  	            });

  	          slotEl.addEventListener("dragover",
  	            function (event) {
  	              if (state.actionMode !== "RotateSwap" && state.actionMode !== "Allocate") {
  	                return;
  	              }

  	              event.preventDefault();

  	              if (event.dataTransfer) {
  	                event.dataTransfer.dropEffect = "move";
  	              }

  	              slotEl.style.background = "rgba(204,102,51,0.22)";
  	            });

  	          slotEl.addEventListener("dragleave",
  	            function () {
  	              var positionKey = slotEl.getAttribute("data-position-key") || "";

  	              if (state.selectedPosition === positionKey) {
  	                slotEl.style.background = "rgba(204,102,51,0.22)";
  	                slotEl.style.outline = "3px solid #CC6633";
  	                slotEl.style.boxShadow = "0 0 18px rgba(204,102,51,0.7)";
  	              } else {
  	                slotEl.style.background = "transparent";
  	                slotEl.style.outline = "1px solid transparent";
  	                slotEl.style.boxShadow = "none";
  	              }
  	            });

  	          slotEl.addEventListener("drop",
  	            function (event) {
  	              var positionKey = slotEl.getAttribute("data-position-key") || "";
  	              var source = state.dragSource;
  	              var raw;

  	              event.preventDefault();

  	              if (state.actionMode !== "RotateSwap" && state.actionMode !== "Allocate") {
  	                state.actionMessage = "Tyre movement is locked. Select Rotate / Swap or Allocate first.";
  	                state.actionError = true;
  	                renderVisualTyreOperations();
  	                return;
  	              }

  	              if (!source && event.dataTransfer) {
  	                raw = event.dataTransfer.getData("text/plain");

  	                try {
  	                  source = JSON.parse(raw);
  	                } catch (error) {
  	                  source = null;
  	                }
  	              }

  	              if (!source) {
  	                state.actionMessage = "No tyre source found.";
  	                state.actionError = true;
  	                renderVisualTyreOperations();
  	                return;
  	              }

  	              if (!sourceAllowedForCurrentMode(source)) {
  	                state.actionMessage = "This source is not allowed in the current mode.";
  	                state.actionError = true;
  	                renderVisualTyreOperations();
  	                return;
  	              }

  	              if (state.actionMode === "RotateSwap") {
  	                if (source.SourceType !== "fitted") {
  	                  state.actionMessage = "Only fitted tyres can be used in Rotate / Swap mode.";
  	                  state.actionError = true;
  	                  renderVisualTyreOperations();
  	                  return;
  	                }

  	                moveTyreInRotationDraft(source.SourcePosition, positionKey);

  	                state.dragSource = null;
  	                renderVisualTyreOperations();
  	                return;
  	              }

  	              if (state.actionMode === "Allocate") {
  	                applyDraftTyreMove(source, positionKey);

  	                state.pendingTyreAction = null;
  	                state.dragSource = null;
  	                state.tapSource = null;
  	                state.allocatePopupOpen = true;

  	                renderVisualTyreOperations();
  	                renderAllocatePopup();
  	                return;
  	              }

  	              state.dragSource = null;
  	              renderVisualTyreOperations();
  	            });

  	          slotEl.onclick = function () {
  	            var positionKey = slotEl.getAttribute("data-position-key") || "";
  	            var hadTapSource = !!state.tapSource;
  	            var slot;
  	            var tPositions;

  	            if (state.actionMode === "RotateSwap" && hadTapSource) {
  	              moveTyreInRotationDraft(
  	                state.tapSource.SourcePosition,
  	                positionKey
  	              );

  	              clearTapSource();
  	              renderVisualTyreOperations();
  	              return;
  	            }

  	            if (state.actionMode === "Allocate") {
  	              if (hadTapSource) {
  	                applyDraftTyreMove(state.tapSource, positionKey);

  	                clearTapSource();

  	                state.pendingTyreAction = null;
  	                state.allocatePopupOpen = true;

  	                renderVisualTyreOperations();
  	                renderAllocatePopup();
  	                return;
  	              }

  	              tPositions = getRotationDraftTPositions();
  	              slot = getSlot(tPositions, positionKey);

  	              state.selectedPosition = positionKey;

  	              if (slot && slot.TyreObjectId) {
  	                setTapSource("fitted", slot.TyreObjectId, slot.PositionKey);
  	                state.selectedPosition = slot.PositionKey;
  	                state.actionMessage = "Selected " + slot.PositionKey + ". Tap another position to move or swap it.";
  	                state.actionError = false;
  	              } else {
  	                state.actionMessage = "Select a warehouse tyre from the Allocate popup, or tap a fitted tyre first.";
  	                state.actionError = false;
  	              }

  	              renderVisualTyreOperations();
  	              renderAllocatePopup();
  	              return;
  	            }

  	            handleSlotTarget(positionKey);

  	            if (hadTapSource) {
  	              clearTapSource();
  	            }

  	            renderVisualTyreOperations();
  	          };
  	        });

  	      if (confirmPendingBtn) {
  	        confirmPendingBtn.onclick = function () {
  	          if (state.actionMode === "Allocate") {
  	            renderAllocatePopup();
  	            state.actionMessage = "Confirm allocation inside the Allocate Tyre popup.";
  	            state.actionError = false;
  	            renderVisualTyreOperations();
  	            return;
  	          }

  	          var validation = validatePendingStillPossible();

  	          if (!validation.ok) {
  	            state.actionMessage = validation.message;
  	            state.actionError = true;
  	            renderVisualTyreOperations();
  	            return;
  	          }

  	          if (!confirmSafe("Confirm tyre action?\n\n" + pendingActionLabel())) {
  	            return;
  	          }

  	          confirmPendingBtn.disabled = true;
  	          confirmPendingBtn.textContent = "Saving...";

  	          executePendingTyreAction()
  	          .then(function (message) {
  	            state.pendingTyreAction = null;
  	            state.dragSource = null;
  	            state.tapSource = null;

  	            state.actionMessage = message || "Tyre action saved.";
  	            state.actionError = false;
  	            resetDraftTPositions();

  	            renderVisualTyreOperations();
  	            renderList(search.value || "");
  	          })
  	          .catch(function (error) {
  	            state.actionMessage = error && error.message ? error.message: "Tyre action failed.";
  	            state.actionError = true;
  	            renderVisualTyreOperations();
  	          });
  	        };
  	      }


  	      if (clearPendingBtn) {
  	        clearPendingBtn.onclick = function () {
  	          state.pendingTyreAction = null;
  	          state.dragSource = null;
  	          state.tapSource = null;
  	          state.actionMessage = "Pending tyre action cleared.";
  	          state.actionError = false;
  	          renderVisualTyreOperations();
  	        };
  	      }

  	      if (openRotationSavePopupBtn) {
  	        openRotationSavePopupBtn.onclick = function () {
  	          var arrows = getRotationArrows();

  	          if (!arrows.length) {
  	            state.actionMessage = "No rotation changes to save.";
  	            state.actionError = true;
  	            renderVisualTyreOperations();
  	            return;
  	          }

  	          state.rotationPopupOpen = true;
  	          renderRotationSavePopup();
  	        };
  	      }

  	      if (clearRotationPlanBtn) {
  	        clearRotationPlanBtn.onclick = function () {
  	          beginRotationPlan();

  	          state.rotationPopupOpen = false;
  	          closeFloatingPopup("rotationSavePopup");

  	          state.actionMessage = "Rotation plan cleared. Start dragging again.";
  	          state.actionError = false;
  	          renderVisualTyreOperations();
  	        };
  	      }

  	      if (removeSelectedBtn) {
  	        removeSelectedBtn.onclick = function () {
  	          if (!confirmSafe("Remove selected tyre from this vehicle?")) {
  	            return;
  	          }

  	          removeSelectedBtn.disabled = true;
  	          removeSelectedBtn.textContent = "Removing...";

  	          executeRemoveFromUi()
  	          .then(function (message) {
  	            state.pendingTyreAction = null;
  	            state.dragSource = null;
  	            state.tapSource = null;
  	            state.actionMessage = message || "Tyre removed.";
  	            state.actionError = false;
  	            resetDraftTPositions();

  	            renderVisualTyreOperations();
  	            renderList(search.value || "");
  	          })
  	          .catch(function (error) {
  	            state.actionMessage = error && error.message ? error.message: "Tyre removal failed.";
  	            state.actionError = true;
  	            renderVisualTyreOperations();
  	          });
  	        };
  	      }
  	    } // =========================================================
  	    // GENERIC TAB RENDERING
  	    // =========================================================
  	    function renderGenericTab(tabLabel) {
  	      var currentVehicle = state.activeTractor || tractor;
  	      var def = TAB_DEFS.filter(function (tabDef) {
  	        return tabDef.label === tabLabel;
  	      })[0];

  	      var key = def ? def.key: tabLabel.replace(/\s+/g, "");
  	      var root = currentVehicle.Data || {};
  	      var data = root[key];
  	      var keys;
  	      var objectKeys;
  	      var scalarKeys;
  	      var sections = [];
  	      var subTabBar;
  	      var subContent;

  	      body.innerHTML = "";

  	      if (!data || typeof data !== "object") {
  	        body.innerHTML = "<div style=\"color:#777;\">No Data</div>";
  	        return;
  	      }

  	      keys = Object.keys(data);

  	      objectKeys = keys.filter(function (k) {
  	        var value = data[k];

  	        return value &&
  	        typeof value === "object" &&
  	        !Array.isArray(value) &&
  	        !isWrapped(value);
  	      });

  	      scalarKeys = keys.filter(function (k) {
  	        return objectKeys.indexOf(k) === -1;
  	      });

  	      if (scalarKeys.length && !objectKeys.length) {
  	        body.innerHTML = buildForm(data, key);
  	        return;
  	      }

  	      if (scalarKeys.length) {
  	        var overview = {};

  	        scalarKeys.forEach(function (k) {
  	          overview[k] = data[k];
  	        });

  	        sections.push({
  	          key: "_overview",
  	          label: "Overview",
  	          value: overview,
  	          basePath: key
  	        });
  	      }

  	      objectKeys.forEach(function (k) {
  	        sections.push({
  	          key: k,
  	          label: prettyName(k),
  	          value: data[k],
  	          basePath: key + "." + k
  	        });
  	      });

  	      subTabBar = DocumentSafe.createElement("div");

  	      Object.assign(subTabBar.style, {
  	        display: "flex",
  	        flexWrap: "wrap",
  	        gap: "4px 6px",
  	        background: "#181818",
  	        padding: "8px 10px",
  	        borderBottom: "1px solid #333",
  	        position: "sticky",
  	        top: "0",
  	        zIndex: 5
  	      });

  	      subContent = DocumentSafe.createElement("div");
  	      subContent.style.marginTop = "8px";

  	      body.appendChild(subTabBar);
  	      body.appendChild(subContent);

  	      function setSubTab(subKey) {
  	        var section = sections.filter(function (s) {
  	          return s.key === subKey;
  	        })[0];

  	        if (!section) {
  	          return;
  	        }

  	        subContent.innerHTML = buildForm(section.value, section.basePath);

  	        Array.prototype.forEach.call(subTabBar.children, function (btn) {
  	          var selected = btn.dataset.subKey === subKey;

  	          Object.assign(btn.style, {
  	            background: selected ? "#262626": "transparent",
  	            color: selected ? "#fff": "#ccc",
  	            border: selected ? "1px solid #CC6633": "1px solid #333"
  	          });
  	        });
  	      }

  	      sections.forEach(function (section) {
  	        var btn = DocumentSafe.createElement("div");

  	        btn.textContent = section.label;
  	        btn.dataset.subKey = section.key;

  	        Object.assign(btn.style, {
  	          padding: "6px 12px",
  	          cursor: "pointer",
  	          borderRadius: "6px",
  	          fontSize: "12px",
  	          border: "1px solid #333"
  	        });

  	        btn.onclick = function () {
  	          setSubTab(section.key);
  	        };

  	        subTabBar.appendChild(btn);
  	      });

  	      if (sections.length) {
  	        setSubTab(sections[0].key);
  	      }
  	    }

  	        function renderTab(tabLabel) {
  	      if (tabLabel === "Tyres") {
  	        if (state.editMode) {
  	          renderAxleConfigurator();
  	        } else {
  	          renderVisualTyreOperations();

  	          loadTyres().then(function () {
  	            if (
  	              state.activeTractor &&
  	              vehicleObjectId(state.activeTractor) === vehicleObjectId(tractor) &&
  	              state.activeTab === "Tyres" &&
  	              !state.editMode
  	            ) {
  	              renderVisualTyreOperations();
  	            }
  	          });
  	        }

  	        return;
  	      }

  	      renderGenericTab(tabLabel);
  	    }

  	    state.__rerenderTyreEditor = function () {
  	      if (
  	        !state.activeTractor ||
  	        vehicleObjectId(state.activeTractor) !== vehicleObjectId(tractor)
  	      ) {
  	        return false;
  	      }

  	      if (state.activeTab === "Tyres" && !state.editMode) {
  	        renderVisualTyreOperations();
  	      } else {
  	        renderTab(state.activeTab || "Tyres");
  	      }

  	      if (typeof renderList === "function") {
  	        try {
  	          renderList(typeof search !== "undefined" && search && search.value ? search.value: "");
  	        } catch (error) {
  	          renderList("");
  	        }
  	      }

  	      return true;
  	    };

  	    function setActiveTab(label) {
  	      state.activeTab = label;

  	      if (label !== "Tyres") {
  	        clearPendingTyreAction();

  	        state.actionMode = "";
  	        state.allocatePopupOpen = false;
  	        state.rotationPopupOpen = false;
  	        state.allocateSelectedTyreId = "";

  	        closeFloatingPopup("allocateTyrePopup");
  	        closeFloatingPopup("rotationSavePopup");
  	      }

  	      renderTabButtons();
  	      renderTab(label);
  	    }

  	    // =========================================================
  	    // EDIT / SAVE / CANCEL
  	    // =========================================================
  	    function enableEdit() {
  	      state.editMode = true;

  	      clearPendingTyreAction();

  	      state.actionMode = "";
  	      state.allocatePopupOpen = false;
  	      state.rotationPopupOpen = false;
  	      state.allocateSelectedTyreId = "";

  	      closeFloatingPopup("allocateTyrePopup");
  	      closeFloatingPopup("rotationSavePopup");

  	      editBtn.style.display = "none";
  	      controlBar.style.display = "flex";
  	      fidInput.disabled = false;

  	      if (state.activeTab === "Tyres") {
  	        resetDraftTPositions();
  	      }

  	      renderTab(state.activeTab);
  	    }

  	    function disableEdit() {
  	      state.editMode = false;

  	      clearPendingTyreAction();

  	      state.actionMode = "";
  	      state.allocatePopupOpen = false;
  	      state.rotationPopupOpen = false;
  	      state.allocateSelectedTyreId = "";

  	      closeFloatingPopup("allocateTyrePopup");
  	      closeFloatingPopup("rotationSavePopup");

  	      editBtn.style.display = "block";
  	      controlBar.style.display = "none";
  	      fidInput.disabled = true;

  	      resetDraftTPositions();
  	      renderTab(state.activeTab);
  	    }

  	    editBtn.onclick = function () {
  	      enableEdit();
  	    };

  	    cancelBtn.onclick = function () {
  	      disableEdit();
  	    };

  	    saveBtn.onclick = function () {
  	      var updated = clone(state.activeTractor);
  	      var draft;
  	      var savePromise;

  	      saveBtn.disabled = true;
  	      saveBtn.textContent = "Saving...";

  	      if (state.activeTab === "Tyres") {
  	        draft = getDraftTPositions();

  	        writeTPositionsToVehicle(updated, draft);
  	        savePromise = saveVehicleWithTPositions(updated, draft);
  	      } else {
  	        applyBoundInputsToVehicle(updated, editorPanel);
  	        savePromise = saveVehicleOnly(updated);
  	      }

  	      savePromise
  	      .then(function (saved) {
  	        if (saved && typeof saved === "object") {
  	          state.activeTractor = saved;
  	        }

  	        saveBtn.textContent = "Saved";

  	        renderList(search.value || "");
  	        disableEdit();
  	      })
  	      .catch(function (error) {
  	        alertSafe(error && error.message ? error.message: "Save failed.");
  	      })
  	      .then(function () {
  	        saveBtn.disabled = false;
  	        saveBtn.textContent = "Save";
  	      });
  	    };

  	    // =========================================================
  	    // INITIAL EDITOR RENDER
  	    // =========================================================
  	    renderTabButtons();
  	    setActiveTab("Vehicle");
  	  }

  	  return true;
  	})({
  	  App: (typeof App !== "undefined" ? App: null),
  	  Tractors: (typeof Tractors !== "undefined" ? Tractors: []),
  	  Tyres: (typeof Tyres !== "undefined" ? Tyres: []),
  	  Hub: (typeof Hub !== "undefined" ? Hub: null),
  	  Backendless: (typeof Backendless !== "undefined" ? Backendless: null)
  	});
  })(___arguments.context.appData, (await Tractors2()), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b20f5d284a885938a0bdfa782448dee8')), 'data:image/png;base64,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');
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e517ec0e29819ef91cfda218a0f846b6', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, View;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Settings')).indexOf('Vehicles') !== -1) {
      View = true;
    } else {
      View = false;
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      View = false;
    }

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/99a77e889b28f1461e79ec81fec1175a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function Menu_Closers() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fc90fe85fb3fdb851e842383a2cbe6d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb589f58823489b55d73a8c86512ba2a', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fd81dee1f1852b56f34b68de1d3d46e', false);

  } catch (error) {
    console.log(error);

  }
}


  await Menu_Closers();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb589f58823489b55d73a8c86512ba2a', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function(AppData, Hub) {
  	(function dataOSManager(args) {
  	  console.log("DATA-OS: INIT (TRAC-MAN style)", args);
  	
  	  const { AppData, Hub, Backendless } = args || {};
  	
  	 // Resolve a real DOM element from any Backendless component shape
  	function resolveHubElement(Hub) {
  	  if (!Hub) return null;
  	
  	  // Direct DOM?
  	  if (Hub instanceof HTMLElement) return Hub;
  	
  	  // Backendless common fields
  	  if (Hub.el instanceof HTMLElement) return Hub.el;
  	  if (Hub.element instanceof HTMLElement) return Hub.element;
  	  if (Hub.elRef instanceof HTMLElement) return Hub.elRef;
  	  if (Hub.ref instanceof HTMLElement) return Hub.ref;
  	
  	  // Some blocks expose a getter
  	  if (typeof Hub.getEl === "function") {
  	    const el = Hub.getEl();
  	    if (el instanceof HTMLElement) return el;
  	  }
  	
  	  // Final fallback: try querySelector if UID is present
  	  if (Hub.componentUID) {
  	    const node = document.querySelector(`[data-component="${Hub.componentUID}"]`);
  	    if (node instanceof HTMLElement) return node;
  	  }
  	
  	  return null;
  	}
  	
  	const hubEl = resolveHubElement(Hub);
  	
  	if (!hubEl) {
  	  console.warn("DATA-OS: Hub DOM element not found", Hub);
  	  return;
  	}
  	
  	 // ==========================================================
  	// 0. STYLES (INJECT ONCE) — DARK THEME + ACCENT #CC6633
  	// ==========================================================
  	function injectStylesOnce() {
  	  if (document.getElementById("data-os-styles")) return;
  	  const style = document.createElement("style");
  	  style.id = "data-os-styles";
  	  style.textContent = `
  	    .dos-root {
  	      font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  	      display: grid;
  	      grid-template-columns: 260px minmax(0, 1fr);
  	      gap: 12px;
  	      padding: 12px;
  	      box-sizing: border-box;
  	      max-width: 1200px;
  	      margin: 0 auto;
  	      color: #f0f0f0;
  	    }
  	
  	    .dos-panel {
  	      border: 1px solid #333333;
  	      border-radius: 10px;
  	      background: rgba(16, 16, 16, 0.94);
  	      padding: 10px;
  	      box-sizing: border-box;
  	    }
  	
  	    .dos-panel-header {
  	      display: flex;
  	      align-items: center;
  	      justify-content: space-between;
  	      margin-bottom: 6px;
  	    }
  	
  	    .dos-panel-header h3 {
  	      margin: 0;
  	      font-size: 0.95rem;
  	      color: #ffffff;
  	    }
  	
  	    .dos-badge {
  	      font-size: 0.7rem;
  	      padding: 2px 6px;
  	      border-radius: 999px;
  	      background: #2a2f38;
  	      color: #d2d7de;
  	    }
  	
  	    .dos-collections {
  	      display: flex;
  	      flex-direction: column;
  	      gap: 6px;
  	      max-height: calc(100vh - 100px);
  	      overflow-y: auto;
  	    }
  	
  	    .dos-collection {
  	      border-radius: 8px;
  	      background: #1f1f1f;
  	      border: 1px solid #3a3a3a;
  	      padding: 6px 8px;
  	    }
  	
  	    .dos-collection-header {
  	      display: flex;
  	      align-items: center;
  	      justify-content: space-between;
  	      gap: 6px;
  	      cursor: pointer;
  	    }
  	
  	    .dos-collection-header-title {
  	      display: flex;
  	      flex-direction: column;
  	    }
  	
  	    .dos-collection-name {
  	      font-weight: 600;
  	      font-size: 0.85rem;
  	      color: #f4f4f4;
  	    }
  	
  	    .dos-collection-meta {
  	      font-size: 0.7rem;
  	      color: #9aa0a6;
  	    }
  	
  	    .dos-collection-toggle {
  	      font-size: 0.8rem;
  	      color: #b0b0b0;
  	    }
  	
  	    .dos-collection-items {
  	      margin-top: 6px;
  	      display: flex;
  	      flex-direction: column;
  	      gap: 4px;
  	    }
  	
  	    .dos-item-button {
  	      border-radius: 6px;
  	      border: 1px solid transparent;
  	      padding: 4px 6px;
  	      font-size: 0.8rem;
  	      display: flex;
  	      align-items: center;
  	      justify-content: space-between;
  	      cursor: pointer;
  	      background: #272727;
  	      color: #e8e8e8;
  	    }
  	
  	    .dos-item-button--active {
  	      border-color: #CC6633;
  	      background: #2b1b12;
  	    }
  	
  	    .dos-item-main {
  	      display: flex;
  	      flex-direction: column;
  	    }
  	
  	    .dos-item-id {
  	      font-weight: 500;
  	      color: #f0f0f0;
  	    }
  	
  	    .dos-item-caption {
  	      font-size: 0.7rem;
  	      color: #b8b8b8;
  	    }
  	
  	    .dos-btn {
  	      border-radius: 999px;
  	      border: 1px solid #555555;
  	      background: #333333;
  	      font-size: 0.75rem;
  	      padding: 4px 8px;
  	      cursor: pointer;
  	      color: #e0e0e0;
  	    }
  	
  	    .dos-btn:hover {
  	      background: #3c3c3c;
  	    }
  	
  	    .dos-btn-primary {
  	      background: #CC6633;
  	      color: #ffffff;
  	      border-color: #CC6633;
  	    }
  	
  	    .dos-btn-primary:hover {
  	      background: #e0733a;
  	      border-color: #e0733a;
  	    }
  	
  	    .dos-btn-danger {
  	      background: #4a2020;
  	      color: #ffcccc;
  	      border-color: #aa4444;
  	    }
  	
  	    .dos-btn-danger:hover {
  	      background: #5c2626;
  	    }
  	
  	    .dos-editor-empty {
  	      font-size: 0.85rem;
  	      color: #a0a4aa;
  	      padding: 20px 10px;
  	    }
  	
  	    .dos-editor-header {
  	      display: flex;
  	      flex-direction: column;
  	      gap: 4px;
  	      margin-bottom: 8px;
  	    }
  	
  	    .dos-editor-title {
  	      font-weight: 600;
  	      font-size: 0.95rem;
  	      color: #ffffff;
  	    }
  	
  	    .dos-editor-path {
  	      font-size: 0.75rem;
  	      color: #b0b0b0;
  	    }
  	
  	    .dos-editor-actions {
  	      display: flex;
  	      justify-content: flex-end;
  	      gap: 6px;
  	      margin-top: 8px;
  	      margin-bottom: 4px;
  	    }
  	
  	    .dos-sections {
  	      display: flex;
  	      flex-direction: column;
  	      gap: 8px;
  	      max-height: calc(100vh - 150px);
  	      overflow-y: auto;
  	      padding-right: 4px;
  	    }
  	
  	    .dos-section {
  	      border-radius: 8px;
  	      border: 1px solid #333333;
  	      background: #1b1b1b;
  	      padding: 8px;
  	    }
  	
  	    .dos-section-title {
  	      font-weight: 600;
  	      font-size: 0.85rem;
  	      margin-bottom: 4px;
  	      color: #f4f4f4;
  	    }
  	
  	    .dos-section-desc {
  	      font-size: 0.75rem;
  	      color: #9a9a9a;
  	      margin-bottom: 4px;
  	    }
  	
  	    .dos-fields {
  	      display: flex;
  	      flex-direction: column;
  	      gap: 6px;
  	    }
  	
  	    .dos-field-row {
  	      display: grid;
  	      grid-template-columns: 200px minmax(0, 1fr);
  	      gap: 6px;
  	      align-items: flex-start;
  	    }
  	
  	    .dos-field-label {
  	      font-size: 0.8rem;
  	      font-weight: 500;
  	      display: flex;
  	      align-items: center;
  	      gap: 4px;
  	      color: #e0e0e0;
  	    }
  	
  	    .dos-field-help {
  	      font-size: 0.7rem;
  	      color: #b0b0b0;
  	      cursor: help;
  	    }
  	
  	    .dos-required-badge {
  	      font-size: 0.7rem;
  	      padding: 1px 4px;
  	      border-radius: 999px;
  	      background: #3a2318;
  	      color: #ffb38a;
  	    }
  	
  	    .dos-field-input input,
  	    .dos-field-input select,
  	    .dos-field-input textarea {
  	      width: 100%;
  	      max-width: 100%;
  	      padding: 4px 6px;
  	      border-radius: 6px;
  	      border: 1px solid #444444;
  	      font-size: 0.8rem;
  	      box-sizing: border-box;
  	      background: #262626;
  	      color: #e0e0e0;
  	    }
  	
  	    .dos-field-input input:focus,
  	    .dos-field-input select:focus,
  	    .dos-field-input textarea:focus {
  	      outline: none;
  	      border-color: #CC6633;
  	      box-shadow: 0 0 0 1px #CC6633;
  	    }
  	
  	    .dos-group {
  	      display: flex;
  	      flex-direction: column;
  	      gap: 4px;
  	      padding: 6px;
  	      border-radius: 6px;
  	      border: 1px dashed #444444;
  	      background: #222222;
  	    }
  	
  	    .dos-list {
  	      display: flex;
  	      flex-direction: column;
  	      gap: 6px;
  	    }
  	
  	    .dos-list-header {
  	      display: flex;
  	      justify-content: space-between;
  	      align-items: center;
  	      font-size: 0.75rem;
  	      color: #d0d0d0;
  	    }
  	
  	    .dos-list-items {
  	      display: flex;
  	      flex-direction: column;
  	      gap: 4px;
  	    }
  	
  	    .dos-list-item {
  	      display: flex;
  	      align-items: flex-start;
  	      justify-content: space-between;
  	      gap: 6px;
  	      padding: 4px 6px;
  	      border-radius: 6px;
  	      background: #262626;
  	    }
  	
  	    .dos-list-item-main {
  	      flex: 1;
  	      display: flex;
  	      flex-direction: column;
  	      gap: 4px;
  	    }
  	
  	    .dos-toggle-label {
  	      font-size: 0.8rem;
  	      display: inline-flex;
  	      align-items: center;
  	      gap: 4px;
  	      color: #e0e0e0;
  	    }
  	
  	    .dos-reference-select {
  	      font-size: 0.8rem;
  	      background: #262626;
  	      color: #e0e0e0;
  	      border: 1px solid #444444;
  	    }
  	
  	    .dos-formula-box {
  	      border-radius: 6px;
  	      border: 1px dashed #444444;
  	      padding: 6px;
  	      background: #222222;
  	      display: flex;
  	      flex-direction: column;
  	      gap: 4px;
  	    }
  	
  	    .dos-formula-preview {
  	      font-size: 0.75rem;
  	      color: #c0c0c0;
  	    }
  	
  	    .dos-error-message {
  	      font-size: 0.75rem;
  	      color: #ff7777;
  	    }
  	  `;
  	  document.head.appendChild(style);
  	}
  	
  	injectStylesOnce();
  	
  	  // ==========================================================
  	  // 1. SCHEMA REGISTRY (EDIT THESE FOR YOUR BUSINESS)
  	  // ==========================================================
  	
  	  // We expect data to be under AppData.JsonData:
  	  // AppData.JsonData = {
  	  //   Tractors: { _schema: "Tractor", items: { id1: {...}, id2: {...} } },
  	  //   Employees: { _schema: "Employee", items: {...} },
  	  //   ...
  	  // }
  	
  	  const SchemaRegistry = {
  	    Tractor: {
  	      title: "Tractor Profile",
  	      description: "Standard data template for tractors.",
  	      sections: [
  	        {
  	          id: "basic",
  	          label: "Basic Info",
  	          fields: [
  	            {
  	              id: "name",
  	              label: "Tractor Name",
  	              type: "string",
  	              required: true,
  	              placeholder: "e.g. John Deere 5075E",
  	              help: "Internal friendly name for this tractor."
  	            },
  	            {
  	              id: "type",
  	              label: "Type",
  	              type: "dropdown",
  	              required: true,
  	              options: [
  	                { value: "tractor", label: "Tractor" },
  	                { value: "harvester", label: "Harvester" },
  	                { value: "sprayer", label: "Sprayer" }
  	              ],
  	              help: "General type / category."
  	            },
  	            {
  	              id: "horsepower",
  	              label: "Horsepower",
  	              type: "number",
  	              min: 0,
  	              max: 1000,
  	              step: 1,
  	              help: "Approximate engine horsepower."
  	            },
  	            {
  	              id: "gpsEnabled",
  	              label: "GPS Tracking Enabled",
  	              type: "boolean",
  	              default: true,
  	              help: "Turn off only if the tractor has no tracking hardware."
  	            }
  	          ]
  	        },
  	        {
  	          id: "assignment",
  	          label: "Assignment",
  	          fields: [
  	            {
  	              id: "primaryLocation",
  	              label: "Primary Location",
  	              type: "reference",
  	              source: "Locations",
  	              displayField: "name",
  	              help: "Where this tractor is mostly based."
  	            },
  	            {
  	              id: "operators",
  	              label: "Assigned Operators",
  	              type: "list",
  	              item: {
  	                type: "group",
  	                fields: [
  	                  {
  	                    id: "employee",
  	                    label: "Employee",
  	                    type: "reference",
  	                    source: "Employees",
  	                    displayField: "name"
  	                  },
  	                  {
  	                    id: "role",
  	                    label: "Role",
  	                    type: "string",
  	                    placeholder: "e.g. Main operator"
  	                  }
  	                ]
  	              }
  	            }
  	          ]
  	        }
  	      ]
  	    },
  	
  	    Employee: {
  	      title: "Employee Record",
  	      description: "Basic information for employees.",
  	      sections: [
  	        {
  	          id: "main",
  	          label: "Main Info",
  	          fields: [
  	            {
  	              id: "name",
  	              label: "Name",
  	              type: "string",
  	              required: true
  	            },
  	            {
  	              id: "role",
  	              label: "Role / Position",
  	              type: "string"
  	            },
  	            {
  	              id: "phone",
  	              label: "Phone Number",
  	              type: "string",
  	              placeholder: "e.g. +27 82 123 4567"
  	            },
  	            {
  	              id: "homeBase",
  	              label: "Home Location",
  	              type: "reference",
  	              source: "Locations",
  	              displayField: "name"
  	            }
  	          ]
  	        }
  	      ]
  	    },
  	
  	    Location: {
  	      title: "Location",
  	      description: "Worksites, depots, fields, etc.",
  	      sections: [
  	        {
  	          id: "basic",
  	          label: "Basic Info",
  	          fields: [
  	            {
  	              id: "name",
  	              label: "Location Name",
  	              type: "string",
  	              required: true
  	            },
  	            {
  	              id: "kind",
  	              label: "Type",
  	              type: "dropdown",
  	              options: [
  	                { value: "farm", label: "Farm" },
  	                { value: "field", label: "Field" },
  	                { value: "depot", label: "Depot" },
  	                { value: "workshop", label: "Workshop" }
  	              ]
  	            },
  	            {
  	              id: "region",
  	              label: "Region / Area",
  	              type: "string"
  	            }
  	          ]
  	        }
  	      ]
  	    },
  	
  	    TrackingPoint: {
  	      title: "Tracking Point",
  	      description: "Snapshot from GPS / telematics.",
  	      sections: [
  	        {
  	          id: "core",
  	          label: "Core Data",
  	          fields: [
  	            {
  	              id: "timestamp",
  	              label: "Timestamp",
  	              type: "string",
  	              required: true,
  	              placeholder: "YYYY-MM-DD HH:mm:ss"
  	            },
  	            {
  	              id: "lat",
  	              label: "Latitude",
  	              type: "number"
  	            },
  	            {
  	              id: "lng",
  	              label: "Longitude",
  	              type: "number"
  	            },
  	            {
  	              id: "tractor",
  	              label: "Tractor",
  	              type: "reference",
  	              source: "Tractors",
  	              displayField: "name"
  	            },
  	            {
  	              id: "location",
  	              label: "Location (if matched)",
  	              type: "reference",
  	              source: "Locations",
  	              displayField: "name"
  	            }
  	          ]
  	        },
  	        {
  	          id: "derived",
  	          label: "Derived / Formula Fields",
  	          fields: [
  	            {
  	              id: "workWindow",
  	              label: "Work Window (Start/End)",
  	              type: "formula",
  	              formulaType: "timeDifference",
  	              help: "Config: which tracking points define a work window.",
  	              inputs: [
  	                {
  	                  id: "startRef",
  	                  label: "Start Tracking Point",
  	                  type: "reference",
  	                  source: "TrackingPoints",
  	                  displayField: "timestamp"
  	                },
  	                {
  	                  id: "endRef",
  	                  label: "End Tracking Point",
  	                  type: "reference",
  	                  source: "TrackingPoints",
  	                  displayField: "timestamp"
  	                }
  	              ]
  	            }
  	          ]
  	        }
  	      ]
  	    }
  	  };
  	
  	  // ==========================================================
  	  // 2. BASIC HELPERS
  	  // ==========================================================
  	
  	  function createEl(tag, options = {}) {
  	    const el = document.createElement(tag);
  	    if (options.className) el.className = options.className;
  	    if (options.text != null) el.textContent = options.text;
  	    if (options.html != null) el.innerHTML = options.html;
  	    if (options.attrs) {
  	      Object.entries(options.attrs).forEach(([k, v]) => {
  	        if (v != null) el.setAttribute(k, v);
  	      });
  	    }
  	    return el;
  	  }
  	
  	  function deepClone(obj) {
  	    return obj == null ? obj : JSON.parse(JSON.stringify(obj));
  	  }
  	
  	  function getValueByPath(obj, path) {
  	    if (!path) return obj;
  	    const parts = path.split(".");
  	    let cur = obj;
  	    for (const p of parts) {
  	      if (cur == null) return undefined;
  	      cur = cur[p];
  	    }
  	    return cur;
  	  }
  	
  	  function setValueByPath(obj, path, value) {
  	    const parts = path.split(".");
  	    let cur = obj;
  	    for (let i = 0; i < parts.length; i++) {
  	      const key = parts[i];
  	      if (i === parts.length - 1) {
  	        cur[key] = value;
  	      } else {
  	        if (typeof cur[key] !== "object" || cur[key] === null) {
  	          cur[key] = {};
  	        }
  	        cur = cur[key];
  	      }
  	    }
  	  }
  	
  	  function ensureArrayAtPath(obj, path) {
  	    const val = getValueByPath(obj, path);
  	    if (!Array.isArray(val)) {
  	      setValueByPath(obj, path, []);
  	      return getValueByPath(obj, path);
  	    }
  	    return val;
  	  }
  	
  	  function showToast(msg) {
  	    alert(msg); // swap out later if you want fancy toasts
  	  }
  	
  	  function buildEmptyFromSchema(schema) {
  	    const out = {};
  	    if (!schema || !Array.isArray(schema.sections)) return out;
  	
  	    schema.sections.forEach(sec => {
  	      (sec.fields || []).forEach(field => {
  	        fillDefaultForField(field, "", out);
  	      });
  	    });
  	    return out;
  	  }
  	
  	  function fillDefaultForField(fieldDef, parentPath, target) {
  	    const fieldPath = parentPath ? `${parentPath}.${fieldDef.id}` : fieldDef.id;
  	
  	    switch (fieldDef.type) {
  	      case "string":
  	      case "number":
  	      case "dropdown":
  	      case "boolean": {
  	        if (fieldDef.default != null) {
  	          setValueByPath(target, fieldPath, fieldDef.default);
  	        } else if (fieldDef.type === "boolean") {
  	          setValueByPath(target, fieldPath, false);
  	        } else {
  	          setValueByPath(target, fieldPath, null);
  	        }
  	        break;
  	      }
  	
  	      case "group": {
  	        (fieldDef.fields || []).forEach(child => {
  	          fillDefaultForField(child, fieldPath, target);
  	        });
  	        break;
  	      }
  	
  	      case "list": {
  	        setValueByPath(target, fieldPath, []);
  	        break;
  	      }
  	
  	      case "reference": {
  	        setValueByPath(target, fieldPath, null);
  	        break;
  	      }
  	
  	      case "formula": {
  	        setValueByPath(target, fieldPath, {
  	          formulaType: fieldDef.formulaType || "",
  	          inputs: {}
  	        });
  	        break;
  	      }
  	
  	      default:
  	        break;
  	    }
  	  }
  	
  	// ==========================================================
  	// AUTO-DISCOVER COLLECTIONS FROM RAW AppData
  	// ==========================================================
  	function autoExtractCollections(source, prefix = "", out = {}) {
  	  if (!source || typeof source !== "object") return out;
  	
  	  const base = prefix ? prefix + "." : "";
  	
  	  Object.keys(source).forEach(key => {
  	    const fullPath = base + key;
  	    const value = source[key];
  	
  	    // Rule 1 — any array of objects becomes a collection
  	    if (Array.isArray(value) && value.every(v => v && typeof v === "object")) {
  	      out[fullPath] = {
  	        _schema: "Generic",
  	        items: {}
  	      };
  	      value.forEach((obj, idx) => {
  	        const id =
  	          obj.objectId ||
  	          obj.id ||
  	          obj.ID ||
  	          `${key}_${idx}`;
  	        out[fullPath].items[id] = obj;
  	      });
  	    }
  	
  	    // Rule 2 — recurse into nested objects
  	    else if (value && typeof value === "object") {
  	      autoExtractCollections(value, fullPath, out);
  	    }
  	  });
  	
  	  return out;
  	}
  	
  	const dataRoot = autoExtractCollections(AppData);
  	const collectionKeys = Object.keys(dataRoot);
  	
  	
  	
  	  // ==========================================================
  	  // 3. STATE
  	  // ==========================================================
  	  const state = {
  	    collections: dataRoot,
  	    expandedCollections: new Set(collectionKeys), // start expanded
  	    activeCollectionKey: collectionKeys[0] || null,
  	    activeItemId: null,
  	    editingData: null,
  	    editingSchema: null,
  	    isDirty: false
  	  };
  	
  	  // ==========================================================
  	  // 4. EXPLORER (LEFT PANEL)
  	  // ==========================================================
  	
  	  function renderExplorer(container) {
  	    const header = createEl("div", { className: "dos-panel-header" });
  	    header.appendChild(createEl("h3", { text: "Data Explorer" }));
  	    const badge = createEl("span", {
  	      className: "dos-badge",
  	      text: `${collectionKeys.length} collections`
  	    });
  	    header.appendChild(badge);
  	    container.appendChild(header);
  	
  	    const list = createEl("div", { className: "dos-collections" });
  	
  	    collectionKeys.forEach(colKey => {
  	      const col = state.collections[colKey] || {};
  	      const schemaName = col._schema || colKey;
  	      const schema = SchemaRegistry[schemaName];
  	      const items = col.items || {};
  	      const itemIds = Object.keys(items);
  	
  	      const colBox = createEl("div", { className: "dos-collection" });
  	
  	      const headerRow = createEl("div", {
  	        className: "dos-collection-header"
  	      });
  	
  	      const titleWrap = createEl("div", {
  	        className: "dos-collection-header-title"
  	      });
  	      titleWrap.appendChild(
  	        createEl("div", {
  	          className: "dos-collection-name",
  	          text: colKey
  	        })
  	      );
  	      titleWrap.appendChild(
  	        createEl("div", {
  	          className: "dos-collection-meta",
  	          text: `${schemaName} • ${itemIds.length} item(s)`
  	        })
  	      );
  	
  	      const rightWrap = createEl("div");
  	      const toggle = createEl("span", {
  	        className: "dos-collection-toggle",
  	        text: state.expandedCollections.has(colKey) ? "▼" : "▶"
  	      });
  	      rightWrap.appendChild(toggle);
  	
  	      headerRow.appendChild(titleWrap);
  	      headerRow.appendChild(rightWrap);
  	
  	      headerRow.addEventListener("click", () => {
  	        if (state.expandedCollections.has(colKey)) {
  	          state.expandedCollections.delete(colKey);
  	        } else {
  	          state.expandedCollections.add(colKey);
  	        }
  	        render();
  	      });
  	
  	      colBox.appendChild(headerRow);
  	
  	      const itemsWrap = createEl("div", { className: "dos-collection-items" });
  	
  	      // New item button
  	      const newBtn = createEl("button", {
  	        className: "dos-btn",
  	        text: "+ New"
  	      });
  	      newBtn.type = "button";
  	      newBtn.addEventListener("click", () => {
  	        const id = prompt("New item ID:", `${colKey.toLowerCase()}_${Date.now()}`);
  	        if (!id) return;
  	
  	        const sc = schema || { sections: [] };
  	        col.items = col.items || {};
  	        if (col.items[id]) {
  	          showToast("ID already exists.");
  	          return;
  	        }
  	
  	        const empty = buildEmptyFromSchema(sc);
  	        col.items[id] = empty;
  	
  	        state.activeCollectionKey = colKey;
  	        state.activeItemId = id;
  	        state.editingSchema = sc;
  	        state.editingData = deepClone(empty);
  	        state.isDirty = false;
  	
  	        state.expandedCollections.add(colKey);
  	        render();
  	      });
  	      itemsWrap.appendChild(newBtn);
  	
  	      if (state.expandedCollections.has(colKey)) {
  	        itemIds.forEach(itemId => {
  	          const obj = items[itemId] || {};
  	          const labelField =
  	            (schema &&
  	              schema.sections &&
  	              schema.sections[0] &&
  	              schema.sections[0].fields &&
  	              schema.sections[0].fields.find(f => f.id === "name")) ||
  	            null;
  	          const displayName =
  	            labelField && obj && obj[labelField.id]
  	              ? String(obj[labelField.id])
  	              : "";
  	
  	          const btn = createEl("div", {
  	            className:
  	              "dos-item-button" +
  	              (state.activeCollectionKey === colKey &&
  	              state.activeItemId === itemId
  	                ? " dos-item-button--active"
  	                : "")
  	          });
  	
  	          const main = createEl("div", { className: "dos-item-main" });
  	          main.appendChild(
  	            createEl("div", {
  	              className: "dos-item-id",
  	              text: itemId
  	            })
  	          );
  	          if (displayName) {
  	            main.appendChild(
  	              createEl("div", {
  	                className: "dos-item-caption",
  	                text: displayName
  	              })
  	            );
  	          }
  	
  	          const delBtn = createEl("button", {
  	            className: "dos-btn dos-btn-danger",
  	            text: "×"
  	          });
  	          delBtn.type = "button";
  	          delBtn.title = "Delete item";
  	
  	          delBtn.addEventListener("click", ev => {
  	            ev.stopPropagation();
  	            if (!confirm(`Delete item "${itemId}" from "${colKey}"?`)) return;
  	            delete col.items[itemId];
  	            if (
  	              state.activeCollectionKey === colKey &&
  	              state.activeItemId === itemId
  	            ) {
  	              state.activeItemId = null;
  	              state.editingData = null;
  	              state.editingSchema = null;
  	              state.isDirty = false;
  	            }
  	            render();
  	          });
  	
  	          btn.appendChild(main);
  	          btn.appendChild(delBtn);
  	
  	          btn.addEventListener("click", () => {
  	            openItemForEdit(colKey, itemId);
  	          });
  	
  	          itemsWrap.appendChild(btn);
  	        });
  	      }
  	
  	      colBox.appendChild(itemsWrap);
  	      list.appendChild(colBox);
  	    });
  	
  	    container.appendChild(list);
  	  }
  	
  	  function openItemForEdit(collectionKey, itemId) {
  	    const col = state.collections[collectionKey];
  	    if (!col) return;
  	    const schemaName = col._schema || collectionKey;
  	    const schema = SchemaRegistry[schemaName];
  	    const rawObj = (col.items || {})[itemId];
  	
  	    if (!schema) {
  	      showToast(`No schema registered for "${schemaName}".`);
  	      return;
  	    }
  	    if (!rawObj) {
  	      showToast(`Item "${itemId}" not found in "${collectionKey}".`);
  	      return;
  	    }
  	
  	    state.activeCollectionKey = collectionKey;
  	    state.activeItemId = itemId;
  	    state.editingSchema = schema;
  	    state.editingData = deepClone(rawObj);
  	    state.isDirty = false;
  	    render();
  	  }
  	
  	  // ==========================================================
  	  // 5. EDITOR (RIGHT PANEL)
  	  // ==========================================================
  	
  	  function renderEditor(container) {
  	    const header = createEl("div", { className: "dos-editor-header" });
  	    const title = createEl("div", {
  	      className: "dos-editor-title",
  	      text: state.editingSchema
  	        ? state.editingSchema.title || "Editor"
  	        : "No item selected"
  	    });
  	    const pathText =
  	      state.activeCollectionKey && state.activeItemId
  	        ? `${state.activeCollectionKey} / ${state.activeItemId}`
  	        : "Select an item from the explorer to start editing.";
  	    const path = createEl("div", {
  	      className: "dos-editor-path",
  	      text: pathText
  	    });
  	
  	    header.appendChild(title);
  	    header.appendChild(path);
  	    container.appendChild(header);
  	
  	    if (!state.editingSchema || !state.editingData) {
  	      const empty = createEl("div", {
  	        className: "dos-editor-empty",
  	        text: "No object open. Choose a record on the left or create a new one."
  	      });
  	      container.appendChild(empty);
  	      return;
  	    }
  	
  	    const actions = createEl("div", { className: "dos-editor-actions" });
  	
  	    const resetBtn = createEl("button", {
  	      className: "dos-btn",
  	      text: "Reset"
  	    });
  	    resetBtn.type = "button";
  	    resetBtn.addEventListener("click", () => {
  	      if (!state.activeCollectionKey || !state.activeItemId) return;
  	      const col = state.collections[state.activeCollectionKey];
  	      const rawObj = (col.items || {})[state.activeItemId];
  	      state.editingData = deepClone(rawObj);
  	      state.isDirty = false;
  	      render();
  	    });
  	
  	    const saveBtn = createEl("button", {
  	      className: "dos-btn dos-btn-primary",
  	      text: "Save"
  	    });
  	    saveBtn.type = "button";
  	    saveBtn.addEventListener("click", () => {
  	      handleSave();
  	    });
  	
  	    actions.appendChild(resetBtn);
  	    actions.appendChild(saveBtn);
  	    container.appendChild(actions);
  	
  	    const sectionsWrap = createEl("div", { className: "dos-sections" });
  	
  	    (state.editingSchema.sections || []).forEach(section => {
  	      const secEl = createEl("div", { className: "dos-section" });
  	      secEl.appendChild(
  	        createEl("div", {
  	          className: "dos-section-title",
  	          text: section.label || section.id
  	        })
  	      );
  	      if (section.description) {
  	        secEl.appendChild(
  	          createEl("div", {
  	            className: "dos-section-desc",
  	            text: section.description
  	          })
  	        );
  	      }
  	
  	      const fieldsWrap = createEl("div", { className: "dos-fields" });
  	      (section.fields || []).forEach(fieldDef => {
  	        renderField(fieldDef, "", fieldsWrap);
  	      });
  	
  	      secEl.appendChild(fieldsWrap);
  	      sectionsWrap.appendChild(secEl);
  	    });
  	
  	    container.appendChild(sectionsWrap);
  	  }
  	
  	  function renderField(fieldDef, parentPath, container) {
  	    const path = parentPath ? `${parentPath}.${fieldDef.id}` : fieldDef.id;
  	    const val = getValueByPath(state.editingData, path);
  	
  	    const row = createEl("div", { className: "dos-field-row" });
  	
  	    const labelCol = createEl("div", { className: "dos-field-label" });
  	    labelCol.appendChild(
  	      createEl("span", {
  	        text: fieldDef.label || fieldDef.id
  	      })
  	    );
  	    if (fieldDef.required) {
  	      labelCol.appendChild(
  	        createEl("span", {
  	          className: "dos-required-badge",
  	          text: "Required"
  	        })
  	      );
  	    }
  	    if (fieldDef.help) {
  	      const help = createEl("span", {
  	        className: "dos-field-help",
  	        text: "ⓘ"
  	      });
  	      help.title = fieldDef.help;
  	      labelCol.appendChild(help);
  	    }
  	
  	    const inputCol = createEl("div", { className: "dos-field-input" });
  	
  	    switch (fieldDef.type) {
  	      case "string": {
  	        const input = createEl("input", {
  	          attrs: {
  	            type: "text",
  	            value: val != null ? val : "",
  	            placeholder: fieldDef.placeholder || ""
  	          }
  	        });
  	        input.addEventListener("input", () => {
  	          setValueByPath(state.editingData, path, input.value);
  	          state.isDirty = true;
  	        });
  	        inputCol.appendChild(input);
  	        break;
  	      }
  	
  	      case "number": {
  	        const input = createEl("input", {
  	          attrs: {
  	            type: "number",
  	            value: val != null ? val : "",
  	            placeholder: fieldDef.placeholder || ""
  	          }
  	        });
  	        if (fieldDef.min != null) input.min = fieldDef.min;
  	        if (fieldDef.max != null) input.max = fieldDef.max;
  	        if (fieldDef.step != null) input.step = fieldDef.step;
  	
  	        input.addEventListener("input", () => {
  	          const v = input.value;
  	          if (v === "") {
  	            setValueByPath(state.editingData, path, null);
  	          } else {
  	            const num = Number(v);
  	            setValueByPath(
  	              state.editingData,
  	              path,
  	              Number.isNaN(num) ? null : num
  	            );
  	          }
  	          state.isDirty = true;
  	        });
  	        inputCol.appendChild(input);
  	        break;
  	      }
  	
  	      case "boolean": {
  	        const label = createEl("label", { className: "dos-toggle-label" });
  	        const input = createEl("input", {
  	          attrs: {
  	            type: "checkbox"
  	          }
  	        });
  	        input.checked = !!(val != null ? val : fieldDef.default);
  	        input.addEventListener("change", () => {
  	          setValueByPath(state.editingData, path, input.checked);
  	          state.isDirty = true;
  	        });
  	        label.appendChild(input);
  	        label.appendChild(createEl("span", { text: "Yes / No" }));
  	        inputCol.appendChild(label);
  	        break;
  	      }
  	
  	      case "dropdown": {
  	        const select = createEl("select", {});
  	        const emptyOpt = createEl("option", { text: "-- Select --" });
  	        emptyOpt.value = "";
  	        select.appendChild(emptyOpt);
  	
  	        (fieldDef.options || []).forEach(opt => {
  	          const optEl = createEl("option", {
  	            text: opt.label || opt.value
  	          });
  	          optEl.value = opt.value;
  	          if (val === opt.value) optEl.selected = true;
  	          select.appendChild(optEl);
  	        });
  	
  	        select.addEventListener("change", () => {
  	          const v = select.value || null;
  	          setValueByPath(state.editingData, path, v);
  	          state.isDirty = true;
  	        });
  	
  	        inputCol.appendChild(select);
  	        break;
  	      }
  	
  	      case "group": {
  	        const group = createEl("div", { className: "dos-group" });
  	        (fieldDef.fields || []).forEach(child => {
  	          renderField(child, path, group);
  	        });
  	        inputCol.appendChild(group);
  	        break;
  	      }
  	
  	      case "list": {
  	        const listWrap = createEl("div", { className: "dos-list" });
  	        const header = createEl("div", { className: "dos-list-header" });
  	        header.appendChild(
  	          createEl("span", {
  	            text: "Items"
  	          })
  	        );
  	        const addBtn = createEl("button", {
  	          className: "dos-btn",
  	          text: "+ Add"
  	        });
  	        addBtn.type = "button";
  	        addBtn.addEventListener("click", () => {
  	          const arr = ensureArrayAtPath(state.editingData, path);
  	          const itemDef = fieldDef.item || {};
  	          let newItem;
  	          if (itemDef.type === "group") {
  	            newItem = {};
  	            (itemDef.fields || []).forEach(f => {
  	              fillDefaultForField(f, "", newItem);
  	            });
  	          } else {
  	            newItem = itemDef.default != null ? itemDef.default : null;
  	          }
  	          arr.push(newItem);
  	          state.isDirty = true;
  	          render();
  	        });
  	        header.appendChild(addBtn);
  	        listWrap.appendChild(header);
  	
  	        const itemsContainer = createEl("div", { className: "dos-list-items" });
  	        const arr = ensureArrayAtPath(state.editingData, path);
  	
  	        arr.forEach((itemVal, index) => {
  	          const itemRow = createEl("div", { className: "dos-list-item" });
  	          const main = createEl("div", { className: "dos-list-item-main" });
  	
  	          if (fieldDef.item.type === "group") {
  	            (fieldDef.item.fields || []).forEach(child => {
  	              renderField(child, `${path}.${index}`, main);
  	            });
  	          } else {
  	            const t = fieldDef.item.type === "number" ? "number" : "text";
  	            const input = createEl("input", {
  	              attrs: {
  	                type: t,
  	                value: itemVal != null ? itemVal : "",
  	                placeholder: fieldDef.item.placeholder || ""
  	              }
  	            });
  	            input.addEventListener("input", () => {
  	              const arr2 = ensureArrayAtPath(state.editingData, path);
  	              if (t === "number") {
  	                const num = Number(input.value);
  	                arr2[index] = Number.isNaN(num) ? null : num;
  	              } else {
  	                arr2[index] = input.value;
  	              }
  	              state.isDirty = true;
  	            });
  	            main.appendChild(input);
  	          }
  	
  	          const controls = createEl("div");
  	          const del = createEl("button", {
  	            className: "dos-btn dos-btn-danger",
  	            text: "Remove"
  	          });
  	          del.type = "button";
  	          del.addEventListener("click", () => {
  	            const arr2 = ensureArrayAtPath(state.editingData, path);
  	            arr2.splice(index, 1);
  	            state.isDirty = true;
  	            render();
  	          });
  	          controls.appendChild(del);
  	
  	          itemRow.appendChild(main);
  	          itemRow.appendChild(controls);
  	          itemsContainer.appendChild(itemRow);
  	        });
  	
  	        listWrap.appendChild(itemsContainer);
  	        inputCol.appendChild(listWrap);
  	        break;
  	      }
  	
  	      case "reference": {
  	        const select = createEl("select", {
  	          className: "dos-reference-select"
  	        });
  	        const emptyOpt = createEl("option", { text: "-- None --" });
  	        emptyOpt.value = "";
  	        select.appendChild(emptyOpt);
  	
  	        const sourceColKey = fieldDef.source;
  	        const col = state.collections[sourceColKey];
  	        if (col && col.items) {
  	          Object.keys(col.items).forEach(id => {
  	            const obj = col.items[id];
  	            const display =
  	              (fieldDef.displayField && obj && obj[fieldDef.displayField]) ||
  	              id;
  	            const optEl = createEl("option", { text: String(display) });
  	            optEl.value = id;
  	            select.appendChild(optEl);
  	          });
  	        }
  	
  	        const current = val && typeof val === "object" ? val.id : val;
  	        if (current) select.value = current;
  	
  	        select.addEventListener("change", () => {
  	          const chosenId = select.value || null;
  	          if (!chosenId) {
  	            setValueByPath(state.editingData, path, null);
  	          } else {
  	            setValueByPath(state.editingData, path, {
  	              collection: sourceColKey,
  	              id: chosenId
  	            });
  	          }
  	          state.isDirty = true;
  	        });
  	
  	        inputCol.appendChild(select);
  	        break;
  	      }
  	
  	      case "formula": {
  	        const box = createEl("div", { className: "dos-formula-box" });
  	        const stored =
  	          val && typeof val === "object"
  	            ? val
  	            : {
  	                formulaType: fieldDef.formulaType || "",
  	                inputs: {}
  	              };
  	
  	        box.appendChild(
  	          createEl("div", {
  	            className: "dos-section-desc",
  	            text:
  	              fieldDef.help ||
  	              "Formula config (result is calculated elsewhere, not here)."
  	          })
  	        );
  	
  	        (fieldDef.inputs || []).forEach(inputDef => {
  	          const row2 = createEl("div", { className: "dos-field-row" });
  	          const lbl = createEl("div", { className: "dos-field-label" });
  	          lbl.appendChild(
  	            createEl("span", {
  	              text: inputDef.label || inputDef.id || "Input"
  	            })
  	          );
  	          const inpCol = createEl("div", { className: "dos-field-input" });
  	
  	          if (inputDef.type === "reference") {
  	            const sel = createEl("select", { className: "dos-reference-select" });
  	            const empty = createEl("option", { text: "-- None --" });
  	            empty.value = "";
  	            sel.appendChild(empty);
  	
  	            const srcColKey = inputDef.source;
  	            const col = state.collections[srcColKey];
  	            if (col && col.items) {
  	              Object.keys(col.items).forEach(id => {
  	                const obj = col.items[id];
  	                const display =
  	                  (inputDef.displayField &&
  	                    obj &&
  	                    obj[inputDef.displayField]) ||
  	                  id;
  	                const optEl = createEl("option", { text: String(display) });
  	                optEl.value = id;
  	                sel.appendChild(optEl);
  	              });
  	            }
  	
  	            const currentVal =
  	              stored.inputs && stored.inputs[inputDef.id || inputDef.label];
  	            const currentId =
  	              currentVal && typeof currentVal === "object"
  	                ? currentVal.id
  	                : currentVal;
  	            if (currentId) sel.value = currentId;
  	
  	            sel.addEventListener("change", () => {
  	              const chosenId = sel.value || null;
  	              const key = inputDef.id || inputDef.label || "input";
  	              if (!stored.inputs) stored.inputs = {};
  	              if (!chosenId) {
  	                stored.inputs[key] = null;
  	              } else {
  	                stored.inputs[key] = {
  	                  collection: srcColKey,
  	                  id: chosenId
  	                };
  	              }
  	              setValueByPath(state.editingData, path, stored);
  	              state.isDirty = true;
  	            });
  	
  	            inpCol.appendChild(sel);
  	          } else {
  	            inpCol.appendChild(
  	              createEl("div", {
  	                className: "dos-section-desc",
  	                text: "Unsupported input type."
  	              })
  	            );
  	          }
  	
  	          row2.appendChild(lbl);
  	          row2.appendChild(inpCol);
  	          box.appendChild(row2);
  	        });
  	
  	        const preview = createEl("div", {
  	          className: "dos-formula-preview",
  	          text:
  	            "Formula type: " +
  	            (stored.formulaType || fieldDef.formulaType || "n/a") +
  	            " • Result will be computed by backend logic."
  	        });
  	        box.appendChild(preview);
  	
  	        inputCol.appendChild(box);
  	        break;
  	      }
  	
  	      default: {
  	        inputCol.appendChild(
  	          createEl("div", {
  	            className: "dos-section-desc",
  	            text: `Unsupported field type: ${fieldDef.type}`
  	          })
  	        );
  	      }
  	    }
  	
  	    row.appendChild(labelCol);
  	    row.appendChild(inputCol);
  	    container.appendChild(row);
  	  }
  	
  	  function validateRequiredFields() {
  	    const missing = [];
  	
  	    function walkField(fieldDef, parentPath) {
  	      const path = parentPath ? `${parentPath}.${fieldDef.id}` : fieldDef.id;
  	      const val = getValueByPath(state.editingData, path);
  	
  	      if (fieldDef.type === "group") {
  	        (fieldDef.fields || []).forEach(child => walkField(child, path));
  	        return;
  	      }
  	
  	      if (fieldDef.type === "list") {
  	        return;
  	      }
  	
  	      if (fieldDef.required) {
  	        const empty =
  	          val === null ||
  	          val === undefined ||
  	          (typeof val === "string" && val.trim() === "");
  	        if (empty) {
  	          missing.push(fieldDef.label || fieldDef.id);
  	        }
  	      }
  	    }
  	
  	    (state.editingSchema.sections || []).forEach(sec => {
  	      (sec.fields || []).forEach(f => walkField(f, ""));
  	    });
  	
  	    return missing;
  	  }
  	
  	  function handleSave() {
  	    if (!state.activeCollectionKey || !state.activeItemId) return;
  	
  	    const missing = validateRequiredFields();
  	    if (missing.length) {
  	      showToast("Please fill in required fields: " + missing.join(", "));
  	      return;
  	    }
  	
  	    const col = state.collections[state.activeCollectionKey];
  	    if (!col || !col.items) {
  	      showToast("Collection not found.");
  	      return;
  	    }
  	
  	    col.items[state.activeItemId] = deepClone(state.editingData);
  	    state.isDirty = false;
  	
  	    // Push back into AppData.JsonData so the rest of the app can use it
  	    if (AppData) {
  	      AppData.JsonData = state.collections;
  	    }
  	    if (Hub) {
  	      Hub.value = state.collections;
  	    }
  	
  	    showToast("Saved successfully.");
  	  }
  	
  	  // ==========================================================
  	  // 6. MAIN RENDER
  	  // ==========================================================
  	
  	  function render() {
  	    hubEl.innerHTML = "";
  	    const root = createEl("div", { className: "dos-root" });
  	
  	    const leftPanel = createEl("div", { className: "dos-panel" });
  	    const rightPanel = createEl("div", { className: "dos-panel" });
  	
  	    renderExplorer(leftPanel);
  	    renderEditor(rightPanel);
  	
  	    root.appendChild(leftPanel);
  	    root.appendChild(rightPanel);
  	    hubEl.appendChild(root);
  	  }
  	
  	  render();
  	
  	})({
  	  AppData,
  	  Hub,
  	  Backendless
  	});

  })(___arguments.context.appData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb589f58823489b55d73a8c86512ba2a')));
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e517ec0e29819ef91cfda218a0f846b6', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/322892188c78f18efd9193e7dc054259/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), 'Max')), 'Throttle')) + String('%');

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/6a993fb84d2efa08cd2881582fa8aae8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_afe6ec398aae1809c98d61f4839bb155']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'Events')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('51056bb7b1d8fa182fa8195846f8c87e')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'SelectedTractor')), 'CAN')), 'Exclusions')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), (getObjectProperty(___arguments.context.appData, 'SelectedTractor')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca82095f05f36f82678380871e101f6')), 'Throttle Overuse', ___arguments.context.appData, 'Throttle');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/b8981fc61f28d02814b83e783b382e22/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Locations, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fd81dee1f1852b56f34b68de1d3d46e', true);
  await (async function(uid) {
  	return new Promise(resolve => {
  	    function wait() {
  	        const el = ___arguments.context.getComponentByUid(uid);
  	        if (el !== undefined && el !== null) {
  	            resolve(el);
  	        } else {
  	            setTimeout(wait, 5); // try again in 5ms
  	        }
  	    }
  	    wait();
  	});

  })('67483b334ccf3f07d1147d3805582d58');
  await (async function(AppData, Locations) {
  	// ========================================================================
  	// MODULE: Location Registry v3.4 (Backwards Compatible + Global Edit Lock + Click-Through Edit Mode)
  	// PURPOSE: Headless-safe registry for Location runtime + persistence
  	// DESIGN:
  	//   - AppData = persistent JSON descriptors ONLY
  	//   - window.LocationRuntimeRegistry = live map objects + listeners
  	//   - Registry NEVER requires Map to exist
  	//   - Global edit-lock so only one location can be master at a time,
  	//     all others forced into slave mode (no click / no edit / no drag)
  	//   - v3.4 CHANGE (YOUR REQUIREMENT):
  	//       * In EDIT MODE: ALL polygons MUST NOT be selectable (NO clicks)
  	//       * In EDIT MODE: click-through MUST be allowed (map receives clicks)
  	//       * Visual: outline-only (no fill) so drawing is clean
  	// CONTEXT: Backendless Advanced Custom Code Block
  	// AUTHOR : Raymond + Rog
  	// ========================================================================
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 0: SAFE GLOBAL RESOLUTION (Golden Standard)
  	// ------------------------------------------------------------------------
  	var BackendlessSafe = (typeof Backendless !== "undefined" ? Backendless : null);
  	var AppDataSafe     = (typeof AppData     !== "undefined" ? AppData     : null);
  	var LocationsSafe   = (typeof Locations   !== "undefined" ? Locations   : null);
  	var PanelSafe       = (typeof Panel       !== "undefined" ? Panel       : null);
  	
  	// NOTE: Map is OPTIONAL here
  	var MapSafe         = (typeof Map         !== "undefined" ? Map         : null);
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 1: INITIALISE PERSISTENT STORE (JSON ONLY)
  	// ------------------------------------------------------------------------
  	if (!AppDataSafe) {
  	  // AppData not available. Registry runs volatile.
  	}
  	
  	if (AppDataSafe && !AppDataSafe.LocationRegistryStore) {
  	  AppDataSafe.LocationRegistryStore = {
  	    version: "store-v3.4",
  	    byId: {}
  	  };
  	}
  	
  	var STORE = AppDataSafe ? AppDataSafe.LocationRegistryStore : { byId: {} };
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 2: INITIALISE RUNTIME REGISTRY (LIVE OBJECTS)
  	// ------------------------------------------------------------------------
  	
  	// Map-safe shim (NO new Map())
  	function createSafeMap() {
  	  var _store = Object.create(null);
  	  return {
  	    has: function (k) { return Object.prototype.hasOwnProperty.call(_store, String(k)); },
  	    get: function (k) { k = String(k); return Object.prototype.hasOwnProperty.call(_store, k) ? _store[k] : undefined; },
  	    set: function (k, v) { _store[String(k)] = v; return this; },
  	    delete: function (k) { k = String(k); if (Object.prototype.hasOwnProperty.call(_store, k)) { delete _store[k]; return true; } return false; },
  	    clear: function () { _store = Object.create(null); },
  	    forEach: function (fn) {
  	      for (var k in _store) if (Object.prototype.hasOwnProperty.call(_store, k)) fn(_store[k], k);
  	    },
  	    values: function () {
  	      var out = [];
  	      for (var k in _store) if (Object.prototype.hasOwnProperty.call(_store, k)) out.push(_store[k]);
  	      return out;
  	    }
  	  };
  	}
  	
  	if (!window.LocationRuntimeRegistry) {
  	  window.LocationRuntimeRegistry = {
  	    version: "runtime-v3.4",
  	    byId: createSafeMap(),   // id → runtime entry (safe)
  	    activeId: null,
  	
  	    // --- Global edit lock ---
  	    editLock: { owner: null, activeId: null, mode: "idle" },
  	
  	    // snapshots for restoring options after slave/clickthrough
  	    slaveSnapshot: createSafeMap(), // id -> { poly:{...}, marker:{...} }
  	
  	    // v3.4: click-through mode state
  	    clickThrough: { owner: null, mode: "off" }
  	  };
  	}
  	
  	var RUNTIME = window.LocationRuntimeRegistry;
  	
  	// ------------------------------------------------------------------------
  	// STEP 3: LOW-LEVEL HELPERS (SAFE, SILENT)
  	// ------------------------------------------------------------------------
  	function getLocId(loc) {
  	  return (loc && (loc.objectId || loc.ObjectId || loc.id)) || null;
  	}
  	
  	function safeRemoveListener(h) {
  	  try { google.maps.event.removeListener(h); } catch (_) {}
  	}
  	
  	function removeAllListeners(runtime) {
  	  if (!runtime || !Array.isArray(runtime.listeners)) return;
  	  runtime.listeners.forEach(safeRemoveListener);
  	  runtime.listeners = [];
  	}
  	
  	function removeMapObjects(runtime) {
  	  if (!runtime) return;
  	
  	  if (runtime.polygon) {
  	    try { runtime.polygon.setMap(null); } catch (_) {}
  	    runtime.polygon = null;
  	  }
  	
  	  if (runtime.marker) {
  	    try { runtime.marker.setMap(null); } catch (_) {}
  	    runtime.marker = null;
  	  }
  	}
  	
  	function dispatchEventSafe(type, detail) {
  	  try { window.dispatchEvent(new CustomEvent(type, { detail: detail || {} })); } catch (_) {}
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 4: ENSURE / UPDATE STORE DESCRIPTOR (PURE JSON)
  	// ------------------------------------------------------------------------
  	function ensureStoreDescriptor(loc, geometryMeta) {
  	  var id = getLocId(loc);
  	  if (!id) return null;
  	
  	  var desc = STORE.byId[id] || {};
  	
  	  desc.id        = id;
  	  desc.Name      = (loc && loc.Name)  || desc.Name  || "";
  	  desc.Type      = (loc && loc.Type)  || desc.Type  || "";
  	  desc.Color     = (loc && loc.Color) || desc.Color || "";
  	  desc.CompanyId = (loc && loc.Company && loc.Company.objectId) || desc.CompanyId || "";
  	
  	  desc.GeometryMeta = geometryMeta || desc.GeometryMeta || { type: "Polygon" };
  	
  	  if (loc && loc.Polygon)        desc.Polygon       = loc.Polygon;
  	  if (loc && loc.EntrancePoint)  desc.EntrancePoint = loc.EntrancePoint;
  	
  	  STORE.byId[id] = desc;
  	  return desc;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 5: GLOBAL EDIT LOCK + SLAVE MODE
  	//   v3.4 POLICY:
  	//     - When locked/editing: ALL polygons are NOT selectable (clickable:false)
  	//     - This provides click-through for drawing on the map.
  	// ------------------------------------------------------------------------
  	function isLocked() {
  	  return !!(RUNTIME.editLock && RUNTIME.editLock.mode === "editing" && RUNTIME.editLock.owner);
  	}
  	
  	function snapshotRuntimeOptions(id, runtime) {
  	  if (!id || !runtime) return;
  	  if (!RUNTIME.slaveSnapshot) RUNTIME.slaveSnapshot = new Map();
  	  if (RUNTIME.slaveSnapshot.has(id)) return;
  	
  	  var snap = { poly: null, marker: null };
  	
  	  if (runtime.polygon) {
  	    snap.poly = {
  	      clickable: (typeof runtime.polygon.getClickable === "function") ? runtime.polygon.getClickable() : true,
  	      editable:  (typeof runtime.polygon.getEditable  === "function") ? runtime.polygon.getEditable()  : false,
  	      draggable: (typeof runtime.polygon.getDraggable === "function") ? runtime.polygon.getDraggable() : false,
  	      zIndex:    (typeof runtime.polygon.get === "function") ? runtime.polygon.get("zIndex") : null,
  	      fillOpacity:   (typeof runtime.polygon.get === "function") ? runtime.polygon.get("fillOpacity") : null,
  	      strokeOpacity: (typeof runtime.polygon.get === "function") ? runtime.polygon.get("strokeOpacity") : null,
  	      strokeWeight:  (typeof runtime.polygon.get === "function") ? runtime.polygon.get("strokeWeight") : null
  	    };
  	  }
  	
  	  if (runtime.marker) {
  	    snap.marker = {
  	      clickable: (typeof runtime.marker.getClickable === "function") ? runtime.marker.getClickable() : true,
  	      draggable: (typeof runtime.marker.getDraggable === "function") ? runtime.marker.getDraggable() : false,
  	      zIndex:    (typeof runtime.marker.get === "function") ? runtime.marker.get("zIndex") : null
  	    };
  	  }
  	
  	  RUNTIME.slaveSnapshot.set(id, snap);
  	}
  	
  	function restoreSlaveMode() {
  	  if (!RUNTIME.slaveSnapshot) return;
  	
  	  RUNTIME.byId.forEach(function (runtime, id) {
  	    var snap = RUNTIME.slaveSnapshot.get(id);
  	    if (!runtime || !snap) return;
  	
  	    if (runtime.polygon && snap.poly) {
  	      try {
  	        runtime.polygon.setOptions({
  	          clickable: !!snap.poly.clickable,
  	          editable: !!snap.poly.editable,
  	          draggable: !!snap.poly.draggable,
  	          fillOpacity: (snap.poly.fillOpacity === null || snap.poly.fillOpacity === undefined) ? 0.30 : snap.poly.fillOpacity,
  	          strokeOpacity: (snap.poly.strokeOpacity === null || snap.poly.strokeOpacity === undefined) ? 1 : snap.poly.strokeOpacity,
  	          strokeWeight: (snap.poly.strokeWeight === null || snap.poly.strokeWeight === undefined) ? 2 : snap.poly.strokeWeight,
  	          zIndex: (snap.poly.zIndex === null || snap.poly.zIndex === undefined) ? 99999999 : snap.poly.zIndex
  	        });
  	      } catch (_) {}
  	    }
  	
  	    if (runtime.marker && snap.marker) {
  	      try {
  	        runtime.marker.setOptions({
  	          clickable: !!snap.marker.clickable,
  	          draggable: !!snap.marker.draggable,
  	          zIndex: (snap.marker.zIndex === null || snap.marker.zIndex === undefined) ? 99999999 : snap.marker.zIndex
  	        });
  	      } catch (_) {}
  	    }
  	  });
  	
  	  try { RUNTIME.slaveSnapshot.clear(); } catch (_) {}
  	}
  	
  	function applyEditModePolicy() {
  	  // v3.4: In edit mode, NOTHING is selectable; click-through must be allowed.
  	  // Also: outline-only for visual clarity.
  	  RUNTIME.byId.forEach(function (runtime, id) {
  	    if (!runtime || !id) return;
  	    snapshotRuntimeOptions(id, runtime);
  	
  	    if (runtime.polygon) {
  	      try {
  	        runtime.polygon.setOptions({
  	          clickable: false,     // KEY: disables polygon hit-testing => map click-through
  	          editable: false,
  	          draggable: false,
  	          fillOpacity: 0,       // outline-only
  	          strokeOpacity: 1,
  	          strokeWeight: 2,
  	          zIndex: 1
  	        });
  	      } catch (_) {}
  	    }
  	
  	    if (runtime.marker) {
  	      try {
  	        runtime.marker.setOptions({
  	          clickable: false,
  	          draggable: false,
  	          zIndex: 1
  	        });
  	      } catch (_) {}
  	    }
  	  });
  	}
  	
  	function beginEditSession(activeId, owner) {
  	  owner = owner || "REGISTRY";
  	
  	  // if someone else owns lock, refuse
  	  if (RUNTIME.editLock && RUNTIME.editLock.owner && RUNTIME.editLock.owner !== owner) return false;
  	
  	  // v3.4: still store activeId for state, but it does NOT grant clickability
  	  RUNTIME.editLock = { owner: owner, activeId: activeId || null, mode: "editing" };
  	  RUNTIME.activeId = activeId || null;
  	
  	  // Enforce your policy immediately
  	  applyEditModePolicy();
  	
  	  dispatchEventSafe("location:edit:begin", { activeId: activeId || null, owner: owner });
  	  return true;
  	}
  	
  	function endEditSession(owner) {
  	  owner = owner || (RUNTIME.editLock ? RUNTIME.editLock.owner : null);
  	
  	  // only owner can release
  	  if (RUNTIME.editLock && RUNTIME.editLock.owner && owner && RUNTIME.editLock.owner !== owner) return false;
  	
  	  // restore previous states (clickable/fill/etc)
  	  restoreSlaveMode();
  	
  	  var prev = RUNTIME.editLock || { owner: null, activeId: null };
  	  RUNTIME.editLock = { owner: null, activeId: null, mode: "idle" };
  	  RUNTIME.activeId = null;
  	
  	  dispatchEventSafe("location:edit:end", { activeId: prev.activeId || null, owner: prev.owner || null });
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 5.6: EXPLICIT CLICK-THROUGH MODE (OPTIONAL API)
  	//   NOTE: In v3.4, edit mode already enforces click-through.
  	//   This API is still useful if your wizard wants click-through without editLock.
  	// ------------------------------------------------------------------------
  	function beginMapClickThrough(owner) {
  	  owner = owner || "WIZARD";
  	
  	  if (!RUNTIME.clickThrough) RUNTIME.clickThrough = { owner: null, mode: "off" };
  	
  	  // If someone else owns it, refuse
  	  if (RUNTIME.clickThrough.owner && RUNTIME.clickThrough.owner !== owner) return false;
  	
  	  RUNTIME.clickThrough = { owner: owner, mode: "on" };
  	
  	  RUNTIME.byId.forEach(function (runtime, id) {
  	    if (!runtime || !id) return;
  	    snapshotRuntimeOptions(id, runtime);
  	
  	    if (runtime.polygon) {
  	      try {
  	        runtime.polygon.setOptions({
  	          clickable: false,
  	          editable: false,
  	          draggable: false,
  	          fillOpacity: 0,
  	          strokeOpacity: 1
  	        });
  	      } catch (_) {}
  	    }
  	
  	    if (runtime.marker) {
  	      try {
  	        runtime.marker.setOptions({
  	          clickable: false,
  	          draggable: false
  	        });
  	      } catch (_) {}
  	    }
  	  });
  	
  	  dispatchEventSafe("location:clickthrough:begin", { owner: owner });
  	  return true;
  	}
  	
  	function endMapClickThrough(owner) {
  	  owner = owner || (RUNTIME.clickThrough ? RUNTIME.clickThrough.owner : null);
  	
  	  if (!RUNTIME.clickThrough) RUNTIME.clickThrough = { owner: null, mode: "off" };
  	
  	  // only owner can release
  	  if (RUNTIME.clickThrough.owner && owner && RUNTIME.clickThrough.owner !== owner) return false;
  	
  	  restoreSlaveMode();
  	
  	  RUNTIME.clickThrough = { owner: null, mode: "off" };
  	  dispatchEventSafe("location:clickthrough:end", { owner: owner });
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 6: UI DELEGATION (NO UI LOGIC HERE)
  	//   This MUST preserve the old behaviour that opens the HUB panel.
  	// ------------------------------------------------------------------------
  	function openEditPanel(loc, polygon, marker) {
  	  var ui = window.LocationRegistryUI;
  	
  	  if (ui && typeof ui.openEditPanel === "function") {
  	    try {
  	      ui.openEditPanel({
  	        loc: loc,
  	        polygon: polygon,
  	        marker: marker || null,
  	        registryApi: window.LocationRegistry
  	      });
  	      return;
  	    } catch (e) {
  	      // UI hook failed; fallback used.
  	    }
  	  }
  	
  	  // Minimal fallback (your existing working mechanism)
  	  try {
  	    if (typeof ___arguments !== "undefined" && ___arguments && ___arguments.context && ___arguments.context.setComponentDataStoreByUid) {
  	      ___arguments.context.setComponentDataStoreByUid(
  	        "12b83f221428faab7998dcb80dd3337b",
  	        {
  	          Location: loc,
  	          Polygon: polygon,
  	          EntranceMarker: marker || null,
  	          AppData: AppDataSafe,
  	          Registry: window.LocationRegistry
  	        }
  	      );
  	    }
  	
  	    if (PanelSafe) PanelSafe.display = true;
  	  } catch (err) {
  	    // Failed to open edit panel.
  	  }
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 7: CANONICAL LISTENER ATTACHMENT (ONLY PLACE)
  	//   v3.4: Always obey your rule:
  	//     - If isLocked() => ignore ALL polygon/marker clicks (not selectable)
  	// ------------------------------------------------------------------------
  	function attachCanonicalListeners(loc, polygon, marker) {
  	  var handles = [];
  	  var id = getLocId(loc);
  	
  	  handles.push(
  	    polygon.addListener("mouseover", function () {
  	      // In edit/locked mode: do nothing (also likely non-clickable anyway)
  	      if (isLocked()) return;
  	
  	      if (polygon.getEditable && polygon.getEditable()) return;
  	      polygon.setOptions({ fillOpacity: 0.45 });
  	    })
  	  );
  	
  	  handles.push(
  	    polygon.addListener("mouseout", function () {
  	      if (isLocked()) return;
  	
  	      if (polygon.getEditable && polygon.getEditable()) return;
  	      polygon.setOptions({ fillOpacity: 0.3 });
  	    })
  	  );
  	
  	  handles.push(
  	    polygon.addListener("click", function () {
  	      var clickId = getLocId(loc);
  	      if (!clickId) return;
  	
  	      // v3.4 RULE: In edit mode, ALL polygons NOT selectable
  	      if (isLocked()) return;
  	
  	      // If previously active, exit first (legacy behavior)
  	      if (RUNTIME.activeId && RUNTIME.activeId !== clickId) {
  	        exitEdit("REGISTRY_CLICK");
  	      }
  	
  	      // Begin edit session (will immediately enforce edit policy)
  	      beginEditSession(clickId, "REGISTRY_CLICK");
  	
  	      openEditPanel(loc, polygon, marker);
  	
  	      try {
  	        window.dispatchEvent(
  	          new CustomEvent("location:clicked", { detail: { id: clickId, loc: loc } })
  	        );
  	      } catch (_) {}
  	    })
  	  );
  	
  	  // Marker click mirrors polygon click (if marker exists)
  	  if (marker && marker.addListener) {
  	    handles.push(
  	      marker.addListener("click", function () {
  	        var clickId = getLocId(loc);
  	        if (!clickId) return;
  	
  	        if (isLocked()) return;
  	
  	        if (RUNTIME.activeId && RUNTIME.activeId !== clickId) {
  	          exitEdit("REGISTRY_CLICK");
  	        }
  	
  	        beginEditSession(clickId, "REGISTRY_CLICK");
  	        openEditPanel(loc, polygon, marker);
  	
  	        try {
  	          window.dispatchEvent(
  	            new CustomEvent("location:clicked", { detail: { id: clickId, loc: loc } })
  	          );
  	        } catch (_) {}
  	      })
  	    );
  	  }
  	
  	  return handles;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 8: PUBLIC API — REGISTER (BACKWARDS COMPATIBLE)
  	//   v3.1 contract: register(payload)
  	// ------------------------------------------------------------------------
  	function register(payload) {
  	  var loc     = (payload && (payload.location || payload.loc)) || null;
  	  var polygon = (payload && payload.polygon) || null;
  	  var marker  = (payload && (payload.marker || payload.entranceMarker)) || null;
  	  var geometryMeta = (payload && (payload.geometryMeta || payload.geometry)) || null;
  	
  	  var id = getLocId(loc);
  	  if (!id || !polygon) {
  	    return false;
  	  }
  	
  	  if (RUNTIME.byId.has(id)) {
  	    unregister(id, { keepStore: true });
  	  }
  	
  	  ensureStoreDescriptor(loc, geometryMeta || { type: "Polygon" });
  	
  	  var listeners = attachCanonicalListeners(loc, polygon, marker);
  	
  	  RUNTIME.byId.set(id, {
  	    id: id,
  	    location: loc,
  	    polygon: polygon,
  	    marker: marker || null,
  	    listeners: listeners,
  	    geometryMeta: geometryMeta || { type: "Polygon" },
  	    createdAt: Date.now()
  	  });
  	
  	  // v3.4: If locked OR clickThrough, enforce policy immediately for newly registered entries
  	  if (isLocked()) {
  	    applyEditModePolicy();
  	  } else if (RUNTIME.clickThrough && RUNTIME.clickThrough.mode === "on") {
  	    beginMapClickThrough(RUNTIME.clickThrough.owner || "WIZARD");
  	  }
  	
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 9: PUBLIC API — UNREGISTER
  	// ------------------------------------------------------------------------
  	function unregister(id, opts) {
  	  opts = opts || {};
  	  var keepStore = !!opts.keepStore;
  	
  	  var runtime = RUNTIME.byId.get(id);
  	  if (runtime) {
  	    removeAllListeners(runtime);
  	    removeMapObjects(runtime);
  	    RUNTIME.byId.delete(id);
  	  }
  	
  	  if (RUNTIME.activeId === id) {
  	    exitEdit("REGISTRY_INTERNAL");
  	  }
  	
  	  if (!keepStore) {
  	    try { delete STORE.byId[id]; } catch (_) {}
  	  }
  	
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 10: EXIT EDIT MODE (RELEASE LOCK + RESTORE SNAPSHOT)
  	// ------------------------------------------------------------------------
  	function exitEdit(owner) {
  	  // Turn off editable on active polygon (if any)
  	  var id = RUNTIME.activeId;
  	  if (id) {
  	    var runtime = RUNTIME.byId.get(id);
  	    if (runtime && runtime.polygon) {
  	      try { runtime.polygon.setEditable(false); } catch (_) {}
  	    }
  	  }
  	
  	  // Close panel
  	  if (PanelSafe) PanelSafe.display = false;
  	
  	  // Release lock and restore normal runtime options
  	  endEditSession();
  	
  	  // Clear activeId
  	  RUNTIME.activeId = null;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 11: DELETE EVERYWHERE (SERVER OPTIONAL)
  	// ------------------------------------------------------------------------
  	async function deleteEverywhere(locationId) {
  	  if (!locationId) return false;
  	
  	  if (BackendlessSafe && BackendlessSafe.Data && BackendlessSafe.Data.of) {
  	    try {
  	      await BackendlessSafe.Data.of("Locations").remove({ objectId: locationId });
  	    } catch (_) {}
  	  }
  	
  	  if (AppDataSafe && AppDataSafe.User && AppDataSafe.User.Companies) {
  	    AppDataSafe.User.Companies.forEach(function (co) {
  	      if (!Array.isArray(co.Locations)) return;
  	      co.Locations = co.Locations.filter(function (l) { return l && l.objectId !== locationId; });
  	    });
  	  }
  	
  	  if (Array.isArray(LocationsSafe)) {
  	    var idx = LocationsSafe.findIndex(function (l) { return l && l.objectId === locationId; });
  	    if (idx >= 0) LocationsSafe.splice(idx, 1);
  	  }
  	
  	  unregister(locationId, { keepStore: false });
  	  return true;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 12: HYDRATE STORE (NO MAP REQUIRED)
  	// ------------------------------------------------------------------------
  	function hydrateFromLocations(locs) {
  	  if (!Array.isArray(locs)) return 0;
  	
  	  locs.forEach(function (loc) {
  	    ensureStoreDescriptor(loc, (loc && loc.GeometryMeta) || { type: "Polygon" });
  	  });
  	
  	  return locs.length;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 13: PUBLIC API (GLOBAL) — v3.1 + NEW MODE APIS
  	// ------------------------------------------------------------------------
  	window.LocationRegistry = {
  	  version: "v3.4",
  	
  	  // v3.1 contract
  	  register: register,
  	  unregister: unregister,
  	  exitEdit: exitEdit,
  	  deleteEverywhere: deleteEverywhere,
  	
  	  getRuntime: function (id) { return RUNTIME.byId.get(id) || null; },
  	  hasRuntime: function (id) { return RUNTIME.byId.has(id); },
  	  allRuntime: function () { return Array.from(RUNTIME.byId.values()); },
  	
  	  getStore: function (id) { return STORE.byId[id] || null; },
  	  allStore: function () { return STORE.byId; },
  	
  	  hydrateFromLocations: hydrateFromLocations,
  	
  	  // lock + policy (edit mode)
  	  beginEditSession: beginEditSession,
  	  endEditSession: endEditSession,
  	  isLocked: isLocked,
  	  getLock: function () { return RUNTIME.editLock || { owner: null, activeId: null, mode: "idle" }; },
  	
  	  // explicit click-through (optional, independent of edit lock)
  	  beginMapClickThrough: beginMapClickThrough,
  	  endMapClickThrough: endMapClickThrough,
  	  getClickThrough: function () { return RUNTIME.clickThrough || { owner: null, mode: "off" }; }
  	};
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 14: BOOTSTRAP (SAFE, HEADLESS)
  	// ------------------------------------------------------------------------
  	try {
  	  if (Array.isArray(LocationsSafe)) {
  	    hydrateFromLocations(LocationsSafe);
  	  }
  	} catch (e) {
  	  // bootstrap failed
  	}

  })(___arguments.context.appData, (await Locations2()));
  await (async function(Locations, AppData, Panel, PanelBlock, Map) {
  	// ========================================================================
  	// MODULE: Simple Wizard v4.1 (Complete Rewrite + Uniform Hard Delete Location)
  	// (Registry-Driven Depict + Authoritative AppData Rehydrate + True Hard Refresh + Prune + Timing-Safe UI Pump + Optional List Sync)
  	// MAP-SAFE: DOES NOT USE new Map() OR new Set()
  	//
  	// PURPOSE:
  	//   - Depict (render) Locations polygons on the Google Map reliably
  	//   - Register polygons into LocationRegistry (registry owns listeners/state)
  	//   - Never attach polygon listeners here
  	//   - TRUE HARD REFRESH after save:
  	//       * Rehydrates a FRESH locations list from AppData (authoritative)
  	//       * Prunes deleted locations
  	//       * Clears wizard-owned polygons so new ones can render
  	//       * Never gets stuck on the initial provided Locations array
  	//   - Supports BOTH polygon formats:
  	//       A) loc.Polygon.boundary.points[{x,y}]   (x=lng, y=lat)
  	//       B) GeoJSON { type:"Polygon", coordinates:[[lng,lat]...] }
  	//   - TIMING-SAFE UI PUMP:
  	//       window.LocationRegistryUI.openEditPanel(payload) will:
  	//         * open the panel FIRST
  	//         * wait until panel is detectably open (poll w/ fail-safe)
  	//         * inject hub datastore (latest click wins)
  	//   - OPTIONAL LIST SYNC:
  	//       window.LocationRegistryUI.refreshList() can hydrate a Dynamic List by UID
  	//   - UNIFORM HARD DELETE LOCATION (NEW):
  	//       * Field-wizard style prompt (type DELETE)
  	//       * DB -> AppData -> global Locations -> Registry -> Map -> Repeater/Panel
  	//
  	// AUTHOR : Raymond + Rog
  	// ========================================================================
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 0: SAFE GLOBAL RESOLUTION (Golden Standard)
  	// ------------------------------------------------------------------------
  	var BackendlessSafe = (typeof Backendless !== "undefined" ? Backendless : null);
  	var AppDataSafe     = (typeof AppData     !== "undefined" ? AppData     : null);
  	var PanelSafe       = (typeof Panel       !== "undefined" ? Panel       : null);
  	var PanelBlockSafe  = (typeof PanelBlock  !== "undefined" ? PanelBlock  : null);
  	var MapSafe         = (typeof Map         !== "undefined" ? Map         : null);
  	
  	var RegistrySafe    = (typeof window.LocationRegistry !== "undefined" ? window.LocationRegistry : null);
  	
  	// Backendless context (often present in custom code blocks)
  	var ContextSafe =
  	  (typeof ___arguments !== "undefined" && ___arguments && ___arguments.context)
  	    ? ___arguments.context
  	    : null;
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 1: CONFIG
  	// ------------------------------------------------------------------------
  	var SIMPLE_WIZARD_CFG = {
  	  version: "v4.1-authoritative-appdata-hard-refresh+uniform-hard-delete-location",
  	
  	  // Map readiness
  	  mapReadyTimeoutMs: 3500,
  	
  	  // Fit bounds behavior
  	  doFitBoundsOnRender: true,
  	  maxZoomAfterFit: 18,
  	
  	  // Rendering defaults
  	  defaultColor: "#00BCD4",
  	  strokeWeight: 2,
  	  strokeOpacity: 0.9,
  	  fillOpacity: 0.3,
  	
  	  // Layering base zIndex
  	  zIndexBase: 99900000,
  	
  	  // HUB / PANEL PUMP SETTINGS
  	  hubDataStoreUid: "12b83f221428faab7998dcb80dd3337b",
  	
  	  // OPTIONAL: DynamicList UID to keep in sync (set null to disable)
  	  locationsListComponentUid: "c19f60f9470e0b5c1255ba7824783adf",
  	
  	  // PANEL TIMING / RETRY
  	  panelDetectMaxAttempts: 30,   // 30 * 40ms = 1200ms
  	  panelDetectDelayMs: 40,
  	  panelFailSafeInject: true,
  	
  	  // Diagnostics
  	  logPrefix: "[SimpleWizard v4.1]",
  	  verbose: true,
  	  traceClicks: true
  	};
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 2: LOGGING + UTILS
  	// ------------------------------------------------------------------------
  	function log() {
  	  if (!SIMPLE_WIZARD_CFG.verbose) return;
  	  try { console.log.apply(console, arguments); } catch (_) {}
  	}
  	function warn() {
  	  try { console.warn.apply(console, arguments); } catch (_) {}
  	}
  	function isFn(fn) { return typeof fn === "function"; }
  	
  	function dictHas(dict, key) {
  	  return !!(dict && key && Object.prototype.hasOwnProperty.call(dict, key));
  	}
  	function dictGet(dict, key) {
  	  return dictHas(dict, key) ? dict[key] : null;
  	}
  	function dictSet(dict, key, val) {
  	  if (!dict || !key) return;
  	  dict[key] = val;
  	}
  	function dictKeys(dict) {
  	  try { return Object.keys(dict || {}); } catch (_) { return []; }
  	}
  	
  	function getLocNameKey(loc) {
  	  try {
  	    var n = (loc && (loc.Name || loc.name)) ? String(loc.Name || loc.name) : "";
  	    return n.trim().toLowerCase();
  	  } catch (_) {
  	    return "";
  	  }
  	}
  	
  	function sortLocationsByNameAlpha(list) {
  	  if (!Array.isArray(list)) return [];
  	
  	  // Copy so we never mutate upstream AppData arrays unexpectedly
  	  var out = list.slice(0);
  	
  	  out.sort(function (a, b) {
  	    var an = getLocNameKey(a);
  	    var bn = getLocNameKey(b);
  	
  	    if (an < bn) return -1;
  	    if (an > bn) return 1;
  	
  	    // Tie-breaker: objectId (keeps order deterministic)
  	    var aid = getLocId(a) ? String(getLocId(a)) : "";
  	    var bid = getLocId(b) ? String(getLocId(b)) : "";
  	
  	    if (aid < bid) return -1;
  	    if (aid > bid) return 1;
  	
  	    return 0;
  	  });
  	
  	  return out;
  	}
  	
  	// ------------------------------------------------------------
  	// PATCH: EXCLUDE CHILD LOCATIONS FROM LIST (ParentId != null)
  	// ------------------------------------------------------------
  	function isNullishOrEmpty(v) {
  	  return (v === null || v === undefined || String(v).trim() === "");
  	}
  	
  	function isTopLevelLocation(loc) {
  	  try {
  	    // Support both ParentId and parentId defensively
  	    var pid =
  	      (loc && (loc.ParentId !== undefined)) ? loc.ParentId :
  	      (loc && (loc.parentId !== undefined)) ? loc.parentId :
  	      null;
  	
  	    // Only include top-level (no parent)
  	    return isNullishOrEmpty(pid);
  	  } catch (_) {
  	    return true;
  	  }
  	}
  	
  	function filterTopLevelLocations(list) {
  	  if (!Array.isArray(list)) return [];
  	  return list.filter(function (loc) {
  	    return !!loc && isTopLevelLocation(loc);
  	  });
  	}
  	
  	function getLocId(loc) {
  	  return (loc && (loc.objectId || loc.ObjectId || loc.id)) || null;
  	}
  	
  	
  	function _getProp(obj, path) {
  	  try {
  	    if (!obj || !path || typeof path !== "string") return undefined;
  	    if (obj[path] !== undefined) return obj[path];
  	
  	    var parts = path.split(".");
  	    var cur = obj;
  	    for (var i = 0; i < parts.length; i++) {
  	      if (!cur) return undefined;
  	      var key = parts[i];
  	      if (cur[key] === undefined) return undefined;
  	      cur = cur[key];
  	    }
  	    return cur;
  	  } catch (_) {
  	    return undefined;
  	  }
  	}
  	
  	function resolveAppDataAuthoritative() {
  	  // Priority: ContextSafe.appData (most current) -> AppDataSafe -> window.AppData
  	  try { if (ContextSafe && ContextSafe.appData) return ContextSafe.appData; } catch (_) {}
  	  if (AppDataSafe) return AppDataSafe;
  	
  	  try {
  	    var wAD = (typeof window !== "undefined" && typeof window.AppData !== "undefined") ? window.AppData : null;
  	    return wAD || null;
  	  } catch (_) {
  	    return null;
  	  }
  	}
  	
  	function _flattenLocationsFromAppData(appData) {
  	  // Returns a deduped list of locations from AppData.User.Companies[].Locations
  	  var out = [];
  	  var seen = Object.create(null);
  	
  	  try {
  	    var companies = _getProp(appData, "User.Companies");
  	    if (!Array.isArray(companies)) return out;
  	
  	    for (var j = 0; j < companies.length; j++) {
  	      var comp = companies[j];
  	      var locs = _getProp(comp, "Locations");
  	      if (!Array.isArray(locs)) continue;
  	
  	      for (var k = 0; k < locs.length; k++) {
  	        var loc = locs[k];
  	        if (!loc) continue;
  	
  	        var id = (loc.objectId != null) ? String(loc.objectId) : "";
  	        if (!id) continue;
  	        if (seen[id]) continue;
  	
  	        seen[id] = true;
  	        out.push(loc);
  	      }
  	    }
  	  } catch (_) {}
  	
  	  return out;
  	}
  	
  	function getLocationsFallbackGlobal() {
  	  // Fallback ONLY (non-authoritative): global Locations
  	  try {
  	    var _Locations = (typeof Locations !== "undefined" ? Locations : null);
  	    return Array.isArray(_Locations) ? _Locations : [];
  	  } catch (_) {
  	    return [];
  	  }
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 3: HARD PRECONDITIONS
  	// ------------------------------------------------------------------------
  	if (!RegistrySafe || !isFn(RegistrySafe.register) || !isFn(RegistrySafe.unregister)) {
  	  warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ LocationRegistry missing or incomplete. Aborting.");
  	  return;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 4: MAP RESOLUTION (MATCH WORKING CONTRACT)
  	// ------------------------------------------------------------------------
  	function resolveGMap(MapMaybe) {
  	  var g =
  	    (MapMaybe && MapMaybe.map && MapMaybe.map.map) ||
  	    (MapMaybe && MapMaybe.map) ||
  	    MapMaybe ||
  	    null;
  	
  	  return g || null;
  	}
  	
  	var gMap = resolveGMap(MapSafe);
  	
  	if (!gMap) {
  	  warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ Map not resolved. Aborting.");
  	  return;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 5: UI PUMP OWNER (LocationRegistryUI) + OPTIONAL LIST SYNC
  	// ------------------------------------------------------------------------
  	if (!window.__LocationHubUIState_v41) {
  	  window.__LocationHubUIState_v41 = {
  	    lastLocationId: null,
  	    lastPumpAt: 0,
  	    pumpCount: 0,
  	
  	    // Latest-wins queue
  	    pendingPayload: null,
  	    injectLoopActive: false,
  	    injectAttempt: 0
  	  };
  	}
  	var HUBSTATE = window.__LocationHubUIState_v41;
  	
  	function forceOpenPanel() {
  	  if (!PanelSafe) return;
  	
  	  try {
  	    if (typeof PanelSafe.show === "function") { PanelSafe.show(); return; }
  	    if (typeof PanelSafe.open === "function") { PanelSafe.open(); return; }
  	    if (typeof PanelSafe.setVisible === "function") { PanelSafe.setVisible(true); return; }
  	    if ("visible" in PanelSafe) { PanelSafe.visible = true; return; }
  	    if ("display" in PanelSafe) { PanelSafe.display = true; return; }
  	  } catch (_) {}
  	}
  	
  	function isPanelOpenDetected() {
  	  try {
  	    if (!PanelSafe) return false;
  	
  	    if (typeof PanelSafe.isVisible === "function") return !!PanelSafe.isVisible();
  	    if (typeof PanelSafe.isOpen === "function") return !!PanelSafe.isOpen();
  	
  	    if ("display" in PanelSafe) return !!PanelSafe.display;
  	    if ("visible" in PanelSafe) return !!PanelSafe.visible;
  	
  	    return false;
  	  } catch (_) {
  	    return false;
  	  }
  	}
  	
  	function pushHubDatastore(payload) {
  	  try {
  	    if (!ContextSafe || typeof ContextSafe.setComponentDataStoreByUid !== "function") {
  	      return false;
  	    }
  	
  	    ContextSafe.setComponentDataStoreByUid(
  	      SIMPLE_WIZARD_CFG.hubDataStoreUid,
  	      {
  	        Location: payload.loc || null,
  	        Polygon: payload.polygon || null,
  	        EntranceMarker: payload.marker || null,
  	        AppData: resolveAppDataAuthoritative(),
  	        Registry: payload.registryApi || window.LocationRegistry || null
  	      }
  	    );
  	
  	    return true;
  	  } catch (e) {
  	    warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Hub datastore push failed:", e);
  	    return false;
  	  }
  	}
  	
  	function _setDynamicListItemsByUid(componentUid, listItems) {
  	  try {
  	    if (!componentUid) return false;
  	
  	    // Prefer an explicitly provided UI context (best), else fall back to ContextSafe, else ___arguments.context
  	    var ctx =
  	      (window.__SimpleWizardUIContext_v41) ? window.__SimpleWizardUIContext_v41 :
  	      (ContextSafe) ? ContextSafe :
  	      ((typeof ___arguments !== "undefined" && ___arguments && ___arguments.context) ? ___arguments.context : null);
  	
  	    if (!ctx || typeof ctx.getComponentByUid !== "function") return false;
  	
  	    var cmp = ctx.getComponentByUid(componentUid);
  	    if (!cmp) return false;
  	
  	    cmp.dynamicListItems = Array.isArray(listItems) ? listItems : [];
  	    return true;
  	  } catch (_) {
  	    return false;
  	  }
  	}
  	
  	function refreshLocationsDynamicListIfEnabled() {
  	  try {
  	    var uid = SIMPLE_WIZARD_CFG.locationsListComponentUid;
  	    if (!uid) return false;
  	
  	    var ad = resolveAppDataAuthoritative();
  	    if (!ad) return false;
  	
  	    var list = _flattenLocationsFromAppData(ad);
  	
  	    // Exclude any Location that has a parent (ParentId not null/empty)
  	    list = filterTopLevelLocations(list);
  	
  	    // Sort alphanumeric by Name (deterministic)
  	    list = sortLocationsByNameAlpha(list);
  	
  	    return _setDynamicListItemsByUid(uid, list);
  	
  	  } catch (_) {
  	    return false;
  	  }
  	}
  	
  	
  	function scheduleInjectLatest() {
  	  if (HUBSTATE.injectLoopActive) return;
  	
  	  HUBSTATE.injectLoopActive = true;
  	  HUBSTATE.injectAttempt = 0;
  	
  	  var maxAttempts = SIMPLE_WIZARD_CFG.panelDetectMaxAttempts;
  	  var delayMs = SIMPLE_WIZARD_CFG.panelDetectDelayMs;
  	
  	  function tick() {
  	    HUBSTATE.injectAttempt++;
  	
  	    var payload = HUBSTATE.pendingPayload || {};
  	    var loc = payload.loc || null;
  	    var id = getLocId(loc);
  	
  	    var open = isPanelOpenDetected();
  	
  	    if (SIMPLE_WIZARD_CFG.traceClicks) {
  	      try {
  	        log(SIMPLE_WIZARD_CFG.logPrefix, "🟧 Inject Wait Tick", {
  	          attempt: HUBSTATE.injectAttempt,
  	          maxAttempts: maxAttempts,
  	          panelOpenDetected: open,
  	          pendingId: id,
  	          pendingName: loc && loc.Name
  	        });
  	      } catch (_) {}
  	    }
  	
  	    if (open) {
  	      var ok = pushHubDatastore(payload);
  	
  	      try {
  	        HUBSTATE.lastPumpAt = Date.now();
  	        HUBSTATE.lastLocationId = id;
  	        HUBSTATE.pumpCount = (HUBSTATE.pumpCount || 0) + 1;
  	      } catch (_) {}
  	
  	      if (SIMPLE_WIZARD_CFG.traceClicks) {
  	        try {
  	          log(SIMPLE_WIZARD_CFG.logPrefix, "🟩 Injected After Open", {
  	            id: id,
  	            name: loc && loc.Name,
  	            pushedDatastore: !!ok,
  	            attempts: HUBSTATE.injectAttempt
  	          });
  	        } catch (_) {}
  	      }
  	
  	      // Optional list sync (safe)
  	      refreshLocationsDynamicListIfEnabled();
  	
  	      HUBSTATE.injectLoopActive = false;
  	      HUBSTATE.injectAttempt = 0;
  	      return;
  	    }
  	
  	    if (HUBSTATE.injectAttempt >= maxAttempts) {
  	      if (SIMPLE_WIZARD_CFG.panelFailSafeInject) {
  	        var ok2 = pushHubDatastore(payload);
  	
  	        try {
  	          HUBSTATE.lastPumpAt = Date.now();
  	          HUBSTATE.lastLocationId = id;
  	          HUBSTATE.pumpCount = (HUBSTATE.pumpCount || 0) + 1;
  	        } catch (_) {}
  	
  	        warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Panel open not detected; fail-safe inject executed.", {
  	          id: id,
  	          name: loc && loc.Name,
  	          pushedDatastore: !!ok2,
  	          attempts: HUBSTATE.injectAttempt
  	        });
  	
  	        refreshLocationsDynamicListIfEnabled();
  	      } else {
  	        warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Panel open not detected; injection aborted (fail-safe disabled).", {
  	          pendingId: id,
  	          pendingName: loc && loc.Name,
  	          attempts: HUBSTATE.injectAttempt
  	        });
  	      }
  	
  	      HUBSTATE.injectLoopActive = false;
  	      HUBSTATE.injectAttempt = 0;
  	      return;
  	    }
  	
  	    setTimeout(tick, delayMs);
  	  }
  	
  	  setTimeout(tick, 0);
  	}
  	
  	// Define/overwrite UI owner cleanly
  	window.LocationRegistryUI = {
  	  openEditPanel: function (payload) {
  	    payload = payload || {};
  	
  	    var loc = payload.loc || null;
  	    var id = getLocId(loc);
  	    var poly = payload.polygon || null;
  	
  	    // Latest wins
  	    HUBSTATE.pendingPayload = payload;
  	
  	    if (SIMPLE_WIZARD_CFG.traceClicks) {
  	      try {
  	        log(SIMPLE_WIZARD_CFG.logPrefix, "🟦 Polygon Click Pump (queued)", {
  	          id: id,
  	          name: loc && loc.Name,
  	          type: loc && loc.Type,
  	          hasPolygonObj: !!poly,
  	          hasContext: !!ContextSafe,
  	          panelOpenDetectedNow: isPanelOpenDetected(),
  	          injectLoopActive: !!HUBSTATE.injectLoopActive
  	        });
  	      } catch (_) {}
  	    }
  	
  	    forceOpenPanel();
  	    scheduleInjectLatest();
  	  },
  	
  	  refreshList: function () {
  	    return refreshLocationsDynamicListIfEnabled();
  	  }
  	};
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 5.1: GLOBAL TRACE FOR REGISTRY CLICK EVENT (location:clicked)
  	// ------------------------------------------------------------------------
  	if (!window.__SimpleWizardClickTraceAttached_v41) {
  	  window.__SimpleWizardClickTraceAttached_v41 = true;
  	
  	  try {
  	    window.addEventListener("location:clicked", function (ev) {
  	      try {
  	        if (!SIMPLE_WIZARD_CFG.traceClicks) return;
  	        var d = (ev && ev.detail) ? ev.detail : {};
  	
  	        log(SIMPLE_WIZARD_CFG.logPrefix, "🟨 location:clicked event", {
  	          id: d.id,
  	          name: d.loc && d.loc.Name,
  	          type: d.loc && d.loc.Type,
  	          time: Date.now()
  	        });
  	      } catch (_) {}
  	    });
  	  } catch (e) {
  	    warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Failed to attach location:clicked listener:", e);
  	  }
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 6: RUNTIME STATE (IDEMPOTENT, MAP-SAFE)
  	// ------------------------------------------------------------------------
  	if (!window.__SimpleWizardRuntime_v41) {
  	  window.__SimpleWizardRuntime_v41 = {
  	    version: SIMPLE_WIZARD_CFG.version,
  	
  	    // wizard-owned polygons only (we do NOT assume registry runtime is complete)
  	    polygonsById: {}, // id -> polygon (wizard created)
  	
  	    lastMapRef: null,
  	    renderCount: 0,
  	
  	    // authoritative sources that can be set externally
  	    overrideLocations: null, // if set, used before AppData
  	    overrideAppData: null,   // if set, used before ContextSafe/AppDataSafe
  	    lastHydratedCount: 0
  	  };
  	}
  	var SWR = window.__SimpleWizardRuntime_v41;
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 7: GEOMETRY EXTRACTION (BOTH FORMATS)
  	// ------------------------------------------------------------------------
  	function normalizeNumber(n) {
  	  var x = (typeof n === "string") ? Number(n) : n;
  	  return (typeof x === "number" && !isNaN(x)) ? x : null;
  	}
  	
  	function ringToLatLngs(ring) {
  	  if (!Array.isArray(ring)) return null;
  	
  	  var pts = [];
  	  for (var i = 0; i < ring.length; i++) {
  	    var c = ring[i];
  	    if (!Array.isArray(c) || c.length < 2) continue;
  	
  	    var lng = normalizeNumber(c[0]);
  	    var lat = normalizeNumber(c[1]);
  	    if (lat === null || lng === null) continue;
  	
  	    pts.push({ lat: lat, lng: lng });
  	  }
  	
  	  // remove closure point if present
  	  if (pts.length >= 2) {
  	    var a = pts[0];
  	    var b = pts[pts.length - 1];
  	    if (a.lat === b.lat && a.lng === b.lng) pts.pop();
  	  }
  	
  	  return pts.length >= 3 ? pts : null;
  	}
  	
  	function boundaryPointsToLatLngs(points) {
  	  if (!Array.isArray(points)) return null;
  	
  	  var pts = [];
  	  for (var i = 0; i < points.length; i++) {
  	    var p = points[i];
  	    if (!p) continue;
  	
  	    // Contract: p.x = lng, p.y = lat
  	    var lng = normalizeNumber(p.x);
  	    var lat = normalizeNumber(p.y);
  	
  	    if (lat === null || lng === null) continue;
  	    pts.push({ lat: lat, lng: lng });
  	  }
  	
  	  // remove closure point if present
  	  if (pts.length >= 2) {
  	    var a = pts[0];
  	    var b = pts[pts.length - 1];
  	    if (a.lat === b.lat && a.lng === b.lng) pts.pop();
  	  }
  	
  	  return pts.length >= 3 ? pts : null;
  	}
  	
  	function getPolygonLatLngs(loc) {
  	  var poly = loc && loc.Polygon;
  	  if (!poly) return null;
  	
  	  var boundaryPoints =
  	    (poly.boundary && Array.isArray(poly.boundary.points)) ? poly.boundary.points :
  	    (poly.boundary && Array.isArray(poly.boundary.Points)) ? poly.boundary.Points :
  	    null;
  	
  	  if (boundaryPoints) {
  	    var ptsA = boundaryPointsToLatLngs(boundaryPoints);
  	    if (ptsA) return ptsA;
  	  }
  	
  	  if (poly.coordinates) {
  	    // GeoJSON variants
  	    if (poly.type === "Polygon" && Array.isArray(poly.coordinates) && Array.isArray(poly.coordinates[0])) {
  	      return ringToLatLngs(poly.coordinates[0]);
  	    }
  	
  	    if (poly.type === "MultiPolygon" &&
  	        Array.isArray(poly.coordinates) &&
  	        Array.isArray(poly.coordinates[0]) &&
  	        Array.isArray(poly.coordinates[0][0])) {
  	      return ringToLatLngs(poly.coordinates[0][0]);
  	    }
  	
  	    // loose shape
  	    if (Array.isArray(poly.coordinates[0]) && Array.isArray(poly.coordinates[0][0])) {
  	      return ringToLatLngs(poly.coordinates[0]);
  	    }
  	  }
  	
  	  return null;
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 8: BOUNDS + AREA (FOR LAYERING)
  	// ------------------------------------------------------------------------
  	function safeBounds() {
  	  try { return new google.maps.LatLngBounds(); } catch (_) { return null; }
  	}
  	
  	function extendBounds(bounds, coords) {
  	  if (!bounds || !coords || !coords.length) return;
  	  for (var i = 0; i < coords.length; i++) {
  	    try { bounds.extend(coords[i]); } catch (_) {}
  	  }
  	}
  	
  	function boundsIsEmpty(bounds) {
  	  try { return !bounds || bounds.isEmpty(); } catch (_) { return true; }
  	}
  	
  	function mapLooksReady(m) {
  	  try {
  	    if (m && isFn(m.getBounds)) return !!m.getBounds();
  	    return false;
  	  } catch (_) {
  	    return false;
  	  }
  	}
  	
  	function debugMapInfo() {
  	  try {
  	    var c = (gMap && isFn(gMap.getCenter)) ? gMap.getCenter() : null;
  	    var z = (gMap && isFn(gMap.getZoom)) ? gMap.getZoom() : null;
  	    log(SIMPLE_WIZARD_CFG.logPrefix, "🧭 Map center/zoom:", c ? { lat: c.lat(), lng: c.lng() } : c, z);
  	  } catch (_) {}
  	}
  	
  	function computeAreaSqm(coords) {
  	  if (!Array.isArray(coords) || coords.length < 3) return 0;
  	
  	  // Prefer geometry library if present
  	  try {
  	    if (google &&
  	        google.maps &&
  	        google.maps.geometry &&
  	        google.maps.geometry.spherical &&
  	        typeof google.maps.geometry.spherical.computeArea === "function") {
  	      var path = [];
  	      for (var i = 0; i < coords.length; i++) {
  	        path.push(new google.maps.LatLng(coords[i].lat, coords[i].lng));
  	      }
  	      var a = google.maps.geometry.spherical.computeArea(path);
  	      return (typeof a === "number" && !isNaN(a)) ? a : 0;
  	    }
  	  } catch (_) {}
  	
  	  // Fallback: planar shoelace (good enough for ordering)
  	  try {
  	    var meanLat = 0;
  	    for (var j = 0; j < coords.length; j++) meanLat += coords[j].lat;
  	    meanLat = meanLat / coords.length;
  	
  	    var mPerDegLat = 111132.92;
  	    var mPerDegLng = 111319.49 * Math.cos(meanLat * Math.PI / 180);
  	
  	    var sum = 0;
  	    for (var k = 0; k < coords.length; k++) {
  	      var p1 = coords[k];
  	      var p2 = coords[(k + 1) % coords.length];
  	
  	      var x1 = p1.lng * mPerDegLng;
  	      var y1 = p1.lat * mPerDegLat;
  	      var x2 = p2.lng * mPerDegLng;
  	      var y2 = p2.lat * mPerDegLat;
  	
  	      sum += (x1 * y2 - x2 * y1);
  	    }
  	
  	    var area = Math.abs(sum) / 2;
  	    return (typeof area === "number" && !isNaN(area)) ? area : 0;
  	  } catch (_) {
  	    return 0;
  	  }
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 9: AUTHORITATIVE LOCATIONS RESOLUTION (THE FIX)
  	// ------------------------------------------------------------------------
  	function resolveLocationsAuthoritative() {
  	  // Priority:
  	  //  1) SWR.overrideLocations if set via SimpleWizard.setLocations()
  	  //  2) SWR.overrideAppData if set via SimpleWizard.setAppData()
  	  //  3) ContextSafe.appData / AppDataSafe / window.AppData
  	  //  4) global Locations fallback
  	  try {
  	    if (Array.isArray(SWR.overrideLocations)) return SWR.overrideLocations;
  	  } catch (_) {}
  	
  	  var appData = null;
  	
  	  try {
  	    if (SWR.overrideAppData) appData = SWR.overrideAppData;
  	  } catch (_) {}
  	
  	  if (!appData) appData = resolveAppDataAuthoritative();
  	
  	  var fromAD = _flattenLocationsFromAppData(appData);
  	  if (fromAD && fromAD.length) return fromAD;
  	
  	  return getLocationsFallbackGlobal();
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 10: HARD CLEANUP + PRUNE + REGISTRY CONSISTENCY
  	// ------------------------------------------------------------------------
  	function _removeWizardPolygonById(id) {
  	  var poly = dictGet(SWR.polygonsById, id);
  	  try { if (poly && isFn(poly.setMap)) poly.setMap(null); } catch (_) {}
  	  try { delete SWR.polygonsById[id]; } catch (_) {}
  	}
  	
  	function _unregisterIfPossible(id, keepStore) {
  	  try {
  	    if (RegistrySafe && isFn(RegistrySafe.unregister)) {
  	      RegistrySafe.unregister(id, { keepStore: !!keepStore });
  	    }
  	  } catch (_) {}
  	}
  	
  	function pruneMissingLocations(liveIdsDict) {
  	  // 1) Remove wizard-owned polygons no longer present
  	  dictKeys(SWR.polygonsById).forEach(function (existingId) {
  	    if (!dictHas(liveIdsDict, existingId)) {
  	      _removeWizardPolygonById(existingId);
  	    }
  	  });
  	
  	  // 2) Ask registry to unregister missing IDs if it can (optional)
  	  try {
  	    if (RegistrySafe && isFn(RegistrySafe.pruneMissing)) {
  	      RegistrySafe.pruneMissing(liveIdsDict);
  	      return;
  	    }
  	  } catch (_) {}
  	
  	  // 3) Fallback: If registry exposes runtimes, attempt to unregister missing
  	  try {
  	    if (RegistrySafe && isFn(RegistrySafe.getAllRuntimeIds)) {
  	      var ids = RegistrySafe.getAllRuntimeIds();
  	      if (Array.isArray(ids)) {
  	        for (var i = 0; i < ids.length; i++) {
  	          var id = ids[i];
  	          if (!dictHas(liveIdsDict, id)) _unregisterIfPossible(id, true);
  	        }
  	      }
  	    }
  	  } catch (_) {}
  	}
  	
  	function cleanupAllWizardPolygons() {
  	  var ids = dictKeys(SWR.polygonsById);
  	  for (var i = 0; i < ids.length; i++) _removeWizardPolygonById(ids[i]);
  	  SWR.polygonsById = {};
  	}
  	
  	function hardResetRegistryRuntimeIfSupported() {
  	  try { if (RegistrySafe && isFn(RegistrySafe.clearRuntime)) RegistrySafe.clearRuntime(); } catch (_) {}
  	  try { if (RegistrySafe && isFn(RegistrySafe.resetRuntime)) RegistrySafe.resetRuntime(); } catch (_) {}
  	  try { if (RegistrySafe && isFn(RegistrySafe.reset)) RegistrySafe.reset(); } catch (_) {}
  	}
  	
  	function ensureRegistryPolygonOnMapAndZ(id, zIndex) {
  	  // Returns:
  	  //   { ok:true, polygon: <poly> } if registry already has a polygon we can keep
  	  //   { ok:false } if registry has no polygon runtime and we should draw/register
  	  try {
  	    if (!RegistrySafe || !isFn(RegistrySafe.getRuntime)) return { ok: false };
  	
  	    var rt = RegistrySafe.getRuntime(id);
  	    if (!rt || !rt.polygon) return { ok: false };
  	
  	    var poly = rt.polygon;
  	
  	    try {
  	      if (poly.getMap && poly.getMap() !== gMap && isFn(poly.setMap)) poly.setMap(gMap);
  	    } catch (_) {}
  	
  	    try {
  	      if (typeof zIndex === "number" && isFn(poly.setOptions)) {
  	        poly.setOptions({ zIndex: zIndex });
  	      }
  	    } catch (_) {}
  	
  	    return { ok: true, polygon: poly };
  	  } catch (_) {
  	    return { ok: false };
  	  }
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 11: RENDER (DEPICT) LOCATIONS + LAYERING (AUTHORITATIVE)
  	// ------------------------------------------------------------------------
  	function renderAllLocations(opts) {
  	  opts = opts || {};
  	  var doFit = (opts.doFitBounds !== undefined) ? !!opts.doFitBounds : !!SIMPLE_WIZARD_CFG.doFitBoundsOnRender;
  	
  	  // If map reference changed, hard cleanup wizard polygons
  	  if (SWR.lastMapRef && SWR.lastMapRef !== gMap) {
  	    cleanupAllWizardPolygons();
  	  }
  	  SWR.lastMapRef = gMap;
  	
  	  debugMapInfo();
  	
  	  // ALWAYS resolve fresh list
  	  var liveLocations = resolveLocationsAuthoritative();
  	  SWR.lastHydratedCount = liveLocations.length;
  	
  	  // Build liveIds dict for prune
  	  var liveIds = {};
  	  for (var i0 = 0; i0 < liveLocations.length; i0++) {
  	    var loc0 = liveLocations[i0];
  	    var id0 = getLocId(loc0);
  	    if (id0) liveIds[id0] = true;
  	  }
  	
  	  // Prune missing
  	  pruneMissingLocations(liveIds);
  	
  	  var bounds = safeBounds();
  	
  	  var renderedNew = 0;
  	  var reusedRegistryRuntime = 0;
  	  var skippedNoPolygon = 0;
  	  var skippedBadGeometry = 0;
  	
  	  // Build candidates with area for layering
  	  var renderList = [];
  	  for (var i = 0; i < liveLocations.length; i++) {
  	    var loc = liveLocations[i];
  	    var id = getLocId(loc);
  	    if (!id) continue;
  	
  	    var coords = getPolygonLatLngs(loc);
  	
  	    if (!coords) { skippedNoPolygon++; continue; }
  	    if (coords.length < 3) { skippedBadGeometry++; continue; }
  	
  	    renderList.push({
  	      id: id,
  	      loc: loc,
  	      coords: coords,
  	      areaSqm: computeAreaSqm(coords)
  	    });
  	  }
  	
  	  // Sort: largest first (largest drawn first, smallest on top)
  	  renderList.sort(function (a, b) {
  	    return (b.areaSqm || 0) - (a.areaSqm || 0);
  	  });
  	
  	  if (SIMPLE_WIZARD_CFG.traceClicks) {
  	    try {
  	      log(SIMPLE_WIZARD_CFG.logPrefix, "🧩 Layering order (largest -> smallest)", renderList.map(function (r) {
  	        return {
  	          id: r.id,
  	          name: r.loc && r.loc.Name,
  	          type: r.loc && r.loc.Type,
  	          areaSqm: Math.round(r.areaSqm || 0)
  	        };
  	      }));
  	    } catch (_) {}
  	  }
  	
  	  // Render / Reuse registry runtime
  	  for (var k = 0; k < renderList.length; k++) {
  	    var item = renderList[k];
  	    var locX = item.loc;
  	    var idX = item.id;
  	    var coordsX = item.coords;
  	
  	    var color = (locX && locX.Color) ? locX.Color : SIMPLE_WIZARD_CFG.defaultColor;
  	    var zLayer = (SIMPLE_WIZARD_CFG.zIndexBase || 0) + k;
  	
  	    // If registry already has runtime polygon, prefer reusing it (no double-register)
  	    var keep = ensureRegistryPolygonOnMapAndZ(idX, zLayer);
  	    if (keep.ok) {
  	      reusedRegistryRuntime++;
  	      extendBounds(bounds, coordsX);
  	      continue;
  	    }
  	
  	    // If wizard previously created one for this id, remove it (geometry/color could change)
  	    _removeWizardPolygonById(idX);
  	
  	    // Create polygon
  	    var polygon = null;
  	    try {
  	      polygon = new google.maps.Polygon({
  	        paths: coordsX,
  	        strokeColor: color,
  	        strokeOpacity: SIMPLE_WIZARD_CFG.strokeOpacity,
  	        strokeWeight: SIMPLE_WIZARD_CFG.strokeWeight,
  	        fillColor: color,
  	        fillOpacity: SIMPLE_WIZARD_CFG.fillOpacity,
  	        clickable: true,
  	        zIndex: zLayer,
  	        map: gMap
  	      });
  	    } catch (e1) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Polygon create failed:", idX, e1);
  	      continue;
  	    }
  	
  	    extendBounds(bounds, coordsX);
  	
  	    // Register with registry (registry owns listeners/state)
  	    try {
  	      RegistrySafe.register({
  	        location: locX,
  	        polygon: polygon,
  	        geometryMeta: {
  	          type: (locX && (locX.CreationType || (locX.GeometryMeta && locX.GeometryMeta.type))) || "Polygon"
  	        }
  	      });
  	    } catch (e2) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix, "⚠️ Registry register failed:", idX, e2);
  	      try { polygon.setMap(null); } catch (_) {}
  	      continue;
  	    }
  	
  	    dictSet(SWR.polygonsById, idX, polygon);
  	    renderedNew++;
  	  }
  	
  	  // Fit bounds
  	  try {
  	    if (doFit && bounds && !boundsIsEmpty(bounds) && isFn(gMap.fitBounds)) {
  	      gMap.fitBounds(bounds);
  	
  	      if (google && google.maps && google.maps.event && isFn(google.maps.event.addListenerOnce)) {
  	        google.maps.event.addListenerOnce(gMap, "bounds_changed", function () {
  	          try {
  	            if (isFn(gMap.getZoom) && isFn(gMap.setZoom)) {
  	              var z = gMap.getZoom();
  	              if (z > SIMPLE_WIZARD_CFG.maxZoomAfterFit) gMap.setZoom(SIMPLE_WIZARD_CFG.maxZoomAfterFit);
  	            }
  	          } catch (_) {}
  	        });
  	      }
  	    }
  	  } catch (_) {}
  	
  	  try { SWR.renderCount = (SWR.renderCount || 0) + 1; } catch (_) {}
  	
  	  log(SIMPLE_WIZARD_CFG.logPrefix, "✅ Render complete:", {
  	    renderedNew: renderedNew,
  	    reusedRegistryRuntime: reusedRegistryRuntime,
  	    skippedNoPolygon: skippedNoPolygon,
  	    skippedBadGeometry: skippedBadGeometry,
  	    locationsTotal: liveLocations.length,
  	    renderCount: SWR.renderCount,
  	    reason: opts.reason || null
  	  });
  	
  	  // Optional list sync
  	  refreshLocationsDynamicListIfEnabled();
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 12: MAP READY GUARDS + PUBLIC API (THE FIXED CONTRACT)
  	// ------------------------------------------------------------------------
  	function onMapReadyRunOnce() {
  	  if (window.__SimpleWizardHasRunOnce_v41 === true) return;
  	  window.__SimpleWizardHasRunOnce_v41 = true;
  	  renderAllLocations({ reason: "initial" });
  	}
  	
  	function attachReadyGuards() {
  	  if (mapLooksReady(gMap)) {
  	    onMapReadyRunOnce();
  	    return;
  	  }
  	
  	  try {
  	    if (google && google.maps && google.maps.event && isFn(google.maps.event.addListenerOnce)) {
  	      google.maps.event.addListenerOnce(gMap, "idle", function () {
  	        onMapReadyRunOnce();
  	      });
  	    }
  	  } catch (_) {}
  	
  	  setTimeout(function () {
  	    onMapReadyRunOnce();
  	  }, SIMPLE_WIZARD_CFG.mapReadyTimeoutMs);
  	}
  	
  	
  	// ------------------------------------------------------------------------
  	// STEP 13: START + EXPORTED API
  	// ------------------------------------------------------------------------
  	try {
  	  window.__SimpleWizardHasRunOnce_v41 = false;
  	
  	  window.SimpleWizard = window.SimpleWizard || {};
  	
  	  // ------------------------------------------------------------
  	  // PATCH: Allow UI Builder panel OnMounted to hand us its context
  	  // ------------------------------------------------------------
  	  window.SimpleWizard.setUIContext = function (ctx) {
  	    try {
  	      window.__SimpleWizardUIContext_v41 = ctx || null;
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  };
  	
  	  // ------------------------------------------------------------
  	  // PATCH: Allow panel to tell wizard which dynamic list UID to sync
  	  // ------------------------------------------------------------
  	  window.SimpleWizard.setLocationsListUid = function (uid) {
  	    try {
  	      SIMPLE_WIZARD_CFG.locationsListComponentUid = uid || null;
  	      return true;
  	    } catch (_) {
  	      return false;
  	    }
  	  };
  	
  	  // ============================================================
  	  // NEW: Uniform Hard Delete Location (Field Wizard look & feel)
  	  // Usage:
  	  //   window.SimpleWizard.hardDeleteLocationPrompt(locationObjectId)
  	  // ============================================================
  	  window.SimpleWizard.hardDeleteLocationPrompt = function (locationObjectId) {
  	
  	    // ------------------------------------------------------------
  	    // STEP 0: SAFE GLOBAL RESOLUTION (Golden Standard)
  	    // ------------------------------------------------------------
  	    var _Backendless = (typeof Backendless !== "undefined" ? Backendless : null);
  	    var _LocationRegistry = (typeof window !== "undefined"
  	      ? (typeof window.LocationRegistry !== "undefined" ? window.LocationRegistry : null)
  	      : null);
  	    var _SimpleWizard = (typeof window !== "undefined"
  	      ? (typeof window.SimpleWizard !== "undefined" ? window.SimpleWizard : null)
  	      : null);
  	    var _LocationRegistryUI = (typeof window !== "undefined"
  	      ? (typeof window.LocationRegistryUI !== "undefined" ? window.LocationRegistryUI : null)
  	      : null);
  	
  	    var _Panel = (typeof Panel !== "undefined" ? Panel : null);
  	    var _Hub   = (typeof Hub   !== "undefined" ? Hub   : null);
  	
  	    var _AppData = null;
  	    try { _AppData = (typeof resolveAppDataAuthoritative === "function") ? resolveAppDataAuthoritative() : null; } catch (_) {}
  	    if (!_AppData) _AppData = (typeof AppData !== "undefined" ? AppData : null);
  	
  	    var id = (locationObjectId != null) ? String(locationObjectId).trim() : "";
  	    if (!id) { alert("Delete failed: locationObjectId is empty."); return false; }
  	    if (!_Backendless || !_Backendless.Data || typeof _Backendless.Data.of !== "function") {
  	      alert("Delete failed: Backendless not available.");
  	      return false;
  	    }
  	
  	    // ------------------------------------------------------------
  	    // STEP 1: PROMPT UI (type DELETE)
  	    // ------------------------------------------------------------
  	    function mountRoot() {
  	      try {
  	        if (_Panel && _Panel.el) return _Panel.el;
  	        if (_Hub && _Hub.el) return _Hub.el;
  	        if (_Hub) return _Hub;
  	      } catch (_) {}
  	      return document.body;
  	    }
  	
  	    // Prevent multiple prompts
  	    try {
  	      var existing = document.getElementById("__hardDeletePrompt");
  	      if (existing) existing.remove();
  	    } catch (_) {}
  	
  	    var root = mountRoot();
  	
  	    var overlay = document.createElement("div");
  	    overlay.id = "__hardDeletePrompt";
  	    Object.assign(overlay.style, {
  	      position: "fixed",
  	      inset: "0",
  	      background: "rgba(0,0,0,0.65)",
  	      zIndex: 999999,
  	      display: "flex",
  	      alignItems: "center",
  	      justifyContent: "center",
  	      fontFamily: "system-ui, sans-serif"
  	    });
  	
  	    var card = document.createElement("div");
  	    Object.assign(card.style, {
  	      width: "360px",
  	      background: "#1f1f1f",
  	      color: "#fff",
  	      borderRadius: "12px",
  	      border: "1px solid rgba(204,102,51,0.8)",
  	      boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
  	      padding: "14px 14px 12px"
  	    });
  	
  	    var title = document.createElement("div");
  	    title.textContent = "Hard Delete Location";
  	    Object.assign(title.style, { fontWeight: "700", fontSize: "14px", color: "#CC6633" });
  	
  	    var msg = document.createElement("div");
  	    msg.innerHTML =
  	      "This will permanently delete the Location everywhere.<br>" +
  	      "<div style='margin-top:6px;font-size:11px;color:#bbb'>Location objectId: <b style='color:#eee'>" + id + "</b></div>" +
  	      "<div style='margin-top:10px;font-size:12px;color:#ddd'>Type <b>DELETE</b> to enable the button.</div>";
  	
  	    var input = document.createElement("input");
  	    input.type = "text";
  	    input.placeholder = "Type DELETE";
  	    Object.assign(input.style, {
  	      width: "100%",
  	      padding: "8px",
  	      marginTop: "10px",
  	      borderRadius: "8px",
  	      border: "none",
  	      outline: "none",
  	      background: "#2a2a2a",
  	      color: "#fff",
  	      fontSize: "13px"
  	    });
  	
  	    var row = document.createElement("div");
  	    Object.assign(row.style, { display: "flex", gap: "8px", marginTop: "12px" });
  	
  	    function btnStyle(bg) {
  	      return {
  	        flex: "1",
  	        padding: "8px",
  	        borderRadius: "8px",
  	        border: "none",
  	        cursor: "pointer",
  	        color: "#fff",
  	        fontWeight: "700",
  	        background: bg,
  	        fontSize: "13px"
  	      };
  	    }
  	
  	    var cancelBtn = document.createElement("button");
  	    cancelBtn.textContent = "Cancel";
  	    Object.assign(cancelBtn.style, btnStyle("#444"));
  	
  	    var delBtn = document.createElement("button");
  	    delBtn.textContent = "Delete";
  	    Object.assign(delBtn.style, btnStyle("#7a1f1f"));
  	    delBtn.disabled = true;
  	    delBtn.style.opacity = "0.5";
  	    delBtn.style.cursor = "not-allowed";
  	
  	    var status = document.createElement("div");
  	    Object.assign(status.style, { marginTop: "10px", fontSize: "11px", color: "#aaa", minHeight: "14px" });
  	
  	    input.oninput = function () {
  	      var ok = String(input.value || "").trim().toUpperCase() === "DELETE";
  	      delBtn.disabled = !ok;
  	      delBtn.style.opacity = ok ? "1" : "0.5";
  	      delBtn.style.cursor = ok ? "pointer" : "not-allowed";
  	    };
  	
  	    function closePrompt() {
  	      try { overlay.remove(); } catch (_) {}
  	    }
  	
  	    cancelBtn.onclick = function () { closePrompt(); };
  	
  	    overlay.addEventListener("click", function (e) {
  	      if (e && e.target === overlay) closePrompt();
  	    });
  	
  	    card.appendChild(title);
  	    card.appendChild(msg);
  	    card.appendChild(input);
  	    row.appendChild(cancelBtn);
  	    row.appendChild(delBtn);
  	    card.appendChild(row);
  	    card.appendChild(status);
  	    overlay.appendChild(card);
  	    root.appendChild(overlay);
  	
  	    // ------------------------------------------------------------
  	    // STEP 2: DELETE HELPERS
  	    // ------------------------------------------------------------
  	    function purgeLocationFromAppData(appData, objectId) {
  	      try {
  	        if (!appData || !appData.User || !Array.isArray(appData.User.Companies)) return;
  	
  	        var comps = appData.User.Companies;
  	
  	        for (var ci = 0; ci < comps.length; ci++) {
  	          var comp = comps[ci];
  	          if (!comp) continue;
  	
  	          if (Array.isArray(comp.Locations)) {
  	            comp.Locations = comp.Locations.filter(function (L) {
  	              if (!L) return false;
  	              return String(L.objectId || L.id || "") !== String(objectId);
  	            });
  	          }
  	        }
  	      } catch (_) {}
  	    }
  	
  	    function buildAllLocationsFromAppData(appData) {
  	      var out = [];
  	      var seen = Object.create(null);
  	
  	      function pushDedup(x) {
  	        try {
  	          if (!x) return;
  	          var oid = (x.objectId != null) ? String(x.objectId) : "";
  	          if (!oid || seen[oid]) return;
  	          seen[oid] = true;
  	          out.push(x);
  	        } catch (_) {}
  	      }
  	
  	      try {
  	        var comps = (appData && appData.User && Array.isArray(appData.User.Companies)) ? appData.User.Companies : [];
  	        for (var ci = 0; ci < comps.length; ci++) {
  	          var comp = comps[ci];
  	          var locs = (comp && Array.isArray(comp.Locations)) ? comp.Locations : [];
  	          for (var li = 0; li < locs.length; li++) pushDedup(locs[li]);
  	        }
  	      } catch (_) {}
  	
  	      return out;
  	    }
  	
  	    // ------------------------------------------------------------
  	    // STEP 3: HARD DELETE PIPELINE
  	    // ------------------------------------------------------------
  	    async function hardDeleteEverywhere(objectId) {
  	
  	      // 1) DB delete
  	      status.textContent = "Deleting from database.";
  	      await _Backendless.Data.of("Locations").remove({ objectId: objectId });
  	
  	      // 2) AppData purge
  	      status.textContent = "Purging from AppData.";
  	      purgeLocationFromAppData(_AppData, objectId);
  	
  	      // 2.5) ALSO purge from global Locations array (legacy binding safety)
  	      try {
  	        var LocationsSafe = (typeof Locations !== "undefined" ? Locations : null);
  	        if (Array.isArray(LocationsSafe)) {
  	          LocationsSafe = LocationsSafe.filter(function (l) {
  	            return l && String(l.objectId || l.id || "") !== String(objectId);
  	          });
  	          try { Locations = LocationsSafe; } catch (_) {}
  	        }
  	      } catch (_) {}
  	
  	      // 3) Registry cleanup + (optional) hydrate
  	      status.textContent = "Refreshing registry.";
  	      var allLocs = buildAllLocationsFromAppData(_AppData);
  	
  	      if (_LocationRegistry) {
  	        try { if (typeof _LocationRegistry.removeById === "function") _LocationRegistry.removeById(objectId); } catch (_) {}
  	        try { if (typeof _LocationRegistry.unregister === "function") _LocationRegistry.unregister(objectId, { keepStore: true }); } catch (_) {}
  	
  	        // If your registry expects reset/hydrate for full consistency, do it (tolerant)
  	        try { if (typeof _LocationRegistry.reset === "function") _LocationRegistry.reset(); } catch (_) {}
  	        try {
  	          if (typeof _LocationRegistry.hydrateFromLocations === "function") _LocationRegistry.hydrateFromLocations(allLocs);
  	          else if (typeof _LocationRegistry.hydrate === "function") _LocationRegistry.hydrate(allLocs);
  	        } catch (_) {}
  	      }
  	
  	      // 4) Map redraw (wizard pipeline)
  	      status.textContent = "Refreshing map.";
  	      if (_SimpleWizard) {
  	        if (typeof _SimpleWizard.hardRefresh === "function") _SimpleWizard.hardRefresh({ reason: "hard-delete-location", doFitBounds: false });
  	        else if (typeof _SimpleWizard.refresh === "function") _SimpleWizard.refresh({ reason: "hard-delete-location", doFitBounds: false });
  	      }
  	
  	      // 5) UI last: repeater/list refresh
  	      status.textContent = "Refreshing panel.";
  	      setTimeout(function () {
  	        try {
  	          if (_LocationRegistryUI && typeof _LocationRegistryUI.refreshList === "function") _LocationRegistryUI.refreshList();
  	        } catch (_) {}
  	
  	        try {
  	          if (typeof window !== "undefined" && window && typeof window.dispatchEvent === "function") {
  	            window.dispatchEvent(new CustomEvent("LocationRegistry:updated", {
  	              detail: { reason: "hard-delete-location", objectId: objectId }
  	            }));
  	          }
  	        } catch (_) {}
  	      }, 0);
  	    }
  	
  	    delBtn.onclick = async function () {
  	      delBtn.disabled = true;
  	      cancelBtn.disabled = true;
  	      input.disabled = true;
  	
  	      try {
  	        await hardDeleteEverywhere(id);
  	        status.textContent = "Deleted successfully.";
  	        setTimeout(function () {
  	          closePrompt();
  	          alert("Location deleted successfully.");
  	        }, 250);
  	      } catch (e) {
  	        try { console.error("[HardDeleteLocation]", e); } catch (_) {}
  	        status.textContent = "Delete failed. Check console.";
  	        delBtn.disabled = false;
  	        cancelBtn.disabled = false;
  	        input.disabled = false;
  	      }
  	    };
  	
  	    return true;
  	  };
  	
  	  // --- Primary refresh (always rehydrates from AppData) ---
  	  window.SimpleWizard.refresh = function (opts) {
  	    opts = opts || {};
  	    try {
  	      renderAllLocations({
  	        reason: opts.reason || "manual",
  	        doFitBounds: (opts.doFitBounds !== undefined) ? !!opts.doFitBounds : undefined
  	      });
  	    } catch (e) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ refresh() failed:", e);
  	    }
  	  };
  	
  	  // --- True hard refresh after save (clears wizard polygons + optional registry runtime reset) ---
  	  window.SimpleWizard.hardRefresh = function (opts) {
  	    opts = opts || {};
  	    try {
  	      cleanupAllWizardPolygons();
  	
  	      if (opts.resetRegistryRuntime === true) {
  	        hardResetRegistryRuntimeIfSupported();
  	      }
  	
  	      renderAllLocations({
  	        reason: opts.reason || "hardRefresh",
  	        doFitBounds: (opts.doFitBounds !== undefined) ? !!opts.doFitBounds : true
  	      });
  	
  	      return true;
  	    } catch (e) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ hardRefresh() failed:", e);
  	      return false;
  	    }
  	  };
  	
  	  // --- Authoritative hooks ---
  	  window.SimpleWizard.setLocations = function (locs) {
  	    try { SWR.overrideLocations = Array.isArray(locs) ? locs : null; return true; } catch (_) { return false; }
  	  };
  	
  	  window.SimpleWizard.setAppData = function (appData) {
  	    try { SWR.overrideAppData = appData || null; return true; } catch (_) { return false; }
  	  };
  	
  	  window.SimpleWizard.hardRefreshFromAppData = function (appData, fallbackLocations, opts) {
  	    opts = opts || {};
  	    try {
  	      SWR.overrideAppData = appData || null;
  	      SWR.overrideLocations = Array.isArray(fallbackLocations) ? fallbackLocations : null;
  	
  	      cleanupAllWizardPolygons();
  	
  	      if (opts.resetRegistryRuntime === true) {
  	        hardResetRegistryRuntimeIfSupported();
  	      }
  	
  	      renderAllLocations({
  	        reason: opts.reason || "hardRefreshFromAppData",
  	        doFitBounds: (opts.doFitBounds !== undefined) ? !!opts.doFitBounds : true
  	      });
  	
  	      return { ok: true, locations: SWR.lastHydratedCount };
  	    } catch (e) {
  	      warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ hardRefreshFromAppData() failed:", e);
  	      return { ok: false, error: e };
  	    }
  	  };
  	
  	  // --- Debug helper ---
  	  window.SimpleWizard.getLastHydratedCount = function () {
  	    try { return SWR.lastHydratedCount || 0; } catch (_) { return 0; }
  	  };
  	
  	  log(SIMPLE_WIZARD_CFG.logPrefix, "▶ Starting:", SIMPLE_WIZARD_CFG.version, {
  	    locationsInitial: resolveLocationsAuthoritative().length,
  	    hubDataStoreUid: SIMPLE_WIZARD_CFG.hubDataStoreUid,
  	    listUid: SIMPLE_WIZARD_CFG.locationsListComponentUid,
  	    hasContext: !!ContextSafe,
  	    traceClicks: !!SIMPLE_WIZARD_CFG.traceClicks,
  	    panelDetectMaxAttempts: SIMPLE_WIZARD_CFG.panelDetectMaxAttempts,
  	    panelDetectDelayMs: SIMPLE_WIZARD_CFG.panelDetectDelayMs,
  	    panelFailSafeInject: SIMPLE_WIZARD_CFG.panelFailSafeInject,
  	    zIndexBase: SIMPLE_WIZARD_CFG.zIndexBase
  	  });
  	
  	  attachReadyGuards();
  	} catch (fatal) {
  	  warn(SIMPLE_WIZARD_CFG.logPrefix, "❌ Fatal error:", fatal);
  	}

  })((await Locations2()), ___arguments.context.appData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d26a5df8d9d877c86c587f318c336a84')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('12b83f221428faab7998dcb80dd3337b')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('67483b334ccf3f07d1147d3805582d58')));
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Locations2() {
  Locations = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Locations'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Locations, k);
    }
  }
  return Locations
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('Locations') !== -1) {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cba825083f48a23842c528554b88f698')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72'))]);
    } else {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e'))]);
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e'))]);
    }

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('Locations') !== -1) {
      View = true;
    } else {
      View = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      View = false;
    }

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/1a977ecfe2883ee4456e6178edbc23fd/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  async ['onOpen'](___arguments) {
    /**
 * Describe this function...
 */
async function V3_Coffee() {
  await (async function(App, Map) {
  	return new Promise(resolve => {
  	  (async function CarvedEdgeShapeUI() {
  	    "use strict";

  	    const APP_DATA = App;
  	    const MAP_INPUT = Map;

  	    const ENGINE_ID = "fif-carved-edge-shape-ui";
  	    const STYLE_ID = `${ENGINE_ID}-style`;
  	    const ADD_NEW_LOCATION_TYPE_VALUE = "__add_new_location_type__";
  	    const DEFAULT_NEW_LOCATION_TYPE_COLOR = "#ff9a3d";

  	    const OLD_ENGINE_IDS = [
  	      ENGINE_ID,
  	      "carved-edge-shape-ui",
  	      "trackit-carved-edge-shape-ui",
  	      "trackit-location-carved-edge-ui",
  	      "fif-location-carved-edge-ui"
  	    ];

  	    const CTX = typeof ___arguments !== "undefined"
  	    ? ___arguments.context: null;

  	    let DATA_CHANNEL = null;

  	    let COMPANY_OPTIONS = [{
  	      value: "dummy-company-i",
  	      label: "i",
  	      company: null
  	    }];

  	    const FALLBACK_LOCATION_TYPE_OPTIONS = [{
  	      value: "__add_new_location_type__",
  	      label: "Add New Location Type",
  	      color: "#ff9a3d",
  	      raw: null
  	    },
  	      {
  	        value: "dummy-location-type",
  	        label: "Dummy Location Type",
  	        color: "#49d37d",
  	        raw: null
  	      }];

  	    const HELP_TEXT = {
  	      eventsCapture: {
  	        title: "Events Capture",
  	        body: "Allows this location to capture operational events such as arrivals, departures, delays, exceptions, inspections, notes, and activity records."
  	      },
  	      fuelLogic: {
  	        title: "Fuel Logic",
  	        body: "Adds fuel-related behaviour to this location. Choose either Public Fuel Station or Depot. Only one fuel mode can be active."
  	      },
  	      publicFuelStation: {
  	        title: "Public Fuel Station",
  	        body: "Marks the location as a public fuel station where vehicles can refuel through an external or commercial fuel provider."
  	      },
  	      fuelDepot: {
  	        title: "Depot",
  	        body: "Marks the location as a company depot or internal controlled fuel point."
  	      },
  	      loadLogic: {
  	        title: "Load Logic",
  	        body: "Adds load handling behaviour to this location. Use this for loading points, offloading points, collection areas, dispatch areas, or stock movement."
  	      },
  	      gateLogic: {
  	        title: "Gate Logic",
  	        body: "Adds gate-related behaviour to this location. For now this captures a contact number for future gate communication or access-control functionality."
  	      }
  	    };

  	    const createState = {
  	      isCreating: false,
  	      company: "",
  	      locationType: "",
  	      creationMode: "",
  	      name: "",
  	      openDropdown: "",
  	      isPlotting: false,
  	      isSaved: false,
  	      modalMode: "",
  	      helpTopic: "",
  	      typeManagerName: "",
  	      typeManagerColor: DEFAULT_NEW_LOCATION_TYPE_COLOR,
  	      typeManagerOriginalName: "",
  	      functionality: {
  	        eventsCapture: false,
  	        fuelLogic: false,
  	        publicFuelStation: false,
  	        fuelDepot: false,
  	        loadLogic: false,
  	        gateLogic: false,
  	        gatePhone: ""
  	      }
  	    };

  	    let attentionTimer = null;
  	    let searchPanelResizeRaf = 0;
  	    let searchPanelResizeTimeouts = [];

  	    function safeString(value) {
  	      return value === undefined || value === null ? "": String(value);
  	    }

  	    function escapeHtml(value) {
  	      return safeString(value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/"/g, "&quot;")
  	      .replace(/'/g, "&#039;");
  	    }

  	    function splitTokens(value) {
  	      return safeString(value)
  	      .split(",")
  	      .map(item => item.trim())
  	      .filter(Boolean);
  	    }

  	    function hasToken(value, token) {
  	      const target = safeString(token).toLowerCase();

  	      return splitTokens(value).some(item => {
  	        return item.toLowerCase() === target;
  	      });
  	    }

  	    function resolveComponent(input) {
  	      if (!input) return null;

  	      if (typeof input === "string") {
  	        if (CTX && typeof CTX.getComponentByUid === "function") {
  	          return CTX.getComponentByUid(input);
  	        }

  	        return null;
  	      }

  	      if (input.uid && CTX && typeof CTX.getComponentByUid === "function") {
  	        return CTX.getComponentByUid(input.uid) || input;
  	      }

  	      return input;
  	    }

  	    function readBackendlessArg(name, lowerName, index) {
  	      try {
  	        if (typeof ___arguments !== "undefined" && ___arguments) {
  	          if (___arguments[name] !== undefined) return ___arguments[name];
  	          if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	          if (___arguments[index] !== undefined) return ___arguments[index];
  	        }
  	      } catch (_) {}

  	      return undefined;
  	    }

  	    function getAppBag() {
  	      try {
  	        if (CTX && CTX.appData) return CTX.appData;
  	      } catch (_) {}

  	      try {
  	        if (APP_DATA && APP_DATA.data && typeof APP_DATA.data === "object") {
  	          return APP_DATA.data;
  	        }
  	      } catch (_) {}

  	      try {
  	        if (APP_DATA && typeof APP_DATA === "object") {
  	          return APP_DATA;
  	        }
  	      } catch (_) {}

  	      try {
  	        if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	          return BackendlessUI.App.data;
  	        }
  	      } catch (_) {}

  	      try {
  	        if (typeof window !== "undefined" && window.AppData) {
  	          return window.AppData.data || window.AppData;
  	        }
  	      } catch (_) {}

  	      return null;
  	    }

  	    function getObjectProperty(object, propPath) {
  	      if (!object) return undefined;

  	      if (typeof propPath !== "string" || object[propPath] !== undefined) {
  	        return object[propPath];
  	      }

  	      const parts = propPath.split(".");
  	      let current = object;

  	      for (let i = 0; i < parts.length; i++) {
  	        if (!current || current[parts[i]] === undefined) return undefined;
  	        current = current[parts[i]];
  	      }

  	      return current;
  	    }

  	    function getCompanyId(company, index) {
  	      return (
  	        company?.objectId ||
  	        company?.ObjectId ||
  	        company?.CompanyId ||
  	        company?.companyId ||
  	        company?.id ||
  	        company?.ID ||
  	        `company-${index}`
  	      );
  	    }

  	    function getCompanyName(company) {
  	      return (
  	        company?.Name ||
  	        company?.name ||
  	        company?.CompanyName ||
  	        company?.companyName ||
  	        company?.Title ||
  	        company?.title ||
  	        "Company"
  	      );
  	    }

  	    function getCompanyLocations(company) {
  	      const locations =
  	      company?.Locations ||
  	      company?.locations ||
  	      company?.Location ||
  	      company?.location ||
  	      [];

  	      return Array.isArray(locations) ? locations: [];
  	    }

  	    function getLocationValue(location) {
  	      return (
  	        location?.objectId ||
  	        location?.ObjectId ||
  	        location?.id ||
  	        location?.ID ||
  	        null
  	      );
  	    }

  	    function getLocationName(location) {
  	      return (
  	        location?.Name ||
  	        location?.name ||
  	        location?.Label ||
  	        location?.label ||
  	        location?.Title ||
  	        location?.title ||
  	        location?.ID ||
  	        location?.id ||
  	        "Location"
  	      );
  	    }

  	    function getLocationTypeName(location) {
  	      return (
  	        location?.LocationType ||
  	        location?.locationType ||
  	        location?.Type ||
  	        location?.type ||
  	        location?.FieldType ||
  	        location?.fieldType ||
  	        location?.Shape ||
  	        location?.shape ||
  	        ""
  	      );
  	    }

  	    function getLocationTypeColor(location) {
  	      const value =
  	      location?.Color ||
  	      location?.color ||
  	      location?.Colour ||
  	      location?.colour ||
  	      "";

  	      const color = safeString(value).trim();

  	      if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)) return color;
  	      if (/^rgba?\([0-9.,%\s]+\)$/i.test(color)) return color;
  	      if (/^hsla?\([0-9.,%\s]+\)$/i.test(color)) return color;

  	      return "#49d37d";
  	    }

  	    function getLocationChildren(location) {
  	      const arrays = [
  	        location?.Children,
  	        location?.children,
  	        location?.ChildLocations,
  	        location?.childLocations,
  	        location?.Locations,
  	        location?.locations,
  	        location?.Fields,
  	        location?.fields,
  	        location?.Segments,
  	        location?.segments,
  	        location?.Rings,
  	        location?.rings
  	      ];

  	      const result = [];
  	      const seen = new Set();

  	      arrays.forEach(list => {
  	        if (!Array.isArray(list)) return;

  	        list.forEach(child => {
  	          if (!child || typeof child !== "object") return;

  	          const key = getLocationValue(child) || child;

  	          if (seen.has(key)) return;

  	          seen.add(key);
  	          result.push(child);
  	        });
  	      });

  	      return result;
  	    }

  	    function flattenLocations(locations, output = [], seen = new Set()) {
  	      if (!Array.isArray(locations)) return output;

  	      locations.forEach(location => {
  	        if (!location || typeof location !== "object") return;

  	        const key = getLocationValue(location) || getLocationName(location);

  	        if (key && seen.has(key)) return;

  	        if (key) seen.add(key);

  	        output.push(location);
  	        flattenLocations(getLocationChildren(location), output, seen);
  	      });

  	      return output;
  	    }

  	    function getRegistryLocations(appData) {
  	      const store =
  	      appData?.LocationRegistryStore ||
  	      appData?.locationRegistryStore ||
  	      null;

  	      const byId = store?.byId || store?.ById || {};

  	      if (!byId || typeof byId !== "object") return [];

  	      return Object.keys(byId)
  	      .map(key => byId[key])
  	      .filter(Boolean);
  	    }

  	    function getCompaniesFromData(appData) {
  	      const listInput =
  	      typeof List !== "undefined"
  	      ? List: readBackendlessArg("List", "list", 1);

  	      if (Array.isArray(listInput)) return listInput;

  	      const userCompanies =
  	      appData?.User?.Companies ||
  	      appData?.User?.companies ||
  	      appData?.Companies ||
  	      appData?.companies ||
  	      [];

  	      return Array.isArray(userCompanies) ? userCompanies: [];
  	    }

  	    function createCompanyOptionsFromData(companies) {
  	      const options = companies.map((company, index) => {
  	        return {
  	          value: safeString(getCompanyId(company, index)),
  	          label: safeString(getCompanyName(company)),
  	          company
  	        };
  	      });

  	      return options.length
  	      ? options: [{
  	        value: "dummy-company-i",
  	        label: "i",
  	        company: null
  	      }];
  	    }

  	    function findCompanyOption(value) {
  	      return COMPANY_OPTIONS.find(option => option.value === value) || null;
  	    }

  	    function refreshBackendlessApp() {
  	      try {
  	        if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.refresh) {
  	          BackendlessUI.App.refresh();
  	        }
  	      } catch (_) {}
  	    }

  	    function normalizeLocationTypeColorValue(value) {
  	      const color = safeString(value).trim();

  	      if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)) return color;

  	      return DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	    }

  	    function createLocationTypeValue(name) {
  	      const slug = safeString(name)
  	      .trim()
  	      .toLowerCase()
  	      .replace(/&/g, "and")
  	      .replace(/[^a-z0-9]+/g, "-")
  	      .replace(/^-+|-+$/g, "");

  	      return slug || `location-type-${Date.now()}`;
  	    }

  	    function getCompanyTypeStore(companyValue) {
  	      const option = findCompanyOption(companyValue);
  	      const company = option?.company || null;

  	      if (company && typeof company === "object") {
  	        if (!Array.isArray(company.LocationTypes)) {
  	          company.LocationTypes = Array.isArray(company.locationTypes)
  	          ? company.locationTypes: [];
  	        }

  	        return company.LocationTypes;
  	      }

  	      const appData = getAppBag();

  	      if (!appData) return [];

  	      if (!appData.LocationTypesByCompany || typeof appData.LocationTypesByCompany !== "object") {
  	        appData.LocationTypesByCompany = {};
  	      }

  	      if (!Array.isArray(appData.LocationTypesByCompany[companyValue])) {
  	        appData.LocationTypesByCompany[companyValue] = [];
  	      }

  	      return appData.LocationTypesByCompany[companyValue];
  	    }

  	    function getLocationTypeRecordName(record) {
  	      return (
  	        record?.TypeName ||
  	        record?.typeName ||
  	        record?.Name ||
  	        record?.name ||
  	        record?.Label ||
  	        record?.label ||
  	        ""
  	      );
  	    }

  	    function getLocationTypeRecordColor(record) {
  	      return normalizeLocationTypeColorValue(
  	        record?.Color ||
  	        record?.color ||
  	        record?.Colour ||
  	        record?.colour ||
  	        ""
  	      );
  	    }

  	    function getCompanyObjectByValue(companyValue) {
  	      const option = findCompanyOption(companyValue);

  	      return option?.company || null;
  	    }

  	    function setLocationTypeNameAndColor(location, typeName, color) {
  	      if (!location || typeof location !== "object") return;

  	      const typeFields = [
  	        "LocationType",
  	        "locationType",
  	        "Type",
  	        "type",
  	        "FieldType",
  	        "fieldType"
  	      ];

  	      let hadTypeField = false;

  	      typeFields.forEach(field => {
  	        if (location[field] !== undefined && location[field] !== null && safeString(location[field]).trim()) {
  	          location[field] = typeName;
  	          hadTypeField = true;
  	        }
  	      });

  	      if (!hadTypeField) {
  	        location.LocationType = typeName;
  	      }

  	      if (location.Color !== undefined) {
  	        location.Color = color;
  	      } else if (location.color !== undefined) {
  	        location.color = color;
  	      } else if (location.Colour !== undefined) {
  	        location.Colour = color;
  	      } else if (location.colour !== undefined) {
  	        location.colour = color;
  	      } else {
  	        location.Color = color;
  	      }
  	    }

  	    function bulkUpdateCompanyLocationsByType(companyValue, originalTypeName, newTypeName, newColor) {
  	      const company = getCompanyObjectByValue(companyValue);
  	      const oldName = safeString(originalTypeName).trim();
  	      const nextName = safeString(newTypeName).trim();
  	      const nextColor = normalizeLocationTypeColorValue(newColor);

  	      if (!company || !oldName || !nextName) {
  	        return {
  	          updatedCount: 0,
  	          updatedLocations: []
  	        };
  	      }

  	      const oldKey = oldName.toLowerCase();
  	      const locations = flattenLocations(getCompanyLocations(company));
  	      const updatedLocations = [];

  	      locations.forEach(location => {
  	        const currentType = safeString(getLocationTypeName(location)).trim();

  	        if (!currentType) return;
  	        if (currentType.toLowerCase() !== oldKey) return;

  	        setLocationTypeNameAndColor(location, nextName, nextColor);
  	        updatedLocations.push(location);
  	      });

  	      return {
  	        updatedCount: updatedLocations.length,
  	        updatedLocations
  	      };
  	    }

  	    function upsertCompanyLocationType(companyValue,
  	      typeName,
  	      color,
  	      originalTypeName) {
  	      const cleanName = safeString(typeName).trim();
  	      const cleanColor = normalizeLocationTypeColorValue(color);
  	      const cleanOriginalName = safeString(originalTypeName).trim();

  	      if (!cleanName) return null;

  	      const store = getCompanyTypeStore(companyValue);

  	      const originalIndex = cleanOriginalName
  	      ? store.findIndex(item => {
  	        return safeString(getLocationTypeRecordName(item)).trim().toLowerCase() === cleanOriginalName.toLowerCase();
  	      }): -1;

  	      const targetIndex = store.findIndex(item => {
  	        return safeString(getLocationTypeRecordName(item)).trim().toLowerCase() === cleanName.toLowerCase();
  	      });

  	      let record = null;

  	      if (originalIndex >= 0 && targetIndex >= 0 && originalIndex !== targetIndex) {
  	        record = store[targetIndex];
  	        record.TypeName = cleanName;
  	        record.Color = cleanColor;
  	        store.splice(originalIndex, 1);
  	      } else if (originalIndex >= 0) {
  	        record = store[originalIndex];
  	        record.TypeName = cleanName;
  	        record.Color = cleanColor;
  	      } else if (targetIndex >= 0) {
  	        record = store[targetIndex];
  	        record.TypeName = cleanName;
  	        record.Color = cleanColor;
  	      } else {
  	        record = {
  	          TypeName: cleanName,
  	          Color: cleanColor
  	        };

  	        store.push(record);
  	      }

  	      const bulkResult = cleanOriginalName
  	      ? bulkUpdateCompanyLocationsByType(companyValue, cleanOriginalName, cleanName, cleanColor): {
  	        updatedCount: 0,
  	        updatedLocations: []
  	      };

  	      refreshBackendlessApp();

  	      return {
  	        value: createLocationTypeValue(cleanName),
  	        label: cleanName,
  	        color: cleanColor,
  	        raw: record,
  	        originalName: cleanOriginalName,
  	        updatedCount: bulkResult.updatedCount,
  	        updatedLocations: bulkResult.updatedLocations
  	      };
  	    }

  	    function buildLocationTypeOptionsForCompany(companyValue) {
  	      const option = findCompanyOption(companyValue);
  	      const company = option?.company || null;

  	      const locationList = company
  	      ? flattenLocations(getCompanyLocations(company)): [];

  	      const byType = Object.create(null);

  	      function addTypeOption(typeName, color, raw) {
  	        const label = safeString(typeName).trim();

  	        if (!label) return;

  	        const key = label.toLowerCase();

  	        if (byType[key]) return;

  	        byType[key] = {
  	          value: createLocationTypeValue(label),
  	          label,
  	          color: normalizeLocationTypeColorValue(color),
  	          raw: raw || null
  	        };
  	      }

  	      getCompanyTypeStore(companyValue).forEach(record => {
  	        addTypeOption(
  	          getLocationTypeRecordName(record),
  	          getLocationTypeRecordColor(record),
  	          record
  	        );
  	      });

  	      locationList.forEach(location => {
  	        const typeName = safeString(getLocationTypeName(location)).trim();

  	        if (!typeName) return;

  	        addTypeOption(typeName, getLocationTypeColor(location), location);
  	      });

  	      const dynamicOptions = Object.keys(byType)
  	      .map(key => byType[key])
  	      .sort((a, b) => a.label.localeCompare(b.label, undefined, {
  	        numeric: true,
  	        sensitivity: "base"
  	      }));

  	      return [{
  	        value: ADD_NEW_LOCATION_TYPE_VALUE,
  	        label: "Add New Location Type",
  	        color: DEFAULT_NEW_LOCATION_TYPE_COLOR,
  	        raw: null
  	      },
  	        ...dynamicOptions
  	      ];
  	    }

  	    function getUserMode(appData) {
  	      const user = appData && appData.User ? appData.User: {};
  	      const settings = user.Settings || "";
  	      const hasLocationSettings = hasToken(settings,
  	        "Locations");

  	      return {
  	        mode: hasLocationSettings ? "admin": "viewer",
  	        canCreateLocations: hasLocationSettings,
  	        canEditLocations: hasLocationSettings
  	      };
  	    }

  	    function createDataChannel(appData,
  	      userMode) {
  	      const companies = getCompaniesFromData(appData);
  	      const registryLocations = getRegistryLocations(appData);
  	      const companyOptions = createCompanyOptionsFromData(companies);

  	      const companySummaries = companies.map((company, index) => {
  	        const locations = flattenLocations(getCompanyLocations(company));

  	        return {
  	          index,
  	          id: getCompanyId(company, index),
  	          name: getCompanyName(company),
  	          directLocationCount: getCompanyLocations(company).length,
  	          flattenedLocationCount: locations.length,
  	          locationTypes: Array.from(
  	            new Set(
  	              locations
  	              .map(location => safeString(getLocationTypeName(location)).trim())
  	              .filter(Boolean)
  	            )
  	          )
  	        };
  	      });

  	      return {
  	        loadedAt: new Date().toISOString(),
  	        appData,
  	        user: appData?.User || null,
  	        userMode,
  	        companies,
  	        companyOptions,
  	        companySummaries,
  	        registryStore: appData?.LocationRegistryStore || null,
  	        registryLocations,
  	        selectedLocation: {
  	          marker: appData?.SelectedLocationMarker || null,
  	          objectId: appData?.SelectedLocationObjectId || null,
  	          location: appData?.SelectedLocation || null
  	        },
  	        dropdownBridge: {
  	          status: "placeholder",
  	          source: "TrackIT Location Dropdown",
  	          targetHostSelector: "[data-location-dropdown-host]",
  	          notes: [
  	            "Current placeholder only logs data and prepares the mount point.",
  	            "Next pass will mount the existing TrackIT dropdown tree into this host.",
  	            "The uploaded dropdown code already handles company groups, type groups, parent/child location rows, selection, AppData writing, and map focus."
  	          ]
  	        }
  	      };
  	    }

  	    function printDataChannelOnLoad(dataChannel) {
  	      try {
  	        console.groupCollapsed("[Carved Edge Shape UI] Data Channel Loaded");
  	        console.log("Loaded At:",
  	          dataChannel.loadedAt);
  	        console.log("User Mode:",
  	          dataChannel.userMode);
  	        console.log("User:",
  	          dataChannel.user);
  	        console.log("Companies:",
  	          dataChannel.companies);
  	        console.table(dataChannel.companySummaries);
  	        console.log("Company Options:",
  	          dataChannel.companyOptions);
  	        console.log("Location Registry Store:",
  	          dataChannel.registryStore);
  	        console.log("Registry Locations:",
  	          dataChannel.registryLocations);
  	        console.log("Selected Location:",
  	          dataChannel.selectedLocation);
  	        console.log("Raw App Data:",
  	          dataChannel.appData);
  	        console.log("Dropdown Bridge Placeholder:",
  	          dataChannel.dropdownBridge);
  	        console.groupEnd();
  	      } catch (error) {
  	        console.warn("[Carved Edge Shape UI] Could not print data channel.",
  	          error);
  	      }
  	    }

  	    function mountLocationDropdownBridgePlaceholder(root,
  	      userMode) {
  	      const host = root.querySelector("[data-location-dropdown-host]");

  	      if (!host || !DATA_CHANNEL) return;

  	      host.innerHTML = `
  	      <div class="ces-dropdown-placeholder">
  	      <span class="ces-dropdown-placeholder-icon">⌕</span>
  	      <span class="ces-dropdown-placeholder-text">Search Location</span>
  	      <span class="ces-dropdown-placeholder-caret">⌄</span>
  	      </div>
  	      `;

  	      const bridge = {
  	        status: "placeholder-mounted",
  	        host,
  	        uiRoot: root,
  	        userMode,
  	        dataChannel: DATA_CHANNEL,
  	        mapInput: MAP_INPUT,

  	        resizeTopShell() {
  	          scheduleSearchPanelHeight(root, userMode);
  	        },

  	        resetTopShell() {
  	          resetSearchPanelHeight(root, userMode);
  	        },

  	        mountTrackITDropdown() {
  	          (function () {
  	            // ============================================================
  	            // TrackIT Location Dropdown — Placeholder Card Router Rewrite
  	            //
  	            // Company -> Top-Level Type Groups -> Parent/Child Location Tree
  	            //
  	            // Main behaviour:
  	            //   - Search locations.
  	            //   - Keep company groups open by default.
  	            //   - Type groups start collapsed.
  	            //   - Parent locations with children start collapsed.
  	            //   - First click on collapsed parent opens children only.
  	            //   - Second click selects the parent.
  	            //   - Selection writes to AppData.
  	            //   - Selection focuses/zooms map when possible.
  	            //   - Selection opens a placeholder card/router.
  	            //
  	            // Backendless Custom Code Inputs:
  	            //   Component: Dropdown component
  	            //   List:      App Data -> User -> Companies
  	            //   App:       App Data
  	            //   Map:       Settings - Hub Location Map component
  	            //   Hub:       Optional container/hub component
  	            //
  	            // Future carved UI mount:
  	            //   Can also mount into:
  	            //   window.__CarvedEdgeShapeDropdownBridge.host
  	            // ============================================================

  	            "use strict";

  	            const MAP_COMPONENT_UID = "67483b334ccf3f07d1147d3805582d58";
  	            const MAP_SELECT_ZOOM = 20;
  	            const MAX_Z_INDEX = 2147483647;
  	            const MAP_CONTROL_GAP_PX = 10;

  	            const GOOGLE_LOCATION_COUNTRY_CODE = "za";
  	            const GOOGLE_LOCATION_REGION = "za";
  	            const GOOGLE_LOCATION_LABEL = "South Africa";

  	            // Change this later if required:
  	            //   "placeholder" = show temporary action card
  	            //   "card-router" = dispatch card events and show card
  	            //   "select-only" = select/write/focus only
  	            //   "open-panel" = old behaviour, try LocationRegistry / LocationRegistryUI
  	            const SEARCH_ACTION_MODE = "placeholder";

  	            const STYLE_ID = "trackit-compact-location-dropdown-css";
  	            const EVENT_LOCATION_CHANGE = "locationDropdownChange";

  	            const ROUTER_EVENTS = {
  	              selected: "trackitLocationSelected",
  	              cardRequested: "trackitLocationCardRequested",
  	              dataCardRequested: "trackitLocationDataCardRequested",
  	              childrenRequested: "trackitLocationChildrenRequested",
  	              functionalityRequested: "trackitLocationFunctionalityRequested",
  	              editRequested: "trackitLocationEditRequested"
  	            };

  	            const MAP_CONTROL_SELECTORS = [
  	              ".trackit-compact-map-control",
  	              "#fif-carved-edge-shape-ui .ces-bottom-shape",
  	              "#fif-carved-edge-shape-ui .ces-bottom-content"
  	            ];

  	            // ============================================================
  	            // Backendless argument helpers
  	            // ============================================================

  	            function readBackendlessArg(name, lowerName, index) {
  	              try {
  	                if (typeof ___arguments !== "undefined" && ___arguments) {
  	                  if (___arguments[name] !== undefined) return ___arguments[name];
  	                  if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	                  if (___arguments[index] !== undefined) return ___arguments[index];
  	                }
  	              } catch (_) {}

  	              return undefined;
  	            }

  	            const bridge =
  	            typeof window !== "undefined" && window.__CarvedEdgeShapeDropdownBridge
  	            ? window.__CarvedEdgeShapeDropdownBridge: null;

  	            const ComponentInput =
  	            typeof Component !== "undefined"
  	            ? Component: readBackendlessArg("Component", "component", 0);

  	            const ListInput =
  	            typeof List !== "undefined"
  	            ? List: readBackendlessArg("List", "list", 1);

  	            const AppRoot =
  	            typeof App !== "undefined"
  	            ? App: readBackendlessArg("App", "app", 2);

  	            const MapInputFromArgs = readBackendlessArg("Map", "map", 3);

  	            const HubRoot =
  	            typeof Hub !== "undefined"
  	            ? Hub: readBackendlessArg("Hub", "hub", 4);

  	            const MapRoot =
  	            MapInputFromArgs ||
  	            MAP_INPUT ||
  	            bridge?.mapInput ||
  	            bridge?.dataChannel?.mapInput ||
  	            (
  	              typeof Map !== "undefined" &&
  	              (typeof window === "undefined" || Map !== window.Map)
  	              ? Map: null
  	            );

  	            function resolveElementFromComponent(value) {
  	              try {
  	                if (!value) return null;

  	                if (typeof HTMLElement !== "undefined" && value instanceof HTMLElement) {
  	                  return value;
  	                }

  	                if (value.element && typeof HTMLElement !== "undefined" && value.element instanceof HTMLElement) {
  	                  return value.element;
  	                }

  	                if (value.el && typeof HTMLElement !== "undefined" && value.el instanceof HTMLElement) {
  	                  return value.el;
  	                }

  	                if (value.node && typeof HTMLElement !== "undefined" && value.node instanceof HTMLElement) {
  	                  return value.node;
  	                }

  	                if (value.domNode && typeof HTMLElement !== "undefined" && value.domNode instanceof HTMLElement) {
  	                  return value.domNode;
  	                }

  	                if (typeof value.getElement === "function") {
  	                  const el = value.getElement();
  	                  if (el) return el;
  	                }

  	                if (typeof value.getDomNode === "function") {
  	                  const el = value.getDomNode();
  	                  if (el) return el;
  	                }
  	              } catch (_) {}

  	              return null;
  	            }

  	            const root =
  	            bridge?.host ||
  	            resolveElementFromComponent(ComponentInput) ||
  	            ComponentInput?.element ||
  	            ComponentInput?.el ||
  	            ComponentInput?.node ||
  	            ComponentInput ||
  	            null;

  	            if (!root) {
  	              console.error("[TrackIT Location Dropdown] Component root / host not found.");
  	              return;
  	            }

  	            const hubElement =
  	            resolveElementFromComponent(HubRoot) ||
  	            root.closest?.(".bl-block") ||
  	            root.parentElement ||
  	            null;

  	            const hubOriginalStyle = hubElement
  	            ? {
  	              height: hubElement.style.height || "",
  	              minHeight: hubElement.style.minHeight || "",
  	              maxHeight: hubElement.style.maxHeight || "",
  	              overflow: hubElement.style.overflow || "",
  	              transition: hubElement.style.transition || ""
  	            }: null;

  	            if (typeof root.__locationDropdownCleanup === "function") {
  	              try {
  	                root.__locationDropdownCleanup();
  	              } catch (_) {}
  	            }

  	            if (!root.__trackitCollapsedLocationTree) {
  	              root.__trackitCollapsedLocationTree = {};
  	            }

  	            root.innerHTML = "";
  	            root.style.maxWidth = "100%";
  	            root.style.boxSizing = "border-box";
  	            root.style.overflow = "visible";
  	            root.style.position = root.style.position || "relative";
  	            root.style.zIndex = String(MAX_Z_INDEX);

  	            // ============================================================
  	            // General helpers
  	            // ============================================================

  	            function safeString(value) {
  	              return value === undefined || value === null ? "": String(value);
  	            }

  	            function escapeHtml(value) {
  	              return safeString(value)
  	              .replace(/&/g, "&amp;")
  	              .replace(/</g, "&lt;")
  	              .replace(/>/g, "&gt;")
  	              .replace(/"/g, "&quot;")
  	              .replace(/'/g, "&#039;");
  	            }

  	            function getBackendlessContext() {
  	              try {
  	                if (typeof ___arguments !== "undefined" && ___arguments?.context) {
  	                  return ___arguments.context;
  	                }
  	              } catch (_) {}

  	              return null;
  	            }

  	            function getAppBag() {
  	              const ctx = getBackendlessContext();

  	              if (ctx?.appData) return ctx.appData;

  	              if (bridge?.dataChannel?.appData) {
  	                return bridge.dataChannel.appData;
  	              }

  	              if (AppRoot?.data && typeof AppRoot.data === "object") {
  	                return AppRoot.data;
  	              }

  	              if (AppRoot && typeof AppRoot === "object" && !("data" in AppRoot)) {
  	                return AppRoot;
  	              }

  	              if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	                return BackendlessUI.App.data;
  	              }

  	              if (typeof window !== "undefined" && window.AppData) {
  	                return window.AppData.data || window.AppData;
  	              }

  	              return null;
  	            }

  	            function refreshApp() {
  	              try {
  	                BackendlessUI?.App?.refresh?.();
  	              } catch (_) {}
  	            }

  	            function getObjectProperty(object, propPath) {
  	              if (!object) return undefined;

  	              if (typeof propPath !== "string" || object[propPath] !== undefined) {
  	                return object[propPath];
  	              }

  	              const parts = propPath.split(".");
  	              let current = object;

  	              for (let i = 0; i < parts.length; i++) {
  	                if (!current || current[parts[i]] === undefined) return undefined;
  	                current = current[parts[i]];
  	              }

  	              return current;
  	            }

  	            function getCompaniesFromAnySource() {
  	              if (Array.isArray(ListInput)) return ListInput;

  	              if (Array.isArray(bridge?.dataChannel?.companies)) {
  	                return bridge.dataChannel.companies;
  	              }

  	              const appData = getAppBag();

  	              const userCompanies =
  	              appData?.User?.Companies ||
  	              appData?.User?.companies ||
  	              appData?.Companies ||
  	              appData?.companies ||
  	              [];

  	              return Array.isArray(userCompanies) ? userCompanies: [];
  	            }

  	            const companies = getCompaniesFromAnySource();

  	            // ============================================================
  	            // AppData selection helpers
  	            // ============================================================

  	            function readSelectedLocationMarkerId() {
  	              const appData = getAppBag();

  	              return (
  	                appData?.SelectedLocationMarker ||
  	                appData?.SelectedLocationObjectId ||
  	                appData?.SelectedLocation?.objectId ||
  	                appData?.SelectedLocation?.ObjectId ||
  	                appData?.SelectedLocation?.id ||
  	                null
  	              );
  	            }

  	            function clearSelectedLocationFromAppData() {
  	              const appData = getAppBag();

  	              if (!appData) {
  	                console.warn("[TrackIT Location Dropdown] AppData not found. Could not clear selected location.");
  	                return;
  	              }

  	              try {
  	                delete appData.SelectedLocationMarker;
  	              } catch (_) {
  	                appData.SelectedLocationMarker = null;
  	              }

  	              try {
  	                delete appData.SelectedLocationObjectId;
  	              } catch (_) {
  	                appData.SelectedLocationObjectId = null;
  	              }

  	              try {
  	                delete appData.SelectedLocation;
  	              } catch (_) {
  	                appData.SelectedLocation = null;
  	              }

  	              refreshApp();
  	            }

  	            function writeSelectedLocationToAppData(location) {
  	              if (!location) return;

  	              const appData = getAppBag();

  	              if (!appData) {
  	                console.warn("[TrackIT Location Dropdown] AppData not found. Could not write selected location.");
  	                return;
  	              }

  	              const objectId = getLocationValue(location);

  	              if (!objectId) {
  	                console.warn("[TrackIT Location Dropdown] Selected location has no objectId.", location);
  	                return;
  	              }

  	              appData.SelectedLocationMarker = objectId;
  	              appData.SelectedLocationObjectId = objectId;

  	              let plain = location;

  	              try {
  	                plain = JSON.parse(JSON.stringify(location));
  	              } catch (_) {}

  	              appData.SelectedLocation = plain;
  	              refreshApp();
  	            }

  	            function findLocationByObjectId(inputValue) {
  	              if (!inputValue) return null;

  	              const value = String(inputValue);
  	              const found = flatRows.find(row => row.value === value);

  	              return found?.location || null;
  	            }

  	            // ============================================================
  	            // Number / coordinate helpers
  	            // ============================================================

  	            function num(value) {
  	              return typeof value === "number" ? value: Number(value);
  	            }

  	            function firstFinite(values) {
  	              for (let i = 0; i < values.length; i++) {
  	                const value = num(values[i]);

  	                if (Number.isFinite(value)) {
  	                  return value;
  	                }
  	              }

  	              return NaN;
  	            }

  	            function readLatLngFromKnownPaths(location) {
  	              const lat = firstFinite([
  	                getObjectProperty(location, "position.latitude"),
  	                getObjectProperty(location, "Position.latitude"),
  	                getObjectProperty(location, "center.latitude"),
  	                getObjectProperty(location, "Center.latitude"),
  	                getObjectProperty(location, "location.latitude"),
  	                getObjectProperty(location, "Location.latitude"),
  	                getObjectProperty(location, "Location.position.latitude"),
  	                getObjectProperty(location, "geo.latitude"),
  	                getObjectProperty(location, "Geo.latitude"),
  	                getObjectProperty(location, "latitude"),
  	                getObjectProperty(location, "Latitude"),
  	                getObjectProperty(location, "lat"),
  	                getObjectProperty(location, "Lat")
  	              ]);

  	              const lng = firstFinite([
  	                getObjectProperty(location, "position.longitude"),
  	                getObjectProperty(location, "Position.longitude"),
  	                getObjectProperty(location, "center.longitude"),
  	                getObjectProperty(location, "Center.longitude"),
  	                getObjectProperty(location, "location.longitude"),
  	                getObjectProperty(location, "Location.longitude"),
  	                getObjectProperty(location, "Location.position.longitude"),
  	                getObjectProperty(location, "geo.longitude"),
  	                getObjectProperty(location, "Geo.longitude"),
  	                getObjectProperty(location, "longitude"),
  	                getObjectProperty(location, "Longitude"),
  	                getObjectProperty(location, "lng"),
  	                getObjectProperty(location, "Lng"),
  	                getObjectProperty(location, "lon"),
  	                getObjectProperty(location, "Lon")
  	              ]);

  	              if (Number.isFinite(lat) && Number.isFinite(lng)) {
  	                return {
  	                  lat,
  	                  lng
  	                };
  	              }

  	              return null;
  	            }

  	            function collectLatLngPoints(value, points, depth) {
  	              if (!value || points.length >= 250 || depth > 8) return;

  	              if (Array.isArray(value)) {
  	                if (
  	                  value.length >= 2 &&
  	                  typeof value[0] !== "object" &&
  	                  typeof value[1] !== "object"
  	                ) {
  	                  const a = num(value[0]);
  	                  const b = num(value[1]);

  	                  if (Number.isFinite(a) && Number.isFinite(b)) {
  	                    if (Math.abs(a) <= 180 && Math.abs(b) <= 90) {
  	                      points.push({
  	                        lat: b, lng: a
  	                      });
  	                      return;
  	                    }

  	                    if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
  	                      points.push({
  	                        lat: a, lng: b
  	                      });
  	                      return;
  	                    }
  	                  }
  	                }

  	                value.forEach(child => collectLatLngPoints(child, points, depth + 1));
  	                return;
  	              }

  	              if (typeof value === "object") {
  	                const direct = readLatLngFromKnownPaths(value);

  	                if (direct) {
  	                  points.push(direct);
  	                }

  	                const possibleGeometry =
  	                value.coordinates ||
  	                value.Coordinates ||
  	                value.points ||
  	                value.Points ||
  	                value.path ||
  	                value.Path ||
  	                value.polygon ||
  	                value.Polygon ||
  	                value.boundary ||
  	                value.Boundary ||
  	                value.geometry ||
  	                value.Geometry;

  	                if (possibleGeometry && possibleGeometry !== value) {
  	                  collectLatLngPoints(possibleGeometry, points, depth + 1);
  	                }
  	              }
  	            }

  	            function getLocationCenter(location) {
  	              const direct = readLatLngFromKnownPaths(location);

  	              if (direct) return direct;

  	              const points = [];

  	              collectLatLngPoints(location?.coordinates, points, 0);
  	              collectLatLngPoints(location?.Coordinates, points, 0);
  	              collectLatLngPoints(location?.polygon, points, 0);
  	              collectLatLngPoints(location?.Polygon, points, 0);
  	              collectLatLngPoints(location?.boundary, points, 0);
  	              collectLatLngPoints(location?.Boundary, points, 0);
  	              collectLatLngPoints(location?.geometry, points, 0);
  	              collectLatLngPoints(location?.Geometry, points, 0);
  	              collectLatLngPoints(location?.Polygon?.coordinates, points, 0);
  	              collectLatLngPoints(location?.Polygon?.boundary?.points, points, 0);

  	              if (!points.length) return null;

  	              const total = points.reduce((sum, point) => {
  	                sum.lat += point.lat;
  	                sum.lng += point.lng;
  	                return sum;
  	              }, {
  	                lat: 0, lng: 0
  	              });

  	              return {
  	                lat: total.lat / points.length,
  	                lng: total.lng / points.length
  	              };
  	            }

  	            // ============================================================
  	            // Map helpers
  	            // ============================================================

  	            function getFallbackMapComponentByUid() {
  	              try {
  	                const ctx = getBackendlessContext();
  	                return ctx?.getComponentByUid?.(MAP_COMPONENT_UID) || null;
  	              } catch (_) {
  	                return null;
  	              }
  	            }

  	            function resolveGMap(mapMaybe) {
  	              try {
  	                const candidate = mapMaybe || MapRoot || getFallbackMapComponentByUid();

  	                return (
  	                  candidate?.map?.map ||
  	                  candidate?.map ||
  	                  candidate ||
  	                  null
  	                );
  	              } catch (_) {
  	                return null;
  	              }
  	            }

  	            function getPolygonLatLngsFromLocation(location) {
  	              const poly =
  	              location?.Polygon ||
  	              location?.polygon ||
  	              location?.Boundary ||
  	              location?.boundary ||
  	              null;

  	              if (!poly) return null;

  	              if (poly.boundary?.points && Array.isArray(poly.boundary.points)) {
  	                return poly.boundary.points
  	                .map(p => ({
  	                  lat: Number(p.y),
  	                  lng: Number(p.x)
  	                }))
  	                .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  	              }

  	              if (poly.points && Array.isArray(poly.points)) {
  	                return poly.points
  	                .map(p => ({
  	                  lat: Number(p.y ?? p.lat ?? p.latitude),
  	                  lng: Number(p.x ?? p.lng ?? p.lon ?? p.longitude)
  	                }))
  	                .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  	              }

  	              if (Array.isArray(poly.coordinates) && Array.isArray(poly.coordinates[0])) {
  	                return poly.coordinates[0]
  	                .map(coord => ({
  	                  lat: Number(coord[1]),
  	                  lng: Number(coord[0])
  	                }))
  	                .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  	              }

  	              if (Array.isArray(poly.Coordinates) && Array.isArray(poly.Coordinates[0])) {
  	                return poly.Coordinates[0]
  	                .map(coord => ({
  	                  lat: Number(coord[1]),
  	                  lng: Number(coord[0])
  	                }))
  	                .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  	              }

  	              return null;
  	            }

  	            function fitMapToLatLngs(gMap, latLngs) {
  	              try {
  	                if (!gMap || !latLngs || !latLngs.length) return false;

  	                if (
  	                  typeof google === "undefined" ||
  	                  !google.maps ||
  	                  !google.maps.LatLngBounds
  	                ) {
  	                  return false;
  	                }

  	                const bounds = new google.maps.LatLngBounds();

  	                latLngs.forEach(p => {
  	                  if (Number.isFinite(p.lat) && Number.isFinite(p.lng)) {
  	                    bounds.extend(p);
  	                  }
  	                });

  	                if (bounds.isEmpty && bounds.isEmpty()) {
  	                  return false;
  	                }

  	                if (typeof gMap.fitBounds === "function") {
  	                  gMap.fitBounds(bounds);
  	                }

  	                if (typeof gMap.panToBounds === "function") {
  	                  gMap.panToBounds(bounds);
  	                }

  	                if (google.maps.event?.addListenerOnce) {
  	                  google.maps.event.addListenerOnce(gMap, "bounds_changed", function () {
  	                    try {
  	                      const zoom = typeof gMap.getZoom === "function" ? gMap.getZoom(): null;

  	                      if (Number.isFinite(zoom) && zoom > 18) {
  	                        gMap.setZoom(18);
  	                      }
  	                    } catch (_) {}
  	                  });
  	                }

  	                return true;
  	              } catch (_) {
  	                return false;
  	              }
  	            }

  	            function fitMapToGooglePolygon(gMap,
  	              polygon) {
  	              try {
  	                if (!gMap || !polygon) return false;

  	                if (
  	                  typeof google === "undefined" ||
  	                  !google.maps ||
  	                  !google.maps.LatLngBounds
  	                ) {
  	                  return false;
  	                }

  	                const bounds = new google.maps.LatLngBounds();
  	                const paths = polygon.getPaths ? polygon.getPaths(): null;

  	                if (paths && typeof paths.getLength === "function") {
  	                  for (let pathIndex = 0; pathIndex < paths.getLength(); pathIndex++) {
  	                    const path = paths.getAt(pathIndex);

  	                    if (!path || typeof path.getLength !== "function") continue;

  	                    for (let i = 0; i < path.getLength(); i++) {
  	                      bounds.extend(path.getAt(i));
  	                    }
  	                  }
  	                } else {
  	                  const path = polygon.getPath ? polygon.getPath(): null;

  	                  if (path && typeof path.getLength === "function") {
  	                    for (let i = 0; i < path.getLength(); i++) {
  	                      bounds.extend(path.getAt(i));
  	                    }
  	                  }
  	                }

  	                if (bounds.isEmpty && bounds.isEmpty()) {
  	                  return false;
  	                }

  	                if (typeof gMap.fitBounds === "function") {
  	                  gMap.fitBounds(bounds);
  	                  return true;
  	                }
  	              } catch (_) {}

  	              return false;
  	            }

  	            function centerMapOnLocation(location, mapMaybe) {
  	              if (!location) return false;

  	              const gMap = resolveGMap(mapMaybe);
  	              if (!gMap) return false;

  	              const polygonPoints = getPolygonLatLngsFromLocation(location);

  	              if (polygonPoints && polygonPoints.length) {
  	                const fitted = fitMapToLatLngs(gMap, polygonPoints);
  	                if (fitted) return true;
  	              }

  	              const center = getLocationCenter(location);

  	              if (!center || !Number.isFinite(center.lat) || !Number.isFinite(center.lng)) {
  	                console.warn("[TrackIT Location Dropdown] Location has no valid latitude/longitude.", location);
  	                return false;
  	              }

  	              try {
  	                if (typeof gMap.setCenter === "function") {
  	                  gMap.setCenter({
  	                    lat: center.lat,
  	                    lng: center.lng
  	                  });
  	                } else {
  	                  gMap.center = {
  	                    lat: center.lat,
  	                    lng: center.lng
  	                  };
  	                }

  	                if (typeof gMap.setZoom === "function") {
  	                  gMap.setZoom(MAP_SELECT_ZOOM);
  	                } else {
  	                  gMap.zoom = MAP_SELECT_ZOOM;
  	                }

  	                return true;
  	              } catch (e) {
  	                console.warn("[TrackIT Location Dropdown] Could not center map.", e);
  	                return false;
  	              }
  	            }

  	            function focusMapForSelectedLocation(location) {
  	              return centerMapOnLocation(location, MapRoot);
  	            }

  	            function getGoogleAutocompleteService() {
  	              try {
  	                if (
  	                  typeof google === "undefined" ||
  	                  !google.maps ||
  	                  !google.maps.places ||
  	                  !google.maps.places.AutocompleteService
  	                ) {
  	                  return null;
  	                }

  	                if (!googleAutocompleteService) {
  	                  googleAutocompleteService = new google.maps.places.AutocompleteService();
  	                }

  	                return googleAutocompleteService;
  	              } catch (_) {
  	                return null;
  	              }
  	            }

  	            function getGooglePlacesService() {
  	              try {
  	                if (
  	                  typeof google === "undefined" ||
  	                  !google.maps ||
  	                  !google.maps.places ||
  	                  !google.maps.places.PlacesService
  	                ) {
  	                  return null;
  	                }

  	                if (!googlePlacesService) {
  	                  googlePlacesService = new google.maps.places.PlacesService(document.createElement("div"));
  	                }

  	                return googlePlacesService;
  	              } catch (_) {
  	                return null;
  	              }
  	            }

  	            function getGoogleStatusOk() {
  	              try {
  	                return google.maps.places.PlacesServiceStatus.OK;
  	              } catch (_) {
  	                return "OK";
  	              }
  	            }

  	            function focusMapOnGooglePlace(place) {
  	              try {
  	                const gMap = resolveGMap(MapRoot);

  	                if (!gMap || !place || !place.geometry) return false;

  	                if (place.geometry.viewport && typeof gMap.fitBounds === "function") {
  	                  gMap.fitBounds(place.geometry.viewport);
  	                  return true;
  	                }

  	                const location = place.geometry.location;

  	                if (!location) return false;

  	                const lat = typeof location.lat === "function" ? location.lat(): location.lat;
  	                const lng = typeof location.lng === "function" ? location.lng(): location.lng;

  	                if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return false;

  	                if (typeof gMap.setCenter === "function") {
  	                  gMap.setCenter({
  	                    lat: Number(lat),
  	                    lng: Number(lng)
  	                  });
  	                }

  	                if (typeof gMap.setZoom === "function") {
  	                  gMap.setZoom(17);
  	                }

  	                return true;
  	              } catch (error) {
  	                console.warn("[TrackIT Location Dropdown] Could not focus Google place.", error);
  	                return false;
  	              }
  	            }

  	            function dispatchGooglePlaceSelected(prediction, place) {
  	              try {
  	                const detail = {
  	                  value: prediction?.place_id || "",
  	                  item: place || prediction || null,
  	                  location: place || prediction || null,
  	                  prediction,
  	                  place,
  	                  source: "google-location-search",
  	                  searchMode: "google",
  	                  countryCode: GOOGLE_LOCATION_COUNTRY_CODE,
  	                  region: GOOGLE_LOCATION_REGION,
  	                  countryLabel: GOOGLE_LOCATION_LABEL
  	                };

  	                root.locationDropdownValue = detail.value;
  	                root.locationDropdownItem = detail.item;
  	                root.locationDropdownLocation = detail.location;
  	                root.googlePlacePrediction = prediction || null;
  	                root.googlePlace = place || null;

  	                const appData = getAppBag();

  	                if (appData) {
  	                  appData.SelectedGooglePlace = place || prediction || null;
  	                  appData.SelectedGooglePlaceId = prediction?.place_id || "";
  	                  appData.SelectedGooglePlaceCountryCode = GOOGLE_LOCATION_COUNTRY_CODE;
  	                  appData.SelectedGooglePlaceRegion = GOOGLE_LOCATION_REGION;
  	                  appData.SelectedGooglePlaceCountryLabel = GOOGLE_LOCATION_LABEL;
  	                }

  	                dispatchDropdownEvent(root, EVENT_LOCATION_CHANGE, detail);
  	                dispatchDropdownEvent(root, "trackitGooglePlaceSelected", detail);
  	              } catch (error) {
  	                console.warn("[TrackIT Location Dropdown] Could not dispatch Google place selection.", error);
  	              }
  	            }

  	            function renderGoogleEmpty(message) {
  	              menu.innerHTML = "";

  	              const empty = document.createElement("div");
  	              empty.className = "trackit-empty";
  	              empty.textContent = message;
  	              menu.appendChild(empty);

  	              requestAnimationFrame(() => {
  	                if (dropdown.classList.contains("open")) updateMenuHeightToBottom();
  	              });
  	            }

  	            function renderGooglePlacePredictions(predictions) {
  	              menu.innerHTML = "";
  	              googlePredictions = Array.isArray(predictions) ? predictions: [];
  	              activeIndex = -1;

  	              if (!googlePredictions.length) {
  	                renderGoogleEmpty(`No ${GOOGLE_LOCATION_LABEL} location found`);
  	                return;
  	              }

  	              googlePredictions.forEach((prediction, index) => {
  	                const row = document.createElement("button");
  	                row.className = "trackit-google-place-item";
  	                row.type = "button";
  	                row.__googlePredictionIndex = index;
  	                row.__rowIndex = index;

  	                const mainText =
  	                prediction.structured_formatting?.main_text ||
  	                prediction.description ||
  	                "Google Location";

  	                const secondaryText =
  	                prediction.structured_formatting?.secondary_text ||
  	                prediction.description ||
  	                "";

  	                row.innerHTML = `
  	                <span class="trackit-google-place-icon">
  	                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  	                <circle cx="12" cy="12" r="8.5" stroke-width="2"></circle>
  	                <path d="M3.8 12h16.4" stroke-width="2" stroke-linecap="round"></path>
  	                <path d="M12 3.5c2.25 2.35 3.35 5.18 3.35 8.5S14.25 18.15 12 20.5" stroke-width="2" stroke-linecap="round"></path>
  	                <path d="M12 3.5C9.75 5.85 8.65 8.68 8.65 12s1.1 6.15 3.35 8.5" stroke-width="2" stroke-linecap="round"></path>
  	                </svg>
  	                </span>

  	                <span class="trackit-google-place-main">
  	                <span class="trackit-google-place-name">${escapeHtml(mainText)}</span>
  	                <span class="trackit-google-place-meta">${escapeHtml(secondaryText)}</span>
  	                </span>
  	                `;

  	                menu.appendChild(row);
  	              });

  	              requestAnimationFrame(() => {
  	                if (dropdown.classList.contains("open")) updateMenuHeightToBottom();
  	              });
  	            }

  	            function renderGoogleMenu(query) {
  	              const q = safeString(query).trim();

  	              menu.innerHTML = "";
  	              visibleRows = [];
  	              activeIndex = -1;

  	              if (!q) {
  	                renderGoogleEmpty(`Start typing to search ${GOOGLE_LOCATION_LABEL}`);
  	                return;
  	              }

  	              const autocompleteService = getGoogleAutocompleteService();

  	              if (!autocompleteService) {
  	                renderGoogleEmpty("Google Places search is not loaded");
  	                return;
  	              }

  	              const requestId = ++googlePredictionRequestId;

  	              renderGoogleEmpty(`Searching ${GOOGLE_LOCATION_LABEL}...`);

  	              autocompleteService.getPlacePredictions(
  	                {
  	                  input: q,
  	                  componentRestrictions: {
  	                    country: GOOGLE_LOCATION_COUNTRY_CODE
  	                  },
  	                  region: GOOGLE_LOCATION_REGION,
  	                  language: "en"
  	                },
  	                function (predictions, status) {
  	                  if (requestId !== googlePredictionRequestId) return;

  	                  const ok = getGoogleStatusOk();

  	                  if (status !== ok || !Array.isArray(predictions) || !predictions.length) {
  	                    renderGoogleEmpty(`No ${GOOGLE_LOCATION_LABEL} location found`);
  	                    return;
  	                  }

  	                  renderGooglePlacePredictions(predictions);
  	                }
  	              );
  	            }

  	            function selectGooglePrediction(index) {
  	              const prediction = googlePredictions[index];

  	              if (!prediction) return;

  	              const label = prediction.description || prediction.structured_formatting?.main_text || "Google Location";

  	              searchInput.value = label;
  	              selectedValue = null;
  	              selectedItem = null;
  	              selectedLabel = "";
  	              selectedRowData = null;

  	              dropdown.classList.remove("has-value");
  	              dropdown.classList.remove("has-query");
  	              selectedIcon.removeAttribute("src");

  	              closeActionCard();
  	              closeDropdown();

  	              const placesService = getGooglePlacesService();

  	              if (!placesService || !prediction.place_id) {
  	                dispatchGooglePlaceSelected(prediction, null);
  	                return;
  	              }

  	              placesService.getDetails(
  	                {
  	                  placeId: prediction.place_id,
  	                  fields: ["place_id", "name", "formatted_address", "geometry"]
  	                },
  	                function (place, status) {
  	                  const ok = getGoogleStatusOk();

  	                  if (status === ok && place) {
  	                    focusMapOnGooglePlace(place);
  	                    dispatchGooglePlaceSelected(prediction, place);
  	                    return;
  	                  }

  	                  dispatchGooglePlaceSelected(prediction, null);
  	                }
  	              );
  	            }

  	            function handleGoogleKeydown(event) {
  	              if (!isGoogleSearchMode()) return false;

  	              if (event.key === "ArrowDown") {
  	                event.preventDefault();

  	                if (!dropdown.classList.contains("open")) {
  	                  openDropdown();
  	                }

  	                if (!googlePredictions.length) return true;

  	                activeIndex = activeIndex < googlePredictions.length - 1 ? activeIndex + 1: 0;
  	                paintActiveRow();
  	                return true;
  	              }

  	              if (event.key === "ArrowUp") {
  	                event.preventDefault();

  	                if (!googlePredictions.length) return true;

  	                activeIndex = activeIndex > 0 ? activeIndex - 1: googlePredictions.length - 1;
  	                paintActiveRow();
  	                return true;
  	              }

  	              if (event.key === "Enter") {
  	                event.preventDefault();

  	                if (googlePredictions.length) {
  	                  selectGooglePrediction(activeIndex >= 0 ? activeIndex: 0);
  	                }

  	                return true;
  	              }

  	              if (event.key === "Escape") {
  	                closeDropdown();
  	                return true;
  	              }

  	              return false;
  	            }

  	            // ============================================================
  	            // Old panel behaviour preserved behind SEARCH_ACTION_MODE
  	            // ============================================================

  	            function getLocationIdAny(value) {
  	              try {
  	                if (!value) return null;

  	                if (typeof value === "string") {
  	                  const s = value.trim();
  	                  return s ? s: null;
  	                }

  	                return getLocationValue(value);
  	              } catch (_) {
  	                return null;
  	              }
  	            }

  	            function openLocationPanelAndFocusMap(location, mapMaybe) {
  	              const clickedId = getLocationIdAny(location);

  	              if (!clickedId) {
  	                console.warn("[TrackIT Location Dropdown] Could not resolve selected location ID.", location);
  	                return false;
  	              }

  	              const gMap = resolveGMap(mapMaybe);

  	              const RegistrySafe =
  	              typeof window !== "undefined" && window.LocationRegistry
  	              ? window.LocationRegistry: null;

  	              const RegistryUISafe =
  	              typeof window !== "undefined" && window.LocationRegistryUI
  	              ? window.LocationRegistryUI: null;

  	              let runtime = null;

  	              try {
  	                if (RegistrySafe && typeof RegistrySafe.getRuntime === "function") {
  	                  runtime = RegistrySafe.getRuntime(clickedId);
  	                }
  	              } catch (_) {}

  	              try {
  	                if (gMap && runtime?.polygon) {
  	                  const fittedRuntimePolygon = fitMapToGooglePolygon(gMap, runtime.polygon);

  	                  if (!fittedRuntimePolygon) {
  	                    centerMapOnLocation(location, mapMaybe);
  	                  }
  	                } else {
  	                  centerMapOnLocation(location, mapMaybe);
  	                }
  	              } catch (_) {
  	                centerMapOnLocation(location, mapMaybe);
  	              }

  	              let opened = false;

  	              try {
  	                if (RegistrySafe && typeof RegistrySafe.openLocation === "function") {
  	                  opened = !!RegistrySafe.openLocation(clickedId);
  	                }
  	              } catch (_) {}

  	              if (!opened) {
  	                try {
  	                  if (RegistryUISafe && typeof RegistryUISafe.openEditPanel === "function") {
  	                    RegistryUISafe.openEditPanel({
  	                      loc: runtime?.location || location || null,
  	                      polygon: runtime?.polygon || null,
  	                      marker: runtime?.marker || null,
  	                      registryApi: RegistrySafe || null
  	                    });

  	                    opened = true;
  	                  }
  	                } catch (e) {
  	                  console.warn("[TrackIT Location Dropdown] openEditPanel failed.", e);
  	                }
  	              }

  	              if (!opened) {
  	                console.warn("[TrackIT Location Dropdown] Location panel could not be opened. LocationRegistryUI may not be ready.");
  	              }

  	              return opened;
  	            }

  	            // ============================================================
  	            // Location type helpers + icon logic
  	            // ============================================================

  	            const ICON_CFG = {
  	              W: 176,
  	              H: 176,
  	              CX: 88,
  	              CY: 78,
  	              COLORS: {
  	                fallback: "#2f32d7",
  	                locations: "#2f32d7",
  	                agricultural: "#18a058",
  	                commercial: "#d95f28",
  	                fuel: "#d8a21b",
  	                farm: "#1c7f42",
  	                field: "#27944f",
  	                pivot: "#1f8ccf",
  	                wedge: "#8a63d2",
  	                segment: "#5f8f3f",
  	                ring: "#3a78c2",
  	                gate: "#62d26f",
  	                load_point: "#4fd0e8",
  	                stroke: "#101010",
  	                innerRim: "rgba(255,255,255,0.35)",
  	                outline: "#ffffff"
  	              },
  	              OUTLINE_W: 6
  	            };

  	            const STATIC_TYPE_GROUP_ORDER = [
  	              "farm",
  	              "field",
  	              "pivot",
  	              "wedge",
  	              "segment",
  	              "ring",
  	              "fuel",
  	              "gate",
  	              "load_point",
  	              "agricultural",
  	              "commercial",
  	              "locations"
  	            ];

  	            const TYPE_GROUP_LABELS = {
  	              farm: "Farms",
  	              field: "Fields",
  	              pivot: "Pivots",
  	              wedge: "Wedges",
  	              segment: "Segments",
  	              ring: "Rings",
  	              fuel: "Fuel",
  	              gate: "Gates",
  	              load_point: "Load Points",
  	              agricultural: "Agricultural",
  	              commercial: "Commercial",
  	              locations: "Locations"
  	            };

  	            function cleanColor(value) {
  	              if (typeof value !== "string") return "";

  	              const color = value.trim();

  	              if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)) return color;
  	              if (/^rgba?\([0-9.,%\s]+\)$/i.test(color)) return color;
  	              if (/^hsla?\([0-9.,%\s]+\)$/i.test(color)) return color;

  	              return "";
  	            }

  	            function getLocationCategory(location) {
  	              return (
  	                location?.LocationCategory ||
  	                location?.locationCategory ||
  	                location?.Category ||
  	                location?.category ||
  	                location?.Group ||
  	                location?.group ||
  	                ""
  	              );
  	            }

  	            function getLocationType(location) {
  	              return (
  	                location?.LocationType ||
  	                location?.locationType ||
  	                location?.Type ||
  	                location?.type ||
  	                location?.FieldType ||
  	                location?.fieldType ||
  	                location?.Shape ||
  	                location?.shape ||
  	                ""
  	              );
  	            }

  	            function getLocationShape(location) {
  	              return (
  	                location?.FieldShape ||
  	                location?.fieldShape ||
  	                location?.Shape ||
  	                location?.shape ||
  	                location?.GeometryType ||
  	                location?.geometryType ||
  	                ""
  	              );
  	            }

  	            function typeKey(value) {
  	              return String(value || "").trim().toLowerCase();
  	            }

  	            function titleCaseWords(value) {
  	              return String(value || "")
  	              .replace(/[_-]+/g, " ")
  	              .replace(/\s+/g, " ")
  	              .trim()
  	              .toLowerCase()
  	              .replace(/\b\w/g, c => c.toUpperCase());
  	            }

  	            function slugifyGroup(value) {
  	              const slug = String(value || "")
  	              .toLowerCase()
  	              .replace(/&/g, "and")
  	              .replace(/\//g, " ")
  	              .replace(/[^a-z0-9]+/g, "_")
  	              .replace(/^_+|_+$/g, "");

  	              return slug || "locations";
  	            }

  	            function pluralizeLabel(label) {
  	              const clean = titleCaseWords(label);

  	              if (!clean) return "Locations";

  	              if (/s$/i.test(clean)) return clean;
  	              if (/y$/i.test(clean)) return clean.replace(/y$/i, "ies");
  	              if (/(ch|sh|x|z)$/i.test(clean)) return clean + "es";

  	              return clean + "s";
  	            }

  	            function getDynamicTypeSource(location) {
  	              return (
  	                getLocationType(location) ||
  	                getLocationCategory(location) ||
  	                getLocationShape(location) ||
  	                "Locations"
  	              );
  	            }

  	            function getLocationTypeGroup(location) {
  	              const type = typeKey(getLocationType(location));
  	              const category = typeKey(getLocationCategory(location));
  	              const shape = typeKey(getLocationShape(location));
  	              const combined = `${type} ${category} ${shape}`;

  	              if (combined.includes("farm")) {
  	                return {
  	                  id: "farm",
  	                  label: TYPE_GROUP_LABELS.farm
  	                };
  	              }

  	              if (combined.includes("pivot")) {
  	                return {
  	                  id: "pivot",
  	                  label: TYPE_GROUP_LABELS.pivot
  	                };
  	              }

  	              if (combined.includes("wedge")) {
  	                return {
  	                  id: "wedge",
  	                  label: TYPE_GROUP_LABELS.wedge
  	                };
  	              }

  	              if (combined.includes("segment")) {
  	                return {
  	                  id: "segment",
  	                  label: TYPE_GROUP_LABELS.segment
  	                };
  	              }

  	              if (combined.includes("ring")) {
  	                return {
  	                  id: "ring",
  	                  label: TYPE_GROUP_LABELS.ring
  	                };
  	              }

  	              if (combined.includes("field")) {
  	                return {
  	                  id: "field",
  	                  label: TYPE_GROUP_LABELS.field
  	                };
  	              }

  	              if (combined.includes("fuel")) {
  	                return {
  	                  id: "fuel",
  	                  label: TYPE_GROUP_LABELS.fuel
  	                };
  	              }

  	              if (combined.includes("gate")) {
  	                return {
  	                  id: "gate",
  	                  label: TYPE_GROUP_LABELS.gate
  	                };
  	              }

  	              if (
  	                combined.includes("load") ||
  	                combined.includes("offload") ||
  	                combined.includes("off-load")
  	              ) {
  	                return {
  	                  id: "load_point",
  	                  label: TYPE_GROUP_LABELS.load_point
  	                };
  	              }

  	              if (combined.includes("agric")) {
  	                return {
  	                  id: "agricultural",
  	                  label: TYPE_GROUP_LABELS.agricultural
  	                };
  	              }

  	              if (combined.includes("commercial")) {
  	                return {
  	                  id: "commercial",
  	                  label: TYPE_GROUP_LABELS.commercial
  	                };
  	              }

  	              const source = getDynamicTypeSource(location);
  	              const dynamicLabel = pluralizeLabel(source);
  	              const dynamicId = slugifyGroup(dynamicLabel);

  	              return {
  	                id: dynamicId,
  	                label: dynamicLabel
  	              };
  	            }

  	            function colorForLocation(location) {
  	              const explicit = cleanColor(
  	                location?.color ||
  	                location?.Color ||
  	                location?.colour ||
  	                location?.Colour
  	              );

  	              if (explicit) return explicit;

  	              const group = getLocationTypeGroup(location);

  	              return ICON_CFG.COLORS[group.id] || ICON_CFG.COLORS.fallback;
  	            }

  	            function svgBadge(location) {
  	              const W = ICON_CFG.W;
  	              const H = ICON_CFG.H;
  	              const CX = ICON_CFG.CX;
  	              const CY = ICON_CFG.CY;
  	              const fill = colorForLocation(location || {});

  	              return `
  	              <svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}">
  	              <path d="M ${CX},164 C ${CX},164 38,107 38,64 C 38,35 60,14 ${CX},14 C 116,14 138,35 138,64 C 138,107 ${CX},164 ${CX},164 Z"
  	              fill="none"
  	              stroke="${ICON_CFG.COLORS.outline}"
  	              stroke-width="${ICON_CFG.OUTLINE_W}"/>

  	              <path d="M ${CX},164 C ${CX},164 38,107 38,64 C 38,35 60,14 ${CX},14 C 116,14 138,35 138,64 C 138,107 ${CX},164 ${CX},164 Z"
  	              fill="${fill}"
  	              stroke="${ICON_CFG.COLORS.stroke}"
  	              stroke-width="2"/>

  	              <circle cx="${CX}" cy="${CY - 14}" r="30"
  	              fill="rgba(0,0,0,0.18)"
  	              stroke="${ICON_CFG.COLORS.outline}"
  	              stroke-width="2"/>

  	              <circle cx="${CX}" cy="${CY - 14}" r="15"
  	              fill="${fill}"
  	              stroke="${ICON_CFG.COLORS.outline}"
  	              stroke-width="2"/>

  	              <circle cx="${CX}" cy="${CY - 14}" r="11"
  	              fill="none"
  	              stroke="${ICON_CFG.COLORS.innerRim}"
  	              stroke-width="2"/>
  	              </svg>
  	              `;
  	            }

  	            function iconUrl(location) {
  	              return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgBadge(location || {}))}`;
  	            }

  	            // ============================================================
  	            // Company + location graph helpers
  	            // ============================================================

  	            function getCompanyLabel(company) {
  	              return (
  	                company?.Name ||
  	                company?.name ||
  	                company?.CompanyName ||
  	                company?.companyName ||
  	                company?.Title ||
  	                company?.title ||
  	                "Company"
  	              );
  	            }

  	            function getCompanyKey(company, index) {
  	              return `company:${company?.objectId || company?.ObjectId || getCompanyLabel(company) || index}`;
  	            }

  	            function getCompanyLocations(company) {
  	              const locations =
  	              company?.Locations ||
  	              company?.locations ||
  	              company?.Location ||
  	              company?.location ||
  	              [];

  	              return Array.isArray(locations) ? locations: [];
  	            }

  	            function getLocationLabel(location) {
  	              return (
  	                location?.Name ||
  	                location?.name ||
  	                location?.Label ||
  	                location?.label ||
  	                location?.Title ||
  	                location?.title ||
  	                location?.ID ||
  	                location?.id ||
  	                "Location"
  	              );
  	            }

  	            function getLocationValue(location) {
  	              return (
  	                location?.objectId ||
  	                location?.ObjectId ||
  	                location?.id ||
  	                location?.ID ||
  	                null
  	              );
  	            }

  	            function getLocationParentId(location) {
  	              return (
  	                location?.ParentId ||
  	                location?.parentId ||
  	                location?.ParentID ||
  	                location?.parentID ||
  	                location?.ParentLocationId ||
  	                location?.parentLocationId ||
  	                location?.ParentLocationID ||
  	                location?.parentLocationID ||
  	                location?.Parent?.objectId ||
  	                location?.parent?.objectId ||
  	                location?.Parent?.id ||
  	                location?.parent?.id ||
  	                null
  	              );
  	            }

  	            function getLocationMeta(location) {
  	              const category = getLocationCategory(location);
  	              const type = getLocationType(location);
  	              const fieldShape = getLocationShape(location);

  	              if (category && type && fieldShape && type !== fieldShape) {
  	                return `${category} • ${type} • ${fieldShape}`;
  	              }

  	              if (category && type) return `${category} • ${type}`;
  	              if (type && fieldShape && type !== fieldShape) return `${type} • ${fieldShape}`;
  	              if (type) return type;
  	              if (category) return category;

  	              return (
  	                location?.Address ||
  	                location?.address ||
  	                location?.Description ||
  	                location?.description ||
  	                ""
  	              );
  	            }

  	            function getLocationChildren(location) {
  	              const arrays = [
  	                location?.Children,
  	                location?.children,
  	                location?.ChildLocations,
  	                location?.childLocations,
  	                location?.Locations,
  	                location?.locations,
  	                location?.Fields,
  	                location?.fields,
  	                location?.Segments,
  	                location?.segments,
  	                location?.Rings,
  	                location?.rings
  	              ];

  	              const result = [];
  	              const seen = new Set();

  	              arrays.forEach(list => {
  	                if (!Array.isArray(list)) return;

  	                list.forEach(child => {
  	                  if (!child || typeof child !== "object") return;

  	                  const key = getLocationValue(child) || child;

  	                  if (seen.has(key)) return;

  	                  seen.add(key);
  	                  result.push(child);
  	                });
  	              });

  	              return result;
  	            }

  	            function directChildCount(location) {
  	              try {
  	                return getLocationChildren(location).length;
  	              } catch (_) {
  	                return 0;
  	              }
  	            }

  	            function makeLocationKey(location, fallbackPath) {
  	              return `location:${getLocationValue(location) || fallbackPath || getLocationLabel(location)}`;
  	            }

  	            function getSearchTextForNode(companyEntry, location, path) {
  	              return [
  	                companyEntry?.label,
  	                path,
  	                getLocationLabel(location),
  	                getLocationType(location),
  	                getLocationCategory(location),
  	                getLocationShape(location),
  	                location?.Address,
  	                location?.address,
  	                location?.Description,
  	                location?.description,
  	                location?.Notes,
  	                location?.notes,
  	                location?.Code,
  	                location?.code
  	              ]
  	              .filter(Boolean)
  	              .join(" ")
  	              .toLowerCase();
  	            }

  	            function makeTypeGroupKey(companyEntry, groupId) {
  	              return `typegroup:${companyEntry.key}:${groupId}`;
  	            }

  	            function sortNodesByLabel(nodes) {
  	              return nodes.sort((a,
  	                b) => a.label.localeCompare(b.label,
  	                undefined,
  	                {
  	                  numeric: true,
  	                  sensitivity: "base"
  	                }));
  	            }

  	            function sortLocationsByLabel(locations) {
  	              return locations.sort((a,
  	                b) => getLocationLabel(a).localeCompare(getLocationLabel(b),
  	                undefined,
  	                {
  	                  numeric: true,
  	                  sensitivity: "base"
  	                }));
  	            }

  	            let companyEntries = [];
  	            let flatRows = [];

  	            function buildCompanyLocationGraph(company) {
  	              const byId = Object.create(null);
  	              const orderedIds = [];
  	              const childrenByParentId = Object.create(null);
  	              const parentByChildId = Object.create(null);

  	              function rememberLocation(location) {
  	                const id = getLocationValue(location);

  	                if (!id) return "";

  	                const idText = String(id);

  	                if (!byId[idText]) {
  	                  byId[idText] = location;
  	                  orderedIds.push(idText);
  	                } else {
  	                  const existing = byId[idText];

  	                  if (directChildCount(location) > directChildCount(existing)) {
  	                    byId[idText] = location;
  	                  }
  	                }

  	                return idText;
  	              }

  	              function addChildLink(parentId, childId) {
  	                if (!parentId || !childId) return;

  	                const p = String(parentId);
  	                const c = String(childId);

  	                if (!p || !c || p === c) return;

  	                if (parentByChildId[c] && parentByChildId[c] !== p) {
  	                  return;
  	                }

  	                parentByChildId[c] = p;

  	                if (!childrenByParentId[p]) {
  	                  childrenByParentId[p] = Object.create(null);
  	                }

  	                childrenByParentId[p][c] = true;
  	              }

  	              function scanLocationTree(location, explicitParentId) {
  	                if (!location || typeof location !== "object") return;

  	                const id = rememberLocation(location);

  	                if (!id) return;

  	                if (explicitParentId) {
  	                  addChildLink(explicitParentId, id);
  	                }

  	                const storedParentId = getLocationParentId(location);

  	                if (storedParentId) {
  	                  addChildLink(storedParentId, id);
  	                }

  	                const children = getLocationChildren(location);

  	                children.forEach(child => {
  	                  const childId = rememberLocation(child);

  	                  if (childId) {
  	                    addChildLink(id, childId);
  	                  }

  	                  scanLocationTree(child, id);
  	                });
  	              }

  	              const companyLocations = getCompanyLocations(company);

  	              companyLocations.forEach(location => {
  	                scanLocationTree(location, null);
  	              });

  	              const rootIds = [];

  	              orderedIds.forEach(id => {
  	                const parentId = parentByChildId[id];

  	                if (!parentId || !byId[parentId]) {
  	                  rootIds.push(id);
  	                }
  	              });

  	              return {
  	                byId,
  	                orderedIds,
  	                childrenByParentId,
  	                parentByChildId,
  	                rootIds
  	              };
  	            }

  	            function buildLocationNodeFromGraph(companyEntry,
  	              graph,
  	              id,
  	              depth,
  	              parentPath,
  	              stack) {
  	              const idText = String(id || "");

  	              if (!idText || !graph.byId[idText]) return null;

  	              if (stack.has(idText)) {
  	                console.warn("[TrackIT Location Dropdown] Circular location reference skipped.", graph.byId[idText]);
  	                return null;
  	              }

  	              const location = graph.byId[idText];
  	              const value = getLocationValue(location);

  	              if (!value) return null;

  	              const label = getLocationLabel(location);
  	              const path = parentPath ? `${parentPath} > ${label}`: label;
  	              const key = makeLocationKey(location, path);
  	              const group = getLocationTypeGroup(location);

  	              const nextStack = new Set(stack);
  	              nextStack.add(idText);

  	              const childIds = Object.keys(graph.childrenByParentId[idText] || {});

  	              const childLocations = childIds
  	              .map(childId => graph.byId[childId])
  	              .filter(Boolean);

  	              sortLocationsByLabel(childLocations);

  	              const childrenNodes = childLocations
  	              .map(childLoc => buildLocationNodeFromGraph(
  	                companyEntry,
  	                graph,
  	                getLocationValue(childLoc),
  	                depth + 1,
  	                path,
  	                nextStack
  	              ))
  	              .filter(Boolean);

  	              const node = {
  	                key,
  	                companyEntry,
  	                location,
  	                value: String(value),
  	                label,
  	                meta: getLocationMeta(location),
  	                type: getLocationType(location),
  	                category: getLocationCategory(location),
  	                typeGroupId: group.id,
  	                typeGroupLabel: group.label,
  	                depth,
  	                path,
  	                childrenNodes,
  	                searchText: getSearchTextForNode(companyEntry, location, path)
  	              };

  	              flatRows.push(node);

  	              return node;
  	            }

  	            function groupRootNodesByType(companyEntry, rootNodes) {
  	              const groupsById = Object.create(null);

  	              rootNodes.forEach(node => {
  	                const groupId = node.typeGroupId || "locations";
  	                const groupLabel = node.typeGroupLabel || TYPE_GROUP_LABELS.locations;

  	                if (!groupsById[groupId]) {
  	                  groupsById[groupId] = {
  	                    id: groupId,
  	                    key: makeTypeGroupKey(companyEntry, groupId),
  	                    label: groupLabel,
  	                    companyEntry,
  	                    nodes: []
  	                  };
  	                }

  	                groupsById[groupId].nodes.push(node);
  	              });

  	              const groups = Object.keys(groupsById).map(groupId => {
  	                const group = groupsById[groupId];

  	                group.nodes = sortNodesByLabel(group.nodes);

  	                return group;
  	              });

  	              groups.sort((a, b) => {
  	                const ai = STATIC_TYPE_GROUP_ORDER.indexOf(a.id);
  	                const bi = STATIC_TYPE_GROUP_ORDER.indexOf(b.id);

  	                const aKnown = ai >= 0;
  	                const bKnown = bi >= 0;

  	                if (aKnown && bKnown) return ai - bi;
  	                if (aKnown) return -1;
  	                if (bKnown) return 1;

  	                return a.label.localeCompare(b.label, undefined, {
  	                  numeric: true,
  	                  sensitivity: "base"
  	                });
  	              });

  	              return groups;
  	            }

  	            function buildTreeRows() {
  	              flatRows = [];
  	              companyEntries = [];

  	              companies.forEach((company, index) => {
  	                const entry = {
  	                  company,
  	                  index,
  	                  key: getCompanyKey(company, index),
  	                  label: getCompanyLabel(company),
  	                  locationNodes: [],
  	                  typeGroups: []
  	                };

  	                const graph = buildCompanyLocationGraph(company);

  	                const rootLocations = graph.rootIds
  	                .map(id => graph.byId[id])
  	                .filter(Boolean);

  	                sortLocationsByLabel(rootLocations);

  	                entry.locationNodes = rootLocations
  	                .map(location => buildLocationNodeFromGraph(
  	                  entry,
  	                  graph,
  	                  getLocationValue(location),
  	                  0,
  	                  "",
  	                  new Set()
  	                ))
  	                .filter(Boolean);

  	                entry.typeGroups = groupRootNodesByType(entry, entry.locationNodes);

  	                if (entry.typeGroups.length) {
  	                  companyEntries.push(entry);
  	                }
  	              });
  	            }

  	            function markDefaultCollapsedStates() {
  	              const collapsed = root.__trackitCollapsedLocationTree || {};

  	              companyEntries.forEach(companyEntry => {
  	                collapsed[companyEntry.key] = false;

  	                companyEntry.typeGroups.forEach(typeGroup => {
  	                  if (collapsed[typeGroup.key] === undefined) {
  	                    collapsed[typeGroup.key] = true;
  	                  }

  	                  markLocationChildrenCollapsed(typeGroup.nodes, collapsed);
  	                });
  	              });

  	              root.__trackitCollapsedLocationTree = collapsed;
  	            }

  	            function markLocationChildrenCollapsed(nodes, collapsed) {
  	              if (!Array.isArray(nodes)) return;

  	              nodes.forEach(node => {
  	                if (!node) return;

  	                if (Array.isArray(node.childrenNodes) && node.childrenNodes.length > 0) {
  	                  if (collapsed[node.key] === undefined) {
  	                    collapsed[node.key] = true;
  	                  }

  	                  markLocationChildrenCollapsed(node.childrenNodes, collapsed);
  	                }
  	              });
  	            }

  	            function companyMatchesQuery(companyEntry,
  	              q) {
  	              if (!q) return true;

  	              return [
  	                companyEntry.label,
  	                companyEntry.company?.Name,
  	                companyEntry.company?.name,
  	                companyEntry.company?.CompanyName,
  	                companyEntry.company?.companyName
  	              ]
  	              .filter(Boolean)
  	              .join(" ")
  	              .toLowerCase()
  	              .includes(q);
  	            }

  	            function nodeSelfMatchesQuery(node, q) {
  	              if (!q) return true;
  	              return node.searchText.includes(q);
  	            }

  	            function nodeMatchesQuery(node, q) {
  	              if (!q) return true;
  	              if (nodeSelfMatchesQuery(node, q)) return true;

  	              return node.childrenNodes.some(child => nodeMatchesQuery(child, q));
  	            }

  	            function hasAnyNodes(nodes) {
  	              return Array.isArray(nodes) && nodes.length > 0;
  	            }

  	            // ============================================================
  	            // CSS
  	            // ============================================================

  	            const css = `
  	            .trackit-location-dropdown {
  	            position: relative;
  	            width: 100%;
  	            max-width: 100%;
  	            min-width: 0;
  	            box-sizing: border-box;
  	            font-family: Inter, Arial, sans-serif;
  	            color: #fff;
  	            z-index: ${MAX_Z_INDEX} !important;
  	            user-select: none;
  	            }

  	            .trackit-location-dropdown.google-mode .trackit-location-control {
  	            border-color: rgba(255,122,36,0.72);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.055),
  	            0 0 18px rgba(255,122,36,0.16);
  	            }

  	            .trackit-location-dropdown.google-mode .trackit-menu {
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(255,122,36,0.18), rgba(255,122,36,0.00) 44%),
  	            linear-gradient(145deg, rgba(5,6,7,0.99), rgba(0,0,0,0.98));
  	            border-color: rgba(255,122,36,0.58);
  	            box-shadow:
  	            -14px 16px 32px rgba(0,0,0,0.46),
  	            0 0 20px rgba(255,122,36,0.12),
  	            inset 0 1px 0 rgba(255,255,255,0.035);
  	            }

  	            .trackit-location-dropdown.google-mode .trackit-empty {
  	            width: 100%;
  	            min-height: 40px;
  	            display: flex;
  	            align-items: center;
  	            padding: 9px 11px;
  	            background:
  	            radial-gradient(circle at 0% 50%, rgba(255,122,36,0.10), rgba(255,122,36,0.00) 52%),
  	            linear-gradient(145deg, rgba(7,8,9,0.98), rgba(0,0,0,0.96));
  	            border-bottom: 1px solid rgba(255,122,36,0.16);
  	            color: rgba(255,184,125,0.84);
  	            font-size: 10px;
  	            font-weight: 900;
  	            letter-spacing: 0.02em;
  	            }

  	            .trackit-google-place-item {
  	            width: 100%;
  	            min-height: 42px;
  	            display: grid;
  	            grid-template-columns: 20px 1fr;
  	            gap: 8px;
  	            align-items: center;
  	            padding: 8px 10px;
  	            border: 0;
  	            border-bottom: 1px solid rgba(255,122,36,0.13);
  	            background:
  	            radial-gradient(circle at 0% 50%, rgba(255,122,36,0.08), rgba(255,122,36,0.00) 50%),
  	            linear-gradient(145deg, rgba(8,9,10,0.98), rgba(0,0,0,0.96));
  	            color: rgba(255,216,191,0.88);
  	            text-align: left;
  	            cursor: pointer;
  	            }

  	            .trackit-google-place-item:hover,
  	            .trackit-google-place-item.active {
  	            background:
  	            radial-gradient(circle at 0% 50%, rgba(255,122,36,0.20), rgba(255,122,36,0.00) 54%),
  	            linear-gradient(145deg, rgba(14,10,7,0.99), rgba(0,0,0,0.98));
  	            border-bottom-color: rgba(255,122,36,0.32);
  	            box-shadow:
  	            inset 3px 0 0 rgba(255,122,36,0.78),
  	            inset 0 1px 0 rgba(255,255,255,0.035);
  	            }

  	            .trackit-google-place-icon {
  	            width: 18px;
  	            height: 18px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,154,61,0.92);
  	            filter: drop-shadow(0 0 7px rgba(255,122,36,0.24));
  	            }

  	            .trackit-google-place-icon svg {
  	            width: 14px;
  	            height: 14px;
  	            stroke: currentColor;
  	            }

  	            .trackit-google-place-main {
  	            min-width: 0;
  	            display: block;
  	            }

  	            .trackit-google-place-name {
  	            display: block;
  	            font-size: 10px;
  	            font-weight: 950;
  	            line-height: 1.18;
  	            color: #ffb16f;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }

  	            .trackit-google-place-meta {
  	            display: block;
  	            margin-top: 3px;
  	            font-size: 8px;
  	            font-weight: 800;
  	            line-height: 1.14;
  	            color: rgba(255,216,191,0.56);
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }

  	            .trackit-google-place-item:hover .trackit-google-place-name,
  	            .trackit-google-place-item.active .trackit-google-place-name {
  	            color: #ff9a3d;
  	            }

  	            .trackit-google-place-item:hover .trackit-google-place-meta,
  	            .trackit-google-place-item.active .trackit-google-place-meta {
  	            color: rgba(255,226,207,0.76);
  	            }

  	            .trackit-location-dropdown * {
  	            box-sizing: border-box;
  	            }

  	            .trackit-location-control {
  	            width: 100%;
  	            max-width: 100%;
  	            min-width: 0;
  	            height: 28px;
  	            position: relative;
  	            background:
  	            radial-gradient(circle at 0% 50%, rgba(255,122,36,0.11), rgba(255,122,36,0.00) 46%),
  	            linear-gradient(145deg, rgba(10,13,14,0.96), rgba(0,0,0,0.82));
  	            border: 1px solid rgba(255,122,36,0.34);
  	            border-radius: 14px;
  	            color: #fff;
  	            padding: 0 72px 0 9px;
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.045),
  	            0 0 12px rgba(255,122,36,0.06);
  	            overflow: visible;
  	            }

  	            .trackit-location-control:hover,
  	            .trackit-location-dropdown.open .trackit-location-control {
  	            border-color: rgba(255,122,36,0.72);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.055),
  	            0 0 18px rgba(255,122,36,0.16);
  	            }

  	            .trackit-input-row {
  	            display: grid;
  	            grid-template-columns: 18px 1fr;
  	            align-items: center;
  	            gap: 5px;
  	            width: 100%;
  	            height: 100%;
  	            min-width: 0;
  	            }

  	            .trackit-search-icon {
  	            color: rgba(255,193,148,0.68);
  	            font-size: 12px;
  	            line-height: 1;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            }

  	            .trackit-selected-icon {
  	            width: 18px;
  	            height: 18px;
  	            display: none;
  	            }

  	            .trackit-location-dropdown.has-value .trackit-input-row {
  	            grid-template-columns: 18px 1fr;
  	            }

  	            .trackit-location-dropdown.has-value .trackit-search-icon {
  	            display: none;
  	            }

  	            .trackit-location-dropdown.has-value .trackit-selected-icon {
  	            display: block;
  	            }

  	            .trackit-search-input {
  	            width: 100%;
  	            min-width: 0;
  	            height: 26px;
  	            border: none;
  	            outline: none;
  	            background: transparent;
  	            color: rgba(248,250,252,0.82);
  	            font-size: 10px;
  	            font-weight: 750;
  	            padding: 0;
  	            }

  	            .trackit-search-input::placeholder {
  	            color: rgba(226,232,240,0.44);
  	            font-weight: 750;
  	            }

  	            .trackit-clear {
  	            position: absolute;
  	            right: 50px;
  	            top: 50%;
  	            transform: translateY(-50%);
  	            color: rgba(255,154,61,0.78);
  	            font-size: 18px;
  	            line-height: 1;
  	            cursor: pointer;
  	            display: none;
  	            user-select: none;
  	            z-index: 6;
  	            }

  	            .trackit-clear:hover {
  	            color: #ff9a3d;
  	            }

  	            .trackit-location-dropdown.has-value .trackit-clear,
  	            .trackit-location-dropdown.has-query .trackit-clear {
  	            display: block;
  	            }

  	            .trackit-arrow-hit {
  	            position: absolute;
  	            right: 24px;
  	            top: 0;
  	            width: 24px;
  	            height: 100%;
  	            z-index: 7;
  	            cursor: pointer;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            user-select: none;
  	            }

  	            .trackit-arrow-triangle {
  	            width: 0;
  	            height: 0;
  	            border-left: 3px solid transparent;
  	            border-right: 3px solid transparent;
  	            border-top: 4px solid rgba(255,122,36,0.72);
  	            transition: transform 120ms ease, border-top-color 120ms ease;
  	            }

  	            .trackit-arrow-hit:hover .trackit-arrow-triangle {
  	            border-top-color: #ff9a3d;
  	            }

  	            .trackit-location-dropdown.open .trackit-arrow-triangle {
  	            transform: rotate(180deg);
  	            }

  	            .trackit-google-toggle {
  	            position: absolute;
  	            right: 0;
  	            top: 0;
  	            width: 24px;
  	            height: 100%;
  	            z-index: 8;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            border: 0;
  	            outline: 0;
  	            padding: 0;
  	            margin: 0;
  	            background: transparent;
  	            color: rgba(255,216,191,0.34);
  	            cursor: pointer;
  	            }

  	            .trackit-google-toggle svg {
  	            width: 14px;
  	            height: 14px;
  	            display: block;
  	            stroke: currentColor;
  	            filter: drop-shadow(0 0 0 rgba(255,122,36,0));
  	            transition:
  	            color 130ms ease,
  	            filter 130ms ease,
  	            transform 130ms ease;
  	            }

  	            .trackit-google-toggle:hover {
  	            color: rgba(255,154,61,0.76);
  	            }

  	            .trackit-location-dropdown.google-mode .trackit-google-toggle {
  	            color: #ff9a3d;
  	            }

  	            .trackit-location-dropdown.google-mode .trackit-google-toggle svg {
  	            filter: drop-shadow(0 0 8px rgba(255,122,36,0.48));
  	            transform: scale(1.04);
  	            }

  	            .trackit-location-dropdown.google-mode .trackit-location-control {
  	            border-color: rgba(255,122,36,0.72);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.055),
  	            0 0 18px rgba(255,122,36,0.16);
  	            }

  	            .trackit-menu {
  	            position: absolute;
  	            top: calc(100% + 5px);
  	            left: 0;
  	            right: 0;
  	            z-index: ${MAX_Z_INDEX} !important;

  	            height: var(--trackit-menu-height, 320px);
  	            max-height: var(--trackit-menu-height, 320px);

  	            overflow-y: auto;
  	            overflow-x: hidden;

  	            padding-right: 0;
  	            padding-bottom: 10px;

  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(120,49,15,0.24), rgba(120,49,15,0.00) 44%),
  	            linear-gradient(145deg, rgba(13,17,18,0.99), rgba(0,0,0,0.97));

  	            border: 1px solid rgba(120,49,15,0.72);
  	            border-radius: 16px;
  	            display: none;

  	            box-shadow:
  	            -14px 16px 32px rgba(0,0,0,0.42),
  	            0 0 18px rgba(120,49,15,0.18),
  	            inset 0 1px 0 rgba(255,255,255,0.045);

  	            scrollbar-width: none;
  	            scrollbar-gutter: auto;
  	            -ms-overflow-style: none;
  	            }


  	            .trackit-action-card-body::-webkit-scrollbar {
  	            width: 0;
  	            height: 0;
  	            display: none;
  	            }

  	            .trackit-action-card-body {
  	            max-height: 300px;
  	            overflow-y: auto;
  	            padding: 7px 5px 5px 5px;
  	            scrollbar-width: none;
  	            scrollbar-gutter: auto;
  	            -ms-overflow-style: none;
  	            }

  	            .trackit-company-header,
  	            .trackit-company-collapsed-note,
  	            .trackit-type-group-header,
  	            .trackit-type-group-collapsed-note,
  	            .trackit-location-item,
  	            .trackit-empty {
  	            width: 100%;
  	            max-width: 100%;
  	            margin-right: 0;
  	            }

  	            .trackit-location-item {
  	            padding-right: 8px;
  	            }

  	            .trackit-location-dropdown.open .trackit-menu {
  	            display: block;
  	            }

  	            .trackit-company-header {
  	            position: sticky;
  	            top: 0;
  	            z-index: 3;
  	            display: flex;
  	            align-items: center;
  	            justify-content: space-between;
  	            gap: 8px;
  	            padding: 7px 9px;
  	            background:
  	            linear-gradient(90deg, rgba(120,49,15,0.88), rgba(47,18,6,0.96));
  	            color: #ffd8bf;
  	            font-size: 10px;
  	            font-weight: 950;
  	            letter-spacing: 0.07em;
  	            text-transform: uppercase;
  	            border-bottom: 1px solid rgba(0,0,0,0.35);
  	            cursor: pointer;
  	            user-select: none;
  	            }

  	            .trackit-company-header:hover {
  	            background:
  	            linear-gradient(90deg, rgba(146,58,18,0.92), rgba(61,23,7,0.98));
  	            }

  	            .trackit-company-title {
  	            min-width: 0;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            white-space: nowrap;
  	            }

  	            .trackit-company-meta {
  	            display: flex;
  	            align-items: center;
  	            gap: 6px;
  	            flex: 0 0 auto;
  	            opacity: 0.9;
  	            }

  	            .trackit-company-caret,
  	            .trackit-type-group-caret {
  	            width: 0;
  	            height: 0;
  	            border-left: 4px solid transparent;
  	            border-right: 4px solid transparent;
  	            border-top: 5px solid rgba(255,255,255,0.92);
  	            transition: transform 120ms ease, border-top-color 120ms ease;
  	            }

  	            .trackit-company-header.collapsed .trackit-company-caret,
  	            .trackit-type-group-header.collapsed .trackit-type-group-caret {
  	            transform: rotate(-90deg);
  	            }

  	            .trackit-company-collapsed-note {
  	            height: 28px;
  	            padding: 0;
  	            background: rgba(5, 12, 9, 0.94);
  	            border-bottom: 1px solid rgba(255,255,255,0.04);
  	            cursor: pointer;
  	            }

  	            .trackit-company-collapsed-note:hover {
  	            background: rgba(10, 18, 13, 0.98);
  	            }

  	            .trackit-type-group-header {
  	            display: flex;
  	            align-items: center;
  	            gap: 8px;
  	            min-height: 30px;
  	            padding: 6px 9px 6px 18px;
  	            background:
  	            linear-gradient(90deg, rgba(23, 28, 29, 0.98), rgba(5, 7, 8, 0.98));
  	            border-bottom: 1px solid rgba(255,255,255,0.055);
  	            border-left: 3px solid rgba(120,49,15,0.82);
  	            color: #fff;
  	            cursor: pointer;
  	            user-select: none;
  	            }

  	            .trackit-type-group-header:hover {
  	            background:
  	            linear-gradient(90deg, rgba(35, 42, 44, 0.98), rgba(8, 11, 12, 0.98));
  	            border-left-color: #9a3f16;
  	            }

  	            .trackit-type-group-title {
  	            min-width: 0;
  	            flex: 1;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            white-space: nowrap;
  	            font-size: 11px;
  	            font-weight: 900;
  	            letter-spacing: 0.04em;
  	            text-transform: uppercase;
  	            }

  	            .trackit-type-group-meta {
  	            min-width: 19px;
  	            height: 18px;
  	            padding: 0 6px;
  	            border-radius: 999px;
  	            background: rgba(120,49,15,0.36);
  	            border: 1px solid rgba(120,49,15,0.72);
  	            color: rgba(255,255,255,0.88);
  	            font-size: 10px;
  	            font-weight: 850;
  	            line-height: 16px;
  	            text-align: center;
  	            }

  	            .trackit-type-group-header:hover .trackit-type-group-caret {
  	            border-top-color: #ff9a3d;
  	            }

  	            .trackit-type-group-collapsed-note {
  	            height: 1px;
  	            padding: 0;
  	            background: rgba(5, 12, 9, 0.88);
  	            border-bottom: 1px solid rgba(255,255,255,0.035);
  	            cursor: pointer;
  	            }

  	            .trackit-location-item {
  	            display: flex;
  	            align-items: center;
  	            gap: 6px;
  	            padding: 6px 8px;
  	            cursor: pointer;
  	            border-bottom: 1px solid rgba(255,255,255,0.055);
  	            background: rgba(255,255,255,0.018);
  	            min-width: 0;
  	            }

  	            .trackit-location-item:hover,
  	            .trackit-location-item.active {
  	            background: rgba(120,49,15,0.26);
  	            }

  	            .trackit-location-item.selected {
  	            background: rgba(120,49,15,0.42);
  	            }

  	            .trackit-location-caret-hit {
  	            width: 13px;
  	            height: 26px;
  	            flex: 0 0 13px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            cursor: pointer;
  	            user-select: none;
  	            }

  	            .trackit-location-caret-hit.empty {
  	            cursor: default;
  	            }

  	            .trackit-location-caret {
  	            width: 0;
  	            height: 0;
  	            border-left: 4px solid transparent;
  	            border-right: 4px solid transparent;
  	            border-top: 5px solid rgba(255,255,255,0.82);
  	            transition: transform 120ms ease, border-top-color 120ms ease;
  	            }

  	            .trackit-location-caret-hit:hover .trackit-location-caret {
  	            border-top-color: #ff9a3d;
  	            }

  	            .trackit-location-caret.collapsed {
  	            transform: rotate(-90deg);
  	            }

  	            .trackit-item-icon {
  	            width: 26px;
  	            height: 26px;
  	            flex: 0 0 26px;
  	            }

  	            .trackit-item-text-wrap {
  	            min-width: 0;
  	            flex: 1;
  	            }

  	            .trackit-item-label {
  	            font-size: 12px;
  	            line-height: 15px;
  	            font-weight: 800;
  	            color: #fff;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }

  	            .trackit-item-meta {
  	            margin-top: 0;
  	            font-size: 10px;
  	            line-height: 12px;
  	            color: rgba(255,255,255,0.58);
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }

  	            .trackit-empty {
  	            padding: 10px 9px;
  	            color: rgba(255,255,255,0.65);
  	            font-size: 12px;
  	            }

  	            .trackit-action-card {
  	            position: absolute;
  	            top: calc(100% + 5px);
  	            left: 0;
  	            right: 0;
  	            z-index: ${MAX_Z_INDEX} !important;
  	            display: none;
  	            overflow: hidden;
  	            border-radius: 18px;
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(255,122,36,0.18), rgba(255,122,36,0.00) 42%),
  	            linear-gradient(145deg, rgba(18,24,26,0.98), rgba(0,0,0,0.96));
  	            border: 1px solid rgba(255,122,36,0.44);
  	            box-shadow:
  	            -14px 16px 32px rgba(0,0,0,0.44),
  	            0 0 22px rgba(255,122,36,0.14),
  	            inset 0 1px 0 rgba(255,255,255,0.065);
  	            }

  	            .trackit-action-card.open {
  	            display: block;
  	            }

  	            .trackit-action-card {
  	            padding: 5px;
  	            }

  	            .trackit-action-card-header {
  	            display: block;
  	            padding: 5px 5px 7px 5px;
  	            border-bottom: 1px solid rgba(120,49,15,0.36);
  	            }

  	            .trackit-action-card-top-row {
  	            display: flex;
  	            justify-content: flex-end;
  	            align-items: center;
  	            gap: 5px;
  	            width: 100%;
  	            margin-bottom: 5px;
  	            }

  	            .trackit-action-card-title-wrap {
  	            width: 100%;
  	            min-width: 0;
  	            padding: 0 2px;
  	            }

  	            .trackit-action-card-icon {
  	            width: 32px;
  	            height: 32px;
  	            border-radius: 13px;
  	            object-fit: contain;
  	            background: rgba(0,0,0,0.44);
  	            border: 1px solid rgba(255,122,36,0.22);
  	            box-shadow: 0 0 12px rgba(255,122,36,0.10);
  	            }

  	            .trackit-action-card-title-wrap {
  	            min-width: 0;
  	            }

  	            .trackit-action-card-title {
  	            color: #ffd8bf;
  	            font-size: 12px;
  	            line-height: 1.1;
  	            font-weight: 950;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }

  	            .trackit-action-card-subtitle {
  	            margin-top: 3px;
  	            color: rgba(226,232,240,0.46);
  	            font-size: 8px;
  	            font-weight: 900;
  	            text-transform: uppercase;
  	            letter-spacing: 0.10em;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }

  	            .trackit-action-card-edit {
  	            width: 24px;
  	            height: 24px;
  	            border: 0;
  	            outline: 0;
  	            border-radius: 10px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,216,191,0.82);
  	            font-size: 12px;
  	            font-weight: 950;
  	            background: rgba(0,0,0,0.46);
  	            border: 1px solid rgba(120,49,15,0.42);
  	            cursor: pointer;
  	            }

  	            .trackit-action-card-edit:hover {
  	            color: #ff9a3d;
  	            border-color: rgba(255,122,36,0.52);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.22);
  	            }

  	            .trackit-action-card-close {
  	            width: 24px;
  	            height: 24px;
  	            border: 0;
  	            outline: 0;
  	            border-radius: 10px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,216,191,0.82);
  	            font-size: 13px;
  	            font-weight: 950;
  	            background: rgba(0,0,0,0.46);
  	            border: 1px solid rgba(255,122,36,0.24);
  	            cursor: pointer;
  	            }

  	            .trackit-action-card-close:hover {
  	            color: #ff9a3d;
  	            border-color: rgba(255,122,36,0.52);
  	            }

  	            .trackit-action-card.editing {
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(120,49,15,0.30), rgba(120,49,15,0.00) 44%),
  	            linear-gradient(145deg, rgba(14,18,19,0.99), rgba(0,0,0,0.98));
  	            }

  	            .trackit-action-card-header.is-editing {
  	            border-bottom: 1px solid rgba(120,49,15,0.48);
  	            }

  	            .trackit-action-card-delete,
  	            .trackit-action-card-undo,
  	            .trackit-action-card-save {
  	            width: 24px;
  	            height: 24px;
  	            border: 0;
  	            outline: 0;
  	            border-radius: 10px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,216,191,0.84);
  	            font-size: 12px;
  	            font-weight: 950;
  	            background: rgba(0,0,0,0.46);
  	            border: 1px solid rgba(120,49,15,0.42);
  	            cursor: pointer;
  	            }

  	            .trackit-action-card-delete:hover {
  	            color: #ffb0a3;
  	            border-color: rgba(255,90,60,0.62);
  	            background: rgba(120,24,15,0.32);
  	            box-shadow: 0 0 10px rgba(120,24,15,0.22);
  	            }

  	            .trackit-action-card-undo:hover,
  	            .trackit-action-card-save:hover {
  	            color: #ff9a3d;
  	            border-color: rgba(255,122,36,0.58);
  	            background: rgba(120,49,15,0.28);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.22);
  	            }

  	            .trackit-action-card-save {
  	            background:
  	            linear-gradient(145deg, rgba(120,49,15,0.58), rgba(47,18,6,0.88));
  	            border-color: rgba(255,122,36,0.50);
  	            }

  	            .trackit-action-card-edit-subtitle {
  	            margin-top: 3px;
  	            color: rgba(226,232,240,0.44);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.12em;
  	            }

  	            .trackit-card-edit-tools {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 7px;
  	            margin-bottom: 10px;
  	            }

  	            .trackit-card-tool-button {
  	            width: 100%;
  	            min-height: 31px;
  	            border: 1px solid rgba(120,49,15,0.46);
  	            border-radius: 13px;
  	            background:
  	            linear-gradient(145deg, rgba(18,22,23,0.92), rgba(0,0,0,0.94));
  	            color: rgba(255,216,191,0.88);
  	            font-size: 9px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.065em;
  	            cursor: pointer;
  	            }

  	            .trackit-card-tool-button:hover {
  	            border-color: rgba(255,122,36,0.62);
  	            background:
  	            linear-gradient(145deg, rgba(120,49,15,0.34), rgba(0,0,0,0.94));
  	            box-shadow: 0 0 12px rgba(120,49,15,0.20);
  	            }

  	            .trackit-card-edit-form {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 8px;
  	            }

  	            .trackit-card-edit-field {
  	            width: 100%;
  	            min-width: 0;
  	            }

  	            .trackit-action-card.editing .trackit-card-edit-textarea {
  	            min-height: 58px;
  	            max-height: 86px;
  	            }

  	            .trackit-action-card.editing .trackit-action-card-body {
  	            overflow-y: auto;
  	            padding-bottom: 10px;
  	            }

  	            .trackit-action-card.functionality-editing {
  	            background:
  	            radial-gradient(circle at 0% 0%, rgba(120,49,15,0.30), rgba(120,49,15,0.00) 44%),
  	            linear-gradient(145deg, rgba(14,18,19,0.99), rgba(0,0,0,0.98));
  	            }

  	            .trackit-action-card-header.is-functionality {
  	            border-bottom: 1px solid rgba(120,49,15,0.48);
  	            }

  	            .trackit-card-functionality-form {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 8px;
  	            }

  	            .trackit-card-functionality-row {
  	            min-height: 46px;
  	            display: grid;
  	            grid-template-columns: 1fr 28px;
  	            gap: 7px;
  	            align-items: center;
  	            padding: 8px;
  	            border: 1px solid rgba(120,49,15,0.36);
  	            border-radius: 15px;
  	            background:
  	            linear-gradient(145deg, rgba(0,0,0,0.50), rgba(10,12,13,0.84));
  	            }

  	            .trackit-card-functionality-main {
  	            display: grid;
  	            grid-template-columns: 24px 1fr;
  	            gap: 8px;
  	            align-items: center;
  	            min-width: 0;
  	            cursor: pointer;
  	            }

  	            .trackit-card-functionality-main input {
  	            display: none;
  	            }

  	            .trackit-card-functionality-box {
  	            width: 22px;
  	            height: 22px;
  	            border-radius: 9px;
  	            border: 1px solid rgba(120,49,15,0.62);
  	            background: rgba(0,0,0,0.72);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.04),
  	            0 0 8px rgba(120,49,15,0.08);
  	            }

  	            .trackit-card-functionality-main input:checked + .trackit-card-functionality-box {
  	            background:
  	            radial-gradient(circle at 50% 50%, rgba(255,154,61,0.96), rgba(120,49,15,0.86));
  	            border-color: rgba(255,154,61,0.74);
  	            box-shadow:
  	            0 0 12px rgba(255,122,36,0.22),
  	            inset 0 1px 0 rgba(255,255,255,0.18);
  	            }

  	            .trackit-card-functionality-text {
  	            min-width: 0;
  	            display: flex;
  	            flex-direction: column;
  	            gap: 2px;
  	            }

  	            .trackit-card-functionality-title {
  	            color: rgba(255,226,205,0.92);
  	            font-size: 11px;
  	            font-weight: 950;
  	            line-height: 1.1;
  	            }

  	            .trackit-card-functionality-subtitle {
  	            color: rgba(226,232,240,0.42);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.08em;
  	            line-height: 1.1;
  	            }

  	            .trackit-card-functionality-help {
  	            width: 26px;
  	            height: 26px;
  	            border-radius: 11px;
  	            border: 1px solid rgba(120,49,15,0.54);
  	            background: rgba(0,0,0,0.52);
  	            color: rgba(255,216,191,0.86);
  	            font-size: 11px;
  	            font-weight: 950;
  	            cursor: pointer;
  	            }

  	            .trackit-card-functionality-help:hover {
  	            color: #ff9a3d;
  	            border-color: rgba(255,122,36,0.62);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.20);
  	            }

  	            .trackit-card-functionality-fuel-options {
  	            display: none;
  	            grid-template-columns: 1fr;
  	            gap: 8px;
  	            padding-left: 10px;
  	            border-left: 1px solid rgba(120,49,15,0.28);
  	            }

  	            .trackit-card-functionality-fuel-options.open {
  	            display: grid;
  	            }

  	            .trackit-card-functionality-gate-phone {
  	            display: none;
  	            padding: 8px;
  	            border: 1px solid rgba(120,49,15,0.30);
  	            border-radius: 14px;
  	            background: rgba(0,0,0,0.26);
  	            }

  	            .trackit-card-functionality-gate-phone.open {
  	            display: block;
  	            }

  	            .trackit-card-functionality-help-box {
  	            padding: 9px;
  	            border-radius: 14px;
  	            border: 1px solid rgba(120,49,15,0.42);
  	            background: rgba(0,0,0,0.42);
  	            }

  	            .trackit-card-functionality-help-title {
  	            color: #ffd8bf;
  	            font-size: 10px;
  	            font-weight: 950;
  	            margin-bottom: 4px;
  	            }

  	            .trackit-card-functionality-help-body {
  	            color: rgba(248,250,252,0.66);
  	            font-size: 9px;
  	            font-weight: 750;
  	            line-height: 1.35;
  	            }

  	            .trackit-card-edit-label {
  	            margin-bottom: 4px;
  	            color: rgba(255,193,148,0.64);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.10em;
  	            }

  	            .trackit-card-edit-input,
  	            .trackit-card-edit-textarea {
  	            width: 100%;
  	            min-width: 0;
  	            border: 1px solid rgba(120,49,15,0.42);
  	            outline: 0;
  	            border-radius: 12px;
  	            background:
  	            linear-gradient(145deg, rgba(0,0,0,0.62), rgba(10,12,13,0.92));
  	            color: rgba(248,250,252,0.88);
  	            font-size: 10px;
  	            font-weight: 780;
  	            padding: 8px 9px;
  	            box-sizing: border-box;
  	            }

  	            .trackit-card-edit-input:focus,
  	            .trackit-card-edit-textarea:focus {
  	            border-color: rgba(255,122,36,0.68);
  	            box-shadow:
  	            0 0 0 1px rgba(255,122,36,0.10),
  	            0 0 14px rgba(120,49,15,0.18);
  	            }

  	            .trackit-card-edit-textarea {
  	            min-height: 76px;
  	            max-height: 130px;
  	            resize: vertical;
  	            line-height: 1.35;
  	            }

  	            .trackit-card-color-wrap {
  	            display: grid;
  	            grid-template-columns: 1fr 32px;
  	            gap: 8px;
  	            align-items: center;
  	            }

  	            .trackit-card-edit-color {
  	            width: 100%;
  	            height: 34px;
  	            padding: 3px;
  	            border: 1px solid rgba(120,49,15,0.42);
  	            border-radius: 12px;
  	            background: rgba(0,0,0,0.62);
  	            cursor: pointer;
  	            }

  	            .trackit-card-color-preview {
  	            width: 32px;
  	            height: 32px;
  	            border-radius: 12px;
  	            border: 1px solid rgba(255,216,191,0.22);
  	            box-shadow:
  	            inset 0 1px 0 rgba(255,255,255,0.10),
  	            0 0 10px rgba(120,49,15,0.18);
  	            }

  	            .trackit-card-info-row {
  	            display: grid;
  	            grid-template-columns: 70px 1fr;
  	            gap: 7px;
  	            min-height: 20px;
  	            align-items: center;
  	            color: rgba(248,250,252,0.78);
  	            font-size: 10px;
  	            line-height: 1.25;
  	            padding: 0 2px;
  	            }

  	            .trackit-card-info-row + .trackit-card-info-row {
  	            margin-top: 4px;
  	            }

  	            .trackit-card-info-key {
  	            color: rgba(255,193,148,0.58);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.08em;
  	            }

  	            .trackit-card-info-value {
  	            min-width: 0;
  	            overflow: hidden;
  	            white-space: nowrap;
  	            text-overflow: ellipsis;
  	            font-weight: 760;
  	            }

  	            .trackit-card-placeholder-note {
  	            margin-top: 10px;
  	            padding: 8px;
  	            border-radius: 13px;
  	            background: rgba(0,0,0,0.42);
  	            border: 1px solid rgba(255,122,36,0.16);
  	            color: rgba(248,250,252,0.64);
  	            font-size: 10px;
  	            line-height: 1.35;
  	            font-weight: 720;
  	            }

  	            .trackit-card-actions {
  	            display: grid;
  	            grid-template-columns: 1fr 1fr;
  	            gap: 7px;
  	            padding: 0 10px 10px;
  	            }

  	            .trackit-card-actions.three-actions {
  	            grid-template-columns: 1fr;
  	            }

  	            .trackit-card-action-button {
  	            height: 32px;
  	            border: 0;
  	            outline: 0;
  	            border-radius: 14px;
  	            color: rgba(255,216,191,0.82);
  	            background: rgba(0,0,0,0.48);
  	            border: 1px solid rgba(255,122,36,0.22);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.055em;
  	            cursor: pointer;
  	            }

  	            .trackit-card-action-button:hover {
  	            color: #ffd8bf;
  	            border-color: rgba(255,122,36,0.58);
  	            box-shadow: 0 0 14px rgba(255,122,36,0.12);
  	            }

  	            .trackit-card-action-button.primary {
  	            color: #ffd8bf;
  	            background:
  	            linear-gradient(145deg, rgba(255,127,39,0.46), rgba(91,36,11,0.62));
  	            border-color: rgba(255,127,39,0.68);
  	            box-shadow:
  	            0 8px 20px rgba(255,96,24,0.12),
  	            inset 0 1px 0 rgba(255,221,195,0.16);
  	            }

  	            .trackit-card-children-block {
  	            margin-top: 8px;
  	            padding-top: 8px;
  	            border-top: 1px solid rgba(120,49,15,0.34);
  	            }

  	            .trackit-card-events-block {
  	            margin-top: 8px;
  	            padding-top: 8px;
  	            border-top: 1px solid rgba(120,49,15,0.34);
  	            }

  	            .trackit-card-events-actions {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 6px;
  	            }

  	            .trackit-card-event-button {
  	            width: 100%;
  	            min-height: 30px;
  	            border: 1px solid rgba(120,49,15,0.42);
  	            border-radius: 13px;
  	            background: rgba(0,0,0,0.36);
  	            color: rgba(255,216,191,0.86);
  	            font-size: 9px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.06em;
  	            cursor: pointer;
  	            }

  	            .trackit-card-event-button:hover {
  	            border-color: rgba(255,122,36,0.58);
  	            background: rgba(120,49,15,0.24);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.16);
  	            }

  	            .trackit-card-event-button.primary {
  	            background:
  	            linear-gradient(145deg, rgba(120,49,15,0.72), rgba(47,18,6,0.92));
  	            border-color: rgba(255,122,36,0.52);
  	            color: #ffd8bf;
  	            }

  	            .trackit-card-section-title {
  	            padding: 0 2px 6px 2px;
  	            color: rgba(255,193,148,0.62);
  	            font-size: 8px;
  	            font-weight: 950;
  	            text-transform: uppercase;
  	            letter-spacing: 0.10em;
  	            }

  	            .trackit-card-child-list {
  	            display: grid;
  	            grid-template-columns: 1fr;
  	            gap: 5px;
  	            }

  	            .trackit-card-child-row {
  	            width: 100%;
  	            min-height: 34px;
  	            display: grid;
  	            grid-template-columns: 1fr 22px;
  	            gap: 6px;
  	            align-items: center;
  	            padding: 6px 7px;
  	            border: 1px solid rgba(120,49,15,0.36);
  	            border-radius: 12px;
  	            background: rgba(0,0,0,0.34);
  	            color: #fff;
  	            cursor: pointer;
  	            text-align: left;
  	            }

  	            .trackit-card-child-row:hover {
  	            border-color: rgba(255,122,36,0.56);
  	            background: rgba(120,49,15,0.22);
  	            box-shadow: 0 0 10px rgba(120,49,15,0.16);
  	            }

  	            .trackit-card-child-main {
  	            min-width: 0;
  	            }

  	            .trackit-card-child-name {
  	            color: rgba(248,250,252,0.92);
  	            font-size: 10px;
  	            font-weight: 900;
  	            line-height: 1.1;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }

  	            .trackit-card-child-type {
  	            margin-top: 2px;
  	            color: rgba(226,232,240,0.52);
  	            font-size: 8px;
  	            font-weight: 800;
  	            line-height: 1.1;
  	            white-space: nowrap;
  	            overflow: hidden;
  	            text-overflow: ellipsis;
  	            }

  	            .trackit-card-child-count {
  	            width: 20px;
  	            height: 18px;
  	            border-radius: 999px;
  	            display: flex;
  	            align-items: center;
  	            justify-content: center;
  	            color: rgba(255,216,191,0.84);
  	            background: rgba(120,49,15,0.34);
  	            border: 1px solid rgba(120,49,15,0.60);
  	            font-size: 9px;
  	            font-weight: 950;
  	            }

  	            .trackit-card-empty-children {
  	            min-height: 34px;
  	            display: flex;
  	            align-items: center;
  	            padding: 7px;
  	            border: 1px dashed rgba(120,49,15,0.46);
  	            border-radius: 12px;
  	            background: rgba(0,0,0,0.24);
  	            color: rgba(248,250,252,0.58);
  	            font-size: 9px;
  	            font-weight: 800;
  	            line-height: 1.25;
  	            }
  	            `;

  	            let style = document.getElementById(STYLE_ID);

  	            if (!style) {
  	              style = document.createElement("style");
  	              style.id = STYLE_ID;
  	              document.head.appendChild(style);
  	            }

  	            style.textContent = css;

  	            // ============================================================
  	            // Build dropdown
  	            // ============================================================

  	            const dropdown = document.createElement("div");
  	            dropdown.className = "trackit-location-dropdown";

  	            const control = document.createElement("div");
  	            control.className = "trackit-location-control";

  	            const inputRow = document.createElement("div");
  	            inputRow.className = "trackit-input-row";

  	            const searchIcon = document.createElement("span");
  	            searchIcon.className = "trackit-search-icon";
  	            searchIcon.textContent = "⌕";

  	            const selectedIcon = document.createElement("img");
  	            selectedIcon.className = "trackit-selected-icon";
  	            selectedIcon.alt = "";

  	            const searchInput = document.createElement("input");
  	            searchInput.className = "trackit-search-input";
  	            searchInput.type = "text";
  	            searchInput.placeholder = "Search Location";
  	            searchInput.autocomplete = "off";
  	            searchInput.spellcheck = false;

  	            inputRow.appendChild(searchIcon);
  	            inputRow.appendChild(selectedIcon);
  	            inputRow.appendChild(searchInput);

  	            const clear = document.createElement("span");
  	            clear.className = "trackit-clear";
  	            clear.innerHTML = "&times;";

  	            const arrowHit = document.createElement("span");
  	            arrowHit.className = "trackit-arrow-hit";

  	            const arrowTriangle = document.createElement("span");
  	            arrowTriangle.className = "trackit-arrow-triangle";

  	            arrowHit.appendChild(arrowTriangle);

  	            const googleToggle = document.createElement("button");
  	            googleToggle.className = "trackit-google-toggle";
  	            googleToggle.type = "button";
  	            googleToggle.title = "Toggle Google Location Search";
  	            googleToggle.setAttribute("aria-label", "Toggle Google Location Search");
  	            googleToggle.setAttribute("aria-pressed", "false");
  	            googleToggle.innerHTML = `
  	            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  	            <circle cx="12" cy="12" r="8.5" stroke-width="2"></circle>
  	            <path d="M3.8 12h16.4" stroke-width="2" stroke-linecap="round"></path>
  	            <path d="M12 3.5c2.25 2.35 3.35 5.18 3.35 8.5S14.25 18.15 12 20.5" stroke-width="2" stroke-linecap="round"></path>
  	            <path d="M12 3.5C9.75 5.85 8.65 8.68 8.65 12s1.1 6.15 3.35 8.5" stroke-width="2" stroke-linecap="round"></path>
  	            </svg>
  	            `;

  	            control.appendChild(inputRow);
  	            control.appendChild(clear);
  	            control.appendChild(arrowHit);
  	            control.appendChild(googleToggle);

  	            const menu = document.createElement("div");
  	            menu.className = "trackit-menu";

  	            const actionCard = document.createElement("div");
  	            actionCard.className = "trackit-action-card";

  	            dropdown.appendChild(control);
  	            dropdown.appendChild(menu);
  	            dropdown.appendChild(actionCard);
  	            root.appendChild(dropdown);

  	            let selectedValue = null;
  	            let selectedItem = null;
  	            let selectedLabel = "";
  	            let selectedRowData = null;
  	            let visibleRows = [];
  	            let activeIndex = -1;
  	            let suppressFocusOpenUntil = 0;
  	            let menuResizeRaf = 0;
  	            let mapControlWatchRetry = null;
  	            let watchedMapControl = null;
  	            let mapControlMutationObserver = null;
  	            let mapControlResizeObserver = null;

  	            let locationSearchMode = "trackit";
  	            let googleAutocompleteService = null;
  	            let googlePlacesService = null;
  	            let googlePredictionRequestId = 0;
  	            let googlePredictions = [];

  	            buildTreeRows();
  	            markDefaultCollapsedStates();

  	            const existingSelectedObjectId = readSelectedLocationMarkerId();

  	            function readStoredLocationSearchMode() {
  	              try {
  	                const appData = getAppBag();
  	                const value = safeString(appData?.TrackITLocationSearchMode).trim().toLowerCase();

  	                return value === "google" ? "google": "trackit";
  	              } catch (_) {
  	                return "trackit";
  	              }
  	            }

  	            function writeStoredLocationSearchMode(mode) {
  	              try {
  	                const appData = getAppBag();

  	                if (appData) {
  	                  appData.TrackITLocationSearchMode = mode === "google" ? "google": "trackit";
  	                  refreshApp();
  	                }
  	              } catch (_) {}
  	            }

  	            function isGoogleSearchMode() {
  	              return locationSearchMode === "google";
  	            }

  	            function applyLocationSearchModeVisualState() {
  	              const googleMode = isGoogleSearchMode();

  	              dropdown.classList.toggle("google-mode", googleMode);
  	              googleToggle.setAttribute("aria-pressed", googleMode ? "true": "false");
  	              googleToggle.title = googleMode
  	              ? "Google Location Search is ON": "Google Location Search is OFF";

  	              searchInput.placeholder = googleMode
  	              ? `Search Google Location · ${GOOGLE_LOCATION_LABEL}`: "Search Location";
  	            }

  	            function setLocationSearchMode(mode) {
  	              const nextMode = mode === "google" ? "google": "trackit";

  	              if (locationSearchMode === nextMode) {
  	                applyLocationSearchModeVisualState();
  	                return;
  	              }

  	              locationSearchMode = nextMode;
  	              googlePredictions = [];
  	              activeIndex = -1;

  	              closeActionCard();
  	              applyLocationSearchModeVisualState();
  	              writeStoredLocationSearchMode(locationSearchMode);

  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	            }

  	            function toggleLocationSearchMode() {
  	              setLocationSearchMode(isGoogleSearchMode() ? "trackit": "google");
  	            }

  	            locationSearchMode = readStoredLocationSearchMode();
  	            applyLocationSearchModeVisualState();

  	            // ============================================================
  	            // Dropdown behaviour
  	            // ============================================================
  	            function getMapControlTopLimit() {
  	              try {
  	                let top = Infinity;

  	                MAP_CONTROL_SELECTORS.forEach(selector => {
  	                  document.querySelectorAll(selector).forEach(controlEl => {
  	                    const rect = controlEl.getBoundingClientRect();

  	                    if (rect.width > 0 && rect.height > 0 && rect.top > 0) {
  	                      top = Math.min(top, rect.top);
  	                    }
  	                  });
  	                });

  	                if (Number.isFinite(top)) {
  	                  return top - MAP_CONTROL_GAP_PX;
  	                }
  	              } catch (_) {}

  	              return window.innerHeight - 8;
  	            }

  	            function updateMenuHeightToBottom() {
  	              try {
  	                const rect = menu.getBoundingClientRect();
  	                const bottomLimit = getMapControlTopLimit();
  	                const availableHeight = Math.max(40, Math.floor(bottomLimit - rect.top));

  	                let contentHeight = 0;

  	                Array.from(menu.children).forEach(child => {
  	                  const childRect = child.getBoundingClientRect();

  	                  if (childRect && childRect.height) {
  	                    contentHeight += childRect.height;
  	                  }
  	                });

  	                contentHeight = Math.ceil(contentHeight + 8);

  	                const safeHeight = Math.max(40,
  	                  Math.min(contentHeight, availableHeight));

  	                menu.style.setProperty("--trackit-menu-height",
  	                  `${safeHeight}px`);
  	                menu.style.height = `${safeHeight}px`;
  	                menu.style.maxHeight = `${safeHeight}px`;

  	                growHubToMenuHeight(safeHeight);
  	              } catch (e) {
  	                console.warn("[TrackIT Location Dropdown] Could not calculate menu height.",
  	                  e);
  	              }
  	            }

  	            function growHubToMenuHeight(menuHeight) {
  	              try {
  	                if (!hubElement) return;
  	                if (!dropdown.classList.contains("open")) return;

  	                const hubRect = hubElement.getBoundingClientRect();
  	                const menuRect = menu.getBoundingClientRect();

  	                const neededBottom = menuRect.top + menuHeight;
  	                const neededHeight = Math.ceil(neededBottom - hubRect.top + 2);

  	                if (!Number.isFinite(neededHeight) || neededHeight <= 40) return;

  	                hubElement.style.height = `${neededHeight}px`;
  	                hubElement.style.minHeight = `${neededHeight}px`;
  	                hubElement.style.maxHeight = "none";
  	                hubElement.style.overflow = "visible";

  	                if (!hubElement.style.transition) {
  	                  hubElement.style.transition = "height 140ms ease, min-height 140ms ease";
  	                }
  	              } catch (_) {}
  	            }

  	            function resetHubHeight() {
  	              try {
  	                if (!hubElement || !hubOriginalStyle) return;

  	                hubElement.style.height = hubOriginalStyle.height;
  	                hubElement.style.minHeight = hubOriginalStyle.minHeight;
  	                hubElement.style.maxHeight = hubOriginalStyle.maxHeight;
  	                hubElement.style.overflow = hubOriginalStyle.overflow;
  	                hubElement.style.transition = hubOriginalStyle.transition;
  	              } catch (_) {}
  	            }

  	            function scheduleHubAndMenuResize() {
  	              try {
  	                if (!dropdown.classList.contains("open")) return;

  	                requestAnimationFrame(function () {
  	                  updateMenuHeightToBottom();
  	                });

  	                setTimeout(function () {
  	                  if (dropdown.classList.contains("open")) {
  	                    updateMenuHeightToBottom();
  	                  }
  	                },
  	                  180);
  	              } catch (_) {}
  	            }

  	            function scheduleMenuHeightRefresh() {
  	              try {
  	                if (!dropdown.classList.contains("open")) return;

  	                if (menuResizeRaf) {
  	                  cancelAnimationFrame(menuResizeRaf);
  	                }

  	                menuResizeRaf = requestAnimationFrame(function () {
  	                  menuResizeRaf = 0;
  	                  updateMenuHeightToBottom();
  	                });
  	              } catch (_) {}
  	            }

  	            function getActiveMapControlElement() {
  	              try {
  	                for (let i = 0; i < MAP_CONTROL_SELECTORS.length; i++) {
  	                  const controls = Array.from(document.querySelectorAll(MAP_CONTROL_SELECTORS[i]));

  	                  const found = controls.find(controlEl => {
  	                    const rect = controlEl.getBoundingClientRect();
  	                    return rect.width > 0 && rect.height > 0;
  	                  });

  	                  if (found) return found;
  	                }

  	                return null;
  	              } catch (_) {
  	                return null;
  	              }
  	            }

  	            function mapControlLayoutHandler() {
  	              scheduleMenuHeightRefresh();

  	              setTimeout(function () {
  	                scheduleMenuHeightRefresh();
  	              }, 180);
  	            }

  	            function bindMapControlLayoutListener() {
  	              try {
  	                if (mapControlWatchRetry) {
  	                  clearTimeout(mapControlWatchRetry);
  	                  mapControlWatchRetry = null;
  	                }

  	                const mapControl = getActiveMapControlElement();

  	                if (!mapControl) {
  	                  mapControlWatchRetry = setTimeout(bindMapControlLayoutListener, 250);
  	                  return;
  	                }

  	                if (watchedMapControl === mapControl) {
  	                  return;
  	                }

  	                if (watchedMapControl) {
  	                  try {
  	                    watchedMapControl.removeEventListener("click", mapControlLayoutHandler, true);
  	                  } catch (_) {}
  	                }

  	                if (mapControlMutationObserver) {
  	                  try {
  	                    mapControlMutationObserver.disconnect();
  	                  } catch (_) {}
  	                }

  	                if (mapControlResizeObserver) {
  	                  try {
  	                    mapControlResizeObserver.disconnect();
  	                  } catch (_) {}
  	                }

  	                watchedMapControl = mapControl;

  	                watchedMapControl.addEventListener("click", mapControlLayoutHandler, true);

  	                mapControlMutationObserver = new MutationObserver(mapControlLayoutHandler);
  	                mapControlMutationObserver.observe(watchedMapControl, {
  	                  attributes: true,
  	                  attributeFilter: ["class", "style"]
  	                });

  	                if (typeof ResizeObserver !== "undefined") {
  	                  mapControlResizeObserver = new ResizeObserver(mapControlLayoutHandler);
  	                  mapControlResizeObserver.observe(watchedMapControl);
  	                }

  	                scheduleMenuHeightRefresh();
  	              } catch (_) {}
  	            }

  	            function notifyCarvedShellLayout() {
  	              try {
  	                const bridge = window.__CarvedEdgeShapeDropdownBridge;

  	                if (bridge && typeof bridge.resizeTopShell === "function") {
  	                  bridge.resizeTopShell();
  	                }
  	              } catch (_) {}
  	            }

  	            function notifyCarvedShellReset() {
  	              try {
  	                const bridge = window.__CarvedEdgeShapeDropdownBridge;

  	                if (bridge && typeof bridge.resetTopShell === "function") {
  	                  bridge.resetTopShell();
  	                }
  	              } catch (_) {}
  	            }

  	            function openDropdown() {
  	              actionCard.classList.remove("open");
  	              dropdown.classList.add("open");
  	              scheduleHubAndMenuResize();
  	              notifyCarvedShellLayout();

  	              setTimeout(notifyCarvedShellLayout, 80);
  	              setTimeout(notifyCarvedShellLayout, 220);
  	            }

  	            function closeDropdown() {
  	              dropdown.classList.remove("open");
  	              activeIndex = -1;
  	              paintActiveRow();
  	              resetHubHeight();

  	              if (!actionCard.classList.contains("open")) {
  	                notifyCarvedShellReset();
  	              }
  	            }

  	            function closeActionCard() {
  	              actionCard.classList.remove("open");
  	              resetHubHeight();

  	              if (!dropdown.classList.contains("open")) {
  	                notifyCarvedShellReset();
  	              }
  	            }

  	            function toggleDropdownFromArrow() {
  	              suppressFocusOpenUntil = Date.now() + 250;

  	              if (dropdown.classList.contains("open")) {
  	                closeDropdown();

  	                try {
  	                  searchInput.blur();
  	                } catch (_) {}

  	                return;
  	              }

  	              searchInput.focus();
  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	              openDropdown();
  	            }

  	            function dispatchDropdownEvent(target, eventName, detail) {
  	              try {
  	                target.dispatchEvent(new CustomEvent(eventName, {
  	                  bubbles: true,
  	                  detail
  	                }));
  	              } catch (_) {}

  	              try {
  	                window.dispatchEvent(new CustomEvent(eventName, {
  	                  detail
  	                }));
  	              } catch (_) {}
  	            }

  	            function buildEventDetail(rowData, extra) {
  	              const location = rowData?.location || selectedItem || null;
  	              const value = rowData?.value || selectedValue || null;

  	              return Object.assign({
  	                value,
  	                item: location,
  	                location,
  	                rowData: rowData || selectedRowData || null,
  	                company: rowData?.companyEntry?.company || null,
  	                companyLabel: rowData?.companyEntry?.label || "",
  	                path: rowData?.path || "",
  	                source: "trackit-location-dropdown",
  	                actionMode: SEARCH_ACTION_MODE,
  	                placeholder: SEARCH_ACTION_MODE === "placeholder"
  	              }, extra || {});
  	            }

  	            function emitChange(rowData) {
  	              const location = rowData?.location || selectedItem || null;
  	              const value = rowData?.value || selectedValue || null;

  	              root.locationDropdownValue = value;
  	              root.locationDropdownItem = location;
  	              root.locationDropdownLocation = location;

  	              dispatchDropdownEvent(root, EVENT_LOCATION_CHANGE, {
  	                value,
  	                item: location,
  	                location
  	              });
  	            }

  	            function emitRouterEvent(eventName, rowData, extra) {
  	              dispatchDropdownEvent(root, eventName, buildEventDetail(rowData, extra));
  	            }

  	            function setQueryState() {
  	              const query = searchInput.value.trim();

  	              if (query) {
  	                dropdown.classList.add("has-query");
  	              } else {
  	                dropdown.classList.remove("has-query");
  	              }
  	            }

  	            function paintActiveRow() {
  	              menu.querySelectorAll(".trackit-location-item, .trackit-google-place-item").forEach(row => {
  	                row.classList.toggle("active", row.__rowIndex === activeIndex);
  	              });

  	              const active = menu.querySelector(".trackit-location-item.active, .trackit-google-place-item.active");

  	              if (active) {
  	                active.scrollIntoView({
  	                  block: "nearest"
  	                });
  	              }
  	            }

  	            function paintSelectedRow(rowData, shouldRunSelectionPipeline) {
  	              if (!rowData) return;

  	              const location = rowData.location;
  	              const value = rowData.value;
  	              const label = rowData.label;

  	              selectedValue = value;
  	              selectedItem = location;
  	              selectedLabel = label;
  	              selectedRowData = rowData;

  	              searchInput.value = label;
  	              selectedIcon.src = iconUrl(location);

  	              dropdown.classList.add("has-value");
  	              dropdown.classList.remove("has-query");

  	              menu.querySelectorAll(".trackit-location-item").forEach(element => {
  	                element.classList.toggle("selected", element.__locationValue === value);
  	              });

  	              if (shouldRunSelectionPipeline) {
  	                runLocationSelectionPipeline(rowData);
  	              }
  	            }

  	            function clearSelected(shouldWrite) {
  	              selectedValue = null;
  	              selectedItem = null;
  	              selectedLabel = "";
  	              selectedRowData = null;

  	              searchInput.value = "";
  	              selectedIcon.removeAttribute("src");

  	              dropdown.classList.remove("has-value");
  	              dropdown.classList.remove("has-query");

  	              menu.querySelectorAll(".trackit-location-item").forEach(element => {
  	                element.classList.remove("selected");
  	              });

  	              closeActionCard();
  	              renderMenu("");

  	              if (shouldWrite) {
  	                clearSelectedLocationFromAppData();

  	                root.locationDropdownValue = null;
  	                root.locationDropdownItem = null;
  	                root.locationDropdownLocation = null;

  	                dispatchDropdownEvent(root, EVENT_LOCATION_CHANGE, {
  	                  value: null,
  	                  item: null,
  	                  location: null
  	                });
  	              }
  	            }

  	            function toggleCompanyGroup(companyKey) {
  	              const collapsed = root.__trackitCollapsedLocationTree;
  	              collapsed[companyKey] = !collapsed[companyKey];

  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);

  	              requestAnimationFrame(() => {
  	                updateMenuHeightToBottom();
  	              });
  	            }

  	            function toggleTypeGroup(typeGroupKey) {
  	              const collapsed = root.__trackitCollapsedLocationTree;
  	              collapsed[typeGroupKey] = !collapsed[typeGroupKey];

  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);

  	              requestAnimationFrame(() => {
  	                updateMenuHeightToBottom();
  	              });
  	            }

  	            function toggleLocationNode(nodeKey) {
  	              const collapsed = root.__trackitCollapsedLocationTree;
  	              collapsed[nodeKey] = !collapsed[nodeKey];

  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);

  	              requestAnimationFrame(() => {
  	                updateMenuHeightToBottom();
  	              });
  	            }

  	            // ============================================================
  	            // Placeholder card / router
  	            // ============================================================


  	            function normalizeCardNumber(value) {
  	              const number = typeof value === "string" ? Number(value): value;

  	              return typeof number === "number" && !Number.isNaN(number) ? number: null;
  	            }

  	            function getLocationData(location) {
  	              return (
  	                location?.LocationData ||
  	                location?.locationData ||
  	                location?.Data ||
  	                location?.data ||
  	                {}
  	              );
  	            }

  	            function getCardType(location, rowData) {
  	              return (
  	                location?.Type ||
  	                location?.type ||
  	                location?.LocationType ||
  	                location?.locationType ||
  	                rowData?.type ||
  	                ""
  	              );
  	            }

  	            function getCardContactName(location) {
  	              const data = getLocationData(location);

  	              return (
  	                data?.ContactName ||
  	                data?.contactName ||
  	                data?.Contact ||
  	                data?.contact ||
  	                location?.ContactName ||
  	                location?.contactName ||
  	                ""
  	              );
  	            }

  	            function getCardContactNumber(location) {
  	              const data = getLocationData(location);

  	              return (
  	                data?.ContactNumber ||
  	                data?.contactNumber ||
  	                data?.PhoneNumber ||
  	                data?.phoneNumber ||
  	                data?.Phone ||
  	                data?.phone ||
  	                location?.ContactNumber ||
  	                location?.contactNumber ||
  	                location?.PhoneNumber ||
  	                location?.phoneNumber ||
  	                ""
  	              );
  	            }

  	            function getCardStoredAreaHa(location) {
  	              const data = getLocationData(location);
  	              const area = data?.Area || data?.area || location?.Area || location?.area || null;

  	              const hectares = normalizeCardNumber(
  	                area?.Hectares ||
  	                area?.hectares ||
  	                area?.Ha ||
  	                area?.ha ||
  	                area?.HA ||
  	                null
  	              );

  	              if (hectares !== null) return hectares;

  	              const m2 = normalizeCardNumber(
  	                area?.m2 ||
  	                area?.M2 ||
  	                area?.SquareMeters ||
  	                area?.squareMeters ||
  	                null
  	              );

  	              if (m2 !== null) return m2 / 10000;

  	              return null;
  	            }

  	            function getCardPolygonRing(location) {
  	              try {
  	                const poly =
  	                location?.Polygon ||
  	                location?.polygon ||
  	                location?.Boundary ||
  	                location?.boundary ||
  	                null;

  	                if (!poly) return null;

  	                let ring = null;

  	                if (Array.isArray(poly.coordinates) && Array.isArray(poly.coordinates[0])) {
  	                  ring = poly.coordinates[0];
  	                } else if (Array.isArray(poly.Coordinates) && Array.isArray(poly.Coordinates[0])) {
  	                  ring = poly.Coordinates[0];
  	                }

  	                if (!Array.isArray(ring) || ring.length < 3) return null;

  	                const out = ring
  	                .map(point => {
  	                  if (!Array.isArray(point) || point.length < 2) return null;

  	                  const lng = normalizeCardNumber(point[0]);
  	                  const lat = normalizeCardNumber(point[1]);

  	                  if (lat === null || lng === null) return null;

  	                  return [lng,
  	                    lat];
  	                })
  	                .filter(Boolean);

  	                return out.length >= 3 ? out: null;
  	              } catch (_) {
  	                return null;
  	              }
  	            }

  	            function getCardComputedAreaHa(location) {
  	              try {
  	                const ring = getCardPolygonRing(location);

  	                if (!ring || ring.length < 3) return null;

  	                const closed = ring.slice();
  	                const first = closed[0];
  	                const last = closed[closed.length - 1];

  	                if (first[0] !== last[0] || first[1] !== last[1]) {
  	                  closed.push([first[0], first[1]]);
  	                }

  	                const radius = 6378137;
  	                const toRad = value => value * Math.PI / 180;

  	                let total = 0;

  	                for (let i = 0; i < closed.length - 1; i++) {
  	                  const lng1 = closed[i][0];
  	                  const lat1 = closed[i][1];
  	                  const lng2 = closed[i + 1][0];
  	                  const lat2 = closed[i + 1][1];

  	                  const phi1 = toRad(lat1);
  	                  const phi2 = toRad(lat2);
  	                  const lambda1 = toRad(lng1);
  	                  const lambda2 = toRad(lng2);
  	                  const deltaLambda = lambda2 - lambda1;

  	                  const t = Math.tan(phi2 / 2 + Math.PI / 4);
  	                  const b = Math.tan(phi1 / 2 + Math.PI / 4);

  	                  total += Math.atan2(
  	                    Math.sin(deltaLambda) * b * t,
  	                    1 + b * t * Math.cos(deltaLambda)
  	                  );
  	                }

  	                const m2 = Math.abs(total * 2 * radius * radius);

  	                return m2 / 10000;
  	              } catch (_) {
  	                return null;
  	              }
  	            }

  	            function getCardAreaHa(location) {
  	              const stored = getCardStoredAreaHa(location);

  	              if (stored !== null) return stored;

  	              const computed = getCardComputedAreaHa(location);

  	              if (computed !== null) return computed;

  	              return null;
  	            }

  	            function formatCardAreaHa(value) {
  	              const number = normalizeCardNumber(value);

  	              if (number === null) return "—";

  	              return number.toFixed(2);
  	            }

  	            function cardInfoRow(label, value) {
  	              return `
  	              <div class="trackit-card-info-row">
  	              <div class="trackit-card-info-key">${escapeHtml(label)}</div>
  	              <div class="trackit-card-info-value" title="${escapeHtml(value)}">${escapeHtml(value || "—")}</div>
  	              </div>
  	              `;
  	            }

  	            function buildCardChildrenList(rowData) {
  	              const children = Array.isArray(rowData?.childrenNodes)
  	              ? rowData.childrenNodes: [];

  	              actionCard.__childRows = children;

  	              if (!children.length) {
  	                return `
  	                <div class="trackit-card-children-block">
  	                <div class="trackit-card-section-title">Sub-Locations</div>

  	                <div class="trackit-card-empty-children">
  	                Click Add Location to add Sub-Location
  	                </div>
  	                </div>
  	                `;
  	              }

  	              return `
  	              <div class="trackit-card-children-block">
  	              <div class="trackit-card-section-title">Sub-Locations</div>

  	              <div class="trackit-card-child-list">
  	              ${children.map((child, index) => {
  	                const childType = getCardType(child.location, child);
  	                const childLabel = child.label || getLocationLabel(child.location);
  	                const childCount = Array.isArray(child.childrenNodes)
  	                ? child.childrenNodes.length: 0;

  	                return `
  	                <button class="trackit-card-child-row" type="button" data-card-child-index="${index}">
  	                <div class="trackit-card-child-main">
  	                <div class="trackit-card-child-name">${escapeHtml(childLabel)}</div>
  	                <div class="trackit-card-child-type">${escapeHtml(childType || "Location")}</div>
  	                </div>

  	                <div class="trackit-card-child-count">${childCount}</div>
  	                </button>
  	                `;
  	              }).join("")}
  	              </div>
  	              </div>
  	              `;
  	            }

  	            function getCardFunctionality(location) {
  	              const data = getLocationData(location);

  	              return (
  	                data?.Functionality ||
  	                data?.functionality ||
  	                location?.Functionality ||
  	                location?.functionality ||
  	                {}
  	              );
  	            }

  	            function isEventsCaptureEnabled(location) {
  	              const functionality = getCardFunctionality(location);

  	              return (
  	                functionality?.EventsCapture === true ||
  	                functionality?.eventsCapture === true ||
  	                functionality?.Events === true ||
  	                functionality?.events === true
  	              );
  	            }

  	            function buildCardEventsBlock(location) {
  	              if (!isEventsCaptureEnabled(location)) return "";

  	              return `
  	              <div class="trackit-card-events-block">
  	              <div class="trackit-card-section-title">Events</div>

  	              <div class="trackit-card-events-actions">
  	              <button class="trackit-card-event-button" type="button" data-card-action="viewEvents">
  	              View Events
  	              </button>

  	              <button class="trackit-card-event-button primary" type="button" data-card-action="captureEvent">
  	              Capture Event
  	              </button>
  	              </div>
  	              </div>
  	              `;
  	            }

  	            function cloneCardLocation(location) {
  	              try {
  	                return JSON.parse(JSON.stringify(location || {}));
  	              } catch (_) {
  	                return {};
  	              }
  	            }

  	            function ensureCardLocationData(location) {
  	              if (!location) return {};

  	              if (!location.LocationData || typeof location.LocationData !== "object") {
  	                location.LocationData = {};
  	              }

  	              return location.LocationData;
  	            }

  	            function getCardDescription(location) {
  	              const data = getLocationData(location);

  	              return (
  	                data?.Description ||
  	                data?.description ||
  	                location?.Description ||
  	                location?.description ||
  	                ""
  	              );
  	            }

  	            function getCardColor(location) {
  	              const color = safeString(
  	                location?.Color ||
  	                location?.color ||
  	                location?.Colour ||
  	                location?.colour ||
  	                ""
  	              ).trim();

  	              if (/^#([0-9a-f]{6})$/i.test(color)) return color;

  	              return "#cc6633";
  	            }

  	            function filterCardPhoneValue(value) {
  	              let text = safeString(value);

  	              text = text.replace(/[^\d+]/g, "");

  	              if (text.includes("+")) {
  	                text = "+" + text.replace(/\+/g, "");
  	              }

  	              if (text.length > 1) {
  	                text = text.charAt(0) === "+"
  	                ? "+" + text.slice(1).replace(/\+/g, ""): text.replace(/\+/g, "");
  	              }

  	              return text;
  	            }

  	            function getCardEditField(name) {
  	              return actionCard.querySelector(`[data-card-edit-field="${name}"]`);
  	            }

  	            function getCardEditValue(name) {
  	              const field = getCardEditField(name);
  	              return field ? safeString(field.value): "";
  	            }

  	            function cardEditField(label, fieldHtml) {
  	              return `
  	              <div class="trackit-card-edit-field">
  	              <div class="trackit-card-edit-label">${escapeHtml(label)}</div>
  	              ${fieldHtml}
  	              </div>
  	              `;
  	            }

  	            function buildCardEditForm(rowData) {
  	              const location = rowData.location;

  	              const name = safeString(
  	                location?.Name ||
  	                location?.name ||
  	                rowData.label ||
  	                ""
  	              );

  	              const color = getCardColor(location);
  	              const description = safeString(getCardDescription(location));
  	              const contactName = safeString(getCardContactName(location));
  	              const contactNumber = safeString(getCardContactNumber(location));

  	              return `
  	              <div class="trackit-card-edit-tools">
  	              <button class="trackit-card-tool-button" type="button" data-card-action="editShape">
  	              ✦ Edit Shape
  	              </button>

  	              <button class="trackit-card-tool-button" type="button" data-card-action="setEntrance">
  	              ✦ Set Entrance
  	              </button>

  	              <button class="trackit-card-tool-button" type="button" data-card-action="setFunctionality">
  	              ⚙ Set Functionality
  	              </button>
  	              </div>

  	              <div class="trackit-card-edit-form">
  	              ${cardEditField("Name", `
  	                <input
  	                class="trackit-card-edit-input"
  	                type="text"
  	                value="${escapeHtml(name)}"
  	                data-card-edit-field="name"
  	                autocomplete="off"
  	                />
  	                `)}

  	              ${cardEditField("Color", `
  	                <div class="trackit-card-color-wrap">
  	                <input
  	                class="trackit-card-edit-color"
  	                type="color"
  	                value="${escapeHtml(color)}"
  	                data-card-edit-field="color"
  	                />

  	                <div class="trackit-card-color-preview" style="background:${escapeHtml(color)}"></div>
  	                </div>
  	                `)}

  	              ${cardEditField("Description", `
  	                <textarea
  	                class="trackit-card-edit-textarea"
  	                data-card-edit-field="description"
  	                autocomplete="off"
  	                >${escapeHtml(description)}</textarea>
  	                `)}

  	              ${cardEditField("Contact Name", `
  	                <input
  	                class="trackit-card-edit-input"
  	                type="text"
  	                value="${escapeHtml(contactName)}"
  	                data-card-edit-field="contactName"
  	                autocomplete="off"
  	                placeholder="Contact Name"
  	                />
  	                `)}

  	              ${cardEditField("Contact Number", `
  	                <input
  	                class="trackit-card-edit-input"
  	                type="tel"
  	                inputmode="tel"
  	                autocomplete="tel"
  	                value="${escapeHtml(contactNumber)}"
  	                data-card-edit-field="contactNumber"
  	                placeholder="+27821234567"
  	                />
  	                `)}
  	              </div>
  	              `;
  	            }

  	            function normalizeCardFunctionality(location) {
  	              const data = ensureCardLocationData(location);

  	              if (!data.Functionality || typeof data.Functionality !== "object") {
  	                data.Functionality = {};
  	              }

  	              const functionality = data.Functionality;

  	              return {
  	                eventsCapture:
  	                functionality.EventsCapture === true ||
  	                functionality.eventsCapture === true,

  	                fuelLogic:
  	                functionality.FuelLogic === true ||
  	                functionality.fuelLogic === true,

  	                loadLogic:
  	                functionality.LoadLogic === true ||
  	                functionality.loadLogic === true,

  	                gateLogic:
  	                functionality.GateLogic === true ||
  	                functionality.gateLogic === true,

  	                publicFuelStation:
  	                functionality.PublicFuelStation === true ||
  	                functionality.publicFuelStation === true,

  	                fuelDepot:
  	                functionality.FuelDepot === true ||
  	                functionality.fuelDepot === true,

  	                gatePhone: safeString(
  	                  functionality.GatePhone ||
  	                  functionality.gatePhone ||
  	                  ""
  	                )
  	              };
  	            }

  	            function functionalityToggleRow(key, title, subtitle, checked, helpText) {
  	              return `
  	              <div class="trackit-card-functionality-row">
  	              <label class="trackit-card-functionality-main">
  	              <input
  	              type="checkbox"
  	              data-card-functionality-key="${escapeHtml(key)}"
  	              ${checked ? "checked": ""}
  	              />

  	              <span class="trackit-card-functionality-box"></span>

  	              <span class="trackit-card-functionality-text">
  	              <span class="trackit-card-functionality-title">${escapeHtml(title)}</span>
  	              <span class="trackit-card-functionality-subtitle">${escapeHtml(subtitle)}</span>
  	              </span>
  	              </label>

  	              <button
  	              class="trackit-card-functionality-help"
  	              type="button"
  	              data-card-action="functionalityHelp"
  	              data-functionality-help-title="${escapeHtml(title)}"
  	              data-functionality-help-body="${escapeHtml(helpText)}"
  	              >?</button>
  	              </div>
  	              `;
  	            }

  	            function openLocationFunctionalityCard(rowData) {
  	              if (!rowData) return;

  	              const location = rowData.location;
  	              const functionality = normalizeCardFunctionality(location);

  	              actionCard.__functionalityRowData = rowData;

  	              actionCard.innerHTML = `
  	              <div class="trackit-action-card-header no-location-icon is-functionality">
  	              <div class="trackit-action-card-top-row">
  	              <button class="trackit-action-card-save" type="button" data-card-action="saveFunctionality" title="Save">🖫</button>
  	              <button class="trackit-action-card-undo" type="button" data-card-action="skipFunctionality" title="Skip">↩</button>
  	              <button class="trackit-action-card-close" type="button" data-card-close title="Close">×</button>
  	              </div>

  	              <div class="trackit-action-card-title-wrap">
  	              <div class="trackit-action-card-title">Location Functionality</div>
  	              <div class="trackit-action-card-edit-subtitle">Configure Logic</div>
  	              </div>
  	              </div>

  	              <div class="trackit-action-card-body">
  	              <div class="trackit-card-functionality-form">
  	              ${functionalityToggleRow(
  	                "eventsCapture",
  	                "Events Capture",
  	                "Capture events at this location",
  	                functionality.eventsCapture,
  	                "Allows this location to capture operational events such as arrivals, departures, delays, exceptions, inspections, notes, and activity records."
  	              )}

  	              ${functionalityToggleRow(
  	                "fuelLogic",
  	                "Fuel Logic",
  	                "Enable fuel behaviour",
  	                functionality.fuelLogic,
  	                "Adds fuel-related behaviour to this location. Choose either Public Fuel Station or Depot. Only one fuel mode can be active."
  	              )}

  	              <div class="trackit-card-functionality-fuel-options ${functionality.fuelLogic ? "open": ""}">
  	              ${functionalityToggleRow(
  	                "publicFuelStation",
  	                "Public Fuel Station",
  	                "External or commercial fuel point",
  	                functionality.publicFuelStation,
  	                "Marks the location as a public fuel station where vehicles can refuel through an external or commercial fuel provider."
  	              )}

  	              ${functionalityToggleRow(
  	                "fuelDepot",
  	                "Depot",
  	                "Internal controlled fuel point",
  	                functionality.fuelDepot,
  	                "Marks the location as a company depot or internal controlled fuel point."
  	              )}
  	              </div>

  	              ${functionalityToggleRow(
  	                "loadLogic",
  	                "Load Logic",
  	                "Enable loading behaviour",
  	                functionality.loadLogic,
  	                "Adds load handling behaviour to this location. Use this for loading points, offloading points, collection areas, dispatch areas, or stock movement."
  	              )}

  	              ${functionalityToggleRow(
  	                "gateLogic",
  	                "Gate Logic",
  	                "Enable gate contact logic",
  	                functionality.gateLogic,
  	                "Adds gate-related behaviour to this location. For now this captures a contact number for future gate communication or access-control functionality."
  	              )}

  	              <div class="trackit-card-functionality-gate-phone ${functionality.gateLogic ? "open": ""}">
  	              <div class="trackit-card-edit-label">Gate Phone</div>
  	              <input
  	              class="trackit-card-edit-input trackit-card-functionality-phone"
  	              type="tel"
  	              inputmode="tel"
  	              autocomplete="tel"
  	              value="${escapeHtml(functionality.gatePhone)}"
  	              placeholder="+27821234567"
  	              data-card-functionality-phone
  	              />
  	              </div>

  	              <div class="trackit-card-functionality-help-panel" data-card-functionality-help-panel></div>
  	              </div>
  	              </div>
  	              `;

  	              actionCard.classList.add("open");
  	              actionCard.classList.add("functionality-editing");

  	              notifyCarvedShellLayout();

  	              setTimeout(notifyCarvedShellLayout, 80);
  	              setTimeout(notifyCarvedShellLayout, 220);

  	              emitRouterEvent(ROUTER_EVENTS.functionalityRequested, rowData, {
  	                action: "openFunctionality",
  	                cardType: "location-functionality-card",
  	                placeholder: false
  	              });
  	            }

  	            function saveLocationFunctionalityCard(rowData) {
  	              if (!rowData) return;

  	              const location = rowData.location;
  	              const data = ensureCardLocationData(location);

  	              data.Functionality = data.Functionality || {};

  	              const functionality = data.Functionality;

  	              const eventsInput = actionCard.querySelector('[data-card-functionality-key="eventsCapture"]');
  	              const fuelInput = actionCard.querySelector('[data-card-functionality-key="fuelLogic"]');
  	              const publicInput = actionCard.querySelector('[data-card-functionality-key="publicFuelStation"]');
  	              const depotInput = actionCard.querySelector('[data-card-functionality-key="fuelDepot"]');
  	              const loadInput = actionCard.querySelector('[data-card-functionality-key="loadLogic"]');
  	              const gateInput = actionCard.querySelector('[data-card-functionality-key="gateLogic"]');
  	              const gatePhoneInput = actionCard.querySelector("[data-card-functionality-phone]");

  	              functionality.EventsCapture = !!eventsInput?.checked;
  	              functionality.FuelLogic = !!fuelInput?.checked;
  	              functionality.LoadLogic = !!loadInput?.checked;
  	              functionality.GateLogic = !!gateInput?.checked;

  	              functionality.PublicFuelStation = functionality.FuelLogic && !!publicInput?.checked;
  	              functionality.FuelDepot = functionality.FuelLogic && !!depotInput?.checked;

  	              functionality.FuelMode = functionality.FuelLogic
  	              ? functionality.PublicFuelStation
  	              ? "publicFuelStation": functionality.FuelDepot
  	              ? "depot": "": "";

  	              functionality.GatePhone = functionality.GateLogic
  	              ? filterCardPhoneValue(gatePhoneInput?.value || ""): "";

  	              writeSelectedLocationToAppData(location);

  	              console.groupCollapsed("[TrackIT Location Dropdown] Save Functionality");
  	              console.log("Location:", location);
  	              console.log("Functionality:", functionality);
  	              console.groupEnd();

  	              emitRouterEvent(ROUTER_EVENTS.functionalityRequested, rowData, {
  	                action: "saveFunctionality",
  	                cardType: "location-functionality-card",
  	                functionality
  	              });

  	              actionCard.classList.remove("functionality-editing");
  	              openLocationEditCard(rowData);
  	            }

  	            function updateFunctionalityVisibility() {
  	              const fuelInput = actionCard.querySelector('[data-card-functionality-key="fuelLogic"]');
  	              const publicInput = actionCard.querySelector('[data-card-functionality-key="publicFuelStation"]');
  	              const depotInput = actionCard.querySelector('[data-card-functionality-key="fuelDepot"]');
  	              const gateInput = actionCard.querySelector('[data-card-functionality-key="gateLogic"]');

  	              const fuelOptions = actionCard.querySelector(".trackit-card-functionality-fuel-options");
  	              const gatePhone = actionCard.querySelector(".trackit-card-functionality-gate-phone");

  	              if (fuelOptions) {
  	                fuelOptions.classList.toggle("open", !!fuelInput?.checked);
  	              }

  	              if (!fuelInput?.checked) {
  	                if (publicInput) publicInput.checked = false;
  	                if (depotInput) depotInput.checked = false;
  	              }

  	              if (gatePhone) {
  	                gatePhone.classList.toggle("open", !!gateInput?.checked);
  	              }

  	              if (!gateInput?.checked) {
  	                const gatePhoneInput = actionCard.querySelector("[data-card-functionality-phone]");
  	                if (gatePhoneInput) gatePhoneInput.value = "";
  	              }

  	              notifyCarvedShellLayout();
  	            }

  	            function getLocationFunctionalityForPopup(location) {
  	              const data = ensureCardLocationData(location);
  	              const functionality =
  	              data.Functionality ||
  	              data.functionality ||
  	              location?.Functionality ||
  	              location?.functionality ||
  	              {};

  	              return {
  	                eventsCapture:
  	                functionality.EventsCapture === true ||
  	                functionality.eventsCapture === true,

  	                fuelLogic:
  	                functionality.FuelLogic === true ||
  	                functionality.fuelLogic === true,

  	                publicFuelStation:
  	                functionality.PublicFuelStation === true ||
  	                functionality.publicFuelStation === true,

  	                fuelDepot:
  	                functionality.FuelDepot === true ||
  	                functionality.fuelDepot === true,

  	                loadLogic:
  	                functionality.LoadLogic === true ||
  	                functionality.loadLogic === true,

  	                gateLogic:
  	                functionality.GateLogic === true ||
  	                functionality.gateLogic === true,

  	                gatePhone: safeString(
  	                  functionality.GatePhone ||
  	                  functionality.gatePhone ||
  	                  ""
  	                )
  	              };
  	            }

  	            function openOriginalFunctionalityPopupFromCard(rowData) {
  	              if (!rowData || !rowData.location) return;

  	              const location = rowData.location;
  	              const functionality = getLocationFunctionalityForPopup(location);

  	              createState.functionality.eventsCapture = functionality.eventsCapture;
  	              createState.functionality.fuelLogic = functionality.fuelLogic;
  	              createState.functionality.publicFuelStation = functionality.publicFuelStation;
  	              createState.functionality.fuelDepot = functionality.fuelDepot;
  	              createState.functionality.loadLogic = functionality.loadLogic;
  	              createState.functionality.gateLogic = functionality.gateLogic;
  	              createState.functionality.gatePhone = functionality.gatePhone;

  	              createState.modalMode = "functionality";
  	              createState.helpTopic = "";

  	              if (window.__CarvedEdgeShapeUI) {
  	                window.__CarvedEdgeShapeUI.pendingSaveLocation = location;
  	                window.__CarvedEdgeShapeUI.pendingFunctionalityRowData = rowData;
  	                window.__CarvedEdgeShapeUI.pendingFunctionalitySource = "location-card";

  	                window.__CarvedEdgeShapeUI.afterFunctionalitySave = function () {
  	                  try {
  	                    openLocationEditCard(rowData);
  	                  } catch (error) {
  	                    console.warn("[TrackIT Location Dropdown] Could not return to edit card after functionality save.", error);
  	                  }
  	                };
  	              }

  	              const carvedRoot =
  	              bridge?.uiRoot ||
  	              document.getElementById("fif-carved-edge-shape-ui");

  	              const carvedUserMode = bridge?.userMode || userMode;

  	              if (!carvedRoot) {
  	                console.warn("[TrackIT Location Dropdown] Could not open original functionality popup. Carved UI root not found.");
  	                return;
  	              }

  	              renderModal(carvedRoot, carvedUserMode);
  	            }

  	            function openLocationEditCard(rowData) {
  	              if (!rowData) return;

  	              const location = rowData.location;

  	              actionCard.__editRowData = rowData;
  	              actionCard.__editSnapshot = cloneCardLocation(location);

  	              actionCard.innerHTML = `
  	              <div class="trackit-action-card-header no-location-icon is-editing">
  	              <div class="trackit-action-card-top-row">
  	              <button class="trackit-action-card-delete" type="button" data-card-action="deleteLocation" title="Delete">🗑</button>
  	              <button class="trackit-action-card-undo" type="button" data-card-action="undoEdit" title="Undo">↩</button>
  	              <button class="trackit-action-card-save" type="button" data-card-action="saveEdit" title="Save">🖫</button>
  	              <button class="trackit-action-card-close" type="button" data-card-close title="Close">×</button>
  	              </div>

  	              <div class="trackit-action-card-title-wrap">
  	              <div class="trackit-action-card-title">${escapeHtml(rowData.label)}</div>
  	              <div class="trackit-action-card-edit-subtitle">Edit Location</div>
  	              </div>
  	              </div>

  	              <div class="trackit-action-card-body">
  	              ${buildCardEditForm(rowData)}
  	              </div>
  	              `;

  	              actionCard.classList.add("open");
  	              actionCard.classList.add("editing");

  	              notifyCarvedShellLayout();

  	              setTimeout(notifyCarvedShellLayout, 80);
  	              setTimeout(notifyCarvedShellLayout, 220);

  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "openEdit",
  	                cardType: "location-edit-card",
  	                placeholder: true
  	              });
  	            }

  	            function restoreLocationObject(target, snapshot) {
  	              if (!target || !snapshot) return;

  	              try {
  	                Object.keys(target).forEach(key => {
  	                  delete target[key];
  	                });

  	                Object.keys(snapshot).forEach(key => {
  	                  target[key] = snapshot[key];
  	                });
  	              } catch (_) {}
  	            }

  	            function saveLocationEditCard(rowData) {
  	              if (!rowData) return;

  	              const location = rowData.location;
  	              const data = ensureCardLocationData(location);

  	              const name = getCardEditValue("name").trim();
  	              const color = getCardEditValue("color").trim() || "#cc6633";
  	              const description = getCardEditValue("description");
  	              const contactName = getCardEditValue("contactName").trim();
  	              const contactNumber = filterCardPhoneValue(getCardEditValue("contactNumber"));

  	              if (name) {
  	                location.Name = name;
  	                rowData.label = name;
  	                selectedLabel = name;
  	                searchInput.value = name;
  	              }

  	              location.Color = color;

  	              data.Description = description;
  	              data.ContactName = contactName;
  	              data.ContactNumber = contactNumber;

  	              writeSelectedLocationToAppData(location);

  	              console.groupCollapsed("[TrackIT Location Dropdown] Save Edit Placeholder");
  	              console.log("Location:", location);
  	              console.log("Row Data:", rowData);
  	              console.log("Saved Fields:", {
  	                name,
  	                color,
  	                description,
  	                contactName,
  	                contactNumber
  	              });
  	              console.groupEnd();

  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "saveEdit",
  	                cardType: "location-edit-card",
  	                placeholder: true
  	              });

  	              actionCard.classList.remove("editing");
  	              openLocationActionCard(rowData);
  	            }

  	            function undoLocationEditCard(rowData) {
  	              if (!rowData) return;

  	              const snapshot = actionCard.__editSnapshot;

  	              if (snapshot) {
  	                restoreLocationObject(rowData.location, snapshot);

  	                const restoredName = safeString(
  	                  rowData.location?.Name ||
  	                  rowData.location?.name ||
  	                  rowData.label ||
  	                  ""
  	                );

  	                if (restoredName) {
  	                  rowData.label = restoredName;
  	                  selectedLabel = restoredName;
  	                  searchInput.value = restoredName;
  	                }

  	                writeSelectedLocationToAppData(rowData.location);
  	              }

  	              console.groupCollapsed("[TrackIT Location Dropdown] Undo Edit");
  	              console.log("Location:", rowData.location);
  	              console.log("Row Data:", rowData);
  	              console.groupEnd();

  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "undoEdit",
  	                cardType: "location-edit-card",
  	                placeholder: true
  	              });

  	              actionCard.classList.remove("editing");
  	              openLocationActionCard(rowData);
  	            }

  	            function deleteLocationEditCard(rowData) {
  	              if (!rowData) return;

  	              console.groupCollapsed("[TrackIT Location Dropdown] Delete Placeholder");
  	              console.log("Location:", rowData.location);
  	              console.log("Row Data:", rowData);
  	              console.warn("Delete is currently a placeholder. Hook this into the real delete pipeline later.");
  	              console.groupEnd();

  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "deleteLocation",
  	                cardType: "location-edit-card",
  	                placeholder: true
  	              });
  	            }

  	            function editShapePlaceholder(rowData) {
  	              console.groupCollapsed("[TrackIT Location Dropdown] Edit Shape Placeholder");
  	              console.log("Location:", rowData?.location || null);
  	              console.log("Row Data:", rowData || null);
  	              console.groupEnd();

  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "editShape",
  	                cardType: "location-edit-card",
  	                placeholder: true
  	              });
  	            }

  	            function setEntrancePlaceholder(rowData) {
  	              console.groupCollapsed("[TrackIT Location Dropdown] Set Entrance Placeholder");
  	              console.log("Location:", rowData?.location || null);
  	              console.log("Row Data:", rowData || null);
  	              console.groupEnd();

  	              emitRouterEvent(ROUTER_EVENTS.editRequested, rowData, {
  	                action: "setEntrance",
  	                cardType: "location-edit-card",
  	                placeholder: true
  	              });
  	            }

  	            function openLocationActionCard(rowData) {
  	              if (!rowData) return;

  	              const location = rowData.location;
  	              const type = getCardType(location, rowData);
  	              const companyLabel = rowData.companyEntry?.label || "";
  	              const contactName = safeString(getCardContactName(location)).trim();
  	              const contactNumber = safeString(getCardContactNumber(location)).trim();
  	              const areaHa = getCardAreaHa(location);
  	              const eventsBlockHtml = buildCardEventsBlock(location);
  	              const childrenListHtml = buildCardChildrenList(rowData);

  	              let infoRows = "";

  	              infoRows += cardInfoRow("Company", companyLabel || "—");
  	              infoRows += cardInfoRow("Type", type || "—");
  	              infoRows += cardInfoRow("Area (ha)", formatCardAreaHa(areaHa));

  	              if (contactName) {
  	                infoRows += cardInfoRow("Contact Name", contactName);
  	              }

  	              if (contactNumber) {
  	                infoRows += cardInfoRow("Contact Number", contactNumber);
  	              }

  	              actionCard.innerHTML = `
  	              <div class="trackit-action-card-header no-location-icon">
  	              <div class="trackit-action-card-top-row">
  	              <button class="trackit-action-card-edit" type="button" data-card-action="edit" title="Edit">✎</button>
  	              <button class="trackit-action-card-close" type="button" data-card-close title="Close">×</button>
  	              </div>

  	              <div class="trackit-action-card-title-wrap">
  	              <div class="trackit-action-card-title">${escapeHtml(rowData.label)}</div>
  	              </div>
  	              </div>

  	              <div class="trackit-action-card-body">
  	              ${infoRows}
  	              ${eventsBlockHtml}
  	              ${childrenListHtml}
  	              </div>
  	              `;

  	              actionCard.classList.add("open");

  	              notifyCarvedShellLayout();

  	              setTimeout(notifyCarvedShellLayout, 80);
  	              setTimeout(notifyCarvedShellLayout, 220);

  	              console.groupCollapsed("[TrackIT Location Dropdown] Location Card Opened");
  	              console.log("Location:", location);
  	              console.log("Row Data:", rowData);
  	              console.log("Company:", rowData.companyEntry?.company || null);
  	              console.log("Contact Name:", contactName);
  	              console.log("Contact Number:", contactNumber);
  	              console.log("Area ha:", areaHa);
  	              console.groupEnd();

  	              emitRouterEvent(ROUTER_EVENTS.cardRequested, rowData, {
  	                cardType: "location-card",
  	                visibleCardOpened: true
  	              });
  	            }

  	            function openLocationEventsManager(rowData) {
  	              if (!rowData || !rowData.location) {
  	                window.alert("No location selected.");
  	                return;
  	              }

  	              const location = rowData.location;
  	              const locationId = safeString(getLocationValue(location)).trim();
  	              const locationLabel = safeString(getLocationLabel(location) || rowData.label || locationId).trim();

  	              if (!locationId) {
  	                window.alert("Selected location has no objectId.");
  	                return;
  	              }

  	              const EVENTS_MOUNT_ID = "trackit-location-events-manager";
  	              const EVENTS_STYLE_ID = "trackit-location-events-manager-style";
  	              const TABLE_JOB_ENTRIES = "JobEntries";
  	              const TABLE_LOCATIONS = "Locations";
  	              const LOCATION_JOBS_RELATION_FIELD = "Jobs";

  	              const existing = document.getElementById(EVENTS_MOUNT_ID);

  	              if (existing) {
  	                existing.remove();
  	              }

  	              function hasBackendlessData() {
  	                return !!(
  	                  typeof Backendless !== "undefined" &&
  	                  Backendless &&
  	                  Backendless.Data &&
  	                  typeof Backendless.Data.of === "function"
  	                );
  	              }

  	              function injectEventsStyles() {
  	                if (document.getElementById(EVENTS_STYLE_ID)) return;

  	                const style = document.createElement("style");
  	                style.id = EVENTS_STYLE_ID;
  	                style.textContent = `
  	                #${EVENTS_MOUNT_ID} {
  	                position: fixed;
  	                inset: 0;
  	                z-index: 2147483647;
  	                overflow: hidden;
  	                background: rgba(0,0,0,0.85);
  	                padding: 10px;
  	                box-sizing: border-box;
  	                font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-root {
  	                padding: 12px;
  	                box-sizing: border-box;
  	                color: #f0f0f0;
  	                max-width: 1700px;
  	                margin: 0 auto;
  	                height: calc(100vh - 20px);
  	                display: flex;
  	                flex-direction: column;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-card {
  	                border: 1px solid #333;
  	                border-radius: 14px;
  	                background: rgba(16,16,16,0.94);
  	                padding: 12px;
  	                box-sizing: border-box;
  	                display: flex;
  	                flex-direction: column;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                height: 100%;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-row {
  	                display: flex;
  	                gap: 8px;
  	                align-items: center;
  	                flex-wrap: wrap;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-actions {
  	                display: flex;
  	                align-items: center;
  	                justify-content: space-between;
  	                gap: 10px;
  	                flex-wrap: wrap;
  	                margin-top: 10px;
  	                flex: 0 0 auto;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-title {
  	                font-size: 1.05rem;
  	                font-weight: 900;
  	                color: #fff;
  	                margin: 0;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-sub {
  	                font-size: 0.78rem;
  	                color: #b0b0b0;
  	                margin-top: 2px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-badge {
  	                font-size: 0.72rem;
  	                padding: 4px 10px;
  	                border-radius: 999px;
  	                background: #2a2f38;
  	                color: #d2d7de;
  	                white-space: nowrap;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-divider {
  	                height: 1px;
  	                background: #2a2a2a;
  	                margin: 12px 0;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-search-wrap {
  	                margin: 10px 0 12px 0;
  	                flex: 0 0 auto;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-search {
  	                width: 100%;
  	                box-sizing: border-box;
  	                border: 1px solid #4a4a4a;
  	                background: #0f0f0f;
  	                color: #fff;
  	                border-radius: 10px;
  	                padding: 10px 12px;
  	                font-size: 0.90rem;
  	                outline: none;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-search:focus {
  	                border-color: #CC6633;
  	                box-shadow: 0 0 0 1px #CC6633 inset;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn {
  	                border-radius: 999px;
  	                border: 1px solid #555;
  	                background: #333;
  	                color: #e0e0e0;
  	                font-size: 0.85rem;
  	                padding: 8px 12px;
  	                cursor: pointer;
  	                user-select: none;
  	                white-space: nowrap;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn:hover {
  	                background: #3c3c3c;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-primary {
  	                background: #CC6633;
  	                border-color: #CC6633;
  	                color: #fff;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-primary:hover {
  	                background: #e0733a;
  	                border-color: #e0733a;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-danger {
  	                background: #7f1d1d;
  	                border-color: #a11f1f;
  	                color: #fff;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-danger:hover {
  	                background: #991b1b;
  	                border-color: #b91c1c;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-btn-disabled {
  	                opacity: 0.55;
  	                cursor: not-allowed;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-events-box {
  	                border: 1px solid #333;
  	                border-radius: 12px;
  	                background: #101010;
  	                padding: 0;
  	                box-sizing: border-box;
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                display: flex;
  	                flex-direction: column;
  	                overflow: hidden;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-tablewrap {
  	                flex: 1 1 auto;
  	                min-height: 0;
  	                overflow: auto;
  	                border-radius: 12px;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table {
  	                width: 100%;
  	                border-collapse: collapse;
  	                min-width: 1650px;
  	                background: #141414;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table th,
  	                #${EVENTS_MOUNT_ID} table.jel-table td {
  	                padding: 10px 10px;
  	                border-bottom: 1px solid #242424;
  	                text-align: left;
  	                vertical-align: top;
  	                font-size: 0.9rem;
  	                }

  	                #${EVENTS_MOUNT_ID} table.jel-table th {
  	                position: sticky;
  	                top: 0;
  	                background: #1c1c1c;
  	                z-index: 2;
  	                font-weight: 800;
  	                color: #f2f2f2;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-muted {
  	                color: #a0a4aa;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-empty {
  	                color: #a0a4aa;
  	                font-size: 0.95rem;
  	                padding: 10px 12px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-cell {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 4px;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-big {
  	                font-size: 0.95rem;
  	                font-weight: 900;
  	                color: #ffffff;
  	                line-height: 1.15;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-small {
  	                font-size: 0.80rem;
  	                color: #c1c6ce;
  	                line-height: 1.15;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-smallline {
  	                display: block;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-dash {
  	                color: #80858f;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-num {
  	                font-variant-numeric: tabular-nums;
  	                }

  	                #${EVENTS_MOUNT_ID} .jel-actions-cell {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 6px;
  	                min-width: 96px;
  	                }
  	                `;

  	                document.head.appendChild(style);
  	              }

  	              function pick(obj, keys) {
  	                if (!obj || typeof obj !== "object") return "";

  	                for (let i = 0; i < keys.length; i++) {
  	                  const value = obj[keys[i]];

  	                  if (value === undefined || value === null) continue;

  	                  const text = safeString(value).trim();

  	                  if (text) return text;
  	                }

  	                return "";
  	              }

  	              function numberPick(obj, keys) {
  	                if (!obj || typeof obj !== "object") return null;

  	                for (let i = 0; i < keys.length; i++) {
  	                  const value = obj[keys[i]];

  	                  if (value === undefined || value === null || value === "") continue;

  	                  const number = Number(value);

  	                  if (Number.isFinite(number)) return number;
  	                }

  	                return null;
  	              }

  	              function pad2(value) {
  	                const number = Number(value);

  	                if (!Number.isFinite(number)) return "00";

  	                return number < 10 ? `0${number}`: String(number);
  	              }

  	              function asDate(value) {
  	                if (!value) return null;

  	                if (value instanceof Date && !isNaN(value.getTime())) return value;

  	                const date = new Date(value);

  	                if (!isNaN(date.getTime())) return date;

  	                return null;
  	              }

  	              function formatDate(value) {
  	                const date = asDate(value);

  	                if (!date) return "";

  	                return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
  	              }

  	              function formatTime(value) {
  	                const date = asDate(value);

  	                if (!date) return "";

  	                return `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
  	              }

  	              function formatDuration(seconds) {
  	                const value = Number(seconds);

  	                if (!Number.isFinite(value) || value < 0) return "";

  	                const totalSeconds = Math.round(value);
  	                const hours = Math.floor(totalSeconds / 3600);
  	                const minutes = Math.floor((totalSeconds % 3600) / 60);

  	                if (hours > 0) return `${hours}h ${minutes}m`;

  	                return `${minutes}m`;
  	              }

  	              function getBestTimeIn(job) {
  	                return pick(job, [
  	                  "TimeIn",
  	                  "timeIn",
  	                  "StartTime",
  	                  "startTime",
  	                  "EnterTime",
  	                  "enterTime",
  	                  "EntryTime",
  	                  "entryTime",
  	                  "GeofenceEnterTime",
  	                  "geofenceEnterTime"
  	                ]);
  	              }

  	              function getBestTimeOut(job) {
  	                return pick(job, [
  	                  "TimeOut",
  	                  "timeOut",
  	                  "EndTime",
  	                  "endTime",
  	                  "ExitTime",
  	                  "exitTime",
  	                  "GeofenceExitTime",
  	                  "geofenceExitTime"
  	                ]);
  	              }

  	              function getBestDate(job) {
  	                return (
  	                  pick(job, ["DateISO", "dateISO", "Date", "date"]) ||
  	                  formatDate(getBestTimeIn(job)) ||
  	                  formatDate(getBestTimeOut(job)) ||
  	                  ""
  	                );
  	              }

  	              function getBestDuration(job) {
  	                const direct = numberPick(job, [
  	                  "DurationSeconds",
  	                  "durationSeconds",
  	                  "DurationSec",
  	                  "durationSec",
  	                  "Duration",
  	                  "duration",
  	                  "TimeSeconds",
  	                  "timeSeconds"
  	                ]);

  	                if (direct !== null) {
  	                  return direct > 1000000 ? Math.round(direct / 1000): direct;
  	                }

  	                const timeIn = asDate(getBestTimeIn(job));
  	                const timeOut = asDate(getBestTimeOut(job));

  	                if (timeIn && timeOut) {
  	                  const ms = timeOut.getTime() - timeIn.getTime();

  	                  if (ms >= 0) return Math.round(ms / 1000);
  	                }

  	                return null;
  	              }

  	              function getBestArea(job) {
  	                const fromJob = numberPick(job, [
  	                  "Area",
  	                  "area",
  	                  "FieldArea",
  	                  "fieldArea",
  	                  "LocationArea",
  	                  "locationArea"
  	                ]);

  	                if (fromJob !== null) return fromJob;

  	                return numberPick(location, [
  	                  "Area",
  	                  "area",
  	                  "FieldArea",
  	                  "fieldArea",
  	                  "Size",
  	                  "size",
  	                  "Hectares",
  	                  "hectares"
  	                ]);
  	              }

  	              function normalizeApplications(job) {
  	                const apps = Array.isArray(job?.Applications) ? job.Applications: [];

  	                return apps.map(app => {
  	                  return {
  	                    Type: pick(app, ["Type", "type", "ApplicationType", "applicationType"]),
  	                    Product: pick(app, ["Product", "product"]),
  	                    RateText: pick(app, ["RateText", "rateText", "Rate", "rate"]),
  	                    Registration: pick(app, ["Registration", "registration"]),
  	                    Trailer: pick(app, ["Trailer", "trailer"])
  	                  };
  	                }).filter(app => {
  	                  return app.Type || app.Product || app.RateText || app.Registration || app.Trailer;
  	                });
  	              }

  	              function buildEventText(job) {
  	                const apps = normalizeApplications(job);

  	                if (!apps.length) {
  	                  return pick(job, ["Event", "event", "Type", "type", "Name", "name"]) || "Event";
  	                }

  	                return apps.map(app => {
  	                  const type = app.Type || "Event";
  	                  const reg = app.Registration || app.Trailer || "";

  	                  return reg ? `${type} - ${reg}`: type;
  	                }).join(" | ");
  	              }

  	              function buildProductText(job) {
  	                return normalizeApplications(job).map(app => {
  	                  if (app.Product && app.RateText) return `${app.Product} @ ${app.RateText}`;
  	                  return app.Product || app.RateText || "";
  	                }).filter(Boolean).join(" | ");
  	              }

  	              function calculateFuelUsed(job) {
  	                if (!job || typeof job !== "object") return null;

  	                const consumedIn = numberPick(job, ["FuelConsumedIn", "fuelConsumedIn"]);
  	                const consumedOut = numberPick(job, ["FuelConsumedOut", "fuelConsumedOut"]);

  	                if (consumedIn !== null && consumedOut !== null) {
  	                  const delta = consumedOut - consumedIn;
  	                  if (Number.isFinite(delta) && delta > 0) return delta;
  	                }

  	                const volumeIn = numberPick(job, ["FuelVolumeIn", "fuelVolumeIn"]);
  	                const volumeOut = numberPick(job, ["FuelVolumeOut", "fuelVolumeOut"]);

  	                if (volumeIn !== null && volumeOut !== null) {
  	                  const delta = volumeIn - volumeOut;
  	                  if (Number.isFinite(delta) && delta > 0) return delta;
  	                }

  	                const levelIn = numberPick(job, ["FuelLevelIn", "fuelLevelIn"]);
  	                const levelOut = numberPick(job, ["FuelLevelOut", "fuelLevelOut"]);

  	                if (levelIn !== null && levelOut !== null) {
  	                  const delta = levelIn - levelOut;
  	                  if (Number.isFinite(delta) && delta > 0) return delta;
  	                }

  	                const savedFuel = numberPick(job, ["Fuel", "fuel", "FuelUsed", "fuelUsed"]);

  	                if (savedFuel !== null && savedFuel > 0) return savedFuel;

  	                return null;
  	              }

  	              function getFuelText(job) {
  	                const fuel = calculateFuelUsed(job);

  	                if (fuel === null) return "";

  	                return Number(fuel).toFixed(2);
  	              }

  	              function buildMultilineEvent(job) {
  	                const apps = normalizeApplications(job);
  	                let headline = "";
  	                const extras = [];

  	                apps.forEach(app => {
  	                  const type = safeString(app.Type).trim();
  	                  const reg = safeString(app.Registration).trim();
  	                  const trailer = safeString(app.Trailer).trim();

  	                  let label = "";

  	                  if (reg) label = type ? `${type} - ${reg}`: reg;
  	                  else if (trailer) label = type ? `${type} - ${trailer}`: trailer;
  	                  else label = type;

  	                  if (!label) return;

  	                  if (!headline) headline = label;
  	                  else extras.push(label);
  	                });

  	                if (!headline) {
  	                  headline = pick(job, ["Event", "event", "Type", "type", "Name", "name"]) || "";
  	                }

  	                return {
  	                  headline,
  	                  extras
  	                };
  	              }

  	              function buildMultilineProducts(job) {
  	                return normalizeApplications(job).map(app => {
  	                  const labelBase = safeString(app.Registration || app.Trailer || app.Type).trim();
  	                  const product = safeString(app.Product).trim();

  	                  if (!labelBase && !product) return "";
  	                  if (labelBase && product) return `${labelBase}: ${product}`;

  	                  return product || labelBase;
  	                }).filter(Boolean);
  	              }

  	              function buildMultilineRates(job) {
  	                return normalizeApplications(job).map(app => {
  	                  const labelBase = safeString(app.Registration || app.Trailer || app.Type).trim();
  	                  const rate = safeString(app.RateText).trim();

  	                  if (!labelBase && !rate) return "";
  	                  if (labelBase && rate) return `${labelBase}: ${rate}`;

  	                  return rate || labelBase;
  	                }).filter(Boolean);
  	              }

  	              function smallLines(lines) {
  	                const clean = Array.isArray(lines)
  	                ? lines.map(line => safeString(line).trim()).filter(Boolean): [];

  	                if (!clean.length) return `<div class="jel-big jel-dash">-</div>`;

  	                return `
  	                <div class="jel-small">
  	                ${clean.map(line => `<span class="jel-smallline">${escapeHtml(line)}</span>`).join("")}
  	                </div>
  	                `;
  	              }

  	              function bigSmall(bigText, smallLineArray) {
  	                const big = safeString(bigText).trim();
  	                const small = Array.isArray(smallLineArray) ? smallLineArray: [];

  	                return `
  	                <div class="jel-cell">
  	                <div class="jel-big ${big ? "": "jel-dash"}">${escapeHtml(big || "-")}</div>
  	                ${small.length ? smallLines(small): ""}
  	                </div>
  	                `;
  	              }

  	              function getContractorText(job) {
  	                return pick(job,
  	                  [
  	                    "ContractorLabel",
  	                    "contractorLabel",
  	                    "ContractorName",
  	                    "contractorName",
  	                    "ContractorId",
  	                    "contractorId"
  	                  ]);
  	              }

  	              function getVehicleText(job) {
  	                return pick(job,
  	                  [
  	                    "VehicleLabel",
  	                    "vehicleLabel",
  	                    "VehicleRegistration",
  	                    "vehicleRegistration",
  	                    "VehicleName",
  	                    "vehicleName",
  	                    "VehicleId",
  	                    "vehicleId"
  	                  ]);
  	              }

  	              function sortEvents(events) {
  	                return events.slice().sort((a, b) => {
  	                  const aDate = asDate(getBestTimeIn(a) || getBestTimeOut(a) || getBestDate(a));
  	                  const bDate = asDate(getBestTimeIn(b) || getBestTimeOut(b) || getBestDate(b));

  	                  const aTime = aDate ? aDate.getTime(): 0;
  	                  const bTime = bDate ? bDate.getTime(): 0;

  	                  return bTime - aTime;
  	                });
  	              }

  	              function loadEventsViaRelation() {
  	                if (!hasBackendlessData()) {
  	                  return Promise.resolve({
  	                    ok: false,
  	                    jobs: [],
  	                    reason: "Backendless missing"
  	                  });
  	                }

  	                const locationStore = Backendless.Data.of(TABLE_LOCATIONS);

  	                if (!locationStore || typeof locationStore.loadRelations !== "function") {
  	                  return Promise.resolve({
  	                    ok: false,
  	                    jobs: [],
  	                    reason: "loadRelations missing"
  	                  });
  	                }

  	                return locationStore.loadRelations(
  	                  {
  	                    objectId: locationId
  	                  },
  	                  LOCATION_JOBS_RELATION_FIELD,
  	                  null
  	                ).then(result => {
  	                    return {
  	                      ok: true,
  	                      jobs: Array.isArray(result) ? result: result ? [result]: [],
  	                      source: "Location.Jobs"
  	                    };
  	                  }).catch(error => {
  	                    return {
  	                      ok: false,
  	                      jobs: [],
  	                      reason: error?.message || error?.faultString || "Relation load failed"
  	                    };
  	                  });
  	              }

  	              function loadEventsViaJobEntries() {
  	                if (!hasBackendlessData()) {
  	                  return Promise.resolve({
  	                    ok: false,
  	                    jobs: [],
  	                    reason: "Backendless missing"
  	                  });
  	                }

  	                const store = Backendless.Data.of(TABLE_JOB_ENTRIES);

  	                if (
  	                  !Backendless.DataQueryBuilder ||
  	                  typeof Backendless.DataQueryBuilder.create !== "function" ||
  	                  !store ||
  	                  typeof store.find !== "function"
  	                ) {
  	                  return Promise.resolve({
  	                    ok: false,
  	                    jobs: [],
  	                    reason: "Query builder missing"
  	                  });
  	                }

  	                const safeLocationId = locationId.replace(/'/g, "\\'");
  	                const query = Backendless.DataQueryBuilder.create();

  	                query.setWhereClause(`LocationId = '${safeLocationId}'`);
  	                query.setPageSize(100);
  	                query.setSortBy(["DateISO DESC"]);

  	                return store.find(query).then(result => {
  	                  const jobs = Array.isArray(result)
  	                  ? result: Array.isArray(result?.data)
  	                  ? result.data: [];

  	                  return {
  	                    ok: true,
  	                    jobs,
  	                    source: "JobEntries.LocationId"
  	                  };
  	                }).catch(error => {
  	                  return {
  	                    ok: false,
  	                    jobs: [],
  	                    reason: error?.message || error?.faultString || "JobEntries query failed"
  	                  };
  	                });
  	              }

  	              function loadEvents() {
  	                return loadEventsViaRelation().then(relationResult => {
  	                  if (relationResult.ok && relationResult.jobs.length) {
  	                    return relationResult;
  	                  }

  	                  return loadEventsViaJobEntries().then(queryResult => {
  	                    if (queryResult.ok) return queryResult;

  	                    return relationResult.ok ? relationResult: queryResult;
  	                  });
  	                });
  	              }

  	              function eventMatchesSearch(job, query) {
  	                if (!query) return true;

  	                const blob = [
  	                  getBestDate(job),
  	                  locationLabel,
  	                  buildEventText(job),
  	                  buildProductText(job),
  	                  getContractorText(job),
  	                  getVehicleText(job),
  	                  formatTime(getBestTimeIn(job)),
  	                  formatTime(getBestTimeOut(job)),
  	                  formatDuration(getBestDuration(job)),
  	                  safeString(getBestArea(job) || "")
  	                ].join(" ").toLowerCase();

  	                return blob.includes(query);
  	              }

  	              function renderRows(jobs, query) {
  	                const visible = sortEvents(jobs).filter(job => eventMatchesSearch(job, query));

  	                if (!visible.length) {
  	                  return `
  	                  <div class="jel-empty">
  	                  ${query ? "No matching jobs found.": "No jobs found for this location."}
  	                  </div>
  	                  `;
  	                }

  	                return `
  	                <div class="jel-tablewrap">
  	                <table class="jel-table">
  	                <thead>
  	                <tr>
  	                <th>Date</th>
  	                <th>Field</th>
  	                <th>Area</th>
  	                <th>Event</th>
  	                <th>Product</th>
  	                <th>Rate</th>
  	                <th>Contractor</th>
  	                <th>Tractor</th>
  	                <th>Fuel</th>
  	                <th>Time In</th>
  	                <th>Time Out</th>
  	                <th>Duration</th>
  	                <th>Actions</th>
  	                </tr>
  	                </thead>

  	                <tbody>
  	                ${visible.map((job, index) => {
  	                  const eventInfo = buildMultilineEvent(job);
  	                  const products = buildMultilineProducts(job);
  	                  const rates = buildMultilineRates(job);
  	                  const area = getBestArea(job);
  	                  const duration = getBestDuration(job);

  	                  return `
  	                  <tr>
  	                  <td>
  	                  <div class="${getBestDate(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getBestDate(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <div class="${locationLabel ? "": "jel-muted"}">
  	                  ${escapeHtml(locationLabel || "-")}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <div class="${area === null ? "jel-muted jel-num": "jel-num"}">
  	                  ${area === null ? "-": escapeHtml(Number(area).toFixed(2))}
  	                  </div>
  	                  </td>

  	                  <td>${bigSmall(eventInfo.headline, eventInfo.extras)}</td>

  	                  <td>${smallLines(products)}</td>

  	                  <td>${smallLines(rates)}</td>

  	                  <td>
  	                  <div class="${getContractorText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getContractorText(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <div class="${getVehicleText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getVehicleText(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <div class="${getFuelText(job) ? "": "jel-muted"}">
  	                  ${escapeHtml(getFuelText(job) || "-")}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <div class="${formatTime(getBestTimeIn(job)) ? "jel-num": "jel-muted jel-num"}">
  	                  ${escapeHtml(formatTime(getBestTimeIn(job)) || "-")}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <div class="${formatTime(getBestTimeOut(job)) ? "jel-num": "jel-muted jel-num"}">
  	                  ${escapeHtml(formatTime(getBestTimeOut(job)) || "-")}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <div class="${duration === null ? "jel-muted jel-num": "jel-num"}">
  	                  ${escapeHtml(duration === null ? "-": formatDuration(duration))}
  	                  </div>
  	                  </td>

  	                  <td>
  	                  <div class="jel-actions-cell">
  	                  <button class="jel-btn" type="button" data-tem-edit-index="${index}">Edit</button>
  	                  <button class="jel-btn jel-btn-danger" type="button" data-tem-delete-index="${index}">Delete</button>
  	                  </div>
  	                  </td>
  	                  </tr>
  	                  `;
  	                }).join("")}
  	                </tbody>
  	                </table>
  	                </div>
  	                `;
  	              }

  	              injectEventsStyles();

  	              const mount = document.createElement("div");
  	              mount.id = EVENTS_MOUNT_ID;

  	              mount.innerHTML = `
  	              <div class="jel-root">
  	              <div class="jel-card">
  	              <div class="jel-row" style="justify-content:flex-end;">
  	              <button class="jel-btn" type="button" data-tem-close>✖ Close</button>
  	              </div>

  	              <div class="jel-actions">
  	              <div>
  	              <div class="jel-title">Jobs</div>
  	              <div class="jel-sub">${escapeHtml(locationLabel || locationId || "(No Location)")}</div>
  	              </div>

  	              <div class="jel-row">
  	              <div class="jel-badge" data-tem-status>Loading...</div>
  	              <button class="jel-btn jel-btn-primary" type="button" data-tem-refresh>Refresh</button>
  	              <button class="jel-btn" type="button" data-tem-print>Print</button>
  	              </div>
  	              </div>

  	              <div class="jel-sub" data-tem-source></div>

  	              <div class="jel-search-wrap">
  	              <input
  	              class="jel-search"
  	              type="text"
  	              placeholder="Search jobs, products, trailers, tractors, contractors, dates..."
  	              data-tem-search
  	              />
  	              </div>

  	              <div class="jel-divider"></div>

  	              <div class="jel-events-box" data-tem-body>
  	              <div class="jel-empty">Loading events...</div>
  	              </div>
  	              </div>
  	              </div>
  	              `;

  	              document.body.appendChild(mount);

  	              const statusEl = mount.querySelector("[data-tem-status]");
  	              const bodyEl = mount.querySelector("[data-tem-body]");
  	              const searchInput = mount.querySelector("[data-tem-search]");
  	              const closeButton = mount.querySelector("[data-tem-close]");
  	              const refreshButton = mount.querySelector("[data-tem-refresh]");

  	              const printButton = mount.querySelector("[data-tem-print]");
  	              const sourceEl = mount.querySelector("[data-tem-source]");

  	              let loadedJobs = [];

  	              function renderEvents() {
  	                const query = safeString(searchInput?.value || "").trim().toLowerCase();

  	                bodyEl.innerHTML = renderRows(loadedJobs, query);

  	                statusEl.textContent = loadedJobs.length
  	                ? `Loaded ${loadedJobs.length} event(s)`: "No events found";
  	              }

  	              function refreshEvents() {
  	                statusEl.textContent = "Loading events...";
  	                bodyEl.innerHTML = `<div class="jel-empty">Loading events...</div>`;
  	                refreshButton.disabled = true;

  	                loadEvents().then(result => {
  	                  loadedJobs = Array.isArray(result.jobs) ? result.jobs: [];

  	                  renderEvents();

  	                  if (sourceEl) {
  	                    sourceEl.textContent = result.source ? `Source: ${result.source}`: "";
  	                  }

  	                }).catch(error => {
  	                  loadedJobs = [];
  	                  statusEl.textContent = "Failed to load events";
  	                  bodyEl.innerHTML = `
  	                  <div class="jel-empty">
  	                  ${escapeHtml(error?.message || "Could not load events.")}
  	                  </div>
  	                  `;
  	                }).finally(() => {
  	                  refreshButton.disabled = false;
  	                });
  	              }

  	              closeButton.addEventListener("click",
  	                () => {
  	                  mount.remove();
  	                });

  	              refreshButton.addEventListener("click",
  	                () => {
  	                  refreshEvents();
  	                });

  	              printButton.addEventListener("click",
  	                () => {
  	                  window.print();
  	                });

  	              searchInput.addEventListener("input",
  	                () => {
  	                  renderEvents();
  	                });

  	              mount.addEventListener("mousedown",
  	                event => {
  	                  if (event.target === mount) {
  	                    mount.remove();
  	                  }
  	                });

  	              const appData = getAppBag();

  	              if (appData) {
  	                appData.SelectedLocation = location;
  	                appData.SelectedLocationObjectId = locationId;
  	                appData.SelectedLocationMarker = locationId;
  	              }

  	              refreshEvents();
  	            }

  	            function openLocationCaptureEventForm(rowData) {
  	              if (!rowData || !rowData.location) {
  	                window.alert("No location selected.");
  	                return;
  	              }

  	              const location = rowData.location;
  	              const locationId = safeString(getLocationValue(location)).trim();
  	              const locationLabel = safeString(getLocationLabel(location) || rowData.label || locationId).trim();
  	              const appData = getAppBag();
  	              const company =
  	              rowData.companyEntry?.company ||
  	              rowData.company ||
  	              rowData.companyObject ||
  	              DATA_CHANNEL?.companies?.find(companyItem => {
  	                const companyLocations = flattenLocations(getCompanyLocations(companyItem));
  	                return companyLocations.some(locationItem => {
  	                  return String(getLocationValue(locationItem)) === String(locationId);
  	                });
  	              }) ||
  	              null;

  	              if (!locationId) {
  	                window.alert("Selected location has no objectId.");
  	                return;
  	              }

  	              const MOUNT_ID = "trackit-location-capture-event-form";
  	              const STYLE_ID = "trackit-location-capture-event-form-style";
  	              const TABLE_JOB_ENTRIES = "JobEntries";
  	              const TABLE_LOCATIONS = "Locations";
  	              const LOCATION_JOBS_RELATION_FIELD = "Jobs";

  	              const existing = document.getElementById(MOUNT_ID);

  	              if (existing) {
  	                existing.remove();
  	              }

  	              function toast(message) {
  	                window.alert(message);
  	              }

  	              function deepClone(value) {
  	                try {
  	                  return JSON.parse(JSON.stringify(value));
  	                } catch (_) {
  	                  return value;
  	                }
  	              }

  	              function safeLower(value) {
  	                return safeString(value).trim().toLowerCase();
  	              }

  	              function nowId(prefix) {
  	                return `${prefix || "ID"}_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
  	              }

  	              function todayISO() {
  	                const date = new Date();
  	                const yyyy = date.getFullYear();
  	                const mm = String(date.getMonth() + 1).padStart(2, "0");
  	                const dd = String(date.getDate()).padStart(2, "0");

  	                return `${yyyy}-${mm}-${dd}`;
  	              }

  	              function pickFirstNonEmptyString(object, keys) {
  	                if (!object || typeof object !== "object") return "";

  	                for (let i = 0; i < keys.length; i++) {
  	                  const value = object[keys[i]];

  	                  if (value === undefined || value === null) continue;

  	                  const text = safeString(value).trim();

  	                  if (text) return text;
  	                }

  	                return "";
  	              }

  	              function getIdFromAnyShape(value) {
  	                if (value === undefined || value === null) return "";

  	                if (typeof value === "string" || typeof value === "number") {
  	                  return safeString(value).trim();
  	                }

  	                if (typeof value === "object") {
  	                  return safeString(
  	                    value.LocationId ||
  	                    value.VehicleId ||
  	                    value.ContractorId ||
  	                    value.objectId ||
  	                    value.id ||
  	                    value.ID ||
  	                    value.Id ||
  	                    ""
  	                  ).trim();
  	                }

  	                return "";
  	              }

  	              function getVehiclesArray() {
  	                const user = appData?.User || {};

  	                const list =
  	                company?.Tractors ||
  	                company?.tractors ||
  	                company?.Vehicles ||
  	                company?.vehicles ||
  	                company?.Vehicle ||
  	                company?.vehicle ||
  	                user.Tractors ||
  	                user.tractors ||
  	                user.Vehicles ||
  	                user.vehicles ||
  	                appData?.Tractors ||
  	                appData?.tractors ||
  	                appData?.Vehicles ||
  	                appData?.vehicles ||
  	                [];

  	                console.log("[TrackIT Capture Event] Vehicle source:", {
  	                  company,
  	                  count: Array.isArray(list) ? list.length: 0,
  	                  list
  	                });

  	                return Array.isArray(list) ? list.slice(): [];
  	              }

  	              function getContractorsArray() {
  	                const user = appData?.User || {};

  	                const list =
  	                company?.Contractors ||
  	                company?.contractors ||
  	                company?.Contractor ||
  	                company?.contractor ||
  	                user.Contractors ||
  	                user.contractors ||
  	                appData?.Contractors ||
  	                appData?.contractors ||
  	                [];

  	                console.log("[TrackIT Capture Event] Contractor source:", {
  	                  company,
  	                  count: Array.isArray(list) ? list.length: 0,
  	                  list
  	                });

  	                return Array.isArray(list) ? list.slice(): [];
  	              }

  	              function vehicleToOption(vehicle) {
  	                if (vehicle === undefined || vehicle === null) return null;

  	                if (typeof vehicle === "string" || typeof vehicle === "number") {
  	                  const text = safeString(vehicle).trim();

  	                  if (!text) return null;

  	                  return {
  	                    id: text,
  	                    label: text,
  	                    raw: null
  	                  };
  	                }

  	                if (typeof vehicle === "object") {
  	                  let id = pickFirstNonEmptyString(vehicle, [
  	                    "VehicleId",
  	                    "TractorId",
  	                    "tractorId",
  	                    "objectId",
  	                    "id",
  	                    "ID",
  	                    "Id"
  	                  ]);

  	                  let label = pickFirstNonEmptyString(vehicle, [
  	                    "Label",
  	                    "Name",
  	                    "name",
  	                    "Display",
  	                    "Registration",
  	                    "registration",
  	                    "Plate",
  	                    "plate",
  	                    "VehicleName",
  	                    "TractorName",
  	                    "tractorName",
  	                    "Title",
  	                    "title"
  	                  ]);

  	                  if (!label) {
  	                    label = pickFirstNonEmptyString(vehicle, [
  	                      "registrationNumber",
  	                      "RegistrationNumber",
  	                      "registration",
  	                      "Registration",
  	                      "plateNumber",
  	                      "PlateNumber",
  	                      "plate",
  	                      "Plate",
  	                      "code",
  	                      "Code"
  	                    ]);
  	                  }

  	                  if (!label) label = id || "(Vehicle)";
  	                  if (!id) id = label;

  	                  return {
  	                    id,
  	                    label,
  	                    raw: vehicle
  	                  };
  	                }

  	                return null;
  	              }

  	              function contractorToOption(contractor) {
  	                if (contractor === undefined || contractor === null) return null;

  	                if (typeof contractor === "string" || typeof contractor === "number") {
  	                  const text = safeString(contractor).trim();

  	                  if (!text) return null;

  	                  return {
  	                    id: text,
  	                    label: text,
  	                    raw: null
  	                  };
  	                }

  	                if (typeof contractor === "object") {
  	                  let id = pickFirstNonEmptyString(contractor, ["ContractorId", "objectId", "id", "ID", "Id"]);
  	                  let label = pickFirstNonEmptyString(contractor, ["Name", "name"]);

  	                  if (!label) {
  	                    label = pickFirstNonEmptyString(contractor, ["Label", "Company", "Display", "ContractorName", "Title"]);
  	                  }

  	                  if (!label) {
  	                    label = pickFirstNonEmptyString(contractor, ["fullName", "contactName", "tradingName"]);
  	                  }

  	                  if (!label) label = id || "(Contractor)";
  	                  if (!id) id = label;

  	                  return {
  	                    id,
  	                    label,
  	                    raw: contractor
  	                  };
  	                }

  	                return null;
  	              }

  	              function buildVehicleOptionsAll() {
  	                return getVehiclesArray().map(vehicleToOption).filter(Boolean);
  	              }

  	              function buildContractorOptionsAll() {
  	                return getContractorsArray().map(contractorToOption).filter(Boolean);
  	              }

  	              function buildContractorIndexById() {
  	                const index = {};

  	                getContractorsArray().forEach(contractor => {
  	                  let id = getIdFromAnyShape(contractor);

  	                  if (!id && typeof contractor === "object") {
  	                    id = pickFirstNonEmptyString(contractor, ["ContractorId", "objectId", "id", "ID", "Id"]);
  	                  }

  	                  if (!id) return;

  	                  index[String(id)] = contractor;
  	                });

  	                return index;
  	              }

  	              function getContractorVehiclesArray(contractor) {
  	                if (!contractor || typeof contractor !== "object") return [];

  	                const list =
  	                Array.isArray(contractor.Vehicles) ? contractor.Vehicles:
  	                Array.isArray(contractor.Tractors) ? contractor.Tractors:
  	                Array.isArray(contractor.VehicleIds) ? contractor.VehicleIds:
  	                Array.isArray(contractor.TractorIds) ? contractor.TractorIds:
  	                [];

  	                return Array.isArray(list) ? list.slice(): [];
  	              }

  	              function buildVehicleOptionsForContractor(contractorId) {
  	                const all = buildVehicleOptionsAll();

  	                if (!contractorId) return all;

  	                const contractorIndex = buildContractorIndexById();
  	                const contractor = contractorIndex[String(contractorId)] || null;

  	                if (!contractor) return all;

  	                const contractorVehicles = getContractorVehiclesArray(contractor);
  	                const allowed = {};

  	                contractorVehicles.forEach(item => {
  	                  let id = getIdFromAnyShape(item);

  	                  if (!id && typeof item === "object") {
  	                    id = pickFirstNonEmptyString(item, ["VehicleId", "objectId", "id", "ID", "Id"]);
  	                  }

  	                  if (!id) return;

  	                  allowed[String(id)] = true;
  	                });

  	                const keys = Object.keys(allowed);

  	                if (!keys.length) return [];

  	                return all.filter(option => {
  	                  return !!allowed[String(option.id)];
  	                });
  	              }

  	              function applicationTypeToString(value) {
  	                if (value === undefined || value === null) return "";

  	                if (typeof value === "string") {
  	                  return safeString(value).trim();
  	                }

  	                if (typeof value === "object") {
  	                  return pickFirstNonEmptyString(value, ["Type", "ApplicationType", "Name", "name", "Label", "Title", "Display"]);
  	                }

  	                return "";
  	              }

  	              function getApplicationTypes() {
  	                let list =
  	                company?.Manifest?.Applications && Array.isArray(company.Manifest.Applications)
  	                ? company.Manifest.Applications: [];

  	                if (!list.length) {
  	                  const user = appData?.User || {};

  	                  if (Array.isArray(user.ApplicationsCatalog)) {
  	                    list = user.ApplicationsCatalog;
  	                  }
  	                }

  	                if (!list.length && Array.isArray(state.uiDraft.Applications)) {
  	                  list = state.uiDraft.Applications
  	                  .map(item => item?.Type || "")
  	                  .filter(Boolean);
  	                }

  	                const seen = {};
  	                const result = [];

  	                list.forEach(item => {
  	                  const type = applicationTypeToString(item);

  	                  if (!type) return;

  	                  const key = safeLower(type);

  	                  if (seen[key]) return;

  	                  seen[key] = true;
  	                  result.push(type);
  	                });

  	                result.sort((a, b) => safeLower(a).localeCompare(safeLower(b)));

  	                return result;
  	              }

  	              function backendlessHasData() {
  	                return !!(
  	                  typeof Backendless !== "undefined" &&
  	                  Backendless &&
  	                  Backendless.Data &&
  	                  typeof Backendless.Data.of === "function"
  	                );
  	              }

  	              function sanitizeForBackendless(value) {
  	                if (value === undefined || value === null) return value;
  	                if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return value;
  	                if (Array.isArray(value)) return value.map(sanitizeForBackendless);

  	                if (typeof value === "object") {
  	                  const output = {};

  	                  Object.keys(value).forEach(key => {
  	                    output[key] = sanitizeForBackendless(value[key]);
  	                  });

  	                  return output;
  	                }

  	                return value;
  	              }

  	              function resolveAppTypeForValidation(application) {
  	                const type = safeString(application?.Type).trim();
  	                const other = safeString(application?.TypeOther).trim();

  	                if (safeLower(type) === "other") return other;

  	                return type;
  	              }

  	              function toBackendlessPayloadFromDraft(draft) {
  	                const clean = sanitizeForBackendless(draft);

  	                if (!Array.isArray(clean.Applications)) clean.Applications = [];

  	                clean.Applications = clean.Applications.map(application => {
  	                  const type = safeString(application?.Type).trim();
  	                  const typeOther = safeString(application?.TypeOther).trim();
  	                  const product = safeString(application?.Product).trim();
  	                  const rateText = safeString(application?.RateText).trim();
  	                  const resolvedType = safeLower(type) === "other" ? typeOther: type;

  	                  return {
  	                    Type: resolvedType,
  	                    Product: product,
  	                    RateText: rateText
  	                  };
  	                }).filter(application => {
  	                  return application.Type && application.Product && application.RateText;
  	                });

  	                return clean;
  	              }

  	              function saveJobEntryRow(payload) {
  	                if (!backendlessHasData()) {
  	                  console.warn("[TrackIT Capture Event] Backendless SDK not available.");
  	                  return Promise.resolve({
  	                    ok: false,
  	                    reason: "Backendless missing"
  	                  });
  	                }

  	                return Backendless.Data.of(TABLE_JOB_ENTRIES).save(payload)
  	                .then(saved => {
  	                  return {
  	                    ok: true,
  	                    saved
  	                  };
  	                })
  	                .catch(error => {
  	                  return {
  	                    ok: false,
  	                    reason: error?.message || error?.faultString || "Save failed",
  	                    error
  	                  };
  	                });
  	              }

  	              function linkJobToLocationJobsRelation(savedJob) {
  	                if (!backendlessHasData()) {
  	                  return Promise.resolve({
  	                    ok: true,
  	                    linked: false,
  	                    reason: "Backendless missing"
  	                  });
  	                }

  	                const jobObjectId = safeString(savedJob?.objectId).trim();

  	                if (!jobObjectId) {
  	                  return Promise.resolve({
  	                    ok: true,
  	                    linked: false,
  	                    reason: "Saved job missing objectId"
  	                  });
  	                }

  	                const locationStore = Backendless.Data.of(TABLE_LOCATIONS);

  	                if (!locationStore || typeof locationStore.addRelation !== "function") {
  	                  return Promise.resolve({
  	                    ok: true,
  	                    linked: false,
  	                    reason: "No addRelation method"
  	                  });
  	                }

  	                return locationStore.addRelation(
  	                  {
  	                    objectId: locationId
  	                  },
  	                  LOCATION_JOBS_RELATION_FIELD,
  	                  [{
  	                    objectId: jobObjectId
  	                  }]
  	                ).then(result => {
  	                    return {
  	                      ok: true,
  	                      linked: true,
  	                      method: "addRelation",
  	                      result
  	                    };
  	                  }).catch(error => {
  	                    console.warn("[TrackIT Capture Event] Relation link failed.", error);

  	                    return {
  	                      ok: true,
  	                      linked: false,
  	                      reason: "addRelation failed",
  	                      error
  	                    };
  	                  });
  	              }

  	              function injectStylesOnce() {
  	                if (document.getElementById(STYLE_ID)) return;

  	                const style = document.createElement("style");
  	                style.id = STYLE_ID;
  	                style.textContent = `
  	                #${MOUNT_ID} {
  	                position: fixed;
  	                inset: 0;
  	                z-index: 2147483647;
  	                overflow: auto;
  	                background: rgba(0,0,0,0.85);
  	                padding: 10px;
  	                box-sizing: border-box;
  	                }

  	                #${MOUNT_ID} .jef-root {
  	                font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  	                padding: 12px;
  	                box-sizing: border-box;
  	                color: #f0f0f0;
  	                max-width: 900px;
  	                margin: 0 auto;
  	                }

  	                #${MOUNT_ID} .jef-card {
  	                border: 1px solid #333;
  	                border-radius: 14px;
  	                background: rgba(16,16,16,0.94);
  	                padding: 12px;
  	                box-sizing: border-box;
  	                }

  	                #${MOUNT_ID} .jef-header {
  	                display: flex;
  	                align-items: flex-start;
  	                justify-content: space-between;
  	                gap: 10px;
  	                flex-wrap: wrap;
  	                }

  	                #${MOUNT_ID} .jef-title {
  	                font-size: 1.05rem;
  	                font-weight: 900;
  	                color: #fff;
  	                margin: 0;
  	                }

  	                #${MOUNT_ID} .jef-sub {
  	                font-size: 0.78rem;
  	                color: #b0b0b0;
  	                margin-top: 2px;
  	                }

  	                #${MOUNT_ID} .jef-badge {
  	                font-size: 0.72rem;
  	                padding: 4px 10px;
  	                border-radius: 999px;
  	                background: #2a2f38;
  	                color: #d2d7de;
  	                white-space: nowrap;
  	                }

  	                #${MOUNT_ID} .jef-divider {
  	                height: 1px;
  	                background: #2a2a2a;
  	                margin: 12px 0;
  	                }

  	                #${MOUNT_ID} .jef-grid {
  	                display: grid;
  	                grid-template-columns: 1fr;
  	                gap: 10px;
  	                }

  	                #${MOUNT_ID} .jef-label {
  	                font-size: 0.8rem;
  	                color: #c9c9c9;
  	                margin-bottom: 4px;
  	                font-weight: 700;
  	                }

  	                #${MOUNT_ID} .jef-input,
  	                #${MOUNT_ID} .jef-select {
  	                width: 100%;
  	                padding: 10px 12px;
  	                border-radius: 10px;
  	                border: 1px solid #444;
  	                background: #262626;
  	                color: #e8e8e8;
  	                outline: none;
  	                font-size: 0.95rem;
  	                box-sizing: border-box;
  	                }

  	                #${MOUNT_ID} .jef-input:focus,
  	                #${MOUNT_ID} .jef-select:focus {
  	                border-color: #CC6633;
  	                box-shadow: 0 0 0 1px #CC6633;
  	                }

  	                #${MOUNT_ID} .jef-row {
  	                display: flex;
  	                gap: 8px;
  	                align-items: center;
  	                flex-wrap: wrap;
  	                }

  	                #${MOUNT_ID} .jef-actions {
  	                display: flex;
  	                align-items: center;
  	                justify-content: flex-end;
  	                gap: 8px;
  	                flex-wrap: wrap;
  	                margin-top: 10px;
  	                }

  	                #${MOUNT_ID} .jef-btn {
  	                border-radius: 999px;
  	                border: 1px solid #555;
  	                background: #333;
  	                color: #e0e0e0;
  	                font-size: 0.85rem;
  	                padding: 8px 12px;
  	                cursor: pointer;
  	                user-select: none;
  	                white-space: nowrap;
  	                }

  	                #${MOUNT_ID} .jef-btn:hover {
  	                background: #3c3c3c;
  	                }

  	                #${MOUNT_ID} .jef-btn-primary {
  	                background: #CC6633;
  	                border-color: #CC6633;
  	                color: #fff;
  	                }

  	                #${MOUNT_ID} .jef-btn-primary:hover {
  	                background: #e0733a;
  	                border-color: #e0733a;
  	                }

  	                #${MOUNT_ID} .jef-btn-danger {
  	                background: #4a2020;
  	                border-color: #aa4444;
  	                color: #ffcccc;
  	                }

  	                #${MOUNT_ID} .jef-btn-danger:hover {
  	                background: #5c2626;
  	                }

  	                #${MOUNT_ID} .jef-btn-disabled {
  	                opacity: 0.55;
  	                cursor: not-allowed;
  	                }

  	                #${MOUNT_ID} .jef-list {
  	                display: flex;
  	                flex-direction: column;
  	                gap: 10px;
  	                margin-top: 10px;
  	                }

  	                #${MOUNT_ID} .jef-app-row {
  	                border: 1px solid #3a3a3a;
  	                background: #1f1f1f;
  	                border-radius: 14px;
  	                padding: 10px;
  	                display: flex;
  	                flex-direction: column;
  	                gap: 8px;
  	                }

  	                #${MOUNT_ID} .jef-app-grid {
  	                display: grid;
  	                grid-template-columns: 220px 1fr 220px;
  	                gap: 8px;
  	                align-items: end;
  	                }

  	                #${MOUNT_ID} .jef-app-grid-2 {
  	                display: grid;
  	                grid-template-columns: 220px 1fr;
  	                gap: 8px;
  	                align-items: end;
  	                }

  	                #${MOUNT_ID} .jef-app-actions {
  	                display: flex;
  	                justify-content: flex-end;
  	                gap: 8px;
  	                flex-wrap: wrap;
  	                }

  	                #${MOUNT_ID} .jef-empty {
  	                color: #a0a4aa;
  	                font-size: 0.95rem;
  	                padding: 10px 2px;
  	                }

  	                #${MOUNT_ID} .jef-readonly {
  	                width: 100%;
  	                padding: 10px 12px;
  	                border-radius: 10px;
  	                border: 1px solid #444;
  	                background: #1f1f1f;
  	                color: #e8e8e8;
  	                font-size: 0.95rem;
  	                box-sizing: border-box;
  	                }

  	                @media (max-width: 720px) {
  	                #${MOUNT_ID} .jef-app-grid,
  	                #${MOUNT_ID} .jef-app-grid-2 {
  	                grid-template-columns: 1fr;
  	                }
  	                }
  	                `;

  	                document.head.appendChild(style);
  	              }

  	              function createInitialDraft() {
  	                return {
  	                  DraftId: nowId("DRAFT"),
  	                  DateISO: todayISO(),
  	                  LocationId: locationId,
  	                  LocationLabel: locationLabel,
  	                  VehicleId: "",
  	                  VehicleLabel: "",
  	                  ContractorId: "",
  	                  ContractorLabel: "",
  	                  Applications: []
  	                };
  	              }

  	              function validate(uiDraft) {
  	                const problems = [];

  	                if (!uiDraft.DateISO) problems.push("Date is required.");
  	                if (!uiDraft.LocationId) problems.push("Location is required.");
  	                if (!uiDraft.VehicleId) problems.push("Vehicle is required.");

  	                const applications = Array.isArray(uiDraft.Applications) ? uiDraft.Applications: [];

  	                if (!applications.length) {
  	                  problems.push("Add at least one application.");
  	                }

  	                applications.forEach((application, index) => {
  	                  const type = resolveAppTypeForValidation(application);
  	                  const product = safeString(application?.Product).trim();
  	                  const rate = safeString(application?.RateText).trim();

  	                  if (!type) problems.push(`Application #${index + 1} needs an Application Type.`);
  	                  if (!product) problems.push(`Application #${index + 1} needs a Product.`);
  	                  if (!rate) problems.push(`Application #${index + 1} needs a Rate.`);
  	                });

  	                return problems;
  	              }

  	              const state = {
  	                uiDraft: createInitialDraft(),
  	                isSaving: false,
  	                dirty: false,
  	                status: "Ready"
  	              };

  	              function markDirty() {
  	                state.dirty = true;
  	                state.status = "Unsaved changes";
  	              }

  	              function resetDraftAfterSave() {
  	                state.uiDraft = createInitialDraft();
  	                state.dirty = false;
  	                state.status = "Saved";
  	              }

  	              function addApplicationRow() {
  	                markDirty();

  	                if (!Array.isArray(state.uiDraft.Applications)) {
  	                  state.uiDraft.Applications = [];
  	                }

  	                state.uiDraft.Applications.push({
  	                  Type: "",
  	                  TypeOther: "",
  	                  Product: "",
  	                  RateText: ""
  	                });

  	                render();
  	              }

  	              function removeApplicationRow(index) {
  	                if (!Array.isArray(state.uiDraft.Applications)) return;
  	                if (!state.uiDraft.Applications[index]) return;

  	                markDirty();
  	                state.uiDraft.Applications.splice(index, 1);
  	                render();
  	              }

  	              function setApplicationField(index, field, value) {
  	                if (!Array.isArray(state.uiDraft.Applications)) return;
  	                if (!state.uiDraft.Applications[index]) return;

  	                markDirty();
  	                state.uiDraft.Applications[index][field] = safeString(value);

  	                if (field === "Type" && safeLower(state.uiDraft.Applications[index].Type) !== "other") {
  	                  state.uiDraft.Applications[index].TypeOther = "";
  	                }

  	                render();
  	              }

  	              function saveNow() {
  	                if (state.isSaving) return;

  	                state.uiDraft.LocationId = locationId;
  	                state.uiDraft.LocationLabel = locationLabel;

  	                const problems = validate(state.uiDraft);

  	                if (problems.length) {
  	                  toast(`Fix these before saving:\n\n- ${problems.join("\n- ")}`);
  	                  return;
  	                }

  	                state.isSaving = true;
  	                state.status = "Saving...";
  	                render();

  	                const payload = toBackendlessPayloadFromDraft(state.uiDraft);

  	                payload.LocationId = locationId;
  	                payload.LocationLabel = locationLabel;

  	                if (appData) {
  	                  if (!appData.User) appData.User = {};
  	                  appData.User.JobEntryDraft = deepClone(payload);
  	                }

  	                return saveJobEntryRow(payload).then(result => {
  	                  if (!result || !result.ok) {
  	                    state.status = "Backend save failed";
  	                    state.isSaving = false;
  	                    render();
  	                    toast(`Backend save failed: ${result?.reason || "Unknown"}`);
  	                    return result;
  	                  }

  	                  return linkJobToLocationJobsRelation(result.saved).then(linkResult => {
  	                    state.isSaving = false;
  	                    resetDraftAfterSave();
  	                    render();

  	                    try {
  	                      if (typeof refreshEvents === "function") {
  	                        refreshEvents();
  	                      }
  	                    } catch (_) {}

  	                    return {
  	                      ok: true,
  	                      saved: result.saved,
  	                      linked: !!linkResult?.linked,
  	                      link: linkResult || null
  	                    };
  	                  });
  	                });
  	              }

  	              function render() {
  	                const mount = document.getElementById(MOUNT_ID);

  	                if (!mount) return;

  	                mount.innerHTML = "";

  	                const badgeText = state.isSaving ? "Saving...": state.dirty ? "Unsaved changes": state.status || "Ready";
  	                const contractorOptions = buildContractorOptionsAll();
  	                const vehicleOptions = buildVehicleOptionsForContractor(state.uiDraft.ContractorId);
  	                const typeOptions = getApplicationTypes();
  	                const applications = Array.isArray(state.uiDraft.Applications) ? state.uiDraft.Applications: [];
  	                const TYPE_OTHER_LABEL = "Other";

  	                mount.innerHTML = `
  	                <div class="jef-root">
  	                <div class="jef-card">
  	                <div class="jef-row" style="justify-content:flex-end;">
  	                <button class="jef-btn" type="button" data-jef-close>✖ Close</button>
  	                </div>

  	                <div class="jef-header">
  	                <div>
  	                <div class="jef-title">Job Entry</div>
  	                <div class="jef-sub">${escapeHtml(locationLabel || locationId)}</div>
  	                </div>

  	                <div class="jef-badge">${escapeHtml(badgeText)}</div>
  	                </div>

  	                <div class="jef-divider"></div>

  	                <div class="jef-grid">
  	                <div>
  	                <div class="jef-label">Date</div>
  	                <input class="jef-input" type="date" value="${escapeHtml(state.uiDraft.DateISO || todayISO())}" data-jef-date />
  	                </div>

  	                <div>
  	                <div class="jef-label">Location</div>
  	                <div class="jef-readonly">${escapeHtml(locationLabel || locationId || "(No Location)")}</div>
  	                </div>

  	                <div>
  	                <div class="jef-label">Contractor (optional)</div>
  	                <select class="jef-select" data-jef-contractor>
  	                <option value="">-- Select Contractor (optional) --</option>
  	                ${contractorOptions.map(option => {
  	                  return `
  	                  <option value="${escapeHtml(option.id)}" ${String(state.uiDraft.ContractorId || "") === String(option.id) ? "selected": ""}>
  	                  ${escapeHtml(option.label)}
  	                  </option>
  	                  `;
  	                }).join("")}
  	                </select>
  	                </div>

  	                <div>
  	                <div class="jef-label">Vehicle</div>
  	                <select class="jef-select" data-jef-vehicle>
  	                <option value="">-- Select Vehicle --</option>
  	                ${vehicleOptions.map(option => {
  	                  return `
  	                  <option value="${escapeHtml(option.id)}" ${String(state.uiDraft.VehicleId || "") === String(option.id) ? "selected": ""}>
  	                  ${escapeHtml(option.label)}
  	                  </option>
  	                  `;
  	                }).join("")}
  	                </select>
  	                </div>
  	                </div>

  	                <div class="jef-divider"></div>

  	                <div class="jef-row">
  	                <button class="jef-btn jef-btn-primary ${state.isSaving ? "jef-btn-disabled": ""}" type="button" data-jef-add ${state.isSaving ? "disabled": ""}>
  	                + Add Application
  	                </button>
  	                </div>

  	                <div class="jef-list">
  	                ${
  	                applications.length
  	                ? applications.map((application, index) => {
  	                  const typeValue = safeString(application.Type).trim();

  	                  return `
  	                  <div class="jef-app-row" data-jef-app-index="${index}">
  	                  <div class="jef-app-grid">
  	                  <div>
  	                  <div class="jef-label">Application Type</div>
  	                  <select class="jef-select" data-jef-app-type="${index}" ${state.isSaving ? "disabled": ""}>
  	                  <option value="">-- Select Type --</option>
  	                  ${typeOptions.map(type => {
  	                    return `
  	                    <option value="${escapeHtml(type)}" ${String(typeValue) === String(type) ? "selected": ""}>
  	                    ${escapeHtml(type)}
  	                    </option>
  	                    `;
  	                  }).join("")}
  	                  <option value="${TYPE_OTHER_LABEL}" ${typeValue === TYPE_OTHER_LABEL ? "selected": ""}>${TYPE_OTHER_LABEL}</option>
  	                  </select>
  	                  </div>

  	                  <div>
  	                  <div class="jef-label">Product</div>
  	                  <input
  	                  class="jef-input"
  	                  type="text"
  	                  value="${escapeHtml(application.Product || "")}"
  	                  placeholder="e.g. Calcitic Lime"
  	                  data-jef-app-product="${index}"
  	                  ${state.isSaving ? "disabled": ""}
  	                  />
  	                  </div>

  	                  <div>
  	                  <div class="jef-label">Rate</div>
  	                  <input
  	                  class="jef-input"
  	                  type="text"
  	                  value="${escapeHtml(application.RateText || "")}"
  	                  placeholder="e.g. 200 kg/ha"
  	                  data-jef-app-rate="${index}"
  	                  ${state.isSaving ? "disabled": ""}
  	                  />
  	                  </div>
  	                  </div>

  	                  ${
  	                  safeLower(application.Type) === safeLower(TYPE_OTHER_LABEL)
  	                  ? `
  	                  <div class="jef-app-grid-2">
  	                  <div>
  	                  <div class="jef-label">Type (Other)</div>
  	                  <input
  	                  class="jef-input"
  	                  type="text"
  	                  value="${escapeHtml(application.TypeOther || "")}"
  	                  placeholder="Type your application type"
  	                  data-jef-app-other="${index}"
  	                  ${state.isSaving ? "disabled": ""}
  	                  />
  	                  </div>
  	                  <div></div>
  	                  </div>
  	                  `: ""
  	                  }

  	                  <div class="jef-app-actions">
  	                  <button class="jef-btn jef-btn-danger ${state.isSaving ? "jef-btn-disabled": ""}" type="button" data-jef-remove="${index}" ${state.isSaving ? "disabled": ""}>
  	                  Remove
  	                  </button>
  	                  </div>
  	                  </div>
  	                  `;
  	                }).join(""): `<div class="jef-empty">No applications yet. Click “+ Add Application”.</div>`
  	                }
  	                </div>

  	                <div class="jef-divider"></div>

  	                <div class="jef-actions">
  	                <button class="jef-btn jef-btn-primary ${(!state.dirty || state.isSaving) ? "jef-btn-disabled": ""}" type="button" data-jef-save ${(!state.dirty || state.isSaving) ? "disabled": ""}>
  	                Save
  	                </button>
  	                </div>
  	                </div>
  	                </div>
  	                `;

  	                bindFormEvents(mount, contractorOptions, vehicleOptions);
  	              }

  	              function bindFormEvents(mount, contractorOptions, vehicleOptions) {
  	                const closeButton = mount.querySelector("[data-jef-close]");
  	                const dateInput = mount.querySelector("[data-jef-date]");
  	                const contractorSelect = mount.querySelector("[data-jef-contractor]");
  	                const vehicleSelect = mount.querySelector("[data-jef-vehicle]");
  	                const addButton = mount.querySelector("[data-jef-add]");
  	                const saveButton = mount.querySelector("[data-jef-save]");

  	                closeButton?.addEventListener("click", () => {
  	                  mount.remove();
  	                });

  	                dateInput?.addEventListener("input", () => {
  	                  markDirty();
  	                  state.uiDraft.DateISO = dateInput.value || "";
  	                  render();
  	                });

  	                contractorSelect?.addEventListener("change", () => {
  	                  markDirty();

  	                  state.uiDraft.ContractorId = contractorSelect.value || "";

  	                  const picked = contractorOptions.find(option => {
  	                    return String(option.id) === String(state.uiDraft.ContractorId);
  	                  });

  	                  state.uiDraft.ContractorLabel = picked ? picked.label: "";

  	                  const filteredVehicles = buildVehicleOptionsForContractor(state.uiDraft.ContractorId);
  	                  const stillAllowed = filteredVehicles.some(vehicle => {
  	                    return String(vehicle.id) === String(state.uiDraft.VehicleId || "");
  	                  });

  	                  if (!stillAllowed) {
  	                    state.uiDraft.VehicleId = "";
  	                    state.uiDraft.VehicleLabel = "";
  	                  }

  	                  render();
  	                });

  	                vehicleSelect?.addEventListener("change",
  	                  () => {
  	                    markDirty();

  	                    state.uiDraft.VehicleId = vehicleSelect.value || "";

  	                    const picked = vehicleOptions.find(option => {
  	                      return String(option.id) === String(state.uiDraft.VehicleId);
  	                    });

  	                    state.uiDraft.VehicleLabel = picked ? picked.label: "";

  	                    render();
  	                  });

  	                addButton?.addEventListener("click",
  	                  () => {
  	                    addApplicationRow();
  	                  });

  	                saveButton?.addEventListener("click",
  	                  () => {
  	                    saveNow();
  	                  });

  	                mount.querySelectorAll("[data-jef-remove]").forEach(button => {
  	                  button.addEventListener("click", () => {
  	                    removeApplicationRow(Number(button.getAttribute("data-jef-remove")));
  	                  });
  	                });

  	                mount.querySelectorAll("[data-jef-app-type]").forEach(input => {
  	                  input.addEventListener("change", () => {
  	                    setApplicationField(Number(input.getAttribute("data-jef-app-type")), "Type", input.value || "");
  	                  });
  	                });

  	                mount.querySelectorAll("[data-jef-app-product]").forEach(input => {
  	                  input.addEventListener("change", () => {
  	                    setApplicationField(Number(input.getAttribute("data-jef-app-product")), "Product", input.value || "");
  	                  });
  	                });

  	                mount.querySelectorAll("[data-jef-app-rate]").forEach(input => {
  	                  input.addEventListener("change", () => {
  	                    setApplicationField(Number(input.getAttribute("data-jef-app-rate")), "RateText", input.value || "");
  	                  });
  	                });

  	                mount.querySelectorAll("[data-jef-app-other]").forEach(input => {
  	                  input.addEventListener("change", () => {
  	                    setApplicationField(Number(input.getAttribute("data-jef-app-other")), "TypeOther", input.value || "");
  	                  });
  	                });
  	              }

  	              injectStylesOnce();

  	              const mount = document.createElement("div");
  	              mount.id = MOUNT_ID;
  	              document.body.appendChild(mount);

  	              if (appData) {
  	                appData.SelectedLocation = location;
  	                appData.SelectedLocationObjectId = locationId;
  	                appData.SelectedLocationMarker = locationId;
  	              }

  	              render();
  	            }

  	            function handleCardAction(action) {
  	              const rowData = selectedRowData;

  	              if (!rowData) {
  	                console.warn("[TrackIT Location Dropdown] No selected row for card action:", action);
  	                return;
  	              }

  	              if (action === "edit") {
  	                openLocationEditCard(rowData);
  	                return;
  	              }

  	              if (action === "saveEdit") {
  	                saveLocationEditCard(rowData);
  	                return;
  	              }

  	              if (action === "undoEdit") {
  	                undoLocationEditCard(rowData);
  	                return;
  	              }

  	              if (action === "deleteLocation") {
  	                deleteLocationEditCard(rowData);
  	                return;
  	              }

  	              if (action === "editShape") {
  	                editShapePlaceholder(rowData);
  	                return;
  	              }

  	              if (action === "setEntrance") {
  	                setEntrancePlaceholder(rowData);
  	                return;
  	              }

  	              if (action === "viewEvents") {
  	                openLocationEventsManager(rowData);
  	                return;
  	              }

  	              if (action === "captureEvent") {
  	                openLocationCaptureEventForm(rowData);
  	                return;
  	              }


  	              if (action === "setFunctionality") {
  	                openOriginalFunctionalityPopupFromCard(rowData);
  	                return;
  	              }

  	              if (action === "saveFunctionality") {
  	                saveLocationFunctionalityCard(rowData);
  	                return;
  	              }

  	              if (action === "skipFunctionality") {
  	                actionCard.classList.remove("functionality-editing");
  	                openLocationEditCard(rowData);
  	                return;
  	              }

  	              if (action === "functionalityHelp") {
  	                const button = event?.target?.closest?.("[data-card-action='functionalityHelp']");
  	                return;
  	              }

  	              const eventMap = {
  	                dataCard: ROUTER_EVENTS.dataCardRequested,
  	                children: ROUTER_EVENTS.childrenRequested,
  	                functionality: ROUTER_EVENTS.functionalityRequested,
  	                edit: ROUTER_EVENTS.editRequested
  	              };

  	              const eventName = eventMap[action];

  	              console.groupCollapsed(`[TrackIT Location Dropdown] Placeholder Action: ${action}`);
  	              console.log("Location:", rowData.location);
  	              console.log("Row Data:", rowData);
  	              console.log("Event:", eventName || "");
  	              console.groupEnd();

  	              if (eventName) {
  	                emitRouterEvent(eventName, rowData, {
  	                  action,
  	                  placeholder: true
  	                });
  	              }

  	              if (action === "edit" && SEARCH_ACTION_MODE === "open-panel") {
  	                openLocationPanelAndFocusMap(rowData.location, MapRoot);
  	              }
  	            }

  	            function routeSelectedLocation(rowData, mapFocused) {
  	              if (!rowData) return;

  	              emitRouterEvent(ROUTER_EVENTS.selected, rowData, {
  	                mapFocused
  	              });

  	              if (SEARCH_ACTION_MODE === "select-only") {
  	                return;
  	              }

  	              if (SEARCH_ACTION_MODE === "open-panel") {
  	                openLocationPanelAndFocusMap(rowData.location, MapRoot);
  	                return;
  	              }

  	              openLocationActionCard(rowData);
  	            }

  	            function runLocationSelectionPipeline(rowData) {
  	              if (!rowData) return;

  	              const location = rowData.location;

  	              writeSelectedLocationToAppData(location);

  	              const mapFocused = focusMapForSelectedLocation(location);

  	              emitChange(rowData);

  	              routeSelectedLocation(rowData, mapFocused);
  	            }

  	            // ============================================================
  	            // Rendering
  	            // ============================================================

  	            function renderCompanyHeader(companyEntry, collapsed) {
  	              const header = document.createElement("div");
  	              header.className = "trackit-company-header";

  	              if (collapsed) header.classList.add("collapsed");

  	              const title = document.createElement("div");
  	              title.className = "trackit-company-title";
  	              title.textContent = companyEntry.label;

  	              const meta = document.createElement("div");
  	              meta.className = "trackit-company-meta";

  	              const caret = document.createElement("span");
  	              caret.className = "trackit-company-caret";

  	              meta.appendChild(caret);

  	              header.appendChild(title);
  	              header.appendChild(meta);

  	              header.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleCompanyGroup(companyEntry.key);
  	              });

  	              menu.appendChild(header);
  	            }

  	            function renderCollapsedCompanyNote(companyEntry) {
  	              const collapsedNote = document.createElement("div");
  	              collapsedNote.className = "trackit-company-collapsed-note";
  	              collapsedNote.textContent = "";

  	              collapsedNote.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleCompanyGroup(companyEntry.key);
  	              });

  	              menu.appendChild(collapsedNote);
  	            }

  	            function renderTypeGroupHeader(typeGroup, collapsed) {
  	              const header = document.createElement("div");
  	              header.className = "trackit-type-group-header";

  	              if (collapsed) header.classList.add("collapsed");

  	              const title = document.createElement("div");
  	              title.className = "trackit-type-group-title";
  	              title.textContent = typeGroup.label;

  	              const meta = document.createElement("div");
  	              meta.className = "trackit-type-group-meta";
  	              meta.textContent = String(typeGroup.nodes.length);

  	              const caret = document.createElement("span");
  	              caret.className = "trackit-type-group-caret";

  	              header.appendChild(title);
  	              header.appendChild(meta);
  	              header.appendChild(caret);

  	              header.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleTypeGroup(typeGroup.key);
  	              });

  	              menu.appendChild(header);
  	            }

  	            function renderCollapsedTypeGroupNote(typeGroup) {
  	              const collapsedNote = document.createElement("div");
  	              collapsedNote.className = "trackit-type-group-collapsed-note";
  	              collapsedNote.textContent = "";

  	              collapsedNote.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleTypeGroup(typeGroup.key);
  	              });

  	              menu.appendChild(collapsedNote);
  	            }

  	            function refreshDropdownLayoutAfterTreeChange() {
  	              try {
  	                requestAnimationFrame(function () {
  	                  if (typeof scheduleHubAndMenuResize === "function") {
  	                    scheduleHubAndMenuResize();
  	                  }

  	                  if (typeof updateMenuHeightToBottom === "function") {
  	                    updateMenuHeightToBottom();
  	                  }

  	                  notifyCarvedShellLayout();
  	                });

  	                setTimeout(notifyCarvedShellLayout,
  	                  80);
  	                setTimeout(notifyCarvedShellLayout,
  	                  220);
  	              } catch (_) {}
  	            }

  	            function activateLocationRow(rowData,
  	              searchMode) {
  	              if (!rowData) return;

  	              const hasChildren = hasAnyNodes(rowData.childrenNodes);

  	              const isCollapsed =
  	              !searchMode &&
  	              hasChildren &&
  	              root.__trackitCollapsedLocationTree[rowData.key] === true;

  	              if (hasChildren && isCollapsed) {
  	                root.__trackitCollapsedLocationTree[rowData.key] = false;

  	                renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	                openDropdown();
  	                refreshDropdownLayoutAfterTreeChange();

  	                return;
  	              }

  	              paintSelectedRow(rowData, true);
  	              closeDropdown();
  	            }

  	            function renderLocationRow(rowData, searchMode) {
  	              const rowIndex = visibleRows.length;
  	              visibleRows.push(rowData);

  	              const row = document.createElement("div");
  	              row.className = "trackit-location-item";
  	              row.__locationValue = rowData.value;
  	              row.__rowIndex = rowIndex;

  	              row.style.paddingLeft = `${22 + rowData.depth * 17}px`;

  	              if (selectedValue && rowData.value === selectedValue) {
  	                row.classList.add("selected");
  	              }

  	              const hasChildren = hasAnyNodes(rowData.childrenNodes);
  	              const collapsed =
  	              !searchMode &&
  	              hasChildren &&
  	              root.__trackitCollapsedLocationTree[rowData.key] === true;

  	              const caretHit = document.createElement("span");
  	              caretHit.className = "trackit-location-caret-hit";

  	              if (hasChildren) {
  	                const caret = document.createElement("span");
  	                caret.className = "trackit-location-caret";

  	                if (collapsed) {
  	                  caret.classList.add("collapsed");
  	                }

  	                caretHit.appendChild(caret);

  	                caretHit.addEventListener("mousedown", function (event) {
  	                  event.preventDefault();
  	                  event.stopPropagation();
  	                  toggleLocationNode(rowData.key);
  	                });
  	              } else {
  	                caretHit.classList.add("empty");
  	              }

  	              const img = document.createElement("img");
  	              img.className = "trackit-item-icon";
  	              img.alt = "";
  	              img.src = iconUrl(rowData.location);

  	              const textWrap = document.createElement("div");
  	              textWrap.className = "trackit-item-text-wrap";

  	              const labelElement = document.createElement("div");
  	              labelElement.className = "trackit-item-label";
  	              labelElement.textContent = rowData.label;

  	              const metaElement = document.createElement("div");
  	              metaElement.className = "trackit-item-meta";
  	              metaElement.textContent = rowData.meta || " ";

  	              textWrap.appendChild(labelElement);
  	              textWrap.appendChild(metaElement);

  	              row.appendChild(caretHit);
  	              row.appendChild(img);
  	              row.appendChild(textWrap);

  	              row.addEventListener("mousedown", function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();

  	                activateLocationRow(rowData, searchMode);
  	              });

  	              menu.appendChild(row);
  	            }

  	            function renderLocationNodes(nodes, q, searchMode, forceShowAll) {
  	              nodes.forEach(node => {
  	                const selfMatches = nodeSelfMatchesQuery(node, q);
  	                const treeMatches = nodeMatchesQuery(node, q);

  	                const shouldShow =
  	                forceShowAll ||
  	                !searchMode ||
  	                selfMatches ||
  	                treeMatches;

  	                if (!shouldShow) return;

  	                renderLocationRow(node, searchMode);

  	                const hasChildren = hasAnyNodes(node.childrenNodes);

  	                if (!hasChildren) return;

  	                const collapsed =
  	                !searchMode &&
  	                root.__trackitCollapsedLocationTree[node.key] === true;

  	                const shouldRenderChildren =
  	                searchMode
  	                ? (forceShowAll || treeMatches || selfMatches): !collapsed;

  	                if (!shouldRenderChildren) return;

  	                renderLocationNodes(
  	                  node.childrenNodes,
  	                  q,
  	                  searchMode,
  	                  forceShowAll || (searchMode && selfMatches)
  	                );
  	              });
  	            }

  	            function renderMenu(query) {
  	              if (isGoogleSearchMode()) {
  	                renderGoogleMenu(query);
  	                return;
  	              }

  	              const q = String(query || "").trim().toLowerCase();
  	              const searchMode = !!q;

  	              menu.innerHTML = "";
  	              visibleRows = [];
  	              activeIndex = -1;

  	              let renderedAny = false;

  	              if (!companyEntries.length) {
  	                const empty = document.createElement("div");
  	                empty.className = "trackit-empty";
  	                empty.textContent = "No companies or locations found";
  	                menu.appendChild(empty);
  	                return;
  	              }

  	              companyEntries.forEach(companyEntry => {
  	                const companySelfMatches = companyMatchesQuery(companyEntry, q);
  	                const companyTreeMatches = companyEntry.typeGroups.some(typeGroup => {
  	                  if (String(typeGroup.label || "").toLowerCase().includes(q)) return true;
  	                  return typeGroup.nodes.some(node => nodeMatchesQuery(node, q));
  	                });

  	                if (searchMode && !companySelfMatches && !companyTreeMatches) {
  	                  return;
  	                }

  	                const companyCollapsed =
  	                !searchMode &&
  	                root.__trackitCollapsedLocationTree[companyEntry.key] === true;

  	                renderCompanyHeader(companyEntry, companyCollapsed);
  	                renderedAny = true;

  	                if (companyCollapsed) {
  	                  renderCollapsedCompanyNote(companyEntry);
  	                  return;
  	                }

  	                companyEntry.typeGroups.forEach(typeGroup => {
  	                  if (!typeGroup.nodes.length) return;

  	                  const typeSelfMatches = String(typeGroup.label || "").toLowerCase().includes(q);
  	                  const typeTreeMatches = typeGroup.nodes.some(node => nodeMatchesQuery(node, q));

  	                  if (searchMode && !companySelfMatches && !typeSelfMatches && !typeTreeMatches) {
  	                    return;
  	                  }

  	                  const typeCollapsed =
  	                  !searchMode &&
  	                  root.__trackitCollapsedLocationTree[typeGroup.key] === true;

  	                  renderTypeGroupHeader(typeGroup, typeCollapsed);
  	                  renderedAny = true;

  	                  if (typeCollapsed) {
  	                    renderCollapsedTypeGroupNote(typeGroup);
  	                    return;
  	                  }

  	                  renderLocationNodes(
  	                    typeGroup.nodes,
  	                    q,
  	                    searchMode,
  	                    searchMode && (companySelfMatches || typeSelfMatches)
  	                  );
  	                });
  	              });

  	              if (!renderedAny || (searchMode && !visibleRows.length)) {
  	                menu.innerHTML = "";

  	                const empty = document.createElement("div");
  	                empty.className = "trackit-empty";
  	                empty.textContent = "No location found";
  	                menu.appendChild(empty);
  	              }

  	              requestAnimationFrame(() => {
  	                if (dropdown.classList.contains("open")) updateMenuHeightToBottom();
  	              });
  	            }

  	            // ============================================================
  	            // Initial render + existing selection
  	            // ============================================================

  	            renderMenu("");

  	            if (existingSelectedObjectId) {
  	              const existing = flatRows.find(row => row.value === String(existingSelectedObjectId));

  	              if (existing) {
  	                paintSelectedRow(existing, false);
  	              }
  	            }

  	            // ============================================================
  	            // Event listeners
  	            // ============================================================

  	            control.addEventListener("click", function (event) {
  	              if (event.target.closest(".trackit-arrow-hit")) return;
  	              if (event.target.closest(".trackit-clear")) return;
  	              if (event.target.closest(".trackit-google-toggle")) return;

  	              searchInput.focus();
  	              renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	              openDropdown();
  	            });

  	            arrowHit.addEventListener("mousedown",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	                toggleDropdownFromArrow();
  	              });

  	            arrowHit.addEventListener("click",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	              });

  	            googleToggle.addEventListener("mousedown",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();

  	                suppressFocusOpenUntil = Date.now() + 250;
  	                toggleLocationSearchMode();

  	                searchInput.focus();
  	                renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	                openDropdown();
  	              });

  	            googleToggle.addEventListener("click",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();
  	              });

  	            menu.addEventListener("mousedown",
  	              function (event) {
  	                if (!isGoogleSearchMode()) return;

  	                const googleRow = event.target.closest(".trackit-google-place-item");

  	                if (!googleRow) return;

  	                event.preventDefault();
  	                event.stopPropagation();

  	                const index = Number(googleRow.__googlePredictionIndex);

  	                if (!Number.isFinite(index)) return;

  	                selectGooglePrediction(index);
  	              });

  	            searchInput.addEventListener("focus",
  	              function () {
  	                if (Date.now() < suppressFocusOpenUntil) {
  	                  return;
  	                }

  	                renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	                openDropdown();

  	                setTimeout(() => {
  	                  try {
  	                    searchInput.select();
  	                  } catch (_) {}
  	                }, 0);
  	              });

  	            searchInput.addEventListener("input",
  	              function () {
  	                const query = searchInput.value;

  	                if (selectedValue && query !== selectedLabel) {
  	                  selectedValue = null;
  	                  selectedItem = null;
  	                  selectedLabel = "";
  	                  selectedRowData = null;

  	                  selectedIcon.removeAttribute("src");
  	                  dropdown.classList.remove("has-value");
  	                  closeActionCard();

  	                  menu.querySelectorAll(".trackit-location-item").forEach(element => {
  	                    element.classList.remove("selected");
  	                  });
  	                }

  	                setQueryState();
  	                renderMenu(query);
  	                openDropdown();
  	              });

  	            searchInput.addEventListener("keydown",
  	              function (event) {
  	                if (handleGoogleKeydown(event)) {
  	                  return;
  	                }
  	                if (event.key === "ArrowDown") {
  	                  event.preventDefault();

  	                  if (!dropdown.classList.contains("open")) {
  	                    openDropdown();
  	                  }

  	                  if (!visibleRows.length) return;

  	                  activeIndex = activeIndex < visibleRows.length - 1 ? activeIndex + 1: 0;
  	                  paintActiveRow();
  	                  return;
  	                }

  	                if (event.key === "ArrowUp") {
  	                  event.preventDefault();

  	                  if (!visibleRows.length) return;

  	                  activeIndex = activeIndex > 0 ? activeIndex - 1: visibleRows.length - 1;
  	                  paintActiveRow();
  	                  return;
  	                }

  	                if (event.key === "Enter") {
  	                  if (activeIndex >= 0 && visibleRows[activeIndex]) {
  	                    event.preventDefault();
  	                    activateLocationRow(visibleRows[activeIndex], false);
  	                    return;
  	                  }

  	                  if (activeIndex === -1 && visibleRows.length === 1) {
  	                    event.preventDefault();
  	                    activateLocationRow(visibleRows[0], false);
  	                    return;
  	                  }
  	                }

  	                if (event.key === "Escape") {
  	                  closeDropdown();

  	                  if (selectedLabel) {
  	                    searchInput.value = selectedLabel;
  	                  }

  	                  setQueryState();
  	                }
  	              });

  	            clear.addEventListener("mousedown",
  	              function (event) {
  	                event.preventDefault();
  	                event.stopPropagation();

  	                clearSelected(true);
  	                searchInput.focus();
  	                openDropdown();
  	              });

  	            actionCard.addEventListener("mousedown",
  	              function (event) {
  	                event.stopPropagation();

  	                const closeButton = event.target.closest("[data-card-close]");

  	                if (closeButton) {
  	                  event.preventDefault();
  	                  closeActionCard();
  	                  return;
  	                }

  	                const childButton = event.target.closest("[data-card-child-index]");

  	                if (childButton) {
  	                  event.preventDefault();

  	                  const index = Number(childButton.getAttribute("data-card-child-index"));
  	                  const childRow = actionCard.__childRows && actionCard.__childRows[index];

  	                  if (!childRow) return;

  	                  paintSelectedRow(childRow, true);
  	                  closeDropdown();

  	                  return;
  	                }

  	                const actionButton = event.target.closest("[data-card-action]");

  	                if (actionButton) {
  	                  event.preventDefault();

  	                  const action = actionButton.getAttribute("data-card-action");

  	                  if (action === "functionalityHelp") {
  	                    const title = actionButton.getAttribute("data-functionality-help-title") || "Help";
  	                    const body = actionButton.getAttribute("data-functionality-help-body") || "";
  	                    const panel = actionCard.querySelector("[data-card-functionality-help-panel]");

  	                    if (panel) {
  	                      panel.innerHTML = `
  	                      <div class="trackit-card-functionality-help-box">
  	                      <div class="trackit-card-functionality-help-title">${escapeHtml(title)}</div>
  	                      <div class="trackit-card-functionality-help-body">${escapeHtml(body)}</div>
  	                      </div>
  	                      `;

  	                      notifyCarvedShellLayout();
  	                    }

  	                    return;
  	                  }

  	                  handleCardAction(action);
  	                }
  	              });

  	            actionCard.addEventListener("input",
  	              function (event) {
  	                const target = event.target;

  	                if (!target) return;

  	                if (target.matches('[data-card-edit-field="contactNumber"]')) {
  	                  target.value = filterCardPhoneValue(target.value);
  	                }

  	                if (target.matches("[data-card-functionality-phone]")) {
  	                  target.value = filterCardPhoneValue(target.value);
  	                }

  	                if (target.matches('[data-card-edit-field="color"]')) {
  	                  const preview = actionCard.querySelector(".trackit-card-color-preview");

  	                  if (preview) {
  	                    preview.style.background = target.value || "#cc6633";
  	                  }
  	                }
  	              });

  	            actionCard.addEventListener("change",
  	              function (event) {
  	                const target = event.target;

  	                if (!target) return;

  	                if (target.matches("[data-card-functionality-key]")) {
  	                  const key = target.getAttribute("data-card-functionality-key");

  	                  if (key === "publicFuelStation" && target.checked) {
  	                    const depotInput = actionCard.querySelector('[data-card-functionality-key="fuelDepot"]');

  	                    if (depotInput) depotInput.checked = false;
  	                  }

  	                  if (key === "fuelDepot" && target.checked) {
  	                    const publicInput = actionCard.querySelector('[data-card-functionality-key="publicFuelStation"]');

  	                    if (publicInput) publicInput.checked = false;
  	                  }

  	                  updateFunctionalityVisibility();
  	                }
  	              });

  	            const documentClickHandler = function (event) {
  	              if (!dropdown.contains(event.target)) {
  	                closeDropdown();

  	                if (selectedLabel) {
  	                  searchInput.value = selectedLabel;
  	                }

  	                setQueryState();
  	              }
  	            };

  	            const resizeHandler = function () {
  	              if (dropdown.classList.contains("open")) {
  	                scheduleHubAndMenuResize();
  	              }
  	            };

  	            document.addEventListener("mousedown", documentClickHandler);
  	            window.addEventListener("resize", resizeHandler);
  	            window.addEventListener("orientationchange", resizeHandler);
  	            window.addEventListener("trackitMapControlLayoutChanged", mapControlLayoutHandler);
  	            window.addEventListener("trackitMapControlLayoutChanged", scheduleHubAndMenuResize);

  	            bindMapControlLayoutListener();

  	            // ============================================================
  	            // Public API + cleanup
  	            // ============================================================

  	            root.__locationDropdownApi = {
  	              version: "placeholder-card-router-1",
  	              mode: SEARCH_ACTION_MODE,
  	              root,
  	              dropdown,
  	              menu,
  	              actionCard,
  	              companies,
  	              companyEntries,
  	              getFlatRows() {
  	                return flatRows.slice();
  	              },
  	              getSelected() {
  	                return {
  	                  value: selectedValue,
  	                  item: selectedItem,
  	                  location: selectedItem,
  	                  rowData: selectedRowData
  	                };
  	              },
  	              clear() {
  	                clearSelected(true);
  	              },
  	              open() {
  	                renderMenu(searchInput.value === selectedLabel ? "": searchInput.value);
  	                openDropdown();
  	              },
  	              close() {
  	                closeDropdown();
  	                closeActionCard();
  	              },
  	              refresh() {
  	                buildTreeRows();
  	                markDefaultCollapsedStates();
  	                renderMenu("");
  	              },
  	              openSelectedPlaceholderCard() {
  	                if (selectedRowData) {
  	                  openLocationActionCard(selectedRowData);
  	                }
  	              }
  	            };

  	            root.__locationDropdownCleanup = function () {
  	              try {
  	                document.removeEventListener("mousedown", documentClickHandler);
  	              } catch (_) {}

  	              try {
  	                window.removeEventListener("resize", resizeHandler);
  	                window.removeEventListener("orientationchange", resizeHandler);
  	                window.removeEventListener("trackitMapControlLayoutChanged", mapControlLayoutHandler);
  	                window.removeEventListener("trackitMapControlLayoutChanged", scheduleHubAndMenuResize);
  	              } catch (_) {}

  	              if (mapControlWatchRetry) {
  	                try {
  	                  clearTimeout(mapControlWatchRetry);
  	                } catch (_) {}

  	                mapControlWatchRetry = null;
  	              }

  	              if (menuResizeRaf) {
  	                try {
  	                  cancelAnimationFrame(menuResizeRaf);
  	                } catch (_) {}

  	                menuResizeRaf = 0;
  	              }

  	              if (watchedMapControl) {
  	                try {
  	                  watchedMapControl.removeEventListener("click", mapControlLayoutHandler, true);
  	                } catch (_) {}
  	              }

  	              if (mapControlMutationObserver) {
  	                try {
  	                  mapControlMutationObserver.disconnect();
  	                } catch (_) {}
  	              }

  	              if (mapControlResizeObserver) {
  	                try {
  	                  mapControlResizeObserver.disconnect();
  	                } catch (_) {}
  	              }

  	              resetHubHeight();

  	              try {
  	                root.innerHTML = "";
  	              } catch (_) {}
  	            };

  	            console.groupCollapsed("[TrackIT Location Dropdown] Loaded");
  	            console.log("Version:", "placeholder-card-router-1");
  	            console.log("Action Mode:", SEARCH_ACTION_MODE);
  	            console.log("Companies:", companies);
  	            console.log("Company Entries:", companyEntries);
  	            console.log("Flat Rows:", flatRows);
  	            console.log("Root:", root);
  	            console.log("Map Input:", MapRoot);
  	            console.groupEnd();
  	          })();
  	        }
  	      };

  	      window.__CarvedEdgeShapeDropdownBridge = bridge;

  	      console.groupCollapsed("[Carved Edge Shape UI] Dropdown Bridge Placeholder Mounted");
  	      console.log("Host:",
  	        host);
  	      console.log("Bridge:",
  	        bridge);
  	      console.groupEnd();
  	    }

  	    function cleanupMountedTrackITDropdown(root) {
  	      try {
  	        const bridge = window.__CarvedEdgeShapeDropdownBridge || null;
  	        const bridgeHost = bridge && bridge.host ? bridge.host: null;
  	        const currentHost = root && root.querySelector
  	        ? root.querySelector("[data-location-dropdown-host]"): null;

  	        const host = bridgeHost || currentHost;

  	        if (host && typeof host.__locationDropdownCleanup === "function") {
  	          host.__locationDropdownCleanup();
  	          host.__locationDropdownCleanup = null;
  	        }
  	      } catch (error) {
  	        console.warn("[Carved Edge Shape UI] Could not cleanup mounted TrackIT dropdown.", error);
  	      }
  	    }

  	    function ensureTrackITSearchDropdownMounted(root, userMode) {
  	      try {
  	        if (!root || !root.isConnected || !DATA_CHANNEL) return;

  	        const host = root.querySelector("[data-location-dropdown-host]");

  	        if (!host) return;

  	        if (host.querySelector(".trackit-location-dropdown")) {
  	          return;
  	        }

  	        mountLocationDropdownBridgePlaceholder(root, userMode);

  	        const bridge = window.__CarvedEdgeShapeDropdownBridge || null;

  	        if (bridge && typeof bridge.mountTrackITDropdown === "function") {
  	          bridge.mountTrackITDropdown();

  	          if (typeof bridge.resizeTopShell === "function") {
  	            bridge.resizeTopShell();
  	          }
  	        }
  	      } catch (error) {
  	        console.warn("[Carved Edge Shape UI] Could not remount TrackIT dropdown.", error);
  	      }
  	    }

  	    function getCompanyLabel(value) {
  	      const found = COMPANY_OPTIONS.find(item => item.value === value);
  	      return found ? found.label: "Company";
  	    }

  	    function getActiveLocationTypeOptions() {
  	      return buildLocationTypeOptionsForCompany(createState.company);
  	    }

  	    function getLocationType(value) {
  	      return getActiveLocationTypeOptions().find(item => item.value === value) || null;
  	    }

  	    function resetFunctionalityState() {
  	      createState.functionality.eventsCapture = false;
  	      createState.functionality.fuelLogic = false;
  	      createState.functionality.publicFuelStation = false;
  	      createState.functionality.fuelDepot = false;
  	      createState.functionality.loadLogic = false;
  	      createState.functionality.gateLogic = false;
  	      createState.functionality.gatePhone = "";
  	    }

  	    function resetCreateState() {
  	      createState.isCreating = false;
  	      createState.company = "";
  	      createState.locationType = "";
  	      createState.creationMode = "";
  	      createState.name = "";
  	      createState.openDropdown = "";
  	      createState.isPlotting = false;
  	      createState.isSaved = false;
  	      createState.modalMode = "";
  	      createState.helpTopic = "";
  	      createState.typeManagerName = "";
  	      createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	      createState.typeManagerOriginalName = "";
  	      resetFunctionalityState();
  	    }

  	    function removeExistingUI() {
  	      if (window.__CarvedEdgeShapeUI && typeof window.__CarvedEdgeShapeUI.cleanup === "function") {
  	        try {
  	          window.__CarvedEdgeShapeUI.cleanup();
  	        } catch (error) {
  	          console.warn("[Carved Edge Shape UI] Previous cleanup failed.", error);
  	        }
  	      }

  	      const ids = Array.isArray(OLD_ENGINE_IDS) && OLD_ENGINE_IDS.length
  	      ? OLD_ENGINE_IDS: [ENGINE_ID];

  	      ids.forEach(id => {
  	        const existing = document.getElementById(id);

  	        if (existing && existing.parentNode) {
  	          existing.parentNode.removeChild(existing);
  	        }
  	      });
  	    }

  	    function getTopHeight(userMode) {
  	      if (!userMode.canCreateLocations) return 56;
  	      if (!createState.isCreating) return 94;
  	      if (!createState.company) return 98;
  	      if (!createState.locationType) return 138;
  	      if (!createState.creationMode) return 218;
  	      if (!createState.name.trim()) return 268;
  	      return 318;
  	    }

  	    function clearSearchPanelResizeTimers() {
  	      if (searchPanelResizeRaf) {
  	        try {
  	          cancelAnimationFrame(searchPanelResizeRaf);
  	        } catch (_) {}

  	        searchPanelResizeRaf = 0;
  	      }

  	      searchPanelResizeTimeouts.forEach(timer => {
  	        try {
  	          clearTimeout(timer);
  	        } catch (_) {}
  	      });

  	      searchPanelResizeTimeouts = [];
  	    }

  	    function getTopPanelBottomLimit(root) {
  	      try {
  	        const engineRect = root.getBoundingClientRect();

  	        const selectors = [
  	          ".ces-bottom-shape",
  	          ".ces-bottom-content",
  	          ".trackit-compact-map-control",
  	          ".trackit-map-control",
  	          "[data-map-control]",
  	          "[data-trackit-map-control]"
  	        ];

  	        let nearestTop = Infinity;

  	        selectors.forEach(selector => {
  	          root.querySelectorAll(selector).forEach(element => {
  	            const rect = element.getBoundingClientRect();

  	            if (rect.width > 0 && rect.height > 0) {
  	              nearestTop = Math.min(nearestTop, rect.top);
  	            }
  	          });

  	          document.querySelectorAll(selector).forEach(element => {
  	            const rect = element.getBoundingClientRect();

  	            if (rect.width > 0 && rect.height > 0) {
  	              nearestTop = Math.min(nearestTop, rect.top);
  	            }
  	          });
  	        });

  	        if (Number.isFinite(nearestTop)) {
  	          return Math.max(56, Math.floor(nearestTop - engineRect.top - 10));
  	        }
  	      } catch (_) {}

  	      try {
  	        const engineRect = root.getBoundingClientRect();
  	        return Math.max(56, Math.floor(window.innerHeight - engineRect.top - 86));
  	      } catch (_) {}

  	      return 520;
  	    }

  	    function setTopShapeHeight(root, height) {
  	      const topShape = root.querySelector(".ces-top-shape");

  	      if (!topShape) return;

  	      const safeHeight = Math.max(56, Math.floor(Number(height) || 94));
  	      const currentHeight = Number(topShape.getAttribute("data-ces-top-height") || 0);

  	      if (currentHeight === safeHeight) {
  	        return;
  	      }

  	      topShape.setAttribute("data-ces-top-height", String(safeHeight));
  	      topShape.style.transition = "none";
  	      topShape.style.height = `${safeHeight}px`;

  	      topShape.querySelectorAll(".ces-panel-svg").forEach(svg => {
  	        try {
  	          svg.remove();
  	        } catch (_) {}
  	      });

  	      topShape.insertAdjacentHTML("afterbegin", createTopSvg(safeHeight));
  	    }

  	    function getOpenSearchPanelNaturalHeight(openPanel) {
  	      if (!openPanel) return 0;

  	      try {
  	        if (openPanel.classList && openPanel.classList.contains("trackit-menu")) {
  	          let contentHeight = 0;

  	          Array.from(openPanel.children).forEach(child => {
  	            const childRect = child.getBoundingClientRect();

  	            if (childRect && childRect.height) {
  	              contentHeight += childRect.height;
  	            }
  	          });

  	          if (contentHeight > 0) {
  	            return Math.ceil(contentHeight + 8);
  	          }
  	        }

  	        const scrollHeight = Math.ceil(openPanel.scrollHeight || 0);

  	        if (scrollHeight > 0) {
  	          return scrollHeight;
  	        }

  	        const rect = openPanel.getBoundingClientRect();
  	        return Math.ceil(rect.height || 0);
  	      } catch (_) {
  	        return 0;
  	      }
  	    }

  	    function getLiveSearchExpansionHeight(root, userMode) {
  	      const baseHeight = getTopHeight(userMode);

  	      if (!userMode.canCreateLocations) return baseHeight;
  	      if (createState.isCreating) return baseHeight;
  	      if (createState.modalMode) return baseHeight;

  	      const topShape = root.querySelector(".ces-top-shape");
  	      const host = root.querySelector("[data-location-dropdown-host]");

  	      if (!topShape || !host) return baseHeight;

  	      const openMenu = host.querySelector(".trackit-location-dropdown.open .trackit-menu");
  	      const openCard = host.querySelector(".trackit-action-card.open");
  	      const openPanel = openMenu || openCard;

  	      if (!openPanel) return baseHeight;

  	      try {
  	        const topRect = topShape.getBoundingClientRect();
  	        const panelRect = openPanel.getBoundingClientRect();

  	        const panelTopInsideShell = Math.ceil(panelRect.top - topRect.top);
  	        const naturalHeight = getOpenSearchPanelNaturalHeight(openPanel);

  	        return Math.max(baseHeight, panelTopInsideShell + naturalHeight + 10);
  	      } catch (_) {
  	        return baseHeight;
  	      }
  	    }

  	    function fitSearchDropdownToTopShell(root, finalHeight) {
  	      try {
  	        const topShape = root.querySelector(".ces-top-shape");
  	        const host = root.querySelector("[data-location-dropdown-host]");
  	        const menu = host?.querySelector(".trackit-location-dropdown.open .trackit-menu");
  	        const actionCard = host?.querySelector(".trackit-action-card.open");
  	        const openPanel = menu || actionCard;

  	        if (!topShape || !host || !openPanel) return;

  	        const topRect = topShape.getBoundingClientRect();
  	        const panelRect = openPanel.getBoundingClientRect();

  	        const panelTopInsideShell = Math.ceil(panelRect.top - topRect.top);
  	        const availableHeight = Math.max(40, Math.floor(finalHeight - panelTopInsideShell - 10));
  	        const naturalHeight = getOpenSearchPanelNaturalHeight(openPanel);
  	        const fittedHeight = Math.max(40, Math.min(naturalHeight, availableHeight));

  	        if (menu) {
  	          menu.style.setProperty("--trackit-menu-height", `${fittedHeight}px`);
  	          menu.style.height = `${fittedHeight}px`;
  	          menu.style.maxHeight = `${fittedHeight}px`;
  	        }

  	        if (actionCard) {
  	          actionCard.style.maxHeight = `${fittedHeight}px`;
  	        }
  	      } catch (_) {}
  	    }

  	    function updateSearchPanelHeight(root, userMode) {
  	      if (!root) return;

  	      const baseHeight = getTopHeight(userMode);
  	      const neededHeight = getLiveSearchExpansionHeight(root, userMode);
  	      const bottomLimit = getTopPanelBottomLimit(root);

  	      const finalHeight = Math.max(baseHeight, Math.min(neededHeight, bottomLimit));

  	      setTopShapeHeight(root, finalHeight);
  	      fitSearchDropdownToTopShell(root, finalHeight);
  	    }

  	    function scheduleSearchPanelHeight(root, userMode) {
  	      clearSearchPanelResizeTimers();

  	      if (searchPanelResizeRaf) {
  	        return;
  	      }

  	      searchPanelResizeRaf = requestAnimationFrame(() => {
  	        searchPanelResizeRaf = 0;
  	        updateSearchPanelHeight(root, userMode);
  	      });
  	    }

  	    function bindSearchPanelMapControlWatcher(root, userMode) {
  	      try {
  	        if (!root || root.__searchPanelMapControlWatcherBound) return;

  	        root.__searchPanelMapControlWatcherBound = true;

  	        const handler = () => {
  	          scheduleSearchPanelHeight(root, userMode);
  	        };

  	        root.__searchPanelMapControlHandler = handler;

  	        window.addEventListener("resize", handler);
  	        window.addEventListener("trackitMapControlLayoutChanged", handler);

  	        root.__searchPanelMapControlObserver = null;
  	      } catch (_) {}
  	    }

  	    function unbindSearchPanelMapControlWatcher(root) {
  	      try {
  	        if (!root) return;

  	        if (root.__searchPanelMapControlHandler) {
  	          window.removeEventListener("resize", root.__searchPanelMapControlHandler);
  	          window.removeEventListener("trackitMapControlLayoutChanged", root.__searchPanelMapControlHandler);
  	        }

  	        if (root.__searchPanelMapControlObserver) {
  	          root.__searchPanelMapControlObserver.disconnect();
  	        }

  	        root.__searchPanelMapControlWatcherBound = false;
  	        root.__searchPanelMapControlHandler = null;
  	        root.__searchPanelMapControlObserver = null;
  	      } catch (_) {}
  	    }

  	    function resetSearchPanelHeight(root, userMode) {
  	      clearSearchPanelResizeTimers();
  	      setTopShapeHeight(root, getTopHeight(userMode));
  	    }

  	    function getCurrentRequiredStep(userMode) {
  	      if (!userMode.canCreateLocations) return "";
  	      if (!createState.isCreating) return "";
  	      if (createState.modalMode) return "";
  	      if (!createState.company) return "company";
  	      if (!createState.locationType) return "locationType";
  	      if (!createState.creationMode) return "creationMode";
  	      if (!createState.name.trim()) return "name";
  	      if (!createState.isPlotting) return "plotLocation";
  	      if (createState.isPlotting && !createState.isSaved) return "saveLocation";
  	      return "";
  	    }

  	    function clearAttention(root) {
  	      if (attentionTimer) {
  	        clearTimeout(attentionTimer);
  	        attentionTimer = null;
  	      }

  	      if (!root) return;

  	      root.querySelectorAll(".ces-needs-input").forEach(element => {
  	        element.classList.remove("ces-needs-input");
  	      });
  	    }

  	    function scheduleAttention(root, userMode) {
  	      clearAttention(root);

  	      const step = getCurrentRequiredStep(userMode);
  	      if (!step) return;

  	      attentionTimer = setTimeout(() => {
  	        const stillCurrent = getCurrentRequiredStep(userMode);
  	        if (stillCurrent !== step) return;

  	        let target = null;

  	        if (step === "company") {
  	          target = root.querySelector(".ces-dd-company .ces-dd-button");
  	        }

  	        if (step === "locationType") {
  	          target = root.querySelector(".ces-dd-location-type .ces-dd-button");
  	        }

  	        if (step === "creationMode") {
  	          target = root.querySelector(".ces-creation-panel");
  	        }

  	        if (step === "name") {
  	          target = root.querySelector(".ces-name-wrap");
  	        }

  	        if (step === "plotLocation") {
  	          target = root.querySelector(".ces-plot-location-button");
  	        }

  	        if (step === "saveLocation") {
  	          target = root.querySelector(".ces-save-location-button");
  	        }

  	        if (target) {
  	          target.classList.add("ces-needs-input");
  	        }
  	      },
  	        5000);
  	    }

  	    function injectStyles() {
  	      let style = document.getElementById(STYLE_ID);

  	      if (!style) {
  	        style = document.createElement("style");
  	        style.id = STYLE_ID;
  	        document.head.appendChild(style);
  	      }

  	      style.textContent = `
  	      #${ENGINE_ID} {
  	      position: fixed;
  	      top: 50px;
  	      right: 0;
  	      bottom: 0;
  	      width: 228px;
  	      z-index: 2147483647;
  	      pointer-events: none;
  	      font-family: Inter, Arial, sans-serif;
  	      color: #f8fafc;
  	      user-select: none;
  	      }

  	      #${ENGINE_ID} * {
  	      box-sizing: border-box;
  	      }

  	      #${ENGINE_ID} .ces-top-shape {
  	      position: absolute;
  	      top: 0;
  	      right: 0;
  	      width: 228px;
  	      pointer-events: none;
  	      overflow: visible;
  	      filter:
  	      drop-shadow(-12px 14px 16px rgba(0,0,0,0.34))
  	      drop-shadow(0 0 10px rgba(255,122,36,0.08));
  	      }

  	      #${ENGINE_ID} .ces-bottom-shape {
  	      position: absolute;
  	      right: 0;
  	      bottom: 0;
  	      width: 228px;
  	      height: 66px;
  	      pointer-events: none;
  	      overflow: visible;
  	      filter:
  	      drop-shadow(-12px -14px 16px rgba(0,0,0,0.34))
  	      drop-shadow(0 0 10px rgba(255,122,36,0.08));
  	      }

  	      #${ENGINE_ID} .ces-panel-svg {
  	      position: absolute;
  	      inset: 0;
  	      width: 100%;
  	      height: 100%;
  	      overflow: visible;
  	      }

  	      #${ENGINE_ID} .ces-top-content {
  	      position: absolute;
  	      top: 9px;
  	      left: 46px;
  	      width: 174px;
  	      pointer-events: auto;
  	      z-index: 10;
  	      }

  	      #${ENGINE_ID} .ces-bottom-content {
  	      position: absolute;
  	      top: 10px;
  	      left: 46px;
  	      width: 174px;
  	      pointer-events: auto;
  	      z-index: 10;
  	      }

  	      #${ENGINE_ID} .ces-location-line {
  	      display: grid;
  	      align-items: center;
  	      gap: 8px;
  	      height: 34px;
  	      }

  	      #${ENGINE_ID} .ces-admin-line {
  	      grid-template-columns: 34px 1fr;
  	      }

  	      #${ENGINE_ID} .ces-create-line {
  	      grid-template-columns: 34px 1fr 24px;
  	      }

  	      #${ENGINE_ID} .ces-user-line {
  	      grid-template-columns: 1fr;
  	      }

  	      #${ENGINE_ID} .ces-add-square {
  	      width: 34px;
  	      height: 34px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 14px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: #ff9a3d;
  	      font-size: 14px;
  	      background:
  	      radial-gradient(circle at 35% 25%, rgba(255,122,36,0.36), rgba(0,0,0,0.88) 72%);
  	      border: 1px solid rgba(255,122,36,0.58);
  	      box-shadow:
  	      0 0 18px rgba(255,122,36,0.20),
  	      inset 0 1px 0 rgba(255,255,255,0.08),
  	      inset 0 -1px 0 rgba(0,0,0,0.34);
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-add-square:hover {
  	      border-color: rgba(255,154,61,0.86);
  	      box-shadow:
  	      0 0 22px rgba(255,122,36,0.32),
  	      inset 0 1px 0 rgba(255,255,255,0.10),
  	      inset 0 -1px 0 rgba(0,0,0,0.34);
  	      }

  	      #${ENGINE_ID} .ces-close-create {
  	      width: 24px;
  	      height: 24px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 10px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: rgba(255,216,191,0.82);
  	      font-size: 13px;
  	      font-weight: 950;
  	      background: rgba(0,0,0,0.54);
  	      border: 1px solid rgba(255,122,36,0.24);
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-close-create:hover {
  	      color: #ff9a3d;
  	      border-color: rgba(255,122,36,0.52);
  	      }

  	      #${ENGINE_ID} .ces-title-wrap {
  	      min-width: 0;
  	      }

  	      #${ENGINE_ID} .ces-title {
  	      max-width: 126px;
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      color: #ffd8bf;
  	      font-size: 12px;
  	      font-weight: 950;
  	      line-height: 1.05;
  	      }

  	      #${ENGINE_ID} .ces-user-line .ces-title {
  	      max-width: 166px;
  	      }

  	      #${ENGINE_ID} .ces-subtitle {
  	      margin-top: 4px;
  	      color: rgba(226,232,240,0.48);
  	      font-size: 7px;
  	      font-weight: 900;
  	      text-transform: uppercase;
  	      letter-spacing: 0.11em;
  	      }

  	      #${ENGINE_ID} .ces-search,
  	      #${ENGINE_ID} .ces-name-wrap {
  	      width: 100%;
  	      height: 28px;
  	      margin-top: 8px;
  	      border-radius: 14px;
  	      display: grid;
  	      align-items: center;
  	      gap: 5px;
  	      padding: 0 9px;
  	      background: rgba(0,0,0,0.64);
  	      border: 1px solid rgba(255,122,36,0.18);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.04),
  	      0 0 12px rgba(255,122,36,0.05);
  	      }

  	      #${ENGINE_ID} .ces-search {
  	      grid-template-columns: 18px 1fr 12px;
  	      }

  	      #${ENGINE_ID} .ces-name-wrap {
  	      grid-template-columns: 18px 1fr;
  	      }

  	      #${ENGINE_ID} .ces-search-icon,
  	      #${ENGINE_ID} .ces-name-icon {
  	      color: rgba(255,193,148,0.66);
  	      font-size: 12px;
  	      }

  	      #${ENGINE_ID} .ces-search input,
  	      #${ENGINE_ID} .ces-name-wrap input {
  	      width: 100%;
  	      border: 0;
  	      outline: 0;
  	      background: transparent;
  	      color: rgba(248,250,252,0.82);
  	      font-size: 10px;
  	      font-weight: 750;
  	      }

  	      #${ENGINE_ID} .ces-search input {
  	      pointer-events: none;
  	      }

  	      #${ENGINE_ID} .ces-search input::placeholder,
  	      #${ENGINE_ID} .ces-name-wrap input::placeholder {
  	      color: rgba(226,232,240,0.44);
  	      }

  	      #${ENGINE_ID} .ces-search-caret {
  	      color: rgba(255,122,36,0.62);
  	      font-size: 9px;
  	      text-align: right;
  	      pointer-events: none;
  	      }

  	      #${ENGINE_ID} .ces-dd {
  	      position: relative;
  	      width: 100%;
  	      margin-top: 8px;
  	      z-index: 50;
  	      }

  	      #${ENGINE_ID} .ces-dd-button {
  	      width: 100%;
  	      height: 28px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 14px;
  	      display: grid;
  	      grid-template-columns: 18px 1fr 12px;
  	      align-items: center;
  	      gap: 5px;
  	      padding: 0 9px;
  	      color: rgba(248,250,252,0.82);
  	      text-align: left;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.11), rgba(255,122,36,0.00) 46%),
  	      linear-gradient(145deg, rgba(10,13,14,0.96), rgba(0,0,0,0.82));
  	      border: 1px solid rgba(255,122,36,0.22);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.045),
  	      0 0 12px rgba(255,122,36,0.06);
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-dd-button:hover,
  	      #${ENGINE_ID} .ces-dd.ces-dd-open .ces-dd-button {
  	      border-color: rgba(255,122,36,0.48);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.055),
  	      0 0 16px rgba(255,122,36,0.12);
  	      }

  	      #${ENGINE_ID} .ces-dd-location-type .ces-dd-button {
  	      grid-template-columns: 18px 10px 1fr 12px;
  	      }

  	      #${ENGINE_ID} .ces-dd-icon {
  	      color: rgba(255,193,148,0.68);
  	      font-size: 11px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      }

  	      #${ENGINE_ID} .ces-dd-label {
  	      min-width: 0;
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      color: rgba(248,250,252,0.82);
  	      font-size: 10px;
  	      font-weight: 850;
  	      }

  	      #${ENGINE_ID} .ces-dd-caret {
  	      color: rgba(255,122,36,0.66);
  	      font-size: 9px;
  	      text-align: right;
  	      }

  	      #${ENGINE_ID} .ces-type-dot {
  	      width: 8px;
  	      height: 8px;
  	      border-radius: 999px;
  	      display: block;
  	      background: rgba(255,122,36,0.85);
  	      box-shadow:
  	      0 0 0 3px rgba(255,122,36,0.09),
  	      0 0 10px rgba(255,122,36,0.28);
  	      }

  	      #${ENGINE_ID} .ces-type-dot.ces-dot-empty {
  	      opacity: 0.28;
  	      background: rgba(255,255,255,0.28);
  	      box-shadow: none;
  	      }

  	      #${ENGINE_ID} .ces-dd-list {
  	      position: absolute;
  	      top: 34px;
  	      left: 0;
  	      right: 0;
  	      max-height: 116px;
  	      overflow-y: auto;
  	      overflow-x: hidden;
  	      padding: 5px;
  	      border-radius: 15px;
  	      background:
  	      radial-gradient(circle at 0% 0%, rgba(255,122,36,0.13), rgba(255,122,36,0.00) 44%),
  	      linear-gradient(145deg, rgba(13,17,18,0.98), rgba(0,0,0,0.96));
  	      border: 1px solid rgba(255,122,36,0.34);
  	      box-shadow:
  	      -14px 16px 32px rgba(0,0,0,0.42),
  	      0 0 22px rgba(255,122,36,0.12),
  	      inset 0 1px 0 rgba(255,255,255,0.055);
  	      backdrop-filter: blur(18px);
  	      z-index: 200;
  	      display: none;
  	      }

  	      #${ENGINE_ID} .ces-dd.ces-dd-open .ces-dd-list {
  	      display: block;
  	      }

  	      #${ENGINE_ID} .ces-dd-list::-webkit-scrollbar,
  	      #${ENGINE_ID} .ces-functionality-list::-webkit-scrollbar {
  	      width: 6px;
  	      }

  	      #${ENGINE_ID} .ces-dd-list::-webkit-scrollbar-track,
  	      #${ENGINE_ID} .ces-functionality-list::-webkit-scrollbar-track {
  	      background: rgba(0,0,0,0.44);
  	      border-radius: 999px;
  	      }

  	      #${ENGINE_ID} .ces-dd-list::-webkit-scrollbar-thumb,
  	      #${ENGINE_ID} .ces-functionality-list::-webkit-scrollbar-thumb {
  	      background:
  	      linear-gradient(
  	      to bottom,
  	      rgba(255,122,36,0.84),
  	      rgba(120,49,15,0.84)
  	      );
  	      border-radius: 999px;
  	      box-shadow: 0 0 8px rgba(255,122,36,0.32);
  	      }

  	      #${ENGINE_ID} .ces-dd-list,
  	      #${ENGINE_ID} .ces-functionality-list {
  	      scrollbar-width: thin;
  	      scrollbar-color: rgba(255,122,36,0.84) rgba(0,0,0,0.44);
  	      }

  	      #${ENGINE_ID} .ces-dd-option {
  	      width: 100%;
  	      min-height: 28px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 11px;
  	      display: grid;
  	      grid-template-columns: 1fr;
  	      align-items: center;
  	      gap: 7px;
  	      padding: 0 9px;
  	      color: rgba(248,250,252,0.78);
  	      background: transparent;
  	      text-align: left;
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-dd-location-type .ces-dd-option {
  	      grid-template-columns: 10px 1fr;
  	      }

  	      #${ENGINE_ID} .ces-dd-option span:last-child,
  	      #${ENGINE_ID} .ces-dd-option-label {
  	      min-width: 0;
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      font-size: 10px;
  	      font-weight: 820;
  	      }

  	      #${ENGINE_ID} .ces-dd-option:hover,
  	      #${ENGINE_ID} .ces-dd-option.ces-dd-option-selected {
  	      color: #ffd8bf;
  	      background:
  	      linear-gradient(145deg, rgba(255,122,36,0.18), rgba(255,122,36,0.04));
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.045),
  	      0 0 12px rgba(255,122,36,0.08);
  	      }

  	      #${ENGINE_ID} .ces-dd-option + .ces-dd-option {
  	      margin-top: 3px;
  	      }

  	      #${ENGINE_ID} .ces-creation-panel {
  	      margin-top: 8px;
  	      padding: 8px;
  	      border-radius: 16px;
  	      background: rgba(0,0,0,0.46);
  	      border: 1px solid rgba(255,122,36,0.16);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.04),
  	      0 0 12px rgba(255,122,36,0.05);
  	      }

  	      #${ENGINE_ID} .ces-creation-title {
  	      color: rgba(255,216,191,0.78);
  	      font-size: 8px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.10em;
  	      margin-bottom: 7px;
  	      }

  	      #${ENGINE_ID} .ces-mode-row {
  	      display: grid;
  	      grid-template-columns: 1fr 1fr 1fr;
  	      gap: 6px;
  	      }

  	      #${ENGINE_ID} .ces-mode-button {
  	      height: 44px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 13px;
  	      display: flex;
  	      flex-direction: column;
  	      align-items: center;
  	      justify-content: center;
  	      gap: 4px;
  	      background: rgba(0,0,0,0.48);
  	      border: 1px solid rgba(255,122,36,0.16);
  	      color: rgba(255,216,191,0.62);
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-mode-button:hover,
  	      #${ENGINE_ID} .ces-mode-button.ces-mode-selected {
  	      border-color: rgba(255,122,36,0.62);
  	      color: #ffd8bf;
  	      box-shadow:
  	      0 0 14px rgba(255,122,36,0.14),
  	      inset 0 1px 0 rgba(255,255,255,0.05);
  	      }

  	      #${ENGINE_ID} .ces-mode-shape {
  	      width: 20px;
  	      height: 16px;
  	      display: block;
  	      background: rgba(255,122,36,0.82);
  	      box-shadow: 0 0 10px rgba(255,122,36,0.28);
  	      }

  	      #${ENGINE_ID} .ces-mode-polygon .ces-mode-shape {
  	      clip-path: polygon(18% 0, 82% 0, 100% 52%, 70% 100%, 24% 86%, 0 36%);
  	      }

  	      #${ENGINE_ID} .ces-mode-pivot .ces-mode-shape {
  	      width: 18px;
  	      height: 18px;
  	      border-radius: 50%;
  	      }

  	      #${ENGINE_ID} .ces-mode-wedge .ces-mode-shape {
  	      clip-path: polygon(0 0, 100% 50%, 0 100%);
  	      }

  	      #${ENGINE_ID} .ces-mode-label {
  	      font-size: 7px;
  	      font-weight: 900;
  	      text-transform: uppercase;
  	      letter-spacing: 0.04em;
  	      }

  	      #${ENGINE_ID} .ces-plot-location-button,
  	      #${ENGINE_ID} .ces-save-location-button {
  	      width: 100%;
  	      height: 32px;
  	      margin-top: 8px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 15px;
  	      display: grid;
  	      grid-template-columns: 22px 1fr;
  	      align-items: center;
  	      gap: 7px;
  	      padding: 0 10px;
  	      color: #ffd8bf;
  	      text-align: left;
  	      background:
  	      linear-gradient(145deg, rgba(255,127,39,0.50), rgba(91,36,11,0.68));
  	      border: 1px solid rgba(255,127,39,0.74);
  	      box-shadow:
  	      0 8px 20px rgba(255,96,24,0.16),
  	      0 0 14px rgba(255,122,36,0.12),
  	      inset 0 1px 0 rgba(255,221,195,0.18);
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-plot-location-button:hover,
  	      #${ENGINE_ID} .ces-save-location-button:hover {
  	      border-color: rgba(255,172,84,0.92);
  	      box-shadow:
  	      0 10px 24px rgba(255,96,24,0.20),
  	      0 0 20px rgba(255,122,36,0.18),
  	      inset 0 1px 0 rgba(255,221,195,0.22);
  	      }

  	      #${ENGINE_ID} .ces-points-icon {
  	      position: relative;
  	      width: 18px;
  	      height: 18px;
  	      display: block;
  	      }

  	      #${ENGINE_ID} .ces-points-icon::before {
  	      content: "";
  	      position: absolute;
  	      left: 4px;
  	      top: 4px;
  	      width: 10px;
  	      height: 10px;
  	      border-left: 1px solid rgba(255,154,61,0.72);
  	      border-bottom: 1px solid rgba(255,154,61,0.72);
  	      transform: rotate(-35deg);
  	      transform-origin: center;
  	      box-shadow: 0 0 8px rgba(255,122,36,0.22);
  	      }

  	      #${ENGINE_ID} .ces-points-icon i {
  	      position: absolute;
  	      width: 5px;
  	      height: 5px;
  	      border-radius: 999px;
  	      background: #ff9a3d;
  	      box-shadow:
  	      0 0 0 3px rgba(255,122,36,0.10),
  	      0 0 10px rgba(255,122,36,0.38);
  	      }

  	      #${ENGINE_ID} .ces-points-icon i:nth-child(1) {
  	      left: 1px;
  	      top: 1px;
  	      }

  	      #${ENGINE_ID} .ces-points-icon i:nth-child(2) {
  	      right: 1px;
  	      top: 6px;
  	      }

  	      #${ENGINE_ID} .ces-points-icon i:nth-child(3) {
  	      left: 5px;
  	      bottom: 1px;
  	      }

  	      #${ENGINE_ID} .ces-save-icon {
  	      width: 20px;
  	      height: 20px;
  	      border-radius: 9px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: #ff9a3d;
  	      font-size: 12px;
  	      font-weight: 950;
  	      background: rgba(0,0,0,0.34);
  	      border: 1px solid rgba(255,122,36,0.28);
  	      }

  	      #${ENGINE_ID} .ces-plot-location-button strong,
  	      #${ENGINE_ID} .ces-save-location-button strong {
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      font-size: 9px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      }

  	      #${ENGINE_ID} .ces-screen-blocker {
  	      position: fixed;
  	      inset: 0;
  	      z-index: 2147483647;
  	      pointer-events: auto;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      padding: 24px;
  	      background:
  	      radial-gradient(circle at 50% 42%, rgba(255,122,36,0.12), rgba(0,0,0,0.00) 34%),
  	      rgba(0,0,0,0.72);
  	      backdrop-filter: blur(7px);
  	      }

  	      #${ENGINE_ID} .ces-modal-card {
  	      position: relative;
  	      width: min(390px, calc(100vw - 42px));
  	      max-height: min(620px, calc(100vh - 60px));
  	      overflow: hidden;
  	      padding: 18px;
  	      border-radius: 26px;
  	      background:
  	      radial-gradient(circle at 0% 0%, rgba(255,122,36,0.24), rgba(255,122,36,0.00) 42%),
  	      linear-gradient(145deg, rgba(18,24,26,0.98), rgba(0,0,0,0.94));
  	      border: 1px solid rgba(255,122,36,0.42);
  	      box-shadow:
  	      0 30px 80px rgba(0,0,0,0.58),
  	      0 0 38px rgba(255,122,36,0.16),
  	      inset 0 1px 0 rgba(255,255,255,0.075);
  	      }

  	      #${ENGINE_ID} .ces-modal-card::before {
  	      content: "";
  	      position: absolute;
  	      top: 0;
  	      left: 34px;
  	      right: 0;
  	      height: 1px;
  	      background:
  	      linear-gradient(
  	      to right,
  	      rgba(255,122,36,0.00),
  	      rgba(255,122,36,0.88),
  	      rgba(255,122,36,0.00)
  	      );
  	      box-shadow: 0 0 18px rgba(255,122,36,0.38);
  	      }

  	      #${ENGINE_ID} .ces-modal-header {
  	      display: grid;
  	      grid-template-columns: 38px 1fr 28px;
  	      gap: 10px;
  	      align-items: center;
  	      margin-bottom: 14px;
  	      }

  	      #${ENGINE_ID} .ces-modal-icon {
  	      width: 38px;
  	      height: 38px;
  	      border-radius: 16px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: #ff9a3d;
  	      font-size: 16px;
  	      font-weight: 950;
  	      background:
  	      radial-gradient(circle at 35% 25%, rgba(255,122,36,0.42), rgba(0,0,0,0.88) 72%);
  	      border: 1px solid rgba(255,122,36,0.58);
  	      box-shadow:
  	      0 0 22px rgba(255,122,36,0.24),
  	      inset 0 1px 0 rgba(255,255,255,0.08);
  	      }

  	      #${ENGINE_ID} .ces-modal-title {
  	      color: #ffd8bf;
  	      font-size: 15px;
  	      line-height: 1.1;
  	      font-weight: 950;
  	      }

  	      #${ENGINE_ID} .ces-modal-subtitle {
  	      margin-top: 4px;
  	      color: rgba(226,232,240,0.48);
  	      font-size: 8px;
  	      font-weight: 900;
  	      text-transform: uppercase;
  	      letter-spacing: 0.12em;
  	      }

  	      #${ENGINE_ID} .ces-modal-close {
  	      width: 28px;
  	      height: 28px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 11px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: rgba(255,216,191,0.82);
  	      font-size: 14px;
  	      font-weight: 950;
  	      background: rgba(0,0,0,0.46);
  	      border: 1px solid rgba(255,122,36,0.24);
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-modal-close:hover {
  	      color: #ff9a3d;
  	      border-color: rgba(255,122,36,0.52);
  	      }

  	      #${ENGINE_ID} .ces-modal-body {
  	      color: rgba(248,250,252,0.82);
  	      font-size: 12px;
  	      font-weight: 750;
  	      line-height: 1.45;
  	      margin-bottom: 15px;
  	      }

  	      #${ENGINE_ID} .ces-modal-actions {
  	      display: grid;
  	      grid-template-columns: 1fr 1fr;
  	      gap: 8px;
  	      margin-top: 14px;
  	      }

  	      #${ENGINE_ID} .ces-modal-primary,
  	      #${ENGINE_ID} .ces-modal-secondary {
  	      height: 34px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 15px;
  	      font-size: 9px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-modal-primary {
  	      color: #ffd8bf;
  	      background:
  	      linear-gradient(145deg, rgba(255,127,39,0.50), rgba(91,36,11,0.68));
  	      border: 1px solid rgba(255,127,39,0.74);
  	      box-shadow:
  	      0 8px 20px rgba(255,96,24,0.16),
  	      inset 0 1px 0 rgba(255,221,195,0.18);
  	      }

  	      #${ENGINE_ID} .ces-modal-secondary {
  	      color: rgba(255,216,191,0.70);
  	      background: rgba(0,0,0,0.48);
  	      border: 1px solid rgba(255,122,36,0.18);
  	      }

  	      #${ENGINE_ID} .ces-modal-primary:hover {
  	      border-color: rgba(255,172,84,0.92);
  	      }

  	      #${ENGINE_ID} .ces-modal-secondary:hover {
  	      color: #ffd8bf;
  	      border-color: rgba(255,122,36,0.44);
  	      }

  	      #${ENGINE_ID} .ces-functionality-list {
  	      max-height: 390px;
  	      overflow-y: auto;
  	      padding-right: 4px;
  	      }

  	      #${ENGINE_ID} .ces-functionality-item {
  	      min-height: 42px;
  	      border-radius: 17px;
  	      display: grid;
  	      grid-template-columns: 24px 1fr 24px;
  	      gap: 8px;
  	      align-items: center;
  	      padding: 8px 10px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.09), rgba(255,122,36,0.00) 48%),
  	      rgba(0,0,0,0.46);
  	      border: 1px solid rgba(255,122,36,0.16);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.035),
  	      0 0 12px rgba(255,122,36,0.04);
  	      }

  	      #${ENGINE_ID} .ces-functionality-item + .ces-functionality-item,
  	      #${ENGINE_ID} .ces-fuel-sub-options {
  	      margin-top: 8px;
  	      }

  	      #${ENGINE_ID} .ces-functionality-item.ces-sub-item {
  	      margin-left: 18px;
  	      min-height: 38px;
  	      background:
  	      linear-gradient(145deg, rgba(18,24,26,0.74), rgba(0,0,0,0.62));
  	      border-color: rgba(255,122,36,0.12);
  	      }

  	      #${ENGINE_ID} .ces-check {
  	      width: 20px;
  	      height: 20px;
  	      position: relative;
  	      display: block;
  	      }

  	      #${ENGINE_ID} .ces-check input {
  	      position: absolute;
  	      opacity: 0;
  	      pointer-events: none;
  	      }

  	      #${ENGINE_ID} .ces-check-box {
  	      width: 20px;
  	      height: 20px;
  	      border-radius: 8px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      background: rgba(0,0,0,0.58);
  	      border: 1px solid rgba(255,122,36,0.28);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.05),
  	      0 0 10px rgba(255,122,36,0.06);
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-check-box::after {
  	      content: "✓";
  	      opacity: 0;
  	      color: #ff9a3d;
  	      font-size: 12px;
  	      font-weight: 950;
  	      transform: scale(0.4);
  	      transition:
  	      opacity 160ms ease,
  	      transform 160ms ease;
  	      }

  	      #${ENGINE_ID} .ces-check input:checked + .ces-check-box {
  	      border-color: rgba(255,122,36,0.72);
  	      background:
  	      linear-gradient(145deg, rgba(255,127,39,0.28), rgba(0,0,0,0.58));
  	      box-shadow:
  	      0 0 16px rgba(255,122,36,0.16),
  	      inset 0 1px 0 rgba(255,255,255,0.07);
  	      }

  	      #${ENGINE_ID} .ces-check input:checked + .ces-check-box::after {
  	      opacity: 1;
  	      transform: scale(1);
  	      }

  	      #${ENGINE_ID} .ces-functionality-label {
  	      min-width: 0;
  	      }

  	      #${ENGINE_ID} .ces-functionality-title {
  	      color: rgba(255,216,191,0.88);
  	      font-size: 11px;
  	      font-weight: 950;
  	      line-height: 1.1;
  	      }

  	      #${ENGINE_ID} .ces-functionality-sub {
  	      margin-top: 3px;
  	      color: rgba(226,232,240,0.38);
  	      font-size: 7px;
  	      font-weight: 850;
  	      text-transform: uppercase;
  	      letter-spacing: 0.08em;
  	      }

  	      #${ENGINE_ID} .ces-help-button {
  	      width: 22px;
  	      height: 22px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 9px;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      color: rgba(255,216,191,0.76);
  	      font-size: 11px;
  	      font-weight: 950;
  	      background: rgba(0,0,0,0.50);
  	      border: 1px solid rgba(255,122,36,0.20);
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-help-button:hover {
  	      color: #ff9a3d;
  	      border-color: rgba(255,122,36,0.56);
  	      box-shadow: 0 0 12px rgba(255,122,36,0.14);
  	      }

  	      #${ENGINE_ID} .ces-phone-wrap {
  	      height: 34px;
  	      margin-top: 8px;
  	      margin-left: 18px;
  	      border-radius: 15px;
  	      display: grid;
  	      grid-template-columns: 20px 1fr;
  	      align-items: center;
  	      gap: 7px;
  	      padding: 0 10px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.09), rgba(255,122,36,0.00) 48%),
  	      rgba(0,0,0,0.50);
  	      border: 1px solid rgba(255,122,36,0.16);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.035),
  	      0 0 12px rgba(255,122,36,0.04);
  	      }

  	      #${ENGINE_ID} .ces-phone-icon {
  	      color: rgba(255,193,148,0.66);
  	      font-size: 12px;
  	      }

  	      #${ENGINE_ID} .ces-phone-wrap input {
  	      width: 100%;
  	      border: 0;
  	      outline: 0;
  	      background: transparent;
  	      color: rgba(248,250,252,0.82);
  	      font-size: 10px;
  	      font-weight: 750;
  	      }

  	      #${ENGINE_ID} .ces-phone-wrap input::placeholder {
  	      color: rgba(226,232,240,0.44);
  	      }

  	      #${ENGINE_ID} .ces-help-pop {
  	      position: absolute;
  	      inset: 0;
  	      z-index: 10;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      padding: 18px;
  	      background: rgba(0,0,0,0.68);
  	      backdrop-filter: blur(4px);
  	      }

  	      #${ENGINE_ID} .ces-help-card {
  	      width: 100%;
  	      padding: 15px;
  	      border-radius: 22px;
  	      background:
  	      radial-gradient(circle at 0% 0%, rgba(255,122,36,0.20), rgba(255,122,36,0.00) 42%),
  	      linear-gradient(145deg, rgba(18,24,26,0.99), rgba(0,0,0,0.96));
  	      border: 1px solid rgba(255,122,36,0.38);
  	      box-shadow:
  	      0 20px 60px rgba(0,0,0,0.56),
  	      0 0 28px rgba(255,122,36,0.14),
  	      inset 0 1px 0 rgba(255,255,255,0.07);
  	      }

  	      #${ENGINE_ID} .ces-help-title {
  	      color: #ffd8bf;
  	      font-size: 13px;
  	      font-weight: 950;
  	      margin-bottom: 8px;
  	      }

  	      #${ENGINE_ID} .ces-help-body {
  	      color: rgba(248,250,252,0.78);
  	      font-size: 11px;
  	      font-weight: 720;
  	      line-height: 1.45;
  	      }

  	      #${ENGINE_ID} .ces-help-close {
  	      width: 100%;
  	      height: 32px;
  	      margin-top: 13px;
  	      border: 0;
  	      outline: 0;
  	      border-radius: 14px;
  	      color: #ffd8bf;
  	      background:
  	      linear-gradient(145deg, rgba(255,127,39,0.42), rgba(91,36,11,0.62));
  	      border: 1px solid rgba(255,127,39,0.66);
  	      font-size: 9px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-needs-input {
  	      animation: cesInputThrob 950ms ease-in-out infinite;
  	      }

  	      #${ENGINE_ID} .ces-dropdown-bridge-host {
  	      width: 100%;
  	      margin-top: 8px;
  	      }

  	      #${ENGINE_ID} .ces-dropdown-placeholder {
  	      width: 100%;
  	      height: 28px;
  	      border-radius: 14px;
  	      display: grid;
  	      grid-template-columns: 18px 1fr 12px;
  	      align-items: center;
  	      gap: 5px;
  	      padding: 0 9px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.11), rgba(255,122,36,0.00) 46%),
  	      linear-gradient(145deg, rgba(10,13,14,0.96), rgba(0,0,0,0.82));
  	      border: 1px solid rgba(255,122,36,0.22);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.045),
  	      0 0 12px rgba(255,122,36,0.06);
  	      }

  	      #${ENGINE_ID} .ces-dropdown-placeholder-icon {
  	      color: rgba(255,193,148,0.68);
  	      font-size: 12px;
  	      }

  	      #${ENGINE_ID} .ces-dropdown-placeholder-text {
  	      min-width: 0;
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      color: rgba(248,250,252,0.70);
  	      font-size: 10px;
  	      font-weight: 850;
  	      }

  	      #${ENGINE_ID} .ces-dropdown-placeholder-caret {
  	      color: rgba(255,122,36,0.66);
  	      font-size: 9px;
  	      text-align: right;
  	      }

  	      @keyframes cesInputThrob {
  	      0%, 100% {
  	      transform: scale(1);
  	      border-color: rgba(255,122,36,0.26);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.045),
  	      0 0 10px rgba(255,122,36,0.08);
  	      }

  	      50% {
  	      transform: scale(1.035);
  	      border-color: rgba(255,122,36,0.92);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.075),
  	      0 0 22px rgba(255,122,36,0.38),
  	      0 0 34px rgba(255,122,36,0.14);
  	      }
  	      }

  	      #${ENGINE_ID} .ces-map-main {
  	      height: 46px;
  	      border-radius: 18px 0 0 18px;
  	      display: grid;
  	      grid-template-columns: 30px 1fr 16px;
  	      align-items: center;
  	      gap: 7px;
  	      padding: 0 8px;
  	      background:
  	      linear-gradient(145deg, rgba(24,35,38,0.80), rgba(0,0,0,0.54));
  	      border: 1px solid rgba(255,255,255,0.08);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.06),
  	      0 8px 20px rgba(0,0,0,0.24);
  	      }

  	      #${ENGINE_ID} .ces-layer-icon {
  	      width: 30px;
  	      height: 30px;
  	      border-radius: 12px;
  	      display: flex;
  	      flex-direction: column;
  	      align-items: center;
  	      justify-content: center;
  	      gap: 3px;
  	      background:
  	      radial-gradient(circle at 35% 25%, rgba(255,122,36,0.34), rgba(0,0,0,0.86) 70%);
  	      border: 1px solid rgba(255,122,36,0.44);
  	      box-shadow:
  	      0 0 14px rgba(255,122,36,0.18),
  	      inset 0 1px 0 rgba(255,255,255,0.08);
  	      }

  	      #${ENGINE_ID} .ces-layer-icon span {
  	      width: 14px;
  	      height: 2px;
  	      border-radius: 999px;
  	      background: #ff9a3d;
  	      box-shadow: 0 0 8px rgba(255,122,36,0.38);
  	      }

  	      #${ENGINE_ID} .ces-map-title {
  	      max-width: 92px;
  	      overflow: hidden;
  	      white-space: nowrap;
  	      text-overflow: ellipsis;
  	      color: rgba(255,216,191,0.92);
  	      font-size: 10px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      line-height: 1.05;
  	      }

  	      #${ENGINE_ID} .ces-map-subtitle {
  	      margin-top: 3px;
  	      color: rgba(226,232,240,0.42);
  	      font-size: 7px;
  	      font-weight: 850;
  	      text-transform: uppercase;
  	      letter-spacing: 0.08em;
  	      }

  	      #${ENGINE_ID} .ces-caret {
  	      color: rgba(255,122,36,0.78);
  	      font-size: 12px;
  	      text-align: right;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-card {
  	      width: 284px;
  	      max-width: 284px;
  	      padding: 18px 18px 20px 18px;
  	      border-radius: 28px;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-header {
  	      display: grid;
  	      grid-template-columns: 1fr 28px;
  	      gap: 10px;
  	      align-items: start;
  	      margin-bottom: 10px;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-heading {
  	      min-width: 0;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-card .ces-modal-title {
  	      max-width: 210px;
  	      color: #ffe1cc;
  	      font-size: 18px;
  	      line-height: 1.04;
  	      font-weight: 950;
  	      letter-spacing: -0.02em;
  	      white-space: normal;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-card .ces-modal-subtitle {
  	      margin-top: 4px;
  	      max-width: 210px;
  	      color: rgba(255,216,191,0.52);
  	      font-size: 9px;
  	      line-height: 1.1;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.08em;
  	      white-space: nowrap;
  	      overflow: hidden;
  	      text-overflow: ellipsis;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-close {
  	      position: static;
  	      width: 26px;
  	      height: 26px;
  	      align-self: start;
  	      justify-self: end;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-mode {
  	      min-height: 30px;
  	      display: grid;
  	      grid-template-columns: 1fr auto;
  	      gap: 8px;
  	      align-items: center;
  	      padding: 7px 9px;
  	      margin-bottom: 12px;
  	      border-radius: 15px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.08), rgba(255,122,36,0.00) 50%),
  	      rgba(0,0,0,0.34);
  	      border: 1px solid rgba(255,122,36,0.14);
  	      color: rgba(255,216,191,0.78);
  	      font-size: 10px;
  	      font-weight: 900;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-new-button {
  	      height: 22px;
  	      padding: 0 9px;
  	      border-radius: 999px;
  	      color: #ffd8bf;
  	      background: rgba(0,0,0,0.52);
  	      border: 1px solid rgba(255,122,36,0.24);
  	      font-size: 8px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-new-button:hover {
  	      border-color: rgba(255,122,36,0.70);
  	      color: #fff;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-form {
  	      display: grid;
  	      gap: 11px;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-field {
  	      display: grid;
  	      gap: 6px;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-field > span,
  	      #${ENGINE_ID} .ces-type-manager-section-title {
  	      color: rgba(255,216,191,0.72);
  	      font-size: 9px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.07em;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-input {
  	      width: 100%;
  	      height: 38px;
  	      border-radius: 17px;
  	      outline: 0;
  	      color: #f8fafc;
  	      font-size: 11px;
  	      font-weight: 850;
  	      padding: 0 13px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.09), rgba(255,122,36,0.00) 48%),
  	      rgba(0,0,0,0.50);
  	      border: 1px solid rgba(255,122,36,0.22);
  	      box-shadow:
  	      inset 0 1px 0 rgba(255,255,255,0.035),
  	      0 0 12px rgba(255,122,36,0.04);
  	      }

  	      #${ENGINE_ID} .ces-type-manager-input::placeholder {
  	      color: rgba(248,250,252,0.42);
  	      font-size: 10px;
  	      font-weight: 800;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-input:focus {
  	      border-color: rgba(255,122,36,0.72);
  	      box-shadow:
  	      0 0 0 2px rgba(255,122,36,0.10),
  	      inset 0 1px 0 rgba(255,255,255,0.045);
  	      }

  	      #${ENGINE_ID} .ces-type-manager-input.ces-needs-input {
  	      border-color: rgba(255,70,70,0.82);
  	      box-shadow:
  	      0 0 0 2px rgba(255,70,70,0.12),
  	      inset 0 1px 0 rgba(255,255,255,0.045);
  	      }

  	      #${ENGINE_ID} .ces-type-manager-color-row {
  	      height: 42px;
  	      display: grid;
  	      grid-template-columns: 30px 1fr;
  	      gap: 10px;
  	      align-items: center;
  	      padding: 6px 10px;
  	      border-radius: 18px;
  	      background:
  	      linear-gradient(145deg, rgba(13,17,18,0.92), rgba(0,0,0,0.76));
  	      border: 1px solid rgba(255,122,36,0.20);
  	      }

  	      #${ENGINE_ID} .ces-type-manager-color-preview {
  	      width: 24px;
  	      height: 24px;
  	      border-radius: 999px;
  	      display: block;
  	      border: 2px solid rgba(255,216,191,0.74);
  	      box-shadow:
  	      0 0 12px rgba(255,122,36,0.18),
  	      inset 0 1px 0 rgba(255,255,255,0.18);
  	      }

  	      #${ENGINE_ID} .ces-type-manager-color-input {
  	      width: 100%;
  	      height: 28px;
  	      border: 0;
  	      outline: 0;
  	      padding: 0;
  	      background: transparent;
  	      cursor: pointer;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-existing {
  	      margin-top: 13px;
  	      display: grid;
  	      gap: 7px;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-existing-row,
  	      #${ENGINE_ID} .ces-type-manager-empty {
  	      width: 100%;
  	      min-height: 36px;
  	      display: grid;
  	      grid-template-columns: 18px 1fr auto;
  	      gap: 9px;
  	      align-items: center;
  	      padding: 7px 10px;
  	      border-radius: 16px;
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.07), rgba(255,122,36,0.00) 50%),
  	      rgba(0,0,0,0.38);
  	      border: 1px solid rgba(255,122,36,0.13);
  	      color: rgba(248,250,252,0.84);
  	      font-size: 10px;
  	      font-weight: 850;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-existing-row {
  	      cursor: pointer;
  	      text-align: left;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-existing-row:hover,
  	      #${ENGINE_ID} .ces-type-manager-existing-selected {
  	      border-color: rgba(255,122,36,0.58);
  	      background:
  	      radial-gradient(circle at 0% 50%, rgba(255,122,36,0.16), rgba(255,122,36,0.00) 52%),
  	      rgba(0,0,0,0.48);
  	      }

  	      #${ENGINE_ID} .ces-type-manager-existing-name {
  	      min-width: 0;
  	      overflow: hidden;
  	      text-overflow: ellipsis;
  	      white-space: nowrap;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-edit-label {
  	      color: rgba(255,216,191,0.45);
  	      font-size: 8px;
  	      font-weight: 950;
  	      text-transform: uppercase;
  	      letter-spacing: 0.06em;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-existing-row:hover .ces-type-manager-edit-label,
  	      #${ENGINE_ID} .ces-type-manager-existing-selected .ces-type-manager-edit-label {
  	      color: #ff9a3d;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-empty {
  	      display: block;
  	      color: rgba(255,216,191,0.50);
  	      font-size: 10px;
  	      }

  	      #${ENGINE_ID} .ces-type-manager-actions {
  	      margin-top: 16px;
  	      }

  	      #${ENGINE_ID} .ces-orange-edge {
  	      animation: cesEdgeGlow 4.8s ease-in-out infinite;
  	      }

  	      @keyframes cesEdgeGlow {
  	      0%, 100% {
  	      opacity: 0.62;
  	      }

  	      50% {
  	      opacity: 1;
  	      }
  	      }

  	      @media (prefers-reduced-motion: reduce) {
  	      #${ENGINE_ID} .ces-orange-edge,
  	      #${ENGINE_ID} .ces-needs-input {
  	      animation: none;
  	      }
  	      }
  	      `;
  	    }

  	    function createTopSvg(height) {
  	      const h = Number(height) || 94;
  	      const bottom = h - 2;
  	      const bendY = Math.max(32, bottom - 22);
  	      const neckY = Math.min(48, Math.max(30, h - 26));

  	      return `
  	      <svg class="ces-panel-svg" viewBox="0 0 228 ${h}" preserveAspectRatio="none" aria-hidden="true">
  	      <defs>
  	      <linearGradient id="cesTopFill" x1="0" y1="0" x2="1" y2="1">
  	      <stop offset="0" stop-color="#182224"/>
  	      <stop offset="0.42" stop-color="#050606"/>
  	      <stop offset="1" stop-color="#000000"/>
  	      </linearGradient>

  	      <radialGradient id="cesTopHotspot" cx="0.16" cy="0.04" r="0.92">
  	      <stop offset="0" stop-color="#ff7a24" stop-opacity="0.34"/>
  	      <stop offset="0.34" stop-color="#ff7a24" stop-opacity="0.12"/>
  	      <stop offset="1" stop-color="#ff7a24" stop-opacity="0"/>
  	      </radialGradient>
  	      </defs>

  	      <path
  	      d="
  	      M 8 0
  	      H 228
  	      V ${bottom}
  	      H 56
  	      C 42 ${bottom} 34 ${bottom - 8} 34 ${bendY}
  	      V ${neckY}
  	      C 34 24 24 8 8 0
  	      Z
  	      "
  	      fill="url(#cesTopFill)"
  	      />

  	      <path
  	      d="
  	      M 8 0
  	      H 228
  	      V ${bottom}
  	      H 56
  	      C 42 ${bottom} 34 ${bottom - 8} 34 ${bendY}
  	      V ${neckY}
  	      C 34 24 24 8 8 0
  	      Z
  	      "
  	      fill="url(#cesTopHotspot)"
  	      opacity="0.88"
  	      />

  	      <path
  	      class="ces-orange-edge"
  	      d="
  	      M 8 0
  	      H 228
  	      V ${bottom}
  	      H 56
  	      C 42 ${bottom} 34 ${bottom - 8} 34 ${bendY}
  	      V ${neckY}
  	      C 34 24 24 8 8 0
  	      Z
  	      "
  	      fill="none"
  	      stroke="#ff7a24"
  	      stroke-opacity="0.74"
  	      stroke-width="1.25"
  	      />
  	      </svg>
  	      `;
  	    }

  	    function createBottomSvg() {
  	      return `
  	      <svg class="ces-panel-svg" viewBox="0 0 228 66" preserveAspectRatio="none" aria-hidden="true">
  	      <defs>
  	      <linearGradient id="cesBottomFill" x1="0" y1="0" x2="1" y2="1">
  	      <stop offset="0" stop-color="#12191b"/>
  	      <stop offset="0.50" stop-color="#050606"/>
  	      <stop offset="1" stop-color="#000000"/>
  	      </linearGradient>

  	      <radialGradient id="cesBottomHotspot" cx="0.28" cy="0.90" r="0.82">
  	      <stop offset="0" stop-color="#ff7a24" stop-opacity="0.24"/>
  	      <stop offset="0.42" stop-color="#ff7a24" stop-opacity="0.08"/>
  	      <stop offset="1" stop-color="#ff7a24" stop-opacity="0"/>
  	      </radialGradient>
  	      </defs>

  	      <path
  	      d="
  	      M 34 66
  	      H 228
  	      V 0
  	      H 56
  	      C 42 0 34 8 34 22
  	      V 66
  	      Z
  	      "
  	      fill="url(#cesBottomFill)"
  	      />

  	      <path
  	      d="
  	      M 34 66
  	      H 228
  	      V 0
  	      H 56
  	      C 42 0 34 8 34 22
  	      V 66
  	      Z
  	      "
  	      fill="url(#cesBottomHotspot)"
  	      opacity="0.82"
  	      />

  	      <path
  	      class="ces-orange-edge"
  	      d="
  	      M 34 66
  	      H 228
  	      V 0
  	      H 56
  	      C 42 0 34 8 34 22
  	      V 66
  	      Z
  	      "
  	      fill="none"
  	      stroke="#ff7a24"
  	      stroke-opacity="0.68"
  	      stroke-width="1.25"
  	      />
  	      </svg>
  	      `;
  	    }

  	    function createPointsIcon() {
  	      return `
  	      <span class="ces-points-icon" aria-hidden="true">
  	      <i></i>
  	      <i></i>
  	      <i></i>
  	      </span>
  	      `;
  	    }

  	    function createCompanyDropdown() {
  	      const isOpen = createState.openDropdown === "company";
  	      const label = getCompanyLabel(createState.company);

  	      return `
  	      <div class="ces-dd ces-dd-company ${isOpen ? "ces-dd-open": ""}">
  	      <button class="ces-dd-button" type="button" data-dd-toggle="company">
  	      <span class="ces-dd-icon">▣</span>
  	      <span class="ces-dd-label">${escapeHtml(label)}</span>
  	      <span class="ces-dd-caret">${isOpen ? "⌃": "⌄"}</span>
  	      </button>

  	      <div class="ces-dd-list">
  	      ${
  	      COMPANY_OPTIONS.map(option => `
  	        <button
  	        class="ces-dd-option ${createState.company === option.value ? "ces-dd-option-selected": ""}"
  	        type="button"
  	        data-company-value="${escapeHtml(option.value)}"
  	        >
  	        <span class="ces-dd-option-label">${escapeHtml(option.label)}</span>
  	        </button>
  	        `).join("")
  	      }
  	      </div>
  	      </div>
  	      `;
  	    }

  	    function createLocationTypeDropdown() {
  	      const isOpen = createState.openDropdown === "locationType";
  	      const selectedType = getLocationType(createState.locationType);
  	      const label = selectedType ? selectedType.label: "Location Type";
  	      const color = selectedType ? selectedType.color: "";

  	      return `
  	      <div class="ces-dd ces-dd-location-type ${isOpen ? "ces-dd-open": ""}">
  	      <button class="ces-dd-button" type="button" data-dd-toggle="locationType">
  	      <span class="ces-dd-icon">▤</span>
  	      <span
  	      class="ces-type-dot ${selectedType ? "": "ces-dot-empty"}"
  	      style="${selectedType ? `background:${escapeHtml(color)};`: ""}"
  	      ></span>
  	      <span class="ces-dd-label">${escapeHtml(label)}</span>
  	      <span class="ces-dd-caret">${isOpen ? "⌃": "⌄"}</span>
  	      </button>

  	      <div class="ces-dd-list">
  	      ${
  	      getActiveLocationTypeOptions().map(option => `
  	        <button
  	        class="ces-dd-option ${createState.locationType === option.value ? "ces-dd-option-selected": ""}"
  	        type="button"
  	        data-location-type-value="${escapeHtml(option.value)}"
  	        >
  	        <span class="ces-type-dot" style="background:${escapeHtml(option.color)};"></span>
  	        <span class="ces-dd-option-label">${escapeHtml(option.label)}</span>
  	        </button>
  	        `).join("")
  	      }
  	      </div>
  	      </div>
  	      `;
  	    }

  	    function createPlotOrSaveButton() {
  	      if (!createState.isPlotting) {
  	        return `
  	        <button class="ces-plot-location-button" type="button">
  	        ${createPointsIcon()}
  	        <strong>Plot Location</strong>
  	        </button>
  	        `;
  	      }

  	      return `
  	      <button class="ces-save-location-button" type="button">
  	      <span class="ces-save-icon">✓</span>
  	      <strong>Save Location</strong>
  	      </button>
  	      `;
  	    }

  	    function createTopContent(userMode) {
  	      const canCreateLocations = userMode.canCreateLocations;

  	      if (!canCreateLocations) {
  	        return `
  	        <div class="ces-top-content">
  	        <div class="ces-location-line ces-user-line">
  	        <div class="ces-title-wrap">
  	        <div class="ces-title">Location</div>
  	        <div class="ces-subtitle">User Mode</div>
  	        </div>
  	        </div>
  	        </div>
  	        `;
  	      }

  	      if (!createState.isCreating) {
  	        return `
  	        <div class="ces-top-content">
  	        <div class="ces-location-line ces-admin-line">
  	        <button class="ces-add-square" type="button" title="Add Location">＋</button>

  	        <div class="ces-title-wrap">
  	        <div class="ces-title">Location</div>
  	        <div class="ces-subtitle">Admin Mode</div>
  	        </div>
  	        </div>

  	        <div class="ces-dropdown-bridge-host" data-location-dropdown-host>
  	        <div class="ces-search">
  	        <span class="ces-search-icon">⌕</span>
  	        <input placeholder="Search Location" disabled />
  	        <span class="ces-search-caret">⌄</span>
  	        </div>
  	        </div>
  	        </div>
  	        `;
  	      }

  	      return `
  	      <div class="ces-top-content">
  	      <div class="ces-location-line ces-create-line">
  	      <button class="ces-add-square" type="button" title="Add Location">＋</button>

  	      <div class="ces-title-wrap">
  	      <div class="ces-title">Location</div>
  	      <div class="ces-subtitle">Admin Mode</div>
  	      </div>

  	      <button class="ces-close-create" type="button" title="Cancel">×</button>
  	      </div>

  	      ${createCompanyDropdown()}

  	      ${
  	      createState.company
  	      ? createLocationTypeDropdown(): ``
  	      }

  	      ${
  	      createState.locationType
  	      ? `
  	      <div class="ces-creation-panel">
  	      <div class="ces-creation-title">Creation Mode</div>

  	      <div class="ces-mode-row">
  	      <button class="ces-mode-button ces-mode-polygon ${createState.creationMode === "polygon" ? "ces-mode-selected": ""}" type="button" data-creation-mode="polygon">
  	      <span class="ces-mode-shape"></span>
  	      <span class="ces-mode-label">Polygon</span>
  	      </button>

  	      <button class="ces-mode-button ces-mode-pivot ${createState.creationMode === "pivot" ? "ces-mode-selected": ""}" type="button" data-creation-mode="pivot">
  	      <span class="ces-mode-shape"></span>
  	      <span class="ces-mode-label">Pivot</span>
  	      </button>

  	      <button class="ces-mode-button ces-mode-wedge ${createState.creationMode === "wedge" ? "ces-mode-selected": ""}" type="button" data-creation-mode="wedge">
  	      <span class="ces-mode-shape"></span>
  	      <span class="ces-mode-label">Wedge</span>
  	      </button>
  	      </div>
  	      </div>
  	      `: ``
  	      }

  	      ${
  	      createState.creationMode
  	      ? `
  	      <div class="ces-name-wrap">
  	      <span class="ces-name-icon">✎</span>
  	      <input class="ces-name-input" placeholder="Location Name" value="${escapeHtml(createState.name)}" ${createState.isPlotting ? "disabled": ""} />
  	      </div>

  	      ${
  	      createState.name.trim()
  	      ? createPlotOrSaveButton(): ``
  	      }
  	      `: ``
  	      }
  	      </div>
  	      `;
  	    }

  	    function createSavedModal() {
  	      return `
  	      <div class="ces-screen-blocker">
  	      <div class="ces-modal-card">
  	      <div class="ces-modal-header">
  	      <div class="ces-modal-icon">✓</div>

  	      <div>
  	      <div class="ces-modal-title">Location Saved</div>
  	      <div class="ces-modal-subtitle">Save Complete</div>
  	      </div>

  	      <button class="ces-modal-close" type="button" data-modal-reset title="Close">×</button>
  	      </div>

  	      <div class="ces-modal-body">
  	      Would you like to add functionality.
  	      </div>

  	      <div class="ces-modal-actions">
  	      <button class="ces-modal-primary" type="button" data-open-functionality>Add Functionality</button>
  	      <button class="ces-modal-secondary" type="button" data-modal-reset>Not Now</button>
  	      </div>
  	      </div>
  	      </div>
  	      `;
  	    }

  	    function createFunctionalityItem(key, title, subtitle, checked, isSubItem) {
  	      return `
  	      <div class="ces-functionality-item ${isSubItem ? "ces-sub-item": ""}">
  	      <label class="ces-check">
  	      <input type="checkbox" data-functionality-key="${escapeHtml(key)}" ${checked ? "checked": ""} />
  	      <span class="ces-check-box"></span>
  	      </label>

  	      <div class="ces-functionality-label">
  	      <div class="ces-functionality-title">${escapeHtml(title)}</div>
  	      <div class="ces-functionality-sub">${escapeHtml(subtitle)}</div>
  	      </div>

  	      <button class="ces-help-button" type="button" data-help-topic="${escapeHtml(key)}">?</button>
  	      </div>
  	      `;
  	    }

  	    function createHelpPopup() {
  	      if (!createState.helpTopic) return "";

  	      const help = HELP_TEXT[createState.helpTopic] || {
  	        title: "Description",
  	        body: "No description available."
  	      };

  	      return `
  	      <div class="ces-help-pop">
  	      <div class="ces-help-card">
  	      <div class="ces-help-title">${escapeHtml(help.title)}</div>
  	      <div class="ces-help-body">${escapeHtml(help.body)}</div>
  	      <button class="ces-help-close" type="button" data-close-help>Close</button>
  	      </div>
  	      </div>
  	      `;
  	    }

  	    function createFunctionalityModal() {
  	      const f = createState.functionality;

  	      return `
  	      <div class="ces-screen-blocker">
  	      <div class="ces-modal-card">
  	      <div class="ces-modal-header">
  	      <div class="ces-modal-icon">⚙</div>

  	      <div>
  	      <div class="ces-modal-title">Location Functionality</div>
  	      <div class="ces-modal-subtitle">Configure Logic</div>
  	      </div>

  	      <button class="ces-modal-close" type="button" data-modal-reset title="Close">×</button>
  	      </div>

  	      <div class="ces-functionality-list">
  	      ${createFunctionalityItem("eventsCapture", "Events Capture", "Capture events at this location", f.eventsCapture, false)}

  	      ${createFunctionalityItem("fuelLogic", "Fuel Logic", "Enable fuel behaviour", f.fuelLogic, false)}

  	      ${
  	      f.fuelLogic
  	      ? `
  	      <div class="ces-fuel-sub-options">
  	      ${createFunctionalityItem("publicFuelStation", "Public Fuel Station", "External fuel provider", f.publicFuelStation, true)}
  	      ${createFunctionalityItem("fuelDepot", "Depot", "Company fuel depot", f.fuelDepot, true)}
  	      </div>
  	      `: ``
  	      }

  	      ${createFunctionalityItem("loadLogic", "Load Logic", "Enable loading behaviour", f.loadLogic, false)}

  	      ${createFunctionalityItem("gateLogic", "Gate Logic", "Enable gate contact logic", f.gateLogic, false)}

  	      ${
  	      f.gateLogic
  	      ? `
  	      <div class="ces-phone-wrap">
  	      <span class="ces-phone-icon">☎</span>
  	      <input
  	      class="ces-gate-phone-input"
  	      type="tel"
  	      inputmode="tel"
  	      autocomplete="tel"
  	      placeholder="Phone Number"
  	      value="${escapeHtml(f.gatePhone)}"
  	      />
  	      </div>
  	      `: ``
  	      }
  	      </div>

  	      <div class="ces-modal-actions">
  	      <button class="ces-modal-primary" type="button" data-save-functionality>Save Functionality</button>
  	      <button class="ces-modal-secondary" type="button" data-modal-reset>Skip</button>
  	      </div>

  	      ${createHelpPopup()}
  	      </div>
  	      </div>
  	      `;
  	    }

  	    function createLocationTypeManagerModal() {
  	      const companyLabel = getCompanyLabel(createState.company);
  	      const typeName = safeString(createState.typeManagerName);
  	      const typeColor = normalizeLocationTypeColorValue(createState.typeManagerColor);
  	      const originalName = safeString(createState.typeManagerOriginalName).trim();
  	      const isEditing = !!originalName;

  	      const existingTypes = getActiveLocationTypeOptions()
  	      .filter(option => option.value !== ADD_NEW_LOCATION_TYPE_VALUE);

  	      return `
  	      <div class="ces-screen-blocker">
  	      <div class="ces-modal-card ces-type-manager-card">
  	      <div class="ces-type-manager-header">
  	      <div class="ces-type-manager-heading">
  	      <div class="ces-modal-title">Location Type Manager</div>
  	      <div class="ces-modal-subtitle">${escapeHtml(companyLabel)}</div>
  	      </div>

  	      <button class="ces-modal-close ces-type-manager-close" type="button" data-cancel-location-type-manager title="Close">×</button>
  	      </div>

  	      <div class="ces-type-manager-mode">
  	      <span>${isEditing ? `Editing: ${escapeHtml(originalName)}`: `New Location Type`}</span>

  	      ${
  	      isEditing
  	      ? `
  	      <button class="ces-type-manager-new-button" type="button" data-new-location-type-manager>
  	      New Type
  	      </button>
  	      `: ``
  	      }
  	      </div>

  	      <div class="ces-type-manager-form">
  	      <label class="ces-type-manager-field">
  	      <span>Type Name</span>
  	      <input
  	      class="ces-type-manager-input"
  	      type="text"
  	      maxlength="60"
  	      autocomplete="off"
  	      placeholder="Example: Farm, Field, Gate"
  	      value="${escapeHtml(typeName)}"
  	      data-location-type-manager-name
  	      />
  	      </label>

  	      <label class="ces-type-manager-field">
  	      <span>Color</span>
  	      <div class="ces-type-manager-color-row">
  	      <i class="ces-type-manager-color-preview" style="background:${escapeHtml(typeColor)};"></i>
  	      <input
  	      class="ces-type-manager-color-input"
  	      type="color"
  	      value="${escapeHtml(typeColor)}"
  	      data-location-type-manager-color
  	      />
  	      </div>
  	      </label>
  	      </div>

  	      <div class="ces-type-manager-existing">
  	      <div class="ces-type-manager-section-title">Current Types</div>

  	      ${
  	      existingTypes.length
  	      ? existingTypes.map((type, index) => `
  	        <button
  	        class="ces-type-manager-existing-row ${originalName && originalName.toLowerCase() === safeString(type.label).trim().toLowerCase() ? "ces-type-manager-existing-selected": ""}"
  	        type="button"
  	        data-type-manager-edit-index="${index}"
  	        >
  	        <span class="ces-type-dot" style="background:${escapeHtml(type.color)};"></span>

  	        <span class="ces-type-manager-existing-name">${escapeHtml(type.label)}</span>

  	        <span class="ces-type-manager-edit-label">Edit</span>
  	        </button>
  	        `).join(""): `
  	      <div class="ces-type-manager-empty">
  	      No saved types yet.
  	      </div>
  	      `
  	      }
  	      </div>

  	      <div class="ces-modal-actions ces-type-manager-actions">
  	      <button class="ces-modal-primary" type="button" data-save-location-type-manager>
  	      ${isEditing ? "Update Type": "Save Type"}
  	      </button>

  	      <button class="ces-modal-secondary" type="button" data-cancel-location-type-manager>
  	      Cancel
  	      </button>
  	      </div>
  	      </div>
  	      </div>
  	      `;
  	    }

  	    function createModal() {
  	      if (createState.modalMode === "saved") {
  	        return createSavedModal();
  	      }

  	      if (createState.modalMode === "functionality") {
  	        return createFunctionalityModal();
  	      }

  	      if (createState.modalMode === "locationTypeManager") {
  	        return createLocationTypeManagerModal();
  	      }

  	      return "";
  	    }

  	    function bindModalEvents(root, userMode) {
  	      const resetButtons = root.querySelectorAll("[data-modal-reset]");
  	      const openFunctionalityButton = root.querySelector("[data-open-functionality]");
  	      const functionalityInputs = root.querySelectorAll("[data-functionality-key]");
  	      const gatePhoneInput = root.querySelector(".ces-gate-phone-input");
  	      const helpButtons = root.querySelectorAll("[data-help-topic]");
  	      const closeHelpButton = root.querySelector("[data-close-help]");
  	      const saveFunctionalityButton = root.querySelector("[data-save-functionality]");

  	      const typeManagerNameInput = root.querySelector("[data-location-type-manager-name]");
  	      const typeManagerColorInput = root.querySelector("[data-location-type-manager-color]");
  	      const saveLocationTypeButton = root.querySelector("[data-save-location-type-manager]");
  	      const cancelLocationTypeButtons = root.querySelectorAll("[data-cancel-location-type-manager]");
  	      const editLocationTypeButtons = root.querySelectorAll("[data-type-manager-edit-index]");
  	      const newLocationTypeButton = root.querySelector("[data-new-location-type-manager]");

  	      resetButtons.forEach(button => {
  	        button.addEventListener("click", () => {
  	          resetCreateState();

  	          renderTop(root, userMode);
  	          renderModal(root, userMode);
  	          ensureTrackITSearchDropdownMounted(root, userMode);
  	        });
  	      });

  	      cancelLocationTypeButtons.forEach(button => {
  	        button.addEventListener("click", () => {
  	          createState.modalMode = "";
  	          createState.helpTopic = "";
  	          createState.typeManagerName = "";
  	          createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	          createState.typeManagerOriginalName = "";

  	          renderTop(root, userMode);
  	          renderModal(root, userMode);
  	        });
  	      });

  	      if (newLocationTypeButton) {
  	        newLocationTypeButton.addEventListener("click", () => {
  	          createState.typeManagerName = "";
  	          createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	          createState.typeManagerOriginalName = "";

  	          renderModal(root, userMode);
  	        });
  	      }

  	      editLocationTypeButtons.forEach(button => {
  	        button.addEventListener("click", () => {
  	          const index = Number(button.getAttribute("data-type-manager-edit-index"));
  	          const existingTypes = getActiveLocationTypeOptions()
  	          .filter(option => option.value !== ADD_NEW_LOCATION_TYPE_VALUE);

  	          const selectedType = existingTypes[index];

  	          if (!selectedType) return;

  	          createState.typeManagerOriginalName = selectedType.label;
  	          createState.typeManagerName = selectedType.label;
  	          createState.typeManagerColor = normalizeLocationTypeColorValue(selectedType.color);

  	          renderModal(root, userMode);
  	        });
  	      });

  	      if (typeManagerNameInput) {
  	        typeManagerNameInput.addEventListener("input", event => {
  	          createState.typeManagerName = event.target.value || "";

  	          if (typeManagerNameInput.classList.contains("ces-needs-input")) {
  	            typeManagerNameInput.classList.remove("ces-needs-input");
  	          }
  	        });
  	      }

  	      if (typeManagerColorInput) {
  	        typeManagerColorInput.addEventListener("input", event => {
  	          const color = normalizeLocationTypeColorValue(event.target.value);

  	          createState.typeManagerColor = color;
  	          event.target.value = color;

  	          const preview = root.querySelector(".ces-type-manager-color-preview");

  	          if (preview) {
  	            preview.style.background = color;
  	          }
  	        });
  	      }

  	      if (saveLocationTypeButton) {
  	        saveLocationTypeButton.addEventListener("click", () => {
  	          const typeName = safeString(createState.typeManagerName).trim();
  	          const typeColor = normalizeLocationTypeColorValue(createState.typeManagerColor);

  	          if (!typeName) {
  	            const input = root.querySelector("[data-location-type-manager-name]");

  	            if (input) {
  	              input.classList.add("ces-needs-input");
  	              input.focus();
  	            }

  	            return;
  	          }

  	          const savedType = upsertCompanyLocationType(
  	            createState.company,
  	            typeName,
  	            typeColor,
  	            createState.typeManagerOriginalName
  	          );

  	          if (!savedType) return;

  	          createState.locationType = savedType.value;
  	          createState.creationMode = "";
  	          createState.name = "";
  	          createState.openDropdown = "";
  	          createState.isPlotting = false;
  	          createState.isSaved = false;
  	          createState.modalMode = "";
  	          createState.helpTopic = "";
  	          createState.typeManagerName = "";
  	          createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	          createState.typeManagerOriginalName = "";

  	          renderTop(root, userMode);
  	          renderModal(root, userMode);
  	        });
  	      }

  	      if (openFunctionalityButton) {
  	        openFunctionalityButton.addEventListener("click", () => {
  	          createState.modalMode = "functionality";
  	          createState.helpTopic = "";

  	          renderModal(root, userMode);
  	        });
  	      }

  	      functionalityInputs.forEach(input => {
  	        input.addEventListener("change", () => {
  	          const key = input.getAttribute("data-functionality-key");

  	          if (!key || !(key in createState.functionality)) return;

  	          createState.functionality[key] = input.checked;

  	          if (key === "fuelLogic" && !input.checked) {
  	            createState.functionality.publicFuelStation = false;
  	            createState.functionality.fuelDepot = false;
  	          }

  	          if (key === "publicFuelStation" && input.checked) {
  	            createState.functionality.fuelDepot = false;
  	          }

  	          if (key === "fuelDepot" && input.checked) {
  	            createState.functionality.publicFuelStation = false;
  	          }

  	          if (key === "gateLogic" && !input.checked) {
  	            createState.functionality.gatePhone = "";
  	          }

  	          renderModal(root, userMode);
  	        });
  	      });

  	      if (gatePhoneInput) {
  	        gatePhoneInput.addEventListener("input", event => {
  	          let value = event.target.value || "";

  	          value = value.replace(/[^\d+]/g, "");

  	          if (value.includes("+")) {
  	            value = "+" + value.replace(/\+/g, "");
  	          }

  	          if (value.length > 1) {
  	            value = value.charAt(0) === "+"
  	            ? "+" + value.slice(1).replace(/\+/g, ""): value.replace(/\+/g, "");
  	          }

  	          event.target.value = value;
  	          createState.functionality.gatePhone = value;
  	        });
  	      }

  	      helpButtons.forEach(button => {
  	        button.addEventListener("click", () => {
  	          createState.helpTopic = button.getAttribute("data-help-topic") || "";
  	          renderModal(root, userMode);
  	        });
  	      });

  	      if (closeHelpButton) {
  	        closeHelpButton.addEventListener("click", () => {
  	          createState.helpTopic = "";
  	          renderModal(root, userMode);
  	        });
  	      }

  	      if (saveFunctionalityButton) {
  	        saveFunctionalityButton.addEventListener("click", () => {
  	          const targetLocation = window.__CarvedEdgeShapeUI
  	          ? window.__CarvedEdgeShapeUI.pendingSaveLocation: null;

  	          const payload = {
  	            location: targetLocation,
  	            functionality: {
  	              eventsCapture: createState.functionality.eventsCapture,
  	              fuelLogic: createState.functionality.fuelLogic,
  	              fuelMode: createState.functionality.fuelLogic
  	              ? (
  	                createState.functionality.publicFuelStation
  	                ? "publicFuelStation": createState.functionality.fuelDepot
  	                ? "depot": ""
  	              ): "",
  	              publicFuelStation: createState.functionality.publicFuelStation,
  	              fuelDepot: createState.functionality.fuelDepot,
  	              loadLogic: createState.functionality.loadLogic,
  	              gateLogic: createState.functionality.gateLogic,
  	              gatePhone: createState.functionality.gatePhone
  	            }
  	          };

  	          console.log("Save Functionality pressed:", payload);

  	          if (targetLocation) {
  	            targetLocation.LocationData = targetLocation.LocationData || {};
  	            targetLocation.LocationData.Functionality = targetLocation.LocationData.Functionality || {};

  	            targetLocation.LocationData.Functionality.EventsCapture = payload.functionality.eventsCapture;
  	            targetLocation.LocationData.Functionality.FuelLogic = payload.functionality.fuelLogic;
  	            targetLocation.LocationData.Functionality.FuelMode = payload.functionality.fuelMode;
  	            targetLocation.LocationData.Functionality.PublicFuelStation = payload.functionality.publicFuelStation;
  	            targetLocation.LocationData.Functionality.FuelDepot = payload.functionality.fuelDepot;
  	            targetLocation.LocationData.Functionality.LoadLogic = payload.functionality.loadLogic;
  	            targetLocation.LocationData.Functionality.GateLogic = payload.functionality.gateLogic;
  	            targetLocation.LocationData.Functionality.GatePhone = payload.functionality.gateLogic
  	            ? payload.functionality.gatePhone: "";

  	            try {
  	              const appData = getAppBag();

  	              if (appData) {
  	                appData.SelectedLocation = targetLocation;
  	                appData.SelectedLocationObjectId =
  	                targetLocation.objectId ||
  	                targetLocation.ObjectId ||
  	                targetLocation.id ||
  	                appData.SelectedLocationObjectId ||
  	                null;

  	                appData.SelectedLocationMarker = appData.SelectedLocationObjectId;
  	              }
  	            } catch (_) {}
  	          }

  	          if (window.__CarvedEdgeShapeUI) {
  	            window.__CarvedEdgeShapeUI.pendingFunctionalitySave = payload;
  	          }

  	          createState.modalMode = "";
  	          createState.helpTopic = "";

  	          renderModal(root, userMode);

  	          try {
  	            const callback = window.__CarvedEdgeShapeUI
  	            ? window.__CarvedEdgeShapeUI.afterFunctionalitySave: null;

  	            if (typeof callback === "function") {
  	              callback(payload);
  	            }

  	            if (window.__CarvedEdgeShapeUI) {
  	              window.__CarvedEdgeShapeUI.afterFunctionalitySave = null;
  	            }
  	          } catch (error) {
  	            console.warn("[Carved Edge Shape UI] Could not run after functionality save callback.", error);
  	          }
  	        });
  	      }
  	    }

  	    function renderModal(root,
  	      userMode) {
  	      let modalHost = root.querySelector(".ces-modal-host");

  	      if (!modalHost) {
  	        modalHost = document.createElement("section");
  	        modalHost.className = "ces-modal-host";
  	        root.appendChild(modalHost);
  	      }

  	      modalHost.innerHTML = createModal();
  	      bindModalEvents(root, userMode);
  	    }

  	    function renderTop(root, userMode) {
  	      const topSection = root.querySelector(".ces-top-shape");
  	      const topHeight = getTopHeight(userMode);

  	      if (!topSection) return;

  	      cleanupMountedTrackITDropdown(root);

  	      topSection.style.height = `${topHeight}px`;
  	      topSection.innerHTML = `
  	      ${createTopSvg(topHeight)}
  	      ${createTopContent(userMode)}
  	      `;

  	      bindTopEvents(root, userMode);
  	      scheduleAttention(root, userMode);
  	      ensureTrackITSearchDropdownMounted(root, userMode);
  	    }

  	    function renderBottom(root) {
  	      const bottomSection = root.querySelector(".ces-bottom-shape");

  	      bottomSection.innerHTML = `
  	      ${createBottomSvg()}

  	      <div class="ces-bottom-content">
  	      <div class="ces-map-main">
  	      <div class="ces-layer-icon">
  	      <span></span>
  	      <span></span>
  	      <span></span>
  	      </div>

  	      <div>
  	      <div class="ces-map-title">Map Control</div>
  	      <div class="ces-map-subtitle">Closed</div>
  	      </div>

  	      <div class="ces-caret">⌃</div>
  	      </div>
  	      </div>
  	      `;
  	    }

  	    function bindTopEvents(root, userMode) {
  	      const addButton = root.querySelector(".ces-add-square");
  	      const closeButton = root.querySelector(".ces-close-create");
  	      const dropdownToggles = root.querySelectorAll("[data-dd-toggle]");
  	      const companyOptions = root.querySelectorAll("[data-company-value]");
  	      const locationTypeOptions = root.querySelectorAll("[data-location-type-value]");
  	      const modeButtons = root.querySelectorAll(".ces-mode-button");
  	      const nameInput = root.querySelector(".ces-name-input");
  	      const plotButton = root.querySelector(".ces-plot-location-button");
  	      const saveButton = root.querySelector(".ces-save-location-button");

  	      if (addButton && userMode.canCreateLocations && !createState.isCreating) {
  	        addButton.addEventListener("click", () => {
  	          createState.isCreating = true;
  	          createState.company = "";
  	          createState.locationType = "";
  	          createState.creationMode = "";
  	          createState.name = "";
  	          createState.openDropdown = "";
  	          createState.isPlotting = false;
  	          createState.isSaved = false;
  	          createState.modalMode = "";
  	          createState.helpTopic = "";
  	          createState.typeManagerName = "";
  	          createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	          createState.typeManagerOriginalName = "";
  	          resetFunctionalityState();

  	          renderTop(root, userMode);
  	          renderModal(root, userMode);
  	        });
  	      }

  	      if (closeButton) {
  	        closeButton.addEventListener("click", () => {
  	          resetCreateState();

  	          renderTop(root, userMode);
  	          renderModal(root, userMode);
  	          ensureTrackITSearchDropdownMounted(root, userMode);
  	        });
  	      }

  	      dropdownToggles.forEach(button => {
  	        button.addEventListener("click", event => {
  	          event.stopPropagation();

  	          if (createState.isPlotting) return;

  	          const targetDropdown = button.getAttribute("data-dd-toggle") || "";

  	          createState.openDropdown =
  	          createState.openDropdown === targetDropdown
  	          ? "": targetDropdown;

  	          renderTop(root, userMode);
  	        });
  	      });

  	      companyOptions.forEach(button => {
  	        button.addEventListener("click",
  	          event => {
  	            event.stopPropagation();

  	            if (createState.isPlotting) return;

  	            createState.company = button.getAttribute("data-company-value") || "";
  	            createState.locationType = "";
  	            createState.creationMode = "";
  	            createState.name = "";
  	            createState.openDropdown = "";
  	            createState.isPlotting = false;
  	            createState.isSaved = false;

  	            renderTop(root, userMode);
  	          });
  	      });

  	      locationTypeOptions.forEach(button => {
  	        button.addEventListener("click",
  	          event => {
  	            event.stopPropagation();

  	            if (createState.isPlotting) return;

  	            const selectedValue = button.getAttribute("data-location-type-value") || "";

  	            if (selectedValue === ADD_NEW_LOCATION_TYPE_VALUE) {
  	              createState.modalMode = "locationTypeManager";
  	              createState.helpTopic = "";
  	              createState.typeManagerName = "";
  	              createState.typeManagerColor = DEFAULT_NEW_LOCATION_TYPE_COLOR;
  	              createState.typeManagerOriginalName = "";
  	              createState.openDropdown = "";
  	              createState.creationMode = "";
  	              createState.name = "";
  	              createState.isPlotting = false;
  	              createState.isSaved = false;

  	              renderTop(root, userMode);
  	              renderModal(root, userMode);
  	              return;
  	            }

  	            createState.locationType = selectedValue;
  	            createState.creationMode = "";
  	            createState.name = "";
  	            createState.openDropdown = "";
  	            createState.isPlotting = false;
  	            createState.isSaved = false;
  	            createState.modalMode = "";
  	            createState.helpTopic = "";

  	            renderTop(root, userMode);
  	            renderModal(root, userMode);
  	          });
  	      });

  	      modeButtons.forEach(button => {
  	        button.addEventListener("click",
  	          () => {
  	            if (createState.isPlotting) return;

  	            createState.creationMode = button.getAttribute("data-creation-mode") || "";
  	            createState.openDropdown = "";
  	            createState.name = "";
  	            createState.isPlotting = false;
  	            createState.isSaved = false;

  	            renderTop(root, userMode);
  	          });
  	      });

  	      if (nameInput) {
  	        nameInput.addEventListener("input", event => {
  	          const wasEmpty = !createState.name.trim();

  	          createState.name = event.target.value;
  	          createState.openDropdown = "";
  	          createState.isPlotting = false;
  	          createState.isSaved = false;

  	          clearAttention(root);

  	          const isEmpty = !createState.name.trim();

  	          if (wasEmpty !== isEmpty) {
  	            renderTop(root, userMode);
  	            return;
  	          }

  	          scheduleAttention(root, userMode);
  	        });
  	      }

  	      if (plotButton) {
  	        plotButton.addEventListener("click", () => {
  	          if (!createState.name.trim()) return;

  	          createState.isPlotting = true;
  	          createState.isSaved = false;
  	          createState.openDropdown = "";

  	          renderTop(root, userMode);
  	        });
  	      }

  	      if (saveButton) {
  	        saveButton.addEventListener("click", () => {
  	          createState.isSaved = true;
  	          createState.modalMode = "saved";
  	          createState.helpTopic = "";
  	          createState.openDropdown = "";

  	          const selectedLocationType = getLocationType(createState.locationType);

  	          const payload = {
  	            company: createState.company,
  	            companyLabel: getCompanyLabel(createState.company),

  	            locationType: createState.locationType,
  	            locationTypeName: selectedLocationType ? selectedLocationType.label: createState.locationType,
  	            locationTypeColor: selectedLocationType ? selectedLocationType.color: "",

  	            creationMode: createState.creationMode,
  	            name: createState.name
  	          };

  	          console.log("Save Location pressed:", payload);

  	          if (window.__CarvedEdgeShapeUI) {
  	            window.__CarvedEdgeShapeUI.pendingSaveLocation = payload;
  	          }

  	          renderTop(root, userMode);
  	          renderModal(root, userMode);
  	        });
  	      }
  	    }

  	    function getMapVisibilityElements(mapComponent) {
  	      const found = [];
  	      const seen = new Set();

  	      function addElement(element) {
  	        if (!element) return;

  	        try {
  	          if (typeof Element !== "undefined" && !(element instanceof Element)) return;
  	        } catch (_) {
  	          return;
  	        }

  	        if (seen.has(element)) return;

  	        seen.add(element);
  	        found.push(element);

  	        try {
  	          const closestBlock =
  	          element.closest(".bl-block") ||
  	          element.closest(".bl-customComponent") ||
  	          element.closest(".bl-component") ||
  	          element.closest("[data-component-id]") ||
  	          element.closest("[data-uid]") ||
  	          null;

  	          if (closestBlock && !seen.has(closestBlock)) {
  	            seen.add(closestBlock);
  	            found.push(closestBlock);
  	          }
  	        } catch (_) {}
  	      }

  	      function addFromCandidate(candidate) {
  	        if (!candidate) return;

  	        try {
  	          const resolved = resolveElementFromComponent(candidate);

  	          if (resolved) {
  	            addElement(resolved);
  	          }
  	        } catch (_) {}

  	        try {
  	          if (typeof candidate.getDiv === "function") {
  	            addElement(candidate.getDiv());
  	          }
  	        } catch (_) {}

  	        try {
  	          if (candidate.element) addElement(candidate.element);
  	          if (candidate.el) addElement(candidate.el);
  	          if (candidate.node) addElement(candidate.node);
  	          if (candidate.domNode) addElement(candidate.domNode);
  	        } catch (_) {}

  	        try {
  	          if (candidate.map && typeof candidate.map.getDiv === "function") {
  	            addElement(candidate.map.getDiv());
  	          }
  	        } catch (_) {}

  	        try {
  	          if (candidate.map?.map && typeof candidate.map.map.getDiv === "function") {
  	            addElement(candidate.map.map.getDiv());
  	          }
  	        } catch (_) {}
  	      }

  	      [
  	        mapComponent,
  	        MAP_INPUT,
  	        mapComponent?.map,
  	        mapComponent?.map?.map,
  	        MAP_INPUT?.map,
  	        MAP_INPUT?.map?.map
  	      ].forEach(addFromCandidate);

  	      if (!found.length) {
  	        try {
  	          document.querySelectorAll(".gm-style").forEach(addElement);
  	        } catch (_) {}
  	      }

  	      return found;
  	    }

  	    function closeFloatingLocationOverlays() {
  	      [
  	        "trackit-location-events-manager",
  	        "trackit-location-capture-event-form",
  	        "job-entry-list-mobile-portrait-mount",
  	        "job-entry-form-mobile-portrait-mount"
  	      ].forEach(id => {
  	          const existing = document.getElementById(id);

  	          if (existing && existing.parentNode) {
  	            existing.parentNode.removeChild(existing);
  	          }
  	        });
  	    }

  	    function setCarvedUIVisibleForMap(root,
  	      isVisible) {
  	      if (!root) return;

  	      if (isVisible) {
  	        if (!root.__cesHiddenBecauseMapInvisible) return;

  	        root.__cesHiddenBecauseMapInvisible = false;

  	        root.style.removeProperty("display");
  	        root.style.removeProperty("visibility");
  	        root.style.removeProperty("opacity");
  	        root.style.removeProperty("pointer-events");

  	        if (root.__cesOriginalDisplay) {
  	          root.style.display = root.__cesOriginalDisplay;
  	        }

  	        return;
  	      }

  	      if (root.__cesHiddenBecauseMapInvisible) return;

  	      root.__cesHiddenBecauseMapInvisible = true;
  	      root.__cesOriginalDisplay = root.style.display || "";

  	      createState.openDropdown = "";
  	      createState.modalMode = "";
  	      createState.helpTopic = "";

  	      closeFloatingLocationOverlays();

  	      try {
  	        cleanupMountedTrackITDropdown(root);
  	      } catch (_) {}

  	      root.style.setProperty("display", "none", "important");
  	      root.style.setProperty("visibility", "hidden", "important");
  	      root.style.setProperty("opacity", "0", "important");
  	      root.style.setProperty("pointer-events", "none", "important");
  	    }

  	    function isElementAndParentsVisible(element) {
  	      if (!element || !element.isConnected) return false;

  	      let current = element;

  	      while (current && current.nodeType === 1) {
  	        try {
  	          const styles = window.getComputedStyle(current);

  	          if (!styles) return false;
  	          if (styles.display === "none") return false;
  	          if (styles.visibility === "hidden") return false;
  	          if (styles.visibility === "collapse") return false;
  	          if (Number(styles.opacity) === 0) return false;
  	        } catch (_) {}

  	        current = current.parentElement;
  	      }

  	      try {
  	        const rect = element.getBoundingClientRect();
  	        const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
  	        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

  	        if (!rect) return false;
  	        if (rect.width <= 0 || rect.height <= 0) return false;
  	        if (rect.bottom <= 0) return false;
  	        if (rect.right <= 0) return false;
  	        if (rect.top >= viewportHeight) return false;
  	        if (rect.left >= viewportWidth) return false;

  	        return true;
  	      } catch (_) {
  	        return false;
  	      }
  	    }

  	    function isAnyMapElementVisibleOnScreen(mapComponent) {
  	      const mapElements = getMapVisibilityElements(mapComponent);

  	      if (!mapElements.length) return false;

  	      return mapElements.some(element => {
  	        return isElementAndParentsVisible(element);
  	      });
  	    }

  	    function bindMapVisibilityVanisher(root, mapComponent) {
  	      if (!root) return;

  	      let rafId = 0;
  	      let observer = null;
  	      let intervalId = 0;

  	      const checkVisibility = () => {
  	        rafId = 0;

  	        if (!root || !root.isConnected) return;

  	        const isVisible = isAnyMapElementVisibleOnScreen(mapComponent);

  	        setCarvedUIVisibleForMap(root, isVisible);
  	      };

  	      const scheduleCheck = () => {
  	        if (rafId) return;

  	        rafId = requestAnimationFrame(checkVisibility);
  	      };

  	      try {
  	        observer = new MutationObserver(scheduleCheck);

  	        observer.observe(document.body, {
  	          attributes: true,
  	          childList: true,
  	          subtree: true,
  	          attributeFilter: ["class", "style", "hidden", "aria-hidden"]
  	        });
  	      } catch (_) {
  	        observer = null;
  	      }

  	      window.addEventListener("scroll", scheduleCheck, true);
  	      window.addEventListener("resize", scheduleCheck);
  	      window.addEventListener("orientationchange", scheduleCheck);
  	      window.addEventListener("trackitMapControlLayoutChanged", scheduleCheck);
  	      document.addEventListener("visibilitychange", scheduleCheck);

  	      intervalId = window.setInterval(scheduleCheck, 250);

  	      root.__mapVisibilityCleanup = () => {
  	        try {
  	          if (observer) observer.disconnect();
  	        } catch (_) {}

  	        try {
  	          window.removeEventListener("scroll", scheduleCheck, true);
  	          window.removeEventListener("resize", scheduleCheck);
  	          window.removeEventListener("orientationchange", scheduleCheck);
  	          window.removeEventListener("trackitMapControlLayoutChanged", scheduleCheck);
  	          document.removeEventListener("visibilitychange", scheduleCheck);
  	        } catch (_) {}

  	        try {
  	          if (intervalId) window.clearInterval(intervalId);
  	        } catch (_) {}

  	        try {
  	          if (rafId) cancelAnimationFrame(rafId);
  	        } catch (_) {}

  	        root.__mapVisibilityCleanup = null;
  	      };

  	      checkVisibility();

  	      setTimeout(scheduleCheck, 100);
  	      setTimeout(scheduleCheck, 350);
  	      setTimeout(scheduleCheck, 800);
  	    }

  	    function createUI(userMode) {
  	      injectStyles();

  	      const root = document.createElement("div");
  	      root.id = ENGINE_ID;
  	      root.setAttribute("data-mode",
  	        userMode.mode);

  	      root.innerHTML = `
  	      <section class="ces-top-shape"></section>
  	      <section class="ces-bottom-shape"></section>
  	      <section class="ces-modal-host"></section>
  	      `;

  	      renderTop(root,
  	        userMode);
  	      renderBottom(root);
  	      renderModal(root,
  	        userMode);
  	      mountLocationDropdownBridgePlaceholder(root,
  	        userMode);

  	      const documentClickHandler = event => {
  	        if (!root.contains(event.target) && createState.openDropdown) {
  	          createState.openDropdown = "";
  	          renderTop(root, userMode);
  	        }
  	      };

  	      document.addEventListener("click", documentClickHandler);

  	      root.__cleanup = () => {
  	        document.removeEventListener("click", documentClickHandler);
  	        clearAttention(root);
  	        clearSearchPanelResizeTimers();
  	        unbindSearchPanelMapControlWatcher(root);

  	        if (typeof root.__mapVisibilityCleanup === "function") {
  	          root.__mapVisibilityCleanup();
  	        }
  	      };

  	      return root;
  	    }

  	    try {
  	      if (!APP_DATA) {
  	        resolve({
  	          ok: false,
  	          reason: "App Data missing"
  	        });

  	        return;
  	      }

  	      const mapComponent = resolveComponent(MAP_INPUT);

  	      if (!mapComponent && !MAP_INPUT) {
  	        resolve({
  	          ok: false,
  	          reason: "Map component missing"
  	        });

  	        return;
  	      }

  	      removeExistingUI();

  	      const appBag = getAppBag() || APP_DATA;
  	      const userMode = getUserMode(appBag);

  	      DATA_CHANNEL = createDataChannel(appBag, userMode);
  	      COMPANY_OPTIONS = DATA_CHANNEL.companyOptions;

  	      printDataChannelOnLoad(DATA_CHANNEL);

  	      const uiElement = createUI(userMode);

  	      document.body.appendChild(uiElement);

  	      if (
  	        window.__CarvedEdgeShapeDropdownBridge &&
  	        typeof window.__CarvedEdgeShapeDropdownBridge.mountTrackITDropdown === "function"
  	      ) {
  	        window.__CarvedEdgeShapeDropdownBridge.mountTrackITDropdown();

  	        if (typeof window.__CarvedEdgeShapeDropdownBridge.resizeTopShell === "function") {
  	          window.__CarvedEdgeShapeDropdownBridge.resizeTopShell();
  	        }
  	      }

  	      bindSearchPanelMapControlWatcher(uiElement, userMode);

  	      bindMapVisibilityVanisher(uiElement, mapComponent);

  	      const result = {
  	        ok: true,
  	        mountMode: "fixed-carved-edge-shape-ui",
  	        mode: userMode.mode,
  	        canCreateLocations: userMode.canCreateLocations,
  	        mapComponentFound: !!mapComponent || !!MAP_INPUT,
  	        createState
  	      };

  	      window.__CarvedEdgeShapeUI = {
  	        appData: APP_DATA,
  	        mapInput: MAP_INPUT,
  	        mapComponent,
  	        userMode,
  	        createState,
  	        uiElement,
  	        pendingSaveLocation: null,
  	        pendingFunctionalitySave: null,
  	        dataChannel: DATA_CHANNEL,
  	        dropdownBridge: window.__CarvedEdgeShapeDropdownBridge || null,
  	        refreshDataChannel() {
  	          const appBag = getAppBag() || APP_DATA;
  	          DATA_CHANNEL = createDataChannel(appBag, userMode);
  	          COMPANY_OPTIONS = DATA_CHANNEL.companyOptions;
  	          printDataChannelOnLoad(DATA_CHANNEL);
  	          return DATA_CHANNEL;
  	        },
  	        cleanup() {
  	          try {
  	            const bridge = window.__CarvedEdgeShapeDropdownBridge;
  	            const host = bridge && bridge.host;

  	            if (host && typeof host.__locationDropdownCleanup === "function") {
  	              host.__locationDropdownCleanup();
  	            }
  	          } catch (_) {}

  	          if (uiElement && typeof uiElement.__cleanup === "function") {
  	            uiElement.__cleanup();
  	          }
  	        }
  	      };

  	      console.log("Carved Edge Shape UI mounted:", result);

  	      resolve(result);
  	    } catch (error) {
  	      console.error("Carved Edge Shape UI failed:", error);

  	      resolve({
  	        ok: false,
  	        reason: error.message,
  	        error
  	      });
  	    }
  	  })();
  	});
  })(___arguments.context.appData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('77f7a2f37ce155b8530f61198ab9e503')));
}

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/Office/components/c61dd1c88dd81588f5980ec84aa83a58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba5bf436447b2a98ce63b2a840880d61', undefined);
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd88a9028ef82068369106ed5478c73b', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/94d8dfdfcc1f4a5c1cbbdab8a5ae8751/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Value, Time;

/**
 * Describe this function...
 */
async function Time_Function() {
  if (___arguments.value == '30 Minutes') {
    Value = 1800;
  } else if (___arguments.value == '1 Hour') {
    Value = 3600;
  } else if (___arguments.value == '3 Hours') {
    Value = 10800;
  } else if (___arguments.value == '6 Hours') {
    Value = 21600;
  } else if (___arguments.value == '24 Hours') {
    Value = 86400;
  }
  return Value
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Time = await Time_Function();
  ___arguments.context.pageData['Fine Track Historical'] = ({ [`Date`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Date')),[`Period`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Period')) });
  await BackendlessUI.Functions.Custom['fn_ab413a982236a49bcc125023ef64d39b'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69a4d66f0ae607681644a32c0e389108')), ___arguments.context.appData, [(getObjectProperty(___arguments.context.appData, 'SelectedTractor'))], ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Period')) == 'Whole Day' ? (new Date((await (async function(timestamp) {
  	function getStartOfDayTimestamp(timestamp) {
  	  const startDate = new Date(timestamp);
  	  startDate.setHours(0, 0, 0, 0); // Set to the start of the day
  	
  	  return startDate.getTime();
  	}
  	
  	// Directly execute and return the result
  	return getStartOfDayTimestamp(timestamp);

  })((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Date')))))) : (new Date((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Date'))))), ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Period')) == 'Whole Day' ? (new Date((await (async function(timestamp) {
  	//function getStartOfDayTimestamp(timestamp) {
  	  //const startDate = new Date(timestamp);
  	  //startDate.setHours(23, 59, 59, 99999999); // Set to the start of the day
  	//
  	  //return startDate.getTime();
  	//}
  	
  	// Directly execute and return the result
  	//return getStartOfDayTimestamp(timestamp);
  	function getEndOfDayTimestamp(timestamp) {
  	  const endDate = new Date(timestamp);
  	
  	  if (Number.isNaN(endDate.getTime())) {
  	    throw new Error("Invalid timestamp supplied to End Of Day");
  	  }
  	
  	  endDate.setHours(23, 59, 59, 999);
  	  return endDate.getTime();
  	}
  	
  	return getEndOfDayTimestamp(timestamp);
  })((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Date')))))) : (new Date((new Date((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Date')))).getTime() + (Time * 1000)))), null, null, null, null, null, null);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d8dfdfcc1f4a5c1cbbdab8a5ae8751', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Office/components/2a484c973e58460cd7c87258b22df528/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, Tractors, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Tractors2() {
  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Tractors, k);
    }
  }
  return await asyncListFilter(Tractors, async (item) => {


 return (!(await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(item, 'Tracker')))));
})
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('LiveTrack') !== -1) {
      try {
        await (async function(Map, Vehicles, App) {
        	/*
        	  TrackIT Reset Map View
        	
        	  Custom Code Inputs:
        	    Map      = Track Component Map
        	    Vehicles = Tractors
        	    App      = App Data
        	
        	  Action:
        	    - Close open truck popup
        	    - Stop following selected truck
        	    - Clear SelectedTractorMarker / SelectedTractor
        	    - Fit map back to all truck markers / all vehicle positions
        	    - Reset zoom back out
        	*/
        	
        	(function resetTrackITMapView(MapInput, VehiclesInput, AppInput) {
        	  const RESET_MAX_ZOOM = 14;
        	  const SINGLE_VEHICLE_ZOOM = 14;
        	
        	  function getGoogleMap(mapComponent) {
        	    if (!mapComponent) return null;
        	
        	    // Backendless Google Map component shape
        	    if (mapComponent.map && mapComponent.map.map) {
        	      return mapComponent.map.map;
        	    }
        	
        	    // Already a Google Map instance
        	    if (typeof google !== "undefined" && mapComponent instanceof google.maps.Map) {
        	      return mapComponent;
        	    }
        	
        	    return null;
        	  }
        	
        	  function getAppBag() {
        	    if (AppInput?.data && typeof AppInput.data === "object") {
        	      return AppInput.data;
        	    }
        	
        	    if (AppInput && typeof AppInput === "object" && !("data" in AppInput)) {
        	      return AppInput;
        	    }
        	
        	    if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
        	      return BackendlessUI.App.data;
        	    }
        	
        	    if (typeof window !== "undefined" && window.AppData) {
        	      return window.AppData.data || window.AppData;
        	    }
        	
        	    return null;
        	  }
        	
        	  function refreshApp() {
        	    try {
        	      BackendlessUI?.App?.refresh?.();
        	    } catch (_) {}
        	  }
        	
        	  function clearSelectedTractorMarker() {
        	    const bag = getAppBag();
        	
        	    if (bag) {
        	      try {
        	        delete bag.SelectedTractorMarker;
        	      } catch (_) {
        	        bag.SelectedTractorMarker = null;
        	      }
        	
        	      try {
        	        bag.SelectedTractor = null;
        	      } catch (_) {}
        	    }
        	
        	    try {
        	      if (AppInput?.SelectedTractorMarker?.setMap) {
        	        AppInput.SelectedTractorMarker.setMap(null);
        	      }
        	
        	      AppInput.SelectedTractorMarker = null;
        	    } catch (_) {}
        	
        	    try {
        	      window.SelectedTractor = null;
        	    } catch (_) {}
        	
        	    refreshApp();
        	  }
        	
        	  function num(v) {
        	    return typeof v === "number" ? v : Number(v);
        	  }
        	
        	  function getPath(obj, path) {
        	    if (!obj || !path) return undefined;
        	
        	    // Supports literal dotted keys like Location["position.latitude"]
        	    if (Object.prototype.hasOwnProperty.call(obj, path)) {
        	      return obj[path];
        	    }
        	
        	    return String(path).split(".").reduce((cur, part) => {
        	      return cur && cur[part] !== undefined ? cur[part] : undefined;
        	    }, obj);
        	  }
        	
        	  function getLatLngFromVehicle(item) {
        	    if (Number.isFinite(num(item?.lat)) && Number.isFinite(num(item?.lng))) {
        	      return {
        	        lat: num(item.lat),
        	        lng: num(item.lng)
        	      };
        	    }
        	
        	    const T = item?.Tractor || item;
        	    const L = T?.Location || item?.Location;
        	
        	    const lat = num(getPath(L, "position.latitude"));
        	    const lng = num(getPath(L, "position.longitude"));
        	
        	    if (Number.isFinite(lat) && Number.isFinite(lng)) {
        	      return {
        	        lat,
        	        lng
        	      };
        	    }
        	
        	    return null;
        	  }
        	
        	  function collectMarkerPositions(map) {
        	    const positions = [];
        	    const store = map.__truckPins || {};
        	
        	    Object.keys(store).forEach(id => {
        	      const marker = store[id]?.marker;
        	
        	      if (!marker || typeof marker.getPosition !== "function") return;
        	
        	      const pos = marker.getPosition();
        	
        	      if (pos) {
        	        positions.push(pos);
        	      }
        	    });
        	
        	    return positions;
        	  }
        	
        	  function collectVehiclePositions() {
        	    const positions = [];
        	    const vehicles = Array.isArray(VehiclesInput) ? VehiclesInput : [];
        	
        	    vehicles.forEach(vehicle => {
        	      const pos = getLatLngFromVehicle(vehicle);
        	
        	      if (pos) {
        	        positions.push(pos);
        	      }
        	    });
        	
        	    return positions;
        	  }
        	
        	  const map = getGoogleMap(MapInput);
        	
        	  if (!map || typeof google === "undefined" || !(map instanceof google.maps.Map)) {
        	    console.error("[TrackIT Reset] Invalid Map input.");
        	    return;
        	  }
        	
        	  // Close active truck popup.
        	  try {
        	    if (map.__truckInfoWindow) {
        	      map.__truckInfoWindow.close();
        	      map.__truckInfoWindow.__currentId = null;
        	      map.__truckInfoWindow.__currentTractor = null;
        	    }
        	  } catch (_) {}
        	
        	  // Stop follow mode.
        	  try {
        	    if (map.__follow) {
        	      map.__follow.enabled = false;
        	      map.__follow.id = null;
        	    }
        	  } catch (_) {}
        	
        	  clearSelectedTractorMarker();
        	
        	  // Prefer actual marker positions. Fall back to Vehicles array.
        	  let positions = collectMarkerPositions(map);
        	
        	  if (!positions.length) {
        	    positions = collectVehiclePositions();
        	  }
        	
        	  if (!positions.length) {
        	    console.warn("[TrackIT Reset] No vehicle positions found.");
        	    return;
        	  }
        	
        	  if (positions.length === 1) {
        	    map.setCenter(positions[0]);
        	    map.setZoom(SINGLE_VEHICLE_ZOOM);
        	    return;
        	  }
        	
        	  const bounds = new google.maps.LatLngBounds();
        	
        	  positions.forEach(pos => {
        	    bounds.extend(pos);
        	  });
        	
        	  map.fitBounds(bounds, {
        	    top: 90,
        	    right: 90,
        	    bottom: 90,
        	    left: 260
        	  });
        	
        	  google.maps.event.addListenerOnce(map, "idle", function () {
        	    try {
        	      if (map.getZoom() > RESET_MAX_ZOOM) {
        	        map.setZoom(RESET_MAX_ZOOM);
        	      }
        	    } catch (_) {}
        	  });
        	
        	})(
        	  typeof Map !== "undefined" ? Map : null,
        	  typeof Vehicles !== "undefined" ? Vehicles : [],
        	  typeof App !== "undefined" ? App : null
        	);
        })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c5c1158d7432af8a60840f7e4d8f854')), (await Tractors2()), ___arguments.context.appData);

      } catch (error) {
        console.log(error);

      }
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e')), [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cba825083f48a23842c528554b88f698')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72'))]);
    } else {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e'))]);
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e'))]);
    }

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('LiveTrack') !== -1) {
      View = true;
    } else {
      View = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      View = false;
    }

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/91ed6c680d28c938e49fc6588f83ee18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Menu_Closers() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fc90fe85fb3fdb851e842383a2cbe6d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb589f58823489b55d73a8c86512ba2a', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fd81dee1f1852b56f34b68de1d3d46e', false);

  } catch (error) {
    console.log(error);

  }
}


  await Menu_Closers();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fc90fe85fb3fdb851e842383a2cbe6d', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  await (async function(AppData, Companies, Hub) {
  	(function applicationManager_mobilePortrait_FullRewrite(args) {
  	  console.log("APPLICATION MANAGER (MOBILE PORTRAIT / UI FULL REWRITE): INIT", args);
  	
  	  // ==========================================================
  	  // 0) SAFE INPUTS (Golden standard for injected globals)
  	  // ==========================================================
  	  var AppData = (args && args.AppData) || (typeof AppData !== "undefined" ? AppData : null);
  	  var Hub = (args && args.Hub) || (typeof Hub !== "undefined" ? Hub : null);
  	  var Backendless = (args && args.Backendless) || (typeof Backendless !== "undefined" ? Backendless : null);
  	  var Button = (args && args.Button) || (typeof Button !== "undefined" ? Button : null);
  	
  	  // ==========================================================
  	  // 1) HUB MOUNT
  	  // ==========================================================
  	  function resolveHubElement(Hub) {
  	    if (!Hub) return null;
  	
  	    if (Hub instanceof HTMLElement) return Hub;
  	    if (Hub.el instanceof HTMLElement) return Hub.el;
  	    if (Hub.element instanceof HTMLElement) return Hub.element;
  	    if (Hub.elRef instanceof HTMLElement) return Hub.elRef;
  	    if (Hub.ref instanceof HTMLElement) return Hub.ref;
  	
  	    if (typeof Hub.getEl === "function") {
  	      var el = Hub.getEl();
  	      if (el instanceof HTMLElement) return el;
  	    }
  	
  	    if (Hub.componentUID) {
  	      var node = document.querySelector('[data-component="' + Hub.componentUID + '"]');
  	      if (node instanceof HTMLElement) return node;
  	    }
  	
  	    return null;
  	  }
  	
  	    var hubEl = resolveHubElement(Hub);
  	  if (!hubEl) {
  	    console.warn("APPLICATION MANAGER: Hub DOM element not found", Hub);
  	    return;
  	  }
  	
  	  // Force hub mount to occupy all available space
  	  try {
  	    hubEl.style.width = "100%";
  	    hubEl.style.height = "100%";
  	    hubEl.style.minHeight = "100%";
  	    hubEl.style.display = "flex";
  	    hubEl.style.flexDirection = "column";
  	    hubEl.style.boxSizing = "border-box";
  	    hubEl.style.margin = "0";
  	    hubEl.style.padding = "0";
  	    hubEl.style.overflow = "hidden";
  	  } catch (e) {}
  	
  	  // ==========================================================
  	  // 2) UTILS
  	  // ==========================================================
  	  function deepClone(x) {
  	    try { return JSON.parse(JSON.stringify(x)); } catch (e) { return x; }
  	  }
  	
  	  function toast(msg) {
  	    alert(msg);
  	  }
  	
  	  function safeLower(x) {
  	    return String(x == null ? "" : x).trim().toLowerCase();
  	  }
  	
  	  function nowId(prefix) {
  	    return String(prefix || "ID") + "_" + Date.now() + "_" + Math.floor(Math.random() * 100000);
  	  }
  	
  	  function isPlainObject(x) {
  	    return !!x && typeof x === "object" && Object.prototype.toString.call(x) === "[object Object]";
  	  }
  	
  	  function setButtonVisible(flag) {
  	    try {
  	      if (!Button) return;
  	      if (typeof Button.setVisible === "function") Button.setVisible(!!flag);
  	      else if ("visible" in Button) Button.visible = !!flag;
  	    } catch (e) {}
  	  }
  	
  	  function isDescriptor(x) {
  	    return !!(x && typeof x === "object" && ("value" in x) && ("selector" in x));
  	  }
  	
  	  function readMaybeDescriptor(node, key) {
  	    if (!node) return "";
  	    var v = node[key];
  	    return isDescriptor(v) ? v.value : v;
  	  }
  	
  	  function el(tag, options) {
  	    var node = document.createElement(tag);
  	    options = options || {};
  	
  	    if (options.className) node.className = options.className;
  	    if (options.text != null) node.textContent = options.text;
  	    if (options.html != null) node.innerHTML = options.html;
  	
  	    if (options.attrs) {
  	      Object.keys(options.attrs).forEach(function (k) {
  	        var v = options.attrs[k];
  	        if (v != null) node.setAttribute(k, v);
  	      });
  	    }
  	
  	    return node;
  	  }
  	
  	  // ==========================================================
  	  // 3) AUTHORITATIVE DATA
  	  // ==========================================================
  	  function ensureAppDataUser() {
  	    if (!AppData) return null;
  	    if (!AppData.User) AppData.User = {};
  	    return AppData.User;
  	  }
  	
  	  function ensureAppDataCompaniesArray() {
  	    var user = ensureAppDataUser();
  	    if (!user) return [];
  	    if (!Array.isArray(user.Companies)) user.Companies = [];
  	    return user.Companies;
  	  }
  	
  	  function getAuthoritativeCompaniesRef() {
  	    return ensureAppDataCompaniesArray();
  	  }
  	
  	  // ==========================================================
  	  // 4) NORMALIZATION
  	  // ==========================================================
  	  function ensureListDescriptor(node, key) {
  	    if (!node || typeof node !== "object") return;
  	
  	    var cur = node[key];
  	
  	    if (isDescriptor(cur)) {
  	      cur.editable = true;
  	      cur.selector = "list";
  	      if (!Array.isArray(cur.value)) cur.value = [];
  	      return;
  	    }
  	
  	    node[key] = {
  	      value: Array.isArray(cur) ? cur.slice() : [],
  	      editable: true,
  	      selector: "list"
  	    };
  	  }
  	
  	  function getAppsArrayFromAny(company) {
  	    if (!company || typeof company !== "object") return [];
  	
  	    if (company.Manifest) {
  	      var top = company.Manifest.Applications;
  	      if (isDescriptor(top) && Array.isArray(top.value)) return top.value.slice();
  	      if (Array.isArray(top)) return top.slice();
  	    }
  	
  	    if (company.Data && company.Data.Manifest) {
  	      var data = company.Data.Manifest.Applications;
  	      if (isDescriptor(data) && Array.isArray(data.value)) return data.value.slice();
  	      if (Array.isArray(data)) return data.slice();
  	    }
  	
  	    return [];
  	  }
  	
  	  function normalizeCompany(company) {
  	    if (!company || typeof company !== "object") return company;
  	
  	    if (!company.CompanyId) {
  	      company.CompanyId = company.objectId ? ("CO_" + company.objectId) : nowId("CO_LOCAL");
  	    }
  	
  	    if (!company.Data || !isPlainObject(company.Data)) company.Data = {};
  	    if (!company.Data.Profile || !isPlainObject(company.Data.Profile)) company.Data.Profile = {};
  	    if (!company.Data.Manifest || !isPlainObject(company.Data.Manifest)) company.Data.Manifest = {};
  	    if (!company.Manifest || !isPlainObject(company.Manifest)) company.Manifest = {};
  	
  	    ensureListDescriptor(company.Manifest, "Applications");
  	    ensureListDescriptor(company.Data.Manifest, "Applications");
  	
  	    var apps = getAppsArrayFromAny(company);
  	    company.Manifest.Applications.value = apps.slice();
  	    company.Data.Manifest.Applications.value = apps.slice();
  	
  	    return company;
  	  }
  	
  	  function getApplicationsDescriptor(company) {
  	    if (!company) return null;
  	
  	    normalizeCompany(company);
  	
  	    var dTop = company.Manifest ? company.Manifest.Applications : null;
  	    var dData = (company.Data && company.Data.Manifest) ? company.Data.Manifest.Applications : null;
  	
  	    if (isDescriptor(dTop)) return dTop;
  	    if (isDescriptor(dData)) return dData;
  	
  	    return null;
  	  }
  	
  	  function syncApplications(company) {
  	    if (!company) return;
  	
  	    normalizeCompany(company);
  	
  	    var dTop = company.Manifest ? company.Manifest.Applications : null;
  	    var apps = (isDescriptor(dTop) && Array.isArray(dTop.value)) ? dTop.value.slice() : [];
  	
  	    company.Manifest.Applications.value = apps.slice();
  	    company.Data.Manifest.Applications.value = apps.slice();
  	  }
  	
  	  // ==========================================================
  	  // 5) DISPLAY HELPERS
  	  // ==========================================================
  	  function getCompanyName(company) {
  	    if (!company) return "(Unknown)";
  	    var p = company.Data && company.Data.Profile ? company.Data.Profile : {};
  	
  	    var nm = readMaybeDescriptor(p, "Company_Name");
  	    var ta = readMaybeDescriptor(p, "Trading_As");
  	
  	    var best = String(nm || ta || "").trim();
  	    if (best) return best;
  	
  	    return String(company.CompanyId || company.objectId || "(No Id)");
  	  }
  	
  	  function getCompanyType(company) {
  	    if (!company) return "";
  	    var p = company.Data && company.Data.Profile ? company.Data.Profile : {};
  	    var t = readMaybeDescriptor(p, "Company_Type");
  	    return String(t || "").trim();
  	  }
  	
  	  // ==========================================================
  	  // 6) APPDATA IN-PLACE UPDATE
  	  // ==========================================================
  	  function findAppDataCompanyRef(companyLike) {
  	    var arr = getAuthoritativeCompaniesRef();
  	    if (!companyLike) return null;
  	
  	    if (companyLike.objectId) {
  	      for (var i = 0; i < arr.length; i++) {
  	        if (arr[i] && arr[i].objectId === companyLike.objectId) return arr[i];
  	      }
  	    }
  	
  	    if (companyLike.CompanyId) {
  	      for (var j = 0; j < arr.length; j++) {
  	        if (arr[j] && arr[j].CompanyId === companyLike.CompanyId) return arr[j];
  	      }
  	    }
  	
  	    return null;
  	  }
  	
  	  function applyAppsToAppDataCompanyInPlace(appCompany, appsArray) {
  	    if (!appCompany) return;
  	
  	    var cleanApps = Array.isArray(appsArray) ? appsArray.slice() : [];
  	
  	    if (!appCompany.Manifest || !isPlainObject(appCompany.Manifest)) appCompany.Manifest = {};
  	    if (!appCompany.Data || !isPlainObject(appCompany.Data)) appCompany.Data = {};
  	    if (!appCompany.Data.Manifest || !isPlainObject(appCompany.Data.Manifest)) appCompany.Data.Manifest = {};
  	
  	    appCompany.Manifest.Applications = cleanApps.slice();
  	    appCompany.Data.Manifest.Applications = cleanApps.slice();
  	  }
  	
  	  function refreshBindings() {
  	    var authoritative = getAuthoritativeCompaniesRef();
  	
  	    if (args && typeof args === "object") {
  	      args.Companies = authoritative;
  	    }
  	
  	    if (Hub && typeof Hub === "object") {
  	      try { Hub.value = authoritative; } catch (e) {}
  	      try { if (typeof Hub.setValue === "function") Hub.setValue(authoritative); } catch (e2) {}
  	    }
  	  }
  	
  	  // ==========================================================
  	  // 7) BACKENDLESS SAVE
  	  // ==========================================================
  	  function sanitizeForBackendless(value) {
  	    if (value == null) return value;
  	
  	    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return value;
  	    if (isDescriptor(value)) return sanitizeForBackendless(value.value);
  	    if (Array.isArray(value)) return value.map(sanitizeForBackendless);
  	
  	    if (typeof value === "object") {
  	      var out = {};
  	      Object.keys(value).forEach(function (k) {
  	        if (k === "CompanyId") return;
  	        out[k] = sanitizeForBackendless(value[k]);
  	      });
  	      return out;
  	    }
  	
  	    return value;
  	  }
  	
  	  function toBackendlessCompany(companyUi) {
  	    normalizeCompany(companyUi);
  	    syncApplications(companyUi);
  	
  	    var clean = sanitizeForBackendless(companyUi);
  	
  	    if (!clean.Manifest || !isPlainObject(clean.Manifest)) clean.Manifest = {};
  	    if (!Array.isArray(clean.Manifest.Applications)) clean.Manifest.Applications = [];
  	
  	    return clean;
  	  }
  	
  	  function saveCompanyToBackendless(companyUi) {
  	    if (!companyUi) return Promise.resolve({ ok: false, reason: "No company" });
  	
  	    if (!Backendless || !Backendless.Data || typeof Backendless.Data.of !== "function") {
  	      console.warn("APPLICATION MANAGER: Backendless SDK not available.");
  	      return Promise.resolve({ ok: false, reason: "Backendless missing" });
  	    }
  	
  	    if (!companyUi.objectId) {
  	      console.warn("APPLICATION MANAGER: Company missing objectId; cannot update Companies table.", companyUi);
  	      return Promise.resolve({ ok: false, reason: "Missing objectId" });
  	    }
  	
  	    var cleanToSave = toBackendlessCompany(companyUi);
  	
  	    console.log("APPLICATION MANAGER: Backendless save payload", cleanToSave);
  	
  	    return Backendless.Data.of("Companies").save(cleanToSave)
  	      .then(function (saved) {
  	        console.log("APPLICATION MANAGER: Backendless save success", saved);
  	        return { ok: true, saved: saved };
  	      })
  	      .catch(function (err) {
  	        console.error("APPLICATION MANAGER: Backendless save failed", err);
  	        var msg = (err && (err.message || err.faultString)) ? (err.message || err.faultString) : "Save failed";
  	        return { ok: false, reason: msg, error: err };
  	      });
  	  }
  	
  	  // ==========================================================
  	  // 8) STYLES
  	  // ==========================================================
  	  function injectStylesOnce() {
  	    if (document.getElementById("app-manager-mobile-portrait-clean-ui")) return;
  	
  	    var style = document.createElement("style");
  	    style.id = "app-manager-mobile-portrait-clean-ui";
  	    style.textContent = `
  	      .am4-root{
  	        font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  	        color:#f0f0f0;
  	        box-sizing:border-box;
  	        width:100%;
  	        max-width:100%;
  	        padding:0;
  	        margin:0;
  	      }
  	
  	      .am4-shell{
  	        width:100%;
  	        box-sizing:border-box;
  	        background:linear-gradient(180deg, rgba(12,12,12,0.84) 0%, rgba(12,12,12,0.72) 100%);
  	        border:1px solid rgba(255,255,255,0.08);
  	        border-radius:0;
  	        overflow:hidden;
  	        backdrop-filter:blur(6px);
  	      }
  	
  	      .am4-topbar{
  	        display:flex;
  	        align-items:flex-start;
  	        justify-content:space-between;
  	        gap:10px;
  	        padding:12px 14px 10px 14px;
  	        border-bottom:1px solid rgba(255,255,255,0.07);
  	      }
  	
  	      .am4-topbar-left{
  	        min-width:0;
  	        flex:1 1 auto;
  	      }
  	
  	      .am4-title{
  	        font-size:1.1rem;
  	        font-weight:1000;
  	        color:#ffffff;
  	        line-height:1.1;
  	        margin:0;
  	        letter-spacing:-0.01em;
  	      }
  	
  	      .am4-sub{
  	        margin-top:3px;
  	        font-size:0.78rem;
  	        color:rgba(255,255,255,0.72);
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	
  	      .am4-topbar-right{
  	        display:flex;
  	        align-items:center;
  	        justify-content:flex-end;
  	        gap:8px;
  	        flex:0 0 auto;
  	        flex-wrap:nowrap;
  	      }
  	
  	      .am4-pill{
  	        display:inline-flex;
  	        align-items:center;
  	        justify-content:center;
  	        min-height:34px;
  	        padding:0 12px;
  	        border-radius:999px;
  	        font-size:0.78rem;
  	        font-weight:700;
  	        white-space:nowrap;
  	        background:rgba(73,81,96,0.82);
  	        border:1px solid rgba(255,255,255,0.08);
  	        color:#eef2f7;
  	      }
  	
  	      .am4-btn{
  	        appearance:none;
  	        border-radius:999px;
  	        border:1px solid rgba(255,255,255,0.12);
  	        background:rgba(58,58,58,0.86);
  	        color:#f3f3f3;
  	        font-size:0.84rem;
  	        font-weight:700;
  	        padding:8px 14px;
  	        cursor:pointer;
  	        white-space:nowrap;
  	        user-select:none;
  	      }
  	
  	      .am4-btn:hover{
  	        background:rgba(74,74,74,0.95);
  	      }
  	
  	      .am4-btn-primary{
  	        background:#CC6633;
  	        border-color:#CC6633;
  	        color:#fff;
  	      }
  	
  	      .am4-btn-primary:hover{
  	        background:#dc7440;
  	        border-color:#dc7440;
  	      }
  	
  	      .am4-btn-danger{
  	        background:#552626;
  	        border-color:#a34d4d;
  	        color:#ffd5d5;
  	      }
  	
  	      .am4-btn-danger:hover{
  	        background:#693030;
  	      }
  	
  	      .am4-btn-disabled{
  	        opacity:0.55;
  	        cursor:not-allowed;
  	      }
  	
  	      .am4-body{
  	        padding:12px 14px 14px 14px;
  	      }
  	
  	      .am4-field{
  	        margin-top:10px;
  	      }
  	
  	      .am4-field:first-child{
  	        margin-top:0;
  	      }
  	
  	      .am4-input,
  	      .am4-select,
  	      .am4-textarea{
  	        width:100%;
  	        box-sizing:border-box;
  	        border-radius:12px;
  	        border:1px solid rgba(255,255,255,0.10);
  	        background:rgba(25,25,25,0.88);
  	        color:#ededed;
  	        font-size:0.94rem;
  	        padding:10px 12px;
  	        outline:none;
  	      }
  	
  	      .am4-input:focus,
  	      .am4-select:focus,
  	      .am4-textarea:focus{
  	        border-color:#CC6633;
  	        box-shadow:0 0 0 1px #CC6633;
  	      }
  	
  	      .am4-actions{
  	        display:flex;
  	        gap:8px;
  	        align-items:center;
  	        flex-wrap:wrap;
  	        margin-top:12px;
  	      }
  	
  	      .am4-section{
  	        margin-top:14px;
  	        border-top:1px solid rgba(255,255,255,0.07);
  	        padding-top:12px;
  	      }
  	
  	      .am4-section-title{
  	        font-size:0.78rem;
  	        font-weight:900;
  	        text-transform:uppercase;
  	        letter-spacing:0.04em;
  	        color:rgba(255,255,255,0.68);
  	        margin-bottom:8px;
  	      }
  	
  	      .am4-list{
  	        display:flex;
  	        flex-direction:column;
  	        gap:8px;
  	      }
  	
  	      .am4-item{
  	        display:flex;
  	        align-items:center;
  	        justify-content:space-between;
  	        gap:10px;
  	        padding:10px 12px;
  	        border-radius:12px;
  	        background:rgba(30,30,30,0.88);
  	        border:1px solid rgba(255,255,255,0.08);
  	      }
  	
  	      .am4-item-name{
  	        min-width:0;
  	        flex:1 1 auto;
  	        font-size:0.95rem;
  	        font-weight:800;
  	        color:#f5f5f5;
  	        white-space:nowrap;
  	        overflow:hidden;
  	        text-overflow:ellipsis;
  	      }
  	
  	      .am4-item-actions{
  	        display:flex;
  	        gap:8px;
  	        align-items:center;
  	        flex:0 0 auto;
  	      }
  	
  	      .am4-empty{
  	        padding:10px 2px;
  	        color:rgba(255,255,255,0.62);
  	        font-size:0.94rem;
  	      }
  	
  	      .am4-modal-backdrop{
  	        position:fixed;
  	        inset:0;
  	        background:rgba(0,0,0,0.66);
  	        display:flex;
  	        align-items:center;
  	        justify-content:center;
  	        z-index:999999;
  	      }
  	
  	      .am4-modal{
  	        width:min(560px, calc(100vw - 28px));
  	        border:1px solid rgba(255,255,255,0.10);
  	        border-radius:16px;
  	        background:rgba(16,16,16,0.98);
  	        padding:14px;
  	        box-sizing:border-box;
  	        box-shadow:0 18px 60px rgba(0,0,0,0.5);
  	      }
  	
  	      .am4-modal-title{
  	        font-weight:1000;
  	        color:#fff;
  	        font-size:1rem;
  	        margin-bottom:6px;
  	      }
  	
  	      .am4-modal-sub{
  	        color:rgba(255,255,255,0.72);
  	        font-size:0.86rem;
  	        line-height:1.45;
  	        margin-bottom:10px;
  	      }
  	
  	      .am4-modal-actions{
  	        display:flex;
  	        justify-content:flex-end;
  	        gap:8px;
  	        margin-top:10px;
  	        flex-wrap:wrap;
  	      }
  	    `;
  	    document.head.appendChild(style);
  	  }
  	  injectStylesOnce();
  	
  	  // ==========================================================
  	  // 9) MODALS
  	  // ==========================================================
  	  function removeExistingModal() {
  	    var existing = document.getElementById("am4-modal-backdrop");
  	    if (existing) existing.remove();
  	  }
  	
  	  function openTextBlockModal(opts) {
  	    var title = (opts && opts.title) || "Enter value";
  	    var subtitle = (opts && opts.subtitle) || "";
  	    var placeholder = (opts && opts.placeholder) || "";
  	    var initialValue = (opts && opts.initialValue);
  	    var confirmText = (opts && opts.confirmText) || "OK";
  	    var onConfirm = (opts && opts.onConfirm);
  	
  	    removeExistingModal();
  	
  	    var backdrop = document.createElement("div");
  	    backdrop.id = "am4-modal-backdrop";
  	    backdrop.className = "am4-modal-backdrop";
  	
  	    var modal = document.createElement("div");
  	    modal.className = "am4-modal";
  	
  	    var t = document.createElement("div");
  	    t.className = "am4-modal-title";
  	    t.textContent = title;
  	
  	    var sub = document.createElement("div");
  	    sub.className = "am4-modal-sub";
  	    sub.textContent = subtitle;
  	
  	    var input = document.createElement("textarea");
  	    input.className = "am4-textarea";
  	    input.placeholder = placeholder;
  	    input.value = (initialValue != null) ? String(initialValue) : "";
  	    input.style.minHeight = "120px";
  	
  	    var actions = document.createElement("div");
  	    actions.className = "am4-modal-actions";
  	
  	    var cancelBtn = document.createElement("button");
  	    cancelBtn.className = "am4-btn";
  	    cancelBtn.type = "button";
  	    cancelBtn.textContent = "Cancel";
  	
  	    var okBtn = document.createElement("button");
  	    okBtn.className = "am4-btn am4-btn-primary";
  	    okBtn.type = "button";
  	    okBtn.textContent = confirmText;
  	
  	    function close() {
  	      backdrop.remove();
  	    }
  	
  	    cancelBtn.addEventListener("click", close);
  	
  	    okBtn.addEventListener("click", function () {
  	      var val = String(input.value || "").trim();
  	      if (!val) {
  	        toast("Please enter a value.");
  	        return;
  	      }
  	
  	      try {
  	        if (typeof onConfirm === "function") onConfirm(val);
  	      } finally {
  	        close();
  	      }
  	    });
  	
  	    backdrop.addEventListener("click", function (ev) {
  	      if (ev.target === backdrop) close();
  	    });
  	
  	    input.addEventListener("keydown", function (ev) {
  	      if (ev.key === "Enter" && (ev.ctrlKey || ev.metaKey)) {
  	        ev.preventDefault();
  	        okBtn.click();
  	      }
  	      if (ev.key === "Escape") {
  	        ev.preventDefault();
  	        close();
  	      }
  	    });
  	
  	    actions.appendChild(cancelBtn);
  	    actions.appendChild(okBtn);
  	
  	    modal.appendChild(t);
  	    if (sub.textContent) modal.appendChild(sub);
  	    modal.appendChild(input);
  	    modal.appendChild(actions);
  	
  	    backdrop.appendChild(modal);
  	    document.body.appendChild(backdrop);
  	
  	    setTimeout(function () { input.focus(); }, 0);
  	  }
  	
  	  function openUnsavedCloseModal(opts) {
  	    opts = opts || {};
  	
  	    removeExistingModal();
  	
  	    var backdrop = document.createElement("div");
  	    backdrop.id = "am4-modal-backdrop";
  	    backdrop.className = "am4-modal-backdrop";
  	
  	    var modal = document.createElement("div");
  	    modal.className = "am4-modal";
  	
  	    var t = document.createElement("div");
  	    t.className = "am4-modal-title";
  	    t.textContent = "Unsaved changes";
  	
  	    var sub = document.createElement("div");
  	    sub.className = "am4-modal-sub";
  	    sub.innerHTML = "You have unsaved application changes for the selected company.<br>Choose what to do before closing.";
  	
  	    var actions = document.createElement("div");
  	    actions.className = "am4-modal-actions";
  	
  	    var cancelBtn = document.createElement("button");
  	    cancelBtn.className = "am4-btn";
  	    cancelBtn.type = "button";
  	    cancelBtn.textContent = "Cancel";
  	
  	    var discardBtn = document.createElement("button");
  	    discardBtn.className = "am4-btn am4-btn-danger";
  	    discardBtn.type = "button";
  	    discardBtn.textContent = "Close Without Saving";
  	
  	    var saveBtn = document.createElement("button");
  	    saveBtn.className = "am4-btn am4-btn-primary";
  	    saveBtn.type = "button";
  	    saveBtn.textContent = "Save & Close";
  	
  	    function closeModal() {
  	      backdrop.remove();
  	    }
  	
  	    cancelBtn.addEventListener("click", function () {
  	      closeModal();
  	      if (typeof opts.onCancel === "function") opts.onCancel();
  	    });
  	
  	    discardBtn.addEventListener("click", function () {
  	      closeModal();
  	      if (typeof opts.onDiscardAndClose === "function") opts.onDiscardAndClose();
  	    });
  	
  	    saveBtn.addEventListener("click", function () {
  	      saveBtn.disabled = true;
  	      discardBtn.disabled = true;
  	      cancelBtn.disabled = true;
  	
  	      saveBtn.className += " am4-btn-disabled";
  	      discardBtn.className += " am4-btn-disabled";
  	      cancelBtn.className += " am4-btn-disabled";
  	
  	      if (typeof opts.onSaveAndClose === "function") {
  	        opts.onSaveAndClose(function done() {
  	          closeModal();
  	        });
  	      } else {
  	        closeModal();
  	      }
  	    });
  	
  	    backdrop.addEventListener("click", function (ev) {
  	      if (ev.target === backdrop) {
  	        closeModal();
  	        if (typeof opts.onCancel === "function") opts.onCancel();
  	      }
  	    });
  	
  	    actions.appendChild(cancelBtn);
  	    actions.appendChild(discardBtn);
  	    actions.appendChild(saveBtn);
  	
  	    modal.appendChild(t);
  	    modal.appendChild(sub);
  	    modal.appendChild(actions);
  	
  	    backdrop.appendChild(modal);
  	    document.body.appendChild(backdrop);
  	  }
  	
  	  // ==========================================================
  	  // 10) STATE
  	  // ==========================================================
  	  var state = {
  	    companies: getAuthoritativeCompaniesRef().map(normalizeCompany),
  	    selectedCompanyId: null,
  	    search: "",
  	    isSaving: false,
  	    status: "Ready",
  	    dirty: false,
  	    undoSnapshot: null,
  	    isClosed: false
  	  };
  	
  	  function getSelectedCompany() {
  	    if (!state.selectedCompanyId) return null;
  	
  	    for (var i = 0; i < state.companies.length; i++) {
  	      var c = state.companies[i];
  	      if (c && c.CompanyId === state.selectedCompanyId) return c;
  	    }
  	
  	    return null;
  	  }
  	
  	  function markDirtyIfNeeded() {
  	    if (!state.dirty) {
  	      var c = getSelectedCompany();
  	      state.undoSnapshot = c ? deepClone(c) : null;
  	      state.dirty = true;
  	      state.status = "Unsaved changes";
  	    }
  	  }
  	
  	  function getStatusLabel() {
  	    if (state.isSaving) return "Saving...";
  	    if (state.dirty) return "Unsaved changes";
  	    return state.status || "Ready";
  	  }
  	
  	  // ==========================================================
  	  // 11) APPLICATION CRUD
  	  // ==========================================================
  	  function addApplication(company, name) {
  	    if (!company || typeof company !== "object") {
  	      console.warn("APPLICATION MANAGER: addApplication received invalid company", company);
  	      toast("Could not add application because no valid company was found.");
  	      return;
  	    }
  	
  	    normalizeCompany(company);
  	
  	    var d = getApplicationsDescriptor(company);
  	    if (!d) {
  	      console.warn("APPLICATION MANAGER: Applications descriptor not found after normalization", company);
  	      toast("Applications list could not be resolved for this company.");
  	      return;
  	    }
  	
  	    if (!Array.isArray(d.value)) d.value = [];
  	
  	    var clean = String(name || "").trim();
  	    if (!clean) {
  	      toast("Please enter an application name.");
  	      return;
  	    }
  	
  	    var exists = d.value.some(function (x) {
  	      return safeLower(x) === safeLower(clean);
  	    });
  	
  	    if (exists) {
  	      toast("That application already exists.");
  	      return;
  	    }
  	
  	    markDirtyIfNeeded();
  	    d.value.push(clean);
  	    syncApplications(company);
  	    render();
  	  }
  	
  	  function renameApplication(company, idx, newName) {
  	    normalizeCompany(company);
  	
  	    var d = getApplicationsDescriptor(company);
  	    if (!d) return;
  	
  	    var clean = String(newName || "").trim();
  	    if (!clean) return;
  	
  	    var exists = d.value.some(function (x, j) {
  	      return j !== idx && safeLower(x) === safeLower(clean);
  	    });
  	
  	    if (exists) {
  	      toast("That application already exists.");
  	      return;
  	    }
  	
  	    markDirtyIfNeeded();
  	    d.value[idx] = clean;
  	    syncApplications(company);
  	    render();
  	  }
  	
  	  function removeApplication(company, idx) {
  	    normalizeCompany(company);
  	
  	    var d = getApplicationsDescriptor(company);
  	    if (!d) return;
  	
  	    markDirtyIfNeeded();
  	    d.value.splice(idx, 1);
  	    syncApplications(company);
  	    render();
  	  }
  	
  	  function undoChanges() {
  	    var sel = getSelectedCompany();
  	    if (!sel || !state.undoSnapshot) return;
  	
  	    for (var i = 0; i < state.companies.length; i++) {
  	      if (state.companies[i] && state.companies[i].CompanyId === sel.CompanyId) {
  	        state.companies[i] = normalizeCompany(deepClone(state.undoSnapshot));
  	        break;
  	      }
  	    }
  	
  	    state.dirty = false;
  	    state.undoSnapshot = null;
  	    state.status = "Reverted";
  	    render();
  	  }
  	
  	  // ==========================================================
  	  // 12) SAVE
  	  // ==========================================================
  	  function saveNow() {
  	    var sel = getSelectedCompany();
  	    if (!sel) return Promise.resolve({ ok: false, reason: "No company selected" });
  	
  	    if (!state.dirty) {
  	      toast("Nothing to save.");
  	      return Promise.resolve({ ok: true, skipped: true });
  	    }
  	
  	    normalizeCompany(sel);
  	    syncApplications(sel);
  	
  	    var d = getApplicationsDescriptor(sel);
  	    var apps = (d && Array.isArray(d.value)) ? d.value.slice() : [];
  	
  	    state.isSaving = true;
  	    state.status = "Saving...";
  	    render();
  	
  	    return saveCompanyToBackendless(sel).then(function (r) {
  	      if (r && r.ok) {
  	        var ref = findAppDataCompanyRef(sel);
  	        if (ref) {
  	          applyAppsToAppDataCompanyInPlace(ref, apps);
  	        } else {
  	          console.warn("APPLICATION MANAGER: Could not find company in AppData.User.Companies to update.", sel);
  	        }
  	
  	        refreshBindings();
  	        state.dirty = false;
  	        state.undoSnapshot = null;
  	        state.status = "Saved";
  	      } else {
  	        state.status = "Backend save failed";
  	        toast("Backend save failed: " + (r && r.reason ? r.reason : "Unknown"));
  	      }
  	
  	      state.isSaving = false;
  	      render();
  	      return r;
  	    });
  	  }
  	
  	  // ==========================================================
  	  // 13) CLOSE FLOW
  	  // ==========================================================
  	  function teardownHub() {
  	    removeExistingModal();
  	    state.isClosed = true;
  	    hubEl.innerHTML = "";
  	    setButtonVisible(true);
  	  }
  	
  	  function attemptClose() {
  	    if (state.isSaving) {
  	      toast("Please wait. Save is still in progress.");
  	      return;
  	    }
  	
  	    if (!state.dirty) {
  	      teardownHub();
  	      return;
  	    }
  	
  	    openUnsavedCloseModal({
  	      onSaveAndClose: function (done) {
  	        saveNow().then(function (result) {
  	          if (result && result.ok) {
  	            done();
  	            teardownHub();
  	          } else {
  	            render();
  	          }
  	        });
  	      },
  	      onDiscardAndClose: function () {
  	        teardownHub();
  	      },
  	      onCancel: function () {
  	        render();
  	      }
  	    });
  	  }
  	
  	  // ==========================================================
  	  // 14) RENDER
  	  // ==========================================================
  	  function render() {
  	    if (state.isClosed) return;
  	
  	    hubEl.innerHTML = "";
  	
  	    var root = el("div", { className: "am4-root" });
  	    var shell = el("div", { className: "am4-shell" });
  	
  	    var sel = getSelectedCompany();
  	    var subtitle = sel
  	      ? (getCompanyName(sel) + (getCompanyType(sel) ? (" • " + getCompanyType(sel)) : ""))
  	      : "Select a company to manage its applications";
  	
  	    // ----------------------------------------------------------
  	    // TOP BAR ONLY (single clean header)
  	    // ----------------------------------------------------------
  	    var topbar = el("div", { className: "am4-topbar" });
  	
  	    var topLeft = el("div", { className: "am4-topbar-left" });
  	    topLeft.appendChild(el("div", { className: "am4-title", text: "Application Manager" }));
  	    topLeft.appendChild(el("div", { className: "am4-sub", text: subtitle }));
  	
  	    var topRight = el("div", { className: "am4-topbar-right" });
  	    topRight.appendChild(el("div", { className: "am4-pill", text: getStatusLabel() }));
  	
  	    var closeBtn = el("button", { className: "am4-btn", text: "✕ Close" });
  	    closeBtn.disabled = state.isSaving;
  	    if (closeBtn.disabled) closeBtn.className += " am4-btn-disabled";
  	    closeBtn.addEventListener("click", attemptClose);
  	
  	    topRight.appendChild(closeBtn);
  	
  	    topbar.appendChild(topLeft);
  	    topbar.appendChild(topRight);
  	
  	    shell.appendChild(topbar);
  	
  	    // ----------------------------------------------------------
  	    // BODY
  	    // ----------------------------------------------------------
  	    var body = el("div", { className: "am4-body" });
  	
  	    var searchWrap = el("div", { className: "am4-field" });
  	    var search = el("input", {
  	      className: "am4-input",
  	      attrs: {
  	        type: "text",
  	        placeholder: "Search companies...",
  	        value: state.search || ""
  	      }
  	    });
  	
  	    search.addEventListener("input", function () {
  	      state.search = search.value || "";
  	      render();
  	    });
  	
  	    searchWrap.appendChild(search);
  	    body.appendChild(searchWrap);
  	
  	    var selectWrap = el("div", { className: "am4-field" });
  	    var dropdown = el("select", { className: "am4-select" });
  	
  	    var optNone = el("option", { text: "-- Select Company --" });
  	    optNone.value = "";
  	    dropdown.appendChild(optNone);
  	
  	    var list = state.companies.slice().map(normalizeCompany);
  	    var q = safeLower(state.search || "");
  	
  	    if (q) {
  	      list = list.filter(function (c) {
  	        var blob = (getCompanyName(c) + " " + getCompanyType(c) + " " + String(c.objectId || c.CompanyId || "")).toLowerCase();
  	        return blob.includes(q);
  	      });
  	    }
  	
  	    list.sort(function (a, b) {
  	      var A = safeLower(getCompanyName(a));
  	      var B = safeLower(getCompanyName(b));
  	      if (A < B) return -1;
  	      if (A > B) return 1;
  	      return 0;
  	    });
  	
  	    list.forEach(function (c) {
  	      var o = document.createElement("option");
  	      var label = getCompanyName(c);
  	      var meta = [getCompanyType(c), String(c.objectId || c.CompanyId || "")].filter(Boolean).join(" • ");
  	      o.textContent = meta ? (label + "  (" + meta + ")") : label;
  	      o.value = c.CompanyId;
  	      if (c.CompanyId === state.selectedCompanyId) o.selected = true;
  	      dropdown.appendChild(o);
  	    });
  	
  	    dropdown.addEventListener("change", function () {
  	      if (state.dirty) {
  	        toast("You have unsaved changes. Save, Undo, or Close first.");
  	        dropdown.value = state.selectedCompanyId || "";
  	        return;
  	      }
  	
  	      state.selectedCompanyId = dropdown.value || null;
  	      state.status = "Ready";
  	
  	      var sel2 = getSelectedCompany();
  	      if (sel2) normalizeCompany(sel2);
  	
  	      render();
  	    });
  	
  	    selectWrap.appendChild(dropdown);
  	    body.appendChild(selectWrap);
  	
  	    if (!sel) {
  	      body.appendChild(el("div", {
  	        className: "am4-empty",
  	        text: "Select a company above to view and edit its applications."
  	      }));
  	
  	      shell.appendChild(body);
  	      root.appendChild(shell);
  	      hubEl.appendChild(root);
  	      return;
  	    }
  	
  	    normalizeCompany(sel);
  	
  	    var d = getApplicationsDescriptor(sel);
  	    if (!d) {
  	      body.appendChild(el("div", {
  	        className: "am4-empty",
  	        text: "Applications field missing at Manifest.Applications / Data.Manifest.Applications."
  	      }));
  	
  	      shell.appendChild(body);
  	      root.appendChild(shell);
  	      hubEl.appendChild(root);
  	      return;
  	    }
  	
  	    var apps = Array.isArray(d.value) ? d.value : [];
  	    if (!Array.isArray(d.value)) d.value = apps;
  	
  	    var actions = el("div", { className: "am4-actions" });
  	
  	    var addBtn = el("button", { className: "am4-btn am4-btn-primary", text: "+ Add Application" });
  	    addBtn.disabled = state.isSaving;
  	    if (addBtn.disabled) addBtn.className += " am4-btn-disabled";
  	    addBtn.addEventListener("click", function () {
  	      openTextBlockModal({
  	        title: "Add Application",
  	        subtitle: "Type the application name. Ctrl+Enter submits.",
  	        placeholder: "e.g. Spraying",
  	        initialValue: "",
  	        confirmText: "Add",
  	        onConfirm: function (val) {
  	          var currentSelectedCompany = getSelectedCompany();
  	          if (!currentSelectedCompany) {
  	            toast("No company is selected.");
  	            return;
  	          }
  	          addApplication(currentSelectedCompany, val);
  	        }
  	      });
  	    });
  	
  	    var saveBtn = el("button", { className: "am4-btn", text: "💾 Save" });
  	    saveBtn.disabled = (!state.dirty || state.isSaving);
  	    if (saveBtn.disabled) saveBtn.className += " am4-btn-disabled";
  	    saveBtn.addEventListener("click", function () {
  	      saveNow();
  	    });
  	
  	    var undoBtn = el("button", { className: "am4-btn", text: "↩ Undo" });
  	    undoBtn.disabled = (!state.dirty || state.isSaving);
  	    if (undoBtn.disabled) undoBtn.className += " am4-btn-disabled";
  	    undoBtn.addEventListener("click", undoChanges);
  	
  	    actions.appendChild(addBtn);
  	    actions.appendChild(saveBtn);
  	    actions.appendChild(undoBtn);
  	
  	    body.appendChild(actions);
  	
  	    var section = el("div", { className: "am4-section" });
  	    section.appendChild(el("div", { className: "am4-section-title", text: "Applications" }));
  	
  	    var listWrap = el("div", { className: "am4-list" });
  	
  	    if (!apps.length) {
  	      listWrap.appendChild(el("div", { className: "am4-empty", text: "No applications yet." }));
  	    } else {
  	      apps.forEach(function (name, idx) {
  	        var item = el("div", { className: "am4-item" });
  	        item.appendChild(el("div", { className: "am4-item-name", text: String(name || "") }));
  	
  	        var itemActions = el("div", { className: "am4-item-actions" });
  	
  	        var renameBtn = el("button", { className: "am4-btn", text: "Rename" });
  	        renameBtn.disabled = state.isSaving;
  	        if (renameBtn.disabled) renameBtn.className += " am4-btn-disabled";
  	        renameBtn.addEventListener("click", function () {
  	          openTextBlockModal({
  	            title: "Rename Application",
  	            subtitle: "This marks unsaved changes. Click Save when ready.",
  	            placeholder: "Application name",
  	            initialValue: String(apps[idx] || ""),
  	            confirmText: "Apply",
  	            onConfirm: function (val) {
  	              renameApplication(sel, idx, val);
  	            }
  	          });
  	        });
  	
  	        var delBtn = el("button", { className: "am4-btn am4-btn-danger", text: "Remove" });
  	        delBtn.disabled = state.isSaving;
  	        if (delBtn.disabled) delBtn.className += " am4-btn-disabled";
  	        delBtn.addEventListener("click", function () {
  	          removeApplication(sel, idx);
  	        });
  	
  	        itemActions.appendChild(renameBtn);
  	        itemActions.appendChild(delBtn);
  	
  	        item.appendChild(itemActions);
  	        listWrap.appendChild(item);
  	      });
  	    }
  	
  	    section.appendChild(listWrap);
  	    body.appendChild(section);
  	
  	    shell.appendChild(body);
  	    root.appendChild(shell);
  	    hubEl.appendChild(root);
  	  }
  	
  	  // ==========================================================
  	  // 15) START
  	  // ==========================================================
  	  state.companies = state.companies.map(normalizeCompany);
  	
  	  if (!state.selectedCompanyId && state.companies.length) {
  	    state.selectedCompanyId = state.companies[0].CompanyId;
  	  }
  	
  	  setButtonVisible(false);
  	  refreshBindings();
  	  render();
  	
  	})({
  	  AppData: (typeof AppData !== "undefined" ? AppData : null),
  	  Companies: (typeof Companies !== "undefined" ? Companies : null),
  	  Hub: (typeof Hub !== "undefined" ? Hub : null),
  	  Backendless: (typeof Backendless !== "undefined" ? Backendless : null),
  	  Button: (typeof Button !== "undefined" ? Button : null)
  	});
  })(___arguments.context.appData, (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3fc90fe85fb3fdb851e842383a2cbe6d')));
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e517ec0e29819ef91cfda218a0f846b6', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, View;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Settings')).indexOf('Applications') !== -1) {
      View = true;
    } else {
      View = false;
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      View = false;
    }

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/3afc0ee2e696faa8e43dfcb89de82b48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('Bowser') !== -1) {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cba825083f48a23842c528554b88f698')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72'))]);
      await BackendlessUI.Functions.Custom['fn_fc9582288a86cc06b9574b62748e2a12'](___arguments.context.appData);
    } else {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e'))]);
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0398fb68a41834f858096cb87aa9d2cb')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0d6ffa8cce8268cb89e0e3734c86b72')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e'))]);
    }

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('Bowser') !== -1) {
      View = true;
    } else {
      View = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      View = false;
    }

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/732991f656e8d27bdb1e7dd95dd884f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var Repeater, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Repeater = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));

  } catch (error) {
    console.log(error);

  }

  return Repeater

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Office/components/ba58c7483308e8d80bf4856482a2db18/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var Repeater, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Repeater = (getObjectProperty(___arguments.context.dataModel, 'Tanks'));

  } catch (error) {
    console.log(error);

  }

  return Repeater

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Office/components/d48eaf38c628e947bdd8cf18012826e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var Repeater, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Repeater = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('094e17f8898856d8d834001dcb08bbfb'), 'Bowsers'));

  } catch (error) {
    console.log(error);

  }

  return Repeater

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Office/components/ea09807bde56b1d84b0a9456edc38c98/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await (async function(TankBlock, Tank) {
  	return (function () {
  	  var gaugeHost = TankBlock;
  	  var tank = Tank;
  	
  	  if (!gaugeHost || !tank) {
  	    console.log("Missing TankBlock or Tank");
  	    return null;
  	  }
  	
  	  var hostEl = null;
  	
  	  if (gaugeHost.el) {
  	    hostEl = gaugeHost.el;
  	  } else if (gaugeHost instanceof HTMLElement) {
  	    hostEl = gaugeHost;
  	  }
  	
  	  if (!hostEl) {
  	    console.log("TankBlock does not contain a usable DOM element");
  	    console.log(gaugeHost);
  	    return null;
  	  }
  	
  	  var level = Number(tank.Level);
  	  if (isNaN(level)) level = 0;
  	  if (level < 0) level = 0;
  	  if (level > 100) level = 100;
  	
  	  var grade = tank.Grade || "Tank";
  	  var liquidColor = tank.Color || "#22c55e";
  	
  	  var uid = "tank_" + (tank.objectId || Math.random().toString(36).slice(2));
  	
  	  // Tighter, fuller layout
  	  var vb = 100;
  	  var cx = 50;
  	  var cy = 50;
  	  var outerR = 45;
  	  var innerR = 37;
  	
  	  var liquidTopY = cy + innerR - ((level / 100) * (innerR * 2));
  	  var liquidHeight = (cy + innerR) - liquidTopY;
  	
  	  var levelText = Math.round(level) + "%";
  	
  	  hostEl.innerHTML = ''
  	    + '<svg'
  	    + ' width="100%"'
  	    + ' height="100%"'
  	    + ' viewBox="0 0 100 100"'
  	    + ' preserveAspectRatio="xMidYMid meet"'
  	    + ' xmlns="http://www.w3.org/2000/svg"'
  	    + ' style="display:block;overflow:visible;"'
  	    + '>'
  	    + '  <defs>'
  	    + '    <radialGradient id="' + uid + '_shell" cx="35%" cy="30%" r="75%">'
  	    + '      <stop offset="0%" stop-color="#f8fafc"></stop>'
  	    + '      <stop offset="45%" stop-color="#d1d5db"></stop>'
  	    + '      <stop offset="75%" stop-color="#9ca3af"></stop>'
  	    + '      <stop offset="100%" stop-color="#6b7280"></stop>'
  	    + '    </radialGradient>'
  	    + '    <radialGradient id="' + uid + '_inner" cx="35%" cy="30%" r="80%">'
  	    + '      <stop offset="0%" stop-color="#f3f4f6"></stop>'
  	    + '      <stop offset="100%" stop-color="#d1d5db"></stop>'
  	    + '    </radialGradient>'
  	    + '    <linearGradient id="' + uid + '_glass" x1="0" y1="0" x2="1" y2="1">'
  	    + '      <stop offset="0%" stop-color="#ffffff" stop-opacity="0.24"></stop>'
  	    + '      <stop offset="100%" stop-color="#ffffff" stop-opacity="0.05"></stop>'
  	    + '    </linearGradient>'
  	    + '    <clipPath id="' + uid + '_liquidClip">'
  	    + '      <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '"></circle>'
  	    + '    </clipPath>'
  	    + '  </defs>'
  	
  	    + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + outerR + '" fill="url(#' + uid + '_shell)"></circle>'
  	    + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_inner)"></circle>'
  	
  	    + '  <g clip-path="url(#' + uid + '_liquidClip)">'
  	    + '    <rect x="' + (cx - innerR) + '" y="' + liquidTopY + '" width="' + (innerR * 2) + '" height="' + liquidHeight + '" fill="' + liquidColor + '"></rect>'
  	    + '    <rect x="' + (cx - innerR + 5) + '" y="' + liquidTopY + '" width="' + ((innerR * 2) - 10) + '" height="2.4" rx="1.2" fill="#ffffff" opacity="0.18"></rect>'
  	    + '  </g>'
  	
  	    + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_glass)"></circle>'
  	    + '  <ellipse cx="' + (cx - 10) + '" cy="' + (cy - 9) + '" rx="10" ry="20" fill="#ffffff" opacity="0.12"></ellipse>'
  	
  	    + '  <text x="' + cx + '" y="' + (cy + 1) + '" text-anchor="middle" font-size="15" font-weight="700" fill="#0f172a">' + levelText + '</text>'
  	    + '  <text x="' + cx + '" y="' + (cy + 13) + '" text-anchor="middle" font-size="6.5" font-weight="600" fill="#334155">' + grade + '</text>'
  	    + '</svg>';
  	
  	  return null;
  	})();
  })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea09807bde56b1d84b0a9456edc38c98')), ___arguments.context.getComponentDataStoreByUid('094e17f8898856d8d834001dcb08bbfb'));

  },
  /* handler:onMounted */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(AppData, Company, Tank, Contractors, TankBlock, SVGLogo) {
  	return (function () {
  	  try {
  	    var appData = (typeof AppData !== "undefined" ? AppData : null);
  	    var company = (typeof Company !== "undefined" ? Company : null);
  	    var tank = (typeof Tank !== "undefined" ? Tank : null);
  	    var tankBlock = (typeof TankBlock !== "undefined" ? TankBlock : null);
  	    var backendless = (typeof Backendless !== "undefined" ? Backendless : null);
  	    var currentUser = (typeof CurrentUser !== "undefined" ? CurrentUser : null);
  	    var svgLogo = (typeof SVGLogo !== "undefined" ? SVGLogo : null);
  	
  	    function toArray(value) {
  	      if (Array.isArray(value)) return value;
  	      if (value === null || value === undefined) return [];
  	      return [value];
  	    }
  	
  	    function toNumber(value, fallback) {
  	      var n = Number(String(value).replace(",", "."));
  	      return isNaN(n) ? fallback : n;
  	    }
  	
  	    function text(value, fallback) {
  	      if (value === null || value === undefined || value === "") return fallback;
  	      return String(value);
  	    }
  	
  	    function escapeHtml(value) {
  	      return String(value)
  	        .replace(/&/g, "&amp;")
  	        .replace(/</g, "&lt;")
  	        .replace(/>/g, "&gt;")
  	        .replace(/"/g, "&quot;")
  	        .replace(/'/g, "&#39;");
  	    }
  	
  	    function getDeep(obj, path, fallback) {
  	      try {
  	        var current = obj;
  	        for (var i = 0; i < path.length; i++) {
  	          if (current == null) return fallback;
  	          current = current[path[i]];
  	        }
  	        return current == null ? fallback : current;
  	      } catch (e) {
  	        return fallback;
  	      }
  	    }
  	
  	    function deepClone(value) {
  	      try {
  	        return JSON.parse(JSON.stringify(value));
  	      } catch (e) {
  	        return value;
  	      }
  	    }
  	
  	    function sanitizeNumeric(value) {
  	      return String(value || "").replace(/[^0-9.,]/g, "");
  	    }
  	
  	    function displayNumber(value, decimals) {
  	      var n = toNumber(value, 0);
  	      return n.toFixed(decimals);
  	    }
  	
  	    function pad2(v) {
  	      v = String(v);
  	      return v.length < 2 ? ("0" + v) : v;
  	    }
  	
  	    function getNowIso() {
  	      return new Date().toISOString();
  	    }
  	
  	    function formatDatePretty(isoValue) {
  	      if (!isoValue) return "";
  	      var d = new Date(isoValue);
  	      if (isNaN(d.getTime())) return String(isoValue);
  	      return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate()) + " " + pad2(d.getHours()) + ":" + pad2(d.getMinutes()) + ":" + pad2(d.getSeconds());
  	    }
  	
  	        function formatDateInput(value) {
  	      var d = value ? new Date(value) : new Date();
  	      if (isNaN(d.getTime())) d = new Date();
  	      return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate());
  	    }
  	
  	    function sameKey(a, b) {
  	      var left = String(a === null || a === undefined ? "" : a).trim();
  	      var right = String(b === null || b === undefined ? "" : b).trim();
  	
  	      if (!left || !right) return false;
  	
  	      return left === right;
  	    }
  	
  	    function findIndexByKeys(items, candidate) {
  	      var arr = toArray(items);
  	
  	      for (var i = 0; i < arr.length; i++) {
  	        var row = arr[i];
  	
  	        if (
  	          sameKey(getDeep(row, ["objectId"], null), getDeep(candidate, ["objectId"], null)) ||
  	          sameKey(getDeep(row, ["FID"], null), getDeep(candidate, ["FID"], null)) ||
  	          sameKey(getDeep(row, ["DeviceId"], null), getDeep(candidate, ["DeviceId"], null)) ||
  	          sameKey(getDeep(row, ["Name"], null), getDeep(candidate, ["Name"], null))
  	        ) {
  	          return i;
  	        }
  	      }
  	
  	      return -1;
  	    }
  	
  	    function saveTableRow(tableName, row) {
  	      if (!backendless || !backendless.Data || !backendless.Data.of) {
  	        return Promise.reject(new Error("Backendless SDK is not available"));
  	      }
  	      return backendless.Data.of(tableName).save(row);
  	    }
  	
  	    function addRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	      if (!backendless || !backendless.Data || !backendless.Data.of) {
  	        return Promise.reject(new Error("Backendless SDK is not available"));
  	      }
  	
  	      return backendless.Data.of(tableName).addRelation(
  	        { objectId: parentObjectId },
  	        relationName,
  	        childObjectIds
  	      );
  	    }
  	
  	    function setButtonBusy(button, isBusy, label) {
  	      if (!button) return;
  	      button.disabled = !!isBusy;
  	      button.style.opacity = isBusy ? "0.7" : "1";
  	      button.style.cursor = isBusy ? "wait" : "pointer";
  	      if (label) button.textContent = label;
  	    }
  	
  	    function renderTankGauge(gaugeHost, targetTank) {
  	      try {
  	        if (!gaugeHost || !targetTank) return;
  	
  	        var hostEl = null;
  	
  	        if (gaugeHost.el) {
  	          hostEl = gaugeHost.el;
  	        } else if (typeof HTMLElement !== "undefined" && gaugeHost instanceof HTMLElement) {
  	          hostEl = gaugeHost;
  	        }
  	
  	        if (!hostEl) {
  	          console.log("TankBlock does not contain a usable DOM element");
  	          console.log(gaugeHost);
  	          return;
  	        }
  	
  	        var level = Number(targetTank.Level);
  	        if (isNaN(level)) level = 0;
  	        if (level < 0) level = 0;
  	        if (level > 100) level = 100;
  	
  	        var grade = targetTank.Grade || "Tank";
  	        var liquidColor = targetTank.Color || "#22c55e";
  	
  	        var uid = "tank_" + (targetTank.objectId || Math.random().toString(36).slice(2));
  	
  	        var cx = 50;
  	        var cy = 50;
  	        var outerR = 45;
  	        var innerR = 37;
  	
  	        var liquidTopY = cy + innerR - ((level / 100) * (innerR * 2));
  	        var liquidHeight = (cy + innerR) - liquidTopY;
  	
  	        var levelText = Math.round(level) + "%";
  	
  	        hostEl.innerHTML = ""
  	          + '<svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" style="display:block;overflow:visible;">'
  	          + "  <defs>"
  	          + '    <radialGradient id="' + uid + '_shell" cx="35%" cy="30%" r="75%">'
  	          + '      <stop offset="0%" stop-color="#f8fafc"></stop>'
  	          + '      <stop offset="45%" stop-color="#d1d5db"></stop>'
  	          + '      <stop offset="75%" stop-color="#9ca3af"></stop>'
  	          + '      <stop offset="100%" stop-color="#6b7280"></stop>'
  	          + "    </radialGradient>"
  	          + '    <radialGradient id="' + uid + '_inner" cx="35%" cy="30%" r="80%">'
  	          + '      <stop offset="0%" stop-color="#f3f4f6"></stop>'
  	          + '      <stop offset="100%" stop-color="#d1d5db"></stop>'
  	          + "    </radialGradient>"
  	          + '    <linearGradient id="' + uid + '_glass" x1="0" y1="0" x2="1" y2="1">'
  	          + '      <stop offset="0%" stop-color="#ffffff" stop-opacity="0.24"></stop>'
  	          + '      <stop offset="100%" stop-color="#ffffff" stop-opacity="0.05"></stop>'
  	          + "    </linearGradient>"
  	          + '    <clipPath id="' + uid + '_liquidClip">'
  	          + '      <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '"></circle>'
  	          + "    </clipPath>"
  	          + "  </defs>"
  	          + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + outerR + '" fill="url(#' + uid + '_shell)"></circle>'
  	          + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_inner)"></circle>'
  	          + '  <g clip-path="url(#' + uid + '_liquidClip)">'
  	          + '    <rect x="' + (cx - innerR) + '" y="' + liquidTopY + '" width="' + (innerR * 2) + '" height="' + liquidHeight + '" fill="' + liquidColor + '"></rect>'
  	          + '    <rect x="' + (cx - innerR + 5) + '" y="' + liquidTopY + '" width="' + ((innerR * 2) - 10) + '" height="2.4" rx="1.2" fill="#ffffff" opacity="0.18"></rect>'
  	          + "  </g>"
  	          + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_glass)"></circle>'
  	          + '  <ellipse cx="' + (cx - 10) + '" cy="' + (cy - 9) + '" rx="10" ry="20" fill="#ffffff" opacity="0.12"></ellipse>'
  	          + '  <text x="' + cx + '" y="' + (cy + 1) + '" text-anchor="middle" font-size="15" font-weight="700" fill="#0f172a">' + levelText + "</text>"
  	          + '  <text x="' + cx + '" y="' + (cy + 13) + '" text-anchor="middle" font-size="6.5" font-weight="600" fill="#334155">' + escapeHtml(grade) + "</text>"
  	          + "</svg>";
  	      } catch (gaugeErr) {
  	        console.log("Tank gauge render error:", gaugeErr);
  	      }
  	    }
  	
  	        function appendFuelInOnce(targetObj, savedFuelIn) {
  	      if (!targetObj || !savedFuelIn || !getDeep(savedFuelIn, ["objectId"], null)) return;
  	
  	      targetObj.FuelIn = toArray(targetObj.FuelIn);
  	
  	      var savedFuelInId = String(getDeep(savedFuelIn, ["objectId"], ""));
  	      var alreadyExists = false;
  	
  	      for (var i = 0; i < targetObj.FuelIn.length; i++) {
  	        if (String(getDeep(targetObj.FuelIn[i], ["objectId"], "")) === savedFuelInId) {
  	          alreadyExists = true;
  	          break;
  	        }
  	      }
  	
  	      if (!alreadyExists) {
  	        targetObj.FuelIn.unshift(savedFuelIn);
  	      }
  	    }
  	
  	    function updateTankForLiveUi(existingTankObj, updatedTankObj, savedFuelIn) {
  	      if (!existingTankObj || !updatedTankObj) return existingTankObj;
  	
  	      if (getDeep(updatedTankObj, ["Volume"], null) !== null) {
  	        existingTankObj.Volume = updatedTankObj.Volume;
  	      }
  	
  	      if (getDeep(updatedTankObj, ["Level"], null) !== null) {
  	        existingTankObj.Level = updatedTankObj.Level;
  	      }
  	
  	      appendFuelInOnce(existingTankObj, savedFuelIn);
  	
  	      // Do not touch existingTankObj.Bowsers.
  	      // The repeater needs the original nested bowser/pump list preserved.
  	
  	      return existingTankObj;
  	    }
  	
  	    function replaceNestedCompanyTank(companyObj, tankObj, savedFuelIn) {
  	      var tanks = toArray(getDeep(companyObj, ["Tanks"], []));
  	      var tIndex = findIndexByKeys(tanks, tankObj);
  	
  	      if (tIndex >= 0) {
  	        updateTankForLiveUi(tanks[tIndex], tankObj, savedFuelIn);
  	        companyObj.Tanks = tanks;
  	      }
  	    }
  	
  	    function getAppDataRoot() {
  	      if (appData && typeof appData === "object") return appData;
  	      if (typeof AppData !== "undefined" && AppData && typeof AppData === "object") return AppData;
  	      return null;
  	    }
  	
  	    function getUserCompaniesFromAppData() {
  	      return toArray(getDeep(getAppDataRoot(), ["User", "Companies"], []));
  	    }
  	
  	    function syncTankIntoLiveAppData(updatedTankObj, savedFuelIn) {
  	      if (!updatedTankObj || !getDeep(updatedTankObj, ["objectId"], null)) return false;
  	
  	      var companies = getUserCompaniesFromAppData();
  	      var tankObjectId = String(getDeep(updatedTankObj, ["objectId"], ""));
  	
  	      for (var c = 0; c < companies.length; c++) {
  	        var companyTanks = toArray(getDeep(companies[c], ["Tanks"], []));
  	
  	        for (var i = 0; i < companyTanks.length; i++) {
  	          if (String(getDeep(companyTanks[i], ["objectId"], "")) === tankObjectId) {
  	            updateTankForLiveUi(companyTanks[i], updatedTankObj, savedFuelIn);
  	            companies[c].Tanks = companyTanks;
  	            return true;
  	          }
  	        }
  	      }
  	
  	      return false;
  	    }
  	
  	    function buildDeliverySearchIndex(item) {
  	      var parts = [
  	        getDeep(item, ["FuelDate"], ""),
  	        getDeep(item, ["Supplier"], ""),
  	        getDeep(item, ["ReferenceNo"], ""),
  	        getDeep(item, ["Description"], ""),
  	        getDeep(item, ["Litres"], ""),
  	        getDeep(item, ["Cost"], ""),
  	        getDeep(item, ["CostPerLitre"], ""),
  	        getDeep(item, ["VolumeBefore"], ""),
  	        getDeep(item, ["VolumeAfter"], ""),
  	        getDeep(item, ["objectId"], "")
  	      ];
  	      return parts.join(" ").toLowerCase();
  	    }
  	
  	    function buildDetailRow(label, value) {
  	      return ""
  	        + '<div style="display:grid;grid-template-columns:150px 1fr;gap:10px;padding:7px 0;border-bottom:1px solid rgba(255,255,255,0.06);">'
  	        + '<div style="font-size:11px;color:#94a3b8;">' + escapeHtml(label) + "</div>"
  	        + '<div style="font-size:12px;color:#f8fafc;word-break:break-word;">' + escapeHtml(text(value, "")) + "</div>"
  	        + "</div>";
  	    }
  	
  	    function getVisibleTotals(deliveries) {
  	      var arr = toArray(deliveries);
  	      var litres = 0;
  	      var cost = 0;
  	
  	      for (var i = 0; i < arr.length; i++) {
  	        litres += toNumber(getDeep(arr[i], ["Litres"], 0), 0);
  	        cost += toNumber(getDeep(arr[i], ["Cost"], 0), 0);
  	      }
  	
  	      return {
  	        count: arr.length,
  	        litres: litres,
  	        cost: cost,
  	        avgCostPerLitre: litres > 0 ? (cost / litres) : 0
  	      };
  	    }
  	
  	    function openPrintWindow() {
  	      try {
  	        var visibleRows = toArray(state.filteredDeliveries);
  	        var searchTerm = String(state.searchTerm || "").trim();
  	        var totals = getVisibleTotals(visibleRows);
  	
  	        if (!visibleRows.length) {
  	          alert("There are no visible deliveries to print.");
  	          return;
  	        }
  	
  	        var printWin = window.open("", "_blank", "width=1280,height=900");
  	        if (!printWin) {
  	          alert("Print window was blocked by the browser.");
  	          return;
  	        }
  	
  	        var logoHtml = "";
  	        if (svgLogo) {
  	          logoHtml = '<img src="' + escapeHtml(svgLogo) + '" alt="Logo" style="max-height:68px;max-width:240px;object-fit:contain;display:block;">';
  	        }
  	
  	        var rowsHtml = "";
  	        for (var i = 0; i < visibleRows.length; i++) {
  	          var item = visibleRows[i];
  	          rowsHtml += ""
  	            + "<tr>"
  	            + "<td>" + escapeHtml(formatDatePretty(getDeep(item, ["FuelDate"], ""))) + "</td>"
  	            + "<td>" + escapeHtml(text(getDeep(item, ["Supplier"], ""), "")) + "</td>"
  	            + "<td>" + escapeHtml(text(getDeep(item, ["ReferenceNo"], ""), "")) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["Litres"], 0), 2)) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["Cost"], 0), 2)) + "</td>"
  	            + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["CostPerLitre"], 0), 4)) + "</td>"
  	            + "<td>" + escapeHtml(text(getDeep(item, ["Description"], ""), "")) + "</td>"
  	            + "</tr>";
  	        }
  	
  	        var reportTitle = "Fuel Delivery Report";
  	        var reportSubTitle = tankGrade ? ("Tank: " + tankGrade) : "Tank Deliveries";
  	        var filterLabel = searchTerm ? ('Filtered by: "' + searchTerm + '"') : "Filter: None";
  	        var generatedAt = formatDatePretty(new Date().toISOString());
  	        var companyLabel = text(getDeep(company, ["CompanyId"], ""), "");
  	        var tankLabel = text(getDeep(tank, ["Grade"], ""), "");
  	        var deviceLabel = text(getDeep(tank, ["DeviceId"], ""), "");
  	
  	        var html = ""
  	          + "<!doctype html>"
  	          + "<html>"
  	          + "<head>"
  	          + '<meta charset="utf-8">'
  	          + "<title>" + escapeHtml(reportTitle) + "</title>"
  	          + "<style>"
  	          + "html,body{margin:0;padding:0;background:#ffffff;color:#111827;font-family:Arial,sans-serif;}"
  	          + "body{padding:28px 30px 36px 30px;}"
  	          + ".header{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;border-bottom:2px solid #111827;padding-bottom:14px;margin-bottom:18px;}"
  	          + ".title{font-size:24px;font-weight:700;line-height:1.1;margin:0;}"
  	          + ".subtitle{font-size:12px;color:#4b5563;margin-top:6px;}"
  	          + ".meta{font-size:12px;color:#374151;line-height:1.6;margin-top:10px;}"
  	          + ".summary-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin:18px 0 18px 0;}"
  	          + ".summary-card{border:1px solid #d1d5db;border-radius:8px;padding:12px;background:#f9fafb;}"
  	          + ".summary-label{font-size:11px;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;}"
  	          + ".summary-value{font-size:22px;font-weight:700;color:#111827;margin-top:6px;}"
  	          + ".section-title{font-size:14px;font-weight:700;color:#111827;margin:18px 0 10px 0;}"
  	          + "table{width:100%;border-collapse:collapse;table-layout:fixed;}"
  	          + "thead th{background:#111827;color:#ffffff;font-size:11px;text-transform:uppercase;letter-spacing:.04em;padding:10px 8px;border:1px solid #0f172a;text-align:left;}"
  	          + "tbody td{font-size:11px;color:#111827;padding:8px;border:1px solid #d1d5db;vertical-align:top;word-wrap:break-word;}"
  	          + ".num{text-align:right;font-variant-numeric:tabular-nums;}"
  	          + ".footer{margin-top:18px;font-size:10px;color:#6b7280;border-top:1px solid #d1d5db;padding-top:10px;}"
  	          + "@media print{body{padding:18px 20px 22px 20px;}tr,td,th{page-break-inside:avoid;}}"
  	          + "</style>"
  	          + "</head>"
  	          + "<body>"
  	          + '<div class="header">'
  	          + '  <div style="flex:1;min-width:0;">'
  	          + '    <h1 class="title">' + escapeHtml(reportTitle) + "</h1>"
  	          + '    <div class="subtitle">' + escapeHtml(reportSubTitle) + "</div>"
  	          + '    <div class="meta">'
  	          + "      <div><strong>Company:</strong> " + escapeHtml(companyLabel || "-") + "</div>"
  	          + "      <div><strong>Tank Grade:</strong> " + escapeHtml(tankLabel || "-") + "</div>"
  	          + "      <div><strong>Tank Device:</strong> " + escapeHtml(deviceLabel || "-") + "</div>"
  	          + "      <div><strong>Generated:</strong> " + escapeHtml(generatedAt) + "</div>"
  	          + "      <div><strong>" + escapeHtml(filterLabel) + "</strong></div>"
  	          + "    </div>"
  	          + "  </div>"
  	          + '  <div style="width:260px;display:flex;justify-content:flex-end;align-items:flex-start;">'
  	          + logoHtml
  	          + "  </div>"
  	          + "</div>"
  	          + '<div class="summary-grid">'
  	          + '  <div class="summary-card"><div class="summary-label">Deliveries</div><div class="summary-value">' + escapeHtml(String(totals.count)) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Litres</div><div class="summary-value">' + escapeHtml(displayNumber(totals.litres, 2)) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Cost</div><div class="summary-value">' + escapeHtml(displayNumber(totals.cost, 2)) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Avg Cost / L</div><div class="summary-value">' + escapeHtml(displayNumber(totals.avgCostPerLitre, 4)) + "</div></div>"
  	          + "</div>"
  	          + '<div class="section-title">Deliveries</div>'
  	          + "<table>"
  	          + "<thead><tr><th style='width:140px;'>Date</th><th style='width:140px;'>Supplier</th><th style='width:120px;'>Reference</th><th style='width:85px;text-align:right;'>Litres</th><th style='width:95px;text-align:right;'>Cost</th><th style='width:95px;text-align:right;'>Cost/L</th><th>Description</th></tr></thead>"
  	          + "<tbody>" + rowsHtml + "</tbody>"
  	          + "</table>"
  	          + '<div class="footer">This report reflects only the deliveries currently visible on screen. If a search filter is active, rows and totals are limited to that filtered result set.</div>'
  	          + '<script>window.onload=function(){setTimeout(function(){window.print();},250);};</script>'
  	          + "</body>"
  	          + "</html>";
  	
  	        printWin.document.open();
  	        printWin.document.write(html);
  	        printWin.document.close();
  	      } catch (printErr) {
  	        console.log("Print / PDF error:", printErr);
  	        alert("Print failed: " + (printErr && printErr.message ? printErr.message : printErr));
  	      }
  	    }
  	
  	    function openSingleDeliveryPrintWindow(item) {
  	      try {
  	        if (!item) {
  	          alert("No delivery is selected.");
  	          return;
  	        }
  	
  	        var printWin = window.open("", "_blank", "width=1100,height=850");
  	        if (!printWin) {
  	          alert("Print window was blocked by the browser.");
  	          return;
  	        }
  	
  	        var logoHtml = "";
  	        if (svgLogo) {
  	          logoHtml = '<img src="' + escapeHtml(svgLogo) + '" alt="Logo" style="max-height:68px;max-width:240px;object-fit:contain;display:block;">';
  	        }
  	
  	        var supplier = text(getDeep(item, ["Supplier"], ""), "Unknown Supplier");
  	        var fuelDate = formatDatePretty(getDeep(item, ["FuelDate"], ""));
  	        var referenceNo = text(getDeep(item, ["ReferenceNo"], ""), "");
  	        var description = text(getDeep(item, ["Description"], ""), "");
  	        var litres = displayNumber(getDeep(item, ["Litres"], 0), 2);
  	        var cost = displayNumber(getDeep(item, ["Cost"], 0), 2);
  	        var costPerLitre = displayNumber(getDeep(item, ["CostPerLitre"], 0), 4);
  	        var volumeBefore = displayNumber(getDeep(item, ["VolumeBefore"], 0), 2);
  	        var volumeAfter = displayNumber(getDeep(item, ["VolumeAfter"], 0), 2);
  	        var levelBefore = displayNumber(getDeep(item, ["LevelBefore"], 0), 2) + "%";
  	        var levelAfter = displayNumber(getDeep(item, ["LevelAfter"], 0), 2) + "%";
  	        var objectId = text(getDeep(item, ["objectId"], ""), "");
  	        var generatedAt = formatDatePretty(new Date().toISOString());
  	        var companyLabel = text(getDeep(company, ["CompanyId"], ""), "");
  	        var tankLabel = text(getDeep(tank, ["Grade"], ""), "");
  	        var deviceLabel = text(getDeep(tank, ["DeviceId"], ""), "");
  	
  	        var html = ""
  	          + "<!doctype html>"
  	          + "<html>"
  	          + "<head>"
  	          + '<meta charset="utf-8">'
  	          + "<title>Fuel Delivery Transaction</title>"
  	          + "<style>"
  	          + "html,body{margin:0;padding:0;background:#ffffff;color:#111827;font-family:Arial,sans-serif;}"
  	          + "body{padding:28px 30px 36px 30px;}"
  	          + ".header{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;border-bottom:2px solid #111827;padding-bottom:14px;margin-bottom:18px;}"
  	          + ".title{font-size:24px;font-weight:700;line-height:1.1;margin:0;}"
  	          + ".subtitle{font-size:12px;color:#4b5563;margin-top:6px;}"
  	          + ".meta{font-size:12px;color:#374151;line-height:1.6;margin-top:10px;}"
  	          + ".summary-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin:18px 0 18px 0;}"
  	          + ".summary-card{border:1px solid #d1d5db;border-radius:8px;padding:12px;background:#f9fafb;}"
  	          + ".summary-label{font-size:11px;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;}"
  	          + ".summary-value{font-size:22px;font-weight:700;color:#111827;margin-top:6px;}"
  	          + ".detail-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;}"
  	          + ".detail-card{border:1px solid #d1d5db;border-radius:10px;padding:14px;background:#f9fafb;}"
  	          + ".detail-card-title{font-size:13px;font-weight:700;color:#111827;margin-bottom:8px;}"
  	          + ".detail-row{display:grid;grid-template-columns:140px 1fr;gap:10px;padding:7px 0;border-bottom:1px solid #e5e7eb;}"
  	          + ".detail-label{font-size:11px;color:#6b7280;}"
  	          + ".detail-value{font-size:12px;color:#111827;word-break:break-word;}"
  	          + ".footer{margin-top:18px;font-size:10px;color:#6b7280;border-top:1px solid #d1d5db;padding-top:10px;}"
  	          + "@media print{body{padding:18px 20px 22px 20px;}}"
  	          + "</style>"
  	          + "</head>"
  	          + "<body>"
  	          + '<div class="header">'
  	          + '  <div style="flex:1;min-width:0;">'
  	          + '    <h1 class="title">Fuel Delivery Transaction</h1>'
  	          + '    <div class="subtitle">' + escapeHtml(supplier) + (fuelDate ? (" | " + escapeHtml(fuelDate)) : "") + "</div>"
  	          + '    <div class="meta">'
  	          + "      <div><strong>Company:</strong> " + escapeHtml(companyLabel || "-") + "</div>"
  	          + "      <div><strong>Tank Grade:</strong> " + escapeHtml(tankLabel || "-") + "</div>"
  	          + "      <div><strong>Tank Device:</strong> " + escapeHtml(deviceLabel || "-") + "</div>"
  	          + "      <div><strong>Transaction ID:</strong> " + escapeHtml(objectId || "-") + "</div>"
  	          + "      <div><strong>Generated:</strong> " + escapeHtml(generatedAt) + "</div>"
  	          + "    </div>"
  	          + "  </div>"
  	          + '  <div style="width:260px;display:flex;justify-content:flex-end;align-items:flex-start;">'
  	          + logoHtml
  	          + "  </div>"
  	          + "</div>"
  	          + '<div class="summary-grid">'
  	          + '  <div class="summary-card"><div class="summary-label">Litres</div><div class="summary-value">' + escapeHtml(litres) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Cost</div><div class="summary-value">' + escapeHtml(cost) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Cost / L</div><div class="summary-value">' + escapeHtml(costPerLitre) + "</div></div>"
  	          + '  <div class="summary-card"><div class="summary-label">Supplier</div><div class="summary-value" style="font-size:18px;">' + escapeHtml(supplier) + "</div></div>"
  	          + "</div>"
  	          + '<div class="detail-grid">'
  	          + '  <div class="detail-card">'
  	          + '    <div class="detail-card-title">Delivery</div>'
  	          + '    <div class="detail-row"><div class="detail-label">Fuel Date</div><div class="detail-value">' + escapeHtml(fuelDate || "") + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Entry Type</div><div class="detail-value">' + escapeHtml(text(getDeep(item, ["EntryType"], "delivery"), "delivery")) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Supplier</div><div class="detail-value">' + escapeHtml(supplier) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Reference No</div><div class="detail-value">' + escapeHtml(referenceNo) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Description</div><div class="detail-value">' + escapeHtml(description) + "</div></div>"
  	          + "  </div>"
  	          + '  <div class="detail-card">'
  	          + '    <div class="detail-card-title">Figures</div>'
  	          + '    <div class="detail-row"><div class="detail-label">Litres</div><div class="detail-value">' + escapeHtml(litres) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Cost</div><div class="detail-value">' + escapeHtml(cost) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Cost Per Litre</div><div class="detail-value">' + escapeHtml(costPerLitre) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Volume Before</div><div class="detail-value">' + escapeHtml(volumeBefore) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Volume After</div><div class="detail-value">' + escapeHtml(volumeAfter) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Level Before</div><div class="detail-value">' + escapeHtml(levelBefore) + "</div></div>"
  	          + '    <div class="detail-row"><div class="detail-label">Level After</div><div class="detail-value">' + escapeHtml(levelAfter) + "</div></div>"
  	          + "  </div>"
  	          + "</div>"
  	          + '<div class="footer">This report reflects the selected individual fuel delivery transaction only.</div>'
  	          + '<script>window.onload=function(){setTimeout(function(){window.print();},250);};</script>'
  	          + "</body>"
  	          + "</html>";
  	
  	        printWin.document.open();
  	        printWin.document.write(html);
  	        printWin.document.close();
  	      } catch (printErr) {
  	        console.log("Single delivery print / PDF error:", printErr);
  	        alert("Print failed: " + (printErr && printErr.message ? printErr.message : printErr));
  	      }
  	    }
  	
  	    var state = {
  	      deliveryCache: [],
  	      filteredDeliveries: [],
  	      selectedDelivery: null,
  	      searchTerm: ""
  	    };
  	
  	    var companyId = text(getDeep(company, ["CompanyId"], ""), "");
  	    var tankDeviceId = text(getDeep(tank, ["DeviceId"], ""), "");
  	    var tankGrade = text(getDeep(tank, ["Grade"], ""), "");
  	
  	    var subtitleParts = [];
  	    if (tankGrade) subtitleParts.push(tankGrade);
  	    if (tankDeviceId) subtitleParts.push(tankDeviceId);
  	    if (companyId) subtitleParts.push(companyId);
  	    var subtitle = subtitleParts.join(" | ");
  	
  	    var existing = document.getElementById("fuel-delivery-overlay");
  	    if (existing) existing.remove();
  	
  	    var overlay = document.createElement("div");
  	    overlay.id = "fuel-delivery-overlay";
  	    overlay.style.position = "fixed";
  	    overlay.style.inset = "0";
  	    overlay.style.zIndex = "999999";
  	    overlay.style.display = "flex";
  	    overlay.style.alignItems = "center";
  	    overlay.style.justifyContent = "center";
  	    overlay.style.background = "rgba(0,0,0,0.40)";
  	    overlay.style.backdropFilter = "blur(2px)";
  	    overlay.style.padding = "14px";
  	    overlay.style.boxSizing = "border-box";
  	
  	    var modal = document.createElement("div");
  	    modal.id = "fuel-delivery-modal";
  	    modal.style.width = "calc(100vw - 28px)";
  	    modal.style.height = "calc(100vh - 28px)";
  	    modal.style.maxWidth = "none";
  	    modal.style.maxHeight = "none";
  	    modal.style.background = "linear-gradient(180deg, rgba(5,10,18,0.96) 0%, rgba(10,16,24,0.94) 100%)";
  	    modal.style.borderRadius = "18px";
  	    modal.style.overflow = "hidden";
  	    modal.style.boxShadow = "0 18px 50px rgba(0,0,0,0.38)";
  	    modal.style.display = "flex";
  	    modal.style.flexDirection = "column";
  	    modal.style.color = "#f8fafc";
  	    modal.style.fontFamily = "Arial, sans-serif";
  	    modal.style.border = "1px solid rgba(255,255,255,0.06)";
  	
  	    modal.innerHTML = ""
  	      + "<style>"
  	      + ".fuel-soft-input{width:100%;height:42px;border-radius:10px;border:none;background:#d1d5db;color:#0f172a;padding:0 12px;font-size:14px;box-sizing:border-box;}"
  	      + ".fuel-error-text{display:none;margin-top:4px;font-size:11px;color:#ff7b7b;}"
  	      + ".fuel-help-text{display:none;margin-top:4px;font-size:11px;color:#94a3b8;}"
  	      + ".fuel-delivery-item:hover{background:rgba(255,255,255,0.085)!important;transform:translateY(-1px);}"
  	      + ".fuel-delivery-item{transition:all 140ms ease;}"
  	      + ".fuel-detail-backdrop{position:absolute;inset:0;background:rgba(0,0,0,0.45);display:none;align-items:center;justify-content:center;padding:18px;box-sizing:border-box;z-index:20;}"
  	      + ".fuel-detail-card{width:min(860px,100%);max-height:100%;overflow:auto;background:linear-gradient(180deg, rgba(12,18,28,0.98) 0%, rgba(9,14,22,0.98) 100%);border:1px solid rgba(255,255,255,0.08);border-radius:16px;box-shadow:0 18px 50px rgba(0,0,0,0.45);}"
  	      + "</style>"
  	
  	      + '<div style="padding:16px 16px 10px 16px;border-bottom:1px solid rgba(255,255,255,0.06);display:flex;justify-content:space-between;align-items:flex-start;gap:10px;">'
  	      + '<div style="min-width:0;">'
  	      + '<div style="font-size:16px;font-weight:700;line-height:1.1;">Fuel Delivery</div>'
  	      + '<div style="margin-top:4px;font-size:11px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(subtitle) + "</div>"
  	      + "</div>"
  	      + '<button id="fuel-delivery-close" type="button" style="background:none;border:none;color:#ff3b30;font-size:28px;line-height:1;cursor:pointer;padding:0 2px;">X</button>'
  	      + "</div>"
  	
  	      + '<div style="display:flex;gap:8px;padding:10px 14px 0 14px;">'
  	      + '<button id="fuel-delivery-tab-capture" type="button" style="flex:1;height:38px;border:none;border-radius:10px;background:#f97316;color:#fff;font-size:13px;font-weight:700;cursor:pointer;">Capture</button>'
  	      + '<button id="fuel-delivery-tab-list" type="button" style="flex:1;height:38px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.04);color:#dbe4ee;font-size:13px;font-weight:700;cursor:pointer;">Deliveries</button>'
  	      + "</div>"
  	
  	      + '<div style="position:relative;flex:1;min-height:0;">'
  	
  	      + '<div id="fuel-delivery-capture-panel" style="display:block;position:absolute;inset:0;padding:18px;overflow:auto;">'
  	      + '<div style="max-width:1040px;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;">'
  	
  	      + '<div id="row-delivery-date">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Delivery Date</label>'
  	      + '<input id="fuel-delivery-date" type="date" class="fuel-soft-input">'
  	      + '<div id="fuel-delivery-date-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-supplier">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Supplier</label>'
  	      + '<input id="fuel-delivery-supplier" type="text" placeholder="Supplier" class="fuel-soft-input">'
  	      + '<div id="fuel-delivery-supplier-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-litres">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Litres</label>'
  	      + '<input id="fuel-delivery-litres" type="text" inputmode="decimal" placeholder="Litres" class="fuel-soft-input">'
  	      + '<div id="fuel-delivery-litres-help" class="fuel-help-text"></div>'
  	      + '<div id="fuel-delivery-litres-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-cost">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Total Cost</label>'
  	      + '<input id="fuel-delivery-cost" type="text" inputmode="decimal" placeholder="Total cost" class="fuel-soft-input">'
  	      + '<div id="fuel-delivery-cost-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-cost-per-litre">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Cost Per Litre</label>'
  	      + '<input id="fuel-delivery-cost-per-litre" type="text" readonly="readonly" class="fuel-soft-input" style="background:#94a3b8;color:#0f172a;font-weight:700;">'
  	      + "</div>"
  	
  	      + '<div id="row-reference">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Reference No</label>'
  	      + '<input id="fuel-delivery-reference" type="text" placeholder="Reference No" class="fuel-soft-input">'
  	      + '<div id="fuel-delivery-reference-error" class="fuel-error-text"></div>'
  	      + "</div>"
  	
  	      + '<div id="row-description" style="grid-column:1 / span 2;">'
  	      + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Description / Notes</label>'
  	      + '<input id="fuel-delivery-description" type="text" placeholder="Description / Notes" class="fuel-soft-input">'
  	      + "</div>"
  	
  	      + '<div style="grid-column:1 / span 2;background:rgba(255,255,255,0.05);border-radius:14px;padding:14px;">'
  	      + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:10px;">Live Tank Delivery Summary</div>'
  	      + '<div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;">'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Capacity</div><div id="fuel-delivery-capacity" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Volume Before</div><div id="fuel-delivery-volume-before" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Volume After</div><div id="fuel-delivery-volume-after" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Level Before</div><div id="fuel-delivery-level-before" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00%</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Level After</div><div id="fuel-delivery-level-after" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00%</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;"><div style="font-size:10px;color:#94a3b8;">Remaining Capacity</div><div id="fuel-delivery-remaining-capacity" style="margin-top:3px;font-size:16px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + "</div>"
  	      + '<div id="fuel-delivery-overflow-error" style="display:none;margin-top:10px;font-size:12px;color:#ff7b7b;font-weight:700;"></div>'
  	      + "</div>"
  	
  	      + "</div>"
  	
  	      + '<div style="display:flex;gap:10px;margin-top:18px;max-width:1040px;">'
  	      + '<button id="fuel-delivery-save-btn" type="button" style="display:none;flex:1;height:46px;border:none;border-radius:10px;background:#f97316;color:white;font-size:15px;font-weight:700;cursor:pointer;">Save Delivery</button>'
  	      + '<button id="fuel-delivery-cancel-btn" type="button" style="width:160px;height:46px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.05);color:#e2e8f0;font-size:15px;font-weight:700;cursor:pointer;">Cancel</button>'
  	      + "</div>"
  	      + "</div>"
  	
  	      + '<div id="fuel-delivery-list-panel" style="display:none;position:absolute;inset:0;padding:14px;overflow:hidden;">'
  	      + '<div style="display:grid;grid-template-columns:280px 1fr;gap:14px;height:100%;min-height:0;">'
  	
  	      + '<div style="display:flex;flex-direction:column;gap:10px;min-height:0;">'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:12px;padding:12px;">'
  	      + '<div style="font-size:11px;color:#94a3b8;margin-bottom:6px;">Tank Delivery Ledger</div>'
  	      + '<div style="font-size:14px;font-weight:700;color:#f8fafc;">' + escapeHtml(tankGrade || "Tank") + "</div>"
  	      + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Loaded from the Tank.FuelIn relation already present on this tank.</div>'
  	      + "</div>"
  	
  	      + '<div style="display:grid;grid-template-columns:1fr;gap:8px;">'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;"><div style="font-size:10px;color:#94a3b8;">Deliveries</div><div id="fuel-delivery-summary-count" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">0</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;"><div style="font-size:10px;color:#94a3b8;">Litres</div><div id="fuel-delivery-summary-litres" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;"><div style="font-size:10px;color:#94a3b8;">Cost</div><div id="fuel-delivery-summary-cost" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">0.00</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;"><div style="font-size:10px;color:#94a3b8;">Avg Cost / L</div><div id="fuel-delivery-summary-cpl" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">0.0000</div></div>'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;"><div style="font-size:10px;color:#94a3b8;">Tank</div><div id="fuel-delivery-summary-tank" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">' + escapeHtml(tankGrade || "Tank") + "</div></div>"
  	      + "</div>"
  	      + "</div>"
  	
  	      + '<div style="display:flex;flex-direction:column;min-height:0;position:relative;">'
  	      + '<div style="display:flex;gap:10px;align-items:center;margin-bottom:10px;">'
  	      + '<input id="fuel-delivery-search" type="text" placeholder="Search deliveries..." class="fuel-soft-input" style="flex:1;height:40px;background:rgba(255,255,255,0.9);">'
  	      + '<button id="fuel-delivery-search-clear" type="button" style="height:40px;padding:0 14px;border:none;border-radius:10px;background:rgba(255,255,255,0.08);color:#e2e8f0;font-size:12px;font-weight:700;cursor:pointer;">Clear</button>'
  	      + '<button id="fuel-delivery-refresh-btn" type="button" style="height:40px;padding:0 16px;border:none;border-radius:10px;background:rgba(255,255,255,0.08);color:#ffffff;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;">Refresh</button>'
  	      + '<button id="fuel-delivery-print-btn" type="button" style="height:40px;padding:0 16px;border:none;border-radius:10px;background:#f97316;color:#ffffff;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;">Print / PDF</button>'
  	      + "</div>"
  	
  	      + '<div id="fuel-delivery-list" style="display:flex;flex-direction:column;gap:6px;min-height:0;overflow:auto;padding-right:2px;">'
  	      + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	      + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">Loading deliveries...</div>'
  	      + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Deliveries are loaded from the selected tank object.</div>'
  	      + "</div>"
  	      + "</div>"
  	
  	      + '<div id="fuel-delivery-detail-backdrop" class="fuel-detail-backdrop">'
  	      + '  <div class="fuel-detail-card">'
  	      + '    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;padding:16px 16px 12px 16px;border-bottom:1px solid rgba(255,255,255,0.08);">'
  	      + '      <div>'
  	      + '        <div id="fuel-delivery-detail-title" style="font-size:16px;font-weight:700;color:#f8fafc;">Delivery Detail</div>'
  	      + '        <div id="fuel-delivery-detail-subtitle" style="margin-top:4px;font-size:11px;color:#94a3b8;"></div>'
  	      + "      </div>"
  	      + '      <div style="display:flex;align-items:center;gap:10px;">'
  	      + '        <button id="fuel-delivery-detail-print" type="button" style="height:36px;padding:0 14px;border:none;border-radius:10px;background:#f97316;color:#ffffff;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;">Print / PDF</button>'
  	      + '        <button id="fuel-delivery-detail-close" type="button" style="background:none;border:none;color:#ff3b30;font-size:26px;line-height:1;cursor:pointer;padding:0 2px;">X</button>'
  	      + "      </div>"
  	      + "    </div>"
  	      + '    <div id="fuel-delivery-detail-body" style="padding:14px 16px 18px 16px;"></div>'
  	      + "  </div>"
  	      + "</div>"
  	
  	      + "</div>"
  	      + "</div>"
  	      + "</div>"
  	
  	      + "</div>";
  	
  	    overlay.appendChild(modal);
  	    document.body.appendChild(overlay);
  	
  	    function el(id) {
  	      return document.getElementById(id);
  	    }
  	
  	    function valueOf(id) {
  	      var node = el(id);
  	      return node ? node.value : "";
  	    }
  	
  	    function setValue(id, value) {
  	      var node = el(id);
  	      if (node) node.value = value;
  	    }
  	
  	    function setText(id, value) {
  	      var node = el(id);
  	      if (node) node.textContent = value;
  	    }
  	
  	    function showError(id, message) {
  	      var node = el(id);
  	      if (!node) return;
  	      node.style.display = message ? "block" : "none";
  	      node.textContent = message || "";
  	    }
  	
  	    function showHelp(id, message) {
  	      var node = el(id);
  	      if (!node) return;
  	      node.style.display = message ? "block" : "none";
  	      node.textContent = message || "";
  	    }
  	
  	    function clearValidationMessages() {
  	      showError("fuel-delivery-date-error", "");
  	      showError("fuel-delivery-supplier-error", "");
  	      showError("fuel-delivery-litres-error", "");
  	      showError("fuel-delivery-cost-error", "");
  	      showError("fuel-delivery-reference-error", "");
  	      showHelp("fuel-delivery-litres-help", "");
  	      showError("fuel-delivery-overflow-error", "");
  	    }
  	
  	    function closeModal() {
  	      var node = el("fuel-delivery-overlay");
  	      if (node) node.remove();
  	    }
  	
  	    function closeDeliveryDetail() {
  	      var backdrop = el("fuel-delivery-detail-backdrop");
  	      if (backdrop) backdrop.style.display = "none";
  	      state.selectedDelivery = null;
  	    }
  	
  	    function getLiveDeliveryComputed() {
  	      var capacity = toNumber(getDeep(tank, ["Capacity"], 0), 0);
  	      var volumeBefore = toNumber(getDeep(tank, ["Volume"], 0), 0);
  	      var litres = toNumber(valueOf("fuel-delivery-litres"), 0);
  	      var cost = toNumber(valueOf("fuel-delivery-cost"), 0);
  	
  	      var levelBefore = capacity > 0 ? ((volumeBefore / capacity) * 100) : 0;
  	      var volumeAfter = volumeBefore + litres;
  	      var levelAfter = capacity > 0 ? ((volumeAfter / capacity) * 100) : 0;
  	      var remainingCapacity = capacity - volumeAfter;
  	      var costPerLitre = litres > 0 ? (cost / litres) : 0;
  	      var overflow = remainingCapacity < 0 ? Math.abs(remainingCapacity) : 0;
  	
  	      return {
  	        capacity: capacity,
  	        volumeBefore: volumeBefore,
  	        levelBefore: levelBefore,
  	        litres: litres,
  	        cost: cost,
  	        volumeAfter: volumeAfter,
  	        levelAfter: levelAfter,
  	        remainingCapacity: remainingCapacity,
  	        costPerLitre: costPerLitre,
  	        overflow: overflow
  	      };
  	    }
  	
  	    function refreshLiveSummary() {
  	      var c = getLiveDeliveryComputed();
  	
  	      setText("fuel-delivery-capacity", displayNumber(c.capacity, 2));
  	      setText("fuel-delivery-volume-before", displayNumber(c.volumeBefore, 2));
  	      setText("fuel-delivery-volume-after", displayNumber(c.volumeAfter, 2));
  	      setText("fuel-delivery-level-before", displayNumber(c.levelBefore, 2) + "%");
  	      setText("fuel-delivery-level-after", displayNumber(c.levelAfter, 2) + "%");
  	      setText("fuel-delivery-remaining-capacity", displayNumber(c.remainingCapacity, 2));
  	      setValue("fuel-delivery-cost-per-litre", displayNumber(c.costPerLitre, 4));
  	
  	      if (c.overflow > 0) {
  	        showError("fuel-delivery-overflow-error", "Delivery exceeds tank capacity by " + displayNumber(c.overflow, 2) + " L");
  	      } else {
  	        showError("fuel-delivery-overflow-error", "");
  	      }
  	
  	      if (c.capacity > 0) {
  	        showHelp("fuel-delivery-litres-help", "Tank capacity " + displayNumber(c.capacity, 2) + " L | Current volume " + displayNumber(c.volumeBefore, 2) + " L");
  	      } else {
  	        showHelp("fuel-delivery-litres-help", "");
  	      }
  	    }
  	
  	    function validateDeliveryDate() {
  	      var v = valueOf("fuel-delivery-date");
  	      if (!v) {
  	        showError("fuel-delivery-date-error", "Delivery date is required");
  	        return false;
  	      }
  	      showError("fuel-delivery-date-error", "");
  	      return true;
  	    }
  	
  	    function validateSupplier() {
  	      var v = String(valueOf("fuel-delivery-supplier") || "").trim();
  	      if (!v) {
  	        showError("fuel-delivery-supplier-error", "Supplier is required");
  	        return false;
  	      }
  	      showError("fuel-delivery-supplier-error", "");
  	      return true;
  	    }
  	
  	    function validateLitres() {
  	      var c = getLiveDeliveryComputed();
  	      if (!(c.litres > 0)) {
  	        showError("fuel-delivery-litres-error", "Litres must be greater than 0");
  	        return false;
  	      }
  	      if (c.overflow > 0) {
  	        showError("fuel-delivery-litres-error", "Litres would overfill the tank");
  	        return false;
  	      }
  	      showError("fuel-delivery-litres-error", "");
  	      return true;
  	    }
  	
  	    function validateCost() {
  	      var cost = toNumber(valueOf("fuel-delivery-cost"), NaN);
  	      if (isNaN(cost)) {
  	        showError("fuel-delivery-cost-error", "Total cost is required");
  	        return false;
  	      }
  	      if (cost < 0) {
  	        showError("fuel-delivery-cost-error", "Total cost cannot be negative");
  	        return false;
  	      }
  	      showError("fuel-delivery-cost-error", "");
  	      return true;
  	    }
  	
  	    function validateReference() {
  	      var v = String(valueOf("fuel-delivery-reference") || "").trim();
  	      if (!v) {
  	        showError("fuel-delivery-reference-error", "Reference No is required");
  	        return false;
  	      }
  	      showError("fuel-delivery-reference-error", "");
  	      return true;
  	    }
  	
  	    function isComplete() {
  	      refreshLiveSummary();
  	      if (!validateDeliveryDate()) return false;
  	      if (!validateSupplier()) return false;
  	      if (!validateLitres()) return false;
  	      if (!validateCost()) return false;
  	      if (!validateReference()) return false;
  	      return true;
  	    }
  	
  	    function updateSaveVisibility() {
  	      var btn = el("fuel-delivery-save-btn");
  	      if (!btn) return;
  	      btn.style.display = isComplete() ? "block" : "none";
  	    }
  	
  	    function bindInputRefresh(id, numeric) {
  	      var node = el(id);
  	      if (!node) return;
  	
  	      node.addEventListener("input", function () {
  	        if (numeric) node.value = sanitizeNumeric(node.value);
  	        clearValidationMessages();
  	        refreshLiveSummary();
  	        updateSaveVisibility();
  	      });
  	
  	      node.addEventListener("change", function () {
  	        clearValidationMessages();
  	        refreshLiveSummary();
  	        updateSaveVisibility();
  	      });
  	    }
  	
  	    function buildDeliveryRow(item, index) {
  	      var fuelDate = formatDatePretty(text(getDeep(item, ["FuelDate"], ""), ""));
  	      var supplier = text(getDeep(item, ["Supplier"], ""), "Unknown Supplier");
  	      var referenceNo = text(getDeep(item, ["ReferenceNo"], ""), "");
  	      var litres = displayNumber(getDeep(item, ["Litres"], 0), 2);
  	      var cost = displayNumber(getDeep(item, ["Cost"], 0), 2);
  	      var cpl = displayNumber(getDeep(item, ["CostPerLitre"], 0), 4);
  	      var description = text(getDeep(item, ["Description"], ""), "");
  	
  	      return ""
  	        + '<button type="button" class="fuel-delivery-item" data-delivery-index="' + index + '" style="width:100%;text-align:left;background:rgba(255,255,255,0.05);border:none;border-radius:10px;padding:9px 11px;cursor:pointer;">'
  	        + '  <div style="display:grid;grid-template-columns:minmax(0,1.45fr) 92px 110px 110px;gap:10px;align-items:center;">'
  	        + '    <div style="min-width:0;">'
  	        + '      <div style="font-size:13px;font-weight:700;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(supplier) + "</div>"
  	        + '      <div style="margin-top:2px;font-size:10px;color:#94a3b8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(referenceNo || "No reference") + " | " + escapeHtml(fuelDate || ("Delivery " + (index + 1))) + "</div>"
  	        + (description ? '      <div style="margin-top:2px;font-size:10px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(description) + "</div>" : "")
  	        + "    </div>"
  	        + '    <div style="min-width:0;"><div style="font-size:9px;color:#94a3b8;">Litres</div><div style="margin-top:1px;font-size:14px;font-weight:700;color:#f8fafc;">' + escapeHtml(litres) + "</div></div>"
  	        + '    <div style="min-width:0;"><div style="font-size:9px;color:#94a3b8;">Cost</div><div style="margin-top:1px;font-size:13px;font-weight:700;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(cost) + "</div></div>"
  	        + '    <div style="min-width:0;text-align:right;"><div style="font-size:9px;color:#94a3b8;">Cost / L</div><div style="margin-top:1px;font-size:12px;font-weight:700;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(cpl) + "</div></div>"
  	        + "  </div>"
  	        + "</button>";
  	    }
  	
  	    function bindDeliveryRowClicks() {
  	      var listNode = el("fuel-delivery-list");
  	      if (!listNode) return;
  	
  	      var buttons = listNode.querySelectorAll("[data-delivery-index]");
  	      for (var i = 0; i < buttons.length; i++) {
  	        buttons[i].onclick = function () {
  	          var idx = toNumber(this.getAttribute("data-delivery-index"), -1);
  	          if (idx < 0 || idx >= state.filteredDeliveries.length) return;
  	          openDeliveryDetail(state.filteredDeliveries[idx]);
  	        };
  	      }
  	    }
  	
  	    function openDeliveryDetail(item) {
  	      state.selectedDelivery = item || null;
  	
  	      var backdrop = el("fuel-delivery-detail-backdrop");
  	      var title = el("fuel-delivery-detail-title");
  	      var subtitleNode = el("fuel-delivery-detail-subtitle");
  	      var body = el("fuel-delivery-detail-body");
  	
  	      if (!backdrop || !body || !item) return;
  	
  	      var supplier = text(getDeep(item, ["Supplier"], ""), "Unknown Supplier");
  	      var formattedDate = formatDatePretty(getDeep(item, ["FuelDate"], ""));
  	      var objectId = text(getDeep(item, ["objectId"], ""), "");
  	
  	      if (title) title.textContent = supplier;
  	      if (subtitleNode) subtitleNode.textContent = formattedDate + (objectId ? " | " + objectId : "");
  	
  	      body.innerHTML = ""
  	        + '<div style="display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;">'
  	        + '<div style="background:rgba(255,255,255,0.04);border-radius:12px;padding:12px 14px;">'
  	        + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:6px;">Delivery</div>'
  	        + buildDetailRow("Fuel Date", formattedDate)
  	        + buildDetailRow("Entry Type", getDeep(item, ["EntryType"], "delivery"))
  	        + buildDetailRow("Supplier", getDeep(item, ["Supplier"], ""))
  	        + buildDetailRow("Reference No", getDeep(item, ["ReferenceNo"], ""))
  	        + buildDetailRow("Description", getDeep(item, ["Description"], ""))
  	        + "</div>"
  	
  	        + '<div style="background:rgba(255,255,255,0.04);border-radius:12px;padding:12px 14px;">'
  	        + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:6px;">Figures</div>'
  	        + buildDetailRow("Litres", displayNumber(getDeep(item, ["Litres"], 0), 2))
  	        + buildDetailRow("Cost", displayNumber(getDeep(item, ["Cost"], 0), 2))
  	        + buildDetailRow("Cost Per Litre", displayNumber(getDeep(item, ["CostPerLitre"], 0), 4))
  	        + buildDetailRow("Volume Before", displayNumber(getDeep(item, ["VolumeBefore"], 0), 2))
  	        + buildDetailRow("Volume After", displayNumber(getDeep(item, ["VolumeAfter"], 0), 2))
  	        + buildDetailRow("Level Before", displayNumber(getDeep(item, ["LevelBefore"], 0), 2) + "%")
  	        + buildDetailRow("Level After", displayNumber(getDeep(item, ["LevelAfter"], 0), 2) + "%")
  	        + "</div>"
  	        + "</div>";
  	
  	      backdrop.style.display = "flex";
  	    }
  	
  	    function renderDeliveryListFromState() {
  	      var listNode = el("fuel-delivery-list");
  	      if (!listNode) return;
  	
  	      var deliveries = toArray(state.filteredDeliveries);
  	
  	      if (!deliveries.length) {
  	        listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No matching deliveries</div>'
  	          + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Try a different search term or clear the filter.</div>'
  	          + "</div>";
  	        return;
  	      }
  	
  	      var html = "";
  	      for (var i = 0; i < deliveries.length; i++) {
  	        html += buildDeliveryRow(deliveries[i], i);
  	      }
  	      listNode.innerHTML = html;
  	      bindDeliveryRowClicks();
  	    }
  	
  	    function applyDeliverySearch() {
  	      var raw = valueOf("fuel-delivery-search");
  	      var term = String(raw || "").trim().toLowerCase();
  	      state.searchTerm = term;
  	
  	      var source = toArray(state.deliveryCache);
  	      if (!term) {
  	        state.filteredDeliveries = source.slice();
  	      } else {
  	        state.filteredDeliveries = source.filter(function (item) {
  	          return buildDeliverySearchIndex(item).indexOf(term) >= 0;
  	        });
  	      }
  	
  	      var totals = getVisibleTotals(state.filteredDeliveries);
  	      setText("fuel-delivery-summary-count", String(totals.count));
  	      setText("fuel-delivery-summary-litres", displayNumber(totals.litres, 2));
  	      setText("fuel-delivery-summary-cost", displayNumber(totals.cost, 2));
  	      setText("fuel-delivery-summary-cpl", displayNumber(totals.avgCostPerLitre, 4));
  	
  	      renderDeliveryListFromState();
  	    }
  	
  	    function renderDeliveriesForTank() {
  	      var listNode = el("fuel-delivery-list");
  	      if (!listNode) return Promise.resolve();
  	
  	      closeDeliveryDetail();
  	
  	      if (!tank) {
  	        state.deliveryCache = [];
  	        state.filteredDeliveries = [];
  	        setText("fuel-delivery-summary-count", "0");
  	        setText("fuel-delivery-summary-litres", "0.00");
  	        setText("fuel-delivery-summary-cost", "0.00");
  	        setText("fuel-delivery-summary-cpl", "0.0000");
  	        listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">Tank not available</div>'
  	          + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Cannot load deliveries because the Tank object is missing.</div>'
  	          + "</div>";
  	        return Promise.resolve();
  	      }
  	
  	      listNode.innerHTML = ""
  	        + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	        + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">Loading deliveries...</div>'
  	        + "</div>";
  	
  	      var deliveries = toArray(getDeep(tank, ["FuelIn"], []));
  	
  	      deliveries.sort(function (a, b) {
  	        var da = new Date(text(getDeep(a, ["FuelDate"], ""), "1970-01-01")).getTime();
  	        var db = new Date(text(getDeep(b, ["FuelDate"], ""), "1970-01-01")).getTime();
  	        return db - da;
  	      });
  	
  	      state.deliveryCache = deliveries.slice();
  	
  	      if (!deliveries.length) {
  	        state.filteredDeliveries = [];
  	        setText("fuel-delivery-summary-count", "0");
  	        setText("fuel-delivery-summary-litres", "0.00");
  	        setText("fuel-delivery-summary-cost", "0.00");
  	        setText("fuel-delivery-summary-cpl", "0.0000");
  	        listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No deliveries found</div>'
  	          + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">No FuelIn rows are currently loaded for this tank.</div>'
  	          + "</div>";
  	        return Promise.resolve();
  	      }
  	
  	      applyDeliverySearch();
  	      return Promise.resolve();
  	    }
  	
  	    var captureBtn = el("fuel-delivery-tab-capture");
  	    var listBtn = el("fuel-delivery-tab-list");
  	    var capturePanel = el("fuel-delivery-capture-panel");
  	    var listPanel = el("fuel-delivery-list-panel");
  	
  	    function showCapture() {
  	      capturePanel.style.display = "block";
  	      listPanel.style.display = "none";
  	
  	      captureBtn.style.background = "#f97316";
  	      captureBtn.style.color = "#ffffff";
  	      captureBtn.style.border = "none";
  	
  	      listBtn.style.background = "rgba(255,255,255,0.04)";
  	      listBtn.style.color = "#dbe4ee";
  	      listBtn.style.border = "1px solid rgba(255,255,255,0.12)";
  	    }
  	
  	    function showList() {
  	      capturePanel.style.display = "none";
  	      listPanel.style.display = "block";
  	
  	      listBtn.style.background = "#f97316";
  	      listBtn.style.color = "#ffffff";
  	      listBtn.style.border = "none";
  	
  	      captureBtn.style.background = "rgba(255,255,255,0.04)";
  	      captureBtn.style.color = "#dbe4ee";
  	      captureBtn.style.border = "1px solid rgba(255,255,255,0.12)";
  	    }
  	
  	    if (el("fuel-delivery-close")) el("fuel-delivery-close").onclick = closeModal;
  	    if (el("fuel-delivery-cancel-btn")) el("fuel-delivery-cancel-btn").onclick = closeModal;
  	
  	    overlay.onclick = function (e) {
  	      if (e.target === overlay) closeModal();
  	    };
  	
  	    if (captureBtn) captureBtn.onclick = showCapture;
  	    if (listBtn) {
  	      listBtn.onclick = function () {
  	        showList();
  	        renderDeliveriesForTank();
  	      };
  	    }
  	
  	    var detailBackdrop = el("fuel-delivery-detail-backdrop");
  	    if (detailBackdrop) {
  	      detailBackdrop.onclick = function (e) {
  	        if (e.target === detailBackdrop) closeDeliveryDetail();
  	      };
  	    }
  	
  	    if (el("fuel-delivery-detail-close")) {
  	      el("fuel-delivery-detail-close").onclick = closeDeliveryDetail;
  	    }
  	
  	    if (el("fuel-delivery-detail-print")) {
  	      el("fuel-delivery-detail-print").onclick = function () {
  	        openSingleDeliveryPrintWindow(state.selectedDelivery);
  	      };
  	    }
  	
  	    setValue("fuel-delivery-date", formatDateInput(getNowIso()));
  	
  	    bindInputRefresh("fuel-delivery-date", false);
  	    bindInputRefresh("fuel-delivery-supplier", false);
  	    bindInputRefresh("fuel-delivery-litres", true);
  	    bindInputRefresh("fuel-delivery-cost", true);
  	    bindInputRefresh("fuel-delivery-reference", false);
  	    bindInputRefresh("fuel-delivery-description", false);
  	
  	    if (el("fuel-delivery-search")) {
  	      el("fuel-delivery-search").addEventListener("input", function () {
  	        applyDeliverySearch();
  	      });
  	    }
  	
  	    if (el("fuel-delivery-search-clear")) {
  	      el("fuel-delivery-search-clear").onclick = function () {
  	        setValue("fuel-delivery-search", "");
  	        applyDeliverySearch();
  	      };
  	    }
  	
  	    if (el("fuel-delivery-refresh-btn")) {
  	      el("fuel-delivery-refresh-btn").onclick = function () {
  	        renderDeliveriesForTank();
  	      };
  	    }
  	
  	    if (el("fuel-delivery-print-btn")) {
  	      el("fuel-delivery-print-btn").onclick = function () {
  	        openPrintWindow();
  	      };
  	    }
  	
  	    refreshLiveSummary();
  	    updateSaveVisibility();
  	    renderTankGauge(tankBlock, tank);
  	    showCapture();
  	
  	    if (el("fuel-delivery-save-btn")) {
  	      el("fuel-delivery-save-btn").onclick = function () {
  	        try {
  	          if (!isComplete()) {
  	            alert("Cannot save. The delivery figures are not valid yet.");
  	            return;
  	          }
  	
  	          var saveButton = el("fuel-delivery-save-btn");
  	          setButtonBusy(saveButton, true, "Saving...");
  	
  	          var fuelDateInput = valueOf("fuel-delivery-date");
  	          var supplier = String(valueOf("fuel-delivery-supplier") || "").trim();
  	          var referenceNo = String(valueOf("fuel-delivery-reference") || "").trim();
  	          var description = String(valueOf("fuel-delivery-description") || "").trim();
  	
  	          var computed = getLiveDeliveryComputed();
  	
  	          var volumeBefore = computed.volumeBefore;
  	          var volumeAfter = computed.volumeAfter;
  	          var levelBefore = computed.levelBefore;
  	          var levelAfter = computed.levelAfter;
  	          var litres = computed.litres;
  	          var cost = computed.cost;
  	          var costPerLitre = computed.costPerLitre;
  	
  	          var fuelDateIso = fuelDateInput
  	            ? new Date(fuelDateInput + "T12:00:00").toISOString()
  	            : getNowIso();
  	
  	          var fuelInRow = {
  	            FuelDate: fuelDateIso,
  	            EntryType: "delivery",
  	            Supplier: supplier,
  	            Litres: litres,
  	            Cost: cost,
  	            CostPerLitre: costPerLitre,
  	            ReferenceNo: referenceNo,
  	            Description: description,
  	            VolumeBefore: volumeBefore,
  	            VolumeAfter: volumeAfter,
  	            LevelBefore: levelBefore,
  	            LevelAfter: levelAfter
  	          };
  	
  	          if (company && company.objectId) fuelInRow.Company = { objectId: company.objectId };
  	          if (tank && tank.objectId) fuelInRow.Tank = { objectId: tank.objectId };
  	          if (currentUser && currentUser.objectId) fuelInRow.CapturedBy = { objectId: currentUser.objectId };
  	
  	                    saveTableRow("FuelIn", fuelInRow).then(function (savedFuelIn) {
  	            var minimalTankRow = {
  	              objectId: getDeep(tank, ["objectId"], null),
  	              Volume: volumeAfter,
  	              Level: levelAfter
  	            };
  	
  	            var visualTank = deepClone(tank || {});
  	
  	            visualTank.Volume = volumeAfter;
  	            visualTank.Level = levelAfter;
  	            appendFuelInOnce(visualTank, savedFuelIn);
  	
  	            return saveTableRow("Tanks", minimalTankRow).then(function () {
  	              if (getDeep(tank, ["objectId"], null) && getDeep(savedFuelIn, ["objectId"], null)) {
  	                return addRelation("Tanks", tank.objectId, "FuelIn", [savedFuelIn.objectId]).then(function () {
  	                  return savedFuelIn;
  	                });
  	              }
  	
  	              return savedFuelIn;
  	            }).then(function () {
  	              if (tank) {
  	                tank.Volume = visualTank.Volume;
  	                tank.Level = visualTank.Level;
  	                appendFuelInOnce(tank, savedFuelIn);
  	              }
  	
  	              if (company) {
  	                replaceNestedCompanyTank(company, visualTank, savedFuelIn);
  	              }
  	
  	              syncTankIntoLiveAppData(visualTank, savedFuelIn);
  	
  	              renderTankGauge(tankBlock, tank);
  	
  	              setValue("fuel-delivery-supplier", "");
  	              setValue("fuel-delivery-litres", "");
  	              setValue("fuel-delivery-cost", "");
  	              setValue("fuel-delivery-cost-per-litre", "0.0000");
  	              setValue("fuel-delivery-reference", "");
  	              setValue("fuel-delivery-description", "");
  	              setValue("fuel-delivery-date", formatDateInput(getNowIso()));
  	
  	              clearValidationMessages();
  	              refreshLiveSummary();
  	              updateSaveVisibility();
  	
  	              return renderDeliveriesForTank().then(function () {
  	                showList();
  	                alert("Fuel delivery saved, tank updated, and relation linked.");
  	              });
  	            });
  	          }).catch(function (saveErr) {
  	            console.log("Fuel delivery save error:", saveErr);
  	            alert("Save failed: " + (saveErr && saveErr.message ? saveErr.message : saveErr));
  	          }).then(function () {
  	            setButtonBusy(el("fuel-delivery-save-btn"), false, "Save Delivery");
  	          }, function () {
  	            setButtonBusy(el("fuel-delivery-save-btn"), false, "Save Delivery");
  	          });
  	        } catch (saveOuterErr) {
  	          console.log("Fuel delivery outer save error:", saveOuterErr);
  	          alert("Save failed: " + (saveOuterErr && saveOuterErr.message ? saveOuterErr.message : saveOuterErr));
  	          setButtonBusy(el("fuel-delivery-save-btn"), false, "Save Delivery");
  	        }
  	      };
  	    }
  	
  	    return null;
  	  } catch (err) {
  	    console.log("Fuel delivery full rewrite error:", err);
  	    return null;
  	  }
  	})();
  })(___arguments.context.appData, ___arguments.context.getComponentDataStoreByUid('ba58c7483308e8d80bf4856482a2db18'), ___arguments.context.getComponentDataStoreByUid('094e17f8898856d8d834001dcb08bbfb'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ba58c7483308e8d80bf4856482a2db18'), 'Contractors')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea09807bde56b1d84b0a9456edc38c98')), 'data:image/png;base64,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');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/792837c8c52457b1c62265985438e41c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Text2, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Text2 = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('094e17f8898856d8d834001dcb08bbfb'), 'Volume')),' l / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('094e17f8898856d8d834001dcb08bbfb'), 'Capacity')),' l'].join('');

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Text2 = 'error';
    }

  }

  return Text2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/54417ef8ea821cf8abb84aa3f8f54378/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tank_Data, item, Tanks, error, Tank, Company;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Tanks2() {
  Tanks = [];
  var Company_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var Company_index in Company_list) {
    Company = Company_list[Company_index];
    var Tank_list = (getObjectProperty(Company, 'Tanks'));
    for (var Tank_index in Tank_list) {
      Tank = Tank_list[Tank_index];
      try {
        addItemToList(Tanks, Tank);

      } catch (error) {
        console.log(error);

      }
    }
  }
  return await asyncListFilter(Tanks, async (item) => {


 return (!((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('094e17f8898856d8d834001dcb08bbfb'), 'objectId'))));
})
}


  Tank_Data = await Tanks2();
  await (async function(AppData, Company, Tank, Bowser, Contractors, TankBlock, SVGLogo, Tanks) {
  	return (function () {
  	  try {
  	    var appData = (typeof AppData !== "undefined" ? AppData: null);
  	    var company = (typeof Company !== "undefined" ? Company: null);
  	    var tank = (typeof Tank !== "undefined" ? Tank: null);
  	    var bowser = (typeof Bowser !== "undefined" ? Bowser: null);
  	    var contractorsInput = (typeof Contractors !== "undefined" ? Contractors: []);
  	    var tankBlock = (typeof TankBlock !== "undefined" ? TankBlock: null);
  	    var backendless = (typeof Backendless !== "undefined" ? Backendless: null);
  	    var currentUser = (typeof CurrentUser !== "undefined" ? CurrentUser: null);
  	    var svgLogo = (typeof SVGLogo !== "undefined" ? SVGLogo: null);
  	    var tanks = (typeof Tanks !== "undefined" ? Tanks: []);

  	    var BUSINESS_TIMEZONE_OFFSET_MINUTES = 120;

  	    function toArray(value) {
  	      if (Array.isArray(value)) return value;
  	      if (value === null || value === undefined) return [];
  	      return [value];
  	    }

  	    function toNumber(value, fallback) {
  	      var n = Number(String(value).replace(",", "."));
  	      return isNaN(n) ? fallback: n;
  	    }

  	    function text(value, fallback) {
  	      if (value === null || value === undefined || value === "") return fallback;
  	      return String(value);
  	    }

  	    function escapeHtml(value) {
  	      return String(value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/"/g, "&quot;")
  	      .replace(/'/g, "&#39;");
  	    }

  	    function firstDefined() {
  	      for (var i = 0; i < arguments.length; i++) {
  	        if (arguments[i] !== null && arguments[i] !== undefined && arguments[i] !== "") {
  	          return arguments[i];
  	        }
  	      }
  	      return null;
  	    }

  	    function getDeep(obj, path, fallback) {
  	      try {
  	        var current = obj;
  	        for (var i = 0; i < path.length; i++) {
  	          if (current == null) return fallback;
  	          current = current[path[i]];
  	        }
  	        return current == null ? fallback: current;
  	      } catch (e) {
  	        return fallback;
  	      }
  	    }

  	    function deepClone(value) {
  	      try {
  	        return JSON.parse(JSON.stringify(value));
  	      } catch (e) {
  	        return value;
  	      }
  	    }

  	    function uniqueByValue(list) {
  	      var seen = {};
  	      var out = [];

  	      for (var i = 0; i < list.length; i++) {
  	        var item = list[i];
  	        var key = String(getDeep(item, ["value"], "") || "").trim().toLowerCase();
  	        if (!key) continue;
  	        if (!seen[key]) {
  	          seen[key] = true;
  	          out.push(item);
  	        }
  	      }

  	      return out;
  	    }

  	    function normalizeOption(value, label, raw) {
  	      return {
  	        value: text(value, ""),
  	        label: text(label || value, ""),
  	        raw: raw || null
  	      };
  	    }

  	    function buildOptionsHtml(options, placeholder, selectedValue) {
  	      var html = "";

  	      if (placeholder) {
  	        html += '<option value="">' + escapeHtml(placeholder) + "</option>";
  	      }

  	      for (var i = 0; i < options.length; i++) {
  	        var opt = options[i];
  	        var selected = String(opt.value) === String(selectedValue || "") ? ' selected="selected"': "";
  	        html += '<option value="' + escapeHtml(opt.value) + '"' + selected + ">" + escapeHtml(opt.label) + "</option>";
  	      }

  	      return html;
  	    }

  	    function optionWithOtherFirst(options, otherLabel) {
  	      var out = [normalizeOption("OTHER", otherLabel || "Other", {
  	        type: "other"
  	      })];
  	      for (var i = 0; i < options.length; i++) {
  	        out.push(options[i]);
  	      }
  	      return uniqueByValue(out);
  	    }

  	    function pickVehicleLabel(item, fallbackPrefix, index) {
  	      var tractorId = firstDefined(
  	        getDeep(item, ["ID"], null),
  	        getDeep(item, ["FID"], null),
  	        getDeep(item, ["Name"], null)
  	      );

  	      var registration = firstDefined(
  	        getDeep(item, ["Registration"], null),
  	        getDeep(item, ["Data", "Vehicle", "Registration", "value"], null)
  	      );

  	      var label = firstDefined(
  	        tractorId && registration ? tractorId + " | " + registration: null,
  	        tractorId,
  	        registration
  	      );

  	      return text(label, fallbackPrefix + " " + (index + 1));
  	    }

  	    function pickVehicleValue(item, fallbackPrefix, index) {
  	      return text(
  	        firstDefined(
  	          getDeep(item, ["objectId"], null),
  	          getDeep(item, ["FID"], null),
  	          getDeep(item, ["Registration"], null)
  	        ),
  	        fallbackPrefix + "_" + (index + 1)
  	      );
  	    }

  	    function buildVehicleOptions(items, prefix) {
  	      var arr = toArray(items);
  	      var out = [];

  	      for (var i = 0; i < arr.length; i++) {
  	        out.push(
  	          normalizeOption(
  	            pickVehicleValue(arr[i], prefix, i),
  	            pickVehicleLabel(arr[i], prefix, i),
  	            arr[i]
  	          )
  	        );
  	      }

  	      return uniqueByValue(out);
  	    }

  	    function buildContractorOptions(items) {
  	      var arr = toArray(items);
  	      var out = [];

  	      for (var i = 0; i < arr.length; i++) {
  	        var item = arr[i];
  	        out.push(
  	          normalizeOption(
  	            text(firstDefined(item.objectId, item.CompanyId, item.Name), "CONTRACTOR_" + (i + 1)),
  	            text(firstDefined(item.Name, item.CompanyId), "Contractor " + (i + 1)),
  	            item
  	          )
  	        );
  	      }

  	      return uniqueByValue(out);
  	    }

  	    function buildEmployeeOptions(items) {
  	      var arr = toArray(items);
  	      var out = [];

  	      for (var i = 0; i < arr.length; i++) {
  	        var item = arr[i];

  	        var label = firstDefined(
  	          getDeep(item, ["name"], null),
  	          getDeep(item, ["Name"], null),
  	          [
  	            getDeep(item, ["Data_Details", "employee_details", "first_name"], ""),
  	            getDeep(item, ["Data_Details", "employee_details", "last_name"], "")
  	          ].join(" ").trim(),
  	          getDeep(item, ["email"], null)
  	        );

  	        var value = firstDefined(
  	          getDeep(item, ["ID"], null),
  	          getDeep(item, ["objectId"], null),
  	          getDeep(item, ["email"], null),
  	          label
  	        );

  	        if (label) {
  	          out.push(normalizeOption(value, label, item));
  	        }
  	      }

  	      return uniqueByValue(out);
  	    }

  	    function normalizeGrade(value) {
  	      return String(value || "")
  	      .trim()
  	      .toLowerCase()
  	      .replace(/\s+/g, " ");
  	    }

  	    function pickTankLabel(item, fallbackPrefix, index) {
  	      var tankName = firstDefined(
  	        getDeep(item, ["Name"], null),
  	        getDeep(item, ["TankName"], null),
  	        getDeep(item, ["DeviceId"], null),
  	        getDeep(item, ["FID"], null)
  	      );

  	      var grade = firstDefined(
  	        getDeep(item, ["Grade"], null),
  	        getDeep(item, ["FuelGrade"], null)
  	      );

  	      var label = firstDefined(
  	        tankName && grade ? tankName + " | " + grade: null,
  	        tankName,
  	        grade
  	      );

  	      return text(label, fallbackPrefix + " " + (index + 1));
  	    }

  	    function pickTankValue(item, fallbackPrefix, index) {
  	      return text(
  	        firstDefined(
  	          getDeep(item, ["objectId"], null),
  	          getDeep(item, ["DeviceId"], null),
  	          getDeep(item, ["FID"], null),
  	          getDeep(item, ["Name"], null)
  	        ),
  	        fallbackPrefix + "_" + (index + 1)
  	      );
  	    }

  	    function getAvailableTanks() {
  	      var allFromAppData = [];
  	      var companies = getUserCompaniesFromAppData();

  	      for (var c = 0; c < companies.length; c++) {
  	        var companyTanks = toArray(getDeep(companies[c], ["Tanks"], []));
  	        for (var i = 0; i < companyTanks.length; i++) {
  	          allFromAppData.push(companyTanks[i]);
  	        }
  	      }

  	      if (allFromAppData.length) {
  	        console.log("[Intertank] Using AppData.User.Companies[*].Tanks:", allFromAppData);
  	        return allFromAppData;
  	      }

  	      if (Array.isArray(tanks) && tanks.length) {
  	        console.log("[Intertank] Using Tanks argument fallback:", tanks);
  	        return tanks;
  	      }

  	      var companyTanksFallback = getDeep(company, ["Tanks"], null);
  	      if (Array.isArray(companyTanksFallback) && companyTanksFallback.length) {
  	        console.log("[Intertank] Using company.Tanks fallback:", companyTanksFallback);
  	        return companyTanksFallback;
  	      }

  	      console.log("[Intertank] No tanks available.");
  	      return [];
  	    }

  	    function unwrapTankItem(item) {
  	      if (!item) return null;

  	      if (getDeep(item, ["objectId"], null) || getDeep(item, ["Grade"], null) || getDeep(item, ["DeviceId"], null)) {
  	        return item;
  	      }

  	      if (getDeep(item, ["Tank"], null)) {
  	        return getDeep(item, ["Tank"], null);
  	      }

  	      if (getDeep(item, ["data"], null)) {
  	        return getDeep(item, ["data"], null);
  	      }

  	      return item;
  	    }

  	    function buildIntertankOptions(currentTankObj) {
  	      var availableTanks = getAvailableTanks();
  	      var out = [];
  	      var currentTankId = text(getDeep(currentTankObj, ["objectId"], null), "");
  	      var currentGrade = normalizeGrade(getDeep(currentTankObj, ["Grade"], ""));

  	      console.log("[Intertank] current tank:", currentTankObj);
  	      console.log("[Intertank] raw available tanks:", availableTanks);

  	      for (var i = 0; i < availableTanks.length; i++) {
  	        var rawItem = availableTanks[i];
  	        var item = unwrapTankItem(rawItem);

  	        var itemId = text(getDeep(item, ["objectId"], null), "");
  	        var itemGrade = normalizeGrade(getDeep(item, ["Grade"], ""));
  	        var itemLabel = pickTankLabel(item, "Tank", i);

  	        console.log("[Intertank] candidate:", {
  	          rawItem: rawItem,
  	          item: item,
  	          itemId: itemId,
  	          itemGrade: itemGrade,
  	          itemLabel: itemLabel
  	        });

  	        if (!itemId) continue;
  	        if (itemId === currentTankId) continue;
  	        if (currentGrade && itemGrade !== currentGrade) continue;

  	        out.push(
  	          normalizeOption(
  	            pickTankValue(item, "TANK", i),
  	            itemLabel,
  	            item
  	          )
  	        );
  	      }

  	      console.log("[Intertank] final options:", out);
  	      return uniqueByValue(out);
  	    }

  	    function getSelectedIntertankTarget() {
  	      var selectedId = valueOf("fuel-intertank-target");
  	      var availableTanks = getAvailableTanks();

  	      for (var i = 0; i < availableTanks.length; i++) {
  	        var item = unwrapTankItem(availableTanks[i]);
  	        if (String(getDeep(item, ["objectId"], "")) === String(selectedId || "")) {
  	          return item;
  	        }
  	      }

  	      return null;
  	    }

  	    function validateIntertankTarget() {
  	      var mode = valueOf("fuel-capture-type");

  	      if (mode !== "intertank") {
  	        showError("fuel-intertank-target-error", "");
  	        return {
  	          ok: true
  	        };
  	      }

  	      var targetTank = getSelectedIntertankTarget();

  	      if (!targetTank) {
  	        showError("fuel-intertank-target-error", "Please select a destination tank.");
  	        return {
  	          ok: false
  	        };
  	      }

  	      var sourceTankId = text(getDeep(tank, ["objectId"], null), "");
  	      var targetTankId = text(getDeep(targetTank, ["objectId"], null), "");

  	      if (sourceTankId && targetTankId && sourceTankId === targetTankId) {
  	        showError("fuel-intertank-target-error", "Destination tank cannot be the same as the source tank.");
  	        return {
  	          ok: false
  	        };
  	      }

  	      var sourceGrade = normalizeGrade(getDeep(tank, ["Grade"], ""));
  	      var targetGrade = normalizeGrade(getDeep(targetTank, ["Grade"], ""));

  	      if (sourceGrade !== targetGrade) {
  	        showError(
  	          "fuel-intertank-target-error",
  	          "Grade mismatch. Cannot transfer " +
  	          text(getDeep(tank, ["Grade"], "source grade"), "source grade") +
  	          " into " +
  	          text(getDeep(targetTank, ["Grade"], "destination grade"), "destination grade") +
  	          "."
  	        );
  	        return {
  	          ok: false
  	        };
  	      }

  	      showError("fuel-intertank-target-error", "");
  	      return {
  	        ok: true,
  	        targetTank: targetTank
  	      };
  	    }

  	    function sanitizeNumeric(value) {
  	      return String(value || "").replace(/[^0-9.,]/g, "");
  	    }

  	    function displayNumber(value, decimals) {
  	      var n = toNumber(value, 0);
  	      return n.toFixed(decimals);
  	    }

  	    function formatCurrency(value) {
  	      return "R " + displayNumber(value, 2);
  	    }

  	    function pad2(v) {
  	      return String(v).padStart(2, "0");
  	    }

  	    function getUtcDate(value) {
  	      var d = value ? new Date(value): new Date();
  	      if (isNaN(d.getTime())) d = new Date();
  	      return d;
  	    }

  	    function getBusinessDate(value) {
  	      var utcDate = getUtcDate(value);
  	      return new Date(utcDate.getTime() + (BUSINESS_TIMEZONE_OFFSET_MINUTES * 60000));
  	    }

  	    function ensureBusinessDate(value) {
  	      if (value instanceof Date) {
  	        return new Date(value.getTime());
  	      }
  	      return getBusinessDate(value);
  	    }

  	    function getBusinessNowDate() {
  	      return getBusinessDate(new Date().toISOString());
  	    }

  	    function getNowDate() {
  	      return getBusinessNowDate();
  	    }

  	    function getNowIso() {
  	      return new Date().toISOString();
  	    }

  	    function getMYear(dateObj) {
  	      var d = dateObj ? ensureBusinessDate(dateObj): getBusinessNowDate();
  	      return d.getUTCFullYear() + "-" + pad2(d.getUTCMonth() + 1);
  	    }

  	    function getMonthLabel(dateObj) {
  	      var d = dateObj ? ensureBusinessDate(dateObj): getBusinessNowDate();
  	      var names = [
  	        "January",
  	        "February",
  	        "March",
  	        "April",
  	        "May",
  	        "June",
  	        "July",
  	        "August",
  	        "September",
  	        "October",
  	        "November",
  	        "December"
  	      ];
  	      return names[d.getUTCMonth()] + " " + d.getUTCFullYear();
  	    }

  	    function getMonthStartMs(dateObj) {
  	      var d = dateObj ? ensureBusinessDate(dateObj): getBusinessNowDate();
  	      return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1, 0, 0, 0, 0);
  	    }

  	    function getMonthEndMs(dateObj) {
  	      var d = dateObj ? ensureBusinessDate(dateObj): getBusinessNowDate();
  	      return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 1, 0, 0, 0, 0) - 1;
  	    }

  	    function sameKey(a, b) {
  	      var left = String(a === null || a === undefined ? "": a).trim();
  	      var right = String(b === null || b === undefined ? "": b).trim();

  	      if (!left || !right) return false;

  	      return left === right;
  	    }

  	    function sameObjectId(a, b) {
  	      return sameKey(a, b);
  	    }

  	    function findIndexByKeys(items, candidate) {
  	      var arr = toArray(items);

  	      for (var i = 0; i < arr.length; i++) {
  	        var row = arr[i];

  	        if (
  	          sameKey(getDeep(row, ["objectId"], null), getDeep(candidate, ["objectId"], null)) ||
  	          sameKey(getDeep(row, ["FID"], null), getDeep(candidate, ["FID"], null)) ||
  	          sameKey(getDeep(row, ["Registration"], null), getDeep(candidate, ["Registration"], null)) ||
  	          sameKey(getDeep(row, ["Name"], null), getDeep(candidate, ["Name"], null)) ||
  	          sameKey(getDeep(row, ["DeviceId"], null), getDeep(candidate, ["DeviceId"], null))
  	        ) {
  	          return i;
  	        }
  	      }

  	      return -1;
  	    }

  	    function saveTableRow(tableName, row) {
  	      if (!backendless || !backendless.Data || !backendless.Data.of) {
  	        return Promise.reject(new Error("Backendless SDK is not available"));
  	      }
  	      return backendless.Data.of(tableName).save(row);
  	    }

  	    function loadTableRow(tableName, objectId, relations) {
  	      if (!backendless || !backendless.Data || !backendless.Data.of) {
  	        return Promise.reject(new Error("Backendless SDK is not available"));
  	      }

  	      var builder = backendless.DataQueryBuilder ? backendless.DataQueryBuilder.create(): null;
  	      if (builder && relations && relations.length) {
  	        builder.setRelated(relations);
  	      }

  	      if (backendless.Data.of(tableName).findById.length >= 2) {
  	        return backendless.Data.of(tableName).findById(objectId, builder || undefined);
  	      }

  	      return backendless.Data.of(tableName).findById(objectId);
  	    }

  	    function deleteTableRow(tableName, objectId) {
  	      if (!backendless || !backendless.Data || !backendless.Data.of) {
  	        return Promise.reject(new Error("Backendless SDK is not available"));
  	      }

  	      if (!objectId) {
  	        return Promise.resolve(null);
  	      }

  	      return backendless.Data.of(tableName).remove({
  	        objectId: objectId
  	      });
  	    }

  	    function setRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	      if (!backendless || !backendless.Data || !backendless.Data.of) {
  	        return Promise.reject(new Error("Backendless SDK is not available"));
  	      }

  	      if (!parentObjectId) {
  	        return Promise.resolve(null);
  	      }

  	      var ids = toArray(childObjectIds).filter(function (id) {
  	        return !!id;
  	      });

  	      var tableApi = backendless.Data.of(tableName);

  	      if (typeof tableApi.setRelation !== "function") {
  	        return Promise.reject(
  	          new Error("Backendless setRelation is not available for " + tableName + "." + relationName)
  	        );
  	      }

  	      return tableApi.setRelation(
  	        {
  	          objectId: parentObjectId
  	        },
  	        relationName,
  	        ids
  	      );
  	    }

  	    function addRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	      if (!backendless || !backendless.Data || !backendless.Data.of) {
  	        return Promise.reject(new Error("Backendless SDK is not available"));
  	      }

  	      if (!parentObjectId) {
  	        return Promise.resolve(null);
  	      }

  	      var ids = toArray(childObjectIds).filter(function (id) {
  	        return !!id;
  	      });

  	      return backendless.Data.of(tableName).addRelation(
  	        {
  	          objectId: parentObjectId
  	        },
  	        relationName,
  	        ids
  	      );
  	    }

  	    function buildBowserHistoryRelationIds(targetBowser) {
  	      var ids = [];
  	      var seen = {};
  	      var historyViews = toArray(getDeep(targetBowser, ["ViewH"], []));

  	      for (var i = 0; i < historyViews.length; i++) {
  	        var historyId = getDeep(historyViews[i], ["objectId"], null);
  	        if (!historyId) continue;

  	        if (!seen[historyId]) {
  	          seen[historyId] = true;
  	          ids.push(historyId);
  	        }
  	      }

  	      return ids;
  	    }

  	    async function syncBowserViewRelations(targetBowser, savedCurrentView) {
  	      var bowserObjectId = getDeep(targetBowser, ["objectId"], null);
  	      var currentViewObjectId = getDeep(savedCurrentView, ["objectId"], null);

  	      if (!bowserObjectId) {
  	        throw new Error("Cannot sync bowser view relations without bowser objectId.");
  	      }

  	      if (!currentViewObjectId) {
  	        throw new Error("Cannot sync bowser ViewC relation without current view objectId.");
  	      }

  	      await setRelation("Bowsers", bowserObjectId, "ViewC", [currentViewObjectId]);

  	      var historyRelationIds = buildBowserHistoryRelationIds(targetBowser);
  	      await setRelation("Bowsers", bowserObjectId, "ViewH", historyRelationIds);

  	      targetBowser.ViewC = savedCurrentView;
  	    }

  	    function setButtonBusy(button, isBusy, label) {
  	      if (!button) return;
  	      button.disabled = !!isBusy;
  	      button.style.opacity = isBusy ? "0.7": "1";
  	      button.style.cursor = isBusy ? "wait": "pointer";
  	      if (label) button.textContent = label;
  	    }

  	    function renderTankGauge(gaugeHost, targetTank) {
  	      try {
  	        if (!gaugeHost || !targetTank) return;

  	        var hostEl = null;

  	        if (gaugeHost.el) {
  	          hostEl = gaugeHost.el;
  	        } else if (typeof HTMLElement !== "undefined" && gaugeHost instanceof HTMLElement) {
  	          hostEl = gaugeHost;
  	        }

  	        if (!hostEl) {
  	          console.log("TankBlock does not contain a usable DOM element");
  	          console.log(gaugeHost);
  	          return;
  	        }

  	        var level = Number(targetTank.Level);
  	        if (isNaN(level)) level = 0;
  	        if (level < 0) level = 0;
  	        if (level > 100) level = 100;

  	        var grade = targetTank.Grade || "Tank";
  	        var liquidColor = targetTank.Color || "#22c55e";

  	        var uid = "tank_" + (targetTank.objectId || Math.random().toString(36).slice(2));

  	        var cx = 50;
  	        var cy = 50;
  	        var outerR = 45;
  	        var innerR = 37;

  	        var liquidTopY = cy + innerR - ((level / 100) * (innerR * 2));
  	        var liquidHeight = (cy + innerR) - liquidTopY;

  	        var levelText = Math.round(level) + "%";

  	        hostEl.innerHTML = ""
  	        + '<svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" style="display:block;overflow:visible;">'
  	        + "  <defs>"
  	        + '    <radialGradient id="' + uid + '_shell" cx="35%" cy="30%" r="75%">'
  	        + '      <stop offset="0%" stop-color="#f8fafc"></stop>'
  	        + '      <stop offset="45%" stop-color="#d1d5db"></stop>'
  	        + '      <stop offset="75%" stop-color="#9ca3af"></stop>'
  	        + '      <stop offset="100%" stop-color="#6b7280"></stop>'
  	        + "    </radialGradient>"
  	        + '    <radialGradient id="' + uid + '_inner" cx="35%" cy="30%" r="80%">'
  	        + '      <stop offset="0%" stop-color="#f3f4f6"></stop>'
  	        + '      <stop offset="100%" stop-color="#d1d5db"></stop>'
  	        + "    </radialGradient>"
  	        + '    <linearGradient id="' + uid + '_glass" x1="0" y1="0" x2="1" y2="1">'
  	        + '      <stop offset="0%" stop-color="#ffffff" stop-opacity="0.24"></stop>'
  	        + '      <stop offset="100%" stop-color="#ffffff" stop-opacity="0.05"></stop>'
  	        + "    </linearGradient>"
  	        + '    <clipPath id="' + uid + '_liquidClip">'
  	        + '      <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '"></circle>'
  	        + "    </clipPath>"
  	        + "  </defs>"
  	        + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + outerR + '" fill="url(#' + uid + '_shell)"></circle>'
  	        + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_inner)"></circle>'
  	        + '  <g clip-path="url(#' + uid + '_liquidClip)">'
  	        + '    <rect x="' + (cx - innerR) + '" y="' + liquidTopY + '" width="' + (innerR * 2) + '" height="' + liquidHeight + '" fill="' + liquidColor + '"></rect>'
  	        + '    <rect x="' + (cx - innerR + 5) + '" y="' + liquidTopY + '" width="' + ((innerR * 2) - 10) + '" height="2.4" rx="1.2" fill="#ffffff" opacity="0.18"></rect>'
  	        + "  </g>"
  	        + '  <circle cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="url(#' + uid + '_glass)"></circle>'
  	        + '  <ellipse cx="' + (cx - 10) + '" cy="' + (cy - 9) + '" rx="10" ry="20" fill="#ffffff" opacity="0.12"></ellipse>'
  	        + '  <text x="' + cx + '" y="' + (cy + 1) + '" text-anchor="middle" font-size="15" font-weight="700" fill="#0f172a">' + levelText + "</text>"
  	        + '  <text x="' + cx + '" y="' + (cy + 13) + '" text-anchor="middle" font-size="6.5" font-weight="600" fill="#334155">' + escapeHtml(grade) + "</text>"
  	        + "</svg>";
  	      } catch (gaugeErr) {
  	        console.log("Tank gauge render error:", gaugeErr);
  	      }
  	    }

  	    function mergeVehicleForLiveUi(existingVehicleObj, updatedVehicleObj) {
  	      var mergedVehicle = deepClone(existingVehicleObj || {});
  	      var updatedVehicle = updatedVehicleObj || {};

  	      if (getDeep(updatedVehicle, ["Mileage"], null) !== null) {
  	        mergedVehicle.Mileage = updatedVehicle.Mileage;
  	      }

  	      if (getDeep(updatedVehicle, ["ViewC"], null) !== null) {
  	        mergedVehicle.ViewC = deepClone(updatedVehicle.ViewC);
  	      }

  	      if (getDeep(updatedVehicle, ["ViewH"], null) !== null) {
  	        mergedVehicle.ViewH = deepClone(updatedVehicle.ViewH);
  	      }

  	      if (
  	        getDeep(updatedVehicle, ["Data", "OperationalTargets", "Fuel_Counter", "value"], null) !== null &&
  	        getDeep(mergedVehicle, ["Data", "OperationalTargets", "Fuel_Counter"], null) !== null
  	      ) {
  	        mergedVehicle.Data.OperationalTargets.Fuel_Counter.value =
  	        updatedVehicle.Data.OperationalTargets.Fuel_Counter.value;
  	      }

  	      // Preserve all existing UI fields and nested relations.
  	      // Do not replace the whole tractor object with a partial backend-loaded row.

  	      return mergedVehicle;
  	    }

  	    function replaceNestedCompanyVehicle(companyObj, vehicleObj) {
  	      var tractors = toArray(getDeep(companyObj, ["Tractors"], []));
  	      var vIndex = findIndexByKeys(tractors, vehicleObj);

  	      if (vIndex >= 0) {
  	        tractors[vIndex] = mergeVehicleForLiveUi(tractors[vIndex], vehicleObj);
  	        companyObj.Tractors = tractors;
  	      }
  	    }

  	    function mergeTankForLiveUi(existingTankObj, updatedTankObj) {
  	      var mergedTank = deepClone(existingTankObj || {});
  	      var updatedTank = updatedTankObj || {};

  	      if (getDeep(updatedTank, ["Volume"], null) !== null) {
  	        mergedTank.Volume = updatedTank.Volume;
  	      }

  	      if (getDeep(updatedTank, ["Level"], null) !== null) {
  	        mergedTank.Level = updatedTank.Level;
  	      }

  	      if (getDeep(updatedTank, ["Meter"], null) !== null) {
  	        mergedTank.Meter = updatedTank.Meter;
  	      }

  	      if (getDeep(updatedTank, ["ViewC"], null) !== null) {
  	        mergedTank.ViewC = deepClone(updatedTank.ViewC);
  	      }

  	      if (getDeep(updatedTank, ["ViewH"], null) !== null) {
  	        mergedTank.ViewH = deepClone(updatedTank.ViewH);
  	      }

  	      // Preserve the existing Bowsers array for the repeater.
  	      // Only update matching bowsers inside it; never replace the whole list with a partial backend relation.
  	      var existingBowsers = toArray(getDeep(mergedTank, ["Bowsers"], []));
  	      var updatedBowsers = toArray(getDeep(updatedTank, ["Bowsers"], []));

  	      for (var i = 0; i < updatedBowsers.length; i++) {
  	        var updatedBowser = updatedBowsers[i];
  	        var bowserIndex = findIndexByKeys(existingBowsers, updatedBowser);

  	        if (bowserIndex >= 0) {
  	          existingBowsers[bowserIndex] = Object.assign(
  	            {},
  	            deepClone(existingBowsers[bowserIndex]),
  	            deepClone(updatedBowser)
  	          );
  	        }
  	      }

  	      mergedTank.Bowsers = existingBowsers;

  	      return mergedTank;
  	    }

  	    function replaceNestedCompanyTank(companyObj, tankObj) {
  	      var tanks = toArray(getDeep(companyObj, ["Tanks"], []));
  	      var tIndex = findIndexByKeys(tanks, tankObj);

  	      if (tIndex >= 0) {
  	        // Only update tank scalar values.
  	        // Do not replace the tank object, because the replacement may not contain full Bowsers relation data.
  	        if (getDeep(tankObj, ["Volume"], null) !== null) tanks[tIndex].Volume = tankObj.Volume;
  	        if (getDeep(tankObj, ["Level"], null) !== null) tanks[tIndex].Level = tankObj.Level;

  	        companyObj.Tanks = tanks;
  	      }
  	    }

  	    function getAppDataRoot() {
  	      if (appData && typeof appData === "object") return appData;
  	      if (typeof AppData !== "undefined" && AppData && typeof AppData === "object") return AppData;
  	      return null;
  	    }

  	    function getUserCompaniesFromAppData() {
  	      return toArray(getDeep(getAppDataRoot(), ["User", "Companies"], []));
  	    }

  	    function findTankInAppDataByObjectId(tankObjectId) {
  	      var companies = getUserCompaniesFromAppData();

  	      for (var c = 0; c < companies.length; c++) {
  	        var companyItem = companies[c];
  	        var companyTanks = toArray(getDeep(companyItem, ["Tanks"], []));

  	        for (var i = 0; i < companyTanks.length; i++) {
  	          var candidate = companyTanks[i];
  	          if (String(getDeep(candidate, ["objectId"], "")) === String(tankObjectId || "")) {
  	            return {
  	              companyIndex: c,
  	              tankIndex: i,
  	              company: companyItem,
  	              tank: candidate
  	            };
  	          }
  	        }
  	      }

  	      return null;
  	    }

  	    function syncTankIntoLiveAppData(updatedTankObj) {
  	      if (!updatedTankObj || !getDeep(updatedTankObj, ["objectId"], null)) return false;

  	      var match = findTankInAppDataByObjectId(getDeep(updatedTankObj, ["objectId"], null));
  	      if (!match) return false;

  	      var companies = getUserCompaniesFromAppData();
  	      if (!companies[match.companyIndex]) return false;

  	      var liveTank = companies[match.companyIndex].Tanks[match.tankIndex];
  	      if (!liveTank) return false;

  	      // Only update safe scalar values.
  	      // Never replace the whole tank object here, because that can remove nested Bowsers from the repeater.
  	      if (getDeep(updatedTankObj, ["Volume"], null) !== null) liveTank.Volume = updatedTankObj.Volume;
  	      if (getDeep(updatedTankObj, ["Level"], null) !== null) liveTank.Level = updatedTankObj.Level;

  	      companies[match.companyIndex].Tanks[match.tankIndex] = liveTank;
  	      return true;
  	    }

  	    function syncCompanyIntoLiveAppData(updatedCompanyObj) {
  	      if (!updatedCompanyObj) return false;

  	      var companies = getUserCompaniesFromAppData();

  	      for (var i = 0; i < companies.length; i++) {
  	        var candidate = companies[i];

  	        if (
  	          sameKey(getDeep(candidate, ["objectId"], null), getDeep(updatedCompanyObj, ["objectId"], null)) ||
  	          sameKey(getDeep(candidate, ["CompanyId"], null), getDeep(updatedCompanyObj, ["CompanyId"], null))
  	        ) {
  	          // Never replace candidate.Tractors or candidate.Tanks wholesale.
  	          // Backendless-loaded company rows can contain partial relation arrays.

  	          var updatedTractors = toArray(getDeep(updatedCompanyObj, ["Tractors"], []));
  	          for (var t = 0; t < updatedTractors.length; t++) {
  	            replaceNestedCompanyVehicle(candidate, updatedTractors[t]);
  	          }

  	          var updatedTanks = toArray(getDeep(updatedCompanyObj, ["Tanks"], []));
  	          for (var k = 0; k < updatedTanks.length; k++) {
  	            replaceNestedCompanyTank(candidate, updatedTanks[k]);
  	          }

  	          return true;
  	        }
  	      }

  	      return false;
  	    }

  	    function forceAppDataRefresh() {
  	      // Disabled for fuel capture.
  	      // Full AppData refresh rebuilds the Backendless repeater and can drop nested bowser/pump relations.
  	      return;
  	    }


  	    function isTransactionReversed(item) {
  	      return !!(
  	        getDeep(item, ["IsReversed"], false) ||
  	        getDeep(item, ["Reversed"], false) ||
  	        getDeep(item, ["RollbackStatus"], "") === "reversed"
  	      );
  	    }

  	    function getTransactionTimeMs(item) {
  	      var raw = firstDefined(
  	        getDeep(item, ["FuelDate"], null),
  	        getDeep(item, ["created"], null),
  	        "1970-01-01T00:00:00.000Z"
  	      );
  	      var ms = new Date(raw).getTime();
  	      return isNaN(ms) ? 0: ms;
  	    }

  	    function sortTransactionsAsc(items) {
  	      return toArray(items).slice().sort(function (a, b) {
  	        var aMs = getTransactionTimeMs(a);
  	        var bMs = getTransactionTimeMs(b);

  	        if (aMs !== bMs) return aMs - bMs;

  	        var aMeter = toNumber(getDeep(a, ["Meter"], 0), 0);
  	        var bMeter = toNumber(getDeep(b, ["Meter"], 0), 0);
  	        if (aMeter !== bMeter) return aMeter - bMeter;

  	        var aId = text(getDeep(a, ["objectId"], ""), "");
  	        var bId = text(getDeep(b, ["objectId"], ""), "");
  	        return aId.localeCompare(bId);
  	      });
  	    }

  	    function sortTransactionsDesc(items) {
  	      return sortTransactionsAsc(items).reverse();
  	    }

  	    function getActiveTransactionsOnly(items) {
  	      return toArray(items).filter(function (item) {
  	        return !isTransactionReversed(item);
  	      });
  	    }

  	    function sumTransactionLitres(items) {
  	      var arr = toArray(items);
  	      var total = 0;

  	      for (var i = 0; i < arr.length; i++) {
  	        total += toNumber(getDeep(arr[i], ["Litres"], 0), 0);
  	      }

  	      return total;
  	    }

  	    function getLatestTankFuelIn(targetTank) {
  	      var deliveries = toArray(getDeep(targetTank, ["FuelIn"], []));

  	      if (!deliveries.length) return null;

  	      deliveries.sort(function (a, b) {
  	        var aDate = firstDefined(
  	          getDeep(a, ["FuelDate"], null),
  	          getDeep(a, ["DeliveryDate"], null),
  	          getDeep(a, ["created"], null),
  	          "1970-01-01T00:00:00.000Z"
  	        );

  	        var bDate = firstDefined(
  	          getDeep(b, ["FuelDate"], null),
  	          getDeep(b, ["DeliveryDate"], null),
  	          getDeep(b, ["created"], null),
  	          "1970-01-01T00:00:00.000Z"
  	        );

  	        return new Date(bDate).getTime() - new Date(aDate).getTime();
  	      });

  	      return deliveries[0] || null;
  	    }

  	    function getTankCostPerLitre(targetTank) {
  	      var latestFuelIn = getLatestTankFuelIn(targetTank);
  	      if (!latestFuelIn) return 0;

  	      var stamped = toNumber(getDeep(latestFuelIn, ["CostPerLitre"], NaN), NaN);
  	      if (!isNaN(stamped) && stamped > 0) return stamped;

  	      var totalCost = toNumber(getDeep(latestFuelIn, ["Cost"], 0), 0);
  	      var totalLitres = toNumber(getDeep(latestFuelIn, ["Litres"], 0), 0);

  	      if (totalCost > 0 && totalLitres > 0) {
  	        return totalCost / totalLitres;
  	      }

  	      return 0;
  	    }

  	    function isVehicleSarsCompliant(vehicle) {
  	      var raw = firstDefined(
  	        getDeep(vehicle, ["SARSCompliance"], null),
  	        getDeep(vehicle, ["Data", "SARSCompliance"], null),
  	        getDeep(vehicle, ["Data", "Vehicle", "SARSCompliance", "value"], null)
  	      );

  	      if (raw === true || raw === 1) return true;
  	      if (raw === false || raw === 0 || raw === null || raw === undefined || raw === "") return false;

  	      var normalized = String(raw).trim().toLowerCase();

  	      return (
  	        normalized === "true" ||
  	        normalized === "yes" ||
  	        normalized === "y" ||
  	        normalized === "1" ||
  	        normalized === "compliant" ||
  	        normalized === "approved"
  	      );
  	    }

  	    function getTransactionUnitCost(item) {
  	      var stamped = toNumber(getDeep(item, ["CostPerLitre"], NaN), NaN);
  	      if (!isNaN(stamped) && stamped > 0) return stamped;

  	      var litres = toNumber(getDeep(item, ["Litres"], 0), 0);
  	      var cost = toNumber(getDeep(item, ["Cost"], 0), 0);

  	      if (litres > 0 && cost > 0) return cost / litres;

  	      return 0;
  	    }

  	    function getTransactionSarsRebate(item) {
  	      return toNumber(
  	        firstDefined(
  	          getDeep(item, ["PotentialSARSRebate"], null),
  	          getDeep(item, ["SARSRebate"], null),
  	          0
  	        ),
  	        0
  	      );
  	    }

  	    function getTransactionRegistration(item) {
  	      return text(
  	        firstDefined(
  	          getDeep(item, ["Registration"], null),
  	          getDeep(item, ["Tractor", "Registration"], null),
  	          getDeep(item, ["Tractor", "Data", "Vehicle", "Registration", "value"], null)
  	        ),
  	        "Unspecified Registration"
  	      );
  	    }

  	    function getTransactionTractorHeading(item) {
  	      var tractorId = text(
  	        firstDefined(
  	          getDeep(item, ["TractorID"], null),
  	          getDeep(item, ["Tractor", "ID"], null),
  	          getDeep(item, ["ID"], null),
  	          getDeep(item, ["Tractor", "FID"], null)
  	        ),
  	        ""
  	      );

  	      var registration = text(
  	        firstDefined(
  	          getDeep(item, ["Registration"], null),
  	          getDeep(item, ["Tractor", "Registration"], null),
  	          getDeep(item, ["Tractor", "Data", "Vehicle", "Registration", "value"], null)
  	        ),
  	        ""
  	      );

  	      return tractorId && registration
  	      ? tractorId + " | " + registration: (tractorId || registration || "Unspecified Tractor");
  	    }

  	    function getTransactionDriver(item) {
  	      return text(
  	        firstDefined(
  	          getDeep(item, ["DriverName"], null),
  	          getDeep(item, ["DriverUser", "name"], null),
  	          getDeep(item, ["DriverUser", "Name"], null),
  	          getDeep(item, ["DriverLabel"], null),
  	          getDeep(item, ["DriverUser", "email"], null)
  	        ),
  	        "No driver"
  	      );
  	    }

  	    function getTransactionsForVehicle(items, vehicleObjectId) {
  	      var arr = sortTransactionsAsc(getActiveTransactionsOnly(items));
  	      var out = [];

  	      for (var i = 0; i < arr.length; i++) {
  	        var txVehicleId = firstDefined(
  	          getDeep(arr[i], ["Tractor", "objectId"], null),
  	          getDeep(arr[i], ["Tractor"], null) && typeof getDeep(arr[i], ["Tractor"], null) === "string"
  	          ? getDeep(arr[i], ["Tractor"], null): null
  	        );

  	        if (sameObjectId(txVehicleId, vehicleObjectId)) {
  	          out.push(arr[i]);
  	        }
  	      }

  	      return out;
  	    }

  	    function getLatestTransactionForVehicle(items, vehicleObjectId) {
  	      var arr = getTransactionsForVehicle(items, vehicleObjectId);
  	      return arr.length ? arr[arr.length - 1]: null;
  	    }

  	    function getLatestTransactionForBowser(items) {
  	      var arr = sortTransactionsAsc(getActiveTransactionsOnly(items));
  	      return arr.length ? arr[arr.length - 1]: null;
  	    }

  	    function getTransactionVehicleObjectId(item) {
  	      return firstDefined(
  	        getDeep(item, ["Tractor", "objectId"], null),
  	        getDeep(item, ["Tractor"], null) && typeof getDeep(item, ["Tractor"], null) === "string"
  	        ? getDeep(item, ["Tractor"], null): null
  	      );
  	    }

  	    function isLatestTransactionForBowser(targetItem, items) {
  	      var latest = getLatestTransactionForBowser(items);
  	      return !!(
  	        latest &&
  	        sameObjectId(
  	          getDeep(latest, ["objectId"], null),
  	          getDeep(targetItem, ["objectId"], null)
  	        )
  	      );
  	    }

  	    function isLatestTransactionForVehicle(targetItem, items) {
  	      var vehicleId = getTransactionVehicleObjectId(targetItem);
  	      if (!vehicleId) return false;

  	      var latest = getLatestTransactionForVehicle(items, vehicleId);
  	      return !!(
  	        latest &&
  	        sameObjectId(
  	          getDeep(latest, ["objectId"], null),
  	          getDeep(targetItem, ["objectId"], null)
  	        )
  	      );
  	    }

  	    function getEarliestTransactionForVehicle(items, vehicleObjectId) {
  	      var arr = getTransactionsForVehicle(items, vehicleObjectId);
  	      return arr.length ? arr[0]: null;
  	    }

  	    function buildVehicleViewSeed(dateObj) {
  	      return {
  	        ___class: "Tractorview",
  	        MYear: getMonthLabel(dateObj),
  	        MYearKey: getMYear(dateObj),
  	        DateStart: getMonthStartMs(dateObj),
  	        DateEnd: getMonthEndMs(dateObj),
  	        TransactionCount: 0,
  	        MeterStart: 0,
  	        MeterEnd: 0,
  	        Distance: 0,
  	        Litres: 0,
  	        Cost: 0,
  	        PotentialSARSRebate: 0
  	      };
  	    }

  	    function ensureBowserViewRow(targetBowser, openingMeter, dateObj) {
  	      var businessDate = dateObj ? getBusinessDate(dateObj): getBusinessNowDate();
  	      var mYear = getMYear(businessDate);
  	      var mYearLabel = getMonthLabel(businessDate);
  	      var oldView = getDeep(targetBowser, ["ViewC"], null);

  	      if (!oldView || getDeep(oldView, ["MYearKey"], "") !== mYear) {
  	        if (oldView && (getDeep(oldView, ["objectId"], null) || getDeep(oldView, ["MYear"], ""))) {
  	          targetBowser.ViewH = toArray(targetBowser.ViewH);
  	          targetBowser.ViewH.push(deepClone(oldView));
  	        }

  	        targetBowser.ViewC = {
  	          ___class: "BowserView",
  	          MYear: mYearLabel,
  	          MYearKey: mYear,
  	          DateStart: getMonthStartMs(businessDate),
  	          DateEnd: getMonthEndMs(businessDate),
  	          Litres: 0,
  	          MeterStart: toNumber(openingMeter, 0),
  	          MeterEnd: toNumber(openingMeter, 0)
  	        };
  	      } else {
  	        targetBowser.ViewC.Litres = toNumber(getDeep(targetBowser, ["ViewC", "Litres"], 0), 0);
  	        if (getDeep(targetBowser, ["ViewC", "MeterStart"], null) == null) targetBowser.ViewC.MeterStart = toNumber(openingMeter, 0);
  	        if (getDeep(targetBowser, ["ViewC", "MeterEnd"], null) == null) targetBowser.ViewC.MeterEnd = toNumber(openingMeter, 0);
  	        if (getDeep(targetBowser, ["ViewC", "DateStart"], null) == null) targetBowser.ViewC.DateStart = getMonthStartMs(businessDate);
  	        if (getDeep(targetBowser, ["ViewC", "DateEnd"], null) == null) targetBowser.ViewC.DateEnd = getMonthEndMs(businessDate);
  	        if (getDeep(targetBowser, ["ViewC", "MYearKey"], null) == null) targetBowser.ViewC.MYearKey = mYear;
  	        if (getDeep(targetBowser, ["ViewC", "MYear"], null) == null) targetBowser.ViewC.MYear = mYearLabel;
  	      }

  	      return targetBowser.ViewC;
  	    }

  	    function ensureVehicleViewRow(targetVehicle, dateObj) {
  	      var businessDate = dateObj ? getBusinessDate(dateObj): getBusinessNowDate();
  	      var mYear = getMYear(businessDate);
  	      var mYearLabel = getMonthLabel(businessDate);
  	      var currentView = getDeep(targetVehicle, ["ViewC"], null);
  	      var currentViewMonthKey = getDeep(currentView, ["MYearKey"], "");

  	      if (!currentView || currentViewMonthKey !== mYear) {
  	        if (currentView && (getDeep(currentView, ["objectId"], null) || getDeep(currentView, ["MYear"], ""))) {
  	          targetVehicle.ViewH = toArray(getDeep(targetVehicle, ["ViewH"], []));
  	          targetVehicle.ViewH.push(deepClone(currentView));
  	        }

  	        targetVehicle.ViewC = buildVehicleViewSeed(businessDate);
  	      } else {
  	        if (getDeep(currentView, ["MYearKey"], null) == null) currentView.MYearKey = mYear;
  	        if (getDeep(currentView, ["MYear"], null) == null) currentView.MYear = mYearLabel;
  	        if (getDeep(currentView, ["DateStart"], null) == null) currentView.DateStart = getMonthStartMs(businessDate);
  	        if (getDeep(currentView, ["DateEnd"], null) == null) currentView.DateEnd = getMonthEndMs(businessDate);
  	        if (getDeep(currentView, ["TransactionCount"], null) == null) currentView.TransactionCount = 0;
  	        if (getDeep(currentView, ["MeterStart"], null) == null) currentView.MeterStart = 0;
  	        if (getDeep(currentView, ["MeterEnd"], null) == null) currentView.MeterEnd = 0;
  	        if (getDeep(currentView, ["Distance"], null) == null) currentView.Distance = 0;
  	        if (getDeep(currentView, ["Litres"], null) == null) currentView.Litres = 0;
  	        if (getDeep(currentView, ["Cost"], null) == null) currentView.Cost = 0;
  	        if (getDeep(currentView, ["PotentialSARSRebate"], null) == null) currentView.PotentialSARSRebate = 0;
  	      }

  	      return targetVehicle.ViewC;
  	    }

  	    function recalcBowserViewFromTransactions(targetView, activeTransactions) {
  	      var arr = sortTransactionsAsc(getActiveTransactionsOnly(activeTransactions));
  	      var meterStart = toNumber(getDeep(targetView, ["MeterStart"], 0), 0);
  	      var litres = sumTransactionLitres(arr);
  	      var meterEnd = meterStart;

  	      if (arr.length) {
  	        meterEnd = toNumber(getDeep(arr[arr.length - 1], ["Meter"], meterStart), meterStart);
  	      }

  	      targetView.Litres = litres;
  	      targetView.MeterEnd = meterEnd;

  	      return targetView;
  	    }

  	    function recalcVehicleViewFromTransactions(targetVehicle, activeTransactions, dateObj, baselineMileage) {
  	      var arr = getTransactionsForVehicle(activeTransactions, getDeep(targetVehicle, ["objectId"], null));
  	      var effectiveDate = dateObj || getNowDate();
  	      var currentView = ensureVehicleViewRow(targetVehicle, effectiveDate);
  	      var baseline = toNumber(baselineMileage, 0);

  	      currentView.TransactionCount = arr.length;
  	      currentView.Litres = 0;
  	      currentView.Cost = 0;
  	      currentView.PotentialSARSRebate = 0;

  	      if (arr.length) {
  	        var firstTx = arr[0];
  	        var lastTx = arr[arr.length - 1];

  	        currentView.MeterStart = toNumber(
  	          firstDefined(
  	            getDeep(firstTx, ["MileageLast"], null),
  	            baseline,
  	            0
  	          ),
  	          0
  	        );

  	        currentView.MeterEnd = toNumber(
  	          firstDefined(
  	            getDeep(lastTx, ["Mileage"], null),
  	            getDeep(lastTx, ["MileageLast"], null),
  	            currentView.MeterStart
  	          ),
  	          currentView.MeterStart
  	        );

  	        currentView.Distance = currentView.MeterEnd - currentView.MeterStart;
  	        if (currentView.Distance < 0) currentView.Distance = 0;

  	        for (var i = 0; i < arr.length; i++) {
  	          currentView.Litres += toNumber(getDeep(arr[i], ["Litres"], 0), 0);
  	          currentView.Cost += toNumber(getDeep(arr[i], ["Cost"], 0), 0);
  	          currentView.PotentialSARSRebate += toNumber(getDeep(arr[i], ["PotentialSARSRebate"], 0), 0);
  	        }
  	      } else {
  	        currentView.MeterStart = baseline;
  	        currentView.MeterEnd = baseline;
  	        currentView.Distance = 0;
  	      }

  	      targetVehicle.ViewC = currentView;
  	      return currentView;
  	    }

  	    async function syncVehicleViewFuelRelations(vehicleViewObjectId, transactions) {
  	      if (!vehicleViewObjectId) return;

  	      var ids = [];
  	      var arr = getActiveTransactionsOnly(transactions);

  	      for (var i = 0; i < arr.length; i++) {
  	        var txId = getDeep(arr[i], ["objectId"], null);
  	        if (txId) ids.push(txId);
  	      }

  	      await setRelation("Tractorview", vehicleViewObjectId, "Fuel", ids);
  	    }

  	        function buildVehicleHistoryRelationIds(targetVehicle, currentViewObjectId) {
  	      var ids = [];
  	      var seen = {};
  	      var historyViews = toArray(getDeep(targetVehicle, ["ViewH"], []));

  	      for (var i = 0; i < historyViews.length; i++) {
  	        var historyId = getDeep(historyViews[i], ["objectId"], null);
  	        if (!historyId) continue;

  	        // Do not include the current ViewC in ViewH.
  	        if (currentViewObjectId && sameObjectId(historyId, currentViewObjectId)) continue;

  	        if (!seen[historyId]) {
  	          seen[historyId] = true;
  	          ids.push(historyId);
  	        }
  	      }

  	      return ids;
  	    }

  	    async function syncVehicleViewRelations(targetVehicle, savedCurrentView) {
  	      var vehicleObjectId = getDeep(targetVehicle, ["objectId"], null);
  	      var currentViewObjectId = getDeep(savedCurrentView, ["objectId"], null);

  	      if (!vehicleObjectId) {
  	        throw new Error("Cannot sync tractor view relations without tractor objectId.");
  	      }

  	      if (!currentViewObjectId) {
  	        throw new Error("Cannot sync tractor view relations without current view objectId.");
  	      }

  	      await setRelation("Tractors", vehicleObjectId, "ViewC", [currentViewObjectId]);

  	      var historyRelationIds = buildVehicleHistoryRelationIds(targetVehicle, currentViewObjectId);
  	      await setRelation("Tractors", vehicleObjectId, "ViewH", historyRelationIds);

  	      targetVehicle.ViewC = savedCurrentView;
  	    }

  	    async function loadFreshCurrentBowserView() {
  	      var currentViewId = getDeep(bowser, ["ViewC", "objectId"], null);
  	      if (!currentViewId) {
  	        throw new Error("Bowser current view is missing.");
  	      }

  	      return await loadTableRow("BowserView", currentViewId, [
  	        "FuelOut",
  	        "FuelOut.Tractor",
  	        "FuelOut.DriverUser",
  	        "FuelOut.Company",
  	        "FuelOut.Bowser",
  	        "FuelOut.Tank",
  	        "FuelOut.Contractor"
  	      ]);
  	    }

  	    async function rebuildBowserViewFromActiveTransactions(workingBowser, activeTransactions) {
  	      var workingBowserView = deepClone(getDeep(workingBowser, ["ViewC"], null));

  	      if (!workingBowserView || !getDeep(workingBowserView, ["objectId"], null)) {
  	        throw new Error("Bowser current view is missing.");
  	      }

  	      recalcBowserViewFromTransactions(workingBowserView, activeTransactions);
  	      var savedBowserView = await saveTableRow("BowserView", workingBowserView);

  	      workingBowser.ViewC = savedBowserView;
  	      workingBowser.Meter = toNumber(getDeep(savedBowserView, ["MeterEnd"], 0), 0);

  	      return savedBowserView;
  	    }

  	    async function rebuildVehicleViewForVehicle(vehicleId, activeTransactions, workingCompany) {
  	      var freshVehicle = deepClone(await loadTableRow("Tractors", vehicleId, ["ViewC", "ViewH"]));
  	      var vehicleChain = getTransactionsForVehicle(activeTransactions, vehicleId);
  	      var baselineMileage = vehicleChain.length
  	      ? toNumber(getDeep(vehicleChain[0], ["MileageLast"], 0), 0): toNumber(getDeep(freshVehicle, ["Mileage"], 0), 0);

  	      var viewDate = vehicleChain.length
  	      ? firstDefined(
  	        getDeep(vehicleChain[vehicleChain.length - 1], ["FuelDate"], null),
  	        getDeep(vehicleChain[vehicleChain.length - 1], ["created"], null),
  	        getNowIso()
  	      ): getNowIso();

  	      if (vehicleChain.length) {
  	        freshVehicle.Mileage = toNumber(
  	          firstDefined(
  	            getDeep(vehicleChain[vehicleChain.length - 1], ["Mileage"], null),
  	            getDeep(vehicleChain[vehicleChain.length - 1], ["MileageLast"], null),
  	            getDeep(freshVehicle, ["Mileage"], null),
  	            0
  	          ),
  	          0
  	        );
  	      }

  	      if (
  	        getDeep(freshVehicle, ["Data"], null) &&
  	        getDeep(freshVehicle, ["Data", "OperationalTargets"], null) &&
  	        getDeep(freshVehicle, ["Data", "OperationalTargets", "Fuel_Counter"], null)
  	      ) {
  	        freshVehicle.Data.OperationalTargets.Fuel_Counter.value = vehicleChain.length;
  	      }

  	      recalcVehicleViewFromTransactions(
  	        freshVehicle,
  	        activeTransactions,
  	        viewDate,
  	        baselineMileage
  	      );

  	      if (getDeep(freshVehicle, ["ViewC"], null)) {
  	        freshVehicle.ViewC = await saveTableRow("Tractorview", freshVehicle.ViewC);

  	        await syncVehicleViewFuelRelations(
  	          getDeep(freshVehicle, ["ViewC", "objectId"], null),
  	          vehicleChain
  	        );
  	      }

  	      await saveTableRow("Tractors", freshVehicle);

  	      if (getDeep(freshVehicle, ["ViewC", "objectId"], null)) {
  	        await syncVehicleViewRelations(freshVehicle, freshVehicle.ViewC);
  	      }

  	      if (workingCompany) {
  	        replaceNestedCompanyVehicle(workingCompany, freshVehicle);
  	      }

  	      return freshVehicle;
  	    }

  	    async function rebuildAffectedVehicleViews(vehicleIds, activeTransactions, workingCompany) {
  	      var ids = toArray(vehicleIds);
  	      var refreshedVehicleRows = {};

  	      for (var i = 0; i < ids.length; i++) {
  	        if (!ids[i]) continue;
  	        refreshedVehicleRows[ids[i]] = await rebuildVehicleViewForVehicle(ids[i], activeTransactions, workingCompany);
  	      }

  	      return refreshedVehicleRows;
  	    }

  	    function getVehicleTransactionChain(items, vehicleObjectId) {
  	      return getTransactionsForVehicle(items, vehicleObjectId);
  	    }

  	    function buildVehicleChainFromTransactions(items, vehicleObjectId) {
  	      var chain = getVehicleTransactionChain(items, vehicleObjectId);
  	      var repaired = [];

  	      for (var i = 0; i < chain.length; i++) {
  	        var prev = i > 0 ? chain[i - 1]: null;
  	        var row = deepClone(chain[i]);

  	        var prevMileage = toNumber(
  	          firstDefined(
  	            prev ? getDeep(prev, ["Mileage"], null): null,
  	            getDeep(row, ["MileageLast"], null),
  	            0
  	          ),
  	          0
  	        );

  	        var currentMileage = toNumber(
  	          firstDefined(
  	            getDeep(row, ["Mileage"], null),
  	            prevMileage
  	          ),
  	          prevMileage
  	        );

  	        row.MileageLast = prevMileage;
  	        row.Distance = currentMileage - prevMileage;
  	        if (row.Distance < 0) row.Distance = 0;

  	        repaired.push(row);
  	      }

  	      return repaired;
  	    }

  	    async function persistFuelOutChain(chainRows) {
  	      var arr = toArray(chainRows);
  	      var out = [];

  	      for (var i = 0; i < arr.length; i++) {
  	        out.push(await saveTableRow("FuelOut", arr[i]));
  	      }

  	      return out;
  	    }

  	    async function repairVehicleTransactionChain(vehicleObjectId, allTransactions) {
  	      if (!vehicleObjectId) return [];

  	      var repaired = buildVehicleChainFromTransactions(allTransactions, vehicleObjectId);
  	      return await persistFuelOutChain(repaired);
  	    }

  	    function getPreviousAndNextVehicleTransactions(items, targetItem, vehicleObjectId) {
  	      var chain = getVehicleTransactionChain(items, vehicleObjectId);
  	      var prev = null;
  	      var next = null;

  	      for (var i = 0; i < chain.length; i++) {
  	        if (sameObjectId(getDeep(chain[i], ["objectId"], null), getDeep(targetItem, ["objectId"], null))) {
  	          prev = i > 0 ? chain[i - 1]: null;
  	          next = i < chain.length - 1 ? chain[i + 1]: null;
  	          break;
  	        }
  	      }

  	      return {
  	        previous: prev,
  	        next: next
  	      };
  	    }

  	    function validateHistoricalMileageEdit(targetItem, vehicleObjectId, newMileage, allTransactions) {
  	      var pair = getPreviousAndNextVehicleTransactions(allTransactions, targetItem, vehicleObjectId);

  	      var previousMileage = toNumber(
  	        pair.previous ? getDeep(pair.previous, ["Mileage"], 0): getDeep(targetItem, ["MileageLast"], 0),
  	        0
  	      );

  	      var nextMileage = pair.next
  	      ? toNumber(getDeep(pair.next, ["Mileage"], 0), 0): null;

  	      if (newMileage < previousMileage) {
  	        throw new Error("Mileage cannot be lower than the previous transaction mileage.");
  	      }

  	      if (nextMileage !== null && newMileage > nextMileage) {
  	        throw new Error("Mileage cannot be greater than the next transaction mileage.");
  	      }

  	      return {
  	        previous: pair.previous,
  	        next: pair.next,
  	        previousMileage: previousMileage,
  	        nextMileage: nextMileage
  	      };
  	    }

  	    async function editHistoricalTransaction(targetItem, patch) {
  	      if (!targetItem || !getDeep(targetItem, ["objectId"], null)) {
  	        throw new Error("No transaction selected for edit.");
  	      }

  	      var freshBowserView = await loadFreshCurrentBowserView();
  	      var allTransactions = sortTransactionsAsc(
  	        getActiveTransactionsOnly(toArray(getDeep(freshBowserView, ["FuelOut"], [])))
  	      );

  	      var targetVehicleId = getTransactionVehicleObjectId(targetItem);
  	      var nextVehicleId = firstDefined(
  	        getDeep(patch, ["vehicleObjectId"], null),
  	        targetVehicleId
  	      );

  	      if (!targetVehicleId) {
  	        throw new Error("Original transaction vehicle is missing.");
  	      }

  	      var working = deepClone(await loadTableRow("FuelOut", getDeep(targetItem, ["objectId"], null), ["Tractor"]));

  	      if (patch && patch.mileage !== undefined && patch.mileage !== null && patch.mileage !== "") {
  	        var newMileage = toNumber(patch.mileage, NaN);
  	        if (isNaN(newMileage)) {
  	          throw new Error("Mileage edit value is invalid.");
  	        }

  	        validateHistoricalMileageEdit(working, targetVehicleId, newMileage, allTransactions);
  	        working.Mileage = newMileage;
  	      }

  	      if (nextVehicleId && !sameObjectId(nextVehicleId, targetVehicleId)) {
  	        working.Tractor = {
  	          objectId: nextVehicleId
  	        };

  	        if (patch.registration !== undefined) {
  	          working.Registration = patch.registration;
  	        }
  	      } else if (patch && patch.registration !== undefined && patch.registration !== null) {
  	        working.Registration = patch.registration;
  	      }

  	      await saveTableRow("FuelOut", working);

  	      var refreshedBowserView = await loadFreshCurrentBowserView();
  	      var refreshedTransactions = sortTransactionsAsc(
  	        getActiveTransactionsOnly(toArray(getDeep(refreshedBowserView, ["FuelOut"], [])))
  	      );

  	      await repairVehicleTransactionChain(targetVehicleId, refreshedTransactions);

  	      if (!sameObjectId(nextVehicleId, targetVehicleId)) {
  	        var repairedBowserView = await loadFreshCurrentBowserView();
  	        var repairedTransactions = sortTransactionsAsc(
  	          getActiveTransactionsOnly(toArray(getDeep(repairedBowserView, ["FuelOut"], [])))
  	        );
  	        await repairVehicleTransactionChain(nextVehicleId, repairedTransactions);
  	      }

  	      var finalBowserView = await loadFreshCurrentBowserView();
  	      var finalTransactions = sortTransactionsAsc(
  	        getActiveTransactionsOnly(toArray(getDeep(finalBowserView, ["FuelOut"], [])))
  	      );

  	      var workingBowser = deepClone(await loadTableRow("Bowsers", bowser.objectId, ["ViewC"]));
  	      var workingCompany = deepClone(await loadTableRow("Companies", company.objectId, ["Tanks", "Tractors"]));

  	      var savedBowserView = await rebuildBowserViewFromActiveTransactions(workingBowser, finalTransactions);
  	      await rebuildAffectedVehicleViews(
  	        sameObjectId(nextVehicleId, targetVehicleId)
  	        ? [targetVehicleId]: [targetVehicleId, nextVehicleId],
  	        finalTransactions,
  	        workingCompany
  	      );

  	      await Promise.all([
  	        saveTableRow("Bowsers", workingBowser)
  	      ]);

  	      // Do not save Companies or replace company.Tractors here.
  	      // Merge changed tractor rows into live AppData only.

  	      bowser.ViewC = savedBowserView;
  	      bowser.Meter = workingBowser.Meter;

  	      if (company) {
  	        syncCompanyIntoLiveAppData(workingCompany);
  	      }

  	      return {
  	        editedTransactionId: getDeep(working, ["objectId"], null),
  	        oldVehicleObjectId: targetVehicleId,
  	        newVehicleObjectId: nextVehicleId
  	      };
  	    }


  	    async function rollbackToTransaction(targetItem) {
  	      if (!targetItem || !getDeep(targetItem, ["objectId"], null)) {
  	        throw new Error("No transaction selected for rollback.");
  	      }

  	      if (isTransactionReversed(targetItem)) {
  	        throw new Error("This transaction has already been reversed.");
  	      }

  	      var selectedMeta = getSelectedBowserViewMeta();
  	      if (!selectedMeta || selectedMeta.kind !== "current") {
  	        throw new Error("Rollback is only allowed from the current live view.");
  	      }

  	      if (!bowser || !bowser.objectId) {
  	        throw new Error("Bowser object is missing.");
  	      }

  	      if (!tank || !tank.objectId) {
  	        throw new Error("Tank object is missing.");
  	      }

  	      if (!company || !company.objectId) {
  	        throw new Error("Company object is missing.");
  	      }

  	      var freshBowserView = await loadFreshCurrentBowserView();
  	      var allViewTransactions = sortTransactionsAsc(toArray(getDeep(freshBowserView, ["FuelOut"], [])));
  	      var activeTransactions = getActiveTransactionsOnly(allViewTransactions);

  	      if (!isLatestTransactionForBowser(targetItem, activeTransactions)) {
  	        throw new Error("Rollback blocked. Only the latest bowser transaction may be rolled back. Use edit instead.");
  	      }

  	      if (!isLatestTransactionForVehicle(targetItem, activeTransactions)) {
  	        throw new Error("Rollback blocked. Only the latest vehicle transaction may be rolled back. Use edit instead.");
  	      }

  	      var targetObjectId = getDeep(targetItem, ["objectId"], null);
  	      var targetVehicleId = getTransactionVehicleObjectId(targetItem);

  	      if (!targetVehicleId) {
  	        throw new Error("Target transaction vehicle is missing.");
  	      }

  	      var workingTank = deepClone(await loadTableRow("Tanks", tank.objectId, ["Bowsers"]));
  	      var workingBowser = deepClone(await loadTableRow("Bowsers", bowser.objectId, ["ViewC"]));
  	      var workingCompany = deepClone(await loadTableRow("Companies", company.objectId, ["Tanks", "Tractors"]));
  	      var workingVehicle = deepClone(await loadTableRow("Tractors", targetVehicleId, ["ViewC", "ViewH"]));

  	      var litresToRestore = toNumber(getDeep(targetItem, ["Litres"], 0), 0);
  	      var meterLast = toNumber(getDeep(targetItem, ["MeterLast"], 0), 0);
  	      var mileageLast = toNumber(getDeep(targetItem, ["MileageLast"], 0), 0);

  	      await deleteTableRow("FuelOut", targetObjectId);

  	      workingTank.Volume = toNumber(getDeep(workingTank, ["Volume"], 0), 0) + litresToRestore;

  	      var tankCapacity = toNumber(getDeep(workingTank, ["Capacity"], 0), 0);
  	      if (tankCapacity > 0) {
  	        workingTank.Level = (workingTank.Volume / tankCapacity) * 100;
  	        if (workingTank.Level < 0) workingTank.Level = 0;
  	        if (workingTank.Level > 100) workingTank.Level = 100;
  	      }

  	      workingBowser.Meter = meterLast;
  	      workingVehicle.Mileage = mileageLast;

  	      var refreshedBowserView = await loadFreshCurrentBowserView();
  	      var remainingTransactions = sortTransactionsAsc(
  	        getActiveTransactionsOnly(toArray(getDeep(refreshedBowserView, ["FuelOut"], [])))
  	      );

  	      var savedBowserView = await rebuildBowserViewFromActiveTransactions(workingBowser, remainingTransactions);
  	      await rebuildAffectedVehicleViews([targetVehicleId], remainingTransactions, workingCompany);

  	      var tankBowsers = toArray(getDeep(workingTank, ["Bowsers"], []));
  	      var tankBowserIndex = findIndexByKeys(tankBowsers, workingBowser);
  	      if (tankBowserIndex >= 0) {
  	        tankBowsers[tankBowserIndex] = deepClone(workingBowser);
  	        workingTank.Bowsers = tankBowsers;
  	      }

  	      replaceNestedCompanyTank(workingCompany, workingTank);

  	      await Promise.all([
  	        saveTableRow("Tanks", workingTank),
  	        saveTableRow("Bowsers", workingBowser)
  	      ]);

  	      tank.Volume = workingTank.Volume;
  	      tank.Level = workingTank.Level;

  	      // Do not assign tank.Bowsers here.
  	      // workingTank may not contain the full bowser/pump list.

  	      bowser.Meter = workingBowser.Meter;
  	      bowser.ViewC = savedBowserView;

  	      // Do not assign company.Tractors here.
  	      // Merge changed tractor rows only.

  	      syncTankIntoLiveAppData(workingTank);
  	      syncCompanyIntoLiveAppData(workingCompany);

  	      renderTankGauge(tankBlock, tank);

  	      return {
  	        deletedTransactionId: targetObjectId,
  	        litres: litresToRestore,
  	        vehicleObjectId: targetVehicleId
  	      };
  	    }

  	    function formatDatePretty(dateValue) {
  	      if (dateValue === null || dateValue === undefined || dateValue === "") return "";

  	      var rawValue = dateValue;
  	      var parsedDate = null;

  	      if (dateValue instanceof Date) {
  	        parsedDate = new Date(dateValue.getTime());
  	      } else if (typeof dateValue === "number") {
  	        parsedDate = new Date(dateValue);
  	      } else if (typeof dateValue === "string") {
  	        var trimmedValue = dateValue.trim();

  	        if (/^\d+$/.test(trimmedValue)) {
  	          parsedDate = new Date(Number(trimmedValue));
  	        } else {
  	          parsedDate = new Date(trimmedValue);
  	        }
  	      } else {
  	        parsedDate = new Date(dateValue);
  	      }

  	      if (!parsedDate || isNaN(parsedDate.getTime())) {
  	        return String(rawValue);
  	      }

  	      return parsedDate.getFullYear()
  	      + "-" + pad2(parsedDate.getMonth() + 1)
  	      + "-" + pad2(parsedDate.getDate())
  	      + " " + pad2(parsedDate.getHours())
  	      + ":" + pad2(parsedDate.getMinutes())
  	      + ":" + pad2(parsedDate.getSeconds());
  	    }

  	    function buildTransactionSearchIndex(item) {
  	      var parts = [
  	        getDeep(item, ["FuelDate"], ""),
  	        getDeep(item, ["Registration"], ""),
  	        getDeep(item, ["Application"], ""),
  	        getDeep(item, ["CaptureType"], ""),
  	        getDeep(item, ["Description"], ""),
  	        getDeep(item, ["ContractorName"], ""),
  	        getDeep(item, ["DriverName"], ""),
  	        getDeep(item, ["Litres"], ""),
  	        getDeep(item, ["Cost"], ""),
  	        getDeep(item, ["CostPerLitre"], ""),
  	        getDeep(item, ["PotentialSARSRebate"], ""),
  	        getDeep(item, ["Meter"], ""),
  	        getDeep(item, ["MeterLast"], ""),
  	        getDeep(item, ["Mileage"], ""),
  	        getDeep(item, ["MileageLast"], ""),
  	        getDeep(item, ["Distance"], ""),
  	        isTransactionReversed(item) ? "reversed": "active",
  	        getDeep(item, ["TractorID"], ""),
  	        getDeep(item, ["Tractor", "ID"], ""),
  	        getDeep(item, ["Tractor", "FID"], ""),
  	        getDeep(item, ["Tractor", "Registration"], ""),
  	        getDeep(item, ["DriverUser", "name"], ""),
  	        getDeep(item, ["DriverUser", "Name"], ""),
  	        getDeep(item, ["DriverUser", "email"], "")
  	      ];

  	      return parts.join(" ").toLowerCase();
  	    }

  	    function buildDetailRow(label, value) {
  	      return ""
  	      + '<div style="display:grid;grid-template-columns:160px 1fr;gap:10px;padding:7px 0;border-bottom:1px solid rgba(255,255,255,0.06);">'
  	      + '<div style="font-size:11px;color:#94a3b8;">' + escapeHtml(label) + "</div>"
  	      + '<div style="font-size:12px;color:#f8fafc;word-break:break-word;">' + escapeHtml(text(value, "")) + "</div>"
  	      + "</div>";
  	    }

  	    function getFilteredTotals(transactions) {
  	      var arr = toArray(transactions);
  	      var litres = 0;
  	      var cost = 0;
  	      var rebate = 0;
  	      var meterMin = null;
  	      var meterMax = null;

  	      for (var i = 0; i < arr.length; i++) {
  	        var item = arr[i];
  	        var rowLitres = toNumber(getDeep(item, ["Litres"], 0), 0);
  	        var rowCost = toNumber(getDeep(item, ["Cost"], 0), 0);
  	        var rowRebate = toNumber(getDeep(item, ["PotentialSARSRebate"], 0), 0);
  	        var meterLast = toNumber(getDeep(item, ["MeterLast"], NaN), NaN);
  	        var meter = toNumber(getDeep(item, ["Meter"], NaN), NaN);

  	        litres += rowLitres;
  	        cost += rowCost;
  	        rebate += rowRebate;

  	        if (!isNaN(meterLast)) {
  	          if (meterMin === null || meterLast < meterMin) meterMin = meterLast;
  	        }

  	        if (!isNaN(meter)) {
  	          if (meterMax === null || meter > meterMax) meterMax = meter;
  	        }
  	      }

  	      return {
  	        count: arr.length,
  	        litres: litres,
  	        cost: cost,
  	        rebate: rebate,
  	        meterStart: meterMin === null ? 0: meterMin,
  	        meterEnd: meterMax === null ? 0: meterMax
  	      };
  	    }

  	    function openPrintWindow() {
  	      try {
  	        var selectedTransactions = toArray(state.filteredTransactions);
  	        var selectedViewMeta = getSelectedBowserViewMeta();
  	        var selectedViewName = selectedViewMeta && selectedViewMeta.view
  	        ? text(getDeep(selectedViewMeta.view, ["MYear"], ""), ""): "";
  	        var searchTerm = String(state.searchTerm || "").trim();
  	        var totals = getFilteredTotals(selectedTransactions);

  	        if (!selectedTransactions.length) {
  	          alert("There are no visible transactions to print.");
  	          return;
  	        }

  	        var printWin = window.open("", "_blank", "width=1280,height=900");
  	        if (!printWin) {
  	          alert("Print window was blocked by the browser.");
  	          return;
  	        }

  	        var logoHtml = "";
  	        if (svgLogo) {
  	          logoHtml = '<img src="' + escapeHtml(svgLogo) + '" alt="Logo" style="max-height:68px;max-width:240px;object-fit:contain;display:block;">';
  	        }

  	        var rowsHtml = "";
  	        for (var i = 0; i < selectedTransactions.length; i++) {
  	          var item = selectedTransactions[i];
  	          rowsHtml += ""
  	          + "<tr>"
  	          + "<td>" + escapeHtml(formatDatePretty(getDeep(item, ["FuelDate"], ""))) + "</td>"
  	          + "<td>" + escapeHtml(getTransactionRegistration(item)) + "</td>"
  	          + "<td>" + escapeHtml(getTransactionDriver(item)) + "</td>"
  	          + "<td>" + escapeHtml(text(getDeep(item, ["Application"], ""), "")) + "</td>"
  	          + "<td>" + escapeHtml(text(getDeep(item, ["CaptureType"], ""), "")) + "</td>"
  	          + "<td>" + escapeHtml(isTransactionReversed(item) ? "Reversed": "Active") + "</td>"
  	          + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["Litres"], 0), 2)) + "</td>"
  	          + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["CostPerLitre"], getTransactionUnitCost(item)), 2)) + "</td>"
  	          + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["Cost"], 0), 2)) + "</td>"
  	          + "<td class='num'>" + escapeHtml(displayNumber(getTransactionSarsRebate(item), 2)) + "</td>"
  	          + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["MeterLast"], 0), 2)) + "</td>"
  	          + "<td class='num'>" + escapeHtml(displayNumber(getDeep(item, ["Meter"], 0), 2)) + "</td>"
  	          + "<td>" + escapeHtml(text(getDeep(item, ["Description"], ""), "")) + "</td>"
  	          + "</tr>";
  	        }

  	        var reportTitle = "Fuel Transactions Report";
  	        var reportSubTitle = selectedViewName ? ("View: " + selectedViewName): "View: Not specified";
  	        var filterLabel = searchTerm ? ('Filtered by: "' + searchTerm + '"'): "Filter: None";
  	        var generatedAt = formatDatePretty(new Date().toISOString());
  	        var companyLabel = text(getDeep(company, ["CompanyId"], ""), "");
  	        var bowserLabel = text(firstDefined(getDeep(bowser, ["Name"], null), getDeep(bowser, ["Pump"], null)), "Bowser");
  	        var tankLabel = text(getDeep(tank, ["Grade"], ""), "");
  	        var meterStartText = displayNumber(totals.meterStart, 2);
  	        var meterEndText = displayNumber(totals.meterEnd, 2);
  	        var litresText = displayNumber(totals.litres, 2);
  	        var costText = formatCurrency(totals.cost);
  	        var rebateText = formatCurrency(totals.rebate);

  	        var html = ""
  	        + "<!doctype html>"
  	        + "<html>"
  	        + "<head>"
  	        + '<meta charset="utf-8">'
  	        + "<title>" + escapeHtml(reportTitle) + "</title>"
  	        + "<style>"
  	        + "html,body{margin:0;padding:0;background:#ffffff;color:#111827;font-family:Arial,sans-serif;}"
  	        + "body{padding:28px 30px 36px 30px;}"
  	        + ".header{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;border-bottom:2px solid #111827;padding-bottom:14px;margin-bottom:18px;}"
  	        + ".title{font-size:24px;font-weight:700;line-height:1.1;margin:0;}"
  	        + ".subtitle{font-size:12px;color:#4b5563;margin-top:6px;}"
  	        + ".meta{font-size:12px;color:#374151;line-height:1.6;margin-top:10px;}"
  	        + ".summary-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:12px;margin:18px 0 18px 0;}"
  	        + ".summary-card{border:1px solid #d1d5db;border-radius:8px;padding:12px;background:#f9fafb;}"
  	        + ".summary-label{font-size:11px;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;}"
  	        + ".summary-value{font-size:18px;font-weight:700;color:#111827;margin-top:6px;}"
  	        + ".section-title{font-size:14px;font-weight:700;color:#111827;margin:18px 0 10px 0;}"
  	        + "table{width:100%;border-collapse:collapse;table-layout:fixed;}"
  	        + "thead th{background:#111827;color:#ffffff;font-size:11px;text-transform:uppercase;letter-spacing:.04em;padding:10px 8px;border:1px solid #0f172a;text-align:left;}"
  	        + "tbody td{font-size:11px;color:#111827;padding:8px;border:1px solid #d1d5db;vertical-align:top;word-wrap:break-word;}"
  	        + ".num{text-align:right;font-variant-numeric:tabular-nums;}"
  	        + ".footer{margin-top:18px;font-size:10px;color:#6b7280;border-top:1px solid #d1d5db;padding-top:10px;}"
  	        + "@media print{"
  	        + "  body{padding:18px 20px 22px 20px;}"
  	        + "  .summary-card{break-inside:avoid;}"
  	        + "  tr, td, th{page-break-inside:avoid;}"
  	        + "}"
  	        + "</style>"
  	        + "</head>"
  	        + "<body>"
  	        + '<div class="header">'
  	        + '  <div style="flex:1;min-width:0;">'
  	        + '    <h1 class="title">' + escapeHtml(reportTitle) + "</h1>"
  	        + '    <div class="subtitle">' + escapeHtml(reportSubTitle) + "</div>"
  	        + '    <div class="meta">'
  	        + "      <div><strong>Company:</strong> " + escapeHtml(companyLabel || "-") + "</div>"
  	        + "      <div><strong>Bowser:</strong> " + escapeHtml(bowserLabel || "-") + "</div>"
  	        + "      <div><strong>Tank:</strong> " + escapeHtml(tankLabel || "-") + "</div>"
  	        + "      <div><strong>Generated:</strong> " + escapeHtml(generatedAt) + "</div>"
  	        + "      <div><strong>" + escapeHtml(filterLabel) + "</strong></div>"
  	        + "    </div>"
  	        + "  </div>"
  	        + '  <div style="width:260px;display:flex;justify-content:flex-end;align-items:flex-start;">'
  	        + logoHtml
  	        + "  </div>"
  	        + "</div>"

  	        + '<div class="summary-grid">'
  	        + '  <div class="summary-card">'
  	        + '    <div class="summary-label">Transactions</div>'
  	        + '    <div class="summary-value">' + escapeHtml(String(totals.count)) + "</div>"
  	        + "  </div>"
  	        + '  <div class="summary-card">'
  	        + '    <div class="summary-label">Litres</div>'
  	        + '    <div class="summary-value">' + escapeHtml(litresText) + "</div>"
  	        + "  </div>"
  	        + '  <div class="summary-card">'
  	        + '    <div class="summary-label">Cost</div>'
  	        + '    <div class="summary-value">' + escapeHtml(costText) + "</div>"
  	        + "  </div>"
  	        + '  <div class="summary-card">'
  	        + '    <div class="summary-label">Potential Rebate</div>'
  	        + '    <div class="summary-value">' + escapeHtml(rebateText) + "</div>"
  	        + "  </div>"
  	        + '  <div class="summary-card">'
  	        + '    <div class="summary-label">Meter Start</div>'
  	        + '    <div class="summary-value">' + escapeHtml(meterStartText) + "</div>"
  	        + "  </div>"
  	        + '  <div class="summary-card">'
  	        + '    <div class="summary-label">Meter End</div>'
  	        + '    <div class="summary-value">' + escapeHtml(meterEndText) + "</div>"
  	        + "  </div>"
  	        + "</div>"

  	        + '<div class="section-title">Transactions</div>'
  	        + "<table>"
  	        + "<thead>"
  	        + "<tr>"
  	        + "<th style='width:120px;'>Date</th>"
  	        + "<th style='width:120px;'>Registration</th>"
  	        + "<th style='width:120px;'>Driver</th>"
  	        + "<th style='width:110px;'>Application</th>"
  	        + "<th style='width:90px;'>Type</th>"
  	        + "<th style='width:80px;'>Status</th>"
  	        + "<th style='width:70px;text-align:right;'>Litres</th>"
  	        + "<th style='width:70px;text-align:right;'>R/L</th>"
  	        + "<th style='width:85px;text-align:right;'>Cost</th>"
  	        + "<th style='width:85px;text-align:right;'>Rebate</th>"
  	        + "<th style='width:80px;text-align:right;'>Meter Last</th>"
  	        + "<th style='width:80px;text-align:right;'>Meter</th>"
  	        + "<th>Description</th>"
  	        + "</tr>"
  	        + "</thead>"
  	        + "<tbody>"
  	        + rowsHtml
  	        + "</tbody>"
  	        + "</table>"

  	        + '<div class="footer">'
  	        + "This report reflects the transactions currently visible on screen at the time of printing. "
  	        + "If a search filter is active, totals and rows are limited to the filtered result set."
  	        + "</div>"

  	        + '<script>'
  	        + "window.onload=function(){setTimeout(function(){window.print();},250);};"
  	        + "</script>"
  	        + "</body>"
  	        + "</html>";

  	        printWin.document.open();
  	        printWin.document.write(html);
  	        printWin.document.close();
  	      } catch (printErr) {
  	        console.log("Print / PDF error:", printErr);
  	        alert("Print failed: " + (printErr && printErr.message ? printErr.message: printErr));
  	      }
  	    }

  	    function openSingleTransactionPrintWindow(item) {
  	      try {
  	        if (!item) {
  	          alert("No transaction selected.");
  	          return;
  	        }

  	        var printWin = window.open("", "_blank", "width=1100,height=850");
  	        if (!printWin) {
  	          alert("Print window was blocked by the browser.");
  	          return;
  	        }

  	        var logoHtml = "";
  	        if (svgLogo) {
  	          logoHtml = '<img src="' + escapeHtml(svgLogo) + '" alt="Logo" style="max-height:68px;max-width:240px;object-fit:contain;display:block;">';
  	        }

  	        var fuelDate = formatDatePretty(getDeep(item, ["FuelDate"], ""));
  	        var tractorHeading = getTransactionTractorHeading(item);
  	        var registration = getTransactionRegistration(item);
  	        var driver = getTransactionDriver(item);
  	        var captureType = text(getDeep(item, ["CaptureType"], ""), "");
  	        var application = text(getDeep(item, ["Application"], ""), "");
  	        var description = text(getDeep(item, ["Description"], ""), "");
  	        var contractorName = text(getDeep(item, ["ContractorName"], ""), "");
  	        var litres = toNumber(getDeep(item, ["Litres"], 0), 0);
  	        var cost = toNumber(getDeep(item, ["Cost"], 0), 0);
  	        var costPerLitre = getTransactionUnitCost(item);
  	        var sarsRebate = getTransactionSarsRebate(item);
  	        var sarsCompliance = firstDefined(getDeep(item, ["SARSCompliance"], null), false) ? "Yes": "No";
  	        var mileage = text(getDeep(item, ["Mileage"], ""), "");
  	        var mileageLast = text(getDeep(item, ["MileageLast"], ""), "");
  	        var distance = text(getDeep(item, ["Distance"], ""), "");
  	        var meter = displayNumber(getDeep(item, ["Meter"], 0), 2);
  	        var meterLast = displayNumber(getDeep(item, ["MeterLast"], 0), 2);
  	        var tolerance = displayNumber(getDeep(item, ["Tolerance"], 0), 2);
  	        var rollbackStatus = isTransactionReversed(item) ? "Reversed": "Active";
  	        var companyLabel = text(getDeep(company, ["CompanyId"], ""), "");
  	        var bowserLabel = text(firstDefined(getDeep(bowser, ["Name"], null), getDeep(bowser, ["Pump"], null)), "Bowser");
  	        var tankLabel = text(getDeep(tank, ["Grade"], ""), "");
  	        var generatedAt = formatDatePretty(new Date().toISOString());

  	        var html = ""
  	        + "<!doctype html>"
  	        + "<html>"
  	        + "<head>"
  	        + '<meta charset="utf-8">'
  	        + "<title>Fuel Transaction</title>"
  	        + "<style>"
  	        + "html,body{margin:0;padding:0;background:#ffffff;color:#111827;font-family:Arial,sans-serif;}"
  	        + "body{padding:28px 30px 36px 30px;}"
  	        + ".header{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;border-bottom:2px solid #111827;padding-bottom:14px;margin-bottom:18px;}"
  	        + ".title{font-size:24px;font-weight:700;line-height:1.1;margin:0;}"
  	        + ".subtitle{font-size:12px;color:#4b5563;margin-top:6px;}"
  	        + ".meta{font-size:12px;color:#374151;line-height:1.6;margin-top:10px;}"
  	        + ".grid{display:grid;grid-template-columns:repeat(2,1fr);gap:16px;margin-top:18px;}"
  	        + ".card{border:1px solid #d1d5db;border-radius:10px;padding:14px;background:#f9fafb;break-inside:avoid;}"
  	        + ".card-title{font-size:13px;font-weight:700;color:#111827;margin-bottom:8px;}"
  	        + ".row{display:grid;grid-template-columns:160px 1fr;gap:12px;padding:7px 0;border-bottom:1px solid #e5e7eb;}"
  	        + ".label{font-size:11px;color:#6b7280;}"
  	        + ".value{font-size:12px;color:#111827;font-weight:600;word-break:break-word;}"
  	        + ".footer{margin-top:18px;font-size:10px;color:#6b7280;border-top:1px solid #d1d5db;padding-top:10px;}"
  	        + "@media print{body{padding:18px 20px 22px 20px;}}"
  	        + "</style>"
  	        + "</head>"
  	        + "<body>"
  	        + '<div class="header">'
  	        + '  <div style="flex:1;min-width:0;">'
  	        + '    <h1 class="title">Fuel Transaction</h1>'
  	        + '    <div class="subtitle">' + escapeHtml(registration) + "</div>"
  	        + '    <div class="meta">'
  	        + "      <div><strong>Company:</strong> " + escapeHtml(companyLabel || "-") + "</div>"
  	        + "      <div><strong>Bowser:</strong> " + escapeHtml(bowserLabel || "-") + "</div>"
  	        + "      <div><strong>Tank:</strong> " + escapeHtml(tankLabel || "-") + "</div>"
  	        + "      <div><strong>Generated:</strong> " + escapeHtml(generatedAt) + "</div>"
  	        + "    </div>"
  	        + "  </div>"
  	        + '  <div style="width:260px;display:flex;justify-content:flex-end;align-items:flex-start;">'
  	        + logoHtml
  	        + "  </div>"
  	        + "</div>"

  	        + '<div class="grid">'
  	        + '  <div class="card">'
  	        + '    <div class="card-title">Capture</div>'
  	        + '    <div class="row"><div class="label">Fuel Date</div><div class="value">' + escapeHtml(fuelDate) + "</div></div>"
  	        + '    <div class="row"><div class="label">Tractor</div><div class="value">' + escapeHtml(tractorHeading) + "</div></div>"
  	        + '    <div class="row"><div class="label">Capture Type</div><div class="value">' + escapeHtml(captureType) + "</div></div>"
  	        + '    <div class="row"><div class="label">Application</div><div class="value">' + escapeHtml(application) + "</div></div>"
  	        + '    <div class="row"><div class="label">Registration</div><div class="value">' + escapeHtml(registration) + "</div></div>"
  	        + '    <div class="row"><div class="label">Driver</div><div class="value">' + escapeHtml(driver) + "</div></div>"
  	        + '    <div class="row"><div class="label">Contractor</div><div class="value">' + escapeHtml(contractorName) + "</div></div>"
  	        + '    <div class="row"><div class="label">Description</div><div class="value">' + escapeHtml(description) + "</div></div>"
  	        + '    <div class="row"><div class="label">Status</div><div class="value">' + escapeHtml(rollbackStatus) + "</div></div>"
  	        + "  </div>"

  	        + '  <div class="card">'
  	        + '    <div class="card-title">Figures</div>'
  	        + '    <div class="row"><div class="label">Litres</div><div class="value">' + escapeHtml(displayNumber(litres, 2)) + "</div></div>"
  	        + '    <div class="row"><div class="label">Cost Per Litre</div><div class="value">' + escapeHtml(formatCurrency(costPerLitre)) + "</div></div>"
  	        + '    <div class="row"><div class="label">Cost</div><div class="value">' + escapeHtml(formatCurrency(cost)) + "</div></div>"
  	        + '    <div class="row"><div class="label">SARS Compliant</div><div class="value">' + escapeHtml(sarsCompliance) + "</div></div>"
  	        + '    <div class="row"><div class="label">Potential SARS Rebate</div><div class="value">' + escapeHtml(formatCurrency(sarsRebate)) + "</div></div>"
  	        + '    <div class="row"><div class="label">Mileage</div><div class="value">' + escapeHtml(mileage) + "</div></div>"
  	        + '    <div class="row"><div class="label">Mileage Last</div><div class="value">' + escapeHtml(mileageLast) + "</div></div>"
  	        + '    <div class="row"><div class="label">Distance</div><div class="value">' + escapeHtml(distance) + "</div></div>"
  	        + '    <div class="row"><div class="label">Meter</div><div class="value">' + escapeHtml(meter) + "</div></div>"
  	        + '    <div class="row"><div class="label">Meter Last</div><div class="value">' + escapeHtml(meterLast) + "</div></div>"
  	        + '    <div class="row"><div class="label">Tolerance</div><div class="value">' + escapeHtml(tolerance) + "</div></div>"
  	        + "  </div>"
  	        + "</div>"

  	        + '<div class="footer">This printout reflects the selected transaction only.</div>'
  	        + '<script>window.onload=function(){setTimeout(function(){window.print();},250);};</script>'
  	        + "</body>"
  	        + "</html>";

  	        printWin.document.open();
  	        printWin.document.write(html);
  	        printWin.document.close();
  	      } catch (printErr) {
  	        console.log("Single transaction print error:", printErr);
  	        alert("Single transaction print failed: " + (printErr && printErr.message ? printErr.message: printErr));
  	      }
  	    }

  	    var state = {
  	      transactionCache: [],
  	      filteredTransactions: [],
  	      selectedTransaction: null,
  	      selectedHydratedView: null,
  	      searchTerm: ""
  	    };

  	    var companyId = text(getDeep(company, ["CompanyId"], ""), "");
  	    var bowserName = text(firstDefined(getDeep(bowser, ["Name"], null), getDeep(bowser, ["Pump"], null)), "Bowser");
  	    var tankDeviceId = text(getDeep(tank, ["DeviceId"], ""), "");
  	    var tankGrade = text(getDeep(tank, ["Grade"], ""), "");

  	    var subtitleParts = [];
  	    if (bowserName) subtitleParts.push(bowserName);
  	    if (tankDeviceId) subtitleParts.push(tankDeviceId);
  	    if (tankGrade) subtitleParts.push(tankGrade);
  	    if (companyId) subtitleParts.push(companyId);
  	    var subtitle = subtitleParts.join(" | ");

  	    var companyApplications = toArray(getDeep(company, ["Manifest", "Applications"], []));
  	    var companyTractors = toArray(getDeep(company, ["Tractors"], []));
  	    var companyEmployees = toArray(getDeep(company, ["Employees"], []));
  	    var contractors = toArray(contractorsInput);

  	    var applicationOptions = optionWithOtherFirst(
  	      uniqueByValue(
  	        companyApplications.map(function (app, index) {
  	          return normalizeOption(text(app, "APP_" + (index + 1)), text(app, "Application " + (index + 1)), app);
  	        })
  	      ),
  	      "Other"
  	    );

  	    var companyVehicleOptions = optionWithOtherFirst(
  	      buildVehicleOptions(companyTractors, "COMPANY_VEHICLE"),
  	      "Other"
  	    );

  	    var driverOptions = optionWithOtherFirst(
  	      buildEmployeeOptions(companyEmployees),
  	      "Other"
  	    );

  	    var contractorOptions = optionWithOtherFirst(
  	      buildContractorOptions(contractors),
  	      "Other"
  	    );

  	    var existing = document.getElementById("fuel-capture-overlay");
  	    if (existing) existing.remove();

  	    var overlay = document.createElement("div");
  	    overlay.id = "fuel-capture-overlay";
  	    overlay.style.position = "fixed";
  	    overlay.style.inset = "0";
  	    overlay.style.zIndex = "999999";
  	    overlay.style.display = "flex";
  	    overlay.style.alignItems = "center";
  	    overlay.style.justifyContent = "center";
  	    overlay.style.background = "rgba(0,0,0,0.40)";
  	    overlay.style.backdropFilter = "blur(2px)";
  	    overlay.style.padding = "14px";
  	    overlay.style.boxSizing = "border-box";

  	    var modal = document.createElement("div");
  	    modal.id = "fuel-capture-modal";
  	    modal.style.width = "calc(100vw - 28px)";
  	    modal.style.height = "calc(100vh - 28px)";
  	    modal.style.maxWidth = "none";
  	    modal.style.maxHeight = "none";
  	    modal.style.background = "linear-gradient(180deg, rgba(5,10,18,0.96) 0%, rgba(10,16,24,0.94) 100%)";
  	    modal.style.borderRadius = "18px";
  	    modal.style.overflow = "hidden";
  	    modal.style.boxShadow = "0 18px 50px rgba(0,0,0,0.38)";
  	    modal.style.display = "flex";
  	    modal.style.flexDirection = "column";
  	    modal.style.color = "#f8fafc";
  	    modal.style.fontFamily = "Arial, sans-serif";
  	    modal.style.border = "1px solid rgba(255,255,255,0.06)";

  	    modal.innerHTML = ""
  	    + "<style>"
  	    + ".fuel-dark-select{appearance:none;-webkit-appearance:none;-moz-appearance:none;background:#d1d5db;color:#0f172a;}"
  	    + ".fuel-dark-select option{background:#0f172a;color:#f8fafc;}"
  	    + ".fuel-soft-input{width:100%;height:42px;border-radius:10px;border:none;background:#d1d5db;color:#0f172a;padding:0 12px;font-size:14px;box-sizing:border-box;}"
  	    + ".fuel-error-text{display:none;margin-top:4px;font-size:11px;color:#ff7b7b;}"
  	    + ".fuel-help-text{display:none;margin-top:4px;font-size:11px;color:#94a3b8;}"
  	    + ".fuel-tx-item:hover{background:rgba(255,255,255,0.085)!important;transform:translateY(-1px);}"
  	    + ".fuel-tx-item{transition:all 140ms ease;}"
  	    + ".fuel-detail-backdrop{position:absolute;inset:0;background:rgba(0,0,0,0.45);display:none;align-items:center;justify-content:center;padding:18px;box-sizing:border-box;z-index:20;}"
  	    + ".fuel-detail-card{width:min(900px,100%);max-height:100%;overflow:auto;background:linear-gradient(180deg, rgba(12,18,28,0.98) 0%, rgba(9,14,22,0.98) 100%);border:1px solid rgba(255,255,255,0.08);border-radius:16px;box-shadow:0 18px 50px rgba(0,0,0,0.45);}"
  	    + "</style>"

  	    + '<div style="padding:16px 16px 10px 16px;border-bottom:1px solid rgba(255,255,255,0.06);display:flex;justify-content:space-between;align-items:flex-start;gap:10px;">'
  	    + '<div style="min-width:0;">'
  	    + '<div style="font-size:16px;font-weight:700;line-height:1.1;">Fuel Capture</div>'
  	    + '<div style="margin-top:4px;font-size:11px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(subtitle) + "</div>"
  	    + "</div>"
  	    + '<button id="fuel-capture-close" type="button" style="background:none;border:none;color:#ff3b30;font-size:28px;line-height:1;cursor:pointer;padding:0 2px;">X</button>'
  	    + "</div>"

  	    + '<div style="display:flex;gap:8px;padding:10px 14px 0 14px;">'
  	    + '<button id="fuel-tab-capture" type="button" style="flex:1;height:38px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.04);color:#dbe4ee;font-size:13px;font-weight:700;cursor:pointer;">Capture</button>'
  	    + '<button id="fuel-tab-transactions" type="button" style="flex:1;height:38px;border:none;border-radius:10px;background:#f97316;color:#fff;font-size:13px;font-weight:700;cursor:pointer;">Transactions</button>'
  	    + "</div>"

  	    + '<div style="position:relative;flex:1;min-height:0;">'

  	    + '<div id="fuel-capture-panel" style="display:none;position:absolute;inset:0;padding:18px;overflow:auto;">'
  	    + '<div style="max-width:980px;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;">'

  	    + '<div id="row-capture-type" style="grid-column:1 / span 2;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Capture Type</label>'
  	    + '<select id="fuel-capture-type" class="fuel-dark-select" style="width:100%;height:46px;border-radius:10px;border:1px solid #f97316;padding:0 12px;font-size:14px;box-sizing:border-box;">'
  	    + '<option value="company">Company Vehicles</option>'
  	    + '<option value="contractor">Contractor Vehicles</option>'
  	    + '<option value="intertank">Intertank Fill</option>'
  	    + '<option value="other">Other</option>'
  	    + "</select>"
  	    + "</div>"

  	    + '<div id="row-company-application" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Application</label>'
  	    + '<select id="fuel-company-application" class="fuel-dark-select fuel-soft-input">'
  	    + buildOptionsHtml(applicationOptions, "Select application", "")
  	    + "</select>"
  	    + "</div>"

  	    + '<div id="row-company-application-other" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Application (Other)</label>'
  	    + '<input id="fuel-company-application-other" type="text" placeholder="Type application" class="fuel-soft-input">'
  	    + "</div>"

  	    + '<div id="row-company-registration" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Registration</label>'
  	    + '<select id="fuel-company-registration" class="fuel-dark-select fuel-soft-input">'
  	    + buildOptionsHtml(companyVehicleOptions, "Select registration", "")
  	    + "</select>"
  	    + "</div>"

  	    + '<div id="row-company-registration-other" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Registration (Other)</label>'
  	    + '<input id="fuel-company-registration-other" type="text" placeholder="Type registration" class="fuel-soft-input">'
  	    + "</div>"

  	    + '<div id="row-company-driver" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Driver</label>'
  	    + '<select id="fuel-company-driver" class="fuel-dark-select fuel-soft-input">'
  	    + buildOptionsHtml(driverOptions, "Select driver", "")
  	    + "</select>"
  	    + "</div>"

  	    + '<div id="row-company-driver-other" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Driver (Other)</label>'
  	    + '<input id="fuel-company-driver-other" type="text" placeholder="Type driver" class="fuel-soft-input">'
  	    + "</div>"

  	    + '<div id="row-contractor-name" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Contractor</label>'
  	    + '<select id="fuel-contractor-name" class="fuel-dark-select fuel-soft-input">'
  	    + buildOptionsHtml(contractorOptions, "Select contractor", "")
  	    + "</select>"
  	    + "</div>"

  	    + '<div id="row-contractor-name-other" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Contractor (Other)</label>'
  	    + '<input id="fuel-contractor-name-other" type="text" placeholder="Type contractor" class="fuel-soft-input">'
  	    + "</div>"

  	    + '<div id="row-contractor-application" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Application</label>'
  	    + '<select id="fuel-contractor-application" class="fuel-dark-select fuel-soft-input">'
  	    + buildOptionsHtml(applicationOptions, "Select application", "")
  	    + "</select>"
  	    + "</div>"

  	    + '<div id="row-contractor-application-other" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Application (Other)</label>'
  	    + '<input id="fuel-contractor-application-other" type="text" placeholder="Type application" class="fuel-soft-input">'
  	    + "</div>"

  	    + '<div id="row-contractor-registration" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Registration</label>'
  	    + '<select id="fuel-contractor-registration" class="fuel-dark-select fuel-soft-input">'
  	    + '<option value="">Select registration</option>'
  	    + "</select>"
  	    + "</div>"

  	    + '<div id="row-contractor-registration-other" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Registration (Other)</label>'
  	    + '<input id="fuel-contractor-registration-other" type="text" placeholder="Type registration" class="fuel-soft-input">'
  	    + "</div>"

  	    + '<div id="row-contractor-driver" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Driver</label>'
  	    + '<input id="fuel-contractor-driver" type="text" placeholder="Type driver" class="fuel-soft-input">'
  	    + "</div>"

  	    + '<div id="row-mileage" style="display:none;">'
  	    + '<label id="label-mileage" style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Mileage / Hours</label>'
  	    + '<input id="fuel-mileage" type="text" inputmode="decimal" placeholder="Mileage / Hours" class="fuel-soft-input">'
  	    + '<div id="fuel-mileage-help" class="fuel-help-text"></div>'
  	    + '<div id="fuel-mileage-error" class="fuel-error-text"></div>'
  	    + "</div>"

  	    + '<div id="row-litres" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Litres</label>'
  	    + '<input id="fuel-litres" type="text" inputmode="decimal" placeholder="Litres" class="fuel-soft-input">'
  	    + '<div id="fuel-litres-help" class="fuel-help-text"></div>'
  	    + '<div id="fuel-litres-error" class="fuel-error-text"></div>'
  	    + "</div>"

  	    + '<div id="row-meter" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Meter</label>'
  	    + '<input id="fuel-meter" type="text" inputmode="decimal" placeholder="Meter" value="" class="fuel-soft-input">'
  	    + '<div id="fuel-meter-help" class="fuel-help-text"></div>'
  	    + '<div id="fuel-meter-error" class="fuel-error-text"></div>'
  	    + "</div>"

  	    + '<div id="row-intertank-target" style="display:none;">'
  	    + '<label style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Destination Tank</label>'
  	    + '<select id="fuel-intertank-target" class="fuel-dark-select fuel-soft-input">'
  	    + buildOptionsHtml(buildIntertankOptions(tank), "Select destination tank", "")
  	    + "</select>"
  	    + '<div id="fuel-intertank-target-help" class="fuel-help-text"></div>'
  	    + '<div id="fuel-intertank-target-error" class="fuel-error-text"></div>'
  	    + "</div>"

  	    + '<div id="row-description" style="display:none;grid-column:1 / span 2;">'
  	    + '<label id="label-description" style="display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;">Description</label>'
  	    + '<input id="fuel-description" type="text" placeholder="Description" class="fuel-soft-input">'
  	    + "</div>"

  	    + '<div id="row-cost-preview" style="display:none;grid-column:1 / span 2;">'
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:12px;padding:12px 14px;">'
  	    + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:8px;">Cost Preview</div>'
  	    + '<div style="display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px;">'
  	    + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Tank Price Per Litre</div>'
  	    + '<div id="fuel-preview-cpl" style="margin-top:4px;font-size:16px;font-weight:700;color:#f8fafc;">R 0.00</div>'
  	    + "</div>"
  	    + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Transaction Cost</div>'
  	    + '<div id="fuel-preview-cost" style="margin-top:4px;font-size:16px;font-weight:700;color:#f8fafc;">R 0.00</div>'
  	    + "</div>"
  	    + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">SARS Compliant</div>'
  	    + '<div id="fuel-preview-sars" style="margin-top:4px;font-size:16px;font-weight:700;color:#f8fafc;">No</div>'
  	    + "</div>"
  	    + '<div style="background:rgba(255,255,255,0.04);border-radius:10px;padding:10px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Potential Rebate</div>'
  	    + '<div id="fuel-preview-rebate" style="margin-top:4px;font-size:16px;font-weight:700;color:#f8fafc;">R 0.00</div>'
  	    + "</div>"
  	    + "</div>"
  	    + "</div>"
  	    + "</div>"

  	    + "</div>"

  	    + '<div style="display:flex;gap:10px;margin-top:18px;max-width:980px;">'
  	    + '<button id="fuel-save-btn" type="button" style="display:none;flex:1;height:46px;border:none;border-radius:10px;background:#f97316;color:white;font-size:15px;font-weight:700;cursor:pointer;">Save</button>'
  	    + '<button id="fuel-cancel-btn" type="button" style="width:140px;height:46px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.05);color:#e2e8f0;font-size:15px;font-weight:700;cursor:pointer;">Cancel</button>'
  	    + '<button id="fuel-detail-edit" type="button" style="display:none;">Edit</button>'
  	    +'<button id="fuel-detail-delete-last" type="button" style="display:none;">Delete Last</button>'
  	    + "</div>"
  	    + "</div>"

  	    + '<div id="fuel-transactions-panel" style="display:block;position:absolute;inset:0;padding:14px;overflow:hidden;">'
  	    + '<div style="display:grid;grid-template-columns:280px 1fr;gap:14px;height:100%;min-height:0;">'

  	    + '<div style="display:flex;flex-direction:column;gap:10px;min-height:0;">'
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:12px;padding:12px;">'
  	    + '<div style="font-size:11px;color:#94a3b8;margin-bottom:6px;">View Selector</div>'
  	    + '<select id="fuel-view-selector" class="fuel-dark-select fuel-soft-input">'
  	    + '<option value="">Select view</option>'
  	    + "</select>"
  	    + "</div>"

  	    + '<div style="display:grid;grid-template-columns:1fr;gap:8px;">'
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Transactions</div>'
  	    + '<div id="fuel-summary-count" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">0</div>'
  	    + "</div>"
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Litres</div>'
  	    + '<div id="fuel-summary-litres" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">0.00</div>'
  	    + "</div>"
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Cost</div>'
  	    + '<div id="fuel-summary-cost" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">R 0.00</div>'
  	    + "</div>"
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Potential Rebate</div>'
  	    + '<div id="fuel-summary-rebate" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">R 0.00</div>'
  	    + "</div>"
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Meter Start</div>'
  	    + '<div id="fuel-summary-meter-start" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">0.00</div>'
  	    + "</div>"
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Meter End</div>'
  	    + '<div id="fuel-summary-meter-end" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">0.00</div>'
  	    + "</div>"
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:9px 11px;">'
  	    + '<div style="font-size:10px;color:#94a3b8;">Bowser</div>'
  	    + '<div id="fuel-summary-bowser" style="margin-top:3px;font-size:17px;font-weight:700;color:#f8fafc;">' + escapeHtml(bowserName) + "</div>"
  	    + "</div>"
  	    + "</div>"
  	    + "</div>"

  	    + '<div style="display:flex;flex-direction:column;min-height:0;position:relative;">'
  	    + '<div style="display:flex;gap:10px;align-items:center;margin-bottom:10px;">'
  	    + '<input id="fuel-transactions-search" type="text" placeholder="Search transactions..." class="fuel-soft-input" style="flex:1;height:40px;background:rgba(255,255,255,0.9);">'
  	    + '<button id="fuel-search-clear" type="button" style="height:40px;padding:0 14px;border:none;border-radius:10px;background:rgba(255,255,255,0.08);color:#e2e8f0;font-size:12px;font-weight:700;cursor:pointer;">Clear</button>'
  	    + '<button id="fuel-print-btn" type="button" style="height:40px;padding:0 16px;border:none;border-radius:10px;background:#f97316;color:#ffffff;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;">Print / PDF</button>'
  	    + "</div>"

  	    + '<div id="fuel-transactions-list" style="display:flex;flex-direction:column;gap:6px;min-height:0;overflow:auto;padding-right:2px;">'
  	    + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	    + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No view selected</div>'
  	    + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Select ViewC or a historical view to see every transaction for that month.</div>'
  	    + "</div>"
  	    + "</div>"

  	    + '<div id="fuel-transaction-detail-backdrop" class="fuel-detail-backdrop">'
  	    + '  <div class="fuel-detail-card">'
  	    + '    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;padding:16px 16px 12px 16px;border-bottom:1px solid rgba(255,255,255,0.08);">'
  	    + '      <div>'
  	    + '        <div id="fuel-detail-title" style="font-size:16px;font-weight:700;color:#f8fafc;">Transaction Detail</div>'
  	    + '        <div id="fuel-detail-subtitle" style="margin-top:4px;font-size:11px;color:#94a3b8;"></div>'
  	    + "      </div>"
  	    + '<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;justify-content:flex-end;">'
  	    + '  <button id="fuel-detail-edit" type="button" style="height:34px;padding:0 14px;border:none;border-radius:10px;background:#2563eb;color:#ffffff;font-size:12px;font-weight:800;cursor:pointer;display:none;">Edit</button>'
  	    + '  <button id="fuel-detail-delete-last" type="button" style="height:34px;padding:0 14px;border:none;border-radius:10px;background:#dc2626;color:#ffffff;font-size:12px;font-weight:800;cursor:pointer;display:none;">Delete Last</button>'
  	    + '  <button id="fuel-detail-print" type="button" style="height:34px;padding:0 14px;border:none;border-radius:10px;background:#f97316;color:#ffffff;font-size:12px;font-weight:800;cursor:pointer;">Print / PDF</button>'
  	    + '  <button id="fuel-detail-close" type="button" style="background:none;border:none;color:#ff3b30;font-size:28px;line-height:1;cursor:pointer;padding:0 2px;">X</button>'
  	    + "</div>"
  	    + "    </div>"
  	    + '    <div id="fuel-detail-body" style="padding:14px 16px 18px 16px;"></div>'
  	    + "  </div>"
  	    + "</div>"

  	    + "</div>"
  	    + "</div>"
  	    + "</div>"
  	    + "</div>";

  	    overlay.appendChild(modal);
  	    document.body.appendChild(overlay);

  	    function el(id) {
  	      return document.getElementById(id);
  	    }

  	    function setDisplay(id, visible) {
  	      var node = el(id);
  	      if (node) node.style.display = visible ? "block": "none";
  	    }

  	    function valueOf(id) {
  	      var node = el(id);
  	      return node ? node.value: "";
  	    }

  	    function setValue(id, value) {
  	      var node = el(id);
  	      if (node) node.value = value;
  	    }

  	    function setText(id, value) {
  	      var node = el(id);
  	      if (node) node.textContent = value;
  	    }

  	    function showError(id, message) {
  	      var node = el(id);
  	      if (!node) return;
  	      node.style.display = message ? "block": "none";
  	      node.textContent = message || "";
  	    }

  	    function showHelp(id, message) {
  	      var node = el(id);
  	      if (!node) return;
  	      node.style.display = message ? "block": "none";
  	      node.textContent = message || "";
  	    }

  	    function clearValidationMessages() {
  	      showError("fuel-mileage-error", "");
  	      showError("fuel-litres-error", "");
  	      showError("fuel-meter-error", "");
  	      showError("fuel-intertank-target-error", "");
  	      showHelp("fuel-mileage-help", "");
  	      showHelp("fuel-litres-help", "");
  	      showHelp("fuel-meter-help", "");
  	      showHelp("fuel-intertank-target-help", "");
  	    }

  	    function updateCostPreview() {
  	      var litres = toNumber(valueOf("fuel-litres"), 0);
  	      var activeVehicle = getActiveVehicle();
  	      var cpl = getTankCostPerLitre(tank);
  	      var cost = litres * cpl;
  	      var compliant = activeVehicle ? isVehicleSarsCompliant(activeVehicle): false;
  	      var rebate = compliant ? litres * 3.00: 0;

  	      setText("fuel-preview-cpl", formatCurrency(cpl));
  	      setText("fuel-preview-cost", formatCurrency(cost));
  	      setText("fuel-preview-sars", compliant ? "Yes": "No");
  	      setText("fuel-preview-rebate", formatCurrency(rebate));
  	    }

  	    function closeModal() {
  	      var node = el("fuel-capture-overlay");
  	      if (node) node.remove();
  	    }

  	    function closeTransactionDetail() {
  	      var backdrop = el("fuel-transaction-detail-backdrop");
  	      if (backdrop) backdrop.style.display = "none";
  	      state.selectedTransaction = null;
  	    }

  	    function closeTransactionEditModal() {
  	      var node = el("fuel-transaction-edit-backdrop");
  	      if (node) node.remove();
  	    }

  	    function openTransactionEditModal(item) {
  	      if (!item) return;

  	      closeTransactionEditModal();

  	      var currentVehicleId = getTransactionVehicleObjectId(item);
  	      var currentMileage = text(getDeep(item, ["Mileage"], ""), "");
  	      var currentRegistration = getTransactionRegistration(item);

  	      var vehicleOptions = companyVehicleOptions.filter(function (opt) {
  	        return opt && opt.value && opt.value !== "OTHER";
  	      });

  	      var vehicleOptionsHtml = buildOptionsHtml(vehicleOptions, "Select vehicle", currentVehicleId);

  	      var backdrop = document.createElement("div");
  	      backdrop.id = "fuel-transaction-edit-backdrop";
  	      backdrop.style.position = "fixed";
  	      backdrop.style.inset = "0";
  	      backdrop.style.zIndex = "1000001";
  	      backdrop.style.background = "rgba(15,23,42,0.72)";
  	      backdrop.style.display = "flex";
  	      backdrop.style.alignItems = "center";
  	      backdrop.style.justifyContent = "center";
  	      backdrop.style.padding = "20px";

  	      var modal = document.createElement("div");
  	      modal.style.width = "100%";
  	      modal.style.maxWidth = "620px";
  	      modal.style.background = "#0f172a";
  	      modal.style.border = "1px solid rgba(255,255,255,0.12)";
  	      modal.style.borderRadius = "16px";
  	      modal.style.boxShadow = "0 24px 80px rgba(0,0,0,0.45)";
  	      modal.style.overflow = "hidden";

  	      modal.innerHTML = ""
  	      + '<div style="display:flex;align-items:center;justify-content:space-between;padding:16px 18px;border-bottom:1px solid rgba(255,255,255,0.08);">'
  	      + '  <div>'
  	      + '    <div style="font-size:16px;font-weight:800;color:#f8fafc;">Edit Transaction</div>'
  	      + '    <div style="margin-top:4px;font-size:12px;color:#94a3b8;">' + escapeHtml(getTransactionTractorHeading(item)) + "</div>"
  	      + "  </div>"
  	      + '  <button id="fuel-edit-close" type="button" style="background:none;border:none;color:#ff3b30;font-size:26px;line-height:1;cursor:pointer;padding:0 2px;">X</button>'
  	      + "</div>"

  	      + '<div style="padding:18px;">'
  	      + '  <div style="display:grid;grid-template-columns:1fr;gap:14px;">'
  	      + '    <div>'
  	      + '      <div style="font-size:12px;font-weight:700;color:#cbd5e1;margin-bottom:6px;">Mileage</div>'
  	      + '      <input id="fuel-edit-mileage" type="text" value="' + escapeHtml(currentMileage) + '" class="fuel-soft-input" style="width:100%;height:42px;background:rgba(255,255,255,0.92);">'
  	      + '      <div id="fuel-edit-mileage-error" style="display:none;margin-top:6px;font-size:11px;color:#fda4af;"></div>'
  	      + "    </div>"

  	      + '    <div>'
  	      + '      <div style="font-size:12px;font-weight:700;color:#cbd5e1;margin-bottom:6px;">Vehicle</div>'
  	      + '      <select id="fuel-edit-vehicle" class="fuel-soft-input" style="width:100%;height:42px;background:rgba(255,255,255,0.92);">'
  	      + vehicleOptionsHtml
  	      + "      </select>"
  	      + "    </div>"

  	      + '    <div>'
  	      + '      <div style="font-size:12px;font-weight:700;color:#cbd5e1;margin-bottom:6px;">Registration</div>'
  	      + '      <input id="fuel-edit-registration" type="text" value="' + escapeHtml(currentRegistration) + '" class="fuel-soft-input" style="width:100%;height:42px;background:rgba(255,255,255,0.78);" readonly>'
  	      + "    </div>"
  	      + "  </div>"

  	      + '  <div style="display:flex;justify-content:flex-end;gap:10px;margin-top:18px;">'
  	      + '    <button id="fuel-edit-cancel" type="button" style="height:40px;padding:0 16px;border:1px solid rgba(255,255,255,0.14);border-radius:10px;background:rgba(255,255,255,0.04);color:#e2e8f0;font-size:12px;font-weight:700;cursor:pointer;">Cancel</button>'
  	      + '    <button id="fuel-edit-save" type="button" style="height:40px;padding:0 16px;border:none;border-radius:10px;background:#f97316;color:#ffffff;font-size:12px;font-weight:800;cursor:pointer;">Save Edit</button>'
  	      + "  </div>"
  	      + "</div>";

  	      backdrop.appendChild(modal);
  	      document.body.appendChild(backdrop);

  	      function updateEditRegistrationPreview() {
  	        var selectedVehicleId = valueOf("fuel-edit-vehicle");
  	        var selectedVehicle = null;

  	        for (var i = 0; i < vehicleOptions.length; i++) {
  	          if (String(vehicleOptions[i].value) === String(selectedVehicleId)) {
  	            selectedVehicle = vehicleOptions[i].raw || null;
  	            break;
  	          }
  	        }

  	        var nextRegistration = selectedVehicle
  	        ? text(
  	          firstDefined(
  	            getDeep(selectedVehicle, ["Registration"], null),
  	            getDeep(selectedVehicle, ["Data", "Vehicle", "Registration", "value"], null)
  	          ),
  	          currentRegistration
  	        ): currentRegistration;

  	        setValue("fuel-edit-registration", nextRegistration);
  	      }

  	      var vehicleNode = el("fuel-edit-vehicle");
  	      if (vehicleNode) {
  	        vehicleNode.addEventListener("change", updateEditRegistrationPreview);
  	      }

  	      var closeBtn = el("fuel-edit-close");
  	      var cancelBtn = el("fuel-edit-cancel");
  	      var saveBtn = el("fuel-edit-save");

  	      if (closeBtn) closeBtn.onclick = closeTransactionEditModal;
  	      if (cancelBtn) cancelBtn.onclick = closeTransactionEditModal;

  	      backdrop.onclick = function (e) {
  	        if (e.target === backdrop) closeTransactionEditModal();
  	      };

  	      if (saveBtn) {
  	        saveBtn.onclick = async function () {
  	          try {
  	            showError("fuel-edit-mileage-error", "");

  	            var mileageValue = sanitizeNumeric(valueOf("fuel-edit-mileage"));
  	            var vehicleObjectId = valueOf("fuel-edit-vehicle");
  	            var registrationValue = valueOf("fuel-edit-registration");

  	            if (!mileageValue) {
  	              showError("fuel-edit-mileage-error", "Mileage is required.");
  	              return;
  	            }

  	            var patch = {
  	              mileage: mileageValue,
  	              vehicleObjectId: vehicleObjectId || currentVehicleId,
  	              registration: registrationValue || currentRegistration
  	            };

  	            setButtonBusy(saveBtn, true, "Saving...");

  	            await editHistoricalTransaction(item, patch);

  	            closeTransactionEditModal();
  	            closeTransactionDetail();
  	            await refreshSelectedBowserView();
  	            renderTransactionListFromState();
  	          } catch (err) {
  	            showError("fuel-edit-mileage-error", err && err.message ? err.message: String(err));
  	          } finally {
  	            setButtonBusy(saveBtn, false, "Save Edit");
  	          }
  	        };
  	      }
  	    }

  	    function openTransactionDetail(item) {
  	      state.selectedTransaction = item || null;

  	      var backdrop = el("fuel-transaction-detail-backdrop");
  	      var title = el("fuel-detail-title");
  	      var subtitleNode = el("fuel-detail-subtitle");
  	      var body = el("fuel-detail-body");

  	      if (!backdrop || !body || !item) return;

  	      var tractorHeading = getTransactionTractorHeading(item);
  	      var registration = getTransactionRegistration(item);
  	      var formattedDate = formatDatePretty(getDeep(item, ["FuelDate"], ""));

  	      if (title) title.textContent = tractorHeading;
  	      if (subtitleNode) subtitleNode.textContent = formattedDate;

  	      var driver = getTransactionDriver(item);
  	      var unitCost = getTransactionUnitCost(item);
  	      var sarsRebate = getTransactionSarsRebate(item);
  	      var sarsCompliance = firstDefined(getDeep(item, ["SARSCompliance"], null), false) ? "Yes": "No";
  	      var rollbackStatus = isTransactionReversed(item) ? "Reversed": "Active";

  	      body.innerHTML = ""
  	      + '<div style="display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;">'
  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:12px;padding:12px 14px;">'
  	      + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:6px;">Capture</div>'
  	      + buildDetailRow("Fuel Date", formattedDate)
  	      + buildDetailRow("Tractor", tractorHeading)
  	      + buildDetailRow("Capture Type", getDeep(item, ["CaptureType"], ""))
  	      + buildDetailRow("Application", getDeep(item, ["Application"], ""))
  	      + buildDetailRow("Registration", registration)
  	      + buildDetailRow("Driver", driver)
  	      + buildDetailRow("Contractor Name", getDeep(item, ["ContractorName"], ""))
  	      + buildDetailRow("Description", getDeep(item, ["Description"], ""))
  	      + buildDetailRow("Status", rollbackStatus)
  	      + "</div>"

  	      + '<div style="background:rgba(255,255,255,0.04);border-radius:12px;padding:12px 14px;">'
  	      + '<div style="font-size:12px;font-weight:700;color:#f8fafc;margin-bottom:6px;">Figures</div>'
  	      + buildDetailRow("Litres", displayNumber(getDeep(item, ["Litres"], 0), 2))
  	      + buildDetailRow("Cost Per Litre", formatCurrency(unitCost))
  	      + buildDetailRow("Cost", formatCurrency(getDeep(item, ["Cost"], 0)))
  	      + buildDetailRow("SARS Compliant", sarsCompliance)
  	      + buildDetailRow("Potential SARS Rebate", formatCurrency(sarsRebate))
  	      + buildDetailRow("Mileage", getDeep(item, ["Mileage"], ""))
  	      + buildDetailRow("Mileage Last", getDeep(item, ["MileageLast"], ""))
  	      + buildDetailRow("Distance", getDeep(item, ["Distance"], ""))
  	      + buildDetailRow("Meter", displayNumber(getDeep(item, ["Meter"], 0), 2))
  	      + buildDetailRow("Meter Last", displayNumber(getDeep(item, ["MeterLast"], 0), 2))
  	      + buildDetailRow("Tolerance", displayNumber(getDeep(item, ["Tolerance"], 0), 2))
  	      + "</div>"
  	      + "</div>";

  	      var rollbackBtn = el("fuel-detail-rollback");
  	      if (rollbackBtn) {
  	        var latestAllowed = false;

  	        try {
  	          var allVisibleTx = sortTransactionsAsc(
  	            getActiveTransactionsOnly(
  	              toArray(getDeep(state, ["selectedBowserView", "FuelOut"], []))
  	            )
  	          );

  	          latestAllowed =
  	          isLatestTransactionForBowser(item, allVisibleTx) &&
  	          isLatestTransactionForVehicle(item, allVisibleTx);
  	        } catch (e) {
  	          latestAllowed = false;
  	        }

  	        rollbackBtn.style.display = (isTransactionReversed(item) || !latestAllowed) ? "none": "inline-flex";
  	      }

  	      var editBtn = backdrop.querySelector("#fuel-detail-edit");
  	      if (editBtn) {
  	        editBtn.style.display = isTransactionReversed(item) ? "none": "inline-flex";
  	        editBtn.onclick = function () {
  	          openTransactionEditModal(item);
  	        };
  	      }

  	      var deleteLastBtn = backdrop.querySelector("#fuel-detail-delete-last");
  	      if (deleteLastBtn) {
  	        var canDeleteLast = false;

  	        try {
  	          var allVisibleTx = sortTransactionsAsc(
  	            getActiveTransactionsOnly(
  	              toArray(getDeep(state, ["selectedBowserView", "FuelOut"], []))
  	            )
  	          );

  	          canDeleteLast =
  	          isLatestTransactionForBowser(item, allVisibleTx) &&
  	          isLatestTransactionForVehicle(item, allVisibleTx) &&
  	          !isTransactionReversed(item);
  	        } catch (e) {
  	          canDeleteLast = false;
  	        }

  	        deleteLastBtn.style.display = canDeleteLast ? "inline-flex": "none";
  	        deleteLastBtn.onclick = async function () {
  	          try {
  	            if (!confirm("Delete this last transaction?")) return;

  	            await rollbackToTransaction(item);
  	            closeTransactionDetail();
  	            await refreshSelectedBowserView();
  	            renderTransactionListFromState();
  	          } catch (err) {
  	            alert(err && err.message ? err.message: err);
  	          }
  	        };
  	      }

  	      backdrop.style.display = "flex";
  	    }

  	    var captureBtn = el("fuel-tab-capture");
  	    var transactionsBtn = el("fuel-tab-transactions");
  	    var capturePanel = el("fuel-capture-panel");
  	    var transactionsPanel = el("fuel-transactions-panel");
  	    var saveBtn = el("fuel-save-btn");

  	    function showCapture() {
  	      capturePanel.style.display = "block";
  	      transactionsPanel.style.display = "none";

  	      captureBtn.style.background = "#f97316";
  	      captureBtn.style.color = "#ffffff";
  	      captureBtn.style.border = "none";

  	      transactionsBtn.style.background = "rgba(255,255,255,0.04)";
  	      transactionsBtn.style.color = "#dbe4ee";
  	      transactionsBtn.style.border = "1px solid rgba(255,255,255,0.12)";
  	    }

  	    function showTransactions() {
  	      capturePanel.style.display = "none";
  	      transactionsPanel.style.display = "block";

  	      transactionsBtn.style.background = "#f97316";
  	      transactionsBtn.style.color = "#ffffff";
  	      transactionsBtn.style.border = "none";

  	      captureBtn.style.background = "rgba(255,255,255,0.04)";
  	      captureBtn.style.color = "#dbe4ee";
  	      captureBtn.style.border = "1px solid rgba(255,255,255,0.12)";
  	    }

  	    function getSelectedCompanyVehicle() {
  	      var selected = valueOf("fuel-company-registration");
  	      if (!selected || selected === "OTHER") return null;

  	      for (var i = 0; i < companyVehicleOptions.length; i++) {
  	        if (String(companyVehicleOptions[i].value) === String(selected)) {
  	          return companyVehicleOptions[i].raw || null;
  	        }
  	      }

  	      return null;
  	    }

  	    function getSelectedContractorObject() {
  	      var selected = valueOf("fuel-contractor-name");
  	      if (!selected || selected === "OTHER") return null;

  	      for (var i = 0; i < contractorOptions.length; i++) {
  	        if (String(contractorOptions[i].value) === String(selected)) {
  	          return contractorOptions[i].raw || null;
  	        }
  	      }

  	      return null;
  	    }

  	    function getSelectedContractorVehicle() {
  	      var contractorObj = getSelectedContractorObject();
  	      var selected = valueOf("fuel-contractor-registration");

  	      if (!contractorObj || !selected || selected === "OTHER") return null;

  	      var vehicles = toArray(getDeep(contractorObj, ["Tractors"], []));
  	      for (var i = 0; i < vehicles.length; i++) {
  	        if (String(pickVehicleValue(vehicles[i], "CONTRACTOR_VEHICLE", i)) === String(selected)) {
  	          return vehicles[i];
  	        }
  	      }

  	      return null;
  	    }

  	    function getSelectedDriverOption() {
  	      var selected = valueOf("fuel-company-driver");
  	      if (!selected || selected === "OTHER") return null;

  	      for (var i = 0; i < driverOptions.length; i++) {
  	        if (String(driverOptions[i].value) === String(selected)) {
  	          return driverOptions[i].raw || null;
  	        }
  	      }

  	      return null;
  	    }

  	    function getActiveVehicle() {
  	      var mode = valueOf("fuel-capture-type");
  	      if (mode === "company") return getSelectedCompanyVehicle();
  	      if (mode === "contractor") return getSelectedContractorVehicle();
  	      return null;
  	    }

  	    function getVehicleOldReading(vehicle) {
  	      return toNumber(getDeep(vehicle, ["Mileage"], 0), 0);
  	    }

  	    function getVehicleRange(vehicle) {
  	      return toNumber(getDeep(vehicle, ["Range"], 0), 0);
  	    }

  	    function getVehicleTankCapacity(vehicle) {
  	      return toNumber(getDeep(vehicle, ["CAN", "Tank"], 0), 0);
  	    }

  	    function rebuildContractorRegistrations() {
  	      var contractorObj = getSelectedContractorObject();
  	      var regSelect = el("fuel-contractor-registration");
  	      if (!regSelect) return;

  	      var contractorVehicles = contractorObj ? toArray(getDeep(contractorObj, ["Tractors"], [])): [];
  	      var options = optionWithOtherFirst(buildVehicleOptions(contractorVehicles, "CONTRACTOR_VEHICLE"), "Other");

  	      regSelect.innerHTML = buildOptionsHtml(options, "Select registration", "");
  	    }

  	    function applyNumericSanitizer(id) {
  	      var node = el(id);
  	      if (!node) return;

  	      node.addEventListener("input", function () {
  	        node.value = sanitizeNumeric(node.value);
  	        refreshCaptureVisibility();
  	      });
  	    }

  	    function clearCaptureValues() {
  	      var ids = [
  	        "fuel-company-application",
  	        "fuel-company-application-other",
  	        "fuel-company-registration",
  	        "fuel-company-registration-other",
  	        "fuel-company-driver",
  	        "fuel-company-driver-other",
  	        "fuel-contractor-name",
  	        "fuel-contractor-name-other",
  	        "fuel-contractor-application",
  	        "fuel-contractor-application-other",
  	        "fuel-contractor-registration",
  	        "fuel-contractor-registration-other",
  	        "fuel-contractor-driver",
  	        "fuel-mileage",
  	        "fuel-litres",
  	        "fuel-meter",
  	        "fuel-description"
  	      ];

  	      for (var i = 0; i < ids.length; i++) {
  	        setValue(ids[i], "");
  	      }

  	      rebuildContractorRegistrations();
  	      clearValidationMessages();
  	      updateCostPreview();
  	    }

  	    function validateReading() {
  	      var mode = valueOf("fuel-capture-type");
  	      if (mode === "other") {
  	        showHelp("fuel-mileage-help", "");
  	        showError("fuel-mileage-error", "");
  	        return {
  	          ok: true
  	        };
  	      }

  	      var vehicle = getActiveVehicle();
  	      var entered = toNumber(valueOf("fuel-mileage"), NaN);

  	      if (!vehicle || isNaN(entered)) {
  	        showHelp("fuel-mileage-help", "");
  	        showError("fuel-mileage-error", "");
  	        return {
  	          ok: false
  	        };
  	      }

  	      var oldReading = getVehicleOldReading(vehicle);
  	      var range = getVehicleRange(vehicle);
  	      var maxReading = oldReading + range;

  	      showHelp("fuel-mileage-help", "Allowed range: " + oldReading + " to " + maxReading);

  	      if (entered < oldReading) {
  	        showError("fuel-mileage-error", "Reading cannot be lower than " + oldReading);
  	        return {
  	          ok: false,
  	          oldReading: oldReading,
  	          maxReading: maxReading
  	        };
  	      }

  	      if (entered > maxReading) {
  	        showError("fuel-mileage-error", "Reading cannot be higher than " + maxReading);
  	        return {
  	          ok: false,
  	          oldReading: oldReading,
  	          maxReading: maxReading
  	        };
  	      }

  	      showError("fuel-mileage-error", "");
  	      return {
  	        ok: true,
  	        oldReading: oldReading,
  	        maxReading: maxReading
  	      };
  	    }

  	    function validateLitres() {
  	      var mode = valueOf("fuel-capture-type");
  	      var litres = toNumber(valueOf("fuel-litres"), NaN);

  	      if (isNaN(litres)) {
  	        showHelp("fuel-litres-help", "");
  	        showError("fuel-litres-error", "");
  	        return {
  	          ok: false
  	        };
  	      }

  	      if (litres <= 0) {
  	        showError("fuel-litres-error", "Litres must be greater than 0");
  	        return {
  	          ok: false
  	        };
  	      }

  	      if (mode === "company" || mode === "contractor") {
  	        var vehicle = getActiveVehicle();

  	        if (!vehicle) {
  	          showHelp("fuel-litres-help", "");
  	          showError("fuel-litres-error", "");
  	          return {
  	            ok: false
  	          };
  	        }

  	        var capacity = getVehicleTankCapacity(vehicle);
  	        showHelp("fuel-litres-help", "Vehicle tank capacity: " + capacity + " L");

  	        if (capacity > 0 && litres > capacity) {
  	          showError("fuel-litres-error", "Litres cannot exceed tank capacity of " + capacity + " L");
  	          return {
  	            ok: false,
  	            capacity: capacity
  	          };
  	        }
  	      } else {
  	        showHelp("fuel-litres-help", "");
  	      }

  	      showError("fuel-litres-error", "");
  	      return {
  	        ok: true
  	      };
  	    }

  	    function validateMeter() {
  	      var litres = toNumber(valueOf("fuel-litres"), NaN);
  	      var enteredMeter = toNumber(valueOf("fuel-meter"), NaN);
  	      var tolerance = 0.05;

  	      if (isNaN(litres) || isNaN(enteredMeter)) {
  	        showHelp("fuel-meter-help", "");
  	        showError("fuel-meter-error", "");
  	        return {
  	          ok: false
  	        };
  	      }

  	      var liveBowserMeter = toNumber(getDeep(bowser, ["Meter"], 0), 0);
  	      var expected = liveBowserMeter + litres;
  	      var minAllowed = expected - tolerance;
  	      var maxAllowed = expected + tolerance;

  	      showHelp("fuel-meter-help", "Expected meter: " + displayNumber(expected, 2) + " (tolerance +/-" + displayNumber(tolerance, 2) + ")");

  	      if (enteredMeter < liveBowserMeter) {
  	        showError("fuel-meter-error", "Meter cannot be lower than current meter of " + displayNumber(liveBowserMeter, 2));
  	        return {
  	          ok: false,
  	          expected: expected
  	        };
  	      }

  	      if (enteredMeter < minAllowed || enteredMeter > maxAllowed) {
  	        showError("fuel-meter-error", "Meter must be between " + displayNumber(minAllowed, 2) + " and " + displayNumber(maxAllowed, 2));
  	        return {
  	          ok: false,
  	          expected: expected
  	        };
  	      }

  	      showError("fuel-meter-error", "");
  	      return {
  	        ok: true,
  	        expected: expected
  	      };
  	    }

  	    function isComplete() {
  	      var mode = valueOf("fuel-capture-type");

  	      if (!mode) return false;

  	      if (mode === "company") {
  	        if (!valueOf("fuel-company-application")) return false;
  	        if (valueOf("fuel-company-application") === "OTHER" && !valueOf("fuel-company-application-other")) return false;

  	        if (!valueOf("fuel-company-registration")) return false;
  	        if (valueOf("fuel-company-registration") === "OTHER" && !valueOf("fuel-company-registration-other")) return false;

  	        if (!valueOf("fuel-company-driver")) return false;
  	        if (valueOf("fuel-company-driver") === "OTHER" && !valueOf("fuel-company-driver-other")) return false;

  	        if (!validateReading().ok) return false;
  	        if (!validateLitres().ok) return false;
  	        if (!validateMeter().ok) return false;

  	        return true;
  	      }

  	      if (mode === "contractor") {
  	        if (!valueOf("fuel-contractor-name")) return false;
  	        if (valueOf("fuel-contractor-name") === "OTHER" && !valueOf("fuel-contractor-name-other")) return false;

  	        if (!valueOf("fuel-contractor-application")) return false;
  	        if (valueOf("fuel-contractor-application") === "OTHER" && !valueOf("fuel-contractor-application-other")) return false;

  	        if (!valueOf("fuel-contractor-registration")) return false;
  	        if (valueOf("fuel-contractor-registration") === "OTHER" && !valueOf("fuel-contractor-registration-other")) return false;

  	        if (!valueOf("fuel-contractor-driver")) return false;

  	        if (!validateReading().ok) return false;
  	        if (!validateLitres().ok) return false;
  	        if (!validateMeter().ok) return false;

  	        return true;
  	      }

  	      if (mode === "intertank") {
  	        if (!validateIntertankTarget().ok) return false;
  	        if (!validateLitres().ok) return false;
  	        if (!validateMeter().ok) return false;
  	        return true;
  	      }

  	      if (mode === "other") {
  	        if (!validateLitres().ok) return false;
  	        if (!validateMeter().ok) return false;
  	        return true;
  	      }

  	      return false;
  	    }
  	    function updateSaveVisibility() {
  	      if (!saveBtn) return;
  	      saveBtn.style.display = isComplete() ? "block": "none";
  	    }

  	    function refreshCaptureVisibility() {
  	      var mode = valueOf("fuel-capture-type");

  	      var companyApplication = valueOf("fuel-company-application");
  	      var companyRegistration = valueOf("fuel-company-registration");
  	      var companyDriver = valueOf("fuel-company-driver");

  	      var contractorName = valueOf("fuel-contractor-name");
  	      var contractorApplication = valueOf("fuel-contractor-application");
  	      var contractorRegistration = valueOf("fuel-contractor-registration");

  	      var descriptionLabel = el("label-description");

  	      if (descriptionLabel) descriptionLabel.textContent = "Description";

  	      setDisplay("row-company-application", false);
  	      setDisplay("row-company-application-other", false);
  	      setDisplay("row-company-registration", false);
  	      setDisplay("row-company-registration-other", false);
  	      setDisplay("row-company-driver", false);
  	      setDisplay("row-company-driver-other", false);

  	      setDisplay("row-contractor-name", false);
  	      setDisplay("row-contractor-name-other", false);
  	      setDisplay("row-contractor-application", false);
  	      setDisplay("row-contractor-application-other", false);
  	      setDisplay("row-contractor-registration", false);
  	      setDisplay("row-intertank-target", false);
  	      setDisplay("row-contractor-registration-other", false);
  	      setDisplay("row-contractor-driver", false);

  	      setDisplay("row-mileage", false);
  	      setDisplay("row-litres", false);
  	      setDisplay("row-meter", false);
  	      setDisplay("row-description", false);
  	      setDisplay("row-cost-preview", false);

  	      clearValidationMessages();

  	      if (!mode) {
  	        updateCostPreview();
  	        updateSaveVisibility();
  	        return;
  	      }

  	      if (mode === "company") {
  	        setDisplay("row-company-application", true);

  	        if (companyApplication) {
  	          if (companyApplication === "OTHER") setDisplay("row-company-application-other", true);
  	          if (companyApplication !== "OTHER" || valueOf("fuel-company-application-other")) {
  	            setDisplay("row-company-registration", true);
  	          }
  	        }

  	        if (companyRegistration) {
  	          if (companyRegistration === "OTHER") setDisplay("row-company-registration-other", true);
  	          if (companyRegistration !== "OTHER" || valueOf("fuel-company-registration-other")) {
  	            setDisplay("row-company-driver", true);
  	          }
  	        }

  	        if (companyDriver) {
  	          if (companyDriver === "OTHER") setDisplay("row-company-driver-other", true);
  	          if (companyDriver !== "OTHER" || valueOf("fuel-company-driver-other")) {
  	            setDisplay("row-mileage", true);
  	          }
  	        }

  	        if (valueOf("fuel-mileage") && validateReading().ok) setDisplay("row-litres", true);
  	        if (valueOf("fuel-litres") && validateLitres().ok) setDisplay("row-meter", true);
  	        if (valueOf("fuel-meter") && validateMeter().ok) {
  	          setDisplay("row-description", true);
  	          setDisplay("row-cost-preview", true);
  	        }

  	        if (descriptionLabel) descriptionLabel.textContent = "Client / Description";
  	      }

  	      if (mode === "contractor") {
  	        setDisplay("row-contractor-name", true);
  	        setDisplay("row-contractor-application", true);
  	        setDisplay("row-contractor-registration", true);
  	        setDisplay("row-contractor-driver", true);
  	        setDisplay("row-mileage", true);
  	        setDisplay("row-litres", true);
  	        setDisplay("row-meter", true);
  	        setDisplay("row-description", true);

  	        if (contractorName === "OTHER") {
  	          setDisplay("row-contractor-name-other", true);
  	        }

  	        if (contractorApplication === "OTHER") {
  	          setDisplay("row-contractor-application-other", true);
  	        }

  	        if (contractorRegistration === "OTHER") {
  	          setDisplay("row-contractor-registration-other", true);
  	        }

  	        if (isComplete() || valueOf("fuel-description")) {
  	          setDisplay("row-cost-preview", true);
  	        }
  	      }

  	      if (mode === "intertank") {
  	        setDisplay("row-litres", true);
  	        setDisplay("row-meter", true);
  	        setDisplay("row-intertank-target", true);
  	        setDisplay("row-description", true);

  	        var intertankOptions = buildIntertankOptions(tank);
  	        var intertankNode = el("fuel-intertank-target");

  	        if (intertankNode) {
  	          intertankNode.innerHTML = buildOptionsHtml(
  	            intertankOptions,
  	            "Select destination tank",
  	            valueOf("fuel-intertank-target")
  	          );
  	        }

  	        if (!intertankOptions.length) {
  	          showError(
  	            "fuel-intertank-target-error",
  	            "No same-grade destination tanks are available for this tank."
  	          );
  	        } else {
  	          validateIntertankTarget();
  	        }

  	        if (isComplete() || valueOf("fuel-description")) {
  	          setDisplay("row-cost-preview", true);
  	        }
  	      }

  	      if (mode === "other") {
  	        setDisplay("row-litres", true);
  	        setDisplay("row-meter", true);
  	        setDisplay("row-description", true);

  	        if (isComplete() || valueOf("fuel-description")) {
  	          setDisplay("row-cost-preview", true);
  	        }
  	      }

  	      updateCostPreview();
  	      updateSaveVisibility();
  	    }

  	    function bindChangeRefresh(id, extraFn) {
  	      var node = el(id);
  	      if (!node) return;

  	      node.addEventListener("change", function () {
  	        if (typeof extraFn === "function") extraFn();
  	        refreshCaptureVisibility();
  	      });

  	      node.addEventListener("input",
  	        function () {
  	          refreshCaptureVisibility();
  	        });
  	    }

  	    function buildViewOptionsHtmlFromBowser(sourceBowser) {
  	      var html = '<option value="">Select view</option>';
  	      var currentView = getDeep(sourceBowser,
  	        ["ViewC"],
  	        null);
  	      var historyViews = toArray(getDeep(sourceBowser, ["ViewH"], []));

  	      if (currentView && getDeep(currentView, ["objectId"], null)) {
  	        html += '<option value="VIEWC::' + escapeHtml(text(currentView.objectId, "")) + '">Current | ' + escapeHtml(text(getDeep(currentView, ["MYear"], "Current"), "Current")) + "</option>";
  	      } else if (currentView && getDeep(currentView, ["MYear"], "")) {
  	        html += '<option value="VIEWC">Current | ' + escapeHtml(text(getDeep(currentView, ["MYear"], "Current"), "Current")) + "</option>";
  	      }

  	      for (var i = 0; i < historyViews.length; i++) {
  	        var hv = historyViews[i];
  	        var hvId = text(getDeep(hv, ["objectId"], ""), "");
  	        var hvValue = hvId ? ("VIEWH::" + hvId): ("VIEWHIDX::" + i);
  	        html += '<option value="' + escapeHtml(hvValue) + '">History | ' + escapeHtml(text(getDeep(hv, ["MYear"], "History " + (i + 1)), "History " + (i + 1))) + "</option>";
  	      }

  	      return html;
  	    }

  	    function getSelectedBowserViewMeta() {
  	      var selected = valueOf("fuel-view-selector");
  	      var currentView = getDeep(bowser, ["ViewC"], null);
  	      var historyViews = toArray(getDeep(bowser, ["ViewH"], []));

  	      if (!selected) return null;

  	      if (selected.indexOf("VIEWC::") === 0) {
  	        return {
  	          kind: "current",
  	          objectId: selected.split("::")[1],
  	          view: currentView
  	        };
  	      }

  	      if (selected === "VIEWC") {
  	        return {
  	          kind: "current",
  	          objectId: getDeep(currentView, ["objectId"], null),
  	          view: currentView
  	        };
  	      }

  	      if (selected.indexOf("VIEWH::") === 0) {
  	        var hId = selected.split("::")[1];
  	        for (var i = 0; i < historyViews.length; i++) {
  	          if (String(getDeep(historyViews[i], ["objectId"], "")) === String(hId)) {
  	            return {
  	              kind: "history",
  	              objectId: hId,
  	              view: historyViews[i]
  	            };
  	          }
  	        }
  	      }

  	      if (selected.indexOf("VIEWHIDX::") === 0) {
  	        var idx = toNumber(selected.split("::")[1], -1);
  	        if (idx >= 0 && idx < historyViews.length) {
  	          return {
  	            kind: "history",
  	            objectId: getDeep(historyViews[idx], ["objectId"], null),
  	            view: historyViews[idx]
  	          };
  	        }
  	      }

  	      return null;
  	    }

  	    function buildTransactionRow(item, index) {
  	      var fuelDate = formatDatePretty(text(getDeep(item, ["FuelDate"], ""), ""));
  	      var litres = displayNumber(getDeep(item, ["Litres"], 0), 2);
  	      var cost = formatCurrency(getDeep(item, ["Cost"], 0));
  	      var rebate = formatCurrency(getTransactionSarsRebate(item));
  	      var meter = displayNumber(getDeep(item, ["Meter"], 0), 2);
  	      var meterLast = displayNumber(getDeep(item, ["MeterLast"], 0), 2);

  	      var registration = getTransactionRegistration(item);
  	      var driver = getTransactionDriver(item);
  	      var application = text(getDeep(item, ["Application"], ""), "");
  	      var captureType = text(getDeep(item, ["CaptureType"], ""), "");
  	      var description = text(getDeep(item, ["Description"], ""), "");
  	      var rollbackStatus = isTransactionReversed(item) ? "Reversed": "Active";
  	      var txId = text(getDeep(item, ["objectId"], ""), "");
  	      var headingLine = registration;
  	      var metaLine = driver + (application ? " | " + application: "") + (captureType ? " | " + captureType: "") + " | " + rollbackStatus;

  	      return ""
  	      + '<button type="button" class="fuel-tx-item" data-tx-index="' + index + '"'
  	      + ' style="width:100%;text-align:left;background:rgba(255,255,255,0.05);border:none;border-radius:10px;padding:9px 11px;cursor:pointer;">'
  	      + '  <div style="display:grid;grid-template-columns:minmax(0,1.45fr) 90px 110px 110px 118px 118px;gap:10px;align-items:center;">'
  	      + '    <div style="min-width:0;">'
  	      + '      <div style="font-size:13px;font-weight:700;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(headingLine) + "</div>"
  	      + '      <div style="margin-top:2px;font-size:10px;color:#94a3b8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(metaLine) + "</div>"
  	      + (description ? '      <div style="margin-top:2px;font-size:10px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(description) + "</div>": "")
  	      + "    </div>"
  	      + '    <div style="min-width:0;">'
  	      + '      <div style="font-size:9px;color:#94a3b8;">Litres</div>'
  	      + '      <div style="margin-top:1px;font-size:14px;font-weight:700;color:#f8fafc;">' + escapeHtml(litres) + "</div>"
  	      + "    </div>"
  	      + '    <div style="min-width:0;">'
  	      + '      <div style="font-size:9px;color:#94a3b8;">Cost</div>'
  	      + '      <div style="margin-top:1px;font-size:12px;font-weight:700;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(cost) + "</div>"
  	      + "    </div>"
  	      + '    <div style="min-width:0;">'
  	      + '      <div style="font-size:9px;color:#94a3b8;">Rebate</div>'
  	      + '      <div style="margin-top:1px;font-size:12px;font-weight:700;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(rebate) + "</div>"
  	      + "    </div>"
  	      + '    <div style="min-width:0;">'
  	      + '      <div style="font-size:9px;color:#94a3b8;">Meter Last -> Meter</div>'
  	      + '      <div style="margin-top:1px;font-size:12px;font-weight:700;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(meterLast + " -> " + meter) + "</div>"
  	      + "    </div>"
  	      + '    <div style="min-width:0;text-align:right;">'
  	      + '      <div style="font-size:9px;color:#94a3b8;">Date</div>'
  	      + '      <div style="margin-top:1px;font-size:11px;font-weight:700;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(fuelDate || ("Transaction " + (index + 1))) + "</div>"
  	      + "    </div>"
  	      + "  </div>"
  	      + "</button>";
  	    }

  	    function bindTransactionRowClicks() {
  	      var listNode = el("fuel-transactions-list");
  	      if (!listNode) return;

  	      var buttons = listNode.querySelectorAll("[data-tx-index]");
  	      for (var i = 0; i < buttons.length; i++) {
  	        buttons[i].onclick = function () {
  	          var idx = toNumber(this.getAttribute("data-tx-index"), -1);
  	          if (idx < 0 || idx >= state.filteredTransactions.length) return;
  	          openTransactionDetail(state.filteredTransactions[idx]);
  	        };
  	      }
  	    }

  	    function renderTransactionListFromState() {
  	      var listNode = el("fuel-transactions-list");
  	      if (!listNode) return;

  	      var transactions = toArray(state.filteredTransactions);

  	      if (!transactions.length) {
  	        listNode.innerHTML = ""
  	        + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	        + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No matching transactions</div>'
  	        + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Try a different search term or clear the filter.</div>'
  	        + "</div>";
  	        return;
  	      }

  	      var html = "";
  	      for (var i = 0; i < transactions.length; i++) {
  	        html += buildTransactionRow(transactions[i], i);
  	      }
  	      listNode.innerHTML = html;
  	      bindTransactionRowClicks();
  	    }

  	    function applyTransactionSearch() {
  	      var raw = valueOf("fuel-transactions-search");
  	      var term = String(raw || "").trim().toLowerCase();
  	      state.searchTerm = term;

  	      var source = toArray(state.transactionCache);
  	      if (!term) {
  	        state.filteredTransactions = source.slice();
  	      } else {
  	        state.filteredTransactions = source.filter(function (item) {
  	          return buildTransactionSearchIndex(item).indexOf(term) >= 0;
  	        });
  	      }

  	      var totals = getFilteredTotals(state.filteredTransactions);
  	      setText("fuel-summary-count", String(totals.count));
  	      setText("fuel-summary-litres", displayNumber(totals.litres, 2));
  	      setText("fuel-summary-cost", formatCurrency(totals.cost));
  	      setText("fuel-summary-rebate", formatCurrency(totals.rebate));
  	      setText("fuel-summary-meter-start", displayNumber(totals.meterStart, 2));
  	      setText("fuel-summary-meter-end", displayNumber(totals.meterEnd, 2));

  	      renderTransactionListFromState();
  	    }

  	    async function renderTransactionsForSelectedView() {
  	      var listNode = el("fuel-transactions-list");
  	      if (!listNode) return;

  	      closeTransactionDetail();

  	      var meta = getSelectedBowserViewMeta();

  	      if (!meta) {
  	        state.transactionCache = [];
  	        state.filteredTransactions = [];
  	        state.selectedHydratedView = null;
  	        setText("fuel-summary-count", "0");
  	        setText("fuel-summary-litres", "0.00");
  	        setText("fuel-summary-cost", "R 0.00");
  	        setText("fuel-summary-rebate", "R 0.00");
  	        setText("fuel-summary-meter-start", "0.00");
  	        setText("fuel-summary-meter-end", "0.00");
  	        listNode.innerHTML = ""
  	        + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	        + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No view selected</div>'
  	        + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">Select ViewC or a historical view to see every transaction for that month.</div>'
  	        + "</div>";
  	        return;
  	      }

  	      try {
  	        listNode.innerHTML = ""
  	        + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	        + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">Loading transactions...</div>'
  	        + "</div>";

  	        var hydratedView = meta.view;

  	        if (meta.objectId) {
  	          hydratedView = await loadTableRow("BowserView", meta.objectId, [
  	            "FuelOut",
  	            "FuelOut.Tractor",
  	            "FuelOut.DriverUser",
  	            "FuelOut.Company",
  	            "FuelOut.Bowser",
  	            "FuelOut.Tank",
  	            "FuelOut.Contractor"
  	          ]);
  	        }

  	        state.selectedHydratedView = hydratedView;

  	        var transactions = getActiveTransactionsOnly(toArray(getDeep(hydratedView, ["FuelOut"], [])));
  	        transactions.sort(function (a, b) {
  	          var da = new Date(text(getDeep(a, ["FuelDate"], ""), "1970-01-01")).getTime();
  	          var db = new Date(text(getDeep(b, ["FuelDate"], ""), "1970-01-01")).getTime();
  	          return db - da;
  	        });

  	        state.transactionCache = transactions.slice();

  	        if (!transactions.length) {
  	          state.filteredTransactions = [];
  	          setText("fuel-summary-count", "0");
  	          setText("fuel-summary-litres", "0.00");
  	          setText("fuel-summary-cost", "R 0.00");
  	          setText("fuel-summary-rebate", "R 0.00");
  	          setText("fuel-summary-meter-start", "0.00");
  	          setText("fuel-summary-meter-end", "0.00");
  	          listNode.innerHTML = ""
  	          + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	          + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">No transactions in this view</div>'
  	          + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">This selected monthly view contains no active FuelOut relations.</div>'
  	          + "</div>";
  	          return;
  	        }

  	        applyTransactionSearch();
  	      } catch (err) {
  	        console.log("Render transactions error:", err);
  	        state.transactionCache = [];
  	        state.filteredTransactions = [];
  	        state.selectedHydratedView = null;
  	        setText("fuel-summary-count", "0");
  	        setText("fuel-summary-litres", "0.00");
  	        setText("fuel-summary-cost", "R 0.00");
  	        setText("fuel-summary-rebate", "R 0.00");
  	        setText("fuel-summary-meter-start", "0.00");
  	        setText("fuel-summary-meter-end", "0.00");
  	        listNode.innerHTML = ""
  	        + '<div style="background:rgba(255,255,255,0.05);border-radius:10px;padding:11px 12px;">'
  	        + '<div style="font-size:13px;font-weight:700;color:#f8fafc;">Failed to load transactions</div>'
  	        + '<div style="margin-top:4px;font-size:11px;color:#94a3b8;">' + escapeHtml(text(err && err.message ? err.message: err, "Unknown error")) + "</div>"
  	        + "</div>";
  	      }
  	    }

  	    function refreshViewSelector() {
  	      var selector = el("fuel-view-selector");
  	      if (!selector) return;

  	      var previous = selector.value;
  	      selector.innerHTML = buildViewOptionsHtmlFromBowser(bowser);

  	      if (previous) selector.value = previous;
  	      if (!selector.value) {
  	        if (getDeep(bowser, ["ViewC", "objectId"], null)) {
  	          selector.value = "VIEWC::" + getDeep(bowser, ["ViewC", "objectId"], "");
  	        } else if (getDeep(bowser, ["ViewC", "MYear"], "")) {
  	          selector.value = "VIEWC";
  	        }
  	      }

  	      renderTransactionsForSelectedView();
  	    }

  	    if (el("fuel-capture-close")) el("fuel-capture-close").onclick = closeModal;
  	    if (el("fuel-cancel-btn")) el("fuel-cancel-btn").onclick = closeModal;

  	    overlay.onclick = function (e) {
  	      if (e.target === overlay) closeModal();
  	    };

  	    if (captureBtn) captureBtn.onclick = showCapture;
  	    if (transactionsBtn) transactionsBtn.onclick = showTransactions;

  	    var detailBackdrop = el("fuel-transaction-detail-backdrop");
  	    if (detailBackdrop) {
  	      detailBackdrop.onclick = function (e) {
  	        if (e.target === detailBackdrop) closeTransactionDetail();
  	      };
  	    }

  	    if (el("fuel-detail-close")) {
  	      el("fuel-detail-close").onclick = closeTransactionDetail;
  	    }

  	    if (el("fuel-detail-print")) {
  	      el("fuel-detail-print").onclick = function () {
  	        if (!state.selectedTransaction) {
  	          alert("No transaction selected.");
  	          return;
  	        }
  	        openSingleTransactionPrintWindow(state.selectedTransaction);
  	      };
  	    }

  	    if (el("fuel-detail-rollback")) {
  	      el("fuel-detail-rollback").onclick = async function () {
  	        try {
  	          if (!state.selectedTransaction) {
  	            alert("No transaction selected.");
  	            return;
  	          }

  	          var confirmMessage =
  	          "Rollback from this transaction onward?\n\n" +
  	          "This will reverse this transaction and every later active transaction in the current live view.";

  	          if (!window.confirm(confirmMessage)) {
  	            return;
  	          }

  	          setButtonBusy(el("fuel-detail-rollback"), true, "Rolling Back...");

  	          var result = await rollbackToTransaction(state.selectedTransaction);

  	          closeTransactionDetail();
  	          refreshViewSelector();
  	          showTransactions();

  	          alert(
  	            "Rollback completed.\n" +
  	            "Transactions reversed: " + String(result.count) + "\n" +
  	            "Litres restored to tank: " + displayNumber(result.litres, 2) + "\n" +
  	            "Rollback Group: " + result.rollbackGroupId
  	          );
  	        } catch (rollbackErr) {
  	          console.log("Rollback error:", rollbackErr);
  	          alert("Rollback failed: " + (rollbackErr && rollbackErr.message ? rollbackErr.message: rollbackErr));
  	        } finally {
  	          setButtonBusy(el("fuel-detail-rollback"), false, "Rollback To Here");
  	        }
  	      };
  	    }

  	    var captureTypeNode = el("fuel-capture-type");
  	    if (captureTypeNode) {
  	      captureTypeNode.addEventListener("change", function () {
  	        clearCaptureValues();
  	        refreshCaptureVisibility();
  	      });
  	    }

  	    bindChangeRefresh("fuel-company-application");
  	    bindChangeRefresh("fuel-company-application-other");
  	    bindChangeRefresh("fuel-company-registration");
  	    bindChangeRefresh("fuel-company-registration-other");
  	    bindChangeRefresh("fuel-company-driver");
  	    bindChangeRefresh("fuel-company-driver-other");
  	    bindChangeRefresh("fuel-contractor-name", rebuildContractorRegistrations);
  	    bindChangeRefresh("fuel-contractor-name-other");
  	    bindChangeRefresh("fuel-contractor-application");
  	    bindChangeRefresh("fuel-contractor-application-other");
  	    bindChangeRefresh("fuel-contractor-registration");
  	    bindChangeRefresh("fuel-contractor-registration-other");
  	    bindChangeRefresh("fuel-contractor-driver");
  	    bindChangeRefresh("fuel-intertank-target");
  	    bindChangeRefresh("fuel-description");

  	    applyNumericSanitizer("fuel-mileage");
  	    applyNumericSanitizer("fuel-litres");
  	    applyNumericSanitizer("fuel-meter");

  	    if (el("fuel-view-selector")) {
  	      el("fuel-view-selector").addEventListener("change", function () {
  	        renderTransactionsForSelectedView();
  	      });
  	    }

  	    if (el("fuel-transactions-search")) {
  	      el("fuel-transactions-search").addEventListener("input", function () {
  	        applyTransactionSearch();
  	      });
  	    }

  	    if (el("fuel-search-clear")) {
  	      el("fuel-search-clear").onclick = function () {
  	        setValue("fuel-transactions-search", "");
  	        applyTransactionSearch();
  	      };
  	    }

  	    if (el("fuel-print-btn")) {
  	      el("fuel-print-btn").onclick = function () {
  	        openPrintWindow();
  	      };
  	    }

  	    renderTankGauge(tankBlock, tank);
  	    rebuildContractorRegistrations();
  	    refreshCaptureVisibility();
  	    refreshViewSelector();
  	    showTransactions();

  	    if (el("fuel-save-btn")) {
  	      el("fuel-save-btn").onclick = async function () {
  	        try {
  	          if (!isComplete()) {
  	            alert("Cannot save. The figures are not valid yet.");
  	            return;
  	          }

  	          var saveButton = el("fuel-save-btn");
  	          setButtonBusy(saveButton, true, "Saving...");

  	          var mode = valueOf("fuel-capture-type");
  	          var tolerance = 0.05;
  	          var now = getNowDate();

  	          var activeVehicle = getActiveVehicle();
  	          var activeContractor = getSelectedContractorObject();
  	          var selectedDriverObj = getSelectedDriverOption();
  	          var intertankValidation = validateIntertankTarget();
  	          var selectedIntertankTank = intertankValidation.targetTank || null;

  	          if (mode === "intertank" && !intertankValidation.ok) {
  	            alert("Cannot save. The intertank destination is not valid.");
  	            return;
  	          }

  	          var applicationValue = mode === "company"
  	          ? (valueOf("fuel-company-application") === "OTHER" ? valueOf("fuel-company-application-other"): valueOf("fuel-company-application")): mode === "contractor"
  	          ? (valueOf("fuel-contractor-application") === "OTHER" ? valueOf("fuel-contractor-application-other"): valueOf("fuel-contractor-application")): "";

  	          var registrationValue = "";

  	          if (mode === "company") {
  	            if (valueOf("fuel-company-registration") === "OTHER") {
  	              registrationValue = valueOf("fuel-company-registration-other");
  	            } else if (activeVehicle) {
  	              registrationValue = text(
  	                firstDefined(
  	                  getDeep(activeVehicle, ["ID"], null),
  	                  getDeep(activeVehicle, ["TractorID"], null),
  	                  getDeep(activeVehicle, ["FID"], null)
  	                ),
  	                ""
  	              );
  	            }
  	          } else if (mode === "contractor") {
  	            if (valueOf("fuel-contractor-registration") === "OTHER") {
  	              registrationValue = valueOf("fuel-contractor-registration-other");
  	            } else if (activeVehicle) {
  	              registrationValue = text(
  	                firstDefined(
  	                  getDeep(activeVehicle, ["ID"], null),
  	                  getDeep(activeVehicle, ["TractorID"], null),
  	                  getDeep(activeVehicle, ["FID"], null)
  	                ),
  	                ""
  	              );
  	            }
  	          }

  	          var driverValue = mode === "company"
  	          ? (valueOf("fuel-company-driver") === "OTHER" ? valueOf("fuel-company-driver-other"): valueOf("fuel-company-driver")): mode === "contractor"
  	          ? valueOf("fuel-contractor-driver"): "";

  	          var contractorValue = mode === "contractor"
  	          ? (valueOf("fuel-contractor-name") === "OTHER" ? valueOf("fuel-contractor-name-other"): valueOf("fuel-contractor-name")): "";

  	          var mileageNew = toNumber(valueOf("fuel-mileage"), 0);
  	          var litres = toNumber(valueOf("fuel-litres"), 0);
  	          var meterNew = toNumber(valueOf("fuel-meter"), 0);
  	          var meterLast = toNumber(getDeep(bowser, ["Meter"], 0), 0);
  	          var mileageLast = activeVehicle ? toNumber(getDeep(activeVehicle, ["Mileage"], 0), 0): 0;
  	          var distance = activeVehicle ? (mileageNew - mileageLast): 0;
  	          var intertankTargetId = selectedIntertankTank ? getDeep(selectedIntertankTank, ["objectId"], null): null;
  	          var intertankTargetName = selectedIntertankTank
  	          ? text(firstDefined(getDeep(selectedIntertankTank, ["Name"], null), getDeep(selectedIntertankTank, ["DeviceId"], null)), ""): "";

  	          var costPerLitre = getTankCostPerLitre(tank);
  	          var transactionCost = litres * costPerLitre;
  	          var sarsCompliant = activeVehicle ? isVehicleSarsCompliant(activeVehicle): false;
  	          var potentialSarsRebate = sarsCompliant ? (litres * 3.00): 0;

  	          var driverDisplayName = mode === "company"
  	          ? text(
  	            firstDefined(
  	              getDeep(selectedDriverObj, ["name"], null),
  	              getDeep(selectedDriverObj, ["Name"], null),
  	              driverValue
  	            ),
  	            ""
  	          ): driverValue;

  	          var fuelOutRow = {
  	            FuelDate: now,
  	            CaptureType: mode,
  	            Application: applicationValue,
  	            Registration: registrationValue,
  	            Driver: driverValue,
  	            DriverName: driverDisplayName,
  	            Litres: litres,
  	            CostPerLitre: costPerLitre,
  	            Cost: transactionCost,
  	            SARSCompliance: sarsCompliant,
  	            PotentialSARSRebate: potentialSarsRebate,
  	            Mileage: mode === "other" ? null: mileageNew,
  	            MileageLast: mode === "other" ? null: mileageLast,
  	            Distance: mode === "other" ? 0: distance,
  	            Meter: meterNew,
  	            MeterLast: meterLast,
  	            Tolerance: tolerance,
  	            Description: valueOf("fuel-description") || "",
  	            IsReversed: false,
  	            Reversed: false,
  	            RollbackStatus: "active",
  	            RollbackGroupId: "",
  	            RollbackProtected: false,
  	            RollbackProtectionType: "none"
  	          };

  	          if (company && company.objectId) fuelOutRow.Company = {
  	            objectId: company.objectId
  	          };
  	          if (tank && tank.objectId) fuelOutRow.Tank = {
  	            objectId: tank.objectId
  	          };
  	          if (bowser && bowser.objectId) fuelOutRow.Bowser = {
  	            objectId: bowser.objectId
  	          };
  	          if (mode !== "other" && activeVehicle && activeVehicle.objectId) fuelOutRow.Tractor = {
  	            objectId: activeVehicle.objectId
  	          };
  	          if (mode === "contractor" && activeContractor && activeContractor.objectId) fuelOutRow.Contractor = {
  	            objectId: activeContractor.objectId
  	          };
  	          if (mode === "company" && selectedDriverObj && selectedDriverObj.objectId) fuelOutRow.DriverUser = {
  	            objectId: selectedDriverObj.objectId
  	          };

  	          var savedTransaction = await saveTableRow("FuelOut", fuelOutRow);

  	          var workingTank = deepClone(await loadTableRow("Tanks", tank.objectId, ["Bowsers"]));
  	          var workingBowser = deepClone(await loadTableRow("Bowsers", bowser.objectId, ["ViewC", "ViewH"]));
  	          var workingCompany = deepClone(await loadTableRow("Companies", company.objectId, ["Tanks", "Tractors"]));
  	          var workingVehicle = mode === "other" || !activeVehicle ? null: deepClone(await loadTableRow("Tractors", activeVehicle.objectId, ["ViewC", "ViewH"]));
  	          var workingContractor = mode === "contractor" && activeContractor && activeContractor.objectId
  	          ? deepClone(await loadTableRow("Companies", activeContractor.objectId, ["Tractors"])): null;
  	          var workingDestinationTank = mode === "intertank" && selectedIntertankTank && selectedIntertankTank.objectId
  	          ? deepClone(await loadTableRow("Tanks", selectedIntertankTank.objectId, ["Bowsers"])): null;

  	          var tankVolumeOld = toNumber(getDeep(workingTank, ["Volume"], 0), 0);
  	          var tankCapacity = toNumber(getDeep(workingTank, ["Capacity"], 0), 0);
  	          var tankVolumeNew = tankVolumeOld - litres;

  	          if (tankVolumeNew < 0) {
  	            throw new Error("Tank volume cannot go below 0. Available volume is " + displayNumber(tankVolumeOld, 2));
  	          }

  	          workingTank.Volume = tankVolumeNew;
  	          if (tankCapacity > 0) {
  	            workingTank.Level = (tankVolumeNew / tankCapacity) * 100;
  	          }

  	          workingBowser.Meter = meterNew;

  	          var bowserView = ensureBowserViewRow(workingBowser, meterLast, now);
  	          bowserView.Litres = toNumber(getDeep(bowserView, ["Litres"], 0), 0) + litres;
  	          bowserView.MeterEnd = meterNew;

  	          var savedBowserView = await saveTableRow("BowserView", bowserView);
  	          workingBowser.ViewC = savedBowserView;

  	          await syncBowserViewRelations(workingBowser, savedBowserView);

  	          var savedVehicleView = null;
  	          if (mode !== "other" && workingVehicle) {
  	            workingVehicle.Mileage = mileageNew;

  	            if (
  	              getDeep(workingVehicle, ["Data"], null) &&
  	              getDeep(workingVehicle, ["Data", "OperationalTargets"], null) &&
  	              getDeep(workingVehicle, ["Data", "OperationalTargets", "Fuel_Counter"], null)
  	            ) {
  	              workingVehicle.Data.OperationalTargets.Fuel_Counter.value =
  	              toNumber(getDeep(workingVehicle, ["Data", "OperationalTargets", "Fuel_Counter", "value"], 0), 0) + 1;
  	            }

  	            var vehicleView = ensureVehicleViewRow(workingVehicle, now);

  	            var transactionDistance = mileageNew - mileageLast;
  	            if (transactionDistance < 0) transactionDistance = 0;

  	            vehicleView.TransactionCount = toNumber(getDeep(vehicleView, ["TransactionCount"], 0), 0) + 1;

  	            // Tractorview meter fields must use tractor mileage, not bowser meter.
  	            if (
  	              getDeep(vehicleView, ["MeterStart"], null) === null ||
  	              getDeep(vehicleView, ["MeterStart"], null) === undefined ||
  	              getDeep(vehicleView, ["MeterStart"], null) === "" ||
  	              toNumber(getDeep(vehicleView, ["MeterStart"], 0), 0) <= 0
  	            ) {
  	              vehicleView.MeterStart = mileageLast;
  	            } else {
  	              vehicleView.MeterStart = toNumber(getDeep(vehicleView, ["MeterStart"], mileageLast), mileageLast);
  	            }

  	            vehicleView.MeterEnd = mileageNew;

  	            // Add this fuel transaction's distance onto the monthly ViewC distance.
  	            vehicleView.Distance = toNumber(getDeep(vehicleView, ["Distance"], 0), 0) + transactionDistance;

  	            vehicleView.Litres = toNumber(getDeep(vehicleView, ["Litres"], 0), 0) + litres;
  	            vehicleView.Cost = toNumber(getDeep(vehicleView, ["Cost"], 0), 0) + transactionCost;
  	            vehicleView.PotentialSARSRebate = toNumber(getDeep(vehicleView, ["PotentialSARSRebate"], 0), 0) + potentialSarsRebate;

  	            savedVehicleView = await saveTableRow("Tractorview", vehicleView);
  	            workingVehicle.ViewC = savedVehicleView;

  	            await saveTableRow("Tractors", workingVehicle);
  	            await syncVehicleViewRelations(workingVehicle, savedVehicleView);

  	            if (mode === "company") {
  	              replaceNestedCompanyVehicle(workingCompany, workingVehicle);
  	            }

  	            if (mode === "contractor" && workingContractor) {
  	              replaceNestedCompanyVehicle(workingContractor, workingVehicle);
  	            }
  	          }

  	          var tankBowsers = toArray(getDeep(workingTank, ["Bowsers"], []));
  	          var tankBowserIndex = findIndexByKeys(tankBowsers, workingBowser);
  	          if (tankBowserIndex >= 0) {
  	            tankBowsers[tankBowserIndex] = deepClone(workingBowser);
  	            workingTank.Bowsers = tankBowsers;
  	          }

  	          if (mode === "intertank" && workingDestinationTank) {
  	            var destinationVolumeOld = toNumber(getDeep(workingDestinationTank, ["Volume"], 0), 0);
  	            var destinationCapacity = toNumber(getDeep(workingDestinationTank, ["Capacity"], 0), 0);
  	            var destinationVolumeNew = destinationVolumeOld + litres;

  	            if (destinationCapacity > 0 && destinationVolumeNew > destinationCapacity) {
  	              throw new Error("Destination tank cannot exceed capacity.");
  	            }

  	            workingDestinationTank.Volume = destinationVolumeNew;
  	            if (destinationCapacity > 0) {
  	              workingDestinationTank.Level = (destinationVolumeNew / destinationCapacity) * 100;
  	            }

  	            replaceNestedCompanyTank(workingCompany, workingDestinationTank);
  	          }

  	          replaceNestedCompanyTank(workingCompany, workingTank);

  	          if (mode === "intertank") {
  	            var sourceTankIdForSync = getDeep(workingTank, ["objectId"], null);
  	            var destinationTankIdForSync = getDeep(workingDestinationTank, ["objectId"], null);

  	            if (sourceTankIdForSync) {
  	              syncTankIntoLiveAppData(workingTank);
  	            }

  	            if (destinationTankIdForSync) {
  	              syncTankIntoLiveAppData(workingDestinationTank);
  	            }

  	            syncCompanyIntoLiveAppData(workingCompany);

  	            if (tank && sameObjectId(getDeep(tank, ["objectId"], null), sourceTankIdForSync)) {
  	              tank.Volume = workingTank.Volume;
  	              tank.Level = workingTank.Level;
  	            }

  	            if (
  	              company &&
  	              (
  	                sameKey(getDeep(company, ["objectId"], null), getDeep(workingCompany, ["objectId"], null)) ||
  	                sameKey(getDeep(company, ["CompanyId"], null), getDeep(workingCompany, ["CompanyId"], null))
  	              )
  	            ) {
  	              // Intertank does not touch tractors.
  	              // Never assign company.Tractors from workingCompany here.
  	            }

  	            // Do not assign tank.Bowsers.
  	            // Do not assign company.Tanks.
  	            // Do not force refresh the repeater.
  	          }

  	          var saveJobs = [];
  	          saveJobs.push(saveTableRow("Tanks", workingTank));
  	          saveJobs.push(saveTableRow("Bowsers", workingBowser));

  	          if (mode === "intertank" && workingDestinationTank && workingDestinationTank.objectId) {
  	            saveJobs.push(saveTableRow("Tanks", workingDestinationTank));
  	          }

  	          if (mode !== "other" && mode !== "intertank" && workingVehicle && workingVehicle.objectId) {
  	            saveJobs.push(saveTableRow("Tractors", workingVehicle));
  	          }
  	          if (workingCompany && workingCompany.objectId) {
  	            // Do not save Companies during fuel capture.
  	            // Tanks, Bowsers, Tractor views, and FuelOut are saved directly.
  	            // Saving Companies with partial nested Tanks can damage repeater relation snapshots.
  	            // saveJobs.push(saveTableRow("Companies", workingCompany));
  	          }

  	          if (mode === "contractor" && workingContractor && workingContractor.objectId) {
  	            // Do not save the whole contractor company row during fuel capture.
  	            // The tractor itself has already been saved directly.
  	            // Saving a company row with partial Tractors can damage relation snapshots.
  	            // saveJobs.push(saveTableRow("Companies", workingContractor));
  	          }

  	          await Promise.all(saveJobs);

  	          // Do not force a full AppData/repeater refresh here.
  	          // Backendless repeater redraw causes visible layout shifts on the tank/nozzle rows.
  	          // We update the live objects and the current tank gauge manually below.

  	          if (savedTransaction && savedTransaction.objectId && savedBowserView && savedBowserView.objectId) {
  	            await addRelation("BowserView", savedBowserView.objectId, "FuelOut", [savedTransaction.objectId]);
  	          }

  	          if (mode !== "other" && mode !== "intertank" && savedTransaction && savedTransaction.objectId && savedVehicleView && savedVehicleView.objectId) {
  	            await addRelation("Tractorview", savedVehicleView.objectId, "Fuel", [savedTransaction.objectId]);
  	          }

  	          tank.Volume = workingTank.Volume;
  	          tank.Level = workingTank.Level;

  	          // Do not overwrite tank.Bowsers here.
  	          // The working tank may contain only the currently loaded bowser relation,
  	          // which causes the other bowser/nozzle to vanish from the repeater UI.

  	          bowser.Meter = workingBowser.Meter;
  	          bowser.ViewC = savedBowserView;
  	          bowser.ViewH = workingBowser.ViewH;

  	          if (company && mode === "company" && workingVehicle) {
  	            // Merge only the active tractor into the live company object.
  	            // Never replace the whole company.Tractors array.
  	            replaceNestedCompanyVehicle(company, workingVehicle);
  	          }

  	          if (mode === "contractor" && activeContractor && workingVehicle) {
  	            // If the selected contractor object is live in the UI, merge only the active tractor.
  	            replaceNestedCompanyVehicle(activeContractor, workingVehicle);
  	          }

  	          if (mode === "intertank" && workingDestinationTank) {
  	            syncTankIntoLiveAppData(workingDestinationTank);
  	            syncTankIntoLiveAppData(workingTank);
  	            syncCompanyIntoLiveAppData(workingCompany);

  	            // Do not call forceAppDataRefresh() here.
  	            // The repeater must not be rebuilt during the save flow.
  	          }

  	          if (mode !== "other" && mode !== "intertank" && activeVehicle && workingVehicle) {
  	            activeVehicle.Mileage = workingVehicle.Mileage;
  	            activeVehicle.ViewC = savedVehicleView;
  	            activeVehicle.ViewH = workingVehicle.ViewH;

  	            if (
  	              getDeep(activeVehicle, ["Data"], null) &&
  	              getDeep(activeVehicle, ["Data", "OperationalTargets"], null) &&
  	              getDeep(activeVehicle, ["Data", "OperationalTargets", "Fuel_Counter"], null)
  	            ) {
  	              activeVehicle.Data.OperationalTargets.Fuel_Counter.value =
  	              getDeep(workingVehicle, ["Data", "OperationalTargets", "Fuel_Counter", "value"], 0);
  	            }
  	          }

  	          renderTankGauge(tankBlock, tank);
  	          clearCaptureValues();
  	          refreshCaptureVisibility();
  	          refreshViewSelector();
  	          showTransactions();
  	          alert("Fuel transaction saved and linked to bowser and tractor views.");
  	        } catch (saveErr) {
  	          console.log("Fuel save error:", saveErr);
  	          alert("Save failed: " + (saveErr && saveErr.message ? saveErr.message: saveErr));
  	        } finally {
  	          setButtonBusy(el("fuel-save-btn"), false, "Save");
  	        }
  	      };
  	    }

  	    return null;
  	  } catch (err) {
  	    console.log("Fuel capture full rewrite error:", err);
  	    return null;
  	  }
  	})();
  })(___arguments.context.appData, ___arguments.context.getComponentDataStoreByUid('ba58c7483308e8d80bf4856482a2db18'), ___arguments.context.getComponentDataStoreByUid('094e17f8898856d8d834001dcb08bbfb'), ___arguments.context.dataModel, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ba58c7483308e8d80bf4856482a2db18'), 'Contractors')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea09807bde56b1d84b0a9456edc38c98')), 'data:image/png;base64,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', Tank_Data);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/e0782948458512089fd89fd8698a0afc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, Meter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Meter = (await (async function(Meter, Digits, Decimals) {
    	try {
    	
    	  var meter = Number(Meter);
    	  var digits = Number(Digits);
    	  var decimals = Number(Decimals);
    	
    	  if (isNaN(meter)) {
    	    meter = 0;
    	  }
    	
    	  if (isNaN(digits) || digits < 0) {
    	    digits = 0;
    	  }
    	
    	  if (isNaN(decimals) || decimals < 0) {
    	    decimals = 0;
    	  }
    	
    	  // Round and force decimals
    	  var formatted = meter.toFixed(decimals);
    	
    	  // Calculate final length
    	  var totalLength = digits + 1 + decimals;
    	
    	  // Pad with leading zeros
    	  var padded = formatted.padStart(totalLength, "0");
    	
    	  return padded;
    	
    	} catch (err) {
    	  console.log(err);
    	  return "";
    	}
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('54417ef8ea821cf8abb84aa3f8f54378'), 'Meter')), 7, 2));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Meter = 'error';
    }

  }

  return Meter

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/a0384ac44d4836f9e7288a83b348d551/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error, Name;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Name = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54417ef8ea821cf8abb84aa3f8f54378'), 'Name'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Name = 'error';
    }

  }

  return Name

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/6738e8d829d885288478f12baa387d11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ('Commercial' == (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Viewer'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/892841c86ebef0164957cfc95148b058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, Tractors, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ('Agri' == (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Viewer'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/c6dffb3502e3156831a8fc78e6254918/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ('Private' == (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Viewer'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/a0c3f6987e8835e868c7cd3823a826f8/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var error, Tractors, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Tractors2() {
  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if ((getObjectProperty(k, 'Type')) == 'Private') {
        addItemToList(Tractors, k);
      }
    }
  }
  return Tractors
}


  try {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a0c3f6987e8835e868c7cd3823a826f8', (await Tractors2()));

  } catch (error) {

  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Office/components/3468287ae47b1a58eedbcc7838683f7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Menu_Closers() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fc90fe85fb3fdb851e842383a2cbe6d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb589f58823489b55d73a8c86512ba2a', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fd81dee1f1852b56f34b68de1d3d46e', false);

  } catch (error) {
    console.log(error);

  }
}


  await Menu_Closers();
  await (async function(Companies, User) {
  	/*
  	Fleet In Form - User Creator & Editor
  	Option A: Real Backendless Login Users
  	
  	Features:
  	- Browse users in a table
  	- Search users
  	- Click a user to edit
  	- Create new user
  	- Save to Users table
  	- Sync Companies.Employees relation
  	- Fullscreen modal UI
  	*/
  	
  	return (function () {
  	  try {
  	    var appData = (typeof AppData !== "undefined" ? AppData : null);
  	    var companiesInput = (typeof Companies !== "undefined" ? Companies : []);
  	    var currentUser = (typeof CurrentUser !== "undefined" ? CurrentUser : null);
  	    var backendless = (typeof Backendless !== "undefined" ? Backendless : null);
  	    var existingUserInput = (typeof ExistingUser !== "undefined" ? ExistingUser : null);
  	    var modeInput = (typeof Mode !== "undefined" ? Mode : null);
  	    var mountBlock = (typeof MountBlock !== "undefined" ? MountBlock : null);
  	
  	    function toArray(value) {
  	      if (Array.isArray(value)) return value;
  	      if (value === null || value === undefined) return [];
  	      return [value];
  	    }
  	
  	    function text(value, fallback) {
  	      if (value === null || value === undefined || value === "") return fallback;
  	      return String(value);
  	    }
  	
  	    function escapeHtml(value) {
  	      return String(value)
  	        .replace(/&/g, "&amp;")
  	        .replace(/</g, "&lt;")
  	        .replace(/>/g, "&gt;")
  	        .replace(/"/g, "&quot;")
  	        .replace(/'/g, "&#39;");
  	    }
  	
  	    function normalizeString(value) {
  	      return text(value, "").trim();
  	    }
  	
  	    function normalizeEmail(value) {
  	      return normalizeString(value).toLowerCase();
  	    }
  	
  	    function toBool(value) {
  	      return value === true || value === 1 || String(value).toLowerCase() === "true";
  	    }
  	
  	    function firstDefined() {
  	      for (var i = 0; i < arguments.length; i++) {
  	        if (arguments[i] !== null && arguments[i] !== undefined && arguments[i] !== "") {
  	          return arguments[i];
  	        }
  	      }
  	      return null;
  	    }
  	
  	    function getDeep(obj, path, fallback) {
  	      try {
  	        var current = obj;
  	        for (var i = 0; i < path.length; i++) {
  	          if (current == null) return fallback;
  	          current = current[path[i]];
  	        }
  	        return current == null ? fallback : current;
  	      } catch (e) {
  	        return fallback;
  	      }
  	    }
  	
  	    function deepClone(value) {
  	      try {
  	        return JSON.parse(JSON.stringify(value));
  	      } catch (e) {
  	        return value;
  	      }
  	    }
  	
  	    function isObject(value) {
  	      return !!value && typeof value === "object" && !Array.isArray(value);
  	    }
  	
  	    function deepMerge(target, source) {
  	      target = isObject(target) ? target : {};
  	      if (!isObject(source)) return target;
  	
  	      Object.keys(source).forEach(function (key) {
  	        var srcVal = source[key];
  	        var tgtVal = target[key];
  	
  	        if (Array.isArray(srcVal)) {
  	          target[key] = deepClone(srcVal);
  	          return;
  	        }
  	
  	        if (isObject(srcVal)) {
  	          target[key] = deepMerge(isObject(tgtVal) ? tgtVal : {}, srcVal);
  	          return;
  	        }
  	
  	        target[key] = srcVal;
  	      });
  	
  	      return target;
  	    }
  	
  	    function uniqueByValue(list) {
  	      var seen = {};
  	      var out = [];
  	
  	      for (var i = 0; i < list.length; i++) {
  	        var item = list[i];
  	        var key = String(getDeep(item, ["value"], "") || "").trim().toLowerCase();
  	        if (!key) continue;
  	        if (!seen[key]) {
  	          seen[key] = true;
  	          out.push(item);
  	        }
  	      }
  	
  	      return out;
  	    }
  	
  	    function normalizeOption(value, label, raw) {
  	      return {
  	        value: text(value, ""),
  	        label: text(label || value, ""),
  	        raw: raw || null
  	      };
  	    }
  	
  	    function buildOptionsHtml(options, placeholder, selectedValue) {
  	      var html = "";
  	
  	      if (placeholder) {
  	        html += '<option value="">' + escapeHtml(placeholder) + "</option>";
  	      }
  	
  	      for (var i = 0; i < options.length; i++) {
  	        var opt = options[i];
  	        var selected = String(opt.value) === String(selectedValue || "") ? ' selected="selected"' : "";
  	        html += '<option value="' + escapeHtml(opt.value) + '"' + selected + ">" + escapeHtml(opt.label) + "</option>";
  	      }
  	
  	      return html;
  	    }
  	
  	    function buildCompanyOptions(items) {
  	      var arr = toArray(items);
  	      var out = [];
  	
  	      for (var i = 0; i < arr.length; i++) {
  	        var item = arr[i];
  	        var label = firstDefined(
  	          getDeep(item, ["Name"], null),
  	          getDeep(item, ["CompanyId"], null),
  	          getDeep(item, ["name"], null),
  	          "Company " + (i + 1)
  	        );
  	
  	        var value = firstDefined(
  	          getDeep(item, ["objectId"], null),
  	          getDeep(item, ["CompanyId"], null),
  	          label
  	        );
  	
  	        out.push(normalizeOption(value, label, item));
  	      }
  	
  	      return uniqueByValue(out);
  	    }
  	
  	    function getDefaultEmployeeDetails() {
  	      return {
  	        gender: "",
  	        address: {
  	          city: "",
  	          street: "",
  	          suburb: "",
  	          province: "",
  	          postal_code: ""
  	        },
  	        passport: {
  	          issue_date: "",
  	          expiry_date: "",
  	          passport_number: "",
  	          country_of_issue: ""
  	        },
  	        id_number: "",
  	        last_name: "",
  	        first_name: "",
  	        tax_number: "",
  	        employee_id: "",
  	        nationality: "",
  	        next_of_kin: {
  	          email: "",
  	          address: {
  	            city: "",
  	            street: "",
  	            suburb: "",
  	            province: "",
  	            postal_code: ""
  	          },
  	          last_name: "",
  	          first_name: "",
  	          phone_number: "",
  	          relationship: ""
  	        },
  	        date_of_birth: "",
  	        marital_status: "",
  	        contact_details: {
  	          email: "",
  	          phone_number: ""
  	        },
  	        drivers_license: {
  	          pdp: {
  	            pdp_number: "",
  	            expiry_date: ""
  	          },
  	          permits: [],
  	          issue_date: "",
  	          expiry_date: "",
  	          endorsements: [],
  	          license_code: "",
  	          license_number: "",
  	          available_license_codes: ["A1", "A", "B", "C1", "C", "EB", "EC1", "EC"]
  	        },
  	        emergency_contacts: [],
  	        employment_details: {
  	          job_title: "",
  	          department: "",
  	          start_date: "",
  	          bank_details: {
  	            bank_name: "",
  	            branch_code: "",
  	            account_number: ""
  	          },
  	          pay_frequency: "Monthly",
  	          employment_type: "Permanent",
  	          work_hours_per_week: "",
  	          employment_start_date: ""
  	        }
  	      };
  	    }
  	
  	    function getDefaultWages() {
  	      return {
  	        wage_rates: {
  	          employee_id: "",
  	          deductions: {},
  	          other_earnings: {},
  	          pay_components: {
  	            base_salary: {
  	              amount: 0,
  	              pay_frequency: "Monthly"
  	            }
  	          }
  	        }
  	      };
  	    }
  	
  	    function getDefaultUserRecord() {
  	      return {
  	        APP: "FIFC",
  	        userStatus: "ENABLED",
  	        loginEnabled: true,
  	        mustChangePassword: true,
  	        Role: null,
  	        name: "",
  	        email: "",
  	        password: "",
  	        Data_Leave: null,
  	        Data_Details: {
  	          employee_details: getDefaultEmployeeDetails()
  	        },
  	        Data_Wages: getDefaultWages()
  	      };
  	    }
  	
  	    function buildDisplayName(user) {
  	      var details = getDeep(user, ["Data_Details", "employee_details"], {});
  	      var firstName = normalizeString(getDeep(details, ["first_name"], ""));
  	      var lastName = normalizeString(getDeep(details, ["last_name"], ""));
  	      var fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
  	      return fullName || normalizeString(getDeep(user, ["name"], ""));
  	    }
  	
  	    function sanitizeAppString(value) {
  	      if (Array.isArray(value)) {
  	        return value.map(function (item) {
  	          return normalizeString(item);
  	        }).filter(Boolean).join(",");
  	      }
  	      return normalizeString(value);
  	    }
  	
  	    function buildCanonicalUserPayload(source) {
  	      var base = getDefaultUserRecord();
  	      var payload = deepMerge(base, source || {});
  	
  	      var details = getDeep(payload, ["Data_Details", "employee_details"], {});
  	      var contact = getDeep(details, ["contact_details"], {});
  	      var employment = getDeep(details, ["employment_details"], {});
  	
  	      contact.email = normalizeEmail(firstDefined(contact.email, payload.email, ""));
  	      details.contact_details = contact;
  	      payload.email = contact.email;
  	
  	      details.first_name = normalizeString(details.first_name);
  	      details.last_name = normalizeString(details.last_name);
  	      details.id_number = normalizeString(details.id_number);
  	      details.employee_id = normalizeString(details.employee_id);
  	      details.contact_details.phone_number = normalizeString(contact.phone_number);
  	
  	      employment.department = normalizeString(employment.department);
  	      employment.job_title = normalizeString(employment.job_title);
  	      details.employment_details = employment;
  	
  	      payload.Data_Details.employee_details = details;
  	      payload.name = buildDisplayName(payload);
  	      payload.APP = sanitizeAppString(payload.APP);
  	      payload.loginEnabled = toBool(payload.loginEnabled);
  	      payload.mustChangePassword = toBool(payload.mustChangePassword);
  	
  	      if (!payload.Local_Key && details.id_number) {
  	        payload.Local_Key = details.id_number;
  	      }
  	
  	      if (!payload.ID && details.id_number) {
  	        payload.ID = details.id_number;
  	      }
  	
  	      if (!getDeep(payload, ["Data_Wages", "wage_rates", "employee_id"], "") && details.employee_id) {
  	        payload.Data_Wages.wage_rates.employee_id = details.employee_id;
  	      }
  	
  	      return payload;
  	    }
  	
  	    function validatePayload(payload, mode) {
  	      var errors = [];
  	      var details = getDeep(payload, ["Data_Details", "employee_details"], {});
  	      var employment = getDeep(details, ["employment_details"], {});
  	
  	      if (!normalizeString(details.first_name)) errors.push("First name is required.");
  	      if (!normalizeString(details.last_name)) errors.push("Last name is required.");
  	      if (!normalizeString(payload.email)) errors.push("Email is required.");
  	      if (!normalizeString(details.employee_id) && !normalizeString(details.id_number)) errors.push("Employee ID or ID number is required.");
  	      if (!normalizeString(getDeep(details, ["contact_details", "phone_number"], ""))) errors.push("Phone number is required.");
  	      if (!normalizeString(employment.department)) errors.push("Department is required.");
  	      if (!normalizeString(employment.job_title)) errors.push("Job title is required.");
  	      if (mode === "create" && !normalizeString(payload.password)) errors.push("Password is required for new users.");
  	
  	      return errors;
  	    }
  	
  	    function getCompaniesRelationFromUser(userObj) {
  	      var companies = toArray(getDeep(userObj, ["Companies"], []));
  	      var out = [];
  	
  	      for (var i = 0; i < companies.length; i++) {
  	        if (getDeep(companies[i], ["objectId"], null)) {
  	          out.push(companies[i].objectId);
  	        }
  	      }
  	
  	      return out;
  	    }
  	
  	    function escapeWhereValue(value) {
  	      return String(value).replace(/'/g, "\\'");
  	    }
  	
  	    async function findUsers(whereClause, pageSize, related) {
  	      var builder = backendless.DataQueryBuilder.create();
  	      if (whereClause) builder.setWhereClause(whereClause);
  	      builder.setPageSize(pageSize || 50);
  	      if (related && related.length) {
  	        builder.setRelated(related);
  	      }
  	      return backendless.Data.of("Users").find(builder);
  	    }
  	
  	    async function findAllUsers(pageSize) {
  	      var builder = backendless.DataQueryBuilder.create();
  	      builder.setPageSize(pageSize || 100);
  	      builder.setRelated(["Companies"]);
  	      return backendless.Data.of("Users").find(builder);
  	    }
  	
  	    async function getUserByObjectId(objectId) {
  	      var rows = await findUsers(
  	        "objectId = '" + escapeWhereValue(objectId) + "'",
  	        1,
  	        ["Companies"]
  	      );
  	      return (rows || [])[0] || null;
  	    }
  	
  	    async function getUserByEmail(email) {
  	      var safe = normalizeEmail(email);
  	      if (!safe) return null;
  	      var rows = await findUsers(
  	        "email = '" + escapeWhereValue(safe) + "'",
  	        1
  	      );
  	      return (rows || [])[0] || null;
  	    }
  	
  	    async function getUserByEmployeeId(employeeId) {
  	      var safe = normalizeString(employeeId);
  	      if (!safe) return null;
  	      var rows = await findUsers(
  	        "Data_Details.employee_details.employee_id = '" + escapeWhereValue(safe) + "'",
  	        1
  	      );
  	      return (rows || [])[0] || null;
  	    }
  	
  	    async function getUserByIdNumber(idNumber) {
  	      var safe = normalizeString(idNumber);
  	      if (!safe) return null;
  	      var rows = await findUsers(
  	        "Data_Details.employee_details.id_number = '" + escapeWhereValue(safe) + "'",
  	        1
  	      );
  	      return (rows || [])[0] || null;
  	    }
  	
  	    async function assertUnique(payload, existingUserId) {
  	      var details = getDeep(payload, ["Data_Details", "employee_details"], {});
  	      var collisions = [];
  	
  	      var emailUser = await getUserByEmail(payload.email);
  	      var employeeIdUser = await getUserByEmployeeId(details.employee_id);
  	      var idNumberUser = await getUserByIdNumber(details.id_number);
  	
  	      if (emailUser && emailUser.objectId !== existingUserId) {
  	        collisions.push("Email already exists on another user.");
  	      }
  	
  	      if (employeeIdUser && employeeIdUser.objectId !== existingUserId) {
  	        collisions.push("Employee ID already exists on another user.");
  	      }
  	
  	      if (idNumberUser && idNumberUser.objectId !== existingUserId) {
  	        collisions.push("ID number already exists on another user.");
  	      }
  	
  	      return collisions;
  	    }
  	
  	    async function registerUser(payload) {
  	      var user = new backendless.User();
  	
  	      Object.keys(payload).forEach(function (key) {
  	        if (key !== "password") {
  	          user.setProperty(key, payload[key]);
  	        }
  	      });
  	
  	      return backendless.UserService.register(user, payload.password);
  	    }
  	
  	    async function saveUser(payload) {
  	      var clone = deepClone(payload);
  	      delete clone.password;
  	      return backendless.Data.of("Users").save(clone);
  	    }
  	
  	    async function addRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	      return backendless.Data.of(tableName).addRelation(
  	        { objectId: parentObjectId },
  	        relationName,
  	        childObjectIds
  	      );
  	    }
  	
  	    async function deleteRelation(tableName, parentObjectId, relationName, childObjectIds) {
  	      return backendless.Data.of(tableName).deleteRelation(
  	        { objectId: parentObjectId },
  	        relationName,
  	        childObjectIds
  	      );
  	    }
  	
  	    async function loadCompanyEmployees(companyObjectId) {
  	      return backendless.Data.of("Companies").loadRelations(
  	        companyObjectId,
  	        "Employees",
  	        { pageSize: 100, offset: 0 }
  	      );
  	    }
  	
  	    async function syncCompanyRelations(userObjectId, targetCompanyIds) {
  	      var allCompanies = toArray(companiesInput);
  	      var desired = {};
  	      var currentMembership = {};
  	      var safeTargets = toArray(targetCompanyIds)
  	        .map(function (id) { return normalizeString(id); })
  	        .filter(Boolean);
  	
  	      for (var i = 0; i < safeTargets.length; i++) {
  	        desired[safeTargets[i]] = true;
  	      }
  	
  	      for (var c = 0; c < allCompanies.length; c++) {
  	        var company = allCompanies[c];
  	        var companyId = getDeep(company, ["objectId"], null);
  	        if (!companyId) continue;
  	
  	        var employeeRows = [];
  	        try {
  	          employeeRows = toArray(await loadCompanyEmployees(companyId));
  	        } catch (e) {
  	          employeeRows = toArray(getDeep(company, ["Employees"], []));
  	        }
  	
  	        for (var eIndex = 0; eIndex < employeeRows.length; eIndex++) {
  	          if (String(getDeep(employeeRows[eIndex], ["objectId"], "")) === String(userObjectId)) {
  	            currentMembership[companyId] = true;
  	            break;
  	          }
  	        }
  	      }
  	
  	      var toAdd = safeTargets.filter(function (companyId) {
  	        return !currentMembership[companyId];
  	      });
  	
  	      var toRemove = Object.keys(currentMembership).filter(function (companyId) {
  	        return !desired[companyId];
  	      });
  	
  	      for (var a = 0; a < toAdd.length; a++) {
  	        await addRelation("Companies", toAdd[a], "Employees", [userObjectId]);
  	      }
  	
  	      for (var r = 0; r < toRemove.length; r++) {
  	        await deleteRelation("Companies", toRemove[r], "Employees", [userObjectId]);
  	      }
  	
  	      return {
  	        addedToCompanies: toAdd,
  	        removedFromCompanies: toRemove,
  	        finalCompanyIds: safeTargets
  	      };
  	    }
  	
  	    function userDisplayName(user) {
  	      return (
  	        normalizeString(getDeep(user, ["name"], "")) ||
  	        buildDisplayName(user) ||
  	        normalizeString(getDeep(user, ["email"], "")) ||
  	        "Unnamed User"
  	      );
  	    }
  	
  	    function buildUserSearchIndex(user) {
  	      var parts = [
  	        getDeep(user, ["name"], ""),
  	        getDeep(user, ["email"], ""),
  	        getDeep(user, ["userStatus"], ""),
  	        getDeep(user, ["APP"], ""),
  	        getDeep(user, ["Data_Details", "employee_details", "first_name"], ""),
  	        getDeep(user, ["Data_Details", "employee_details", "last_name"], ""),
  	        getDeep(user, ["Data_Details", "employee_details", "employee_id"], ""),
  	        getDeep(user, ["Data_Details", "employee_details", "id_number"], ""),
  	        getDeep(user, ["Data_Details", "employee_details", "employment_details", "department"], ""),
  	        getDeep(user, ["Data_Details", "employee_details", "employment_details", "job_title"], "")
  	      ];
  	
  	      return parts.join(" ").toLowerCase();
  	    }
  	
  	    function buildCompanyBadgeNames(user) {
  	      var companies = toArray(getDeep(user, ["Companies"], []));
  	      if (!companies.length) return "No companies";
  	
  	      return companies.map(function (company) {
  	        return firstDefined(
  	          getDeep(company, ["Name"], null),
  	          getDeep(company, ["CompanyId"], null),
  	          getDeep(company, ["name"], null),
  	          "Company"
  	        );
  	      }).join(", ");
  	    }
  	
  	    function buildUserStatusOptionsHtml(selectedValue) {
  	      return buildOptionsHtml(
  	        [
  	          normalizeOption("ENABLED", "ENABLED"),
  	          normalizeOption("DISABLED", "DISABLED")
  	        ],
  	        "Select status",
  	        selectedValue || "ENABLED"
  	      );
  	    }
  	
  	    function resolveMode() {
  	      var safeMode = normalizeString(modeInput).toLowerCase();
  	      if (safeMode === "edit" && existingUserInput && getDeep(existingUserInput, ["objectId"], null)) {
  	        return "edit";
  	      }
  	      return "create";
  	    }
  	
  	    var mode = resolveMode();
  	    var seedUser = buildCanonicalUserPayload(existingUserInput || getDefaultUserRecord());
  	    var companyOptions = buildCompanyOptions(companiesInput);
  	    var selectedCompanyIds = mode === "edit" ? getCompaniesRelationFromUser(existingUserInput || {}) : [];
  	
  	    var companyGridHtml = companyOptions.map(function (opt) {
  	      var checked = selectedCompanyIds.indexOf(opt.value) >= 0 ? ' checked="checked"' : "";
  	      return ""
  	        + '<label style="display:flex;align-items:center;gap:10px;background:rgba(255,255,255,0.05);border-radius:10px;padding:10px 12px;cursor:pointer;">'
  	        + '  <input type="checkbox" class="fif-company-check" value="' + escapeHtml(opt.value) + '"' + checked + ">"
  	        + '  <span style="font-size:12px;color:#f8fafc;">' + escapeHtml(opt.label) + "</span>"
  	        + "</label>";
  	    }).join("");
  	
  	    var userStatusOptionsHtml = buildUserStatusOptionsHtml(
  	      getDeep(seedUser, ["userStatus"], "ENABLED")
  	    );
  	
  	    var existing = document.getElementById("fif-user-editor-overlay");
  	    if (existing) existing.remove();
  	
  	    var overlay = document.createElement("div");
  	    overlay.id = "fif-user-editor-overlay";
  	    overlay.style.position = "fixed";
  	    overlay.style.inset = "0";
  	    overlay.style.zIndex = "999999";
  	    overlay.style.display = "flex";
  	    overlay.style.alignItems = "center";
  	    overlay.style.justifyContent = "center";
  	    overlay.style.background = "rgba(0,0,0,0.40)";
  	    overlay.style.backdropFilter = "blur(2px)";
  	    overlay.style.padding = "14px";
  	    overlay.style.boxSizing = "border-box";
  	
  	    var modal = document.createElement("div");
  	    modal.id = "fif-user-editor-modal";
  	    modal.style.width = "calc(100vw - 28px)";
  	    modal.style.height = "calc(100vh - 28px)";
  	    modal.style.background = "linear-gradient(180deg, rgba(5,10,18,0.96) 0%, rgba(10,16,24,0.94) 100%)";
  	    modal.style.borderRadius = "18px";
  	    modal.style.overflow = "hidden";
  	    modal.style.boxShadow = "0 18px 50px rgba(0,0,0,0.38)";
  	    modal.style.display = "flex";
  	    modal.style.flexDirection = "column";
  	    modal.style.color = "#f8fafc";
  	    modal.style.fontFamily = "Arial, sans-serif";
  	    modal.style.border = "1px solid rgba(255,255,255,0.06)";
  	
  	    modal.innerHTML = ""
  	      + "<style>"
  	      + ".fif-soft-input{width:100%;height:42px;border-radius:10px;border:none;background:#d1d5db;color:#0f172a;padding:0 12px;font-size:14px;box-sizing:border-box;}"
  	      + ".fif-dark-select{appearance:none;-webkit-appearance:none;-moz-appearance:none;background:#d1d5db;color:#0f172a;}"
  	      + ".fif-dark-select option{background:#0f172a;color:#f8fafc;}"
  	      + ".fif-field-label{display:block;font-size:12px;color:#f8fafc;margin:0 0 5px 3px;}"
  	      + ".fif-field-error{display:none;margin-top:4px;font-size:11px;color:#ff7b7b;}"
  	      + ".fif-chip{display:inline-flex;align-items:center;gap:6px;padding:7px 10px;border-radius:999px;background:rgba(255,255,255,0.06);font-size:12px;color:#f8fafc;border:1px solid rgba(255,255,255,0.08);cursor:pointer;}"
  	      + ".fif-chip.active{background:#f97316;color:#fff;border-color:#f97316;}"
  	      + ".fif-user-row:hover{background:rgba(255,255,255,0.085)!important;}"
  	      + ".fif-user-row{transition:all 140ms ease;}"
  	      + "</style>"
  	
  	      + '<div style="padding:16px 16px 10px 16px;border-bottom:1px solid rgba(255,255,255,0.06);display:flex;justify-content:space-between;align-items:flex-start;gap:10px;">'
  	      + '  <div style="min-width:0;">'
  	      + '    <div style="font-size:16px;font-weight:700;line-height:1.1;">Fleet In Form User Creator & Editor</div>'
  	      + '    <div style="margin-top:4px;font-size:11px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">Create real Backendless login users, browse existing users, and manage Companies.Employees relations.</div>'
  	      + "  </div>"
  	      + '  <button id="fif-user-editor-close" type="button" style="background:none;border:none;color:#ff3b30;font-size:28px;line-height:1;cursor:pointer;padding:0 2px;">X</button>'
  	      + "</div>"
  	
  	      + '<div style="display:flex;gap:8px;padding:10px 14px 0 14px;">'
  	      + '  <button id="fif-tab-browse" type="button" style="flex:1;height:38px;border:none;border-radius:10px;background:#f97316;color:#fff;font-size:13px;font-weight:700;cursor:pointer;">Users Table</button>'
  	      + '  <button id="fif-tab-account" type="button" style="flex:1;height:38px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.04);color:#dbe4ee;font-size:13px;font-weight:700;cursor:pointer;">Account</button>'
  	      + '  <button id="fif-tab-personal" type="button" style="flex:1;height:38px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.04);color:#dbe4ee;font-size:13px;font-weight:700;cursor:pointer;">Personal</button>'
  	      + '  <button id="fif-tab-employment" type="button" style="flex:1;height:38px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.04);color:#dbe4ee;font-size:13px;font-weight:700;cursor:pointer;">Employment</button>'
  	      + '  <button id="fif-tab-wages" type="button" style="flex:1;height:38px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.04);color:#dbe4ee;font-size:13px;font-weight:700;cursor:pointer;">Wages</button>'
  	      + "</div>"
  	
  	      + '<div style="position:relative;flex:1;min-height:0;">'
  	
  	      + '  <div id="fif-panel-browse" style="display:block;position:absolute;inset:0;padding:14px;overflow:hidden;">'
  	      + '    <div style="display:flex;flex-direction:column;gap:10px;height:100%;min-height:0;">'
  	      + '      <div style="display:flex;gap:10px;align-items:center;">'
  	      + '        <input id="fif-user-search" type="text" placeholder="Search users by name, email, ID, department..." class="fif-soft-input" style="flex:1;height:40px;background:rgba(255,255,255,0.9);">'
  	      + '        <button id="fif-user-search-clear" type="button" style="height:40px;padding:0 14px;border:none;border-radius:10px;background:rgba(255,255,255,0.08);color:#e2e8f0;font-size:12px;font-weight:700;cursor:pointer;">Clear</button>'
  	      + '        <button id="fif-new-user-btn" type="button" style="height:40px;padding:0 16px;border:none;border-radius:10px;background:#f97316;color:#ffffff;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;">New User</button>'
  	      + "      </div>"
  	      + '      <div style="display:grid;grid-template-columns:220px 220px 160px 1fr 110px;gap:0;background:rgba(255,255,255,0.07);border-radius:10px 10px 0 0;overflow:hidden;border:1px solid rgba(255,255,255,0.08);">'
  	      + '        <div style="padding:10px 12px;font-size:11px;font-weight:700;color:#cbd5e1;">Name</div>'
  	      + '        <div style="padding:10px 12px;font-size:11px;font-weight:700;color:#cbd5e1;">Email</div>'
  	      + '        <div style="padding:10px 12px;font-size:11px;font-weight:700;color:#cbd5e1;">Employee ID</div>'
  	      + '        <div style="padding:10px 12px;font-size:11px;font-weight:700;color:#cbd5e1;">Company / Department</div>'
  	      + '        <div style="padding:10px 12px;font-size:11px;font-weight:700;color:#cbd5e1;">Status</div>'
  	      + "      </div>"
  	      + '      <div id="fif-users-table-body" style="flex:1;min-height:0;overflow:auto;border:1px solid rgba(255,255,255,0.08);border-top:none;border-radius:0 0 10px 10px;background:rgba(255,255,255,0.03);"></div>'
  	      + "    </div>"
  	      + "  </div>"
  	
  	      + '  <div id="fif-panel-account" style="display:none;position:absolute;inset:0;padding:18px;overflow:auto;">'
  	      + '    <div style="max-width:1100px;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;">'
  	
  	      + '      <div>'
  	      + '        <label class="fif-field-label">First Name</label>'
  	      + '        <input id="fif-first-name" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "first_name"], "")) + '">'
  	      + '        <div id="fif-first-name-error" class="fif-field-error"></div>'
  	      + "      </div>"
  	
  	      + '      <div>'
  	      + '        <label class="fif-field-label">Last Name</label>'
  	      + '        <input id="fif-last-name" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "last_name"], "")) + '">'
  	      + '        <div id="fif-last-name-error" class="fif-field-error"></div>'
  	      + "      </div>"
  	
  	      + '      <div>'
  	      + '        <label class="fif-field-label">Email</label>'
  	      + '        <input id="fif-email" type="email" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["email"], "")) + '">'
  	      + '        <div id="fif-email-error" class="fif-field-error"></div>'
  	      + "      </div>"
  	
  	      + '      <div id="fif-password-wrap" style="display:' + (mode === "create" ? "block" : "none") + ';">'
  	      + '        <label class="fif-field-label">Temporary Password</label>'
  	      + '        <input id="fif-password" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["password"], "")) + '" placeholder="Set first login password">'
  	      + '        <div id="fif-password-error" class="fif-field-error"></div>'
  	      + "      </div>"
  	
  	      + '      <div>'
  	      + '        <label class="fif-field-label">Employee ID</label>'
  	      + '        <input id="fif-employee-id" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employee_id"], "")) + '">'
  	      + "      </div>"
  	
  	      + '      <div>'
  	      + '        <label class="fif-field-label">ID Number</label>'
  	      + '        <input id="fif-id-number" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "id_number"], "")) + '">'
  	      + "      </div>"
  	
  	      + '      <div>'
  	      + '        <label class="fif-field-label">Phone Number</label>'
  	      + '        <input id="fif-phone" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "contact_details", "phone_number"], "")) + '">'
  	      + "      </div>"
  	
  	      + '      <div>'
  	      + '        <label class="fif-field-label">User Status</label>'
  	      + '        <select id="fif-user-status" class="fif-soft-input fif-dark-select">'
  	      +            userStatusOptionsHtml
  	      + "        </select>"
  	      + "      </div>"
  	
  	      + '      <div style="grid-column:1 / span 2;">'
  	      + '        <label class="fif-field-label">App Access</label>'
  	      + '        <div id="fif-app-chips" style="display:flex;flex-wrap:wrap;gap:8px;">'
  	      + '          <button type="button" class="fif-chip" data-app="FIFC">FIFC</button>'
  	      + '          <button type="button" class="fif-chip" data-app="Office">Office</button>'
  	      + '          <button type="button" class="fif-chip" data-app="Road">Road</button>'
  	      + "        </div>"
  	      + "      </div>"
  	
  	      + '      <div style="grid-column:1 / span 2;">'
  	      + '        <label class="fif-field-label">Assigned Companies</label>'
  	      + '        <div id="fif-company-grid" style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;">'
  	      +            companyGridHtml
  	      + "        </div>"
  	      + '        <div id="fif-company-error" class="fif-field-error"></div>'
  	      + "      </div>"
  	
  	      + "    </div>"
  	      + "  </div>"
  	
  	      + '  <div id="fif-panel-personal" style="display:none;position:absolute;inset:0;padding:18px;overflow:auto;">'
  	      + '    <div style="max-width:1100px;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;">'
  	      + '      <div><label class="fif-field-label">Date of Birth</label><input id="fif-dob" type="date" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "date_of_birth"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Gender</label><input id="fif-gender" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "gender"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Nationality</label><input id="fif-nationality" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "nationality"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Marital Status</label><input id="fif-marital-status" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "marital_status"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Street</label><input id="fif-street" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "address", "street"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Suburb</label><input id="fif-suburb" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "address", "suburb"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">City</label><input id="fif-city" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "address", "city"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Province</label><input id="fif-province" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "address", "province"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Postal Code</label><input id="fif-postal-code" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "address", "postal_code"], "")) + '"></div>'
  	      + "    </div>"
  	      + "  </div>"
  	
  	      + '  <div id="fif-panel-employment" style="display:none;position:absolute;inset:0;padding:18px;overflow:auto;">'
  	      + '    <div style="max-width:1100px;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;">'
  	      + '      <div><label class="fif-field-label">Department</label><input id="fif-department" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employment_details", "department"], "")) + '"><div id="fif-department-error" class="fif-field-error"></div></div>'
  	      + '      <div><label class="fif-field-label">Job Title</label><input id="fif-job-title" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employment_details", "job_title"], "")) + '"><div id="fif-job-title-error" class="fif-field-error"></div></div>'
  	      + '      <div><label class="fif-field-label">Employment Type</label><input id="fif-employment-type" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employment_details", "employment_type"], "Permanent")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Pay Frequency</label><input id="fif-pay-frequency" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employment_details", "pay_frequency"], "Monthly")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Employment Start Date</label><input id="fif-start-date" type="date" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employment_details", "employment_start_date"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Hours Per Week</label><input id="fif-hours-week" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employment_details", "work_hours_per_week"], "")) + '"></div>'
  	      + "    </div>"
  	      + "  </div>"
  	
  	      + '  <div id="fif-panel-wages" style="display:none;position:absolute;inset:0;padding:18px;overflow:auto;">'
  	      + '    <div style="max-width:1100px;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;">'
  	      + '      <div><label class="fif-field-label">Base Salary Amount</label><input id="fif-base-salary" type="text" class="fif-soft-input" value="' + escapeHtml(text(getDeep(seedUser, ["Data_Wages", "wage_rates", "pay_components", "base_salary", "amount"], 0), "0")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Base Salary Frequency</label><input id="fif-base-salary-frequency" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Wages", "wage_rates", "pay_components", "base_salary", "pay_frequency"], "Monthly")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Bank Name</label><input id="fif-bank-name" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employment_details", "bank_details", "bank_name"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Branch Code</label><input id="fif-branch-code" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employment_details", "bank_details", "branch_code"], "")) + '"></div>'
  	      + '      <div><label class="fif-field-label">Account Number</label><input id="fif-account-number" type="text" class="fif-soft-input" value="' + escapeHtml(getDeep(seedUser, ["Data_Details", "employee_details", "employment_details", "bank_details", "account_number"], "")) + '"></div>'
  	      + "    </div>"
  	      + "  </div>"
  	
  	      + "</div>"
  	
  	      + '<div style="padding:12px 18px 18px 18px;border-top:1px solid rgba(255,255,255,0.06);display:flex;gap:10px;align-items:center;">'
  	      + '  <div id="fif-status-bar" style="flex:1;font-size:12px;color:#94a3b8;">Ready.</div>'
  	      + '  <button id="fif-cancel-btn" type="button" style="width:140px;height:46px;border:1px solid rgba(255,255,255,0.12);border-radius:10px;background:rgba(255,255,255,0.05);color:#e2e8f0;font-size:15px;font-weight:700;cursor:pointer;">Cancel</button>'
  	      + '  <button id="fif-save-btn" type="button" style="min-width:180px;height:46px;border:none;border-radius:10px;background:#f97316;color:white;font-size:15px;font-weight:700;cursor:pointer;">' + escapeHtml(mode === "edit" ? "Save Changes" : "Create User") + "</button>"
  	      + "</div>";
  	
  	    overlay.appendChild(modal);
  	
  	    if (mountBlock && mountBlock.el && typeof mountBlock.el.appendChild === "function") {
  	      mountBlock.el.appendChild(overlay);
  	    } else {
  	      document.body.appendChild(overlay);
  	    }
  	
  	    var state = {
  	      mode: mode,
  	      sourceUser: deepClone(existingUserInput || null),
  	      appSet: {},
  	      saving: false,
  	      userTableRows: [],
  	      filteredUserRows: [],
  	      userSearchTerm: ""
  	    };
  	
  	    function el(id) {
  	      return document.getElementById(id);
  	    }
  	
  	    function valueOf(id) {
  	      var node = el(id);
  	      return node ? node.value : "";
  	    }
  	
  	    function setValue(id, value) {
  	      var node = el(id);
  	      if (node) node.value = value == null ? "" : String(value);
  	    }
  	
  	    function setText(id, value) {
  	      var node = el(id);
  	      if (node) node.textContent = text(value, "");
  	    }
  	
  	    function setHtml(id, html) {
  	      var node = el(id);
  	      if (node) node.innerHTML = html || "";
  	    }
  	
  	    function setButtonBusy(button, isBusy, label) {
  	      if (!button) return;
  	      button.disabled = !!isBusy;
  	      button.style.opacity = isBusy ? "0.7" : "1";
  	      button.style.cursor = isBusy ? "wait" : "pointer";
  	      if (label) button.textContent = label;
  	    }
  	
  	    function showError(id, message) {
  	      var node = el(id);
  	      if (!node) return;
  	      node.style.display = message ? "block" : "none";
  	      node.textContent = message || "";
  	    }
  	
  	    function clearErrors() {
  	      var ids = [
  	        "fif-first-name-error",
  	        "fif-last-name-error",
  	        "fif-email-error",
  	        "fif-password-error",
  	        "fif-department-error",
  	        "fif-job-title-error",
  	        "fif-company-error"
  	      ];
  	
  	      for (var i = 0; i < ids.length; i++) {
  	        showError(ids[i], "");
  	      }
  	    }
  	
  	    function closeModal() {
  	      var node = el("fif-user-editor-overlay");
  	      if (node) node.remove();
  	    }
  	
  	    function setStatus(message) {
  	      setText("fif-status-bar", message || "Ready.");
  	    }
  	
  	    function setTab(activeKey) {
  	      var defs = [
  	        { key: "browse", btn: "fif-tab-browse", panel: "fif-panel-browse" },
  	        { key: "account", btn: "fif-tab-account", panel: "fif-panel-account" },
  	        { key: "personal", btn: "fif-tab-personal", panel: "fif-panel-personal" },
  	        { key: "employment", btn: "fif-tab-employment", panel: "fif-panel-employment" },
  	        { key: "wages", btn: "fif-tab-wages", panel: "fif-panel-wages" }
  	      ];
  	
  	      for (var i = 0; i < defs.length; i++) {
  	        var def = defs[i];
  	        var btn = el(def.btn);
  	        var panel = el(def.panel);
  	        var isActive = def.key === activeKey;
  	
  	        if (panel) {
  	          panel.style.display = isActive ? "block" : "none";
  	        }
  	
  	        if (btn) {
  	          btn.style.background = isActive ? "#f97316" : "rgba(255,255,255,0.04)";
  	          btn.style.color = isActive ? "#ffffff" : "#dbe4ee";
  	          btn.style.border = isActive ? "none" : "1px solid rgba(255,255,255,0.12)";
  	        }
  	      }
  	    }
  	
  	    function initAppSet() {
  	      var rawApps = sanitizeAppString(getDeep(seedUser, ["APP"], ""));
  	      var parts = rawApps ? rawApps.split(",") : [];
  	
  	      for (var i = 0; i < parts.length; i++) {
  	        var key = normalizeString(parts[i]);
  	        if (key) {
  	          state.appSet[key] = true;
  	        }
  	      }
  	
  	      renderAppChips();
  	    }
  	
  	    function renderAppChips() {
  	      var host = el("fif-app-chips");
  	      if (!host) return;
  	
  	      var nodes = host.querySelectorAll("[data-app]");
  	      for (var i = 0; i < nodes.length; i++) {
  	        var app = nodes[i].getAttribute("data-app");
  	        if (state.appSet[app]) nodes[i].classList.add("active");
  	        else nodes[i].classList.remove("active");
  	      }
  	    }
  	
  	    function getSelectedCompanyIds() {
  	      var root = el("fif-company-grid");
  	      var nodes = root ? root.querySelectorAll(".fif-company-check") : [];
  	      var out = [];
  	
  	      for (var i = 0; i < nodes.length; i++) {
  	        if (nodes[i].checked) {
  	          out.push(nodes[i].value);
  	        }
  	      }
  	
  	      return out;
  	    }
  	
  	    function setSelectedCompanyIds(ids) {
  	      var selectedMap = {};
  	      var list = toArray(ids);
  	
  	      for (var i = 0; i < list.length; i++) {
  	        selectedMap[String(list[i])] = true;
  	      }
  	
  	      var root = el("fif-company-grid");
  	      var nodes = root ? root.querySelectorAll(".fif-company-check") : [];
  	
  	      for (var n = 0; n < nodes.length; n++) {
  	        nodes[n].checked = !!selectedMap[String(nodes[n].value)];
  	      }
  	    }
  	
  	    function collectFormPayload() {
  	      var payload = deepClone(state.sourceUser || getDefaultUserRecord());
  	
  	      payload.email = valueOf("fif-email");
  	      payload.password = valueOf("fif-password");
  	      payload.userStatus = valueOf("fif-user-status") || "ENABLED";
  	      payload.APP = Object.keys(state.appSet).filter(function (key) {
  	        return state.appSet[key];
  	      }).join(",");
  	      payload.loginEnabled = payload.userStatus === "ENABLED";
  	      payload.mustChangePassword = true;
  	
  	      payload.Data_Details = payload.Data_Details || {};
  	      payload.Data_Details.employee_details = payload.Data_Details.employee_details || getDefaultEmployeeDetails();
  	
  	      payload.Data_Wages = payload.Data_Wages || getDefaultWages();
  	      payload.Data_Wages.wage_rates = payload.Data_Wages.wage_rates || {};
  	      payload.Data_Wages.wage_rates.pay_components = payload.Data_Wages.wage_rates.pay_components || {};
  	      payload.Data_Wages.wage_rates.pay_components.base_salary = payload.Data_Wages.wage_rates.pay_components.base_salary || {};
  	
  	      var details = payload.Data_Details.employee_details;
  	
  	      details.first_name = valueOf("fif-first-name");
  	      details.last_name = valueOf("fif-last-name");
  	      details.id_number = valueOf("fif-id-number");
  	      details.employee_id = valueOf("fif-employee-id");
  	      details.date_of_birth = valueOf("fif-dob");
  	      details.gender = valueOf("fif-gender");
  	      details.nationality = valueOf("fif-nationality");
  	      details.marital_status = valueOf("fif-marital-status");
  	
  	      details.contact_details = details.contact_details || {};
  	      details.contact_details.email = valueOf("fif-email");
  	      details.contact_details.phone_number = valueOf("fif-phone");
  	
  	      details.address = details.address || {};
  	      details.address.street = valueOf("fif-street");
  	      details.address.suburb = valueOf("fif-suburb");
  	      details.address.city = valueOf("fif-city");
  	      details.address.province = valueOf("fif-province");
  	      details.address.postal_code = valueOf("fif-postal-code");
  	
  	      details.employment_details = details.employment_details || {};
  	      details.employment_details.department = valueOf("fif-department");
  	      details.employment_details.job_title = valueOf("fif-job-title");
  	      details.employment_details.employment_type = valueOf("fif-employment-type");
  	      details.employment_details.pay_frequency = valueOf("fif-pay-frequency");
  	      details.employment_details.employment_start_date = valueOf("fif-start-date");
  	      details.employment_details.work_hours_per_week = valueOf("fif-hours-week");
  	
  	      details.employment_details.bank_details = details.employment_details.bank_details || {};
  	      details.employment_details.bank_details.bank_name = valueOf("fif-bank-name");
  	      details.employment_details.bank_details.branch_code = valueOf("fif-branch-code");
  	      details.employment_details.bank_details.account_number = valueOf("fif-account-number");
  	
  	      payload.Data_Wages.wage_rates.employee_id = details.employee_id;
  	      payload.Data_Wages.wage_rates.pay_components.base_salary.amount = Number(valueOf("fif-base-salary") || 0);
  	      payload.Data_Wages.wage_rates.pay_components.base_salary.pay_frequency = valueOf("fif-base-salary-frequency") || "Monthly";
  	
  	      if (state.mode === "edit" && getDeep(state.sourceUser, ["objectId"], null)) {
  	        payload.objectId = state.sourceUser.objectId;
  	      }
  	
  	      return buildCanonicalUserPayload(payload);
  	    }
  	
  	    function surfaceValidation(errors, payload, companyIds) {
  	      clearErrors();
  	
  	      var details = getDeep(payload, ["Data_Details", "employee_details"], {});
  	
  	      if (!normalizeString(details.first_name)) showError("fif-first-name-error", "First name is required.");
  	      if (!normalizeString(details.last_name)) showError("fif-last-name-error", "Last name is required.");
  	      if (!normalizeString(payload.email)) showError("fif-email-error", "Email is required.");
  	      if (state.mode === "create" && !normalizeString(payload.password)) showError("fif-password-error", "Password is required.");
  	      if (!normalizeString(getDeep(details, ["employment_details", "department"], ""))) showError("fif-department-error", "Department is required.");
  	      if (!normalizeString(getDeep(details, ["employment_details", "job_title"], ""))) showError("fif-job-title-error", "Job title is required.");
  	      if (!companyIds.length) showError("fif-company-error", "At least one company must be selected.");
  	
  	      if (errors && errors.length) {
  	        setStatus(errors[0]);
  	      }
  	    }
  	
  	    function setFormMode(newMode) {
  	      state.mode = newMode === "edit" ? "edit" : "create";
  	
  	      var passwordWrap = el("fif-password-wrap");
  	      if (passwordWrap) {
  	        passwordWrap.style.display = state.mode === "create" ? "block" : "none";
  	      }
  	
  	      var saveBtn = el("fif-save-btn");
  	      if (saveBtn) {
  	        saveBtn.textContent = state.mode === "edit" ? "Save Changes" : "Create User";
  	      }
  	    }
  	
  	    function resetToNewUser() {
  	      state.sourceUser = deepClone(getDefaultUserRecord());
  	      setFormMode("create");
  	      clearErrors();
  	
  	      setValue("fif-first-name", "");
  	      setValue("fif-last-name", "");
  	      setValue("fif-email", "");
  	      setValue("fif-password", "");
  	      setValue("fif-employee-id", "");
  	      setValue("fif-id-number", "");
  	      setValue("fif-phone", "");
  	      setValue("fif-user-status", "ENABLED");
  	      setValue("fif-dob", "");
  	      setValue("fif-gender", "");
  	      setValue("fif-nationality", "");
  	      setValue("fif-marital-status", "");
  	      setValue("fif-street", "");
  	      setValue("fif-suburb", "");
  	      setValue("fif-city", "");
  	      setValue("fif-province", "");
  	      setValue("fif-postal-code", "");
  	      setValue("fif-department", "");
  	      setValue("fif-job-title", "");
  	      setValue("fif-employment-type", "Permanent");
  	      setValue("fif-pay-frequency", "Monthly");
  	      setValue("fif-start-date", "");
  	      setValue("fif-hours-week", "");
  	      setValue("fif-base-salary", "0");
  	      setValue("fif-base-salary-frequency", "Monthly");
  	      setValue("fif-bank-name", "");
  	      setValue("fif-branch-code", "");
  	      setValue("fif-account-number", "");
  	
  	      state.appSet = { FIFC: true };
  	      renderAppChips();
  	      setSelectedCompanyIds([]);
  	
  	      setStatus("New user form ready.");
  	      setTab("account");
  	    }
  	
  	    function loadUserIntoForm(user) {
  	      var safeUser = buildCanonicalUserPayload(user || getDefaultUserRecord());
  	
  	      state.sourceUser = deepClone(user || null);
  	      setFormMode(getDeep(user, ["objectId"], null) ? "edit" : "create");
  	      clearErrors();
  	
  	      setValue("fif-first-name", getDeep(safeUser, ["Data_Details", "employee_details", "first_name"], ""));
  	      setValue("fif-last-name", getDeep(safeUser, ["Data_Details", "employee_details", "last_name"], ""));
  	      setValue("fif-email", getDeep(safeUser, ["email"], ""));
  	      setValue("fif-password", "");
  	      setValue("fif-employee-id", getDeep(safeUser, ["Data_Details", "employee_details", "employee_id"], ""));
  	      setValue("fif-id-number", getDeep(safeUser, ["Data_Details", "employee_details", "id_number"], ""));
  	      setValue("fif-phone", getDeep(safeUser, ["Data_Details", "employee_details", "contact_details", "phone_number"], ""));
  	      setValue("fif-user-status", getDeep(safeUser, ["userStatus"], "ENABLED"));
  	
  	      setValue("fif-dob", getDeep(safeUser, ["Data_Details", "employee_details", "date_of_birth"], ""));
  	      setValue("fif-gender", getDeep(safeUser, ["Data_Details", "employee_details", "gender"], ""));
  	      setValue("fif-nationality", getDeep(safeUser, ["Data_Details", "employee_details", "nationality"], ""));
  	      setValue("fif-marital-status", getDeep(safeUser, ["Data_Details", "employee_details", "marital_status"], ""));
  	      setValue("fif-street", getDeep(safeUser, ["Data_Details", "employee_details", "address", "street"], ""));
  	      setValue("fif-suburb", getDeep(safeUser, ["Data_Details", "employee_details", "address", "suburb"], ""));
  	      setValue("fif-city", getDeep(safeUser, ["Data_Details", "employee_details", "address", "city"], ""));
  	      setValue("fif-province", getDeep(safeUser, ["Data_Details", "employee_details", "address", "province"], ""));
  	      setValue("fif-postal-code", getDeep(safeUser, ["Data_Details", "employee_details", "address", "postal_code"], ""));
  	
  	      setValue("fif-department", getDeep(safeUser, ["Data_Details", "employee_details", "employment_details", "department"], ""));
  	      setValue("fif-job-title", getDeep(safeUser, ["Data_Details", "employee_details", "employment_details", "job_title"], ""));
  	      setValue("fif-employment-type", getDeep(safeUser, ["Data_Details", "employee_details", "employment_details", "employment_type"], "Permanent"));
  	      setValue("fif-pay-frequency", getDeep(safeUser, ["Data_Details", "employee_details", "employment_details", "pay_frequency"], "Monthly"));
  	      setValue("fif-start-date", getDeep(safeUser, ["Data_Details", "employee_details", "employment_details", "employment_start_date"], ""));
  	      setValue("fif-hours-week", getDeep(safeUser, ["Data_Details", "employee_details", "employment_details", "work_hours_per_week"], ""));
  	
  	      setValue("fif-base-salary", text(getDeep(safeUser, ["Data_Wages", "wage_rates", "pay_components", "base_salary", "amount"], 0), "0"));
  	      setValue("fif-base-salary-frequency", getDeep(safeUser, ["Data_Wages", "wage_rates", "pay_components", "base_salary", "pay_frequency"], "Monthly"));
  	      setValue("fif-bank-name", getDeep(safeUser, ["Data_Details", "employee_details", "employment_details", "bank_details", "bank_name"], ""));
  	      setValue("fif-branch-code", getDeep(safeUser, ["Data_Details", "employee_details", "employment_details", "bank_details", "branch_code"], ""));
  	      setValue("fif-account-number", getDeep(safeUser, ["Data_Details", "employee_details", "employment_details", "bank_details", "account_number"], ""));
  	
  	      state.appSet = {};
  	      var rawApps = sanitizeAppString(getDeep(safeUser, ["APP"], ""));
  	      var appParts = rawApps ? rawApps.split(",") : [];
  	
  	      for (var i = 0; i < appParts.length; i++) {
  	        var key = normalizeString(appParts[i]);
  	        if (key) state.appSet[key] = true;
  	      }
  	
  	      renderAppChips();
  	      setSelectedCompanyIds(getCompaniesRelationFromUser(user || {}));
  	      setStatus("Editing user: " + userDisplayName(safeUser));
  	      setTab("account");
  	    }
  	
  	    function buildUsersTableHtml(rows) {
  	      var arr = toArray(rows);
  	
  	      if (!arr.length) {
  	        return '<div style="padding:16px;font-size:12px;color:#94a3b8;">No users found.</div>';
  	      }
  	
  	      var html = "";
  	
  	      for (var i = 0; i < arr.length; i++) {
  	        var user = arr[i];
  	        var name = userDisplayName(user);
  	        var email = normalizeString(getDeep(user, ["email"], "")) || "-";
  	        var employeeId = normalizeString(getDeep(user, ["Data_Details", "employee_details", "employee_id"], "")) || "-";
  	        var department = normalizeString(getDeep(user, ["Data_Details", "employee_details", "employment_details", "department"], "")) || "-";
  	        var companyNames = buildCompanyBadgeNames(user);
  	        var status = normalizeString(getDeep(user, ["userStatus"], "")) || "-";
  	
  	        html += ""
  	          + '<button type="button" class="fif-user-row" data-user-id="' + escapeHtml(getDeep(user, ["objectId"], "")) + '" style="width:100%;text-align:left;border:none;background:transparent;cursor:pointer;padding:0;">'
  	          + '  <div style="display:grid;grid-template-columns:220px 220px 160px 1fr 110px;gap:0;border-bottom:1px solid rgba(255,255,255,0.06);">'
  	          + '    <div style="padding:12px;font-size:12px;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(name) + "</div>"
  	          + '    <div style="padding:12px;font-size:12px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(email) + "</div>"
  	          + '    <div style="padding:12px;font-size:12px;color:#cbd5e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(employeeId) + "</div>"
  	          + '    <div style="padding:12px;font-size:12px;color:#cbd5e1;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(companyNames + " | " + department) + "</div>"
  	          + '    <div style="padding:12px;font-size:12px;color:#f8fafc;">' + escapeHtml(status) + "</div>"
  	          + "  </div>"
  	          + "</button>";
  	      }
  	
  	      return html;
  	    }
  	
  	    function bindUserTableClicks() {
  	      var host = el("fif-users-table-body");
  	      if (!host) return;
  	
  	      var nodes = host.querySelectorAll("[data-user-id]");
  	      for (var i = 0; i < nodes.length; i++) {
  	        nodes[i].onclick = function () {
  	          var userId = this.getAttribute("data-user-id");
  	          openUserFromTable(userId);
  	        };
  	      }
  	    }
  	
  	    function renderUserTable() {
  	      setHtml("fif-users-table-body", buildUsersTableHtml(state.filteredUserRows));
  	      bindUserTableClicks();
  	    }
  	
  	    function applyUserSearch() {
  	      var raw = valueOf("fif-user-search");
  	      var term = normalizeString(raw).toLowerCase();
  	
  	      state.userSearchTerm = term;
  	
  	      if (!term) {
  	        state.filteredUserRows = toArray(state.userTableRows).slice();
  	      } else {
  	        state.filteredUserRows = toArray(state.userTableRows).filter(function (user) {
  	          return buildUserSearchIndex(user).indexOf(term) >= 0;
  	        });
  	      }
  	
  	      renderUserTable();
  	    }
  	
  	    async function loadUsersTable() {
  	      try {
  	        setStatus("Loading users table...");
  	        setHtml("fif-users-table-body", '<div style="padding:16px;font-size:12px;color:#94a3b8;">Loading users...</div>');
  	
  	        var rows = await findAllUsers(100);
  	        rows = toArray(rows).sort(function (a, b) {
  	          return userDisplayName(a).localeCompare(userDisplayName(b));
  	        });
  	
  	        state.userTableRows = rows;
  	        state.filteredUserRows = rows.slice();
  	
  	        applyUserSearch();
  	        setStatus("Users table loaded.");
  	      } catch (err) {
  	        console.log("Users table load error:", err);
  	        setHtml("fif-users-table-body", '<div style="padding:16px;font-size:12px;color:#ff7b7b;">Failed to load users table.</div>');
  	        setStatus("Failed to load users table.");
  	      }
  	    }
  	
  	    async function openUserFromTable(userId) {
  	      try {
  	        setStatus("Loading selected user...");
  	        var user = await getUserByObjectId(userId);
  	
  	        if (!user) {
  	          alert("User not found.");
  	          return;
  	        }
  	
  	        loadUserIntoForm(user);
  	      } catch (err) {
  	        console.log("Open user error:", err);
  	        alert("Failed to load user: " + (err && err.message ? err.message : err));
  	      }
  	    }
  	
  	    async function saveFlow() {
  	      if (!backendless || !backendless.Data || !backendless.Data.of) {
  	        alert("Backendless SDK is not available.");
  	        return;
  	      }
  	
  	      try {
  	        clearErrors();
  	        state.saving = true;
  	        setButtonBusy(el("fif-save-btn"), true, state.mode === "edit" ? "Saving..." : "Creating...");
  	        setStatus("Validating...");
  	
  	        var payload = collectFormPayload();
  	        var companyIds = getSelectedCompanyIds();
  	        var validationErrors = validatePayload(payload, state.mode);
  	
  	        if (!companyIds.length) {
  	          validationErrors.push("At least one company must be selected.");
  	        }
  	
  	        if (validationErrors.length) {
  	          surfaceValidation(validationErrors, payload, companyIds);
  	          return;
  	        }
  	
  	        setStatus("Checking uniqueness...");
  	        var uniqueErrors = await assertUnique(
  	          payload,
  	          state.mode === "edit" ? getDeep(state.sourceUser, ["objectId"], null) : null
  	        );
  	
  	        if (uniqueErrors.length) {
  	          surfaceValidation(uniqueErrors, payload, companyIds);
  	          return;
  	        }
  	
  	        var savedUser = null;
  	
  	        if (state.mode === "create") {
  	          setStatus("Creating login user...");
  	          savedUser = await registerUser(payload);
  	        } else {
  	          setStatus("Updating user...");
  	          savedUser = await saveUser(payload);
  	        }
  	
  	        setStatus("Syncing company relations...");
  	        var relationSync = await syncCompanyRelations(savedUser.objectId, companyIds);
  	
  	        setStatus(state.mode === "edit" ? "User updated successfully." : "User created successfully.");
  	
  	        alert(
  	          (state.mode === "edit" ? "User updated" : "User created") +
  	          " successfully.\n\nAssigned companies: " +
  	          relationSync.finalCompanyIds.length
  	        );
  	
  	        var refreshedUser = null;
  	        try {
  	          refreshedUser = await getUserByObjectId(savedUser.objectId);
  	        } catch (refreshErr) {
  	          refreshedUser = savedUser;
  	        }
  	
  	        if (refreshedUser) {
  	          loadUserIntoForm(refreshedUser);
  	        }
  	
  	        await loadUsersTable();
  	        setTab("browse");
  	
  	        return {
  	          ok: true,
  	          mode: state.mode,
  	          user: savedUser,
  	          relationSync: relationSync
  	        };
  	      } catch (err) {
  	        console.log("FIF user creator/editor error:", err);
  	        setStatus("Save failed.");
  	        alert("Save failed: " + (err && err.message ? err.message : err));
  	      } finally {
  	        state.saving = false;
  	        setButtonBusy(el("fif-save-btn"), false, state.mode === "edit" ? "Save Changes" : "Create User");
  	      }
  	    }
  	
  	    if (el("fif-user-editor-close")) {
  	      el("fif-user-editor-close").onclick = closeModal;
  	    }
  	
  	    if (el("fif-cancel-btn")) {
  	      el("fif-cancel-btn").onclick = closeModal;
  	    }
  	
  	    overlay.onclick = function (e) {
  	      if (e.target === overlay) closeModal();
  	    };
  	
  	    if (el("fif-tab-browse")) el("fif-tab-browse").onclick = function () { setTab("browse"); };
  	    if (el("fif-tab-account")) el("fif-tab-account").onclick = function () { setTab("account"); };
  	    if (el("fif-tab-personal")) el("fif-tab-personal").onclick = function () { setTab("personal"); };
  	    if (el("fif-tab-employment")) el("fif-tab-employment").onclick = function () { setTab("employment"); };
  	    if (el("fif-tab-wages")) el("fif-tab-wages").onclick = function () { setTab("wages"); };
  	
  	    var chipHost = el("fif-app-chips");
  	    if (chipHost) {
  	      var chipNodes = chipHost.querySelectorAll("[data-app]");
  	      for (var i = 0; i < chipNodes.length; i++) {
  	        chipNodes[i].onclick = function () {
  	          var app = this.getAttribute("data-app");
  	          state.appSet[app] = !state.appSet[app];
  	          renderAppChips();
  	        };
  	      }
  	    }
  	
  	    if (el("fif-save-btn")) {
  	      el("fif-save-btn").onclick = function () {
  	        saveFlow();
  	      };
  	    }
  	
  	    if (el("fif-user-search")) {
  	      el("fif-user-search").addEventListener("input", function () {
  	        applyUserSearch();
  	      });
  	    }
  	
  	    if (el("fif-user-search-clear")) {
  	      el("fif-user-search-clear").onclick = function () {
  	        setValue("fif-user-search", "");
  	        applyUserSearch();
  	      };
  	    }
  	
  	    if (el("fif-new-user-btn")) {
  	      el("fif-new-user-btn").onclick = function () {
  	        resetToNewUser();
  	      };
  	    }
  	
  	    initAppSet();
  	
  	    if (mode === "edit" && existingUserInput) {
  	      loadUserIntoForm(existingUserInput);
  	      setTab("account");
  	    } else {
  	      setTab("browse");
  	    }
  	
  	    loadUsersTable();
  	    setStatus("Ready.");
  	
  	    return null;
  	  } catch (err) {
  	    console.log("Fleet In Form User Creator Editor error:", err);
  	    return null;
  	  }
  	})();
  })((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies')), (getObjectProperty(___arguments.context.appData, 'User')));
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e517ec0e29819ef91cfda218a0f846b6', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, View;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Settings')).indexOf('Users') !== -1) {
      View = true;
    } else {
      View = false;
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      View = false;
    }

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/cb48cd785c682dd8ec251e08102d8d28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Display, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'Location')), 'position.speed')) == 0 && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'Location')), 'can.engine.rpm')) > 100) {
      Display = true;
    } else {
      Display = false;
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Display = false;
    }

  }

  return Display

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'Location')), 'idle.total')) >= (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'CAN')), 'Idle')) ? String('Idling - ') + String((await (async function(Idle) {
	var IdleValue = (typeof Idle !== "undefined" ? Idle : null);
	var secs = Number(IdleValue || 0);
	
	if (!isFinite(secs) || secs < 0) secs = 0;
	
	var hours = Math.floor(secs / 3600);
	var minutes = Math.floor((secs % 3600) / 60);
	var seconds = Math.floor(secs % 60);
	
	var parts = [];
	
	if (hours > 0) parts.push(hours + "h");
	if (minutes > 0 || hours > 0) parts.push(minutes + "m");
	parts.push(seconds + "s");
	
	return parts.join(" ");
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'Location')), 'idle.total'))))) : 'Idling')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/435f12084158a6e2ea88a0ee4a15c18e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Office')).indexOf('LiveTrack') !== -1) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Office/components/23ef8118081e30a8c844e18bfebc7848/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/b4f552b517d29978d7789101347dd128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Location'))))) {
    Content = (await BackendlessUI.Functions.Custom['fn_b0b7ca9c018bcb74c0961fa7d1b9a96e']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Mileage')), (String(' ') + String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Data')), 'UIUnits')), 'Distance')), 'value'))), '<span style="font-size:0.60em; font-style:italic; color:#888;"> (Last Fuel)</span>'));
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Location')), 'can.vehicle.mileage'))))) {
      if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Location')), 'vehicle.mileage'))))) {
        Content = (await BackendlessUI.Functions.Custom['fn_b0b7ca9c018bcb74c0961fa7d1b9a96e']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Mileage')), (String(' ') + String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Data')), 'UIUnits')), 'Distance')), 'value'))), '<span style="font-size:0.60em; font-style:italic; color:#888;"> (Last Fuel)</span>'));
      } else {
        Content = (await BackendlessUI.Functions.Custom['fn_b0b7ca9c018bcb74c0961fa7d1b9a96e']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Location')), 'vehicle.mileage')), (String(' ') + String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Data')), 'UIUnits')), 'Distance')), 'value'))), '<span style="font-size:0.60em; font-style:italic; color:#888;"> (GPS)</span>'));
      }
    } else {
      Content = (await BackendlessUI.Functions.Custom['fn_b0b7ca9c018bcb74c0961fa7d1b9a96e']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Location')), 'can.vehicle.mileage')), (String(' ') + String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Data')), 'UIUnits')), 'Distance')), 'value'))), '<span style="font-size:0.60em; font-style:italic; color:#888;"> (CAN)</span>'));
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Office/components/0fb28be81d98f9b67b7835483848ebe8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Last Fuel ');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Mileage'));
  console.log(String(' ') + String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Data')), 'UIUnits')), 'Distance')), 'value')));
  console.log((await (async function(Leader, Input, Trailer) {
  	function buildString(Leader, Input, Trailer) {
  	    const parts = [];
  	
  	    if (typeof Leader === "string" && Leader.trim()) {
  	        parts.push(Leader.trim());
  	    }
  	
  	    if (Input !== null && Input !== undefined && Input !== "") {
  	        parts.push(String(Input));
  	    }
  	
  	    if (typeof Trailer === "string" && Trailer.trim()) {
  	        parts.push(Trailer.trim());
  	    }
  	
  	    return parts.length ? parts.join(" ") : "";
  	}
  })('Last Fuel ', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Mileage')), (String(' ') + String(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Data')), 'UIUnits')), 'Distance')), 'value'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/2fb84124ff1654a88fdc7f85b45eb04b/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    var j_list = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2447e9831b800d8812be9e7d18859b9')), 'el')), 'children'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      ((getObjectProperty(j, 'children'))[1])['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2fb84124ff1654a88fdc7f85b45eb04b')), 'el')), 'scrollLeft'));
    }

  } catch (error) {

  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/Office/components/8ca8eeb8b068cd3838286828880c3138/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2fb84124ff1654a88fdc7f85b45eb04b')), 'el'))['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ca8eeb8b068cd3838286828880c3138')), 'el')), 'scrollLeft'));

  } catch (error) {

  }
  try {
    var j_list = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2447e9831b800d8812be9e7d18859b9')), 'el')), 'children'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      ((getObjectProperty(j, 'children'))[5])['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2fb84124ff1654a88fdc7f85b45eb04b')), 'el')), 'scrollLeft'));
    }

  } catch (error) {

  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/Office/components/ffb866028668b5221758e825bd38c728/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/d512cfde2c6f86f82d08b708bc78439a/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c')['Notifications'] = (await (async function(Tractor) {
  	function toDateSafe(value) {
  	  if (value === null || value === undefined) return null;
  	
  	  const s = String(value).trim();
  	  if (!s) return null;
  	
  	  const d = new Date(s);
  	  return isNaN(d.getTime()) ? null : d;
  	}
  	
  	function startOfDay(date) {
  	  const d = new Date(date);
  	  d.setHours(0, 0, 0, 0);
  	  return d;
  	}
  	
  	function daysBetween(fromDate, toDate) {
  	  const msPerDay = 24 * 60 * 60 * 1000;
  	  const from = startOfDay(fromDate).getTime();
  	  const to = startOfDay(toDate).getTime();
  	  return Math.floor((to - from) / msPerDay);
  	}
  	
  	function pushIssue(targetArray, item) {
  	  targetArray.push(item);
  	}
  	
  	function evaluateDateItem(label, rawValue, warningDays, required, issues, warnings) {
  	  const dateValue = toDateSafe(rawValue);
  	  const today = startOfDay(new Date());
  	
  	  if (!dateValue) {
  	    if (required) {
  	      pushIssue(issues, {
  	        type: "missing",
  	        label: label,
  	        message: `${label} is missing`
  	      });
  	    }
  	    return;
  	  }
  	
  	  const daysLeft = daysBetween(today, dateValue);
  	
  	  if (daysLeft < 0) {
  	    pushIssue(issues, {
  	      type: "expired",
  	      label: label,
  	      date: rawValue,
  	      daysOverdue: Math.abs(daysLeft),
  	      message: `${label} expired ${Math.abs(daysLeft)} day(s) ago`
  	    });
  	    return;
  	  }
  	
  	  if (daysLeft <= warningDays) {
  	    pushIssue(warnings, {
  	      type: "due_soon",
  	      label: label,
  	      date: rawValue,
  	      daysLeft: daysLeft,
  	      message: `${label} expires in ${daysLeft} day(s)`
  	    });
  	  }
  	}
  	
  	function identifyTractorIssues(Tractor, options) {
  	  const cfg = options || {};
  	  const warningDays = (typeof cfg.warningDays === "number") ? cfg.warningDays : 30;
  	
  	  const issues = [];
  	  const warnings = [];
  	
  	  if (!Tractor || typeof Tractor !== "object") {
  	    return {
  	      ok: false,
  	      status: "Invalid",
  	      count: 1,
  	      issues: [
  	        {
  	          type: "invalid",
  	          label: "Tractor",
  	          message: "Tractor data is missing or invalid"
  	        }
  	      ],
  	      warnings: []
  	    };
  	  }
  	
  	  const data = (Tractor.Data && typeof Tractor.Data === "object") ? Tractor.Data : {};
  	  const compliance = (data.Compliance && typeof data.Compliance === "object") ? data.Compliance : {};
  	  const service = (data.Service && typeof data.Service === "object") ? data.Service : {};
  	  const history = (service.History && typeof service.History === "object") ? service.History : {};
  	
  	  evaluateDateItem(
  	    "License Expiry Date",
  	    compliance.License_Expiry_Date && compliance.License_Expiry_Date.value,
  	    warningDays,
  	    true,
  	    issues,
  	    warnings
  	  );
  	
  	  evaluateDateItem(
  	    "COF Expiry",
  	    compliance.COF_Expiry && compliance.COF_Expiry.value,
  	    warningDays,
  	    false,
  	    issues,
  	    warnings
  	  );
  	
  	  evaluateDateItem(
  	    "Load Test Expiry",
  	    compliance.Load_Test_Expiry && compliance.Load_Test_Expiry.value,
  	    warningDays,
  	    false,
  	    issues,
  	    warnings
  	  );
  	
  	  evaluateDateItem(
  	    "Calibration Expiry",
  	    compliance.Calibration_Expiry && compliance.Calibration_Expiry.value,
  	    warningDays,
  	    false,
  	    issues,
  	    warnings
  	  );
  	
  	  evaluateDateItem(
  	    "Fire Extinguisher Expiry",
  	    compliance.Fire_Extinguisher_Expiry && compliance.Fire_Extinguisher_Expiry.value,
  	    warningDays,
  	    false,
  	    issues,
  	    warnings
  	  );
  	
  	  evaluateDateItem(
  	    "Warranty Expiry",
  	    data.Service &&
  	    data.Service.Warranty &&
  	    data.Service.Warranty.Warranty_Expiry_Date &&
  	    data.Service.Warranty.Warranty_Expiry_Date.value,
  	    warningDays,
  	    false,
  	    issues,
  	    warnings
  	  );
  	
  	  const currentMileage = Number(Tractor.Mileage);
  	  const nextServiceKm = Number(history.Next_Service_KM && history.Next_Service_KM.value);
  	  const serviceWarningKm = Number(
  	    service.Service_Warning_Duration_in_KM &&
  	    service.Service_Warning_Duration_in_KM.value
  	  );
  	
  	  if (Number.isFinite(currentMileage) && Number.isFinite(nextServiceKm) && nextServiceKm > 0) {
  	    if (currentMileage > nextServiceKm) {
  	      issues.push({
  	        type: "overdue_service",
  	        label: "Service",
  	        currentMileage: currentMileage,
  	        nextServiceKm: nextServiceKm,
  	        kmOverdue: currentMileage - nextServiceKm,
  	        message: `Service is overdue by ${currentMileage - nextServiceKm} km`
  	      });
  	    } else if (
  	      Number.isFinite(serviceWarningKm) &&
  	      serviceWarningKm > 0 &&
  	      currentMileage >= (nextServiceKm - serviceWarningKm)
  	    ) {
  	      warnings.push({
  	        type: "service_due_soon",
  	        label: "Service",
  	        currentMileage: currentMileage,
  	        nextServiceKm: nextServiceKm,
  	        kmLeft: nextServiceKm - currentMileage,
  	        message: `Service is due in ${nextServiceKm - currentMileage} km`
  	      });
  	    }
  	  }
  	
  	  const status =
  	    issues.length > 0 ? "Issue" :
  	    warnings.length > 0 ? "Warning" :
  	    "OK";
  	
  	  return {
  	    ok: true,
  	    status: status,
  	    count: issues.length + warnings.length,
  	    issues: issues,
  	    warnings: warnings
  	  };
  	}
  	
  	/* Example usage in Backendless custom code */
  	const tractor = Tractor;
  	const result = identifyTractorIssues(tractor, { warningDays: 30 });
  	
  	return result;
  })(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Office/components/a9c826585e982af8e80b1568a1b878b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(Input, Tractor) {
  	var TRACTOR_TABLE_NAME = "Tractors";
  	var TRACTOR_ID_FIELD_NAME = "ID";
  	var LICENSE_NUMBER_FIELD_NAME = "License";
  	var LICENSE_EXPIRY_FIELD_NAME = "LicenseExpiry";
  	
  	/*
  	  Use "date" if the Backendless column is Date/DateTime.
  	  Use "string" if the Backendless column is plain text.
  	*/
  	var LICENSE_EXPIRY_SAVE_TYPE = "date";
  	
  	function escapeHtml(value) {
  	  return String(value == null ? "" : value)
  	    .replace(/&/g, "&amp;")
  	    .replace(/</g, "&lt;")
  	    .replace(/>/g, "&gt;")
  	    .replace(/"/g, "&quot;")
  	    .replace(/'/g, "&#39;");
  	}
  	
  	function toCleanString(value) {
  	  return String(value == null ? "" : value).trim();
  	}
  	
  	function getColours() {
  	  return {
  	    fleetOrange: "#ff7a1a",
  	    fleetOrangeSoft: "#ff9a4d",
  	    fleetRed: "#ff4d4f",
  	    fleetAmber: "#ffb347",
  	    fleetGreen: "#38d27d",
  	    panelBg: "#151515",
  	    panelBg2: "#1d1d1d",
  	    panelBg3: "#101010",
  	    panelBorder: "#2f2f2f",
  	    textMain: "#f2f2f2",
  	    textMuted: "#a8a8a8"
  	  };
  	}
  	
  	function getFirstExistingValue(source, fieldNames) {
  	  if (!source || typeof source !== "object") {
  	    return "";
  	  }
  	
  	  for (var i = 0; i < fieldNames.length; i++) {
  	    var fieldName = fieldNames[i];
  	
  	    if (
  	      Object.prototype.hasOwnProperty.call(source, fieldName) &&
  	      source[fieldName] !== null &&
  	      source[fieldName] !== undefined
  	    ) {
  	      return source[fieldName];
  	    }
  	  }
  	
  	  return "";
  	}
  	
  	function getTractorObjectId(tractor) {
  	  if (!tractor || typeof tractor !== "object") {
  	    return "";
  	  }
  	
  	  return toCleanString(getFirstExistingValue(tractor, [
  	    "objectId",
  	    "ObjectId",
  	    "OBJECTID",
  	    "objectID"
  	  ]));
  	}
  	
  	function getTractorLookupId(tractor) {
  	  if (!tractor || typeof tractor !== "object") {
  	    return "";
  	  }
  	
  	  return toCleanString(getFirstExistingValue(tractor, [
  	    TRACTOR_ID_FIELD_NAME,
  	    "ID",
  	    "Id",
  	    "id"
  	  ]));
  	}
  	
  	function getTractorDisplayId(tractor) {
  	  if (!tractor || typeof tractor !== "object") {
  	    return "Unknown Tractor";
  	  }
  	
  	  var tractorId = toCleanString(getFirstExistingValue(tractor, [
  	    TRACTOR_ID_FIELD_NAME,
  	    "ID",
  	    "Id",
  	    "id",
  	    "Registration",
  	    "registration",
  	    "Name",
  	    "name"
  	  ]));
  	
  	  return tractorId || "Unknown Tractor";
  	}
  	
  	function getLicenseNumberFromTractor(tractor) {
  	  return getFirstExistingValue(tractor, [
  	    LICENSE_NUMBER_FIELD_NAME,
  	    "License",
  	    "Licence",
  	    "license",
  	    "licence",
  	    "LicenseNumber",
  	    "LicenceNumber",
  	    "licenseNumber",
  	    "licenceNumber"
  	  ]);
  	}
  	
  	function getLicenseExpiryFromTractor(tractor) {
  	  return getFirstExistingValue(tractor, [
  	    LICENSE_EXPIRY_FIELD_NAME,
  	    "LicenseExpiry",
  	    "LicenceExpiry",
  	    "licenseExpiry",
  	    "licenceExpiry",
  	    "LicenseExpiryDate",
  	    "LicenceExpiryDate",
  	    "licenseExpiryDate",
  	    "licenceExpiryDate"
  	  ]);
  	}
  	
  	function escapeBackendlessStringLiteral(value) {
  	  return String(value == null ? "" : value).replace(/'/g, "''");
  	}
  	
  	function normaliseNotificationStatus(value) {
  	  var status = typeof value === "string" ? value.trim().toLowerCase() : "";
  	
  	  if (status === "issue") {
  	    return "Issue";
  	  }
  	
  	  if (status === "warning") {
  	    return "Warning";
  	  }
  	
  	  if (status === "ok") {
  	    return "OK";
  	  }
  	
  	  return "Invalid";
  	}
  	
  	function normaliseDateInputValue(value) {
  	  if (value === null || value === undefined || value === "") {
  	    return "";
  	  }
  	
  	  if (value instanceof Date && !isNaN(value.getTime())) {
  	    return value.toISOString().slice(0, 10);
  	  }
  	
  	  var text = String(value).trim();
  	
  	  if (!text) {
  	    return "";
  	  }
  	
  	  var isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  	  if (isoMatch) {
  	    return isoMatch[1] + "-" + isoMatch[2] + "-" + isoMatch[3];
  	  }
  	
  	  var slashMatch = text.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
  	  if (slashMatch) {
  	    var day = String(slashMatch[1]).padStart(2, "0");
  	    var month = String(slashMatch[2]).padStart(2, "0");
  	    var year = slashMatch[3];
  	
  	    return year + "-" + month + "-" + day;
  	  }
  	
  	  var parsed = new Date(text);
  	  if (!isNaN(parsed.getTime())) {
  	    return parsed.toISOString().slice(0, 10);
  	  }
  	
  	  return "";
  	}
  	
  	function formatDateForDisplay(value) {
  	  var inputValue = normaliseDateInputValue(value);
  	
  	  if (!inputValue) {
  	    return "Not set";
  	  }
  	
  	  var parts = inputValue.split("-");
  	
  	  if (parts.length !== 3) {
  	    return inputValue;
  	  }
  	
  	  return parts[2] + "/" + parts[1] + "/" + parts[0];
  	}
  	
  	function getDefaultFutureExpiryDate() {
  	  var date = new Date();
  	
  	  date.setFullYear(date.getFullYear() + 1);
  	
  	  return date.toISOString().slice(0, 10);
  	}
  	
  	function dateInputValueToBackendlessValue(dateInputValue) {
  	  var cleanValue = toCleanString(dateInputValue);
  	
  	  if (!cleanValue) {
  	    return null;
  	  }
  	
  	  if (LICENSE_EXPIRY_SAVE_TYPE === "string") {
  	    return cleanValue;
  	  }
  	
  	  var parts = cleanValue.split("-");
  	
  	  if (parts.length !== 3) {
  	    throw new Error("License expiry date is invalid.");
  	  }
  	
  	  var year = Number(parts[0]);
  	  var month = Number(parts[1]);
  	  var day = Number(parts[2]);
  	
  	  if (!year || !month || !day) {
  	    throw new Error("License expiry date is invalid.");
  	  }
  	
  	  return new Date(year, month - 1, day, 12, 0, 0, 0);
  	}
  	
  	function detectNotificationAction(item) {
  	  var field = toCleanString(item && item.field ? item.field : "").toLowerCase();
  	  var code = toCleanString(item && item.code ? item.code : "").toLowerCase();
  	  var action = toCleanString(item && item.action ? item.action : "").toLowerCase();
  	  var message = toCleanString(item && item.message ? item.message : "").toLowerCase();
  	
  	  var combined = field + " " + code + " " + action + " " + message;
  	
  	  if (
  	    combined.indexOf("license expiry") !== -1 ||
  	    combined.indexOf("licence expiry") !== -1 ||
  	    combined.indexOf("licenseexpiry") !== -1 ||
  	    combined.indexOf("licenceexpiry") !== -1 ||
  	    combined.indexOf("expiry date") !== -1 ||
  	    combined.indexOf("expired") !== -1
  	  ) {
  	    return "license-expiry";
  	  }
  	
  	  if (
  	    combined.indexOf("license number") !== -1 ||
  	    combined.indexOf("licence number") !== -1 ||
  	    combined.indexOf("licensenumber") !== -1 ||
  	    combined.indexOf("licencenumber") !== -1
  	  ) {
  	    return "license-number";
  	  }
  	
  	  if (
  	    combined.indexOf("license") !== -1 ||
  	    combined.indexOf("licence") !== -1
  	  ) {
  	    return "license";
  	  }
  	
  	  return "none";
  	}
  	
  	function getNotificationActionText(action) {
  	  if (action === "license-expiry") {
  	    return "Click to fix expiry";
  	  }
  	
  	  if (action === "license-number") {
  	    return "Click to fix license number";
  	  }
  	
  	  if (action === "license") {
  	    return "Click to fix license";
  	  }
  	
  	  return "No quick fix available";
  	}
  	
  	function buildNotificationRow(item, kind, index, colours) {
  	  var isIssue = kind === "issue";
  	  var borderColour = isIssue ? colours.fleetRed : colours.fleetAmber;
  	  var label = isIssue ? "Issue" : "Warning";
  	  var message = item && item.message ? item.message : isIssue ? "Unknown issue" : "Unknown warning";
  	  var action = detectNotificationAction(item);
  	  var actionText = getNotificationActionText(action);
  	  var canFix = action !== "none";
  	
  	  return `
  	    <button
  	      type="button"
  	      class="tractor-notification-row"
  	      data-notification-kind="${escapeHtml(kind)}"
  	      data-notification-index="${escapeHtml(index)}"
  	      data-notification-action="${escapeHtml(action)}"
  	      data-notification-message="${escapeHtml(message)}"
  	      style="
  	        display:block;
  	        width:100%;
  	        text-align:left;
  	        padding:10px 12px;
  	        margin-top:8px;
  	        border:none;
  	        border-left:4px solid ${borderColour};
  	        background:${colours.panelBg2};
  	        border-radius:8px;
  	        cursor:${canFix ? "pointer" : "default"};
  	      "
  	    >
  	      <div style="
  	        display:flex;
  	        justify-content:space-between;
  	        align-items:flex-start;
  	        gap:8px;
  	        margin-bottom:4px;
  	      ">
  	        <div style="
  	          font-size:0.78em;
  	          font-style:italic;
  	          color:${borderColour};
  	        ">${escapeHtml(label)}</div>
  	
  	        <div style="
  	          font-size:0.72em;
  	          color:${canFix ? colours.fleetOrange : colours.textMuted};
  	          white-space:nowrap;
  	        ">${escapeHtml(actionText)}</div>
  	      </div>
  	
  	      <div style="
  	        font-size:0.95em;
  	        line-height:1.35;
  	        color:${colours.textMain};
  	      ">${escapeHtml(message)}</div>
  	    </button>
  	  `;
  	}
  	
  	function buildNotificationRows(issues, warnings, colours) {
  	  var rows = [];
  	
  	  for (var i = 0; i < issues.length; i++) {
  	    rows.push(buildNotificationRow(issues[i], "issue", i, colours));
  	  }
  	
  	  for (var j = 0; j < warnings.length; j++) {
  	    rows.push(buildNotificationRow(warnings[j], "warning", j, colours));
  	  }
  	
  	  if (!rows.length) {
  	    rows.push(`
  	      <div style="
  	        padding:10px 12px;
  	        margin-top:8px;
  	        border-left:4px solid ${colours.fleetOrange};
  	        background:${colours.panelBg2};
  	        border-radius:8px;
  	      ">
  	        <div style="
  	          font-size:0.95em;
  	          line-height:1.35;
  	          color:${colours.textMain};
  	        ">No issues detected.</div>
  	      </div>
  	    `);
  	  }
  	
  	  return rows.join("");
  	}
  	
  	function buildFixCard(tractor, colours) {
  	  var currentLicenseNumber = toCleanString(getLicenseNumberFromTractor(tractor));
  	  var currentLicenseExpiry = normaliseDateInputValue(getLicenseExpiryFromTractor(tractor));
  	  var objectId = getTractorObjectId(tractor);
  	  var lookupId = getTractorLookupId(tractor);
  	
  	  var updateModeText = objectId
  	    ? "Ready to update by objectId."
  	    : lookupId
  	      ? "objectId missing. Will locate tractor by " + TRACTOR_ID_FIELD_NAME + "."
  	      : "Cannot update until this tractor has objectId or " + TRACTOR_ID_FIELD_NAME + ".";
  	
  	  return `
  	    <div
  	      id="tractor-notification-fix-card"
  	      data-selected-action=""
  	      data-selected-kind=""
  	      data-selected-index=""
  	      style="
  	        padding:12px;
  	        margin-bottom:12px;
  	        border:1px solid ${colours.panelBorder};
  	        background:${colours.panelBg2};
  	        border-radius:10px;
  	      "
  	    >
  	      <div style="
  	        font-size:0.95em;
  	        font-weight:700;
  	        color:${colours.fleetOrange};
  	        margin-bottom:4px;
  	      " id="tractor-fix-title">Click a Notification to Fix It</div>
  	
  	      <div style="
  	        font-size:0.75em;
  	        color:${colours.textMuted};
  	        line-height:1.35;
  	        margin-bottom:10px;
  	      " id="tractor-fix-description">
  	        Select an issue below. The correct fix fields will open here.
  	      </div>
  	
  	      <div style="
  	        font-size:0.72em;
  	        color:${colours.textMuted};
  	        line-height:1.35;
  	        margin-bottom:10px;
  	      ">
  	        ${escapeHtml(updateModeText)}
  	      </div>
  	
  	      <div style="
  	        display:grid;
  	        grid-template-columns:1fr;
  	        gap:8px;
  	        margin-bottom:10px;
  	      ">
  	        <div style="
  	          padding:8px 10px;
  	          border:1px solid ${colours.panelBorder};
  	          background:${colours.panelBg3};
  	          border-radius:8px;
  	        ">
  	          <div style="
  	            font-size:0.72em;
  	            color:${colours.textMuted};
  	            margin-bottom:3px;
  	          ">Current License</div>
  	
  	          <div
  	            id="tractor-license-current-number"
  	            style="
  	              font-size:0.88em;
  	              color:${colours.textMain};
  	              line-height:1.3;
  	            "
  	          >${escapeHtml(currentLicenseNumber || "Not set")}</div>
  	        </div>
  	
  	        <div style="
  	          padding:8px 10px;
  	          border:1px solid ${colours.panelBorder};
  	          background:${colours.panelBg3};
  	          border-radius:8px;
  	        ">
  	          <div style="
  	            font-size:0.72em;
  	            color:${colours.textMuted};
  	            margin-bottom:3px;
  	          ">Current Expiry</div>
  	
  	          <div
  	            id="tractor-license-current-expiry"
  	            style="
  	              font-size:0.88em;
  	              color:${colours.textMain};
  	              line-height:1.3;
  	            "
  	          >${escapeHtml(formatDateForDisplay(currentLicenseExpiry))}</div>
  	        </div>
  	      </div>
  	
  	      <div
  	        id="tractor-license-number-field-wrap"
  	        style="display:none;"
  	      >
  	        <label style="
  	          display:block;
  	          font-size:0.75em;
  	          color:${colours.textMuted};
  	          margin-bottom:4px;
  	        ">License Number</label>
  	
  	        <input
  	          id="tractor-license-number-input"
  	          type="text"
  	          value="${escapeHtml(currentLicenseNumber)}"
  	          autocomplete="off"
  	          style="
  	            width:100%;
  	            box-sizing:border-box;
  	            margin-bottom:8px;
  	            padding:8px 10px;
  	            border:1px solid ${colours.panelBorder};
  	            border-radius:8px;
  	            background:${colours.panelBg3};
  	            color:${colours.textMain};
  	            outline:none;
  	          "
  	        />
  	      </div>
  	
  	      <div
  	        id="tractor-license-expiry-field-wrap"
  	        style="display:none;"
  	      >
  	        <label style="
  	          display:block;
  	          font-size:0.75em;
  	          color:${colours.textMuted};
  	          margin-bottom:4px;
  	        ">License Expiry</label>
  	
  	        <input
  	          id="tractor-license-expiry-input"
  	          type="date"
  	          value="${escapeHtml(currentLicenseExpiry)}"
  	          style="
  	            width:100%;
  	            box-sizing:border-box;
  	            margin-bottom:8px;
  	            padding:8px 10px;
  	            border:1px solid ${colours.panelBorder};
  	            border-radius:8px;
  	            background:${colours.panelBg3};
  	            color:${colours.textMain};
  	            outline:none;
  	          "
  	        />
  	
  	        <button
  	          id="tractor-license-plus-one-year-button"
  	          type="button"
  	          style="
  	            width:100%;
  	            appearance:none;
  	            border:1px solid ${colours.panelBorder};
  	            background:${colours.panelBg3};
  	            color:${colours.textMain};
  	            border-radius:8px;
  	            cursor:pointer;
  	            font-size:0.82em;
  	            padding:8px 10px;
  	            margin-bottom:8px;
  	          "
  	        >Set Expiry to One Year From Today</button>
  	      </div>
  	
  	      <button
  	        id="tractor-license-save-button"
  	        type="button"
  	        style="
  	          display:none;
  	          width:100%;
  	          appearance:none;
  	          border:1px solid ${colours.fleetOrange};
  	          background:${colours.fleetOrange};
  	          color:#111;
  	          border-radius:8px;
  	          cursor:pointer;
  	          font-size:0.9em;
  	          font-weight:700;
  	          padding:9px 10px;
  	        "
  	      >Save Fix</button>
  	
  	      <div
  	        id="tractor-license-update-status"
  	        style="
  	          min-height:16px;
  	          margin-top:8px;
  	          font-size:0.78em;
  	          color:${colours.textMuted};
  	          line-height:1.3;
  	        "
  	      ></div>
  	    </div>
  	  `;
  	}
  	
  	function buildNotificationPanel(data, tractor) {
  	  var result = data || {};
  	  var issues = Array.isArray(result.issues) ? result.issues : [];
  	  var warnings = Array.isArray(result.warnings) ? result.warnings : [];
  	  var status = normaliseNotificationStatus(result.status);
  	  var numericCount = Number(result.count);
  	  var count = Number.isFinite(numericCount) ? numericCount : issues.length + warnings.length;
  	  var tractorId = getTractorDisplayId(tractor);
  	  var colours = getColours();
  	
  	  var badgeColor = colours.fleetOrange;
  	  var title = "Notifications";
  	
  	  if (status === "Issue") {
  	    badgeColor = colours.fleetRed;
  	    title = "Issues Found";
  	  } else if (status === "Warning") {
  	    badgeColor = colours.fleetAmber;
  	    title = "Warnings Found";
  	  } else if (status === "OK") {
  	    badgeColor = colours.fleetOrangeSoft;
  	    title = "All In Order";
  	  }
  	
  	  return `
  	    <div style="
  	      width:100%;
  	      height:100%;
  	      box-sizing:border-box;
  	      border-left:1px solid ${colours.panelBorder};
  	      border-top:3px solid ${colours.fleetOrange};
  	      background:${colours.panelBg};
  	      padding:14px;
  	      font-family:Arial, sans-serif;
  	      box-shadow:0 0 24px rgba(0,0,0,0.30);
  	      overflow-y:auto;
  	      overflow-x:hidden;
  	    ">
  	      <div style="
  	        display:flex;
  	        justify-content:space-between;
  	        align-items:flex-start;
  	        gap:10px;
  	        margin-bottom:10px;
  	        position:sticky;
  	        top:0;
  	        background:${colours.panelBg};
  	        padding-bottom:8px;
  	        z-index:2;
  	      ">
  	        <div style="flex:1; min-width:0;">
  	          <div style="
  	            font-size:1.05em;
  	            font-weight:700;
  	            color:${colours.fleetOrange};
  	            letter-spacing:0.2px;
  	            margin-bottom:6px;
  	          ">
  	            ${escapeHtml(title)}
  	          </div>
  	
  	          <div style="
  	            font-size:0.78em;
  	            color:${colours.textMuted};
  	            line-height:1.3;
  	          ">
  	            ${escapeHtml(tractorId)} Notification Panel
  	          </div>
  	        </div>
  	
  	        <div style="
  	          display:flex;
  	          align-items:center;
  	          gap:8px;
  	          flex-shrink:0;
  	        ">
  	          <div style="
  	            font-size:0.8em;
  	            font-style:italic;
  	            color:${badgeColor};
  	            background:transparent;
  	            border:1px solid ${badgeColor};
  	            border-radius:999px;
  	            padding:4px 10px;
  	            white-space:nowrap;
  	          ">
  	            ${escapeHtml(status)} • ${escapeHtml(count)}
  	          </div>
  	
  	          <button
  	            id="tractor-notification-panel-close"
  	            type="button"
  	            style="
  	              appearance:none;
  	              border:1px solid ${colours.panelBorder};
  	              background:${colours.panelBg2};
  	              color:${colours.textMuted};
  	              width:30px;
  	              height:30px;
  	              border-radius:8px;
  	              cursor:pointer;
  	              font-size:16px;
  	              line-height:1;
  	              padding:0;
  	            "
  	            title="Close"
  	          >×</button>
  	        </div>
  	      </div>
  	
  	      ${buildFixCard(tractor, colours)}
  	
  	      <div>
  	        ${buildNotificationRows(issues, warnings, colours)}
  	      </div>
  	    </div>
  	  `;
  	}
  	
  	function setFixStatus(message, isError) {
  	  var colours = getColours();
  	  var statusNode = document.getElementById("tractor-license-update-status");
  	
  	  if (!statusNode) {
  	    return;
  	  }
  	
  	  statusNode.textContent = message || "";
  	  statusNode.style.color = isError ? colours.fleetRed : colours.textMuted;
  	}
  	
  	function setSaveButtonBusy(isBusy) {
  	  var saveBtn = document.getElementById("tractor-license-save-button");
  	
  	  if (!saveBtn) {
  	    return;
  	  }
  	
  	  saveBtn.disabled = !!isBusy;
  	  saveBtn.textContent = isBusy ? "Saving..." : "Save Fix";
  	  saveBtn.style.opacity = isBusy ? "0.65" : "1";
  	  saveBtn.style.cursor = isBusy ? "wait" : "pointer";
  	}
  	
  	function clearSelectedNotificationRows() {
  	  var rows = document.querySelectorAll(".tractor-notification-row");
  	
  	  for (var i = 0; i < rows.length; i++) {
  	    rows[i].style.outline = "none";
  	    rows[i].style.boxShadow = "none";
  	  }
  	}
  	
  	function selectNotificationRow(row) {
  	  var colours = getColours();
  	
  	  clearSelectedNotificationRows();
  	
  	  row.style.outline = "1px solid " + colours.fleetOrange;
  	  row.style.boxShadow = "0 0 0 3px rgba(255,122,26,0.12)";
  	}
  	
  	function showFixFieldsForAction(action, message, kind, index) {
  	  var colours = getColours();
  	  var fixCard = document.getElementById("tractor-notification-fix-card");
  	  var titleNode = document.getElementById("tractor-fix-title");
  	  var descriptionNode = document.getElementById("tractor-fix-description");
  	  var licenseNumberWrap = document.getElementById("tractor-license-number-field-wrap");
  	  var licenseExpiryWrap = document.getElementById("tractor-license-expiry-field-wrap");
  	  var saveBtn = document.getElementById("tractor-license-save-button");
  	  var expiryInput = document.getElementById("tractor-license-expiry-input");
  	  var numberInput = document.getElementById("tractor-license-number-input");
  	
  	  if (!fixCard || !titleNode || !descriptionNode || !licenseNumberWrap || !licenseExpiryWrap || !saveBtn) {
  	    return;
  	  }
  	
  	  fixCard.setAttribute("data-selected-action", action || "");
  	  fixCard.setAttribute("data-selected-kind", kind || "");
  	  fixCard.setAttribute("data-selected-index", index || "");
  	
  	  licenseNumberWrap.style.display = "none";
  	  licenseExpiryWrap.style.display = "none";
  	  saveBtn.style.display = "none";
  	
  	  if (action === "license-expiry") {
  	    titleNode.textContent = "Fix License Expiry";
  	    descriptionNode.textContent = message || "Update the tractor license expiry date.";
  	    licenseExpiryWrap.style.display = "block";
  	    saveBtn.style.display = "block";
  	
  	    if (expiryInput && !toCleanString(expiryInput.value)) {
  	      expiryInput.value = getDefaultFutureExpiryDate();
  	    }
  	
  	    setFixStatus("Choose the new expiry date and save the fix.", false);
  	
  	    if (expiryInput) {
  	      expiryInput.focus();
  	    }
  	  } else if (action === "license-number") {
  	    titleNode.textContent = "Fix License Number";
  	    descriptionNode.textContent = message || "Update the tractor license number.";
  	    licenseNumberWrap.style.display = "block";
  	    saveBtn.style.display = "block";
  	
  	    setFixStatus("Enter the license number and save the fix.", false);
  	
  	    if (numberInput) {
  	      numberInput.focus();
  	    }
  	  } else if (action === "license") {
  	    titleNode.textContent = "Fix License";
  	    descriptionNode.textContent = message || "Update the tractor license details.";
  	    licenseNumberWrap.style.display = "block";
  	    licenseExpiryWrap.style.display = "block";
  	    saveBtn.style.display = "block";
  	
  	    if (expiryInput && !toCleanString(expiryInput.value)) {
  	      expiryInput.value = getDefaultFutureExpiryDate();
  	    }
  	
  	    setFixStatus("Update the required license details and save the fix.", false);
  	
  	    if (numberInput) {
  	      numberInput.focus();
  	    }
  	  } else {
  	    titleNode.textContent = "No Quick Fix Available";
  	    descriptionNode.textContent = message || "This notification does not have a mapped fix action yet.";
  	    setFixStatus("This notification needs a custom fix mapping.", true);
  	  }
  	
  	  fixCard.style.borderColor = colours.fleetOrange;
  	
  	  if (typeof fixCard.scrollIntoView === "function") {
  	    fixCard.scrollIntoView({
  	      behavior: "smooth",
  	      block: "nearest"
  	    });
  	  }
  	}
  	
  	function updateCurrentLicenseDisplay(licenseNumber, licenseExpiryInputValue) {
  	  var currentNumberNode = document.getElementById("tractor-license-current-number");
  	  var currentExpiryNode = document.getElementById("tractor-license-current-expiry");
  	
  	  if (currentNumberNode) {
  	    currentNumberNode.textContent = licenseNumber || "Not set";
  	  }
  	
  	  if (currentExpiryNode) {
  	    currentExpiryNode.textContent = formatDateForDisplay(licenseExpiryInputValue);
  	  }
  	}
  	
  	function markSelectedNotificationSaved() {
  	  var fixCard = document.getElementById("tractor-notification-fix-card");
  	
  	  if (!fixCard) {
  	    return;
  	  }
  	
  	  var kind = fixCard.getAttribute("data-selected-kind") || "";
  	  var index = fixCard.getAttribute("data-selected-index") || "";
  	
  	  if (!kind || index === "") {
  	    return;
  	  }
  	
  	  var row = document.querySelector(
  	    ".tractor-notification-row[data-notification-kind='" +
  	      kind +
  	      "'][data-notification-index='" +
  	      index +
  	      "']"
  	  );
  	
  	  if (!row) {
  	    return;
  	  }
  	
  	  var colours = getColours();
  	
  	  row.style.borderLeftColor = colours.fleetGreen;
  	  row.style.opacity = "0.75";
  	
  	  var statusText = row.querySelector("div div:last-child");
  	
  	  if (statusText) {
  	    statusText.textContent = "Saved — recheck to confirm";
  	    statusText.style.color = colours.fleetGreen;
  	  }
  	}
  	
  	function getBackendlessSDK() {
  	  var BackendlessSDK = (typeof Backendless !== "undefined" ? Backendless : null);
  	
  	  if (
  	    !BackendlessSDK ||
  	    !BackendlessSDK.Data ||
  	    typeof BackendlessSDK.Data.of !== "function"
  	  ) {
  	    throw new Error("Backendless SDK is not available on this page.");
  	  }
  	
  	  return BackendlessSDK;
  	}
  	
  	async function findExistingTractorById(BackendlessSDK, tractor) {
  	  var lookupId = getTractorLookupId(tractor);
  	
  	  if (!lookupId) {
  	    throw new Error("Cannot update: Tractor has no objectId and no " + TRACTOR_ID_FIELD_NAME + " value.");
  	  }
  	
  	  if (
  	    !BackendlessSDK.DataQueryBuilder ||
  	    typeof BackendlessSDK.DataQueryBuilder.create !== "function"
  	  ) {
  	    throw new Error("Cannot look up tractor by " + TRACTOR_ID_FIELD_NAME + ": Backendless DataQueryBuilder is not available.");
  	  }
  	
  	  var queryBuilder = BackendlessSDK.DataQueryBuilder.create();
  	  var whereClause = TRACTOR_ID_FIELD_NAME + " = '" + escapeBackendlessStringLiteral(lookupId) + "'";
  	
  	  queryBuilder.setWhereClause(whereClause);
  	
  	  if (typeof queryBuilder.setPageSize === "function") {
  	    queryBuilder.setPageSize(2);
  	  }
  	
  	  var records = await BackendlessSDK.Data.of(TRACTOR_TABLE_NAME).find(queryBuilder);
  	
  	  if (!Array.isArray(records) || records.length === 0) {
  	    throw new Error("Cannot update: no tractor found where " + TRACTOR_ID_FIELD_NAME + " = " + lookupId + ".");
  	  }
  	
  	  if (records.length > 1) {
  	    throw new Error("Cannot update safely: more than one tractor matches " + TRACTOR_ID_FIELD_NAME + " = " + lookupId + ".");
  	  }
  	
  	  if (!records[0] || !records[0].objectId) {
  	    throw new Error("Cannot update: matched tractor has no objectId.");
  	  }
  	
  	  return records[0];
  	}
  	
  	async function resolveTractorForUpdate(BackendlessSDK, tractor) {
  	  var objectId = getTractorObjectId(tractor);
  	
  	  if (objectId) {
  	    return {
  	      objectId: objectId
  	    };
  	  }
  	
  	  return findExistingTractorById(BackendlessSDK, tractor);
  	}
  	
  	async function saveSelectedNotificationFix(tractor) {
  	  var BackendlessSDK = getBackendlessSDK();
  	
  	  if (!tractor || typeof tractor !== "object") {
  	    throw new Error("Cannot update: Tractor object is missing.");
  	  }
  	
  	  var fixCard = document.getElementById("tractor-notification-fix-card");
  	
  	  if (!fixCard) {
  	    throw new Error("Cannot update: Fix card is missing.");
  	  }
  	
  	  var selectedAction = fixCard.getAttribute("data-selected-action") || "";
  	
  	  if (!selectedAction || selectedAction === "none") {
  	    throw new Error("Click a fixable notification first.");
  	  }
  	
  	  var existingTractor = await resolveTractorForUpdate(BackendlessSDK, tractor);
  	
  	  var licenseNumberInput = document.getElementById("tractor-license-number-input");
  	  var licenseExpiryInput = document.getElementById("tractor-license-expiry-input");
  	
  	  var licenseNumber = licenseNumberInput ? toCleanString(licenseNumberInput.value) : "";
  	  var licenseExpiryInputValue = licenseExpiryInput ? toCleanString(licenseExpiryInput.value) : "";
  	
  	  var updateObject = {
  	    objectId: existingTractor.objectId
  	  };
  	
  	  if (selectedAction === "license-number" || selectedAction === "license") {
  	    if (!licenseNumber) {
  	      throw new Error("Enter the license number before saving.");
  	    }
  	
  	    updateObject[LICENSE_NUMBER_FIELD_NAME] = licenseNumber;
  	  }
  	
  	  if (selectedAction === "license-expiry" || selectedAction === "license") {
  	    if (!licenseExpiryInputValue) {
  	      throw new Error("Select the license expiry date before saving.");
  	    }
  	
  	    updateObject[LICENSE_EXPIRY_FIELD_NAME] = dateInputValueToBackendlessValue(licenseExpiryInputValue);
  	  }
  	
  	  var savedTractor = await BackendlessSDK.Data.of(TRACTOR_TABLE_NAME).save(updateObject);
  	
  	  tractor.objectId = savedTractor && savedTractor.objectId ? savedTractor.objectId : existingTractor.objectId;
  	
  	  if (Object.prototype.hasOwnProperty.call(updateObject, LICENSE_NUMBER_FIELD_NAME)) {
  	    tractor[LICENSE_NUMBER_FIELD_NAME] = savedTractor && savedTractor[LICENSE_NUMBER_FIELD_NAME] !== undefined
  	      ? savedTractor[LICENSE_NUMBER_FIELD_NAME]
  	      : licenseNumber;
  	  }
  	
  	  if (Object.prototype.hasOwnProperty.call(updateObject, LICENSE_EXPIRY_FIELD_NAME)) {
  	    tractor[LICENSE_EXPIRY_FIELD_NAME] = savedTractor && savedTractor[LICENSE_EXPIRY_FIELD_NAME] !== undefined
  	      ? savedTractor[LICENSE_EXPIRY_FIELD_NAME]
  	      : licenseExpiryInputValue;
  	  }
  	
  	  updateCurrentLicenseDisplay(
  	    toCleanString(getLicenseNumberFromTractor(tractor)),
  	    normaliseDateInputValue(getLicenseExpiryFromTractor(tractor))
  	  );
  	
  	  return savedTractor || updateObject;
  	}
  	
  	function emitNotificationFixedEvent(savedTractor) {
  	  try {
  	    var eventPayload = {
  	      tractor: savedTractor || null
  	    };
  	
  	    if (typeof CustomEvent === "function") {
  	      document.dispatchEvent(new CustomEvent("tractor-notification-fixed", {
  	        detail: eventPayload
  	      }));
  	
  	      document.dispatchEvent(new CustomEvent("tractor-license-updated", {
  	        detail: eventPayload
  	      }));
  	
  	      return;
  	    }
  	
  	    var fallbackEvent = document.createEvent("CustomEvent");
  	    fallbackEvent.initCustomEvent("tractor-notification-fixed", true, true, eventPayload);
  	    document.dispatchEvent(fallbackEvent);
  	  } catch (error) {
  	    /*
  	      Event dispatch is useful, but it must not block the save.
  	    */
  	  }
  	}
  	
  	function wireNotificationPanelEvents(tractor) {
  	  var closeBtn = document.getElementById("tractor-notification-panel-close");
  	
  	  if (closeBtn) {
  	    closeBtn.onclick = function () {
  	      var panel = document.getElementById("tractor-notification-panel");
  	
  	      if (panel) {
  	        panel.remove();
  	      }
  	    };
  	  }
  	
  	  var notificationRows = document.querySelectorAll(".tractor-notification-row");
  	
  	  for (var i = 0; i < notificationRows.length; i++) {
  	    notificationRows[i].onclick = function () {
  	      var action = this.getAttribute("data-notification-action") || "none";
  	      var message = this.getAttribute("data-notification-message") || "";
  	      var kind = this.getAttribute("data-notification-kind") || "";
  	      var index = this.getAttribute("data-notification-index") || "";
  	
  	      selectNotificationRow(this);
  	      showFixFieldsForAction(action, message, kind, index);
  	    };
  	  }
  	
  	  var plusOneYearBtn = document.getElementById("tractor-license-plus-one-year-button");
  	
  	  if (plusOneYearBtn) {
  	    plusOneYearBtn.onclick = function () {
  	      var expiryInput = document.getElementById("tractor-license-expiry-input");
  	
  	      if (expiryInput) {
  	        expiryInput.value = getDefaultFutureExpiryDate();
  	        expiryInput.focus();
  	        setFixStatus("Expiry date set to one year from today. Save the fix to update Backendless.", false);
  	      }
  	    };
  	  }
  	
  	  var saveBtn = document.getElementById("tractor-license-save-button");
  	
  	  if (saveBtn) {
  	    saveBtn.onclick = async function () {
  	      try {
  	        setSaveButtonBusy(true);
  	        setFixStatus("Saving fix...", false);
  	
  	        var savedTractor = await saveSelectedNotificationFix(tractor || null);
  	
  	        emitNotificationFixedEvent(savedTractor);
  	        markSelectedNotificationSaved();
  	        setFixStatus("Fix saved successfully. Re-run the validation to confirm the issue is cleared.", false);
  	      } catch (error) {
  	        setFixStatus(error && error.message ? error.message : "Failed to save fix.", true);
  	      } finally {
  	        setSaveButtonBusy(false);
  	      }
  	    };
  	  }
  	}
  	
  	function showNotificationPanel(input, tractor) {
  	  var existing = document.getElementById("tractor-notification-panel");
  	
  	  if (existing) {
  	    existing.remove();
  	  }
  	
  	  var host = document.createElement("div");
  	
  	  host.id = "tractor-notification-panel";
  	  host.style.position = "fixed";
  	  host.style.top = "250px";
  	  host.style.right = "0px";
  	  host.style.bottom = "0px";
  	  host.style.width = "380px";
  	  host.style.maxWidth = "calc(100vw - 20px)";
  	  host.style.zIndex = "999999";
  	  host.style.pointerEvents = "auto";
  	  host.innerHTML = buildNotificationPanel(input || {}, tractor || null);
  	
  	  document.body.appendChild(host);
  	
  	  wireNotificationPanelEvents(tractor || null);
  	
  	  return true;
  	}
  	
  	var input = (typeof Input !== "undefined" ? Input : {});
  	var tractor = (typeof Tractor !== "undefined" ? Tractor : null);
  	
  	return showNotificationPanel(input, tractor);
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Notifications')), ___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var color;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'), 'Notifications.count')) > 0) {
    color = ({ [`color`]: 'rgba(255, 0, 0, 1' });
  } else {
    color = ({ [`color`]: 'rgba(204, 204, 204, 1' });
  }

  return color

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Office/components/43a90b1c12d16b47de18c4937f68bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Tractors, k, j, Month;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Tractors2() {
  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if ((getObjectProperty(k, 'Type')) == 'Agri') {
        if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(k, 'ViewC'))))) {
        } else {
          if ((getObjectProperty((getObjectProperty(k, 'ViewC')), 'MYear')) == ___arguments.value) {
            addItemToList(Tractors, k);
          }
        }
      }
    }
  }
  return Tractors
}


  try {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d2447e9831b800d8812be9e7d18859b9', (await Tractors2()));

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Tractors, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Myear() {
  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(k, 'ViewC'))))) {
      } else {
        addItemToList(Tractors, (getObjectProperty((getObjectProperty(k, 'ViewC')), 'MYear')));
      }
    }
  }
  return (await (async function(List) {
	return (function () {
	  try {
	    var list = (typeof List !== "undefined" ? List : []);
	
	    function toArray(value) {
	      if (Array.isArray(value)) return value;
	      if (value === null || value === undefined) return [];
	      return [value];
	    }
	
	    function getDeep(obj, path, fallback) {
	      try {
	        var current = obj;
	
	        for (var i = 0; i < path.length; i++) {
	          if (current === null || current === undefined) return fallback;
	          current = current[path[i]];
	        }
	
	        return current === null || current === undefined ? fallback : current;
	      } catch (e) {
	        return fallback;
	      }
	    }
	
	    function firstDefined() {
	      for (var i = 0; i < arguments.length; i++) {
	        if (arguments[i] !== null && arguments[i] !== undefined && arguments[i] !== "") {
	          return arguments[i];
	        }
	      }
	
	      return null;
	    }
	
	    function getDuplicateKey(item) {
	      if (item === null || item === undefined) return "";
	
	      if (typeof item !== "object") {
	        return String(item).trim().toLowerCase();
	      }
	
	      return String(
	        firstDefined(
	          getDeep(item, ["objectId"], null),
	          getDeep(item, ["ID"], null),
	          getDeep(item, ["FID"], null),
	          getDeep(item, ["DeviceId"], null),
	          getDeep(item, ["Registration"], null),
	          getDeep(item, ["Name"], null),
	          JSON.stringify(item)
	        )
	      ).trim().toLowerCase();
	    }
	
	    var source = toArray(list);
	    var seen = {};
	    var output = [];
	
	    for (var i = 0; i < source.length; i++) {
	      var item = source[i];
	      var key = getDuplicateKey(item);
	
	      if (!key) continue;
	
	      if (!seen[key]) {
	        seen[key] = true;
	        output.push(item);
	      }
	    }
	
	    return output;
	  } catch (error) {
	    console.log("Duplicate Remover error:", error);
	    return [];
	  }
	})();
})(Tractors))
}



  return (await Promise.all((await (async function(List) {
	return (function () {
	  try {
	    var list = (typeof List !== "undefined" ? List: null);

	    function toArray(value) {
	      if (Array.isArray(value)) return value;
	      if (value === null || value === undefined) return [];
	      return [value];
	    }

	    function getDeep(obj, path, fallback) {
	      try {
	        var current = obj;

	        for (var i = 0; i < path.length; i++) {
	          if (current === null || current === undefined) return fallback;
	          current = current[path[i]];
	        }

	        return current === null || current === undefined ? fallback: current;
	      } catch (e) {
	        return fallback;
	      }
	    }

	    function getMonthIndex(monthName) {
	      var months = {
	        january: 0,
	        february: 1,
	        march: 2,
	        april: 3,
	        may: 4,
	        june: 5,
	        july: 6,
	        august: 7,
	        september: 8,
	        october: 9,
	        november: 10,
	        december: 11
	      };

	      return months[String(monthName || "").trim().toLowerCase()];
	    }

	    function getSortableDateValue(item) {
	      var raw = item;

	      if (item && typeof item === "object") {
	        raw = getDeep(item, ["MYear"], null);
	      }

	      raw = String(raw || "").trim();

	      // Supports "2026-06"
	      var keyMatch = raw.match(/^(\d{4})-(\d{1,2})$/);
	      if (keyMatch) {
	        return new Date(Number(keyMatch[1]), Number(keyMatch[2]) - 1, 1).getTime();
	      }

	      // Supports "June 2026"
	      var labelMatch = raw.match(/^([A-Za-z]+)\s+(\d{4})$/);
	      if (labelMatch) {
	        var monthIndex = getMonthIndex(labelMatch[1]);
	        var year = Number(labelMatch[2]);

	        if (monthIndex !== undefined && !isNaN(year)) {
	          return new Date(year, monthIndex, 1).getTime();
	        }
	      }

	      // Fallback for actual date strings
	      var parsed = new Date(raw).getTime();
	      if (!isNaN(parsed)) return parsed;

	      return 0;
	    }

	    var output = toArray(list).slice();

	    output.sort(function (a, b) {
	      return getSortableDateValue(a) - getSortableDateValue(b);
	    });

	    return output;
	  } catch (error) {
	    console.log("Month Year Sorter error:", error);
	    return [];
	  }
	})();
})((await Myear()))).map(async item => {; return ({ [`value`]: item,[`label`]: item });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Office/components/2948954dad05d378514a8fb85d485128/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var Attampt, error, j, k, Month, Success, Tractors, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Form_Hydrater() {
  try {
    if ((getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('43a90b1c12d16b47de18c4937f68bb48'))[0]), 'value')) == 'value-1') {
    } else {
      Month = (await (async function(Values) {
      	return (function () {
      	  try {
      	    var values = (typeof Values !== "undefined" ? Values : []);
      	
      	    function toArray(value) {
      	      if (Array.isArray(value)) return value;
      	      if (value === null || value === undefined) return [];
      	      return [value];
      	    }
      	
      	    function getDeep(obj, path, fallback) {
      	      try {
      	        var current = obj;
      	
      	        for (var i = 0; i < path.length; i++) {
      	          if (current === null || current === undefined) return fallback;
      	          current = current[path[i]];
      	        }
      	
      	        return current === null || current === undefined ? fallback : current;
      	      } catch (e) {
      	        return fallback;
      	      }
      	    }
      	
      	    function firstDefined() {
      	      for (var i = 0; i < arguments.length; i++) {
      	        if (arguments[i] !== null && arguments[i] !== undefined && arguments[i] !== "") {
      	          return arguments[i];
      	        }
      	      }
      	
      	      return null;
      	    }
      	
      	    function getMonthIndex(monthName) {
      	      var months = {
      	        january: 0,
      	        february: 1,
      	        march: 2,
      	        april: 3,
      	        may: 4,
      	        june: 5,
      	        july: 6,
      	        august: 7,
      	        september: 8,
      	        october: 9,
      	        november: 10,
      	        december: 11
      	      };
      	
      	      return months[String(monthName || "").trim().toLowerCase()];
      	    }
      	
      	    function getOptionValue(item) {
      	      if (item && typeof item === "object") {
      	        return firstDefined(
      	          getDeep(item, ["value"], null),
      	          getDeep(item, ["label"], null),
      	          getDeep(item, ["MYear"], null),
      	          getDeep(item, ["MYearKey"], null)
      	        );
      	      }
      	
      	      return item;
      	    }
      	
      	    function getSortableDateValue(item) {
      	      var raw = getOptionValue(item);
      	      raw = String(raw || "").trim();
      	
      	      // Supports "2026-06"
      	      var keyMatch = raw.match(/^(\d{4})-(\d{1,2})$/);
      	      if (keyMatch) {
      	        return new Date(Number(keyMatch[1]), Number(keyMatch[2]) - 1, 1).getTime();
      	      }
      	
      	      // Supports "June 2026"
      	      var labelMatch = raw.match(/^([A-Za-z]+)\s+(\d{4})$/);
      	      if (labelMatch) {
      	        var monthIndex = getMonthIndex(labelMatch[1]);
      	        var year = Number(labelMatch[2]);
      	
      	        if (monthIndex !== undefined && !isNaN(year)) {
      	          return new Date(year, monthIndex, 1).getTime();
      	        }
      	      }
      	
      	      // Fallback for real date strings
      	      var parsed = new Date(raw).getTime();
      	      if (!isNaN(parsed)) return parsed;
      	
      	      return 0;
      	    }
      	
      	    var source = toArray(values);
      	    var latestItem = null;
      	    var latestTime = -Infinity;
      	
      	    for (var i = 0; i < source.length; i++) {
      	      var item = source[i];
      	      var time = getSortableDateValue(item);
      	
      	      if (time > latestTime) {
      	        latestTime = time;
      	        latestItem = item;
      	      }
      	    }
      	
      	    return latestItem ? String(getOptionValue(latestItem) || "") : "";
      	  } catch (error) {
      	    console.log("Latest Month Selector error:", error);
      	    return "";
      	  }
      	})();
      })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('43a90b1c12d16b47de18c4937f68bb48'))));
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('43a90b1c12d16b47de18c4937f68bb48', Month);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d2447e9831b800d8812be9e7d18859b9', (await Tractors2()));
      Success = false;
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Attampt = (typeof Attampt == 'number' ? Attampt : 0) + 1;
    }

  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Tractors2() {
  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if ((getObjectProperty(k, 'Type')) == 'Agri') {
        if ((await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(k, 'ViewC'))))) {
        } else {
          if ((getObjectProperty((getObjectProperty(k, 'ViewC')), 'MYear')) == Month) {
            addItemToList(Tractors, k);
          }
        }
      }
    }
  }
  return Tractors
}


  Attampt = 0;
  Success = true;
  while (Success == true) {
    if (Attampt > 40) {
      break;
    }
    await Form_Hydrater();
    if (Success == false) {
      break;
    } else {
      await new Promise(r => setTimeout(r, 50 || 0));
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Office/components/41f421544278574e5ca8eb38c67b447a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function(App, SVG, Vehicle) {
  	function vehicleManager(args) {
  	  console.log("VEH-MAN: INIT vehicle-only manager modern rewrite", args);

  	  args = args || {};

  	  // ===============================================================
  	  // SAFE INPUTS
  	  // ===============================================================
  	  function pickInputValue(source, names) {
  	    var i;
  	    var value;

  	    source = source || {};

  	    for (i = 0; i < names.length; i++) {
  	      if (
  	        Object.prototype.hasOwnProperty.call(source, names[i]) &&
  	        source[names[i]] !== null &&
  	        source[names[i]] !== undefined
  	      ) {
  	        value = source[names[i]];

  	        if (
  	          value &&
  	          typeof value === "object" &&
  	          !Array.isArray(value) &&
  	          Object.prototype.hasOwnProperty.call(value, "value")
  	        ) {
  	          value = value.value;
  	        }

  	        return value;
  	      }
  	    }

  	    return null;
  	  }

  	  var BackendlessSafe = pickInputValue(args, ["Backendless", "backendless"]) || (typeof Backendless !== "undefined" ? Backendless: null);
  	  var AppSafe = pickInputValue(args, ["App", "app", "AppData", "appData"]) || (typeof App !== "undefined" ? App: null);
  	  var VehicleSafe = pickInputValue(args, [
  	    "Vehicle",
  	    "vehicle",
  	    "Vehichle",
  	    "Vehchle",
  	    "Tractor",
  	    "tractor",
  	    "Item",
  	    "item",
  	    "DataItem",
  	    "dataItem",
  	    "RepeaterDataItem",
  	    "repeaterDataItem",
  	    "Repeater Data Item"
  	  ]);
  	  var TyresSafe = Array.isArray(args.Tyres) ? args.Tyres: (typeof Tyres !== "undefined" && Array.isArray(Tyres) ? Tyres: []);
  	  var SvgSafe =
  	  args.SVG ||
  	  args.svg ||
  	  args.Svg ||
  	  (typeof SVG !== "undefined" ? SVG: "") ||
  	  (typeof window !== "undefined" && window.SVG ? window.SVG: "");

  	  var DocumentSafe = typeof document !== "undefined" ? document: null;
  	  var WindowSafe = typeof window !== "undefined" ? window: null;

  	  if (!DocumentSafe) {
  	    console.warn("VEH-MAN: document unavailable");
  	    return false;
  	  }

  	  if (!VehicleSafe || typeof VehicleSafe !== "object") {
  	    console.warn("VEH-MAN: Vehicle input missing or invalid", VehicleSafe);

  	    if (WindowSafe && typeof WindowSafe.alert === "function") {
  	      WindowSafe.alert("Vehicle Manager could not open because no vehicle was supplied.");
  	    }

  	    return false;
  	  }

  	  // ===============================================================
  	  // CONFIG
  	  // ===============================================================
  	  var TABLE_VEHICLES = args.VehicleTable || args.TableName || "Tractors";
  	  var TABLE_TYRES = args.TyreTable || "Tyres";

  	  var TPOSITIONS_PRIMARY = "TPositions";
  	  var TPOSITIONS_SECONDARY = "TyrePositions";
  	  var TYRES_RELATION = "Tyres";

  	  var LIFE_CYCLE_FIELD = "LifeCycle";
  	  var HISTORY_FIELD = "History";

  	  var SCHEMA_VERSION = "T3.0";
  	  var DEFAULT_VEHICLE_TYPE = args.VehicleType || "Tractor";

  	  var TYRE_STATUS = {
  	    OK: "All In Order",
  	    RETREAD: "In For Retread",
  	    SCRAPPED: "Scrapped",
  	    STOLEN: "Stolen",
  	    SOLD: "Sold",
  	    LOST: "Lost"
  	  };

  	  var REMOVE_DESTINATIONS = [{
  	    value: "Warehouse",
  	    label: "Warehouse",
  	    status: TYRE_STATUS.OK
  	  },
  	    {
  	      value: "Retread",
  	      label: "Retread",
  	      status: TYRE_STATUS.RETREAD
  	    },
  	    {
  	      value: "Scrap",
  	      label: "Scrap",
  	      status: TYRE_STATUS.SCRAPPED
  	    },
  	    {
  	      value: "Stolen",
  	      label: "Stolen",
  	      status: TYRE_STATUS.STOLEN
  	    }];

  	  var VEHICLE_TABS = [{
  	    label: "Vehicle",
  	    key: "Vehicle"
  	  },
  	    {
  	      label: "Service",
  	      key: "Service"
  	    },
  	    {
  	      label: "Maintenance",
  	      key: "Maintenance"
  	    },
  	    {
  	      label: "Tyres",
  	      key: "Tyres"
  	    },
  	    {
  	      label: "Compliance",
  	      key: "Compliance"
  	    }];

  	  var BackendlessApi = BackendlessSafe;
  	  var App = AppSafe;
  	  var TyresInput = TyresSafe;

  	  // ===============================================================
  	  // STATE
  	  // ===============================================================
  	  var state = {
  	    sourceVehicle: VehicleSafe,
  	    activeTab: "Vehicle",
  	    root: null,

  	    message: "",
  	    messageError: false,
  	    busy: false,

  	    tyreArray: [],
  	    tyresLoaded: false,
  	    tyresLoading: null,

  	    selectedPosition: "",
  	    selectedTyreObjectId: "",

  	    actionMode: "",
  	    dragSource: null,
  	    tapSource: null,

  	    draftTPositions: null,
  	    draftVehicleObjectId: "",

  	    actionMessage: "",
  	    actionError: false,

  	    modal: null
  	  };

  	  // ===============================================================
  	  // BASIC UTILITIES
  	  // ===============================================================
  	  function escapeHtml(value) {
  	    return String(value == null ? "": value)
  	    .replace(/&/g, "&amp;")
  	    .replace(/</g, "&lt;")
  	    .replace(/>/g, "&gt;")
  	    .replace(/\"/g, "&quot;")
  	    .replace(/'/g, "&#39;");
  	  }

  	  function clean(value) {
  	    return String(value == null ? "": value).trim();
  	  }

  	  function clone(value) {
  	    return JSON.parse(JSON.stringify(value || {}));
  	  }

  	  function arr(value) {
  	    return Array.isArray(value) ? value: [];
  	  }

  	  function isWrapped(value) {
  	    return !!(
  	      value &&
  	      typeof value === "object" &&
  	      !Array.isArray(value) &&
  	      Object.prototype.hasOwnProperty.call(value, "value")
  	    );
  	  }

  	  function unwrap(value) {
  	    return isWrapped(value) ? value.value: value;
  	  }

  	  function getFirst(source, names) {
  	    var i;

  	    if (!source || typeof source !== "object") {
  	      return "";
  	    }

  	    for (i = 0; i < names.length; i++) {
  	      if (
  	        Object.prototype.hasOwnProperty.call(source, names[i]) &&
  	        source[names[i]] !== null &&
  	        source[names[i]] !== undefined
  	      ) {
  	        return source[names[i]];
  	      }
  	    }

  	    return "";
  	  }

  	  function getPath(root, path) {
  	    var ref = root;
  	    var i;

  	    for (i = 0; i < path.length; i++) {
  	      if (!ref || typeof ref !== "object") {
  	        return "";
  	      }

  	      ref = ref[path[i]];
  	    }

  	    return unwrap(ref);
  	  }

  	  function ensureObjectPath(root, path) {
  	    var ref = root;

  	    path.forEach(function (key) {
  	      if (!ref[key] || typeof ref[key] !== "object" || Array.isArray(ref[key])) {
  	        ref[key] = {};
  	      }

  	      ref = ref[key];
  	    });

  	    return ref;
  	  }

  	  function ensureArrayPath(root,
  	    path) {
  	    var parent = ensureObjectPath(root,
  	      path.slice(0, -1));
  	    var key = path[path.length - 1];

  	    if (!Array.isArray(parent[key])) {
  	      parent[key] = [];
  	    }

  	    return parent[key];
  	  }

  	  function parseJson(raw, fallback) {
  	    if (raw === null || raw === undefined || raw === "") {
  	      return clone(fallback);
  	    }

  	    if (typeof raw === "object") {
  	      return clone(raw);
  	    }

  	    try {
  	      return JSON.parse(raw);
  	    } catch (error) {
  	      console.warn("VEH-MAN: JSON parse failed", error, raw);
  	      return clone(fallback);
  	    }
  	  }

  	  function numberOrNull(value) {
  	    var unwrapped = unwrap(value);
  	    var number;

  	    if (unwrapped === null || unwrapped === undefined || unwrapped === "") {
  	      return null;
  	    }

  	    number = Number(unwrapped);

  	    return Number.isFinite(number) ? number: null;
  	  }

  	  function clamp(value, min, max, fallback) {
  	    var number = Number(value);

  	    if (!Number.isFinite(number)) {
  	      number = fallback === undefined ? min: fallback;
  	    }

  	    return Math.max(min, Math.min(max, number));
  	  }

  	  function prettyName(value) {
  	    return String(value || "")
  	    .replace(/_/g, " ")
  	    .replace(/([a-z])([A-Z])/g, "$1 $2")
  	    .trim()
  	    .replace(/\b\w/g, function (char) {
  	      return char.toUpperCase();
  	    });
  	  }

  	  function formatDate(value) {
  	    var text;
  	    var isoMatch;
  	    var parsed;
  	    var year;
  	    var month;
  	    var day;

  	    if (value === null || value === undefined || value === "") {
  	      return "";
  	    }

  	    if (value instanceof Date && !isNaN(value.getTime())) {
  	      year = value.getFullYear();
  	      month = String(value.getMonth() + 1).padStart(2, "0");
  	      day = String(value.getDate()).padStart(2, "0");
  	      return day + "/" + month + "/" + year;
  	    }

  	    text = String(value).trim();

  	    if (!text) {
  	      return "";
  	    }

  	    isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})/);

  	    if (isoMatch) {
  	      return isoMatch[3] + "/" + isoMatch[2] + "/" + isoMatch[1];
  	    }

  	    parsed = new Date(text);

  	    if (!isNaN(parsed.getTime())) {
  	      year = parsed.getFullYear();
  	      month = String(parsed.getMonth() + 1).padStart(2, "0");
  	      day = String(parsed.getDate()).padStart(2, "0");
  	      return day + "/" + month + "/" + year;
  	    }

  	    return text;
  	  }

  	  function displayValue(value) {
  	    value = unwrap(value);

  	    if (value === null || value === undefined || value === "") {
  	      return "Not set";
  	    }

  	    if (typeof value === "boolean") {
  	      return value ? "Yes": "No";
  	    }

  	    if (Array.isArray(value)) {
  	      return value.length ? value.join(", "): "Not set";
  	    }

  	    if (typeof value === "object") {
  	      return JSON.stringify(value);
  	    }

  	    return String(value);
  	  }

  	  function alertSafe(message) {
  	    if (WindowSafe && typeof WindowSafe.alert === "function") {
  	      WindowSafe.alert(message);
  	      return;
  	    }

  	    console.warn(message);
  	  }

  	  function confirmSafe(message) {
  	    if (WindowSafe && typeof WindowSafe.confirm === "function") {
  	      return WindowSafe.confirm(message);
  	    }

  	    return true;
  	  }

  	  function readValue(id) {
  	    var el = DocumentSafe.getElementById(id);

  	    if (!el) {
  	      return "";
  	    }

  	    return clean(el.value);
  	  }

  	  function setMessage(message, isError) {
  	    state.message = message || "";
  	    state.messageError = !!isError;
  	  }

  	  function setActionMessage(message, isError) {
  	    state.actionMessage = message || "";
  	    state.actionError = !!isError;
  	  }

  	  function setButtonBusy(button, busy, normalText) {
  	    if (!button) {
  	      return;
  	    }

  	    button.disabled = !!busy;
  	    button.textContent = busy ? "Saving...": normalText;
  	    button.style.opacity = busy ? "0.65": "1";
  	    button.style.cursor = busy ? "wait": "pointer";
  	  }

  	  function clearInputs(ids) {
  	    ids.forEach(function (id) {
  	      var el = DocumentSafe.getElementById(id);

  	      if (el) {
  	        el.value = "";
  	      }
  	    });
  	  }

  	  function cleanSvgLogoHtml() {
  	    var svg = SvgSafe;
  	    var cleaned;

  	    if (svg && typeof svg === "object") {
  	      svg = svg.value || svg.Value || svg.src || svg.url || "";
  	    }

  	    svg = clean(svg);

  	    if (
  	      svg.length >= 2 &&
  	      (
  	        (svg.charAt(0) === "\"" && svg.charAt(svg.length - 1) === "\"") ||
  	        (svg.charAt(0) === "'" && svg.charAt(svg.length - 1) === "'")
  	      )
  	    ) {
  	      svg = svg.substring(1, svg.length - 1);
  	    }

  	    if (!svg) {
  	      return "";
  	    }

  	    if (/^data:image\//i.test(svg)) {
  	      return "<img class=\"vehman-logo-img\" src=\"" + escapeHtml(svg) + "\" alt=\"Logo\">";
  	    }

  	    if (/^<svg[\s>]/i.test(svg)) {
  	      cleaned = svg
  	      .replace(/<script[\s\S]*?<\/script>/gi, "")
  	      .replace(/<svg(?![^>]*preserveAspectRatio)/i, "<svg preserveAspectRatio=\"xMidYMid meet\"")
  	      .replace(/<svg([^>]*?)>/i, "<svg$1 class=\"vehman-logo-svg\">");

  	      return cleaned;
  	    }

  	    return "";
  	  }

  	  // ===============================================================
  	  // VEHICLE HELPERS
  	  // ===============================================================
  	  function vehicleObjectId(vehicle) {
  	    return clean(getFirst(vehicle, ["objectId", "ObjectId", "OBJECTID", "objectID"]));
  	  }

  	  function vehicleId(vehicle) {
  	    return clean(getFirst(vehicle, ["ID", "Id", "id", "FID", "fid"]));
  	  }

  	  function vehicleMake(vehicle) {
  	    return clean(getPath(vehicle, ["Data", "Vehicle", "Make"]));
  	  }

  	  function vehicleModel(vehicle) {
  	    return clean(getPath(vehicle, ["Data", "Vehicle", "Model"]));
  	  }

  	  function vehicleRegistration(vehicle) {
  	    return clean(getFirst(vehicle, ["Registration", "registration"])) ||
  	    clean(getPath(vehicle, ["Data", "Vehicle", "Registration"]));
  	  }

  	  function vehicleTitle(vehicle) {
  	    var title = clean(vehicleMake(vehicle) + " " + vehicleModel(vehicle));

  	    if (!title) {
  	      title = vehicleId(vehicle) || vehicleObjectId(vehicle) || "Vehicle";
  	    }

  	    if (vehicleRegistration(vehicle)) {
  	      title += " (" + vehicleRegistration(vehicle) + ")";
  	    }

  	    return title;
  	  }

  	  function vehicleOdometer(vehicle) {
  	    var names = [
  	      "Odometer",
  	      "Current_Odometer",
  	      "CurrentOdometer",
  	      "Mileage",
  	      "Current_Mileage",
  	      "Last_Odometer",
  	      "LastOdometer"
  	    ];
  	    var i;
  	    var value;

  	    for (i = 0; i < names.length; i++) {
  	      value = numberOrNull(vehicle && vehicle[names[i]]);

  	      if (value !== null) {
  	        return value;
  	      }
  	    }

  	    if (vehicle && vehicle.Data && vehicle.Data.Vehicle) {
  	      for (i = 0; i < names.length; i++) {
  	        value = numberOrNull(vehicle.Data.Vehicle[names[i]]);

  	        if (value !== null) {
  	          return value;
  	        }
  	      }
  	    }

  	    return 0;
  	  }

  	  // ===============================================================
  	  // TYRE HELPERS
  	  // ===============================================================
  	  function tyreObjectId(tyre) {
  	    return clean(getFirst(tyre, ["objectId", "ObjectId", "objectID", "id"]));
  	  }

  	  function tyreNumber(tyre) {
  	    return clean(getFirst(tyre, [
  	      "ID",
  	      "FID",
  	      "Tyre_Number",
  	      "TyreNumber",
  	      "Tyre_No",
  	      "TyreNo",
  	      "Serial_Number",
  	      "SerialNumber"
  	    ]));
  	  }

  	  function tyreSerial(tyre) {
  	    return clean(getFirst(tyre, ["Serial_Number", "SerialNumber", "Serial"]));
  	  }

  	  function tyreMake(tyre) {
  	    return clean(getFirst(tyre, ["Make", "Brand", "Tyre_Brand", "Manufacturer"]));
  	  }

  	  function tyreModel(tyre) {
  	    return clean(getFirst(tyre, ["Model", "Pattern"]));
  	  }

  	  function tyreSize(tyre) {
  	    return clean(getFirst(tyre, ["Size"]));
  	  }

  	  function tyreType(tyre) {
  	    return clean(getFirst(tyre, ["Type", "Tyre_Type"]));
  	  }

  	  function tyreStage(tyre) {
  	    return clean(getFirst(tyre, ["Current_Stage", "Stage", "State"])) || "New";
  	  }

  	  function tyreStatus(tyre) {
  	    return clean(getFirst(tyre, ["Status", "Current_Status"])) || TYRE_STATUS.OK;
  	  }

  	  function tyreName(tyre) {
  	    if (!tyre) {
  	      return "";
  	    }

  	    return [
  	      tyreNumber(tyre),
  	      tyreSerial(tyre),
  	      tyreMake(tyre),
  	      tyreModel(tyre),
  	      tyreSize(tyre)
  	    ].filter(Boolean).join(" - ") || tyreObjectId(tyre);
  	  }

  	  function parseLifeCycle(tyre) {
  	    if (!tyre || typeof tyre !== "object") {
  	      return null;
  	    }

  	    return parseJson(tyre[LIFE_CYCLE_FIELD], null);
  	  }

  	  function tyreExpectedMileage(tyre) {
  	    var direct = numberOrNull(getFirst(tyre, [
  	      "Expected_Mileage",
  	      "Mileage_Expected",
  	      "ExpectedMileage"
  	    ]));
  	    var lifecycle;
  	    var current;

  	    if (direct !== null) {
  	      return direct;
  	    }

  	    lifecycle = parseLifeCycle(tyre);
  	    current = lifecycle && lifecycle.Current ? lifecycle.Current: {};

  	    return numberOrNull(
  	      current.ExpectedMileage ||
  	      current.MileageExpected ||
  	      current.Mileage_Expected
  	    );
  	  }

  	  function tyreCurrentMileage(tyre) {
  	    var direct = numberOrNull(getFirst(tyre, [
  	      "Current_Mileage",
  	      "Mileage_Current",
  	      "CurrentMileage"
  	    ]));
  	    var lifecycle;
  	    var current;

  	    if (direct !== null) {
  	      return direct;
  	    }

  	    lifecycle = parseLifeCycle(tyre);
  	    current = lifecycle && lifecycle.Current ? lifecycle.Current: {};

  	    return numberOrNull(
  	      current.CurrentMileage ||
  	      current.MileageCurrent ||
  	      current.Mileage_Current
  	    );
  	  }

  	  function tyreLife(tyre) {
  	    var direct = numberOrNull(getFirst(tyre, [
  	      "Current_Life",
  	      "Life_Percentage",
  	      "LifePercentage",
  	      "Life",
  	      "Life_Remaining",
  	      "Remaining_Life"
  	    ]));
  	    var currentMileage;
  	    var expectedMileage;

  	    if (direct !== null) {
  	      return clamp(direct, 0, 100, 0);
  	    }

  	    currentMileage = tyreCurrentMileage(tyre);
  	    expectedMileage = tyreExpectedMileage(tyre);

  	    if (currentMileage !== null && expectedMileage !== null && expectedMileage > 0) {
  	      return clamp(100 - ((currentMileage / expectedMileage) * 100), 0, 100, 0);
  	    }

  	    return null;
  	  }

  	  function tyreColor(tyre) {
  	    var life = tyreLife(tyre);

  	    if (life === null) return "#6b7280";
  	    if (life <= 0) return "#111827";
  	    if (life < 20) return "#ff2b1a";
  	    if (life < 40) return "#ff8a00";
  	    if (life < 60) return "#ffd633";
  	    if (life < 80) return "#a6ff33";

  	    return "#39ff14";
  	  }

  	  function tyreLifeLabel(tyre) {
  	    var life = tyreLife(tyre);

  	    if (life === null) {
  	      return "No life data";
  	    }

  	    return life.toFixed(0) + "% life remaining";
  	  }

  	  function isTyreBlocked(tyre) {
  	    var status = tyreStatus(tyre).toLowerCase();
  	    var holderType = clean(tyre && tyre.Current_Holder_Type).toLowerCase();

  	    return [
  	      "scrapped",
  	      "stolen",
  	      "sold",
  	      "lost",
  	      "in for retread",
  	      "in for retread supplier"
  	    ].indexOf(status) !== -1 ||
  	    [
  	      "scrap yard",
  	      "stolen",
  	      "sold",
  	      "lost",
  	      "retread supplier"
  	    ].indexOf(holderType) !== -1;
  	  }

  	  function isWarehouseTyre(tyre) {
  	    if (!tyre || !tyreObjectId(tyre)) {
  	      return false;
  	    }

  	    if (isTyreBlocked(tyre)) {
  	      return false;
  	    }

  	    if (clean(tyre.Vehicle_ObjectId)) {
  	      return false;
  	    }

  	    if (clean(tyre.Current_Holder_ObjectId) && clean(tyre.Current_Holder_Type).toLowerCase() === "vehicle") {
  	      return false;
  	    }

  	    return true;
  	  }

  	  function addTyreToMap(map, tyre) {
  	    var id = tyreObjectId(tyre);

  	    if (id) {
  	      map[id] = tyre;
  	    }
  	  }

  	  function collectTyres() {
  	    var map = {};

  	    arr(TyresInput).forEach(function (tyre) {
  	      addTyreToMap(map, tyre);
  	    });

  	    arr(state.sourceVehicle && state.sourceVehicle[TYRES_RELATION]).forEach(function (tyre) {
  	      addTyreToMap(map, tyre);
  	    });

  	    try {
  	      arr(App && App.User && App.User.Companies).forEach(function (company) {
  	        arr(company.Tyres).forEach(function (tyre) {
  	          addTyreToMap(map, tyre);
  	        });

  	        arr(company.Tractors).forEach(function (vehicle) {
  	          arr(vehicle.Tyres).forEach(function (tyre) {
  	            addTyreToMap(map, tyre);
  	          });
  	        });

  	        arr(company.Trailers).forEach(function (vehicle) {
  	          arr(vehicle.Tyres).forEach(function (tyre) {
  	            addTyreToMap(map, tyre);
  	          });
  	        });
  	      });
  	    } catch (error) {
  	      console.warn("VEH-MAN: collectTyres failed", error);
  	    }

  	    state.tyreArray = Object.keys(map).map(function (id) {
  	      return map[id];
  	    });

  	    return state.tyreArray;
  	  }

  	  function findTyre(id) {
  	    var cleanId = clean(id);
  	    var i;

  	    if (!cleanId) {
  	      return null;
  	    }

  	    for (i = 0; i < state.tyreArray.length; i++) {
  	      if (tyreObjectId(state.tyreArray[i]) === cleanId) {
  	        return state.tyreArray[i];
  	      }
  	    }

  	    return null;
  	  }

  	  function upsertTyre(tyre) {
  	    var id = tyreObjectId(tyre);
  	    var i;

  	    if (!id) {
  	      return;
  	    }

  	    for (i = 0; i < state.tyreArray.length; i++) {
  	      if (tyreObjectId(state.tyreArray[i]) === id) {
  	        state.tyreArray[i] = tyre;
  	        return;
  	      }
  	    }

  	    state.tyreArray.push(tyre);
  	  }

  	  function loadTyres() {
  	    var query;

  	    collectTyres();

  	    if (state.tyresLoaded) {
  	      return Promise.resolve(state.tyreArray);
  	    }

  	    if (state.tyresLoading) {
  	      return state.tyresLoading;
  	    }

  	    if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	      return Promise.resolve(state.tyreArray);
  	    }

  	    try {
  	      if (BackendlessApi.DataQueryBuilder && BackendlessApi.DataQueryBuilder.create) {
  	        query = BackendlessApi.DataQueryBuilder.create();

  	        if (typeof query.setPageSize === "function") {
  	          query.setPageSize(100);
  	        }
  	      } else {
  	        query = {
  	          pageSize: 100
  	        };
  	      }
  	    } catch (error) {
  	      query = {
  	        pageSize: 100
  	      };
  	    }

  	    state.tyresLoading = BackendlessApi.Data.of(TABLE_TYRES).find(query)
  	    .then(function (rows) {
  	      rows = Array.isArray(rows) ? rows: rows && Array.isArray(rows.data) ? rows.data: [];

  	      rows.forEach(function (tyre) {
  	        upsertTyre(tyre);
  	      });

  	      state.tyresLoaded = true;
  	      state.tyresLoading = null;

  	      return state.tyreArray;
  	    })
  	    .catch(function (error) {
  	      console.warn("VEH-MAN: tyre load failed", error);
  	      state.tyresLoading = null;
  	      return state.tyreArray;
  	    });

  	    return state.tyresLoading;
  	  }

  	  // ===============================================================
  	  // TPOSITIONS ENGINE
  	  // ===============================================================
  	  function emptyTPositions() {
  	    return {
  	      SchemaVersion: SCHEMA_VERSION,
  	      VehicleType: DEFAULT_VEHICLE_TYPE,
  	      Axles: [],
  	      Positions: {},
  	      Summary: {
  	        TotalAxles: 0,
  	        TotalPositions: 0,
  	        AssignedTyres: 0,
  	        EmptyPositions: 0
  	      },
  	      UpdatedAt: "",
  	      UpdatedBy: ""
  	    };
  	  }

  	  function tPositionsFieldName(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") {
  	      return TPOSITIONS_PRIMARY;
  	    }

  	    if (Object.prototype.hasOwnProperty.call(vehicle, TPOSITIONS_PRIMARY)) {
  	      return TPOSITIONS_PRIMARY;
  	    }

  	    if (Object.prototype.hasOwnProperty.call(vehicle, TPOSITIONS_SECONDARY)) {
  	      return TPOSITIONS_SECONDARY;
  	    }

  	    if (vehicle.Data && Object.prototype.hasOwnProperty.call(vehicle.Data, TPOSITIONS_PRIMARY)) {
  	      return TPOSITIONS_PRIMARY;
  	    }

  	    if (vehicle.Data && Object.prototype.hasOwnProperty.call(vehicle.Data, TPOSITIONS_SECONDARY)) {
  	      return TPOSITIONS_SECONDARY;
  	    }

  	    return TPOSITIONS_PRIMARY;
  	  }

  	  function readTPositionsRaw(vehicle) {
  	    if (!vehicle) {
  	      return null;
  	    }

  	    if (vehicle[TPOSITIONS_PRIMARY] !== null && vehicle[TPOSITIONS_PRIMARY] !== undefined) {
  	      return vehicle[TPOSITIONS_PRIMARY];
  	    }

  	    if (vehicle[TPOSITIONS_SECONDARY] !== null && vehicle[TPOSITIONS_SECONDARY] !== undefined) {
  	      return vehicle[TPOSITIONS_SECONDARY];
  	    }

  	    if (vehicle.Data && vehicle.Data[TPOSITIONS_PRIMARY] !== null && vehicle.Data[TPOSITIONS_PRIMARY] !== undefined) {
  	      return unwrap(vehicle.Data[TPOSITIONS_PRIMARY]);
  	    }

  	    if (vehicle.Data && vehicle.Data[TPOSITIONS_SECONDARY] !== null && vehicle.Data[TPOSITIONS_SECONDARY] !== undefined) {
  	      return unwrap(vehicle.Data[TPOSITIONS_SECONDARY]);
  	    }

  	    return null;
  	  }

  	  function normaliseTPositions(raw) {
  	    var base = emptyTPositions();
  	    var parsed = parseJson(raw, base);
  	    var tPositions = {
  	      SchemaVersion: parsed.SchemaVersion || SCHEMA_VERSION,
  	      VehicleType: parsed.VehicleType || DEFAULT_VEHICLE_TYPE,
  	      Axles: Array.isArray(parsed.Axles) ? clone(parsed.Axles): [],
  	      Positions: parsed.Positions && typeof parsed.Positions === "object" ? clone(parsed.Positions): {},
  	      Summary: parsed.Summary && typeof parsed.Summary === "object" ? clone(parsed.Summary): clone(base.Summary),
  	      UpdatedAt: parsed.UpdatedAt || "",
  	      UpdatedBy: parsed.UpdatedBy || ""
  	    };

  	    tPositions.Summary = summaryForTPositions(tPositions);

  	    return tPositions;
  	  }

  	  function summaryForTPositions(tPositions) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    var keys = Object.keys(positions);
  	    var assigned = keys.filter(function (key) {
  	      return !!(positions[key] && positions[key].TyreObjectId);
  	    }).length;

  	    return {
  	      TotalAxles: arr(tPositions && tPositions.Axles).length,
  	      TotalPositions: keys.length,
  	      AssignedTyres: assigned,
  	      EmptyPositions: keys.length - assigned
  	    };
  	  }

  	  function sortedPositionKeys(tPositions) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	    return Object.keys(positions).sort(function (a, b) {
  	      var pa = positions[a] || {};
  	      var pb = positions[b] || {};
  	      var aSpare = String(a).indexOf("SP") === 0;
  	      var bSpare = String(b).indexOf("SP") === 0;
  	      var sideOrder = {
  	        L: 1, R: 2, SP: 3
  	      };
  	      var sideA;
  	      var sideB;

  	      if (aSpare && !bSpare) return 1;
  	      if (!aSpare && bSpare) return -1;

  	      if (Number(pa.Axle || 999) !== Number(pb.Axle || 999)) {
  	        return Number(pa.Axle || 999) - Number(pb.Axle || 999);
  	      }

  	      sideA = sideOrder[pa.SideCode] || 99;
  	      sideB = sideOrder[pb.SideCode] || 99;

  	      if (sideA !== sideB) {
  	        return sideA - sideB;
  	      }

  	      return Number(pa.TyreIndex || 0) - Number(pb.TyreIndex || 0);
  	    });
  	  }

  	  function getSlot(tPositions,
  	    positionKey) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    var key = clean(positionKey);
  	    var keys;
  	    var i;

  	    if (!key) {
  	      return null;
  	    }

  	    if (positions[key]) {
  	      return positions[key];
  	    }

  	    keys = Object.keys(positions);

  	    for (i = 0; i < keys.length; i++) {
  	      if (positions[keys[i]] && clean(positions[keys[i]].PositionKey) === key) {
  	        return positions[keys[i]];
  	      }
  	    }

  	    return null;
  	  }

  	  function getStorageKey(tPositions, positionKey) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    var key = clean(positionKey);
  	    var keys;
  	    var i;

  	    if (positions[key]) {
  	      return key;
  	    }

  	    keys = Object.keys(positions);

  	    for (i = 0; i < keys.length; i++) {
  	      if (positions[keys[i]] && clean(positions[keys[i]].PositionKey) === key) {
  	        return keys[i];
  	      }
  	    }

  	    return "";
  	  }

  	  function fitSlot(slot, tyre) {
  	    if (!slot || !tyre) {
  	      return;
  	    }

  	    slot.TyreObjectId = tyreObjectId(tyre);
  	    slot.TyreNumber = tyreNumber(tyre);
  	    slot.SerialNumber = tyreSerial(tyre);
  	    slot.Status = "Fitted";
  	    slot.UpdatedAt = new Date().toISOString();
  	  }

  	  function clearSlot(slot) {
  	    if (!slot) {
  	      return;
  	    }

  	    slot.TyreObjectId = "";
  	    slot.TyreNumber = "";
  	    slot.SerialNumber = "";
  	    slot.Status = "Empty";
  	    slot.UpdatedAt = new Date().toISOString();
  	  }

  	  function copySlotTyre(fromSlot, toSlot) {
  	    if (!fromSlot || !toSlot) {
  	      return;
  	    }

  	    toSlot.TyreObjectId = fromSlot.TyreObjectId || "";
  	    toSlot.TyreNumber = fromSlot.TyreNumber || "";
  	    toSlot.SerialNumber = fromSlot.SerialNumber || "";
  	    toSlot.Status = toSlot.TyreObjectId ? "Fitted": "Empty";
  	    toSlot.UpdatedAt = new Date().toISOString();
  	  }

  	  function assignedTyreIds(tPositions) {
  	    var ids = [];
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	    Object.keys(positions).forEach(function (key) {
  	      var id = clean(positions[key] && positions[key].TyreObjectId);

  	      if (id && ids.indexOf(id) === -1) {
  	        ids.push(id);
  	      }
  	    });

  	    return ids;
  	  }

  	  function assignedTyreObjects(tPositions) {
  	    return assignedTyreIds(tPositions)
  	    .map(function (id) {
  	      return findTyre(id);
  	    })
  	    .filter(Boolean);
  	  }

  	  function findSlotByTyreId(tPositions,
  	    tyreId) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    var keys = Object.keys(positions);
  	    var cleanId = clean(tyreId);
  	    var i;

  	    if (!cleanId) {
  	      return null;
  	    }

  	    for (i = 0; i < keys.length; i++) {
  	      if (clean(positions[keys[i]] && positions[keys[i]].TyreObjectId) === cleanId) {
  	        return positions[keys[i]];
  	      }
  	    }

  	    return null;
  	  }

  	  function slotsForAxle(tPositions, axleNo, sideCode) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	    return Object.keys(positions)
  	    .map(function (key) {
  	      var slot = clone(positions[key]);
  	      slot.PositionKey = slot.PositionKey || key;
  	      slot.__key = key;
  	      return slot;
  	    })
  	    .filter(function (slot) {
  	      return Number(slot.Axle || 0) === Number(axleNo) &&
  	      String(slot.SideCode || "").toUpperCase() === String(sideCode).toUpperCase();
  	    })
  	    .sort(function (a, b) {
  	      return Number(a.TyreIndex || 0) - Number(b.TyreIndex || 0);
  	    });
  	  }

  	  function spareSlots(tPositions) {
  	    var positions = tPositions && tPositions.Positions ? tPositions.Positions: {};

  	    return Object.keys(positions)
  	    .map(function (key) {
  	      var slot = clone(positions[key]);
  	      slot.PositionKey = slot.PositionKey || key;
  	      slot.__key = key;
  	      return slot;
  	    })
  	    .filter(function (slot) {
  	      return String(slot.SideCode || "").toUpperCase() === "SP" ||
  	      String(slot.PositionKey || "").indexOf("SP") === 0;
  	    });
  	  }

  	  function axlesForTPositions(tPositions) {
  	    var axles = arr(tPositions && tPositions.Axles).map(function (axle) {
  	      return clone(axle);
  	    });
  	    var seen = {};
  	    var positions;
  	    var keys;

  	    if (axles.length) {
  	      return axles.sort(function (a, b) {
  	        return Number(a.Axle || 999) - Number(b.Axle || 999);
  	      });
  	    }

  	    positions = tPositions && tPositions.Positions ? tPositions.Positions: {};
  	    keys = Object.keys(positions);

  	    keys.forEach(function (key) {
  	      var slot = positions[key] || {};
  	      var axleNo = Number(slot.Axle || 0);

  	      if (!axleNo || seen[axleNo]) {
  	        return;
  	      }

  	      seen[axleNo] = true;

  	      axles.push({
  	        Axle: axleNo,
  	        Type: slot.AxleType || "Axle",
  	        TyresPerSide: slot.TyresPerSide || 1,
  	        WearRate: slot.WearRate || 1
  	      });
  	    });

  	    return axles.sort(function (a, b) {
  	      return Number(a.Axle || 999) - Number(b.Axle || 999);
  	    });
  	  }

  	  function cleanTPositionsForSave(tPositions) {
  	    var cleaned = clone(tPositions);

  	    cleaned.SchemaVersion = SCHEMA_VERSION;
  	    cleaned.VehicleType = cleaned.VehicleType || DEFAULT_VEHICLE_TYPE;
  	    cleaned.UpdatedAt = new Date().toISOString();
  	    cleaned.Summary = summaryForTPositions(cleaned);

  	    return cleaned;
  	  }

  	  function writeTPositionsToVehicle(vehicle,
  	    tPositions) {
  	    var field = tPositionsFieldName(vehicle);
  	    var other = field === TPOSITIONS_PRIMARY ? TPOSITIONS_SECONDARY: TPOSITIONS_PRIMARY;
  	    var cleaned = cleanTPositionsForSave(tPositions);

  	    vehicle[field] = cleaned;

  	    if (Object.prototype.hasOwnProperty.call(vehicle, other)) {
  	      vehicle[other] = cleaned;
  	    }

  	    vehicle[TYRES_RELATION] = assignedTyreObjects(cleaned);

  	    return vehicle;
  	  }

  	  function getLiveTPositions() {
  	    return normaliseTPositions(readTPositionsRaw(state.sourceVehicle));
  	  }

  	  function beginDraft() {
  	    state.draftTPositions = normaliseTPositions(readTPositionsRaw(state.sourceVehicle));
  	    state.draftVehicleObjectId = vehicleObjectId(state.sourceVehicle);
  	    return state.draftTPositions;
  	  }

  	  function resetDraft() {
  	    state.draftTPositions = null;
  	    state.draftVehicleObjectId = "";
  	  }

  	  function getDraftTPositions() {
  	    var currentId = vehicleObjectId(state.sourceVehicle);

  	    if (state.draftTPositions && state.draftVehicleObjectId === currentId) {
  	      return state.draftTPositions;
  	    }

  	    return beginDraft();
  	  }

  	  function visualTPositions() {
  	    if (state.actionMode === "Allocate" || state.actionMode === "RotateSwap") {
  	      return getDraftTPositions();
  	    }

  	    return getLiveTPositions();
  	  }

  	  // ===============================================================
  	  // CSS / SHELL
  	  // ===============================================================
  	  function vehicleManagerCss() {
  	    return `
  	    <style>
  	    #individualVehicleManagerRoot,
  	    #individualVehicleManagerRoot * {
  	    box-sizing:border-box;
  	    }

  	    #individualVehicleManagerRoot {
  	    position:fixed;
  	    top:50px;
  	    right:200px;
  	    bottom:0;
  	    left:0;
  	    z-index:999998;
  	    overflow:hidden;
  	    background:rgba(0,0,0,0.38);
  	    font-family:system-ui, Arial, sans-serif;
  	    }

  	    #individualVehicleManagerDialog {
  	    position:absolute;
  	    inset:0;
  	    background:#0b0b0b;
  	    color:#fff;
  	    border:1px solid #292929;
  	    border-top:3px solid #CC6633;
  	    box-shadow:0 18px 60px rgba(0,0,0,0.55);
  	    display:flex;
  	    flex-direction:column;
  	    overflow:hidden;
  	    }

  	    .vehman-head {
  	    flex:0 0 auto;
  	    display:flex;
  	    justify-content:space-between;
  	    align-items:flex-start;
  	    gap:14px;
  	    padding:12px 16px;
  	    background:#121212;
  	    border-bottom:1px solid #2c2c2c;
  	    }

  	    .vehman-title-wrap {
  	    min-width:0;
  	    flex:1 1 auto;
  	    }

  	    .vehman-title {
  	    color:#CC6633;
  	    font-size:20px;
  	    font-weight:950;
  	    line-height:1.2;
  	    white-space:nowrap;
  	    overflow:hidden;
  	    text-overflow:ellipsis;
  	    }

  	    .vehman-subtitle {
  	    color:#aaa;
  	    font-size:12px;
  	    line-height:1.45;
  	    margin-top:4px;
  	    }

  	    .vehman-logo-box {
  	    flex:0 0 auto;
  	    min-width:120px;
  	    display:flex;
  	    justify-content:flex-end;
  	    align-items:flex-start;
  	    }

  	    .vehman-logo-img,
  	    .vehman-logo-svg {
  	    height:42px;
  	    width:auto;
  	    max-width:165px;
  	    object-fit:contain;
  	    display:block;
  	    }

  	    .vehman-close-main {
  	    flex:0 0 auto;
  	    background:#1f1f1f;
  	    color:#bbb;
  	    border:1px solid #3a3a3a;
  	    width:34px;
  	    height:34px;
  	    border-radius:8px;
  	    cursor:pointer;
  	    font-size:20px;
  	    line-height:1;
  	    font-weight:900;
  	    }

  	    .vehman-close-main:hover {
  	    background:#2a2a2a;
  	    color:#fff;
  	    }

  	    .vehman-tabs {
  	    flex:0 0 auto;
  	    display:flex;
  	    gap:6px;
  	    overflow-x:auto;
  	    background:#151515;
  	    border-bottom:1px solid #2c2c2c;
  	    padding:8px 10px;
  	    }

  	    .vehman-tab {
  	    appearance:none;
  	    border:1px solid #343434;
  	    background:#202020;
  	    color:#ccc;
  	    padding:8px 13px;
  	    border-radius:8px;
  	    cursor:pointer;
  	    font-size:13px;
  	    font-weight:850;
  	    white-space:nowrap;
  	    }

  	    .vehman-tab:hover {
  	    background:#2b2b2b;
  	    color:#fff;
  	    }

  	    .vehman-tab-active {
  	    background:#CC6633;
  	    border-color:#CC6633;
  	    color:#111;
  	    }

  	    .vehman-status {
  	    flex:0 0 auto;
  	    min-height:0;
  	    padding:7px 14px;
  	    background:#101010;
  	    border-bottom:1px solid #242424;
  	    color:#aaa;
  	    font-size:12px;
  	    line-height:1.35;
  	    }

  	    .vehman-status-error {
  	    color:#ff4d4f;
  	    }

  	    .vehman-body {
  	    flex:1 1 auto;
  	    min-height:0;
  	    overflow:auto;
  	    padding:12px;
  	    background:#0b0b0b;
  	    }

  	    .vehman-grid-two {
  	    display:grid;
  	    grid-template-columns:minmax(0, 1fr) minmax(340px, 420px);
  	    gap:12px;
  	    align-items:start;
  	    }

  	    .vehman-panel {
  	    border:1px solid #303030;
  	    border-radius:9px;
  	    background:#101010;
  	    overflow:hidden;
  	    margin-bottom:10px;
  	    }

  	    .vehman-panel-head {
  	    display:flex;
  	    justify-content:space-between;
  	    align-items:center;
  	    gap:10px;
  	    padding:9px 12px;
  	    border-bottom:1px solid #303030;
  	    background:#181818;
  	    }

  	    .vehman-panel-title {
  	    color:#CC6633;
  	    font-size:13px;
  	    font-weight:900;
  	    letter-spacing:0.2px;
  	    }

  	    .vehman-panel-subtitle {
  	    color:#888;
  	    font-size:11px;
  	    line-height:1.35;
  	    margin-top:2px;
  	    }

  	    .vehman-panel-body {
  	    padding:0;
  	    }

  	    .vehman-line {
  	    display:grid;
  	    grid-template-columns:190px minmax(0, 1fr);
  	    gap:12px;
  	    align-items:center;
  	    min-height:31px;
  	    padding:7px 11px;
  	    border-bottom:1px solid #252525;
  	    }

  	    .vehman-line-label {
  	    color:#9c9c9c;
  	    font-size:12px;
  	    line-height:1.25;
  	    white-space:nowrap;
  	    overflow:hidden;
  	    text-overflow:ellipsis;
  	    }

  	    .vehman-line-value {
  	    color:#f2f2f2;
  	    font-size:13px;
  	    font-weight:750;
  	    line-height:1.25;
  	    white-space:nowrap;
  	    overflow:hidden;
  	    text-overflow:ellipsis;
  	    }

  	    .vehman-line-empty {
  	    color:#666;
  	    font-weight:500;
  	    }

  	    .vehman-record {
  	    border-bottom:1px solid #333;
  	    background:#101010;
  	    }

  	    .vehman-record:nth-child(even) {
  	    background:#131313;
  	    }

  	    .vehman-record-title {
  	    padding:8px 11px;
  	    color:#CC6633;
  	    font-size:12px;
  	    font-weight:900;
  	    border-bottom:1px solid #252525;
  	    }

  	    .vehman-empty {
  	    padding:12px;
  	    color:#777;
  	    font-size:13px;
  	    line-height:1.45;
  	    }

  	    .vehman-btn {
  	    border:none;
  	    border-radius:8px;
  	    padding:8px 12px;
  	    cursor:pointer;
  	    font-size:12px;
  	    font-weight:900;
  	    white-space:nowrap;
  	    }

  	    .vehman-btn-primary {
  	    background:#CC6633;
  	    color:#111;
  	    }

  	    .vehman-btn-green {
  	    background:#2a8f3a;
  	    color:#fff;
  	    }

  	    .vehman-btn-grey {
  	    background:#555;
  	    color:#fff;
  	    }

  	    .vehman-btn-dark {
  	    background:#374151;
  	    color:#fff;
  	    }

  	    .vehman-btn-red {
  	    background:#7f1d1d;
  	    color:#fff;
  	    }

  	    .vehman-input,
  	    .vehman-select,
  	    .vehman-textarea {
  	    width:100%;
  	    box-sizing:border-box;
  	    border:1px solid #343434;
  	    border-radius:7px;
  	    background:#151515;
  	    color:#fff;
  	    outline:none;
  	    font-size:13px;
  	    }

  	    .vehman-input,
  	    .vehman-select {
  	    height:32px;
  	    padding:5px 8px;
  	    }

  	    .vehman-textarea {
  	    min-height:68px;
  	    padding:8px;
  	    resize:vertical;
  	    }

  	    .vehman-field {
  	    padding:9px 12px;
  	    border-bottom:1px solid #252525;
  	    }

  	    .vehman-label {
  	    display:block;
  	    color:#aaa;
  	    font-size:12px;
  	    margin-bottom:5px;
  	    }

  	    .vehman-capture-grid {
  	    display:grid;
  	    grid-template-columns:220px minmax(0, 1fr);
  	    gap:12px;
  	    align-items:center;
  	    padding:8px 12px;
  	    border-bottom:1px solid #252525;
  	    }

  	    .vehman-capture-grid-start {
  	    align-items:start;
  	    }

  	    .vehman-body::-webkit-scrollbar,
  	    .vehman-tabs::-webkit-scrollbar {
  	    width:10px;
  	    height:10px;
  	    }

  	    .vehman-body::-webkit-scrollbar-thumb,
  	    .vehman-tabs::-webkit-scrollbar-thumb {
  	    background:#333;
  	    border-radius:999px;
  	    }

  	    .vehman-body::-webkit-scrollbar-track,
  	    .vehman-tabs::-webkit-scrollbar-track {
  	    background:#101010;
  	    }

  	    @media (max-width:1100px) {
  	    #individualVehicleManagerRoot {
  	    right:0;
  	    }

  	    .vehman-grid-two {
  	    grid-template-columns:1fr;
  	    }

  	    .vehman-logo-box {
  	    display:none;
  	    }
  	    }
  	    </style>
  	    `;
  	  }

  	  function buildShellHtml() {
  	    var title = vehicleTitle(state.sourceVehicle);
  	    var id = vehicleId(state.sourceVehicle);
  	    var objectId = vehicleObjectId(state.sourceVehicle);
  	    var logo = cleanSvgLogoHtml();

  	    return `
  	    ${vehicleManagerCss()}

  	    <div id="individualVehicleManagerDialog">
  	    <div class="vehman-head">
  	    <div class="vehman-title-wrap">
  	    <div class="vehman-title">${escapeHtml(title)}</div>
  	    <div class="vehman-subtitle">
  	    Vehicle Manager
  	    ${id ? " • ID: " + escapeHtml(id): ""}
  	    ${objectId ? " • objectId: " + escapeHtml(objectId): ""}
  	    </div>
  	    </div>

  	    <div class="vehman-logo-box">
  	    ${logo || ""}
  	    </div>

  	    <button
  	    id="individualVehicleManagerCloseBtn"
  	    type="button"
  	    title="Close"
  	    class="vehman-close-main"
  	    >×</button>
  	    </div>

  	    <div id="individualVehicleManagerTabs" class="vehman-tabs"></div>

  	    <div
  	    id="individualVehicleManagerStatus"
  	    class="vehman-status"
  	    style="display:none;"
  	    ></div>

  	    <div id="individualVehicleManagerBody" class="vehman-body"></div>
  	    </div>
  	    `;
  	  }

  	  function closeManager() {
  	    if (state.root && state.root.parentNode) {
  	      state.root.parentNode.removeChild(state.root);
  	    }

  	    state.root = null;
  	    state.modal = null;
  	  }

  	  function showStatus() {
  	    var statusEl = state.root
  	    ? state.root.querySelector("#individualVehicleManagerStatus"): null;

  	    if (!statusEl) {
  	      return;
  	    }

  	    if (!state.message) {
  	      statusEl.style.display = "none";
  	      statusEl.textContent = "";
  	      statusEl.className = "vehman-status";
  	      return;
  	    }

  	    statusEl.style.display = "block";
  	    statusEl.textContent = state.message;
  	    statusEl.className = state.messageError
  	    ? "vehman-status vehman-status-error": "vehman-status";
  	  }

  	  function renderTabs() {
  	    var tabsEl = state.root
  	    ? state.root.querySelector("#individualVehicleManagerTabs"): null;

  	    if (!tabsEl) {
  	      return;
  	    }

  	    tabsEl.innerHTML = VEHICLE_TABS.map(function (tab) {
  	      var active = state.activeTab === tab.label;

  	      return `
  	      <button
  	      type="button"
  	      class="${active ? "vehman-tab vehman-tab-active": "vehman-tab"}"
  	      data-vehman-tab="${escapeHtml(tab.label)}"
  	      >${escapeHtml(tab.label)}</button>
  	      `;
  	    }).join("");

  	    Array.prototype.forEach.call(tabsEl.querySelectorAll("[data-vehman-tab]"), function (button) {
  	      button.onclick = function () {
  	        state.activeTab = button.getAttribute("data-vehman-tab") || "Vehicle";
  	        renderTabs();
  	        renderActiveTab();
  	      };
  	    });
  	  }

  	  function renderActiveTab() {
  	    var body = state.root
  	    ? state.root.querySelector("#individualVehicleManagerBody"): null;

  	    if (!body) {
  	      return;
  	    }

  	    showStatus();

  	    if (state.activeTab === "Vehicle") {
  	      body.innerHTML = renderVehicleTab();
  	      wireGenericCaptureEvents();
  	      return;
  	    }

  	    if (state.activeTab === "Service") {
  	      body.innerHTML = renderServiceTab();
  	      wireGenericCaptureEvents();
  	      return;
  	    }

  	    if (state.activeTab === "Maintenance") {
  	      body.innerHTML = renderMaintenanceTab();
  	      wireGenericCaptureEvents();
  	      return;
  	    }

  	    if (state.activeTab === "Tyres") {
  	      body.innerHTML = renderTyresTab();
  	      wireTyresTabEvents();

  	      loadTyres().then(function () {
  	        if (state.root && state.activeTab === "Tyres") {
  	          body.innerHTML = renderTyresTab();
  	          wireTyresTabEvents();
  	        }
  	      });

  	      return;
  	    }

  	    if (state.activeTab === "Compliance") {
  	      body.innerHTML = renderComplianceTab();
  	      wireGenericCaptureEvents();
  	      return;
  	    }

  	    body.innerHTML = renderGenericObjectTab(state.activeTab, {});
  	  }

  	  function renderManager() {
  	    closeManager();

  	    state.root = DocumentSafe.createElement("div");
  	    state.root.id = "individualVehicleManagerRoot";
  	    state.root.innerHTML = buildShellHtml();

  	    DocumentSafe.body.appendChild(state.root);

  	    renderTabs();
  	    renderActiveTab();
  	    wireShellEvents();
  	  }

  	  function wireShellEvents() {
  	    var closeBtn = state.root
  	    ? state.root.querySelector("#individualVehicleManagerCloseBtn"): null;

  	    if (closeBtn) {
  	      closeBtn.onclick = function () {
  	        closeManager();
  	      };
  	    }
  	  }

  	  // ===============================================================
  	  // GENERIC UI BUILDERS
  	  // ===============================================================
  	  function lineHtml(label, value) {
  	    var display = displayValue(value);
  	    var empty = display === "Not set";

  	    return `
  	    <div class="vehman-line">
  	    <div class="vehman-line-label">${escapeHtml(label)}</div>
  	    <div
  	    class="${empty ? "vehman-line-value vehman-line-empty": "vehman-line-value"}"
  	    title="${escapeHtml(display)}"
  	    >${escapeHtml(display)}</div>
  	    </div>
  	    `;
  	  }

  	  function panelHtml(title, subtitle, bodyHtml, rightHtml) {
  	    return `
  	    <div class="vehman-panel">
  	    <div class="vehman-panel-head">
  	    <div style="min-width:0;">
  	    <div class="vehman-panel-title">${escapeHtml(title)}</div>
  	    ${subtitle ? `<div class="vehman-panel-subtitle">${escapeHtml(subtitle)}</div>`: ""}
  	    </div>

  	    ${rightHtml || ""}
  	    </div>

  	    <div class="vehman-panel-body">
  	    ${bodyHtml || `<div class="vehman-empty">No data available.</div>`}
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function objectLinesHtml(obj) {
  	    var keys;
  	    var html = "";

  	    if (!obj || typeof obj !== "object") {
  	      return "";
  	    }

  	    keys = Object.keys(obj);

  	    keys.forEach(function (key) {
  	      var value = obj[key];

  	      if (Array.isArray(value)) {
  	        return;
  	      }

  	      if (value && typeof value === "object" && !isWrapped(value)) {
  	        return;
  	      }

  	      html += lineHtml(prettyName(key), unwrap(value));
  	    });

  	    return html;
  	  }

  	  function nestedPanelsHtml(obj) {
  	    var keys;
  	    var html = "";

  	    if (!obj || typeof obj !== "object") {
  	      return "";
  	    }

  	    keys = Object.keys(obj);

  	    keys.forEach(function (key) {
  	      var value = obj[key];
  	      var body;

  	      if (!value || typeof value !== "object" || isWrapped(value) || Array.isArray(value)) {
  	        return;
  	      }

  	      body = objectLinesHtml(value) + nestedPanelsHtml(value);
  	      html += panelHtml(prettyName(key), "", body);
  	    });

  	    return html;
  	  }

  	  function renderGenericObjectTab(title,
  	    obj) {
  	    var body = objectLinesHtml(obj) + nestedPanelsHtml(obj);

  	    return panelHtml(title || "Details",
  	      "Vehicle data",
  	      body);
  	  }

  	  function recordRowsHtml(records,
  	    columns,
  	    emptyText) {
  	    var html = "";

  	    if (!Array.isArray(records) || !records.length) {
  	      return `<div class="vehman-empty">${escapeHtml(emptyText || "No records captured yet.")}</div>`;
  	    }

  	    records.slice().reverse().forEach(function (record, index) {
  	      var originalIndex = records.length - index;
  	      var lines = "";

  	      columns.forEach(function (column) {
  	        var value = record ? record[column.key]: "";

  	        if (column.type === "date") {
  	          value = formatDate(value);
  	        }

  	        lines += lineHtml(column.label, value);
  	      });

  	      html += `
  	      <div class="vehman-record">
  	      <div class="vehman-record-title">Record ${escapeHtml(originalIndex)}</div>
  	      ${lines}
  	      </div>
  	      `;
  	    });

  	    return html;
  	  }

  	  function captureInput(id, label, type, placeholder) {
  	    return `
  	    <div class="vehman-capture-grid">
  	    <label class="vehman-label" for="${escapeHtml(id)}">${escapeHtml(label)}</label>
  	    <input
  	    id="${escapeHtml(id)}"
  	    class="vehman-input"
  	    type="${escapeHtml(type || "text")}"
  	    placeholder="${escapeHtml(placeholder || "")}"
  	    >
  	    </div>
  	    `;
  	  }

  	  function captureTextarea(id, label, placeholder) {
  	    return `
  	    <div class="vehman-capture-grid vehman-capture-grid-start">
  	    <label class="vehman-label" for="${escapeHtml(id)}">${escapeHtml(label)}</label>
  	    <textarea
  	    id="${escapeHtml(id)}"
  	    class="vehman-textarea"
  	    placeholder="${escapeHtml(placeholder || "")}"
  	    ></textarea>
  	    </div>
  	    `;
  	  }

  	  function capturePanelHtml(title, subtitle, fieldsHtml, buttonId, buttonText, buttonClass) {
  	    return panelHtml(
  	      title,
  	      subtitle,
  	      fieldsHtml + `
  	      <div style="display:flex;justify-content:flex-end;gap:8px;padding:10px 12px;">
  	      <button
  	      id="${escapeHtml(buttonId)}"
  	      type="button"
  	      class="vehman-btn ${buttonClass || "vehman-btn-primary"}"
  	      >${escapeHtml(buttonText)}</button>
  	      </div>
  	      `
  	    );
  	  }

  	  // ===============================================================
  	  // RECORD ACCESSORS
  	  // ===============================================================
  	  function getServiceRecords(vehicle) {
  	    var records =
  	    getPath(vehicle, ["Data", "Service", "ServiceRecords"]) ||
  	    getPath(vehicle, ["Data", "Service", "ServiceHistory"]) ||
  	    getPath(vehicle, ["Data", "ServiceRecords"]) ||
  	    [];

  	    return Array.isArray(records) ? records: [];
  	  }

  	  function getMaintenanceRecords(vehicle) {
  	    var records =
  	    getPath(vehicle, ["Data", "Maintenance", "MaintenanceRecords"]) ||
  	    getPath(vehicle, ["Data", "Service", "MaintenanceRecords"]) ||
  	    getPath(vehicle, ["Data", "MaintenanceRecords"]) ||
  	    [];

  	    return Array.isArray(records) ? records: [];
  	  }

  	  function getTyreRecords(vehicle) {
  	    var records =
  	    getPath(vehicle, ["Data", "Tyres", "TyreRecords"]) ||
  	    getPath(vehicle, ["Data", "Service", "TyreRecords"]) ||
  	    getPath(vehicle, ["Data", "TyreRecords"]) ||
  	    [];

  	    return Array.isArray(records) ? records: [];
  	  }

  	  function getComplianceRecords(vehicle) {
  	    var records =
  	    getPath(vehicle, ["Data", "Compliance", "ComplianceRecords"]) ||
  	    getPath(vehicle, ["Data", "ComplianceRecords"]) ||
  	    [];

  	    return Array.isArray(records) ? records: [];
  	  }

  	  // ===============================================================
  	  // NON-TYRE TABS
  	  // ===============================================================
  	  function renderVehicleTab() {
  	    var vehicle = state.sourceVehicle;
  	    var vehicleData = vehicle && vehicle.Data && vehicle.Data.Vehicle ? vehicle.Data.Vehicle: {};
  	    var serviceData = vehicle && vehicle.Data && vehicle.Data.Service ? vehicle.Data.Service: {};
  	    var complianceData = vehicle && vehicle.Data && vehicle.Data.Compliance ? vehicle.Data.Compliance: {};
  	    var financialData = vehicle && vehicle.Data && vehicle.Data.Financials ? vehicle.Data.Financials: {};
  	    var financialTargets = vehicle && vehicle.Data && vehicle.Data.FinancialTargets ? vehicle.Data.FinancialTargets: {};
  	    var operationalTargets = vehicle && vehicle.Data && vehicle.Data.OperationalTargets ? vehicle.Data.OperationalTargets: {};
  	    var tPositions = getLiveTPositions();
  	    var summary = tPositions && tPositions.Summary ? tPositions.Summary: summaryForTPositions(tPositions);
  	    var fittedTyres = assignedTyreIds(tPositions).length;
  	    var vehicleHtml = "";
  	    var statusHtml = "";
  	    var complianceHtml = "";
  	    var serviceHtml = "";
  	    var targetsHtml = "";
  	    var tyreHtml = "";

  	    vehicleHtml += lineHtml("Fleet ID", vehicleId(vehicle));
  	    vehicleHtml += lineHtml("Registration", vehicleRegistration(vehicle));
  	    vehicleHtml += lineHtml("Make", vehicleMake(vehicle));
  	    vehicleHtml += lineHtml("Model", vehicleModel(vehicle));
  	    vehicleHtml += lineHtml("Year", getPath(vehicleData,
  	      ["Year"]));
  	    vehicleHtml += lineHtml("VIN", getPath(vehicleData,
  	      ["VIN"]));
  	    vehicleHtml += lineHtml("Engine Number", getPath(vehicleData,
  	      ["Engine_Number"]));
  	    vehicleHtml += lineHtml("Fuel Type", getPath(vehicleData,
  	      ["Fuel_Type"]));
  	    vehicleHtml += lineHtml("Trailer Configuration", getPath(vehicleData,
  	      ["Trailer_Configuration"]));

  	    statusHtml += lineHtml("Vehicle Status", getPath(vehicleData,
  	      ["Status"]));
  	    statusHtml += lineHtml("Type", vehicle.Type || vehicle.Vehicle_Type || DEFAULT_VEHICLE_TYPE);
  	    statusHtml += lineHtml("Mileage", vehicleOdometer(vehicle) ? vehicleOdometer(vehicle) + " km": "");
  	    statusHtml += lineHtml("Range", vehicle.Range ? vehicle.Range + " km": getPath(vehicleData,
  	      ["Tractor_Range"]));
  	    statusHtml += lineHtml("Tank Capacity", getPath(vehicleData,
  	      ["Tank_Capacity"]));
  	    statusHtml += lineHtml("Payload", getPath(vehicleData,
  	      ["Payload"]));
  	    statusHtml += lineHtml("GVM", getPath(vehicleData,
  	      ["GVM"]));
  	    statusHtml += lineHtml("Tare", getPath(vehicleData,
  	      ["Tare"]));

  	    complianceHtml += lineHtml("Licence Expiry", getPath(complianceData,
  	      ["License_Expiry_Date"]));
  	    complianceHtml += lineHtml("COF Expiry", getPath(complianceData,
  	      ["COF_Expiry"]));
  	    complianceHtml += lineHtml("Roadworthy Status", getPath(complianceData,
  	      ["Roadworthy_Status"]));
  	    complianceHtml += lineHtml("Calibration Expiry", getPath(complianceData,
  	      ["Calibration_Expiry"]));
  	    complianceHtml += lineHtml("Load Test Expiry", getPath(complianceData,
  	      ["Load_Test_Expiry"]));
  	    complianceHtml += lineHtml("Fire Extinguisher Expiry", getPath(complianceData,
  	      ["Fire_Extinguisher_Expiry"]));

  	    serviceHtml += lineHtml("Service Status", getPath(serviceData,
  	      ["Service_Status"]));
  	    serviceHtml += lineHtml("Service Interval", getPath(serviceData,
  	      ["Service_Interval"]));
  	    serviceHtml += lineHtml("Last Service KM", getPath(serviceData,
  	      ["History",
  	        "Last_Service_KM"]));
  	    serviceHtml += lineHtml("Next Service KM", getPath(serviceData,
  	      ["History",
  	        "Next_Service_KM"]));
  	    serviceHtml += lineHtml("Last Service Date", getPath(serviceData,
  	      ["History",
  	        "Last_Service_Date"]));
  	    serviceHtml += lineHtml("Next Service Date", getPath(serviceData,
  	      ["History",
  	        "Next_Service_Date_Estimate"]));

  	    targetsHtml += lineHtml("Monthly Mileage Target", getPath(operationalTargets,
  	      ["Monthly_Mileage_Target"]));
  	    targetsHtml += lineHtml("Monthly Tonnage Target", getPath(operationalTargets,
  	      ["Monthly_Tonnage_Target"]));
  	    targetsHtml += lineHtml("Fuel Counter", getPath(operationalTargets,
  	      ["Fuel_Counter"]));
  	    targetsHtml += lineHtml("Fuel Check Frequency", getPath(operationalTargets,
  	      ["Fuel_Check_Frequency"]));
  	    targetsHtml += lineHtml("Monthly Profit Target", getPath(financialTargets,
  	      ["Monthly_Profit_Target"]));
  	    targetsHtml += lineHtml("Ideal Rate Per KM", getPath(financialTargets,
  	      ["Ideal_Rate_Per_Km"]));

  	    tyreHtml += lineHtml("Total Tyre Positions", summary.TotalPositions || 0);
  	    tyreHtml += lineHtml("Assigned Tyres", summary.AssignedTyres || fittedTyres || 0);
  	    tyreHtml += lineHtml("Empty Positions", summary.EmptyPositions || 0);
  	    tyreHtml += lineHtml("Total Axles", summary.TotalAxles || 0);


  	    return `
  	    <div class="vehman-grid-two">
  	    <div>
  	    ${panelHtml("Vehicle Identity", "Core vehicle profile.", vehicleHtml)}
  	    ${panelHtml("Operational Status", "Current vehicle operating details.", statusHtml)}
  	    ${panelHtml("Tyre Summary", "Current tyre layout summary.", tyreHtml)}
  	    </div>

  	    <div>
  	    ${panelHtml("Compliance Snapshot", "Important legal and inspection dates.", complianceHtml)}
  	    ${panelHtml("Service Snapshot", "Current service position.", serviceHtml)}
  	    ${panelHtml("Targets", "Operational and financial targets.", targetsHtml)}
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function renderServiceTab() {
  	    var records = getServiceRecords(state.sourceVehicle);
  	    var columns = [{
  	      key: "Date", label: "Date", type: "date"
  	    },
  	      {
  	        key: "Odometer", label: "Odometer"
  	      },
  	      {
  	        key: "Type", label: "Service Type"
  	      },
  	      {
  	        key: "Provider", label: "Provider"
  	      },
  	      {
  	        key: "Cost", label: "Cost"
  	      },
  	      {
  	        key: "Notes", label: "Notes"
  	      }];

  	    return `
  	    <div class="vehman-grid-two">
  	    <div>
  	    ${panelHtml(
  	      "Service Records",
  	      "Most recent records appear first.",
  	      recordRowsHtml(records,
  	        columns,
  	        "No service records captured yet.")
  	    )}
  	    </div>

  	    <div>
  	    ${capturePanelHtml(
  	      "New Service Record",
  	      "Add a basic service entry to this vehicle.",
  	      captureInput("vehmanServiceDate",
  	        "Date",
  	        "date",
  	        "") +
  	      captureInput("vehmanServiceOdometer",
  	        "Odometer",
  	        "number",
  	        "km") +
  	      captureInput("vehmanServiceType",
  	        "Service Type",
  	        "text",
  	        "e.g. Minor Service") +
  	      captureInput("vehmanServiceProvider",
  	        "Provider",
  	        "text",
  	        "Workshop / supplier") +
  	      captureInput("vehmanServiceCost",
  	        "Cost",
  	        "number",
  	        "0.00") +
  	      captureTextarea("vehmanServiceNotes",
  	        "Notes",
  	        "Service notes"),
  	      "vehmanSaveServiceBtn",
  	      "Save Service",
  	      "vehman-btn-green"
  	    )}
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function renderMaintenanceTab() {
  	    var records = getMaintenanceRecords(state.sourceVehicle);
  	    var columns = [{
  	      key: "Date", label: "Date", type: "date"
  	    },
  	      {
  	        key: "Odometer", label: "Odometer"
  	      },
  	      {
  	        key: "Type", label: "Maintenance Type"
  	      },
  	      {
  	        key: "Provider", label: "Provider"
  	      },
  	      {
  	        key: "Cost", label: "Cost"
  	      },
  	      {
  	        key: "Notes", label: "Notes"
  	      }];

  	    return `
  	    <div class="vehman-grid-two">
  	    <div>
  	    ${panelHtml(
  	      "Maintenance Records",
  	      "Most recent records appear first.",
  	      recordRowsHtml(records,
  	        columns,
  	        "No maintenance records captured yet.")
  	    )}
  	    </div>

  	    <div>
  	    ${capturePanelHtml(
  	      "New Maintenance Record",
  	      "Add a maintenance entry to this vehicle.",
  	      captureInput("vehmanMaintenanceDate",
  	        "Date",
  	        "date",
  	        "") +
  	      captureInput("vehmanMaintenanceOdometer",
  	        "Odometer",
  	        "number",
  	        "km") +
  	      captureInput("vehmanMaintenanceType",
  	        "Maintenance Type",
  	        "text",
  	        "e.g. Brake repair") +
  	      captureInput("vehmanMaintenanceProvider",
  	        "Provider",
  	        "text",
  	        "Workshop / supplier") +
  	      captureInput("vehmanMaintenanceCost",
  	        "Cost",
  	        "number",
  	        "0.00") +
  	      captureTextarea("vehmanMaintenanceNotes",
  	        "Notes",
  	        "Maintenance notes"),
  	      "vehmanSaveMaintenanceBtn",
  	      "Save Maintenance",
  	      "vehman-btn-green"
  	    )}
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function renderComplianceTab() {
  	    var complianceData = state.sourceVehicle &&
  	    state.sourceVehicle.Data &&
  	    state.sourceVehicle.Data.Compliance
  	    ? state.sourceVehicle.Data.Compliance: {};

  	    var records = getComplianceRecords(state.sourceVehicle);
  	    var columns = [{
  	      key: "Date", label: "Date", type: "date"
  	    },
  	      {
  	        key: "Type", label: "Compliance Type"
  	      },
  	      {
  	        key: "ExpiryDate", label: "Expiry Date", type: "date"
  	      },
  	      {
  	        key: "Reference", label: "Reference"
  	      },
  	      {
  	        key: "Notes", label: "Notes"
  	      }];

  	    return `
  	    <div class="vehman-grid-two">
  	    <div>
  	    ${panelHtml(
  	      "Compliance Details",
  	      "Current compliance fields.",
  	      objectLinesHtml(complianceData) + nestedPanelsHtml(complianceData)
  	    )}

  	    ${panelHtml(
  	      "Compliance Records",
  	      "Most recent records appear first.",
  	      recordRowsHtml(records,
  	        columns,
  	        "No compliance records captured yet.")
  	    )}
  	    </div>

  	    <div>
  	    ${capturePanelHtml(
  	      "New Compliance Record",
  	      "Add a licence, permit, roadworthy, inspection, or insurance entry.",
  	      captureInput("vehmanComplianceDate",
  	        "Date",
  	        "date",
  	        "") +
  	      captureInput("vehmanComplianceType",
  	        "Compliance Type",
  	        "text",
  	        "e.g. Roadworthy") +
  	      captureInput("vehmanComplianceExpiry",
  	        "Expiry Date",
  	        "date",
  	        "") +
  	      captureInput("vehmanComplianceReference",
  	        "Reference",
  	        "text",
  	        "Document / policy number") +
  	      captureTextarea("vehmanComplianceNotes",
  	        "Notes",
  	        "Compliance notes"),
  	      "vehmanSaveComplianceBtn",
  	      "Save Compliance",
  	      "vehman-btn-green"
  	    )}
  	    </div>
  	    </div>
  	    `;
  	  }


  	  // ===============================================================
  	  // TYRE TAB VISUALS
  	  // ===============================================================
  	  function tyreLegendHtml() {
  	    var items = [{
  	      label: "80–100%", color: "#39ff14"
  	    },
  	      {
  	        label: "60–79%", color: "#a6ff33"
  	      },
  	      {
  	        label: "40–59%", color: "#ffd633"
  	      },
  	      {
  	        label: "20–39%", color: "#ff8a00"
  	      },
  	      {
  	        label: "1–19%", color: "#ff2b1a"
  	      },
  	      {
  	        label: "0%", color: "#111827"
  	      },
  	      {
  	        label: "No data", color: "#6b7280"
  	      }];

  	    return `
  	    <div style="display:flex;flex-wrap:wrap;gap:8px;margin:0 0 10px;">
  	    ${items.map(function (item) {
  	      return `
  	      <div style="display:flex;align-items:center;gap:5px;color:#aaa;font-size:11px;">
  	      <div style="
  	      width:22px;
  	      height:12px;
  	      border-radius:3px;
  	      background:${escapeHtml(item.color)};
  	      border:1px solid rgba(0,0,0,0.8);
  	      "></div>
  	      ${escapeHtml(item.label)}
  	      </div>
  	      `;
  	    }).join("")}
  	    </div>
  	    `;
  	  }

  	  function tyreTreadGlyphHtml(color, selected) {
  	    return `
  	    <div style="
  	    width:100%;
  	    height:34px;
  	    border-radius:5px;
  	    background:${escapeHtml(color)};
  	    border:${selected ? "2px solid #ffffff": "1px solid rgba(0,0,0,0.85)"};
  	    box-shadow:
  	    inset 0 0 0 1px rgba(255,255,255,0.18),
  	    0 1px 2px rgba(0,0,0,0.45);
  	    background-image:
  	    repeating-linear-gradient(
  	    135deg,
  	    rgba(0,0,0,0.72) 0px,
  	    rgba(0,0,0,0.72) 3px,
  	    transparent 3px,
  	    transparent 7px
  	    ),
  	    repeating-linear-gradient(
  	    45deg,
  	    rgba(0,0,0,0.55) 0px,
  	    rgba(0,0,0,0.55) 2px,
  	    transparent 2px,
  	    transparent 6px
  	    );
  	    "></div>
  	    `;
  	  }

  	  function slotHtml(slot) {
  	    var positionKey = clean(slot && (slot.PositionKey || slot.__key));
  	    var tyreId = clean(slot && slot.TyreObjectId);
  	    var tyre = findTyre(tyreId);
  	    var selected = state.selectedPosition === positionKey;
  	    var hasTyre = !!tyreId;
  	    var color = tyre ? tyreColor(tyre): hasTyre ? "#6b7280": "#263044";
  	    var label = tyre ? tyreName(tyre): hasTyre ? (slot.TyreNumber || slot.SerialNumber || tyreId): "Empty";
  	    var life = tyre ? tyreLifeLabel(tyre): hasTyre ? "Tyre record not loaded": "No tyre fitted";
  	    var draggable = hasTyre && (state.actionMode === "RotateSwap" || state.actionMode === "Allocate");

  	    return `
  	    <div
  	    class="vehman-tyre-slot"
  	    draggable="${draggable ? "true": "false"}"
  	    data-position-key="${escapeHtml(positionKey)}"
  	    data-tyre-object-id="${escapeHtml(tyreId)}"
  	    title="${escapeHtml(positionKey + " • " + label + " • " + life)}"
  	    style="
  	    cursor:${state.actionMode ? "pointer": "default"};
  	    padding:4px;
  	    border-radius:7px;
  	    background:${selected ? "rgba(255,255,255,0.14)": "transparent"};
  	    outline:${state.tapSource && state.tapSource.SourcePosition === positionKey ? "2px solid #CC6633": "none"};
  	    "
  	    >
  	    ${tyreTreadGlyphHtml(color, selected)}

  	    <div style="
  	    margin-top:3px;
  	    color:#9ca3af;
  	    font-size:10px;
  	    white-space:nowrap;
  	    overflow:hidden;
  	    text-overflow:ellipsis;
  	    text-align:center;
  	    ">${escapeHtml(positionKey)}</div>
  	    </div>
  	    `;
  	  }

  	  function spareSlotHtml(slot) {
  	    var positionKey = clean(slot && (slot.PositionKey || slot.__key || "Spare"));
  	    var tyreId = clean(slot && slot.TyreObjectId);
  	    var tyre = findTyre(tyreId);
  	    var color = tyre ? tyreColor(tyre): tyreId ? "#6b7280": "#263044";

  	    return `
  	    <div style="
  	    border:1px solid #3b3b3b;
  	    background:#1f2937;
  	    border-radius:9px;
  	    padding:9px;
  	    min-width:180px;
  	    ">
  	    <div style="color:#CC6633;font-size:12px;font-weight:900;margin-bottom:7px;">
  	    ${escapeHtml(positionKey)}
  	    </div>

  	    ${slotHtml(slot)}

  	    <div style="
  	    margin-top:7px;
  	    color:#cbd5e1;
  	    font-size:11px;
  	    white-space:nowrap;
  	    overflow:hidden;
  	    text-overflow:ellipsis;
  	    ">
  	    ${escapeHtml(tyre ? tyreName(tyre): tyreId ? tyreId: "No tyre assigned")}
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function axleHtml(tPositions, axle) {
  	    var axleNo = Number(axle.Axle || 0);
  	    var axleType = axle.Type || "Axle";
  	    var leftSlots = slotsForAxle(tPositions, axleNo, "L");
  	    var rightSlots = slotsForAxle(tPositions, axleNo, "R");

  	    return `
  	    <div style="
  	    width:178px;
  	    min-height:370px;
  	    background:#253044;
  	    border-left:6px solid #6b7280;
  	    border-right:6px solid #6b7280;
  	    position:relative;
  	    box-shadow:0 0 0 1px rgba(255,255,255,0.04);
  	    display:flex;
  	    flex-direction:column;
  	    justify-content:space-between;
  	    padding:10px 8px;
  	    ">
  	    <div style="
  	    position:absolute;
  	    top:8px;
  	    left:8px;
  	    right:8px;
  	    display:flex;
  	    gap:5px;
  	    flex-direction:column;
  	    ">
  	    ${
  	    leftSlots.length
  	    ? leftSlots.map(slotHtml).join(""): `<div style="height:38px;color:#64748b;font-size:11px;text-align:center;">No left tyres</div>`
  	    }
  	    </div>

  	    <div style="
  	    position:absolute;
  	    top:50%;
  	    left:0;
  	    right:0;
  	    transform:translateY(-50%);
  	    text-align:center;
  	    color:#cbd5e1;
  	    font-size:12px;
  	    font-weight:900;
  	    opacity:0.8;
  	    ">
  	    A${escapeHtml(axleNo)}<br>
  	    <span style="font-size:10px;font-weight:700;">${escapeHtml(axleType)}</span>
  	    ${
  	    axleType === "Tag"
  	    ? `<br><span style="font-size:10px;color:#facc15;">Wear ${escapeHtml(axle.WearRate || 0)}</span>`: ""
  	    }
  	    </div>

  	    <div style="
  	    position:absolute;
  	    bottom:8px;
  	    left:8px;
  	    right:8px;
  	    display:flex;
  	    gap:5px;
  	    flex-direction:column;
  	    ">
  	    ${
  	    rightSlots.length
  	    ? rightSlots.map(slotHtml).join(""): `<div style="height:38px;color:#64748b;font-size:11px;text-align:center;">No right tyres</div>`
  	    }
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function tyreLayoutHtml(tPositions) {
  	    var axles = axlesForTPositions(tPositions).filter(function (axle) {
  	      return String(axle && axle.Type || "").toLowerCase() !== "spare";
  	    });

  	    var spares = spareSlots(tPositions);

  	    if (!axles.length && !spares.length) {
  	      return panelHtml(
  	        "Visual Tyre Layout",
  	        "No layout found.",
  	        `<div class="vehman-empty">No TPositions / TyrePositions layout was found for this vehicle.</div>`
  	      );
  	    }

  	    return panelHtml(
  	      "Visual Tyre Layout",
  	      state.actionMode
  	      ? "Tap or drag tyres according to the active action mode.": "Select an action above to allocate, remove, rotate, or swap tyres.",
  	      `
  	      <div style="padding:12px;">
  	      ${tyreLegendHtml()}

  	      <div style="
  	      display:flex;
  	      gap:14px;
  	      align-items:flex-start;
  	      justify-content:flex-start;
  	      overflow-x:auto;
  	      padding:0 0 10px;
  	      max-width:100%;
  	      ">
  	      ${
  	      axles.length
  	      ? axles.map(function (axle) {
  	        return `
  	        <div style="flex:0 0 auto;">
  	        ${axleHtml(tPositions, axle)}
  	        </div>
  	        `;
  	      }).join(""): `<div class="vehman-empty">No main axles found.</div>`
  	      }
  	      </div>

  	      ${
  	      spares.length
  	      ? `
  	      <div style="
  	      margin-top:12px;
  	      border-top:1px solid #303030;
  	      padding-top:10px;
  	      ">
  	      <div style="
  	      color:#CC6633;
  	      font-size:12px;
  	      font-weight:900;
  	      margin-bottom:8px;
  	      ">Spare Positions</div>

  	      <div style="
  	      display:flex;
  	      gap:10px;
  	      flex-wrap:wrap;
  	      align-items:flex-start;
  	      ">
  	      ${spares.map(spareSlotHtml).join("")}
  	      </div>
  	      </div>
  	      `: ""
  	      }
  	      </div>
  	      `
  	    );
  	  }

  	  function selectedTyreDetailsHtml(tPositions) {
  	    var slot = getSlot(tPositions, state.selectedPosition);
  	    var tyre = slot && slot.TyreObjectId ? findTyre(slot.TyreObjectId): null;
  	    var tyreLabel = "";
  	    var wear = null;
  	    var color = "#6b7280";

  	    if (!slot) {
  	      return panelHtml(
  	        "Selected Position",
  	        "No position selected.",
  	        `<div class="vehman-empty">Select a tyre position to see details.</div>`
  	      );
  	    }

  	    tyreLabel = tyre
  	    ? tyreName(tyre): slot.TyreObjectId
  	    ? (slot.TyreNumber || slot.SerialNumber || slot.TyreObjectId): "No tyre assigned";

  	    wear = tyre ? tyreLife(tyre): null;
  	    color = tyre ? tyreColor(tyre): slot.TyreObjectId ? "#6b7280": "#263044";

  	    return panelHtml(
  	      "Selected Position",
  	      "Position and fitted tyre details.",
  	      `
  	      <div style="padding:12px 12px 4px;">
  	      ${tyreTreadGlyphHtml(color, true)}
  	      </div>

  	      ${lineHtml("Position", state.selectedPosition || "Not set")}
  	      ${lineHtml("Tyre", tyreLabel)}
  	      ${lineHtml("Tyre ID", tyre ? tyreNumber(tyre): slot.TyreObjectId)}
  	      ${lineHtml("Serial", tyre ? tyreSerial(tyre): slot.SerialNumber)}
  	      ${lineHtml("Make", tyre ? tyreMake(tyre): "")}
  	      ${lineHtml("Model", tyre ? tyreModel(tyre): "")}
  	      ${lineHtml("Size", tyre ? tyreSize(tyre): "")}
  	      ${lineHtml("Type", tyre ? tyreType(tyre): "")}
  	      ${lineHtml("Stage", tyre ? tyreStage(tyre): "")}
  	      ${lineHtml("Status", tyre ? tyreStatus(tyre): slot.Status)}
  	      ${lineHtml("Expected Mileage", tyre && tyreExpectedMileage(tyre) !== null ? tyreExpectedMileage(tyre) + " km": "")}
  	      ${lineHtml("Current Mileage", tyre && tyreCurrentMileage(tyre) !== null ? tyreCurrentMileage(tyre) + " km": "")}
  	      ${lineHtml("Life Remaining", wear !== null ? wear.toFixed(2) + " %": "")}
  	      `
  	    );
  	  }

  	  function tyreHistoryEvents(tyre) {
  	    var history = tyre && tyre.History ? tyre.History: {};
  	    var lifeCycle = tyre && tyre.LifeCycle ? tyre.LifeCycle: {};
  	    var events = [];

  	    ["New",
  	      "Cap1",
  	      "Cap2",
  	      "Cap3"].forEach(function (stageName) {
  	        var stage = history && history[stageName] ? history[stageName]: null;

  	        arr(stage && stage.Events).forEach(function (event) {
  	          var copy = clone(event);

  	          copy.__stage = stageName;
  	          events.push(copy);
  	        });
  	      });

  	    arr(lifeCycle && lifeCycle.Events).forEach(function (event) {
  	      var exists = events.some(function (existing) {
  	        return String(existing.Date || "") === String(event.Date || "") &&
  	        String(existing.Type || "") === String(event.Type || "") &&
  	        String(existing.FromPosition || "") === String(event.FromPosition || "") &&
  	        String(existing.ToPosition || "") === String(event.ToPosition || "");
  	      });

  	      if (!exists) {
  	        events.push(clone(event));
  	      }
  	    });

  	    return events.sort(function (a, b) {
  	      return new Date(b.Date || 0).getTime() - new Date(a.Date || 0).getTime();
  	    });
  	  }

  	  function tyreHistoryRowsHtml(tyre) {
  	    var events = tyreHistoryEvents(tyre);

  	    if (!events.length) {
  	      return `<div class="vehman-empty">No tyre history found.</div>`;
  	    }

  	    return events.map(function (event) {
  	      return `
  	      <div class="vehman-record">
  	      <div class="vehman-record-title">
  	      ${escapeHtml(event.Type || "Event")}${event.__stage ? " • " + escapeHtml(event.__stage): ""}
  	      </div>

  	      ${lineHtml("Date", formatDate(event.Date))}
  	      ${lineHtml("From", event.FromPosition || "")}
  	      ${lineHtml("To", event.ToPosition || event.Destination || "")}
  	      ${lineHtml("Odometer", event.Odometer || "")}
  	      ${lineHtml("Wear Rate", event.WearRate || "")}
  	      ${lineHtml("Captured By", event.CapturedBy || "")}
  	      ${lineHtml("Notes", event.Notes || "")}
  	      </div>
  	      `;
  	    }).join("");
  	  }

  	  function renderTyreDetailsPopup(tyre, slot) {
  	    var positionKey = clean(slot && (slot.PositionKey || slot.__key));
  	    var html;
  	    var popup;

  	    if (!tyre) {
  	      return;
  	    }

  	    closeFloatingPopup("vehmanTyreDetailsPopup");

  	    html = `
  	    <div style="display:grid;grid-template-columns:minmax(300px,390px) minmax(420px,1fr);gap:12px;align-items:start;">
  	    <div>
  	    ${panelHtml(
  	      "Tyre Details",
  	      "Current tyre and fitment information.",
  	      `
  	      <div style="padding:12px 12px 4px;">
  	      ${tyreTreadGlyphHtml(tyreColor(tyre), true)}
  	      </div>

  	      ${lineHtml("Position", positionKey || tyre.Current_Position || "")}
  	      ${lineHtml("Tyre ID", tyreNumber(tyre))}
  	      ${lineHtml("Serial", tyreSerial(tyre))}
  	      ${lineHtml("Make", tyreMake(tyre))}
  	      ${lineHtml("Model", tyreModel(tyre))}
  	      ${lineHtml("Size", tyreSize(tyre))}
  	      ${lineHtml("Type", tyreType(tyre))}
  	      ${lineHtml("Stage", tyreStage(tyre))}
  	      ${lineHtml("Status", tyreStatus(tyre))}
  	      ${lineHtml("Expected Mileage", tyreExpectedMileage(tyre) !== null ? tyreExpectedMileage(tyre) + " km": "")}
  	      ${lineHtml("Current Mileage", tyreCurrentMileage(tyre) !== null ? tyreCurrentMileage(tyre) + " km": "")}
  	      ${lineHtml("Remaining Life", tyreLife(tyre) !== null ? tyreLife(tyre).toFixed(2) + " %": "")}
  	      ${lineHtml("Fitted Odometer", tyre.Fitted_Odometer || "")}
  	      ${lineHtml("Last Vehicle Odometer", tyre.Last_Vehicle_Odometer || "")}
  	      `
  	    )}
  	    </div>

  	    <div>
  	    ${panelHtml(
  	      "Tyre History",
  	      "Most recent events appear first.",
  	      tyreHistoryRowsHtml(tyre)
  	    )}
  	    </div>
  	    </div>
  	    `;

  	    DocumentSafe.body.insertAdjacentHTML(
  	      "beforeend",
  	      floatingPopupShellHtml("vehmanTyreDetailsPopup", "Tyre Details & History", html, "980px")
  	    );

  	    popup = DocumentSafe.getElementById("vehmanTyreDetailsPopup");

  	    if (popup) {
  	      Array.prototype.forEach.call(popup.querySelectorAll("[data-popup-close=\"vehmanTyreDetailsPopup\"]"), function (button) {
  	        button.onclick = function () {
  	          closeFloatingPopup("vehmanTyreDetailsPopup");
  	        };
  	      });
  	    }
  	  }

  	  function actionBarHtml() {
  	    var count = plannedMovementRows().length;

  	    if (state.actionMode === "Allocate") {
  	      return `
  	      <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px;align-items:center;">
  	      <button id="vehmanCompleteAllocationBtn" type="button" class="vehman-btn vehman-btn-green">
  	      Complete Allocation${count ? " (" + escapeHtml(count) + ")": ""}
  	      </button>
  	      <button id="vehmanCancelAllocationBtn" type="button" class="vehman-btn vehman-btn-grey">
  	      Cancel Allocation
  	      </button>
  	      <div style="color:#aaa;font-size:12px;margin-left:auto;">
  	      Select a warehouse tyre, then click a vehicle position.
  	      </div>
  	      </div>
  	      `;
  	    }

  	    if (state.actionMode === "RotateSwap") {
  	      return `
  	      <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px;align-items:center;">
  	      <button id="vehmanCompleteRotationBtn" type="button" class="vehman-btn vehman-btn-green">
  	      Complete Rotation${count ? " (" + escapeHtml(count) + ")": ""}
  	      </button>
  	      <button id="vehmanCancelRotationBtn" type="button" class="vehman-btn vehman-btn-grey">
  	      Cancel Rotation
  	      </button>
  	      <div style="color:#aaa;font-size:12px;margin-left:auto;">
  	      Select a fitted tyre, then select its target position.
  	      </div>
  	      </div>
  	      `;
  	    }

  	    if (state.actionMode === "Remove") {
  	      return `
  	      <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px;align-items:center;">
  	      <button id="vehmanCancelRemoveBtn" type="button" class="vehman-btn vehman-btn-grey">
  	      Cancel Remove
  	      </button>
  	      <div style="color:#aaa;font-size:12px;margin-left:auto;">
  	      Click a fitted tyre position to remove it.
  	      </div>
  	      </div>
  	      `;
  	    }

  	    return `
  	    <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px;align-items:center;">
  	    <button id="vehmanStartAllocateBtn" type="button" class="vehman-btn vehman-btn-green">Allocate</button>
  	    <button id="vehmanStartRotateBtn" type="button" class="vehman-btn vehman-btn-primary">Rotate / Swap</button>
  	    <button id="vehmanStartRemoveBtn" type="button" class="vehman-btn vehman-btn-red">Remove</button>
  	    <div style="color:#aaa;font-size:12px;margin-left:auto;">
  	    Vehicle-only tyre manager
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function actionStatusHtml() {
  	    if (!state.actionMessage) {
  	      return "";
  	    }

  	    return `
  	    <div style="
  	    margin-bottom:10px;
  	    border:1px solid ${state.actionError ? "#7f1d1d": "#333"};
  	    background:${state.actionError ? "#221010": "#101010"};
  	    color:${state.actionError ? "#ff4d4f": "#aaa"};
  	    border-radius:8px;
  	    padding:9px 12px;
  	    font-size:12px;
  	    line-height:1.4;
  	    ">
  	    ${escapeHtml(state.actionMessage)}
  	    </div>
  	    `;
  	  }

  	  function availableWarehouseTyres(tPositions) {
  	    var assignedHere = assignedTyreIds(tPositions);
  	    var currentVehicleObjectId = vehicleObjectId(state.sourceVehicle);

  	    return state.tyreArray.filter(function (tyre) {
  	      var id = tyreObjectId(tyre);

  	      if (!id) {
  	        return false;
  	      }

  	      if (assignedHere.indexOf(id) !== -1) {
  	        return false;
  	      }

  	      if (!isWarehouseTyre(tyre)) {
  	        return false;
  	      }

  	      if (findExistingFleetAssignment(id, currentVehicleObjectId)) {
  	        return false;
  	      }

  	      return true;
  	    });
  	  }

  	  function warehouseTyreCardHtml(tyre) {
  	    var id = tyreObjectId(tyre);
  	    var selected = state.tapSource &&
  	    state.tapSource.SourceType === "warehouse" &&
  	    state.tapSource.TyreObjectId === id;

  	    return `
  	    <div
  	    class="vehman-warehouse-tyre"
  	    draggable="true"
  	    data-warehouse-tyre-id="${escapeHtml(id)}"
  	    style="
  	    border:1px solid ${selected ? "#CC6633": "#303030"};
  	    background:${selected ? "#20150f": "#101010"};
  	    border-radius:8px;
  	    padding:9px;
  	    cursor:pointer;
  	    margin-bottom:8px;
  	    "
  	    title="${escapeHtml(tyreName(tyre))}"
  	    >
  	    <div style="display:grid;grid-template-columns:52px minmax(0, 1fr);gap:9px;align-items:center;">
  	    <div>
  	    ${tyreTreadGlyphHtml(tyreColor(tyre),
  	      selected)}
  	    </div>

  	    <div style="min-width:0;">
  	    <div style="
  	    color:#f2f2f2;
  	    font-size:12px;
  	    font-weight:900;
  	    white-space:nowrap;
  	    overflow:hidden;
  	    text-overflow:ellipsis;
  	    ">
  	    ${escapeHtml(tyreName(tyre))}
  	    </div>

  	    <div style="color:#888;font-size:11px;margin-top:3px;">
  	    ${escapeHtml(tyreType(tyre) || "No type")} • ${escapeHtml(tyreLifeLabel(tyre))}
  	    </div>
  	    </div>
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function warehousePanelHtml(tPositions) {
  	    var available = availableWarehouseTyres(tPositions);

  	    if (state.actionMode !== "Allocate") {
  	      return "";
  	    }

  	    return panelHtml(
  	      "Warehouse Tyres",
  	      "Available tyres not currently fitted to this vehicle or another vehicle.",
  	      available.length
  	      ? `<div style="padding:10px;max-height:360px;overflow:auto;">${available.map(warehouseTyreCardHtml).join("")}</div>`: `<div class="vehman-empty">No available warehouse tyres found.</div>`
  	    );
  	  }

  	  function renderTyresTab() {
  	    var tPositions = visualTPositions();

  	    if (!state.selectedPosition) {
  	      var keys = sortedPositionKeys(tPositions);

  	      if (keys.length) {
  	        state.selectedPosition = clean(tPositions.Positions[keys[0]].PositionKey || keys[0]);
  	      }
  	    }

  	    return `
  	    ${actionBarHtml()}
  	    ${actionStatusHtml()}

  	    <div class="vehman-grid-two">
  	    <div>
  	    ${tyreLayoutHtml(tPositions)}
  	    </div>

  	    <div>
  	    ${selectedTyreDetailsHtml(tPositions)}
  	    ${warehousePanelHtml(tPositions)}
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function tyreRecordPanelHtml() {
  	    var records = getTyreRecords(state.sourceVehicle);
  	    var columns = [{
  	      key: "date",
  	      label: "Date",
  	      type: "date"
  	    },
  	      {
  	        key: "type",
  	        label: "Type"
  	      },
  	      {
  	        key: "fromPosition",
  	        label: "From"
  	      },
  	      {
  	        key: "toPosition",
  	        label: "To"
  	      },
  	      {
  	        key: "tyre",
  	        label: "Tyre"
  	      },
  	      {
  	        key: "odometer",
  	        label: "Odometer"
  	      },
  	      {
  	        key: "notes",
  	        label: "Notes"
  	      }];

  	    return panelHtml(
  	      "Vehicle Tyre Records",
  	      "Records stored on this vehicle.",
  	      recordRowsHtml(records, columns, "No tyre movement records captured yet.")
  	    );
  	  }

  	  // ===============================================================
  	  // DRAFT / ACTION ENGINE
  	  // ===============================================================
  	  function startTyreAction(mode) {
  	    state.actionMode = mode;
  	    state.tapSource = null;
  	    state.dragSource = null;
  	    state.actionError = false;
  	    state.selectedTyreObjectId = "";

  	    beginDraft();

  	    if (mode === "Allocate") {
  	      state.actionMessage = "Allocation mode active. Select a warehouse tyre, then click a target vehicle position.";
  	    } else if (mode === "RotateSwap") {
  	      state.actionMessage = "Rotation mode active. Select a fitted tyre, then click its target position.";
  	    } else if (mode === "Remove") {
  	      state.actionMessage = "Remove mode active. Click a fitted tyre position to remove it.";
  	    } else {
  	      state.actionMessage = "";
  	    }

  	    rerenderTyresTabOnly();
  	  }

  	  function cancelTyreAction(message) {
  	    state.actionMode = "";
  	    state.tapSource = null;
  	    state.dragSource = null;
  	    state.selectedTyreObjectId = "";
  	    resetDraft();

  	    state.actionMessage = message || "Tyre action cancelled.";
  	    state.actionError = false;

  	    closeFloatingPopup("vehmanAllocationPopup");
  	    closeFloatingPopup("vehmanRotationPopup");
  	    closeFloatingPopup("vehmanRemovePopup");

  	    rerenderTyresTabOnly();
  	  }

  	  function rerenderTyresTabOnly() {
  	    var body = state.root
  	    ? state.root.querySelector("#individualVehicleManagerBody"): null;

  	    if (!body || state.activeTab !== "Tyres") {
  	      return;
  	    }

  	    body.innerHTML = renderTyresTab();
  	    wireTyresTabEvents();
  	  }

  	  function setTapSource(sourceType, tyreId, positionKey) {
  	    state.tapSource = {
  	      SourceType: sourceType,
  	      TyreObjectId: clean(tyreId),
  	      SourcePosition: clean(positionKey)
  	    };
  	  }

  	  function clearTapAndDrag() {
  	    state.tapSource = null;
  	    state.dragSource = null;
  	  }

  	  function moveOrSwapDraftTyres(sourcePosition, targetPosition) {
  	    var tPositions = getDraftTPositions();
  	    var sourceSlot = getSlot(tPositions, sourcePosition);
  	    var targetSlot = getSlot(tPositions, targetPosition);
  	    var temp;

  	    if (!sourceSlot || !sourceSlot.TyreObjectId) {
  	      setActionMessage("Source position does not contain a fitted tyre.", true);
  	      return false;
  	    }

  	    if (!targetSlot) {
  	      setActionMessage("Target position could not be found.", true);
  	      return false;
  	    }

  	    if (clean(sourceSlot.PositionKey || sourcePosition) === clean(targetSlot.PositionKey || targetPosition)) {
  	      setActionMessage("Source and target positions are the same.", true);
  	      return false;
  	    }

  	    temp = clone(targetSlot);
  	    copySlotTyre(sourceSlot, targetSlot);

  	    if (temp.TyreObjectId) {
  	      copySlotTyre(temp, sourceSlot);
  	      setActionMessage("Swap planned: " + clean(sourcePosition) + " ↔ " + clean(targetPosition) + ".", false);
  	    } else {
  	      clearSlot(sourceSlot);
  	      setActionMessage("Move planned: " + clean(sourcePosition) + " → " + clean(targetPosition) + ".", false);
  	    }

  	    clearTapAndDrag();
  	    rerenderTyresTabOnly();

  	    return true;
  	  }

  	  function allocateDraftTyreToSlot(tyreId, targetPosition) {
  	    var tPositions = getDraftTPositions();
  	    var targetSlot = getSlot(tPositions, targetPosition);
  	    var tyre = findTyre(tyreId);

  	    if (!tyre) {
  	      setActionMessage("Selected warehouse tyre could not be found.", true);
  	      return false;
  	    }

  	    if (!targetSlot) {
  	      setActionMessage("Target position could not be found.", true);
  	      return false;
  	    }

  	    fitSlot(targetSlot, tyre);

  	    setActionMessage("Allocation planned: " + tyreName(tyre) + " → " + clean(targetPosition) + ".", false);
  	    clearTapAndDrag();
  	    rerenderTyresTabOnly();

  	    return true;
  	  }

  	  function handleWarehouseTyreClick(tyreId) {
  	    var tyre = findTyre(tyreId);

  	    if (state.actionMode !== "Allocate") {
  	      return;
  	    }

  	    if (!tyre) {
  	      setActionMessage("Warehouse tyre could not be found.", true);
  	      rerenderTyresTabOnly();
  	      return;
  	    }

  	    setTapSource("warehouse", tyreObjectId(tyre), "");
  	    setActionMessage("Selected warehouse tyre. Now click a target vehicle position.", false);
  	    rerenderTyresTabOnly();
  	  }

  	  function handleSlotClick(positionKey) {
  	    var tPositions = visualTPositions();
  	    var slot = getSlot(tPositions, positionKey);
  	    var tyreId = slot ? clean(slot.TyreObjectId): "";

  	    state.selectedPosition = clean(positionKey);
  	    state.selectedTyreObjectId = tyreId;

  	    if (!state.actionMode) {
  	      if (tyreId) {
  	        renderTyreDetailsPopup(findTyre(tyreId), slot);
  	      }

  	      rerenderTyresTabOnly();
  	      return;
  	    }

  	    if (!slot) {
  	      setActionMessage("Position could not be found.", true);
  	      rerenderTyresTabOnly();
  	      return;
  	    }

  	    if (state.actionMode === "Remove") {
  	      if (!tyreId) {
  	        setActionMessage("Select a fitted tyre position to remove.", true);
  	        rerenderTyresTabOnly();
  	        return;
  	      }

  	      renderRemovePopup(slot);
  	      rerenderTyresTabOnly();
  	      return;
  	    }

  	    if (state.actionMode === "Allocate") {
  	      if (!state.tapSource) {
  	        if (tyreId) {
  	          setTapSource("fitted", tyreId, clean(slot.PositionKey || positionKey));
  	          setActionMessage("Selected fitted tyre. Click another position to move or swap, or select a warehouse tyre.", false);
  	        } else {
  	          setActionMessage("Select a warehouse tyre first, then click this target position.", false);
  	        }

  	        rerenderTyresTabOnly();
  	        return;
  	      }

  	      if (state.tapSource.SourceType === "warehouse") {
  	        allocateDraftTyreToSlot(state.tapSource.TyreObjectId, positionKey);
  	        return;
  	      }

  	      if (state.tapSource.SourceType === "fitted") {
  	        moveOrSwapDraftTyres(state.tapSource.SourcePosition, positionKey);
  	        return;
  	      }
  	    }

  	    if (state.actionMode === "RotateSwap") {
  	      if (!state.tapSource) {
  	        if (!tyreId) {
  	          setActionMessage("Select a fitted tyre first.", false);
  	          rerenderTyresTabOnly();
  	          return;
  	        }

  	        setTapSource("fitted", tyreId, clean(slot.PositionKey || positionKey));
  	        setActionMessage("Selected " + clean(slot.PositionKey || positionKey) + ". Now click the target position.", false);
  	        rerenderTyresTabOnly();
  	        return;
  	      }

  	      moveOrSwapDraftTyres(state.tapSource.SourcePosition, positionKey);
  	    }
  	  }

  	  function plannedMovementRows() {
  	    var live = getLiveTPositions();
  	    var draft = state.draftTPositions ? state.draftTPositions: null;
  	    var livePositions = live && live.Positions ? live.Positions: {};
  	    var draftPositions = draft && draft.Positions ? draft.Positions: {};
  	    var liveByTyre = {};
  	    var draftByTyre = {};
  	    var rows = [];

  	    if (!draft) {
  	      return rows;
  	    }

  	    Object.keys(livePositions).forEach(function (key) {
  	      var slot = livePositions[key] || {};
  	      var tyreId = clean(slot.TyreObjectId);

  	      if (tyreId) {
  	        liveByTyre[tyreId] = clean(slot.PositionKey || key);
  	      }
  	    });

  	    Object.keys(draftPositions).forEach(function (key) {
  	      var slot = draftPositions[key] || {};
  	      var tyreId = clean(slot.TyreObjectId);

  	      if (tyreId) {
  	        draftByTyre[tyreId] = clean(slot.PositionKey || key);
  	      }
  	    });

  	    Object.keys(draftByTyre).forEach(function (tyreId) {
  	      var from = liveByTyre[tyreId] || "";
  	      var to = draftByTyre[tyreId] || "";
  	      var tyre = findTyre(tyreId);

  	      if (from === to) {
  	        return;
  	      }

  	      rows.push({
  	        Type: from ? "Move": "Allocate",
  	        TyreObjectId: tyreId,
  	        TyreLabel: tyre ? tyreName(tyre): tyreId,
  	        FromPosition: from,
  	        ToPosition: to,
  	        FromLabel: from || "Warehouse",
  	        ToLabel: to || "Warehouse"
  	      });
  	    });

  	    Object.keys(liveByTyre).forEach(function (tyreId) {
  	      var from = liveByTyre[tyreId] || "";
  	      var to = draftByTyre[tyreId] || "";
  	      var tyre = findTyre(tyreId);

  	      if (to) {
  	        return;
  	      }

  	      rows.push({
  	        Type: "RemoveToWarehouse",
  	        TyreObjectId: tyreId,
  	        TyreLabel: tyre ? tyreName(tyre): tyreId,
  	        FromPosition: from,
  	        ToPosition: "",
  	        FromLabel: from || "Vehicle",
  	        ToLabel: "Warehouse"
  	      });
  	    });

  	    return rows;
  	  }

  	  function movementRowsHtml(rows) {
  	    if (!rows.length) {
  	      return `<div class="vehman-empty">No planned tyre movements.</div>`;
  	    }

  	    return rows.map(function (row) {
  	      var typeLabel = row.Type === "RemoveToWarehouse" ? "Remove to warehouse": row.Type;

  	      return `
  	      <div style="
  	      display:grid;
  	      grid-template-columns:88px 24px 88px minmax(0, 1fr);
  	      gap:8px;
  	      align-items:center;
  	      border-bottom:1px solid #242424;
  	      padding:8px 0;
  	      ">
  	      <div style="
  	      background:#1f2937;
  	      border:1px solid #334155;
  	      border-radius:7px;
  	      padding:7px 10px;
  	      color:#fff;
  	      font-weight:900;
  	      text-align:center;
  	      font-size:12px;
  	      ">${escapeHtml(row.FromLabel || "Warehouse")}</div>

  	      <div style="color:#CC6633;font-weight:900;text-align:center;">→</div>

  	      <div style="
  	      background:#1f2937;
  	      border:1px solid #334155;
  	      border-radius:7px;
  	      padding:7px 10px;
  	      color:#fff;
  	      font-weight:900;
  	      text-align:center;
  	      font-size:12px;
  	      ">${escapeHtml(row.ToLabel || "Warehouse")}</div>

  	      <div style="min-width:0;">
  	      <div style="
  	      color:#bbb;
  	      font-size:13px;
  	      font-weight:850;
  	      white-space:nowrap;
  	      overflow:hidden;
  	      text-overflow:ellipsis;
  	      ">${escapeHtml(row.TyreLabel || "Tyre")}</div>

  	      <div style="color:#777;font-size:11px;margin-top:2px;">
  	      ${escapeHtml(typeLabel)}
  	      </div>
  	      </div>
  	      </div>
  	      `;
  	    }).join("");
  	  }

  	  // ===============================================================
  	  // FLOATING POPUPS
  	  // ===============================================================
  	  function floatingPopupShellHtml(id, title, bodyHtml, width) {
  	    return `
  	    <div
  	    id="${escapeHtml(id)}"
  	    style="
  	    position:fixed;
  	    inset:0;
  	    z-index:1000000;
  	    background:rgba(0,0,0,0.55);
  	    display:flex;
  	    align-items:center;
  	    justify-content:center;
  	    padding:22px;
  	    font-family:system-ui, Arial, sans-serif;
  	    "
  	    >
  	    <div style="
  	    width:${escapeHtml(width || "760px")};
  	    max-width:calc(100vw - 44px);
  	    max-height:calc(100vh - 44px);
  	    overflow:auto;
  	    background:#0b0b0b;
  	    border:1px solid #333;
  	    border-top:3px solid #CC6633;
  	    border-radius:12px;
  	    box-shadow:0 24px 80px rgba(0,0,0,0.65);
  	    color:#fff;
  	    ">
  	    <div style="
  	    display:flex;
  	    justify-content:space-between;
  	    align-items:center;
  	    gap:10px;
  	    padding:12px 14px;
  	    border-bottom:1px solid #303030;
  	    background:#151515;
  	    ">
  	    <div style="color:#CC6633;font-size:16px;font-weight:950;">
  	    ${escapeHtml(title)}
  	    </div>

  	    <button
  	    type="button"
  	    data-popup-close="${escapeHtml(id)}"
  	    style="
  	    background:#202020;
  	    color:#bbb;
  	    border:1px solid #444;
  	    width:32px;
  	    height:32px;
  	    border-radius:8px;
  	    cursor:pointer;
  	    font-size:18px;
  	    font-weight:900;
  	    "
  	    >×</button>
  	    </div>

  	    <div style="padding:14px;">
  	    ${bodyHtml}
  	    </div>
  	    </div>
  	    </div>
  	    `;
  	  }

  	  function closeFloatingPopup(id) {
  	    var popup = DocumentSafe.getElementById(id);

  	    if (popup && popup.parentNode) {
  	      popup.parentNode.removeChild(popup);
  	    }
  	  }

  	  function closeAllFloatingPopups() {
  	    closeFloatingPopup("vehmanAllocationPopup");
  	    closeFloatingPopup("vehmanRotationPopup");
  	    closeFloatingPopup("vehmanRemovePopup");
  	  }

  	  function refreshPopupSaveButton(popup, buttonId) {
  	    var input = popup ? popup.querySelector("#tyreActionOdometer"): null;
  	    var saveBtn = popup ? popup.querySelector("#" + buttonId): null;
  	    var value = input ? numberOrNull(input.value): null;

  	    if (saveBtn) {
  	      saveBtn.style.display = value !== null ? "inline-flex": "none";
  	    }
  	  }

  	  function renderAllocationPopup() {
  	    var rows = plannedMovementRows();
  	    var html;
  	    var popup;

  	    closeFloatingPopup("vehmanAllocationPopup");

  	    if (!rows.length) {
  	      alertSafe("No allocation changes have been planned yet.");
  	      return;
  	    }

  	    html = `
  	    <div style="display:flex;flex-direction:column;gap:12px;">
  	    <div style="color:#aaa;font-size:12px;line-height:1.45;">
  	    Review the planned allocation movements, enter one vehicle odometer reading, then save.
  	    </div>

  	    <div style="border:1px solid #2a8f3a;background:#101010;border-radius:8px;overflow:hidden;">
  	    <div style="
  	    padding:9px 12px;
  	    border-bottom:1px solid #333;
  	    background:#181818;
  	    color:#CC6633;
  	    font-size:13px;
  	    font-weight:900;
  	    ">Planned Tyre Changes</div>

  	    <div style="padding:10px 12px;max-height:260px;overflow:auto;">
  	    ${movementRowsHtml(rows)}
  	    </div>
  	    </div>

  	    <div style="border:1px solid #333;background:#101010;border-radius:8px;padding:12px;">
  	    <div style="margin-bottom:10px;">
  	    <label class="vehman-label" for="tyreActionOdometer">Vehicle Odometer</label>
  	    <input id="tyreActionOdometer" class="vehman-input" type="number" placeholder="km">
  	    </div>

  	    <div style="margin-bottom:12px;">
  	    <label class="vehman-label" for="tyreActionNotes">Notes</label>
  	    <textarea id="tyreActionNotes" class="vehman-textarea" placeholder="Notes for all planned tyre changes"></textarea>
  	    </div>

  	    <div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;align-items:center;">
  	    <button id="vehmanAllocationPrintBtn" type="button" class="vehman-btn vehman-btn-dark" style="margin-right:auto;display:inline-flex;align-items:center;gap:6px;">
  	    🖨 Print Report
  	    </button>
  	    <button id="vehmanAllocationSaveBtn" type="button" class="vehman-btn vehman-btn-green" style="display:none;">
  	    Save All Changes
  	    </button>
  	    <button id="vehmanAllocationCancelBtn" type="button" class="vehman-btn vehman-btn-grey">
  	    Cancel
  	    </button>
  	    </div>
  	    </div>
  	    </div>
  	    `;

  	    DocumentSafe.body.insertAdjacentHTML(
  	      "beforeend",
  	      floatingPopupShellHtml("vehmanAllocationPopup", "Complete Allocation", html, "780px")
  	    );

  	    popup = DocumentSafe.getElementById("vehmanAllocationPopup");

  	    if (popup) {
  	      wireAllocationPopupEvents(popup);
  	    }
  	  }

  	  function renderRotationPopup() {
  	    var rows = plannedMovementRows();
  	    var html;
  	    var popup;

  	    closeFloatingPopup("vehmanRotationPopup");

  	    if (!rows.length) {
  	      alertSafe("No rotation or swap changes have been planned yet.");
  	      return;
  	    }

  	    html = `
  	    <div style="display:flex;flex-direction:column;gap:12px;">
  	    <div style="color:#aaa;font-size:12px;line-height:1.45;">
  	    Review the planned rotation/swap movements, enter one vehicle odometer reading, then save.
  	    </div>

  	    <div style="border:1px solid #CC6633;background:#101010;border-radius:8px;overflow:hidden;">
  	    <div style="
  	    padding:9px 12px;
  	    border-bottom:1px solid #333;
  	    background:#181818;
  	    color:#CC6633;
  	    font-size:13px;
  	    font-weight:900;
  	    ">Planned Rotation / Swap</div>

  	    <div style="padding:10px 12px;max-height:260px;overflow:auto;">
  	    ${movementRowsHtml(rows)}
  	    </div>
  	    </div>

  	    <div style="border:1px solid #333;background:#101010;border-radius:8px;padding:12px;">
  	    <div style="margin-bottom:10px;">
  	    <label class="vehman-label" for="tyreActionOdometer">Vehicle Odometer</label>
  	    <input id="tyreActionOdometer" class="vehman-input" type="number" placeholder="km">
  	    </div>

  	    <div style="margin-bottom:12px;">
  	    <label class="vehman-label" for="tyreActionNotes">Notes</label>
  	    <textarea id="tyreActionNotes" class="vehman-textarea" placeholder="Notes for the rotation / swap"></textarea>
  	    </div>

  	    <div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;align-items:center;">
  	    <button id="vehmanRotationPrintBtn" type="button" class="vehman-btn vehman-btn-dark" style="margin-right:auto;display:inline-flex;align-items:center;gap:6px;">
  	    🖨 Print Report
  	    </button>
  	    <button id="vehmanRotationSaveBtn" type="button" class="vehman-btn vehman-btn-green" style="display:none;">
  	    Save Rotation Plan
  	    </button>
  	    <button id="vehmanRotationCancelBtn" type="button" class="vehman-btn vehman-btn-grey">
  	    Cancel
  	    </button>
  	    </div>
  	    </div>
  	    </div>
  	    `;

  	    DocumentSafe.body.insertAdjacentHTML(
  	      "beforeend",
  	      floatingPopupShellHtml("vehmanRotationPopup", "Save Rotation Plan", html, "780px")
  	    );

  	    popup = DocumentSafe.getElementById("vehmanRotationPopup");

  	    if (popup) {
  	      wireRotationPopupEvents(popup);
  	    }
  	  }

  	  function renderRemovePopup(slot) {
  	    var positionKey = clean(slot && slot.PositionKey);
  	    var tyreId = clean(slot && slot.TyreObjectId);
  	    var tyre = findTyre(tyreId);
  	    var options = REMOVE_DESTINATIONS.map(function (item) {
  	      return `<option value="${escapeHtml(item.value)}">${escapeHtml(item.label)}</option>`;
  	    }).join("");
  	    var html;
  	    var popup;

  	    closeFloatingPopup("vehmanRemovePopup");

  	    if (!slot || !tyreId) {
  	      alertSafe("Select a fitted tyre position to remove.");
  	      return;
  	    }

  	    html = `
  	    <div style="display:flex;flex-direction:column;gap:12px;">
  	    <div style="border:1px solid #333;background:#101010;border-radius:8px;overflow:hidden;">
  	    <div style="
  	    padding:9px 12px;
  	    border-bottom:1px solid #333;
  	    background:#181818;
  	    color:#CC6633;
  	    font-size:13px;
  	    font-weight:900;
  	    ">Tyre to Remove</div>

  	    ${lineHtml("Position", positionKey)}
  	    ${lineHtml("Tyre", tyre ? tyreName(tyre): tyreId)}
  	    ${lineHtml("Tyre ID", tyre ? tyreNumber(tyre): tyreId)}
  	    ${lineHtml("Serial", tyre ? tyreSerial(tyre): slot.SerialNumber)}
  	    </div>

  	    <div style="border:1px solid #333;background:#101010;border-radius:8px;padding:12px;">
  	    <div style="margin-bottom:10px;">
  	    <label class="vehman-label" for="tyreRemoveDestination">Destination</label>
  	    <select id="tyreRemoveDestination" class="vehman-select">${options}</select>
  	    </div>

  	    <div style="margin-bottom:10px;">
  	    <label class="vehman-label" for="tyreActionOdometer">Vehicle Odometer</label>
  	    <input id="tyreActionOdometer" class="vehman-input" type="number" placeholder="km">
  	    </div>

  	    <div style="margin-bottom:12px;">
  	    <label class="vehman-label" for="tyreActionNotes">Notes</label>
  	    <textarea id="tyreActionNotes" class="vehman-textarea" placeholder="Removal notes"></textarea>
  	    </div>

  	    <div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;align-items:center;">
  	    <button id="vehmanRemoveSaveBtn" type="button" class="vehman-btn vehman-btn-red" style="display:none;">
  	    Save Removal
  	    </button>
  	    <button id="vehmanRemoveCancelBtn" type="button" class="vehman-btn vehman-btn-grey">
  	    Cancel
  	    </button>
  	    </div>
  	    </div>
  	    </div>
  	    `;

  	    DocumentSafe.body.insertAdjacentHTML(
  	      "beforeend",
  	      floatingPopupShellHtml("vehmanRemovePopup", "Remove Tyre", html, "640px")
  	    );

  	    popup = DocumentSafe.getElementById("vehmanRemovePopup");

  	    if (popup) {
  	      popup.setAttribute("data-position-key", positionKey);
  	      wireRemovePopupEvents(popup);
  	    }
  	  }

  	  // ===============================================================
  	  // POPUP WIRING
  	  // ===============================================================
  	  function wirePopupCloseAsCancel(popup, popupId, message) {
  	    var closeButtons = popup.querySelectorAll("[data-popup-close=\"" + popupId + "\"]");

  	    Array.prototype.forEach.call(closeButtons, function (button) {
  	      button.onclick = function (event) {
  	        if (event && event.preventDefault) {
  	          event.preventDefault();
  	        }

  	        if (event && event.stopPropagation) {
  	          event.stopPropagation();
  	        }

  	        if (!confirmSafe("Cancel this tyre action and reset the layout?")) {
  	          return;
  	        }

  	        cancelTyreAction(message || "Tyre action cancelled.");
  	      };
  	    });
  	  }

  	  function wireAllocationPopupEvents(popup) {
  	    var saveBtn = popup.querySelector("#vehmanAllocationSaveBtn");
  	    var printBtn = popup.querySelector("#vehmanAllocationPrintBtn");
  	    var cancelBtn = popup.querySelector("#vehmanAllocationCancelBtn");
  	    var odometerInput = popup.querySelector("#tyreActionOdometer");

  	    refreshPopupSaveButton(popup,
  	      "vehmanAllocationSaveBtn");

  	    if (odometerInput) {
  	      odometerInput.oninput = function () {
  	        refreshPopupSaveButton(popup, "vehmanAllocationSaveBtn");
  	      };

  	      odometerInput.onchange = function () {
  	        refreshPopupSaveButton(popup, "vehmanAllocationSaveBtn");
  	      };
  	    }

  	    if (printBtn) {
  	      printBtn.onclick = function () {
  	        if (typeof printAllocationPlanReportFromPopup === "function") {
  	          printAllocationPlanReportFromPopup();
  	          return;
  	        }

  	        alertSafe("Allocation report print function is not installed yet.");
  	      };
  	    }

  	    if (saveBtn) {
  	      saveBtn.onclick = function () {
  	        if (typeof saveAllocationPlanFromUi !== "function") {
  	          alertSafe("Allocation save function is not installed yet.");
  	          return;
  	        }

  	        saveAllocationPlanFromUi(saveBtn);
  	      };
  	    }

  	    if (cancelBtn) {
  	      cancelBtn.onclick = function () {
  	        if (!confirmSafe("Cancel this allocation plan and reset the tyre layout?")) {
  	          return;
  	        }

  	        cancelTyreAction("Allocation cancelled. Tyre layout reset.");
  	      };
  	    }

  	    wirePopupCloseAsCancel(popup, "vehmanAllocationPopup", "Allocation cancelled. Tyre layout reset.");
  	  }

  	  function wireRotationPopupEvents(popup) {
  	    var saveBtn = popup.querySelector("#vehmanRotationSaveBtn");
  	    var printBtn = popup.querySelector("#vehmanRotationPrintBtn");
  	    var cancelBtn = popup.querySelector("#vehmanRotationCancelBtn");
  	    var odometerInput = popup.querySelector("#tyreActionOdometer");

  	    refreshPopupSaveButton(popup, "vehmanRotationSaveBtn");

  	    if (odometerInput) {
  	      odometerInput.oninput = function () {
  	        refreshPopupSaveButton(popup, "vehmanRotationSaveBtn");
  	      };

  	      odometerInput.onchange = function () {
  	        refreshPopupSaveButton(popup, "vehmanRotationSaveBtn");
  	      };
  	    }

  	    if (printBtn) {
  	      printBtn.onclick = function () {
  	        if (typeof printRotationPlanReportFromPopup === "function") {
  	          printRotationPlanReportFromPopup();
  	          return;
  	        }

  	        alertSafe("Rotation report print function is not installed yet.");
  	      };
  	    }

  	    if (saveBtn) {
  	      saveBtn.onclick = function () {
  	        if (typeof saveRotationPlanFromUi !== "function") {
  	          alertSafe("Rotation save function is not installed yet.");
  	          return;
  	        }

  	        saveRotationPlanFromUi(saveBtn);
  	      };
  	    }

  	    if (cancelBtn) {
  	      cancelBtn.onclick = function () {
  	        if (!confirmSafe("Cancel this rotation plan and reset the tyre layout?")) {
  	          return;
  	        }

  	        cancelTyreAction("Rotation cancelled. Tyre layout reset.");
  	      };
  	    }

  	    wirePopupCloseAsCancel(popup, "vehmanRotationPopup", "Rotation cancelled. Tyre layout reset.");
  	  }

  	  function wireRemovePopupEvents(popup) {
  	    var saveBtn = popup.querySelector("#vehmanRemoveSaveBtn");
  	    var cancelBtn = popup.querySelector("#vehmanRemoveCancelBtn");
  	    var odometerInput = popup.querySelector("#tyreActionOdometer");

  	    refreshPopupSaveButton(popup, "vehmanRemoveSaveBtn");

  	    if (odometerInput) {
  	      odometerInput.oninput = function () {
  	        refreshPopupSaveButton(popup, "vehmanRemoveSaveBtn");
  	      };

  	      odometerInput.onchange = function () {
  	        refreshPopupSaveButton(popup, "vehmanRemoveSaveBtn");
  	      };
  	    }

  	    if (saveBtn) {
  	      saveBtn.onclick = function () {
  	        if (typeof saveRemovalFromUi !== "function") {
  	          alertSafe("Removal save function is not installed yet.");
  	          return;
  	        }

  	        saveRemovalFromUi(saveBtn);
  	      };
  	    }

  	    if (cancelBtn) {
  	      cancelBtn.onclick = function () {
  	        closeFloatingPopup("vehmanRemovePopup");
  	      };
  	    }

  	    Array.prototype.forEach.call(popup.querySelectorAll("[data-popup-close=\"vehmanRemovePopup\"]"), function (button) {
  	      button.onclick = function () {
  	        closeFloatingPopup("vehmanRemovePopup");
  	      };
  	    });
  	  }

  	  // ===============================================================
  	  // TYRE TAB EVENT WIRING
  	  // ===============================================================
  	  function wireTyresTabEvents() {
  	    var startAllocateBtn = DocumentSafe.getElementById("vehmanStartAllocateBtn");
  	    var startRotateBtn = DocumentSafe.getElementById("vehmanStartRotateBtn");
  	    var startRemoveBtn = DocumentSafe.getElementById("vehmanStartRemoveBtn");

  	    var completeAllocationBtn = DocumentSafe.getElementById("vehmanCompleteAllocationBtn");
  	    var cancelAllocationBtn = DocumentSafe.getElementById("vehmanCancelAllocationBtn");

  	    var completeRotationBtn = DocumentSafe.getElementById("vehmanCompleteRotationBtn");
  	    var cancelRotationBtn = DocumentSafe.getElementById("vehmanCancelRotationBtn");

  	    var cancelRemoveBtn = DocumentSafe.getElementById("vehmanCancelRemoveBtn");

  	    if (startAllocateBtn) {
  	      startAllocateBtn.onclick = function () {
  	        startTyreAction("Allocate");
  	      };
  	    }

  	    if (startRotateBtn) {
  	      startRotateBtn.onclick = function () {
  	        startTyreAction("RotateSwap");
  	      };
  	    }

  	    if (startRemoveBtn) {
  	      startRemoveBtn.onclick = function () {
  	        startTyreAction("Remove");
  	      };
  	    }

  	    if (completeAllocationBtn) {
  	      completeAllocationBtn.onclick = function () {
  	        renderAllocationPopup();
  	      };
  	    }

  	    if (cancelAllocationBtn) {
  	      cancelAllocationBtn.onclick = function () {
  	        if (!confirmSafe("Cancel this allocation plan and reset the tyre layout?")) {
  	          return;
  	        }

  	        cancelTyreAction("Allocation cancelled. Tyre layout reset.");
  	      };
  	    }

  	    if (completeRotationBtn) {
  	      completeRotationBtn.onclick = function () {
  	        renderRotationPopup();
  	      };
  	    }

  	    if (cancelRotationBtn) {
  	      cancelRotationBtn.onclick = function () {
  	        if (!confirmSafe("Cancel this rotation plan and reset the tyre layout?")) {
  	          return;
  	        }

  	        cancelTyreAction("Rotation cancelled. Tyre layout reset.");
  	      };
  	    }

  	    if (cancelRemoveBtn) {
  	      cancelRemoveBtn.onclick = function () {
  	        cancelTyreAction("Remove mode cancelled.");
  	      };
  	    }

  	    Array.prototype.forEach.call(DocumentSafe.querySelectorAll(".vehman-tyre-slot"), function (slotEl) {
  	      slotEl.onclick = function () {
  	        handleSlotClick(slotEl.getAttribute("data-position-key") || "");
  	      };

  	      slotEl.ondragstart = function (event) {
  	        var tyreId = slotEl.getAttribute("data-tyre-object-id") || "";
  	        var positionKey = slotEl.getAttribute("data-position-key") || "";

  	        if (!tyreId || (state.actionMode !== "RotateSwap" && state.actionMode !== "Allocate")) {
  	          if (event && event.preventDefault) {
  	            event.preventDefault();
  	          }

  	          return;
  	        }

  	        state.dragSource = {
  	          SourceType: "fitted",
  	          TyreObjectId: tyreId,
  	          SourcePosition: positionKey
  	        };

  	        if (event && event.dataTransfer) {
  	          event.dataTransfer.setData("text/plain", JSON.stringify(state.dragSource));
  	          event.dataTransfer.effectAllowed = "move";
  	        }
  	      };

  	      slotEl.ondragover = function (event) {
  	        if (state.actionMode === "Allocate" || state.actionMode === "RotateSwap") {
  	          if (event && event.preventDefault) {
  	            event.preventDefault();
  	          }
  	        }
  	      };

  	      slotEl.ondrop = function (event) {
  	        var targetPosition = slotEl.getAttribute("data-position-key") || "";
  	        var source = state.dragSource;

  	        if (event && event.preventDefault) {
  	          event.preventDefault();
  	        }

  	        if (!source && event && event.dataTransfer) {
  	          try {
  	            source = JSON.parse(event.dataTransfer.getData("text/plain") || "{}");
  	          } catch (error) {
  	            source = null;
  	          }
  	        }

  	        if (!source) {
  	          return;
  	        }

  	        if (source.SourceType === "warehouse") {
  	          allocateDraftTyreToSlot(source.TyreObjectId, targetPosition);
  	          return;
  	        }

  	        if (source.SourceType === "fitted") {
  	          moveOrSwapDraftTyres(source.SourcePosition, targetPosition);
  	        }
  	      };
  	    });

  	    Array.prototype.forEach.call(DocumentSafe.querySelectorAll(".vehman-warehouse-tyre"),
  	      function (card) {
  	        card.onclick = function () {
  	          handleWarehouseTyreClick(card.getAttribute("data-warehouse-tyre-id") || "");
  	        };

  	        card.ondragstart = function (event) {
  	          var tyreId = card.getAttribute("data-warehouse-tyre-id") || "";

  	          if (state.actionMode !== "Allocate" || !tyreId) {
  	            if (event && event.preventDefault) {
  	              event.preventDefault();
  	            }

  	            return;
  	          }

  	          state.dragSource = {
  	            SourceType: "warehouse",
  	            TyreObjectId: tyreId,
  	            SourcePosition: ""
  	          };

  	          if (event && event.dataTransfer) {
  	            event.dataTransfer.setData("text/plain", JSON.stringify(state.dragSource));
  	            event.dataTransfer.effectAllowed = "move";
  	          }
  	        };
  	      });
  	  }

  	  // ===============================================================
  	  // FLEET DUPLICATE FITMENT SAFETY
  	  // ===============================================================
  	  function scanVehicleForTyre(vehicle,
  	    tyreId,
  	    currentVehicleObjectId) {
  	    var tPositions;
  	    var positions;
  	    var keys;
  	    var vehicleObjId;
  	    var slot;
  	    var i;

  	    tyreId = clean(tyreId);

  	    if (!vehicle || !tyreId) {
  	      return null;
  	    }

  	    vehicleObjId = vehicleObjectId(vehicle);

  	    if (
  	      currentVehicleObjectId &&
  	      vehicleObjId &&
  	      String(vehicleObjId) === String(currentVehicleObjectId)
  	    ) {
  	      return null;
  	    }

  	    tPositions = normaliseTPositions(readTPositionsRaw(vehicle));
  	    positions = tPositions.Positions || {};
  	    keys = Object.keys(positions);

  	    for (i = 0; i < keys.length; i++) {
  	      slot = positions[keys[i]];

  	      if (slot && String(slot.TyreObjectId || "") === tyreId) {
  	        return {
  	          vehicle: vehicle,
  	          vehicleObjectId: vehicleObjId,
  	          vehicleLabel: vehicleTitle(vehicle),
  	          positionKey: slot.PositionKey || keys[i]
  	        };
  	      }
  	    }

  	    return null;
  	  }

  	  function findExistingFleetAssignment(tyreId, currentVehicleObjectId) {
  	    var found = null;

  	    tyreId = clean(tyreId);

  	    if (!tyreId) {
  	      return null;
  	    }

  	    try {
  	      arr(App && App.User && App.User.Companies).some(function (company) {
  	        var stop = false;

  	        arr(company.Tractors).some(function (vehicle) {
  	          found = scanVehicleForTyre(vehicle, tyreId, currentVehicleObjectId);
  	          stop = !!found;
  	          return stop;
  	        });

  	        if (stop) {
  	          return true;
  	        }

  	        arr(company.Trailers).some(function (vehicle) {
  	          found = scanVehicleForTyre(vehicle, tyreId, currentVehicleObjectId);
  	          stop = !!found;
  	          return stop;
  	        });

  	        return stop;
  	      });
  	    } catch (error) {
  	      console.warn("VEH-MAN: fleet assignment scan failed",
  	        error);
  	    }

  	    return found;
  	  }

  	  // ===============================================================
  	  // TYRE HISTORY / LIFE CYCLE ENGINE
  	  // ===============================================================
  	  function blankHistoryStage(active) {
  	    return {
  	      CPK: 0,
  	      Cost: 0,
  	      Ended: "",
  	      Notes: "",
  	      Active: !!active,
  	      Events: [],
  	      Status: active ? "Active": "Not Started",
  	      Started: active ? new Date().toISOString(): "",
  	      End_Mileage: 0,
  	      Mileage_Done: 0,
  	      Start_Mileage: 0,
  	      Mileage_Expected: 0
  	    };
  	  }

  	  function defaultHistory(tyre) {
  	    var stage = tyreStage(tyre) || "New";

  	    return {
  	      New: blankHistoryStage(stage === "New"),
  	      Cap1: blankHistoryStage(stage === "Cap1"),
  	      Cap2: blankHistoryStage(stage === "Cap2"),
  	      Cap3: blankHistoryStage(stage === "Cap3"),
  	      Totals: {
  	        Cost_Total: numberOrNull(tyre && tyre.Total_Cost) || 0,
  	        Average_CPK: numberOrNull(tyre && tyre.Total_CPK) || 0,
  	        Mileage_Total: numberOrNull(tyre && tyre.Total_Mileage) || 0,
  	        Total_Life_Stages_Used: 1
  	      },
  	      Current: {
  	        Stage: stage
  	      }
  	    };
  	  }

  	  function normaliseHistory(tyre) {
  	    var fallback = defaultHistory(tyre);
  	    var history = parseJson(tyre && tyre[HISTORY_FIELD],
  	      fallback);

  	    ["New", "Cap1", "Cap2", "Cap3"].forEach(function (stage) {
  	      if (!history[stage] || typeof history[stage] !== "object") {
  	        history[stage] = clone(fallback[stage]);
  	      }

  	      if (!Array.isArray(history[stage].Events)) {
  	        history[stage].Events = [];
  	      }
  	    });

  	    if (!history.Totals || typeof history.Totals !== "object") {
  	      history.Totals = clone(fallback.Totals);
  	    }

  	    if (!history.Current || typeof history.Current !== "object") {
  	      history.Current = {
  	        Stage: tyreStage(tyre) || "New"
  	      };
  	    }

  	    return history;
  	  }

  	  function defaultLifeCycle(tyre) {
  	    var stage = tyreStage(tyre) || "New";

  	    return {
  	      Current: {
  	        Stage: stage,
  	        Status: tyreStatus(tyre),
  	        HolderType: tyre && tyre.Current_Holder_Type ? tyre.Current_Holder_Type: "",
  	        HolderObjectId: tyre && tyre.Current_Holder_ObjectId ? tyre.Current_Holder_ObjectId: "",
  	        LastEventType: "",
  	        LastEventDate: ""
  	      },
  	      New: {
  	        Active: stage === "New",
  	        Events: []
  	      },
  	      Cap1: {
  	        Active: stage === "Cap1",
  	        Events: []
  	      },
  	      Cap2: {
  	        Active: stage === "Cap2",
  	        Events: []
  	      },
  	      Cap3: {
  	        Active: stage === "Cap3",
  	        Events: []
  	      },
  	      Events: []
  	    };
  	  }

  	  function normaliseLifeCycle(tyre) {
  	    var fallback = defaultLifeCycle(tyre);
  	    var lifeCycle = parseJson(tyre && tyre[LIFE_CYCLE_FIELD], fallback);

  	    if (!lifeCycle.Current || typeof lifeCycle.Current !== "object") {
  	      lifeCycle.Current = clone(fallback.Current);
  	    }

  	    ["New",
  	      "Cap1",
  	      "Cap2",
  	      "Cap3"].forEach(function (stage) {
  	        if (!lifeCycle[stage] || typeof lifeCycle[stage] !== "object") {
  	          lifeCycle[stage] = {
  	            Active: false,
  	            Events: []
  	          };
  	        }

  	        if (!Array.isArray(lifeCycle[stage].Events)) {
  	          lifeCycle[stage].Events = [];
  	        }
  	      });

  	    if (!Array.isArray(lifeCycle.Events)) {
  	      lifeCycle.Events = [];
  	    }

  	    return lifeCycle;
  	  }

  	  function createTyreEvent(type, options) {
  	    options = options || {};

  	    return {
  	      Date: new Date().toISOString(),
  	      Type: type,
  	      Vehicle_ObjectId: vehicleObjectId(state.sourceVehicle),
  	      Vehicle_ID: vehicleId(state.sourceVehicle),
  	      VehicleObjectId: vehicleObjectId(state.sourceVehicle),
  	      VehicleId: vehicleId(state.sourceVehicle),
  	      FromPosition: options.FromPosition || "",
  	      ToPosition: options.ToPosition || "",
  	      Odometer: options.Odometer || "",
  	      Destination: options.Destination || "",
  	      WearRate: options.WearRate === null || options.WearRate === undefined ? "": options.WearRate,
  	      CapturedBy: "Vehicle Manager",
  	      Notes: options.Notes || ""
  	    };
  	  }

  	  function appendTyreEvent(tyre, event) {
  	    var updated = clone(tyre);
  	    var stage = tyreStage(updated) || "New";
  	    var history = normaliseHistory(updated);
  	    var lifeCycle = normaliseLifeCycle(updated);

  	    if (!history[stage] || typeof history[stage] !== "object") {
  	      history[stage] = blankHistoryStage(true);
  	    }

  	    if (!Array.isArray(history[stage].Events)) {
  	      history[stage].Events = [];
  	    }

  	    history[stage].Events.push(event);
  	    history.Current.Stage = stage;
  	    history.Current.Last_Event_Type = event.Type || "";
  	    history.Current.Last_Event_Date = event.Date || "";
  	    history.Current.Vehicle_ObjectId = updated.Vehicle_ObjectId || "";
  	    history.Current.Vehicle_ID = updated.Vehicle_ID || "";
  	    history.Current.Position = updated.Current_Position || "";
  	    history.Current.Axle_Type = updated.Current_Axle_Type || "";
  	    history.Current.Wear_Rate = updated.Current_Wear_Rate || "";

  	    if (!lifeCycle[stage] || typeof lifeCycle[stage] !== "object") {
  	      lifeCycle[stage] = {
  	        Active: true,
  	        Events: []
  	      };
  	    }

  	    if (!Array.isArray(lifeCycle[stage].Events)) {
  	      lifeCycle[stage].Events = [];
  	    }

  	    lifeCycle[stage].Events.push(event);
  	    lifeCycle.Events.push(event);
  	    lifeCycle.Current.Stage = stage;
  	    lifeCycle.Current.Status = updated.Status || updated.Current_Status || "";
  	    lifeCycle.Current.HolderType = updated.Current_Holder_Type || "";
  	    lifeCycle.Current.HolderObjectId = updated.Current_Holder_ObjectId || "";
  	    lifeCycle.Current.LastEventType = event.Type || "";
  	    lifeCycle.Current.LastEventDate = event.Date || "";

  	    updated[HISTORY_FIELD] = history;
  	    updated[LIFE_CYCLE_FIELD] = lifeCycle;

  	    return updated;
  	  }

  	  function makeTyreFitted(tyre, slot, odometer, notes, eventType, fromPosition) {
  	    var updated = clone(tyre);
  	    var event;

  	    updated.Vehicle_ObjectId = vehicleObjectId(state.sourceVehicle) || null;
  	    updated.Vehicle_ID = vehicleId(state.sourceVehicle) || null;
  	    updated.Vehicle_Type = DEFAULT_VEHICLE_TYPE;

  	    updated.Current_Holder_Type = "Vehicle";
  	    updated.Current_Holder_ObjectId = vehicleObjectId(state.sourceVehicle) || null;
  	    updated.Current_Status = "Fitted";
  	    updated.Is_Fitted = true;

  	    updated.Current_Position = slot.PositionKey;
  	    updated.Current_Axle_Type = slot.AxleType || "";
  	    updated.Current_Wear_Rate = slot.WearRate === null || slot.WearRate === undefined ? 1: slot.WearRate;

  	    updated.Status = TYRE_STATUS.OK;
  	    updated.Last_Event_Type = eventType || "Installed";
  	    updated.Last_Event_Date = new Date().toISOString();

  	    if (eventType === "Installed" || eventType === "Allocated" || !updated.Fitted_Date) {
  	      updated.Fitted_Date = new Date().toISOString();
  	    }

  	    if (odometer !== "") {
  	      updated.Fitted_Odometer = odometer;
  	      updated.Last_Vehicle_Odometer = odometer;
  	    }

  	    event = createTyreEvent(eventType || "Installed", {
  	      FromPosition: fromPosition || "",
  	      ToPosition: slot.PositionKey,
  	      Odometer: odometer,
  	      WearRate: slot.WearRate,
  	      Notes: notes || ""
  	    });

  	    return appendTyreEvent(updated, event);
  	  }

  	  function makeTyreMoved(tyre, fromSlot, toSlot, odometer, notes, eventType) {
  	    var updated = clone(tyre);
  	    var event;

  	    updated.Vehicle_ObjectId = vehicleObjectId(state.sourceVehicle) || null;
  	    updated.Vehicle_ID = vehicleId(state.sourceVehicle) || null;
  	    updated.Vehicle_Type = DEFAULT_VEHICLE_TYPE;

  	    updated.Current_Holder_Type = "Vehicle";
  	    updated.Current_Holder_ObjectId = vehicleObjectId(state.sourceVehicle) || null;
  	    updated.Current_Status = "Fitted";
  	    updated.Is_Fitted = true;

  	    updated.Current_Position = toSlot.PositionKey;
  	    updated.Current_Axle_Type = toSlot.AxleType || "";
  	    updated.Current_Wear_Rate = toSlot.WearRate === null || toSlot.WearRate === undefined ? 1: toSlot.WearRate;

  	    updated.Status = TYRE_STATUS.OK;
  	    updated.Last_Event_Type = eventType || "Rotation";
  	    updated.Last_Event_Date = new Date().toISOString();

  	    if (odometer !== "") {
  	      updated.Last_Vehicle_Odometer = odometer;
  	    }

  	    event = createTyreEvent(eventType || "Rotation", {
  	      FromPosition: fromSlot.PositionKey,
  	      ToPosition: toSlot.PositionKey,
  	      Odometer: odometer,
  	      WearRate: toSlot.WearRate,
  	      Notes: notes || ""
  	    });

  	    return appendTyreEvent(updated, event);
  	  }

  	  function destinationMeta(destination) {
  	    var found = REMOVE_DESTINATIONS.filter(function (item) {
  	      return item.value === destination;
  	    })[0];

  	    return found || REMOVE_DESTINATIONS[0];
  	  }

  	  function makeTyreRemoved(tyre, slot, destination, odometer, notes) {
  	    var updated = clone(tyre);
  	    var meta = destinationMeta(destination);
  	    var event;

  	    updated.Vehicle_ObjectId = null;
  	    updated.Vehicle_ID = null;
  	    updated.Vehicle_Type = null;

  	    updated.Current_Holder_Type = meta.label === "Warehouse" ? "Warehouse": meta.label;
  	    updated.Current_Holder_ObjectId = "";
  	    updated.Current_Status = meta.status;
  	    updated.Is_Fitted = false;

  	    updated.Current_Position = null;
  	    updated.Current_Axle_Type = null;
  	    updated.Current_Wear_Rate = null;

  	    updated.Fitted_Date = null;
  	    updated.Fitted_Odometer = null;

  	    updated.Status = meta.status;
  	    updated.Last_Event_Type = "Removed";
  	    updated.Last_Event_Date = new Date().toISOString();

  	    if (odometer !== "") {
  	      updated.Last_Vehicle_Odometer = odometer;
  	    }

  	    event = createTyreEvent("Removed", {
  	      FromPosition: slot.PositionKey,
  	      ToPosition: "",
  	      Odometer: odometer,
  	      Destination: meta.label,
  	      WearRate: slot.WearRate,
  	      Notes: notes || ""
  	    });

  	    return appendTyreEvent(updated, event);
  	  }

  	  // ===============================================================
  	  // SAVE ENGINE
  	  // ===============================================================
  	  var TYRE_EXPRESSION_FIELDS = [
  	    "Warehouse",
  	    "Current_CPK",
  	    "Total_CPK",
  	    "Current_Life",
  	    "Total_Mileage",
  	    "Mileage_Warning",
  	    "Total_Cost",
  	    "Expected_CPK",
  	    "Remaining_Mileage"
  	  ];

  	  var READ_ONLY_FIELDS = [
  	    "created",
  	    "updated",
  	    "ownerId",
  	    "___class"
  	  ];

  	  function cleanObjectForSave(row) {
  	    var payload = clone(row);

  	    READ_ONLY_FIELDS.forEach(function (field) {
  	      if (Object.prototype.hasOwnProperty.call(payload, field)) {
  	        delete payload[field];
  	      }
  	    });

  	    return payload;
  	  }

  	  function cleanTyreForSave(tyre) {
  	    var payload = cleanObjectForSave(tyre);

  	    TYRE_EXPRESSION_FIELDS.forEach(function (field) {
  	      if (Object.prototype.hasOwnProperty.call(payload, field)) {
  	        delete payload[field];
  	      }
  	    });

  	    return payload;
  	  }

  	  function saveTyresSequentially(tyres) {
  	    var store;
  	    var saved = [];

  	    tyres = arr(tyres).filter(function (tyre) {
  	      return tyre && tyreObjectId(tyre);
  	    });

  	    if (!tyres.length) {
  	      return Promise.resolve([]);
  	    }

  	    if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	      return Promise.reject(new Error("Backendless is unavailable. Cannot save tyre records."));
  	    }

  	    store = BackendlessApi.Data.of(TABLE_TYRES);

  	    return tyres.reduce(function (chain, tyre) {
  	      return chain.then(function () {
  	        var payload = cleanTyreForSave(tyre);

  	        return store.save(payload).then(function (row) {
  	          row = row && typeof row === "object" ? row: tyre;
  	          saved.push(row);
  	          upsertTyre(row);
  	          return row;
  	        });
  	      });
  	    }, Promise.resolve()).then(function () {
  	      return saved;
  	    });
  	  }

  	  function removeTyreRelationForSave(vehicle) {
  	    var payload = cleanObjectForSave(vehicle);

  	    delete payload[TYRES_RELATION];

  	    return payload;
  	  }

  	  function syncTyreRelation(vehicle, tPositions) {
  	    var store;
  	    var refs;

  	    if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	      return Promise.resolve({
  	        skipped: true
  	      });
  	    }

  	    store = BackendlessApi.Data.of(TABLE_VEHICLES);

  	    if (!store || typeof store.setRelation !== "function") {
  	      return Promise.resolve({
  	        skipped: true
  	      });
  	    }

  	    refs = assignedTyreIds(tPositions).map(function (id) {
  	      return {
  	        objectId: id
  	      };
  	    });

  	    return store.setRelation(vehicle, TYRES_RELATION, refs).catch(function (firstError) {
  	      var objectId = vehicleObjectId(vehicle);

  	      console.warn("VEH-MAN: setRelation with object failed. Trying objectId.", firstError);

  	      if (!objectId) {
  	        throw firstError;
  	      }

  	      return store.setRelation(objectId, TYRES_RELATION, refs);
  	    });
  	  }

  	  function syncVehicleIntoAppData(updated) {
  	    var updatedObjectId = vehicleObjectId(updated);
  	    var updatedId = vehicleId(updated);

  	    try {
  	      arr(App && App.User && App.User.Companies).forEach(function (company) {
  	        ["Tractors",
  	          "Trailers",
  	          "Vehicles"].forEach(function (collectionName) {
  	            var list = arr(company[collectionName]);

  	            list.some(function (vehicle, index) {
  	              if (
  	                vehicleObjectId(vehicle) === updatedObjectId ||
  	                (updatedId && vehicleId(vehicle) === updatedId)
  	              ) {
  	                company[collectionName][index] = updated;
  	                return true;
  	              }

  	              return false;
  	            });
  	          });
  	      });
  	    } catch (error) {
  	      console.warn("VEH-MAN: vehicle sync into App data failed", error);
  	    }
  	  }

  	  function saveVehicleOnly(vehicle) {
  	    var payload;

  	    if (!BackendlessApi || !BackendlessApi.Data || !BackendlessApi.Data.of) {
  	      return Promise.reject(new Error("Backendless is unavailable. Cannot save vehicle."));
  	    }

  	    payload = removeTyreRelationForSave(vehicle);

  	    return BackendlessApi.Data.of(TABLE_VEHICLES).save(payload).then(function (saved) {
  	      saved = saved && typeof saved === "object" ? saved: payload;

  	      Object.assign(state.sourceVehicle, saved);
  	      syncVehicleIntoAppData(saved);

  	      return saved;
  	    });
  	  }

  	  function saveVehicleWithTPositions(vehicle, tPositions) {
  	    writeTPositionsToVehicle(vehicle, tPositions);

  	    return saveVehicleOnly(vehicle).then(function (saved) {
  	      return syncTyreRelation(saved, tPositions).then(function () {
  	        saved[TYRES_RELATION] = assignedTyreObjects(tPositions);
  	        Object.assign(state.sourceVehicle, saved);
  	        syncVehicleIntoAppData(saved);
  	        return saved;
  	      });
  	    });
  	  }

  	  function appendTyreMovementRecord(record) {
  	    var records = ensureArrayPath(state.sourceVehicle, ["Data", "Tyres", "TyreRecords"]);

  	    records.push(record);
  	  }

  	  function tyreMovementRecord(type, fromPosition, toPosition, tyre, odometer, notes, destination) {
  	    return {
  	      date: new Date().toISOString(),
  	      type: type || "",
  	      fromPosition: fromPosition || "",
  	      toPosition: toPosition || "",
  	      tyre: tyre ? tyreName(tyre): "",
  	      tyreObjectId: tyre ? tyreObjectId(tyre): "",
  	      odometer: odometer || "",
  	      destination: destination || "",
  	      notes: notes || ""
  	    };
  	  }

  	  function buildUpdatedTyresForPlan(rows, odometer, notes) {
  	    var live = getLiveTPositions();
  	    var draft = getDraftTPositions();
  	    var updatedTyres = [];

  	    rows.forEach(function (row) {
  	      var tyre = findTyre(row.TyreObjectId);
  	      var fromSlot = row.FromPosition ? getSlot(live, row.FromPosition): null;
  	      var toSlot = row.ToPosition ? getSlot(draft, row.ToPosition): null;
  	      var updated;

  	      if (!tyre) {
  	        return;
  	      }

  	      if (row.Type === "Allocate") {
  	        updated = makeTyreFitted(tyre, toSlot, odometer, notes, "Installed", "");
  	      } else if (row.Type === "Move") {
  	        updated = makeTyreMoved(tyre, fromSlot, toSlot, odometer, notes, "Rotation");
  	      } else if (row.Type === "RemoveToWarehouse") {
  	        updated = makeTyreRemoved(tyre, fromSlot, "Warehouse", odometer, notes);
  	      }

  	      if (updated) {
  	        updatedTyres.push(updated);
  	      }
  	    });

  	    return updatedTyres;
  	  }

  	  function saveMovementPlanFromUi(button,
  	    modeName) {
  	    var popup = button ? button.closest("[id]"): null;
  	    var rows = plannedMovementRows();
  	    var odometer = readValue("tyreActionOdometer");
  	    var notes = readValue("tyreActionNotes");
  	    var odometerNumber = numberOrNull(odometer);
  	    var updatedTyres;

  	    if (!rows.length) {
  	      alertSafe("No tyre movements have been planned.");
  	      return;
  	    }

  	    if (odometerNumber === null) {
  	      alertSafe("Enter a valid vehicle odometer reading before saving.");
  	      return;
  	    }

  	    updatedTyres = buildUpdatedTyresForPlan(rows, odometer, notes);

  	    setButtonBusy(button, true, modeName === "RotateSwap" ? "Save Rotation Plan": "Save All Changes");

  	    rows.forEach(function (row) {
  	      var tyre = findTyre(row.TyreObjectId);

  	      appendTyreMovementRecord(
  	        tyreMovementRecord(
  	          row.Type,
  	          row.FromPosition,
  	          row.ToPosition,
  	          tyre,
  	          odometer,
  	          notes,
  	          row.Type === "RemoveToWarehouse" ? "Warehouse": ""
  	        )
  	      );
  	    });

  	    return saveTyresSequentially(updatedTyres)
  	    .then(function () {
  	      return saveVehicleWithTPositions(state.sourceVehicle, getDraftTPositions());
  	    })
  	    .then(function () {
  	      closeAllFloatingPopups();

  	      state.actionMode = "";
  	      state.tapSource = null;
  	      state.dragSource = null;
  	      resetDraft();

  	      state.actionMessage = modeName === "RotateSwap"
  	      ? "Rotation plan saved. Tyre movement locked.": "Allocation plan saved. Tyre movement locked.";
  	      state.actionError = false;

  	      setMessage(state.actionMessage, false);
  	      renderActiveTab();
  	    })
  	    .catch(function (error) {
  	      console.warn("VEH-MAN: movement plan save failed", error);

  	      setButtonBusy(button, false, modeName === "RotateSwap" ? "Save Rotation Plan": "Save All Changes");

  	      state.actionMessage = error && error.message
  	      ? error.message: "Could not save tyre movement plan.";
  	      state.actionError = true;

  	      setMessage(state.actionMessage, true);
  	      showStatus();
  	    });
  	  }

  	  function saveAllocationPlanFromUi(button) {
  	    return saveMovementPlanFromUi(button, "Allocate");
  	  }

  	  function saveRotationPlanFromUi(button) {
  	    return saveMovementPlanFromUi(button, "RotateSwap");
  	  }

  	  function saveRemovalFromUi(button) {
  	    var popup = DocumentSafe.getElementById("vehmanRemovePopup");
  	    var positionKey = popup ? clean(popup.getAttribute("data-position-key")): "";
  	    var destination = readValue("tyreRemoveDestination") || "Warehouse";
  	    var odometer = readValue("tyreActionOdometer");
  	    var notes = readValue("tyreActionNotes");
  	    var odometerNumber = numberOrNull(odometer);
  	    var tPositions = getLiveTPositions();
  	    var slot = getSlot(tPositions, positionKey);
  	    var tyre = slot && slot.TyreObjectId ? findTyre(slot.TyreObjectId): null;
  	    var updatedTyre;

  	    if (!slot || !slot.TyreObjectId || !tyre) {
  	      alertSafe("The selected fitted tyre could not be found.");
  	      return;
  	    }

  	    if (odometerNumber === null) {
  	      alertSafe("Enter a valid vehicle odometer reading before saving.");
  	      return;
  	    }

  	    updatedTyre = makeTyreRemoved(tyre, slot, destination, odometer, notes);

  	    setButtonBusy(button, true, "Save Removal");

  	    clearSlot(slot);

  	    appendTyreMovementRecord(
  	      tyreMovementRecord(
  	        "Removed",
  	        positionKey,
  	        "",
  	        tyre,
  	        odometer,
  	        notes,
  	        destinationMeta(destination).label
  	      )
  	    );

  	    return saveTyresSequentially([updatedTyre])
  	    .then(function () {
  	      return saveVehicleWithTPositions(state.sourceVehicle, tPositions);
  	    })
  	    .then(function () {
  	      closeFloatingPopup("vehmanRemovePopup");

  	      state.actionMode = "";
  	      state.tapSource = null;
  	      state.dragSource = null;
  	      resetDraft();

  	      state.actionMessage = "Tyre removed and vehicle layout saved.";
  	      state.actionError = false;

  	      setMessage(state.actionMessage, false);
  	      renderActiveTab();
  	    })
  	    .catch(function (error) {
  	      console.warn("VEH-MAN: removal save failed", error);

  	      setButtonBusy(button, false, "Save Removal");

  	      state.actionMessage = error && error.message
  	      ? error.message: "Could not save tyre removal.";
  	      state.actionError = true;

  	      setMessage(state.actionMessage, true);
  	      showStatus();
  	    });
  	  }

  	  // ===============================================================
  	  // REPORT PRINTING
  	  // ===============================================================
  	  function reportRowsHtml(rows) {
  	    if (!rows.length) {
  	      return "<tr><td colspan=\"5\" style=\"padding:8px;border:1px solid #ddd;color:#777;\">No tyre movements.</td></tr>";
  	    }

  	    return rows.map(function (row, index) {
  	      return ""
  	      + "<tr>"
  	      + "  <td style=\"padding:7px;border:1px solid #ddd;text-align:center;\">" + (index + 1) + "</td>"
  	      + "  <td style=\"padding:7px;border:1px solid #ddd;\">" + escapeHtml(row.Type || "") + "</td>"
  	      + "  <td style=\"padding:7px;border:1px solid #ddd;\">" + escapeHtml(row.FromLabel || row.FromPosition || "Warehouse") + "</td>"
  	      + "  <td style=\"padding:7px;border:1px solid #ddd;\">" + escapeHtml(row.ToLabel || row.ToPosition || "Warehouse") + "</td>"
  	      + "  <td style=\"padding:7px;border:1px solid #ddd;\">" + escapeHtml(row.TyreLabel || "") + "</td>"
  	      + "</tr>";
  	    }).join("");
  	  }

  	  function movementReportHtml(title, subtitle, rows, odometer, notes) {
  	    var generatedAt = new Date().toLocaleString();
  	    var logoHtml = cleanSvgLogoHtml();

  	    return ""
  	    + "<div style=\"font-family:Arial,sans-serif;color:#111;padding:20px 22px;\">"
  	    + "  <div style=\"display:flex;justify-content:space-between;align-items:flex-start;gap:18px;border-bottom:2px solid #CC6633;padding-bottom:10px;margin-bottom:14px;\">"
  	    + "    <div>"
  	    + "      <h2 style=\"margin:0 0 5px;font-size:22px;color:#111;\">" + escapeHtml(title) + "</h2>"
  	    + "      <div style=\"font-size:12px;color:#555;\">Vehicle: " + escapeHtml(vehicleTitle(state.sourceVehicle)) + "</div>"
  	    + "      <div style=\"font-size:12px;color:#555;\">Generated: " + escapeHtml(generatedAt) + "</div>"
  	    + "      <div style=\"font-size:12px;color:#777;margin-top:2px;\">" + escapeHtml(subtitle || "") + "</div>"
  	    + "    </div>"
  	    + "    <div style=\"min-width:160px;text-align:right;display:flex;justify-content:flex-end;align-items:flex-start;\">"
  	    + (logoHtml || "<div style=\"font-size:12px;color:#555;\">Vehicle Manager</div>")
  	    + "    </div>"
  	    + "  </div>"

  	    + "  <div style=\"display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:12px;font-size:12px;\">"
  	    + "    <div style=\"border:1px solid #ddd;padding:8px;\"><strong>Odometer:</strong> " + escapeHtml(odometer || "—") + "</div>"
  	    + "    <div style=\"border:1px solid #ddd;padding:8px;\"><strong>Movement Count:</strong> " + rows.length + "</div>"
  	    + "  </div>"

  	    + "  <table style=\"width:100%;border-collapse:collapse;font-size:12px;\">"
  	    + "    <thead>"
  	    + "      <tr style=\"background:#f1f1f1;\">"
  	    + "        <th style=\"padding:7px;border:1px solid #ddd;text-align:center;\">#</th>"
  	    + "        <th style=\"padding:7px;border:1px solid #ddd;text-align:left;\">Type</th>"
  	    + "        <th style=\"padding:7px;border:1px solid #ddd;text-align:left;\">From</th>"
  	    + "        <th style=\"padding:7px;border:1px solid #ddd;text-align:left;\">To</th>"
  	    + "        <th style=\"padding:7px;border:1px solid #ddd;text-align:left;\">Tyre</th>"
  	    + "      </tr>"
  	    + "    </thead>"
  	    + "    <tbody>"
  	    + reportRowsHtml(rows)
  	    + "    </tbody>"
  	    + "  </table>"

  	    + "  <div style=\"margin-top:12px;border:1px solid #ddd;padding:8px;font-size:12px;\"><strong>Notes:</strong><br>" + escapeHtml(notes || "—") + "</div>"
  	    + "</div>";
  	  }

  	  function printHtmlInHiddenFrame(title, html) {
  	    var frame;
  	    var doc;

  	    if (!DocumentSafe || !DocumentSafe.body) {
  	      alertSafe("Printing is unavailable in this browser.");
  	      return;
  	    }

  	    frame = DocumentSafe.createElement("iframe");
  	    frame.style.position = "fixed";
  	    frame.style.right = "0";
  	    frame.style.bottom = "0";
  	    frame.style.width = "0";
  	    frame.style.height = "0";
  	    frame.style.border = "0";
  	    frame.style.opacity = "0";
  	    frame.style.pointerEvents = "none";

  	    DocumentSafe.body.appendChild(frame);

  	    doc = frame.contentWindow.document;
  	    doc.open();
  	    doc.write("<!doctype html>");
  	    doc.write("<html>");
  	    doc.write("<head>");
  	    doc.write("  <meta charset=\"utf-8\">");
  	    doc.write("  <title>" + escapeHtml(title) + "</title>");
  	    doc.write("  <style>");
  	    doc.write("    @page{size:A4 landscape;margin:10mm;}");
  	    doc.write("    html,body{margin:0;padding:0;background:#fff;color:#000;font-family:Arial,sans-serif;}");
  	    doc.write("    *{box-sizing:border-box;}");
  	    doc.write("    table{width:100%;border-collapse:collapse;page-break-inside:auto;}");
  	    doc.write("    th,td{page-break-inside:avoid;}");
  	    doc.write("    tr{page-break-inside:avoid;page-break-after:auto;}");
  	    doc.write("    h2{page-break-after:avoid;}");
  	    doc.write("    .vehman-logo-img,.vehman-logo-svg{height:48px;width:auto;max-width:190px;object-fit:contain;display:block;}");
  	    doc.write("    @media print{body{margin:0;}button{display:none!important;}}");
  	    doc.write("  </style>");
  	    doc.write("</head>");
  	    doc.write("<body>");
  	    doc.write(html);
  	    doc.write("</body>");
  	    doc.write("</html>");
  	    doc.close();

  	    setTimeout(function () {
  	      try {
  	        frame.contentWindow.focus();
  	        frame.contentWindow.print();

  	        setTimeout(function () {
  	          if (frame && frame.parentNode) {
  	            frame.parentNode.removeChild(frame);
  	          }
  	        },
  	          1000);
  	      } catch (error) {
  	        console.warn("VEH-MAN: print failed",
  	          error);
  	        alertSafe("Could not print the report.");
  	      }
  	    }, 250);
  	  }

  	  function printAllocationPlanReportFromPopup() {
  	    var rows = plannedMovementRows();
  	    var odometer = readValue("tyreActionOdometer");
  	    var notes = readValue("tyreActionNotes");

  	    if (!rows.length) {
  	      alertSafe("No allocation changes to print.");
  	      return;
  	    }

  	    printHtmlInHiddenFrame(
  	      "Tyre Allocation Report",
  	      movementReportHtml("Tyre Allocation Report", "Allocation Report", rows, odometer, notes)
  	    );
  	  }

  	  function printRotationPlanReportFromPopup() {
  	    var rows = plannedMovementRows();
  	    var odometer = readValue("tyreActionOdometer");
  	    var notes = readValue("tyreActionNotes");

  	    if (!rows.length) {
  	      alertSafe("No rotation changes to print.");
  	      return;
  	    }

  	    printHtmlInHiddenFrame(
  	      "Tyre Rotation Report",
  	      movementReportHtml("Tyre Rotation Report", "Rotation / Swap Report", rows, odometer, notes)
  	    );
  	  }

  	  // ===============================================================
  	  // GENERIC CAPTURE SAVE EVENTS
  	  // ===============================================================
  	  function saveOdometerRecord(button) {
  	    var odometer = readValue("vehmanOdometerValue");
  	    var notes = readValue("vehmanOdometerNotes");
  	    var value = numberOrNull(odometer);
  	    var records;

  	    if (value === null) {
  	      alertSafe("Enter a valid odometer value.");
  	      return;
  	    }

  	    if (!state.sourceVehicle.Data) {
  	      state.sourceVehicle.Data = {};
  	    }

  	    if (!state.sourceVehicle.Data.Vehicle) {
  	      state.sourceVehicle.Data.Vehicle = {};
  	    }

  	    state.sourceVehicle.Odometer = value;
  	    state.sourceVehicle.Data.Vehicle.Odometer = value;

  	    records = ensureArrayPath(state.sourceVehicle, ["Data", "Vehicle", "OdometerRecords"]);

  	    records.push({
  	      Date: new Date().toISOString(),
  	      Odometer: value,
  	      Notes: notes || "",
  	      CapturedBy: "Vehicle Manager"
  	    });

  	    setButtonBusy(button, true, "Save Odometer");

  	    return saveVehicleOnly(state.sourceVehicle)
  	    .then(function () {
  	      setMessage("Odometer saved.", false);
  	      clearInputs(["vehmanOdometerValue", "vehmanOdometerNotes"]);
  	      renderActiveTab();
  	    })
  	    .catch(function (error) {
  	      console.warn("VEH-MAN: odometer save failed", error);
  	      setButtonBusy(button, false, "Save Odometer");
  	      setMessage(error && error.message ? error.message: "Could not save odometer.", true);
  	      showStatus();
  	    });
  	  }

  	  function saveServiceRecord(button) {
  	    var records = ensureArrayPath(state.sourceVehicle, ["Data", "Service", "ServiceRecords"]);

  	    records.push({
  	      Date: readValue("vehmanServiceDate") || new Date().toISOString(),
  	      Odometer: readValue("vehmanServiceOdometer"),
  	      Type: readValue("vehmanServiceType"),
  	      Provider: readValue("vehmanServiceProvider"),
  	      Cost: readValue("vehmanServiceCost"),
  	      Notes: readValue("vehmanServiceNotes"),
  	      CapturedBy: "Vehicle Manager"
  	    });

  	    setButtonBusy(button, true, "Save Service");

  	    return saveVehicleOnly(state.sourceVehicle)
  	    .then(function () {
  	      setMessage("Service record saved.", false);
  	      clearInputs([
  	        "vehmanServiceDate",
  	        "vehmanServiceOdometer",
  	        "vehmanServiceType",
  	        "vehmanServiceProvider",
  	        "vehmanServiceCost",
  	        "vehmanServiceNotes"
  	      ]);
  	      renderActiveTab();
  	    })
  	    .catch(function (error) {
  	      console.warn("VEH-MAN: service save failed", error);
  	      setButtonBusy(button, false, "Save Service");
  	      setMessage(error && error.message ? error.message: "Could not save service record.", true);
  	      showStatus();
  	    });
  	  }

  	  function saveMaintenanceRecord(button) {
  	    var records = ensureArrayPath(state.sourceVehicle, ["Data", "Maintenance", "MaintenanceRecords"]);

  	    records.push({
  	      Date: readValue("vehmanMaintenanceDate") || new Date().toISOString(),
  	      Odometer: readValue("vehmanMaintenanceOdometer"),
  	      Type: readValue("vehmanMaintenanceType"),
  	      Provider: readValue("vehmanMaintenanceProvider"),
  	      Cost: readValue("vehmanMaintenanceCost"),
  	      Notes: readValue("vehmanMaintenanceNotes"),
  	      CapturedBy: "Vehicle Manager"
  	    });

  	    setButtonBusy(button, true, "Save Maintenance");

  	    return saveVehicleOnly(state.sourceVehicle)
  	    .then(function () {
  	      setMessage("Maintenance record saved.", false);
  	      clearInputs([
  	        "vehmanMaintenanceDate",
  	        "vehmanMaintenanceOdometer",
  	        "vehmanMaintenanceType",
  	        "vehmanMaintenanceProvider",
  	        "vehmanMaintenanceCost",
  	        "vehmanMaintenanceNotes"
  	      ]);
  	      renderActiveTab();
  	    })
  	    .catch(function (error) {
  	      console.warn("VEH-MAN: maintenance save failed", error);
  	      setButtonBusy(button, false, "Save Maintenance");
  	      setMessage(error && error.message ? error.message: "Could not save maintenance record.", true);
  	      showStatus();
  	    });
  	  }

  	  function saveComplianceRecord(button) {
  	    var records = ensureArrayPath(state.sourceVehicle, ["Data", "Compliance", "ComplianceRecords"]);

  	    records.push({
  	      Date: readValue("vehmanComplianceDate") || new Date().toISOString(),
  	      Type: readValue("vehmanComplianceType"),
  	      ExpiryDate: readValue("vehmanComplianceExpiry"),
  	      Reference: readValue("vehmanComplianceReference"),
  	      Notes: readValue("vehmanComplianceNotes"),
  	      CapturedBy: "Vehicle Manager"
  	    });

  	    setButtonBusy(button, true, "Save Compliance");

  	    return saveVehicleOnly(state.sourceVehicle)
  	    .then(function () {
  	      setMessage("Compliance record saved.", false);
  	      clearInputs([
  	        "vehmanComplianceDate",
  	        "vehmanComplianceType",
  	        "vehmanComplianceExpiry",
  	        "vehmanComplianceReference",
  	        "vehmanComplianceNotes"
  	      ]);
  	      renderActiveTab();
  	    })
  	    .catch(function (error) {
  	      console.warn("VEH-MAN: compliance save failed", error);
  	      setButtonBusy(button, false, "Save Compliance");
  	      setMessage(error && error.message ? error.message: "Could not save compliance record.", true);
  	      showStatus();
  	    });
  	  }

  	  function wireGenericCaptureEvents() {
  	    var odometerBtn = DocumentSafe.getElementById("vehmanSaveOdometerBtn");
  	    var serviceBtn = DocumentSafe.getElementById("vehmanSaveServiceBtn");
  	    var maintenanceBtn = DocumentSafe.getElementById("vehmanSaveMaintenanceBtn");
  	    var complianceBtn = DocumentSafe.getElementById("vehmanSaveComplianceBtn");

  	    if (odometerBtn) {
  	      odometerBtn.onclick = function () {
  	        saveOdometerRecord(odometerBtn);
  	      };
  	    }

  	    if (serviceBtn) {
  	      serviceBtn.onclick = function () {
  	        saveServiceRecord(serviceBtn);
  	      };
  	    }

  	    if (maintenanceBtn) {
  	      maintenanceBtn.onclick = function () {
  	        saveMaintenanceRecord(maintenanceBtn);
  	      };
  	    }

  	    if (complianceBtn) {
  	      complianceBtn.onclick = function () {
  	        saveComplianceRecord(complianceBtn);
  	      };
  	    }
  	  }

  	  // ===============================================================
  	  // STARTUP
  	  // ===============================================================
  	  collectTyres();
  	  renderManager();

  	  loadTyres().then(function () {
  	    if (state.root && state.activeTab === "Tyres") {
  	      renderActiveTab();
  	    }
  	  });

  	  return true;
  	}

  	vehicleManager((function () {
  	  var inputArgs = {};

  	  if (typeof args !== "undefined" && args && typeof args === "object") {
  	    Object.keys(args).forEach(function (key) {
  	      inputArgs[key] = args[key];
  	    });
  	  }

  	  if (!inputArgs.Vehicle && typeof Vehicle !== "undefined") {
  	    inputArgs.Vehicle = Vehicle;
  	  }

  	  if (!inputArgs.Vehicle && typeof vehicle !== "undefined") {
  	    inputArgs.Vehicle = vehicle;
  	  }

  	  if (!inputArgs.Vehicle && typeof Vehichle !== "undefined") {
  	    inputArgs.Vehicle = Vehichle;
  	  }

  	  if (!inputArgs.Vehicle && typeof Vehchle !== "undefined") {
  	    inputArgs.Vehicle = Vehchle;
  	  }

  	  if (!inputArgs.Vehicle && typeof Item !== "undefined") {
  	    inputArgs.Vehicle = Item;
  	  }

  	  if (!inputArgs.Vehicle && typeof item !== "undefined") {
  	    inputArgs.Vehicle = item;
  	  }

  	  if (!inputArgs.Vehicle && typeof dataItem !== "undefined") {
  	    inputArgs.Vehicle = dataItem;
  	  }

  	  if (!inputArgs.App && typeof App !== "undefined") {
  	    inputArgs.App = App;
  	  }

  	  if (!inputArgs.SVG && typeof SVG !== "undefined") {
  	    inputArgs.SVG = SVG;
  	  }

  	  if (!inputArgs.Backendless && typeof Backendless !== "undefined") {
  	    inputArgs.Backendless = Backendless;
  	  }

  	  return inputArgs;
  	})());
  })(___arguments.context.appData, 'data:image/png;base64,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', ___arguments.context.getComponentDataStoreByUid('49f8b7b8243c2d28865a64dbfbe6c10c'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/e7a8280e08c88ac255d85208b4d8808b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Tractors, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Tractors2() {
  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Tractors, k);
    }
  }
  return Tractors
}

/**
 * Describe this function...
 */
async function Menu_Closers() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e487ca4eaeecb57fb48a992d27843ff', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fc90fe85fb3fdb851e842383a2cbe6d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb589f58823489b55d73a8c86512ba2a', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fd81dee1f1852b56f34b68de1d3d46e', false);

  } catch (error) {
    console.log(error);

  }
}


  await Menu_Closers();
  await (async function(App, Tractors, Hub, SVG) {
  	(function companyTyreManager(rawArgs, directApp, directTractors, directHub, directBackendless, directSvg) {
  	  console.log("COMPANY-TYRES: INIT company tyre manager full rewrite", {
  	    rawArgs: rawArgs,
  	    directApp: !!directApp,
  	    directTractors: Array.isArray(directTractors) ? directTractors.length: 0,
  	    directHub: !!directHub,
  	    directBackendless: !!directBackendless,
  	    directSvg: !!directSvg
  	  });

  	  rawArgs = rawArgs && typeof rawArgs === "object" ? rawArgs: {};

  	  var WindowSafe = typeof window !== "undefined" ? window: null;
  	  var DocumentSafe = typeof document !== "undefined" ? document: null;

  	  var AppSafe = rawArgs.App || directApp || (typeof App !== "undefined" ? App: null);
  	  var BackendlessSafe = rawArgs.Backendless || directBackendless || (typeof Backendless !== "undefined" ? Backendless: null);
  	  var SvgSafe = rawArgs.SVG || rawArgs.svg || directSvg || (typeof SVG !== "undefined" ? SVG: "");

  	  var TABLE_TYRES = "Tyres";
  	  var ROOT_ID = "companyTyreManagerRoot";

  	  var DEFAULT_FLEET_PREFIX = "FLE TY";
  	  var DEFAULT_FLEET_PADDING = 5;

  	  var TYRE_STATUS = {
  	    OK: "All In Order",
  	    RETREAD: "In For Retread",
  	    SCRAPPED: "Scrapped",
  	    STOLEN: "Stolen"
  	  };

  	  var STAGES = ["New", "Cap1", "Cap2", "Cap3"];
  	  var TYPES = ["Steer", "Drive", "Trailer", "Spare"];

  	  if (!DocumentSafe || !DocumentSafe.body) {
  	    console.warn("COMPANY-TYRES: document/body missing");
  	    return false;
  	  }

  	  function createOwnRootDiv() {
  	    var root = DocumentSafe.getElementById(ROOT_ID);

  	    if (!root) {
  	      root = DocumentSafe.createElement("div");
  	      root.id = ROOT_ID;
  	      DocumentSafe.body.appendChild(root);
  	    }

  	    root.removeAttribute("style");

  	    root.style.position = "fixed";
  	    root.style.top = "50px";
  	    root.style.right = "200px";
  	    root.style.bottom = "0";
  	    root.style.left = "0";
  	    root.style.zIndex = "99999";
  	    root.style.overflow = "hidden";
  	    root.style.boxSizing = "border-box";
  	    root.style.background = "#0f0f0f";
  	    root.style.padding = "0";
  	    root.style.margin = "0";
  	    root.style.display = "flex";
  	    root.style.justifyContent = "stretch";
  	    root.style.alignItems = "stretch";

  	    return root;
  	  }

  	  var hubEl = createOwnRootDiv();

  	  function escapeHtml(value) {
  	    return String(value == null ? "": value)
  	    .replace(/&/g, "&amp;")
  	    .replace(/</g, "&lt;")
  	    .replace(/>/g, "&gt;")
  	    .replace(/\"/g, "&quot;")
  	    .replace(/'/g, "&#39;");
  	  }

  	  function clean(value) {
  	    return String(value == null ? "": value).trim();
  	  }

  	  function reportLogoHtml() {
  	    var svg = clean(SvgSafe);
  	    var cleaned;

  	    if (!svg) {
  	      return "";
  	    }

  	    if (svg.indexOf("data:image") === 0) {
  	      return "<img class=\"ctm-report-logo\" src=\"" + escapeHtml(svg) + "\" alt=\"Report Logo\">";
  	    }

  	    if (svg.indexOf("<svg") === 0) {
  	      cleaned = svg
  	      .replace(/<script[\s\S]*?<\/script>/gi, "")
  	      .replace(/<svg(?![^>]*preserveAspectRatio)/i, "<svg preserveAspectRatio=\"xMidYMid meet\"")
  	      .replace(/<svg([^>]*?)>/i, "<svg$1 class=\"ctm-report-logo-svg\">");

  	      return "<div class=\"ctm-report-logo-inline\">" + cleaned + "</div>";
  	    }

  	    return "";
  	  }

  	  function arr(value) {
  	    return Array.isArray(value) ? value: [];
  	  }

  	  function clone(value) {
  	    return JSON.parse(JSON.stringify(value || {}));
  	  }

  	  function numberOrNull(value) {
  	    if (value === null || value === undefined || value === "") {
  	      return null;
  	    }

  	    var number = Number(value);

  	    return isFinite(number) ? number: null;
  	  }

  	  function nowIso() {
  	    return new Date().toISOString();
  	  }

  	  function alertSafe(message) {
  	    if (WindowSafe && typeof WindowSafe.alert === "function") {
  	      WindowSafe.alert(message);
  	      return;
  	    }

  	    console.warn(message);
  	  }

  	  function confirmSafe(message) {
  	    if (WindowSafe && typeof WindowSafe.confirm === "function") {
  	      return WindowSafe.confirm(message);
  	    }

  	    return true;
  	  }

  	  function getFirst(source, names) {
  	    var i;

  	    if (!source || typeof source !== "object") {
  	      return "";
  	    }

  	    for (i = 0; i < names.length; i++) {
  	      if (
  	        Object.prototype.hasOwnProperty.call(source, names[i]) &&
  	        source[names[i]] !== null &&
  	        source[names[i]] !== undefined
  	      ) {
  	        return source[names[i]];
  	      }
  	    }

  	    return "";
  	  }

  	  function readValue(id) {
  	    var el = DocumentSafe.getElementById(id);

  	    if (!el) {
  	      return "";
  	    }

  	    return clean(el.value);
  	  }

  	  function parseJson(raw, fallback) {
  	    if (raw === null || raw === undefined || raw === "") {
  	      return clone(fallback);
  	    }

  	    if (typeof raw === "object") {
  	      return clone(raw);
  	    }

  	    try {
  	      return JSON.parse(raw);
  	    } catch (error) {
  	      console.warn("COMPANY-TYRES: JSON parse failed", error, raw);
  	      return clone(fallback);
  	    }
  	  }

  	  function escapeRegex(value) {
  	    return String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  	  }

  	  function zeroPad(number, width) {
  	    var text = String(Math.max(0, Number(number) || 0));

  	    while (text.length < width) {
  	      text = "0" + text;
  	    }

  	    return text;
  	  }

  	  function normaliseFleetPrefix(prefix) {
  	    return clean(prefix || DEFAULT_FLEET_PREFIX).replace(/\s+/g, " ");
  	  }

  	  function formatFleetNumber(prefix, number) {
  	    return normaliseFleetPrefix(prefix) + " " + zeroPad(number, DEFAULT_FLEET_PADDING);
  	  }

  	  function companyObjectId(company) {
  	    return clean(getFirst(company, ["objectId", "ObjectId", "objectID", "id"]));
  	  }

  	  function companyName(company) {
  	    return clean(getFirst(company, [
  	      "Name",
  	      "Company_Name",
  	      "CompanyName",
  	      "Trading_Name",
  	      "TradingName",
  	      "Name_Company"
  	    ])) || companyObjectId(company) || "Company";
  	  }

  	  function companyClassName(company) {
  	    return clean(getFirst(company, ["___class", "__class", "className"])) || "Companies";
  	  }

  	  function collectCompanies() {
  	    var companies = [];
  	    var seen = {};

  	    try {
  	      arr(AppSafe && AppSafe.User && AppSafe.User.Companies).forEach(function (company) {
  	        var id = companyObjectId(company);

  	        if (!id) {
  	          return;
  	        }

  	        if (!seen[id]) {
  	          seen[id] = true;

  	          companies.push({
  	            id: id,
  	            name: companyName(company),
  	            className: companyClassName(company),
  	            row: company
  	          });
  	        }
  	      });
  	    } catch (error) {
  	      console.warn("COMPANY-TYRES: company collection failed",
  	        error);
  	    }

  	    return companies;
  	  }

  	  var companies = collectCompanies();

  	  function defaultCompanyId() {
  	    return companies.length ? companies[0].id: "";
  	  }

  	  function selectedCompany() {
  	    var i;

  	    for (i = 0; i < companies.length; i++) {
  	      if (companies[i].id === state.companyId) {
  	        return companies[i];
  	      }
  	    }

  	    return null;
  	  }

  	  function canAccessCompanyId(companyId) {
  	    var i;

  	    for (i = 0; i < companies.length; i++) {
  	      if (companies[i].id === companyId) {
  	        return true;
  	      }
  	    }

  	    return false;
  	  }

  	  function tyreObjectId(tyre) {
  	    return clean(getFirst(tyre, ["objectId", "ObjectId", "objectID", "id"]));
  	  }

  	  function tyreNumber(tyre) {
  	    return clean(getFirst(tyre, [
  	      "ID",
  	      "FID",
  	      "Tyre_Number",
  	      "TyreNumber",
  	      "Serial_Number",
  	      "SerialNumber"
  	    ]));
  	  }

  	  function tyreSerial(tyre) {
  	    return clean(getFirst(tyre, ["Serial_Number", "SerialNumber", "Serial"]));
  	  }

  	  function tyreMake(tyre) {
  	    return clean(getFirst(tyre, ["Make", "Tyre_Brand", "Brand"]));
  	  }

  	  function tyreModel(tyre) {
  	    return clean(getFirst(tyre, ["Model", "Pattern"]));
  	  }

  	  function tyreSize(tyre) {
  	    return clean(getFirst(tyre, ["Size"]));
  	  }

  	  function tyreType(tyre) {
  	    return clean(getFirst(tyre, ["Type"]));
  	  }

  	  function tyreStatus(tyre) {
  	    return clean(getFirst(tyre, ["Status"])) || TYRE_STATUS.OK;
  	  }

  	  function tyreStage(tyre) {
  	    return clean(getFirst(tyre, ["Current_Stage"])) || "New";
  	  }

  	  function tyreName(tyre) {
  	    return [
  	      tyreNumber(tyre),
  	      tyreSerial(tyre),
  	      tyreMake(tyre),
  	      tyreModel(tyre),
  	      tyreSize(tyre)
  	    ].filter(Boolean).join(" - ") || tyreObjectId(tyre) || "Tyre";
  	  }

  	  function tyreIsFitted(tyre) {
  	    return !!clean(tyre && tyre.Vehicle_ObjectId);
  	  }

  	  function tyreIsWarehouse(tyre) {
  	    return !tyreIsFitted(tyre) && tyreStatus(tyre) === TYRE_STATUS.OK;
  	  }

  	  function tyreRemainingMileage(tyre) {
  	    var direct = numberOrNull(getFirst(tyre, [
  	      "Remaining_Mileage",
  	      "RemainingMileage",
  	      "Remaining_KM",
  	      "RemainingKm"
  	    ]));
  	    var expected;
  	    var current;

  	    if (direct !== null) {
  	      return direct;
  	    }

  	    expected = numberOrNull(getFirst(tyre, [
  	      "Expected_Mileage",
  	      "ExpectedMileage"
  	    ]));

  	    current = numberOrNull(getFirst(tyre, [
  	      "Current_Mileage",
  	      "CurrentMileage"
  	    ]));

  	    if (expected !== null && current !== null) {
  	      return Math.max(0, expected - current);
  	    }

  	    return null;
  	  }

  	  function formatMileage(value) {
  	    var n = numberOrNull(value);

  	    if (n === null) {
  	      return "—";
  	    }

  	    return Math.round(n).toLocaleString() + " km";
  	  }

  	  function sortText(value) {
  	    return clean(value).toLowerCase();
  	  }

  	  function sortValueForTyre(tyre, key) {
  	    if (key === "tyre") {
  	      return sortText(tyreNumber(tyre) || tyreObjectId(tyre));
  	    }

  	    if (key === "remainingMileage") {
  	      return tyreRemainingMileage(tyre);
  	    }

  	    if (key === "type") {
  	      return sortText(tyreType(tyre));
  	    }

  	    if (key === "stage") {
  	      return sortText(tyreStage(tyre));
  	    }

  	    if (key === "status") {
  	      return sortText(tyreStatus(tyre));
  	    }

  	    if (key === "warning") {
  	      return sortText(mileageWarningText(tyre));
  	    }

  	    if (key === "location") {
  	      return sortText(locationText(tyre) + " " + locationSubText(tyre));
  	    }
  	    return sortText(tyreName(tyre));
  	  }

  	  function compareSortValues(a, b, key, dir) {
  	    var av = sortValueForTyre(a, key);
  	    var bv = sortValueForTyre(b, key);
  	    var direction = dir === "desc" ? -1: 1;
  	    var aMissing = av === null || av === undefined || av === "";
  	    var bMissing = bv === null || bv === undefined || bv === "";

  	    if (aMissing && bMissing) {
  	      return tyreName(a).localeCompare(tyreName(b));
  	    }

  	    if (aMissing) {
  	      return 1;
  	    }

  	    if (bMissing) {
  	      return -1;
  	    }

  	    if (typeof av === "number" || typeof bv === "number") {
  	      av = Number(av) || 0;
  	      bv = Number(bv) || 0;

  	      if (av < bv) return -1 * direction;
  	      if (av > bv) return 1 * direction;

  	      return tyreName(a).localeCompare(tyreName(b));
  	    }

  	    return String(av).localeCompare(String(bv)) * direction || tyreName(a).localeCompare(tyreName(b));
  	  }

  	  function sortHeaderHtml(key, label) {
  	    var active = state.sortKey === key;
  	    var arrow = active ? (state.sortDir === "asc" ? " ▲": " ▼"): "";

  	    return ""
  	    + "<button type=\"button\" class=\"ctm-sort-head\" data-sort-key=\"" + escapeHtml(key) + "\">"
  	    + escapeHtml(label + arrow)
  	    + "</button>";
  	  }

  	  function tyreSearchBlob(tyre) {
  	    return [
  	      tyreObjectId(tyre),
  	      tyreNumber(tyre),
  	      tyreSerial(tyre),
  	      tyreMake(tyre),
  	      tyreModel(tyre),
  	      tyreSize(tyre),
  	      tyreType(tyre),
  	      tyreStage(tyre),
  	      tyreStatus(tyre),
  	      clean(tyre && tyre.Vehicle_ID),
  	      clean(tyre && tyre.Current_Position),
  	      clean(tyre && tyre.Company_ID),
  	      clean(tyre && tyre.__CompanyName)
  	    ].join(" ").toLowerCase();
  	  }

  	  function clampTyreValue(value, min, max, fallback) {
  	    var number = Number(value);

  	    if (!isFinite(number)) {
  	      number = fallback;
  	    }

  	    return Math.max(min, Math.min(max, number));
  	  }

  	  function tyreLife(tyre) {
  	    var direct;
  	    var currentMileage;
  	    var expectedMileage;

  	    if (!tyre) {
  	      return null;
  	    }

  	    if (tyreStatus(tyre) === TYRE_STATUS.SCRAPPED) {
  	      return 0;
  	    }

  	    direct = numberOrNull(tyre.Current_Life);

  	    if (direct !== null) {
  	      return clampTyreValue(direct, 0, 100, 0);
  	    }

  	    currentMileage = numberOrNull(tyre.Current_Mileage);
  	    expectedMileage = numberOrNull(tyre.Expected_Mileage);

  	    if (currentMileage !== null && expectedMileage !== null && expectedMileage > 0) {
  	      return clampTyreValue(100 - ((currentMileage / expectedMileage) * 100), 0, 100, 0);
  	    }

  	    if (tyreStatus(tyre) === TYRE_STATUS.OK && tyreStage(tyre) === "New") {
  	      return 100;
  	    }

  	    return null;
  	  }

  	  function tyreVisualColor(tyre) {
  	    var life = tyreLife(tyre);

  	    if (tyreStatus(tyre) === TYRE_STATUS.SCRAPPED) return "#7b3935";
  	    if (tyreStatus(tyre) === TYRE_STATUS.RETREAD) return "#8a5a33";
  	    if (tyreStatus(tyre) === TYRE_STATUS.STOLEN) return "#4e455f";

  	    if (life === null) return "#6b7280";
  	    if (life <= 0) return "#111827";
  	    if (life < 20) return "#ff2b1a";
  	    if (life < 40) return "#ff8a00";
  	    if (life < 60) return "#ffd633";
  	    if (life < 80) return "#a6ff33";

  	    return "#39ff14";
  	  }

  	  function tyreLifeText(tyre) {
  	    var life = tyreLife(tyre);

  	    if (life === null) {
  	      return "Life not set";
  	    }

  	    return Math.round(life) + "% life";
  	  }

  	  function tyreGraphicHtml(tyre, variant) {
  	    var isLarge = variant === "large";
  	    var color = tyreVisualColor(tyre);
  	    var number = tyreNumber(tyre) || "Tyre";
  	    var title = [
  	      number,
  	      tyreMake(tyre),
  	      tyreModel(tyre),
  	      tyreSize(tyre),
  	      tyreStage(tyre),
  	      tyreStatus(tyre),
  	      tyreLifeText(tyre)
  	    ].filter(Boolean).join(" - ");

  	    return ""
  	    + "<div class=\"ctm-tyre-visual-wrap" + (isLarge ? " ctm-tyre-visual-large": "") + "\" title=\"" + escapeHtml(title) + "\">"
  	    + "  <div class=\"ctm-tyre-graphic\" style=\"--ctm-tyre-color:" + escapeHtml(color) + ";\"></div>"
  	    + "  <div class=\"ctm-tyre-visual-text\">"
  	    + "    <div>" + escapeHtml(number) + "</div>"
  	    + "    <div>" + escapeHtml(tyreLifeText(tyre)) + "</div>"
  	    + "  </div>"
  	    + "</div>";
  	  }

  	  function parseFleetSequence(value, prefix) {
  	    var cleanPrefix = normaliseFleetPrefix(prefix);
  	    var text = clean(value).replace(/\s+/g, " ");
  	    var re;
  	    var match;

  	    if (!text) {
  	      return null;
  	    }

  	    re = new RegExp("^" + escapeRegex(cleanPrefix) + "\\s+(\\d+)$", "i");
  	    match = text.match(re);

  	    if (!match) {
  	      return null;
  	    }

  	    return Number(match[1]);
  	  }

  	  function nextStage(stage) {
  	    var index = STAGES.indexOf(clean(stage) || "New");

  	    if (index === -1) {
  	      return "Cap1";
  	    }

  	    if (index >= STAGES.length - 1) {
  	      return "";
  	    }

  	    return STAGES[index + 1];
  	  }

  	  function clearVehicleFields(tyre) {
  	    tyre.Vehicle_ObjectId = null;
  	    tyre.Vehicle_ID = null;
  	    tyre.Vehicle_Type = null;
  	    tyre.Current_Position = null;
  	    tyre.Current_Axle_Type = null;
  	    tyre.Current_Wear_Rate = null;
  	    tyre.Fitted_Date = null;
  	    tyre.Fitted_Odometer = null;
  	    return tyre;
  	  }

  	  function blankHistoryStage(active) {
  	    return {
  	      CPK: 0,
  	      Cost: 0,
  	      Ended: "",
  	      Notes: "",
  	      Active: !!active,
  	      Events: [],
  	      Status: active ? "Active": "Not Started",
  	      Started: active ? nowIso(): "",
  	      End_Mileage: 0,
  	      Mileage_Done: 0,
  	      Start_Mileage: 0,
  	      Mileage_Expected: 0
  	    };
  	  }

  	  function defaultHistory(tyre) {
  	    var stage = tyreStage(tyre);

  	    return {
  	      New: blankHistoryStage(stage === "New"),
  	      Cap1: blankHistoryStage(stage === "Cap1"),
  	      Cap2: blankHistoryStage(stage === "Cap2"),
  	      Cap3: blankHistoryStage(stage === "Cap3"),
  	      Totals: {
  	        Cost_Total: numberOrNull(tyre && tyre.Total_Cost) || 0,
  	        Average_CPK: numberOrNull(tyre && tyre.Total_CPK) || 0,
  	        Mileage_Total: numberOrNull(tyre && tyre.Total_Mileage) || 0,
  	        Total_Life_Stages_Used: 1
  	      },
  	      Current: {
  	        Stage: stage
  	      }
  	    };
  	  }

  	  function normaliseHistory(tyre) {
  	    var fallback = defaultHistory(tyre);
  	    var history = parseJson(tyre && tyre.History, fallback);

  	    STAGES.forEach(function (stage) {
  	      if (!history[stage] || typeof history[stage] !== "object") {
  	        history[stage] = clone(fallback[stage]);
  	      }

  	      if (!Array.isArray(history[stage].Events)) {
  	        history[stage].Events = [];
  	      }
  	    });

  	    if (!history.Totals || typeof history.Totals !== "object") {
  	      history.Totals = clone(fallback.Totals);
  	    }

  	    if (!history.Current || typeof history.Current !== "object") {
  	      history.Current = {
  	        Stage: tyreStage(tyre)
  	      };
  	    }

  	    return history;
  	  }

  	  function applyCostToCurrentStage(tyre, cost) {
  	    var updated = clone(tyre);
  	    var history = normaliseHistory(updated);
  	    var stage = tyreStage(updated);
  	    var safeCost = numberOrNull(cost) || 0;

  	    if (!history[stage] || typeof history[stage] !== "object") {
  	      history[stage] = blankHistoryStage(true);
  	    }

  	    history[stage].Cost = safeCost;
  	    history.Totals.Cost_Total = (numberOrNull(history.Totals.Cost_Total) || 0) + safeCost;

  	    updated.History = history;

  	    return updated;
  	  }

  	  function tyreEvent(type, options) {
  	    options = options || {};

  	    return {
  	      Date: nowIso(),
  	      Type: type,
  	      Vehicle_ObjectId: options.Vehicle_ObjectId || "",
  	      Vehicle_ID: options.Vehicle_ID || "",
  	      FromPosition: options.FromPosition || "",
  	      ToPosition: options.ToPosition || "",
  	      Odometer: options.Odometer || "",
  	      Destination: options.Destination || "",
  	      WearRate: options.WearRate === null || options.WearRate === undefined ? "": options.WearRate,
  	      CapturedBy: "Company Tyre Manager",
  	      Notes: options.Notes || "",
  	      Cost: options.Cost || "",
  	      Retread_From_Stage: options.Retread_From_Stage || "",
  	      Retread_To_Stage: options.Retread_To_Stage || "",
  	      Retread_Cost: options.Retread_Cost || "",
  	      Scrap_Reason: options.Scrap_Reason || "",
  	      Bulk_Create_Count: options.Bulk_Create_Count || "",
  	      Bulk_Create_Batch: options.Bulk_Create_Batch || ""
  	    };
  	  }

  	  function appendHistoryEvent(tyre, event) {
  	    var updated = clone(tyre);
  	    var history = normaliseHistory(updated);
  	    var stage = tyreStage(updated);

  	    if (!history[stage] || typeof history[stage] !== "object") {
  	      history[stage] = blankHistoryStage(true);
  	    }

  	    if (!Array.isArray(history[stage].Events)) {
  	      history[stage].Events = [];
  	    }

  	    history[stage].Events.push(event);

  	    history.Current.Stage = stage;
  	    history.Current.Last_Event_Type = event.Type || "";
  	    history.Current.Last_Event_Date = event.Date || "";
  	    history.Current.Vehicle_ObjectId = updated.Vehicle_ObjectId || "";
  	    history.Current.Vehicle_ID = updated.Vehicle_ID || "";
  	    history.Current.Position = updated.Current_Position || "";
  	    history.Current.Axle_Type = updated.Current_Axle_Type || "";
  	    history.Current.Wear_Rate = updated.Current_Wear_Rate || "";

  	    updated.History = history;

  	    return updated;
  	  }

  	  function currentStageName(tyre) {
  	    return tyreStage(tyre) || "New";
  	  }

  	  function stageEvents(tyre, stage) {
  	    var history = normaliseHistory(tyre);
  	    var stageName = stage || currentStageName(tyre);

  	    if (!history[stageName] || !Array.isArray(history[stageName].Events)) {
  	      return [];
  	    }

  	    return history[stageName].Events;
  	  }

  	  function formatHistoryDate(value) {
  	    var raw = clean(value);
  	    var date;

  	    if (!raw) {
  	      return "—";
  	    }

  	    date = new Date(raw);

  	    if (isNaN(date.getTime())) {
  	      return raw;
  	    }

  	    return date.toLocaleString();
  	  }

  	  function historyDisplayValue(value) {
  	    if (value === null || value === undefined || value === "") {
  	      return "—";
  	    }

  	    if (typeof value === "object") {
  	      try {
  	        return JSON.stringify(value);
  	      } catch (error) {
  	        return String(value);
  	      }
  	    }

  	    return clean(value);
  	  }

  	  function collectTyreHistoryRows(tyre) {
  	    var history = normaliseHistory(tyre);
  	    var rows = [];

  	    STAGES.forEach(function (stage) {
  	      var stageData = history[stage] || {};
  	      var events = Array.isArray(stageData.Events) ? stageData.Events: [];

  	      events.forEach(function (event, index) {
  	        event = event || {};

  	        rows.push({
  	          Key: "h" + rows.length,
  	          Stage: stage,
  	          StageIndex: index,
  	          Date: clean(event.Date),
  	          Type: clean(event.Type) || "Event",
  	          Odometer: historyDisplayValue(event.Odometer),
  	          FromPosition: historyDisplayValue(event.FromPosition),
  	          ToPosition: historyDisplayValue(event.ToPosition),
  	          Destination: historyDisplayValue(event.Destination),
  	          Cost: historyDisplayValue(event.Cost),
  	          Notes: historyDisplayValue(event.Notes),
  	          Event: event
  	        });
  	      });
  	    });

  	    rows.sort(function (a, b) {
  	      var ad = Date.parse(a.Date);
  	      var bd = Date.parse(b.Date);

  	      if (!isNaN(ad) && !isNaN(bd)) {
  	        return bd - ad;
  	      }

  	      if (!isNaN(ad)) {
  	        return -1;
  	      }

  	      if (!isNaN(bd)) {
  	        return 1;
  	      }

  	      return a.Stage.localeCompare(b.Stage) || a.StageIndex - b.StageIndex;
  	    });

  	    rows.forEach(function (row, index) {
  	      row.Key = "h" + index;
  	    });

  	    return rows;
  	  }

  	  function historyEventDetailHtml(row) {
  	    var event = row && row.Event ? row.Event: {};
  	    var keys = Object.keys(event).filter(function (key) {
  	      return event[key] !== null && event[key] !== undefined && event[key] !== "";
  	    }).sort();

  	    if (!keys.length) {
  	      return "<div class=\"ctm-muted\">No extra event detail is stored for this history row.</div>";
  	    }

  	    return ""
  	    + "<div class=\"ctm-history-detail-grid\">"
  	    + keys.map(function (key) {
  	      return ""
  	      + "<div>"
  	      + "  <div class=\"ctm-history-detail-label\">" + escapeHtml(key) + "</div>"
  	      + "  <div class=\"ctm-history-detail-value\">" + escapeHtml(historyDisplayValue(event[key])) + "</div>"
  	      + "</div>";
  	    }).join("")
  	    + "</div>";
  	  }

  	  function tyreHistoryTableHtml(tyre) {
  	    var rows = collectTyreHistoryRows(tyre);

  	    return ""
  	    + "<div class=\"ctm-history-wrap\">"
  	    + "  <div class=\"ctm-section-title\">Tyre History</div>"
  	    + (rows.length ? ""
  	      + "  <div class=\"ctm-note\">Select a history row to view the full stored event detail.</div>"
  	      + "  <div class=\"ctm-history-scroll\">"
  	      + "    <table class=\"ctm-history-table\">"
  	      + "      <thead>"
  	      + "        <tr>"
  	      + "          <th>Date</th>"
  	      + "          <th>Stage</th>"
  	      + "          <th>Event</th>"
  	      + "          <th>Odometer</th>"
  	      + "          <th>From</th>"
  	      + "          <th>To</th>"
  	      + "          <th>Destination</th>"
  	      + "          <th>Cost</th>"
  	      + "          <th>Notes</th>"
  	      + "        </tr>"
  	      + "      </thead>"
  	      + "      <tbody>"
  	      + rows.map(function (row) {
  	        return ""
  	        + "        <tr class=\"ctm-history-row\" data-history-key=\"" + escapeHtml(row.Key) + "\">"
  	        + "          <td>" + escapeHtml(formatHistoryDate(row.Date)) + "</td>"
  	        + "          <td>" + escapeHtml(row.Stage) + "</td>"
  	        + "          <td>" + escapeHtml(row.Type) + "</td>"
  	        + "          <td>" + escapeHtml(row.Odometer) + "</td>"
  	        + "          <td>" + escapeHtml(row.FromPosition) + "</td>"
  	        + "          <td>" + escapeHtml(row.ToPosition) + "</td>"
  	        + "          <td>" + escapeHtml(row.Destination) + "</td>"
  	        + "          <td>" + escapeHtml(row.Cost) + "</td>"
  	        + "          <td>" + escapeHtml(row.Notes) + "</td>"
  	        + "        </tr>"
  	        + "        <tr id=\"ctmHistoryDetail_" + escapeHtml(row.Key) + "\" class=\"ctm-history-detail-row\" style=\"display:none;\">"
  	        + "          <td colspan=\"9\">" + historyEventDetailHtml(row) + "</td>"
  	        + "        </tr>";
  	      }).join("")
  	      + "      </tbody>"
  	      + "    </table>"
  	      + "  </div>": "<div class=\"ctm-empty\">No tyre history events are stored yet.</div>")
  	    + "</div>";
  	  }

  	  function printReportValue(value) {
  	    return historyDisplayValue(value);
  	  }

  	  function printTyreDetailRowsHtml(tyre) {
  	    var history = normaliseHistory(tyre);
  	    var rows = [
  	      ["Company",
  	        clean(tyre.__CompanyName) || "Unassigned"],
  	      ["Fleet Number",
  	        tyreNumber(tyre)],
  	      ["Serial Number",
  	        tyreSerial(tyre)],
  	      ["Make",
  	        tyreMake(tyre)],
  	      ["Model / Pattern",
  	        tyreModel(tyre)],
  	      ["Size",
  	        tyreSize(tyre)],
  	      ["Type",
  	        tyreType(tyre)],
  	      ["Status",
  	        tyreStatus(tyre)],
  	      ["Stage",
  	        tyreStage(tyre)],
  	      ["Life",
  	        tyreLifeText(tyre)],
  	      ["Current Mileage",
  	        formatMileage(tyre.Current_Mileage)],
  	      ["Expected Mileage",
  	        formatMileage(tyre.Expected_Mileage)],
  	      ["Remaining Mileage",
  	        formatMileage(tyreRemainingMileage(tyre))],
  	      ["Mileage Warning",
  	        mileageWarningText(tyre) || "—"],
  	      ["Location",
  	        locationText(tyre)],
  	      ["Position",
  	        locationSubText(tyre) || "—"],
  	      ["Vehicle ObjectId",
  	        clean(tyre.Vehicle_ObjectId) || "—"],
  	      ["Vehicle Type",
  	        clean(tyre.Vehicle_Type) || "—"],
  	      ["Axle Type",
  	        clean(tyre.Current_Axle_Type) || "—"],
  	      ["Wear Rate",
  	        clean(tyre.Current_Wear_Rate) || "—"],
  	      ["Fitted Date",
  	        clean(tyre.Fitted_Date) || "—"],
  	      ["Fitted Odometer",
  	        clean(tyre.Fitted_Odometer) || "—"],
  	      ["Total Mileage",
  	        formatMileage(tyre.Total_Mileage)],
  	      ["Total Cost",
  	        printReportValue(tyre.Total_Cost)],
  	      ["Current CPK",
  	        printReportValue(tyre.Current_CPK)],
  	      ["Total CPK",
  	        printReportValue(tyre.Total_CPK)],
  	      ["Expected CPK",
  	        printReportValue(tyre.Expected_CPK)],
  	      ["ObjectId",
  	        tyreObjectId(tyre)],
  	      ["Company ObjectId",
  	        clean(tyre.__CompanyObjectId) || clean(tyre.Company_ID) || "—"],
  	      ["History Current Stage",
  	        history && history.Current ? printReportValue(history.Current.Stage): "—"],
  	      ["History Last Event",
  	        history && history.Current ? printReportValue(history.Current.Last_Event_Type): "—"],
  	      ["History Last Event Date",
  	        history && history.Current ? printReportValue(history.Current.Last_Event_Date): "—"]
  	    ];
  	    var html = "";
  	    var i;
  	    var left;
  	    var right;

  	    for (i = 0; i < rows.length; i += 2) {
  	      left = rows[i];
  	      right = rows[i + 1];

  	      html += ""
  	      + "<tr>"
  	      + "  <th>" + escapeHtml(left[0]) + "</th>"
  	      + "  <td>" + escapeHtml(printReportValue(left[1])) + "</td>"
  	      + (right ? "  <th>" + escapeHtml(right[0]) + "</th>"
  	        + "  <td>" + escapeHtml(printReportValue(right[1])) + "</td>": "<th></th><td></td>")
  	      + "</tr>";
  	    }

  	    return html;
  	  }

  	  function printTyreHistoryRowsHtml(tyre) {
  	    var rows = collectTyreHistoryRows(tyre);

  	    if (!rows.length) {
  	      return "<tr><td colspan=\"11\">No tyre history events are stored yet.</td></tr>";
  	    }

  	    return rows.map(function (row) {
  	      return ""
  	      + "<tr>"
  	      + "  <td>" + escapeHtml(formatHistoryDate(row.Date)) + "</td>"
  	      + "  <td>" + escapeHtml(row.Stage) + "</td>"
  	      + "  <td>" + escapeHtml(row.Type) + "</td>"
  	      + "  <td>" + escapeHtml(row.Odometer) + "</td>"
  	      + "  <td>" + escapeHtml(row.FromPosition) + "</td>"
  	      + "  <td>" + escapeHtml(row.ToPosition) + "</td>"
  	      + "  <td>" + escapeHtml(row.Destination) + "</td>"
  	      + "  <td>" + escapeHtml(row.Cost) + "</td>"
  	      + "  <td>" + escapeHtml(row.Notes) + "</td>"
  	      + "  <td>" + escapeHtml(historyDisplayValue(row.Event && row.Event.WearRate)) + "</td>"
  	      + "  <td>" + escapeHtml(historyDisplayValue(row.Event && row.Event.CapturedBy)) + "</td>"
  	      + "</tr>";
  	    }).join("");
  	  }

  	  function printTyreReportHtml(tyre) {
  	    var title = "Tyre Report - " + (tyreNumber(tyre) || tyreObjectId(tyre) || "Tyre");

  	    return ""
  	    + "<!doctype html>"
  	    + "<html>"
  	    + "<head>"
  	    + "  <meta charset=\"utf-8\">"
  	    + "  <title>" + escapeHtml(title) + "</title>"
  	    + "  <style>"
  	    + "    *{box-sizing:border-box;}"
  	    + "    body{font-family:Arial,sans-serif;color:#111;margin:24px;font-size:12px;}"
  	    + "    .ctm-report-head{display:flex;justify-content:space-between;align-items:flex-start;gap:14px;border-bottom:2px solid #cc6b33;padding-bottom:8px;margin-bottom:12px;}"
  	    + "    .ctm-report-logo-box{min-width:110px;text-align:right;}"
  	    + "    .ctm-report-logo{height:42px;width:auto;max-width:180px;object-fit:contain;}"
  	    + "    .ctm-report-logo-svg{height:42px;width:auto;max-width:180px;display:block;}"
  	    + "    .ctm-report-logo-inline{display:inline-flex;align-items:center;justify-content:flex-end;}"
  	    + "    h1{font-size:22px;margin:0 0 4px;color:#111;}"
  	    + "    h2{font-size:15px;margin:22px 0 8px;border-bottom:2px solid #222;padding-bottom:5px;}"
  	    + "    .sub{color:#555;margin-bottom:16px;}"
  	    + "    .summary{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:8px;margin:12px 0 18px;}"
  	    + "    .box{border:1px solid #bbb;padding:8px;border-radius:4px;}"
  	    + "    .box b{display:block;font-size:10px;text-transform:uppercase;color:#555;margin-bottom:3px;}"
  	    + "    table{width:100%;border-collapse:collapse;margin-bottom:12px;}"
  	    + "    th,td{border:1px solid #bbb;padding:5px 6px;vertical-align:top;text-align:left;}"
  	    + "    th{background:#eee;font-weight:700;}"
  	    + "    .details th{width:18%;}"
  	    + "    .details td{width:32%;}"
  	    + "    pre{white-space:pre-wrap;word-break:break-word;margin:0;font-family:Consolas,monospace;font-size:10px;}"
  	    + "    .print-meta{font-size:10px;color:#666;margin-top:18px;}"
  	    + "    @media print{body{margin:10mm;}button{display:none!important;}h2{page-break-after:avoid;}tr{page-break-inside:avoid;}}"
  	    + "  </style>"
  	    + "</head>"
  	    + "<body>"
  	    + "  <button onclick=\"window.print()\" style=\"float:right;padding:8px 12px;\">Print</button>"
  	    + "  <div class=\"ctm-report-head\">"
  	    + "    <div>"
  	    + "      <h1>" + escapeHtml(title) + "</h1>"
  	    + "      <div class=\"sub\">" + escapeHtml([tyreMake(tyre), tyreModel(tyre), tyreSize(tyre)].filter(Boolean).join(" - ") || "No make/model/size") + "</div>"
  	    + "    </div>"
  	    + "    <div class=\"ctm-report-logo-box\">" + reportLogoHtml() + "</div>"
  	    + "  </div>"
  	    + "  <div class=\"summary\">"
  	    + "    <div class=\"box\"><b>Status</b>" + escapeHtml(tyreStatus(tyre)) + "</div>"
  	    + "    <div class=\"box\"><b>Stage</b>" + escapeHtml(tyreStage(tyre)) + "</div>"
  	    + "    <div class=\"box\"><b>Remaining Mileage</b>" + escapeHtml(formatMileage(tyreRemainingMileage(tyre))) + "</div>"
  	    + "    <div class=\"box\"><b>Location</b>" + escapeHtml(locationText(tyre)) + "</div>"
  	    + "    <div class=\"box\"><b>Position</b>" + escapeHtml(locationSubText(tyre) || "—") + "</div>"
  	    + "    <div class=\"box\"><b>Life</b>" + escapeHtml(tyreLifeText(tyre)) + "</div>"
  	    + "  </div>"
  	    + "  <h2>Tyre Details</h2>"
  	    + "  <table class=\"details\"><tbody>"
  	    + printTyreDetailRowsHtml(tyre)
  	    + "  </tbody></table>"
  	    + "  <h2>Full Tyre History</h2>"
  	    + "  <table>"
  	    + "    <thead>"
  	    + "      <tr>"
  	    + "        <th>Date</th>"
  	    + "        <th>Stage</th>"
  	    + "        <th>Event</th>"
  	    + "        <th>Odometer</th>"
  	    + "        <th>From</th>"
  	    + "        <th>To</th>"
  	    + "        <th>Destination</th>"
  	    + "        <th>Cost</th>"
  	    + "        <th>Notes</th>"
  	    + "        <th>Wear Rate</th>"
  	    + "        <th>Captured By</th>"
  	    + "      </tr>"
  	    + "    </thead>"
  	    + "    <tbody>"
  	    + printTyreHistoryRowsHtml(tyre)
  	    + "    </tbody>"
  	    + "  </table>"
  	    + "  <div class=\"print-meta\">Printed from Company Tyre Manager on " + escapeHtml(new Date().toLocaleString()) + "</div>"
  	    + "</body>"
  	    + "</html>";
  	  }

  	  function printSelectedTyreReport() {
  	    var tyre = findTyreById(state.modal && state.modal.tyreId);
  	    var printWindow;
  	    var html;

  	    if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	      alertSafe("You do not have access to this tyre.");
  	      return;
  	    }

  	    if (!WindowSafe || typeof WindowSafe.open !== "function") {
  	      alertSafe("Printing is unavailable in this browser.");
  	      return;
  	    }

  	    html = printTyreReportHtml(tyre);
  	    printWindow = WindowSafe.open("", "_blank");

  	    if (!printWindow) {
  	      alertSafe("The print window was blocked. Allow popups for this app and try again.");
  	      return;
  	    }

  	    printWindow.document.open();
  	    printWindow.document.write(html);
  	    printWindow.document.close();

  	    try {
  	      printWindow.focus();
  	      setTimeout(function () {
  	        printWindow.print();
  	      }, 250);
  	    } catch (error) {
  	      console.warn("COMPANY-TYRES: print failed", error);
  	    }
  	  }

  	  function tyreWarningBucket(tyre) {
  	    var warning = mileageWarningText(tyre).toLowerCase();

  	    if (!warning || warning === "null") {
  	      return "";
  	    }

  	    if (warning.indexOf("over") !== -1) {
  	      return "Over Mileage";
  	    }

  	    if (warning.indexOf("5000") !== -1 || warning.indexOf("5k") !== -1) {
  	      return "5000km Warning";
  	    }

  	    if (warning.indexOf("10000") !== -1 || warning.indexOf("10k") !== -1) {
  	      return "10000km Warning";
  	    }

  	    if (warning.indexOf("15000") !== -1 || warning.indexOf("15k") !== -1) {
  	      return "15000km Warning";
  	    }

  	    return mileageWarningText(tyre);
  	  }

  	  function warehouseWarningStats() {
  	    var stats = {
  	      total: 0,
  	      warningTotal: 0,
  	      over: 0,
  	      five: 0,
  	      ten: 0,
  	      fifteen: 0
  	    };

  	    companyScopedTyres().forEach(function (tyre) {
  	      var bucket = tyreWarningBucket(tyre);

  	      stats.total += 1;

  	      if (!bucket) {
  	        return;
  	      }

  	      stats.warningTotal += 1;

  	      if (bucket === "Over Mileage") {
  	        stats.over += 1;
  	      }

  	      if (bucket === "5000km Warning") {
  	        stats.five += 1;
  	      }

  	      if (bucket === "10000km Warning") {
  	        stats.ten += 1;
  	      }

  	      if (bucket === "15000km Warning") {
  	        stats.fifteen += 1;
  	      }
  	    });

  	    return stats;
  	  }

  	  function warehouseOrderRows() {
  	    var map = {};
  	    var rows = [];

  	    companyScopedTyres().forEach(function (tyre) {
  	      var bucket = tyreWarningBucket(tyre);
  	      var make;
  	      var model;
  	      var type;
  	      var size;
  	      var key;

  	      if (bucket !== "5000km Warning" && bucket !== "10000km Warning") {
  	        return;
  	      }

  	      make = tyreMake(tyre) || "Unknown Make";
  	      model = tyreModel(tyre) || "Unknown Model";
  	      type = tyreType(tyre) || "Unknown Type";
  	      size = tyreSize(tyre) || "Unknown Size";

  	      key = [
  	        make.toLowerCase(),
  	        model.toLowerCase(),
  	        type.toLowerCase(),
  	        size.toLowerCase()
  	      ].join("|");

  	      if (!map[key]) {
  	        map[key] = {
  	          Make: make,
  	          Model: model,
  	          Type: type,
  	          Size: size,
  	          Qty5k: 0,
  	          Qty10k: 0,
  	          Tyres: []
  	        };
  	      }

  	      if (bucket === "5000km Warning") {
  	        map[key].Qty5k += 1;
  	      }

  	      if (bucket === "10000km Warning") {
  	        map[key].Qty10k += 1;
  	      }

  	      map[key].Tyres.push(tyreNumber(tyre) || tyreObjectId(tyre));
  	    });

  	    rows = Object.keys(map).map(function (key) {
  	      map[key].TotalQty = map[key].Qty5k + map[key].Qty10k;
  	      return map[key];
  	    });

  	    rows.sort(function (a, b) {
  	      return b.TotalQty - a.TotalQty ||
  	      a.Type.localeCompare(b.Type) ||
  	      a.Make.localeCompare(b.Make) ||
  	      a.Model.localeCompare(b.Model) ||
  	      a.Size.localeCompare(b.Size);
  	    });

  	    return rows;
  	  }

  	  function warehouseOrderRowsHtml() {
  	    var rows = warehouseOrderRows();

  	    if (!rows.length) {
  	      return "<tr><td colspan=\"7\">No tyres are currently in the 5000km or 10000km warning order range.</td></tr>";
  	    }

  	    return rows.map(function (row) {
  	      return ""
  	      + "<tr>"
  	      + "  <td>" + escapeHtml(row.Make) + "</td>"
  	      + "  <td>" + escapeHtml(row.Model) + "</td>"
  	      + "  <td>" + escapeHtml(row.Type) + "</td>"
  	      + "  <td>" + escapeHtml(row.Size) + "</td>"
  	      + "  <td>" + escapeHtml(row.Qty5k) + "</td>"
  	      + "  <td>" + escapeHtml(row.Qty10k) + "</td>"
  	      + "  <td>" + escapeHtml(row.TotalQty) + "</td>"
  	      + "</tr>";
  	    }).join("");
  	  }

  	  function warehouseWarningTyreRowsHtml() {
  	    var tyres = companyScopedTyres().filter(function (tyre) {
  	      var bucket = tyreWarningBucket(tyre);
  	      return bucket === "5000km Warning" || bucket === "10000km Warning" || bucket === "15000km Warning" || bucket === "Over Mileage";
  	    }).sort(function (a, b) {
  	      return compareSortValues(a, b, "remainingMileage", "asc");
  	    });

  	    if (!tyres.length) {
  	      return "<tr><td colspan=\"8\">No tyres are currently in a mileage warning state.</td></tr>";
  	    }

  	    return tyres.map(function (tyre) {
  	      return ""
  	      + "<tr>"
  	      + "  <td>" + escapeHtml(tyreNumber(tyre) || tyreObjectId(tyre)) + "</td>"
  	      + "  <td>" + escapeHtml(tyreWarningBucket(tyre) || "—") + "</td>"
  	      + "  <td>" + escapeHtml(formatMileage(tyreRemainingMileage(tyre))) + "</td>"
  	      + "  <td>" + escapeHtml(tyreMake(tyre) || "—") + "</td>"
  	      + "  <td>" + escapeHtml(tyreModel(tyre) || "—") + "</td>"
  	      + "  <td>" + escapeHtml(tyreType(tyre) || "—") + "</td>"
  	      + "  <td>" + escapeHtml(tyreSize(tyre) || "—") + "</td>"
  	      + "  <td>" + escapeHtml(locationText(tyre) + (locationSubText(tyre) ? " / " + locationSubText(tyre): "")) + "</td>"
  	      + "</tr>";
  	    }).join("");
  	  }

  	  function warehouseWarningReportHtml() {
  	    var company = selectedCompany();
  	    var stats = warehouseWarningStats();
  	    var title = "Warehouse Tyre Warning Report";

  	    return ""
  	    + "<!doctype html>"
  	    + "<html>"
  	    + "<head>"
  	    + "  <meta charset=\"utf-8\">"
  	    + "  <title>" + escapeHtml(title) + "</title>"
  	    + "  <style>"
  	    + "    *{box-sizing:border-box;}"
  	        + "    body{font-family:Arial,sans-serif;color:#111;margin:22px;font-size:12px;}"
  	    + "    .ctm-report-head{display:flex;justify-content:space-between;align-items:flex-start;gap:14px;border-bottom:2px solid #cc6b33;padding-bottom:8px;margin-bottom:12px;}"
  	    + "    .ctm-report-logo-box{min-width:110px;text-align:right;}"
  	    + "    .ctm-report-logo{height:42px;width:auto;max-width:180px;object-fit:contain;}"
  	    + "    .ctm-report-logo-svg{height:42px;width:auto;max-width:180px;display:block;}"
  	    + "    .ctm-report-logo-inline{display:inline-flex;align-items:center;justify-content:flex-end;}"
  	    + "    h1{font-size:22px;margin:0 0 4px;color:#111;}"
  	    + "    h2{font-size:15px;margin:18px 0 8px;border-bottom:2px solid #222;padding-bottom:5px;}"
  	    + "    .sub{color:#555;margin-bottom:14px;}"
  	    + "    .summary{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin:12px 0 16px;}"
  	    + "    .box{border:1px solid #bbb;padding:8px;border-radius:4px;}"
  	    + "    .box b{display:block;font-size:10px;text-transform:uppercase;color:#555;margin-bottom:3px;}"
  	    + "    table{width:100%;border-collapse:collapse;margin-bottom:12px;}"
  	    + "    th,td{border:1px solid #bbb;padding:5px 6px;vertical-align:top;text-align:left;}"
  	    + "    th{background:#eee;font-weight:700;}"
  	    + "    .print-meta{font-size:10px;color:#666;margin-top:16px;}"
  	    + "    @media print{body{margin:10mm;}button{display:none!important;}h2{page-break-after:avoid;}tr{page-break-inside:avoid;}}"
  	    + "  </style>"
  	    + "</head>"
  	    + "<body>"
  	    + "  <button onclick=\"window.print()\" style=\"float:right;padding:8px 12px;\">Print</button>"
  	        + "  <div class=\"ctm-report-head\">"
  	    + "    <div>"
  	    + "      <h1>" + escapeHtml(title) + "</h1>"
  	    + "      <div class=\"sub\">Company: " + escapeHtml(company ? company.name: "Selected Company") + "</div>"
  	    + "    </div>"
  	    + "    <div class=\"ctm-report-logo-box\">" + reportLogoHtml() + "</div>"
  	    + "  </div>"
  	    + "  <div class=\"summary\">"
  	    + "    <div class=\"box\"><b>Total Tyres</b>" + escapeHtml(stats.total) + "</div>"
  	    + "    <div class=\"box\"><b>Total Warnings</b>" + escapeHtml(stats.warningTotal) + "</div>"
  	    + "    <div class=\"box\"><b>Over Mileage</b>" + escapeHtml(stats.over) + "</div>"
  	    + "    <div class=\"box\"><b>5000km Warning</b>" + escapeHtml(stats.five) + "</div>"
  	    + "    <div class=\"box\"><b>10000km Warning</b>" + escapeHtml(stats.ten) + "</div>"
  	    + "    <div class=\"box\"><b>15000km Warning</b>" + escapeHtml(stats.fifteen) + "</div>"
  	    + "    <div class=\"box\"><b>Order Range</b>" + escapeHtml(stats.five + stats.ten) + "</div>"
  	    + "    <div class=\"box\"><b>Report Date</b>" + escapeHtml(new Date().toLocaleString()) + "</div>"
  	    + "  </div>"
  	    + "  <h2>Order Summary: 5000km and 10000km Warning Tyres</h2>"
  	    + "  <table>"
  	    + "    <thead>"
  	    + "      <tr>"
  	    + "        <th>Make</th>"
  	    + "        <th>Model / Pattern</th>"
  	    + "        <th>Type</th>"
  	    + "        <th>Size</th>"
  	    + "        <th>5000km Qty</th>"
  	    + "        <th>10000km Qty</th>"
  	    + "        <th>Total Qty</th>"
  	    + "      </tr>"
  	    + "    </thead>"
  	    + "    <tbody>"
  	    + warehouseOrderRowsHtml()
  	    + "    </tbody>"
  	    + "  </table>"
  	    + "  <h2>All Tyres In Mileage Warning State</h2>"
  	    + "  <table>"
  	    + "    <thead>"
  	    + "      <tr>"
  	    + "        <th>Tyre</th>"
  	    + "        <th>Warning</th>"
  	    + "        <th>Remaining</th>"
  	    + "        <th>Make</th>"
  	    + "        <th>Model / Pattern</th>"
  	    + "        <th>Type</th>"
  	    + "        <th>Size</th>"
  	    + "        <th>Location</th>"
  	    + "      </tr>"
  	    + "    </thead>"
  	    + "    <tbody>"
  	    + warehouseWarningTyreRowsHtml()
  	    + "    </tbody>"
  	    + "  </table>"
  	    + "  <div class=\"print-meta\">Printed from Company Tyre Manager on " + escapeHtml(new Date().toLocaleString()) + "</div>"
  	    + "</body>"
  	    + "</html>";
  	  }

  	  function printWarehouseWarningReport() {
  	    var printWindow;
  	    var html;

  	    if (!companies.length || !selectedCompany()) {
  	      alertSafe("Select a company before printing the warehouse report.");
  	      return;
  	    }

  	    if (!WindowSafe || typeof WindowSafe.open !== "function") {
  	      alertSafe("Printing is unavailable in this browser.");
  	      return;
  	    }

  	    html = warehouseWarningReportHtml();
  	    printWindow = WindowSafe.open("", "_blank");

  	    if (!printWindow) {
  	      alertSafe("The print window was blocked. Allow popups for this app and try again.");
  	      return;
  	    }

  	    printWindow.document.open();
  	    printWindow.document.write(html);
  	    printWindow.document.close();

  	    try {
  	      printWindow.focus();
  	      setTimeout(function () {
  	        printWindow.print();
  	      }, 250);
  	    } catch (error) {
  	      console.warn("COMPANY-TYRES: warehouse warning report print failed", error);
  	    }
  	  }

  	  function transactionPanelHtml() {
  	    return ""
  	    + "<div class=\"ctm-transaction-shell\">"
  	    + buttonHtml("ctmNewTransactionBtn", "New Transaction", "ctm-btn-orange")
  	    + "  <div id=\"ctmTransactionPanel\" class=\"ctm-transaction-panel\" style=\"display:none;\">"
  	    + "    <div class=\"ctm-section-title\">New Transaction</div>"
  	    + "    <div class=\"ctm-note\">Record a tyre repair, inspection, valve replacement, patch, plug, vulcanising, or other tyre cost event.</div>"
  	    + "    <div class=\"ctm-grid2\">"
  	    + selectHtml("ctmTransactionType", "Transaction Type", ["", "Vulcanised", "Patched", "Plugged", "Valve Replaced", "Bead Repair", "Inspection", "Other"], "")
  	    + fieldHtml("ctmTransactionCost", "Transaction Cost", "", "Required for tyre transaction", "number")
  	    + "    </div>"
  	    + "    <div class=\"ctm-bottom-actions\" style=\"margin-top:10px;\">"
  	    + buttonHtml("ctmSaveTransactionBtn", "Save Transaction", "ctm-btn-green", "style=\"display:none;\"")
  	    + "    </div>"
  	    + "  </div>"
  	    + "</div>";
  	  }

  	  function updateTransactionSaveVisibility() {
  	    var typeEl = DocumentSafe.getElementById("ctmTransactionType");
  	    var costEl = DocumentSafe.getElementById("ctmTransactionCost");
  	    var saveBtn = DocumentSafe.getElementById("ctmSaveTransactionBtn");
  	    var type = typeEl ? clean(typeEl.value): "";
  	    var cost = costEl ? numberOrNull(costEl.value): null;

  	    if (!saveBtn) {
  	      return;
  	    }

  	    saveBtn.style.display = type && cost !== null && cost > 0 ? "inline-flex": "none";
  	  }

  	  function saveTransactionFromModal() {
  	    var tyre = findTyreById(state.modal && state.modal.tyreId);
  	    var updated;
  	    var transactionType = readValue("ctmTransactionType");
  	    var transactionCost = readValue("ctmTransactionCost");
  	    var notes = readValue("ctmEditNotes");
  	    var company;

  	    if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	      alertSafe("You do not have access to this tyre.");
  	      return;
  	    }

  	    company = {
  	      id: clean(tyre.__CompanyObjectId),
  	      name: clean(tyre.__CompanyName)
  	    };

  	    try {
  	      updated = applyTyreTransaction(tyre, transactionType, transactionCost, notes);
  	    } catch (error) {
  	      alertSafe(error && error.message ? error.message: "Could not save tyre transaction.");
  	      return;
  	    }

  	    state.busy = true;
  	    setMessage("Saving transaction...", false);
  	    render();

  	    saveTyre(updated, company)
  	    .then(function () {
  	      state.busy = false;
  	      setMessage("Transaction saved.", false);
  	      render();
  	    })
  	    .catch(failSave);
  	  }

  	  function currentMileageLockedForStage(tyre) {
  	    var events = stageEvents(tyre, currentStageName(tyre));
  	    var i;

  	    for (i = 0; i < events.length; i++) {
  	      if (events[i] && events[i].Type === "Current Mileage Set") {
  	        return true;
  	      }
  	    }

  	    return false;
  	  }

  	  function applyCurrentMileageForStage(tyre, mileage, notes) {
  	    var updated = clone(tyre);
  	    var history = normaliseHistory(updated);
  	    var stage = currentStageName(updated);
  	    var safeMileage = numberOrNull(mileage);

  	    if (safeMileage === null || safeMileage < 0) {
  	      throw new Error("Current Mileage must be a valid number.");
  	    }

  	    if (currentMileageLockedForStage(updated)) {
  	      throw new Error("Current Mileage has already been set for this stage cycle.");
  	    }

  	    updated.Current_Mileage = safeMileage;

  	    if (!history[stage] || typeof history[stage] !== "object") {
  	      history[stage] = blankHistoryStage(true);
  	    }

  	    history[stage].Start_Mileage = safeMileage;

  	    if (!Array.isArray(history[stage].Events)) {
  	      history[stage].Events = [];
  	    }

  	    history[stage].Events.push(tyreEvent("Current Mileage Set", {
  	      Notes: notes || "Current mileage set for this stage cycle.",
  	      Odometer: safeMileage
  	    }));

  	    history.Current.Stage = stage;
  	    history.Current.Last_Event_Type = "Current Mileage Set";
  	    history.Current.Last_Event_Date = nowIso();

  	    updated.History = history;

  	    return updated;
  	  }

  	  function applyExpectedMileageFromRemaining(tyre, remainingKm, notes) {
  	    var updated = clone(tyre);
  	    var history = normaliseHistory(updated);
  	    var stage = currentStageName(updated);
  	    var currentMileage = numberOrNull(updated.Current_Mileage);
  	    var remaining = numberOrNull(remainingKm);
  	    var expectedMileage;

  	    if (currentMileage === null || currentMileage < 0) {
  	      throw new Error("Set Current Mileage before calculating Expected Mileage.");
  	    }

  	    if (remaining === null || remaining < 0) {
  	      throw new Error("Remaining KM must be a valid number.");
  	    }

  	    expectedMileage = currentMileage + remaining;

  	    updated.Expected_Mileage = expectedMileage;

  	    if (!history[stage] || typeof history[stage] !== "object") {
  	      history[stage] = blankHistoryStage(true);
  	    }

  	    history[stage].Mileage_Expected = expectedMileage;

  	    if (!Array.isArray(history[stage].Events)) {
  	      history[stage].Events = [];
  	    }

  	    history[stage].Events.push(tyreEvent("Expected Mileage Updated", {
  	      Notes: notes || ("Expected mileage updated from remaining estimate of " + remaining + " km."),
  	      Odometer: currentMileage,
  	      Destination: "Expected Mileage: " + expectedMileage
  	    }));

  	    history.Current.Stage = stage;
  	    history.Current.Last_Event_Type = "Expected Mileage Updated";
  	    history.Current.Last_Event_Date = nowIso();

  	    updated.History = history;

  	    return updated;
  	  }

  	  function applyTyreTransaction(tyre, transactionType, cost, notes) {
  	    var updated = clone(tyre);
  	    var history = normaliseHistory(updated);
  	    var stage = currentStageName(updated);
  	    var safeCost = numberOrNull(cost);

  	    transactionType = clean(transactionType);

  	    if (!transactionType) {
  	      throw new Error("Select a transaction type.");
  	    }

  	    if (safeCost === null || safeCost < 0) {
  	      throw new Error("Transaction cost is required.");
  	    }

  	    if (!history[stage] || typeof history[stage] !== "object") {
  	      history[stage] = blankHistoryStage(true);
  	    }

  	    history[stage].Cost = (numberOrNull(history[stage].Cost) || 0) + safeCost;
  	    history.Totals.Cost_Total = (numberOrNull(history.Totals.Cost_Total) || 0) + safeCost;

  	    if (!Array.isArray(history[stage].Events)) {
  	      history[stage].Events = [];
  	    }

  	    history[stage].Events.push(tyreEvent("Tyre Transaction", {
  	      Notes: notes || transactionType,
  	      Cost: safeCost,
  	      Destination: transactionType
  	    }));

  	    history.Current.Stage = stage;
  	    history.Current.Last_Event_Type = "Tyre Transaction";
  	    history.Current.Last_Event_Date = nowIso();

  	    updated.History = history;

  	    return updated;
  	  }

  	  function advanceRetreadStage(tyre, fromStage, toStage, event, cost) {
  	    var updated = clone(tyre);
  	    var history = normaliseHistory(updated);
  	    var safeCost = numberOrNull(cost) || 0;

  	    if (!history[fromStage] || typeof history[fromStage] !== "object") {
  	      history[fromStage] = blankHistoryStage(false);
  	    }

  	    history[fromStage].Active = false;
  	    history[fromStage].Status = "Completed";
  	    history[fromStage].Ended = nowIso();

  	    if (!history[toStage] || typeof history[toStage] !== "object") {
  	      history[toStage] = blankHistoryStage(true);
  	    }

  	    history[toStage].Active = true;
  	    history[toStage].Status = "Active";
  	    history[toStage].Cost = safeCost;

  	    if (!history[toStage].Started) {
  	      history[toStage].Started = nowIso();
  	    }

  	    if (!Array.isArray(history[toStage].Events)) {
  	      history[toStage].Events = [];
  	    }

  	    history[toStage].Events.push(event);
  	    history.Totals.Cost_Total = (numberOrNull(history.Totals.Cost_Total) || 0) + safeCost;

  	    history.Current.Stage = toStage;
  	    history.Current.Last_Event_Type = event.Type || "";
  	    history.Current.Last_Event_Date = event.Date || "";

  	    updated.Current_Stage = toStage;
  	    updated.History = history;

  	    return updated;
  	  }

  	  var TYRE_EXPRESSION_FIELDS = [
  	    "Warehouse",
  	    "Current_CPK",
  	    "Total_CPK",
  	    "Current_Life",
  	    "Total_Mileage",
  	    "Mileage_Warning",
  	    "Total_Cost",
  	    "Expected_CPK",
  	    "Remaining_Mileage"
  	  ];

  	  var TYRE_READ_ONLY_FIELDS = [
  	    "created",
  	    "updated",
  	    "ownerId",
  	    "___class",
  	    "__CompanyObjectId",
  	    "__CompanyName"
  	  ];

  	  function cleanTyreForSave(tyre) {
  	    var payload = clone(tyre);

  	    TYRE_EXPRESSION_FIELDS.concat(TYRE_READ_ONLY_FIELDS).forEach(function (field) {
  	      if (Object.prototype.hasOwnProperty.call(payload, field)) {
  	        delete payload[field];
  	      }
  	    });

  	    return payload;
  	  }

  	  function stampCompanyMeta(tyre,
  	    company) {
  	    var updated = clone(tyre);

  	    if (company && company.id) {
  	      updated.Company_ID = company.id;
  	      updated.__CompanyObjectId = company.id;
  	      updated.__CompanyName = company.name;
  	    }

  	    return updated;
  	  }

  	  function addTyreToMap(map, tyre, company) {
  	    var id = tyreObjectId(tyre);
  	    var copy;

  	    if (!tyre || !company || !company.id) {
  	      return;
  	    }

  	    copy = stampCompanyMeta(tyre, company);

  	    if (id) {
  	      map[id] = copy;
  	      return;
  	    }

  	    map["unsaved-" + Object.keys(map).length] = copy;
  	  }

  	  function collectTyres() {
  	    var map = {};

  	    try {
  	      companies.forEach(function (companyItem) {
  	        var company = companyItem.row;

  	        arr(company && company.Tyres).forEach(function (tyre) {
  	          addTyreToMap(map, tyre, companyItem);
  	        });

  	        arr(company && company.Tractors).forEach(function (vehicle) {
  	          arr(vehicle && vehicle.Tyres).forEach(function (tyre) {
  	            addTyreToMap(map, tyre, companyItem);
  	          });
  	        });

  	        arr(company && company.Trailers).forEach(function (vehicle) {
  	          arr(vehicle && vehicle.Tyres).forEach(function (tyre) {
  	            addTyreToMap(map, tyre, companyItem);
  	          });
  	        });
  	      });
  	    } catch (error) {
  	      console.warn("COMPANY-TYRES: App tyre collection failed", error);
  	    }

  	    return Object.keys(map).map(function (key) {
  	      return map[key];
  	    });
  	  }

  	  var state = {
  	    tyres: [],
  	    companyId: defaultCompanyId(),
  	    search: "",
  	    statusFilter: "All",
  	    stageFilter: "All",
  	    typeFilter: "All",
  	    locationFilter: "All",
  	    sortKey: "remainingMileage",
  	    sortDir: "asc",
  	    modal: null,
  	    busy: false,
  	    message: "",
  	    messageError: false,
  	    bulkPrefix: DEFAULT_FLEET_PREFIX,
  	    bulkCount: 1
  	  };

  	  state.tyres = collectTyres();

  	  function companyScopedTyres() {
  	    if (!state.companyId || !canAccessCompanyId(state.companyId)) {
  	      return [];
  	    }

  	    return state.tyres.filter(function (tyre) {
  	      return clean(tyre.__CompanyObjectId) === state.companyId;
  	    });
  	  }

  	  function highestFleetSequence(prefix) {
  	    var highest = 0;

  	    companyScopedTyres().forEach(function (tyre) {
  	      [
  	        clean(tyre.ID),
  	        clean(tyre.FID),
  	        clean(tyre.Tyre_Number),
  	        clean(tyre.TyreNumber)
  	      ].forEach(function (value) {
  	          var number = parseFleetSequence(value, prefix);

  	          if (number !== null && number > highest) {
  	            highest = number;
  	          }
  	        });
  	    });

  	    return highest;
  	  }

  	  function nextFleetSequence(prefix) {
  	    return highestFleetSequence(prefix) + 1;
  	  }

  	  function bulkPreviewIds(prefix, start, count) {
  	    var ids = [];
  	    var i;

  	    start = Math.max(1, Number(start) || 1);
  	    count = Math.max(1, Math.min(500,
  	      Number(count) || 1));

  	    for (i = 0; i < count; i++) {
  	      ids.push(formatFleetNumber(prefix, start + i));
  	    }

  	    return ids;
  	  }

  	  function upsertTyre(tyre, company) {
  	    var id = tyreObjectId(tyre);
  	    var i;
  	    var copy = stampCompanyMeta(tyre, company || selectedCompany());

  	    if (!id) {
  	      state.tyres.push(copy);
  	      return;
  	    }

  	    for (i = 0; i < state.tyres.length; i++) {
  	      if (tyreObjectId(state.tyres[i]) === id) {
  	        state.tyres[i] = copy;
  	        return;
  	      }
  	    }

  	    state.tyres.push(copy);
  	  }

  	  function attachTyreToCompany(savedTyre, company) {
  	    var store;

  	    if (!company || !company.row || !company.row.objectId) {
  	      return Promise.resolve(savedTyre);
  	    }

  	    if (!BackendlessSafe || !BackendlessSafe.Data || !BackendlessSafe.Data.of) {
  	      return Promise.resolve(savedTyre);
  	    }

  	    try {
  	      store = BackendlessSafe.Data.of(company.className || "Companies");

  	      if (store && typeof store.addRelation === "function") {
  	        return store.addRelation(company.row, "Tyres", [savedTyre])
  	        .then(function () {
  	          return savedTyre;
  	        })
  	        .catch(function (error) {
  	          console.warn("COMPANY-TYRES: relation attach failed", error);
  	          return savedTyre;
  	        });
  	      }
  	    } catch (error) {
  	      console.warn("COMPANY-TYRES: relation attach unavailable", error);
  	    }

  	    return Promise.resolve(savedTyre);
  	  }

  	  function saveTyre(tyre, company) {
  	    var payload;
  	    var owningCompany = company || selectedCompany();

  	    if (!BackendlessSafe || !BackendlessSafe.Data || !BackendlessSafe.Data.of) {
  	      return Promise.reject(new Error("Backendless is unavailable. Cannot save tyre."));
  	    }

  	    tyre = stampCompanyMeta(tyre, owningCompany);
  	    tyre = stampCompanyMeta(tyre, owningCompany);
  	    payload = cleanTyreForSave(tyre);

  	    return BackendlessSafe.Data.of(TABLE_TYRES).save(payload)
  	    .then(function (saved) {
  	      saved = saved && typeof saved === "object" ? saved: payload;
  	      upsertTyre(saved, owningCompany);

  	      return attachTyreToCompany(saved, owningCompany)
  	      .then(function () {
  	        return saved;
  	      });
  	    });
  	  }

  	  function saveTyresSequentially(tyres, progressPrefix) {
  	    var saved = [];
  	    var total = tyres.length;
  	    var company = selectedCompany();

  	    return tyres.reduce(function (chain, tyre, index) {
  	      return chain.then(function () {
  	        state.busy = true;
  	        state.message = (progressPrefix || "Saving tyres") + " " + (index + 1) + " of " + total + "...";
  	        state.messageError = false;
  	        render();

  	        return saveTyre(tyre, company).then(function (savedTyre) {
  	          saved.push(savedTyre);
  	          return savedTyre;
  	        });
  	      });
  	    }, Promise.resolve()).then(function () {
  	      return saved;
  	    });
  	  }

  	  function loadTyres() {
  	    var fresh = collectTyres();
  	    var map = {};

  	    fresh.forEach(function (tyre) {
  	      var id = tyreObjectId(tyre);

  	      if (id) {
  	        map[id] = tyre;
  	      }
  	    });

  	    state.tyres.forEach(function (tyre) {
  	      var id = tyreObjectId(tyre);
  	      var companyId = clean(tyre.__CompanyObjectId);

  	      if (id && companyId && canAccessCompanyId(companyId) && !map[id]) {
  	        map[id] = tyre;
  	      }
  	    });

  	    state.tyres = Object.keys(map).map(function (key) {
  	      return map[key];
  	    });

  	    state.busy = false;
  	    state.message = "Company tyres refreshed.";
  	    state.messageError = false;

  	    render();

  	    return Promise.resolve(state.tyres);
  	  }

  	  function filteredTyres() {
  	    var q = clean(state.search).toLowerCase();

  	    return companyScopedTyres().filter(function (tyre) {
  	      if (q && tyreSearchBlob(tyre).indexOf(q) === -1) {
  	        return false;
  	      }

  	      if (state.statusFilter !== "All" && tyreStatus(tyre) !== state.statusFilter) {
  	        return false;
  	      }

  	      if (state.stageFilter !== "All" && tyreStage(tyre) !== state.stageFilter) {
  	        return false;
  	      }

  	      if (state.typeFilter !== "All" && tyreType(tyre) !== state.typeFilter) {
  	        return false;
  	      }

  	      if (state.locationFilter === "Warehouse" && !tyreIsWarehouse(tyre)) {
  	        return false;
  	      }

  	      if (state.locationFilter === "Fitted" && !tyreIsFitted(tyre)) {
  	        return false;
  	      }

  	      return true;
  	    }).sort(function (a, b) {
  	      return compareSortValues(a, b, state.sortKey || "remainingMileage", state.sortDir || "asc");
  	    });
  	  }

  	  function counts() {
  	    var tyres = companyScopedTyres();

  	    return {
  	      total: tyres.length,
  	      warehouse: tyres.filter(tyreIsWarehouse).length,
  	      fitted: tyres.filter(tyreIsFitted).length,
  	      retread: tyres.filter(function (tyre) {
  	        return tyreStatus(tyre) === TYRE_STATUS.RETREAD;
  	      }).length,
  	      scrapped: tyres.filter(function (tyre) {
  	        return tyreStatus(tyre) === TYRE_STATUS.SCRAPPED;
  	      }).length,
  	      newStage: tyres.filter(function (tyre) {
  	        return tyreStage(tyre) === "New";
  	      }).length,
  	      cap1: tyres.filter(function (tyre) {
  	        return tyreStage(tyre) === "Cap1";
  	      }).length,
  	      cap2: tyres.filter(function (tyre) {
  	        return tyreStage(tyre) === "Cap2";
  	      }).length,
  	      cap3: tyres.filter(function (tyre) {
  	        return tyreStage(tyre) === "Cap3";
  	      }).length
  	    };
  	  }

  	  function cssHtml() {
  	    return ""
  	    + "<style>"
  	    + "#" + ROOT_ID + " *{box-sizing:border-box;}"
  	    + "#" + ROOT_ID + "{font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#e8e8e8;}"
  	    + "#" + ROOT_ID + " .ctm-panel{position:relative;width:100%!important;max-width:none!important;height:100%!important;min-height:0!important;margin:0!important;background:#111;border:1px solid #2f2f2f;border-radius:0;box-shadow:0 18px 60px rgba(0,0,0,.72);overflow:hidden!important;display:flex!important;flex-direction:column!important;flex:1 1 auto!important;}"
  	    + "#" + ROOT_ID + " .ctm-main-head-actions{position:absolute;top:7px;right:9px;display:flex;align-items:center;gap:7px;z-index:50;}"
  	    + "#" + ROOT_ID + " .ctm-close-main{width:28px;height:28px;border-radius:5px;background:#1d1d1d;border:1px solid #3a3a3a;color:#ddd;font-size:17px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;}"
  	    + "#" + ROOT_ID + " .ctm-close-main:hover{background:#2a2a2a;color:#fff;}"
  	    + "#" + ROOT_ID + " .ctm-head{display:flex;justify-content:space-between;gap:14px;align-items:flex-start;margin-bottom:5px;padding-right:145px;}"
  	    + "#" + ROOT_ID + " .ctm-title{color:#cc6633;font-size:17px;font-weight:850;letter-spacing:.01em;}"
  	    + "#" + ROOT_ID + " .ctm-message{font-size:11px;font-weight:750;text-align:right;min-width:230px;}"
  	    + "#" + ROOT_ID + " .ctm-company-row{display:grid;grid-template-columns:260px max-content;gap:8px;align-items:end;margin:8px 0 10px;justify-content:start;}"
  	    + "#" + ROOT_ID + " .ctm-stats{display:flex;gap:6px;flex-wrap:wrap;margin:7px 0 10px;}"
  	    + "#" + ROOT_ID + " .ctm-stat{border:1px solid #333;background:#151515;border-radius:5px;padding:5px 9px;display:flex;gap:7px;align-items:center;min-height:27px;}"
  	    + "#" + ROOT_ID + " .ctm-stat span:first-child{color:#858585;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.05em;}"
  	    + "#" + ROOT_ID + " .ctm-stat span:last-child{color:#f2f2f2;font-size:13px;font-weight:850;}"
  	    + "#" + ROOT_ID + " .ctm-tools{display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr auto;gap:7px;align-items:end;margin:8px 0 9px;}"
  	    + "#" + ROOT_ID + " label{display:block;color:#bdbdbd;font-size:10px;font-weight:650;margin-bottom:2px;}"
  	    + "#" + ROOT_ID + " input,#" + ROOT_ID + " select,#" + ROOT_ID + " textarea{width:100%;background:#0f0f0f;border:1px solid #3c3c3c;border-radius:5px;color:#eee;padding:5px 8px;font-size:12px;outline:none;min-height:30px;}"
  	    + "#" + ROOT_ID + " input:focus,#" + ROOT_ID + " select:focus,#" + ROOT_ID + " textarea:focus{border-color:#6a6a6a;box-shadow:none;}"
  	    + "#" + ROOT_ID + " textarea{min-height:46px;resize:vertical;}" + "#" + ROOT_ID + " button{border:none;border-radius:5px;color:#fff;padding:7px 10px;font-size:12px;font-weight:750;cursor:pointer;}"
  	    + "#" + ROOT_ID + " button:hover{filter:brightness(1.08);}"
  	    + "#" + ROOT_ID + " button:disabled{opacity:.48;cursor:not-allowed;}"
  	    + "#" + ROOT_ID + " .ctm-btn-main{background:#b86635;}"
  	    + "#" + ROOT_ID + " .ctm-btn-muted{background:#555;}"
  	    + "#" + ROOT_ID + " .ctm-btn-dark{background:#2a2a2a;}"
  	    + "#" + ROOT_ID + " .ctm-btn-green{background:#3d7d40;}"
  	    + "#" + ROOT_ID + " .ctm-btn-orange{background:#9a5d2e;}"
  	    + "#" + ROOT_ID + " .ctm-btn-red{background:#8a3b37;}"
  	    + "#" + ROOT_ID + " .ctm-list{display:flex;flex-direction:column;gap:3px;}"
  	    + "#" + ROOT_ID + " .ctm-list-head{display:grid;grid-template-columns:2.4fr 1.1fr .65fr .65fr .9fr 1fr;gap:8px;color:#b86635;font-size:10px;font-weight:800;text-transform:uppercase;padding:0 9px 3px;}"
  	    + "#" + ROOT_ID + " .ctm-row{display:grid;grid-template-columns:2.4fr 1.1fr .65fr .65fr .9fr 1fr;gap:8px;align-items:center;background:rgba(18,18,18,.86);border:1px solid #282828;border-radius:5px;padding:5px 9px;cursor:pointer;transition:background .12s,border-color .12s;min-height:36px;}"
  	    + "#" + ROOT_ID + " .ctm-row:hover{background:#191919;border-color:#4a4a4a;}"
  	    + "#" + ROOT_ID + " .ctm-sort-head{width:auto;background:transparent!important;border:0!important;color:#b86635!important;padding:0!important;margin:0!important;font-size:10px!important;font-weight:850!important;text-transform:uppercase!important;text-align:left!important;box-shadow:none!important;}"
  	    + "#" + ROOT_ID + " .ctm-sort-head:hover{color:#e08b53!important;text-decoration:underline;filter:none!important;}" + "#" + ROOT_ID + " .ctm-fleet{font-weight:800;color:#f4f4f4;font-size:12px;line-height:1.12;}"
  	    + "#" + ROOT_ID + " .ctm-desc{color:#888;font-size:10px;margin-top:1px;line-height:1.18;}"
  	    + "#" + ROOT_ID + " .ctm-small{color:#b7b7b7;font-size:11px;line-height:1.15;}"
  	    + "#" + ROOT_ID + " .ctm-muted{color:#777;font-size:10px;line-height:1.15;}"
  	    + "#" + ROOT_ID + " .ctm-badge{display:inline-flex;align-items:center;border-radius:5px;padding:2px 7px;font-size:10px;font-weight:800;white-space:nowrap;}"
  	    + "#" + ROOT_ID + " .ctm-empty{border:1px dashed #333;background:#121212;border-radius:5px;padding:24px;text-align:center;color:#777;}"
  	    + "#" + ROOT_ID + " .ctm-modal{position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,.58);display:flex;align-items:flex-start;justify-content:center;padding:72px 18px 18px;}"
  	    + "#" + ROOT_ID + " .ctm-card{width:800px;max-width:100%;max-height:calc(100vh - 95px);background:#151515;border:1px solid #343434;border-radius:5px;box-shadow:0 18px 55px rgba(0,0,0,.78);overflow:hidden;}"
  	    + "#" + ROOT_ID + " .ctm-card-head{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:8px 13px;border-bottom:1px solid #303030;background:#1a1a1a;}"
  	    + "#" + ROOT_ID + " .ctm-card-title{color:#cc6633;font-weight:800;font-size:15px;}"
  	    + "#" + ROOT_ID + " .ctm-card-head-actions{display:flex;align-items:center;gap:7px;}"
  	    + "#" + ROOT_ID + " .ctm-print-head-btn{background:#2a2a2a!important;border:1px solid #444!important;padding:6px 9px!important;font-size:12px!important;height:28px!important;display:inline-flex!important;align-items:center!important;gap:5px!important;}"
  	    + "#" + ROOT_ID + " .ctm-card-body{padding:9px 12px 10px;overflow:auto;max-height:calc(100vh - 135px);}"
  	    + "#" + ROOT_ID + " .ctm-grid2{display:grid;grid-template-columns:1fr 1fr;gap:6px 10px;}"
  	    + "#" + ROOT_ID + " .ctm-note{color:#999;font-size:11px;line-height:1.3;margin-bottom:7px;}"
  	    + "#" + ROOT_ID + " .ctm-preview{border:1px solid #303030;background:#111;border-radius:5px;padding:7px 9px;margin:7px 0;color:#d0d0d0;font-size:12px;line-height:1.35;max-height:88px;overflow:auto;}"
  	    + "#" + ROOT_ID + " .ctm-popup-actions{display:grid;grid-template-columns:repeat(4,minmax(120px,1fr));gap:7px;margin:7px 0 9px;}"
  	    + "#" + ROOT_ID + " .ctm-popup-actions button{padding:7px 10px;font-size:12px;}"
  	    + "#" + ROOT_ID + " .ctm-bottom-actions{display:flex;gap:7px;justify-content:flex-end;margin-top:8px;flex-wrap:wrap;}"
  	    + "#" + ROOT_ID + " .ctm-detail-top{display:flex;justify-content:space-between;gap:12px;align-items:flex-start;margin-bottom:7px;}"
  	    + "#" + ROOT_ID + " .ctm-detail-name{font-size:18px;font-weight:850;color:#f4f4f4;line-height:1.05;}"
  	    + "#" + ROOT_ID + " .ctm-detail-sub{font-size:12px;color:#888;margin-top:2px;line-height:1.2;}"
  	    + "#" + ROOT_ID + " .ctm-section-title{color:#cc6633;font-size:13px;font-weight:850;margin:8px 0 5px;}"
  	    + "#" + ROOT_ID + " .ctm-transaction-shell{margin:8px 0;}"
  	    + "#" + ROOT_ID + " .ctm-transaction-panel{border:1px solid #303030;background:#111;border-radius:5px;padding:8px;margin-top:7px;}"
  	    + "#" + ROOT_ID + " .ctm-history-wrap{margin-top:8px;border-top:1px solid #292929;padding-top:7px;}"
  	    + "#" + ROOT_ID + " .ctm-history-scroll{max-height:220px;overflow:auto;border:1px solid #303030;border-radius:5px;background:#0f0f0f;}"+ "#" + ROOT_ID + " .ctm-history-table{width:100%;border-collapse:collapse;font-size:11px;min-width:980px;}"
  	    + "#" + ROOT_ID + " .ctm-history-table th{position:sticky;top:0;background:#191919;color:#b86635;text-align:left;font-size:10px;text-transform:uppercase;padding:7px;border-bottom:1px solid #333;z-index:1;}"
  	    + "#" + ROOT_ID + " .ctm-history-table td{padding:7px;border-bottom:1px solid #242424;color:#cfcfcf;vertical-align:top;}"
  	    + "#" + ROOT_ID + " .ctm-history-row{cursor:pointer;}"
  	    + "#" + ROOT_ID + " .ctm-history-row:hover td{background:#181818;}"
  	    + "#" + ROOT_ID + " .ctm-history-selected td{background:#202020!important;color:#fff;}"
  	    + "#" + ROOT_ID + " .ctm-history-detail-row td{background:#111!important;border-bottom:1px solid #333;}"
  	    + "#" + ROOT_ID + " .ctm-history-detail-grid{display:grid;grid-template-columns:repeat(3,minmax(160px,1fr));gap:8px;}"
  	    + "#" + ROOT_ID + " .ctm-history-detail-label{color:#888;font-size:9px;font-weight:800;text-transform:uppercase;margin-bottom:2px;}"
  	    + "#" + ROOT_ID + " .ctm-history-detail-value{color:#eee;font-size:11px;word-break:break-word;}"
  	    + "@media(max-width:1000px){#" + ROOT_ID + "{padding:64px 8px 8px 8px!important;}#" + ROOT_ID + " .ctm-panel{width:100%;}#" + ROOT_ID + " .ctm-tools{grid-template-columns:1fr 1fr;}#" + ROOT_ID + " .ctm-company-row{grid-template-columns:1fr;}#" + ROOT_ID + " .ctm-list-head{display:none;}#" + ROOT_ID + " .ctm-row{grid-template-columns:1fr;}#" + ROOT_ID + " .ctm-grid2{grid-template-columns:1fr;}#" + ROOT_ID + " .ctm-popup-actions{grid-template-columns:1fr;}#" + ROOT_ID + " .ctm-history-detail-grid{grid-template-columns:1fr;}}"
  	    + "#" + ROOT_ID + " .ctm-panel{width:100%!important;max-width:none!important;margin:0!important;height:100%!important;min-height:0!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;background:#111!important;border-radius:0!important;flex:1 1 auto!important;}"
  	    + "#" + ROOT_ID + " .ctm-wrap{width:100%!important;max-width:none!important;min-width:980px!important;height:100%!important;min-height:0!important;display:flex!important;flex-direction:column!important;padding:6px 8px 0!important;overflow:hidden!important;}"
  	    + "#" + ROOT_ID + " #ctmListMount{width:100%!important;max-width:none!important;flex:1 1 auto!important;min-height:0!important;overflow:auto!important;padding-bottom:8px!important;}"
  	    + "#" + ROOT_ID + " .ctm-list-head,#" + ROOT_ID + " .ctm-row{grid-template-columns:96px 2.1fr .9fr .65fr .65fr .9fr 1.1fr 1fr!important;}"
  	    + "#" + ROOT_ID + " .ctm-tyre-visual-wrap{display:flex;flex-direction:column;align-items:flex-start;gap:2px;min-width:76px;}"
  	    + "#" + ROOT_ID + " .ctm-tyre-visual-large{flex-direction:row;align-items:center;gap:13px;min-width:300px;}"
  	    + "#" + ROOT_ID + " .ctm-tyre-graphic{position:relative;width:76px;height:25px;border:2px solid #050505;border-radius:4px;background-color:var(--ctm-tyre-color,#6b7280);background-image:linear-gradient(45deg,rgba(0,0,0,.82) 25%,transparent 25%,transparent 50%,rgba(0,0,0,.82) 50%,rgba(0,0,0,.82) 75%,transparent 75%,transparent),linear-gradient(-45deg,rgba(0,0,0,.72) 25%,transparent 25%,transparent 50%,rgba(0,0,0,.72) 50%,rgba(0,0,0,.72) 75%,transparent 75%,transparent);background-size:10px 10px;box-shadow:inset 0 0 0 1px rgba(255,255,255,.16),inset 0 -7px 11px rgba(0,0,0,.38),0 1px 4px rgba(0,0,0,.75);overflow:hidden;}"
  	    + "#" + ROOT_ID + " .ctm-tyre-graphic:before{content:'';position:absolute;left:3px;right:3px;top:3px;height:3px;border-radius:3px;background:rgba(255,255,255,.18);}"
  	    + "#" + ROOT_ID + " .ctm-tyre-visual-large .ctm-tyre-graphic{width:180px;height:46px;border-radius:6px;background-size:13px 13px;}"
  	    + "#" + ROOT_ID + " .ctm-tyre-visual-text{font-size:9px;line-height:1.15;color:#8f8f8f;font-weight:750;white-space:nowrap;}"
  	    + "#" + ROOT_ID + " .ctm-tyre-visual-large .ctm-tyre-visual-text{font-size:12px;line-height:1.35;color:#bdbdbd;}"
  	    + "#" + ROOT_ID + " .ctm-list{width:100%!important;}"
  	    + "#" + ROOT_ID + " .ctm-list-head,#" + ROOT_ID + " .ctm-row{width:100%!important;grid-template-columns:96px minmax(230px,2.1fr) minmax(130px,.9fr) minmax(80px,.65fr) minmax(80px,.65fr) minmax(130px,.9fr) minmax(150px,1.1fr) minmax(160px,1fr)!important;}"
  	    + "#" + ROOT_ID + " .ctm-list-head{position:sticky!important;top:0!important;z-index:5!important;background:rgba(17,17,17,.98)!important;padding-top:4px!important;border-bottom:1px solid #292929!important;}"
  	    + "#" + ROOT_ID + " #ctmListMount::-webkit-scrollbar{width:10px;height:10px;}"
  	    + "#" + ROOT_ID + " #ctmListMount::-webkit-scrollbar-thumb{background:#333;border-radius:8px;}"
  	    + "#" + ROOT_ID + " #ctmListMount::-webkit-scrollbar-track{background:#111;}"
  	    + "</style>";
  	  }

  	  function buttonHtml(id,
  	    label,
  	    className,
  	    extraAttrs) {
  	    return "<button id=\"" + escapeHtml(id) + "\" type=\"button\" class=\"" + escapeHtml(className || "ctm-btn-main") + "\" " + (extraAttrs || "") + ">" + escapeHtml(label) + "</button>";
  	  }

  	  function statPillHtml(label,
  	    value) {
  	    return "<div class=\"ctm-stat\"><span>" + escapeHtml(label) + "</span><span>" + escapeHtml(value) + "</span></div>";
  	  }

  	  function optionHtml(value,
  	    current,
  	    label) {
  	    return "<option value=\"" + escapeHtml(value) + "\"" + (value === current ? " selected": "") + ">" + escapeHtml(label || value) + "</option>";
  	  }

  	  function fieldHtml(id,
  	    label,
  	    value,
  	    placeholder,
  	    type) {
  	    return ""
  	    + "<div>"
  	    + "  <label>" + escapeHtml(label) + "</label>"
  	    + "  <input id=\"" + escapeHtml(id) + "\" type=\"" + escapeHtml(type || "text") + "\" value=\"" + escapeHtml(value || "") + "\" placeholder=\"" + escapeHtml(placeholder || "") + "\">"
  	    + "</div>";
  	  }

  	  function textareaHtml(id,
  	    label,
  	    placeholder,
  	    value) {
  	    return ""
  	    + "<div>"
  	    + "  <label>" + escapeHtml(label) + "</label>"
  	    + "  <textarea id=\"" + escapeHtml(id) + "\" placeholder=\"" + escapeHtml(placeholder || "") + "\">" + escapeHtml(value || "") + "</textarea>"
  	    + "</div>";
  	  }

  	  function selectHtml(id,
  	    label,
  	    values,
  	    current) {
  	    return ""
  	    + "<div>"
  	    + "  <label>" + escapeHtml(label) + "</label>"
  	    + "  <select id=\"" + escapeHtml(id) + "\">"
  	    + values.map(function (value) {
  	      return optionHtml(value, current, value);
  	    }).join("")
  	    + "  </select>"
  	    + "</div>";
  	  }

  	  function companySelectHtml() {
  	    return ""
  	    + "<div class=\"ctm-company-row\">"
  	    + "  <div>"
  	    + "    <label>Company Tyres</label>"
  	    + "    <select id=\"ctmCompanyFilter\">"
  	    + (companies.length
  	      ? companies.map(function (company) {
  	        return optionHtml(company.id, state.companyId, company.name);
  	      }).join(""): "<option value=\"\">No accessible companies</option>")
  	    + "    </select>"
  	    + "  </div>"
  	    + "  <div style=\"display:flex;gap:7px;justify-content:flex-start;align-items:end;\">"
  	    + buttonHtml("ctmNewTyresBtn",
  	      "New Tyres",
  	      "ctm-btn-main")
  	    + buttonHtml("ctmRefreshBtn",
  	      "Refresh",
  	      "ctm-btn-muted")
  	    + "  </div>"
  	    + "</div>";
  	  }

  	  function filtersHtml() {
  	    return ""
  	    + "<div class=\"ctm-tools\">"
  	    + "  <div>"
  	    + "    <label>Search</label>"
  	    + "    <input id=\"ctmSearch\" value=\"" + escapeHtml(state.search) + "\" placeholder=\"ID, serial, make, size, vehicle, stage...\">"
  	    + "  </div>"
  	    + "  <div>"
  	    + "    <label>Location</label>"
  	    + "    <select id=\"ctmLocationFilter\">"
  	    + optionHtml("All",
  	      state.locationFilter,
  	      "All")
  	    + optionHtml("Warehouse",
  	      state.locationFilter,
  	      "Warehouse")
  	    + optionHtml("Fitted",
  	      state.locationFilter,
  	      "Fitted")
  	    + "    </select>"
  	    + "  </div>"
  	    + "  <div>"
  	    + "    <label>Status</label>"
  	    + "    <select id=\"ctmStatusFilter\">"
  	    + optionHtml("All",
  	      state.statusFilter,
  	      "All")
  	    + optionHtml(TYRE_STATUS.OK,
  	      state.statusFilter,
  	      TYRE_STATUS.OK)
  	    + optionHtml(TYRE_STATUS.RETREAD,
  	      state.statusFilter,
  	      TYRE_STATUS.RETREAD)
  	    + optionHtml(TYRE_STATUS.SCRAPPED,
  	      state.statusFilter,
  	      TYRE_STATUS.SCRAPPED)
  	    + optionHtml(TYRE_STATUS.STOLEN,
  	      state.statusFilter,
  	      TYRE_STATUS.STOLEN)
  	    + "    </select>"
  	    + "  </div>"
  	    + "  <div>"
  	    + "    <label>Stage</label>"
  	    + "    <select id=\"ctmStageFilter\">"
  	    + optionHtml("All",
  	      state.stageFilter,
  	      "All")
  	    + STAGES.map(function (stage) {
  	      return optionHtml(stage, state.stageFilter, stage);
  	    }).join("")
  	    + "    </select>"
  	    + "  </div>"
  	    + "  <div>"
  	    + "    <label>Type</label>"
  	    + "    <select id=\"ctmTypeFilter\">"
  	    + optionHtml("All",
  	      state.typeFilter,
  	      "All")
  	    + TYPES.map(function (type) {
  	      return optionHtml(type, state.typeFilter, type);
  	    }).join("")
  	    + "    </select>"
  	    + "  </div>"
  	    + "  <div></div>"
  	    + "</div>";
  	  }

  	  function statusBadgeHtml(tyre) {
  	    var status = tyreStatus(tyre);
  	    var bg = "#444";

  	    if (status === TYRE_STATUS.OK) bg = "#3d6f40";
  	    if (status === TYRE_STATUS.RETREAD) bg = "#8a5a33";
  	    if (status === TYRE_STATUS.SCRAPPED) bg = "#7b3935";
  	    if (status === TYRE_STATUS.STOLEN) bg = "#4e455f";

  	    return "<span class=\"ctm-badge\" style=\"background:" + bg + ";\">" + escapeHtml(status) + "</span>";
  	  }

  	  function mileageWarningText(tyre) {
  	    return clean(tyre && tyre.Mileage_Warning);
  	  }

  	  function mileageWarningHtml(tyre) {
  	    var warning = mileageWarningText(tyre);
  	    var bg = "#333";
  	    var color = "#d0d0d0";

  	    if (!warning || warning.toLowerCase() === "null") {
  	      return "<span class=\"ctm-muted\">—</span>";
  	    }

  	    if (warning === "Over Mileage") {
  	      bg = "#ef3b24";
  	      color = "#ffffff";
  	    } else if (warning === "5000km Warning") {
  	      bg = "#f28c28";
  	      color = "#ffffff";
  	    } else if (warning === "10000km Warning") {
  	      bg = "#ffd23f";
  	      color = "#111111";
  	    } else if (warning === "15000km Warning") {
  	      bg = "#ffff3f";
  	      color = "#111111";
  	    }

  	    return "<span class=\"ctm-badge\" style=\"background:" + bg + ";color:" + color + ";\">" + escapeHtml(warning) + "</span>";
  	  }

  	  function locationText(tyre) {
  	    if (tyreIsFitted(tyre)) {
  	      return clean(tyre.Vehicle_ID) || "Fitted";
  	    }

  	    if (tyreStatus(tyre) === TYRE_STATUS.OK) {
  	      return "Warehouse";
  	    }

  	    return "Not fitted";
  	  }

  	  function locationSubText(tyre) {
  	    if (tyreIsFitted(tyre)) {
  	      return clean(tyre.Current_Position);
  	    }

  	    return "";
  	  }

  	  function locationHtml(tyre) {
  	    if (tyreIsFitted(tyre)) {
  	      return ""
  	      + "<div class=\"ctm-small\" style=\"font-weight:750;color:#eee;\">" + escapeHtml(locationText(tyre)) + "</div>"
  	      + "<div class=\"ctm-muted\">" + escapeHtml(locationSubText(tyre)) + "</div>";
  	    }

  	    if (tyreStatus(tyre) === TYRE_STATUS.OK) {
  	      return "<span class=\"ctm-small\" style=\"color:#a7d8aa;font-weight:750;\">Warehouse</span>";
  	    }

  	    return "<span class=\"ctm-muted\">Not fitted</span>";
  	  }

  	  function listHtml() {
  	    var tyres = filteredTyres();

  	    if (!companies.length) {
  	      return "<div class=\"ctm-empty\">No accessible companies were found.</div>";
  	    }

  	    if (!tyres.length) {
  	      return "<div class=\"ctm-empty\">No tyres match the current filters.</div>";
  	    }

  	    return ""
  	    + "<div class=\"ctm-list-head\">"
  	    + "  <div></div>"
  	    + "  <div>" + sortHeaderHtml("tyre", "Tyre") + "</div>"
  	    + "  <div>" + sortHeaderHtml("remainingMileage", "Remaining Mileage") + "</div>"
  	    + "  <div>" + sortHeaderHtml("type", "Type") + "</div>"
  	    + "  <div>" + sortHeaderHtml("stage", "Stage") + "</div>"
  	    + "  <div>" + sortHeaderHtml("status", "Status") + "</div>"
  	    + "  <div>" + sortHeaderHtml("warning", "Warning") + "</div>"
  	    + "  <div>" + sortHeaderHtml("location", "Location") + "</div>"
  	    + "</div>"
  	    + "<div class=\"ctm-list\">"
  	    + tyres.map(function (tyre) {
  	      var id = tyreObjectId(tyre);

  	      return ""
  	      + "<div class=\"ctm-row\" data-row-id=\"" + escapeHtml(id) + "\" title=\"Click to open tyre details\">"
  	      + "  <div>" + tyreGraphicHtml(tyre, "row") + "</div>"
  	      + "  <div>"
  	      + "    <div class=\"ctm-fleet\">" + escapeHtml(tyreNumber(tyre) || id || "Unsaved tyre") + "</div>"
  	      + "    <div class=\"ctm-desc\">" + escapeHtml([tyreMake(tyre), tyreModel(tyre), tyreSize(tyre)].filter(Boolean).join(" - ") || "No make/model/size") + "</div>"
  	      + "  </div>"
  	      + "  <div class=\"ctm-small\" style=\"font-weight:850;color:#eee;\">" + escapeHtml(formatMileage(tyreRemainingMileage(tyre))) + "</div>" + "  <div class=\"ctm-small\">" + escapeHtml(tyreType(tyre) || "—") + "</div>"
  	      + "  <div class=\"ctm-small\" style=\"font-weight:750;color:#eee;\">" + escapeHtml(tyreStage(tyre)) + "</div>"
  	      + "  <div>" + statusBadgeHtml(tyre) + "</div>"
  	      + "  <div>" + mileageWarningHtml(tyre) + "</div>"
  	      + "  <div>" + locationHtml(tyre) + "</div>"
  	      + "</div>";
  	    }).join("")
  	    + "</div>";
  	  }

  	  function updateListOnly() {
  	    var mount = DocumentSafe.getElementById("ctmListMount");

  	    if (mount) {
  	      mount.innerHTML = listHtml();
  	    }
  	  }

  	  function modalShellHtml(title, innerHtml) {
  	    var showPrint = state.modal && state.modal.type === "tyre";

  	    return ""
  	    + "<div class=\"ctm-modal\" id=\"ctmModal\">"
  	    + "  <div class=\"ctm-card\" id=\"ctmModalCard\">"
  	    + "    <div class=\"ctm-card-head\">"
  	    + "      <div class=\"ctm-card-title\">" + escapeHtml(title) + "</div>"
  	    + "      <div class=\"ctm-card-head-actions\">"
  	    + (showPrint ? "        <button id=\"ctmPrintTyreReport\" type=\"button\" class=\"ctm-print-head-btn\">🖨 Print</button>": "")
  	    + "        <button id=\"ctmModalClose\" type=\"button\" class=\"ctm-btn-dark\">✕</button>"
  	    + "      </div>"
  	    + "    </div>"
  	    + "    <div class=\"ctm-card-body\">"
  	    + innerHtml
  	    + "    </div>"
  	    + "  </div>"
  	    + "</div>";
  	  }

  	  function tyreDetailActionsHtml(tyre) {
  	    var status = tyreStatus(tyre);
  	    var stage = tyreStage(tyre);
  	    var next = nextStage(stage);
  	    var fitted = tyreIsFitted(tyre);

  	    return ""
  	    + "<div class=\"ctm-popup-actions\">"
  	    + (fitted ? "<button type=\"button\" class=\"ctm-btn-dark\" disabled>Remove From Vehicle First</button>": "")
  	    + (!fitted && status !== TYRE_STATUS.RETREAD && status !== TYRE_STATUS.SCRAPPED && status !== TYRE_STATUS.STOLEN && next ? buttonHtml("ctmDetailSendRetread", "Send For Retread", "ctm-btn-orange"): "")
  	    + (!fitted && status === TYRE_STATUS.RETREAD && next ? buttonHtml("ctmDetailCompleteRetread", "Complete Retread → " + next, "ctm-btn-green"): "")
  	    + (!fitted && status !== TYRE_STATUS.SCRAPPED && status !== TYRE_STATUS.STOLEN ? buttonHtml("ctmDetailScrap", "Scrap Tyre", "ctm-btn-red"): "")
  	    + ""
  	    + "</div>";
  	  }

  	  function tyreDetailModalHtml() {
  	    var tyre = findTyreById(state.modal && state.modal.tyreId);
  	    var status;
  	    var stage;

  	    if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	      return modalShellHtml("Tyre Details", "<div style=\"color:#d98f8f;\">You do not have access to this tyre.</div>");
  	    }

  	    status = tyreStatus(tyre);
  	    stage = tyreStage(tyre);

  	    return modalShellHtml("Tyre Details", ""
  	      + "<div class=\"ctm-detail-top\">"
  	      + "  <div style=\"display:flex;gap:14px;align-items:center;min-width:0;\">"
  	      + tyreGraphicHtml(tyre, "large")
  	      + "    <div style=\"min-width:0;\">"
  	      + "      <div class=\"ctm-detail-name\">" + escapeHtml(tyreNumber(tyre) || tyreObjectId(tyre)) + "</div>"
  	      + "      <div class=\"ctm-detail-sub\">" + escapeHtml([tyreMake(tyre), tyreModel(tyre), tyreSize(tyre)].filter(Boolean).join(" - ") || "No tyre details") + "</div>"
  	      + "    </div>"
  	      + "  </div>"
  	      + "  <div style=\"display:flex;gap:6px;align-items:center;flex-wrap:wrap;justify-content:flex-end;\">"
  	      + statusBadgeHtml(tyre)
  	      + "    <span class=\"ctm-badge\" style=\"background:#333;\">" + escapeHtml(stage) + "</span>"
  	      + "  </div>"
  	      + "</div>"

  	      + tyreDetailActionsHtml(tyre)

  	      + "<div class=\"ctm-grid2\">"
  	      + fieldHtml("ctmEditId", "Company Fleet Number", clean(tyre.ID || tyre.FID || tyre.Tyre_Number || tyre.TyreNumber), "FLE TY 00001")
  	      + fieldHtml("ctmEditSerial", "Serial Number", tyreSerial(tyre), "Can be edited later")
  	      + fieldHtml("ctmEditMake", "Make", tyreMake(tyre), "Dunlop")
  	      + fieldHtml("ctmEditModel", "Model / Pattern", tyreModel(tyre), "SP 700")
  	      + fieldHtml("ctmEditSize", "Size", tyreSize(tyre), "225 80 R20")
  	      + selectHtml("ctmEditType", "Type", TYPES, tyreType(tyre) || "Drive")
  	      + fieldHtml(
  	        "ctmCurrentMileage",
  	        currentMileageLockedForStage(tyre) ? "Current Mileage - Locked This Stage": "Current Mileage - Once Per Stage",
  	        clean(tyre.Current_Mileage),
  	        currentMileageLockedForStage(tyre) ? "Already set for this stage": "Set once for this stage",
  	        "number"
  	      )
  	      + fieldHtml("ctmRemainingKm", "Remaining KM Estimate", "", "Used to calculate Expected Mileage", "number")
  	      + fieldHtml("ctmActionCost", "Action Cost", "", "Required for completed retreads", "number")
  	      + "</div>"

  	      + transactionPanelHtml()

  	      + textareaHtml("ctmEditNotes", "Edit Notes", "What changed?", "")

  	      + "<div class=\"ctm-preview\">"
  	      + "  <b>Company:</b> " + escapeHtml(clean(tyre.__CompanyName) || "Unassigned") + "<br>"
  	      + "  <b>Location:</b> " + escapeHtml(tyreIsFitted(tyre) ? clean(tyre.Vehicle_ID) + " / " + clean(tyre.Current_Position): tyreStatus(tyre) === TYRE_STATUS.OK ? "Warehouse": "Not fitted") + "<br>"
  	      + "  <b>ObjectId:</b> " + escapeHtml(tyreObjectId(tyre)) + "<br>"
  	      + "  <b>Status:</b> " + escapeHtml(status) + "<br>"
  	      + "  <b>Stage:</b> " + escapeHtml(stage)
  	      + "</div>"

  	      + tyreHistoryTableHtml(tyre)

  	      + "<div class=\"ctm-bottom-actions\">"
  	      + buttonHtml("ctmSaveEditTyre", "Save Details", "ctm-btn-green")
  	      + buttonHtml("ctmCancelModal", "Close", "ctm-btn-muted")
  	      + "</div>"
  	    );
  	  }

  	  function newTyresModalHtml() {
  	    var prefix = state.bulkPrefix || DEFAULT_FLEET_PREFIX;
  	    var nextNumber = nextFleetSequence(prefix);
  	    var count = state.bulkCount || 1;
  	    var preview = bulkPreviewIds(prefix, nextNumber, count);

  	    return modalShellHtml("New Tyres", ""
  	      + "<div class=\"ctm-grid2\">"
  	      + fieldHtml("ctmBulkPrefix", "Fleet Prefix", prefix, "FLE TY")
  	      + fieldHtml("ctmBulkStart", "Start Number", String(nextNumber), "Auto", "number")
  	      + fieldHtml("ctmBulkCount", "Quantity", String(count), "1", "number")
  	      + fieldHtml("ctmBulkCost", "Cost Per Tyre", "", "Required", "number")
  	      + selectHtml("ctmBulkType", "Type", TYPES, "Drive")
  	      + fieldHtml("ctmBulkMake", "Make", "", "Dunlop")
  	      + fieldHtml("ctmBulkModel", "Model / Pattern", "", "SP 700")
  	      + fieldHtml("ctmBulkSize", "Size", "", "225 80 R20")
  	      + fieldHtml("ctmBulkSerialPrefix", "Optional Serial Prefix", "", "Leave blank")
  	      + fieldHtml("ctmBulkPurchaseRef", "Purchase Ref / Invoice", "", "Optional")
  	      + "</div>"

  	      + textareaHtml("ctmBulkNotes", "Notes", "Serial numbers can be added later.", "Serial numbers can be added later.")

  	      + "<div class=\"ctm-preview\">"
  	      + "  <div style=\"color:#cc6633;font-weight:750;margin-bottom:5px;\">Preview</div>"
  	      + "  <div id=\"ctmBulkPreview\">" + escapeHtml(preview.join(", ")) + "</div>"
  	      + "</div>"

  	      + "<div class=\"ctm-bottom-actions\">"
  	      + buttonHtml("ctmConfirmBulkCreate", "Create Tyres", "ctm-btn-green")
  	      + buttonHtml("ctmCancelModal", "Cancel", "ctm-btn-muted")
  	      + "</div>"
  	    );
  	  }

  	  function modalHtml() {
  	    if (!state.modal) {
  	      return "";
  	    }

  	    if (state.modal.type === "new") {
  	      return newTyresModalHtml();
  	    }

  	    if (state.modal.type === "tyre") {
  	      return tyreDetailModalHtml();
  	    }

  	    return "";
  	  }

  	  function render() {
  	    var c = counts();

  	    hubEl = createOwnRootDiv();

  	    hubEl.innerHTML = cssHtml()
  	    + "<div class=\"ctm-panel\" id=\"ctmPanel\">"
  	    + "  <div class=\"ctm-main-head-actions\">"
  	    + "    <button id=\"ctmPrintWarehouseReport\" type=\"button\" class=\"ctm-print-head-btn\">🖨 Print</button>"
  	    + "    <button id=\"ctmCloseX\" type=\"button\" class=\"ctm-close-main\">×</button>"
  	    + "  </div>"
  	    + "  <div class=\"ctm-wrap\">"
  	    + "    <div class=\"ctm-head\">"
  	    + "      <div>"
  	    + "        <div class=\"ctm-title\">Company Tyre Manager</div>"
  	    + "      </div>"
  	    + "      <div class=\"ctm-message\" style=\"color:" + (state.messageError ? "#d98f8f": "#a7d8aa") + ";\">"
  	    + escapeHtml(state.busy ? "Working...": state.message)
  	    + "      </div>"
  	    + "    </div>"
  	    + companySelectHtml()
  	    + "    <div class=\"ctm-stats\">"
  	    + statPillHtml("Total", c.total)
  	    + statPillHtml("Warehouse", c.warehouse)
  	    + statPillHtml("Fitted", c.fitted)
  	    + statPillHtml("Retread", c.retread)
  	    + statPillHtml("Scrapped", c.scrapped)
  	    + statPillHtml("New", c.newStage)
  	    + statPillHtml("Cap1", c.cap1)
  	    + statPillHtml("Cap2", c.cap2)
  	    + statPillHtml("Cap3", c.cap3)
  	    + "    </div>"
  	    + filtersHtml()
  	    + "    <div id=\"ctmListMount\">"
  	    + listHtml()
  	    + "    </div>"
  	    + "  </div>"
  	    + "</div>"
  	    + modalHtml();

  	    wireEvents();
  	  }

  	  function setMessage(message, isError) {
  	    state.message = message || "";
  	    state.messageError = !!isError;
  	  }

  	  function beginSave() {
  	    state.busy = true;
  	    setMessage("Saving...", false);
  	    render();
  	  }

  	  function finishSave(message) {
  	    state.busy = false;
  	    state.modal = null;
  	    setMessage(message, false);
  	    render();
  	  }

  	  function failSave(error) {
  	    state.busy = false;
  	    setMessage(error && error.message ? error.message: "Save failed.", true);
  	    render();
  	  }

  	  function createNewTyresFromModal() {
  	    var prefix = normaliseFleetPrefix(readValue("ctmBulkPrefix") || DEFAULT_FLEET_PREFIX);
  	    var start = Math.max(1, Number(readValue("ctmBulkStart")) || nextFleetSequence(prefix));
  	    var count = Math.max(1, Math.min(500, Number(readValue("ctmBulkCount")) || 1));
  	    var cost = numberOrNull(readValue("ctmBulkCost"));
  	    var make = readValue("ctmBulkMake");
  	    var model = readValue("ctmBulkModel");
  	    var size = readValue("ctmBulkSize");
  	    var type = readValue("ctmBulkType") || "Drive";
  	    var serialPrefix = readValue("ctmBulkSerialPrefix");
  	    var purchaseRef = readValue("ctmBulkPurchaseRef");
  	    var notes = readValue("ctmBulkNotes");
  	    var batchId = "NEW-TYRES-" + nowIso();
  	    var ids = bulkPreviewIds(prefix, start, count);
  	    var duplicateIds = [];
  	    var tyres = [];
  	    var company = selectedCompany();

  	    if (!company || !company.id) {
  	      alertSafe("Select a company before creating tyres.");
  	      return;
  	    }

  	    if (cost === null || cost <= 0) {
  	      alertSafe("Cost Per Tyre is required.");
  	      return;
  	    }

  	    ids.forEach(function (id) {
  	      companyScopedTyres().forEach(function (existing) {
  	        if (
  	          clean(existing.ID) === id ||
  	          clean(existing.FID) === id ||
  	          clean(existing.Tyre_Number) === id ||
  	          clean(existing.TyreNumber) === id
  	        ) {
  	          duplicateIds.push(id);
  	        }
  	      });
  	    });

  	    if (duplicateIds.length) {
  	      alertSafe("These fleet numbers already exist in this company:\n\n" + duplicateIds.join(", "));
  	      return;
  	    }

  	    if (!make || !model || !size) {
  	      alertSafe("Enter Make, Model / Pattern, and Size.");
  	      return;
  	    }

  	    if (!confirmSafe("Create " + count + " tyre(s)?\n\nCompany: " + company.name + "\nFrom: " + ids[0] + "\nTo: " + ids[ids.length - 1] + "\nCost per tyre: " + cost)) {
  	      return;
  	    }

  	    ids.forEach(function (id, index) {
  	      var tyre = {};
  	      var serial = "";

  	      if (serialPrefix) {
  	        serial = serialPrefix + zeroPad(index + 1, DEFAULT_FLEET_PADDING);
  	      }

  	      tyre.ID = id;
  	      tyre.FID = id;
  	      tyre.Tyre_Number = id;
  	      tyre.Company_ID = company.id;
  	      tyre.Serial_Number = serial;
  	      tyre.Make = make;
  	      tyre.Model = model;
  	      tyre.Size = size;
  	      tyre.Type = type;
  	      tyre.Status = TYRE_STATUS.OK;
  	      tyre.Current_Stage = "New";

  	      clearVehicleFields(tyre);

  	      tyre.History = defaultHistory(tyre);
  	      tyre = applyCostToCurrentStage(tyre, cost);
  	      tyre = appendHistoryEvent(tyre, tyreEvent("Created", {
  	        Notes: notes || "New tyre created. Serial number may be added later.",
  	        Destination: purchaseRef || "",
  	        Cost: cost,
  	        Bulk_Create_Count: count,
  	        Bulk_Create_Batch: batchId
  	      }));

  	      tyre = stampCompanyMeta(tyre, company);

  	      tyres.push(tyre);
  	    });

  	    state.bulkPrefix = prefix;
  	    state.bulkCount = count;

  	    saveTyresSequentially(tyres,
  	      "Creating tyres")
  	    .then(function () {
  	      finishSave("Created " + count + " tyre(s): " + ids[0] + " to " + ids[ids.length - 1] + ".");
  	    })
  	    .catch(failSave);
  	  }

  	  function saveEditedTyreFromModal() {
  	    var tyre = findTyreById(state.modal && state.modal.tyreId);
  	    var updated;
  	    var id = readValue("ctmEditId");
  	    var notes = readValue("ctmEditNotes");
  	    var currentMileageText = readValue("ctmCurrentMileage");
  	    var remainingKmText = readValue("ctmRemainingKm");
  	    var originalCurrentMileage;
  	    var newCurrentMileage;
  	    var company;

  	    if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	      alertSafe("You do not have access to this tyre.");
  	      return;
  	    }

  	    if (!id) {
  	      alertSafe("Company Fleet Number is required.");
  	      return;
  	    }

  	    company = {
  	      id: clean(tyre.__CompanyObjectId),
  	      name: clean(tyre.__CompanyName)
  	    };

  	    updated = clone(tyre);

  	    updated.ID = id;
  	    updated.FID = id;
  	    updated.Tyre_Number = id;
  	    updated.Serial_Number = readValue("ctmEditSerial");
  	    updated.Make = readValue("ctmEditMake");
  	    updated.Model = readValue("ctmEditModel");
  	    updated.Size = readValue("ctmEditSize");
  	    updated.Type = readValue("ctmEditType") || updated.Type || "Drive";

  	    originalCurrentMileage = numberOrNull(tyre.Current_Mileage);
  	    newCurrentMileage = numberOrNull(currentMileageText);

  	    try {
  	      if (
  	        currentMileageText !== "" &&
  	        newCurrentMileage !== null &&
  	        newCurrentMileage !== originalCurrentMileage
  	      ) {
  	        updated = applyCurrentMileageForStage(updated, newCurrentMileage, notes);
  	      }

  	      if (remainingKmText !== "") {
  	        updated = applyExpectedMileageFromRemaining(updated, remainingKmText, notes);
  	      }

  	    } catch (error) {
  	      alertSafe(error && error.message ? error.message: "Could not update tyre mileage or transaction.");
  	      return;
  	    }

  	    updated = appendHistoryEvent(updated, tyreEvent("Edited", {
  	      Notes: notes || "Tyre details edited."
  	    }));

  	    beginSave();

  	    saveTyre(updated, company)
  	    .then(function () {
  	      finishSave("Tyre updated.");
  	    })
  	    .catch(failSave);
  	  }

  	  function sendTyreForRetreadById(tyreId) {
  	    var tyre = findTyreById(tyreId);
  	    var updated;
  	    var company;

  	    if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	      alertSafe("You do not have access to this tyre.");
  	      return;
  	    }

  	    if (tyreIsFitted(tyre)) {
  	      alertSafe("This tyre is still fitted to a vehicle. Remove it from the vehicle first.");
  	      return;
  	    }

  	    if (tyreStatus(tyre) === TYRE_STATUS.SCRAPPED || tyreStatus(tyre) === TYRE_STATUS.STOLEN) {
  	      alertSafe("This tyre cannot be sent for retread because it is " + tyreStatus(tyre) + ".");
  	      return;
  	    }

  	    if (!nextStage(tyreStage(tyre))) {
  	      alertSafe("This tyre is already at Cap3 and cannot advance further.");
  	      return;
  	    }

  	    company = {
  	      id: clean(tyre.__CompanyObjectId),
  	      name: clean(tyre.__CompanyName)
  	    };

  	    updated = clone(tyre);
  	    clearVehicleFields(updated);
  	    updated.Status = TYRE_STATUS.RETREAD;

  	    updated = appendHistoryEvent(updated, tyreEvent("Sent For Retread", {
  	      Destination: "Retread",
  	      Notes: "Tyre sent for retread.",
  	      Retread_From_Stage: tyreStage(updated),
  	      Retread_To_Stage: nextStage(tyreStage(updated))
  	    }));

  	    beginSave();

  	    saveTyre(updated, company)
  	    .then(function () {
  	      finishSave("Tyre sent for retread.");
  	    })
  	    .catch(failSave);
  	  }

  	  function completeTyreRetreadById(tyreId) {
  	    var tyre = findTyreById(tyreId);
  	    var updated;
  	    var fromStage;
  	    var toStage;
  	    var cost = numberOrNull(readValue("ctmActionCost"));
  	    var company;

  	    if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	      alertSafe("You do not have access to this tyre.");
  	      return;
  	    }

  	    if (cost === null || cost <= 0) {
  	      alertSafe("Action Cost is required before completing a retread.");
  	      return;
  	    }

  	    if (tyreIsFitted(tyre)) {
  	      alertSafe("This tyre is still fitted to a vehicle. Remove it from the vehicle first.");
  	      return;
  	    }

  	    fromStage = tyreStage(tyre);
  	    toStage = nextStage(fromStage);

  	    if (!toStage) {
  	      alertSafe("This tyre is already at Cap3 and cannot advance further.");
  	      return;
  	    }

  	    company = {
  	      id: clean(tyre.__CompanyObjectId),
  	      name: clean(tyre.__CompanyName)
  	    };

  	    updated = clone(tyre);
  	    clearVehicleFields(updated);
  	    updated.Status = TYRE_STATUS.OK;
  	    updated.Current_Stage = toStage;

  	    updated = advanceRetreadStage(updated, fromStage, toStage, tyreEvent("Retread Completed", {
  	      Notes: "Retread completed.",
  	      Cost: cost,
  	      Retread_From_Stage: fromStage,
  	      Retread_To_Stage: toStage,
  	      Retread_Cost: cost
  	    }), cost);

  	    beginSave();

  	    saveTyre(updated, company)
  	    .then(function () {
  	      finishSave("Retread completed. Tyre advanced to " + toStage + ".");
  	    })
  	    .catch(failSave);
  	  }

  	  function scrapTyreById(tyreId) {
  	    var tyre = findTyreById(tyreId);
  	    var updated;
  	    var company;

  	    if (!tyre || !canAccessCompanyId(clean(tyre.__CompanyObjectId))) {
  	      alertSafe("You do not have access to this tyre.");
  	      return;
  	    }

  	    if (tyreIsFitted(tyre)) {
  	      alertSafe("This tyre is still fitted to a vehicle. Remove it from the vehicle first.");
  	      return;
  	    }

  	    if (!confirmSafe("Scrap this tyre?\n\n" + tyreName(tyre))) {
  	      return;
  	    }

  	    company = {
  	      id: clean(tyre.__CompanyObjectId),
  	      name: clean(tyre.__CompanyName)
  	    };

  	    updated = clone(tyre);
  	    clearVehicleFields(updated);
  	    updated.Status = TYRE_STATUS.SCRAPPED;

  	    updated = appendHistoryEvent(updated, tyreEvent("Scrapped", {
  	      Destination: "Scrapped",
  	      Notes: "Tyre scrapped.",
  	      Scrap_Reason: "Scrapped from company tyre manager."
  	    }));

  	    beginSave();

  	    saveTyre(updated, company)
  	    .then(function () {
  	      finishSave("Tyre scrapped.");
  	    })
  	    .catch(failSave);
  	  }

  	  function closeManager() {
  	    if (hubEl && hubEl.parentNode) {
  	      hubEl.parentNode.removeChild(hubEl);
  	    }
  	  }

  	  function closePopup() {
  	    state.modal = null;
  	    render();
  	  }

  	  function findTyreById(id) {
  	    var cleanId = clean(id);
  	    var i;

  	    for (i = 0; i < state.tyres.length; i++) {
  	      if (tyreObjectId(state.tyres[i]) === cleanId) {
  	        return state.tyres[i];
  	      }
  	    }

  	    return null;
  	  }

  	  function closestWithAttribute(node, attributeName) {
  	    while (node && node !== hubEl && node.nodeType === 1) {
  	      if (node.getAttribute && node.getAttribute(attributeName) !== null) {
  	        return node;
  	      }

  	      node = node.parentNode;
  	    }

  	    return null;
  	  }

  	  function updateNewTyresPreviewFromInputs() {
  	    var previewEl = DocumentSafe.getElementById("ctmBulkPreview");
  	    var prefix = normaliseFleetPrefix(readValue("ctmBulkPrefix") || DEFAULT_FLEET_PREFIX);
  	    var start = Math.max(1, Number(readValue("ctmBulkStart")) || nextFleetSequence(prefix));
  	    var count = Math.max(1, Math.min(500, Number(readValue("ctmBulkCount")) || 1));
  	    var ids;

  	    if (!previewEl) {
  	      return;
  	    }

  	    ids = bulkPreviewIds(prefix, start, count);
  	    previewEl.textContent = ids.join(", ");
  	  }

  	  function wireEvents() {
  	    var companyFilter = DocumentSafe.getElementById("ctmCompanyFilter");
  	    var search = DocumentSafe.getElementById("ctmSearch");
  	    var locationFilter = DocumentSafe.getElementById("ctmLocationFilter");
  	    var statusFilter = DocumentSafe.getElementById("ctmStatusFilter");
  	    var stageFilter = DocumentSafe.getElementById("ctmStageFilter");
  	    var typeFilter = DocumentSafe.getElementById("ctmTypeFilter");
  	    var bulkPrefixInput = DocumentSafe.getElementById("ctmBulkPrefix");
  	    var bulkStartInput = DocumentSafe.getElementById("ctmBulkStart");
  	    var bulkCountInput = DocumentSafe.getElementById("ctmBulkCount");
  	    var transactionTypeInput = DocumentSafe.getElementById("ctmTransactionType");
  	    var transactionCostInput = DocumentSafe.getElementById("ctmTransactionCost");

  	    if (companyFilter) {
  	      companyFilter.onchange = function () {
  	        state.companyId = companyFilter.value || "";
  	        render();
  	      };
  	    }

  	    if (search) {
  	      search.oninput = function () {
  	        state.search = search.value || "";
  	        updateListOnly();
  	      };
  	    }

  	    if (locationFilter) {
  	      locationFilter.onchange = function () {
  	        state.locationFilter = locationFilter.value || "All";
  	        updateListOnly();
  	      };
  	    }

  	    if (statusFilter) {
  	      statusFilter.onchange = function () {
  	        state.statusFilter = statusFilter.value || "All";
  	        updateListOnly();
  	      };
  	    }

  	    if (stageFilter) {
  	      stageFilter.onchange = function () {
  	        state.stageFilter = stageFilter.value || "All";
  	        updateListOnly();
  	      };
  	    }

  	    if (typeFilter) {
  	      typeFilter.onchange = function () {
  	        state.typeFilter = typeFilter.value || "All";
  	        updateListOnly();
  	      };
  	    }

  	    if (bulkPrefixInput) {
  	      bulkPrefixInput.oninput = function () {
  	        var prefix = normaliseFleetPrefix(bulkPrefixInput.value || DEFAULT_FLEET_PREFIX);
  	        var startEl = DocumentSafe.getElementById("ctmBulkStart");

  	        if (startEl) {
  	          startEl.value = String(nextFleetSequence(prefix));
  	        }

  	        updateNewTyresPreviewFromInputs();
  	      };
  	    }

  	    if (bulkStartInput) {
  	      bulkStartInput.oninput = updateNewTyresPreviewFromInputs;
  	    }

  	    if (bulkCountInput) {
  	      bulkCountInput.oninput = updateNewTyresPreviewFromInputs;
  	    }

  	    if (transactionTypeInput) {
  	      transactionTypeInput.onchange = updateTransactionSaveVisibility;
  	      transactionTypeInput.oninput = updateTransactionSaveVisibility;
  	    }

  	    if (transactionCostInput) {
  	      transactionCostInput.oninput = updateTransactionSaveVisibility;
  	      transactionCostInput.onchange = updateTransactionSaveVisibility;
  	    }

  	    hubEl.onclick = function (event) {
  	      var target = event.target;
  	      var rowEl;
  	      var historyEl;
  	      var detailEl;
  	      var historyRows;
  	      var detailRows;
  	      var panel;
  	      var i;
  	      var id;

  	      if (target === hubEl && !state.modal) {
  	        closeManager();
  	        return;
  	      }

  	      if (target && target.getAttribute && target.getAttribute("data-sort-key")) {
  	        if (state.sortKey === target.getAttribute("data-sort-key")) {
  	          state.sortDir = state.sortDir === "asc" ? "desc": "asc";
  	        } else {
  	          state.sortKey = target.getAttribute("data-sort-key");
  	          state.sortDir = state.sortKey === "remainingMileage" ? "asc": "asc";
  	        }

  	        updateListOnly();
  	        return;
  	      }

  	      if (target && target.id === "ctmModal") {
  	        closePopup();
  	        return;
  	      }

  	      if (target && target.id === "ctmCloseX") {
  	        closeManager();
  	        return;
  	      }

  	      if (target && target.id === "ctmNewTyresBtn") {
  	        state.modal = {
  	          type: "new"
  	        };
  	        render();
  	        return;
  	      }

  	      if (target && target.id === "ctmRefreshBtn") {
  	        loadTyres();
  	        return;
  	      }

  	      if (target && target.id === "ctmPrintWarehouseReport") {
  	        printWarehouseWarningReport();
  	        return;
  	      }

  	      if (target && (target.id === "ctmModalClose" || target.id === "ctmCancelModal")) {
  	        closePopup();
  	        return;
  	      }

  	      if (target && target.id === "ctmConfirmBulkCreate") {
  	        createNewTyresFromModal();
  	        return;
  	      }

  	      if (target && target.id === "ctmNewTransactionBtn") {
  	        panel = DocumentSafe.getElementById("ctmTransactionPanel");

  	        if (panel) {
  	          panel.style.display = "block";
  	        }

  	        target.style.display = "none";
  	        updateTransactionSaveVisibility();
  	        return;
  	      }

  	      if (target && target.id === "ctmSaveTransactionBtn") {
  	        saveTransactionFromModal();
  	        return;
  	      }

  	      historyEl = closestWithAttribute(target, "data-history-key");

  	      if (historyEl && state.modal && state.modal.type === "tyre") {
  	        id = historyEl.getAttribute("data-history-key");

  	        historyRows = hubEl.querySelectorAll(".ctm-history-row");
  	        detailRows = hubEl.querySelectorAll(".ctm-history-detail-row");

  	        for (i = 0; i < historyRows.length; i++) {
  	          historyRows[i].className = historyRows[i].className.replace(/\s?ctm-history-selected/g, "");
  	        }

  	        for (i = 0; i < detailRows.length; i++) {
  	          detailRows[i].style.display = "none";
  	        }

  	        historyEl.className += " ctm-history-selected";

  	        detailEl = DocumentSafe.getElementById("ctmHistoryDetail_" + id);

  	        if (detailEl) {
  	          detailEl.style.display = "";
  	        }

  	        return;
  	      }

  	      if (target && target.id === "ctmPrintTyreReport") {
  	        printSelectedTyreReport();
  	        return;
  	      }

  	      if (target && target.id === "ctmSaveEditTyre") {
  	        saveEditedTyreFromModal();
  	        return;
  	      }

  	      if (target && target.id === "ctmDetailSendRetread") {
  	        sendTyreForRetreadById(state.modal && state.modal.tyreId);
  	        return;
  	      }

  	      if (target && target.id === "ctmDetailCompleteRetread") {
  	        completeTyreRetreadById(state.modal && state.modal.tyreId);
  	        return;
  	      }

  	      if (target && target.id === "ctmDetailScrap") {
  	        scrapTyreById(state.modal && state.modal.tyreId);
  	        return;
  	      }

  	      rowEl = closestWithAttribute(target, "data-row-id");

  	      if (rowEl) {
  	        id = rowEl.getAttribute("data-row-id");

  	        if (id) {
  	          state.modal = {
  	            type: "tyre",
  	            tyreId: id
  	          };
  	          render();
  	        }
  	      }
  	    };
  	  }

  	  render();
  	  loadTyres();

  	  return true;
  	})(
  	  typeof args !== "undefined" ? args: {},
  	  typeof App !== "undefined" ? App: null,
  	  typeof Tractors !== "undefined" ? Tractors: [],
  	  typeof Hub !== "undefined" ? Hub: null,
  	  typeof Backendless !== "undefined" ? Backendless: null,
  	  typeof SVG !== "undefined" ? SVG: ""
  	);
  })(___arguments.context.appData, (await Tractors2()), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e487ca4eaeecb57fb48a992d27843ff')), 'data:image/png;base64,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');
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e517ec0e29819ef91cfda218a0f846b6', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/f27e5ea88938a6b5eae5473847f10d68/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item, Sort, Tractor2, Tractors;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await (async function(Component, List, App) {
  	(function () {
  	  // ============================================================
  	  // TrackIT Vehicle Dropdown
  	  // Company headers + collapsible company groups + autocomplete
  	  // Full-height panel + transparent grey scrollbar
  	  // Collapsed company = clean black space, no count text
  	  // Arrow closes/open panel properly
  	  // ============================================================

  	  const MAP_COMPONENT_UID = "1c5c1158d7432af8a60840f7e4d8f854";
  	  const MAP_SELECT_ZOOM = 20;

  	  function readBackendlessArg(name, lowerName, index) {
  	    try {
  	      if (typeof ___arguments !== "undefined") {
  	        if (___arguments[name] !== undefined) return ___arguments[name];
  	        if (___arguments[lowerName] !== undefined) return ___arguments[lowerName];
  	        if (___arguments[index] !== undefined) return ___arguments[index];
  	      }
  	    } catch (_) {}

  	    return undefined;
  	  }

  	  const component =
  	    typeof Component !== "undefined"
  	      ? Component
  	      : readBackendlessArg("Component", "component", 0);

  	  const listInput =
  	    typeof List !== "undefined"
  	      ? List
  	      : readBackendlessArg("List", "list", 1);

  	  const AppRoot =
  	    typeof App !== "undefined"
  	      ? App
  	      : readBackendlessArg("App", "app", 2);

  	  const groups = Array.isArray(listInput) ? listInput : [];

  	  const root =
  	    component?.element ||
  	    component?.el ||
  	    component?.node ||
  	    component;

  	  if (!root) {
  	    console.error("[TrackIT Dropdown] Component root not found.");
  	    return;
  	  }

  	  if (typeof root.__vehicleDropdownCleanup === "function") {
  	    try {
  	      root.__vehicleDropdownCleanup();
  	    } catch (_) {}
  	  }

  	  if (!root.__trackitCollapsedCompanyGroups) {
  	    root.__trackitCollapsedCompanyGroups = {};
  	  }

  	  root.innerHTML = "";
  	  root.style.maxWidth = "100%";
  	  root.style.boxSizing = "border-box";
  	  root.style.overflow = "visible";

  	  // ============================================================
  	  // AppData helpers
  	  // ============================================================

  	  function getBackendlessContext() {
  	    try {
  	      if (typeof ___arguments !== "undefined" && ___arguments?.context) {
  	        return ___arguments.context;
  	      }
  	    } catch (_) {}

  	    return null;
  	  }

  	  function getAppBag() {
  	    const ctx = getBackendlessContext();

  	    if (ctx?.appData) return ctx.appData;

  	    if (AppRoot?.data && typeof AppRoot.data === "object") {
  	      return AppRoot.data;
  	    }

  	    if (AppRoot && typeof AppRoot === "object" && !("data" in AppRoot)) {
  	      return AppRoot;
  	    }

  	    if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
  	      return BackendlessUI.App.data;
  	    }

  	    if (typeof window !== "undefined" && window.AppData) {
  	      return window.AppData.data || window.AppData;
  	    }

  	    return null;
  	  }

  	  function refreshApp() {
  	    try {
  	      BackendlessUI?.App?.refresh?.();
  	    } catch (_) {}
  	  }

  	  function getObjectProperty(object, propPath) {
  	    if (!object) return;

  	    if (typeof propPath !== "string" || object[propPath] !== undefined) {
  	      return object[propPath];
  	    }

  	    const propsNamesList = propPath.split(".");
  	    let result = object;

  	    for (let i = 0; i < propsNamesList.length; i++) {
  	      if (!result || result[propsNamesList[i]] === undefined) {
  	        return;
  	      }

  	      result = result[propsNamesList[i]];
  	    }

  	    return result;
  	  }

  	  // ============================================================
  	  // Tracker visibility rule
  	  // A tractor with Tracker === null must NEVER appear
  	  // in this dropdown and must never be selectable through it.
  	  // ============================================================

  	  function hasDisplayableTracker(tractor) {
  	    if (!tractor || typeof tractor !== "object") return true;

  	    // IMPORTANT:
  	    // Hide ONLY when the capital-T property Tracker is explicitly null.
  	    // If Tracker is undefined / not present in this List payload, the tractor
  	    // remains visible because Backendless may not have loaded that property
  	    // into the dropdown source object.
  	    return getObjectProperty(tractor, "Tracker") !== null;
  	  }

  	  function readSelectedTractorMarkerId() {
  	    const appData = getAppBag();
  	    return appData?.SelectedTractorMarker || null;
  	  }

  	  function clearSelectedVehicleFromAppData() {
  	    const appData = getAppBag();

  	    if (!appData) {
  	      console.warn("[TrackIT Dropdown] AppData not found. Could not clear selected tractor.");
  	      return;
  	    }

  	    try {
  	      delete appData.SelectedTractorMarker;
  	    } catch (_) {
  	      appData.SelectedTractorMarker = null;
  	    }

  	    try {
  	      delete appData.SelectedTractor;
  	    } catch (_) {
  	      appData.SelectedTractor = null;
  	    }

  	    refreshApp();
  	  }

  	  function findTractorByObjectId(inputValue) {
  	    const appData = getAppBag();

  	    if (!appData) return null;

  	    const companies =
  	      getObjectProperty(getObjectProperty(appData, "User"), "Companies") || [];

  	    const tractors = [];

  	    companies.forEach(company => {
  	      const companyTractors = getObjectProperty(company, "Tractors") || [];

  	      companyTractors.forEach(tractor => {
  	        tractors.push(tractor);
  	      });
  	    });

  	    return tractors.find(tractor => {
  	      return (
  	        hasDisplayableTracker(tractor) &&
  	        getObjectProperty(tractor, "objectId") === inputValue
  	      );
  	    }) || null;
  	  }

  	  function writeSelectedVehicleToAppData(tractor) {
  	    if (!tractor) return;

  	    const appData = getAppBag();

  	    if (!appData) {
  	      console.warn("[TrackIT Dropdown] AppData not found. Could not write selected tractor.");
  	      return;
  	    }

  	    const objectId = getObjectProperty(tractor, "objectId");

  	    if (!objectId) {
  	      console.warn("[TrackIT Dropdown] Selected tractor has no objectId.", tractor);
  	      return;
  	    }

  	    appData.SelectedTractorMarker = objectId;

  	    let plain = tractor;

  	    try {
  	      plain = JSON.parse(JSON.stringify(tractor));
  	    } catch (_) {}

  	    appData.SelectedTractor = plain;

  	    refreshApp();
  	  }

  	  function centerMapOnTractor(tractor) {
  	    if (!tractor) return;

  	    const location = getObjectProperty(tractor, "Location");

  	    const lat = Number(getObjectProperty(location, "position.latitude"));
  	    const lng = Number(getObjectProperty(location, "position.longitude"));

  	    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
  	      console.warn("[TrackIT Dropdown] Tractor has no valid latitude/longitude.", tractor);
  	      return;
  	    }

  	    const ctx = getBackendlessContext();

  	    try {
  	      const mapComponent = ctx?.getComponentByUid?.(MAP_COMPONENT_UID);

  	      if (mapComponent) {
  	        mapComponent.center = { lat, lng };
  	        mapComponent.zoom = MAP_SELECT_ZOOM;
  	        return;
  	      }
  	    } catch (e) {
  	      console.warn("[TrackIT Dropdown] Could not center Backendless map component.", e);
  	    }

  	    try {
  	      if (window.__truckFollow_map) {
  	        window.__truckFollow_map.setCenter({ lat, lng });
  	        window.__truckFollow_map.setZoom(MAP_SELECT_ZOOM);
  	      }
  	    } catch (e) {
  	      console.warn("[TrackIT Dropdown] Could not center Google map fallback.", e);
  	    }
  	  }

  	  function runVehicleSelectChange(inputValue, fallbackTractor) {
  	    if (!inputValue) {
  	      clearSelectedVehicleFromAppData();
  	      return;
  	    }

  	    const tractor = findTractorByObjectId(inputValue) || fallbackTractor;

  	    if (!tractor) {
  	      console.warn("[TrackIT Dropdown] No tractor found for selected value:", inputValue);
  	      return;
  	    }

  	    if (!hasDisplayableTracker(tractor)) {
  	      console.warn("[TrackIT Dropdown] Tractor blocked because Tracker is explicitly null.", tractor);
  	      clearSelectedVehicleFromAppData();
  	      return;
  	    }

  	    writeSelectedVehicleToAppData(tractor);
  	    centerMapOnTractor(tractor);
  	  }

  	  // ============================================================
  	  // Icon logic
  	  // ============================================================

  	  const CFG = {
  	    W: 176,
  	    H: 176,
  	    CX: 88,
  	    CY: 88,
  	    OUTER_R: 44,
  	    DOT_R: 18,
  	    PTR_LEN: 40,
  	    PTR_HALF: 24,
  	    HEADING_OFFSET: 0,
  	    MOVING_SPEED_KMH: 2,
  	    COLORS: {
  	      truckFallback: "#2f32d7",
  	      status: {
  	        moving: "#18a058",
  	        stopped: "#7a7a7a",
  	        warn: "#ee4b2b"
  	      },
  	      stroke: "#101010",
  	      innerRim: "rgba(255,255,255,0.35)",
  	      outline: "#ffffff"
  	    },
  	    OUTLINE_W: 6
  	  };

  	  const num = value => {
  	    return typeof value === "number" ? value : Number(value);
  	  };

  	  const bool = value => {
  	    return (
  	      value === true ||
  	      value === 1 ||
  	      (
  	        typeof value === "string" &&
  	        ["true", "1", "yes", "y", "on"].includes(value.toLowerCase())
  	      )
  	    );
  	  };

  	  const getPath = (object, path) => {
  	    if (!object || !path) return undefined;

  	    if (Object.prototype.hasOwnProperty.call(object, path)) {
  	      return object[path];
  	    }

  	    return path.split(".").reduce((result, key) => {
  	      return result && result[key] !== undefined ? result[key] : undefined;
  	    }, object);
  	  };

  	  function isMoving(tractor) {
  	    const location = tractor?.Location || {};
  	    const speed = num(getPath(location, "position.speed"));

  	    if (Number.isFinite(speed)) {
  	      return speed > CFG.MOVING_SPEED_KMH;
  	    }

  	    const canSpeed = num(tractor?.CAN?.Speed ?? tractor?.["can.vehicle.speed"]);

  	    if (Number.isFinite(canSpeed)) {
  	      return canSpeed > CFG.MOVING_SPEED_KMH;
  	    }

  	    return bool(getPath(location, "movement.status")) === true;
  	  }

  	  function hasWarning(tractor) {
  	    const location = tractor?.Location || {};
  	    const limits = tractor?.CAN || {};

  	    const speed = num(getPath(location, "position.speed"));
  	    const rpm = num(getPath(location, "can.engine.rpm"));
  	    const temp = num(getPath(location, "can.engine.temperature"));

  	    const limitSpeed = num(limits?.Speed);
  	    const limitRpm = num(limits?.RPM);
  	    const limitTemp = num(limits?.Temp);

  	    if (Number.isFinite(speed) && Number.isFinite(limitSpeed) && speed > limitSpeed) return true;
  	    if (Number.isFinite(rpm) && Number.isFinite(limitRpm) && rpm > limitRpm) return true;
  	    if (Number.isFinite(temp) && Number.isFinite(limitTemp) && temp > limitTemp) return true;

  	    return false;
  	  }

  	  function svgBadge(tractor) {
  	    const W = CFG.W;
  	    const H = CFG.H;
  	    const CX = CFG.CX;
  	    const CY = CFG.CY;
  	    const R = CFG.OUTER_R;
  	    const DR = CFG.DOT_R;
  	    const PH = CFG.PTR_HALF;
  	    const PL = CFG.PTR_LEN;

  	    const location = tractor?.Location || {};
  	    const headingDeg = num(getPath(location, "position.direction")) || 0;
  	    const angle = headingDeg + CFG.HEADING_OFFSET;

  	    const warning = hasWarning(tractor);
  	    const moving = isMoving(tractor);

  	    const truckColor =
  	      tractor?.color ||
  	      tractor?.Color ||
  	      tractor?.colour ||
  	      tractor?.Colour ||
  	      CFG.COLORS.truckFallback;

  	    const statusColor = warning
  	      ? CFG.COLORS.status.warn
  	      : moving
  	        ? CFG.COLORS.status.moving
  	        : CFG.COLORS.status.stopped;

  	    const tipY = CY - R - PL;
  	    const baseY = CY - R + 2;

  	    return `
  	      <svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}">
  	        <circle cx="${CX}" cy="${CY}" r="${R}" fill="none" stroke="${CFG.COLORS.outline}" stroke-width="${CFG.OUTLINE_W}"/>

  	        <g transform="rotate(${angle}, ${CX}, ${CY})">
  	          <path d="M ${CX},${tipY} L ${CX - PH},${baseY} L ${CX + PH},${baseY} Z"
  	                fill="none"
  	                stroke="${CFG.COLORS.outline}"
  	                stroke-width="${CFG.OUTLINE_W}"/>
  	        </g>

  	        <circle cx="${CX}" cy="${CY}" r="${R}"
  	                fill="${truckColor}"
  	                stroke="${CFG.COLORS.stroke}"
  	                stroke-width="2"/>

  	        <circle cx="${CX}" cy="${CY}" r="${DR}"
  	                fill="${statusColor}"
  	                stroke="${CFG.COLORS.outline}"
  	                stroke-width="2"/>

  	        <circle cx="${CX}" cy="${CY}" r="${DR - 3}"
  	                fill="none"
  	                stroke="${CFG.COLORS.innerRim}"
  	                stroke-width="2"/>

  	        <g transform="rotate(${angle}, ${CX}, ${CY})">
  	          <path d="M ${CX},${tipY} L ${CX - PH},${baseY} L ${CX + PH},${baseY} Z"
  	                fill="${truckColor}"
  	                stroke="${CFG.COLORS.stroke}"
  	                stroke-width="2"/>
  	        </g>
  	      </svg>
  	    `;
  	  }

  	  function iconUrl(tractor) {
  	    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgBadge(tractor || {}))}`;
  	  }

  	  // ============================================================
  	  // Vehicle helpers
  	  // ============================================================

  	  function getVehicleFromItem(item) {
  	    return item?.tractor || item?.Tractor || item?.vehicle || item?.Vehicle || item || {};
  	  }

  	  function getItemLabel(item) {
  	    const tractor = getVehicleFromItem(item);

  	    return (
  	      item?.label ||
  	      tractor?.Name ||
  	      tractor?.ID ||
  	      tractor?.FID ||
  	      tractor?.Registration ||
  	      tractor?.Tracker ||
  	      "Vehicle"
  	    );
  	  }

  	  function getItemValue(item) {
  	    const tractor = getVehicleFromItem(item);

  	    // Hard rule: no Tracker means no dropdown value, therefore no row.
  	    if (!hasDisplayableTracker(tractor)) return null;

  	    return (
  	      item?.value ||
  	      item?.objectId ||
  	      tractor?.objectId ||
  	      tractor?.Location?.objectId ||
  	      null
  	    );
  	  }

  	  function getItemMeta(item) {
  	    const tractor = getVehicleFromItem(item);

  	    const registration = tractor?.Registration || tractor?.Location?.Registration || "";
  	    const fleet = tractor?.FID || tractor?.ID || "";

  	    if (registration && fleet && registration !== fleet) {
  	      return `${fleet} • ${registration}`;
  	    }

  	    if (registration) return registration;
  	    if (fleet) return fleet;

  	    return "";
  	  }

  	  function getSearchText(group, item) {
  	    const tractor = getVehicleFromItem(item);

  	    return [
  	      group?.groupLabel,
  	      group?.label,
  	      group?.Name,
  	      item?.label,
  	      item?.value,
  	      tractor?.Name,
  	      tractor?.ID,
  	      tractor?.FID,
  	      tractor?.Registration,
  	      tractor?.Tracker,
  	      tractor?.Location?.ident,
  	      tractor?.Location?.Registration
  	    ]
  	      .filter(Boolean)
  	      .join(" ")
  	      .toLowerCase();
  	  }

  	  // ============================================================
  	  // CSS
  	  // ============================================================

  	  const css = `
  	    .trackit-vehicle-dropdown {
  	      position: relative;
  	      width: 100%;
  	      max-width: 100%;
  	      min-width: 0;
  	      box-sizing: border-box;
  	      font-family: Inter, Arial, sans-serif;
  	      color: #fff;
  	    }

  	    .trackit-vehicle-control {
  	      width: 100%;
  	      max-width: 100%;
  	      min-width: 0;
  	      height: 40px;
  	      box-sizing: border-box;
  	      position: relative;
  	      background: rgba(5, 12, 9, 0.94);
  	      border: 1px solid #d95f28;
  	      border-radius: 5px;
  	      color: #fff;
  	      padding: 4px 39px 4px 8px;
  	      box-shadow: 0 6px 14px rgba(0,0,0,0.32);
  	      overflow: visible;
  	    }

  	    .trackit-vehicle-control:hover,
  	    .trackit-vehicle-dropdown.open .trackit-vehicle-control {
  	      border-color: #ff7b38;
  	      box-shadow: 0 0 0 1px rgba(217,95,40,0.28);
  	    }

  	    .trackit-floating-label {
  	      position: absolute;
  	      top: -9px;
  	      left: 8px;
  	      background: rgba(5, 12, 9, 0.98);
  	      padding: 0 4px;
  	      color: #fff;
  	      font-size: 10px;
  	      font-weight: 700;
  	      line-height: 12px;
  	      z-index: 2;
  	      pointer-events: none;
  	    }

  	    .trackit-input-row {
  	      display: flex;
  	      align-items: center;
  	      gap: 5px;
  	      width: 100%;
  	      height: 100%;
  	      min-width: 0;
  	    }

  	    .trackit-selected-icon {
  	      width: 23px;
  	      height: 23px;
  	      flex: 0 0 23px;
  	      display: none;
  	    }

  	    .trackit-vehicle-dropdown.has-value .trackit-selected-icon {
  	      display: block;
  	    }

  	    .trackit-search-input {
  	      width: 100%;
  	      min-width: 0;
  	      height: 27px;
  	      border: none;
  	      outline: none;
  	      background: transparent;
  	      color: #fff;
  	      font-size: 13px;
  	      font-weight: 700;
  	      padding: 0;
  	      box-sizing: border-box;
  	    }

  	    .trackit-search-input::placeholder {
  	      color: #fff;
  	      opacity: 0.95;
  	      font-weight: 700;
  	    }

  	    .trackit-clear {
  	      position: absolute;
  	      right: 25px;
  	      top: 50%;
  	      transform: translateY(-50%);
  	      color: #e27a3d;
  	      font-size: 18px;
  	      line-height: 1;
  	      cursor: pointer;
  	      display: none;
  	      user-select: none;
  	      z-index: 6;
  	    }

  	    .trackit-clear:hover {
  	      color: #ff9a5f;
  	    }

  	    .trackit-vehicle-dropdown.has-value .trackit-clear,
  	    .trackit-vehicle-dropdown.has-query .trackit-clear {
  	      display: block;
  	    }

  	    .trackit-arrow-hit {
  	      position: absolute;
  	      right: 0;
  	      top: 0;
  	      width: 30px;
  	      height: 100%;
  	      z-index: 7;
  	      cursor: pointer;
  	      display: flex;
  	      align-items: center;
  	      justify-content: center;
  	      user-select: none;
  	    }

  	    .trackit-arrow-triangle {
  	      width: 0;
  	      height: 0;
  	      border-left: 5px solid transparent;
  	      border-right: 5px solid transparent;
  	      border-top: 6px solid #d77b3f;
  	      transition: transform 120ms ease, border-top-color 120ms ease;
  	    }

  	    .trackit-arrow-hit:hover .trackit-arrow-triangle {
  	      border-top-color: #ff9a5f;
  	    }

  	    .trackit-vehicle-dropdown.open .trackit-arrow-triangle {
  	      transform: rotate(180deg);
  	    }

  	    .trackit-menu {
  	      position: absolute;
  	      top: calc(100% + 4px);
  	      left: 0;
  	      right: 0;
  	      z-index: 99999;

  	      height: var(--trackit-menu-height, 320px);
  	      max-height: var(--trackit-menu-height, 320px);

  	      overflow-y: auto;
  	      overflow-x: hidden;

  	      background: linear-gradient(180deg, #101711 0%, #0b100c 100%);
  	      border: 1px solid rgba(217,95,40,0.78);
  	      border-radius: 6px;
  	      display: none;
  	      box-shadow: 0 14px 28px rgba(0,0,0,0.48);
  	      box-sizing: border-box;

  	      scrollbar-width: thin;
  	      scrollbar-color: rgba(190,190,190,0.45) rgba(255,255,255,0.05);
  	      scrollbar-gutter: stable;
  	    }

  	    .trackit-menu::-webkit-scrollbar {
  	      width: 8px;
  	    }

  	    .trackit-menu::-webkit-scrollbar-track {
  	      background: rgba(255,255,255,0.04);
  	      border-radius: 999px;
  	      margin: 5px 0;
  	    }

  	    .trackit-menu::-webkit-scrollbar-thumb {
  	      background: rgba(185,185,185,0.42);
  	      border-radius: 999px;
  	      border: 2px solid rgba(10,14,11,0.72);
  	    }

  	    .trackit-menu::-webkit-scrollbar-thumb:hover {
  	      background: rgba(230,230,230,0.58);
  	    }

  	    .trackit-menu::-webkit-scrollbar-corner {
  	      background: transparent;
  	    }

  	    .trackit-vehicle-dropdown.open .trackit-menu {
  	      display: block;
  	    }

  	    .trackit-company-header {
  	      position: sticky;
  	      top: 0;
  	      z-index: 3;
  	      display: flex;
  	      align-items: center;
  	      justify-content: space-between;
  	      gap: 8px;
  	      padding: 6px 9px;
  	      background: linear-gradient(90deg, #d95f28, #833414);
  	      color: #fff;
  	      font-size: 10px;
  	      font-weight: 800;
  	      letter-spacing: 0.06em;
  	      text-transform: uppercase;
  	      border-bottom: 1px solid rgba(0,0,0,0.35);
  	      cursor: pointer;
  	      user-select: none;
  	    }

  	    .trackit-company-header:hover {
  	      background: linear-gradient(90deg, #f07232, #974019);
  	    }

  	    .trackit-company-title {
  	      min-width: 0;
  	      overflow: hidden;
  	      text-overflow: ellipsis;
  	      white-space: nowrap;
  	    }

  	    .trackit-company-meta {
  	      display: flex;
  	      align-items: center;
  	      gap: 6px;
  	      flex: 0 0 auto;
  	      opacity: 0.9;
  	    }

  	    .trackit-company-caret {
  	      width: 0;
  	      height: 0;
  	      border-left: 4px solid transparent;
  	      border-right: 4px solid transparent;
  	      border-top: 5px solid rgba(255,255,255,0.92);
  	      transition: transform 120ms ease;
  	    }

  	    .trackit-company-header.collapsed .trackit-company-caret {
  	      transform: rotate(-90deg);
  	    }

  	    .trackit-company-collapsed-note {
  	      height: 28px;
  	      padding: 0;
  	      background: rgba(5, 12, 9, 0.94);
  	      border-bottom: 1px solid rgba(255,255,255,0.04);
  	      cursor: pointer;
  	    }

  	    .trackit-company-collapsed-note:hover {
  	      background: rgba(10, 18, 13, 0.98);
  	    }

  	    .trackit-vehicle-item {
  	      display: flex;
  	      align-items: center;
  	      gap: 6px;
  	      padding: 6px 8px;
  	      cursor: pointer;
  	      border-bottom: 1px solid rgba(255,255,255,0.06);
  	      background: rgba(255,255,255,0.02);
  	      min-width: 0;
  	    }

  	    .trackit-vehicle-item:hover,
  	    .trackit-vehicle-item.active {
  	      background: rgba(217,95,40,0.24);
  	    }

  	    .trackit-vehicle-item.selected {
  	      background: rgba(217,95,40,0.38);
  	    }

  	    .trackit-item-icon {
  	      width: 26px;
  	      height: 26px;
  	      flex: 0 0 26px;
  	    }

  	    .trackit-item-text-wrap {
  	      min-width: 0;
  	      flex: 1;
  	    }

  	    .trackit-item-label {
  	      font-size: 12px;
  	      line-height: 15px;
  	      font-weight: 750;
  	      color: #fff;
  	      white-space: nowrap;
  	      overflow: hidden;
  	      text-overflow: ellipsis;
  	    }

  	    .trackit-item-meta {
  	      margin-top: 0;
  	      font-size: 10px;
  	      line-height: 12px;
  	      color: rgba(255,255,255,0.62);
  	      white-space: nowrap;
  	      overflow: hidden;
  	      text-overflow: ellipsis;
  	    }

  	    .trackit-empty {
  	      padding: 10px 9px;
  	      color: rgba(255,255,255,0.65);
  	      font-size: 12px;
  	    }
  	  `;

  	  let style = document.getElementById("trackit-compact-vehicle-dropdown-css");

  	  if (!style) {
  	    style = document.createElement("style");
  	    style.id = "trackit-compact-vehicle-dropdown-css";
  	    document.head.appendChild(style);
  	  }

  	  style.textContent = css;

  	  // ============================================================
  	  // Build dropdown
  	  // ============================================================

  	  const dropdown = document.createElement("div");
  	  dropdown.className = "trackit-vehicle-dropdown";

  	  const control = document.createElement("div");
  	  control.className = "trackit-vehicle-control";


  	  const inputRow = document.createElement("div");
  	  inputRow.className = "trackit-input-row";

  	  const selectedIcon = document.createElement("img");
  	  selectedIcon.className = "trackit-selected-icon";
  	  selectedIcon.alt = "";

  	  const searchInput = document.createElement("input");
  	  searchInput.className = "trackit-search-input";
  	  searchInput.type = "text";
  	  searchInput.placeholder = "Select vehicle";
  	  searchInput.autocomplete = "off";
  	  searchInput.spellcheck = false;

  	  inputRow.appendChild(selectedIcon);
  	  inputRow.appendChild(searchInput);

  	  const clear = document.createElement("span");
  	  clear.className = "trackit-clear";
  	  clear.innerHTML = "&times;";

  	  const arrowHit = document.createElement("span");
  	  arrowHit.className = "trackit-arrow-hit";

  	  const arrowTriangle = document.createElement("span");
  	  arrowTriangle.className = "trackit-arrow-triangle";

  	  arrowHit.appendChild(arrowTriangle);

  	  control.appendChild(inputRow);
  	  control.appendChild(clear);
  	  control.appendChild(arrowHit);

  	  const menu = document.createElement("div");
  	  menu.className = "trackit-menu";

  	  dropdown.appendChild(control);
  	  dropdown.appendChild(menu);
  	  root.appendChild(dropdown);

  	  let selectedValue = null;
  	  let selectedItem = null;
  	  let selectedLabel = "";
  	  let flatRows = [];
  	  let visibleRows = [];
  	  let activeIndex = -1;
  	  let suppressFocusOpenUntil = 0;

  	  const existingSelectedObjectId = readSelectedTractorMarkerId();

  	  function updateMenuHeightToBottom() {
  	    try {
  	      const rect = menu.getBoundingClientRect();
  	      const bottomPadding = 8;
  	      const availableHeight = window.innerHeight - rect.top - bottomPadding;
  	      const safeHeight = Math.max(160, availableHeight);

  	      menu.style.setProperty("--trackit-menu-height", `${safeHeight}px`);
  	    } catch (e) {
  	      console.warn("[TrackIT Dropdown] Could not calculate menu height.", e);
  	    }
  	  }

  	  function openDropdown() {
  	    dropdown.classList.add("open");

  	    requestAnimationFrame(() => {
  	      updateMenuHeightToBottom();
  	    });
  	  }

  	  function closeDropdown() {
  	    dropdown.classList.remove("open");
  	    activeIndex = -1;
  	    paintActiveRow();
  	  }

  	  function toggleDropdownFromArrow() {
  	    suppressFocusOpenUntil = Date.now() + 250;

  	    if (dropdown.classList.contains("open")) {
  	      closeDropdown();
  	      try {
  	        searchInput.blur();
  	      } catch (_) {}
  	      return;
  	    }

  	    searchInput.focus();
  	    renderMenu(searchInput.value === selectedLabel ? "" : searchInput.value);
  	    openDropdown();
  	  }

  	  function emitChange() {
  	    root.vehicleDropdownValue = selectedValue;
  	    root.vehicleDropdownItem = selectedItem;

  	    root.dispatchEvent(new CustomEvent("vehicleDropdownChange", {
  	      bubbles: true,
  	      detail: {
  	        value: selectedValue,
  	        item: selectedItem
  	      }
  	    }));

  	    window.dispatchEvent(new CustomEvent("vehicleDropdownChange", {
  	      detail: {
  	        value: selectedValue,
  	        item: selectedItem
  	      }
  	    }));
  	  }

  	  function setQueryState() {
  	    const query = searchInput.value.trim();

  	    if (query) {
  	      dropdown.classList.add("has-query");
  	    } else {
  	      dropdown.classList.remove("has-query");
  	    }
  	  }

  	  function paintActiveRow() {
  	    menu.querySelectorAll(".trackit-vehicle-item").forEach(row => {
  	      row.classList.toggle("active", row.__rowIndex === activeIndex);
  	    });

  	    const active = menu.querySelector(".trackit-vehicle-item.active");

  	    if (active) {
  	      active.scrollIntoView({ block: "nearest" });
  	    }
  	  }

  	  function paintSelected(item, shouldWrite) {
  	    const tractor = getVehicleFromItem(item);

  	    // No exception: a tractor without Tracker cannot become the selected item.
  	    if (!hasDisplayableTracker(tractor)) {
  	      return;
  	    }

  	    const value = getItemValue(item);
  	    const label = getItemLabel(item);

  	    if (!value) return;

  	    selectedValue = value;
  	    selectedItem = item;
  	    selectedLabel = label;

  	    searchInput.value = label;
  	    selectedIcon.src = iconUrl(tractor);

  	    dropdown.classList.add("has-value");
  	    dropdown.classList.remove("has-query");

  	    menu.querySelectorAll(".trackit-vehicle-item").forEach(element => {
  	      element.classList.toggle("selected", element.__vehicleValue === value);
  	    });

  	    if (shouldWrite) {
  	      runVehicleSelectChange(value, tractor);
  	      emitChange();
  	    }
  	  }

  	  function clearSelected(shouldWrite) {
  	    selectedValue = null;
  	    selectedItem = null;
  	    selectedLabel = "";

  	    searchInput.value = "";
  	    selectedIcon.removeAttribute("src");

  	    dropdown.classList.remove("has-value");
  	    dropdown.classList.remove("has-query");

  	    menu.querySelectorAll(".trackit-vehicle-item").forEach(element => {
  	      element.classList.remove("selected");
  	    });

  	    renderMenu("");

  	    if (shouldWrite) {
  	      runVehicleSelectChange(null, null);
  	      emitChange();
  	    }
  	  }

  	  function buildFlatRows() {
  	    flatRows = [];

  	    groups.forEach(group => {
  	      const children = Array.isArray(group?.children) ? group.children : [];

  	      children.forEach(item => {
  	        const tractor = getVehicleFromItem(item);

  	        // Absolute dropdown rule:
  	        // Tracker === null = do not display this tractor.
  	        if (!hasDisplayableTracker(tractor)) return;

  	        const value = getItemValue(item);

  	        if (!value) return;

  	        flatRows.push({
  	          group,
  	          item,
  	          value,
  	          label: getItemLabel(item),
  	          meta: getItemMeta(item),
  	          tractor,
  	          searchText: getSearchText(group, item)
  	        });
  	      });
  	    });
  	  }

  	  function toggleCompanyGroup(groupName) {
  	    const collapsed = root.__trackitCollapsedCompanyGroups;

  	    collapsed[groupName] = !collapsed[groupName];

  	    renderMenu(searchInput.value === selectedLabel ? "" : searchInput.value);

  	    requestAnimationFrame(() => {
  	      updateMenuHeightToBottom();
  	    });
  	  }

  	  function renderMenu(query) {
  	    const q = String(query || "").trim().toLowerCase();
  	    const searchMode = q.length > 0;

  	    menu.innerHTML = "";
  	    visibleRows = [];
  	    activeIndex = -1;

  	    const grouped = new Map();

  	    flatRows.forEach(row => {
  	      if (q && !row.searchText.includes(q)) return;

  	      const groupName =
  	        row.group?.groupLabel ||
  	        row.group?.label ||
  	        row.group?.Name ||
  	        "Company";

  	      if (!grouped.has(groupName)) {
  	        grouped.set(groupName, []);
  	      }

  	      grouped.get(groupName).push(row);
  	    });

  	    if (!grouped.size) {
  	      const empty = document.createElement("div");
  	      empty.className = "trackit-empty";
  	      empty.textContent = "No vehicle found";
  	      menu.appendChild(empty);

  	      requestAnimationFrame(() => {
  	        if (dropdown.classList.contains("open")) updateMenuHeightToBottom();
  	      });

  	      return;
  	    }

  	    grouped.forEach((rows, groupName) => {
  	      const collapsed =
  	        !searchMode &&
  	        root.__trackitCollapsedCompanyGroups[groupName] === true;

  	      const header = document.createElement("div");
  	      header.className = "trackit-company-header";

  	      if (collapsed) {
  	        header.classList.add("collapsed");
  	      }

  	      const title = document.createElement("div");
  	      title.className = "trackit-company-title";
  	      title.textContent = groupName;

  	      const meta = document.createElement("div");
  	      meta.className = "trackit-company-meta";

  	      const caret = document.createElement("span");
  	      caret.className = "trackit-company-caret";

  	      meta.appendChild(caret);

  	      header.appendChild(title);
  	      header.appendChild(meta);

  	      header.addEventListener("mousedown", function (event) {
  	        event.preventDefault();
  	        event.stopPropagation();
  	        toggleCompanyGroup(groupName);
  	      });

  	      menu.appendChild(header);

  	      if (collapsed) {
  	        const collapsedNote = document.createElement("div");
  	        collapsedNote.className = "trackit-company-collapsed-note";
  	        collapsedNote.textContent = "";

  	        collapsedNote.addEventListener("mousedown", function (event) {
  	          event.preventDefault();
  	          event.stopPropagation();
  	          toggleCompanyGroup(groupName);
  	        });

  	        menu.appendChild(collapsedNote);
  	        return;
  	      }

  	      rows.forEach(rowData => {
  	        const rowIndex = visibleRows.length;
  	        visibleRows.push(rowData);

  	        const row = document.createElement("div");
  	        row.className = "trackit-vehicle-item";
  	        row.__vehicleValue = rowData.value;
  	        row.__rowIndex = rowIndex;

  	        if (selectedValue && rowData.value === selectedValue) {
  	          row.classList.add("selected");
  	        }

  	        const img = document.createElement("img");
  	        img.className = "trackit-item-icon";
  	        img.alt = "";
  	        img.src = iconUrl(rowData.tractor);

  	        const textWrap = document.createElement("div");
  	        textWrap.className = "trackit-item-text-wrap";

  	        const labelElement = document.createElement("div");
  	        labelElement.className = "trackit-item-label";
  	        labelElement.textContent = rowData.label;

  	        const metaElement = document.createElement("div");
  	        metaElement.className = "trackit-item-meta";
  	        metaElement.textContent = rowData.meta || " ";

  	        textWrap.appendChild(labelElement);
  	        textWrap.appendChild(metaElement);

  	        row.appendChild(img);
  	        row.appendChild(textWrap);

  	        row.addEventListener("mousedown", function (event) {
  	          event.preventDefault();
  	          paintSelected(rowData.item, true);
  	          closeDropdown();
  	        });

  	        menu.appendChild(row);
  	      });
  	    });

  	    requestAnimationFrame(() => {
  	      if (dropdown.classList.contains("open")) updateMenuHeightToBottom();
  	    });
  	  }

  	  buildFlatRows();
  	  renderMenu("");

  	  if (existingSelectedObjectId) {
  	    const existing = flatRows.find(row => row.value === existingSelectedObjectId);

  	    if (existing) {
  	      paintSelected(existing.item, false);
  	    }
  	  }

  	  control.addEventListener("click", function (event) {
  	    if (event.target.closest(".trackit-arrow-hit")) return;
  	    if (event.target.closest(".trackit-clear")) return;

  	    searchInput.focus();
  	    renderMenu(searchInput.value === selectedLabel ? "" : searchInput.value);
  	    openDropdown();
  	  });

  	  arrowHit.addEventListener("mousedown", function (event) {
  	    event.preventDefault();
  	    event.stopPropagation();
  	    toggleDropdownFromArrow();
  	  });

  	  arrowHit.addEventListener("click", function (event) {
  	    event.preventDefault();
  	    event.stopPropagation();
  	  });

  	  searchInput.addEventListener("focus", function () {
  	    if (Date.now() < suppressFocusOpenUntil) {
  	      return;
  	    }

  	    renderMenu(searchInput.value === selectedLabel ? "" : searchInput.value);
  	    openDropdown();

  	    setTimeout(() => {
  	      try {
  	        searchInput.select();
  	      } catch (_) {}
  	    }, 0);
  	  });

  	  searchInput.addEventListener("input", function () {
  	    const query = searchInput.value;

  	    if (selectedValue && query !== selectedLabel) {
  	      selectedValue = null;
  	      selectedItem = null;
  	      selectedLabel = "";

  	      selectedIcon.removeAttribute("src");
  	      dropdown.classList.remove("has-value");

  	      menu.querySelectorAll(".trackit-vehicle-item").forEach(element => {
  	        element.classList.remove("selected");
  	      });
  	    }

  	    setQueryState();
  	    renderMenu(query);
  	    openDropdown();
  	  });

  	  searchInput.addEventListener("keydown", function (event) {
  	    if (event.key === "ArrowDown") {
  	      event.preventDefault();

  	      if (!dropdown.classList.contains("open")) {
  	        openDropdown();
  	      }

  	      if (!visibleRows.length) return;

  	      activeIndex = activeIndex < visibleRows.length - 1 ? activeIndex + 1 : 0;
  	      paintActiveRow();
  	      return;
  	    }

  	    if (event.key === "ArrowUp") {
  	      event.preventDefault();

  	      if (!visibleRows.length) return;

  	      activeIndex = activeIndex > 0 ? activeIndex - 1 : visibleRows.length - 1;
  	      paintActiveRow();
  	      return;
  	    }

  	    if (event.key === "Enter") {
  	      if (activeIndex >= 0 && visibleRows[activeIndex]) {
  	        event.preventDefault();
  	        paintSelected(visibleRows[activeIndex].item, true);
  	        closeDropdown();
  	        return;
  	      }

  	      if (activeIndex === -1 && visibleRows.length === 1) {
  	        event.preventDefault();
  	        paintSelected(visibleRows[0].item, true);
  	        closeDropdown();
  	        return;
  	      }
  	    }

  	    if (event.key === "Escape") {
  	      closeDropdown();

  	      if (selectedLabel) {
  	        searchInput.value = selectedLabel;
  	      }

  	      setQueryState();
  	    }
  	  });

  	  clear.addEventListener("mousedown", function (event) {
  	    event.preventDefault();
  	    event.stopPropagation();

  	    clearSelected(true);
  	    searchInput.focus();
  	    openDropdown();
  	  });

  	  const documentClickHandler = function (event) {
  	    if (!dropdown.contains(event.target)) {
  	      closeDropdown();

  	      if (selectedLabel) {
  	        searchInput.value = selectedLabel;
  	      }

  	      setQueryState();
  	    }
  	  };

  	  const resizeHandler = function () {
  	    if (dropdown.classList.contains("open")) {
  	      updateMenuHeightToBottom();
  	    }
  	  };

  	  document.addEventListener("mousedown", documentClickHandler);
  	  window.addEventListener("resize", resizeHandler);
  	  window.addEventListener("orientationchange", resizeHandler);

  	  root.__vehicleDropdownCleanup = function () {
  	    document.removeEventListener("mousedown", documentClickHandler);
  	    window.removeEventListener("resize", resizeHandler);
  	    window.removeEventListener("orientationchange", resizeHandler);
  	  };
  	})();
  })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f27e5ea88938a6b5eae5473847f10d68')), (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies')).map(async item => {; return ({ [`groupLabel`]: (getObjectProperty(item, 'Name')),[`children`]: (await asyncListSort((await Promise.all((getObjectProperty(item, 'Tractors')).map(async Tractors => {; return ({ [`label`]: (getObjectProperty(Tractors, 'ID')),[`value`]: (getObjectProperty(Tractors, 'objectId')),[`Color`]: (getObjectProperty(Tractors, 'color')),[`Tracker`]: (getObjectProperty(Tractors, 'Tracker')) });}))), 1, async (Sort) => {


   return (getObjectProperty(Sort, 'label'));
  })) });}))), ___arguments.context.appData);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Office/components/ae7f253cbca10d381c4848c2cd2f6968/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(Color, Component, Vehicle) {
  	// ============================================================
  	// Fleet In Form - TrackIT Repeater Vehicle Icon
  	// Vehicle Argument Version
  	//
  	// REQUIRED CUSTOM CODE ARGUMENTS:
  	//   Color
  	//   Component
  	//   Vehicle
  	//
  	// Vehicle MUST be the full current repeater item / vehicle object.
  	//
  	// This version deliberately uses ONLY those three arguments.
  	// Heading, stale state, movement state, tracking age and vehicle
  	// supply voltage are all read directly from Vehicle.
  	//
  	// STATUS ICONS:
  	//   Battery icon = vehicle/main external power supply failure
  	//   Wi-Fi icon   = reporting gap after last-known active telemetry; NOT confirmed signal loss
  	//
  	// IMPORTANT:
  	//   A last-known parked vehicle with explicit ignition OFF is NOT marked stale simply
  	//   because its last tracker message is old.
  	//
  	// Default tracking thresholds:
  	//   Moving vehicle: stale after 120 seconds
  	//   Ignition/engine ON but stationary: stale after 300 seconds
  	//
  	// Battery failure:
  	//   recent external.powersource.voltage between 0 and 2.0 V (last 300 seconds)
  	//
  	// Display order:
  	//   Vehicle -> Battery -> Stale Wi-Fi
  	//
  	// REPEATER ALIGNMENT:
  	//   - Main vehicle icon is always anchored at the far left.
  	//   - The icon component has a fixed width for up to two alerts.
  	//   - Vehicle names therefore start at the same X position.
  	// ============================================================

  	(async function () {
  	  "use strict";

  	  const DEFAULT_SIZE = 30;
  	  const FALLBACK_COLOR = "#2f32d7";

  	  const MOVING_STALE_SECONDS = 120;
  	  const IGNITION_STALE_SECONDS = 300;
  	  const BATTERY_FAILURE_VOLTS = 2.0;

  	  const ALERT_RED = "#e53935";

  	  const WAIT_TIMEOUT_MS = 5000;
  	  const WAIT_STEP_MS = 80;

  	  // SVG coordinate system
  	  const BASE_W = 176;
  	  const BASE_H = 176;
  	  const STATUS_SLOT_W = 92;

  	  // ------------------------------------------------------------
  	  // BASIC HELPERS
  	  // ------------------------------------------------------------

  	  function sleep(ms) {
  	    return new Promise(resolve => setTimeout(resolve, ms));
  	  }

  	  function getArgs() {
  	    try {
  	      return typeof ___arguments !== "undefined" ? ___arguments : {};
  	    } catch (_) {
  	      return {};
  	    }
  	  }

  	  function readArg(name) {
  	    const args = getArgs();

  	    try {
  	      if (args[name] !== undefined) return args[name];

  	      const lower =
  	        name.charAt(0).toLowerCase() + name.slice(1);

  	      if (args[lower] !== undefined) return args[lower];
  	    } catch (_) {}

  	    try {
  	      return eval(
  	        "typeof " + name + " !== 'undefined' ? " + name + " : undefined"
  	      );
  	    } catch (_) {}

  	    return undefined;
  	  }

  	  function isElement(value) {
  	    return (
  	      typeof HTMLElement !== "undefined" &&
  	      value instanceof HTMLElement
  	    );
  	  }

  	  function getContext() {
  	    try {
  	      return getArgs()?.context || null;
  	    } catch (_) {
  	      return null;
  	    }
  	  }

  	  // Missing or unrecognised values remain unknown, never implicitly OFF.
  	  function toBool(value) {
  	    if (value === true || value === 1) return true;
  	    if (value === false || value === 0) return false;
  	    if (typeof value !== "string") return null;
  	    const text = value.trim().toLowerCase();
  	    if (["true", "1", "yes", "on", "moving", "active"].includes(text)) return true;
  	    if (["false", "0", "no", "off", "stationary", "stopped", "parked", "inactive"].includes(text)) return false;
  	    return null;
  	  }

  	  function toNumber(value) {
  	    if (typeof value !== "number" && typeof value !== "string") return null;
  	    if (typeof value === "string" && !value.trim()) return null;
  	    const n = Number(value);
  	    return Number.isFinite(n) ? n : null;
  	  }

  	  function timestampSeconds(value) {
  	    const numeric = toNumber(value);
  	    if (numeric !== null) {
  	      if (numeric <= 0) return null;
  	      return numeric >= 1e12 ? numeric / 1000 : numeric;
  	    }
  	    // Only parse ISO dates with an explicit timezone; local dates are ambiguous.
  	    if (typeof value === "string" && /T.*(?:Z|[+-]\d{2}:?\d{2})$/i.test(value)) {
  	      const ms = Date.parse(value);
  	      return Number.isFinite(ms) ? ms / 1000 : null;
  	    }
  	    return null;
  	  }

  	  function safeCssColor(value) {
  	    if (!value) return FALLBACK_COLOR;

  	    const color = String(value).trim();

  	    const isHex =
  	      /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color);

  	    const isRgb =
  	      /^rgba?\(\s*[\d.]+%?\s*,\s*[\d.]+%?\s*,\s*[\d.]+%?\s*(,\s*[\d.]+)?\s*\)$/i.test(color);

  	    const isHsl =
  	      /^hsla?\(\s*[\d.]+(?:deg)?\s*,\s*[\d.]+%\s*,\s*[\d.]+%\s*(,\s*[\d.]+)?\s*\)$/i.test(color);

  	    return isHex || isRgb || isHsl
  	      ? color
  	      : FALLBACK_COLOR;
  	  }

  	  function hexToRgb(hex) {
  	    let clean = String(hex || "")
  	      .replace("#", "")
  	      .trim();

  	    if (clean.length === 3) {
  	      clean = clean
  	        .split("")
  	        .map(ch => ch + ch)
  	        .join("");
  	    }

  	    if (!/^[0-9a-f]{6}$/i.test(clean)) {
  	      return null;
  	    }

  	    return {
  	      r: parseInt(clean.slice(0, 2), 16),
  	      g: parseInt(clean.slice(2, 4), 16),
  	      b: parseInt(clean.slice(4, 6), 16)
  	    };
  	  }

  	  function lightenHex(hex, percent) {
  	    const rgb = hexToRgb(hex);

  	    if (!rgb) {
  	      return "rgba(255,255,255,0.78)";
  	    }

  	    const p =
  	      Math.max(0, Math.min(100, percent)) / 100;

  	    return (
  	      "rgb(" +
  	      Math.round(rgb.r + (255 - rgb.r) * p) +
  	      ", " +
  	      Math.round(rgb.g + (255 - rgb.g) * p) +
  	      ", " +
  	      Math.round(rgb.b + (255 - rgb.b) * p) +
  	      ")"
  	    );
  	  }

  	  function firstDefined(values) {
  	    for (const value of values) {
  	      if (
  	        value !== undefined &&
  	        value !== null
  	      ) {
  	        return value;
  	      }
  	    }

  	    return undefined;
  	  }

  	  // ------------------------------------------------------------
  	  // COMPONENT LOOKUP
  	  // ------------------------------------------------------------

  	  function tryGetById(id) {
  	    if (!id) return null;

  	    const ctx = getContext();

  	    try {
  	      if (ctx?.getComponentByUid) {
  	        const c = ctx.getComponentByUid(id);
  	        const root = getRoot(c);

  	        if (root) return root;
  	      }
  	    } catch (_) {}

  	    try {
  	      if (ctx?.getComponentById) {
  	        const c = ctx.getComponentById(id);
  	        const root = getRoot(c);

  	        if (root) return root;
  	      }
  	    } catch (_) {}

  	    try {
  	      const el = document.getElementById(id);
  	      if (el) return el;
  	    } catch (_) {}

  	    try {
  	      return document.querySelector(
  	        '[data-component-id="' + id + '"],' +
  	        '[data-component-uid="' + id + '"],' +
  	        '[data-uid="' + id + '"],' +
  	        '[data-id="' + id + '"]'
  	      );
  	    } catch (_) {}

  	    return null;
  	  }

  	  function deepFindElement(object, depth, seen) {
  	    if (!object || depth > 6) return null;

  	    if (isElement(object)) {
  	      return object;
  	    }

  	    if (
  	      typeof object !== "object" &&
  	      typeof object !== "function"
  	    ) {
  	      return null;
  	    }

  	    seen = seen || [];

  	    if (seen.indexOf(object) >= 0) {
  	      return null;
  	    }

  	    seen.push(object);

  	    const directKeys = [
  	      "element",
  	      "el",
  	      "node",
  	      "root",
  	      "container",
  	      "wrapper",
  	      "htmlElement",
  	      "domElement",
  	      "view",
  	      "body",
  	      "content"
  	    ];

  	    for (const key of directKeys) {
  	      try {
  	        if (isElement(object[key])) {
  	          return object[key];
  	        }

  	        if (
  	          object[key]?.current &&
  	          isElement(object[key].current)
  	        ) {
  	          return object[key].current;
  	        }
  	      } catch (_) {}
  	    }

  	    const methodNames = [
  	      "getElement",
  	      "getDOMNode",
  	      "getNode",
  	      "getRoot",
  	      "getContainer",
  	      "getWrapper"
  	    ];

  	    for (const method of methodNames) {
  	      try {
  	        if (typeof object[method] === "function") {
  	          const result = object[method]();

  	          if (isElement(result)) {
  	            return result;
  	          }
  	        }
  	      } catch (_) {}
  	    }

  	    const idKeys = [
  	      "uid",
  	      "id",
  	      "objectId",
  	      "componentId",
  	      "componentUid",
  	      "name"
  	    ];

  	    for (const key of idKeys) {
  	      try {
  	        if (typeof object[key] === "string") {
  	          const found = tryGetById(object[key]);

  	          if (found) return found;
  	        }
  	      } catch (_) {}
  	    }

  	    try {
  	      if (
  	        object.$el?.[0] &&
  	        isElement(object.$el[0])
  	      ) {
  	        return object.$el[0];
  	      }
  	    } catch (_) {}

  	    try {
  	      for (const key of Object.keys(object)) {
  	        const found = deepFindElement(
  	          object[key],
  	          depth + 1,
  	          seen
  	        );

  	        if (found) return found;
  	      }
  	    } catch (_) {}

  	    return null;
  	  }

  	  function getRoot(component) {
  	    if (!component) return null;

  	    if (isElement(component)) {
  	      return component;
  	    }

  	    if (typeof component === "string") {
  	      return tryGetById(component);
  	    }

  	    return deepFindElement(component, 0, []);
  	  }

  	  // ------------------------------------------------------------
  	  // VEHICLE DATA
  	  // ------------------------------------------------------------

  	  function getSnapshot(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") {
  	      return null;
  	    }

  	    // Current monthly vehicle view is the preferred source.
  	    if (vehicle.ViewC?.Snapshot?.current) {
  	      return vehicle.ViewC.Snapshot;
  	    }

  	    if (vehicle.viewC?.Snapshot?.current) {
  	      return vehicle.viewC.Snapshot;
  	    }

  	    if (vehicle.ViewC?.snapshot?.current) {
  	      return vehicle.ViewC.snapshot;
  	    }

  	    // Some data structures may expose Snapshot directly.
  	    if (vehicle.Snapshot?.current) {
  	      return vehicle.Snapshot;
  	    }

  	    if (vehicle.snapshot?.current) {
  	      return vehicle.snapshot;
  	    }

  	    // Fallback: pick the newest Snapshot from ViewH.
  	    if (Array.isArray(vehicle.ViewH)) {
  	      let best = null;
  	      let bestStamp = -Infinity;

  	      for (const view of vehicle.ViewH) {
  	        const snapshot =
  	          view?.Snapshot || view?.snapshot;

  	        if (!snapshot?.current) continue;

  	        const stamp =
  	          timestampSeconds(snapshot.current.timestamp) ??
  	          timestampSeconds(view?.DateStart) ??
  	          0;

  	        if (stamp > bestStamp) {
  	          best = snapshot;
  	          bestStamp = stamp;
  	        }
  	      }

  	      if (best) return best;
  	    }

  	    return null;
  	  }

  	  function getLocation(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") {
  	      return null;
  	    }

  	    if (
  	      vehicle.Location &&
  	      typeof vehicle.Location === "object"
  	    ) {
  	      return vehicle.Location;
  	    }

  	    if (
  	      vehicle.location &&
  	      typeof vehicle.location === "object"
  	    ) {
  	      return vehicle.location;
  	    }

  	    if (
  	      vehicle.CurrentLocation &&
  	      typeof vehicle.CurrentLocation === "object"
  	    ) {
  	      return vehicle.CurrentLocation;
  	    }

  	    return null;
  	  }

  	  function getRegistration(vehicle) {
  	    return firstDefined([
  	      vehicle?.Registration,
  	      vehicle?.registration,
  	      vehicle?.ID,
  	      vehicle?.FID,
  	      vehicle?.FleetID,
  	      vehicle?.Name
  	    ]) || "";
  	  }

  	  function getHeading(vehicle, current, location) {
  	    return (
  	      toNumber(
  	        firstDefined([
  	          location?.["position.direction"],
  	          current?.direction,
  	          vehicle?.Heading,
  	          vehicle?.heading
  	        ])
  	      ) ?? 0
  	    );
  	  }

  	  function deriveHealth(vehicle) {
  	    const snapshot = getSnapshot(vehicle);
  	    const current = snapshot?.current || null;
  	    const location = getLocation(vehicle);
  	    const now = Date.now() / 1000;
  	    // Pick a single record; never merge its activity with another record's age.
  	    const candidates = [];
  	    for (const [source, record] of [["Location", location], ["Snapshot.current", current]]) {
  	      if (!record) continue;
  	      const stamp = timestampSeconds(record.timestamp);
  	      const storedAge = source === "Snapshot.current" ? toNumber(record.age_seconds) : null;
  	      const invalidStamp = record.timestamp != null && stamp === null;
  	      const futureStamp = stamp !== null && stamp > now + 60;
  	      const age = invalidStamp || futureStamp ? null : stamp !== null
  	        ? Math.max(0, now - stamp)
  	        : storedAge !== null && storedAge >= 0 ? storedAge : null;
  	      candidates.push({source, record, stamp, age, invalidStamp, futureStamp});
  	    }
  	    // Known timestamps win over undated records. Stored age is a fallback only.
  	    const dated = candidates.filter(x => x.stamp !== null && !x.futureStamp);
  	    dated.sort((x,y) => y.stamp - x.stamp);
  	    const selected = dated[0] || candidates.find(x => x.age !== null) || candidates[0];
  	    const record = selected?.record || {};
  	    const fromLocation = selected?.source === "Location";
  	    const speed = toNumber(fromLocation
  	      ? firstDefined([record["position.speed"], record["can.vehicle.speed"]])
  	      : firstDefined([record.speed, record.can_speed]));
  	    const movement = toBool(fromLocation
  	      ? firstDefined([record["movement.status"], record["fif.motion.state"]])
  	      : firstDefined([record.movement_status, record.motion_state]));
  	    const moving = speed !== null && speed > 3 ? true : movement;
  	    const ignition = toBool(fromLocation ? record["engine.ignition.status"] : record.ignition);
  	    const engineOn = toBool(fromLocation ? record["fif.engine.on"] : record.engine_on);
  	    const expectedToReport = moving === true || ignition === true || engineOn === true;
  	    const parkedOff = !expectedToReport && ignition === false && engineOn !== true &&
  	      (moving === false || (speed !== null && speed <= 3));
  	    const ageSeconds = selected?.age ?? null;
  	    const sourceSaysStale = toBool(current?.stale);
  	    const threshold = moving === true ? MOVING_STALE_SECONDS : IGNITION_STALE_SECONDS;
  	    // A generic source stale flag is evidence about age, not proof of signal loss.
  	    const stale = expectedToReport && ageSeconds !== null && ageSeconds >= threshold;
  	    const state = ageSeconds === null ? "unknown" : stale ? "reporting-gap" : parkedOff
  	      ? "parked-off-last-known" : expectedToReport ? "recent-active" : "unknown-activity";
  	    const externalVoltage = toNumber(fromLocation ? record["external.powersource.voltage"] : null);
  	    // Old power readings describe the past; do not display them as a current fault.
  	    const batteryFailure = ageSeconds !== null && ageSeconds < IGNITION_STALE_SECONDS &&
  	      externalVoltage !== null && externalVoltage >= 0 && externalVoltage <= BATTERY_FAILURE_VOLTS;
  	    return {
  	      snapshot, current, location, registration: getRegistration(vehicle),
  	      heading: getHeading(vehicle, current, location), speed, moving, ignition, engineOn,
  	      expectedToReport, parkedOff, ageSeconds, sourceSaysStale, stale,
  	      externalVoltage, batteryFailure, state, telemetrySource: selected?.source || "none",
  	      telemetryTimestamp: selected?.stamp ?? null,
  	      communicationLossConfirmed: false
  	    };
  	  }

  	  // ------------------------------------------------------------
  	  // SVG ICONS
  	  // ------------------------------------------------------------

  	  function vehicleSvg(
  	    color,
  	    headingDeg,
  	    offsetX
  	  ) {
  	    const CX = offsetX + 88;
  	    const CY = 88;

  	    const OUTER_R = 44;
  	    const DOT_R = 18;
  	    const PTR_LEN = 40;
  	    const PTR_HALF = 24;
  	    const OUTLINE_W = 6;

  	    const bodyColor =
  	      safeCssColor(color);

  	    const dotColor =
  	      bodyColor.indexOf("#") === 0
  	        ? lightenHex(bodyColor, 62)
  	        : "rgba(255,255,255,0.78)";

  	    const heading =
  	      Number.isFinite(Number(headingDeg))
  	        ? Number(headingDeg)
  	        : 0;

  	    const tipY =
  	      CY - OUTER_R - PTR_LEN;

  	    const baseY =
  	      CY - OUTER_R + 2;

  	    return `
  	      <g>
  	        <circle
  	          cx="${CX}"
  	          cy="${CY}"
  	          r="${OUTER_R}"
  	          fill="none"
  	          stroke="#ffffff"
  	          stroke-width="${OUTLINE_W}"
  	        />

  	        <g transform="rotate(${heading}, ${CX}, ${CY})">
  	          <path
  	            d="
  	              M ${CX},${tipY}
  	              L ${CX - PTR_HALF},${baseY}
  	              L ${CX + PTR_HALF},${baseY}
  	              Z
  	            "
  	            fill="none"
  	            stroke="#ffffff"
  	            stroke-width="${OUTLINE_W}"
  	          />
  	        </g>

  	        <circle
  	          cx="${CX}"
  	          cy="${CY}"
  	          r="${OUTER_R}"
  	          fill="${bodyColor}"
  	          stroke="#101010"
  	          stroke-width="2"
  	        />

  	        <circle
  	          cx="${CX}"
  	          cy="${CY}"
  	          r="${DOT_R}"
  	          fill="${dotColor}"
  	          stroke="#ffffff"
  	          stroke-width="2"
  	        />

  	        <circle
  	          cx="${CX}"
  	          cy="${CY}"
  	          r="${DOT_R - 3}"
  	          fill="none"
  	          stroke="rgba(255,255,255,0.40)"
  	          stroke-width="2"
  	        />

  	        <g transform="rotate(${heading}, ${CX}, ${CY})">
  	          <path
  	            d="
  	              M ${CX},${tipY}
  	              L ${CX - PTR_HALF},${baseY}
  	              L ${CX + PTR_HALF},${baseY}
  	              Z
  	            "
  	            fill="${bodyColor}"
  	            stroke="#101010"
  	            stroke-width="2"
  	          />
  	        </g>
  	      </g>
  	    `;
  	  }

  	  function batteryAlertSvg(cx) {
  	    const cy = BASE_H / 2;

  	    return `
  	      <g>
  	        <circle
  	          cx="${cx}"
  	          cy="${cy}"
  	          r="38"
  	          fill="${ALERT_RED}"
  	          stroke="#ffffff"
  	          stroke-width="5"
  	        />

  	        <circle
  	          cx="${cx}"
  	          cy="${cy}"
  	          r="38"
  	          fill="none"
  	          stroke="#101010"
  	          stroke-width="2"
  	        />

  	        <rect
  	          x="${cx - 24}"
  	          y="${cy - 17}"
  	          width="43"
  	          height="34"
  	          rx="5"
  	          fill="none"
  	          stroke="#ffffff"
  	          stroke-width="6"
  	        />

  	        <rect
  	          x="${cx + 19}"
  	          y="${cy - 8}"
  	          width="8"
  	          height="16"
  	          rx="2"
  	          fill="#ffffff"
  	        />

  	        <line
  	          x1="${cx - 5}"
  	          y1="${cy - 10}"
  	          x2="${cx - 5}"
  	          y2="${cy + 3}"
  	          stroke="#ffffff"
  	          stroke-width="6"
  	          stroke-linecap="round"
  	        />

  	        <circle
  	          cx="${cx - 5}"
  	          cy="${cy + 11}"
  	          r="3.5"
  	          fill="#ffffff"
  	        />
  	      </g>
  	    `;
  	  }

  	  function staleWifiSvg(cx) {
  	    const cy = BASE_H / 2;

  	    return `
  	      <g>
  	        <circle
  	          cx="${cx}"
  	          cy="${cy}"
  	          r="38"
  	          fill="${ALERT_RED}"
  	          stroke="#ffffff"
  	          stroke-width="5"
  	        />

  	        <circle
  	          cx="${cx}"
  	          cy="${cy}"
  	          r="38"
  	          fill="none"
  	          stroke="#101010"
  	          stroke-width="2"
  	        />

  	        <path
  	          d="
  	            M ${cx - 25},${cy - 8}
  	            Q ${cx},${cy - 30}
  	              ${cx + 25},${cy - 8}
  	          "
  	          fill="none"
  	          stroke="#ffffff"
  	          stroke-width="6"
  	          stroke-linecap="round"
  	        />

  	        <path
  	          d="
  	            M ${cx - 17},${cy + 1}
  	            Q ${cx},${cy - 13}
  	              ${cx + 17},${cy + 1}
  	          "
  	          fill="none"
  	          stroke="#ffffff"
  	          stroke-width="6"
  	          stroke-linecap="round"
  	        />

  	        <path
  	          d="
  	            M ${cx - 9},${cy + 10}
  	            Q ${cx},${cy + 3}
  	              ${cx + 9},${cy + 10}
  	          "
  	          fill="none"
  	          stroke="#ffffff"
  	          stroke-width="6"
  	          stroke-linecap="round"
  	        />

  	        <circle
  	          cx="${cx}"
  	          cy="${cy + 19}"
  	          r="4.5"
  	          fill="#ffffff"
  	        />

  	        <line
  	          x1="${cx - 29}"
  	          y1="${cy - 29}"
  	          x2="${cx + 29}"
  	          y2="${cy + 29}"
  	          stroke="#ffffff"
  	          stroke-width="7"
  	          stroke-linecap="round"
  	        />
  	      </g>
  	    `;
  	  }

  	  function buildSvg(
  	    color,
  	    health
  	  ) {
  	    const statuses = [];

  	    if (health.batteryFailure) {
  	      statuses.push("battery");
  	    }

  	    if (health.stale) {
  	      statuses.push("stale");
  	    }

  	    // Repeater layout:
  	    // - Keep a FIXED width large enough for vehicle + two warnings.
  	    // - Anchor the vehicle icon at the FAR LEFT.
  	    // - Pack active warning icons immediately after the vehicle.
  	    // - Any unused warning space remains transparent on the RIGHT.
  	    //
  	    // This keeps every vehicle name aligned to the same X position
  	    // regardless of whether it has 0, 1 or 2 warning icons.
  	    const totalW =
  	      BASE_W + (STATUS_SLOT_W * 2);

  	    const vehicleOffsetX = 0;
  	    const vehicleRight = BASE_W;

  	    let statusSvg = "";

  	    statuses.forEach(
  	      (status, index) => {
  	        const cx =
  	          vehicleRight +
  	          (STATUS_SLOT_W / 2) +
  	          (index * STATUS_SLOT_W);

  	        if (status === "battery") {
  	          statusSvg +=
  	            batteryAlertSvg(cx);
  	        }

  	        if (status === "stale") {
  	          statusSvg +=
  	            staleWifiSvg(cx);
  	        }
  	      }
  	    );

  	    const svg = `
  	      <svg
  	        xmlns="http://www.w3.org/2000/svg"
  	        width="${totalW}"
  	        height="${BASE_H}"
  	        viewBox="0 0 ${totalW} ${BASE_H}"
  	      >
  	        ${vehicleSvg(
  	          color,
  	          health.heading,
  	          vehicleOffsetX
  	        )}

  	        ${statusSvg}
  	      </svg>
  	    `;

  	    return {
  	      svg,
  	      width: totalW,
  	      height: BASE_H
  	    };
  	  }

  	  function makeDataUrl(
  	    color,
  	    health
  	  ) {
  	    const badge =
  	      buildSvg(
  	        color,
  	        health
  	      );

  	    return {
  	      url:
  	        "data:image/svg+xml;charset=UTF-8," +
  	        encodeURIComponent(badge.svg),

  	      viewWidth:
  	        badge.width,

  	      viewHeight:
  	        badge.height
  	    };
  	  }

  	  // ------------------------------------------------------------
  	  // RENDER
  	  // ------------------------------------------------------------

  	  function statusTitle(health) {
  	    const parts = [];
  	    if (health.batteryFailure) parts.push("Recent low external power supply reading: " + health.externalVoltage.toFixed(2) + " V");
  	    const age = health.ageSeconds === null ? "age unknown" : Math.round(health.ageSeconds) + " seconds old";
  	    if (health.stale) {
  	      parts.push("Reporting gap: last known " + (health.moving === true ? "moving" : "ignition/engine ON") +
  	        " telemetry is " + age + "; communication loss is unconfirmed");
  	    } else if (health.state === "parked-off-last-known") {
  	      parts.push("Last known parked with ignition OFF; tracker may be sleeping (" + age + "); current communication unknown");
  	    } else if (health.state === "recent-active") {
  	      parts.push("Recent active telemetry (" + age + "); no reporting gap at configured threshold");
  	    } else {
  	      parts.push("Tracking state unknown (" + age + "); missing or unrecognised activity/age data");
  	    }
  	    if (health.sourceSaysStale === true && !health.stale) parts.push("Snapshot source marks data stale; this does not establish signal loss");
  	    return parts.join(" | ");
  	  }

  	  function render(
  	    root,
  	    component,
  	    color,
  	    health
  	  ) {
  	    const result =
  	      makeDataUrl(
  	        color,
  	        health
  	      );

  	    const widthRatio =
  	      result.viewWidth /
  	      result.viewHeight;

  	    const renderedWidth =
  	      Math.round(
  	        DEFAULT_SIZE *
  	        widthRatio
  	      );

  	    const title =
  	      statusTitle(health);

  	    try {
  	      if (
  	        component &&
  	        typeof component === "object"
  	      ) {
  	        component.src = result.url;
  	        component.url = result.url;
  	        component.image = result.url;
  	        component.imageUrl = result.url;
  	        component.value = result.url;
  	      }
  	    } catch (_) {}

  	    root.style.width =
  	      renderedWidth + "px";

  	    root.style.height =
  	      DEFAULT_SIZE + "px";

  	    root.style.minWidth =
  	      renderedWidth + "px";

  	    root.style.minHeight =
  	      DEFAULT_SIZE + "px";

  	    root.style.maxWidth =
  	      renderedWidth + "px";

  	    root.style.maxHeight =
  	      DEFAULT_SIZE + "px";

  	    root.style.display = "flex";
  	    root.style.alignItems = "center";
  	    root.style.justifyContent = "flex-start";
  	    root.style.overflow = "visible";
  	    root.style.lineHeight = "0";
  	    root.style.boxSizing = "border-box";
  	    root.style.padding = "0";
  	    root.style.margin = "0";

  	    root.title = title;

  	    try {
  	      root.dataset.trackitRegistration =
  	        health.registration;

  	      root.dataset.trackitStale =
  	        health.stale
  	          ? "true"
  	          : "false";

  	      root.dataset.trackitBatteryFailure =
  	        health.batteryFailure
  	          ? "true"
  	          : "false";
  	    } catch (_) {}

  	    if (
  	      root.tagName &&
  	      root.tagName.toLowerCase() === "img"
  	    ) {
  	      root.src = result.url;
  	      root.alt = "";
  	      root.title = title;

  	      root.style.width =
  	        renderedWidth + "px";

  	      root.style.height =
  	        DEFAULT_SIZE + "px";

  	      root.style.objectFit =
  	        "contain";

  	      root.style.objectPosition =
  	        "left center";

  	      root.style.display =
  	        "block";

  	      return;
  	    }

  	    root.innerHTML = "";

  	    const holder =
  	      document.createElement("div");

  	    holder.style.width =
  	      renderedWidth + "px";

  	    holder.style.height =
  	      DEFAULT_SIZE + "px";

  	    holder.style.display =
  	      "flex";

  	    holder.style.alignItems =
  	      "center";

  	    holder.style.justifyContent =
  	      "flex-start";

  	    holder.style.overflow =
  	      "visible";

  	    holder.style.lineHeight =
  	      "0";

  	    holder.style.padding =
  	      "0";

  	    holder.style.margin =
  	      "0";

  	    const img =
  	      document.createElement("img");

  	    img.src = result.url;
  	    img.alt = "";
  	    img.title = title;

  	    img.style.width =
  	      renderedWidth + "px";

  	    img.style.height =
  	      DEFAULT_SIZE + "px";

  	    img.style.display =
  	      "block";

  	    img.style.objectFit =
  	      "contain";

  	    img.style.objectPosition =
  	      "left center";

  	    img.style.margin =
  	      "0";

  	    img.style.padding =
  	      "0";

  	    img.style.pointerEvents =
  	      "none";

  	    holder.appendChild(img);
  	    root.appendChild(holder);
  	  }

  	  // ------------------------------------------------------------
  	  // EXECUTION
  	  // ------------------------------------------------------------

  	  const start =
  	    Date.now();

  	  while (
  	    Date.now() - start <
  	    WAIT_TIMEOUT_MS
  	  ) {
  	    const color =
  	      readArg("Color");

  	    const component =
  	      readArg("Component");

  	    const vehicle =
  	      readArg("Vehicle");

  	    const root =
  	      getRoot(component);

  	    if (
  	      root &&
  	      vehicle &&
  	      typeof vehicle === "object"
  	    ) {
  	      const health =
  	        deriveHealth(vehicle);

  	      render(
  	        root,
  	        component,
  	        safeCssColor(color),
  	        health
  	      );

  	      console.info(
  	        "[TrackIT Icon] Vehicle health",
  	        {
  	          registration:
  	            health.registration,

  	          tracker:
  	            vehicle?.Tracker ?? null,

  	          state: health.state,
  	          telemetrySource: health.telemetrySource,
  	          telemetryTimestamp: health.telemetryTimestamp,
  	          communicationLossConfirmed: health.communicationLossConfirmed,

  	          stale:
  	            health.stale,

  	          sourceSaysStale:
  	            health.sourceSaysStale,

  	          ageSeconds:
  	            health.ageSeconds,

  	          moving:
  	            health.moving,

  	          speed:
  	            health.speed,

  	          ignition:
  	            health.ignition,

  	          engineOn:
  	            health.engineOn,

  	          expectedToReport:
  	            health.expectedToReport,

  	          externalVoltage:
  	            health.externalVoltage,

  	          batteryFailure:
  	            health.batteryFailure,

  	          heading:
  	            health.heading,

  	          snapshotFound:
  	            !!health.snapshot,

  	          locationFound:
  	            !!health.location
  	        }
  	      );

  	      return;
  	    }

  	    await sleep(
  	      WAIT_STEP_MS
  	    );
  	  }

  	  // If Vehicle was not received, do not pretend tracking is healthy.
  	  const component =
  	    readArg("Component");

  	  const root =
  	    getRoot(component);

  	  if (root) {
  	    console.error(
  	      "[TrackIT Icon] Vehicle argument missing or invalid.",
  	      {
  	        Vehicle:
  	          readArg("Vehicle"),

  	        Color:
  	          readArg("Color"),

  	        Component:
  	          component
  	      }
  	    );
  	  } else {
  	    console.error(
  	      "[TrackIT Icon] Component root could not be resolved."
  	    );
  	  }
  	})();

  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'color')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ae7f253cbca10d381c4848c2cd2f6968')), ___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'));

  },
  /* handler:onMounted */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function(APP, Tractor, Logo) {
  	/*
  	 * Fleet In Form — Vehicle Click + CANbus Telemetry Dashboard
  	 * Version 4.5.0
  	 *
  	 * Backendless Custom Code arguments expected:
  	 *   APP      -> App Data
  	 *   Tractor  -> Repeater tractor object
  	 *   Logo     -> Fleet In Form logo (data URI, URL, or raw SVG markup)
  	 *
  	 * Behaviour:
  	 *   Single click  -> existing map select / center / zoom behaviour
  	 *   Double click  -> full-screen CANbus telemetry dashboard
  	 */

  	(function FIFVehicleClickCANbusDashboard(___arguments) {
  	  "use strict";

  	  const VERSION = "4.5.0";
  	  const MAP_UID = "1c5c1158d7432af8a60840f7e4d8f854";
  	  const ROOT_ID = "fif-can-dashboard-root";
  	  const STYLE_ID = "fif-can-dashboard-style";
  	  const DTC_MODAL_ID = "fif-can-dtc-modal";
  	  const CLICK_STATE_KEY = "__FIF_VEHICLE_DOUBLE_CLICK_V3__";
  	  const DASH_STATE_KEY = "__FIF_CAN_DASHBOARD_V3__";
  	  const DOUBLE_CLICK_MS = 320;
  	  const SAMPLE_MS = 2000;
  	  const MAX_SAMPLES = 42;

  	  const ctx = ___arguments && ___arguments.context ? ___arguments.context : {};
  	  const APP = (___arguments && (___arguments.APP || ___arguments.App || ___arguments.app)) || ctx.appData || {};
  	  const Tractor = (___arguments && (___arguments.Tractor || ___arguments.tractor)) || ctx.dataModel || null;
  	  // Backendless exposes connected Custom Code inputs as variables in the
  	  // generated handler scope. This mirrors the proven Rog report pattern:
  	  //   const svg = typeof SVG !== "undefined" ? SVG : window.SVG || null;
  	  //
  	  // Do NOT try to crawl ___arguments/context for Logo.
  	  const logoInput =
  	    typeof Logo !== "undefined"
  	      ? Logo
  	      : (typeof window !== "undefined" ? (window.Logo || null) : null);

  	  const logoAsset =
  	    typeof logoInput === "string"
  	      ? logoInput.trim()
  	      : (logoInput == null ? "" : String(logoInput).trim());

  	  if (!Tractor) {
  	    console.warn("[FIF CAN Dashboard] Tractor argument is missing.");
  	    return false;
  	  }

  	  function arr(value) {
  	    return Array.isArray(value) ? value : [];
  	  }

  	  function clean(value, fallback) {
  	    const s = value == null ? "" : String(value).trim();
  	    return s || (fallback == null ? "" : String(fallback));
  	  }

  	  function num(value, fallback) {
  	    const n = Number(value);
  	    return Number.isFinite(n) ? n : (fallback == null ? null : fallback);
  	  }

  	  function clamp(value, min, max) {
  	    return Math.max(min, Math.min(max, value));
  	  }

  	  function esc(value) {
  	    return String(value == null ? "" : value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/"/g, "&quot;")
  	      .replace(/'/g, "&#039;");
  	  }

  	  function logoHtml() {
  	    if (!logoAsset) {
  	      return '<div class="side-logo-missing" title="Logo input not supplied">LOGO</div>';
  	    }

  	    // Same successful pattern used in the Rog report:
  	    // raw SVG -> inject directly; data:image -> normal <img src="...">.
  	    if (logoAsset.trim().startsWith("<svg")) {
  	      let cleaned = logoAsset
  	        .replace(
  	          /<svg(?![^>]*preserveAspectRatio)/i,
  	          '<svg preserveAspectRatio="xMidYMid meet"'
  	        )
  	        .replace(
  	          /<svg([^>]*?)>/i,
  	          '<svg$1 class="fif-user-logo-svg" style="width:100%;height:100%;max-width:80px;max-height:58px;display:block;" >'
  	        );

  	      return '<div class="side-logo-mark side-logo-inline">' + cleaned + '</div>';
  	    }

  	    if (
  	      logoAsset.startsWith("data:image") ||
  	      logoAsset.startsWith("http://") ||
  	      logoAsset.startsWith("https://") ||
  	      logoAsset.startsWith("blob:")
  	    ) {
  	      return '<div class="side-logo-mark">'
  	        + '<img class="side-logo-img loaded" src="' + esc(logoAsset) + '" alt="Fleet In Form">'
  	        + '</div>';
  	    }

  	    console.warn(
  	      "[FIF CAN Dashboard] Logo input exists but is not a supported SVG/image value.",
  	      { length: logoAsset.length, prefix: logoAsset.slice(0, 30) }
  	    );

  	    return '<div class="side-logo-missing" title="Unsupported Logo value">LOGO</div>';
  	  }

  	  function get(object, path, fallback) {
  	    if (!object || !path) return fallback;
  	    if (Object.prototype.hasOwnProperty.call(object, path)) {
  	      return object[path] === undefined ? fallback : object[path];
  	    }
  	    const parts = String(path).split(".");
  	    let value = object;
  	    for (let i = 0; i < parts.length; i += 1) {
  	      if (value == null || value[parts[i]] === undefined) return fallback;
  	      value = value[parts[i]];
  	    }
  	    return value === undefined ? fallback : value;
  	  }

  	  function has(object, path) {
  	    if (!object || !path) return false;
  	    if (Object.prototype.hasOwnProperty.call(object, path)) return true;
  	    const parts = String(path).split(".");
  	    let value = object;
  	    for (let i = 0; i < parts.length; i += 1) {
  	      if (value == null || !Object.prototype.hasOwnProperty.call(value, parts[i])) return false;
  	      value = value[parts[i]];
  	    }
  	    return true;
  	  }

  	  function descriptor(value) {
  	    if (value && typeof value === "object" && !Array.isArray(value) && Object.prototype.hasOwnProperty.call(value, "value")) {
  	      return value.value;
  	    }
  	    return value;
  	  }

  	  function first(values, fallback) {
  	    for (let i = 0; i < values.length; i += 1) {
  	      const value = descriptor(values[i]);
  	      if (value !== undefined && value !== null && value !== "") return value;
  	    }
  	    return fallback;
  	  }

  	  function bool(value) {
  	    value = descriptor(value);
  	    if (typeof value === "boolean") return value;
  	    if (value === 1 || value === "1") return true;
  	    if (value === 0 || value === "0") return false;
  	    const key = clean(value).toLowerCase();
  	    if (["true", "yes", "on"].indexOf(key) !== -1) return true;
  	    if (["false", "no", "off"].indexOf(key) !== -1) return false;
  	    return null;
  	  }

  	  function fmt(value, decimals) {
  	    const n = num(value, null);
  	    if (n === null) return "—";
  	    return n.toLocaleString("en-ZA", {
  	      minimumFractionDigits: decimals == null ? 0 : decimals,
  	      maximumFractionDigits: decimals == null ? 0 : decimals
  	    });
  	  }

  	  function formatTime(unixValue) {
  	    const n = num(unixValue, null);
  	    if (n === null) return "—";
  	    const ms = n < 100000000000 ? n * 1000 : n;
  	    try {
  	      return new Date(ms).toLocaleString("en-ZA", {
  	        timeZone: "Africa/Johannesburg",
  	        day: "2-digit",
  	        month: "short",
  	        year: "numeric",
  	        hour: "2-digit",
  	        minute: "2-digit",
  	        second: "2-digit"
  	      });
  	    } catch (_) {
  	      return "—";
  	    }
  	  }

  	  function relativeAge(unixValue) {
  	    const n = num(unixValue, null);
  	    if (n === null) return "No timestamp";
  	    const ms = n < 100000000000 ? n * 1000 : n;
  	    const seconds = Math.max(0, Math.round((Date.now() - ms) / 1000));
  	    if (seconds < 10) return "Live now";
  	    if (seconds < 60) return seconds + " sec ago";
  	    if (seconds < 3600) return Math.round(seconds / 60) + " min ago";
  	    if (seconds < 86400) return Math.round(seconds / 3600) + " h ago";
  	    return Math.round(seconds / 86400) + " d ago";
  	  }

  	  function tractorId(tractor) {
  	    return clean(first([
  	      tractor && tractor.objectId,
  	      tractor && tractor.ID,
  	      tractor && tractor.FID,
  	      tractor && tractor.Registration,
  	      tractor && tractor.Tracker
  	    ], ""));
  	  }

  	  function findLiveTractor(app, id) {
  	    const user = app && app.User ? app.User : app;
  	    const companies = arr(user && user.Companies);
  	    for (let c = 0; c < companies.length; c += 1) {
  	      const tractors = arr(companies[c] && companies[c].Tractors);
  	      for (let t = 0; t < tractors.length; t += 1) {
  	        if (tractorId(tractors[t]) === id) return tractors[t];
  	      }
  	    }
  	    return null;
  	  }

  	  function currentTractor() {
  	    return findLiveTractor(APP, tractorId(Tractor)) || Tractor;
  	  }

  	  function locationOf(tractor) {
  	    return tractor && tractor.Location && typeof tractor.Location === "object" ? tractor.Location : {};
  	  }

  	  function snapshotCurrent(tractor) {
  	    const view = tractor && tractor.ViewC;
  	    const actualView = Array.isArray(view) ? view[0] : view;
  	    if (!actualView || typeof actualView !== "object") return {};
  	    let snap = actualView.Snapshot || actualView.snapshot || {};
  	    if (typeof snap === "string") {
  	      try { snap = JSON.parse(snap); } catch (_) { snap = {}; }
  	    }
  	    const current = snap && (snap.current || snap.Current);
  	    return current && typeof current === "object" ? current : {};
  	  }

  	  function sourceValue(candidates, fallback) {
  	    for (let i = 0; i < candidates.length; i += 1) {
  	      const candidate = candidates[i] || {};
  	      const value = descriptor(candidate.value);
  	      if (value !== undefined && value !== null && value !== "") {
  	        return { value: value, source: clean(candidate.source, "DATA"), path: clean(candidate.path, "") };
  	      }
  	    }
  	    return { value: fallback, source: "NO SIGNAL", path: "" };
  	  }

  	  function snapshotContainer(tractor) {
  	    const view = tractor && tractor.ViewC;
  	    const actualView = Array.isArray(view) ? view[0] : view;
  	    if (!actualView || typeof actualView !== "object") return {};
  	    let snap = actualView.Snapshot || actualView.snapshot || {};
  	    if (typeof snap === "string") {
  	      try { snap = JSON.parse(snap); } catch (_) { snap = {}; }
  	    }
  	    return snap && typeof snap === "object" ? snap : {};
  	  }

  	  function snapshotCurrent(tractor) {
  	    const snap = snapshotContainer(tractor);
  	    const current = snap.current || snap.Current;
  	    return current && typeof current === "object" ? current : {};
  	  }

  	  function viewC(tractor) {
  	    const value = tractor && tractor.ViewC;
  	    return Array.isArray(value) ? (value[0] || {}) : (value || {});
  	  }

  	  function monthlyReport(tractor) {
  	    const report = get(tractor, "Reports.Monthly", null);
  	    return report && typeof report === "object" ? report : {};
  	  }

  	  function secondsAge(unixValue) {
  	    const n = num(unixValue, null);
  	    if (n === null) return null;
  	    const ms = n < 100000000000 ? n * 1000 : n;
  	    return Math.max(0, Math.round((Date.now() - ms) / 1000));
  	  }

  	  function telemetry(tractor) {
  	    const l = locationOf(tractor);
  	    const s = snapshotCurrent(tractor);
  	    const id = identity(tractor);
  	    const counterType = clean(first([
  	      tractor && tractor.CounterType,
  	      get(tractor, "Data.Vehicle.Usage.CounterType.value", ""),
  	      get(tractor, "Data.Vehicle.Usage.CounterType", "")
  	    ], "Kilometers"));
  	    const hoursVehicle = counterType.toLowerCase().indexOf("hour") !== -1;

  	    const fuelPctField = sourceValue([
  	      { value: l["can.fuel.level"], source: "CAN", path: "Location.can.fuel.level" },
  	      { value: s.fuel_level, source: "SNAPSHOT", path: "ViewC.Snapshot.current.fuel_level" }
  	    ], null);
  	    const mileageField = sourceValue([
  	      { value: l["can.vehicle.mileage"], source: "CAN", path: "Location.can.vehicle.mileage" },
  	      { value: s.can_mileage, source: "SNAPSHOT", path: "ViewC.Snapshot.current.can_mileage" },
  	      { value: hoursVehicle ? null : get(tractor, "Data.Vehicle.Usage.CurrentReading.value", null), source: "CONFIG", path: "Data.Vehicle.Usage.CurrentReading" },
  	      { value: hoursVehicle ? null : tractor.Mileage, source: "BACKENDLESS", path: "Mileage" }
  	    ], null);
  	    const rpmField = sourceValue([
  	      { value: l["can.engine.rpm"], source: "CAN", path: "Location.can.engine.rpm" },
  	      { value: s.rpm, source: "SNAPSHOT", path: "ViewC.Snapshot.current.rpm" }
  	    ], null);
  	    const speedField = sourceValue([
  	      { value: l["can.vehicle.speed"], source: "CAN", path: "Location.can.vehicle.speed" },
  	      { value: l["position.speed"], source: "GPS", path: "Location.position.speed" },
  	      { value: s.can_speed, source: "SNAPSHOT", path: "ViewC.Snapshot.current.can_speed" },
  	      { value: s.speed, source: "SNAPSHOT", path: "ViewC.Snapshot.current.speed" }
  	    ], null);
  	    const tempField = sourceValue([
  	      { value: l["can.engine.temperature"], source: "CAN", path: "Location.can.engine.temperature" },
  	      { value: s.engine_temperature, source: "SNAPSHOT", path: "ViewC.Snapshot.current.engine_temperature" }
  	    ], null);
  	    const timestampField = sourceValue([
  	      { value: l.timestamp, source: "TRACKER", path: "Location.timestamp" },
  	      { value: l["server.timestamp"], source: "TRACKER", path: "Location.server.timestamp" },
  	      { value: s.timestamp, source: "SNAPSHOT", path: "ViewC.Snapshot.current.timestamp" }
  	    ], null);
  	    const ignitionField = sourceValue([
  	      { value: l["engine.ignition.status"], source: "TRACKER", path: "Location.engine.ignition.status" },
  	      { value: l["can.engine.ignition.status"], source: "CAN", path: "Location.can.engine.ignition.status" },
  	      { value: s.ignition, source: "SNAPSHOT", path: "ViewC.Snapshot.current.ignition" }
  	    ], null);
  	    const fuelConsumedField = sourceValue([
  	      { value: l["can.fuel.consumed"], source: "CAN", path: "Location.can.fuel.consumed" },
  	      { value: l["can.tracker.counted.fuel.consumed"], source: "TRACKER", path: "Location.can.tracker.counted.fuel.consumed" }
  	    ], null);

  	    const timestamp = num(timestampField.value, null);
  	    const ageSeconds = secondsAge(timestamp);
  	    const snapshotStale = bool(s.stale) === true;
  	    const hasCan = bool(l["fif.has.can"]);
  	    let freshness = "NO DATA";
  	    if (timestamp !== null) {
  	      if (ageSeconds !== null && ageSeconds <= 90) freshness = "LIVE";
  	      else if (ageSeconds !== null && ageSeconds <= 600) freshness = "DELAYED";
  	      else freshness = "STALE";
  	    }
  	    if (hasCan === false && freshness === "LIVE") freshness = "TRACKER";
  	    if (snapshotStale && freshness === "LIVE") freshness = "DELAYED";

  	    const canTank = num(get(tractor, "CAN.Tank", null), null);
  	    const vehicleTank = num(descriptor(get(tractor, "Data.Vehicle.Tank_Capacity", null)), null);
  	    const tankCapacity = canTank !== null ? canTank : vehicleTank;
  	    const fuelPct = num(fuelPctField.value, null);
  	    const configuredReading = num(first([
  	      get(tractor, "Data.Vehicle.Usage.CurrentReading.value", null),
  	      tractor && tractor.Mileage
  	    ], null), null);
  	    const mileage = num(mileageField.value, null);
  	    const hourReading = hoursVehicle ? configuredReading : null;
  	    const rangeConfigured = num(first([
  	      get(tractor, "Data.Vehicle.Tractor_Range.value", null),
  	      get(tractor, "Data.Vehicle.Usage.Range.value", null),
  	      tractor && tractor.Range
  	    ], null), null);

  	    return {
  	      location: l,
  	      snapshot: s,
  	      identity: id,
  	      counterType: counterType,
  	      hoursVehicle: hoursVehicle,
  	      fuelPct: fuelPct,
  	      fuelPctSource: fuelPctField.source,
  	      fuelPctPath: fuelPctField.path,
  	      fuelLitres: fuelPct !== null && tankCapacity !== null ? tankCapacity * fuelPct / 100 : null,
  	      tankCapacity: tankCapacity,
  	      canTank: canTank,
  	      vehicleTank: vehicleTank,
  	      rangeConfigured: rangeConfigured,
  	      estimatedRange: fuelPct !== null && rangeConfigured !== null ? rangeConfigured * clamp(fuelPct, 0, 100) / 100 : null,
  	      mileage: mileage,
  	      mileageSource: mileageField.source,
  	      configuredReading: configuredReading,
  	      mileageDelta: !hoursVehicle && mileage !== null && configuredReading !== null ? mileage - configuredReading : null,
  	      hourReading: hourReading,
  	      timestamp: timestamp,
  	      timestampSource: timestampField.source,
  	      ageSeconds: ageSeconds,
  	      freshness: freshness,
  	      stale: freshness === "STALE" || freshness === "NO DATA",
  	      speed: num(speedField.value, null),
  	      speedSource: speedField.source,
  	      rpm: num(rpmField.value, null),
  	      rpmSource: rpmField.source,
  	      temp: num(tempField.value, null),
  	      tempSource: tempField.source,
  	      ignition: bool(ignitionField.value),
  	      ignitionSource: ignitionField.source,
  	      engineOn: bool(first([l["fif.engine.on"], s.engine_on, ignitionField.value], null)),
  	      fuelConsumed: num(fuelConsumedField.value, null),
  	      fuelConsumedSource: fuelConsumedField.source,
  	      canFuelConsumed: num(l["can.fuel.consumed"], null),
  	      trackerFuelConsumed: num(l["can.tracker.counted.fuel.consumed"], null),
  	      throttle: num(l["can.throttle.pedal.level"], null),
  	      externalVoltage: num(l["external.powersource.voltage"], null),
  	      internalVoltage: num(l["battery.voltage"], null),
  	      charging: bool(l["can.vehicle.battery.charging.status"]),
  	      signal: num(l["gsm.signal.level"], null),
  	      satellites: num(l["position.satellites"], null),
  	      hdop: num(l["position.hdop"], null),
  	      pdop: num(l["position.pdop"], null),
  	      gnssValid: bool(first([l["position.valid"], l["gnss.status"]], null)),
  	      altitude: num(l["position.altitude"], null),
  	      direction: num(first([l["position.direction"], s.direction], null), null),
  	      latitude: num(first([l["position.latitude"], s.latitude], null), null),
  	      longitude: num(first([l["position.longitude"], s.longitude], null), null),
  	      hasCan: hasCan,
  	      motion: clean(l["fif.motion.state"], num(speedField.value, 0) > 0 ? "moving" : "stationary"),
  	      deviceId: clean(first([l["device.id"], tractor && tractor.Tracker], "")),
  	      deviceName: clean(l["device.name"], ""),
  	      ident: clean(l.ident, ""),
  	      codecId: clean(l["codec.id"], ""),
  	      protocolId: clean(l["protocol.id"], ""),
  	      channelId: clean(l["channel.id"], ""),
  	      peer: clean(l.peer, ""),
  	      gsmOperator: clean(l["gsm.operator.code"], ""),
  	      gsmMcc: clean(l["gsm.mcc"], ""),
  	      gsmMnc: clean(l["gsm.mnc"], ""),
  	      msgKind: clean(l["fif.msg.kind"], ""),
  	      programId: clean(l["can.program.id"], "")
  	    };
  	  }

  	  function singleClickAction(tractor) {
  	    try {
  	      if (APP && typeof APP === "object") {
  	        APP.SelectedTractorMarker = tractor && tractor.objectId;
  	      }
  	      if (ctx && ctx.appData && typeof ctx.appData === "object") {
  	        ctx.appData.SelectedTractorMarker = tractor && tractor.objectId;
  	      }

  	      const l = locationOf(tractor);
  	      const s = snapshotCurrent(tractor);
  	      const lat = num(first([l["position.latitude"], s.latitude], null), null);
  	      const lng = num(first([l["position.longitude"], s.longitude], null), null);

  	      if (lat !== null && lng !== null && ctx && typeof ctx.getComponentByUid === "function") {
  	        const map = ctx.getComponentByUid(MAP_UID);
  	        if (map) {
  	          map.center = { lat: lat, lng: lng };
  	          map.zoom = 20;
  	        }
  	      }
  	    } catch (error) {
  	      console.warn("[FIF Vehicle Click] Could not center selected tractor.", error);
  	    }
  	  }


  	  function installStyles() {
  	    const old = document.getElementById(STYLE_ID);
  	    if (old) old.remove();
  	    const style = document.createElement("style");
  	    style.id = STYLE_ID;
  	    style.textContent = `
  	      #${ROOT_ID}, #${ROOT_ID} * { box-sizing:border-box; }
  	      #${ROOT_ID} {
  	        --bg:#041018; --panel:#08161f; --panel2:#0b1b25; --panel3:#0e222d; --line:#173543; --line2:#24505e;
  	        --text:#edf8fb; --muted:#748b96; --muted2:#536c78; --cyan:#39b6e4; --green:#61d36d; --amber:#e8b83a;
  	        --orange:#df7c34; --red:#ff5959; --blue:#4ea7e4; --violet:#b58cff;
  	        position:fixed; inset:0; z-index:2147483500; overflow:hidden;
  	        background:radial-gradient(circle at 62% -18%,rgba(44,145,185,.13),transparent 31%),linear-gradient(180deg,#07151e,#030a0f 74%);
  	        color:var(--text); font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;
  	      }
  	      #${ROOT_ID} button { font:inherit; }
  	      #${ROOT_ID} .dash-layout { display:grid; grid-template-columns:92px minmax(0,1fr); height:100vh; }
  	      #${ROOT_ID} .side { min-height:0; background:linear-gradient(180deg,#07141d,#040c12); border-right:1px solid #13303d; display:flex; flex-direction:column; }
  	      #${ROOT_ID} .side-brand { height:76px; display:grid; place-items:center; padding:7px 5px; border-bottom:1px solid #12303d; color:var(--cyan); }
  	      #${ROOT_ID} .side-wing { display:none; }
  	      #${ROOT_ID} .side-logo-mark { width:80px; height:60px; display:grid; place-items:center; overflow:visible; }
  	      #${ROOT_ID} .side-logo-img { display:block; max-width:80px; max-height:60px; width:auto; height:auto; object-fit:contain; opacity:0; transition:opacity .16s ease; filter:drop-shadow(0 5px 9px rgba(0,0,0,.30)); }
  	      #${ROOT_ID} .side-logo-img.loaded { opacity:1; }
  	      #${ROOT_ID} .side-logo-inline { overflow:visible; }
  	      #${ROOT_ID} .side-logo-inline svg { display:block; width:100%; height:100%; max-width:80px; max-height:60px; }
  	      #${ROOT_ID} .side-logo-missing,#${ROOT_ID} .side-logo-error { color:#637985; font-size:7px; font-weight:900; letter-spacing:.12em; opacity:.68; }
  	      #${ROOT_ID} .nav { padding:8px 7px; display:flex; flex-direction:column; gap:3px; }
  	      #${ROOT_ID} .nav-btn { appearance:none; border:1px solid transparent; background:transparent; color:#81949e; min-height:55px; border-radius:8px; display:grid; place-items:center; align-content:center; gap:5px; cursor:pointer; font-size:8px; font-weight:800; padding:5px 2px; transition:.14s ease; }
  	      #${ROOT_ID} .nav-btn .nav-ico { width:18px; height:18px; color:#a5b5bd; }
  	      #${ROOT_ID} .nav-btn.active { color:#62c8ef; background:linear-gradient(180deg,#0b2635,#09202d); border-color:#17526b; box-shadow:inset 2px 0 0 var(--cyan); }
  	      #${ROOT_ID} .nav-btn.active .nav-ico { color:#62c8ef; filter:drop-shadow(0 0 5px rgba(57,182,228,.28)); }
  	      #${ROOT_ID} .nav-btn:hover { background:#0a1d27; color:#e3eff3; }
  	      #${ROOT_ID} .nav-spacer { flex:1; }
  	      #${ROOT_ID} .side-badge { margin:0 auto 10px; width:60px; text-align:center; color:#6f858f; font-size:6px; line-height:1.35; font-weight:800; }
  	      #${ROOT_ID} .side-badge-ring { width:44px; height:44px; margin:0 auto 4px; border:1px solid #af962f; border-radius:50%; display:grid; place-items:center; color:#e6c139; font-size:16px; box-shadow:0 0 18px rgba(230,193,57,.08); }
  	      #${ROOT_ID} .main { min-width:0; min-height:0; height:100vh; display:grid; grid-template-rows:76px minmax(0,1fr) 26px; overflow:hidden; padding:0 12px; }
  	      #${ROOT_ID} .topbar { display:grid; grid-template-columns:minmax(360px,1.5fr) repeat(4,minmax(110px,.62fr)) auto 42px; align-items:center; gap:12px; border-bottom:1px solid #173440; }
  	      #${ROOT_ID} .vehicle-ident { display:flex; align-items:center; gap:12px; min-width:0; }
  	      #${ROOT_ID} .vehicle-art { width:142px; height:66px; flex:0 0 auto; display:block; overflow:visible; shape-rendering:geometricPrecision; filter:drop-shadow(0 8px 10px rgba(0,0,0,.34)); }
  	      #${ROOT_ID} .brand-mini { color:#8ba0aa; font-size:8px; font-weight:900; letter-spacing:.13em; }
  	      #${ROOT_ID} .title { color:#fff; font-size:15px; font-weight:900; margin-top:2px; }
  	      #${ROOT_ID} .sub-title { color:#b8c7cd; font-size:10px; margin-top:3px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  	      #${ROOT_ID} .head-lab { color:#5f7782; font-size:7px; margin-bottom:4px; text-transform:uppercase; letter-spacing:.05em; }
  	      #${ROOT_ID} .head-val { color:#dce9ed; font-size:9px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  	      #${ROOT_ID} .top-live { display:grid; grid-template-columns:auto 7px auto; align-items:center; gap:7px; justify-self:end; color:#eef7f9; font-size:8px; font-weight:900; white-space:nowrap; }
  	      #${ROOT_ID} .top-live small { grid-column:1/-1; color:#697f89; text-align:right; font-size:6px; font-weight:700; }
  	      #${ROOT_ID} .top-close {
  	        appearance:none; width:34px; height:34px; border-radius:9px; cursor:pointer;
  	        display:grid; place-items:center; justify-self:end;
  	        border:1px solid rgba(96,166,191,.22);
  	        background:linear-gradient(180deg,rgba(14,37,48,.88),rgba(5,17,24,.88));
  	        color:#94aab3;
  	        box-shadow:inset 0 1px 0 rgba(255,255,255,.025),0 8px 20px rgba(0,0,0,.10);
  	        transition:.16s ease;
  	      }
  	      #${ROOT_ID} .top-close:hover {
  	        color:#ff7c86; border-color:rgba(255,91,104,.46);
  	        background:linear-gradient(180deg,rgba(74,27,35,.72),rgba(29,12,18,.84));
  	        box-shadow:inset 0 1px 0 rgba(255,255,255,.03),0 0 18px rgba(255,78,91,.08);
  	        transform:translateY(-1px);
  	      }
  	      #${ROOT_ID} .top-close svg { width:14px; height:14px; display:block; }

  	      #${ROOT_ID} .status-dot { width:7px; height:7px; border-radius:50%; background:var(--green); box-shadow:0 0 0 3px rgba(97,211,109,.08),0 0 11px rgba(97,211,109,.28); }
  	      #${ROOT_ID} .top-live.delayed .status-dot { background:var(--amber); box-shadow:0 0 0 3px rgba(232,184,58,.08),0 0 11px rgba(232,184,58,.25); }
  	      #${ROOT_ID} .top-live.stale .status-dot,#${ROOT_ID} .top-live.nodata .status-dot { background:var(--red); box-shadow:0 0 0 3px rgba(255,89,89,.08),0 0 11px rgba(255,89,89,.25); }
  	      #${ROOT_ID} .signal-bars { display:flex; align-items:end; gap:2px; height:12px; }
  	      #${ROOT_ID} .signal-bars i { display:block; width:2px; background:#d2dde2; opacity:.2; } #${ROOT_ID} .signal-bars i:nth-child(1){height:3px} #${ROOT_ID} .signal-bars i:nth-child(2){height:6px} #${ROOT_ID} .signal-bars i:nth-child(3){height:9px} #${ROOT_ID} .signal-bars i:nth-child(4){height:12px} #${ROOT_ID} .signal-bars i.on{opacity:1}
  	      #${ROOT_ID} .content-shell { min-height:0; overflow:hidden; padding:10px 0 8px; }
  	      #${ROOT_ID} .workspace { min-height:0; height:100%; display:grid; grid-template-columns:minmax(0,1fr) 315px; gap:10px; }
  	      #${ROOT_ID} .left-work { min-width:0; min-height:0; display:grid; grid-template-rows:minmax(0,1fr) 214px; gap:10px; }
  	      #${ROOT_ID} .right { min-width:0; min-height:0; display:grid; grid-template-rows:minmax(170px,.82fr) minmax(165px,.76fr) minmax(155px,.72fr); gap:10px; }
  	      #${ROOT_ID} .panel { min-width:0; min-height:0; border:1px solid var(--line); border-radius:8px; background:linear-gradient(180deg,rgba(8,23,32,.96),rgba(6,18,25,.96)); overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,.12); }
  	      #${ROOT_ID} .panel-head { min-height:37px; display:flex; align-items:center; justify-content:space-between; gap:8px; padding:0 12px; border-bottom:1px solid #15323f; color:#eef7fa; font-size:10px; font-weight:900; }
  	      #${ROOT_ID} .panel-head small { color:#65808c; font-size:7px; font-weight:700; }
  	      #${ROOT_ID} .telemetry-grid { height:calc(100% - 37px); padding:8px; display:grid; grid-template-columns:repeat(5,minmax(0,1fr)); grid-template-rows:repeat(4,minmax(0,1fr)); gap:7px; }
  	      #${ROOT_ID} .card { position:relative; min-width:0; min-height:0; border:1px solid #193946; border-radius:6px; background:linear-gradient(160deg,#081923,#07151d); padding:7px 8px 6px; display:grid; grid-template-rows:18px minmax(0,1fr) 19px; text-align:center; overflow:hidden; transition:border-color .15s ease,box-shadow .15s ease,transform .15s ease; }
  	      #${ROOT_ID} .card:hover { border-color:#276278; box-shadow:0 7px 22px rgba(0,0,0,.22); transform:translateY(-1px); }
  	      #${ROOT_ID} .card.bad { border-color:rgba(255,89,89,.52); box-shadow:inset 0 0 24px rgba(255,89,89,.035); } #${ROOT_ID} .card.warn { border-color:rgba(232,184,58,.42); } #${ROOT_ID} .card.muted { opacity:.78; }
  	      #${ROOT_ID} .card-title { color:#eaf5f8; font-size:8px; font-weight:800; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  	      #${ROOT_ID} .card-main { min-height:0; display:flex; flex-direction:column; align-items:center; justify-content:center; position:relative; }
  	      #${ROOT_ID} .card-bottom { color:var(--green); font-size:7px; display:flex; align-items:center; justify-content:center; line-height:1.15; overflow:hidden; } #${ROOT_ID} .card-bottom.bad{color:#ff6b6b} #${ROOT_ID} .card-bottom.warn{color:#e8bf49} #${ROOT_ID} .card-bottom.muted{color:#607681}
  	      #${ROOT_ID} .source-badge { position:absolute; right:5px; bottom:4px; z-index:3; padding:2px 4px; border-radius:3px; border:1px solid #20414f; background:#07131a; color:#607984; font-size:5px; font-weight:900; letter-spacing:.05em; }
  	      #${ROOT_ID} .source-badge.CAN { color:#77d8ff; border-color:#1c566d; } #${ROOT_ID} .source-badge.GPS,#${ROOT_ID} .source-badge.TRACKER { color:#8abdf0; } #${ROOT_ID} .source-badge.SNAPSHOT { color:#c8a8ff; } #${ROOT_ID} .source-badge.CONFIG { color:#efc661; } #${ROOT_ID} .source-badge.DERIVED { color:#8fdb9b; }
  	      #${ROOT_ID} .icon { width:34px; height:34px; color:#aebdc4; margin-bottom:3px; overflow:visible; filter:drop-shadow(0 3px 4px rgba(0,0,0,.28)); } #${ROOT_ID} .icon.red{color:#ff6767;filter:drop-shadow(0 0 5px rgba(255,89,89,.18))} #${ROOT_ID} .icon.amber{color:#e7ba38;filter:drop-shadow(0 0 5px rgba(232,184,58,.18))}
  	      #${ROOT_ID} .metric-value { color:#f4fbfd; font-size:18px; line-height:1; font-weight:900; letter-spacing:-.03em; } #${ROOT_ID} .metric-small { color:#f4fbfd; font-size:14px; line-height:1.08; font-weight:900; }
  	      #${ROOT_ID} .metric-unit { color:#9bb0ba; font-size:8px; font-weight:800; margin-left:2px; }
  	      #${ROOT_ID} .dial { width:108px; height:66px; overflow:visible; margin-bottom:-6px; filter:drop-shadow(0 3px 5px rgba(0,0,0,.28)); } #${ROOT_ID} .dial text { fill:#879aa3; font:600 6px Arial,sans-serif; }
  	      #${ROOT_ID} .dial-value { color:#f8fdff; font-size:16px; font-weight:900; line-height:1; margin-top:-4px; } #${ROOT_ID} .dial-unit { font-size:7px; color:#8ba1aa; }
  	      #${ROOT_ID} .fuel-scale { width:92%; display:grid; grid-template-columns:10px 1fr 10px; align-items:center; gap:4px; margin-top:7px; color:#c2d0d5; font-size:6px; }
  	      #${ROOT_ID} .fuel-bar { position:relative; height:8px; border-radius:8px; overflow:hidden; background:linear-gradient(90deg,#eb5151 0 22%,#eac43f 22% 48%,#66cc5c 48% 100%); } #${ROOT_ID} .fuel-mask { position:absolute; right:0; top:0; bottom:0; background:#15232a; opacity:.94; }
  	      #${ROOT_ID} .door-car { width:42px; height:47px; color:#a7b6bd; margin-bottom:0; filter:drop-shadow(0 3px 4px rgba(0,0,0,.28)); }
  	      #${ROOT_ID} .turn-wrap { display:flex; gap:7px; align-items:center; justify-content:center; margin-bottom:6px; } #${ROOT_ID} .turn-arrow{width:33px;height:24px;color:#647780} #${ROOT_ID} .turn-arrow.on{color:#f0b72d;filter:drop-shadow(0 0 5px rgba(240,183,45,.4));animation:fifBlink .8s steps(1,end) infinite}
  	      #${ROOT_ID} .lamp-strip { display:flex; gap:5px; overflow-x:auto; scrollbar-width:none; padding:5px 8px; border-bottom:1px solid #14313d; background:#06141c; } #${ROOT_ID} .lamp-strip::-webkit-scrollbar{display:none}
  	      #${ROOT_ID} .lamp { flex:0 0 auto; min-width:42px; height:24px; border:1px solid #17343f; border-radius:4px; display:flex; align-items:center; justify-content:center; gap:4px; padding:0 5px; color:#4d626c; font-size:6px; font-weight:900; background:#07151d; } #${ROOT_ID} .lamp.on{color:#ff7777;border-color:#70373b;background:rgba(255,89,89,.07);box-shadow:0 0 12px rgba(255,89,89,.08)} #${ROOT_ID} .lamp.ok{color:#6f9177} #${ROOT_ID} .lamp.warn{color:#e5be4d;border-color:#63542d}
  	      #${ROOT_ID} .diag-count { color:#ff6a6a; border:1px solid #643139; background:rgba(255,89,89,.08); border-radius:4px; padding:3px 7px; font-size:7px; }
  	      #${ROOT_ID} .diag-body { height:calc(100% - 37px); display:grid; grid-template-rows:minmax(0,1fr) 36px; padding:0 10px; }
  	      #${ROOT_ID} .diag-table { min-height:0; overflow:hidden; } #${ROOT_ID} .diag-head,#${ROOT_ID} .diag-row { display:grid; grid-template-columns:55px minmax(0,1fr) 49px; gap:7px; align-items:center; border-bottom:1px solid #14313d; } #${ROOT_ID} .diag-head{height:27px;color:#617985;font-size:6px} #${ROOT_ID} .diag-row{min-height:42px;color:#b8c8ce;font-size:7px;line-height:1.25} #${ROOT_ID} .diag-code{color:#ff6565;font-weight:900} #${ROOT_ID} .diag-row.warning .diag-code,#${ROOT_ID} .diag-row.config .diag-code{color:#e7ba3c} #${ROOT_ID} .diag-status{color:#ff6b6b} #${ROOT_ID} .diag-row.warning .diag-status,#${ROOT_ID} .diag-row.config .diag-status{color:#e5bd45} #${ROOT_ID} .diag-empty{color:#65808b;font-size:8px;padding:16px 2px}
  	      #${ROOT_ID} .view-dtc { appearance:none; align-self:center; width:100%; height:26px; border:1px solid #214350; border-radius:4px; background:#0c1d26; color:#b6c7ce; font-size:7px; font-weight:800; cursor:pointer; }
  	      #${ROOT_ID} .summary { padding:3px 11px 8px; } #${ROOT_ID} .sum-row { min-height:28px; display:grid; grid-template-columns:minmax(0,1fr) auto; gap:10px; align-items:center; border-bottom:1px solid #14303b; color:#6d8490; font-size:7px; } #${ROOT_ID} .sum-row:last-child{border-bottom:0} #${ROOT_ID} .sum-row strong{color:#dce7eb;font-size:7px;text-align:right} #${ROOT_ID} .sum-row strong.good{color:#6ad16c} #${ROOT_ID} .sum-row strong.warn{color:#e9ba3e} #${ROOT_ID} .sum-row strong.bad{color:#ff6262}
  	      #${ROOT_ID} .source-wave { padding:0 10px 8px; } #${ROOT_ID} .source-wave svg{width:100%;height:42px} #${ROOT_ID} .source-wave line{stroke:#12303b;stroke-width:1} #${ROOT_ID} .source-wave path{fill:none;stroke:#267b75;stroke-width:1.4}
  	      #${ROOT_ID} .trend-panel { overflow:hidden; background:linear-gradient(180deg,rgba(8,24,33,.98),rgba(5,16,23,.98)); } #${ROOT_ID} .trend-panel .panel-head{height:36px;min-height:36px} #${ROOT_ID} .trend-controls { display:flex; align-items:center; gap:4px; } #${ROOT_ID} .trend-mode { appearance:none; border:1px solid #1d3c49; background:#081821; color:#718893; border-radius:4px; padding:4px 7px; font-size:6px; font-weight:900; cursor:pointer; } #${ROOT_ID} .trend-mode.active{color:#66c9ee;border-color:#22617a;background:#0b2431;box-shadow:0 0 12px rgba(57,182,228,.08)}
  	      #${ROOT_ID} .trend-grid { height:calc(100% - 36px); display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:0; } #${ROOT_ID} .trend { min-width:0; border-right:1px solid #14313c; padding:8px 9px 5px; background:radial-gradient(circle at 50% 100%,rgba(42,108,132,.055),transparent 60%); } #${ROOT_ID} .trend:last-child{border-right:0} #${ROOT_ID} .trend-head{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:start;gap:7px;color:#78909a;font-size:7px} #${ROOT_ID} .trend-head>span{font-weight:800;letter-spacing:.02em} #${ROOT_ID} .trend-head strong{color:#f1f9fb;font-size:10px;letter-spacing:-.02em} #${ROOT_ID} .trend-stats{grid-column:1/-1;display:flex;gap:9px;margin-top:2px;color:#4f6874;font-size:5.5px;font-weight:800} #${ROOT_ID} .trend-stats b{color:#718b96;font-weight:900} #${ROOT_ID} .trend-svg{width:100%;height:126px;margin-top:1px;overflow:visible} #${ROOT_ID} .gridline{stroke:#17343f;stroke-width:.75;stroke-dasharray:2 3} #${ROOT_ID} .vgrid{stroke:#102b35;stroke-width:.65} #${ROOT_ID} .axis-text{fill:#55707c;font:5.4px Arial,sans-serif} #${ROOT_ID} .line{fill:none;stroke-width:2.05;stroke-linecap:round;stroke-linejoin:round} #${ROOT_ID} .trend-threshold{stroke:#e0a93c;stroke-width:.85;stroke-dasharray:4 3;opacity:.72} #${ROOT_ID} .threshold-text{fill:#c89a38;font:5.2px Arial,sans-serif} #${ROOT_ID} .trend-dot{stroke:#07151d;stroke-width:2} #${ROOT_ID} .rpm-line{stroke:#70d65d} #${ROOT_ID} .temp-line{stroke:#ff5e5e} #${ROOT_ID} .speed-line{stroke:#4db7ee} #${ROOT_ID} .fuel-line{stroke:#e2c13a}

  	      #${ROOT_ID} .trend-limit-chip { display:inline-flex; align-items:center; gap:4px; margin-left:5px; padding:2px 5px; border:1px solid #34505a; border-radius:999px; color:#78919b; background:#07151d; font-size:5.5px; font-weight:900; letter-spacing:.03em; white-space:nowrap; }
  	      #${ROOT_ID} .trend-limit-chip.over { color:#ff7777; border-color:#6e3439; background:rgba(255,89,89,.07); box-shadow:0 0 10px rgba(255,89,89,.08); }
  	      #${ROOT_ID} .trend-over-cap { stroke:#ff6161; stroke-width:2.4; }
  	      #${ROOT_ID} .trend-over-text { fill:#ff7474; font:700 5.8px Arial,sans-serif; letter-spacing:.02em; }
  	      #${ROOT_ID} .footer { display:flex; align-items:center; justify-content:space-between; gap:20px; border-top:1px solid #102832; color:#49616c; font-size:6px; }
  	      #${ROOT_ID} .view-scroll { height:100%; overflow:auto; padding-right:2px; scrollbar-color:#173945 transparent; } #${ROOT_ID} .view-scroll::-webkit-scrollbar{width:7px} #${ROOT_ID} .view-scroll::-webkit-scrollbar-thumb{background:#173945;border-radius:8px}
  	      #${ROOT_ID} .view-head { display:flex; align-items:end; justify-content:space-between; gap:14px; margin:2px 2px 10px; } #${ROOT_ID} .view-title{font-size:18px;font-weight:900;color:#f2f9fb} #${ROOT_ID} .view-sub{font-size:8px;color:#6b828d;margin-top:3px}
  	      #${ROOT_ID} .kpi-grid { display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:8px; margin-bottom:10px; } #${ROOT_ID} .kpi { border:1px solid var(--line); border-radius:7px; background:#081820; padding:12px; min-height:80px; } #${ROOT_ID} .kpi span{display:block;color:#637b86;font-size:7px;text-transform:uppercase;font-weight:900;letter-spacing:.04em} #${ROOT_ID} .kpi strong{display:block;color:#f2fafc;font-size:20px;margin-top:7px;letter-spacing:-.03em} #${ROOT_ID} .kpi small{display:block;color:#59707b;font-size:7px;margin-top:4px}
  	      #${ROOT_ID} .data-panel { border:1px solid var(--line); border-radius:8px; background:#071720; overflow:hidden; margin-bottom:10px; } #${ROOT_ID} .data-panel-head{min-height:36px;display:flex;align-items:center;justify-content:space-between;padding:0 12px;border-bottom:1px solid #15323d;font-size:9px;font-weight:900} #${ROOT_ID} .data-table{width:100%;border-collapse:collapse;font-size:7px} #${ROOT_ID} .data-table th{color:#66808b;text-align:left;padding:8px 10px;border-bottom:1px solid #173440;font-weight:800} #${ROOT_ID} .data-table td{color:#b7c7cd;padding:8px 10px;border-bottom:1px solid #112c37} #${ROOT_ID} .data-table tr:last-child td{border-bottom:0} #${ROOT_ID} .data-table td.r{text-align:right} #${ROOT_ID} .data-table .good{color:#63cd69} #${ROOT_ID} .data-table .warn{color:#e7bb45} #${ROOT_ID} .data-table .bad{color:#ff6767}
  	      #${ROOT_ID} .event-list { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:7px; padding:8px; } #${ROOT_ID} .event-rule{border:1px solid #173744;border-radius:6px;background:#081820;padding:9px 10px;display:grid;grid-template-columns:minmax(0,1fr) auto;gap:8px} #${ROOT_ID} .event-rule b{font-size:8px;color:#dce9ed} #${ROOT_ID} .event-rule small{display:block;color:#5f7782;font-size:6px;margin-top:3px} #${ROOT_ID} .event-pill{align-self:start;border:1px solid #244754;border-radius:999px;padding:3px 6px;color:#718b95;font-size:6px;font-weight:900} #${ROOT_ID} .event-pill.enabled{color:#73d37d;border-color:#28583c} #${ROOT_ID} .event-pill.active{color:#ff7878;border-color:#6c353a;background:rgba(255,89,89,.06)}
  	      #${ROOT_ID} .conflict { border:1px solid #604f25; background:rgba(232,184,58,.045); border-radius:7px; padding:10px 12px; margin-bottom:8px; display:grid;grid-template-columns:24px minmax(0,1fr);gap:8px; } #${ROOT_ID} .conflict strong{font-size:8px;color:#eac34f} #${ROOT_ID} .conflict p{margin:3px 0 0;color:#8797a0;font-size:7px;line-height:1.4}
  	      #${ROOT_ID} .help-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:9px} #${ROOT_ID} .help-card{border:1px solid var(--line);border-radius:7px;background:#071720;padding:13px} #${ROOT_ID} .help-card h3{margin:0;color:#e8f4f7;font-size:10px} #${ROOT_ID} .help-card p{margin:6px 0 0;color:#708690;font-size:8px;line-height:1.55}
  	      #${ROOT_ID} .tiny-source { display:inline-flex;padding:2px 5px;border:1px solid #24434e;border-radius:4px;margin:0 3px 3px 0;color:#77909b;font-size:6px;font-weight:900; }
  	      @keyframes fifBlink{0%,49%{opacity:1}50%,100%{opacity:.2}}
  	      @media (max-width:1280px){#${ROOT_ID} .workspace{grid-template-columns:minmax(0,1fr) 280px}#${ROOT_ID} .topbar{grid-template-columns:minmax(340px,1.45fr) repeat(2,minmax(100px,.6fr)) auto 42px}#${ROOT_ID} .hide-1280{display:none}}
  	      @media (max-width:1040px){#${ROOT_ID}{overflow:auto}#${ROOT_ID} .dash-layout{grid-template-columns:78px minmax(980px,1fr);min-height:780px}#${ROOT_ID} .main{min-width:980px;min-height:780px;height:auto}}
  	      #${DTC_MODAL_ID} { position:fixed; inset:0; z-index:2147483600; display:grid; place-items:center; padding:24px; background:rgba(0,5,8,.82); backdrop-filter:blur(5px); }
  	      #${DTC_MODAL_ID} .dtc-modal-card { width:min(900px,100%); max-height:min(760px,90vh); display:grid; grid-template-rows:48px minmax(0,1fr); border:1px solid #27505f; border-radius:9px; background:#071720; box-shadow:0 24px 80px rgba(0,0,0,.62); overflow:hidden; }
  	      #${DTC_MODAL_ID} .dtc-modal-head { display:flex; align-items:center; justify-content:space-between; padding:0 14px; border-bottom:1px solid #183845; color:#eef7fa; font-size:11px; font-weight:900; }
  	      #${DTC_MODAL_ID} .dtc-close { appearance:none; width:31px; height:31px; border:1px solid #28505f; border-radius:5px; background:#0c2029; color:#aec0c7; cursor:pointer; }
  	      #${DTC_MODAL_ID} .dtc-all { overflow:auto; padding:7px 14px 15px; }
  	      #${DTC_MODAL_ID} .dtc-all-row { display:grid; grid-template-columns:90px minmax(0,1fr) 90px; gap:10px; padding:11px 4px; border-bottom:1px solid #163440; font-size:8px; } #${DTC_MODAL_ID} .dtc-all-row .code{color:#ff6a6a;font-weight:900} #${DTC_MODAL_ID} .dtc-all-row.warning .code,#${DTC_MODAL_ID} .dtc-all-row.config .code{color:#e4bc45} #${DTC_MODAL_ID} .evidence{grid-column:2/4;color:#667f89;font-size:7px;margin-top:-5px}

  	      /* ============================================================
  	         FIF CAN Dashboard v4 — APEX visual system
  	         ============================================================ */
  	      #${ROOT_ID} {
  	        --apex-cyan:#36c7ff;
  	        --apex-blue:#348cff;
  	        --apex-green:#62e572;
  	        --apex-amber:#ffc247;
  	        --apex-red:#ff5666;
  	        --apex-ink:#02070c;
  	        --apex-glass:rgba(7,21,30,.82);
  	        --apex-line:rgba(90,185,220,.18);
  	        background:
  	          radial-gradient(circle at 20% -12%,rgba(31,138,194,.19),transparent 31%),
  	          radial-gradient(circle at 88% 10%,rgba(12,95,126,.14),transparent 25%),
  	          linear-gradient(rgba(50,145,180,.025) 1px,transparent 1px),
  	          linear-gradient(90deg,rgba(50,145,180,.025) 1px,transparent 1px),
  	          linear-gradient(180deg,#06131c 0%,#02090e 72%,#010508 100%);
  	        background-size:auto,auto,38px 38px,38px 38px,auto;
  	      }
  	      #${ROOT_ID}:before {
  	        content:""; position:absolute; inset:0; pointer-events:none; z-index:0;
  	        background:
  	          linear-gradient(90deg,transparent 0%,rgba(57,182,228,.025) 50%,transparent 100%);
  	        mix-blend-mode:screen;
  	      }
  	      #${ROOT_ID} .dash-layout { position:relative; z-index:1; }
  	      #${ROOT_ID} .side {
  	        background:
  	          radial-gradient(circle at 50% 0,rgba(42,169,214,.08),transparent 28%),
  	          linear-gradient(180deg,rgba(5,18,27,.98),rgba(2,8,13,.99));
  	        border-right:1px solid rgba(79,170,204,.18);
  	        box-shadow:12px 0 35px rgba(0,0,0,.18);
  	      }
  	      #${ROOT_ID} .side-brand {
  	        position:relative;
  	        height:76px;
  	        padding:7px 5px;
  	        border-bottom:1px solid rgba(73,177,216,.18);
  	        background:linear-gradient(180deg,rgba(20,60,78,.16),transparent);
  	      }
  	      #${ROOT_ID} .side-brand:after {
  	        content:""; position:absolute; left:18px; right:18px; bottom:-1px; height:1px;
  	        background:linear-gradient(90deg,transparent,var(--apex-cyan),transparent);
  	        opacity:.55;
  	      }
  	      #${ROOT_ID} .nav-btn {
  	        position:relative; border-radius:10px; overflow:hidden;
  	        transition:background .18s ease,color .18s ease,border-color .18s ease,transform .18s ease,box-shadow .18s ease;
  	      }
  	      #${ROOT_ID} .nav-btn:hover { transform:translateX(1px); background:rgba(18,57,75,.34); }
  	      #${ROOT_ID} .nav-btn.active {
  	        color:#8bddff;
  	        border-color:rgba(62,180,227,.34);
  	        background:
  	          linear-gradient(90deg,rgba(43,173,225,.17),rgba(8,36,50,.58));
  	        box-shadow:
  	          inset 2px 0 0 var(--apex-cyan),
  	          inset 0 1px 0 rgba(255,255,255,.035),
  	          0 0 18px rgba(45,177,225,.08);
  	      }
  	      #${ROOT_ID} .nav-btn.active:after {
  	        content:""; position:absolute; right:8px; top:10px; width:3px; height:3px; border-radius:50%;
  	        background:var(--apex-cyan); box-shadow:0 0 9px var(--apex-cyan);
  	      }

  	      #${ROOT_ID} .topbar {
  	        position:relative;
  	        border-bottom:1px solid rgba(75,175,209,.20);
  	        background:
  	          linear-gradient(90deg,rgba(14,40,53,.14),transparent 38%,rgba(16,49,64,.08));
  	      }
  	      #${ROOT_ID} .topbar:after {
  	        content:""; position:absolute; left:0; right:0; bottom:-1px; height:1px;
  	        background:linear-gradient(90deg,var(--apex-cyan),rgba(54,199,255,.12) 28%,transparent 65%);
  	        opacity:.55;
  	      }
  	      #${ROOT_ID} .vehicle-art {
  	        filter:
  	          drop-shadow(0 10px 12px rgba(0,0,0,.42))
  	          drop-shadow(0 0 11px rgba(85,194,231,.11));
  	      }
  	      #${ROOT_ID} .brand-mini { color:#73b9d1; letter-spacing:.17em; }
  	      #${ROOT_ID} .title { text-shadow:0 0 20px rgba(105,210,247,.08); }
  	      #${ROOT_ID} .head-val { font-variant-numeric:tabular-nums; color:#e5f3f7; }
  	      #${ROOT_ID} .top-live {
  	        padding:6px 8px; border:1px solid rgba(62,153,186,.16); border-radius:8px;
  	        background:rgba(4,15,22,.42);
  	      }

  	      #${ROOT_ID} .panel {
  	        position:relative;
  	        border:1px solid rgba(72,164,198,.19);
  	        border-radius:11px;
  	        background:
  	          radial-gradient(circle at 18% 0,rgba(54,199,255,.035),transparent 35%),
  	          linear-gradient(180deg,rgba(8,25,35,.94),rgba(4,14,21,.97));
  	        box-shadow:
  	          inset 0 1px 0 rgba(255,255,255,.025),
  	          inset 0 -1px 0 rgba(0,0,0,.28),
  	          0 16px 42px rgba(0,0,0,.16);
  	      }
  	      #${ROOT_ID} .panel:before {
  	        content:""; position:absolute; left:14px; right:14px; top:0; height:1px; pointer-events:none;
  	        background:linear-gradient(90deg,transparent,rgba(69,195,239,.48),transparent);
  	        opacity:.42;
  	      }
  	      #${ROOT_ID} .panel-head {
  	        position:relative;
  	        min-height:39px;
  	        padding:0 13px;
  	        background:linear-gradient(180deg,rgba(22,52,66,.15),rgba(3,12,18,.03));
  	        border-bottom-color:rgba(70,157,190,.16);
  	        letter-spacing:.012em;
  	      }
  	      #${ROOT_ID} .panel-head:after {
  	        content:""; position:absolute; left:12px; bottom:-1px; width:70px; height:1px;
  	        background:linear-gradient(90deg,var(--apex-cyan),transparent);
  	        opacity:.36;
  	      }

  	      #${ROOT_ID} .card {
  	        border:1px solid rgba(72,156,187,.22);
  	        border-radius:9px;
  	        background:
  	          radial-gradient(circle at 50% 35%,rgba(71,177,216,.035),transparent 43%),
  	          linear-gradient(155deg,rgba(9,28,39,.96),rgba(4,15,22,.98));
  	        box-shadow:
  	          inset 0 1px 0 rgba(255,255,255,.025),
  	          inset 0 -14px 34px rgba(0,0,0,.06);
  	        transition:transform .16s ease,border-color .16s ease,box-shadow .16s ease,background .16s ease;
  	      }
  	      #${ROOT_ID} .card:before {
  	        content:""; position:absolute; left:10px; right:10px; top:0; height:1px;
  	        background:linear-gradient(90deg,transparent,rgba(84,196,236,.28),transparent);
  	      }
  	      #${ROOT_ID} .card:after {
  	        content:""; position:absolute; width:8px; height:8px; right:4px; top:4px;
  	        border-top:1px solid rgba(90,196,232,.20); border-right:1px solid rgba(90,196,232,.20);
  	        pointer-events:none;
  	      }
  	      #${ROOT_ID} .card:hover {
  	        transform:translateY(-2px);
  	        border-color:rgba(74,192,235,.45);
  	        background:
  	          radial-gradient(circle at 50% 35%,rgba(54,199,255,.07),transparent 48%),
  	          linear-gradient(155deg,#0a2230,#061720);
  	        box-shadow:0 12px 28px rgba(0,0,0,.24),0 0 22px rgba(50,167,210,.05);
  	      }
  	      #${ROOT_ID} .card.bad {
  	        border-color:rgba(255,82,97,.56);
  	        box-shadow:inset 0 2px 0 rgba(255,82,97,.38),inset 0 0 32px rgba(255,70,84,.035);
  	      }
  	      #${ROOT_ID} .card.warn {
  	        border-color:rgba(255,194,71,.48);
  	        box-shadow:inset 0 2px 0 rgba(255,194,71,.30),inset 0 0 30px rgba(255,194,71,.025);
  	      }
  	      #${ROOT_ID} .card-title {
  	        color:#dcecf2; font-size:8px; letter-spacing:.025em;
  	      }
  	      #${ROOT_ID} .metric-value,#${ROOT_ID} .metric-small,#${ROOT_ID} .dial-value {
  	        font-variant-numeric:tabular-nums;
  	        text-shadow:0 2px 10px rgba(0,0,0,.38);
  	      }
  	      #${ROOT_ID} .metric-value { font-size:19px; }
  	      #${ROOT_ID} .card-bottom { letter-spacing:.01em; }

  	      #${ROOT_ID} .source-badge {
  	        right:6px; bottom:5px; border-radius:999px; padding:2px 5px;
  	        background:rgba(2,10,15,.72);
  	        box-shadow:inset 0 1px 0 rgba(255,255,255,.025);
  	      }

  	      #${ROOT_ID} .icon {
  	        width:38px; height:38px; margin-bottom:2px;
  	        filter:
  	          drop-shadow(0 5px 7px rgba(0,0,0,.34))
  	          drop-shadow(0 0 8px rgba(112,206,235,.08));
  	      }
  	      #${ROOT_ID} .icon .ico-shell { fill:rgba(89,177,209,.045); stroke:rgba(111,196,226,.20); }
  	      #${ROOT_ID} .icon .ico-fill { fill:currentColor; fill-opacity:.09; stroke:none; }
  	      #${ROOT_ID} .icon .ico-hot { fill:currentColor; fill-opacity:.26; stroke:none; }

  	      #${ROOT_ID} .dial {
  	        width:114px; height:72px; margin-bottom:-7px;
  	        filter:drop-shadow(0 7px 9px rgba(0,0,0,.34));
  	      }
  	      #${ROOT_ID} .dial .gauge-ring { filter:drop-shadow(0 0 4px rgba(63,191,234,.10)); }
  	      #${ROOT_ID} .dial .needle { filter:drop-shadow(0 0 4px rgba(239,249,252,.34)); }
  	      #${ROOT_ID} .dial .hub-outer { fill:#0d222c; stroke:#526f7b; }
  	      #${ROOT_ID} .dial .hub-inner { fill:#dfeff4; }
  	      #${ROOT_ID} .dial-value { font-size:17px; }
  	      #${ROOT_ID} .door-car { width:46px; height:51px; }

  	      #${ROOT_ID} .lamp-strip {
  	        gap:5px; padding:6px 8px;
  	        background:
  	          linear-gradient(90deg,rgba(7,23,32,.92),rgba(3,13,19,.92));
  	      }
  	      #${ROOT_ID} .lamp {
  	        position:relative; min-width:44px; height:25px; border-radius:6px;
  	        border-color:rgba(72,147,173,.16);
  	        background:linear-gradient(180deg,rgba(13,32,42,.92),rgba(5,17,23,.92));
  	      }
  	      #${ROOT_ID} .lamp:before {
  	        content:""; width:4px; height:4px; border-radius:50%; background:#33505d;
  	        box-shadow:0 0 5px rgba(60,115,137,.1);
  	      }
  	      #${ROOT_ID} .lamp.ok:before { background:#5ed66c; box-shadow:0 0 8px rgba(94,214,108,.35); }
  	      #${ROOT_ID} .lamp.warn:before { background:#ffc247; box-shadow:0 0 8px rgba(255,194,71,.36); }
  	      #${ROOT_ID} .lamp.on:before { background:#ff5b68; box-shadow:0 0 9px rgba(255,91,104,.45); }

  	      #${ROOT_ID} .diag-count {
  	        border-radius:999px; padding:4px 8px; letter-spacing:.025em;
  	        box-shadow:inset 0 1px 0 rgba(255,255,255,.035),0 0 14px rgba(255,78,90,.06);
  	      }
  	      #${ROOT_ID} .diag-row {
  	        position:relative; padding-left:8px;
  	      }
  	      #${ROOT_ID} .diag-row:before {
  	        content:""; position:absolute; left:0; top:7px; bottom:7px; width:2px; border-radius:3px;
  	        background:#ff5c68; box-shadow:0 0 8px rgba(255,92,104,.24);
  	      }
  	      #${ROOT_ID} .diag-row.warning:before,#${ROOT_ID} .diag-row.config:before { background:#f4bd41; box-shadow:0 0 8px rgba(244,189,65,.18); }

  	      #${ROOT_ID} .sum-row { min-height:29px; }
  	      #${ROOT_ID} .sum-row strong { font-variant-numeric:tabular-nums; }
  	      #${ROOT_ID} .source-wave {
  	        position:relative; margin:0 10px 9px; padding:7px 8px 5px;
  	        border:1px solid rgba(67,150,179,.14); border-radius:7px;
  	        background:linear-gradient(180deg,rgba(8,28,37,.55),rgba(2,11,16,.30));
  	      }
  	      #${ROOT_ID} .source-wave:before {
  	        content:"SIGNAL TELEMETRY"; position:absolute; top:4px; left:8px;
  	        color:#496772; font-size:5px; font-weight:900; letter-spacing:.08em;
  	      }
  	      #${ROOT_ID} .source-wave svg { margin-top:6px; }

  	      #${ROOT_ID} .trend-panel {
  	        background:
  	          radial-gradient(circle at 40% 0,rgba(47,169,214,.035),transparent 40%),
  	          linear-gradient(180deg,rgba(7,23,32,.98),rgba(3,13,19,.98));
  	      }
  	      #${ROOT_ID} .trend-grid { gap:0; }
  	      #${ROOT_ID} .trend {
  	        position:relative;
  	        padding:8px 9px 4px;
  	        background:
  	          radial-gradient(circle at 50% 110%,rgba(55,164,205,.045),transparent 55%);
  	        transition:background .18s ease;
  	      }
  	      #${ROOT_ID} .trend:hover {
  	        background:
  	          radial-gradient(circle at 50% 105%,rgba(55,176,220,.085),transparent 62%);
  	      }
  	      #${ROOT_ID} .trend:before {
  	        content:""; position:absolute; left:8px; right:8px; top:0; height:1px;
  	        background:linear-gradient(90deg,transparent,rgba(71,183,222,.20),transparent);
  	      }
  	      #${ROOT_ID} .trend-head { min-height:32px; align-items:flex-start; }
  	      #${ROOT_ID} .trend-head > span:first-child { color:#8ca3ad; font-weight:800; letter-spacing:.015em; }
  	      #${ROOT_ID} .trend-head > strong {
  	        padding:3px 6px; border:1px solid rgba(78,162,192,.16); border-radius:5px;
  	        background:rgba(3,13,18,.54);
  	        font-size:9px; font-variant-numeric:tabular-nums;
  	      }
  	      #${ROOT_ID} .trend-svg { height:108px; }
  	      #${ROOT_ID} .gridline { stroke:rgba(70,148,177,.16); stroke-dasharray:2 3; }
  	      #${ROOT_ID} .vgrid { stroke:rgba(63,132,157,.08); }
  	      #${ROOT_ID} .axis-text { fill:#4f6d79; font:5.6px Arial,sans-serif; }
  	      #${ROOT_ID} .trend-threshold { stroke:#f4bd47; stroke-width:1; stroke-dasharray:4 3; }
  	      #${ROOT_ID} .threshold-text { fill:#e6b945; font:700 5.4px Arial,sans-serif; }
  	      #${ROOT_ID} .line { stroke-width:2.05; }
  	      #${ROOT_ID} .trend-dot { filter:drop-shadow(0 0 4px currentColor); }
  	      #${ROOT_ID} .trend-limit-chip {
  	        background:rgba(6,18,24,.72); border-color:rgba(81,153,179,.18);
  	      }
  	      #${ROOT_ID} .trend-stats {
  	        margin-top:2px; opacity:.92;
  	      }
  	      #${ROOT_ID} .trend-stats span {
  	        border-radius:4px; padding:2px 4px;
  	        background:rgba(3,12,17,.34);
  	      }
  	      #${ROOT_ID} .trend-current-rail {
  	        position:absolute; top:41px; bottom:18px; right:10px; width:1px;
  	        background:linear-gradient(180deg,transparent,rgba(124,217,247,.35),transparent);
  	        pointer-events:none;
  	      }
  	      #${ROOT_ID} .trend-live-dot {
  	        position:absolute; right:7px; top:48px; width:6px; height:6px; border-radius:50%;
  	        box-shadow:0 0 10px currentColor; animation:fifPulse 1.5s ease-in-out infinite;
  	      }
  	      #${ROOT_ID} .trend-zone-danger { fill:rgba(255,82,97,.045); }
  	      #${ROOT_ID} .trend-zone-warn { fill:rgba(255,194,71,.035); }
  	      #${ROOT_ID} .sample-dot { opacity:.42; }

  	      #${ROOT_ID} .footer {
  	        border-top-color:rgba(68,150,181,.12);
  	        background:linear-gradient(90deg,rgba(8,25,34,.22),transparent);
  	      }
  	      @keyframes fifPulse { 0%,100%{opacity:.42;transform:scale(.82)} 50%{opacity:1;transform:scale(1.18)} }

  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function iconSvg(name, cls) {
  	    const c = cls ? " " + cls : "";
  	    const wrap = function (content) {
  	      return '<svg class="icon' + c + '" viewBox="0 0 64 64" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.15" stroke-linecap="round" stroke-linejoin="round">'
  	        +'<circle class="ico-shell" cx="32" cy="32" r="28"/>'
  	        +'<circle cx="32" cy="32" r="23" fill="none" stroke="currentColor" stroke-opacity=".055"/>'
  	        +content+'</svg>';
  	    };
  	    switch (name) {
  	      case "fuel": return wrap('<rect class="ico-fill" x="15" y="11" width="25" height="43" rx="3"/><rect x="15" y="11" width="25" height="43" rx="3"/><rect class="ico-hot" x="20" y="17" width="15" height="11" rx="1.5"/><rect x="20" y="17" width="15" height="11" rx="1.5"/><path d="M40 19h5l7 8v20c0 5-2 7-5 7s-5-2-5-7V35"/><path d="M45 19v9h7"/><path d="M20 46h15"/>');
  	      case "road": return wrap('<path class="ico-fill" d="M20 54 27 10h10l7 44Z"/><path d="M20 54 27 10M44 54 37 10"/><path d="M32 15v7m0 7v7m0 7v7" stroke-width="2.8"/><path d="M18 55h28" stroke-opacity=".55"/>');
  	      case "oil": return wrap('<path class="ico-fill" d="M12 31h25l8 8v11H19l-7-7Z"/><path d="M12 31h25l8 8v11H19l-7-7Z"/><path d="M20 31v-7h14l8 7"/><path d="M43 21 51 29"/><path d="M49 43c7-8 10-6 10-2a7 7 0 0 1-7 7"/><circle class="ico-hot" cx="52" cy="48" r="2.5"/>');
  	      case "oilLevel": return wrap('<path class="ico-fill" d="M11 31h26l8 8v11H18l-7-7Z"/><path d="M11 31h26l8 8v11H18l-7-7Z"/><path d="M19 31v-7h15l8 7"/><path d="M48 17v13M44 21h8"/><path d="M18 44h20" stroke-width="3"/>');
  	      case "thermo": return wrap('<path class="ico-fill" d="M27 13v23a11 11 0 1 0 10 0V13a5 5 0 0 0-10 0Z"/><path d="M27 13v23a11 11 0 1 0 10 0V13a5 5 0 0 0-10 0Z"/><path d="M32 20v22" stroke-width="4"/><circle class="ico-hot" cx="32" cy="47" r="5"/><path d="M15 49c4-3 8 3 12 0s8 3 12 0 8 3 12 0"/>');
  	      case "pedal": return wrap('<path class="ico-fill" d="M17 41 40 20l8 7-23 21Z"/><path d="M17 41 40 20l8 7-23 21Z"/><path d="m21 40 18-15m-13 15 16-14m-11 10 9-8M18 47l8 3"/>');
  	      case "vin": return wrap('<rect class="ico-fill" x="11" y="14" width="42" height="36" rx="4"/><rect x="11" y="14" width="42" height="36" rx="4"/><circle class="ico-hot" cx="24" cy="28" r="5.5"/><path d="M16 42c2-7 14-7 16 0M36 23h11m-11 8h11m-11 8h8"/>');
  	      case "light": return wrap('<path class="ico-fill" d="M13 23h20l10 9-10 9H13Z"/><path d="M13 23h20l10 9-10 9H13Z"/><path d="M18 27h13l6 5-6 5H18"/><path d="M47 21h10m-10 8h12m-12 8h12m-12 8h10"/>');
  	      case "cng": return wrap('<rect class="ico-fill" x="20" y="14" width="26" height="40" rx="5"/><rect x="20" y="14" width="26" height="40" rx="5"/><path d="M27 9h12v5H27zM46 26h5v14h-5"/><path d="M26 38h14"/><text x="33" y="31" text-anchor="middle" fill="currentColor" stroke="none" font-size="8" font-family="Arial" font-weight="800">CNG</text>');
  	      case "adblue": return wrap('<path class="ico-fill" d="M32 10c9 12 16 20 16 29a16 16 0 0 1-32 0c0-9 7-17 16-29Z"/><path d="M32 10c9 12 16 20 16 29a16 16 0 0 1-32 0c0-9 7-17 16-29Z"/><path d="M22 42c5 4 15 4 20 0M24 36c4 3 12 3 16 0"/>');
  	      case "heat": return wrap('<path d="M14 50h36" stroke-width="3"/><path d="M20 43c-7-8 6-11 0-21m12 21c-7-8 6-11 0-21m12 21c-7-8 6-11 0-21" stroke-width="2.8"/><path class="ico-fill" d="M18 47h28v7H18z"/>');
  	      case "seatbelt": return wrap('<circle class="ico-fill" cx="24" cy="14" r="6"/><circle cx="24" cy="14" r="6"/><path d="M24 20v15L14 53m10-18 14 12M19 27h18l9 26M16 44h26"/><path d="M15 17 45 51" stroke-width="4"/>');
  	      case "engine": return wrap('<path class="ico-fill" d="M12 27h8l6-7h18l7 8v19H19l-7-7Z"/><path d="M12 27h8l6-7h18l7 8v19H19l-7-7Z"/><path d="M51 32h6v10h-6M27 20v-7m12 7v-7M20 31h-8"/><path d="M28 34h14" stroke-width="3"/>');
  	      case "tire": return wrap('<path class="ico-fill" d="M20 12c-8 7-11 14-11 21s3 14 11 21m24-42c8 7 11 14 11 21s-3 14-11 21"/><path d="M20 12c-8 7-11 14-11 21s3 14 11 21m24-42c8 7 11 14 11 21s-3 14-11 21" stroke-width="3"/><path d="M26 17h12m-14 9h16m-16 9h16m-14 9h12"/><path d="M32 16v19" stroke-width="3"/><circle class="ico-hot" cx="32" cy="46" r="2.8"/>');
  	      case "battery": return wrap('<rect class="ico-fill" x="11" y="20" width="42" height="31" rx="4"/><rect x="11" y="20" width="42" height="31" rx="4"/><path d="M21 15v5m22-5v5M18 35h12m-6-6v12m13-6h10" stroke-width="3"/>');
  	      default: return wrap('<circle class="ico-fill" cx="32" cy="32" r="18"/><circle cx="32" cy="32" r="18"/>');
  	    }
  	  }

  	  function sideIcon(name) {
  	    const paths = {
  	      dashboard:'<rect x="7" y="7" width="12" height="12" rx="2"/><rect x="25" y="7" width="12" height="12" rx="2"/><rect x="7" y="25" width="12" height="12" rx="2"/><rect x="25" y="25" width="12" height="12" rx="2"/>',
  	      map:'<circle cx="24" cy="21" r="6"/><path d="M24 39s11-11 11-19a11 11 0 1 0-22 0c0 8 11 19 11 19Z"/>',
  	      report:'<rect x="10" y="7" width="28" height="34" rx="2"/><path d="M16 16h16m-16 7h16m-16 7h11"/>',
  	      alert:'<path d="M24 7 42 39H6z"/><path d="M24 18v9m0 6v.5"/>',
  	      wrench:'<path d="M31 9a9 9 0 0 0-10 12L8 34l6 6 13-13A9 9 0 0 0 39 17l-7 7-7-7z"/>',
  	      device:'<rect x="10" y="11" width="28" height="24" rx="3"/><path d="M16 19h16m-16 8h10M19 39h10"/>',
  	      settings:'<circle cx="24" cy="24" r="6"/><path d="M24 7v5m0 24v5M7 24h5m24 0h5M12 12l4 4m16 16 4 4M36 12l-4 4M16 32l-4 4"/>',
  	      help:'<circle cx="24" cy="24" r="17"/><path d="M18 19a6 6 0 1 1 9 5c-2 1-3 2-3 5m0 6h.1"/>',
  	      close:'<path d="M13 13l22 22M35 13 13 35"/>'
  	    };
  	    return '<svg class="nav-ico" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round">'+(paths[name]||paths.dashboard)+'</svg>';
  	  }

  	  function vehicleSvg() {
  	    return `<svg class="vehicle-art" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 508" preserveAspectRatio="xMidYMid meet" role="img" aria-label="2018 Toyota Land Cruiser Prado"><path fill="rgb(244,245,247)" fill-rule="evenodd" d="M379,440 381,441 381,444 388,455 389,452 388,453 383,446 382,441ZM401,430 402,431 406,426 409,426 411,428 412,433 412,430 414,426 413,428 410,426 406,426 404,428 403,427ZM376,419 376,423 375,424 374,423 374,421 376,429 377,426 379,425 377,424ZM295,394 303,394 311,396 327,396 326,395ZM85,393 85,406 86,409 86,393ZM413,391 416,392 417,398 422,397 417,396 417,394 419,392 420,393 417,388 418,390 414,392ZM62,380 60,381 60,390 63,386 61,387 60,386 62,384ZM877,380 884,376 887,372 884,374 882,372 878,372 877,370 876,372 877,373ZM515,367 515,368 524,372 544,378 547,380 550,380 523,371ZM888,360 886,367 887,370 888,370 888,365 887,364 889,363ZM89,354 85,357 88,360 89,364 92,363 91,359 90,361 88,360 88,358 90,356ZM872,356 868,349 844,358 613,363 597,353 597,363 575,358 552,379 554,388 506,375 555,388 587,363 643,365 644,371 646,365ZM627,362 628,361 632,362 631,363ZM561,325 557,325 543,339 545,341 547,340ZM206,324 319,337 314,332 301,327 208,316ZM167,318 169,320 199,323 200,324 204,324 205,316 202,315 193,315 192,314 183,314 182,313 175,313 170,315ZM848,266 848,273 847,274 846,289 845,290 846,290 847,286ZM451,266 448,270 455,281 459,290 456,283 456,280 450,269ZM608,266 597,265 596,264 589,270 590,269 592,270 590,272 584,271 584,272 592,271 597,265ZM861,262 855,267 849,296 658,299 616,268 642,292 648,314 650,306 855,303 857,311ZM880,258 883,263 883,267 887,270 889,275 887,277 867,285 865,287 864,281 863,287 865,304 865,297 872,291 875,290 894,273ZM654,246 653,251 654,255 655,254 656,255 655,261 657,268 658,282 659,285 660,285ZM459,256 467,247 475,261 468,267 487,273 491,301 496,289 502,294 506,275 611,288 619,294 579,287 535,289 620,301 619,291 492,272 470,245ZM695,241 694,244 696,250 698,272 699,273 699,285 700,285 699,266 698,265 698,258 697,257ZM783,240 786,252 787,274 788,275 788,284 789,284 788,283 787,254 786,253 785,242ZM734,252 734,257 737,260 735,256 735,250 737,247 742,251 749,252 750,258 751,252 762,252 768,246 771,251 770,261 765,266 771,258 771,251 765,243 767,245 765,248 758,251 753,241 750,242 749,245 750,252 739,247 739,244 744,240 746,240 740,242ZM752,243 755,244 757,249 756,251 751,251 750,250 750,245ZM594,239 592,240 593,244 591,248 587,252 592,248 594,244ZM612,238 614,243 628,245 633,248 629,241 626,242ZM526,235 527,238 530,239 532,242 537,243 541,242 539,240 538,241 529,238ZM815,228 814,229 820,238 822,247 825,284 825,271 824,270 824,258 823,257 822,243ZM503,228 499,229 502,232 501,235 499,236 501,236 504,233 504,231 502,230ZM567,227 565,228 562,234 560,233 562,230 560,231 559,234 557,233 558,231 557,239 558,237 562,239 562,234ZM859,213 851,218 840,222 841,223 846,221ZM343,206 338,249 339,241 347,243 352,253 349,260 366,242 390,240 420,248 446,268 450,264 421,234 398,224 405,224 404,219 399,222 393,218 392,221 388,215 377,214 378,223 369,218 370,221 342,216ZM384,215 385,218 383,220 380,217ZM209,203 207,226 208,222 336,240 339,212 338,217 306,219 242,210 235,216 225,218 214,215 213,212 219,212 211,212ZM527,202 528,204 618,214 528,204ZM216,203 220,206 229,206 230,207 238,205 232,202 234,204 233,206 225,203 229,202 217,201 220,202ZM59,195 58,197 59,211 57,215 58,219 53,222 56,220 66,219 77,221 89,226 90,225 93,199 92,200 89,198 75,195 70,196 67,194ZM133,193 131,193 129,195 127,194 127,195 131,196ZM333,191 330,194 330,197 332,199 340,201 335,196ZM109,193 124,195 123,193 125,191 129,192 112,189ZM771,178 790,182 814,190 827,197 832,204 844,196 851,200 841,190 822,183 808,182 807,184 801,181 789,182 788,180ZM485,169 558,188 508,184 524,196 520,189 593,197 590,188 630,214 621,215 834,216 807,190 640,168 688,192ZM691,195 694,194 705,199 707,201 706,202 701,201ZM751,193 752,192 774,192 775,193 815,194 819,196 823,201 822,202 771,198 762,199 754,198ZM605,192 682,191 692,196 687,198 615,198ZM546,191 547,190 548,191 549,190 550,191 560,191 561,192 572,192 574,191 578,194 582,195 583,194 587,197 586,198 581,198 575,196 574,197 554,193 547,193ZM620,202 719,202 664,174 748,201 709,204 792,202 829,212 642,214ZM216,173 331,184 303,182 294,177 313,177 220,168ZM274,174 275,173 279,174 278,175ZM220,169 221,168 225,169 224,170ZM96,198 92,228 111,247 95,220 99,215 121,212 139,232 140,228 159,233 169,217 203,221 204,229 207,199 206,203 161,200 147,183 117,167 213,174 218,168 120,161ZM104,192 114,183 128,184 133,187 130,189 137,193 135,198 128,203 137,195 138,197 149,195 158,203 157,213 153,215 145,215 116,207 116,205 126,204 113,204 110,199 105,197ZM151,164 152,163 157,163 158,164 157,165 152,165ZM367,156 443,191 379,190 377,207 436,220 437,232 446,236 440,230 448,226 466,245 456,256 470,242 448,224 465,217 481,234 467,212 472,198 524,203 502,201 467,181 515,190 387,162 380,150 382,155ZM690,132 693,139 691,134 692,132 698,136 705,152 703,159 700,156 707,161 706,154 710,151 707,151 704,148 699,138 699,134 708,135 721,148 724,148 718,138 710,132ZM260,128 258,138 262,139 258,140 279,141 269,140 285,139 326,143 330,147 332,156 330,136 325,127 318,123 308,121 270,121 264,123ZM269,129 276,125 279,126 282,124 284,125 297,124 303,126 314,125 317,127 322,127 326,131 330,142 325,143 310,139 309,140 306,139 305,140 302,138 288,139 280,136 278,137 273,135 269,131 270,130ZM100,67 81,90 75,106 85,161 47,161 50,146 33,184 32,200 33,186 94,197 117,161 94,158 82,127 81,90ZM105,166 106,165 112,165 113,166 112,167 106,167ZM40,173 42,168 44,166 48,165 64,167 70,169 71,168 72,169 79,169 84,171 83,173 81,172 80,173 68,172 67,171 66,172 57,171 49,174 46,173 41,174ZM331,44 346,56 458,54 570,60 552,59 556,54 590,63 574,55 519,46 339,40ZM351,55 352,54 358,54 359,55 358,56 352,56ZM352,45 353,44 357,45 356,46ZM362,45 386,42 498,47 545,52 552,57ZM338,42 339,41 343,42 342,43ZM101,65 198,50 304,53 328,73 354,145 354,137 366,154 372,150 347,78 379,148 342,63 317,42 189,40 252,40ZM254,40 257,38 258,39 259,38 260,39 274,39 275,40 274,41 255,41Z"/><path fill="rgb(229,230,232)" fill-rule="evenodd" d="M418,387 416,385 414,388 413,387 410,389 417,390 416,388ZM506,376 509,380 511,379 511,381 514,380 523,383 521,384 527,383 528,384 526,385 534,385 531,386 546,386 547,387 545,388 555,386 551,379 548,379 551,380 547,381 544,379 546,378 542,379 524,373 514,367 533,379 523,381 514,379 511,376 512,375 510,375 512,377 509,380ZM880,365 882,367 879,368 878,365 877,367 878,371 877,372 876,371 877,372 876,373 876,380 876,373 878,371 882,371 884,373 888,371ZM873,357 869,359 856,361 852,363 850,362 832,362 849,362 850,367 851,366 852,367 855,365 865,364 871,360 872,358 873,359ZM579,355 580,356 579,357 585,362 593,362 594,361 597,362 600,358 602,360 606,361 609,360 613,362 614,361 623,361 624,362 623,363 625,361 626,362 625,361 611,361 610,360 612,359 602,360 596,353 587,353 584,355 582,354 581,356ZM578,339 584,341 587,339 589,340 591,337 581,336ZM567,330 564,329 558,334 560,333 562,334 565,330ZM208,314 301,326 314,331 322,338 316,331 299,324ZM158,319 168,320 166,318 170,314 175,312 202,314 206,316 206,311 205,315 202,313 196,313 189,311 172,310 161,316ZM894,274 875,291 872,292 866,297 866,304 865,305 864,304 864,297 865,314 866,311 871,307 874,308 876,306 874,305 877,302 879,302 885,296 885,293 889,289 891,289ZM623,269 638,284 639,283 638,280 629,271 628,272 626,271 625,268ZM862,263 861,264 860,263 854,264 853,265 854,266 854,271 854,267 857,266 860,263 861,264ZM879,254 880,256 877,261 875,260 875,253 875,255 868,264 870,264 871,266 867,268 867,271 866,270 866,273 867,271 868,274 866,278 865,275 865,286 888,275 886,270 882,267 882,263 880,260 881,258 894,272ZM876,266 878,267 875,271 878,274 877,275 882,272 885,274 879,279 877,279 873,275 874,274 872,273 873,272 872,270ZM872,261 873,263 871,265 869,263ZM848,251 847,273 847,266 849,262 848,261ZM339,242 339,249 337,254 337,267 337,257 338,256 342,260 341,261 343,263 344,268 342,278 346,266 349,261 348,259 349,258 350,259 349,257 352,256 351,257 350,256 351,253 349,252 348,245 347,244 345,245 344,243 342,243 343,244 340,245ZM373,241 381,245 379,246 382,244 385,247 391,246 420,259 425,263 425,267 422,267 424,270 426,266 430,266 433,271 428,272 434,277 432,275 437,273 438,279 438,276 445,269 434,257 415,247 396,242 386,242 390,241ZM16,234 15,237 16,240 11,249 10,247 9,249 10,248 11,249 10,253 15,254 13,251 16,248 19,240 16,237ZM207,233 211,231 240,237 243,235 258,239 290,241 303,247 327,251 329,254 334,252 335,256 336,241 214,223 208,223ZM637,221 636,222 635,221 636,222 635,223 636,226 635,227 634,226 635,231 636,229 637,230 636,229 638,224ZM445,221 455,228 467,242 470,241 471,242 472,240 473,241 474,239 475,240 476,238 477,239 481,237 482,235 483,236 478,232 479,231 478,232 475,228 476,227 475,228 473,225 472,226 468,221 464,219 465,218 460,218 459,219 456,218 457,219 456,220 454,219 453,221 451,220 452,221 449,224 447,221 446,222ZM138,232 142,242 150,247 158,245 167,230 172,226 203,230 204,243 203,222 169,218 159,234 145,232 147,231 140,229 140,232ZM150,244 151,243 156,243 157,244 154,246ZM99,216 96,218 96,220 108,240 107,242 110,243 109,245 110,244 110,247 113,249 112,250 118,264 113,245 107,232 107,227 112,224 123,224 127,226 130,225 131,227 134,225 127,217 121,213 120,215 110,214ZM620,201 628,210 642,213 828,212 823,207 792,203 716,206 699,201ZM116,206 120,206 125,209 130,209 134,212 139,212 145,214 153,214 156,213 157,210 157,203 149,196 147,197 144,196 142,198 141,197 138,198 137,196 132,202 130,203 129,202 130,203 129,204 124,202 125,201 123,203 126,203 127,204 126,205ZM752,193 754,197 822,201 823,199 829,202 826,203 830,207 832,215 835,216 854,206 850,198 848,200 846,197 832,205 827,198 823,199 818,195ZM547,191 547,192 554,192 561,194 586,197 583,195 582,196 578,195 574,192 572,193 561,193 560,192 550,192 549,191 548,192ZM36,247 33,223 41,231 38,244 45,229 54,220 57,221 55,220 59,194 94,198 32,186 34,212 25,215 30,218 29,221 32,219ZM468,181 478,183 489,188 502,200 508,199 510,201 523,202 522,200 523,199 521,198 522,197 521,198 519,195 520,194 516,190 515,191 512,189 513,188 507,189 478,182ZM520,178 535,182 539,185 545,184 546,185 545,186 547,185 551,186 539,182ZM292,176 298,177 299,178 298,180 303,181 313,181 314,182 324,182 325,183 333,183 334,182 333,181 334,180 333,181 332,180 327,181 326,180 327,179 325,178 315,179 314,178 315,177 313,178 304,178 303,177 304,176 303,177 295,177 294,176 295,175ZM209,202 211,205 215,193 219,196 216,192 227,191 244,200 243,210 306,218 339,217 342,201 329,197 331,189 302,204 288,195 284,182 289,181 216,175ZM665,174 670,177 671,175 675,176 676,179 672,178 702,195 677,179 697,182 747,202 745,203 747,201 720,189ZM696,196 638,167 639,173 629,175 649,181 558,179 653,180 683,191 590,189 594,197 584,200 519,189 533,205 628,216 609,194ZM118,167 143,179 154,188 161,199 168,197 174,200 183,199 207,203 206,199 209,194 208,190 210,190 212,174ZM39,175 41,173 46,172 47,173 54,171 57,172 56,171 57,170 59,171 60,170 63,171 67,170 68,171 77,171 78,172 81,171 83,172 83,171 72,170 71,169 70,170 52,166 50,167 49,166 47,167 43,166 44,167 41,172 40,171 41,173ZM671,169 679,168 676,168 675,167 676,166 686,166 676,165 673,166 675,168 674,169ZM678,173 713,177 732,184 806,188 775,181 783,178 815,182 724,166 723,169 714,164ZM760,181 762,180 765,182 762,184ZM755,181 759,179 760,180 759,183ZM751,180 754,179 755,181 753,182ZM771,180 775,178 780,179 775,181ZM765,179 770,178 771,179 770,180 767,180 769,180 770,183 768,184 765,181ZM770,178 771,177 775,178 774,179ZM727,171 728,170 732,171 731,172ZM717,172 720,170 718,169 719,168 722,168 725,170 720,173ZM717,167 718,166 722,167 721,168ZM577,165 583,165 587,167 606,171 633,170 623,166 606,166 605,165 606,164 618,164 608,164 607,163ZM441,164 487,170 472,166 532,163 533,169 591,170 550,162ZM386,160 499,181 498,183 505,185 510,183 543,187 400,163 389,158ZM258,153 263,152 266,154 273,154 274,153 275,154 289,155 283,154 281,152 278,153 264,153 259,151ZM270,140 289,142 296,148 294,149 296,152 295,153 298,153 298,155 305,154 315,157 333,159 334,148 331,140 331,145 333,147 332,157 329,147 326,144ZM327,149 323,153 318,150 315,151 312,147 313,146 316,148 317,147 318,148 320,146 322,147 323,144ZM354,138 371,180 343,216 461,251 460,290 438,282 471,329 474,271 490,342 513,291 623,292 648,327 800,309 857,330 858,302 648,315 622,267 483,238 492,271 622,290 506,276 491,302 453,231 376,207 442,191ZM463,320 464,322 468,323 465,326 461,323ZM543,269 544,268 548,272 547,273 548,272 552,273 553,275 557,273 560,276 562,275 566,276 567,275 569,277 564,280 562,280 560,278 556,279 553,277 549,278 548,276 547,277 545,275ZM521,261 522,260 531,261 538,264 534,265ZM450,236 453,237 451,241 448,238ZM439,233 441,231 442,232 445,231 446,232 445,233 448,235 446,237ZM415,231 417,230 419,233 418,234ZM440,228 443,227 444,229 442,231ZM439,225 441,227 439,229 441,231 439,233 437,233 436,231 437,230 438,231 435,228 438,227ZM412,221 413,220 417,221 416,222ZM409,219 411,217 414,218 411,220ZM368,218 369,217 372,220 371,221ZM358,216 361,214 363,217 360,218ZM372,211 373,212 372,215 369,213ZM699,135 705,148 707,150 711,151 707,154 707,160 708,161 716,155 718,155 720,157 722,155 720,152 724,149 721,149 708,136ZM692,133 694,137 694,140 699,145 699,149 702,153 703,158 704,152 701,147 697,136ZM270,129 271,130 270,131 273,134 278,136 280,135 288,138 292,137 301,138 302,137 310,140 314,139 329,142 325,131 322,128 317,128 314,126 303,127 297,125 296,126 282,125 279,127 272,126 273,127ZM344,75 371,148 376,156 382,154 380,149 375,148 377,147 376,140 374,140 373,133 372,134 370,130 371,128 370,129 368,126 369,123 368,124 361,108 362,106 361,107 359,103 360,101 356,100 358,96 356,96 355,89 353,91ZM373,149 375,148 380,151 376,152ZM550,51 561,52 573,55 561,51 558,52ZM363,45 579,60 498,48ZM318,39 318,40 321,39 328,41 329,42 328,43 329,42 330,44 332,43 333,44 332,45 334,44 337,46 334,44 337,41 334,41 333,39 332,40ZM251,39 184,39 99,51 75,78 47,126 56,128 47,160 84,161 74,106 104,61 162,48 178,51 173,50 186,44ZM251,34 251,35 248,30 244,31 239,30 241,31 229,33 228,32 223,33 222,32 224,31 209,31 217,31 218,32 210,34 207,36 201,36 232,35 233,34 244,35 248,33Z"/><path fill="rgb(209,210,212)" fill-rule="evenodd" d="M514,369 515,370 513,375 514,378 523,380 524,379 532,379 532,378 528,377ZM577,371 579,369 583,371 589,370 600,372 616,371 625,372 634,375 641,373 643,379 642,367 640,366 589,364 581,367ZM705,313 653,315 648,328 644,308 627,314 616,325 569,324 547,347 515,351 526,367 514,366 548,378 529,367 561,367 582,349 597,350 609,337 703,339ZM577,339 581,335 591,336 592,337 589,341 587,340 588,339 587,340 586,339 587,340 584,342 579,341ZM209,306 208,313 303,324 316,330 323,337 322,339 312,338 329,340 321,328 305,319 238,310 210,309ZM206,299 205,309 190,305 167,304 154,313 151,318 160,321 187,323 162,321 157,319 172,309 189,310 205,314ZM433,275 434,276 433,277 437,281 436,280 437,276 440,279 438,277 439,276 438,277 437,274ZM457,267 473,325 463,321 459,332 469,377 493,375 501,361 507,374 510,313 623,315 617,287 545,266 617,287 621,308 513,292 498,308 490,343 484,297 475,296 482,286 473,271ZM470,278 471,279 468,282 467,280ZM462,273 463,271 466,272 464,274ZM894,275 892,289 865,315 870,263 861,265 857,331 853,314 804,312 804,337 866,333 875,358 865,365 645,372 819,368 864,375 877,351 875,322 864,319 895,309ZM432,269 425,270 420,260 376,242 355,252 343,276 338,257 336,355 349,292 366,263 389,259 418,266 429,274ZM335,317 336,318 336,324 335,325 334,324 334,318ZM205,224 207,272 208,258 233,266 260,265 267,271 279,269 299,275 324,291 326,303 332,307 332,320 334,253 329,255 290,242 207,234ZM8,253 30,267 33,307 48,247 63,237 89,243 89,228 129,309 143,278 152,291 174,250 203,256 204,268 203,231 172,227 150,248 134,226 109,226 118,265 91,226 58,221 40,240 34,223 35,244 31,219 19,212 19,244ZM123,287 125,293 124,294 121,292ZM121,279 123,283 122,288 120,283ZM19,260 21,259 23,262 22,263ZM39,249 41,251 40,253 37,251ZM36,243 37,244 36,248 35,247ZM803,188 808,189 826,199 825,197 813,191ZM116,184 121,185 119,187 120,189 129,191 131,190 129,191 128,190 129,188 122,188 120,186 121,185 120,184ZM285,182 288,183 288,188 289,189 288,190 290,194 289,195 292,196 293,198 295,198 296,201 301,201 302,203 305,201 306,202 310,201 311,199 315,198 322,192 326,191 328,189 331,188 333,189 329,185 313,186 306,184 309,183 302,183 301,184 296,182ZM678,179 689,186 693,187 698,192 716,200 721,200 724,202 721,203 746,202 718,190 690,181ZM473,166 556,178 646,180 628,175 640,171 634,166 681,173 696,168 606,165 634,170 606,172 576,165 588,164 560,164 592,170 570,172 533,170 532,164ZM627,166 628,165 632,166 631,167ZM400,162 552,187 463,166ZM417,164 418,163 423,164 422,165ZM724,157 720,158 718,156 716,156 708,162 710,161 713,164 714,163 715,164 714,163 719,161 720,162 721,161 719,159ZM288,154 292,156 314,157 305,155 298,156 297,155 298,154ZM334,152 334,159 333,160 336,160 335,152ZM356,148 356,162 358,162 356,181 354,183 349,182 349,184 337,187 334,191 336,191 335,193 337,193 337,197 341,200 365,204 365,201 362,198 363,192 369,186 367,184 370,180 363,166 363,158 367,154 361,160 360,155 357,155 360,153ZM345,195 347,196 346,199 343,197ZM348,192 349,193 347,196 345,194ZM349,188 351,190 349,193 347,191ZM327,153 325,151 326,149 324,146 325,145 324,146 323,145 322,148 320,147 318,149 313,147 315,150 318,149 323,152 325,151ZM695,141 696,143 695,146 697,149 696,150 701,155 701,153 698,149 698,145ZM534,47 543,48 548,50 555,50 556,51 561,49 557,48 559,49 558,50 549,49 548,48 550,47 540,48 539,47 541,46ZM238,35 211,36 235,37 232,36 233,35ZM193,35 194,34 199,36 194,37 206,38 202,38 200,36 201,35 207,35 213,32 217,32 204,31 200,33 193,33Z"/><path fill="rgb(186,187,188)" fill-rule="evenodd" d="M398,436 399,437 396,441 393,449 395,445 396,448 398,443 397,441 399,440 398,438 399,437 400,438ZM394,417 389,419 382,427 381,426 382,424 381,425 379,422 381,426 375,430 380,427 383,428 382,430 386,425 385,424 389,422ZM394,402 393,406 396,408 395,411 396,408 398,412 397,406ZM301,396 304,396 306,398 312,400 322,400 325,398 327,399 326,397 317,400 309,397ZM530,370 550,378 554,376 553,375 560,368 559,366 556,366 554,368 549,366 541,366 540,367 535,366 532,367 531,366ZM887,375 874,379 876,363 864,376 819,369 645,373 641,385 641,374 579,370 557,388 567,381 640,386 866,377 876,382ZM501,362 493,376 486,377 482,375 479,377 470,377 472,384 471,386 474,389 473,391 477,394 475,395 478,395 478,400 482,404 486,404 482,404 479,401 481,398 481,394 491,392 500,385 501,387 503,385 514,383 508,381 505,378 502,370 502,365 500,364ZM334,358 335,359 333,368 334,369 331,371 331,373 332,374 333,372 335,373 335,381 335,375 336,374 337,375 337,381 336,358ZM516,354 516,356 514,357 514,365 522,366 528,369 519,363 516,359ZM429,347 428,350 429,352 427,353 428,354 424,364 425,367 426,365 424,364 427,363 425,362 430,356 430,354 432,352 433,353 432,352 433,351 432,352 429,349ZM869,346 873,351 873,356 875,361 872,346ZM392,340 389,343 392,348 391,349 393,350 392,352 395,359 393,354 394,347 393,349 392,348 393,345ZM333,337 333,349 335,352 334,355 335,356 335,338 334,340ZM412,333 410,343 411,344 410,362 411,352 412,351 411,345 413,343 412,339 414,338 413,336 414,335 413,336 411,334ZM96,323 93,334 94,334 94,332 98,325 97,326ZM68,320 67,322 69,324 68,325 70,326 70,330 73,335 72,336 74,339 75,344 76,343 74,340 75,337 73,332 72,333 70,330 71,324 70,325 67,321ZM507,316 505,320 507,328 507,326 508,325 509,326 508,322 510,321 507,318ZM889,314 886,313 883,315 870,319 865,319 866,321 873,321 874,323 875,321 866,321 865,320 871,318 877,318ZM85,311 84,312 82,311 83,322 84,312ZM894,271 896,278 896,306 895,307 896,309 889,312 892,313 895,310 896,312 893,319 895,316 896,319 896,310 897,309 896,306 897,305 897,287 896,286 897,284 896,283 896,276ZM208,259 208,310 209,305 297,316 316,323 330,340 206,327 207,338 299,347 331,358 331,307 317,285 279,270ZM7,255 10,308 12,311 23,316 31,323 32,303 31,300 30,303 28,301 29,267 26,266 24,263 25,260 22,258 20,261 23,263 19,264 17,262 18,260 14,259 15,256 11,263ZM203,257 174,251 162,282 148,291 143,279 129,310 121,280 123,293 120,296 118,289 117,293 123,298 121,312 129,338 129,334 151,330 205,339 205,323 150,318 167,303 205,308ZM90,231 90,244 89,245 90,244 91,245ZM605,218 606,219 604,220 612,221 620,220 621,221 618,222 621,221 623,223 626,223 627,224 624,226 620,225 622,226 616,227 614,233 613,232 614,237 629,239 632,243 633,242 635,243 630,240 631,238 630,234 632,233 631,229 632,228 633,229 632,224 633,223 634,224 631,222 633,220 624,221 618,219 610,220 608,218ZM862,214 861,218 863,220 864,219 867,220 865,219 866,218 865,219 864,218 866,215 867,216 866,215 864,217 862,215 864,214ZM220,212 223,216 228,216 232,213 231,214 225,214ZM516,208 521,208 522,209 527,208 529,210 554,213 552,213 551,211 544,212 543,210 539,211 534,209 530,210 528,208 520,208 519,207ZM113,199 114,200 113,202 115,203 121,203 123,200 120,201ZM221,200 222,199 228,201 234,200 239,202 239,201 236,201 234,199 233,195 226,194 224,196 226,199 225,200 222,199ZM121,186 122,187 129,187 126,185ZM349,183 342,182 340,184 332,186 336,194 334,189 337,186 344,185 345,183 346,184ZM260,155 261,158 274,158 280,160 317,162 329,164 336,163 336,161 326,159ZM309,161 310,160 315,161 314,162ZM295,160 296,159 303,159 304,160 303,161 296,161ZM279,146 280,149 282,147 283,150 286,150 284,149 285,148 290,149 288,147 286,148 284,146 281,147ZM168,34 162,34 156,37 152,36 154,35 145,36 143,41 145,42 161,41 159,41 158,40 159,39 168,40 165,38 168,36Z"/><path fill="rgb(152,154,157)" fill-rule="evenodd" d="M394,445 395,447 394,448 393,447 394,449 392,450 392,453 389,457 392,459 394,457 393,455 395,453 394,450 396,449ZM424,436 425,440 427,441 426,443 429,448 428,450 429,453 431,453 433,450 431,449 430,447 431,446 430,447 429,446 430,444 428,443 429,442 427,441 428,439 427,440 426,439 427,437 426,438 425,437 426,435ZM411,435 410,435 411,437 410,463 408,464 406,462 407,463 405,464 402,461 399,462 408,464 409,467 415,466 413,465 414,463 413,465 412,463 411,464 410,463 410,457 412,447 412,449 411,450 410,449ZM386,422 384,424 383,423 384,424 381,427 380,425 378,427 380,428 376,431 377,432 376,434 378,435 377,436 378,435 379,436 378,435 382,431 381,430 385,425 386,426 385,425ZM428,409 429,408 428,410 436,417 437,416 443,422 444,412 443,413 444,414 442,416 440,415 441,414 439,415 438,414 439,413 436,416 434,414 437,412 435,413 434,412 435,411 433,412 432,410 431,411ZM371,401 372,400 371,401 371,408 377,406 392,406 390,405 388,406 376,406 374,404 376,403 373,402 376,400 373,402ZM293,396 295,396 302,401 328,403 328,400 326,399 322,401 312,401 308,400 304,397 296,395ZM65,387 60,393 61,397 62,396 61,395 63,393 63,390 64,389 65,390 64,389ZM639,385 567,382 558,389 547,390 511,383 481,395 479,402 510,405 508,404 514,398 541,391 594,392 603,385ZM443,380 442,381 439,379 436,382 433,383 431,386 430,385 428,388 427,386 428,389 433,386 434,387 438,384 439,385 440,383 442,384ZM850,393 854,394 859,391 862,392 863,391 869,394 867,395 871,395 876,391 886,378 884,378 876,383 869,383 866,378 848,380 853,380 854,379 858,380 853,384ZM377,361 377,364 375,368 377,371 378,370 379,372 389,380 382,374 385,371 380,366 379,367 377,365 378,363ZM576,356 575,357 574,356 553,376 566,365 574,356 575,357ZM201,355 320,370 335,385 334,373 330,373 333,369 321,370 282,363ZM133,350 134,349 135,350 134,352 135,351 137,354 136,355 138,356 139,359 142,356 149,357 158,353 163,354 163,352 165,350 159,350 157,348 150,349 145,347 136,347ZM104,346 101,349 100,352 98,351 94,356 95,357 104,352 103,351ZM508,316 511,320 514,317 560,320 590,319 570,320 570,318 575,318 555,319 555,317 563,317 538,318 513,315 521,314 512,314ZM10,309 18,321 32,334 31,324 23,317 14,312 12,312ZM333,308 331,359 299,348 151,331 129,335 129,339 145,344 153,337 207,339 209,343 314,354 333,363ZM659,286 658,287 659,292 660,291ZM659,286 660,287 659,292 658,291ZM867,219 868,220 866,221 869,222 873,226 875,233 876,228 874,227 875,225 873,224 875,222 874,221 873,222 871,220 872,219 871,220 873,222 871,224ZM862,220 860,218 859,219 858,218 856,221 855,220 850,223 852,223 854,221 856,223 847,229 855,224 858,224 861,227 859,225 859,223 862,222ZM115,198 115,199 120,200 121,199 125,200 131,198 133,199 132,198 126,199 125,198 126,197 121,197 120,196 116,196 120,196 123,198 122,199 116,199ZM15,183 17,183 18,184 17,185 20,184 18,183 21,180 23,181 23,180 18,180 17,181 16,180ZM41,137 36,137 35,136 36,137 34,141 37,142ZM36,140 37,137 41,138 38,141ZM582,66 593,67 598,74 595,76 670,142 681,155 675,156 682,157 681,148 632,99 593,67ZM447,37 456,37 465,39 478,39 479,40 476,37ZM467,38 468,37 476,37 477,38 476,39 468,39Z"/><path fill="rgb(126,127,131)" fill-rule="evenodd" d="M411,443 411,449 412,450 411,463 412,462 414,465 412,457ZM371,400 377,403 375,404 376,405 375,406 373,406 388,405 389,404 392,405 391,403 379,403 374,402ZM641,386 603,386 594,393 561,395 541,392 514,399 509,404 510,406 505,406 599,407 617,395ZM562,405 563,404 567,405 566,406ZM870,396 863,392 854,395 849,393 852,384 857,380 846,382 841,380 844,381 833,390 817,391 808,388 801,389 803,391 799,392 803,394 792,394 829,394 844,382 824,400 830,399 840,391 844,393 842,398 838,399ZM127,377 321,403 302,402 293,395 209,385 215,384 132,373ZM238,389 239,388 244,389 243,390ZM177,381 178,380 183,381 182,382ZM171,380 172,379 177,379 178,380 177,381 172,381ZM163,379 164,378 169,378 170,379 169,380 164,380ZM150,377 151,376 156,377 155,378ZM132,375 133,374 139,374 140,375 139,376 133,376ZM96,373 97,374 96,375 104,382 104,380 106,378 101,377 100,375 99,376ZM384,372 383,374 391,382 390,379ZM138,358 155,361 185,356 313,373 330,379 320,371 288,366 294,365 216,357 223,356 159,349 166,350 163,355ZM145,342 206,343 209,351 212,351 209,344 312,357 325,362 313,364 333,365 314,355 208,345 195,340 153,338ZM61,338 60,341 62,343 64,342 63,341 65,339 64,340ZM616,246 615,248 616,247 619,250 618,251 620,252 619,253 620,252 622,255 621,256 623,254 625,254 630,258 637,261 638,263 637,264 639,265 639,267 644,275 645,274 643,273 644,272 641,270 641,268 634,256 630,252ZM855,230 858,233 855,234 854,236 856,241 857,241 858,239 859,240 858,238 857,240 856,239 856,235 858,233ZM474,211 474,215 476,217 475,219 477,216 476,215 480,214 476,213ZM22,168 21,172 25,173 27,169ZM680,148 684,152 683,157 685,154 688,156 685,157 689,157ZM604,103 603,108 611,115 610,114 611,113 613,113 614,115 617,114ZM566,80 569,80 582,87 585,92 588,91 594,97 595,96 581,86 569,80ZM550,63 566,64 582,72 576,74 584,76 599,88 600,100 607,94 622,107 620,114 637,121 670,154 667,155 680,155 647,121 594,76 597,74 593,71 594,67 587,69 582,65Z"/><path fill="rgb(100,105,109)" fill-rule="evenodd" d="M426,465 421,471 414,474 411,473 408,477 405,477 401,475 400,473 395,472 392,470 390,472 388,471 391,474 394,475 401,475 404,477 410,477 419,473ZM68,426 74,431 84,430 81,431 80,429 78,430 77,429 78,428 74,428 71,425ZM843,392 840,392 830,398 831,399 841,398ZM638,387 634,390 629,390 626,393 617,396 602,406 615,406 616,407 618,405 620,406 641,406 624,406 622,404 623,403 622,402ZM846,381 642,386 625,403 656,397 726,398 720,404 729,404 746,395 803,393 798,392 801,388 837,388 823,400ZM130,379 300,404 329,404 307,404 271,396 264,398 260,394 251,396 199,389 194,385 182,387ZM58,368 59,374 62,372 70,370 61,370 60,369 63,368 59,369ZM239,366 247,366 255,368 263,368 264,369 299,373 293,371 287,372 285,370 279,370 264,367 245,366 244,365ZM141,361 143,362 148,361 152,363 158,363 162,361 156,361 155,362 149,362 146,360ZM193,360 213,362 200,359ZM59,349 58,351 59,361 62,360 60,357ZM157,342 164,344 163,347 173,345 182,349 190,347 190,350 198,348 198,351 206,349 206,352 212,349 217,351 215,353 232,352 231,355 240,353 238,356 247,354 247,357 255,355 271,357 271,360 324,364 312,358 211,347 207,341 207,345ZM63,340 65,342 63,344 69,347 68,346 69,345 67,343 66,344ZM768,312 773,312 774,313 800,313 798,312 789,312 788,313ZM766,313 765,312 764,313 745,313 744,314 741,313 740,314 738,313 711,313 711,314ZM397,311 394,311 384,317 376,325 369,336 373,329 384,318ZM713,256 712,266 714,276 714,285 715,271 714,270 714,263 712,262ZM619,252 618,253 619,252 620,253 619,255 620,254 623,258 622,260 623,259 626,262 625,263 626,262 631,269 632,268 648,285 649,283 647,282 648,281 646,280 647,279 643,275 644,273 643,274 641,271 643,270 641,271 638,267 638,265 640,264 637,265 636,264 638,262 637,263 636,261 630,259 625,255 622,256ZM799,243 801,251 801,261 803,268 803,284 804,271 802,262 802,253 801,252 802,251 801,246ZM834,242 835,254 836,255 836,264 837,265 837,284 838,284 837,258 836,257 836,248ZM855,240 855,244 859,245 858,244 859,242 860,243 858,240 856,242ZM708,240 710,246 710,251 712,252 712,249 711,250 710,249 711,242 710,243ZM787,236 788,237 787,238 788,244 789,243 790,244 789,250 790,248 791,249 790,259 791,256 792,257 793,272 791,248 790,247 790,242 788,241ZM851,225 849,224 845,226 847,228 846,229ZM243,136 244,137 242,139 240,149 248,150 248,141 246,150 243,146 243,140 244,139 244,136ZM253,130 250,151 255,149 256,151 253,152 256,152 255,143 258,142 255,139 255,134 254,135 253,134ZM156,135 214,145 215,140 213,142 211,139 208,140 207,138 203,138 204,141 207,141 206,143 196,141 198,140 194,137 196,136 191,134 187,135 185,133 183,134 178,131 175,132 174,130 177,129 173,125 173,120 165,118 162,129 159,131 158,128ZM154,118 155,120 154,121 153,120 149,129 150,131 147,134 151,134 150,131 153,129 155,122ZM101,111 100,114 101,115 101,122 103,126 102,127 113,128 119,130 124,117 123,118 120,118 118,116 113,116 112,117 111,115 103,117 101,115 104,114ZM113,127 115,126 117,128 114,129ZM505,60 559,71 543,73 554,78 529,77 558,153 669,156 637,122 619,114 622,109 611,97 600,101 598,88 575,74 582,73 551,62ZM649,145 653,151 652,154 648,147ZM630,128 631,127 637,133 635,134ZM594,107 595,106 603,115 613,122 616,123 629,122 630,124 628,126 626,126 625,125 627,124 623,126 615,127 608,123 602,117 600,117 595,112 596,111 594,109ZM602,103 603,102 606,104 607,103 614,111 613,112 616,110 617,111 616,112 618,114 615,116 613,114 610,115 602,108 603,104ZM592,95 594,94 596,96 594,98ZM582,88 584,87 589,91 587,93 585,93 582,90 583,89ZM573,83 575,82 583,87 581,88ZM565,80 566,79 570,80 569,81ZM258,19 269,20 274,24 273,22 274,21 279,22 276,20 271,20 270,21 268,19Z"/><path fill="rgb(71,75,79)" fill-rule="evenodd" d="M446,416 442,441 424,465 409,471 393,466 380,456 380,451 379,453 374,446 375,442 373,440 373,444 369,437 370,435 372,438 367,421 366,436 377,463 386,473 399,479 412,478 422,473 440,447ZM404,472 405,471 410,472 409,473ZM422,471 417,475 414,473 419,470ZM410,471 411,470 415,471 414,472ZM388,472 392,469 395,471 400,472 401,474 405,476 408,476 411,472 416,475 410,478 404,478 401,476 391,475ZM426,464 427,466 424,469 423,467ZM54,393 56,407 62,422 72,432 84,432 96,420 98,416 97,415 98,416 87,426 78,426 72,423 64,412 61,411 58,406 56,397 57,396 59,398 57,394 56,396ZM67,426 69,424 72,425 73,424 74,427 78,427 79,428 78,429 80,428 83,431 82,432 74,432ZM277,388 286,388 289,390 297,389ZM396,382 395,386 399,390 398,388 399,387 400,388 398,386 400,385 395,383ZM374,376 375,379 373,385 374,383 375,384 375,389 378,392 376,389 375,377ZM73,370 71,367 61,369ZM92,365 89,367 91,370ZM459,357 456,359 457,361 456,362 460,362ZM60,349 61,357 62,359 65,359 63,358ZM66,343 70,347 69,348 67,347 73,351 77,356 78,355 76,354 77,352 75,352ZM59,304 58,304 59,305 58,306 56,306 57,307 53,313 51,324ZM424,302 421,301 418,305 420,306ZM363,341 363,350 373,325 393,308 398,311 393,314 409,312 436,335 453,374 450,358 455,357 445,344 455,343 447,339 450,332 447,338 441,332 448,329 441,329 444,323 434,323 440,316 434,317 436,311 428,311 428,304 419,311 412,309 417,300 408,305 412,299 400,308 403,299 389,306ZM449,351 451,353 450,358 448,355ZM431,325 432,324 435,328 434,329ZM438,322 440,324 439,329 436,326ZM381,316 382,318 379,321 378,318ZM424,316 426,314 430,318 428,319ZM429,312 431,313 430,316 427,314ZM422,310 424,309 427,313 425,314ZM398,310 399,309 409,309 410,310 409,311 399,311ZM402,307 405,305 410,307 409,308 403,308ZM659,295 660,296 720,296 725,295 717,295 716,296 715,295 708,295 707,296 705,295 696,295 695,296 678,296 677,295 675,296 661,296ZM771,294 775,295 796,294 788,294 787,295ZM841,293 840,292 839,293 823,293 823,294ZM71,285 74,289 69,288 65,293 79,291 92,298 108,326 112,347 113,335 120,344 120,339 114,337 119,336 113,335 109,321 118,328 109,321 107,313 113,314 108,311 111,307 104,309 109,303 103,302 105,296 98,304 95,298 103,294 94,295 100,290 92,291 95,284 88,288 91,282 79,285 81,280 77,286ZM112,331 113,332 112,336 111,335ZM103,302 105,305 104,308 102,305ZM85,289 87,288 90,290 91,288 93,292 92,293 88,291 86,292ZM84,286 83,288 76,288 75,287 83,285ZM604,261 596,260 595,259 596,258 591,259 590,260 593,263 589,267 587,265 586,266 588,266 590,268 589,267 595,261ZM791,257 789,266 790,264 791,265 792,283 790,285 791,284 793,285 794,284 792,278 793,277 792,272 793,263 792,266 791,265ZM828,255 826,258 825,257 826,262 828,264 828,269 827,270 826,269 827,279 828,278 829,279 828,274 829,265 827,262 828,261 827,259ZM700,248 700,250 698,251 701,252 701,256 699,258 700,259 701,257 702,258 702,263 700,266 702,265 703,266 703,271 701,277 702,277 703,274 704,275 703,281 704,285 705,285 705,281 704,282 703,281 704,279 704,267 702,264 703,259 701,257 702,252 700,251ZM667,243 668,248 669,247 670,248 669,252 671,253 670,258 671,257 672,258 671,264 673,267 672,271 674,272 675,283 674,284 676,285 674,286 676,285 676,283 675,282 670,246ZM597,241 597,243 599,243 601,246 598,247 595,244 596,246 594,249 593,248 594,249 593,253 597,248 601,250 600,252 601,253 599,254 603,253 602,252 603,249 604,251 607,252 606,253 607,254 606,253 611,250 616,255 614,258 613,257 614,258 613,259 615,260 614,263 618,263 620,261 617,259 618,258 616,257 617,256 612,247 611,247 612,248 611,250 607,244 608,243 602,241 604,239 601,241ZM751,234 748,234 744,236 741,235 742,238 747,235 751,235ZM649,228 655,238 654,241 656,242 657,246 656,250 658,250 657,255 658,254 660,257 658,261 660,261 659,267 661,267 660,275 663,275 661,284 662,283 664,285 663,286 665,286 663,270 662,272 661,271 663,267 660,258 661,255 659,253 660,250 658,248 659,245 656,244 658,241 656,239 657,238 655,238 656,236 654,236 655,234 653,234 653,231 649,229 651,228ZM417,158 426,158 428,156 429,157 438,157 425,156ZM37,144 34,143 33,147 36,146ZM335,141 336,151 337,148 339,151 340,144 338,141ZM246,120 241,141 243,137 242,136 244,135 244,146 246,149 247,141 249,141 249,150 247,151 250,152 249,163 256,164 257,153 249,151 252,131 251,135 250,127 248,133 246,131ZM396,118 396,123 394,124 394,126 397,130ZM595,107 597,112 611,124 615,126 619,126 627,123 630,125 629,123 616,124 609,121ZM258,104 253,127 254,134 255,133 256,136 257,134 256,132 258,130 257,128 261,122 262,123 260,121 260,117 256,113ZM84,106 84,117 87,125 104,128 101,127 99,112 101,110 105,114 102,115 103,116 111,114 112,116 118,115 123,117 124,121 120,130 131,130 131,124 134,122 133,119 135,119 129,116 125,117 129,105 103,100 100,106 95,106 91,103 89,110 85,110ZM165,91 157,112 149,119 145,114 138,132 146,134 149,131 148,129 152,120 156,119 154,129 151,131 152,134 149,135 152,136 148,156 157,114ZM231,86 217,130 176,120 175,112 167,111 164,118 162,114 159,130 165,117 172,118 178,129 175,131 196,135 199,140 197,141 201,142 198,143 206,142 203,141 205,137 213,141 215,139 216,142ZM385,78 388,82 383,85 384,86 382,88 380,88 378,90 379,89 381,91 380,93 381,94 378,96 386,97 387,95 384,94 386,92 382,91 386,87 387,90 388,90 387,87 389,83ZM419,75 425,106 428,130 432,112 437,104 428,78ZM433,76 443,103 469,104 479,111 485,127 487,147 510,147 507,131 500,122 492,95 458,94 455,91 456,80 460,76 465,76 460,74ZM160,73 155,79 139,116 131,144 128,149 128,154 133,134 148,99 147,98 153,88 152,86 155,83 154,82 156,81 157,76 159,75 158,74ZM458,59 511,71 521,80 495,88 507,91 509,85 534,146 541,150 517,84 524,91 523,80 533,96 527,77 554,77 542,73 558,71 524,62ZM259,53 258,57 293,59 309,64 322,77 331,95 325,83 328,78 326,79 326,76 324,76 325,73 322,73 323,68 319,69 315,62 314,64 311,62 313,61 309,61 310,59 308,61 305,57 297,57 295,55ZM259,54 260,53 264,54 263,55ZM257,53 167,57 160,71 165,60 237,56 227,54 241,53 237,67 242,71 240,75 237,69 237,75 234,75 239,79 238,84 247,58 248,62 240,86 250,76 250,66ZM167,58 168,57 173,57 174,58 173,59 168,59ZM249,53 251,55 248,59 247,56ZM382,37 403,38 404,39 415,39 416,38 435,39 430,38ZM182,33 179,32 175,34 171,34 169,36 170,37 179,37ZM503,32 504,31 505,33 508,34 510,36 509,37 510,38 509,37 511,36 513,38 516,38 519,40 507,32 504,31ZM131,30 124,32 119,31 113,35 121,33 127,33 128,36 121,43 128,36ZM185,25 153,27 137,30 146,28 157,28 167,26ZM250,21 187,24 250,22ZM255,21 256,20 265,21 269,25 274,26 276,28 275,30 279,33 278,34 263,34 281,34 275,24 276,23 282,24 280,22 281,21 280,22 279,20 274,18 280,22 276,23 273,21 276,23 274,25 269,21 258,20 256,18Z"/><path fill="rgb(51,56,59)" fill-rule="evenodd" d="M781,440 774,446 763,450 753,449 759,451 766,450 773,447 779,442 780,443ZM63,425 66,428 65,430 66,429 67,432 69,432 72,435 76,434 77,436 82,436 83,435 85,436 87,433 89,433 89,429 90,428 91,431 93,428 93,425 84,433 75,434 69,431ZM97,419 94,423 95,426 98,423ZM633,400 635,400 636,402 645,402 647,403 646,400ZM421,399 419,399 421,400 421,403 419,405 418,404 417,408 413,412 411,411 410,412 411,415 410,414 411,413 416,413 417,414 419,412 420,406 422,404ZM57,397 59,406 62,411 63,410 69,419 74,423 72,421 73,420 72,421 69,418 70,417 69,418 66,414 67,413 66,414 63,410 60,402 60,400 62,398 58,399ZM809,395 814,395 815,396 812,397 814,398 820,398 818,397 819,396 816,395ZM286,387 297,388 298,389 294,390 295,391 306,391 301,390 306,389ZM234,384 239,382 248,382 252,385 257,384 259,386 275,385 254,383 253,382 251,383 245,381 244,382 236,382ZM202,376 204,378 209,378 210,379 211,378 221,378 226,380 231,380 232,379 237,380ZM415,373 414,374 411,371 408,372 407,371 408,372 409,371 411,373 408,376 403,375 402,372 401,375 404,377 404,379 406,376 408,377 415,374ZM375,371 376,373 374,379 375,376 376,377 377,389 379,392 382,391 383,392 383,390 382,391 377,385 377,378 376,377 377,374ZM154,370 155,371 154,372 157,371 168,371 169,372 170,371 172,373 169,374 177,374 178,373 179,374 188,374 188,373 179,374 178,373 179,372ZM89,369 87,375 91,374 91,371ZM109,368 107,375 110,376 107,379 106,386 108,388 107,389 106,388 107,392 105,394 107,394 106,393 108,390 109,392 109,390 111,388 113,369 110,373 108,370ZM110,381 111,385 108,387 107,385ZM52,368 49,371 50,384 48,385 51,388 51,394 53,398 55,410 61,421 60,423 62,423 56,410 53,399 54,392 56,393 55,394 56,395 57,393 59,397 56,387 55,373 52,371ZM457,348 452,349 451,350 452,351 450,353 449,352 451,361 453,361 453,360 450,357 450,353 451,352 452,354 455,352 457,354 458,352 457,354 456,353ZM61,346 60,348 62,350 64,358 65,357 67,358 68,354 65,355 63,353ZM389,346 387,345 388,347 386,349 385,348 379,361 382,360 384,356 384,353 388,349ZM511,343 525,344 526,345 542,345 543,344 546,345 545,343 540,345ZM84,342 84,345 82,347 81,346 82,347 78,349 77,351 72,348 75,351 78,352 77,354 79,354 78,350 79,349 82,350 84,347ZM427,338 429,340 429,342 433,345 430,339 429,340ZM49,337 47,342 48,345 47,346 46,344 47,349 46,350 47,351 45,354 45,379 46,380 46,386 45,387 46,386 46,376 45,375 47,374 45,373 46,372 45,366 46,365 47,366 46,365 46,360 48,351 47,348 49,345 48,340 50,339ZM407,334 399,337 398,336 396,339 399,339 401,337 407,337ZM556,324 554,326 553,325 550,328 544,329 537,333 539,335 540,334 543,335 541,338 535,336 543,338 542,337 544,335 545,336 546,335 545,334 553,325 554,326ZM442,319 438,323 440,321 441,323 442,321 444,324 441,325 444,326 442,327 444,329 443,330 444,329 443,325 445,322ZM428,314 431,316 436,323 438,319 437,318 438,315 437,314 435,316 436,317 435,318 437,319 435,321 432,318 433,317 432,318 430,313 429,315ZM398,313 362,348 353,409 371,459 365,424 394,468 360,391 354,409 360,356 387,319 422,322 448,372 441,449 412,479 375,464 409,484 432,470 466,390 459,356 453,375 429,327ZM372,440 373,439 376,443 375,444ZM448,425 450,426 449,430 447,428ZM367,420 370,429 369,432 367,429 366,424ZM458,385 460,384 463,387 461,388ZM459,377 461,376 462,379 460,380ZM459,375 460,376 456,380 455,377ZM455,368 456,369 455,373 454,372ZM455,368 458,366 460,367 457,370ZM391,316 392,315 396,316 393,318ZM113,312 107,316 111,320 111,330 114,330 112,348 102,317 99,323 106,326 106,330 102,330 109,339 106,347 110,349 107,356 109,350 113,358 110,362 109,359 112,367 114,356 117,357 116,364 121,363 117,357 122,359 118,354 121,347 116,346 118,341 116,337 114,341 113,331 120,336 119,331 114,330 118,325 114,329 115,322 112,327 109,323 115,318 109,316ZM115,353 116,352 119,355 116,356ZM118,348 119,349 117,353 115,351ZM114,345 117,347 116,349 115,348 114,351 113,350ZM81,311 80,312 78,311 75,315 74,313 71,317 72,316 74,317 79,313 81,313ZM97,308 99,316 98,317 95,314 98,319 100,314 101,315 98,308ZM92,299 91,300 83,293 75,292 67,296 61,304 58,302 60,304 59,306 58,305 58,312 56,313 54,318 55,319 51,325 50,323 49,328 50,326 53,326 52,324 55,317 67,298 68,300 74,294 77,295 82,293 85,298 88,296 90,301ZM745,276 744,279 745,278 747,281 746,286 748,284 747,283 748,277 746,278ZM606,252 608,254 608,257 611,256 613,258 616,254 615,255 611,251 607,253ZM747,243 748,244 745,243 741,247 742,246 746,248 745,249ZM735,237 731,239 732,241 729,246 729,249 732,248 731,243 734,240 737,241 734,238ZM607,231 604,234 602,239 598,238 597,240 601,240 603,238 605,239 604,235 606,233 607,238 608,238 607,237 608,234ZM257,158 257,164 262,163 263,164 262,166 263,166 263,164ZM650,158 644,159 643,158 645,156 642,159 635,157 636,158 635,159 629,158 624,159 623,161 619,161 616,159 623,157 616,157 614,159 611,159 612,160 609,162 601,162 614,161 612,160 613,159 615,159 617,161 628,161 639,158 640,159ZM470,156 471,157 491,157ZM458,153 458,154 460,154 462,152 467,154 469,153 487,154 483,153 469,153 467,154 462,152ZM240,150 241,151 240,152 239,162 243,163 243,158 245,157 246,158 245,163 247,163 247,157 248,156 249,157 249,162 249,154 246,151 243,151 242,153ZM242,153 243,154 243,159 242,160 243,162 240,163 239,162 240,155ZM243,154 244,151 247,152 245,155ZM330,130 331,131 330,133 331,132 332,133 332,135 335,139 333,140 334,141 338,140 339,142 340,137 339,134ZM344,127 343,131 344,136 348,139 350,144 352,141 350,143 349,142 347,133ZM667,124 673,130 672,131 678,137 679,136 681,138ZM129,108 126,117 128,115 134,117 136,113 135,112 137,111 136,109 135,110 132,108 130,109ZM157,106 158,107 156,106 154,108 149,108 148,107 146,111 147,112 145,113 146,116 149,118 151,115 153,116 154,113 157,110 156,108ZM132,98 131,100 124,98 125,95 116,96 110,94 108,92 109,91 102,100 95,98 94,99 92,97 89,100 87,98 85,99 84,98 83,110 84,105 85,109 86,108 89,109 91,102 92,104 93,103 95,105 100,105 103,99 123,104 129,104 130,106ZM255,82 243,128 246,119 247,131 248,132 250,126 251,134 253,126 252,122 253,114 249,119 248,112ZM267,72 261,90 262,93 261,94 260,93 261,98 260,99 259,97 260,102 259,103 258,101 259,104 258,108 257,105 258,108 257,113 256,110 256,112 261,117 261,121 263,120 265,121 266,119 270,120 276,98 274,85 270,81 270,77 267,76ZM318,66 327,79 326,81 325,80 325,84 327,84 326,86 328,86 327,88 329,88 328,90 329,89 329,92 331,92 330,94 332,94 331,96 334,99 333,101 335,101 334,103 337,106 336,108 338,108 337,110 339,111 338,112 342,120 342,108 340,107 341,105 338,104 339,102 337,102 338,100 336,98 338,97 335,97 337,95 335,95 333,92 335,90 332,90 333,88 326,78 328,76 326,77ZM239,66 220,125 177,113 178,102 171,99 162,112 164,117 167,110 175,111 176,119 217,129 219,124 214,160 222,161 234,100 224,159 233,161 236,123 248,78 238,81ZM235,96 237,99 236,101 234,100ZM238,81 241,84 241,86 239,87 240,90 238,91 239,93 237,94 238,95 237,98 234,93 236,92 235,90 237,89 236,87 238,85 237,84ZM351,65 352,66 355,63 358,62 359,63 365,60 352,60 354,61 352,62ZM342,59 346,66 348,67 347,70 348,69 349,70 348,72 349,71 351,74 350,76 351,75 354,81 355,79 358,85 350,67 348,66 349,65 347,61ZM355,70 398,141 385,77 460,73 456,91 492,94 513,133 510,148 486,138 511,149 489,154 557,157 527,155 556,153 528,77 533,97 518,84 541,151 512,89 494,88 519,82 462,58ZM546,140 550,149 550,151 548,153 546,150 547,148 545,143ZM511,137 512,138 512,143 513,142 516,144 517,148 516,149 512,149 510,146 510,138ZM518,126 520,130 519,131 520,133 519,134 521,136 520,137 526,142 524,147 528,149 527,150 517,148 517,141 516,140 517,139 517,127ZM385,126 386,127 385,131 384,130ZM390,112 393,116 392,118 389,117ZM394,105 395,106 394,110 393,109ZM534,97 538,105 537,107 533,101ZM377,96 379,94 382,95 382,93 381,95 379,93 381,90 386,91 387,92 385,94 388,95 386,98 383,97 382,98ZM389,82 390,84 388,87 389,89 388,91 386,90 386,88 384,91 379,88 383,86 384,88 382,85 386,82 388,83ZM500,79 502,77 505,79 504,80ZM361,78 362,74 367,73 368,74 367,75 369,76 372,72 373,73 374,72 377,73 379,72 386,76 385,77 383,76 371,77 364,79ZM424,68 430,66 435,67 437,66 440,68 439,69 425,69ZM228,54 237,55 238,56 237,57 232,57 239,57 240,58 238,56 241,55 241,54ZM511,37 511,39 516,43 514,41 515,40 520,44 523,43 522,44 520,41 518,42 517,41 518,40 516,39 513,40ZM334,37 345,38 345,40 426,40 388,39 381,37 364,38 351,36ZM129,32 127,34 121,34 116,36 115,35 111,37 110,36 111,37 106,45 111,46 110,45 111,44 116,44 117,43 120,44 126,37 127,38 128,37 127,34ZM251,22 193,23 201,24 133,30 134,33 142,33 152,30 160,31 158,29 186,29 184,28 202,26 251,27 249,26ZM275,23 278,25 277,26 281,30 280,31 282,29 285,30 289,29 291,31 282,22 280,21 282,23 280,25ZM250,20 254,21 253,26 254,34 278,33 274,30 275,28 274,27 269,26 265,22 261,21 260,22 258,21 255,22 253,20 254,19Z"/><path fill="rgb(34,38,40)" fill-rule="evenodd" d="M403,434 400,441 401,443 399,444 400,448 397,450 396,453 397,456 395,458 397,456 398,457 400,454 398,451 400,450 402,443 401,440 403,437ZM838,433 835,437 834,436 833,437 832,442 830,445 833,443 835,444 834,442 837,439 835,438 838,436ZM732,432 738,441 737,442 734,439 742,447 738,443 739,442 738,440 739,439 743,443ZM427,429 433,441 434,441 433,440 434,438 433,433 431,433ZM791,426 790,425 786,435 780,442 777,440 777,441 778,440 780,442 775,446 774,445 775,446 773,448 767,450 766,452 761,451 766,452 776,447 786,436 787,432 789,431 788,430 789,427ZM841,422 838,425 836,425 834,433 838,429 839,431 840,428 839,425 841,424ZM839,425 840,426 837,429 836,427ZM397,417 395,419 394,418 390,424 387,426 380,437 387,427ZM491,410 493,425 499,431 532,430 535,427 535,426 533,429 513,430 512,429 514,428 509,428 508,427 509,426 507,427 506,425 504,426 501,422 498,423 494,421 492,417ZM858,405 855,408 853,407 855,409 853,410 853,414 856,412 858,413 859,412 859,410 859,412 858,413 857,412 857,406ZM851,402 849,401 833,405 822,411 818,411 816,408 817,415 819,417 837,416 841,419 839,421 837,419 837,423 842,419 843,416 846,417 847,419 845,419 844,422 846,424 843,426 845,425 846,427 842,431 845,435 847,430 845,432 843,431 847,427 846,424 849,420 849,407 851,406ZM848,419 849,420 846,424 845,422ZM858,400 855,399 853,405 856,403 859,403 857,401ZM467,393 458,396 448,418 450,436 433,470 409,485 381,474 357,418 355,433 369,470 404,493 388,487 414,489 426,482 452,437 452,450 463,448 455,442 471,446 464,443 472,439 458,438 471,432 463,426 475,424 461,419 471,413 462,410 469,408 462,401ZM382,482 384,481 389,486 386,487ZM464,440 465,441 462,445 461,442ZM462,407 463,406 465,407 466,405 468,408 463,409ZM462,399 463,398 467,399 466,400ZM461,396 462,397 459,405 458,404 458,397ZM338,390 337,394 338,419ZM377,373 378,374 377,376 378,385 384,391 384,382 385,381 381,380ZM389,350 385,353 385,356 383,360 381,361 384,361 388,357 386,353ZM63,345 62,348 64,353 67,354 68,351 67,352 62,346ZM416,336 417,339 416,340 415,339 416,344 415,348 416,343 417,342 419,343 417,339 418,338 420,340 421,339 420,340ZM65,328 66,329 63,334 64,335 66,334 67,336 65,332 68,328 66,329ZM551,326 548,327 544,326 536,331 534,336 533,334 532,336 531,335 535,337 534,336 535,335 540,337 539,338 542,335 539,336 536,333 544,328ZM78,324 77,329 79,332 79,336 80,336 80,332 78,329ZM101,323 100,325 104,329 103,331 105,330 105,326 104,324 103,325ZM423,322 400,316 380,326 362,358 356,412 360,390 369,410 367,365 385,330 398,324 416,328 419,333 408,330 430,338 444,366 437,341ZM368,382 369,383 368,388 367,387ZM414,296 418,299 419,298 420,299 421,297 422,298 426,297 427,298 425,299 427,300 423,301 422,300 427,301 435,298 432,298 431,300 429,300 428,299 429,298 428,297 427,298 425,296 424,297 422,296 419,297 418,296 419,297 418,298ZM82,294 57,312 46,366 49,410 69,442 100,427 110,397 118,401 113,390 125,366 116,366 130,363 123,355 109,366 105,332 114,373 99,423 85,437 67,433 48,371 55,372 57,321 71,304 84,303 101,319ZM69,438 72,437 75,439 72,440ZM116,376 118,375 119,378 118,379ZM115,358 116,357 117,360 121,361 122,363 118,364 115,361ZM765,253 763,255 761,255 760,265 761,265 760,263 765,262 767,258 767,255ZM738,253 738,256 740,258 739,261 740,260 741,261 746,260 746,256 743,256ZM605,232 601,237 600,235 597,235 596,243 596,239 598,237 602,238 602,236ZM502,211 504,211 506,213 514,213 515,214 519,213 520,214 519,215 521,215 519,213ZM546,161 523,161 522,160 523,159 530,159 528,158 536,156 519,158 523,159 519,161ZM683,134 686,138 685,139 686,138 692,144 692,142 690,140 691,139 689,138 690,137 685,135 684,136ZM343,133 341,143 342,148 343,144 345,145 347,143 350,145 347,141 347,139 343,136ZM106,145 111,145 114,142 117,134 121,131 114,131 113,130 107,131 106,129 103,129 103,134ZM518,127 518,139 517,140 518,141 518,148 523,148 529,150 523,147 523,145 526,143 519,137 520,136 518,134 519,133 518,132 519,130ZM499,113 503,125 509,131 511,138 511,146 512,148 516,148 515,144 511,143 510,134 513,132 512,133 506,129 504,126 505,124 501,120 502,118 504,119 502,114ZM160,96 156,100 152,98 148,106 149,107 154,107 157,105 158,106 157,108 160,101 159,99 161,98ZM179,77 170,100 166,100 163,108 166,110 171,98 178,103 177,112 219,122 221,111 218,109 212,111 185,106 179,101 185,97 212,98 222,109 231,79ZM142,77 119,77 108,90 103,86 99,86 93,92 88,92 88,89 84,97 89,99 92,96 94,98 102,99 108,91 116,95 125,94 125,98 132,100 130,108 136,108 137,110 137,107 139,106 138,104 141,101 134,100 133,97ZM362,75 383,75 391,83 399,142 383,132 379,107 367,100 385,139 398,152 510,149 486,149 477,110 443,105 432,76 421,74 429,77 439,105 427,133 417,75 416,80 415,75ZM400,149 405,146 410,145 424,145 428,147 427,149 420,147 411,147 406,148 403,150ZM259,61 247,106 254,84 249,118 254,114 253,122 267,71 278,88 272,118 315,119 340,135 344,116 341,124 323,81 311,67ZM284,118 285,117 292,117 293,118 292,119 285,119ZM323,103 324,102 327,105 325,106ZM298,91 301,89 303,92 299,93ZM303,90 306,86 308,87 309,85 312,88 317,86 318,87 317,91 320,92 318,95 316,94 313,96 310,93 307,94 305,93ZM281,85 285,88 286,91 284,93 283,92 284,94 285,92 287,94 282,97 280,93 281,92 280,89ZM347,60 357,81 350,71 349,74 384,149 354,70 414,66 357,59 366,60 352,67 353,61ZM294,35 288,29 289,30 288,31 284,30 281,31 280,30 283,36 285,36 283,36 282,35 283,34 293,36Z"/><path fill="rgb(21,23,25)" fill-rule="evenodd" d="M754,451 755,453 763,453 765,451 767,452 766,451 764,452ZM763,434 761,434 763,437 761,439 761,441 764,437ZM511,433 508,433 506,436 505,432 504,436 507,439 503,438 502,449 496,463 498,466 495,466 491,473 492,475 490,476 492,477 488,479 485,484 492,482 488,481 494,479 495,477 492,476 499,470 500,471 500,466 502,466 501,465 504,461 502,460 506,457 505,456 508,452 505,452 509,449 508,447 510,445 507,445 510,441 507,439 511,439 512,436 509,436ZM501,454 502,452 506,453 503,455ZM405,432 404,437 402,440 403,441 401,450 399,451 401,454 399,456 401,455 400,452 405,442 404,437ZM838,430 835,433 834,430 831,445 821,463 818,461 826,447 822,448 822,444 819,455 808,468 811,469 806,470 800,476 804,476 818,462 817,467 805,478 811,476 823,465 834,447 833,444 836,442 832,445 830,443 832,439 837,438 832,439 837,432 839,434ZM824,451 820,453 818,452 822,449ZM833,444 834,447 832,448 831,446ZM491,431 487,430 486,433 487,436 485,438 487,439 485,440 485,444 483,450 485,451 483,453 482,452 483,454 481,455 480,458 481,460 468,483 473,484 483,467 481,465 482,464 484,465 485,463 484,461 486,460 485,457 486,456 487,457 486,456 487,454 488,455 487,452 490,448 492,439 491,437 492,433 490,432ZM495,429 498,433 495,435 495,443 492,448 493,447 494,449 491,452 491,454 494,455 490,456 484,470 485,471 482,474 483,476 481,477 483,478 479,479 480,481 473,487 475,488 469,491 472,490 473,492 481,484 478,483 483,481 482,479 486,477 486,474 489,472 489,468 494,462 497,454 496,451 499,446 499,439 501,438 500,436 497,436 501,433ZM418,428 418,431 416,432 417,433 416,435 417,439 416,441 416,447 417,448 416,452 417,449 418,454 420,456 422,453 420,452 420,446 417,439 419,431ZM389,424 386,431 383,434 382,433 383,435 379,438 385,437 383,436 388,431 390,426ZM480,419 479,432 477,432 477,430 482,437 478,440 476,436 478,443 476,445 475,443 475,449 473,450 477,449 479,451 472,454 475,454 471,457 473,456 474,458 470,459 471,462 469,463 472,465 468,465 465,476 458,483 457,489 463,485 470,475 479,454 477,453 481,448 482,441 480,440 483,437 479,434 481,431 484,435 484,432 481,431 484,429 479,426 483,422ZM826,418 824,420 818,419 825,420 825,424 816,423 816,429 812,438 817,440 811,441 809,447 815,451 808,450 805,455 811,457 804,457 800,461 803,463 797,467 803,470 795,470 793,472 799,474 799,471 802,471 814,456 820,443 821,435 823,435 822,432 824,429 822,427 825,426ZM803,463 805,462 808,464 804,465ZM816,430 817,429 822,429 823,430 822,431 817,431ZM817,428 820,425 823,428 822,429ZM840,417 838,418 837,417 838,419 836,421 836,424 838,424 841,421 838,418ZM835,417 828,417 829,420 832,418 834,419 830,423 829,422 827,427 828,426 829,428 827,429 829,430 827,432 826,431 826,432 829,431 832,426 833,427 832,424 834,422 833,418ZM426,417 429,418 424,419 426,420 427,428 431,432 433,432 430,429 431,424 429,422 430,420 428,419 429,417ZM401,414 399,417 398,416 397,418 396,417 395,418 396,419 392,423 396,423 398,421 396,419 398,417 401,417ZM492,411 494,420 498,422 501,421 504,425 505,424 507,426 509,425 510,426 509,427 514,427 515,428 513,429 533,428 534,429 533,430 535,428 534,427 535,417 530,419 521,417 520,418 519,417 512,417 511,416 510,417 507,416 504,417 493,414ZM476,412 465,411 472,413 462,419 474,419 475,428 458,439 470,437 465,443 472,446 454,448 457,453 451,450 452,438 443,464 422,486 402,490 383,482 390,490 373,478 389,494 427,495 423,492 432,493 443,483 452,487 442,481 455,483 462,473ZM405,494 408,492 412,493 409,495ZM393,491 396,490 405,493 404,494 398,494 394,493ZM427,485 429,483 432,484 430,486ZM446,476 447,475 449,476 448,474 451,473 453,477 458,479 457,480 449,479ZM451,470 456,469 461,471 459,473 454,472ZM452,463 454,461 457,462 463,461 464,462 463,465 455,463 453,464ZM456,454 457,453 465,454 467,456 464,459 461,457 463,456 459,456ZM450,453 453,451 455,454 451,455ZM469,436 473,435 474,437 471,438ZM770,409 614,414 586,437 605,437 620,428 613,427 620,419 633,421 617,435 626,430 656,431 677,416 717,415 700,432 739,426 731,434 734,438 733,432 753,428ZM719,425 721,423 727,423 726,422 727,421 729,423 734,423 735,424 727,426 720,426ZM656,422 657,421 660,422 661,420 664,422 660,425ZM647,422 651,420 654,420 656,423 655,424 650,423 649,424ZM756,415 752,420 749,421 746,424 743,423 745,422 744,420 740,421 737,424 734,421 729,421 728,420 732,418 745,418 749,415 754,414ZM677,412 678,413 677,415 674,417 673,416 674,414ZM719,410 720,413 717,415 716,413ZM858,404 853,406 858,406 858,412 852,414 852,436 846,439 842,434 849,423 845,418 845,430 839,440 842,442 835,449 841,447 845,438 848,442 844,445 849,446 843,448 839,456 838,451 834,451 832,460 816,475 824,473 818,479 829,473 846,453 857,424 852,416 856,413 858,419ZM837,455 838,457 835,462 824,473 823,472 824,470 829,466 830,463 832,462 832,460ZM846,423 848,425 847,428 843,425ZM836,404 816,406 818,410 826,409 827,407 829,407 833,404ZM468,402 468,407 470,408 469,409 474,409 471,406 473,403ZM429,403 430,405 431,404 435,406 436,408 437,407 443,409 440,407 436,407 435,406 436,404 434,402 433,403 431,402 430,404ZM79,402 76,407 75,404 73,414 74,415 73,414 76,412 77,413 76,410ZM75,407 76,408 75,412 74,411ZM89,394 88,396 88,412 90,413 91,410 89,406ZM331,393 331,392 326,392 325,391 328,390 317,393 316,392 309,392 315,392 316,393 325,392 328,394ZM94,381 95,382 94,384 96,386 95,390 99,393 100,396 101,395 97,389 99,384 96,383 97,381 96,382ZM73,380 74,381 68,387 69,389 68,390 67,389 68,391 65,392 64,397 65,394 73,386 71,385 74,381ZM379,375 381,377 380,378 381,379 386,380 381,375 380,376ZM386,365 391,369 390,370 396,375 397,379 399,380 397,379 396,377 397,375 388,365ZM169,368 335,389 330,383 197,365ZM174,367 177,366 184,368 183,369 176,369ZM130,364 120,365 126,366 117,376 121,376 121,386 114,390 119,401 115,403 111,397 106,414 110,416 106,423 105,417 103,429 84,442 66,438 70,447 71,442 76,448 76,444 79,448 93,447 92,442 96,446 103,439 100,435 104,437 104,431 114,422 113,414 125,411 115,407 126,407 127,402 117,399 127,399 121,393 115,396 114,391 128,392 121,390 120,384 125,383 126,376 121,375ZM99,430 101,433 97,436 96,434ZM177,360 176,361 169,360 156,366 148,366 157,366 158,365 161,367ZM432,355 433,360 430,363 429,362 430,363 428,364 429,366 427,367 428,368 425,371 426,370 427,372 423,377 423,381 428,382 430,381 428,382 425,377 428,372 427,370 430,368 431,363 434,359ZM122,361 128,361 130,360 129,359 130,357 128,355 126,356 125,355 124,358 126,359ZM399,347 401,348 402,358 405,362 405,367 407,368 407,370 408,369 407,364 403,357 403,352 402,351 404,346ZM644,341 648,342 649,341 650,342 675,342ZM422,340 421,341 423,343 422,344 417,343 415,349 415,359 414,360 415,370 414,360 416,355 415,350 418,343 419,344 423,343ZM459,337 454,338 458,344 457,345 459,345 458,344 459,342 457,341ZM123,330 120,332 121,336 120,337 123,339 123,344 126,344 127,347 126,348 124,346 120,345 118,346 122,346 123,350 127,352 121,354 128,352 129,353 130,350 128,349 129,346 125,341 126,339 120,337 123,336 122,334ZM98,327 95,335 95,337 95,335 96,334 97,335 97,338 95,341 94,339 93,344 96,342 99,333 97,332ZM543,326 538,326 535,331 534,329 533,331 534,335 535,331ZM416,329 409,326 404,327 403,325 398,325 385,331 377,340 378,345 368,365 370,367 370,371 368,371 368,380 370,383 370,371 372,371 378,351 381,351 380,349 386,339 398,331 412,329 411,332 415,330 415,332 419,332 420,335 421,334ZM386,336 388,334 391,335 388,337ZM447,324 451,328 450,329 454,331 453,334 457,335 456,330 451,330 450,329 453,328 451,325 454,323ZM89,317 87,318 87,324 85,327 87,329 87,331 85,333 85,338 87,343 89,341 88,340 89,339 86,337 86,334 89,330 89,328 87,327 90,319ZM116,316 118,318 115,321 116,320 119,323 120,328 119,329 122,328 119,326 121,324 120,323 121,321 116,320 119,319 121,316 119,317 118,316 119,315ZM802,315 710,316 709,356 782,357 770,356 800,355ZM722,325 725,323 727,329 730,324 745,322 749,326 747,334 750,339 753,331 760,339 761,333 767,333 763,333 762,330 757,333 751,332 749,325 753,321 756,324 767,322 768,325 772,321 786,322 789,330 781,332 785,336 785,342 781,347 774,347 772,344 769,347 758,348 754,345 752,348 746,348 742,343 741,348 737,344 729,348 728,333 722,331ZM108,307 111,304 114,306 115,308 114,309 116,309 117,305 112,305 111,304ZM86,305 76,303 71,305 66,311 64,310 65,313 60,321 58,321 59,325 55,335 55,356 57,355 56,347 58,347 57,342 59,341 59,333 61,333 60,330 63,324 61,323 63,319 64,321 66,318 67,319 66,317 78,307 86,306 90,309ZM108,299 110,299 111,302 116,303 115,302 116,301 114,300 115,299ZM430,295 433,296 429,299 432,300 430,302 428,301 433,303 433,305 437,302 440,306 435,306 437,307 435,308 437,312 440,310 436,309 439,307 443,309 448,307 450,309 444,311 441,315 450,314 450,317 446,317 446,321 453,321 451,314 445,313 449,310 452,311 450,310 451,308 444,307 448,304 443,304 442,307 439,304 441,300 447,302 446,300 441,300 446,296ZM435,301 437,299 440,301 439,302ZM431,298 435,297 436,300 434,301 433,300 434,299 432,300ZM434,296 435,295 439,296 438,297ZM115,295 113,293 112,295 110,294 107,295 107,296 111,295 112,296 111,297 114,297ZM706,284 706,286 703,289 702,286 702,291 701,292 704,292ZM94,279 96,280 94,282 98,285 99,284 105,284 106,285 101,287 105,288 103,290 105,293 106,292 111,292 112,291 110,289 111,287 114,290 112,288 114,285 113,286 111,283 112,282 110,281 111,279 110,277 109,280 108,279 103,279 102,281 101,280 100,281 97,277 98,278 97,279 95,278ZM107,287 108,284 112,286 110,288ZM106,282 109,281 110,283 108,284ZM96,283 100,281 103,282 101,284ZM748,254 746,254 748,255 746,261 743,262 740,261 745,266 748,265 747,264ZM585,245 581,250 580,249 581,252 583,250 584,251 587,248 585,247 586,246ZM586,228 591,229 592,228 597,234 600,234 601,236 604,232 597,233 596,232 600,229ZM727,225 706,226 707,227 712,227 714,229 713,228 714,227 723,227 722,226 723,225ZM665,225 665,227 679,227 680,226 681,227 680,226 666,226ZM551,225 552,227 556,229 554,230 556,230 558,226 552,226ZM541,226 541,228 545,229 545,235 546,232 547,233 547,238 547,227 545,225 547,227 545,229 544,227 543,228ZM514,225 515,226 514,227 515,226 517,229 515,230 517,229 521,231 521,226 520,225 519,226 518,224 517,226ZM515,218 512,219 511,223 509,224 511,224ZM487,215 494,217 497,216 498,218 500,218 502,220 501,219 503,218 504,220 504,218 502,218 501,216 498,217 494,215 491,216 489,214ZM516,214 521,213 527,216 533,215 533,217 547,217 546,219 551,218 590,225 595,224 596,226 609,227 610,229 608,223 603,226 601,224 593,224 592,221 586,224 586,222 548,218 540,214 539,217 537,215 529,216 530,214 528,213 526,215 523,213ZM335,169 341,170 342,171 341,175 344,176 345,169 342,168ZM344,148 342,149 341,148 340,159 338,163 339,162 340,163 339,162 342,156 341,154 343,153 342,152 346,149ZM154,135 156,138 154,144 155,151 153,151 153,149 154,155 158,156 153,157 191,160 200,159 205,161 212,161 211,159 214,147 213,146 158,138ZM190,158 191,157 195,158 194,159ZM183,158 184,157 189,157 190,158 189,159 184,159ZM168,157 169,156 174,156 175,157 174,158 169,158ZM137,133 138,134 132,151 132,155 127,156 145,156 148,157 145,156 147,155 150,136 146,135 140,136 139,135 140,134ZM86,128 88,129 87,132 93,148 92,150 95,153 98,152 99,154 115,154 112,155 121,154 121,150 123,150 123,144 125,144 124,142 126,141 125,139 128,135 125,133 127,132 120,132 117,136 119,134 119,138 117,140 116,139 111,146 106,146 102,134 102,129 91,129 90,128 92,127ZM180,101 181,104 190,106 197,106 202,108 206,107 209,109 211,108 212,110 215,109 218,110 219,109 220,111 217,102 212,99 185,98 181,99ZM304,90 305,92 307,93 310,92 312,94 309,95 312,94 314,95 316,93 318,94 319,92 316,91 318,89 319,90 317,87 318,86 315,88 314,87 315,88 314,89 310,88 309,86 308,88 306,87ZM280,85 282,90 281,93 282,96 286,94 284,92 285,91 284,88ZM359,83 388,152 394,157 397,156 396,158 399,159 422,155 400,154 387,143 375,121ZM172,63 168,64 150,101 152,97 156,99 160,95 161,97 164,88 163,87 165,86 164,84 166,83 165,81 167,80 166,79 168,74 169,75 168,74 170,72 169,70 170,69 171,70 170,69 172,67 171,65 172,64 173,65ZM237,60 180,62 166,99 169,100 179,76 231,78 231,76 233,76 232,73 234,73 234,68 236,68ZM162,57 136,58 135,60 128,59 106,64 87,90 93,91 99,85 106,86 107,90 119,76 142,76 144,78 134,99 141,100 146,85ZM511,43 504,35 487,28 405,29 409,30 370,33 476,34 481,40 480,38 485,36 490,39 483,40ZM505,40 504,41 495,41 494,40 501,38ZM506,37 509,39 507,42 505,38ZM441,33 442,32 446,33 447,32 450,34 449,35 443,35Z"/><path fill="rgb(3,4,6)" fill-rule="evenodd" d="M408,431 406,431 405,433 406,434 405,437 406,442 401,452 402,454 404,453 408,454ZM419,425 417,427 420,429 418,439 421,446 421,452 423,453 421,455 423,453 425,454 424,455 427,453ZM648,422 649,423 650,422 655,423 656,421 660,424 663,422 662,421 660,423 656,421 655,422 654,421ZM632,420 620,420 614,427 620,427 621,428 611,431 608,435 616,435 615,434 629,424ZM402,416 401,418 397,419 399,421 396,424 391,424 389,431 384,436 390,436 389,435 391,434 393,436 394,440 395,440 396,436 404,422ZM755,415 749,416 745,419 732,419 729,420 734,420 737,423 740,420 744,419 746,422 741,425 752,419ZM426,412 427,413 425,416 429,416 430,417 429,419 431,420 430,422 429,421 432,424 432,428 431,429 430,428 438,436 436,438 437,438 441,423ZM373,409 385,411 386,412 386,418 393,412 393,410 391,409 384,409 383,410ZM651,403 679,402 682,400 655,400ZM401,400 399,403 400,402 401,403 401,407 403,408 404,406 401,404 401,402 403,400ZM687,402 717,401 719,399 692,399ZM767,397 764,398 746,398 743,400 764,400ZM801,396 776,397 773,399 789,399 790,398 798,398ZM331,397 332,398 331,407 334,407 336,409 336,396ZM82,391 81,400 77,412 73,415 77,412 79,412 79,410 81,409ZM89,388 90,391 89,393 90,394 90,406 92,412 94,411ZM442,386 441,388 436,391 433,391 429,393 430,395 432,395 434,397 435,400 432,402 434,401 437,404 434,407 431,405 434,407 440,406 443,408ZM386,381 385,396 393,398 394,399 393,400 398,397 397,396 398,390 389,382ZM389,493 483,491 506,439 490,407 536,417 506,435 576,440 614,413 769,407 749,431 619,435 706,431 744,480 809,482 853,401 807,477 837,418 798,469 815,406 844,401 488,407 467,378 458,481ZM443,488 446,487 448,490 446,491ZM482,488 483,485 487,486 484,487 483,489ZM470,485 471,487 468,490 467,488ZM469,484 470,485 468,487 466,487 465,490 464,486 466,484ZM444,484 445,483 446,484 453,483 455,485 452,488 449,488 445,486ZM484,484 486,481 491,482 486,485ZM482,484 475,491 470,490 472,488 474,488 472,487 476,484 477,481 479,481 480,482 479,483ZM478,479 482,478 484,481 481,483ZM817,477 811,480 810,479 814,475ZM790,475 791,474 796,474 797,476 795,477ZM811,470 809,473 805,474 806,475 802,478 799,476 806,469ZM792,472 795,469 801,469 802,470 800,471 801,473 799,475ZM735,441 736,440 741,445 739,446ZM497,433 499,435 496,438 500,435 502,437 500,439 501,441 499,450 497,451 498,454 496,456 497,457 495,459 493,466 490,468 491,469 490,472 487,474 488,475 485,479 483,479 482,478 485,476 483,477 481,474 484,471 483,470 488,461 489,456 494,454 491,455 490,452 493,449 491,448 492,444 494,443 493,442 494,435ZM492,431 489,434 491,432 493,433 492,437 493,439 491,448 489,451 489,455 486,458 487,459 486,463 473,485 467,483 472,476 479,461 484,444 486,430 487,429ZM482,426 483,430 481,432 484,431 485,435 479,457 477,459 475,458 478,460 467,481 462,487 459,487 461,488 459,490 457,490 455,487 460,479 464,476 463,474 465,473 464,472 467,465 471,465 468,463 470,457 473,457 471,454 472,450 474,449 473,447 475,436 477,434 477,427ZM480,418 484,422 482,424 480,423 481,425 479,427 478,426 478,419ZM598,418 599,417 605,417 606,418 605,419 599,419ZM606,414 607,413 611,414 608,416ZM579,412 581,414 579,417 577,415ZM795,406 796,414 788,435 780,445 770,452 763,454 748,452 744,449 750,450 741,445 731,433 734,431 743,442 752,447 764,448 761,446 772,445 775,443 765,444 761,442 760,434 772,435 774,439 777,439 777,435 787,429 794,411 791,406ZM96,377 98,380 97,383 100,384 98,389 102,395 101,397 103,391 103,384ZM82,376 80,376 77,380 72,384 71,383 70,384 71,383 74,386 63,398 72,395 73,397 74,393 80,383 79,378 80,377 81,378ZM193,373 239,380 232,381 250,380 332,392 329,394 336,394 336,391ZM73,371 63,375 66,377 68,375 70,377 69,379 73,374 72,373ZM433,355 435,359 432,363 431,368 428,370 429,372 426,377 427,380 431,381 427,384 430,383 440,375 436,361ZM104,354 104,356 102,358 99,358 98,361 100,361 102,363 103,366 100,368 102,368 105,372 105,356ZM391,353 389,359 386,360 387,361 390,360 392,361 392,363 389,365 398,375 397,376 398,379 400,379 401,377 395,366ZM66,348 70,351 69,352 69,362 68,363 73,364 75,363 77,358 73,353ZM420,339 419,341 423,344 422,345 418,344 416,350 417,355 415,360 415,365 417,372 419,370 420,371 427,349 427,347 419,340ZM423,356 424,359 422,363 420,361 420,358ZM408,338 407,341 404,340 402,342 400,342 401,345 406,345 407,346 404,349 402,348 404,349 403,350 404,357 408,364 408,368ZM865,343 864,337 804,340 804,347 864,344 804,350 801,357 708,359 706,340 609,341 600,355 790,358 847,354 848,348 854,353ZM641,353 643,354 642,358 640,357ZM678,352 679,357 677,358 676,356ZM609,352 610,355 608,357 605,354ZM818,349 819,353 817,355 816,351ZM602,348 604,346 614,348 701,350 696,352 638,352 604,350ZM643,344 644,348 642,349 641,346ZM679,343 680,344 679,349 678,348ZM819,341 820,345 818,346 817,343ZM850,340 851,342 849,345 848,341ZM889,333 889,336 886,339 881,341 879,340 879,336 880,341 880,362 882,365 884,365 885,362 884,364 883,363 883,360 885,356 887,339 889,336ZM410,331 398,332 392,336 388,335 387,336 391,336 384,343 383,341 381,344 383,342 384,343 383,347 379,351 379,354 376,358 373,367 371,381 375,362 384,345 394,335 400,332ZM99,329 98,331 100,333 97,342 93,345 95,348 98,347 99,349 103,345ZM563,322 513,323 514,319 525,319 511,322 510,372 515,348 542,346 511,345 511,339 526,339 513,338 511,325 529,323 532,335 528,338 537,340 530,337 538,325 554,323 552,327ZM890,318 885,319 887,322 887,330 885,332 887,332 888,330 888,319ZM77,318 79,319 76,320 81,321 79,323 81,331 81,338 81,316ZM90,314 89,316 91,319 90,323 88,325 90,330 87,334 87,337 90,340 90,336 94,323 94,319 89,315ZM64,441 116,452 145,440 166,387 130,383 129,368 191,372 168,368 197,364 335,388 321,378 193,361 148,367 120,313 131,367 121,384 129,392 119,392 128,400 118,399 127,405 116,407 126,411 113,413 96,447ZM133,421 135,424 134,425 131,423ZM120,416 121,417 119,420 117,418ZM123,415 124,418 122,421 121,417ZM137,406 139,407 138,411 136,410ZM128,406 131,405 133,408 131,410 129,410ZM131,398 134,400 131,404 129,402ZM136,384 138,385 138,391 137,392 135,389ZM136,358 137,360 135,361 136,362 133,365 132,364 132,359ZM85,308 78,308 75,310 73,309 66,316 67,318 64,322 63,320 62,323 63,322 64,323 63,326 68,316 74,310 78,308ZM444,297 446,298 441,304 436,303 428,310 439,303 449,304 445,306 446,310 435,315 447,310 446,306 450,307 451,310 446,313 451,313 454,321 446,324 452,323 454,328 447,331 457,330 458,335 450,338 459,338 460,345 454,347 461,347 459,349 462,353 457,355 462,356 463,362 458,364 464,364 465,370 461,372 465,372 455,321ZM444,300 446,299 448,302 447,303ZM112,279 111,281 113,282 114,289 113,290 108,285 108,287 110,287 113,291 111,293 106,293 104,295 110,293 112,294 113,292 115,293 116,296 114,298 108,298 106,300 108,298 115,298 117,303 111,305 117,304 118,305 116,307 117,306 118,308 111,312 113,310 117,310 118,312 119,307ZM831,274 830,290 828,292 826,291 824,292 838,292 838,291 835,290 836,285 835,285 834,290 833,285 833,289 832,290 831,289ZM420,270 377,262 367,266 356,284 341,350 340,347 339,413 343,431 355,431 354,367 372,321 386,306 405,296 445,295ZM75,241 63,240 53,245 57,244 45,262 37,291 34,379 44,386 43,362 48,324 62,293 72,283 85,277 111,277 98,252ZM566,230 567,229 568,230 572,227 577,227 578,228 579,227 584,231 585,230 588,231 585,228 580,228 579,227 578,228 577,227 570,227 568,230 567,229ZM831,226 830,227 838,240 839,251 838,243 841,243 842,286 840,291 843,291 845,273 845,242 842,237 835,231 836,230ZM796,227 805,244 807,292 822,292 818,241 811,226 803,228 810,238 813,253 815,285 812,291 808,242 801,228ZM806,229 808,230 813,238 815,245 817,270 818,271 818,285 817,286 815,284 815,266 814,265 814,256 812,249 812,243 805,230ZM754,226 766,238 761,229 766,231 774,248 768,229 775,239 779,285 775,261 773,293 785,293 782,243 774,230 777,226 786,230 793,250 795,287 788,293 803,292 797,240 789,227 794,226ZM784,226 788,226 791,229 797,241 801,279 799,292 797,291 798,278 798,288 797,291 795,291 795,266 792,242 788,233 783,227ZM706,227 715,245 718,294 737,293 740,272 749,277 748,292 743,293 761,293 756,292 757,276 763,273 764,293 771,293 771,268 747,274 734,267 726,253 731,234 725,229 736,226 742,233 740,226 745,233 743,226 749,233 745,227 751,226 714,228 724,249 728,284 724,292 720,245 712,228ZM755,276 756,277 756,289 754,293 753,292 754,288 753,277ZM752,276 753,277 753,287 751,293 750,292 750,277ZM729,265 732,275 732,287 731,288 729,283 729,271 728,270ZM719,229 726,239 725,244 720,233 718,231ZM664,227 671,237 674,246 680,286 678,294 696,294 696,268 691,241 683,229 683,226 679,228ZM678,229 685,239 689,256 691,279 692,280 692,286 690,293 689,292 689,277 688,276 686,256 682,239 677,231ZM671,228 673,228 676,231 682,242 688,281 688,288 686,293 684,292 685,288 684,276 679,245 675,235 670,229ZM813,227 818,226 825,236 819,227 823,226 829,234 824,227 828,226 828,225 822,225 821,226 818,225ZM689,225 687,226 692,226 700,237 707,286 705,292 700,294 715,294 712,292 707,241 700,229 706,239 712,286 708,293 703,247 694,228 695,226 699,231 696,227 704,226ZM710,287 711,288 710,293 709,292ZM641,225 636,243 644,263 638,235 657,293 653,259 641,230 643,226 650,226 660,243 666,292 660,294 676,294 672,293 665,239 657,227 662,226ZM653,226 656,226 659,229 665,240 672,280 672,292 670,294 670,287 669,293 667,293 666,273 661,245 656,233 652,228ZM593,222 593,223 606,224 599,222ZM526,220 516,219 520,220 515,227 514,226 515,229 515,227 518,223 519,225 520,224 521,225 523,223 524,224 523,226 524,225 523,222ZM544,215 544,216 548,217 544,218 556,217 563,219 591,222 591,221 589,222 584,220 577,220 576,219ZM507,204 634,219 834,218 627,218ZM16,193 26,195 25,198 26,205 24,207 19,207 18,206 17,207 22,209 21,210 24,209 29,211 29,203 27,200 25,192 24,193ZM43,163 38,164 35,166 29,180ZM625,162 688,163 689,164 693,162 670,160 664,161 662,158 647,157 650,157 651,158 650,160ZM525,160 609,160 576,159 574,156 547,155 558,155 559,156 557,159 549,158ZM413,160 486,161 503,159 470,158 468,155 457,155 454,158ZM30,153 30,154 36,154 39,156 44,156 45,157 46,154 42,151 40,153 37,151 36,153ZM353,181 353,161 349,149 343,152 351,155 344,155 339,163 352,165 350,180 345,180 340,175 341,171 334,169 338,168 316,170 334,166 262,161 267,161 269,168 310,172 314,169 313,175 316,172ZM53,131 48,134 49,135 45,144 46,148 49,137ZM84,122 89,144 91,149 94,151 89,143 86,132 87,129 85,128 89,127 86,127 84,125ZM589,65 594,65 631,96 677,141 695,164 700,164 641,101 599,67ZM174,61 166,63 154,87 137,129 129,155 131,155 137,130 153,91 167,64 172,62 172,66ZM301,63 257,59 244,109 235,163 238,159 246,104 258,60ZM239,58 178,61 159,115 150,157 161,110 178,63 218,59 238,61ZM347,59 411,56 486,57 407,56ZM174,55 165,56 142,104 124,155 151,84 164,58 167,55ZM408,30 342,33 401,34 369,33 371,31ZM251,28 213,28 133,35 122,44 138,41 149,33 183,30 185,32 182,37 189,37 188,34 192,30Z"/></svg>`;
  	  }

  	  function aliasNumber(l, paths) { for (let i=0;i<paths.length;i+=1){ if(has(l,paths[i])){ const v=num(l[paths[i]],null); if(v!==null)return v; } } return null; }
  	  function aliasBool(l, paths) { for (let i=0;i<paths.length;i+=1){ if(has(l,paths[i])){ const v=bool(l[paths[i]]); if(v!==null)return v; } } return null; }
  	  function aliasSupported(l, paths) { return paths.some(function(p){return has(l,p);}); }

  	  function identity(tractor) {
  	    return {
  	      registration: clean(first([tractor && tractor.Registration,tractor && tractor.FID,tractor && tractor.ID,get(tractor,"Data.Vehicle.Identity.Registration.value","")],"Vehicle")),
  	      make: clean(first([get(tractor,"Data.Vehicle.Make.value",""),get(tractor,"Data.Vehicle.Make","")],"")),
  	      model: clean(first([get(tractor,"Data.Vehicle.Model.value",""),get(tractor,"Data.Vehicle.Model","")],"")),
  	      year: clean(first([get(tractor,"Data.Vehicle.Year.value",""),get(tractor,"Data.Vehicle.Year","")],"")),
  	      vin: clean(first([get(tractor,"Data.Vehicle.VIN.value",""),get(tractor,"Data.Vehicle.VIN","")],"N/A")),
  	      status: clean(first([get(tractor,"Data.Vehicle.Status.value",""),tractor && tractor.Status],"Active")),
  	      fuelGrade: clean(first([get(tractor,"Data.FuelAndEnergy.FuelGrade.value",""),get(tractor,"Data.Vehicle.Fuel_Type.value","")],""))
  	    };
  	  }

  	  function sourceBadge(source,title) { const s=clean(source,"NO SIGNAL").toUpperCase(); return '<span class="source-badge '+esc(s.replace(/[^A-Z]/g,""))+'" title="'+esc(title||s)+'">'+esc(s)+'</span>'; }

  	  function doorState(l) {
  	    const fields=[["FL","can.front.left.door.status"],["FR","can.front.right.door.status"],["RL","can.rear.left.door.status"],["RR","can.rear.right.door.status"],["BONNET","can.hood.status"],["BOOT","can.trunk.status"],["ROOF","can.roof.opened.status"]];
  	    const supported=fields.some(function(x){return has(l,x[1]);})||has(l,"door.open.status");
  	    const open=fields.filter(function(x){return bool(l[x[1]])===true;}).map(function(x){return x[0];});
  	    if(!supported)return {supported:false,open:[],label:"N/A",status:"No CAN signal"};
  	    if(!open.length&&bool(l["door.open.status"])===true)return {supported:true,open:["Door"],label:"Open",status:"Door Open"};
  	    return open.length?{supported:true,open:open,label:open.length+" Open",status:open.join(" · ")}:{supported:true,open:[],label:"All Closed",status:"All Closed"};
  	  }
  	  function doorGraphic(state) {
  	    const open=state.open||[],is=function(k){return open.indexOf(k)!==-1;};
  	    return `<svg class="door-car" viewBox="0 0 68 78" aria-hidden="true">
  	      <defs><linearGradient id="fifDoorBody" x1="0" x2="1"><stop offset="0" stop-color="#69828d"/><stop offset=".5" stop-color="#c9d9df"/><stop offset="1" stop-color="#5d7681"/></linearGradient></defs>
  	      <path d="M22 7h24l8 15v37l-9 12H23L14 59V22Z" fill="url(#fifDoorBody)" fill-opacity=".13" stroke="currentColor" stroke-width="2"/>
  	      <path d="M24 17h20l5 10v22l-5 9H24l-5-9V27Z" fill="#06141b" stroke="#637d88" stroke-width="1.2"/>
  	      <path d="M24 18v39M44 18v39M19 37h30" stroke="#47616c" stroke-width="1"/>
  	      <path d="M25 7V3h18v4M24 71h20" stroke="#708b96" stroke-width="1.5"/>
  	      <path d="M14 28H8v18h6M54 28h6v18h-6" stroke="#718b96" stroke-width="2"/>
  	      ${is('FL')?'<path d="M14 28 3 20v23" stroke="#ff5a66" stroke-width="2.7" filter="drop-shadow(0 0 3px #ff5a66)"/>':''}
  	      ${is('FR')?'<path d="M54 28 65 20v23" stroke="#ff5a66" stroke-width="2.7" filter="drop-shadow(0 0 3px #ff5a66)"/>':''}
  	      ${is('RL')?'<path d="M14 46 3 56V35" stroke="#ff5a66" stroke-width="2.7" filter="drop-shadow(0 0 3px #ff5a66)"/>':''}
  	      ${is('RR')?'<path d="M54 46 65 56V35" stroke="#ff5a66" stroke-width="2.7" filter="drop-shadow(0 0 3px #ff5a66)"/>':''}
  	      ${is('BONNET')?'<path d="M22 7 34 0 46 7" stroke="#ff5a66" stroke-width="2.7"/>':''}
  	      ${is('BOOT')?'<path d="M23 71 34 78 45 71" stroke="#ff5a66" stroke-width="2.7"/>':''}
  	      <circle cx="34" cy="37" r="2.2" fill="currentColor" fill-opacity=".55"/>
  	    </svg>`;
  	  }

  	  function lightsState(l) {
  	    const paths=["can.low.beam.status","can.high.beam.status","can.lights.hazard.lights.status","can.front.fog.lights.status","can.rear.fog.lights.status","can.parking.lights.status"];
  	    if(!aliasSupported(l,paths))return {supported:false,label:"N/A",status:"No CAN signal"};
  	    const active=[]; if(bool(l["can.low.beam.status"]))active.push("Low Beam"); if(bool(l["can.high.beam.status"]))active.push("High Beam"); if(bool(l["can.lights.hazard.lights.status"]))active.push("Hazards"); if(bool(l["can.front.fog.lights.status"]))active.push("Front Fog"); if(bool(l["can.rear.fog.lights.status"]))active.push("Rear Fog"); if(bool(l["can.parking.lights.status"]))active.push("Parking");
  	    return {supported:true,label:active.length?active[0]:"Off",status:active.length?active.join(" · "):"Lights Off"};
  	  }
  	  function turnState(l) {
  	    const leftPaths=["can.left.turn.signal.status","can.turn.signal.left.status","can.left.indicator.status","can.turn.left.status"],rightPaths=["can.right.turn.signal.status","can.turn.signal.right.status","can.right.indicator.status","can.turn.right.status"];
  	    const supported=aliasSupported(l,leftPaths.concat(rightPaths)); if(!supported)return {supported:false,left:false,right:false,label:"N/A",status:"No CAN signal"};
  	    const left=aliasBool(l,leftPaths)===true,right=aliasBool(l,rightPaths)===true; return {supported:true,left:left,right:right,label:left&&right?"Hazards":left?"Left":right?"Right":"Off",status:left&&right?"Hazards On":left?"Left Indicator":right?"Right Indicator":"Indicators Off"};
  	  }
  	  function gearStatus(l) { if(!["can.drive.gear.status","can.neutral.gear.status","can.reverse.gear.status"].some(function(p){return has(l,p);}))return "—"; if(bool(l["can.reverse.gear.status"]))return "R"; if(bool(l["can.neutral.gear.status"]))return "N"; if(bool(l["can.drive.gear.status"]))return "D"; return "—"; }

  	  function configurationConflicts(tractor,t) {
  	    const rows=[]; const add=function(code,title,detail){rows.push({code:code,title:title,detail:detail});};
  	    if(t.canTank!==null&&t.vehicleTank!==null&&Math.abs(t.canTank-t.vehicleTank)>1)add("CFG-TANK","Fuel tank capacity mismatch","CAN is configured for "+fmt(t.canTank,0)+" L while Vehicle Master is "+fmt(t.vehicleTank,0)+" L.");
  	    if(!t.hoursVehicle&&t.mileageDelta!==null&&Math.abs(t.mileageDelta)>50)add("CFG-ODO","Odometer reconciliation required","Live CAN odometer differs from the configured vehicle reading by "+fmt(t.mileageDelta,1)+" km.");
  	    const gh=num(get(tractor,"CAN.RPMGH",null),null),gl=num(get(tractor,"CAN.RPMGL",null),null); if(gh!==null&&gl!==null&&gl>gh)add("CFG-GREEN","Green Band limits appear inverted","RPMGL is "+fmt(gl,0)+" rpm while RPMGH is "+fmt(gh,0)+" rpm. The configured rule expects low ≤ high.");
  	    const primaryReg=clean(first([tractor&&tractor.Registration,tractor&&tractor.FID,get(tractor,"Data.Vehicle.Identity.Registration.value","")],"")),secondaryReg=clean(descriptor(get(tractor,"Data.Vehicle.Registration",null)),""); if(primaryReg&&secondaryReg&&primaryReg.replace(/\s+/g,"").toLowerCase()!==secondaryReg.replace(/\s+/g,"").toLowerCase())add("CFG-REG","Vehicle registration mismatch","Fleet identity is "+primaryReg+" while Data.Vehicle.Registration is "+secondaryReg+".");
  	    const licenceSetup=clean(get(tractor,"Data.Compliance.Setup.Requirements.VehicleLicence.ExpiryDate",""),""),licenceLegacy=clean(descriptor(get(tractor,"Data.Compliance.License_Expiry_Date",null)),""); if(licenceSetup&&licenceLegacy&&licenceSetup!==licenceLegacy)add("CFG-LIC","Licence expiry mismatch","Vehicle Licence requirement is "+licenceSetup+" while the legacy licence field is "+licenceLegacy+".");
  	    if(t.ignition===true&&t.charging===false&&t.externalVoltage!==null&&t.externalVoltage>=26)add("SIG-ALT","Charging signal disagreement","CAN says the alternator is not charging, but external power is "+fmt(t.externalVoltage,2)+" V.");
  	    if(t.rpm!==null&&t.rpm>300&&t.engineOn===true&&has(t.location,"can.engine.working.status")&&bool(t.location["can.engine.working.status"])===false)add("SIG-ENGINE","Engine-state signal disagreement","RPM is "+fmt(t.rpm,0)+" and FIF engine state is ON, but can.engine.working.status is false.");
  	    if(t.speed!==null&&t.speed>3&&["D","N","R"].indexOf(gearStatus(t.location))===-1)add("SIG-GEAR","Transmission state unavailable","Vehicle is moving at "+fmt(t.speed,0)+" km/h but no Drive, Neutral or Reverse CAN state is active.");
  	    if(t.stale)add("DATA-STALE","Telemetry is stale","Latest tracker message is "+relativeAge(t.timestamp)+".");
  	    return rows;
  	  }

  	  function cardShell(title,main,bottom,level,source,sourceTitle) { const c=level?" "+level:"",b=level?" "+level:""; return '<div class="card'+c+'"><div class="card-title">'+esc(title)+'</div><div class="card-main">'+main+'</div><div class="card-bottom'+b+'">'+esc(bottom||"")+'</div>'+sourceBadge(source||"NO SIGNAL",sourceTitle)+'</div>'; }
  	  function naCard(title,iconName) { return cardShell(title,iconSvg(iconName)+'<div class="metric-value">N/A</div>',"No CAN signal","muted","NO SIGNAL"); }
  	  function valueCard2(title,iconName,value,unit,bottom,level,small,source,sourceTitle) { return cardShell(title,iconSvg(iconName,level==="bad"?"red":level==="warn"?"amber":"")+'<div class="'+(small?'metric-small':'metric-value')+'">'+esc(value)+(unit?'<span class="metric-unit">'+esc(unit)+'</span>':'')+'</div>',bottom,level,source,sourceTitle); }
  	  function dialSvg(value,min,max,color,labels) {
  	    const v=num(value,null),pct=v===null?0:clamp((v-min)/(max-min),0,1),cx=64,cy=59,r=42;
  	    const start=-142,end=142,angle=start+pct*(end-start),rad=angle*Math.PI/180,nx=cx+Math.cos(rad)*31,ny=cy+Math.sin(rad)*31;
  	    const ticks=[];
  	    for(let i=0;i<=14;i+=1){
  	      const a=(start+(end-start)*(i/14))*Math.PI/180,major=i%7===0||i===7,r1=major?31:34,r2=42;
  	      const x1=cx+Math.cos(a)*r1,y1=cy+Math.sin(a)*r1,x2=cx+Math.cos(a)*r2,y2=cy+Math.sin(a)*r2;
  	      ticks.push('<line x1="'+x1.toFixed(1)+'" y1="'+y1.toFixed(1)+'" x2="'+x2.toFixed(1)+'" y2="'+y2.toFixed(1)+'" stroke="'+(major?'#9bb0b9':'#45616d')+'" stroke-opacity="'+(major?'.9':'.66')+'" stroke-width="'+(major?'1.4':'.7')+'"/>');
  	    }
  	    const labs=labels||[];
  	    return `<svg class="dial" viewBox="0 0 128 84" aria-hidden="true">
  	      <defs>
  	        <radialGradient id="fifGaugeFace" cx="50%" cy="58%" r="60%"><stop offset="0" stop-color="#12303d" stop-opacity=".34"/><stop offset=".72" stop-color="#081923" stop-opacity=".12"/><stop offset="1" stop-color="#02090d" stop-opacity="0"/></radialGradient>
  	        <filter id="fifNeedleGlow" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="1.1" result="g"/><feMerge><feMergeNode in="g"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
  	      </defs>
  	      <circle cx="64" cy="58" r="47" fill="url(#fifGaugeFace)" stroke="#173845" stroke-width="1"/>
  	      <path class="gauge-ring" d="M24 61 A42 42 0 1 1 104 61" fill="none" stroke="#142d38" stroke-width="9" stroke-linecap="round"/>
  	      <path d="M24 61 A42 42 0 0 1 40 27" fill="none" stroke="#5ed76e" stroke-width="4.6" stroke-linecap="round"/>
  	      <path d="M40 27 A42 42 0 0 1 88 27" fill="none" stroke="#ffc34a" stroke-width="4.6" stroke-linecap="round"/>
  	      <path d="M88 27 A42 42 0 0 1 104 61" fill="none" stroke="#ff5a66" stroke-width="4.6" stroke-linecap="round"/>
  	      <path d="M29 61 A36 36 0 1 1 99 61" fill="none" stroke="#34505b" stroke-opacity=".38" stroke-width="1"/>
  	      ${ticks.join('')}
  	      ${labs.map(function(x){return '<text x="'+x[0]+'" y="'+x[1]+'">'+x[2]+'</text>';}).join('')}
  	      <circle class="hub-outer" cx="64" cy="59" r="8.2"/>
  	      <circle cx="64" cy="59" r="5.4" fill="#07141b" stroke="#71909c" stroke-opacity=".6"/>
  	      <line class="needle" x1="64" y1="59" x2="${nx.toFixed(1)}" y2="${ny.toFixed(1)}" stroke="${color||'#edf7fa'}" stroke-width="2.9" stroke-linecap="round" filter="url(#fifNeedleGlow)"/>
  	      <circle class="hub-inner" cx="64" cy="59" r="2.8"/>
  	      <circle cx="64" cy="59" r="12" fill="none" stroke="#6e9bab" stroke-opacity=".12"/>
  	    </svg>`;
  	  }

  	  function fuelGaugeSvg(percent) {
  	    const p=clamp(num(percent,0),0,100),cx=64,cy=59,start=-142,end=142,a=(start+(end-start)*(p/100))*Math.PI/180,nx=cx+Math.cos(a)*31,ny=cy+Math.sin(a)*31;
  	    const ticks=[];
  	    for(let i=0;i<=14;i+=1){const rr=(start+(end-start)*(i/14))*Math.PI/180,major=i===0||i===7||i===14,x1=cx+Math.cos(rr)*(major?31:34),y1=cy+Math.sin(rr)*(major?31:34),x2=cx+Math.cos(rr)*42,y2=cy+Math.sin(rr)*42;ticks.push('<line x1="'+x1.toFixed(1)+'" y1="'+y1.toFixed(1)+'" x2="'+x2.toFixed(1)+'" y2="'+y2.toFixed(1)+'" stroke="'+(major?'#91a7b0':'#4b6671')+'" stroke-width="'+(major?'1.4':'.75')+'"/>');}
  	    return `<svg class="dial fuel-dial" viewBox="0 0 128 84" aria-hidden="true">
  	      <defs><radialGradient id="fifFuelFace" cx="50%" cy="58%" r="60%"><stop offset="0" stop-color="#183541" stop-opacity=".28"/><stop offset="1" stop-color="#041018" stop-opacity="0"/></radialGradient><filter id="fifFuelNeedleGlow" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="1.1" result="g"/><feMerge><feMergeNode in="g"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
  	      <circle cx="64" cy="58" r="47" fill="url(#fifFuelFace)" stroke="#173845" stroke-width="1"/>
  	      <path d="M24 61 A42 42 0 1 1 104 61" fill="none" stroke="#142d38" stroke-width="9" stroke-linecap="round"/>
  	      <path d="M24 61 A42 42 0 0 1 39 29" fill="none" stroke="#ff5965" stroke-width="4.7" stroke-linecap="round"/>
  	      <path d="M39 29 A42 42 0 0 1 55 20" fill="none" stroke="#ffc247" stroke-width="4.7" stroke-linecap="round"/>
  	      <path d="M55 20 A42 42 0 0 1 104 61" fill="none" stroke="#61dc70" stroke-width="4.7" stroke-linecap="round"/>
  	      ${ticks.join('')}
  	      <text x="18" y="70">E</text><text x="106" y="70" text-anchor="end">F</text>
  	      <g transform="translate(55 34)" opacity=".72"><rect x="0" y="0" width="18" height="22" rx="2" fill="currentColor" fill-opacity=".08" stroke="currentColor"/><rect x="4" y="4" width="10" height="6" rx="1" fill="currentColor" fill-opacity=".18"/><path d="M18 6h4l4 5v9" fill="none" stroke="currentColor"/></g>
  	      <circle class="hub-outer" cx="64" cy="59" r="8.2"/>
  	      <line class="needle" x1="64" y1="59" x2="${nx.toFixed(1)}" y2="${ny.toFixed(1)}" stroke="#edf8fa" stroke-width="2.9" stroke-linecap="round" filter="url(#fifFuelNeedleGlow)"/>
  	      <circle class="hub-inner" cx="64" cy="59" r="2.8"/>
  	    </svg>`;
  	  }

  	  function dialCard(title,value,unit,min,max,bottom,level,labels,source) { const main=dialSvg(value,min,max,level==="bad"?"#ff5757":"#d8e4e8",labels)+'<div class="dial-value">'+(value===null?'—':esc(fmt(value,0)))+' <span class="dial-unit">'+esc(unit)+'</span></div>'; return cardShell(title,main,bottom,level,source); }
  	  function turnGraphic(s) { const arrow=function(dir,on){return `<svg class="turn-arrow${on?' on':''}" viewBox="0 0 38 28" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M${dir==='L'?'17 5 5 14l12 9V17h15':'21 5 33 14l-12 9V17H6'}"/></svg>`;}; return '<div class="turn-wrap">'+arrow('L',s.left)+arrow('R',s.right)+'</div><div class="metric-small">'+esc(s.label)+'</div>'; }

  	  function fuelLevelCard(t) {
  	    if(t.fuelPct===null)return naCard("Fuel Level","fuel"); const p=clamp(t.fuelPct,0,100),level=p<=10?"bad":p<=25?"warn":"";
  	    const detail=[]; if(t.fuelLitres!==null)detail.push(fmt(t.fuelLitres,1)+" L"); if(t.estimatedRange!==null)detail.push("≈ "+fmt(t.estimatedRange,0)+" km range"); if(t.canTank!==null&&t.vehicleTank!==null&&Math.abs(t.canTank-t.vehicleTank)>1)detail.push("capacity conflict");
  	    const main=fuelGaugeSvg(p)+'<div class="dial-value">'+fmt(p,0)+' <span class="dial-unit">%</span></div>';
  	    return cardShell("Fuel Level",main,detail.join(" · "),level,t.fuelPctSource,t.fuelPctPath);
  	  }

  	  function telemetryCards(tractor,t) {
  	    const l=t.location,id=identity(tractor),cards=[];
  	    const fuelBottom=[]; if(t.trackerFuelConsumed!==null&&t.canFuelConsumed!==null)fuelBottom.push("Tracker "+fmt(t.trackerFuelConsumed,1)+" L"); if(!fuelBottom.length)fuelBottom.push("Lifetime total");
  	    cards.push(t.fuelConsumed!==null?valueCard2("Total Fuel Consumption","fuel",fmt(t.fuelConsumed,1),"L",fuelBottom.join(" · "),"",false,t.fuelConsumedSource):naCard("Total Fuel Consumption","fuel"));
  	    cards.push(fuelLevelCard(t));
  	    if(t.hoursVehicle){cards.push(valueCard2("Vehicle Hobbs Meter","road",t.hourReading===null?"—":fmt(t.hourReading,1),"h",t.counterType,"",false,"CONFIG"));}
  	    else { const delta=t.mileageDelta!==null&&Math.abs(t.mileageDelta)>50?"Office "+fmt(t.configuredReading,0)+" km · Δ "+fmt(t.mileageDelta,1):"CAN odometer"; cards.push(valueCard2("Vehicle Mileage","road",t.mileage===null?"—":fmt(t.mileage,1),"km",delta,t.mileageDelta!==null&&Math.abs(t.mileageDelta)>50?"warn":"",false,t.mileageSource)); }
  	    const doors=doorState(l); cards.push(cardShell("Door Status",doorGraphic(doors)+'<div class="metric-value">'+esc(doors.label)+'</div>',doors.status,doors.open.length?"bad":doors.supported?"":"muted",doors.supported?"CAN":"NO SIGNAL"));
  	    const rpmLimit=num(get(tractor,"CAN.RPM",null),null),rpmMax=Math.max(3000,num(get(tractor,"CAN.RPMGL",null),0),num(get(tractor,"CAN.RPMGH",null),0),rpmLimit||0),rpmBad=t.rpm!==null&&rpmLimit!==null&&t.rpm>rpmLimit; const greenLow=num(get(tractor,"CAN.RPMGL",null),null),greenHigh=num(get(tractor,"CAN.RPMGH",null),null),greenOk=t.rpm!==null&&greenLow!==null&&greenHigh!==null&&greenLow<=greenHigh&&t.rpm>=greenLow&&t.rpm<=greenHigh; cards.push(t.rpm===null?naCard("Engine Speed (RPM)","engine"):dialCard("Engine Speed (RPM)",t.rpm,"RPM",0,rpmMax,rpmBad?"Above "+fmt(rpmLimit,0)+" rpm":greenOk?"Green band":"Normal",rpmBad?"bad":greenOk?"":"",[[20,65,"0"],[51,19,"2"],[94,65,"4"]],t.rpmSource));

  	    const oilPressure=aliasNumber(l,["can.engine.oil.pressure","can.oil.pressure","engine.oil.pressure"]),oilWarn=aliasBool(l,["can.oil.pressure.indicator.status"]); if(oilPressure!==null)cards.push(valueCard2("Oil Pressure","oil",fmt(oilPressure,0),"kPa",oilWarn?"Warning":"Normal",oilWarn?"bad":"",false,"CAN")); else if(oilWarn!==null)cards.push(valueCard2("Oil Pressure","oil",oilWarn?"LOW":"OK","",oilWarn?"Pressure Warning":"Normal",oilWarn?"bad":"",false,"CAN")); else cards.push(naCard("Oil Pressure","oil"));
  	    const oilLevel=aliasNumber(l,["can.engine.oil.level","can.oil.level","engine.oil.level"]),oilLow=aliasBool(l,["can.oil.level.low.indicator.status","can.engine.oil.level.low.status"]); if(oilLevel!==null)cards.push(valueCard2("Oil Level","oilLevel",fmt(oilLevel,0),"%",oilLow?"Low":"Normal",oilLow?"bad":"",false,"CAN")); else if(oilLow!==null)cards.push(valueCard2("Oil Level","oilLevel",oilLow?"LOW":"Normal","",oilLow?"Low":"Normal",oilLow?"bad":"",false,"CAN")); else cards.push(naCard("Oil Level","oilLevel"));
  	    const tempLimit=num(get(tractor,"CAN.Temp",null),null),tempBad=t.temp!==null&&tempLimit!==null&&t.temp>tempLimit; cards.push(t.temp===null?naCard("Engine Coolant Temperature","thermo"):dialCard("Engine Coolant Temperature",t.temp,"°C",40,Math.max(125,(tempLimit||100)+20),tempBad?"High · Limit "+fmt(tempLimit,0)+"°C":"Limit "+fmt(tempLimit||100,0)+"°C",tempBad?"bad":"",[[21,65,"50"],[52,20,"90"],[91,65,"130"]],t.tempSource));
  	    const speedLimit=num(get(tractor,"CAN.Speed",null),null),speedMax=Math.max(140,(speedLimit||0)*1.2),speedBad=t.speed!==null&&speedLimit!==null&&t.speed>speedLimit; cards.push(t.speed===null?naCard("Vehicle Speed","road"):dialCard("Vehicle Speed",t.speed,"km/h",0,speedMax,speedBad?"Above "+fmt(speedLimit,0)+" km/h":"Limit "+fmt(speedLimit||0,0)+" km/h",speedBad?"bad":"",[[19,65,"0"],[51,19,"70"],[91,65,"140"]],t.speedSource));
  	    cards.push(t.throttle===null?naCard("Accelerator Pedal Position","pedal"):valueCard2("Accelerator Pedal Position","pedal",fmt(t.throttle,0),"%",bool(l["can.pedal.brake.status"])?"Brake pedal active":"","",false,"CAN"));

  	    cards.push(valueCard2("VIN","vin",id.vin||"N/A","",id.vin&&id.vin!=="N/A"?"Vehicle master":"Not captured",id.vin&&id.vin!=="N/A"?"":"warn",true,"CONFIG"));
  	    const lights=lightsState(l); cards.push(lights.supported?valueCard2("Lights Status","light",lights.label,"",lights.status,"",false,"CAN"):naCard("Lights Status","light"));
  	    const turn=turnState(l); cards.push(cardShell("Turn Signal",turnGraphic(turn),turn.status,turn.supported?(turn.left||turn.right?"warn":""):"muted",turn.supported?"CAN":"NO SIGNAL"));
  	    const cng=aliasNumber(l,["can.cng.level","can.cng.level.percent","cng.level"]),cngStatus=aliasBool(l,["can.cng.status"]); if(cng!==null)cards.push(valueCard2("CNG Level","cng",fmt(cng,0),"%","","",false,"CAN")); else if(cngStatus===true)cards.push(valueCard2("CNG Level","cng","Active","","Level unavailable","warn",false,"CAN")); else cards.push(cardShell("CNG Level",iconSvg("cng")+'<div class="metric-value">N/A</div>',id.fuelGrade.toLowerCase().indexOf("cng")!==-1?"No level signal":"Not fitted / inactive","muted",cngStatus===false?"CAN":"NO SIGNAL"));
  	    const adblue=aliasNumber(l,["can.adblue.level","can.adblue.level.percent","can.urea.level","can.scr.urea.level","adblue.level"]); cards.push(adblue===null?naCard("AdBlue Level","adblue"):valueCard2("AdBlue Level","adblue",fmt(adblue,0),"%","","",false,"CAN"));

  	    const web=aliasBool(l,["can.webasto.status"]); cards.push(web===null?naCard("Webasto","heat"):valueCard2("Webasto","heat",web?"ON":"Off","",web?"Active":"Off","",false,"CAN"));
  	    cards.push(t.rpm===null?naCard("Simple Tacho","engine"):dialCard("Simple Tacho",t.rpm,"RPM",0,rpmMax,greenOk?"Green Band":"",greenOk?"":"",[[20,65,"0"],[52,19,"2"],[94,65,"4"]],t.rpmSource));
  	    const seat=aliasBool(l,["can.driver.seatbelt.indicator.status"]); cards.push(seat===null?naCard("Seat Belt Status","seatbelt"):valueCard2("Seat Belt Status","seatbelt",seat?"Unbuckled":"Buckled","",seat?"Driver: Unbuckled":"Driver: Buckled",seat?"bad":"",false,"CAN"));
  	    const check=aliasBool(l,["can.check.engine.indicator.status"]); cards.push(check===null?naCard("Check Engine","engine"):valueCard2("Check Engine","engine",check?"ON":"OFF","",check?"Fault indicator active":"OK",check?"bad":"",false,"CAN"));
  	    const tyre=aliasBool(l,["can.tire.pressure.low.status"]); cards.push(tyre===null?naCard("Low Tire Pressure","tire"):valueCard2("Low Tire Pressure","tire",tyre?"LOW":"OK","",tyre?"Pressure warning":"OK",tyre?"bad":"",false,"CAN"));
  	    return cards.join("");
  	  }

  	  function warningLampsHtml(t) {
  	    const l=t.location,defs=[
  	      ["ABS","can.abs.failure.indicator.status","bad"],["ESP","can.esp.indicator.status","bad"],["EPS","can.eps.indicator.status","bad"],["AIRBAG","can.airbag.indicator.status","bad"],["BAT","can.battery.indicator.status","bad"],["CEL","can.check.engine.indicator.status","bad"],["COOLANT","can.coolant.level.low.indicator.status","bad"],["GLOW","can.glow.plug.indicator.status","warn"],["SERVICE","can.maintenance.required.status","warn"],["OIL","can.oil.pressure.indicator.status","bad"],["BRAKES","can.wear.brake.pads.indicator.status","warn"],["TPMS","can.tire.pressure.low.status","warn"],["STOP","can.stop.indicator.status","bad"],["WARN","can.warning.indicator.status","warn"],["CHARGE","can.vehicle.battery.charging.status","charging"]
  	    ];
  	    return '<div class="lamp-strip">'+defs.map(function(d){if(!has(l,d[1]))return '<span class="lamp">'+esc(d[0])+'</span>'; const v=bool(l[d[1]]),active=d[2]==="charging"?(t.ignition===true&&v===false):v===true; return '<span class="lamp '+(active?(d[2]==="warn"?'warn':'on'):'ok')+'">'+esc(d[0])+'</span>';}).join('')+'</div>';
  	  }

  	  function diagnostics(tractor,t) {
  	    const l=t.location,rows=[]; const add=function(code,description,status,level,evidence){rows.push({code:code,description:description,status:status||"Active",level:level||"active",evidence:evidence||""});};
  	    if(aliasBool(l,["can.check.engine.indicator.status"])===true)add("CAN-CEL","Check engine indicator active","Active","active","CAN check-engine bit is ON.");
  	    if(aliasBool(l,["can.abs.failure.indicator.status"])===true)add("CAN-ABS","ABS failure indicator active","Active","active","ABS failure bit is ON.");
  	    if(aliasBool(l,["can.esp.indicator.status","can.eps.indicator.status"])===true)add("CAN-ESP","ESP / EPS fault indicator active","Active","active","ESP/EPS warning signal is active.");
  	    if(aliasBool(l,["can.coolant.level.low.indicator.status"])===true)add("CAN-CLT","Engine coolant level low","Active","active","Coolant low indicator is ON.");
  	    if(aliasBool(l,["can.oil.pressure.indicator.status"])===true)add("CAN-OIL","Oil pressure warning","Active","active","Oil-pressure warning bit is ON.");
  	    if(aliasBool(l,["can.tire.pressure.low.status"])===true)add("CAN-TPMS","Low tyre pressure warning","Active","active","TPMS low-pressure bit is ON.");
  	    if(aliasBool(l,["can.maintenance.required.status"])===true)add("CAN-SVC","Maintenance required","Active","active","CAN maintenance-required signal is ON.");
  	    if(aliasBool(l,["can.warning.indicator.status"])===true)add("CAN-WARN","General warning indicator","Active","active","General warning bit is ON.");
  	    if(aliasBool(l,["can.wear.brake.pads.indicator.status"])===true)add("CAN-BRAKE","Brake pad wear warning","Active","active","Brake-pad wear bit is ON.");
  	    if(t.ignition===true&&has(l,"can.vehicle.battery.charging.status")&&t.charging===false)add("CAN-ALT","Alternator not charging",t.externalVoltage!==null&&t.externalVoltage>=26?"Signal conflict":"Warning","warning","Ignition ON · charging bit OFF"+(t.externalVoltage!==null?" · supply "+fmt(t.externalVoltage,2)+" V":""));
  	    const limits=[["LIMIT-RPM","Engine RPM above configured limit",t.rpm,num(get(tractor,"CAN.RPM",null),null)," RPM"],["LIMIT-TEMP","Engine coolant temperature above limit",t.temp,num(get(tractor,"CAN.Temp",null),null)," °C"],["LIMIT-SPD","Vehicle speed above configured limit",t.speed,num(get(tractor,"CAN.Speed",null),null)," km/h"]];
  	    limits.forEach(function(x){if(x[2]!==null&&x[3]!==null&&x[2]>x[3])add(x[0],x[1],"High","warning","Actual "+fmt(x[2],0)+x[4]+" · Limit "+fmt(x[3],0)+x[4]);});
  	    const lowFuel=num(get(tractor,"CAN.LowFuel",null),null); if(t.fuelPct!==null&&lowFuel!==null&&t.fuelPct<=lowFuel)add("LIMIT-FUEL","Fuel level below configured threshold","Warning","warning","Fuel "+fmt(t.fuelPct,0)+"% · Threshold "+fmt(lowFuel,0)+"%");
  	    const voltageLimit=num(get(tractor,"CAN.Voltage",null),null); if(t.externalVoltage!==null&&voltageLimit!==null&&t.externalVoltage<voltageLimit)add("LIMIT-VOLT","External power voltage below configured threshold","Warning","warning","Supply "+fmt(t.externalVoltage,2)+" V · Threshold "+fmt(voltageLimit,2)+" V");
  	    if(t.gnssValid===false)add("GNSS-POS","Position invalid","Warning","warning","GNSS position.valid is false."); const hdopLimit=num(get(tractor,"CAN.PoorHdop",null),null); if(t.hdop!==null&&hdopLimit!==null&&t.hdop>hdopLimit)add("GNSS-HDOP","Poor GNSS quality","Warning","warning","HDOP "+fmt(t.hdop,1)+" · Limit "+fmt(hdopLimit,1));
  	    if(t.hasCan===false)add("DATA-CAN","CAN telemetry unavailable","Offline","active","fif.has.can is false.");
  	    configurationConflicts(tractor,t).forEach(function(c){add(c.code,c.title,"Review","config",c.detail);});
  	    const stored=clean(first([get(tractor,"Data.Service.Diagnostics.Last_Fault_Code.value",""),get(tractor,"Data.Service.Diagnostics.Last_Fault_Code","")],"")); if(stored)add(stored,"Stored diagnostic fault","Stored","active","Vehicle Service Diagnostics field.");
  	    return rows;
  	  }
  	  function diagMini(rows) { if(!rows.length)return '<div class="diag-empty">No active diagnostic warnings.</div>'; return '<div class="diag-head"><span>Code</span><span>Description</span><span>Status</span></div>'+rows.slice(0,3).map(function(r){return '<div class="diag-row '+esc(r.level)+'"><span class="diag-code">'+esc(r.code)+'</span><span>'+esc(r.description)+'</span><span class="diag-status">'+esc(r.status)+'</span></div>';}).join(''); }

  	  function summaryHtml(tractor,t) {
  	    const gear=gearStatus(t.location),odo=t.hoursVehicle?(t.hourReading===null?"—":fmt(t.hourReading,1)+" h"):(t.mileage===null?"—":fmt(t.mileage,1)+" km"),can=t.freshness;
  	    return '<div class="sum-row"><span>Ignition Status</span><strong class="'+(t.ignition?'good':'')+'">'+(t.ignition===true?'ON':t.ignition===false?'OFF':'—')+'</strong></div>'+
  	      '<div class="sum-row"><span>Power Voltage</span><strong>'+(t.externalVoltage===null?'—':fmt(t.externalVoltage,1)+' V')+'</strong></div>'+
  	      '<div class="sum-row"><span>Transmission</span><strong>'+esc(gear)+'</strong></div>'+
  	      '<div class="sum-row"><span>'+esc(t.hoursVehicle?'Hobbs Meter':'Odometer')+'</span><strong>'+esc(odo)+'</strong></div>'+
  	      '<div class="sum-row"><span>Motion State</span><strong>'+esc(t.motion||'—')+'</strong></div>'+
  	      '<div class="sum-row"><span>CANbus Status</span><strong class="'+(can==='LIVE'?'good':can==='DELAYED'?'warn':'bad')+'">'+esc(can)+'</strong></div>';
  	  }
  	  function signalBars(signal) { const s=num(signal,0),bars=s>=75?4:s>=50?3:s>=25?2:s>0?1:0; return '<span class="signal-bars">'+[1,2,3,4].map(function(i){return '<i class="'+(i<=bars?'on':'')+'"></i>';}).join('')+'</span>'; }
  	  function sparkPathFixed(values,w,h,min,max,pad) { const pts=[],span=Math.max(.0001,max-min),count=Math.max(1,values.length-1); values.forEach(function(v,i){if(v===null||!Number.isFinite(v))return; const x=pad+(w-pad*2)*(i/count),y=h-pad-((clamp(v,min,max)-min)/span)*(h-pad*2);pts.push((pts.length?'L ':'M ')+x.toFixed(1)+' '+y.toFixed(1));}); return pts.join(' '); }
  	  function sourceHtml(t,samples) {
  	    const conn=t.freshness,cls=conn==='LIVE'?'good':conn==='DELAYED'?'warn':'bad',vals=samples.signal||[],p=sparkPathFixed(vals,270,42,0,100,2);
  	    const last=vals.length?vals[vals.length-1]:null;
  	    const fillPath=p? p+' L 268 40 L 2 40 Z':'';
  	    return '<div class="summary">'+
  	      '<div class="sum-row"><span>CANbus Adapter</span><strong>'+esc(t.codecId?'Codec '+t.codecId:'CAN')+'</strong></div>'+
  	      '<div class="sum-row"><span>Device</span><strong>'+esc(t.deviceId||'—')+'</strong></div>'+
  	      '<div class="sum-row"><span>Connection</span><strong class="'+cls+'">'+esc(conn)+'</strong></div>'+
  	      '<div class="sum-row"><span>GSM Signal</span><strong>'+esc(t.signal===null?'—':fmt(t.signal,0))+'</strong></div>'+
  	      '<div class="sum-row"><span>GNSS</span><strong class="'+(t.gnssValid===false?'bad':'good')+'">'+esc(t.satellites===null?'—':fmt(t.satellites,0)+' sats · HDOP '+fmt(t.hdop,1))+'</strong></div></div>'+
  	      '<div class="source-wave"><svg viewBox="0 0 270 42" preserveAspectRatio="none"><defs><linearGradient id="fifSignalFill" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#38c7b7" stop-opacity=".22"/><stop offset="1" stop-color="#38c7b7" stop-opacity="0"/></linearGradient></defs><line x1="0" y1="12" x2="270" y2="12"/><line x1="0" y1="24" x2="270" y2="24"/><line x1="0" y1="36" x2="270" y2="36"/>'+(fillPath?'<path d="'+esc(fillPath)+'" fill="url(#fifSignalFill)" stroke="none"/>':'')+'<path d="'+esc(p)+'"/></svg></div>';
  	  }


  	  function fmtClock(ms) { try{return new Date(ms).toLocaleTimeString('en-ZA',{hour:'2-digit',minute:'2-digit',hour12:false});}catch(_){return '';} }
  	  function fmtDuration(seconds) { const s=Math.max(0,num(seconds,0)),h=Math.floor(s/3600),m=Math.floor((s%3600)/60); return h? h+'h '+m+'m' : m+'m'; }
  	  function trendColor(lineClass){return lineClass==='rpm-line'?'#70d65d':lineClass==='temp-line'?'#ff5e5e':lineClass==='speed-line'?'#4db7ee':'#e2c13a';}
  	  function trendSeries(values,w,h,min,max) {
  	    const left=30,right=8,top=8,bottom=18,plotW=w-left-right,plotH=h-top-bottom,span=Math.max(.0001,max-min),valid=[];
  	    values.forEach(function(v,i){if(v===null||!Number.isFinite(v))return;const x=left+plotW*(values.length<=1?1:i/(values.length-1)),y=top+(1-(clamp(v,min,max)-min)/span)*plotH;valid.push({x:x,y:y,v:v,i:i});});
  	    if(!valid.length)return {line:'',area:'',last:null,left:left,right:right,top:top,bottom:bottom,plotW:plotW,plotH:plotH};
  	    let line='M '+valid[0].x.toFixed(1)+' '+valid[0].y.toFixed(1);
  	    if(valid.length===2){line+=' L '+valid[1].x.toFixed(1)+' '+valid[1].y.toFixed(1);} else if(valid.length>2){for(let i=1;i<valid.length-1;i+=1){const p=valid[i],n=valid[i+1],mx=(p.x+n.x)/2,my=(p.y+n.y)/2;line+=' Q '+p.x.toFixed(1)+' '+p.y.toFixed(1)+' '+mx.toFixed(1)+' '+my.toFixed(1);}const last=valid[valid.length-1];line+=' T '+last.x.toFixed(1)+' '+last.y.toFixed(1);}
  	    const base=(top+plotH).toFixed(1),area=line+' L '+valid[valid.length-1].x.toFixed(1)+' '+base+' L '+valid[0].x.toFixed(1)+' '+base+' Z';
  	    return {line:line,area:area,last:valid[valid.length-1],left:left,right:right,top:top,bottom:bottom,plotW:plotW,plotH:plotH};
  	  }
  	  function trendCard(title,value,unit,values,times,min,max,lineClass,labels,threshold,thresholdLabel,ceilingSource) {
  	    const w=300,h=116,series=trendSeries(values,w,h,min,max),color=trendColor(lineClass),grad='fifTrend'+title.replace(/[^a-z0-9]/gi,'')+lineClass.replace(/[^a-z0-9]/gi,''),valid=values.filter(function(v){return v!==null&&Number.isFinite(v);}),minV=valid.length?Math.min.apply(null,valid):null,maxV=valid.length?Math.max.apply(null,valid):null,avgV=valid.length?valid.reduce(function(a,b){return a+b;},0)/valid.length:null;
  	    const firstTime=times.length?(labels&&labels[0]?labels[0]:fmtClock(times[0])):'',midIndex=Math.max(0,Math.floor((times.length-1)/2)),midTime=times.length?(labels&&labels[midIndex]?labels[midIndex]:fmtClock(times[midIndex])):'',lastTime=times.length?(labels&&labels[labels.length-1]?labels[labels.length-1]:fmtClock(times[times.length-1])):'';
  	    const grid=[0,.25,.5,.75,1].map(function(r){const y=series.top+series.plotH*r,val=max-(max-min)*r;return '<line class="gridline" x1="'+series.left+'" y1="'+y.toFixed(1)+'" x2="'+(w-series.right)+'" y2="'+y.toFixed(1)+'"/><text class="axis-text" x="2" y="'+(y+2).toFixed(1)+'">'+esc(fmt(val,unit==='h'?1:0))+'</text>';}).join('');
  	    const vgrid=[0,.25,.5,.75,1].map(function(r){const x=series.left+series.plotW*r;return '<line class="vgrid" x1="'+x.toFixed(1)+'" y1="'+series.top+'" x2="'+x.toFixed(1)+'" y2="'+(series.top+series.plotH)+'"/>';}).join('');

  	    let zoneSvg='';
  	    const isFuel=/fuel/i.test(title);
  	    if(threshold!==null&&Number.isFinite(threshold)&&threshold>=min&&threshold<=max){
  	      const y=series.top+(1-(threshold-min)/(max-min))*series.plotH;
  	      if(isFuel){
  	        zoneSvg='<rect class="trend-zone-danger" x="'+series.left+'" y="'+y.toFixed(1)+'" width="'+series.plotW.toFixed(1)+'" height="'+((series.top+series.plotH)-y).toFixed(1)+'"/>';
  	      } else {
  	        const stripH=Math.min(10,series.plotH*.12);
  	        zoneSvg='<rect class="trend-zone-danger" x="'+series.left+'" y="'+series.top+'" width="'+series.plotW.toFixed(1)+'" height="'+stripH.toFixed(1)+'"/>';
  	      }
  	    }

  	    let thresholdSvg=''; if(threshold!==null&&Number.isFinite(threshold)&&threshold>=min&&threshold<=max){const y=series.top+(1-(threshold-min)/(max-min))*series.plotH;thresholdSvg='<line class="trend-threshold" x1="'+series.left+'" y1="'+y.toFixed(1)+'" x2="'+(w-series.right)+'" y2="'+y.toFixed(1)+'"/><text class="threshold-text" x="'+(w-series.right-2)+'" y="'+Math.max(7,y-2).toFixed(1)+'" text-anchor="end">'+esc(thresholdLabel||('Limit '+fmt(threshold,0)))+'</text>';}
  	    const overMax=maxV!==null&&maxV>max,overNow=value!==null&&Number.isFinite(value)&&value>max;
  	    let overSvg='';
  	    if(overMax){const overAmount=maxV-max;overSvg='<line class="trend-over-cap" x1="'+series.left+'" y1="'+series.top+'" x2="'+(w-series.right)+'" y2="'+series.top+'"/><text class="trend-over-text" x="'+(w-series.right-2)+'" y="'+(series.top+8)+'" text-anchor="end">PEAK +'+esc(fmt(overAmount,unit==='h'?1:0))+' '+esc(unit||'')+'</text>';}

  	    const sampleDots=[];
  	    const span=Math.max(.0001,max-min),plotCount=Math.max(1,values.length-1);
  	    values.forEach(function(v,i){
  	      if(v===null||!Number.isFinite(v))return;
  	      if(i!==values.length-1 && i%Math.max(1,Math.floor(values.length/8))!==0)return;
  	      const x=series.left+series.plotW*(values.length<=1?1:i/plotCount),y=series.top+(1-(clamp(v,min,max)-min)/span)*series.plotH;
  	      sampleDots.push('<circle class="sample-dot" cx="'+x.toFixed(1)+'" cy="'+y.toFixed(1)+'" r="1.45" fill="'+color+'"/>');
  	    });

  	    const dot=series.last?'<circle class="trend-dot" cx="'+series.last.x.toFixed(1)+'" cy="'+series.last.y.toFixed(1)+'" r="3.5" fill="'+(overNow?'#ff6161':color)+'"/><circle cx="'+series.last.x.toFixed(1)+'" cy="'+series.last.y.toFixed(1)+'" r="7.2" fill="none" stroke="'+(overNow?'#ff6161':color)+'" stroke-opacity=".15"/>':'';
  	    const sourceChip=ceilingSource?'<span class="trend-limit-chip'+(overNow?' over':'')+'">'+(overNow?'OVER LIMIT · ':'')+esc(ceilingSource)+' '+esc(fmt(max,unit==='h'?1:0))+(unit?' '+esc(unit):'')+'</span>':'';
  	    const liveRail=labels?'':'<div class="trend-current-rail"></div><i class="trend-live-dot" style="color:'+color+';background:'+color+'"></i>';

  	    return `<div class="trend">${liveRail}<div class="trend-head"><span>${esc(title)}${sourceChip}</span><strong>${value===null?'—':esc(fmt(value,unit==='h'?1:0))}${unit?' '+esc(unit):''}</strong><div class="trend-stats"><span>MIN <b>${minV===null?'—':esc(fmt(minV,unit==='h'?1:0))}</b></span><span>AVG <b>${avgV===null?'—':esc(fmt(avgV,unit==='h'?1:0))}</b></span><span>MAX <b>${maxV===null?'—':esc(fmt(maxV,unit==='h'?1:0))}</b></span></div></div><svg class="trend-svg" viewBox="0 0 ${w} ${h}" preserveAspectRatio="none"><defs><linearGradient id="${grad}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${color}" stop-opacity=".30"/><stop offset=".72" stop-color="${color}" stop-opacity=".055"/><stop offset="1" stop-color="${color}" stop-opacity="0"/></linearGradient><filter id="${grad}Glow" x="-20%" y="-30%" width="140%" height="160%"><feGaussianBlur stdDeviation="1.1" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>${zoneSvg}${grid}${vgrid}${thresholdSvg}${overSvg}${series.area?'<path d="'+esc(series.area)+'" fill="url(#'+grad+')"/>':''}${series.line?'<path class="line '+lineClass+'" d="'+esc(series.line)+'" filter="url(#'+grad+'Glow)"/>':''}${sampleDots.join('')}${dot}<text class="axis-text" x="${series.left}" y="114">${esc(firstTime)}</text><text class="axis-text" x="${(series.left+series.plotW/2).toFixed(1)}" y="114" text-anchor="middle">${esc(midTime)}</text><text class="axis-text" x="${w-series.right}" y="114" text-anchor="end">${esc(lastTime)}</text></svg></div>`;
  	  }

  	  function monthTrendData(tractor) {
  	    const report=monthlyReport(tractor),days=arr(report.daily_reports); if(!days.length)return null; const labels=days.map(function(d){try{return new Date(num(d.begin,0)*1000).toLocaleDateString('en-ZA',{day:'2-digit',month:'short'});}catch(_){return '';} });
  	    return {labels:labels,time:days.map(function(d){return num(d.begin,0)*1000;}),distance:days.map(function(d){return num(d.distance_km,0);}),rpm:days.map(function(d){return num(d.top_rpm,0);}),idle:days.map(function(d){return num(get(d,'idle_summary.duration',0),0)/3600;}),fuel:days.map(function(d){return num(d.closing_fuel_level,null);})};
  	  }
  	  function trendGridHtml(tractor,t,runtime) {
  	    /*
  	     * Graph scale policy:
  	     * - Engine RPM upper axis = Tractor.CAN.RPM
  	     * - Coolant upper axis    = Tractor.CAN.Temp
  	     * - Vehicle Speed upper   = Tractor.CAN.Speed
  	     * - Fuel Level upper      = 100% (physical percentage ceiling)
  	     *
  	     * CAN limits are authoritative whenever configured. We do NOT auto-expand
  	     * above them. Values beyond the configured ceiling are clipped to the top
  	     * edge and explicitly marked OVER LIMIT.
  	     */
  	    const canRpmMax=num(get(tractor,'CAN.RPM',null),null);
  	    const canTempMax=num(get(tractor,'CAN.Temp',null),null);
  	    const canSpeedMax=num(get(tractor,'CAN.Speed',null),null);
  	    const canLowFuel=num(get(tractor,'CAN.LowFuel',null),null);

  	    if(runtime.trendMode==='month'){
  	      const m=monthTrendData(tractor);
  	      if(m){
  	        const maxDist=Math.max(100,Math.max.apply(null,m.distance)*1.12);
  	        const maxIdle=Math.max(1,Math.max.apply(null,m.idle)*1.18);
  	        const rpmFallback=Math.max(2500,Math.max.apply(null,m.rpm)*1.12);
  	        const rpmMax=canRpmMax!==null&&canRpmMax>0?canRpmMax:rpmFallback;

  	        return trendCard('Distance / Day',m.distance[m.distance.length-1],'km',m.distance,m.time,0,maxDist,'speed-line',m.labels,null,'',null)
  	          +trendCard('Top RPM / Day',m.rpm[m.rpm.length-1],'RPM',m.rpm,m.time,0,rpmMax,'rpm-line',m.labels,canRpmMax,'CAN RPM MAX',canRpmMax!==null?'CAN':'AUTO')
  	          +trendCard('Idle / Day',m.idle[m.idle.length-1],'h',m.idle,m.time,0,maxIdle,'temp-line',m.labels,null,'',null)
  	          +trendCard('Closing Fuel',m.fuel[m.fuel.length-1],'%',m.fuel,m.time,0,100,'fuel-line',m.labels,canLowFuel,'LOW FUEL','PHYSICAL MAX');
  	      }
  	    }

  	    const rpmObserved=Math.max(1,t.rpm||0,...runtime.samples.rpm.filter(function(v){return v!==null&&Number.isFinite(v);}));
  	    const speedObserved=Math.max(1,t.speed||0,...runtime.samples.speed.filter(function(v){return v!==null&&Number.isFinite(v);}));
  	    const tempObserved=Math.max(1,t.temp||0,...runtime.samples.temp.filter(function(v){return v!==null&&Number.isFinite(v);}));

  	    const rpmMax=canRpmMax!==null&&canRpmMax>0?canRpmMax:Math.max(3000,rpmObserved*1.12);
  	    const speedMax=canSpeedMax!==null&&canSpeedMax>0?canSpeedMax:Math.max(140,speedObserved*1.12);
  	    const tempMax=canTempMax!==null&&canTempMax>40?canTempMax:Math.max(130,tempObserved*1.12);

  	    return trendCard('Engine RPM',t.rpm,'RPM',runtime.samples.rpm,runtime.samples.time,0,rpmMax,'rpm-line',null,canRpmMax,'CAN RPM MAX',canRpmMax!==null?'CAN':'AUTO')
  	      +trendCard('Coolant Temp',t.temp,'°C',runtime.samples.temp,runtime.samples.time,40,tempMax,'temp-line',null,canTempMax,'CAN TEMP MAX',canTempMax!==null?'CAN':'AUTO')
  	      +trendCard('Vehicle Speed',t.speed,'km/h',runtime.samples.speed,runtime.samples.time,0,speedMax,'speed-line',null,canSpeedMax,'CAN SPEED MAX',canSpeedMax!==null?'CAN':'AUTO')
  	      +trendCard('Fuel Level',t.fuelPct,'%',runtime.samples.fuel,runtime.samples.time,0,100,'fuel-line',null,canLowFuel,'LOW FUEL','PHYSICAL MAX');
  	  }

  	  function navHtml(view) {
  	    const button=function(key,label,icon){return '<button class="nav-btn '+(view===key?'active':'')+'" data-fif-view="'+esc(key)+'" type="button">'+sideIcon(icon)+esc(label)+'</button>';};
  	    return '<nav class="nav">'+button('dashboard','Dashboard','dashboard')+'<button class="nav-btn" data-fif-live-map type="button">'+sideIcon('map')+'Live Map</button>'+button('reports','Reports','report')+button('alerts','Alerts','alert')+button('maintenance','Maintenance','wrench')+button('devices','Devices','device')+button('settings','Settings','settings')+button('help','Help','help')+'</nav>';
  	  }
  	  function topbarHtml(tractor,t) {
  	    const id=identity(tractor),vehicleTitle=[id.year,id.make,id.model].filter(Boolean).join(' ')||id.registration,lastUpdate=t.timestamp?formatTime(t.timestamp):'—',liveClass=t.freshness==='LIVE'?'':t.freshness==='DELAYED'?' delayed':t.freshness==='STALE'?' stale':' nodata';
  	    return '<header class="topbar">'
  	      +'<div class="vehicle-ident">'+vehicleSvg()+'<div style="min-width:0"><div class="brand-mini">FLEET IN FORM</div><div class="title">CANbus Telemetry Dashboard</div><div class="sub-title">'+esc(id.registration)+' · '+esc(vehicleTitle)+'</div></div></div>'
  	      +'<div><div class="head-lab">Vehicle</div><div class="head-val">'+esc(vehicleTitle)+'</div></div>'
  	      +'<div><div class="head-lab">VIN</div><div class="head-val">'+esc(id.vin)+'</div></div>'
  	      +'<div class="hide-1280"><div class="head-lab">Device</div><div class="head-val">'+esc(t.deviceId||clean(tractor.Tracker,'—'))+'</div></div>'
  	      +'<div class="hide-1280"><div class="head-lab">Last Update</div><div class="head-val">'+esc(lastUpdate)+'</div></div>'
  	      +'<div class="top-live'+liveClass+'"><span>'+esc(t.freshness)+'</span><i class="status-dot"></i>'+signalBars(t.signal)+'<small>'+esc(relativeAge(t.timestamp))+'</small></div>'
  	      +'<button class="top-close" data-fif-close type="button" title="Close dashboard" aria-label="Close dashboard"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M5 5 19 19M19 5 5 19"/></svg></button>'
  	      +'</header>';
  	  }

  	  function dashboardView(tractor,t,runtime) {
  	    const rows=diagnostics(tractor,t); return '<section class="workspace"><div class="left-work"><div class="panel"><div class="panel-head"><span>Live CANbus Parameters</span><small style="margin-left:auto;margin-right:8px">ECU TELEMETRY</small><small>'+esc(relativeAge(t.timestamp))+'</small></div>'+warningLampsHtml(t)+'<div class="telemetry-grid" style="height:calc(100% - 66px)">'+telemetryCards(tractor,t)+'</div></div><div class="panel trend-panel"><div class="panel-head"><span>Telemetry Analysis</span><div class="trend-controls"><button class="trend-mode '+(runtime.trendMode==='live'?'active':'')+'" data-trend-mode="live">LIVE</button><button class="trend-mode '+(runtime.trendMode==='month'?'active':'')+'" data-trend-mode="month">MONTH</button></div></div><div class="trend-grid">'+trendGridHtml(tractor,t,runtime)+'</div></div></div><aside class="right"><div class="panel"><div class="panel-head"><span>Diagnostic Trouble Codes (DTC)</span><span class="diag-count">'+rows.length+' Active</span></div><div class="diag-body"><div class="diag-table">'+diagMini(rows)+'</div><button class="view-dtc" type="button" data-view-dtcs>View All DTCs</button></div></div><div class="panel"><div class="panel-head"><span>Vehicle Summary</span></div><div class="summary">'+summaryHtml(tractor,t)+'</div></div><div class="panel"><div class="panel-head"><span>Data Source</span></div>'+sourceHtml(t,runtime.samples)+'</div></aside></section>';
  	  }

  	  function kpi(label,value,foot){return '<div class="kpi"><span>'+esc(label)+'</span><strong>'+esc(value)+'</strong><small>'+esc(foot||'')+'</small></div>';}
  	  function reportsView(tractor,t) {
  	    const report=monthlyReport(tractor),sum=report.monthly_summary||{},vc=viewC(tractor),days=arr(report.daily_reports),litres=num(vc.Litres,null),distance=num(first([sum.distance_km,report.distance_km,vc.Distance],0),0),cons=distance>0&&litres!==null?litres/distance*100:num(vc.ConsumptionL100Km,null);
  	    const rows=days.slice().reverse().map(function(d){const date=d.begin?new Date(num(d.begin,0)*1000).toLocaleDateString('en-ZA',{day:'2-digit',month:'short'}):'—';return '<tr><td>'+esc(date)+'</td><td class="r">'+fmt(d.distance_km,1)+' km</td><td class="r">'+fmtDuration(d.engine_seconds)+'</td><td class="r">'+fmtDuration(get(d,'idle_summary.duration',0))+'</td><td class="r">'+fmt(d.top_speed,0)+' km/h</td><td class="r">'+fmt(d.top_rpm,0)+' rpm</td><td class="r">'+(d.closing_fuel_level==null?'—':fmt(d.closing_fuel_level,0)+'%')+'</td></tr>';}).join('');
  	    return '<div class="view-scroll"><div class="view-head"><div><div class="view-title">Vehicle Reports</div><div class="view-sub">'+esc(clean(report.report_month,clean(get(tractor,'Reports.Month',''),'Current month')))+' · loaded vehicle history</div></div></div><div class="kpi-grid">'+kpi('Distance',fmt(distance,1)+' km',num(sum.days_with_data,days.length)+' days with data')+kpi('Engine Runtime',fmtDuration(sum.engine_seconds),'Moving '+fmtDuration(sum.moving_seconds))+kpi('Idle',fmtDuration(sum.idle_seconds),fmt(sum.idle_incidents,0)+' incidents')+kpi('Over Rev',fmt(sum.over_rev_incidents,0),'Events · '+fmtDuration(sum.over_rev_seconds))+kpi('Top Speed',fmt(sum.top_speed,0)+' km/h','Month maximum')+kpi('Top RPM',fmt(sum.top_rpm,0)+' rpm','Month maximum')+kpi('Fuel Recorded',litres===null?'—':fmt(litres,1)+' L',fmt(num(vc.TransactionCount,0),0)+' fuel transactions')+kpi('Consumption',cons===null?'—':fmt(cons,1)+' L/100km','Vehicle ViewC')+'</div><div class="data-panel"><div class="data-panel-head"><span>Daily Operating Summary</span><small>'+days.length+' report days</small></div><table class="data-table"><thead><tr><th>Date</th><th class="r">Distance</th><th class="r">Engine</th><th class="r">Idle</th><th class="r">Top Speed</th><th class="r">Top RPM</th><th class="r">Fuel</th></tr></thead><tbody>'+(rows||'<tr><td colspan="7">No daily reports are loaded.</td></tr>')+'</tbody></table></div></div>';
  	  }

  	  function alertsView(tractor,t) {
  	    const rows=diagnostics(tractor,t),events=arr(get(tractor,'CAN.Events',[])),enabled=get(tractor,'CAN.EventsBoolean',{})||{};
  	    const diagRows=rows.map(function(r){return '<tr><td class="'+(r.level==='active'?'bad':'warn')+'">'+esc(r.code)+'</td><td>'+esc(r.description)+'</td><td>'+esc(r.evidence)+'</td><td class="r '+(r.level==='active'?'bad':'warn')+'">'+esc(r.status)+'</td></tr>';}).join('');
  	    const eventRows=events.map(function(e){const name=clean(e&&e.name,'Unnamed rule'),category=clean(e&&e.category,'General'),on=enabled[name]!==false; return '<div class="event-rule"><div><b>'+esc(name)+'</b><small>'+esc(category)+'</small></div><span class="event-pill '+(on?'enabled':'')+'">'+(on?'ENABLED':'OFF')+'</span></div>';}).join('');
  	    return '<div class="view-scroll"><div class="view-head"><div><div class="view-title">Alerts & Event Intelligence</div><div class="view-sub">Live warning signals, thresholds, data conflicts and configured CAN rules</div></div></div>'+warningLampsHtml(t)+'<div style="height:8px"></div><div class="data-panel"><div class="data-panel-head"><span>Active Diagnostics</span><small>'+rows.length+' requiring review</small></div><table class="data-table"><thead><tr><th>Code</th><th>Condition</th><th>Evidence</th><th class="r">Status</th></tr></thead><tbody>'+(diagRows||'<tr><td colspan="4" class="good">No active diagnostics.</td></tr>')+'</tbody></table></div><div class="data-panel"><div class="data-panel-head"><span>Configured CAN Event Rules</span><small>'+events.length+' rules</small></div><div class="event-list">'+eventRows+'</div></div></div>';
  	  }

  	  function dateText(value){const v=descriptor(value); if(!v)return '—'; try{const d=typeof v==='number'?new Date(v):new Date(String(v));return Number.isNaN(d.getTime())?clean(v,'—'):d.toLocaleDateString('en-ZA',{day:'2-digit',month:'short',year:'numeric'});}catch(_){return clean(v,'—');}}
  	  function maintenanceView(tractor,t) {
  	    const serviceStatus=clean(descriptor(get(tractor,'Data.Service.Service_Status',null)),'—'),interval=num(descriptor(get(tractor,'Data.Service.Service_Interval',null)),null),lastKm=num(descriptor(get(tractor,'Data.Service.History.Last_Service_KM',null)),null),nextKm=num(descriptor(get(tractor,'Data.Service.History.Next_Service_KM',null)),null),lastDate=descriptor(get(tractor,'Data.Service.History.Last_Service_Date',null)),nextDate=descriptor(get(tractor,'Data.Service.History.Next_Service_Date_Estimate',null)),warranty=bool(descriptor(get(tractor,'Data.Service.Warranty.Is_Under_Warranty',null))),licence=first([get(tractor,'Data.Compliance.Setup.Requirements.VehicleLicence.ExpiryDate',''),tractor&&tractor.LicenseExpiry,get(tractor,'Data.Compliance.License_Expiry_Date.value','')],''); const maint=arr(tractor&&tractor.Maintenance),conf=configurationConflicts(tractor,t);
  	    return '<div class="view-scroll"><div class="view-head"><div><div class="view-title">Maintenance & Compliance</div><div class="view-sub">Service configuration, workshop position and compliance dates</div></div></div><div class="kpi-grid">'+kpi('Service Status',serviceStatus,'Vehicle master')+kpi('Service Interval',interval===null?'—':fmt(interval,0)+' '+(t.hoursVehicle?'h':'km'),'Configured interval')+kpi('Last Service',lastKm?fmt(lastKm,0)+' km':dateText(lastDate),'Recorded history')+kpi('Next Service',nextKm?fmt(nextKm,0)+' km':dateText(nextDate),'Recorded target')+kpi('Warranty',warranty===true?'YES':warranty===false?'NO':'—','Under warranty')+kpi('Licence Expiry',dateText(licence),'Compliance')+kpi('Open Records',fmt(maint.length,0),'Maintenance relation')+kpi('CAN Service Lamp',bool(t.location['can.maintenance.required.status'])===true?'ON':'OFF','Current CAN state')+'</div>'+(conf.map(function(c){return '<div class="conflict"><div>⚠</div><div><strong>'+esc(c.title)+'</strong><p>'+esc(c.detail)+'</p></div></div>';}).join('')||'')+'</div>';
  	  }

  	  function devicesView(tractor,t) {
  	    const l=t.location; const rows=[['Device Name',t.deviceName||'—'],['Device ID',t.deviceId||'—'],['IMEI / Ident',t.ident||'—'],['Channel ID',t.channelId||'—'],['Codec',t.codecId||'—'],['Protocol',t.protocolId||'—'],['Peer',t.peer||'—'],['Message Kind',t.msgKind||'—'],['CAN Program ID',t.programId||'—'],['CAN Available',t.hasCan===true?'YES':t.hasCan===false?'NO':'—'],['GSM Operator',t.gsmOperator||'—'],['GSM MCC / MNC',[t.gsmMcc,t.gsmMnc].filter(Boolean).join(' / ')||'—'],['GSM Signal',t.signal===null?'—':fmt(t.signal,0)],['GNSS Valid',t.gnssValid===true?'YES':t.gnssValid===false?'NO':'—'],['Satellites',t.satellites===null?'—':fmt(t.satellites,0)],['HDOP',t.hdop===null?'—':fmt(t.hdop,1)],['PDOP',t.pdop===null?'—':fmt(t.pdop,1)],['Altitude',t.altitude===null?'—':fmt(t.altitude,0)+' m'],['Latitude',t.latitude===null?'—':fmt(t.latitude,6)],['Longitude',t.longitude===null?'—':fmt(t.longitude,6)],['CAN Connection 1',clean(l['can.connection.state.1'],'—')],['CAN Connection 2',clean(l['can.connection.state.2'],'—')],['CAN Connection 3',clean(l['can.connection.state.3'],'—')],['Last Message',t.timestamp?formatTime(t.timestamp):'—']];
  	    return '<div class="view-scroll"><div class="view-head"><div><div class="view-title">Devices & Data Source</div><div class="view-sub">Tracker, CAN adapter, GSM and GNSS health</div></div></div><div class="kpi-grid">'+kpi('Connection',t.freshness,relativeAge(t.timestamp))+kpi('GSM',t.signal===null?'—':fmt(t.signal,0),'Signal level')+kpi('GNSS',t.satellites===null?'—':fmt(t.satellites,0)+' sats','HDOP '+fmt(t.hdop,1))+kpi('Power',t.externalVoltage===null?'—':fmt(t.externalVoltage,2)+' V','External supply')+'</div><div class="data-panel"><div class="data-panel-head"><span>Device Detail</span><small>Current tracker point</small></div><table class="data-table"><tbody>'+rows.map(function(r){return '<tr><td>'+esc(r[0])+'</td><td class="r">'+esc(r[1])+'</td></tr>';}).join('')+'</tbody></table></div></div>';
  	  }

  	  function settingsView(tractor,t) {
  	    const settings=[['RPM Warning',get(tractor,'CAN.RPM',null),'rpm'],['Green Band High',get(tractor,'CAN.RPMGH',null),'rpm'],['Green Band Low',get(tractor,'CAN.RPMGL',null),'rpm'],['Speed Limit',get(tractor,'CAN.Speed',null),'km/h'],['Temperature Limit',get(tractor,'CAN.Temp',null),'°C'],['Idle Threshold',get(tractor,'CAN.Idle',null),'s'],['CAN Tank Capacity',get(tractor,'CAN.Tank',null),'L'],['Vehicle Tank Capacity',descriptor(get(tractor,'Data.Vehicle.Tank_Capacity',null)),'L'],['Low Fuel',get(tractor,'CAN.LowFuel',null),'%'],['Voltage Minimum',get(tractor,'CAN.Voltage',null),'V'],['Poor HDOP',get(tractor,'CAN.PoorHdop',null),''],['Acceleration G',get(tractor,'CAN.AccelG',null),'g'],['Brake G',get(tractor,'CAN.BrakeG',null),'g'],['Fuel Loss Step',get(tractor,'CAN.FuelLossStepL',null),'L'],['Night Start',get(tractor,'CAN.NightHoursStart',null),''],['Night End',get(tractor,'CAN.NightHoursEnd',null),'']]; const conflicts=configurationConflicts(tractor,t);
  	    return '<div class="view-scroll"><div class="view-head"><div><div class="view-title">CANbus Configuration</div><div class="view-sub">Thresholds used by the vehicle event engine</div></div></div>'+(conflicts.map(function(c){return '<div class="conflict"><div>⚠</div><div><strong>'+esc(c.title)+'</strong><p>'+esc(c.detail)+'</p></div></div>';}).join('')||'<div class="conflict" style="border-color:#28563a;background:rgba(97,211,109,.03)"><div>✓</div><div><strong style="color:#70d17a">No obvious configuration conflicts</strong><p>Configured values are internally consistent.</p></div></div>')+'<div class="data-panel"><div class="data-panel-head"><span>Vehicle Thresholds</span><small>Read-only dashboard view</small></div><table class="data-table"><thead><tr><th>Setting</th><th class="r">Value</th><th class="r">Source</th></tr></thead><tbody>'+settings.map(function(r){return '<tr><td>'+esc(r[0])+'</td><td class="r">'+esc(r[1]===null||r[1]===undefined||r[1]===''?'—':String(r[1])+(r[2]?' '+r[2]:''))+'</td><td class="r">CAN CONFIG</td></tr>';}).join('')+'</tbody></table></div></div>';
  	  }

  	  function helpView() {
  	    return '<div class="view-scroll"><div class="view-head"><div><div class="view-title">Dashboard Guide</div><div class="view-sub">How Fleet In Form interprets this vehicle data</div></div></div><div class="help-grid"><div class="help-card"><h3>Source badges</h3><p><span class="tiny-source">CAN</span><span class="tiny-source">GPS</span><span class="tiny-source">TRACKER</span><span class="tiny-source">SNAPSHOT</span><span class="tiny-source">CONFIG</span> show exactly where each value came from. No signal means the selected vehicle does not currently expose that parameter.</p></div><div class="help-card"><h3>Freshness</h3><p>LIVE is a point received within roughly 90 seconds. DELAYED is recent but not live. STALE means the telemetry point is older than ten minutes. This prevents an old point from looking live.</p></div><div class="help-card"><h3>Diagnostics</h3><p>The DTC panel combines CAN warning bits, configured thresholds, GNSS/data health and configuration conflicts. Evidence is shown in View All DTCs.</p></div><div class="help-card"><h3>Reports</h3><p>Monthly history is read from the loaded vehicle report. The dashboard never invents missing daily data; unavailable values remain blank or N/A.</p></div><div class="help-card"><h3>Single / double click</h3><p>Single click still selects and zooms the tractor on the map. A second click inside the double-click window cancels that action and opens this dashboard.</p></div><div class="help-card"><h3>Read only</h3><p>This dashboard does not write thresholds or vehicle master data. Configuration conflicts are surfaced for correction in the appropriate Fleet In Form data screen.</p></div></div></div>';
  	  }

  	  function viewContent(tractor,t,runtime) { switch(runtime.view){case 'reports':return reportsView(tractor,t);case 'alerts':return alertsView(tractor,t);case 'maintenance':return maintenanceView(tractor,t);case 'devices':return devicesView(tractor,t);case 'settings':return settingsView(tractor,t);case 'help':return helpView();default:return dashboardView(tractor,t,runtime);} }

  	  function dashboardMarkup(tractor,runtime) {
  	    const t=telemetry(tractor); return '<div class="dash-layout"><aside class="side"><div class="side-brand">'+logoHtml()+'</div>'+navHtml(runtime.view)+'<div class="nav-spacer"></div><div class="side-badge"><div class="side-badge-ring">FIF</div>FLEET IN FORM</div></aside><main class="main">'+topbarHtml(tractor,t)+'<div class="content-shell">'+viewContent(tractor,t,runtime)+'</div><footer class="footer"><span>Source-aware vehicle intelligence · unsupported telemetry remains N/A.</span><span>FIF CAN Dashboard v4.5.0</span></footer></main></div>';
  	  }

  	  function openDtcModal() {
  	    const old=document.getElementById(DTC_MODAL_ID); if(old)old.remove(); const tractor=currentTractor(),t=telemetry(tractor),rows=diagnostics(tractor,t),modal=document.createElement('div'); modal.id=DTC_MODAL_ID;
  	    modal.innerHTML='<div class="dtc-modal-card"><div class="dtc-modal-head"><span>All Diagnostic Trouble Codes, Warnings & Data Conflicts</span><button class="dtc-close" type="button">×</button></div><div class="dtc-all">'+(rows.length?rows.map(function(r){return '<div class="dtc-all-row '+esc(r.level)+'"><span class="code">'+esc(r.code)+'</span><span>'+esc(r.description)+'</span><span>'+esc(r.status)+'</span>'+(r.evidence?'<div class="evidence">'+esc(r.evidence)+'</div>':'')+'</div>';}).join(''):'<div class="diag-empty">No active diagnostics.</div>')+'</div></div>';
  	    document.body.appendChild(modal); const close=function(){if(modal.parentNode)modal.remove();}; modal.querySelector('.dtc-close').addEventListener('click',close); modal.addEventListener('click',function(e){if(e.target===modal)close();});
  	  }

  	  function closeDashboard(returnToMap) {
  	    const runtime=window[DASH_STATE_KEY]; if(runtime){if(runtime.timer)clearInterval(runtime.timer);if(runtime.keydown)document.removeEventListener('keydown',runtime.keydown,true);} const modal=document.getElementById(DTC_MODAL_ID);if(modal)modal.remove(); const root=document.getElementById(ROOT_ID);if(root)root.remove(); const style=document.getElementById(STYLE_ID);if(style)style.remove(); try{delete window[DASH_STATE_KEY];}catch(_){window[DASH_STATE_KEY]=null;} if(returnToMap)singleClickAction(currentTractor());
  	  }
  	  function appendSample(samples,tractor) { const t=telemetry(tractor),push=function(list,v){list.push(v===null?null:v);if(list.length>MAX_SAMPLES)list.shift();};push(samples.rpm,t.rpm);push(samples.temp,t.temp);push(samples.speed,t.speed);push(samples.fuel,t.fuelPct);push(samples.signal,t.signal);samples.time.push(Date.now());if(samples.time.length>MAX_SAMPLES)samples.time.shift(); }
  	  function captureScroll(root){const node=root&&root.querySelector('.view-scroll');return node?node.scrollTop:0;} function restoreScroll(root,value){const node=root&&root.querySelector('.view-scroll');if(node)node.scrollTop=value||0;}
  	  function refreshDashboard(runtime) {
  	    const tractor=currentTractor();
  	    appendSample(runtime.samples,tractor);

  	    const root=document.getElementById(ROOT_ID);
  	    if(!root)return closeDashboard(false);

  	    const scroll=captureScroll(root);

  	    root.innerHTML=dashboardMarkup(tractor,runtime);
  	    bindDashboardEvents(root,runtime);
  	    restoreScroll(root,scroll);
  	  }
  	  function renderDashboard(runtime,resetScroll){
  	    const root=document.getElementById(ROOT_ID);
  	    if(!root)return;

  	    // Revoke the previous temporary logo URL before rebuilding the DOM.

  	    root.innerHTML=dashboardMarkup(currentTractor(),runtime);

  	    // IMPORTANT: every dashboard render creates a fresh logo <img>.
  	    // Mount its src immediately, not only on the periodic refresh.

  	    bindDashboardEvents(root,runtime);

  	    if(resetScroll){
  	      const node=root.querySelector('.view-scroll');
  	      if(node)node.scrollTop=0;
  	    }
  	  }
  	  function bindDashboardEvents(root,runtime) {
  	    root.querySelectorAll('[data-fif-close]').forEach(function(b){b.addEventListener('click',function(){closeDashboard(false);});});
  	    root.querySelectorAll('[data-fif-live-map]').forEach(function(b){b.addEventListener('click',function(){closeDashboard(true);});});
  	    root.querySelectorAll('[data-fif-view]').forEach(function(b){b.addEventListener('click',function(){runtime.view=b.getAttribute('data-fif-view')||'dashboard';renderDashboard(runtime,true);});});
  	    root.querySelectorAll('[data-trend-mode]').forEach(function(b){b.addEventListener('click',function(){runtime.trendMode=b.getAttribute('data-trend-mode')||'live';renderDashboard(runtime,false);});});
  	    const dtc=root.querySelector('[data-view-dtcs]');if(dtc)dtc.addEventListener('click',openDtcModal);
  	  }
  	  function openDashboard() {
  	    closeDashboard(false);installStyles();const root=document.createElement('div');root.id=ROOT_ID;document.body.appendChild(root);const openingTractor=currentTractor(),openingTelemetry=telemetry(openingTractor),openingMonth=monthTrendData(openingTractor),runtime={samples:{rpm:[],temp:[],speed:[],fuel:[],signal:[],time:[]},view:'dashboard',trendMode:(openingTelemetry.stale&&openingMonth?'month':'live'),timer:null,keydown:null};appendSample(runtime.samples,openingTractor);window[DASH_STATE_KEY]=runtime;renderDashboard(runtime,true);runtime.keydown=function(e){if(e.key==='Escape'){e.preventDefault();const modal=document.getElementById(DTC_MODAL_ID);if(modal)modal.remove();else closeDashboard(false);}};document.addEventListener('keydown',runtime.keydown,true);runtime.timer=setInterval(function(){refreshDashboard(runtime);},SAMPLE_MS);console.info('[FIF CAN Dashboard] Opened',{
  	      version:VERSION,
  	      tractor:tractorId(Tractor),
  	      tracker:Tractor&&Tractor.Tracker,
  	      view:runtime.view,
  	      logoResolved:!!logoAsset,
  	      logoType:logoAsset
  	        ? (logoAsset.indexOf('data:image/')===0
  	            ? 'data-uri'
  	            : (logoAsset.indexOf('<svg')===0 ? 'inline-svg' : 'url'))
  	        : 'missing',
  	      logoLength:logoAsset.length
  	    });
  	  }
  	  function handleClick() {
  	    const id=tractorId(Tractor),now=Date.now();let state=window[CLICK_STATE_KEY];if(!state){state={lastId:'',lastAt:0,timer:null};window[CLICK_STATE_KEY]=state;}const second=state.lastId===id&&(now-state.lastAt)<=DOUBLE_CLICK_MS;if(second){if(state.timer){clearTimeout(state.timer);state.timer=null;}state.lastId='';state.lastAt=0;openDashboard();return 'double';}if(state.timer){clearTimeout(state.timer);state.timer=null;}state.lastId=id;state.lastAt=now;state.timer=setTimeout(function(){state.timer=null;state.lastId='';state.lastAt=0;singleClickAction(Tractor);},DOUBLE_CLICK_MS);return 'single-pending';
  	  }
  	  return handleClick();
  	})(___arguments);

  })(___arguments.context.appData, ___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'), 'data:image/png;base64,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');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Office/components/a4939b31591ffb081f481c781b885308/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await (async function(Component, Vehicle) {
  	/*
  	  TrackIT Fuel Gauge
  	  Backendless Custom Code Inputs:
  	    Component = fuel gauge holder component
  	    Vehicle   = repeater item / tractor object
  	
  	  Visual:
  	    E  [ rounded fuel gauge ]  F
  	
  	  Box:
  	    175px x 30px
  	    5px rounded corners
  	    No orange border
  	
  	  Visibility:
  	    - Hidden if Vehicle.Location does NOT contain:
  	        "can.fuel.level"
  	        OR
  	        "can.fuel.volume"
  	
  	  Fuel Logic:
  	    - If Location["can.fuel.level"] exists:
  	        percent = Location["can.fuel.level"]
  	    - Else if Location["can.fuel.volume"] exists:
  	        percent = Location["can.fuel.volume"] / Vehicle.CAN.Tank * 100
  	
  	  Hover:
  	    - Shows Fuel Level percentage and source
  	*/
  	
  	var __trackitFuelArgs = typeof arguments !== "undefined" ? arguments : [];
  	
  	(function runTrackitFuelGauge(ComponentInput, VehicleInput) {
  	  const MAX_WAIT_MS = 5000;
  	  const RETRY_MS = 150;
  	  const START = Date.now();
  	
  	  const WIDTH = 175;
  	  const HEIGHT = 30;
  	  const RADIUS = 5;
  	
  	  const SIDE_LABEL_W = 22;
  	  const GAP = 6;
  	  const BAR_H = 13;
  	  const BAR_W = WIDTH - SIDE_LABEL_W * 2 - GAP * 2;
  	
  	  function hasOwn(obj, key) {
  	    return !!obj && Object.prototype.hasOwnProperty.call(obj, key);
  	  }
  	
  	  function toNumber(value, fallback) {
  	    const n = Number(value);
  	    return Number.isFinite(n) ? n : fallback;
  	  }
  	
  	  function clamp(value, min, max) {
  	    return Math.max(min, Math.min(max, value));
  	  }
  	
  	  function getDomElement(component) {
  	    if (!component) return null;
  	
  	    if (component.nodeType === 1) return component;
  	
  	    const possible =
  	      component.el ||
  	      component.$el ||
  	      component.element ||
  	      component.domElement ||
  	      component.htmlElement ||
  	      component.root ||
  	      component._el ||
  	      component._element ||
  	      component._root;
  	
  	    if (possible) {
  	      if (possible.nodeType === 1) return possible;
  	      if (possible[0] && possible[0].nodeType === 1) return possible[0];
  	    }
  	
  	    if (typeof component.getElement === "function") {
  	      const el = component.getElement();
  	      if (el && el.nodeType === 1) return el;
  	    }
  	
  	    return null;
  	  }
  	
  	  function resolveFuel(vehicle) {
  	    const loc = vehicle && vehicle.Location ? vehicle.Location : null;
  	    const can = vehicle && vehicle.CAN ? vehicle.CAN : null;
  	
  	    if (!loc) {
  	      return {
  	        visible: false,
  	        reason: "missing-location"
  	      };
  	    }
  	
  	    const hasFuelLevel = hasOwn(loc, "can.fuel.level");
  	    const hasFuelVolume = hasOwn(loc, "can.fuel.volume");
  	
  	    if (!hasFuelLevel && !hasFuelVolume) {
  	      return {
  	        visible: false,
  	        reason: "no-live-fuel-field"
  	      };
  	    }
  	
  	    let percent = null;
  	    let source = "";
  	
  	    if (hasFuelLevel) {
  	      percent = toNumber(loc["can.fuel.level"], null);
  	      source = "can.fuel.level";
  	
  	      // Some providers send 0.55 for 55%.
  	      if (percent !== null && percent > 0 && percent <= 1) {
  	        percent = percent * 100;
  	      }
  	    } else {
  	      const fuelVolume = toNumber(loc["can.fuel.volume"], null);
  	      const tank = toNumber(can && can.Tank, null);
  	
  	      if (fuelVolume === null || !tank || tank <= 0) {
  	        return {
  	          visible: false,
  	          reason: "invalid-volume-or-tank"
  	        };
  	      }
  	
  	      percent = (fuelVolume / tank) * 100;
  	      source = "can.fuel.volume";
  	    }
  	
  	    if (!Number.isFinite(percent)) {
  	      return {
  	        visible: false,
  	        reason: "invalid-percent"
  	      };
  	    }
  	
  	    percent = clamp(percent, 0, 100);
  	
  	    let state = "normal";
  	
  	    if (percent <= 15) {
  	      state = "critical";
  	    } else if (percent <= 30) {
  	      state = "low";
  	    } else if (percent <= 60) {
  	      state = "watch";
  	    }
  	
  	    return {
  	      visible: true,
  	      percent: percent,
  	      roundedPercent: Math.round(percent),
  	      state: state,
  	      source: source
  	    };
  	  }
  	
  	  function hexToRgb(hex) {
  	    hex = String(hex || "").replace("#", "");
  	
  	    if (hex.length === 3) {
  	      hex = hex
  	        .split("")
  	        .map(function (c) {
  	          return c + c;
  	        })
  	        .join("");
  	    }
  	
  	    const num = parseInt(hex, 16);
  	
  	    if (!Number.isFinite(num)) {
  	      return { r: 255, g: 255, b: 255 };
  	    }
  	
  	    return {
  	      r: (num >> 16) & 255,
  	      g: (num >> 8) & 255,
  	      b: num & 255
  	    };
  	  }
  	
  	  function rgbToHex(r, g, b) {
  	    function part(n) {
  	      return Math.round(clamp(n, 0, 255))
  	        .toString(16)
  	        .padStart(2, "0");
  	    }
  	
  	    return "#" + part(r) + part(g) + part(b);
  	  }
  	
  	  function mixColor(a, b, t) {
  	    const ca = hexToRgb(a);
  	    const cb = hexToRgb(b);
  	
  	    return rgbToHex(
  	      ca.r + (cb.r - ca.r) * t,
  	      ca.g + (cb.g - ca.g) * t,
  	      ca.b + (cb.b - ca.b) * t
  	    );
  	  }
  	
  	  function getFuelColor(percent) {
  	    percent = clamp(Number(percent) || 0, 0, 100);
  	
  	    /*
  	      Deep scaled fuel colour:
  	        0%   = dark red
  	        20%  = red-orange
  	        40%  = orange
  	        60%  = yellow
  	        80%  = green
  	        100% = deep green
  	    */
  	
  	    const stops = [
  	      { p: 0, c: "#7a0d12" },
  	      { p: 20, c: "#b82114" },
  	      { p: 40, c: "#df7b12" },
  	      { p: 60, c: "#ffd23f" },
  	      { p: 80, c: "#4a9f38" },
  	      { p: 100, c: "#006b2e" }
  	    ];
  	
  	    for (let i = 0; i < stops.length - 1; i++) {
  	      const left = stops[i];
  	      const right = stops[i + 1];
  	
  	      if (percent >= left.p && percent <= right.p) {
  	        const t = (percent - left.p) / (right.p - left.p);
  	        return mixColor(left.c, right.c, t);
  	      }
  	    }
  	
  	    return stops[stops.length - 1].c;
  	  }
  	
  	  function setHidden(root) {
  	    if (!root) return;
  	
  	    root.innerHTML = "";
  	    root.style.display = "none";
  	    root.removeAttribute("data-trackit-fuel-percent");
  	    root.removeAttribute("data-trackit-fuel-source");
  	  }
  	
  	  function createSvgEl(tag) {
  	    return document.createElementNS("http://www.w3.org/2000/svg", tag);
  	  }
  	
  	  function createGaugeLetter(letter) {
  	    const wrap = document.createElement("div");
  	
  	    wrap.style.width = SIDE_LABEL_W + "px";
  	    wrap.style.height = HEIGHT + "px";
  	    wrap.style.display = "flex";
  	    wrap.style.alignItems = "center";
  	    wrap.style.justifyContent = "center";
  	    wrap.style.flex = "0 0 " + SIDE_LABEL_W + "px";
  	    wrap.style.boxSizing = "border-box";
  	
  	    const svg = createSvgEl("svg");
  	    svg.setAttribute("width", "14");
  	    svg.setAttribute("height", "14");
  	    svg.setAttribute("viewBox", "0 0 24 24");
  	    svg.setAttribute("shape-rendering", "geometricPrecision");
  	    svg.setAttribute("aria-hidden", "true");
  	
  	    svg.style.display = "block";
  	    svg.style.width = "14px";
  	    svg.style.height = "14px";
  	    svg.style.overflow = "visible";
  	
  	    function line(x1, y1, x2, y2) {
  	      const l = createSvgEl("line");
  	
  	      l.setAttribute("x1", String(x1));
  	      l.setAttribute("y1", String(y1));
  	      l.setAttribute("x2", String(x2));
  	      l.setAttribute("y2", String(y2));
  	      l.setAttribute("stroke", "rgba(255,255,255,0.88)");
  	      l.setAttribute("stroke-width", "2.15");
  	      l.setAttribute("stroke-linecap", "round");
  	      l.setAttribute("vector-effect", "non-scaling-stroke");
  	
  	      return l;
  	    }
  	
  	    if (letter === "E") {
  	      svg.appendChild(line(7, 5, 17, 5));
  	      svg.appendChild(line(7, 12, 15, 12));
  	      svg.appendChild(line(7, 19, 17, 19));
  	      svg.appendChild(line(7, 5, 7, 19));
  	    } else {
  	      svg.appendChild(line(7, 5, 17, 5));
  	      svg.appendChild(line(7, 12, 15, 12));
  	      svg.appendChild(line(7, 5, 7, 19));
  	    }
  	
  	    wrap.appendChild(svg);
  	    return wrap;
  	  }
  	
  	  function createTooltip(fuel, fillColor) {
  	    const tooltip = document.createElement("div");
  	
  	    tooltip.innerHTML =
  	      '<div style="font-weight:900;margin-bottom:2px;">Fuel Level: ' +
  	      fuel.roundedPercent +
  	      "%</div>" +
  	      '<div style="opacity:0.78;font-size:10px;">Source: ' +
  	      fuel.source +
  	      "</div>";
  	
  	    tooltip.style.position = "absolute";
  	    tooltip.style.left = "50%";
  	    tooltip.style.bottom = "34px";
  	    tooltip.style.transform = "translateX(-50%) translateY(0)";
  	    tooltip.style.minWidth = "116px";
  	    tooltip.style.padding = "6px 8px";
  	    tooltip.style.borderRadius = "6px";
  	    tooltip.style.background = "rgba(5, 10, 8, 0.97)";
  	    tooltip.style.border = "1px solid rgba(255,255,255,0.18)";
  	    tooltip.style.boxShadow =
  	      "0 6px 16px rgba(0,0,0,0.42), 0 0 10px " + fillColor;
  	    tooltip.style.color = "#ffffff";
  	    tooltip.style.fontSize = "11px";
  	    tooltip.style.lineHeight = "13px";
  	    tooltip.style.textAlign = "center";
  	    tooltip.style.pointerEvents = "none";
  	    tooltip.style.opacity = "0";
  	    tooltip.style.transition = "opacity 120ms ease, transform 120ms ease";
  	    tooltip.style.zIndex = "999999";
  	
  	    const arrow = document.createElement("div");
  	    arrow.style.position = "absolute";
  	    arrow.style.left = "50%";
  	    arrow.style.bottom = "-5px";
  	    arrow.style.width = "8px";
  	    arrow.style.height = "8px";
  	    arrow.style.transform = "translateX(-50%) rotate(45deg)";
  	    arrow.style.background = "rgba(5, 10, 8, 0.97)";
  	    arrow.style.borderRight = "1px solid rgba(255,255,255,0.18)";
  	    arrow.style.borderBottom = "1px solid rgba(255,255,255,0.18)";
  	
  	    tooltip.appendChild(arrow);
  	
  	    return tooltip;
  	  }
  	
  	  function renderFuelGauge(root, fuel) {
  	    const percent = fuel.percent;
  	    const rounded = fuel.roundedPercent;
  	    const fillColor = getFuelColor(percent);
  	
  	    root.innerHTML = "";
  	
  	    root.style.display = "block";
  	    root.style.width = WIDTH + "px";
  	    root.style.height = HEIGHT + "px";
  	    root.style.boxSizing = "border-box";
  	    root.style.borderRadius = RADIUS + "px";
  	    root.style.overflow = "visible";
  	    root.style.position = "relative";
  	
  	    // No orange border.
  	    root.style.border = "none";
  	    root.style.outline = "none";
  	
  	    root.style.background = "rgba(5, 9, 12, 0.94)";
  	    root.style.boxShadow = "none";
  	    root.style.fontFamily = "Inter, Arial, sans-serif";
  	    root.style.userSelect = "none";
  	    root.style.cursor = "default";
  	
  	    root.title = "Fuel Level: " + rounded + "%";
  	
  	    root.setAttribute("data-trackit-fuel-percent", String(rounded));
  	    root.setAttribute("data-trackit-fuel-source", fuel.source);
  	
  	    const shell = document.createElement("div");
  	    shell.style.position = "relative";
  	    shell.style.width = "100%";
  	    shell.style.height = "100%";
  	    shell.style.display = "flex";
  	    shell.style.alignItems = "center";
  	    shell.style.justifyContent = "center";
  	    shell.style.boxSizing = "border-box";
  	    shell.style.borderRadius = RADIUS + "px";
  	    shell.style.overflow = "hidden";
  	    shell.style.background = "rgba(5, 9, 12, 0.94)";
  	
  	    const labelE = createGaugeLetter("E");
  	    const labelF = createGaugeLetter("F");
  	
  	    const gaugeWrap = document.createElement("div");
  	    gaugeWrap.style.width = BAR_W + "px";
  	    gaugeWrap.style.height = BAR_H + "px";
  	    gaugeWrap.style.marginLeft = GAP + "px";
  	    gaugeWrap.style.marginRight = GAP + "px";
  	    gaugeWrap.style.position = "relative";
  	    gaugeWrap.style.borderRadius = "999px";
  	    gaugeWrap.style.overflow = "hidden";
  	    gaugeWrap.style.background = "rgba(255,255,255,0.11)";
  	    gaugeWrap.style.boxSizing = "border-box";
  	    gaugeWrap.style.boxShadow =
  	      "inset 0 1px 2px rgba(0,0,0,0.68), inset 0 -1px 0 rgba(255,255,255,0.04)";
  	
  	    const fill = document.createElement("div");
  	    fill.style.position = "absolute";
  	    fill.style.left = "0";
  	    fill.style.top = "0";
  	    fill.style.height = "100%";
  	    fill.style.width = percent + "%";
  	    fill.style.borderRadius = "999px";
  	    fill.style.background = fillColor;
  	    fill.style.boxShadow =
  	      "inset 0 1px 0 rgba(255,255,255,0.28), inset 0 -1px 2px rgba(0,0,0,0.24)";
  	    fill.style.transition = "width 250ms ease, background 250ms ease";
  	
  	    const fillShine = document.createElement("div");
  	    fillShine.style.position = "absolute";
  	    fillShine.style.left = "0";
  	    fillShine.style.top = "0";
  	    fillShine.style.width = "100%";
  	    fillShine.style.height = "50%";
  	    fillShine.style.borderRadius = "999px 999px 0 0";
  	    fillShine.style.background =
  	      "linear-gradient(180deg, rgba(255,255,255,0.22), rgba(255,255,255,0))";
  	    fillShine.style.pointerEvents = "none";
  	
  	    const emptyShade = document.createElement("div");
  	    emptyShade.style.position = "absolute";
  	    emptyShade.style.left = "0";
  	    emptyShade.style.top = "0";
  	    emptyShade.style.width = "100%";
  	    emptyShade.style.height = "100%";
  	    emptyShade.style.borderRadius = "999px";
  	    emptyShade.style.boxShadow = "inset 0 0 0 1px rgba(255,255,255,0.03)";
  	    emptyShade.style.pointerEvents = "none";
  	
  	    const tooltip = createTooltip(fuel, fillColor);
  	
  	    root.onmouseenter = function () {
  	      tooltip.style.opacity = "1";
  	      tooltip.style.transform = "translateX(-50%) translateY(-2px)";
  	    };
  	
  	    root.onmouseleave = function () {
  	      tooltip.style.opacity = "0";
  	      tooltip.style.transform = "translateX(-50%) translateY(0)";
  	    };
  	
  	    fill.appendChild(fillShine);
  	    gaugeWrap.appendChild(fill);
  	    gaugeWrap.appendChild(emptyShade);
  	
  	    shell.appendChild(labelE);
  	    shell.appendChild(gaugeWrap);
  	    shell.appendChild(labelF);
  	
  	    root.appendChild(shell);
  	    root.appendChild(tooltip);
  	  }
  	
  	  function attempt() {
  	    const root = getDomElement(ComponentInput);
  	    const vehicle = VehicleInput;
  	
  	    if (!root) {
  	      if (Date.now() - START < MAX_WAIT_MS) {
  	        setTimeout(attempt, RETRY_MS);
  	      }
  	      return;
  	    }
  	
  	    if (!vehicle) {
  	      if (Date.now() - START < MAX_WAIT_MS) {
  	        setTimeout(attempt, RETRY_MS);
  	      } else {
  	        setHidden(root);
  	      }
  	      return;
  	    }
  	
  	    const fuel = resolveFuel(vehicle);
  	
  	    if (!fuel.visible) {
  	      setHidden(root);
  	      return;
  	    }
  	
  	    renderFuelGauge(root, fuel);
  	  }
  	
  	  attempt();
  	})(
  	  typeof Component !== "undefined" ? Component : __trackitFuelArgs[0],
  	  typeof Vehicle !== "undefined" ? Vehicle : __trackitFuelArgs[1]
  	);
  })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a4939b31591ffb081f481c781b885308')), ___arguments.context.getComponentDataStoreByUid('6c788686090312d9aa15b1483018fbb8'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Office/components/77f7a2f37ce155b8530f61198ab9e503/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 350 || 0));
  await BackendlessUI.Functions.Custom['fn_5f5f461bf34ccd068f9312393141132a'](___arguments.context.appData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('77f7a2f37ce155b8530f61198ab9e503')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Office/components/3ce5232a03b82af8ca3633383f284d85/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var error, item, Tractors, k, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Tractors2() {
  Tractors = [];
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Companies'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Tractors'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      addItemToList(Tractors, k);
    }
  }
  return await asyncListFilter(Tractors, async (item) => {


 return (!(await BackendlessUI.Functions.Custom['fn_629c27af68227fc75311860d0568b097']((getObjectProperty(item, 'Tracker')))));
})
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Home')) == 'LiveTrack') {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e')), [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd'))]);
      try {
        await (async function(Map, Vehicles, App) {
        	/*
        	  TrackIT Reset Map View
        	
        	  Custom Code Inputs:
        	    Map      = Track Component Map
        	    Vehicles = Tractors
        	    App      = App Data
        	
        	  Action:
        	    - Close open truck popup
        	    - Stop following selected truck
        	    - Clear SelectedTractorMarker / SelectedTractor
        	    - Fit map back to all truck markers / all vehicle positions
        	    - Reset zoom back out
        	*/
        	
        	(function resetTrackITMapView(MapInput, VehiclesInput, AppInput) {
        	  const RESET_MAX_ZOOM = 14;
        	  const SINGLE_VEHICLE_ZOOM = 14;
        	
        	  function getGoogleMap(mapComponent) {
        	    if (!mapComponent) return null;
        	
        	    // Backendless Google Map component shape
        	    if (mapComponent.map && mapComponent.map.map) {
        	      return mapComponent.map.map;
        	    }
        	
        	    // Already a Google Map instance
        	    if (typeof google !== "undefined" && mapComponent instanceof google.maps.Map) {
        	      return mapComponent;
        	    }
        	
        	    return null;
        	  }
        	
        	  function getAppBag() {
        	    if (AppInput?.data && typeof AppInput.data === "object") {
        	      return AppInput.data;
        	    }
        	
        	    if (AppInput && typeof AppInput === "object" && !("data" in AppInput)) {
        	      return AppInput;
        	    }
        	
        	    if (typeof BackendlessUI !== "undefined" && BackendlessUI?.App?.data) {
        	      return BackendlessUI.App.data;
        	    }
        	
        	    if (typeof window !== "undefined" && window.AppData) {
        	      return window.AppData.data || window.AppData;
        	    }
        	
        	    return null;
        	  }
        	
        	  function refreshApp() {
        	    try {
        	      BackendlessUI?.App?.refresh?.();
        	    } catch (_) {}
        	  }
        	
        	  function clearSelectedTractorMarker() {
        	    const bag = getAppBag();
        	
        	    if (bag) {
        	      try {
        	        delete bag.SelectedTractorMarker;
        	      } catch (_) {
        	        bag.SelectedTractorMarker = null;
        	      }
        	
        	      try {
        	        bag.SelectedTractor = null;
        	      } catch (_) {}
        	    }
        	
        	    try {
        	      if (AppInput?.SelectedTractorMarker?.setMap) {
        	        AppInput.SelectedTractorMarker.setMap(null);
        	      }
        	
        	      AppInput.SelectedTractorMarker = null;
        	    } catch (_) {}
        	
        	    try {
        	      window.SelectedTractor = null;
        	    } catch (_) {}
        	
        	    refreshApp();
        	  }
        	
        	  function num(v) {
        	    return typeof v === "number" ? v : Number(v);
        	  }
        	
        	  function getPath(obj, path) {
        	    if (!obj || !path) return undefined;
        	
        	    // Supports literal dotted keys like Location["position.latitude"]
        	    if (Object.prototype.hasOwnProperty.call(obj, path)) {
        	      return obj[path];
        	    }
        	
        	    return String(path).split(".").reduce((cur, part) => {
        	      return cur && cur[part] !== undefined ? cur[part] : undefined;
        	    }, obj);
        	  }
        	
        	  function getLatLngFromVehicle(item) {
        	    if (Number.isFinite(num(item?.lat)) && Number.isFinite(num(item?.lng))) {
        	      return {
        	        lat: num(item.lat),
        	        lng: num(item.lng)
        	      };
        	    }
        	
        	    const T = item?.Tractor || item;
        	    const L = T?.Location || item?.Location;
        	
        	    const lat = num(getPath(L, "position.latitude"));
        	    const lng = num(getPath(L, "position.longitude"));
        	
        	    if (Number.isFinite(lat) && Number.isFinite(lng)) {
        	      return {
        	        lat,
        	        lng
        	      };
        	    }
        	
        	    return null;
        	  }
        	
        	  function collectMarkerPositions(map) {
        	    const positions = [];
        	    const store = map.__truckPins || {};
        	
        	    Object.keys(store).forEach(id => {
        	      const marker = store[id]?.marker;
        	
        	      if (!marker || typeof marker.getPosition !== "function") return;
        	
        	      const pos = marker.getPosition();
        	
        	      if (pos) {
        	        positions.push(pos);
        	      }
        	    });
        	
        	    return positions;
        	  }
        	
        	  function collectVehiclePositions() {
        	    const positions = [];
        	    const vehicles = Array.isArray(VehiclesInput) ? VehiclesInput : [];
        	
        	    vehicles.forEach(vehicle => {
        	      const pos = getLatLngFromVehicle(vehicle);
        	
        	      if (pos) {
        	        positions.push(pos);
        	      }
        	    });
        	
        	    return positions;
        	  }
        	
        	  const map = getGoogleMap(MapInput);
        	
        	  if (!map || typeof google === "undefined" || !(map instanceof google.maps.Map)) {
        	    console.error("[TrackIT Reset] Invalid Map input.");
        	    return;
        	  }
        	
        	  // Close active truck popup.
        	  try {
        	    if (map.__truckInfoWindow) {
        	      map.__truckInfoWindow.close();
        	      map.__truckInfoWindow.__currentId = null;
        	      map.__truckInfoWindow.__currentTractor = null;
        	    }
        	  } catch (_) {}
        	
        	  // Stop follow mode.
        	  try {
        	    if (map.__follow) {
        	      map.__follow.enabled = false;
        	      map.__follow.id = null;
        	    }
        	  } catch (_) {}
        	
        	  clearSelectedTractorMarker();
        	
        	  // Prefer actual marker positions. Fall back to Vehicles array.
        	  let positions = collectMarkerPositions(map);
        	
        	  if (!positions.length) {
        	    positions = collectVehiclePositions();
        	  }
        	
        	  if (!positions.length) {
        	    console.warn("[TrackIT Reset] No vehicle positions found.");
        	    return;
        	  }
        	
        	  if (positions.length === 1) {
        	    map.setCenter(positions[0]);
        	    map.setZoom(SINGLE_VEHICLE_ZOOM);
        	    return;
        	  }
        	
        	  const bounds = new google.maps.LatLngBounds();
        	
        	  positions.forEach(pos => {
        	    bounds.extend(pos);
        	  });
        	
        	  map.fitBounds(bounds, {
        	    top: 90,
        	    right: 90,
        	    bottom: 90,
        	    left: 260
        	  });
        	
        	  google.maps.event.addListenerOnce(map, "idle", function () {
        	    try {
        	      if (map.getZoom() > RESET_MAX_ZOOM) {
        	        map.setZoom(RESET_MAX_ZOOM);
        	      }
        	    } catch (_) {}
        	  });
        	
        	})(
        	  typeof Map !== "undefined" ? Map : null,
        	  typeof Vehicles !== "undefined" ? Vehicles : [],
        	  typeof App !== "undefined" ? App : null
        	);
        })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c5c1158d7432af8a60840f7e4d8f854')), (await Tractors2()), ___arguments.context.appData);

      } catch (error) {
        console.log(error);

      }
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Home')) == 'Dash') {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd'))]);
      await BackendlessUI.Functions.Custom['fn_2a3bf3cde9c8d10f742f3579cbb2a766'](___arguments.context.appData);
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Home')) == 'Bowser') {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(null, [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd'))]);
      await BackendlessUI.Functions.Custom['fn_fc9582288a86cc06b9574b62748e2a12'](___arguments.context.appData);
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Home')) == 'Locations') {
      await (async function(Open, Close) {
      	(function drawerSort(openDrawer, drawersToClose) {
      	  // ---------- utilities ----------
      	  const isPromise = v => v && typeof v.then === 'function';
      	  const unwrap = c => c?.component || c?.view || c;
      	
      	  function tryCall(comp, methods, arg) {
      	    const t = unwrap(comp);
      	    if (!t) return false;
      	    for (const m of methods) {
      	      const fn = t[m];
      	      if (typeof fn === 'function') {
      	        try {
      	          const r = fn.call(t, arg);
      	          if (isPromise(r)) r.catch(() => {}); // swallow async errors
      	          return true;
      	        } catch (e) {
      	          console.warn('[DrawerSort] method failed:', m, e);
      	        }
      	      }
      	    }
      	    return false;
      	  }
      	
      	  function isOpen(comp) {
      	    const t = unwrap(comp);
      	    try {
      	      if (typeof t?.isOpen === 'function') return !!t.isOpen();
      	      if ('opened' in t) return !!t.opened;
      	      if ('visible' in t) return !!t.visible;
      	      if (typeof t?.getState === 'function') return !!t.getState()?.open;
      	    } catch (_) {}
      	    return null; // unknown
      	  }
      	
      	  function closeSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === false) return; // already closed -> skip
      	    if (tryCall(comp, ['close', 'hide', 'collapse'])) return;
      	    // property fallbacks (wrapped in try so it never throws)
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = false;
      	      if ('visible' in t) t.visible = false;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback close failed:', e);
      	    }
      	  }
      	
      	  function openSafe(comp) {
      	    if (!comp) return;
      	    const opened = isOpen(comp);
      	    if (opened === true) return; // already open
      	    if (tryCall(comp, ['open', 'show', 'expand'])) return;
      	    try {
      	      const t = unwrap(comp);
      	      if ('opened' in t) t.opened = true;
      	      if ('visible' in t) t.visible = true;
      	    } catch (e) {
      	      console.warn('[DrawerSort] fallback open failed:', e);
      	    }
      	  }
      	
      	  // ---------- logic ----------
      	  const toClose = Array.isArray(drawersToClose)
      	    ? drawersToClose.filter(Boolean)
      	    : (drawersToClose ? [drawersToClose] : []);
      	
      	  toClose.forEach(c => { if (c !== openDrawer) closeSafe(c); });
      	  openSafe(openDrawer);
      	})(arguments[0], arguments[1]);

      })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a977ecfe2883ee4456e6178edbc23fd')), [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('435f12084158a6e2ea88a0ee4a15c18e')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('332c7b6dd01a3d7e91a5a418524866cd'))]);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Road/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await (async function(App, SVG) {
  	/*
  	 Fleet In Form — Driver Mobile
  	 Version 1.0.14

  	 Purpose
  	 - Phone-only driver workspace.
  	 - Board one company vehicle only by scanning its steel QR tag. No manual boarding path exists.
  	 - Open the device rear camera and match the QR payload to the vehicle objectId already loaded in App Data.
  	 - Keep Users.Tractor and the current Tractorview Driver relation aligned.
  	 - Leave the current vehicle safely.
  	 - Capture on-road fuel through a large, simple step-by-step flow using the vehicle's distance or operating-hours meter profile.
  	 - Apply every accepted fuel reading to Data.Vehicle.Usage.CurrentReading, the legacy Tractor.Mileage field, the active Tractorview and fitted tyre usage/history.
  	 - Advance fitted tyres from the positive operating-reading differential for both kilometre and hour/Hobbs vehicles, respecting tag-axle wear rates and spare positions.
  	 - Re-evaluate Dashboard-equivalent Service and Preventive Maintenance notification thresholds after fuel capture.
  	 - Honour Notify Service Provider and Notify Company independently.
  	 - Resolve the owning Company from AppData.User.Companies and silently email its configured company address when Notify Company is enabled.
  	 - DUE_SOON is one-time per enabled recipient; OVERDUE / UNSERVICED emails repeat after every new Driver Mobile FuelOut until the service cycle is reset.
  	 - Service emails include Registration, Make, Model, Year, VIN and Engine Number plus the Service/Maintenance status and triggering FuelOut.
  	 - All Service email success, failure and audit activity remains completely invisible to the driver.
  	 - Start GPS immediately when fuel capture opens and expose only company fuel locations containing the driver or within 20 metres, while always allowing Other.
  	 - Silently capture the latest Flespi can.vehicle.mileage when fuel capture opens and attach a valid reading to the FuelOut audit payload.
  	 - Offer one optional fuel-slip photo and one optional odometer / vehicle-meter photo before review.
  	 - Open the rear phone camera through the native capture control and compress accepted photos to readable JPEG evidence before upload.
  	 - Save FuelOut first; optional photo upload failure never invalidates the saved fuel transaction.
  	 - Provide the protected, permission-aware Fleet In Form application switcher from the header Logout button.
  	 - Preserve the confirmed explicit logout action that ends the Backendless session and opens Login.
  	 - Treat Driver Mobile as Road and exclude Road from the application menu.

  	 Expected inputsa
  	 - App / AppData with AppData.User and related Companies, Tractors and Locations.
  	 - Backendless, either as the local Backendless variable or window.Backendless.
  	 - SVG is optional and is used only as a supplied brand mark when available.

  	 Database relationships used
  	 - Users.Tractor
  	 - Tractorview.Driver1 or Tractorview.Driver2
  	 - Companies.FuelOut
  	 - Tractors.FuelOut
  	 - Tractorview.Fuel
  	 - Companies.Transactions
  	 - Tractors.Transactions
  	 - Tractorview.Transactions
  	 - FuelOut.Transactions
  	 - Transactions.Company, Tractor, TractorPeriod and FuelOutRecord

  	 Fuel and financial record tables
  	 - FuelOut
  	 - Transactions

  	 Transaction rules
  	 - TransactionDate and PostingDate are Backendless DATE values.
  	 - Financial Transactions.Odometer remains blank; the operating meter stays on FuelOut and Tractor only.
  	*/

  	return (async function FleetInFormDriverMobileV1_0_15() {
  	  "use strict";

  	  const VERSION = "1.0.15";
  	  const ROOT_ID = "fif-driver-mobile-root";
  	  const STYLE_ID = "fif-driver-mobile-style-v1015";
  	  const V104_STYLE_ID = "fif-driver-mobile-v104-style";
  	  const V108_STYLE_ID = "fif-driver-mobile-v108-style";
  	  const DIALOG_ID = "fif-driver-mobile-dialog";
  	  const OPERATION_ID = "fif-driver-mobile-operation";
  	  const APP_MENU_ID = "fif-driver-mobile-app-switcher";
  	  const LOGOUT_GUARD_KEY = "__FIF_LOGOUT_GUARD_V1__";
  	  const PUBLIC_KEY = "FIFDriverMobile";
  	  const DRIVER_SLOTS = ["Driver1", "Driver2"];
  	  const USER_TRACTOR_RELATION = "Tractor";
  	  const MAX_GPS_AGE_MS = 0;
  	  const GPS_TIMEOUT_MS = 30000;
  	  const GPS_TARGET_ACCURACY_M = 25;
  	  const GPS_ACCEPTABLE_ACCURACY_M = 80;
  	  const GPS_HARD_LIMIT_ACCURACY_M = 250;
  	  const FUEL_LOCATION_PROXIMITY_M = 20;
  	  const GPS_FIX_MAX_AGE_MS = 10 * 60 * 1000;
  	  const QR_BOARD_AUTHORISATION_MS = 2 * 60 * 1000;
  	  const FLESPI_AUTH_TOKEN = "FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW";
  	  const FLESPI_MILEAGE_PARAMETER = "can.vehicle.mileage";
  	  const FLESPI_REQUEST_TIMEOUT_MS = 8000;
  	  const FUEL_FILE_API_BASE = "https://files-api.fiffiles.com";
  	  const FUEL_PHOTO_MAX_SOURCE_BYTES = 30 * 1024 * 1024;
  	  const FUEL_PHOTO_TARGET_BYTES = 1800 * 1024;
  	  const FUEL_PHOTO_MAX_DIMENSION = 2200;
  	  const FUEL_PHOTO_MIN_DIMENSION = 1100;
  	  const FUEL_PHOTO_INITIAL_QUALITY = 0.84;
  	  const FUEL_PHOTO_MIN_QUALITY = 0.58;

  	  const APP_INPUT = typeof App !== "undefined" ? App : null;
  	  const HUB_INPUT = typeof Hub !== "undefined" ? Hub : null;
  	  const SVG_INPUT = typeof SVG !== "undefined" ? SVG : null;

  	  function clean(value) {
  	    if (value === null || value === undefined) return "";
  	    return String(value).trim();
  	  }

  	  function lower(value) {
  	    return clean(value).toLowerCase();
  	  }

  	  function arr(value) {
  	    if (Array.isArray(value)) return value;
  	    if (value === null || value === undefined || value === "") return [];
  	    return [value];
  	  }

  	  function clone(value) {
  	    if (value === undefined) return undefined;
  	    try {
  	      return JSON.parse(JSON.stringify(value));
  	    } catch (_) {
  	      if (Array.isArray(value)) return value.slice();
  	      if (value && typeof value === "object") return Object.assign({}, value);
  	      return value;
  	    }
  	  }

  	  function firstValue(values, fallback) {
  	    for (let index = 0; index < values.length; index += 1) {
  	      const value = values[index];
  	      if (value !== undefined && value !== null && value !== "") return value;
  	    }
  	    return fallback;
  	  }

  	  function getDeep(object, path, fallback) {
  	    let current = object;
  	    for (let index = 0; index < path.length; index += 1) {
  	      if (current === null || current === undefined) return fallback;
  	      current = current[path[index]];
  	    }
  	    return current === null || current === undefined ? fallback : current;
  	  }

  	  function descriptorValue(value) {
  	    if (!value || typeof value !== "object" || Array.isArray(value)) return value;
  	    return firstValue([
  	      value.value,
  	      value.Value,
  	      value.current,
  	      value.Current,
  	      value.selected,
  	      value.Selected,
  	      value.label,
  	      value.Label
  	    ], value);
  	  }

  	  function numberValue(value) {
  	    const raw = descriptorValue(value);
  	    if (raw === null || raw === undefined || raw === "") return null;
  	    const parsed = Number(String(raw).replace(/\s/g, "").replace(/,/g, "."));
  	    return Number.isFinite(parsed) ? parsed : null;
  	  }

  	  function numberOr(value, fallback) {
  	    const parsed = numberValue(value);
  	    return parsed === null ? fallback : parsed;
  	  }

  	  function objectIdOf(value) {
  	    if (!value) return "";
  	    // Fleet In Form uses opaque alphanumeric identifiers such as SA IDs,
  	    // company names and vehicle codes. Never coerce them to numbers or UUIDs.
  	    if (typeof value === "string" || typeof value === "number") return clean(value);
  	    return clean(firstValue([
  	      value.objectId,
  	      value.ObjectId,
  	      value.objectID,
  	      value.ID,
  	      value.id
  	    ], ""));
  	  }

  	  function uniqueObjects(rows) {
  	    const seen = Object.create(null);
  	    const result = [];
  	    arr(rows).forEach(function (row, index) {
  	      if (!row) return;
  	      const key = objectIdOf(row) || clean(firstValue([row.ID, row.FID, row.Name], "row-" + index));
  	      if (!key || seen[key]) return;
  	      seen[key] = true;
  	      result.push(row);
  	    });
  	    return result;
  	  }

  	  function escapeHtml(value) {
  	    return String(value === null || value === undefined ? "" : value)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/\"/g, "&quot;")
  	      .replace(/'/g, "&#039;");
  	  }

  	  function escapeAttr(value) {
  	    return escapeHtml(value).replace(/`/g, "&#096;");
  	  }

  	  function formatNumber(value, decimals) {
  	    const parsed = numberValue(value);
  	    if (parsed === null) return "—";
  	    return new Intl.NumberFormat("en-ZA", {
  	      minimumFractionDigits: decimals || 0,
  	      maximumFractionDigits: decimals || 0
  	    }).format(parsed);
  	  }

  	  function formatMoney(value) {
  	    const parsed = numberValue(value);
  	    if (parsed === null) return "R 0.00";
  	    return new Intl.NumberFormat("en-ZA", {
  	      style: "currency",
  	      currency: "ZAR",
  	      minimumFractionDigits: 2,
  	      maximumFractionDigits: 2
  	    }).format(parsed);
  	  }

  	  function resolveAppData(input) {
  	    const candidates = [
  	      input && input.data,
  	      input,
  	      typeof AppData !== "undefined" ? AppData : null,
  	      typeof window !== "undefined" && window.AppData ? (window.AppData.data || window.AppData) : null,
  	      typeof window !== "undefined" && window.APP_DATA ? window.APP_DATA : null
  	    ];
  	    for (let index = 0; index < candidates.length; index += 1) {
  	      if (candidates[index] && candidates[index].User) return candidates[index];
  	    }
  	    return null;
  	  }

  	  function resolveBackendless() {
  	    const candidates = [
  	      typeof Backendless !== "undefined" ? Backendless : null,
  	      typeof window !== "undefined" ? window.Backendless : null,
  	      APP_INPUT && APP_INPUT.Backendless,
  	      APP_INPUT && APP_INPUT.backendless
  	    ];
  	    return candidates.find(function (item) {
  	      return item && item.Data && typeof item.Data.of === "function";
  	    }) || null;
  	  }

  	  const APP_DATA = resolveAppData(APP_INPUT);
  	  const DB = resolveBackendless();

  	  function userRecord() {
  	    return APP_DATA && APP_DATA.User ? APP_DATA.User : null;
  	  }

  	  const APPLICATION_PAGES = Object.freeze({
  	    FIFM: "FIFM",
  	    Office: "Office",
  	    Road: "Road",
  	    Bowser: "Bowser",
  	    "Mobile Tracking": "MobileTracking",
  	    Snapshot: "Snapshot"
  	  });

  	  function normaliseApplicationName(value) {
  	    switch (lower(value).replace(/[\s_-]+/g, "")) {
  	      case "fifm":
  	        return "FIFM";
  	      case "office":
  	        return "Office";
  	      case "road":
  	      case "drivermobile":
  	      case "mobiledriver":
  	        return "Road";
  	      case "bowser":
  	        return "Bowser";
  	      case "mobiletracking":
  	        return "Mobile Tracking";
  	      case "snapshot":
  	        return "Snapshot";
  	      default:
  	        return clean(value);
  	    }
  	  }

  	  function currentApplication() {
  	    try {
  	      const page = new URL(window.location.href).searchParams.get("page");
  	      const fromPage = normaliseApplicationName(page);
  	      if (APPLICATION_PAGES[fromPage]) return fromPage;
  	    } catch (_) {}

  	    const fromData = normaliseApplicationName(APP_DATA && APP_DATA.APP);
  	    return APPLICATION_PAGES[fromData] ? fromData : "Road";
  	  }

  	  function allowedApplicationsFor(user) {
  	    const raw = Array.isArray(user && user.APP)
  	      ? user.APP
  	      : clean(user && user.APP).split(",");

  	    const allowed = raw
  	      .map(normaliseApplicationName)
  	      .filter(function (name) {
  	        return !!APPLICATION_PAGES[name];
  	      });

  	    if (lower(user && user.Office).indexOf("livetrack") !== -1) {
  	      allowed.push("Mobile Tracking");
  	    }
  	    if (lower(user && user.Settings).indexOf("overview") !== -1) {
  	      allowed.push("Snapshot");
  	    }

  	    return allowed.filter(function (name, index, list) {
  	      return list.indexOf(name) === index;
  	    });
  	  }

  	  function installLogoutGuard() {
  	    try {
  	      if (
  	        !DB ||
  	        !DB.UserService ||
  	        typeof DB.UserService.logout !== "function"
  	      ) {
  	        return null;
  	      }

  	      const service = DB.UserService;
  	      const existing = window[LOGOUT_GUARD_KEY];

  	      if (
  	        existing &&
  	        existing.service === service &&
  	        service.logout === existing.wrapper
  	      ) {
  	        return existing;
  	      }

  	      const original =
  	        existing &&
  	        existing.service === service &&
  	        typeof existing.original === "function"
  	          ? existing.original
  	          : service.logout;

  	      const guard = {
  	        version: "1.0",
  	        service: service,
  	        original: original,
  	        wrapper: null,
  	        explicitBusy: false,
  	        blockedCount: existing && existing.blockedCount
  	          ? existing.blockedCount
  	          : 0,
  	        async explicitLogout() {
  	          if (guard.explicitBusy) return false;
  	          guard.explicitBusy = true;
  	          try {
  	            return await guard.original.apply(guard.service, arguments);
  	          } finally {
  	            guard.explicitBusy = false;
  	          }
  	        }
  	      };

  	      guard.wrapper = function protectedBackendlessLogout() {
  	        guard.blockedCount += 1;
  	        console.warn(
  	          "[FIF Logout Guard] Blocked a background logout during app switching.",
  	          { blockedCount: guard.blockedCount }
  	        );
  	        return Promise.resolve(false);
  	      };

  	      try {
  	        service.logout = guard.wrapper;
  	      } catch (_) {
  	        Object.defineProperty(service, "logout", {
  	          configurable: true,
  	          writable: true,
  	          value: guard.wrapper
  	        });
  	      }

  	      if (service.logout !== guard.wrapper) return null;
  	      window[LOGOUT_GUARD_KEY] = guard;
  	      return guard;
  	    } catch (error) {
  	      console.error("[FIF Logout Guard] Could not install.", error);
  	      return null;
  	    }
  	  }

  	  const logoutGuard = installLogoutGuard();

  	  function userName(user) {
  	    const details = getDeep(user, ["Data_Details", "employee_details"], {}) || {};
  	    return clean(firstValue([
  	      user && user.name,
  	      [details.first_name, details.last_name].filter(Boolean).join(" "),
  	      user && user.email,
  	      "Driver"
  	    ], "Driver"));
  	  }

  	  function displayValue(value) {
  	    const resolved = descriptorValue(value);
  	    if (resolved === null || resolved === undefined || typeof resolved === "object") return "";
  	    return clean(resolved);
  	  }

  	  function companyName(company) {
  	    return clean(firstValue([
  	      displayValue(company && company.Name),
  	      displayValue(company && company.CompanyName),
  	      displayValue(company && company.FID),
  	      displayValue(company && company.ID),
  	      displayValue(getDeep(company, ["Data", "Name"], "")),
  	      "Company"
  	    ], "Company"));
  	  }

  	  function vehicleName(vehicle) {
  	    return clean(firstValue([
  	      displayValue(vehicle && vehicle.Name),
  	      displayValue(vehicle && vehicle.VehicleName),
  	      displayValue(vehicle && vehicle.FID),
  	      displayValue(vehicle && vehicle.ID),
  	      displayValue(vehicle && vehicle.Registration),
  	      displayValue(getDeep(vehicle, ["Data", "Vehicle", "Name"], "")),
  	      displayValue(getDeep(vehicle, ["Data", "Vehicle", "Registration"], "")),
  	      "Company vehicle"
  	    ], "Company vehicle"));
  	  }

  	  function vehicleSubtitle(vehicle) {
  	    const make = clean(firstValue([
  	      displayValue(vehicle && vehicle.Make),
  	      displayValue(getDeep(vehicle, ["Data", "Vehicle", "Make"], "")),
  	      displayValue(getDeep(vehicle, ["Data", "General", "Make"], ""))
  	    ], ""));
  	    const model = clean(firstValue([
  	      displayValue(vehicle && vehicle.Model),
  	      displayValue(getDeep(vehicle, ["Data", "Vehicle", "Model"], "")),
  	      displayValue(getDeep(vehicle, ["Data", "General", "Model"], ""))
  	    ], ""));
  	    const registration = clean(firstValue([
  	      displayValue(vehicle && vehicle.Registration),
  	      displayValue(vehicle && vehicle.RegNo),
  	      displayValue(getDeep(vehicle, ["Data", "Vehicle", "Registration"], "")),
  	      displayValue(getDeep(vehicle, ["Data", "Vehicle", "Identity", "Registration"], ""))
  	    ], ""));
  	    return [make, model, registration].filter(Boolean).join(" · ") || "Powered company vehicle";
  	  }

  	  function companyRows() {
  	    if (!APP_DATA) return [];
  	    return uniqueObjects(
  	      arr(getDeep(APP_DATA, ["User", "Companies"], []))
  	        .concat(arr(APP_DATA.Companies))
  	    );
  	  }

  	  function companyTractors(company) {
  	    return uniqueObjects(
  	      arr(company && company.Tractors)
  	        .concat(arr(getDeep(company, ["Data", "Tractors"], [])))
  	        .concat(arr(company && company.Vehicles))
  	    ).filter(function (vehicle) {
  	      const type = lower(firstValue([
  	        vehicle && vehicle.Type,
  	        vehicle && vehicle.AssetType,
  	        getDeep(vehicle, ["Data", "Vehicle", "Type"], "")
  	      ], ""));
  	      return !/trailer|implement|bowser|tank/.test(type);
  	    });
  	  }

  	  function currentView(vehicle) {
  	    if (vehicle && vehicle.ViewC && typeof vehicle.ViewC === "object") return vehicle.ViewC;
  	    const views = arr(vehicle && vehicle.Tractorview).concat(arr(vehicle && vehicle.Views));
  	    return views.find(function (view) {
  	      return /current|active/i.test(clean(firstValue([view && view.Status, view && view.Type], "")));
  	    }) || null;
  	  }

  	  function relationId(value) {
  	    if (!value) return "";
  	    if (typeof value === "string" || typeof value === "number") return clean(value);
  	    return objectIdOf(value);
  	  }

  	  function relationList(value) {
  	    if (Array.isArray(value)) return value;
  	    if (value && typeof value === "object") return [value];
  	    return [];
  	  }

  	  function userVehicleRelations(user) {
  	    // The actual Users schema exposes one current vehicle through Users.Tractor.
  	    // Read the old plural shape only as a harmless local-data fallback; never write it.
  	    return relationList(user && (user.Tractor || user.Tractors));
  	  }

  	  function setLocalUserVehicle(user, vehicle) {
  	    if (!user) return;
  	    user.Tractor = vehicle || null;
  	    // Prevent a stale local plural value from making the driver appear boarded twice.
  	    if (Object.prototype.hasOwnProperty.call(user, "Tractors")) user.Tractors = [];
  	  }

  	  function viewDriverSlot(view, userId) {
  	    if (!view || !userId) return "";
  	    return DRIVER_SLOTS.find(function (slot) {
  	      return relationId(view[slot]) === userId;
  	    }) || "";
  	  }

  	  function occupiedDriverName(value) {
  	    if (!value || typeof value !== "object") return "another driver";
  	    return userName(value);
  	  }

  	  function companiesAndVehicles() {
  	    const rows = [];
  	    companyRows().forEach(function (company) {
  	      companyTractors(company).forEach(function (vehicle) {
  	        rows.push({ company: company, vehicle: vehicle });
  	      });
  	    });
  	    return rows;
  	  }

  	  function findAssignment() {
  	    const user = userRecord();
  	    const userId = objectIdOf(user);
  	    if (!user || !userId) return null;

  	    const all = companiesAndVehicles();
  	    const relatedIds = userVehicleRelations(user).map(objectIdOf).filter(Boolean);

  	    for (let index = 0; index < all.length; index += 1) {
  	      const row = all[index];
  	      const view = currentView(row.vehicle);
  	      const slot = viewDriverSlot(view, userId);
  	      if (slot) return Object.assign({}, row, { view: view, slot: slot, source: "ViewC" });
  	    }

  	    for (let index = 0; index < all.length; index += 1) {
  	      const row = all[index];
  	      if (relatedIds.indexOf(objectIdOf(row.vehicle)) !== -1) {
  	        return Object.assign({}, row, {
  	          view: currentView(row.vehicle),
  	          slot: "",
  	          source: "Users.Tractor"
  	        });
  	      }
  	    }

  	    return null;
  	  }

  	  function freeDriverSlot(vehicle, userId) {
  	    const view = currentView(vehicle);
  	    if (!view || !objectIdOf(view)) return { slot: "", reason: "No current vehicle period" };
  	    const existing = viewDriverSlot(view, userId);
  	    if (existing) return { slot: existing, reason: "" };
  	    for (let index = 0; index < DRIVER_SLOTS.length; index += 1) {
  	      const slot = DRIVER_SLOTS[index];
  	      if (!relationId(view[slot])) return { slot: slot, reason: "" };
  	    }
  	    return {
  	      slot: "",
  	      reason: occupiedDriverName(view.Driver1) + " and " + occupiedDriverName(view.Driver2) + " are already assigned"
  	    };
  	  }

  	  function locationName(location) {
  	    return clean(firstValue([
  	      location && location.Name,
  	      location && location.LocationName,
  	      location && location.Title,
  	      location && location.FID,
  	      location && location.ID,
  	      getDeep(location, ["Data", "Name"], ""),
  	      getDeep(location, ["Data", "Location", "Name"], ""),
  	      "Fuel station"
  	    ], "Fuel station"));
  	  }

  	  function locationType(location) {
  	    return clean(firstValue([
  	      location && location.Type,
  	      location && location.LocationType,
  	      location && location.Category,
  	      getDeep(location, ["LocationData", "Type"], ""),
  	      getDeep(location, ["Data", "Type"], ""),
  	      getDeep(location, ["Data", "Location", "Type"], "")
  	    ], ""));
  	  }

  	  function truthyFuel(value) {
  	    const raw = descriptorValue(value);
  	    if (raw === true || raw === 1) return true;
  	    if (raw === false || raw === 0 || raw === null || raw === undefined || raw === "") return false;
  	    if (Array.isArray(raw)) return raw.some(truthyFuel);
  	    if (typeof raw === "object") {
  	      return truthyFuel(firstValue([
  	        raw.Enabled,
  	        raw.Active,
  	        raw.IsEnabled,
  	        raw.HasFuel,
  	        raw.AllowFuel,
  	        raw.FuelEnabled,
  	        raw.value
  	      ], Object.keys(raw).length > 0));
  	    }
  	    return /^(true|yes|active|enabled|fuel|on|1)$/i.test(clean(raw));
  	  }

  	  function isFuelLocation(location) {
  	    const type = locationType(location);
  	    if (/(^|\s|[-_/])fuel($|\s|[-_/])/i.test(type)) return true;
  	    return [
  	      location && location.FuelLogic,
  	      location && location.Fuel_Logic,
  	      location && location.HasFuel,
  	      location && location.FuelEnabled,
  	      location && location.Logic,
  	      getDeep(location, ["Logic", "Fuel"], null),
  	      getDeep(location, ["LocationData", "FuelLogic"], null),
  	      getDeep(location, ["LocationData", "Logic", "Fuel"], null),
  	      getDeep(location, ["LocationData", "Area", "Functionality", "FuelLogic"], null),
  	      getDeep(location, ["LocationData", "Area", "Functionality", "FuelDepot"], null),
  	      getDeep(location, ["Functionality", "FuelLogic"], null),
  	      getDeep(location, ["Functionality", "FuelDepot"], null),
  	      getDeep(location, ["Functionality", "PublicFuelStation"], null),
  	      getDeep(location, ["Data", "FuelLogic"], null),
  	      getDeep(location, ["Data", "Logic", "Fuel"], null),
  	      getDeep(location, ["Data", "LocationData", "Area", "Functionality", "FuelLogic"], null)
  	    ].some(truthyFuel);
  	  }

  	  function companyLocations(company) {
  	    const result = [];
  	    const seen = Object.create(null);
  	    const visit = function (location, fallbackIndex) {
  	      if (!location || typeof location !== "object") return;
  	      const key = objectIdOf(location) || clean(firstValue([location.ID, location.FID, location.Name], "location-" + fallbackIndex));
  	      if (key && seen[key]) return;
  	      if (key) seen[key] = true;
  	      result.push(location);
  	      arr(location.Fields).forEach(visit);
  	      arr(location.Children).forEach(visit);
  	      arr(location.Locations).forEach(visit);
  	      arr(getDeep(location, ["LocationData", "Fields"], [])).forEach(visit);
  	      arr(getDeep(location, ["Data", "Fields"], [])).forEach(visit);
  	    };
  	    arr(company && company.Locations)
  	      .concat(arr(company && company.Location))
  	      .concat(arr(getDeep(company, ["Data", "Locations"], [])))
  	      .concat(arr(getDeep(company, ["Data", "Location"], [])))
  	      .forEach(visit);
  	    return result;
  	  }

  	  function coordinatesFromObject(source) {
  	    if (!source) return null;

  	    // Backendless GeoPoint / GeoJSON Point values use [longitude, latitude].
  	    if (Array.isArray(source) && source.length >= 2) {
  	      const longitude = numberValue(source[0]);
  	      const latitude = numberValue(source[1]);
  	      if (latitude !== null && longitude !== null && latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180) {
  	        return { latitude: latitude, longitude: longitude };
  	      }
  	      return null;
  	    }
  	    if (Array.isArray(source.coordinates)) {
  	      const point = coordinatesFromObject(source.coordinates);
  	      if (point) return point;
  	    }

  	    const latitude = numberValue(firstValue([
  	      source.latitude,
  	      source.Latitude,
  	      source.lat,
  	      source.Lat,
  	      source.y,
  	      source.Y,
  	      source["position.latitude"],
  	      getDeep(source, ["position", "latitude"], null),
  	      getDeep(source, ["Position", "Latitude"], null),
  	      getDeep(source, ["coordinates", "latitude"], null),
  	      getDeep(source, ["Coordinates", "Latitude"], null)
  	    ], null));
  	    const longitude = numberValue(firstValue([
  	      source.longitude,
  	      source.Longitude,
  	      source.lng,
  	      source.Lng,
  	      source.lon,
  	      source.Lon,
  	      source.x,
  	      source.X,
  	      source["position.longitude"],
  	      getDeep(source, ["position", "longitude"], null),
  	      getDeep(source, ["Position", "Longitude"], null),
  	      getDeep(source, ["coordinates", "longitude"], null),
  	      getDeep(source, ["Coordinates", "Longitude"], null)
  	    ], null));
  	    if (latitude === null || longitude === null) return null;
  	    if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) return null;
  	    return { latitude: latitude, longitude: longitude };
  	  }

  	  function locationCoordinates(location) {
  	    // Prefer the actual entrance used by a driver, then the stored centre.
  	    const candidates = [
  	      location && location.EntrancePoint,
  	      getDeep(location, ["LocationData", "Shape", "EntrancePoint"], null),
  	      getDeep(location, ["Data", "LocationData", "Shape", "EntrancePoint"], null),
  	      location && location.Centre,
  	      location && location.Center,
  	      getDeep(location, ["LocationData", "Area", "Center"], null),
  	      getDeep(location, ["LocationData", "Area", "Centre"], null),
  	      getDeep(location, ["Data", "LocationData", "Area", "Center"], null),
  	      location,
  	      location && location.GeoPoint,
  	      location && location.Point,
  	      location && location.Coordinates,
  	      location && location.Position,
  	      location && location.Location,
  	      getDeep(location, ["LocationData"], null),
  	      getDeep(location, ["LocationData", "GeoPoint"], null),
  	      getDeep(location, ["LocationData", "Coordinates"], null),
  	      getDeep(location, ["Data"], null),
  	      getDeep(location, ["Data", "Location"], null),
  	      getDeep(location, ["Data", "Location", "GeoPoint"], null),
  	      getDeep(location, ["Data", "Coordinates"], null)
  	    ];
  	    for (let index = 0; index < candidates.length; index += 1) {
  	      const result = coordinatesFromObject(candidates[index]);
  	      if (result) return result;
  	    }
  	    return null;
  	  }

  	  function radians(value) {
  	    return value * Math.PI / 180;
  	  }

  	  function distanceKm(a, b) {
  	    if (!a || !b) return null;
  	    const earthRadius = 6371;
  	    const latitudeDistance = radians(b.latitude - a.latitude);
  	    const longitudeDistance = radians(b.longitude - a.longitude);
  	    const firstLatitude = radians(a.latitude);
  	    const secondLatitude = radians(b.latitude);
  	    const haversine = Math.sin(latitudeDistance / 2) * Math.sin(latitudeDistance / 2) +
  	      Math.sin(longitudeDistance / 2) * Math.sin(longitudeDistance / 2) *
  	      Math.cos(firstLatitude) * Math.cos(secondLatitude);
  	    return earthRadius * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
  	  }

  	  function pointInRing(point, ring) {
  	    if (!point || !Array.isArray(ring) || ring.length < 3) return false;
  	    let inside = false;
  	    const x = point.longitude;
  	    const y = point.latitude;
  	    for (let index = 0, previous = ring.length - 1; index < ring.length; previous = index++) {
  	      const currentPoint = ring[index];
  	      const previousPoint = ring[previous];
  	      if (!currentPoint || !previousPoint) continue;
  	      const xi = currentPoint.longitude;
  	      const yi = currentPoint.latitude;
  	      const xj = previousPoint.longitude;
  	      const yj = previousPoint.latitude;
  	      const intersects = ((yi > y) !== (yj > y)) &&
  	        (x < (xj - xi) * (y - yi) / ((yj - yi) || Number.EPSILON) + xi);
  	      if (intersects) inside = !inside;
  	    }
  	    return inside;
  	  }

  	  function normaliseRing(points) {
  	    return arr(points).map(coordinatesFromObject).filter(Boolean);
  	  }

  	  function locationPolygonRings(location) {
  	    const rings = [];
  	    const addCoordinates = function (coordinates) {
  	      if (!Array.isArray(coordinates) || !coordinates.length) return;
  	      // GeoJSON Polygon: [ring, hole, ...]
  	      if (Array.isArray(coordinates[0]) && Array.isArray(coordinates[0][0]) && typeof coordinates[0][0][0] !== "object") {
  	        coordinates.forEach(function (ring) {
  	          const normalised = normaliseRing(ring);
  	          if (normalised.length >= 3) rings.push(normalised);
  	        });
  	        return;
  	      }
  	      // GeoJSON MultiPolygon.
  	      if (Array.isArray(coordinates[0]) && Array.isArray(coordinates[0][0]) && Array.isArray(coordinates[0][0][0])) {
  	        coordinates.forEach(addCoordinates);
  	      }
  	    };

  	    [
  	      location && location.Polygon,
  	      getDeep(location, ["LocationData", "Polygon"], null),
  	      getDeep(location, ["Data", "Polygon"], null),
  	      getDeep(location, ["Data", "LocationData", "Polygon"], null)
  	    ].forEach(function (polygon) {
  	      if (polygon && Array.isArray(polygon.coordinates)) addCoordinates(polygon.coordinates);
  	    });

  	    [
  	      getDeep(location, ["Geometry", "rawPoints"], null),
  	      getDeep(location, ["LocationData", "Geometry", "rawPoints"], null),
  	      getDeep(location, ["Data", "Geometry", "rawPoints"], null),
  	      getDeep(location, ["Data", "LocationData", "Geometry", "rawPoints"], null)
  	    ].forEach(function (points) {
  	      const normalised = normaliseRing(points);
  	      if (normalised.length >= 3) rings.push(normalised);
  	    });
  	    return rings;
  	  }

  	  function distanceMetersToSegment(point, start, end) {
  	    if (!point || !start || !end) return Infinity;
  	    const latitudeReference = radians(point.latitude);
  	    const metresPerDegreeLatitude = 111320;
  	    const metresPerDegreeLongitude = Math.max(1, 111320 * Math.cos(latitudeReference));
  	    const px = 0;
  	    const py = 0;
  	    const ax = (start.longitude - point.longitude) * metresPerDegreeLongitude;
  	    const ay = (start.latitude - point.latitude) * metresPerDegreeLatitude;
  	    const bx = (end.longitude - point.longitude) * metresPerDegreeLongitude;
  	    const by = (end.latitude - point.latitude) * metresPerDegreeLatitude;
  	    const dx = bx - ax;
  	    const dy = by - ay;
  	    const lengthSquared = dx * dx + dy * dy;
  	    let t = lengthSquared ? ((px - ax) * dx + (py - ay) * dy) / lengthSquared : 0;
  	    t = Math.max(0, Math.min(1, t));
  	    const closestX = ax + t * dx;
  	    const closestY = ay + t * dy;
  	    return Math.sqrt(closestX * closestX + closestY * closestY);
  	  }

  	  function distanceMetersToRing(point, ring) {
  	    if (!Array.isArray(ring) || ring.length < 2) return Infinity;
  	    let shortest = Infinity;
  	    for (let index = 0; index < ring.length; index += 1) {
  	      const next = (index + 1) % ring.length;
  	      shortest = Math.min(shortest, distanceMetersToSegment(point, ring[index], ring[next]));
  	    }
  	    return shortest;
  	  }

  	  function locationProximity(location, position) {
  	    if (!position) return { inside: false, distanceMeters: null, eligible: false, method: "No GPS" };
  	    const rings = locationPolygonRings(location);
  	    let inside = false;
  	    let boundaryDistance = Infinity;
  	    rings.forEach(function (ring, index) {
  	      if (index === 0 && pointInRing(position, ring)) inside = true;
  	      boundaryDistance = Math.min(boundaryDistance, distanceMetersToRing(position, ring));
  	    });

  	    const referenceCoordinates = locationCoordinates(location);
  	    const referenceDistance = referenceCoordinates ? distanceKm(position, referenceCoordinates) * 1000 : Infinity;
  	    const distanceMeters = inside ? 0 : (Number.isFinite(boundaryDistance) ? boundaryDistance : referenceDistance);
  	    return {
  	      inside: inside,
  	      distanceMeters: Number.isFinite(distanceMeters) ? distanceMeters : null,
  	      eligible: inside || (Number.isFinite(distanceMeters) && distanceMeters <= FUEL_LOCATION_PROXIMITY_M),
  	      method: rings.length ? "Geofence" : "Location point"
  	    };
  	  }

  	  function gpsFixIsFresh(position) {
  	    if (!position || !position.capturedAt) return false;
  	    const captured = Date.parse(position.capturedAt);
  	    return Number.isFinite(captured) && Date.now() - captured <= GPS_FIX_MAX_AGE_MS;
  	  }

  	  function gpsFixCanGateFuel(position) {
  	    return !!position && gpsFixIsFresh(position) && numberOr(position.accuracy, Infinity) <= GPS_ACCEPTABLE_ACCURACY_M;
  	  }

  	  function fuelLocations(company, position) {
  	    return companyLocations(company).filter(isFuelLocation).map(function (location, index) {
  	      const coordinates = locationCoordinates(location);
  	      const proximity = locationProximity(location, position);
  	      return {
  	        key: objectIdOf(location) || clean(firstValue([location.ID, location.FID, locationName(location)], "location-" + index)),
  	        objectId: objectIdOf(location),
  	        name: locationName(location),
  	        type: locationType(location) || "Fuel",
  	        coordinates: coordinates,
  	        distance: proximity.distanceMeters === null ? null : proximity.distanceMeters / 1000,
  	        distanceMeters: proximity.distanceMeters,
  	        inside: proximity.inside,
  	        eligible: proximity.eligible,
  	        proximityMethod: proximity.method,
  	        location: location
  	      };
  	    }).sort(function (left, right) {
  	      if (left.distanceMeters !== null && right.distanceMeters !== null) return left.distanceMeters - right.distanceMeters;
  	      if (left.distanceMeters !== null) return -1;
  	      if (right.distanceMeters !== null) return 1;
  	      return left.name.localeCompare(right.name);
  	    });
  	  }

  	  function eligibleFuelLocations(company, position) {
  	    if (!gpsFixCanGateFuel(position)) return [];
  	    return fuelLocations(company, position).filter(function (location) { return location.eligible; });
  	  }

  	  function suppliedSvg() {
  	    if (!SVG_INPUT) return "";
  	    let value = SVG_INPUT;
  	    if (typeof SVG_INPUT === "object") {
  	      value = firstValue([
  	        SVG_INPUT.Logo,
  	        SVG_INPUT.logo,
  	        SVG_INPUT.FleetInForm,
  	        SVG_INPUT.Vehicle,
  	        SVG_INPUT.Truck
  	      ], "");
  	    }
  	    if (typeof value !== "string") return "";
  	    value = value.trim();
  	    if (!value) return "";
  	    // UI Builder may pass a PNG data URL through the input named SVG.
  	    if (/^data:image\//i.test(value) || /^(https?:|blob:)/i.test(value)) {
  	      return '<img src="' + escapeAttr(value) + '" alt="Fleet In Form">';
  	    }
  	    return value;
  	  }

  	  function fallbackLogo() {
  	    return '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M8 35h5l6-15h25l8 15h4v12h-5a8 8 0 0 1-16 0H26a8 8 0 0 1-16 0H8V35Zm13-9-4 9h28l-5-9H21Zm-3 25a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm25 0a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" fill="currentColor"/></svg>';
  	  }

  	  function icon(name) {
  	    const icons = {
  	      vehicle: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 11l2-5h10l2 5 2 2v6h-2a2 2 0 0 1-4 0H9a2 2 0 0 1-4 0H3v-6l2-2Zm3.4-3-1.2 3h9.6l-1.2-3H8.4ZM7 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>',
  	      fuel: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h8a2 2 0 0 1 2 2v14H4V5a2 2 0 0 1 2-2Zm0 2v5h8V5H6Zm1 9v3h6v-3H7Zm10-8h2l2 3v8a2 2 0 1 1-4 0v-5h2v5a.5.5 0 1 0 1 0V10l-3-4Z" fill="currentColor"/></svg>',
  	      location: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a8 8 0 0 1 8 8c0 5.5-8 12-8 12S4 15.5 4 10a8 8 0 0 1 8-8Zm0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" fill="currentColor"/></svg>',
  	      leave: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 3h9a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-9v-2h9V5h-9V3Zm1.6 5.4L13 7l5 5-5 5-1.4-1.4 2.6-2.6H3v-2h11.2l-2.6-2.6Z" fill="currentColor"/></svg>',
  	      logout: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 3h9a2 2 0 0 1 2 2v3h-2V5H4v14h9v-3h2v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm13.6 5.4L19 7l5 5-5 5-1.4-1.4 2.6-2.6H9v-2h11.2l-2.6-2.6Z" fill="currentColor"/></svg>',
  	      back: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14.7 5.3-1.4-1.4L5.2 12l8.1 8.1 1.4-1.4L8 12l6.7-6.7Z" fill="currentColor"/></svg>',
  	      check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9.2 16.6-4.8-4.8L3 13.2l6.2 6.2L21 7.6 19.6 6.2 9.2 16.6Z" fill="currentColor"/></svg>',
  	      warning: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 1 21h22L12 2Zm0 5 6.9 12H5.1L12 7Zm-1 3v5h2v-5h-2Zm0 6v2h2v-2h-2Z" fill="currentColor"/></svg>',
  	      qr: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3h8v8H3V3Zm2 2v4h4V5H5Zm8-2h8v8h-8V3Zm2 2v4h4V5h-4ZM3 13h8v8H3v-8Zm2 2v4h4v-4H5Zm8-2h3v3h-3v-3Zm5 0h3v3h-3v-3Zm-5 5h3v3h-3v-3Zm4-1h2v2h2v2h-4v-4Z" fill="currentColor"/></svg>',
  	      camera: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.2 4 6.8 6H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2.8l-1.4-2H8.2ZM12 9a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" fill="currentColor"/></svg>',
  	      keyboard: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm1 3v2h2V8H4Zm3 0v2h2V8H7Zm3 0v2h2V8h-2Zm3 0v2h2V8h-2Zm3 0v2h2V8h-2Zm3 0v2h1V8h-1ZM4 12v2h2v-2H4Zm3 0v2h2v-2H7Zm3 0v2h2v-2h-2Zm3 0v2h2v-2h-2Zm3 0v2h4v-2h-4ZM6 16v1h12v-1H6Z" fill="currentColor"/></svg>',
  	      torch: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 2h8l-1 6 3 3-4 11h-4L6 11l3-3-1-6Zm2.3 2 .7 4-2.6 3.4L11.4 20h1.2l3-8.6L13 8l.7-4h-3.4Z" fill="currentColor"/></svg>',
  	      retry: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4a8 8 0 1 1-7.45 10.9l1.86-.72A6 6 0 1 0 7.1 8H10v2H3V3h2v3.2A7.96 7.96 0 0 1 12 4Z" fill="currentColor"/></svg>'
  	    };
  	    return icons[name] || icons.vehicle;
  	  }

  	  const state = {
  	    screen: "home",
  	    selectedCompanyId: "",
  	    selectedVehicleId: "",
  	    assignment: null,
  	    fuelStep: 0,
  	    gps: null,
  	    gpsError: "",
  	    gpsBusy: false,
  	    gpsStatus: "",
  	    gpsSamples: 0,
  	    selectedFuelLocationKey: "",
  	    otherSupplier: "",
  	    mileage: "",
  	    litres: "",
  	    totalCost: "",
  	    reference: "",
  	    slipPhoto: null,
  	    odometerPhoto: null,
  	    saving: false,
  	    success: null,
  	    scannerStatus: "",
  	    scannerError: "",
  	    scannerResult: null,
  	    qrAuthorisedVehicleId: "",
  	    qrAuthorisedAt: 0,
  	    scannerTorchAvailable: false,
  	    scannerTorchOn: false,
  	    previousBodyOverflow: "",
  	    appSwitchInProgress: false,
  	    logoutInProgress: false,
  	    destroyed: false
  	  };

  	  const qrRuntime = {
  	    stream: null,
  	    detector: null,
  	    frameRequest: 0,
  	    active: false,
  	    detecting: false,
  	    processing: false,
  	    lastDetectionAt: 0,
  	    track: null
  	  };

  	  const gpsRuntime = {
  	    watchId: null,
  	    timerId: 0,
  	    best: null,
  	    samples: 0,
  	    resolve: null,
  	    finished: false
  	  };

  	  const flespiMileageRuntime = {
  	    requestId: 0,
  	    deviceId: "",
  	    controller: null,
  	    promise: null,
  	    value: null
  	  };

  	  const FUEL_PHOTO_FIELDS = Object.freeze({
  	    slip: {
  	      stateKey: "slipPhoto",
  	      label: "Fuel slip",
  	      url: "SlipPhotoURL",
  	      key: "SlipPhotoKey",
  	      name: "SlipPhotoName"
  	    },
  	    odometer: {
  	      stateKey: "odometerPhoto",
  	      label: "Odometer",
  	      url: "OdometerPhotoURL",
  	      key: "OdometerPhotoKey",
  	      name: "OdometerPhotoName"
  	    }
  	  });

  	  function fuelPhotoField(kind) {
  	    return FUEL_PHOTO_FIELDS[kind] || null;
  	  }

  	  function fuelPhotoState(kind) {
  	    const field = fuelPhotoField(kind);
  	    return field ? state[field.stateKey] : null;
  	  }

  	  function formatBytes(value) {
  	    const bytes = Math.max(0, numberOr(value, 0));
  	    if (bytes < 1024) return Math.round(bytes) + " B";
  	    if (bytes < 1024 * 1024) return formatNumber(bytes / 1024, 0) + " KB";
  	    return formatNumber(bytes / (1024 * 1024), 1) + " MB";
  	  }

  	  function revokeFuelPhoto(photo) {
  	    if (!photo || !photo.previewUrl) return;
  	    try {
  	      URL.revokeObjectURL(photo.previewUrl);
  	    } catch (_) {}
  	  }

  	  function clearFuelPhoto(kind) {
  	    const field = fuelPhotoField(kind);
  	    if (!field) return;
  	    revokeFuelPhoto(state[field.stateKey]);
  	    state[field.stateKey] = null;
  	  }

  	  function clearFuelPhotos() {
  	    clearFuelPhoto("slip");
  	    clearFuelPhoto("odometer");
  	  }

  	  function fuelPhotoFileName(kind) {
  	    const prefix = kind === "odometer" ? "odometer" : "fuel-slip";
  	    const stamp = new Date().toISOString().replace(/[:.]/g, "-");
  	    return prefix + "-" + stamp + ".jpg";
  	  }

  	  function loadFuelPhotoSource(file) {
  	    return new Promise(async function (resolve, reject) {
  	      if (typeof createImageBitmap === "function") {
  	        try {
  	          let bitmap;
  	          try {
  	            bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
  	          } catch (_) {
  	            bitmap = await createImageBitmap(file);
  	          }
  	          resolve({
  	            source: bitmap,
  	            width: bitmap.width,
  	            height: bitmap.height,
  	            cleanup: function () {
  	              try {
  	                if (bitmap && typeof bitmap.close === "function") bitmap.close();
  	              } catch (_) {}
  	            }
  	          });
  	          return;
  	        } catch (_) {
  	          /* fall through to Image */
  	        }
  	      }

  	      const objectUrl = URL.createObjectURL(file);
  	      const image = new Image();
  	      image.onload = function () {
  	        resolve({
  	          source: image,
  	          width: image.naturalWidth || image.width,
  	          height: image.naturalHeight || image.height,
  	          cleanup: function () {
  	            try { URL.revokeObjectURL(objectUrl); } catch (_) {}
  	          }
  	        });
  	      };
  	      image.onerror = function () {
  	        try { URL.revokeObjectURL(objectUrl); } catch (_) {}
  	        reject(new Error("The selected photo could not be read by this phone."));
  	      };
  	      image.src = objectUrl;
  	    });
  	  }

  	  function fuelPhotoCanvasBlob(canvas, quality) {
  	    return new Promise(function (resolve, reject) {
  	      if (!canvas || typeof canvas.toBlob !== "function") {
  	        reject(new Error("This phone cannot prepare the photo for upload."));
  	        return;
  	      }
  	      canvas.toBlob(function (blob) {
  	        if (!blob) {
  	          reject(new Error("The photo could not be compressed."));
  	          return;
  	        }
  	        resolve(blob);
  	      }, "image/jpeg", quality);
  	    });
  	  }

  	  async function compressFuelPhoto(file, kind) {
  	    if (!file) throw new Error("No photo was selected.");
  	    if (!(Object.prototype.toString.call(file) === "[object File]" || typeof file === "object")) {
  	      throw new Error("The selected photo is not valid.");
  	    }

  	    const type = lower(file.type);
  	    if (type && type.indexOf("image/") !== 0) {
  	      throw new Error("Only camera images can be attached.");
  	    }

  	    const sourceBytes = numberOr(file.size, 0);
  	    if (sourceBytes <= 0) throw new Error("The selected photo is empty.");
  	    if (sourceBytes > FUEL_PHOTO_MAX_SOURCE_BYTES) {
  	      throw new Error("The selected photo is too large for the phone to prepare safely.");
  	    }

  	    const loaded = await loadFuelPhotoSource(file);
  	    try {
  	      if (!loaded.width || !loaded.height) {
  	        throw new Error("The selected photo has no readable dimensions.");
  	      }

  	      const longest = Math.max(loaded.width, loaded.height);
  	      let scale = longest > FUEL_PHOTO_MAX_DIMENSION
  	        ? FUEL_PHOTO_MAX_DIMENSION / longest
  	        : 1;
  	      let quality = FUEL_PHOTO_INITIAL_QUALITY;
  	      let blob = null;
  	      let width = 0;
  	      let height = 0;

  	      for (let attempt = 0; attempt < 9; attempt += 1) {
  	        width = Math.max(1, Math.round(loaded.width * scale));
  	        height = Math.max(1, Math.round(loaded.height * scale));

  	        const canvas = document.createElement("canvas");
  	        canvas.width = width;
  	        canvas.height = height;
  	        const context = canvas.getContext("2d", { alpha: false });
  	        if (!context) throw new Error("This phone cannot prepare the photo.");

  	        context.fillStyle = "#ffffff";
  	        context.fillRect(0, 0, width, height);
  	        context.imageSmoothingEnabled = true;
  	        context.imageSmoothingQuality = "high";
  	        context.drawImage(loaded.source, 0, 0, width, height);

  	        blob = await fuelPhotoCanvasBlob(canvas, quality);

  	        if (blob.size <= FUEL_PHOTO_TARGET_BYTES) break;

  	        if (quality > FUEL_PHOTO_MIN_QUALITY + 0.01) {
  	          quality = Math.max(FUEL_PHOTO_MIN_QUALITY, quality - 0.07);
  	          continue;
  	        }

  	        const currentLongest = Math.max(width, height);
  	        if (currentLongest <= FUEL_PHOTO_MIN_DIMENSION) break;
  	        scale *= 0.86;
  	      }

  	      if (!blob || !blob.size) {
  	        throw new Error("The photo could not be compressed.");
  	      }

  	      const compressedFile = new File(
  	        [blob],
  	        fuelPhotoFileName(kind),
  	        {
  	          type: "image/jpeg",
  	          lastModified: Date.now()
  	        }
  	      );

  	      return {
  	        file: compressedFile,
  	        previewUrl: URL.createObjectURL(compressedFile),
  	        originalName: clean(file.name) || "camera-photo",
  	        originalBytes: sourceBytes,
  	        compressedBytes: compressedFile.size,
  	        width: width,
  	        height: height
  	      };
  	    } finally {
  	      loaded.cleanup();
  	    }
  	  }

  	  async function setFuelPhoto(kind, file) {
  	    const field = fuelPhotoField(kind);
  	    if (!field) return false;

  	    showOperation(
  	      "Preparing " + field.label.toLowerCase() + " photo…",
  	      "Compressing the image for a faster mobile upload."
  	    );

  	    try {
  	      const prepared = await compressFuelPhoto(file, kind);
  	      clearFuelPhoto(kind);
  	      state[field.stateKey] = prepared;
  	      closeOperation();
  	      render();
  	      return true;
  	    } catch (error) {
  	      closeOperation();
  	      await showDialog({
  	        title: "Photo not added",
  	        message: clean(error && error.message) || "The photo could not be prepared.",
  	        confirmText: "Close",
  	        hideCancel: true,
  	        danger: true
  	      });
  	      return false;
  	    }
  	  }

  	  async function getFuelPhotoUserToken() {
  	    let token = "";

  	    if (
  	      DB &&
  	      DB.UserService &&
  	      typeof DB.UserService.getCurrentUserToken === "function"
  	    ) {
  	      token = DB.UserService.getCurrentUserToken();
  	      if (token && typeof token.then === "function") token = await token;
  	    }

  	    if (!token) {
  	      token = firstValue([
  	        getDeep(userRecord(), ["user-token"], ""),
  	        getDeep(userRecord(), ["userToken"], ""),
  	        ""
  	      ], "");
  	    }

  	    token = clean(token);
  	    if (!token) {
  	      throw new Error("Your login session is unavailable. Please log in again before uploading a fuel photo.");
  	    }
  	    return token;
  	  }

  	  async function readFuelPhotoApiJson(response) {
  	    const responseText = await response.text();
  	    let payload = {};
  	    try {
  	      payload = responseText ? JSON.parse(responseText) : {};
  	    } catch (_) {
  	      payload = {};
  	    }

  	    if (!response.ok || payload.ok === false) {
  	      throw new Error(
  	        payload && payload.error
  	          ? payload.error
  	          : "The photo service could not complete the request."
  	      );
  	    }
  	    return payload || {};
  	  }

  	  async function uploadFuelOutPhoto(file, fuelOutObjectId, kind) {
  	    const objectId = clean(fuelOutObjectId);
  	    if (!objectId) throw new Error("The FuelOut record must be saved before a photo can be uploaded.");
  	    if (!fuelPhotoField(kind)) throw new Error("Unknown fuel photo type.");

  	    const token = await getFuelPhotoUserToken();
  	    const response = await fetch(
  	      FUEL_FILE_API_BASE +
  	        "/fuel-out/" +
  	        encodeURIComponent(objectId) +
  	        "/photo/" +
  	        encodeURIComponent(kind),
  	      {
  	        method: "PUT",
  	        headers: {
  	          "Content-Type": "image/jpeg",
  	          "X-Backendless-User-Token": token,
  	          "X-File-Name": encodeURIComponent(clean(file && file.name) || fuelPhotoFileName(kind))
  	        },
  	        body: file
  	      }
  	    );

  	    return readFuelPhotoApiJson(response);
  	  }

  	  function safeFuelOutPhotoUrl(value) {
  	    const rawUrl = clean(value);
  	    if (!rawUrl) throw new Error("The saved fuel photo URL is missing.");

  	    let parsed;
  	    try {
  	      parsed = new URL(rawUrl);
  	    } catch (_) {
  	      throw new Error("The saved fuel photo URL is invalid.");
  	    }

  	    if (
  	      parsed.origin !== FUEL_FILE_API_BASE ||
  	      !/^\/fuel-out\/[A-Za-z0-9_-]{1,64}\/photo\/(slip|odometer)\/[0-9a-f-]{36}\.(jpg|jpeg|png|webp)$/i.test(parsed.pathname)
  	    ) {
  	      throw new Error("The saved fuel photo URL is not trusted.");
  	    }

  	    return parsed.href;
  	  }

  	  async function deleteFuelOutPhotoUrl(photoUrl) {
  	    const trustedUrl = safeFuelOutPhotoUrl(photoUrl);
  	    const token = await getFuelPhotoUserToken();
  	    const response = await fetch(trustedUrl, {
  	      method: "DELETE",
  	      headers: {
  	        "X-Backendless-User-Token": token
  	      }
  	    });
  	    return readFuelPhotoApiJson(response);
  	  }

  	  async function attachOptionalFuelPhotos(savedFuelOut) {
  	    const fuelOutId = objectIdOf(savedFuelOut);
  	    if (!fuelOutId) return { uploadedCount: 0, warnings: ["FuelOut objectId was unavailable for optional photos."] };

  	    const queue = ["slip", "odometer"].map(function (kind) {
  	      return { kind: kind, field: fuelPhotoField(kind), photo: fuelPhotoState(kind) };
  	    }).filter(function (item) {
  	      return !!(item.field && item.photo && item.photo.file);
  	    });

  	    if (!queue.length) return { uploadedCount: 0, warnings: [] };

  	    let uploadedCount = 0;
  	    const warnings = [];

  	    for (let index = 0; index < queue.length; index += 1) {
  	      const item = queue[index];
  	      let uploaded = null;
  	      updateOperation(
  	        "Saving fuel…",
  	        "Uploading optional " + item.field.label.toLowerCase() + " photo " + (index + 1) + " of " + queue.length + "."
  	      );

  	      try {
  	        uploaded = await uploadFuelOutPhoto(item.photo.file, fuelOutId, item.kind);

  	        const patch = { objectId: fuelOutId };
  	        patch[item.field.url] = clean(firstValue([uploaded.photoUrl, uploaded.documentUrl], ""));
  	        patch[item.field.key] = clean(firstValue([uploaded.photoKey, uploaded.documentKey], ""));
  	        patch[item.field.name] = clean(firstValue([
  	          uploaded.photoName,
  	          uploaded.documentName,
  	          item.photo.file.name
  	        ], item.photo.file.name));

  	        const savedPatch = await DB.Data.of("FuelOut").save(patch);
  	        Object.assign(savedFuelOut, patch, savedPatch || {});
  	        uploadedCount += 1;
  	      } catch (error) {
  	        warnings.push(
  	          item.field.label + " photo was not uploaded: " +
  	          (clean(error && error.message) || "unknown upload error")
  	        );

  	        const uploadedUrl = uploaded && firstValue([
  	          uploaded.photoUrl,
  	          uploaded.documentUrl
  	        ], "");

  	        if (uploadedUrl) {
  	          try {
  	            await deleteFuelOutPhotoUrl(uploadedUrl);
  	          } catch (cleanupError) {
  	            console.warn("FIF Driver Mobile optional fuel photo cleanup failed", cleanupError);
  	          }
  	        }

  	        console.warn("FIF Driver Mobile optional " + item.kind + " photo upload failed", error);
  	      }
  	    }

  	    return { uploadedCount: uploadedCount, warnings: warnings };
  	  }


  	  function safeAccent(value) {
  	    const raw = clean(value);
  	    return /^#[0-9a-f]{3,8}$/i.test(raw) ? raw : "#d8662c";
  	  }

  	  function vehicleAccent(vehicle) {
  	    return safeAccent(firstValue([
  	      vehicle && vehicle.color,
  	      vehicle && vehicle.Color,
  	      getDeep(vehicle, ["Data", "Vehicle", "Color"], "")
  	    ], "#d8662c"));
  	  }

  	  function vehicleQrCandidates(rawValue) {
  	    const rows = [];
  	    const push = function (value) {
  	      const token = clean(value);
  	      if (token && rows.indexOf(token) === -1) rows.push(token);
  	    };
  	    const raw = clean(rawValue);
  	    push(raw);
  	    try { push(decodeURIComponent(raw)); } catch (_) {}
  	    try {
  	      const parsed = JSON.parse(raw);
  	      if (parsed && typeof parsed === "object") {
  	        push(parsed.objectId);
  	        push(parsed.ObjectId);
  	        push(parsed.vehicleObjectId);
  	        push(parsed.VehicleObjectId);
  	        push(parsed.id);
  	      }
  	    } catch (_) {}
  	    try {
  	      const url = new URL(raw, window.location.href);
  	      ["objectId", "vehicleObjectId", "vehicle", "id"].forEach(function (key) {
  	        push(url.searchParams.get(key));
  	      });
  	      const parts = url.pathname.split("/").filter(Boolean);
  	      if (parts.length) push(parts[parts.length - 1]);
  	    } catch (_) {}
  	    ["FIF:", "VEHICLE:", "TRACTOR:", "OBJECTID:"].forEach(function (prefix) {
  	      if (raw.toUpperCase().indexOf(prefix) === 0) push(raw.slice(prefix.length));
  	    });
  	    const pair = raw.match(/(?:objectId|vehicleObjectId|vehicle|tractor)\s*[:=]\s*(.+)$/i);
  	    if (pair) push(pair[1]);
  	    return rows;
  	  }

  	  function findVehicleByQr(rawValue) {
  	    const candidates = vehicleQrCandidates(rawValue);
  	    const rows = companiesAndVehicles();
  	    for (let candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
  	      const candidate = candidates[candidateIndex];
  	      for (let rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
  	        if (objectIdOf(rows[rowIndex].vehicle) === candidate) {
  	          return Object.assign({}, rows[rowIndex], { scannedCode: clean(rawValue), matchedObjectId: candidate });
  	        }
  	      }
  	    }
  	    for (let candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
  	      const candidate = lower(candidates[candidateIndex]);
  	      for (let rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
  	        if (lower(objectIdOf(rows[rowIndex].vehicle)) === candidate) {
  	          return Object.assign({}, rows[rowIndex], { scannedCode: clean(rawValue), matchedObjectId: objectIdOf(rows[rowIndex].vehicle) });
  	        }
  	      }
  	    }
  	    return null;
  	  }

  	  function scannerUiStatus(status, error) {
  	    state.scannerStatus = clean(status);
  	    state.scannerError = clean(error);
  	    const statusNode = document.querySelector("#" + ROOT_ID + " [data-scanner-status]");
  	    const errorNode = document.querySelector("#" + ROOT_ID + " [data-scanner-error]");
  	    if (statusNode) statusNode.textContent = state.scannerStatus || "Point the camera at the vehicle QR code.";
  	    if (errorNode) {
  	      errorNode.textContent = state.scannerError;
  	      errorNode.classList.toggle("visible", !!state.scannerError);
  	    }
  	  }

  	  function stopQrScanner() {
  	    qrRuntime.active = false;
  	    qrRuntime.processing = false;
  	    qrRuntime.detecting = false;
  	    if (qrRuntime.frameRequest) {
  	      cancelAnimationFrame(qrRuntime.frameRequest);
  	      qrRuntime.frameRequest = 0;
  	    }
  	    if (qrRuntime.stream) {
  	      qrRuntime.stream.getTracks().forEach(function (track) {
  	        try { track.stop(); } catch (_) {}
  	      });
  	    }
  	    qrRuntime.stream = null;
  	    qrRuntime.detector = null;
  	    qrRuntime.track = null;
  	    state.scannerTorchAvailable = false;
  	    state.scannerTorchOn = false;
  	  }

  	  async function toggleScannerTorch() {
  	    const track = qrRuntime.track;
  	    if (!track || !state.scannerTorchAvailable || typeof track.applyConstraints !== "function") return false;
  	    const next = !state.scannerTorchOn;
  	    try {
  	      await track.applyConstraints({ advanced: [{ torch: next }] });
  	      state.scannerTorchOn = next;
  	      const button = document.querySelector("#" + ROOT_ID + " [data-action='scanner-torch']");
  	      if (button) {
  	        button.classList.toggle("is-on", next);
  	        button.setAttribute("aria-pressed", next ? "true" : "false");
  	        const label = button.querySelector("span");
  	        if (label) label.textContent = next ? "Light On" : "Light";
  	      }
  	      return true;
  	    } catch (_) {
  	      scannerUiStatus(state.scannerStatus, "The camera light is not available on this device.");
  	      return false;
  	    }
  	  }

  	  async function acceptScannedVehicle(rawValue) {
  	    if (qrRuntime.processing) return;
  	    qrRuntime.processing = true;
  	    const match = findVehicleByQr(rawValue);
  	    if (!match) {
  	      scannerUiStatus("Keep the QR code inside the square.", "This QR code does not match a vehicle loaded for your companies.");
  	      if (navigator.vibrate) navigator.vibrate([70, 40, 70]);
  	      window.setTimeout(function () { qrRuntime.processing = false; }, 1200);
  	      return;
  	    }

  	    if (navigator.vibrate) navigator.vibrate([45, 35, 90]);
  	    stopQrScanner();
  	    state.scannerResult = match;
  	    state.qrAuthorisedVehicleId = objectIdOf(match.vehicle);
  	    state.qrAuthorisedAt = Date.now();
  	    state.selectedCompanyId = objectIdOf(match.company);
  	    state.selectedVehicleId = objectIdOf(match.vehicle);
  	    state.screen = "scan-confirm";
  	    render();
  	  }

  	  async function startQrScanner() {
  	    stopQrScanner();
  	    state.scannerStatus = "Starting the rear camera…";
  	    state.scannerError = "";
  	    scannerUiStatus(state.scannerStatus, "");

  	    if (!window.isSecureContext) {
  	      scannerUiStatus("Camera unavailable", "QR scanning requires the secure HTTPS page.");
  	      return false;
  	    }
  	    if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== "function") {
  	      scannerUiStatus("Camera unavailable", "This browser cannot open the device camera. Vehicle boarding requires a working QR camera.");
  	      return false;
  	    }
  	    if (!("BarcodeDetector" in window)) {
  	      scannerUiStatus("QR reader unavailable", "This browser does not provide QR detection. Vehicle boarding is unavailable on this device.");
  	      return false;
  	    }

  	    try {
  	      if (typeof window.BarcodeDetector.getSupportedFormats === "function") {
  	        const formats = await window.BarcodeDetector.getSupportedFormats();
  	        if (Array.isArray(formats) && formats.indexOf("qr_code") === -1) {
  	          scannerUiStatus("QR reader unavailable", "This device does not support QR-code detection. Vehicle boarding is unavailable on this device.");
  	          return false;
  	        }
  	      }
  	      qrRuntime.detector = new window.BarcodeDetector({ formats: ["qr_code"] });
  	      qrRuntime.stream = await navigator.mediaDevices.getUserMedia({
  	        audio: false,
  	        video: {
  	          facingMode: { ideal: "environment" },
  	          width: { ideal: 1280 },
  	          height: { ideal: 1280 }
  	        }
  	      });
  	      qrRuntime.track = qrRuntime.stream.getVideoTracks()[0] || null;
  	      const capabilities = qrRuntime.track && typeof qrRuntime.track.getCapabilities === "function" ? qrRuntime.track.getCapabilities() : {};
  	      state.scannerTorchAvailable = !!(capabilities && capabilities.torch);

  	      const video = document.querySelector("#" + ROOT_ID + " [data-qr-video]");
  	      if (!video || state.screen !== "scanner") {
  	        stopQrScanner();
  	        return false;
  	      }
  	      video.srcObject = qrRuntime.stream;
  	      video.setAttribute("playsinline", "");
  	      video.muted = true;
  	      await video.play();
  	      qrRuntime.active = true;
  	      scannerUiStatus("Camera ready — hold still over the QR code.", "");
  	      const torchButton = document.querySelector("#" + ROOT_ID + " [data-action='scanner-torch']");
  	      if (torchButton) torchButton.hidden = !state.scannerTorchAvailable;

  	      const scanFrame = async function (timestamp) {
  	        if (!qrRuntime.active || state.screen !== "scanner") return;
  	        const activeVideo = document.querySelector("#" + ROOT_ID + " [data-qr-video]");
  	        if (activeVideo && activeVideo.readyState >= 2 && !qrRuntime.detecting && timestamp - qrRuntime.lastDetectionAt > 170) {
  	          qrRuntime.lastDetectionAt = timestamp;
  	          qrRuntime.detecting = true;
  	          try {
  	            const codes = await qrRuntime.detector.detect(activeVideo);
  	            const qr = arr(codes).find(function (code) {
  	              return code && (!code.format || code.format === "qr_code") && clean(code.rawValue);
  	            });
  	            if (qr) await acceptScannedVehicle(qr.rawValue);
  	          } catch (error) {
  	            if (qrRuntime.active) console.warn("FIF Driver QR frame detection failed", error);
  	          } finally {
  	            qrRuntime.detecting = false;
  	          }
  	        }
  	        if (qrRuntime.active) qrRuntime.frameRequest = requestAnimationFrame(scanFrame);
  	      };
  	      qrRuntime.frameRequest = requestAnimationFrame(scanFrame);
  	      return true;
  	    } catch (error) {
  	      stopQrScanner();
  	      const name = clean(error && error.name);
  	      const message = name === "NotAllowedError"
  	        ? "Camera permission was not allowed. Permit camera access and tap Try Camera Again."
  	        : name === "NotFoundError"
  	          ? "No rear camera was found on this device."
  	          : "The camera could not start. Camera access is required to board a vehicle.";
  	      scannerUiStatus("Camera did not open", message);
  	      return false;
  	    }
  	  }

  	  async function openQrScanner() {
  	    stopQrScanner();
  	    state.scannerResult = null;
  	    state.scannerStatus = "Starting the rear camera…";
  	    state.scannerError = "";
  	    state.screen = "scanner";
  	    render();
  	    return startQrScanner();
  	  }

  	  function selectedCompany() {
  	    const rows = companyRows();
  	    return rows.find(function (company) {
  	      return objectIdOf(company) === state.selectedCompanyId;
  	    }) || (rows.length === 1 ? rows[0] : null);
  	  }

  	  function selectedVehicle() {
  	    const company = selectedCompany();
  	    if (!company) return null;
  	    return companyTractors(company).find(function (vehicle) {
  	      return objectIdOf(vehicle) === state.selectedVehicleId;
  	    }) || null;
  	  }

  	  function selectedFuelLocation() {
  	    const company = selectedCompany();
  	    if (!company || state.selectedFuelLocationKey === "__other__") return null;
  	    return eligibleFuelLocations(company, state.gps).find(function (location) {
  	      return location.key === state.selectedFuelLocationKey;
  	    }) || null;
  	  }

  	  function currentMileage(vehicle) {
  	    return numberValue(firstValue([
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Usage", "CurrentReading"], null)),
  	      vehicle && vehicle.Mileage
  	    ], null));
  	  }

  	  function vehicleFlespiDeviceId(vehicle) {
  	    const raw = firstValue([
  	      vehicle && vehicle.Tracker,
  	      vehicle && vehicle.TrackerId,
  	      vehicle && vehicle.TrackerID,
  	      vehicle && vehicle.FlespiDeviceId,
  	      vehicle && vehicle.FlespiDeviceID,
  	      getDeep(vehicle, ["Data", "Vehicle", "Tracker"], null),
  	      getDeep(vehicle, ["Data", "Vehicle", "TrackerId"], null),
  	      getDeep(vehicle, ["Data", "Telematics", "FlespiDeviceId"], null)
  	    ], "");
  	    const value = descriptorValue(raw);
  	    return value && typeof value === "object" ? objectIdOf(value) : clean(value);
  	  }

  	  function extractFlespiMileage(responseBody) {
  	    const rows = arr(responseBody && responseBody.result);
  	    if (!rows.length && responseBody && typeof responseBody === "object") rows.push(responseBody);

  	    for (let index = 0; index < rows.length; index += 1) {
  	      const telemetryNode = getDeep(rows[index], ["telemetry", FLESPI_MILEAGE_PARAMETER], null);
  	      const mileage = numberValue(telemetryNode);
  	      if (mileage !== null && mileage >= 0) return mileage;
  	    }
  	    return null;
  	  }

  	  function startFlespiMileageLookup(vehicle) {
  	    const requestId = flespiMileageRuntime.requestId + 1;
  	    const deviceId = vehicleFlespiDeviceId(vehicle);
  	    const token = clean(FLESPI_AUTH_TOKEN);

  	    flespiMileageRuntime.requestId = requestId;
  	    flespiMileageRuntime.deviceId = deviceId;
  	    flespiMileageRuntime.value = null;
  	    if (flespiMileageRuntime.controller) {
  	      try { flespiMileageRuntime.controller.abort(); } catch (_) {}
  	    }
  	    flespiMileageRuntime.controller = null;

  	    if (!deviceId || !token || typeof fetch !== "function") {
  	      flespiMileageRuntime.promise = Promise.resolve(null);
  	      return flespiMileageRuntime.promise;
  	    }

  	    const controller = typeof AbortController === "function" ? new AbortController() : null;
  	    flespiMileageRuntime.controller = controller;
  	    const authHeader = token.indexOf("FlespiToken ") === 0 ? token : "FlespiToken " + token;
  	    const url = "https://flespi.io/gw/devices/" + encodeURIComponent(deviceId) +
  	      "/telemetry/" + encodeURIComponent(FLESPI_MILEAGE_PARAMETER);

  	    const request = (async function () {
  	      try {
  	        const response = await fetch(url, {
  	          method: "GET",
  	          headers: { Authorization: authHeader },
  	          signal: controller ? controller.signal : undefined
  	        });
  	        if (!response.ok) return null;
  	        return extractFlespiMileage(await response.json());
  	      } catch (_) {
  	        return null;
  	      }
  	    })();

  	    let timeoutId = 0;
  	    const timeout = new Promise(function (resolve) {
  	      timeoutId = setTimeout(function () {
  	        if (controller) {
  	          try { controller.abort(); } catch (_) {}
  	        }
  	        resolve(null);
  	      }, FLESPI_REQUEST_TIMEOUT_MS);
  	    });

  	    flespiMileageRuntime.promise = Promise.race([request, timeout]).then(function (value) {
  	      if (timeoutId) clearTimeout(timeoutId);
  	      const mileage = numberValue(value);
  	      const validMileage = mileage !== null && mileage >= 0 ? mileage : null;
  	      if (flespiMileageRuntime.requestId === requestId) {
  	        flespiMileageRuntime.value = validMileage;
  	        flespiMileageRuntime.controller = null;
  	      }
  	      return validMileage;
  	    }, function () {
  	      if (timeoutId) clearTimeout(timeoutId);
  	      if (flespiMileageRuntime.requestId === requestId) {
  	        flespiMileageRuntime.value = null;
  	        flespiMileageRuntime.controller = null;
  	      }
  	      return null;
  	    });

  	    return flespiMileageRuntime.promise;
  	  }

  	  async function flespiMileageForFuelPayload(vehicle) {
  	    const deviceId = vehicleFlespiDeviceId(vehicle);
  	    if (deviceId && deviceId !== flespiMileageRuntime.deviceId) {
  	      startFlespiMileageLookup(vehicle);
  	    }

  	    if (flespiMileageRuntime.promise) {
  	      try { await flespiMileageRuntime.promise; } catch (_) {}
  	    }

  	    const mileage = numberValue(flespiMileageRuntime.value);
  	    return mileage !== null && mileage >= 0 ? mileage : null;
  	  }

  	  function maximumMileage(vehicle) {
  	    const current = currentMileage(vehicle);
  	    const range = numberValue(descriptorValue(firstValue([
  	      getDeep(vehicle, ["Data", "Vehicle", "Usage", "Range"], null),
  	      vehicle && vehicle.Range
  	    ], null)));
  	    if (current === null || range === null || range <= 0) return null;
  	    return current + range;
  	  }

  	  function tankCapacity(vehicle) {
  	    return numberValue(descriptorValue(getDeep(vehicle, ["CAN", "Tank"], null)));
  	  }


  	  function booleanValue(value) {
  	    const raw = descriptorValue(value);
  	    if (raw === true || raw === false) return raw;
  	    if (raw === 1 || raw === 0) return raw === 1;
  	    const valueText = lower(raw);
  	    if (["true", "yes", "1", "enabled", "active", "compliant"].indexOf(valueText) !== -1) return true;
  	    if (["false", "no", "0", "disabled", "inactive", "not compliant", "non-compliant"].indexOf(valueText) !== -1) return false;
  	    return false;
  	  }

  	  function vehicleMeterProfile(vehicle) {
  	    const canonicalCounterType = lower(descriptorValue(firstValue([
  	      vehicle && vehicle.CounterType,
  	      getDeep(vehicle, ["Data", "Vehicle", "Usage", "CounterType"], null),
  	      getDeep(vehicle, ["Data", "Vehicle", "CounterType"], null)
  	    ], "")));
  	    if (/hour|hobbs|time/.test(canonicalCounterType)) {
  	      return {
  	        kind: "hours",
  	        heading: "Vehicle operating hours",
  	        fieldLabel: "Hours shown on vehicle",
  	        shortLabel: "Operating hours",
  	        unit: "h",
  	        decimals: 1,
  	        step: "0.1",
  	        placeholder: "Example: 1080.5"
  	      };
  	    }
  	    if (/km|kilomet|distance|odometer/.test(canonicalCounterType)) {
  	      return {
  	        kind: "distance",
  	        heading: "Vehicle mileage",
  	        fieldLabel: "Kilometres shown on vehicle",
  	        shortLabel: "Mileage",
  	        unit: "km",
  	        decimals: 0,
  	        step: "1",
  	        placeholder: "Example: 245680"
  	      };
  	    }

  	    const explicitUnit = lower(firstValue([
  	      descriptorValue(vehicle && vehicle.MeterUnit),
  	      descriptorValue(vehicle && vehicle.OdometerUnit),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "MeterUnit"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "OdometerUnit"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "OperatingMeterUnit"], ""))
  	    ], ""));
  	    const triggerPolicy = lower(descriptorValue(getDeep(vehicle, ["Data", "Service", "Schedule", "TriggerPolicy"], "")));
  	    const vehicleClass = lower(firstValue([
  	      descriptorValue(getDeep(vehicle, ["Data", "Profile", "VehicleClass"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Classification", "VehicleClass"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "TowSystem", "PowerUnitClass"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Agricultural", "MachineClass"], ""))
  	    ], ""));
  	    const hourMeterNode = getDeep(vehicle, ["Data", "Agricultural", "Hours", "HourMeter"], null);
  	    const hasHourMeter = hourMeterNode !== null && hourMeterNode !== undefined;
  	    const explicitHours = /hour/.test(explicitUnit) || /hour/.test(triggerPolicy);
  	    const explicitDistance = /km|kilomet|distance|odometer/.test(explicitUnit);
  	    const agriculturalHours = !explicitDistance && /agricultural tractor|self-propelled agricultural machine|tractor/.test(vehicleClass) && hasHourMeter;
  	    const usesHours = explicitHours || agriculturalHours;
  	    return usesHours ? {
  	      kind: "hours",
  	      heading: "Vehicle operating hours",
  	      fieldLabel: "Hours shown on vehicle",
  	      shortLabel: "Operating hours",
  	      unit: "h",
  	      decimals: 1,
  	      step: "0.1",
  	      placeholder: "Example: 1080.5"
  	    } : {
  	      kind: "distance",
  	      heading: "Vehicle mileage",
  	      fieldLabel: "Kilometres shown on vehicle",
  	      shortLabel: "Mileage",
  	      unit: "km",
  	      decimals: 0,
  	      step: "1",
  	      placeholder: "Example: 245680"
  	    };
  	  }

  	  function formatVehicleMeter(vehicle, value) {
  	    const profile = vehicleMeterProfile(vehicle);
  	    const reading = numberValue(value);
  	    return reading === null ? "Not captured" : formatNumber(reading, profile.decimals) + " " + profile.unit;
  	  }

  	  function vehicleRegistration(vehicle) {
  	    return clean(firstValue([
  	      vehicle && vehicle.Registration,
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Registration"], "")),
  	      descriptorValue(getDeep(vehicle, ["Data", "Vehicle", "Identity", "Registration"], ""))
  	    ], ""));
  	  }

  	  function driverVehicleIdentityDetails(vehicle) {
  	    function read(paths) {
  	      for (let index = 0; index < paths.length; index += 1) {
  	        const value = clean(descriptorValue(getDeep(vehicle, paths[index], "")));
  	        if (value) return value;
  	      }
  	      return "Not captured";
  	    }

  	    return {
  	      make: read([
  	        ["Data", "Vehicle", "Identity", "Make"],
  	        ["Data", "Vehicle", "Make"],
  	        ["Data", "General", "Make"],
  	        ["Make"]
  	      ]),
  	      model: read([
  	        ["Data", "Vehicle", "Identity", "Model"],
  	        ["Data", "Vehicle", "Model"],
  	        ["Data", "General", "Model"],
  	        ["Model"]
  	      ]),
  	      year: read([
  	        ["Data", "Vehicle", "Identity", "Year"],
  	        ["Data", "Vehicle", "Year"],
  	        ["Data", "General", "Year"],
  	        ["Year"]
  	      ]),
  	      vin: read([
  	        ["Data", "Vehicle", "Identity", "VIN"],
  	        ["Data", "Vehicle", "VIN"],
  	        ["VIN"]
  	      ]),
  	      engineNumber: read([
  	        ["Data", "Vehicle", "Identity", "EngineNumber"],
  	        ["Data", "Vehicle", "EngineNumber"],
  	        ["Data", "Vehicle", "Engine_Number"],
  	        ["EngineNumber"],
  	        ["Engine_Number"]
  	      ])
  	    };
  	  }

  	  function vehicleSarsRebateRate(vehicle) {
  	    const raw = firstValue([
  	      getDeep(vehicle, ["Data", "Vehicle", "SARS_Rebate_Rate"], null),
  	      getDeep(vehicle, ["Data", "Vehicle", "Sars_Rebate_Rate"], null),
  	      getDeep(vehicle, ["Data", "Vehicle", "SARSRebateRate"], null),
  	      getDeep(vehicle, ["Data", "Vehicle", "Financials", "SARS", "RebateRate"], null),
  	      getDeep(vehicle, ["Data", "Financials", "SARS", "RebateRate"], null),
  	      getDeep(vehicle, ["Data", "SARS_Rebate_Rate"], null)
  	    ], null);
  	    const rate = numberValue(descriptorValue(raw));
  	    return rate === null || rate < 0 ? 0 : Math.round(rate * 10000) / 10000;
  	  }

  	  function vehicleSarsCompliance(vehicle) {
  	    return booleanValue(firstValue([
  	      vehicle && vehicle.SARSCompliance,
  	      getDeep(vehicle, ["Data", "Vehicle", "SARSCompliance"], null),
  	      getDeep(vehicle, ["Data", "Vehicle", "SARS_Compliance"], null),
  	      getDeep(vehicle, ["Data", "Vehicle", "Financials", "SARS", "Compliance"], null),
  	      getDeep(vehicle, ["Data", "Financials", "SARS", "Compliance"], null)
  	    ], false));
  	  }

  	  function companyOwnerId(company) {
  	    return clean(company && company.ownerId);
  	  }

  	  function transactionPeriodKey(value) {
  	    const date = value instanceof Date ? value : new Date(value || Date.now());
  	    if (Number.isNaN(date.getTime())) return "";
  	    return date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0");
  	  }

  	  function fuelTransactionNumber() {
  	    return "FUEL-" + Date.now().toString(36).toUpperCase() + "-" + Math.random().toString(36).slice(2, 7).toUpperCase();
  	  }


  	  function driverRelationRows(value) {
  	    if (Array.isArray(value)) return value.slice();
  	    if (value === null || value === undefined || value === "") return [];
  	    if (value && typeof value === "object") {
  	      const length = Number(value.length);
  	      if (Number.isFinite(length) && length >= 0) {
  	        const rows = [];
  	        for (let index = 0; index < length; index += 1) {
  	          if (value[index] !== undefined) rows.push(value[index]);
  	        }
  	        return rows;
  	      }
  	      try {
  	        if (typeof Symbol !== "undefined" && typeof value[Symbol.iterator] === "function") {
  	          return Array.from(value);
  	        }
  	      } catch (_) {}
  	      return [value];
  	    }
  	    return [];
  	  }

  	  async function driverLoadRow(tableName, objectId) {
  	    if (!DB || !objectId || !DB.Data || typeof DB.Data.of !== "function") return null;
  	    const store = DB.Data.of(tableName);
  	    try {
  	      if (store && typeof store.findById === "function") {
  	        return await store.findById(String(objectId));
  	      }
  	    } catch (_) {}
  	    try {
  	      if (
  	        store &&
  	        typeof store.find === "function" &&
  	        DB.DataQueryBuilder &&
  	        typeof DB.DataQueryBuilder.create === "function"
  	      ) {
  	        const escaped = String(objectId).replace(/'/g, "''");
  	        const query = DB.DataQueryBuilder.create();
  	        if (typeof query.setWhereClause === "function") query.setWhereClause("objectId = '" + escaped + "'");
  	        if (typeof query.setPageSize === "function") query.setPageSize(1);
  	        const rows = await store.find(query);
  	        return arr(rows)[0] || null;
  	      }
  	    } catch (_) {}
  	    return null;
  	  }

  	  async function driverLoadRelation(tableName, parentId, relationName) {
  	    if (!DB || !parentId || !relationName || !DB.Data || typeof DB.Data.of !== "function") return [];
  	    if (!DB.LoadRelationsQueryBuilder || typeof DB.LoadRelationsQueryBuilder.create !== "function") return [];
  	    const store = DB.Data.of(tableName);
  	    if (!store || typeof store.loadRelations !== "function") return [];

  	    const all = [];
  	    const pageSize = 100;
  	    for (let offset = 0; offset < 1000; offset += pageSize) {
  	      try {
  	        const query = DB.LoadRelationsQueryBuilder.create();
  	        query.setRelationName(relationName);
  	        if (typeof query.setPageSize === "function") query.setPageSize(pageSize);
  	        if (typeof query.setOffset === "function") query.setOffset(offset);
  	        const batch = driverRelationRows(await store.loadRelations(String(parentId), query));
  	        all.push.apply(all, batch);
  	        if (batch.length < pageSize || typeof query.setOffset !== "function") break;
  	      } catch (_) {
  	        break;
  	      }
  	    }
  	    return all;
  	  }

  	  async function driverLoadFuelVehicleContext(vehicle, view) {
  	    const vehicleId = objectIdOf(vehicle);
  	    let workingVehicle = clone(vehicle) || {};
  	    const freshVehicle = await driverLoadRow("Tractors", vehicleId);
  	    if (freshVehicle && typeof freshVehicle === "object") {
  	      workingVehicle = Object.assign({}, workingVehicle, freshVehicle);
  	    }

  	    ["TPositions", "TyrePositions"].forEach(function (key) {
  	      if (
  	        (workingVehicle[key] === undefined || workingVehicle[key] === null || workingVehicle[key] === "") &&
  	        vehicle && vehicle[key] !== undefined
  	      ) {
  	        workingVehicle[key] = clone(vehicle[key]);
  	      }
  	    });

  	    const tyreRows = await driverLoadRelation("Tractors", vehicleId, "Tyres");
  	    if (tyreRows.length) workingVehicle.Tyres = tyreRows;
  	    else if (!driverRelationRows(workingVehicle.Tyres).length) workingVehicle.Tyres = driverRelationRows(vehicle && vehicle.Tyres);

  	    const maintenanceRows = await driverLoadRelation("Tractors", vehicleId, "Maintenance");
  	    if (maintenanceRows.length) workingVehicle.Maintenance = maintenanceRows;
  	    else if (!driverRelationRows(workingVehicle.Maintenance).length) workingVehicle.Maintenance = driverRelationRows(vehicle && vehicle.Maintenance);

  	    const viewId = objectIdOf(view);
  	    let workingView = view ? clone(view) : null;
  	    if (viewId) {
  	      const freshView = await driverLoadRow("Tractorview", viewId);
  	      if (freshView && typeof freshView === "object") workingView = Object.assign({}, workingView || {}, freshView);
  	    }
  	    if (workingView) workingVehicle.ViewC = workingView;

  	    return {
  	      vehicle: workingVehicle,
  	      view: workingView || view || null
  	    };
  	  }

  	  function driverEnsureVehicleUsage(vehicle) {
  	    if (!vehicle || typeof vehicle !== "object") return null;
  	    if (!vehicle.Data || typeof vehicle.Data !== "object" || Array.isArray(vehicle.Data)) vehicle.Data = {};
  	    if (!vehicle.Data.Vehicle || typeof vehicle.Data.Vehicle !== "object" || Array.isArray(vehicle.Data.Vehicle)) vehicle.Data.Vehicle = {};
  	    if (!vehicle.Data.Vehicle.Usage || typeof vehicle.Data.Vehicle.Usage !== "object" || Array.isArray(vehicle.Data.Vehicle.Usage)) {
  	      vehicle.Data.Vehicle.Usage = {};
  	    }
  	    return vehicle.Data.Vehicle.Usage;
  	  }

  	  function driverSetVehicleCurrentReading(vehicle, reading, profile) {
  	    const numeric = numberValue(reading);
  	    if (!vehicle || numeric === null || numeric < 0) return;
  	    const usage = driverEnsureVehicleUsage(vehicle);
  	    const unitType = profile && profile.kind === "hours" ? "Time" : "Distance";
  	    const existing = usage.CurrentReading;
  	    if (existing && typeof existing === "object" && !Array.isArray(existing)) {
  	      existing.value = numeric;
  	      existing.editable = false;
  	      existing.selector = "number";
  	      existing.unitType = unitType;
  	    } else {
  	      usage.CurrentReading = {
  	        value: numeric,
  	        editable: false,
  	        selector: "number",
  	        unitType: unitType
  	      };
  	    }
  	    vehicle.Mileage = numeric;
  	  }

  	  function driverIncrementFuelCounter(vehicle) {
  	    const node = getDeep(vehicle, ["Data", "OperationalTargets", "Fuel_Counter"], null);
  	    if (node === null || node === undefined) return;
  	    const next = numberOr(descriptorValue(node), 0) + 1;
  	    if (node && typeof node === "object" && !Array.isArray(node)) {
  	      node.value = next;
  	    } else if (vehicle.Data && vehicle.Data.OperationalTargets) {
  	      vehicle.Data.OperationalTargets.Fuel_Counter = next;
  	    }
  	  }

  	  function driverTPositions(vehicle) {
  	    let raw = firstValue([
  	      vehicle && vehicle.TPositions,
  	      vehicle && vehicle.TyrePositions,
  	      getDeep(vehicle, ["Data", "TPositions"], null),
  	      getDeep(vehicle, ["Data", "TyrePositions"], null)
  	    ], {});
  	    raw = descriptorValue(raw);
  	    if (typeof raw === "string") {
  	      try { raw = JSON.parse(raw); } catch (_) { raw = {}; }
  	    }
  	    if (!raw || typeof raw !== "object" || Array.isArray(raw)) raw = {};
  	    const positions = raw.Positions && typeof raw.Positions === "object" && !Array.isArray(raw.Positions)
  	      ? raw.Positions
  	      : {};
  	    return { raw: raw, positions: positions };
  	  }

  	  function driverTyreByAnyId(rows, id) {
  	    const wanted = clean(id);
  	    if (!wanted) return null;
  	    return driverRelationRows(rows).find(function (tyre) {
  	      return clean(firstValue([
  	        tyre && tyre.objectId,
  	        tyre && tyre.ID,
  	        tyre && tyre.FID,
  	        tyre && tyre.Serial_Number
  	      ], "")) === wanted;
  	    }) || null;
  	  }

  	  function driverTyreIsSpare(tyre, positionKey, slot) {
  	    const position = clean(firstValue([
  	      positionKey,
  	      tyre && tyre.Current_Position,
  	      getDeep(tyre, ["History", "Current", "Position"], "")
  	    ], "")).replace(/[\s_-]+/g, "").toUpperCase();
  	    const axleType = lower(firstValue([
  	      slot && slot.AxleType,
  	      tyre && tyre.Current_Axle_Type,
  	      getDeep(tyre, ["History", "Current", "Axle_Type"], "")
  	    ], ""));
  	    return axleType === "spare" || /^SP(?:ARE)?\d*$/.test(position);
  	  }

  	  function driverTyreWearRate(tyre, positionKey, slot) {
  	    if (driverTyreIsSpare(tyre, positionKey, slot)) return 0;
  	    const axleType = lower(firstValue([
  	      slot && slot.AxleType,
  	      tyre && tyre.Current_Axle_Type,
  	      getDeep(tyre, ["History", "Current", "Axle_Type"], "")
  	    ], ""));
  	    if (axleType === "tag") {
  	      const rate = numberValue(firstValue([
  	        slot && slot.WearRate,
  	        tyre && tyre.Current_Wear_Rate,
  	        1
  	      ], 1));
  	      return Math.max(0, Math.min(1, rate === null ? 1 : rate));
  	    }
  	    return 1;
  	  }

  	  function driverFittedTyres(vehicle) {
  	    const relationTyres = driverRelationRows(vehicle && vehicle.Tyres);
  	    const result = [];
  	    const seen = Object.create(null);
  	    const tPositions = driverTPositions(vehicle);
  	    const positions = tPositions.positions;

  	    Object.keys(positions).forEach(function (positionKey) {
  	      const slot = positions[positionKey] || {};
  	      const tyreId = clean(firstValue([
  	        slot.TyreObjectId,
  	        slot.TyreId,
  	        slot.ObjectId
  	      ], ""));
  	      if (!tyreId || seen[tyreId]) return;
  	      const tyre = driverTyreByAnyId(relationTyres, tyreId);
  	      if (!tyre || !objectIdOf(tyre)) return;
  	      seen[tyreId] = true;
  	      result.push({
  	        tyre: tyre,
  	        positionKey: positionKey,
  	        slot: slot,
  	        wearRate: driverTyreWearRate(tyre, positionKey, slot),
  	        spare: driverTyreIsSpare(tyre, positionKey, slot)
  	      });
  	    });

  	    const vehicleId = objectIdOf(vehicle);
  	    const vehicleCode = clean(firstValue([vehicle && vehicle.ID, vehicle && vehicle.FID], ""));
  	    relationTyres.forEach(function (tyre) {
  	      const tyreId = objectIdOf(tyre);
  	      if (!tyreId || seen[tyreId]) return;

  	      const holderType = lower(tyre && tyre.Current_Holder_Type);
  	      if (holderType && holderType !== "vehicle") return;
  	      if (tyre && tyre.Is_Fitted === false) return;

  	      const linkedObjectId = clean(firstValue([
  	        tyre && tyre.Current_Holder_ObjectId,
  	        tyre && tyre.Vehicle_ObjectId,
  	        tyre && tyre.VehicleObjectId,
  	        getDeep(tyre, ["History", "Current", "Vehicle_ObjectId"], "")
  	      ], ""));
  	      const linkedVehicleId = clean(firstValue([
  	        tyre && tyre.Vehicle_ID,
  	        tyre && tyre.VehicleId
  	      ], ""));
  	      const currentPosition = clean(firstValue([
  	        tyre && tyre.Current_Position,
  	        getDeep(tyre, ["History", "Current", "Position"], "")
  	      ], ""));

  	      const attached =
  	        !!currentPosition ||
  	        (vehicleId && linkedObjectId === vehicleId) ||
  	        (vehicleCode && linkedVehicleId === vehicleCode);
  	      if (!attached) return;

  	      let slot = null;
  	      if (currentPosition && positions[currentPosition]) slot = positions[currentPosition];
  	      if (!slot && currentPosition) {
  	        const wanted = currentPosition.replace(/[\s_-]+/g, "").toUpperCase();
  	        Object.keys(positions).some(function (key) {
  	          if (key.replace(/[\s_-]+/g, "").toUpperCase() === wanted) {
  	            slot = positions[key];
  	            return true;
  	          }
  	          return false;
  	        });
  	      }

  	      seen[tyreId] = true;
  	      result.push({
  	        tyre: tyre,
  	        positionKey: currentPosition,
  	        slot: slot,
  	        wearRate: driverTyreWearRate(tyre, currentPosition, slot),
  	        spare: driverTyreIsSpare(tyre, currentPosition, slot)
  	      });
  	    });

  	    return result;
  	  }

  	  function driverTyreHistoryObject(tyre) {
  	    const raw = tyre && tyre.History;
  	    if (!raw) return {};
  	    if (typeof raw === "object" && !Array.isArray(raw)) return clone(raw) || {};
  	    try {
  	      const parsed = JSON.parse(raw);
  	      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  	    } catch (_) {
  	      return {};
  	    }
  	  }

  	  function driverTyreStageKey(history, currentStage) {
  	    const direct = clean(currentStage);
  	    if (direct && history[direct] && typeof history[direct] === "object") return direct;
  	    const wanted = direct.toLowerCase().replace(/[^a-z0-9]/g, "");
  	    if (!wanted) return "";
  	    return Object.keys(history).find(function (key) {
  	      return key.toLowerCase().replace(/[^a-z0-9]/g, "") === wanted &&
  	        history[key] && typeof history[key] === "object";
  	    }) || "";
  	  }

  	  function driverEnsureTyreStage(history, tyre, currentMileage) {
  	    const safeHistory = history && typeof history === "object" && !Array.isArray(history) ? history : {};
  	    const requestedStage = clean(firstValue([
  	      tyre && tyre.Current_Stage,
  	      getDeep(safeHistory, ["Current", "Stage"], "")
  	    ], "New")) || "New";
  	    let stageKey = driverTyreStageKey(safeHistory, requestedStage);
  	    let repaired = false;

  	    if (!stageKey) {
  	      stageKey = requestedStage;
  	      safeHistory[stageKey] = {
  	        CPK: 0,
  	        Cost: 0,
  	        Ended: "",
  	        Notes: "Usage stage restored automatically during fuel capture.",
  	        Active: true,
  	        Events: [],
  	        Status: "Active",
  	        Started: clean(firstValue([
  	          tyre && tyre.Fitted_Date,
  	          tyre && tyre.Date_Fitted,
  	          tyre && tyre.created
  	        ], "")) || new Date().toISOString(),
  	        End_Mileage: Math.max(0, numberOr(currentMileage, 0)),
  	        Mileage_Done: 0,
  	        Start_Mileage: Math.max(0, numberOr(currentMileage, 0)),
  	        Mileage_Expected: Math.max(0, numberOr(tyre && tyre.Expected_Mileage, 0))
  	      };
  	      repaired = true;
  	    }

  	    if (!safeHistory.Current || typeof safeHistory.Current !== "object" || Array.isArray(safeHistory.Current)) {
  	      safeHistory.Current = {};
  	    }
  	    safeHistory.Current.Stage = stageKey;
  	    return { history: safeHistory, stageKey: stageKey, repaired: repaired };
  	  }

  	  function driverTyreCurrentLife(tyre, source) {
  	    const expected = numberValue(firstValue([
  	      source && source.Expected_Mileage,
  	      tyre && tyre.Expected_Mileage
  	    ], null));
  	    const current = Math.max(0, numberOr(firstValue([
  	      source && source.Current_Mileage,
  	      tyre && tyre.Current_Mileage
  	    ], 0), 0));
  	    if (expected === null || expected <= 0) return numberOr(tyre && tyre.Current_Life, 0);
  	    const remaining = numberOr(firstValue([
  	      source && source.Remaining_Mileage,
  	      expected - current
  	    ], expected - current), expected - current);
  	    return Math.round(Math.max(0, Math.min(100, remaining / expected * 100)) * 100) / 100;
  	  }

  	  function driverBuildTyreUsagePatch(item, targetReading, previousReading, readingDelta) {
  	    const tyre = item && item.tyre;
  	    const tyreId = objectIdOf(tyre);
  	    if (!tyre || !tyreId) return null;

  	    const lastVehicleReading = numberValue(tyre.Last_Vehicle_Odometer);
  	    if (lastVehicleReading !== null && lastVehicleReading > targetReading) {
  	      throw new Error("Tyre " + tyreId + " has a last vehicle reading higher than the new vehicle reading.");
  	    }

  	    let vehicleUsage = Math.max(0, numberOr(readingDelta, 0));
  	    if (lastVehicleReading !== null && lastVehicleReading > 0) vehicleUsage = Math.max(0, targetReading - lastVehicleReading);
  	    else if (previousReading === null) vehicleUsage = 0;

  	    const wearRate = Math.max(0, Math.min(1, numberOr(item.wearRate, 1)));
  	    const increment = Math.round(vehicleUsage * wearRate * 1000) / 1000;
  	    const oldCurrentMileage = Math.max(0, numberOr(tyre.Current_Mileage, 0));
  	    const oldTotalMileage = Math.max(0, numberOr(firstValue([tyre.Total_Mileage, oldCurrentMileage], oldCurrentMileage), oldCurrentMileage));

  	    if (item.spare) {
  	      return {
  	        tyre: tyre,
  	        increment: 0,
  	        historyRepaired: false,
  	        patch: {
  	          objectId: tyreId,
  	          Last_Vehicle_Odometer: targetReading,
  	          Current_Wear_Rate: 0
  	        }
  	      };
  	    }

  	    if (!(increment > 0)) return null;

  	    const newCurrentMileage = Math.round((oldCurrentMileage + increment) * 1000) / 1000;
  	    const newTotalMileage = Math.round((oldTotalMileage + increment) * 1000) / 1000;
  	    const stageResolution = driverEnsureTyreStage(driverTyreHistoryObject(tyre), tyre, oldCurrentMileage);
  	    const stage = clone(stageResolution.history[stageResolution.stageKey]) || {};
  	    stage.Mileage_Done = Math.round((Math.max(0, numberOr(stage.Mileage_Done, 0)) + increment) * 1000) / 1000;
  	    stage.End_Mileage = newCurrentMileage;
  	    stageResolution.history[stageResolution.stageKey] = stage;

  	    if (!stageResolution.history.Totals || typeof stageResolution.history.Totals !== "object" || Array.isArray(stageResolution.history.Totals)) {
  	      stageResolution.history.Totals = {};
  	    }
  	    stageResolution.history.Totals.Mileage_Total =
  	      Math.round((Math.max(0, numberOr(stageResolution.history.Totals.Mileage_Total, 0)) + increment) * 1000) / 1000;

  	    const patch = {
  	      objectId: tyreId,
  	      Current_Mileage: newCurrentMileage,
  	      Total_Mileage: newTotalMileage,
  	      Last_Vehicle_Odometer: targetReading,
  	      Current_Wear_Rate: wearRate,
  	      History: stageResolution.history
  	    };
  	    const expected = numberValue(tyre.Expected_Mileage);
  	    if (expected !== null && expected >= 0) {
  	      patch.Remaining_Mileage = Math.max(0, Math.round((expected - newCurrentMileage) * 1000) / 1000);
  	    }

  	    return {
  	      tyre: tyre,
  	      increment: increment,
  	      historyRepaired: stageResolution.repaired,
  	      patch: patch
  	    };
  	  }

  	  function driverMergeSavedTyre(vehicle, sourceTyre, saved, patch) {
  	    const row = Object.assign(sourceTyre || {}, saved || {}, patch || {});
  	    row.Current_Life = driverTyreCurrentLife(row, row);
  	    const rows = driverRelationRows(vehicle.Tyres);
  	    const id = objectIdOf(row);
  	    const index = rows.findIndex(function (item) { return objectIdOf(item) === id; });
  	    if (index === -1) rows.push(row);
  	    else rows[index] = Object.assign(rows[index], row);
  	    vehicle.Tyres = rows;
  	  }

  	  async function driverApplyTyreUsage(vehicle, targetReading, previousReading, readingDelta) {
  	    const result = {
  	      processed: 0,
  	      updated: 0,
  	      advanced: 0,
  	      historyRepairs: 0,
  	      errors: []
  	    };
  	    const items = driverFittedTyres(vehicle);
  	    result.processed = items.length;

  	    const updates = [];
  	    items.forEach(function (item) {
  	      try {
  	        const update = driverBuildTyreUsagePatch(item, targetReading, previousReading, readingDelta);
  	        if (update) updates.push(update);
  	      } catch (error) {
  	        result.errors.push(clean(error && (error.message || error.faultString)) || "Tyre usage update could not be prepared.");
  	      }
  	    });

  	    const savedRows = await Promise.all(updates.map(async function (update) {
  	      try {
  	        const saved = await DB.Data.of("Tyres").save(update.patch);
  	        return { update: update, saved: saved || update.patch, error: null };
  	      } catch (error) {
  	        return { update: update, saved: null, error: error };
  	      }
  	    }));

  	    savedRows.forEach(function (entry) {
  	      if (entry.error) {
  	        result.errors.push(clean(entry.error && (entry.error.message || entry.error.faultString)) || "Tyre usage update failed.");
  	        return;
  	      }
  	      driverMergeSavedTyre(vehicle, entry.update.tyre, entry.saved, entry.update.patch);
  	      result.updated += 1;
  	      if (entry.update.increment > 0) result.advanced += 1;
  	      if (entry.update.historyRepaired) result.historyRepairs += 1;
  	    });

  	    return result;
  	  }

  	  function driverCollectionValue(value) {
  	    if (value === null || value === undefined) return value;
  	    if (Array.isArray(value)) return value;

  	    if (value && typeof value === "object") {
  	      const keys = ["value", "Value", "current", "Current"];
  	      for (let index = 0; index < keys.length; index += 1) {
  	        const key = keys[index];
  	        if (
  	          Object.prototype.hasOwnProperty.call(value, key) &&
  	          value[key] !== null &&
  	          value[key] !== undefined
  	        ) {
  	          return driverCollectionValue(value[key]);
  	        }
  	      }
  	    }

  	    return value;
  	  }

  	  function driverAppCompanies() {
  	    return uniqueObjects(
  	      arr(getDeep(APP_DATA, ["User", "Companies"], []))
  	        .concat(arr(APP_DATA && APP_DATA.Companies))
  	    );
  	  }

  	  function driverCompanyIdentityKeys(company) {
  	    if (!company || typeof company !== "object") return [];

  	    return [
  	      objectIdOf(company),
  	      descriptorValue(company.CompanyId),
  	      descriptorValue(company.CompanyID),
  	      descriptorValue(company.Name),
  	      descriptorValue(company.CompanyName),
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "CompanyId"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "Company_Name"], "")),
  	      descriptorValue(getDeep(company, ["Manifest", "Profile", "TradingName"], ""))
  	    ].map(function (value) {
  	      return lower(value);
  	    }).filter(Boolean);
  	  }

  	  function driverCompanyContainsVehicle(company, vehicle) {
  	    const vehicleId = objectIdOf(vehicle);
  	    const registration = lower(vehicleRegistration(vehicle));
  	    const vehicleCode = lower(firstValue([
  	      descriptorValue(vehicle && vehicle.ID),
  	      descriptorValue(vehicle && vehicle.FID),
  	      descriptorValue(vehicle && vehicle.Name)
  	    ], ""));

  	    return arr(company && company.Tractors)
  	      .concat(arr(company && company.Vehicles))
  	      .concat(arr(getDeep(company, ["Data", "Tractors"], [])))
  	      .some(function (item) {
  	        if (!item || typeof item !== "object") return false;

  	        if (vehicleId && objectIdOf(item) === vehicleId) return true;

  	        const itemRegistration = lower(vehicleRegistration(item));
  	        if (
  	          registration &&
  	          itemRegistration &&
  	          registration === itemRegistration
  	        ) return true;

  	        const itemCode = lower(firstValue([
  	          descriptorValue(item.ID),
  	          descriptorValue(item.FID),
  	          descriptorValue(item.Name)
  	        ], ""));

  	        return !!(
  	          vehicleCode &&
  	          itemCode &&
  	          vehicleCode === itemCode
  	        );
  	      });
  	  }

  	  function driverResolveCompanyFromAppData(company, vehicle) {
  	    const companies = driverAppCompanies();
  	    if (!companies.length) return company || null;

  	    const containing = companies.find(function (candidate) {
  	      return driverCompanyContainsVehicle(candidate, vehicle);
  	    });

  	    if (containing) return containing;

  	    const suppliedKeys = driverCompanyIdentityKeys(company);
  	    if (suppliedKeys.length) {
  	      const matching = companies.find(function (candidate) {
  	        return driverCompanyIdentityKeys(candidate).some(function (key) {
  	          return suppliedKeys.indexOf(key) !== -1;
  	        });
  	      });

  	      if (matching) return matching;
  	    }

  	    return companies.length === 1
  	      ? companies[0]
  	      : (company || null);
  	  }

  	  function driverUniqueEmails(values) {
  	    const result = [];
  	    const seen = Object.create(null);

  	    arr(values).forEach(function (value) {
  	      String(descriptorValue(value) || "")
  	        .split(/[;,\n]+/)
  	        .map(function (item) { return clean(item); })
  	        .filter(Boolean)
  	        .forEach(function (email) {
  	          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
  	          const key = lower(email);
  	          if (seen[key]) return;
  	          seen[key] = true;
  	          result.push(email);
  	        });
  	    });

  	    return result;
  	  }

  	  function driverCompanyServiceEmails(company) {
  	    if (!company || typeof company !== "object") return [];

  	    return driverUniqueEmails([
  	      getDeep(company, ["Manifest", "Profile", "PrimaryEmail"], null),
  	      getDeep(company, ["Manifest", "Contacts", "Primary", "Email"], null),
  	      getDeep(company, ["Manifest", "Profile", "Email"], null),
  	      getDeep(company, ["Manifest", "Billing", "Account", "InvoiceEmail"], null),
  	      getDeep(company, ["Manifest", "Billing", "Account", "StatementEmail"], null),
  	      company.PrimaryEmail,
  	      company.CompanyEmail,
  	      company.ContactEmail,
  	      company.Email,
  	      company.email
  	    ]);
  	  }

  	  function driverServiceArray(value) {
  	    value = driverCollectionValue(value);

  	    if (Array.isArray(value)) return value.slice();

  	    if (value && typeof value === "object") {
  	      if (Array.isArray(value.data)) return value.data.slice();
  	      if (Array.isArray(value.items)) return value.items.slice();
  	    }

  	    return [];
  	  }

  	  function driverServiceProviders(company) {
  	    const rows = driverServiceArray(firstValue([
  	      getDeep(company, ["Manifest", "ServiceProviders"], null),
  	      getDeep(company, ["Data", "Manifest", "ServiceProviders"], null)
  	    ], []));
  	    return rows.map(function (provider) {
  	      provider = provider && typeof provider === "object" ? provider : {};
  	      return {
  	        ProviderId: clean(firstValue([
  	          provider.ProviderId,
  	          provider.Id,
  	          provider.objectId,
  	          provider.Name,
  	          provider.CompanyName
  	        ], "")),
  	        Name: clean(firstValue([provider.Name, provider.Company, provider.CompanyName, "Service Provider"], "Service Provider")),
  	        TradingName: clean(provider.TradingName),
  	        Status: clean(provider.Status || "Active"),
  	        Preferred: booleanValue(provider.Preferred),
  	        Contact: {
  	          Email: clean(firstValue([
  	            getDeep(provider, ["Contact", "Email"], null),
  	            provider.Email
  	          ], ""))
  	        }
  	      };
  	    });
  	  }

  	  function driverServiceProviderLabel(provider) {
  	    return clean(firstValue([
  	      provider && provider.TradingName,
  	      provider && provider.Name,
  	      "Service Provider"
  	    ], "Service Provider"));
  	  }

  	  function driverServiceProviderByIdOrName(company, value) {
  	    const wanted = clean(value);
  	    if (!wanted) return null;
  	    const key = lower(wanted);
  	    return driverServiceProviders(company).find(function (provider) {
  	      return clean(provider.ProviderId) === wanted ||
  	        lower(driverServiceProviderLabel(provider)) === key ||
  	        lower(provider.Name) === key;
  	    }) || null;
  	  }

  	  function driverServiceSetup(vehicle) {
  	    const service = getDeep(vehicle, ["Data", "Service"], {}) || {};
  	    const schedule = getDeep(service, ["Schedule"], {}) || {};
  	    const notifications = getDeep(service, ["Notifications"], {}) || {};
  	    const current = getDeep(service, ["Current"], {}) || {};
  	    const history = getDeep(service, ["History"], {}) || {};
  	    const profile = vehicleMeterProfile(vehicle);
  	    const hours = profile.kind === "hours";

  	    return {
  	      unit: hours ? "h" : "km",
  	      notifyProvider: booleanValue(
  	        descriptorValue(notifications.NotifyServiceProvider)
  	      ),
  	      notifyCompany: booleanValue(
  	        descriptorValue(notifications.NotifyCompany)
  	      ),
  	      providerId: clean(descriptorValue(firstValue([
  	        notifications.ServiceProviderId,
  	        notifications.ProviderId
  	      ], ""))),
  	      providerName: clean(descriptorValue(firstValue([
  	        notifications.ServiceProviderName,
  	        notifications.ProviderName
  	      ], ""))),
  	      interval: Math.max(0, numberOr(descriptorValue(firstValue(hours ? [
  	        schedule.ServiceIntervalHours,
  	        schedule.Service_Interval_Hours
  	      ] : [
  	        schedule.ServiceIntervalKM,
  	        schedule.Service_Interval_KM,
  	        service.Service_Interval
  	      ], 0)), 0)),
  	      intervalDays: Math.max(0, numberOr(descriptorValue(firstValue([
  	        schedule.ServiceIntervalDays,
  	        schedule.Service_Interval_Days
  	      ], 0)), 0)),
  	      warning: Math.max(0, numberOr(descriptorValue(firstValue(hours ? [
  	        schedule.ServiceWarningHours
  	      ] : [
  	        schedule.ServiceWarningKM,
  	        service.Service_Warning_Duration_in_KM
  	      ], 0)), 0)),
  	      warningDays: Math.max(0, numberOr(descriptorValue(schedule.ServiceWarningDays), 0)),
  	      lastReading: numberValue(descriptorValue(firstValue(hours ? [
  	        current.LastServiceHours,
  	        current.Last_Service_Hours,
  	        history.Last_Service_Hours
  	      ] : [
  	        current.LastServiceMileage,
  	        current.Last_Service_KM,
  	        current.LastServiceKM,
  	        history.Last_Service_KM
  	      ], null))),
  	      storedNextReading: numberValue(descriptorValue(firstValue(hours ? [
  	        current.NextServiceHours,
  	        current.Next_Service_Hours,
  	        history.Next_Service_Hours
  	      ] : [
  	        current.NextServiceMileage,
  	        current.Next_Service_KM,
  	        current.NextServiceKM,
  	        history.Next_Service_KM
  	      ], null))),
  	      lastDate: clean(descriptorValue(firstValue([
  	        current.LastServiceDate,
  	        current.Last_Service_Date,
  	        history.Last_Service_Date
  	      ], ""))),
  	      storedNextDate: clean(descriptorValue(firstValue([
  	        current.NextServiceDate,
  	        current.Next_Service_Date_Estimate,
  	        current.Next_Service_Date,
  	        history.Next_Service_Date_Estimate,
  	        history.Next_Service_Date
  	      ], "")))
  	    };
  	  }

  	  function driverDatePlusDays(value, days) {
  	    const date = new Date(value);
  	    const count = Math.round(numberOr(days, 0));
  	    if (!count || Number.isNaN(date.getTime())) return "";
  	    date.setUTCDate(date.getUTCDate() + count);
  	    return date.toISOString().slice(0, 10);
  	  }

  	  function driverDaysUntil(value) {
  	    const date = new Date(value);
  	    if (!value || Number.isNaN(date.getTime())) return null;
  	    const today = new Date();
  	    today.setHours(0, 0, 0, 0);
  	    date.setHours(0, 0, 0, 0);
  	    return Math.ceil((date.getTime() - today.getTime()) / 86400000);
  	  }

  	  function driverServiceWorkOrders(company, vehicle) {
  	    const vehicleId = objectIdOf(vehicle);
  	    const vehicleCode = clean(firstValue([vehicle && vehicle.ID, vehicle && vehicle.FID, vehicleName(vehicle)], ""));
  	    const manifestRows = driverServiceArray(firstValue([
  	      getDeep(company, ["Manifest", "ServiceWorkOrders"], null),
  	      getDeep(company, ["Data", "Manifest", "ServiceWorkOrders"], null)
  	    ], []));
  	    return uniqueObjects(manifestRows.concat(driverRelationRows(vehicle && vehicle.Maintenance))).filter(function (order) {
  	      const linkedId = clean(firstValue([
  	        order && order.VehicleObjectId,
  	        order && order.TractorObjectId,
  	        getDeep(order, ["Data", "VehicleObjectId"], "")
  	      ], ""));
  	      const linkedCode = clean(firstValue([
  	        order && order.VehicleId,
  	        order && order.TractorId,
  	        order && order.Registration,
  	        getDeep(order, ["Data", "VehicleId"], "")
  	      ], ""));
  	      return !linkedId && !linkedCode ? true :
  	        (vehicleId && linkedId === vehicleId) ||
  	        (vehicleCode && linkedCode === vehicleCode) ||
  	        (vehicleRegistration(vehicle) && linkedCode === vehicleRegistration(vehicle));
  	    });
  	  }

  	  function driverCanonicalMaintenanceStatus(value) {
  	    const key = lower(value).replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  	    if (!key || key === "new" || key === "scheduled" || key === "planned") return "Scheduled";
  	    if (key === "booked" || key === "confirmed" || key === "booking confirmed") return "Booked";
  	    if (key === "in progress" || key === "at provider" || key === "workshop" || key === "started") return "In Progress";
  	    if (key === "waiting parts" || key === "waiting for parts" || key === "delayed" || key === "on hold") return "Waiting Parts";
  	    if (key === "ready" || key === "ready for collection" || key === "awaiting collection") return "Ready";
  	    if (key === "completed" || key === "complete" || key === "closed") return "Completed";
  	    if (key === "cancelled" || key === "canceled" || key === "abandoned") return "Cancelled";
  	    return clean(value) || "Scheduled";
  	  }

  	  function driverServiceHealth(company, vehicle) {
  	    const setup = driverServiceSetup(vehicle);
  	    const reading = currentMileage(vehicle);
  	    const nextReading = setup.lastReading !== null && setup.interval > 0
  	      ? setup.lastReading + setup.interval
  	      : setup.storedNextReading !== null && setup.storedNextReading > 0
  	        ? setup.storedNextReading
  	        : null;
  	    const nextDate = setup.lastDate && setup.intervalDays > 0
  	      ? driverDatePlusDays(setup.lastDate, setup.intervalDays)
  	      : setup.storedNextDate;
  	    const calculationReading = reading === null
  	      ? setup.lastReading
  	      : setup.lastReading === null
  	        ? reading
  	        : Math.max(reading, setup.lastReading);
  	    const remaining = nextReading === null || calculationReading === null ? null : nextReading - calculationReading;
  	    const remainingDays = nextDate ? driverDaysUntil(nextDate) : null;
  	    const counterConflict = nextReading !== null && setup.lastReading !== null && nextReading <= setup.lastReading;
  	    const lastDateValue = setup.lastDate ? new Date(setup.lastDate) : null;
  	    const nextDateValue = nextDate ? new Date(nextDate) : null;
  	    const dateConflict = !!(
  	      lastDateValue && nextDateValue &&
  	      !Number.isNaN(lastDateValue.getTime()) &&
  	      !Number.isNaN(nextDateValue.getTime()) &&
  	      nextDateValue.getTime() <= lastDateValue.getTime()
  	    );
  	    const openOrders = driverServiceWorkOrders(company, vehicle).filter(function (order) {
  	      const category = lower(firstValue([order && order.Category, getDeep(order, ["Data", "Category"], "")], ""));
  	      const status = driverCanonicalMaintenanceStatus(firstValue([order && order.Status, getDeep(order, ["Data", "Status"], "")], ""));
  	      return (category === "service" || /service/.test(category)) &&
  	        ["Scheduled", "Booked", "In Progress", "Waiting Parts", "Ready"].indexOf(status) !== -1;
  	    });

  	    return {
  	      unit: setup.unit,
  	      nextCounter: nextReading,
  	      lastCounter: setup.lastReading,
  	      remainingCounter: remaining,
  	      nextDate: nextDate,
  	      remainingDays: remainingDays,
  	      warningCounter: setup.warning,
  	      warningDays: setup.warningDays,
  	      dataConflict: counterConflict || dateConflict,
  	      openOrders: openOrders
  	    };
  	  }

  	  function driverProviderSnapshotFromVehicle(vehicle, requested) {
  	    const notifications =
  	      getDeep(vehicle, ["Data", "Service", "Notifications"], {}) || {};

  	    let providerId = clean(descriptorValue(firstValue([
  	      notifications.ServiceProviderId,
  	      notifications.ProviderId,
  	      requested
  	    ], "")));

  	    let providerName = clean(descriptorValue(firstValue([
  	      notifications.ServiceProviderName,
  	      notifications.ProviderName
  	    ], "")));

  	    let providerEmail = clean(descriptorValue(firstValue([
  	      notifications.ServiceProviderEmail,
  	      notifications.ProviderEmail
  	    ], "")));

  	    const wanted = lower(firstValue([
  	      requested,
  	      providerId,
  	      providerName
  	    ], ""));

  	    const history = driverProviderHistory(vehicle);

  	    for (let index = history.length - 1; index >= 0; index -= 1) {
  	      const entry = history[index] || {};
  	      const historyId = clean(entry.ProviderId);
  	      const historyName = clean(entry.ProviderName);
  	      const historyEmail = clean(entry.ProviderEmail);

  	      const matches =
  	        !wanted ||
  	        lower(historyId) === wanted ||
  	        lower(historyName) === wanted ||
  	        (providerId && historyId === providerId) ||
  	        (
  	          providerName &&
  	          lower(historyName) === lower(providerName)
  	        );

  	      if (!matches) continue;

  	      if (!providerId && historyId) providerId = historyId;
  	      if (!providerName && historyName) providerName = historyName;
  	      if (!providerEmail && historyEmail) providerEmail = historyEmail;

  	      if (providerEmail) break;
  	    }

  	    if (!providerEmail) return null;

  	    return {
  	      ProviderId:
  	        providerId ||
  	        clean(requested) ||
  	        providerName ||
  	        "vehicle-provider",
  	      Name:
  	        providerName ||
  	        clean(requested) ||
  	        "Service Provider",
  	      TradingName: "",
  	      Status: "Active",
  	      Preferred: false,
  	      Contact: { Email: providerEmail },
  	      Source: "Vehicle Service Notification Snapshot"
  	    };
  	  }

  	  function driverResolveNotificationProvider(company, vehicle, requested, health) {
  	    let provider = driverServiceProviderByIdOrName(company, requested);
  	    if (provider && lower(provider.Status) === "active") return provider;

  	    const setup = driverServiceSetup(vehicle);
  	    provider = driverServiceProviderByIdOrName(company, setup.providerId || setup.providerName);
  	    if (provider && lower(provider.Status) === "active") return provider;

  	    const openOrders = health && Array.isArray(health.openOrders) ? health.openOrders : [];
  	    for (let index = 0; index < openOrders.length; index += 1) {
  	      provider = driverServiceProviderByIdOrName(
  	        company,
  	        firstValue([openOrders[index].ProviderId, openOrders[index].ProviderName], "")
  	      );
  	      if (provider && lower(provider.Status) === "active") return provider;
  	    }

  	    const lastUsed = clean(descriptorValue(firstValue([
  	      getDeep(vehicle, ["Data", "Service", "Current", "ServiceCentreLastUsed"], ""),
  	      getDeep(vehicle, ["Data", "Service", "History", "Service_Centre_Last_Used"], "")
  	    ], "")));
  	    provider = driverServiceProviderByIdOrName(company, lastUsed);
  	    if (provider && lower(provider.Status) === "active") return provider;

  	    const active = driverServiceProviders(company).filter(function (candidate) {
  	      return lower(candidate.Status) === "active";
  	    });
  	    const preferred = active.filter(function (candidate) {
  	      return candidate.Preferred === true;
  	    });

  	    if (preferred.length === 1) return preferred[0];
  	    if (active.length === 1) return active[0];

  	    return driverProviderSnapshotFromVehicle(
  	      vehicle,
  	      firstValue([
  	        requested,
  	        setup.providerId,
  	        setup.providerName
  	      ], "")
  	    );
  	  }

  	  function driverServiceNotificationCandidate(company, vehicle) {
  	    const setup = driverServiceSetup(vehicle);
  	    if (!setup.notifyProvider && !setup.notifyCompany) return null;
  	    const health = driverServiceHealth(company, vehicle);
  	    if (health.dataConflict || (health.nextCounter === null && !health.nextDate)) return null;

  	    const overdue =
  	      (health.remainingCounter !== null && health.remainingCounter <= 0) ||
  	      (health.remainingDays !== null && health.remainingDays < 0);
  	    const dueSoon =
  	      (health.remainingCounter !== null && health.warningCounter > 0 && health.remainingCounter <= health.warningCounter) ||
  	      (health.remainingDays !== null && health.warningDays > 0 && health.remainingDays <= health.warningDays);
  	    if (!overdue && !dueSoon) return null;

  	    const provider = driverResolveNotificationProvider(
  	      company,
  	      vehicle,
  	      "",
  	      health
  	    );

  	    const stage = overdue ? "OVERDUE" : "DUE_SOON";
  	    const remaining = [];
  	    const due = [];
  	    if (health.remainingCounter !== null) {
  	      remaining.push(
  	        health.remainingCounter <= 0
  	          ? formatNumber(Math.abs(health.remainingCounter), 0) + " " + health.unit + " overdue"
  	          : formatNumber(health.remainingCounter, 0) + " " + health.unit + " remaining"
  	      );
  	    }
  	    if (health.remainingDays !== null) {
  	      remaining.push(
  	        health.remainingDays < 0
  	          ? Math.abs(health.remainingDays) + " day" + (Math.abs(health.remainingDays) === 1 ? "" : "s") + " overdue"
  	          : health.remainingDays === 0
  	            ? "due today"
  	            : health.remainingDays + " day" + (health.remainingDays === 1 ? "" : "s") + " remaining"
  	      );
  	    }
  	    if (health.nextCounter !== null) due.push(formatNumber(health.nextCounter, 0) + " " + health.unit);
  	    if (health.nextDate) due.push(health.nextDate);

  	    const cycle = [
  	      health.nextCounter === null ? "" : String(Math.round(health.nextCounter * 100) / 100),
  	      clean(health.nextDate)
  	    ].join("|");

  	    return {
  	      key: [
  	        "SERVICE",
  	        objectIdOf(vehicle),
  	        provider
  	          ? provider.ProviderId
  	          : (setup.providerId || setup.providerName || "NO_PROVIDER"),
  	        stage,
  	        cycle
  	      ].join("|"),
  	      kind: "Service",
  	      stage: stage,
  	      provider: provider,
  	      title: overdue ? "Service Overdue" : "Service Due Soon",
  	      summary: remaining.join(" · ") || (overdue ? "The scheduled service is overdue." : "The scheduled service is approaching."),
  	      duePosition: due.join(" · ") || "Configured service interval",
  	      scope: "Scheduled vehicle service",
  	      reference: ""
  	    };
  	  }

  	  function driverPreventivePlans(vehicle) {
  	    return driverServiceArray(getDeep(vehicle, ["Data", "Maintenance", "PreventivePlans"], []))
  	      .filter(function (plan) { return plan && typeof plan === "object" && !Array.isArray(plan); })
  	      .map(function (plan) {
  	        return {
  	          PlanId: clean(plan.PlanId),
  	          Name: clean(plan.Name),
  	          Scope: clean(plan.Scope),
  	          TriggerMode: clean(plan.TriggerMode || "First Due"),
  	          IntervalKM: Math.max(0, numberOr(plan.IntervalKM, 0)),
  	          IntervalDays: Math.max(0, numberOr(plan.IntervalDays, 0)),
  	          WarningKM: Math.max(0, numberOr(plan.WarningKM, 0)),
  	          WarningDays: Math.max(0, numberOr(plan.WarningDays, 0)),
  	          BaselineKM: numberValue(plan.BaselineKM),
  	          BaselineDate: clean(plan.BaselineDate),
  	          ProviderId: clean(plan.ProviderId),
  	          ProviderName: clean(plan.ProviderName),
  	          Active: plan.Active !== false
  	        };
  	      });
  	  }

  	  function driverPreventiveRecords(vehicle, planId) {
  	    const wanted = clean(planId);
  	    return driverRelationRows(vehicle && vehicle.Maintenance).filter(function (record) {
  	      return clean(firstValue([
  	        record && record.PreventivePlanId,
  	        getDeep(record, ["Data", "PreventivePlanId"], "")
  	      ], "")) === wanted;
  	    });
  	  }

  	  function driverPreventiveCandidate(company, vehicle, plan) {
  	    if (!plan || !plan.Active) return null;
  	    const records = driverPreventiveRecords(vehicle, plan.PlanId);
  	    const openJob = records.find(function (record) {
  	      const status = driverCanonicalMaintenanceStatus(firstValue([record && record.Status, getDeep(record, ["Data", "Status"], "")], ""));
  	      return ["Scheduled", "Booked", "In Progress", "Waiting Parts", "Ready"].indexOf(status) !== -1;
  	    });
  	    if (openJob) return null;

  	    const completed = records.filter(function (record) {
  	      return driverCanonicalMaintenanceStatus(firstValue([record && record.Status, getDeep(record, ["Data", "Status"], "")], "")) === "Completed";
  	    }).sort(function (left, right) {
  	      const rightTime = new Date(firstValue([right && right.CompletedDate, right && right.ReportedDate, 0], 0)).getTime();
  	      const leftTime = new Date(firstValue([left && left.CompletedDate, left && left.ReportedDate, 0], 0)).getTime();
  	      return rightTime - leftTime;
  	    })[0] || null;

  	    const currentCounter = currentMileage(vehicle);
  	    const baselineCounter = completed
  	      ? numberValue(firstValue([completed.Odometer, getDeep(completed, ["Data", "Odometer"], null)], null))
  	      : plan.BaselineKM;
  	    const baselineDate = clean(
  	      completed
  	        ? firstValue([completed.CompletedDate, completed.ReportedDate], "")
  	        : plan.BaselineDate
  	    );
  	    const useCounter = plan.TriggerMode !== "Time Only" && plan.IntervalKM > 0;
  	    const useTime = plan.TriggerMode !== "Kilometers Only" && plan.IntervalDays > 0;
  	    const nextCounter = useCounter && baselineCounter !== null ? baselineCounter + plan.IntervalKM : null;
  	    const nextDate = useTime && baselineDate ? driverDatePlusDays(baselineDate, plan.IntervalDays) : "";
  	    const calculationCounter = currentCounter === null
  	      ? baselineCounter
  	      : baselineCounter === null
  	        ? currentCounter
  	        : Math.max(currentCounter, baselineCounter);
  	    const remainingCounter = nextCounter !== null && calculationCounter !== null ? nextCounter - calculationCounter : null;
  	    const remainingDays = nextDate ? driverDaysUntil(nextDate) : null;
  	    const overdue =
  	      (useCounter && remainingCounter !== null && remainingCounter <= 0) ||
  	      (useTime && remainingDays !== null && remainingDays <= 0);
  	    const dueSoon = !overdue && (
  	      (useCounter && remainingCounter !== null && plan.WarningKM > 0 && remainingCounter <= plan.WarningKM) ||
  	      (useTime && remainingDays !== null && plan.WarningDays > 0 && remainingDays <= plan.WarningDays)
  	    );
  	    if (!overdue && !dueSoon) return null;

  	    const provider = driverResolveNotificationProvider(
  	      company,
  	      vehicle,
  	      plan.ProviderId || plan.ProviderName,
  	      null
  	    );

  	    const stage = overdue ? "OVERDUE" : "DUE_SOON";
  	    const remaining = [];
  	    const due = [];
  	    if (remainingCounter !== null) {
  	      remaining.push(
  	        remainingCounter <= 0
  	          ? formatNumber(Math.abs(remainingCounter), 0) + " km overdue"
  	          : formatNumber(remainingCounter, 0) + " km remaining"
  	      );
  	    }
  	    if (remainingDays !== null) {
  	      remaining.push(
  	        remainingDays <= 0
  	          ? Math.abs(remainingDays) + " day" + (Math.abs(remainingDays) === 1 ? "" : "s") + " overdue"
  	          : remainingDays + " day" + (remainingDays === 1 ? "" : "s") + " remaining"
  	      );
  	    }
  	    if (nextCounter !== null) due.push(formatNumber(nextCounter, 0) + " km");
  	    if (nextDate) due.push(nextDate);

  	    return {
  	      key: [
  	        "MAINTENANCE",
  	        objectIdOf(vehicle),
  	        plan.PlanId,
  	        provider
  	          ? provider.ProviderId
  	          : (plan.ProviderId || plan.ProviderName || "NO_PROVIDER"),
  	        stage,
  	        nextCounter === null ? "" : String(Math.round(nextCounter * 100) / 100),
  	        clean(nextDate)
  	      ].join("|"),
  	      kind: "Maintenance",
  	      stage: stage,
  	      provider: provider,
  	      title: overdue ? "Preventive Maintenance Overdue" : "Preventive Maintenance Due Soon",
  	      summary: remaining.join(" · ") || (overdue ? "Maintenance overdue" : "Maintenance due soon"),
  	      duePosition: due.join(" · ") || "Preventive maintenance interval",
  	      scope: plan.Scope || plan.Name || "Preventive maintenance",
  	      reference: plan.PlanId
  	    };
  	  }

  	  function driverNotificationCandidates(company, vehicle) {
  	    const setup = driverServiceSetup(vehicle);
  	    if (!setup.notifyProvider && !setup.notifyCompany) return [];
  	    const service = driverServiceNotificationCandidate(company, vehicle);
  	    return (service ? [service] : []).concat(
  	      driverPreventivePlans(vehicle).map(function (plan) {
  	        return driverPreventiveCandidate(company, vehicle, plan);
  	      }).filter(Boolean)
  	    );
  	  }

  	  function driverProviderHistory(vehicle) {
  	    const raw = driverCollectionValue(
  	      getDeep(
  	        vehicle,
  	        ["Data", "Service", "Notifications", "ProviderEmailHistory"],
  	        []
  	      )
  	    );

  	    return Array.isArray(raw)
  	      ? raw
  	          .filter(function (entry) {
  	            return entry &&
  	              typeof entry === "object" &&
  	              !Array.isArray(entry);
  	          })
  	          .map(clone)
  	      : [];
  	  }

  	  function driverSetDescriptor(container, key, value) {
  	    if (!container || typeof container !== "object") return;
  	    const existing = container[key];
  	    if (existing && typeof existing === "object" && !Array.isArray(existing) && Object.prototype.hasOwnProperty.call(existing, "value")) {
  	      existing.value = clone(value);
  	    } else {
  	      container[key] = clone(value);
  	    }
  	  }

  	  function driverSetProviderHistory(vehicle, history) {
  	    if (!vehicle.Data || typeof vehicle.Data !== "object" || Array.isArray(vehicle.Data)) vehicle.Data = {};
  	    if (!vehicle.Data.Service || typeof vehicle.Data.Service !== "object" || Array.isArray(vehicle.Data.Service)) vehicle.Data.Service = {};
  	    if (!vehicle.Data.Service.Notifications || typeof vehicle.Data.Service.Notifications !== "object" || Array.isArray(vehicle.Data.Service.Notifications)) {
  	      vehicle.Data.Service.Notifications = {};
  	    }
  	    const rows = arr(history).slice(-100);
  	    driverSetDescriptor(vehicle.Data.Service.Notifications, "ProviderEmailHistory", rows);
  	    driverSetDescriptor(
  	      vehicle.Data.Service.Notifications,
  	      "LastProviderEmailAt",
  	      rows.length ? clean(rows[rows.length - 1].SentAt) : ""
  	    );
  	  }

  	  function driverNotificationHistoryRecipientState(history, candidateKey) {
  	    let providerSent = false;
  	    let companySent = false;

  	    arr(history).forEach(function (entry) {
  	      if (!entry || clean(entry.Key) !== clean(candidateKey)) return;

  	      if (
  	        entry.ProviderEmailSent === true ||
  	        clean(entry.ProviderEmail)
  	      ) providerSent = true;

  	      if (
  	        entry.CompanyEmailSent === true ||
  	        clean(entry.CompanyEmail) ||
  	        clean(entry.CompanyEmails)
  	      ) companySent = true;
  	    });

  	    return {
  	      providerSent: providerSent,
  	      companySent: companySent
  	    };
  	  }

  	  function driverProviderEmailBody(company, vehicle, candidate, fuel) {
  	    const providerName = candidate.provider
  	      ? driverServiceProviderLabel(candidate.provider)
  	      : "Not configured";
  	    const companyLabel = companyName(company);
  	    const vehicleLabel = vehicleName(vehicle);
  	    const registration = vehicleRegistration(vehicle) || "Not captured";
  	    const identity = driverVehicleIdentityDetails(vehicle);
  	    const litres = numberOr(fuel && fuel.Litres, 0);
  	    const profile = vehicleMeterProfile(vehicle);
  	    const reading = currentMileage(vehicle);
  	    const fuelOutId = objectIdOf(fuel);

  	    const textBody = [
  	      "Fleet In Form - " + candidate.title,
  	      "",
  	      "Service Provider: " + providerName,
  	      "Company: " + companyLabel,
  	      "Vehicle: " + vehicleLabel,
  	      "Registration: " + registration,
  	      "Make: " + identity.make,
  	      "Model: " + identity.model,
  	      "Year: " + identity.year,
  	      "VIN: " + identity.vin,
  	      "Engine Number: " + identity.engineNumber,
  	      "Type: " + candidate.kind,
  	      "Status: " + candidate.title,
  	      "Current Position: " + candidate.summary,
  	      "Due Position: " + candidate.duePosition,
  	      "Work Scope: " + candidate.scope,
  	      candidate.reference ? "Reference: " + candidate.reference : "",
  	      "Fuel Transaction: " + formatNumber(litres, 2) + " L",
  	      fuelOutId ? "FuelOut ID: " + fuelOutId : "",
  	      "Vehicle Reading: " +
  	        formatNumber(reading, profile.decimals) +
  	        " " +
  	        profile.unit,
  	      "",
  	      "This notification was generated automatically by Fleet In Form after a Driver Mobile fuel transaction."
  	    ].filter(Boolean).join("\n");

  	    const htmlBody =
  	      '<div style="font-family:Arial,sans-serif;color:#202420;line-height:1.45">' +
  	      '<h2 style="margin:0 0 4px;color:#a34f29">Fleet In Form</h2>' +
  	      '<h3 style="margin:0 0 18px">' + escapeHtml(candidate.title) + '</h3>' +
  	      '<table style="border-collapse:collapse;width:100%;max-width:720px">' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Service Provider</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(providerName) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Company</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(companyLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Vehicle</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(vehicleLabel) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Registration</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(registration) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Make</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.make) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Model</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.model) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Year</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.year) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">VIN</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.vin) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Engine Number</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(identity.engineNumber) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Notification</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.kind + " · " + candidate.title) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Current Position</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.summary) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Due Position</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.duePosition) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Work Scope</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(candidate.scope) + '</td></tr>' +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Fuel Transaction</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(formatNumber(litres, 2) + " L") + '</td></tr>' +
  	      (fuelOutId
  	        ? '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">FuelOut ID</td><td style="padding:7px;border:1px solid #d9dedb">' + escapeHtml(fuelOutId) + '</td></tr>'
  	        : "") +
  	      '<tr><td style="padding:7px;border:1px solid #d9dedb;font-weight:bold">Vehicle Reading</td><td style="padding:7px;border:1px solid #d9dedb">' +
  	      escapeHtml(formatNumber(reading, profile.decimals) + " " + profile.unit) +
  	      '</td></tr>' +
  	      '</table>' +
  	      '<p style="margin-top:18px;color:#657069;font-size:12px">Generated automatically after a Driver Mobile fuel transaction.</p>' +
  	      '</div>';

  	    return { text: textBody, html: htmlBody };
  	  }

  	  async function driverSendProviderEmail(company, vehicle, candidate, fuel) {
  	    if (!DB || !DB.Messaging || typeof DB.Messaging.sendEmail !== "function") {
  	      throw new Error("Backendless Messaging.sendEmail is unavailable.");
  	    }

  	    const email = clean(getDeep(candidate.provider, ["Contact", "Email"], ""));
  	    if (!email) throw new Error("The Service Provider has no email address.");

  	    const body = driverProviderEmailBody(company, vehicle, candidate, fuel);
  	    const bodyParts = typeof DB.Bodyparts === "function" ? new DB.Bodyparts() : {};
  	    bodyParts.textmessage = body.text;
  	    bodyParts.htmlmessage = body.html;

  	    await DB.Messaging.sendEmail(
  	      "Fleet In Form - " + candidate.title + " - " + (vehicleRegistration(vehicle) || vehicleName(vehicle)),
  	      bodyParts,
  	      [email],
  	      []
  	    );
  	  }

  	  async function driverSendCompanyServiceEmail(company, vehicle, candidate, fuel, recipients) {
  	    if (!DB || !DB.Messaging || typeof DB.Messaging.sendEmail !== "function") {
  	      throw new Error("Backendless Messaging.sendEmail is unavailable.");
  	    }

  	    const emails = driverUniqueEmails(recipients);
  	    if (!emails.length) throw new Error("The Company has no Service notification email.");

  	    const body = driverProviderEmailBody(company, vehicle, candidate, fuel);
  	    const bodyParts = typeof DB.Bodyparts === "function" ? new DB.Bodyparts() : {};
  	    bodyParts.textmessage = body.text;
  	    bodyParts.htmlmessage = body.html;

  	    await DB.Messaging.sendEmail(
  	      "Fleet In Form - " + candidate.title + " - " + (vehicleRegistration(vehicle) || vehicleName(vehicle)),
  	      bodyParts,
  	      emails,
  	      []
  	    );
  	  }

  	  async function driverProcessProviderNotificationsSilently(company, vehicle, fuel) {
  	    /*
  	     * Driver Mobile never exposes email state.
  	     *
  	     * DUE_SOON:
  	     *   one email per enabled recipient for the current service/maintenance cycle.
  	     *
  	     * OVERDUE / UNSERVICED:
  	     *   email every enabled recipient after EVERY new Driver Mobile FuelOut
  	     *   until the service/maintenance cycle is completed/reset.
  	     */
  	    try {
  	      const setup = driverServiceSetup(vehicle);
  	      if (!setup.notifyProvider && !setup.notifyCompany) return false;

  	      const ownerCompany =
  	        driverResolveCompanyFromAppData(company, vehicle) ||
  	        company;

  	      const companyEmails = setup.notifyCompany
  	        ? driverCompanyServiceEmails(ownerCompany)
  	        : [];

  	      const serviceCompany =
  	        driverServiceProviders(ownerCompany).length
  	          ? ownerCompany
  	          : company;

  	      const candidates =
  	        driverNotificationCandidates(serviceCompany, vehicle);

  	      if (!candidates.length) return false;

  	      const history = driverProviderHistory(vehicle);
  	      let changed = false;

  	      for (let index = 0; index < candidates.length; index += 1) {
  	        const candidate = candidates[index];
  	        if (!candidate || !candidate.key) continue;

  	        const recipientState =
  	          driverNotificationHistoryRecipientState(
  	            history,
  	            candidate.key
  	          );

  	        const repeat =
  	          candidate.stage === "OVERDUE";

  	        const providerEmail =
  	          candidate.provider
  	            ? clean(
  	                getDeep(
  	                  candidate.provider,
  	                  ["Contact", "Email"],
  	                  ""
  	                )
  	              )
  	            : "";

  	        const sendProvider = !!(
  	          setup.notifyProvider &&
  	          providerEmail &&
  	          (repeat || !recipientState.providerSent)
  	        );

  	        const sendCompany = !!(
  	          setup.notifyCompany &&
  	          companyEmails.length &&
  	          (repeat || !recipientState.companySent)
  	        );

  	        if (!sendProvider && !sendCompany) continue;

  	        let providerSent = false;
  	        let companySent = false;

  	        if (sendProvider) {
  	          try {
  	            await driverSendProviderEmail(
  	              ownerCompany,
  	              vehicle,
  	              candidate,
  	              fuel
  	            );
  	            providerSent = true;
  	          } catch (_) {
  	            /* deliberately silent */
  	          }
  	        }

  	        if (sendCompany) {
  	          try {
  	            await driverSendCompanyServiceEmail(
  	              ownerCompany,
  	              vehicle,
  	              candidate,
  	              fuel,
  	              companyEmails
  	            );
  	            companySent = true;
  	          } catch (_) {
  	            /* deliberately silent */
  	          }
  	        }

  	        if (!providerSent && !companySent) continue;

  	        history.push({
  	          Key: candidate.key,
  	          Kind: candidate.kind,
  	          Stage: candidate.stage,

  	          ProviderId:
  	            candidate.provider
  	              ? candidate.provider.ProviderId
  	              : "",
  	          ProviderName:
  	            candidate.provider
  	              ? driverServiceProviderLabel(candidate.provider)
  	              : "",
  	          ProviderEmail:
  	            providerSent ? providerEmail : "",
  	          ProviderEmailSent: providerSent,

  	          CompanyId:
  	            objectIdOf(ownerCompany) ||
  	            clean(firstValue([
  	              ownerCompany && ownerCompany.CompanyId,
  	              ownerCompany && ownerCompany.Name
  	            ], "")),
  	          CompanyName: companyName(ownerCompany),
  	          CompanyEmail:
  	            companySent
  	              ? companyEmails.join(", ")
  	              : "",
  	          CompanyEmails:
  	            companySent
  	              ? companyEmails.join(", ")
  	              : "",
  	          CompanyEmailSent: companySent,

  	          Subject:
  	            "Fleet In Form - " +
  	            candidate.title +
  	            " - " +
  	            (vehicleRegistration(vehicle) || vehicleName(vehicle)),

  	          SentAt: new Date().toISOString(),
  	          Trigger: "Driver Mobile Fuel Transaction",
  	          RepeatOverdue: repeat,
  	          FuelOutObjectId: objectIdOf(fuel),
  	          OccurrenceKey:
  	            candidate.key +
  	            "|FUELOUT|" +
  	            objectIdOf(fuel)
  	        });

  	        changed = true;
  	      }

  	      if (changed) {
  	        driverSetProviderHistory(vehicle, history);

  	        /*
  	         * Audit persistence is internal only. It must never surface to
  	         * the driver or affect the already-valid fuel transaction.
  	         */
  	        try {
  	          await DB.Data.of("Tractors").save({
  	            objectId: objectIdOf(vehicle),
  	            Data: clone(vehicle.Data)
  	          });
  	        } catch (_) {
  	          /* deliberately silent */
  	        }
  	      }

  	      return changed;
  	    } catch (_) {
  	      return false;
  	    }
  	  }

  	  function resetFuelDraft(vehicle) {
  	    clearFuelPhotos();
  	    startFlespiMileageLookup(vehicle);
  	    state.fuelStep = 0;
  	    stopGpsWatch();
  	    state.gps = null;
  	    state.gpsError = "";
  	    state.gpsBusy = false;
  	    state.gpsStatus = "";
  	    state.gpsSamples = 0;
  	    state.selectedFuelLocationKey = "";
  	    state.otherSupplier = "";
  	    state.mileage = "";
  	    state.litres = "";
  	    state.totalCost = "";
  	    state.reference = "";
  	    state.success = null;
  	    const mileage = currentMileage(vehicle);
  	    if (mileage !== null) state.mileage = String(Math.round(mileage));
  	  }

  	  function injectStyles() {
  	    if (document.getElementById(STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = STYLE_ID;
  	    style.textContent = `
  	      :root{--fif-orange:#cc6633;--fif-orange-dark:#7d3518;--fif-bg:#07100c;--fif-card:#111914;--fif-line:rgba(255,255,255,.10);--fif-muted:#9da9a1;--fif-good:#2fbf71;--fif-danger:#e75d5d}
  	      #${ROOT_ID}{position:fixed;inset:0;z-index:2147482000;background:radial-gradient(circle at 50% -10%,rgba(204,102,51,.19),transparent 38%),linear-gradient(180deg,#09110d,#050a07);color:#f7faf8;font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;overflow:hidden;-webkit-font-smoothing:antialiased}
  	      #${ROOT_ID} *{box-sizing:border-box}
  	      #${ROOT_ID} button,#${ROOT_ID} input,#${ROOT_ID} select,#${ROOT_ID} textarea{font:inherit}
  	      #${ROOT_ID} button{touch-action:manipulation}
  	      #${ROOT_ID} .fifd-shell{width:100%;height:100%;max-width:560px;margin:0 auto;display:flex;flex-direction:column;background:rgba(5,11,7,.76);border-left:1px solid rgba(255,255,255,.055);border-right:1px solid rgba(255,255,255,.055)}
  	      #${ROOT_ID} .fifd-header{flex:0 0 auto;padding:calc(12px + env(safe-area-inset-top)) 16px 13px;border-bottom:1px solid var(--fif-line);background:rgba(5,10,7,.92);backdrop-filter:blur(16px);display:flex;align-items:center;gap:12px}
  	      #${ROOT_ID} .fifd-logo{width:48px;height:48px;flex:0 0 48px;border-radius:15px;display:grid;place-items:center;color:#f9b48e;background:linear-gradient(145deg,rgba(204,102,51,.30),rgba(204,102,51,.08));border:1px solid rgba(204,102,51,.45);overflow:hidden}
  	      #${ROOT_ID} .fifd-logo svg{width:32px;height:32px;display:block}
  	      #${ROOT_ID} .fifd-logo img{display:block;width:100%;height:100%;object-fit:contain;padding:4px}
  	      #${ROOT_ID} .fifd-logo>svg:not(:only-child){max-width:100%;max-height:100%}
  	      #${ROOT_ID} .fifd-title{min-width:0;flex:1}
  	      #${ROOT_ID} .fifd-title small{display:block;color:#d8895f;font-size:11px;font-weight:900;letter-spacing:.11em;text-transform:uppercase}
  	      #${ROOT_ID} .fifd-title strong{display:block;margin-top:3px;font-size:20px;line-height:1.1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fifd-title span{display:block;margin-top:4px;color:var(--fif-muted);font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  	      #${ROOT_ID} .fifd-main{flex:1 1 auto;min-height:0;overflow-y:auto;padding:18px 16px calc(110px + env(safe-area-inset-bottom));overscroll-behavior:contain}
  	      #${ROOT_ID} .fifd-kicker{color:#d8895f;font-size:11px;font-weight:900;letter-spacing:.1em;text-transform:uppercase}
  	      #${ROOT_ID} h1,#${ROOT_ID} h2,#${ROOT_ID} h3,#${ROOT_ID} p{margin:0}
  	      #${ROOT_ID} h1{margin-top:6px;font-size:31px;line-height:1.08;letter-spacing:-.025em}
  	      #${ROOT_ID} h2{font-size:22px;line-height:1.15}
  	      #${ROOT_ID} p{margin-top:8px;color:var(--fif-muted);font-size:14px;line-height:1.5}
  	      #${ROOT_ID} .fifd-stack{display:flex;flex-direction:column;gap:14px;margin-top:18px}
  	      #${ROOT_ID} .fifd-card{border:1px solid var(--fif-line);border-top-color:rgba(204,102,51,.36);border-radius:20px;background:linear-gradient(145deg,rgba(255,255,255,.055),rgba(255,255,255,.018));box-shadow:0 18px 42px rgba(0,0,0,.26);padding:18px}
  	      #${ROOT_ID} .fifd-vehicle{display:grid;grid-template-columns:58px minmax(0,1fr);gap:14px;align-items:center}
  	      #${ROOT_ID} .fifd-vehicle-icon{width:58px;height:58px;border-radius:18px;display:grid;place-items:center;background:rgba(204,102,51,.13);color:#ed9b70;border:1px solid rgba(204,102,51,.27)}
  	      #${ROOT_ID} .fifd-vehicle-icon svg{width:34px;height:34px}
  	      #${ROOT_ID} .fifd-vehicle strong{display:block;font-size:19px;line-height:1.2}
  	      #${ROOT_ID} .fifd-vehicle span{display:block;margin-top:5px;color:var(--fif-muted);font-size:13px;line-height:1.35}
  	      #${ROOT_ID} .fifd-badge{display:inline-flex!important;width:auto!important;margin-top:9px!important;padding:5px 9px;border-radius:999px;background:rgba(47,191,113,.14);border:1px solid rgba(47,191,113,.28);color:#83e9ad!important;font-size:11px!important;font-weight:900;text-transform:uppercase;letter-spacing:.05em}
  	      #${ROOT_ID} .fifd-actions{display:grid;grid-template-columns:1fr;gap:11px;margin-top:16px}
  	      #${ROOT_ID} .fifd-btn{width:100%;min-height:58px;border:1px solid rgba(255,255,255,.13);border-radius:16px;background:linear-gradient(145deg,#17221b,#0d1510);color:#fff;padding:12px 16px;font-size:17px;font-weight:900;display:flex;align-items:center;justify-content:center;gap:10px;cursor:pointer;box-shadow:0 10px 22px rgba(0,0,0,.18)}
  	      #${ROOT_ID} .fifd-btn svg{width:23px;height:23px;flex:0 0 23px}
  	      #${ROOT_ID} .fifd-btn.primary{background:linear-gradient(145deg,#b75429,#7b3418);border-color:rgba(235,139,87,.62);box-shadow:0 14px 28px rgba(138,56,23,.31)}
  	      #${ROOT_ID} .fifd-btn.good{background:linear-gradient(145deg,#257d4c,#185536);border-color:rgba(88,213,139,.52)}
  	      #${ROOT_ID} .fifd-btn.danger{background:linear-gradient(145deg,#4b1f1f,#2c1111);border-color:rgba(231,93,93,.45);color:#ffb5b5}
  	      #${ROOT_ID} .fifd-btn:disabled{opacity:.43;cursor:not-allowed;box-shadow:none}
  	      #${ROOT_ID} .fifd-btn:active:not(:disabled){transform:translateY(1px)}
  	      #${ROOT_ID} .fifd-company-list,#${ROOT_ID} .fifd-vehicle-list,#${ROOT_ID} .fifd-location-list{display:flex;flex-direction:column;gap:11px;margin-top:18px}
  	      #${ROOT_ID} .fifd-option{width:100%;min-height:74px;border:1px solid var(--fif-line);border-radius:18px;background:rgba(255,255,255,.035);color:#fff;padding:14px;text-align:left;display:flex;align-items:center;gap:13px;cursor:pointer}
  	      #${ROOT_ID} .fifd-option.is-selected{border-color:rgba(204,102,51,.75);background:rgba(204,102,51,.13);box-shadow:0 0 0 3px rgba(204,102,51,.09)}
  	      #${ROOT_ID} .fifd-option:disabled{opacity:.42;cursor:not-allowed}
  	      #${ROOT_ID} .fifd-option-icon{width:46px;height:46px;flex:0 0 46px;border-radius:14px;display:grid;place-items:center;color:#ef9a6d;background:rgba(204,102,51,.11)}
  	      #${ROOT_ID} .fifd-option-icon svg{width:27px;height:27px}
  	      #${ROOT_ID} .fifd-option-body{min-width:0;flex:1}
  	      #${ROOT_ID} .fifd-option-body strong{display:block;font-size:16px;line-height:1.2}
  	      #${ROOT_ID} .fifd-option-body span{display:block;margin-top:5px;color:var(--fif-muted);font-size:12px;line-height:1.35}
  	      #${ROOT_ID} .fifd-option-side{flex:0 0 auto;color:#f0a77e;font-weight:900;font-size:13px;text-align:right}
  	      #${ROOT_ID} .fifd-progress{display:grid;grid-template-columns:repeat(5,1fr);gap:6px;margin:0 0 18px}
  	      #${ROOT_ID} .fifd-progress span{height:7px;border-radius:999px;background:rgba(255,255,255,.10)}
  	      #${ROOT_ID} .fifd-progress span.active{background:linear-gradient(90deg,#cc6633,#ed9a6c)}
  	      #${ROOT_ID} .fifd-step-number{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:12px;background:rgba(204,102,51,.15);border:1px solid rgba(204,102,51,.30);color:#f1a57c;font-weight:950;margin-bottom:12px}
  	      #${ROOT_ID} .fifd-field{display:block;margin-top:18px}
  	      #${ROOT_ID} .fifd-field>span{display:block;margin:0 0 8px 2px;color:#dbe4de;font-size:15px;font-weight:850}
  	      #${ROOT_ID} .fifd-field>small{display:block;margin:7px 2px 0;color:var(--fif-muted);font-size:12px;line-height:1.4}
  	      #${ROOT_ID} .fifd-input{width:100%;height:62px;border:1px solid rgba(255,255,255,.14);border-radius:17px;background:#0b130e;color:#fff;padding:0 16px;font-size:20px;font-weight:850;outline:none;box-shadow:inset 0 1px 0 rgba(255,255,255,.03)}
  	      #${ROOT_ID} .fifd-input:focus{border-color:rgba(204,102,51,.88);box-shadow:0 0 0 4px rgba(204,102,51,.13)}
  	      #${ROOT_ID} .fifd-input::placeholder{color:#5e6b63;font-weight:650}
  	      #${ROOT_ID} .fifd-money-grid{display:grid;grid-template-columns:1fr;gap:14px}
  	      #${ROOT_ID} .fifd-photo-grid{display:grid;grid-template-columns:1fr;gap:14px;margin-top:18px}
  	      #${ROOT_ID} .fifd-photo-card{overflow:hidden;border:1px solid rgba(255,255,255,.10);border-top-color:rgba(204,102,51,.38);border-radius:18px;background:rgba(255,255,255,.035)}
  	      #${ROOT_ID} .fifd-photo-copy{padding:15px}
  	      #${ROOT_ID} .fifd-photo-copy strong{display:block;font-size:16px}
  	      #${ROOT_ID} .fifd-photo-copy span{display:block;margin-top:5px;color:var(--fif-muted);font-size:12px;line-height:1.4}
  	      #${ROOT_ID} .fifd-photo-preview{display:block;width:100%;max-height:250px;object-fit:contain;background:#050906;border-top:1px solid rgba(255,255,255,.07)}
  	      #${ROOT_ID} .fifd-photo-status{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:11px 15px;border-top:1px solid rgba(255,255,255,.07);color:#b9f5d0;font-size:12px;font-weight:800}
  	      #${ROOT_ID} .fifd-photo-actions{display:grid;grid-template-columns:1fr;gap:8px;padding:0 15px 15px}
  	      #${ROOT_ID} .fifd-photo-actions.has-photo{grid-template-columns:1fr 1fr}
  	      #${ROOT_ID} .fifd-photo-actions .fifd-btn{min-height:48px}
  	      #${ROOT_ID} .fifd-photo-input{position:absolute!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important;overflow:hidden!important}
  	      #${ROOT_ID} .fifd-review-photos{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin-top:14px}
  	      #${ROOT_ID} .fifd-review-photo{overflow:hidden;border:1px solid rgba(255,255,255,.09);border-radius:13px;background:#070b08}
  	      #${ROOT_ID} .fifd-review-photo img{display:block;width:100%;height:105px;object-fit:cover}
  	      #${ROOT_ID} .fifd-review-photo span{display:block;padding:8px;color:#c9d3cc;font-size:11px;font-weight:800;text-align:center}
  	      #${ROOT_ID} .fifd-info{margin-top:16px;padding:14px 15px;border-radius:16px;border:1px solid rgba(255,255,255,.09);background:rgba(255,255,255,.035);color:#c8d2cb;font-size:13px;line-height:1.45}
  	      #${ROOT_ID} .fifd-info.good{border-color:rgba(47,191,113,.28);background:rgba(47,191,113,.09);color:#b9f5d0}
  	      #${ROOT_ID} .fifd-info.warn{border-color:rgba(238,162,86,.32);background:rgba(238,162,86,.09);color:#ffd2a7}
  	      #${ROOT_ID} .fifd-gps{display:grid;grid-template-columns:52px minmax(0,1fr);gap:13px;align-items:center}
  	      #${ROOT_ID} .fifd-gps-icon{width:52px;height:52px;border-radius:16px;display:grid;place-items:center;color:#ef9b6f;background:rgba(204,102,51,.12)}
  	      #${ROOT_ID} .fifd-gps-icon svg{width:29px;height:29px}
  	      #${ROOT_ID} .fifd-gps strong{font-size:16px}
  	      #${ROOT_ID} .fifd-gps span{display:block;margin-top:4px;color:var(--fif-muted);font-size:12px;line-height:1.35}
  	      #${ROOT_ID} .fifd-review{display:flex;flex-direction:column;gap:10px;margin-top:18px}
  	      #${ROOT_ID} .fifd-review-row{display:flex;justify-content:space-between;gap:16px;padding:13px 0;border-bottom:1px solid rgba(255,255,255,.075)}
  	      #${ROOT_ID} .fifd-review-row span{color:var(--fif-muted);font-size:13px}
  	      #${ROOT_ID} .fifd-review-row strong{text-align:right;font-size:14px;max-width:64%}
  	      #${ROOT_ID} .fifd-footer{position:absolute;left:50%;bottom:0;transform:translateX(-50%);width:100%;max-width:560px;padding:12px 16px calc(12px + env(safe-area-inset-bottom));border-top:1px solid var(--fif-line);background:rgba(5,10,7,.95);backdrop-filter:blur(16px);display:grid;grid-template-columns:112px 1fr;gap:10px}
  	      #${ROOT_ID} .fifd-footer.single{grid-template-columns:1fr}
  	      #${ROOT_ID} .fifd-footer .fifd-btn{min-height:56px;font-size:16px}
  	      #${ROOT_ID} .fifd-empty{text-align:center;padding:38px 18px}
  	      #${ROOT_ID} .fifd-empty .fifd-option-icon{margin:0 auto 14px}
  	      #${ROOT_ID} .fifd-success{text-align:center;padding:24px 10px}
  	      #${ROOT_ID} .fifd-success-icon{width:92px;height:92px;border-radius:50%;display:grid;place-items:center;margin:0 auto 20px;color:#98f1ba;background:rgba(47,191,113,.13);border:2px solid rgba(47,191,113,.36)}
  	      #${ROOT_ID} .fifd-success-icon svg{width:48px;height:48px}
  	      #${APP_MENU_ID}{position:fixed;z-index:2147483647;box-sizing:border-box;width:210px;overflow:hidden;padding:5px;color:#fff;border:1px solid rgba(204,102,51,.72);border-radius:13px;background:radial-gradient(circle at 16% -10%,rgba(204,102,51,.25),transparent 42%),repeating-radial-gradient(circle at 80% 118%,transparent 0 13px,rgba(204,102,51,.13) 14px 16px),linear-gradient(145deg,#1b1714 0%,#0b0d0d 58%,#050707 100%);box-shadow:0 18px 42px rgba(0,0,0,.58),0 0 0 1px rgba(0,0,0,.65) inset,0 0 18px rgba(204,102,51,.12);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;transform-origin:top right;animation:fifdAppMenuIn 130ms ease-out both}
  	      #${APP_MENU_ID} .fifd-app-option{display:flex;align-items:center;width:100%;min-height:38px;margin:0;padding:9px 11px;border:0;border-radius:8px;outline:0;color:#f5f5f5;background:transparent;cursor:pointer;text-align:left;font-size:13px;font-weight:900;letter-spacing:.01em;transition:color 120ms ease,background 120ms ease,box-shadow 120ms ease}
  	      #${APP_MENU_ID} .fifd-app-option:hover,#${APP_MENU_ID} .fifd-app-option:focus-visible{color:#fff;background:rgba(204,102,51,.22);box-shadow:inset 2px 0 0 #cc6633}
  	      #${APP_MENU_ID} .fifd-app-option:disabled{cursor:wait;opacity:.55}
  	      #${APP_MENU_ID} .fifd-app-option.logout{margin-top:4px;border-top:1px solid rgba(204,102,51,.26);border-radius:0 0 8px 8px;color:#ff8a3d}
  	      #${APP_MENU_ID} .fifd-app-status{padding:6px 10px 7px;color:#ff8a3d;font-size:11px;font-weight:800;line-height:1.3}
  	      #${APP_MENU_ID} .fifd-app-status.error{color:#ff5b45}
  	      @keyframes fifdAppMenuIn{from{opacity:0;transform:translateY(-4px) scale(.98)}to{opacity:1;transform:translateY(0) scale(1)}}

  	      #${DIALOG_ID}{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.72);display:grid;place-items:end center;padding:18px;backdrop-filter:blur(4px)}
  	      #${DIALOG_ID} .fifd-dialog-card{width:100%;max-width:520px;border:1px solid rgba(255,255,255,.14);border-top-color:rgba(204,102,51,.55);border-radius:24px;background:linear-gradient(160deg,#172019,#0a100c);padding:22px;box-shadow:0 24px 70px rgba(0,0,0,.55)}
  	      #${DIALOG_ID} h2{font-size:23px;color:#fff;margin:0}
  	      #${DIALOG_ID} p{color:#aeb9b2;font-size:14px;line-height:1.5;margin:9px 0 0}
  	      #${DIALOG_ID} .fifd-dialog-actions{display:grid;grid-template-columns:1fr;gap:10px;margin-top:20px}
  	      #${OPERATION_ID}{position:fixed;inset:0;z-index:2147483500;background:rgba(3,7,4,.92);display:grid;place-items:center;padding:22px;text-align:center}
  	      #${OPERATION_ID} .fifd-operation-card{width:100%;max-width:420px;padding:28px;border-radius:24px;border:1px solid rgba(255,255,255,.10);background:linear-gradient(145deg,#172019,#0b120d)}
  	      #${OPERATION_ID} .fifd-spinner{width:62px;height:62px;border:5px solid rgba(255,255,255,.11);border-top-color:#cc6633;border-radius:50%;margin:0 auto 18px;animation:fifd-spin .8s linear infinite}
  	      #${OPERATION_ID} strong{display:block;font-size:20px;color:#fff}
  	      #${OPERATION_ID} span{display:block;margin-top:8px;color:#aab5ae;font-size:13px;line-height:1.45}
  	      @keyframes fifd-spin{to{transform:rotate(360deg)}}
  	      @media(min-width:430px){#${ROOT_ID} .fifd-actions.two{grid-template-columns:1fr 1fr}#${ROOT_ID} .fifd-money-grid{grid-template-columns:1fr 1fr}}
  	      @media(max-height:650px){#${ROOT_ID} .fifd-header{padding-top:calc(8px + env(safe-area-inset-top));padding-bottom:8px}#${ROOT_ID} .fifd-logo{width:42px;height:42px;flex-basis:42px}#${ROOT_ID} .fifd-title strong{font-size:18px}#${ROOT_ID} .fifd-main{padding-top:14px}}

  	      /* V1.0.1 — phone-first visual system */
  	      #${ROOT_ID}{--fif-orange:#e36f32;--fif-bg:#050805;--fif-card:#101610;color-scheme:dark;background:#050805}
  	      #${ROOT_ID} .fifd-shell{max-width:500px;background:linear-gradient(180deg,#0a100b 0%,#060906 100%);border:0;box-shadow:0 0 80px rgba(0,0,0,.55)}
  	      #${ROOT_ID} .fifd-header{padding:calc(10px + env(safe-area-inset-top)) 14px 10px;background:#080d09;border-bottom-color:rgba(227,111,50,.28);backdrop-filter:none}
  	      #${ROOT_ID} .fifd-logo{width:44px;height:44px;flex-basis:44px;border-radius:12px;background:#101711;border-color:rgba(227,111,50,.38)}
  	      #${ROOT_ID} .fifd-title small{font-size:9px;color:#ef8a55}
  	      #${ROOT_ID} .fifd-title strong{font-size:18px}
  	      #${ROOT_ID} .fifd-title span{font-size:11px}
  	      #${ROOT_ID} .fifd-main{padding:18px 14px calc(104px + env(safe-area-inset-bottom));scrollbar-width:none}
  	      #${ROOT_ID} .fifd-main::-webkit-scrollbar{display:none}
  	      #${ROOT_ID} h1{font-size:29px;line-height:1.08}
  	      #${ROOT_ID} p{font-size:14px;line-height:1.42}
  	      #${ROOT_ID} .fifd-card{border-radius:16px;padding:16px;background:#101610;border-color:rgba(255,255,255,.09);border-top-color:rgba(227,111,50,.48);box-shadow:none}
  	      #${ROOT_ID} .fifd-option{min-height:80px;border-radius:15px;padding:14px;background:#0e140f;border-color:rgba(255,255,255,.10);box-shadow:none}
  	      #${ROOT_ID} .fifd-option:active:not(:disabled){background:#182019;transform:scale(.995)}
  	      #${ROOT_ID} .fifd-option.is-selected{background:#25170f;border-color:#e36f32;box-shadow:inset 4px 0 0 #e36f32}
  	      #${ROOT_ID} .fifd-option-icon{width:48px;height:48px;flex-basis:48px;border-radius:13px;background:#171f18;color:#f08a55}
  	      #${ROOT_ID} .fifd-option-body strong{font-size:17px}
  	      #${ROOT_ID} .fifd-option-body span{font-size:12px}
  	      #${ROOT_ID} .fifd-option-side{font-size:11px;letter-spacing:.03em;text-transform:uppercase}
  	      #${ROOT_ID} .fifd-btn{min-height:62px;border-radius:14px;background:#151d16;border:1px solid rgba(255,255,255,.13);box-shadow:none;font-size:17px;letter-spacing:.01em;-webkit-appearance:none;appearance:none}
  	      #${ROOT_ID} .fifd-btn.primary{background:#d85f25;border-color:#f18953;box-shadow:none}
  	      #${ROOT_ID} .fifd-btn.good{background:#237348;border-color:#4aa778;box-shadow:none}
  	      #${ROOT_ID} .fifd-btn.danger{background:#3b1717;border-color:#8d3a3a;color:#ffd0d0}
  	      #${ROOT_ID} .fifd-input{height:64px;border-radius:14px;background:#090e0a;border-color:rgba(255,255,255,.14);font-size:22px;-webkit-appearance:none;appearance:none}
  	      #${ROOT_ID} .fifd-footer{max-width:500px;padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:#080d09;border-top-color:rgba(227,111,50,.25);backdrop-filter:none}
  	      #${ROOT_ID} .fifd-footer .fifd-btn{min-height:60px}

  	      #${DIALOG_ID}{align-items:end;justify-items:center;padding:12px 12px calc(12px + env(safe-area-inset-bottom));background:rgba(0,0,0,.78);backdrop-filter:none;font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#fff}
  	      #${DIALOG_ID} *{box-sizing:border-box}
  	      #${DIALOG_ID} .fifd-dialog-card{max-width:500px;border-radius:20px 20px 16px 16px;background:#101610;border:1px solid rgba(255,255,255,.12);border-top:3px solid #e36f32;padding:20px 16px 16px;box-shadow:0 24px 70px rgba(0,0,0,.66)}
  	      #${DIALOG_ID} h2{font-size:24px;line-height:1.12}
  	      #${DIALOG_ID} p{font-size:14px;line-height:1.45;color:#aeb9b2}
  	      #${DIALOG_ID} .fifd-dialog-actions{gap:10px;margin-top:20px}
  	      #${DIALOG_ID} .fifd-btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:62px;padding:12px 16px;border-radius:14px;border:1px solid rgba(255,255,255,.14);background:#171e18;color:#fff;font:900 17px/1.1 Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;cursor:pointer;-webkit-appearance:none;appearance:none;box-shadow:none}
  	      #${DIALOG_ID} .fifd-btn.primary{background:#d85f25;border-color:#f18953}
  	      #${DIALOG_ID} .fifd-btn.danger{background:#4a1b1b;border-color:#9f4242;color:#ffd0d0}
  	      #${DIALOG_ID} .fifd-btn:active{transform:translateY(1px)}

  	      #${OPERATION_ID}{background:rgba(3,6,3,.94);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#fff}
  	      #${OPERATION_ID} .fifd-operation-card{max-width:420px;border-radius:18px;background:#101610;border-top:3px solid #e36f32;padding:26px 20px}
  	      @media(min-width:700px){#${DIALOG_ID}{align-items:center}#${DIALOG_ID} .fifd-dialog-card{border-radius:20px}}
  	    `;
  	    document.head.appendChild(style);
  	  }


  	  function injectV104Styles() {
  	    if (document.getElementById(V104_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = V104_STYLE_ID;
  	    style.textContent = `
  	      #${ROOT_ID}{--fif-orange:#df6b2d;--fif-orange-soft:#f08b58;--fif-panel:#0d1510;--fif-panel-2:#121c15;background:
  	        radial-gradient(circle at 18% -8%,rgba(239,112,48,.30),transparent 32%),
  	        radial-gradient(circle at 110% 36%,rgba(67,139,91,.11),transparent 35%),
  	        linear-gradient(180deg,#070c08 0%,#050806 100%)}
  	      #${ROOT_ID}:before{content:"";position:absolute;inset:0;pointer-events:none;opacity:.10;background-image:linear-gradient(rgba(255,255,255,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.025) 1px,transparent 1px);background-size:26px 26px;mask-image:linear-gradient(180deg,#000,transparent 62%)}
  	      #${ROOT_ID} .fifd-shell{position:relative;max-width:520px;background:linear-gradient(180deg,rgba(7,12,8,.90),rgba(4,8,5,.96));border-color:rgba(255,255,255,.07);box-shadow:0 0 80px rgba(0,0,0,.45)}
  	      #${ROOT_ID} .fifd-header{min-height:82px;padding:calc(13px + env(safe-area-inset-top)) 17px 13px;background:linear-gradient(180deg,rgba(7,12,8,.96),rgba(7,12,8,.85));border-bottom-color:rgba(223,107,45,.20)}
  	      #${ROOT_ID} .fifd-logo{width:52px;height:52px;flex-basis:52px;border-radius:17px;background:linear-gradient(145deg,rgba(223,107,45,.24),rgba(255,255,255,.035));box-shadow:inset 0 1px 0 rgba(255,255,255,.10),0 10px 24px rgba(0,0,0,.24)}
  	      #${ROOT_ID} .fifd-title small{color:#ef8c59;font-size:10px}
  	      #${ROOT_ID} .fifd-title strong{font-size:19px}
  	      #${ROOT_ID} .fifd-header-status{flex:0 0 auto;display:flex;align-items:center;gap:6px;padding:7px 9px;border:1px solid rgba(255,255,255,.09);border-radius:999px;background:rgba(255,255,255,.035);color:#b6c1ba;font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.04em}
  	      #${ROOT_ID} .fifd-header-status:before{content:"";width:7px;height:7px;border-radius:50%;background:#50cf85;box-shadow:0 0 0 4px rgba(80,207,133,.09)}
  	      #${ROOT_ID} .fifd-header-actions{flex:0 0 auto;display:flex;align-items:center;gap:8px;margin-left:auto}
  	      #${ROOT_ID} .fifd-logout{min-width:44px;height:44px;padding:0 12px;border:1px solid rgba(239,112,48,.32);border-radius:14px;background:linear-gradient(145deg,rgba(56,24,14,.92),rgba(19,12,9,.96));color:#ffb18b;display:flex;align-items:center;justify-content:center;gap:7px;font:900 11px/1 inherit;text-transform:uppercase;letter-spacing:.035em;box-shadow:0 10px 24px rgba(0,0,0,.18);cursor:pointer;-webkit-tap-highlight-color:transparent}
  	      #${ROOT_ID} .fifd-logout svg{width:20px;height:20px;flex:0 0 20px}
  	      #${ROOT_ID} .fifd-logout:active{transform:translateY(1px);background:#7a3017}
  	      #${ROOT_ID} .fifd-main{padding:22px 17px calc(112px + env(safe-area-inset-bottom))}
  	      #${ROOT_ID} .fifd-kicker{display:inline-flex;align-items:center;gap:7px;color:#ef8c59}
  	      #${ROOT_ID} .fifd-kicker:before{content:"";width:17px;height:2px;border-radius:2px;background:#df6b2d}
  	      #${ROOT_ID} h1{font-size:32px;letter-spacing:-.035em}
  	      #${ROOT_ID} .fifd-board-hero{position:relative;overflow:hidden;margin-top:20px;padding:23px 19px 19px;border-radius:24px;border:1px solid rgba(240,139,88,.35);background:linear-gradient(145deg,rgba(223,107,45,.20),rgba(16,25,18,.96) 48%,rgba(10,16,11,.98));box-shadow:0 25px 55px rgba(0,0,0,.30)}
  	      #${ROOT_ID} .fifd-board-hero:after{content:"";position:absolute;width:180px;height:180px;right:-72px;top:-82px;border-radius:50%;border:26px solid rgba(240,139,88,.07);box-shadow:0 0 0 24px rgba(240,139,88,.035)}
  	      #${ROOT_ID} .fifd-board-symbol{position:relative;z-index:1;width:78px;height:78px;border-radius:24px;display:grid;place-items:center;background:linear-gradient(145deg,#ed7b40,#a63f17);color:#fff;box-shadow:0 18px 34px rgba(142,54,20,.34),inset 0 1px 0 rgba(255,255,255,.25)}
  	      #${ROOT_ID} .fifd-board-symbol svg{width:44px;height:44px}
  	      #${ROOT_ID} .fifd-board-hero h2{position:relative;z-index:1;margin-top:18px;font-size:25px}
  	      #${ROOT_ID} .fifd-board-hero p{position:relative;z-index:1;max-width:360px}
  	      #${ROOT_ID} .fifd-board-actions{position:relative;z-index:1;display:grid;gap:10px;margin-top:20px}
  	      #${ROOT_ID} .fifd-btn.scan{min-height:68px;background:linear-gradient(145deg,#ed7335,#b14519);border-color:#f29a68;font-size:18px;box-shadow:0 16px 28px rgba(151,55,18,.28)}
  	      #${ROOT_ID} .fifd-btn.secondary{background:rgba(255,255,255,.045);border-color:rgba(255,255,255,.11);color:#d8e0db}
  	      #${ROOT_ID} .fifd-help-strip{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin-top:15px}
  	      #${ROOT_ID} .fifd-help-strip span{min-width:0;padding:10px 7px;border:1px solid rgba(255,255,255,.07);border-radius:13px;background:rgba(255,255,255,.025);color:#9daaa1;text-align:center;font-size:10px;font-weight:800;line-height:1.25}
  	      #${ROOT_ID} .fifd-help-strip b{display:grid;place-items:center;width:22px;height:22px;margin:0 auto 6px;border-radius:50%;background:rgba(223,107,45,.16);color:#f49b6d;font-size:11px}
  	      #${ROOT_ID} .fifd-card{border-radius:22px;background:linear-gradient(145deg,rgba(19,29,21,.97),rgba(11,18,13,.97));border-color:rgba(255,255,255,.08);border-top-color:rgba(239,112,48,.35);box-shadow:0 20px 42px rgba(0,0,0,.22)}
  	      #${ROOT_ID} .fifd-current-card{position:relative;overflow:hidden;border-left:4px solid var(--vehicle-accent,#df6b2d)}
  	      #${ROOT_ID} .fifd-current-card:after{content:"";position:absolute;width:160px;height:160px;right:-88px;bottom:-100px;border-radius:50%;background:var(--vehicle-accent,#df6b2d);opacity:.08}
  	      #${ROOT_ID} .fifd-vehicle-icon{background:color-mix(in srgb,var(--vehicle-accent,#df6b2d) 18%,transparent);color:var(--vehicle-accent,#df6b2d);border-color:color-mix(in srgb,var(--vehicle-accent,#df6b2d) 35%,transparent)}
  	      #${ROOT_ID} .fifd-option{position:relative;overflow:hidden;background:linear-gradient(145deg,rgba(17,26,19,.96),rgba(10,16,11,.96));border-radius:18px}
  	      #${ROOT_ID} .fifd-option-side{padding:6px 8px;border-radius:999px;background:rgba(255,255,255,.045)}
  	      #${ROOT_ID} .fifd-scan-main{display:flex;flex-direction:column}
  	      #${ROOT_ID} .fifd-scanner-frame{position:relative;width:100%;aspect-ratio:1/1;margin-top:18px;overflow:hidden;border-radius:28px;background:#000;border:1px solid rgba(240,139,88,.48);box-shadow:0 22px 50px rgba(0,0,0,.45)}
  	      #${ROOT_ID} .fifd-scanner-frame video{width:100%;height:100%;object-fit:cover;background:#020302}
  	      #${ROOT_ID} .fifd-scanner-vignette{position:absolute;inset:0;background:radial-gradient(circle at center,transparent 0 37%,rgba(0,0,0,.24) 55%,rgba(0,0,0,.64) 100%);pointer-events:none}
  	      #${ROOT_ID} .fifd-scan-box{position:absolute;left:12%;right:12%;top:12%;bottom:12%;border-radius:24px;box-shadow:0 0 0 999px rgba(0,0,0,.18);pointer-events:none}
  	      #${ROOT_ID} .fifd-scan-box i{position:absolute;width:42px;height:42px;border-color:#ff8d52;border-style:solid;filter:drop-shadow(0 0 8px rgba(255,118,58,.55))}
  	      #${ROOT_ID} .fifd-scan-box i:nth-child(1){left:0;top:0;border-width:4px 0 0 4px;border-radius:14px 0 0 0}
  	      #${ROOT_ID} .fifd-scan-box i:nth-child(2){right:0;top:0;border-width:4px 4px 0 0;border-radius:0 14px 0 0}
  	      #${ROOT_ID} .fifd-scan-box i:nth-child(3){left:0;bottom:0;border-width:0 0 4px 4px;border-radius:0 0 0 14px}
  	      #${ROOT_ID} .fifd-scan-box i:nth-child(4){right:0;bottom:0;border-width:0 4px 4px 0;border-radius:0 0 14px 0}
  	      #${ROOT_ID} .fifd-scan-line{position:absolute;left:14%;right:14%;top:18%;height:2px;border-radius:2px;background:linear-gradient(90deg,transparent,#ff925c 16%,#fff 50%,#ff925c 84%,transparent);box-shadow:0 0 14px rgba(255,126,66,.88);animation:fifd-scan-line 2.25s ease-in-out infinite;pointer-events:none}
  	      @keyframes fifd-scan-line{0%,100%{transform:translateY(0);opacity:.55}50%{transform:translateY(calc(64vw - 78px));opacity:1}}
  	      #${ROOT_ID} .fifd-scanner-tools{position:absolute;left:12px;right:12px;bottom:12px;display:flex;justify-content:flex-end;gap:8px}
  	      #${ROOT_ID} .fifd-camera-tool{min-height:44px;border:1px solid rgba(255,255,255,.18);border-radius:999px;background:rgba(5,9,6,.78);color:#fff;padding:0 13px;display:flex;align-items:center;gap:7px;font-weight:850;font-size:12px;backdrop-filter:blur(10px)}
  	      #${ROOT_ID} .fifd-camera-tool svg{width:18px;height:18px}
  	      #${ROOT_ID} .fifd-camera-tool.is-on{background:#df6b2d;border-color:#f39967}
  	      #${ROOT_ID} .fifd-scanner-status{margin-top:13px;padding:13px 14px;border-radius:15px;border:1px solid rgba(255,255,255,.08);background:rgba(255,255,255,.035);color:#d4ddd7;font-size:13px;font-weight:750;text-align:center}
  	      #${ROOT_ID} .fifd-scanner-error{display:none;margin-top:9px;padding:12px 13px;border:1px solid rgba(231,93,93,.34);border-radius:14px;background:rgba(118,31,31,.20);color:#ffb4b4;font-size:12px;line-height:1.4}
  	      #${ROOT_ID} .fifd-scanner-error.visible{display:block}
  	      #${ROOT_ID} .fifd-scan-confirm{margin-top:20px}
  	      #${ROOT_ID} .fifd-recognised{display:flex;align-items:center;gap:9px;margin-bottom:14px;color:#7fe2a6;font-size:12px;font-weight:900;text-transform:uppercase;letter-spacing:.06em}
  	      #${ROOT_ID} .fifd-recognised:before{content:"";width:10px;height:10px;border-radius:50%;background:#43c47b;box-shadow:0 0 0 5px rgba(67,196,123,.11)}
  	      #${ROOT_ID} .fifd-code{margin-top:14px;padding:12px 13px;border-radius:13px;background:#080d09;border:1px solid rgba(255,255,255,.08);color:#b8c3bc;font:700 12px/1.4 ui-monospace,SFMono-Regular,Consolas,monospace;overflow-wrap:anywhere}
  	      #${ROOT_ID} .fifd-confirm-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:14px}
  	      #${ROOT_ID} .fifd-confirm-grid div{padding:11px;border-radius:13px;background:rgba(255,255,255,.035)}
  	      #${ROOT_ID} .fifd-confirm-grid small{display:block;color:#829087;font-size:9px;font-weight:900;text-transform:uppercase;letter-spacing:.07em}
  	      #${ROOT_ID} .fifd-confirm-grid strong{display:block;margin-top:4px;color:#fff;font-size:13px}
  	      #${ROOT_ID} .fifd-fuel-finder{min-height:430px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:34px 20px;border:1px solid rgba(223,107,45,.28);border-radius:26px;background:radial-gradient(circle at 50% 35%,rgba(223,107,45,.18),rgba(16,25,18,.96) 55%,rgba(9,15,10,.98));box-shadow:0 24px 55px rgba(0,0,0,.28)}
  	      #${ROOT_ID} .fifd-fuel-finder h1{margin-top:24px;font-size:29px}
  	      #${ROOT_ID} .fifd-fuel-finder p{max-width:360px}
  	      #${ROOT_ID} .fifd-fuel-spinner{position:relative;width:116px;height:116px;border-radius:50%;display:grid;place-items:center}
  	      #${ROOT_ID} .fifd-fuel-spinner:before,#${ROOT_ID} .fifd-fuel-spinner:after{content:"";position:absolute;inset:0;border-radius:50%;border:6px solid rgba(255,255,255,.07);border-top-color:#ef7b3d;animation:fifd-fuel-spin 1.05s linear infinite}
  	      #${ROOT_ID} .fifd-fuel-spinner:after{inset:18px;border-width:4px;border-top-color:#62d491;border-right-color:#62d491;animation-duration:1.45s;animation-direction:reverse}
  	      #${ROOT_ID} .fifd-fuel-spinner i{width:22px;height:22px;border-radius:50%;background:#ef7b3d;box-shadow:0 0 0 10px rgba(239,123,61,.12),0 0 34px rgba(239,123,61,.45)}
  	      #${ROOT_ID} .fifd-finder-status{margin-top:18px;padding:10px 14px;border-radius:999px;background:rgba(255,255,255,.045);border:1px solid rgba(255,255,255,.08);color:#b9c5bd;font-size:12px;font-weight:850}
  	      @keyframes fifd-fuel-spin{to{transform:rotate(360deg)}}
  	      @media(max-width:390px){#${ROOT_ID} .fifd-header-status{display:none}#${ROOT_ID} .fifd-logout{width:44px;padding:0}#${ROOT_ID} .fifd-logout span{display:none}#${ROOT_ID} h1{font-size:29px}#${ROOT_ID} .fifd-help-strip{gap:5px}#${ROOT_ID} .fifd-help-strip span{font-size:9px;padding:9px 4px}}
  	      @media(min-width:521px){#${ROOT_ID} .fifd-scan-line{animation-name:fifd-scan-line-wide}@keyframes fifd-scan-line-wide{0%,100%{transform:translateY(0);opacity:.55}50%{transform:translateY(285px);opacity:1}}}
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function injectV108Styles() {
  	    if (document.getElementById(V108_STYLE_ID)) return;
  	    const style = document.createElement("style");
  	    style.id = V108_STYLE_ID;
  	    style.textContent = `
  	      #${ROOT_ID}{--fif-orange:#c45b29;--fif-orange-soft:#dc8050;--fif-panel:#0d1510;--fif-panel-2:#131c16;background:
  	        radial-gradient(circle at 20% -10%,rgba(196,91,41,.20),transparent 35%),
  	        radial-gradient(circle at 108% 36%,rgba(72,129,88,.08),transparent 34%),
  	        linear-gradient(180deg,#080d09 0%,#050806 100%)}
  	      #${ROOT_ID}:before{opacity:.07}
  	      #${ROOT_ID} .fifd-shell{background:linear-gradient(180deg,rgba(7,12,8,.94),rgba(4,8,5,.98));box-shadow:0 24px 72px rgba(0,0,0,.38)}
  	      #${ROOT_ID} .fifd-header{background:rgba(7,12,8,.96);border-bottom-color:rgba(196,91,41,.20)}
  	      #${ROOT_ID} .fifd-logo{background:linear-gradient(145deg,rgba(196,91,41,.22),rgba(255,255,255,.025));border-color:rgba(211,108,61,.34);box-shadow:inset 0 1px 0 rgba(255,255,255,.07)}
  	      #${ROOT_ID} .fifd-title small,#${ROOT_ID} .fifd-kicker{color:#d77b4c}
  	      #${ROOT_ID} .fifd-kicker:before{background:#bd5122}
  	      #${ROOT_ID} .fifd-logout{border-color:rgba(196,91,41,.32);background:linear-gradient(145deg,#27150e,#15100c);color:#e29a72;box-shadow:none}
  	      #${ROOT_ID} .fifd-logout:active{background:#3a1a0e}
  	      #${ROOT_ID} .fifd-card{background:linear-gradient(145deg,rgba(18,28,20,.98),rgba(10,16,11,.98));border-color:rgba(255,255,255,.075);border-top-color:rgba(196,91,41,.32);box-shadow:0 17px 40px rgba(0,0,0,.20)}
  	      #${ROOT_ID} .fifd-board-hero{border-color:rgba(211,108,61,.30);background:linear-gradient(145deg,rgba(92,38,17,.26),rgba(15,24,17,.98) 47%,rgba(9,15,10,.99));box-shadow:0 21px 46px rgba(0,0,0,.25)}
  	      #${ROOT_ID} .fifd-board-hero:after{border-color:rgba(210,105,57,.055);box-shadow:0 0 0 24px rgba(210,105,57,.025)}
  	      #${ROOT_ID} .fifd-board-symbol{background:linear-gradient(145deg,#c55b29,#783016);color:#fff;border:1px solid rgba(231,137,88,.42);box-shadow:0 14px 28px rgba(103,39,14,.24)}
  	      #${ROOT_ID} .fifd-btn{background:linear-gradient(145deg,#19221b,#101611);border-color:rgba(255,255,255,.11);box-shadow:none;color:#f2f5f2}
  	      #${ROOT_ID} .fifd-btn.primary,#${ROOT_ID} .fifd-btn.scan{background:linear-gradient(145deg,#b94d20,#782d13);border-color:rgba(222,126,76,.62);color:#fff;box-shadow:0 10px 22px rgba(88,31,10,.18)}
  	      #${ROOT_ID} .fifd-btn.scan{font-size:17px}
  	      #${ROOT_ID} .fifd-btn.good{background:linear-gradient(145deg,#276942,#1b4b30);border-color:rgba(82,177,119,.45)}
  	      #${ROOT_ID} .fifd-btn.danger{background:#321717;border-color:rgba(171,70,70,.42);color:#f4c4c4}
  	      #${ROOT_ID} .fifd-option{background:linear-gradient(145deg,rgba(17,26,19,.98),rgba(9,15,10,.98));border-color:rgba(255,255,255,.075)}
  	      #${ROOT_ID} .fifd-option.is-selected{border-color:rgba(204,91,39,.72);background:rgba(126,48,18,.22);box-shadow:inset 4px 0 0 #c45b29}
  	      #${ROOT_ID} .fifd-option-icon,#${ROOT_ID} .fifd-gps-icon{color:#dd8454;background:rgba(196,91,41,.12)}
  	      #${ROOT_ID} .fifd-option-side{color:#dc8a5e;background:rgba(196,91,41,.075)}
  	      #${ROOT_ID} .fifd-progress span.active{background:linear-gradient(90deg,#a8421b,#d47240)}
  	      #${ROOT_ID} .fifd-step-number{background:rgba(196,91,41,.13);border-color:rgba(211,108,61,.30);color:#e39266}
  	      #${ROOT_ID} .fifd-input:focus{border-color:rgba(205,94,42,.78);box-shadow:0 0 0 3px rgba(196,91,41,.12)}
  	      #${ROOT_ID} .fifd-scanner-frame{border-color:rgba(211,108,61,.44)}
  	      #${ROOT_ID} .fifd-scan-box i{border-color:#d96d39;filter:drop-shadow(0 0 7px rgba(196,91,41,.38))}
  	      #${ROOT_ID} .fifd-scan-line{background:linear-gradient(90deg,transparent,#c45b29 18%,#f3c1a7 50%,#c45b29 82%,transparent);box-shadow:0 0 11px rgba(196,91,41,.52)}
  	      #${ROOT_ID} .fifd-camera-tool.is-on{background:#9d401b;border-color:#cf6a39}
  	      #${ROOT_ID} .fifd-fuel-finder{border-color:rgba(196,91,41,.26);background:radial-gradient(circle at 50% 34%,rgba(196,91,41,.14),rgba(16,25,18,.97) 58%,rgba(8,13,9,.99));box-shadow:0 19px 46px rgba(0,0,0,.23)}
  	      #${ROOT_ID} .fifd-fuel-spinner:before{border-color:rgba(255,255,255,.065);border-top-color:#c45b29}
  	      #${ROOT_ID} .fifd-fuel-spinner:after{border-color:rgba(255,255,255,.045);border-top-color:#5f9d74;border-right-color:#5f9d74}
  	      #${ROOT_ID} .fifd-fuel-spinner i{background:#c45b29;box-shadow:0 0 0 9px rgba(196,91,41,.09)}
  	      #${ROOT_ID} .fifd-footer{background:rgba(6,10,7,.97);border-top-color:rgba(196,91,41,.18)}
  	      #${DIALOG_ID} .fifd-dialog-card{background:linear-gradient(160deg,#151d17,#0b110d);border-color:rgba(255,255,255,.10);border-top-color:rgba(196,91,41,.50)}
  	      #${DIALOG_ID} .fifd-btn.primary{background:linear-gradient(145deg,#b94d20,#782d13);border-color:rgba(222,126,76,.58)}
  	      #${OPERATION_ID} .fifd-operation-card{background:#111812;border-top-color:#b94d20}
  	      #${OPERATION_ID} .fifd-spinner{border-top-color:#c45b29}
  	    `;
  	    document.head.appendChild(style);
  	  }

  	  function mountHost() {
  	    if (HUB_INPUT && HUB_INPUT.nodeType === 1) return HUB_INPUT;
  	    if (HUB_INPUT && HUB_INPUT[0] && HUB_INPUT[0].nodeType === 1) return HUB_INPUT[0];
  	    return document.body;
  	  }

  	  function removeExisting() {
  	    closeAppMenu();
  	    const previous = document.getElementById(ROOT_ID);
  	    if (previous && typeof previous.__destroy === "function") previous.__destroy();
  	    else if (previous) previous.remove();
  	    document.getElementById(DIALOG_ID)?.remove();
  	    document.getElementById(OPERATION_ID)?.remove();
  	  }

  	  function showOperation(title, detail) {
  	    document.getElementById(OPERATION_ID)?.remove();
  	    const overlay = document.createElement("div");
  	    overlay.id = OPERATION_ID;
  	    overlay.innerHTML = `<div class="fifd-operation-card"><div class="fifd-spinner"></div><strong>${escapeHtml(title || "Working…")}</strong><span>${escapeHtml(detail || "Please wait.")}</span></div>`;
  	    document.body.appendChild(overlay);
  	    return overlay;
  	  }

  	  function updateOperation(title, detail) {
  	    const overlay = document.getElementById(OPERATION_ID);
  	    if (!overlay) return showOperation(title, detail);
  	    const titleNode = overlay.querySelector(".fifd-operation-card strong");
  	    const detailNode = overlay.querySelector(".fifd-operation-card span");
  	    if (titleNode) titleNode.textContent = clean(title) || "Working…";
  	    if (detailNode) detailNode.textContent = clean(detail) || "Please wait.";
  	    return overlay;
  	  }

  	  function closeOperation() {
  	    document.getElementById(OPERATION_ID)?.remove();
  	  }

  	  function showDialog(options) {
  	    options = options || {};
  	    document.getElementById(DIALOG_ID)?.remove();
  	    return new Promise(function (resolve) {
  	      const overlay = document.createElement("div");
  	      overlay.id = DIALOG_ID;
  	      overlay.innerHTML = `<div class="fifd-dialog-card" role="dialog" aria-modal="true">
  	        <h2>${escapeHtml(options.title || "Please confirm")}</h2>
  	        <p>${escapeHtml(options.message || "")}</p>
  	        <div class="fifd-dialog-actions">
  	          <button type="button" class="fifd-btn ${options.danger ? "danger" : "primary"}" data-dialog-confirm>${escapeHtml(options.confirmText || "Continue")}</button>
  	          ${options.hideCancel ? "" : `<button type="button" class="fifd-btn" data-dialog-cancel>${escapeHtml(options.cancelText || "Cancel")}</button>`}
  	        </div>
  	      </div>`;
  	      const finish = function (value) {
  	        overlay.remove();
  	        resolve(value);
  	      };
  	      overlay.querySelector("[data-dialog-confirm]").addEventListener("click", function () { finish(true); });
  	      overlay.querySelector("[data-dialog-cancel]")?.addEventListener("click", function () { finish(false); });
  	      document.body.appendChild(overlay);
  	    });
  	  }

  	  async function setRelation(table, parentId, relation, childObjects, existingObjects) {
  	    if (!DB || !DB.Data || typeof DB.Data.of !== "function") throw new Error("The database is not available.");
  	    if (!parentId) throw new Error(table + "." + relation + " cannot be updated because the parent objectId is missing.");
  	    const store = DB.Data.of(table);
  	    const parent = { objectId: parentId };
  	    const children = arr(childObjects).map(function (item) {
  	      const id = objectIdOf(item);
  	      return id ? { objectId: id } : null;
  	    }).filter(Boolean);

  	    if (typeof store.setRelation === "function") {
  	      try {
  	        await store.setRelation(parent, relation, children);
  	        return true;
  	      } catch (error) {
  	        const message = clean(error && (error.message || error.faultString));
  	        if (/unknown column|column.+does not exist/i.test(message)) {
  	          throw new Error("The database relationship " + table + "." + relation + " does not exist. The driver was not changed.");
  	        }
  	        throw error;
  	      }
  	    }

  	    const existing = arr(existingObjects).map(function (item) {
  	      const id = objectIdOf(item);
  	      return id ? { objectId: id } : null;
  	    }).filter(Boolean);

  	    if (existing.length && typeof store.deleteRelation === "function") {
  	      await store.deleteRelation(parent, relation, existing);
  	    }
  	    if (children.length && typeof store.addRelation === "function") {
  	      await store.addRelation(parent, relation, children);
  	      return true;
  	    }
  	    if (!children.length && !existing.length) return true;
  	    throw new Error("The relation API cannot update " + table + "." + relation + ".");
  	  }

  	  async function addRelationOptional(table, parentId, relation, childId) {
  	    if (!DB || !parentId || !childId) return false;
  	    try {
  	      const store = DB.Data.of(table);
  	      if (typeof store.addRelation === "function") {
  	        await store.addRelation({ objectId: parentId }, relation, [{ objectId: childId }]);
  	        return true;
  	      }
  	      return false;
  	    } catch (error) {
  	      const message = clean(error && (error.message || error.faultString));
  	      if (/already|duplicate|exists/i.test(message)) return true;
  	      console.warn("FIF Driver Mobile optional relation failed", table, relation, error);
  	      return false;
  	    }
  	  }


  	  async function addRelationRequired(table, parentId, relation, childId) {
  	    if (!DB || !DB.Data || typeof DB.Data.of !== "function") throw new Error("The database is unavailable.");
  	    if (!parentId || !childId) throw new Error(table + "." + relation + " cannot be linked because an objectId is missing.");
  	    try {
  	      const store = DB.Data.of(table);
  	      if (typeof store.addRelation !== "function") throw new Error("The relation API is unavailable.");
  	      await store.addRelation({ objectId: parentId }, relation, [{ objectId: childId }]);
  	      return true;
  	    } catch (error) {
  	      const message = clean(error && (error.message || error.faultString || error.details));
  	      if (/already|duplicate|exists|relation.+exist/i.test(message)) return true;
  	      throw new Error("The " + table + "." + relation + " relationship could not be created. " + (message || "Database relationship rejected."));
  	    }
  	  }

  	  async function setBackRelationRequired(table, parentId, relation, childId) {
  	    if (!DB || !DB.Data || typeof DB.Data.of !== "function") throw new Error("The database is unavailable.");
  	    if (!parentId || !childId) throw new Error(table + "." + relation + " cannot be linked because an objectId is missing.");
  	    try {
  	      const store = DB.Data.of(table);
  	      const parent = { objectId: parentId };
  	      const children = [{ objectId: childId }];
  	      if (typeof store.setRelation === "function") await store.setRelation(parent, relation, children);
  	      else if (typeof store.addRelation === "function") await store.addRelation(parent, relation, children);
  	      else throw new Error("The relation API is unavailable.");
  	      return true;
  	    } catch (error) {
  	      const message = clean(error && (error.message || error.faultString || error.details));
  	      if (/already|duplicate|exists|relation.+exist/i.test(message)) return true;
  	      throw new Error("The " + table + "." + relation + " relationship could not be created. " + (message || "Database relationship rejected."));
  	    }
  	  }

  	  async function boardVehicle(company, vehicle) {
  	    const user = userRecord();
  	    const userId = objectIdOf(user);
  	    const vehicleId = objectIdOf(vehicle);
  	    const view = currentView(vehicle);
  	    const viewId = objectIdOf(view);
  	    if (!userId) throw new Error("Your user account has no objectId.");
  	    if (!vehicleId) throw new Error("The selected vehicle has no objectId.");
  	    if (!viewId) throw new Error("This vehicle has no current ViewC record and cannot be boarded.");
  	    const scanAge = Date.now() - numberOr(state.qrAuthorisedAt, 0);
  	    if (state.qrAuthorisedVehicleId !== vehicleId || scanAge < 0 || scanAge > QR_BOARD_AUTHORISATION_MS) {
  	      throw new Error("This vehicle must be scanned from its fitted QR tag before it can be boarded.");
  	    }

  	    const existingAssignment = findAssignment();
  	    if (existingAssignment && objectIdOf(existingAssignment.vehicle) !== vehicleId) {
  	      throw new Error("You are already boarded on " + vehicleName(existingAssignment.vehicle) + ". Leave that vehicle first.");
  	    }

  	    const slotResult = freeDriverSlot(vehicle, userId);
  	    if (!slotResult.slot) throw new Error(slotResult.reason || "This vehicle has no open driver position.");

  	    await setRelation("Users", userId, USER_TRACTOR_RELATION, [vehicle], userVehicleRelations(user));
  	    await setRelation("Tractorview", viewId, slotResult.slot, [user], relationList(view[slotResult.slot]));

  	    setLocalUserVehicle(user, vehicle);
  	    view[slotResult.slot] = user;
  	    state.assignment = { company: company, vehicle: vehicle, view: view, slot: slotResult.slot, source: "Boarded" };
  	    state.selectedCompanyId = objectIdOf(company);
  	    state.selectedVehicleId = vehicleId;
  	    state.qrAuthorisedVehicleId = "";
  	    state.qrAuthorisedAt = 0;
  	    state.screen = "home";
  	    render();
  	    return state.assignment;
  	  }

  	  async function ensureAssignmentRelations(assignment) {
  	    if (!assignment) throw new Error("No boarded vehicle was found.");
  	    const user = userRecord();
  	    const userId = objectIdOf(user);
  	    const vehicle = assignment.vehicle;
  	    const vehicleId = objectIdOf(vehicle);
  	    const view = currentView(vehicle);
  	    const viewId = objectIdOf(view);
  	    if (!userId || !vehicleId || !viewId) throw new Error("The boarding relationship is incomplete.");

  	    let slot = viewDriverSlot(view, userId);
  	    if (!slot) {
  	      const available = freeDriverSlot(vehicle, userId);
  	      if (!available.slot) throw new Error("The current vehicle period has no available driver position.");
  	      slot = available.slot;
  	      await setRelation("Tractorview", viewId, slot, [user], relationList(view[slot]));
  	      view[slot] = user;
  	    }

  	    const related = userVehicleRelations(user).some(function (item) { return objectIdOf(item) === vehicleId; });
  	    if (!related) {
  	      await setRelation("Users", userId, USER_TRACTOR_RELATION, [vehicle], userVehicleRelations(user));
  	      setLocalUserVehicle(user, vehicle);
  	    }

  	    assignment.view = view;
  	    assignment.slot = slot;
  	    return assignment;
  	  }

  	  async function leaveVehicle() {
  	    const assignment = state.assignment || findAssignment();
  	    if (!assignment) return true;
  	    const user = userRecord();
  	    const userId = objectIdOf(user);
  	    const vehicle = assignment.vehicle;
  	    const view = currentView(vehicle);
  	    if (!userId || !objectIdOf(vehicle)) throw new Error("The current vehicle relationship is incomplete.");

  	    await setRelation("Users", userId, USER_TRACTOR_RELATION, [], userVehicleRelations(user));
  	    setLocalUserVehicle(user, null);

  	    if (view && objectIdOf(view)) {
  	      for (let index = 0; index < DRIVER_SLOTS.length; index += 1) {
  	        const slot = DRIVER_SLOTS[index];
  	        if (relationId(view[slot]) !== userId) continue;
  	        await setRelation("Tractorview", objectIdOf(view), slot, [], relationList(view[slot]));
  	        view[slot] = null;
  	      }
  	    }

  	    state.assignment = null;
  	    state.selectedVehicleId = "";
  	    state.screen = "home";
  	    render();
  	    return true;
  	  }

  	  function gpsAccuracyQuality(accuracy) {
  	    const metres = numberValue(accuracy);
  	    if (metres === null) return { key: "unknown", label: "Unknown accuracy" };
  	    if (metres <= GPS_TARGET_ACCURACY_M) return { key: "excellent", label: "Excellent" };
  	    if (metres <= GPS_ACCEPTABLE_ACCURACY_M) return { key: "good", label: "Good" };
  	    if (metres <= GPS_HARD_LIMIT_ACCURACY_M) return { key: "weak", label: "Weak" };
  	    return { key: "poor", label: "Too inaccurate" };
  	  }

  	  function stopGpsWatch() {
  	    if (gpsRuntime.watchId !== null && navigator.geolocation && typeof navigator.geolocation.clearWatch === "function") {
  	      try { navigator.geolocation.clearWatch(gpsRuntime.watchId); } catch (_) {}
  	    }
  	    if (gpsRuntime.timerId) window.clearTimeout(gpsRuntime.timerId);
  	    gpsRuntime.watchId = null;
  	    gpsRuntime.timerId = 0;
  	  }

  	  function gpsSnapshot(position) {
  	    if (!position || !position.coords) return null;
  	    const latitude = numberValue(position.coords.latitude);
  	    const longitude = numberValue(position.coords.longitude);
  	    const accuracy = numberValue(position.coords.accuracy);
  	    if (latitude === null || longitude === null || accuracy === null) return null;
  	    if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180 || accuracy < 0) return null;
  	    return {
  	      latitude: latitude,
  	      longitude: longitude,
  	      accuracy: accuracy,
  	      capturedAt: new Date(position.timestamp || Date.now()).toISOString(),
  	      samples: gpsRuntime.samples,
  	      source: "watchPosition"
  	    };
  	  }

  	  function finishGpsRequest(result, message) {
  	    if (gpsRuntime.finished) return;
  	    gpsRuntime.finished = true;
  	    stopGpsWatch();
  	    state.gpsBusy = false;
  	    state.gpsSamples = gpsRuntime.samples;
  	    state.gpsStatus = message || "";
  	    state.gps = result || gpsRuntime.best || null;

  	    if (state.gps) {
  	      state.gps.samples = gpsRuntime.samples;
  	      const quality = gpsAccuracyQuality(state.gps.accuracy);
  	      if (state.gps.accuracy <= GPS_ACCEPTABLE_ACCURACY_M) {
  	        state.gpsError = "";
  	        const company = selectedCompany();
  	        const locations = eligibleFuelLocations(company, state.gps);
  	        state.selectedFuelLocationKey = locations.length ? locations[0].key : "__other__";
  	        if (!locations.length) state.gpsStatus = "No approved company fuel station was found within " + FUEL_LOCATION_PROXIMITY_M + " metres.";
  	      } else {
  	        state.selectedFuelLocationKey = "__other__";
  	        state.gpsError = "GPS is only accurate to about " + formatNumber(state.gps.accuracy, 0) + " metres. Move outside, keep the phone still and tap Try GPS Again. Company fuel stations remain locked until the position improves.";
  	      }
  	      state.gps.quality = quality.key;
  	    } else {
  	      state.selectedFuelLocationKey = "__other__";
  	    }

  	    render();
  	    const resolver = gpsRuntime.resolve;
  	    gpsRuntime.resolve = null;
  	    if (typeof resolver === "function") resolver(state.gps);
  	  }

  	  function requestGps() {
  	    if (!navigator.geolocation) {
  	      state.gpsError = "This phone does not provide browser GPS. Only Other can be used.";
  	      state.gpsBusy = false;
  	      render();
  	      return Promise.resolve(null);
  	    }

  	    stopGpsWatch();
  	    gpsRuntime.best = null;
  	    gpsRuntime.samples = 0;
  	    gpsRuntime.finished = false;
  	    state.gps = null;
  	    state.selectedFuelLocationKey = "";
  	    state.gpsBusy = true;
  	    state.gpsError = "";
  	    state.gpsStatus = "Waiting for a satellite-quality position…";
  	    state.gpsSamples = 0;
  	    render();

  	    return new Promise(function (resolve) {
  	      gpsRuntime.resolve = resolve;

  	      const onPosition = function (position) {
  	        gpsRuntime.samples += 1;
  	        const fix = gpsSnapshot(position);
  	        if (!fix) return;
  	        const capturedTime = Date.parse(fix.capturedAt);
  	        if (Number.isFinite(capturedTime) && Date.now() - capturedTime > 10000) return;

  	        if (!gpsRuntime.best || fix.accuracy < gpsRuntime.best.accuracy) gpsRuntime.best = fix;
  	        gpsRuntime.best.samples = gpsRuntime.samples;
  	        state.gps = Object.assign({}, gpsRuntime.best);
  	        state.gpsSamples = gpsRuntime.samples;
  	        const quality = gpsAccuracyQuality(state.gps.accuracy);
  	        state.gps.quality = quality.key;
  	        state.gpsStatus = "Improving accuracy — " + quality.label + " fix";
  	        render();

  	        if (state.gps.accuracy <= GPS_TARGET_ACCURACY_M) {
  	          finishGpsRequest(state.gps, "Best GPS position locked.");
  	        }
  	      };

  	      const onError = function (error) {
  	        const messages = {
  	          1: "Location permission was not allowed. Enable precise location for this site, then try again.",
  	          2: "The phone could not determine its location. Move outside and try again.",
  	          3: "GPS is still searching. Move outside and try again."
  	        };
  	        if (error && error.code === 1) {
  	          state.gpsError = messages[1];
  	          finishGpsRequest(null, "Location permission required.");
  	          return;
  	        }
  	        if (!gpsRuntime.best && error && error.code !== 3) {
  	          state.gpsError = messages[error.code] || "GPS is unavailable. Only Other can be used.";
  	          finishGpsRequest(null, "GPS unavailable.");
  	        }
  	      };

  	      gpsRuntime.watchId = navigator.geolocation.watchPosition(onPosition, onError, {
  	        enableHighAccuracy: true,
  	        timeout: 12000,
  	        maximumAge: MAX_GPS_AGE_MS
  	      });

  	      gpsRuntime.timerId = window.setTimeout(function () {
  	        if (gpsRuntime.best) finishGpsRequest(gpsRuntime.best, gpsRuntime.best.accuracy <= GPS_ACCEPTABLE_ACCURACY_M ? "GPS position ready." : "Best available position received.");
  	        else {
  	          state.gpsError = "No GPS position was received. Move outside, enable precise location and try again.";
  	          finishGpsRequest(null, "No position received.");
  	        }
  	      }, GPS_TIMEOUT_MS);
  	    });
  	  }

  	  function fuelCalculation() {
  	    const litres = numberValue(state.litres);
  	    const cost = numberValue(state.totalCost);
  	    if (litres === null || litres <= 0 || cost === null || cost < 0) return null;
  	    return {
  	      litres: Math.round(litres * 1000) / 1000,
  	      cost: Math.round(cost * 100) / 100,
  	      costPerLitre: litres > 0 ? Math.round(cost / litres * 100) / 100 : 0
  	    };
  	  }

  	  function validateFuelStep(step) {
  	    const vehicle = selectedVehicle();
  	    if (!vehicle) return "No boarded vehicle is selected.";
  	    if (step === 0) {
  	      if (state.gpsBusy) return "Wait while the phone finds approved fuel stations.";
  	      if (!state.selectedFuelLocationKey) return "Choose an approved fuel station or select Other.";
  	      if (state.selectedFuelLocationKey === "__other__" && !clean(state.otherSupplier)) return "Type the fuel station or supplier name.";
  	      if (state.selectedFuelLocationKey !== "__other__") {
  	        if (!gpsFixCanGateFuel(state.gps)) return "A fresh, accurate GPS position is required for a company fuel station.";
  	        const location = selectedFuelLocation();
  	        if (!location || !location.eligible) return "You must be inside this fuel location or within " + FUEL_LOCATION_PROXIMITY_M + " metres of it.";
  	      }
  	    }
  	    if (step === 1) {
  	      const reading = numberValue(state.mileage);
  	      const current = currentMileage(vehicle);
  	      const profile = vehicleMeterProfile(vehicle);
  	      const maximum = profile.kind === "distance" ? maximumMileage(vehicle) : null;
  	      if (reading === null || reading < 0) return "Enter the operating meter reading shown on the vehicle.";
  	      if (current !== null && reading < current) return profile.shortLabel + " cannot be lower than " + formatVehicleMeter(vehicle, current) + ".";
  	      if (maximum !== null && reading > maximum) return profile.shortLabel + " cannot be higher than " + formatVehicleMeter(vehicle, maximum) + ".";
  	    }
  	    if (step === 2) {
  	      const calculation = fuelCalculation();
  	      if (!calculation || calculation.litres <= 0) return "Enter the litres and the total amount.";
  	      const capacity = tankCapacity(vehicle);
  	      if (capacity !== null && capacity > 0 && calculation.litres > capacity) return "Litres cannot exceed the tank capacity of " + formatNumber(capacity, 1) + " L.";
  	    }
  	    return "";
  	  }

  	  function fuelSupplierName() {
  	    if (state.selectedFuelLocationKey === "__other__") return clean(state.otherSupplier);
  	    const location = selectedFuelLocation();
  	    return location ? location.name : "";
  	  }

  	  function reconcileFuelLocal(company, vehicle, view, saved) {
  	    if (!Array.isArray(company.FuelOut)) company.FuelOut = [];
  	    if (!Array.isArray(vehicle.FuelOut)) vehicle.FuelOut = [];
  	    if (view && !Array.isArray(view.Fuel)) view.Fuel = [];
  	    const upsert = function (rows) {
  	      const id = objectIdOf(saved);
  	      const index = rows.findIndex(function (row) { return objectIdOf(row) === id; });
  	      if (index === -1) rows.push(saved);
  	      else rows[index] = Object.assign(rows[index], saved);
  	    };
  	    upsert(company.FuelOut);
  	    upsert(vehicle.FuelOut);
  	    if (view) upsert(view.Fuel);
  	  }

  	  function reconcileTransactionLocal(company, vehicle, view, fuel, transaction) {
  	    const collections = [company, vehicle, view, fuel].filter(Boolean);
  	    collections.forEach(function (record) {
  	      if (!Array.isArray(record.Transactions)) record.Transactions = [];
  	      const transactionId = objectIdOf(transaction);
  	      const index = record.Transactions.findIndex(function (row) { return objectIdOf(row) === transactionId; });
  	      if (index === -1) record.Transactions.push(transaction);
  	      else record.Transactions[index] = Object.assign(record.Transactions[index], transaction);
  	    });
  	  }

  	  async function createFuelTransaction(company, vehicle, view, fuel, ownerId) {
  	    const fuelId = objectIdOf(fuel);
  	    const companyId = objectIdOf(company);
  	    const vehicleId = objectIdOf(vehicle);
  	    if (!fuelId || !companyId || !vehicleId || !ownerId) throw new Error("The fuel transaction cannot be created because its source links are incomplete.");

  	    const now = new Date();
  	    const fuelDate = new Date(fuel && fuel.FuelDate ? fuel.FuelDate : now);
  	    const transactionDate = Number.isNaN(fuelDate.getTime())
  	      ? new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0, 0)
  	      : new Date(fuelDate.getFullYear(), fuelDate.getMonth(), fuelDate.getDate(), 12, 0, 0, 0);
  	    const transactionNumber = fuelTransactionNumber();
  	    const gross = Math.round(numberOr(fuel.Cost, 0) * 100) / 100;
  	    const transactionPayload = {
  	      ownerId: ownerId,
  	      TransactionNumber: transactionNumber,
  	      TransactionGroupId: transactionNumber,
  	      SourceKey: "FuelOut:" + fuelId + ":Original",
  	      Status: "Pending",
  	      Direction: "Debit",
  	      TransactionType: "Fuel Issue",
  	      Category: "Fuel",
  	      Subcategory: "Fuel",
  	      TransactionDate: transactionDate,
  	      PostingDate: new Date(transactionDate.getTime()),
  	      PeriodKey: transactionPeriodKey(transactionDate),
  	      Quantity: numberOr(fuel.Litres, 0),
  	      Unit: "L",
  	      UnitCost: numberOr(fuel.CostPerLitre, 0),
  	      NetAmount: gross,
  	      VATAmount: 0,
  	      GrossAmount: gross,
  	      Currency: "ZAR",
  	      Description: clean(fuel.Description || "Driver mobile on-road fuel capture."),
  	      ReferenceNumber: fuelId,
  	      SupplierName: clean(fuel.ContractorName),
  	      CompanyObjectId: companyId,
  	      CompanyId: clean(firstValue([company && company.CompanyId, companyName(company)], "")),
  	      AssetType: "Tractor",
  	      AssetObjectId: vehicleId,
  	      AssetId: vehicleName(vehicle),
  	      Registration: vehicleRegistration(vehicle),
  	      Odometer: null,
  	      SourceTable: "FuelOut",
  	      SourceObjectId: fuelId,
  	      SourceRecordId: fuelId,
  	      PotentialSARSRebate: numberOr(fuel.PotentialSARSRebate, 0),
  	      SARSRebateRate: numberOr(fuel.SARSRebateRate, 0),
  	      SARSCompliance: fuel.SARSCompliance === true,
  	      Notes: "Created automatically from driver mobile fuel capture.",
  	      Audit: {
  	        CreatedAt: now.toISOString(),
  	        CreatedBy: clean(fuel.CapturedByName),
  	        UpdatedAt: now.toISOString(),
  	        UpdatedBy: clean(fuel.CapturedByName)
  	      },
  	      Data: {
  	        SchemaVersion: VERSION,
  	        SourceKey: "FuelOut:" + fuelId + ":Original",
  	        CaptureType: clean(fuel.CaptureType || "on-road"),
  	        SARSRebateRate: numberOr(fuel.SARSRebateRate, 0),
  	        CreatedBy: clean(fuel.CapturedByName),
  	        UpdatedAt: now.toISOString()
  	      }
  	    };

  	    const transactionRaw = await DB.Data.of("Transactions").save(transactionPayload);
  	    const transaction = Object.assign({}, transactionPayload, transactionRaw || {});
  	    const transactionId = objectIdOf(transaction);
  	    if (!transactionId) throw new Error("The Transactions record saved without an objectId.");

  	    await addRelationRequired("Companies", companyId, "Transactions", transactionId);
  	    await addRelationRequired("Tractors", vehicleId, "Transactions", transactionId);
  	    if (view && objectIdOf(view)) await addRelationRequired("Tractorview", objectIdOf(view), "Transactions", transactionId);
  	    await addRelationRequired("FuelOut", fuelId, "Transactions", transactionId);

  	    await setBackRelationRequired("Transactions", transactionId, "Company", companyId);
  	    await setBackRelationRequired("Transactions", transactionId, "Tractor", vehicleId);
  	    if (view && objectIdOf(view)) await setBackRelationRequired("Transactions", transactionId, "TractorPeriod", objectIdOf(view));
  	    await setBackRelationRequired("Transactions", transactionId, "FuelOutRecord", fuelId);

  	    const postedRaw = await DB.Data.of("Transactions").save({ objectId: transactionId, Status: "Posted" });
  	    Object.assign(transaction, postedRaw || {}, { Status: "Posted" });
  	    reconcileTransactionLocal(company, vehicle, view, fuel, transaction);
  	    return transaction;
  	  }

  	  async function saveFuel() {
  	    const assignment = await ensureAssignmentRelations(state.assignment || findAssignment());
  	    const company = assignment.company;
  	    const localVehicle = assignment.vehicle;
  	    const localView = currentView(localVehicle);
  	    const user = userRecord();
  	    const companyId = objectIdOf(company);
  	    const vehicleId = objectIdOf(localVehicle);
  	    const userId = objectIdOf(user);
  	    if (!DB) throw new Error("The database is unavailable.");
  	    if (!companyId || !vehicleId || !userId) throw new Error("Company, vehicle or driver objectId is missing.");

  	    for (let step = 0; step <= 2; step += 1) {
  	      const error = validateFuelStep(step);
  	      if (error) throw new Error(error);
  	    }

  	    const context = await driverLoadFuelVehicleContext(localVehicle, localView);
  	    const vehicle = context.vehicle;
  	    const view = context.view;
  	    const flespiMileage = await flespiMileageForFuelPayload(vehicle);
  	    const calculation = fuelCalculation();
  	    const mileage = numberValue(state.mileage);
  	    const previousMileage = currentMileage(vehicle);
  	    const meterProfile = vehicleMeterProfile(vehicle);
  	    const maximum = meterProfile.kind === "distance" ? maximumMileage(vehicle) : null;

  	    if (mileage === null || mileage < 0) throw new Error("Enter the operating meter reading shown on the vehicle.");
  	    if (previousMileage !== null && mileage < previousMileage) {
  	      throw new Error(meterProfile.shortLabel + " cannot be lower than " + formatVehicleMeter(vehicle, previousMileage) + ".");
  	    }
  	    if (maximum !== null && mileage > maximum) {
  	      throw new Error(meterProfile.shortLabel + " cannot be higher than " + formatVehicleMeter(vehicle, maximum) + ".");
  	    }

  	    const meterDifference = previousMileage === null ? 0 : Math.max(0, mileage - previousMileage);
  	    const distance = meterProfile.kind === "distance" ? meterDifference : 0;
  	    const hours = meterProfile.kind === "hours" ? meterDifference : 0;
  	    const efficiency = calculation.litres > 0
  	      ? Math.round((meterDifference / calculation.litres) * 1000) / 1000
  	      : 0;
  	    const location = selectedFuelLocation();
  	    const supplier = fuelSupplierName();
  	    const now = new Date();
  	    const ownerId = companyOwnerId(company);
  	    const capturedByName = userName(user);
  	    const sarsRate = vehicleSarsRebateRate(vehicle);
  	    const sarsCompliant = vehicleSarsCompliance(vehicle);
  	    const potentialSarsRebate = sarsCompliant
  	      ? Math.round(calculation.litres * sarsRate * 100) / 100
  	      : 0;
  	    const registration = vehicleRegistration(vehicle);
  	    if (!ownerId) throw new Error("The selected company has no ownerId. Fuel cannot be saved with an incorrect owner.");

  	    const payload = {
  	      ownerId: ownerId,
  	      FuelDate: now.toISOString(),
  	      CaptureType: "on-road",
  	      EntryType: "On Road Fuel",
  	      Mileage: mileage,
  	      MileageLast: previousMileage,
  	      ReadingUnit: meterProfile.unit,
  	      ReadingDelta: meterDifference,
  	      Efficiency: efficiency,
  	      EfficiencyUnit: meterProfile.kind === "hours" ? "h/L" : "km/L",
  	      Distance: distance,
  	      Hours: hours,
  	      Litres: calculation.litres,
  	      CostPerLitre: calculation.costPerLitre,
  	      Cost: calculation.cost,
  	      ContractorName: supplier,
  	      ReferenceNo: clean(state.reference),
  	      Application: "",
  	      Description: clean((state.reference ? "Receipt " + state.reference + ". " : "") + "Driver mobile on-road fuel capture." + (sarsCompliant ? " SARS rebate calculated at " + formatMoney(sarsRate) + " per litre." : "")),
  	      Driver: capturedByName,
  	      DriverName: capturedByName,
  	      DriverObjectId: userId,
  	      CapturedByObjectId: userId,
  	      CapturedByName: capturedByName,
  	      Registration: registration,
  	      SARSCompliance: sarsCompliant,
  	      SARSRebateRate: sarsRate,
  	      PotentialSARSRebate: potentialSarsRebate,
  	      CompanyObjectId: companyId,
  	      TractorObjectId: vehicleId,
  	      VehicleObjectId: vehicleId,
  	      FuelLocationObjectId: location ? location.objectId : "",
  	      FuelLocationName: supplier,
  	      FuelLocationDistanceKM: location && location.distance !== null ? Math.round(location.distance * 1000) / 1000 : null,
  	      FuelLocationDistanceM: location && location.distanceMeters !== null ? Math.round(location.distanceMeters * 10) / 10 : null,
  	      FuelLocationInside: location ? !!location.inside : false,
  	      FuelLocationGateMetres: FUEL_LOCATION_PROXIMITY_M,
  	      FuelLocationProximityMethod: location ? location.proximityMethod : "",
  	      LocationSource: state.selectedFuelLocationKey === "__other__" ? "Other" : "GPS verified company fuel location",
  	      Latitude: state.gps ? state.gps.latitude : null,
  	      Longitude: state.gps ? state.gps.longitude : null,
  	      GPSAccuracy: state.gps ? state.gps.accuracy : null,
  	      GPSCapturedAt: state.gps ? state.gps.capturedAt : null,
  	      GPSFixSamples: state.gps ? numberOr(state.gps.samples, state.gpsSamples) : 0,
  	      GPSQuality: state.gps ? gpsAccuracyQuality(state.gps.accuracy).label : "No GPS",
  	      GPSAcquisitionMethod: state.gps ? clean(state.gps.source || "watchPosition") : "",
  	      RollbackMileageDifferential: meterDifference,
  	      RollbackVehicleMileageBefore: previousMileage,
  	      Company: { objectId: companyId },
  	      Tractor: { objectId: vehicleId }
  	    };
  	    if (flespiMileage !== null) payload.FlespiMileage = flespiMileage;
  	    if (location && location.objectId) payload.Location = { objectId: location.objectId };

  	    const savedRaw = await DB.Data.of("FuelOut").save(payload);
  	    const saved = Object.assign({}, payload, savedRaw || {});
  	    const fuelId = objectIdOf(saved);
  	    if (!fuelId) throw new Error("The fuel record saved without an objectId.");

  	    await addRelationOptional("Companies", companyId, "FuelOut", fuelId);
  	    await addRelationOptional("Tractors", vehicleId, "FuelOut", fuelId);
  	    if (view && objectIdOf(view)) await addRelationOptional("Tractorview", objectIdOf(view), "Fuel", fuelId);
  	    await addRelationOptional("Users", userId, "FuelOut", fuelId);
  	    await addRelationOptional("FuelOut", fuelId, "Company", companyId);
  	    await addRelationOptional("FuelOut", fuelId, "Tractor", vehicleId);
  	    if (location && location.objectId) await addRelationOptional("FuelOut", fuelId, "Location", location.objectId);

  	    driverSetVehicleCurrentReading(vehicle, mileage, meterProfile);
  	    driverIncrementFuelCounter(vehicle);

  	    const tractorPatch = {
  	      objectId: vehicleId,
  	      Mileage: mileage,
  	      Data: clone(vehicle.Data)
  	    };
  	    const tractorSaved = await DB.Data.of("Tractors").save(tractorPatch);
  	    Object.assign(vehicle, tractorSaved || {}, tractorPatch);

  	    const tyreUsage = await driverApplyTyreUsage(
  	      vehicle,
  	      mileage,
  	      previousMileage,
  	      meterDifference
  	    );

  	    if (view && objectIdOf(view)) {
  	      const existingMeterStart = numberValue(view.MeterStart);
  	      const viewPatch = {
  	        objectId: objectIdOf(view),
  	        TransactionCount: numberOr(view.TransactionCount, 0) + 1,
  	        MeterStart: (existingMeterStart === null || existingMeterStart <= 0) && previousMileage !== null
  	          ? previousMileage
  	          : view.MeterStart,
  	        MeterEnd: mileage,
  	        Distance: numberOr(view.Distance, 0) + distance,
  	        Hours: numberOr(view.Hours, 0) + hours,
  	        Litres: Math.round((numberOr(view.Litres, 0) + calculation.litres) * 1000) / 1000,
  	        Cost: Math.round((numberOr(view.Cost, 0) + calculation.cost) * 100) / 100,
  	        PotentialSARSRebate: Math.round((numberOr(view.PotentialSARSRebate, 0) + potentialSarsRebate) * 100) / 100
  	      };
  	      try {
  	        const viewSaved = await DB.Data.of("Tractorview").save(viewPatch);
  	        Object.assign(view, viewPatch, viewSaved || {});
  	      } catch (error) {
  	        console.warn("FIF Driver Mobile ViewC summary update failed", error);
  	      }
  	    }

  	    Object.assign(localVehicle, vehicle);
  	    localVehicle.Mileage = mileage;
  	    if (vehicle.Data) localVehicle.Data = clone(vehicle.Data);
  	    if (vehicle.Tyres) localVehicle.Tyres = driverRelationRows(vehicle.Tyres);
  	    if (localView && view) Object.assign(localView, view);

  	    reconcileFuelLocal(company, localVehicle, localView || view, saved);

  	    const transaction = await createFuelTransaction(company, localVehicle, localView || view, saved, ownerId);
  	    saved.Transactions = [transaction];

  	    /*
  	     * Match Dashboard/Bowser Service and Preventive Maintenance thresholds,
  	     * but keep all email activity invisible to the driver. Email failures are
  	     * deliberately isolated from the fuel transaction and never surface in
  	     * Driver Mobile.
  	     */
  	    await driverProcessProviderNotificationsSilently(company, vehicle, saved);
  	    if (vehicle.Data) localVehicle.Data = clone(vehicle.Data);

  	    const photoResult = await attachOptionalFuelPhotos(saved);

  	    state.success = {
  	      fuel: saved,
  	      vehicle: localVehicle,
  	      supplier: supplier,
  	      litres: calculation.litres,
  	      cost: calculation.cost,
  	      transaction: transaction,
  	      potentialSarsRebate: potentialSarsRebate,
  	      photoUploadedCount: photoResult.uploadedCount,
  	      photoWarnings: photoResult.warnings
  	    };
  	    state.screen = "success";
  	    render();
  	    return saved;
  	  }

  	  function appMenuNode() {
  	    return document.getElementById(APP_MENU_ID);
  	  }

  	  function logoutButtonNode() {
  	    return document.querySelector(
  	      "#" + ROOT_ID + " [data-action='logout']"
  	    );
  	  }

  	  function positionAppMenu() {
  	    const menu = appMenuNode();
  	    if (!menu) return;

  	    const button = logoutButtonNode();
  	    const width = Math.min(220, Math.max(176, window.innerWidth - 16));
  	    const viewportPadding = 8;
  	    const gap = 6;
  	    let left = window.innerWidth - width - viewportPadding;
  	    let top = viewportPadding;

  	    if (button && button.getBoundingClientRect) {
  	      const rect = button.getBoundingClientRect();
  	      left = Math.min(
  	        window.innerWidth - width - viewportPadding,
  	        Math.max(viewportPadding, rect.right - width)
  	      );
  	      top = rect.bottom + gap;

  	      const height = menu.offsetHeight || 210;
  	      if (top + height > window.innerHeight - viewportPadding) {
  	        top = Math.max(viewportPadding, rect.top - height - gap);
  	      }
  	    }

  	    menu.style.width = width + "px";
  	    menu.style.left = Math.round(left) + "px";
  	    menu.style.top = Math.round(top) + "px";
  	  }

  	  function onAppMenuOutside(event) {
  	    const menu = appMenuNode();
  	    const button = logoutButtonNode();
  	    if (!menu) return;
  	    if (menu.contains(event.target)) return;
  	    if (button && button.contains(event.target)) return;
  	    closeAppMenu();
  	  }

  	  function onAppMenuKeyDown(event) {
  	    if (event.key !== "Escape") return;
  	    event.preventDefault();
  	    closeAppMenu();
  	  }

  	  function closeAppMenu() {
  	    const menu = appMenuNode();
  	    if (menu) menu.remove();

  	    document.removeEventListener("pointerdown", onAppMenuOutside, true);
  	    document.removeEventListener("keydown", onAppMenuKeyDown, true);
  	    window.removeEventListener("resize", positionAppMenu);
  	    window.removeEventListener("scroll", positionAppMenu, true);

  	    const button = logoutButtonNode();
  	    if (button) button.setAttribute("aria-expanded", "false");
  	  }

  	  function setAppMenuStatus(message, error) {
  	    const menu = appMenuNode();
  	    if (!menu) return;
  	    const status = menu.querySelector("[data-app-menu-status]");
  	    if (!status) return;
  	    status.textContent = clean(message);
  	    status.hidden = !clean(message);
  	    status.classList.toggle("error", !!error);
  	  }

  	  function disableAppMenuOptions(disabled) {
  	    const menu = appMenuNode();
  	    if (!menu) return;
  	    menu.querySelectorAll("button").forEach(function (button) {
  	      button.disabled = !!disabled;
  	    });
  	  }

  	  async function isBackendlessSessionValid() {
  	    try {
  	      if (
  	        DB &&
  	        DB.UserService &&
  	        typeof DB.UserService.isValidLogin === "function"
  	      ) {
  	        return !!(await DB.UserService.isValidLogin());
  	      }
  	    } catch (_) {
  	      return false;
  	    }
  	    return true;
  	  }

  	  function applicationNavigator() {
  	    const candidates = [];
  	    try {
  	      if (typeof BackendlessUI !== "undefined") candidates.push(BackendlessUI);
  	    } catch (_) {}
  	    try {
  	      if (window.BackendlessUI) candidates.push(window.BackendlessUI);
  	    } catch (_) {}
  	    try {
  	      if (window.parent && window.parent !== window && window.parent.BackendlessUI) {
  	        candidates.push(window.parent.BackendlessUI);
  	      }
  	    } catch (_) {}
  	    try {
  	      if (window.top && window.top !== window && window.top.BackendlessUI) {
  	        candidates.push(window.top.BackendlessUI);
  	      }
  	    } catch (_) {}

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      if (
  	        candidates[index] &&
  	        candidates[index].Navigator &&
  	        typeof candidates[index].Navigator.goToPage === "function"
  	      ) {
  	        return candidates[index].Navigator;
  	      }
  	    }
  	    return null;
  	  }

  	  async function navigateToApplicationPage(pageName) {
  	    const navigator = applicationNavigator();
  	    if (!navigator) throw new Error("Application navigation is unavailable.");
  	    await Promise.resolve(navigator.goToPage(pageName, undefined));
  	  }

  	  async function switchApplication(appName) {
  	    if (state.appSwitchInProgress || state.logoutInProgress) return false;

  	    const user = userRecord();
  	    const target = normaliseApplicationName(appName);
  	    const allowed = allowedApplicationsFor(user);

  	    if (!APPLICATION_PAGES[target] || allowed.indexOf(target) === -1) {
  	      setAppMenuStatus(
  	        "You do not have permission to open this application.",
  	        true
  	      );
  	      return false;
  	    }

  	    state.appSwitchInProgress = true;
  	    disableAppMenuOptions(true);
  	    setAppMenuStatus("Opening " + target + "…", false);

  	    try {
  	      const sessionValid = await isBackendlessSessionValid();
  	      const activeGuard = installLogoutGuard() || logoutGuard;

  	      console.info("[Driver Mobile App Switcher]", {
  	        version: VERSION,
  	        from: currentApplication(),
  	        to: target,
  	        sessionValid: sessionValid,
  	        logoutGuardActive: !!activeGuard
  	      });

  	      if (!sessionValid) {
  	        throw new Error("Your session has ended. Please log in again.");
  	      }

  	      stopQrScanner();
  	      stopGpsWatch();

  	      if (APP_DATA && typeof APP_DATA === "object") {
  	        APP_DATA.APP = target;
  	      }

  	      const pageName = APPLICATION_PAGES[target];
  	      closeAppMenu();
  	      await navigateToApplicationPage(pageName);

  	      window.setTimeout(function () {
  	        try {
  	          if (document.getElementById(ROOT_ID)) destroy();
  	        } catch (_) {}
  	      }, 500);

  	      return true;
  	    } catch (error) {
  	      state.appSwitchInProgress = false;
  	      disableAppMenuOptions(false);
  	      setAppMenuStatus(
  	        clean(error && error.message) ||
  	          "The selected application could not be opened.",
  	        true
  	      );
  	      return false;
  	    }
  	  }

  	  function openAppMenu(applications) {
  	    closeAppMenu();

  	    const menu = document.createElement("div");
  	    menu.id = APP_MENU_ID;
  	    menu.setAttribute("role", "menu");
  	    menu.setAttribute("aria-label", "Switch application or log out");

  	    applications.forEach(function (name) {
  	      const option = document.createElement("button");
  	      option.type = "button";
  	      option.className = "fifd-app-option";
  	      option.setAttribute("role", "menuitem");
  	      option.textContent = name;
  	      option.addEventListener("click", function (event) {
  	        event.preventDefault();
  	        event.stopPropagation();
  	        switchApplication(name);
  	      });
  	      menu.appendChild(option);
  	    });

  	    const logout = document.createElement("button");
  	    logout.type = "button";
  	    logout.className = "fifd-app-option logout";
  	    logout.setAttribute("role", "menuitem");
  	    logout.textContent = "Log Out";
  	    logout.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      closeAppMenu();
  	      requestConfirmedLogout();
  	    });
  	    menu.appendChild(logout);

  	    const status = document.createElement("div");
  	    status.className = "fifd-app-status";
  	    status.setAttribute("data-app-menu-status", "");
  	    status.setAttribute("aria-live", "polite");
  	    status.hidden = true;
  	    menu.appendChild(status);

  	    document.body.appendChild(menu);
  	    positionAppMenu();

  	    const button = logoutButtonNode();
  	    if (button) button.setAttribute("aria-expanded", "true");

  	    document.addEventListener("pointerdown", onAppMenuOutside, true);
  	    document.addEventListener("keydown", onAppMenuKeyDown, true);
  	    window.addEventListener("resize", positionAppMenu);
  	    window.addEventListener("scroll", positionAppMenu, true);

  	    window.setTimeout(function () {
  	      positionAppMenu();
  	      const first = menu.querySelector("button");
  	      if (first && typeof first.focus === "function") first.focus();
  	    }, 0);
  	  }

  	  function handleLogoutButton() {
  	    if (appMenuNode()) {
  	      closeAppMenu();
  	      return;
  	    }

  	    const user = userRecord();
  	    const current = currentApplication();
  	    const alternatives = allowedApplicationsFor(user).filter(function (name) {
  	      return name !== current;
  	    });

  	    console.info("[Driver Mobile App Switcher Ready]", {
  	      version: VERSION,
  	      currentApp: current,
  	      availableApps: alternatives,
  	      logoutGuardActive: !!(installLogoutGuard() || logoutGuard)
  	    });

  	    if (!user || !alternatives.length) {
  	      requestConfirmedLogout();
  	      return;
  	    }

  	    openAppMenu(alternatives);
  	  }

  	  function loginPageUrl(targetWindow) {
  	    try {
  	      const current = new URL(targetWindow.location.href);
  	      current.searchParams.set("page", "Login");
  	      current.hash = "";
  	      return current.toString();
  	    } catch (_) {
  	      return "index.html?page=Login";
  	    }
  	  }

  	  function navigateToLogin() {
  	    const navigatorScopes = [];
  	    const addNavigator = function (scope) {
  	      if (!scope || !scope.Navigator || typeof scope.Navigator.goToPage !== "function") return;
  	      if (navigatorScopes.indexOf(scope) === -1) navigatorScopes.push(scope);
  	    };

  	    try { if (typeof BackendlessUI !== "undefined") addNavigator(BackendlessUI); } catch (_) {}
  	    try { if (typeof window !== "undefined") addNavigator(window.BackendlessUI); } catch (_) {}
  	    try { if (typeof window !== "undefined" && window.parent && window.parent !== window) addNavigator(window.parent.BackendlessUI); } catch (_) {}
  	    try { if (typeof window !== "undefined" && window.top && window.top !== window) addNavigator(window.top.BackendlessUI); } catch (_) {}

  	    for (let index = 0; index < navigatorScopes.length; index += 1) {
  	      try {
  	        const result = navigatorScopes[index].Navigator.goToPage("Login", undefined);
  	        if (result && typeof result.catch === "function") {
  	          result.catch(function (error) {
  	            console.warn("FIF Driver Mobile Login navigator rejected; hard redirect will continue.", error);
  	          });
  	        }
  	        break;
  	      } catch (error) {
  	        console.warn("FIF Driver Mobile Login navigator failed; trying fallback.", error);
  	      }
  	    }

  	    // UI Builder's Navigator can silently no-op in custom-code page contexts.
  	    // Always follow it with a hard same-container redirect so logout cannot leave
  	    // the driver stranded on the protected Road page.
  	    setTimeout(function () {
  	      let targetWindow = typeof window !== "undefined" ? window : null;
  	      try {
  	        if (window.top && window.top.location && window.top.location.href) targetWindow = window.top;
  	      } catch (_) {}
  	      if (!targetWindow) return;

  	      const targetUrl = loginPageUrl(targetWindow);
  	      try {
  	        targetWindow.location.replace(targetUrl);
  	      } catch (_) {
  	        try {
  	          window.location.replace(targetUrl);
  	        } catch (_) {
  	          window.location.href = targetUrl;
  	        }
  	      }
  	    }, 250);

  	    return true;
  	  }

  	  async function logoutUser() {
  	    if (state.logoutInProgress) return true;
  	    state.logoutInProgress = true;

  	    const backendlessApi = DB || (typeof Backendless !== "undefined" ? Backendless : null) || (typeof window !== "undefined" ? window.Backendless : null);
  	    if (!backendlessApi || !backendlessApi.UserService || typeof backendlessApi.UserService.logout !== "function") {
  	      state.logoutInProgress = false;
  	      throw new Error("Backendless logout is unavailable on this page.");
  	    }

  	    try {
  	      stopQrScanner();
  	      stopGpsWatch();

  	      const activeGuard = installLogoutGuard() || logoutGuard;
  	      if (
  	        activeGuard &&
  	        typeof activeGuard.explicitLogout === "function"
  	      ) {
  	        await activeGuard.explicitLogout();
  	      } else {
  	        await backendlessApi.UserService.logout();
  	      }

  	      closeOperation();
  	      navigateToLogin();
  	      return true;
  	    } catch (error) {
  	      state.logoutInProgress = false;
  	      throw error;
  	    }
  	  }

  	  async function requestConfirmedLogout() {
  	    if (state.logoutInProgress) return;

  	    const approved = await showDialog({
  	      title: "Log out?",
  	      message: "Your current session will close and the Login page will open. Your vehicle boarding relationship will not be changed.",
  	      confirmText: "YES  LOG OUT",
  	      cancelText: "STAY LOGGED IN",
  	      danger: true
  	    });

  	    if (!approved) return;

  	    showOperation("Logging out…", "Closing your secure session.");
  	    try {
  	      await logoutUser();
  	    } catch (error) {
  	      closeOperation();
  	      await showDialog({
  	        title: "Logout failed",
  	        message: clean(error && error.message) || "The session could not be closed.",
  	        confirmText: "Close",
  	        hideCancel: true,
  	        danger: true
  	      });
  	    }
  	  }

  	  function renderHeader() {
  	    const user = userRecord();
  	    const company = selectedCompany() || (state.assignment && state.assignment.company);
  	    const logo = suppliedSvg();
  	    const assigned = state.assignment || findAssignment();
  	    return `<header class="fifd-header">
  	      <div class="fifd-logo">${logo || fallbackLogo()}</div>
  	      <div class="fifd-title">
  	        <small>Fleet In Form · Road</small>
  	        <strong>${escapeHtml(userName(user))}</strong>
  	        <span>${escapeHtml(company ? companyName(company) : "Driver vehicle workspace")}</span>
  	      </div>
  	      <div class="fifd-header-actions">
  	        <div class="fifd-header-status">${assigned ? "Boarded" : "Ready"}</div>
  	        <button type="button" class="fifd-logout" data-action="logout" aria-label="Switch application or log out" aria-haspopup="menu" aria-expanded="false">${icon("logout")}<span>Logout</span></button>
  	      </div>
  	    </header>`;
  	  }

  	  function renderHome() {
  	    const assignment = state.assignment || findAssignment();
  	    state.assignment = assignment;
  	    if (!assignment) {
  	      return `<main class="fifd-main">
  	        <span class="fifd-kicker">Ready to drive</span>
  	        <h1>Scan your vehicle</h1>
  	        <p>Use the steel QR tag fitted to the vehicle. The code is checked against your company vehicles before anything is changed.</p>
  	        <section class="fifd-board-hero">
  	          <div class="fifd-board-symbol">${icon("qr")}</div>
  	          <h2>Board with the camera</h2>
  	          <p>Point the rear camera at the vehicle QR plate, confirm the vehicle, and start work.</p>
  	          <div class="fifd-board-actions">
  	            <button type="button" class="fifd-btn scan" data-action="scan-vehicle">${icon("camera")} Open Camera &amp; Scan</button>
  	          </div>
  	          <div class="fifd-help-strip"><span><b>1</b>Scan tag</span><span><b>2</b>Check vehicle</span><span><b>3</b>Board</span></div>
  	        </section>
  	      </main>`;
  	    }

  	    state.selectedCompanyId = objectIdOf(assignment.company);
  	    state.selectedVehicleId = objectIdOf(assignment.vehicle);
  	    const accent = vehicleAccent(assignment.vehicle);
  	    return `<main class="fifd-main">
  	      <span class="fifd-kicker">Current vehicle</span>
  	      <h1>${escapeHtml(vehicleName(assignment.vehicle))}</h1>
  	      <p>You are ready for road fuel capture. Leave the vehicle only when your trip or shift is finished.</p>
  	      <div class="fifd-stack">
  	        <div class="fifd-card fifd-current-card" style="--vehicle-accent:${escapeAttr(accent)}">
  	          <div class="fifd-vehicle">
  	            <div class="fifd-vehicle-icon">${icon("vehicle")}</div>
  	            <div>
  	              <strong>${escapeHtml(vehicleName(assignment.vehicle))}</strong>
  	              <span>${escapeHtml(vehicleSubtitle(assignment.vehicle))}</span>
  	              <span class="fifd-badge">Boarded · ${escapeHtml(assignment.slot || "Driver")}</span>
  	            </div>
  	          </div>
  	          <div class="fifd-confirm-grid">
  	            <div><small>Company</small><strong>${escapeHtml(companyName(assignment.company))}</strong></div>
  	            <div><small>${escapeHtml(vehicleMeterProfile(assignment.vehicle).shortLabel)}</small><strong>${escapeHtml(formatVehicleMeter(assignment.vehicle, currentMileage(assignment.vehicle)))}</strong></div>
  	          </div>
  	          <div class="fifd-actions">
  	            <button type="button" class="fifd-btn primary" data-action="start-fuel">${icon("fuel")} Capture Fuel</button>
  	            <button type="button" class="fifd-btn danger" data-action="leave-vehicle">${icon("leave")} Leave Vehicle</button>
  	          </div>
  	        </div>
  	      </div>
  	    </main>`;
  	  }

  	  function renderScanner() {
  	    return `<main class="fifd-main fifd-scan-main">
  	      <span class="fifd-kicker">Board vehicle</span>
  	      <h1>Scan the QR tag</h1>
  	      <p>Hold the steel vehicle tag inside the square. The rear camera reads the vehicle objectId automatically.</p>
  	      <div class="fifd-scanner-frame">
  	        <video data-qr-video autoplay muted playsinline></video>
  	        <div class="fifd-scanner-vignette"></div>
  	        <div class="fifd-scan-box"><i></i><i></i><i></i><i></i></div>
  	        <div class="fifd-scan-line"></div>
  	        <div class="fifd-scanner-tools">
  	          <button type="button" class="fifd-camera-tool" data-action="scanner-torch" aria-pressed="false" hidden>${icon("torch")} <span>Light</span></button>
  	        </div>
  	      </div>
  	      <div class="fifd-scanner-status" data-scanner-status>${escapeHtml(state.scannerStatus || "Starting the rear camera…")}</div>
  	      <div class="fifd-scanner-error ${state.scannerError ? "visible" : ""}" data-scanner-error>${escapeHtml(state.scannerError)}</div>
  	    </main>
  	    <footer class="fifd-footer">
  	      <button type="button" class="fifd-btn" data-action="scanner-cancel">${icon("back")} Cancel</button>
  	      <button type="button" class="fifd-btn secondary" data-action="scanner-retry">${icon("retry")} Try Camera</button>
  	    </footer>`;
  	  }

  	  function renderScanConfirmation() {
  	    const match = state.scannerResult;
  	    if (!match || !match.vehicle || !match.company) {
  	      state.screen = "home";
  	      return renderHome();
  	    }
  	    const availability = freeDriverSlot(match.vehicle, objectIdOf(userRecord()));
  	    const available = !!availability.slot;
  	    const accent = vehicleAccent(match.vehicle);
  	    return `<main class="fifd-main">
  	      <span class="fifd-kicker">QR recognised</span>
  	      <h1>Is this your vehicle?</h1>
  	      <p>Check the vehicle name and registration before boarding.</p>
  	      <section class="fifd-card fifd-current-card fifd-scan-confirm" style="--vehicle-accent:${escapeAttr(accent)}">
  	        <div class="fifd-recognised">Vehicle found in App Data</div>
  	        <div class="fifd-vehicle">
  	          <div class="fifd-vehicle-icon">${icon("vehicle")}</div>
  	          <div><strong>${escapeHtml(vehicleName(match.vehicle))}</strong><span>${escapeHtml(vehicleSubtitle(match.vehicle))}</span></div>
  	        </div>
  	        <div class="fifd-confirm-grid">
  	          <div><small>Company</small><strong>${escapeHtml(companyName(match.company))}</strong></div>
  	          <div><small>Driver position</small><strong>${escapeHtml(available ? availability.slot : "Unavailable")}</strong></div>
  	        </div>
  	        <div class="fifd-code">${escapeHtml(objectIdOf(match.vehicle))}</div>
  	        ${available ? "" : `<div class="fifd-info warn">${escapeHtml(availability.reason || "This vehicle cannot be boarded.")}</div>`}
  	      </section>
  	    </main>
  	    <footer class="fifd-footer">
  	      <button type="button" class="fifd-btn" data-action="scan-again">${icon("camera")} Scan Again</button>
  	      <button type="button" class="fifd-btn ${available ? "good" : ""}" data-action="board-scanned" ${available ? "" : "disabled"}>${icon("check")} Board Vehicle</button>
  	    </footer>`;
  	  }

  	  function renderFuelProgress() {
  	    return `<div class="fifd-progress">${[0,1,2,3,4].map(function (step) {
  	      return `<span class="${step <= state.fuelStep ? "active" : ""}"></span>`;
  	    }).join("")}</div>`;
  	  }

  	  function renderStationStep() {
  	    const company = selectedCompany();
  	    const locations = eligibleFuelLocations(company, state.gps);
  	    if (state.gpsBusy) {
  	      return `<main class="fifd-main">
  	        ${renderFuelProgress()}
  	        <span class="fifd-step-number">1</span>
  	        <section class="fifd-fuel-finder">
  	          <div class="fifd-fuel-spinner" aria-hidden="true"><i></i><i></i><i></i></div>
  	          <h1>Finding fuel stations</h1>
  	          <p>Keep the phone still while GPS checks whether you are inside an approved company fuel location or within ${FUEL_LOCATION_PROXIMITY_M} metres of it.</p>
  	          <div class="fifd-finder-status">${escapeHtml(state.gps ? "Accuracy ±" + formatNumber(state.gps.accuracy, 0) + " m · " + state.gpsSamples + " reading" + (state.gpsSamples === 1 ? "" : "s") : (state.gpsStatus || "Starting precise GPS…"))}</div>
  	        </section>
  	      </main>
  	      ${renderFuelFooter()}`;
  	    }

  	    return `<main class="fifd-main">
  	      ${renderFuelProgress()}
  	      <span class="fifd-step-number">1</span>
  	      <h1>Fuel location</h1>
  	      <p>Company fuel stations are shown only when GPS confirms that you are inside the location or no more than ${FUEL_LOCATION_PROXIMITY_M} metres away.</p>
  	      <div class="fifd-stack">
  	        <div class="fifd-card">
  	          <div class="fifd-gps">
  	            <div class="fifd-gps-icon">${icon("location")}</div>
  	            <div><strong>${state.gps ? "GPS check complete" : "GPS position unavailable"}</strong><span>${state.gps ? "Accuracy ±" + formatNumber(state.gps.accuracy, 0) + " m · " + (state.gpsStatus || "Position checked") : (state.gpsStatus || "Only Other is available until GPS succeeds.")}</span></div>
  	          </div>
  	          <div class="fifd-actions">
  	            <button type="button" class="fifd-btn ${locations.length ? "good" : "primary"}" data-action="gps">${icon("location")} Try GPS Again</button>
  	          </div>
  	          ${state.gpsError ? `<div class="fifd-info warn">${escapeHtml(state.gpsError)}</div>` : ""}
  	        </div>
  	      </div>
  	      <div class="fifd-location-list">
  	        ${locations.map(function (location) {
  	          const selected = state.selectedFuelLocationKey === location.key;
  	          const proximityText = location.inside ? "You are inside this location" : Math.round(location.distanceMeters) + " m from the location";
  	          return `<button type="button" class="fifd-option ${selected ? "is-selected" : ""}" data-fuel-location="${escapeAttr(location.key)}">
  	            <span class="fifd-option-icon">${icon("fuel")}</span>
  	            <span class="fifd-option-body"><strong>${escapeHtml(location.name)}</strong><span>${escapeHtml(proximityText + " · GPS verified")}</span></span>
  	            <span class="fifd-option-side">${selected ? "Selected" : "Choose"}</span>
  	          </button>`;
  	        }).join("")}
  	        ${!locations.length ? `<div class="fifd-info warn">No approved company fuel location was detected within ${FUEL_LOCATION_PROXIMITY_M} metres. Select Other or retry GPS.</div>` : ""}
  	        <button type="button" class="fifd-option ${state.selectedFuelLocationKey === "__other__" ? "is-selected" : ""}" data-fuel-location="__other__">
  	          <span class="fifd-option-icon">${icon("location")}</span>
  	          <span class="fifd-option-body"><strong>Other fuel station</strong><span>Use this for an external or unlisted supplier.</span></span>
  	          <span class="fifd-option-side">${state.selectedFuelLocationKey === "__other__" ? "Selected" : "Choose"}</span>
  	        </button>
  	      </div>
  	      ${state.selectedFuelLocationKey === "__other__" ? `<label class="fifd-field"><span>Fuel station or supplier</span><input class="fifd-input" name="OtherSupplier" value="${escapeAttr(state.otherSupplier)}" placeholder="Type the name" autocomplete="organization"><small>Example: Shell Harrismith</small></label>` : ""}
  	    </main>
  	    ${renderFuelFooter()}`;
  	  }

  	  function renderMileageStep() {
  	    const vehicle = selectedVehicle();
  	    const profile = vehicleMeterProfile(vehicle);
  	    const current = currentMileage(vehicle);
  	    const maximum = profile.kind === "distance" ? maximumMileage(vehicle) : null;
  	    const currentHelp = current === null
  	      ? "No previous operating meter reading is loaded."
  	      : "Current saved reading is " + formatVehicleMeter(vehicle, current) + (maximum === null ? "." : ". Maximum allowed now is " + formatVehicleMeter(vehicle, maximum) + ".");
  	    return `<main class="fifd-main">
  	      ${renderFuelProgress()}
  	      <span class="fifd-step-number">2</span>
  	      <h1>${escapeHtml(profile.heading)}</h1>
  	      <p>Look at the vehicle dashboard and type the operating meter reading shown.</p>
  	      <label class="fifd-field">
  	        <span>${escapeHtml(profile.fieldLabel)}</span>
  	        <input class="fifd-input" name="Mileage" type="number" inputmode="decimal" step="${escapeAttr(profile.step)}" min="0" value="${escapeAttr(state.mileage)}" placeholder="${escapeAttr(profile.placeholder)}" autofocus>
  	        <small>${escapeHtml(currentHelp)}</small>
  	      </label>
  	      <div class="fifd-info">Do not estimate. Enter the exact number displayed by the vehicle.</div>
  	    </main>
  	    ${renderFuelFooter()}`;
  	  }

  	  function renderAmountStep() {
  	    const vehicle = selectedVehicle();
  	    const capacity = tankCapacity(vehicle);
  	    const calculation = fuelCalculation();
  	    return `<main class="fifd-main">
  	      ${renderFuelProgress()}
  	      <span class="fifd-step-number">3</span>
  	      <h1>Fuel amount</h1>
  	      <p>Type the litres and the total amount shown on the slip or pump.</p>
  	      <div class="fifd-money-grid">
  	        <label class="fifd-field"><span>Litres</span><input class="fifd-input" name="Litres" type="number" inputmode="decimal" step="0.001" min="0" value="${escapeAttr(state.litres)}" placeholder="0.00"><small>${escapeHtml(capacity && capacity > 0 ? "Tank capacity: " + formatNumber(capacity, 1) + " L" : "Enter the litres delivered.")}</small></label>
  	        <label class="fifd-field"><span>Total amount in rand</span><input class="fifd-input" name="TotalCost" type="number" inputmode="decimal" step="0.01" min="0" value="${escapeAttr(state.totalCost)}" placeholder="0.00"><small>Enter the final total paid.</small></label>
  	      </div>
  	      <label class="fifd-field"><span>Receipt number — optional</span><input class="fifd-input" name="Reference" type="text" inputmode="text" value="${escapeAttr(state.reference)}" placeholder="Slip or invoice number"></label>
  	      ${calculation ? `<div class="fifd-info good"><strong>${escapeHtml(formatNumber(calculation.litres, 3) + " L")}</strong> at approximately <strong>${escapeHtml(formatMoney(calculation.costPerLitre) + " per litre")}</strong>. Total <strong>${escapeHtml(formatMoney(calculation.cost))}</strong>.</div>` : `<div class="fifd-info">The price per litre is calculated automatically.</div>`}
  	    </main>
  	    ${renderFuelFooter()}`;
  	  }

  	  function renderFuelPhotoCard(kind, title, description) {
  	    const photo = fuelPhotoState(kind);
  	    const actionPrefix = kind === "odometer" ? "odometer" : "slip";
  	    const sizeText = photo
  	      ? formatBytes(photo.originalBytes) + " → " + formatBytes(photo.compressedBytes)
  	      : "";

  	    return `<section class="fifd-photo-card">
  	      <div class="fifd-photo-copy">
  	        <strong>${escapeHtml(title)}</strong>
  	        <span>${escapeHtml(description)}</span>
  	      </div>
  	      ${photo ? `<img class="fifd-photo-preview" src="${escapeAttr(photo.previewUrl)}" alt="${escapeAttr(title + " preview")}">` : ""}
  	      ${photo ? `<div class="fifd-photo-status"><span>Photo ready</span><span>${escapeHtml(sizeText)}</span></div>` : ""}
  	      <div class="fifd-photo-actions ${photo ? "has-photo" : ""}">
  	        <button type="button" class="fifd-btn ${photo ? "" : "primary"}" data-action="take-${escapeAttr(actionPrefix)}-photo">${icon("camera")} ${photo ? "Retake" : "Take Photo"}</button>
  	        ${photo ? `<button type="button" class="fifd-btn danger" data-action="remove-${escapeAttr(actionPrefix)}-photo">Remove</button>` : ""}
  	      </div>
  	      <input
  	        class="fifd-photo-input"
  	        type="file"
  	        accept="image/*"
  	        capture="environment"
  	        data-photo-input="${escapeAttr(kind)}"
  	        aria-label="${escapeAttr("Take " + title.toLowerCase())}">
  	    </section>`;
  	  }

  	  function renderPhotoStep() {
  	    const vehicle = selectedVehicle();
  	    const profile = vehicleMeterProfile(vehicle);
  	    const readingLabel = profile.kind === "hours" ? "Vehicle meter photo" : "Odometer photo";
  	    const readingDescription = profile.kind === "hours"
  	      ? "Optional. Photograph the dashboard showing " + formatVehicleMeter(vehicle, state.mileage) + "."
  	      : "Optional. Photograph the odometer showing " + formatVehicleMeter(vehicle, state.mileage) + ".";

  	    return `<main class="fifd-main">
  	      ${renderFuelProgress()}
  	      <span class="fifd-step-number">4</span>
  	      <h1>Photos</h1>
  	      <p>Both photos are optional. The phone will compress them automatically before upload.</p>
  	      <div class="fifd-photo-grid">
  	        ${renderFuelPhotoCard("slip", "Fuel slip photo", "Optional. Take a clear photo of the fuel slip or receipt.")}
  	        ${renderFuelPhotoCard("odometer", readingLabel, readingDescription)}
  	      </div>
  	      <div class="fifd-info">You can continue with no photos, one photo or both. Photos never prevent the fuel transaction from saving.</div>
  	    </main>
  	    ${renderFuelFooter()}`;
  	  }

  	  function renderReviewStep() {
  	    const vehicle = selectedVehicle();
  	    const location = selectedFuelLocation();
  	    const calculation = fuelCalculation();
  	    const photoCount = (state.slipPhoto ? 1 : 0) + (state.odometerPhoto ? 1 : 0);
  	    return `<main class="fifd-main">
  	      ${renderFuelProgress()}
  	      <span class="fifd-step-number">5</span>
  	      <h1>Check and save</h1>
  	      <p>Check the details. Tap Save Fuel only once.</p>
  	      <div class="fifd-card" style="margin-top:18px">
  	        <div class="fifd-vehicle">
  	          <div class="fifd-vehicle-icon">${icon("vehicle")}</div>
  	          <div><strong>${escapeHtml(vehicleName(vehicle))}</strong><span>${escapeHtml(vehicleSubtitle(vehicle))}</span></div>
  	        </div>
  	        <div class="fifd-review">
  	          <div class="fifd-review-row"><span>Fuel station</span><strong>${escapeHtml(fuelSupplierName())}</strong></div>
  	          <div class="fifd-review-row"><span>GPS</span><strong>${escapeHtml(location ? (location.inside ? "Inside approved location" : Math.round(location.distanceMeters) + " m from location") : state.gps ? "Other · GPS captured" : "Other")}</strong></div>
  	          <div class="fifd-review-row"><span>${escapeHtml(vehicleMeterProfile(vehicle).shortLabel)}</span><strong>${escapeHtml(formatVehicleMeter(vehicle, state.mileage))}</strong></div>
  	          <div class="fifd-review-row"><span>Litres</span><strong>${escapeHtml(calculation ? formatNumber(calculation.litres, 3) + " L" : "—")}</strong></div>
  	          <div class="fifd-review-row"><span>Total</span><strong>${escapeHtml(calculation ? formatMoney(calculation.cost) : "—")}</strong></div>
  	          <div class="fifd-review-row"><span>Receipt</span><strong>${escapeHtml(clean(state.reference) || "Not supplied")}</strong></div>
  	          <div class="fifd-review-row"><span>Photos</span><strong>${escapeHtml(photoCount ? photoCount + " attached" : "None — optional")}</strong></div>
  	        </div>
  	        ${photoCount ? `<div class="fifd-review-photos">
  	          ${state.slipPhoto ? `<div class="fifd-review-photo"><img src="${escapeAttr(state.slipPhoto.previewUrl)}" alt="Fuel slip preview"><span>Fuel slip</span></div>` : ""}
  	          ${state.odometerPhoto ? `<div class="fifd-review-photo"><img src="${escapeAttr(state.odometerPhoto.previewUrl)}" alt="Odometer preview"><span>${escapeHtml(vehicleMeterProfile(vehicle).kind === "hours" ? "Vehicle meter" : "Odometer")}</span></div>` : ""}
  	        </div>` : ""}
  	      </div>
  	    </main>
  	    ${renderFuelFooter(true)}`;
  	  }

  	  function renderFuelFooter(saveMode) {
  	    const disabled = state.saving || (state.fuelStep === 0 && state.gpsBusy);
  	    return `<footer class="fifd-footer">
  	      <button type="button" class="fifd-btn" data-action="fuel-back">${icon("back")} Back</button>
  	      <button type="button" class="fifd-btn primary" data-action="${saveMode ? "save-fuel" : "fuel-next"}" ${disabled ? "disabled" : ""}>${saveMode ? icon("check") + " Save Fuel" : state.gpsBusy ? "Finding Stations…" : "Continue"}</button>
  	    </footer>`;
  	  }

  	  function renderFuel() {
  	    if (state.fuelStep === 0) return renderStationStep();
  	    if (state.fuelStep === 1) return renderMileageStep();
  	    if (state.fuelStep === 2) return renderAmountStep();
  	    if (state.fuelStep === 3) return renderPhotoStep();
  	    return renderReviewStep();
  	  }

  	  function renderSuccess() {
  	    const success = state.success;
  	    return `<main class="fifd-main">
  	      <div class="fifd-success">
  	        <div class="fifd-success-icon">${icon("check")}</div>
  	        <span class="fifd-kicker">Saved</span>
  	        <h1>Fuel captured</h1>
  	        <p>${escapeHtml(success ? formatNumber(success.litres, 3) + " litres for " + vehicleName(success.vehicle) + " at " + success.supplier + "." : "The fuel record was saved.")}</p>
  	        <div class="fifd-card" style="margin-top:22px">
  	          <div class="fifd-review-row"><span>Total amount</span><strong>${escapeHtml(success ? formatMoney(success.cost) : "—")}</strong></div>
  	          <div class="fifd-review-row"><span>Current vehicle</span><strong>${escapeHtml(success ? vehicleName(success.vehicle) : "—")}</strong></div>
  	          <div class="fifd-review-row"><span>Photos uploaded</span><strong>${escapeHtml(success ? String(numberOr(success.photoUploadedCount, 0)) : "0")}</strong></div>
  	        </div>
  	        ${success && arr(success.photoWarnings).length ? `<div class="fifd-info warn">${escapeHtml("Fuel was saved safely. " + arr(success.photoWarnings).join(" "))}</div>` : ""}
  	        <div class="fifd-actions" style="margin-top:18px">
  	          <button type="button" class="fifd-btn primary" data-action="capture-another">${icon("fuel")} Capture Another</button>
  	          <button type="button" class="fifd-btn" data-action="home">Back to Vehicle</button>
  	        </div>
  	      </div>
  	    </main>`;
  	  }

  	  function renderBody() {
  	    if (state.screen === "scanner") return renderScanner();
  	    if (state.screen === "scan-confirm") return renderScanConfirmation();
  	    if (state.screen === "fuel") return renderFuel();
  	    if (state.screen === "success") return renderSuccess();
  	    return renderHome();
  	  }

  	  function render() {
  	    if (state.destroyed) return;
  	    if (state.screen !== "scanner" && qrRuntime.active) stopQrScanner();
  	    const root = document.getElementById(ROOT_ID);
  	    if (!root) return;
  	    root.innerHTML = `<div class="fifd-shell">${renderHeader()}${renderBody()}</div>`;
  	    bindEvents(root);
  	  }

  	  function updateDraftFromInput(input) {
  	    if (!input || !input.name) return;
  	    if (input.name === "OtherSupplier") state.otherSupplier = input.value;
  	    if (input.name === "Mileage") state.mileage = input.value;
  	    if (input.name === "Litres") state.litres = input.value;
  	    if (input.name === "TotalCost") state.totalCost = input.value;
  	    if (input.name === "Reference") state.reference = input.value;
  	  }

  	  function bindEvents(root) {
  	    root.querySelectorAll("input").forEach(function (input) {
  	      input.addEventListener("input", function () { updateDraftFromInput(input); });
  	      input.addEventListener("change", function () { updateDraftFromInput(input); });
  	    });

  	    root.querySelectorAll("[data-fuel-location]").forEach(function (button) {
  	      button.addEventListener("click", async function () {
  	        const key = button.getAttribute("data-fuel-location") || "";
  	        if (key !== "__other__") {
  	          const allowed = eligibleFuelLocations(selectedCompany(), state.gps).some(function (location) { return location.key === key; });
  	          if (!allowed) {
  	            await showDialog({ title: "Fuel station locked", message: "You must be inside this company fuel location or within " + FUEL_LOCATION_PROXIMITY_M + " metres of it.", confirmText: "Close", hideCancel: true, danger: true });
  	            return;
  	          }
  	        }
  	        state.selectedFuelLocationKey = key;
  	        render();
  	      });
  	    });

  	    root.querySelectorAll("[data-photo-input]").forEach(function (input) {
  	      input.addEventListener("change", async function () {
  	        const kind = clean(input.getAttribute("data-photo-input"));
  	        const file = input.files && input.files[0] ? input.files[0] : null;
  	        if (!file) return;
  	        await setFuelPhoto(kind, file);
  	      });
  	    });

  	    root.querySelectorAll("[data-action]").forEach(function (button) {
  	      button.addEventListener("click", async function () {
  	        const action = button.getAttribute("data-action") || "";
  	        if (action === "logout") {
  	          handleLogoutButton();
  	          return;
  	        }
  	        if (action === "scan-vehicle") {
  	          await openQrScanner();
  	          return;
  	        }
  	        if (action === "scanner-cancel") {
  	          stopQrScanner();
  	          state.screen = "home";
  	          state.scannerError = "";
  	          state.qrAuthorisedVehicleId = "";
  	          state.qrAuthorisedAt = 0;
  	          render();
  	          return;
  	        }
  	        if (action === "scanner-retry") {
  	          await startQrScanner();
  	          return;
  	        }
  	        if (action === "scanner-torch") {
  	          await toggleScannerTorch();
  	          return;
  	        }
  	        if (action === "scan-again") {
  	          await openQrScanner();
  	          return;
  	        }
  	        if (action === "board-scanned") {
  	          const match = state.scannerResult;
  	          if (!match || !match.vehicle || !match.company) return;
  	          const existing = state.assignment || findAssignment();
  	          if (existing && objectIdOf(existing.vehicle) !== objectIdOf(match.vehicle)) {
  	            await showDialog({ title: "Already on another vehicle", message: "Leave " + vehicleName(existing.vehicle) + " before boarding another vehicle.", confirmText: "Close", hideCancel: true, danger: true });
  	            return;
  	          }
  	          const approved = await showDialog({
  	            title: "Board " + vehicleName(match.vehicle) + "?",
  	            message: "This QR tag matches the vehicle shown. Your account and the current ViewC driver position will be updated.",
  	            confirmText: "YES  BOARD VEHICLE",
  	            cancelText: "SCAN AGAIN"
  	          });
  	          if (!approved) {
  	            await openQrScanner();
  	            return;
  	          }
  	          showOperation("Boarding vehicle…", "Saving your current vehicle and driver position.");
  	          try {
  	            await boardVehicle(match.company, match.vehicle);
  	            state.scannerResult = null;
  	            closeOperation();
  	          } catch (error) {
  	            closeOperation();
  	            await showDialog({ title: "Vehicle not boarded", message: clean(error && error.message) || "The vehicle relationship could not be saved.", confirmText: "Close", hideCancel: true, danger: true });
  	          }
  	          return;
  	        }
  	        if (action === "home") {
  	          state.screen = "home";
  	          state.fuelStep = 0;
  	          render();
  	          return;
  	        }
  	        if (action === "start-fuel") {
  	          const assignment = state.assignment || findAssignment();
  	          if (!assignment) return;
  	          state.assignment = assignment;
  	          state.selectedCompanyId = objectIdOf(assignment.company);
  	          state.selectedVehicleId = objectIdOf(assignment.vehicle);
  	          resetFuelDraft(assignment.vehicle);
  	          state.screen = "fuel";
  	          render();
  	          requestGps();
  	          try {
  	            state.assignment = await ensureAssignmentRelations(assignment);
  	          } catch (error) {
  	            stopGpsWatch();
  	            state.screen = "home";
  	            render();
  	            await showDialog({ title: "Fuel capture cannot open", message: clean(error && error.message) || "The vehicle boarding relationship is incomplete.", confirmText: "Close", hideCancel: true, danger: true });
  	          }
  	          return;
  	        }
  	        if (action === "capture-another") {
  	          resetFuelDraft(selectedVehicle());
  	          state.screen = "fuel";
  	          render();
  	          requestGps();
  	          return;
  	        }
  	        if (action === "gps") {
  	          await requestGps();
  	          return;
  	        }
  	        if (action === "take-slip-photo" || action === "take-odometer-photo") {
  	          const kind = action === "take-odometer-photo" ? "odometer" : "slip";
  	          const input = root.querySelector("[data-photo-input='" + kind + "']");
  	          if (input) {
  	            input.value = "";
  	            input.click();
  	          }
  	          return;
  	        }
  	        if (action === "remove-slip-photo" || action === "remove-odometer-photo") {
  	          clearFuelPhoto(action === "remove-odometer-photo" ? "odometer" : "slip");
  	          render();
  	          return;
  	        }
  	        if (action === "leave-vehicle") {
  	          const assignment = state.assignment || findAssignment();
  	          if (!assignment) return;
  	          const approved = await showDialog({
  	            title: "Leave " + vehicleName(assignment.vehicle) + "?",
  	            message: "You will be removed from the vehicle and its current driver position. Fuel capture will close.",
  	            confirmText: "Leave Vehicle",
  	            danger: true
  	          });
  	          if (!approved) return;
  	          showOperation("Leaving vehicle…", "Removing both vehicle relationships.");
  	          try {
  	            await leaveVehicle();
  	            closeOperation();
  	          } catch (error) {
  	            closeOperation();
  	            await showDialog({ title: "Vehicle not cleared", message: clean(error && error.message) || "The vehicle relationship could not be removed.", confirmText: "Close", hideCancel: true, danger: true });
  	          }
  	          return;
  	        }
  	        if (action === "fuel-back") {
  	          if (state.fuelStep > 0) {
  	            state.fuelStep -= 1;
  	            render();
  	          } else {
  	            state.screen = "home";
  	            render();
  	          }
  	          return;
  	        }
  	        if (action === "fuel-next") {
  	          const error = validateFuelStep(state.fuelStep);
  	          if (error) {
  	            await showDialog({ title: "Check this step", message: error, confirmText: "Fix It", hideCancel: true, danger: true });
  	            return;
  	          }
  	          state.fuelStep = Math.min(4, state.fuelStep + 1);
  	          render();
  	          return;
  	        }
  	        if (action === "save-fuel") {
  	          const error = [0,1,2].map(validateFuelStep).find(Boolean);
  	          if (error) {
  	            await showDialog({ title: "Check the fuel details", message: error, confirmText: "Fix It", hideCancel: true, danger: true });
  	            return;
  	          }
  	          state.saving = true;
  	          showOperation("Saving fuel…", "Please keep this page open. Do not tap Save again.");
  	          try {
  	            await saveFuel();
  	            state.saving = false;
  	            closeOperation();
  	          } catch (saveError) {
  	            state.saving = false;
  	            closeOperation();
  	            await showDialog({ title: "Fuel was not completed", message: clean(saveError && saveError.message) || "The fuel record could not be saved.", confirmText: "Close", hideCancel: true, danger: true });
  	            render();
  	          }
  	        }
  	      });
  	    });
  	  }

  	  function destroy() {
  	    if (state.destroyed) return;
  	    stopGpsWatch();
  	    stopQrScanner();
  	    clearFuelPhotos();
  	    if (flespiMileageRuntime.controller) {
  	      try { flespiMileageRuntime.controller.abort(); } catch (_) {}
  	    }
  	    closeAppMenu();
  	    state.destroyed = true;
  	    document.getElementById(ROOT_ID)?.remove();
  	    document.getElementById(DIALOG_ID)?.remove();
  	    document.getElementById(OPERATION_ID)?.remove();
  	    document.getElementById(STYLE_ID)?.remove();
  	    document.getElementById(V104_STYLE_ID)?.remove();
  	    document.getElementById(V108_STYLE_ID)?.remove();
  	    document.body.style.overflow = state.previousBodyOverflow;
  	    try {
  	      if (window[PUBLIC_KEY] && window[PUBLIC_KEY].version === VERSION) delete window[PUBLIC_KEY];
  	    } catch (_) {}
  	  }

  	  if (!APP_DATA || !userRecord()) {
  	    removeExisting();
  	    injectStyles();
  	    injectV104Styles();
  	    injectV108Styles();
  	    const root = document.createElement("div");
  	    root.id = ROOT_ID;
  	    root.innerHTML = `<div class="fifd-shell">${renderHeader()}<main class="fifd-main"><div class="fifd-card fifd-empty"><div class="fifd-option-icon">${icon("warning")}</div><h2>Driver data unavailable</h2><p>App Data.User was not supplied. This driver workspace cannot safely continue.</p></div></main></div>`;
  	    document.body.appendChild(root);
  	    return { ok: false, version: VERSION, reason: "App Data.User not found" };
  	  }

  	  if (!DB) {
  	    removeExisting();
  	    injectStyles();
  	    injectV104Styles();
  	    injectV108Styles();
  	    const root = document.createElement("div");
  	    root.id = ROOT_ID;
  	    root.innerHTML = `<div class="fifd-shell">${renderHeader()}<main class="fifd-main"><div class="fifd-card fifd-empty"><div class="fifd-option-icon">${icon("warning")}</div><h2>Database unavailable</h2><p>Backendless was not supplied. Boarding and fuel capture cannot be saved.</p></div></main></div>`;
  	    document.body.appendChild(root);
  	    return { ok: false, version: VERSION, reason: "Backendless not found" };
  	  }

  	  removeExisting();
  	  injectStyles();
  	  injectV104Styles();
  	  injectV108Styles();
  	  state.previousBodyOverflow = document.body.style.overflow;
  	  document.body.style.overflow = "hidden";

  	  const root = document.createElement("div");
  	  root.id = ROOT_ID;
  	  root.__destroy = destroy;
  	  mountHost().appendChild(root);

  	  state.assignment = findAssignment();
  	  if (state.assignment) {
  	    state.selectedCompanyId = objectIdOf(state.assignment.company);
  	    state.selectedVehicleId = objectIdOf(state.assignment.vehicle);
  	  } else if (companyRows().length === 1) {
  	    state.selectedCompanyId = objectIdOf(companyRows()[0]);
  	  }

  	  window[PUBLIC_KEY] = {
  	    version: VERSION,
  	    rootId: ROOT_ID,
  	    render: render,
  	    destroy: destroy,
  	    getState: function () {
  	      return {
  	        screen: state.screen,
  	        fuelStep: state.fuelStep,
  	        selectedCompanyId: state.selectedCompanyId,
  	        selectedVehicleId: state.selectedVehicleId,
  	        assignment: state.assignment,
  	        scannerResult: state.scannerResult,
  	        scannerActive: qrRuntime.active,
  	        gps: state.gps,
  	        selectedFuelLocationKey: state.selectedFuelLocationKey,
  	        hasSlipPhoto: !!state.slipPhoto,
  	        hasOdometerPhoto: !!state.odometerPhoto
  	      };
  	    },
  	    refreshAssignment: function () {
  	      state.assignment = findAssignment();
  	      render();
  	      return state.assignment;
  	    },
  	    scanVehicle: openQrScanner,
  	    stopScanner: stopQrScanner,
  	    requestGps: requestGps,
  	    stopGps: stopGpsWatch,
  	    leave: leaveVehicle,
  	    logout: logoutUser,
  	    startFuel: async function () {
  	      const assignment = state.assignment || findAssignment();
  	      if (!assignment) return false;
  	      state.assignment = assignment;
  	      state.selectedCompanyId = objectIdOf(assignment.company);
  	      state.selectedVehicleId = objectIdOf(assignment.vehicle);
  	      resetFuelDraft(assignment.vehicle);
  	      state.screen = "fuel";
  	      render();
  	      requestGps();
  	      state.assignment = await ensureAssignmentRelations(assignment);
  	      return true;
  	    }
  	  };

  	  render();

  	  return {
  	    ok: true,
  	    version: VERSION,
  	    rootId: ROOT_ID,
  	    assignment: state.assignment,
  	    destroy: destroy
  	  };
  	})();

  })(___arguments.context.appData, 'data:image/png;base64,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');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Snapshot/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await (async function(App) {
  	return await (async function FIFSnapshotMobileV2_8_0(App) {
  	  "use strict";

  	  const VERSION = "2.8.1-dashboard-period-parity";
  	  const REFRESH_MS = 30 * 1000;
  	  const ATG_STALE_MS = 15 * 60 * 1000;
  	  const ROOT_ID = "fif-snapshot-mobile-root";
  	  const STYLE_ID = "fif-snapshot-mobile-style";
  	  const STATE_KEY = "__FIF_SNAPSHOT_MOBILE_STATE__";
  	  const ALL = "__ALL__";
  	  const APP_MENU_ID = "fif-snapshot-app-switcher";
  	  const DIALOG_ID = "fif-snapshot-dialog";
  	  const LOGOUT_GUARD_KEY = "__FIF_LOGOUT_GUARD_V1__";

  	  const AppData = App || {};
  	  let snapshotUser = AppData.User || {};
  	  let companies = Array.isArray(snapshotUser.Companies) ? snapshotUser.Companies.filter(Boolean) : [];

  	  function resolveBackendless() {
  	    const candidates = [
  	      typeof Backendless !== "undefined" ? Backendless : null,
  	      typeof window !== "undefined" ? window.Backendless : null,
  	      AppData && AppData.Backendless,
  	      AppData && AppData.backendless
  	    ];
  	    return candidates.find(function (item) {
  	      return item && item.Data && typeof item.Data.of === "function";
  	    }) || null;
  	  }

  	  const DB = resolveBackendless();

  	  function arr(v) { return Array.isArray(v) ? v : []; }
  	  function n(v, fallback) {
  	    const x = Number(v);
  	    return Number.isFinite(x) ? x : (fallback == null ? 0 : fallback);
  	  }
  	  function hasNumber(v) { return v !== null && v !== "" && Number.isFinite(Number(v)); }
  	  function text(v, fallback) {
  	    const s = v == null ? "" : String(v).trim();
  	    return s || (fallback == null ? "" : String(fallback));
  	  }
  	  function esc(v) {
  	    return String(v == null ? "" : v)
  	      .replace(/&/g, "&amp;")
  	      .replace(/</g, "&lt;")
  	      .replace(/>/g, "&gt;")
  	      .replace(/"/g, "&quot;")
  	      .replace(/'/g, "&#039;");
  	  }
  	  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  	  function sum(list, fn) {
  	    return arr(list).reduce(function (total, item, index) {
  	      return total + n(fn ? fn(item, index) : item, 0);
  	    }, 0);
  	  }
  	  function formatNumber(v, decimals) {
  	    const d = decimals == null ? 0 : decimals;
  	    if (!Number.isFinite(Number(v))) return "—";
  	    return Number(v).toLocaleString("en-ZA", {
  	      minimumFractionDigits: d,
  	      maximumFractionDigits: d
  	    });
  	  }
  	  function formatCompact(v, decimals) {
  	    const x = n(v, 0);
  	    const d = decimals == null ? 0 : decimals;
  	    if (Math.abs(x) >= 1000000) return formatNumber(x / 1000000, 1) + "m";
  	    if (Math.abs(x) >= 10000) return formatNumber(x / 1000, 1) + "k";
  	    return formatNumber(x, d);
  	  }
  	  function formatRand(v, decimals) {
  	    return "R " + formatNumber(v, decimals == null ? 0 : decimals);
  	  }
  	  function pad2(v) { return String(v).padStart(2, "0"); }
  	  function currentMonthKey() {
  	    const d = new Date();
  	    return d.getFullYear() + "-" + pad2(d.getMonth() + 1);
  	  }
  	  function currentMonthLabel() {
  	    return new Date().toLocaleDateString("en-ZA", { month: "long", year: "numeric" });
  	  }
  	  function elapsedDaysThisMonth() {
  	    const d = new Date();
  	    return Math.max(1, d.getDate());
  	  }
  	  function asEpochMs(v) {
  	    if (v == null || v === "") return 0;
  	    if (typeof v === "number") return v < 100000000000 ? v * 1000 : v;
  	    if (/^\d+(\.\d+)?$/.test(String(v).trim())) {
  	      const q = Number(v);
  	      return q < 100000000000 ? q * 1000 : q;
  	    }
  	    const p = Date.parse(v);
  	    return Number.isFinite(p) ? p : 0;
  	  }
  	  function ageLabel(ms) {
  	    if (!ms) return "No recent fix";
  	    const age = Math.max(0, Date.now() - ms);
  	    if (age < 60000) return "Just now";
  	    if (age < 3600000) return Math.round(age / 60000) + " min ago";
  	    if (age < 86400000) return Math.round(age / 3600000) + " h ago";
  	    return Math.round(age / 86400000) + " d ago";
  	  }
  	  function pct(v) { return clamp(n(v, 0), 0, 100); }
  	  function clockLabel(ms) {
  	    if (!ms) return "Not refreshed yet";
  	    try {
  	      return new Date(ms).toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit" });
  	    } catch (_) {
  	      return "Updated";
  	    }
  	  }


  	  /* =========================================================
  	     SNAPSHOT DATA HELPERS

  	     Fast reporting data is persisted by the Cloudflare Worker on:
  	       Tractor.ViewC.Snapshot.current
  	       Tractor.ViewC.Snapshot.today
  	       Tractor.ViewC.Snapshot.yesterday
  	       Tractor.ViewC.Snapshot.monthly

  	     Full historical reports remain in R2; this UI does not download them.
  	     ========================================================= */

  	  function vehicleCurrentView(vehicle) {
  	    if (!vehicle) return null;

  	    const value = vehicle.ViewC;

  	    if (value && typeof value === "object" && !Array.isArray(value)) {
  	      return value;
  	    }

  	    if (Array.isArray(value) && value.length) {
  	      const first = value[0];
  	      return first && typeof first === "object" ? first : null;
  	    }

  	    return null;
  	  }

  	  function parseJsonObject(value) {
  	    if (value && typeof value === "object" && !Array.isArray(value)) {
  	      return value;
  	    }

  	    if (typeof value === "string" && value.trim()) {
  	      try {
  	        const parsed = JSON.parse(value);
  	        return parsed && typeof parsed === "object" && !Array.isArray(parsed)
  	          ? parsed
  	          : null;
  	      } catch (_) {
  	        return null;
  	      }
  	    }

  	    return null;
  	  }

  	  function vehicleSnapshotContainer(vehicle) {
  	    const view = vehicleCurrentView(vehicle);
  	    if (!view) return {};

  	    return (
  	      parseJsonObject(view.Snapshot) ||
  	      parseJsonObject(view.snapshot) ||
  	      {}
  	    );
  	  }

  	  /*
  	   * Naming compatibility:
  	   * buildSnapshot historically calls today's summary "current",
  	   * yesterday's summary "daily", and the month summary "monthly".
  	   * Keep those helper names so the rest of the dashboard stays stable.
  	   */
  	  function vehicleCurrentReport(vehicle) {
  	    const snapshot = vehicleSnapshotContainer(vehicle);
  	    const report = snapshot.today || snapshot.Today;
  	    return report && typeof report === "object" && !Array.isArray(report) && report.available !== false
  	      ? report
  	      : null;
  	  }

  	  function vehicleDailyReport(vehicle) {
  	    const snapshot = vehicleSnapshotContainer(vehicle);
  	    const report = snapshot.yesterday || snapshot.Yesterday;
  	    return report && typeof report === "object" && !Array.isArray(report) && report.available !== false
  	      ? report
  	      : null;
  	  }

  	  function vehicleMonthlyReport(vehicle) {
  	    const snapshot = vehicleSnapshotContainer(vehicle);
  	    const report = snapshot.monthly || snapshot.Monthly;
  	    return report && typeof report === "object" && !Array.isArray(report)
  	      ? report
  	      : null;
  	  }

  	  function vehicleLiveSnapshot(vehicle) {
  	    const snapshot = vehicleSnapshotContainer(vehicle);
  	    const current = snapshot.current || snapshot.Current;
  	    return current && typeof current === "object" && !Array.isArray(current)
  	      ? current
  	      : null;
  	  }

  	  function monthlyReportSummary(report) {
  	    /*
  	     * Snapshot.monthly is already the compact monthly summary.
  	     * Keep compatibility with any older cached monthly_report shape.
  	     */
  	    if (!report || typeof report !== "object" || Array.isArray(report)) return {};

  	    const nested = report.monthly_summary;
  	    return nested && typeof nested === "object" && !Array.isArray(nested)
  	      ? nested
  	      : report;
  	  }

  	  function reportTodayKey(vehicle) {
  	    const snapshot = vehicleSnapshotContainer(vehicle);
  	    const current = vehicleCurrentReport(vehicle);

  	    return text(
  	      (current && (current.date || current.report_date)) ||
  	      snapshot.report_date ||
  	      "",
  	      ""
  	    );
  	  }

  	  function reportDateKey(vehicle) {
  	    const daily = vehicleDailyReport(vehicle);
  	    return text(daily && (daily.date || daily.report_date), "");
  	  }

  	  function reportMonthKey(vehicle) {
  	    const monthly = vehicleMonthlyReport(vehicle);
  	    return text(monthly && (monthly.month || monthly.report_month), "");
  	  }

  	  function reportAvailability(vehicle, type) {
  	    const snapshot = vehicleSnapshotContainer(vehicle);
  	    const freshness =
  	      snapshot.freshness &&
  	      typeof snapshot.freshness === "object" &&
  	      !Array.isArray(snapshot.freshness)
  	        ? snapshot.freshness
  	        : {};

  	    if (type === "current") {
  	      if (typeof freshness.today_available === "boolean") {
  	        return freshness.today_available;
  	      }
  	      return !!vehicleCurrentReport(vehicle);
  	    }

  	    if (type === "daily") {
  	      if (typeof freshness.yesterday_available === "boolean") {
  	        return freshness.yesterday_available;
  	      }
  	      return !!vehicleDailyReport(vehicle);
  	    }

  	    if (typeof freshness.monthly_available === "boolean") {
  	      return freshness.monthly_available;
  	    }

  	    return !!vehicleMonthlyReport(vehicle);
  	  }

  	  function monthLabelFromKey(key) {
  	    const match = /^(\d{4})-(\d{2})$/.exec(text(key, ""));
  	    if (!match) return currentMonthLabel();
  	    const d = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1, 12));
  	    return d.toLocaleDateString("en-ZA", {
  	      timeZone: "Africa/Johannesburg",
  	      month: "long",
  	      year: "numeric"
  	    });
  	  }

  	  function dateLabelFromKey(key) {
  	    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text(key, ""));
  	    if (!match) return "Previous day";
  	    const d = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12));
  	    return d.toLocaleDateString("en-ZA", {
  	      timeZone: "Africa/Johannesburg",
  	      day: "2-digit",
  	      month: "short",
  	      year: "numeric"
  	    });
  	  }

  	  function reportSecondsToHours(value) {
  	    return Math.max(0, n(value, 0)) / 3600;
  	  }

  	  function formatDurationSeconds(value) {
  	    const total = Math.max(0, Math.round(n(value, 0)));

  	    if (total < 60) {
  	      return total + " sec";
  	    }

  	    const hours = Math.floor(total / 3600);
  	    const minutes = Math.floor((total % 3600) / 60);

  	    if (hours > 0) {
  	      return hours + "h " + minutes + "m";
  	    }

  	    return minutes + " min";
  	  }

  	  function dailySummaryCount(report, summaryName) {
  	    return n(report && report[summaryName] && report[summaryName].count, 0);
  	  }

  	  function dailySummaryDuration(report, summaryName) {
  	    return Math.max(0, n(report && report[summaryName] && report[summaryName].duration, 0));
  	  }

  	  function dailySummaryDistance(report, summaryName) {
  	    return Math.max(0, n(report && report[summaryName] && report[summaryName].distance_km, 0));
  	  }

  	  function safePercent(part, whole) {
  	    const numerator = Math.max(0, n(part, 0));
  	    const denominator = Math.max(0, n(whole, 0));
  	    if (!(denominator > 0)) return 0;
  	    return clamp((numerator / denominator) * 100, 0, 100);
  	  }

  	  function reportTopTemperature(report) {
  	    if (!report || typeof report !== "object") return null;

  	    const directCandidates = [
  	      report.top_temperature,
  	      report.top_temp,
  	      report.max_temperature,
  	      report.maximum_temperature,
  	      report.highest_engine_temperature,
  	      report.engine_temperature_max
  	    ];

  	    for (let i = 0; i < directCandidates.length; i++) {
  	      if (hasNumber(directCandidates[i])) return Number(directCandidates[i]);
  	    }

  	    const summary = report.over_temperature_summary;
  	    if (summary && typeof summary === "object") {
  	      const summaryCandidates = [
  	        summary.max_temperature,
  	        summary.top_temperature,
  	        summary.highest_temperature
  	      ];

  	      for (let i = 0; i < summaryCandidates.length; i++) {
  	        if (hasNumber(summaryCandidates[i])) return Number(summaryCandidates[i]);
  	      }
  	    }

  	    return null;
  	  }

  	  function firstReportPeriod(selectedCompanies) {
  	    let todayKey = "";
  	    let dateKey = "";
  	    let monthKey = "";

  	    arr(selectedCompanies).some(function (company) {
  	      return arr(company && company.Tractors).some(function (vehicle) {
  	        if (!todayKey) todayKey = reportTodayKey(vehicle);
  	        if (!dateKey) dateKey = reportDateKey(vehicle);
  	        if (!monthKey) monthKey = reportMonthKey(vehicle);
  	        return !!todayKey && !!dateKey && !!monthKey;
  	      });
  	    });

  	    return {
  	      todayKey: todayKey,
  	      dateKey: dateKey,
  	      monthKey: monthKey
  	    };
  	  }


  	  /* =========================================================
  	     SNAPSHOT CACHE READINESS

  	     There is no report-download phase anymore. Snapshot data is a scalar JSON
  	     column on ViewC and arrives with the normal Backendless relation query.
  	     Missing vehicle snapshots never block the entire dashboard.
  	     ========================================================= */

  	  function reportLoadState() {
  	    let trackedVehicles = 0;
  	    let snapshotContainers = 0;
  	    let todayAvailable = 0;
  	    let yesterdayAvailable = 0;
  	    let monthlyAvailable = 0;

  	    arr(snapshotUser && snapshotUser.Companies).forEach(function (company) {
  	      arr(company && company.Tractors).forEach(function (vehicle) {
  	        if (!text(vehicle && vehicle.Tracker, "")) return;

  	        trackedVehicles++;

  	        const snapshot = vehicleSnapshotContainer(vehicle);
  	        if (!snapshot || !Object.keys(snapshot).length) return;

  	        snapshotContainers++;

  	        if (vehicleCurrentReport(vehicle)) todayAvailable++;
  	        if (vehicleDailyReport(vehicle)) yesterdayAvailable++;
  	        if (vehicleMonthlyReport(vehicle)) monthlyAvailable++;
  	      });
  	    });

  	    return {
  	      trackedVehicles: trackedVehicles,
  	      reportContainers: snapshotContainers,
  	      snapshotContainers: snapshotContainers,
  	      loading: 0,
  	      finished: snapshotContainers,
  	      todayAvailable: todayAvailable,
  	      yesterdayAvailable: yesterdayAvailable,
  	      monthlyAvailable: monthlyAvailable,
  	      waiting: false
  	    };
  	  }

  	  function reportsAreLoading() {
  	    return false;
  	  }


  	  const APPLICATION_PAGES = Object.freeze({
  	    FIFM: "FIFM",
  	    Office: "Office",
  	    Road: "Road",
  	    Bowser: "Bowser",
  	    "Mobile Tracking": "MobileTracking",
  	    Snapshot: "Snapshot"
  	  });

  	  function normaliseApplicationName(value) {
  	    switch (text(value, "").toLowerCase().replace(/[\s_-]+/g, "")) {
  	      case "fifm": return "FIFM";
  	      case "office": return "Office";
  	      case "road":
  	      case "drivermobile":
  	      case "mobiledriver": return "Road";
  	      case "bowser": return "Bowser";
  	      case "mobiletracking": return "Mobile Tracking";
  	      case "snapshot": return "Snapshot";
  	      default: return text(value, "");
  	    }
  	  }

  	  function currentApplication() {
  	    try {
  	      const page = new URL(window.location.href).searchParams.get("page");
  	      const fromPage = normaliseApplicationName(page);
  	      if (APPLICATION_PAGES[fromPage]) return fromPage;
  	    } catch (_) {}
  	    const fromData = normaliseApplicationName(AppData && AppData.APP);
  	    return APPLICATION_PAGES[fromData] ? fromData : "Snapshot";
  	  }

  	  function allowedApplicationsFor(user) {
  	    const raw = Array.isArray(user && user.APP)
  	      ? user.APP
  	      : text(user && user.APP, "").split(",");

  	    const allowed = raw
  	      .map(normaliseApplicationName)
  	      .filter(function (name) { return !!APPLICATION_PAGES[name]; });

  	    if (text(user && user.Office, "").toLowerCase().indexOf("livetrack") !== -1) {
  	      allowed.push("Mobile Tracking");
  	    }
  	    if (text(user && user.Settings, "").toLowerCase().indexOf("overview") !== -1) {
  	      allowed.push("Snapshot");
  	    }

  	    return allowed.filter(function (name, index, list) {
  	      return list.indexOf(name) === index;
  	    });
  	  }

  	  function installLogoutGuard() {
  	    try {
  	      if (!DB || !DB.UserService || typeof DB.UserService.logout !== "function") return null;

  	      const service = DB.UserService;
  	      const existing = window[LOGOUT_GUARD_KEY];
  	      if (existing && existing.service === service && service.logout === existing.wrapper) return existing;

  	      const original = existing && existing.service === service && typeof existing.original === "function"
  	        ? existing.original
  	        : service.logout;

  	      const guard = {
  	        version: "1.0",
  	        service: service,
  	        original: original,
  	        wrapper: null,
  	        explicitBusy: false,
  	        blockedCount: existing && existing.blockedCount ? existing.blockedCount : 0,
  	        async explicitLogout() {
  	          if (guard.explicitBusy) return false;
  	          guard.explicitBusy = true;
  	          try {
  	            return await guard.original.apply(guard.service, arguments);
  	          } finally {
  	            guard.explicitBusy = false;
  	          }
  	        }
  	      };

  	      guard.wrapper = function protectedBackendlessLogout() {
  	        guard.blockedCount += 1;
  	        console.warn("[FIF Logout Guard] Blocked a background logout during app switching.", {
  	          blockedCount: guard.blockedCount
  	        });
  	        return Promise.resolve(false);
  	      };

  	      try {
  	        service.logout = guard.wrapper;
  	      } catch (_) {
  	        Object.defineProperty(service, "logout", {
  	          configurable: true,
  	          writable: true,
  	          value: guard.wrapper
  	        });
  	      }

  	      if (service.logout !== guard.wrapper) return null;
  	      window[LOGOUT_GUARD_KEY] = guard;
  	      return guard;
  	    } catch (error) {
  	      console.error("[FIF Logout Guard] Could not install on Snapshot.", error);
  	      return null;
  	    }
  	  }

  	  const logoutGuard = installLogoutGuard();

  	  function recordMonthView(record, key) {
  	    if (!record) return null;
  	    const current = record.ViewC;
  	    if (current && (!current.MYearKey || current.MYearKey === key)) return current;
  	    const history = arr(record.ViewH);
  	    for (let i = 0; i < history.length; i++) {
  	      if (history[i] && history[i].MYearKey === key) return history[i];
  	    }
  	    return null;
  	  }

  	  function companyLabel(company) {
  	    return text(company && (company.Name || company.CompanyId), "Company");
  	  }
  	  function companyKey(company, index) {
  	    return text(company && (company.objectId || company.CompanyId || company.Name), "company-" + index);
  	  }
  	  function vehicleLabel(vehicle) {
  	    return text(vehicle && (vehicle.Registration || vehicle.FID || vehicle.ID), "Vehicle");
  	  }
  	  function tankLabel(tank) {
  	    return text(tank && (tank.Name || tank.Grade), "Fuel Tank");
  	  }

  	  function parseJsonArray(value) {
  	    if (Array.isArray(value)) return value;

  	    if (typeof value === "string" && value.trim()) {
  	      try {
  	        const parsed = JSON.parse(value);
  	        return Array.isArray(parsed) ? parsed : [];
  	      } catch (_) {
  	        return [];
  	      }
  	    }

  	    if (value && typeof value === "object") {
  	      if (Array.isArray(value.data)) return value.data;
  	      if (Array.isArray(value.items)) return value.items;
  	    }

  	    return [];
  	  }

  	  function tankAtgRelation(tank) {
  	    if (!tank) return null;

  	    const relation = tank.ATG || tank.ATGPoll || tank.ATGPolls || null;

  	    if (Array.isArray(relation)) return relation[0] || null;
  	    if (relation && Array.isArray(relation.data)) return relation.data[0] || null;

  	    return relation && typeof relation === "object" ? relation : null;
  	  }

  	  function tankAtgNumber(tank) {
  	    return text(
  	      tank && (
  	        tank.ATG_NUMBER ??
  	        tank.ATGNumber ??
  	        tank.AtgNumber
  	      ),
  	      ""
  	    );
  	  }

  	  function tankAtgReading(tank) {
  	    const atg = tankAtgRelation(tank);
  	    const wanted = tankAtgNumber(tank);
  	    if (!atg || !wanted) return null;

  	    return parseJsonArray(atg.Readings).find(function (reading) {
  	      const readingNumber = text(
  	        reading && (
  	          reading.TankNumber ??
  	          reading.ATGNumber ??
  	          reading.TankNo
  	        ),
  	        ""
  	      );
  	      return readingNumber === wanted;
  	    }) || null;
  	  }

  	  function tankAtgSnapshot(tank) {
  	    const atg = tankAtgRelation(tank);
  	    const reading = tankAtgReading(tank);
  	    const capturedAt = asEpochMs(
  	      atg && (
  	        atg.CapturedAt ??
  	        atg.CapturedAtIso ??
  	        atg.updated ??
  	        atg.created
  	      )
  	    );
  	    const volume = n(reading && reading.VolumeL, NaN);
  	    const available = !!reading && Number.isFinite(volume);
  	    const stale = available && (!capturedAt || Date.now() - capturedAt > ATG_STALE_MS);

  	    return {
  	      linked: !!atg,
  	      available: available,
  	      stale: stale,
  	      status: !available ? "unavailable" : stale ? "stale" : "live",
  	      tankNumber: tankAtgNumber(tank),
  	      product: text(reading && reading.Product, ""),
  	      volume: volume,
  	      temperature: n(reading && reading.TemperatureC, NaN),
  	      water: n(reading && reading.Water, NaN),
  	      ullage: n(reading && reading.UllageL, NaN),
  	      height: n(reading && reading.Height, NaN),
  	      capturedAt: capturedAt
  	    };
  	  }

  	  function validFuelTransactions(view) {
  	    return arr(view && view.Fuel).filter(function (row) {
  	      return row && row.IsReversed !== true && row.Reversed !== true && !row.ReversedAt;
  	    });
  	  }

  	  function sastDateKeyFromValue(value) {
  	    if (value === undefined || value === null || value === "") return "";

  	    let ms = 0;

  	    if (typeof value === "number" && Number.isFinite(value)) {
  	      ms = value < 100000000000 ? value * 1000 : value;
  	    } else if (/^\d+(\.\d+)?$/.test(String(value).trim())) {
  	      const numeric = Number(value);
  	      ms = numeric < 100000000000 ? numeric * 1000 : numeric;
  	    } else {
  	      ms = Date.parse(value);
  	    }

  	    if (!Number.isFinite(ms) || ms <= 0) return "";

  	    try {
  	      const parts = new Intl.DateTimeFormat("en-ZA", {
  	        timeZone: "Africa/Johannesburg",
  	        year: "numeric",
  	        month: "2-digit",
  	        day: "2-digit"
  	      }).formatToParts(new Date(ms));

  	      const get = function (type) {
  	        const part = parts.find(function (item) { return item.type === type; });
  	        return part ? part.value : "";
  	      };

  	      const year = get("year");
  	      const month = get("month");
  	      const day = get("day");

  	      return year && month && day ? year + "-" + month + "-" + day : "";
  	    } catch (_) {
  	      return "";
  	    }
  	  }

  	  function fuelTransactionDateKey(row) {
  	    return sastDateKeyFromValue(
  	      row && (
  	        row.FuelDate ??
  	        row.GPSCapturedAt ??
  	        row.created ??
  	        row.updated
  	      )
  	    );
  	  }
  	  function viewFuelCost(view) {
  	    if (!view) return 0;
  	    if (hasNumber(view.FuelCost) && n(view.FuelCost) > 0) return n(view.FuelCost);
  	    if (hasNumber(view.Cost) && n(view.Cost) > 0) return n(view.Cost);
  	    return sum(validFuelTransactions(view), function (x) { return x.Cost; });
  	  }
  	  function viewFuelLitres(view) {
  	    if (!view) return 0;
  	    if (hasNumber(view.Litres)) return n(view.Litres);
  	    return sum(validFuelTransactions(view), function (x) { return x.Litres; });
  	  }

  	  function isHoursVehicle(vehicle) {
  	    // Dashboard V21.12.94 gives canonical Data.Vehicle.Usage.CounterType
  	    // priority over the top-level Tractor.CounterType legacy mirror.
  	    const data = parseJsonObject(vehicle && vehicle.Data) || {};
  	    const usage = data.Vehicle && data.Vehicle.Usage;
  	    const descriptor = usage && usage.CounterType;
  	    const canonical = descriptor && typeof descriptor === "object" &&
  	      Object.prototype.hasOwnProperty.call(descriptor, "value")
  	        ? descriptor.value : descriptor;
  	    const counter = text(canonical, text(vehicle && vehicle.CounterType, "")).toLowerCase();
  	    return counter === "hours" || counter === "hour" || counter.indexOf("hobbs") !== -1;
  	  }

  	  function viewHours(view) {
  	    if (!view) return 0;
  	    if (hasNumber(view.Hours)) return Math.max(0, n(view.Hours));
  	    if (hasNumber(view.MeterStart) && hasNumber(view.MeterEnd)) {
  	      const start = n(view.MeterStart);
  	      const end = n(view.MeterEnd);
  	      if (end >= start) return end - start;
  	    }
  	    return 0;
  	  }

  	  function currentHobbsReading(vehicle) {
  	    // Tractor.Mileage carries the current counter value; CounterType tells us
  	    // whether that value is kilometres or an hour/Hobbs reading.
  	    if (!isHoursVehicle(vehicle)) return null;
  	    if (hasNumber(vehicle && vehicle.Mileage)) return Math.max(0, n(vehicle.Mileage));
  	    const hourMeter = vehicle && vehicle.Data && vehicle.Data.Vehicle && vehicle.Data.Vehicle.Hours && vehicle.Data.Vehicle.Hours.HourMeter;
  	    if (hourMeter && hasNumber(hourMeter.value)) return Math.max(0, n(hourMeter.value));
  	    return null;
  	  }

  	  function locationTimestamp(location) {
  	    if (!location) return 0;
  	    const candidates = [
  	      location.timestamp,
  	      location["server.timestamp"],
  	      location["device.timestamp"],
  	      location["position.timestamp"],
  	      location.updated
  	    ];
  	    for (let i = 0; i < candidates.length; i++) {
  	      const ms = asEpochMs(candidates[i]);
  	      if (ms) return ms;
  	    }
  	    return 0;
  	  }
  	  function locationNumber(location, keys) {
  	    if (!location) return null;
  	    for (let i = 0; i < keys.length; i++) {
  	      if (hasNumber(location[keys[i]])) return Number(location[keys[i]]);
  	    }
  	    return null;
  	  }
  	  function truthyLocation(location, keys) {
  	    if (!location) return null;
  	    for (let i = 0; i < keys.length; i++) {
  	      if (typeof location[keys[i]] === "boolean") return location[keys[i]];
  	    }
  	    return null;
  	  }


  	  /* =========================================================
  	     DASHBOARD-COMPATIBLE OPERATIONAL ALERT ENGINE

  	     Mirrors the Dashboard alert classes:
  	       - Data quality
  	       - Service
  	       - Preventive maintenance
  	       - Workshop / open maintenance
  	       - Tyres
  	       - Compliance
  	       - Fuel
  	       - Legacy Notifications

  	     Snapshot remains read-only. It derives alerts from the same persisted
  	     vehicle data/relations and never writes service, tyre or compliance data.
  	     ========================================================= */

  	  const SNAPSHOT_OPEN_WORKSHOP_STATUSES = [
  	    "Draft",
  	    "Scheduled",
  	    "Booked",
  	    "In Progress",
  	    "Waiting Parts",
  	    "Ready"
  	  ];

  	  const SNAPSHOT_COMPLIANCE_DEFINITIONS = [
  	    {
  	      key: "VehicleLicence",
  	      label: "Vehicle licence",
  	      recordTypes: ["Vehicle Licence"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "RegistrationAndLicensing", "LicenceExpiry"],
  	        ["Data", "Compliance", "License_Expiry_Date"]
  	      ]
  	    },
  	    {
  	      key: "Roadworthiness",
  	      label: "Roadworthiness / COF",
  	      recordTypes: ["Certificate of Fitness", "Roadworthy"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Roadworthiness", "COFExpiry"],
  	        ["Data", "Compliance", "COF_Expiry"]
  	      ]
  	    },
  	    {
  	      key: "Insurance",
  	      label: "Insurance",
  	      recordTypes: ["Insurance"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Insurance", "ExpiryDate"],
  	        ["Data", "Compliance", "InsuranceExpiry"]
  	      ]
  	    },
  	    {
  	      key: "OperatingPermit",
  	      label: "Operating permit",
  	      recordTypes: ["Operating Permit"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Permits", "OperatingPermitExpiry"]
  	      ]
  	    },
  	    {
  	      key: "CrossBorderPermit",
  	      label: "Cross-border permit",
  	      recordTypes: ["Cross-border Permit"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Permits", "CrossBorderExpiry"]
  	      ]
  	    },
  	    {
  	      key: "DangerousGoods",
  	      label: "Dangerous goods",
  	      recordTypes: ["Dangerous Goods"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Permits", "DangerousGoodsExpiry"]
  	      ]
  	    },
  	    {
  	      key: "LoadTest",
  	      label: "Load test",
  	      recordTypes: ["Load Test"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Testing", "LoadTestExpiry"],
  	        ["Data", "Compliance", "Load_Test_Expiry"]
  	      ]
  	    },
  	    {
  	      key: "Calibration",
  	      label: "Calibration",
  	      recordTypes: ["Calibration"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Testing", "CalibrationExpiry"],
  	        ["Data", "Compliance", "Calibration_Expiry"]
  	      ]
  	    },
  	    {
  	      key: "FireExtinguisher",
  	      label: "Fire extinguisher",
  	      recordTypes: ["Fire Extinguisher"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "SafetyEquipment", "FireExtinguisherExpiry"],
  	        ["Data", "Compliance", "Fire_Extinguisher_Expiry"]
  	      ]
  	    },
  	    {
  	      key: "TrackingCertificate",
  	      label: "Tracking certificate",
  	      recordTypes: ["Tracking Certificate"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Tracking", "CertificateExpiry"]
  	      ]
  	    },
  	    {
  	      key: "ROPSInspection",
  	      label: "ROPS inspection",
  	      recordTypes: ["Other Compliance"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Agricultural", "ROPSInspectionExpiry"]
  	      ]
  	    },
  	    {
  	      key: "PTOGuardInspection",
  	      label: "PTO guard inspection",
  	      recordTypes: ["Other Compliance"],
  	      expiryPaths: [
  	        ["Data", "Compliance", "Agricultural", "PTOGuardInspectionExpiry"]
  	      ]
  	    }
  	  ];

  	  function alertClean(value) {
  	    return String(value == null ? "" : value).trim();
  	  }

  	  function alertLower(value) {
  	    return alertClean(value).toLowerCase();
  	  }

  	  function alertFirst(values, fallback) {
  	    const list = arr(values);
  	    for (let i = 0; i < list.length; i++) {
  	      const value = list[i];
  	      if (value !== null && value !== undefined && value !== "") return value;
  	    }
  	    return fallback;
  	  }

  	  function alertGetDeep(source, path, fallback) {
  	    let value = source;
  	    for (let i = 0; i < path.length; i++) {
  	      if (!value || typeof value !== "object" || !(path[i] in value)) return fallback;
  	      value = value[path[i]];
  	    }
  	    return value === undefined ? fallback : value;
  	  }

  	  function alertDescriptorValue(value) {
  	    if (
  	      value &&
  	      typeof value === "object" &&
  	      !Array.isArray(value) &&
  	      Object.prototype.hasOwnProperty.call(value, "value")
  	    ) {
  	      return value.value;
  	    }
  	    return value;
  	  }

  	  function alertNumber(value) {
  	    value = alertDescriptorValue(value);
  	    if (value === null || value === undefined || value === "") return null;
  	    const number = Number(value);
  	    return Number.isFinite(number) ? number : null;
  	  }

  	  function alertBoolean(value) {
  	    value = alertDescriptorValue(value);
  	    if (typeof value === "boolean") return value;
  	    const key = alertLower(value);
  	    if (["true", "yes", "1", "on"].indexOf(key) !== -1) return true;
  	    if (["false", "no", "0", "off"].indexOf(key) !== -1) return false;
  	    return null;
  	  }

  	  function alertObjectId(value) {
  	    return alertClean(value && (value.objectId || value.ObjectId || value.objectID || value.id));
  	  }

  	  function alertDate(value) {
  	    if (value === null || value === undefined || value === "") return null;
  	    const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  	    return Number.isNaN(date.getTime()) ? null : date;
  	  }

  	  function alertDaysUntil(value) {
  	    const date = alertDate(value);
  	    if (!date) return null;
  	    const now = new Date();
  	    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  	    const target = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  	    return Math.ceil((target - start) / 86400000);
  	  }

  	  function alertFormatDate(value) {
  	    const date = alertDate(value);
  	    if (!date) return "—";
  	    return date.toLocaleDateString("en-ZA", {
  	      year: "numeric",
  	      month: "short",
  	      day: "2-digit"
  	    });
  	  }

  	  function alertDatePlusDays(value, days) {
  	    const date = alertDate(value);
  	    const count = Math.round(n(days, 0));
  	    if (!date || !count) return "";
  	    date.setUTCDate(date.getUTCDate() + count);
  	    return date.toISOString().slice(0, 10);
  	  }

  	  function alertSeverityRank(severity) {
  	    switch (alertLower(severity)) {
  	      case "critical": return 0;
  	      case "high": return 1;
  	      case "warning": return 2;
  	      case "info": return 3;
  	      default: return 4;
  	    }
  	  }

  	  function alertSeverityLevel(severity) {
  	    const value = alertLower(severity);
  	    if (value === "critical" || value === "high") return "danger";
  	    if (value === "warning") return "warn";
  	    return "info";
  	  }

  	  function alertSeverityLabel(severity) {
  	    const value = alertLower(severity);
  	    if (value === "critical") return "Critical";
  	    if (value === "high") return "High";
  	    if (value === "warning") return "Warning";
  	    if (value === "info") return "Information";
  	    return "Notice";
  	  }

  	  function alertTokens(value) {
  	    return (Array.isArray(value) ? value : String(value || "").split(/[;,|]/g))
  	      .map(function (item) { return alertLower(item); })
  	      .filter(Boolean);
  	  }

  	  function snapshotAlertPermission(option) {
  	    const user = snapshotUser || AppData.User || {};
  	    const app = alertTokens(user.APP);
  	    const office = alertTokens(user.Office);
  	    const settings = alertTokens(user.Settings);

  	    /*
  	     * Dashboard semantics:
  	     *   APP contains Office
  	     *   Office contains Dash
  	     *   Settings contains Alerts + the relevant function.
  	     *
  	     * If the user model predates granular Dash settings, do not suppress
  	     * Snapshot entirely; retain legacy visibility.
  	     */
  	    const hasModernDashboardPermissions =
  	      settings.some(function (item) {
  	        return ["alerts", "service", "maintenance", "tyres", "compliance", "fuel", "vehicles", "vehicledata"].indexOf(item.replace(/[^a-z]/g, "")) !== -1;
  	      });

  	    if (!hasModernDashboardPermissions) return true;

  	    const officeApp = app.some(function (item) { return item.replace(/[^a-z]/g, "") === "office"; });
  	    const dashOffice = office.some(function (item) { return item.replace(/[^a-z]/g, "") === "dash"; });

  	    if (!officeApp || !dashOffice) return false;

  	    const normal = String(option || "").toLowerCase().replace(/[^a-z]/g, "");
  	    const aliases = {
  	      alerts: ["alerts", "alert", "notifications", "operationalalerts", "vehiclealerts"],
  	      service: ["service", "services"],
  	      maintenance: ["maintenance"],
  	      tyres: ["tyres", "tyre", "tires", "tire"],
  	      compliance: ["compliance", "regulatorycompliance"],
  	      fuel: ["fuel", "fuels"],
  	      vehicles: ["vehicles", "vehicle"],
  	      vehicledata: ["vehicledata"]
  	    };

  	    const wanted = aliases[normal] || [normal];

  	    return settings.some(function (item) {
  	      const key = item.replace(/[^a-z]/g, "");
  	      return wanted.indexOf(key) !== -1;
  	    });
  	  }

  	  function snapshotAlertsEnabled() {
  	    return snapshotAlertPermission("alerts");
  	  }

  	  function snapshotVehicleCounterType(vehicle) {
  	    const value = alertClean(alertFirst([
  	      vehicle && vehicle.CounterType,
  	      alertGetDeep(vehicle, ["Data", "Vehicle", "Usage", "CounterType"], ""),
  	      alertGetDeep(vehicle, ["Data", "Usage", "CounterType"], "")
  	    ], "Kilometers"));

  	    return alertLower(value) === "hours" ? "Hours" : "Kilometers";
  	  }

  	  function snapshotVehicleReading(vehicle) {
  	    const live = vehicleLiveSnapshot(vehicle) || {};
  	    const candidates = [
  	      vehicle && vehicle.Mileage,
  	      vehicle && vehicle.CurrentReading,
  	      alertGetDeep(vehicle, ["Data", "Vehicle", "Usage", "CurrentReading"], null),
  	      alertGetDeep(vehicle, ["Data", "Usage", "CurrentReading"], null),
  	      snapshotVehicleCounterType(vehicle) === "Hours" ? vehicle && vehicle.Mileage : live.can_mileage
  	    ];

  	    for (let i = 0; i < candidates.length; i++) {
  	      const value = alertNumber(candidates[i]);
  	      if (value !== null) return value;
  	    }

  	    return null;
  	  }

  	  function snapshotMaintenanceRows(vehicle) {
  	    const rows = arr(vehicle && vehicle.Maintenance);
  	    const seen = Object.create(null);

  	    return rows.filter(function (row, index) {
  	      if (!row || typeof row !== "object") return false;
  	      const key = alertObjectId(row) || alertClean(row.WorkOrderId) || "row-" + index;
  	      if (seen[key]) return false;
  	      seen[key] = true;
  	      return true;
  	    });
  	  }

  	  function snapshotMaintenanceCategory(record) {
  	    return alertClean(record && (record.Category || record.TypeCategory || record.WorkCategory));
  	  }

  	  function snapshotWorkshopStatus(record) {
  	    const raw = alertClean(record && (record.Status || record.Phase || record.WorkStatus));
  	    const key = alertLower(raw).replace(/[_-]+/g, " ").replace(/\s+/g, " ");

  	    if (key === "in progress" || key === "inprogress") return "In Progress";
  	    if (key === "waiting parts" || key === "waitingparts") return "Waiting Parts";
  	    if (key === "scheduled") return "Scheduled";
  	    if (key === "booked") return "Booked";
  	    if (key === "ready") return "Ready";
  	    if (key === "completed" || key === "complete") return "Completed";
  	    if (key === "cancelled" || key === "canceled") return "Cancelled";
  	    if (key === "renewed") return "Renewed";
  	    if (key === "closed") return "Completed";
  	    return raw || "Draft";
  	  }

  	  function snapshotWorkshopPhaseAgeDays(record) {
  	    const value = alertFirst([
  	      record && record.PhaseChangedAt,
  	      record && record.StatusChangedAt,
  	      record && record.UpdatedAt,
  	      record && record.updated,
  	      record && record.created,
  	      record && record.ReportedDate
  	    ], "");

  	    const date = alertDate(value);
  	    if (!date) return 0;
  	    return Math.max(0, Math.floor((Date.now() - date.getTime()) / 86400000));
  	  }

  	  function snapshotOpenOrders(vehicle, category) {
  	    const wanted = alertLower(category);
  	    return snapshotMaintenanceRows(vehicle).filter(function (record) {
  	      return alertLower(snapshotMaintenanceCategory(record)) === wanted &&
  	        SNAPSHOT_OPEN_WORKSHOP_STATUSES.indexOf(snapshotWorkshopStatus(record)) !== -1;
  	    });
  	  }

  	  function snapshotServiceInterval(vehicle, hours) {
  	    const service = alertGetDeep(vehicle, ["Data", "Service"], {}) || {};
  	    const schedule = alertGetDeep(service, ["Schedule"], {}) || {};

  	    return Math.max(0, n(alertDescriptorValue(alertFirst(hours ? [
  	      schedule.ServiceIntervalHours,
  	      schedule.Service_Interval_Hours
  	    ] : [
  	      schedule.ServiceIntervalKM,
  	      schedule.Service_Interval_KM,
  	      service.Service_Interval
  	    ], 0)), 0));
  	  }

  	  function snapshotServiceIntervalDays(vehicle) {
  	    const service = alertGetDeep(vehicle, ["Data", "Service"], {}) || {};
  	    const schedule = alertGetDeep(service, ["Schedule"], {}) || {};

  	    const explicit = Math.max(0, n(alertDescriptorValue(alertFirst([
  	      schedule.ServiceIntervalDays,
  	      schedule.Service_Interval_Days
  	    ], 0)), 0));

  	    if (explicit > 0) return explicit;

  	    const current = alertGetDeep(service, ["Current"], {}) || {};
  	    const history = alertGetDeep(service, ["History"], {}) || {};
  	    const lastDate = alertClean(alertDescriptorValue(alertFirst([
  	      current.LastServiceDate,
  	      current.Last_Service_Date,
  	      history.Last_Service_Date
  	    ], "")));
  	    const nextDate = alertClean(alertDescriptorValue(alertFirst([
  	      current.NextServiceDate,
  	      current.Next_Service_Date_Estimate,
  	      current.Next_Service_Date,
  	      history.Next_Service_Date_Estimate,
  	      history.Next_Service_Date
  	    ], "")));

  	    const last = alertDate(lastDate);
  	    const next = alertDate(nextDate);

  	    if (!last || !next || next <= last) return 0;
  	    return Math.round((next.getTime() - last.getTime()) / 86400000);
  	  }

  	  function snapshotServiceHealth(vehicle) {
  	    const counterType = snapshotVehicleCounterType(vehicle);
  	    const hours = counterType === "Hours";
  	    const unit = hours ? "h" : "km";
  	    const reading = snapshotVehicleReading(vehicle);

  	    const service = alertGetDeep(vehicle, ["Data", "Service"], {}) || {};
  	    const current = alertGetDeep(service, ["Current"], {}) || {};
  	    const history = alertGetDeep(service, ["History"], {}) || {};
  	    const schedule = alertGetDeep(service, ["Schedule"], {}) || {};

  	    const storedNextCounter = alertNumber(alertDescriptorValue(alertFirst(hours ? [
  	      current.NextServiceHours,
  	      current.Next_Service_Hours,
  	      history.Next_Service_Hours
  	    ] : [
  	      current.NextServiceMileage,
  	      current.Next_Service_KM,
  	      current.NextServiceKM,
  	      history.Next_Service_KM
  	    ], null)));

  	    const lastCounter = alertNumber(alertDescriptorValue(alertFirst(hours ? [
  	      current.LastServiceHours,
  	      current.Last_Service_Hours,
  	      history.Last_Service_Hours
  	    ] : [
  	      current.LastServiceMileage,
  	      current.Last_Service_KM,
  	      current.LastServiceKM,
  	      history.Last_Service_KM
  	    ], null)));

  	    const storedNextDate = alertClean(alertDescriptorValue(alertFirst([
  	      current.NextServiceDate,
  	      current.Next_Service_Date_Estimate,
  	      current.Next_Service_Date,
  	      history.Next_Service_Date_Estimate,
  	      history.Next_Service_Date
  	    ], "")));

  	    const lastDate = alertClean(alertDescriptorValue(alertFirst([
  	      current.LastServiceDate,
  	      current.Last_Service_Date,
  	      history.Last_Service_Date
  	    ], "")));

  	    const intervalCounter = snapshotServiceInterval(vehicle, hours);
  	    const intervalDays = snapshotServiceIntervalDays(vehicle);

  	    const calculatedNextCounter =
  	      lastCounter !== null && intervalCounter > 0
  	        ? lastCounter + intervalCounter
  	        : null;

  	    const calculatedNextDate =
  	      lastDate && intervalDays > 0
  	        ? alertDatePlusDays(lastDate, intervalDays)
  	        : "";

  	    const nextCounter =
  	      calculatedNextCounter !== null
  	        ? calculatedNextCounter
  	        : storedNextCounter !== null && storedNextCounter > 0
  	          ? storedNextCounter
  	          : null;

  	    const nextDate = calculatedNextDate || storedNextDate;

  	    const warningCounter = Math.max(0, n(alertDescriptorValue(alertFirst(hours ? [
  	      schedule.ServiceWarningHours
  	    ] : [
  	      schedule.ServiceWarningKM,
  	      alertGetDeep(service, ["Service_Warning_Duration_in_KM"], 0)
  	    ], 0)), 0));

  	    const warningDays = Math.max(0, n(alertDescriptorValue(schedule.ServiceWarningDays), 0));

  	    const serviceStatus = alertLower(alertDescriptorValue(alertFirst([
  	      current.ServiceStatus,
  	      service.Service_Status
  	    ], "")));

  	    const calculationReading =
  	      reading === null
  	        ? lastCounter
  	        : lastCounter === null
  	          ? reading
  	          : Math.max(reading, lastCounter);

  	    const remainingCounter =
  	      nextCounter === null || calculationReading === null
  	        ? null
  	        : nextCounter - calculationReading;

  	    const remainingDays = nextDate ? alertDaysUntil(nextDate) : null;

  	    const counterConflict =
  	      nextCounter !== null &&
  	      lastCounter !== null &&
  	      nextCounter <= lastCounter;

  	    const lastDateValue = alertDate(lastDate);
  	    const nextDateValue = alertDate(nextDate);

  	    const dateConflict = !!(
  	      lastDateValue &&
  	      nextDateValue &&
  	      nextDateValue.getTime() <= lastDateValue.getTime()
  	    );

  	    return {
  	      unit: unit,
  	      reading: reading,
  	      lastCounter: lastCounter,
  	      nextCounter: nextCounter,
  	      remainingCounter: remainingCounter,
  	      nextDate: nextDate,
  	      remainingDays: remainingDays,
  	      warningCounter: warningCounter,
  	      warningDays: warningDays,
  	      serviceStatus: serviceStatus,
  	      dataConflict: counterConflict || dateConflict,
  	      openOrders: snapshotOpenOrders(vehicle, "Service")
  	    };
  	  }

  	  function snapshotPreventivePlans(vehicle) {
  	    return arr(alertGetDeep(vehicle, ["Data", "Maintenance", "PreventivePlans"], []))
  	      .filter(function (plan) { return plan && typeof plan === "object" && !Array.isArray(plan); })
  	      .map(function (plan, index) {
  	        return {
  	          PlanId: alertClean(plan.PlanId) || "PM-" + index,
  	          Name: alertClean(plan.Name) || "Preventive maintenance",
  	          TriggerMode: ["First Due", "Kilometers Only", "Time Only"].indexOf(alertClean(plan.TriggerMode)) !== -1
  	            ? alertClean(plan.TriggerMode)
  	            : "First Due",
  	          IntervalKM: Math.max(0, n(plan.IntervalKM, 0)),
  	          IntervalDays: Math.max(0, n(plan.IntervalDays, 0)),
  	          WarningKM: Math.max(0, n(plan.WarningKM, 0)),
  	          WarningDays: Math.max(0, n(plan.WarningDays, 0)),
  	          BaselineKM: alertNumber(plan.BaselineKM),
  	          BaselineDate: alertClean(plan.BaselineDate),
  	          Priority: alertClean(plan.Priority) || "Normal",
  	          Active: plan.Active !== false
  	        };
  	      });
  	  }

  	  function snapshotPreventivePlanRecords(vehicle, planId) {
  	    return snapshotMaintenanceRows(vehicle).filter(function (record) {
  	      return alertClean(record.PreventivePlanId) === alertClean(planId);
  	    });
  	  }

  	  function snapshotPreventiveStatus(vehicle, plan) {
  	    const records = snapshotPreventivePlanRecords(vehicle, plan.PlanId);

  	    const latestCompleted = records
  	      .filter(function (record) { return snapshotWorkshopStatus(record) === "Completed"; })
  	      .sort(function (a, b) {
  	        return (alertDate(b.CompletedDate || b.ReportedDate) || new Date(0)).getTime() -
  	          (alertDate(a.CompletedDate || a.ReportedDate) || new Date(0)).getTime();
  	      })[0] || null;

  	    const openJob = records
  	      .filter(function (record) {
  	        return SNAPSHOT_OPEN_WORKSHOP_STATUSES.indexOf(snapshotWorkshopStatus(record)) !== -1;
  	      })[0] || null;

  	    const currentKM = snapshotVehicleReading(vehicle);
  	    const completedOdometer = latestCompleted ? alertNumber(latestCompleted.Odometer) : null;
  	    const baselineKM = completedOdometer !== null ? completedOdometer : plan.BaselineKM;
  	    const baselineDate = alertClean(
  	      latestCompleted && (latestCompleted.CompletedDate || latestCompleted.ReportedDate)
  	    ) || plan.BaselineDate;

  	    const usesKM = plan.TriggerMode !== "Time Only" && plan.IntervalKM > 0;
  	    const usesTime = plan.TriggerMode !== "Kilometers Only" && plan.IntervalDays > 0;

  	    const nextKM = usesKM && baselineKM !== null ? baselineKM + plan.IntervalKM : null;
  	    const nextDate = usesTime && baselineDate ? alertDatePlusDays(baselineDate, plan.IntervalDays) : "";

  	    const calculationKM =
  	      currentKM === null
  	        ? baselineKM
  	        : baselineKM === null
  	          ? currentKM
  	          : Math.max(currentKM, baselineKM);

  	    const remainingKM =
  	      nextKM !== null && calculationKM !== null
  	        ? nextKM - calculationKM
  	        : null;

  	    const remainingDays = nextDate ? alertDaysUntil(nextDate) : null;

  	    const configured = usesKM || usesTime;
  	    const missingBaseline = (usesKM && baselineKM === null) || (usesTime && !baselineDate);

  	    return {
  	      openJob: openJob,
  	      configured: configured && !missingBaseline,
  	      nextKM: nextKM,
  	      nextDate: nextDate,
  	      remainingKM: remainingKM,
  	      remainingDays: remainingDays,
  	      due:
  	        !openJob &&
  	        plan.Active &&
  	        (
  	          (usesKM && remainingKM !== null && remainingKM <= 0) ||
  	          (usesTime && remainingDays !== null && remainingDays <= 0)
  	        ),
  	      dueSoon:
  	        !openJob &&
  	        plan.Active &&
  	        !(
  	          (usesKM && remainingKM !== null && remainingKM <= 0) ||
  	          (usesTime && remainingDays !== null && remainingDays <= 0)
  	        ) &&
  	        (
  	          (usesKM && remainingKM !== null && plan.WarningKM > 0 && remainingKM <= plan.WarningKM) ||
  	          (usesTime && remainingDays !== null && plan.WarningDays > 0 && remainingDays <= plan.WarningDays)
  	        )
  	    };
  	  }

  	  function snapshotTyreHistory(tyre) {
  	    const raw = tyre && tyre.History;
  	    if (!raw) return {};
  	    if (typeof raw === "object" && !Array.isArray(raw)) return raw;
  	    try {
  	      const parsed = JSON.parse(raw);
  	      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  	    } catch (_) {
  	      return {};
  	    }
  	  }

  	  function snapshotVehicleTyres(company, vehicle) {
  	    const result = [];
  	    const seen = Object.create(null);
  	    const vehicleId = alertObjectId(vehicle);
  	    const vehicleCode = alertClean(vehicle && (vehicle.ID || vehicle.FID));

  	    const companyTyres = arr(company && company.Tyres).filter(function (tyre) {
  	      const linkedObjectId = alertClean(tyre && (tyre.Vehicle_ObjectId || tyre.VehicleObjectId));
  	      const linkedId = alertClean(tyre && (tyre.Vehicle_ID || tyre.VehicleId));
  	      return (vehicleId && linkedObjectId === vehicleId) || (vehicleCode && linkedId === vehicleCode);
  	    });

  	    arr(vehicle && vehicle.Tyres).concat(companyTyres).forEach(function (tyre) {
  	      const id = alertClean(
  	        tyre && (tyre.objectId || tyre.ID || tyre.FID || tyre.Serial_Number || tyre.SerialNumber)
  	      );
  	      if (!id || seen[id]) return;
  	      seen[id] = true;
  	      result.push(tyre);
  	    });

  	    return result;
  	  }

  	  function snapshotTyreLabel(tyre) {
  	    return alertClean(alertFirst([
  	      tyre && tyre.ID,
  	      tyre && tyre.FID,
  	      tyre && tyre.Tyre_Number,
  	      tyre && tyre.Serial_Number,
  	      tyre && tyre.SerialNumber
  	    ], "Tyre"));
  	  }

  	  function snapshotTyrePosition(tyre) {
  	    const history = snapshotTyreHistory(tyre);
  	    return alertClean(alertFirst([
  	      tyre && tyre.Current_Position,
  	      tyre && tyre.Position,
  	      alertGetDeep(history, ["Current", "Position"], "")
  	    ], ""));
  	  }

  	  function snapshotTyreThreshold(tyre, vehicle) {
  	    const history = snapshotTyreHistory(tyre);
  	    const hours = snapshotVehicleCounterType(vehicle) === "Hours";
  	    const value = alertNumber(
  	      alertGetDeep(
  	        history,
  	        ["Current", hours ? "Warning_Threshold_Hours" : "Warning_Threshold_KM"],
  	        null
  	      )
  	    );
  	    return value !== null && value > 0 ? value : null;
  	  }

  	  function snapshotTyreRemaining(tyre) {
  	    const expected = alertNumber(alertFirst([
  	      tyre && tyre.Expected_Mileage,
  	      tyre && tyre.ExpectedMileage
  	    ], null));

  	    if (expected === null || expected <= 0) return null;

  	    const direct = alertNumber(alertFirst([
  	      tyre && tyre.Remaining_Mileage,
  	      tyre && tyre.RemainingMileage,
  	      tyre && tyre.Remaining_KM,
  	      tyre && tyre.RemainingKm
  	    ], null));

  	    if (direct !== null) return direct;

  	    const current = alertNumber(alertFirst([
  	      tyre && tyre.Current_Mileage,
  	      tyre && tyre.CurrentMileage
  	    ], null));

  	    return current === null ? null : expected - current;
  	  }

  	  function snapshotComplianceRecords(vehicle) {
  	    return snapshotMaintenanceRows(vehicle).filter(function (record) {
  	      return alertLower(snapshotMaintenanceCategory(record)) === "compliance";
  	    });
  	  }

  	  function snapshotComplianceStatus(record) {
  	    return alertClean(record && (record.ComplianceStatus || record.Status));
  	  }

  	  function snapshotComplianceLatestRecord(vehicle, definition) {
  	    const types = definition.recordTypes.map(alertLower);
  	    return snapshotComplianceRecords(vehicle)
  	      .filter(function (record) {
  	        return types.indexOf(alertLower(record.Type || record.RecordType || record.ComplianceType)) !== -1;
  	      })
  	      .sort(function (a, b) {
  	        const right = alertDate(b.IssueDate || b.EffectiveDate || b.ReportedDate || b.updated || b.created);
  	        const left = alertDate(a.IssueDate || a.EffectiveDate || a.ReportedDate || a.updated || a.created);
  	        return (right ? right.getTime() : 0) - (left ? left.getTime() : 0);
  	      })[0] || null;
  	  }

  	  function snapshotComplianceLegacyExpiry(vehicle, definition) {
  	    for (let i = 0; i < definition.expiryPaths.length; i++) {
  	      const value = alertClean(alertDescriptorValue(alertGetDeep(vehicle, definition.expiryPaths[i], "")));
  	      if (value) return value;
  	    }
  	    return "";
  	  }

  	  function snapshotComplianceAlerts(vehicle, add) {
  	    const root = alertGetDeep(vehicle, ["Data", "Compliance"], null);
  	    const setup = alertGetDeep(vehicle, ["Data", "Compliance", "Setup"], {}) || {};
  	    const configured = alertBoolean(alertDescriptorValue(setup.Configured)) === true;
  	    const warningDays = Math.max(1, n(alertDescriptorValue(setup.WarningDays), 60));
  	    const requirements = alertGetDeep(setup, ["Requirements"], {}) || {};
  	    const matchedRecordIds = Object.create(null);

  	    if (root && !configured) {
  	      add({
  	        key: "Compliance:" + alertObjectId(vehicle) + ":SetupRequired",
  	        category: "Compliance",
  	        code: "COMPLIANCE_SETUP_REQUIRED",
  	        severity: "warning",
  	        title: "Compliance setup required",
  	        message: "Select the compliance requirements that apply to this vehicle.",
  	        actual: "Not configured",
  	        threshold: "Vehicle requirements selected"
  	      });
  	    }

  	    SNAPSHOT_COMPLIANCE_DEFINITIONS.forEach(function (definition) {
  	      const req = requirements[definition.key] || {};
  	      const required = configured ? alertBoolean(alertDescriptorValue(req.Required)) === true : false;
  	      const record = snapshotComplianceLatestRecord(vehicle, definition);
  	      if (record && alertObjectId(record)) matchedRecordIds[alertObjectId(record)] = true;

  	      const expiry = alertClean(
  	        alertFirst([
  	          record && record.ExpiryDate,
  	          alertDescriptorValue(req.ExpiryDate),
  	          snapshotComplianceLegacyExpiry(vehicle, definition)
  	        ], "")
  	      );

  	      if (!required && !record && !expiry) return;

  	      const status = snapshotComplianceStatus(record);
  	      const days = expiry ? alertDaysUntil(expiry) : null;

  	      let stateLabel = "";
  	      let severity = "";

  	      if (record && ["failed", "rejected"].indexOf(alertLower(status)) !== -1) {
  	        stateLabel = "Action required";
  	        severity = "critical";
  	      } else if (days !== null && days < 0) {
  	        stateLabel = "Overdue";
  	        severity = "critical";
  	      } else if (required && !record && !expiry) {
  	        stateLabel = "Missing evidence";
  	        severity = "high";
  	      } else if (days !== null && days <= warningDays) {
  	        stateLabel = "Due soon";
  	        severity = days <= 7 ? "critical" : days <= 14 ? "high" : "warning";
  	      } else if (required && !expiry && !record) {
  	        stateLabel = "Setup required";
  	        severity = "warning";
  	      }

  	      if (!severity) return;

  	      add({
  	        key: "Compliance:" + alertObjectId(vehicle) + ":" + definition.key + ":" + stateLabel,
  	        category: "Compliance",
  	        code:
  	          stateLabel === "Overdue"
  	            ? "COMPLIANCE_EXPIRED"
  	            : stateLabel === "Due soon"
  	              ? "COMPLIANCE_EXPIRING"
  	              : stateLabel === "Missing evidence"
  	                ? "COMPLIANCE_EVIDENCE_MISSING"
  	                : "COMPLIANCE_ACTION_REQUIRED",
  	        severity: severity,
  	        title: definition.label + " · " + stateLabel.toLowerCase(),
  	        message:
  	          stateLabel === "Overdue"
  	            ? "Expired " + Math.abs(days) + " day" + (Math.abs(days) === 1 ? "" : "s") + " ago."
  	            : stateLabel === "Due soon"
  	              ? "Expires in " + days + " day" + (days === 1 ? "" : "s") + "."
  	              : stateLabel === "Missing evidence"
  	                ? "This requirement applies, but no current record or expiry date is available."
  	                : "Current compliance evidence requires attention.",
  	        actual: stateLabel,
  	        threshold: expiry ? alertFormatDate(expiry) : "Current evidence required"
  	      });
  	    });

  	    snapshotComplianceRecords(vehicle).forEach(function (record) {
  	      const id = alertObjectId(record);
  	      if (id && matchedRecordIds[id]) return;

  	      const expiry = alertClean(record.ExpiryDate);
  	      const status = snapshotComplianceStatus(record);
  	      const days = expiry ? alertDaysUntil(expiry) : null;
  	      let severity = "";
  	      let stateLabel = "";

  	      if (["failed", "rejected"].indexOf(alertLower(status)) !== -1) {
  	        severity = "critical";
  	        stateLabel = "Action required";
  	      } else if (days !== null && days < 0) {
  	        severity = "critical";
  	        stateLabel = "Overdue";
  	      } else if (days !== null && days <= warningDays) {
  	        severity = days <= 7 ? "critical" : days <= 14 ? "high" : "warning";
  	        stateLabel = "Due soon";
  	      }

  	      if (!severity) return;

  	      add({
  	        key: "Compliance:Record:" + (id || alertClean(record.WorkOrderId || record.Type)),
  	        category: "Compliance",
  	        code: stateLabel === "Overdue" ? "COMPLIANCE_EXPIRED" : "COMPLIANCE_EXPIRING",
  	        severity: severity,
  	        title: alertClean(record.Type || "Other compliance") + " · " + stateLabel.toLowerCase(),
  	        message:
  	          stateLabel === "Overdue"
  	            ? "Expired " + Math.abs(days) + " day" + (Math.abs(days) === 1 ? "" : "s") + " ago."
  	            : "Expires in " + days + " day" + (days === 1 ? "" : "s") + ".",
  	        actual: stateLabel,
  	        threshold: expiry ? alertFormatDate(expiry) : "Current evidence required"
  	      });
  	    });
  	  }

  	  function snapshotFuelAlert(vehicle, add) {
  	    const current = vehicleCurrentView(vehicle);
  	    if (!current) return;

  	    const distance = alertNumber(current.Distance);
  	    const litres = alertNumber(current.Litres);

  	    if (litres !== null && litres > 0 && (distance === null || distance <= 0)) {
  	      add({
  	        key: "Fuel:" + alertObjectId(vehicle) + ":NoDistance",
  	        category: "Fuel",
  	        code: "FUEL_WITHOUT_DISTANCE",
  	        severity: "high",
  	        title: "Fuel recorded without distance",
  	        message: formatNumber(litres, 1) + " L is recorded for the current period, but no usable distance is available.",
  	        actual: formatNumber(litres, 1) + " L",
  	        threshold: "Distance required"
  	      });
  	      return;
  	    }

  	    if (distance === null || litres === null || distance < 300 || litres <= 0) return;

  	    const history = arr(vehicle && vehicle.ViewH)
  	      .map(function (view) {
  	        return {
  	          distance: alertNumber(view && view.Distance),
  	          litres: alertNumber(view && view.Litres)
  	        };
  	      })
  	      .filter(function (row) {
  	        return row.distance !== null && row.litres !== null && row.distance >= 300 && row.litres > 0;
  	      })
  	      .slice(-6);

  	    if (history.length < 2) return;

  	    const baselineDistance = history.reduce(function (total, row) { return total + row.distance; }, 0);
  	    const baselineLitres = history.reduce(function (total, row) { return total + row.litres; }, 0);

  	    if (baselineDistance <= 0 || baselineLitres <= 0) return;

  	    const currentRate = litres / distance * 100;
  	    const baselineRate = baselineLitres / baselineDistance * 100;
  	    const variance = baselineRate > 0 ? (currentRate - baselineRate) / baselineRate * 100 : 0;

  	    if (variance < 15) return;

  	    add({
  	      key: "Fuel:" + alertObjectId(vehicle) + ":ConsumptionSpike",
  	      category: "Fuel",
  	      code: "FUEL_CONSUMPTION_SPIKE",
  	      severity: variance >= 40 ? "critical" : variance >= 25 ? "high" : "warning",
  	      title: "Fuel consumption spike",
  	      message:
  	        "Current consumption is " +
  	        formatNumber(currentRate, 1) +
  	        " L/100 km, " +
  	        formatNumber(variance, 1) +
  	        "% above the weighted historical baseline.",
  	      actual: formatNumber(currentRate, 1) + " L/100 km",
  	      threshold: formatNumber(baselineRate, 1) + " L/100 km baseline"
  	    });
  	  }

  	  function snapshotLegacyAlerts(vehicle, add) {
  	    arr(alertGetDeep(vehicle, ["Notifications", "issues"], [])).forEach(function (item, index) {
  	      const message = alertClean(
  	        typeof item === "string"
  	          ? item
  	          : alertFirst([item && item.Message, item && item.Title, item && item.message], "Operational issue")
  	      );

  	      add({
  	        key: "LegacyIssue:" + index + ":" + message,
  	        category: "Vehicle",
  	        code: "LEGACY_ISSUE",
  	        severity: "high",
  	        title: alertClean(item && item.Title) || "Operational issue",
  	        message: message
  	      });
  	    });

  	    arr(alertGetDeep(vehicle, ["Notifications", "warnings"], [])).forEach(function (item, index) {
  	      const message = alertClean(
  	        typeof item === "string"
  	          ? item
  	          : alertFirst([item && item.Message, item && item.Title, item && item.message], "Operational warning")
  	      );

  	      add({
  	        key: "LegacyWarning:" + index + ":" + message,
  	        category: "Vehicle",
  	        code: "LEGACY_WARNING",
  	        severity: "warning",
  	        title: alertClean(item && item.Title) || "Operational warning",
  	        message: message
  	      });
  	    });
  	  }

  	  function snapshotDashboardAlerts(company, vehicle) {
  	    if (!snapshotAlertsEnabled() || !vehicle) return [];

  	    const alerts = [];
  	    const byKey = Object.create(null);
  	    const vehicleId = alertObjectId(vehicle);
  	    const label = vehicleLabel(vehicle);

  	    const add = function (input) {
  	      if (!input || !input.key) return;

  	      const alert = Object.assign({
  	        category: "Vehicle",
  	        code: "GENERAL",
  	        severity: "warning",
  	        title: "Attention required",
  	        message: "",
  	        actual: "",
  	        threshold: "",
  	        position: "",
  	        vehicleLabel: label,
  	        vehicleObjectId: vehicleId
  	      }, input);

  	      const existing = byKey[alert.key];
  	      if (existing) {
  	        if (alertSeverityRank(alert.severity) < alertSeverityRank(existing.severity)) {
  	          Object.assign(existing, alert);
  	        }
  	        return;
  	      }

  	      byKey[alert.key] = alert;
  	      alerts.push(alert);
  	    };

  	    const reading = snapshotVehicleReading(vehicle);
  	    const counterType = snapshotVehicleCounterType(vehicle);
  	    const unit = counterType === "Hours" ? "h" : "km";

  	    if (reading === null && snapshotAlertPermission("vehicledata")) {
  	      add({
  	        key: "Vehicle:" + vehicleId + ":" + (counterType === "Hours" ? "HobbsMissing" : "MileageMissing"),
  	        category: "Data Quality",
  	        code: counterType === "Hours" ? "TRACTOR_HOBBS_MISSING" : "TRACTOR_MILEAGE_MISSING",
  	        severity: "critical",
  	        title: counterType === "Hours" ? "Hobbs meter reading is missing" : "Tractor mileage is missing",
  	        message:
  	          (counterType === "Hours" ? "Hour-based" : "Mileage-based") +
  	          " service and tyre alerts are unavailable until a current operational reading is captured.",
  	        actual: counterType === "Hours" ? "No Hobbs meter value" : "No mileage value",
  	        threshold: counterType === "Hours" ? "Current hour reading required" : "Current mileage required"
  	      });
  	    }

  	    if (snapshotAlertPermission("service")) {
  	      const health = snapshotServiceHealth(vehicle);
  	      const service = alertGetDeep(vehicle, ["Data", "Service"], null);
  	      const openJob = health.openOrders[0] || null;

  	      if (health.serviceStatus === "out of service") {
  	        add({
  	          key: "Service:" + vehicleId + ":OutOfService",
  	          category: "Service",
  	          code: "VEHICLE_OUT_OF_SERVICE",
  	          severity: "critical",
  	          title: "Vehicle is out of service",
  	          message: "The vehicle is marked out of service.",
  	          actual: "Out of service",
  	          threshold: "Operational service status"
  	        });
  	      }

  	      if (health.dataConflict) {
  	        add({
  	          key: "Service:" + vehicleId + ":SetupConflict",
  	          category: "Service",
  	          code: "SERVICE_SETUP_CONFLICT",
  	          severity: "critical",
  	          title: "Service setup needs correction",
  	          message: "The next service position is not later than the last service position.",
  	          actual: health.lastCounter === null ? "Last service not recorded" : formatNumber(health.lastCounter, 0) + " " + health.unit,
  	          threshold: health.nextCounter === null ? "Next service not configured" : formatNumber(health.nextCounter, 0) + " " + health.unit
  	        });
  	      }

  	      if (!health.dataConflict && health.nextCounter === null && !health.nextDate) {
  	        add({
  	          key: "Service:" + vehicleId + ":SetupRequired",
  	          category: "Service",
  	          code: "SERVICE_SETUP_REQUIRED",
  	          severity: service ? "warning" : "high",
  	          title: "Service setup required",
  	          message: "Configure a service interval and capture the starting service position before relying on service alerts.",
  	          actual: service ? "No next service position" : "No Service data",
  	          threshold: "Counter interval or time interval"
  	        });
  	      }

  	      if (!health.dataConflict && health.nextCounter !== null && reading !== null) {
  	        const remaining = health.remainingCounter;

  	        if (remaining !== null && remaining <= 0) {
  	          add({
  	            key: "Service:" + vehicleId + ":OverdueCounter",
  	            category: "Service",
  	            code: health.unit === "h" ? "SERVICE_OVERDUE_HOURS" : "SERVICE_OVERDUE_KM",
  	            severity: "critical",
  	            title: "Service overdue by " + (health.unit === "h" ? "hours" : "mileage"),
  	            message: "The service position is " + formatNumber(Math.abs(remaining), 0) + " " + health.unit + " overdue.",
  	            actual: formatNumber(reading, 0) + " " + health.unit,
  	            threshold: formatNumber(health.nextCounter, 0) + " " + health.unit
  	          });
  	        } else if (
  	          remaining !== null &&
  	          health.warningCounter > 0 &&
  	          remaining <= health.warningCounter
  	        ) {
  	          add({
  	            key: "Service:" + vehicleId + ":DueSoonCounter",
  	            category: "Service",
  	            code: health.unit === "h" ? "SERVICE_DUE_SOON_HOURS" : "SERVICE_DUE_SOON_KM",
  	            severity:
  	              remaining <= Math.min(health.unit === "h" ? 10 : 1000, health.warningCounter)
  	                ? "high"
  	                : "warning",
  	            title: "Service due soon by " + (health.unit === "h" ? "hours" : "mileage"),
  	            message: formatNumber(remaining, 0) + " " + health.unit + " remains before the next service.",
  	            actual: formatNumber(reading, 0) + " " + health.unit,
  	            threshold: formatNumber(health.nextCounter, 0) + " " + health.unit
  	          });
  	        }
  	      }

  	      if (!health.dataConflict && health.nextDate) {
  	        const days = health.remainingDays;

  	        if (days !== null && days < 0) {
  	          add({
  	            key: "Service:" + vehicleId + ":OverdueDate",
  	            category: "Service",
  	            code: "SERVICE_OVERDUE_DATE",
  	            severity: "critical",
  	            title: "Service overdue by date",
  	            message: "The service date passed " + Math.abs(days) + " day" + (Math.abs(days) === 1 ? "" : "s") + " ago.",
  	            actual: alertFormatDate(new Date()),
  	            threshold: alertFormatDate(health.nextDate)
  	          });
  	        } else if (
  	          days !== null &&
  	          health.warningDays > 0 &&
  	          days <= health.warningDays
  	        ) {
  	          add({
  	            key: "Service:" + vehicleId + ":DueSoonDate",
  	            category: "Service",
  	            code: "SERVICE_DUE_SOON_DATE",
  	            severity: days <= 7 ? "high" : "warning",
  	            title: "Service date approaching",
  	            message: "The next service date is in " + days + " day" + (days === 1 ? "" : "s") + ".",
  	            actual: alertFormatDate(new Date()),
  	            threshold: alertFormatDate(health.nextDate)
  	          });
  	        }
  	      }
  	    }

  	    if (snapshotAlertPermission("maintenance")) {
  	      snapshotPreventivePlans(vehicle).forEach(function (plan) {
  	        const position = snapshotPreventiveStatus(vehicle, plan);
  	        if (!plan.Active || position.openJob) return;

  	        if (!position.configured) {
  	          add({
  	            key: "Maintenance:Plan:" + plan.PlanId + ":Unconfigured",
  	            category: "Maintenance",
  	            code: "PREVENTIVE_PLAN_INCOMPLETE",
  	            severity: "warning",
  	            title: plan.Name + " needs setup",
  	            message: "Complete the plan interval and starting reading or date before it can calculate a due position.",
  	            actual: plan.TriggerMode,
  	            threshold: "Usable interval and baseline"
  	          });
  	          return;
  	        }

  	        const counterText =
  	          position.remainingKM === null
  	            ? ""
  	            : position.remainingKM < 0
  	              ? formatNumber(Math.abs(position.remainingKM), 0) + " km overdue"
  	              : position.remainingKM === 0
  	                ? "Due now by kilometers"
  	                : formatNumber(position.remainingKM, 0) + " km remaining";

  	        const timeText =
  	          position.remainingDays === null
  	            ? ""
  	            : position.remainingDays < 0
  	              ? Math.abs(position.remainingDays) + " day" + (Math.abs(position.remainingDays) === 1 ? "" : "s") + " overdue"
  	              : position.remainingDays === 0
  	                ? "Due today"
  	                : position.remainingDays + " day" + (position.remainingDays === 1 ? "" : "s") + " remaining";

  	        const evidence = [counterText, timeText].filter(Boolean).join(" · ") || "Due position unavailable";
  	        const threshold = [
  	          position.nextKM === null ? "" : formatNumber(position.nextKM, 0) + " km",
  	          position.nextDate ? alertFormatDate(position.nextDate) : ""
  	        ].filter(Boolean).join(" · ") || "Plan interval";

  	        if (position.due) {
  	          const trulyOverdue =
  	            (position.remainingKM !== null && position.remainingKM < 0) ||
  	            (position.remainingDays !== null && position.remainingDays < 0);

  	          add({
  	            key: "Maintenance:Plan:" + plan.PlanId + ":Due",
  	            category: "Maintenance",
  	            code: trulyOverdue ? "PREVENTIVE_MAINTENANCE_OVERDUE" : "PREVENTIVE_MAINTENANCE_DUE",
  	            severity: trulyOverdue || plan.Priority === "Critical" ? "critical" : "high",
  	            title: plan.Name + (trulyOverdue ? " is overdue" : " is due now"),
  	            message: evidence + ".",
  	            actual: evidence,
  	            threshold: threshold
  	          });
  	        } else if (position.dueSoon) {
  	          const closeByCounter =
  	            position.remainingKM !== null &&
  	            plan.WarningKM > 0 &&
  	            position.remainingKM <= Math.min(500, plan.WarningKM);

  	          const closeByTime =
  	            position.remainingDays !== null &&
  	            position.remainingDays <= 7;

  	          add({
  	            key: "Maintenance:Plan:" + plan.PlanId + ":DueSoon",
  	            category: "Maintenance",
  	            code: "PREVENTIVE_MAINTENANCE_DUE_SOON",
  	            severity: closeByCounter || closeByTime || plan.Priority === "Critical" ? "high" : "warning",
  	            title: plan.Name + " is due soon",
  	            message: evidence + ".",
  	            actual: evidence,
  	            threshold: threshold
  	          });
  	        }
  	      });
  	    }

  	    if (snapshotAlertPermission("tyres")) {
  	      snapshotVehicleTyres(company, vehicle).forEach(function (tyre) {
  	        const tyreId = alertObjectId(tyre) || snapshotTyreLabel(tyre);
  	        const tyreLabel = snapshotTyreLabel(tyre);
  	        const position = snapshotTyrePosition(tyre);
  	        const threshold = snapshotTyreThreshold(tyre, vehicle);
  	        const remaining = snapshotTyreRemaining(tyre);

  	        if (threshold === null || remaining === null || remaining > threshold) return;

  	        const critical = remaining <= 0;

  	        add({
  	          key: "Tyre:" + tyreId + ":" + (counterType === "Hours" ? "HourThreshold" : "MileageThreshold"),
  	          category: "Tyres",
  	          code: critical
  	            ? counterType === "Hours" ? "TYRE_HOURS_CRITICAL" : "TYRE_MILEAGE_CRITICAL"
  	            : counterType === "Hours" ? "TYRE_HOURS_WARNING" : "TYRE_MILEAGE_WARNING",
  	          severity: critical ? "critical" : "high",
  	          title: critical
  	            ? tyreLabel + " has no remaining tyre " + (counterType === "Hours" ? "operating hours" : "mileage")
  	            : tyreLabel + " reached its tyre warning threshold",
  	          message:
  	            tyreLabel +
  	            (position ? " at " + position : "") +
  	            (critical
  	              ? " has reached zero remaining " + (counterType === "Hours" ? "operating hours." : "mileage.")
  	              : " has " + formatNumber(remaining, 0) + " " + unit + " remaining."),
  	          actual: formatNumber(Math.max(0, remaining), 0) + " " + unit + " remaining",
  	          threshold: formatNumber(threshold, 0) + " " + unit + " warning threshold",
  	          position: position
  	        });
  	      });
  	    }

  	    if (snapshotAlertPermission("compliance")) {
  	      snapshotComplianceAlerts(vehicle, add);
  	    }

  	    if (snapshotAlertPermission("maintenance") || snapshotAlertPermission("service")) {
  	      snapshotMaintenanceRows(vehicle)
  	        .filter(function (record) {
  	          const category = alertLower(snapshotMaintenanceCategory(record));
  	          return ["service", "maintenance"].indexOf(category) !== -1 &&
  	            SNAPSHOT_OPEN_WORKSHOP_STATUSES.indexOf(snapshotWorkshopStatus(record)) !== -1;
  	        })
  	        .forEach(function (record) {
  	          const category = alertLower(snapshotMaintenanceCategory(record));
  	          if (category === "service" && !snapshotAlertPermission("service")) return;
  	          if (category === "maintenance" && !snapshotAlertPermission("maintenance")) return;

  	          const phase = snapshotWorkshopStatus(record);
  	          const phaseAge = snapshotWorkshopPhaseAgeDays(record);
  	          const scheduledDays = record.ScheduledDate ? alertDaysUntil(record.ScheduledDate) : null;
  	          const expectedDays = record.DelayExpectedDate ? alertDaysUntil(record.DelayExpectedDate) : null;
  	          const titlePrefix = category === "service" ? "Service" : "Maintenance";
  	          const workOrderId = alertClean(record.WorkOrderId || alertObjectId(record) || "Workshop job");

  	          if (
  	            category === "maintenance" &&
  	            (record.OperationalBlock === true || record.SafeToOperate === false)
  	          ) {
  	            add({
  	              key: "Workshop:" + workOrderId + ":Unsafe",
  	              category: "Maintenance",
  	              code: "MAINTENANCE_OPERATIONAL_BLOCK",
  	              severity: "critical",
  	              title: "Vehicle is not safe to operate",
  	              message: workOrderId + " is open and blocks normal vehicle operation.",
  	              actual: phase,
  	              threshold: "Safe to operate"
  	            });
  	          } else if (
  	            category === "maintenance" &&
  	            alertLower(record.Priority) === "critical"
  	          ) {
  	            add({
  	              key: "Workshop:" + workOrderId + ":CriticalPriority",
  	              category: "Maintenance",
  	              code: "CRITICAL_MAINTENANCE_JOB_OPEN",
  	              severity: "high",
  	              title: "Critical maintenance job is open",
  	              message: workOrderId + " requires priority workshop attention.",
  	              actual: phase,
  	              threshold: "Critical priority"
  	            });
  	          }

  	          if (phase === "Scheduled" && scheduledDays !== null && scheduledDays < 0) {
  	            add({
  	              key: "Workshop:" + workOrderId + ":BookingOverdue",
  	              category: titlePrefix,
  	              code: "WORKSHOP_BOOKING_OVERDUE",
  	              severity: "high",
  	              title: titlePrefix + " booking is not confirmed",
  	              message: workOrderId + " passed its proposed date " + Math.abs(scheduledDays) + " day" + (Math.abs(scheduledDays) === 1 ? "" : "s") + " ago and is still Scheduled.",
  	              actual: phase,
  	              threshold: alertFormatDate(record.ScheduledDate)
  	            });
  	          }

  	          if (phase === "Booked" && scheduledDays !== null && scheduledDays < -1) {
  	            add({
  	              key: "Workshop:" + workOrderId + ":StartOverdue",
  	              category: titlePrefix,
  	              code: "WORKSHOP_START_OVERDUE",
  	              severity: "high",
  	              title: titlePrefix + " work has not started",
  	              message: workOrderId + " is Booked but its confirmed date has passed.",
  	              actual: phase,
  	              threshold: alertFormatDate(record.ScheduledDate)
  	            });
  	          }

  	          if (phase === "In Progress" && phaseAge >= 3) {
  	            add({
  	              key: "Workshop:" + workOrderId + ":Stalled",
  	              category: titlePrefix,
  	              code: "WORKSHOP_STALLED",
  	              severity: phaseAge >= 7 ? "high" : "warning",
  	              title: titlePrefix + " job may be stalled",
  	              message: workOrderId + " has remained In Progress for " + phaseAge + " days without a phase change.",
  	              actual: phaseAge + " days",
  	              threshold: "Review after 3 days"
  	            });
  	          }

  	          if (phase === "Waiting Parts" && expectedDays !== null && expectedDays < 0) {
  	            add({
  	              key: "Workshop:" + workOrderId + ":PartsLate",
  	              category: titlePrefix,
  	              code: "WORKSHOP_PARTS_OVERDUE",
  	              severity: "high",
  	              title: "Parts review date has passed",
  	              message: workOrderId + " is delayed and its expected-parts or review date has passed.",
  	              actual: phase,
  	              threshold: alertFormatDate(record.DelayExpectedDate)
  	            });
  	          }

  	          if (phase === "Ready" && phaseAge >= 1) {
  	            add({
  	              key: "Workshop:" + workOrderId + ":Ready",
  	              category: titlePrefix,
  	              code: "WORKSHOP_READY_UNCLOSED",
  	              severity: phaseAge >= 3 ? "high" : "warning",
  	              title: "Ready job is not completed",
  	              message: workOrderId + " has been Ready for " + phaseAge + " day" + (phaseAge === 1 ? "" : "s") + ".",
  	              actual: phase,
  	              threshold: "Complete after acceptance"
  	            });
  	          }
  	        });
  	    }

  	    if (snapshotAlertPermission("fuel")) {
  	      snapshotFuelAlert(vehicle, add);
  	    }

  	    snapshotLegacyAlerts(vehicle, add);

  	    return alerts.sort(function (a, b) {
  	      const severity = alertSeverityRank(a.severity) - alertSeverityRank(b.severity);
  	      if (severity) return severity;

  	      const category = String(a.category || "").localeCompare(String(b.category || ""), undefined, { numeric: true });
  	      if (category) return category;

  	      return String(a.title || "").localeCompare(String(b.title || ""), undefined, { numeric: true });
  	    });
  	  }

  	  function snapshotFleetOperationalAlerts(selectedCompanies) {
  	    const alerts = [];

  	    arr(selectedCompanies).forEach(function (company) {
  	      arr(company && company.Tractors).forEach(function (vehicle) {
  	        snapshotDashboardAlerts(company, vehicle).forEach(function (alert) {
  	          alerts.push(alert);
  	        });
  	      });
  	    });

  	    return alerts.sort(function (a, b) {
  	      const rank = alertSeverityRank(a.severity) - alertSeverityRank(b.severity);
  	      if (rank) return rank;
  	      const companyCompare = String(a.companyLabel || "").localeCompare(String(b.companyLabel || ""), undefined, { numeric: true });
  	      if (companyCompare) return companyCompare;
  	      return String(a.vehicleLabel || "").localeCompare(String(b.vehicleLabel || ""), undefined, { numeric: true });
  	    });
  	  }

  	  function buildSnapshot(selectedCompanies) {
  	    const period = firstReportPeriod(selectedCompanies);
  	    // Transaction-day filters must use today's actual South African date,
  	    // not a potentially stale date stored by the last telemetry Worker run.
  	    const todayKey = sastDateKeyFromValue(Date.now()) || period.todayKey || "";
  	    const monthKey = period.monthKey || currentMonthKey();
  	    const dateKey = period.dateKey || "";
  	    const vehicleRows = [];
  	    const tankRows = [];

  	    let totalKm = 0;
  	    let totalEngineHours = 0;
  	    let totalMovingHours = 0;
  	    let monthlyTopSpeed = null;
  	    let monthlyTopRpm = null;
  	    let monthlyIdleIncidents = 0;
  	    let monthlySpeedingIncidents = 0;
  	    let monthlyOverRevIncidents = 0;
  	    let monthlyOverTempIncidents = 0;
  	    let monthlyOverTempSeconds = 0;
  	    let monthlyIdleSeconds = 0;
  	    let monthlySpeedingDistanceKm = 0;
  	    let monthlyOverRevDistanceKm = 0;
  	    let monthlyOverTempDistanceKm = 0;
  	    let monthlyTopTemp = null;
  	    let monthlyMileageVehicles = 0;
  	    let monthlyMovingVehicles = 0;
  	    let monthlyReportsAvailable = 0;
  	    let mileageVehiclesIncluded = 0;
  	    let mileageVehiclesExcluded = 0;
  	    let excludedMonthlyKm = 0;
  	    let excludedYesterdayKm = 0;
  	    let excludedTodayKm = 0;

  	    let todayKm = 0;
  	    let todayEngineHours = 0;
  	    let todayMovingHours = 0;
  	    let todayTopSpeed = null;
  	    let todayTopRpm = null;
  	    let todayIdleIncidents = 0;
  	    let todaySpeedingIncidents = 0;
  	    let todayOverRevIncidents = 0;
  	    let todayOverTempIncidents = 0;
  	    let todayIdleSeconds = 0;
  	    let todaySpeedingDistanceKm = 0;
  	    let todayOverRevDistanceKm = 0;
  	    let todayOverTempDistanceKm = 0;
  	    let todayOverTempSeconds = 0;
  	    let todayTopTemp = null;
  	    let todayMileageVehicles = 0;
  	    let todayMovingVehicles = 0;
  	    let currentReportsAvailable = 0;

  	    let yesterdayKm = 0;
  	    let yesterdayEngineHours = 0;
  	    let yesterdayMovingHours = 0;
  	    let yesterdayTopSpeed = null;
  	    let yesterdayTopRpm = null;
  	    let yesterdayIdleIncidents = 0;
  	    let yesterdaySpeedingIncidents = 0;
  	    let yesterdayOverRevIncidents = 0;
  	    let yesterdayOverTempIncidents = 0;
  	    let yesterdayIdleSeconds = 0;
  	    let yesterdaySpeedingDistanceKm = 0;
  	    let yesterdayOverRevDistanceKm = 0;
  	    let yesterdayOverTempDistanceKm = 0;
  	    let yesterdayOverTempSeconds = 0;
  	    let yesterdayTopTemp = null;
  	    let yesterdayMileageVehicles = 0;
  	    let yesterdayMovingVehicles = 0;
  	    let dailyReportsAvailable = 0;

  	    let totalHours = 0;
  	    let totalLitres = 0;
  	    let totalFuelCost = 0;
  	    let distanceLitres = 0;
  	    let distanceFuelCost = 0;
  	    let hourLitres = 0;
  	    let hourFuelCost = 0;

  	    // Simplified Snapshot period fuel/usage totals.
  	    let distanceFuelToday = 0;
  	    let distanceFuelYesterday = 0;
  	    let hourFuelToday = 0;
  	    let hourFuelYesterday = 0;
  	    let hourUsageToday = 0;
  	    let hourUsageYesterday = 0;
  	    let activeDistanceVehicles = 0;
  	    let activeHourVehicles = 0;
  	    let fuelTransactions = 0;
  	    let hourFuelTransactions = 0;
  	    let maxReportDays = 0;

  	    function maxNullable(current, value) {
  	      if (!hasNumber(value)) return current;
  	      const num = Number(value);
  	      return current == null ? num : Math.max(current, num);
  	    }

  	    selectedCompanies.forEach(function (company) {
  	      arr(company.Tractors).forEach(function (vehicle) {
  	        const view = recordMonthView(vehicle, monthKey);
  	        const hoursVehicle = isHoursVehicle(vehicle);
  	        const rawCurrent = vehicleCurrentReport(vehicle);
  	        const storedTodayKey = reportTodayKey(vehicle);
  	        // A previous day's report in Snapshot.today is stale, not "today".
  	        const current = rawCurrent && (!storedTodayKey || storedTodayKey === todayKey)
  	          ? rawCurrent : null;
  	        const daily = vehicleDailyReport(vehicle);
  	        const monthly = vehicleMonthlyReport(vehicle);
  	        const monthlySummary = monthlyReportSummary(monthly);

  	        const hasCurrent = !!current;
  	        const hasDaily = !!daily;
  	        const hasMonthly = !!monthly;

  	        if (hasCurrent) currentReportsAvailable++;
  	        if (hasDaily) dailyReportsAvailable++;
  	        if (hasMonthly) monthlyReportsAvailable++;

  	        /*
  	         * Fleet mileage rule:
  	         * A vehicle contributes mileage to Snapshot only when it has actually
  	         * received fuel in the current reporting month.
  	         *
  	         * This prevents unfuelled vehicles from inflating Total KM,
  	         * Avg KM / Vehicle, Avg KM / Day, km/L and fuel-cost-per-km figures.
  	         */
  	        const litres = viewFuelLitres(view);
  	        const fuelCost = viewFuelCost(view);
  	        const fuelRows = validFuelTransactions(view);
  	        const transactions = view
  	          ? (hasNumber(view.TransactionCount) ? n(view.TransactionCount) : fuelRows.length)
  	          : 0;

  	        const fuelTodayForVehicle = sum(
  	          fuelRows.filter(function (row) {
  	            return fuelTransactionDateKey(row) === todayKey;
  	          }),
  	          function (row) { return row.Litres; }
  	        );

  	        const fuelYesterdayForVehicle = sum(
  	          fuelRows.filter(function (row) {
  	            return fuelTransactionDateKey(row) === dateKey;
  	          }),
  	          function (row) { return row.Litres; }
  	        );

  	        const fuelSupplied =
  	          litres > 0;

  	        const rawMonthlyDistance = hoursVehicle
  	          ? 0
  	          : n(
  	              hasNumber(monthlySummary.distance_km)
  	                ? monthlySummary.distance_km
  	                : (monthly && monthly.distance_km),
  	              0
  	            );

  	        const distance =
  	          fuelSupplied
  	            ? rawMonthlyDistance
  	            : 0;

  	        const engineHours = reportSecondsToHours(
  	          hasNumber(monthlySummary.engine_seconds)
  	            ? monthlySummary.engine_seconds
  	            : (monthly && monthly.engine_seconds)
  	        );

  	        const movingHours = reportSecondsToHours(
  	          hasNumber(monthlySummary.moving_seconds)
  	            ? monthlySummary.moving_seconds
  	            : (monthly && monthly.moving_seconds)
  	        );

  	        const rawCurrentDistance =
  	          hoursVehicle
  	            ? 0
  	            : n(current && current.distance_km, 0);

  	        /*
  	         * The same fleet-mileage rule applies to Today:
  	         * vehicles with no supplied fuel for the reporting month
  	         * do not contribute mileage-based totals.
  	         */
  	        const currentDistance =
  	          fuelSupplied
  	            ? rawCurrentDistance
  	            : 0;

  	        const currentEngineHours =
  	          reportSecondsToHours(
  	            current && current.engine_seconds
  	          );

  	        const currentMovingHours =
  	          reportSecondsToHours(
  	            current && current.moving_seconds
  	          );


  	        const rawDailyDistance =
  	          hoursVehicle
  	            ? 0
  	            : n(daily && daily.distance_km, 0);

  	        const dailyDistance =
  	          fuelSupplied
  	            ? rawDailyDistance
  	            : 0;

  	        const dailyEngineHours = reportSecondsToHours(daily && daily.engine_seconds);
  	        const dailyMovingHours = reportSecondsToHours(daily && daily.moving_seconds);

  	        const monthIdle = n(monthlySummary.idle_incidents, 0);
  	        const monthSpeeding = n(monthlySummary.speeding_incidents, 0);
  	        const monthOverRev = n(monthlySummary.over_rev_incidents, 0);
  	        const monthOverTemp = n(monthlySummary.over_temperature_incidents, 0);

  	        const monthIdleSeconds = Math.max(0, n(monthlySummary.idle_seconds, 0));
  	        const monthSpeedingDistance = Math.max(0, n(monthlySummary.speeding_distance_km, 0));
  	        const monthOverRevDistance = Math.max(0, n(monthlySummary.over_rev_distance_km, 0));
  	        const monthOverTempSeconds = Math.max(0, n(monthlySummary.over_temperature_seconds, 0));
  	        const monthOverTempDistance = Math.max(0, n(monthlySummary.over_temperature_distance_km, 0));
  	        const monthTopTemp = reportTopTemperature(monthlySummary);

  	        const currentIdle =
  	          dailySummaryCount(
  	            current,
  	            "idle_summary"
  	          );

  	        const currentSpeeding =
  	          dailySummaryCount(
  	            current,
  	            "speeding_summary"
  	          );

  	        const currentOverRev =
  	          dailySummaryCount(
  	            current,
  	            "over_rev_summary"
  	          );

  	        const currentOverTemp =
  	          dailySummaryCount(
  	            current,
  	            "over_temperature_summary"
  	          );

  	        const currentIdleSeconds =
  	          dailySummaryDuration(current, "idle_summary");
  	        const currentSpeedingDistance =
  	          dailySummaryDistance(current, "speeding_summary");
  	        const currentOverRevDistance =
  	          dailySummaryDistance(current, "over_rev_summary");
  	        const currentOverTempSeconds =
  	          dailySummaryDuration(current, "over_temperature_summary");
  	        const currentOverTempDistance =
  	          dailySummaryDistance(current, "over_temperature_summary");
  	        const currentTopTemp =
  	          reportTopTemperature(current);

  	        const dayIdle = dailySummaryCount(daily, "idle_summary");
  	        const daySpeeding = dailySummaryCount(daily, "speeding_summary");
  	        const dayOverRev = dailySummaryCount(daily, "over_rev_summary");
  	        const dayOverTemp = dailySummaryCount(daily, "over_temperature_summary");

  	        const dayIdleSeconds =
  	          dailySummaryDuration(daily, "idle_summary");
  	        const daySpeedingDistance =
  	          dailySummaryDistance(daily, "speeding_summary");
  	        const dayOverRevDistance =
  	          dailySummaryDistance(daily, "over_rev_summary");
  	        const dayOverTempSeconds =
  	          dailySummaryDuration(daily, "over_temperature_summary");
  	        const dayOverTempDistance =
  	          dailySummaryDistance(daily, "over_temperature_summary");
  	        const dayTopTemp =
  	          reportTopTemperature(daily);

  	        maxReportDays = Math.max(
  	          maxReportDays,
  	          n(monthlySummary.days_with_data, 0)
  	        );

  	        monthlyTopSpeed = maxNullable(
  	          monthlyTopSpeed,
  	          hasNumber(monthlySummary.top_speed)
  	            ? monthlySummary.top_speed
  	            : (monthly && monthly.top_speed)
  	        );
  	        monthlyTopRpm = maxNullable(
  	          monthlyTopRpm,
  	          hasNumber(monthlySummary.top_rpm)
  	            ? monthlySummary.top_rpm
  	            : (monthly && monthly.top_rpm)
  	        );
  	        todayTopSpeed =
  	          maxNullable(
  	            todayTopSpeed,
  	            current && current.top_speed
  	          );

  	        todayTopRpm =
  	          maxNullable(
  	            todayTopRpm,
  	            current && current.top_rpm
  	          );

  	        yesterdayTopSpeed = maxNullable(yesterdayTopSpeed, daily && daily.top_speed);
  	        yesterdayTopRpm = maxNullable(yesterdayTopRpm, daily && daily.top_rpm);

  	        monthlyTopTemp = maxNullable(monthlyTopTemp, monthTopTemp);
  	        todayTopTemp = maxNullable(todayTopTemp, currentTopTemp);
  	        yesterdayTopTemp = maxNullable(yesterdayTopTemp, dayTopTemp);

  	        if (!hoursVehicle) {
  	          if (fuelSupplied) {
  	            mileageVehiclesIncluded++;

  	            if (hasMonthly) {
  	              monthlyMileageVehicles++;
  	              if (movingHours > 0) monthlyMovingVehicles++;
  	            }

  	            if (hasCurrent) {
  	              todayMileageVehicles++;
  	              if (currentMovingHours > 0) todayMovingVehicles++;
  	            }

  	            if (hasDaily) {
  	              yesterdayMileageVehicles++;
  	              if (dailyMovingHours > 0) yesterdayMovingVehicles++;
  	            }
  	          } else {
  	            mileageVehiclesExcluded++;
  	            excludedMonthlyKm += rawMonthlyDistance;
  	            excludedYesterdayKm += rawDailyDistance;
  	            excludedTodayKm += rawCurrentDistance;
  	          }
  	        }

  	        totalKm += distance;
  	        totalEngineHours += engineHours;
  	        totalMovingHours += movingHours;
  	        monthlyIdleIncidents += monthIdle;
  	        monthlySpeedingIncidents += monthSpeeding;
  	        monthlyOverRevIncidents += monthOverRev;
  	        monthlyOverTempIncidents += monthOverTemp;
  	        monthlyIdleSeconds += monthIdleSeconds;
  	        monthlyOverTempSeconds += monthOverTempSeconds;
  	        if (fuelSupplied && !hoursVehicle) {
  	          monthlySpeedingDistanceKm += monthSpeedingDistance;
  	          monthlyOverRevDistanceKm += monthOverRevDistance;
  	          monthlyOverTempDistanceKm += monthOverTempDistance;
  	        }

  	        todayKm += currentDistance;
  	        todayEngineHours += currentEngineHours;
  	        todayMovingHours += currentMovingHours;
  	        todayIdleIncidents += currentIdle;
  	        todaySpeedingIncidents += currentSpeeding;
  	        todayOverRevIncidents += currentOverRev;
  	        todayOverTempIncidents += currentOverTemp;
  	        todayIdleSeconds += currentIdleSeconds;
  	        todayOverTempSeconds += currentOverTempSeconds;
  	        if (fuelSupplied && !hoursVehicle) {
  	          todaySpeedingDistanceKm += currentSpeedingDistance;
  	          todayOverRevDistanceKm += currentOverRevDistance;
  	          todayOverTempDistanceKm += currentOverTempDistance;
  	        }

  	        yesterdayKm += dailyDistance;
  	        yesterdayEngineHours += dailyEngineHours;
  	        yesterdayMovingHours += dailyMovingHours;
  	        yesterdayIdleIncidents += dayIdle;
  	        yesterdaySpeedingIncidents += daySpeeding;
  	        yesterdayOverRevIncidents += dayOverRev;
  	        yesterdayOverTempIncidents += dayOverTemp;
  	        yesterdayIdleSeconds += dayIdleSeconds;
  	        yesterdayOverTempSeconds += dayOverTempSeconds;
  	        if (fuelSupplied && !hoursVehicle) {
  	          yesterdaySpeedingDistanceKm += daySpeedingDistance;
  	          yesterdayOverRevDistanceKm += dayOverRevDistance;
  	          yesterdayOverTempDistanceKm += dayOverTempDistance;
  	        }

  	        const hours = hoursVehicle ? viewHours(view) : 0;
  	        const hobbsReading = hoursVehicle ? currentHobbsReading(vehicle) : null;

  	        const monthActive = hoursVehicle
  	          ? (hours > 0 || litres > 0 || transactions > 0 || hasMonthly)
  	          : fuelSupplied;

  	        totalLitres += litres;
  	        totalFuelCost += fuelCost;
  	        fuelTransactions += transactions;

  	        if (hoursVehicle) {
  	          totalHours += hours;
  	          hourLitres += litres;
  	          hourFuelCost += fuelCost;
  	          hourFuelTransactions += transactions;

  	          // Daily hour usage uses the corrected Flespi engine runtime.
  	          // Month-to-date hour usage remains the existing Hobbs/ViewC total.
  	          hourUsageToday += currentEngineHours;
  	          hourUsageYesterday += dailyEngineHours;
  	          hourFuelToday += fuelTodayForVehicle;
  	          hourFuelYesterday += fuelYesterdayForVehicle;

  	          if (monthActive) activeHourVehicles++;
  	        } else {
  	          distanceLitres += litres;
  	          distanceFuelCost += fuelCost;
  	          distanceFuelToday += fuelTodayForVehicle;
  	          distanceFuelYesterday += fuelYesterdayForVehicle;
  	          if (monthActive) activeDistanceVehicles++;
  	        }

  	        const loc = vehicle.Location || {};
  	        const liveSnapshot = vehicleLiveSnapshot(vehicle) || {};
  	        const can = vehicle.CAN || {};

  	        const runtimeTs = locationTimestamp(loc);
  	        const cachedTs = asEpochMs(liveSnapshot.timestamp);
  	        const ts = Math.max(runtimeTs || 0, cachedTs || 0);

  	        const age = ts ? Date.now() - ts : Infinity;
  	        const online = age >= -300000 && age <= 15 * 60 * 1000;
  	        const stale = !!vehicle.Tracker && (!ts || age > 60 * 60 * 1000);

  	        const runtimeSpeed =
  	          locationNumber(loc, ["position.speed", "can.vehicle.speed", "gps.speed"]);
  	        const runtimeRpm =
  	          locationNumber(loc, ["can.engine.rpm", "engine.rpm"]);

  	        const speed =
  	          runtimeSpeed != null
  	            ? runtimeSpeed
  	            : (hasNumber(liveSnapshot.speed) ? Number(liveSnapshot.speed) : null);

  	        const rpm =
  	          runtimeRpm != null
  	            ? runtimeRpm
  	            : (hasNumber(liveSnapshot.rpm) ? Number(liveSnapshot.rpm) : null);

  	        const speedLimit = hasNumber(can.Speed) ? n(can.Speed) : null;
  	        const rpmLimit = hasNumber(can.RPM) ? n(can.RPM) : null;

  	        let idle =
  	          typeof liveSnapshot.idle_status === "boolean"
  	            ? liveSnapshot.idle_status
  	            : truthyLocation(loc, ["idle.status", "idle"]);

  	        if (idle == null && online && rpm != null && speed != null) {
  	          idle = rpm >= 400 && speed <= 1;
  	        }

  	        const moving = online && speed != null && speed > 1;
  	        const speeding =
  	          online &&
  	          speed != null &&
  	          speedLimit != null &&
  	          speedLimit > 0 &&
  	          speed > speedLimit;

  	        const overRev =
  	          online &&
  	          rpm != null &&
  	          rpmLimit != null &&
  	          rpmLimit > 0 &&
  	          rpm > rpmLimit;

  	        vehicleRows.push({
  	          company: company,
  	          vehicle: vehicle,
  	          label: vehicleLabel(vehicle),
  	          view: view,
  	          current: current,
  	          daily: daily,
  	          monthly: monthly,
  	          monthlySummary: monthlySummary,
  	          hasCurrent: hasCurrent,
  	          hasDaily: hasDaily,
  	          hasMonthly: hasMonthly,
  	          hoursVehicle: hoursVehicle,
  	          counterType: text(vehicle.CounterType, "KM"),
  	          distance: distance,
  	          rawMonthlyDistance: rawMonthlyDistance,
  	          fuelSupplied: fuelSupplied,
  	          engineHours: engineHours,
  	          movingHours: movingHours,
  	          currentDistance: currentDistance,
  	          rawCurrentDistance: rawCurrentDistance,
  	          currentEngineHours: currentEngineHours,
  	          currentMovingHours: currentMovingHours,
  	          currentIdle: currentIdle,
  	          currentSpeeding: currentSpeeding,
  	          currentOverRev: currentOverRev,
  	          currentOverTemp: currentOverTemp,
  	          dailyDistance: dailyDistance,
  	          rawDailyDistance: rawDailyDistance,
  	          dailyEngineHours: dailyEngineHours,
  	          dailyMovingHours: dailyMovingHours,
  	          monthIdle: monthIdle,
  	          monthSpeeding: monthSpeeding,
  	          monthOverRev: monthOverRev,
  	          monthOverTemp: monthOverTemp,
  	          dayIdle: dayIdle,
  	          daySpeeding: daySpeeding,
  	          dayOverRev: dayOverRev,
  	          dayOverTemp: dayOverTemp,
  	          hours: hours,
  	          hobbsReading: hobbsReading,
  	          litres: litres,
  	          fuelCost: fuelCost,
  	          monthActive: monthActive,
  	          ts: ts,
  	          online: online,
  	          stale: stale,
  	          speed: speed,
  	          rpm: rpm,
  	          speedLimit: speedLimit,
  	          rpmLimit: rpmLimit,
  	          idle: idle === true,
  	          moving: moving,
  	          speeding: speeding,
  	          overRev: overRev
  	        });
  	      });

  	      arr(company.Tanks).forEach(function (tank) {
  	        const capacity = Math.max(0, n(tank.Capacity, 0));
  	        const volume = Math.max(0, n(tank.Volume, 0));
  	        const levelPct = capacity > 0
  	          ? clamp((volume / capacity) * 100, 0, 100)
  	          : clamp(n(tank.Level, 0) * (n(tank.Level, 0) <= 1 ? 100 : 1), 0, 100);
  	        const atg = tankAtgSnapshot(tank);
  	        const atgVolume = atg.available ? Math.max(0, atg.volume) : null;
  	        const atgLevelPct = atg.available && capacity > 0
  	          ? clamp((atgVolume / capacity) * 100, 0, 100)
  	          : null;
  	        const atgDifference = atg.available ? atgVolume - volume : null;

  	        const bowserRows = arr(tank.Bowsers).map(function (bowser) {
  	          const bv = recordMonthView(bowser, monthKey);
  	          return {
  	            name: text(bowser.Name, "Bowser"),
  	            litres: n(bv && bv.Litres, 0),
  	            meterStart: hasNumber(bv && bv.MeterStart) ? n(bv.MeterStart) : null,
  	            meterEnd: hasNumber(bv && bv.MeterEnd) ? n(bv.MeterEnd) : null
  	          };
  	        });

  	        const bowserOut = sum(bowserRows, function (x) { return x.litres; });
  	        const orderThreshold = Math.max(0, n(tank.OrderThreshold, 0));

  	        tankRows.push({
  	          company: company,
  	          tank: tank,
  	          label: tankLabel(tank),
  	          grade: text(tank.Grade, "Fuel"),
  	          capacity: capacity,
  	          volume: volume,
  	          levelPct: levelPct,
  	          atg: atg,
  	          atgAvailable: atg.available,
  	          atgVolume: atgVolume,
  	          atgLevelPct: atgLevelPct,
  	          atgDifference: atgDifference,
  	          orderThreshold: orderThreshold,
  	          bowserRows: bowserRows,
  	          bowserOut: bowserOut,
  	          low: orderThreshold > 0 && volume <= orderThreshold
  	        });
  	      });
  	    });

  	    const distanceVehicleRows = vehicleRows.filter(function (x) { return !x.hoursVehicle; });
  	    const hourVehicleRows = vehicleRows.filter(function (x) { return x.hoursVehicle; });

  	    const tankCapacity = sum(tankRows, function (x) { return x.capacity; });
  	    const tankVolume = sum(tankRows, function (x) { return x.volume; });
  	    const tankLevelPct = tankCapacity > 0 ? (tankVolume / tankCapacity) * 100 : 0;
  	    const bowserOut = sum(tankRows, function (x) { return x.bowserOut; });
  	    const atgRows = tankRows.filter(function (x) { return x.atgAvailable; });
  	    const atgCapacity = sum(atgRows, function (x) { return x.capacity; });
  	    const atgVolume = sum(atgRows, function (x) { return x.atgVolume; });
  	    const atgBookVolume = sum(atgRows, function (x) { return x.volume; });
  	    const atgLevelPct = atgCapacity > 0 ? (atgVolume / atgCapacity) * 100 : 0;
  	    const atgVariance = atgVolume - atgBookVolume;
  	    const atgStaleCount = atgRows.filter(function (x) { return x.atg.stale; }).length;

  	    const onlineRows = vehicleRows.filter(function (x) { return x.online; });
  	    const movingRows = vehicleRows.filter(function (x) { return x.moving; });
  	    const idlingRows = vehicleRows.filter(function (x) { return x.online && x.idle; });
  	    const speedingRows = vehicleRows.filter(function (x) { return x.speeding; });
  	    const overRevRows = vehicleRows.filter(function (x) { return x.overRev; });
  	    const speedMonitored = vehicleRows.filter(function (x) { return x.online && x.speed != null && x.speedLimit != null && x.speedLimit > 0; });
  	    const rpmMonitored = vehicleRows.filter(function (x) { return x.online && x.rpm != null && x.rpmLimit != null && x.rpmLimit > 0; });
  	    const staleRows = vehicleRows.filter(function (x) { return x.stale; });

  	    const attention = [];

  	    // Live exceptions first.
  	    speedingRows.forEach(function (x) {
  	      attention.push({
  	        level: "danger",
  	        title: x.label + " is speeding now",
  	        detail: formatNumber(x.speed, 0) + " km/h · limit " + formatNumber(x.speedLimit, 0) + " km/h"
  	      });
  	    });

  	    overRevRows.forEach(function (x) {
  	      attention.push({
  	        level: "danger",
  	        title: x.label + " is over-revving now",
  	        detail: formatNumber(x.rpm, 0) + " rpm · limit " + formatNumber(x.rpmLimit, 0) + " rpm"
  	      });
  	    });

  	    // Today's calculated report exceptions next.
  	    vehicleRows.forEach(function (x) {
  	      if (x.currentOverTemp > 0) {
  	        attention.push({
  	          level: "danger",
  	          title: x.label + " has over-temperature incidents today",
  	          detail: formatNumber(x.currentOverTemp, 0) + " incident" + (x.currentOverTemp === 1 ? "" : "s") + " since midnight"
  	        });
  	      }

  	      if (x.currentSpeeding > 0) {
  	        attention.push({
  	          level: "danger",
  	          title: x.label + " has speeding incidents today",
  	          detail: formatNumber(x.currentSpeeding, 0) + " incident" + (x.currentSpeeding === 1 ? "" : "s") + " since midnight"
  	        });
  	      }

  	      if (x.currentOverRev > 0) {
  	        attention.push({
  	          level: "warn",
  	          title: x.label + " has over-rev incidents today",
  	          detail: formatNumber(x.currentOverRev, 0) + " incident" + (x.currentOverRev === 1 ? "" : "s") + " since midnight"
  	        });
  	      }

  	      if (x.currentIdle > 0) {
  	        attention.push({
  	          level: "warn",
  	          title: x.label + " has excessive idle today",
  	          detail: formatNumber(x.currentIdle, 0) + " incident" + (x.currentIdle === 1 ? "" : "s") + " since midnight"
  	        });
  	      }
  	    });


  	    // Yesterday's report exceptions next.
  	    vehicleRows.forEach(function (x) {
  	      if (x.dayOverTemp > 0) {
  	        attention.push({
  	          level: "danger",
  	          title: x.label + " overheated yesterday",
  	          detail: formatNumber(x.dayOverTemp, 0) + " over-temperature incident" + (x.dayOverTemp === 1 ? "" : "s")
  	        });
  	      }
  	      if (x.daySpeeding > 0) {
  	        attention.push({
  	          level: "danger",
  	          title: x.label + " had speeding incidents yesterday",
  	          detail: formatNumber(x.daySpeeding, 0) + " incident" + (x.daySpeeding === 1 ? "" : "s")
  	        });
  	      }
  	      if (x.dayOverRev > 0) {
  	        attention.push({
  	          level: "warn",
  	          title: x.label + " over-revved yesterday",
  	          detail: formatNumber(x.dayOverRev, 0) + " incident" + (x.dayOverRev === 1 ? "" : "s")
  	        });
  	      }
  	      if (x.dayIdle > 0) {
  	        attention.push({
  	          level: "warn",
  	          title: x.label + " had excessive idle yesterday",
  	          detail: formatNumber(x.dayIdle, 0) + " incident" + (x.dayIdle === 1 ? "" : "s")
  	        });
  	      }
  	    });

  	    tankRows.filter(function (x) { return x.low; }).forEach(function (x) {
  	      attention.push({
  	        level: "warn",
  	        title: x.label + " is at / below reorder level",
  	        detail: formatNumber(x.volume, 0) + " L remaining · threshold " + formatNumber(x.orderThreshold, 0) + " L"
  	      });
  	    });

  	    const reportDays = Math.max(1, maxReportDays || elapsedDaysThisMonth());

  	    const todayPeriod = {
  	      distanceKm: todayKm,
  	      avgKmMovingVehicle: todayMovingVehicles > 0 ? todayKm / todayMovingVehicles : 0,
  	      avgKmVehicle: todayMileageVehicles > 0 ? todayKm / todayMileageVehicles : 0,
  	      mileageVehicles: todayMileageVehicles,
  	      movingVehicles: todayMovingVehicles,
  	      engineSeconds: todayEngineHours * 3600,
  	      idleSeconds: todayIdleSeconds,
  	      idleIncidents: todayIdleIncidents,
  	      idleRuntimePct: safePercent(todayIdleSeconds, todayEngineHours * 3600),
  	      topSpeed: todayTopSpeed,
  	      speedingMileagePct: safePercent(todaySpeedingDistanceKm, todayKm),
  	      topRpm: todayTopRpm,
  	      overRevMileagePct: safePercent(todayOverRevDistanceKm, todayKm),
  	      topTemp: todayTopTemp,
  	      overTempMileagePct: safePercent(todayOverTempDistanceKm, todayKm)
  	    };

  	    const yesterdayPeriod = {
  	      distanceKm: yesterdayKm,
  	      avgKmMovingVehicle: yesterdayMovingVehicles > 0 ? yesterdayKm / yesterdayMovingVehicles : 0,
  	      avgKmVehicle: yesterdayMileageVehicles > 0 ? yesterdayKm / yesterdayMileageVehicles : 0,
  	      mileageVehicles: yesterdayMileageVehicles,
  	      movingVehicles: yesterdayMovingVehicles,
  	      engineSeconds: yesterdayEngineHours * 3600,
  	      idleSeconds: yesterdayIdleSeconds,
  	      idleIncidents: yesterdayIdleIncidents,
  	      idleRuntimePct: safePercent(yesterdayIdleSeconds, yesterdayEngineHours * 3600),
  	      topSpeed: yesterdayTopSpeed,
  	      speedingMileagePct: safePercent(yesterdaySpeedingDistanceKm, yesterdayKm),
  	      topRpm: yesterdayTopRpm,
  	      overRevMileagePct: safePercent(yesterdayOverRevDistanceKm, yesterdayKm),
  	      topTemp: yesterdayTopTemp,
  	      overTempMileagePct: safePercent(yesterdayOverTempDistanceKm, yesterdayKm)
  	    };

  	    const monthlyPeriod = {
  	      distanceKm: totalKm,
  	      avgKmMovingVehicle: monthlyMovingVehicles > 0 ? totalKm / monthlyMovingVehicles : 0,
  	      avgKmVehicle: monthlyMileageVehicles > 0 ? totalKm / monthlyMileageVehicles : 0,
  	      mileageVehicles: monthlyMileageVehicles,
  	      movingVehicles: monthlyMovingVehicles,
  	      engineSeconds: totalEngineHours * 3600,
  	      idleSeconds: monthlyIdleSeconds,
  	      idleIncidents: monthlyIdleIncidents,
  	      idleRuntimePct: safePercent(monthlyIdleSeconds, totalEngineHours * 3600),
  	      topSpeed: monthlyTopSpeed,
  	      speedingMileagePct: safePercent(monthlySpeedingDistanceKm, totalKm),
  	      topRpm: monthlyTopRpm,
  	      overRevMileagePct: safePercent(monthlyOverRevDistanceKm, totalKm),
  	      topTemp: monthlyTopTemp,
  	      overTempMileagePct: safePercent(monthlyOverTempDistanceKm, totalKm)
  	    };

  	    return {
  	      todayKey: todayKey,
  	      monthKey: monthKey,
  	      dateKey: dateKey,
  	      todayLabel: dateLabelFromKey(todayKey),
  	      monthLabel: monthLabelFromKey(monthKey),
  	      dateLabel: dateLabelFromKey(dateKey),
  	      days: reportDays,

  	      todayPeriod: todayPeriod,
  	      yesterdayPeriod: yesterdayPeriod,
  	      monthlyPeriod: monthlyPeriod,

  	      vehicleRows: vehicleRows,
  	      tankRows: tankRows,
  	      distanceVehicleRows: distanceVehicleRows,
  	      hourVehicleRows: hourVehicleRows,

  	      currentReportsAvailable: currentReportsAvailable,
  	      monthlyReportsAvailable: monthlyReportsAvailable,
  	      dailyReportsAvailable: dailyReportsAvailable,
  	      mileageVehiclesIncluded: mileageVehiclesIncluded,
  	      mileageVehiclesExcluded: mileageVehiclesExcluded,
  	      excludedMonthlyKm: excludedMonthlyKm,
  	      excludedYesterdayKm: excludedYesterdayKm,
  	      excludedTodayKm: excludedTodayKm,

  	      todayKm: todayKm,
  	      todayEngineHours: todayEngineHours,
  	      todayMovingHours: todayMovingHours,
  	      todayTopSpeed: todayTopSpeed,
  	      todayTopRpm: todayTopRpm,
  	      todayIdleIncidents: todayIdleIncidents,
  	      todaySpeedingIncidents: todaySpeedingIncidents,
  	      todayOverRevIncidents: todayOverRevIncidents,
  	      todayOverTempIncidents: todayOverTempIncidents,

  	      totalKm: totalKm,
  	      totalEngineHours: totalEngineHours,
  	      totalMovingHours: totalMovingHours,
  	      monthlyTopSpeed: monthlyTopSpeed,
  	      monthlyTopRpm: monthlyTopRpm,
  	      monthlyIdleIncidents: monthlyIdleIncidents,
  	      monthlySpeedingIncidents: monthlySpeedingIncidents,
  	      monthlyOverRevIncidents: monthlyOverRevIncidents,
  	      monthlyOverTempIncidents: monthlyOverTempIncidents,
  	      monthlyOverTempSeconds: monthlyOverTempSeconds,

  	      yesterdayKm: yesterdayKm,
  	      yesterdayEngineHours: yesterdayEngineHours,
  	      yesterdayMovingHours: yesterdayMovingHours,
  	      yesterdayTopSpeed: yesterdayTopSpeed,
  	      yesterdayTopRpm: yesterdayTopRpm,
  	      yesterdayIdleIncidents: yesterdayIdleIncidents,
  	      yesterdaySpeedingIncidents: yesterdaySpeedingIncidents,
  	      yesterdayOverRevIncidents: yesterdayOverRevIncidents,
  	      yesterdayOverTempIncidents: yesterdayOverTempIncidents,

  	      // Exact-line simplified Snapshot data.
  	      distanceFuelToday: distanceFuelToday,
  	      distanceFuelYesterday: distanceFuelYesterday,
  	      distanceFuelMonthAverage: reportDays > 0 ? distanceLitres / reportDays : 0,
  	      kmPerLitreToday: distanceFuelToday > 0 ? todayKm / distanceFuelToday : 0,
  	      kmPerLitreYesterday: distanceFuelYesterday > 0 ? yesterdayKm / distanceFuelYesterday : 0,
  	      kmPerLitreMonth: distanceLitres > 0 ? totalKm / distanceLitres : 0,

  	      hourUsageToday: hourUsageToday,
  	      hourUsageYesterday: hourUsageYesterday,
  	      hourUsageMonthAverage: reportDays > 0 ? totalHours / reportDays : 0,
  	      hourFuelToday: hourFuelToday,
  	      hourFuelYesterday: hourFuelYesterday,
  	      hourFuelMonthAverage: reportDays > 0 ? hourLitres / reportDays : 0,
  	      hoursPerLitreToday: hourFuelToday > 0 ? hourUsageToday / hourFuelToday : 0,
  	      hoursPerLitreYesterday: hourFuelYesterday > 0 ? hourUsageYesterday / hourFuelYesterday : 0,
  	      hoursPerLitreMonth: hourLitres > 0 ? totalHours / hourLitres : 0,

  	      idleTodaySeconds: todayIdleSeconds,
  	      idleYesterdaySeconds: yesterdayIdleSeconds,
  	      idleMonthAverageSeconds: reportDays > 0 ? monthlyIdleSeconds / reportDays : 0,

  	      totalHours: totalHours,
  	      totalLitres: totalLitres,
  	      totalFuelCost: totalFuelCost,
  	      distanceLitres: distanceLitres,
  	      distanceFuelCost: distanceFuelCost,
  	      hourLitres: hourLitres,
  	      hourFuelCost: hourFuelCost,
  	      activeDistanceVehicles: activeDistanceVehicles,
  	      activeHourVehicles: activeHourVehicles,
  	      fuelTransactions: fuelTransactions,
  	      hourFuelTransactions: hourFuelTransactions,

  	      avgKmVehicle: activeDistanceVehicles > 0 ? totalKm / activeDistanceVehicles : 0,
  	      avgKmDay: totalKm / reportDays,
  	      kmPerLitre: distanceLitres > 0 ? totalKm / distanceLitres : 0,
  	      randPerKm: totalKm > 0 ? distanceFuelCost / totalKm : 0,
  	      avgHoursVehicle: activeHourVehicles > 0 ? totalHours / activeHourVehicles : 0,
  	      avgHoursDay: totalHours / reportDays,
  	      litresPerHour: totalHours > 0 ? hourLitres / totalHours : 0,
  	      randPerHour: totalHours > 0 ? hourFuelCost / totalHours : 0,

  	      tankCapacity: tankCapacity,
  	      tankVolume: tankVolume,
  	      tankLevelPct: tankLevelPct,
  	      atgRows: atgRows,
  	      atgCapacity: atgCapacity,
  	      atgVolume: atgVolume,
  	      atgBookVolume: atgBookVolume,
  	      atgLevelPct: atgLevelPct,
  	      atgVariance: atgVariance,
  	      atgStaleCount: atgStaleCount,
  	      bowserOut: bowserOut,

  	      onlineRows: onlineRows,
  	      movingRows: movingRows,
  	      idlingRows: idlingRows,
  	      speedingRows: speedingRows,
  	      overRevRows: overRevRows,
  	      speedMonitored: speedMonitored,
  	      rpmMonitored: rpmMonitored,
  	      staleRows: staleRows,
  	      drivingAttention: attention,
  	      operationalAlerts: snapshotFleetOperationalAlerts(selectedCompanies),
  	      attention: attention
  	    };
  	  }

  	  const oldRoot = document.getElementById(ROOT_ID);
  	  if (oldRoot) oldRoot.remove();
  	  const oldMenu = document.getElementById(APP_MENU_ID);
  	  if (oldMenu) oldMenu.remove();
  	  const oldDialog = document.getElementById(DIALOG_ID);
  	  if (oldDialog) oldDialog.remove();
  	  const oldStyle = document.getElementById(STYLE_ID);
  	  if (oldStyle) oldStyle.remove();

  	  const style = document.createElement("style");
  	  style.id = STYLE_ID;
  	  style.textContent = `
  	    #${ROOT_ID}, #${ROOT_ID} * { box-sizing: border-box; }
  	    #${ROOT_ID} {
  	      --bg:#080d0a;
  	      --panel:#111713;
  	      --panel2:#151c17;
  	      --line:#27322a;
  	      --line2:#36443a;
  	      --text:#f4f6f4;
  	      --muted:#8e9b92;
  	      --muted2:#667169;
  	      --accent:#c66b32;
  	      --accent2:#e28a4b;
  	      --good:#63d99a;
  	      --warn:#f2c35a;
  	      --bad:#ff7474;
  	      position:fixed;
  	      inset:0;
  	      z-index:2147482000;
  	      overflow:auto;
  	      overscroll-behavior:contain;
  	      -webkit-overflow-scrolling:touch;
  	      background:
  	        radial-gradient(circle at 86% -8%, rgba(198,107,50,.16), transparent 32%),
  	        linear-gradient(180deg,#0b110d 0%,#070b08 100%);
  	      color:var(--text);
  	      font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;
  	      padding:env(safe-area-inset-top) 0 env(safe-area-inset-bottom);
  	    }
  	    #${ROOT_ID} button { font:inherit; }
  	    #${ROOT_ID} .snap-shell { width:min(100%,760px); margin:0 auto; padding:18px 14px 42px; }
  	    #${ROOT_ID} .snap-header { display:flex; align-items:flex-start; justify-content:space-between; gap:14px; margin:4px 2px 16px; }
  	    #${ROOT_ID} .snap-kicker { font-size:10px; font-weight:900; letter-spacing:.14em; color:var(--accent2); text-transform:uppercase; }
  	    #${ROOT_ID} .snap-title { font-size:30px; line-height:1; font-weight:900; margin-top:5px; letter-spacing:-.035em; }
  	    #${ROOT_ID} .snap-sub { margin-top:7px; font-size:12px; color:var(--muted); }
  	    #${ROOT_ID} .snap-live { flex:0 0 auto; display:flex; align-items:center; gap:7px; border:1px solid var(--line); background:#0f1511; border-radius:999px; padding:8px 10px; font-size:10px; font-weight:800; color:#bac4bd; }
  	    #${ROOT_ID} .snap-actions { flex:0 0 auto; display:grid; justify-items:end; gap:7px; }
  	    #${ROOT_ID} .refresh-btn { appearance:none; border:1px solid #4a3528; background:#1b1713; color:#e9c3a7; border-radius:999px; min-height:32px; padding:7px 10px; font:800 9px/1 Arial,sans-serif; letter-spacing:.04em; cursor:pointer; }
  	    #${ROOT_ID} .refresh-btn:disabled { opacity:.6; cursor:wait; }
  	    #${ROOT_ID} .refresh-btn .spin { display:inline-block; animation:fifSnapSpin .85s linear infinite; }
  	    #${ROOT_ID} .snap-action-row { display:flex; align-items:center; justify-content:flex-end; gap:6px; }
  	    #${ROOT_ID} .app-btn { appearance:none; border:1px solid #4a3528; background:#1b1713; color:#f1d2bd; border-radius:999px; min-height:32px; padding:7px 10px; font:800 9px/1 Arial,sans-serif; letter-spacing:.04em; cursor:pointer; }
  	    #${ROOT_ID} .app-btn:disabled { opacity:.6; cursor:wait; }
  	    #${APP_MENU_ID}{position:fixed;z-index:2147483647;box-sizing:border-box;width:210px;overflow:hidden;padding:5px;color:#fff;border:1px solid rgba(204,102,51,.72);border-radius:13px;background:radial-gradient(circle at 16% -10%,rgba(204,102,51,.25),transparent 42%),repeating-radial-gradient(circle at 80% 118%,transparent 0 13px,rgba(204,102,51,.13) 14px 16px),linear-gradient(145deg,#1b1714 0%,#0b0d0d 58%,#050707 100%);box-shadow:0 18px 42px rgba(0,0,0,.58),0 0 0 1px rgba(0,0,0,.65) inset,0 0 18px rgba(204,102,51,.12);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;transform-origin:top right;animation:fifSnapAppMenuIn 130ms ease-out both}
  	    #${APP_MENU_ID} .snap-app-option{display:flex;align-items:center;width:100%;min-height:38px;margin:0;padding:9px 11px;border:0;border-radius:8px;outline:0;color:#f5f5f5;background:transparent;cursor:pointer;text-align:left;font-size:13px;font-weight:900;letter-spacing:.01em;transition:color 120ms ease,background 120ms ease,box-shadow 120ms ease}
  	    #${APP_MENU_ID} .snap-app-option:hover,#${APP_MENU_ID} .snap-app-option:focus-visible{color:#fff;background:rgba(204,102,51,.22);box-shadow:inset 2px 0 0 #cc6633}
  	    #${APP_MENU_ID} .snap-app-option:disabled{cursor:wait;opacity:.55}
  	    #${APP_MENU_ID} .snap-app-option.logout{margin-top:4px;border-top:1px solid rgba(204,102,51,.26);border-radius:0 0 8px 8px;color:#ff8a3d}
  	    #${APP_MENU_ID} .snap-app-status{padding:6px 10px 7px;color:#ff8a3d;font-size:11px;font-weight:800;line-height:1.3}
  	    #${APP_MENU_ID} .snap-app-status.error{color:#ff5b45}
  	    #${DIALOG_ID}{position:fixed;inset:0;z-index:2147483646;background:rgba(0,0,0,.72);display:grid;place-items:center;padding:18px;backdrop-filter:blur(4px)}
  	    #${DIALOG_ID} .snap-dialog-card{width:min(100%,430px);border:1px solid rgba(255,255,255,.14);border-top-color:rgba(204,102,51,.55);border-radius:20px;background:linear-gradient(160deg,#172019,#0a100c);padding:20px;box-shadow:0 24px 70px rgba(0,0,0,.55)}
  	    #${DIALOG_ID} h2{font-size:21px;color:#fff;margin:0 0 8px}
  	    #${DIALOG_ID} p{font-size:12px;line-height:1.5;color:#9eaaa2;margin:0}
  	    #${DIALOG_ID} .snap-dialog-actions{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:18px}
  	    #${DIALOG_ID} button{min-height:42px;border-radius:11px;border:1px solid #344039;background:#121915;color:#e8ede9;font-weight:900;cursor:pointer}
  	    #${DIALOG_ID} button.danger{border-color:#7e382d;background:#6a2f26;color:#fff}
  	    @keyframes fifSnapAppMenuIn{from{opacity:0;transform:translateY(-4px) scale(.98)}to{opacity:1;transform:translateY(0) scale(1)}}
  	    #${ROOT_ID} .refresh-meta { max-width:120px; text-align:right; font-size:8px; line-height:1.35; color:var(--muted2); }
  	    #${ROOT_ID} .refresh-meta.bad { color:var(--warn); }
  	    @keyframes fifSnapSpin { to { transform:rotate(360deg); } }
  	    #${ROOT_ID} .snap-dot { width:7px; height:7px; border-radius:50%; background:var(--good); box-shadow:0 0 0 4px rgba(99,217,154,.10); }
  	    #${ROOT_ID} .company-scroller { display:flex; gap:8px; overflow-x:auto; scrollbar-width:none; padding:1px 1px 12px; margin:0 0 3px; }
  	    #${ROOT_ID} .company-scroller::-webkit-scrollbar { display:none; }
  	    #${ROOT_ID} .company-chip { white-space:nowrap; border:1px solid var(--line); background:#0d130f; color:#aeb9b1; padding:9px 12px; border-radius:999px; font-size:11px; font-weight:800; cursor:pointer; }
  	    #${ROOT_ID} .company-chip.is-active { border-color:#9a502b; background:linear-gradient(180deg,#a9562c,#80411f); color:white; box-shadow:0 8px 24px rgba(0,0,0,.22); }
  	    #${ROOT_ID} .section { margin-top:16px; }
  	    #${ROOT_ID} .section-head { display:flex; align-items:end; justify-content:space-between; gap:12px; margin:0 2px 9px; }
  	    #${ROOT_ID} .section-title { font-size:12px; font-weight:900; letter-spacing:.08em; text-transform:uppercase; color:#d9dedb; }
  	    #${ROOT_ID} .section-note { font-size:10px; color:var(--muted2); text-align:right; }
  	    #${ROOT_ID} .hero-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:9px; }
  	    #${ROOT_ID} .metric { min-height:105px; border:1px solid var(--line); border-radius:16px; background:linear-gradient(180deg,rgba(21,28,23,.96),rgba(14,20,16,.96)); padding:13px; box-shadow:0 12px 30px rgba(0,0,0,.12); position:relative; overflow:hidden; }
  	    #${ROOT_ID} .metric::after { content:""; position:absolute; right:-18px; top:-22px; width:72px; height:72px; border-radius:50%; background:rgba(198,107,50,.055); }
  	    #${ROOT_ID} .metric-label { position:relative; z-index:1; font-size:9px; letter-spacing:.07em; text-transform:uppercase; font-weight:900; color:#8fa095; }
  	    #${ROOT_ID} .metric-value { position:relative; z-index:1; font-size:27px; line-height:1.06; font-weight:900; letter-spacing:-.035em; margin-top:8px; color:white; }
  	    #${ROOT_ID} .metric-unit { font-size:13px; font-weight:800; color:#cad2cd; letter-spacing:0; }
  	    #${ROOT_ID} .metric-foot { position:relative; z-index:1; font-size:9px; color:var(--muted2); margin-top:7px; line-height:1.3; }
  	    #${ROOT_ID} .behaviour-grid { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:8px; }
  	    #${ROOT_ID} .behaviour { border:1px solid var(--line); background:#101612; border-radius:15px; padding:12px 9px 11px; min-width:0; }
  	    #${ROOT_ID} .behaviour-top { display:flex; align-items:center; justify-content:space-between; gap:6px; }
  	    #${ROOT_ID} .behaviour-label { font-size:9px; text-transform:uppercase; letter-spacing:.06em; font-weight:900; color:#92a097; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  	    #${ROOT_ID} .behaviour-icon { width:26px; height:26px; border-radius:9px; display:grid; place-items:center; background:#181f1a; border:1px solid #2b352e; font-size:13px; }
  	    #${ROOT_ID} .behaviour-value { font-size:23px; font-weight:900; margin-top:9px; letter-spacing:-.03em; }
  	    #${ROOT_ID} .behaviour-foot { font-size:8px; color:var(--muted2); margin-top:5px; line-height:1.3; }
  	    #${ROOT_ID} .fuel-panel { border:1px solid var(--line); border-radius:17px; background:linear-gradient(180deg,#121914,#0d130f); padding:14px; }
  	    #${ROOT_ID} .fuel-summary { display:grid; grid-template-columns:1.15fr 1.15fr .85fr .85fr; gap:9px; align-items:stretch; }
  	    #${ROOT_ID} .gauge-card { border:1px solid #2c382f; border-radius:14px; padding:12px; background:#0c120e; }
  	    #${ROOT_ID} .gauge-row { display:flex; align-items:end; justify-content:space-between; gap:10px; }
  	    #${ROOT_ID} .gauge-big { font-size:28px; font-weight:900; letter-spacing:-.04em; }
  	    #${ROOT_ID} .gauge-meta { font-size:9px; color:var(--muted); margin-top:4px; }
  	    #${ROOT_ID} .bar { height:8px; border-radius:999px; background:#202a23; overflow:hidden; margin-top:12px; }
  	    #${ROOT_ID} .bar > span { display:block; height:100%; border-radius:inherit; background:linear-gradient(90deg,#9f5029,#dc8246); }
  	    #${ROOT_ID} .small-stat { border:1px solid #2c382f; border-radius:14px; padding:12px; background:#0c120e; }
  	    #${ROOT_ID} .small-stat-value { font-size:20px; font-weight:900; margin-top:7px; letter-spacing:-.025em; }
  	    #${ROOT_ID} .tank-list { display:grid; gap:8px; margin-top:10px; }
  	    #${ROOT_ID} .tank-row { border-top:1px solid #252f28; padding:11px 1px 1px; display:grid; grid-template-columns:minmax(0,1fr) minmax(220px,auto); gap:10px; align-items:center; }
  	    #${ROOT_ID} .tank-name { font-size:11px; font-weight:900; color:#edf1ee; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  	    #${ROOT_ID} .tank-meta { font-size:9px; color:var(--muted2); margin-top:3px; }
  	    #${ROOT_ID} .tank-atg-meta { font-size:8px; color:#8fa095; margin-top:5px; line-height:1.4; }
  	    #${ROOT_ID} .tank-readings { display:grid; grid-template-columns:repeat(2,minmax(102px,1fr)); gap:7px; }
  	    #${ROOT_ID} .tank-reading { min-width:0; border:1px solid #2c382f; border-radius:11px; background:#0c120e; padding:8px 9px; }
  	    #${ROOT_ID} .tank-reading.book { border-color:rgba(220,130,70,.36); }
  	    #${ROOT_ID} .tank-reading.atg { border-color:rgba(92,183,133,.38); }
  	    #${ROOT_ID} .tank-reading.atg.stale { border-color:rgba(242,195,90,.48); }
  	    #${ROOT_ID} .tank-reading.atg.unavailable { border-color:#303730; opacity:.7; }
  	    #${ROOT_ID} .tank-reading-label { font-size:8px; letter-spacing:.07em; text-transform:uppercase; font-weight:900; color:#8fa095; }
  	    #${ROOT_ID} .tank-reading.book .tank-reading-label { color:#dc8246; }
  	    #${ROOT_ID} .tank-reading.atg.live .tank-reading-label { color:#71c99a; }
  	    #${ROOT_ID} .tank-reading.atg.stale .tank-reading-label { color:var(--warn); }
  	    #${ROOT_ID} .tank-pct { font-size:16px; font-weight:900; margin-top:4px; }
  	    #${ROOT_ID} .tank-litres { font-size:9px; color:var(--muted); margin-top:2px; white-space:nowrap; }
  	    #${ROOT_ID} .tank-mini-bar { height:4px; border-radius:999px; background:#202a23; overflow:hidden; margin-top:6px; }
  	    #${ROOT_ID} .tank-mini-bar > span { display:block; height:100%; border-radius:inherit; background:#dc8246; }
  	    #${ROOT_ID} .tank-reading.atg .tank-mini-bar > span { background:#71c99a; }
  	    #${ROOT_ID} .tank-reading.atg.stale .tank-mini-bar > span { background:var(--warn); }
  	    #${ROOT_ID} .attention { display:grid; gap:7px; }
  	    #${ROOT_ID} .alert { display:grid; grid-template-columns:10px minmax(0,1fr); gap:10px; border:1px solid var(--line); border-radius:13px; padding:10px 11px; background:#0f1511; }
  	    #${ROOT_ID} .alert-mark { width:8px; height:8px; border-radius:50%; margin-top:4px; background:#728078; }
  	    #${ROOT_ID} .alert.danger .alert-mark { background:var(--bad); box-shadow:0 0 0 4px rgba(255,116,116,.08); }
  	    #${ROOT_ID} .alert.warn .alert-mark { background:var(--warn); box-shadow:0 0 0 4px rgba(242,195,90,.08); }
  	    #${ROOT_ID} .alert-title { font-size:10px; font-weight:900; }
  	    #${ROOT_ID} .alert-detail { font-size:9px; color:var(--muted2); margin-top:3px; line-height:1.45; }
  	    #${ROOT_ID} .alert.info .alert-mark { background:#77a9d8; box-shadow:0 0 0 4px rgba(119,169,216,.08); }
  	    #${ROOT_ID} .alert-top { display:flex; align-items:center; gap:6px; flex-wrap:wrap; margin-bottom:4px; }
  	    #${ROOT_ID} .alert-badge,
  	    #${ROOT_ID} .alert-category {
  	      display:inline-flex;
  	      align-items:center;
  	      min-height:18px;
  	      padding:2px 6px;
  	      border:1px solid var(--line2);
  	      border-radius:999px;
  	      color:var(--muted);
  	      background:#0b100d;
  	      font-size:7px;
  	      font-weight:900;
  	      letter-spacing:.06em;
  	      text-transform:uppercase;
  	    }
  	    #${ROOT_ID} .alert-badge.critical { color:#ffaaaa; border-color:rgba(255,116,116,.35); background:rgba(255,116,116,.07); }
  	    #${ROOT_ID} .alert-badge.high { color:#ffb989; border-color:rgba(226,138,75,.35); background:rgba(226,138,75,.07); }
  	    #${ROOT_ID} .alert-badge.warning { color:#f2d17a; border-color:rgba(242,195,90,.35); background:rgba(242,195,90,.06); }
  	    #${ROOT_ID} .alert-badge.info { color:#9ec6ea; border-color:rgba(119,169,216,.35); background:rgba(119,169,216,.06); }
  	    #${ROOT_ID} .alert-evidence { display:flex; gap:8px; flex-wrap:wrap; margin-top:5px; color:#7f8a83; font-size:8px; }
  	    #${ROOT_ID} .alert-evidence b { color:#a7b2ab; }
  	    #${ROOT_ID} .alert-summary {
  	      display:grid;
  	      grid-template-columns:repeat(4,minmax(0,1fr));
  	      gap:7px;
  	      margin-bottom:9px;
  	    }
  	    #${ROOT_ID} .alert-summary-card {
  	      border:1px solid var(--line);
  	      border-radius:12px;
  	      padding:9px 10px;
  	      background:#0d130f;
  	    }
  	    #${ROOT_ID} .alert-summary-card span { display:block; color:var(--muted2); font-size:7px; font-weight:900; text-transform:uppercase; letter-spacing:.07em; }
  	    #${ROOT_ID} .alert-summary-card strong { display:block; margin-top:3px; color:#f4f6f4; font-size:17px; }
  	    #${ROOT_ID} .alert-summary-card.critical strong { color:#ff9292; }
  	    #${ROOT_ID} .alert-summary-card.high strong { color:#e89b6b; }
  	    #${ROOT_ID} .alert-summary-card.warning strong { color:#e6c86f; }
  	    #${ROOT_ID} .alert-summary-card.info strong { color:#94bce1; }
  	    #${ROOT_ID} .all-clear { border:1px solid rgba(99,217,154,.22); background:rgba(99,217,154,.055); border-radius:14px; padding:13px; color:#bfe8cf; font-size:11px; font-weight:800; }
  	    #${ROOT_ID} .fleet-strip { display:flex; gap:7px; overflow-x:auto; scrollbar-width:none; padding-bottom:2px; }
  	    #${ROOT_ID} .fleet-strip::-webkit-scrollbar { display:none; }
  	    #${ROOT_ID} .fleet-pill { flex:0 0 auto; min-width:92px; border:1px solid var(--line); background:#0e1410; border-radius:12px; padding:9px 10px; }
  	    #${ROOT_ID} .fleet-pill-val { font-size:16px; font-weight:900; }
  	    #${ROOT_ID} .fleet-pill-lab { font-size:8px; color:var(--muted2); text-transform:uppercase; letter-spacing:.06em; margin-top:2px; font-weight:800; }
  	    #${ROOT_ID} .subreport-head { display:flex; justify-content:space-between; align-items:end; gap:12px; margin:14px 0 8px; }
  	    #${ROOT_ID} .subreport-title { color:#d7dfda; font-size:11px; font-weight:900; letter-spacing:.12em; text-transform:uppercase; }
  	    #${ROOT_ID} .subreport-note { color:var(--muted); font-size:9px; text-align:right; }
  	    #${ROOT_ID} .hobbs-meter-strip { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:8px; margin-top:8px; }
  	    #${ROOT_ID} .hobbs-pill { background:#0d130f; border:1px solid var(--line); border-radius:12px; padding:10px 12px; min-width:0; }
  	    #${ROOT_ID} .hobbs-pill-name { font-size:10px; font-weight:850; color:#dce5df; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  	    #${ROOT_ID} .hobbs-pill-reading { font-size:16px; font-weight:900; color:var(--accent2); margin-top:3px; }
  	    #${ROOT_ID} .hobbs-pill-meta { font-size:8px; color:var(--muted); margin-top:2px; }
  	    #${ROOT_ID} .footer-note { margin:18px 3px 0; padding-top:12px; border-top:1px solid #1e2721; font-size:9px; color:#536058; line-height:1.45; }
  	    #${ROOT_ID} .empty { border:1px dashed #344039; border-radius:15px; padding:18px; text-align:center; color:#7f8d84; font-size:11px; }

  	    #${ROOT_ID} .snapshot-loading {
  	      min-height:100vh;
  	      display:grid;
  	      place-items:center;
  	      padding:28px 18px;
  	    }
  	    #${ROOT_ID} .snapshot-loading-card {
  	      width:min(100%,420px);
  	      text-align:center;
  	      padding:28px 22px 26px;
  	      border:1px solid var(--line);
  	      border-top-color:rgba(198,107,50,.68);
  	      border-radius:22px;
  	      background:
  	        radial-gradient(circle at 50% -10%,rgba(198,107,50,.18),transparent 45%),
  	        linear-gradient(180deg,rgba(21,28,23,.98),rgba(11,16,13,.98));
  	      box-shadow:0 24px 70px rgba(0,0,0,.34);
  	    }
  	    #${ROOT_ID} .snapshot-loading-mark {
  	      width:70px;
  	      height:70px;
  	      margin:0 auto 18px;
  	      position:relative;
  	      display:grid;
  	      place-items:center;
  	    }
  	    #${ROOT_ID} .snapshot-loading-ring,
  	    #${ROOT_ID} .snapshot-loading-ring::before,
  	    #${ROOT_ID} .snapshot-loading-ring::after {
  	      position:absolute;
  	      inset:0;
  	      border-radius:50%;
  	      content:"";
  	    }
  	    #${ROOT_ID} .snapshot-loading-ring {
  	      border:2px solid rgba(198,107,50,.18);
  	      border-top-color:var(--accent2);
  	      animation:fifSnapshotTaking 1s linear infinite;
  	    }
  	    #${ROOT_ID} .snapshot-loading-ring::before {
  	      inset:8px;
  	      border:1px solid rgba(99,217,154,.17);
  	      border-right-color:rgba(99,217,154,.72);
  	      animation:fifSnapshotTakingReverse 1.45s linear infinite;
  	    }
  	    #${ROOT_ID} .snapshot-loading-ring::after {
  	      inset:19px;
  	      background:rgba(198,107,50,.13);
  	      box-shadow:0 0 26px rgba(198,107,50,.12);
  	    }
  	    #${ROOT_ID} .snapshot-loading-dot {
  	      width:8px;
  	      height:8px;
  	      position:relative;
  	      z-index:2;
  	      border-radius:50%;
  	      background:var(--accent2);
  	      box-shadow:0 0 0 5px rgba(198,107,50,.10),0 0 18px rgba(226,138,75,.45);
  	    }
  	    #${ROOT_ID} .snapshot-loading-kicker {
  	      color:var(--accent2);
  	      font-size:9px;
  	      font-weight:900;
  	      letter-spacing:.16em;
  	      text-transform:uppercase;
  	    }
  	    #${ROOT_ID} .snapshot-loading-title {
  	      margin-top:7px;
  	      color:#fff;
  	      font-size:27px;
  	      line-height:1.08;
  	      font-weight:900;
  	      letter-spacing:-.035em;
  	    }
  	    #${ROOT_ID} .snapshot-loading-copy {
  	      max-width:310px;
  	      margin:10px auto 0;
  	      color:var(--muted);
  	      font-size:11px;
  	      line-height:1.55;
  	    }
  	    #${ROOT_ID} .snapshot-loading-pulse {
  	      display:flex;
  	      justify-content:center;
  	      gap:5px;
  	      margin-top:16px;
  	    }
  	    #${ROOT_ID} .snapshot-loading-pulse span {
  	      width:5px;
  	      height:5px;
  	      border-radius:50%;
  	      background:var(--accent2);
  	      opacity:.25;
  	      animation:fifSnapshotPulse 1.2s ease-in-out infinite;
  	    }
  	    #${ROOT_ID} .snapshot-loading-pulse span:nth-child(2) { animation-delay:.15s; }
  	    #${ROOT_ID} .snapshot-loading-pulse span:nth-child(3) { animation-delay:.30s; }

  	    @keyframes fifSnapshotTaking {
  	      to { transform:rotate(360deg); }
  	    }
  	    @keyframes fifSnapshotTakingReverse {
  	      to { transform:rotate(-360deg); }
  	    }
  	    @keyframes fifSnapshotPulse {
  	      0%,100% { opacity:.22; transform:translateY(0); }
  	      50% { opacity:1; transform:translateY(-3px); }
  	    }

  	    @media (min-width:620px) {
  	      #${ROOT_ID} .snap-shell { padding:24px 20px 54px; }
  	      #${ROOT_ID} .hero-grid { grid-template-columns:repeat(3,minmax(0,1fr)); }
  	      #${ROOT_ID} .metric { min-height:112px; }
  	      #${ROOT_ID} .metric-value { font-size:30px; }
  	    }
  	    @media (max-width:520px) {
  	      #${ROOT_ID} .hobbs-meter-strip { grid-template-columns:1fr; }
  	      #${ROOT_ID} .fuel-summary { grid-template-columns:1fr 1fr; }
  	      #${ROOT_ID} .tank-row { grid-template-columns:1fr; }
  	    }
  	    @media (max-width:380px) {
  	      #${ROOT_ID} .snap-title { font-size:27px; }
  	      #${ROOT_ID} .metric-value { font-size:23px; }
  	      #${ROOT_ID} .behaviour-value { font-size:19px; }
  	      #${ROOT_ID} .fuel-summary { grid-template-columns:1fr 1fr; }
  	      #${ROOT_ID} .gauge-card { grid-column:auto; }
  	      #${ROOT_ID} .gauge-big { font-size:23px; }
  	      #${ROOT_ID} .tank-readings { grid-template-columns:1fr 1fr; }
  	    }

  	    /* =========================================================
  	       V2.7 EXPANDABLE SNAPSHOT
  	       Progressive disclosure: summary first, detail on demand.
  	       ========================================================= */
  	    #${ROOT_ID} .snapshot-sticky {
  	      position:sticky;
  	      top:0;
  	      z-index:40;
  	      margin:0 0 10px;
  	      padding:4px 0 2px;
  	      background:linear-gradient(180deg,rgba(8,13,10,.98) 0%,rgba(8,13,10,.96) 78%,rgba(8,13,10,.88) 100%);
  	      border-bottom:1px solid rgba(54,68,58,.72);
  	      box-shadow:0 10px 22px rgba(0,0,0,.18);
  	      backdrop-filter:blur(14px);
  	      -webkit-backdrop-filter:blur(14px);
  	    }
  	    #${ROOT_ID} .snapshot-sticky .snap-header { margin-bottom:9px; }
  	    #${ROOT_ID} .snapshot-sticky .company-scroller { margin-bottom:0; padding-bottom:8px; }
  	    /* Dashboard-parity recorded totals (ViewC) deliberately separated from
  	       telemetry Today/Yesterday and GPS monthly averages. */
  	    #${ROOT_ID} .period-parity {
  	      margin:10px 0 13px; padding:13px 12px; border-radius:14px;
  	      border:1px solid #3b3d32; background:linear-gradient(180deg,#181d17,#101510);
  	    }
  	    #${ROOT_ID} .period-parity-heading { display:flex; justify-content:space-between; gap:10px; flex-wrap:wrap; align-items:baseline; margin-bottom:10px; }
  	    #${ROOT_ID} .period-parity-heading strong { color:#e6eee7; font-size:11px; font-weight:900; letter-spacing:.04em; text-transform:uppercase; }
  	    #${ROOT_ID} .period-parity-heading span { color:var(--muted); font-size:9px; font-weight:700; }
  	    #${ROOT_ID} .period-parity-grid { display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:8px; }
  	    #${ROOT_ID} .period-parity-metric { min-width:0; padding:9px 10px; border-radius:10px; background:#0d140f; border:1px solid #2c3a2e; }
  	    #${ROOT_ID} .period-parity-metric > span { display:block; color:#95a399; font-size:8px; letter-spacing:.07em; text-transform:uppercase; font-weight:900; margin-bottom:7px; }
  	    #${ROOT_ID} .period-parity-metric > strong { display:block; color:#fff; font-size:17px; font-weight:900; line-height:1.1; overflow-wrap:anywhere; }
  	    #${ROOT_ID} .period-parity-metric small { color:#a3afa6; font-size:10px; }
  	    #${ROOT_ID} .period-parity-note { margin-top:9px; color:#f2c35a; font-size:10px; line-height:1.4; }
  	    @media (max-width:520px) {
  	      #${ROOT_ID} .period-parity-grid { grid-template-columns:repeat(2,minmax(0,1fr)); }
  	      #${ROOT_ID} .period-parity-metric > strong { font-size:18px; }
  	    }
  	    #${ROOT_ID} .primary-expander-grid {
  	      display:grid;
  	      grid-template-columns:repeat(2,minmax(0,1fr));
  	      gap:9px;
  	      margin-top:4px;
  	    }
  	    #${ROOT_ID} .primary-expander,
  	    #${ROOT_ID} .expand-row {
  	      width:100%;
  	      appearance:none;
  	      border:1px solid var(--line);
  	      color:var(--text);
  	      background:linear-gradient(180deg,#151c17,#0f1511);
  	      cursor:pointer;
  	      text-align:left;
  	      transition:border-color 120ms ease,background 120ms ease,transform 120ms ease;
  	    }
  	    #${ROOT_ID} .primary-expander:hover,
  	    #${ROOT_ID} .primary-expander:focus-visible,
  	    #${ROOT_ID} .expand-row:hover,
  	    #${ROOT_ID} .expand-row:focus-visible {
  	      border-color:#6d4935;
  	      background:linear-gradient(180deg,#181f1a,#111713);
  	      outline:none;
  	    }
  	    #${ROOT_ID} .primary-expander {
  	      min-height:112px;
  	      border-radius:16px;
  	      padding:14px;
  	      position:relative;
  	      overflow:hidden;
  	    }
  	    #${ROOT_ID} .primary-expander.is-open { border-color:#8d4d2d; }
  	    #${ROOT_ID} .primary-expander::after {
  	      content:"";
  	      position:absolute;
  	      right:-20px;
  	      top:-24px;
  	      width:84px;
  	      height:84px;
  	      border-radius:50%;
  	      background:rgba(198,107,50,.06);
  	      pointer-events:none;
  	    }
  	    #${ROOT_ID} .expander-kicker {
  	      position:relative;
  	      z-index:1;
  	      color:#9ba89f;
  	      font-size:9px;
  	      font-weight:900;
  	      letter-spacing:.09em;
  	      text-transform:uppercase;
  	    }
  	    #${ROOT_ID} .expander-value {
  	      position:relative;
  	      z-index:1;
  	      margin-top:8px;
  	      color:#fff;
  	      font-size:28px;
  	      line-height:1;
  	      font-weight:900;
  	      letter-spacing:-.035em;
  	    }
  	    #${ROOT_ID} .expander-value span {
  	      color:#a9b4ad;
  	      font-size:12px;
  	      letter-spacing:0;
  	    }
  	    #${ROOT_ID} .expander-foot {
  	      position:relative;
  	      z-index:1;
  	      margin-top:8px;
  	      display:flex;
  	      align-items:center;
  	      justify-content:space-between;
  	      gap:8px;
  	      color:var(--muted2);
  	      font-size:9px;
  	      font-weight:800;
  	    }
  	    #${ROOT_ID} .chevron {
  	      flex:0 0 auto;
  	      color:var(--accent2);
  	      font-size:15px;
  	      line-height:1;
  	      transition:transform 140ms ease;
  	    }
  	    #${ROOT_ID} .is-open .chevron { transform:rotate(180deg); }
  	    #${ROOT_ID} .detail-panel {
  	      margin-top:9px;
  	      border:1px solid var(--line);
  	      border-radius:16px;
  	      background:#0c120e;
  	      padding:12px;
  	    }
  	    #${ROOT_ID} .detail-group + .detail-group { margin-top:12px; }
  	    #${ROOT_ID} .detail-group-title {
  	      margin:0 2px 7px;
  	      color:#849188;
  	      font-size:8px;
  	      font-weight:900;
  	      letter-spacing:.09em;
  	      text-transform:uppercase;
  	    }
  	    #${ROOT_ID} .combined-fuel-strip {
  	      margin-top:9px;
  	      min-height:58px;
  	      border:1px solid #3b332b;
  	      border-radius:14px;
  	      background:linear-gradient(180deg,#171712,#11130f);
  	      padding:10px 12px;
  	      display:grid;
  	      grid-template-columns:minmax(0,1fr) auto;
  	      align-items:center;
  	      gap:12px;
  	    }
  	    #${ROOT_ID} .combined-fuel-label {
  	      color:#dce3de;
  	      font-size:9px;
  	      font-weight:900;
  	      letter-spacing:.07em;
  	      text-transform:uppercase;
  	    }
  	    #${ROOT_ID} .combined-fuel-breakdown {
  	      margin-top:4px;
  	      color:var(--muted2);
  	      font-size:8px;
  	      line-height:1.35;
  	      font-weight:800;
  	    }
  	    #${ROOT_ID} .combined-fuel-value {
  	      color:#fff;
  	      font-size:22px;
  	      line-height:1;
  	      font-weight:900;
  	      letter-spacing:-.03em;
  	      white-space:nowrap;
  	      text-align:right;
  	    }
  	    #${ROOT_ID} .combined-fuel-value span {
  	      color:var(--muted);
  	      font-size:10px;
  	      letter-spacing:0;
  	    }
  	    #${ROOT_ID} .compact-stack { display:grid; gap:8px; margin-top:12px; }
  	    #${ROOT_ID} .expand-row {
  	      min-height:58px;
  	      border-radius:14px;
  	      padding:11px 12px;
  	      display:grid;
  	      grid-template-columns:minmax(0,1fr) auto auto;
  	      align-items:center;
  	      gap:10px;
  	    }
  	    #${ROOT_ID} .expand-row.is-open { border-color:#674631; }
  	    #${ROOT_ID} .expand-label {
  	      min-width:0;
  	      color:#dce3de;
  	      font-size:10px;
  	      font-weight:900;
  	      letter-spacing:.06em;
  	      text-transform:uppercase;
  	    }
  	    #${ROOT_ID} .expand-summary {
  	      color:#fff;
  	      font-size:15px;
  	      font-weight:900;
  	      white-space:nowrap;
  	    }
  	    #${ROOT_ID} .expand-summary small {
  	      color:var(--muted);
  	      font-size:9px;
  	      font-weight:800;
  	    }
  	    #${ROOT_ID} .compact-detail { margin-top:8px; }
  	    #${ROOT_ID} .alert-filter-bar {
  	      display:flex;
  	      align-items:center;
  	      gap:8px;
  	      flex-wrap:wrap;
  	      margin:0 0 9px;
  	    }
  	    #${ROOT_ID} .alert-type-select {
  	      min-height:34px;
  	      max-width:210px;
  	      border:1px solid var(--line2);
  	      border-radius:10px;
  	      background:#0d130f;
  	      color:#e8ede9;
  	      padding:7px 28px 7px 9px;
  	      font-size:9px;
  	      font-weight:900;
  	      cursor:pointer;
  	    }
  	    #${ROOT_ID} .severity-filters {
  	      display:flex;
  	      gap:5px;
  	      overflow-x:auto;
  	      scrollbar-width:none;
  	      flex:1 1 280px;
  	    }
  	    #${ROOT_ID} .severity-filters::-webkit-scrollbar { display:none; }
  	    #${ROOT_ID} .filter-chip {
  	      flex:0 0 auto;
  	      appearance:none;
  	      border:1px solid var(--line);
  	      border-radius:999px;
  	      background:#0d130f;
  	      color:#8d9991;
  	      min-height:30px;
  	      padding:6px 9px;
  	      font-size:8px;
  	      font-weight:900;
  	      cursor:pointer;
  	    }
  	    #${ROOT_ID} .filter-chip.is-active {
  	      border-color:#8d4d2d;
  	      background:#3a2418;
  	      color:#fff;
  	    }
  	    #${ROOT_ID} .filter-chip[data-alert-severity="critical"].is-active { border-color:rgba(255,116,116,.62); background:rgba(255,116,116,.10); color:#ffaaaa; }
  	    #${ROOT_ID} .filter-chip[data-alert-severity="high"].is-active { border-color:rgba(226,138,75,.62); background:rgba(226,138,75,.10); color:#ffc09a; }
  	    #${ROOT_ID} .filter-chip[data-alert-severity="warning"].is-active { border-color:rgba(242,195,90,.62); background:rgba(242,195,90,.09); color:#f5d681; }
  	    #${ROOT_ID} .filter-chip[data-alert-severity="info"].is-active { border-color:rgba(119,169,216,.62); background:rgba(119,169,216,.09); color:#a7cbed; }
  	    #${ROOT_ID} .alert-result-meta {
  	      margin-left:auto;
  	      color:var(--muted2);
  	      font-size:8px;
  	      font-weight:800;
  	      white-space:nowrap;
  	    }
  	    #${ROOT_ID} .alert.compact-alert {
  	      width:100%;
  	      appearance:none;
  	      text-align:left;
  	      color:inherit;
  	      cursor:pointer;
  	    }
  	    #${ROOT_ID} .alert.compact-alert .alert-top { margin-bottom:2px; }
  	    #${ROOT_ID} .alert.compact-alert .alert-title { font-size:10px; }
  	    #${ROOT_ID} .alert.compact-alert .alert-detail,
  	    #${ROOT_ID} .alert.compact-alert .alert-evidence {
  	      margin-top:7px;
  	    }
  	    #${ROOT_ID} .alert.compact-alert .alert-chevron {
  	      margin-left:auto;
  	      color:var(--muted2);
  	      font-size:12px;
  	      transition:transform 120ms ease;
  	    }
  	    #${ROOT_ID} .alert.compact-alert.is-open .alert-chevron { transform:rotate(180deg); color:var(--accent2); }
  	    #${ROOT_ID} .alerts-empty {
  	      border:1px dashed #344039;
  	      border-radius:13px;
  	      padding:14px;
  	      color:#7f8d84;
  	      font-size:10px;
  	      text-align:center;
  	    }
  	    @media (max-width:520px) {
  	      #${ROOT_ID} .primary-expander-grid { grid-template-columns:1fr 1fr; }
  	      #${ROOT_ID} .primary-expander { min-height:102px; padding:12px; }
  	      #${ROOT_ID} .expander-value { font-size:23px; }
  	      #${ROOT_ID} .expand-row { grid-template-columns:minmax(0,1fr) auto auto; }
  	      #${ROOT_ID} .alert-type-select { max-width:none; width:100%; }
  	      #${ROOT_ID} .alert-result-meta { margin-left:0; }
  	      #${ROOT_ID} .combined-fuel-strip { grid-template-columns:minmax(0,1fr) auto; }
  	      #${ROOT_ID} .combined-fuel-value { font-size:19px; }
  	    }

  	    .simple-snapshot .simple-section {
  	      display:flex;
  	      flex-direction:column;
  	      gap:10px;
  	    }
  	    .simple-snapshot .simple-section > .section-title {
  	      margin-bottom:2px;
  	    }
  	    .simple-row {
  	      display:grid;
  	      grid-template-columns:repeat(3,minmax(0,1fr));
  	      gap:8px;
  	    }
  	    .simple-metric {
  	      min-width:0;
  	      border:1px solid var(--line);
  	      background:var(--panel);
  	      border-radius:12px;
  	      padding:14px 15px;
  	    }
  	    .simple-label {
  	      color:var(--muted);
  	      font-size:11px;
  	      font-weight:800;
  	      letter-spacing:.04em;
  	      text-transform:uppercase;
  	      margin-bottom:7px;
  	    }
  	    .simple-value {
  	      color:var(--text);
  	      font-size:22px;
  	      line-height:1.15;
  	      font-weight:900;
  	      letter-spacing:-.02em;
  	    }
  	    .simple-unit {
  	      color:var(--muted);
  	      font-size:11px;
  	      font-weight:800;
  	      letter-spacing:0;
  	    }
  	    @media (max-width: 760px) {
  	      .simple-row {
  	        grid-template-columns:1fr;
  	      }
  	    }
  	`;
  	  document.head.appendChild(style);

  	  const root = document.createElement("div");
  	  root.id = ROOT_ID;
  	  document.body.appendChild(root);

  	  const priorState = window[STATE_KEY];
  	  if (priorState && typeof priorState.cleanup === "function") {
  	    try { priorState.cleanup(); } catch (_) {}
  	  }

  	  const state = priorState || { selectedCompany: ALL };
  	  state.refreshing = false;
  	  state.refreshError = "";
  	  state.lastRefreshAt = Date.now();
  	  state.refreshTimer = null;
  	  state.detachObserver = null;
  	  state.reportReadyTimer = null;
  	  state.reportReadyListener = null;
  	  state.appSwitchInProgress = false;
  	  state.logoutInProgress = false;
  	  state.expanded = Object.assign({
  	    km: false,
  	    hobbs: false,
  	    idling: false,
  	    max: false,
  	    fuel: false,
  	    alerts: false
  	  }, state.expanded || {});

  	  // V2.7.1 uses a single-open accordion. If an older runtime left more than
  	  // one section open, keep the first one and close the rest immediately.
  	  let initialOpenSection = "";
  	  Object.keys(state.expanded).forEach(function (key) {
  	    if (state.expanded[key] && !initialOpenSection) initialOpenSection = key;
  	    state.expanded[key] = false;
  	  });
  	  if (initialOpenSection && Object.prototype.hasOwnProperty.call(state.expanded, initialOpenSection)) {
  	    state.expanded[initialOpenSection] = true;
  	  }

  	  state.alertType = text(state.alertType, ALL) || ALL;
  	  state.alertSeverity = text(state.alertSeverity, ALL) || ALL;
  	  state.expandedAlertKey = text(state.expandedAlertKey, "");
  	  window[STATE_KEY] = state;

  	  function ensureSelectedCompanyValid() {
  	    const validKeys = new Set(companies.map(companyKey));
  	    if (state.selectedCompany !== ALL && !validKeys.has(state.selectedCompany)) {
  	      state.selectedCompany = ALL;
  	    }
  	  }

  	  function selectedCompanies() {
  	    if (state.selectedCompany === ALL) return companies;
  	    return companies.filter(function (c, i) { return companyKey(c, i) === state.selectedCompany; });
  	  }

  	  function snapshotRelations() {
  	    return [
  	      "Companies.Tractors.ViewC.Fuel",
  	      "Companies.Tractors.ViewH.Fuel",
  	      "Companies.Tractors.Maintenance",
  	      "Companies.Tractors.Tyres",
  	      "Companies.Maintenance",
  	      "Companies.Tyres",
  	      "Companies.Tanks.Bowsers.ViewC.FuelOut",
  	      "Companies.Tanks.Bowsers.ViewH.FuelOut",
  	      "Companies.Tanks.ViewC.FuelIn",
  	      "Companies.Tanks.ViewH.FuelIn",
  	      "Companies.Tanks.ATG"
  	    ];
  	  }

  	  async function fetchFreshSnapshotUser() {
  	    if (!DB || !DB.Data || !DB.DataQueryBuilder) {
  	      throw new Error("Backendless is not available on this page.");
  	    }

  	    const userId = text(snapshotUser && snapshotUser.objectId, text(AppData.User && AppData.User.objectId, ""));
  	    if (!userId) throw new Error("Current user objectId is unavailable.");

  	    const safeUserId = userId.replace(/'/g, "''");
  	    const qb = DB.DataQueryBuilder.create()
  	      .setWhereClause("objectId = '" + safeUserId + "'")
  	      .setRelated(snapshotRelations())
  	      .setRelationsDepth(10)
  	      .setRelationsPageSize(100)
  	      .setPageSize(1);

  	    const rows = await DB.Data.of("Users").find(qb);
  	    if (!Array.isArray(rows) || !rows[0]) throw new Error("Snapshot refresh returned no user data.");
  	    return rows[0];
  	  }

  	  function tractorRuntimeKey(vehicle) {
  	    if (!vehicle) return "";
  	    return text(vehicle.objectId || vehicle.ID || vehicle.FID || vehicle.Registration || vehicle.Tracker, "");
  	  }

  	  function collectRuntimeTractors(user) {
  	    const map = new Map();
  	    arr(user && user.Companies).forEach(function (company) {
  	      arr(company && company.Tractors).forEach(function (vehicle) {
  	        const key = tractorRuntimeKey(vehicle);
  	        if (key) map.set(key, vehicle);
  	      });
  	    });
  	    return map;
  	  }

  	  function preserveLiveRuntimeOnFreshUser(freshUser) {
  	    // Backendless refresh returns the persisted data tree, but the live Flespi
  	    // Location/Tracking values are runtime data injected into App.User.
  	    // Never let a persistence refresh erase those runtime values from Snapshot.
  	    const priorMap = collectRuntimeTractors(snapshotUser);
  	    const appMap = collectRuntimeTractors(AppData.User);
  	    const runtimeFields = ["Location", "Tracking", "Beacons", "GPSWarnings"];

  	    arr(freshUser && freshUser.Companies).forEach(function (company) {
  	      arr(company && company.Tractors).forEach(function (vehicle) {
  	        const key = tractorRuntimeKey(vehicle);
  	        const runtimeVehicle = (key && appMap.get(key)) || (key && priorMap.get(key));
  	        if (!runtimeVehicle) return;

  	        runtimeFields.forEach(function (field) {
  	          if (runtimeVehicle[field] !== undefined && runtimeVehicle[field] !== null) {
  	            vehicle[field] = runtimeVehicle[field];
  	          }
  	        });
  	      });
  	    });

  	    return freshUser;
  	  }

  	  function consoleSnapshotApp(source) {
  	    let vehicleCount = 0;
  	    let snapshotContainers = 0;
  	    let todayAvailable = 0;
  	    let yesterdayAvailable = 0;
  	    let monthlyAvailable = 0;

  	    arr(snapshotUser && snapshotUser.Companies).forEach(function (company) {
  	      arr(company && company.Tractors).forEach(function (vehicle) {
  	        vehicleCount++;

  	        const snapshot = vehicleSnapshotContainer(vehicle);
  	        if (snapshot && Object.keys(snapshot).length) snapshotContainers++;
  	        if (vehicleCurrentReport(vehicle)) todayAvailable++;
  	        if (vehicleDailyReport(vehicle)) yesterdayAvailable++;
  	        if (vehicleMonthlyReport(vehicle)) monthlyAvailable++;
  	      });
  	    });

  	    console.log("Fleet In Form Snapshot update [" + (source || "auto") + "]", {
  	      version: VERSION,
  	      companies: arr(snapshotUser && snapshotUser.Companies).length,
  	      vehicles: vehicleCount,
  	      snapshotContainers: snapshotContainers,
  	      todayAvailable: todayAvailable,
  	      yesterdayAvailable: yesterdayAvailable,
  	      monthlyAvailable: monthlyAvailable,
  	      source: "Tractor.ViewC.Snapshot"
  	    });
  	  }

  	  async function refreshSnapshotData(source) {
  	    if (state.refreshing) return false;
  	    state.refreshing = true;
  	    state.refreshError = "";
  	    render();

  	    try {
  	      const freshUser = preserveLiveRuntimeOnFreshUser(await fetchFreshSnapshotUser());

  	      // IMPORTANT: Snapshot is read-only against the global App object.
  	      // We refresh our local data model only; App.User is never replaced.
  	      snapshotUser = freshUser;
  	      companies = Array.isArray(freshUser.Companies) ? freshUser.Companies.filter(Boolean) : [];
  	      ensureSelectedCompanyValid();
  	      state.lastRefreshAt = Date.now();
  	      state.refreshError = "";

  	      consoleSnapshotApp(source);

  	      render();
  	      try {
  	        window.dispatchEvent(new CustomEvent("fif:snapshot-refreshed", {
  	          detail: { at: state.lastRefreshAt, source: source || "auto", version: VERSION }
  	        }));
  	      } catch (_) {}
  	      return true;
  	    } catch (err) {
  	      state.refreshError = err && err.message ? err.message : String(err || "Refresh failed");
  	      render();
  	      console.warn("Fleet In Form Snapshot refresh failed:", err);
  	      return false;
  	    } finally {
  	      state.refreshing = false;
  	      render();
  	    }
  	  }

  	  function appMenuNode() {
  	    return document.getElementById(APP_MENU_ID);
  	  }

  	  function appMenuButtonNode() {
  	    return root.querySelector("[data-snapshot-app-menu]");
  	  }

  	  function positionAppMenu() {
  	    const menu = appMenuNode();
  	    if (!menu) return;
  	    const button = appMenuButtonNode();
  	    const width = Math.min(220, Math.max(176, window.innerWidth - 16));
  	    const viewportPadding = 8;
  	    const gap = 6;
  	    let left = window.innerWidth - width - viewportPadding;
  	    let top = viewportPadding;

  	    if (button && button.getBoundingClientRect) {
  	      const rect = button.getBoundingClientRect();
  	      left = Math.min(window.innerWidth - width - viewportPadding, Math.max(viewportPadding, rect.right - width));
  	      top = rect.bottom + gap;
  	      const height = menu.offsetHeight || 210;
  	      if (top + height > window.innerHeight - viewportPadding) {
  	        top = Math.max(viewportPadding, rect.top - height - gap);
  	      }
  	    }

  	    menu.style.width = width + "px";
  	    menu.style.left = Math.round(left) + "px";
  	    menu.style.top = Math.round(top) + "px";
  	  }

  	  function onAppMenuOutside(event) {
  	    const menu = appMenuNode();
  	    const button = appMenuButtonNode();
  	    if (!menu) return;
  	    if (menu.contains(event.target)) return;
  	    if (button && button.contains(event.target)) return;
  	    closeAppMenu();
  	  }

  	  function onAppMenuKeyDown(event) {
  	    if (event.key !== "Escape") return;
  	    event.preventDefault();
  	    closeAppMenu();
  	  }

  	  function closeAppMenu() {
  	    const menu = appMenuNode();
  	    if (menu) menu.remove();
  	    document.removeEventListener("pointerdown", onAppMenuOutside, true);
  	    document.removeEventListener("keydown", onAppMenuKeyDown, true);
  	    window.removeEventListener("resize", positionAppMenu);
  	    window.removeEventListener("scroll", positionAppMenu, true);
  	    const button = appMenuButtonNode();
  	    if (button) button.setAttribute("aria-expanded", "false");
  	  }

  	  function setAppMenuStatus(message, isError) {
  	    const menu = appMenuNode();
  	    if (!menu) return;
  	    const status = menu.querySelector("[data-app-menu-status]");
  	    if (!status) return;
  	    status.textContent = text(message, "");
  	    status.hidden = !text(message, "");
  	    status.classList.toggle("error", !!isError);
  	  }

  	  function disableAppMenuOptions(disabled) {
  	    const menu = appMenuNode();
  	    if (!menu) return;
  	    menu.querySelectorAll("button").forEach(function (button) {
  	      button.disabled = !!disabled;
  	    });
  	  }

  	  async function isBackendlessSessionValid() {
  	    try {
  	      if (DB && DB.UserService && typeof DB.UserService.isValidLogin === "function") {
  	        return !!(await DB.UserService.isValidLogin());
  	      }
  	    } catch (_) {
  	      return false;
  	    }
  	    return true;
  	  }

  	  function readLocalJSON(key) {
  	    if (!key) return null;
  	    try {
  	      const raw = window.localStorage.getItem(key);
  	      return raw ? JSON.parse(raw) : null;
  	    } catch (_) {
  	      return null;
  	    }
  	  }

  	  function generateShortUUID() {
  	    try {
  	      if (
  	        typeof crypto !== "undefined" &&
  	        crypto &&
  	        typeof crypto.randomUUID === "function"
  	      ) {
  	        return crypto.randomUUID();
  	      }
  	    } catch (_) {}

  	    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (character) {
  	      const random = Math.random() * 16 | 0;
  	      const value = character === "x" ? random : (random & 0x3 | 0x8);
  	      return value.toString(16);
  	    });
  	  }

  	  async function prepareOfficeApplication(user) {
  	    const localKey = text(user && user.Local_Key, "");

  	    if (!localKey) {
  	      throw new Error("The user does not have a Local_Key.");
  	    }

  	    const stored = readLocalJSON(localKey);

  	    if (stored === null) {
  	      try {
  	        window.localStorage.setItem(
  	          localKey,
  	          JSON.stringify({
  	            "Lets See this Work": generateShortUUID()
  	          })
  	        );
  	      } catch (error) {
  	        throw new Error("Office local storage could not be prepared on this device.");
  	      }
  	    }

  	    /*
  	     * Office owns its own loader. Do not run an Office loader from Snapshot.
  	     * We only ensure the local key exists and preserve the existing App/User
  	     * object so the Office page can initialise itself after navigation.
  	     */
  	    return true;
  	  }

  	  function cleanupSharedAppSwitcherRuntime() {
  	    try {
  	      const sharedRuntime = window.__FIF_SHARED_APP_SWITCHER_V2__;
  	      if (sharedRuntime && typeof sharedRuntime.cleanup === "function") {
  	        sharedRuntime.cleanup();
  	      }
  	      delete window.__FIF_SHARED_APP_SWITCHER_V2__;
  	    } catch (_) {}
  	  }

  	  function applicationNavigator() {
  	    const candidates = [];
  	    try { if (typeof BackendlessUI !== "undefined") candidates.push(BackendlessUI); } catch (_) {}
  	    try { if (window.BackendlessUI) candidates.push(window.BackendlessUI); } catch (_) {}
  	    try { if (window.parent && window.parent !== window && window.parent.BackendlessUI) candidates.push(window.parent.BackendlessUI); } catch (_) {}
  	    try { if (window.top && window.top !== window && window.top.BackendlessUI) candidates.push(window.top.BackendlessUI); } catch (_) {}

  	    for (let index = 0; index < candidates.length; index += 1) {
  	      if (candidates[index] && candidates[index].Navigator && typeof candidates[index].Navigator.goToPage === "function") {
  	        return candidates[index].Navigator;
  	      }
  	    }
  	    return null;
  	  }

  	  async function navigateToApplicationPage(pageName, applicationName, user) {
  	    const navigator = applicationNavigator();
  	    if (!navigator) throw new Error("Application navigation is unavailable.");

  	    const sessionValid = await isBackendlessSessionValid();

  	    console.info("[Snapshot App Switcher Navigation]", {
  	      version: VERSION,
  	      targetApp: applicationName,
  	      targetPage: pageName,
  	      sessionValid: sessionValid,
  	      logoutGuardActive: !!installLogoutGuard()
  	    });

  	    if (!sessionValid) {
  	      throw new Error("Your session has ended. Please log in again.");
  	    }

  	    /*
  	     * Office expects the shared AppData/User object to survive the SPA change
  	     * and APP to name the destination application before the Office page mounts.
  	     */
  	    if (AppData && typeof AppData === "object") {
  	      AppData.User = AppData.User || user || snapshotUser;
  	      AppData.APP = applicationName;
  	    }

  	    cleanupSharedAppSwitcherRuntime();

  	    await Promise.resolve(
  	      navigator.goToPage(pageName, undefined)
  	    );

  	    /*
  	     * Backendless SPA navigation does not automatically remove DOM nodes that
  	     * this Custom Code appended directly to document.body. Snapshot is a fixed
  	     * full-screen root, so leaving it alive masks the destination page even
  	     * though Office has mounted successfully underneath it.
  	     */
  	    destroySnapshotUi();

  	    return true;
  	  }

  	  async function switchApplication(appName) {
  	    if (state.appSwitchInProgress || state.logoutInProgress) return false;

  	    const user = snapshotUser || AppData.User || {};
  	    const target = normaliseApplicationName(appName);
  	    const allowed = allowedApplicationsFor(user);
  	    if (!APPLICATION_PAGES[target] || allowed.indexOf(target) === -1) {
  	      setAppMenuStatus("You do not have permission to open this application.", true);
  	      return false;
  	    }

  	    state.appSwitchInProgress = true;
  	    disableAppMenuOptions(true);
  	    setAppMenuStatus("Opening " + target + "…", false);

  	    try {
  	      const sessionValid = await isBackendlessSessionValid();
  	      const activeGuard = installLogoutGuard() || logoutGuard;
  	      console.info("[Snapshot App Switcher]", {
  	        version: VERSION,
  	        from: currentApplication(),
  	        to: target,
  	        sessionValid: sessionValid,
  	        logoutGuardActive: !!activeGuard
  	      });
  	      if (!sessionValid) throw new Error("Your session has ended. Please log in again.");

  	      if (target === "Office") {
  	        await prepareOfficeApplication(user);
  	      }

  	      const pageName = APPLICATION_PAGES[target];

  	      /*
  	       * Stop Snapshot polling before the page change, but keep the shared
  	       * App/User object intact for the destination page.
  	       */
  	      cleanup();
  	      closeAppMenu();

  	      await navigateToApplicationPage(
  	        pageName,
  	        target,
  	        user
  	      );

  	      return true;
  	    } catch (error) {
  	      state.appSwitchInProgress = false;
  	      setAppMenuStatus(text(error && error.message, "The selected application could not be opened."), true);
  	      disableAppMenuOptions(false);
  	      startAutoRefresh();
  	      return false;
  	    }
  	  }

  	  function openAppMenu(applications) {
  	    closeAppMenu();
  	    const menu = document.createElement("div");
  	    menu.id = APP_MENU_ID;
  	    menu.setAttribute("role", "menu");
  	    menu.setAttribute("aria-label", "Switch application or log out");

  	    applications.forEach(function (name) {
  	      const option = document.createElement("button");
  	      option.type = "button";
  	      option.className = "snap-app-option";
  	      option.setAttribute("role", "menuitem");
  	      option.textContent = name;
  	      option.addEventListener("click", function (event) {
  	        event.preventDefault();
  	        event.stopPropagation();
  	        switchApplication(name);
  	      });
  	      menu.appendChild(option);
  	    });

  	    const logout = document.createElement("button");
  	    logout.type = "button";
  	    logout.className = "snap-app-option logout";
  	    logout.setAttribute("role", "menuitem");
  	    logout.textContent = "Log Out";
  	    logout.addEventListener("click", function (event) {
  	      event.preventDefault();
  	      event.stopPropagation();
  	      closeAppMenu();
  	      requestConfirmedLogout();
  	    });
  	    menu.appendChild(logout);

  	    const status = document.createElement("div");
  	    status.className = "snap-app-status";
  	    status.setAttribute("data-app-menu-status", "");
  	    status.setAttribute("aria-live", "polite");
  	    status.hidden = true;
  	    menu.appendChild(status);

  	    document.body.appendChild(menu);
  	    positionAppMenu();
  	    const button = appMenuButtonNode();
  	    if (button) button.setAttribute("aria-expanded", "true");
  	    document.addEventListener("pointerdown", onAppMenuOutside, true);
  	    document.addEventListener("keydown", onAppMenuKeyDown, true);
  	    window.addEventListener("resize", positionAppMenu);
  	    window.addEventListener("scroll", positionAppMenu, true);

  	    window.setTimeout(function () {
  	      positionAppMenu();
  	      const first = menu.querySelector("button");
  	      if (first && typeof first.focus === "function") first.focus();
  	    }, 0);
  	  }

  	  function showConfirmDialog() {
  	    return new Promise(function (resolve) {
  	      const old = document.getElementById(DIALOG_ID);
  	      if (old) old.remove();
  	      const overlay = document.createElement("div");
  	      overlay.id = DIALOG_ID;
  	      overlay.innerHTML = '<div class="snap-dialog-card"><h2>Log out?</h2><p>Your current session will close and the Login page will open.</p><div class="snap-dialog-actions"><button type="button" data-snap-stay>Stay Logged In</button><button type="button" class="danger" data-snap-confirm>Yes, Log Out</button></div></div>';
  	      document.body.appendChild(overlay);

  	      const finish = function (approved) {
  	        if (overlay.parentNode) overlay.remove();
  	        resolve(approved);
  	      };
  	      overlay.querySelector("[data-snap-stay]").addEventListener("click", function () { finish(false); });
  	      overlay.querySelector("[data-snap-confirm]").addEventListener("click", function () { finish(true); });
  	      overlay.addEventListener("click", function (event) {
  	        if (event.target === overlay) finish(false);
  	      });
  	    });
  	  }

  	  function loginPageUrl(targetWindow) {
  	    try {
  	      const current = new URL(targetWindow.location.href);
  	      current.searchParams.set("page", "Login");
  	      current.hash = "";
  	      return current.toString();
  	    } catch (_) {
  	      return "index.html?page=Login";
  	    }
  	  }

  	  function navigateToLogin() {
  	    const navigator = applicationNavigator();
  	    if (navigator) {
  	      try {
  	        const result = navigator.goToPage("Login", undefined);
  	        if (result && typeof result.catch === "function") {
  	          result.catch(function (error) { console.warn("Snapshot Login navigator rejected; hard redirect will continue.", error); });
  	        }
  	      } catch (error) {
  	        console.warn("Snapshot Login navigator failed; hard redirect will continue.", error);
  	      }
  	    }

  	    setTimeout(function () {
  	      let targetWindow = typeof window !== "undefined" ? window : null;
  	      try { if (window.top && window.top.location && window.top.location.href) targetWindow = window.top; } catch (_) {}
  	      if (!targetWindow) return;
  	      const targetUrl = loginPageUrl(targetWindow);
  	      try {
  	        targetWindow.location.replace(targetUrl);
  	      } catch (_) {
  	        try { window.location.replace(targetUrl); } catch (__) { window.location.href = targetUrl; }
  	      }
  	    }, 250);
  	    return true;
  	  }

  	  async function logoutUser() {
  	    if (state.logoutInProgress) return true;
  	    state.logoutInProgress = true;
  	    if (!DB || !DB.UserService || typeof DB.UserService.logout !== "function") {
  	      state.logoutInProgress = false;
  	      throw new Error("Backendless logout is unavailable on this page.");
  	    }

  	    try {
  	      cleanup();
  	      closeAppMenu();
  	      const activeGuard = installLogoutGuard() || logoutGuard;
  	      if (activeGuard && typeof activeGuard.explicitLogout === "function") {
  	        await activeGuard.explicitLogout();
  	      } else {
  	        await DB.UserService.logout();
  	      }
  	      navigateToLogin();
  	      return true;
  	    } catch (error) {
  	      state.logoutInProgress = false;
  	      startAutoRefresh();
  	      throw error;
  	    }
  	  }

  	  async function requestConfirmedLogout() {
  	    if (state.logoutInProgress) return;
  	    const approved = await showConfirmDialog();
  	    if (!approved) return;
  	    try {
  	      await logoutUser();
  	    } catch (error) {
  	      console.error("Snapshot logout failed:", error);
  	      alert(text(error && error.message, "The session could not be closed."));
  	    }
  	  }

  	  function handleAppMenuButton() {
  	    if (appMenuNode()) {
  	      closeAppMenu();
  	      return;
  	    }
  	    const user = snapshotUser || AppData.User || {};
  	    const current = currentApplication();
  	    const alternatives = allowedApplicationsFor(user).filter(function (name) { return name !== current; });

  	    console.info("[Snapshot App Switcher Ready]", {
  	      version: VERSION,
  	      currentApp: current,
  	      availableApps: alternatives,
  	      logoutGuardActive: !!(installLogoutGuard() || logoutGuard)
  	    });

  	    if (!alternatives.length) {
  	      requestConfirmedLogout();
  	      return;
  	    }
  	    openAppMenu(alternatives);
  	  }

  	  function cleanup() {
  	    closeAppMenu();
  	    stopReportReadinessWatch();
  	    const dialog = document.getElementById(DIALOG_ID);
  	    if (dialog) dialog.remove();
  	    if (state.refreshTimer) {
  	      clearInterval(state.refreshTimer);
  	      state.refreshTimer = null;
  	    }
  	    if (state.detachObserver) {
  	      try { state.detachObserver.disconnect(); } catch (_) {}
  	      state.detachObserver = null;
  	    }
  	  }

  	  function destroySnapshotUi() {
  	    cleanup();

  	    const menu = document.getElementById(APP_MENU_ID);
  	    if (menu) menu.remove();

  	    const dialog = document.getElementById(DIALOG_ID);
  	    if (dialog) dialog.remove();

  	    const rootNode = document.getElementById(ROOT_ID);
  	    if (rootNode) rootNode.remove();

  	    const styleNode = document.getElementById(STYLE_ID);
  	    if (styleNode) styleNode.remove();

  	    console.info("[Snapshot Destroyed For App Switch]", {
  	      version: VERSION,
  	      currentUrl: String(window.location.href || "")
  	    });
  	  }

  	  state.cleanup = cleanup;
  	  state.destroy = destroySnapshotUi;

  	  function startAutoRefresh() {
  	    /*
  	     * Reset only the auto-refresh resources here.
  	     * ViewC.Snapshot is persisted JSON, so no report-download
  	     * readiness listener is required.
  	     */
  	    if (state.refreshTimer) {
  	      clearInterval(state.refreshTimer);
  	      state.refreshTimer = null;
  	    }

  	    if (state.detachObserver) {
  	      try { state.detachObserver.disconnect(); } catch (_) {}
  	      state.detachObserver = null;
  	    }

  	    state.cleanup = cleanup;

  	    state.refreshTimer = setInterval(function () {
  	      if (!document.body.contains(root)) {
  	        cleanup();
  	        return;
  	      }
  	      refreshSnapshotData("auto");
  	    }, REFRESH_MS);

  	    if (typeof MutationObserver !== "undefined") {
  	      state.detachObserver = new MutationObserver(function () {
  	        if (!document.body.contains(root)) cleanup();
  	      });
  	      try { state.detachObserver.observe(document.body, { childList: true, subtree: true }); } catch (_) {}
  	    }
  	  }

  	  ensureSelectedCompanyValid();

  	  function renderTakingSnapshot() {
  	    root.innerHTML = `
  	      <div class="snapshot-loading" role="status" aria-live="polite">
  	        <div class="snapshot-loading-card">
  	          <div class="snapshot-loading-mark" aria-hidden="true">
  	            <div class="snapshot-loading-ring"></div>
  	            <div class="snapshot-loading-dot"></div>
  	          </div>
  	          <div class="snapshot-loading-kicker">Fleet In Form</div>
  	          <div class="snapshot-loading-title">Taking your Snapshot</div>
  	          <div class="snapshot-loading-copy">
  	            Loading the latest cached fleet Snapshot.
  	          </div>
  	          <div class="snapshot-loading-pulse" aria-hidden="true">
  	            <span></span><span></span><span></span>
  	          </div>
  	        </div>
  	      </div>
  	    `;
  	  }

  	  function stopReportReadinessWatch() {
  	    if (state.reportReadyTimer) {
  	      clearInterval(state.reportReadyTimer);
  	      state.reportReadyTimer = null;
  	    }

  	    if (state.reportReadyListener) {
  	      try {
  	        window.removeEventListener(
  	          "fif:vehicle-reports-loaded",
  	          state.reportReadyListener
  	        );
  	      } catch (_) {}
  	      state.reportReadyListener = null;
  	    }
  	  }

  	  function startReportReadinessWatch() {
  	    stopReportReadinessWatch();

  	    state.reportReadyListener = function () {
  	      if (!document.body.contains(root)) {
  	        stopReportReadinessWatch();
  	        return;
  	      }

  	      if (!reportsAreLoading()) {
  	        stopReportReadinessWatch();
  	        render();
  	      }
  	    };

  	    try {
  	      window.addEventListener(
  	        "fif:vehicle-reports-loaded",
  	        state.reportReadyListener
  	      );
  	    } catch (_) {}

  	    state.reportReadyTimer = setInterval(function () {
  	      if (!document.body.contains(root)) {
  	        stopReportReadinessWatch();
  	        return;
  	      }

  	      if (!reportsAreLoading()) {
  	        stopReportReadinessWatch();
  	        render();
  	      }
  	    }, 250);
  	  }

  	  function metric(label, value, unit, foot) {
  	    return '<div class="metric">' +
  	      '<div class="metric-label">' + esc(label) + '</div>' +
  	      '<div class="metric-value">' + esc(value) + (unit ? ' <span class="metric-unit">' + esc(unit) + '</span>' : '') + '</div>' +
  	      '<div class="metric-foot">' + esc(foot) + '</div>' +
  	    '</div>';
  	  }

  	  function periodMetricsHtml(period, periodLabel) {
  	    const p = period || {};

  	    const mileageVehicles = n(p.mileageVehicles, 0);
  	    const movingVehicles = n(p.movingVehicles, 0);

  	    return [
  	      /*
  	       * LINE 1
  	       * Distance | Distance / Moving Vehicle Avg | Distance / Vehicle Avg
  	       */
  	      metric(
  	        "Distance",
  	        formatCompact(p.distanceKm, 0),
  	        "km",
  	        mileageVehicles + " included vehicle" + (mileageVehicles === 1 ? "" : "s")
  	      ),

  	      metric(
  	        "Distance / Moving Vehicle Avg",
  	        formatCompact(p.avgKmMovingVehicle, 0),
  	        "km",
  	        "Fleet distance ÷ " + movingVehicles + " moving vehicle" + (movingVehicles === 1 ? "" : "s")
  	      ),

  	      metric(
  	        "Distance / Vehicle Avg",
  	        formatCompact(p.avgKmVehicle, 0),
  	        "km",
  	        "Fleet distance ÷ " + mileageVehicles + " included vehicle" + (mileageVehicles === 1 ? "" : "s")
  	      ),

  	      /*
  	       * LINE 2
  	       * Top Speed + % mileage | Top RPM + % mileage | Top Temp + % mileage
  	       */
  	      metric(
  	        "Top Speed",
  	        formatNumber(p.topSpeed, 0),
  	        "km/h",
  	        formatNumber(p.speedingMileagePct, 1) + "% of fleet mileage above speed limit"
  	      ),

  	      metric(
  	        "Top RPM",
  	        formatNumber(p.topRpm, 0),
  	        "rpm",
  	        formatNumber(p.overRevMileagePct, 1) + "% of fleet mileage above RPM limit"
  	      ),

  	      metric(
  	        "Top Temp",
  	        hasNumber(p.topTemp) ? formatNumber(p.topTemp, 0) : "—",
  	        hasNumber(p.topTemp) ? "°C" : "",
  	        formatNumber(p.overTempMileagePct, 1) + "% of fleet mileage above temperature limit"
  	      ),

  	      /*
  	       * LINE 3
  	       * Total idling time | Idling as % of engine run time
  	       */
  	      metric(
  	        "Total Idling",
  	        formatDurationSeconds(p.idleSeconds),
  	        "",
  	        formatNumber(p.idleIncidents, 0) + " excessive-idle incident" + (n(p.idleIncidents, 0) === 1 ? "" : "s")
  	      ),

  	      metric(
  	        "Idling / Engine Runtime",
  	        formatNumber(p.idleRuntimePct, 1),
  	        "%",
  	        "Total idling time ÷ total engine-run time"
  	      )
  	    ].join("");
  	  }

  	  function behaviourCard(icon, label, count, denominator, foot) {
  	    const rate = denominator > 0 ? (count / denominator) * 100 : 0;
  	    return '<div class="behaviour">' +
  	      '<div class="behaviour-top"><div class="behaviour-label">' + esc(label) + '</div><div class="behaviour-icon">' + esc(icon) + '</div></div>' +
  	      '<div class="behaviour-value">' + formatNumber(rate, 0) + '<span style="font-size:11px;color:#9aa79f">%</span></div>' +
  	      '<div class="behaviour-foot">' + esc(count + ' of ' + denominator + ' monitored · ' + foot) + '</div>' +
  	    '</div>';
  	  }

  	  function simpleMetric(label, value, unit) {
  	    return '<div class="simple-metric">' +
  	      '<div class="simple-label">' + esc(label) + '</div>' +
  	      '<div class="simple-value">' + esc(value) +
  	      (unit ? ' <span class="simple-unit">' + esc(unit) + '</span>' : '') +
  	      '</div>' +
  	    '</div>';
  	  }

  	  function simpleRow(items) {
  	    return '<div class="simple-row">' + items.join('') + '</div>';
  	  }

  	  /*
  	   * Dashboard-parity period totals. The main dashboard's Current view uses
  	   * Tractor.ViewC, NOT ViewC.Snapshot.today or the telemetry monthly report.
  	   * Keep this calculation independent of the telemetry-based Today/Yesterday
  	   * cards; it never replaces or writes their data.
  	   */
  	  function dashboardPeriodTotals(selectedCompanies) {
  	    const result = {
  	      vehicles: 0, distance: 0, hours: 0, litres: 0, cost: 0,
  	      hasDistance: false, hasHours: false, hasLitres: false, hasCost: false,
  	      periodKeys: []
  	    };

  	    function valueOrNull(value) {
  	      const raw = value && typeof value === "object" &&
  	        Object.prototype.hasOwnProperty.call(value, "value") ? value.value : value;
  	      if (raw === null || raw === undefined || raw === "") return null;
  	      const parsed = Number(raw);
  	      return Number.isFinite(parsed) ? parsed : null;
  	    }

  	    arr(selectedCompanies).forEach(function (company) {
  	      arr(company && company.Tractors).forEach(function (vehicle) {
  	        result.vehicles++;
  	        const view = vehicle && vehicle.ViewC;
  	        if (!view || typeof view !== "object") return;

  	        const periodKey = text(view.MYearKey || view.MonthKey || view.MYear, "");
  	        if (periodKey && result.periodKeys.indexOf(periodKey) < 0) {
  	          result.periodKeys.push(periodKey);
  	        }

  	        const hoursVehicle = isHoursVehicle(vehicle);
  	        const distance = !hoursVehicle ? valueOrNull(view.Distance) : null;
  	        // Dashboard: hour-based vehicles use ViewC.Hours, with ViewC.Distance
  	        // as a legacy fallback only when Hours is genuinely absent.
  	        const primaryHours = hoursVehicle ? valueOrNull(view.Hours) : null;
  	        const hours = hoursVehicle
  	          ? (primaryHours !== null ? primaryHours : valueOrNull(view.Distance))
  	          : null;
  	        const litres = valueOrNull(view.Litres);
  	        const cost = valueOrNull(view.Cost);

  	        if (distance !== null) { result.distance += distance; result.hasDistance = true; }
  	        if (hours !== null) { result.hours += hours; result.hasHours = true; }
  	        if (litres !== null) { result.litres += litres; result.hasLitres = true; }
  	        if (cost !== null) { result.cost += cost; result.hasCost = true; }
  	      });
  	    });

  	    result.periodLabel = result.periodKeys.length === 1
  	      ? (/^\d{4}-\d{2}$/.test(result.periodKeys[0])
  	        ? monthLabelFromKey(result.periodKeys[0]) : result.periodKeys[0])
  	      : (result.periodKeys.length > 1 ? "Mixed vehicle periods" : "Current period");
  	    return result;
  	  }

  	  function render() {
  	    const chosen = selectedCompanies();
  	    const s = buildSnapshot(chosen);
  	    const dashboardPeriod = dashboardPeriodTotals(chosen);
  	    const trackedVehicles = s.vehicleRows.filter(function (row) {
  	      return !!text(row && row.vehicle && row.vehicle.Tracker, "");
  	    }).length;
  	    const hasTodayTelemetry = s.currentReportsAvailable > 0;
  	    // Snapshot monthly fuel uses its report-month view; Dashboard uses ViewC.
  	    // A mismatch means the records or reporting periods need investigation.
  	    const fuelSourceDelta = dashboardPeriod.hasLitres
  	      ? dashboardPeriod.litres - s.totalLitres : 0;
  	    const hoursSourceDelta = dashboardPeriod.hasHours
  	      ? dashboardPeriod.hours - s.totalHours : 0;
  	    const periodSourceNote = Math.abs(fuelSourceDelta) > 0.1 || Math.abs(hoursSourceDelta) > 0.1
  	      ? ("Source mismatch: Dashboard ViewC versus Snapshot reporting month: fuel " +
  	          formatNumber(fuelSourceDelta, 1) + " L; hours " +
  	          formatNumber(hoursSourceDelta, 1) + " h. Check month keys and data refresh.")
  	      : "";
  	    const todayCoverageNote = trackedVehicles && s.currentReportsAvailable < trackedVehicles
  	      ? (s.currentReportsAvailable + " of " + trackedVehicles + " tracker reports received for Today; totals may be incomplete.")
  	      : "";
  	    const scopeLabel = state.selectedCompany === ALL
  	      ? "All Fleet"
  	      : (chosen[0] ? companyLabel(chosen[0]) : "Fleet");

  	    // One operational fuel number across both counter types. This is TODAY's
  	    // combined fuel usage, matching the headline period on the KM/Hobbs blocks.
  	    const combinedFuelToday = Math.max(0, n(s.distanceFuelToday, 0)) + Math.max(0, n(s.hourFuelToday, 0));

  	    const companyChips = ['<button class="company-chip ' + (state.selectedCompany === ALL ? 'is-active' : '') + '" data-company="' + ALL + '">All Fleet</button>']
  	      .concat(companies.map(function (c, i) {
  	        const key = companyKey(c, i);
  	        return '<button class="company-chip ' + (state.selectedCompany === key ? 'is-active' : '') + '" data-company="' + esc(key) + '">' + esc(companyLabel(c)) + '</button>';
  	      })).join('');

  	    const toggleButton = function (key, label, summary, unit) {
  	      const open = !!state.expanded[key];
  	      return '<button type="button" class="expand-row ' + (open ? 'is-open' : '') + '" data-expand="' + esc(key) + '" aria-expanded="' + (open ? 'true' : 'false') + '">' +
  	        '<span class="expand-label">' + esc(label) + '</span>' +
  	        '<span class="expand-summary">' + esc(summary) + (unit ? ' <small>' + esc(unit) + '</small>' : '') + '</span>' +
  	        '<span class="chevron" aria-hidden="true">⌄</span>' +
  	      '</button>';
  	    };

  	    const kmDetailHtml = state.expanded.km
  	      ? '<div class="detail-panel">' +
  	          '<div class="detail-group"><div class="detail-group-title">Usage</div>' + simpleRow([
  	            simpleMetric("Today", hasTodayTelemetry ? formatCompact(s.todayKm, 1) : "—", "km"),
  	            simpleMetric("Yesterday", formatCompact(s.yesterdayKm, 1), "km"),
  	            simpleMetric("MTD Avg", formatCompact(s.avgKmDay, 1), "km/day")
  	          ]) + '</div>' +
  	          '<div class="detail-group"><div class="detail-group-title">Fuel</div>' + simpleRow([
  	            simpleMetric("Today", formatNumber(s.distanceFuelToday, 1), "L"),
  	            simpleMetric("Yesterday", formatNumber(s.distanceFuelYesterday, 1), "L"),
  	            simpleMetric("MTD Avg", formatNumber(s.distanceFuelMonthAverage, 1), "L/day")
  	          ]) + '</div>' +
  	          '<div class="detail-group"><div class="detail-group-title">Efficiency</div>' + simpleRow([
  	            simpleMetric("Today", s.distanceFuelToday > 0 ? formatNumber(s.kmPerLitreToday, 2) : "—", s.distanceFuelToday > 0 ? "km/L" : ""),
  	            simpleMetric("Yesterday", s.distanceFuelYesterday > 0 ? formatNumber(s.kmPerLitreYesterday, 2) : "—", s.distanceFuelYesterday > 0 ? "km/L" : ""),
  	            simpleMetric("MTD Avg", s.distanceLitres > 0 ? formatNumber(s.kmPerLitreMonth, 2) : "—", s.distanceLitres > 0 ? "km/L" : "")
  	          ]) + '</div>' +
  	        '</div>'
  	      : '';

  	    const hobbsDetailHtml = state.expanded.hobbs
  	      ? '<div class="detail-panel">' +
  	          '<div class="detail-group"><div class="detail-group-title">Usage</div>' + simpleRow([
  	            simpleMetric("Today", hasTodayTelemetry ? formatNumber(s.hourUsageToday, 2) : "—", "h"),
  	            simpleMetric("Yesterday", formatNumber(s.hourUsageYesterday, 2), "h"),
  	            simpleMetric("MTD Avg", formatNumber(s.hourUsageMonthAverage, 2), "h/day")
  	          ]) + '</div>' +
  	          '<div class="detail-group"><div class="detail-group-title">Fuel</div>' + simpleRow([
  	            simpleMetric("Today", formatNumber(s.hourFuelToday, 1), "L"),
  	            simpleMetric("Yesterday", formatNumber(s.hourFuelYesterday, 1), "L"),
  	            simpleMetric("MTD Avg", formatNumber(s.hourFuelMonthAverage, 1), "L/day")
  	          ]) + '</div>' +
  	          '<div class="detail-group"><div class="detail-group-title">Efficiency</div>' + simpleRow([
  	            simpleMetric("Today", s.hourFuelToday > 0 ? formatNumber(s.hoursPerLitreToday, 3) : "—", s.hourFuelToday > 0 ? "h/L" : ""),
  	            simpleMetric("Yesterday", s.hourFuelYesterday > 0 ? formatNumber(s.hoursPerLitreYesterday, 3) : "—", s.hourFuelYesterday > 0 ? "h/L" : ""),
  	            simpleMetric("MTD Avg", s.hourLitres > 0 ? formatNumber(s.hoursPerLitreMonth, 3) : "—", s.hourLitres > 0 ? "h/L" : "")
  	          ]) + '</div>' +
  	        '</div>'
  	      : '';

  	    const idlingDetailHtml = state.expanded.idling
  	      ? '<div class="detail-panel compact-detail">' + simpleRow([
  	          simpleMetric("Today", formatDurationSeconds(s.idleTodaySeconds), ""),
  	          simpleMetric("Yesterday", formatDurationSeconds(s.idleYesterdaySeconds), ""),
  	          simpleMetric("MTD Avg", formatDurationSeconds(s.idleMonthAverageSeconds), "")
  	        ]) + '</div>'
  	      : '';

  	    const maxDetailHtml = state.expanded.max
  	      ? '<div class="detail-panel compact-detail">' + simpleRow([
  	          simpleMetric("Speed", hasNumber(s.todayTopSpeed) ? formatNumber(s.todayTopSpeed, 0) : "—", hasNumber(s.todayTopSpeed) ? "km/h" : ""),
  	          simpleMetric("RPM", hasNumber(s.todayTopRpm) ? formatNumber(s.todayTopRpm, 0) : "—", hasNumber(s.todayTopRpm) ? "rpm" : ""),
  	          simpleMetric("Temp", hasNumber(s.todayPeriod && s.todayPeriod.topTemp) ? formatNumber(s.todayPeriod.topTemp, 0) : "—", hasNumber(s.todayPeriod && s.todayPeriod.topTemp) ? "°C" : "")
  	        ]) + '</div>'
  	      : '';

  	    const tankHtml = s.tankRows.length
  	      ? s.tankRows
  	          .slice()
  	          .sort(function (a, b) { return a.levelPct - b.levelPct; })
  	          .map(function (x) {
  	            const companyPart = state.selectedCompany === ALL ? companyLabel(x.company) + ' · ' : '';
  	            const bowserPart = x.bowserRows.length
  	              ? (' · ' + x.bowserRows.length + ' bowser' + (x.bowserRows.length === 1 ? '' : 's') + ' · ' + formatNumber(x.bowserOut, 0) + ' L out')
  	              : '';
  	            const atgState = x.atg.status;
  	            const atgLabel = atgState === 'live' ? 'ATG LIVE' : atgState === 'stale' ? 'ATG STALE' : 'ATG UNAVAILABLE';
  	            const atgPctText = x.atgAvailable ? formatNumber(x.atgLevelPct, 0) + '%' : '—';
  	            const atgLitresText = x.atgAvailable ? formatCompact(x.atgVolume, 0) + ' / ' + formatCompact(x.capacity, 0) + ' L' : 'No physical reading';
  	            const varianceText = x.atgAvailable
  	              ? ((x.atgDifference > 0 ? '+' : '') + formatNumber(x.atgDifference, 0) + ' L variance')
  	              : 'Variance unavailable';
  	            const atgDetails = x.atgAvailable
  	              ? [
  	                  varianceText,
  	                  Number.isFinite(x.atg.temperature) ? formatNumber(x.atg.temperature, 1) + ' °C' : '',
  	                  Number.isFinite(x.atg.water) ? 'Water ' + formatNumber(x.atg.water, 1) + ' mm' : '',
  	                  Number.isFinite(x.atg.ullage) ? 'Ullage ' + formatNumber(x.atg.ullage, 0) + ' L' : '',
  	                  x.atg.capturedAt ? ageLabel(x.atg.capturedAt) : ''
  	                ].filter(Boolean).join(' · ')
  	              : 'ATG tank ' + (x.atg.tankNumber || 'not linked');
  	            return '<div class="tank-row">' +
  	              '<div><div class="tank-name">' + esc(x.label) + '</div>' +
  	              '<div class="tank-meta">' + esc(companyPart + x.grade + bowserPart) + '</div>' +
  	              '<div class="tank-atg-meta">' + esc(atgDetails) + '</div></div>' +
  	              '<div class="tank-readings">' +
  	                '<div class="tank-reading book"><div class="tank-reading-label">BOOK STOCK</div>' +
  	                  '<div class="tank-pct" style="color:' + (x.low ? 'var(--warn)' : '#e7ece9') + '">' + formatNumber(x.levelPct, 0) + '%</div>' +
  	                  '<div class="tank-litres">' + formatCompact(x.volume, 0) + ' / ' + formatCompact(x.capacity, 0) + ' L</div>' +
  	                  '<div class="tank-mini-bar"><span style="width:' + pct(x.levelPct) + '%"></span></div></div>' +
  	                '<div class="tank-reading atg ' + atgState + '"><div class="tank-reading-label">' + atgLabel + '</div>' +
  	                  '<div class="tank-pct">' + atgPctText + '</div>' +
  	                  '<div class="tank-litres">' + atgLitresText + '</div>' +
  	                  '<div class="tank-mini-bar"><span style="width:' + (x.atgAvailable ? pct(x.atgLevelPct) : 0) + '%"></span></div></div>' +
  	              '</div>' +
  	            '</div>';
  	          }).join('')
  	      : '<div class="empty">No fuel tanks in this scope.</div>';

  	    const aggregateAtgAvailable = s.atgRows.length > 0;
  	    const aggregateAtgStatus = !aggregateAtgAvailable
  	      ? 'ATG unavailable'
  	      : s.atgStaleCount > 0
  	        ? s.atgStaleCount + ' stale reading' + (s.atgStaleCount === 1 ? '' : 's')
  	        : s.atgRows.length + ' live reading' + (s.atgRows.length === 1 ? '' : 's');
  	    const aggregateVarianceText = aggregateAtgAvailable
  	      ? (s.atgVariance > 0 ? '+' : '') + formatCompact(s.atgVariance, 0)
  	      : '—';

  	    const fuelDetailHtml = state.expanded.fuel
  	      ? '<div class="fuel-panel compact-detail">' +
  	          '<div class="fuel-summary">' +
  	            '<div class="gauge-card"><div class="metric-label">Book Stock</div><div class="gauge-row"><div><div class="gauge-big">' + formatNumber(s.tankLevelPct, 1) + '%</div><div class="gauge-meta">' + formatCompact(s.tankVolume, 0) + ' / ' + formatCompact(s.tankCapacity, 0) + ' L · Sales & purchases</div></div></div><div class="bar"><span style="width:' + pct(s.tankLevelPct) + '%"></span></div></div>' +
  	            '<div class="gauge-card"><div class="metric-label">ATG Physical Check</div><div class="gauge-row"><div><div class="gauge-big">' + (aggregateAtgAvailable ? formatNumber(s.atgLevelPct, 1) + '%' : '—') + '</div><div class="gauge-meta">' + (aggregateAtgAvailable ? formatCompact(s.atgVolume, 0) + ' / ' + formatCompact(s.atgCapacity, 0) + ' L' : 'No ATG reading') + ' · ' + esc(aggregateAtgStatus) + '</div></div></div><div class="bar"><span style="width:' + (aggregateAtgAvailable ? pct(s.atgLevelPct) : 0) + '%;background:#71c99a"></span></div></div>' +
  	            '<div class="small-stat"><div class="metric-label">ATG − Book</div><div class="small-stat-value">' + aggregateVarianceText + (aggregateAtgAvailable ? ' <span class="metric-unit">L</span>' : '') + '</div><div class="gauge-meta">Matched tanks only</div></div>' +
  	            '<div class="small-stat"><div class="metric-label">Bowser Out</div><div class="small-stat-value">' + formatCompact(s.bowserOut, 0) + ' <span class="metric-unit">L</span></div><div class="gauge-meta">' + esc(s.monthLabel) + '</div></div>' +
  	          '</div>' +
  	          '<div class="tank-list">' + tankHtml + '</div>' +
  	        '</div>'
  	      : '';

  	    const dashboardAlerts = arr(s.operationalAlerts);
  	    const drivingAlerts = arr(s.drivingAttention).map(function (a, index) {
  	      return {
  	        key: "Driving:" + index + ":" + a.title,
  	        category: "Driving",
  	        severity: a.level === "danger" ? "high" : a.level === "warn" ? "warning" : "info",
  	        title: a.title,
  	        message: a.detail,
  	        vehicleLabel: ""
  	      };
  	    });

  	    const combinedAlerts = dashboardAlerts.concat(drivingAlerts).sort(function (a, b) {
  	      const rank = alertSeverityRank(a.severity) - alertSeverityRank(b.severity);
  	      if (rank) return rank;
  	      return String(a.title || "").localeCompare(String(b.title || ""), undefined, { numeric: true });
  	    });

  	    const alertCounts = { critical: 0, high: 0, warning: 0, info: 0 };
  	    combinedAlerts.forEach(function (alert) {
  	      const key = alertLower(alert.severity);
  	      if (Object.prototype.hasOwnProperty.call(alertCounts, key)) alertCounts[key] += 1;
  	    });

  	    const alertTypes = combinedAlerts
  	      .map(function (a) { return text(a.category, "Vehicle"); })
  	      .filter(function (value, index, list) { return list.indexOf(value) === index; })
  	      .sort(function (a, b) { return a.localeCompare(b); });

  	    if (state.alertType !== ALL && alertTypes.indexOf(state.alertType) === -1) state.alertType = ALL;
  	    if ([ALL, "critical", "high", "warning", "info"].indexOf(state.alertSeverity) === -1) state.alertSeverity = ALL;

  	    const filteredAlerts = combinedAlerts.filter(function (a) {
  	      const typeMatch = state.alertType === ALL || text(a.category, "Vehicle") === state.alertType;
  	      const severityMatch = state.alertSeverity === ALL || alertLower(a.severity) === state.alertSeverity;
  	      return typeMatch && severityMatch;
  	    });

  	    const typeOptions = ['<option value="' + ALL + '"' + (state.alertType === ALL ? ' selected' : '') + '>All types</option>']
  	      .concat(alertTypes.map(function (type) {
  	        return '<option value="' + esc(type) + '"' + (state.alertType === type ? ' selected' : '') + '>' + esc(type) + '</option>';
  	      })).join('');

  	    const severityChip = function (key, label, count) {
  	      return '<button type="button" class="filter-chip ' + (state.alertSeverity === key ? 'is-active' : '') + '" data-alert-severity="' + esc(key) + '">' + esc(label) + ' ' + formatNumber(count, 0) + '</button>';
  	    };

  	    const alertFiltersHtml = '<div class="alert-filter-bar">' +
  	      '<select class="alert-type-select" data-alert-type aria-label="Filter alerts by type">' + typeOptions + '</select>' +
  	      '<div class="severity-filters" aria-label="Filter alerts by severity">' +
  	        severityChip(ALL, "All", combinedAlerts.length) +
  	        severityChip("critical", "Critical", alertCounts.critical) +
  	        severityChip("high", "High", alertCounts.high) +
  	        severityChip("warning", "Warning", alertCounts.warning) +
  	        severityChip("info", "Info", alertCounts.info) +
  	      '</div>' +
  	      '<div class="alert-result-meta">' + formatNumber(filteredAlerts.length, 0) + ' shown</div>' +
  	    '</div>';

  	    const alertsHtml = filteredAlerts.length
  	      ? filteredAlerts.map(function (a, index) {
  	          const severity = alertLower(a.severity) || "warning";
  	          const level = alertSeverityLevel(severity);
  	          const alertKey = encodeURIComponent(String(a.key || (a.category + ':' + a.title + ':' + index)));
  	          const open = state.expandedAlertKey === alertKey;
  	          const evidence = [
  	            a.actual ? '<span><b>Actual:</b> ' + esc(a.actual) + '</span>' : '',
  	            a.threshold ? '<span><b>Limit:</b> ' + esc(a.threshold) + '</span>' : '',
  	            a.position ? '<span><b>Position:</b> ' + esc(a.position) + '</span>' : ''
  	          ].filter(Boolean).join('');
  	          const asset = a.vehicleLabel ? esc(a.vehicleLabel) + ' · ' : '';

  	          return '<button type="button" class="alert compact-alert ' + esc(level) + ' ' + (open ? 'is-open' : '') + '" data-alert-key="' + esc(alertKey) + '" aria-expanded="' + (open ? 'true' : 'false') + '">' +
  	            '<span class="alert-mark"></span>' +
  	            '<span>' +
  	              '<span class="alert-top">' +
  	                '<span class="alert-badge ' + esc(severity) + '">' + esc(alertSeverityLabel(severity)) + '</span>' +
  	                '<span class="alert-category">' + esc(a.category || 'Vehicle') + '</span>' +
  	                '<span class="alert-chevron" aria-hidden="true">⌄</span>' +
  	              '</span>' +
  	              '<span class="alert-title">' + asset + esc(a.title) + '</span>' +
  	              (open && (a.message || a.detail) ? '<span class="alert-detail">' + esc(a.message || a.detail || '') + '</span>' : '') +
  	              (open && evidence ? '<span class="alert-evidence">' + evidence + '</span>' : '') +
  	            '</span>' +
  	          '</button>';
  	        }).join('')
  	      : '<div class="alerts-empty">No alerts match the selected filters.</div>';

  	    const criticalSummary = alertCounts.critical > 0
  	      ? alertCounts.critical + ' critical'
  	      : combinedAlerts.length + ' active';

  	    const alertsDetailHtml = state.expanded.alerts
  	      ? '<div class="detail-panel compact-detail">' + alertFiltersHtml + '<div class="attention">' + alertsHtml + '</div></div>'
  	      : '';

  	    root.innerHTML = `
  	      <div class="snap-shell simple-snapshot">
  	        <div class="snapshot-sticky">
  	          <header class="snap-header">
  	            <div>
  	              <div class="snap-kicker">Fleet In Form</div>
  	              <div class="snap-title">Snapshot</div>
  	              <div class="snap-sub">${esc(scopeLabel)}</div>
  	            </div>
  	            <div class="snap-actions">
  	              <div class="snap-action-row">
  	                <button class="app-btn" type="button" data-snapshot-app-menu aria-label="Switch application or log out" aria-haspopup="menu" aria-expanded="false" ${state.appSwitchInProgress || state.logoutInProgress ? "disabled" : ""}>Logout</button>
  	              </div>
  	            </div>
  	          </header>

  	          <div class="company-scroller">${companyChips}</div>
  	        </div>

  	        <section class="period-parity" aria-label="Dashboard-equivalent current period totals">
  	          <div class="period-parity-heading">
  	            <strong>Current Period · ${esc(dashboardPeriod.periodLabel)}</strong>
  	            <span>${formatNumber(dashboardPeriod.vehicles, 0)} vehicles · ViewC records · matches Dashboard Current</span>
  	          </div>
  	          <div class="period-parity-grid">
  	            <div class="period-parity-metric"><span>Distance</span><strong>${dashboardPeriod.hasDistance ? formatNumber(dashboardPeriod.distance, 0) : "—"} <small>km</small></strong></div>
  	            <div class="period-parity-metric"><span>Hours</span><strong>${dashboardPeriod.hasHours ? formatNumber(dashboardPeriod.hours, 1) : "—"} <small>h</small></strong></div>
  	            <div class="period-parity-metric"><span>Fuel</span><strong>${dashboardPeriod.hasLitres ? formatNumber(dashboardPeriod.litres, 1) : "—"} <small>L</small></strong></div>
  	            <div class="period-parity-metric"><span>Cost</span><strong>${dashboardPeriod.hasCost ? formatRand(dashboardPeriod.cost, 2) : "—"}</strong></div>
  	          </div>
  	          ${periodSourceNote ? '<div class="period-parity-note">' + esc(periodSourceNote) + '</div>' : ''}
  	          ${todayCoverageNote ? '<div class="period-parity-note">' + esc(todayCoverageNote) + '</div>' : ''}
  	          ${!hasTodayTelemetry ? '<div class="period-parity-note">Today tracking summaries are unavailable. A dash indicates no report, not zero activity. Current-period recorded totals above remain available.</div>' : ''}
  	        </section>

  	        <div class="primary-expander-grid">
  	          <button type="button" class="primary-expander ${state.expanded.km ? 'is-open' : ''}" data-expand="km" aria-expanded="${state.expanded.km ? 'true' : 'false'}">
  	            <div class="expander-kicker">Mileage KM</div>
  	            <div class="expander-value">${hasTodayTelemetry ? formatCompact(s.todayKm, 1) : "—"} <span>km</span></div>
  	            <div class="expander-foot"><span>Today</span><span class="chevron" aria-hidden="true">⌄</span></div>
  	          </button>
  	          <button type="button" class="primary-expander ${state.expanded.hobbs ? 'is-open' : ''}" data-expand="hobbs" aria-expanded="${state.expanded.hobbs ? 'true' : 'false'}">
  	            <div class="expander-kicker">Hobbs Meter</div>
  	            <div class="expander-value">${hasTodayTelemetry ? formatNumber(s.hourUsageToday, 2) : "—"} <span>h</span></div>
  	            <div class="expander-foot"><span>Today</span><span class="chevron" aria-hidden="true">⌄</span></div>
  	          </button>
  	        </div>

  	        <div class="combined-fuel-strip" aria-label="Combined fuel used today">
  	          <div>
  	            <div class="combined-fuel-label">Combined Fuel Used Today</div>
  	            <div class="combined-fuel-breakdown">KM vehicles ${formatNumber(s.distanceFuelToday, 1)} L · Hobbs vehicles ${formatNumber(s.hourFuelToday, 1)} L</div>
  	          </div>
  	          <div class="combined-fuel-value">${formatNumber(combinedFuelToday, 1)} <span>L</span></div>
  	        </div>

  	        ${kmDetailHtml}
  	        ${hobbsDetailHtml}

  	        <div class="compact-stack">
  	          ${toggleButton("idling", "Idling", formatDurationSeconds(s.idleTodaySeconds), "today")}
  	          ${idlingDetailHtml}

  	          ${toggleButton("max", "Max Today", hasNumber(s.todayTopSpeed) ? formatNumber(s.todayTopSpeed, 0) : "—", hasNumber(s.todayTopSpeed) ? "km/h" : "")}
  	          ${maxDetailHtml}

  	          ${toggleButton("fuel", "Tank & Bowser Fuel", formatCompact(s.tankVolume, 0), "L book stock")}
  	          ${fuelDetailHtml}

  	          ${toggleButton("alerts", "Notifications & Alerts", formatNumber(combinedAlerts.length, 0), criticalSummary)}
  	          ${alertsDetailHtml}
  	        </div>
  	      </div>
  	    `;

  	    root.querySelectorAll('[data-company]').forEach(function (button) {
  	      button.addEventListener('click', function () {
  	        state.selectedCompany = button.getAttribute('data-company') || ALL;
  	        state.expandedAlertKey = "";
  	        render();
  	        try { root.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_) { root.scrollTop = 0; }
  	      });
  	    });

  	    root.querySelectorAll('[data-expand]').forEach(function (button) {
  	      button.addEventListener('click', function () {
  	        const key = button.getAttribute('data-expand');
  	        if (!key || !Object.prototype.hasOwnProperty.call(state.expanded, key)) return;

  	        const wasOpen = !!state.expanded[key];

  	        // True accordion behaviour: opening one Snapshot block closes every
  	        // other block. Clicking the open block closes it and leaves all closed.
  	        Object.keys(state.expanded).forEach(function (sectionKey) {
  	          state.expanded[sectionKey] = false;
  	        });
  	        if (!wasOpen) state.expanded[key] = true;

  	        // Alert evidence belongs to the Alerts block; never leave a hidden alert
  	        // marked open when another top-level block takes focus.
  	        if (key !== "alerts" || wasOpen) state.expandedAlertKey = "";

  	        render();
  	      });
  	    });

  	    const alertType = root.querySelector('[data-alert-type]');
  	    if (alertType) {
  	      alertType.addEventListener('change', function () {
  	        state.alertType = alertType.value || ALL;
  	        state.expandedAlertKey = "";
  	        render();
  	      });
  	    }

  	    root.querySelectorAll('[data-alert-severity]').forEach(function (button) {
  	      button.addEventListener('click', function () {
  	        state.alertSeverity = button.getAttribute('data-alert-severity') || ALL;
  	        state.expandedAlertKey = "";
  	        render();
  	      });
  	    });

  	    root.querySelectorAll('[data-alert-key]').forEach(function (button) {
  	      button.addEventListener('click', function () {
  	        const key = button.getAttribute('data-alert-key') || "";
  	        state.expandedAlertKey = state.expandedAlertKey === key ? "" : key;
  	        render();
  	      });
  	    });

  	    const appMenuButton = root.querySelector('[data-snapshot-app-menu]');
  	    if (appMenuButton) {
  	      appMenuButton.addEventListener('click', function () {
  	        handleAppMenuButton();
  	      });
  	    }
  	  }

  	  if (!companies.length) {
  	    root.innerHTML = '<div class="snap-shell"><div class="snap-header"><div><div class="snap-kicker">Fleet In Form</div><div class="snap-title">Snapshot</div><div class="snap-sub">Loading fleet data…</div></div></div></div>';
  	  } else {
  	    /*
  	     * ViewC.Snapshot is already part of the loaded Backendless relation tree.
  	     * Paint immediately. Never wait for external report downloads.
  	     */
  	    render();
  	  }

  	  startAutoRefresh();
  	  consoleSnapshotApp("initial");

  	  /*
  	   * Pull a fresh Backendless tree immediately in the background. The current
  	   * screen remains visible while this happens, so opening Snapshot is instant.
  	   */
  	  Promise.resolve().then(function () {
  	    return refreshSnapshotData("initial-background");
  	  }).catch(function (_) {});

  	  return {
  	    ok: true,
  	    version: VERSION,
  	    rootId: ROOT_ID,
  	    companyCount: companies.length,
  	    monthKey: currentMonthKey(),
  	    refreshMs: REFRESH_MS,
  	    appSwitcher: true,
  	    reportDriven: false,
  	    snapshotDriven: true,
  	    loadingScreen: "non-blocking",
  	    waitsForReportDownloads: false,
  	    currentTelemetrySource: "Tractor.Location -> ViewC.Snapshot.current fallback",
  	    todaySource: "Tractor.ViewC.Snapshot.today",
  	    yesterdaySource: "Tractor.ViewC.Snapshot.yesterday",
  	    monthlySource: "Tractor.ViewC.Snapshot.monthly",
  	    uniformPeriodMetrics: true,
  	    expandableSnapshot: true,
  	    stickyHeaderAndCompanySelector: true,
  	    singleOpenAccordion: true,
  	    combinedFuelHeadline: "today",
  	    dashboardPeriodParity: "Tractor.ViewC",
  	    missingTodayTelemetryDisplay: "unavailable-not-zero",
  	    alertFiltering: ["type", "severity"],
  	    periodMetricCount: 8,
  	    perVehicleHobbsCards: false,
  	    progressiveDisclosure: true,
  	    dashboardStyleAlerts: true,
  	    alertSources: ["Service", "Maintenance", "Tyres", "Compliance", "Fuel", "Data Quality", "Driving", "Legacy Notifications"],
  	    logoutGuard: !!logoutGuard
  	  };
  	})(App);

  })(___arguments.context.appData);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Upgrade/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await (async function() {
  	/*
  	  FLEET IN FORM — ATG POLLS DATABASE UPGRADE v1
  	  ------------------------------------------------
  	  Run this ONCE before installing the FIF Veeder-Root ATG Poller.

  	  PURPOSE
  	  - Creates / expands ATGPolls
  	  - Adds every field transmitted by FIF-ATGPoller.ps1
  	  - Verifies the schema by reading the temporary row back
  	  - Removes the temporary row when finished

  	  RUN
  	  1. Backendless -> Database -> Configuration
  	  2. Temporarily ENABLE Dynamic Schema Definition
  	  3. Run this file from a temporary UI Builder Custom Code block
  	  4. Wait for: FLEET IN FORM ATG DATABASE READY
  	  5. DISABLE Dynamic Schema Definition again

  	  Existing Fleet in Form data is not deleted or rewritten.
  	*/

  	(async function FleetInFormATGPollsDatabaseUpgradeV1(){
  	  'use strict';

  	  const ROOT='fif-atg-polls-database-upgrade-v1';
  	  const TABLE='ATGPolls';
  	  const REQUIRED_FIELDS=[
  	    'PollId',
  	    'Bridge',
  	    'ConsoleIp',
  	    'ConsolePort',
  	    'SiteCode',
  	    'SiteName',
  	    'SiteAddress',
  	    'ReportDateText',
  	    'CapturedAt',
  	    'CapturedAtIso',
  	    'TankCount',
  	    'Readings',
  	    'RawReport',
  	    'Status'
  	  ];

  	  document.getElementById(ROOT)?.remove();
  	  const root=document.createElement('div');
  	  root.id=ROOT;
  	  root.style.cssText='position:fixed;inset:0;z-index:2147483647;background:#101820;color:#E8EEF3;font-family:Inter,Segoe UI,Arial,sans-serif;display:grid;place-items:center;padding:24px;box-sizing:border-box';
  	  document.body.appendChild(root);
  	  root.innerHTML=`
  	    <div style="width:min(780px,96vw);background:#17242D;border:1px solid #D8792F;border-radius:18px;box-shadow:0 22px 70px rgba(0,0,0,.38);overflow:hidden">
  	      <div style="background:#0C151B;color:#fff;padding:22px 26px;border-bottom:3px solid #D8792F">
  	        <div style="font-size:24px;font-weight:900">Fleet in Form ATG Database Upgrade v1</div>
  	        <div style="margin-top:5px;color:#F2B27C;font-size:12px">Veeder-Root polling · One-minute inventory records</div>
  	      </div>
  	      <div style="padding:24px 26px">
  	        <div id="fif-atg-status" style="font-weight:900;margin-bottom:12px">STARTING…</div>
  	        <pre id="fif-atg-log" style="background:#081014;color:#E8EEF3;border-radius:12px;padding:16px;min-height:250px;max-height:430px;overflow:auto;white-space:pre-wrap;border:1px solid #314550"></pre>
  	        <div style="display:flex;justify-content:flex-end;margin-top:16px">
  	          <button id="fif-atg-close" type="button" style="display:none;border:0;border-radius:9px;background:#D8792F;color:#fff;font-weight:900;padding:11px 18px;cursor:pointer">CLOSE</button>
  	        </div>
  	      </div>
  	    </div>`;

  	  const status=root.querySelector('#fif-atg-status');
  	  const logEl=root.querySelector('#fif-atg-log');
  	  const closeButton=root.querySelector('#fif-atg-close');
  	  const log=message=>{
  	    logEl.textContent+=`${message}\n`;
  	    logEl.scrollTop=logEl.scrollHeight;
  	  };
  	  closeButton.addEventListener('click',()=>root.remove());

  	  let savedId='';
  	  let removed=false;

  	  async function removeTemporaryRow(api){
  	    if(!savedId||removed)return;
  	    try{
  	      await api.remove(savedId);
  	      removed=true;
  	      log('✓ Temporary ATGPolls schema row removed.');
  	    }catch(error){
  	      log(`⚠ Temporary ATGPolls row ${savedId} could not be removed automatically: ${error.message||error}`);
  	    }
  	  }

  	  try{
  	    if(!window.Backendless?.Data){
  	      throw new Error('Backendless Data SDK is unavailable. Run this inside Backendless UI Builder.');
  	    }

  	    const marker=`FIF-ATG-SCHEMA-${Date.now()}`;
  	    const now=new Date();
  	    const api=Backendless.Data.of(TABLE);

  	    status.textContent='CREATING ATG POLLS TABLE…';
  	    log('Creating ATGPolls schema…');
  	    log('Adding fields used by the PowerShell poller…');

  	    const saved=await api.save({
  	      PollId:marker,
  	      Bridge:'SCHEMA TEMP',
  	      ConsoleIp:'127.0.0.1',
  	      ConsolePort:10001,
  	      SiteCode:'SCHEMA',
  	      SiteName:'SCHEMA TEMP',
  	      SiteAddress:'SCHEMA TEMP',
  	      ReportDateText:'01/01/2000 00:00',
  	      CapturedAt:now,
  	      CapturedAtIso:now.toISOString(),
  	      TankCount:1,
  	      Readings:'[{"TankNumber":0,"Product":"SCHEMA TEMP","VolumeL":0,"TcVolumeL":0,"UllageL":0,"Height":0,"Water":0,"TemperatureC":0}]',
  	      RawReport:'SCHEMA TEMP',
  	      Status:'SCHEMA TEMP'
  	    });

  	    if(!saved?.objectId){
  	      throw new Error('Backendless did not return an objectId for the temporary ATGPolls row.');
  	    }
  	    savedId=saved.objectId;
  	    log(`✓ Temporary schema row created: ${savedId}`);

  	    status.textContent='VERIFYING ATG POLLS SCHEMA…';
  	    const verified=await api.findById(savedId);
  	    if(!verified?.objectId){
  	      throw new Error('The temporary ATGPolls row could not be read back.');
  	    }

  	    const missing=REQUIRED_FIELDS.filter(field=>!Object.prototype.hasOwnProperty.call(verified,field));
  	    if(missing.length){
  	      throw new Error(`ATGPolls verification failed. Missing fields: ${missing.join(', ')}`);
  	    }

  	    if(String(verified.PollId)!==marker){
  	      throw new Error('ATGPolls verification returned the wrong temporary row.');
  	    }

  	    log(`✓ Verified ${REQUIRED_FIELDS.length} poller fields.`);
  	    log('✓ CapturedAt is available for date-sorted remote queries.');
  	    log('✓ Readings is available for the complete tank array.');
  	    log('✓ RawReport is available for troubleshooting and audit.');

  	    await removeTemporaryRow(api);

  	    status.textContent='FLEET IN FORM ATG DATABASE READY';
  	    status.style.color='#72D49A';
  	    log('');
  	    log('✓ ATGPolls is ready for the FIF PowerShell ATG Poller.');
  	    log('✓ Existing Fleet in Form data was left unchanged.');
  	    log('✓ The poller may now transmit one inventory record every minute.');
  	    log('IMPORTANT: Disable Dynamic Schema Definition again now.');

  	    window.FleetInFormATGPollsDatabaseUpgradeV1Result={
  	      success:true,
  	      table:TABLE,
  	      fields:REQUIRED_FIELDS.slice(),
  	      temporaryRowRemoved:removed
  	    };
  	  }catch(error){
  	    console.error('[Fleet in Form ATG Polls Database Upgrade v1]',error);
  	    try{
  	      if(window.Backendless?.Data)await removeTemporaryRow(Backendless.Data.of(TABLE));
  	    }catch(cleanupError){
  	      console.warn('[Fleet in Form ATG schema cleanup]',cleanupError);
  	    }
  	    status.textContent='UPGRADE FAILED';
  	    status.style.color='#FF7B72';
  	    log(`✕ ${error.message||String(error)}`);
  	    log('Check that Dynamic Schema Definition is temporarily ON, then run the upgrade again.');
  	    window.FleetInFormATGPollsDatabaseUpgradeV1Result={
  	      success:false,
  	      table:TABLE,
  	      error:error.message||String(error),
  	      temporaryRowId:savedId||null,
  	      temporaryRowRemoved:removed
  	    };
  	  }finally{
  	    closeButton.style.display='inline-block';
  	  }
  	})();


  })();

  },
  /* handler:onEnter */
  /* content */
}))

